require=(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
require("moment/min/locales.min");
var _lodash = require("lodash");
var _errorReporting = require("./utils/errorReporting");
var _webappSkeleton = require("./utils/webapp-skeleton");
var _assets = require("./utils/assets");
var _authService = require("./services/authService");
if ("production" !== 'dev') {
  var isInAnIframe = function isInAnIframe() {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  };
  if (isInAnIframe()) {
    window.parent.location = window.location;
  }
}
var $injector = angular.injector(['ng']);
var $http = $injector.get('$http');
var $q = $injector.get('$q');
var $timeout = $injector.get('$timeout');
var $httpParamSerializer = $injector.get('$httpParamSerializer');
var ENV = "production";
var VERSION = "1.156.0";
var APP_RESOURCE_PATH;
if ("production" === 'production') {
  APP_RESOURCE_PATH = "/webapp/static/".concat(VERSION);
} else {
  APP_RESOURCE_PATH = '';
}
angular.module('maestro.config', []);
var provideMaestroConfig = function provideMaestroConfig(response) {
  var _response$data = response.data,
    event = _response$data.event,
    user = _response$data.user,
    branding = _response$data.branding,
    version = _response$data.version,
    prefix = response.prefix;
  var title = event.name || (event.description || {}).en;
  document.title = "".concat(title, " - SpotMe");
  (0, _errorReporting.register)(branding || event.branded_app, event._id);
  angular.module('maestro.config').constant('ENV', ENV).constant('VERSION', VERSION).constant('EID', event._id).constant('EVENT', event).constant('APP_RESOURCE_PATH', APP_RESOURCE_PATH).constant('PID', user._id).constant('ACTIVATED_PERSON', user).constant('BRANDING', branding).constant('PLATFORM', 'web').constant('ANALYTICS_PLATFORM', 'web').constant('ROUTE_PREFIX', prefix || '').constant('BACKEND_VERSION', (version || {}).backend).constant('WHITE_LABEL_DOMAIN', (event || {}).white_label_domain).constant('NO_CBL', false);
  return event;
};
var appScriptUrl = function appScriptUrl(eid, path) {
  return "/api/v1/eid/".concat(eid, "/appscripts/").concat(path);
};
var runAppScript = function runAppScript(_ref) {
  var eid = _ref.eid,
    path = _ref.path,
    params = _ref.params,
    lang = _ref.lang,
    timezone = _ref.timezone;
  return $http({
    method: 'POST',
    url: appScriptUrl(eid, path),
    data: {
      timezone: timezone,
      lang: lang,
      params: params
    }
  });
};
var initAppScript = function initAppScript(_ref2) {
  var eid = _ref2.eid,
    path = _ref2.path,
    params = _ref2.params,
    lang = _ref2.lang,
    timezone = _ref2.timezone;
  angular.module('maestro.config').constant('APPSCRIPT_CONFIG', {}).constant('APPSCRIPT_BLOB', null);
  return runAppScript({
    eid: eid,
    path: path,
    params: params,
    lang: lang,
    timezone: timezone
  });
};
var setTimezone = function setTimezone(settings, event) {
  var timezone = _momentTimezone.default.tz.guess();
  if (!settings.date || settings.date.timezone !== 'device') {
    timezone = event.timezone;
    _momentTimezone.default.tz.setDefault(timezone);
  }
  console.log('[maestro] party is in...', timezone);
  return timezone;
};
var loadConfig = function loadConfig(event, cacheBust) {
  return $http.get("/api/v1/eid/".concat(event._id, "/webapp/bootstrap-resources").concat(cacheBust ? "?_=".concat(Date.now()) : '')).then(function (_ref3) {
    var data = _ref3.data;
    var normNavs = (0, _webappSkeleton.normalizeNavs)(data.navs);
    var timezone = setTimezone(data.settings, event);
    var settings = data.settings;
    var actions = data.actions;
    angular.module('maestro.config').constant('I18N', data.i18n).constant('SETTINGS', data.settings).constant('ACTIONS', data.actions || {}).constant('BEHAVIOURS', data.behaviours || {}).constant('PERSON_DYNAMIC_EXTENSIONS', data.personDynamicExtensions).constant('THEME', (0, _webappSkeleton.parseTheme)(data.theme, event)).constant('EVENT_NAVS', normNavs).constant('EVENT_TYPE', 'event').constant('METADATA', data.metadata).constant('NAV_BAR_CONFIG', normNavs.nav_navigation_bar || {
      enabled: false
    }).constant('USE_APPCUES', (event.webapp || {}).load_appcues).constant('ANALYTICS_ENDPOINT', data.analytics_endpoint);
    var lang = angular.injector(['ng', 'maestro.config', 'i18n']).get('$i18n').lang;
    _momentTimezone.default.locale(lang);
    console.log('Locale', _momentTimezone.default.locale());
    var setHomeNav = function setHomeNav(nav) {
      nav = nav || data.navs.nav_home;
      nav.$is_home = true;
      angular.module('maestro.config').constant('HOME_NAV', nav);
    };
    var home = (data.config.home || {}).ds;
    var applyHomeFallback = function applyHomeFallback() {
      return setHomeNav(normNavs.nav_home);
    };
    var _ref4 = settings['home-launcher'].item || {},
      fpType = _ref4.fp_type,
      fpExtId = _ref4.fp_ext_id;
    if (fpType && fpExtId) {
      if (fpType === 'nav') {
        var nav = normNavs[fpExtId];
        if (nav) {
          var customNavAction = actions["fp_type:nav:".concat(fpExtId)];
          if (!customNavAction || customNavAction.local_resolution) {
            return setHomeNav(nav);
          }
        }
      }
    }
    if (!home || home.type !== 'javascript' || !home.source || !home.source.path) {
      setHomeNav(data.navs.nav_home);
      home = data.navs.nav_home.ds;
    }
    return initAppScript({
      eid: event._id,
      path: home.source.path,
      params: home.source.params,
      timezone: timezone,
      lang: lang
    }).then(function (_ref5) {
      var _ref5$data = _ref5.data,
        status = _ref5$data.status,
        response = _ref5$data.response;
      if (status === 'error') applyHomeFallback();
      setHomeNav(response || data.navs.nav_home);
    }, applyHomeFallback);
  });
};
var loadWebinarConfig = function loadWebinarConfig(event) {
  return $http.get("/api/v1/eid/".concat(event._id, "/webapp/webinar-resources")).then(function (_ref6) {
    var data = _ref6.data;
    setTimezone(data.settings, event);
    angular.module('maestro.config').constant('I18N', data.i18n).constant('SETTINGS', data.settings).constant('ACTIONS', {}).constant('BEHAVIOURS', {}).constant('THEME', (0, _webappSkeleton.parseTheme)(data.theme, event)).constant('EVENT_NAVS', {}).constant('EVENT_TYPE', 'webinar').constant('METADATA', data.metadata).constant('NAV_BAR_CONFIG', {
      enabled: false
    }).constant('USE_APPCUES', (event.webapp || {}).load_appcues).constant('APPSCRIPT_CONFIG', {}).constant('APPSCRIPT_BLOB', null).constant('ANALYTICS_ENDPOINT', data.analytics_endpoint).constant('HOME_NAV', {
      $is_home: true
    });
    var lang = angular.injector(['ng', 'maestro.config', 'i18n']).get('$i18n').lang;
    _momentTimezone.default.locale(lang);
    console.log('Locale', _momentTimezone.default.locale());
  });
};
var applyEventBranding = function applyEventBranding(event) {
  var iconUrl = (0, _assets.getEventIconUrl)(event);
  var el = angular.element;
  el('head').append(el("<link rel=\"icon\" href=\"".concat(iconUrl, "\"/>"))).append(el("<link rel=\"apple-touch-icon\" href=\"".concat(iconUrl, "\"/>"))).append(el("<meta name=\"msapplication-square70x70logo\" content=\"".concat(iconUrl, "\"/>"))).append(el("<meta name=\"msapplication-square150x150logo\" content=\"".concat(iconUrl, "\"/>")));
};
var bootReady = function bootReady() {
  var requestTimeout = $q.defer();
  var cancelRequest = $timeout(function () {
    console.warn('[maestro] Failed to get session in a timely manner. Retrying.');
    requestTimeout.reject();
    boot();
    angular.element('#app-preloader .progress-bar').addClass('finished-with-error');
    angular.element('#app-preloader .preloader-error').show();
    angular.element('.global-blocking-task-guard').hide();
  }, 60 * 1000 + Math.round(Math.random() * 1000));
  $timeout.cancel(cancelRequest);
  angular.element('#app-preloader, #unsupported').remove();
  angular.element(document).ready(function () {
    angular.bootstrap(document, ['maestro'], {
      strictDi: true
    });
    window.debugAppscript = function (scriptName) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      angular.element(document.body).injector().get('databaseService').runAppScript(scriptName, params).then(function (e) {
        return console.log(e.data);
      });
    };
  });
};
var boot = function () {
  var _ref7 = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee() {
    var requestTimeout, redirectToLogin, session, event;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          requestTimeout = $q.defer();
          redirectToLogin = function redirectToLogin(branding, reason, redirect) {
            if (window.location.href.indexOf('/welcome') !== -1) {
              return;
            }
            var url = "https://webapp.spotme.com" + '/welcome';
            if (branding) {
              url += "/".concat(branding);
            }
            var query = {};
            if (reason) {
              query.reason = reason;
            }
            if (redirect) {
              query.redirect = redirect;
            }
            if (reason || redirect) {
              url += "?".concat($httpParamSerializer(query));
            }
            window.location.href = url;
          };
          _context.next = 4;
          return (0, _authService.getUserSession)({
            timeout: requestTimeout.promise
          }, $http).catch(function (errorResponse) {
            var error = errorResponse.data || {};
            var branding = error.branding;
            if (errorResponse.status === 400 && error.error === 'archived event') {
              redirectToLogin(branding, 'archived');
            } else {
              redirectToLogin(branding, null, window.location.pathname);
            }
            console.error('[Bootloader] Boot interrupted:', error);
            throw new Error('Failed to get session');
          });
        case 4:
          session = _context.sent;
          _context.next = 7;
          return provideMaestroConfig(session);
        case 7:
          event = _context.sent;
          if (!event.is_webinar) {
            _context.next = 13;
            break;
          }
          _context.next = 11;
          return loadWebinarConfig(event);
        case 11:
          _context.next = 15;
          break;
        case 13:
          _context.next = 15;
          return loadConfig(event, (0, _lodash.get)(session, 'data.user.is_team_member'));
        case 15:
          _context.next = 17;
          return bootReady();
        case 17:
          applyEventBranding(event);
        case 18:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function boot() {
    return _ref7.apply(this, arguments);
  };
}();
console.log('[maestro] booting v' + "1.156.0", "production");
if ("production" !== 'dev') {
  boot();
} else {
  if ('__karma__' in window) {
    console.log('[bootloader] test env detected, skipping boot procedures');
  } else {
    boot();
  }
}

},{"./services/authService":243,"./utils/assets":350,"./utils/errorReporting":356,"./utils/webapp-skeleton":370,"@babel/runtime/helpers/asyncToGenerator":375,"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/regenerator":398,"lodash":"lodash","moment-timezone":"moment-timezone","moment/min/locales.min":1166}],2:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppChromeComponent = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
var AppChromeComponent = {
  template: require('./app-chrome.jade'),
  controller: function () {
    AppChromeComponent.$inject = ["THEME", "EVENT_NAVS", "NAV_TEMPLATES", "NAV_BAR_CONFIG", "PID", "SETTINGS", "$rootScope", "$scope", "$timeout", "$window", "$i18n", "progressBarService", "navService", "pictureInPictureService", "databaseService", "signalService", "notificationsService", "uiService", "$eventBus", "$compile", "$element", "websocketConnectionReportingService"];
    /* @ngInject */function AppChromeComponent(THEME, EVENT_NAVS, NAV_TEMPLATES, NAV_BAR_CONFIG, PID, SETTINGS, $rootScope, $scope, $timeout, $window, $i18n, progressBarService, navService, pictureInPictureService, databaseService, signalService, notificationsService, uiService, $eventBus, $compile, $element, websocketConnectionReportingService) {
      (0, _classCallCheck2.default)(this, AppChromeComponent);
      $scope.activatedPerson = $rootScope.activatedPerson;
      $scope.device = $rootScope.device;
      $scope.eventTheme = THEME;
      $scope.navTemplates = NAV_TEMPLATES;
      this.pid = PID;
      this.settings = SETTINGS;
      this.navTemplates = NAV_TEMPLATES;
      this.useNavBar = NAV_BAR_CONFIG.enabled;
      this.$rootScope = $rootScope;
      this.$scope = $scope;
      this.$compile = $compile;
      this.$element = $element;
      this.$eventBus = $eventBus;
      this.$timeout = $timeout;
      this.$window = $window;
      this.$i18n = $i18n;
      this.progressBarService = progressBarService;
      this.navService = navService;
      this.pictureInPictureService = pictureInPictureService;
      this.uiService = uiService;
      this.signalService = signalService;
      this.databaseService = databaseService;
      this.notificationsService = notificationsService;
      this.websocketConnectionReportingService = websocketConnectionReportingService;
      this.appLoading = true;
      this.activeNav = navService.activeNav;
      this.performActions = (0, _lodash.curryRight)(navService.performActions.bind(navService))(null);
      this.hasGlobalBlockingTasks = progressBarService.hasGlobalBlockingTasks;
      this.containerClass = [];
      if (this.useNavBar) {
        this.containerClass.push('app-nav-bar-mode');
      }
      this.spotmanNav = EVENT_NAVS.nav_spotman;
      this.currentNuid = null;
      this.back = function () {
        return $window.history.back();
      };
      this.onPushNotification = this._onPushNotification.bind(this);
      this.listeners = [];
    }
    (0, _createClass2.default)(AppChromeComponent, [{
      key: "$onInit",
      value: function $onInit() {
        var _this = this;
        angular.element('html').attr('lang', this.$i18n.lang || 'en');
        this.websocketConnectionReportingService.init();
        this.$timeout(function () {
          _this.appLoading = false;
        });
        this.$timeout(function () {
          _this.notificationsService.checkForNewNotification(_this.onPushNotification);
          _this.notificationsService.startCheckInterval(_this.onPushNotification);
        });
        var theatreOnListener = this.$eventBus.on('theatreMode:enabled', function () {
          _this.navPanelsClass = 'theatre-mode';
        });
        var theatreOffListener = this.$eventBus.on('theatreMode:disabled', function () {
          _this.navPanelsClass = undefined;
        });
        this.signalService.addSignalListener("pushNotification/".concat(this.pid), this.onPushNotification).then(function (remover) {
          return _this.listeners.push(remover);
        });
        var notificationInAppListener = this.$eventBus.on('notification:in-app', function (config) {
          _this.$scope.$applyAsync(function () {
            var scope = _this.$rootScope.$new(true);
            angular.extend(scope, config);
            _this.$element.append(_this.$compile('<in-app-notification></in-app-notification>')(scope));
          });
        });
        this.listeners.push(theatreOnListener, theatreOffListener, notificationInAppListener, this.$scope.$on('error-banner:display', function (event, isVisible) {
          var errorBannerVisibleClass = 'error-banner-visible';
          if (isVisible) {
            _this.containerClass.push(errorBannerVisibleClass);
          } else {
            _this.containerClass = _this.containerClass.filter(function (c) {
              return c !== errorBannerVisibleClass;
            });
          }
        }));
        var body = angular.element(document.body);
        if ('objectFit' in document.documentElement.style === false) {
          body.addClass('no-objectfit');
        }
        var ua = window.navigator.userAgent;
        var iphone = !!ua.match(/iPhone/i);
        var ipad = !!ua.match(/iPad/i);
        var iOS = iphone || ipad;
        var webkit = !!ua.match(/WebKit/i);
        var iOSSafari = iOS && webkit && !ua.match(/CriOS/i);
        if (iphone) body.addClass('iphone');
        if (ipad) body.addClass('ipad');
        if (iOSSafari) body.addClass('mobile-safari');
        this.databaseService.runLifeCycleScripts('on-load');
        this.complianceHeaderContent = (0, _lodash.get)(this.settings, 'compliance_header.text');
        this.complianceHeaderStyle = this.getStyleFromSettings('header');
        this.complianceFooterContent = (0, _lodash.get)(this.settings, 'compliance_footer.text');
        this.complianceFooterStyle = this.getStyleFromSettings('footer');
      }
    }, {
      key: "scrolled",
      value: function scrolled(toTop) {
        if (toTop) {
          this.containerClass = this.containerClass.filter(function (c) {
            return c !== 'scrolled';
          });
        } else {
          this.containerClass.push('scrolled');
        }
      }
    }, {
      key: "bottomReached",
      value: function bottomReached() {
        this.$rootScope.$broadcast('bottom-reached');
      }
    }, {
      key: "_onPushNotification",
      value: function _onPushNotification(_ref) {
        var _this2 = this;
        var notificationLinkId = _ref.notificationLinkId,
          notificationPayload = _ref.notificationPayload;
        var ctx = (0, _lodash.get)(notificationPayload, 'ctx');
        var docId = (0, _lodash.get)(notificationPayload, 'doc_id');
        if (!this.notificationsService.shouldDisplayNotification(ctx, docId)) {
          return;
        }
        this.notificationsService.trackNotificationReception(notificationPayload);
        notificationPayload = (0, _lodash.defaults)(notificationPayload, {
          backgroundColor: (0, _lodash.get)(this.$scope, 'eventTheme.toolbar.background_color'),
          contentColor: (0, _lodash.get)(this.$scope, 'eventTheme.toolbar.font_color'),
          iconColor: (0, _lodash.get)(this.$scope, 'eventTheme.toolbar.font_color')
        });
        var message = this.uiService.buildNotificationMessage(notificationPayload);
        if (!notificationLinkId) {
          return this.uiService.inAppNotification(message);
        }
        this.databaseService.docWithId(notificationLinkId).then(function () {
          return _this2.uiService.inAppNotification(message);
        }).catch(function () {
          return console.log("Notification was not sent, doc with id: ".concat(notificationLinkId, " has been deleted!"));
        });
      }
    }, {
      key: "getStyleFromSettings",
      value: function getStyleFromSettings(type) {
        var applyCustomColors = (0, _lodash.get)(this.settings, "compliance_".concat(type, ".custom_colors"));
        if (applyCustomColors) {
          var linkColorPropertyName = "--".concat(type, "-link-color");
          return (0, _defineProperty2.default)({
            backgroundColor: (0, _lodash.get)(this.settings, "compliance_".concat(type, ".background_color")),
            color: (0, _lodash.get)(this.settings, "compliance_".concat(type, ".text_color")),
            borderColor: (0, _lodash.get)(this.settings, "compliance_".concat(type, ".border_color")),
            borderWidth: (0, _lodash.get)(this.settings, "compliance_".concat(type, ".border_pixels"))
          }, linkColorPropertyName, (0, _lodash.get)(this.settings, "compliance_".concat(type, ".link_color")));
        } else {
          var _linkColorPropertyName = "--".concat(type, "-link-color");
          var eventTheme = this.$scope.eventTheme;
          var themeVersion = eventTheme.version;
          var oldThemeVersion = 2;
          return (0, _defineProperty2.default)({
            backgroundColor: themeVersion > oldThemeVersion ? eventTheme.backgroundColor3 : '#FFF',
            color: themeVersion > oldThemeVersion ? eventTheme.foregroundColor1 : '#000',
            borderColor: themeVersion > oldThemeVersion ? eventTheme.backgroundColor2 : '#DDD',
            borderWidth: '1px'
          }, _linkColorPropertyName, eventTheme.primary_color);
        }
      }
    }, {
      key: "$onDestroy",
      value: function $onDestroy() {
        this.websocketConnectionReportingService.dispose();
        (0, _lodash.each)(this.listeners, function (unsub) {
          if ((0, _lodash.isFunction)(unsub)) {
            unsub();
          }
        });
        this.$window.removeEventListener('unload', this.unloadHandler);
        this.notificationsService.cancelCheckInterval();
      }
    }, {
      key: "$doCheck",
      value: function $doCheck() {
        var _this3 = this;
        var actualNuid = (this.activeNav.nav || {}).nuid;
        if (this.currentNuid !== actualNuid) {
          this.currentNuid = actualNuid;
          this.$scope.nav = null;
          this.$timeout(function () {
            return _this3.$scope.nav = _this3.activeNav.nav;
          });
        }
      }
    }]);
    return AppChromeComponent;
  }()
};
exports.AppChromeComponent = AppChromeComponent;

},{"./app-chrome.jade":3,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/defineProperty":378,"@babel/runtime/helpers/interopRequireDefault":382,"lodash":"lodash"}],3:[function(require,module,exports){
module.exports = '<div class="global-blocking-task-guard" ng-show="$ctrl.hasGlobalBlockingTasks()"></div><main class="ng-hide current_page_{{$ctrl.activeNav.nav._id}}" id="container" ng-hide="$ctrl.appLoading" ng-class="$ctrl.containerClass" scrolled="$ctrl.scrolled" on-bottom-reached="$ctrl.bottomReached()"><app-nav-bar></app-nav-bar><div class="nav-panels" ng-class="$ctrl.navPanelsClass"><div class="container-fluid no-gutter"><div class="row"><spotman-nav class="col-md-3 col-sm-3 hidden-xs sticky" config="::$ctrl.spotmanNav"></spotman-nav><div class="nav-panel col-md-9 col-sm-9 col-xs-12"><div class="row compliance-header" ng-if="$ctrl.complianceHeaderContent" ng-style="$ctrl.complianceHeaderStyle" ng-bind-html="$ctrl.complianceHeaderContent"></div><div id="pip-wrapper"></div><div class="row nav-content" ng-include="$ctrl.navTemplates[nav.nav_type]"></div><div class="row compliance-footer" ng-if="$ctrl.complianceFooterContent" ng-style="$ctrl.complianceFooterStyle" ng-bind-html="$ctrl.complianceFooterContent"></div></div></div></div></div></main><cookies-notification></cookies-notification><offline-notification></offline-notification><test-watermark></test-watermark><update-browser></update-browser>';
},{}],4:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppNavBarComponent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
var _menu = require("../../../utils/menu");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var AppNavBarComponent = {
  template: require('./app-nav-bar.jade'),
  controller: function () {
    AppNavBarComponent.$inject = ["THEME", "NAV_BAR_CONFIG", "EVENT_NAVS", "$device", "$rootScope", "$eventBus", "navService", "databaseService"];
    /* @ngInject */
    function AppNavBarComponent(THEME, NAV_BAR_CONFIG, EVENT_NAVS, $device, $rootScope, $eventBus, navService, databaseService) {
      (0, _classCallCheck2.default)(this, AppNavBarComponent);
      this.theme = THEME;
      this.nav = NAV_BAR_CONFIG;
      this.$device = $device;
      this.$rootScope = $rootScope;
      this.$eventBus = $eventBus;
      this.navService = navService;
      this.databaseService = databaseService;
      this.listeners = [];
      this.searchNav = EVENT_NAVS['nav_app_search'];
    }
    (0, _createClass2.default)(AppNavBarComponent, [{
      key: "$onInit",
      value: function $onInit() {
        var _this = this;
        if (!this.nav || !this.nav.enabled) return;
        var toolbarTheme = this.theme.toolbar || {};
        this.notificationBadgeStyle = {
          color: toolbarTheme.background_color,
          background: toolbarTheme.font_color,
          borderColor: toolbarTheme.background_color
        };
        if (this.theme.version === 3 && this.theme.activeLinkStyle === 'underline') {
          this.notificationBadgeStyle.background = this.theme.backgroundColor3;
        }
        var spotmanListener = this.$eventBus.on('spotman:click', function (row) {
          var id = row._id;
          if (id.startsWith('back_to_')) {
            id = id.replace(/^back_to_/, '');
          }
          _this.activeItemId = id;
        });
        this.listeners.push(spotmanListener);
        this.inflate();
      }
    }, {
      key: "$onDestroy",
      value: function $onDestroy() {
        var _iterator = _createForOfIteratorHelper(this.listeners),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var unsubscribe = _step.value;
            if ((0, _lodash.isFunction)(unsubscribe)) {
              unsubscribe();
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }, {
      key: "inflate",
      value: function inflate() {
        var _this2 = this;
        if (this.inflated) return;
        this.inflated = true;
        this.navService.inflateNav(this.nav).then(function (_ref) {
          var elements = _ref.elements;
          _this2.items = elements;
          _this2.initBadges();
          _this2.initNotificationListeners();
        }, function () {
          return _this2.inflated = false;
        });
      }
    }, {
      key: "initBadges",
      value: function initBadges() {
        var _this3 = this;
        this.badges = {};
        (0, _lodash.each)(this.items, function (item) {
          return _this3.getItemBadge(item);
        });
      }
    }, {
      key: "initNotificationListeners",
      value: function initNotificationListeners() {
        var _this4 = this;
        var subscribeToRowNotifications = function subscribeToRowNotifications(notifications, action) {
          return _this4.navService.subscribeToEvents(_this4.navService.flattenNotificationMap(notifications), action);
        };
        (0, _lodash.each)(this.items, function (item) {
          if (!item.badge || !item.badge.ds || !item.badge.ds.reload_on) {
            return;
          }
          subscribeToRowNotifications(item.badge.ds.reload_on, _this4.getItemBadge.bind(_this4, item));
        });
        var notificationInAppListener = this.$eventBus.on('notification:in-app', function () {
          var _iterator2 = _createForOfIteratorHelper(_this4.items),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var element = _step2.value;
              _this4.getItemBadge(element);
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        });
        this.listeners.push(notificationInAppListener);
      }
    }, {
      key: "getItemBadge",
      value: function getItemBadge(item) {
        var _this5 = this;
        (0, _menu.getItemBadge)(item, this.databaseService, function (i, count) {
          item.badge.value = count;
          if (_this5.badges[item._id] !== count) {
            if (_this5.badges[item._id] || count > 0) {
              _this5.$rootScope.$emit('badges:updated', {
                _id: item._id,
                value: count
              });
            }
            _this5.badges[item._id] = count;
          }
        });
      }
    }, {
      key: "activate",
      value: function activate(item) {
        this.activeItemId = item._id;
        this.navService.performActions(item.actions, 'app-nav-bar');
      }
    }, {
      key: "iconColor",
      value: function iconColor(item) {
        var colorizeIcons = Boolean((0, _lodash.get)(this, 'theme.spotman.view.icon_color'));
        if (!colorizeIcons) {
          return;
        }
        var _this$theme$toolbar = this.theme.toolbar,
          background_color = _this$theme$toolbar.background_color,
          font_color = _this$theme$toolbar.font_color;
        return this.activeItemId === item._id ? background_color : font_color;
      }
    }]);
    return AppNavBarComponent;
  }()
};
exports.AppNavBarComponent = AppNavBarComponent;

},{"../../../utils/menu":362,"./app-nav-bar.jade":5,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"lodash":"lodash"}],5:[function(require,module,exports){
module.exports = '<div class="wrapper" theme="::$ctrl.theme.version === 3 ? {} : $ctrl.theme" theme-selector="toolbar" theme-attrs="color"><div class="wrapper-inner"><app-search ng-if="::$ctrl.searchNav" config="$ctrl.searchNav"></app-search><a class="item inverse-bg-when-active" ng-repeat="item in $ctrl.items track by item._id" ng-click="$ctrl.activate(item)" ng-class="{active: $ctrl.activeItemId === item._id}" id="app-nav-bar-item-{{::item._id}}"><span class="notification-badge" ng-show="item.badge.value &gt; 0 &amp;&amp; item.badge.value &lt; 10" ng-style="::$ctrl.notificationBadgeStyle" ng-bind="item.badge.value"></span><span class="notification-badge" ng-show="item.badge.value &gt; 10" ng-style="::$ctrl.notificationBadgeStyle">9+</span><i class="nav-list-item-icon" icon="::item.img" force-color="$ctrl.iconColor(item)"></i><span class="title" title="{{::item.title}}">{{::item.title}}</span></a></div></div>';
},{}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppNavBarModule = void 0;
var _appNavBar = require("./app-nav-bar.component");
var AppNavBarModule = angular.module('maestro.components.app-chrome.nav-bar', []).component('appNavBar', _appNavBar.AppNavBarComponent).name;
exports.AppNavBarModule = AppNavBarModule;

},{"./app-nav-bar.component":4}],7:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppSearchComponent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
var _i18nWithFallback = _interopRequireDefault(require("../../../utils/i18n-with-fallback"));
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var AppSearchComponent = {
  template: require('./app-search.pug'),
  bindings: {
    config: '<'
  },
  controller: function () {
    AppSearchComponent.$inject = ["THEME", "navService", "databaseService", "navRouterService", "$eventBus", "$i18n", "$element"];
    /* @ngInject */
    function AppSearchComponent(THEME, navService, databaseService, navRouterService, $eventBus, $i18n, $element) {
      (0, _classCallCheck2.default)(this, AppSearchComponent);
      this.navService = navService;
      this.databaseService = databaseService;
      this.navRouterService = navRouterService;
      this.$eventBus = $eventBus;
      this.$element = $element;
      this.listeners = [];
      this.query = '';
      this.appearance = THEME.get('appearance') || 'blank';
      this.searchPlaceholder = (0, _i18nWithFallback.default)($i18n, 'general.search', 'Search');
      this.searchAriaDescription = (0, _i18nWithFallback.default)($i18n, 'general.perform_search', 'Perform search');
      this.closeAriaDescription = (0, _i18nWithFallback.default)($i18n, 'general.clear_search', 'Clear the search query');
    }
    (0, _createClass2.default)(AppSearchComponent, [{
      key: "$onInit",
      value: function $onInit() {
        console.log('[AppSearch] init', this.config);
        var route = this.navRouterService.extractNavIdAndParamsFromUrl(location.href);
        if (route.navId === this.config._id) {
          var query = (0, _lodash.get)(route, 'routeParams.query');
          if (query) {
            this.query = decodeURIComponent(query);
            this.search();
          }
        }
        this.registerListeners();
      }
    }, {
      key: "$onDestroy",
      value: function $onDestroy() {
        this.close();
        this.unregisterListeners();
      }
    }, {
      key: "registerListeners",
      value: function registerListeners() {
        var _this = this;
        var navChangeListener = this.$eventBus.on('$navChange', function (nav) {
          if (nav._id === _this.config._id) {
            if (nav.query && nav.query !== _this.query) {
              _this.query = decodeURIComponent(nav.query);
              _this.search();
            }
            return;
          }
          _this.close();
        });
        this.listeners.push(navChangeListener);
      }
    }, {
      key: "unregisterListeners",
      value: function unregisterListeners() {
        var _iterator = _createForOfIteratorHelper(this.listeners),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var unsub = _step.value;
            if ((0, _lodash.isFunction)(unsub)) unsub();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }, {
      key: "search",
      value: function search() {
        var _this2 = this;
        var source = (0, _lodash.get)(this.config, 'ds.source', {});
        var path = source.path,
          _source$params = source.params,
          params = _source$params === void 0 ? {} : _source$params;
        if (!path) {
          console.error('[AppSeach] No search datasource provided');
          return;
        }
        if ((0, _lodash.isEmpty)(this.query)) {
          console.info('[AppSearch] empty query, giving up');
          this.$element.find('input').focus();
          return;
        }
        console.log('[AppSearch] Search for ', this.query);
        params.search = this.query;
        this.databaseService.runAppScript(path, params).then(function (_ref) {
          var data = _ref.data;
          console.info('[AppSearch] Search results:', data.response);
          var nav = Object.assign({}, _this2.config, {
            query: _this2.query,
            results: data.response
          });
          _this2.navService.openNav(nav);
        }).finally(function () {
          _this2.$element.find('input').focus();
        });
      }
    }, {
      key: "close",
      value: function close($event) {
        if ($event) {
          $event.preventDefault();
          this.$element.find('input').focus();
        }
        console.debug('[AppSearch] Closing');
        this.query = '';
      }
    }]);
    return AppSearchComponent;
  }()
};
exports.AppSearchComponent = AppSearchComponent;

},{"../../../utils/i18n-with-fallback":359,"./app-search.pug":8,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"lodash":"lodash"}],8:[function(require,module,exports){
module.exports = '<form class="app-search search-bar" ng-class="$ctrl.appearance" ng-submit="$ctrl.search($event)" role="search"><div class="search-input-wrapper"><input type="search" ng-attr-placeholder="{{$ctrl.searchPlaceholder}}" ng-model="$ctrl.query" spellcheck="false"/><button class="search no-click-effect" ng-attr-aria-label="{{$ctrl.searchAriaDescription}}"><i class="icon-magnifying-glass"></i></button><button class="clear no-click-effect" ng-click="$ctrl.close($event)" ng-attr-aria-label="{{$ctrl.closeAriaDescription}}"><i class="icon-cross"></i></button></div></form>';
},{}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppSearchModule = void 0;
var _appSearch = require("./app-search.component");
var AppSearchModule = angular.module('maestro.components.app-chrome.app-search', []).component('appSearch', _appSearch.AppSearchComponent).name;
exports.AppSearchModule = AppSearchModule;

},{"./app-search.component":7}],10:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppChromeModule = void 0;
var _appChrome = require("./app-chrome.component");
var _appNavBar = require("./app-nav-bar");
var _appSearch = require("./app-search");
var AppChromeModule = angular.module('maestro.components.app-chrome', [_appNavBar.AppNavBarModule, _appSearch.AppSearchModule]).component('appChrome', _appChrome.AppChromeComponent).name;
exports.AppChromeModule = AppChromeModule;

},{"./app-chrome.component":2,"./app-nav-bar":6,"./app-search":9}],11:[function(require,module,exports){
module.exports = '<div class="card-block" ng-click="$ctrl.performAction($event)" theme="$ctrl.THEME.version === 3 ? { card: true } : $ctrl.config.data.theme" ng-class="{\'no-card\': $ctrl.noCard, \'no-action\': $ctrl.noAction, \'no-click-effect\': $ctrl.noAction}"><component-loader class="component" ng-repeat="row in $ctrl.config.data.elements" component="::(row.type + &quot;-fragment&quot;)" attrs="{row:&quot;row&quot;, class: &quot;widget&quot;}"></component-loader></div>';
},{}],12:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardComponent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
var CardComponent = {
  bindings: {
    config: '<'
  },
  template: require('./card-block.jade'),
  controller: function () {
    CardComponent.$inject = ["navService", "databaseService", "$element", "THEME"];
    /* @ngInject */
    function CardComponent(navService, databaseService, $element, THEME) {
      (0, _classCallCheck2.default)(this, CardComponent);
      this.navService = navService;
      this.databaseService = databaseService;
      this.$element = $element;
      this.THEME = THEME;
    }
    (0, _createClass2.default)(CardComponent, [{
      key: "$onInit",
      value: function $onInit() {
        this.noCard = (0, _lodash.has)(this.config, 'data.theme.card') ? !this.config.data.theme.card : false;
        this.noAction = (0, _lodash.isEmpty)((0, _lodash.get)(this.config, 'data.action'));
      }
    }, {
      key: "performAction",
      value: function performAction($event) {
        if (this.$element.closest('.panning').length !== 0) {
          return;
        }
        $event.stopPropagation();
        var action = this.config.data.action;
        if (!action) return;
        if (action.path) {
          this.databaseService.runAppScript(action.path, action.params);
        } else {
          this.navService.performActions([action]);
        }
      }
    }]);
    return CardComponent;
  }()
};
exports.CardComponent = CardComponent;

},{"./card-block.jade":11,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"lodash":"lodash"}],13:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionsComponent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
var ActionsComponent = {
  bindings: {
    row: '<'
  },
  replace: true,
  template: require('./actions.jade'),
  controller: function () {
    ActionsComponent.$inject = ["styleParser", "$filter", "databaseService"];
    /* @ngInject */
    function ActionsComponent(styleParser, $filter, databaseService) {
      (0, _classCallCheck2.default)(this, ActionsComponent);
      this.parser = styleParser;
      this.$filter = $filter;
      this.databaseService = databaseService;
    }
    (0, _createClass2.default)(ActionsComponent, [{
      key: "$onInit",
      value: function $onInit() {
        this.config = this.row.config;
        this.style = this.parser.parseMargins(this.config);
        if (this.config.left) {
          this.parseButtonsStyles(this.config.left);
        }
        if (this.config.right) {
          this.parseButtonsStyles(this.config.right);
        }
      }
    }, {
      key: "performAction",
      value: function performAction(button, $event) {
        $event.stopPropagation();
        if (button.path) {
          this.databaseService.runAppScript(button.path, button.params);
        }
      }
    }, {
      key: "parseButtonsStyles",
      value: function parseButtonsStyles(buttonsGroup) {
        var _this = this;
        (0, _lodash.each)(buttonsGroup, function (btn) {
          btn.style = _this.parser.parseTextsStyles(btn, 'label');
          if (btn.icon_url) {
            var img = 'url(' + _this.$filter('assetUrl')(btn.icon_url) + ')';
            btn.icon_style = {
              'background-image': img
            };
          }
        });
      }
    }]);
    return ActionsComponent;
  }()
};
exports.ActionsComponent = ActionsComponent;

},{"./actions.jade":14,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"lodash":"lodash"}],14:[function(require,module,exports){
module.exports = '<div class="actions-bar clearfix" ng-style="{{::$ctrl.style}}"><div class="right" ng-if="::$ctrl.config.right"><button ng-repeat="btn in $ctrl.config.right" ng-click="$ctrl.performAction(btn, $event)" ng-style="{{btn.style}}"><i class="icon" ng-style="{{btn.icon_style}}" ng-if="btn.icon_url"></i><span class="label" ng-if="btn.label">{{btn.label | i18n}}</span></button></div><div class="left" ng-if="::$ctrl.config.left"><button ng-repeat="btn in $ctrl.config.left" ng-click="$ctrl.performAction(btn, $event)" ng-style="{{btn.style}}"><i class="icon" ng-style="{{btn.icon_style}}" ng-if="btn.icon_url"></i><span class="label" ng-if="btn.label">{{btn.label | i18n}}</span></button></div></div>';
},{}],15:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CarouselController = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var CarouselController = function () {
  CarouselController.$inject = ["THEME", "databaseService", "$element", "$timeout", "styleParser"];
  /* @ngInject */
  function CarouselController(THEME, databaseService, $element, $timeout, styleParser) {
    (0, _classCallCheck2.default)(this, CarouselController);
    this.theme = THEME;
    this.databaseService = databaseService;
    this.$element = $element;
    this.$timeout = $timeout;
    this.parser = styleParser;
  }
  (0, _createClass2.default)(CarouselController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.config = this.row.config;
      console.debug("[".concat(this.constructor.name, "] init"), this.config);
      this.style = this.parser.parseMargins(this.config);
      this.title_style = this.parser.parseTextsStyles(this.config, 'title');
      if (this.config.detail) {
        this.label_style = this.parser.parseTextsStyles(this.config.detail, 'label');
      }
      this.$timeout(function () {
        var mLeft = _this.$element.find('.carousel').css('marginLeft');
        mLeft = mLeft ? parseInt(mLeft, 10) : 0;
        var mRight = _this.$element.find('.carousel').css('marginRight');
        mRight = mRight ? parseInt(mRight, 10) : 0;
        _this.$element.find('.outer').css({
          'margin-left': mLeft * -1,
          'margin-right': mRight * -1
        });
        var w = w || _this.$element.find('.outer').width();
        var slides = _this.$element.find('.item');
        slides.find('.card-block').css({
          height: _this.config.card_height,
          width: w * _this.config.card_weight - mLeft - mRight,
          'flex-basis': _this.config.card_weight * 100 + '%'
        });
        slides.first().css('margin-left', mLeft);
        slides.last().css('margin-right', mRight);
        _this.showArrows = false;
        var vpWidth = _this.$element.find('.viewport').width();
        var ctWidth = 0;
        _this.$element.find('.item').each(function () {
          ctWidth += parseInt($(this).outerWidth(true), 10);
        });
        if (ctWidth - vpWidth > 15) {
          _this.showArrows = true;
        }
      });
      var vp = this.$element.find('.viewport');
      var next = this.$element.find('.arrow.right');
      var prev = this.$element.find('.arrow.left');
      next.on('click', function (e) {
        e.stopPropagation();
        vp.animate({
          scrollLeft: vp[0].scrollLeft + 200
        }, {
          queue: false
        });
      });
      prev.on('click', function (e) {
        e.stopPropagation();
        vp.animate({
          scrollLeft: vp[0].scrollLeft - 200
        }, {
          queue: false
        });
      });
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.$element.find('.viewport').off('mousedown.carousel mousemove.carousel mouseup.carousel');
      $(document.body).on('mouseup.carousel');
      this.$element.removeClass('panning');
    }
  }, {
    key: "performLabelAction",
    value: function performLabelAction($event, action) {
      $event.stopPropagation();
      if (this.$element.hasClass('panning')) return;
      action = action ? action : this.config.detail ? this.config.detail.action : null;
      if (!action) return;
      this.databaseService.runAppScript(action.path, action.params);
    }
  }]);
  return CarouselController;
}();
exports.CarouselController = CarouselController;

},{"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382}],16:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CarouselComponent = void 0;
var _carouselController = require("./carousel-controller");
var CarouselComponent = {
  bindings: {
    row: '<'
  },
  replace: true,
  template: require('./carousel.jade'),
  controller: _carouselController.CarouselController
};
exports.CarouselComponent = CarouselComponent;

},{"./carousel-controller":15,"./carousel.jade":17}],17:[function(require,module,exports){
module.exports = '<div class="carousel" ng-style="{{::$ctrl.style}}"><span class="label" ng-if="$ctrl.config.detail.label &amp;&amp; $ctrl.config.detail.action" ng-style="{{$ctrl.label_style}}" ng-click="$ctrl.performLabelAction($event)">{{$ctrl.config.detail.label}}</span><span class="label" ng-if="$ctrl.config.detail.label &amp;&amp; !$ctrl.config.detail.action" ng-style="{{$ctrl.label_style}}">{{$ctrl.config.detail.label}}</span><span class="title" ng-if="$ctrl.config.title" ng-style="{{$ctrl.title_style}}">{{$ctrl.config.title}}</span><div class="outer"><div class="arrow left" style="border-color:{{::$ctrl.theme.toolbar.font_color}};background-color:{{::$ctrl.theme.toolbar.background_color}}" ng-class="{hidden: !$ctrl.showArrows}"></div><div class="arrow right" style="border-color:{{::$ctrl.theme.toolbar.font_color}};background-color:{{::$ctrl.theme.toolbar.background_color}}" ng-class="{hidden: !$ctrl.showArrows}"></div><div class="viewport"><div class="items-container"><div class="item" ng-repeat="card in $ctrl.config.elements"><card config="card" ng-class="{single: $ctrl.config.elements.length === 1}"></card></div></div></div></div></div>';
},{}],18:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DividerComponent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var DividerComponent = {
  bindings: {
    row: '<'
  },
  template: require('./divider.jade'),
  controller: function () {
    DividerComponent.$inject = ["navService", "styleParser"];
    /* @ngInject */
    function DividerComponent(navService, styleParser) {
      (0, _classCallCheck2.default)(this, DividerComponent);
      this.navService = navService;
      this.parser = styleParser;
    }
    (0, _createClass2.default)(DividerComponent, [{
      key: "$onInit",
      value: function $onInit() {
        this.config = this.row.config;
        var bg = {
          'background-color': this.parser.parseColor(this.config.color || '#808080')
        };
        var margins = this.parser.parseMargins(this.config);
        var boxing = this.parser.parseBoxing(this.config);
        this.style = angular.merge(bg, margins, boxing);
      }
    }]);
    return DividerComponent;
  }()
};
exports.DividerComponent = DividerComponent;

},{"./divider.jade":19,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382}],19:[function(require,module,exports){
module.exports = '<div class="divider" ng-style="{{::$ctrl.style}}"></div>';
},{}],20:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageComponent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var ImageComponent = {
  bindings: {
    row: '<'
  },
  template: require('./image.jade'),
  controller: function () {
    ImageComponent.$inject = ["navService", "styleParser"];
    /* @ngInject */
    function ImageComponent(navService, styleParser) {
      (0, _classCallCheck2.default)(this, ImageComponent);
      this.navService = navService;
      this.parser = styleParser;
    }
    (0, _createClass2.default)(ImageComponent, [{
      key: "$onInit",
      value: function $onInit() {
        this.config = this.row.config;
        var margins = this.parser.parseMargins(this.config);
        var boxing = this.parser.parseBoxing(this.config);
        this.style = angular.merge(margins, boxing);
      }
    }]);
    return ImageComponent;
  }()
};
exports.ImageComponent = ImageComponent;

},{"./image.jade":21,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382}],21:[function(require,module,exports){
module.exports = '<figure class="image" ng-style="{{::$ctrl.style}}" ng-class="$ctrl.config.image_shape"><picture><img ng-src="{{::($ctrl.config.url | assetUrl)}}" alt="{{::$ctrl.config.title}}"/></picture><figcaption ng-if="$ctrl.config.title || $ctrl.config.subtitle"><span class="title" ng-if="$ctrl.config.title">{{$ctrl.config.title}}</span><span class="subtitle" ng-if="$ctrl.config.subtitle">{{$ctrl.config.subtitle}}</span></figcaption></figure>';
},{}],22:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FragmentsModule = void 0;
var _actionsFragment = require("./actions/actions-fragment.component");
var _carouselFragment = require("./carousel/carousel-fragment.component");
var _dividerFragment = require("./divider/divider-fragment.component");
var _imageFragment = require("./image/image-fragment.component");
var _mediaTextFragment = require("./media-text/media-text-fragment.component");
var _textFragment = require("./text/text-fragment.component");
var _tagList = require("./tag-list/tag-list.component");
var FragmentsModule = angular.module('maestro.components.blocks.cards.fragments', []).component('actionsFragment', _actionsFragment.ActionsComponent).component('carouselFragment', _carouselFragment.CarouselComponent).component('dividerFragment', _dividerFragment.DividerComponent).component('imageFragment', _imageFragment.ImageComponent).component('mediaTextFragment', _mediaTextFragment.MediaTextComponent).component('textFragment', _textFragment.TextComponent).component('tagListFragment', _tagList.TagListComponent).name;
exports.FragmentsModule = FragmentsModule;

},{"./actions/actions-fragment.component":13,"./carousel/carousel-fragment.component":16,"./divider/divider-fragment.component":18,"./image/image-fragment.component":20,"./media-text/media-text-fragment.component":23,"./tag-list/tag-list.component":25,"./text/text-fragment.component":27}],23:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MediaTextComponent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var MediaTextComponent = {
  bindings: {
    row: '<'
  },
  replace: true,
  template: require('./media-text.jade'),
  controller: function () {
    MediaTextComponent.$inject = ["navService", "styleParser"];
    /* @ngInject */
    function MediaTextComponent(navService, styleParser) {
      (0, _classCallCheck2.default)(this, MediaTextComponent);
      this.navService = navService;
      this.parser = styleParser;
    }
    (0, _createClass2.default)(MediaTextComponent, [{
      key: "$onInit",
      value: function $onInit() {
        this.config = this.row.config;
        var titleTexts = this.parser.parseTextsStyles(this.config, 'title');
        var titleBoxing = this.parser.parseBoxing(this.config, 'title');
        this.title_style = angular.merge(titleTexts, titleBoxing);
        this.style = this.parser.parseMargins(this.config);
        this.image_style = this.parser.parseImageStyles(this.config);
        if (this.image_style) {
          this.image_wrapper_style = {
            width: this.image_style.width,
            height: this.image_style.height
          };
        }
        this.subtitle_style = this.parser.parseTextsStyles(this.config, 'subtitle');
        this.sidetitle_style = this.parser.parseTextsStyles(this.config, 'sidetitle');
      }
    }, {
      key: "performSideTitleAction",
      value: function performSideTitleAction($event) {
        $event.stopPropagation();
        var act = this.config.sidetitle_action;
        var lastNav = this.navService.activeNav.nav || {};
        return this.navService.openDocument(act.params, {
          _parent_nav_id: lastNav.nuid
        });
      }
    }]);
    return MediaTextComponent;
  }()
};
exports.MediaTextComponent = MediaTextComponent;

},{"./media-text.jade":24,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382}],24:[function(require,module,exports){
module.exports = '<div class="media-text" ng-style="{{::$ctrl.style}}"><div class="image-wrapper" ng-if="::($ctrl.config.image_url || $ctrl.config.fp_type === \'person\')" ng-style="{{::$ctrl.image_wrapper_style}}"><img class="image" ng-if="::$ctrl.config.fp_type !== \'person\'" asset-src="{{::$ctrl.config.image_url | assetUrl}}" alt="{{::$ctrl.config.title}}" ng-style="{{::$ctrl.image_style}}"/><avatar ng-if="::$ctrl.config.fp_type === \'person\'" object="$ctrl.config"></avatar></div><div class="text"><span class="sidetitle" ng-if="$ctrl.config.sidetitle_action" ng-style="{{::$ctrl.sidetitle_style}}" ng-click="$ctrl.performSideTitleAction($event)">{{::$ctrl.config.sidetitle}}</span><span class="sidetitle" ng-if="!$ctrl.config.sidetitle_action" ng-style="{{::$ctrl.sidetitle_style}}">{{::$ctrl.config.sidetitle}}</span><span class="title" ng-style="{{::$ctrl.title_style}}">{{::$ctrl.config.title}}</span><span class="subtitle" ng-style="{{::$ctrl.subtitle_style}}">{{::$ctrl.config.subtitle}}</span></div></div>';
},{}],25:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TagListComponent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _lodash = require("lodash");
var _carouselController = require("../carousel/carousel-controller");
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = (0, _getPrototypeOf2.default)(t); if (r) { var s = (0, _getPrototypeOf2.default)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0, _possibleConstructorReturn2.default)(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var TagListComponent = {
  template: require('./tag-list.jade'),
  bindings: {
    row: '<'
  },
  controller: function (_CarouselController) {
    (0, _inherits2.default)(TagListComponent, _CarouselController);
    var _super = _createSuper(TagListComponent);
    function TagListComponent() {
      (0, _classCallCheck2.default)(this, TagListComponent);
      return _super.apply(this, arguments);
    }
    (0, _createClass2.default)(TagListComponent, [{
      key: "$onInit",
      value: function $onInit() {
        (0, _get2.default)((0, _getPrototypeOf2.default)(TagListComponent.prototype), "$onInit", this).call(this);
        this.config.elements = this.config.items;
        this.setStyles();
      }
    }, {
      key: "setStyles",
      value: function setStyles() {
        var _this = this;
        (0, _lodash.each)(this.config.elements, function (item) {
          item.style = _this.parser.parseTextsStyles(item);
          if (item.selected || item.text_color) {
            item.style['background-color'] = _this.parser.parseColor(item.color);
          }
          if (item.text_color) {
            item.style['color'] = _this.parser.parseColor(item.selected ? item.text_color.selected : item.text_color.default);
            if (!item.selected) {
              item.style['background-color'] = 'transparent';
              item.style['border-color'] = _this.parser.parseColor(item.color);
            }
          }
        });
      }
    }, {
      key: "performLabelAction",
      value: function performLabelAction($event, row) {
        var _this2 = this;
        (0, _get2.default)((0, _getPrototypeOf2.default)(TagListComponent.prototype), "performLabelAction", this).call(this, $event, row.action);
        if (this.config.selectable !== false) {
          (0, _lodash.each)(this.config.elements, function (item) {
            item.style = _this2.parser.parseTextsStyles(item);
            item.selected = false;
          });
          row.selected = true;
          this.setStyles();
        }
      }
    }]);
    return TagListComponent;
  }(_carouselController.CarouselController)
};
exports.TagListComponent = TagListComponent;

},{"../carousel/carousel-controller":15,"./tag-list.jade":26,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/get":379,"@babel/runtime/helpers/getPrototypeOf":380,"@babel/runtime/helpers/inherits":381,"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/helpers/possibleConstructorReturn":387,"lodash":"lodash"}],26:[function(require,module,exports){
module.exports = '<div class="carousel tag-list" ng-style="{{::$ctrl.style}}"><span class="title" ng-if="$ctrl.config.title" ng-style="{{$ctrl.title_style}}">{{$ctrl.config.title}}</span><div class="outer"><div class="arrow left" style="border-color:{{::$ctrl.theme.toolbar.font_color}};background-color:{{::$ctrl.theme.toolbar.background_color}}" ng-class="{hidden: !$ctrl.showArrows}"></div><div class="arrow right" style="border-color:{{::$ctrl.theme.toolbar.font_color}};background-color:{{::$ctrl.theme.toolbar.background_color}}" ng-class="{hidden: !$ctrl.showArrows}"></div><div class="viewport"><div class="items-container"><div class="item" ng-repeat="item in $ctrl.config.elements"><div class="tag" ng-style="item.style" ng-class="{selected: item.selected}" ng-click="$ctrl.performLabelAction($event, item)"><span class="text">{{::item.label}}</span></div></div></div></div></div></div>';
},{}],27:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextComponent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var TextComponent = {
  bindings: {
    row: '<'
  },
  replace: true,
  template: require('./text.jade'),
  controller: function () {
    TextComponent.$inject = ["navService", "styleParser"];
    /* @ngInject */
    function TextComponent(navService, styleParser) {
      (0, _classCallCheck2.default)(this, TextComponent);
      this.navService = navService;
      this.parser = styleParser;
    }
    (0, _createClass2.default)(TextComponent, [{
      key: "$onInit",
      value: function $onInit() {
        this.config = this.row.config;
        var texts = this.parser.parseTextsStyles(this.config);
        var margins = this.parser.parseMargins(this.config);
        var boxing = this.parser.parseBoxing(this.config);
        this.style = angular.merge(texts, margins, boxing);
      }
    }]);
    return TextComponent;
  }()
};
exports.TextComponent = TextComponent;

},{"./text.jade":28,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382}],28:[function(require,module,exports){
module.exports = '<p class="text" ng-style="{{::$ctrl.style}}">{{::$ctrl.config.text}}</p>';
},{}],29:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardModule = void 0;
var _card = require("./card.component");
var _fragments = require("./fragments");
var CardModule = angular.module('maestro.components.blocks.cards', [_fragments.FragmentsModule]).component('card', _card.CardComponent).name;
exports.CardModule = CardModule;

},{"./card.component":12,"./fragments":22}],30:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionBtnBlockComponent = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
var ActionBtnBlockComponent = {
  template: require('./action-btn-block.jade'),
  bindings: {
    parentNavId: '<',
    config: '<'
  },
  controller: function () {
    ActionBtnBlockComponent.$inject = ["$q", "databaseService", "navFormService", "navService", "progressBarService", "$eventBus"];
    /* @ngInject */function ActionBtnBlockComponent($q, databaseService, navFormService, navService, progressBarService, $eventBus) {
      (0, _classCallCheck2.default)(this, ActionBtnBlockComponent);
      this.$q = $q;
      this.databaseService = databaseService;
      this.navFormService = navFormService;
      this.navService = navService;
      this.progressBarService = progressBarService;
      this.$eventBus = $eventBus;
      this.disaabled = true;
    }
    (0, _createClass2.default)(ActionBtnBlockComponent, [{
      key: "$onInit",
      value: function $onInit() {
        var _this = this;
        this.btnLabel = (0, _lodash.get)(this.config, 'data.content.title');
        this.loading = false;
        console.log('[ActionBtnBlockComponent] init', this.config);
        this.$eventBus.on('sheet:form-data-changed', function () {
          return _this.checkForm();
        });
      }
    }, {
      key: "checkForm",
      value: function checkForm() {
        var form = this.navFormService.get(this.parentNavId);
        var requiredFields = Object.keys(this.navFormService.getRequiredFields(this.parentNavId));
        var hasEmptyRequiredField = !(0, _lodash.isEmpty)(requiredFields) && this.allFieldsAreEmpty(form, requiredFields);
        var nonEmptyFieldsGroup = (0, _lodash.get)(this.config, 'data.non_empty_fields_group');
        var hasEmptyGroup = !(0, _lodash.isEmpty)(nonEmptyFieldsGroup) && this.allFieldsAreEmpty(form, nonEmptyFieldsGroup);
        this.disaabled = hasEmptyRequiredField || hasEmptyGroup;
      }
    }, {
      key: "allFieldsAreEmpty",
      value: function allFieldsAreEmpty(form, fields) {
        return (0, _lodash.every)(fields, function (key) {
          if (form[key] instanceof File) return false;
          if ((0, _typeof2.default)(form[key]) === 'object') {
            return (0, _lodash.every)(form[key], function (item) {
              return (0, _lodash.isEmpty)(item);
            });
          }
          return (0, _lodash.isEmpty)(form[key]);
        });
      }
    }, {
      key: "triggerBtnAction",
      value: function triggerBtnAction() {
        var _this2 = this;
        if (this.loading) return;
        var actions = (0, _lodash.get)(this.config, 'data.actions') || {};
        var actionsToExecute = [];
        (0, _lodash.each)(actions, function (action) {
          var params = action.params || {};
          if (action.action_key === 'send_data' && _this2.parentNavId) {
            (0, _lodash.extend)(params, _this2.navFormService.get(_this2.parentNavId));
          }
          actionsToExecute.push(_this2.databaseService.runAppScript(action.target, params));
        });
        this.loading = true;
        this.progressBarService.startTask();
        this.$q.all(actionsToExecute).finally(function () {
          _this2.loading = false;
          _this2.progressBarService.finishTask();
        });
      }
    }]);
    return ActionBtnBlockComponent;
  }()
};
exports.ActionBtnBlockComponent = ActionBtnBlockComponent;

},{"./action-btn-block.jade":31,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/helpers/typeof":396,"lodash":"lodash"}],31:[function(require,module,exports){
module.exports = '<div class="action-btn btn btn-default" ng-click="$ctrl.triggerBtnAction()" ng-disabled="$ctrl.disaabled || $ctrl.loading">{{$ctrl.btnLabel | i18n}}</div>';
},{}],32:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionBtnBlockModule = void 0;
var _actionBtnBlock = require("./action-btn-block.component");
var ActionBtnBlockModule = angular.module('maestro.components.blocks.action-btn', []).component('actionBtnBlock', _actionBtnBlock.ActionBtnBlockComponent).name;
exports.ActionBtnBlockModule = ActionBtnBlockModule;

},{"./action-btn-block.component":30}],33:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditTextBlockComponent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
var depsLoaded = false;
var EditTextBlockComponent = {
  template: require('./edit-text-block.jade'),
  bindings: {
    parentNavId: '<',
    config: '<',
    onSetValue: '&'
  },
  controller: function () {
    EditTextBlockComponent.$inject = ["$element", "$q", "$filter", "$timeout", "$eventBus", "navFormService", "databaseService"];
    /* @ngInject */function EditTextBlockComponent($element, $q, $filter, $timeout, $eventBus, navFormService, databaseService) {
      var _this = this;
      (0, _classCallCheck2.default)(this, EditTextBlockComponent);
      this.$q = $q;
      this.$timeout = $timeout;
      this.$eventBus = $eventBus;
      this.navFormService = navFormService;
      this.databaseService = databaseService;
      this.appResource = $filter('appResource');
      this.assetUrl = $filter('assetUrl');
      this.cache = {};
      this.$editor = $element.find('.editor');
      var updateValue = this.updateValue.bind(this);
      this.updateValue = (0, _lodash.throttle)(function () {
        return $timeout(function () {
          return updateValue();
        });
      }, 500);
      var getSuggestions = this.getSuggestions.bind(this);
      this.getSuggestions = (0, _lodash.throttle)(function (text) {
        return $timeout(function () {
          return getSuggestions(text);
        });
      }, 1000);
      this.ensureDependenciesAreLoaded().then(function () {
        return _this.initSuggestions();
      });
    }
    (0, _createClass2.default)(EditTextBlockComponent, [{
      key: "$onInit",
      value: function $onInit() {
        var _this2 = this;
        console.log('[EditTextBlockComponent] init', this.config);
        this.value = this.config.data.content.text || {};
        this.links = (0, _lodash.clone)(this.config.data.content.links || []);
        this.$editor.on('input change blur keyup paste', function () {
          return _this2.updateValue();
        });
        if (this.config.required) {
          this.navFormService.setRequiredField(this.parentNavId, this.config.input_key, true);
        }
      }
    }, {
      key: "$onDestroy",
      value: function $onDestroy() {
        if (this.$editor && this.$editor.atwho) {
          this.$editor.atwho('destroy');
          this.$editor.off('input change blur keyup paste');
        }
        this.navFormService.set(this.parentNavId, this.config.input_key, null);
      }
    }, {
      key: "updateValue",
      value: function updateValue() {
        this.navFormService.set(this.parentNavId, this.config.input_key, {
          text: this.extractTextFromEditor(),
          links: this.extractLinksFromEditor()
        });
      }
    }, {
      key: "initSuggestions",
      value: function initSuggestions() {
        var _this3 = this;
        this.$editor.atwho({
          at: '@',
          searchKey: 'text',
          displayTpl: function displayTpl(_ref) {
            var icon_url = _ref.icon_url,
              text = _ref.text;
            var iconUrl = _this3.assetUrl(icon_url);
            return "<li><img src=\"".concat(iconUrl, "\" class=\"icon\" onload=\"this.classList.add('loaded')\"/>").concat(text, "</li>");
          },
          insertTpl: function insertTpl(_ref2) {
            var text = _ref2.text,
              metadata = _ref2.metadata;
            var meta = encodeURIComponent(JSON.stringify(metadata));
            return "<span class=\"link mention\" link-metadata=\"".concat(meta, "\">@").concat(text, "</a>");
          },
          delay: 10,
          data: [],
          callbacks: {
            matcher: function matcher(flag, subtext) {
              var regexp = new RegExp(flag + '([^\\s@#]+(\\s+[^\\s@#]+){0,2})$', 'gi');
              var matched = regexp.exec(subtext.replace(/\s/g, ' '));
              return matched && matched.length ? matched[1] : null;
            },
            remoteFilter: function remoteFilter(text, cb) {
              return _this3.getSuggestions("@".concat(text)).then(cb);
            }
          }
        });
        this.$editor.atwho({
          at: '#',
          searchKey: 'text',
          displayTpl: function displayTpl(_ref3) {
            var text = _ref3.text;
            return "<li>".concat(text, "</li>");
          },
          insertTpl: function insertTpl(_ref4) {
            var text = _ref4.text,
              metadata = _ref4.metadata;
            var meta = encodeURIComponent(JSON.stringify(metadata));
            return "<span class=\"link hashtag\" link-metadata=\"".concat(meta, "\">#").concat(text, "</a>");
          },
          delay: 10,
          data: [],
          callbacks: {
            remoteFilter: function remoteFilter(text, cb) {
              _this3.getSuggestions("#".concat(text)).then(cb);
            }
          }
        });
      }
    }, {
      key: "getSuggestions",
      value: function getSuggestions(text) {
        var _this4 = this;
        if (!text || text.length < 2) return this.$q.when([]);
        var cache = this.cache[text];
        if (cache) {
          return this.$q.when(cache);
        }
        var actions = this.config.data.actions;
        var action = actions && actions.autocomplete;
        if (!action || !action.path) return this.$q.resolve([]);
        var params = (0, _lodash.extend)({}, action.params || {}, {
          text: text
        });
        return this.databaseService.runAppScript(action.path, params).then(function (_ref5) {
          var response = _ref5.data.response;
          _this4.cache[text] = response;
          return _this4.cache[text];
        });
      }
    }, {
      key: "extractTextFromEditor",
      value: function extractTextFromEditor() {
        return this.$editor.html().replace(/&amp;/g, '&').replace(/&nbsp;/g, ' ').replace(/&#160;/g, ' ').replace(/&#10;/g, '').replace(/<br(\s*)\/*>/gi, '\n').replace(/<[div>]+>/gi, '\n').replace(/<\/[div>]+>/gm, '').replace(/<\S[^><]*>/g, '').replace(/(\u00ad|\u200b|\u200c|\u200d)/g, '').trim();
      }
    }, {
      key: "extractLinksFromEditor",
      value: function extractLinksFromEditor() {
        var linkElements = this.$editor.find('.link');
        var fullText = this.extractTextFromEditor();
        var consumedTextLength = 0;
        var links = (0, _lodash.map)(linkElements, function (el) {
          var text = el.innerText.trim();
          var metadata = JSON.parse(decodeURIComponent(el.getAttribute('link-metadata')));
          var relativeIndex = fullText.indexOf(text);
          if (relativeIndex < 0) {
            return null;
          }
          var index = consumedTextLength + fullText.indexOf(text);
          fullText = fullText.slice(relativeIndex + text.length);
          consumedTextLength += relativeIndex + text.length;
          return {
            index: index,
            text: text,
            metadata: metadata
          };
        });
        return (0, _lodash.compact)(links);
      }
    }, {
      key: "ensureDependenciesAreLoaded",
      value: function ensureDependenciesAreLoaded() {
        if (depsLoaded) {
          this.autocompleteReady = true;
          return this.$q.when(true);
        }
        if (this.loadingDepsPromise) {
          return this.loadingDepsPromise;
        }
        var deferred = this.$q.defer();
        this.loadingDepsPromise = deferred.promise;
        console.log('[EditTextBlockComponent] loading caret.js and at.js');
        require('frontloader-common/lab').script([this.appResource('js/jquery.caret.js'), this.appResource('js/jquery.atwho.js')]).wait(function () {
          console.log('[EditTextBlockComponent] loaded caret.js and at.js');
          depsLoaded = true;
          deferred.resolve(true);
        });
        return this.loadingDepsPromise;
      }
    }]);
    return EditTextBlockComponent;
  }()
};
exports.EditTextBlockComponent = EditTextBlockComponent;

},{"./edit-text-block.jade":34,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"frontloader-common/lab":1110,"lodash":"lodash"}],34:[function(require,module,exports){
module.exports = '<div class="editor" contenteditable="true" placeholder="{{$ctrl.config.data.content.hint}}" autofocus="autofocus"></div>';
},{}],35:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditTextBlockModule = void 0;
var _editTextBlock = require("./edit-text-block.component");
var EditTextBlockModule = angular.module('maestro.components.blocks.edit-text', []).component('editTextBlock', _editTextBlock.EditTextBlockComponent).name;
exports.EditTextBlockModule = EditTextBlockModule;

},{"./edit-text-block.component":33}],36:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmptyStateComponent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
var _assets = require("../../../../utils/assets");
var _i18nWithFallback = _interopRequireDefault(require("../../../../utils/i18n-with-fallback"));
var EmptyStateComponent = {
  template: require('./empty-state.pug'),
  transclude: true,
  bindings: {
    config: '<',
    title: '<',
    subtitle: '<',
    imageUrl: '<'
  },
  controller: function () {
    EmptyStateComponent.$inject = ["THEME", "$i18n"];
    /* @ngInject */
    function EmptyStateComponent(THEME, $i18n) {
      (0, _classCallCheck2.default)(this, EmptyStateComponent);
      this.assetSuffix = THEME.get('appearance') === 'dark' ? 'dark' : 'light';
      this.$i18n = $i18n;
      this.IMAGES_MAP = {
        'nav_bookmarks': (0, _assets.getStaticAsset)("graphics/no-bookmarks-".concat(this.assetSuffix, ".png 2x")),
        'nav_business_cards': (0, _assets.getStaticAsset)("graphics/no-contacts-".concat(this.assetSuffix, ".png 2x")),
        'nav_chats': (0, _assets.getStaticAsset)("graphics/no-chats-".concat(this.assetSuffix, ".png 2x")),
        'nav_meetings': (0, _assets.getStaticAsset)("graphics/no-meetings-".concat(this.assetSuffix, ".png 2x")),
        'nav_messages_no_send': (0, _assets.getStaticAsset)("graphics/no-chats-".concat(this.assetSuffix, ".png 2x")),
        'nav_noteslist': (0, _assets.getStaticAsset)("graphics/no-notes-".concat(this.assetSuffix, ".png 2x")),
        'nav_notifications': (0, _assets.getStaticAsset)("graphics/no-notifications-".concat(this.assetSuffix, ".png 2x")),
        'nav_questionnaire': (0, _assets.getStaticAsset)("graphics/no-forms-".concat(this.assetSuffix, ".png 2x")),
        'nav_leads': (0, _assets.getStaticAsset)("graphics/no-leads-".concat(this.assetSuffix, ".png 2x")),
        'no-comments': (0, _assets.getStaticAsset)("graphics/no-posts-".concat(this.assetSuffix, ".png 2x")),
        'no-matches': (0, _assets.getStaticAsset)("graphics/no-matches-".concat(this.assetSuffix, ".png 2x"))
      };
    }
    (0, _createClass2.default)(EmptyStateComponent, [{
      key: "$onInit",
      value: function $onInit() {
        console.info('[EmptyState] init', this.config);
        var id = (0, _lodash.get)(this.config, '_id', (0, _lodash.get)(this.config, 'id'));
        if (this.config.data) {
          this.title = (0, _lodash.get)(this, 'config.data.content.title') || '';
          this.subtitle = (0, _lodash.get)(this, 'config.data.content.subtitle') || '';
          this.imageUrl = (0, _lodash.get)(this, 'config.data.content.image_url') || '';
        }
        this.imageUrl = this.IMAGES_MAP[id] || this.imageUrl || '';
        var noContent = this.config.no_content || this.config.nocontent;
        if (!(0, _lodash.isEmpty)(noContent)) {
          if (noContent.title_text) {
            this.title = this.$i18n(noContent.title_text);
          }
          if (noContent.subtitle_text) {
            this.subtitle = this.$i18n(noContent.subtitle_text);
          }
          if (noContent.is_activity) {
            this.imageUrl = (0, _assets.getStaticAsset)("graphics/no-activity-".concat(this.assetSuffix, ".png 2x"));
          }
        }
        if (id === 'nav_business_cards') {
          this.title = this.$i18n('nav_scan.bcx.nocontents.title');
          this.subtitle = this.$i18n('nav_scan.bcx.exchanged.instructions');
        }
        if ((0, _lodash.isEmpty)(this.title)) {
          this.title = (0, _i18nWithFallback.default)(this.$i18n, 'general.no_content', 'No content');
        }
        if (this.imageUrl.endsWith('2x')) {
          this.srcset = this.imageUrl;
          this.imageUrl = this.imageUrl.split(' 2x')[0];
        }
      }
    }, {
      key: "onImageError",
      value: function onImageError($event) {
        console.error('[EmptyState] Could not load image', $event.originalEvent);
        this.imageUrl = null;
      }
    }]);
    return EmptyStateComponent;
  }()
};
exports.EmptyStateComponent = EmptyStateComponent;

},{"../../../../utils/assets":350,"../../../../utils/i18n-with-fallback":359,"./empty-state.pug":37,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"lodash":"lodash"}],37:[function(require,module,exports){
module.exports = '<div class="empty-state"><img class="icon" ng-if="$ctrl.imageUrl" ng-src="{{::($ctrl.imageUrl | assetUrl)}}" alt="{{::$ctrl.title}}" ng-attr-srcset="{{::$ctrl.srcset}}" ng-on-error="$ctrl.onImageError($event)"/><div class="title" ng-if="::$ctrl.title">{{::$ctrl.title}}</div><div class="subtitle" ng-if="::$ctrl.subtitle">{{::$ctrl.subtitle}}</div><div class="actions" ng-transclude="ng-transclude"></div></div>';
},{}],38:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmptyStateModule = void 0;
var _emptyState = require("./empty-state.component");
var EmptyStateModule = angular.module('maestro.components.blocks.empty-state', []).component('emptyState', _emptyState.EmptyStateComponent).name;
exports.EmptyStateModule = EmptyStateModule;

},{"./empty-state.component":36}],39:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InlineBlockPaginatorModule = void 0;
var _inlineBlockPaginator = require("./inline-block-paginator.component");
var InlineBlockPaginatorModule = angular.module('maestro.components.common.inline-paginator', []).component('inlineBlockPaginator', _inlineBlockPaginator.InlineBlockPaginatorComponent).name;
exports.InlineBlockPaginatorModule = InlineBlockPaginatorModule;

},{"./inline-block-paginator.component":40}],40:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InlineBlockPaginatorComponent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
var _i18nWithFallback = _interopRequireDefault(require("../../../../utils/i18n-with-fallback"));
var InlineBlockPaginatorComponent = {
  template: require('./inline-block-paginator.jade'),
  bindings: {
    blocks: '<',
    previousPage: '<',
    previousPageAction: '<',
    prependBlocks: '&',
    removeBlock: '&',
    updateInlineBlock: '&',
    threadAction: '<'
  },
  controller: function () {
    InlineBlockPaginatorComponent.$inject = ["$i18n", "databaseService", "navService", "EventEmitter"];
    /* @ngInject */function InlineBlockPaginatorComponent($i18n, databaseService, navService, EventEmitter) {
      (0, _classCallCheck2.default)(this, InlineBlockPaginatorComponent);
      this.databaseService = databaseService;
      this.EventEmitter = EventEmitter;
      this.navService = navService;
      this.$i18n = $i18n;
      this.showThreadLabel = (0, _i18nWithFallback.default)($i18n, 'feed.show_this_thread', 'Show this thread');
    }
    (0, _createClass2.default)(InlineBlockPaginatorComponent, [{
      key: "$onInit",
      value: function $onInit() {
        console.log('[InlineBlockPaginatorComponent] init', this.blocks);
        var hasLabel = this.$i18n('feed.show_this_thread') !== 'feed.show_this_thread';
        this.showThreadAction = hasLabel && this.threadAction;
      }
    }, {
      key: "$onChanges",
      value: function $onChanges(changes) {
        if (changes.blocks) {
          this.blocks = (0, _lodash.extend)({}, this.blocks);
        }
      }
    }, {
      key: "getPageParams",
      value: function getPageParams(action, pageParam, getBlock) {
        if (!action || !action.path) {
          return null;
        }
        if (!this.blocks || !this.blocks.length) {
          return (action.params || {}).page || {};
        }
        var block = getBlock();
        return block && block.data.content[pageParam];
      }
    }, {
      key: "hasMoreContent",
      value: function hasMoreContent() {
        return this.hasPreviousPage();
      }
    }, {
      key: "previousPageParams",
      value: function previousPageParams() {
        return this.previousPageAction && this.previousPageAction.path && this.previousPage;
      }
    }, {
      key: "hasPreviousPage",
      value: function hasPreviousPage() {
        return !!this.previousPageParams();
      }
    }, {
      key: "loadPage",
      value: function loadPage(action, pageParams) {
        var params = (0, _lodash.extend)({}, action.params, {
          page: pageParams
        });
        return this.databaseService.runAppScript(action.path || action.target, params).then(function (_ref) {
          var response = _ref.data.response;
          return response;
        });
      }
    }, {
      key: "loadPreviousPage",
      value: function loadPreviousPage() {
        var _this = this;
        var pageParams = this.previousPageParams();
        if (!pageParams) return;
        this.loadingPreviousPage = true;
        this.loadPage(this.previousPageAction, pageParams).then(function (blocks) {
          return _this.prependBlocks(_this.EventEmitter({
            blocks: blocks
          }));
        }).finally(function () {
          _this.clicked = true;
          _this.loadingPreviousPage = false;
        });
      }
    }, {
      key: "performBlockAction",
      value: function performBlockAction() {
        if (this.threadAction) {
          this.navService.runScript(this.threadAction);
        }
      }
    }]);
    return InlineBlockPaginatorComponent;
  }()
};
exports.InlineBlockPaginatorComponent = InlineBlockPaginatorComponent;

},{"../../../../utils/i18n-with-fallback":359,"./inline-block-paginator.jade":41,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"lodash":"lodash"}],41:[function(require,module,exports){
module.exports = '<div class="btn btn-default load-previous" ng-show="$ctrl.hasPreviousPage() &amp;&amp; !$ctrl.clicked" ng-click="$ctrl.loadPreviousPage()"><i class="icon-loader" ng-show="$ctrl.loadingPreviousPage"></i><span ng-hide="$ctrl.loadingPreviousPage" ng-bind="::$ctrl.previousPageAction.label"></span></div><feed-reply-block ng-repeat="block in $ctrl.blocks track by block.id" ng-class="{first: $first, last: $last}" config="block" on-remove="$ctrl.removeBlock($event)" on-update="$ctrl.updateInlineBlock($event)"></feed-reply-block><div class="thread-actions" ng-if="$ctrl.showThreadAction"><a ng-click="$ctrl.performBlockAction()" ng-bind="::$ctrl.showThreadLabel"></a></div>';
},{}],42:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListBannerModule = void 0;
var _listBanner = require("./list-banner.component");
var ListBannerModule = angular.module('maestro.components.blocks.list-banner', []).component('listBanner', _listBanner.ListBannerComponent).name;
exports.ListBannerModule = ListBannerModule;

},{"./list-banner.component":43}],43:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListBannerComponent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var ListBannerComponent = {
  template: require('./list-banner.jade'),
  bindings: {
    image: '<'
  },
  controller: function () {
    function ListBannerComponent() {
      (0, _classCallCheck2.default)(this, ListBannerComponent);
    }
    (0, _createClass2.default)(ListBannerComponent, [{
      key: "$onInit",
      value: function $onInit() {
        var cfg = this.image;
        console.info('[ListBannerComponent] init', cfg);
      }
    }]);
    return ListBannerComponent;
  }()
};
exports.ListBannerComponent = ListBannerComponent;

},{"./list-banner.jade":44,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382}],44:[function(require,module,exports){
module.exports = '<div class="image-banner panel panel-default" ng-if="::$ctrl.image.image_url"><div class="image-container"><img ng-src="{{::$ctrl.image.image_url | assetUrl}}" alt="banner"/></div></div>';
},{}],45:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListHeaderModule = void 0;
var _listHeader = require("./list-header.component");
var ListHeaderModule = angular.module('maestro.components.blocks.list-header', []).component('listHeader', _listHeader.ListHeaderComponent).name;
exports.ListHeaderModule = ListHeaderModule;

},{"./list-header.component":46}],46:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListHeaderComponent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var ListHeaderComponent = {
  template: require('./list-header.jade'),
  bindings: {
    config: '<'
  },
  controller: function () {
    function ListHeaderComponent() {
      (0, _classCallCheck2.default)(this, ListHeaderComponent);
    }
    (0, _createClass2.default)(ListHeaderComponent, [{
      key: "$onInit",
      value: function $onInit() {
        var cfg = this.config;
        console.info('[ListHeader] init', cfg);
        if (cfg.data) {
          this.title = cfg.data.content.title;
        }
      }
    }]);
    return ListHeaderComponent;
  }()
};
exports.ListHeaderComponent = ListHeaderComponent;

},{"./list-header.jade":47,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382}],47:[function(require,module,exports){
module.exports = '<div class="list-header" theme="::$ctrl.theme"><h4>{{::$ctrl.title}}</h4></div>';
},{}],48:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectBlockModule = void 0;
var _selectBlock = require("./select-block.component");
var SelectBlockModule = angular.module('maestro.components.blocks.select', []).component('selectBlock', _selectBlock.SelectBlockComponent).name;
exports.SelectBlockModule = SelectBlockModule;

},{"./select-block.component":49}],49:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectBlockComponent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
var SelectBlockComponent = {
  template: require('./select-block.pug'),
  bindings: {
    parentNavId: '<',
    config: '<'
  },
  controller: function () {
    SelectBlockComponent.$inject = ["navService", "navFormService", "$sheet", "$eventBus"];
    /* @ngInject */function SelectBlockComponent(navService, navFormService, $sheet, $eventBus) {
      (0, _classCallCheck2.default)(this, SelectBlockComponent);
      this.navService = navService;
      this.navFormService = navFormService;
      this.$sheet = $sheet;
      this.$eventBus = $eventBus;
    }
    (0, _createClass2.default)(SelectBlockComponent, [{
      key: "$onInit",
      value: function $onInit() {
        var _this = this;
        console.log('[SelectBlockComponent] init', this.config);
        this.pristine = (0, _lodash.get)(this.config, 'data.theme.pristine') === false ? false : true;
        this.showRequiredText = this.config.required;
        this.selectorText = this.config.data.content.placeholder;
        this.requiredText = (0, _lodash.get)(this.config, 'data.content.required_text') || 'This field is required';
        this.items = (0, _lodash.get)(this, 'config.data.content.items') || [];
        this.visible = this.items.length > 1;
        this.actions = (0, _lodash.map)(this.items, function (i) {
          return {
            id: i.id,
            label: i.title,
            params: {
              id: i.id
            },
            action: function action(_ref) {
              var _action = _ref.action;
              return _this.selectItem(_action);
            }
          };
        });
        if (this.items.length === 1) {
          this.selectItem(this.items[0]);
        }
        if (this.config.required) {
          this.navFormService.setRequiredField(this.parentNavId, this.config.input_key, true);
        }
      }
    }, {
      key: "selectItem",
      value: function selectItem(item) {
        console.info('[SelectBlockComponent] Element selected', item);
        this.pristine = false;
        this.selectorText = item.label;
        this.showRequiredText = false;
        this.navFormService.set(this.parentNavId, this.config.input_key, item.id);
      }
    }, {
      key: "showFeedsList",
      value: function showFeedsList($event) {
        this.$sheet({
          menu: true,
          positionMenuAround: $event.currentTarget,
          title: this.config.data.content.placeholder,
          actions: this.actions,
          anchor: 'bottom left',
          vOffset: 6
        });
      }
    }]);
    return SelectBlockComponent;
  }()
};
exports.SelectBlockComponent = SelectBlockComponent;

},{"./select-block.pug":50,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"lodash":"lodash"}],50:[function(require,module,exports){
module.exports = '<div class="select-block-panel" ng-class="{hidden: !$ctrl.visible}"><div class="panel panel-default select-block"><div class="selector" ng-click="$ctrl.showFeedsList($event)" ng-class="{pristine: $ctrl.pristine}"><i class="icon-chevron-down"></i><span class="text">{{$ctrl.selectorText | i18n}}</span></div></div><div class="required-text" ng-if="$ctrl.showRequiredText">{{$ctrl.requiredText | i18n}}</div></div>';
},{}],51:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleBlockModule = void 0;
var _toggleBlock = require("./toggle-block.component");
var ToggleBlockModule = angular.module('maestro.components.blocks.toggle', []).component('toggleBlock', _toggleBlock.ToggleBlockComponent).name;
exports.ToggleBlockModule = ToggleBlockModule;

},{"./toggle-block.component":52}],52:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleBlockComponent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
var ToggleBlockComponent = {
  template: require('./toggle-block.jade'),
  bindings: {
    parentNavId: '<',
    config: '<'
  },
  controller: function () {
    ToggleBlockComponent.$inject = ["$q", "databaseService", "progressBarService"];
    /* @ngInject */function ToggleBlockComponent($q, databaseService, progressBarService) {
      (0, _classCallCheck2.default)(this, ToggleBlockComponent);
      this.$q = $q;
      this.databaseService = databaseService;
      this.progressBarService = progressBarService;
      this.disabled = true;
    }
    (0, _createClass2.default)(ToggleBlockComponent, [{
      key: "$onInit",
      value: function $onInit() {
        this.content = (0, _lodash.get)(this.config, 'data.content');
        this.disabled = !(0, _lodash.get)(this.config, 'data.content.enabled');
        this.selected = this.content.selected;
        this.loading = false;
        console.log('[ToggleBlockComponent] init', this.config);
      }
    }, {
      key: "triggerAction",
      value: function triggerAction() {
        var _this = this;
        if (this.disabled || this.loading) return;
        this.selected = !this.selected;
        var actions = (0, _lodash.get)(this.config, 'data.actions') || {};
        var actionsToExecute = [];
        (0, _lodash.each)(actions, function (action) {
          var params = action.params || {};
          var path = action.path || action.target;
          actionsToExecute.push(_this.databaseService.runAppScript(path, params));
        });
        this.loading = true;
        this.progressBarService.startTask();
        this.$q.all(actionsToExecute).finally(function () {
          _this.loading = false;
          _this.progressBarService.finishTask();
        });
      }
    }]);
    return ToggleBlockComponent;
  }()
};
exports.ToggleBlockComponent = ToggleBlockComponent;

},{"./toggle-block.jade":53,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"lodash":"lodash"}],53:[function(require,module,exports){
module.exports = '<div class="toggler-block" ng-click="$ctrl.triggerAction()"><label class="toggler" ng-class="{\'disabled\': $ctrl.disabled || $ctrl.loading}"><span ng-class="{\'switch-on\': $ctrl.selected}"><input type="checkbox" name="name" ng-checked="$ctrl.content.selected"/><span class="switch"></span></span><div class="label"><div ng-class="{\'no-subtitle\': !$ctrl.content.subtitle}">{{$ctrl.content.title}}</div><div class="subtitle" ng-if="$ctrl.content.subtitle">{{$ctrl.content.subtitle}}</div></div></label></div>';
},{}],54:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UploadBlockModule = void 0;
var _uploadBlock = require("./upload-block.component");
var _onFileChange = require("./on-file-change.directive");
var UploadBlockModule = angular.module('maestro.components.blocks.upload', []).component('uploadBlock', _uploadBlock.UploadBlockComponent).directive('onFileChange', _onFileChange.OnFileChangeDirective).name;
exports.UploadBlockModule = UploadBlockModule;

},{"./on-file-change.directive":55,"./upload-block.component":56}],55:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OnFileChangeDirective = void 0;
var OnFileChangeDirective = ['EventEmitter', function (EventEmitter) {
  return {
    restrict: 'A',
    scope: {
      onFileChange: '&'
    },
    link: function link(scope, elem) {
      elem.on('change', function () {
        return scope.onFileChange(EventEmitter({
          file: elem[0].files[0]
        }));
      });
      scope.$on('$destroy', function () {
        return elem.off('change');
      });
    }
  };
}];
exports.OnFileChangeDirective = OnFileChangeDirective;

},{}],56:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UploadBlockComponent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
var _i18nWithFallback = _interopRequireDefault(require("../../../../utils/i18n-with-fallback"));
var MIN_VIDEO_DURATION = 3;
var MAX_VIDEO_DURATION = 60;
var MAX_WIDTH = 1200;
var MAX_HEIGHT = 1200;
var ACCEPTED_VIDEO_MIME = ['video/mp4'];
var UploadBlockComponent = {
  template: require('./upload-block.jade'),
  bindings: {
    parentNavId: '<',
    config: '<',
    accept: '<',
    maxSize: '<'
  },
  controller: function () {
    UploadBlockComponent.$inject = ["$timeout", "navFormService", "$element", "$sheet", "$i18n", "$eventBus"];
    /* @ngInject */
    function UploadBlockComponent($timeout, navFormService, $element, $sheet, $i18n, $eventBus) {
      (0, _classCallCheck2.default)(this, UploadBlockComponent);
      this.$timeout = $timeout;
      this.navFormService = navFormService;
      this.el = $element;
      this.$sheet = $sheet;
      this.$i18n = $i18n;
      this.$eventBus = $eventBus;
    }
    (0, _createClass2.default)(UploadBlockComponent, [{
      key: "$onInit",
      value: function $onInit() {
        var _this = this;
        this.enabled = 'FileReader' in window;
        if (!this.enabled) return;
        this.btnLabel = (0, _i18nWithFallback.default)(this.$i18n, 'feed.photo_upload_btn_label', 'Photo/Video');
        this.accept = this.accept ? this.accept.split(',') : null;
        this.maxVideoDuration = (0, _lodash.get)(this.config, 'data.content.video_max_length') || MAX_VIDEO_DURATION;
        this.setFormValue = function (value) {
          return _this.navFormService.set(_this.parentNavId, _this.config.input_key, value);
        };
        this.setFormMetaValue = function (value) {
          return _this.navFormService.set(_this.parentNavId, "_".concat(_this.config.input_key, "_meta"), value);
        };
        this.setFormThumbnailValue = function (value) {
          return _this.navFormService.set(_this.parentNavId, _this.config.thumbnail_key, value);
        };
        this.setFormThumbnailMetadata = function (value) {
          return _this.navFormService.set(_this.parentNavId, "_".concat(_this.config.thumbnail_key, "_meta"), value);
        };
        console.info('[UploadBlockComponent] init', this.config);
        this.preSelectedFile = this.navFormService.getPreSelectedFile();
        if (this.preSelectedFile[this.config.input_key]) {
          this.fileSelected({
            file: this.preSelectedFile[this.config.input_key]
          });
          this.navFormService.setPreSelectedFile(this.config.input_key, null);
          this.preSelectedFile = {};
        }
      }
    }, {
      key: "$onDestroy",
      value: function $onDestroy() {
        this.setFormValue(null);
        this.setFormMetaValue(null);
        this.setFormThumbnailValue(null);
        this.setFormThumbnailMetadata(null);
      }
    }, {
      key: "fileSelected",
      value: function fileSelected(_ref) {
        var _this2 = this;
        var file = _ref.file;
        this.errors = {};
        if (!file) {
          this.removeFile();
          return;
        }
        var mimeType = file.type;
        if (this.accept && (!mimeType || this.accept.indexOf(mimeType) === -1)) {
          this.$timeout(function () {
            return _this2.errors.type = true;
          });
          this.removeFile();
          return;
        }
        var maxLength = (0, _lodash.get)(this.config, 'data.content.video_max_length');
        var isVideo = ACCEPTED_VIDEO_MIME.includes(mimeType);
        if (!isVideo || isVideo && !maxLength) {
          var size = file.size;
          if (this.maxSize && size > this.maxSize) {
            this.$timeout(this.errors.size = true);
            this.removeFile();
            return;
          }
        }
        var reader = new FileReader(file);
        reader.onload = function (_ref2) {
          var result = _ref2.target.result;
          return _this2.$timeout(function () {
            var urlCreator = window.URL || window.webkitURL;
            var br = new Blob([result], {
              type: file.type
            });
            var imageUrl = urlCreator.createObjectURL(br);
            _this2.getMediaMetadata(file, imageUrl);
          });
        };
        reader.onerror = function () {
          return _this2.$timeout(function () {
            return _this2.removeFile();
          });
        };
        reader.readAsArrayBuffer(file);
        this.setFormValue(file);
        if (!this.preSelectedFile[this.config.input_key]) {
          this.$eventBus.emit('upload-block:file-selected', true);
        }
      }
    }, {
      key: "getMediaMetadata",
      value: function getMediaMetadata(file, data) {
        var mimeType = file.type;
        if (mimeType) {
          if (mimeType.indexOf('image/') === 0) {
            this.downSizeLargeImages(file, data);
          }
          if (mimeType.indexOf('video/') === 0) {
            this.getVideoMetadata(mimeType, data);
          }
        }
      }
    }, {
      key: "getVideoMetadata",
      value: function getVideoMetadata(mimeType, data) {
        var _this3 = this;
        var v = document.createElement('video');
        v.src = data;
        v.autoplay = true;
        v.preload = 'metadata';
        v.setAttribute('playsinline', true);
        v.style.display = 'none';
        v.addEventListener('loadeddata', function () {
          v.pause();
          if (v.duration > _this3.maxVideoDuration) {
            _this3.removeFile();
            return _this3.showErrorPopup("The maximum video duration allowed is ".concat(_this3.maxVideoDuration, "s."));
          }
          if (v.duration < MIN_VIDEO_DURATION) {
            _this3.removeFile();
            return _this3.showErrorPopup("The minimum video duration allowed is ".concat(MIN_VIDEO_DURATION, "s."));
          }
          var canvas = document.createElement('canvas');
          canvas.width = v.videoWidth;
          canvas.height = v.videoHeight;
          canvas.getContext('2d').drawImage(v, 0, 0, v.videoWidth, v.videoHeight);
          _this3.filePreview = canvas.toDataURL('image/jpeg');
          _this3.$timeout(function () {
            _this3.setFormMetaValue({
              contentType: mimeType,
              size: {
                width: v.videoWidth,
                height: v.videoHeight
              }
            });
            canvas.toBlob(function (blob) {
              var f = new File([blob], 'poster.jpg', {
                type: blob.type
              });
              _this3.setFormThumbnailValue(f);
            }, 'image/jpeg', 0.95);
            _this3.setFormThumbnailMetadata({
              contentType: 'image/jpeg',
              size: {
                width: v.videoWidth,
                height: v.videoHeight
              }
            });
            canvas = null;
            v = null;
          });
        });
      }
    }, {
      key: "downSizeLargeImages",
      value: function downSizeLargeImages(file, data) {
        var _this4 = this;
        this.setFormThumbnailValue(null);
        this.setFormThumbnailMetadata(null);
        var img = new Image();
        img.onload = function () {
          var canvas = document.createElement('canvas');
          var ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);
          var width = img.width;
          var height = img.height;
          if (width > height) {
            if (width > MAX_WIDTH) {
              height *= MAX_WIDTH / width;
              width = MAX_WIDTH;
            }
          } else {
            if (height > MAX_HEIGHT) {
              width *= MAX_HEIGHT / height;
              height = MAX_HEIGHT;
            }
          }
          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0, width, height);
          _this4.setFormMetaValue({
            contentType: file.type,
            size: {
              image_width: width,
              image_height: height
            }
          });
          canvas.toBlob(function (blob) {
            var f = new File([blob], file.name, {
              type: blob.type
            });
            _this4.$timeout(function () {
              var urlCreator = window.URL || window.webkitURL;
              var imageUrl = urlCreator.createObjectURL(f);
              _this4.filePreview = imageUrl;
              _this4.setFormValue(f);
            });
          }, file.type, 0.6);
        };
        img.src = data;
      }
    }, {
      key: "removeFile",
      value: function removeFile() {
        this.filePreview = null;
        this.el.find('input.file-input').val('');
        this.setFormValue(null);
        this.setFormMetaValue(null);
        this.setFormThumbnailValue(null);
        this.setFormThumbnailMetadata(null);
      }
    }, {
      key: "showErrorPopup",
      value: function showErrorPopup(message) {
        this.$sheet({
          title: this.$i18n('general.error'),
          message: message,
          pin: false,
          scrollable: false,
          prompt: true,
          actions: [{
            id: 'close',
            label: this.$i18n('general.close'),
            action: function action(sheet) {
              return sheet.reject();
            }
          }]
        });
      }
    }]);
    return UploadBlockComponent;
  }()
};
exports.UploadBlockComponent = UploadBlockComponent;

},{"../../../../utils/i18n-with-fallback":359,"./upload-block.jade":57,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"lodash":"lodash"}],57:[function(require,module,exports){
module.exports = '<div ng-if="::$ctrl.enabled"><p class="text-danger" ng-if="$ctrl.errors.type">{{::"upload.upload_type" | i18n}}</p><p class="text-danger" ng-if="$ctrl.errors.size">{{::"upload.upload_size" | i18n}}</p><div class="upload-control"><label class="btn btn-default btn-transparent"><div class="btn-content"><i class="icon-image"></i><span class="btn-label">{{::$ctrl.btnLabel | i18n}}</span></div><input class="file-input" type="file" on-file-change="$ctrl.fileSelected($event)" accept="{{$ctrl.accept.join(&quot;,&quot;)}}"/></label></div><div class="upload-preview" ng-if="$ctrl.filePreview"><div class="media"><div class="btn btn-default btn-transparent remove" ng-click="$ctrl.removeFile()"><i class="icon-circle-with-cross"></i></div><img class="animated fadeIn" ng-src="{{$ctrl.filePreview}}" prevent-context-menu="prevent-context-menu"/></div></div></div>';
},{}],58:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeedCommentBlockComponent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _lodash = require("lodash");
var _commonFeedBlock = require("../common-feed-block");
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = (0, _getPrototypeOf2.default)(t); if (r) { var s = (0, _getPrototypeOf2.default)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0, _possibleConstructorReturn2.default)(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var FeedCommentBlockComponent = {
  template: require('./feed-comment-block.jade'),
  bindings: {
    config: '<',
    onUpdate: '&'
  },
  controller: function (_CommonFeedBlock) {
    FeedCommentBlockComponent.$inject = ["NAV_TEMPLATE_API_PREFIX", "$timeout", "databaseService", "navService", "$filter", "$sheet", "$i18n", "EventEmitter", "THEME"];
    (0, _inherits2.default)(FeedCommentBlockComponent, _CommonFeedBlock);
    var _super = _createSuper(FeedCommentBlockComponent);
    /* @ngInject */function FeedCommentBlockComponent(NAV_TEMPLATE_API_PREFIX, $timeout, databaseService, navService, $filter, $sheet, $i18n, EventEmitter, THEME) {
      var _this;
      (0, _classCallCheck2.default)(this, FeedCommentBlockComponent);
      _this = _super.call(this, NAV_TEMPLATE_API_PREFIX, $filter, $sheet, $i18n, THEME);
      _this.$timeout = $timeout;
      _this.databaseService = databaseService;
      _this.navService = navService;
      _this.runScript = navService.runScript.bind(navService);
      _this.EventEmitter = EventEmitter;
      return _this;
    }
    (0, _createClass2.default)(FeedCommentBlockComponent, [{
      key: "$onInit",
      value: function $onInit() {
        var _this2 = this;
        (0, _get2.default)((0, _getPrototypeOf2.default)(FeedCommentBlockComponent.prototype), "$onInit", this).call(this);
        var menu = (0, _lodash.get)(this, 'config.data.actions.contextual_menu');
        var content = (0, _lodash.get)(this, 'config.data.content');
        if (menu) {
          this.showContextualMenu = this.navService.showNavToolbarMenu((0, _lodash.map)(menu.actions, function (action) {
            action.action = function () {
              _this2.runScript(action);
            };
            return action;
          }));
        }
        if (!content) {
          return;
        }
        this.authorAction = function () {
          return _this2.runScript(_this2.actions.profile);
        };
        if (content.feed) {
          this.titleAction = this.authorAction;
          this.authorAction = null;
          this.feedAction = function () {
            return _this2.runScript(_this2.actions.feed);
          };
          this.feedMeta = content.feed;
        }
      }
    }, {
      key: "$onChanges",
      value: function $onChanges(changes) {
        (0, _get2.default)((0, _getPrototypeOf2.default)(FeedCommentBlockComponent.prototype), "$onChanges", this).call(this, changes);
        if (!changes.config) return;
        var data = this.content;
        this.author = {
          photo: data.avatar_url,
          title: data.title,
          subtitle: (0, _lodash.compact)([data.company, data.position]).join(' • ')
        };
        if ((0, _lodash.get)(this, 'config.data.actions.contextual_menu')) {
          this.author.subtitle = (0, _lodash.get)(this, 'config.data.content.time') || this.author.subtitle;
        }
      }
    }, {
      key: "triggerAction",
      value: function triggerAction(button) {
        var _this3 = this;
        if (!button.disabled && button.action.target) {
          this.runScript(button.action).then(function (_ref) {
            var data = _ref.data;
            if (data.status !== 'ok') return;
            var modPaths = _this3.config.data.actions.moderator_actions.map(function (a) {
              return a.action.path;
            });
            if (modPaths.some(function (path) {
              return path === button.action.path;
            })) {
              _this3.config.data.actions.moderator_actions = data.response;
            }
          });
        }
      }
    }]);
    return FeedCommentBlockComponent;
  }(_commonFeedBlock.CommonFeedBlock)
};
exports.FeedCommentBlockComponent = FeedCommentBlockComponent;

},{"../common-feed-block":62,"./feed-comment-block.jade":59,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/get":379,"@babel/runtime/helpers/getPrototypeOf":380,"@babel/runtime/helpers/inherits":381,"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/helpers/possibleConstructorReturn":387,"lodash":"lodash"}],59:[function(require,module,exports){
module.exports = '<div class="panel panel-default"><div class="posted-at nav-list-item-subsubtitle pull-right" ng-bind="::$ctrl.content.time" ng-if="::!$ctrl.actions.contextual_menu"></div><button class="btn btn-transparent ctx-button pull-right" ng-if="$ctrl.actions.contextual_menu" ng-click="$ctrl.showContextualMenu($event)"><img class="icon" ng-src="{{$ctrl.actions.contextual_menu.icon_url | assetUrl}}" ng-show="$ctrl.actions.contextual_menu.icon_url"/><i class="icon-dots-three-horizontal" ng-show="!$ctrl.actions.contextual_menu.icon_url"></i></button><div class="extras" ng-if="$ctrl.content.supplementary_text &amp;&amp; $ctrl.actions.toolbar_actions" ng-click="$ctrl.runScript($ctrl.actions.supplementary)"><img class="icon" ng-src="{{::$ctrl.content.supplementary_icon_url | assetUrl}}" ng-show="$ctrl.content.supplementary_icon_url"/><small>{{$ctrl.content.supplementary_text}}</small></div><div class="panel-author" ng-if="::$ctrl.author"><div class="media no-click-effect" ng-click="$ctrl.authorAction()"><div class="media-left"><div class="media-object"><avatar object="$ctrl.author" mode="small"></avatar></div></div><div class="media-body"><div class="nav-list-item-title" ng-if="!$ctrl.feedMeta" ng-bind="$ctrl.author.title"></div><div class="nav-list-item-title" ng-if="$ctrl.feedMeta"><span ng-bind="$ctrl.author.title" ng-click="$ctrl.titleAction()"></span><span class="preposition">&nbsp;{{$ctrl.feedMeta.preposition}}&nbsp;</span><span ng-bind="$ctrl.feedMeta.name" ng-click="$ctrl.feedAction()"></span></div><div class="nav-list-item-subtitle" ng-show="::$ctrl.author.subtitle" ng-bind="::$ctrl.author.subtitle"></div></div></div></div><div class="panel-body" ng-if="::$ctrl.content.message" ng-bind-html="::($ctrl.content.message | postLinks:$ctrl.content.links:$ctrl.actions.links)"></div><div class="panel-media" ng-if="::($ctrl.content.image_url || $ctrl.content.video_url)"><video-player ng-if="::$ctrl.content.video_url" media="::$ctrl.media" autoplay="false" config="{ fp_type: \'video\', document_id: $ctrl.content.video_id, configOverrides: $ctrl.content.config_overrides }" use-metadata="true"></video-player><div class="img" ng-if="::$ctrl.content.image_url" lazy-background-asset-src="{{::$ctrl.content.image_url | assetUrl}}" data-max-ratio="75" ng-click="$ctrl.zoomMedia($ctrl.content.image_url)"></div></div><feed-post-attachments ng-if="::$ctrl.content.attachments.length" attachments="::$ctrl.content.attachments"></feed-post-attachments><div class="panel-footer post-actions" ng-if="::(!$ctrl.actions.toolbar_actions &amp;&amp; ($ctrl.actions.footer_right.length || $ctrl.actions.footer_left.length))"><div class="pull-right" ng-if="::$ctrl.actions.footer_right.length"><footer-buttons buttons="$ctrl.actions.footer_right"></footer-buttons></div><div ng-if="::$ctrl.actions.footer_left.length"><footer-buttons buttons="$ctrl.actions.footer_left"></footer-buttons></div><div class="extras" ng-if="::$ctrl.content.supplementary_text" ng-click="$ctrl.runScript($ctrl.actions.supplementary)"><small>{{::$ctrl.content.supplementary_text}}</small></div></div><div class="panel-footer toolbar-actions" ng-if="::($ctrl.actions.toolbar_actions)"><div class="footer-post-actions-block"><a ng-repeat="button in $ctrl.actions.toolbar_actions.footer_block" data-cue="action-{{::button.action.target}}" ng-click="$ctrl.triggerAction(button)"><i class="icon" icon="button.icon_url" ng-if="button.icon_url"></i><span ng-bind="button.label"></span></a></div><div class="actions"><div class="action" ng-repeat="button in $ctrl.actions.toolbar_actions.footer_left" data-cue="action-{{::button.action.target}}" ng-click="$ctrl.triggerAction(button)"><div><i class="icon" icon="button.icon_url" ng-show="button.icon_url" force-color="$ctrl.config.data.theme.icon_color"></i><span ng-if="button.label" ng-bind="button.label"></span></div></div></div></div><div class="moderator-actions" ng-if="::($ctrl.actions.moderator_actions &amp;&amp; $ctrl.actions.moderator_actions.length)"><div class="action" ng-repeat="button in $ctrl.actions.moderator_actions" data-cue="action-{{::button.action.target}}" ng-click="$ctrl.triggerAction(button)" ng-class="{ &quot;disabled&quot;: button.disabled, &quot;selected&quot;: button.selected }"><div ng-hide="button.loading"><i class="icon" icon="button.icon_url" ng-show="button.icon_url" force-color="$ctrl.config.data.theme.icon_color"></i><span ng-if="button.label" ng-bind="button.label"></span></div></div></div><inline-block-paginator class="panel-footer" ng-if="$ctrl.inlineBlocks.length || $ctrl.actions.load_previous" blocks="$ctrl.inlineBlocks" prepend-blocks="$ctrl.prependBlocks($event)" previous-page-action="$ctrl.actions.load_previous" thread-action="$ctrl.actions.block" previous-page="$ctrl.content.previous_page" update-inline-block="$ctrl.updateInlineBlock($event)"></inline-block-paginator></div>';
},{}],60:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeedCommentBlockModule = void 0;
var _feedCommentBlock = require("./feed-comment-block.component");
var FeedCommentBlockModule = angular.module('maestro.components.blocks.feed-comment', []).component('feedCommentBlock', _feedCommentBlock.FeedCommentBlockComponent).name;
exports.FeedCommentBlockModule = FeedCommentBlockModule;

},{"./feed-comment-block.component":58}],61:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CommonFeedBlockNotificationHandlers = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
var CommonFeedBlockNotificationHandlers = function () {
  CommonFeedBlockNotificationHandlers.$inject = ["THEME"];
  /* @ngInject */
  function CommonFeedBlockNotificationHandlers(THEME) {
    (0, _classCallCheck2.default)(this, CommonFeedBlockNotificationHandlers);
    this.THEME = THEME;
  }
  (0, _createClass2.default)(CommonFeedBlockNotificationHandlers, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var config = this.config;
      var notificationsToSubscribeTo = config.reload_on && config.reload_on.notifications;
      if (!notificationsToSubscribeTo || !notificationsToSubscribeTo.length) {
        return;
      }
      this.notificationSubscriptions = [];
      var specialHandlers = {
        'blocks:insert': this.onBlocksInsertNotification.bind(this),
        'blocks:remove': this.onBlocksRemoveNotification.bind(this),
        'blocks:update': this.onBlocksUpdateNotification.bind(this)
      };
      (0, _lodash.each)(specialHandlers, function (handler, name) {
        if (notificationsToSubscribeTo.indexOf(name) !== -1) {
          _this.notificationSubscriptions.push(_this.navService.on(name, handler));
        }
      });
      if ((0, _lodash.get)(this, 'config.data.theme') && this.THEME.version !== 3) {
        this.topic_theme = {
          background_color: this.config.data.theme.background_color_topic,
          text_color: this.config.data.theme.text_color_topic
        };
      }
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      var subs = this.notificationSubscriptions;
      if (subs && subs.length) {
        (0, _lodash.each)(subs, function (unsub) {
          return unsub();
        });
      }
    }
  }, {
    key: "onBlocksInsertNotification",
    value: function onBlocksInsertNotification(_ref) {
      var target = _ref.target,
        block = _ref.block;
      if (this.config.id !== target || !this.inlineBlocks) return;
      console.log('[CommonFeedBlockNotificationHandlers] insert', target, block);
      this.onUpdate(this.EventEmitter({
        id: this.config.id,
        updates: {
          content: {
            inline_blocks: (0, _lodash.uniq)(this.inlineBlocks.concat([block]), function (_ref2) {
              var id = _ref2.id;
              return id;
            })
          }
        }
      }));
    }
  }, {
    key: "onBlocksRemoveNotification",
    value: function onBlocksRemoveNotification(_ref3) {
      var target = _ref3.target;
      var n = this.inlineBlocks.length;
      var filtered = (0, _lodash.filter)(this.inlineBlocks, function (_ref4) {
        var id = _ref4.id;
        return id !== target;
      });
      if (n !== filtered.length) {
        console.log('[CommonFeedBlockNotificationHandlers] remove', target);
        this.onUpdate(this.EventEmitter({
          id: this.config.id,
          updates: {
            content: {
              inline_blocks: filtered
            }
          }
        }));
      }
    }
  }, {
    key: "onBlocksUpdateNotification",
    value: function onBlocksUpdateNotification(_ref5) {
      var target = _ref5.target,
        updates = _ref5.updates;
      if (this.config.id !== target) return;
      console.log('[CommonFeedBlockNotificationHandlers] update', target, updates);
      this.onUpdate(this.EventEmitter({
        id: target,
        updates: updates
      }));
    }
  }]);
  return CommonFeedBlockNotificationHandlers;
}();
exports.CommonFeedBlockNotificationHandlers = CommonFeedBlockNotificationHandlers;

},{"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"lodash":"lodash"}],62:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CommonFeedBlock = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _lodash = require("lodash");
var _commonFeedBlockNotificationsHandler = require("./common-feed-block-notifications-handler");
var _mergeWithoutArrays = _interopRequireDefault(require("../../../utils/merge-without-arrays"));
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = (0, _getPrototypeOf2.default)(t); if (r) { var s = (0, _getPrototypeOf2.default)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0, _possibleConstructorReturn2.default)(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var CommonFeedBlock = function (_CommonFeedBlockNotif) {
  (0, _inherits2.default)(CommonFeedBlock, _CommonFeedBlockNotif);
  var _super = _createSuper(CommonFeedBlock);
  function CommonFeedBlock(NAV_TEMPLATE_API_PREFIX, $filter, $sheet, $i18n, THEME) {
    var _this;
    (0, _classCallCheck2.default)(this, CommonFeedBlock);
    _this = _super.call(this, THEME);
    _this.assetUrl = $filter('assetUrl');
    _this.NAV_TEMPLATE_API_PREFIX = NAV_TEMPLATE_API_PREFIX;
    _this.$sheet = $sheet;
    _this.$i18n = $i18n;
    return _this;
  }
  (0, _createClass2.default)(CommonFeedBlock, [{
    key: "$onInit",
    value: function $onInit() {
      (0, _get2.default)((0, _getPrototypeOf2.default)(CommonFeedBlock.prototype), "$onInit", this).call(this);
      this.blockId = this.config.id;
      console.log("[".concat(this.constructor.name, "] init"), this.config);
      var content = (0, _lodash.get)(this, 'config.data.content');
      if (content.video_url) {
        this.media = {
          sources: [{
            type: 'video/mp4',
            source: this.assetUrl(content.video_url)
          }]
        };
        if (content.image_url) {
          this.media.thumbnail = this.assetUrl(content.image_url);
        }
        this.config.data.content.image_url = null;
      }
    }
  }, {
    key: "$onChanges",
    value: function $onChanges(changes) {
      if (!changes.config) return;
      this.config = (0, _lodash.extend)({}, this.config);
      this.content = this.config.data.content;
      this.actions = this.config.data.actions;
      this.inlineBlocks = this.content.inline_blocks || [];
    }
  }, {
    key: "prependBlocks",
    value: function prependBlocks(_ref) {
      var blocks = _ref.blocks;
      if (!(0, _lodash.isArray)(blocks)) return;
      console.log("[".concat(this.constructor.name, "] prepending blocks"), this.config.id, blocks);
      this.onUpdate(this.EventEmitter({
        id: this.config.id,
        updates: {
          content: {
            inline_blocks: blocks.concat(this.inlineBlocks)
          }
        }
      }));
    }
  }, {
    key: "updateInlineBlock",
    value: function updateInlineBlock(_ref2) {
      var id = _ref2.id,
        updates = _ref2.updates;
      if (!id || !updates) return;
      var blockIndex = (0, _lodash.findIndex)(this.inlineBlocks, function (_ref3) {
        var _id = _ref3.id;
        return id === _id;
      });
      if (blockIndex === -1) return;
      console.log("[".concat(this.constructor.name, "] inline update"), id, updates);
      var block = (0, _lodash.extend)({}, this.inlineBlocks[blockIndex]);
      block.data = (0, _mergeWithoutArrays.default)(block.data, updates);
      var newInlineBlocks = this.inlineBlocks.slice(0, blockIndex).concat([block]).concat(this.inlineBlocks.slice(blockIndex + 1));
      this.onUpdate(this.EventEmitter({
        id: this.config.id,
        updates: {
          content: {
            inline_blocks: newInlineBlocks
          }
        }
      }));
    }
  }, {
    key: "zoomMedia",
    value: function zoomMedia(image) {
      this.$sheet({
        templateUri: "".concat(this.NAV_TEMPLATE_API_PREFIX, "/zoom.html"),
        actions: [{
          id: 'close',
          label: this.$i18n('general.close'),
          action: function action(sheet) {
            return sheet.reject();
          }
        }],
        scrollable: true,
        image: image
      });
    }
  }]);
  return CommonFeedBlock;
}(_commonFeedBlockNotificationsHandler.CommonFeedBlockNotificationHandlers);
exports.CommonFeedBlock = CommonFeedBlock;

},{"../../../utils/merge-without-arrays":363,"./common-feed-block-notifications-handler":61,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/get":379,"@babel/runtime/helpers/getPrototypeOf":380,"@babel/runtime/helpers/inherits":381,"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/helpers/possibleConstructorReturn":387,"lodash":"lodash"}],63:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeedNewPostBlockComponent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
var FeedNewPostBlockComponent = {
  template: require('./feed-new-post-block.jade'),
  bindings: {
    parentNavId: '<',
    config: '<'
  },
  controller: function () {
    FeedNewPostBlockComponent.$inject = ["ACTIVATED_PERSON", "THEME", "databaseService", "navFormService", "$eventBus"];
    /* @ngInject */function FeedNewPostBlockComponent(ACTIVATED_PERSON, THEME, databaseService, navFormService, $eventBus) {
      (0, _classCallCheck2.default)(this, FeedNewPostBlockComponent);
      this.person = ACTIVATED_PERSON;
      this.THEME = THEME;
      this.databaseService = databaseService;
      this.navFormService = navFormService;
      this.$eventBus = $eventBus;
      this.input_key = 'media';
      this.thumbnail_key = 'thumbnail';
      this.person.photo = "".concat(ACTIVATED_PERSON._id, "-photo/photo?_=1");
      this.person.full_name = ACTIVATED_PERSON._representation || [ACTIVATED_PERSON.fname, ACTIVATED_PERSON.lname].join(' ');
    }
    (0, _createClass2.default)(FeedNewPostBlockComponent, [{
      key: "$onInit",
      value: function $onInit() {
        var _this = this;
        this.disableUpload = (0, _lodash.get)(this.config, 'data.action.params.disable_photo_upload');
        this.uploadBlockConfig = this.disableUpload ? null : {
          input_key: this.input_key,
          thumbnail_key: this.thumbnail_key
        };
        this.$eventBus.on('upload-block:file-selected', function () {
          _this.onFileSelected();
        });
      }
    }, {
      key: "onFileSelected",
      value: function onFileSelected() {
        var uploadedFile = this.navFormService.get(this.parentNavId);
        if (!uploadedFile || !uploadedFile[this.input_key]) return;
        this.navFormService.setPreSelectedFile(this.input_key, uploadedFile[this.input_key]);
        this.openModal();
      }
    }, {
      key: "openModal",
      value: function openModal() {
        var _this2 = this;
        var targetScript = (0, _lodash.get)(this.config, 'data.action.target');
        var params = (0, _lodash.get)(this.config, 'data.action.params');
        params.feedFormDataKey = this.parentNavId;
        this.databaseService.runAppScript(targetScript, params).finally(function () {
          _this2.navFormService.set(_this2.parentNavId, _this2.input_key, null);
        });
      }
    }]);
    return FeedNewPostBlockComponent;
  }()
};
exports.FeedNewPostBlockComponent = FeedNewPostBlockComponent;

},{"./feed-new-post-block.jade":64,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"lodash":"lodash"}],64:[function(require,module,exports){
module.exports = '<div class="panel panel-default"><div class="block-new-post"><div class="top-section" ng-class="{&quot;upload-disabled&quot;: $ctrl.disableUpload}"><div class="media-left"><div class="media-object"><avatar object="$ctrl.person" mode="small"></avatar></div></div><input class="form-control" type="text" ng-focus="$ctrl.openModal()" placeholder="{{::&quot;feed.write_a_post&quot; | i18n}}"/></div><upload-block ng-if="::!$ctrl.disableUpload" parent-nav-id="::$ctrl.parentNavId" config="::$ctrl.uploadBlockConfig" accept="&quot;image/jpeg,image/jpg,image/png,image/gif,video/mp4&quot;" max-size="10000000"></upload-block></div></div>';
},{}],65:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeedNewPostBlockModule = void 0;
var _feedNewPostBlock = require("./feed-new-post-block.component");
var FeedNewPostBlockModule = angular.module('maestro.components.blocks.feed-new-post', []).component('feedNewPostBlock', _feedNewPostBlock.FeedNewPostBlockComponent).name;
exports.FeedNewPostBlockModule = FeedNewPostBlockModule;

},{"./feed-new-post-block.component":63}],66:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeedPostAttachmentsComponent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var FeedPostAttachmentsComponent = {
  template: require('./feed-post-attachments.jade'),
  bindings: {
    attachments: '<'
  },
  controller: function () {
    FeedPostAttachmentsComponent.$inject = ["navService"];
    /* @ngInject */function FeedPostAttachmentsComponent(navService) {
      (0, _classCallCheck2.default)(this, FeedPostAttachmentsComponent);
      this.navService = navService;
    }
    (0, _createClass2.default)(FeedPostAttachmentsComponent, [{
      key: "open",
      value: function open(_ref) {
        var action = _ref.action;
        this.navService.openDocument(action.params);
      }
    }]);
    return FeedPostAttachmentsComponent;
  }()
};
exports.FeedPostAttachmentsComponent = FeedPostAttachmentsComponent;

},{"./feed-post-attachments.jade":67,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382}],67:[function(require,module,exports){
module.exports = '<div class="attachment" ng-repeat="att in ::$ctrl.attachments" ng-class="::({first: $first, last: $last})" ng-click="$ctrl.open(att)"><div class="media"><div class="media-left media-top" ng-if="::att.icon_url"><div class="media-object" lazy-background-asset-src="{{::att.icon_url}}"></div></div><div class="media-body" ng-class="::({&quot;no-media-object&quot;: !att.icon_url})"><div class="nav-list-item-title" ng-bind="::att.title"></div><div class="nav-list-item-subtitle" ng-bind="::att.subtitle"></div></div></div></div>';
},{}],68:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeedPostAttachmentsModule = void 0;
var _feedPostAttachments = require("./feed-post-attachments.component");
var FeedPostAttachmentsModule = angular.module('maestro.components.feed.post-attachments', []).component('feedPostAttachments', _feedPostAttachments.FeedPostAttachmentsComponent).name;
exports.FeedPostAttachmentsModule = FeedPostAttachmentsModule;

},{"./feed-post-attachments.component":66}],69:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeedReplyBlockComponent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _lodash = require("lodash");
var _commonFeedBlock = require("../common-feed-block");
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = (0, _getPrototypeOf2.default)(t); if (r) { var s = (0, _getPrototypeOf2.default)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0, _possibleConstructorReturn2.default)(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var FeedReplyBlockComponent = {
  template: require('./feed-reply-block.jade'),
  bindings: {
    config: '<',
    onParentUpdate: '&onUpdate'
  },
  controller: function (_CommonFeedBlock) {
    FeedReplyBlockComponent.$inject = ["NAV_TEMPLATE_API_PREFIX", "navService", "databaseService", "EventEmitter", "$element", "$filter", "$sheet", "$i18n", "THEME"];
    (0, _inherits2.default)(FeedReplyBlockComponent, _CommonFeedBlock);
    var _super = _createSuper(FeedReplyBlockComponent);
    /* @ngInject */function FeedReplyBlockComponent(NAV_TEMPLATE_API_PREFIX, navService, databaseService, EventEmitter, $element, $filter, $sheet, $i18n, THEME) {
      var _this;
      (0, _classCallCheck2.default)(this, FeedReplyBlockComponent);
      _this = _super.call(this, NAV_TEMPLATE_API_PREFIX, $filter, $sheet, $i18n, THEME);
      _this.databaseService = databaseService;
      _this.navService = navService;
      _this.runScript = navService.runScript.bind(navService);
      _this.EventEmitter = EventEmitter;
      _this.$element = $element;
      return _this;
    }
    (0, _createClass2.default)(FeedReplyBlockComponent, [{
      key: "$onInit",
      value: function $onInit() {
        (0, _get2.default)((0, _getPrototypeOf2.default)(FeedReplyBlockComponent.prototype), "$onInit", this).call(this);
        this.$element.trigger('ready');
      }
    }, {
      key: "$onChanges",
      value: function $onChanges(changes) {
        (0, _get2.default)((0, _getPrototypeOf2.default)(FeedReplyBlockComponent.prototype), "$onChanges", this).call(this, changes);
        if (!changes.config) return;
        var data = this.config.data.content;
        this.author = {
          photo: data.avatar_url,
          title: data.title,
          subtitle: (0, _lodash.compact)([data.company, data.position]).join(' • ')
        };
      }
    }, {
      key: "prependBlocks",
      value: function prependBlocks(_ref) {
        var blocks = _ref.blocks;
        console.log('[FeedReplyBlockComponent] prependBlocks', blocks);
        this.onUpdate(this.EventEmitter({
          id: this.config.id,
          updates: {
            content: {
              inline_blocks: (0, _lodash.uniq)(blocks.concat(this.inlineBlocks), function (_ref2) {
                var id = _ref2.id;
                return id;
              })
            }
          }
        }));
      }
    }, {
      key: "onUpdate",
      value: function onUpdate($event) {
        console.log('[FeedReplyBlockComponent] onUpdate', $event);
        this.onParentUpdate(this.EventEmitter($event));
      }
    }]);
    return FeedReplyBlockComponent;
  }(_commonFeedBlock.CommonFeedBlock)
};
exports.FeedReplyBlockComponent = FeedReplyBlockComponent;

},{"../common-feed-block":62,"./feed-reply-block.jade":70,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/get":379,"@babel/runtime/helpers/getPrototypeOf":380,"@babel/runtime/helpers/inherits":381,"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/helpers/possibleConstructorReturn":387,"lodash":"lodash"}],70:[function(require,module,exports){
module.exports = '<div class="media"><div class="media-left"><div class="media-object" ng-click="$ctrl.runScript($ctrl.actions.profile)"><avatar object="$ctrl.author" mode="small"></avatar></div></div><div class="media-body"><div class="nav-list-item-title"><span ng-click="$ctrl.runScript($ctrl.actions.profile)" ng-bind="::$ctrl.content.title"></span><span class="nav-list-item-subsubtitle" ng-bind="::$ctrl.content.time"></span></div><div class="nav-list-item-body" ng-bind-html="::($ctrl.content.message | postLinks:$ctrl.content.links:$ctrl.actions.links)"></div><div class="panel-media" ng-if="::($ctrl.content.image_url || $ctrl.content.video_url)"><video-player ng-if="::$ctrl.content.video_url" media="::$ctrl.media" autoplay="false" config="{ fp_type: \'video\', document_id: $ctrl.content.video_id, configOverrides: $ctrl.content.config_overrides }" use-metadata="true"></video-player><div class="img" ng-if="::$ctrl.content.image_url" lazy-background-asset-src="{{::$ctrl.content.image_url | assetUrl}}" data-max-ratio="75" ng-click="$ctrl.zoomMedia($ctrl.content.image_url)"></div></div><div class="nav-list-item-subtitle"><div class="pull-right" ng-if="::$ctrl.actions.footer_right.length"><footer-buttons buttons="$ctrl.actions.footer_right" labels-only="labels-only"></footer-buttons></div><div ng-if="::$ctrl.actions.footer_left.length"><footer-buttons buttons="$ctrl.actions.footer_left" labels-only="labels-only"></footer-buttons></div></div><inline-block-paginator ng-if="::($ctrl.inlineBlocks.length || $ctrl.actions.load_previous)" blocks="$ctrl.inlineBlocks" prepend-blocks="$ctrl.prependBlocks($event)" previous-page-action="$ctrl.actions.load_previous" previous-page="$ctrl.content.previous_page"></inline-block-paginator></div></div>';
},{}],71:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeedReplyBlockModule = void 0;
var _feedReplyBlock = require("./feed-reply-block.component");
var FeedReplyBlockModule = angular.module('maestro.components.blocks.feed-reply', []).component('feedReplyBlock', _feedReplyBlock.FeedReplyBlockComponent).name;
exports.FeedReplyBlockModule = FeedReplyBlockModule;

},{"./feed-reply-block.component":69}],72:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeedTopicBlockComponent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _lodash = require("lodash");
var _commonFeedBlock = require("../common-feed-block");
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = (0, _getPrototypeOf2.default)(t); if (r) { var s = (0, _getPrototypeOf2.default)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0, _possibleConstructorReturn2.default)(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var FeedTopicBlockComponent = {
  template: require('./feed-topic-block.jade'),
  bindings: {
    config: '<',
    onUpdate: '&'
  },
  controller: function (_CommonFeedBlock) {
    FeedTopicBlockComponent.$inject = ["NAV_TEMPLATE_API_PREFIX", "$timeout", "databaseService", "navService", "EventEmitter", "$filter", "$sheet", "$i18n", "THEME"];
    (0, _inherits2.default)(FeedTopicBlockComponent, _CommonFeedBlock);
    var _super = _createSuper(FeedTopicBlockComponent);
    /* @ngInject */function FeedTopicBlockComponent(NAV_TEMPLATE_API_PREFIX, $timeout, databaseService, navService, EventEmitter, $filter, $sheet, $i18n, THEME) {
      var _this;
      (0, _classCallCheck2.default)(this, FeedTopicBlockComponent);
      _this = _super.call(this, NAV_TEMPLATE_API_PREFIX, $filter, $sheet, $i18n, THEME);
      _this.$timeout = $timeout;
      _this.databaseService = databaseService;
      _this.navService = navService;
      _this.runScript = navService.runScript.bind(navService);
      _this.EventEmitter = EventEmitter;
      return _this;
    }
    (0, _createClass2.default)(FeedTopicBlockComponent, [{
      key: "onToolbarActionClick",
      value: function onToolbarActionClick(toolbarAction) {
        var action = toolbarAction.action,
          loading = toolbarAction.loading;
        if (loading || !action || !action.target) {
          return;
        }
        toolbarAction.loading = true;
        this.databaseService.runAppScript(action.target, action.params).then(function (_ref) {
          var response = _ref.data.response;
          return (0, _lodash.extend)(toolbarAction, response);
        }).finally(function () {
          toolbarAction.loading = false;
        });
      }
    }]);
    return FeedTopicBlockComponent;
  }(_commonFeedBlock.CommonFeedBlock)
};
exports.FeedTopicBlockComponent = FeedTopicBlockComponent;

},{"../common-feed-block":62,"./feed-topic-block.jade":73,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/getPrototypeOf":380,"@babel/runtime/helpers/inherits":381,"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/helpers/possibleConstructorReturn":387,"lodash":"lodash"}],73:[function(require,module,exports){
module.exports = '<div class="panel panel-default" theme="::$ctrl.topic_theme"><div class="posted-at nav-list-item-subsubtitle pull-right" ng-if="::$ctrl.content.time" ng-bind="::$ctrl.content.time"></div><div class="extras" ng-if="$ctrl.content.supplementary_text &amp;&amp; $ctrl.actions.toolbar_actions" ng-click="$ctrl.runScript($ctrl.actions.supplementary)"><img class="icon" ng-src="{{::$ctrl.content.supplementary_icon_url | assetUrl}}" ng-show="$ctrl.content.supplementary_icon_url"/><small>{{$ctrl.content.supplementary_text}}</small></div><div class="panel-heading" ng-if="::($ctrl.content.title || $ctrl.content.time)"><span ng-bind="$ctrl.content.title"></span><span class="preposition" ng-if="$ctrl.content.feed.name">&nbsp;{{$ctrl.content.feed.preposition}}&nbsp;</span><span ng-if="$ctrl.content.feed.name" ng-bind="$ctrl.content.feed.name "></span></div><div class="panel-media" ng-if="::($ctrl.content.image_url || $ctrl.content.video_url)"><video-player ng-if="::$ctrl.content.video_url" media="::$ctrl.media" autoplay="false" config="{ fp_type: \'video\', document_id: $ctrl.content.video_id, configOverrides: $ctrl.content.config_overrides }" use-metadata="true"></video-player><div class="img" ng-if="::$ctrl.content.image_url" lazy-background-asset-src="{{::$ctrl.content.image_url | assetUrl}}" data-max-ratio="75" ng-click="$ctrl.zoomMedia($ctrl.content.image_url)"></div></div><div class="panel-body" ng-if="::$ctrl.content.description" ng-bind-html="::($ctrl.content.description | postLinks:$ctrl.content.links:$ctrl.actions.links)"></div><feed-post-attachments ng-if="::$ctrl.content.attachments.length" ng-class="{ &quot;no-title&quot;: !$ctrl.content.title }" attachments="::$ctrl.content.attachments"></feed-post-attachments><div class="panel-footer toolbar-actions" ng-if="::($ctrl.actions.toolbar_actions)"><div class="footer-post-actions-block"><a ng-repeat="button in $ctrl.actions.toolbar_actions.footer_block" data-cue="action-{{::button.action.target}}" ng-click="$ctrl.onToolbarActionClick(button)"><i class="icon" icon="button.icon_url" ng-if="button.icon_url"></i><span ng-bind="button.label"></span></a></div><div class="actions"><div class="action" ng-repeat="button in $ctrl.actions.toolbar_actions.footer_left" data-cue="action-{{::button.action.target}}" ng-click="$ctrl.onToolbarActionClick(button)"><div><i class="icon" icon="button.icon_url" ng-show="button.icon_url" force-color="$ctrl.config.data.theme.icon_color"></i><span ng-bind="button.label"></span></div></div></div></div><div class="panel-footer post-actions" ng-if="::(!$ctrl.actions.toolbar_actions &amp;&amp; ($ctrl.actions.footer_left.length || $ctrl.actions.footer_left.length))"><div class="pull-right" ng-if="::$ctrl.actions.footer_right.length"><footer-buttons buttons="$ctrl.actions.footer_right"></footer-buttons></div><div ng-if="::$ctrl.actions.footer_left.length"><footer-buttons buttons="$ctrl.actions.footer_left"></footer-buttons></div></div><inline-block-paginator class="panel-footer" ng-if="::($ctrl.inlineBlocks.length || $ctrl.actions.load_previous)" blocks="$ctrl.inlineBlocks" prepend-blocks="$ctrl.prependBlocks($event)" previous-page-action="$ctrl.actions.load_previous" thread-action="$ctrl.actions.block" previous-page="$ctrl.content.previous_page" update-inline-block="$ctrl.updateInlineBlock($event)"></inline-block-paginator></div>';
},{}],74:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeedTopicBlockModule = void 0;
var _feedTopicBlock = require("./feed-topic-block.component");
var FeedTopicBlockModule = angular.module('maestro.components.blocks.feed-topic', []).component('feedTopicBlock', _feedTopicBlock.FeedTopicBlockComponent).name;
exports.FeedTopicBlockModule = FeedTopicBlockModule;

},{"./feed-topic-block.component":72}],75:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MeetingBlockModule = void 0;
var _meetingBlock = require("./meeting-block.component");
var MeetingBlockModule = angular.module('maestro.components.blocks.meeting', []).component('meetingBlock', _meetingBlock.MeetingBlockComponent).name;
exports.MeetingBlockModule = MeetingBlockModule;

},{"./meeting-block.component":76}],76:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MeetingBlockComponent = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
var MeetingBlockComponent = {
  template: require('./meeting-block.pug'),
  bindings: {
    config: '<'
  },
  controller: function () {
    MeetingBlockComponent.$inject = ["databaseService"];
    /* @ngInject */function MeetingBlockComponent(databaseService) {
      (0, _classCallCheck2.default)(this, MeetingBlockComponent);
      this.databaseService = databaseService;
    }
    (0, _createClass2.default)(MeetingBlockComponent, [{
      key: "$onInit",
      value: function $onInit() {
        var config = this.config;
        console.info('[MeetingBlockComponent] init', config);
        this.content = config.data.content;
        this.attend = config.data.content.status || 'maybe';
        var externalAvatars = (this.content.externals || []).map(function (external) {
          return {
            initials: external.substring(0, 2)
          };
        });
        this.avatars = [].concat((0, _toConsumableArray2.default)(this.content.participants || []), (0, _toConsumableArray2.default)(externalAvatars));
        if (this.avatars.length > 4) {
          var len = this.avatars.length;
          this.avatars = this.avatars.slice(0, 3);
          this.avatars.push({
            initials: "+".concat(len - 3)
          });
        }
        if (this.content.meeting_location) {
          var location = this.content.location || '';
          this.content.location = this.content.meeting_location.title;
          if (location.length) {
            this.content.location += " - ".concat(location);
          }
        }
      }
    }, {
      key: "$onChanges",
      value: function $onChanges(changes) {
        var config = changes.config.currentValue;
        this.attend = config.data.content.status;
      }
    }, {
      key: "openDetails",
      value: function openDetails() {
        var action = (0, _lodash.get)(this, 'config.data.actions.block');
        if (action) {
          this.performAction(action);
        }
      }
    }, {
      key: "toggleAttendance",
      value: function toggleAttendance() {
        var data = this.config.data;
        var action = data.actions.attendance;
        switch (data.content.status) {
          case 'yes':
            action.params.attend = 'no';
            break;
          case 'no':
            action.params.attend = 'maybe';
            break;
          default:
            action.params.attend = 'yes';
            break;
        }
        this.attend = data.content.status = action.params.attend;
        this.performAction(action);
      }
    }, {
      key: "performAction",
      value: function performAction(action) {
        this.databaseService.runAppScript(action.path, action.params);
      }
    }]);
    return MeetingBlockComponent;
  }()
};
exports.MeetingBlockComponent = MeetingBlockComponent;

},{"./meeting-block.pug":77,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/helpers/toConsumableArray":393,"lodash":"lodash"}],77:[function(require,module,exports){
module.exports = '<div class="block-meeting"><header><span class="attendance" ng-click="$ctrl.toggleAttendance()" ng-class="$ctrl.attend"><i class="icon-cross"></i><i class="icon-check"></i><i class="question"></i></span><h3 ng-click="$ctrl.openDetails()">{{::$ctrl.content.title}}</h3></header><section ng-click="$ctrl.openDetails()"><div class="location"><i class="icon-location"></i>{{::$ctrl.content.location}}</div><div class="date"><i class="icon-calendar"></i>{{::$ctrl.content.start_time | time:\'LL\'}}</div><div class="time"><i class="icon-clock"></i>{{::$ctrl.content.start_time | shortTime}}\n' +
'-\n' +
'{{::$ctrl.content.end_time | shortTime}}</div><div class="pax-list"><div class="pax" ng-repeat="pax in $ctrl.avatars"><avatar object="pax" mode="small important"></avatar></div></div></section></div>';
},{}],78:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AvatarComponent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
var NO_PHOTO = 'icon.nophoto/file.png';
var AvatarController = function () {
  AvatarController.$inject = ["THEME", "$scope", "$filter", "SETTINGS"];
  /* @ngInject */
  function AvatarController(THEME, $scope, $filter, SETTINGS) {
    (0, _classCallCheck2.default)(this, AvatarController);
    this.theme = THEME;
    this.$scope = $scope;
    this.$filter = $filter;
    this.zoomed = false;
    this.settings = SETTINGS;
  }
  (0, _createClass2.default)(AvatarController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      if (this.watch) {
        this.$scope.$watch('$ctrl.object', function () {
          return _this.update();
        }, true);
        this.$scope.$watch('$ctrl.hidePicture', function () {
          return _this.update();
        }, true);
      } else {
        this.update();
      }
    }
  }, {
    key: "toggleZoom",
    value: function toggleZoom() {
      if (this.zoomable) {
        this.zoomed = !this.zoomed;
      }
    }
  }, {
    key: "onImageError",
    value: function onImageError() {
      this.zoomable = false;
      var placeHolderImage = this.getPlaceholderImage();
      if (placeHolderImage && this.getImage() !== placeHolderImage) {
        this.image = placeHolderImage;
      } else if ((0, _lodash.get)(this.settings, 'person.show_initials', true)) {
        this.showInitials = true;
      } else if (this.image !== NO_PHOTO) {
        this.image = NO_PHOTO;
      }
      this.$scope.$applyAsync();
    }
  }, {
    key: "update",
    value: function update() {
      if (this.hidePicture) {
        this.showInitials = true;
        if (!(0, _lodash.get)(this.settings, 'person.show_initials', true)) {
          this.initials = ' ';
        }
      }
      this.initials = this.getInitials();
      this.image = this.getImage();
      this.mode = this.getMode();
      this.$scope.$applyAsync();
    }
  }, {
    key: "getInitials",
    value: function getInitials() {
      var _this2 = this;
      if (this.initials || this.object.initials) {
        return this.initials || this.object.initials;
      }
      var prop = ['_representation', 'full_name', 'real_name', 'title'].find(function (p) {
        return _this2.object.hasOwnProperty(p);
      });
      var name = this.object[prop];
      if (!name || !name.length) {
        console.warn('[AvatarComponent] Could not find a name in the given object', this.object);
        return;
      }
      return this.$filter('takeInitials')(name);
    }
  }, {
    key: "getImage",
    value: function getImage() {
      var _this3 = this;
      var prop = ['_representation_image', 'image_url', 'image', 'img', 'photo', 'photoUrl', 'avatar_url'].find(function (p) {
        return _this3.object.hasOwnProperty(p);
      });
      var image = this.object[prop];
      if (image && image.length && image !== NO_PHOTO) {
        this.showInitials = false;
        return image;
      }
      if ((0, _lodash.get)(this.settings, 'person.show_initials', true)) {
        this.showInitials = true;
      } else {
        return NO_PHOTO;
      }
    }
  }, {
    key: "getPlaceholderImage",
    value: function getPlaceholderImage() {
      var image = this.object.placeholder_img;
      if (image && image.length && image !== NO_PHOTO) {
        return image;
      }
      return false;
    }
  }, {
    key: "getMode",
    value: function getMode() {
      return this.object.mode || this.mode;
    }
  }]);
  return AvatarController;
}();
var AvatarComponent = {
  bindings: {
    object: '<',
    initials: '@',
    mode: '@',
    zoomable: '<',
    watch: '<',
    shape: '<',
    outlined: '<',
    hidePicture: '<',
    immediate: '<'
  },
  template: require('./avatar.pug'),
  controller: AvatarController
};
exports.AvatarComponent = AvatarComponent;

},{"./avatar.pug":79,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"lodash":"lodash"}],79:[function(require,module,exports){
module.exports = '<div class="avatar ng-hide" ng-show="$ctrl.object" ng-class="[$ctrl.mode, { zoomed: $ctrl.zoomed, zoomable: $ctrl.zoomable }, $ctrl.shape]"><div class="outer-wrapper" ng-class="{\'colored-background\': $ctrl.showInitials, outlined: $ctrl.outlined }"><div class="image-wrapper" ng-if="!$ctrl.showInitials" ng-click="$ctrl.toggleZoom()"><img class="no-click-effect" ng-if="!$ctrl.immediate" onerror="$ctrl.onImageError()" watch-src="true" asset-src="{{ $ctrl.image | assetUrl }}" aria-hidden="true" loading="lazy"/><img class="no-click-effect asset-loaded" ng-if="$ctrl.immediate" ng-on-error="$ctrl.onImageError()" src="{{ $ctrl.image | assetUrl }}" aria-hidden="true"/></div><div class="empty" ng-if="$ctrl.showInitials"><span>{{ $ctrl.initials }}</span></div></div></div>';
},{}],80:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AvatarModule = void 0;
var _avatar = require("./avatar.component");
function tryModule() {
  try {
    var mod = angular.module('frontstage.components.avatar');
    console.info('[Avatar] Module already installed, skipping installation from webapp');
    return mod.name;
  } catch (error) {
    console.info('[Avatar] Module not installed yet; installing from webapp');
    return angular.module('maestro.components.common.avatar', []).component('avatar', _avatar.AvatarComponent).name;
  }
}
var AvatarModule = tryModule();
exports.AvatarModule = AvatarModule;

},{"./avatar.component":78}],81:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CookiesNotificationComponent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _i18nWithFallback = _interopRequireDefault(require("../../../utils/i18n-with-fallback"));
var CookiesNotificationComponent = {
  template: require('./cookies-notification.jade'),
  controller: function () {
    CookiesNotificationComponent.$inject = ["$i18n", "$cookies", "$element", "$timeout", "metricsService", "EVENT"];
    /* @ngInject */
    function CookiesNotificationComponent($i18n, $cookies, $element, $timeout, metricsService, EVENT) {
      (0, _classCallCheck2.default)(this, CookiesNotificationComponent);
      this.$cookies = $cookies;
      this.$element = $element;
      this.$timeout = $timeout;
      this.tracker = metricsService;
      this.event = EVENT;
      this.key = 'cookies-policy';
      this.cookiePolicyUrl = (0, _i18nWithFallback.default)($i18n, 'general.cookies-disclaimer-url', "https://support.spotme.com/hc/en-us/articles/11137129955731");
      this.cookieLinkLabel = (0, _i18nWithFallback.default)($i18n, 'general.cookies-disclaimer-link', 'cookie policy');
      var introLabel = (0, _i18nWithFallback.default)($i18n, 'general.cookies-disclaimer', 'You can share anonymized usage statistics with us to improve your experience. Read our {0}');
      introLabel = introLabel.replace('{0}', "<a href=\"".concat(this.cookiePolicyUrl, "\"  target=\"_blank\" rel=\"noopener noreferrer\">").concat(this.cookieLinkLabel, "</a>"));
      this.introLabel = introLabel;
      this.agreeLabel = (0, _i18nWithFallback.default)($i18n, 'general.agree', 'Yes, please!');
      this.rejectLabel = (0, _i18nWithFallback.default)($i18n, 'general.disagree', 'No, thanks!');
    }
    (0, _createClass2.default)(CookiesNotificationComponent, [{
      key: "$onInit",
      value: function $onInit() {
        var _this = this;
        var accepted = this.$cookies.get(this.key);
        if (this.event.show_cookie_banner && !accepted) {
          this.$timeout(function () {
            _this.$element.addClass('in');
          }, 1000);
        } else {
          this.tracker.init();
          this.clearElement();
        }
      }
    }, {
      key: "$onDestroy",
      value: function $onDestroy() {
        this.$element.remove();
      }
    }, {
      key: "accept",
      value: function accept() {
        this.$cookies.put(this.key, 1);
        this.tracker.init();
        this.clearElement();
      }
    }, {
      key: "reject",
      value: function reject() {
        this.$cookies.put('cookies-policy', 0);
        this.tracker.stopTracking();
        this.clearElement();
      }
    }, {
      key: "clearElement",
      value: function clearElement() {
        var _this2 = this;
        this.$element.removeClass('in');
        this.$timeout(function () {
          _this2.$element.remove();
        }, 1000);
      }
    }]);
    return CookiesNotificationComponent;
  }()
};
exports.CookiesNotificationComponent = CookiesNotificationComponent;

},{"../../../utils/i18n-with-fallback":359,"./cookies-notification.jade":82,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382}],82:[function(require,module,exports){
module.exports = '<div class="cookies-notification"><p ng-bind-html="::$ctrl.introLabel"></p><p><button class="btn btn-default btn-primary" ng-click="$ctrl.reject()">{{::$ctrl.rejectLabel}}</button><button class="btn btn-default btn-primary" ng-click="$ctrl.accept()">{{::$ctrl.agreeLabel}}</button></p></div>';
},{}],83:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CookiesNotificationModule = void 0;
var _cookiesNotification = require("./cookies-notification.component");
var CookiesNotificationModule = angular.module('maestro.components.common.cookies-notification', []).component('cookiesNotification', _cookiesNotification.CookiesNotificationComponent).name;
exports.CookiesNotificationModule = CookiesNotificationModule;

},{"./cookies-notification.component":81}],84:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilteringComponent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
var _i18nWithFallback = _interopRequireDefault(require("../../../utils/i18n-with-fallback"));
var FilteringComponent = {
  template: require('./filtering.pug'),
  bindings: {
    filters: '=',
    selection: '<',
    onAccept: '&',
    onApplyFilters: '&',
    searchQuery: '<'
  },
  controller: function () {
    FilteringComponent.$inject = ["$i18n", "THEME"];
    /* @ngInject */
    function FilteringComponent($i18n, THEME) {
      (0, _classCallCheck2.default)(this, FilteringComponent);
      this.selectedOptionStyle = {
        'color': THEME.foregroundColor1 || THEME.toolbar.font_color || 'white',
        'background-color': THEME.toolbar.background_color
      };
      this.moreLabel = (0, _i18nWithFallback.default)($i18n, 'agenda_nav.filters.show_all', 'Show all...');
      this.clearLabel = (0, _i18nWithFallback.default)($i18n, 'general.clear', 'Clear');
      this.noMatchesFoundLabel = (0, _i18nWithFallback.default)($i18n, 'general.no_matches_found', 'No matches found');
      this.applied = false;
    }
    (0, _createClass2.default)(FilteringComponent, [{
      key: "$onInit",
      value: function $onInit() {
        var _this$selection;
        this.filters = this.filters.map(function (f) {
          if (f.mode === 'tags') {
            f.options = f.options.map(function (o) {
              o.notSelectedLabelStyle = {
                color: o.background_color
              };
              o.selectedLabelStyle = {
                color: o.background_color,
                'background-color': o.background_color
              };
              o.selectedFontStyle = {
                color: o.font_color
              };
              return o;
            });
            f.shownOptions = f.shownOptions || f.options.slice(0, 4);
          }
          return f;
        });
        if ((_this$selection = this.selection) !== null && _this$selection !== void 0 && _this$selection.length) {
          this.applied = true;
        }
        console.log('[FilteringComponent] Init', this.filters);
      }
    }, {
      key: "$onChanges",
      value: function $onChanges(changes) {
        var _this = this;
        if (changes.filters && changes.filters.currentValue) {
          this.filters = angular.copy(this.filters);
        }
        if (this.filters && this.selection) {
          console.log('[FilteringComponent] $onChange', this.filters, this.selection);
          (0, _lodash.each)(this.filters, function (_filter) {
            return (0, _lodash.each)(_filter.options, function (option) {
              option.selected = (0, _lodash.some)(_this.selection, function (selectedItem) {
                return selectedItem.field === _filter.field && selectedItem.value.indexOf(option.value) !== -1;
              });
            });
          });
        }
      }
    }, {
      key: "$onDestroy",
      value: function $onDestroy() {
        if (!this.applied && (0, _lodash.isFunction)(this.onApplyFilters)) {
          this.onApplyFilters({
            value: 'closed'
          });
        }
      }
    }, {
      key: "showClearFilters",
      value: function showClearFilters() {
        return this.searchQuery && this.searchQuery.length || this.filters.map(function (filter) {
          return filter.options;
        }).flat().filter(function (filter) {
          return filter.selected;
        }).length;
      }
    }, {
      key: "clearFilters",
      value: function clearFilters(specificFilter) {
        (0, _lodash.each)(this.filters, function (_filter) {
          if (specificFilter && _filter.field !== specificFilter.field) return;
          (0, _lodash.each)(_filter.options, function (option) {
            option.selected = false;
          });
          if (_filter.mode === 'select') {
            _filter.selectedOptionsCount = 0;
          }
        });
        return this.applyFilters();
      }
    }, {
      key: "applyFilters",
      value: function applyFilters() {
        var selection = {};
        (0, _lodash.each)(this.filters, function (_filter) {
          var field = _filter.field;
          var selectedValues = (0, _lodash.filter)(_filter.options, function (option) {
            return option.selected;
          }).map(function (option) {
            return option.value;
          });
          if (selectedValues && selectedValues.length) {
            selection[field] = (selection[field] || []).concat(selectedValues);
          }
        });
        selection = (0, _lodash.map)(selection, function (value, field) {
          return {
            field: field,
            value: value
          };
        });
        console.log('[FilteringComponent] applyFilters', selection);
        if ((0, _lodash.isFunction)(this.onApplyFilters)) {
          this.onApplyFilters({
            value: selection.length ? selection : 'cleared'
          });
          this.applied = true;
        }
        this.onAccept({
          value: selection
        });
      }
    }, {
      key: "toggleFilterOptions",
      value: function toggleFilterOptions() {
        var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, _lodash.each)(this.filters, function (_filter) {
          _filter.showOptions = _filter.field === filter.field ? !filter.showOptions : false;
        });
      }
    }, {
      key: "showAllOptions",
      value: function showAllOptions(filter, $event) {
        $event.stopPropagation();
        filter.shownOptions = filter.options;
      }
    }, {
      key: "selectOption",
      value: function selectOption(filter, option) {
        option.selected = true;
        option.order = (filter.lastOptionIndex || 0) + 1;
        filter.lastOptionIndex = option.order;
        filter.selectedOptionsCount++;
        this.toggleFilterOptions(filter);
        this.applyFilters();
      }
    }, {
      key: "removeOption",
      value: function removeOption(filter, option) {
        option.selected = false;
        filter.selectedOptionsCount--;
        filter.lastOptionIndex = option.order--;
        this.applyFilters();
      }
    }]);
    return FilteringComponent;
  }()
};
exports.FilteringComponent = FilteringComponent;

},{"../../../utils/i18n-with-fallback":359,"./filtering.pug":85,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"lodash":"lodash"}],85:[function(require,module,exports){
module.exports = '<div class="form-horizontal"><div class="form-group" ng-repeat="filter in ::$ctrl.filters" ng-if="filter.options.length || filter.shownOptions.length"><h5>{{::filter.label}}</h5><div class="filter-type" ng-if="::(filter.mode === \'select\')" ng-class="::filter.mode"><div class="clear-filter-btn" ng-if="filter.selectedOptionsCount" ng-click="$ctrl.clearFilters(filter)"> {{::$ctrl.clearLabel}} ({{filter.selectedOptionsCount}})</div><div class="select-wrapper" ng-click="$ctrl.toggleFilterOptions(filter)"><div class="placeholder">{{::filter.placeholder}}</div><div class="selector"><i class="icon-chevron-down" ng-if="!filter.showOptions"></i><i class="icon-chevron-up" ng-if="filter.showOptions"></i></div></div><div class="options" ng-if="filter.showOptions"><div class="option" ng-repeat="option in filter.options" ng-if="!option.selected" ng-click="$ctrl.selectOption(filter, option)"><span>{{::option.value}}</span></div><div class="option no-option" ng-if="filter.selectedOptionsCount === filter.options.length || !filter.options.length"><span>{{::$ctrl.noMatchesFoundLabel}}</span></div></div><div class="selected-values"><div class="selected-value" ng-repeat="option in filter.options | orderBy: \'order\'" ng-if="option.selected" ng-click="$ctrl.removeOption(filter, option)" ng-style="$ctrl.selectedOptionStyle"><span>{{::option.value}}</span><i class="closer"></i></div></div></div><div class="filter-type" ng-if="::(filter.mode === \'list\')" ng-class="::filter.mode"><div class="checkbox" ng-repeat="option in ::filter.options"><label><input type="checkbox" ng-model="option.selected" ng-change="$ctrl.applyFilters()"/><span class="text">{{::option.label}}</span></label></div></div><div class="filter-type tags" ng-if="::(filter.mode === \'tags\')" ng-class="{\'collapsed\': filter.options.length !== filter.shownOptions.length &amp;&amp; filter.options.length &gt; 4}"><div class="checkboxes"><div class="checkbox" ng-repeat="option in filter.shownOptions"><label ng-style="option.selected ? option.selectedLabelStyle : option.notSelectedLabelStyle" title="{{::option.label}}"><input type="checkbox" ng-model="option.selected" ng-change="$ctrl.applyFilters()"/><i class="checker" style="background-color: {{::option.background_color}}"></i><span class="text" ng-style="option.selected ? option.selectedFontStyle : {}">{{::option.label}}</span><i class="closer" style="color: {{::option.font_color}}"></i></label></div></div><div class="more" ng-if="filter.options.length !== filter.shownOptions.length &amp;&amp; filter.options.length &gt; 4" ng-click="$ctrl.showAllOptions(filter, $event)">{{ $ctrl.moreLabel }}</div></div></div></div><div class="popover-footer-placeholder"></div><div class="popover-footer" ng-if="$ctrl.showClearFilters()"><div class="btn btn-transparent btn-sm" ng-click="$ctrl.clearFilters()">{{::(\'agenda_nav.filters.clear_all\' | i18n)}}</div></div>';
},{}],86:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilteringModule = exports.FilteringController = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _i18nWithFallback = _interopRequireDefault(require("../../../utils/i18n-with-fallback"));
var _filtering = require("./filtering.component");
var _lodash = require("lodash");
var FilteringModule = angular.module('maestro.components.common.filtering', []).component('filtering', _filtering.FilteringComponent).name;
exports.FilteringModule = FilteringModule;
var FilteringController = function () {
  FilteringController.$inject = ["THEME", "EID", "$q", "$popover", "$i18n", "$http", "dataSourceEvaluatorService"];
  /* @ngInject */
  function FilteringController(THEME, EID, $q, $popover, $i18n, $http, dataSourceEvaluatorService) {
    (0, _classCallCheck2.default)(this, FilteringController);
    this.theme = THEME;
    this.EID = EID;
    this.$q = $q;
    this.$popover = $popover;
    this.i18n = $i18n;
    this.$http = $http;
    this.dse = dataSourceEvaluatorService;
    this.selectedFilters = [];
  }
  (0, _createClass2.default)(FilteringController, [{
    key: "$onDestroy",
    value: function $onDestroy() {
      this.$popover.clearAll();
    }
  }, {
    key: "getFilters",
    value: function getFilters() {
      var _this = this;
      if (this.filters) return this.$q.when(this.filters);
      if (this.config.remote_ds_filters) {
        var filtersToQuery = this.config.remote_ds_filters.filters.join();
        return this.$http.get("/api/v1/eid/".concat(this.EID, "/").concat(this.config.remote_ds_filters.path), {
          params: {
            filters: filtersToQuery
          }
        }).then(function () {
          var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            data = _ref.data;
          var filters = data;
          _this.filters = (0, _lodash.map)(filters, function (filter) {
            return {
              field: filter.key,
              label: _this.i18n("nav_personlist.filters.".concat(filter.key)),
              placeholder: _this.i18n("nav_personlist.filters.".concat(filter.key, "_placeholder")),
              mode: 'select',
              options: (0, _lodash.map)(filter.options, function (opt) {
                return {
                  value: opt,
                  selected: false
                };
              }),
              showOptions: false,
              selectedOptionsCount: 0
            };
          });
        });
      }
      if (this.config.filters_ds) {
        return this.dse.eval(this.config.filters_ds).then(function (filters) {
          return _this.filters = filters;
        });
      }
    }
  }, {
    key: "clearFilters",
    value: function clearFilters() {
      this.selectedFilters = [];
      this.reload(true);
    }
  }, {
    key: "showFilters",
    value: function showFilters($event) {
      var _this2 = this;
      return this.getFilters().then(function (filters) {
        return _this2.$popover({
          template: '<filtering filters="::filters" selection="selection" on-accept="accept(value)" on-apply-filters="onApplyFilters(value)"></filtering>',
          target: $event.target,
          options: {
            title: _this2.$i18n('agenda_nav.filters.title'),
            container: 'body'
          },
          filters: filters,
          selection: _this2.selectedFilters,
          onApplyFilters: _this2.onApplyFilters.bind(_this2)
        });
      }).then(function (selection) {
        console.log('filter selection', selection);
        _this2.selectedFilters = (0, _lodash.isArray)(selection) ? selection : [];
      }).finally(function () {
        _this2.appliedFiltersLabel = _this2.getAppliedFiltersLabel();
        _this2.reload(true);
      });
    }
  }, {
    key: "getAppliedFiltersLabel",
    value: function getAppliedFiltersLabel() {
      var filtersCount = this.selectedFilters.reduce(function (count, filter) {
        return count + filter.value.length;
      }, 0);
      var label = 'agenda_nav.filters.single_selected_filter';
      if (filtersCount > 1) {
        label = (0, _i18nWithFallback.default)(this.i18n, 'agenda_nav.filters.multiple_selected_filter', '%d filters selected');
      } else {
        label = (0, _i18nWithFallback.default)(this.i18n, 'agenda_nav.filters.single_selected_filter', '%d filter selected');
      }
      return label.replace('%d', filtersCount);
    }
  }, {
    key: "onApplyFilters",
    value: function onApplyFilters(filtersApplied) {
      console.warn('[FilteringController] onApplyFilters should be implemented on child controller');
      return filtersApplied;
    }
  }]);
  return FilteringController;
}();
exports.FilteringController = FilteringController;

},{"../../../utils/i18n-with-fallback":359,"./filtering.component":84,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"lodash":"lodash"}],87:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageMediumComponent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var ImageMediumComponent = {
  bindings: {
    media: '<',
    load: '<',
    zoomed: '<'
  },
  template: require('./image.jade'),
  controller: function () {
    ImageMedium.$inject = ["navService", "loadAssetImg", "$element", "$scope"];
    /* @ngInject */
    function ImageMedium(navService, loadAssetImg, $element, $scope) {
      (0, _classCallCheck2.default)(this, ImageMedium);
      this.navService = navService;
      this.loadAssetImg = loadAssetImg;
      this.element = $element;
      this.$scope = $scope;
      this.loading = true;
    }
    (0, _createClass2.default)(ImageMedium, [{
      key: "$onInit",
      value: function $onInit() {
        this.image = this.element.find('img');
        if (this.zoomed) {
          this.load = this.media.url;
        }
        this.loadImage(this.load || this.media.thumbnail);
      }
    }, {
      key: "zoom",
      value: function zoom() {
        var _this = this;
        if (this.zoomed) {
          return;
        }
        this.loadImage(this.media.url, function () {
          _this.$scope.$emit('startZoom', {
            element: _this.element,
            media: _this.media
          });
        });
      }
    }, {
      key: "loadImage",
      value: function loadImage(url, callback) {
        var _this2 = this;
        this.loading = true;
        this.loadAssetImg(this.image, url, function () {
          _this2.loading = false;
          _this2.$scope.$apply();
          if (callback && typeof callback === 'function') {
            callback();
          }
        });
      }
    }, {
      key: "performActions",
      value: function performActions() {
        console.info('[ImageMedium] performActions');
        this.navService.performActions(this.media.actions);
      }
    }]);
    return ImageMedium;
  }()
};
exports.ImageMediumComponent = ImageMediumComponent;

},{"./image.jade":88,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382}],88:[function(require,module,exports){
module.exports = '<div class="media-wrapper no-click-effect" ng-click="$ctrl.zoom($event)" ng-class="{\'loading\': $ctrl.loading}"><i class="icon-loader" ng-show="$ctrl.loading"></i><div class="no-obj-fit" style="background-image:url({{$ctrl.media.thumbnail}})"></div><figure class="media-container"><img alt="{{::$ctrl.media.description}}"/><figcaption class="caption" ng-if="::($ctrl.media.description || $ctrl.media.timestamp || $ctrl.media.author || $ctrl.media.actions)"><span class="author" ng-if="::$ctrl.media.author">{{::$ctrl.media.author}}</span><span class="time" ng-if="::$ctrl.media.time">{{::$ctrl.media.time}}</span><div class="description" ng-if="::$ctrl.media.description">{{::$ctrl.media.description}}</div><div class="actions"><footer-buttons buttons="::$ctrl.media.actions"></footer-buttons></div></figcaption></figure></div>';
},{}],89:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageMediumModule = void 0;
var _imageMedium = require("./image-medium.component");
var ImageMediumModule = angular.module('maestro.components.common.image-medium', []).component('imageMedium', _imageMedium.ImageMediumComponent).name;
exports.ImageMediumModule = ImageMediumModule;

},{"./image-medium.component":87}],90:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InAppNotificationComponent = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assets = require("../../../utils/assets");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var InAppNotificationComponent = {
  template: require('./in-app-notification.pug'),
  controller: function () {
    InAppNotificationComponent.$inject = ["$timeout", "$log", "$scope", "$element", "$eventBus", "databaseService", "metricsService"];
    /* @ngInject */
    function InAppNotificationComponent($timeout, $log, $scope, $element, $eventBus, databaseService, metricsService) {
      (0, _classCallCheck2.default)(this, InAppNotificationComponent);
      $scope.isDestroyed = false;
      this.appscriptLoading = false;
      this.$timeout = $timeout;
      this.$log = $log;
      this.$scope = $scope;
      this.$element = $element;
      this.databaseService = databaseService;
      this.metricsService = metricsService;
      this.$eventBus = $eventBus;
      this.$scope = $scope.$parent;
      var duration = this.$scope.duration;
      this.scheduleSelfDestruction(duration);
    }
    (0, _createClass2.default)(InAppNotificationComponent, [{
      key: "$onInit",
      value: function $onInit() {
        var _this = this;
        this.action = this.$scope.action;
        this.icon_url = this.$scope.icon_url;
        (0, _assets.checkIfImageLoads)(this.icon_url).then(function (result) {
          return _this.iconError = !result;
        });
        this.content_color = this.$scope.content_color;
        this.title = this.$scope.title;
        this.subtitle = this.$scope.subtitle;
        var _this$$scope = this.$scope,
          background_color = _this$$scope.background_color,
          content_color = _this$$scope.content_color;
        this.innerEl = this.$element.find('.in-app-notification');
        this.innerEl.css('backgroundColor', background_color);
        this.innerEl.css('color', content_color);
        if (this.$scope.notificationId) {
          this.metricsService.trackAnalytics({
            name: 'view',
            document_id: this.$scope.notificationId,
            document_type: 'notification'
          });
        }
      }
    }, {
      key: "scheduleSelfDestruction",
      value: function scheduleSelfDestruction(duration) {
        this.$timeout(this.triggerSelfDestruction.bind(this), duration * 1000);
      }
    }, {
      key: "triggerSelfDestruction",
      value: function triggerSelfDestruction() {
        var _this2 = this;
        this.innerEl.on('animationend', function () {
          return _this2.performSelfDestruction();
        });
        this.isDestroyed = true;
      }
    }, {
      key: "performSelfDestruction",
      value: function performSelfDestruction() {
        this.$scope.$destroy();
        this.$element.remove();
      }
    }, {
      key: "onClick",
      value: function onClick() {
        var _this3 = this;
        if (!this.action || this.appscriptLoading || this.$scope.isDestroyed) {
          return;
        }
        this.appscriptLoading = true;
        var params = this.action.params;
        if (this.$scope.notificationId) {
          params = _objectSpread(_objectSpread({}, this.action.params), {}, {
            notification: {
              _id: this.$scope.notificationId
            }
          });
        }
        if (this.$scope.ctx === 'polls') {
          this.$eventBus.emit('video-pip:reopen-nav', params.id);
        }
        this.databaseService.runAppScript(this.action.path, params).then(function () {
          _this3.triggerSelfDestruction();
        }).catch(function (error) {
          return _this3.$log.error("[in-app-notification] An error occurred while processing appscript ".concat(_this3.action.path, ": ").concat(String(error)));
        }).finally(function () {
          _this3.appscriptLoading = false;
        });
      }
    }]);
    return InAppNotificationComponent;
  }()
};
exports.InAppNotificationComponent = InAppNotificationComponent;

},{"../../../utils/assets":350,"./in-app-notification.pug":91,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/defineProperty":378,"@babel/runtime/helpers/interopRequireDefault":382}],91:[function(require,module,exports){
module.exports = '<div class="in-app-notification no-click-effect" ng-class="{\'has-action\': $ctrl.action, \'destroyed\': $ctrl.isDestroyed }" ng-click="$ctrl.onClick()"><div class="icon-wrapper" ng-if="!$ctrl.iconError"><i icon="::$ctrl.icon_url" force-color="::$ctrl.content_color"></i></div><div class="text-wrapper"><div class="heading">{{ ::$ctrl.title }}</div><div class="message">{{ ::$ctrl.subtitle }}</div></div></div>';
},{}],92:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InAppNotificationModule = void 0;
var _inAppNotification = require("./in-app-notification.component");
var InAppNotificationModule = angular.module('maestro.components.common.in-app-notification', []).component('inAppNotification', _inAppNotification.InAppNotificationComponent).name;
exports.InAppNotificationModule = InAppNotificationModule;

},{"./in-app-notification.component":90}],93:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OfflineNotificationModule = void 0;
var _offlineNotification = require("./offline-notification.component");
var OfflineNotificationModule = angular.module('maestro.components.common.offline-notification', []).component('offlineNotification', _offlineNotification.OfflineNotificationComponent).name;
exports.OfflineNotificationModule = OfflineNotificationModule;

},{"./offline-notification.component":94}],94:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OfflineNotificationComponent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
var _i18nWithFallback = _interopRequireDefault(require("../../../utils/i18n-with-fallback"));
var MAX_AUTO_RECONNECT_ATTEMPTS = 5;
var OfflineNotificationComponent = {
  template: require('./offline-notification.jade'),
  controller: function () {
    OfflineNotificationComponent.$inject = ["offlineService", "signalService", "$i18n", "$scope"];
    /* @ngInject */
    function OfflineNotificationComponent(offlineService, signalService, $i18n, $scope) {
      (0, _classCallCheck2.default)(this, OfflineNotificationComponent);
      this.offlineService = offlineService;
      this.signalService = signalService;
      this.$scope = $scope;
      this.offline = false;
      this.pendingCall = false;
      this.signalConnected = true;
      this.signalReconnectAttempts = 0;
      this.permanentSignalDisconnected = false;
      this.labels = {
        offlineTitle: (0, _i18nWithFallback.default)($i18n, 'webapp_offline.offline'),
        offlineSubtitle: (0, _i18nWithFallback.default)($i18n, 'webapp_offline.pending_offline'),
        noSignalTitle: (0, _i18nWithFallback.default)($i18n, 'webapp_offline.no_signal_title', 'Something preventing the system from working.'),
        noSignalSubtitle: (0, _i18nWithFallback.default)($i18n, 'webapp_offline.no_signal_subtitle', 'Please refer to our troubleshooting article for guidance.'),
        reconnectButton: (0, _i18nWithFallback.default)($i18n, 'webapp_offline.reconnect', 'Try to refresh')
      };
    }
    (0, _createClass2.default)(OfflineNotificationComponent, [{
      key: "$onInit",
      value: function $onInit() {
        var _this = this;
        var onSignalStateChange = function onSignalStateChange() {
          return _this.$scope.$emit('error-banner:display', _this.showSignalReconnectMessage);
        };
        this.eventListeners = [this.offlineService.on('offline', function () {
          return _this.onOffline();
        }), this.offlineService.on('online', function () {
          return _this.onOnline();
        }), this.offlineService.on('offline:pending', function () {
          return _this.onPendingRequest();
        }), this.signalService.addEventListener('end', function () {
          return _this.onSignalDisconnection();
        }), this.signalService.addEventListener('open', function () {
          return _this.onSignalProofOfConnection();
        }), this.signalService.addEventListener('data', function () {
          return _this.onSignalProofOfConnection();
        }), this.$scope.$watch('$ctrl.showSignalReconnectMessage', onSignalStateChange, true)];
        onSignalStateChange();
      }
    }, {
      key: "showSignalReconnectMessage",
      get: function get() {
        return !this.pendingCall && this.permanentSignalDisconnected;
      }
    }, {
      key: "onSignalDisconnection",
      value: function onSignalDisconnection() {
        this.loading = false;
        this.signalConnected = false;
        if (this.signalReconnectAttempts < MAX_AUTO_RECONNECT_ATTEMPTS) {
          console.warn('[OfflineNotification] Signal disconnected, reconnecting...');
          this.reconnectSignal();
        } else {
          console.error('[OfflineNotification] Signal permanently disconnected, prompting user to reconnect');
          this.permanentSignalDisconnected = true;
        }
      }
    }, {
      key: "onSignalProofOfConnection",
      value: function onSignalProofOfConnection() {
        this.loading = false;
        this.signalConnected = true;
        this.signalReconnectAttempts = 0;
        this.offline = false;
        this.pendingCall = false;
        this.permanentSignalDisconnected = false;
      }
    }, {
      key: "onOffline",
      value: function onOffline() {
        this.offline = true;
      }
    }, {
      key: "onOnline",
      value: function onOnline() {
        this.offline = false;
        this.pendingCall = false;
        this.reconnectSignal({
          delay: 0,
          jitter: 0
        });
      }
    }, {
      key: "onPendingRequest",
      value: function onPendingRequest() {
        this.pendingCall = true;
      }
    }, {
      key: "reconnectSignal",
      value: function reconnectSignal() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          delay = _ref.delay,
          jitter = _ref.jitter;
        if (this.signalConnected) {
          this.loading = false;
          return;
        }
        this.signalReconnectAttempts++;
        this.loading = true;
        this.signalService.restart({
          delay: delay,
          jitter: jitter
        });
      }
    }, {
      key: "$onDestroy",
      value: function $onDestroy() {
        (0, _lodash.each)(this.eventListeners, function (unsub) {
          return unsub();
        });
      }
    }]);
    return OfflineNotificationComponent;
  }()
};
exports.OfflineNotificationComponent = OfflineNotificationComponent;

},{"../../../utils/i18n-with-fallback":359,"./offline-notification.jade":95,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"lodash":"lodash"}],95:[function(require,module,exports){
module.exports = '<div class="offline-notification-websocket" ng-if="$ctrl.showSignalReconnectMessage"><span>{{ $ctrl.labels.noSignalTitle }}&nbsp;</span><a href="https://support.spotme.com/hc/en-us/articles/360052063893" target="_blank">{{ $ctrl.labels.noSignalSubtitle }}</a><button ng-if="!$ctrl.loading" ng-click="$ctrl.reconnectSignal({ delay: 0 })">{{ $ctrl.labels.reconnectButton }}</button><div class="loading-placeholder" ng-if="$ctrl.loading"><i class="icon-loader"></i></div></div><div class="offline-notification animated flash infinite" ng-if="$ctrl.offline &amp;&amp; !$ctrl.pendingCall"><i class="icon-warning" title="{{::(&quot;webapp_offline.offline&quot; | i18n)}}"></i></div><div class="offline-pending-call animated fadeIn" ng-if="$ctrl.pendingCall"><div><i class="icon-warning"></i><span>{{ $ctrl.labels.offlineTitle }}</span><div class="subtitle">{{ $ctrl.labels.offlineSubtitle }}</div></div></div>';
},{}],96:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PipModule = void 0;
var _pip = require("./pip.component");
var _pipControls = require("./pip-controls.component");
var PipModule = angular.module('maestro.components.common.pip', []).component('pip', _pip.PipComponent).component('pipControls', _pipControls.PipControlsComponent).name;
exports.PipModule = PipModule;

},{"./pip-controls.component":97,"./pip.component":99}],97:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PipControlsComponent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var PipControlsComponent = {
  template: require('./pip-controls.jade'),
  bindings: {},
  controller: function () {
    PipControls.$inject = ["$eventBus", "$scope"];
    /* @ngInject */function PipControls($eventBus, $scope) {
      (0, _classCallCheck2.default)(this, PipControls);
      this.$eventBus = $eventBus;
      this.$scope = $scope;
    }
    (0, _createClass2.default)(PipControls, [{
      key: "reattach",
      value: function reattach() {
        this.$eventBus.emit('video-pip:reopen-nav');
      }
    }, {
      key: "close",
      value: function close() {
        this.$scope.$emit('pip:close');
      }
    }]);
    return PipControls;
  }()
};
exports.PipControlsComponent = PipControlsComponent;

},{"./pip-controls.jade":98,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382}],98:[function(require,module,exports){
module.exports = '<div class="pip-controls"><div class="area-controls"><i class="reattach-btn icon-pip-out" ng-click="$ctrl.reattach()"></i></div><i class="close-btn icon-cross" ng-click="$ctrl.close()"></i></div>';
},{}],99:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PipComponent = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
var _promise = require("../../../utils/promise");
var _url = require("../../../utils/url");
var _dom = require("../../../utils/dom");
var _audioTimer = require("../../../utils/audioTimer");
require("frontend-video-player/webcomponent");
var _time = require("../../../utils/time");
var _assets = require("../../../utils/assets");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var START_BROADCAST_DELAY_WINDOW = 45;
var STOP_BROADCAST_DELAY_WINDOW = 90;
var PipComponent = {
  template: require('./pip.jade'),
  bindings: {
    config: '<',
    onClose: '&',
    analytics: '<'
  },
  controller: function () {
    PipComponent.$inject = ["EVENT", "$element", "$eventBus", "$filter", "$sce", "$scope", "pictureInPictureService", "signalService", "libLoaderService", "liveStreamService", "triggerService", "websocketConnectionReportingService", "$rootScope", "videoPlayerService", "visibilityService", "offlineService"];
    /* @ngInject */function PipComponent(EVENT, $element, $eventBus, $filter, $sce, $scope, pictureInPictureService, signalService, libLoaderService, liveStreamService, triggerService, websocketConnectionReportingService, $rootScope, videoPlayerService, visibilityService, offlineService) {
      (0, _classCallCheck2.default)(this, PipComponent);
      this.$element = $element;
      this.$eventBus = $eventBus;
      this.$filter = $filter;
      this.$sce = $sce;
      this.$scope = $scope;
      this.isWebinar = EVENT.is_webinar;
      this.pictureInPictureService = pictureInPictureService;
      this.signalService = signalService;
      this.libLoaderService = libLoaderService;
      this.liveStreamService = liveStreamService;
      this.triggerService = triggerService;
      this.visibilityService = visibilityService;
      this.offlineService = offlineService;
      this.videoPlayerService = videoPlayerService;
      this.websocketConnectionReportingService = websocketConnectionReportingService;
      this.broadcastStarted = false;
      this.isIframeContent = false;
      this.ready = false;
      this.oldUrl = '';
      this.hasReceivedCookies = false;
      this.useMetadata = false;
      this.isSafari = $rootScope.device.browser === 'Safari';
      this.listeners = [];
      this.signalListeners = {};
      try {
        this.isLocalDevNode = "production" === 'dev';
      } catch (e) {
        console.log(e);
      }
    }
    (0, _createClass2.default)(PipComponent, [{
      key: "$onInit",
      value: function () {
        var _$onInit = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee3() {
          var _this = this;
          return _regenerator.default.wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                console.log('[PipComponent] init', this.config);
                this.websocketConnectionReportingService.setLiveStreamId(this.liveStreamId);
                this.reloadConfigDebounced = (0, _promise.debounceAndUnique)(this.reloadConfig.bind(this), 5000, 5000);
                this.listeners.push(this.$scope.$on('theatreMode:on', function () {
                  return _this.maximise();
                }), this.$scope.$on('theatreMode:off', function () {
                  return _this.minimise();
                }), this.$eventBus.on('theatreMode:off', function () {
                  return _this.minimise();
                }), this.$scope.$on('pip:close', function () {
                  return _this.close();
                }), this.$scope.$on('isSmallScreen', function (event, isSmallScreen) {
                  isSmallScreen ? _this.$element.addClass('is-small-screen') : _this.$element.removeClass('is-small-screen');
                }), this.$scope.$on('hasSideBar', function (event, hasSideBar) {
                  hasSideBar ? _this.$element.addClass('has-side-bar') : _this.$element.removeClass('has-side-bar');
                }), this.$scope.$on('live-stream:start-broadcast-from-id3', function () {
                  if (!_this.isThirdParty) {
                    console.log('[PipComponent] start broadcast from id3');
                    _this.onStartBroadcast();
                  }
                }), this.$scope.$on('live-stream:stop-broadcast-from-id3', function () {
                  if (!_this.isThirdParty) {
                    console.log('[PipComponent] stop broadcast from id3');
                    _this.onStopBroadcast();
                  }
                }), this.$eventBus.on('notification:in-app', function () {
                  if (_this.isIframeContent && document.fullscreenElement) {
                    (0, _dom.exitNativeFullscreen)();
                  }
                }), this.$eventBus.on('pip:reset', (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee() {
                  return _regenerator.default.wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return _this.reset();
                      case 2:
                        return _context.abrupt("return", _context.sent);
                      case 3:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }))), this.$scope.$watch('$ctrl.config', function () {
                  _this.resolvePlayerRendering();
                  _this.setupExpirationHook();
                  _this.checkForSignalCleanup();
                }, true), (0, _dom.addEventListener)(window, 'unload', function () {
                  return _this.liveStreamService.sendStopWatching(_this.liveStreamId);
                }), this.triggerService.addTrigger('forceConfigReload', (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee2() {
                  return _regenerator.default.wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        _this.reloadConfig();
                      case 1:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2);
                }))), this.triggerService.addTrigger('fakeIsLiveID3', function (isLive) {
                  isLive ? _this.onStartBroadcast() : _this.onStopBroadcast();
                }), this.visibilityService.on('visible', function () {
                  if (!_this.broadcastStarted) {
                    _this.reloadConfigDebounced();
                  }
                }), this.offlineService.on('online', function () {
                  if (!_this.broadcastStarted) {
                    _this.reloadConfigDebounced();
                  }
                }));
                this.isThirdParty = this.config.isThirdParty;
                this.isInPerson = this.liveStreamService.isInPerson(this.config);
                this.isInPerson ? this.$element.removeClass('with-stream') : this.$element.addClass('with-stream');
                this.needsCookies = this.liveStreamService.needsAuthCookies(this.config);
                this.hasReceivedCookies = !!this.config.cookies;
                this.latestKnownDocVersion = (0, _lodash.get)(this.config, 'version', 0);
                _context3.next = 12;
                return this.initSignals();
              case 12:
                _context3.next = 14;
                return this.resolveSigning({
                  newConfig: this.config
                });
              case 14:
                _context3.next = 16;
                return this.applyConfig(this.config);
              case 16:
                this.liveStreamService.sendStartWatching(this.liveStreamId);
              case 17:
              case "end":
                return _context3.stop();
            }
          }, _callee3, this);
        }));
        function $onInit() {
          return _$onInit.apply(this, arguments);
        }
        return $onInit;
      }()
    }, {
      key: "liveStreamId",
      get: function get() {
        return (0, _lodash.get)(this, 'config.liveStreamId');
      }
    }, {
      key: "isFinished",
      get: function get() {
        return this.liveStreamService.isFinished(this.config);
      }
    }, {
      key: "reset",
      value: function () {
        var _reset = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee4() {
          return _regenerator.default.wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                this.ready = false;
                this.$onDestroy();
                _context4.next = 4;
                return this.reloadConfig();
              case 4:
                _context4.next = 6;
                return this.$onInit();
              case 6:
                this.ready = true;
              case 7:
              case "end":
                return _context4.stop();
            }
          }, _callee4, this);
        }));
        function reset() {
          return _reset.apply(this, arguments);
        }
        return reset;
      }()
    }, {
      key: "shouldRegisterToSignals",
      value: function shouldRegisterToSignals() {
        if (this.isThirdParty) {
          return true;
        }
        if (this.broadcastStarted) {
          return true;
        }
        return !this.isFinished;
      }
    }, {
      key: "initSignals",
      value: function () {
        var _initSignals = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee5() {
          var _this2 = this;
          return _regenerator.default.wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                if (this.shouldRegisterToSignals()) {
                  _context5.next = 2;
                  break;
                }
                return _context5.abrupt("return");
              case 2:
                _context5.next = 4;
                return this.signalService.addSignalListener("liveStream/".concat(this.liveStreamId, "/appUpdate"), function (data) {
                  return _this2.onNewLiveStreamDoc({
                    liveStreamDoc: data.liveStream
                  });
                });
              case 4:
                this.signalListeners['onUpdate'] = _context5.sent;
                _context5.next = 7;
                return this.signalService.addEventListener('open', function () {
                  return _this2.reloadConfigDebounced();
                });
              case 7:
                this.signalListeners['onConnection'] = _context5.sent;
              case 8:
              case "end":
                return _context5.stop();
            }
          }, _callee5, this);
        }));
        function initSignals() {
          return _initSignals.apply(this, arguments);
        }
        return initSignals;
      }()
    }, {
      key: "checkForSignalCleanup",
      value: function checkForSignalCleanup() {
        if (this.shouldRegisterToSignals()) return;
        (0, _lodash.get)(this.signalListeners, 'onUpdate', function () {})();
        (0, _lodash.get)(this.signalListeners, 'onConnection', function () {})();
        this.signalListeners = {};
      }
    }, {
      key: "onStartBroadcast",
      value: function onStartBroadcast() {
        console.log('[PipComponent] start broadcast');
        if (this.broadcastStarted || this.isFinished) {
          return;
        }
        this.broadcastStarted = true;
        clearTimeout(this.stopBroadcastTimeout);
        this.clearDoubleTimeout();
        this.$scope.$applyAsync();
      }
    }, {
      key: "onStopBroadcast",
      value: function onStopBroadcast() {
        console.log('[PipComponent] stop broadcast');
        if (!this.broadcastStarted) {
          return;
        }
        clearTimeout(this.stopBroadcastTimeout);
        this.clearDoubleTimeout();
        this.broadcastStarted = false;
        if (this.isFinished) {
          this.config.url = '';
          this.sourceUrl = '';
          this.oldUrl = '';
        } else {
          this.$scope.$broadcast('video-player:premature-stop');
        }
        this.$scope.$applyAsync();
      }
    }, {
      key: "setupExpirationHook",
      value: function setupExpirationHook() {
        var _this3 = this;
        var expires = (0, _lodash.get)(this.config, 'expires');
        if (expires) {
          clearTimeout(this.updateConfTimeout);
          var now = Date.now();
          var timeout = expires * 1000 - now - 30000;
          console.log('[PipComponent] Video config will be refreshed at', new Date(now + timeout));
          this.updateConfTimeout = setTimeout(function () {
            _this3.reloadConfig();
          }, timeout);
        }
      }
    }, {
      key: "onNewLiveStreamDoc",
      value: function () {
        var _onNewLiveStreamDoc = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee6(_ref3) {
          var liveStreamDoc, newConfig, needsSigning, doesNewOneHaveHigherVersion;
          return _regenerator.default.wrap(function _callee6$(_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                liveStreamDoc = _ref3.liveStreamDoc;
                console.log('[PipComponent] received new live stream doc', liveStreamDoc);
                newConfig = this.liveStreamService.getConfigFromLiveStreamDoc(liveStreamDoc);
                if (!(this.liveStreamId !== (0, _lodash.get)(newConfig, 'liveStreamId'))) {
                  _context6.next = 5;
                  break;
                }
                return _context6.abrupt("return");
              case 5:
                this.latestKnownDocVersion = (0, _lodash.get)(newConfig, 'version', 0);
                _context6.next = 8;
                return this.resolveSigning({
                  newConfig: newConfig
                });
              case 8:
                needsSigning = _context6.sent;
                if (!needsSigning) {
                  _context6.next = 13;
                  break;
                }
                this.resolveUseMetadata(newConfig);
                this.$scope.$applyAsync();
                return _context6.abrupt("return");
              case 13:
                doesNewOneHaveHigherVersion = (0, _lodash.get)(this, 'config.version', 0) < (0, _lodash.get)(newConfig, 'version', 0);
                if (doesNewOneHaveHigherVersion) {
                  _context6.next = 16;
                  break;
                }
                return _context6.abrupt("return");
              case 16:
                _context6.next = 18;
                return this.applyConfig(newConfig);
              case 18:
              case "end":
                return _context6.stop();
            }
          }, _callee6, this);
        }));
        function onNewLiveStreamDoc(_x) {
          return _onNewLiveStreamDoc.apply(this, arguments);
        }
        return onNewLiveStreamDoc;
      }()
    }, {
      key: "resolveUseMetadata",
      value: function resolveUseMetadata(config) {
        if (this.isInPerson || this.isThirdParty || this.isLocalDevNode) {
          this.useMetadata = false;
          return;
        }
        var isVod = this.liveStreamService.isVod(config);
        var isLive = this.liveStreamService.isLive(config);
        this.useMetadata = isVod || this.broadcastStarted || isLive || this.isFinished;
      }
    }, {
      key: "resolveSigning",
      value: function () {
        var _resolveSigning = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee7(_ref4) {
          var newConfig;
          return _regenerator.default.wrap(function _callee7$(_context7) {
            while (1) switch (_context7.prev = _context7.next) {
              case 0:
                newConfig = _ref4.newConfig;
                if (this.needsCookies) {
                  _context7.next = 3;
                  break;
                }
                return _context7.abrupt("return", false);
              case 3:
                if (!(newConfig.cookies && newConfig.url)) {
                  _context7.next = 7;
                  break;
                }
                _context7.next = 6;
                return this.onNewUrl(newConfig.url);
              case 6:
                return _context7.abrupt("return", false);
              case 7:
                if (!(!this.hasReceivedCookies && newConfig.is_live)) {
                  _context7.next = 11;
                  break;
                }
                console.log('[PipComponent] fetching self signing url for live stream');
                this.reloadConfigDebounced();
                return _context7.abrupt("return", true);
              case 11:
                return _context7.abrupt("return", false);
              case 12:
              case "end":
                return _context7.stop();
            }
          }, _callee7, this);
        }));
        function resolveSigning(_x2) {
          return _resolveSigning.apply(this, arguments);
        }
        return resolveSigning;
      }()
    }, {
      key: "resolvePlayerRendering",
      value: function resolvePlayerRendering() {
        if (this.isWebinar) {
          return;
        }
        var shouldRenderPlayer = this.liveStreamService.isToggleStreamTabEnabled(this.config) || !this.isInPerson || (0, _lodash.get)(this.config, 'qna', false) || (0, _lodash.get)(this.config, 'polls_enabled', false);
        shouldRenderPlayer ? this.pictureInPictureService.show() : this.pictureInPictureService.hide();
      }
    }, {
      key: "$onDestroy",
      value: function $onDestroy() {
        var _this$listeners,
          _this4 = this;
        this.liveStreamService.sendStopWatching(this.liveStreamId);
        this.websocketConnectionReportingService.setLiveStreamId(undefined);
        clearTimeout(this.updateConfTimeout);
        clearTimeout(this.stopBroadcastTimeout);
        this.clearDoubleTimeout();
        (_this$listeners = this.listeners).push.apply(_this$listeners, (0, _toConsumableArray2.default)(Object.keys(this.signalListeners).map(function (key) {
          return _this4.signalListeners[key];
        })));
        var _iterator = _createForOfIteratorHelper(this.listeners),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var unsub = _step.value;
            if ((0, _lodash.isFunction)(unsub)) {
              unsub();
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }, {
      key: "reloadConfig",
      value: function () {
        var _reloadConfig = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee8() {
          var _this5 = this;
          var liveStreamDoc;
          return _regenerator.default.wrap(function _callee8$(_context8) {
            while (1) switch (_context8.prev = _context8.next) {
              case 0:
                console.log('[PipComponent] reload config');
                if (this.liveStreamId) {
                  _context8.next = 4;
                  break;
                }
                console.warn('[PipComponent] Cannot reload config because liveStreamId is not set');
                return _context8.abrupt("return");
              case 4:
                _context8.next = 6;
                return this.liveStreamService.loadConfiguration(this.liveStreamId, this.latestKnownDocVersion).catch(function (err) {
                  console.error('[PipComponent] Failed to fetch live stream doc', err);
                  if (err.status === 404) {
                    _this5.config.is_deleted = true;
                  } else {
                    throw err;
                  }
                });
              case 6:
                liveStreamDoc = _context8.sent;
                this.config.version = 0;
                _context8.next = 10;
                return this.onNewLiveStreamDoc({
                  liveStreamDoc: liveStreamDoc
                });
              case 10:
              case "end":
                return _context8.stop();
            }
          }, _callee8, this);
        }));
        function reloadConfig() {
          return _reloadConfig.apply(this, arguments);
        }
        return reloadConfig;
      }()
    }, {
      key: "clearDoubleTimeout",
      value: function clearDoubleTimeout() {
        clearTimeout(this.startBroadcastTimeout);
        if ((0, _lodash.isFunction)(this.killStartBroadcastAudioTimer)) {
          this.killStartBroadcastAudioTimer();
        }
        this.startBroadcastTimeout = null;
        this.killStartBroadcastAudioTimer = null;
      }
    }, {
      key: "setDoubleStartTimeout",
      value: function setDoubleStartTimeout(delay) {
        var _this6 = this;
        this.clearDoubleTimeout();
        var handler = function handler() {
          console.log('[PipComponent] start broadcast after timeout');
          _this6.clearDoubleTimeout();
          _this6.onStartBroadcast();
        };
        this.startBroadcastTimeout = setTimeout(handler, delay);
        this.killStartBroadcastAudioTimer = (0, _audioTimer.timer)(handler, delay);
      }
    }, {
      key: "applyConfig",
      value: function () {
        var _applyConfig = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee9(config) {
          var oldConfig;
          return _regenerator.default.wrap(function _callee9$(_context9) {
            while (1) switch (_context9.prev = _context9.next) {
              case 0:
                console.log('[PipComponent] apply config', config, this.config);
                _context9.next = 3;
                return this.importHive(config);
              case 3:
                oldConfig = (0, _lodash.cloneDeep)(this.config);
                this.config = config;
                if (!config.resolved_session_type) {
                  this.config.multicast_session_id = oldConfig.multicast_session_id;
                  this.config.live_captions_labels = oldConfig.live_captions_labels;
                  this.config.resolved_session_type = oldConfig.resolved_session_type;
                }
                this.resolveBroadcastState({
                  oldConfig: oldConfig,
                  newConfig: config
                });
                this.resolveUseMetadata(this.config);
                if (this.needsCookies) {
                  _context9.next = 11;
                  break;
                }
                _context9.next = 11;
                return this.onNewUrl(config.url);
              case 11:
                if (this.config.is_deleted) {
                  this.close();
                }
                this.ready = true;
                this.$scope.$applyAsync();
              case 14:
              case "end":
                return _context9.stop();
            }
          }, _callee9, this);
        }));
        function applyConfig(_x3) {
          return _applyConfig.apply(this, arguments);
        }
        return applyConfig;
      }()
    }, {
      key: "importHive",
      value: function () {
        var _importHive = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee10() {
          return _regenerator.default.wrap(function _callee10$(_context10) {
            while (1) switch (_context10.prev = _context10.next) {
              case 0:
                if ((0, _lodash.get)(this, 'config.hiveConfig.jwt')) {
                  _context10.next = 2;
                  break;
                }
                return _context10.abrupt("return");
              case 2:
                _context10.next = 4;
                return this.libLoaderService.load(_assets.getStaticAsset, 'hiveHls').catch(function (err) {
                  return console.error('[PipComponent] could not load hiveHls', err);
                });
              case 4:
                _context10.next = 6;
                return this.libLoaderService.load(_assets.getStaticAsset, 'hive').catch(function (err) {
                  return console.error('[PipComponent] could not load hive', err);
                });
              case 6:
              case "end":
                return _context10.stop();
            }
          }, _callee10, this);
        }));
        function importHive() {
          return _importHive.apply(this, arguments);
        }
        return importHive;
      }()
    }, {
      key: "resolveBroadcastState",
      value: function resolveBroadcastState(_ref5) {
        var _this7 = this;
        var oldConfig = _ref5.oldConfig,
          newConfig = _ref5.newConfig;
        var nowTimestamp = (0, _time.nowUnixTimestamp)();
        if (!this.broadcastStarted && newConfig.is_live && !newConfig.is_finished) {
          var isStarting = !oldConfig.is_live;
          var hasStartedALongTimeAgo = newConfig.is_live_timestamp < nowTimestamp - START_BROADCAST_DELAY_WINDOW;
          var hasJustStarted = !hasStartedALongTimeAgo;
          if (hasStartedALongTimeAgo || this.isThirdParty) {
            console.info("[PipComponent] Stream went live more than ".concat(START_BROADCAST_DELAY_WINDOW, " secs ago or is thirdParty. Starting player"));
            this.onStartBroadcast(newConfig);
          } else if (isStarting || hasJustStarted) {
            console.info("[PipComponent] Start broadcast action will be scheduled for ".concat(START_BROADCAST_DELAY_WINDOW, "s after is_live_timestamp if not triggered before."));
            var delayBeforeEndOfDelayWindow = newConfig.is_live_timestamp + START_BROADCAST_DELAY_WINDOW - nowTimestamp;
            this.setDoubleStartTimeout(delayBeforeEndOfDelayWindow * 1000);
          }
        } else if (this.broadcastStarted && !newConfig.is_live && (newConfig.is_finished || this.isThirdParty)) {
          var isStopping = !oldConfig.is_finished;
          var hasStoppedALongTimeAgo = newConfig.is_finished_timestamp < nowTimestamp - STOP_BROADCAST_DELAY_WINDOW;
          var hasJustStopped = !hasStoppedALongTimeAgo;
          if (hasStoppedALongTimeAgo || this.isThirdParty) {
            console.info("[PipComponent] stopped live more than ".concat(STOP_BROADCAST_DELAY_WINDOW, " secs ago or Third party stream or Id3 not supported, stopping player."));
            this.onStopBroadcast(newConfig);
          }
          if (isStopping || hasJustStopped) {
            console.info("[PipComponent] Stop broadcast action will be scheduled in ".concat(STOP_BROADCAST_DELAY_WINDOW, "s if not triggered before."));
            this.stopBroadcastTimeout = setTimeout(function () {
              console.log('[PipComponent] stop broadcast after timeout');
              _this7.onStopBroadcast();
            }, STOP_BROADCAST_DELAY_WINDOW * 1000);
          }
        }
      }
    }, {
      key: "onNewUrl",
      value: function () {
        var _onNewUrl = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee11(newUrl) {
          var prevReferrerVal;
          return _regenerator.default.wrap(function _callee11$(_context11) {
            while (1) switch (_context11.prev = _context11.next) {
              case 0:
                console.log('[PipComponent] onNewUrl', {
                  newUrl: newUrl,
                  oldUrl: this.oldUrl
                });
                if (newUrl) {
                  _context11.next = 5;
                  break;
                }
                this.sourceUrl = '';
                this.oldUrl = newUrl;
                return _context11.abrupt("return");
              case 5:
                if (!(0, _url.isSameUrlWithoutQuery)(newUrl, this.oldUrl)) {
                  _context11.next = 12;
                  break;
                }
                console.log('[PipComponent] same url, not updating the sourceUrl');
                if (!(newUrl && this.needsCookies)) {
                  _context11.next = 11;
                  break;
                }
                _context11.next = 10;
                return this.videoPlayerService.getCookies(newUrl);
              case 10:
                this.hasReceivedCookies = true;
              case 11:
                return _context11.abrupt("return");
              case 12:
                this.oldUrl = newUrl;
                if (this.isSafari) {
                  _context11.next = 17;
                  break;
                }
                _context11.next = 16;
                return this.setMedia(newUrl);
              case 16:
                return _context11.abrupt("return", _context11.sent);
              case 17:
                prevReferrerVal = (0, _dom.replaceReferrer)('origin');
                _context11.next = 20;
                return this.setMedia(newUrl);
              case 20:
                angular.element(function () {
                  return (0, _dom.replaceReferrer)(prevReferrerVal);
                });
              case 21:
              case "end":
                return _context11.stop();
            }
          }, _callee11, this);
        }));
        function onNewUrl(_x4) {
          return _onNewUrl.apply(this, arguments);
        }
        return onNewUrl;
      }()
    }, {
      key: "setMedia",
      value: function () {
        var _setMedia = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee12(url) {
          var sourceUrl, embedable;
          return _regenerator.default.wrap(function _callee12$(_context12) {
            while (1) switch (_context12.prev = _context12.next) {
              case 0:
                console.log('[PipComponent] set media', {
                  url: url
                });
                if (url) {
                  _context12.next = 3;
                  break;
                }
                return _context12.abrupt("return");
              case 3:
                sourceUrl = url.toString();
                this.isIframeContent = !(0, _url.isPlayableVideoUrl)(sourceUrl);
                if (!this.isIframeContent) {
                  _context12.next = 9;
                  break;
                }
                embedable = (0, _url.convertEmbedableUrl)(sourceUrl);
                this.sourceUrl = this.$sce.trustAsResourceUrl(embedable);
                return _context12.abrupt("return");
              case 9:
                _context12.next = 11;
                return this.videoPlayerService.getCookies(sourceUrl);
              case 11:
                this.sourceUrl = _context12.sent;
                this.hasReceivedCookies = true;
              case 13:
              case "end":
                return _context12.stop();
            }
          }, _callee12, this);
        }));
        function setMedia(_x5) {
          return _setMedia.apply(this, arguments);
        }
        return setMedia;
      }()
    }, {
      key: "maximise",
      value: function maximise() {
        if (this.pictureInPictureService.isFloating) {
          this.pictureInPictureService.embed();
        }
        if (this.$element.is('.pinned')) {
          this.positionToRestore = {
            top: this.$element.css('top'),
            left: this.$element.css('left')
          };
        } else {
          this.positionToRestore = null;
        }
        this.$element.css({
          top: '',
          left: ''
        }).addClass('maximized');
        this.$eventBus.emit('theatreMode:enabled');
      }
    }, {
      key: "minimise",
      value: function minimise() {
        if (this.isWebinar) return;
        if (this.positionToRestore) {
          this.$element.css(this.positionToRestore);
          delete this.positionToRestore;
        }
        this.$element.removeClass('maximized');
        this.$eventBus.emit('theatreMode:disabled');
      }
    }, {
      key: "close",
      value: function close() {
        this.$eventBus.emit('theatreMode:disabled');
        this.pictureInPictureService.embed();
        this.onClose();
      }
    }]);
    return PipComponent;
  }()
};
exports.PipComponent = PipComponent;

},{"../../../utils/assets":350,"../../../utils/audioTimer":351,"../../../utils/dom":355,"../../../utils/promise":365,"../../../utils/time":367,"../../../utils/url":369,"./pip.jade":100,"@babel/runtime/helpers/asyncToGenerator":375,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/helpers/toConsumableArray":393,"@babel/runtime/regenerator":398,"frontend-video-player/webcomponent":1106,"lodash":"lodash"}],100:[function(require,module,exports){
module.exports = '<pip-controls ng-if="!$ctrl.isWebinar"></pip-controls><div class="iframe-container"><webinar-header class="show-webinar-header" ng-if="$ctrl.EVENT.is_webinar &amp;&amp; $ctrl.shouldShowCountDown()"></webinar-header><video-player ng-if="$ctrl.ready" source-url="$ctrl.sourceUrl" config="$ctrl.config" broadcast-started="$ctrl.broadcastStarted" is-iframe-content="$ctrl.isIframeContent" use-metadata="$ctrl.useMetadata" autoplay="true"></video-player></div>';
},{}],101:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SuggestionsModule = void 0;
var _suggestions = require("./suggestions.component");
var SuggestionsModule = angular.module('maestro.components.common.suggestions', []).component('suggestions', _suggestions.SuggestionsComponent).name;
exports.SuggestionsModule = SuggestionsModule;

},{"./suggestions.component":102}],102:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SuggestionsComponent = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
var _i18nWithFallback = _interopRequireDefault(require("../../../utils/i18n-with-fallback"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var SuggestionsComponent = {
  bindings: {
    disabled: '<',
    documents: '=',
    ds: '<',
    error: '=',
    invalid: '<',
    exclusions: '<',
    fieldIcon: '@',
    fieldName: '@',
    placeholder: '@',
    representation: '<',
    representationSub: '<',
    autofocus: '<',
    max: '<',
    allowMissing: '<',
    createNewLabel: '<',
    createNewAction: '<',
    searchParams: '<'
  },
  template: require('./suggestions.pug'),
  controller: function () {
    SuggestionsComponent.$inject = ["SETTINGS", "dataSourceEvaluatorService", "progressBarService", "databaseService", "navService", "$scope", "$element", "$i18n"];
    /* @ngInject */
    function SuggestionsComponent(SETTINGS, dataSourceEvaluatorService, progressBarService, databaseService, navService, $scope, $element, $i18n) {
      (0, _classCallCheck2.default)(this, SuggestionsComponent);
      this.dses = dataSourceEvaluatorService;
      this.progressBarService = progressBarService;
      this.databaseService = databaseService;
      this.$scope = $scope;
      this.exclusions = this.exclusions || [];
      this.el = $element;
      this.doc_suggestions = [];
      this.$i18n = $i18n;
      this.settings = SETTINGS;
      this.navService = navService;
      this.labels = {
        email_missing: (0, _i18nWithFallback.default)(this.$i18n, 'suggestions.email_missing', 'Email is missing from the profile. Please edit the profile to schedule the meeting.')
      };
    }
    (0, _createClass2.default)(SuggestionsComponent, [{
      key: "$onInit",
      value: function $onInit() {
        console.info('[SuggestionsComponent] init');
        if (this.autofocus) {
          this.el.find('input').focus();
        }
      }
    }, {
      key: "$onDestroy",
      value: function $onDestroy() {
        console.info('[SuggestionsComponent] destroying');
        this.removeSuggestions();
      }
    }, {
      key: "reset",
      value: function reset() {
        this.documents = [];
        this.doc_suggestions = [];
      }
    }, {
      key: "searchDocuments",
      value: function searchDocuments() {
        this.doc_suggestions = [];
        var term = (this.doc || '').trim().toLowerCase();
        if (term.length === 0) {
          this.removeSuggestions(true);
          return;
        }
        this.checkInput(term);
      }
    }, {
      key: "checkInput",
      value: function checkInput(term) {
        var _this = this;
        if ((0, _lodash.isFunction)(this.allowMissing)) {
          var item = this.allowMissing(term);
          if (item) {
            this.doc_suggestions = [item];
            return;
          }
        }
        this.progressBarService.startTask();
        this.dses.eval(this.ds, _objectSpread({
          searchTerm: term
        }, this.searchParams)).then(function (resp) {
          var docs = (0, _lodash.map)(resp, function (row) {
            return row.doc;
          });
          _this.doc_suggestions = (0, _lodash.uniq)(docs, '_id');
          angular.element('body').on('click.docs-sugg', function (e) {
            var target = angular.element(e.target);
            if (!target.is('.doc, input.docs')) {
              _this.removeSuggestions(true);
            }
          });
          _this.clearSuggestions();
        }).finally(function () {
          return _this.progressBarService.finishTask();
        });
      }
    }, {
      key: "selectDoc",
      value: function selectDoc(doc) {
        if (this.documents.length >= this.max) return;
        var valueAlreadyPresent = this.documents.some(function (d) {
          var email = d.email,
            id = d.id,
            _id = d._id;
          return _id && _id === doc._id || id && id === doc.id || email && email.length && email === doc.email;
        });
        if (valueAlreadyPresent) {
          this.clearSuggestions();
          return;
        }
        this.documents.push(doc);
        this.removeSuggestions();
        document.querySelector('suggestions input').focus();
        if (this.documents.length >= this.max) {
          this.full = true;
        }
      }
    }, {
      key: "selectDocOnEnter",
      value: function selectDocOnEnter(doc) {
        if (event.keyCode === 13) {
          this.selectDoc(doc);
        }
      }
    }, {
      key: "removeDoc",
      value: function removeDoc(doc) {
        (0, _lodash.remove)(this.documents, doc);
        if (this.documents.length < this.max) {
          this.full = false;
        }
      }
    }, {
      key: "editDoc",
      value: function editDoc(doc) {
        var _doc$_id;
        this.$scope.$emit('editParticipant', (_doc$_id = doc._id) !== null && _doc$_id !== void 0 ? _doc$_id : doc.id);
      }
    }, {
      key: "removeDocOnEnter",
      value: function removeDocOnEnter(doc) {
        if (event.keyCode === 13) {
          this.removeDoc(doc);
        }
      }
    }, {
      key: "clearSuggestions",
      value: function clearSuggestions() {
        var _this2 = this;
        var ids = (0, _lodash.map)(this.documents, function (d) {
          return d._id || d.id;
        }) || [];
        this.doc_suggestions = (0, _lodash.reject)(this.doc_suggestions, function (s) {
          return ids.indexOf(s._id || s.id) !== -1 || _this2.exclusions.indexOf(s._id || s.id) !== -1;
        });
      }
    }, {
      key: "removeSuggestions",
      value: function removeSuggestions(digest) {
        this.doc = '';
        this.doc_suggestions = [];
        angular.element('body').off('click.docs-sugg');
        if (digest) {
          this.$scope.$apply();
        }
      }
    }, {
      key: "itemsCount",
      value: function itemsCount() {
        return (this.documents || []).length;
      }
    }, {
      key: "onKeyUp",
      value: function onKeyUp(event) {
        if (event.keyCode === 13 && this.doc_suggestions.length) {
          event.stopPropagation();
          event.preventDefault();
          this.selectDoc(this.doc_suggestions[0]);
        }
      }
    }, {
      key: "onKeyDown",
      value: function onKeyDown(event) {
        if (event.keyCode === 13 && this.doc_suggestions.length) {
          event.stopPropagation();
          event.preventDefault();
        }
      }
    }]);
    return SuggestionsComponent;
  }()
};
exports.SuggestionsComponent = SuggestionsComponent;

},{"../../../utils/i18n-with-fallback":359,"./suggestions.pug":103,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/defineProperty":378,"@babel/runtime/helpers/interopRequireDefault":382,"lodash":"lodash"}],103:[function(require,module,exports){
module.exports = '<div class="form-group suggestions"><i ng-class="$ctrl.fieldIcon"></i><input class="form-control docs" ng-on-keydown="$ctrl.onKeyDown($event)" ng-on-keyup="$ctrl.onKeyUp($event)" ng-model="$ctrl.doc" ng-model-options="{ debounce: 500 }" type="text" placeholder="{{ $ctrl.placeholder | i18n }}" name="{{$ctrl.fieldName}}" autocomplete="off" ng-disabled="$ctrl.disabled || $ctrl.full" ng-change="$ctrl.searchDocuments()"/><div class="error" ng-if="$ctrl.error"><p>{{$ctrl.error | i18n}}</p></div><div class="documents" ng-if="($ctrl.doc_suggestions.length != 0 || $ctrl.createNewLabel &amp;&amp; $ctrl.doc.length &gt; 1) &amp;&amp; !$ctrl.full"><div class="doc" ng-repeat="doc in $ctrl.doc_suggestions" tabIndex="0" ng-click="::($ctrl.selectDoc(doc))" ng-keydown="::($ctrl.selectDocOnEnter(doc))"><span class="name">{{::($ctrl.representation(doc))}}</span><span class="sub">{{::($ctrl.representationSub(doc))}}</span><i class="icon-plus"></i></div><div class="create-new" ng-if="$ctrl.createNewLabel" ng-click="::($ctrl.createNewAction($ctrl.navService, $ctrl.$i18n))">{{::($ctrl.createNewLabel)}} +</div></div><div class="selected-documents"><div class="doc" ng-repeat="doc in $ctrl.documents"><span class="name">{{::($ctrl.representation(doc))}}</span><span class="sub">{{::($ctrl.representationSub(doc))}}</span><i class="icon-trash" tabIndex="0" ng-click="::($ctrl.removeDoc(doc))" ng-keydown="::($ctrl.removeDocOnEnter(doc))"></i><i class="icon-edit edit-icon" ng-if="doc.fp_type === \'prospect\'" tabIndex="0" ng-click="::($ctrl.editDoc(doc))" ng-keydown="::($ctrl.editDocOnEnter(doc))"></i><div class="error-message" ng-if="doc.fp_type === \'prospect\' &amp;&amp; !doc.email">{{ $ctrl.labels.email_missing | i18n }}</div></div></div></div>';
},{}],104:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TestWatermarkModule = void 0;
var _testWatermark = require("./test-watermark.component");
var TestWatermarkModule = angular.module('maestro.components.common.test-watermark', []).component('testWatermark', _testWatermark.TestWatermarkComponent).name;
exports.TestWatermarkModule = TestWatermarkModule;

},{"./test-watermark.component":105}],105:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TestWatermarkComponent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var TestWatermarkComponent = {
  template: require('./test-watermark.pug'),
  controller: function () {
    TestWatermarkComponent.$inject = ["EVENT", "ACTIVATED_PERSON"];
    /* @ngInject */
    function TestWatermarkComponent(EVENT, ACTIVATED_PERSON) {
      (0, _classCallCheck2.default)(this, TestWatermarkComponent);
      this.isTestEvent = Boolean(EVENT.test_event);
      this.userEmail = ACTIVATED_PERSON.email || '';
    }
    (0, _createClass2.default)(TestWatermarkComponent, [{
      key: "$onInit",
      value: function $onInit() {
        var isSpotme = this.userEmail.endsWith('@spotme.com');
        this.showWatermark = this.isTestEvent && !isSpotme;
      }
    }]);
    return TestWatermarkComponent;
  }()
};
exports.TestWatermarkComponent = TestWatermarkComponent;

},{"./test-watermark.pug":106,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382}],106:[function(require,module,exports){
module.exports = '<div class="test-watermark" ng-if="$ctrl.showWatermark"><p>Demo workspace, not for production use</p></div>';
},{}],107:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UpdateBrowserModule = void 0;
var _updateBrowser = require("./update-browser.component");
var _updateBrowserBox = require("./update-browser-box.component");
var UpdateBrowserModule = angular.module('maestro.components.common.update-browser', []).component('updateBrowser', _updateBrowser.UpdateBrowserComponent).component('updateBrowserBox', _updateBrowserBox.UpdateBrowserBoxComponent).name;
exports.UpdateBrowserModule = UpdateBrowserModule;

},{"./update-browser-box.component":108,"./update-browser.component":110}],108:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UpdateBrowserBoxComponent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _i18nWithFallback = _interopRequireDefault(require("../../../utils/i18n-with-fallback"));
var UpdateBrowserBoxComponent = {
  template: require('./update-browser-box.jade'),
  controller: function () {
    UpdateBrowserBoxComponent.$inject = ["$i18n", "$element"];
    /* @ngInject */
    function UpdateBrowserBoxComponent($i18n, $element) {
      (0, _classCallCheck2.default)(this, UpdateBrowserBoxComponent);
      this.$element = $element;
      this.$i18n = $i18n;
      this.labels = {
        title: (0, _i18nWithFallback.default)($i18n, 'update-browser.title', 'You should update your browser'),
        text: (0, _i18nWithFallback.default)($i18n, 'update-browser.title', 'Unfortunately the browser you are using will not allow some of the app  features to work. Please download and use one of the following browsers to access the app.')
      };
      var browsers = [{
        name: 'firefox',
        owner: 'Mozilla',
        link: 'https://www.mozilla.org/firefox/download'
      }, {
        name: 'chrome',
        owner: 'Google',
        link: 'https://www.google.com/chrome'
      }, {
        name: 'edge (v80+)',
        owner: 'Microsoft',
        link: 'https://www.microsoft.com/en-us/edge'
      }, {
        name: 'opera',
        owner: 'Opera',
        link: 'https://www.opera.com/download'
      }];
      this.browsers = this.shuffleArray(browsers);
    }
    (0, _createClass2.default)(UpdateBrowserBoxComponent, [{
      key: "shuffleArray",
      value: function shuffleArray(array) {
        for (var i = array.length - 1; i > 0; i--) {
          var j = Math.floor(Math.random() * (i + 1));
          var temp = array[i];
          array[i] = array[j];
          array[j] = temp;
        }
        return array;
      }
    }, {
      key: "downloadBrowser",
      value: function downloadBrowser(browser) {
        window.open(browser.link, '_blank');
      }
    }]);
    return UpdateBrowserBoxComponent;
  }()
};
exports.UpdateBrowserBoxComponent = UpdateBrowserBoxComponent;

},{"../../../utils/i18n-with-fallback":359,"./update-browser-box.jade":109,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382}],109:[function(require,module,exports){
module.exports = '<div class="content"><div class="header"><h2 class="title">{{ $ctrl.labels.title }}</h2></div><div class="body"><p class="text">{{ $ctrl.labels.text }}</p><ul class="browsers"><li class="browser" ng-repeat="browser in $ctrl.browsers track by browser.name" ng-click="$ctrl.downloadBrowser(browser)"><div class="browser-img" ng-class="browser.name"></div><p class="name">{{ browser.name }}</p><p class="owner">{{ browser.owner }}</p></li></ul></div></div>';
},{}],110:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UpdateBrowserComponent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _i18nWithFallback = _interopRequireDefault(require("../../../utils/i18n-with-fallback"));
var _browser = require("../../../utils/browser");
var UpdateBrowserComponent = {
  template: require('./update-browser.jade'),
  controller: function () {
    UpdateBrowserComponent.$inject = ["$i18n", "$element"];
    /* @ngInject */
    function UpdateBrowserComponent($i18n, $element) {
      (0, _classCallCheck2.default)(this, UpdateBrowserComponent);
      this.$element = $element;
      this.$i18n = $i18n;
      this.labels = {
        bannerText: (0, _i18nWithFallback.default)($i18n, 'update-browser.banner', 'You need to switch to one of recommended browsers to use all the functionalities in the app.')
      };
      this.showModal = true;
    }
    (0, _createClass2.default)(UpdateBrowserComponent, [{
      key: "$onInit",
      value: function $onInit() {
        this.isUnsupported = (0, _browser.isUnsupported)();
        if (!this.isUnsupported) {
          this.clearElement();
        }
      }
    }, {
      key: "$onDestroy",
      value: function $onDestroy() {
        this.$element.remove();
      }
    }, {
      key: "clearElement",
      value: function clearElement() {
        this.$element.remove();
      }
    }, {
      key: "dismiss",
      value: function dismiss() {
        this.showModal = false;
        angular.element('body').addClass('update-browser-banner');
      }
    }, {
      key: "bannerClick",
      value: function bannerClick() {
        this.showModal = true;
      }
    }]);
    return UpdateBrowserComponent;
  }()
};
exports.UpdateBrowserComponent = UpdateBrowserComponent;

},{"../../../utils/browser":352,"../../../utils/i18n-with-fallback":359,"./update-browser.jade":111,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382}],111:[function(require,module,exports){
module.exports = '<div class="modal modal-sheet" ng-if="$ctrl.isUnsupported &amp;&amp; $ctrl.showModal"><div class="modal-dialog"><div class="modal-content"><div class="close-btn" aria-label="{{\'generic.close\' | i18n}}" ng-click="$ctrl.dismiss()"><i class="icon-cross"></i></div><update-browser-box></update-browser-box></div></div></div><div class="browser-banner" ng-if="$ctrl.isUnsupported" ng-click="$ctrl.bannerClick()"><p>{{ $ctrl.labels.bannerText }}</p></div>';
},{}],112:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SHARE_VALUES = exports.BEST_FIT_VALUES = void 0;
exports.bestFit = bestFit;
exports.share = share;
var _BroadcastLayoutGenerator = require("./BroadcastLayoutGenerator.js");
var BEST_FIT_VALUES = [(0, _BroadcastLayoutGenerator.getPositions)(77.50, null, {
  x: 1,
  y: 1.777
}, [1]), (0, _BroadcastLayoutGenerator.getPositions)(43.75, null, {
  x: 1,
  y: 1.777
}, [2]), (0, _BroadcastLayoutGenerator.getPositions)(43.75, null, {
  x: 1,
  y: 1.777
}, [2, 1]), (0, _BroadcastLayoutGenerator.getPositions)(43.75, null, {
  x: 1,
  y: 1.777
}, [2, 2]), (0, _BroadcastLayoutGenerator.getPositions)(31.25, null, {
  x: 1,
  y: 1.777
}, [3, 2]), (0, _BroadcastLayoutGenerator.getPositions)(31.25, null, {
  x: 1,
  y: 1.777
}, [3, 3]), (0, _BroadcastLayoutGenerator.getPositions)(31.25, null, {
  x: 1,
  y: 1.777
}, [3, 3, 1]), (0, _BroadcastLayoutGenerator.getPositions)(31.25, null, {
  x: 1,
  y: 1.777
}, [3, 3, 2]), (0, _BroadcastLayoutGenerator.getPositions)(31.25, null, {
  x: 1,
  y: 1.777
}, [3, 3, 3]), (0, _BroadcastLayoutGenerator.getPositions)(23.00, null, {
  x: 1,
  y: 1.777
}, [4, 4, 2]), (0, _BroadcastLayoutGenerator.getPositions)(23.00, null, {
  x: 1,
  y: 1.777
}, [4, 4, 3]), (0, _BroadcastLayoutGenerator.getPositions)(23.00, null, {
  x: 1,
  y: 1.777
}, [4, 4, 4])];
exports.BEST_FIT_VALUES = BEST_FIT_VALUES;
var SHARE_VALUES = [(0, _BroadcastLayoutGenerator.getPositionsForScreenShare)(15, null, 0.8, {
  x: 10,
  y: 1
}, 1), (0, _BroadcastLayoutGenerator.getPositionsForScreenShare)(15, null, 0.8, {
  x: 10,
  y: 1
}, 2), (0, _BroadcastLayoutGenerator.getPositionsForScreenShare)(15, null, 0.8, {
  x: 10,
  y: 1
}, 3), (0, _BroadcastLayoutGenerator.getPositionsForScreenShare)(15, null, 0.8, {
  x: 10,
  y: 1
}, 4), (0, _BroadcastLayoutGenerator.getPositionsForScreenShare)(15, null, 0.8, {
  x: 10,
  y: 1
}, 5), (0, _BroadcastLayoutGenerator.getPositionsForScreenShare)(15, null, 0.8, {
  x: 10,
  y: 1
}, 6)];
exports.SHARE_VALUES = SHARE_VALUES;
function bestFit(n) {
  return (0, _BroadcastLayoutGenerator.bestFitGenerator)(BEST_FIT_VALUES, n);
}
function share(n) {
  return (0, _BroadcastLayoutGenerator.bestFitGenerator)(SHARE_VALUES, n);
}

},{"./BroadcastLayoutGenerator.js":113}],113:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bestFitGenerator = bestFitGenerator;
exports.getPositions = getPositions;
exports.getPositionsForScreenShare = getPositionsForScreenShare;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function getPositions(width, height, videoMargins, videosPerRow) {
  if (!height) {
    height = width;
  }
  var pos = [];
  var row = 0;
  var maxPerRow = Math.max.apply(Math, (0, _toConsumableArray2.default)(videosPerRow));
  var numberOfRows = videosPerRow.length;
  var screenMargins = {};
  screenMargins.x = (100 - videoMargins.x * (maxPerRow - 1) - maxPerRow * width) / 2;
  screenMargins.y = (100 - videoMargins.y * (numberOfRows - 1) - numberOfRows * height) / 2;
  screenMargins.x = screenMargins.x || 0;
  screenMargins.y = screenMargins.y || 0;
  if (screenMargins.x < 0 || screenMargins.y < 0) {
    throw new Error('Overconstrained error', screenMargins);
  }
  var _iterator = _createForOfIteratorHelper(videosPerRow),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var numberThisRow = _step.value;
      var offsetX = (maxPerRow - numberThisRow) * ((width + videoMargins.x) / 2);
      for (var col = 0; col < numberThisRow; col++) {
        var top = screenMargins.y + row * videoMargins.y + row * height;
        var left = offsetX + screenMargins.x + col * videoMargins.x + col * width;
        pos.push([top, left]);
      }
      row++;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return [width, height, pos];
}
function getPositionsForScreenShare(width, height, videoMarginX, screenMargins, number) {
  if (!height) {
    height = width;
  }
  var pos = [];
  var offsetX = (100 - width * number - (number - 1) * videoMarginX - 2 * screenMargins.x) / 2;
  for (var col = 0; col < number; col++) {
    var top = screenMargins.y;
    var left = offsetX + screenMargins.x + col * videoMarginX + col * width;
    pos.push([top, left]);
  }
  return [width, height, pos];
}
function bestFitGenerator(values) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  if (n < 1) {
    n = 1;
  }
  n = Math.min(n, values.length);
  var _values = (0, _slicedToArray2.default)(values[n - 1], 3),
    width = _values[0],
    height = _values[1],
    positions = _values[2];
  return positions.map(function (_ref, i) {
    var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
      top = _ref2[0],
      left = _ref2[1];
    return "\n  .stream_".concat(i, " {\n      z-index: 1;\n      width: ").concat(width, "%;\n      height: ").concat(height, "%;\n      top: ").concat(top, "%;\n      left: ").concat(left, "%;\n  }\n  .stream_").concat(i, " video {\n      object-fit: cover;\n  }");
  }).join('');
}

},{"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/helpers/slicedToArray":390,"@babel/runtime/helpers/toConsumableArray":393}],114:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeviceManager = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
var _videoCallModeratorService = require("../../../services/videoCallModeratorService");
var DeviceManager = function () {
  DeviceManager.$inject = ["mediaDevicesService", "$eventBus", "$scope"];
  /* @ngInject */
  function DeviceManager(mediaDevicesService, $eventBus, $scope) {
    var _this = this;
    (0, _classCallCheck2.default)(this, DeviceManager);
    this.mediaDevicesService = mediaDevicesService;
    this.$eventBus = $eventBus;
    this.streams = [];
    this.userPermissions = null;
    this.userPermissionAsked = false;
    this.$scope = $scope;
    this.videoOn = true;
    this.audioOn = true;
    this.settings = {};
    var hideInputDevices = function hideInputDevices() {
      if (_this.showAudioInputs || _this.showVideoInputs) {
        _this.hideInputDevicesTimeout = setTimeout(function () {
          _this.showAudioInputs = false;
          _this.showVideoInputs = false;
          _this.$scope.$applyAsync();
        });
      }
    };
    this.hideInputDevices = hideInputDevices.bind(this);
    this.$eventBus.on("moderatorRequest:".concat(_videoCallModeratorService.MODERATOR_ACTIONS.FORCE_MUTE), function () {
      _this.toggleAudio(false);
    });
    this.$eventBus.on("moderatorRequest:".concat(_videoCallModeratorService.MODERATOR_ACTIONS.UNMUTE), function () {
      if (!_this.audioOn) {
        _this.showAskToUnmute = true;
        _this.showList = false;
      }
    });
  }
  (0, _createClass2.default)(DeviceManager, [{
    key: "init",
    value: function init() {
      this.subscribeToDeviceChange();
      document.addEventListener('mouseup', this.hideInputDevices);
    }
  }, {
    key: "subscribeToDeviceChange",
    value: function subscribeToDeviceChange() {
      this.deviceChangeListener = this.mediaDevicesService.onDevicesChange(this.deviceUpdatedHandler.bind(this));
    }
  }, {
    key: "unsubscribeFromDeviceChange",
    value: function unsubscribeFromDeviceChange() {
      if ((0, _lodash.isFunction)(this.deviceChangeListener)) {
        this.deviceChangeListener();
      }
    }
  }, {
    key: "toggleCamera",
    value: function toggleCamera() {
      var videoOn = !this.videoOn;
      if (videoOn && !this.mediaDevicesService.videoDeviceSelected) {
        this.mediaDevicesService.selectDefaultVideo();
      }
      this.setVideoOn(videoOn);
    }
  }, {
    key: "toggleAudio",
    value: function toggleAudio() {
      var audioOn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !this.audioOn;
      if (audioOn && !this.mediaDevicesService.audioDeviceSelected) {
        this.mediaDevicesService.selectDefaultAudio();
      }
      this.setAudioOn(audioOn);
    }
  }, {
    key: "showInputDevices",
    value: function showInputDevices(type) {
      this.showAudioInputs = type === 'audio' && !this.showAudioInputs;
      this.showVideoInputs = type === 'video' && !this.showVideoInputs;
    }
  }, {
    key: "changeAudioSource",
    value: function changeAudioSource(device) {
      this.showAudioInputs = false;
      this.mediaDevicesService.selectDevice('audio', device);
    }
  }, {
    key: "changeVideoSource",
    value: function changeVideoSource(device) {
      this.showVideoInputs = false;
      this.mediaDevicesService.selectDevice('video', device);
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.unsubscribeFromDeviceChange();
      document.removeEventListener('mouseup', this.hideInputDevices);
      clearTimeout(this.hideInputDevicesTimeout);
    }
  }]);
  return DeviceManager;
}();
exports.DeviceManager = DeviceManager;

},{"../../../services/videoCallModeratorService":291,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"lodash":"lodash"}],115:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Subscriber = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var Subscriber = function () {
  function Subscriber(_ref, _ref2) {
    var triggerService = _ref.triggerService;
    var session = _ref2.session,
      name = _ref2.name,
      pid = _ref2.pid,
      stream = _ref2.stream;
    (0, _classCallCheck2.default)(this, Subscriber);
    console.log('[Subscriber] constructor', stream);
    this.triggerService = triggerService;
    this.session = session;
    this.name = name;
    this.pid = pid;
    this.stream = stream;
    this.hasAudio = stream.hasAudio;
    this.hasVideo = stream.hasVideo;
    this.otSubscriberObject = null;
    this.isPinned = false;
    this.listeners = [];
  }
  (0, _createClass2.default)(Subscriber, [{
    key: "init",
    value: function () {
      var _init = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee(element, eventEmitter) {
        var options,
          _args = arguments;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
              this.element = element;
              this.eventEmitter = eventEmitter;
              this.options = options;
              _context.next = 6;
              return this.subscribeToStream();
            case 6:
              this.options.subscribeToAudio = true;
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function init(_x, _x2) {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "subscribeToStream",
    value: function () {
      var _subscribeToStream = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee2() {
        var _this = this;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!this.isSubscribing) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              this.isSubscribing = true;
              _context2.next = 5;
              return this.unsubscribe();
            case 5:
              return _context2.abrupt("return", new Promise(function (resolve, reject) {
                var options = (0, _lodash.defaults)(_this.options, {
                  insertMode: 'append',
                  fitMode: 'contain',
                  showControls: false,
                  width: '100%',
                  height: '100%',
                  subscribeToAudio: true
                });
                var otSubscriberObject = _this.session.subscribe(_this.stream, _this.element, options, function (err) {
                  _this.isSubscribing = false;
                  if (err) {
                    return reject(err);
                  } else {
                    _this.otSubscriberObject = otSubscriberObject;
                    _this.videoElement = _this.element.getElementsByTagName('video')[0];
                    _this.mediaStream = _this.videoElement.srcObject;
                    _this.addListeners();
                    _this.adaptResolution();
                    _this.eventEmitter.emit('subscriber:subscribed');
                    return resolve();
                  }
                });
              }));
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function subscribeToStream() {
        return _subscribeToStream.apply(this, arguments);
      }
      return subscribeToStream;
    }()
  }, {
    key: "unsubscribe",
    value: function () {
      var _unsubscribe = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee3() {
        var _iterator, _step, _unsubscribe2;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              console.log('[Subscriber] unsubscribe');
              _iterator = _createForOfIteratorHelper(this.listeners);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  _unsubscribe2 = _step.value;
                  _unsubscribe2();
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              this.listeners = [];
              clearTimeout(this.resubscribeTimeout);
              this.resubscribeTimeout = null;
              if (!this.otSubscriberObject) {
                _context3.next = 12;
                break;
              }
              this.otSubscriberObject.off();
              _context3.next = 10;
              return this.session.unsubscribe(this.otSubscriberObject);
            case 10:
              this.otSubscriberObject = null;
              this.element.innerHTML = '';
            case 12:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function unsubscribe() {
        return _unsubscribe.apply(this, arguments);
      }
      return unsubscribe;
    }()
  }, {
    key: "adaptResolution",
    value: function adaptResolution() {
      var layoutData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.layoutData;
      if (!layoutData || !(0, _lodash.isFunction)((0, _lodash.get)(this, 'otSubscriberObject.setPreferredResolution'))) {
        return;
      }
      this.layoutData = layoutData;
      var widthPercentage = (0, _lodash.get)(layoutData, 'fitValues[0]', 100);
      var heightPercentage = (0, _lodash.get)(layoutData, 'fitValues[1]', 100);
      var percentage = Math.min(widthPercentage, heightPercentage);
      percentage = Math.max(percentage, 25);
      var reductionFactor = Math.floor(100 / percentage);
      var width = 1280 / reductionFactor;
      var height = 720 / reductionFactor;
      this.otSubscriberObject.setPreferredResolution({
        width: width,
        height: height
      });
    }
  }, {
    key: "destroy",
    value: function () {
      var _destroy = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee4() {
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.unsubscribe();
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function destroy() {
        return _destroy.apply(this, arguments);
      }
      return destroy;
    }()
  }, {
    key: "addListeners",
    value: function addListeners() {
      var _this2 = this;
      this.listeners = [this.triggerService.addTrigger('destroySubscriber', (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee5() {
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this2.session.unsubscribe(_this2.otSubscriberObject);
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))), this.triggerService.addTrigger('stopSubscriberVideoMediaStreamTrack', function () {
        _this2.mediaStream.getVideoTracks()[0].stop();
      }), this.triggerService.addTrigger('stopSubscriberAudioMediaStreamTrack', function () {
        _this2.mediaStream.getAudioTracks()[0].stop();
      }), this.triggerService.addTrigger('stopSubscriberMediaTracks', function () {
        var _iterator2 = _createForOfIteratorHelper(_this2.mediaStream.getTracks()),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var track = _step2.value;
            track.stop();
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      })];
      this.otSubscriberObject.on('disconnected', function () {
        console.log('[Subscriber] disconnected');
      });
      this.otSubscriberObject.on('connected', (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee6() {
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              console.log('[Subscriber] connected');
              _this2.scheduleResubscribe();
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      })));
      this.otSubscriberObject.on('destroyed', function () {
        var _ref5 = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee7(event) {
          return _regenerator.default.wrap(function _callee7$(_context7) {
            while (1) switch (_context7.prev = _context7.next) {
              case 0:
                console.log('[Subscriber] destroyed', _this2.otSubscriberObject, event);
                _this2.scheduleResubscribe();
              case 2:
              case "end":
                return _context7.stop();
            }
          }, _callee7);
        }));
        return function (_x3) {
          return _ref5.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "scheduleResubscribe",
    value: function scheduleResubscribe() {
      var _this3 = this;
      if (this.resubscribeTimeout) {
        return;
      }
      this.resubscribeTimeout = setTimeout((0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee8() {
        return _regenerator.default.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              console.log('[Subscriber] resubscribing');
              _this3.resubscribeTimeout = null;
              _context8.next = 4;
              return _this3.subscribeToStream(true);
            case 4:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      })), 1000);
    }
  }, {
    key: "setPinned",
    value: function setPinned(val) {
      this.isPinned = val;
    }
  }, {
    key: "setTalkingPosition",
    value: function setTalkingPosition(val) {
      this.talkingPosition = val;
    }
  }]);
  return Subscriber;
}();
exports.Subscriber = Subscriber;

},{"@babel/runtime/helpers/asyncToGenerator":375,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/regenerator":398,"lodash":"lodash"}],116:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoCallModule = void 0;
var _onboarding = require("./onboarding.component");
var _publisher = require("./publisher.component");
var _subscriber = require("./subscriber.component");
var _participantsList = require("./participants-list.component");
var _videoCall = require("./video-call.component");
var _videoCallV = require("./video-call-v2.component");
var _joinCallButton = require("./join-call-button.component");
var _moderatorOptions = require("./moderator-options.component");
var _videoCallModal = require("./video-call-modal.component");
var VideoCallModule = angular.module('maestro.components.common.video-call', []).component('onboarding', _onboarding.OnboardingComponent).component('publisher', _publisher.PublisherComponent).component('subscriber', _subscriber.SubscriberComponent).component('participantsList', _participantsList.ParticipantsListComponent).component('videoCall', _videoCall.VideoCallComponent).component('videoCallV2', _videoCallV.VideoCallV2Component).component('joinCallButton', _joinCallButton.JoinCallButtonComponent).component('videoCallModal', _videoCallModal.VideoCallModalComponent).component('moderatorOptions', _moderatorOptions.ModeratorOptions).name;
exports.VideoCallModule = VideoCallModule;

},{"./join-call-button.component":117,"./moderator-options.component":119,"./onboarding.component":121,"./participants-list.component":123,"./publisher.component":125,"./subscriber.component":128,"./video-call-modal.component":130,"./video-call-v2.component":132,"./video-call.component":134}],117:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JoinCallButtonComponent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var JoinCallButtonComponent = {
  bindings: {
    sessionId: '<',
    nav: '<'
  },
  template: require('./join-call-button.pug'),
  controller: function () {
    JoinCallButtonComponent.$inject = ["$scope", "$eventBus", "videoBreakoutService", "$location"];
    /* @ngInject */
    function JoinCallButtonComponent($scope, $eventBus, videoBreakoutService, $location) {
      (0, _classCallCheck2.default)(this, JoinCallButtonComponent);
      this.$scope = $scope;
      this.$eventBus = $eventBus;
      this.$location = $location;
      this.videoBreakoutService = videoBreakoutService;
      this.showButton = true;
    }
    (0, _createClass2.default)(JoinCallButtonComponent, [{
      key: "$onInit",
      value: function $onInit() {
        var _this = this;
        var showButton = function showButton() {
          return _this.showButton = true;
        };
        var hideButton = function hideButton() {
          return _this.showButton = false;
        };
        var unsubVideoCreated = this.$eventBus.on('join-call-button:hide', hideButton);
        var unsubOngoing = this.$eventBus.on('video-call:ongoing', hideButton);
        var unsubOnClose = this.$eventBus.on('join-call-button:show', showButton);
        this.listeners = [unsubVideoCreated, unsubOngoing, unsubOnClose];
      }
    }, {
      key: "$postLink",
      value: function $postLink() {
        this.$eventBus.emit('join-call-button:created', this.$location.url());
        this.videoBreakoutService.attemptAutoStart(this.nav, this.sessionId);
      }
    }, {
      key: "$onDestroy",
      value: function $onDestroy() {
        var _iterator = _createForOfIteratorHelper(this.listeners),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var unsub = _step.value;
            if ((0, _lodash.isFunction)(unsub)) unsub();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }, {
      key: "joinVideoCall",
      value: function joinVideoCall() {
        this.videoBreakoutService.start(this.nav, this.sessionId);
      }
    }]);
    return JoinCallButtonComponent;
  }()
};
exports.JoinCallButtonComponent = JoinCallButtonComponent;

},{"./join-call-button.pug":118,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"lodash":"lodash"}],118:[function(require,module,exports){
module.exports = '<div class="join-call-btn" ng-if="$ctrl.showButton" ng-click="$ctrl.joinVideoCall()"><i class="icon-phone"></i>{{::(\'video_calls.labels.join\' | i18n)}}</div>';
},{}],119:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModeratorOptions = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
var _videoCallModeratorService = require("../../../services/videoCallModeratorService");
var _i18nWithFallback = _interopRequireDefault(require("../../../utils/i18n-with-fallback"));
var _dom = require("../../../utils/dom");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var ModeratorOptions = {
  bindings: {
    isPinned: '<',
    otObject: '=',
    showModeratorControls: '=',
    hasAudio: '<',
    pid: '<',
    isOwnPublisher: '=',
    name: '='
  },
  template: require('./moderator-options.pug'),
  controller: function () {
    SubscriberComponent.$inject = ["$i18n", "$scope", "$element", "$eventBus", "$timeout", "uiService", "videoCallModeratorService", "THEME"];
    /* @ngInject */
    function SubscriberComponent($i18n, $scope, $element, $eventBus, $timeout, uiService, videoCallModeratorService, THEME) {
      (0, _classCallCheck2.default)(this, SubscriberComponent);
      this.$scope = $scope;
      $scope.eventTheme = THEME;
      this.$eventBus = $eventBus;
      this.uiService = uiService;
      this.videoCallModeratorService = videoCallModeratorService;
      this.listeners = [];
      this.showSubscriberOptions = false;
      this.$timeout = $timeout;
      this.labels = {
        mute: (0, _i18nWithFallback.default)($i18n, 'video_calls.actions.mute', 'Mute'),
        ask_unmute: (0, _i18nWithFallback.default)($i18n, 'video_calls.actions.ask_all_unmute', 'Ask to unmute'),
        kickout: (0, _i18nWithFallback.default)($i18n, 'video_calls.actions.kickout', 'Kickout participant'),
        pin: (0, _i18nWithFallback.default)($i18n, 'video_calls.actions.pin', 'Pin'),
        unpin: (0, _i18nWithFallback.default)($i18n, 'video_calls.actions.unpin', 'Unpin'),
        actions: (0, _i18nWithFallback.default)($i18n, 'video_calls.actions.actions', 'Actions'),
        all_participants: (0, _i18nWithFallback.default)($i18n, 'video_calls.message.all_participants', 'All participants'),
        unmute_request_sent: (0, _i18nWithFallback.default)($i18n, 'video_calls.message.unmute_request_sent', 'Unmute request sent')
      };
    }
    (0, _createClass2.default)(SubscriberComponent, [{
      key: "$postLink",
      value: function $postLink() {
        var _this = this;
        var hideOptions = function hideOptions() {
          if (_this.showSubscriberOptions) {
            _this.$timeout(function () {
              _this.showSubscriberOptions = false;
            });
          }
        };
        this.listeners.push((0, _dom.addEventListener)(document, 'mouseup', hideOptions));
      }
    }, {
      key: "$onDestroy",
      value: function $onDestroy() {
        var _iterator = _createForOfIteratorHelper(this.listeners),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var listener = _step.value;
            if ((0, _lodash.isFunction)(listener)) {
              listener();
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        this.listeners = [];
      }
    }, {
      key: "toggleSubscriberOptions",
      value: function toggleSubscriberOptions() {
        this.showSubscriberOptions = !this.showSubscriberOptions;
      }
    }, {
      key: "moderatorAction",
      value: function moderatorAction(action) {
        var connection = (0, _lodash.get)(this, 'otObject.stream.connection', {});
        if (!connection) {
          return;
        }
        if (action === 'KICKOUT') {
          return this.$scope.$emit('moderator:showKickoutModal', {
            connection: connection
          });
        }
        this.videoCallModeratorService.sendAction(_videoCallModeratorService.MODERATOR_ACTIONS[action], {
          connection: connection
        });
        if (action === 'UNMUTE') {
          var message = this.uiService.buildNotificationMessage({
            title: this.name || this.labels.all_participants,
            message: {
              body: this.labels.unmute_request_sent
            },
            duration: 5,
            backgroundColor: (0, _lodash.get)(this.$scope, 'eventTheme.toolbar.background_color'),
            contentColor: (0, _lodash.get)(this.$scope, 'eventTheme.toolbar.font_color'),
            iconColor: (0, _lodash.get)(this.$scope, 'eventTheme.toolbar.font_color')
          });
          this.uiService.inAppNotification(message);
        }
      }
    }, {
      key: "pinSpeaker",
      value: function pinSpeaker() {
        this.$scope.$emit('moderator:pin', this.pid);
      }
    }]);
    return SubscriberComponent;
  }()
};
exports.ModeratorOptions = ModeratorOptions;

},{"../../../services/videoCallModeratorService":291,"../../../utils/dom":355,"../../../utils/i18n-with-fallback":359,"./moderator-options.pug":120,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"lodash":"lodash"}],120:[function(require,module,exports){
module.exports = '<div class="button-bar"><div class="button-wrapper" ng-if="$ctrl.isPinned"><button class="unpin-speaker" ng-click="$ctrl.pinSpeaker()"><i class="icon-pin-filled"></i><div class="action-tooltip unpin-tooltip">{{ $ctrl.labels.unpin }}</div></button></div><div class="button-wrapper" ng-if="!$ctrl.isPinned &amp;&amp; $ctrl.isOwnPublisher"><button class="pin-speaker" ng-click="$ctrl.pinSpeaker()"><i class="icon-pin-outline"></i><div class="action-tooltip unpin-tooltip">{{ $ctrl.labels.pin }}</div></button></div><div class="button-wrapper" ng-if="$ctrl.showModeratorControls &amp;&amp; !$ctrl.isOwnPublisher"><div class="option-button"><button class="show-options" ng-click="$ctrl.toggleSubscriberOptions()"><i class="icon-dots-three-vertical"></i><div class="action-tooltip more-tooltip">{{ $ctrl.labels.actions }}</div></button></div></div></div><div class="options" ng-if="$ctrl.showSubscriberOptions"><ul><li><button class="option" ng-if="!$ctrl.isPinned" ng-click="$ctrl.pinSpeaker()"><i class="icon-pin-outline"></i><span>{{ $ctrl.labels.pin }}</span></button><button class="option" ng-if="$ctrl.isPinned" ng-click="$ctrl.pinSpeaker()"><i class="icon-pin-filled"></i><span>{{ $ctrl.labels.unpin }}</span></button></li><li><button class="option" ng-if="$ctrl.hasAudio" ng-click="$ctrl.moderatorAction(\'FORCE_MUTE\')"><i class="icon-mic"></i><span>{{ $ctrl.labels.mute }}</span></button><button class="option" ng-if="!$ctrl.hasAudio" ng-click="$ctrl.moderatorAction(\'UNMUTE\')"><i class="icon-mic-off"></i><span>{{ $ctrl.labels.ask_unmute }}</span></button></li><li><button class="option" ng-click="$ctrl.moderatorAction(\'KICKOUT\')"><i class="icon-kick-out"></i><span>{{ $ctrl.labels.kickout }}</span></button></li></ul></div>';
},{}],121:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OnboardingComponent = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _DeviceManager2 = require("./DeviceManager");
var _i18nWithFallback = _interopRequireDefault(require("../../../utils/i18n-with-fallback"));
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = (0, _getPrototypeOf2.default)(t); if (r) { var s = (0, _getPrototypeOf2.default)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0, _possibleConstructorReturn2.default)(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var VIDEO_FRAME_WIDTH = 1280;
var VIDEO_FRAME_HEIGHT = 720;
var VOLUME_METER_WIDTH = 48;
var VOLUME_METER_HEIGHT = 48;
var OnboardingComponent = {
  bindings: {
    actions: '=',
    conversation: '='
  },
  template: require('./onboarding.pug'),
  controller: function (_DeviceManager) {
    OnboardingComponent.$inject = ["$scope", "ACTIVATED_PERSON", "mediaDevicesService", "$element", "$eventBus", "$i18n"];
    (0, _inherits2.default)(OnboardingComponent, _DeviceManager);
    var _super = _createSuper(OnboardingComponent);
    /* @ngInject */
    function OnboardingComponent($scope, ACTIVATED_PERSON, mediaDevicesService, $element, $eventBus, $i18n) {
      var _this;
      (0, _classCallCheck2.default)(this, OnboardingComponent);
      _this = _super.call(this, mediaDevicesService, $eventBus, $scope);
      _this.ACTIVATED_PERSON = ACTIVATED_PERSON;
      _this.$i18n = $i18n;
      _this.$element = $element;
      _this.audioOn = true;
      _this.videoOn = true;
      _this.hasConnectedOneDevice = false;
      _this.labels = {
        no_cam_found: (0, _i18nWithFallback.default)(_this.$i18n, 'video_calls.onboard.no_cam_found', 'No camera found'),
        no_mic_found: (0, _i18nWithFallback.default)(_this.$i18n, 'video_calls.onboard.no_mic_found', 'No microphone found'),
        at_least_one_device: (0, _i18nWithFallback.default)(_this.$i18n, 'video_calls.onboard.at_least_one_device', 'You need at least a microphone, or a camera, to enter the call.'),
        browser_device_request: (0, _i18nWithFallback.default)(_this.$i18n, 'video_calls.onboard.waiting_permission', 'When your browser requests access to your webcam and microphone, please click “allow”. You may need to click on the little lock, or camera, on the URL left hand side, and allow access again.')
      };
      return _this;
    }
    (0, _createClass2.default)(OnboardingComponent, [{
      key: "$postLink",
      value: function () {
        var _$postLink = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee() {
          return _regenerator.default.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                (0, _get2.default)((0, _getPrototypeOf2.default)(OnboardingComponent.prototype), "init", this).call(this);
                _context.next = 3;
                return this.mediaDevicesService.requestPermissions();
              case 3:
                this.userPermissions = _context.sent;
                this.userPermissionAsked = true;
                this.$scope.$emit('hideSpinner');
                this.$scope.$applyAsync();
              case 7:
              case "end":
                return _context.stop();
            }
          }, _callee, this);
        }));
        function $postLink() {
          return _$postLink.apply(this, arguments);
        }
        return $postLink;
      }()
    }, {
      key: "$onDestroy",
      value: function $onDestroy() {
        (0, _get2.default)((0, _getPrototypeOf2.default)(OnboardingComponent.prototype), "$onDestroy", this).call(this);
        this.releaseAudioContextOrVideoEl('all');
        this.mediaDevicesService.stopAllStreams();
      }
    }, {
      key: "releaseAudioContextOrVideoEl",
      value: function releaseAudioContextOrVideoEl(kind) {
        if (kind === 'audio' || kind === 'all') {
          if (this.audioContext && this.audioContext.state !== 'closed') {
            this.audioContext.close();
          }
        }
        if (kind === 'video' || kind === 'all') {
          this.mediaDevicesService.stopVideoElement(this.videoElement);
        }
      }
    }, {
      key: "deviceUpdatedHandler",
      value: function () {
        var _deviceUpdatedHandler = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee2(_ref) {
          var error;
          return _regenerator.default.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                error = _ref.error;
                if (error) this.handleError(error);
                this.mediaDevicesService.selectDefaultDevices();
                _context2.next = 5;
                return this.initVideoInput();
              case 5:
                _context2.next = 7;
                return this.initAudioInput();
              case 7:
                this.$scope.$applyAsync();
              case 8:
              case "end":
                return _context2.stop();
            }
          }, _callee2, this);
        }));
        function deviceUpdatedHandler(_x) {
          return _deviceUpdatedHandler.apply(this, arguments);
        }
        return deviceUpdatedHandler;
      }()
    }, {
      key: "joinCall",
      value: function joinCall() {
        this.$scope.$emit('joinCall', {
          videoOn: this.videoOn,
          audioOn: this.audioOn
        });
      }
    }, {
      key: "initVideoInput",
      value: function () {
        var _initVideoInput = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee4() {
          var _this2 = this;
          var params, stream;
          return _regenerator.default.wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                console.info('[Onboarding] Video source changed');
                if (this.mediaDevicesService.videoDeviceSelected) {
                  _context4.next = 5;
                  break;
                }
                _context4.next = 4;
                return this.setVideoOn(false);
              case 4:
                return _context4.abrupt("return");
              case 5:
                this.mediaDevicesService.stopAllStreams('video');
                params = {
                  video: {
                    deviceId: {
                      exact: this.mediaDevicesService.videoDeviceSelected.deviceId
                    },
                    facingMode: 'user',
                    width: {
                      ideal: VIDEO_FRAME_WIDTH
                    },
                    height: {
                      ideal: VIDEO_FRAME_HEIGHT
                    },
                    aspectRatio: {
                      exact: 16 / 9
                    }
                  },
                  audio: false
                };
                _context4.prev = 7;
                _context4.next = 10;
                return this.mediaDevicesService.getUserMedia(params);
              case 10:
                stream = _context4.sent;
                this.videoElement = this.$element.find('video')[0];
                if (this.videoElement) {
                  _context4.next = 14;
                  break;
                }
                return _context4.abrupt("return");
              case 14:
                this.videoElement.srcObject = stream;
                this.videoElement.onloadedmetadata = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee3() {
                  var _this2$videoElement, videoWidth, videoHeight;
                  return _regenerator.default.wrap(function _callee3$(_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        _this2$videoElement = _this2.videoElement, videoWidth = _this2$videoElement.videoWidth, videoHeight = _this2$videoElement.videoHeight;
                        console.debug('[Onboarding] Camera resolution', videoWidth, videoHeight);
                        _context3.prev = 2;
                        _context3.next = 5;
                        return _this2.videoElement.play();
                      case 5:
                        _this2.hasConnectedOneDevice = true;
                        _this2.$scope.$applyAsync();
                        _context3.next = 12;
                        break;
                      case 9:
                        _context3.prev = 9;
                        _context3.t0 = _context3["catch"](2);
                        console.error('[onboardingComponent] Failed to play', _context3.t0);
                      case 12:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee3, null, [[2, 9]]);
                }));
                _context4.next = 23;
                break;
              case 18:
                _context4.prev = 18;
                _context4.t0 = _context4["catch"](7);
                _context4.next = 22;
                return this.setVideoOn(false);
              case 22:
                this.mediaDevicesService.selectDevice('video', null);
              case 23:
              case "end":
                return _context4.stop();
            }
          }, _callee4, this, [[7, 18]]);
        }));
        function initVideoInput() {
          return _initVideoInput.apply(this, arguments);
        }
        return initVideoInput;
      }()
    }, {
      key: "initAudioInput",
      value: function () {
        var _initAudioInput = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee5() {
          var params, stream, volume, analyser, microphone, javascriptNode, canvasContext;
          return _regenerator.default.wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                console.info('[Onboarding] Audio source changed');
                if (this.mediaDevicesService.audioDeviceSelected) {
                  _context5.next = 5;
                  break;
                }
                _context5.next = 4;
                return this.setAudioOn(false);
              case 4:
                return _context5.abrupt("return");
              case 5:
                this.releaseAudioContextOrVideoEl('audio');
                params = {
                  audio: {
                    deviceId: {
                      exact: this.mediaDevicesService.audioDeviceSelected.deviceId
                    }
                  }
                };
                _context5.prev = 7;
                _context5.next = 10;
                return this.mediaDevicesService.getUserMedia(params);
              case 10:
                stream = _context5.sent;
                volume = angular.element('.volume')[0];
                if (volume) {
                  _context5.next = 14;
                  break;
                }
                return _context5.abrupt("return");
              case 14:
                this.audioContext = new AudioContext();
                analyser = this.audioContext.createAnalyser();
                microphone = this.audioContext.createMediaStreamSource(stream);
                javascriptNode = this.audioContext.createScriptProcessor(2048, 1, 1);
                analyser.smoothingTimeConstant = 0.7;
                analyser.fftSize = 1024;
                microphone.connect(analyser);
                analyser.connect(javascriptNode);
                javascriptNode.connect(this.audioContext.destination);
                volume.width = VOLUME_METER_WIDTH;
                volume.height = VOLUME_METER_HEIGHT;
                canvasContext = volume.getContext('2d');
                javascriptNode.onaudioprocess = function () {
                  var array = new Uint8Array(analyser.frequencyBinCount);
                  analyser.getByteFrequencyData(array);
                  var values = 0;
                  var length = array.length;
                  for (var i = 0; i < length; i++) {
                    values += array[i];
                  }
                  var average = values / length;
                  canvasContext.clearRect(0, 0, VOLUME_METER_WIDTH, VOLUME_METER_HEIGHT);
                  canvasContext.fillStyle = 'rgba(0, 0, 0, 0.5)';
                  canvasContext.fillRect(0, 0, VOLUME_METER_WIDTH, VOLUME_METER_HEIGHT);
                  canvasContext.fillStyle = '#2DD269';
                  canvasContext.fillRect(0, VOLUME_METER_HEIGHT - average / 100 * VOLUME_METER_HEIGHT, VOLUME_METER_WIDTH, VOLUME_METER_HEIGHT * 2);
                };
                this.hasConnectedOneDevice = true;
                this.$scope.$applyAsync();
                _context5.next = 36;
                break;
              case 31:
                _context5.prev = 31;
                _context5.t0 = _context5["catch"](7);
                _context5.next = 35;
                return this.setAudioOn(false);
              case 35:
                this.mediaDevicesService.selectDevice('audio', null);
              case 36:
              case "end":
                return _context5.stop();
            }
          }, _callee5, this, [[7, 31]]);
        }));
        function initAudioInput() {
          return _initAudioInput.apply(this, arguments);
        }
        return initAudioInput;
      }()
    }, {
      key: "setVideoOn",
      value: function () {
        var _setVideoOn = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee6(value) {
          return _regenerator.default.wrap(function _callee6$(_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                this.videoOn = value;
                if (this.videoOn) {
                  _context6.next = 5;
                  break;
                }
                this.releaseAudioContextOrVideoEl('video');
                _context6.next = 7;
                break;
              case 5:
                _context6.next = 7;
                return this.initVideoInput();
              case 7:
                if (!this.initials && this.ACTIVATED_PERSON) {
                  this.initials = this.ACTIVATED_PERSON.fname[0] + this.ACTIVATED_PERSON.lname[0];
                }
                this.$scope.$applyAsync();
              case 9:
              case "end":
                return _context6.stop();
            }
          }, _callee6, this);
        }));
        function setVideoOn(_x2) {
          return _setVideoOn.apply(this, arguments);
        }
        return setVideoOn;
      }()
    }, {
      key: "setAudioOn",
      value: function () {
        var _setAudioOn = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee7(value) {
          return _regenerator.default.wrap(function _callee7$(_context7) {
            while (1) switch (_context7.prev = _context7.next) {
              case 0:
                this.audioOn = value;
                if (this.audioOn) {
                  _context7.next = 5;
                  break;
                }
                this.releaseAudioContextOrVideoEl('audio');
                _context7.next = 7;
                break;
              case 5:
                _context7.next = 7;
                return this.initAudioInput();
              case 7:
                this.$scope.$applyAsync();
              case 8:
              case "end":
                return _context7.stop();
            }
          }, _callee7, this);
        }));
        function setAudioOn(_x3) {
          return _setAudioOn.apply(this, arguments);
        }
        return setAudioOn;
      }()
    }, {
      key: "changeAudioSource",
      value: function () {
        var _changeAudioSource = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee8(device) {
          return _regenerator.default.wrap(function _callee8$(_context8) {
            while (1) switch (_context8.prev = _context8.next) {
              case 0:
                (0, _get2.default)((0, _getPrototypeOf2.default)(OnboardingComponent.prototype), "changeAudioSource", this).call(this, device);
                _context8.next = 3;
                return this.initAudioInput();
              case 3:
                this.$scope.$applyAsync();
              case 4:
              case "end":
                return _context8.stop();
            }
          }, _callee8, this);
        }));
        function changeAudioSource(_x4) {
          return _changeAudioSource.apply(this, arguments);
        }
        return changeAudioSource;
      }()
    }, {
      key: "changeVideoSource",
      value: function () {
        var _changeVideoSource = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee9(device) {
          return _regenerator.default.wrap(function _callee9$(_context9) {
            while (1) switch (_context9.prev = _context9.next) {
              case 0:
                (0, _get2.default)((0, _getPrototypeOf2.default)(OnboardingComponent.prototype), "changeVideoSource", this).call(this, device);
                _context9.next = 3;
                return this.initVideoInput();
              case 3:
                this.$scope.$applyAsync();
              case 4:
              case "end":
                return _context9.stop();
            }
          }, _callee9, this);
        }));
        function changeVideoSource(_x5) {
          return _changeVideoSource.apply(this, arguments);
        }
        return changeVideoSource;
      }()
    }, {
      key: "hasAuthorizedOneDevice",
      value: function hasAuthorizedOneDevice() {
        if (!this.userPermissions) {
          return false;
        }
        return this.userPermissions.audio || this.userPermissions.video;
      }
    }, {
      key: "onTryAgainClicked",
      value: function () {
        var _onTryAgainClicked = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee10() {
          return _regenerator.default.wrap(function _callee10$(_context10) {
            while (1) switch (_context10.prev = _context10.next) {
              case 0:
                if (this.hasAuthorizedOneDevice()) {
                  _context10.next = 2;
                  break;
                }
                return _context10.abrupt("return", location.reload());
              case 2:
                _context10.next = 4;
                return this.mediaDevicesService.requestPermissions();
              case 4:
                this.userPermissions = _context10.sent;
                this.$eventBus.emit('restartCall');
                this.$scope.$applyAsync();
              case 7:
              case "end":
                return _context10.stop();
            }
          }, _callee10, this);
        }));
        function onTryAgainClicked() {
          return _onTryAgainClicked.apply(this, arguments);
        }
        return onTryAgainClicked;
      }()
    }, {
      key: "handleError",
      value: function handleError(error, name) {
        this.releaseAudioContextOrVideoEl('all');
        if (error) console.error('[Onboarding] Error: ', error);
        if (name) this.errorMessage = "video_calls.errors.".concat(name);
        this.$scope.$applyAsync();
      }
    }]);
    return OnboardingComponent;
  }(_DeviceManager2.DeviceManager)
};
exports.OnboardingComponent = OnboardingComponent;

},{"../../../utils/i18n-with-fallback":359,"./DeviceManager":114,"./onboarding.pug":122,"@babel/runtime/helpers/asyncToGenerator":375,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/get":379,"@babel/runtime/helpers/getPrototypeOf":380,"@babel/runtime/helpers/inherits":381,"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/helpers/possibleConstructorReturn":387,"@babel/runtime/regenerator":398}],122:[function(require,module,exports){
module.exports = '<div class="onboarding" ng-show="$ctrl.userPermissionAsked"><div class="no-permissions" ng-if="!$ctrl.hasAuthorizedOneDevice() &amp;&amp; !$ctrl.errorMessage"><p>{{ $ctrl.labels.at_least_one_device }}</p><p>{{ $ctrl.labels.browser_device_request }}</p><a href="" ng-click="$ctrl.onTryAgainClicked()">{{ \'video_calls.actions.try_again\' | i18n }}</a><span>&nbsp|&nbsp</span><a href="{{ \'video_calls.onboard.intro_help_link\' | i18n }}" target="_blank">{{ \'video_calls.onboard.intro_help_text\' | i18n }}</a></div><div class="error" ng-if="$ctrl.errorMessage"><p>{{ $ctrl.errorMessage | i18n }}</p><a href="" ng-click="$ctrl.onTryAgainClicked()">{{ \'video_calls.actions.try_again\' | i18n }}</a><span>&nbsp|&nbsp</span><a href="{{ \'video_calls.onboard.intro_help_link\' | i18n }}" target="_blank">{{ \'video_calls.onboard.intro_help_text\' | i18n }}</a></div><div class="settings" ng-show="$ctrl.hasAuthorizedOneDevice() &amp;&amp; !$ctrl.errorMessage"><div class="heading">{{ \'video_calls.onboard.title\' | i18n }}</div><div class="help">{{ \'video_calls.onboard.intro\' | i18n }}&nbsp <a href="{{ \'video_calls.onboard.intro_help_link\' | i18n }}" target="_blank">{{ \'video_calls.onboard.intro_help_text\' | i18n }}</a></div><div class="onboarding-video-wrapper"><div class="camera" ng-click="$ctrl.toggleCamera()"><div class="icon-wrapper" ng-if="$ctrl.videoOn"><i class="icon-webcam"></i></div><div class="icon-wrapper off" ng-if="!$ctrl.videoOn"><i class="icon-webcam-off"></i></div></div><div class="volume-wrapper" ng-click="$ctrl.toggleAudio()"><canvas class="volume" ng-if="$ctrl.audioOn"></canvas><div class="icon-wrapper" ng-if="$ctrl.audioOn"><i class="icon-mic"></i></div><div class="icon-wrapper off" ng-if="!$ctrl.audioOn"><i class="icon-mic-off"></i></div></div><video class="video" ng-show="$ctrl.videoOn" playsinline="playsinline"></video><div class="no-video" ng-if="!$ctrl.videoOn"><div class="initials-wrapper"><div class="initials">{{$ctrl.initials}}</div></div></div></div><div class="selectors"><div class="select-wrapper" ng-click="$ctrl.showInputDevices(\'audio\')"><i class="icon-mic"></i><div class="active-device">{{ $ctrl.mediaDevicesService.audioDeviceSelected.label || $ctrl.labels.no_mic_found}}</div><div class="selector"><i class="icon-chevron-down" ng-if="!$ctrl.showAudioInputs"></i><i class="icon-chevron-up" ng-if="$ctrl.showAudioInputs"></i></div></div><div class="select-wrapper" ng-click="$ctrl.showInputDevices(\'video\')"><i class="icon-webcam"></i><div class="active-device">{{ $ctrl.mediaDevicesService.videoDeviceSelected.label || $ctrl.labels.no_cam_found }}</div><div class="selector"><i class="icon-chevron-down" ng-if="!$ctrl.showVideoInputs"></i><i class="icon-chevron-up" ng-if="$ctrl.showVideoInputs"></i></div></div><div class="input-devices video-devices" ng-if="$ctrl.showVideoInputs"><div class="device" ng-repeat="device in $ctrl.mediaDevicesService.videoDevices" ng-click="$ctrl.changeVideoSource(device)" ng-init="selected = $ctrl.mediaDevicesService.videoDeviceSelected.deviceId === device.deviceId" ng-class="{ \'selected\': selected }"><i class="icon-webcam" ng-if="selected"></i><span ng-class="{ \'active\': selected }">{{ device.label }}</span></div></div><div class="input-devices audio-devices" ng-if="$ctrl.showAudioInputs"><div class="device" ng-repeat="device in $ctrl.mediaDevicesService.audioDevices" ng-click="$ctrl.changeAudioSource(device)" ng-init="selected = $ctrl.mediaDevicesService.audioDeviceSelected.deviceId === device.deviceId" ng-class="{ \'selected\': selected }"><i class="icon-mic" ng-if="selected"></i><span ng-class="{ \'active\': selected }">{{ device.label }}</span></div></div></div><button class="join-call-btn" ng-click="$ctrl.joinCall()" ng-disabled="!$ctrl.hasConnectedOneDevice" ng-class="{ \'disabled\': !$ctrl.hasConnectedOneDevice }"><span>{{ \'video_calls.actions.join\' | i18n }}</span></button></div></div>';
},{}],123:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ParticipantsListComponent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _i18nWithFallback = _interopRequireDefault(require("../../../utils/i18n-with-fallback"));
var _lodash = require("lodash");
var _videoCallModeratorService = require("../../../services/videoCallModeratorService");
var _dom = require("../../../utils/dom");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var ParticipantsListComponent = {
  bindings: {
    participants: '<',
    pinnedParticipants: '<',
    conversationId: '<',
    showList: '=',
    showModeratorControls: '='
  },
  template: require('./participants-list.pug'),
  controller: function () {
    ParticipantsListComponent.$inject = ["$http", "EVENT", "$element", "$timeout", "navService", "databaseService", "$i18n", "$scope", "ACTIVATED_PERSON", "uiService", "videoCallModeratorService", "THEME"];
    /* @ngInject */
    function ParticipantsListComponent($http, EVENT, $element, $timeout, navService, databaseService, $i18n, $scope, ACTIVATED_PERSON, uiService, videoCallModeratorService, THEME) {
      (0, _classCallCheck2.default)(this, ParticipantsListComponent);
      this.eid = EVENT._id;
      this.$element = $element;
      this.$timeout = $timeout;
      this.$http = $http;
      this.$i18n = $i18n;
      this.$scope = $scope;
      $scope.eventTheme = THEME;
      this.navService = navService;
      this.databaseService = databaseService;
      this.ACTIVATED_PERSON = ACTIVATED_PERSON;
      this.uiService = uiService;
      this.videoCallModeratorService = videoCallModeratorService;
      this.selectedPax = null;
      this.listeners = [];
      this.labels = {
        chat_opened: (0, _i18nWithFallback.default)($i18n, 'video_calls.labels.already_on_chat', 'Chat already opened'),
        mute_all: (0, _i18nWithFallback.default)($i18n, 'video_calls.actions.mute_all', 'Mute all'),
        ask_all_unmute: (0, _i18nWithFallback.default)($i18n, 'video_calls.actions.ask_all_unmute', 'Ask all to unmute'),
        ask_unmute: (0, _i18nWithFallback.default)($i18n, 'video_calls.actions.ask_unmute', 'Ask to unmute'),
        mute: (0, _i18nWithFallback.default)($i18n, 'video_calls.actions.mute', 'Mute'),
        more_actions: (0, _i18nWithFallback.default)($i18n, 'video_calls.actions.more_actions', 'More Actions'),
        kickout: (0, _i18nWithFallback.default)($i18n, 'video_calls.actions.kickout', 'Kickout participant'),
        send_message: (0, _i18nWithFallback.default)($i18n, 'video_calls.actions.send_message', 'Chat'),
        add_to_contacts: (0, _i18nWithFallback.default)($i18n, 'video_calls.actions.add_to_contacts', 'Add contact'),
        pin: (0, _i18nWithFallback.default)($i18n, 'video_calls.actions.pin', 'Pin participant'),
        unpin: (0, _i18nWithFallback.default)($i18n, 'video_calls.actions.unpin', 'Unpin participant'),
        all_participants: (0, _i18nWithFallback.default)($i18n, 'video_calls.message.all_participants', 'All participants'),
        unmute_request_sent: (0, _i18nWithFallback.default)($i18n, 'video_calls.message.unmute_request_sent', 'Unmute request sent')
      };
    }
    (0, _createClass2.default)(ParticipantsListComponent, [{
      key: "$onInit",
      value: function $onInit() {
        var _this = this;
        this.contactsActions = (0, _lodash.get)(this.navService, 'EVENT_NAVS.nav_business_cards.video_calls_actions');
        if (this.contactsActions) this.getBcxStatus(this.contactsActions.request_states_action.target);
        this.chatActions = (0, _lodash.get)(this.navService, 'EVENT_NAVS.nav_conversation.video_calls_actions');
        this.enableMessages = !!this.chatActions;
        var isInChat = (0, _lodash.get)(this.navService, 'activeNav.nav.nav_type', '') === 'conversation';
        if (isInChat) {
          var participantsIds = Object.keys((0, _lodash.get)(this.navService, 'activeNav.nav.participants', {}));
          var is1to1 = participantsIds.length === 2;
          if (is1to1) {
            this.disableOpenChatForPaxIds = participantsIds.filter(function (pax) {
              return pax.id !== _this.ACTIVATED_PERSON._id;
            });
          }
        }
        var hidePaxMenu = function hidePaxMenu() {
          if (_this.selectedPax) {
            _this.$timeout(function () {
              _this.selectedPax = null;
            });
          }
        };
        this.listeners.push((0, _dom.addEventListener)(document, 'mouseup', hidePaxMenu));
      }
    }, {
      key: "$onDestroy",
      value: function $onDestroy() {
        var _iterator = _createForOfIteratorHelper(this.listeners),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var listener = _step.value;
            if ((0, _lodash.isFunction)(listener)) {
              listener();
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        this.listeners = [];
      }
    }, {
      key: "shouldDisableOpenPaxChat",
      value: function shouldDisableOpenPaxChat(pid) {
        if (!pid || !this.disableOpenChatForPaxIds) {
          return false;
        }
        return this.disableOpenChatForPaxIds.includes(pid);
      }
    }, {
      key: "getBcxStatus",
      value: function getBcxStatus(targetAppscript) {
        var _this2 = this;
        this.databaseService.runAppScript(targetAppscript, {
          peerIds: (0, _lodash.pluck)(this.participants, 'id')
        }).then(function (_ref) {
          var response = _ref.data.response;
          (0, _lodash.each)(_this2.participants, function (participant) {
            if (['pending', 'reviewing', 'ignored'].includes(response.states[participant.id])) {
              participant.bcxStatus = 'pending';
            } else {
              participant.bcxStatus = response.states[participant.id];
            }
          });
        });
      }
    }, {
      key: "openProfile",
      value: function openProfile(pid) {
        this.navService.openDocument({
          _id: pid
        }, {
          navParams: {
            modal: true,
            fullscreen: true
          }
        });
      }
    }, {
      key: "openChat",
      value: function openChat(pid) {
        var _this3 = this;
        this.databaseService.runAppScript(this.chatActions.open_conversation_action.target, {
          participant: pid
        }).then(function (_ref2) {
          var response = _ref2.data.response;
          if (response.id) {
            if (response.id === _this3.conversationId) return;
            _this3.navService.openDocument({
              _id: response.id
            });
          } else {
            _this3.databaseService.docWithId(pid).then(function (_ref3) {
              var fp_ext_id = _ref3.fp_ext_id;
              return _this3.databaseService.runAppScript(_this3.chatActions.new_message_action.target, {
                recipients: [fp_ext_id]
              });
            });
          }
        });
      }
    }, {
      key: "addContact",
      value: function addContact(pid) {
        var _iterator2 = _createForOfIteratorHelper(this.participants),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var participant = _step2.value;
            if (pid === participant.id) {
              if (participant.bcxStatus === 'pending') return;
              participant.bcxStatus = 'pending';
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        this.databaseService.runAppScript(this.contactsActions.send_request_action.target, {
          peerId: pid
        });
      }
    }, {
      key: "closeList",
      value: function closeList() {
        this.showList = false;
      }
    }, {
      key: "moderatorAction",
      value: function moderatorAction(action) {
        var participant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var connection = (0, _lodash.get)(participant, 'subscriber.otSubscriberObject.stream.connection');
        if (action === 'KICKOUT' && connection) {
          return this.$scope.$emit('moderator:showKickoutModal', {
            connection: connection
          });
        }
        this.videoCallModeratorService.sendAction(_videoCallModeratorService.MODERATOR_ACTIONS[action], {
          connection: connection
        });
        if (action === 'UNMUTE') {
          var message = this.uiService.buildNotificationMessage({
            title: participant.name || this.labels.all_participants,
            message: {
              body: this.labels.unmute_request_sent
            },
            duration: 5,
            backgroundColor: (0, _lodash.get)(this.$scope, 'eventTheme.toolbar.background_color'),
            contentColor: (0, _lodash.get)(this.$scope, 'eventTheme.toolbar.font_color'),
            iconColor: (0, _lodash.get)(this.$scope, 'eventTheme.toolbar.font_color')
          });
          this.uiService.inAppNotification(message);
        }
      }
    }, {
      key: "pinParticipant",
      value: function pinParticipant(pid) {
        this.$scope.$emit('moderator:pin', pid);
      }
    }, {
      key: "selectPax",
      value: function selectPax($event, pid) {
        if (this.selectedPax) {
          return this.selectedPax = null;
        }
        var buttonElementPos = $event.target.getBoundingClientRect();
        var wrapperElementPos = this.$element[0].getBoundingClientRect();
        var menuElement = this.$element.find('.action-list').get(0);
        menuElement.style.top = buttonElementPos.bottom - wrapperElementPos.top + 4 + 'px';
        menuElement.style.right = wrapperElementPos.right - buttonElementPos.right - 4 + 'px';
        this.selectedPax = pid;
      }
    }, {
      key: "hasAudio",
      value: function hasAudio(participant) {
        return (0, _lodash.get)(participant, 'subscriber.otSubscriberObject.stream.hasAudio', false);
      }
    }, {
      key: "isPinned",
      value: function isPinned(participant) {
        return this.pinnedParticipants.includes(participant.id);
      }
    }, {
      key: "getOpenProfileTooltip",
      value: function getOpenProfileTooltip(participant) {
        return this.$i18n('video_calls.labels.open_profile').replace('{{fname}}', participant.fname);
      }
    }]);
    return ParticipantsListComponent;
  }()
};
exports.ParticipantsListComponent = ParticipantsListComponent;

},{"../../../services/videoCallModeratorService":291,"../../../utils/dom":355,"../../../utils/i18n-with-fallback":359,"./participants-list.pug":124,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"lodash":"lodash"}],124:[function(require,module,exports){
module.exports = '<div class="participants-list"><div class="list-header"><div class="label">{{ ::\'video_calls.labels.participants\' | i18n }} ({{ $ctrl.participants.length }})</div><div class="action-btn close-btn" ng-click="$ctrl.closeList()"><i class="icon-cross"></i></div></div><div class="list-body" ng-class="{ \'no-scroll\': $ctrl.selectedPax }"><div class="profile" ng-repeat="participant in $ctrl.participants track by participant.id"><div class="user-info" ng-click="$ctrl.openProfile(participant.id)"><div class="picture" ng-if="participant.picture"><div class="initials">{{ ::participant.name | takeInitials }}</div></div><div class="participant-name">{{ ::participant.name }}</div><div class="action-tooltip open-profile-tooltip" ng-if="!participant.isActPerson">{{ $ctrl.getOpenProfileTooltip(participant) }}</div></div><div class="actions" ng-if="$ctrl.showModeratorControls"><div class="action-btn mute-btn" ng-if="!participant.isActPerson &amp;&amp; $ctrl.hasAudio(participant)" ng-click="$ctrl.moderatorAction(\'FORCE_MUTE\', participant)"><i class="icon-mic"></i><div class="action-tooltip mute-tooltip">{{ $ctrl.labels.mute }}</div></div><div class="action-btn unmute-btn" ng-if="!participant.isActPerson &amp;&amp; !$ctrl.hasAudio(participant)" ng-click="$ctrl.moderatorAction(\'UNMUTE\', participant)"><i class="icon-mic-off"></i><div class="action-tooltip unmute-tooltip">{{ $ctrl.labels.ask_unmute }}</div></div><div class="action-btn pin-btn" ng-if="!$ctrl.isPinned(participant)" ng-click="$ctrl.pinParticipant(participant.id)"><i class="icon-pin-outline"></i><div class="action-tooltip pin-tooltip">{{ $ctrl.labels.pin }}</div></div><div class="action-btn unpin-btn" ng-if="$ctrl.isPinned(participant)" ng-click="$ctrl.pinParticipant(participant.id)"><i class="icon-pin-filled"></i><div class="action-tooltip unpin-tooltip">{{ $ctrl.labels.unpin }}</div></div><div class="action-btn show-actions-btn" ng-if="!participant.isActPerson" ng-click="$ctrl.selectPax($event, participant)"><i class="icon-dots-three-vertical"></i><div class="action-tooltip more-tooltip">{{ $ctrl.labels.more_actions }}</div></div></div><div class="actions" ng-if="!$ctrl.showModeratorControls &amp;&amp; !participant.isActPerson"><div class="action-btn send-message-btn" ng-if="$ctrl.enableMessages" ng-class="{ \'disabled\': $ctrl.shouldDisableOpenPaxChat(participant.id) }" ng-click="$ctrl.openChat(participant.id)"><i class="icon-messages"></i><div class="action-tooltip send-message-tooltip">{{ ::\'video_calls.labels.send_message\' | i18n }}</div><div class="action-tooltip already-on-chat-tooltip">{{ $ctrl.labels.chat_opened }}</div></div><div class="action-btn add-contact-btn" ng-if="participant.bcxStatus &amp;&amp; participant.bcxStatus !== \'approved\'" ng-class="{ \'disabled\': participant.bcxStatus === \'pending\' }" ng-click="$ctrl.addContact(participant.id)"><i class="icon-user-add"></i><div class="action-tooltip add-contact-tooltip">{{ ::\'video_calls.labels.add_to_contacts\' | i18n }}</div><div class="action-tooltip request-sent-tooltip">{{ ::\'video_calls.labels.request_sent\' | i18n }}</div></div></div></div></div><div class="list-footer" ng-if="$ctrl.showModeratorControls"><button class="mute-all" ng-click="$ctrl.moderatorAction(\'FORCE_MUTE\')">{{ $ctrl.labels.mute_all }}</button><button class="unmute-all" ng-click="$ctrl.moderatorAction(\'UNMUTE\')">{{ $ctrl.labels.ask_all_unmute }}</button></div></div><div class="action-list" ng-show="$ctrl.selectedPax"><ul><li ng-if="$ctrl.enableMessages"><button class="option" ng-click="$ctrl.openChat($ctrl.selectedPax.id)"><i class="icon-messages"></i><span>{{ $ctrl.labels.send_message }}</span></button></li><li ng-if="$ctrl.selectedPax.bcxStatus &amp;&amp; $ctrl.selectedPax.bcxStatus !== \'approved\'"><button class="option" ng-click="$ctrl.addContact($ctrl.selectedPax.id)"><i class="icon-user-add"></i><span>{{ $ctrl.labels.add_to_contacts }}</span></button></li><li ng-if="$ctrl.showModeratorControls &amp;&amp; !$ctrl.isOwnPublisher"><button class="option" ng-click="$ctrl.moderatorAction(\'KICKOUT\', $ctrl.selectedPax)"><i class="icon-kick-out"></i><span>{{ $ctrl.labels.kickout }}</span></button></li></ul></div>';
},{}],125:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PublisherComponent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
var _dom = require("../../../utils/dom");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var PUBLISHER_RESOLUTION = {
  width: 1280,
  height: 720
};
var PublisherComponent = {
  bindings: {
    publisher: '=',
    audioOn: '=',
    conversationId: '<',
    videoOn: '=',
    session: '=',
    name: '<',
    pid: '<',
    screenShareActive: '<',
    showModeratorControls: '=',
    isPinned: '<',
    testOptions: '='
  },
  template: require('./publisher.pug'),
  controller: function () {
    PublisherComponent.$inject = ["$scope", "$element", "mediaDevicesService", "$eventBus", "triggerService", "crashReportingService", "$timeout"];
    /* @ngInject */
    function PublisherComponent($scope, $element, mediaDevicesService, $eventBus, triggerService, crashReportingService, $timeout) {
      (0, _classCallCheck2.default)(this, PublisherComponent);
      this.$scope = $scope;
      this.$eventBus = $eventBus;
      this.$element = $element;
      this.mediaDevicesService = mediaDevicesService;
      this.triggerService = triggerService;
      this.crashReportingService = crashReportingService;
      this.$timeout = $timeout;
      this.listeners = [];
      this.addErrorTriggers();
      this.addEventListeners();
      this.addMediaStreamTrackErrorHandlers();
    }
    (0, _createClass2.default)(PublisherComponent, [{
      key: "$postLink",
      value: function $postLink() {
        this.publisherVideoEl = this.$element.find('.publisher-video')[0];
        this.initPublisher();
        this.listeners.push((0, _dom.addEventListener)(this.publisherVideoEl, 'contextmenu', function (e) {
          return e.preventDefault();
        }));
      }
    }, {
      key: "addEventListeners",
      value: function addEventListeners() {
        var updateVideoSourceListener = this.$scope.$on('publisher:updateVideoSource', this.updateVideoSource.bind(this));
        var updateAudioSourceListener = this.$scope.$on('publisher:updateAudioSource', this.updateAudioSource.bind(this));
        this.listeners.push(updateVideoSourceListener, updateAudioSourceListener);
      }
    }, {
      key: "$onDestroy",
      value: function $onDestroy() {
        var _iterator = _createForOfIteratorHelper(this.listeners),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var unsub = _step.value;
            if ((0, _lodash.isFunction)(unsub)) {
              unsub();
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        this.publisher.off();
        this.publisher.destroy();
        this.publisher = null;
      }
    }, {
      key: "initPublisher",
      value: function initPublisher() {
        this.options = {
          insertMode: 'append',
          width: '100%',
          height: '100%',
          fitMode: 'contain',
          showControls: false,
          publishAudio: this.audioOn,
          publishVideo: this.videoOn,
          name: this.name,
          mirror: true,
          videoSource: this.mediaDevicesService.permissions.video ? this.mediaDevicesService.videoDeviceSelected : null,
          audioSource: this.mediaDevicesService.permissions.audio ? this.mediaDevicesService.audioDeviceSelected : null
        };
        if ((0, _lodash.get)(this, 'testOptions.videoFilter')) {
          this.options.videoFilter = this.testOptions.videoFilter;
        }
        var resolutionReductionFactor = (0, _lodash.get)(this, 'testOptions.reducePublisherResolutionByFactor', 1);
        this.options.resolution = PUBLISHER_RESOLUTION.width / resolutionReductionFactor + 'x' + PUBLISHER_RESOLUTION.height / resolutionReductionFactor;
        console.log('[Publisher component] initiating publisher with options', this.options);
        this.publisher = OT.initPublisher(this.publisherVideoEl, this.options, this.publishToSession.bind(this));
        this.addPublisherListeners();
      }
    }, {
      key: "addPublisherListeners",
      value: function addPublisherListeners() {
        var _this = this;
        this.publisher.on('streamCreated', function () {
          _this.$scope.$emit('publisher:created', _this.publisher);
          _this.$eventBus.emit("chat:updatecall:".concat(_this.conversationId));
          _this.addAudioMediaTrackListeners();
          _this.addVideoMediaTrackListeners();
        });
        this.publisher.on('accessDenied', function (event) {
          console.error('[Publisher component] user have prevented access to camera and microphone, or screen share on some machine', event);
          _this.crashReportingService.reportError('Publisher component', 'publisher error', (0, _lodash.omit)(event, ['stack']));
          _this.$scope.$emit('publisher:accessDenied');
        });
        this.publisher.on('destroyed', function (event) {
          console.error('[Publisher component] publisher destroyed');
          _this.handleError(event);
        });
        this.publisher.on('streamDestroyed', function (event) {
          console.error('[Publisher component] publisher stream destroyed');
          event.preventDefault();
          _this.publishToSession();
        });
      }
    }, {
      key: "publishToSession",
      value: function publishToSession(err) {
        var _this2 = this;
        if (err) return this.handleError(err);
        this.session.publish(this.publisher, function (err) {
          if (err) {
            return _this2.handleError(err);
          }
          _this2.$scope.$emit('publisher:published');
          console.log('[Publisher component] publisher published');
        });
      }
    }, {
      key: "updateAudioSource",
      value: function updateAudioSource() {
        var _this3 = this;
        this.removeAudioMediaTrackListeners();
        this.publisher.setAudioSource(this.mediaDevicesService.audioDeviceSelected.deviceId).then(function (err) {
          if (err) {
            return _this3.$scope.$emit('publisher:deviceChangeError', err);
          }
          _this3.addAudioMediaTrackListeners();
        });
      }
    }, {
      key: "updateVideoSource",
      value: function updateVideoSource() {
        var _this4 = this;
        this.removeVideoMediaTrackListeners();
        this.publisher.setVideoSource(this.mediaDevicesService.videoDeviceSelected.deviceId).then(function (err) {
          if (err) {
            return _this4.$scope.$emit('publisher:deviceChangeError', err);
          }
          _this4.addVideoMediaTrackListeners();
        });
      }
    }, {
      key: "addVideoMediaTrackListeners",
      value: function addVideoMediaTrackListeners() {
        var mediaStreamTrack = this.publisher.getVideoSource().track;
        if (!mediaStreamTrack) {
          return;
        }
        mediaStreamTrack.addEventListener('ended', this.onVideoMediaStreamTrackEnded);
        mediaStreamTrack.addEventListener('mute', this.onVideoMediaStreamTrackMuted);
      }
    }, {
      key: "addAudioMediaTrackListeners",
      value: function addAudioMediaTrackListeners() {
        var mediaStreamTrack = this.publisher.getAudioSource();
        if (!mediaStreamTrack) {
          return;
        }
        mediaStreamTrack.addEventListener('ended', this.onAudioMediaStreamTrackEnded);
        mediaStreamTrack.addEventListener('mute', this.onAudioMediaStreamTrackMuted);
      }
    }, {
      key: "removeVideoMediaTrackListeners",
      value: function removeVideoMediaTrackListeners() {
        try {
          var mediaStreamTrack = this.publisher.getVideoSource().track;
          if (!mediaStreamTrack) {
            return;
          }
          mediaStreamTrack.removeEventListener('ended', this.onVideoMediaStreamTrackEnded);
          mediaStreamTrack.removeEventListener('mute', this.onVideoMediaStreamTrackMuted);
        } catch (e) {
          console.error(e);
        }
      }
    }, {
      key: "removeAudioMediaTrackListeners",
      value: function removeAudioMediaTrackListeners() {
        try {
          var mediaStreamTrack = this.publisher.getAudioSource();
          if (!mediaStreamTrack) {
            return;
          }
          mediaStreamTrack.removeEventListener('ended', this.onAudioMediaStreamTrackEnded);
          mediaStreamTrack.removeEventListener('mute', this.onAudioMediaStreamTrackMuted);
        } catch (e) {
          console.error(e);
        }
      }
    }, {
      key: "addMediaStreamTrackErrorHandlers",
      value: function addMediaStreamTrackErrorHandlers() {
        var _this5 = this;
        var onAudioMediaStreamTrackIssue = function onAudioMediaStreamTrackIssue(event) {
          console.log('[Publisher component] audio mediaStreamTrack has ' + event);
          _this5.crashReportingService.reportError('Publisher component', 'audio media stream track', event);
          _this5.$timeout(function () {
            _this5.updateAudioSource();
          }, 1000);
        };
        var onVideoMediaStreamTrackEnded = function onVideoMediaStreamTrackEnded(event) {
          console.log('[Publisher component] video mediaStreamTrack has ' + event);
          _this5.crashReportingService.reportError('Publisher component', 'video media stream track ', event);
          _this5.$timeout(function () {
            _this5.updateVideoSource();
          }, 1000);
        };
        this.onAudioMediaStreamTrackEnded = function () {
          onAudioMediaStreamTrackIssue('ended');
        };
        this.onVideoMediaStreamTrackEnded = function () {
          onVideoMediaStreamTrackEnded('ended');
        };
        this.onAudioMediaStreamTrackMuted = function () {
          onAudioMediaStreamTrackIssue('mute');
        };
        this.onVideoMediaStreamTrackMuted = function () {
          onVideoMediaStreamTrackEnded('mute');
        };
      }
    }, {
      key: "addErrorTriggers",
      value: function addErrorTriggers() {
        var _this6 = this;
        this.listeners.push(this.triggerService.addTrigger('destroyPublisher', function () {
          _this6.publisher.destroy();
        }), this.triggerService.addTrigger('destroyPublisherStream', function () {
          _this6.publisher.stream.destroy();
        }), this.triggerService.addTrigger('destroyPublisherVideoMediaTrack', function () {
          var mediaStreamTrack = _this6.publisher.getVideoSource().track;
          mediaStreamTrack.stop();
          mediaStreamTrack.dispatchEvent(new Event('ended'));
        }), this.triggerService.addTrigger('destroyPublisherAudioMediaTrack', function () {
          var mediaStreamTrack = _this6.publisher.getAudioSource();
          mediaStreamTrack.stop();
          mediaStreamTrack.dispatchEvent(new Event('ended'));
        }));
      }
    }, {
      key: "handleError",
      value: function handleError(e) {
        if (e) {
          console.error('[Publisher component] handleError', e);
          this.$scope.$emit('publisher:error');
          this.crashReportingService.reportError('Publisher component', 'publisher error', (0, _lodash.omit)(e, ['stack', 'target', 'stream', '_defaultPrevented']));
        }
      }
    }]);
    return PublisherComponent;
  }()
};
exports.PublisherComponent = PublisherComponent;

},{"../../../utils/dom":355,"./publisher.pug":126,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"lodash":"lodash"}],126:[function(require,module,exports){
module.exports = '<div class="publisher-video"></div><div class="invisible-overlay"></div><div class="talking-indicator-border"></div><div class="blank" ng-if="!$ctrl.videoOn"></div><div class="name"><i class="icon-mic-off" ng-if="!$ctrl.audioOn"></i><span ng-if="$ctrl.screenShareActive">{{ \'conversation_nav.details.you\' | i18n }}</span><span ng-if="!$ctrl.screenShareActive">{{ $ctrl.name }} ({{ \'conversation_nav.details.you\' | i18n }})</span></div><div class="initials-wrapper" ng-if="!$ctrl.videoOn"><div class="initials">{{ $ctrl.name | takeInitials }}</div></div><moderator-options ng-if="$ctrl.publisher &amp;&amp; $ctrl.showModeratorControls" is-own-publisher="true" session="$ctrl.session" ot-object="$ctrl.publisher" is-pinned="$ctrl.isPinned" show-moderator-controls="$ctrl.showModeratorControls" pid="$ctrl.pid"></moderator-options>';
},{}],127:[function(require,module,exports){
"use strict";

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
module.exports.videoElementSanityCheck = function (element, checkAudio, checkVideo) {
  if (!element || !element.srcObject) {
    console.warn('[SanityCheck] mediaStreamSanityCheck failed', element);
    return false;
  }
  var mediaStream = element.srcObject;
  var audioMediaStreamTracks = mediaStream.getAudioTracks() || [];
  var videoMediaStreamTracks = mediaStream.getVideoTracks() || [];
  return mediaStreamSanityCheck(mediaStream) && (checkAudio ? mediaStreamTracksSanityCheck(audioMediaStreamTracks) : true) && (checkVideo ? mediaStreamTracksSanityCheck(videoMediaStreamTracks) : true);
};
var mediaStreamSanityCheck = function mediaStreamSanityCheck(mediaStream) {
  var sane = mediaStream.active;
  if (!sane) {
    console.warn('[SanityCheck] mediaStreamSanityCheck failed', mediaStream);
  }
  return sane;
};
var mediaStreamTracksSanityCheck = function mediaStreamTracksSanityCheck(mediaStreamTracks) {
  if (!mediaStreamTracks || !mediaStreamTracks.length) {
    console.warn('[SanityCheck] mediaStreamTracksSanityCheck failed', mediaStreamTracks);
    return false;
  }
  var _iterator = _createForOfIteratorHelper(mediaStreamTracks),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var mediaStreamTrack = _step.value;
      if (mediaStreamTrackSanityCheck(mediaStreamTrack)) {
        return true;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return false;
};
var mediaStreamTrackSanityCheck = function mediaStreamTrackSanityCheck(mediaStreamTrack) {
  if (!mediaStreamTrack) {
    console.warn('[SanityCheck] mediaStreamTrackSanityCheck failed', mediaStreamTrack);
    return false;
  }
  var sane = mediaStreamTrack && mediaStreamTrack.readyState === 'live' && !mediaStreamTrack.muted && mediaStreamTrack.enabled;
  if (!sane) {
    console.warn('[SanityCheck] mediaStreamTrackSanityCheck failed', mediaStreamTrack);
  }
  return sane;
};

},{}],128:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubscriberComponent = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
var _eventEmitter = _interopRequireDefault(require("../../../utils/event-emitter"));
var _dom = require("../../../utils/dom");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var SubscriberComponent = {
  bindings: {
    session: '=',
    conversationId: '<',
    hasVideo: '<',
    hasAudio: '<',
    isVisible: '<',
    isPinned: '<',
    name: '<',
    subscriber: '=',
    publisherPublished: '=',
    showModeratorControls: '='
  },
  template: require('./subscriber.pug'),
  controller: function () {
    SubscriberComponent.$inject = ["$i18n", "$scope", "$element", "$eventBus", "$timeout"];
    /* @ngInject */
    function SubscriberComponent($i18n, $scope, $element, $eventBus, $timeout) {
      (0, _classCallCheck2.default)(this, SubscriberComponent);
      this.$scope = $scope;
      this.$eventBus = $eventBus;
      this.$element = $element;
      this.listeners = [];
      this.showSubscriberOptions = false;
      this.hideModeratorControls = true;
      this.eventEmitter = new _eventEmitter.default($timeout);
    }
    (0, _createClass2.default)(SubscriberComponent, [{
      key: "$postLink",
      value: function $postLink() {
        this.init();
      }
    }, {
      key: "init",
      value: function () {
        var _init = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee() {
          var _this = this;
          var subscriberEl;
          return _regenerator.default.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                subscriberEl = this.$element.find('.subscriber-video').get(0);
                this.listeners.push((0, _dom.addEventListener)(subscriberEl, 'contextmenu', function (e) {
                  return e.preventDefault();
                }));
                _context.next = 5;
                return this.subscriber.init(subscriberEl, this.eventEmitter, {
                  subscribeToAudio: this.publisherPublished
                });
              case 5:
                this.$eventBus.emit("chat:updatecall:".concat(this.conversationId));
                this.$scope.$emit('subscriber:initiated', this.subscriber);
                console.log('adding the listener with ', this.subscriber);
                this.listeners.push(this.$scope.$on('layout:changed', function (event, layoutData) {
                  _this.subscriber.adaptResolution(layoutData);
                }), this.eventEmitter.addEventListener('subscriber:subscribed', function () {
                  console.log('[Subscriber] subscriber was properly resubscribed');
                }), this.$scope.$watch('$ctrl.publisherPublished', function () {
                  return _this.subscribeToAudio();
                }, true));
                this.subscribeToAudio();
                this.hideModeratorControls = !this.showModeratorControls;
                this.$scope.$applyAsync();
                _context.next = 17;
                break;
              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](0);
                this.handleError(_context.t0);
              case 17:
              case "end":
                return _context.stop();
            }
          }, _callee, this, [[0, 14]]);
        }));
        function init() {
          return _init.apply(this, arguments);
        }
        return init;
      }()
    }, {
      key: "subscribeToAudio",
      value: function subscribeToAudio() {
        if (this.publisherPublished && (0, _lodash.isFunction)((0, _lodash.get)(this, 'subscriber.otSubscriberObject.subscribeToAudio'))) {
          this.subscriber.otSubscriberObject.subscribeToAudio(true);
        }
      }
    }, {
      key: "$onDestroy",
      value: function $onDestroy() {
        this.subscriber.destroy();
        var _iterator = _createForOfIteratorHelper(this.listeners),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var listener = _step.value;
            if ((0, _lodash.isFunction)(listener)) {
              listener();
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        this.listeners = [];
      }
    }, {
      key: "handleError",
      value: function handleError(err) {
        if (err) console.error('[Subscriber] handle error', err);
      }
    }]);
    return SubscriberComponent;
  }()
};
exports.SubscriberComponent = SubscriberComponent;

},{"../../../utils/dom":355,"../../../utils/event-emitter":357,"./subscriber.pug":129,"@babel/runtime/helpers/asyncToGenerator":375,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/regenerator":398,"lodash":"lodash"}],129:[function(require,module,exports){
module.exports = '<div class="subscriber-video"></div><div class="invisible-overlay"></div><div class="talking-indicator-border"></div><div class="blank" ng-if="!$ctrl.hasVideo"></div><div class="name"><i class="icon-mic-off" ng-if="!$ctrl.hasAudio"></i><span>{{ $ctrl.name }}</span></div><div class="initials-wrapper" ng-if="!$ctrl.hasVideo"><div class="initials">{{ $ctrl.name | takeInitials }}</div></div><moderator-options ng-if="!$ctrl.hideModeratorControls" session="$ctrl.session" ot-object="$ctrl.subscriber.otSubscriberObject" is-pinned="$ctrl.isPinned" show-moderator-controls="$ctrl.showModeratorControls" has-audio="$ctrl.hasAudio" pid="$ctrl.subscriber.pid" name="$ctrl.name"></moderator-options>';
},{}],130:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoCallModalComponent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var VideoCallModalComponent = {
  bindings: {
    params: '='
  },
  template: require('./video-call-modal.pug'),
  controller: function () {
    function VideoCallModalComponent() {
      (0, _classCallCheck2.default)(this, VideoCallModalComponent);
    }
    (0, _createClass2.default)(VideoCallModalComponent, [{
      key: "buttonClicked",
      value: function buttonClicked(buttonOptions) {
        buttonOptions.action();
      }
    }]);
    return VideoCallModalComponent;
  }()
};
exports.VideoCallModalComponent = VideoCallModalComponent;

},{"./video-call-modal.pug":131,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382}],131:[function(require,module,exports){
module.exports = '<span class="title">{{ $ctrl.params.title }}</span><span class="hint" ng-bind-html="$ctrl.params.hint"></span><button class="unmute" ng-if="$ctrl.params.buttonValidate" ng-click="$ctrl.buttonClicked($ctrl.params.buttonValidate)">{{ $ctrl.params.buttonValidate.label }}</button><button class="cancel" ng-click="$ctrl.buttonClicked($ctrl.params.buttonCancel)">{{ $ctrl.params.buttonCancel.label }}</button>';
},{}],132:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoCallV2Component = void 0;
require("frontend-real-time-com-toolkit/dist/frontend-real-time-com-toolkit.umd.js");
var VideoCallV2Component = {
  template: require('./video-call-v2.pug')
};
exports.VideoCallV2Component = VideoCallV2Component;

},{"./video-call-v2.pug":133,"frontend-real-time-com-toolkit/dist/frontend-real-time-com-toolkit.umd.js":1104}],133:[function(require,module,exports){
module.exports = '<div class="video-call video-call-v2"><spotme-rtc-breakouts></spotme-rtc-breakouts></div>';
},{}],134:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoCallComponent = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _lodash = require("lodash");
var _DeviceManager2 = require("./DeviceManager");
var _i18nWithFallback = _interopRequireDefault(require("../../../utils/i18n-with-fallback"));
var _BroadcastLayout = require("./BroadcastLayout");
var _videoCallModeratorService = require("../../../services/videoCallModeratorService");
var _Subscriber = require("./Subscriber");
var _sanityChecks = require("./sanity-checks");
var _eventEmitter = _interopRequireDefault(require("../../../utils/event-emitter"));
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = (0, _getPrototypeOf2.default)(t); if (r) { var s = (0, _getPrototypeOf2.default)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0, _possibleConstructorReturn2.default)(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var ROOM_CAPACITY = 50;
var USERS_PER_PAGE = 12;
var USERS_PER_SHARE_SCREEN_PAGE = 6;
var LAYOUT_CHANGE_THROTTLES = 500;
var MAX_SCREENSHARE_RESOLUTION = {
  width: 1280,
  height: 720
};
var SCREENSHARE_CONTENT_HINT = '';
var VideoCallComponent = {
  bindings: {
    actions: '=',
    conversationId: '<',
    sessionId: '<',
    docType: '<',
    parentDocumentId: '<'
  },
  template: require('./video-call.pug'),
  controller: function (_DeviceManager) {
    VideoCallComponent.$inject = ["ACTIVATED_PERSON", "crashReportingService", "$scope", "videoCallService", "videoCallModeratorService", "videoBreakoutService", "databaseService", "metricsService", "libLoaderService", "$i18n", "$http", "$element", "$eventBus", "$sce", "$timeout", "$interval", "$filter", "mediaDevicesService", "signalService", "triggerService", "uiService"];
    (0, _inherits2.default)(VideoCallComponent, _DeviceManager);
    var _super = _createSuper(VideoCallComponent);
    /* @ngInject */
    function VideoCallComponent(ACTIVATED_PERSON, crashReportingService, $scope, videoCallService, videoCallModeratorService, videoBreakoutService, databaseService, metricsService, libLoaderService, $i18n, $http, $element, $eventBus, $sce, $timeout, $interval, $filter, mediaDevicesService, signalService, triggerService, uiService) {
      var _this;
      (0, _classCallCheck2.default)(this, VideoCallComponent);
      _this = _super.call(this, mediaDevicesService, $eventBus, $scope);
      _this.ACTIVATED_PERSON = ACTIVATED_PERSON;
      _this._videoCallService = videoCallService;
      _this._videoBreakoutService = videoBreakoutService;
      _this.videoCallModeratorService = videoCallModeratorService;
      _this.crashReportingService = crashReportingService;
      _this.triggerService = triggerService;
      _this.uiService = uiService;
      _this.libLoaderService = libLoaderService;
      _this.dbService = databaseService;
      _this.$http = $http;
      _this.$i18n = $i18n;
      _this.$sce = $sce;
      _this.$element = $element;
      _this.$timeout = $timeout;
      _this.$interval = $interval;
      _this.$filter = $filter;
      _this.publisherTestOptions = {};
      _this.publisher = null;
      _this.participants = [];
      _this.subscribers = [];
      _this.pinnedParticipants = [];
      _this.talkingOrder = [];
      _this.showAudioInputs = false;
      _this.showVideoInputs = false;
      _this.showAskToUnmute = false;
      _this.layoutData = {};
      _this.errorMessage = null;
      _this.showReconnectionMessage = false;
      _this.metricsService = metricsService;
      _this.signalService = signalService;
      _this.publisherPublished = false;
      _this.eventEmitter = new _eventEmitter.default($timeout);
      _this.showCall = false;
      _this.showSpinner = true;
      _this.numberOfAutoReconnect = 0;
      _this.listeners = [];
      _this.sessionListeners = [{
        event: 'streamCreated',
        handler: _this.onStreamCreated.bind((0, _assertThisInitialized2.default)(_this))
      }, {
        event: 'streamDestroyed',
        handler: _this.onStreamDestroyed.bind((0, _assertThisInitialized2.default)(_this))
      }, {
        event: 'streamPropertyChanged',
        handler: _this.onStreamPropertyChanged.bind((0, _assertThisInitialized2.default)(_this))
      }, {
        event: 'connectionDestroyed',
        handler: _this.removeParticipant.bind((0, _assertThisInitialized2.default)(_this))
      }, {
        event: 'sessionDisconnected',
        handler: _this.onSessionDisconnected.bind((0, _assertThisInitialized2.default)(_this))
      }];
      _this.labels = {
        you_were_disconnected: (0, _i18nWithFallback.default)($i18n, 'video_calls.labels.you_were_disconnected', 'You were disconnected from the call'),
        auto_reconnect_in: (0, _i18nWithFallback.default)($i18n, 'video_calls.labels.auto_reconnect_in', 'You will be automatically reconnected in'),
        reconnect_now: (0, _i18nWithFallback.default)($i18n, 'video_calls.actions.reconnect_now', 'Reconnect now'),
        unmute_modal_title: (0, _i18nWithFallback.default)($i18n, 'video_calls.unmute_modal.title', 'Unmute microphone'),
        unmute_modal_hint: (0, _i18nWithFallback.default)($i18n, 'video_calls.unmute_modal.hint', 'The moderator is asking you to unmute yourself.'),
        unmute: (0, _i18nWithFallback.default)($i18n, 'video_calls.unmute', 'Unmute'),
        cancel: (0, _i18nWithFallback.default)($i18n, 'video_calls.cancel', 'Cancel'),
        screen_error_modal_title: (0, _i18nWithFallback.default)($i18n, 'video_calls.screen_error_modal_title', 'Screen sharing not available'),
        screen_error_modal_hint: (0, _i18nWithFallback.default)($i18n, 'video_calls.screen_error_modal_hint', 'Please grant screen share access in the privacy settings.'),
        more_info: (0, _i18nWithFallback.default)($i18n, 'video_calls.more_info', 'More info'),
        kickout_participant: (0, _i18nWithFallback.default)($i18n, 'video_calls.kickout_participant', 'Kickout Participant'),
        confirm_kickout_participant: (0, _i18nWithFallback.default)($i18n, 'video_calls.confirm_kickout_participant', 'Are you sure you want to kickout this participant'),
        kickout: (0, _i18nWithFallback.default)($i18n, 'video_calls.kickout', 'Kick out'),
        moderator: (0, _i18nWithFallback.default)($i18n, 'video_calls.moderator', 'Moderator'),
        moderator_removed_you: (0, _i18nWithFallback.default)($i18n, 'video_calls.moderator_removed_you', 'The moderator removed you from the meeting.')
      };
      _this.askToUnmuteModal = {
        title: _this.labels.unmute_modal_title,
        hint: _this.labels.unmute_modal_hint,
        buttonValidate: {
          label: _this.labels.unmute,
          action: function action() {
            _this.toggleAudio(true);
            _this.showAskToUnmute = false;
          }
        },
        buttonCancel: {
          label: _this.labels.cancel,
          action: function action() {
            _this.showAskToUnmute = false;
          }
        }
      };
      _this.screenShareErrorModal = {
        title: _this.labels.screen_error_modal_title,
        hint: "<span> ".concat(_this.labels.screen_error_modal_hint, " </span>\n                        <a target=\"_blank\" href=\"https://support.spotme.com/hc/en-us/articles/360062337193-How-to-allow-screen-sharing-for-your-browser-on-Mac\">\n                        ").concat(_this.labels.more_info, "</a>"),
        buttonCancel: {
          label: _this.labels.cancel,
          action: function action() {
            _this.showScreenShareErrorModal = false;
          }
        }
      };
      _this.keyDownEscapeHandler = function (e) {
        if (!e || e.key !== 'Escape') {
          return;
        }
        _this.toggleFullScreen(false);
      };
      var setPages = function setPages() {
        var usersPerPage = _this.getNumberOfUserPerPage();
        _this.subscribers = _this.subscribers.filter(function (subscriber) {
          return !_this.hasDeadStream(subscriber);
        });
        for (var i in _this.subscribers) {
          var talkingPosition = _this.talkingOrder.indexOf(_this.subscribers[i].pid);
          talkingPosition = talkingPosition < 0 ? ROOM_CAPACITY : talkingPosition;
          _this.subscribers[i].setPinned(_this.pinnedParticipants.includes(_this.subscribers[i].pid));
          _this.subscribers[i].setTalkingPosition(talkingPosition);
        }
        _this.subscribers = _this.subscribers.sort(function (a, b) {
          if (a.isPinned && !b.isPinned) {
            return -1;
          } else if (!a.isPinned && b.isPinned) {
            return 1;
          } else if (a.isPinned && b.isPinned) {
            return 0;
          } else if (_this.subscribers.length > usersPerPage - 1) {
            if (a.talkingPosition < b.talkingPosition) {
              return -1;
            } else if (b.talkingPosition < a.talkingPosition) {
              return 1;
            }
          }
          return 0;
        });
        for (var _i = 0; _i < _this.subscribers.length; _i++) {
          _this.subscribers[_i].index = _i % (usersPerPage - 1) + 1;
        }
        _this.pages = (0, _lodash.chunk)(_this.subscribers, usersPerPage - 1);
        var pageIndex = _this.currentPage ? _this.currentPage.index : 0;
        _this.goToPage(pageIndex);
        (0, _lodash.each)(_this.subscribers, function (subscriber) {
          subscriber.show = !!_this.currentPage.subscribers[subscriber.stream.streamId];
        });
        _this.setLayout();
      };
      var setLayout = function setLayout() {
        var style = _this.$element.find('style')[0];
        if (!style) {
          return;
        }
        var count = (0, _lodash.get)((0, _assertThisInitialized2.default)(_this), 'currentPage.size', 0) + 1;
        _this.layout = count ? _this.isSomeContentShared() ? (0, _BroadcastLayout.share)(count) : (0, _BroadcastLayout.bestFit)(count) : (0, _BroadcastLayout.bestFit)(1);
        style.textContent = _this.layout;
        count--;
        _this.layoutData.fitValues = count ? _this.isSomeContentShared() ? _BroadcastLayout.SHARE_VALUES[count] : _BroadcastLayout.BEST_FIT_VALUES[count] : _BroadcastLayout.BEST_FIT_VALUES[0];
        _this.setSubscribersVisibility();
        _this.adaptSubscriberResolution();
        _this.$scope.$applyAsync();
      };
      _this.setLayout = (0, _lodash.throttle)(function () {
        setLayout();
      }, LAYOUT_CHANGE_THROTTLES);
      _this.setPages = (0, _lodash.throttle)(function () {
        setPages();
      }, LAYOUT_CHANGE_THROTTLES);
      _this.listeners.push(_this.triggerService.addTrigger('destroySession', function () {
        _this.session.disconnect();
      }), _this.triggerService.addTrigger('setScreenShareResolution', function (width, height) {
        MAX_SCREENSHARE_RESOLUTION = {
          width: width,
          height: height
        };
      }), _this.triggerService.addTrigger('setScreenShareContentHint', function (newVal) {
        SCREENSHARE_CONTENT_HINT = newVal;
      }), _this.triggerService.addTrigger('reducePublisherResolutionByFactor', function () {
        var f = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
        _this.publisherTestOptions.reducePublisherResolutionByFactor = f;
      }), _this.triggerService.addTrigger('setNumberOfUserPerPage', function () {
        var newVal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 12;
        var newScreenShareVal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
        USERS_PER_PAGE = Math.min(newVal, 12);
        USERS_PER_SHARE_SCREEN_PAGE = Math.min(newScreenShareVal, 6);
        _this.setPages();
      }), _this.triggerService.addTrigger('testVideoCall', (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee2() {
        var sleep;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              sleep = function () {
                var _sleep = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee(ms) {
                  return _regenerator.default.wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        return _context.abrupt("return", new Promise(function (resolve) {
                          return setTimeout(resolve, ms);
                        }));
                      case 1:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                function sleep(_x) {
                  return _sleep.apply(this, arguments);
                }
                return sleep;
              }();
              window.triggers.destroySession();
              _context2.next = 4;
              return sleep(20 * 1000);
            case 4:
              window.triggers.destroyPublisher();
              _context2.next = 7;
              return sleep(20 * 1000);
            case 7:
              window.triggers.destroyPublisherStream();
              _context2.next = 10;
              return sleep(6 * 1000);
            case 10:
              window.triggers.destroyPublisherVideoMediaTrack();
              _context2.next = 13;
              return sleep(6 * 1000);
            case 13:
              window.triggers.destroyPublisherAudioMediaTrack();
              _context2.next = 16;
              return sleep(6 * 1000);
            case 16:
              window.triggers.destroySubscriber();
              _context2.next = 19;
              return sleep(6 * 1000);
            case 19:
              window.triggers.stopSubscriberMediaTracks();
              _context2.next = 22;
              return sleep(6 * 1000);
            case 22:
              window.triggers.stopSubscriberAudioMediaStreamTrack();
              _context2.next = 25;
              return sleep(6 * 1000);
            case 25:
              window.triggers.stopSubscriberVideoMediaStreamTrack();
              _context2.next = 28;
              return sleep(6 * 1000);
            case 28:
              console.debug('[VideoCalls] all error triggers were called, hopefully video and audio was restored between each interruption!');
            case 29:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))), _this.triggerService.addTrigger('enableScreenShareSimulcast', function (val) {
        _this.enableScreenShareSimulcast = val;
      }), _this.triggerService.addTrigger('enableVideoFilter', function (filter) {
        _this.publisherTestOptions.videoFilter = filter || {
          type: 'backgroundBlur',
          blurStrength: 'high'
        };
      }));
      return _this;
    }
    (0, _createClass2.default)(VideoCallComponent, [{
      key: "$onInit",
      value: function () {
        var _$onInit = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee7() {
          var _this2 = this;
          var onPublisherPublished, pinParticipant, isTalking, updateModerators, showKickoutModal, notifyOfBeingKickedOut;
          return _regenerator.default.wrap(function _callee7$(_context7) {
            while (1) switch (_context7.prev = _context7.next) {
              case 0:
                this.videoCallService = this.conversationId ? this._videoCallService : this._videoBreakoutService;
                this.inCall = false;
                this.videoCallId = this.sessionId;
                this.OTexceptionHandler = function () {
                  var _ref2 = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee3(err) {
                    var errorMessage, videostream, audiostream;
                    return _regenerator.default.wrap(function _callee3$(_context3) {
                      while (1) switch (_context3.prev = _context3.next) {
                        case 0:
                          console.error('[video call component] OT exception', err);
                          errorMessage = (0, _lodash.pick)(err, ['code', 'message', 'title', 'type']);
                          _context3.prev = 2;
                          _context3.next = 5;
                          return _this2.mediaDevicesService.getUserMedia({
                            video: true,
                            audio: false
                          });
                        case 5:
                          videostream = _context3.sent;
                          errorMessage.videoStream = {
                            active: videostream.active,
                            track: (0, _lodash.pick)(videostream.getVideoTracks()[0], ['enabled', 'kind', 'label', 'muted', 'readyState'])
                          };
                          _context3.next = 12;
                          break;
                        case 9:
                          _context3.prev = 9;
                          _context3.t0 = _context3["catch"](2);
                          errorMessage.videoStreamError = (0, _lodash.pick)(_context3.t0, ['message', 'name']);
                        case 12:
                          _context3.prev = 12;
                          _context3.next = 15;
                          return _this2.mediaDevicesService.getUserMedia({
                            audio: true,
                            video: false
                          });
                        case 15:
                          audiostream = _context3.sent;
                          errorMessage.audioStream = {
                            active: audiostream.active,
                            track: (0, _lodash.pick)(audiostream.getAudioTracks()[0], ['enabled', 'kind', 'label', 'muted', 'readyState'])
                          };
                          _context3.next = 22;
                          break;
                        case 19:
                          _context3.prev = 19;
                          _context3.t1 = _context3["catch"](12);
                          errorMessage.audioStreamError = (0, _lodash.pick)(_context3.t1, ['message', 'name']);
                        case 22:
                          _this2.mediaDevicesService.stopAllStreams();
                          _this2.crashReportingService.reportError('Video call component', 'OT exception handler', errorMessage);
                        case 24:
                        case "end":
                          return _context3.stop();
                      }
                    }, _callee3, null, [[2, 9], [12, 19]]);
                  }));
                  return function (_x2) {
                    return _ref2.apply(this, arguments);
                  };
                }();
                _context7.prev = 4;
                _context7.next = 7;
                return this.libLoaderService.load(this.$filter('appResource'), 'opentok');
              case 7:
                this.$scope.$applyAsync(function () {
                  return _this2.init();
                });
                OT.on('exception', this.OTexceptionHandler);
                _context7.next = 14;
                break;
              case 11:
                _context7.prev = 11;
                _context7.t0 = _context7["catch"](4);
                this.handleError(null, 'unable_to_connect');
              case 14:
                onPublisherPublished = function onPublisherPublished() {
                  _this2.publisherPublished = true;
                  _this2.showCall = true;
                  _this2.showState('call');
                  _this2.adaptSubscriberResolution();
                  if (_this2.conversationId) {
                    if (_this2.isFirstInCall) {
                      _this2.sendStartVideoCallAction().catch(function () {});
                    } else if (!_this2.subscribers.length) {
                      _this2.sendStartVideoCallAction().catch(function () {});
                    } else {
                      _this2.sendAction('join_video_call').catch(function () {});
                    }
                  }
                  _this2.$interval.cancel(_this2.sanityCheckInterval);
                  _this2.sanityCheckInterval = _this2.$interval((0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee4() {
                    var _iterator, _step, subscriber;
                    return _regenerator.default.wrap(function _callee4$(_context4) {
                      while (1) switch (_context4.prev = _context4.next) {
                        case 0:
                          _iterator = _createForOfIteratorHelper(_this2.subscribers);
                          _context4.prev = 1;
                          _iterator.s();
                        case 3:
                          if ((_step = _iterator.n()).done) {
                            _context4.next = 11;
                            break;
                          }
                          subscriber = _step.value;
                          if ((0, _sanityChecks.videoElementSanityCheck)(subscriber.videoElement, subscriber.hasAudio, subscriber.hasVideo)) {
                            _context4.next = 9;
                            break;
                          }
                          console.log("[VideoCall] sanity check failed, resubscribing to ".concat(subscriber.name, "'s subscriber"));
                          _context4.next = 9;
                          return subscriber.subscribeToStream();
                        case 9:
                          _context4.next = 3;
                          break;
                        case 11:
                          _context4.next = 16;
                          break;
                        case 13:
                          _context4.prev = 13;
                          _context4.t0 = _context4["catch"](1);
                          _iterator.e(_context4.t0);
                        case 16:
                          _context4.prev = 16;
                          _iterator.f();
                          return _context4.finish(16);
                        case 19:
                        case "end":
                          return _context4.stop();
                      }
                    }, _callee4, null, [[1, 13, 16, 19]]);
                  })), 5 * 1000);
                };
                window.onbeforeunload = this.partVideoCall.bind(this);
                if (this.docType === 'session') {
                  this.videoType = 'session-breakout';
                } else if (this.docType === 'sponsor') {
                  this.videoType = 'sponsor-booth';
                } else if (this.docType === 'chat') {
                  this.videoType = 'chat';
                }
                pinParticipant = function pinParticipant(pid) {
                  if (!_this2.pinnedParticipants.includes(pid)) {
                    if (_this2.pinnedParticipants.length >= 5) {
                      return;
                    }
                    _this2.pinnedParticipants.push(pid);
                  } else {
                    _this2.pinnedParticipants = _this2.pinnedParticipants.filter(function (id) {
                      return id !== pid;
                    });
                  }
                  _this2.videoCallService.savePinnedParticipants(_this2.videoCallDoc._id, _this2.pinnedParticipants);
                  _this2.videoCallModeratorService.sendAction(_videoCallModeratorService.MODERATOR_ACTIONS.PIN, {
                    data: {
                      pinnedParticipants: _this2.pinnedParticipants
                    }
                  });
                  _this2.setPages();
                };
                isTalking = function isTalking(pid) {
                  if (_this2.talkingOrder.includes(pid)) {
                    if (_this2.talkingOrder.indexOf(pid) > _this2.getNumberOfUserPerPage() - _this2.pinnedParticipants.length - 2) {
                      _this2.talkingOrder = _this2.talkingOrder.sort(function (x, y) {
                        return x === pid ? -1 : y === pid ? 1 : 0;
                      });
                    }
                  } else {
                    _this2.talkingOrder.unshift(pid);
                  }
                  _this2.setPages();
                };
                updateModerators = function () {
                  var _ref4 = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee5() {
                    var moderators,
                      _args5 = arguments;
                    return _regenerator.default.wrap(function _callee5$(_context5) {
                      while (1) switch (_context5.prev = _context5.next) {
                        case 0:
                          moderators = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : [];
                          if (!(!moderators || !moderators.length)) {
                            _context5.next = 6;
                            break;
                          }
                          if (!_this2.parentDocumentId) {
                            _context5.next = 6;
                            break;
                          }
                          _context5.next = 5;
                          return _this2.videoCallService.getModerators(_this2.parentDocumentId);
                        case 5:
                          moderators = _context5.sent;
                        case 6:
                          _this2.isModerator = moderators.includes(_this2.ACTIVATED_PERSON._id) || moderators.includes(_this2.ACTIVATED_PERSON.fp_ext_id);
                        case 7:
                        case "end":
                          return _context5.stop();
                      }
                    }, _callee5);
                  }));
                  return function updateModerators() {
                    return _ref4.apply(this, arguments);
                  };
                }();
                showKickoutModal = function showKickoutModal(event, options) {
                  _this2.kickoutModal = {
                    title: _this2.labels.kickout_participant,
                    hint: _this2.labels.confirm_kickout_participant,
                    buttonValidate: {
                      label: _this2.labels.kickout,
                      action: function action() {
                        _this2.videoCallModeratorService.sendAction(_videoCallModeratorService.MODERATOR_ACTIONS.KICKOUT, options);
                        _this2.kickoutModal = null;
                      }
                    },
                    buttonCancel: {
                      label: _this2.labels.cancel,
                      action: function action() {
                        _this2.kickoutModal = null;
                      }
                    }
                  };
                };
                notifyOfBeingKickedOut = function notifyOfBeingKickedOut() {
                  var message = _this2.uiService.buildNotificationMessage({
                    title: _this2.labels.moderator,
                    message: {
                      body: _this2.labels.moderator_removed_you
                    },
                    duration: 5,
                    backgroundColor: (0, _lodash.get)(_this2.$scope, 'eventTheme.toolbar.background_color'),
                    contentColor: (0, _lodash.get)(_this2.$scope, 'eventTheme.toolbar.font_color'),
                    iconColor: (0, _lodash.get)(_this2.$scope, 'eventTheme.toolbar.font_color')
                  });
                  _this2.uiService.inAppNotification(message);
                };
                _context7.t1 = this.listeners;
                _context7.t2 = this.$scope.$on('joinCall', function (event, _ref5) {
                  var videoOn = _ref5.videoOn,
                    audioOn = _ref5.audioOn;
                  return _this2.joinVideoCall({
                    videoOn: videoOn,
                    audioOn: audioOn
                  });
                });
                _context7.t3 = this.$scope.$on('hideSpinner', function () {
                  return _this2.showState('onboarding');
                });
                _context7.t4 = this.$scope.$on('publisher:error', function () {
                  return _this2.destroySession();
                });
                _context7.t5 = this.$scope.$on('publisher:published', function () {
                  return onPublisherPublished();
                });
                _context7.t6 = this.$scope.$on('publisher:deviceChangeError', function (err) {
                  return _this2.handleError(err);
                });
                _context7.t7 = this.$scope.$on('pip:close', function () {
                  return _this2.partVideoCall();
                });
                _context7.t8 = this.$scope.$on('publisher:accessDenied', function () {
                  _this2.destroySession();
                  _this2.showState('error');
                  _this2.callJoined = false;
                  _this2.$scope.$applyAsync();
                });
                _context7.t9 = this.$scope.$on('publisher:created', function (event, publisher) {
                  _this2.publisher = publisher;
                  _this2.$scope.$applyAsync();
                });
                _context7.t10 = this.$eventBus.on('$navChange', function () {
                  _this2.toggleFullScreen(false);
                  _this2.showList = false;
                });
                _context7.t11 = this.$eventBus.on("moderatorRequest:".concat(_videoCallModeratorService.MODERATOR_ACTIONS.KICKOUT), function () {
                  notifyOfBeingKickedOut();
                  _this2.partVideoCall();
                });
                _context7.t12 = this.$eventBus.on("moderatorRequest:".concat(_videoCallModeratorService.MODERATOR_ACTIONS.PIN), function (data) {
                  _this2.pinnedParticipants = (0, _lodash.get)(data, 'pinnedParticipants', []);
                  _this2.setPages();
                });
                _context7.t13 = this.$scope.$on('moderator:pin', function (event, pid) {
                  pinParticipant(pid);
                });
                _context7.t14 = this.$scope.$on('talkingIndicator:isTalking', function (event, pid) {
                  isTalking(pid);
                });
                _context7.next = 38;
                return this.signalService.addSignalListener("videoCalls/new-moderators/".concat(this.parentDocumentId), function () {
                  var _ref6 = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee6(signal) {
                    return _regenerator.default.wrap(function _callee6$(_context6) {
                      while (1) switch (_context6.prev = _context6.next) {
                        case 0:
                          _context6.next = 2;
                          return updateModerators(signal.moderators);
                        case 2:
                          _this2.$scope.$applyAsync();
                        case 3:
                        case "end":
                          return _context6.stop();
                      }
                    }, _callee6);
                  }));
                  return function (_x3) {
                    return _ref6.apply(this, arguments);
                  };
                }());
              case 38:
                _context7.t15 = _context7.sent;
                _context7.t16 = this.$scope.$on('subscriber:initiated', function (event, subscriber) {
                  _this2.participants = _this2.participants.map(function (p) {
                    if (p.id === subscriber.pid) {
                      p.subscriber = subscriber;
                    }
                    return p;
                  });
                });
                _context7.t17 = this.$scope.$on('moderator:showKickoutModal', showKickoutModal);
                _context7.t1.push.call(_context7.t1, _context7.t2, _context7.t3, _context7.t4, _context7.t5, _context7.t6, _context7.t7, _context7.t8, _context7.t9, _context7.t10, _context7.t11, _context7.t12, _context7.t13, _context7.t14, _context7.t15, _context7.t16, _context7.t17);
                _context7.next = 44;
                return updateModerators();
              case 44:
              case "end":
                return _context7.stop();
            }
          }, _callee7, this, [[4, 11]]);
        }));
        function $onInit() {
          return _$onInit.apply(this, arguments);
        }
        return $onInit;
      }()
    }, {
      key: "deviceUpdatedHandler",
      value: function deviceUpdatedHandler(_ref7) {
        var error = _ref7.error;
        if (error) this.handleError(error);
        if (!this.mediaDevicesService.audioDevices.length || !this.mediaDevicesService.audioDeviceSelected) {
          this.setAudioOn(false);
        }
        if (!this.mediaDevicesService.videoDevices.length || !this.mediaDevicesService.videoDeviceSelected) {
          this.setVideoOn(false);
        }
        this.$scope.$applyAsync();
      }
    }, {
      key: "init",
      value: function init() {
        console.info('[VideoCall] Init', this.conversationId, this.actions);
        this.showState('loading');
        this.showOnboarding = true;
        this.getSession();
      }
    }, {
      key: "sendStartVideoCallAction",
      value: function sendStartVideoCallAction() {
        return this.sendAction('start_video_call', {
          session_id: this.videoCallId,
          conversation_id: this.conversationId
        });
      }
    }, {
      key: "getSession",
      value: function getSession() {
        var _this3 = this;
        this.errorMessage = null;
        if (this.session) this.session.disconnect();
        if (this.videoCallId && !this.conversationId) {
          this.publisherName = this.ACTIVATED_PERSON.fname + ' ' + this.ACTIVATED_PERSON.lname;
          return;
        }
        this.videoCallService.getConversation(this.conversationId).then(function (conversation) {
          _this3.videoCallId = conversation.session_id;
          _this3.isFirstInCall = !conversation.is_live;
          _this3.publisherName = conversation.all_pax[_this3.ACTIVATED_PERSON._id];
        }).catch(function (err) {
          return _this3.handleError(err, 'unable_to_connect');
        });
      }
    }, {
      key: "getTokenAndApiKey",
      value: function getTokenAndApiKey() {
        var _this4 = this;
        return this.videoCallService.getTokenAndApiKey(this.videoCallId, this.parentDocumentId).then(function (_ref8) {
          var data = _ref8.data;
          _this4.videoCallDoc = data;
          var _this4$videoCallDoc = _this4.videoCallDoc,
            videoSessionConfig = _this4$videoCallDoc.videoSessionConfig,
            token = _this4$videoCallDoc.token,
            embedded_url_enabled = _this4$videoCallDoc.embedded_url_enabled,
            embedded_url = _this4$videoCallDoc.embedded_url,
            pinnedParticipants = _this4$videoCallDoc.pinnedParticipants;
          _this4.vonageSessionId = videoSessionConfig && videoSessionConfig.sessionId ? videoSessionConfig.sessionId : _this4.videoCallId;
          _this4.apiKey = videoSessionConfig.apiKey;
          _this4.token = token;
          _this4.embeddedUrl = embedded_url_enabled ? _this4.$sce.trustAsResourceUrl(embedded_url) : false;
          _this4.pinnedParticipants = pinnedParticipants || [];
        }).catch(function (err) {
          return _this4.handleError(err, 'unable_to_connect');
        });
      }
    }, {
      key: "isSomeContentShared",
      value: function isSomeContentShared() {
        return !!(this.embeddedUrl || this.screenShareActive);
      }
    }, {
      key: "joinVideoCall",
      value: function joinVideoCall() {
        var _this5 = this;
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, _get2.default)((0, _getPrototypeOf2.default)(VideoCallComponent.prototype), "init", this).call(this);
        this.inCall = true;
        this.showState('loading');
        if (options.hasOwnProperty('videoOn')) {
          this.videoOn = options.videoOn;
        }
        if (options.hasOwnProperty('audioOn')) {
          this.audioOn = options.audioOn;
        }
        this.getTokenAndApiKey().then(function () {
          _this5.setupSession();
          _this5.$eventBus.emit('video-call:joined');
        });
      }
    }, {
      key: "setupSession",
      value: function () {
        var _setupSession = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee8() {
          var _this6 = this;
          var session;
          return _regenerator.default.wrap(function _callee8$(_context8) {
            while (1) switch (_context8.prev = _context8.next) {
              case 0:
                this.showReconnectionMessage = false;
                this.callJoined = false;
                this.showState('loading');
                session = OT.initSession(this.apiKey, this.vonageSessionId);
                this.session = this.angularizeSessionListeners(session);
                this.session.connect(this.token, function (err) {
                  if (err) return _this6.handleError(err, 'unable_to_connect');
                  _this6.addParticipant({
                    id: _this6.ACTIVATED_PERSON._id
                  });
                  _this6.videoCallModeratorService.init(_this6.session);
                  _this6.createSessionListeners();
                  _this6.$timeout(function () {
                    _this6.setPages();
                    _this6.callJoined = true;
                  }, 1000);
                });
              case 6:
              case "end":
                return _context8.stop();
            }
          }, _callee8, this);
        }));
        function setupSession() {
          return _setupSession.apply(this, arguments);
        }
        return setupSession;
      }()
    }, {
      key: "onStreamCreated",
      value: function onStreamCreated(event) {
        if (event.stream.videoType === 'screen') {
          this.subscriberSharingStream = event.stream;
          this.screenShareActive = true;
        } else {
          if (this.hasDeadStream(event)) {
            return;
          }
          this.subscribers.push(new _Subscriber.Subscriber({
            triggerService: this.triggerService
          }, {
            session: this.session,
            name: event.stream.name,
            pid: this.getStreamOwner(event.stream).id,
            stream: event.stream
          }));
          if (this.subscribers.length + 1 > ROOM_CAPACITY && !this.callJoined) {
            this.destroySession();
            this.handleError(null, 'limit_reached');
            return this.$scope.$applyAsync();
          }
          if (this.callJoined) this.setPages();
          this.addParticipant(event);
        }
        if (this.callJoined) this.emitUpdate();
      }
    }, {
      key: "onStreamPropertyChanged",
      value: function onStreamPropertyChanged(event) {
        if (event.stream.connection.connectionId === this.session.connection.connectionId) return;
        if (event.changedProperty === 'hasVideo') {
          this.toggleSubscriberAudioVideo(event.stream, 'hasVideo', event.newValue);
        }
        if (event.changedProperty === 'hasAudio') {
          this.toggleSubscriberAudioVideo(event.stream, 'hasAudio', event.newValue);
        }
        this.$scope.$applyAsync();
      }
    }, {
      key: "hasDeadStream",
      value: function hasDeadStream(obj) {
        var connectionDestroyed = (0, _lodash.get)(obj, 'stream.connection.destroyed', function () {})();
        var streamDestroyed = (0, _lodash.get)(obj, 'stream.destroyed');
        return streamDestroyed || connectionDestroyed;
      }
    }, {
      key: "adaptSubscriberResolution",
      value: function adaptSubscriberResolution() {
        this.$scope.$broadcast('layout:changed', this.layoutData);
      }
    }, {
      key: "switchPage",
      value: function switchPage(increment) {
        var newIndex = this.currentPage.index + increment;
        this.goToPage(newIndex);
        this.setLayout();
      }
    }, {
      key: "goToPage",
      value: function goToPage(index) {
        this.currentPage = {
          index: index,
          subscribers: (0, _lodash.indexBy)(this.pages[index], function (sub) {
            return sub.stream.streamId;
          }),
          size: this.pages[index] ? this.pages[index].length : 0
        };
        if (this.currentPage.size === 0 && index > 0) {
          this.goToPage(index - 1);
        }
      }
    }, {
      key: "setSubscribersVisibility",
      value: function setSubscribersVisibility() {
        var _this7 = this;
        if (!this.currentPage) {
          return;
        }
        (0, _lodash.each)(this.subscribers, function (subscriber) {
          if (_this7.currentPage.subscribers[subscriber.stream.streamId]) {
            _this7.setSingleSubscriberVisibility(subscriber, true);
          } else {
            _this7.setSingleSubscriberVisibility(subscriber, false);
          }
        });
      }
    }, {
      key: "setSingleSubscriberVisibility",
      value: function setSingleSubscriberVisibility(subscriber, val) {
        subscriber.show = val;
        if (subscriber.otSubscriberObject && (0, _lodash.isFunction)(subscriber.otSubscriberObject.restrictFrameRate)) {
          subscriber.otSubscriberObject.restrictFrameRate(!val);
        }
      }
    }, {
      key: "onStreamDestroyed",
      value: function onStreamDestroyed(event) {
        console.log('[VideoCall] onStreamDestroyed', event);
        if (this.subscriberSharingStream && this.subscriberSharingStream.streamId === event.stream.streamId) {
          this.subscriberSharingStream = null;
          this.screenShareActive = false;
        } else {
          this.subscribers = this.subscribers.filter(function (sub) {
            return sub.stream.streamId !== event.stream.streamId;
          });
        }
        this.setPages();
        this.emitUpdate();
      }
    }, {
      key: "getStreamOwner",
      value: function getStreamOwner(stream) {
        var jsonData = (0, _lodash.get)(stream, 'connection.data');
        var participant;
        if (jsonData) {
          participant = JSON.parse(jsonData);
        } else {
          participant = stream;
        }
        return participant;
      }
    }, {
      key: "addParticipant",
      value: function addParticipant(event) {
        var stream = (0, _lodash.get)(event, 'stream', event);
        var participant = this.getStreamOwner(stream);
        if (participant.id === this.ACTIVATED_PERSON._id) {
          participant.name = this.$i18n('conversation_nav.details.you');
          participant.isActPerson = true;
          this.participants.unshift(participant);
        }
        if (!this.participants.find(function (p) {
          return p.id === participant.id;
        })) {
          participant.fname = participant.name.split(' ')[0];
          participant.openProfileTooltip = this.$i18n('video_calls.labels.open_profile').replace('{{fname}}', participant.fname);
          this.participants.push(participant);
        }
        this.participants = (0, _lodash.uniq)(this.participants, function (p) {
          return p.id;
        });
      }
    }, {
      key: "removeParticipant",
      value: function removeParticipant(event) {
        var jsonData = (0, _lodash.get)(event, 'connection.data');
        var participant = JSON.parse(jsonData);
        this.participants = this.participants.filter(function (p) {
          return p.id !== participant.id;
        });
      }
    }, {
      key: "toggleSubscriberAudioVideo",
      value: function toggleSubscriberAudioVideo(stream, type, value) {
        this.subscribers = this.subscribers.map(function (sub) {
          if (sub.stream.streamId === stream.streamId) {
            sub[type] = value;
          }
          return sub;
        });
      }
    }, {
      key: "toggleScreenSharing",
      value: function toggleScreenSharing() {
        var _this8 = this;
        if (this.subscriberSharingStream) {
          this.showScreenshareBusyError = true;
          this.$timeout(function () {
            _this8.showScreenshareBusyError = false;
            _this8.$scope.$applyAsync();
          }, 5000);
          return;
        }
        if (!this.screenShareActive && !this.screenSharingCapabilityChecked) {
          OT.checkScreenSharingCapability(function (response) {
            if (!response.supported || response.extensionRegistered === false) {
              _this8.handleError(new Error('This browser does not support screen sharing.'));
            } else {
              _this8.screenShareActive = true;
            }
            _this8.screenSharingCapabilityChecked = true;
          });
        } else {
          this.screenShareActive = !this.screenShareActive;
          if (!this.screenShareActive) this.stopScreenShare();
        }
      }
    }, {
      key: "startScreenShare",
      value: function () {
        var _startScreenShare = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee9() {
          var _this9 = this;
          var screenPreviewEl, screenShareOptions;
          return _regenerator.default.wrap(function _callee9$(_context9) {
            while (1) switch (_context9.prev = _context9.next) {
              case 0:
                this.setPages();
                screenPreviewEl = this.$element.find('.screen-preview').get(0);
                if (!this.subscriberSharingStream) {
                  _context9.next = 11;
                  break;
                }
                if (!this.screenShareSubscriber) {
                  _context9.next = 7;
                  break;
                }
                _context9.next = 6;
                return this.screenShareSubscriber.destroy();
              case 6:
                this.screenShareSubscriber = null;
              case 7:
                this.screenShareSubscriber = new _Subscriber.Subscriber({
                  triggerService: this.triggerService
                }, {
                  session: this.session,
                  stream: this.subscriberSharingStream
                });
                _context9.next = 10;
                return this.screenShareSubscriber.init(screenPreviewEl, this.eventEmitter);
              case 10:
                return _context9.abrupt("return", _context9.sent);
              case 11:
                screenShareOptions = {
                  videoSource: 'screen',
                  videoContentHint: SCREENSHARE_CONTENT_HINT,
                  insertMode: 'append',
                  width: '100%',
                  height: '100%',
                  showControls: false,
                  publishAudio: true,
                  disableAudioProcessing: true,
                  name: this.publisherName
                };
                if (this.enableScreenShareSimulcast) {
                  screenShareOptions.scalableScreenshare = true;
                } else {
                  screenShareOptions.maxResolution = MAX_SCREENSHARE_RESOLUTION;
                }
                this.screenSharePublisher = OT.initPublisher(screenPreviewEl, screenShareOptions, function (err) {
                  if (err) {
                    var deniedBySystem = (err.originalMessage || '').toLowerCase().includes('by system') || (err.message || '').toLowerCase().includes('by system');
                    if (deniedBySystem) {
                      _this9.showScreenShareErrorModal = true;
                    }
                    _this9.stopScreenShare();
                    return _this9.handleError(err);
                  }
                  _this9.screenSharePublisher.on('mediaStopped', _this9.stopScreenShare.bind(_this9));
                  _this9.session.publish(_this9.screenSharePublisher, function (error) {
                    return error && _this9.handleError(error);
                  });
                  _this9.adaptSubscriberResolution();
                });
              case 14:
              case "end":
                return _context9.stop();
            }
          }, _callee9, this);
        }));
        function startScreenShare() {
          return _startScreenShare.apply(this, arguments);
        }
        return startScreenShare;
      }()
    }, {
      key: "stopScreenShare",
      value: function stopScreenShare() {
        this.screenShareActive = false;
        if (this.screenSharePublisher) {
          this.session.unpublish(this.screenSharePublisher);
          this.screenSharePublisher.destroy();
        }
        this.screenSharePublisher = null;
        this.setPages();
      }
    }, {
      key: "setVideoOn",
      value: function setVideoOn(value) {
        if (this.showOnboarding) {
          return;
        }
        var selectedVideoSourceId = (0, _lodash.get)(this, 'mediaDevicesService.videoDeviceSelected.deviceId');
        this.videoOn = selectedVideoSourceId ? value : false;
        if (!this.publisher) {
          return this.$scope.$applyAsync();
        }
        this.publisher.publishVideo(this.videoOn);
        if (!this.videoOn) {
          return this.$scope.$applyAsync();
        }
        var effectiveVideoSourceId;
        try {
          effectiveVideoSourceId = this.publisher.getVideoSource().deviceId;
        } catch (e) {
          effectiveVideoSourceId = null;
        }
        var shouldSetVideoSource = effectiveVideoSourceId !== selectedVideoSourceId;
        if (shouldSetVideoSource) {
          this.$scope.$broadcast('publisher:updateVideoSource');
        }
      }
    }, {
      key: "setAudioOn",
      value: function setAudioOn(value) {
        if (this.showOnboarding) {
          return;
        }
        var selectedAudioSourceId = (0, _lodash.get)(this, 'mediaDevicesService.audioDeviceSelected.deviceId');
        this.audioOn = selectedAudioSourceId ? value : false;
        if (!this.publisher) {
          return this.$scope.$applyAsync();
        }
        this.publisher.publishAudio(this.audioOn);
        if (!this.audioOn) {
          return this.$scope.$applyAsync();
        }
        var effectiveAudioSourceId;
        try {
          effectiveAudioSourceId = this.publisher.getAudioSource().getSettings().deviceId;
        } catch (e) {
          effectiveAudioSourceId = null;
        }
        var shouldSetAudioSource = effectiveAudioSourceId !== selectedAudioSourceId;
        if (shouldSetAudioSource) {
          this.$scope.$broadcast('publisher:updateAudioSource');
        }
      }
    }, {
      key: "changeAudioSource",
      value: function changeAudioSource(device) {
        (0, _get2.default)((0, _getPrototypeOf2.default)(VideoCallComponent.prototype), "changeAudioSource", this).call(this, device);
        this.$scope.$applyAsync();
        this.$scope.$broadcast('publisher:updateAudioSource');
      }
    }, {
      key: "changeVideoSource",
      value: function changeVideoSource(device) {
        (0, _get2.default)((0, _getPrototypeOf2.default)(VideoCallComponent.prototype), "changeVideoSource", this).call(this, device);
        this.$scope.$applyAsync();
        this.$scope.$broadcast('publisher:updateVideoSource');
      }
    }, {
      key: "toggleFullScreen",
      value: function toggleFullScreen() {
        var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !this.fullScreen;
        this.fullScreen = val;
        this.$element.removeAttr('style');
        if (this.fullScreen) {
          this.$element.css({
            'z-index': 20
          });
          this.$element.addClass('full-screen');
          document.addEventListener('keydown', this.keyDownEscapeHandler);
        } else {
          this.$element.css({
            zIndex: ''
          });
          this.$element.removeClass('full-screen');
          document.removeEventListener('keydown', this.keyDownEscapeHandler);
        }
      }
    }, {
      key: "reJoinVideoCall",
      value: function reJoinVideoCall() {
        this.$eventBus.emit('restartCall');
      }
    }, {
      key: "createSessionListeners",
      value: function createSessionListeners() {
        var _iterator2 = _createForOfIteratorHelper(this.sessionListeners),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var listener = _step2.value;
            this.session.on(listener.event, listener.handler);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    }, {
      key: "removeSessionListeners",
      value: function removeSessionListeners() {
        this.session.off();
      }
    }, {
      key: "destroySession",
      value: function destroySession() {
        if (!this.session) return;
        this.removeSessionListeners();
        this.inCall = false;
        if (this.screenSharePublisher) this.session.unpublish(this.screenSharePublisher);
        if (this.publisher) {
          this.publisher.off();
          this.session.unpublish(this.publisher);
          this.publisher.destroy();
        }
        this.session.disconnect();
        this.callJoined = false;
        this.callEnded = true;
        this.lastInCall = this.session.streams.length() <= 1;
        this.metricsService.endTrack(this.videoCallDurationTrakingId, {});
        if (this.conversationId) {
          if (this.publisherPublished && !this.subscribers.length && this.lastInCall) {
            this.sendAction('stop_video_call');
          } else {
            this.sendBeacon('part_video_call');
          }
        }
        this.publisherPublished = false;
        this.onSessionDisconnected();
      }
    }, {
      key: "onSessionDisconnected",
      value: function () {
        var _onSessionDisconnected = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee10(event) {
          var _this10 = this;
          var _iterator3, _step3, subscriber;
          return _regenerator.default.wrap(function _callee10$(_context10) {
            while (1) switch (_context10.prev = _context10.next) {
              case 0:
                this.subscribers = [];
                this.participants = [];
                this.pinnedParticipants = [];
                if (this.publisher) {
                  this.publisher.off();
                }
                _iterator3 = _createForOfIteratorHelper(this.subscribers);
                _context10.prev = 5;
                _iterator3.s();
              case 7:
                if ((_step3 = _iterator3.n()).done) {
                  _context10.next = 14;
                  break;
                }
                subscriber = _step3.value;
                if (!(subscriber && subscriber.otSubscriberObject)) {
                  _context10.next = 12;
                  break;
                }
                _context10.next = 12;
                return this.session.unsubscribe(subscriber.otSubscriberObject);
              case 12:
                _context10.next = 7;
                break;
              case 14:
                _context10.next = 19;
                break;
              case 16:
                _context10.prev = 16;
                _context10.t0 = _context10["catch"](5);
                _iterator3.e(_context10.t0);
              case 19:
                _context10.prev = 19;
                _iterator3.f();
                return _context10.finish(19);
              case 22:
                this.removeSessionListeners();
                this.emitUpdate();
                if (event) {
                  this.crashReportingService.reportError('Video call component', 'onSessionDisconnected', (0, _lodash.omit)(event, ['target']));
                }
                this.showState('error');
                this.showReconnectionMessage = true;
                this.reconnectionCountdown = 10;
                this.addReconnectionCountdown = false;
                if (this.numberOfAutoReconnect < 5) {
                  this.addReconnectionCountdown = true;
                  this.$interval.cancel(this.reconnectionInterval);
                  this.reconnectionInterval = this.$interval(function () {
                    _this10.reconnectionCountdown = _this10.reconnectionCountdown - 1;
                    if (_this10.reconnectionCountdown <= 0) {
                      _this10.numberOfAutoReconnect++;
                      _this10.reconnectNow();
                    }
                  }, 1000);
                }
              case 30:
              case "end":
                return _context10.stop();
            }
          }, _callee10, this, [[5, 16, 19, 22]]);
        }));
        function onSessionDisconnected(_x4) {
          return _onSessionDisconnected.apply(this, arguments);
        }
        return onSessionDisconnected;
      }()
    }, {
      key: "reconnectNow",
      value: function () {
        var _reconnectNow = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee11() {
          return _regenerator.default.wrap(function _callee11$(_context11) {
            while (1) switch (_context11.prev = _context11.next) {
              case 0:
                this.$interval.cancel(this.reconnectionInterval);
                this.joinVideoCall();
              case 2:
              case "end":
                return _context11.stop();
            }
          }, _callee11, this);
        }));
        function reconnectNow() {
          return _reconnectNow.apply(this, arguments);
        }
        return reconnectNow;
      }()
    }, {
      key: "partVideoCall",
      value: function partVideoCall() {
        this.$eventBus.emit("chat:stopcall:".concat(this.conversationId));
        this.$eventBus.emit('video-pip:close');
        this.$eventBus.emit('join-call-button:show');
      }
    }, {
      key: "toggleParticipantsList",
      value: function toggleParticipantsList() {
        this.showList = !this.showList;
      }
    }, {
      key: "sendAction",
      value: function sendAction(action) {
        var _this11 = this;
        var extraParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (!this.conversationId || !this.actions) return;
        var params = Object.assign({
          conversation_id: this.conversationId
        }, extraParams);
        return this.dbService.runAppScript(this.actions[action].path, params).then(function (_ref9) {
          var data = _ref9.data;
          if (data.error) {
            console.error('[VideoCall] Cannot perform requested action', data.error);
            return;
          }
          console.log('[VideoCall] Service response: ', data.response);
          return data.response;
        }).finally(function () {
          return _this11.emitUpdate();
        });
      }
    }, {
      key: "sendBeacon",
      value: function sendBeacon(action) {
        if (!this.conversationId || !this.actions) return;
        var params = "params=".concat(JSON.stringify({
          conversation_id: this.conversationId
        }));
        navigator.sendBeacon("/api/v1/eid/".concat(this.eid, "/appscripts/").concat(this.actions[action].path, "?").concat(params));
        this.emitUpdate();
      }
    }, {
      key: "handleError",
      value: function handleError(error, name) {
        if (!error && !name) {
          return;
        }
        console.error('[videoCall component error]', error, name);
        this.setLayout();
        if (name) {
          this.errorMessage = "video_calls.errors.".concat(name);
          this.showState('error');
        }
        this.$scope.$applyAsync();
      }
    }, {
      key: "unsubscribeFromEvents",
      value: function unsubscribeFromEvents() {
        var _iterator4 = _createForOfIteratorHelper(this.listeners),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var unsub = _step4.value;
            if ((0, _lodash.isFunction)(unsub)) {
              unsub();
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      }
    }, {
      key: "$onDestroy",
      value: function $onDestroy() {
        (0, _get2.default)((0, _getPrototypeOf2.default)(VideoCallComponent.prototype), "$onDestroy", this).call(this);
        OT.off('exception', this.OTexceptionHandler);
        if (this.publisher) {
          this.publisher.off();
        }
        this.destroySession();
        this.partVideoCall();
        this.unsubscribeFromEvents();
        this.videoCallModeratorService.unregisterListeners();
        document.removeEventListener('keydown', this.keyDownEscapeHandler);
        window.onbeforeunload = function () {};
        this.$interval.cancel(this.sanityCheckInterval);
        this.$interval.cancel(this.reconnectionInterval);
      }
    }, {
      key: "emitUpdate",
      value: function emitUpdate() {
        this.$scope.$applyAsync();
        if (this.conversationId) this.$eventBus.emit("chat:updatecall:".concat(this.conversationId), this.inCall);
      }
    }, {
      key: "showState",
      value: function showState(state) {
        if (state === 'onboarding') {
          this.showSpinner = false;
          this.showCall = false;
          this.fixPipSize(true);
        } else if (state === 'call') {
          this.showOnboarding = false;
          this.showCall = true;
          this.showSpinner = false;
          this.fixPipSize(false);
        } else if (state === 'error') {
          this.showOnboarding = false;
          this.showSpinner = false;
          this.showCall = false;
          this.fixPipSize(true);
        } else {
          this.showSpinner = true;
          this.showCall = false;
          this.showOnboarding = false;
          this.fixPipSize(true);
        }
      }
    }, {
      key: "fixPipSize",
      value: function fixPipSize(val) {
        if (val) {
          this.videoCallService.addPipClass('fixed-size');
          this.videoCallService.addPipClass('with-vonage');
        } else {
          this.videoCallService.removePipClass('fixed-size');
          this.videoCallService.addPipClass('with-vonage');
        }
      }
    }, {
      key: "showScreenPreview",
      value: function showScreenPreview() {
        return this.session && this.session.connection && !this.embeddedUrl && this.screenShareActive;
      }
    }, {
      key: "angularizeSessionListeners",
      value: function angularizeSessionListeners(session) {
        var _this12 = this;
        var on = session.on;
        session.on = function (type, handler, context) {
          on(type, (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee12() {
            var _args12 = arguments;
            return _regenerator.default.wrap(function _callee12$(_context12) {
              while (1) switch (_context12.prev = _context12.next) {
                case 0:
                  _context12.next = 2;
                  return handler.apply(void 0, _args12);
                case 2:
                  _this12.$scope.$applyAsync();
                case 3:
                case "end":
                  return _context12.stop();
              }
            }, _callee12);
          })), context);
        };
        return session;
      }
    }, {
      key: "getNumberOfUserPerPage",
      value: function getNumberOfUserPerPage() {
        var usersPerPage = USERS_PER_PAGE;
        if (this.screenShareActive) {
          usersPerPage = USERS_PER_SHARE_SCREEN_PAGE;
        }
        return usersPerPage;
      }
    }]);
    return VideoCallComponent;
  }(_DeviceManager2.DeviceManager)
};
exports.VideoCallComponent = VideoCallComponent;

},{"../../../services/videoCallModeratorService":291,"../../../utils/event-emitter":357,"../../../utils/i18n-with-fallback":359,"./BroadcastLayout":112,"./DeviceManager":114,"./Subscriber":115,"./sanity-checks":127,"./video-call.pug":135,"@babel/runtime/helpers/assertThisInitialized":374,"@babel/runtime/helpers/asyncToGenerator":375,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/get":379,"@babel/runtime/helpers/getPrototypeOf":380,"@babel/runtime/helpers/inherits":381,"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/helpers/possibleConstructorReturn":387,"@babel/runtime/regenerator":398,"lodash":"lodash"}],135:[function(require,module,exports){
module.exports = '<div class="video-call" ng-class="{ \'screen-share-active\': $ctrl.screenShareActive }"><div class="loading-placeholder" ng-if="$ctrl.showSpinner"><i class="icon-loader"></i></div><div class="error" ng-if="$ctrl.errorMessage &amp;&amp; !$ctrl.showReconnectionMessage"><p>{{ $ctrl.errorMessage | i18n }}</p><a href="" ng-click="$ctrl.reJoinVideoCall()">{{ ::\'video_calls.actions.try_again\' | i18n }}</a><span>|</span><a href="{{ \'video_calls.onboard.intro_help_link\' | i18n }}" target="_blank"> {{ ::\'video_calls.onboard.intro_help_text\' | i18n }}</a></div><div class="error reconnection" ng-if="$ctrl.showReconnectionMessage"><p>{{ $ctrl.labels.you_were_disconnected }}</p><p ng-if="$ctrl.addReconnectionCountdown">{{ $ctrl.labels.auto_reconnect_in + \' \' + $ctrl.reconnectionCountdown }}</p><a href="" ng-click="$ctrl.partVideoCall()">{{ ::\'video_calls.actions.hang_up\' | i18n }}</a><a href="" ng-click="$ctrl.reconnectNow()">{{ $ctrl.labels.reconnect_now }}</a></div><div class="width-viewport" ng-show="$ctrl.showCall"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAJCAQAAACRI2S5AAAAEElEQVR42mNkIAAYRxWAAQAG9gAKqv6+AwAAAABJRU5ErkJggg=="/><div class="inner-wrapper"><div class="height-viewport"><div class="video-wrapper" ng-if="!$ctrl.errorMessage &amp;&amp; !$ctrl.showReconnectionMessage" ng-class="{\'full-screen\': $ctrl.fullScreen}"><div class="arrow" ng-if="$ctrl.currentPage &amp;&amp; $ctrl.currentPage.index &gt; 0" ng-class="$ctrl.isSomeContentShared() ? \'screen-share-left\' : \'left\'" ng-click="$ctrl.switchPage(-1)"><i class="ic-chevron-right"></i></div><div class="arrow" ng-if="$ctrl.pages.length &gt; 1 &amp;&amp; ($ctrl.currentPage.index + 1) !== $ctrl.pages.length" ng-class="$ctrl.isSomeContentShared() ? \'screen-share-right\' : \'right\'" ng-click="$ctrl.switchPage(1)"><i class="ic-chevron-right"></i></div><div class="participants" ng-class="{ \'align-items-left\': $ctrl.isSomeContentShared() &amp;&amp; !$ctrl.fullScreen &amp;&amp; $ctrl.pages.length &gt; 1,                        \'darkened\' : $ctrl.showList || $ctrl.showAskToUnmute }"><publisher class="stream_0" ng-if="$ctrl.callJoined &amp;&amp; !$ctrl.errorMessage" talking-indicator="$ctrl.publisher" ng-class="[ $ctrl.isSomeContentShared() ? \'screen-share\' : \'\' ]" publisher="$ctrl.publisher" audio-on="$ctrl.audioOn" video-on="$ctrl.videoOn" conversation-id="conversationId" screen-share-active="$ctrl.screenShareActive" session="$ctrl.session" name="$ctrl.publisherName" pid="$ctrl.ACTIVATED_PERSON._id" is-pinned="$ctrl.pinnedParticipants.includes($ctrl.ACTIVATED_PERSON._id)" show-moderator-controls="$ctrl.isModerator" test-options="$ctrl.publisherTestOptions"></publisher><subscriber ng-if="$ctrl.subscribers.length" ng-repeat="subscriber in $ctrl.subscribers" ng-show="subscriber.show" ng-class="[ $ctrl.isSomeContentShared() ? \'screen-share\' : \'\', \'stream_\' + subscriber.index ]" ng-init="$ctrl.setLayout()" session="$ctrl.session" subscriber="subscriber" conversation-id="conversationId" talking-indicator="{ otSubscriberObject: subscriber.otSubscriberObject, pid: subscriber.pid }" stream="subscriber.stream" name="subscriber.name" has-video="subscriber.hasVideo" has-audio="subscriber.hasAudio" is-visible="subscriber.show" is-pinned="subscriber.isPinned" publisher-published="$ctrl.publisherPublished" show-moderator-controls="$ctrl.isModerator"></subscriber><div class="embedded-iframe" ng-if="$ctrl.embeddedUrl"><iframe ng-src="{{$ctrl.embeddedUrl}}"></iframe></div><div class="screen-preview" ng-if="$ctrl.showScreenPreview()" ng-init="$ctrl.startScreenShare()"><div class="name"><div class="span">{{ $ctrl.subscriberSharingStream ? $ctrl.subscriberSharingStream.name : $ctrl.publisherName }}</div><div class="span" ng-if="!$ctrl.subscriberSharingStream">({{ \'conversation_nav.details.you\' | i18n }})</div></div></div></div></div></div></div></div><div class="video-call-controls" ng-show="$ctrl.showCall"><div class="control-btn first-control" ng-click="$ctrl.toggleAudio()"><i class="icon-mic" ng-if="$ctrl.audioOn"></i><div class="label" ng-if="$ctrl.audioOn">{{ ::\'video_calls.actions.mute\' | i18n }}</div><i class="icon-mic-off off" ng-if="!$ctrl.audioOn"></i><div class="label" ng-if="!$ctrl.audioOn">{{ ::\'video_calls.actions.unmute\' | i18n }}</div></div><div class="input-devices audio-devices" ng-if="$ctrl.showAudioInputs"><div class="input-label">{{ ::\'video_calls.labels.microphone\' | i18n }}</div><div class="device" ng-repeat="device in $ctrl.mediaDevicesService.audioDevices" ng-click="$ctrl.changeAudioSource(device)" ng-class="{ \'selected\': $ctrl.mediaDevicesService.audioDeviceSelected.deviceId === device.deviceId }"><i class="icon-mic" ng-if="$ctrl.mediaDevicesService.audioDeviceSelected.deviceId === device.deviceId"></i>{{ device.label }}</div></div><div class="selector" ng-click="$ctrl.showInputDevices(\'audio\')"><i class="icon-chevron-down"></i></div><div class="control-btn" ng-click="$ctrl.toggleCamera()"><i class="icon-webcam" ng-if="$ctrl.videoOn"></i><div class="label" ng-if="$ctrl.videoOn">{{ \'video_calls.actions.stop_video\' | i18n }}</div><i class="icon-webcam-off off" ng-if="!$ctrl.videoOn"></i><div class="label" ng-if="!$ctrl.videoOn">{{ \'video_calls.actions.start_video\' | i18n }}</div></div><div class="input-devices video-devices" ng-if="$ctrl.showVideoInputs"><div class="input-label">{{ ::\'video_calls.labels.camera\' | i18n }}</div><div class="device" ng-repeat="device in $ctrl.mediaDevicesService.videoDevices" ng-click="$ctrl.changeVideoSource(device)" ng-class="{ \'selected\': $ctrl.mediaDevicesService.videoDeviceSelected.deviceId === device.deviceId }"><i class="icon-webcam" ng-if="$ctrl.mediaDevicesService.audioDeviceSelected.deviceId === device.deviceId"></i>{{ device.label }}</div></div><div class="selector" ng-click="$ctrl.showInputDevices(\'video\')"><i class="icon-chevron-down"></i></div><div class="control-btn" ng-if="!$ctrl.embeddedUrl" ng-click="$ctrl.toggleScreenSharing()"><i class="icon-screen-share" ng-class="{ \'active\': $ctrl.screenShareActive }"></i><div class="label" ng-if="!$ctrl.screenShareActive || $ctrl.subscriberSharingStream">{{ ::\'video_calls.actions.share_screen\' | i18n }}</div><div class="label" ng-if="$ctrl.screenShareActive &amp;&amp; !$ctrl.subscriberSharingStream">{{ ::\'video_calls.actions.stop_share_screen\' | i18n }}</div></div><div class="screenshare-busy" ng-if="$ctrl.showScreenshareBusyError">{{ \'video_calls.errors.screenshare_busy\' | i18n }}</div><div class="control-btn" ng-class="{ \'participants-btn\': !$ctrl.embeddedUrl }" ng-click="$ctrl.toggleParticipantsList()"><i class="icon-users"></i><div class="label">{{ ::\'video_calls.labels.participants\' | i18n }}</div><div class="count">{{ $ctrl.participants.length }}</div></div><div class="control-btn stop-call-btn" ng-click="$ctrl.partVideoCall()"><i class="icon-hang-up"></i><div class="label">{{ ::\'video_calls.actions.hang_up\' | i18n }}</div></div><i class="full-screen-btn" ng-click="$ctrl.toggleFullScreen()" ng-class="{\'icon-fulscreen-in\': !$ctrl.fullScreen, \'icon-fullscreen-out\': $ctrl.fullScreen}"></i></div><pip-controls></pip-controls><participants-list ng-if="$ctrl.showList" participants="$ctrl.participants" pinned-participants="$ctrl.pinnedParticipants" show-list="$ctrl.showList" conversation-id="$ctrl.conversationId" show-moderator-controls="$ctrl.isModerator"></participants-list><video-call-modal ng-if="$ctrl.showAskToUnmute" params="$ctrl.askToUnmuteModal"></video-call-modal><video-call-modal ng-if="$ctrl.showScreenShareErrorModal" params="$ctrl.screenShareErrorModal"></video-call-modal><video-call-modal ng-if="$ctrl.kickoutModal" params="$ctrl.kickoutModal"></video-call-modal><onboarding ng-if="$ctrl.showOnboarding &amp;&amp; !$ctrl.errorMessage"></onboarding></div><style></style>';
},{}],136:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLabels = getLabels;
var _i18nWithFallback = _interopRequireDefault(require("../../../utils/i18n-with-fallback"));
function getLabels($i18n, ACTIVATED_PERSON) {
  return {
    countdown: {
      title: (0, _i18nWithFallback.default)($i18n, 'live-stream.countdown.status_message', 'Hold tight!'),
      countdownMessage: (0, _i18nWithFallback.default)($i18n, 'live-stream.countdown.intro_message', 'The live stream will start in:'),
      countdownEndedMessage: (0, _i18nWithFallback.default)($i18n, 'live-stream.countdown.countdown_ended', 'The wait is over, we are about to start…'),
      streamEnded: (0, _i18nWithFallback.default)($i18n, 'live-stream.countdown.replay_pending_message', 'This stream has ended. Thank you for watching!'),
      day: (0, _i18nWithFallback.default)($i18n, 'live-stream.countdown.day', 'day'),
      days: (0, _i18nWithFallback.default)($i18n, 'live-stream.countdown.days', 'days')
    },
    polls: {
      waitingPollResults: (0, _i18nWithFallback.default)($i18n, 'live-stream.polling.loading', 'Thanks for responding')
    },
    claps: {
      throttleMessage: (0, _i18nWithFallback.default)($i18n, 'reactions.throttling.claps', "Give your hands a rest. In a minute you'll be able to clap again."),
      ariaLabel: (0, _i18nWithFallback.default)($i18n, 'a11y.player.controls.claps', 'Clap')
    },
    qna: {
      answerNow: (0, _i18nWithFallback.default)($i18n, 'qna.answering_now', 'Answering now'),
      anonymous: (0, _i18nWithFallback.default)($i18n, 'qna.input.anonymous', 'Anonymous')
    },
    'client-fullscreen': {
      tooltip: (0, _i18nWithFallback.default)($i18n, 'live-stream.tooltip.fullscreen', 'Toggle fullscreen'),
      ariaLabel: (0, _i18nWithFallback.default)($i18n, 'a11y.player.controls.fullscreen', 'Toggle fullscreen')
    },
    fullscreen: {
      tooltip: (0, _i18nWithFallback.default)($i18n, 'live-stream.tooltip.fullscreen', 'Toggle fullscreen'),
      ariaLabel: (0, _i18nWithFallback.default)($i18n, 'a11y.player.controls.fullscreen', 'Toggle fullscreen')
    },
    'play-pause-toggle': {
      tooltip: (0, _i18nWithFallback.default)($i18n, 'live-stream.tooltip.playpause', 'Play/pause'),
      ariaLabel: (0, _i18nWithFallback.default)($i18n, 'a11y.player.controls.play_and_pause', 'Play or pause')
    },
    'play-stop-toggle': {
      tooltip: (0, _i18nWithFallback.default)($i18n, 'live-stream.tooltip.playstop', 'Play/stop'),
      ariaLabel: (0, _i18nWithFallback.default)($i18n, 'a11y.player.controls.play_and_stop', 'Play or stop')
    },
    help: {
      tooltip: (0, _i18nWithFallback.default)($i18n, 'live-stream.tooltip.help', 'Having an issue?'),
      ariaLabel: (0, _i18nWithFallback.default)($i18n, 'a11y.player.controls.help', 'Help')
    },
    'seek-bar': {
      ariaLabel: (0, _i18nWithFallback.default)($i18n, 'a11y.player.controls.progress', 'Progress')
    },
    'sidebar-toggle': {
      tooltip: (0, _i18nWithFallback.default)($i18n, 'live-stream.tooltip.sidebar', 'Open/close side panel'),
      ariaLabel: (0, _i18nWithFallback.default)($i18n, 'a11y.player.controls.sidebar', 'Open or close side panel')
    },
    language: {
      title: (0, _i18nWithFallback.default)($i18n, 'player.controls.language.title', 'Subtitles/CC'),
      tooltip: (0, _i18nWithFallback.default)($i18n, 'live-stream.tooltip.language', 'Change language'),
      tooltip_enable: (0, _i18nWithFallback.default)($i18n, 'live-stream.tooltip.enable_cc', 'Enable subtitles/CC'),
      tooltip_disable: (0, _i18nWithFallback.default)($i18n, 'live-stream.tooltip.disable_cc', 'Disable subtitles/CC'),
      ariaLabel: (0, _i18nWithFallback.default)($i18n, 'a11y.player.controls.captions', 'Captions')
    },
    interprefy: {
      tooltip: (0, _i18nWithFallback.default)($i18n, 'live-stream.tooltip.interprefy', 'Change language'),
      ariaLabel: (0, _i18nWithFallback.default)($i18n, 'a11y.player.controls.interprefy', 'Change language')
    },
    'live-badge': {
      ariaLabel: (0, _i18nWithFallback.default)($i18n, 'a11y.player.controls.live', 'This video is a live stream')
    },
    'volume': {
      buttonAriaLabel: (0, _i18nWithFallback.default)($i18n, 'a11y.player.controls.mute_and_unmute', 'Mute or unmute'),
      sliderAriaLabel: (0, _i18nWithFallback.default)($i18n, 'a11y.player.controls.volume', 'Volume level')
    },
    'time': {
      ariaLabel: (0, _i18nWithFallback.default)($i18n, 'a11y.player.controls.elapsed_time', 'Elapsed time')
    },
    'side-bar': {
      stream: {
        tabName: (0, _i18nWithFallback.default)($i18n, 'stream.stream_tab', 'Stream'),
        streamEnableTitle: (0, _i18nWithFallback.default)($i18n, 'stream.stream_enable.title', 'Watch the stream'),
        streamEnableSubtitle: (0, _i18nWithFallback.default)($i18n, 'stream.stream_enable.subtitle', 'As an in-person attendee, the stream isn\'t available by default. Enable it using the button below.'),
        streamEnableButton: (0, _i18nWithFallback.default)($i18n, 'stream.stream_enable.button', 'Watch stream'),
        streamDisableTitle: (0, _i18nWithFallback.default)($i18n, 'stream.stream_disable.title', 'Hide stream'),
        streamDisableSubtitle: (0, _i18nWithFallback.default)($i18n, 'stream.stream_disable.subtitle', 'By hiding the live stream, we eliminate the small delay, enabling interactivity to be displayed in real time.'),
        streamDisableButton: (0, _i18nWithFallback.default)($i18n, 'stream.stream_disable.button', 'Hide stream')
      },
      viewers: {
        tabName: (0, _i18nWithFallback.default)($i18n, 'viewers.title', 'Viewers'),
        waitingForViewers: (0, _i18nWithFallback.default)($i18n, 'viewers.empty', 'Waiting for participants')
      },
      qna: {
        private: {
          tabName: (0, _i18nWithFallback.default)($i18n, 'qna.private_title', 'Private Q&A'),
          noQuestionTitle: (0, _i18nWithFallback.default)($i18n, 'qna.private_empty_title', 'Ask a question to today’s speaker(s)!'),
          askFirst: (0, _i18nWithFallback.default)($i18n, 'qna.private_empty', 'Hi {{fname}}, questions during this session will only be visible to moderators and speakers!', ACTIVATED_PERSON),
          postNotification: (0, _i18nWithFallback.default)($i18n, 'qna.private_input_posted', 'Your question has been sent to the moderator and will not appear on this panel.')
        },
        tabName: (0, _i18nWithFallback.default)($i18n, 'qna.title', 'Q&A'),
        noQuestionTitle: (0, _i18nWithFallback.default)($i18n, 'qna.empty_title', 'There are no questions yet'),
        askFirst: (0, _i18nWithFallback.default)($i18n, 'qna.empty', "Hi {{fname}}, be first to ask a question to today's speaker(s)!", ACTIVATED_PERSON),
        send: (0, _i18nWithFallback.default)($i18n, 'general.send', 'send'),
        qnaLimitNotification: (0, _i18nWithFallback.default)($i18n, 'qna.input.qna_limit', 'You have reached the limit of questions you can send per minute. You will be able to send a new question in {0} seconds'),
        postNotification: (0, _i18nWithFallback.default)($i18n, 'qna.input.posted', 'Your question will appear in the feed once it is approved by today’s host.'),
        sendAnonymously: (0, _i18nWithFallback.default)($i18n, 'votecomment_nav.send_anonymously', 'Anonymous'),
        inputPlaceholder: (0, _i18nWithFallback.default)($i18n, 'qna.input.hint', 'Write your question...'),
        anonymous: (0, _i18nWithFallback.default)($i18n, 'qna.input.anonymous', 'Anonymous'),
        answerNow: (0, _i18nWithFallback.default)($i18n, 'qna.answering_now', 'Answering now'),
        sortOptions: {
          newest: (0, _i18nWithFallback.default)($i18n, 'qna.sort_options.newest', 'Time'),
          upvotes: (0, _i18nWithFallback.default)($i18n, 'qna.sort_options.upvotes', 'Upvotes')
        },
        orientationOptions: {
          newest: {
            bottomToTop: (0, _i18nWithFallback.default)($i18n, 'qna.sort_direction.newest_bottom', 'Most recent bottom'),
            topToBottom: (0, _i18nWithFallback.default)($i18n, 'qna.sort_direction.newest_top', 'Most recent top')
          }
        }
      },
      polls: {
        tabName: (0, _i18nWithFallback.default)($i18n, 'live-stream.polling.title', 'Poll'),
        submit: (0, _i18nWithFallback.default)($i18n, 'live-stream.polling.submit', 'Send'),
        noPollTitle: (0, _i18nWithFallback.default)($i18n, 'live-stream.polling.no_polling_title', 'There is not a running poll yet.'),
        noPollSubtitle: (0, _i18nWithFallback.default)($i18n, 'live-stream.polling.no_polling_subtitle', "You'll get a notification when a poll is launched."),
        pollIncomingTitle: (0, _i18nWithFallback.default)($i18n, 'live-stream.polling.poll_incoming_title', 'A poll will be launched here soon!'),
        pollIncomingSubtitle: (0, _i18nWithFallback.default)($i18n, 'live-stream.polling.poll_incoming_subtitle', 'The host of this session launched a poll. It will appear here soon for your participation.'),
        thankYouForVoting: (0, _i18nWithFallback.default)($i18n, 'live-stream.polling.loading', 'Thanks for responding'),
        answerLimitHint: (0, _i18nWithFallback.default)($i18n, 'live-stream.polling.answer_limit_hint', 'Allowed answers: {0}'),
        seeResults: (0, _i18nWithFallback.default)($i18n, 'live-stream.polling.alert.results', 'See results'),
        goToPoll: (0, _i18nWithFallback.default)($i18n, 'live-stream.polling.alert.open', 'Go to poll'),
        joinPoll: (0, _i18nWithFallback.default)($i18n, 'live-stream.polling.alert.join', 'Join poll'),
        send: (0, _i18nWithFallback.default)($i18n, 'general.send', 'send'),
        inputPlaceholder: (0, _i18nWithFallback.default)($i18n, 'live-stream.polling.wordcloud.input_placeholder', 'Your answer'),
        thankYouForAnswer: (0, _i18nWithFallback.default)($i18n, 'live-stream.polling.alert.thank_you_for_answer', 'Thank you for your answer'),
        anErrorOccurred: (0, _i18nWithFallback.default)($i18n, 'live-stream.polling.alert.an_error_occurred', 'An Error occurred, please try again'),
        alreadyVoted: (0, _i18nWithFallback.default)($i18n, 'live-stream.polling.alert.already_voted', 'You already voted for this poll'),
        alreadySubmittedAnswer: (0, _i18nWithFallback.default)($i18n, 'live-stream.polling.alert.already_submitted_answer', 'We already saved this answer for you'),
        youCannotSubmitMore: (0, _i18nWithFallback.default)($i18n, 'live-stream.polling.alert.you_cannot_submit_more', 'Thank you for taking part in this poll! You cannot submit any further answers.'),
        youCannotSubmitMultipleWords: (0, _i18nWithFallback.default)($i18n, 'live-stream.polling.alert.you_cannot_submit_multiple_words', 'You cannot submit multiple words'),
        blockedWords: (0, _i18nWithFallback.default)($i18n, 'live-stream.polling.alert.no_blocked_words', 'Sorry, it seems like that phrase is not allowed'),
        charLimitExceeded: (0, _i18nWithFallback.default)($i18n, 'live-stream.polling.alert.char_limit_exceeded', 'You have exceeded the maximum number of characters allowed'),
        youCanSubmitMore: (0, _i18nWithFallback.default)($i18n, 'live-stream.polling.alert.you_can_submit_more', 'Thanks for your answer, you can submit other answers'),
        multipleWordAnswerTooltip: (0, _i18nWithFallback.default)($i18n, 'live-stream.polling.alert.multiple_word_answer_tooltip', 'This will be considered as one answer'),
        expandSidebar: (0, _i18nWithFallback.default)($i18n, 'live-stream.polling.wordcloud.expand_sidebar', 'Expand view')
      },
      translations: {
        tabName: (0, _i18nWithFallback.default)($i18n, 'live-stream.translations_tab.tab_name', 'Translation'),
        header: (0, _i18nWithFallback.default)($i18n, 'live-stream.translations_tab.header', 'Translations & Captions')
      }
    },
    resolution: {
      title: (0, _i18nWithFallback.default)($i18n, 'player.controls.resolution.title', 'Resolution'),
      tooltip: (0, _i18nWithFallback.default)($i18n, 'player.controls.resolution.tooltip', 'Change Resolution'),
      ariaLabel: (0, _i18nWithFallback.default)($i18n, 'a11y.player.controls.resolution', 'Change Resolution')
    },
    'crash-overlay': {
      title: (0, _i18nWithFallback.default)($i18n, 'live-stream.error.player-title', 'Oops! Something went wrong.'),
      message: (0, _i18nWithFallback.default)($i18n, 'live-stream.error.player-message', 'Please refresh the browser or refer to our troubleshooting article for guidance.'),
      buttonLabel: (0, _i18nWithFallback.default)($i18n, 'live-stream.error.player-button', 'Refresh')
    }
  };
}

},{"../../../utils/i18n-with-fallback":359,"@babel/runtime/helpers/interopRequireDefault":382}],137:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoPlayerModule = void 0;
var _videoPlayer = require("./video-player.component");
var VideoPlayerModule = angular.module('maestro.components.common.video-player', []).component('videoPlayer', _videoPlayer.VideoPlayerComponent).component('newVideoPlayer', _videoPlayer.VideoPlayerComponent).name;
exports.VideoPlayerModule = VideoPlayerModule;

},{"./video-player.component":145}],138:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Configurator = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
var _Qna = require("./Qna");
var _Viewers = require("./Viewers");
var _Polls = require("./Polls");
var _Translations = require("./Translations");
var _Stream = require("./Stream");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var Configurator = function () {
  function Configurator(services, context, getters, updatePlayerHandler) {
    (0, _classCallCheck2.default)(this, Configurator);
    this.services = services;
    this.context = context;
    this.getters = getters;
    this.updatePlayerHandler = updatePlayerHandler;
    this.listeners = [];
    this.tabs = [{
      id: 'viewers',
      condition: function condition() {
        return getters.showViewers();
      },
      handlerClass: _Viewers.Viewers,
      instance: null,
      sidebarEventName: 'sideBarViewers'
    }, {
      id: 'polls',
      condition: function condition(config) {
        return (0, _lodash.get)(config, 'polls_enabled', true);
      },
      handlerClass: _Polls.Polls,
      instance: null,
      sidebarEventName: 'sideBarPolls',
      eventName: 'polls'
    }, {
      id: 'qna',
      condition: function condition(config) {
        return (0, _lodash.get)(config, 'qna', false);
      },
      handlerClass: _Qna.Qna,
      instance: null,
      sidebarEventName: 'sideBarQna',
      eventName: 'qna'
    }, {
      id: 'translations',
      condition: function condition() {
        return getters.showTranslationsTab();
      },
      handlerClass: _Translations.Translations,
      instance: null
    }, {
      id: 'stream',
      condition: function condition() {
        return getters.showStreamTab();
      },
      handlerClass: _Stream.Stream,
      instance: null,
      sidebarEventName: 'sideBarStream'
    }];
  }
  (0, _createClass2.default)(Configurator, [{
    key: "getTabInstance",
    value: function getTabInstance(tabId) {
      var tab = this.tabs.find(function (tab) {
        return tab.id === tabId;
      });
      return tab && tab.instance;
    }
  }, {
    key: "onLivestreamUpdate",
    value: function onLivestreamUpdate(livestream, initialUpdate) {
      var oldContext = (0, _lodash.cloneDeep)(this.context);
      this.context.livestream = livestream;
      this.livestreamId = (0, _lodash.get)(this, 'context.livestream.liveStreamId');
      if (!this.livestreamId) {
        return this.resolveTabs({});
      }
      this.resolveTabs(this.context.livestream, initialUpdate, oldContext);
    }
  }, {
    key: "resolveTabs",
    value: function resolveTabs() {
      var livestream = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.context.livestream;
      var initialUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var oldContext = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      if (!livestream || !this.livestreamId) {
        return;
      }
      var _iterator = _createForOfIteratorHelper(this.tabs),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var tab = _step.value;
          if (tab.condition(livestream)) {
            if (!tab.instance) {
              tab.instance = new tab.handlerClass(this.services, this.context, this.getters, this.updatePlayerHandler);
              tab.instance.init(this.livestreamId, initialUpdate);
            } else {
              tab.instance.onContextUpdated(oldContext);
            }
          } else if (!tab.condition(livestream) && tab.instance) {
            tab.instance.destroy();
            tab.instance = null;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "onSideBarEvent",
    value: function onSideBarEvent(context, payload) {
      var _iterator2 = _createForOfIteratorHelper(this.tabs),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var tab = _step2.value;
          if (tab.instance && tab.sidebarEventName === context) {
            tab.instance.onSideBarEvent(payload);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "onEvent",
    value: function onEvent(context, payload) {
      var _iterator3 = _createForOfIteratorHelper(this.tabs),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var tab = _step3.value;
          if (tab.instance && tab.eventName === context) {
            tab.instance.onEvent(payload);
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }, {
    key: "init",
    value: function () {
      var _init = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee(livestream) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.onLivestreamUpdate(livestream);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function init(_x) {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "destroy",
    value: function destroy() {
      var _iterator4 = _createForOfIteratorHelper(this.listeners),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var unsub = _step4.value;
          if ((0, _lodash.isFunction)(unsub)) {
            unsub();
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      this.resolveTabs({});
    }
  }, {
    key: "viewersCount",
    get: function get() {
      var viewersTab = this.tabs.find(function (tab) {
        return tab.id === 'viewers';
      });
      return (0, _lodash.get)(viewersTab, 'instance.viewers.length', 0);
    }
  }, {
    key: "hasTabs",
    get: function get() {
      return this.tabs.reduce(function (count, tab) {
        return count + (tab.instance ? 1 : 0);
      }, 0);
    }
  }, {
    key: "isIframeContent",
    get: function get() {
      return this.getters.isIframeContent();
    }
  }, {
    key: "isPrivateQna",
    get: function get() {
      return this.getters.isPrivateQna();
    }
  }, {
    key: "config",
    get: function get() {
      var components = [];
      var _iterator5 = _createForOfIteratorHelper(this.tabs),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var tab = _step5.value;
          components.push.apply(components, (0, _toConsumableArray2.default)(tab.instance ? [tab.instance.config] : []));
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      return {
        components: components,
        showFullscreenToggler: this.isIframeContent,
        theme: {
          tabHighlightColor: this.services.THEME.contrastColor || this.services.THEME.primary_color,
          btnBackgroundColor: this.services.THEME.toolbar.background_color,
          btnColor: this.services.THEME.toolbar.font_color,
          borderColor: this.services.THEME.toolbar.background_color
        },
        isPrivateQna: this.isPrivateQna
      };
    }
  }]);
  return Configurator;
}();
exports.Configurator = Configurator;

},{"./Polls":139,"./Qna":140,"./Stream":141,"./Translations":143,"./Viewers":144,"@babel/runtime/helpers/asyncToGenerator":375,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/helpers/toConsumableArray":393,"@babel/runtime/regenerator":398,"lodash":"lodash"}],139:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Polls = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _get3 = _interopRequireDefault(require("@babel/runtime/helpers/get"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _lodash = require("lodash");
var _Tab2 = require("./Tab");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = (0, _getPrototypeOf2.default)(t); if (r) { var s = (0, _getPrototypeOf2.default)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0, _possibleConstructorReturn2.default)(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var POLL_TYPES = {
  WORD_CLOUD: 'word_cloud',
  MULTIPLE_CHOICE: 'multiple_choice'
};
var ERROR_TYPES = {
  ANSWER_CONTAINS_BLOCKED_WORDS: 'ANSWER_CONTAINS_BLOCKED_WORDS',
  ANSWER_LIMIT_EXCEEDED: 'ANSWER_LIMIT_EXCEEDED',
  CHARACTER_LIMIT_EXCEEDED: 'CHARACTER_LIMIT_EXCEEDED',
  MULTI_WORDS_NOT_ALLOWED: 'MULTI_WORDS_NOT_ALLOWED'
};
var VOTING_ERROR_MESSAGES = function VOTING_ERROR_MESSAGES(isWordCloud) {
  var _ref;
  return _ref = {}, (0, _defineProperty2.default)(_ref, ERROR_TYPES.MULTI_WORDS_NOT_ALLOWED, 'youCannotSubmitMultipleWords'), (0, _defineProperty2.default)(_ref, ERROR_TYPES.CHARACTER_LIMIT_EXCEEDED, 'charLimitExceeded'), (0, _defineProperty2.default)(_ref, ERROR_TYPES.ANSWER_LIMIT_EXCEEDED, isWordCloud ? 'youCannotSubmitMore' : 'alreadyVoted'), (0, _defineProperty2.default)(_ref, "DEFAULT", 'anErrorOccurred'), (0, _defineProperty2.default)(_ref, ERROR_TYPES.ANSWER_CONTAINS_BLOCKED_WORDS, 'blockedWords'), _ref;
};
var Polls = function (_Tab) {
  (0, _inherits2.default)(Polls, _Tab);
  var _super = _createSuper(Polls);
  function Polls() {
    var _this;
    (0, _classCallCheck2.default)(this, Polls);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.userAnswers = {};
    _this.blockedAnswers = {};
    _this.targetingCache = {};
    _this.showPollIncoming = false;
    return _this;
  }
  (0, _createClass2.default)(Polls, [{
    key: "init",
    value: (function () {
      var _init = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee(livestreamId, initialLivestreamUpdate) {
        var _this2 = this;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.pollResultsListeners = {};
              this.livestreamId = livestreamId;
              this.services.pollService.onPollExecuted(this.livestreamId, function (payload) {
                return _this2.onPollExecutedSignal(payload);
              }).then(function (remover) {
                return _this2.listeners.push(remover);
              });
              this.services.pollService.onExecutionUpdate(this.livestreamId, function (payload) {
                return _this2.onExecutionUpdate(payload);
              }).then(function (remover) {
                return _this2.listeners.push(remover);
              });
              this.services.pollService.onHideResults(this.livestreamId, function (payload) {
                return _this2.onHideResultsSignal(payload);
              }).then(function (remover) {
                return _this2.listeners.push(remover);
              });
              this.listeners.push(this.services.signalService.addEventListener('open', function () {
                return _this2.getInitialState();
              }));
              if (!initialLivestreamUpdate) {
                _context.next = 9;
                break;
              }
              _context.next = 9;
              return this.getInitialState();
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function init(_x, _x2) {
        return _init.apply(this, arguments);
      }
      return init;
    }())
  }, {
    key: "destroy",
    value: function destroy() {
      (0, _get3.default)((0, _getPrototypeOf2.default)(Polls.prototype), "destroy", this).call(this);
      this.removeAllResultsListeners();
    }
  }, {
    key: "getInitialState",
    value: function () {
      var _getInitialState = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee2() {
        var response, pollExecutionId;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.services.pollService.getCurrentPoll(this.livestreamId);
            case 2:
              _context2.t0 = _context2.sent;
              if (_context2.t0) {
                _context2.next = 5;
                break;
              }
              _context2.t0 = {};
            case 5:
              response = _context2.t0;
              pollExecutionId = (0, _lodash.get)(response, 'pollExecution.id');
              if (pollExecutionId) {
                _context2.next = 9;
                break;
              }
              return _context2.abrupt("return");
            case 9:
              this.setUserAnswer(pollExecutionId, response.userAnswers);
              this.setBlockedAnswers(pollExecutionId, response.blockedUserAnswers);
              if (!this.useMetadata) {
                this.setPollExecution(response.pollExecution);
              } else {
                this.toggleShowPollIncoming(true);
              }
              this.forceUserToGoToPolls();
            case 13:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getInitialState() {
        return _getInitialState.apply(this, arguments);
      }
      return getInitialState;
    }()
  }, {
    key: "setUserAnswer",
    value: function setUserAnswer(pollExecutionId, userAnswers) {
      if (!userAnswers) {
        return;
      }
      var previousAnswers = (0, _lodash.get)(this, "userAnswers.".concat(pollExecutionId), []);
      if ((0, _lodash.isString)(userAnswers)) {
        userAnswers = [userAnswers];
      }
      this.userAnswers[pollExecutionId] = [].concat((0, _toConsumableArray2.default)(previousAnswers), (0, _toConsumableArray2.default)(userAnswers));
    }
  }, {
    key: "setBlockedAnswers",
    value: function setBlockedAnswers(pollExecutionId) {
      var answers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      if (!answers || !answers.length) return;
      var previousBlocked = (0, _lodash.get)(this, "blockedAnswers.".concat(pollExecutionId), []);
      this.blockedAnswers[pollExecutionId] = [].concat((0, _toConsumableArray2.default)(previousBlocked), (0, _toConsumableArray2.default)(answers));
    }
  }, {
    key: "onPollExecutedSignal",
    value: function onPollExecutedSignal(payload) {
      this.toggleShowPollIncoming(true);
      if (this.useMetadata) return;
      this.setPollExecution((0, _lodash.get)(payload, 'pollExecution', {}));
    }
  }, {
    key: "onExecutionUpdate",
    value: function onExecutionUpdate(payload) {
      this.toggleShowPollIncoming(false);
      if (this.useMetadata) return;
      this.setPollExecution((0, _lodash.get)(payload, 'pollExecution', {}));
    }
  }, {
    key: "onHideResultsSignal",
    value: function onHideResultsSignal(payload) {
      this.toggleShowPollIncoming(false);
      if (this.useMetadata) return;
      if ((0, _lodash.get)(payload, 'hiddenExecutionsIds', []).includes(this.executionId)) {
        this.setPollExecution({});
      }
    }
  }, {
    key: "toggleShowPollIncoming",
    value: function toggleShowPollIncoming(enable) {
      this.showPollIncoming = enable;
      this.applyConfig();
    }
  }, {
    key: "onWordCloudResultsSignal",
    value: function onWordCloudResultsSignal(executionId) {
      var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (executionId !== this.executionId || !payload || !payload.pollExecution) {
        return;
      }
      if (this.useMetadata && !this.isVod) {
        if (this.executionId === payload.pollExecution.id) {
          this.setPollExecution(_objectSpread(_objectSpread({}, this._pollExecution), {}, {
            word_cloud_results: payload.pollExecution.word_cloud_results
          }));
        }
      } else {
        this.setPollExecution(payload.pollExecution);
      }
    }
  }, {
    key: "onMultipleChoiceResultsSignal",
    value: function onMultipleChoiceResultsSignal(executionId) {
      var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (executionId !== this.executionId || !payload || !payload.pollExecution) {
        return;
      }
      if (this.useMetadata && !this.isVod) {
        if (this.executionId === payload.pollExecution.id) {
          this.setPollExecution(_objectSpread(_objectSpread({}, this._pollExecution), {}, {
            results: payload.pollExecution.results
          }));
        }
      } else {
        this.setPollExecution(_objectSpread(_objectSpread({}, payload.pollExecution), {}, {
          results: payload.results
        }));
      }
    }
  }, {
    key: "onPollMetadata",
    value: function onPollMetadata(payload) {
      if (!this.useMetadata) return;
      this.setPollExecution(payload || {});
    }
  }, {
    key: "onEvent",
    value: function onEvent(payload) {
      this.onPollMetadata(payload);
    }
  }, {
    key: "inviteUserToGoToPolls",
    value: function inviteUserToGoToPolls(state) {
      console.info('[Polls] Inviting user to change to poll tab');
      if (!state || !this.question) {
        return this.showNotification(null);
      }
      var pollsLabel = (0, _lodash.get)(this, 'context.labels.side-bar.polls', {});
      var buttonText = state === 'results' ? pollsLabel.seeResults : pollsLabel.goToPoll;
      var title = state === 'results' ? pollsLabel.seeResults : pollsLabel.joinPoll;
      this.showNotification({
        toTab: 'polls',
        title: title,
        subtitle: this.question,
        buttonText: buttonText
      });
    }
  }, {
    key: "forceUserToGoToPolls",
    value: function forceUserToGoToPolls() {
      console.info('[Polls] Changing to poll tab immediately');
      this.showNotification({
        toTab: 'polls',
        immediateTabSwitch: true
      });
    }
  }, {
    key: "onSideBarEvent",
    value: function onSideBarEvent(_ref2) {
      var _this3 = this;
      var executionId = _ref2.pollId,
        answer = _ref2.answer,
        answers = _ref2.answers,
        onSuccess = _ref2.onSuccess,
        onError = _ref2.onError;
      if (!executionId || executionId !== this.executionId) return;
      console.info('[Poll] new vote:', executionId, answers);
      if (this.isWordCloud && !(0, _lodash.isString)(answer)) {
        return;
      }
      if (this.pollType === POLL_TYPES.MULTIPLE_CHOICE && (!answers || !answers.length)) {
        return;
      }
      var errorHandler = function errorHandler(message) {
        if ((0, _lodash.isFunction)(onError)) {
          onError(message);
        }
      };
      var successHandler = function successHandler(message) {
        if ((0, _lodash.isFunction)(onSuccess)) {
          onSuccess(message);
        }
      };
      if (this.isWordCloud) {
        answer = answer.toLowerCase().trim().replace(/\s+/g, ' ');
      }
      var pollsLabel = (0, _lodash.get)(this, 'context.labels.side-bar.polls', {});
      if (this.isWordCloud && (0, _lodash.get)(this, "userAnswers.".concat(executionId), []).includes(answer)) {
        return errorHandler(pollsLabel.alreadySubmittedAnswer);
      }
      var newUserAnswers = answers || [answer];
      this.services.pollService.vote(this.livestreamId, executionId, newUserAnswers).then(function () {
        _this3.setUserAnswer(executionId, newUserAnswers);
        var canSubmitMore = _this3.answerLimit - (0, _lodash.get)(_this3, "userAnswers.".concat(executionId, ".length"), 0) > 0;
        successHandler(canSubmitMore ? pollsLabel.youCanSubmitMore : pollsLabel.thankYouForAnswer);
        _this3.applyConfig();
      }).catch(function (error) {
        console.error("[LiveStreamSidebar] Couldn't vote.", error);
        var errorType = (0, _lodash.get)(error, 'data.error', 'DEFAULT');
        if (errorType === ERROR_TYPES.ANSWER_CONTAINS_BLOCKED_WORDS) {
          _this3.setBlockedAnswers(executionId, newUserAnswers);
        } else if (errorType === ERROR_TYPES.ANSWER_LIMIT_EXCEEDED) {
          _this3.setBlockedAnswers(executionId, newUserAnswers);
        }
        var errorLabelKey = VOTING_ERROR_MESSAGES(_this3.isWordCloud)[errorType];
        errorHandler(pollsLabel[errorLabelKey]);
        _this3.applyConfig();
      });
    }
  }, {
    key: "addWordCloudResultsListener",
    value: (function () {
      var _addWordCloudResultsListener = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee3(executionId) {
        var _this4 = this;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!this.pollResultsListeners.hasOwnProperty(executionId)) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return");
            case 2:
              this.removeAllResultsListeners();
              if (!this.isWordCloud) {
                _context3.next = 7;
                break;
              }
              _context3.next = 6;
              return this.services.pollService.onWordCloudResults(this.livestreamId, executionId, function (payload) {
                _this4.onWordCloudResultsSignal(executionId, payload);
              });
            case 6:
              this.pollResultsListeners[executionId] = _context3.sent;
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function addWordCloudResultsListener(_x3) {
        return _addWordCloudResultsListener.apply(this, arguments);
      }
      return addWordCloudResultsListener;
    }())
  }, {
    key: "addMultipleChoiceResultsListener",
    value: function () {
      var _addMultipleChoiceResultsListener = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee4(executionId) {
        var _this5 = this;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!this.pollResultsListeners.hasOwnProperty(executionId)) {
                _context4.next = 2;
                break;
              }
              return _context4.abrupt("return");
            case 2:
              this.removeAllResultsListeners();
              _context4.next = 5;
              return this.services.pollService.onMultipleChoiceResults(this.livestreamId, executionId, function (payload) {
                _this5.onMultipleChoiceResultsSignal(executionId, payload);
              });
            case 5:
              this.pollResultsListeners[executionId] = _context4.sent;
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function addMultipleChoiceResultsListener(_x4) {
        return _addMultipleChoiceResultsListener.apply(this, arguments);
      }
      return addMultipleChoiceResultsListener;
    }()
  }, {
    key: "removeResultsListener",
    value: function removeResultsListener(executionId) {
      var remover = this.pollResultsListeners[executionId];
      if ((0, _lodash.isFunction)(remover)) {
        remover();
      }
      delete this.pollResultsListeners[executionId];
    }
  }, {
    key: "removeAllResultsListeners",
    value: function removeAllResultsListeners() {
      var resultsListeners = Object.keys(this.pollResultsListeners);
      for (var _i = 0, _resultsListeners = resultsListeners; _i < _resultsListeners.length; _i++) {
        var executionId = _resultsListeners[_i];
        this.removeResultsListener(executionId);
      }
    }
  }, {
    key: "applyConfig",
    value: function applyConfig() {
      if ((0, _lodash.isEqual)(this.config, this.previousConfig)) {
        return;
      }
      this.previousConfig = (0, _lodash.cloneDeep)(this.config);
      this.updatePlayerHandler();
    }
  }, {
    key: "reset",
    value: function reset() {
      this._pollExecution = {};
      this.services.pollService.onResultsHidden();
      this.inviteUserToGoToPolls();
      this.applyConfig();
    }
  }, {
    key: "setPollExecution",
    value: (function () {
      var _setPollExecution = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee5(pollExecution) {
        var oldExecutionId, newExecutionId, oldShowFinalResults, oldWordCloudResults, newWordCloudResults, oldVotes, newVotes, oldResults, newResults, _oldVotes, _newVotes;
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (!(0, _lodash.isEmpty)(pollExecution)) {
                _context5.next = 2;
                break;
              }
              return _context5.abrupt("return", this.reset());
            case 2:
              if (!(0, _lodash.isEmpty)(pollExecution)) {
                delete pollExecution.results_released;
              }
              oldExecutionId = this.executionId;
              newExecutionId = (0, _lodash.get)(pollExecution, 'id');
              oldShowFinalResults = this.showFinalResults;
              if (!this.services.EVENT.is_webinar) {
                _context5.next = 10;
                break;
              }
              this.targetingCache[newExecutionId] = true;
              _context5.next = 14;
              break;
            case 10:
              if (this.targetingCache.hasOwnProperty(newExecutionId)) {
                _context5.next = 14;
                break;
              }
              _context5.next = 13;
              return this.services.targetingService.isUserTargeted(pollExecution);
            case 13:
              this.targetingCache[newExecutionId] = _context5.sent;
            case 14:
              if (this.targetingCache[newExecutionId]) {
                _context5.next = 16;
                break;
              }
              return _context5.abrupt("return", this.reset());
            case 16:
              pollExecution = addCountdownEndTimestamp(pollExecution, this._pollExecution, this.useMetadata);
              if (!(0, _lodash.isEmpty)(pollExecution) && newExecutionId === oldExecutionId) {
                if (this.isWordCloud) {
                  oldWordCloudResults = (0, _lodash.get)(this, '_pollExecution.word_cloud_results', []);
                  newWordCloudResults = pollExecution.word_cloud_results || [];
                  oldVotes = oldWordCloudResults.reduce(function (acc, _ref3) {
                    var votes = _ref3.votes;
                    return acc + votes;
                  }, 0);
                  newVotes = newWordCloudResults.reduce(function (acc, _ref4) {
                    var votes = _ref4.votes;
                    return acc + votes;
                  }, 0);
                  if (oldVotes > newVotes) {
                    pollExecution.word_cloud_results = oldWordCloudResults;
                  }
                } else {
                  oldResults = (0, _lodash.get)(this, '_pollExecution.results', {});
                  newResults = pollExecution.results || {};
                  _oldVotes = Object.values(oldResults).reduce(function (acc, votes) {
                    return acc + votes;
                  }, 0);
                  _newVotes = Object.values(newResults).reduce(function (acc, votes) {
                    return acc + votes;
                  }, 0);
                  if (_oldVotes > _newVotes) {
                    pollExecution.results = oldResults;
                  }
                }
              }
              this._pollExecution = pollExecution;
              if (!(this.votingClosed && !this.showFinalResults)) {
                _context5.next = 21;
                break;
              }
              return _context5.abrupt("return", this.reset());
            case 21:
              if (!(this.isVod && !this.isWordCloud && !this.showResults)) {
                _context5.next = 23;
                break;
              }
              return _context5.abrupt("return", this.reset());
            case 23:
              if ((0, _lodash.isEmpty)(this._pollExecution) || this.votingClosed) {
                this.removeAllResultsListeners();
              } else if (this.isWordCloud) {
                this.addWordCloudResultsListener(this.executionId).catch(function (error) {
                  return console.error(error);
                });
              } else if (this.showLiveResultsAfterUserVoted) {
                this.addMultipleChoiceResultsListener(this.executionId).catch(function (error) {
                  return console.error(error);
                });
              } else {
                this.removeAllResultsListeners();
              }
              if (this.votingClosed && this.showFinalResults && (oldShowFinalResults !== this.showFinalResults || oldExecutionId !== newExecutionId)) {
                this.services.pollService.onResultsShown(newExecutionId);
                this.inviteUserToGoToPolls('results');
              } else if (newExecutionId && oldExecutionId !== newExecutionId && !this.hasVoted) {
                this.services.pollService.onExecution(newExecutionId);
                this.inviteUserToGoToPolls('executed');
              }
              this.applyConfig();
            case 26:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function setPollExecution(_x5) {
        return _setPollExecution.apply(this, arguments);
      }
      return setPollExecution;
    }())
  }, {
    key: "executionId",
    get: function get() {
      return (0, _lodash.get)(this, '_pollExecution.id');
    }
  }, {
    key: "question",
    get: function get() {
      return (0, _lodash.get)(this, '_pollExecution.question');
    }
  }, {
    key: "answers",
    get: function get() {
      var answers = (0, _lodash.get)(this, '_pollExecution.answers', []);
      var userAnswers = (0, _lodash.get)(this, "userAnswers.".concat(this.executionId));
      if (userAnswers) {
        var _iterator = _createForOfIteratorHelper(answers),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var answer = _step.value;
            answer.selected = userAnswers.includes(answer.id);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      return answers;
    }
  }, {
    key: "showLiveResultsAfterUserVoted",
    get: function get() {
      if (!this._pollExecution) {
        return false;
      }
      return !!this._pollExecution.show_results_live;
    }
  }, {
    key: "showFinalResults",
    get: function get() {
      if (!this._pollExecution) {
        return false;
      }
      return !!this._pollExecution.show_results;
    }
  }, {
    key: "showLiveResults",
    get: function get() {
      if (!this._pollExecution) {
        return false;
      }
      return this.hasVoted && this.showLiveResultsAfterUserVoted;
    }
  }, {
    key: "showResults",
    get: function get() {
      return this.showFinalResults || this.showLiveResults;
    }
  }, {
    key: "votingClosed",
    get: function get() {
      if (!this._pollExecution) {
        return false;
      }
      return !!this._pollExecution.voting_closed;
    }
  }, {
    key: "results",
    get: function get() {
      if (this.isWordCloud) {
        var word_cloud_results = (0, _lodash.get)(this, '_pollExecution.word_cloud_results', []);
        var userAnswers = (0, _lodash.get)(this, "userAnswers.".concat(this.executionId), []);
        userAnswers.forEach(function (answer) {
          var match = word_cloud_results.find(function (e) {
            return e.text === answer;
          });
          if (!match) {
            word_cloud_results.push({
              text: answer,
              votes: 1
            });
          }
        });
        return word_cloud_results;
      }
      if (!this.showResults) {
        return null;
      }
      var results = (0, _lodash.get)(this, '_pollExecution.results', {});
      var answers = (0, _lodash.get)(this, '_pollExecution.answers', []);
      var total = Object.keys(results).reduce(function (acc, x) {
        return acc + results[x];
      }, 0);
      return answers.map(function (answer) {
        return _objectSpread(_objectSpread({}, answer), {}, {
          votes: results[answer.id] || 0,
          percentage: (results[answer.id] || 0) / total * 100 || 0
        });
      });
    }
  }, {
    key: "isWordCloud",
    get: function get() {
      return this.pollType === POLL_TYPES.WORD_CLOUD;
    }
  }, {
    key: "hasVoted",
    get: function get() {
      return !!(0, _lodash.get)(this, "userAnswers.".concat(this.executionId, ".length"));
    }
  }, {
    key: "pollType",
    get: function get() {
      return (0, _lodash.get)(this, '_pollExecution.poll_type');
    }
  }, {
    key: "characterLimit",
    get: function get() {
      return (0, _lodash.get)(this, '_pollExecution.character_limit');
    }
  }, {
    key: "allowMultiWords",
    get: function get() {
      return (0, _lodash.get)(this, '_pollExecution.allow_multi_words');
    }
  }, {
    key: "blockedWordsCount",
    get: function get() {
      return (0, _lodash.get)(this, "blockedAnswers.".concat(this.executionId, ".length"), 0);
    }
  }, {
    key: "answerLimit",
    get: function get() {
      var votedCount = (0, _lodash.get)(this, "userAnswers.".concat(this.executionId, ".length"), 0);
      var allowedCount = (0, _lodash.get)(this, '_pollExecution.answer_limit', 0);
      return Math.max(allowedCount - votedCount - this.blockedWordsCount, 0);
    }
  }, {
    key: "countdownEndTimestamp",
    get: function get() {
      return (0, _lodash.get)(this, '_pollExecution.countdownEndTimestamp', -1);
    }
  }, {
    key: "config",
    get: function get() {
      var allowVoting = !this.votingClosed && !this.isVod;
      var config = _objectSpread({
        id: 'polls',
        pollId: this.executionId,
        pollType: this.pollType,
        question: this.question,
        characterLimit: this.characterLimit,
        allowMultiWords: this.allowMultiWords,
        answerLimit: this.answerLimit,
        answers: this.answers,
        hasVoted: this.hasVoted,
        allowVoting: allowVoting,
        results: this.results,
        showResults: this.showResults,
        showPollIncoming: this.showPollIncoming,
        wordCloudConfig: {
          colors: (0, _lodash.get)(this, 'livestream.polls_colours'),
          largeWordCloud: false
        }
      }, this.isSmallScreen || this.isInPerson ? {
        preventExpand: true
      } : {});
      if (allowVoting) {
        config.countdownEndTimestamp = this.countdownEndTimestamp;
        config.countdownDuration = (0, _lodash.get)(this, '_pollExecution.countdown_duration');
      }
      return config;
    }
  }]);
  return Polls;
}(_Tab2.Tab);
exports.Polls = Polls;
function addCountdownEndTimestamp(newExecution) {
  var oldExecution = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var useMetadata = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if ((0, _lodash.isEmpty)(newExecution)) {
    return newExecution;
  }
  var countdownDuration = newExecution.countdown_duration;
  var votingOpenedTimestamp = newExecution.voting_opened_timestamp;
  if (!countdownDuration || !votingOpenedTimestamp) {
    return newExecution;
  }
  if (oldExecution.id === newExecution.id && oldExecution.countdownEndTimestamp) {
    var oldDuration = (0, _lodash.get)(oldExecution, 'countdown_duration');
    if (countdownDuration <= oldDuration) {
      newExecution.countdownEndTimestamp = oldExecution.countdownEndTimestamp;
      return newExecution;
    }
  }
  var offset = useMetadata ? 25 : 0;
  newExecution.countdownEndTimestamp = votingOpenedTimestamp + countdownDuration + offset;
  return newExecution;
}

},{"./Tab":142,"@babel/runtime/helpers/asyncToGenerator":375,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/defineProperty":378,"@babel/runtime/helpers/get":379,"@babel/runtime/helpers/getPrototypeOf":380,"@babel/runtime/helpers/inherits":381,"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/helpers/possibleConstructorReturn":387,"@babel/runtime/helpers/toConsumableArray":393,"@babel/runtime/regenerator":398,"lodash":"lodash"}],140:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Qna = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _lodash = require("lodash");
var _filters = require("../../../../filters");
var _Tab2 = require("./Tab");
var _time = require("../../../../utils/time");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = (0, _getPrototypeOf2.default)(t); if (r) { var s = (0, _getPrototypeOf2.default)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0, _possibleConstructorReturn2.default)(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var SortOptions = Object.freeze({
  Newest: 'newest',
  Upvotes: 'upvotes'
});
var AlignOptions = Object.freeze({
  Bottom: 'bottom',
  Top: 'top'
});
var Qna = function (_Tab) {
  (0, _inherits2.default)(Qna, _Tab);
  var _super = _createSuper(Qna);
  function Qna() {
    (0, _classCallCheck2.default)(this, Qna);
    return _super.apply(this, arguments);
  }
  (0, _createClass2.default)(Qna, [{
    key: "init",
    value: function () {
      var _init = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee(livestreamId, initialLivestreamUpdate) {
        var _this = this;
        var sortOptions;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              sortOptions = [{
                id: SortOptions.Newest,
                showOrientationToggler: true,
                defaultOrientation: 'bottomToTop'
              }, {
                id: SortOptions.Upvotes,
                showOrientationToggler: false,
                defaultOrientation: 'topToBottom'
              }];
              this.livestreamId = livestreamId;
              this.showUserInitials = (0, _lodash.get)(this.services.settings, 'person.show_initials', true);
              this.upvotedQuestionIds = [];
              this.pendingUpvotes = [];
              this.pendingDownvotes = [];
              this.sorting = {
                sortBy: SortOptions.Newest,
                options: sortOptions
              };
              this.debouncedVoteQuestionsRequest = (0, _lodash.debounce)(this.sendVoteQuestionsRequest.bind(this), 1000);
              _context.t0 = this.listeners;
              _context.next = 11;
              return this.services.signalService.addSignalListener(this.services.qnaService.updateSignal(livestreamId), function (signal) {
                return _this.onUpdateSignal(signal);
              });
            case 11:
              _context.t1 = _context.sent;
              _context.t2 = this.services.signalService.addEventListener('open', function () {
                return _this.getInitialState(livestreamId);
              });
              _context.t0.push.call(_context.t0, _context.t1, _context.t2);
              if (!initialLivestreamUpdate) {
                _context.next = 17;
                break;
              }
              _context.next = 17;
              return this.getInitialState(livestreamId);
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function init(_x, _x2) {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "isUpvotingEnabled",
    value: function isUpvotingEnabled() {
      var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.context;
      return (0, _lodash.get)(context, 'livestream.qna_upvoting_enabled', false);
    }
  }, {
    key: "isAskOnVodEnabled",
    value: function isAskOnVodEnabled() {
      var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.context;
      return (0, _lodash.get)(context, 'livestream.qna_ask_on_vod', false);
    }
  }, {
    key: "getInitialState",
    value: (function () {
      var _getInitialState = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee2(livestreamId) {
        var _ref, questions, questionsSortedByUpvotes, upvotedQuestionIds;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.services.qnaService.getQuestions(livestreamId);
            case 2:
              _context2.t0 = _context2.sent;
              if (_context2.t0) {
                _context2.next = 5;
                break;
              }
              _context2.t0 = {};
            case 5:
              _ref = _context2.t0;
              questions = _ref.qna;
              questionsSortedByUpvotes = _ref.qnaSortedByUpvotes;
              upvotedQuestionIds = _ref.qnaUpvotedQuestions;
              this.upvotedQuestionIds = upvotedQuestionIds;
              this.updateQuestions({
                questions: questions,
                questionsSortedByUpvotes: questionsSortedByUpvotes
              });
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getInitialState(_x3) {
        return _getInitialState.apply(this, arguments);
      }
      return getInitialState;
    }())
  }, {
    key: "addUpvote",
    value: function addUpvote(questionId) {
      this.markAsUpvoted(questionId);
      this.updatePlayerHandler();
      if (this.pendingDownvotes.includes(questionId)) {
        this.pendingDownvotes.splice(this.pendingDownvotes.indexOf(questionId), 1);
        return;
      }
      this.pendingUpvotes.push(questionId);
      this.debouncedVoteQuestionsRequest();
    }
  }, {
    key: "markAsUpvoted",
    value: function markAsUpvoted(questionId) {
      this.upvotedQuestionIds.push(questionId);
      this.getConcatenatedQuestions().filter(function (q) {
        return q.id === questionId;
      }).forEach(function (q) {
        q.upvoted = true;
        q.upvotes += 1;
      });
    }
  }, {
    key: "removeUpvote",
    value: function removeUpvote(questionId) {
      this.unmarkAsUpvoted(questionId);
      this.updatePlayerHandler();
      if (this.pendingUpvotes.includes(questionId)) {
        this.pendingUpvotes.splice(this.pendingUpvotes.indexOf(questionId), 1);
        return;
      }
      this.pendingDownvotes.push(questionId);
      this.debouncedVoteQuestionsRequest();
    }
  }, {
    key: "unmarkAsUpvoted",
    value: function unmarkAsUpvoted(questionId) {
      var index = this.upvotedQuestionIds.indexOf(questionId);
      if (index !== -1) {
        this.upvotedQuestionIds.splice(index, 1);
      }
      this.getConcatenatedQuestions().filter(function (q) {
        return q.id === questionId;
      }).forEach(function (q) {
        q.upvoted = false;
        q.upvotes -= 1;
      });
    }
  }, {
    key: "getConcatenatedQuestions",
    value: function getConcatenatedQuestions() {
      var questions = this.questions || [];
      var questionsSortedByUpvotes = this.questionsSortedByUpvotes || [];
      return questions.concat(questionsSortedByUpvotes);
    }
  }, {
    key: "sendVoteQuestionsRequest",
    value: function sendVoteQuestionsRequest() {
      if (!this.pendingUpvotes.length && !this.pendingDownvotes.length) {
        return;
      }
      this.services.qnaService.voteQuestions(this.livestreamId, {
        upvotes: this.pendingUpvotes,
        downvotes: this.pendingDownvotes
      });
      this.pendingUpvotes = [];
      this.pendingDownvotes = [];
    }
  }, {
    key: "getQuestion",
    value: function getQuestion(questionId) {
      return this.questions && this.questions.find(function (q) {
        return q.id === questionId;
      }) || this.questionsSortedByUpvotes && this.questionsSortedByUpvotes.find(function (q) {
        return q.id === questionId;
      });
    }
  }, {
    key: "onUpdateSignal",
    value: function onUpdateSignal(signal) {
      var _this2 = this;
      if (signal.questions) signal.questions.forEach(function (q) {
        return _this2.adjustUpvotesOfPendingQuestion(q);
      });
      if (signal.questionsSortedByUpvotes) signal.questionsSortedByUpvotes.forEach(function (q) {
        return _this2.adjustUpvotesOfPendingQuestion(q);
      });
      this.updateQuestions(signal);
    }
  }, {
    key: "adjustUpvotesOfPendingQuestion",
    value: function adjustUpvotesOfPendingQuestion(question) {
      if (question.upvotes != null) {
        if (this.pendingUpvotes.includes(question.id)) {
          question.upvotes++;
          question.upvoted = true;
        } else if (this.pendingDownvotes.includes(question.id)) {
          question.upvotes--;
          question.upvoted = false;
        }
      }
    }
  }, {
    key: "updateQuestions",
    value: function updateQuestions(signal) {
      var _this3 = this;
      if (!signal) {
        return;
      }
      var oldQuestions = (0, _lodash.cloneDeep)(this.questions || []);
      var oldQuestionsSortedByUpvotes = (0, _lodash.cloneDeep)(this.questionsSortedByUpvotes || []);
      var oldQuestionsMap = oldQuestions.concat(oldQuestionsSortedByUpvotes).reduce(function (acc, q) {
        return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2.default)({}, q.id, q));
      }, {});
      if (signal.questions) {
        this.questions = signal.questions.reverse().map(function (q) {
          return _this3.formatQuestion(q, oldQuestionsMap[q.id]);
        }).filter(function (q) {
          return q;
        });
      }
      if (signal.questionsSortedByUpvotes) {
        this.questionsSortedByUpvotes = signal.questionsSortedByUpvotes.map(function (q) {
          return _this3.formatQuestion(q, oldQuestionsMap[q.id]);
        }).filter(function (q) {
          return q;
        });
      }
      var visibleQuestionsHaveChanged = this.sorting.sortBy === SortOptions.Newest && !(0, _lodash.isEqual)(oldQuestions, this.questions) || this.sorting.sortBy === SortOptions.Upvotes && !(0, _lodash.isEqual)(oldQuestionsSortedByUpvotes, this.questionsSortedByUpvotes);
      if (visibleQuestionsHaveChanged) {
        this.updatePlayerHandler();
      }
    }
  }, {
    key: "formatQuestion",
    value: function formatQuestion(question) {
      var oldQuestion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if ((0, _lodash.isEmpty)(question)) {
        return null;
      }
      question = this.services.qnaService.resolveProfilePicture(question, this.context.eventIcon);
      var fromBstg = this.services.qnaService.isFromBSTG(question);
      var darkMode = this.services.THEME.get('appearance') === 'dark';
      var formattedQuestion = {
        id: question.id,
        question: (0, _filters.questionLinks)(this.services.$filter, this.services.$i18n, question.question),
        sent: (0, _filters.unixFromNow)(minimizeQuestionTime(question.sent)),
        status: question.status,
        showUserInitials: this.showUserInitials,
        upvotes: (0, _lodash.get)(question, 'upvotes', oldQuestion.upvotes || 0),
        upvoted: (0, _lodash.get)(question, 'upvoted', oldQuestion.upvoted || false),
        userName: question.participant,
        userId: question.pid,
        profilePicture: question.profile_pic,
        styles: {
          'background-color': fromBstg ? darkMode ? '#18191A' : '#F3F3F3' : ''
        }
      };
      if (!formattedQuestion.upvoted && this.upvotedQuestionIds.includes(formattedQuestion.id)) {
        formattedQuestion.upvoted = true;
      }
      return formattedQuestion;
    }
  }, {
    key: "onSideBarEvent",
    value: function onSideBarEvent(_ref2) {
      var newQuestion = _ref2.newQuestion,
        anonymous = _ref2.anonymous,
        onSuccess = _ref2.onSuccess,
        onError = _ref2.onError;
      if (!newQuestion) return;
      console.info('[Qna] Asking the question:', anonymous, newQuestion);
      this.services.qnaService.postQuestion(this.livestreamId, {
        anonymous: anonymous,
        question: newQuestion
      }).then(function () {
        if ((0, _lodash.isFunction)(onSuccess)) {
          onSuccess();
        }
      }).catch(function (error) {
        console.error("[LiveStreamSidebar] Couldn't post the question.", error);
        if ((0, _lodash.isFunction)(onError)) {
          onError();
        }
      });
    }
  }, {
    key: "onEvent",
    value: function onEvent(payload) {
      this.onQnaMetadata(payload);
    }
  }, {
    key: "onQnaMetadata",
    value: function onQnaMetadata(payload) {
      if (!this.useMetadata) return;
      this.highlightedQuestionFromMetadata = payload;
      this.updatePlayerHandler();
    }
  }, {
    key: "updateSortBy",
    value: function updateSortBy(sortOption) {
      if (!Object.values(SortOptions).includes(sortOption)) {
        return;
      }
      this.sorting.sortBy = sortOption;
      this.updatePlayerHandler();
    }
  }, {
    key: "getSortedQuestions",
    value: function getSortedQuestions() {
      if (!this.isUpvotingEnabled()) {
        return this.questions;
      }
      return this.sorting.sortBy === SortOptions.Newest ? this.questions : this.questionsSortedByUpvotes;
    }
  }, {
    key: "getAlign",
    value: function getAlign() {
      if (!this.isUpvotingEnabled() || !this.sorting) {
        return AlignOptions.Bottom;
      }
      return this.sorting.sortBy === SortOptions.Newest ? AlignOptions.Bottom : AlignOptions.Top;
    }
  }, {
    key: "config",
    get: function get() {
      var highlightedQuestionOnTop = this.isStreamless || this.isSmallScreen;
      var sortedQuestions = this.getSortedQuestions() || [];
      var highlightedQuestion;
      if (highlightedQuestionOnTop) {
        if (this.useMetadata) {
          var _this$highlightedQues, _highlightedQuestion;
          var qid = (_this$highlightedQues = this.highlightedQuestionFromMetadata) === null || _this$highlightedQues === void 0 ? void 0 : _this$highlightedQues.id;
          highlightedQuestion = this.formatQuestion(this.highlightedQuestionFromMetadata);
          var signalQuestion = this.getQuestion((_highlightedQuestion = highlightedQuestion) === null || _highlightedQuestion === void 0 ? void 0 : _highlightedQuestion.id);
          if (signalQuestion) {
            highlightedQuestion.upvoted = signalQuestion.upvoted;
            highlightedQuestion.upvotes = signalQuestion.upvotes;
          }
          sortedQuestions = sortedQuestions.filter(function (q) {
            return q.id !== qid;
          });
        } else {
          highlightedQuestion = sortedQuestions.find(function (q) {
            return q.status === 'highlighted';
          });
          sortedQuestions = sortedQuestions.filter(function (q) {
            return q.status !== 'highlighted';
          });
        }
      }
      if (!(0, _lodash.isEmpty)(highlightedQuestion)) {
        this.showNotification(null);
      }
      return {
        id: 'qna',
        align: this.getAlign(),
        questions: sortedQuestions,
        highlightedQuestion: highlightedQuestion,
        anonymousAllowed: (0, _lodash.get)(this, 'context.livestream.qna_anonymous_enabled'),
        throttleAskingQuestions: !(0, _lodash.get)(this, 'context.livestream.qna_moderation_enabled', true),
        upvotingEnabled: this.isUpvotingEnabled(),
        upvotingAllowed: this.services.liveStreamService.isUpvotingAllowed((0, _lodash.get)(this, 'context.livestream')),
        sorting: this.isUpvotingEnabled() ? this.sorting : null,
        disableSendingQuestions: this.streamEnded && !this.isAskOnVodEnabled()
      };
    }
  }]);
  return Qna;
}(_Tab2.Tab);
exports.Qna = Qna;
function minimizeQuestionTime(ts) {
  var now = (0, _time.nowUnixTimestamp)();
  return Math.min(ts, now);
}

},{"../../../../filters":235,"../../../../utils/time":367,"./Tab":142,"@babel/runtime/helpers/asyncToGenerator":375,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/defineProperty":378,"@babel/runtime/helpers/getPrototypeOf":380,"@babel/runtime/helpers/inherits":381,"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/helpers/possibleConstructorReturn":387,"@babel/runtime/regenerator":398,"lodash":"lodash"}],141:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Stream = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _Tab2 = require("./Tab");
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = (0, _getPrototypeOf2.default)(t); if (r) { var s = (0, _getPrototypeOf2.default)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0, _possibleConstructorReturn2.default)(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Stream = function (_Tab) {
  (0, _inherits2.default)(Stream, _Tab);
  var _super = _createSuper(Stream);
  function Stream() {
    (0, _classCallCheck2.default)(this, Stream);
    return _super.apply(this, arguments);
  }
  (0, _createClass2.default)(Stream, [{
    key: "config",
    get: function get() {
      return {
        id: 'stream'
      };
    }
  }, {
    key: "onSideBarEvent",
    value: function onSideBarEvent(payload) {
      var eid = this.services.EVENT._id;
      var currentKey = this.services.liveStreamService.STREAM_TOGGLE_KEY.replace('{{eid}}', eid);
      console.info('[Sidebar-Stream] Toggling stream visualization', payload);
      localStorage.setItem(currentKey, JSON.stringify(payload));
      this.services.eventBus.emit('pip:reset');
    }
  }]);
  return Stream;
}(_Tab2.Tab);
exports.Stream = Stream;

},{"./Tab":142,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/getPrototypeOf":380,"@babel/runtime/helpers/inherits":381,"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/helpers/possibleConstructorReturn":387}],142:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tab = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var Tab = function () {
  function Tab(services, context, getters, updatePlayerHandler) {
    (0, _classCallCheck2.default)(this, Tab);
    this.services = services;
    this.context = context;
    this.getters = getters;
    this.updatePlayerHandler = updatePlayerHandler;
    this.listeners = [];
  }
  (0, _createClass2.default)(Tab, [{
    key: "init",
    value: function init() {}
  }, {
    key: "onContextUpdated",
    value: function onContextUpdated(_oldContext) {}
  }, {
    key: "destroy",
    value: function destroy() {
      var _iterator = _createForOfIteratorHelper(this.listeners),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var unsub = _step.value;
          if ((0, _lodash.isFunction)(unsub)) {
            unsub();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "showNotification",
    value: function showNotification(payload) {
      this.playerApi.clientAction(payload, 'sideBarNotification');
    }
  }, {
    key: "useMetadata",
    get: function get() {
      return this.getters.useMetadata();
    }
  }, {
    key: "playerApi",
    get: function get() {
      return this.getters.playerApi();
    }
  }, {
    key: "isIframeContent",
    get: function get() {
      return this.getters.isIframeContent();
    }
  }, {
    key: "isSmallScreen",
    get: function get() {
      return this.getters.isSmallScreen();
    }
  }, {
    key: "isStreamless",
    get: function get() {
      return this.getters.isStreamless();
    }
  }, {
    key: "isInPerson",
    get: function get() {
      return this.getters.isInPerson();
    }
  }, {
    key: "isVod",
    get: function get() {
      return this.getters.isVod();
    }
  }, {
    key: "streamEnded",
    get: function get() {
      return this.getters.streamEnded();
    }
  }, {
    key: "livestream",
    get: function get() {
      return this.context.livestream;
    }
  }]);
  return Tab;
}();
exports.Tab = Tab;

},{"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"lodash":"lodash"}],143:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Translations = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _Tab2 = require("./Tab");
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = (0, _getPrototypeOf2.default)(t); if (r) { var s = (0, _getPrototypeOf2.default)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0, _possibleConstructorReturn2.default)(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Translations = function (_Tab) {
  (0, _inherits2.default)(Translations, _Tab);
  var _super = _createSuper(Translations);
  function Translations() {
    (0, _classCallCheck2.default)(this, Translations);
    return _super.apply(this, arguments);
  }
  (0, _createClass2.default)(Translations, [{
    key: "parameters",
    get: function get() {
      var isDarkMode = this.services.THEME.get('appearance') === 'dark';
      return "".concat(isDarkMode ? 'fgcolor=E4E6EB&bgcolor=18191A' : 'fgcolor=18191A&bgcolor=FFFFFF', "&lang=en&enableTTS=true");
    }
  }, {
    key: "sessionId",
    get: function get() {
      return this.livestream.multicast_session_id;
    }
  }, {
    key: "url",
    get: function get() {
      return "https://attend.wordly.ai/frame/".concat(this.sessionId, "?").concat(this.parameters);
    }
  }, {
    key: "config",
    get: function get() {
      if (!this.sessionId) {
        return {};
      }
      return {
        id: 'translations',
        src: this.url
      };
    }
  }]);
  return Translations;
}(_Tab2.Tab);
exports.Translations = Translations;

},{"./Tab":142,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/getPrototypeOf":380,"@babel/runtime/helpers/inherits":381,"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/helpers/possibleConstructorReturn":387}],144:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Viewers = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _lodash = require("lodash");
var _Tab2 = require("./Tab");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = (0, _getPrototypeOf2.default)(t); if (r) { var s = (0, _getPrototypeOf2.default)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0, _possibleConstructorReturn2.default)(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Viewers = function (_Tab) {
  (0, _inherits2.default)(Viewers, _Tab);
  var _super = _createSuper(Viewers);
  function Viewers() {
    (0, _classCallCheck2.default)(this, Viewers);
    return _super.apply(this, arguments);
  }
  (0, _createClass2.default)(Viewers, [{
    key: "init",
    value: function () {
      var _init = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee(livestreamId) {
        var _this = this;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = this.listeners;
              _context.next = 3;
              return this.services.signalService.addSignalListener("liveStream/".concat(livestreamId, "/interactions"), function (signal) {
                return _this.updateViewers(signal);
              });
            case 3:
              _context.t1 = _context.sent;
              _context.t0.push.call(_context.t0, _context.t1);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function init(_x) {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "updateViewers",
    value: function updateViewers(data) {
      this.loaded = true;
      if (!data || !data.viewers) {
        return;
      }
      var oldViewers = (0, _lodash.cloneDeep)(this.viewers);
      var viewers = data.viewers;
      this.viewers = (viewers.participants || []).map(function (viewer) {
        return _objectSpread({}, viewer);
      });
      if (!(0, _lodash.isEqual)(oldViewers, this.viewers)) {
        this.updatePlayerHandler();
      }
    }
  }, {
    key: "onSideBarEvent",
    value: function onSideBarEvent(_ref) {
      var pid = _ref.pid;
      if (this.services.EVENT.is_webinar) return;
      this.services.navService.openDocument({
        _id: pid
      }, {
        navParams: {
          modal: true,
          fullscreen: true
        }
      });
    }
  }, {
    key: "config",
    get: function get() {
      return {
        id: 'viewers',
        viewers: this.viewers,
        hidden: !this.loaded
      };
    }
  }]);
  return Viewers;
}(_Tab2.Tab);
exports.Viewers = Viewers;

},{"./Tab":142,"@babel/runtime/helpers/asyncToGenerator":375,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/defineProperty":378,"@babel/runtime/helpers/getPrototypeOf":380,"@babel/runtime/helpers/inherits":381,"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/helpers/possibleConstructorReturn":387,"@babel/runtime/regenerator":398,"lodash":"lodash"}],145:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoPlayerComponent = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
require("frontend-video-player/webcomponent");
var _dom = require("../../../utils/dom");
var _i18n = require("./i18n");
var _Configurator = require("./side-bar/Configurator");
var _filters = require("../../../filters");
var _assets = require("../../../utils/assets");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var COUNTDOWN_STATES = {
  STREAM_IS_LIVE: 'streamIsLive',
  COUNTDOWN_ONGOING: 'countdownOngoing',
  COUNTDOWN_ENDED: 'countdownEnded',
  STREAM_ENDED: 'streamEnded'
};
var ANALYTICS_TRACK_JITTER = 10 * 1000;
var COUNTDOWN_ANALYTICS_INTERVAL = 30 * 1000;
var MAX_WINDOW_WIDTH_FOR_MOBILE_EXPERIENCE = 991;
var getInterprefyUrl = function getInterprefyUrl() {
  var interprefyProjectId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return "https://interpret.world/loginlink?token=".concat(interprefyProjectId);
};
var VideoPlayerComponent = {
  template: require('./video-player.jade'),
  bindings: {
    config: '<',
    sourceUrl: '<',
    isIframeContent: '=',
    broadcastStarted: '=',
    media: '<',
    autoplay: '<',
    useMetadata: '='
  },
  controller: function () {
    VideoPlayerComponent.$inject = ["$element", "$eventBus", "$i18n", "$filter", "$scope", "$interval", "ACTIVATED_PERSON", "EID", "EVENT", "SETTINGS", "THEME", "triggerService", "reactionsService", "liveStreamService", "metricsService", "navService", "qnaService", "pollService", "signalService", "targetingService", "videoPlayerService"];
    /* @ngInject */function VideoPlayerComponent($element, $eventBus, $i18n, $filter, $scope, $interval, ACTIVATED_PERSON, EID, EVENT, SETTINGS, THEME, triggerService, reactionsService, liveStreamService, metricsService, navService, qnaService, pollService, signalService, targetingService, videoPlayerService) {
      (0, _classCallCheck2.default)(this, VideoPlayerComponent);
      this.$element = $element;
      this.$eventBus = $eventBus;
      this.$scope = $scope;
      this.$filter = $filter;
      this.$i18n = $i18n;
      this.$interval = $interval;
      this.theme = THEME;
      this.settings = SETTINGS;
      this.triggerService = triggerService;
      this.setCaptionTextPosition(null);
      this.ACTIVATED_PERSON = ACTIVATED_PERSON;
      this.EID = EID;
      this.EVENT = EVENT;
      this.isMaximised = false;
      this.reactionsService = reactionsService;
      this.liveStreamService = liveStreamService;
      this.signalService = signalService;
      this.qnaService = qnaService;
      this.pollService = pollService;
      this.navService = navService;
      this.targetingService = targetingService;
      this.videoPlayerService = videoPlayerService;
      this.videoInPipMode = false;
      this.destroyed = false;
      this.listeners = [];
      this.countdownState = '';
      this.metricsService = metricsService;
      this.analyticsJitter = Math.floor(Math.random() * ANALYTICS_TRACK_JITTER);
      this.countdownInterval = undefined;
      this.sendAnalyticsTimeout = undefined;
      this.getNewCookiesOnPlay = false;
      this.videoSessionId = null;
      this.configIsReady = false;
      this.url = '';
      this.dummyVideoIsPlaying = false;
      this.isPlayerFullscreen = false;
      this.shouldShowCrashMessage = false;
      this.hadNetworkError = false;
      this.addResolutionControl = false;
      try {
        this.isLocalDevNode = "production" === 'dev';
      } catch (e) {
        console.log(e);
      }
      this.cmcdSessionId = ACTIVATED_PERSON._id + '@' + Date.now();
      this.playerLabels = (0, _i18n.getLabels)(this.$i18n, ACTIVATED_PERSON);
    }
    (0, _createClass2.default)(VideoPlayerComponent, [{
      key: "$onInit",
      value: function $onInit() {
        this.isInPerson = this.liveStreamService.isInPerson(this.config);
        this.isToggleStreamTabEnabled = this.liveStreamService.isToggleStreamTabEnabled(this.config);
        this.isThirdParty = this.config.isThirdParty;
      }
    }, {
      key: "$postLink",
      value: function () {
        var _$postLink = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee2() {
          var _this = this;
          var width, eventIcon, _showTranslationsTab, skipNextFullscreenEvent, onNativeFullscreenChange;
          return _regenerator.default.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                console.log('[VideoPlayer] initializing video player');
                if (this.$element.closest('.block').length) {
                  width = this.$element.width();
                  this.$element.height(width * (9 / 16));
                }
                eventIcon = (0, _assets.getEventIconUrl)(this.EVENT);
                _context2.next = 5;
                return (0, _assets.checkIfImageLoads)(eventIcon);
              case 5:
                if (!_context2.sent) {
                  _context2.next = 9;
                  break;
                }
                _context2.t0 = eventIcon;
                _context2.next = 10;
                break;
              case 9:
                _context2.t0 = null;
              case 10:
                this.eventIcon = _context2.t0;
                _showTranslationsTab = function showTranslationsTab() {
                  return !!(0, _lodash.get)(_this.config, 'multicast_session_id', '');
                };
                this.sideBarConfigurator = new _Configurator.Configurator({
                  navService: this.navService,
                  signalService: this.signalService,
                  pollService: this.pollService,
                  qnaService: this.qnaService,
                  targetingService: this.targetingService,
                  liveStreamService: this.liveStreamService,
                  EVENT: this.EVENT,
                  THEME: this.theme,
                  $i18n: this.$i18n,
                  $filter: this.$filter,
                  settings: this.settings,
                  eventBus: this.$eventBus
                }, {
                  livestream: this.config,
                  labels: this.playerLabels,
                  eventIcon: this.eventIcon
                }, {
                  useMetadata: function useMetadata() {
                    return _this.useMetadata;
                  },
                  playerApi: function playerApi() {
                    return _this.playerApi;
                  },
                  isIframeContent: function isIframeContent() {
                    return _this.isIframeContent;
                  },
                  isSmallScreen: function isSmallScreen() {
                    return _this.isSmallScreen;
                  },
                  isStreamless: function isStreamless() {
                    return _this.isStreamless;
                  },
                  isInPerson: function isInPerson() {
                    return _this.isInPerson;
                  },
                  isVod: function isVod() {
                    return _this.isVod;
                  },
                  streamEnded: function streamEnded() {
                    return _this.streamEnded;
                  },
                  showViewers: function showViewers() {
                    return _this.showViewers;
                  },
                  showTranslationsTab: function showTranslationsTab() {
                    return _showTranslationsTab();
                  },
                  showStreamTab: function showStreamTab() {
                    return _this.showStreamTab;
                  },
                  isPrivateQna: function isPrivateQna() {
                    return _this.isPrivateQna;
                  }
                }, function () {
                  return _this.updatePlayerConfig();
                });
                skipNextFullscreenEvent = false;
                onNativeFullscreenChange = function () {
                  var _ref = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee() {
                    return _regenerator.default.wrap(function _callee$(_context) {
                      while (1) switch (_context.prev = _context.next) {
                        case 0:
                          if (!skipNextFullscreenEvent) {
                            _context.next = 3;
                            break;
                          }
                          skipNextFullscreenEvent = false;
                          return _context.abrupt("return");
                        case 3:
                          if (!document.fullscreenElement) {
                            _context.next = 7;
                            break;
                          }
                          skipNextFullscreenEvent = true;
                          _context.next = 7;
                          return document.exitFullscreen();
                        case 7:
                          _this.toggleClientFullscreen();
                        case 8:
                        case "end":
                          return _context.stop();
                      }
                    }, _callee);
                  }));
                  return function onNativeFullscreenChange() {
                    return _ref.apply(this, arguments);
                  };
                }();
                this.setupWindowWidthListener();
                this.listeners.push(this.$scope.$watch('$ctrl.sourceUrl', function () {
                  return _this.setUrl();
                }, false), this.$scope.$watch('$ctrl.config', function () {
                  return _this.onNewConfig();
                }, true), this.$scope.$watch('$ctrl.isIframeContent', function () {
                  return _this.newIframeContent();
                }, true), this.$scope.$watch('$ctrl.useCredentials', function () {
                  return _this.setUrl();
                }, true), this.$scope.$watch('$ctrl.playerHidden', function () {
                  return _this.setUrl();
                }, true), this.$scope.$watch('$ctrl.broadcastStarted', function () {
                  _this.sideBarConfigurator.resolveTabs();
                  _this.updatePlayerConfig();
                }, true), this.$scope.$on('video-pip:float', function () {
                  _this.videoInPipMode = true;
                  _this.updatePlayerConfig();
                  _this.showNotifications();
                }), this.$scope.$on('video-pip:embed', function () {
                  _this.videoInPipMode = false;
                  _this.updatePlayerConfig();
                  _this.hideNotifications();
                }), this.$scope.$on('video-player:premature-stop', function () {
                  return _this.onPrematureStop();
                }), (0, _dom.addEventListener)(this.player, 'fullscreenchange', onNativeFullscreenChange), (0, _dom.addEventListener)(this.player, 'mozfullscreenchange', onNativeFullscreenChange), (0, _dom.addEventListener)(this.player, 'webkitfullscreenchange', onNativeFullscreenChange), (0, _dom.addEventListener)(this.player, 'msfullscreenchange', onNativeFullscreenChange), (0, _dom.addEventListener)(window, 'beforeunload', function () {
                  return _this.sendUpdatedAnalytics();
                }), this.$eventBus.on('video-player:force-pause', function (_ref2) {
                  var emitter = _ref2.emitter;
                  if (emitter === _this) {
                    return;
                  }
                  console.log('[VideoPlayer] pausing because another player started');
                  _this.playerApi.pause();
                  _this.getNewCookiesOnPlay = true;
                }), this.triggerService.addTrigger('reset', function () {
                  _this.playerApi.clientAction(true, 'resetController');
                }), this.triggerService.addTrigger('resolution', function () {
                  _this.addResolutionControl = true;
                  _this.updatePlayerConfig();
                }));
                this.hideNotifications();
                this.onNewConfig(true);
                _context2.next = 21;
                return this.setUrl();
              case 21:
                this.setupPlayer();
              case 22:
              case "end":
                return _context2.stop();
            }
          }, _callee2, this);
        }));
        function $postLink() {
          return _$postLink.apply(this, arguments);
        }
        return $postLink;
      }()
    }, {
      key: "$onDestroy",
      value: function $onDestroy() {
        this.destroyed = true;
        this.removeAnalyticsInterval();
        clearTimeout(this.sendAnalyticsTimeout);
        this.sendUpdatedAnalytics();
        this.playerApi.dispose();
        var _iterator = _createForOfIteratorHelper(this.listeners),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var unsub = _step.value;
            if ((0, _lodash.isFunction)(unsub)) {
              unsub();
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        if (this.sideBarConfigurator) {
          this.sideBarConfigurator.destroy();
        }
        if (this.isPlayerFullscreen) {
          this.$eventBus.emit('theatreMode:disabled');
        }
        this.showNotifications();
      }
    }, {
      key: "showNotifications",
      value: function showNotifications() {
        this.$eventBus.emit('notifications:show', "polls-".concat(this.liveStreamId));
      }
    }, {
      key: "hideNotifications",
      value: function hideNotifications() {
        this.$eventBus.emit('notifications:hide', "polls-".concat(this.liveStreamId));
      }
    }, {
      key: "newIframeContent",
      value: function () {
        var _newIframeContent = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee3() {
          return _regenerator.default.wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                this.updatePlayerConfig();
              case 1:
              case "end":
                return _context3.stop();
            }
          }, _callee3, this);
        }));
        function newIframeContent() {
          return _newIframeContent.apply(this, arguments);
        }
        return newIframeContent;
      }()
    }, {
      key: "onNewConfig",
      value: function onNewConfig() {
        var initialUpdate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        this.useCredentials = this.liveStreamId && (this.isVod || !!(0, _lodash.get)(this, 'config.cookies') || this.useCredentials) && !this.isLocalDevNode || this.config && this.config.fp_type === 'video';
        this.sideBarConfigurator.onLivestreamUpdate(this.config, initialUpdate);
        this.updatePlayerConfig();
      }
    }, {
      key: "setUrl",
      value: function () {
        var _setUrl = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee4() {
          return _regenerator.default.wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                this.dummyVideoIsPlaying = false;
                if (!this.liveStreamId) {
                  if (this.sourceUrl) {
                    this.url = this.sourceUrl;
                  } else if ((0, _lodash.isString)(this.media)) {
                    this.url = this.media;
                  } else {
                    this.url = (0, _lodash.get)(this.media, 'sources[0].source', null);
                  }
                } else if (this.isThirdParty || this.isIframeContent) {
                  this.url = this.playerHidden ? '' : this.sourceUrl;
                } else if (this.useCredentials || this.isLocalDevNode && this.sourceUrl) {
                  this.url = this.sourceUrl;
                } else if (!this.isFinished) {
                  this.url = (0, _assets.getStaticAsset)('media/video.mp4');
                  this.dummyVideoIsPlaying = true;
                } else {
                  this.url = '';
                }
                _context4.next = 4;
                return this.videoPlayerService.getCookies(this.url);
              case 4:
                this.url = _context4.sent;
                console.log('[VideoPlayer] set url', {
                  url: this.url,
                  loop: this.dummyVideoIsPlaying
                });
              case 6:
              case "end":
                return _context4.stop();
            }
          }, _callee4, this);
        }));
        function setUrl() {
          return _setUrl.apply(this, arguments);
        }
        return setUrl;
      }()
    }, {
      key: "setupPlayer",
      value: function setupPlayer() {
        var player = this.player;
        if (!player) return;
        player.config = this.playerConfig;
        if (this.liveStreamId) {
          this.setupClaps();
          this.setupQna();
          if (!this.isVod) {
            this.setupCountdown();
          }
          this.sideBarConfigurator.init(this.config);
          this.getInitialState();
        }
        if (!(0, _lodash.some)(this.playerConfig.components, this.countdownWidget)) {
          this.configIsReady = true;
        }
        this.$scope.$applyAsync();
      }
    }, {
      key: "setupWindowWidthListener",
      value: function setupWindowWidthListener() {
        var _this2 = this;
        this.isSmallScreen = false;
        var windowResizeListener = (0, _lodash.throttle)(function () {
          var isSmallScreen = window.innerWidth <= MAX_WINDOW_WIDTH_FOR_MOBILE_EXPERIENCE;
          if (_this2.isSmallScreen !== isSmallScreen) {
            _this2.isSmallScreen = isSmallScreen;
            _this2.$scope.$emit('isSmallScreen', _this2.isSmallScreen);
            _this2.updatePlayerConfig();
          }
        }, 500);
        this.listeners.push((0, _dom.addEventListener)(window, 'resize', windowResizeListener));
        windowResizeListener();
      }
    }, {
      key: "getInitialState",
      value: function () {
        var _getInitialState = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee5() {
          var qnaState;
          return _regenerator.default.wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                if (this.liveStreamId) {
                  _context5.next = 2;
                  break;
                }
                return _context5.abrupt("return");
              case 2:
                if (this.useMetadata) {
                  _context5.next = 7;
                  break;
                }
                _context5.next = 5;
                return this.qnaService.getQuestions(this.liveStreamId);
              case 5:
                qnaState = _context5.sent;
                this.onQnaSignal(qnaState.qna, qnaState.qnaSortedByUpdates);
              case 7:
              case "end":
                return _context5.stop();
            }
          }, _callee5, this);
        }));
        function getInitialState() {
          return _getInitialState.apply(this, arguments);
        }
        return getInitialState;
      }()
    }, {
      key: "onPlayerError",
      value: function onPlayerError(event) {
        var payload = (0, _lodash.get)(event, 'originalEvent.detail.0');
        var context = (0, _lodash.get)(event, 'originalEvent.detail.1');
        if (context !== 'hls') return;
        var _pick = (0, _lodash.pick)((0, _lodash.get)(payload, 'data', {}), ['fatal', 'type', 'details', 'response']),
          fatal = _pick.fatal,
          type = _pick.type,
          details = _pick.details,
          response = _pick.response;
        var responseCode = (0, _lodash.get)(response, 'code', 0);
        console.debug('[VideoPlayer] onPlayerError', {
          fatal: fatal,
          type: type,
          details: details,
          response: response
        });
        var stats = (0, _lodash.isFunction)(this.getUpdatedStats) ? this.getUpdatedStats() : undefined;
        var isTimeout = details && details.toLowerCase().includes('timeout') || (0, _lodash.get)(payload, 'data.error.message', '').includes('timeout') || type === 'networkError' && !response;
        var requestedResource = type !== 'networkError' || !details ? undefined : details.startsWith('frag') ? 'segment' : 'playlist';
        this.videoPlayerService.trackError({
          liveStreamId: this.liveStreamId,
          parentDocId: (0, _lodash.get)(this, 'config.analytic_params.document_id'),
          videoElapsedSecs: (0, _lodash.get)(this.playerApi.getState(), 'videoElapsedSecs'),
          url: (0, _lodash.get)(payload, 'data.url'),
          errorType: type,
          errorDetails: details,
          responseCode: responseCode,
          fatal: fatal,
          videoSessionId: this.videoSessionId,
          isTimeout: isTimeout,
          requestedResource: requestedResource,
          resolution: (0, _lodash.get)(stats, 'playlist_resolution'),
          org: this.EVENT.orgName
        });
        var isAuthError = type === 'networkError' && (responseCode === 401 || responseCode === 403);
        var probablyCORSerror = this.hadNetworkError && fatal && details === 'smvpError';
        if (isAuthError || probablyCORSerror) {
          console.error('[VideoPlayer] detected some potential auth/CORS issue, stopping playback and flag to reload on play', {
            fatal: fatal,
            type: type,
            details: details,
            response: response
          });
          this.playerApi.pause();
          this.getNewCookiesOnPlay = true;
          this.hadNetworkError = false;
          return;
        } else if (fatal && details === 'smvpError') {
          this.hadNetworkError = false;
          return this.handleFatalHlsError();
        }
        this.hadNetworkError = this.hadNetworkError || type === 'networkError';
      }
    }, {
      key: "onPrematureStop",
      value: function onPrematureStop() {
        this.videoPlayerService.trackError({
          liveStreamId: this.liveStreamId,
          parentDocId: (0, _lodash.get)(this, 'config.analytic_params.document_id'),
          videoElapsedSecs: (0, _lodash.get)(this.playerApi.getState(), 'videoElapsedSecs'),
          url: (0, _lodash.get)(this, 'config.url'),
          errorType: 'prematureStop',
          errorDetails: 'premature stop, id3 contained is_live: false before we got a live stream document with is_finished: true',
          videoSessionId: this.videoSessionId
        });
      }
    }, {
      key: "showCrashMessage",
      value: function showCrashMessage() {
        this.shouldShowCrashMessage = true;
        this.updatePlayerConfig();
      }
    }, {
      key: "removeCrashMessage",
      value: function removeCrashMessage() {
        this.shouldShowCrashMessage = false;
        this.updatePlayerConfig();
      }
    }, {
      key: "handleFatalHlsError",
      value: function handleFatalHlsError() {
        this.showCrashMessage();
      }
    }, {
      key: "onCustomAction",
      value: function onCustomAction(event) {
        var payload = (0, _lodash.get)(event, 'originalEvent.detail.0');
        var context = (0, _lodash.get)(event, 'originalEvent.detail.1');
        switch (context) {
          case 'clientFullscreen':
            return this.toggleClientFullscreen();
          case 'fullscreen':
            return this.toggleFullscreen(payload);
          case 'claps':
            return this.handleClaps(payload);
          case 'qna':
            this.sideBarConfigurator.onEvent(context, payload);
            return this.onQnaMetadata(payload);
          case 'addQuestionUpvote':
            return this.addQuestionUpvote(payload);
          case 'removeQuestionUpvote':
            return this.removeQuestionUpvote(payload);
          case 'polls':
            return this.sideBarConfigurator.onEvent(context, payload);
          case 'countdown':
            return this.onCountdownEvent(payload);
          case 'sideBarViewers':
            return this.sideBarConfigurator.onSideBarEvent(context, payload);
          case 'sideBarQna':
            return this.sideBarConfigurator.onSideBarEvent(context, payload);
          case 'sideBarQnaSortBy':
            return this.updateSideBarQnaSortBy(payload);
          case 'sideBarPolls':
            return this.sideBarConfigurator.onSideBarEvent(context, payload);
          case 'sideBarNotification':
            return this.handleSidebarNotification(payload);
          case 'hls':
            return this.onHlsAction(payload);
          case 'sideBarStream':
            return this.sideBarConfigurator.onSideBarEvent(context, payload);
        }
      }
    }, {
      key: "addQuestionUpvote",
      value: function addQuestionUpvote(question) {
        var qnaTab = this.sideBarConfigurator.getTabInstance('qna');
        qnaTab.addUpvote(question.id);
        this.updateHighlightedQuestionUpvotes(question.id);
      }
    }, {
      key: "removeQuestionUpvote",
      value: function removeQuestionUpvote(question) {
        var qnaTab = this.sideBarConfigurator.getTabInstance('qna');
        qnaTab.removeUpvote(question.id);
        this.updateHighlightedQuestionUpvotes(question.id);
      }
    }, {
      key: "updateSideBarQnaSortBy",
      value: function updateSideBarQnaSortBy(sortOption) {
        var qnaTab = this.sideBarConfigurator.getTabInstance('qna');
        qnaTab.updateSortBy(sortOption);
      }
    }, {
      key: "updateHighlightedQuestionUpvotes",
      value: function updateHighlightedQuestionUpvotes(questionId) {
        var newQuestion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var qnaTab = this.sideBarConfigurator.getTabInstance('qna');
        if (this.highlightedQuestion && this.highlightedQuestion.id === questionId) {
          var q = newQuestion || qnaTab.getQuestion(questionId);
          var newHighlightedQuestion = (0, _lodash.cloneDeep)(this.highlightedQuestion);
          newHighlightedQuestion.upvotes = q.upvotes;
          newHighlightedQuestion.upvoted = q.upvoted;
          this.processHighlightedQuestion(newHighlightedQuestion);
        }
      }
    }, {
      key: "onHlsAction",
      value: function onHlsAction(payload) {
        var _ref3 = payload || {},
          event = _ref3.event;
        switch (event) {
          case 'bufferingEnded':
          case 'smvpErrorRecover':
            return this.onPlaybackResumedHandler();
          case 'hlsLevelUpdated':
            return this.hlsLevelUpdated(payload);
        }
      }
    }, {
      key: "onPlaybackResumedHandler",
      value: function onPlaybackResumedHandler() {
        this.removeCrashMessage();
      }
    }, {
      key: "hlsLevelUpdated",
      value: function hlsLevelUpdated(payload) {
        var isLive = payload.isLive;
        console.log('[VideoPlayer] hlsLevelUpdated', {
          isLive: isLive
        });
      }
    }, {
      key: "onPlayerAnalytics",
      value: function onPlayerAnalytics(event) {
        var payload = (0, _lodash.get)(event, 'originalEvent.detail.0', {});
        var context = (0, _lodash.get)(event, 'originalEvent.detail.1');
        var stats = payload.stats || {};
        var dummyUrl = (0, _assets.getStaticAsset)('media/video.mp4');
        if ((0, _lodash.get)(stats.player, 'source.src') === dummyUrl) {
          return;
        }
        this.getUpdatedStats = payload.getUpdatedStats;
        switch (context) {
          case 'hls':
            return this.sendAnalytics({
              stats: stats
            });
        }
      }
    }, {
      key: "onVideoPlayerStateChanged",
      value: function onVideoPlayerStateChanged(event) {
        var payload = (0, _lodash.get)(event, 'detail.0', {});
        var isPlaying = payload.isPlaying;
        if (!(0, _lodash.isBoolean)(isPlaying)) {
          return;
        }
        if (isPlaying) {
          console.log('[VideoPlayer] playback started');
          if (this.getNewCookiesOnPlay) {
            this.getNewCookiesOnPlay = false;
            this.videoPlayerService.getCookies(this.sourceUrl);
          }
          this.$eventBus.emit('video-player:force-pause', {
            emitter: this
          });
        } else {
          console.log('[VideoPlayer] playback stopped', payload);
        }
      }
    }, {
      key: "sendUpdatedAnalytics",
      value: function sendUpdatedAnalytics() {
        if ((0, _lodash.isFunction)(this.getUpdatedStats)) {
          var updatedStats = this.getUpdatedStats();
          this.sendAnalytics({
            stats: updatedStats,
            immediate: true
          });
        }
      }
    }, {
      key: "sendAnalytics",
      value: function sendAnalytics() {
        var _this3 = this;
        var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          stats = _ref4.stats,
          _ref4$immediate = _ref4.immediate,
          immediate = _ref4$immediate === void 0 ? false : _ref4$immediate;
        if ((0, _lodash.isEmpty)(stats)) {
          return;
        }
        this.videoSessionId = stats.video_session_id;
        if (this.liveStreamId) {
          stats.fp_type = 'live_stream';
          stats.document_id = this.liveStreamId;
        } else {
          stats.fp_type = this.config.fp_type;
          stats.document_id = this.config.document_id;
        }
        if (!stats.document_id || !stats.fp_type) {
          return;
        }
        if (immediate) {
          return this.metricsService.trackAnalytics(stats);
        }
        if (this.destroyed) return;
        this.sendAnalyticsTimeout = setTimeout(function () {
          stats.jitter = _this3.analyticsJitter;
          _this3.metricsService.trackAnalytics(stats);
        }, this.analyticsJitter);
      }
    }, {
      key: "toggleClientFullscreen",
      value: function toggleClientFullscreen() {
        this.isMaximised = !this.isMaximised;
        if (this.isMaximised) {
          this.$scope.$emit('theatreMode:on');
        } else {
          this.$scope.$emit('theatreMode:off');
        }
        this.playerApi.clientAction(this.isMaximised, 'clientFullscreen');
      }
    }, {
      key: "toggleFullscreen",
      value: function toggleFullscreen() {
        var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          isFullScreen = _ref5.isFullScreen;
        this.isPlayerFullscreen = isFullScreen;
        if (isFullScreen) {
          this.$eventBus.emit('theatreMode:enabled');
        } else {
          this.$eventBus.emit('theatreMode:disabled');
        }
        this.updatePlayerConfig();
      }
    }, {
      key: "updatePlayerConfig",
      value: function updatePlayerConfig() {
        var player = this.player;
        if (!this.configIsReady) {
          return;
        }
        player.config = this.playerConfig;
      }
    }, {
      key: "setCaptionTextPosition",
      value: function setCaptionTextPosition() {
        var isSomethingAlreadyOnScreen = this.hasSideBarNotificationOnScreen || !!this.highlightedQuestion;
        var currentTextPosition = this.captionTextPosition;
        this.captionTextPosition = isSomethingAlreadyOnScreen ? 'top' : 'bottom';
        if (currentTextPosition !== this.captionTextPosition) {
          this.updatePlayerConfig();
        }
      }
    }, {
      key: "handleSidebarNotification",
      value: function handleSidebarNotification(payload) {
        this.hasSideBarNotificationOnScreen = !(0, _lodash.isEmpty)(payload);
        this.setCaptionTextPosition();
      }
    }, {
      key: "setupCountdown",
      value: function setupCountdown() {
        var _this4 = this;
        if (this.destroyed) return;
        this.countdownInterval = this.$interval(function () {
          return _this4.updateCountdownAnalytics();
        }, COUNTDOWN_ANALYTICS_INTERVAL);
        this.updateCountdownAnalytics(true);
      }
    }, {
      key: "updateCountdownAnalytics",
      value: function updateCountdownAnalytics(skipPlayerCheck) {
        if (!this.playerHidden && !skipPlayerCheck) {
          return this.removeAnalyticsInterval();
        }
        this.metricsService.trackAnalytics({
          name: 'waiting',
          document_id: this.liveStreamId,
          document_type: 'live_stream'
        });
      }
    }, {
      key: "removeAnalyticsInterval",
      value: function removeAnalyticsInterval() {
        this.$interval.cancel(this.countdownInterval);
      }
    }, {
      key: "playerHidden",
      get: function get() {
        return this.countdownState !== COUNTDOWN_STATES.STREAM_IS_LIVE;
      }
    }, {
      key: "reactToCountdownStateChange",
      value: function () {
        var _reactToCountdownStateChange = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee6(newState) {
          return _regenerator.default.wrap(function _callee6$(_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                this.countdownState = newState;
                if (!this.isThirdParty) {
                  _context6.next = 4;
                  break;
                }
                _context6.next = 4;
                return this.setUrl();
              case 4:
                this.updatePlayerConfig();
              case 5:
              case "end":
                return _context6.stop();
            }
          }, _callee6, this);
        }));
        function reactToCountdownStateChange(_x) {
          return _reactToCountdownStateChange.apply(this, arguments);
        }
        return reactToCountdownStateChange;
      }()
    }, {
      key: "onCountdownEvent",
      value: function () {
        var _onCountdownEvent = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee7(payload) {
          return _regenerator.default.wrap(function _callee7$(_context7) {
            while (1) switch (_context7.prev = _context7.next) {
              case 0:
                if (payload.streamIsLive) {
                  this.$scope.$emit('live-stream:start-broadcast-from-id3');
                }
                if (payload.streamEnded) {
                  this.$scope.$emit('live-stream:stop-broadcast-from-id3');
                }
                if (!payload.newState) {
                  _context7.next = 5;
                  break;
                }
                _context7.next = 5;
                return this.reactToCountdownStateChange(payload.newState);
              case 5:
                if (!this.configIsReady) {
                  this.configIsReady = true;
                  this.updatePlayerConfig();
                  this.$scope.$applyAsync();
                }
              case 6:
              case "end":
                return _context7.stop();
            }
          }, _callee7, this);
        }));
        function onCountdownEvent(_x2) {
          return _onCountdownEvent.apply(this, arguments);
        }
        return onCountdownEvent;
      }()
    }, {
      key: "setupClaps",
      value: function setupClaps() {
        var _this5 = this;
        this.reactionsService.onClapsSignal(this.liveStreamId, function (_ref6) {
          var reactions = _ref6.reactions;
          return _this5.onClapsSignal(reactions);
        }).then(function (remover) {
          return _this5.listeners.push(remover);
        });
      }
    }, {
      key: "onClapsSignal",
      value: function onClapsSignal(reactions) {
        var claps = (0, _lodash.get)(reactions, 'claps', 0);
        this.playerApi.clientAction(claps, 'claps');
      }
    }, {
      key: "handleClaps",
      value: function handleClaps(payload) {
        if (payload <= 0) return;
        this.reactionsService.sendClaps(this.liveStreamId, payload);
      }
    }, {
      key: "setupQna",
      value: (function () {
        var _setupQna = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee8() {
          var _this6 = this;
          return _regenerator.default.wrap(function _callee8$(_context8) {
            while (1) switch (_context8.prev = _context8.next) {
              case 0:
                _context8.t0 = this.listeners;
                _context8.next = 3;
                return this.signalService.addSignalListener(this.qnaService.updateSignal(this.liveStreamId), function (signal) {
                  _this6.onQnaSignal(signal.questions, signal.questionsSortedByUpvotes);
                });
              case 3:
                _context8.t1 = _context8.sent;
                _context8.t0.push.call(_context8.t0, _context8.t1);
              case 5:
              case "end":
                return _context8.stop();
            }
          }, _callee8, this);
        }));
        function setupQna() {
          return _setupQna.apply(this, arguments);
        }
        return setupQna;
      }())
    }, {
      key: "onQnaSignal",
      value: function onQnaSignal(questions, questionsSortedByUpvotes) {
        var _this7 = this;
        if (!(0, _lodash.get)(questions, 'length')) return;
        var allQuestions = questionsSortedByUpvotes && questionsSortedByUpvotes.length > 0 ? questions.concat(questionsSortedByUpvotes) : questions;
        if (this.isThirdParty) {
          var highlight = allQuestions.find(function (q) {
            return q.status === 'highlighted';
          });
          this.processHighlightedQuestion(highlight);
        } else if (this.config.qna_upvoting_enabled && this.highlightedQuestion) {
          var q = allQuestions.find(function (i) {
            return i.id === _this7.highlightedQuestion.id;
          });
          if (q) {
            this.updateHighlightedQuestionUpvotes(q.id, q);
          }
        }
      }
    }, {
      key: "onQnaMetadata",
      value: function onQnaMetadata(payload) {
        this.processHighlightedQuestion(payload);
      }
    }, {
      key: "processHighlightedQuestion",
      value: function processHighlightedQuestion(question) {
        if (!question || !question.question) {
          this.playerApi.clientAction(null, 'qna');
          this.highlightedQuestion = null;
          this.setCaptionTextPosition();
          return;
        }
        question.question = (0, _filters.questionLinks)(this.$filter, this.$i18n, question.question);
        question = this.qnaService.resolveProfilePicture(question, this.eventIcon);
        question.showUserInitials = (0, _lodash.get)(this.settings, 'person.show_initials', true);
        var sideBarQuestion = this.findQuestionInSideBar(question.id);
        if (sideBarQuestion) {
          question.upvotes = sideBarQuestion.upvotes;
          question.upvoted = sideBarQuestion.upvoted;
        }
        this.qnaService.onQnaHighlight(question.id);
        this.playerApi.clientAction(question, 'qna');
        this.highlightedQuestion = question;
        this.setCaptionTextPosition();
      }
    }, {
      key: "findQuestionInSideBar",
      value: function findQuestionInSideBar(questionId) {
        var qnaTab = this.sideBarConfigurator ? this.sideBarConfigurator.getTabInstance('qna') : null;
        if (!qnaTab) {
          return null;
        }
        return qnaTab.getQuestion(questionId);
      }
    }, {
      key: "liveStreamId",
      get: function get() {
        return (0, _lodash.get)(this.config, 'liveStreamId');
      }
    }, {
      key: "configOverrides",
      get: function get() {
        return (0, _lodash.get)(this.config, 'configOverwrites') || (0, _lodash.get)(this.config, 'configOverrides');
      }
    }, {
      key: "hlsConfigOverrides",
      get: function get() {
        return (0, _lodash.get)(this.configOverrides, 'hls');
      }
    }, {
      key: "playerConfigOverrides",
      get: function get() {
        return (0, _lodash.get)(this.configOverrides, 'player');
      }
    }, {
      key: "documentId",
      get: function get() {
        return this.liveStreamId || (0, _lodash.get)(this.config, 'document_id') || (0, _lodash.get)(this.config, 'analytic_params.document_id');
      }
    }, {
      key: "isFinished",
      get: function get() {
        return (0, _lodash.get)(this, 'config.is_finished', false);
      }
    }, {
      key: "isVod",
      get: function get() {
        return this.liveStreamService.isVod(this.config);
      }
    }, {
      key: "streamEnded",
      get: function get() {
        return this.isFinished && !this.broadcastStarted;
      }
    }, {
      key: "isRtmps",
      get: function get() {
        return this.liveStreamService.isRtmps(this.config);
      }
    }, {
      key: "isStreamless",
      get: function get() {
        return this.isInPerson && !this.isVod;
      }
    }, {
      key: "player",
      get: function get() {
        return (0, _lodash.get)(this.$element.find('spotme-video-player'), '0');
      }
    }, {
      key: "playerApi",
      get: function get() {
        var player = this.player;
        return (0, _lodash.get)(player, 'getApi', function () {
          return undefined;
        })();
      }
    }, {
      key: "showViewers",
      get: function get() {
        var viewers_enabled = (0, _lodash.get)(this.config, 'viewers_enabled', false);
        return viewers_enabled && !this.streamEnded;
      }
    }, {
      key: "showStreamTab",
      get: function get() {
        return this.isToggleStreamTabEnabled && !this.isVod;
      }
    }, {
      key: "isPrivateQna",
      get: function get() {
        return (0, _lodash.get)(this.config, 'qna_private_enabled', false);
      }
    }, {
      key: "hiveConfig",
      get: function get() {
        var hiveConfig = (0, _lodash.get)(this.config, 'hiveConfig') || {};
        var jwt = hiveConfig.jwt;
        if (!jwt) {
          return {};
        }
        return hiveConfig;
      }
    }, {
      key: "playerConfig",
      get: function get() {
        var hasSidebar = (this.sideBarConfigurator.hasTabs || this.isThirdParty) && !this.videoInPipMode;
        this.$scope.$emit('hasSideBar', hasSidebar);
        var components = this.playerComponents();
        return {
          components: components,
          thumbnail: (0, _lodash.get)(this, 'media.thumbnail'),
          isIframeContent: this.isIframeContent,
          hideControlBar: this.videoInPipMode,
          disableNativePip: true,
          labels: this.playerLabels,
          sideBar: hasSidebar ? this.sideBarConfigurator.config : undefined,
          noPlayer: this.isStreamless,
          isSideBarBelow: this.isSmallScreen,
          isWebinar: this.EVENT.is_webinar,
          hiveConfig: this.hiveConfig,
          darkMode: {
            enabled: this.theme.get('appearance') === 'dark',
            'background-color': this.theme.backgroundColor3,
            color: this.theme.foregroundColor1,
            'border-color': this.theme.backgroundColor2
          }
        };
      }
    }, {
      key: "playerComponents",
      value: function playerComponents() {
        var fullscreen = this.isSmallScreen ? 'fullscreen' : 'client-fullscreen';
        if (this.isStreamless) {
          return [];
        }
        if (!this.liveStreamId && this.isIframeContent) {
          return [];
        }
        var components;
        if (!this.liveStreamId) {
          components = [this.getBigPlayButtonWidget(), 'shortcuts', 'play-pause-toggle', 'volume', 'seek-bar', 'time', this.subtitlesWidget, this.languageControl, 'fullscreen'];
        } else if (this.isIframeContent && this.playerHidden) {
          components = [this.blackOverlayWidget, this.countdownWidget];
        } else if (this.isIframeContent) {
          components = [this.clapsWidget, this.qnaWidget, this.pollWidget, this.countdownWidget];
        } else if (this.isVod) {
          components = [this.slidesBackgroundImageWidget, this.getBigPlayButtonWidget(), 'big-unmute-button', 'shortcuts', 'play-pause-toggle', 'volume', 'seek-bar', 'time', this.viewersCount, this.languageControl, this.interprefyControl, this.helpControl, 'resolution', fullscreen, this.subtitlesWidget, this.clapsWidget, this.qnaWidget, this.pollWidget, this.slidesWidget];
        } else if (this.playerHidden) {
          components = [this.viewersCount, fullscreen, this.blackOverlayWidget, this.countdownWidget, this.userInteractorWidget];
        } else {
          components = [this.slidesBackgroundImageWidget, this.getBigPlayButtonWidget(true), 'big-unmute-button', 'shortcuts', this.playStopToggle, 'volume', 'live-badge', this.viewersCount, this.subtitlesWidget, this.languageControl, this.interprefyControl, this.helpControl, fullscreen, this.clapsWidget, this.pollWidget, this.qnaWidget, this.slidesWidget, this.countdownWidget];
        }
        if (this.shouldShowCrashMessage) {
          components.push(this.playerCrashWidget);
        }
        if (this.addResolutionControl) {
          components.push('resolution');
        }
        components = this.filterOutImproperComponents(components);
        components = this.applyConfigOverrides(components);
        return components;
      }
    }, {
      key: "filterOutImproperComponents",
      value: function filterOutImproperComponents(components) {
        var _this8 = this;
        var hasClaps = (0, _lodash.get)(this, 'config.clapping_enabled', false);
        var hasQna = (0, _lodash.get)(this, 'config.qna');
        var hasInterprefy = !!(0, _lodash.get)(this, 'config.interprefy_project_id');
        if (!hasClaps) {
          components = components.filter(function (comp) {
            return !(0, _lodash.isEqual)(comp, _this8.clapsWidget);
          });
        }
        if (!hasQna) {
          components = components.filter(function (comp) {
            return !(0, _lodash.isEqual)(comp, _this8.qnaWidget);
          });
        }
        if (!this.showViewers) {
          components = components.filter(function (comp) {
            return !(0, _lodash.isEqual)(comp, _this8.viewersCount);
          });
        }
        if (!hasInterprefy) {
          components = components.filter(function (comp) {
            return !(0, _lodash.isEqual)(comp, _this8.interprefyControl);
          });
        }
        if (!this.isRtmps) {
          components = components.filter(function (comp) {
            return comp && comp.id !== 'slides' && !(0, _lodash.isEqual)(comp, _this8.slidesBackgroundImageWidget);
          });
        } else if (!this.backgroundImageUrl) {
          components = components.filter(function (comp) {
            return !(0, _lodash.isEqual)(comp, _this8.slidesBackgroundImageWidget);
          });
        }
        if (this.EVENT.is_webinar) {
          components = components.filter(function (comp) {
            return comp !== 'fullscreen' && comp !== 'client-fullscreen';
          });
        }
        if (this.countdownState === COUNTDOWN_STATES.STREAM_ENDED) {
          components = components.filter(function (comp) {
            return !(0, _lodash.isEqual)(comp, _this8.userInteractorWidget);
          });
        }
        if (this.videoInPipMode) {
          components = components.filter(function (comp) {
            return comp !== 'big-unmute-button' && !(0, _lodash.isEqual)(comp, _this8.getBigPlayButtonWidget()) && !(0, _lodash.isEqual)(comp, _this8.getBigPlayButtonWidget(true)) && !(0, _lodash.isEqual)(comp, _this8.userInteractorWidget) && comp !== 'seek-bar';
          });
        }
        if (this.isThirdParty) {
          components = components.map(function (comp) {
            return (0, _lodash.isEqual)(comp, _this8.playStopToggle) ? 'play-pause-toggle' : comp;
          });
          components = components.map(function (comp) {
            return (0, _lodash.isEqual)(comp, _this8.getBigPlayButtonWidget(true)) ? _this8.getBigPlayButtonWidget(false) : comp;
          });
        }
        return components;
      }
    }, {
      key: "applyConfigOverrides",
      value: function applyConfigOverrides(components) {
        var _this9 = this;
        if ((0, _lodash.isEmpty)(this.playerConfigOverrides)) {
          return components;
        }
        if ((0, _lodash.isArray)(this.playerConfigOverrides.filter)) {
          components = components.filter(function (comp) {
            return !_this9.playerConfigOverrides.filter.includes(comp) && !((0, _lodash.isObject)(comp) && _this9.playerConfigOverrides.filter.includes(comp.id));
          });
        }
        if ((0, _lodash.isArray)(this.playerConfigOverrides.components)) {
          components = components.concat(this.playerConfigOverrides.components);
        }
        return components;
      }
    }, {
      key: "getBigPlayButtonWidget",
      value: function getBigPlayButtonWidget() {
        var seekToLiveOnPlay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        if (seekToLiveOnPlay && this.isSmallScreen) {
          return;
        }
        return {
          id: 'big-play-button',
          config: {
            seekToLiveOnPlay: seekToLiveOnPlay
          }
        };
      }
    }, {
      key: "playStopToggle",
      get: function get() {
        return {
          id: 'play-stop-toggle',
          config: {
            seekToLiveOnPlay: true
          }
        };
      }
    }, {
      key: "viewersCount",
      get: function get() {
        return {
          id: 'viewers-count',
          config: {
            count: (0, _lodash.get)(this, 'sideBarConfigurator.viewersCount', 0)
          }
        };
      }
    }, {
      key: "interprefyControl",
      get: function get() {
        return {
          id: 'interprefy',
          config: {
            iframeUrl: getInterprefyUrl((0, _lodash.get)(this, 'config.interprefy_project_id'))
          }
        };
      }
    }, {
      key: "helpControl",
      get: function get() {
        var _this10 = this;
        return {
          id: 'help',
          config: {
            onClick: function onClick() {
              var supportUrl = new URL("https://spotme.typeform.com/to/e32pvfxl");
              supportUrl.searchParams.append('eid', _this10.EID);
              supportUrl.searchParams.append('pid', _this10.ACTIVATED_PERSON.fp_ext_id);
              supportUrl.searchParams.append('livestream_id', _this10.liveStreamId);
              supportUrl.searchParams.append('url', encodeURIComponent(window.location.href));
              window.open(supportUrl, '_blank');
            }
          }
        };
      }
    }, {
      key: "languageControl",
      get: function get() {
        var live_captions_labels = (0, _lodash.get)(this, 'config.live_captions_labels', {});
        return {
          id: 'language',
          config: (0, _lodash.isEmpty)(live_captions_labels) ? {} : {
            subtitleTrackNames: live_captions_labels,
            visibleSubtitleTrackLabels: (0, _lodash.filter)(Object.keys(live_captions_labels))
          }
        };
      }
    }, {
      key: "subtitlesWidget",
      get: function get() {
        return {
          id: 'subtitles',
          config: {
            position: this.captionTextPosition
          }
        };
      }
    }, {
      key: "clapsWidget",
      get: function get() {
        return {
          id: 'claps',
          config: {
            useMetadata: this.isVod
          },
          hidden: this.videoInPipMode
        };
      }
    }, {
      key: "qnaWidget",
      get: function get() {
        return {
          id: 'qna',
          config: {
            useMetadata: this.useMetadata,
            upvotingEnabled: this.config.qna_upvoting_enabled || false,
            upvotingAllowed: this.liveStreamService.isUpvotingAllowed(this.config)
          },
          hidden: this.videoInPipMode || this.isSmallScreen && !this.isPlayerFullscreen
        };
      }
    }, {
      key: "userInteractorWidget",
      get: function get() {
        return {
          id: 'user-interactor',
          config: {
            destroyOnAutoPlay: !this.playerHidden
          }
        };
      }
    }, {
      key: "pollWidget",
      get: function get() {
        return {
          id: 'polls',
          config: {
            showResultsOnly: this.isVod
          },
          hidden: true
        };
      }
    }, {
      key: "slidesWidget",
      get: function get() {
        var _this11 = this;
        return {
          id: 'slides',
          config: {
            getSlideImageUrl: function () {
              var _getSlideImageUrl = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee9(slideshowDocId, slideIndex) {
                return _regenerator.default.wrap(function _callee9$(_context9) {
                  while (1) switch (_context9.prev = _context9.next) {
                    case 0:
                      _context9.next = 2;
                      return _this11.liveStreamService.getSlideImageUrl(slideshowDocId, slideIndex);
                    case 2:
                      return _context9.abrupt("return", _context9.sent);
                    case 3:
                    case "end":
                      return _context9.stop();
                  }
                }, _callee9);
              }));
              function getSlideImageUrl(_x3, _x4) {
                return _getSlideImageUrl.apply(this, arguments);
              }
              return getSlideImageUrl;
            }(),
            splitPane: true,
            useMetadata: true
          }
        };
      }
    }, {
      key: "countdownWidget",
      get: function get() {
        return {
          id: 'countdown',
          config: {
            startTime: (0, _lodash.get)(this, 'config.start_time'),
            streamEnded: this.streamEnded,
            streamIsLive: this.broadcastStarted
          }
        };
      }
    }, {
      key: "blackOverlayWidget",
      get: function get() {
        return {
          id: 'overlay',
          config: {
            color: 'black'
          }
        };
      }
    }, {
      key: "backgroundImageUrl",
      get: function get() {
        return (0, _lodash.get)(this, 'config.backgroundImageUrl');
      }
    }, {
      key: "slidesBackgroundImageWidget",
      get: function get() {
        return {
          id: 'overlay',
          config: {
            imageUrl: this.backgroundImageUrl,
            color: 'black',
            behindVideoElement: true
          }
        };
      }
    }, {
      key: "playerCrashWidget",
      get: function get() {
        var _this$playerLabels$cr = this.playerLabels['crash-overlay'],
          title = _this$playerLabels$cr.title,
          message = _this$playerLabels$cr.message,
          buttonLabel = _this$playerLabels$cr.buttonLabel;
        return {
          id: 'message-overlay',
          config: {
            onTop: true,
            title: title,
            message: message,
            link: 'https://support.spotme.com/hc/en-us/articles/360052063893-Troubleshooting-for-app-users#h_01EGATKZRMDBNA4GQ5CV09K18Y',
            button: {
              text: buttonLabel,
              action: function action() {
                return window.location.reload();
              }
            }
          }
        };
      }
    }]);
    return VideoPlayerComponent;
  }()
};
exports.VideoPlayerComponent = VideoPlayerComponent;

},{"../../../filters":235,"../../../utils/assets":350,"../../../utils/dom":355,"./i18n":136,"./side-bar/Configurator":138,"./video-player.jade":146,"@babel/runtime/helpers/asyncToGenerator":375,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/regenerator":398,"frontend-video-player/webcomponent":1106,"lodash":"lodash"}],146:[function(require,module,exports){
module.exports = '<spotme-video-player ng-show="$ctrl.configIsReady" ng-on-custom-action="$ctrl.onCustomAction($event)" ng-on-player-error="$ctrl.onPlayerError($event)" ng-on-state-change="$ctrl.onVideoPlayerStateChanged($event)" ng-on-player-analytics="$ctrl.onPlayerAnalytics($event)" ng-attr-source-url="{{ $ctrl.url }}" ng-attr-content-id="{{ $ctrl.documentId }}" ng-attr-cmcd-session-id="{{ $ctrl.cmcdSessionId }}" ng-attr-hls-config-overwrites="{{ $ctrl.hlsConfigOverrides }}" ng-attr-use-credentials="{{ $ctrl.useCredentials ? \'use-credentials\' : undefined }}" ng-attr-autoplay="{{ $ctrl.autoplay ? \'autoplay\' : undefined }}" ng-attr-loop-video="{{ $ctrl.dummyVideoIsPlaying ? $ctrl.dummyVideoIsPlaying : undefined }}" ng-attr-restrict-metadata="{{ $ctrl.isThirdParty ? \'restrictMetadata\' : undefined }}"></spotme-video-player>';
},{}],147:[function(require,module,exports){
module.exports = '<slick infinite="false" dots="false" arrows="true" rows="0" slides-to-show="1" next-arrow=".arrow.next" prev-arrow=".arrow.prev" initial-slide="{{::$ctrl.offset}}"><div class="item" ng-repeat="medium in ::$ctrl.carouselMedia"><component-loader class="medium no-click-effect" ng-click="$ctrl.toggleDetails()" component="::(medium.type + &quot;-medium&quot;)" attrs="{media: &quot;medium&quot;, class: &quot;media-type&quot;, zoomed: true, &quot;data-mid&quot;: medium.id}"></component-loader></div></slick>';
},{}],148:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ZoomModule = void 0;
var _zoom = require("./zoom.component");
var ZoomModule = angular.module('maestro.components.common.zoom', []).component('zoom', _zoom.ZoomComponent).name;
exports.ZoomModule = ZoomModule;

},{"./zoom.component":149}],149:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ZoomComponent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
var ZoomComponent = {
  bindings: {
    allMedia: '='
  },
  template: require('./zoom.jade'),
  controller: function () {
    Zoom.$inject = ["navService", "$element", "$scope", "$timeout", "$compile", "$q"];
    /* @ngInject */
    function Zoom(navService, $element, $scope, $timeout, $compile, $q) {
      (0, _classCallCheck2.default)(this, Zoom);
      this.navService = navService;
      this.element = $element;
      this.$scope = $scope;
      this.$timeout = $timeout;
      this.$compile = $compile;
      this.$q = $q;
    }
    (0, _createClass2.default)(Zoom, [{
      key: "$onInit",
      value: function $onInit() {
        var _this = this;
        this.fullscreenElement = this.element;
        this.wrapper = this.element.find('.zoom-container');
        this.content = this.wrapper.find('.content');
        this.totalMedia = 0;
        this.animationsEnabled = false;
        this.zoomed = false;
        this.SLIDES_NUM = 10;
        this.firstIndex = 0;
        this.currentIndex = this.firstIndex;
        this.lastIndex = this.SLIDES_NUM;
        this.carouselMedia = [];
        this.prevSlide = 0;
        this.preload = (0, _lodash.debounce)(function (elements, onTop) {
          _this.buildCarousel(elements, onTop);
        }, 100);
        this.$scope.$on('zoom', function (e, _ref) {
          var element = _ref.element,
            media = _ref.media;
          _this.zoom(element, media);
        });
        this.$scope.$on('closeZoom', function () {
          _this.close();
        });
        var elem = this.fullscreenElement[0];
        this.hasFullscreen = false;
        this.fullScreen = elem.requestFullScreen || elem.webkitRequestFullScreen || elem.mozRequestFullScreen || elem.msRequestFullScreen || elem.msRequestFullscreen;
        if (this.fullScreen) {
          this.hasFullscreen = true;
        }
        this.exitFullscreen = document.exitFullscreen || document.webkitExitFullscreen || document.mozCancelFullScreen || document.msExitFullscreen;
        this.inFullscreen = false;
        this.carouselTemplate = require('./carousel.jade');
        this.$scope.$on('nav:content-update', function (ev, elements, onTop) {
          _this.preload(elements, onTop);
          if (_this.zoomed) {
            _this.zoom(_this.lastElement, {
              index: _this.currentIndex
            }, true);
          }
        });
        this.$scope.$on('media:pause', function () {
          if (_this.slick) {
            _this.slick.options.swipeToSlide = false;
            _this.slick.options.swipe = false;
            _this.$scope.$apply();
          }
        });
        this.$scope.$on('media:start', function () {
          if (_this.slick) {
            _this.slick.options.swipeToSlide = true;
            _this.slick.options.swipe = true;
            _this.$scope.$apply();
          }
        });
        angular.element(document).on('fullscreenchange webkitfullscreenchange mozfullscreenchange MSFullscreenChange', function () {
          _this.inFullscreen = document.webkitIsFullScreen || document.mozFullScreen || document.msFullscreenElement;
          _this.$scope.$apply();
        });
        this.detailed = false;
      }
    }, {
      key: "$onDestroy",
      value: function $onDestroy() {
        this.close();
      }
    }, {
      key: "bindKeys",
      value: function bindKeys() {
        var _this2 = this;
        angular.element(window).on('keyup.zoom', function (e) {
          var code = window.event ? e.keyCode : e.which;
          switch (code) {
            case 27:
              _this2.close();
              break;
            case 37:
              _this2.prevMedia(e);
              break;
            case 39:
              _this2.nextMedia(e);
              break;
            default:
              break;
          }
        });
      }
    }, {
      key: "unbindKeys",
      value: function unbindKeys() {
        angular.element(window).off('keyup.zoom');
      }
    }, {
      key: "zoom",
      value: function zoom(element, media, reset) {
        var _this3 = this;
        this.currentIndex = media.index;
        this.totalMedia = this.allMedia.length;
        if (!this.zoomed || reset) {
          this.zoomed = true;
          var clone = null;
          if (this.animationsEnabled) {
            var styles = this.getElementPosition(element);
            clone = angular.copy(element);
            this.content.append(clone);
            this.wrapper.css(styles).data('originalPosition', styles);
          }
          this.wrapper.addClass('in');
          if (this.animationsEnabled) {
            this.wrapper.addClass('animating');
          }
          requestAnimationFrame(function () {
            _this3.wrapper.css({
              top: 0,
              left: 0,
              height: '100%',
              width: '100%'
            });
            _this3.buildCarousel();
            _this3.wrapper.removeClass('animating');
            _this3.$timeout(function () {
              if (_this3.slick) {
                _this3.slick.setDimensions();
              }
              clone && clone.remove();
              _this3.wrapper.addClass('completed');
            }, _this3.animationsEnabled ? 250 : 1);
          });
        }
        if (!reset) {
          this.bindKeys();
        }
      }
    }, {
      key: "getElementPosition",
      value: function getElementPosition(element) {
        var offset = element.offset();
        return {
          top: offset.top,
          left: offset.left,
          height: element.outerHeight(true),
          width: element.outerWidth(true)
        };
      }
    }, {
      key: "buildCarousel",
      value: function buildCarousel(elements) {
        var _this4 = this;
        if (!this.carousel || this.carousel && !elements) {
          this.offset = this.currentIndex < this.offset ? this.currentIndex : this.SLIDES_NUM / 2;
          this.calculateCarouselMedia();
          this.carousel = this.$compile(this.carouselTemplate)(this.$scope);
          this.carousel.on('init', function (e, slick) {
            _this4.slick = slick;
            _this4.prevSlide = _this4.offset;
          }).on('afterChange', function (event, slick, currentSlide) {
            if (_this4.animationsEnabled) {
              _this4.lastElement = angular.element('.sections .medium[data-index="' + _this4.currentIndex + '"]');
              _this4.wrapper.data('originalPosition', _this4.getElementPosition(_this4.lastElement));
            }
            if (_this4.zoomed && currentSlide !== _this4.prevSlide) {
              var l = _this4.allMedia.length;
              var k = _this4.prevSlide <= currentSlide ? 1 : -1;
              _this4.currentIndex += k;
              _this4.calculateCarouselMedia();
              var i = k > 0 ? _this4.lastIndex - 1 : _this4.firstIndex;
              if (i <= l) {
                var m = _this4.allMedia[i];
                if (m && $('.media-type[data-mid="' + m.id + '"]').length === 0) {
                  var e = _this4.buildCarouselElement(m);
                  _this4.carousel.slick('slickAdd', e, null, k < 0);
                  if (k < 0) {
                    slick.currentSlide += 1;
                    currentSlide++;
                  }
                }
              }
              if (_this4.currentIndex < 0) {
                _this4.currentIndex = 0;
              }
              if (_this4.currentIndex >= l) {
                _this4.currentIndex = _this4.allMedia.length - 1;
              }
              _this4.prevSlide = currentSlide;
            }
            _this4.$scope.$apply();
            _this4.$scope.$broadcast('media:slide-changed');
          });
          this.content.empty().append(this.carousel);
        }
      }
    }, {
      key: "buildCarouselElement",
      value: function buildCarouselElement(medium) {
        var template = document.createElement(medium.type + '-medium');
        var attrs = {
          media: 'medium',
          class: 'media-type',
          zoomed: true,
          'data-mid': medium.id
        };
        (0, _lodash.each)(attrs, function (value, key) {
          return template.setAttribute(key, value);
        });
        this.$scope.medium = medium;
        var media = $('<div class="item">').append('<div class="medium">').append(this.$compile(template)(this.$scope));
        return media;
      }
    }, {
      key: "calculateCarouselMedia",
      value: function calculateCarouselMedia() {
        this.firstIndex = this.currentIndex - this.offset;
        if (this.firstIndex < 0) {
          this.firstIndex = 0;
        }
        this.lastIndex = this.firstIndex + this.SLIDES_NUM;
        this.carouselMedia = this.allMedia.slice(this.firstIndex, this.lastIndex);
      }
    }, {
      key: "toggleFullscreen",
      value: function toggleFullscreen() {
        if (this.inFullscreen) {
          this.exitFS();
        } else {
          this.enterFS();
        }
      }
    }, {
      key: "enterFS",
      value: function enterFS() {
        if (this.hasFullscreen) {
          this.fullScreen.call(this.fullscreenElement[0]);
          this.$scope.$broadcast('media:fullscreen:enter', this.currentIndex);
        }
      }
    }, {
      key: "exitFS",
      value: function exitFS() {
        this.exitFullscreen && this.exitFullscreen.call(document);
        this.$scope.$broadcast('media:fullscreen:exit', this.currentIndex);
      }
    }, {
      key: "close",
      value: function close() {
        var _this5 = this;
        this.unbindKeys();
        this.exitFS();
        this.inFullscreen = false;
        if (this.wrapper.hasClass('animating')) {
          return;
        }
        this.wrapper.addClass('closing').removeClass('completed');
        var clone;
        if (this.animationsEnabled) {
          clone = angular.copy(angular.element('.slick-current .medium'));
          this.content.prepend(clone);
          var styles = this.wrapper.data('originalPosition');
          if (styles) {
            this.wrapper.css(styles);
          }
        }
        this.$timeout(function () {
          _this5.wrapper.removeClass('in closing');
          _this5.zoomed = false;
          clone && clone.remove();
        }, this.animationsEnabled ? 200 : 1);
        this.detailed = false;
        this.offset = this.SLIDES_NUM / 2;
        this.$scope.$broadcast('media:close');
      }
    }, {
      key: "toggleDetails",
      value: function toggleDetails() {
        this.detailed = !this.detailed;
      }
    }, {
      key: "nextMedia",
      value: function nextMedia() {
        if (this.slick) {
          this.slick.next();
        }
      }
    }, {
      key: "prevMedia",
      value: function prevMedia() {
        if (this.slick) {
          this.slick.prev();
        }
      }
    }]);
    return Zoom;
  }()
};
exports.ZoomComponent = ZoomComponent;

},{"./carousel.jade":147,"./zoom.jade":150,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"lodash":"lodash"}],150:[function(require,module,exports){
module.exports = '<div class="zoom-container no-click-effect" ng-class="{\'fullscreen\': $ctrl.inFullscreen, \'animated\': $ctrl.animationsEnabled, \'detailed\': $ctrl.detailed}"><header>{{$ctrl.currentIndex + 1}}/{{$ctrl.totalMedia}}<span class="action close" aria-label="{{\'generic.close\' | i18n}}" ng-click="$ctrl.close()">&times;</span><span class="action fullscreen" ng-if="::$ctrl.hasFullscreen" ng-click="$ctrl.toggleFullscreen()"><i></i></span></header><div class="inner"><div class="content"></div><nav class="arrows"><button class="arrow prev"></button><button class="arrow next"></button></nav></div></div><div class="zoom-backdrop" ng-class="{\'in\': $ctrl.zoomed, \'animated\': $ctrl.animationsEnabled}"></div>';
},{}],151:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ComponentsModule = void 0;
var _appChrome = require("./app-chrome");
var _avatar = require("./common/avatar");
var _pip = require("./common/pip");
var _videoPlayer = require("./common/video-player");
var _cookiesNotification = require("./common/cookies-notification");
var _offlineNotification = require("./common/offline-notification");
var _updateBrowser = require("./common/update-browser");
var _testWatermark = require("./common/test-watermark");
var _inAppNotification = require("./common/in-app-notification");
var _suggestions = require("./common/suggestions");
var _filtering = require("./common/filtering");
var _image = require("./common/image");
var _zoom = require("./common/zoom");
var _videoCall = require("./common/video-call");
var _navHeader = require("./navs/common/nav-header");
var _footerButtons = require("./navs/common/footer-buttons");
var _agenda = require("./navs/agenda");
var _appscriptLauncher = require("./navs/appscript-launcher");
var _blocks = require("./navs/blocks");
var _blocksList = require("./navs/blocks-list");
var _list = require("./navs/list");
var _document = require("./navs/document");
var _note = require("./navs/note");
var _conversation = require("./navs/conversation");
var _scan = require("./navs/scan");
var _spotman = require("./navs/spotman");
var _newMeeting = require("./navs/new-meeting");
var _newMessage = require("./navs/new-message");
var _actionBtn = require("./blocks/common/action-btn");
var _cards = require("./blocks/cards");
var _postAttachments = require("./blocks/feed/post-attachments");
var _topic = require("./blocks/feed/topic");
var _comment = require("./blocks/feed/comment");
var _newPost = require("./blocks/feed/new-post");
var _reply = require("./blocks/feed/reply");
var _editText = require("./blocks/common/edit-text");
var _emptyState = require("./blocks/common/empty-state");
var _select = require("./blocks/common/select");
var _toggle = require("./blocks/common/toggle");
var _upload = require("./blocks/common/upload");
var _listHeader = require("./blocks/common/list-header");
var _listBanner = require("./blocks/common/list-banner");
var _inlineBlockPaginator = require("./blocks/common/inline-block-paginator");
var _meeting = require("./blocks/meeting");
var _universalSearch = require("./rows/universal-search");
var _profile = require("./rows/profile");
var ComponentsModule = angular.module('maestro.components', [_appChrome.AppChromeModule, _avatar.AvatarModule, _pip.PipModule, _videoPlayer.VideoPlayerModule, _cookiesNotification.CookiesNotificationModule, _offlineNotification.OfflineNotificationModule, _updateBrowser.UpdateBrowserModule, _testWatermark.TestWatermarkModule, _inAppNotification.InAppNotificationModule, _suggestions.SuggestionsModule, _filtering.FilteringModule, _image.ImageMediumModule, _zoom.ZoomModule, _videoCall.VideoCallModule, _navHeader.NavHeaderModule, _footerButtons.FooterButtonsModule, _agenda.AgendaNavModule, _appscriptLauncher.AppScriptLauncherNavModule, _blocks.BlocksNavModule, _blocksList.BlocksListNavModule, _list.ListNavModule, _document.DocumentNavModule, _note.NoteNavModule, _conversation.ConversationNavModule, _scan.ScanNavModule, _spotman.SpotmanNavModule, _newMeeting.NewMeetingNavModule, _newMessage.NewMessageNavModule, _actionBtn.ActionBtnBlockModule, _cards.CardModule, _emptyState.EmptyStateModule, _postAttachments.FeedPostAttachmentsModule, _topic.FeedTopicBlockModule, _comment.FeedCommentBlockModule, _newPost.FeedNewPostBlockModule, _reply.FeedReplyBlockModule, _editText.EditTextBlockModule, _select.SelectBlockModule, _toggle.ToggleBlockModule, _upload.UploadBlockModule, _listHeader.ListHeaderModule, _listBanner.ListBannerModule, _inlineBlockPaginator.InlineBlockPaginatorModule, _meeting.MeetingBlockModule, _universalSearch.UniversalSearchRowModule, _profile.ProfileRowModule]).name;
exports.ComponentsModule = ComponentsModule;

},{"./app-chrome":10,"./blocks/cards":29,"./blocks/common/action-btn":32,"./blocks/common/edit-text":35,"./blocks/common/empty-state":38,"./blocks/common/inline-block-paginator":39,"./blocks/common/list-banner":42,"./blocks/common/list-header":45,"./blocks/common/select":48,"./blocks/common/toggle":51,"./blocks/common/upload":54,"./blocks/feed/comment":60,"./blocks/feed/new-post":65,"./blocks/feed/post-attachments":68,"./blocks/feed/reply":71,"./blocks/feed/topic":74,"./blocks/meeting":75,"./common/avatar":80,"./common/cookies-notification":83,"./common/filtering":86,"./common/image":89,"./common/in-app-notification":92,"./common/offline-notification":93,"./common/pip":96,"./common/suggestions":101,"./common/test-watermark":104,"./common/update-browser":107,"./common/video-call":116,"./common/video-player":137,"./common/zoom":148,"./navs/agenda":156,"./navs/appscript-launcher":166,"./navs/blocks":172,"./navs/blocks-list":169,"./navs/common/footer-buttons":175,"./navs/common/nav-header":176,"./navs/conversation":186,"./navs/document":189,"./navs/list":190,"./navs/new-meeting":193,"./navs/new-message":196,"./navs/note":199,"./navs/scan":202,"./navs/spotman":205,"./rows/profile":208,"./rows/universal-search":211}],152:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AgendaNavComponent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _lodash = require("lodash");
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _filtering = require("../../common/filtering");
var _agendaSessions = require("../../../utils/agenda-sessions");
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = (0, _getPrototypeOf2.default)(t); if (r) { var s = (0, _getPrototypeOf2.default)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0, _possibleConstructorReturn2.default)(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var AgendaNavComponent = {
  bindings: {
    config: '<'
  },
  template: require('./agenda-nav.jade'),
  controller: function (_FilteringController) {
    AgendaNavComponent.$inject = ["THEME", "EVENT", "SETTINGS", "$element", "$q", "$http", "$i18n", "$popover", "$scope", "dataSourceEvaluatorService", "navService", "progressBarService", "localCacheFactory", "metricsService"];
    (0, _inherits2.default)(AgendaNavComponent, _FilteringController);
    var _super = _createSuper(AgendaNavComponent);
    /* @ngInject */
    function AgendaNavComponent(THEME, EVENT, SETTINGS, $element, $q, $http, $i18n, $popover, $scope, dataSourceEvaluatorService, navService, progressBarService, localCacheFactory, metricsService) {
      var _this;
      (0, _classCallCheck2.default)(this, AgendaNavComponent);
      _this = _super.call(this, THEME, EVENT._id, $q, $popover, $i18n, $http, dataSourceEvaluatorService);
      _this.event = EVENT;
      _this.settings = SETTINGS;
      _this.$q = $q;
      _this.ds = dataSourceEvaluatorService;
      _this.navService = navService;
      _this.progressBarService = progressBarService;
      _this.$i18n = $i18n;
      _this.$popover = $popover;
      _this.$element = $element;
      _this.lastSelectedDayCache = localCacheFactory('agenda/lastSelectedDay');
      _this.filtersCache = localCacheFactory('agenda/selectedFilters');
      _this.searchQuery = '';
      _this.selectedFilters = [];
      _this.pages = {};
      _this.notificationSubscriptions = [];
      _this.performActions = function (actions) {
        return navService.performActions(actions, _this.config.nuid);
      };
      _this.lastRowIsBelowFold = function () {
        var lastRow = $element.find('component-loader:last')[0];
        if (!lastRow) return true;
        var container = $element.find('.agenda-nav-list-items')[0];
        console.log('[AgendaNavComponent] lastRowIsBelowFold', lastRow.offsetTop, container.clientHeight, lastRow.offsetTop > container.clientHeight);
        return lastRow.offsetTop > container.clientHeight;
      };
      _this.metricsService = metricsService;
      $scope.$on('bottom-reached', function () {
        return _this.nextPage();
      });
      return _this;
    }
    (0, _createClass2.default)(AgendaNavComponent, [{
      key: "$onInit",
      value: function $onInit() {
        var _this2 = this;
        console.log('[AgendaNavComponent] init', this.config);
        var lastSelectedDay = this.lastSelectedDayCache.get('day');
        this.progressBarService.startTask();
        this.ds.eval(this.config.agenda_days_ds).then(function (info) {
          _this2.days = info.days;
          _this2.selectedDay = typeof lastSelectedDay === 'number' && info.days[lastSelectedDay].enabled ? lastSelectedDay : info.selected_day_index;
          _this2.nextPage();
        }, function (resp) {
          return console.error('agenda days error', resp);
        }).finally(function () {
          return _this2.progressBarService.finishTask();
        });
        this.notificationSubscriptions.push(this.navService.on('rows:update', this.onRowUpdate.bind(this)));
        this.getFilters();
        var cacheFilters = this.filtersCache.get('filters') || null;
        var selectedFilters = cacheFilters && JSON.parse(cacheFilters);
        if (!(0, _lodash.isEmpty)(selectedFilters)) {
          this.selectedFilters = selectedFilters;
          this.onApplyInlineFilters(selectedFilters);
        }
      }
    }, {
      key: "$onDestroy",
      value: function $onDestroy() {
        (0, _get2.default)((0, _getPrototypeOf2.default)(AgendaNavComponent.prototype), "$onDestroy", this).call(this);
        var subs = this.notificationSubscriptions;
        if (subs && subs.length) {
          (0, _lodash.each)(subs, function (unsub) {
            return unsub();
          });
        }
      }
    }, {
      key: "onDayChange",
      value: function onDayChange(_ref) {
        var index = _ref.index;
        console.log('[AgendaNavComponent] onDayChange', this.days[index]);
        this.lastSelectedDayCache.put('day', index);
        this.selectedDay = index;
        var day = this.days[index];
        if (!day.sessions || !day.sessions.length) {
          this.nextPage();
        } else {
          this.scrollToNextSession();
        }
      }
    }, {
      key: "onPageRendered",
      value: function onPageRendered() {
        console.log('[AgendaNavComponent] onPageRendered');
        if (!this.lastRowIsBelowFold()) {
          console.log('[AgendaNavComponent] requesting more');
          this.nextPage();
        }
      }
    }, {
      key: "updatePictures",
      value: function updatePictures() {
        this.$element.find('[lazy-background-asset-src]').trigger('assets:load');
      }
    }, {
      key: "onRowUpdate",
      value: function onRowUpdate(_ref2) {
        var target = _ref2.target,
          updates = _ref2.updates;
        var day = this.days[this.selectedDay];
        var sessions = day.sessions;
        var isTargetedSession = function isTargetedSession(_ref3) {
          var id = _ref3.id;
          return id === target;
        };
        var targetedSession = (0, _lodash.find)(sessions, isTargetedSession);
        if (!targetedSession) {
          (0, _lodash.each)(this.days, function (_ref4) {
            var sessions = _ref4.sessions;
            if (targetedSession || !sessions) return;
            targetedSession = (0, _lodash.find)(sessions, isTargetedSession);
          });
        }
        if (!targetedSession) return;
        (0, _lodash.extend)(targetedSession, updates);
        console.log('[AgendaNavComponent] updated row', target, updates);
      }
    }, {
      key: "reload",
      value: function reload() {
        var _this3 = this;
        (0, _lodash.each)(this.days, function (day, index) {
          day.nextPage = null;
          delete day.loaded;
          if (index !== _this3.selectedDay) {
            day.sessions = [];
            delete day.empty;
          }
        });
        this.nextPage(true);
      }
    }, {
      key: "nextPage",
      value: function nextPage() {
        var _this4 = this;
        var reset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        if (!this.days || !this.days[this.selectedDay]) return;
        var day = this.days[this.selectedDay];
        var page = day.nextPage || day.page;
        if (!page || this.loading || day.empty && !this.selectedFilters.length || day.loaded && !reset) {
          return;
        }
        console.log('[AgendaNavComponent] nextPage', day, page);
        this.loading = true;
        var dsParams = {
          page: page,
          search: this.searchQuery.length ? this.searchQuery : undefined
        };
        if (this.selectedFilters.length) {
          dsParams.filters = this.selectedFilters;
          delete dsParams.impose;
        }
        this.ds.eval(this.config.ds, dsParams).then(function (rows) {
          day.sessions = reset ? rows : (0, _lodash.uniq)((day.sessions || []).concat(rows), function (_ref5) {
            var id = _ref5.id;
            return id;
          });
          _this4.scrollToNextSession();
          var lastRow = rows[rows.length - 1];
          if (lastRow) {
            console.log('setting next page to', lastRow.next_page);
            day.nextPage = lastRow.next_page;
            if (!day.nextPage) {
              day.loaded = true;
            }
          }
          if ((0, _lodash.isEmpty)(day.sessions)) {
            day.empty = true;
          }
        }).finally(function () {
          _this4.updatePictures();
          _this4.loading = false;
        });
      }
    }, {
      key: "scrollToNextSession",
      value: function scrollToNextSession() {
        var today = new Date();
        var now = Math.round(today.getTime() / 1000);
        var day = this.days[this.selectedDay];
        var date = new Date(day.timestamp * 1000);
        var tzSettings = (0, _lodash.get)(this.settings, 'date.timezone', 'device');
        var momentDate = tzSettings === 'device' ? (0, _momentTimezone.default)(date) : _momentTimezone.default.tz(date, this.event.timezone);
        this.isToday = momentDate.isSame(today, 'day');
        if (this.isToday) {
          this.scrollToSession = (0, _agendaSessions.selectNextSession)(day.sessions, now);
        }
      }
    }, {
      key: "toggleSearch",
      value: function toggleSearch() {
        this.showSearch = !this.showSearch;
        if (!this.showSearch) {
          this.searchQuery = '';
          this.reload();
        }
      }
    }, {
      key: "onSearchQueryChange",
      value: function onSearchQueryChange() {
        console.log('[AgendaNavComponent] onSearchQueryChange', this.searchQuery);
        this.reload();
        var payload = {
          list_id: this.config._id,
          query: this.searchQuery,
          filters: this.selectedFilters
        };
        console.debug('[AgendaNavComponent] Tracking filters agenda-search', payload);
      }
    }, {
      key: "hasNoSessions",
      value: function hasNoSessions() {
        var day = this.days && this.days[this.selectedDay];
        if (!day) return true;
        var sessions = day.sessions;
        return sessions ? sessions.length === 0 : true;
      }
    }, {
      key: "noResulsImage",
      value: function noResulsImage() {
        var type = this.isFilteringOrSearchingActive() ? 'no_results' : 'no_content';
        return this.config[type].icon;
      }
    }, {
      key: "noResultsLabel",
      value: function noResultsLabel() {
        var type = this.isFilteringOrSearchingActive() ? 'no_results' : 'no_content';
        return this.$i18n(this.config[type].label);
      }
    }, {
      key: "isFilteringOrSearchingActive",
      value: function isFilteringOrSearchingActive() {
        return this.searchQuery || this.selectedFilters.length;
      }
    }, {
      key: "restoreDayState",
      value: function restoreDayState() {
        var day = this.days[this.selectedDay];
        delete day.empty;
      }
    }, {
      key: "cancelFilteringAndSearching",
      value: function cancelFilteringAndSearching() {
        this.searchQuery = '';
        this.showSearch = false;
        this.clearFilters();
      }
    }, {
      key: "showFilters",
      value: function showFilters($event) {
        (0, _get2.default)((0, _getPrototypeOf2.default)(AgendaNavComponent.prototype), "showFilters", this).call(this, $event);
        console.debug('[AgendaNavComponent] Tracking filters agenda-filters-open');
      }
    }, {
      key: "clearFilters",
      value: function clearFilters() {
        this.restoreDayState();
        (0, _get2.default)((0, _getPrototypeOf2.default)(AgendaNavComponent.prototype), "clearFilters", this).call(this);
        this.trackFilterClear();
        this.filtersCache.remove('filters');
      }
    }, {
      key: "onApplyFilters",
      value: function onApplyFilters(filtersApplied) {
        this.onApplyInlineFilters(filtersApplied);
      }
    }, {
      key: "onApplyInlineFilters",
      value: function onApplyInlineFilters(filtersApplied) {
        console.log('[AgendaNavComponent] applying filters', filtersApplied);
        if (filtersApplied === 'cleared') {
          return this.clearFilters();
        }
        if ((0, _lodash.isEmpty)(filtersApplied)) {
          this.restoreDayState();
        }
        var filters = this.selectedFilters;
        if ((0, _lodash.isObject)(filtersApplied)) {
          filters = filtersApplied;
        }
        var payload = {
          list_id: this.config._id,
          apply: filtersApplied !== 'closed',
          filters: filters
        };
        console.debug('[AgendaNavComponent] Tracking filters agenda-filters-close', payload);
        this.selectedFilters = (0, _lodash.isArray)(filtersApplied) ? filtersApplied : [];
        this.appliedFiltersLabel = this.getAppliedFiltersLabel();
        this.filtersCache.put('filters', JSON.stringify(this.selectedFilters));
        this.reload();
      }
    }, {
      key: "trackFilterClear",
      value: function trackFilterClear() {
        console.debug('[AgendaNavComponent] Tracking filters agenda-filters-clear');
      }
    }]);
    return AgendaNavComponent;
  }(_filtering.FilteringController)
};
exports.AgendaNavComponent = AgendaNavComponent;

},{"../../../utils/agenda-sessions":349,"../../common/filtering":86,"./agenda-nav.jade":153,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/get":379,"@babel/runtime/helpers/getPrototypeOf":380,"@babel/runtime/helpers/inherits":381,"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/helpers/possibleConstructorReturn":387,"lodash":"lodash","moment-timezone":"moment-timezone"}],153:[function(require,module,exports){
module.exports = '<nav class="nav-wrapper nav-agenda2"><div class="container-fluid no-gutters" nav-id="{{::$ctrl.config._id}}"><div class="row"><nav-header parent-nav-id="::$ctrl.config.nuid" label="::$ctrl.config.title" actions="::$ctrl.config.nav_bar_actions"><button class="btn btn-default btn-transparent visible-xs-inline-block" ng-click="$ctrl.toggleSearch()"><i class="icon-magnifying-glass"></i></button><button class="btn btn-default btn-transparent visible-xs-inline-block" ng-if="::$ctrl.config.filters_ds.enabled" ng-click="$ctrl.showFilters($event)"><i class="icon-funnel"></i></button></nav-header></div><div class="row"><div class="col-sm-8 col-xs-12"><div class="nav-content"><div class="search-bar" ng-show="$ctrl.showSearch"><input type="text" ng-model="$ctrl.searchQuery" ng-model-options="{debounce: 500}" ng-change="$ctrl.onSearchQueryChange()" placeholder="Search..."/><div class="btn btn-default" ng-click="$ctrl.toggleSearch()">{{::(\'general.cancel\' | i18n)}}</div></div><agenda-calendar days="::$ctrl.days" selected-day="::$ctrl.selectedDay" on-day-change="::$ctrl.onDayChange($event)"></agenda-calendar><div class="filters-applied-info" ng-show="$ctrl.selectedFilters.length"><div class="pull-right"><div class="btn btn-transparent btn-xs" ng-click="$ctrl.clearFilters()">{{::(\'general.cancel\' | i18n)}}</div></div>{{::(\'agenda_nav.filters.filters_applied\' | i18n)}}</div><div class="no-content" ng-if="$ctrl.hasNoSessions()"><img ng-src="{{::($ctrl.noResulsImage() | assetUrl)}}"/><div>{{::($ctrl.noResultsLabel())}}</div><div class="btn btn-default" ng-show="::$ctrl.isFilteringOrSearchingActive()" ng-click="$ctrl.cancelFilteringAndSearching()">{{::($ctrl.config.no_results.action_label | i18n)}}</div></div><div class="agenda-nav-list-items lazy-asset-grid" assets-in-bg="assets-in-bg" scrolls-in-window="scrolls-in-window"><component-loader scroll-here="{{::(row.id === $ctrl.scrollToSession.id)}}" ng-repeat="row in $ctrl.days[$ctrl.selectedDay].sessions track by row.id" on-repeat-done="$ctrl.onPageRendered()" component="::(row.row_type + &quot;-row&quot;)" attrs="{row:&quot;row&quot;, &quot;on-click&quot;:&quot;$ctrl.onClick($event)&quot;}"></component-loader><div class="selected-filters visible-xs" ng-if="$ctrl.selectedFilters.length" ng-click="$ctrl.showFilters($event)"><div class="filters" theme="::$ctrl.theme" theme-selector="toolbar">{{ $ctrl.appliedFiltersLabel }}</div></div><div class="selected-filters hidden-xs" ng-if="$ctrl.selectedFilters.length"><div class="filters" theme="::$ctrl.theme" theme-selector="toolbar">{{ $ctrl.appliedFiltersLabel }}</div></div></div></div></div><div class="col-sm-4 hidden-xs nav-sidebar"><input class="search" type="text" ng-model="$ctrl.searchQuery" ng-model-options="{debounce: 500}" ng-change="$ctrl.onSearchQueryChange()" placeholder="{{::(&quot;general.search&quot; | i18n)}}"/><filtering ng-if="::($ctrl.filters &amp;&amp; $ctrl.config.filters_ds &amp;&amp; $ctrl.config.filters_ds.enabled)" filters="$ctrl.filters" selection="$ctrl.selectedFilters" on-apply-filters="$ctrl.onApplyInlineFilters(value)"></filtering></div></div></div></nav>';
},{}],154:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CalendarComponent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var CalendarComponent = {
  bindings: {
    days: '<',
    onDayChange: '&',
    preselectedIndex: '<selectedDay'
  },
  template: require('./calendar.jade'),
  controller: function () {
    CalendarComponent.$inject = ["EventEmitter", "$element", "$timeout", "$window", "$i18n"];
    /* @ngInject */
    function CalendarComponent(EventEmitter, $element, $timeout, $window, $i18n) {
      (0, _classCallCheck2.default)(this, CalendarComponent);
      this.EventEmitter = EventEmitter;
      this.$element = $element;
      this.$timeout = $timeout;
      this.$window = angular.element($window);
      this.$i18n = $i18n;
    }
    (0, _createClass2.default)(CalendarComponent, [{
      key: "$onInit",
      value: function $onInit() {
        console.log('[CalendarComponent] init');
        this.days = [{}, {}, {}, {}, {}, {}, {}];
      }
    }, {
      key: "$onChanges",
      value: function $onChanges(changes) {
        console.log('[CalendarComponent] changes', changes);
        if (changes.days && changes.days.currentValue) {
          this.days = angular.copy(this.days);
        }
        if (changes.preselectedIndex && changes.days.currentValue) {
          this.selectDayAtIndex(null, this.preselectedIndex, false);
        }
      }
    }, {
      key: "selectDayAtIndex",
      value: function selectDayAtIndex($event, index) {
        var _this = this;
        var bubble = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        console.log('[CalendarComponent] selectDayAtIndex', index);
        this.$window.trigger('assets:load');
        var day = this.days[index];
        if (!day || !day.enabled || this.selected === index) return;
        this.selected = index;
        if (bubble) {
          this.onDayChange(this.EventEmitter({
            index: index
          }));
        }
        if (!$event) {
          this.$timeout(function () {
            return _this.scrollToDay();
          });
        }
      }
    }, {
      key: "scrollToDay",
      value: function scrollToDay() {
        var selectedDay = this.$element.find('.selected');
        if (selectedDay.length !== 0) {
          this.$element[0].scrollLeft = selectedDay[0].offsetLeft;
        }
      }
    }, {
      key: "localizeNumber",
      value: function localizeNumber(n) {
        return this.$i18n.localizeNumber(n);
      }
    }]);
    return CalendarComponent;
  }()
};
exports.CalendarComponent = CalendarComponent;

},{"./calendar.jade":155,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382}],155:[function(require,module,exports){
module.exports = '<div class="item" ng-repeat="day in $ctrl.days" ng-class="{disabled: !day.enabled, selected: $ctrl.selected === $index}" ng-click="$ctrl.selectDayAtIndex($event, $index)"><div class="day" ng-bind="::day.day_of_week"></div><div class="date" ng-bind="::$ctrl.localizeNumber(day.date)"></div></div>';
},{}],156:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AgendaNavModule = void 0;
var _agendaNav = require("./agenda-nav.component");
var _calendar = require("./calendar/calendar.component");
var _rows = require("./rows");
var AgendaNavModule = angular.module('maestro.components.navs.agenda', [_rows.RowsModule]).component('agendaCalendar', _calendar.CalendarComponent).component('agendaNav', _agendaNav.AgendaNavComponent).name;
exports.AgendaNavModule = AgendaNavModule;

},{"./agenda-nav.component":152,"./calendar/calendar.component":154,"./rows":159}],157:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BannerRowComponent = void 0;
var _agendaSessions = require("../../../../../utils/agenda-sessions");
var BannerRowComponent = {
  bindings: {
    row: '<'
  },
  template: require('./banner-row.jade'),
  controller: /* @ngInject */["navService", function controller(navService) {
    var _this = this;
    this.$onInit = function () {
      _this.isLive = (0, _agendaSessions.isSessionLive)(_this.row);
    };
    this.$onChanges = function (changes) {
      if (changes.row && changes.row.currentValue) {
        _this.row = angular.copy(_this.row);
      }
    };
    this.performRowActions = function () {
      navService.performActions(_this.row.actions);
    };
  }]
};
exports.BannerRowComponent = BannerRowComponent;

},{"../../../../../utils/agenda-sessions":349,"./banner-row.jade":158}],158:[function(require,module,exports){
module.exports = '<div ng-click="$ctrl.performRowActions()"><img ng-src="{{::$ctrl.row.banner_url|assetUrl}}" on-error-src="on-error-src"/><div class="title"><div class="media"><div class="media-left"><div class="media-object"><div>{{::$ctrl.row.start}}</div><div>{{::$ctrl.row.end}}</div></div></div><div class="media-body"> <div class="live-badge" ng-if="$ctrl.isLive"><span><em></em> {{::(\'agenda_discover.live\' | i18n)}}</span></div><div>{{::$ctrl.row.title}}</div></div></div></div></div>';
},{}],159:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowsModule = void 0;
var _bannerRow = require("./banner/banner-row.component");
var _regularRow = require("./regular/regular-row.component");
var _masterRow = require("./master/master-row.component");
var RowsModule = angular.module('maestro.components.navs.agenda.rows', []).component('bannerRow', _bannerRow.BannerRowComponent).component('regularRow', _regularRow.RegularRowComponent).component('masterRow', _masterRow.MasterRowComponent).name;
exports.RowsModule = RowsModule;

},{"./banner/banner-row.component":157,"./master/master-row.component":160,"./regular/regular-row.component":162}],160:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MasterRowComponent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
var _agendaSessions = require("../../../../../utils/agenda-sessions");
var MasterRowComponent = {
  bindings: {
    row: '<'
  },
  template: require('./master-row.jade'),
  controller: function () {
    MasterRowComponent.$inject = ["dataSourceEvaluatorService", "navService", "$element"];
    /* @ngInject */
    function MasterRowComponent(dataSourceEvaluatorService, navService, $element) {
      (0, _classCallCheck2.default)(this, MasterRowComponent);
      this.ds = dataSourceEvaluatorService;
      this.navService = navService;
      this.expanded = false;
      this.trackSessions = [];
      this.notificationSubscriptions = [];
      this.$element = $element;
      this.isLive = false;
    }
    (0, _createClass2.default)(MasterRowComponent, [{
      key: "$onInit",
      value: function $onInit() {
        var _this = this;
        this.notificationSubscriptions.push(this.navService.on('rows:update', this.onTrackSessionUpdate.bind(this)));
        this.notificationSubscriptions.push(this.navService.on('agenda:reload-slot', function (data) {
          return _this.onTrackSessionUpdate(data);
        }));
        this.isLive = (0, _agendaSessions.isSessionLive)(this.row);
        this.isPast = (0, _agendaSessions.isSessionPast)(this.row);
      }
    }, {
      key: "$onChanges",
      value: function $onChanges(changes) {
        var prevRow = (changes.row || {}).previousValue;
        var currRow = (changes.row || {}).currentValue;
        if (currRow) {
          this.row = angular.copy(this.row);
          if (this.expanded !== this.row.expanded) {
            this.expand(this.row.expanded);
          } else if (!(0, _lodash.isEqual)(prevRow.in_slots_ds, currRow.in_slots_ds)) {
            this.getTrackSessions();
          }
        }
      }
    }, {
      key: "$onDestroy",
      value: function $onDestroy() {
        var subs = this.notificationSubscriptions;
        if (subs && subs.length) {
          (0, _lodash.each)(subs, function (unsub) {
            return unsub();
          });
        }
      }
    }, {
      key: "toggle",
      value: function toggle() {
        this.expand(!this.expanded);
        this.$element.trigger('ready');
      }
    }, {
      key: "expand",
      value: function expand(state) {
        if (this.expanded === state) return;
        this.expanded = state;
        if (this.expanded) {
          this.getTrackSessions();
        }
      }
    }, {
      key: "getTrackSessions",
      value: function getTrackSessions() {
        var _this2 = this;
        if (this.loading) return;
        console.log('[MasterRowComponent] getTrackSessions', this.row);
        this.loading = true;
        this.ds.eval(this.row.in_slots_ds).then(function (sessions) {
          console.log('[MasterRowComponent] getTrackSessions received', sessions);
          _this2.trackSessions = sessions;
          _this2.isLive = sessions.some(_agendaSessions.isSessionLive);
        }).finally(function () {
          _this2.loading = false;
          _this2.trackSessionsReady = true;
        });
      }
    }, {
      key: "onTrackSessionUpdate",
      value: function onTrackSessionUpdate(_ref) {
        var target = _ref.target,
          updates = _ref.updates;
        var sessions = this.trackSessions;
        var targetedSession = (0, _lodash.find)(sessions, function (_ref2) {
          var id = _ref2.id;
          return id === target;
        });
        if (!targetedSession && this.row.id === target) {
          this.trackSessions = [];
          return this.getTrackSessions();
        }
        if (!targetedSession) return;
        (0, _lodash.extend)(targetedSession, updates);
      }
    }]);
    return MasterRowComponent;
  }()
};
exports.MasterRowComponent = MasterRowComponent;

},{"../../../../../utils/agenda-sessions":349,"./master-row.jade":161,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"lodash":"lodash"}],161:[function(require,module,exports){
module.exports = '<div ng-class="{expanded: $ctrl.expanded, past: $ctrl.isPast}"><div class="nav-list-item" ng-click="$ctrl.toggle()"><div class="media"><div class="media-left"><div class="media-object"><div class="nav-list-item-subsubtitle">{{::$ctrl.row.start}}</div><div class="nav-list-item-subsubtitle">{{::$ctrl.row.end}}</div></div></div><div class="media-body"><div class="live-badge" ng-if="$ctrl.isLive"><span><em></em> {{::(\'agenda_discover.live\' | i18n)}}</span></div><div class="nav-list-item-title">{{::$ctrl.row.title}}</div><div class="nav-list-item-subtitle">{{::$ctrl.row.subtitle}}</div></div><div class="media-right"><i class="icon-triangle-left track-expander-icon" ng-show="!$ctrl.loading"></i><i class="icon-loader" ng-show="$ctrl.loading"></i></div></div></div><div class="track-sessions-wrapper"><div class="track-sessions" ng-if="$ctrl.trackSessionsReady"><component-loader ng-repeat="trackSession in $ctrl.trackSessions track by trackSession.id" component="::(trackSession.row_type+&quot;-row&quot;)" attrs="{row: &quot;trackSession&quot;}"></component-loader></div></div></div>';
},{}],162:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RegularRowComponent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _agendaSessions = require("../../../../../utils/agenda-sessions");
var RegularRowComponent = {
  bindings: {
    row: '<'
  },
  template: require('./regular-row.jade'),
  controller: function () {
    RegularRowComponent.$inject = ["navService"];
    /* @ngInject */
    function RegularRowComponent(navService) {
      (0, _classCallCheck2.default)(this, RegularRowComponent);
      this.navService = navService;
    }
    (0, _createClass2.default)(RegularRowComponent, [{
      key: "$onInit",
      value: function $onInit() {
        this.isLive = (0, _agendaSessions.isSessionLive)(this.row);
        this.isPast = (0, _agendaSessions.isSessionPast)(this.row);
      }
    }, {
      key: "performActions",
      value: function performActions() {
        this.navService.performActions(this.row.actions);
      }
    }]);
    return RegularRowComponent;
  }()
};
exports.RegularRowComponent = RegularRowComponent;

},{"../../../../../utils/agenda-sessions":349,"./regular-row.jade":163,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382}],163:[function(require,module,exports){
module.exports = '<div class="nav-list-item media" ng-click="$ctrl.performActions()" ng-class="{live: $ctrl.isLive, past: $ctrl.isPast}"><div class="media-left"><div class="media-object"><div class="nav-list-item-subsubtitle">{{::$ctrl.row.start}}</div><div class="nav-list-item-subsubtitle">{{::$ctrl.row.end}}</div></div></div><div class="media-body"><div class="live-badge" ng-if="$ctrl.isLive"><span><em></em> {{::(\'agenda_discover.live\' | i18n)}}</span></div><div class="nav-list-item-title">{{::$ctrl.row.title}}</div><div class="nav-list-item-subtitle">{{::$ctrl.row.subtitle}}</div><div class="tags"><div class="tag" ng-repeat="tag in ::$ctrl.row.tags" ng-style="::({backgroundColor: tag.background_color, color: tag.font_color})">{{::tag.label}}</div></div><div class="inline-images"><avatar ng-repeat="image in ::$ctrl.row.inline_images" object="image" mode="small"></avatar></div></div><div class="media-right"><i class="icon-check animated bounceInBig" ng-show="$ctrl.row.registered"></i></div></div>';
},{}],164:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppScriptLauncherNavComponent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var AppScriptLauncherNavComponent = {
  bindings: {
    config: '<'
  },
  template: require('./appscript-launcher-nav.jade'),
  controller: function () {
    AppScriptLauncherNavComponent.$inject = ["THEME", "databaseService", "progressBarService"];
    /* @ngInject */
    function AppScriptLauncherNavComponent(THEME, databaseService, progressBarService) {
      (0, _classCallCheck2.default)(this, AppScriptLauncherNavComponent);
      this.theme = THEME;
      this.databaseService = databaseService;
      this.progressBarService = progressBarService;
    }
    (0, _createClass2.default)(AppScriptLauncherNavComponent, [{
      key: "$onInit",
      value: function $onInit() {
        var _this = this;
        var config = this.config;
        var appscript;
        try {
          appscript = JSON.parse(atob(config.content));
        } catch (x_X) {}
        if (appscript && appscript.path) {
          this.progressBarService.startTask();
          this.databaseService.runAppScript(appscript.path, appscript.params, function () {
            return _this.progressBarService.finishTask();
          });
        }
      }
    }]);
    return AppScriptLauncherNavComponent;
  }()
};
exports.AppScriptLauncherNavComponent = AppScriptLauncherNavComponent;

},{"./appscript-launcher-nav.jade":165,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382}],165:[function(require,module,exports){
module.exports = '<nav class="nav-wrapper"><div class="nav-column nav-appscript-launcher" theme="::$ctrl.theme" nav-id="{{::$ctrl.config._id}}"></div></nav>';
},{}],166:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppScriptLauncherNavModule = void 0;
var _appscriptLauncherNav = require("./appscript-launcher-nav.component");
var AppScriptLauncherNavModule = angular.module('maestro.components.navs.appscript-launcher', []).component('appscriptLauncherNav', _appscriptLauncherNav.AppScriptLauncherNavComponent).name;
exports.AppScriptLauncherNavModule = AppScriptLauncherNavModule;

},{"./appscript-launcher-nav.component":164}],167:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlocksListNavComponent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _lodash = require("lodash");
var _filtering = require("../../common/filtering");
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = (0, _getPrototypeOf2.default)(t); if (r) { var s = (0, _getPrototypeOf2.default)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0, _possibleConstructorReturn2.default)(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var NEW_POST_BLOCK = {
  id: 'feed-new-post-block',
  block_type: 'block_feed_new_post',
  data: {
    action: {
      action_key: 'compose-post',
      target: 'actions/compose-post'
    }
  }
};
var configBlockId = 'block-list-config';
var BlocksListNavComponent = {
  template: require('./blocks-list-nav.jade'),
  bindings: {
    config: '<'
  },
  controller: function (_FilteringController) {
    BlocksListNavComponent.$inject = ["NAV_TEMPLATES", "THEME", "EID", "navService", "progressBarService", "paginatorFactory", "databaseService", "$i18n", "$popover", "dataSourceEvaluatorService", "$q", "$scope", "$element", "$interval", "$window", "$http"];
    (0, _inherits2.default)(BlocksListNavComponent, _FilteringController);
    var _super = _createSuper(BlocksListNavComponent);
    /* @ngInject */function BlocksListNavComponent(NAV_TEMPLATES, THEME, EID, navService, progressBarService, paginatorFactory, databaseService, $i18n, $popover, dataSourceEvaluatorService, $q, $scope, $element, $interval, $window, $http) {
      var _this;
      (0, _classCallCheck2.default)(this, BlocksListNavComponent);
      _this = _super.call(this, THEME, EID, $q, $popover, $i18n, $http, dataSourceEvaluatorService);
      _this.navTemplates = NAV_TEMPLATES;
      _this.theme = THEME;
      _this.$window = $window;
      _this.getPaginator = function () {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          limit = _ref.limit;
        return paginatorFactory({
          getNextStartKey: function getNextStartKey(_ref2) {
            var next_page = _ref2.next_page;
            return next_page;
          },
          buildQueryParams: function buildQueryParams(nextPage) {
            return nextPage ? {
              page: (0, _lodash.extend)(nextPage, {
                limit: limit
              })
            } : {
              page: {
                limit: limit
              }
            };
          }
        });
      };
      _this.paginator = _this.getPaginator();
      _this.databaseService = databaseService;
      _this.progressBarService = progressBarService;
      _this.navService = navService;
      _this.$i18n = $i18n;
      _this.$popover = $popover;
      _this.dse = dataSourceEvaluatorService;
      _this.$q = $q;
      _this.selectedFilters = [];
      _this.$scope = $scope;
      _this.element = $element;
      _this.hasNewContentButton = false;
      _this.showNewContentButton = false;
      _this.loading = false;
      _this.loadingNextPageFromBottom = false;
      _this.$interval = $interval;
      _this.EMPTY_STATES_BLOCKS = ['no-comments', 'no-matches'];
      return _this;
    }
    (0, _createClass2.default)(BlocksListNavComponent, [{
      key: "$onInit",
      value: function $onInit() {
        var _this2 = this;
        console.log('[BlocksListNavComponent] init', this.config);
        this.loading = true;
        var config = this.config;
        if (this.config.theme) {
          this.theme = (0, _lodash.extend)(this.theme, this.config.theme);
        }
        if (this.config.list_padding) {
          this.theme.view = this.theme.view || {};
          this.theme.view.paddings = this.config.list_padding;
        }
        var navService = this.navService;
        this.searchable = config.searchable;
        this.blocks = [];
        var reloadOn = (0, _lodash.get)(this.config, 'ds.reload_on');
        if (reloadOn) {
          this.unsubFromNotifications = navService.subscribeToEvents(navService.flattenNotificationMap(reloadOn), function (event, data) {
            switch (event.name) {
              case 'blocks:filter':
                _this2.filter(data);
                break;
              case 'blocks:insert':
                _this2.insert(data);
                break;
              case 'blocks:remove':
                _this2.remove(data);
                break;
              case 'blocks:update':
                data.blocks.forEach(function (b) {
                  _this2.updateBlock({
                    id: b.id,
                    updates: b
                  });
                });
                break;
              case 'set-loading':
                if (data.value) {
                  _this2.progressBarService.startTask();
                } else {
                  _this2.progressBarService.finishTask();
                }
                break;
              case 'reload-with':
                _this2.reloadWithParams(data);
                break;
              default:
                _this2.reload(true);
                break;
            }
          });
          var fpTypes = reloadOn.fp_type || reloadOn.fp_types || [];
          if (fpTypes.some(function (t) {
            return t.match(/^feed/);
          })) {
            console.info('[BlocksListNavComponent] setting reload interval');
            this.reloadInterval = this.$interval(function () {
              return _this2.checkForNewBlocks();
            }, 60 * 1000);
            this.hasNewContentButton = true;
          }
        }
        this.blockStyles = {};
        if (this.config.list_divider) {
          var d = this.config.list_divider;
          this.blockStyles = {
            'border-bottom': "".concat(d.size, "px solid ").concat(d.color)
          };
        }
        if (this.searchQuery) {
          this.performSearch();
        } else {
          this.reload(false).finally(function () {
            _this2.loading = false;
          });
        }
        this.navBarActions = this.config.nav_bar_actions || [];
        this.processNavBarActions();
        this.$scope.$on('bottom-reached', function () {
          if (_this2.loadingNextPageFromBottom) {
            return;
          }
          _this2.loadingNextPageFromBottom = true;
          _this2.nextPage().finally(function () {
            _this2.loadingNextPageFromBottom = false;
          });
        });
      }
    }, {
      key: "$onDestroy",
      value: function $onDestroy() {
        (0, _get2.default)((0, _getPrototypeOf2.default)(BlocksListNavComponent.prototype), "$onDestroy", this).call(this);
        if ((0, _lodash.isFunction)(this.unsubFromNotifications)) {
          this.unsubFromNotifications();
        }
        if (this.reloadInterval) {
          this.$interval.cancel(this.reloadInterval);
        }
      }
    }, {
      key: "$onChanges",
      value: function $onChanges(changes) {
        if ('searchQuery' in changes && !changes.searchQuery.isFirstChange()) {
          this.performSearch();
        }
      }
    }, {
      key: "reload",
      value: function reload(clearSearch) {
        console.info('[BlocksListNavComponent] reloading...');
        if (clearSearch) {
          this.clearSearch();
        }
        this.paginator.reset();
        return this.nextPage({
          reset: true
        });
      }
    }, {
      key: "reloadWithParams",
      value: function reloadWithParams(_ref3) {
        var target = _ref3.target,
          params = _ref3.params;
        console.info("[BlocksListNavComponent] reloading nav \"".concat(target, "\" with params..."), params);
        this.navService.presentNav({
          _id: this.config._id,
          ds: {
            source: {
              params: {
                reload_with_params: params
              }
            }
          }
        });
      }
    }, {
      key: "showNewContent",
      value: function showNewContent() {
        this.showNewContentButton = false;
        window.scrollTo(0, 0);
        this.reload(false);
      }
    }, {
      key: "nextPage",
      value: function nextPage() {
        var _this3 = this;
        var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            reset: false
          },
          reset = _ref4.reset;
        if (this.config.results) {
          console.info('[BlocksListNavComponent] Injecting config elements');
          this.blocks = this.config.results;
          return Promise.resolve();
        }
        console.info('[BlocksListNavComponent] loading next page...');
        if (!this.paginator.hasMorePages()) {
          this.progressBarService.finishTask();
          return Promise.resolve();
        }
        if (reset) {
          var params = (0, _lodash.get)(this, 'config.ds.source.params', {});
          if (!params.page) {
            params.page = {
              first: true
            };
          }
          delete params.search;
        }
        this.progressBarService.startTask();
        return this.navService.inflatePaginatedNav(this.config, {
          cache: false,
          filters: this.selectedFilters.length ? this.selectedFilters : undefined
        }, this.paginator).then(function (_ref5) {
          var paginatedElements = _ref5.paginatedElements;
          return reset ? [].concat(paginatedElements) : _this3.blocks.concat(paginatedElements);
        }).then(function (blocks) {
          return _this3.blocks = (0, _lodash.uniq)(blocks, function (_ref6) {
            var id = _ref6.id;
            return id;
          });
        }).then(this.processConfigBlocks.bind(this)).finally(function () {
          if ((0, _lodash.get)(_this3, 'config.ds.source.params.page')) {
            delete _this3.config.ds.source.params.page;
          }
          _this3.progressBarService.finishTask();
          _this3.element.find('.lazy-asset-grid').trigger('ready');
        });
      }
    }, {
      key: "processConfigBlocks",
      value: function processConfigBlocks() {
        var configBlock = this.blocks.find(function (block) {
          return block.id === configBlockId;
        });
        this.blocks = this.blocks.filter(function (block) {
          return block.id !== configBlockId;
        });
        if (configBlock) {
          (0, _lodash.merge)(this.config, configBlock.data);
          this.navBarActions = this.config.nav_bar_actions;
        }
        this.processNavBarActions();
      }
    }, {
      key: "processNavBarActions",
      value: function processNavBarActions() {
        var _this4 = this;
        this.config.nav_bar_actions = (0, _lodash.filter)(this.navBarActions, function (action) {
          if (action.action_key === 'compose-post') {
            NEW_POST_BLOCK.data.action.params = action.params;
            if ((_this4.blocks[0] || {}).id !== NEW_POST_BLOCK.id) {
              _this4.blocks.unshift(NEW_POST_BLOCK);
            }
            return false;
          }
          return true;
        });
      }
    }, {
      key: "checkForNewBlocks",
      value: function checkForNewBlocks() {
        var _this5 = this;
        var lastElementPagination = this.getPaginator({
          limit: 5
        });
        this.navService.inflatePaginatedNav(this.config, {
          cache: false,
          filters: this.selectedFilters.length ? this.selectedFilters : undefined
        }, lastElementPagination).then(function (_ref7) {
          var paginatedElements = _ref7.paginatedElements;
          var existingIds = _this5.blocks.map(function (block) {
            return block.id;
          });
          if (!paginatedElements || paginatedElements.every(function (block) {
            if (block.id === configBlockId) return true;
            return existingIds.includes(block.id);
          })) {
            return;
          }
          if (_this5.element.closest('main.scrolled').length === 0) {
            _this5.showNewContentButton = false;
            _this5.reload(false);
          } else {
            _this5.showNewContentButton = true;
          }
        });
      }
    }, {
      key: "templateUrlForBlock",
      value: function templateUrlForBlock(_ref8) {
        var block_type = _ref8.block_type;
        return this.navTemplates[block_type];
      }
    }, {
      key: "classNamesForBlock",
      value: function classNamesForBlock(_ref9) {
        var type = _ref9.block_type,
          _ref9$layout = _ref9.layout,
          layout = _ref9$layout === void 0 ? {} : _ref9$layout;
        return [type, "block-width-".concat(layout.width), "block-height-".concat(layout.height), 'animated'].join(' ');
      }
    }, {
      key: "updateBlock",
      value: function updateBlock(_ref10) {
        var id = _ref10.id,
          updates = _ref10.updates;
        if (!id || !updates) return;
        var blockIndex = (0, _lodash.findIndex)(this.blocks, function (_ref11) {
          var _id = _ref11.id;
          return id === _id;
        });
        if (blockIndex === -1) return;
        console.log('[BlocksListNavComponent] updateBlock', id, updates);
        if (updates.content && updates.content.inline_blocks) {
          var block = (0, _lodash.clone)(this.blocks[blockIndex]);
          block.data.content.inline_blocks = updates.content.inline_blocks;
          this.blocks[blockIndex] = block;
        } else {
          var _block = this.blocks[blockIndex];
          (0, _lodash.merge)(_block.data, updates);
        }
        this.originalBlocks = this.blocks;
      }
    }, {
      key: "remove",
      value: function remove(_ref12) {
        var target = _ref12.target;
        this.filter({
          remove: (0, _lodash.isArray)(target) ? target : [target]
        });
      }
    }, {
      key: "filter",
      value: function filter(_ref13) {
        var remove = _ref13.remove,
          keep = _ref13.keep;
        var pool = remove || keep;
        if (pool) {
          var direction = keep !== undefined;
          this.blocks = (0, _lodash.filter)(this.blocks, function (block) {
            return direction !== (pool.indexOf(block.id) === -1);
          });
        }
      }
    }, {
      key: "insert",
      value: function insert(_ref14) {
        var blocks = _ref14.blocks,
          block = _ref14.block,
          add_to = _ref14.add_to;
        blocks = block ? [block] : blocks || [];
        console.info('[BlocksListNavComponent] Inserting new blocks', blocks);
        if (add_to === 'bottom') {
          this.blocks = (this.blocks || []).concat(blocks);
        } else {
          this.blocks = (blocks || []).concat(this.blocks);
        }
        angular.element(this.$window).trigger('assets:load');
      }
    }, {
      key: "performActions",
      value: function performActions(actions) {
        return this.navService.performActions(actions, this.config.nuid);
      }
    }, {
      key: "toggleSearch",
      value: function toggleSearch() {
        this.showSearch = !this.showSearch;
        if (!this.showSearch) {
          this.clearSearch();
        }
      }
    }, {
      key: "clearSearch",
      value: function clearSearch() {
        this.showSearch = false;
        if (this.originalBlocks) {
          this.blocks = this.originalBlocks;
        } else if (this.searchQuery && this.searchQuery.length) {
          this.searchQuery = '';
          this.search();
        }
      }
    }, {
      key: "performSearch",
      value: function performSearch() {
        if (this.searchQuery && this.searchQuery.length >= 3) {
          this.search();
        } else if (this.originalBlocks && this.searchQuery.length === 0) {
          console.debug('[BlocksListNavComponent] Restoring blocks');
          this.blocks = this.originalBlocks;
          this.originalBlocks = null;
        }
      }
    }, {
      key: "search",
      value: function search() {
        var _this6 = this;
        if (!this.searchable) return;
        console.debug('[BlocksListNavComponent] Search for:', this.searchQuery);
        if (this.config.ds.source.path) {
          var params = this.config.ds.source.params || {};
          if ((0, _lodash.isEmpty)(this.searchQuery)) {
            delete params.search;
          } else {
            params.search = this.searchQuery;
          }
          this.databaseService.runAppScript(this.config.ds.source.path, params).then(function (_ref15) {
            var data = _ref15.data;
            console.info('[BlocksListNavComponent] Filtered results:', data.response);
            if (!_this6.originalBlocks) {
              _this6.originalBlocks = _this6.blocks;
            }
            _this6.blocks = data.response;
          });
        }
      }
    }]);
    return BlocksListNavComponent;
  }(_filtering.FilteringController)
};
exports.BlocksListNavComponent = BlocksListNavComponent;

},{"../../common/filtering":86,"./blocks-list-nav.jade":168,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/get":379,"@babel/runtime/helpers/getPrototypeOf":380,"@babel/runtime/helpers/inherits":381,"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/helpers/possibleConstructorReturn":387,"lodash":"lodash"}],168:[function(require,module,exports){
module.exports = '<nav class="nav-wrapper nav-column nav-blocks nav-blocks-list" theme="::$ctrl.theme" nav-id="{{::$ctrl.config._id}}"><div class="new-content" ng-if="$ctrl.hasNewContentButton" ng-class="{in: $ctrl.showNewContentButton}"><a theme="::$ctrl.theme" theme-selector="toolbar" ng-click="$ctrl.showNewContent()">{{ ::(\'feed.see_new_posts\' | i18n) }}</a></div><nav-header ng-class="{\'search-in\': $ctrl.showSearch}" parent-nav-id="::$ctrl.config.nuid" label="::$ctrl.config.title" actions="::$ctrl.config.nav_bar_actions" banner="::$ctrl.config.parallax_header.image_url"><div class="search-tool" ng-if="$ctrl.searchable" ng-class="{\'in\': $ctrl.showSearch}"><div class="search-blocks-list-form"><input type="text" ng-model="$ctrl.searchQuery" ng-model-options="{debounce: 500}" ng-change="$ctrl.performSearch()" placeholder="{{::(\'general.search\' | i18n)}}"/></div><button class="btn" ng-click="$ctrl.toggleSearch()"><span class="text">{{::(\'general.cancel\' | i18n)}}</span><img ng-if="::$ctrl.searchable_icon_url" ng-src="{{::($ctrl.searchable_icon_url | assetUrl)}}"/><i class="icon-magnifying-glass active-text-color" ng-if="::!$ctrl.searchable_icon_url"></i></button></div><button class="btn" ng-if="::$ctrl.config.filters_ds.enabled" ng-click="$ctrl.showFilters($event)"><i class="icon-funnel"></i></button></nav-header><div class="nav-content lazy-asset-grid" assets-in-bg="assets-in-bg"><div class="blocks-root clearfix" intercept-appscript-links="intercept-appscript-links"><div class="block-group block-group-width-full" ng-if="::$ctrl.config.parallax_header"><list-banner class="block" image="::$ctrl.config.parallax_header"></list-banner></div><empty-state ng-if="!$ctrl.loading &amp;&amp; !$ctrl.blocks.length &amp;&amp; $ctrl.config.no_content" config="$ctrl.config"></empty-state><div class="block-group block-group-width-full" ng-if="$ctrl.blocks.length" ng-repeat="block in $ctrl.blocks track by block.id" on-repeat-done="checkAssets()"><empty-state ng-if="$ctrl.EMPTY_STATES_BLOCKS.includes(block.id)" config="block"></empty-state><div class="block {{::$ctrl.classNamesForBlock(block)}}" ng-if="!$ctrl.EMPTY_STATES_BLOCKS.includes(block.id)" ng-style="$ctrl.blockStyles" ng-include="::$ctrl.templateUrlForBlock(block)"></div></div></div></div></nav>';
},{}],169:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlocksListNavModule = void 0;
var _blocksListNav = require("./blocks-list-nav.component");
var BlocksListNavModule = angular.module('maestro.components.navs.blocks-list', []).component('blocksListNav', _blocksListNav.BlocksListNavComponent).name;
exports.BlocksListNavModule = BlocksListNavModule;

},{"./blocks-list-nav.component":167}],170:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlocksNavComponent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
var _i18nWithFallback = _interopRequireDefault(require("../../../utils/i18n-with-fallback"));
var ANIMATION_DELAY_FACTOR = 20;
var ACTION_BTN_BLOCK = {
  id: 'action-btn',
  block_type: 'block_action_btn',
  data: {
    non_empty_fields_group: ['content', 'media'],
    content: {
      title: 'feed.post'
    },
    actions: {
      post: {
        action_key: 'send_data',
        target: 'feed-ui/create-post'
      }
    }
  }
};
var BlocksNavComponent = {
  template: require('./blocks-nav.jade'),
  bindings: {
    config: '<'
  },
  controller: function () {
    BlocksNavComponent.$inject = ["THEME", "NAV_TEMPLATES", "$i18n", "handlerService", "navService", "databaseService", "progressBarService"];
    /* @ngInject */function BlocksNavComponent(THEME, NAV_TEMPLATES, $i18n, handlerService, navService, databaseService, progressBarService) {
      (0, _classCallCheck2.default)(this, BlocksNavComponent);
      this.theme = THEME;
      this.navTemplates = NAV_TEMPLATES;
      this.handlerService = handlerService;
      this.navService = navService;
      this.databaseService = databaseService;
      this.progressBarService = progressBarService;
      this.cookiePolicyUrl = "https://support.spotme.com/hc/en-us/articles/11137129955731";
      this.privacyPolicyUrl = "https://spotme.com/app-privacy-policy/";
      this.blocksToAdd = [];
      this.cookiePolicyLabel = (0, _i18nWithFallback.default)($i18n, 'general.cookie_policy', 'Cookie Policy');
      this.privacyPolicyLabel = (0, _i18nWithFallback.default)($i18n, 'general.privacy_policy', 'Privacy Policy');
      this.loading = false;
    }
    (0, _createClass2.default)(BlocksNavComponent, [{
      key: "$onInit",
      value: function $onInit() {
        var _this = this;
        console.log('[BlockNavComponent] init', this.config);
        this.config.nav_bar_actions = (0, _lodash.filter)(this.config.nav_bar_actions, function (action) {
          if (action.action_key === 'send_data') {
            ACTION_BTN_BLOCK.data.actions.post.params = action.params;
            _this.blocksToAdd.push(ACTION_BTN_BLOCK);
            return false;
          }
          return true;
        });
        var config = this.config;
        this.performActions = (0, _lodash.curryRight)(this.navService.performActions.bind(this.navService))(config.nuid);
        this.progressBarService.startTask();
        this.navService.inflateNav(config).then(function (_ref) {
          var elements = _ref.elements;
          _this.groupBlockContainers(elements.concat(_this.blocksToAdd));
        }).finally(function () {
          _this.progressBarService.finishTask();
          _this.isHome = config._id === 'nav_home';
        });
      }
    }, {
      key: "groupBlockContainers",
      value: function groupBlockContainers(blocks) {
        this.containerGroups = [];
        if (blocks && blocks.length) {
          var groups = [];
          var blockIds = 0;
          for (var i = 0, n = blocks.length; i < n; i++) {
            var b = blocks[i];
            var prevBlock = blocks[i - 1];
            var prevGroup = groups[groups.length - 1];
            if (!b.id) b.id = blockIds++;
            b.templateUrl = this.navTemplates[b.block_type];
            if (prevBlock && prevGroup && prevBlock.layout && prevBlock.layout.group_with_next && prevGroup.blocks.length <= 2 && b.layout.width !== 'full') {
              prevGroup.blocks.push(b);
            } else {
              groups.push({
                id: i,
                blocks: [b],
                width: b.layout && b.layout.width || 'full',
                delay: (i + 1) / ANIMATION_DELAY_FACTOR
              });
            }
          }
          console.log('[BlockNavComponent] showing blocks', groups);
          this.containerGroups = groups;
        }
        return this.containerGroups;
      }
    }]);
    return BlocksNavComponent;
  }()
};
exports.BlocksNavComponent = BlocksNavComponent;

},{"../../../utils/i18n-with-fallback":359,"./blocks-nav.jade":171,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"lodash":"lodash"}],171:[function(require,module,exports){
module.exports = '<nav class="nav-column nav-blocks nav-wrapper" theme="::$ctrl.theme" theme-selector="home"><nav-header class="visible-xs-block" parent-nav-id="::$ctrl.config.nuid" label="::$ctrl.config.title || &quot;section_title.home&quot;" theme-selector="toolbar" actions="::$ctrl.config.nav_bar_actions"></nav-header><div class="nav-content"><div class="blocks-root clearfix"><div class="block-group block-group-width-{{::group.width}} animated fadeInUp" ng-repeat="group in ::$ctrl.containerGroups track by group.id" style="-webkit-animation-delay: {{::group.delay}}s; animation-delay: {{::group.delay}}s"><div class="block {{::block.block_type}} block-width-{{::block.layout.width}} block-height-{{::block.layout.height}} animated" ng-repeat="block in ::group.blocks track by block.id" ng-include="::block.templateUrl"></div></div></div><div class="legal-disclaimer animated fadeIn" ng-if="::$ctrl.isHome"><a ng-href="{{::$ctrl.privacyPolicyUrl}}" target="_blank">{{::$ctrl.privacyPolicyLabel}}</a>&nbsp;|&nbsp;<a ng-href="{{::$ctrl.cookiePolicyUrl}}" target="_blank">{{::$ctrl.cookiePolicyLabel}}</a></div></div></nav>';
},{}],172:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlocksNavModule = void 0;
var _blocksNav = require("./blocks-nav.component");
var BlocksNavModule = angular.module('maestro.components.navs.blocks', []).component('blocksNav', _blocksNav.BlocksNavComponent).name;
exports.BlocksNavModule = BlocksNavModule;

},{"./blocks-nav.component":170}],173:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FooterButtonsComponent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
var FooterButtonsComponent = {
  template: require('./footer-buttons.jade'),
  bindings: {
    buttons: '<'
  },
  controller: function () {
    FooterButtonsComponent.$inject = ["databaseService"];
    /* @ngInject */function FooterButtonsComponent(databaseService) {
      (0, _classCallCheck2.default)(this, FooterButtonsComponent);
      this.databaseService = databaseService;
    }
    (0, _createClass2.default)(FooterButtonsComponent, [{
      key: "onActionClick",
      value: function onActionClick(button) {
        if (button.loading) return;
        button.loading = true;
        var action = button.action;
        if (!action || !action.target) {
          button.loading = false;
          return;
        }
        this.databaseService.runAppScript(action.target, action.params).then(function (_ref) {
          var response = _ref.data.response;
          return (0, _lodash.extend)(button, response);
        }).finally(function () {
          return button.loading = false;
        });
      }
    }]);
    return FooterButtonsComponent;
  }()
};
exports.FooterButtonsComponent = FooterButtonsComponent;

},{"./footer-buttons.jade":174,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"lodash":"lodash"}],174:[function(require,module,exports){
module.exports = '<div class="action" ng-repeat="button in $ctrl.buttons" ng-click="$ctrl.onActionClick(button)"><div class="loading animated" ng-show="button.loading"><i class="icon-loader"></i></div><div ng-hide="button.loading"><span class="animated fadeIn" ng-if="button.label_position === &quot;left&quot;">{{ button.label }}</span><i class="icon" icon="button.icon_url" ng-show="button.icon_url" force-color="$ctrl.config.data.theme.icon_color"></i><span class="animated fadeIn" ng-if="button.label_position !== &quot;left&quot;">{{ button.label }}</span></div></div>';
},{}],175:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FooterButtonsModule = void 0;
var _footerButtons = require("./footer-buttons.component");
var FooterButtonsModule = angular.module('maestro.components.navs.common.footerButtons', []).component('footerButtons', _footerButtons.FooterButtonsComponent).value('EventEmitter', function (payload) {
  return {
    $event: payload
  };
}).name;
exports.FooterButtonsModule = FooterButtonsModule;

},{"./footer-buttons.component":173}],176:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavHeaderModule = void 0;
var _navHeaderActions = require("./nav-header-actions");
var _navHeader = require("./nav-header.component");
var NavHeaderModule = angular.module('maestro.components.common.nav-header', [_navHeaderActions.NavHeaderActionsModule]).component('navHeader', _navHeader.NavHeaderComponent).name;
exports.NavHeaderModule = NavHeaderModule;

},{"./nav-header-actions":177,"./nav-header.component":180}],177:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavHeaderActionsModule = void 0;
var _navHeaderActions = require("./nav-header-actions.component");
var NavHeaderActionsModule = angular.module('maestro.components.common.nav-header-actions', []).component('navHeaderActions', _navHeaderActions.NavHeaderActionsComponent).name;
exports.NavHeaderActionsModule = NavHeaderActionsModule;

},{"./nav-header-actions.component":178}],178:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavHeaderActionsComponent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
var NavHeaderActionsComponent = {
  template: require('./nav-header-actions.jade'),
  bindings: {
    parentNavId: '<',
    actions: '<',
    toolbar: '<'
  },
  controller: function () {
    NavHeaderActionsComponent.$inject = ["THEME", "databaseService", "navFormService", "navService", "progressBarService", "$scope"];
    /* @ngInject */function NavHeaderActionsComponent(THEME, databaseService, navFormService, navService, progressBarService, $scope) {
      (0, _classCallCheck2.default)(this, NavHeaderActionsComponent);
      this.databaseService = databaseService;
      this.navFormService = navFormService;
      this.navService = navService;
      this.progressBarService = progressBarService;
      this.iconColor = THEME.primary_color || '#999999';
      this.buttonStyle = $scope.$$sheetId ? '' : 'btn-transparent';
    }
    (0, _createClass2.default)(NavHeaderActionsComponent, [{
      key: "$onInit",
      value: function $onInit() {
        this.loading = false;
        this.showToolbarMenu = this.navService.showNavToolbarMenu(this.toolbar);
      }
    }, {
      key: "trigger",
      value: function trigger(action) {
        var _this = this;
        if (this.loading) return;
        var params = (0, _lodash.cloneDeep)(action.params);
        if (action.action_key === 'send_data' && this.parentNavId) {
          (0, _lodash.extend)(params, this.navFormService.get(this.parentNavId));
        }
        this.loading = true;
        this.progressBarService.startTask();
        this.databaseService.runAppScript(action.target, params).finally(function () {
          _this.loading = false;
          _this.progressBarService.finishTask();
        });
      }
    }]);
    return NavHeaderActionsComponent;
  }()
};
exports.NavHeaderActionsComponent = NavHeaderActionsComponent;

},{"./nav-header-actions.jade":179,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"lodash":"lodash"}],179:[function(require,module,exports){
module.exports = '<button class="btn btn-default" ng-repeat="action in ::$ctrl.actions" ng-click="$ctrl.trigger(action)" ng-class="$ctrl.buttonStyle" ng-disabled="$ctrl.loading" data-cue="action-{{::action.target}}" title="{{::action.title}}"><i ng-if="::action.icon_url" icon="::action.icon_url" force-color="$ctrl.iconColor"></i><span ng-bind="::action.title"></span></button><button class="btn btn-default btn-transparent" ng-if="::$ctrl.toolbar.length" ng-click="::$ctrl.showToolbarMenu($event)"><i class="icon-dots-three-horizontal"></i></button>';
},{}],180:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavHeaderComponent = void 0;
var NavHeaderComponent = {
  template: require('./nav-header.jade'),
  bindings: {
    parentNavId: '<',
    label: '<',
    actions: '<',
    toolbar: '<',
    banner: '<'
  },
  transclude: true
};
exports.NavHeaderComponent = NavHeaderComponent;

},{"./nav-header.jade":181}],181:[function(require,module,exports){
module.exports = '<div class="nav-header"><nav-header-actions ng-if="::$ctrl.actions.length" parent-nav-id="::$ctrl.parentNavId" actions="::$ctrl.actions" toolbar="::$ctrl.toolbar"></nav-header-actions><div class="nav-header-actions" ng-transclude="ng-transclude"></div><span class="title">{{$ctrl.label | i18n}}</span></div>';
},{}],182:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChatDetailsComponent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var ChatDetailsComponent = {
  bindings: {
    config: '='
  },
  template: require('./chat-details.pug'),
  controller: function () {
    ChatDetailsComponent.$inject = ["EVENT_NAVS", "ACTIVATED_PERSON", "$window", "$scope", "$sheet", "databaseService", "navService", "progressBarService", "dataSourceEvaluatorService"];
    /* @ngInject */
    function ChatDetailsComponent(EVENT_NAVS, ACTIVATED_PERSON, $window, $scope, $sheet, databaseService, navService, progressBarService, dataSourceEvaluatorService) {
      (0, _classCallCheck2.default)(this, ChatDetailsComponent);
      this.newMsgNav = EVENT_NAVS['nav_newmessage'];
      this.actPerson = ACTIVATED_PERSON;
      this.$window = angular.element($window);
      this.$scope = $scope;
      this.sheet = $sheet;
      this.databaseService = databaseService;
      this.navService = navService;
      this.progressBarService = progressBarService;
      this.ds = dataSourceEvaluatorService;
    }
    (0, _createClass2.default)(ChatDetailsComponent, [{
      key: "$onInit",
      value: function $onInit() {
        var _this = this;
        if (!this.newMsgNav) {
          console.warn('[ChatDetailsComponent] Old message package detected, skipping init.');
          return;
        }
        console.log('[ChatDetailsComponent] init', this.config);
        this.original_chat_name = this.config.chat_name;
        this.participants_ds = this.newMsgNav.participants_list.ds;
        this.reset();
        this.$scope.$on('conversation:load_details', function () {
          _this.reload();
        });
      }
    }, {
      key: "reload",
      value: function reload() {
        var _this2 = this;
        this.sheet.dismissAllSheets();
        this.progressBarService.startTask();
        this.ds.eval(this.config.details.ds, {
          conversation_id: this.config.conversation_id
        }).then(function (resp) {
          console.info('[ChatDetailsComponent] Details loaded:', resp);
          _this2.reset();
          if (resp.chat_name) {
            _this2.config.chat_name = resp.chat_name;
          }
          var admins = resp.admins || [];
          _this2.isAdmin = admins.indexOf(_this2.actPerson._id) !== -1;
          resp.participants.forEach(function (pax) {
            _this2.suggestions_exclusions.push(pax.id);
            if (!pax.menu) {
              pax.menu = [];
            }
            if (pax.id !== _this2.actPerson._id && _this2.isAdmin) {
              pax.menu.push({
                id: 'kick',
                action: {
                  method: 'runScript',
                  params: {
                    path: _this2.config.actions.participant_interactions.path,
                    params: {
                      conversation_id: _this2.config.conversation_id,
                      kick_participant: pax.id
                    }
                  }
                },
                label: 'conversation_nav.details.kick_participant'
              });
            }
          });
          _this2.participants = resp.participants;
        }).finally(function () {
          _this2.progressBarService.finishTask();
          _this2.$window.trigger('assets:load');
        });
      }
    }, {
      key: "reset",
      value: function reset() {
        this.errors = [];
        this.suggestions_exclusions = [];
        this.participants = [];
      }
    }, {
      key: "closeDetails",
      value: function closeDetails() {
        this.config.detailsIn = false;
        this.renameChat();
      }
    }, {
      key: "closeInvites",
      value: function closeInvites() {
        this.addFormIn = false;
        this.sendInvites();
      }
    }, {
      key: "changeGroupName",
      value: function changeGroupName() {
        this.renameChat();
      }
    }, {
      key: "renameChat",
      value: function renameChat() {
        var _this3 = this;
        if ((this.config.chat_name || '').trim().length === 0) {
          this.config.chat_name = this.original_chat_name;
        }
        if (this.sending || this.original_chat_name === this.config.chat_name) {
          return;
        }
        this.sending = true;
        this.progressBarService.startTask();
        this.databaseService.runAppScript(this.config.actions.rename_chatroom.path, {
          conversation_id: this.config.conversation_id,
          chat_name: this.config.chat_name
        }).finally(function () {
          _this3.sending = false;
          _this3.original_chat_name = _this3.config.chat_name;
          _this3.progressBarService.finishTask();
          _this3.config.title = _this3.config.chat_name;
        });
      }
    }, {
      key: "openProfile",
      value: function openProfile(profile) {
        var lastNav = this.navService.activeNav.nav;
        this.navService.openDocument({
          id: profile.id
        }, {
          _parent_nav_id: lastNav.nuid
        });
      }
    }, {
      key: "showUserMenu",
      value: function showUserMenu(e, pax) {
        e.preventDefault();
        e.stopPropagation();
        this.navService.showNavToolbarMenu(pax.menu)(e);
      }
    }, {
      key: "showAddParticipantsForm",
      value: function showAddParticipantsForm() {
        this.addFormIn = true;
      }
    }, {
      key: "leaveGroup",
      value: function leaveGroup() {
        this.navService.alert({
          title: 'conversation_nav.leaving_alert.title',
          message: 'conversation_nav.leaving_alert.message',
          buttons: [{
            title: 'general.cancel'
          }, {
            title: 'conversation_nav.details.leave_group',
            target: {
              method: 'runScript',
              params: {
                path: this.config.actions.participant_interactions.path,
                params: {
                  conversation_id: this.config.conversation_id,
                  leave_conversation: true
                }
              }
            }
          }]
        });
      }
    }, {
      key: "sendInvites",
      value: function sendInvites() {
        var _this4 = this;
        var newInvites = this.participants.filter(function (p) {
          return p._id;
        });
        if (this.sending || newInvites.length === 0) return;
        console.info('[ChatDetailsComponent] Sending invites', newInvites);
        this.progressBarService.startTask();
        this.sending = true;
        this.databaseService.runAppScript(this.config.actions.participant_interactions.path, {
          conversation_id: this.config.conversation_id,
          add_participant: newInvites.map(function (p) {
            return p._id;
          })
        }).finally(function () {
          _this4.sending = false;
          _this4.participants = [];
          _this4.progressBarService.finishTask();
        });
      }
    }, {
      key: "representation",
      value: function representation(doc) {
        if (doc.full_name) {
          return doc.full_name;
        }
        return [doc.fname || doc.first_name, doc.lname || doc.last_name].join(' ').trim();
      }
    }]);
    return ChatDetailsComponent;
  }()
};
exports.ChatDetailsComponent = ChatDetailsComponent;

},{"./chat-details.pug":183,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382}],183:[function(require,module,exports){
module.exports = '<div class="chat-details in lazy-asset-grid" assets-in-bg="assets-in-bg"><nav-header label="\'conversation_nav.details.title\'"><button class="btn" ng-click="$ctrl.closeDetails()"><i class="icon-cross"></i></button></nav-header><div class="nav-content"><form class="vibram" ng-submit="$ctrl.changeGroupName()" name="groupDetails"><div class="form-group"><i class="icon-edit"></i><input class="form-control" ng-model="$ctrl.config.chat_name" ng-model-options="{ debounce: 500 }" type="text" name="chat_name" placeholder="{{\'conversation_nav.details.rename_hint\' | i18n}}"/></div></form><h3><span class="count">{{ $ctrl.participants.length }}</span>{{ \'conversation_nav.details.members\' | i18n }}</h3><section class="participants"><div class="pax" ng-repeat="pax in $ctrl.participants"><div class="media row-person" ng-click="$ctrl.openProfile(pax)"><div class="media-left"><div class="media-object"><avatar object="pax" mode="medium"></avatar></div></div><div class="media-body"><button class="btn more" ng-if="pax.menu.length !== 0" ng-click="$ctrl.showUserMenu($event, pax)"><i class="icon-dots-three-vertical"></i></button><div class="nav-list-item-title" ng-bind="::$ctrl.representation(pax)"></div><div class="nav-list-item-subtitle" ng-bind="::(pax.description)"></div></div></div></div></section><section class="actions"><div class="action" ng-if="!$ctrl.config.max_users || $ctrl.config.max_users &gt; $ctrl.participants.length"><a ng-click="$ctrl.showAddParticipantsForm()"><i class="icon-plus"></i>{{ \'conversation_nav.details.add_participants\' | i18n }}</a></div><div class="action highlight"><a ng-click="$ctrl.leaveGroup()"><i class="ic-log-out icon-log-out"></i>{{ \'conversation_nav.details.leave_group\' | i18n }}</a></div></section></div></div><div class="invites" ng-class="{\'in\': $ctrl.addFormIn}"><nav-header label="\'conversation_nav.details.add_participants\'"><button class="btn" ng-click="$ctrl.closeInvites()"><i class="icon-check"></i></button></nav-header><div class="nav-content"><form class="vibram" ng-submit="$ctrl.invitePeople()" name="invitations"><suggestions max="$ctrl.config.max_users" documents="$ctrl.participants" ds="$ctrl.participants_ds" error="$ctrl.errors.participants" exclusions="$ctrl.suggestions_exclusions" field-icon="icon-users" field-name="participants" placeholder="conversation_nav.details.add_participants" representation="$ctrl.representation"></suggestions></form></div></div>';
},{}],184:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConversationNavComponent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _uuid = require("uuid");
var _i18nWithFallback = _interopRequireDefault(require("../../../utils/i18n-with-fallback"));
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var _ = require('lodash');
var moment = require('moment-timezone');
var READ_MESSAGE_IDS = {};
var ConversationNavComponent = {
  bindings: {
    config: '<'
  },
  template: require('./conversation-nav.jade'),
  controller: function () {
    ConversationNavComponent.$inject = ["NAV_TEMPLATES", "PID", "THEME", "EVENT", "$timeout", "navService", "databaseService", "videoCallService", "progressBarService", "signalService", "$http", "$scope", "$i18n", "$element", "$filter", "$eventBus", "dataSourceEvaluatorService"];
    /* @ngInject */
    function ConversationNavComponent(NAV_TEMPLATES, PID, THEME, EVENT, $timeout, navService, databaseService, videoCallService, progressBarService, signalService, $http, $scope, $i18n, $element, $filter, $eventBus, dataSourceEvaluatorService) {
      (0, _classCallCheck2.default)(this, ConversationNavComponent);
      this.navTemplates = NAV_TEMPLATES;
      this.pid = PID;
      this.theme = THEME;
      this.EVENT = EVENT;
      this.$timeout = $timeout;
      this.navService = navService;
      this.databaseService = databaseService;
      this.videoCallService = videoCallService;
      this.progressBarService = progressBarService;
      this.signalService = signalService;
      this.$http = $http;
      this.loading = true;
      this.messageIds = {};
      this.updateInProgress = false;
      this.lastKey = '';
      this.lastDocId = '';
      this.sending = false;
      this.sendJustFinished = false;
      this.$scope = $scope;
      this.$i18n = $i18n;
      this.linky = $filter('linky');
      this.$eventBus = $eventBus;
      this.textarea = $element.find('textarea.form-control');
      this.container = $element.find('.nav-content');
      this.glued = false;
      this.ds = dataSourceEvaluatorService;
      this.inCall = false;
      this.joinCallLabel = (0, _i18nWithFallback.default)($i18n, 'video_calls.actions.join', 'Join call');
    }
    (0, _createClass2.default)(ConversationNavComponent, [{
      key: "$onInit",
      value: function $onInit() {
        var _this = this;
        var config = this.config;
        if (!config.participants) {
          return;
        }
        console.debug('[ConversationNavComponent] init', config);
        config.ds.elements = [];
        this.isGroupChat = _.size(config.participants) > 2;
        if (!this.config.chat_name) {
          var p = _.clone(config.participants);
          delete p[this.pid];
          var paxes = Object.keys(p).map(function (k) {
            return p[k];
          });
          this.config.chat_name = paxes.join(', ');
        }
        this.use_vonage_calls_in_chat = this.EVENT.use_vonage_calls_in_chat;
        this.showDetails = config.actions && config.actions.participant_interactions && config.actions.rename_chatroom;
        this.removeUpdateListener = this.$eventBus.on('messages:update', function () {
          return _this.updateNav();
        });
        this.signalService.addSignalListener("pushNotification/".concat(this.pid), function (_ref) {
          var notificationPayload = _ref.notificationPayload;
          var conversation_id = _.get(notificationPayload, 'action.params.conversation_id');
          if (conversation_id === _this.config.conversation_id) {
            _this.evalDs().then(function () {
              return _this.updateNav();
            });
          }
        }).then(function (remover) {
          return _this.removePushNotificationListener = remover;
        });
        this.$eventBus.emit('notifications:hide', "chat-message-".concat(this.config.conversation_id));
        this.unsubFromNotifications = this.navService.subscribeToEvents(this.navService.flattenNotificationMap(config.ds.reload_on), function (event, data) {
          switch (event.name) {
            case 'activatedperson_updated':
              _this.$scope.$broadcast('conversation:load_details', data);
              break;
          }
        });
        this.showVideoCall = !this.videoCallService.isDifferentLocation();
        this.$eventBus.on('video-pip:close', function () {
          _this.showVideoCall = !_this.videoCallService.isDifferentLocation();
        });
        this.$eventBus.on('video-pip:started', function () {
          _this.showVideoCall = !_this.videoCallService.isDifferentLocation();
        });
        if (this.EVENT.use_vonage_calls_in_chat) {
          this.disableJoinButton = true;
          this.showVideoButtons = true;
          this.$scope.$watch('$ctrl.conversation', function (newValue) {
            if (newValue) {
              _this.disableJoinButton = _this.inCall || _this.callEnded;
              _this.showVideoButtons = !!newValue.is_live;
            }
          });
        }
        if (this.config.details && this.config.details.ds) {
          this.evalDs().then(function () {
            return _this.updateNav();
          });
        } else {
          this.updateNav();
        }
      }
    }, {
      key: "evalDs",
      value: function evalDs() {
        var _this2 = this;
        return this.ds.eval(this.config.details.ds, {
          conversation_id: this.config.conversation_id
        }).then(function (conversation) {
          console.info('[ConversationNavComponent] Details loaded:', conversation);
          _this2.conversation = conversation;
          _this2.showVideoButtons = !!conversation.is_live;
          return conversation;
        }).then(function (conversation) {
          if (!_.find(_this2.conversation.participants, function (p) {
            return p.id === _this2.pid;
          })) {
            _this2.config.ds.elements = [];
            _this2.blockedConversation = true;
            return _this2.$scope.$applyAsync();
          }
          return _this2.EVENT.use_vonage_calls_in_chat && !conversation.session_id ? _this2.videoCallService.createSession() : null;
        }).then(function (sessionId) {
          if (!sessionId) return;
          _this2.conversation.session_id = sessionId;
          return _this2.videoCallService.addSessionIdToConversation(_this2.conversation.id, sessionId);
        }).catch(function (err) {
          return console.error('[ConversationNavComponent] Error:', err);
        });
      }
    }, {
      key: "$onDestroy",
      value: function $onDestroy() {
        if (_.isFunction(this.unsubFromNotifications)) {
          this.unsubFromNotifications();
        }
        if (_.isFunction(this.removePushNotificationListener)) {
          this.removePushNotificationListener();
        }
        if (_.isFunction(this.removeUpdateListener)) {
          this.removeUpdateListener();
        }
        if (_.isFunction(this.callStopUnregister)) {
          this.callStopUnregister();
        }
        if (_.isFunction(this.callUpdateUnregister)) {
          this.callUpdateUnregister();
        }
        this.$eventBus.emit('notifications:show', "chat-message-".concat(this.config.conversation_id));
      }
    }, {
      key: "filterAndAppend",
      value: function filterAndAppend(messages) {
        var _this3 = this;
        messages = _.filter(messages, function (_ref2) {
          var _id = _ref2._id;
          return _this3.messageIds[_id] ? false : _this3.messageIds[_id] = true;
        });
        messages = this.remapMessages(messages);
        Array.prototype.push.apply(this.config.ds.elements, messages);
        this.regroupMessages();
      }
    }, {
      key: "remapMessages",
      value: function remapMessages(messages) {
        var rows = [];
        var onlyVideoMessages = _.every(messages, function (message) {
          var event_type = _.get(message, 'render.params.mapping.event_type') || '';
          return event_type.includes('call');
        });
        var _iterator = _createForOfIteratorHelper(messages),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var m = _step.value;
            try {
              var mapping = m.render.params.mapping;
              var row = {
                _id: m._id,
                body: this.linky(mapping.body, '_blank'),
                category: mapping.category,
                cssClasses: [],
                isOwn: mapping.is_own === 'true' || mapping.origin === this.pid,
                pid: mapping.pid,
                showName: true,
                title: mapping.title,
                ts: mapping.ts,
                timestamp: mapping.timestamp,
                row_type: m.render.row_type
              };
              if (row.category) {
                if (row.category === 'chat_notifications') {
                  row.body = mapping.system_notification;
                  var eventType = mapping.event_type;
                  row.cssClasses = row.cssClasses.concat(['event', eventType]);
                  row.type = eventType || row.type;
                  if (!(eventType || '').startsWith('call')) {
                    row.cssClasses.push('notification');
                    row.themeSelector = 'toolbar';
                    delete row.ts;
                  } else {
                    if (row.isOwn) {
                      row.body = row.body.replace(this.config.participants[this.pid].trim(), this.$i18n('conversation_nav.details.you'));
                    }
                    row.category = 'mail';
                    if (onlyVideoMessages && eventType === 'callstart') {
                      this.evalDs();
                      this.callEnded = false;
                    }
                    if (onlyVideoMessages && eventType === 'callstop') {
                      this.disableJoinButton = true;
                      this.callEnded = true;
                    }
                    if (eventType === 'callpart' && row.isOwn) {
                      row.rejoin = true;
                    }
                  }
                }
                if (row.category === 'chat_dates') {
                  row.body = mapping.date_notification;
                  row.cssClasses = row.cssClasses.concat(['notification', 'date']);
                  delete row.ts;
                }
                if (row.type === 'quit' && mapping.origin === this.pid) {
                  this.evalDs();
                }
                if (row.isOwn && row.category === 'mail') {
                  row.cssClasses.push('own');
                } else if (row.category === 'mail') {
                  row.cssClasses.push('their');
                }
                row.showName = !row.isOwn && row.category === 'mail';
              } else {
                if (row.isOwn) {
                  row.cssClasses.push('own');
                  row.showName = false;
                }
                row.ts = row.timestamp;
              }
              rows.push(row);
            } catch (error) {
              console.error('[ConversationNavComponent] Error parsing message', m);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        return this.config.nav_version >= 3 ? rows.reverse() : rows;
      }
    }, {
      key: "regroupMessages",
      value: function regroupMessages() {
        var latestCallRow = _.reduce(this.config.ds.elements, function (memo, row) {
          if ((row.type === 'callstart' || row.type === 'callpart' && row.isOwn) && row.timestamp > memo.timestamp) {
            memo = row;
          }
          return memo;
        });
        var n = this.config.ds.elements.length;
        while (n--) {
          var row = this.config.ds.elements[n];
          var prev = this.config.ds.elements[n - 1];
          if (!prev) continue;
          row.showName = !row.isOwn && row.category === 'mail';
          var sameCat = row.category === prev.category;
          if (row.title === prev.title && sameCat) {
            prev.cssClasses.push('group-with-next');
            row.cssClasses.push('group-with-prev');
          }
          if (['callstart', 'callpart'].includes(row.type)) {
            row.latest = row._id === latestCallRow._id;
          }
        }
        if (this.conversation.is_live && !_.find(this.config.ds.elements, function (el) {
          return el.latest;
        })) {
          this.config.ds.elements.push({
            body: this.$i18n('conversation_nav.notifications.video_call_title'),
            category: 'mail',
            cssClasses: ['event', 'callstart', 'own'],
            isOwn: true,
            row_type: 'conversation_row',
            type: 'callstart',
            latest: true
          });
        }
      }
    }, {
      key: "updateNav",
      value: function updateNav() {
        var _this4 = this;
        var refocus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        if (this.updateInProgress || this.blockedConversation) return;
        if (this.updateTimeout) this.$timeout.cancel(this.updateTimeout);
        if (!this.config.conversation_id) return;
        this.updateInProgress = true;
        this.glued = true;
        this.progressBarService.startTask();
        return this.navService.inflateNav(this.config, {
          skip: this.lastKey ? 1 : 0,
          updates_only: this.lastKey ? true : false,
          startkey: this.lastKey,
          startkey_docid: this.lastDocId,
          conversation_id: this.config.conversation_id,
          version: 4,
          cache: false
        }).then(function (_ref3) {
          var elements = _ref3.elements;
          if (!elements || !elements.length) {
            return;
          }
          _this4.lastKey = elements[0].key;
          _this4.lastDocId = elements[0]._id;
          elements.reverse();
          _this4.filterAndAppend(elements);
        }).finally(function () {
          _this4.markLastMessageAsRead();
          if (refocus) {
            _this4.textarea.focus();
          }
          _this4.$timeout(function () {
            var container = _this4.container[0];
            if (container) {
              container.scrollTo(0, container.getBoundingClientRect().height);
            }
            _this4.updateInProgress = false;
            _this4.progressBarService.finishTask();
          }, 250);
        });
      }
    }, {
      key: "sendMessage",
      value: function sendMessage($event) {
        var _this5 = this;
        if ($event) $event.stopPropagation();
        if (this.sending) return;
        if (!this.messageToSend || this.messageToSend.length < 1) return;
        this.sending = true;
        this.databaseService.runAppScript(this.config.actions.send_button.path, {
          message: {
            _id: (0, _uuid.v4)(),
            body: this.messageToSend,
            conversation_id: this.config.conversation_id || (0, _uuid.v4)(),
            participants: this.config.participants
          }
        }).then(function (_ref4) {
          var response = _ref4.data.response;
          if (response.conversation_id) _this5.config.conversation_id = response.conversation_id;
        }).finally(function () {
          _this5.sending = false;
          _this5.sendJustFinished = true;
          _this5.messageToSend = '';
        }).finally(function () {
          if (_this5.config.nav_version < 4) {
            _this5.navService.emit('messages:update');
          }
          _this5.updateNav(true);
        });
      }
    }, {
      key: "openUserProfile",
      value: function openUserProfile(pid) {
        if (this.config.participants) {
          var lastNav = this.navService.activeNav.nav;
          this.navService.openDocument({
            id: pid
          }, {
            _parent_nav_id: lastNav.nuid
          });
        }
      }
    }, {
      key: "markLastMessageAsRead",
      value: function markLastMessageAsRead() {
        var _this6 = this;
        if (READ_MESSAGE_IDS[this.lastDocId]) return;
        READ_MESSAGE_IDS[this.lastDocId] = true;
        return this.databaseService.saveDoc({
          fp_type: 'mail_status',
          fp_owner: this.pid,
          status: 'read',
          conversation_id: this.config.conversation_id,
          parent_mail: this.lastDocId,
          timestamp: moment().unix()
        }).finally(function () {
          return _this6.navService.emit('messages:update');
        });
      }
    }, {
      key: "openDetails",
      value: function openDetails() {
        this.config.detailsIn = true;
        this.$scope.$broadcast('conversation:load_details');
      }
    }, {
      key: "startVideoCall",
      value: function startVideoCall() {
        var _this7 = this;
        this.callStopUnregister = this.$eventBus.on("chat:stopcall:".concat(this.conversation.id), function () {
          _this7.showVideoCall = false;
          _this7.videoCallService.stop();
          _this7.inCall = false;
          _this7.disableJoinButton = true;
          _this7.callStopUnregister();
          _this7.callUpdateUnregister();
          _this7.evalDs().then(function () {
            return _this7.updateNav();
          });
        });
        this.callUpdateUnregister = this.$eventBus.on("chat:updatecall:".concat(this.conversation.id), function (event, inCall) {
          _this7.navService.emit('messages:update');
          if (_.isBoolean(inCall)) {
            _this7.inCall = inCall;
            _this7.disableJoinButton = inCall || _this7.callEnded;
          }
        });
        this.videoCallService.start({
          docType: this.conversation.type,
          sessionId: this.conversation.session_id,
          conversationId: this.conversation.id,
          actions: this.config.actions
        });
        this.showVideoCall = true;
        this.callEnded = false;
      }
    }]);
    return ConversationNavComponent;
  }()
};
exports.ConversationNavComponent = ConversationNavComponent;

},{"../../../utils/i18n-with-fallback":359,"./conversation-nav.jade":185,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"lodash":"lodash","moment-timezone":"moment-timezone","uuid":1222}],185:[function(require,module,exports){
module.exports = '<nav class="nav-wrapper"><div class="nav-column nav-conversation" ng-class="{&quot;group-chat&quot;:$ctrl.config.isGroupChat, &quot;live&quot;: $ctrl.showVideoCall}" theme="::$ctrl.theme" nav-id="{{::$ctrl.config._id}}"><nav-header ng-if="::(!$ctrl.config.modal)" label="$ctrl.config.title" actions="::$ctrl.config.nav_bar_actions"><button class="btn btn-default" ng-if="$ctrl.use_vonage_calls_in_chat &amp;&amp; $ctrl.config.enable_video_calls &amp;&amp; $ctrl.conversation.session_id &amp;&amp; !$ctrl.blockedConversation" ng-click="$ctrl.startVideoCall()">{{ $ctrl.joinCallLabel }}</button><button class="btn btn-default btn-transparent chat-info-button" ng-if="$ctrl.showDetails &amp;&amp; !$ctrl.conversation.meeting_video_call" ng-click="$ctrl.openDetails()"><i class="ic-info icon-info"></i></button></nav-header><div class="nav-content" scroll-glue-bottom="$ctrl.glued"><div class="nav-list"><div ng-repeat="row in $ctrl.config.ds.elements track by row._id" ng-include="$ctrl.navTemplates[row.row_type]"></div></div><div class="nav-footer"><div class="input-group"><textarea class="camo form-control" enter-key="enter" on-submit="$ctrl.sendMessage(e)" ng-attr-placeholder="{{&quot;wv.mail.write_a_reply&quot; | i18n}}" ng-model="$ctrl.messageToSend" ng-model-options="{updateOn: &quot;default blur&quot;}" ng-disabled="$ctrl.sending"></textarea><span class="input-group-btn animated" ng-class="{sendPlane: $ctrl.sending, landPlane: !$ctrl.sending &amp;&amp; $ctrl.sendJustFinished}"><button class="btn btn-default btn-transparent" ng-click="$ctrl.sendMessage($event)" data-cue="chat-submit-message" ng-disabled="$ctrl.blockedConversation"><i class="icon-paper-plane" title="{{&quot;general.send&quot; | i18n}}"></i></button></span></div></div></div><chat-details ng-if="$ctrl.showDetails" config="$ctrl.config" ng-class="{\'in\': $ctrl.config.detailsIn}"></chat-details></div></nav>';
},{}],186:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConversationNavModule = void 0;
var _conversationNav = require("./conversation-nav.component");
var _chatDetails = require("./chat-details/chat-details.component");
var ConversationNavModule = angular.module('maestro.components.navs.conversation', []).component('chatDetails', _chatDetails.ChatDetailsComponent).component('conversationNav', _conversationNav.ConversationNavComponent).name;
exports.ConversationNavModule = ConversationNavModule;

},{"./chat-details/chat-details.component":182,"./conversation-nav.component":184}],187:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DocumentNavComponent = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var DEFAULT_SCALE_DELTA = 1.1;
var MIN_SCALE = 0.25;
var MAX_SCALE = 10.0;
var DocumentNavComponent = {
  bindings: {
    config: '<',
    onReject: '&'
  },
  template: require('./document-nav.jade'),
  controller: function () {
    DocumentNavComponent.$inject = ["EID", "$filter", "$element", "$timeout", "$q", "pdfService", "databaseService", "navService", "progressBarService", "metricsService", "$scope"];
    /* @ngInject */
    function DocumentNavComponent(EID, $filter, $element, $timeout, $q, pdfService, databaseService, navService, progressBarService, metricsService, $scope) {
      (0, _classCallCheck2.default)(this, DocumentNavComponent);
      this.EID = EID;
      this.$filter = $filter;
      this.$element = $element;
      this.$timeout = $timeout;
      this.$q = $q;
      this.pdfService = pdfService;
      this.databaseService = databaseService;
      this.navService = navService;
      this.progressBarService = progressBarService;
      this.metricsService = metricsService;
      this.minScale = MIN_SCALE;
      this.maxScale = MAX_SCALE;
      this.pdfReader = true;
      this.pdfLoading = true;
      this.annotationsEnabled = false;
      this.sharingEnabled = false;
      this.sharingUrl = null;
      this.viewer = null;
      this.viewerState = {
        page: 1,
        searchTerm: '',
        numPages: 1
      };
      this.noteId = null;
      this.url = null;
      this.addNoteActive = false;
      this.initialSearch = true;
      this.$scope = $scope;
    }
    (0, _createClass2.default)(DocumentNavComponent, [{
      key: "$onInit",
      value: function $onInit() {
        var _this = this;
        var config = this.config;
        var url = this.url = config.url || config.media_url || config.doc_location;
        if (!url || !url.length) {
          console.warn('[DocumentNavCtrl] No url to open');
          this.navService.resetNavigation();
          return;
        }
        console.log('[DocumentNavCtrl] init', url);
        var openExternal = function openExternal(error) {
          console.log('[DocumentNavCtrl] Opening as external', url);
          _this.external = true;
          if (_this.onReject) {
            _this.onReject(error);
          }
          _this.navService.openExternalUri({
            uri: url
          });
        };
        var noteId = this.noteId = config.doc_id;
        var isPdf = url.toLowerCase().indexOf('.pdf') !== -1;
        var withAnnotation = !!config.annotations;
        if (url.indexOf('://') === -1 && url[0] !== '/') {
          url = this.$filter('assetUrl')(url);
        }
        if (!isPdf) {
          return openExternal();
        }
        this.pdfReader = true;
        this.annotationsEnabled = withAnnotation;
        this.sharingEnabled = config.file_sharing_enabled;
        this.sharingUrl = url;
        this.progressBarService.startTask();
        this.$timeout(function () {
          _this.$q.all([_this.initPDFViewer(), withAnnotation && noteId ? _this.databaseService.docWithId(noteId) : null]).then(function (_ref) {
            var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
              viewer = _ref2[0],
              annotations = _ref2[1];
            if (!withAnnotation) return;
            _this.annotationController = _this.pdfService.mapAnnotations(viewer, annotations, config.parent_doc_id, function (_ref3) {
              var data = _ref3.data;
              return _this.noteId = data.id;
            });
            _this.annotationController.onActiveEnd(function () {
              return _this.$timeout(function () {
                return _this.addNoteActive = false;
              });
            });
          }).catch(function (error) {
            console.error('[DocumentNavCtrl] Unable to initialize PDF viewer', error);
            openExternal(error);
          }).finally(function () {
            _this.pdfLoading = false;
            _this.progressBarService.finishTask();
          });
        });
      }
    }, {
      key: "initPDFViewer",
      value: function initPDFViewer() {
        var _this2 = this;
        var container = this.$element.find('.nav-document-pdf-container')[0];
        return this.pdfService.getViewer(this.sharingUrl, container).then(function (_ref4) {
          var viewer = _ref4.viewer,
            document = _ref4.document,
            findController = _ref4.findController;
          _this2.viewer = viewer;
          _this2.findController = findController;
          _this2.viewerState.numPages = document.numPages;
          container.addEventListener('pagechange', function (evt) {
            return _this2.$timeout(function () {
              return _this2.viewerState.page = evt.pageNumber;
            });
          });
          _this2.findController.onUpdateState = function () {
            _this2.$timeout(function () {
              if (_this2.findController.matchCount === 0) {
                _this2.noMatches = true;
              } else {
                _this2.noMatches = false;
              }
              _this2.$scope.$apply();
            }, 250);
          };
          return viewer;
        });
      }
    }, {
      key: "search",
      value: function search() {
        this.findController.executeCommand(this.initialSearch ? 'find' : 'findagain', {
          query: this.viewerState.searchTerm
        });
        this.initialSearch = false;
      }
    }, {
      key: "changePage",
      value: function changePage() {
        var page = parseInt(this.viewerState.page, 10);
        if (isNaN(page)) {
          page = this.viewer.currentPageNumber;
        } else {
          page = Math.min(page, this.viewerState.numPages);
          page = Math.max(page, 1);
          this.viewer.currentPageNumber = page;
        }
        this.viewerState.page = page;
      }
    }, {
      key: "nextPage",
      value: function nextPage() {
        this.viewer.currentPageNumber++;
      }
    }, {
      key: "previousPage",
      value: function previousPage() {
        this.viewer.currentPageNumber--;
      }
    }, {
      key: "zoomIn",
      value: function zoomIn() {
        var newScale = this.viewer.currentScale;
        newScale = (newScale * DEFAULT_SCALE_DELTA).toFixed(2);
        newScale = Math.ceil(newScale * 10) / 10;
        newScale = Math.min(MAX_SCALE, newScale);
        this.viewer.currentScaleValue = newScale;
        this.viewerState.currentScaleValue = newScale;
      }
    }, {
      key: "zoomOut",
      value: function zoomOut() {
        var newScale = this.viewer.currentScale;
        newScale = (newScale / DEFAULT_SCALE_DELTA).toFixed(2);
        newScale = Math.floor(newScale * 10) / 10;
        newScale = Math.max(MIN_SCALE, newScale);
        this.viewer.currentScaleValue = newScale;
        this.viewerState.currentScaleValue = newScale;
      }
    }, {
      key: "share",
      value: function share() {
        var noteId = this.noteId;
        var url = this.url;
        this.navService.openExternalUri({
          uri: noteId ? "/api/v1/eid/".concat(this.EID, "/pdf/annotations/note/").concat(noteId) : url
        });
      }
    }, {
      key: "toggleAddNote",
      value: function toggleAddNote() {
        this.addNoteActive = !this.addNoteActive;
        this.annotationController.setActive(this.addNoteActive);
      }
    }, {
      key: "toggleSearch",
      value: function toggleSearch() {
        this.showSearch = !this.showSearch;
        if (this.showSearch) {
          this.addNoteActive = false;
          this.annotationController.setActive(false);
        }
      }
    }, {
      key: "onSearchTermChange",
      value: function onSearchTermChange() {
        if (this.viewerState.searchTerm.length === 0) {
          this.noMatches = false;
        }
        this.initialSearch = true;
      }
    }]);
    return DocumentNavComponent;
  }()
};
exports.DocumentNavComponent = DocumentNavComponent;

},{"./document-nav.jade":188,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/helpers/slicedToArray":390}],188:[function(require,module,exports){
module.exports = '<div class="nav-document-container" ng-if="::$ctrl.pdfReader"><div class="nav-document-pdf-toolbar btn-toolbar" ng-show="!$ctrl.pdfLoading"><div class="btn-group nav-document-pdf-page hidden-xs"><form ng-submit="$ctrl.changePage()"><input ng-blur="$ctrl.changePage()" type="number" ng-model="$ctrl.viewerState.page"/>/<span ng-bind="$ctrl.viewerState.numPages"></span></form></div><form class="pull-right btn-group nav-document-pdf-search" ng-submit="$ctrl.search()" ng-class="{&quot;pdf-search-active&quot;:$ctrl.showSearch}"><input ng-model="$ctrl.viewerState.searchTerm" ng-class="{\'no-matches\': $ctrl.noMatches}" ng-change="$ctrl.onSearchTermChange()" placeholder="{{::(&quot;document_nav.search&quot; | i18n)}}"/><i class="icon-cross pull-right visible-xs-block" ng-click="$ctrl.toggleSearch()"></i></form><div class="btn-group"><div class="btn btn-default" title="{{::(&quot;document_nav.next_page&quot; | i18n)}}" ng-click="$ctrl.nextPage()" ng-disabled="$ctrl.viewerState.page == $ctrl.viewerState.numPages"><i class="icon-triangle-down"></i></div><div class="btn btn-default" title="{{::(&quot;document_nav.previous_page&quot; | i18n)}}" ng-click="$ctrl.previousPage()" ng-disabled="$ctrl.viewerState.page == 1"><i class="icon-triangle-up"></i></div></div><div class="btn-group"><div class="btn btn-default" title="{{::(&quot;document_nav.zoom_out&quot; | i18n)}}" ng-click="$ctrl.zoomOut()"><i class="icon-minus"></i></div><div class="btn btn-default" title="{{::(&quot;document_nav.zoom_in&quot; | i18n)}}" ng-click="$ctrl.zoomIn()"><i class="icon-plus"></i></div></div><div class="btn-group"><a class="btn btn-default btn-add-note" ng-if="$ctrl.annotationsEnabled" ng-click="$ctrl.toggleAddNote()" title="{{::(&quot;document_nav.add_note&quot; | i18n)}}" ng-class="{active: $ctrl.addNoteActive}"><i class="ic-edit icon-edit" ng-class="{&quot;animated pulse infinite&quot;: $ctrl.addNoteActive}"></i></a><a class="btn btn-default visible-xs-block" ng-click="$ctrl.toggleSearch()" title="{{::(&quot;document_nav.search&quot; | i18n)}}"><i class="icon-magnifying-glass"></i></a></div><div class="btn-group"><a class="btn btn-default" ng-if="$ctrl.sharingEnabled" ng-click="$ctrl.share()" title="{{::(&quot;general.download&quot; | i18n)}}"><i class="icon-download ic-download"></i></a></div></div><div class="nav-document-pdf-container" ng-show="!$ctrl.pdfLoading"><div class="nav-document-pdf-viewer pdfViewer" ng-class="{&quot;nav-document-add-annotation&quot;: $ctrl.addNoteActive}"></div></div></div>';
},{}],189:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DocumentNavModule = void 0;
var _documentNav = require("./document-nav.component");
var DocumentNavModule = angular.module('maestro.components.navs.document', []).component('documentNav', _documentNav.DocumentNavComponent).name;
exports.DocumentNavModule = DocumentNavModule;

},{"./document-nav.component":187}],190:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListNavModule = void 0;
var _listNav = require("./list-nav.component");
var ListNavModule = angular.module('maestro.components.navs.list', []).component('listNav', _listNav.ListNavComponent).name;
exports.ListNavModule = ListNavModule;

},{"./list-nav.component":191}],191:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListNavComponent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _lodash = require("lodash");
var _filtering = require("../../common/filtering");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = (0, _getPrototypeOf2.default)(t); if (r) { var s = (0, _getPrototypeOf2.default)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0, _possibleConstructorReturn2.default)(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var PAGE_SIZE = 52;
var ListNavComponent = {
  bindings: {
    config: '<'
  },
  template: require('./list-nav.jade'),
  controller: function (_FilteringController) {
    ListNavComponent.$inject = ["NAV_TEMPLATES", "PID", "THEME", "EID", "$timeout", "navService", "metaService", "metricsService", "progressBarService", "paginatorFactory", "$scope", "$eventBus", "$q", "dataSourceEvaluatorService", "$i18n", "$popover", "$http"];
    (0, _inherits2.default)(ListNavComponent, _FilteringController);
    var _super = _createSuper(ListNavComponent);
    /* @ngInject */
    function ListNavComponent(NAV_TEMPLATES, PID, THEME, EID, $timeout, navService, metaService, metricsService, progressBarService, paginatorFactory, $scope, $eventBus, $q, dataSourceEvaluatorService, $i18n, $popover, $http) {
      var _this;
      (0, _classCallCheck2.default)(this, ListNavComponent);
      _this = _super.call(this, THEME, EID, $q, $popover, $i18n, $http, dataSourceEvaluatorService);
      _this.navTemplates = NAV_TEMPLATES;
      _this.pid = PID;
      _this.theme = THEME;
      _this.$timeout = $timeout;
      _this.navService = navService;
      _this.metaService = metaService;
      _this.metricsService = metricsService;
      _this.progressBarService = progressBarService;
      _this.paginator = null;
      _this.paginatorFactory = paginatorFactory;
      _this.elementIds = {};
      _this.loading = false;
      _this.$eventBus = $eventBus;
      _this.searchQuery = '';
      _this.selectedFilters = [];
      $scope.$on('bottom-reached', function () {
        return _this.nextPage();
      });
      _this.listeners = [];
      return _this;
    }
    (0, _createClass2.default)(ListNavComponent, [{
      key: "$onInit",
      value: function $onInit() {
        var _this2 = this;
        var config = this.config;
        console.log('[ListNavComponent] init', config);
        if (config.remote_ds) {
          config.ds = {
            type: 'remote',
            source: {
              path: config.remote_ds.path
            },
            paginate: true
          };
          this.searchEnabled = config.remote_ds_filters && config.remote_ds_filters.search;
          this.paginator = this.paginatorFactory({
            pageSize: config.remote_ds.page_size || PAGE_SIZE,
            buildQueryParams: function buildQueryParams(nextStartKey) {
              if (nextStartKey && nextStartKey.bookmark) {
                return {
                  bookmark: nextStartKey.bookmark
                };
              }
              return _this2.getInflateNavParams();
            }
          });
        } else {
          this.paginator = this.paginatorFactory({
            pageSize: config.ds.page_size || PAGE_SIZE
          });
        }
        config.ds.elements = (0, _lodash.isArray)(config.ds.elements) ? config.ds.elements : [];
        this.paginator.reset();
        this.reloadNav();
        this.selectedFilters = this.filters;
        this.getFilters();
        this.performRowActions = this.navService.mergeAndPerformRowActions(config.actions, config.nuid);
        if (config.no_content) {
          this.performNoContentActions = function () {
            return _this2.navService.performActions(config.no_content.actions, config.nuid);
          };
        }
        var unsub = this.navService.subscribeToEvents(this.navService.flattenNotificationMap(this.config.ds.reload_on), this.reset.bind(this));
        var notificationUnsub = this.$eventBus.on('notification:in-app', function (config) {
          if ((0, _lodash.get)(config, 'action.params.conversation_id')) {
            _this2.reset();
          }
        });
        this.listeners.push(unsub, notificationUnsub);
      }
    }, {
      key: "$onDestroy",
      value: function $onDestroy() {
        var _iterator = _createForOfIteratorHelper(this.listeners),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var unsubscribe = _step.value;
            if ((0, _lodash.isFunction)(unsubscribe)) {
              unsubscribe();
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }, {
      key: "reset",
      value: function reset(data) {
        console.log('[ListNavComponent] reload', data);
        this.paginator.reset();
        this.elementIds = {};
        this.config.ds.elements.splice(0, this.config.ds.elements.length);
        this.reloadNav();
      }
    }, {
      key: "reload",
      value: function reload() {
        this.reset();
      }
    }, {
      key: "filterAndAppendElements",
      value: function filterAndAppendElements(elements) {
        var _this3 = this;
        if (!elements) return;
        elements = (0, _lodash.filter)(elements, function (_ref) {
          var _id = _ref._id;
          return _this3.elementIds[_id] ? false : _this3.elementIds[_id] = true;
        });
        elements.forEach(function (e) {
          var type = (0, _lodash.get)(e, 'render.row_type');
          if (type === 'person_row') {
            var mapping = (0, _lodash.get)(e, 'render.params.mapping');
            mapping.mode = _this3.config.use_grid_layout ? 'large' : '';
          }
        });
        Array.prototype.push.apply(this.config.ds.elements, elements);
      }
    }, {
      key: "performAction",
      value: function performAction(button) {
        console.log('Button: ', button);
        return this.navService.performActions(button, this.config.nuid);
      }
    }, {
      key: "reloadNav",
      value: function reloadNav() {
        var _this4 = this;
        if (this.config.ds.paginate !== false) {
          return this.nextPage();
        }
        this.loading = true;
        this.progressBarService.startTask();
        this.navService.inflateNav(this.config, {}).then(function (resp) {
          if (!resp) return;
          _this4.elementIds = {};
          _this4.config.ds.elements.splice(0, _this4.config.ds.elements.length);
          _this4.$timeout(function () {
            return _this4.filterAndAppendElements(resp.elements);
          });
        }).finally(function () {
          return _this4.finishLoading();
        });
      }
    }, {
      key: "nextPage",
      value: function nextPage(optimalCount) {
        var _this5 = this;
        if (optimalCount) {
          this.paginator.setPageSize(optimalCount);
        }
        if (!this.paginator.hasMorePages()) {
          return this.finishLoading();
        }
        if (this.loading) {
          return;
        }
        this.loading = true;
        this.progressBarService.startTask();
        this.navService.inflatePaginatedNav(this.config, {}, this.paginator).then(function (resp) {
          if (!resp) return;
          return _this5.filterAndAppendElements(resp.elements);
        }).finally(function () {
          return _this5.finishLoading();
        });
      }
    }, {
      key: "getInflateNavParams",
      value: function getInflateNavParams() {
        var params = {
          search: encodeURIComponent(this.searchQuery)
        };
        (0, _lodash.each)(this.selectedFilters, function (filter) {
          params[filter.field] = filter.value.map(encodeURIComponent).join();
        });
        return params;
      }
    }, {
      key: "finishLoading",
      value: function finishLoading() {
        this.progressBarService.finishTask();
        this.loading = false;
      }
    }, {
      key: "onApplyInlineFilters",
      value: function onApplyInlineFilters(filtersApplied) {
        if (filtersApplied === 'cleared') {
          this.searchQuery = '';
          this.clearFilters();
        } else {
          this.selectedFilters = (0, _lodash.isArray)(filtersApplied) ? filtersApplied : [];
        }
        this.reset();
      }
    }, {
      key: "onSearchQueryChange",
      value: function onSearchQueryChange() {
        console.log('[ListNavComponent] onSearchQueryChange', this.searchQuery);
        this.reset();
      }
    }]);
    return ListNavComponent;
  }(_filtering.FilteringController)
};
exports.ListNavComponent = ListNavComponent;

},{"../../common/filtering":86,"./list-nav.jade":192,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/getPrototypeOf":380,"@babel/runtime/helpers/inherits":381,"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/helpers/possibleConstructorReturn":387,"lodash":"lodash"}],192:[function(require,module,exports){
module.exports = '<nav class="nav-wrapper"><div class="container-fluid no-gutters" theme="::$ctrl.theme" nav-id="{{::$ctrl.config._id}}"><div class="row"><nav-header label="::$ctrl.config.title" parent-nav-id="::$ctrl.config.nuid" actions="::$ctrl.config.nav_bar_actions" toolbar="::$ctrl.config.toolbar_menu"></nav-header></div><div class="row"><empty-state config="$ctrl.config" ng-if="!$ctrl.loading &amp;&amp; !$ctrl.config.ds.elements.length" transclude="true"><button class="btn btn-default nav-list-no-content-btn" ng-if="$ctrl.config.no_content.button_text &amp;&amp; $ctrl.config.no_content.actions.length" ng-click="$ctrl.performNoContentActions()">{{::($ctrl.config.no_content.button_text | i18n)}}</button></empty-state><div ng-if="$ctrl.config.ds.elements.length" ng-class="($ctrl.searchEnabled || $ctrl.filters.length) ? &quot;col-md-8&quot; : &quot;col-md-12&quot;"><div class="nav-content nav-list lazy-asset-grid" assets-in-bg="assets-in-bg"><div ng-class="{ &quot;grid-layout&quot;: $ctrl.config.use_grid_layout }"><div class="tile {{::row.render.params.mapping.img_scale_mode}}" ng-repeat="row in $ctrl.config.ds.elements track by row._id" on-repeat-done="checkAssets()" ng-class="{last: $last}" ng-include="$ctrl.navTemplates[row.render.row_type]"></div></div></div></div><div class="col-md-4 hidden-xs nav-sidebar" ng-if="$ctrl.searchEnabled || $ctrl.filters.length"><input class="search" ng-if="$ctrl.searchEnabled" type="text" ng-model="$ctrl.searchQuery" ng-model-options="{debounce: 500}" ng-change="$ctrl.onSearchQueryChange()" placeholder="{{::(&quot;general.search&quot; | i18n)}}"/><filtering ng-if="::($ctrl.filters)" filters="$ctrl.filters" selection="$ctrl.selectedFilters" on-apply-filters="$ctrl.onApplyInlineFilters(value)" search-query="$ctrl.searchQuery"></filtering></div></div></div></nav>';
},{}],193:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NewMeetingNavModule = void 0;
var _newMeetingNav = require("./new-meeting-nav.component");
var NewMeetingNavModule = angular.module('maestro.components.navs.new-meeting', []).component('newMeetingNav', _newMeetingNav.NewMeetingNavComponent).name;
exports.NewMeetingNavModule = NewMeetingNavModule;

},{"./new-meeting-nav.component":194}],194:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NewMeetingNavComponent = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _i18nWithFallback = _interopRequireDefault(require("../../../utils/i18n-with-fallback"));
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var NewMeetingNavComponent = {
  bindings: {
    config: '<'
  },
  template: require('./new-meeting-nav.pug'),
  controller: function () {
    NewMeetingNavComponent.$inject = ["progressBarService", "databaseService", "navService", "$scope", "$sheet", "$i18n", "THEME", "ACTIVATED_PERSON", "EVENT", "SETTINGS"];
    /* @ngInject */
    function NewMeetingNavComponent(progressBarService, databaseService, navService, $scope, $sheet, $i18n, THEME, ACTIVATED_PERSON, EVENT, SETTINGS) {
      (0, _classCallCheck2.default)(this, NewMeetingNavComponent);
      this.progressBarService = progressBarService;
      this.databaseService = databaseService;
      this.navService = navService;
      this.$scope = $scope;
      this.$sheet = $sheet;
      this.$i18n = $i18n;
      this.theme = THEME;
      this.actPerson = ACTIVATED_PERSON;
      this.event = EVENT;
      this.settings = SETTINGS;
      this.isEditMode = false;
      this.validatedOnce = false;
      this.locationSelectedOnce = false;
      this.reset();
    }
    (0, _createClass2.default)(NewMeetingNavComponent, [{
      key: "$onInit",
      value: function $onInit() {
        var _this = this;
        var config = this.config;
        console.log('[NewMeetingNavComponent] init', config);
        this.participants_ds = this.config.participants_list.ds;
        this.durations = [this.duration];
        config.durations_list.ds.source.forEach(function (d) {
          var enabled = (0, _lodash.get)(_this.settings, 'meetings.allowed-durations.' + d.duration, true);
          if (enabled) {
            _this.durations.push({
              label: d.title,
              value: d.duration
            });
          }
        });
        this.datePickerConfig = {};
        var timeInterval = (0, _lodash.get)(this.settings, 'meetings.time_interval');
        if (timeInterval) {
          timeInterval = Number.parseInt(timeInterval) / 60;
        } else {
          timeInterval = 30;
        }
        if (timeInterval < 60) {
          this.datePickerConfig['minuteStep'] = timeInterval;
        } else {
          this.datePickerConfig['minView'] = 'hour';
        }
        this.$scope.$watch('$ctrl.title', function () {
          return _this.validate();
        });
        this.$scope.$watch('$ctrl.date', this.onDurationPaxOrDateChange.bind(this));
        this.$scope.$watch('$ctrl.duration', this.onDurationPaxOrDateChange.bind(this));
        this.$scope.$watch('$ctrl.participants', this.onDurationPaxOrDateChange.bind(this), true);
        this.$scope.$watch('$ctrl.showAllRooms', this.onRoomsVisibilityChange.bind(this));
        this.$scope.$watch('$ctrl.showAllTimeSlots', this.onTimeSlotVisibilityChange.bind(this));
        this.$scope.$watch('$ctrl.location', function (newVal) {
          _this.validate();
          if ((newVal || '').length) {
            _this.locationSelectedOnce = true;
            if (_this.meeting_location) {
              _this.meeting_location = null;
            }
          }
        });
        this.$scope.$watch('$ctrl.meeting_location', function (newVal) {
          _this.validate();
          if (newVal) {
            _this.locationSelectedOnce = true;
            if (_this.location) {
              _this.location = '';
            }
          }
        });
        this.$scope.$on('editParticipant', function (_event, participantId) {
          _this.upsertParticipant(_this.navService, _this.$i18n, {
            model_id: participantId
          });
        });
        this.participants = [];
        this.pax_suggestions = [];
        this.supportsBooking = 'get_available_locations' in this.config.actions;
        this.showCustomLocation = (0, _lodash.get)(this.settings, 'meetings.custom-location', true);
        this.externalAllowed = (0, _lodash.get)(this.settings, 'meetings.allow-external-invitees', false);
        this.searchParams = this.externalAllowed ? null : {
          excludeProspects: true
        };
        this.showAddExternalsButton = config.meetings_v4 && this.externalAllowed;
        this.disableValidateExternalEmail = config.meetings_v4 || !this.externalAllowed;
        this.showInternalNotes = config.meetings_v4;
        this.showDescription = this.showInternalNotes;
        this.showLegacyNotes = !this.showInternalNotes;
        var meeting_data = config.meeting_data;
        if (meeting_data) {
          this.isEditMode = true;
          this.title = meeting_data.title;
          this.participants = [].concat((0, _toConsumableArray2.default)(meeting_data.participants.filter(function (p) {
            var paxId = p._id || p.id;
            return paxId && paxId !== _this.actPerson._id;
          })), (0, _toConsumableArray2.default)((meeting_data.externals || []).map(function (e) {
            return {
              email: e
            };
          })));
          this.meeting_location = meeting_data.meeting_location;
          this.location = meeting_data.location;
          this.showLocation = this.location || this.meeting_location || this.duration && this.date && this.participants.length;
          this.date = new Date(meeting_data.start_time * 1000);
          this.dateByEventTimezone = null;
          var notesField = this.showLegacyNotes ? 'notes' : 'internal_notes';
          this[notesField] = meeting_data[notesField] || '';
          this.description = meeting_data.description;
          this.originalPaxes = (0, _lodash.clone)(meeting_data.participants);
          var duration = meeting_data.duration;
          if (duration) {
            this.duration = {
              label: duration.title,
              value: duration.duration
            };
          }
        } else {
          var _config$params;
          var startTs = (_config$params = config.params) !== null && _config$params !== void 0 && _config$params.startTs ? config.params.startTs * 1000 : Date.now();
          if (this.settings.date.timezone === 'event') {
            var dateStr = (0, _momentTimezone.default)(startTs).tz(this.event.timezone).format('YYYY-MM-DD HH:mm');
            startTs = _momentTimezone.default.tz(dateStr, _momentTimezone.default.tz.guess()).unix() * 1000;
          }
          var timeSteps = Number((0, _lodash.get)(this.settings, 'meetings.time_interval', '1800'));
          this.date = new Date(Math.ceil(startTs / 1000 / timeSteps) * timeSteps * 1000);
        }
        this.setHumanReadableDate(meeting_data || this.settings.date.timezone === 'device');
        this.listenToAddExternalParticipant = function (e) {
          _this.participants = _this.participants.filter(function (item) {
            var _item$_id, _e$detail$_id;
            return ((_item$_id = item._id) !== null && _item$_id !== void 0 ? _item$_id : item.id) !== ((_e$detail$_id = e.detail._id) !== null && _e$detail$_id !== void 0 ? _e$detail$_id : e.detail.id);
          });
          _this.participants.push(e.detail);
        };
        window.addEventListener('add-external-participant', this.listenToAddExternalParticipant);
      }
    }, {
      key: "$onDestroy",
      value: function $onDestroy() {
        console.info('[NewMeetingNavComponent] destroying');
        this.hideDatepicker();
        window.removeEventListener('add-external-participant', this.listenToAddExternalParticipant);
      }
    }, {
      key: "reset",
      value: function reset() {
        this.title = '';
        this.participants = [];
        this.rooms = [];
        this.visibleRooms = [];
        this.showAllRooms = false;
        this.showMoreVisible = false;
        this.showLessVisible = false;
        this.timeSlots = [];
        this.visibleTimeSlots = [];
        this.showAllTimeSlots = false;
        this.showMoreTsVisible = false;
        this.showLessTsVisible = false;
        this.location = '';
        this.date = new Date();
        this.dateByEventTimezone = null;
        this.duration = {};
        this.notes = '';
        this.description = '';
        this.internal_notes = '';
        this.setHumanReadableDate(true);
      }
    }, {
      key: "showDatepicker",
      value: function showDatepicker() {
        var _this2 = this;
        if (!this.datepickerIn) {
          angular.element('body').on('click.meet-datepicker', function (e) {
            var target = angular.element(e.target);
            if (target.is('input.date')) {
              return true;
            }
            if (target.closest('.date-picker').length === 0) {
              if (_this2.datepickerIn) {
                _this2.hideDatepicker(e);
              }
            }
          });
          this.datepickerIn = true;
        }
      }
    }, {
      key: "beforeRenderDatepicker",
      value: function beforeRenderDatepicker($dates) {
        var today = new Date();
        today.setUTCHours(0, 0, 0, 0);
        $dates.filter(function (date) {
          return !date.current && date.utcDateValue < today.getTime();
        }).forEach(function (date) {
          return date.selectable = false;
        });
      }
    }, {
      key: "hideDatepicker",
      value: function hideDatepicker(e) {
        this.datepickerIn = false;
        angular.element('body').off('click.meet-datepicker');
        if (e) {
          this.$scope.$apply();
        }
      }
    }, {
      key: "setHumanReadableDate",
      value: function setHumanReadableDate() {
        var isUTC = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var ts = this.date.getTime();
        if (!(0, _lodash.isNumber)(ts)) return;
        if (isUTC) {
          this.humanReadableDate = (0, _momentTimezone.default)(ts).format('LLLL');
        } else {
          var dateObj = {
            year: this.date.getFullYear(),
            month: this.date.getMonth(),
            day: this.date.getDate(),
            hour: this.date.getHours(),
            minute: this.date.getMinutes(),
            second: this.date.getSeconds()
          };
          var mDate = (0, _momentTimezone.default)(dateObj);
          this.humanReadableDate = mDate.format('LLLL');
          this.date = mDate.toDate();
          this.dateByEventTimezone = _momentTimezone.default.tz(mDate, this.event.timezone).toDate();
        }
        this.hideDatepicker();
      }
    }, {
      key: "validate",
      value: function validate() {
        var _this$$scope, _this$$scope$$ctrl;
        this.validatedOnce = true;
        var form = this.$scope.meetingForm;
        var participants = (_this$$scope = this.$scope) === null || _this$$scope === void 0 ? void 0 : (_this$$scope$$ctrl = _this$$scope.$ctrl) === null || _this$$scope$$ctrl === void 0 ? void 0 : _this$$scope$$ctrl.participants;
        var allParticipantsHaveEmails = participants ? participants === null || participants === void 0 ? void 0 : participants.filter(function (participant) {
          return participant.fp_type === 'prospect';
        }).every(function (participant) {
          return !!(participant !== null && participant !== void 0 && participant.email);
        }) : true;
        this.errors = {};
        form.title.$setValidity('required', true);
        form.participants.$setValidity('required', true);
        form.participants.$setValidity('valid', true);
        form.location.$setValidity('required', true);
        form.date.$setValidity('required', true);
        form.duration.$setValidity('required', true);
        if (!allParticipantsHaveEmails) {
          this.errors = _objectSpread(_objectSpread({}, this.errors), {}, {
            emailMissing: true
          });
          form.participants.$setValidity('valid', false);
        }
        if (this.title.trim().length === 0) {
          form.title.$setValidity('required', false);
        }
        if (this.participants.length === 0) {
          form.participants.$setValidity('required', false);
        }
        if (this.showLocation && !(this.location || '').trim().length && !this.meeting_location) {
          form.location.$setValidity('required', false);
        }
        if (this.date.value === 0) {
          form.date.$setValidity('required', false);
        }
        if (this.duration.value === 0) {
          form.duration.$setValidity('required', false);
        }
        return form.$valid;
      }
    }, {
      key: "buildData",
      value: function buildData() {
        var participants = this.participants.filter(function (p) {
          return p._id || p.id;
        }).map(function (p) {
          return p._id || p.id;
        });
        var externals = this.participants.filter(function (p) {
          return p.email;
        }).map(function (p) {
          return p.email;
        });
        var params = {
          title: this.title,
          participants: participants,
          externals: externals,
          location: this.location,
          meeting_location: this.meeting_location,
          start_ts: (this.dateByEventTimezone || this.date).getTime() / 1000,
          duration: this.duration.value,
          description: this.description,
          internal_notes: this.internal_notes
        };
        if (this.showLegacyNotes) {
          params.notes = this.notes;
        }
        if (this.isEditMode) {
          var meeting_data = this.config.meeting_data;
          params._id = meeting_data._id;
          params._rev = meeting_data._rev;
          params.excludedParticipants = [];
          var _iterator = _createForOfIteratorHelper(this.originalPaxes),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var pax = _step.value;
              if (!participants.includes(pax.id)) {
                params.excludedParticipants.push(pax.id);
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          params.timestamp = meeting_data.timestamp;
        }
        return params;
      }
    }, {
      key: "saveMeeting",
      value: function saveMeeting() {
        if (this.isEditMode) {
          return this.updateMeeting();
        } else {
          return this.createMeeting();
        }
      }
    }, {
      key: "updateMeeting",
      value: function updateMeeting() {
        this.save(this.config.actions.save.path);
      }
    }, {
      key: "createMeeting",
      value: function createMeeting() {
        this.save(this.config.actions.send_button.path);
      }
    }, {
      key: "save",
      value: function save(path) {
        var _this3 = this;
        if (!this.validate()) {
          return;
        }
        if (this.sending) return;
        this.sending = true;
        var params = this.buildData();
        this.progressBarService.startTask();
        this.databaseService.runAppScript(path, params).then(function (_ref) {
          var data = _ref.data;
          if (data.error) {
            _this3.handleSaveError(data.error);
          }
        }).finally(function () {
          _this3.progressBarService.finishTask();
          _this3.sending = false;
        });
      }
    }, {
      key: "handleSaveError",
      value: function handleSaveError(error) {
        var parsedResponse;
        try {
          parsedResponse = JSON.parse(error);
        } catch (err) {
          return this.navService.alert({
            title: 'general.error',
            message: 'newmeeting_nav.create.error'
          });
        }
        var form = this.$scope.meetingForm;
        this.errors = {};
        var errors = this.errors;
        Object.keys(parsedResponse).forEach(function (k) {
          if (k === 'start_ts') k = 'date';
          if (form.hasOwnProperty(k)) {
            form[k].$setValidity('required', false);
            errors[k] = parsedResponse[k];
          }
        });
      }
    }, {
      key: "deleteMeeting",
      value: function deleteMeeting($event) {
        var _this4 = this;
        $event.preventDefault();
        $event.stopPropagation();
        var message = (0, _i18nWithFallback.default)(this.$i18n, 'newmeeting_nav.delete_alert.message', 'Do you want to delete this meeting?');
        this.$sheet({
          title: message,
          pin: true,
          scrollable: false,
          prompt: true,
          actions: [{
            id: 'close',
            label: this.$i18n('general.dismiss'),
            action: function action(sheet) {
              return sheet.reject();
            }
          }, {
            id: 'delete',
            label: this.$i18n('newmeeting_nav.delete_button'),
            action: function action(sheet) {
              return sheet.accept();
            }
          }]
        }).then(function () {
          var url = (0, _lodash.get)(_this4, 'config.actions.send_button.path');
          if (url) {
            _this4.databaseService.runAppScript(url, {
              id: _this4.config.meeting_data._id
            });
          }
        }).finally(function () {
          _this4.$sheet.dismissAllSheets({
            applyNavs: true
          });
        });
      }
    }, {
      key: "representation",
      value: function representation(doc) {
        if (doc.email && !doc._id && !doc.id) {
          return doc.email.trim();
        }
        if (doc.full_name) {
          return doc.full_name;
        }
        return [doc.fname, doc.lname].join(' ').trim();
      }
    }, {
      key: "representationSub",
      value: function representationSub(doc) {
        if (doc.fp_type === 'prospect') {
          return this.$i18n('newmeeting_nav.external_invitee');
        }
      }
    }, {
      key: "onDurationPaxOrDateChange",
      value: (function () {
        var _onDurationPaxOrDateChange = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee() {
          return _regenerator.default.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (!(!this.date || !(0, _lodash.get)(this, 'duration.value') || !this.participants.length)) {
                  _context.next = 5;
                  break;
                }
                this.showLocation = false;
                this.meeting_location = null;
                _context.next = 9;
                break;
              case 5:
                _context.next = 7;
                return this.getRoomsAvailability();
              case 7:
                this.showLocation = true;
                this.validate();
              case 9:
              case "end":
                return _context.stop();
            }
          }, _callee, this);
        }));
        function onDurationPaxOrDateChange() {
          return _onDurationPaxOrDateChange.apply(this, arguments);
        }
        return onDurationPaxOrDateChange;
      }())
    }, {
      key: "getRoomsAvailability",
      value: (function () {
        var _getRoomsAvailability = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee2() {
          var _this5 = this;
          var _yield$this$databaseS, response;
          return _regenerator.default.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                if (this.supportsBooking) {
                  _context2.next = 2;
                  break;
                }
                return _context2.abrupt("return");
              case 2:
                _context2.prev = 2;
                this.loading = true;
                _context2.next = 6;
                return this.databaseService.runAppScript(this.config.actions.get_available_locations.path, {
                  meetingId: (0, _lodash.get)(this.config, 'meeting_data._id'),
                  timestamp: Math.round((this.dateByEventTimezone || this.date).getTime() / 1000),
                  duration: this.duration.value,
                  capacity: this.participants.length + 1
                });
              case 6:
                _yield$this$databaseS = _context2.sent;
                response = _yield$this$databaseS.data.response;
                if (!response.noLocations) {
                  _context2.next = 12;
                  break;
                }
                this.supportsBooking = false;
                this.meeting_location = null;
                return _context2.abrupt("return");
              case 12:
                this.rooms = response.availableRooms;
                this.showMoreVisible = this.rooms.length > 6;
                if (!this.rooms.find(function (room) {
                  return room._id === _this5.meeting_location;
                })) {
                  this.meeting_location = null;
                }
                if (response.availableTimeSlots && response.availableTimeSlots.length) {
                  this.timeSlots = response.availableTimeSlots.map(function (t) {
                    return {
                      start: _momentTimezone.default.unix(t.start_ts).format('LT'),
                      end: _momentTimezone.default.unix(t.end_ts).format('LT')
                    };
                  });
                  this.showMoreTsVisible = this.timeSlots.length > 6;
                } else {
                  this.timeSlots = [];
                }
                this.onRoomsVisibilityChange();
                this.onTimeSlotVisibilityChange();
                _context2.next = 24;
                break;
              case 20:
                _context2.prev = 20;
                _context2.t0 = _context2["catch"](2);
                console.error('[NewMeetingNavComponent] Could not load rooms availability', _context2.t0);
                this.rooms = [];
              case 24:
                _context2.prev = 24;
                this.loading = false;
                this.$scope.$applyAsync();
                return _context2.finish(24);
              case 28:
              case "end":
                return _context2.stop();
            }
          }, _callee2, this, [[2, 20, 24, 28]]);
        }));
        function getRoomsAvailability() {
          return _getRoomsAvailability.apply(this, arguments);
        }
        return getRoomsAvailability;
      }())
    }, {
      key: "selectRoom",
      value: function selectRoom(room) {
        this.meeting_location = room._id;
      }
    }, {
      key: "toggleAllRooms",
      value: function toggleAllRooms() {
        this.showAllRooms = !this.showAllRooms;
        this.showMoreVisible = !this.showAllRooms;
        this.showLessVisible = this.showAllRooms;
      }
    }, {
      key: "toggleAllTimeSlots",
      value: function toggleAllTimeSlots() {
        this.showAllTimeSlots = !this.showAllTimeSlots;
        this.showMoreTsVisible = !this.showAllTimeSlots;
        this.showLessTsVisible = this.showAllTimeSlots;
      }
    }, {
      key: "onRoomsVisibilityChange",
      value: function onRoomsVisibilityChange() {
        var visibleRooms = (0, _toConsumableArray2.default)(this.rooms);
        if (!this.showAllRooms) {
          visibleRooms.splice(6);
        }
        this.visibleRooms = visibleRooms;
      }
    }, {
      key: "onTimeSlotVisibilityChange",
      value: function onTimeSlotVisibilityChange() {
        var visibleSlots = (0, _toConsumableArray2.default)(this.timeSlots);
        if (!this.showAllTimeSlots) {
          visibleSlots.splice(6);
        }
        this.visibleTimeSlots = visibleSlots;
      }
    }, {
      key: "validateExternalEmail",
      value: function validateExternalEmail() {
        var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        if (input.match(/^[^@]+@[^@]+$/)) {
          return {
            email: input
          };
        }
        return false;
      }
    }, {
      key: "createNewParticipantLabel",
      value: function createNewParticipantLabel() {
        return (0, _i18nWithFallback.default)(this.$i18n, 'newmeeting_nav.add_external_participant', 'Add external participant');
      }
    }, {
      key: "upsertParticipant",
      value: function upsertParticipant(navService, $i18n, pageParams) {
        var isEditMode = pageParams !== undefined;
        navService.openNav({
          nav_id: 'nav_fstg',
          page_id: 'prospect',
          modal: true,
          scrollable: false,
          page_params: _objectSpread(_objectSpread({}, pageParams), {}, {
            cache: false
          }),
          title: (0, _i18nWithFallback.default)($i18n, !isEditMode ? 'newmeeting_nav.add_external_participant' : 'newmeeting_nav.edit_external_participant', !isEditMode ? 'Add external participant' : 'External participant'),
          _parent_nav_id: 'nav_newmeeting'
        });
      }
    }]);
    return NewMeetingNavComponent;
  }()
};
exports.NewMeetingNavComponent = NewMeetingNavComponent;

},{"../../../utils/i18n-with-fallback":359,"./new-meeting-nav.pug":195,"@babel/runtime/helpers/asyncToGenerator":375,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/defineProperty":378,"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/helpers/toConsumableArray":393,"@babel/runtime/regenerator":398,"lodash":"lodash","moment-timezone":"moment-timezone"}],195:[function(require,module,exports){
module.exports = '<div class="new-meeting"><form class="panel-form" ng-submit="$ctrl.saveMeeting()" name="meetingForm"><div class="form-container"><div class="form-group"><label>{{\'meetings.form_labels.title\' | i18n}}</label><input class="form-control" ng-model="$ctrl.title" type="text" name="title"/></div><label>{{\'meetings.form_labels.participants\' | i18n}} </label><suggestions documents="$ctrl.participants" ds="$ctrl.participants_ds" error="$ctrl.errors.participants" exclusions="[$ctrl.actPerson._id]" field-name="participants" allow-missing="$ctrl.disableValidateExternalEmail ? undefined : $ctrl.validateExternalEmail" representation="$ctrl.representation" representation-sub="$ctrl.representationSub" create-new-label="$ctrl.showAddExternalsButton ? $ctrl.createNewParticipantLabel() : undefined" create-new-action="$ctrl.showAddExternalsButton ? $ctrl.upsertParticipant : undefined" invalid="meetingForm.participants.$invalid" search-params="$ctrl.searchParams"></suggestions><div class="form-group"><label ng-class="{\'error-label\': meetingForm.date.$invalid}">{{\'meetings.form_labels.date\' | i18n}}</label><div class="date-picker-wrapper"><input class="form-control date" ng-value="$ctrl.humanReadableDate" type="text" name="date" ng-model="$ctrl.hrDate" ng-focus="$ctrl.showDatepicker()"/><i class="dateicon-calendar ic-calendar"></i></div><p class="error" ng-if="meetingForm.date.$invalid"><i class="ic-alert-triangle"></i>{{$ctrl.errors.date || \'meetings.validations.start_ts\' | i18n}}</p><div class="date-picker" ng-class="{\'in\': $ctrl.datepickerIn}"><datetimepicker data-ng-model="$ctrl.date" data-datetimepicker-config="$ctrl.datePickerConfig" before-render="$ctrl.beforeRenderDatepicker($dates)" on-set-time="$ctrl.setHumanReadableDate()"></datetimepicker></div></div><div class="form-group"><label ng-class="{\'error-label\': meetingForm.duration.$invalid}">{{\'meetings.form_labels.duration\' | i18n}}</label><div class="duration-picker-wrapper"><select class="form-control" ng-model="$ctrl.duration" name="duration" required="required" ng-options="item as (item.label | i18n) for item in $ctrl.durations track by item.value"></select><i class="ic-time"></i></div></div><div class="locations" ng-show="$ctrl.showLocation" ng-class="{invalid: meetingForm.location.$invalid &amp;&amp; $ctrl.locationSelectedOnce, \'only-custom\': !$ctrl.supportsBooking}"><h4 ng-show="$ctrl.supportsBooking">{{ \'newmeeting_nav.booking_title\' | i18n }}</h4><div class="rooms" ng-if="$ctrl.supportsBooking &amp;&amp; $ctrl.rooms.length"><div class="list"><div class="room" ng-repeat="room in $ctrl.visibleRooms track by room._id" ng-click="$ctrl.selectRoom(room)" ng-class="{selected: $ctrl.meeting_location === room._id}"><div class="title">{{ room.title }}<span class="capacity"> • {{ room.capacity }} {{ \'newmeeting_nav.capacity\' | i18n }}</span></div><div class="subtitle">{{ room.description }}</div></div></div><a class="more" ng-if="$ctrl.showMoreVisible" ng-click="$ctrl.toggleAllRooms()">{{ \'newmeeting_nav.show_more\' | i18n }}<i class="icon-chevron-down"></i></a><a class="less" ng-if="$ctrl.showLessVisible" ng-click="$ctrl.toggleAllRooms()">{{ \'newmeeting_nav.show_less\' | i18n }}<i class="icon-chevron-up"></i></a></div><div class="no-rooms" ng-if="$ctrl.supportsBooking &amp;&amp; !$ctrl.rooms.length &amp;&amp; !$ctrl.loading"><p class="error" ng-if="!$ctrl.visibleTimeSlots.length &amp;&amp; $ctrl.showCustomLocation"><i class="ic-alert-triangle"></i>{{ \'newmeeting_nav.no_locations_available\' | i18n }}</p><p class="error" ng-if="!$ctrl.visibleTimeSlots.length &amp;&amp; !$ctrl.showCustomLocation"><i class="ic-alert-triangle"></i>{{ \'newmeeting_nav.no_locations_available_no_custom\' | i18n }}</p><div class="time-slots" ng-if="$ctrl.visibleTimeSlots.length"><p>{{ \'newmeeting_nav.time_slots_available\' | i18n }}</p><ul><li class="slot" ng-repeat="slot in $ctrl.visibleTimeSlots">{{ slot.start }} - {{ slot.end }}</li></ul><a class="more" ng-if="$ctrl.showMoreTsVisible" ng-click="$ctrl.toggleAllTimeSlots()">{{ \'newmeeting_nav.show_more\' | i18n }}<i class="icon-chevron-down"></i></a><a class="less" ng-if="$ctrl.showLessTsVisible" ng-click="$ctrl.toggleAllTimeSlots()">{{ \'newmeeting_nav.show_less\' | i18n }}<i class="icon-chevron-up"></i></a></div></div><div class="custom-location" ng-show="$ctrl.showCustomLocation"><p class="small" ng-show="$ctrl.supportsBooking">{{ \'newmeeting_nav.booking_disclaimer\' | i18n }}</p><div class="form-group"><label ng-show="!$ctrl.supportsBooking">{{\'meetings.form_labels.location\' | i18n}}</label><input class="form-control" ng-model="$ctrl.location" type="text" name="location" placeholder="{{\'newmeeting_nav.location_field_placeholder\' | i18n}}"/></div><p class="error" ng-if="$ctrl.supportsBooking &amp;&amp; meetingForm.location.$invalid &amp;&amp; $ctrl.locationSelectedOnce"><i class="ic-alert-triangle"></i>{{$ctrl.errors.location || \'meetings.validations.location\' | i18n}}</p></div></div><div class="form-group" ng-if="$ctrl.showDescription"><label>{{\'meetings.form_labels.description\' | i18n}}</label><textarea class="form-control" ng-model="$ctrl.description" name="description" row="1"></textarea></div><div class="form-group" ng-if="$ctrl.showInternalNotes"><label>{{\'meetings.form_labels.internal_notes\' | i18n}}</label><textarea class="form-control" ng-model="$ctrl.internal_notes" name="internal_notes" row="1"></textarea></div><div class="form-group" ng-if="$ctrl.showLegacyNotes"><label>{{\'meetings.form_labels.legacy_notes\' | i18n}}</label><textarea class="form-control" ng-model="$ctrl.notes" name="notes" row="1"></textarea></div></div><div class="form-actions"><button class="btn btn-lg btn-primary" ng-if="!$ctrl.isEditMode" ng-disabled="meetingForm.$invalid || !$ctrl.validatedOnce || $ctrl.errors.emailMissing">{{\'meetings.form_labels.create_button\' | i18n}}</button><button class="btn btn-lg btn-danger" type="button" ng-if="$ctrl.isEditMode &amp;&amp; $ctrl.config.actions.send_button" ng-click="$ctrl.deleteMeeting($event)">{{\'newmeeting_nav.delete_button\' | i18n}}</button><button class="btn btn-lg btn-primary" ng-if="$ctrl.supportsBooking &amp;&amp; $ctrl.isEditMode" ng-disabled="meetingForm.$invalid || !$ctrl.validatedOnce">{{\'meetings.form_labels.save_button\' | i18n}}</button><button class="btn btn-lg btn-primary" ng-if="!$ctrl.supportsBooking &amp;&amp; $ctrl.isEditMode">{{\'meetings.edit_meeting\' | i18n}}</button></div></form></div>';
},{}],196:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NewMessageNavModule = void 0;
var _newMessageNav = require("./new-message-nav.component");
var NewMessageNavModule = angular.module('maestro.components.navs.new-message', []).component('newMessageNav', _newMessageNav.NewMessageNavComponent).name;
exports.NewMessageNavModule = NewMessageNavModule;

},{"./new-message-nav.component":197}],197:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NewMessageNavComponent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
var _uuid = require("uuid");
var NewMessageNavComponent = {
  bindings: {
    config: '<'
  },
  template: require('./new-message-nav.pug'),
  controller: function () {
    NewMessageNavComponent.$inject = ["ACTIVATED_PERSON", "dataSourceEvaluatorService", "progressBarService", "videoCallService", "databaseService", "$scope", "$http"];
    /* @ngInject */
    function NewMessageNavComponent(ACTIVATED_PERSON, dataSourceEvaluatorService, progressBarService, videoCallService, databaseService, $scope, $http) {
      (0, _classCallCheck2.default)(this, NewMessageNavComponent);
      this.actPerson = ACTIVATED_PERSON;
      this.ds = dataSourceEvaluatorService;
      this.progressBarService = progressBarService;
      this.videoCallService = videoCallService;
      this.databaseService = databaseService;
      this.$scope = $scope;
      this.$http = $http;
      this.sent = false;
    }
    (0, _createClass2.default)(NewMessageNavComponent, [{
      key: "$onInit",
      value: function $onInit() {
        console.info('[NewMessageNavComponent] init', this.config);
        this.participants_ds = this.config.participants_list.ds;
        if (this.config.recipients) {
          this.participants = this.config.recipients.map(function (r) {
            return r.value;
          });
        }
        if (this.config.message) {
          this.message = this.config.message;
        }
      }
    }, {
      key: "validate",
      value: function validate() {
        var form = this.$scope.chat;
        this.errors = {};
        form.participants.$setValidity('required', true);
        form.message.$setValidity('required', true);
        if (this.participants.length === 0) {
          form.participants.$setValidity('required', false);
        }
        if ((this.message || '').trim().length === 0) {
          form.message.$setValidity('required', false);
        }
        return form.$valid;
      }
    }, {
      key: "startChat",
      value: function startChat() {
        var _this = this;
        if (!this.validate()) {
          return;
        }
        if (this.sending) return;
        this.sending = true;
        this.videoCallService.createSession().then(function (sessionId) {
          var paxes = {};
          paxes[_this.actPerson._id] = [_this.actPerson.fname, _this.actPerson.lname].join(' ').trim();
          (0, _lodash.each)(_this.participants, function (p) {
            paxes[p._id] = [p.fname, p.lname].join(' ').trim();
          });
          var params = {
            brand_new: true,
            message: {
              _id: (0, _uuid.v4)(),
              body: _this.message,
              conversation_id: (0, _uuid.v4)(),
              session_id: sessionId,
              participants: paxes
            }
          };
          _this.progressBarService.startTask();
          _this.databaseService.runAppScript(_this.config.actions.send_button.path, params).then(function (_ref) {
            var data = _ref.data;
            if (data.status && data.status === 'error') {
              var form = _this.$scope.chat;
              _this.errors = {};
              Object.keys(data.response).forEach(function (k) {
                if (form.hasOwnProperty(k)) {
                  form[k].$setValidity('required', false);
                  _this.errors[k] = data.response[k];
                }
              });
            }
          }).finally(function () {
            _this.progressBarService.finishTask();
            _this.sending = false;
            _this.sent = true;
          });
        });
      }
    }, {
      key: "representation",
      value: function representation(doc) {
        return [doc.fname, doc.lname].join(' ').trim();
      }
    }]);
    return NewMessageNavComponent;
  }()
};
exports.NewMessageNavComponent = NewMessageNavComponent;

},{"./new-message-nav.pug":198,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"lodash":"lodash","uuid":1222}],198:[function(require,module,exports){
module.exports = '<div class="new-message"><form class="vibram" ng-submit="$ctrl.startChat()" name="chat"><suggestions disabled="$ctrl.sending" documents="$ctrl.participants" ds="$ctrl.participants_ds" max="$ctrl.config.max_users" error="$ctrl.errors.participants" exclusions="[$ctrl.actPerson._id]" field-icon="icon-users" field-name="participants" placeholder="newmessage_nav.message_to" autofocus="true" representation="$ctrl.representation"></suggestions><div class="form-group with-button"><i class="ic-align-left icon-align-left"></i><textarea class="form-control" enter-key="enter" on-submit="$ctrl.startChat()" name="message" ng-attr-placeholder="{{&quot;newmessage_nav.write_message&quot; | i18n}}" ng-model="$ctrl.message" ng-disabled="$ctrl.sending"></textarea><button class="btn btn-default btn-transparent" data-cue="chat-submit-message" ng-class="{sendPlane: $ctrl.sending, landPlane: !$ctrl.sending &amp;&amp; $ctrl.sent}"><i class="icon-paper-plane" title="{{&quot;general.send&quot; | i18n}}"></i></button></div></form></div>';
},{}],199:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NoteNavModule = void 0;
var _noteNav = require("./note-nav.component");
var NoteNavModule = angular.module('maestro.components.navs.note', []).component('noteNav', _noteNav.NoteNavComponent).name;
exports.NoteNavModule = NoteNavModule;

},{"./note-nav.component":200}],200:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NoteNavComponent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _lodash = require("lodash");
var AUTO_SAVE_INTERVAL = 15 * 1000;
var MAX_FILE_SIZE = 10000000;
var NoteNavComponent = {
  bindings: {
    config: '<'
  },
  template: require('./note-nav.jade'),
  controller: function () {
    NoteNavComponent.$inject = ["PID", "THEME", "$interval", "progressBarService", "databaseService", "navService", "dataSourceEvaluatorService", "$filter", "$scope", "$sheet", "$i18n"];
    /* @ngInject */
    function NoteNavComponent(PID, THEME, $interval, progressBarService, databaseService, navService, dataSourceEvaluatorService, $filter, $scope, $sheet, $i18n) {
      (0, _classCallCheck2.default)(this, NoteNavComponent);
      this.theme = THEME;
      this.loading = true;
      this.saving = false;
      this.note = {
        fp_type: 'note',
        fp_owner: PID,
        timestamp: (0, _momentTimezone.default)().unix(),
        body: null
      };
      this.annotationsNote = false;
      this.prevNoteBody = null;
      this.doc_id = null;
      this.autoSaveTimer = null;
      this.$interval = $interval;
      this.progressBarService = progressBarService;
      this.databaseService = databaseService;
      this.navService = navService;
      this.ds = dataSourceEvaluatorService;
      this.stripHTML = $filter('stripHTML');
      this.assetUrl = $filter('assetUrl');
      this.$scope = $scope;
      this.$sheet = $sheet;
      this.$i18n = $i18n;
    }
    (0, _createClass2.default)(NoteNavComponent, [{
      key: "$onInit",
      value: function $onInit() {
        var _this = this;
        var config = this.config;
        if (this.config.features) {
          (0, _lodash.extend)(this.config, this.config.features);
          delete this.config.features;
        }
        console.log('[NoteNavComponent] init', config);
        this.doc_id = config.doc_id;
        this.note.parent_doc_id = this.config.parent_doc_id;
        this.autoSaveInterval = config.autosave_interval * 1000 || AUTO_SAVE_INTERVAL;
        this.showParentPreview = this.note.parent_doc_id && !this.config.modal && !this.config.hide_session_link;
        this.performActions = function (actions) {
          _this.saveNote();
          return _this.navService.performActions(actions, config.nuid);
        };
        if (!this.config.allow_rich_media_text) {
          this.fetchNote();
        }
      }
    }, {
      key: "$onDestroy",
      value: function $onDestroy() {
        this.saveNote();
        this.$interval.cancel(this.autoSaveTimer);
      }
    }, {
      key: "setEditor",
      value: function setEditor(editor) {
        this.editor = editor;
        this.fetchNote();
      }
    }, {
      key: "addMedia",
      value: function addMedia() {
        var toolbar = this.editor.getModule('toolbar');
        toolbar.handlers.image.call(toolbar);
      }
    }, {
      key: "hasChangesToCommit",
      value: function hasChangesToCommit() {
        var currentBody = this.note.body;
        return (currentBody || this.prevNoteBody) && currentBody !== this.prevNoteBody;
      }
    }, {
      key: "saveNote",
      value: function saveNote() {
        var _this2 = this;
        var currentBody = this.note.body;
        if (this.saving || !this.hasChangesToCommit()) {
          return;
        }
        if (this.config.allow_rich_media_text) {
          this.encodeNote();
        }
        if (!this.config.allow_rich_media_text && this.note.rich_text_body) {
          console.warn('[NoteNavComponent] cannot save legacy note over a new note format', this.note);
          return;
        }
        console.log('[NoteNavComponent] saving note', this.note);
        var save = function save() {
          _this2.saving = true;
          _this2.progressBarService.startTask();
          if (_this2.config.allow_rich_media_text) {
            return _this2.databaseService.runAppScript(_this2.config.actions.save.path, _this2.data);
          } else {
            return _this2.databaseService.saveDoc(_this2.note);
          }
        };
        save().then(function (_ref) {
          var _ref$data = _ref.data,
            id = _ref$data.id,
            rev = _ref$data.rev;
          if (_this2.config.allow_rich_media_text) {
            return _this2.fetchNote();
          }
          _this2.prevNoteBody = currentBody;
          _this2.doc_id = id;
          _this2.note._id = id;
          _this2.note._rev = rev;
        }).finally(function () {
          _this2.progressBarService.finishTask()(_this2.saving = false);
        });
      }
    }, {
      key: "fetchNote",
      value: function fetchNote() {
        var _this3 = this;
        if (!this.doc_id) {
          this.loading = false;
          return;
        }
        var fetch = function fetch() {
          _this3.loading = true;
          _this3.progressBarService.startTask();
          if (_this3.config.get_from_ds) {
            return _this3.ds.eval(_this3.config.ds, {
              id: _this3.config.doc_id
            });
          } else {
            return _this3.databaseService.docWithId(_this3.doc_id);
          }
        };
        fetch().then(function (note) {
          _this3.note = note;
          if (_this3.config.get_from_ds) {
            _this3.decodeNote();
          }
          _this3.prevNoteBody = note.body;
          if (note.annotations && note.annotations.length) {
            _this3.annotationsNote = true;
            _this3.navService.openDocument({
              _id: note.parent_doc_id
            });
          }
          _this3.autoSaveTimer = _this3.$interval(function () {
            return _this3.saveNote();
          }, _this3.autoSaveInterval);
          _this3.getParentDoc();
        }).finally(function () {
          _this3.loading = false;
          _this3.progressBarService.finishTask();
        });
      }
    }, {
      key: "encodeNote",
      value: function encodeNote() {
        var _this4 = this;
        this.note.rich_text_body = [];
        if (!this.note.body) {
          return;
        }
        this.data = {};
        this.data.note = this.note;
        (0, _lodash.each)(this.note.body.ops, function (op, idx) {
          if (!op.insert) {
            return;
          }
          var block = {};
          if ((0, _lodash.isObject)(op.insert)) {
            block.type = Object.keys(op.insert)[0];
            var b64String = op.insert[block.type];
            if (b64String.indexOf('base64,') !== -1) {
              var ts = Math.round(Date.now() / 1000) + idx;
              var ctype = _this4.base64MimeType(b64String);
              block.timestamp = ts;
              block.content_type = ctype;
              block.media_key = 'media-' + ts;
              var b64data = (0, _lodash.last)(b64String.split('base64,'));
              _this4.data[block.media_key] = _this4.b64toFile(b64data, ctype, block.media_key);
              if (_this4.data[block.media_key].size > MAX_FILE_SIZE) {
                _this4.data[block.media_key] = null;
                _this4.showErrorPopup("Maximum file size allowed is ".concat(MAX_FILE_SIZE / 1000000, "MB."));
              }
            } else {
              block.id = _this4.mediaURLs[b64String].id;
              block.timestamp = _this4.mediaURLs[b64String].ts;
              block.url = b64String;
            }
          } else {
            block.type = 'text';
            block.text = _this4.stripHTML(op.insert);
          }
          _this4.note.rich_text_body.push(block);
        });
        delete this.note.body;
      }
    }, {
      key: "decodeNote",
      value: function decodeNote() {
        var _this5 = this;
        var contents = [];
        this.note.body = this.note.body || {};
        this.mediaURLs = {};
        (0, _lodash.each)(this.note.rich_text_body, function (item) {
          if (item.type === 'text') {
            contents.push({
              insert: _this5.stripHTML(item.text)
            });
          } else {
            contents.push({
              insert: {
                image: _this5.assetUrl(item.url)
              }
            });
            _this5.mediaURLs[_this5.assetUrl(item.url)] = {
              ts: item.timestamp,
              id: item.id
            };
          }
        });
        requestAnimationFrame(function () {
          console.info('[NoteNavComponent] Setting contents', contents);
          _this5.editor.setContents(contents, 'api');
        });
      }
    }, {
      key: "getParentDoc",
      value: function getParentDoc() {
        var _this6 = this;
        var parentId = this.config.parent_doc_id || this.note.parent_doc_id;
        console.log('[NoteNavComponent] getting note parent doc', parentId);
        if (!parentId || !this.config.parentDocDs) {
          return;
        }
        this.databaseService.runAppScript(this.config.parentDocDs.source, {
          id: parentId
        }).then(function (_ref2) {
          var response = _ref2.data.response;
          return _this6.parentDoc = response;
        });
      }
    }, {
      key: "base64MimeType",
      value: function base64MimeType(encoded) {
        var result = null;
        if (typeof encoded !== 'string') {
          return result;
        }
        var mime = encoded.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/);
        if (mime && mime.length) {
          result = mime[1];
        }
        return result;
      }
    }, {
      key: "b64toFile",
      value: function b64toFile(b64Data) {
        var contentType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        var filename = arguments.length > 2 ? arguments[2] : undefined;
        var sliceSize = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 512;
        var byteCharacters = atob(b64Data);
        var byteArrays = [];
        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);
          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }
          var byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }
        var blob = new File(byteArrays, filename, {
          type: contentType
        });
        return blob;
      }
    }, {
      key: "showErrorPopup",
      value: function showErrorPopup(message) {
        this.$sheet({
          title: this.$i18n('general.error'),
          message: message,
          pin: false,
          scrollable: false,
          prompt: true,
          actions: [{
            id: 'close',
            label: this.$i18n('general.close'),
            action: function action(sheet) {
              return sheet.reject();
            }
          }]
        });
      }
    }]);
    return NoteNavComponent;
  }()
};
exports.NoteNavComponent = NoteNavComponent;

},{"./note-nav.jade":201,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"lodash":"lodash","moment-timezone":"moment-timezone"}],201:[function(require,module,exports){
module.exports = '<nav class="nav-wrapper"><div class="nav-column nav-note" ng-class="{\'legacy\': !$ctrl.config.allow_rich_media_text}" theme="::$ctrl.theme" nav-id="{{::$ctrl.config._id}}"><nav-header ng-if="::(!$ctrl.config.modal)" label="::(&quot;section_title.note&quot; | i18n)" actions="::$ctrl.config.nav_bar_actions"><button class="btn btn-default btn-transparent action-button" ng-show="!$ctrl.saving &amp;&amp; !$ctrl.loading &amp;&amp; $ctrl.hasChangesToCommit()" ng-click="$ctrl.saveNote()"><i class="icon-check"></i></button><button class="btn btn-default btn-transparent action-button" ng-show="$ctrl.saving"><i class="icon-loader" ng-show="$ctrl.saving &amp;&amp; !$ctrl.loading"></i></button><button class="btn btn-default btn-transparent action-button" ng-if="::$ctrl.config.allow_rich_media_text" ng-click="$ctrl.addMedia()"><i class="icon-images"></i></button></nav-header><div class="nav-content"><div class="parent-preview" ng-if="$ctrl.showParentPreview" ng-click="$ctrl.performActions($ctrl.parentDoc.actions)"><i class="icon-attachment"></i><div class="nav-list-item-title" ng-bind="($ctrl.parentDoc.title || &quot;…&quot;)"></div><div class="nav-list-item-subtitle" ng-bind="($ctrl.parentDoc.subtitle || &quot;general.tap_to_view&quot;) | i18n">…</div></div><textarea class="camo" ng-if="!$ctrl.config.allow_rich_media_text &amp;&amp; !$ctrl.annotationsNote" ng-model="$ctrl.note.body" ng-class="{invisible: $ctrl.loading}" ng-attr-placeholder="{{::(&quot;general.write_down_notes&quot; | i18n)}}" autofocus="300"></textarea><ng-quill-editor class="editor" ng-if="$ctrl.config.allow_rich_media_text &amp;&amp; !$ctrl.annotationsNote" ng-class="{invisible: $ctrl.loading}" ng-model="$ctrl.note.body" format="object" placeholder="::(&quot;general.write_down_notes&quot; | i18n)" autofocus="300" on-editor-created="$ctrl.setEditor(editor)" sanitize="true"><ng-quill-toolbar><div><span class="ql-formats"><button class="ql-image"></button></span></div></ng-quill-toolbar></ng-quill-editor></div></div></nav>';
},{}],202:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScanNavModule = void 0;
var _scanNav = require("./scan-nav.component");
var ScanNavModule = angular.module('maestro.components.navs.scan', []).component('scanNav', _scanNav.ScanNavComponent).name;
exports.ScanNavModule = ScanNavModule;

},{"./scan-nav.component":203}],203:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScanNavComponent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
var UPDATE_INTERVAL = 25000;
var ScanNavComponent = {
  bindings: {
    config: '<'
  },
  template: require('./scan-nav.jade'),
  controller: function () {
    ScanNavComponent.$inject = ["NAV_TEMPLATES", "ACTIVATED_PERSON", "THEME", "$timeout", "$i18n", "$sheet", "progressBarService", "handlerService", "navService", "metricsService"];
    /* @ngInject */
    function ScanNavComponent(NAV_TEMPLATES, ACTIVATED_PERSON, THEME, $timeout, $i18n, $sheet, progressBarService, handlerService, navService, metricsService) {
      (0, _classCallCheck2.default)(this, ScanNavComponent);
      this.navTemplates = NAV_TEMPLATES;
      this.activatedPerson = ACTIVATED_PERSON;
      this.activatedPersonFullName = "".concat(ACTIVATED_PERSON.fname, " ").concat(ACTIVATED_PERSON.lname).trim();
      this.theme = THEME;
      this.$timeout = $timeout;
      this.$i18n = $i18n;
      this.$sheet = $sheet;
      this.progressBarService = progressBarService;
      this.handlerService = handlerService;
      this.navService = navService;
      this.metricsService = metricsService;
      this.newCardIsBeingPresented = false;
      this.updateTimeout = 0;
      this.firstUpdateDone = false;
      this.updateInProgress = false;
    }
    (0, _createClass2.default)(ScanNavComponent, [{
      key: "$onInit",
      value: function $onInit() {
        var config = this.config;
        console.log('[ScanNavComponent] init', config);
        this.showToolbarMenu = this.navService.showNavToolbarMenu(config.toolbar_menu);
        this.loading = true;
        this.config.ds.elements = [];
        this.updateNav();
      }
    }, {
      key: "$onDestroy",
      value: function $onDestroy() {
        this.updateTimeout && this.$timeout.cancel(this.updateTimeout);
      }
    }, {
      key: "presentNewCard",
      value: function presentNewCard(card) {
        var _this = this;
        if (this.newCardIsBeingPresented || this.$sheet.hasOpenSheets()) return;
        this.newCardIsBeingPresented = true;
        this.$sheet({
          title: this.$i18n('nav_scan.bcx.new-card'),
          templateUri: this.navTemplates.person_row,
          pin: false,
          scrollable: false,
          prompt: true,
          actions: [{
            id: 'view',
            label: 'View contact details',
            action: function action(sheet) {
              return sheet.accept();
            }
          }, {
            id: 'close',
            label: this.$i18n('general.dismiss'),
            action: function action(sheet) {
              return sheet.reject();
            }
          }],
          row: card
        }).then(function () {
          return _this.performRowActions(card);
        }).finally(function () {
          return _this.newCardIsBeingPresented = false;
        });
      }
    }, {
      key: "filterNewCards",
      value: function filterNewCards(cards) {
        var _this2 = this;
        return (0, _lodash.filter)(cards, function (card) {
          var currentCard = _this2.config.ds.elements.find(function (_ref) {
            var _id = _ref._id;
            return _id === card._id;
          });
          return !(0, _lodash.isEqual)(currentCard, card);
        });
      }
    }, {
      key: "updateNav",
      value: function updateNav() {
        var _this3 = this;
        if (this.updateInProgress) return;
        if (this.updateTimeout) {
          this.$timeout.cancel(this.updateTimeout);
        }
        if (!this.firstUpdateDone) this.progressBarService.startTask();
        this.updateInProgress = true;
        return this.navService.inflateNav(this.config, {
          cache: false
        }).then(function (_ref2) {
          var elements = _ref2.elements;
          if (!elements || !elements.length) {
            return;
          }
          _this3.config.ds.elements = elements.reverse();
          var newCards = _this3.filterNewCards(elements);
          if (_this3.firstUpdateDone && newCards.length === 1) {
            _this3.presentNewCard(newCards[0]);
          }
        }).finally(function () {
          if (!_this3.firstUpdateDone) _this3.progressBarService.finishTask();
          _this3.updateInProgress = false;
          _this3.firstUpdateDone = true;
          _this3.updateTimeout = _this3.$timeout(function () {
            return _this3.updateNav();
          }, UPDATE_INTERVAL + Math.round(Math.random() * 1000));
          _this3.adding = false;
        });
      }
    }, {
      key: "performRowActions",
      value: function performRowActions(row) {
        this.navService.openDocument({
          id: row._id
        }, {
          _parent_nav_id: this.config.nuid
        });
      }
    }]);
    return ScanNavComponent;
  }()
};
exports.ScanNavComponent = ScanNavComponent;

},{"./scan-nav.jade":204,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"lodash":"lodash"}],204:[function(require,module,exports){
module.exports = '<nav class="nav-wrapper nav-scan" nav-id="{{::$ctrl.config._id}}"><div class="container-fluid no-gutters"><div class="row"><div class="nav-header"><span>{{::($ctrl.config.title | i18n)}}</span><div class="nav-header-actions"><button class="btn btn-default btn-transparent action-button" ng-if="$ctrl.config.toolbar_menu" ng-click="$ctrl.showToolbarMenu($event)"><i class="icon-dots-three-horizontal"></i></button></div></div></div><div class="row"><div class="col-xs-12"><empty-state config="$ctrl.config" ng-if="!$ctrl.config.ds.elements.length"></empty-state><div class="nav-content lazy-asset-grid" assets-in-bg="assets-in-bg" ng-if="$ctrl.config.ds.elements.length"><div class="scanned-cards"><div class="groups-container animated fadeIn"><div class="group" ng-repeat="row in $ctrl.config.ds.elements track by row._id" on-repeat-done="checkAssets()"><div class="panel panel-default scanned-card"><div class="row-person media nav-list-item" ng-click="$ctrl.performRowActions(row)"><div class="media-left"><div class="media-object"><!-- Take the shape from the theme, if a theme exist. However, if there is no images in the mapping, then ignore the theme as we want always rounded initials.--><avatar object="row.render.params.mapping" shape="row.render.params.mapping.img &amp;&amp; row.render.params.theme &amp;&amp; row.render.params.theme.img &amp;&amp; row.render.params.theme.img.shape"></avatar><div class="chip-wrapper" ng-if="row.render.params.mapping.badge"><div class="chip" ng-bind="row.render.params.mapping.badge" ng-style="{\'background-color\': row.render.params.theme.img.badge_color, \'color\': row.render.params.theme.img.font_color}"></div></div></div></div><div class="media-body"><div class="nav-list-item-title" ng-if="row.render.params.mapping.title" ng-bind="row.render.params.mapping.title"></div><div class="nav-list-item-subtitle" ng-show="row.render.params.mapping.subtitle" ng-bind="row.render.params.mapping.subtitle"></div><div class="nav-list-item-subsubtitle" ng-show="row.render.params.mapping.position" ng-bind="row.render.params.mapping.position"></div></div></div></div></div></div></div></div></div></div></div></nav>';
},{}],205:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpotmanNavModule = void 0;
var _spotmanNav = require("./spotman-nav.component");
var SpotmanNavModule = angular.module('maestro.components.navs.spotman', []).component('spotmanNav', _spotmanNav.SpotmanNavComponent).name;
exports.SpotmanNavModule = SpotmanNavModule;

},{"./spotman-nav.component":206}],206:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpotmanNavComponent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
var _color = require("../../../utils/color");
var _menu = require("../../../utils/menu");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var VISIBILITY_SCRIPTS = ['morsel-simple-spotman-entry/visibility'];
var NO_SERVER_CALL = ['profile/row'];
var SpotmanNavComponent = {
  bindings: {
    config: '<'
  },
  template: require('./spotman-nav.jade'),
  controller: function () {
    SpotmanNavComponent.$inject = ["NAV_BAR_CONFIG", "NAV_TEMPLATES", "THEME", "$q", "$timeout", "$rootScope", "$eventBus", "navService", "databaseService", "progressBarService", "targetingService"];
    /* @ngInject */
    function SpotmanNavComponent(NAV_BAR_CONFIG, NAV_TEMPLATES, THEME, $q, $timeout, $rootScope, $eventBus, navService, databaseService, progressBarService, targetingService) {
      (0, _classCallCheck2.default)(this, SpotmanNavComponent);
      this.navBarConfig = NAV_BAR_CONFIG;
      this.navTemplates = NAV_TEMPLATES;
      this.theme = THEME;
      this.$q = $q;
      this.$timeout = $timeout;
      this.$rootScope = $rootScope;
      this.$eventBus = $eventBus;
      this.navService = navService;
      this.databaseService = databaseService;
      this.progressBarService = progressBarService;
      this.isSpotmanActive = false;
      this.searchFocused = false;
      this.hasGlobalActiveTasks = false;
      this.targetingService = targetingService;
      this.listeners = [];
    }
    (0, _createClass2.default)(SpotmanNavComponent, [{
      key: "$onInit",
      value: function $onInit() {
        var _this = this;
        console.log('[SpotmanNavComponent] init', this.config);
        var self = this;
        var dsEvaluators = {
          visible: function visible(ds, element) {
            console.log('[SpotmanNavComponent] evaluating row ds for key "visible"', ds);
            element.visible = false;
            var serial = self.$q.resolve();
            var run = function run() {
              serial = self.evalDs(serial, ds).then(function (_ref) {
                var response = _ref.data.response;
                return element.visible = response;
              });
            };
            run();
            self.subscribeToRowNotifications(ds.reload_on, run);
          },
          badge: function badge(ds, element) {
            console.log('[SpotmanNavComponent] evaluating row ds for key "badge"', ds);
            var serial = self.$q.resolve();
            var run = function run() {
              serial = self.evalDs(serial, ds).then(function (_ref2) {
                var response = _ref2.data.response;
                return element.badgeCount = response;
              });
            };
            run();
            self.subscribeToRowNotifications((ds.reload_on, run));
          }
        };
        var iconsColor = (0, _lodash.get)(this, 'theme.spotman.view.icon_color');
        var toolbColor = (0, _lodash.get)(this, 'theme.spotman.view.background_color');
        if (this.theme.editorV2Enabled) {
          this.iconsColor = iconsColor;
        } else if (iconsColor && toolbColor) {
          if (this.theme.get('appearance') === 'dark' && (0, _color.getLightFromHex)(iconsColor) < (0, _color.getLightFromHex)(toolbColor) || this.theme.get('appearance') !== 'dark' && (0, _color.getLightFromHex)(iconsColor) > (0, _color.getLightFromHex)(toolbColor)) {
            this.iconsColor = toolbColor;
          } else {
            this.iconsColor = iconsColor;
          }
        }
        var menuItems = this.config.ds.elements.filter(function (el) {
          return !el.is_in_nav_bar || (0, _lodash.get)(el, 'dataSources.visible') || el.row_type === 'profile_row';
        });
        var _iterator = _createForOfIteratorHelper(menuItems),
          _step;
        try {
          var _loop = function _loop() {
            var element = _step.value;
            if (_this.isDsValid(element.ds)) {
              console.log('[SpotmanNavComponent] evaluating row DS in compatibility mode', element.ds);
              _this.evalCompatDs(element);
              return "continue";
            }
            (0, _lodash.each)(element.dataSources, function (ds, key) {
              _this.isDsValid(ds) && (0, _lodash.isFunction)(dsEvaluators[key]) && dsEvaluators[key](ds, element);
            });
          };
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _ret = _loop();
            if (_ret === "continue") continue;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        this.$rootScope.$on('progress:activity', function (event, activity) {
          _this.hasGlobalActiveTasks = activity;
          if (!_this.$rootScope.$$phase) {
            _this.$rootScope.$apply();
          }
        });
        var navBarItems = this.config.ds.elements.filter(function (el) {
          return el.is_in_nav_bar;
        });
        this.$rootScope.$on('badges:updated', function (event, badgeNewValue) {
          var _iterator2 = _createForOfIteratorHelper(navBarItems),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var element = _step2.value;
              if (element._id === badgeNewValue._id) {
                element.badgeCount = badgeNewValue.value;
                break;
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        });
        var notificationInAppListener = this.$eventBus.on('notification:in-app', function () {
          var _iterator3 = _createForOfIteratorHelper(menuItems),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var item = _step3.value;
              (0, _menu.getItemBadge)(item, _this.databaseService, function (i, count) {
                return i.badgeCount = count;
              });
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        });
        this.listeners.push(notificationInAppListener);
      }
    }, {
      key: "$onDestroy",
      value: function $onDestroy() {
        var _iterator4 = _createForOfIteratorHelper(this.listeners),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var unsubscribe = _step4.value;
            if ((0, _lodash.isFunction)(unsubscribe)) {
              unsubscribe();
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      }
    }, {
      key: "toggleSpotman",
      value: function toggleSpotman() {
        if (this.isSpotmanActive) {
          return this.hideSpotman();
        } else {
          return this.showSpotman();
        }
      }
    }, {
      key: "showSpotman",
      value: function showSpotman() {
        this.isSpotmanActive = true;
        angular.element('body').addClass('menu-open');
      }
    }, {
      key: "hideSpotman",
      value: function hideSpotman($event) {
        if ($event && event.target.nodeName === 'INPUT') {
          return true;
        }
        this.isSpotmanActive = false;
        angular.element('body').removeClass('menu-open');
      }
    }, {
      key: "performActions",
      value: function performActions(actions, row) {
        this.$eventBus.emit('spotman:click', row);
        this.isSpotmanActive = false;
        this.navService.performActions(actions, this.config.nuid);
        this.hideSpotman();
      }
    }, {
      key: "$debounce",
      value: function $debounce(fn, time) {
        var _this2 = this;
        return (0, _lodash.debounce)(function () {
          return _this2.$timeout(fn);
        }, time);
      }
    }, {
      key: "subscribeToRowNotifications",
      value: function subscribeToRowNotifications(notifications, action) {
        this.listeners.push(this.navService.subscribeToEvents(this.navService.flattenNotificationMap(notifications), this.$debounce(action, 500)));
      }
    }, {
      key: "isDsValid",
      value: function isDsValid(ds) {
        return (0, _lodash.isObject)(ds) && ds.type === 'javascript' && (0, _lodash.isString)(ds.source.path);
      }
    }, {
      key: "evalDs",
      value: function evalDs(serial, ds) {
        var _this3 = this;
        var askTheServer = !NO_SERVER_CALL.includes(ds.source.path);
        if (VISIBILITY_SCRIPTS.includes(ds.source.path)) {
          askTheServer = this.targetingService.shouldAskTheServer(ds.source.params);
        }
        if (askTheServer) {
          return serial.then(function () {
            return _this3.databaseService.runAppScript(ds.source.path, ds.source.params);
          });
        } else {
          return serial.then(function () {
            return {
              data: {
                response: {
                  visible: _this3.targetingService.canUserSeeItem(ds.source.params)
                }
              }
            };
          });
        }
      }
    }, {
      key: "evalCompatDs",
      value: function evalCompatDs(element) {
        var _this4 = this;
        var serial = this.$q.resolve();
        var run = function run() {
          serial = _this4.evalDs(serial, element.ds).then(function (_ref3) {
            var response = _ref3.data.response;
            if (response.hasOwnProperty('badge')) {
              response.badgeCount = response.badge;
              delete response.badge;
            }
            angular.extend(element, response);
          });
        };
        run();
        this.subscribeToRowNotifications(element.ds.reload_on, run);
      }
    }]);
    return SpotmanNavComponent;
  }()
};
exports.SpotmanNavComponent = SpotmanNavComponent;

},{"../../../utils/color":354,"../../../utils/menu":362,"./spotman-nav.jade":207,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"lodash":"lodash"}],207:[function(require,module,exports){
module.exports = '<nav theme="::$ctrl.theme.spotman" nav-id="{{::$ctrl.config._id}}"><div class="visible-xs-block global-progress-bar-container"><div class="progress-bar global-progress-bar" ng-show="$ctrl.hasGlobalActiveTasks"><div class="bar"></div></div></div><div class="nav-spotman" ng-class="{active: $ctrl.isSpotmanActive || $ctrl.active}"><div class="hidden-xs global-progress-bar-container"><div class="progress-bar global-progress-bar" ng-show="$ctrl.hasGlobalActiveTasks"><div class="bar"></div></div></div><div class="nav-list"><div ng-repeat="row in ::$ctrl.config.ds.elements track by row._id" data-cue="row-{{::row._id}}" ng-include="$ctrl.navTemplates[row.row_type]"></div></div></div></nav>';
},{}],208:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProfileRowModule = void 0;
var _profileRow = require("./profile-row.component");
var ProfileRowModule = angular.module('maestro.components.rows.profile', []).component('profileRow', _profileRow.ProfileRowComponent).name;
exports.ProfileRowModule = ProfileRowModule;

},{"./profile-row.component":209}],209:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProfileRowComponent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
var ProfileRowComponent = {
  template: require('./profile-row.jade'),
  bindings: {
    config: '<'
  },
  controller: function () {
    ProfileRowComponent.$inject = ["ACTIVATED_PERSON", "EVENT", "THEME", "navService", "$scope", "$i18n"];
    /* @ngInject */
    function ProfileRowComponent(ACTIVATED_PERSON, EVENT, THEME, navService, $scope, $i18n) {
      var _this = this;
      (0, _classCallCheck2.default)(this, ProfileRowComponent);
      this.person = ACTIVATED_PERSON;
      this.photoRev = 1;
      this.paxFullName = ACTIVATED_PERSON._representation || "".concat(ACTIVATED_PERSON.fname, " ").concat(ACTIVATED_PERSON.lname);
      navService.on('activated-person:photo', function () {
        _this.photoRev++;
        _this.refreshImage();
      });
      this.performActions = function () {
        return navService.performActions(_this.config.actions, _this.config.nuid);
      };
      this.THEME = THEME;
      $scope.$watch('$ctrl.config', function () {
        _this.bannerUrl = (0, _lodash.get)(_this, 'config.ds.source.params.banner', null);
        _this.showPhoto = !(0, _lodash.get)(_this, 'config.ds.source.params.disable_user_photo');
        _this.refreshImage();
        _this.person.full_name = ACTIVATED_PERSON._representation || (0, _lodash.compact)([ACTIVATED_PERSON.fname, ACTIVATED_PERSON.lname]).join(' ');
        var subtitle = (0, _lodash.get)(_this, 'config.ds.source.params.subtitle') || 'eventName';
        switch (subtitle) {
          case 'nothing':
            _this.subtitle = '';
            break;
          case 'labelMyProfile':
            _this.subtitle = $i18n('section_title.my_profile');
            break;
          case 'eventName':
            _this.subtitle = EVENT.description.title.en;
            break;
          default:
            _this.subtitle = ACTIVATED_PERSON[subtitle] || EVENT.description.title.en;
        }
      }, true);
    }
    (0, _createClass2.default)(ProfileRowComponent, [{
      key: "refreshImage",
      value: function refreshImage() {
        this.person.photo = "".concat(this.person._id, "-photo/photo?_=").concat(this.photoRev);
        if (this.person.hasOwnProperty('_representation_image')) {
          this.person._representation_image = this.person.photo;
        }
      }
    }]);
    return ProfileRowComponent;
  }()
};
exports.ProfileRowComponent = ProfileRowComponent;

},{"./profile-row.jade":210,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"lodash":"lodash"}],210:[function(require,module,exports){
module.exports = '<style>.bg-wrapper {\n' +
'  background-color: {{ ::$ctrl.THEME.spotman.view.background_color }};\n' +
'  color: {{ ::$ctrl.THEME.spotman.view.font_color }};\n' +
'}\n' +
'\n' +
'.bg-wrapper .banner,\n' +
'.bg-wrapper .user-info .empty-avatar,\n' +
'.bg-wrapper .user-info .avatar > img {\n' +
'  background-color: {{ ::$ctrl.THEME.primary_color }};\n' +
'}\n' +
'\n' +
'.bg-wrapper .user-info .nav-list-item-title {\n' +
'  color: {{ ::$ctrl.THEME.get(\'navs.nav_spotman.profilerow_nav.title.font_color\') }};\n' +
'}\n' +
'\n' +
'.bg-wrapper .user-info .nav-list-item-subtitle {\n' +
'  color: {{ ::$ctrl.THEME.get(\'navs.nav_spotman.profilerow_nav.subtitle.font_color\') }};\n' +
'}\n' +
'</style><div class="bg-wrapper no-click-effect" ng-click="$ctrl.performActions()" ng-class="{&quot;with-bg&quot;: $ctrl.bannerUrl, &quot;no-actions&quot;: !$ctrl.config.actions.length}"><img class="banner" ng-if="$ctrl.bannerUrl" ng-src="{{$ctrl.bannerUrl | assetUrl}}"/><div class="user-info"><avatar ng-if="$ctrl.showPhoto" object="$ctrl.person" mode="important" watch="true"></avatar><div class="nav-list-item-title">{{$ctrl.person.full_name}}</div><div class="nav-list-item-subtitle">{{$ctrl.subtitle}}</div></div></div>';
},{}],211:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UniversalSearchRowModule = void 0;
var _universalSearchRow = require("./universal-search-row.component");
var UniversalSearchRowModule = angular.module('maestro.components.rows.universal-search', []).component('universalSearchRow', _universalSearchRow.UniversalSearchRowComponent).name;
exports.UniversalSearchRowModule = UniversalSearchRowModule;

},{"./universal-search-row.component":212}],212:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UniversalSearchRowComponent = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
var _memoizeAsync = _interopRequireDefault(require("../../../utils/memoizeAsync"));
var UniversalSearchRowComponent = {
  template: require('./universal-search-row.jade'),
  bindings: {
    config: '<',
    onFocus: '&',
    onBlur: '&',
    onActions: '&'
  },
  controller: function () {
    UniversalSearchRowComponent.$inject = ["NAV_TEMPLATES", "$timeout", "$q", "databaseService"];
    /* @ngInject */
    function UniversalSearchRowComponent(NAV_TEMPLATES, $timeout, $q, databaseService) {
      (0, _classCallCheck2.default)(this, UniversalSearchRowComponent);
      this.navTemplates = NAV_TEMPLATES;
      this.$timeout = $timeout;
      this.$q = $q;
      this.databaseService = databaseService;
      this.reset();
    }
    (0, _createClass2.default)(UniversalSearchRowComponent, [{
      key: "$onInit",
      value: function $onInit() {
        var _this = this;
        console.log('[UniversalSearchRow] init', this.config);
        var ds = (this.config.dataSources || {}).searchResults;
        this.visible = ds && ds.type === 'javascript' && (0, _lodash.isString)(ds.source.path);
        if (!this.visible) return console.warn('[UniversalSearchRow] malformed DS configuration', ds);
        var render = this.config.render;
        this.noResultsLabel = render.no_results;
        this.placeholderLabel = render.placeholder;
        this.renderGroupLabels = render.groups;
        this.execSearch = (0, _memoizeAsync.default)(function (term) {
          return _this.databaseService.runAppScript(ds.source.path, {
            term: term
          }).then(function (_ref) {
            var response = _ref.data.response;
            return response;
          });
        }, this.$q);
      }
    }, {
      key: "performSearch",
      value: function performSearch() {
        var _this2 = this;
        var term = (this.searchTerm || '').trim();
        if (!term || term.length < 3 || !this.execSearch) {
          if (!term || !term.length) {
            this.searchResults = [];
          }
          this.activity = false;
          return;
        }
        this.activity = true;
        this.execSearch(term).then(function (response) {
          return _this2.applyResults(response);
        }).finally(function () {
          return _this2.activity = false;
        });
      }
    }, {
      key: "applyResults",
      value: function applyResults(results) {
        this.searchResults = (0, _lodash.groupBy)(results, 'key');
        this.noResults = !results.length;
        this.activity = false;
      }
    }, {
      key: "wakeup",
      value: function wakeup($event) {
        return $event.which > 47 && !$event.altKey && !$event.ctrlKey && !$event.shiftKey && (this.activity = true);
      }
    }, {
      key: "focus",
      value: function focus() {
        this.searchFocused = true;
        this.onFocus();
      }
    }, {
      key: "reset",
      value: function reset() {
        this.searchFocused = false;
        this.searchTerm = '';
        this.searchResults = null;
        this.noResults = false;
      }
    }, {
      key: "close",
      value: function close() {
        this.reset();
        this.onBlur();
      }
    }, {
      key: "performActions",
      value: function performActions(actions) {
        this.onActions({
          actions: actions
        });
      }
    }, {
      key: "classNamesForBlock",
      value: function classNamesForBlock(_ref2) {
        var type = _ref2.block_type,
          _ref2$layout = _ref2.layout,
          layout = _ref2$layout === void 0 ? {} : _ref2$layout;
        return [type, "block-width-".concat(layout.width), "block-height-".concat(layout.height), 'animated'].join(' ');
      }
    }, {
      key: "templateUrlForBlock",
      value: function templateUrlForBlock(_ref3) {
        var block_type = _ref3.block_type;
        return this.navTemplates[block_type];
      }
    }]);
    return UniversalSearchRowComponent;
  }()
};
exports.UniversalSearchRowComponent = UniversalSearchRowComponent;

},{"../../../utils/memoizeAsync":361,"./universal-search-row.jade":213,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"lodash":"lodash"}],213:[function(require,module,exports){
module.exports = '<div class="nav-list-item row-universal-search no-click-effect" ng-if="::$ctrl.visible" ng-class="{&quot;search-focused&quot;: $ctrl.searchFocused}"><form class="input-group" ng-submit="$ctrl.performSearch()"><div class="search-placeholder" ng-show="!$ctrl.searchFocused">{{::($ctrl.placeholderLabel | i18n)}}</div><input class="camo" type="search" ng-attr-placeholder="{{($ctrl.searchFocused ? $ctrl.placeholderLabel : null) | i18n}}" ng-model="$ctrl.searchTerm" ng-model-options="{debounce: 500}" ng-focus="$ctrl.focus()" ng-keyup="$ctrl.wakeup($event)" ng-change="$ctrl.performSearch()" ng-trim="false"/><div class="input-group-addon btn btn-default btn-transparent no-click-effect" ng-click="$ctrl.close()"><i class="icon-cross hidden-xs"></i><span class="visible-xs-inline">{{::(\'general.cancel\' | i18n)}}</span></div></form><div class="progress-bar" ng-show="$ctrl.activity"><div class="bar"></div></div></div><div class="universal-search-results-overlay" ng-if="$ctrl.searchFocused"><small class="animated fadeIn" ng-show="$ctrl.noResults &amp;&amp; !$ctrl.activity">{{::($ctrl.noResultsLabel | i18n)}}</small><div ng-if="!$ctrl.noResults"><div class="animated fadeInDown row-search-result-group" ng-repeat="(group, rows) in $ctrl.searchResults"><div class="group-header" ng-bind="::($ctrl.renderGroupLabels[group] | i18n)" ng-class="{first: $first, last: $last}"></div><div class="block {{::$ctrl.classNamesForBlock(block)}}" ng-repeat="block in rows track by block.id" ng-include="::$ctrl.templateUrlForBlock(block)"></div></div></div></div>';
},{}],214:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _lodash = require("lodash");
LazyAssetGridDirective.$inject = ["$window", "$filter", "loadAssetImg", "EID", "$http"];
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/* @ngInject */
function LazyAssetGridDirective($window, $filter, loadAssetImg, EID, $http) {
  var assetUrl = $filter('assetUrl');
  var $$window = angular.element($window);
  var checkIfAssetsExist = function checkIfAssetsExist(assets) {
    var isExternalPath = function isExternalPath(path) {
      return /^(?:[^/]*\/\/.+|\/api)/.test(path);
    };
    var _partition = (0, _lodash.partition)(assets, function (_ref) {
        var _ref2 = (0, _slicedToArray2.default)(_ref, 1),
          path = _ref2[0];
        return isExternalPath(path);
      }),
      _partition2 = (0, _slicedToArray2.default)(_partition, 2),
      externals = _partition2[0],
      internals = _partition2[1];
    var _iterator = _createForOfIteratorHelper(externals),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = (0, _slicedToArray2.default)(_step.value, 2),
          path = _step$value[0],
          el = _step$value[1];
        loadAssetImg(el, path);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    assets = internals.filter(function (i) {
      return i[0] !== null;
    }).map(function (_ref3) {
      var _ref4 = (0, _slicedToArray2.default)(_ref3, 2),
        path = _ref4[0],
        el = _ref4[1];
      return [path.split('/')[0], {
        path: path,
        el: el
      }];
    });
    if (!assets.length) return;
    var ids = (0, _lodash.pluck)(assets, '0').join(',');
    $http.get("/api/v1/eid/".concat(EID, "/webapp/doc-list?ids=").concat(ids)).then(function (_ref5) {
      var data = _ref5.data;
      (0, _lodash.each)((data.rows || data.docs || []).reverse(), function (row, n) {
        var assetsToUpdate = (0, _lodash.filter)(assets, function (_ref6) {
          var _ref7 = (0, _slicedToArray2.default)(_ref6, 1),
            assetId = _ref7[0];
          return !row.error && (assetId === row.id || assetId === row._id);
        });
        (0, _lodash.each)(assetsToUpdate, function (_ref8) {
          var _ref9 = (0, _slicedToArray2.default)(_ref8, 2),
            _ref9$ = _ref9[1],
            el = _ref9$.el,
            path = _ref9$.path;
          if (path && path.length) {
            setTimeout(function () {
              return loadAssetImg(el, assetUrl(path));
            }, (n + 1) * 50);
          }
        });
      });
    });
  };
  var isAnyPartOfElementInViewport = function isAnyPartOfElementInViewport(el) {
    var rect = el.getBoundingClientRect();
    var windowHeight = window.innerHeight || document.documentElement.clientHeight;
    var windowWidth = window.innerWidth || document.documentElement.clientWidth;
    var vertInView = rect.top <= windowHeight && rect.top + rect.height >= 0;
    var horInView = rect.left <= windowWidth && rect.left + rect.width >= 0;
    return vertInView && horInView;
  };
  var link = function link(scope, elem, attrs) {
    var checkScroll = function checkScroll() {
      console.groupCollapsed('[LazyAssetGridDirective] checking grid', elem[0]);
      var assetQuery = '[lazy-background-asset-src], [lazy-asset-src]';
      var assetHeightAttr = attrs.assetsInBg ? 'clientHeight' : 'height';
      var assets = elem.find(assetQuery);
      console.log('Found %d assets', assets.length, assets);
      if (!assets.length) {
        console.groupEnd();
        return;
      }
      var gridOffset = elem.offset();
      var firstElInView = document.elementFromPoint(gridOffset.left + 1, gridOffset.top + 1);
      var firstAsset = $(firstElInView).find(assetQuery);
      var firstAssetIndex = firstAsset.length ? assets.index(firstAsset) : 0;
      console.log('Starting scan with', firstAssetIndex, firstAsset[0]);
      var firstInViewFound = false;
      var assetHeight = assets[0][assetHeightAttr];
      var assetsToCheck = assets.slice(firstAssetIndex);
      var assetsToLoad = [];
      for (var i = 0, n = assetsToCheck.length; i < n; i += 1) {
        var asset = assetsToCheck[i];
        if (asset.className.indexOf('asset-loaded') !== -1) {
          console.log('skipping an already loaded asset');
          continue;
        }
        var $asset = $(asset);
        var assetOffset = $asset.offset().top - assetHeight;
        if (assetOffset < 0) {
          console.warn('assetOffset < 0', asset);
        }
        var isInView = isAnyPartOfElementInViewport(asset);
        if (!firstInViewFound && isInView) {
          firstInViewFound = true;
        }
        if (!isInView && firstInViewFound) {
          console.log('Last element', asset);
          break;
        }
        if (!isInView) {
          continue;
        }
        var assetSrc = asset.getAttribute('lazy-background-asset-src') || asset.getAttribute('lazy-asset-src');
        assetsToLoad.push([assetSrc, $asset]);
      }
      console.log('Assets to load', assetsToLoad);
      console.groupEnd();
      if (assetsToLoad.length) checkIfAssetsExist(assetsToLoad);
    };
    var _checkScroll = (0, _lodash.debounce)(checkScroll, 500);
    elem.on('ready', _checkScroll);
    $$window.on('scroll', _checkScroll);
    $$window.on('resize assets:load', _checkScroll);
    scope.$on('$destroy', function () {
      $$window.off('scroll', _checkScroll);
      elem.off('ready', _checkScroll);
      $$window.off('resize', _checkScroll);
    });
    scope.checkAssets = _checkScroll;
  };
  return {
    restrict: 'C',
    priority: 0,
    link: link
  };
}
angular.module('maestro.directives').directive('lazyAssetGrid', LazyAssetGridDirective).directive('onErrorSrc', function () {
  return {
    link: function link(scope, element, attrs) {
      element.bind('error', function () {
        attrs.$set('src', 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACwAAAAAAQABAAACAkQBADs=');
        element.addClass('no-src');
      });
    }
  };
});

},{"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/helpers/slicedToArray":390,"lodash":"lodash"}],215:[function(require,module,exports){
"use strict";

angular.module('maestro.directives').directive('autofocus', ['$timeout', function ($timeout) {
  return {
    restrict: 'A',
    link: function link($scope, $element, attrs) {
      $timeout(function () {
        console.log('[autofocus]', $element[0]);
        $element[0].focus();
      }, parseInt(attrs.autofocus, 10) || 10);
    }
  };
}]);

},{}],216:[function(require,module,exports){
"use strict";

BlockAutoSliderDirective.$inject = ["$parse", "$interval"];
/* @ngInject */
function BlockAutoSliderDirective($parse, $interval) {
  return {
    restrict: 'AC',
    link: function link(scope, elem, attrs) {
      var autoSlidingInterval = $parse(attrs.blockAutoSlider)(scope);
      var updateInterval;
      var nextSlide = function nextSlide() {
        return scope.nextSlide();
      };
      var cancel = function cancel() {
        return $interval.cancel(updateInterval);
      };
      if (autoSlidingInterval > 0) {
        console.log('[BlockAutoSliderDirective] init', autoSlidingInterval);
        updateInterval = $interval(nextSlide, autoSlidingInterval * 1000);
        scope.$on('$destroy', cancel);
      }
    }
  };
}
angular.module('maestro.directives').directive('blockAutoSlider', BlockAutoSliderDirective);

},{}],217:[function(require,module,exports){
"use strict";

var _lodash = require("lodash");
ComponentLoaderDirective.$inject = ["$compile"];
/* @ngInject */
function ComponentLoaderDirective($compile) {
  return {
    restrict: 'E',
    scope: {
      component: '<',
      attrs: '<'
    },
    link: function link($scope, $element) {
      var componentName = $scope.component;
      var template = document.createElement(componentName);
      var attrs = $scope.attrs || {};
      (0, _lodash.each)(attrs, function (value, key) {
        return template.setAttribute(key, value);
      });
      $element.html($compile(template)($scope.$parent));
    }
  };
}
angular.module('maestro.directives').directive('componentLoader', ComponentLoaderDirective);

},{"lodash":"lodash"}],218:[function(require,module,exports){
"use strict";

function EnterKey() {
  var linker = function linker($scope, element) {
    console.info('[EnterKey] init', element);
    element.on('keydown', function (e) {
      if (e.key.toLowerCase() === $scope.submitKey && e.shiftKey) {
        element.val(element.val().trim());
      }
    }).on('keypress', function (e) {
      if (e.key.toLowerCase() === $scope.submitKey && !e.shiftKey) {
        $scope.onSubmit(e);
        $scope.$apply();
        element.focus();
        return false;
      }
    });
  };
  return {
    restrict: 'A',
    scope: {
      submitKey: '@enterKey',
      onSubmit: '&'
    },
    link: linker
  };
}
angular.module('maestro.directives').directive('enterKey', EnterKey);

},{}],219:[function(require,module,exports){
"use strict";

var GlobalTheme = /* @ngInject */function GlobalTheme(THEME) {
  return {
    link: function link(_$scope, $element) {
      $element.addClass('theme-v' + THEME.version);
      $element.addClass('link-style-' + (THEME.activeLinkStyle || 'background'));
      if (THEME.version === 2) {
        THEME.backgroundColor1 = '#F7F7F7';
        THEME.backgroundColor2 = '#DDDDDD';
        THEME.backgroundColor3 = '#FFFFFF';
        THEME.foregroundColor1 = '#7D8082';
        THEME.foregroundColor2 = '#7D8082';
      }
      var darkModeEnabled = THEME.get('appearance') === 'dark';
      $element.addClass(darkModeEnabled ? 'dark-mode' : 'light-mode');
      angular.element(document.head).append("<style id=\"global-colors\">\n:root {\n    --background-color-0: ".concat(THEME.toolbar.background_color, ";\n    --background-color-1: ").concat(THEME.backgroundColor1, ";\n    --background-color-2: ").concat(THEME.backgroundColor2, ";\n    --background-color-3: ").concat(THEME.backgroundColor3, ";\n    --background-color-4: ").concat(THEME.backgroundColor4 || '#f7f7f7', ";\n    --background-color-5: ").concat(THEME.backgroundColor5, ";\n    --contrast-color: ").concat(THEME.contrastColor || THEME.toolbar.background_color || '#2c3e50', ";\n    --foreground-color-0: ").concat(THEME.toolbar.font_color, ";\n    --foreground-color-1: ").concat(THEME.foregroundColor1, ";\n    --foreground-color-2: ").concat(THEME.foregroundColor2, ";\n}</style>"));
      if (THEME.version !== 3) {
        return;
      }
      angular.element(document.head).append("<style id=\"global-theme\">\n\nbody {\n    background-color: ".concat(THEME.backgroundColor4, ";\n    color: ").concat(THEME.foregroundColor1, ";\n}\n\napp-nav-bar .wrapper {\n    color: ").concat(THEME.foregroundColor1, ";\n    background-color: ").concat(THEME.backgroundColor3, ";\n}\n\nbody .panel,\nbody .panel.panel-default,\nbody .card-block,\nbody update-browser-box .content,\n.platform-web .fstg-block .panel.panel-default\n{\n    background-color: ").concat(THEME.backgroundColor3, ";\n    color: ").concat(THEME.foregroundColor1, ";\n    border-color: ").concat(THEME.backgroundColor2, ";\n}\n\n.dark-mode .block_common_edit_text .panel.panel-default {\n    border-color: #484D51;\n}\n\nselect, .select .options, .select .select-wrapper {\n    background-color: ").concat(THEME.backgroundColor3, ";\n    color: ").concat(THEME.foregroundColor1, ";\n    border-color: ").concat(THEME.backgroundColor2, ";\n}\n\n.select .options .option:hover {\n    background-color: ").concat(THEME.backgroundColor2, ";\n}\n\nbody update-browser-box .browser {\n    background-color: ").concat(THEME.backgroundColor1, ";\n}\n\nbody .panel.panel-default .extras {\n    color: ").concat(THEME.foregroundColor2, ";\n}\n\n.panel-default > .panel-heading {\n    color: ").concat(THEME.foregroundColor1, ";\n    border-color: ").concat(THEME.backgroundColor2, ";\n}\n\n.panel-footer {\n    background-color: ").concat(THEME.backgroundColor1, ";\n    color: ").concat(THEME.foregroundColor1, ";\n}\n\n.card-block .widget > div {\n    color: ").concat(THEME.foregroundColor1, ";\n}\n\n.row-separator {\n    background-color: ").concat(THEME.backgroundColor3, ";\n}\n\n.nav-header {\n    color: ").concat(THEME.foregroundColor2, ";\n}\n\n.nav-spotman {\n    color: ").concat(THEME.foregroundColor1, ";\n}\n\n.nav-list-item-subsubtitle {\n    color: ").concat(THEME.foregroundColor2, ";\n}\n\n.nav-list-item-title {\n    color: ").concat(THEME.foregroundColor1, ";\n}\n\nmaster-row .nav-list-item {\n    background-color: ").concat(THEME.backgroundColor1, ";\n}\n\n.nav-list-item-subtitle {\n    color: ").concat(THEME.foregroundColor2, ";\n}\n\ninput,\n.dark-mode input:disabled,\ntextarea,\n.form-control,\nform.vibram .form-control,\nform.vibram .form-control[disabled],\nform.vibram .form-control[readonly]\n{\n    color: ").concat(THEME.foregroundColor1, ";\n    background-color: ").concat(THEME.backgroundColor3, ";\n    border-color: ").concat(THEME.backgroundColor2, ";\n}\n\n.dark-mode input,\n.dark-mode textarea,\n.dark-mode .form-control,\n.dark-mode form.vibram .form-control,\n.dark-mode form.vibram .form-control[disabled],\n.dark-mode form.vibram .form-control[readonly]{\n    border-color: #484D51;\n}\n\nfiltering h5,\nfiltering .popover-footer\n{\n    border-color: ").concat(THEME.backgroundColor3, ";\n}\n\nfiltering .popover-footer {\n    background-color: transparent;\n}\n\nfiltering .tags .checkbox label {\n    background-color: transparent;\n    border-color: ").concat(THEME.contrastColor, ";\n}\n\nfiltering .tags .checkbox label:hover {\n    background-color: ").concat(THEME.backgroundColor3, ";\n}\n\nfiltering .tags .checkbox label .text {\n    color: ").concat(THEME.contrastColor, ";\n}\n\n.modal-content {\n    background-color: ").concat(THEME.backgroundColor3, ";\n}\n\n.modal-footer .btn.btn-default,\n.modal-footer,\n.modal-header\n{\n    border-color: ").concat(THEME.backgroundColor2, ";\n}\n\ninline-block-paginator.panel-footer {\n    border-color: ").concat(THEME.backgroundColor2, ";\n}\n\n.nav-note .parent-preview,\n.nav-list.nav-content\n{\n    background-color: ").concat(THEME.backgroundColor3, ";\n    border-color: ").concat(THEME.backgroundColor2, ";\n}\n\n.list-group-item {\n    background-color: ").concat(THEME.backgroundColor3, ";\n    border-color: ").concat(THEME.backgroundColor2, ";\n}\n\n.link-style-underline app-nav-bar .wrapper .item.active.inverse-bg-when-active {\n    border-bottom: solid 4px ").concat(THEME.contrastColor, ";\n    background-color: transparent !important;\n    border-radius: 0;\n    margin-bottom: 0;\n    padding-bottom: 6px;\n}\n\n.theme-v3 profile-row,\n#pip-wrapper video-call .onboarding,\n#pip-wrapper video-call > .video-wrapper {\n    border-color: ").concat(THEME.backgroundColor2, ";\n}\n\n.theme-v3 profile-row .user-info img {\n    border-color: ").concat(THEME.backgroundColor3, ";\n}\n\n.theme-v3 profile-row .bg-wrapper {\n    box-shadow: inset 0 60px ").concat(THEME.contrastColor, ";\n}\n\n.theme-v3 .bg-wrapper {\n    background-color: ").concat(THEME.backgroundColor3, ";\n    color: ").concat(THEME.foregroundColor1, ";\n}\n\n.theme-v3 .bg-wrapper .banner {\n    background-color: ").concat(THEME.backgroundColor3, ";\n}\n\n.theme-v3 .bg-wrapper .user-info .nav-list-item-title {\n    color: ").concat(THEME.foregroundColor1, ";\n}\n\n.theme-v3 .bg-wrapper .user-info .nav-list-item-subtitle {\n    color: ").concat(THEME.foregroundColor2, ";\n}\n\n.block_feed_comment .toolbar-actions .footer-post-actions-block  {\n    border-color: ").concat(THEME.backgroundColor2, ";\n}\n\n.block_feed_topic .footer-post-actions-block,\n.block_feed_topic .panel-body a\n{\n    color: ").concat(THEME.contrastColor, ";\n}\n\n.block_feed_topic .footer-post-actions-block {\n    border-color: ").concat(THEME.backgroundColor2, ";\n}\n\nfeed-reply-block {\n    color: ").concat(THEME.foregroundColor2, ";\n    border-color: ").concat(THEME.backgroundColor2, ";\n}\n\nfeed-post-attachments .attachment,\nfeed-post-attachments .attachment .media {\n    background-color: ").concat(THEME.backgroundColor2, ";\n}\n\nagenda-nav .nav-content {\n    color: ").concat(THEME.foregroundColor1, ";\n    background-color: ").concat(THEME.backgroundColor3, ";\n}\n\nagenda-nav .nav-content,\nagenda-calendar,\nagenda-calendar .item,\n.nav-list-item\n{\n    border-color: ").concat(THEME.backgroundColor2, ";\n}\n\n.btn.btn-default:hover, .active-bg-highlight:hover,\n.nav-spotman .nav-list-item:hover {\n    background-color: ").concat(THEME.backgroundColor5, ";\n}\n\nagenda-calendar .item.disabled {\n    color: ").concat(THEME.foregroundColor2, ";\n}\n\nagenda-calendar .item.selected {\n    background-color: ").concat(THEME.backgroundColor1, ";\n}\n\n.nav-scan .nav-content,\nagenda-nav .nav-sidebar .search\n{\n    color: ").concat(THEME.foregroundColor1, ";\n    background-color: ").concat(THEME.backgroundColor3, ";\n    border-color: ").concat(THEME.backgroundColor2, ";\n}\n\n.nav-scan .nav-content {\n    border: 1px solid ").concat(THEME.backgroundColor2, ";\n}\n\n.nav-note .editor {\n    background-color: ").concat(THEME.backgroundColor1, ";\n    border-color: ").concat(THEME.backgroundColor2, ";\n    color: ").concat(THEME.foregroundColor1, ";\n}\n\nbody .ql-editor.ql-blank::before {\n    color: ").concat(THEME.foregroundColor2, ";\n}\n\n.suggestions .documents,\n.suggestions .new-meeting .date-picker,\n.new-meeting .suggestions .date-picker,\n.modal.modal-sheet.menu .modal-footer .btn-group.btn-group-justified .btn-group .btn\n{\n    background-color: ").concat(THEME.backgroundColor1, ";\n    border-color: ").concat(THEME.backgroundColor2, ";\n    color: ").concat(THEME.foregroundColor1, ";\n}\n\n.modal.modal-sheet.menu .modal-footer .btn-group.btn-group-justified .btn-group .btn.btn-default:hover,\n.suggestions .documents .doc:hover\n{\n    background-color: ").concat(THEME.backgroundColor5, " !important;\n    color: ").concat(THEME.foregroundColor1, " !important;\n}\n\nconversation-nav .nav-content {\n    background-color: ").concat(THEME.backgroundColor3, ";\n    border-color: ").concat(THEME.backgroundColor2, " !important;;\n}\n\nconversation-nav .nav-footer {\n    background-color: ").concat(THEME.backgroundColor2, ";\n    border-color: ").concat(THEME.backgroundColor2, ";\n}\n\n.conversation-row.own .message {\n    background-color: ").concat(THEME.backgroundColor1, ";\n    color: ").concat(THEME.foregroundColor1, ";\n}\n\n.conversation-row .message {\n    background-color: ").concat(THEME.backgroundColor2, ";\n}\n\n.conversation-row .name {\n    color: ").concat(THEME.foregroundColor1, ";\n}\n\nchat-details, .chat-details, .invites {\n    background-color: ").concat(THEME.backgroundColor4, ";\n}\n\n.chat-details .action a {\n    color: ").concat(THEME.foregroundColor2, ";\n}\n\n.chat-details .action.highlight a {\n    color: ").concat(THEME.contrastColor, ";\n}\n\n.chat-details .action,\n.chat-details h3\n{\n    border-color: ").concat(THEME.backgroundColor2, ";\n}\n\n.nav-document-pdf-toolbar {\n    background-color: ").concat(THEME.backgroundColor1, ";\n}\n\n.ql-snow .ql-fill, .ql-snow .ql-stroke.ql-fill {\n    fill: ").concat(THEME.contrastColor, ";\n}\n\n.ql-snow .ql-stroke {\n    stroke: ").concat(THEME.contrastColor, ";\n}\n\ndiv[lazy-background-asset-src].asset-loaded,\ndiv[background-asset-src].asset-loaded {\n    background-color: transparent;\n}\n\n.new-meeting .suggestions .documents,\n.suggestions .new-meeting .documents,\n.new-meeting .date-picker {\n  background-color: ").concat(THEME.backgroundColor3, ";\n  border-color: ").concat(THEME.backgroundColor2, ";\n}\n\n.datetimepicker .disabled,\n.datetimepicker .disabled:hover {\n  color: ").concat(THEME.foregroundColor2, ";\n}\n\n.datetimepicker .minute:hover,\n.datetimepicker .hour:hover,\n.datetimepicker .day:hover,\n.datetimepicker .switch:hover,\n.datetimepicker .left:hover,\n.datetimepicker .right:hover {\n  background-color: ").concat(THEME.backgroundColor5, ";\n}\n\n.datetimepicker .current,\n.datetimepicker .current:hover,\n.datetimepicker .current.disabled,\n.datetimepicker .current.disabled:hover {\n  background-color: ").concat(THEME.backgroundColor2, ";\n}\n\n.datetimepicker .active,\n.datetimepicker .active:hover,\n.datetimepicker .active.disabled,\n.datetimepicker .active.disabled:hover,\n.datetimepicker .table > tbody > tr > td.active,\n.datetimepicker .table > tbody > tr > td.active.disabled,\n.datetimepicker .table > tbody > tr > td.active.disabled:hover {\n  background-color: ").concat(THEME.contrastColor, ";\n  color: ").concat(THEME.foregroundColor1, ";\n}\n\n.block-meeting {\n  background-color: ").concat(THEME.backgroundColor3, ";\n}\n\n.block-meeting section {\n  color: ").concat(THEME.foregroundColor2, ";\n}\n\n.block-meeting section .pax-list span {\n  border-color: ").concat(THEME.backgroundColor1, ";\n}\n\n.block-meeting section .pax-list span.initials {\n  color: ").concat(THEME.foregroundColor1, ";\n  background-color: ").concat(THEME.backgroundColor2, ";\n}\n\n.nav-votecomment .commenting textarea {\n  border-color: ").concat(THEME.backgroundColor1, ";\n}\n</style>"));
    }
  };
};
GlobalTheme.$inject = ["THEME"];
angular.module('maestro.directives').directive('globalTheme', GlobalTheme);

},{}],220:[function(require,module,exports){
"use strict";

var _lodash = require("lodash");
VendorFixes.$inject = ["$window"];
/* @ngInject */
function VendorFixes($window) {
  var forceRepaint = function forceRepaint(elem) {
    elem.style.display = 'none';
    elem.style.display = '';
  };
  var linker = function linker($scope, elements) {
    var body = angular.element($window.document.body);
    if (body.is('.mobile-safari')) {
      (0, _lodash.each)(elements, function (elem) {
        $scope.$on('fstg:page:loaded', function () {
          setTimeout(function () {
            console.debug('[VendorFixes] Forcing repaing on', elem);
            forceRepaint(elem);
          }, 3000);
        });
      });
    }
  };
  return {
    restrict: 'C',
    link: linker
  };
}
angular.module('maestro.directives').directive('navFstg', VendorFixes);

},{"lodash":"lodash"}],221:[function(require,module,exports){
"use strict";

var _lodash = require("lodash");
BannerRatioDirective.$inject = ["$window"];
var BANNER_RATIO = 20 / 5;

/* @ngInject */
function BannerRatioDirective($window) {
  return {
    restrict: 'C',
    link: function link(scope, elem) {
      var _adoptHeight;
      var adoptHeight = function adoptHeight() {
        var h = Math.floor(elem.width() / BANNER_RATIO);
        if (!h) {
          return _adoptHeight();
        }
        elem.height(h);
      };
      _adoptHeight = (0, _lodash.throttle)(adoptHeight, 500);
      var $$window = angular.element($window);
      $$window.bind('resize', _adoptHeight);
      scope.$on('$destroy', function () {
        return $$window.off('resize', _adoptHeight);
      });
      _adoptHeight();
    }
  };
}
angular.module('maestro.directives').directive('bannerRatio', BannerRatioDirective);

},{"lodash":"lodash"}],222:[function(require,module,exports){
"use strict";

var _color = require("../utils/color");
IconDirective.$inject = ["$filter", "$q"];
/* @ngInject */
function IconDirective($filter, $q) {
  var assetUrl = $filter('iconUrl');
  return {
    restrict: 'A',
    scope: {
      icon: '=',
      forceColor: '<'
    },
    link: function link(scope, elem) {
      scope.$watchGroup(['icon', 'forceColor'], function () {
        var icon = scope.icon,
          forceColor = scope.forceColor;
        if (!icon || !icon.length) return;
        if (icon.indexOf('icon-') === 0) {
          elem.addClass(icon);
          return;
        }
        var iconAsset = icon;
        if (iconAsset.indexOf('/') === -1) {
          iconAsset += '/file.png';
        }
        elem.addClass('asset-icon');
        var iconAssertUrl = assetUrl(iconAsset);
        if (forceColor) {
          return (0, _color.recolorize)(iconAssertUrl, forceColor, $q).then(function (recolorizedUrl) {
            return elem.css('background-image', "url('".concat(recolorizedUrl, "')"));
          });
        }
        elem.css('background-image', "url('".concat(iconAssertUrl, "')"));
      });
    }
  };
}
angular.module('maestro.directives').directive('icon', IconDirective);

},{"../utils/color":354}],223:[function(require,module,exports){
"use strict";

angular.module('maestro.directives', []);
require('./assetSrc');
require('./autofocus');
require('./blockAutoSlider');
require('./componentLoader');
require('./enterKey');
require('./globalTheme');
require('./hacks');
require('./homeBannerUtils');
require('./icon');
require('./interceptAppScriptLinks');
require('./layoutManager');
require('./nabShield');
require('./onBottomReached');
require('./preventContextMenu');
require('./repeatUtils');
require('./scroll-here');
require('./sheet');
require('./talking-indicator');
require('./theme');
require('./webappUiVersion');

},{"./assetSrc":214,"./autofocus":215,"./blockAutoSlider":216,"./componentLoader":217,"./enterKey":218,"./globalTheme":219,"./hacks":220,"./homeBannerUtils":221,"./icon":222,"./interceptAppScriptLinks":224,"./layoutManager":225,"./nabShield":226,"./onBottomReached":227,"./preventContextMenu":228,"./repeatUtils":229,"./scroll-here":230,"./sheet":231,"./talking-indicator":232,"./theme":233,"./webappUiVersion":234}],224:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
InterceptAppscriptLinksDirective.$inject = ["navService"];
/* @ngInject */
function InterceptAppscriptLinksDirective(navService) {
  return {
    restrict: 'A',
    link: function link(scope, elem) {
      console.log('[InterceptAppscriptLinksDirective] init', elem);
      var intercept = function intercept(e) {
        e.preventDefault();
        var _this$getAttribute$sp = this.getAttribute('href').split('://')[1].split('?'),
          _this$getAttribute$sp2 = (0, _slicedToArray2.default)(_this$getAttribute$sp, 2),
          path = _this$getAttribute$sp2[0],
          params = _this$getAttribute$sp2[1];
        params = decodeURIComponent(params);
        if (!params) return;
        try {
          params = JSON.parse(params);
        } catch (e) {
          console.error('[InterceptAppScriptLinks] invalid JSON', params, e);
          return;
        }
        console.log('[InterceptAppScriptLinks] intercepted', path, params);
        navService.runScript({
          path: path,
          params: params
        });
      };
      elem.on('click', 'a.appscript-link', intercept);
      scope.$on('$destroy', function () {
        return elem.off('click', 'a.appscript-link');
      });
    }
  };
}
angular.module('maestro.directives').directive('interceptAppscriptLinks', InterceptAppscriptLinksDirective);

},{"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/helpers/slicedToArray":390}],225:[function(require,module,exports){
"use strict";

var deprecate = function deprecate(a, b, c) {
  return console.warn('[LayoutManager] This module is deprecated, please advise.', a, b, c);
};
function VerticalLayoutDirective() {
  var link = deprecate;
  return {
    restrict: 'AC',
    priority: 0,
    link: link
  };
}
angular.module('maestro.layoutmanager', []).service('$layout', function () {
  return {
    update: deprecate
  };
});
angular.module('maestro.directives').directive('vLayout', VerticalLayoutDirective);

},{}],226:[function(require,module,exports){
"use strict";

angular.module('maestro.directives').directive('nabShield', [function () {
  return {
    restrict: 'A',
    link: function link($scope, $element) {
      $element.on('click.nabbing', '.nav-panels a[target="_blank"]', function (ev) {
        $('.nav-panels a[target="_blank"]').attr('rel', 'noopener noreferrer');
        ev.preventDefault();
        var newWindow = window.open(this.getAttribute('href'), 'noopener,noreferrer,');
        newWindow.opener = null;
      });
    }
  };
}]);

},{}],227:[function(require,module,exports){
"use strict";

var _lodash = require("lodash");
var SCROLL_THROTTLE_TIMEOUT = 120;
var BOTTOM_TRESHOLD = 600;
var DEFAULT_ITEM_HEIGHT = 70;
var OnBottomReachedDirective = /* @ngInject */function OnBottomReachedDirective($timeout, $window) {
  var $$window = $($window);
  var link = function link(scope, elem) {
    var scrollTarget = $$window;
    var itemHeight = 0;
    var checkScroll = function checkScroll() {
      var scrollPosition = window.innerHeight + window.pageYOffset;
      if (scrollPosition >= document.body.offsetHeight - BOTTOM_TRESHOLD) {
        if (!itemHeight) {
          itemHeight = elem.find('div:eq(0)').height() || 0;
        }
        var height = elem.height();
        $timeout(function () {
          return scope.onBottomReached({
            optimalCount: Math.round(height / (itemHeight || DEFAULT_ITEM_HEIGHT)) * 2
          });
        });
      }
    };
    var onScroll = (0, _lodash.throttle)(checkScroll, SCROLL_THROTTLE_TIMEOUT);
    scrollTarget.on('scroll', function (ev) {
      if (!elem.is(':visible')) return;
      onScroll(ev);
      var scrolledCallback = scope.scrolled && scope.scrolled();
      if ((0, _lodash.isFunction)(scrolledCallback)) {
        scrolledCallback.call(scope.$parent.$ctrl, window.pageYOffset === 0);
      }
    });
    scope.$on('$destroy', function () {
      return scrollTarget.off('scroll', onScroll);
    });
  };
  return {
    restrict: 'AC',
    scope: {
      onBottomReached: '&',
      scrolled: '&',
      scrollsInBody: '<'
    },
    link: link
  };
};
OnBottomReachedDirective.$inject = ["$timeout", "$window"];
angular.module('maestro.directives').directive('onBottomReached', OnBottomReachedDirective);

},{"lodash":"lodash"}],228:[function(require,module,exports){
"use strict";

function PreventContextMenuDirective() {
  return {
    restrict: 'A',
    link: function link(scope, elem) {
      elem.on('contextmenu', function (e) {
        return e.preventDefault();
      });
    }
  };
}
angular.module('maestro.directives').directive('preventContextMenu', [PreventContextMenuDirective]);

},{}],229:[function(require,module,exports){
"use strict";

function OnRepeatDoneDirective() {
  return {
    restrict: 'A',
    priority: 2,
    link: function link(scope, elem, attrs) {
      if (scope.$last) {
        scope.$parent.$$repeatDone = true;
        scope.$eval(attrs.onRepeatDone);
      }
    }
  };
}
function EmitPrependedItemsDirective() {
  return {
    restrict: 'A',
    priority: 1,
    link: function link(scope, elem) {
      if (scope.$parent.$$repeatDone && scope.$first) {
        scope.$prepended = true;
        scope.$emit('itemPrepended', elem);
      }
    }
  };
}
function EmitAppendedItemsDirective() {
  return {
    restrict: 'A',
    priority: 1,
    link: function link(scope, elem) {
      if (scope.$parent.$$repeatDone && scope.$last) {
        scope.$appended = true;
        scope.$emit('itemAppended', elem);
      }
    }
  };
}
angular.module('maestro.directives').directive('onRepeatDone', [OnRepeatDoneDirective]).directive('emitPrependedItems', [EmitPrependedItemsDirective]).directive('emitAppendedItems', [EmitAppendedItemsDirective]);

},{}],230:[function(require,module,exports){
"use strict";

function getScrollParent(node) {
  if (node === null) {
    return null;
  }
  if (node.scrollHeight > node.clientHeight) {
    return node;
  } else {
    return getScrollParent(node.parentNode);
  }
}
angular.module('maestro.directives').directive('scrollHere', ['$timeout', function ($timeout) {
  return {
    restrict: 'A',
    link: function link($scope, $element, attrs) {
      if (attrs.scrollHere === 'true') {
        $timeout(function () {
          var el = $element[0];
          var scrollable = getScrollParent(el);
          el.scrollIntoView(true);
          if (scrollable) {
            scrollable.scrollTop -= 60;
          }
        });
      }
    }
  };
}]);

},{}],231:[function(require,module,exports){
"use strict";

SheetDirective.$inject = ["NAV_TEMPLATE_API_PREFIX", "$rootScope"];
var MENU_WIDTH = 300;

/* @ngInject */
function SheetDirective(NAV_TEMPLATE_API_PREFIX, $rootScope) {
  return {
    restrict: 'EA',
    templateUrl: "".concat(NAV_TEMPLATE_API_PREFIX, "/sheet.html"),
    link: function link(scope, el) {
      var appearAnimation = 'zoomIn';
      var dismissAnimation = 'zoomOut';
      if (scope.pin) {
        appearAnimation = 'fadeInUp';
        dismissAnimation = 'fadeOutDown';
      }
      if (scope.menu && scope.positionMenuAround && !$rootScope.device.isPhone) {
        var source = $(scope.positionMenuAround);
        var rect = scope.positionMenuAround.getBoundingClientRect();
        var sourceWidth = source.outerWidth();
        var sourceOffset = rect || source.offset();
        var verticalOffset = scope.vOffset || (source ? source.outerHeight() : 0);
        var horizontalOffset = scope.hOffset || 0;
        var anchor = scope.anchor ? scope.anchor : 'top right';
        var anchors = anchor.split(' ');
        var style = {
          top: 0,
          left: 0,
          bottom: 'auto'
        };
        appearAnimation = 'zoomInTopLeft';
        dismissAnimation = 'zoomOutTopLeft';
        anchors.forEach(function (a) {
          switch (a) {
            case 'top':
              style.top = sourceOffset.top;
              break;
            case 'right':
              style.left = sourceOffset.left + sourceWidth - MENU_WIDTH;
              break;
            case 'bottom':
              style.top = sourceOffset.top + source.outerHeight();
              break;
            case 'left':
              style.left = sourceOffset.left;
              appearAnimation = 'zoomInTopRight';
              dismissAnimation = 'zoomOutTopRight';
              break;
          }
        });
        style.top = style.top + verticalOffset;
        style.left = Math.max(style.left + horizontalOffset, 0);
        el.find('.modal-content').css(style);
      }
      if (scope.menu) {
        el.find('.modal-content').css({
          bottom: 'unset'
        });
      }
      el.find('.modal-content').addClass(appearAnimation);
      scope.$$deferred().promise.finally(function () {
        if (!(scope.menu && $rootScope.device.isPhone)) {
          el.addClass('animated fadeOut');
        }
        el.find('.modal-content').removeClass(appearAnimation).addClass(dismissAnimation);
        el.find('.modal-sheet').addClass('disappearing');
        setTimeout(function () {
          return el.remove();
        }, 600);
      });
      if (scope.dismissOnOutsideClick) {
        var dismissHandler = function dismissHandler(ev) {
          return scope.$evalAsync(function () {
            return scope.$dismissOnOutsideClick(ev);
          });
        };
        el.find('.modal-sheet').on('click touchend', dismissHandler);
      }
      scope.$dismissOnOutsideClick = function (ev) {
        setTimeout(function () {
          var $target = angular.element(ev.target);
          if ($target.closest('.modal-sheet').length === 0) {
            console.debug('[SheetDirective] Prevent dismiss on sensible areas.');
            return;
          }
          if (scope.dismissOnOutsideClick) {
            scope.reject('click outside');
          }
        }, 100);
      };
    }
  };
}
angular.module('maestro.directives').directive('sheet', SheetDirective);

},{}],232:[function(require,module,exports){
"use strict";

var _lodash = require("lodash");
function detectTalking(emitter, startedTalkingHandler, isContinuouslyTalkingHandler) {
  var isTalking = false;
  var lastTalkingTimestamp = null;
  function setIsTalking(val) {
    isTalking = val;
    startedTalkingHandler(val);
  }
  var movingAvg;
  var onAudioLevelUpdated = function onAudioLevelUpdated(event) {
    var now = Date.now();
    if (movingAvg === undefined || movingAvg <= event.audioLevel) {
      movingAvg = event.audioLevel;
    } else {
      movingAvg = 0.7 * movingAvg + 0.3 * event.audioLevel;
    }
    var logLevel = Math.log(movingAvg) / Math.LN10 / 1.5 + 1;
    logLevel = Math.min(Math.max(logLevel, 0), 1);
    if (logLevel > 0.2) {
      if (!lastTalkingTimestamp) {
        lastTalkingTimestamp = now;
      } else if (isTalking) {
        lastTalkingTimestamp = now;
      } else if (now - lastTalkingTimestamp > 1000) {
        setIsTalking(true);
      }
    } else if (lastTalkingTimestamp !== null && now - lastTalkingTimestamp > 3000) {
      setIsTalking(false);
      lastTalkingTimestamp = null;
    }
    if (isTalking) {
      isContinuouslyTalkingHandler();
    }
  };
  emitter.on('audioLevelUpdated', onAudioLevelUpdated);
  return function () {
    emitter.off('audioLevelUpdated', onAudioLevelUpdated);
  };
}
function talkingIndicator() {
  return {
    restrict: 'A',
    link: function link(scope, elem, attrs) {
      var parent = elem.parent();
      var unsubscriber;
      scope.$watch(attrs.talkingIndicator, tryInit);
      tryInit();
      function tryInit() {
        var attr = scope.$eval(attrs.talkingIndicator);
        if (!attr) {
          return;
        }
        var emitter = attr && attr.otSubscriberObject ? attr.otSubscriberObject : attr;
        if (!emitter || !emitter.on || !emitter.id) {
          return;
        }
        var startedTalkingHandler = function startedTalkingHandler(isTalking) {
          var otVideoPosterEl = elem.find('.OT_video-poster');
          if (isTalking) {
            (0, _lodash.debounce)(function () {
              parent.find('.focused-speaker').removeClass('focused-speaker');
            }, 1000, {
              leading: true,
              trailing: false
            });
            elem.addClass('talking-indicator focused-speaker');
            otVideoPosterEl.addClass('talking-indicator poster');
          } else {
            elem.removeClass('talking-indicator');
            otVideoPosterEl.removeClass('talking-indicator poster');
          }
        };
        var isContinuouslyTalkingHandler = function isContinuouslyTalkingHandler() {};
        if (attr.pid) {
          isContinuouslyTalkingHandler = (0, _lodash.throttle)(function () {
            scope.$emit('talkingIndicator:isTalking', attr.pid);
          }, 2000);
        }
        if (unsubscriber) {
          unsubscriber();
        }
        unsubscriber = detectTalking(emitter, startedTalkingHandler, isContinuouslyTalkingHandler);
        console.log('[TalkingIndicator] successfully (re)instantiated');
      }
    }
  };
}
angular.module('maestro.directives').directive('talkingIndicator', talkingIndicator);

},{"lodash":"lodash"}],233:[function(require,module,exports){
"use strict";

var _lodash = require("lodash");
ThemeDirective.$inject = ["$parse"];
/* @ngInject */
function ThemeDirective($parse) {
  return {
    restrict: 'A',
    compile: function compile() {
      return {
        pre: function pre(scope, elem, attrs) {
          var theme = $parse(attrs.theme)(scope);
          scope.$theme = theme;
          if (!scope.$theme) {
            return;
          }
          elem.css('background-color', scope.$theme.background_color);
          var sideTag = scope.$theme.side_tag_view;
          if (sideTag && !sideTag.hidden && sideTag.background_color) {
            elem.css('border-left', "5px solid ".concat(sideTag.background_color));
          }
          if (!(0, _lodash.isEmpty)(theme.text_color)) {
            elem.css('color', theme.text_color);
          }
        },
        post: angular.noop
      };
    }
  };
}
function ThemeSelectorDirective() {
  return {
    restrict: 'A',
    compile: function compile() {
      return {
        pre: function pre(scope, elem, attrs) {
          var theme = (scope.$theme || {})[attrs.themeSelector];
          if (!theme) {
            return;
          }
          theme.paddings = theme.paddings || {};
          elem.css({
            display: theme.hidden ? 'none' : '',
            backgroundColor: theme.background_color,
            color: theme.font_color,
            fontSize: theme.font_size,
            fontWeight: theme.font_type === 'bold' ? 'bold' : undefined,
            fontStyle: theme.font_type === 'italic' ? 'italic' : undefined,
            backgroundSize: theme.scale_mode === 'aspect_fill' ? 'cover' : 'contain',
            textAlign: theme.alignment,
            paddingTop: theme.paddings.vertical,
            paddingBottom: theme.paddings.vertical,
            paddingLeft: theme.paddings.horizontal,
            paddingRight: theme.paddings.horizontal
          });
          if (theme.alignment_vertical) {
            elem.addClass('theme-vertical-align-' + theme.alignment_vertical);
          }
        },
        post: angular.noop
      };
    }
  };
}
angular.module('maestro.directives').directive('theme', ThemeDirective).directive('themeSelector', ThemeSelectorDirective);

},{"lodash":"lodash"}],234:[function(require,module,exports){
"use strict";

angular.module('maestro.directives').directive('decorateWithWebappUiVersion', function () {
  return {
    restrict: 'AC',
    link: function link(_scope, el) {
      el.addClass('webapp-ui-v2');
    }
  };
});

},{}],235:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appResource = appResource;
exports.feedLinky = feedLinky;
exports.humanizeDuration = humanizeDuration;
exports.postLinks = postLinks;
exports.questionLinks = questionLinks;
exports.secureStripHTML = secureStripHTML;
exports.shortDate = shortDate;
exports.shortTime = shortTime;
exports.takeInitials = takeInitials;
exports.time = time;
exports.timeDisplay = timeDisplay;
exports.unescapeAmps = unescapeAmps;
exports.unixFromNow = unixFromNow;
var _toArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _lodash = require("lodash");
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _string = require("../utils/string");
var _url = require("../utils/url");
var _i18nWithFallback = _interopRequireDefault(require("../utils/i18n-with-fallback"));
iconUrlFilter.$inject = ["handlerService"];
assetUrlFilter.$inject = ["handlerService"];
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var POSTS_CACHE = {};
var QUESTIONS_CACHE = {};
var ICON_ENDPOINT = 'webapp/icon';
var SIGNED_ASSET_ENDPOINT = 'webapp/signed-asset';
function takeInitials(str) {
  var names = (str || '').trim().replace(/[[\]]+/g, '').split(' ');
  if (names.length === 0) return '';
  if (names.length === 1) return names[0][0];
  return names[0][0] + (0, _lodash.last)(names)[0];
}

/* @ngInject */
function assetUrlFilter(handlerService) {
  return function (src) {
    if (!src || !src.length) {
      return src;
    }
    if (src[0] === '/') {
      return src;
    }
    try {
      new URL(src);
      return src;
    } catch (err) {}
    src = src.replace('{{couchbase_url}}/{{default_db}}/', '');
    var _src$split = src.split('?'),
      _src$split2 = (0, _slicedToArray2.default)(_src$split, 2),
      file = _src$split2[0],
      extraQueryParams = _src$split2[1];
    var _file$split = file.split('/'),
      _file$split2 = (0, _toArray2.default)(_file$split),
      id = _file$split2[0],
      attachment = _file$split2.slice(1);
    attachment = attachment.join('/');
    if (attachment && attachment.endsWith('.m3u8')) {
      return handlerService.generateBackendUrl("".concat(SIGNED_ASSET_ENDPOINT, "/").concat(id, "/").concat(attachment));
    }
    var params = (0, _lodash.extend)({
      id: id,
      attachment: attachment
    }, (0, _url.fromQueryString)(extraQueryParams));
    return handlerService.generateBackendUrl('webapp/doc', params);
  };
}

/* @ngInject */
function iconUrlFilter(handlerService) {
  return function (src) {
    if (!src || !src.length) {
      return src;
    }
    return handlerService.generateBackendUrl("".concat(ICON_ENDPOINT, "/").concat(src.split('/')[0]));
  };
}
function time(ts, format) {
  if (!(0, _lodash.isNumber)(ts)) return 'N/A';
  return _momentTimezone.default.unix(ts).format(format);
}
function shortDate(ts) {
  if (!(0, _lodash.isNumber)(ts)) return 'N/A';
  return _momentTimezone.default.unix(ts).format('ddd, MMM D');
}
function shortTime(ts) {
  if (!(0, _lodash.isNumber)(ts)) return 'N/A';
  return _momentTimezone.default.unix(ts).format('LT');
}
function timeDisplay(ts) {
  ts = Number.parseInt(ts);
  if (isNaN(ts)) return '-';
  var format = ts < 3600 ? 'mm:ss' : 'HH:mm:ss';
  return _momentTimezone.default.utc(ts * 1000).format(format);
}
function humanizeDuration(ts) {
  var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'seconds';
  if (!(0, _lodash.isNumber)(ts)) return 'N/A';
  return _momentTimezone.default.duration(-ts, unit).humanize(true);
}
function unescapeAmps(text) {
  return (text || '').replace(new RegExp(/&amp;/, 'g'), '&').replace(new RegExp(/\n/, 'g'), '&#10;').replace(new RegExp(/&#10;/, 'g'), '<br/>');
}
function unixFromNow(ts) {
  return _momentTimezone.default.unix(ts).fromNow();
}
unixFromNow.$stateful = true;
function feedLinky(content, links, action) {
  if (!content || !(0, _lodash.isString)(content) || !content.includes('@') && !content.includes('#') || !action || !action.path) {
    return content;
  }
  console.groupCollapsed('[feedLinky] linking');
  var rawContent = $('<div>').html(content).html();
  console.log('content', rawContent);
  var urlRegex = /<a\s(?:.(?!=href))*?href="(?:[^"]*)"[^>]*?>(?:.*?)<\/a>/g;
  var urlLinks = rawContent.match(urlRegex);
  (urlLinks || []).forEach(function (link) {
    var el = $(link);
    var url = el.attr('href');
    rawContent = rawContent.replace(url, "/api/v1/open-proxy?url=".concat(url));
  });
  links = (0, _lodash.isArray)(links) ? links : [];
  var hashtags = (rawContent.match(/\B(\#[a-zA-Z0-9\u00C0-\u024F\u1E00-\u1EFF]+\b)(?!;)|(\#[a-zA-Z0-9\u00C0-\u024F\u1E00-\u1EFF]+)/g) || []).filter(function (h) {
    return !links.map(function (l) {
      return l.text;
    }).includes(h);
  });
  var _iterator = _createForOfIteratorHelper(hashtags),
    _step;
  try {
    var _loop = function _loop() {
      var hashtag = _step.value;
      if (!links.find(function (l) {
        return l.text === hashtag;
      })) {
        links.push({
          index: content.indexOf(hashtag),
          text: hashtag
        });
      }
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  links = (0, _lodash.sortBy)(links, 'index');
  console.log('injecting links', links);
  var parsed = [];
  var _iterator2 = _createForOfIteratorHelper(links),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var link = _step2.value;
      if (parsed.includes(link.text)) {
        continue;
      }
      var params = encodeURIComponent(JSON.stringify((0, _lodash.extend)({}, action.params || {}, {
        text: link.text,
        metadata: link.metadata
      })));
      var linkText = "<a href=\"appscript://".concat(action.path, "?").concat(params, "\" class=\"appscript-link\">").concat(link.text, "</a>");
      rawContent = rawContent.replace(new RegExp("".concat(link.text), 'g'), linkText);
      parsed.push(link.text);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  console.log('done', rawContent);
  console.groupEnd('[feedLinky] linking');
  return rawContent;
}
function postLinks($filter, content, links, action) {
  if (!POSTS_CACHE[content]) {
    var linky = $filter('linky');
    var rawContent = linky(content, '_blank');
    rawContent = feedLinky(rawContent, links, action);
    POSTS_CACHE[content] = unescapeAmps(rawContent);
  }
  return POSTS_CACHE[content];
}
function questionLinks($filter, $i18n, content) {
  if (!QUESTIONS_CACHE[content]) {
    var linky = $filter('linky');
    var attributeFn = function attributeFn(url) {
      if (url.startsWith('https://') || url.startsWith('mailto:')) {
        return {
          class: 'link'
        };
      }
      return {
        href: '#',
        target: '',
        class: 'link disabled',
        title: (0, _i18nWithFallback.default)($i18n, 'qna.tooltip.link_not_allowed', 'This link is not secure. Only https links are allowed.')
      };
    };
    var rawContent = linky(content, '_blank', attributeFn);
    QUESTIONS_CACHE[content] = unescapeAmps(rawContent);
  }
  return QUESTIONS_CACHE[content];
}
var staticAssetSuffix = ".min";
function appResource(resource) {
  var parts = resource.split('.');
  var ext = parts.pop();
  var baseName = parts.join('.');
  return "/webapp/static/".concat("1.156.0", "/", baseName).concat(staticAssetSuffix, ".").concat(ext);
}
function secureStripHTML($sce, html) {
  return (0, _string.stripHTML)($sce.getTrustedHtml(html));
}
angular.module('maestro.filters', []).filter('takeInitials', [function () {
  return takeInitials;
}]).filter('assetUrl', assetUrlFilter).filter('iconUrl', iconUrlFilter).filter('time', [function () {
  return time;
}]).filter('shortDate', [function () {
  return shortDate;
}]).filter('shortTime', [function () {
  return shortTime;
}]).filter('timeDisplay', [function () {
  return timeDisplay;
}]).filter('humanizeDuration', [function () {
  return humanizeDuration;
}]).filter('appResource', [function () {
  return appResource;
}]).filter('stripHTML', ['$sce', function ($sce) {
  return function (html) {
    return secureStripHTML($sce, html);
  };
}]).filter('feedLinky', [function () {
  return feedLinky;
}]).filter('unescape', [function () {
  return unescapeAmps;
}]).filter('unixFromNow', [function () {
  return unixFromNow;
}]).filter('postLinks', ['$filter', function ($filter) {
  return function (content, links, action) {
    return postLinks($filter, content, links, action);
  };
}]).filter('questionLinks', ['$filter', '$i18n', function ($filter, $i18n) {
  return function (content) {
    return questionLinks($filter, $i18n, content);
  };
}]);

},{"../utils/i18n-with-fallback":359,"../utils/string":366,"../utils/url":369,"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/helpers/slicedToArray":390,"@babel/runtime/helpers/toArray":392,"lodash":"lodash","moment-timezone":"moment-timezone"}],236:[function(require,module,exports){
"use strict";

angular.module('frontloader', ['maestro.config', 'frontstage.config', 'maestro.services', 'dbinterface']);
require('./resourceLoaderService');

},{"./resourceLoaderService":237}],237:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _toArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toArray"));
var _lodash = require("lodash");
ResourceLoaderService.$inject = ["COMPILED_FSTG_ASSETS", "$q", "$document", "$templateCache", "handlerService"];
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var BLOCKS_PROTO = 'fstg-blocks://';
var SOURCES_PROTO = 'fstg-sources://';
var FSTG_SOURCE_HANDLER = 'webapp/fstg-source';
var FSTG_RESOURCE_HANDLER = 'webapp/fstg-resource';
var HARDCODED_INCLUDES = ['fstg-sources://lib/d3.v3.min.js', 'fstg-sources://lib/d3.cloud.layout.js', 'fstg-blocks://session-registrations/block.js', 'fstg-blocks://session-registration-with-restrictions/block.js'];

/* @ngInject */
function ResourceLoaderService(COMPILED_FSTG_ASSETS, $q, $document, $templateCache, handlerService) {
  var doc = $document[0];
  var resourceLoaded = false;
  var logs = [];
  var differLog = function differLog(type, message, param) {
    return logs.push({
      type: type,
      message: message,
      param: param
    });
  };
  var log = function log() {
    if ("production" === 'dev') {
      logs.forEach(function (_ref) {
        var type = _ref.type,
          message = _ref.message,
          param = _ref.param;
        return console[type](message, param);
      });
      logs.splice(0);
    }
  };
  var normalizeUri = function normalizeUri() {
    var uri = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    uri = uri.trim();
    if (uri.indexOf(BLOCKS_PROTO) === 0) {
      var _uri$replace$split = uri.replace(BLOCKS_PROTO, '').split('/'),
        _uri$replace$split2 = (0, _toArray2.default)(_uri$replace$split),
        block = _uri$replace$split2[0],
        resource = _uri$replace$split2.slice(1);
      return handlerService.generateBackendUrl(FSTG_RESOURCE_HANDLER, {
        params: {
          attachment: "".concat(block, "/").concat(resource.join('/'))
        }
      });
    }
    if (uri.indexOf(SOURCES_PROTO) === 0) {
      return handlerService.generateBackendUrl(FSTG_SOURCE_HANDLER, {
        params: {
          attachment: "".concat(uri.replace(SOURCES_PROTO, ''))
        }
      });
    }
    return uri;
  };
  var normalizeUriList = function normalizeUriList(uris) {
    return (0, _lodash.chain)([uris]).flatten().compact().uniq().map(normalizeUri).value();
  };
  var resourceInjectors = {
    css: function css(path, body) {
      var el = doc.createElement('style');
      el.type = 'text/css';
      var cssText = "".concat(body, "\n/* sourceURL: ").concat(path, "*/");
      if (el.styleSheet) {
        el.styleSheet.cssText = cssText;
      } else {
        el.appendChild(document.createTextNode(cssText));
      }
      doc.head.appendChild(el);
      differLog('log', '[resourceLoader] css injected', path);
    },
    js: function js(path, body) {
      var el = doc.createElement('script');
      el.type = 'text/javascript';
      el.text = "".concat(body, "\n//# sourceURL=").concat(path);
      doc.head.appendChild(el);
      differLog('log', '[resourceLoader] js injected', path);
    },
    html: function html(path, body) {
      $templateCache.put(normalizeUri(path), body);
      differLog('log', '[resourceLoader] html injected', path);
    }
  };
  var injectResource = function injectResource(body, path) {
    var type = path.split('.').slice(-1)[0];
    var resourceInjector = resourceInjectors[type];
    if (!resourceInjector) {
      differLog('error', '[resourceLoader] Unknown resource injector', type);
      return;
    }
    resourceInjector(path, body);
  };
  var vendorSort = function vendorSort(a, b) {
    var vendorA = a.includes('/vendor/');
    var vendorB = b.includes('/vendor/');
    var aFileName = a.replace(/\.[^.]*$/, '');
    var bFileName = b.replace(/\.[^.]*$/, '');
    var aIndex = HARDCODED_INCLUDES.includes(a) ? HARDCODED_INCLUDES.indexOf(a) : Infinity;
    var bIndex = HARDCODED_INCLUDES.includes(b) ? HARDCODED_INCLUDES.indexOf(b) : Infinity;
    if (vendorA && !vendorB) {
      return -1;
    }
    if (vendorB && !vendorA) {
      return 1;
    }
    if (aIndex < bIndex) {
      return -1;
    }
    if (aIndex > bIndex) {
      return 1;
    }
    if (aFileName < bFileName) {
      return -1;
    }
    if (aFileName > bFileName) {
      return 1;
    }
    return 0;
  };
  var injectResources = function () {
    var _ref2 = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee() {
      var _iterator, _step, resource;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(resourceLoaded || !COMPILED_FSTG_ASSETS)) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            resourceLoaded = true;
            _iterator = _createForOfIteratorHelper(Object.keys(COMPILED_FSTG_ASSETS).sort(vendorSort));
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                resource = _step.value;
                injectResource(COMPILED_FSTG_ASSETS[resource], resource);
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
            console.groupCollapsed('[resourceLoader] loading resources');
            log();
            console.groupEnd();
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function injectResources() {
      return _ref2.apply(this, arguments);
    };
  }();
  return {
    normalizeUri: normalizeUri,
    normalizeUriList: normalizeUriList,
    loadBlockResources: injectResources,
    loadPageResources: injectResources
  };
}
angular.module('frontloader').service('resourceLoaderService', ResourceLoaderService);

},{"@babel/runtime/helpers/asyncToGenerator":375,"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/helpers/toArray":392,"@babel/runtime/regenerator":398,"lodash":"lodash"}],238:[function(require,module,exports){
"use strict";

window.jQuery = window.$ = require('jquery');
var angular = require('angular');
var debugEnabled = false;
if (!('console' in window)) {
  window.console = {
    log: function log() {},
    error: function error() {}
  };
}
window.APP = {};
require('moment');
require('slick-carousel');
require('angular-slick-carousel');
require('angularjs-scroll-glue');
require('angularjs-bootstrap-datetimepicker');
require('oclazyload');
require('ng-quill');
require('./templates');
require('./services');
require('./filters');
require('./directives');
require('./frontloader');
require('./navs');
angular.module('maestro', [require('angular-sanitize'), require('angular-cookies'), 'luegg.directives', 'slickCarousel', 'maestro.config', 'maestro.auth', 'maestro.navs', 'maestro.navs.router', 'maestro.services', 'maestro.services.metrics', 'maestro.services.appcues', 'maestro.filters', 'maestro.directives', 'maestro.layoutmanager', 'maestro.cache.templates', 'ui.bootstrap.datetimepicker', require('./components').ComponentsModule, require('frontloader-common/meta-service'), require('frontloader-common/device-provider'), require('frontloader-common/theme-provider'), require('frontloader-common/i18n'), require('frontloader-common/asset-utils'), 'dbinterface', 'oc.lazyLoad', 'ngQuill']).config( /* @ngInject */["$compileProvider", "$locationProvider", "$sceDelegateProvider", "$logProvider", "$ocLazyLoadProvider", function ($compileProvider, $locationProvider, $sceDelegateProvider, $logProvider, $ocLazyLoadProvider) {
  if (!false) {
    $compileProvider.debugInfoEnabled(false);
    $logProvider.debugEnabled(false);
  }
  debugEnabled = $compileProvider.debugInfoEnabled();
  $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|open\-document|appscript):/);
  $compileProvider.imgSrcSanitizationWhitelist(/^\s*((https?|ftp|file|blob|fp\-asset):|data:image\/)/);
  $sceDelegateProvider.resourceUrlWhitelist(['self']);
  $locationProvider.html5Mode(true).hashPrefix('!');
  $ocLazyLoadProvider.config({
    debug: false
  });
}]).run( /* @ngInject */["ACTIVATED_PERSON", "EID", "$i18n", "$rootScope", "metaService", "signalService", "appcuesService", "$timeout", "metricsService", function (ACTIVATED_PERSON, EID, $i18n, $rootScope, metaService, signalService, appcuesService, $timeout, metricsService) {
  console.log('[maestro] run');
  signalService.init(EID, $timeout);
  appcuesService.load();
  $rootScope.activatedPerson = ACTIVATED_PERSON;
  window.APP.services.i18n = $i18n;
  if (debugEnabled) {
    metaService.exposeGlobalHelper();
  }
}]);
require('./bootloader');

},{"./bootloader":1,"./components":151,"./directives":223,"./filters":235,"./frontloader":236,"./navs":239,"./services":253,"./templates":318,"angular":"angular","angular-cookies":551,"angular-sanitize":553,"angular-slick-carousel":554,"angularjs-bootstrap-datetimepicker":556,"angularjs-scroll-glue":559,"frontloader-common/asset-utils":1107,"frontloader-common/device-provider":1108,"frontloader-common/i18n":1109,"frontloader-common/meta-service":1111,"frontloader-common/theme-provider":1112,"jquery":"jquery","moment":"moment","ng-quill":1167,"oclazyload":1169,"slick-carousel":1188}],239:[function(require,module,exports){
"use strict";

angular.module('maestro.navs');
require('./navAgendaCtrl');
require('./navFstgCtrl');

},{"./navAgendaCtrl":240,"./navFstgCtrl":241}],240:[function(require,module,exports){
"use strict";

AgendaNavCtrl.$inject = ["$rootScope", "$scope", "progressBarService", "navService", "databaseService", "localCacheFactory", "paginatorFactory"];
var _require = require('lodash'),
  map = _require.map,
  isArray = _require.isArray;
var moment = require('moment-timezone');
var MAX_TAG_WIDTH = 45;
var DAY_IN_SECONDS = 24 * 60 * 60 - 1;

/* @ngInject */
function AgendaNavCtrl($rootScope, $scope, progressBarService, navService, databaseService, localCacheFactory, paginatorFactory) {
  var nav = $scope.nav;
  var paginator = paginatorFactory({
    pageSize: 100
  });
  var now = moment();
  var today = now.startOf('day').unix();
  $scope.selectedDay = null;
  var localCalendarCache = localCacheFactory("".concat(nav._dynamic_nav ? new Date().getTime() : nav._id, "/calendar"));
  var eventCalendarCache = localCalendarCache.get('days');
  var eventCalendarCacheExpires = localCalendarCache.get('expires', -1);
  var calendarCacheExpired = function calendarCacheExpired() {
    if (!eventCalendarCacheExpires) return false;
    return eventCalendarCacheExpires < moment.unix();
  };
  var cacheEventCalendar = function cacheEventCalendar(days) {
    if (!days || !isArray(days.days)) {
      return days;
    }
    localCalendarCache.put('days', days);
    localCalendarCache.put('expires', moment().add(1, 'hour').unix());
    eventCalendarCache = localCalendarCache.get('days');
    return days;
  };
  var defaultDay = function defaultDay() {
    var _eventCalendarCache = eventCalendarCache,
      days = _eventCalendarCache.days;
    return days.indexOf(today) === -1 ? days[0] : today;
  };
  var buildCalendarStrip = function buildCalendarStrip(days) {
    var dayWidth = "".concat(100 / days.days.length, "%");
    $scope.calendarDays = map(days.tags, function (tags, day) {
      day = parseInt(day, 10);
      var date = moment.unix(day);
      var totalSessions = 0;
      for (var tag in tags) {
        if (tags.hasOwnProperty(tag)) {
          totalSessions += tags[tag];
        }
      }
      return {
        ts: day,
        day: date.format('ddd'),
        date: date.date(),
        today: today === date.unix(),
        width: dayWidth,
        tags: map(tags, function (v, k) {
          return {
            backgroundColor: k,
            'max-width': 5 + Math.round(v / totalSessions * MAX_TAG_WIDTH)
          };
        })
      };
    });
  };
  var getEventDaysAndBuildCalendar = function getEventDaysAndBuildCalendar() {
    var _$scope$nav$agendaDay = $scope.nav.agendaDays,
      source = _$scope$nav$agendaDay.source,
      params = _$scope$nav$agendaDay.params;
    if (!source) {
      console.warn('[AgendaNavCtrl] missing agendaDays data source', $scope.nav);
      return;
    }
    if (eventCalendarCache) {
      buildCalendarStrip(eventCalendarCache);
      $scope.setDay(defaultDay());
      if (calendarCacheExpired()) {
        console.log('[AgendaNavCtrl] calendar cache expired, refreshing');
        databaseService.runAppScript(source, params).then(function (_ref) {
          var days = _ref.data.response;
          return cacheEventCalendar(days);
        });
      }
    } else {
      progressBarService.startTask();
      databaseService.runAppScript(source, params).then(function (_ref2) {
        var days = _ref2.data.response;
        return buildCalendarStrip(cacheEventCalendar(days));
      }).then(function () {
        return $scope.setDay(defaultDay());
      }).finally(progressBarService.finishTask);
    }
  };
  var join = function join(dest, source) {
    return Array.prototype.push.apply(dest, source);
  };
  var updateNav = function updateNav() {
    progressBarService.startTask();
    navService.inflatePaginatedNav($scope.nav, {
      start: $scope.selectedDay,
      end: $scope.selectedDay + DAY_IN_SECONDS
    }, paginator).then(function (resp) {
      return resp ? join($scope.nav.ds.elements, resp.paginatedElements) : null;
    }).finally(function () {
      progressBarService.finishTask();
    });
  };
  $scope.nextPage = function () {
    if (paginator.hasMorePages()) updateNav();
  };
  $scope.setDay = function (date) {
    if ($scope.selectedDay === date) return;
    $scope.selectedDay = date;
    paginator.reset();
    $scope.nav.ds.elements = [];
    updateNav();
  };
  $scope.performRowActions = navService.mergeAndPerformRowActions(nav.actions, nav.nuid);
  $scope.toggleBreakout = function (row) {
    if (row.expanded) {
      row.expanded = false;
    } else {
      $scope.expandBreakout(row);
    }
  };
  $scope.expandBreakout = function (row) {
    row.expanded = true;
    if (!row.elements || !row.elements.length) {
      navService.inflateNav($scope.nav, {
        parent: row.render.params.mapping.breakout_id
      }).then(function (_ref3) {
        var elements = _ref3.elements;
        return row.elements = elements;
      });
    }
  };
  var initCtrl = function initCtrl() {
    $scope.nav.ds.elements = [];
    $scope.showCalendar = 'show_calendar' in ($scope.nav.theme || {}) ? $scope.nav.theme.show_calendar : true;
    paginator.reset();
    getEventDaysAndBuildCalendar();
  };
  $scope.$watch('nav', initCtrl);
}
angular.module('maestro.navs').controller('AgendaNavCtrl', AgendaNavCtrl);

},{"lodash":"lodash","moment-timezone":"moment-timezone"}],241:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _lodash = require("lodash");
FstgNavCtrl.$inject = ["EVENT", "$scope", "$injector", "progressBarService", "navService", "frontstageLoaderService", "liveStreamService", "signalService", "videoBreakoutService"];
/* @ngInject */
function FstgNavCtrl(EVENT, $scope, $injector, progressBarService, navService, frontstageLoaderService, liveStreamService, signalService, videoBreakoutService) {
  console.log('[navFstgCtrl] init', $scope.nav.page_id);
  $scope.eventTitle = EVENT.description.title.en;
  $scope.page = {};
  var videoBreakoutId;
  var signalListeners = [];
  var pageService = {};
  var unsubscribeFromSignals = function () {
    var _ref = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee() {
      var _i, _signalListeners, remover;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _i = 0, _signalListeners = signalListeners;
          case 1:
            if (!(_i < _signalListeners.length)) {
              _context.next = 9;
              break;
            }
            remover = _signalListeners[_i];
            if (!(0, _lodash.isFunction)(remover)) {
              _context.next = 6;
              break;
            }
            _context.next = 6;
            return remover();
          case 6:
            _i++;
            _context.next = 1;
            break;
          case 9:
            signalListeners = [];
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function unsubscribeFromSignals() {
      return _ref.apply(this, arguments);
    };
  }();
  $scope.$on('$destroy', (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee2() {
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return unsubscribeFromSignals();
        case 2:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  })));
  var loadPage = function () {
    var _ref3 = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee4(nav) {
      var onRegistrationStatusEvent;
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            if (!(!nav || !nav.page_id)) {
              _context4.next = 2;
              break;
            }
            return _context4.abrupt("return");
          case 2:
            console.info('[navFstgCtrl] loadPage', nav);
            videoBreakoutId = null;
            $scope.video_breakout_id = null;
            $scope.pageController = null;
            progressBarService.startTask();
            pageService.loadPage(nav.page_id, nav.page_params || {}).then(function (_ref4) {
              var _ref5 = (0, _slicedToArray2.default)(_ref4, 2),
                page = _ref5[0],
                pageController = _ref5[1];
              $scope.page = page;
              $scope.pageController = pageController;
              if (nav.live_stream_id) {
                console.log('[FstgCtrl] Opening live stream with ID ', nav.live_stream_id);
                return liveStreamService.start({
                  id: nav.live_stream_id
                });
              }
              if (nav.video_breakout) {
                if (nav.video_breakout.id) {
                  videoBreakoutId = nav.video_breakout.id;
                  if (!nav.can_register) {
                    return videoBreakoutService.attemptAutoStart(nav, videoBreakoutId);
                  }
                }
              } else if (nav.video_breakout_id) {
                videoBreakoutId = nav.video_breakout_id;
                return videoBreakoutService.attemptAutoStart(nav, videoBreakoutId);
              }
            }).finally(function () {
              $scope.$emit('fstg:page:loaded');
              progressBarService.finishTask();
            });
            onRegistrationStatusEvent = function () {
              var _ref6 = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee3(sessionId, is_registered) {
                return _regenerator.default.wrap(function _callee3$(_context3) {
                  while (1) switch (_context3.prev = _context3.next) {
                    case 0:
                      if (!(sessionId !== nav.page_params.model_id)) {
                        _context3.next = 2;
                        break;
                      }
                      return _context3.abrupt("return");
                    case 2:
                      nav.is_registered = is_registered;
                      if (nav.is_registered) {
                        $scope.video_breakout_id = videoBreakoutId;
                        nav.video_breakout_id = videoBreakoutId;
                      } else {
                        stopCall(nav);
                      }
                    case 4:
                    case "end":
                      return _context3.stop();
                  }
                }, _callee3);
              }));
              return function onRegistrationStatusEvent(_x2, _x3) {
                return _ref6.apply(this, arguments);
              };
            }();
            _context4.next = 11;
            return unsubscribeFromSignals();
          case 11:
            _context4.t0 = signalListeners;
            _context4.next = 14;
            return signalService.addSignalListener("videoCalls/schedule/".concat(nav.page_params.model_id), function (_ref7) {
              var video_breakout_id = _ref7.video_breakout_id;
              videoBreakoutId = video_breakout_id;
              if (!nav.can_register || nav.is_registered) {
                $scope.video_breakout_id = videoBreakoutId;
              }
            });
          case 14:
            _context4.t1 = _context4.sent;
            _context4.next = 17;
            return signalService.addSignalListener("videoCalls/cancel/".concat(nav.page_params.model_id), function () {
              stopCall(nav);
              videoBreakoutId = null;
            });
          case 17:
            _context4.t2 = _context4.sent;
            _context4.t3 = navService.on('webview:refresh', function () {
              return navService.reload();
            });
            _context4.t4 = navService.on('session_registration:status', function (_ref8) {
              var is_registered = _ref8.is_registered,
                sessionId = _ref8.sessionId;
              return onRegistrationStatusEvent(sessionId, is_registered);
            });
            _context4.t0.push.call(_context4.t0, _context4.t1, _context4.t2, _context4.t3, _context4.t4);
          case 21:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function loadPage(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var stopCall = function stopCall(nav) {
    if (videoBreakoutId) {
      videoBreakoutService.stop();
    }
    $scope.video_breakout_id = null;
    nav.video_breakout_id = null;
  };
  frontstageLoaderService.loadFstg().then(function () {
    pageService = $injector.get('pageService');
    $scope.$watch('nav', loadPage);
  });
}
angular.module('maestro.navs').controller('FstgNavCtrl', FstgNavCtrl);

},{"@babel/runtime/helpers/asyncToGenerator":375,"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/helpers/slicedToArray":390,"@babel/runtime/regenerator":398,"lodash":"lodash"}],242:[function(require,module,exports){
"use strict";

AppcuesService.$inject = ["USE_APPCUES", "EID", "PID", "$window", "$rootScope"];
/* @ngInject */
function AppcuesService(USE_APPCUES, EID, PID, $window, $rootScope) {
  if (!USE_APPCUES) {
    return {
      load: function load() {
        console.log('[appcuesService] disabled on this workspace');
      }
    };
  }
  var loadingStarted = false;
  var load = function load() {
    if (loadingStarted) return;
    loadingStarted = true;
    $rootScope.$on('$locationChangeSuccess', function () {
      if ($window.Appcues) {
        $window.Appcues.page();
      }
    });
    var script = document.createElement('script');
    script.onload = function () {
      console.log('[appcuesService] Loaded');
      $window.Appcues.identify(PID, {
        eid: EID,
        product: 'webapp-vx'
      });
    };
    script.src = "//fast.appcues.com/56484.js";
    document.head.append(script);
  };
  return {
    load: load
  };
}
angular.module('maestro.services.appcues', []).service('appcuesService', AppcuesService);

},{}],243:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
HttpAuthInterceptor.$inject = ["$q", "authService", "$injector"];
var _require = require('../utils/url'),
  replaceHostIfHasWhiteLabelDomain = _require.replaceHostIfHasWhiteLabelDomain;
var SESSION_ENDPOINT = '/api/v1/webapp/session?eid={eid}';
var getUserSession = function getUserSession(options, $http) {
  var pathname = window.location.pathname;
  var _pathname$split$reduc = pathname.split('/').reduce(function (previous, current) {
      if (!current) return previous;
      if (previous.eid) return previous;
      if (/^[\w]{32}$/.test(current)) {
        previous.eid = current;
      } else {
        previous.prefix += "/".concat(current);
      }
      return previous;
    }, {
      prefix: ''
    }),
    prefix = _pathname$split$reduc.prefix,
    eid = _pathname$split$reduc.eid;
  if (!eid) {
    console.error('Could not find eid in path ', pathname);
  }
  return $http.get(SESSION_ENDPOINT.replace('{eid}', eid), options).then(function (data) {
    if (data) data.prefix = prefix;
    return data;
  });
};
var AuthService = function () {
  AuthService.$inject = ["ACTIVATED_PERSON", "BRANDING", "EID", "WHITE_LABEL_DOMAIN", "$window"];
  /* @ngInject */
  function AuthService(ACTIVATED_PERSON, BRANDING, EID, WHITE_LABEL_DOMAIN, $window) {
    (0, _classCallCheck2.default)(this, AuthService);
    this.ACTIVATED_PERSON = ACTIVATED_PERSON;
    this.BRANDING = BRANDING;
    this.EID = EID;
    this.WHITE_LABEL_DOMAIN = WHITE_LABEL_DOMAIN;
    this.$window = $window;
  }
  (0, _createClass2.default)(AuthService, [{
    key: "logOut",
    value: function logOut() {
      var _this = this;
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var redirectTo = options.redirectTo || '/';
      var reason = options.reason || 'logout';
      var branding = options.branding || null;
      var goToWelcomePage = options.goToWelcomePage || false;
      try {
        this.$window.localStorage.clear();
      } catch (e) {}
      var loginUrlWithPrefilledData = "https://webapp.spotme.com".concat("/login?") + "branding=".concat(branding || this.BRANDING || 'eventspace') + (reason ? "&reason=".concat(reason) : '') + "&redirect=".concat(redirectTo) + "&email=".concat(this.ACTIVATED_PERSON.email) + "&install_instructions=".concat(goToWelcomePage);
      loginUrlWithPrefilledData = replaceHostIfHasWhiteLabelDomain(loginUrlWithPrefilledData, this.WHITE_LABEL_DOMAIN);
      $.ajax(SESSION_ENDPOINT.replace('{eid}', this.EID), {
        method: 'DELETE',
        complete: function complete() {
          return _this.$window.location.href = loginUrlWithPrefilledData;
        }
      });
    }
  }, {
    key: "getSession",
    value: function getSession() {
      return getUserSession({}, angular.injector(['ng']).get('$http'));
    }
  }]);
  return AuthService;
}();
/* @ngInject */
function HttpAuthInterceptor($q, authService, $injector) {
  return {
    responseError: function responseError(response) {
      if (response.status === 401) {
        authService.getSession().catch(function () {
          console.log('[HttpAuthInterceptor] 401 response detected, kicking user out');
          var BRANDING = $injector.get('BRANDING');
          return authService.logOut(undefined, undefined, BRANDING || (response.data || {}).branding);
        });
      }
      return $q.reject(response);
    }
  };
}
angular.module('maestro.auth', ['maestro.config']).service('authService', AuthService).factory('httpAuthInterceptor', HttpAuthInterceptor).config(['$httpProvider', function ($httpProvider) {
  return $httpProvider.interceptors.push('httpAuthInterceptor');
}]);
module.exports.getUserSession = getUserSession;

},{"../utils/url":369,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382}],244:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseService = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var BaseService = function () {
  function BaseService($http) {
    (0, _classCallCheck2.default)(this, BaseService);
    this.$http = $http;
    this.GETrequestCache = {};
  }
  (0, _createClass2.default)(BaseService, [{
    key: "getCachedOrMakeRequest",
    value: function getCachedOrMakeRequest(url, expires) {
      var _this = this;
      if (this.GETrequestCache[url]) {
        return this.GETrequestCache[url];
      }
      var promise = this.$http.get(url);
      this.GETrequestCache[url] = promise;
      setTimeout(function () {
        delete _this.GETrequestCache[url];
      }, expires);
      return promise;
    }
  }, {
    key: "postWithRetries",
    value: (function () {
      var _postWithRetries = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee(url, data) {
        var _this2 = this;
        var retries,
          delay,
          makeRequest,
          _args = arguments;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              retries = _args.length > 2 && _args[2] !== undefined ? _args[2] : 3;
              delay = _args.length > 3 && _args[3] !== undefined ? _args[3] : 1000;
              makeRequest = function makeRequest(retries) {
                return _this2.$http.post(url, data).catch(function (err) {
                  if (retries < 1) {
                    throw err;
                  }
                  if (err && err.status === 409) {
                    console.info('Post request failed because of a conflict, retrying');
                  } else {
                    console.error('Post request failed because of an unknown error, retrying', err);
                  }
                  return _this2.timeout(function () {
                    return makeRequest(retries - 1);
                  }, delay);
                });
              };
              return _context.abrupt("return", makeRequest(retries));
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function postWithRetries(_x, _x2) {
        return _postWithRetries.apply(this, arguments);
      }
      return postWithRetries;
    }())
  }, {
    key: "timeout",
    value: (function () {
      var _timeout = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee3(callback, delay) {
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", new Promise(function (resolve, reject) {
                setTimeout((0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee2() {
                  var res;
                  return _regenerator.default.wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        _context2.next = 2;
                        return callback().catch(function (e) {
                          return reject(e);
                        });
                      case 2:
                        res = _context2.sent;
                        resolve(res);
                      case 4:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2);
                })), delay);
              }));
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function timeout(_x3, _x4) {
        return _timeout.apply(this, arguments);
      }
      return timeout;
    }())
  }]);
  return BaseService;
}();
exports.BaseService = BaseService;

},{"@babel/runtime/helpers/asyncToGenerator":375,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/regenerator":398}],245:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _time = require("../utils/time");
var GET_COOKIES_ENDPOINT = '/api/v1/eid/{{eid}}/signed-assets/{{docId}}';
var CdnCookiesProvider = function () {
  CdnCookiesProvider.$inject = ["$http", "EID"];
  /* @ngInject */
  function CdnCookiesProvider($http, EID) {
    (0, _classCallCheck2.default)(this, CdnCookiesProvider);
    this.$http = $http;
    this.EID = EID;
    this.cache = new Map();
  }
  (0, _createClass2.default)(CdnCookiesProvider, [{
    key: "getCookiesForDirectory",
    value: (function () {
      var _getCookiesForDirectory = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee(docId) {
        var cacheKey, cachedData, getCookiesUrl, response, _response$data, baseCdnDirectoryUrl, expires;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              cacheKey = docId;
              cachedData = this.cache.get(cacheKey);
              if (!(cachedData && (0, _time.nowUnixTimestamp)() < cachedData.expires - 30)) {
                _context.next = 5;
                break;
              }
              console.debug('[CdnCookiesProvider] cookies still valid', docId);
              return _context.abrupt("return", cachedData.baseCdnDirectoryUrl);
            case 5:
              getCookiesUrl = GET_COOKIES_ENDPOINT.replace('{{eid}}', this.EID).replace('{{docId}}', docId);
              _context.next = 8;
              return this.$http.get(getCookiesUrl, {
                withCredentials: true,
                cache: false
              }).catch(function (err) {
                console.error('[CdnCookiesProvider] Failed to get CDN cookies for directory', {
                  err: err,
                  docId: docId
                });
                throw err;
              });
            case 8:
              response = _context.sent;
              _response$data = response.data, baseCdnDirectoryUrl = _response$data.url, expires = _response$data.expires;
              console.debug('[CdnCookiesProvider] received new cookies', {
                baseCdnDirectoryUrl: baseCdnDirectoryUrl,
                expires: expires
              });
              this.cache.set(cacheKey, {
                baseCdnDirectoryUrl: baseCdnDirectoryUrl,
                expires: expires !== null && expires !== void 0 ? expires : (0, _time.nowUnixTimestamp)() + 60 * 60
              });
              return _context.abrupt("return", baseCdnDirectoryUrl);
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getCookiesForDirectory(_x) {
        return _getCookiesForDirectory.apply(this, arguments);
      }
      return getCookiesForDirectory;
    }())
  }]);
  return CdnCookiesProvider;
}();
exports.default = CdnCookiesProvider;

},{"../utils/time":367,"@babel/runtime/helpers/asyncToGenerator":375,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/regenerator":398}],246:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _browserRum = require("@datadog/browser-rum");
var CrashReportingService = function () {
  function CrashReportingService() {
    (0, _classCallCheck2.default)(this, CrashReportingService);
  }
  (0, _createClass2.default)(CrashReportingService, [{
    key: "captureException",
    value: function captureException(message) {
      console.error('[CrashReporting] an error occurred:', message);
      if (undefined) {
        _browserRum.datadogRum.addError(message);
      }
    }
  }, {
    key: "reportError",
    value: function reportError(label, reason, error) {
      var msgParts = [];
      if (label) {
        msgParts.push('[', label, ']');
        if (reason || error) {
          msgParts.push(' ');
        }
      }
      if (reason) {
        msgParts.push(reason);
        if (error) {
          msgParts.push(' - ');
        }
      }
      if (error) {
        if (!(error instanceof Error) && (0, _typeof2.default)(error) === 'object') {
          msgParts.push(JSON.stringify(error));
        } else {
          msgParts.push(error);
        }
      }
      var msg = msgParts.join('');
      if (msg) {
        this.captureException(msg);
      }
    }
  }]);
  return CrashReportingService;
}();
exports.default = CrashReportingService;

},{"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/helpers/typeof":396,"@datadog/browser-rum":546}],247:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
var DsService = function () {
  DsService.$inject = ["$q", "progressBarService", "databaseService"];
  /* @ngInject */
  function DsService($q, progressBarService, databaseService) {
    (0, _classCallCheck2.default)(this, DsService);
    this.$q = $q;
    this.progressBarService = progressBarService;
    this.databaseService = databaseService;
  }
  (0, _createClass2.default)(DsService, [{
    key: "eval",
    value: function _eval(ds, paramOverrides) {
      if (!ds.type) return this.$q.reject('missing ds.type');
      var evaluatorKey = "eval_".concat(ds.type);
      if (typeof this[evaluatorKey] !== 'function') return this.$q.reject("unknown ds.type: ".concat(ds.type));
      console.log('[dataSourceEvaluatorService] evaluating', ds.type, ds.source);
      return this[evaluatorKey](ds, paramOverrides);
    }
  }, {
    key: "eval_javascript",
    value: function eval_javascript(_ref, paramOverrides) {
      var _this = this;
      var _ref$source = _ref.source,
        path = _ref$source.path,
        _ref$source$params = _ref$source.params,
        params = _ref$source$params === void 0 ? {} : _ref$source$params;
      if (paramOverrides) {
        params = (0, _lodash.extend)({}, params, paramOverrides);
      }
      this.progressBarService.startTask();
      return this.databaseService.runAppScript(path, params).then(function (_ref2) {
        var data = _ref2.data;
        if (data.status !== 'ok') return _this.$q.reject(data.response);
        return data.response;
      }).finally(function () {
        return _this.progressBarService.finishTask();
      });
    }
  }]);
  return DsService;
}();
angular.module('maestro.services').service('dataSourceEvaluatorService', DsService);

},{"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"lodash":"lodash"}],248:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _lodash = require("lodash");
var _moment = _interopRequireDefault(require("moment"));
var _i18nWithFallback = _interopRequireDefault(require("../utils/i18n-with-fallback"));
HttpJSONPInterceptor.$inject = ["$q"];
DatabaseService.$inject = ["EID", "PID", "$q", "$http", "$i18n", "$sheet", "authService", "metaService", "handlerService", "metricsService", "progressBarService", "$eventBus", "ACTIVATED_PERSON"];
var GET_DOC_ENDPOINT = 'webapp/doc';
var GET_VIEW_ENDPOINT = 'webapp/view';
function showEmailUsedByOtherUserAlert($sheet, $i18n) {
  $sheet({
    title: $i18n('general.logout'),
    message: (0, _i18nWithFallback.default)($i18n, 'profile_page.email_used_by_other_user', 'This email cannot be used.'),
    pin: false,
    scrollable: false,
    prompt: true,
    actions: [{
      id: 'ok',
      label: $i18n('general.ok'),
      action: function action(sheet) {
        return sheet.reject();
      }
    }]
  });
}

/* @ngInject */
function DatabaseService(EID, PID, $q, $http, $i18n, $sheet, authService, metaService, handlerService, metricsService, progressBarService, $eventBus, ACTIVATED_PERSON) {
  var savedPromise = $q.resolve();
  var deviceTimezone = _moment.default.tz.guess();
  var buildFormData = function buildFormData(params, fileParams, config) {
    var fd = new FormData();
    fd.append('params', JSON.stringify(_lodash.omit.apply(void 0, [params].concat((0, _toConsumableArray2.default)(fileParams)))));
    (0, _lodash.each)(fileParams, function (k) {
      return fd.append(k, params[k]);
    });
    config.headers = config.headers || {};
    config.headers['Content-Type'] = undefined;
    config.transformRequest = angular.identity;
    config.data = fd;
    var csrfTokenUrl = "/api/v1/eid/".concat(EID, "/csrf-token");
    return $http.get(csrfTokenUrl).then(function (result) {
      var csrfToken = result.data.token;
      fd.append('_csrf', csrfToken);
    });
  };
  var callHttp = function callHttp() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (config.params && '_cache' in config.params) {
      config.cache = config.params._cache;
      delete config.params._cache;
    }
    var prefetchParams = $q.resolve();
    if ('File' in window && config.data && config.data.params) {
      var params = config.data.params;
      var fileParams = (0, _lodash.filter)((0, _lodash.keys)(params), function (k) {
        return params[k] instanceof File;
      });
      if (fileParams.length) {
        prefetchParams = buildFormData(params, fileParams, config);
      }
    }
    return prefetchParams.then(savedPromise).then(function () {
      return $http(config);
    }, function () {
      return $http(config);
    });
  };
  var callBackend = function callBackend(endpoint, config) {
    if (!config.method) {
      config.method = 'GET';
    }
    config.url = handlerService.generateBackendUrl(endpoint);
    return callHttp(config);
  };
  var pluckValues = function pluckValues(data) {
    return (0, _lodash.pluck)(data, 'value');
  };
  var parseAppScriptEvents = function parseAppScriptEvents(resp) {
    return $q.all((0, _lodash.map)((resp.data || {}).events || [], function (e) {
      return $q.resolve(metaService.callServiceMethod(e.service, e.method, [e.params]));
    })).then(function () {
      return resp;
    });
  };
  return {
    docWithId: function docWithId(id) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!config.params) {
        config.params = {};
      }
      config.params.id = id;
      if (id === PID || config.cache === false) {
        config.params._ = Date.now();
      }
      return callBackend(GET_DOC_ENDPOINT, config).then(function (_ref) {
        var data = _ref.data;
        return data;
      });
    },
    docsOfType: function docsOfType(type) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return callBackend(GET_VIEW_ENDPOINT, {
        method: 'POST',
        params: {
          ddoc: 'core',
          view: 'type'
        },
        data: (0, _lodash.extend)(config, {
          keys: [type],
          include_docs: false
        })
      }).then(function (_ref2) {
        var data = _ref2.data;
        return pluckValues(data);
      }, function () {
        return [];
      });
    },
    docOfTypeAndExtId: function docOfTypeAndExtId(type, extId) {
      return callBackend(GET_VIEW_ENDPOINT, {
        method: 'POST',
        params: {
          ddoc: 'core',
          view: 'extidstype'
        },
        data: {
          include_docs: false,
          keys: [[type, extId]]
        }
      }).then(function (_ref3) {
        var data = _ref3.data;
        return pluckValues(data)[0];
      }, function () {
        return null;
      });
    },
    docsOfTypeAndExtIds: function docsOfTypeAndExtIds(type, extIds) {
      if (!extIds || extIds.length === 0) {
        return $q.when([]);
      }
      var viewParams = {
        include_docs: false,
        keys: (0, _lodash.map)(extIds, function (extId) {
          return [type, extId];
        })
      };
      return callBackend(GET_VIEW_ENDPOINT, {
        method: 'POST',
        params: {
          ddoc: 'core',
          view: 'extidstype'
        },
        data: viewParams
      }).then(function (_ref4) {
        var data = _ref4.data;
        return pluckValues(data);
      }, function () {
        return [];
      });
    },
    saveDoc: function saveDoc(doc) {
      var _this = this;
      var save = function save() {
        savedPromise = callBackend(GET_DOC_ENDPOINT, {
          method: 'POST',
          data: {
            doc: doc
          }
        }).then(function () {
          var _ref5 = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee(resp) {
            var id, currentUser;
            return _regenerator.default.wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  id = resp.data.id;
                  $eventBus.emit("doc:".concat(resp.data.id));
                  $eventBus.emit("type:".concat(doc.fp_type));
                  if (!(id === PID)) {
                    _context.next = 9;
                    break;
                  }
                  _context.next = 6;
                  return _this.docWithId(PID);
                case 6:
                  currentUser = _context.sent;
                  Object.assign(ACTIVATED_PERSON, currentUser);
                  $eventBus.emit('activatedperson_updated');
                case 9:
                  return _context.abrupt("return", resp);
                case 10:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }));
          return function (_x) {
            return _ref5.apply(this, arguments);
          };
        }(), $q.reject);
        return savedPromise;
      };
      if (doc.fp_type === 'person' && !(0, _lodash.isEmpty)(doc.email) && doc.email.toLowerCase() !== ACTIVATED_PERSON.email) {
        $sheet({
          title: $i18n('general.logout'),
          message: (0, _i18nWithFallback.default)($i18n, 'profile_page.logout_required', 'Changing the email address requires logout. You will be able to login again with your new email.<br/>' + '<strong>Important</strong>: Please ensure that you enter the correct email address, ' + 'as you will need it to access the event.'),
          pin: false,
          scrollable: false,
          prompt: true,
          actions: [{
            id: 'logout',
            label: $i18n('general.logout'),
            action: function action(sheet) {
              return save().then(function () {
                return authService.logOut({
                  goToWelcomePage: true
                });
              }).catch(function (err) {
                if ((err.data || {}).error === 'email_used_by_other_user') {
                  sheet.reject();
                  showEmailUsedByOtherUserAlert($sheet, $i18n);
                }
              });
            }
          }, {
            id: 'cancel',
            label: $i18n('general.cancel'),
            action: function action(sheet) {
              return sheet.reject();
            }
          }]
        });
        return $q.reject('Logout required');
      } else {
        return save();
      }
    },
    runAppScript: function runAppScript(scriptName) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var url = "/api/v1/eid/".concat(EID, "/appscripts/").concat(scriptName);
      var shouldBlockInterface = params._blockInterfaceUntilFinished;
      if (shouldBlockInterface) {
        progressBarService.startBlockingTask();
        delete params._blockInterfaceUntilFinished;
      }
      var data = params instanceof FormData ? params : {
        lang: $i18n.lang,
        timezone: deviceTimezone,
        session_id: metricsService === null || metricsService === void 0 ? void 0 : metricsService.sessionId,
        params: params
      };
      return callHttp({
        method: 'POST',
        url: url,
        data: data
      }).then(parseAppScriptEvents, parseAppScriptEvents).finally(function () {
        return shouldBlockInterface ? progressBarService.finishBlockingTask() : null;
      });
    },
    runLifeCycleScripts: function runLifeCycleScripts(stage) {
      if (stage !== 'on-load') {
        throw new Error("Unsupported lifecycle stage ".concat(stage));
      }
      return $http.get("/api/v1/eid/".concat(EID, "/webapp/").concat(stage)).then(function (_ref6) {
        var data = _ref6.data;
        for (var _i = 0, _Object$keys = Object.keys(data); _i < _Object$keys.length; _i++) {
          var appscriptName = _Object$keys[_i];
          var result = data[appscriptName];
          if (result.status === 'error') {
            console.error("Failed to run ".concat(appscriptName, ": ").concat(data[appscriptName].error.message));
          }
          parseAppScriptEvents({
            data: result
          });
        }
      });
    }
  };
}
/* @ngInject */
function HttpJSONPInterceptor($q) {
  return {
    request: function request(config) {
      if (config.method === 'JSONP') {
        var message = 'JSONP in $http is not allowed.';
        console.error(message, config);
        return $q.reject(message);
      }
      return config;
    }
  };
}
angular.module('dbinterface', []).service('databaseService', DatabaseService).factory('httpJSONPInterceptor', HttpJSONPInterceptor).config(['$httpProvider', function ($httpProvider) {
  return $httpProvider.interceptors.push('httpJSONPInterceptor');
}]);

},{"../utils/i18n-with-fallback":359,"@babel/runtime/helpers/asyncToGenerator":375,"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/helpers/toConsumableArray":393,"@babel/runtime/regenerator":398,"lodash":"lodash","moment":"moment"}],249:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var DocumentService = function () {
  DocumentService.$inject = ["navService"];
  /* @ngInject */function DocumentService(navService) {
    (0, _classCallCheck2.default)(this, DocumentService);
    this.navService = navService;
  }
  (0, _createClass2.default)(DocumentService, [{
    key: "open",
    value: function open() {
      console.warn('[DocumentService/open] this method has been deprecated, please use navService.openDocument instead');
      this.navService.openDocument.apply(this.navService, arguments);
    }
  }]);
  return DocumentService;
}();
angular.module('maestro.services').service('documentService', DocumentService);

},{"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382}],250:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _lodash = require("lodash");
var EventBusService = (0, _createClass2.default)( /* @ngInject */["$rootScope", function EventBusService($rootScope) {
  (0, _classCallCheck2.default)(this, EventBusService);
  this.spawn = function (target) {
    if (!target) target = {};
    var eventBus = $rootScope.$new(true);
    target.on = eventBus.$on.bind(eventBus);
    target.on = function (name, handler) {
      return eventBus.$on(name, function (_ev, name, data) {
        return handler(name, data);
      });
    };
    target.emit = function (name, data) {
      console.log('[$eventBus]', name, data);
      eventBus.$emit(name, data);
    };
    target.subscribeToEvents = function (events, callback) {
      var unsubs = (0, _lodash.map)(events, function (e) {
        return eventBus.$on(e, callback);
      }) || [];
      return function () {
        return (0, _lodash.map)(unsubs, function (fn) {
          return fn();
        });
      };
    };
    return target;
  };
  this.spawn(this);
}]);
angular.module('maestro.services').service('$eventBus', EventBusService);

},{"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"lodash":"lodash"}],251:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var FrontstageLoaderService = function () {
  FrontstageLoaderService.$inject = ["EVENT", "$http", "$injector", "$q", "handlerService", "progressBarService", "$ocLazyLoad"];
  /* @ngInject */
  function FrontstageLoaderService(EVENT, $http, $injector, $q, handlerService, progressBarService, $ocLazyLoad) {
    (0, _classCallCheck2.default)(this, FrontstageLoaderService);
    this.event = EVENT;
    this.$http = $http;
    this.$injector = $injector;
    this.$q = $q;
    this.progressBarService = progressBarService;
    this.handlerService = handlerService;
    this.loadingPromise = false;
    this.$ocLazyLoad = $ocLazyLoad;
  }
  (0, _createClass2.default)(FrontstageLoaderService, [{
    key: "loadFstg",
    value: function loadFstg() {
      var _this = this;
      var deferred = this.$q.defer();
      var backendUrl = this.handlerService.generateBackendUrl;
      if (this.$injector.has('pageService')) {
        return this.$q.resolve(true);
      }
      if (this.loadingPromise) {
        return this.loadingPromise;
      }
      this.loadingPromise = deferred.promise;
      this.progressBarService.startTask();
      return this.$http.get(backendUrl('webapp/fstg-all')).then(function (response) {
        var _compiledFstgAssets$f;
        var compiledFstgAssets = response.data;
        var blocks = (_compiledFstgAssets$f = compiledFstgAssets.frontstageBlocks) === null || _compiledFstgAssets$f === void 0 ? void 0 : _compiledFstgAssets$f.blocks;
        delete compiledFstgAssets.frontstageBlocks;
        return angular.module('frontstage.config', []).constant('FSTG_LOADER', 'maestro').constant('COMPILED_FSTG_ASSETS', compiledFstgAssets).constant('BLOCKS', blocks);
      }).then(function () {
        var fstgSrcUrl = backendUrl('webapp/fstg-source');
        return _this.$ocLazyLoad.load('js!' + fstgSrcUrl).then(function () {
          deferred.resolve(true);
        });
      }).finally(function () {
        _this.progressBarService.finishTask();
      });
    }
  }]);
  return FrontstageLoaderService;
}();
angular.module('maestro.services').service('frontstageLoaderService', FrontstageLoaderService);

},{"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382}],252:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var HandlerService = function () {
  HandlerService.$inject = ["EID", "BACKEND_VERSION", "$http", "$httpParamSerializerJQLike", "progressBarService"];
  /* @ngInject */function HandlerService(EID, BACKEND_VERSION, $http, $httpParamSerializerJQLike, progressBarService) {
    (0, _classCallCheck2.default)(this, HandlerService);
    this.EID = EID;
    this.$http = $http;
    this.progressBarService = progressBarService;
    this.generateHandlerUrl = function (handler, params) {
      if (handler === 'webapp/doc' && params && params['id'] && params['attachment']) {
        return "/api/v1/eid/".concat(EID, "/webapp/").concat(params['id'], "/").concat(params['attachment']);
      }
      params = params ? '?' + $httpParamSerializerJQLike(params) : '';
      return "/api/v1/eid/".concat(EID, "/nodehandlers/").concat(handler).concat(params);
    };
    this.generateBackendUrl = function (handler, params) {
      params = params ? '?' + $httpParamSerializerJQLike(params.params || params) : '';
      return "/api/v1/eid/".concat(EID, "/").concat(handler).concat(params);
    };
  }
  (0, _createClass2.default)(HandlerService, [{
    key: "callHandlerRaw",
    value: function callHandlerRaw(method, handler) {
      var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var isHandler = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      if (method.toLowerCase().trim() === 'jsonp') {
        method = 'GET';
        console.warn('[HandlerService/callHandlerRaw] JSONP is deprecated, use GET instead.');
        if (!config.headers) config.headers = {};
        config.headers['json'] = true;
        if (!config.params) config.params = {};
        config.params.callback = 'cb';
      }
      config.method = method;
      config.url = isHandler ? this.generateHandlerUrl(handler) : this.generateBackendUrl(handler);
      if (config.params && config.params._cache === false) {
        config.cache = false;
        delete config.params._cache;
      }
      return this.$http(config);
    }
  }, {
    key: "callHandler",
    value: function callHandler(handler) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var silent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var progressBarService = this.progressBarService;
      if (!silent) progressBarService.startTask();
      return this.callHandlerRaw('GET', handler, {
        params: params
      }).then(function (_ref) {
        var data = _ref.data;
        return data;
      }, function (reason) {
        console.error("[HandlerService] Could not call handle ".concat(handler), reason);
        throw reason;
      }).finally(function () {
        return silent || progressBarService.finishTask();
      });
    }
  }, {
    key: "callBackend",
    value: function callBackend(endpoint) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var silent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var progressBarService = this.progressBarService;
      if (!silent) progressBarService.startTask();
      return this.callHandlerRaw('GET', endpoint, {
        params: params
      }, false).then(function (_ref2) {
        var data = _ref2.data;
        return data;
      }, function (reason) {
        console.error("[HandlerService] Could not call backend ".concat(endpoint), reason);
        throw reason;
      }).finally(function () {
        return silent || progressBarService.finishTask();
      });
    }
  }]);
  return HandlerService;
}();
angular.module('maestro.services').service('handlerService', HandlerService);

},{"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382}],253:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _primus = _interopRequireDefault(require("primus"));
var WebSocketsService = require('./vanilla/webSocketsService').default;
window.APP.services = {
  webSockets: new WebSocketsService(_primus.default)
};
angular.module('maestro.services', []);
require('./appcuesService');
require('./authService');
require('./dataSourceEvaluatorService');
require('./databaseService');
require('./documentService');
require('./eventBusService');
require('./frontstageLoaderService');
require('./handlerService');
require('./liveStreamService');
require('./localCacheService');
require('./mediaDevicesService');
require('./metricsService');
require('./navFormService');
require('./navRouterService');
require('./navService');
require('./notificationsService');
require('./offlineService');
require('./paginatorFactory');
require('./pdfService');
require('./pictureInPictureService');
require('./popoverService');
require('./progressBarService');
require('./reactionsService');
require('./qnaService');
require('./pollService');
require('./sheetService');
require('./styleParserService');
require('./triggerService');
require('./uiService');
require('./videoBreakoutService');
require('./videoCallModeratorService');
require('./videoCallService');
require('./visibilityService');
var TargetingService = require('./targetingService').default;
angular.module('maestro.services').service('targetingService', TargetingService);
var CrashReportingService = require('./crashReportingService').default;
angular.module('maestro.services').service('crashReportingService', CrashReportingService);
var CdnCookiesProvider = require('./cdnCookiesProvider').default;
angular.module('maestro.services').service('cdnCookiesProvider', CdnCookiesProvider);
var LibLoaderService = require('./libLoaderService').default;
angular.module('maestro.services').service('libLoaderService', LibLoaderService);
var VideoPlayerService = require('./videoPlayerService').default;
angular.module('maestro.services').service('videoPlayerService', VideoPlayerService);
var WebsocketConnectionReportingService = require('./websocketConnectionReportingService').default;
angular.module('maestro.services').service('websocketConnectionReportingService', WebsocketConnectionReportingService);
var SignalService = require('./signalService').default;
angular.module('maestro.services').service('signalService', SignalService);

},{"./appcuesService":242,"./authService":243,"./cdnCookiesProvider":245,"./crashReportingService":246,"./dataSourceEvaluatorService":247,"./databaseService":248,"./documentService":249,"./eventBusService":250,"./frontstageLoaderService":251,"./handlerService":252,"./libLoaderService":254,"./liveStreamService":255,"./localCacheService":256,"./mediaDevicesService":257,"./metricsService":258,"./navFormService":259,"./navRouterService":260,"./navService":261,"./notificationsService":273,"./offlineService":274,"./paginatorFactory":275,"./pdfService":276,"./pictureInPictureService":277,"./pollService":278,"./popoverService":279,"./progressBarService":280,"./qnaService":281,"./reactionsService":282,"./sheetService":283,"./signalService":284,"./styleParserService":285,"./targetingService":286,"./triggerService":287,"./uiService":288,"./vanilla/webSocketsService":289,"./videoBreakoutService":290,"./videoCallModeratorService":291,"./videoCallService":292,"./videoPlayerService":294,"./visibilityService":295,"./websocketConnectionReportingService":296,"@babel/runtime/helpers/interopRequireDefault":382,"primus":1238}],254:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lab = _interopRequireDefault(require("frontloader-common/lab"));
var libs = {
  opentok: 'js/opentok.js',
  hive: 'js/hivejs.js',
  hiveHls: 'js/hive-hls-module.js'
};
var LibLoaderService = function () {
  function LibLoaderService() {
    (0, _classCallCheck2.default)(this, LibLoaderService);
    this.loadPromises = {};
  }
  (0, _createClass2.default)(LibLoaderService, [{
    key: "load",
    value: function () {
      var _load = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee(appResource, lib) {
        var path;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              path = libs[lib];
              if (path) {
                _context.next = 3;
                break;
              }
              throw new Error("[LibLoaderService] Library ".concat(lib, " not found"));
            case 3:
              if (!this.loadPromises[lib]) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return", this.loadPromises[lib]);
            case 5:
              path = appResource(path);
              this.loadPromises[lib] = loadLibrary(path);
              return _context.abrupt("return", this.loadPromises[lib]);
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function load(_x, _x2) {
        return _load.apply(this, arguments);
      }
      return load;
    }()
  }]);
  return LibLoaderService;
}();
exports.default = LibLoaderService;
var loadLibrary = function loadLibrary(path) {
  return new Promise(function (resolve, reject) {
    _lab.default.script([path]).wait(function (err) {
      if (err) {
        return reject(err);
      } else {
        resolve();
      }
    });
  });
};

},{"@babel/runtime/helpers/asyncToGenerator":375,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/regenerator":398,"frontloader-common/lab":1110}],255:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _baseService = require("./baseService");
var _lodash = require("lodash");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = (0, _getPrototypeOf2.default)(t); if (r) { var s = (0, _getPrototypeOf2.default)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0, _possibleConstructorReturn2.default)(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var RETRY_START_WATCHING_TIMEOUT = 1000;
var INITIAL_STATE_CACHE_EXPIRE = 10 * 1000;
var PROVIDER_TYPES = {
  RTMPS: 'RTMPS',
  THIRD_PARTY: '3rdparty',
  STUDIO: 'studio',
  STREAMLESS: 'none'
};
var SESSION_TYPES = {
  IN_PERSON: 'in_person',
  REMOTE: 'remote'
};
var LiveStreamService = function (_BaseService) {
  LiveStreamService.$inject = ["ACTIVATED_PERSON", "EID", "$eventBus", "$http", "$timeout", "cdnCookiesProvider", "METADATA"];
  (0, _inherits2.default)(LiveStreamService, _BaseService);
  var _super = _createSuper(LiveStreamService);
  /** @ngInject */
  function LiveStreamService(ACTIVATED_PERSON, EID, $eventBus, $http, $timeout, cdnCookiesProvider, METADATA) {
    var _this;
    (0, _classCallCheck2.default)(this, LiveStreamService);
    _this = _super.call(this, $http);
    _this.ACTIVATED_PERSON = ACTIVATED_PERSON;
    _this.eventId = EID;
    _this.$eventBus = $eventBus;
    _this.$http = $http;
    _this.$timeout = $timeout;
    _this.cdnCookiesProvider = cdnCookiesProvider;
    _this.STREAM_TOGGLE_KEY = 'SHOW_STREAM_{{eid}}';
    _this.liveStreamMetadata = METADATA.live_stream;
    return _this;
  }
  (0, _createClass2.default)(LiveStreamService, [{
    key: "start",
    value: (function () {
      var _start = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee(_ref) {
        var id, fullscreen, _ref$startInPip, startInPip, liveStreamDoc, config;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              id = _ref.id, fullscreen = _ref.fullscreen, _ref$startInPip = _ref.startInPip, startInPip = _ref$startInPip === void 0 ? true : _ref$startInPip;
              _context.next = 3;
              return this.loadConfiguration(id);
            case 3:
              liveStreamDoc = _context.sent;
              config = this.getConfigFromLiveStreamDoc(liveStreamDoc);
              config.fullscreen = fullscreen;
              if (startInPip) {
                console.info('[LiveStreamService] Starting live stream', id);
                this.$eventBus.emit('pip:start', config);
              }
              return _context.abrupt("return", config);
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function start(_x) {
        return _start.apply(this, arguments);
      }
      return start;
    }())
  }, {
    key: "getConfigFromLiveStreamDoc",
    value: function getConfigFromLiveStreamDoc(liveStream) {
      var config = _objectSpread(_objectSpread({}, liveStream), {}, {
        liveStreamId: liveStream.id,
        isInPerson: this.isInPerson(liveStream),
        isThirdParty: this.isThirdParty(liveStream),
        url: (liveStream.url || '').toString()
      });
      delete config.id;
      delete config.who_is_watching;
      delete config.clapping;
      return config;
    }
  }, {
    key: "loadConfiguration",
    value: (function () {
      var _loadConfiguration = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee2(liveStreamId, version) {
        var desiredAttendanceType, userAttendanceType, _yield$this$getWithRe, liveStreamDoc;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              desiredAttendanceType = this.getDesiredAttendanceType();
              userAttendanceType = this.ACTIVATED_PERSON.attendance_type;
              _context2.next = 4;
              return this.getWithRetries("/api/v1/eid/".concat(this.eventId, "/live-stream/").concat(liveStreamId), {
                params: {
                  version: version,
                  desiredAttendanceType: desiredAttendanceType,
                  userAttendanceType: userAttendanceType
                }
              });
            case 4:
              _yield$this$getWithRe = _context2.sent;
              liveStreamDoc = _yield$this$getWithRe.data;
              return _context2.abrupt("return", liveStreamDoc);
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function loadConfiguration(_x2, _x3) {
        return _loadConfiguration.apply(this, arguments);
      }
      return loadConfiguration;
    }())
  }, {
    key: "needsAuthCookies",
    value: function needsAuthCookies(liveStream) {
      return this.isRtmps(liveStream) || this.isStudio(liveStream);
    }
  }, {
    key: "isLiveStream",
    value: function isLiveStream(object) {
      return !(0, _lodash.isEmpty)(object) && object.hasOwnProperty('is_live');
    }
  }, {
    key: "isStudio",
    value: function isStudio(liveStream) {
      if (!this.isLiveStream(liveStream)) {
        return false;
      }
      return (0, _lodash.get)(liveStream, 'provider', '') === PROVIDER_TYPES.STUDIO || (0, _lodash.get)(liveStream, 'use_studio', false);
    }
  }, {
    key: "isThirdParty",
    value: function isThirdParty(liveStream) {
      if (!this.isLiveStream(liveStream)) {
        return false;
      }
      return (0, _lodash.get)(liveStream, 'provider', '') === PROVIDER_TYPES.THIRD_PARTY || (0, _lodash.get)(liveStream, 'is_third_party', false);
    }
  }, {
    key: "isHybrid",
    value: function isHybrid(liveStream) {
      return (0, _lodash.get)(liveStream, 'session_type') === 'HYBRID';
    }
  }, {
    key: "isToggleStreamTabEnabled",
    value: function isToggleStreamTabEnabled(liveStream) {
      return this.isHybrid(liveStream) && (0, _lodash.get)(this.liveStreamMetadata, 'toggle_stream_visibility_enabled');
    }
  }, {
    key: "getDesiredAttendanceType",
    value: function getDesiredAttendanceType() {
      var currentKey = this.STREAM_TOGGLE_KEY.replace('{{eid}}', this.eventId);
      var storedKeyValue;
      try {
        storedKeyValue = JSON.parse(localStorage.getItem(currentKey));
      } catch (e) {
        console.error(e);
      }
      if (storedKeyValue) {
        console.info('[liveStreamService] Resolved session type with local storage:', storedKeyValue);
        return storedKeyValue.showStream ? SESSION_TYPES.REMOTE : SESSION_TYPES.IN_PERSON;
      }
    }
  }, {
    key: "isInPerson",
    value: function isInPerson(liveStream) {
      return (0, _lodash.get)(liveStream, 'resolved_session_type', 'remote') === SESSION_TYPES.IN_PERSON;
    }
  }, {
    key: "isRtmps",
    value: function isRtmps(liveStream) {
      if (!this.isLiveStream(liveStream)) {
        return false;
      }
      return (0, _lodash.get)(liveStream, 'provider', '') === PROVIDER_TYPES.RTMPS;
    }
  }, {
    key: "getInitialState",
    value: function getInitialState(liveStreamId) {
      return this.getCachedOrMakeRequest("/api/v1/eid/".concat(this.eventId, "/live-stream/").concat(liveStreamId, "/initial-state"), INITIAL_STATE_CACHE_EXPIRE);
    }
  }, {
    key: "isUpvotingAllowed",
    value: function isUpvotingAllowed() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return config.qna_upvoting_enabled && !this.isVod(config) && !this.isFinished(config);
    }
  }, {
    key: "isVod",
    value: function isVod() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return !!config.liveStreamId && !!config.is_published && !!config.is_live;
    }
  }, {
    key: "isLive",
    value: function isLive() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return !!config.liveStreamId && !!config.is_live;
    }
  }, {
    key: "isFinished",
    value: function isFinished() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return !!config.is_finished;
    }
  }, {
    key: "sendStartWatching",
    value: function sendStartWatching(livestreamId) {
      var _this2 = this;
      var retry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      this.$timeout.cancel(this.startWatchingTimeout);
      if (!livestreamId) {
        return;
      }
      var url = "/api/v1/eid/".concat(this.eventId, "/live-stream/").concat(livestreamId, "/start-watching");
      this.$http.post(url).catch(function () {
        if (retry < 5) {
          retry++;
          _this2.startWatchingTimeout = _this2.$timeout(function () {
            return _this2.sendStartWatching(livestreamId, retry);
          }, retry * RETRY_START_WATCHING_TIMEOUT);
        }
      });
    }
  }, {
    key: "sendStopWatching",
    value: function sendStopWatching(livestreamId) {
      this.$timeout.cancel(this.startWatchingTimeout);
      if (!livestreamId) {
        return;
      }
      var url = "/api/v1/eid/".concat(this.eventId, "/live-stream/").concat(livestreamId, "/stop-watching");
      navigator.sendBeacon(url);
    }
  }, {
    key: "getWithRetries",
    value: function getWithRetries(url, params) {
      var _this3 = this;
      var maxRetries = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3;
      var makeRequest = function makeRequest() {
        var retries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : maxRetries;
        return _this3.$http.get(url, params).catch(function (err) {
          console.error("getting ".concat(url, " failed, retrying"), err);
          if (retries === 1) {
            throw err;
          }
          return _this3.$timeout(function () {
            return makeRequest(retries - 1);
          }, 5000);
        });
      };
      return makeRequest();
    }
  }, {
    key: "getSlideImageUrl",
    value: function () {
      var _getSlideImageUrl = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee3(slideshowDocId, slideIndex) {
        var baseSlideCdnUrl;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.cdnCookiesProvider.getCookiesForDirectory(slideshowDocId);
            case 2:
              baseSlideCdnUrl = _context3.sent;
              return _context3.abrupt("return", "".concat(baseSlideCdnUrl, "/desktop/image").concat(slideIndex, ".jpeg"));
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getSlideImageUrl(_x4, _x5) {
        return _getSlideImageUrl.apply(this, arguments);
      }
      return getSlideImageUrl;
    }()
  }]);
  return LiveStreamService;
}(_baseService.BaseService);
angular.module('maestro.services').service('liveStreamService', LiveStreamService);

},{"./baseService":244,"@babel/runtime/helpers/asyncToGenerator":375,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/defineProperty":378,"@babel/runtime/helpers/getPrototypeOf":380,"@babel/runtime/helpers/inherits":381,"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/helpers/possibleConstructorReturn":387,"@babel/runtime/regenerator":398,"lodash":"lodash"}],256:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _localCache = _interopRequireDefault(require("../utils/localCache"));
var LocalCacheFactory = (0, _createClass2.default)( /* @ngInject */["EID", "PID", function LocalCacheFactory(EID, PID) {
  (0, _classCallCheck2.default)(this, LocalCacheFactory);
  return function (id) {
    return (0, _localCache.default)("".concat(EID, ":").concat(PID, "/").concat(id));
  };
}]);
angular.module('maestro.services').service('localCacheFactory', LocalCacheFactory);

},{"../utils/localCache":360,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382}],257:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var DEVICE_CHANGE_EVENT = 'device-change';
var MediaDevicesService = function () {
  MediaDevicesService.$inject = ["$eventBus", "localCacheFactory"];
  /* @ngInject */
  function MediaDevicesService($eventBus, localCacheFactory) {
    var _this = this;
    (0, _classCallCheck2.default)(this, MediaDevicesService);
    this.$eventBus = $eventBus;
    this.devicesError = null;
    this.audioDevices = [];
    this.videoDevices = [];
    this.audioDeviceSelected = null;
    this.videoDeviceSelected = null;
    this.streamsWithAudio = [];
    this.streamsWithVideo = [];
    this.mediaDevicesProvider = navigator.mediaDevices;
    this.lastSelectedDeviceCache = localCacheFactory('breakout/device');
    this.mediaDevicesProvider.ondevicechange = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee() {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            console.log('[MediaDevicesService] Detected a change of devices');
            _context.next = 3;
            return _this.storeDeviceList();
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    this.listeners = [];
    this.storeDeviceList();
  }
  (0, _createClass2.default)(MediaDevicesService, [{
    key: "getDeviceList",
    value: function getDeviceList() {
      return {
        audioDevices: this.audioDevices,
        videoDevices: this.videoDevices,
        error: this.devicesError
      };
    }
  }, {
    key: "storeDeviceList",
    value: function () {
      var _storeDeviceList = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee2() {
        var _this2 = this;
        var retry,
          devices,
          cleanUpDevices,
          audioDevices,
          videoDevices,
          audioDeviceLabel,
          videoDeviceLabel,
          _args2 = arguments;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              retry = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : 0;
              this.devicesError = null;
              _context2.prev = 2;
              _context2.next = 5;
              return this.mediaDevicesProvider.enumerateDevices();
            case 5:
              devices = _context2.sent;
              cleanUpDevices = function cleanUpDevices(devices) {
                return devices.map(function (_ref2) {
                  var deviceId = _ref2.deviceId,
                    label = _ref2.label;
                  return {
                    deviceId: deviceId,
                    label: label
                  };
                }).filter(function (_ref3) {
                  var deviceId = _ref3.deviceId;
                  return deviceId !== 'default';
                });
              };
              audioDevices = cleanUpDevices(devices.filter(function (input) {
                return input.kind === 'audioinput' && input.deviceId;
              }));
              videoDevices = cleanUpDevices(devices.filter(function (input) {
                return input.kind === 'videoinput' && input.deviceId;
              }));
              this.audioDevices = audioDevices || [];
              this.videoDevices = videoDevices || [];
              console.log('[MediaDevicesService] stored device list');
              audioDeviceLabel = (0, _lodash.get)(this, 'audioDevices[0].label');
              videoDeviceLabel = (0, _lodash.get)(this, 'videoDevices[0].label');
              if (retry < 5 && (audioDeviceLabel === '' || videoDeviceLabel === '')) {
                retry++;
                console.warn('[MediaDevicesService] stored device list: due to temporary device permission on firefox, label was empty', {
                  retry: retry
                });
                this.retryStoreDeviceListTimeout = setTimeout(function () {
                  _this2.storeDeviceList(retry);
                }, 1000);
              } else {
                clearTimeout(this.retryStoreDeviceListTimeout);
              }
              this.selectDefaultVideo();
              this.selectDefaultAudio();
              this.updateSelectedDeviceName();
              _context2.next = 27;
              break;
            case 20:
              _context2.prev = 20;
              _context2.t0 = _context2["catch"](2);
              console.error('[MediaDevicesService] Failed to retrieve the devices', _context2.t0);
              clearTimeout(this.retryStoreDeviceListTimeout);
              this.audioDevices = [];
              this.videoDevices = [];
              this.devicesError = _context2.t0;
            case 27:
              this.$eventBus.emit(DEVICE_CHANGE_EVENT, this.getDeviceList());
            case 28:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[2, 20]]);
      }));
      function storeDeviceList() {
        return _storeDeviceList.apply(this, arguments);
      }
      return storeDeviceList;
    }()
  }, {
    key: "updateSelectedDeviceName",
    value: function updateSelectedDeviceName() {
      try {
        if (this.audioDeviceSelected) {
          var _iterator = _createForOfIteratorHelper(this.audioDevices),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var device = _step.value;
              if (device.deviceId === this.audioDeviceSelected.deviceId && device.label !== '') {
                this.audioDeviceSelected.label = device.label;
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
        if (this.videoDeviceSelected) {
          var _iterator2 = _createForOfIteratorHelper(this.videoDevices),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _device = _step2.value;
              if (_device.deviceId === this.videoDeviceSelected.deviceId && _device.label !== '') {
                this.videoDeviceSelected.label = _device.label;
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      } catch (e) {
        console.error(e);
      }
    }
  }, {
    key: "selectDevice",
    value: function selectDevice(type, device) {
      if (type === 'audio') {
        if (this.audioDeviceSelected && device && device.deviceId === this.audioDeviceSelected.deviceId) {
          return;
        }
        if (this.isDeviceValid(this.audioDevices, device)) {
          this.audioDeviceSelected = device;
          this.lastSelectedDeviceCache.put('audioDeviceIdSelected', device.deviceId);
        } else {
          this.audioDeviceSelected = null;
        }
      } else if (type === 'video') {
        if (this.videoDeviceSelected && device && device.deviceId === this.videoDeviceSelected.deviceId) {
          return;
        }
        if (this.isDeviceValid(this.videoDevices, device)) {
          this.videoDeviceSelected = device;
          this.lastSelectedDeviceCache.put('videoDeviceIdSelected', device.deviceId);
        } else {
          this.videoDeviceSelected = null;
        }
      }
    }
  }, {
    key: "selectDefaultVideo",
    value: function selectDefaultVideo() {
      if (!this.videoDevices.length || this.isDeviceValid(this.videoDevices, this.videoDeviceSelected)) {
        return;
      }
      var deviceId = this.lastSelectedDeviceCache.get('videoDeviceIdSelected');
      var lastSelectedDevice = this.videoDevices.find(function (device) {
        return device.deviceId === deviceId;
      });
      if (lastSelectedDevice) {
        this.videoDeviceSelected = lastSelectedDevice;
      } else {
        this.videoDeviceSelected = this.videoDevices[0];
      }
    }
  }, {
    key: "selectDefaultAudio",
    value: function selectDefaultAudio() {
      if (!this.audioDevices.length || this.isDeviceValid(this.audioDevices, this.audioDeviceSelected)) {
        return;
      }
      var deviceId = this.lastSelectedDeviceCache.get('audioDeviceIdSelected');
      var lastSelectedDevice = this.audioDevices.find(function (device) {
        return device.deviceId === deviceId;
      });
      if (lastSelectedDevice) {
        this.audioDeviceSelected = lastSelectedDevice;
      } else {
        this.audioDeviceSelected = this.audioDevices[0];
      }
    }
  }, {
    key: "selectDefaultDevices",
    value: function selectDefaultDevices() {
      this.selectDefaultAudio();
      this.selectDefaultVideo();
    }
  }, {
    key: "isDeviceValid",
    value: function isDeviceValid(deviceList, device) {
      if (!device || !device.deviceId || !deviceList || !deviceList.length) {
        return false;
      }
      var deviceIds = deviceList.map(function (device) {
        return device.deviceId;
      });
      return deviceIds.includes(device.deviceId);
    }
  }, {
    key: "onDevicesChange",
    value: function onDevicesChange(handler) {
      console.log("[MediaDevicesService] New subscription to '".concat(DEVICE_CHANGE_EVENT, "'"));
      if (!handler || !(0, _lodash.isFunction)(handler)) {
        return;
      }
      return this.$eventBus.on(DEVICE_CHANGE_EVENT, handler);
    }
  }, {
    key: "getUserMedia",
    value: (function () {
      var _getUserMedia = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee3(constraints) {
        var stream;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              console.log('[MediaDevicesService] getUserMedia');
              if (constraints.audio) {
                this.stopStreamsWithAudio();
              }
              if (constraints.video) {
                this.stopStreamsWithVideo();
              }
              _context3.prev = 3;
              _context3.next = 6;
              return this.mediaDevicesProvider.getUserMedia(constraints);
            case 6:
              stream = _context3.sent;
              _context3.next = 13;
              break;
            case 9:
              _context3.prev = 9;
              _context3.t0 = _context3["catch"](3);
              if (_context3.t0.name === 'NotFoundError' || _context3.t0.name === 'DevicesNotFoundError') {
                console.error('[MediaDevicesService] getUserMedia error: required track is missing');
              } else if (_context3.t0.name === 'NotReadableError' || _context3.t0.name === 'TrackStartError') {
                console.error('[MediaDevicesService] getUserMedia error: webcam or mic are already in use');
              } else if (_context3.t0.name === 'OverconstrainedError' || _context3.t0.name === 'ConstraintNotSatisfiedError') {
                console.error('[MediaDevicesService] getUserMedia error: constraints can not be satisfied by avb. devices');
              } else if (_context3.t0.name === 'NotAllowedError' || _context3.t0.name === 'PermissionDeniedError') {
                console.error('[MediaDevicesService] getUserMedia error: permission denied in browser');
              } else if (_context3.t0.name === 'TypeError') {
                console.error('[MediaDevicesService] getUserMedia error: empty constraints object');
              } else {
                console.error('[MediaDevicesService] getUserMedia error:', _context3.t0);
              }
              throw _context3.t0;
            case 13:
              if (constraints.audio) {
                this.streamsWithAudio.push(stream);
              }
              if (constraints.video) {
                this.streamsWithVideo.push(stream);
              }
              return _context3.abrupt("return", stream);
            case 16:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[3, 9]]);
      }));
      function getUserMedia(_x) {
        return _getUserMedia.apply(this, arguments);
      }
      return getUserMedia;
    }())
  }, {
    key: "requestPermissions",
    value: (function () {
      var _requestPermissions = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee4() {
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.permissions = {
                audio: true,
                video: true
              };
              _context4.prev = 1;
              _context4.next = 4;
              return this.getUserMedia({
                audio: true
              });
            case 4:
              _context4.next = 9;
              break;
            case 6:
              _context4.prev = 6;
              _context4.t0 = _context4["catch"](1);
              this.permissions.audio = false;
            case 9:
              _context4.prev = 9;
              _context4.next = 12;
              return this.getUserMedia({
                video: true
              });
            case 12:
              _context4.next = 17;
              break;
            case 14:
              _context4.prev = 14;
              _context4.t1 = _context4["catch"](9);
              this.permissions.video = false;
            case 17:
              this.stopAllStreams();
              _context4.next = 20;
              return this.storeDeviceList();
            case 20:
              return _context4.abrupt("return", this.permissions);
            case 21:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[1, 6], [9, 14]]);
      }));
      function requestPermissions() {
        return _requestPermissions.apply(this, arguments);
      }
      return requestPermissions;
    }())
  }, {
    key: "stopStreamsWithAudio",
    value: function stopStreamsWithAudio() {
      this.stopAllStreamTracks(this.streamsWithAudio);
    }
  }, {
    key: "stopStreamsWithVideo",
    value: function stopStreamsWithVideo() {
      this.stopAllStreamTracks(this.streamsWithVideo);
    }
  }, {
    key: "stopAllStreams",
    value: function stopAllStreams() {
      this.stopStreamsWithVideo();
      this.stopStreamsWithAudio();
    }
  }, {
    key: "stopVideoElement",
    value: function stopVideoElement(videoEl) {
      var killStream = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      console.log('[MediaDevicesService] stop video element');
      if (videoEl) {
        try {
          videoEl.pause();
        } catch (error) {}
        try {
          if (killStream) {
            var stream = videoEl.srcObject;
            this.stopAllStreamTracks([stream]);
          }
          videoEl.srcObject = null;
        } catch (error) {
          console.warn('[MediaDevicesService] stopVideoElement error', error);
        }
      }
    }
  }, {
    key: "stopAllStreamTracks",
    value: function stopAllStreamTracks(streams) {
      if (!streams || !streams.length) {
        return;
      }
      var _iterator3 = _createForOfIteratorHelper(streams),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var stream = _step3.value;
          if (!stream) {
            continue;
          }
          if ((0, _lodash.isFunction)(stream.getTracks)) {
            var _iterator4 = _createForOfIteratorHelper(stream.getTracks()),
              _step4;
            try {
              for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                var track = _step4.value;
                if ((0, _lodash.isFunction)(track.stop)) {
                  track.stop();
                }
              }
            } catch (err) {
              _iterator4.e(err);
            } finally {
              _iterator4.f();
            }
          }
          if ((0, _lodash.isFunction)(stream.stop)) {
            stream.stop();
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }]);
  return MediaDevicesService;
}();
exports.default = MediaDevicesService;
angular.module('maestro.services').service('mediaDevicesService', MediaDevicesService);

},{"@babel/runtime/helpers/asyncToGenerator":375,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/regenerator":398,"lodash":"lodash"}],258:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _uuid = require("uuid");
var _lodash = require("lodash");
MetricsService.$inject = ["$window", "$http", "$cookies", "EID", "PID", "SETTINGS", "ACTIVATED_PERSON", "BRANDING", "EVENT", "ANALYTICS_ENDPOINT"];
/* @ngInject */
function MetricsService($window, $http, $cookies, EID, PID, SETTINGS, ACTIVATED_PERSON, BRANDING, EVENT, ANALYTICS_ENDPOINT) {
  var sessionId = (0, _uuid.v4)();
  var stopTracking = function stopTracking() {
    var beacons = Object.keys($cookies.getAll()).filter(function (c) {
      return c.startsWith('mp_');
    });
    beacons.forEach(function (b) {
      var host = location.host.replace(/(:[0-9]{1,5})?$/, '');
      $cookies.remove(b, {
        domain: ".".concat(host)
      });
      var tld = host.split('.');
      tld.shift();
      tld = tld.join('.');
      $cookies.remove(b, {
        domain: ".".concat(tld)
      });
    });
  };
  var isTrackingForbidden = function isTrackingForbidden() {
    return ACTIVATED_PERSON.do_not_track || EVENT.show_cookie_banner && $cookies.get('cookies-policy') !== '1';
  };
  if (isTrackingForbidden()) {
    stopTracking();
  }
  var sendDeviceStatus = function sendDeviceStatus() {
    var url = "/api/v1/eid/".concat(EID, "/log/app/status");
    var postData = {
      platform: 'web',
      device: 'web',
      device_id: "".concat(EID, "-").concat(PID, "-browser"),
      browser_version: $window.navigator.userAgent,
      system_locale: $window.navigator.language,
      app_version: "1.156.0"
    };
    return $http.post(url, postData).catch(function (err) {
      return console.error('[metricsService] Failed to send device status', err);
    });
  };
  sendDeviceStatus();
  var init = function init() {};
  var track = function track() {
    console.log('[MetricsService] depreciated track() called');
  };
  var startTrack = function startTrack() {
    console.log('[MetricsService] depreciated startTrack() called');
  };
  var endTrack = function endTrack() {
    console.log('[MetricsService] depreciated endTrack() called');
  };
  var trackAnalytics = function trackAnalytics(event) {
    if (!ANALYTICS_ENDPOINT) {
      return;
    }
    return $http.post(ANALYTICS_ENDPOINT, Object.assign({
      app_version: "1.156.0",
      session_id: sessionId
    }, event)).catch(function (err) {
      return console.error('[metricsService] Failed to send analytics', err);
    });
  };
  var tryCatchWrapper = function tryCatchWrapper(f) {
    if (!(0, _lodash.isFunction)(f)) {
      return f;
    }
    return (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee() {
      var _args = arguments;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return f.apply(void 0, _args);
          case 3:
            return _context.abrupt("return", _context.sent);
          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](0);
            console.error("[metricsService] ".concat(f.name, " error"), _context.t0);
          case 9:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 6]]);
    }));
  };
  return {
    init: tryCatchWrapper(init),
    track: tryCatchWrapper(track),
    startTrack: tryCatchWrapper(startTrack),
    endTrack: tryCatchWrapper(endTrack),
    stopTracking: tryCatchWrapper(stopTracking),
    trackAnalytics: tryCatchWrapper(trackAnalytics),
    get sessionId() {
      return sessionId;
    }
  };
}
angular.module('maestro.services.metrics', ['dbinterface']).service('metricsService', MetricsService);

},{"@babel/runtime/helpers/asyncToGenerator":375,"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/regenerator":398,"lodash":"lodash","uuid":1222}],259:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var NavFormService = function () {
  NavFormService.$inject = ["$eventBus"];
  /* @ngInject */
  function NavFormService($eventBus) {
    (0, _classCallCheck2.default)(this, NavFormService);
    this.$$forms = {};
    this.$eventBus = $eventBus;
  }
  (0, _createClass2.default)(NavFormService, [{
    key: "get",
    value: function get(navId) {
      var store = this.$$forms[navId];
      if (!store) {
        return this.$$forms[navId] = {};
      }
      return store;
    }
  }, {
    key: "set",
    value: function set(navId, key, value) {
      if (!navId || !key) return;
      this.get(navId)[key] = value;
      this.$eventBus.emit('sheet:form-data-changed', true);
    }
  }, {
    key: "getRequiredFields",
    value: function getRequiredFields(navId) {
      var store = this.$$forms["".concat(navId, "-required-fields")];
      if (!store) {
        return this.$$forms["".concat(navId, "-required-fields")] = {};
      }
      return store;
    }
  }, {
    key: "setRequiredField",
    value: function setRequiredField(navId, key, value) {
      if (!navId || !key) return;
      this.get("".concat(navId, "-required-fields"))[key] = value;
    }
  }, {
    key: "getPreSelectedFile",
    value: function getPreSelectedFile() {
      var store = this.$$forms['selected-file'];
      if (!store) {
        return this.$$forms['selected-file'] = {};
      }
      return store;
    }
  }, {
    key: "setPreSelectedFile",
    value: function setPreSelectedFile(key, value) {
      if (!key) return;
      this.get('selected-file')[key] = value;
    }
  }, {
    key: "destroy",
    value: function destroy(navId) {
      delete this.$$forms[navId];
    }
  }]);
  return NavFormService;
}();
exports.default = NavFormService;
angular.module('maestro.services').service('navFormService', NavFormService);

},{"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382}],260:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
var _handlebars = _interopRequireDefault(require("handlebars"));
var _unflattenObject = _interopRequireDefault(require("../utils/unflattenObject"));
var _uuid = require("uuid");
var ROUTES = {};
var ROUTE_TESTS = {};
var COMPILED_ROUTES = {};
var ignoreNextUrlChange = null;
var NavRouterService = function () {
  NavRouterService.$inject = ["EVENT_NAVS", "$location", "$rootScope", "$timeout"];
  /* @ngInject */
  function NavRouterService(EVENT_NAVS, $location, $rootScope, $timeout) {
    (0, _classCallCheck2.default)(this, NavRouterService);
    this.eventNavs = EVENT_NAVS;
    this.$location = $location;
    this.$rootScope = $rootScope;
    this.$timeout = $timeout;
    this.NAV_VERSION = 2;
  }
  (0, _createClass2.default)(NavRouterService, [{
    key: "setUrlForNav",
    value: function setUrlForNav(nav, navService) {
      var _this = this;
      var currentUrl = this.$location.$$url;
      if (!nav.route || nav.set_route === false) {
        this.$location.url(currentUrl);
        return;
      }
      var urlFn = COMPILED_ROUTES[nav._id];
      var url = currentUrl;
      if ((0, _lodash.isFunction)(urlFn)) {
        url = urlFn(nav);
      }
      if (nav._dynamic_nav) {
        if (!decodeURIComponent(url).includes('#_dynamic')) {
          url = url + (nav.nuid ? "#".concat(nav.nuid) : '#_dynamic_' + (0, _uuid.v4)());
          this.eventNavs[nav.nuid] = nav;
        }
      }
      if (this.$location.$$url === url) return;
      if (nav.modal) {
        url = url + '?modal';
      }
      console.log('[navRouterService] url set to', url);
      ignoreNextUrlChange = url;
      try {
        var _nav = (0, _lodash.cloneDeep)(navService.activeNav.nav);
        var sheets = (0, _lodash.cloneDeep)(navService.getSavedSheets());
        this.$location.state(JSON.stringify({
          nav: _nav,
          sheets: sheets,
          version: this.NAV_VERSION
        }));
      } catch (error) {
        console.warn('[navRouterService] browser does not support HTML5 history', error);
      }
      if (currentUrl.includes('?modal')) {
        this.$timeout(function () {
          _this.$location.url(url);
          _this.$rootScope.$apply();
        });
      } else {
        this.$location.url(url);
      }
    }
  }, {
    key: "extractNavFromUrl",
    value: function extractNavFromUrl(url) {
      var _this$extractNavIdAnd = this.extractNavIdAndParamsFromUrl(url),
        navId = _this$extractNavIdAnd.navId,
        routeParams = _this$extractNavIdAnd.routeParams;
      if (!navId) return {};
      var nav = (0, _unflattenObject.default)(routeParams, (0, _lodash.cloneDeep)(this.eventNavs[navId]));
      if (!nav) return {};
      if (nav.model_route_param) {
        nav.model_id = routeParams[nav.model_route_param];
      }
      return nav;
    }
  }, {
    key: "extractNavIdAndParamsFromUrl",
    value: function extractNavIdAndParamsFromUrl(url) {
      if (url.includes('#_dynamic_')) {
        var _url$split = url.split('#'),
          _url$split2 = (0, _slicedToArray2.default)(_url$split, 2),
          nid = _url$split2[1];
        return {
          navId: nid,
          routeParams: {}
        };
      }
      var navId = this.extractNavIdFromUrl(url);
      if (!navId) return {};
      var route = ROUTES[navId];
      var test = ROUTE_TESTS[navId];
      var mustacheShaver = /{|}/g;
      var paramKeys = (0, _lodash.map)(route.match(test).slice(1), function (param) {
        return param.replace(mustacheShaver, '');
      });
      var paramValues = url.match(test).slice(1);
      var routeParams = (0, _lodash.zipObject)(paramKeys, paramValues);
      return {
        navId: navId,
        routeParams: routeParams
      };
    }
  }, {
    key: "extractNavIdFromUrl",
    value: function extractNavIdFromUrl(url) {
      var matchedRoutes = (0, _lodash.filter)(ROUTE_TESTS, function (t) {
        return t.test(url);
      }).sort(function (a, b) {
        var al = a.toString().length,
          bl = b.toString().length;
        var res = al < bl ? 1 : -1;
        return al === bl && /\(\.\*\)/.test(b) ? -1 : res;
      });
      return (0, _lodash.findKey)(ROUTE_TESTS, function (t) {
        return t === matchedRoutes[0];
      });
    }
  }]);
  return NavRouterService;
}();
var modalUrl = function modalUrl(url, oldUrl) {
  var urlHasModal = (url || '').includes('?modal');
  var oldUrlHasModal = (oldUrl || '').includes('?modal');
  if (url !== oldUrl || urlHasModal || oldUrlHasModal) {
    var bothModal = urlHasModal && oldUrlHasModal;
    return bothModal || url.split('?modal')[0] === oldUrl.split('?modal')[0];
  }
  return false;
};
var buildNavRoutes = /* @ngInject */function buildNavRoutes(EVENT_NAVS, EID, ROUTE_PREFIX, HOME_NAV, $rootScope, $location, $timeout, navService, navRouterService) {
  var TEMPL_REGEX = /{{[^}}]+}}/g;
  var prefix = "".concat(ROUTE_PREFIX, "/").concat(EID);
  (0, _lodash.each)(EVENT_NAVS, function (_ref, id) {
    var route = _ref.route;
    if (!route) return;
    route = prefix + route;
    ROUTES[id] = route;
    ROUTE_TESTS[id] = new RegExp(route.replace(TEMPL_REGEX, '(.*)'));
    COMPILED_ROUTES[id] = _handlebars.default.compile(route);
  });
  var firstLocationChange = false;
  $rootScope.$on('$locationChangeStart', function (event, url, oldUrl, newState) {
    var parsedState = newState ? JSON.parse(newState) : {};
    if (!firstLocationChange && url.includes('?modal')) {
      url = url.split('?')[0];
      oldUrl = oldUrl.split('?')[0];
    }
    firstLocationChange = true;
    var path = $location.path() + ($location.hash() ? "#".concat($location.hash()) : '');
    if ($location.search().modal) {
      path += '?modal';
    }
    if (url !== oldUrl && path.substr(0, prefix.length) !== prefix) {
      console.warn("[navRouter] Path ".concat(path, " does not match current event prefix (").concat(prefix, "), reloading."));
      return navService.reload();
    }
    if (ignoreNextUrlChange === path) {
      ignoreNextUrlChange = null;
      return;
    }
    if (modalUrl(url, oldUrl)) {
      var lastSheetId = navService.getLastSheetId();
      var lastSheet = navService.getSavedSheets().filter(function (sheet) {
        return sheet.sheetId === lastSheetId;
      });
      var bothModal = url && oldUrl && url.includes('?modal') && oldUrl.includes('?modal');
      if (!bothModal && navService.$sheet.hasOpenSheets() && oldUrl.includes('?modal') && lastSheet.length > 0) {
        event.preventDefault();
        navService.closeLastNav();
        navService.removeSavedSheet(navService.getLastSheetId());
      } else if (!navService.$sheet.hasOpenSheets() && url.includes('?modal')) {
        event.preventDefault();
      }
      return;
    }
    $rootScope.$emit('navigate');
    var nav = navRouterService.extractNavFromUrl(url);
    if (newState && !nav.model_route_param) {
      var _nav2 = parsedState.nav,
        sheets = parsedState.sheets,
        version = parsedState.version;
      if (version === navRouterService.NAV_VERSION) {
        if (!url.includes('?modal') && sheets.find(function (sheet) {
          return sheet.modal;
        })) {
          return navService.applyNavs(_nav2, []);
        }
        return navService.applyNavs(_nav2, sheets);
      }
    }
    if (!url || !url.length) {
      return navService.resetNavigation();
    }
    if (!nav || (0, _lodash.isEmpty)(nav)) {
      console.log('[navRouter] unknown route', url, 'returning home');
      return navService.resetNavigation();
    }
    if (nav.route === HOME_NAV.route) {
      return navService.resetNavigation();
    }
    if (nav.modal) {
      navService.resetNavigation();
      $timeout(function () {
        return navService.openNav(nav);
      });
    } else if (nav.model_id && nav.page_id !== 'profile' && nav.fp_ext_id !== 'nav_app_search') {
      navService.openDocument({
        id: nav.model_id
      });
    } else if (nav._id === 'nav_video_content' && nav.video_id && !(nav.url || nav.media_url)) {
      navService.openDocument({
        id: nav.video_id
      });
    } else {
      navService.presentNav(nav);
    }
  });
  $rootScope.$on('$locationChangeSuccess', function (_, url, oldUrl) {
    if (!modalUrl(url, oldUrl)) {
      window.scrollTo(0, 0);
    }
  });
};
buildNavRoutes.$inject = ["EVENT_NAVS", "EID", "ROUTE_PREFIX", "HOME_NAV", "$rootScope", "$location", "$timeout", "navService", "navRouterService"];
angular.module('maestro.navs.router', ['maestro.navs.types']).service('navRouterService', NavRouterService).run(buildNavRoutes);

},{"../utils/unflattenObject":368,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/helpers/slicedToArray":390,"handlebars":"handlebars","lodash":"lodash","uuid":1222}],261:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _lodash = require("lodash");
var _mixin = _interopRequireDefault(require("../utils/mixin"));
var _localCache = _interopRequireDefault(require("../utils/localCache"));
applyActivationConfig.$inject = ["EVENT_NAVS", "EID", "PID", "navService", "databaseService"];
var bind = Function.prototype.bind;
var mixins = (0, _lodash.map)([require('./navs/actions'), require('./navs/activate-event'), require('./navs/appscript'), require('./navs/events'), require('./navs/externals'), require('./navs/inflator'), require('./navs/integrations'), require('./navs/misc'), require('./navs/open-doc'), require('./navs/ops'), require('./navs/ui')], function (r) {
  return r.default;
});
var NavService = (0, _createClass2.default)(function NavService() {
  var _arguments = arguments;
  (0, _classCallCheck2.default)(this, NavService);
  var deps = {};
  var instance = this;
  (0, _lodash.each)(NavService.$inject, function (dep, i) {
    return deps[dep] = _arguments[i];
  });
  (0, _lodash.each)(mixins, function (NavPartial) {
    var $inject = (NavPartial.$inject || []).map(function (dep) {
      return deps[dep];
    });
    try {
      var partial = new (bind.apply(NavPartial, [null].concat($inject)))();
      (0, _lodash.extend)(instance, partial);
    } catch (e) {
      console.warn("Failed to initialize ".concat(NavPartial.name), e);
    }
  });
});
(0, _lodash.reduce)(mixins, _mixin.default, NavService);

/* @ngInject */
function applyActivationConfig(EVENT_NAVS, EID, PID, navService, databaseService) {
  var cache = (0, _localCache.default)('applyActivationConfig');
  if (cache.get('activated') === "".concat(EID, ":").concat(PID)) {
    return;
  }
  cache.put('activated', "".concat(EID, ":").concat(PID));
  var activationConfig = EVENT_NAVS['actstoryboard_config'];
  if (activationConfig && activationConfig.document) {
    return navService.openDocument(activationConfig.document);
  } else if (activationConfig && activationConfig.edit_profile) {
    return databaseService.runAppScript('actions/edit-profile');
  }
}
angular.module('maestro.navs', ['maestro.navs.templates', 'maestro.navs.router']).service('navService', NavService).run(applyActivationConfig);

},{"../utils/localCache":360,"../utils/mixin":364,"./navs/actions":262,"./navs/activate-event":263,"./navs/appscript":264,"./navs/events":265,"./navs/externals":266,"./navs/inflator":267,"./navs/integrations":268,"./navs/misc":269,"./navs/open-doc":270,"./navs/ops":271,"./navs/ui":272,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"lodash":"lodash"}],262:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
var getParentNavConfig = function getParentNavConfig(parentNavId) {
  return parentNavId ? {
    _parent_nav_id: parentNavId
  } : null;
};
var NavActions = function () {
  NavActions.$inject = ["$rootScope", "$sheet", "metaService", "progressBarService", "$q"];
  /* @ngInject */
  function NavActions($rootScope, $sheet, metaService, progressBarService, $q) {
    (0, _classCallCheck2.default)(this, NavActions);
    this.$rootScope = $rootScope;
    this.$sheet = $sheet;
    this.metaService = metaService;
    this.ongoingAction = false;
    this.progressBarService = progressBarService;
    this.$q = $q;
  }
  (0, _createClass2.default)(NavActions, [{
    key: "dispatch",
    value: function dispatch(action) {
      if ((0, _lodash.isString)(action)) {
        action = {
          service: 'navService',
          method: 'openExternalUri',
          params: {
            uri: action
          }
        };
      }
      this.$$performAction(action);
    }
  }, {
    key: "$$performAction",
    value: function $$performAction(_ref) {
      var service = _ref.service,
        method = _ref.method,
        _ref$params = _ref.params,
        params = _ref$params === void 0 ? {} : _ref$params,
        extraParams = _ref.extraParams;
      return this.$q.resolve(this.metaService.callServiceMethod(service, method, [params, extraParams]));
    }
  }, {
    key: "performActions",
    value: function performActions(actions, parentNavId) {
      var _this = this;
      if (this.ongoingAction) {
        console.log('[NavHelpers.performActions] Skip actions because of ongoing action.');
        return;
      }
      this.ongoingAction = true;
      var progressBarService = this.progressBarService;
      progressBarService.startTask();
      if (!parentNavId && parentNavId !== null) {
        console.warn('[NavHelpers.performActions] parentNavId should be provided for proper navigation.');
      }
      this.$q.all((0, _lodash.map)(actions, function (action) {
        return _this.$$performAction((0, _lodash.extend)(action, {
          extraParams: getParentNavConfig(parentNavId)
        }));
      })).catch(function () {
        return console.warn('[NavHelpers.performActions] could not perform actions.', actions);
      }).then(function () {
        _this.ongoingAction = false;
        progressBarService.finishTask();
      });
    }
  }, {
    key: "mergeAndPerformRowActions",
    value: function mergeAndPerformRowActions(actionsSpec, parentNavId) {
      var _this2 = this;
      if (!parentNavId && parentNavId !== null) {
        console.warn('[NavHelpers.mergeAndPerformRowActions] parentNavId should be provided for proper navigation.');
      }
      return function (row) {
        return _this2.performActions(row.actions && !row.actionParam ? row.actions : (0, _lodash.map)((0, _lodash.cloneDeep)(actionsSpec), function (action, index) {
          action.params = row.actionParams[index] || {};
          return action;
        }), parentNavId);
      };
    }
  }, {
    key: "showNavToolbarMenu",
    value: function showNavToolbarMenu(menu) {
      var _this3 = this;
      return function ($event) {
        return _this3.$sheet({
          menu: true,
          positionMenuAround: $event.currentTarget,
          title: 'general.more_with_ellipsis',
          actions: (0, _lodash.map)(menu, function (action) {
            if (typeof action.action !== 'function') {
              action.action = _this3.performActions.bind(_this3, (0, _lodash.cloneDeep)([action.action]));
            }
            return action;
          })
        });
      };
    }
  }]);
  return NavActions;
}();
exports.default = NavActions;

},{"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"lodash":"lodash"}],263:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var NavActivateEvent = function () {
  NavActivateEvent.$inject = ["$window", "BRANDING"];
  /* @ngInject */
  function NavActivateEvent($window, BRANDING) {
    (0, _classCallCheck2.default)(this, NavActivateEvent);
    this.$windows = $window;
    this.BRANDING = BRANDING;
  }
  (0, _createClass2.default)(NavActivateEvent, [{
    key: "activateEvent",
    value: function activateEvent(_ref) {
      var eid = _ref.eid,
        pid = _ref.pid,
        token = _ref.token,
        appScript = _ref.appScript;
      var redirect = appScript ? "&redirect=/_as/".concat(btoa(JSON.stringify(appScript))) : '';
      this.$window.location.href = "https://webapp.spotme.com".concat("/api/v1/request-webapp-link?") + 'format=redirect' + "&eid=".concat(eid, "&pid=").concat(pid) + "&invitationToken=".concat(token) + "&branding=".concat(this.BRANDING) + redirect;
    }
  }]);
  return NavActivateEvent;
}();
exports.default = NavActivateEvent;

},{"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382}],264:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var NavAppscript = function () {
  NavAppscript.$inject = ["databaseService"];
  /* @ngInject */
  function NavAppscript(databaseService) {
    (0, _classCallCheck2.default)(this, NavAppscript);
    this.databaseService = databaseService;
  }
  (0, _createClass2.default)(NavAppscript, [{
    key: "runScript",
    value: function runScript(_ref) {
      var path = _ref.path,
        target = _ref.target,
        params = _ref.params;
      return this.databaseService.runAppScript(path || target, params);
    }
  }]);
  return NavAppscript;
}();
exports.default = NavAppscript;

},{"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382}],265:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
var NavEvents = function () {
  NavEvents.$inject = ["$eventBus"];
  /* @ngInject */
  function NavEvents($eventBus) {
    (0, _classCallCheck2.default)(this, NavEvents);
    this.$eventBus = $eventBus;
  }
  (0, _createClass2.default)(NavEvents, [{
    key: "on",
    value: function on() {
      return this.$eventBus.on.apply(null, arguments);
    }
  }, {
    key: "emit",
    value: function emit(name) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.$eventBus.emit(name, data);
    }
  }, {
    key: "subscribeToEvents",
    value: function subscribeToEvents() {
      return this.$eventBus.subscribeToEvents.apply(null, arguments);
    }
  }, {
    key: "postNotification",
    value: function postNotification(_ref) {
      var name = _ref.name,
        data = _ref.data;
      return this.$eventBus.emit(name, data);
    }
  }, {
    key: "flattenNotificationMap",
    value: function flattenNotificationMap() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        notification = _ref2.notification,
        notifications = _ref2.notifications,
        doc_ids = _ref2.doc_ids,
        fp_types = _ref2.fp_types;
      var clean = function clean(items) {
        return (0, _lodash.isArray)(items) ? items : [];
      };
      return (0, _lodash.uniq)((0, _lodash.compact)([].concat(clean(notification)).concat(clean(notifications)).concat((0, _lodash.map)(clean(doc_ids), function (id) {
        return "doc:".concat(id);
      })).concat((0, _lodash.map)(clean(fp_types), function (id) {
        return "type:".concat(id);
      }))));
    }
  }]);
  return NavEvents;
}();
exports.default = NavEvents;

},{"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"lodash":"lodash"}],266:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var NavExternals = function () {
  NavExternals.$inject = ["$window", "$filter", "$i18n", "$q", "$sheet"];
  /* @ngInject */
  function NavExternals($window, $filter, $i18n, $q, $sheet) {
    (0, _classCallCheck2.default)(this, NavExternals);
    this.$window = $window;
    this.$filter = $filter;
    this.$i18n = $i18n;
    this.$q = $q;
    this.$sheet = $sheet;
  }
  (0, _createClass2.default)(NavExternals, [{
    key: "showLegalRequirements",
    value: function showLegalRequirements(action) {
      var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
      if (isIE11) {
        action.features = 'scrollbars=1,resizable=1';
      }
      return this.openExternalUri(action);
    }
  }, {
    key: "openExternalUri",
    value: function openExternalUri(_ref) {
      var uri = _ref.uri,
        features = _ref.features,
        url = _ref.url;
      var fullUri = url || this.$filter('assetUrl')(uri);
      var linkElement = angular.element('<a id="_link"></a>');
      angular.element('body').append(linkElement);
      if (features) {
        fullUri += (fullUri.indexOf('?') === -1 ? '?' : '&') + features;
      }
      linkElement.attr('href', fullUri);
      linkElement.attr('target', '_blank');
      linkElement.attr('rel', 'noopener noreferrer');
      setTimeout(function () {
        linkElement[0].click();
        linkElement.remove();
      }, 0);
      return this.$q.resolve();
    }
  }, {
    key: "reload",
    value: function reload() {
      this.$window.location.reload(true);
    }
  }]);
  return NavExternals;
}();
exports.default = NavExternals;

},{"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382}],267:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _lodash = require("lodash");
var _webappSkeleton = require("../../utils/webapp-skeleton");
var paramSerializer = angular.injector(['ng']).get('$httpParamSerializer');
var evaluators = {
  javascript: function javascript(nav) {
    var _this = this;
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var key = arguments.length > 2 ? arguments[2] : undefined;
    var requestParams = angular.merge({}, nav[key].params || nav[key].source.params, params);
    var requestData = {
      nav_id: nav._id,
      params: requestParams,
      lang: this.$i18n.lang,
      tz: _momentTimezone.default.tz().zoneAbbr()
    };
    if (nav._dynamic_nav) {
      params.cache = false;
      requestData.full_nav = nav;
    }
    var qs;
    if (requestParams.cache === true) {
      qs = paramSerializer(requestData);
      var cached = this.inflatorRequestCache.get(qs);
      if (cached) {
        return this.$q.resolve((0, _lodash.cloneDeep)(cached));
      }
    }
    var service = this.databaseService.runAppScript('webapp/inflate-nav', requestData).then(function (_ref) {
      var data = _ref.data;
      return data.response;
    });
    return service.then(function (data) {
      if (requestParams.cache !== false && qs) {
        _this.inflatorRequestCache.put(qs, data);
      }
      return (0, _lodash.cloneDeep)(data);
    });
  },
  enum: function _enum(nav, params, key) {
    return this.$q.when({
      elements: angular.copy(nav[key].elements || [])
    });
  },
  handler: function handler(nav, params, key) {
    var ds = nav[key].source;
    return this.handlerService.callHandler(ds.handler, ds.params);
  },
  remote: function remote(nav, params, key) {
    var path = nav[key].source.path;
    var bookmark = null;
    return this.$http.get("api/v1/eid/".concat(this.EID, "/").concat(path), {
      params: params
    }).then(function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        data = _ref2.data;
      if (data.bookmark) bookmark = data.bookmark;
      return {
        elements: (0, _webappSkeleton.renderRows)({
          render: nav.render,
          actions: nav.actions
        }, data.documents),
        bookmark: bookmark
      };
    }).catch(function (err) {
      return console.error(err);
    });
  }
};
var NavInflator = function () {
  NavInflator.$inject = ["$cacheFactory", "$q", "$i18n", "handlerService", "databaseService", "$http", "EID"];
  /* @ngInject */
  function NavInflator($cacheFactory, $q, $i18n, handlerService, databaseService, $http, EID) {
    (0, _classCallCheck2.default)(this, NavInflator);
    this.$q = $q;
    this.$i18n = $i18n;
    this.$http = $http;
    this.EID = EID;
    this.handlerService = handlerService;
    this.databaseService = databaseService;
    this.inflatorRequestCache = $cacheFactory('navInflator');
  }
  (0, _createClass2.default)(NavInflator, [{
    key: "inflateNav",
    value: function inflateNav(nav, params) {
      var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'ds';
      var ds = nav[key];
      if (!ds) {
        throw new Error('missing ds');
      }
      var evaluator = evaluators[ds.type];
      if (!evaluator) {
        throw new Error('unknown ds: ' + ds.type);
      }
      return evaluator.call(this, nav, params, key);
    }
  }, {
    key: "inflatePaginatedNav",
    value: function inflatePaginatedNav(nav, params, paginator) {
      if (!paginator.hasMorePages()) {
        return this.$q.reject();
      }
      return this.inflateNav(nav, (0, _lodash.extend)({}, params || {}, paginator.queryParams())).then(function (resp) {
        resp.paginatedElements = paginator.processNewPage(resp.elements, resp);
        return resp;
      });
    }
  }]);
  return NavInflator;
}();
exports.default = NavInflator;

},{"../../utils/webapp-skeleton":370,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"lodash":"lodash","moment-timezone":"moment-timezone"}],268:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _externalCalendarServices = require("../../utils/external-calendar-services");
var _i18nWithFallback = _interopRequireDefault(require("../../utils/i18n-with-fallback"));
var VCARD_HANDLER = 'webapp/export-vcard';
var ALL_VCARDS_HANDLER = 'webapp/export-all-vcards';
var ICAL_HANDLER = 'webapp/export-ical';
var NOTES_EXPORT_HANDLER = 'webapp/export-notes';
var choiceSheet = function choiceSheet(_ref) {
  var $sheet = _ref.$sheet,
    $device = _ref.$device,
    navTemplates = _ref.navTemplates,
    title = _ref.title,
    actions = _ref.actions;
  var sheetConfig = {
    title: title,
    scrollable: false,
    dismissOnOutsideClick: true
  };
  if ($device('isPhone')) {
    sheetConfig.menu = true;
    sheetConfig.actions = actions;
  } else {
    sheetConfig.services = actions;
    sheetConfig.templateUri = navTemplates.calendar_services_sheet;
  }
  return $sheet(sheetConfig);
};
var NavIntegrations = function () {
  NavIntegrations.$inject = ["NAV_TEMPLATES", "EVENT", "SETTINGS", "$window", "$i18n", "$device", "handlerService", "$filter"];
  /* @ngInject */
  function NavIntegrations(NAV_TEMPLATES, EVENT, SETTINGS, $window, $i18n, $device, handlerService, $filter) {
    (0, _classCallCheck2.default)(this, NavIntegrations);
    this.NAV_TEMPLATES = NAV_TEMPLATES;
    this.EVENT = EVENT;
    this.SETTINGS = SETTINGS;
    this.$window = $window;
    this.$i18n = $i18n;
    this.$device = $device;
    this.handlerService = handlerService;
    this.stripHTML = $filter('stripHTML');
  }
  (0, _createClass2.default)(NavIntegrations, [{
    key: "addToAddressBook",
    value: function addToAddressBook(data) {
      var attrs = (0, _lodash.pick)(data, '_id', 'fname', 'lname', 'position', 'company', 'email', 'phone', 'mobile', 'linkedin_url', 'notes');
      this.$window.open(this.handlerService.generateHandlerUrl(VCARD_HANDLER, attrs), '_blank');
    }
  }, {
    key: "addAllToAddressBook",
    value: function addAllToAddressBook() {
      var $window = this.$window,
        $sheet = this.$sheet,
        $device = this.$device,
        $i18n = this.$i18n,
        handlerService = this.handlerService;
      var download = function download(format) {
        return $window.open(handlerService.generateHandlerUrl(ALL_VCARDS_HANDLER, {
          format: format
        }), '_blank');
      };
      var supportsMultipleFormats = $i18n('general.download_csv_cards') !== 'general.download_csv_cards';
      if (!supportsMultipleFormats) {
        return download('vcf');
      }
      choiceSheet({
        $sheet: $sheet,
        $device: $device,
        navTemplates: this.NAV_TEMPLATES,
        title: $i18n('general.select_format'),
        actions: [{
          id: 'vcf',
          label: $i18n('general.download_vcf_cards'),
          action: function action() {
            return download('vcf') && true;
          }
        }, {
          id: 'csv',
          label: $i18n('general.download_csv_cards'),
          action: function action() {
            return download('csv') && true;
          }
        }]
      });
    }
  }, {
    key: "addToCalendar",
    value: function addToCalendar(data) {
      var _this = this;
      var $window = this.$window,
        $sheet = this.$sheet,
        $device = this.$device,
        $i18n = this.$i18n,
        handlerService = this.handlerService;
      var openICalFile = function openICalFile() {
        var attrs = (0, _lodash.pick)(data, '_id', 'name', 'start', 'end', 'location');
        if (data.content) {
          attrs.notes = _this.stripHTML(data.content);
          if (attrs.notes.length > 1500) {
            attrs.notes = attrs.notes.substring(0, 1494) + ' [...]';
          }
        }
        var url = handlerService.generateHandlerUrl(ICAL_HANDLER, attrs);
        $window.open(url, '_top');
      };
      var openGoogleCalendar = function openGoogleCalendar() {
        return $window.open((0, _externalCalendarServices.googleCalendarUrl)(data, (0, _lodash.get)(_this, 'SETTINGS.date.timezone') === 'device' ? _momentTimezone.default.tz.guess() : _this.EVENT.timezone), '_blank') && true;
      };
      choiceSheet({
        $sheet: $sheet,
        $device: $device,
        navTemplates: this.NAV_TEMPLATES,
        title: $i18n('general.select_service'),
        actions: [{
          id: 'native',
          label: this.$i18n('general.native_calendar_apps'),
          action: openICalFile
        }, {
          id: 'gcal',
          label: (0, _i18nWithFallback.default)(this.$i18n, 'general.google_calendar', 'Google Calendar'),
          action: openGoogleCalendar
        }]
      });
    }
  }, {
    key: "exportNotes",
    value: function exportNotes() {
      this.$window.open(this.handlerService.generateHandlerUrl(NOTES_EXPORT_HANDLER), '_blank');
    }
  }]);
  return NavIntegrations;
}();
exports.default = NavIntegrations;

},{"../../utils/external-calendar-services":358,"../../utils/i18n-with-fallback":359,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"lodash":"lodash","moment-timezone":"moment-timezone"}],269:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var NavMisc = function () {
  NavMisc.$inject = ["$q", "authService"];
  /* @ngInject */
  function NavMisc($q, authService) {
    (0, _classCallCheck2.default)(this, NavMisc);
    this.$q = $q;
    this.authService = authService;
  }
  (0, _createClass2.default)(NavMisc, [{
    key: "sync",
    value: function sync() {
      console.warn('[NavService/sync] is not implemented');
      return this.$q.resolve();
    }
  }, {
    key: "flushRepl",
    value: function flushRepl() {
      console.warn('[NavService/flushRepl] is not implemented');
      return this.$q.resolve();
    }
  }, {
    key: "flushReplications",
    value: function flushReplications() {
      console.warn('[NavService/flushReplications] is not implemented');
      return this.$q.resolve();
    }
  }, {
    key: "singlerepl",
    value: function singlerepl() {
      console.warn('[NavService/singlerepl] is not implemented');
      return this.$q.resolve();
    }
  }, {
    key: "hideSpotman",
    value: function hideSpotman() {
      console.warn('[NavService/hideSpotman] is not implemented');
      return this.$q.resolve();
    }
  }, {
    key: "nativeCall",
    value: function nativeCall() {
      console.warn('[NavService/nativeCall] is not implemented');
      return this.$q.resolve();
    }
  }, {
    key: "logOut",
    value: function logOut() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.authService.logOut(options);
    }
  }]);
  return NavMisc;
}();
exports.default = NavMisc;

},{"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382}],270:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
var _cleanMagicProperties = _interopRequireDefault(require("../../utils/clean-magic-properties"));
var OpenDocument = function () {
  OpenDocument.$inject = ["ACTIONS", "metaService", "databaseService", "progressBarService", "metricsService", "$anchorScroll"];
  /* @ngInject */
  function OpenDocument(ACTIONS, metaService, databaseService, progressBarService, metricsService, $anchorScroll) {
    (0, _classCallCheck2.default)(this, OpenDocument);
    this.ACTIONS = ACTIONS;
    this.metaService = metaService;
    this.databaseService = databaseService;
    this.progressBarService = progressBarService;
    this.metricsService = metricsService;
    this.$anchorScroll = $anchorScroll;
  }
  (0, _createClass2.default)(OpenDocument, [{
    key: "openDocument",
    value: function openDocument(arg) {
      var _this = this;
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var ACTIONS = this.ACTIONS,
        databaseService = this.databaseService,
        progressBarService = this.progressBarService,
        metricsService = this.metricsService;
      var deferred;
      if (typeof arg === 'string') {
        arg = {
          id: arg
        };
      }
      arg = (0, _cleanMagicProperties.default)(arg);
      config = (0, _cleanMagicProperties.default)(config);
      if (arg.id || arg._id) {
        deferred = databaseService.docWithId(arg.id || arg._id);
      } else if (arg.fp_ext_id && arg.fp_type) {
        deferred = databaseService.docOfTypeAndExtId(arg.fp_type, arg.fp_ext_id);
      } else {
        console.error("[navService/openDocument] can't determine which document to open", arg);
        return;
      }
      progressBarService.startTask();
      return deferred.then(function (doc) {
        var fpType = doc.fp_type;
        var fpTypeAction = "fp_type:".concat(fpType);
        var customAction = ACTIONS[fpTypeAction];
        if (customAction) {
          console.log('[navService/openDocument] offloading action to app script', doc);
          arg.id = doc._id;
          return databaseService.runAppScript('actions/open-document', (0, _lodash.extend)({}, arg, config));
        }
        metricsService.trackAnalytics({
          name: 'view',
          document_id: doc._id,
          document_type: fpType
        });
        var source = arg.source;
        var openMethod = source === 'spotman' || source === 'home' ? 'presentNav' : 'openNav';
        var navParams = {
          nav_id: 'nav_fstg',
          page_id: arg.fstgPage || doc.fp_fstg_page || fpType,
          page_params: {
            model_id: doc._id,
            fp_type: fpType,
            model_ext_id: doc.fp_ext_id
          }
        };
        if ('_parent_nav_id' in config) {
          navParams._parent_nav_id = config._parent_nav_id;
        }
        if (!(0, _lodash.isEmpty)(doc.video_breakout_id) && !doc.video_breakout_cancel) {
          navParams.video_breakout_id = doc.video_breakout_id;
        }
        if (config.navParams) {
          (0, _lodash.extend)(navParams, config.navParams);
        }
        var actionSpec = {
          method: openMethod,
          params: navParams
        };
        _this.metaService.callServiceMethod(actionSpec.service, actionSpec.method, [actionSpec.params]);
        _this.$anchorScroll();
      }).finally(function () {
        return progressBarService.finishTask();
      });
    }
  }]);
  return OpenDocument;
}();
exports.default = OpenDocument;

},{"../../utils/clean-magic-properties":353,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"lodash":"lodash"}],271:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
function importNav(config) {
  if (typeof config === 'string') {
    config = {
      nav_id: config
    };
  }
  var navId = config._id || config.nav_id;
  var nav = (0, _lodash.merge)({
    _id: navId || '_dynamic'
  }, navId ? this.EVENT_NAVS[navId] : null, config);
  delete nav.nav_id;
  return nav;
}
function initNav(nav) {
  if (nav.$is_home) {
    nav = this.HOME_NAV;
  }
  nav = importNav.call(this, nav);
  if (!nav) {
    throw new Error('Cannot initialize a null nav');
  }
  return angular.merge({}, {
    nuid: (0, _lodash.uniqueId)("".concat(nav._id, "_").concat(Date.now(), "_"))
  }, angular.copy(nav));
}
function openModalNav(nav) {
  var _this = this;
  var title = nav.show_title === false ? '' : nav.title;
  var scrollable = nav.scrollable !== false;
  nav.show_title = false;
  var sheet = this.$sheet({
    nav: nav,
    title: title,
    templateUri: this.NAV_TEMPLATES[nav.nav_type],
    pin: scrollable ? 'bottom' : '',
    scrollable: scrollable,
    actions: [{
      id: 'close',
      label: this.$i18n('general.close'),
      action: function action(sheet) {
        var navIndex = (0, _lodash.findIndex)(_this.savedNavSheets, function (sheet) {
          return sheet.nuid === nav.nuid;
        });
        if (navIndex !== -1) {
          _this.savedNavSheets.splice(navIndex, 1);
        }
        return sheet.accept();
      }
    }]
  });
  var navCopy = (0, _lodash.cloneDeep)(nav);
  navCopy.sheetId = sheet.$$sheetId;
  nav.sheetId = navCopy.sheetId;
  this.savedNavSheets.push(navCopy);
  if (nav.route && nav.set_route !== false) {
    var backIfNotNav = function backIfNotNav(reason) {
      if (!reason || !reason.applyNavs) _this.$window.history.back();
    };
    sheet.then(backIfNotNav, backIfNotNav);
  }
}
function activateNav(nav, skipSetRoute) {
  this.$sheet.dismissMenus();
  if (!skipSetRoute && nav.set_route !== false) {
    this.navRouterService.setUrlForNav(nav, this);
  }
  if (nav.events && nav.events.on_appear) {
    this.databaseService.runAppScript(nav.events.on_appear.path);
  }
  this.emit('$navChange', nav);
  trackNav.call(this, nav);
}
function trackNav(nav) {
  this.metricsService.trackAnalytics({
    name: 'view',
    document_type: 'nav',
    fp_type: 'nav',
    document_id: nav._id
  });
  var trackParams = {
    id: nav._id
  };
  if (trackParams.id === 'nav_fstg') {
    var page_params = nav.page_params;
    trackParams.document_type = page_params.fp_type;
    trackParams.document_id = page_params.model_id;
  }
  trackParams.connection_mode = window.navigator.onLine;
  if (nav.analytic_params) {
    (0, _lodash.extend)(trackParams, nav.analytic_params);
  }
}
var NavOps = function () {
  NavOps.$inject = ["EVENT_NAVS", "NAV_TEMPLATES", "HOME_NAV", "$sheet", "$window", "$i18n", "$eventBus", "navRouterService", "metricsService", "databaseService", "liveStreamService"];
  /* @ngInject */
  function NavOps(EVENT_NAVS, NAV_TEMPLATES, HOME_NAV, $sheet, $window, $i18n, $eventBus, navRouterService, metricsService, databaseService, liveStreamService) {
    (0, _classCallCheck2.default)(this, NavOps);
    this.EVENT_NAVS = EVENT_NAVS;
    this.HOME_NAV = HOME_NAV;
    this.NAV_TEMPLATES = NAV_TEMPLATES;
    this.$sheet = $sheet;
    this.$i18n = $i18n;
    this.$window = $window;
    this.$eventBus = $eventBus;
    this.navRouterService = navRouterService;
    this.metricsService = metricsService;
    this.databaseService = databaseService;
    this.liveStreamService = liveStreamService;
    this.activeNav = {
      nav: null
    };
    this.savedNavSheets = [];
  }
  (0, _createClass2.default)(NavOps, [{
    key: "openNav",
    value: function openNav(nav) {
      if (!nav) return;
      this.$eventBus.emit('theatreMode:off');
      var newNav = initNav.call(this, nav);
      if (this.$sheet.hasOpenSheets()) {
        newNav.modal = true;
      }
      if (newNav.modal) {
        openModalNav.call(this, newNav);
      } else {
        this.activeNav.nav = newNav;
      }
      activateNav.call(this, newNav);
    }
  }, {
    key: "presentNav",
    value: function presentNav(nav) {
      if (!nav) return;
      this.$eventBus.emit('theatreMode:off');
      var fullNav = initNav.call(this, nav);
      if (fullNav.modal) {
        return this.openNav(nav);
      }
      this.$sheet.dismissAllSheets({
        applyNavs: true
      });
      this.activeNav.nav = fullNav;
      activateNav.call(this, fullNav);
    }
  }, {
    key: "showNav",
    value: function showNav(nav) {
      console.warn('[navService/showNav] this method is being depracated, use presentNav instead');
      this.presentNav(nav);
    }
  }, {
    key: "showHome",
    value: function showHome() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!params.force) {
        return console.warn('[navService/showHome] force: false, ignoring request (iOS compatibility)');
      }
      this.resetNavigation();
    }
  }, {
    key: "hideHome",
    value: function hideHome() {}
  }, {
    key: "resetNavigation",
    value: function resetNavigation() {
      this.presentNav(this.HOME_NAV);
    }
  }, {
    key: "closeFullscreenNav",
    value: function closeFullscreenNav() {
      if (this.$sheet.hasOpenSheets()) {
        this.$sheet.dismissSheet(this.getLastSheetId());
      }
    }
  }, {
    key: "closeLastNav",
    value: function closeLastNav() {
      if (this.$sheet.hasOpenSheets()) {
        var lastSheetId = this.getLastSheetId();
        if (lastSheetId) return this.$sheet.dismissSheet(lastSheetId);
      }
      this.$window.history.go(-1);
      return false;
    }
  }, {
    key: "removeSavedSheet",
    value: function removeSavedSheet(sheetToRemoveId) {
      this.savedNavSheets = this.savedNavSheets.filter(function (sheet) {
        return sheet.sheetId !== sheetToRemoveId;
      });
    }
  }, {
    key: "getSavedSheets",
    value: function getSavedSheets() {
      var _this2 = this;
      this.savedNavSheets = this.savedNavSheets.filter(function (sheet) {
        return _this2.$sheet.getSheetIds().includes(sheet.sheetId);
      });
      return this.savedNavSheets;
    }
  }, {
    key: "getLastSheetId",
    value: function getLastSheetId() {
      return (0, _lodash.last)(this.$sheet.getNavSheetIds());
    }
  }, {
    key: "startPictureInPicturePreview",
    value: function startPictureInPicturePreview(params) {
      if (params.id) {
        console.log('[navService/startPictureInPicturePreview] Starting a live stream with params', params);
        return this.liveStreamService.start(params);
      }
      this.$eventBus.emit('pip:start', params);
    }
  }, {
    key: "applyNavs",
    value: function applyNavs(newNav, newSheets) {
      var _this$savedNavSheets,
        _this3 = this;
      this.$eventBus.emit('theatreMode:off');
      newNav = initNav.call(this, newNav);
      this.activeNav.nav = newNav;
      activateNav.call(this, newNav, true);
      var existingSheetIds = this.$sheet.getSheetIds();
      var newSheetsIds = [];
      (_this$savedNavSheets = this.savedNavSheets).splice.apply(_this$savedNavSheets, [0, this.savedNavSheets.length].concat((0, _toConsumableArray2.default)(newSheets.map(function (nav) {
        if (existingSheetIds.indexOf(nav.sheetId) === -1) {
          nav = initNav.call(_this3, nav);
          openModalNav.call(_this3, nav);
        }
        newSheetsIds.push(nav.sheetId);
        return nav;
      }))));
      this.savedNavSheets = (0, _lodash.uniq)(this.savedNavSheets, function (x) {
        return x.nuid;
      });
      this.$sheet.getNavSheetIds().forEach(function (sheetId) {
        if (newSheetsIds.indexOf(sheetId) === -1) {
          _this3.$sheet.dismissSheet(sheetId, {
            applyNavs: true
          });
        }
      });
      this.$sheet.dismissMenus();
    }
  }, {
    key: "getActiveNav",
    value: function getActiveNav() {
      return this.activeNav.nav;
    }
  }]);
  return NavOps;
}();
exports.default = NavOps;

},{"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/helpers/toConsumableArray":393,"lodash":"lodash"}],272:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
var NavUi = function () {
  NavUi.$inject = ["$sheet", "metaService"];
  /* @ngInject */
  function NavUi($sheet, metaService) {
    (0, _classCallCheck2.default)(this, NavUi);
    this.$sheet = $sheet;
    this.metaService = metaService;
  }
  (0, _createClass2.default)(NavUi, [{
    key: "alert",
    value: function alert(config) {
      var _this = this;
      var $sheet = this.$sheet;
      var runAction = function runAction(_ref) {
        var service = _ref.service,
          method = _ref.method,
          params = _ref.params;
        return _this.metaService.callServiceMethod(service, method, [params]);
      };
      var actions = config.buttons || [];
      if (!actions.length) {
        actions.push({
          label: 'general.dismiss',
          action: function action(scope) {
            return scope.accept();
          }
        });
      } else {
        actions = (0, _lodash.map)(config.buttons, function (button, i) {
          return {
            id: i,
            label: button.title,
            action: function action(scope) {
              scope.accept();
              if (button.target) {
                runAction(button.target);
              }
            }
          };
        });
      }
      $sheet((0, _lodash.extend)({}, config, {
        prompt: true,
        alert: true,
        actions: actions
      }));
    }
  }]);
  return NavUi;
}();
exports.default = NavUi;

},{"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"lodash":"lodash"}],273:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
var TRACKED_CTX = ['polls'];
var NotificationsService = function () {
  NotificationsService.$inject = ["databaseService", "pollService", "$interval", "$eventBus"];
  /** @ngInject */
  function NotificationsService(databaseService, pollService, $interval, $eventBus) {
    var _this = this;
    (0, _classCallCheck2.default)(this, NotificationsService);
    this.databaseService = databaseService;
    this.pollService = pollService;
    this.$interval = $interval;
    this.scheduledNotifications = [];
    this.interval = 1000 * 60 * 5;
    this.scheduledIntervals = {};
    this.contexts = {};
    $eventBus.on('notifications:hide', function (ctx) {
      return _this.contexts[ctx] = true;
    });
    $eventBus.on('notifications:show', function (ctx) {
      return delete _this.contexts[ctx];
    });
  }
  (0, _createClass2.default)(NotificationsService, [{
    key: "checkForNewNotification",
    value: function checkForNewNotification(onPushNotification) {
      var _this2 = this;
      this.getAllNotifications().then(function (_ref) {
        var response = _ref.data.response;
        var notificationsToSchedule = (0, _lodash.filter)(response, function (notification) {
          return notification.delivery_mode === 'schedule' && !notification.local_shown_on_web && !notification.isRead && !_this2.scheduledNotifications.includes(notification._id);
        });
        if (notificationsToSchedule.length) {
          _this2.scheduleNotifications(notificationsToSchedule, onPushNotification);
        }
      });
    }
  }, {
    key: "scheduleNotifications",
    value: function scheduleNotifications(notifications, onPushNotification) {
      var _this3 = this;
      var now = Math.round(Date.now() / 1000);
      (0, _lodash.each)(notifications, function (notification) {
        _this3.scheduledNotifications.push(notification._id);
        var timeout = (notification.timestamp - now) * 1000;
        if (timeout < 0) return;
        _this3.scheduledIntervals[notification._id] = _this3.$interval(function () {
          var nowTs = Math.round(Date.now() / 1000);
          if (notification.timestamp - 100 > nowTs) {
            return _this3.$interval.cancel(_this3.scheduledIntervals[notification._id]);
          }
          onPushNotification({
            notificationLinkId: notification.linkId,
            notificationPayload: {
              message: {
                title: notification.title,
                body: notification.body
              },
              icon: 'icon.spotman.bell/file.png',
              action: {
                path: 'notifications/open-from-push',
                params: {
                  notification: notification
                }
              }
            }
          });
          _this3.$interval.cancel(_this3.scheduledIntervals[notification._id]);
        }, timeout);
      });
    }
  }, {
    key: "getAllNotifications",
    value: function getAllNotifications() {
      return this.databaseService.runAppScript('notifications/get-all-notifications', {
        includeFutureNotifications: true
      });
    }
  }, {
    key: "startCheckInterval",
    value: function startCheckInterval(onPushNotification) {
      var _this4 = this;
      this.checkInterval = this.$interval(function () {
        return _this4.checkForNewNotification(onPushNotification);
      }, this.interval);
    }
  }, {
    key: "cancelCheckInterval",
    value: function cancelCheckInterval() {
      this.$interval.cancel(this.checkInterval);
    }
  }, {
    key: "shouldDisplayNotification",
    value: function shouldDisplayNotification(ctx, docId) {
      if (!ctx || !docId) {
        return true;
      } else {
        return !this.contexts["".concat(ctx, "-").concat(docId)];
      }
    }
  }, {
    key: "trackNotificationReception",
    value: function trackNotificationReception(notificationPayload) {
      var context = (0, _lodash.get)(notificationPayload, 'ctx');
      if (TRACKED_CTX.includes(context)) {
        this.trackPollNotificationReception(notificationPayload);
      }
    }
  }, {
    key: "trackPollNotificationReception",
    value: function trackPollNotificationReception(notificationPayload) {
      var type = (0, _lodash.get)(notificationPayload, 'type');
      var execution_id = (0, _lodash.get)(notificationPayload, 'execution_id');
      if (!type || !execution_id) return;
      if (type === 'vote') {
        return this.pollService.onExecution(execution_id);
      } else {
        return this.pollService.onResultsShown(execution_id);
      }
    }
  }]);
  return NotificationsService;
}();
angular.module('maestro.services').service('notificationsService', NotificationsService);

},{"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"lodash":"lodash"}],274:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var OfflineService = function () {
  OfflineService.$inject = ["$q", "$eventBus", "$timeout"];
  /* @ngInject */
  function OfflineService($q, $eventBus, $timeout) {
    (0, _classCallCheck2.default)(this, OfflineService);
    this.$q = $q;
    this.$timeout = $timeout;
    $eventBus.spawn(this);
  }
  (0, _createClass2.default)(OfflineService, [{
    key: "interceptor",
    value: function interceptor() {
      var $q = this.$q;
      var $timeout = this.$timeout;
      var eventEmitter = this;
      var offline = false;
      var pendingCall = false;
      var defer = $q.defer();
      defer.resolve();
      window.addEventListener('offline', function () {
        defer = $q.defer();
        offline = true;
        $timeout(function () {
          return eventEmitter.emit('offline');
        });
      });
      window.addEventListener('online', function () {
        offline = false;
        pendingCall = false;
        $timeout(function () {
          return eventEmitter.emit('online');
        });
        defer.resolve();
      });
      return {
        request: function request(_request) {
          if (offline && !pendingCall) {
            pendingCall = true;
            $timeout(function () {
              return eventEmitter.emit('offline:pending');
            });
          }
          return defer.promise.then(function () {
            return _request;
          });
        }
      };
    }
  }]);
  return OfflineService;
}();
angular.module('maestro.services').service('offlineService', OfflineService).config(['$httpProvider', function ($httpProvider) {
  $httpProvider.interceptors.push(['offlineService', function (offlineService) {
    return offlineService.interceptor();
  }]);
}]);

},{"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382}],275:[function(require,module,exports){
"use strict";

var _lodash = require("lodash");
var PaginatorFactory = function PaginatorFactory() {
  var getNextStartKeyOfList = function getNextStartKeyOfList(_ref) {
    var _id = _ref._id,
      key = _ref.key,
      bookmark = _ref.bookmark;
    return {
      id: _id,
      key: key,
      bookmark: bookmark
    };
  };
  var paginator = function paginator() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var nextStartKey = config.startKey || null;
    var currentState;
    var buildQueryParamsForList = function buildQueryParamsForList(nextPage) {
      if (!nextPage) {
        return {
          limit: pageSize
        };
      }
      if (nextStartKey.bookmark) {
        return {
          bookmark: nextStartKey.bookmark
        };
      }
      return {
        startkey: nextStartKey.key,
        startkey_docid: nextStartKey.id,
        limit: pageSize
      };
    };
    var _config$pageSize = config.pageSize,
      pageSize = _config$pageSize === void 0 ? 10 : _config$pageSize,
      _config$getNextStartK = config.getNextStartKey,
      getNextStartKey = _config$getNextStartK === void 0 ? getNextStartKeyOfList : _config$getNextStartK,
      _config$buildQueryPar = config.buildQueryParams,
      buildQueryParams = _config$buildQueryPar === void 0 ? buildQueryParamsForList : _config$buildQueryPar;
    return {
      getCurrentState: function getCurrentState() {
        return currentState || {
          limit: pageSize
        };
      },
      reset: function reset() {
        nextStartKey = null;
      },
      setPageSize: function setPageSize(_size) {
        pageSize = _size;
      },
      hasMorePages: function hasMorePages() {
        return nextStartKey !== Infinity && nextStartKey !== undefined;
      },
      queryParams: function queryParams() {
        return buildQueryParams(nextStartKey);
      },
      processNewPage: function processNewPage() {
        var respElements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var resp = arguments.length > 1 ? arguments[1] : undefined;
        if (resp && resp.bookmark) {
          currentState = (0, _lodash.cloneDeep)(nextStartKey);
          nextStartKey = getNextStartKey({
            bookmark: resp.bookmark
          });
          return;
        }
        var elements;
        if (respElements.hasOwnProperty('list')) {
          elements = respElements.list;
        } else {
          elements = respElements;
        }
        if (!(0, _lodash.isArray)(elements) || !elements.length) {
          nextStartKey = undefined;
          return [];
        }
        var firstElement = elements[0];
        if (firstElement && nextStartKey && firstElement._id === nextStartKey.id) {
          elements = elements.slice(1);
        }
        var lastElement = (0, _lodash.last)(elements);
        if (lastElement) {
          if (nextStartKey) {
            currentState = (0, _lodash.cloneDeep)(nextStartKey);
            currentState.limit = pageSize;
          }
          nextStartKey = getNextStartKey(lastElement);
        }
        console.debug('[PaginatorFactory] Current and next page:', currentState, nextStartKey);
        return respElements;
      }
    };
  };
  this.$get = paginator;
  return paginator;
};
angular.module('maestro.services').factory('paginatorFactory', [PaginatorFactory]);

},{"lodash":"lodash"}],276:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _lab = _interopRequireDefault(require("frontloader-common/lab"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _rangefix = _interopRequireDefault(require("rangefix"));
var _lodash = require("lodash");
var _color = require("../utils/color");
PdfService.$inject = ["$q", "$popover", "$i18n", "$filter", "$timeout", "NAV_TEMPLATES", "PID", "databaseService"];
var ANNOTATION_SCALING = 1.333;
var HORIZONTAL_SHIFT = 25;
var VERTICAL_SHIFT = 0;
var BORDER_WIDTH = 9;
var xToWeb = function xToWeb(x) {
  return x * ANNOTATION_SCALING;
};
var yToWeb = function yToWeb(y) {
  return y * ANNOTATION_SCALING;
};
var xFromWeb = function xFromWeb(x) {
  return x / ANNOTATION_SCALING;
};
var yFromWeb = function yFromWeb(y) {
  return y / ANNOTATION_SCALING;
};
var normalizeDoc = function normalizeDoc(doc, parentId, PID) {
  if (!doc) {
    return {
      parent_doc_id: parentId,
      annotations: [],
      type: 'pdf',
      fp_type: 'note',
      fp_owner: PID,
      timestamp: (0, _momentTimezone.default)().unix()
    };
  }
  delete doc._rev;
  return doc;
};
var getSelection = function getSelection() {
  var allRects = [];
  var highlighted = '';
  var parent = null;
  try {
    var selection = window.getSelection();
    for (var i = 0; i < selection.rangeCount; i++) {
      var range = selection.getRangeAt(i);
      var rects = (0, _lodash.filter)(_rangefix.default.getClientRects(range), function (rect) {
        return rect.width && rect.height && rect.width > 1;
      });
      if (rects) {
        allRects = allRects.concat(rects);
        highlighted += range.toString();
        parent = range.commonAncestorContainer || parent;
      }
    }
  } catch (x_X) {
    console.log('[pdfService] selection not supported');
    return null;
  }
  if (!allRects.length) {
    return null;
  }
  return {
    rects: allRects,
    highlighted: highlighted,
    parent: parent
  };
};
var getPageRect = function getPageRect(pageDom) {
  var rect = pageDom.getBoundingClientRect();
  return {
    left: rect.left + BORDER_WIDTH,
    bottom: rect.bottom - BORDER_WIDTH
  };
};
var getRect = function getRect(quads) {
  return (0, _lodash.reduce)(quads, function (previous, _ref) {
    var x1 = _ref.x1,
      y1 = _ref.y1,
      x4 = _ref.x4,
      y4 = _ref.y4;
    if (!previous.lower_left_x || x1 < previous.lower_left_x) {
      previous.lower_left_x = x1;
    }
    if (!previous.upper_right_x || x4 > previous.upper_right_x) {
      previous.upper_right_x = x4;
    }
    if (!previous.lower_left_y || y4 < previous.lower_left_y) {
      previous.lower_left_y = y4;
    }
    if (!previous.upper_right_y || y1 > previous.upper_right_y) {
      previous.upper_right_y = y1;
    }
    return previous;
  }, {
    lower_left_y: null,
    upper_right_y: null,
    lower_left_x: null,
    upper_right_x: null
  });
};
var filterEmptyAnnotations = function filterEmptyAnnotations(annotations) {
  return (0, _lodash.filter)(annotations, function (ann) {
    if (ann.prune) return false;
    if (ann.type === 'text' && !ann.contents) return false;
    return true;
  });
};

/* @ngInject */
function PdfService($q, $popover, $i18n, $filter, $timeout, NAV_TEMPLATES, PID, databaseService) {
  var initPromise = null;
  var initPdfService = function initPdfService() {
    return $q(function (resolve) {
      var appResource = $filter('appResource');
      _lab.default.script([appResource('js/compatibility.js'), appResource('js/pdfjs-dist.js'), appResource('js/pdf_viewer.js')]).wait(function () {
        require('pdfjs-dist/web/compatibility');
        require('pdfjs-dist');
        require('pdfjs-dist/web/pdf_viewer');
        PDFJS.workerSrc = appResource('js/pdf.worker.js');
        resolve();
      });
    });
  };
  var init = function init() {
    if (!initPromise) {
      initPromise = initPdfService();
    }
    return initPromise;
  };
  return {
    getViewer: function getViewer(url, container) {
      return init().then(function () {
        var pdfLinkService = new PDFJS.PDFLinkService();
        var pdfViewer = new PDFJS.PDFViewer({
          container: container,
          linkService: pdfLinkService
        });
        pdfLinkService.setViewer(pdfViewer);
        var pdfFindController = new PDFJS.PDFFindController({
          pdfViewer: pdfViewer
        });
        pdfViewer.setFindController(pdfFindController);
        container.addEventListener('pagesinit', function () {
          $timeout(function () {
            return pdfViewer.currentScaleValue = 'auto';
          });
        });
        return $q(function (resolve, reject) {
          console.log('[pdfService] Loading a document', url);
          PDFJS.getDocument(url).then(function (pdfDocument) {
            pdfViewer.setDocument(pdfDocument);
            pdfLinkService.setDocument(pdfDocument, null);
            resolve({
              viewer: pdfViewer,
              document: pdfDocument,
              findController: pdfFindController
            });
          }, function (error) {
            console.error('[pdfService] Unable to load document (reject)', error);
            return reject(error);
          });
        });
      });
    },
    mapAnnotations: function mapAnnotations(viewer, doc, parentId, saveCb) {
      doc = normalizeDoc(doc, parentId, PID);
      var active = false;
      var activeEndCb = angular.noop;
      var buildAnnotation = function buildAnnotation(pageDom, annotation, scale) {
        var node = document.createElement('div');
        pageDom.appendChild(node);
        node.style.left = (xToWeb(annotation.pos_x) + HORIZONTAL_SHIFT) * scale + 'px';
        node.style.bottom = (yToWeb(annotation.pos_y) + VERTICAL_SHIFT) * scale + 'px';
        node.className = 'nav-document-pdf-annotation';
        node.innerHTML = '<i class="icon-menu"></i>';
        node.addEventListener('click', function () {
          return showAnnotationEditor([node], annotation);
        });
        return [node];
      };
      var buildHighlightAnnotation = function buildHighlightAnnotation(pageDom, annotation, scale) {
        var nodes = [];
        (0, _lodash.each)(annotation.quad_points, function (_ref2) {
          var x1 = _ref2.x1,
            y1 = _ref2.y1,
            x4 = _ref2.x4,
            y4 = _ref2.y4;
          var node = document.createElement('div');
          var style = node.style;
          pageDom.appendChild(node);
          style.left = xToWeb(x1) * scale + 'px';
          style.bottom = yToWeb(y4) * scale + 'px';
          style.width = xToWeb(x4 - x1) * scale + 'px';
          style.height = xToWeb(y1 - y4) * scale + 'px';
          style.backgroundColor = annotation.color;
          node.className = 'nav-document-pdf-highlight';
          nodes.push(node);
          node.addEventListener('click', function () {
            return showAnnotationEditor(nodes, annotation);
          });
        });
        return nodes;
      };
      var showAnnotationEditor = function showAnnotationEditor(nodes, annotation) {
        var saveAction = {
          id: 'save',
          label: $i18n('general.save'),
          action: function action(popover) {
            return popover.accept();
          }
        };
        var deleteAction = {
          id: 'delete',
          label: $i18n('general.delete'),
          action: function action(popover) {
            annotation.prune = true;
            popover.accept();
          }
        };
        var closeAction = {
          id: 'close',
          label: $i18n('general.close'),
          action: function action(popover) {
            return popover.reject();
          }
        };
        var cancelAction = {
          id: 'close',
          label: $i18n('general.cancel'),
          action: function action(popover) {
            return popover.reject();
          }
        };
        return $popover({
          target: nodes[0],
          templateUri: NAV_TEMPLATES.document_note,
          annotation: {
            contents: annotation.contents,
            color: annotation.color ? (0, _color.hexShorthandToFull)(annotation.color) : undefined,
            type: annotation.type
          },
          actions: annotation.new ? [saveAction, cancelAction] : [saveAction, deleteAction, closeAction]
        }).then(function ($scope) {
          annotation.contents = $scope.annotation.contents;
          if (annotation.prune) {
            doc.annotations = filterEmptyAnnotations(doc.annotations);
            (0, _lodash.invoke)(nodes, 'remove');
            if (annotation.new) return;
          }
          if (annotation.type === 'highlight') {
            annotation.color = $scope.annotation.color;
            (0, _lodash.each)(nodes, function (node) {
              return node.style.backgroundColor = annotation.color;
            });
          }
          if (annotation.type === 'text' && annotation.new && !annotation.contents) return;
          delete annotation.new;
          return databaseService.saveDoc(doc).then(saveCb);
        }, function () {
          if (annotation.new) {
            annotation.prune = true;
            doc.annotations = filterEmptyAnnotations(doc.annotations);
            (0, _lodash.invoke)(nodes, 'remove');
          }
        });
      };
      var container = viewer.container;
      container.addEventListener('pagerendered', function (e) {
        var page = e.detail.pageNumber;
        var pageDom = e.target;
        var scale = viewer.currentScale;
        var annotationsByType = (0, _lodash.chain)(doc.annotations).filter(function (ann) {
          return ann.page === page;
        }).groupBy('type').value();
        (0, _lodash.each)(annotationsByType.highlight, function (ann) {
          return buildHighlightAnnotation(pageDom, ann, scale);
        });
        (0, _lodash.each)(annotationsByType.text, function (ann) {
          return buildAnnotation(pageDom, ann, scale);
        });
        var addTextAnnotation = function addTextAnnotation(e) {
          var x = e.clientX;
          var y = e.clientY;
          var rect = getPageRect(pageDom);
          var annotation = {
            new: true,
            pos_x: xFromWeb((x - rect.left - HORIZONTAL_SHIFT) / scale),
            pos_y: yFromWeb((rect.bottom - y) / scale),
            page: page,
            type: 'text',
            timestamp: (0, _momentTimezone.default)().unix()
          };
          doc.annotations.push(annotation);
          var nodes = buildAnnotation(pageDom, annotation, scale);
          showAnnotationEditor(nodes, annotation);
        };
        var addHighLightAnnotation = function addHighLightAnnotation(e, selection) {
          var quads = [];
          var rect = getPageRect(pageDom);
          var getQuad = function getQuad(_ref3) {
            var bottom = _ref3.bottom,
              left = _ref3.left,
              height = _ref3.height,
              width = _ref3.width;
            if (!height || !width) {
              return;
            }
            var x1 = xFromWeb((left - rect.left) / scale);
            var x4 = xFromWeb(width / scale) + x1;
            var y4 = yFromWeb((rect.bottom - bottom) / scale);
            var y1 = yFromWeb(height / scale) + y4;
            quads.push({
              x1: x1,
              y1: y1,
              x2: x4,
              y2: y1,
              x3: x1,
              y3: y4,
              x4: x4,
              y4: y4
            });
          };
          selection = selection || getSelection();
          if (selection) {
            selection.rects.forEach(getQuad);
          }
          if (!quads.length) {
            return;
          }
          if (e) e.preventDefault();
          var annotation = {
            new: true,
            page: page,
            quad_points: quads,
            type: 'highlight',
            timestamp: (0, _momentTimezone.default)().unix(),
            color: '#f00',
            highlighted_text: selection.highlighted,
            rect: getRect(quads)
          };
          doc.annotations.push(annotation);
          var nodes = buildHighlightAnnotation(pageDom, annotation, scale);
          showAnnotationEditor(nodes, annotation);
        };
        var textlayer = pageDom.querySelector('.textLayer');
        var triggerSelection = function triggerSelection(selection, e) {
          if (selection) {
            addHighLightAnnotation(e, selection);
          } else {
            addTextAnnotation(e);
          }
          active = false;
          activeEndCb();
        };
        textlayer.addEventListener('mouseup', function (e) {
          if (!active) return;
          var selection = getSelection();
          $timeout(function () {
            return triggerSelection(selection, e);
          });
        });
        textlayer.triggerSelection = triggerSelection;
      });
      return {
        onActiveEnd: function onActiveEnd(cb) {
          activeEndCb = cb;
        },
        setActive: function setActive(activeState) {
          active = activeState;
          if (!active) {
            return;
          }
          var selection = getSelection();
          var parentNode = selection ? selection.parent : null;
          while (parentNode && !$(parentNode).hasClass('page')) {
            parentNode = parentNode.parentNode;
          }
          if (parentNode) {
            var layer = $(parentNode).find('.textLayer')[0];
            if (layer) $timeout(function () {
              return layer.triggerSelection(selection);
            });
          }
        }
      };
    }
  };
}
angular.module('maestro.services').service('pdfService', PdfService);

},{"../utils/color":354,"@babel/runtime/helpers/interopRequireDefault":382,"frontloader-common/lab":1110,"lodash":"lodash","moment-timezone":"moment-timezone","pdfjs-dist":1181,"pdfjs-dist/web/compatibility":1183,"pdfjs-dist/web/pdf_viewer":1184,"rangefix":1239}],277:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _lodash = require("lodash");
var _browser = require("../utils/browser");
var _videoPipService = _interopRequireDefault(require("./videoPipService"));
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = (0, _getPrototypeOf2.default)(t); if (r) { var s = (0, _getPrototypeOf2.default)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0, _possibleConstructorReturn2.default)(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var PictureInPictureService = function (_VideoPipService) {
  PictureInPictureService.$inject = ["EVENT", "$document", "$q", "$compile", "$rootScope", "$eventBus", "$location", "$http", "metricsService", "visibilityService", "navService"];
  (0, _inherits2.default)(PictureInPictureService, _VideoPipService);
  var _super = _createSuper(PictureInPictureService);
  /* @ngInject */function PictureInPictureService(EVENT, $document, $q, $compile, $rootScope, $eventBus, $location, $http, metricsService, visibilityService, navService) {
    var _this;
    (0, _classCallCheck2.default)(this, PictureInPictureService);
    _this = _super.call(this, $document, $eventBus, $location, $rootScope, $http, navService);
    _this.event = EVENT;
    _this.$q = $q;
    _this.$compile = $compile;
    _this.metricsService = metricsService;
    _this.theatreMode = false;
    _this.player = null;
    _this.activeTrackings = [];
    $eventBus.spawn((0, _assertThisInitialized2.default)(_this));
    $eventBus.on('pip:start', function (params) {
      return _this.start(params);
    });
    _this.currentUrl = null;
    _this.currentLiveStreamId = null;
    return _this;
  }
  (0, _createClass2.default)(PictureInPictureService, [{
    key: "start",
    value: function start(config) {
      var _this2 = this;
      console.log('[PictureInPictureService] start');
      if ((0, _lodash.isEmpty)(config) || !(0, _lodash.isObject)(config)) {
        return;
      }
      var width = config.width,
        height = config.height,
        url = config.url,
        liveStreamId = config.liveStreamId;
      if (liveStreamId && (0, _lodash.get)(this, 'config.liveStreamId') === liveStreamId) {
        return;
      }
      this.config = config;
      this.initialWidth = width;
      if (url && this.currentUrl === url && liveStreamId === this.currentLiveStreamId) {
        this.setStaticPosition(width);
        return;
      }
      this.stop();
      this.currentUrl = url;
      this.currentLiveStreamId = liveStreamId;
      this.startTracking(config);
      var deferred = this.$q.defer();
      this.pipScope = this.$rootScope.$new(true);
      this.player = {
        deferred: deferred,
        scope: this.pipScope
      };
      this.pipScope.config = config;
      this.pipScope.onClose = function () {
        _this2.stop();
      };
      this.pipScope.analytics = config.analytic_params;
      console.log('[PictureInPictureService] starting playback', url);
      var videoElement;
      if ((0, _browser.isUnsupported)()) {
        console.log('[PictureInPictureService] video streaming not supported on this browser');
        videoElement = this.$compile('<update-browser-box></update-browser-box>')(this.pipScope);
      } else {
        var isInSession = (0, _lodash.get)(this, 'navService.activeNav.nav.page_params.fp_type', '') === 'session';
        var homeFeedWidthClass = config.isInPerson && !isInSession ? 'home-feed-width' : '';
        videoElement = this.$compile("<pip class=\"hls ".concat(homeFeedWidthClass, "\" config=\"config\" on-close=\"onClose()\" analytics=\"analytics\"></pip>"))(this.pipScope);
      }
      (0, _get2.default)((0, _getPrototypeOf2.default)(PictureInPictureService.prototype), "init", this).call(this, videoElement, {
        scope: this.pipScope,
        width: width,
        height: height
      });
      this.setStaticPosition(width);
      if (config.fullscreen) {
        this.enterTheatreMode();
      }
      return deferred.promise;
    }
  }, {
    key: "stop",
    value: function stop() {
      if (!this.player) {
        return;
      }
      console.log('[PictureInPictureService] finished');
      this.player.deferred.resolve();
      this.player = null;
      this.pipScope.$destroy();
      this.pipScope = null;
      this.currentUrl = null;
      this.currentLiveStreamId = null;
      this.config = null;
      this.stopTracking();
      (0, _get2.default)((0, _getPrototypeOf2.default)(PictureInPictureService.prototype), "stop", this).call(this);
    }
  }, {
    key: "startTracking",
    value: function startTracking(config) {
      this.trackingConfiguration = {
        analytic_params: config.analytic_params
      };
      this.activeTrackings.push(this.trackingConfiguration);
    }
  }, {
    key: "stopTracking",
    value: function stopTracking() {
      var _this3 = this;
      (0, _lodash.remove)(this.activeTrackings, function (conf) {
        return conf === _this3.trackingConfiguration;
      });
    }
  }, {
    key: "float",
    value: function float() {
      if ((0, _lodash.get)(this, 'pipScope.config.isInPerson')) {
        return this.stop();
      }
      (0, _get2.default)((0, _getPrototypeOf2.default)(PictureInPictureService.prototype), "float", this).call(this);
    }
  }, {
    key: "setStaticPosition",
    value: function setStaticPosition(width) {
      this.embed();
      if (width) {
        this.videoElement.removeClass('pinned').css({
          width: '',
          left: '',
          top: '',
          height: ''
        });
      }
    }
  }, {
    key: "restore",
    value: function restore() {
      this.setStaticPosition(this.initialWidth);
    }
  }, {
    key: "enterTheatreMode",
    value: function enterTheatreMode() {
      this.theatreMode = true;
    }
  }, {
    key: "leaveTheatreMode",
    value: function leaveTheatreMode() {
      if (this.event.is_webinar) return;
      this.theatreMode = false;
    }
  }]);
  return PictureInPictureService;
}(_videoPipService.default);
angular.module('maestro.services').service('pictureInPictureService', PictureInPictureService);

},{"../utils/browser":352,"./videoPipService":293,"@babel/runtime/helpers/assertThisInitialized":374,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/get":379,"@babel/runtime/helpers/getPrototypeOf":380,"@babel/runtime/helpers/inherits":381,"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/helpers/possibleConstructorReturn":387,"lodash":"lodash"}],278:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
var PollService = function () {
  PollService.$inject = ["EID", "$http", "liveStreamService", "metricsService", "signalService"];
  /* @ngInject */
  function PollService(EID, $http, liveStreamService, metricsService, signalService) {
    (0, _classCallCheck2.default)(this, PollService);
    this.$http = $http;
    this.eid = EID;
    this.liveStreamService = liveStreamService;
    this.metricsService = metricsService;
    this.signalService = signalService;
    this.trackedExecutions = [];
    this.trackedResultsShown = [];
    this.jitter = Math.round(Math.random() * 10 * 1000);
  }
  (0, _createClass2.default)(PollService, [{
    key: "onPollExecuted",
    value: function onPollExecuted(documentId, handler) {
      if (!documentId) {
        return console.error('[PollsService] documentId is required');
      }
      return this.signalService.addSignalListener("".concat(documentId, "/poll/executed"), handler);
    }
  }, {
    key: "onExecutionUpdate",
    value: function onExecutionUpdate(documentId, handler) {
      if (!documentId) {
        return console.error('[PollsService] documentId is required');
      }
      return this.signalService.addSignalListener("".concat(documentId, "/poll/execution/update"), handler);
    }
  }, {
    key: "onHideResults",
    value: function onHideResults(documentId, handler) {
      if (!documentId) {
        return console.error('[PollsService] documentId is required');
      }
      return this.signalService.addSignalListener("".concat(documentId, "/poll/hide-results"), handler);
    }
  }, {
    key: "onWordCloudResults",
    value: function onWordCloudResults(livestreamId, executionId, handler) {
      return this.signalService.addSignalListener("".concat(livestreamId, "/word-cloud/results/").concat(executionId), function (payload) {
        delete payload.results;
        handler(payload);
      });
    }
  }, {
    key: "onMultipleChoiceResults",
    value: function onMultipleChoiceResults(livestreamId, executionId, handler) {
      return this.signalService.addSignalListener("".concat(livestreamId, "/poll/results/").concat(executionId), function (payload) {
        handler(payload);
      });
    }
  }, {
    key: "vote",
    value: function vote(documentId, executionId, answers) {
      return this.$http.post("/api/v1/eid/".concat(this.eid, "/live-stream/").concat(documentId, "/poll/").concat(executionId), {
        answers: answers
      });
    }
  }, {
    key: "getCurrentPoll",
    value: (function () {
      var _getCurrentPoll = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee(liveStreamId) {
        var state;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.liveStreamService.getInitialState(liveStreamId);
            case 2:
              state = _context.sent;
              return _context.abrupt("return", (0, _lodash.get)(state, 'data.pollState', {}));
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getCurrentPoll(_x) {
        return _getCurrentPoll.apply(this, arguments);
      }
      return getCurrentPoll;
    }())
  }, {
    key: "onExecution",
    value: function onExecution(executionId) {
      var _this = this;
      this.onResultsHidden();
      if (!executionId || this.trackedExecutions.includes(executionId)) {
        return;
      }
      this.trackedExecutions.push(executionId);
      var stats = {
        name: 'view',
        document_type: 'poll-execution',
        document_id: executionId,
        jitter: this.jitter
      };
      setTimeout(function () {
        return _this.metricsService.trackAnalytics(stats);
      }, this.jitter);
    }
  }, {
    key: "onResultsShown",
    value: function onResultsShown(executionId) {
      var _this2 = this;
      if (!executionId || this.trackedResultsShown.includes(executionId)) {
        return;
      }
      this.trackedResultsShown.push(executionId);
      var stats = {
        name: 'view',
        document_type: 'poll-execution-result',
        document_id: executionId,
        jitter: this.jitter
      };
      setTimeout(function () {
        return _this2.metricsService.trackAnalytics(stats);
      }, this.jitter);
    }
  }, {
    key: "onResultsHidden",
    value: function onResultsHidden() {
      this.trackedResultsShown = [];
    }
  }]);
  return PollService;
}();
exports.default = PollService;
angular.module('maestro.services').service('pollService', PollService);

},{"@babel/runtime/helpers/asyncToGenerator":375,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/regenerator":398,"lodash":"lodash"}],279:[function(require,module,exports){
"use strict";

require("frontloader-common/vendor/bootstrap/tooltip");
require("frontloader-common/vendor/bootstrap/popover");
var _lodash = require("lodash");
var DEFAULT_POPOVER_OPTIONS = {
  animated: true,
  html: true,
  placement: 'top auto',
  trigger: 'manual'
};
function PopoverService() {
  var currentOpenPopoverScope;
  var _service;
  window.addEventListener('orientationchange', function () {
    if (_service) {
      _service.clearAll();
    }
  });
  this.$get = /* @ngInject */["$q", "$rootScope", "$templateRequest", "$compile", "$timeout", function ($q, $rootScope, $templateRequest, $compile, $timeout) {
    var closeOutsideHandler = function closeOutsideHandler(e) {
      if (currentOpenPopoverScope && $(e.target).parents('.popover.in').length === 0) {
        currentOpenPopoverScope.reject('clickOutside');
      }
    };
    _service = function service(config) {
      _service.dismissOpenPopover();
      var $target = angular.element(config.target);
      var deferred = $q.defer();
      var localScope = $rootScope.$new(true);
      angular.extend(localScope, config);
      localScope.$$deferred = function () {
        return deferred;
      };
      localScope.accept = function (value) {
        return deferred.resolve(value || localScope);
      };
      localScope.reject = function (reason) {
        return deferred.reject(reason || localScope);
      };
      var fetchTemplate = function fetchTemplate() {
        return config.template ? $q.resolve(config.template) : $templateRequest(config.templateUri);
      };
      fetchTemplate().then(function (template) {
        var options = (0, _lodash.defaults)(config.options || {}, DEFAULT_POPOVER_OPTIONS);
        options.content = $compile(template)(localScope);
        $target.popover(options);
        if (options.trigger === 'manual') {
          $target.popover('show');
          $timeout(function () {
            return $(document.body).on('click', closeOutsideHandler);
          });
        }
        currentOpenPopoverScope = localScope;
      }, function () {
        return deferred.reject(localScope);
      });
      return deferred.promise.finally(function () {
        localScope.$destroy();
        $target.popover('destroy');
        currentOpenPopoverScope = null;
        $(document.body).off('click', closeOutsideHandler);
      });
    };
    _service.hasOpenPopover = function () {
      return !!currentOpenPopoverScope;
    };
    _service.dismissOpenPopover = function () {
      if (currentOpenPopoverScope) {
        currentOpenPopoverScope.reject();
      }
      currentOpenPopoverScope = null;
    };
    _service.clearAll = function () {
      _service.dismissOpenPopover();
      angular.element('.popover.in').remove();
    };
    return _service;
  }];
}
angular.module('maestro.services').provider('$popover', PopoverService);

},{"frontloader-common/vendor/bootstrap/popover":1113,"frontloader-common/vendor/bootstrap/tooltip":1114,"lodash":"lodash"}],280:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var ProgressBarService = function () {
  ProgressBarService.$inject = ["$rootScope"];
  /* @ngInject */
  function ProgressBarService($rootScope) {
    (0, _classCallCheck2.default)(this, ProgressBarService);
    this.$rootScope = $rootScope;
    this.activeTasks = 0;
    this.activeBlockingTasks = 0;
  }
  (0, _createClass2.default)(ProgressBarService, [{
    key: "hasActiveTasks",
    value: function hasActiveTasks() {
      return this.activeTasks > 0 || this.activeBlockingTasks > 0;
    }
  }, {
    key: "hasBlockingTasks",
    value: function hasBlockingTasks() {
      return this.activeBlockingTasks > 0;
    }
  }, {
    key: "notify",
    value: function notify() {
      this.$rootScope.$emit('progress:activity', this.hasActiveTasks());
    }
  }, {
    key: "startTask",
    value: function startTask() {
      this.activeTasks += 1;
      this.notify();
      return this.activeTasks;
    }
  }, {
    key: "finishTask",
    value: function finishTask() {
      this.activeTasks = this.activeTasks > 0 ? this.activeTasks - 1 : 0;
      this.notify();
      return this.activeTasks;
    }
  }, {
    key: "startBlockingTask",
    value: function startBlockingTask() {
      console.log('[ProgressBarService] started a blocking task');
      this.activeBlockingTasks += 1;
      this.notify();
      return this.activeBlockingTasks;
    }
  }, {
    key: "finishBlockingTask",
    value: function finishBlockingTask() {
      if (!this.activeBlockingTasks) {
        this.notify();
        return;
      }
      this.activeBlockingTasks -= 1;
      if (this.activeBlockingTasks === 0) {
        console.log('[ProgressBarService] all blocking tasks have finished');
      }
      this.notify();
      return this.activeBlockingTasks;
    }
  }]);
  return ProgressBarService;
}();
angular.module('maestro.services').service('progressBarService', ProgressBarService);

},{"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382}],281:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
var QnaService = function () {
  QnaService.$inject = ["EID", "$http", "liveStreamService", "metricsService", "signalService"];
  /* @ngInject */
  function QnaService(EID, $http, liveStreamService, metricsService, signalService) {
    (0, _classCallCheck2.default)(this, QnaService);
    this.$http = $http;
    this.eid = EID;
    this.liveStreamService = liveStreamService;
    this.metricsService = metricsService;
    this.signalService = signalService;
    this.trackedHighlightedQuestions = [];
    this.jitter = Math.round(Math.random() * 10 * 1000);
  }
  (0, _createClass2.default)(QnaService, [{
    key: "updateSignal",
    value: function updateSignal(livestreamId) {
      return "liveStream/".concat(livestreamId, "/questions");
    }
  }, {
    key: "getQuestions",
    value: (function () {
      var _getQuestions = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee(livestreamId) {
        var state;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.liveStreamService.getInitialState(livestreamId);
            case 2:
              state = _context.sent;
              return _context.abrupt("return", {
                qna: (0, _lodash.get)(state, 'data.qna', []),
                qnaSortedByUpvotes: (0, _lodash.get)(state, 'data.qnaSortedByUpvotes', []),
                qnaUpvotedQuestions: (0, _lodash.get)(state, 'data.qnaUpvotedQuestions')
              });
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getQuestions(_x) {
        return _getQuestions.apply(this, arguments);
      }
      return getQuestions;
    }())
  }, {
    key: "postQuestion",
    value: function postQuestion(livestreamId, _ref) {
      var anonymous = _ref.anonymous,
        question = _ref.question;
      return this.$http.post("/api/v1/eid/".concat(this.eid, "/live-stream/").concat(livestreamId, "/questions"), {
        anonymous: anonymous,
        question: question
      });
    }
  }, {
    key: "isAnonymous",
    value: function isAnonymous(question) {
      if (!question) {
        return false;
      }
      return !question.participant || question.participant.toLowerCase() === 'anonymous';
    }
  }, {
    key: "isFromBSTG",
    value: function isFromBSTG(question) {
      if (!question) {
        return false;
      }
      return !question.pid && !this.isAnonymous(question);
    }
  }, {
    key: "resolveProfilePicture",
    value: function resolveProfilePicture(question, eventIcon) {
      if (!question) {
        return question;
      }
      var fromBstg = this.isFromBSTG(question);
      question.profile_pic = question.profile_pic || eventIcon && fromBstg ? eventIcon : '';
      return question;
    }
  }, {
    key: "onQnaHighlight",
    value: function onQnaHighlight(questionId) {
      var _this = this;
      if (!questionId || this.trackedHighlightedQuestions.includes(questionId)) {
        return;
      }
      this.trackedHighlightedQuestions.push(questionId);
      var stats = {
        name: 'view',
        document_type: 'live_qna_question',
        document_id: questionId,
        jitter: this.jitter
      };
      setTimeout(function () {
        return _this.metricsService.trackAnalytics(stats);
      }, this.jitter);
    }
  }, {
    key: "voteQuestions",
    value: function voteQuestions(livestreamId, _ref2) {
      var _ref2$upvotes = _ref2.upvotes,
        upvotes = _ref2$upvotes === void 0 ? undefined : _ref2$upvotes,
        _ref2$downvotes = _ref2.downvotes,
        downvotes = _ref2$downvotes === void 0 ? undefined : _ref2$downvotes;
      return this.$http.post("/api/v1/eid/".concat(this.eid, "/live-stream/").concat(livestreamId, "/questions/vote"), {
        upvotes: upvotes,
        downvotes: downvotes
      });
    }
  }]);
  return QnaService;
}();
exports.default = QnaService;
angular.module('maestro.services').service('qnaService', QnaService);

},{"@babel/runtime/helpers/asyncToGenerator":375,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/regenerator":398,"lodash":"lodash"}],282:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var sendReaction = function sendReaction(http, endpoint, reactions) {
  http.post(endpoint, reactions).catch(function (error) {
    console.error("[Reactions] Couldn't update reaction count:", error.message || error.statusText);
  });
};
var ReactionsService = function () {
  ReactionsService.$inject = ["EID", "$http", "signalService"];
  /* @ngInject */
  function ReactionsService(EID, $http, signalService) {
    (0, _classCallCheck2.default)(this, ReactionsService);
    this.$http = $http;
    this.eid = EID;
    this.signalService = signalService;
  }
  (0, _createClass2.default)(ReactionsService, [{
    key: "sendClaps",
    value: function sendClaps(documentId, claps) {
      sendReaction(this.$http, this.endpoint(documentId), {
        claps: claps
      });
    }
  }, {
    key: "onClapsSignal",
    value: function onClapsSignal(documentId, handler) {
      return this.signalService.addSignalListener("liveStream/".concat(documentId, "/interactions"), handler);
    }
  }, {
    key: "endpoint",
    value: function endpoint(documentId) {
      return "/api/v1/eid/".concat(this.eid, "/log/live-stream/").concat(documentId, "/reactions");
    }
  }]);
  return ReactionsService;
}();
exports.default = ReactionsService;
angular.module('maestro.services').service('reactionsService', ReactionsService);

},{"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382}],283:[function(require,module,exports){
"use strict";

var _lodash = require("lodash");
function SheetService() {
  var openSheets = [];
  this.$get = /* @ngInject */["THEME", "$document", "$rootScope", "$q", "$compile", "$window", function (THEME, $document, $rootScope, $q, $compile, $window) {
    var $body = $($document[0].body);
    var service = function service(config) {
      var id = (0, _lodash.uniqueId)('sheet_');
      var deferred = $q.defer();
      var promise = deferred.promise;
      var sheetScope = $rootScope.$new(true);
      openSheets.push(sheetScope);
      sheetScope.$$sheetId = promise.$$sheetId = id;
      sheetScope.$$deferred = function () {
        return deferred;
      };
      sheetScope.relayout = function () {
        return deferred.notify(1);
      };
      sheetScope.accept = function (reason) {
        return deferred.resolve(reason);
      };
      sheetScope.reject = function (reason) {
        return deferred.reject(reason);
      };
      sheetScope.device = $rootScope.device;
      sheetScope.eventTheme = THEME;
      if (config.menu) {
        config.pin = 'bottom';
        config.prompt = true;
        config.dismissOnOutsideClick = true;
        angular.element($window).one('resize', function () {
          return deferred.reject();
        });
      }
      angular.extend(sheetScope, config);
      $body.append($compile('<sheet></sheet>')(sheetScope));
      $body.addClass('modal-open');
      promise.then(function (reason) {
        sheetScope.$destroy();
        return reason;
      }, function (reason) {
        console.log('[$sheet] rejected', id, reason);
        sheetScope.$destroy();
        return $q.reject(reason);
      }).finally(function () {
        console.log('[$sheet] cleaning up', id);
        openSheets = (0, _lodash.filter)(openSheets, function (sheet) {
          return sheet.$$sheetId !== id;
        });
        if (openSheets.length === 0) {
          $body.removeClass('modal-open');
        }
      });
      if (!config.nav && !config.prompt) {
        var off = $rootScope.$on('navigate', function () {
          deferred.reject();
          off();
        });
      }
      return promise;
    };
    service.hasOpenSheets = function () {
      return openSheets.filter(function (sheet) {
        return !sheet.menu && !sheet.alert;
      }).length > 0;
    };
    service.dismissAllSheets = function (reason) {
      return (0, _lodash.each)(openSheets, function (sheet) {
        return sheet.reject(reason);
      });
    };
    service.dismissMenus = function (reason) {
      return openSheets.filter(function (sheet) {
        return sheet.menu;
      }).forEach(function (sheet) {
        return sheet.reject(reason);
      });
    };
    service.getSheetIds = function () {
      return openSheets.map(function (sheet) {
        return sheet.$$sheetId;
      });
    };
    service.getNavSheetIds = function () {
      return openSheets.filter(function (sheet) {
        return !!sheet.nav;
      }).map(function (sheet) {
        return sheet.$$sheetId;
      });
    };
    service.dismissSheet = function (id, reason) {
      return openSheets.filter(function (sheet) {
        return sheet.$$sheetId === id;
      }).forEach(function (sheet) {
        return sheet.reject(reason);
      });
    };
    return service;
  }];
}
angular.module('maestro.services').provider('$sheet', SheetService);

},{"lodash":"lodash"}],284:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _baseService = require("./baseService");
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = (0, _getPrototypeOf2.default)(t); if (r) { var s = (0, _getPrototypeOf2.default)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0, _possibleConstructorReturn2.default)(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var SignalService = function (_BaseService) {
  SignalService.$inject = ["$http", "databaseService"];
  (0, _inherits2.default)(SignalService, _BaseService);
  var _super = _createSuper(SignalService);
  /* @ngInject */
  function SignalService($http, databaseService) {
    var _this;
    (0, _classCallCheck2.default)(this, SignalService);
    _this = _super.call(this, $http);
    _this.databaseService = databaseService;
    _this.appScriptListeners = {};
    _this.isConnected = false;
    var webSocketsService = window.APP.services.webSockets;
    _this.init = webSocketsService.init.bind(webSocketsService);
    _this.addSignalListener = webSocketsService.addSignalListener.bind(webSocketsService);
    _this.removeSignalListener = webSocketsService.removeSignalListener.bind(webSocketsService);
    _this.sendSignal = webSocketsService.sendSignal.bind(webSocketsService);
    _this.addEventListener = webSocketsService.addEventListener.bind(webSocketsService);
    _this.removeEventListener = webSocketsService.removeEventListener.bind(webSocketsService);
    _this.restart = webSocketsService.restart.bind(webSocketsService);
    return _this;
  }
  (0, _createClass2.default)(SignalService, [{
    key: "addAppscriptSignalListener",
    value: (function () {
      var _addAppscriptSignalListener = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee(args) {
        var _this2 = this;
        var _args, signalType, appscriptPath, key, listener;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _args = (0, _slicedToArray2.default)(args, 2), signalType = _args[0], appscriptPath = _args[1];
              key = "".concat(signalType, "-").concat(appscriptPath);
              listener = function listener(signal) {
                return _this2.databaseService.runAppScript(appscriptPath, signal);
              };
              this.appScriptListeners[key] = listener;
              _context.next = 6;
              return this.addSignalListener(signalType, listener);
            case 6:
              return _context.abrupt("return", _context.sent);
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function addAppscriptSignalListener(_x) {
        return _addAppscriptSignalListener.apply(this, arguments);
      }
      return addAppscriptSignalListener;
    }())
  }, {
    key: "removeAppscriptSignalListener",
    value: function () {
      var _removeAppscriptSignalListener = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee2(args) {
        var _args3, signalType, appscriptPath, key, listener;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _args3 = (0, _slicedToArray2.default)(args, 2), signalType = _args3[0], appscriptPath = _args3[1];
              key = "".concat(signalType, "-").concat(appscriptPath);
              listener = this.appScriptListeners[key];
              if (listener) {
                _context2.next = 5;
                break;
              }
              return _context2.abrupt("return");
            case 5:
              delete this.appScriptListeners[key];
              _context2.next = 8;
              return this.removeSignalListener(signalType, listener);
            case 8:
              return _context2.abrupt("return", _context2.sent);
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function removeAppscriptSignalListener(_x2) {
        return _removeAppscriptSignalListener.apply(this, arguments);
      }
      return removeAppscriptSignalListener;
    }()
  }]);
  return SignalService;
}(_baseService.BaseService);
exports.default = SignalService;

},{"./baseService":244,"@babel/runtime/helpers/asyncToGenerator":375,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/getPrototypeOf":380,"@babel/runtime/helpers/inherits":381,"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/helpers/possibleConstructorReturn":387,"@babel/runtime/helpers/slicedToArray":390,"@babel/runtime/regenerator":398}],285:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
var _color = require("../utils/color");
var StyleParserService = function () {
  function StyleParserService() {
    (0, _classCallCheck2.default)(this, StyleParserService);
  }
  (0, _createClass2.default)(StyleParserService, [{
    key: "_getKey",
    value: function _getKey(symbol, key) {
      return symbol ? symbol + '_' + key : key;
    }
  }, {
    key: "parseBoxing",
    value: function parseBoxing(config, symbol) {
      var styles = {};
      var key = this._getKey(symbol, 'width');
      if (config[key]) {
        styles['width'] = config[key] + 'px';
      }
      key = this._getKey(symbol, 'height');
      if (config[key]) {
        styles['height'] = config[key] + 'px';
      }
      key = this._getKey(symbol, 'thickness');
      if (config[key]) {
        styles['height'] = config[key] + 'px';
      }
      key = this._getKey(symbol, 'max_width');
      if (config[key]) {
        styles['max-width'] = config[key] + 'px';
      }
      key = this._getKey(symbol, 'max_height');
      if (config[key]) {
        styles['max-height'] = config[key] + 'px';
      }
      key = this._getKey(symbol, 'max_lines');
      if (config[key] === 1) {
        styles['overflow'] = 'hidden';
        styles['white-space'] = 'nowrap';
        styles['text-overflow'] = 'ellipsis';
      }
      return styles;
    }
  }, {
    key: "parseMargins",
    value: function parseMargins(config) {
      var styles = {};
      if (config.margin) {
        (0, _lodash.each)(config.margin, function (v, k) {
          var key = 'margin-' + k;
          styles[key] = v + 'px';
        });
      }
      return styles;
    }
  }, {
    key: "parseColor",
    value: function parseColor(color) {
      return (0, _color.sanitizeHex)(color);
    }
  }, {
    key: "parseTextsStyles",
    value: function parseTextsStyles(config, symbol) {
      var styles = {};
      var key = this._getKey(symbol, 'color');
      if (config[key]) {
        styles['color'] = this.parseColor(config[key]);
      }
      if (config.text_color) {
        styles['color'] = '#ffffff';
        if (config.text_color.default) {
          styles['color'] = this.parseColor(config.text_color.default);
        }
      }
      key = this._getKey(symbol, 'size');
      if (config[key]) {
        styles['font-size'] = config[key] + 'px';
      }
      key = this._getKey(symbol, 'style');
      switch (config[key]) {
        case 'bold':
        case 'normal':
          styles['font-weight'] = config[key];
          break;
        case 'bold-italic':
          styles['font-weight'] = config[key];
          styles['font-style'] = config[key];
          break;
        case 'italic':
          styles['font-style'] = 'italic';
          break;
      }
      key = this._getKey(symbol, 'alignment');
      if (config[key]) {
        styles['text-align'] = config[key];
      }
      return styles;
    }
  }, {
    key: "parseImageStyles",
    value: function parseImageStyles(config) {
      var styles = this.parseBoxing(config, 'image');
      if (config.image_shape === 'circle') {
        styles['border-radius'] = '100%';
      }
      if (config.image_height || config.image_width) {
        styles['object-fit'] = 'cover';
      }
      return styles;
    }
  }]);
  return StyleParserService;
}();
function StyleParserProvider() {
  this.$get = function () {
    return new StyleParserService();
  };
}
angular.module('maestro.services').provider('styleParser', StyleParserProvider);

},{"../utils/color":354,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"lodash":"lodash"}],286:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var EXT_PREFIX = '_ext.';
var PRESENCE_STRING_VALUE = '*has_field*';
var TargetingService = function () {
  TargetingService.$inject = ["ACTIVATED_PERSON", "PERSON_DYNAMIC_EXTENSIONS", "EID", "PID", "$http"];
  /* @ngInject */
  function TargetingService(ACTIVATED_PERSON, PERSON_DYNAMIC_EXTENSIONS, EID, PID, $http) {
    (0, _classCallCheck2.default)(this, TargetingService);
    this.user = ACTIVATED_PERSON;
    this.dynExt = PERSON_DYNAMIC_EXTENSIONS;
    this.$http = $http;
    this.eventId = EID;
    this.pid = PID;
  }
  (0, _createClass2.default)(TargetingService, [{
    key: "canUserSeeItem",
    value: function canUserSeeItem(item) {
      if (!(0, _lodash.isObject)(item)) {
        return false;
      }
      if (this.shouldAskTheServer(item)) {
        console.warn('[TargetingService] Request should be offloaded to the server');
        return false;
      }
      var _this$_extractRules = this._extractRules(item),
        targets = _this$_extractRules.targets,
        exceptions = _this$_extractRules.exceptions;
      if (targets.length === 0 && exceptions.length === 0) {
        return true;
      }
      return this._testTargetsAndExceptions(targets, exceptions);
    }
  }, {
    key: "isUserTargeted",
    value: (function () {
      var _isUserTargeted = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee(item) {
        var _this$_extractRules2, targets, exceptions;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if ((0, _lodash.isObject)(item)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return", false);
            case 2:
              if (!this.shouldAskTheServer(item)) {
                _context.next = 7;
                break;
              }
              console.warn('[TargetingService] Request should be offloaded to the server');
              _context.next = 6;
              return this._askServer(item);
            case 6:
              return _context.abrupt("return", _context.sent);
            case 7:
              _this$_extractRules2 = this._extractRules(item), targets = _this$_extractRules2.targets, exceptions = _this$_extractRules2.exceptions;
              if (!(targets.length === 0 && exceptions.length === 0)) {
                _context.next = 10;
                break;
              }
              return _context.abrupt("return", true);
            case 10:
              return _context.abrupt("return", this._testTargetsAndExceptions(targets, exceptions));
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function isUserTargeted(_x) {
        return _isUserTargeted.apply(this, arguments);
      }
      return isUserTargeted;
    }())
  }, {
    key: "shouldAskTheServer",
    value: function shouldAskTheServer(item) {
      if (!(0, _lodash.isObject)(item)) {
        return false;
      }
      var _this$_extractRules3 = this._extractRules(item),
        targets = _this$_extractRules3.targets,
        exceptions = _this$_extractRules3.exceptions;
      var rules = [].concat((0, _toConsumableArray2.default)(targets), (0, _toConsumableArray2.default)(exceptions));
      var _iterator = _createForOfIteratorHelper(rules),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var rule = _step.value;
          for (var _i = 0, _Object$keys = Object.keys(rule); _i < _Object$keys.length; _i++) {
            var field = _Object$keys[_i];
            if (this.dynExt.includes(field)) {
              return true;
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return false;
    }
  }, {
    key: "_askServer",
    value: (function () {
      var _askServer2 = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee2(item) {
        var _this$_extractRules4, targets, exceptions, url, result;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this$_extractRules4 = this._extractRules(item), targets = _this$_extractRules4.targets, exceptions = _this$_extractRules4.exceptions;
              url = "/api/v1/eid/".concat(this.eventId, "/targeting/is-targeted");
              _context2.next = 4;
              return this.$http.post(url, {
                targets: targets,
                exceptions: exceptions
              });
            case 4:
              result = _context2.sent;
              return _context2.abrupt("return", (0, _lodash.get)(result, 'data.targeted', false));
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function _askServer(_x2) {
        return _askServer2.apply(this, arguments);
      }
      return _askServer;
    }())
  }, {
    key: "_extractRules",
    value: function _extractRules(item) {
      var targets = item.targets,
        exceptions = item.exceptions;
      targets = targets || [];
      exceptions = exceptions || [];
      if ((0, _lodash.isString)(targets)) {
        try {
          targets = JSON.parse(targets);
        } catch (error) {
          console.warn('[TargetingService] Could not parse the target', error);
        }
      }
      if ((0, _lodash.isString)(exceptions)) {
        try {
          exceptions = JSON.parse(exceptions);
        } catch (error) {
          console.warn('[TargetingService] Could not parse the exceptions', error);
        }
      }
      return {
        targets: targets,
        exceptions: exceptions
      };
    }
  }, {
    key: "_testTargetsAndExceptions",
    value: function _testTargetsAndExceptions(targets, exceptions) {
      var isTargeted = targets.length ? false : true;
      for (var i = 0; i < targets.length; i++) {
        if (this._checkMatch(targets[i])) {
          isTargeted = true;
          break;
        }
      }
      if (!isTargeted) {
        return false;
      }
      if (!exceptions) {
        return true;
      }
      for (var _i2 = 0; _i2 < exceptions.length; _i2++) {
        if (this._checkMatch(exceptions[_i2])) {
          isTargeted = false;
          break;
        }
      }
      return isTargeted;
    }
  }, {
    key: "_checkMatch",
    value: function _checkMatch(atom) {
      try {
        var user = this.user;
        var keys = Object.keys(atom);
        for (var _i3 = 0, _keys = keys; _i3 < _keys.length; _i3++) {
          var key = _keys[_i3];
          var fieldValue = user[key];
          if (key.slice(0, EXT_PREFIX.length) === EXT_PREFIX && user._ext) {
            fieldValue = user._ext[key.slice(EXT_PREFIX.length)];
          }
          var testField = atom[key];
          if (!this._checkFieldMatch(fieldValue, testField, key)) {
            return false;
          }
        }
        return true;
      } catch (error) {
        console.error('[TargetingService] Could not verify target for user', error);
        return false;
      }
    }
  }, {
    key: "_checkFieldMatch",
    value: function _checkFieldMatch(fieldValue, searchedValue, fieldName) {
      if (searchedValue === PRESENCE_STRING_VALUE) {
        return this.user.hasOwnProperty(fieldName);
      }
      var fieldsMatch = fieldValue === searchedValue;
      if (!fieldsMatch && (0, _lodash.isArray)(fieldValue)) {
        if ((0, _lodash.isArray)(searchedValue)) {
          fieldsMatch = (0, _lodash.difference)(fieldValue, searchedValue).length === 0;
        } else {
          fieldsMatch = fieldValue.includes(searchedValue);
        }
      }
      return fieldsMatch;
    }
  }]);
  return TargetingService;
}();
exports.default = TargetingService;

},{"@babel/runtime/helpers/asyncToGenerator":375,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/helpers/toConsumableArray":393,"@babel/runtime/regenerator":398,"lodash":"lodash"}],287:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var TriggerService = function () {
  /* @ngInject */
  function TriggerService() {
    (0, _classCallCheck2.default)(this, TriggerService);
    window.triggers = {};
    this.handlers = {};
  }
  (0, _createClass2.default)(TriggerService, [{
    key: "addTrigger",
    value: function addTrigger(name, fun) {
      var _this = this;
      if (!(0, _lodash.isFunction)(fun)) {
        return;
      }
      if (!this.handlers[name]) {
        this.handlers[name] = [];
      }
      this.handlers[name].push(fun);
      window.triggers[name] = function () {
        for (var _len = arguments.length, arg = new Array(_len), _key = 0; _key < _len; _key++) {
          arg[_key] = arguments[_key];
        }
        var _iterator = _createForOfIteratorHelper(_this.handlers[name]),
          _step;
        try {
          var _loop = function _loop() {
            var handler = _step.value;
            if ((0, _lodash.isFunction)(handler)) {
              setTimeout(function () {
                return handler.apply(void 0, arg);
              });
            }
          };
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        console.log("successfully triggered ".concat(name));
      };
      return function () {
        _this.removeTrigger(name, fun);
      };
    }
  }, {
    key: "removeTrigger",
    value: function removeTrigger(name, fun) {
      this.handlers[name] = this.handlers[name].filter(function (o) {
        return o !== fun;
      });
    }
  }]);
  return TriggerService;
}();
angular.module('maestro.services').service('triggerService', TriggerService);

},{"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"lodash":"lodash"}],288:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
var UiService = function () {
  UiService.$inject = ["$eventBus", "$i18n", "ACTIVATED_PERSON"];
  /* @ngInject */
  function UiService($eventBus, $i18n, ACTIVATED_PERSON) {
    (0, _classCallCheck2.default)(this, UiService);
    this.$eventBus = $eventBus;
    this.$i18n = $i18n;
    this.pid = ACTIVATED_PERSON._id;
    $eventBus.spawn(this);
  }
  (0, _createClass2.default)(UiService, [{
    key: "inAppNotification",
    value: function inAppNotification(config) {
      console.info('[UI Service] In App Notification:', config);
      if ((0, _lodash.get)(config, 'action.params.sender_pid') === this.pid) return;
      this.$eventBus.emit('notification:in-app', config);
    }
  }, {
    key: "buildNotificationMessage",
    value: function buildNotificationMessage(message) {
      message = (0, _lodash.defaults)(message, {
        message: {
          title: '',
          body: ''
        },
        icon: 'icon.spotman/file.png',
        backgroundColor: '#FB4F15',
        contentColor: '#FFFFFF',
        iconColor: '#FFFFFF',
        duration: 10,
        action: {
          path: '',
          params: {}
        }
      });
      var titleTr = message.title && this.$i18n(message.title);
      var subtitleTr = message.body && this.$i18n(message.body);
      if (subtitleTr && message.senderName) {
        subtitleTr = subtitleTr.replace('{fname}', message.senderName);
      }
      return {
        title: titleTr || message.message.title,
        subtitle: subtitleTr || message.message.body,
        icon_url: buildImageUrl(message.icon),
        background_color: message.backgroundColor,
        icon_color: message.iconColor,
        content_color: message.contentColor,
        duration: message.duration,
        action: message.action,
        notificationId: message.notificationId,
        ctx: message.ctx
      };
    }
  }]);
  return UiService;
}();
exports.default = UiService;
function buildImageUrl(asset) {
  if (!(0, _lodash.isString)(asset)) {
    return '';
  }
  if (asset.includes('://')) {
    return asset;
  }
  return asset.replace(/\{{2,3}deviceorientation\}{2,3}/g, 'landscape');
}
angular.module('maestro.services').service('uiService', UiService);

},{"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"lodash":"lodash"}],289:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _url = require("../../utils/url");
var _eventEmitter = _interopRequireDefault(require("../../utils/event-emitter"));
var _lodash = require("lodash");
var MAX_RETRIES = 6;
var TIMEOUT = 15000;
var MIN_DELAY = 500;
var approxMaxRetryDelay = MIN_DELAY * (Math.pow(2, MAX_RETRIES) - 1);
var DEFAULT_RESTART_JITTER = 5 * 1000;
var DEFAULT_RESTART_DELAY = 10 * 1000;
var WebSocketsService = function () {
  function WebSocketsService(primusProvider) {
    var windowProvider = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
    (0, _classCallCheck2.default)(this, WebSocketsService);
    this.primusProvider = primusProvider;
    this.windowProvider = windowProvider;
    this.isConnected = false;
    this.eid = null;
  }
  (0, _createClass2.default)(WebSocketsService, [{
    key: "init",
    value: function init(eid, $timeout) {
      var _this = this;
      console.log('[SignalService] init', eid);
      this.eid = eid;
      this.signalEmitter = new _eventEmitter.default($timeout);
      this.eventEmitter = new _eventEmitter.default($timeout);
      if (this.primus) {
        try {
          this.primus.destroy();
        } catch (e) {
          console.log('[SignalService] could not destroy previous instance', e);
        }
        this.primus = null;
      }
      clearTimeout(this.restartPrimusTimeout);
      this.restartPrimusTimeout = null;
      var query = {
        source: 'webApp',
        eid: eid
      };
      this.primus = new this.primusProvider("".concat(this.windowProvider.location.origin, "?").concat((0, _url.toQueryString)(query)), {
        timeout: TIMEOUT,
        strategy: 'disconnect,online,timeout',
        reconnect: {
          'reconnect timeout': TIMEOUT,
          retries: MAX_RETRIES,
          min: MIN_DELAY
        }
      });
      this.primus.on('open', function () {
        return _this._onInitOpen();
      });
      this.primus.on('error', function (err) {
        return _this.onInitError(err);
      });
      this.primus.on('timeout', function (err) {
        return _this.onInitError(err);
      });
      this.primus.on('data', function (data) {
        return _this._onData(data);
      });
      var genericEventTypes = ['close', 'disconnection', 'open', 'reconnect', 'reconnected', 'reconnect failed', 'timeout', 'end', 'data'];
      var _loop = function _loop() {
        var type = _genericEventTypes[_i];
        _this.primus.on(type, function (err) {
          return _this._onPrimusGenericEvent(type, err);
        });
      };
      for (var _i = 0, _genericEventTypes = genericEventTypes; _i < _genericEventTypes.length; _i++) {
        _loop();
      }
    }
  }, {
    key: "addSignalListener",
    value: (function () {
      var _addSignalListener = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee(signalType, listener) {
        var _this2 = this;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if ((0, _lodash.isFunction)(listener)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return", console.error('[SignalService] listener must be a function'));
            case 2:
              _context.prev = 2;
              _context.next = 5;
              return this.primus.write({
                type: 'registerToSignal',
                signalType: signalType
              });
            case 5:
              this.signalEmitter.addEventListener(signalType, listener);
              return _context.abrupt("return", function () {
                return _this2.removeSignalListener(signalType, listener);
              });
            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](2);
              console.error('[SignalService] An error occurred while adding listener', _context.t0);
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[2, 9]]);
      }));
      function addSignalListener(_x, _x2) {
        return _addSignalListener.apply(this, arguments);
      }
      return addSignalListener;
    }())
  }, {
    key: "removeSignalListener",
    value: (function () {
      var _removeSignalListener = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee2(signalType, listener) {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.signalEmitter.removeEventListener(signalType, listener);
              if (this.signalEmitter.hasListeners(signalType)) {
                _context2.next = 10;
                break;
              }
              _context2.prev = 2;
              _context2.next = 5;
              return this.primus.write({
                type: 'unregisterFromSignal',
                signalType: signalType
              });
            case 5:
              _context2.next = 10;
              break;
            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](2);
              console.error('[SignalService] An error occurred while removing listener', _context2.t0);
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[2, 7]]);
      }));
      function removeSignalListener(_x3, _x4) {
        return _removeSignalListener.apply(this, arguments);
      }
      return removeSignalListener;
    }())
  }, {
    key: "sendSignal",
    value: (function () {
      var _sendSignal = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee3(signal) {
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              console.log('[SignalService] Sending signal', signal);
              _context3.prev = 1;
              _context3.next = 4;
              return this.primus.write({
                type: 'sendSignal',
                signal: signal
              });
            case 4:
              _context3.next = 9;
              break;
            case 6:
              _context3.prev = 6;
              _context3.t0 = _context3["catch"](1);
              console.error('[SignalService] An error occurred while sending signal', _context3.t0);
            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[1, 6]]);
      }));
      function sendSignal(_x5) {
        return _sendSignal.apply(this, arguments);
      }
      return sendSignal;
    }())
  }, {
    key: "addEventListener",
    value: function addEventListener(eventType, listener) {
      return this.eventEmitter.addEventListener(eventType, listener);
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(eventType, listener) {
      return this.eventEmitter.removeEventListener(eventType, listener);
    }
  }, {
    key: "_triggerEvent",
    value: function _triggerEvent(event) {
      this.eventEmitter.emit(event.type, event);
    }
  }, {
    key: "_offInitListeners",
    value: function _offInitListeners() {
      this.primus.off('open', this._onInitOpen);
      this.primus.off('error', this.onInitError);
      this.primus.off('timeout', this.onInitError);
    }
  }, {
    key: "_onInitOpen",
    value: function _onInitOpen() {
      var _this3 = this;
      console.info('[SignalService] connected');
      this._offInitListeners();
      this.primus.on('error', function (err) {
        return _this3._onPrimusGenericEvent('error', err);
      });
      this.primus.on('timeout', function (err) {
        return _this3._onPrimusGenericEvent('timeout', err);
      });
    }
  }, {
    key: "onInitError",
    value: function onInitError(error) {
      console.error("[SignalService] signal initialization error, we will retry ".concat(MAX_RETRIES, " times for approx. ").concat(approxMaxRetryDelay / 1000, "s"), error);
      this.isConnected = false;
      this._triggerEvent({
        type: 'onInitError',
        error: error
      });
    }
  }, {
    key: "_onData",
    value: function _onData(data) {
      var type = data.type,
        signal = data.signal;
      if (type === 'signal' && signal && (0, _lodash.isString)(signal.type) && !(0, _lodash.isEmpty)(signal.type)) {
        this.signalEmitter.emit(signal.type, signal);
      }
    }
  }, {
    key: "_addBackAllExistingSignals",
    value: function _addBackAllExistingSignals() {
      var _this4 = this;
      Object.keys(this.signalEmitter.getListeners()).forEach(function (signalType) {
        _this4.primus.write({
          type: 'registerToSignal',
          signalType: signalType
        });
      });
    }
  }, {
    key: "_onPrimusGenericEvent",
    value: function _onPrimusGenericEvent(type, error) {
      console.debug("[SignalService] ".concat(type, " event"), error);
      if (type === 'open') {
        clearTimeout(this.restartPrimusTimeout);
        this.restartPrimusTimeout = null;
        this._addBackAllExistingSignals();
        this.isConnected = true;
      } else if (['close', 'timeout', 'end'].includes(type)) {
        this.isConnected = false;
      }
      this._triggerEvent({
        type: type,
        error: error
      });
    }
  }, {
    key: "restart",
    value: function restart() {
      var _this5 = this;
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$delay = _ref.delay,
        delay = _ref$delay === void 0 ? DEFAULT_RESTART_DELAY : _ref$delay,
        _ref$jitter = _ref.jitter,
        jitter = _ref$jitter === void 0 ? DEFAULT_RESTART_JITTER : _ref$jitter;
      if (this.restartPrimusTimeout) {
        return;
      }
      this.restartPrimusTimeout = setTimeout(function () {
        _this5.restartPrimusTimeout = null;
        console.error('[SignalService] connection is dead, initiating it again');
        _this5.init(_this5.eid);
      }, delay + Math.floor(Math.random() * jitter));
    }
  }]);
  return WebSocketsService;
}();
exports.default = WebSocketsService;

},{"../../utils/event-emitter":357,"../../utils/url":369,"@babel/runtime/helpers/asyncToGenerator":375,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/regenerator":398,"lodash":"lodash"}],290:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _videoCallService = _interopRequireDefault(require("./videoCallService"));
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = (0, _getPrototypeOf2.default)(t); if (r) { var s = (0, _getPrototypeOf2.default)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0, _possibleConstructorReturn2.default)(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var VideoBreakoutService = function (_VideoCallService) {
  VideoBreakoutService.$inject = ["$http", "EVENT", "databaseService", "$document", "$compile", "$rootScope", "$eventBus", "$location", "navService", "SETTINGS"];
  (0, _inherits2.default)(VideoBreakoutService, _VideoCallService);
  var _super = _createSuper(VideoBreakoutService);
  /* @ngInject */
  function VideoBreakoutService($http, EVENT, databaseService, $document, $compile, $rootScope, $eventBus, $location, navService, SETTINGS) {
    var _this;
    (0, _classCallCheck2.default)(this, VideoBreakoutService);
    _this = _super.call(this, $http, EVENT, databaseService, $document, $compile, $rootScope, $eventBus, $location, navService, SETTINGS);
    _this.$compile = $compile;
    _this.SETTINGS = SETTINGS;
    _this.listeners = [];
    return _this;
  }
  (0, _createClass2.default)(VideoBreakoutService, [{
    key: "shouldAutoJoin",
    value: function shouldAutoJoin(nav) {
      var docType = nav.page_params.fp_type || nav.analytic_params.document_type;
      var settingName = "".concat(docType, "-video-call");
      if (this.SETTINGS.hasOwnProperty(settingName)) {
        return this.SETTINGS[settingName]['auto-join'];
      }
      return true;
    }
  }, {
    key: "attemptAutoStart",
    value: function attemptAutoStart(nav, meetingId) {
      if (this.shouldAutoJoin(nav)) {
        this.start(nav, meetingId);
      }
    }
  }, {
    key: "start",
    value: function start(nav, sessionId) {
      var _this2 = this;
      var docType = nav.page_params.fp_type || nav.analytic_params.document_type;
      var parentDocumentId = nav.page_params.model_id || nav.analytic_params.document_id;
      (0, _get2.default)((0, _getPrototypeOf2.default)(VideoBreakoutService.prototype), "start", this).call(this, {
        docType: docType,
        sessionId: sessionId,
        parentDocumentId: parentDocumentId
      });
      this.$eventBus.emit('join-call-button:hide');
      var ongoingListener = this.$eventBus.on('join-call-button:created', function (location) {
        if (_this2.originalLocation && location) {
          if (_this2.originalLocation === location) {
            _this2.$eventBus.emit('join-call-button:hide');
          } else {
            _this2.$eventBus.emit('join-call-button:show');
          }
        }
      });
      this.listeners.push(ongoingListener);
    }
  }]);
  return VideoBreakoutService;
}(_videoCallService.default);
angular.module('maestro.services').service('videoBreakoutService', VideoBreakoutService);

},{"./videoCallService":292,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/get":379,"@babel/runtime/helpers/getPrototypeOf":380,"@babel/runtime/helpers/inherits":381,"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/helpers/possibleConstructorReturn":387}],291:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MODERATOR_ACTIONS = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var MODERATOR_ACTIONS = {
  FORCE_MUTE: 'forceMute',
  UNMUTE: 'askUnmute',
  KICKOUT: 'kickout',
  PIN: 'pinSpeaker'
};
exports.MODERATOR_ACTIONS = MODERATOR_ACTIONS;
var VideoCallModeratorService = function () {
  VideoCallModeratorService.$inject = ["$eventBus"];
  /* @ngInject */
  function VideoCallModeratorService($eventBus) {
    (0, _classCallCheck2.default)(this, VideoCallModeratorService);
    this.$eventBus = $eventBus;
    this.listeners = [];
  }
  (0, _createClass2.default)(VideoCallModeratorService, [{
    key: "init",
    value: function init(session) {
      this.session = session;
      this.unregisterListeners();
      this.registerToSignalListeners();
    }
  }, {
    key: "unregisterListeners",
    value: function unregisterListeners() {
      var _iterator = _createForOfIteratorHelper(this.listeners),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var unsubscribe = _step.value;
          if ((0, _lodash.isFunction)(unsubscribe)) {
            unsubscribe();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.listeners = [];
    }
  }, {
    key: "registerToSignalListeners",
    value: function registerToSignalListeners() {
      var _this = this;
      var _loop = function _loop() {
        var action = MODERATOR_ACTIONS[key];
        var handler = function handler(event) {
          if (_this.session.connection && event.from.connectionId !== _this.session.connection.id) {
            console.log('[ModeratorService] got action ' + action, event.data);
            var data;
            if ((0, _lodash.isString)(event.data)) {
              data = JSON.parse(event.data);
            }
            _this.$eventBus.emit("moderatorRequest:".concat(action), data);
          }
        };
        _this.session.on("signal:".concat(action), handler);
        _this.listeners.push(function () {
          _this.session.off("signal:".concat(action), handler);
        });
      };
      for (var key in MODERATOR_ACTIONS) {
        _loop();
      }
    }
  }, {
    key: "sendAction",
    value: function sendAction(action, options) {
      console.log('[ModeratorService] send action', action, options);
      var payload = {
        type: action
      };
      if (options) {
        if (options.connection) {
          payload.to = options.connection;
        }
        if (options.data) {
          payload.data = JSON.stringify(options.data);
        }
      }
      this.session.signal(payload);
    }
  }]);
  return VideoCallModeratorService;
}();
angular.module('maestro.services').service('videoCallModeratorService', VideoCallModeratorService);

},{"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"lodash":"lodash"}],292:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _lodash = require("lodash");
var _videoPipService = _interopRequireDefault(require("./videoPipService"));
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = (0, _getPrototypeOf2.default)(t); if (r) { var s = (0, _getPrototypeOf2.default)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0, _possibleConstructorReturn2.default)(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var VideoCallService = function (_VideoPipService) {
  VideoCallService.$inject = ["$http", "EVENT", "databaseService", "$document", "$compile", "$rootScope", "$eventBus", "$location", "navService", "SETTINGS"];
  (0, _inherits2.default)(VideoCallService, _VideoPipService);
  var _super = _createSuper(VideoCallService);
  /* @ngInject */
  function VideoCallService($http, EVENT, databaseService, $document, $compile, $rootScope, $eventBus, $location, navService, SETTINGS) {
    var _this;
    (0, _classCallCheck2.default)(this, VideoCallService);
    _this = _super.call(this, $document, $eventBus, $location, $rootScope, $http, navService);
    _this.$http = $http;
    _this.eid = EVENT._id;
    _this.databaseService = databaseService;
    _this.$compile = $compile;
    _this.SETTINGS = SETTINGS;
    _this.listeners = [];
    return _this;
  }
  (0, _createClass2.default)(VideoCallService, [{
    key: "start",
    value: (function () {
      var _start = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee(_ref) {
        var _this2 = this;
        var docType, parentDocumentId, sessionId, conversationId, actions, videoChat, videoJoined, navChange, restart;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              docType = _ref.docType, parentDocumentId = _ref.parentDocumentId, sessionId = _ref.sessionId, conversationId = _ref.conversationId, actions = _ref.actions;
              if (!(this.currentSessionId === sessionId)) {
                _context.next = 4;
                break;
              }
              console.info('[VideoBreakoutService] Meeting already open');
              return _context.abrupt("return");
            case 4:
              if (!(0, _lodash.isEmpty)(this.currentSessionId)) {
                this.stop();
              }
              console.log('[VideoCallService] Opening video call with ID ', sessionId);
              this.videoScope = this.$rootScope.$new(true);
              if (!conversationId) {
                videoChat = this.$compile('<video-call-v2 />')(this.videoScope);
                this.currentSessionId = sessionId;
              } else {
                this.videoScope.sessionId = sessionId;
                this.videoScope.docType = docType;
                this.videoScope.parentDocumentId = parentDocumentId;
                this.videoScope.conversationId = conversationId;
                this.videoScope.actions = actions;
                this.currentSessionId = sessionId;
                videoChat = this.$compile('<video-call ' + 'session-id="sessionId" ' + 'doc-type="docType" ' + 'parent-document-id="parentDocumentId" ' + 'conversation-id="conversationId" ' + 'actions="actions" ' + '></video-call>')(this.videoScope);
              }
              videoJoined = this.$eventBus.on('video-call:joined', function () {
                return _this2.busy = true;
              });
              navChange = this.$eventBus.on('$navChange', function () {
                if (!_this2.busy) return _this2.stop();
              });
              restart = this.$eventBus.on('restartCall', function () {
                _this2.stop();
                _this2.start({
                  docType: docType,
                  parentDocumentId: parentDocumentId,
                  sessionId: sessionId,
                  conversationId: conversationId,
                  actions: actions
                });
              });
              this.listeners.push(videoJoined, navChange, restart);
              (0, _get2.default)((0, _getPrototypeOf2.default)(VideoCallService.prototype), "init", this).call(this, videoChat);
              this.pipWrapper.addClass('video-call');
              this.pipWrapper.addClass('fixed-size');
              if (conversationId) {
                this.pipWrapper.addClass('with-vonage');
              }
            case 16:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function start(_x) {
        return _start.apply(this, arguments);
      }
      return start;
    }())
  }, {
    key: "clearListeners",
    value: function clearListeners() {
      var _this$listeners;
      if (!((_this$listeners = this.listeners) !== null && _this$listeners !== void 0 && _this$listeners.length)) {
        return;
      }
      var _iterator = _createForOfIteratorHelper(this.listeners),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var unsub = _step.value;
          if ((0, _lodash.isFunction)(unsub)) unsub();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.listeners = [];
    }
  }, {
    key: "reset",
    value: function reset() {
      (0, _get2.default)((0, _getPrototypeOf2.default)(VideoCallService.prototype), "reset", this).call(this);
      this.clearListeners();
      this.busy = false;
      this.currentSessionId = null;
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this.videoScope) {
        this.videoScope.$destroy();
      }
      this.busy = false;
      this.currentSessionId = null;
      this.clearListeners();
      (0, _get2.default)((0, _getPrototypeOf2.default)(VideoCallService.prototype), "stop", this).call(this);
    }
  }, {
    key: "createSession",
    value: function createSession() {
      return this.$http.post("/api/v1/eid/".concat(this.eid, "/video-calls/start"), {}).then(function (_ref2) {
        var data = _ref2.data;
        return data.sessionId;
      });
    }
  }, {
    key: "getTokenAndApiKey",
    value: function getTokenAndApiKey(sessionId, parentDocumentId) {
      return this.$http.post("/api/v1/eid/".concat(this.eid, "/video-calls/token"), {
        sessionId: sessionId,
        parentDocumentId: parentDocumentId
      });
    }
  }, {
    key: "getModerators",
    value: (function () {
      var _getModerators = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee2(parentDocumentId) {
        var response;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.$http.get("/api/v1/eid/".concat(this.eid, "/video-calls/").concat(parentDocumentId, "/moderators"));
            case 2:
              response = _context2.sent;
              return _context2.abrupt("return", (0, _lodash.get)(response, 'data.moderators', []));
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getModerators(_x2) {
        return _getModerators.apply(this, arguments);
      }
      return getModerators;
    }())
  }, {
    key: "savePinnedParticipants",
    value: (function () {
      var _savePinnedParticipants = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee3(videoCallDocId, list) {
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.postWithRetries("/api/v1/eid/".concat(this.eid, "/video-calls/pinned-participants"), {
                videoCallDocId: videoCallDocId,
                list: list
              }, 3);
            case 2:
              return _context3.abrupt("return", _context3.sent);
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function savePinnedParticipants(_x3, _x4) {
        return _savePinnedParticipants.apply(this, arguments);
      }
      return savePinnedParticipants;
    }())
  }, {
    key: "addSessionIdToConversation",
    value: function addSessionIdToConversation(conversation_id, session_id) {
      return this.databaseService.runAppScript('chats/add-session-id', {
        conversation_id: conversation_id,
        session_id: session_id
      });
    }
  }, {
    key: "getConversation",
    value: function getConversation(conversation_id) {
      return this.databaseService.runAppScript('chats/get-conversation', {
        conversation_id: conversation_id
      }).then(function (_ref3) {
        var data = _ref3.data;
        return data.response;
      });
    }
  }]);
  return VideoCallService;
}(_videoPipService.default);
exports.default = VideoCallService;
angular.module('maestro.services').service('videoCallService', VideoCallService);

},{"./videoPipService":293,"@babel/runtime/helpers/asyncToGenerator":375,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/get":379,"@babel/runtime/helpers/getPrototypeOf":380,"@babel/runtime/helpers/inherits":381,"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/helpers/possibleConstructorReturn":387,"@babel/runtime/regenerator":398,"lodash":"lodash"}],293:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _lodash = require("lodash");
var _baseService = require("./baseService");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = (0, _getPrototypeOf2.default)(t); if (r) { var s = (0, _getPrototypeOf2.default)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0, _possibleConstructorReturn2.default)(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var FRAME_MARGINS = 15;
var VideoPipService = function (_BaseService) {
  VideoPipService.$inject = ["$document", "$eventBus", "$location", "$rootScope", "$http", "navService"];
  (0, _inherits2.default)(VideoPipService, _BaseService);
  var _super = _createSuper(VideoPipService);
  /* @ngInject */
  function VideoPipService($document, $eventBus, $location, $rootScope, $http, navService) {
    var _this;
    (0, _classCallCheck2.default)(this, VideoPipService);
    _this = _super.call(this, $http);
    _this.$eventBus = $eventBus;
    _this.$location = $location;
    _this.$rootScope = $rootScope;
    _this.navService = navService;
    _this.$document = $document;
    _this.pipListeners = [];
    _this.videoElement = null;
    _this.windowResizeListener = function () {
      if (!_this.videoElement) {
        return;
      }
      var x = parseInt(_this.videoElement.css('left'), 10) || window.innerWidth;
      var y = parseInt(_this.videoElement.css('top'), 10) || window.innerHeight;
      _this.setPosition(x, y);
      _this.snapToSide();
    };
    _this.reset();
    return _this;
  }
  (0, _createClass2.default)(VideoPipService, [{
    key: "init",
    value: function init(videoElement) {
      var _this2 = this;
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        scope = _ref.scope,
        width = _ref.width,
        height = _ref.height;
      this.$eventBus.emit('video-pip:close');
      this.pipWrapper = this.$document.find('#pip-wrapper');
      this.show();
      this.originalNav = this.navService.getActiveNav();
      this.originalLocation = this.$location.url();
      this.videoElement = videoElement;
      this.videoElementScope = scope;
      this.pipWrapper.append(videoElement);
      window.scrollTo(0, 0);
      width = Number.parseInt(width) || 320;
      height = Number.parseInt(height) || 180;
      this.pipSize = {
        width: width,
        height: height
      };
      var navChange = this.$eventBus.on('$navChange', function (nav) {
        if (_this2.shouldFloat(nav)) {
          _this2.float();
        }
      });
      var locationChange = this.$rootScope.$on('$locationChangeSuccess', function () {
        if (_this2.$location.url() === _this2.originalLocation) {
          _this2.embed();
        }
      });
      var videoReopen = this.$eventBus.on('video-pip:reopen-nav', function (id) {
        if ((0, _lodash.isObject)(_this2.originalNav)) {
          _this2.navService.openNav(_this2.originalNav);
        } else if (_this2.originalLocation && (!id || _this2.originalLocation.includes(id))) {
          _this2.$location.url(_this2.originalLocation);
        } else {
          _this2.embed();
        }
      });
      var videoClose = this.$eventBus.on('video-pip:close', function () {
        return _this2.stop();
      });
      this.pipListeners.push(videoClose, navChange, videoReopen, locationChange);
      this.videoElement.off('mousedown');
      this.videoElement.on('mousedown', function (e) {
        if (!_this2.videoElement.is('.pinned') || _this2.videoElement.is('.maximized')) return;
        if (e.target.tagName === 'INPUT' || e.target.tagName === 'BUTTON') return;
        e.preventDefault();
        _this2.startX = e.clientX - _this2.videoElement[0].offsetLeft;
        _this2.startY = e.clientY - _this2.videoElement[0].offsetTop;
        _this2.$document.on('mousemove.pip', function (ev) {
          return _this2.onMouseMove(ev);
        });
        _this2.$document.on('mouseup.pip', function (ev) {
          return _this2.onMouseUp(ev);
        });
      });
      this.started = true;
      this.isFloating = false;
      this.$eventBus.emit('video-pip:started');
    }
  }, {
    key: "reset",
    value: function reset() {
      this.originalNav = null;
      this.originalLocation = null;
      if (this.videoElement) {
        this.onMouseUp();
        this.videoElement.remove();
      }
      this.videoElement = null;
      this.isFloating = false;
      var _iterator = _createForOfIteratorHelper(this.pipListeners),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var unsub = _step.value;
          if ((0, _lodash.isFunction)(unsub)) unsub();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.pipListeners = [];
      window.removeEventListener('resize', this.windowResizeListener);
      if (this.pipWrapper) {
        this.pipWrapper.innerHTML = '';
        this.pipWrapper.removeClass();
      }
      this.pipWrapper = null;
    }
  }, {
    key: "stop",
    value: function stop() {
      this.embed();
      this.reset();
    }
  }, {
    key: "isDifferentLocation",
    value: function isDifferentLocation() {
      return this.$location.url() !== this.originalLocation;
    }
  }, {
    key: "shouldFloat",
    value: function shouldFloat() {
      var nav = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.navService.getActiveNav();
      if (!this.videoElement) {
        return true;
      }
      var isNotModal = !nav.modal && !nav.fullscreen;
      var isDifferentLocation = this.isDifferentLocation();
      var shouldFloat = isNotModal && isDifferentLocation;
      console.log('[videoPipService] shouldFloat ?', shouldFloat, {
        isNotModal: isNotModal,
        isDifferentLocation: isDifferentLocation
      });
      return shouldFloat;
    }
  }, {
    key: "embed",
    value: function embed() {
      this.isFloating = false;
      if (this.videoElementScope) {
        this.videoElementScope.$broadcast('video-pip:embed');
      }
      if (this.pipWrapper) {
        this.pipWrapper.removeClass('detached');
      }
      if (this.videoElement) {
        this.videoElement.removeClass('pinned');
        this.videoElement.removeAttr('style');
      }
      window.removeEventListener('resize', this.windowResizeListener);
    }
  }, {
    key: "float",
    value: function float() {
      if (!this.pipWrapper) {
        return;
      }
      this.isFloating = true;
      if (this.videoElementScope) {
        this.videoElementScope.$broadcast('video-pip:float');
      }
      this.pipWrapper.addClass('detached');
      this.videoElement.addClass('pinned');
      this.setPosition(window.outerWidth, window.outerHeight);
      this.snapToSide();
      window.addEventListener('resize', this.windowResizeListener);
    }
  }, {
    key: "hide",
    value: function hide() {
      this.pipWrapper.addClass('hidden');
    }
  }, {
    key: "show",
    value: function show() {
      this.pipWrapper.removeClass('hidden');
    }
  }, {
    key: "addPipClass",
    value: function addPipClass(c) {
      if (this.pipWrapper) {
        this.pipWrapper.addClass(c);
      }
    }
  }, {
    key: "removePipClass",
    value: function removePipClass(c) {
      if (this.pipWrapper) {
        this.pipWrapper.removeClass(c);
      }
    }
  }, {
    key: "onMouseMove",
    value: function onMouseMove(e) {
      var x = e.clientX - this.startX;
      var y = e.clientY - this.startY;
      this.videoElement.addClass('dragging');
      this.setPosition(x, y);
    }
  }, {
    key: "onMouseUp",
    value: function onMouseUp() {
      this.$document.off('mousemove.pip');
      this.$document.off('mouseup.pip');
      this.videoElement.removeClass('dragging');
      this.snapToSide();
    }
  }, {
    key: "setPosition",
    value: function setPosition(x, y) {
      var _this3 = this;
      if (!this.videoElement || !this.isFloating) {
        return;
      }
      var width = this.pipSize.width;
      var height = this.pipSize.height;
      if (!this.controlsHeight) {
        this.controlsHeight = this.videoElement.find('.controls').height() || 0;
      }
      height = height + this.controlsHeight;
      requestAnimationFrame(function () {
        if (!_this3.videoElement) {
          return;
        }
        if (width && height) {
          _this3.videoElement.css({
            width: width,
            height: height
          });
        }
        x = Math.max(FRAME_MARGINS, Math.min(window.innerWidth - FRAME_MARGINS - width, x));
        y = Math.max(FRAME_MARGINS + _this3.controlsHeight, Math.min(window.innerHeight - FRAME_MARGINS - height, y));
        _this3.videoElement.css({
          top: y + 'px',
          left: x + 'px'
        });
      });
    }
  }, {
    key: "snapToSide",
    value: function snapToSide() {
      var _this4 = this;
      requestAnimationFrame(function () {
        if (!_this4.videoElement || !_this4.isFloating) {
          return;
        }
        var x = _this4.videoElement[0].offsetLeft + _this4.pipSize.width / 2;
        var w = window.innerWidth;
        var side = x > w / 2 ? 'right' : 'left';
        var newX = side === 'right' ? w - FRAME_MARGINS - _this4.pipSize.width : FRAME_MARGINS;
        if (newX < FRAME_MARGINS) {
          newX = FRAME_MARGINS;
        }
        _this4.videoElement.css({
          left: newX
        });
      });
    }
  }]);
  return VideoPipService;
}(_baseService.BaseService);
exports.default = VideoPipService;

},{"./baseService":244,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/getPrototypeOf":380,"@babel/runtime/helpers/inherits":381,"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/helpers/possibleConstructorReturn":387,"lodash":"lodash"}],294:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _lodash = require("lodash");
var _baseService = require("./baseService");
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = (0, _getPrototypeOf2.default)(t); if (r) { var s = (0, _getPrototypeOf2.default)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0, _possibleConstructorReturn2.default)(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var VideoPlayerService = function (_BaseService) {
  VideoPlayerService.$inject = ["$http", "EID", "PID"];
  (0, _inherits2.default)(VideoPlayerService, _BaseService);
  var _super = _createSuper(VideoPlayerService);
  /* @ngInject */
  function VideoPlayerService($http, EID, PID) {
    var _this;
    (0, _classCallCheck2.default)(this, VideoPlayerService);
    _this = _super.call(this, $http);
    _this.$http = $http;
    _this.eventId = EID;
    _this.pid = PID;
    _this.errorBuffer = [];
    _this.lastAddedError = null;
    var jitter = 3000 + Math.round(Math.random() * 3000);
    var sendErrorBuffer = function () {
      var _ref = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee() {
        var url;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!_this.errorBuffer || _this.errorBuffer.length === 0)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              url = "/api/v1/eid/".concat(_this.eventId, "/live-stream/log-pax-issues");
              _this.postWithRetries(url, {
                errorArray: (0, _lodash.cloneDeep)(_this.errorBuffer),
                pid: _this.pid
              }, 2, 1000);
              _this.errorBuffer = [];
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function sendErrorBuffer() {
        return _ref.apply(this, arguments);
      };
    }();
    _this._sendErrorBuffer = (0, _lodash.throttle)(sendErrorBuffer, jitter, {
      leading: false,
      trailing: true
    });
    return _this;
  }
  (0, _createClass2.default)(VideoPlayerService, [{
    key: "trackError",
    value: function trackError(payload) {
      if ((0, _lodash.isEmpty)(payload) || (0, _lodash.isEqual)(payload, this.lastAddedError)) {
        return;
      }
      this.lastAddedError = payload;
      this.errorBuffer.push(payload);
      this._sendErrorBuffer();
    }
  }, {
    key: "getCookies",
    value: (function () {
      var _getCookies = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee2(url) {
        var response, fileUrl;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(!url || !(0, _lodash.isString)(url))) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return", url);
            case 2:
              if (url.includes("".concat(this.eventId, "/webapp/signed-asset"))) {
                _context2.next = 4;
                break;
              }
              return _context2.abrupt("return", url);
            case 4:
              _context2.next = 6;
              return this.$http.get(url, {
                withCredentials: true,
                cache: false,
                params: {
                  skipRedirect: true
                }
              }).catch(function (err) {
                return console.error('[VideoPlayerService] webapp/signed-asset error', err);
              });
            case 6:
              response = _context2.sent;
              if (!(!response || !response.data || !response.data.fileUrl)) {
                _context2.next = 10;
                break;
              }
              console.error('[VideoPlayerService] failed to get fileUrl', {
                url: url,
                response: response
              });
              return _context2.abrupt("return", url);
            case 10:
              fileUrl = response.data.fileUrl;
              console.log('[VideoPlayerService] getCookies response ', {
                fileUrl: fileUrl
              });
              return _context2.abrupt("return", fileUrl);
            case 13:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getCookies(_x) {
        return _getCookies.apply(this, arguments);
      }
      return getCookies;
    }())
  }]);
  return VideoPlayerService;
}(_baseService.BaseService);
exports.default = VideoPlayerService;

},{"./baseService":244,"@babel/runtime/helpers/asyncToGenerator":375,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/getPrototypeOf":380,"@babel/runtime/helpers/inherits":381,"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/helpers/possibleConstructorReturn":387,"@babel/runtime/regenerator":398,"lodash":"lodash"}],295:[function(require,module,exports){
"use strict";

VisibilityService.$inject = ["$eventBus"];
/* @ngInject */
function VisibilityService($eventBus) {
  var eventEmitter = $eventBus.spawn();
  var hidden = 'hidden';
  if (hidden in document) {
    document.addEventListener('visibilitychange', onchange);
  } else if ((hidden = 'mozHidden') in document) {
    document.addEventListener('mozvisibilitychange', onchange);
  } else if ((hidden = 'webkitHidden') in document) {
    document.addEventListener('webkitvisibilitychange', onchange);
  } else if ((hidden = 'msHidden') in document) {
    document.addEventListener('msvisibilitychange', onchange);
  } else if ('onfocusin' in document) {
    document.onfocusin = document.onfocusout = onchange;
  } else {
    window.onpageshow = window.onpagehide = window.onfocus = window.onblur = onchange;
  }
  function onchange(evt) {
    var v = 'visible',
      h = 'hidden',
      evtMap = {
        focus: v,
        focusin: v,
        pageshow: v,
        blur: h,
        focusout: h,
        pagehide: h
      };
    evt = evt || window.event;
    if (evt.type in evtMap) {
      eventEmitter.emit(evtMap[evt.type]);
    } else {
      eventEmitter.emit(this[hidden] ? 'hidden' : 'visible');
    }
  }
  if (document[hidden] !== undefined) onchange({
    type: document[hidden] ? 'blur' : 'focus'
  });
  return eventEmitter;
}
angular.module('maestro.services').service('visibilityService', VisibilityService);

},{}],296:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
var _baseService = require("./baseService");
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = (0, _getPrototypeOf2.default)(t); if (r) { var s = (0, _getPrototypeOf2.default)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0, _possibleConstructorReturn2.default)(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var LocalWebsocketMetricsStorage = function () {
  function LocalWebsocketMetricsStorage() {
    (0, _classCallCheck2.default)(this, LocalWebsocketMetricsStorage);
  }
  (0, _createClass2.default)(LocalWebsocketMetricsStorage, [{
    key: "getPreviousAppUptimeMs",
    value: function getPreviousAppUptimeMs() {
      var previous = this._get('app-uptime-ms');
      return previous || 0;
    }
  }, {
    key: "setPreviousAppUptimeMs",
    value: function setPreviousAppUptimeMs(value) {
      this._set('app-uptime-ms', value);
    }
  }, {
    key: "getPreviousWsUptimeMs",
    value: function getPreviousWsUptimeMs() {
      var previous = this._get('ws-uptime-ms');
      return previous || 0;
    }
  }, {
    key: "setPreviousWsUptimeMs",
    value: function setPreviousWsUptimeMs(value) {
      this._set('ws-uptime-ms', value);
    }
  }, {
    key: "_get",
    value: function _get(metricName) {
      var stored = localStorage.getItem(metricName);
      return Number.parseInt(stored);
    }
  }, {
    key: "_set",
    value: function _set(metricName, value) {
      localStorage.setItem(metricName, value);
    }
  }]);
  return LocalWebsocketMetricsStorage;
}();
var WebsocketConnectionReportingService = function (_BaseService) {
  WebsocketConnectionReportingService.$inject = ["EID", "$http", "PID", "EVENT", "signalService"];
  (0, _inherits2.default)(WebsocketConnectionReportingService, _BaseService);
  var _super = _createSuper(WebsocketConnectionReportingService);
  /** @ngInject */
  function WebsocketConnectionReportingService(EID, $http, PID, EVENT, signalService) {
    var _this;
    var websocketMetricsStorage = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : new LocalWebsocketMetricsStorage();
    (0, _classCallCheck2.default)(this, WebsocketConnectionReportingService);
    _this = _super.call(this, $http);
    _this._pid = PID;
    _this._signalProvider = signalService;
    _this._eventId = EID;
    _this._org = EVENT.orgName;
    _this._metricsStorage = websocketMetricsStorage;
    _this._unsubscribers = [];
    _this._applicationUptimePeriodTimestampMs = Date.now();
    _this._isConnected = false;
    return _this;
  }
  (0, _createClass2.default)(WebsocketConnectionReportingService, [{
    key: "init",
    value: function init() {
      this._subscribeToWebsocketEvents();
      this._schedulePeriodicUptimeReporting();
      if (this._signalProvider.isConnected) {
        this._handleConnectionEstablishment();
      }
    }
  }, {
    key: "setLiveStreamId",
    value: function setLiveStreamId(value) {
      this._liveStreamId = value;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this._unsubscribeFromWebsocketEvents();
      clearInterval(this._reportTimeoutId);
    }
  }, {
    key: "_subscribeToWebsocketEvents",
    value: function _subscribeToWebsocketEvents() {
      var _this2 = this;
      this._signalProvider.addEventListener('open', function () {
        _this2._handleConnectionEstablishment();
      });
      ['close', 'timeout', 'onInitError', 'end'].forEach(function (connectionErrorType) {
        var handler = function handler(_ref) {
          var type = _ref.type,
            error = _ref.error;
          return _this2._handleConnectionEnd(type, error);
        };
        var unsub = _this2._signalProvider.addEventListener(connectionErrorType, handler);
        _this2._unsubscribers.push(unsub);
      });
    }
  }, {
    key: "_unsubscribeFromWebsocketEvents",
    value: function _unsubscribeFromWebsocketEvents() {
      this._unsubscribers.forEach(function (unsub) {
        if ((0, _lodash.isFunction)(unsub)) {
          unsub();
        }
      });
      this._unsubscribers = [];
    }
  }, {
    key: "_schedulePeriodicUptimeReporting",
    value: function _schedulePeriodicUptimeReporting() {
      var _this3 = this;
      var periodMs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 60 * 1000;
      this._reportTimeoutId = setTimeout((0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this3._reportUptime();
            case 2:
              _this3._schedulePeriodicUptimeReporting(periodMs);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })), periodMs);
    }
  }, {
    key: "_handleConnectionEstablishment",
    value: function _handleConnectionEstablishment() {
      if (this._isConnected) {
        return;
      }
      this._isConnected = true;
      this._websocketUptimePeriodStartTimestampMs = Date.now();
      this._sendReport('connection-established');
    }
  }, {
    key: "_handleConnectionEnd",
    value: function _handleConnectionEnd(reason, error) {
      this._isConnected = false;
      this._websocketUptimePeriodEndTimestampMs = Date.now();
      this._sendReport('connection-failed', {
        reason: reason,
        error: error
      });
    }
  }, {
    key: "_reportUptime",
    value: function () {
      var _reportUptime2 = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee2() {
        var _this$_buildUptimes, appUptimeMs, wsUptimeMs;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this$_buildUptimes = this._buildUptimes(), appUptimeMs = _this$_buildUptimes.appUptimeMs, wsUptimeMs = _this$_buildUptimes.wsUptimeMs;
              this._saveUptimes(appUptimeMs, wsUptimeMs);
              _context2.next = 4;
              return this._sendReport('uptime', {
                appUptimeMs: appUptimeMs,
                wsUptimeMs: wsUptimeMs
              });
            case 4:
              this._applicationUptimePeriodTimestampMs = Date.now();
              this._websocketUptimePeriodStartTimestampMs = Date.now();
              this._websocketUptimePeriodEndTimestampMs = undefined;
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function _reportUptime() {
        return _reportUptime2.apply(this, arguments);
      }
      return _reportUptime;
    }()
  }, {
    key: "_buildUptimes",
    value: function _buildUptimes() {
      var previousAppUptimeMs = this._metricsStorage.getPreviousAppUptimeMs();
      var appUptimeMsInPeriod = Date.now() - this._applicationUptimePeriodTimestampMs;
      var appUptimeMs = previousAppUptimeMs + appUptimeMsInPeriod;
      var previousWsUptimeMs = this._metricsStorage.getPreviousWsUptimeMs();
      var wsConnectedInPeriod = this._websocketUptimePeriodStartTimestampMs !== undefined;
      var wsUptimePeriodEndTimestampMs = this._websocketUptimePeriodEndTimestampMs === undefined ? Date.now() : this._websocketUptimePeriodEndTimestampMs;
      var wsUptimeMsInPeriod = wsConnectedInPeriod ? wsUptimePeriodEndTimestampMs - this._websocketUptimePeriodStartTimestampMs : 0;
      var wsUptimeMs = previousWsUptimeMs + wsUptimeMsInPeriod;
      return {
        appUptimeMs: appUptimeMs,
        wsUptimeMs: wsUptimeMs
      };
    }
  }, {
    key: "_saveUptimes",
    value: function _saveUptimes(appUptimeMs, wsUptimeMs) {
      this._metricsStorage.setPreviousAppUptimeMs(appUptimeMs);
      this._metricsStorage.setPreviousWsUptimeMs(wsUptimeMs);
    }
  }, {
    key: "_sendReport",
    value: function () {
      var _sendReport2 = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee3(action, payload) {
        var context, url;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              context = {
                userId: this._pid,
                org: this._org,
                liveStreamId: this._liveStreamId
              };
              url = "/api/v1/eid/".concat(this._eventId, "/log/websocket-connection-metrics");
              _context3.prev = 2;
              _context3.next = 5;
              return this.postWithRetries(url, {
                action: action,
                context: context,
                payload: payload
              }, 0);
            case 5:
              _context3.next = 10;
              break;
            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3["catch"](2);
              console.error('[WebsocketConnectionReporting] Failed to send report', _context3.t0);
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[2, 7]]);
      }));
      function _sendReport(_x, _x2) {
        return _sendReport2.apply(this, arguments);
      }
      return _sendReport;
    }()
  }]);
  return WebsocketConnectionReportingService;
}(_baseService.BaseService);
exports.default = WebsocketConnectionReportingService;

},{"./baseService":244,"@babel/runtime/helpers/asyncToGenerator":375,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/getPrototypeOf":380,"@babel/runtime/helpers/inherits":381,"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/helpers/possibleConstructorReturn":387,"@babel/runtime/regenerator":398,"lodash":"lodash"}],297:[function(require,module,exports){
module.exports = '<action-btn-block parent-nav-id="::$ctrl.config.nuid" config="::block"></action-btn-block>';
},{}],298:[function(require,module,exports){
module.exports = '<div class="panel panel-default" ng-if="::block.ds.length"><slick ng-if="::block.ds.length &gt; 1" infinite="false" autoplay-speed="{{::block.config.autosliding_interval * 1000}}" autoplay="{{::block.config.autosliding_interval &gt; 0}}" dots="{{::(block.ds.length &gt; 1)}}" arrows="false"><div class="block" ng-repeat="banner in ::block.ds"><div class="layer" theme="::banner.ds.theme"><div class="title" ng-if="::banner.content.title" ng-bind="::banner.content.title" theme-selector="title"></div><div class="image" background-asset-src="{{::banner.ds.content.image_uri}}" draggable="false" theme-selector="image_view"></div></div></div></slick><div class="block" ng-if="::block.ds.length == 1" ng-repeat="banner in ::block.ds"><div class="layer" theme="::banner.ds.theme"><div class="title" ng-if="::banner.content.title" ng-bind="::banner.content.title" theme-selector="title"></div><div class="image" background-asset-src="{{::banner.ds.content.image_uri}}" draggable="false" theme-selector="image_view"></div></div></div></div>';
},{}],299:[function(require,module,exports){
module.exports = '<card config="block"></card>';
},{}],300:[function(require,module,exports){
module.exports = '<upload-block parent-nav-id="::$ctrl.config.nuid" config="::block" accept="&quot;image/jpeg,image/jpg,image/png,image/gif,video/mp4&quot;" max-size="10000000"></upload-block>';
},{}],301:[function(require,module,exports){
module.exports = '<select-block parent-nav-id="::$ctrl.config.nuid" config="::block"></select-block>';
},{}],302:[function(require,module,exports){
module.exports = '<edit-text-block parent-nav-id="::$ctrl.config.nuid" config="::block"></edit-text-block>';
},{}],303:[function(require,module,exports){
module.exports = '<empty-state config="block"></empty-state>';
},{}],304:[function(require,module,exports){
module.exports = '<feed-comment-block config="block" on-update="$ctrl.updateBlock($event)"></feed-comment-block>';
},{}],305:[function(require,module,exports){
module.exports = '<feed-new-post-block config="block" parent-nav-id="::$ctrl.config.nuid"></feed-new-post-block>';
},{}],306:[function(require,module,exports){
module.exports = '<feed-topic-block config="block" on-update="$ctrl.updateBlock($event)"></feed-topic-block>';
},{}],307:[function(require,module,exports){
module.exports = '<div class="panel panel-default" theme="::block.ds.theme" ng-click="$ctrl.performActions(block.actions)" ng-class="::({&quot;panel-active&quot;: block.actions &amp;&amp; block.actions.length &gt; 0})"><div class="panel-heading" ng-bind="::block.ds.content.title" ng-if="::block.ds.content.title" theme-selector="title"></div><div class="image" background-asset-src="{{::block.ds.content.image_uri}}" title="{{::block.ds.content.title}}" draggable="false" theme-selector="image_view"></div></div>';
},{}],308:[function(require,module,exports){
module.exports = '<div class="panel panel-default" theme="::block.ds.source.theme"><div class="panel-heading"><div class="action pull-right" ng-if="::block.content.right_button" ng-bind="::block.content.right_button" ng-click="$ctrl.performActions(block.actions)" ng-class="::({&quot;panel-active&quot;: block.actions &amp;&amp; block.actions.length &gt; 0})"></div><div class="title" ng-bind="::block.content.title"></div></div><ul class="list-group"><li class="list-group-item" ng-repeat="item in ::block.ds" ng-click="$ctrl.performActions(item.ds.actions)" ng-class="::({first: $first, last:$last, disabled:!item.ds.actions.length})" theme="::item.ds.theme"><div class="nav-list-item-title" ng-bind="::item.ds.content.title"></div><div class="nav-list-item-subtitle" ng-bind="::item.ds.content.subtitle"></div></li></ul></div>';
},{}],309:[function(require,module,exports){
module.exports = '<list-header config="block"></list-header>';
},{}],310:[function(require,module,exports){
module.exports = '<meeting-block config="block"></meeting-block>';
},{}],311:[function(require,module,exports){
module.exports = '<slick ng-if="::(block.ds.length &gt; 1)" infinite="false" autoplay-speed="{{::block.config.autosliding_interval * 1000}}" autoplay="{{::block.config.autosliding_interval &gt; 0}}" dots="{{::!block.theme.page_control.hidden}}" arrows="false"><div class="block {{::block.block_type}}" ng-repeat="block in ::block.ds" ng-include="::($ctrl.navTemplates[block.block_type])"></div></slick><div class="slider-container" ng-if="::(block.ds.length === 1)"><div ng-init="block = block.ds[0]"><div class="block {{::block.block_type}}" ng-include="::($ctrl.navTemplates[block.block_type])"></div></div></div>';
},{}],312:[function(require,module,exports){
module.exports = '<div class="panel panel-default" theme="::block.ds.theme" ng-class="::({&quot;with-title&quot;: block.ds.content.title, &quot;panel-active&quot;: block.actions &amp;&amp; block.actions.length &gt; 0})" ng-click="performActions ? performActions(block.actions) : $ctrl.performActions(block.actions)"><div class="panel-body" ng-if="block.ds.content.left_image_uri || block.ds.content.title || block.ds.content.subtitle || block.ds.content.body || block.ds.content.right_image_uri"><div class="media"><div class="media-left" ng-if="::block.ds.content.left_image_uri"><img class="media-object" asset-src="{{::block.ds.content.left_image_uri}}"/></div><div class="media-body"><div class="panel-heading" theme-selector="title" ng-bind-html="::block.ds.content.title"></div><p ng-if="::block.ds.content.subtitle" ng-bind="::block.ds.content.subtitle" theme-selector="subtitle"></p><p ng-if="::block.ds.content.body" ng-bind="::block.ds.content.body" theme-selector="body"></p></div><div class="media-right" ng-if="::block.ds.content.right_image_uri"><img class="media-object" asset-src="{{::block.ds.content.right_image_uri}}"/></div></div></div></div>';
},{}],313:[function(require,module,exports){
module.exports = '<toggle-block parent-nav-id="::$ctrl.config.nuid" config="::block"></toggle-block>';
},{}],314:[function(require,module,exports){
module.exports = '<div class="panel panel-default aspect-{{::block.theme.image.scale_mode}}" style="background-color: {{::block.theme.image.background}}" background-asset-src="{{::block.content.image_uri}}" ng-click="$ctrl.performActions(block.actions)" ng-class="::({&quot;panel-active&quot;: block.actions &amp;&amp; block.actions.length &gt; 0})"><div class="panel-heading align-{{::block.theme.title.halign}} align-{{::block.theme.title.valign}}" style="color: {{::block.theme.title.color}}; background-color: {{::block.theme.title.background}}"><div class="title">{{::block.content.title}}</div></div></div>';
},{}],315:[function(require,module,exports){
module.exports = '<div class="panel panel-default"><div class="panel-heading" ng-if="::block.content.title"><div class="action pull-right" ng-if="::block.content.action_text" ng-bind-html="::block.content.action_text" ng-click="$ctrl.performActions(block.actions)" ng-class="::({&quot;panel-active&quot;: block.actions &amp;&amp; block.actions.length &gt; 0})"></div><div class="title" ng-bind-html="::block.content.title"></div></div><div class="panel-body" ng-if="::block.content.body" ng-bind-html="::block.content.body"></div><ul class="list-group"><div class="list-group-item" ng-repeat="item in ::block.content.items track by item.id" ng-click="$ctrl.performActions(item.actions)" ng-class="{first: $first, last: $last}" ng-style="::{&quot;border-left-color&quot;: item.theme.side_tag.background_color}"><div class="media"><div class="media-left" ng-if="::item.content.left_image"><img ng-src="::item.content.left_image | assetUrl"/></div><div class="media-body"><div class="nav-list-item-title" ng-bind-html="::item.content.title"></div><div class="nav-list-item-subtitle" ng-bind-html="::item.content.subtitle"></div><div class="nav-list-item-subsubtitle" ng-bind-html="::item.content.body"></div></div><div class="media-right" ng-if="::item.content.right_image"><img ng-src="::item.content.right_image | assetUrl"/></div></div></div></ul></div>';
},{}],316:[function(require,module,exports){
module.exports = '<div class="panel panel-default"><div class="panel-heading" ng-if="::block.content.title"><div class="action pull-right" ng-if="::block.content.action_text" ng-bind-html="::block.content.action_text" ng-click="$ctrl.performActions(block.actions)" ng-class="::({&quot;panel-active&quot;: block.actions &amp;&amp; block.actions.length &gt; 0})"></div><div class="title" ng-bind-html="::block.content.title"></div></div><div class="panel-body" ng-if="::block.content.body" ng-bind-html="::block.content.body"></div></div>';
},{}],317:[function(require,module,exports){
module.exports = '<div class="zoom"><img src="{{::image | assetUrl}}" alt=""/></div>';
},{}],318:[function(require,module,exports){
"use strict";

var _lodash = require("lodash");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var TEMPLATE_API_PREFIX = '/api/v1/nav-template';
var NAVS = {
  './navs/agenda.jade': require('./navs/agenda.jade'),
  './navs/appscript_launcher.jade': require('./navs/appscript_launcher.jade'),
  './navs/blocks.jade': require('./navs/blocks.jade'),
  './navs/blocks_list.jade': require('./navs/blocks_list.jade'),
  './navs/calendar_services_sheet.jade': require('./navs/calendar_services_sheet.jade'),
  './navs/conversation.jade': require('./navs/conversation.jade'),
  './navs/document.jade': require('./navs/document.jade'),
  './navs/document_note.jade': require('./navs/document_note.jade'),
  './navs/fstg.jade': require('./navs/fstg.jade'),
  './navs/home.jade': require('./navs/home.jade'),
  './navs/list.jade': require('./navs/list.jade'),
  './navs/media.jade': require('./navs/media.jade'),
  './navs/new_meeting.jade': require('./navs/new_meeting.jade'),
  './navs/new_message.pug': require('./navs/new_message.pug'),
  './navs/note.jade': require('./navs/note.jade'),
  './navs/qr_sheet.jade': require('./navs/qr_sheet.jade'),
  './navs/scan.jade': require('./navs/scan.jade'),
  './navs/sheet.jade': require('./navs/sheet.jade'),
  './navs/spotman.jade': require('./navs/spotman.jade')
};
var ROWS = {
  './rows/agenda_master_row.jade': require('./rows/agenda_master_row.jade'),
  './rows/agenda_regular_row.jade': require('./rows/agenda_regular_row.jade'),
  './rows/conversation_row.jade': require('./rows/conversation_row.jade'),
  './rows/conversationmessage_row.jade': require('./rows/conversationmessage_row.jade'),
  './rows/list_row.jade': require('./rows/list_row.jade'),
  './rows/person_row.pug': require('./rows/person_row.pug'),
  './rows/profile_row.jade': require('./rows/profile_row.jade'),
  './rows/separator_row.jade': require('./rows/separator_row.jade'),
  './rows/spotman_row.jade': require('./rows/spotman_row.jade'),
  './rows/text_row.jade': require('./rows/text_row.jade'),
  './rows/universal_search_row.jade': require('./rows/universal_search_row.jade')
};
var BLOCKS = {
  './blocks/block_action_btn.jade': require('./blocks/block_action_btn.jade'),
  './blocks/block_banner.jade': require('./blocks/block_banner.jade'),
  './blocks/block_card.jade': require('./blocks/block_card.jade'),
  './blocks/block_common_attach_image_preview.jade': require('./blocks/block_common_attach_image_preview.jade'),
  './blocks/block_common_edit_select.pug': require('./blocks/block_common_edit_select.pug'),
  './blocks/block_common_edit_text.jade': require('./blocks/block_common_edit_text.jade'),
  './blocks/block_empty_state.jade': require('./blocks/block_empty_state.jade'),
  './blocks/block_feed_comment.jade': require('./blocks/block_feed_comment.jade'),
  './blocks/block_feed_topic.jade': require('./blocks/block_feed_topic.jade'),
  './blocks/block_feed_new_post.jade': require('./blocks/block_feed_new_post.jade'),
  './blocks/block_image.jade': require('./blocks/block_image.jade'),
  './blocks/block_list.jade': require('./blocks/block_list.jade'),
  './blocks/block_list_header.jade': require('./blocks/block_list_header.jade'),
  './blocks/block_meeting.pug': require('./blocks/block_meeting.pug'),
  './blocks/block_slider.jade': require('./blocks/block_slider.jade'),
  './blocks/block_text.jade': require('./blocks/block_text.jade'),
  './blocks/block_toggle.jade': require('./blocks/block_toggle.jade'),
  './blocks/image_block.jade': require('./blocks/image_block.jade'),
  './blocks/list_block.jade': require('./blocks/list_block.jade'),
  './blocks/text_block.jade': require('./blocks/text_block.jade'),
  './blocks/zoom.pug': require('./blocks/zoom.pug')
};
var TEMPLATES = Object.assign({}, NAVS, ROWS, BLOCKS);
var KNOWN_NAVS = Object.keys(TEMPLATES).map(function (path) {
  return (0, _lodash.last)(path.split('/')).split('.')[0];
});
function injectTemplates($templateCache) {
  console.groupCollapsed('[maestro] injecting cached templates', KNOWN_NAVS.length);
  for (var _i = 0, _Object$keys = Object.keys(TEMPLATES); _i < _Object$keys.length; _i++) {
    var path = _Object$keys[_i];
    var url = "".concat(TEMPLATE_API_PREFIX, "/").concat((0, _lodash.last)(path.split('/')).replace(/\.(pug|jade)/, '.html'));
    console.log(url);
    $templateCache.put(url, TEMPLATES[path]);
  }
  console.groupEnd();
}
angular.module('maestro.navs.types', []).constant('NAV_TEMPLATE_API_PREFIX', TEMPLATE_API_PREFIX).constant('NAV_TYPES', KNOWN_NAVS);
var NAV_TEMPLATES = {};
var _iterator = _createForOfIteratorHelper(KNOWN_NAVS),
  _step;
try {
  for (_iterator.s(); !(_step = _iterator.n()).done;) {
    var nav = _step.value;
    NAV_TEMPLATES[nav] = "".concat(TEMPLATE_API_PREFIX, "/").concat(nav, ".html");
  }
} catch (err) {
  _iterator.e(err);
} finally {
  _iterator.f();
}
angular.module('maestro.navs.templates', []).constant('NAV_TEMPLATES', NAV_TEMPLATES);
angular.module('maestro.cache.templates', []).run(['$templateCache', injectTemplates]);

},{"./blocks/block_action_btn.jade":297,"./blocks/block_banner.jade":298,"./blocks/block_card.jade":299,"./blocks/block_common_attach_image_preview.jade":300,"./blocks/block_common_edit_select.pug":301,"./blocks/block_common_edit_text.jade":302,"./blocks/block_empty_state.jade":303,"./blocks/block_feed_comment.jade":304,"./blocks/block_feed_new_post.jade":305,"./blocks/block_feed_topic.jade":306,"./blocks/block_image.jade":307,"./blocks/block_list.jade":308,"./blocks/block_list_header.jade":309,"./blocks/block_meeting.pug":310,"./blocks/block_slider.jade":311,"./blocks/block_text.jade":312,"./blocks/block_toggle.jade":313,"./blocks/image_block.jade":314,"./blocks/list_block.jade":315,"./blocks/text_block.jade":316,"./blocks/zoom.pug":317,"./navs/agenda.jade":319,"./navs/appscript_launcher.jade":320,"./navs/blocks.jade":321,"./navs/blocks_list.jade":322,"./navs/calendar_services_sheet.jade":323,"./navs/conversation.jade":324,"./navs/document.jade":325,"./navs/document_note.jade":326,"./navs/fstg.jade":327,"./navs/home.jade":328,"./navs/list.jade":329,"./navs/media.jade":330,"./navs/new_meeting.jade":331,"./navs/new_message.pug":332,"./navs/note.jade":333,"./navs/qr_sheet.jade":334,"./navs/scan.jade":335,"./navs/sheet.jade":336,"./navs/spotman.jade":337,"./rows/agenda_master_row.jade":338,"./rows/agenda_regular_row.jade":339,"./rows/conversation_row.jade":340,"./rows/conversationmessage_row.jade":341,"./rows/list_row.jade":342,"./rows/person_row.pug":343,"./rows/profile_row.jade":344,"./rows/separator_row.jade":345,"./rows/spotman_row.jade":346,"./rows/text_row.jade":347,"./rows/universal_search_row.jade":348,"lodash":"lodash"}],319:[function(require,module,exports){
module.exports = '<agenda-nav ng-if="::(nav.nav_version || nav.agenda_days_ds)" config="::nav"></agenda-nav><nav ng-if="::!nav.nav_version"><nav class="nav-wrapper"><div class="nav-column nav-agenda" ng-controller="AgendaNavCtrl" theme="::eventTheme" nav-id="{{::nav._id}}"><nav-header label="::nav.title" theme-selector="toolbar"></nav-header><div class="nav-content nav-list" on-bottom-reached="nextPage()"><div class="calendar-strip-wrapper" ng-if="::(calendarDays.length &amp;&amp; showCalendar)"><div class="calendar-strip"><div class="day-box" ng-repeat="day in ::calendarDays track by day.ts" ng-class="{today: day.today, selected: day.ts===selectedDay}" ng-style="::{width: day.width}" ng-click="setDay(day.ts)"><div class="day">{{::day.day}}</div><div class="date">{{::day.date}}</div><div class="grid"><div class="dot" ng-repeat="tag in ::day.tags" ng-style="tag"></div></div></div></div></div><div class="sessions"><div ng-repeat="row in nav.ds.elements track by row._id" ng-include="navTemplates[row.render.row_type]"></div></div></div></div></nav></nav>';
},{}],320:[function(require,module,exports){
module.exports = '<appscript-launcher-nav config="::nav"></appscript-launcher-nav>';
},{}],321:[function(require,module,exports){
module.exports = '<blocks-nav config="::nav"></blocks-nav>';
},{}],322:[function(require,module,exports){
module.exports = '<blocks-list-nav config="::nav"></blocks-list-nav>';
},{}],323:[function(require,module,exports){
module.exports = '<ul class="list-group"><li class="list-group-item" ng-repeat="service in ::services" ng-click="service.action(this)"><span>{{::service.label}}</span></li></ul>';
},{}],324:[function(require,module,exports){
module.exports = '<conversation-nav config="::nav"></conversation-nav>';
},{}],325:[function(require,module,exports){
module.exports = '<document-nav config="::nav" on-reject="reject()"></document-nav>';
},{}],326:[function(require,module,exports){
module.exports = '<div class="nav-document-note-color" ng-show="::(annotation.type == &quot;highlight&quot;)"><input class="pull-right input-xs" id="noteColor" ng-model="annotation.color" type="color"/><label for="noteColor">{{::("general.colour" | i18n)}}</label></div><textarea class="nav-document-note camo" ng-model="annotation.contents" ng-attr-placeholder="{{::(&quot;document_nav.add_note&quot; | i18n)}}"></textarea><div class="btn-group btn-group-justified"><div class="btn-group" ng-repeat="action in ::actions track by action.id"><button class="btn btn-default btn-sm" ng-class="{first:$first, last:$last}" ng-click="action.action(this)">{{::(action.label | i18n)}}</button></div></div>';
},{}],327:[function(require,module,exports){
module.exports = '<nav class="nav-wrapper" ng-controller="FstgNavCtrl" nav-id="{{::nav._id}}"><div class="nav-fstg" theme="::eventTheme"><nav-header ng-if="::(nav.title || nav.nav_bar_actions)" label="::nav.title" actions="::nav.nav_bar_actions"></nav-header><div class="nav-content"><join-call-button ng-if="video_breakout_id || nav.video_breakout_id" session-id="video_breakout_id || nav.video_breakout_id" nav="nav"></join-call-button><div class="fstg-page" ng-if="pageController" ng-controller="pageController" ng-include="page.templateUrl"></div></div></div></nav>';
},{}],328:[function(require,module,exports){
module.exports = '<div class="col-md-9 col-sm-9 nav-column nav-home v-layout" ng-controller="HomeNavCtrl" theme="::eventTheme"><div ng-if="packeryLoaded"><div class="nav-header visible-xs-block v-layout-fixed" theme-selector="toolbar">{{::(\'section_title.home\' | i18n)}}</div><div class="v-layout-fixed event-banner" background-asset-src="banner.home_web/file.jpg" ng-class="{&quot;stretch-banner&quot;: nav.render.theme.stretch_banner}"><div class="text-cover" ng-if="::nav.render.theme.text_cover"><div class="text-cover-frame"><h1>{{::eventTitle}}</h1><div>{{::eventStart | time:\'MMMM D\'}}<span ng-if="::eventSpansMultipleDays">&nbsp;&mdash; {{::eventEnd | time:eventEndDateFormat}}</span></div><div>{{::eventVenue}}</div></div></div></div><div class="v-layout-stretch"><div class="packery-wrapper"><div class="packery-container"><div class="grid-sizer"></div><div class="gutter-sizer"></div><div class="group group-{{::group.width}}" ng-repeat="group in ::blockGroups track by group.id"><div class="block block-{{::block.block_type}} {{::block.layout.width}}-width {{::block.layout.height}}-height animated fadeInUp" ng-repeat="block in ::group.blocks track by block.id" ng-include="navTemplates[block.block_type + &quot;_block&quot;]" on-repeat-done="repack()" style="-webkit-animation-delay: {{::block.delay}}s; animation-delay: {{::block.delay}}s"></div></div></div></div><div class="last-access-info" ng-if="::(lastAccess &amp;&amp; blockGroups.length)"><abbr title="With {{::lastAccess.user_agent}}">{{::(\'general.last_access\' | i18n)}}:\n' +
'{{::(lastAccess.last_access | time:\'LTS ll\')}}</abbr></div></div></div></div>';
},{}],329:[function(require,module,exports){
module.exports = '<list-nav config="::nav"></list-nav>';
},{}],330:[function(require,module,exports){
module.exports = '<div class="nav-media"><video-player ng-if="nav._id == \'nav_video\' || nav._id == \'nav_video_content\'" media="::nav.url | assetUrl" autoplay="::nav.autoplay" config="{ fp_type: \'video\', document_id: nav.video_id, configOverrides: nav.config_overrides }" use-metadata="true"></video-player><audio ng-if="nav._id == \'nav_audio\'" controls="controls" ng-attr-autoplay="{{nav.autoplay ? true : undefined}}" ng-src="{{::nav.url | assetUrl}}"><!-- fallback for browser not supporting audio--><a href="{{::nav.url | assetUrl}}"><i class="icon-share"></i>{{::("general.download" | i18n)}}</a></audio></div>';
},{}],331:[function(require,module,exports){
module.exports = '<new-meeting-nav config="::nav"></new-meeting-nav>';
},{}],332:[function(require,module,exports){
module.exports = '<new-message-nav config="::nav"></new-message-nav>';
},{}],333:[function(require,module,exports){
module.exports = '<note-nav config="::nav"></note-nav>';
},{}],334:[function(require,module,exports){
module.exports = '<div class="bcx-qr-sheet"><img class="animated fadeIn qr-code" ng-src="{{qrCodeContents}}"/><span class="tmp-code">{{::tmpCode}}</span></div>';
},{}],335:[function(require,module,exports){
module.exports = '<scan-nav config="::nav"></scan-nav>';
},{}],336:[function(require,module,exports){
module.exports = '<div class="modal modal-sheet no-click-effect pin-{{::pin}}" ng-class="{scrollable: scrollable, menu: menu}"><div class="modal-dialog"><div class="modal-content animated" layout-enabled="::scrollable"><div class="modal-header"><div class="btn-group pull-right" ng-if="::!prompt"><button class="btn btn-default btn-transparent" ng-repeat="action in ::actions track by action.id" ng-click="action.action(this)" type="button">{{::(action.label | i18n)}}</button></div><nav-header-actions class="btn-group pull-right" ng-if="::nav.nav_bar_actions.length" parent-nav-id="::nav.nuid" actions="::nav.nav_bar_actions" action-style="text"></nav-header-actions><h4 class="modal-title" ng-bind-html="::(title | i18n)">&nbsp;</h4></div><div class="modal-body" ng-if="::templateUri"><div ng-include="::templateUri" onload="relayout()"></div></div><div class="modal-body" ng-if="::(prompt &amp;&amp; message)"><div class="modal-message" ng-bind-html="::(message | i18n)"></div></div><div class="modal-footer" ng-if="::prompt"><div class="btn-group btn-group-justified"><div class="btn-group" ng-repeat="action in ::actions track by action.id"><button class="btn btn-default" ng-class="{first:$first, last:$last}" ng-click="action.action(this)">{{::(action.label | i18n)}}</button></div></div></div></div></div></div>';
},{}],337:[function(require,module,exports){
module.exports = '<spotman-nav config="::nav"></spotman-nav>';
},{}],338:[function(require,module,exports){
module.exports = '<div class="media nav-list-item list-row agenda-row agenda-row-master" ng-click="toggleBreakout(row)" ng-class="{expanded: row.expanded}" ng-style="::{&quot;border-left-color&quot;: row.render.params.theme.image_view.background_color}"><div class="media-left"><div class="media-object"><div class="nav-list-item-title"><i class="breakout-expander-icon" ng-class="{&quot;icon-triangle-right&quot;: !row.expanded, &quot;icon-triangle-down&quot;: row.expanded}"></i><span ng-bind="::row.render.params.mapping.start"></span></div></div></div><div class="media-body"><div class="nav-list-item-title" ng-bind="::row.render.params.mapping.title"></div></div></div><div class="breakout-wrapper"><div class="breakout" ng-if="row.expanded"><div ng-repeat="row in row.elements track by row._id" ng-include="navTemplates[row.render.row_type]"></div></div></div>';
},{}],339:[function(require,module,exports){
module.exports = '<div class="media nav-list-item list-row agenda-row agenda-row-regular" ng-click="performRowActions(row)" ng-style="{&quot;border-left-color&quot;: row.render.params.theme.image_view.background_color}"><div class="media-left"><div class="media-object"><div class="nav-list-item-title"><i class="breakout-expander-icon ion-arrow-right-b"></i><span ng-bind="::row.render.params.mapping.start"></span></div><div class="nav-list-item-subtitle" title="{{::row.render.params.mapping.tag}}" ng-bind="::row.render.params.mapping.tag"></div></div></div><div class="media-body"><div class="nav-list-item-title" ng-bind="::row.render.params.mapping.title"></div><div class="nav-list-item-subtitle" ng-show="::row.render.params.mapping.subtitle" ng-bind="::row.render.params.mapping.subtitle"></div></div></div>';
},{}],340:[function(require,module,exports){
module.exports = '<div class="conversation-row animated {{row.cssClasses.join(&quot; &quot;)}}" ng-if="!$ctrl.blockedConversation"><div class="timestamp" ng-bind="::row.ts"></div><div class="message" ng-class="{\'first\': row.showName}" theme="::$ctrl.theme" theme-selector="{{ row.themeSelector }}"><a class="name no-click-effect" ng-click="$ctrl.openUserProfile(row.pid)" ng-if="::row.showName" ng-bind="::row.title"></a><div class="text"><i class="icon-webcam" ng-if="row.type.startsWith(\'call\')"></i><span ng-bind-html="row.body"></span></div><div class="actions" ng-if="::($ctrl.showVideoButtons &amp;&amp; row.type === \'callstart\' &amp;&amp; row.latest)"><a class="btn btn-success" ng-class="{\'disabled\': $ctrl.disableJoinButton}" ng-click="$ctrl.startVideoCall()">{{ \'video_calls.actions.join\' | i18n }}</a></div><div class="actions" ng-if="::($ctrl.showVideoButtons &amp;&amp; row.type === \'callpart\' &amp;&amp; row.rejoin &amp;&amp; row.latest)"><a class="btn btn-success" ng-class="{\'disabled\': $ctrl.disableJoinButton}" ng-click="$ctrl.startVideoCall()">{{ \'video_calls.actions.rejoin\' | i18n }}</a></div></div></div>';
},{}],341:[function(require,module,exports){
module.exports = '<div class="media nav-list-item row-person row-conversationmessage status-{{::row.render.params.mapping.status}}" ng-click="$ctrl.performRowActions(row)"><div class="media-left"><div class="media-object"><div class="notification"></div><avatar object="row.render.params.mapping"></avatar></div></div><div class="media-body"><div class="nav-list-item-subsubtitle pull-right" ng-bind="::row.render.params.mapping.timestamp"></div><div class="nav-list-item-title" ng-bind="::row.render.params.mapping.title"></div><div class="nav-list-item-subtitle" ng-bind="::row.render.params.mapping.body"></div></div></div>';
},{}],342:[function(require,module,exports){
module.exports = '<div class="media nav-list-item list-row" ng-click="performRowActions($index)"><div class="media-left"><div class="media-object nav-list-item-icon" style="background:#fb4f15"></div></div><div class="media-body">{{row.render.params.mapping.title}}</div></div>';
},{}],343:[function(require,module,exports){
module.exports = '<div class="row-person media nav-list-item" ng-click="$ctrl.performRowActions(row)"><div class="media-left"><div class="media-object"><!-- Take the shape from the theme, if a theme exist. However, if there is no images in the mapping, then ignore the theme as we want always rounded initials.--><avatar object="row.render.params.mapping" shape="row.render.params.mapping.img &amp;&amp; row.render.params.theme &amp;&amp; row.render.params.theme.img &amp;&amp; row.render.params.theme.img.shape"></avatar><div class="chip-wrapper" ng-if="row.render.params.mapping.badge"><div class="chip" ng-bind="row.render.params.mapping.badge" ng-style="{\'background-color\': row.render.params.theme.img.badge_color, \'color\': row.render.params.theme.img.font_color}"></div></div></div></div><div class="media-body"><div class="nav-list-item-title" ng-if="row.render.params.mapping.title" ng-bind="row.render.params.mapping.title"></div><div class="nav-list-item-subtitle" ng-show="row.render.params.mapping.subtitle" ng-bind="row.render.params.mapping.subtitle"></div><div class="nav-list-item-subsubtitle" ng-show="row.render.params.mapping.position" ng-bind="row.render.params.mapping.position"></div></div></div>';
},{}],344:[function(require,module,exports){
module.exports = '<profile-row config="::row"></profile-row>';
},{}],345:[function(require,module,exports){
module.exports = '<div class="row-separator"></div>';
},{}],346:[function(require,module,exports){
module.exports = '<div class="media nav-list-item ng-hide" ng-click="$ctrl.performActions(row.actions, row)" ng-show="(row.visible!==false)" ng-class="::({\'in-nav-bar\': row.is_in_nav_bar})" row-id="{{::row._id}}"><div class="media-left"><span class="notification-badge animated zoomIn" ng-show="row.display_empty_badge" theme-selector="badge"></span><span class="notification-badge animated zoomIn" ng-show="!row.display_empty_badge &amp;&amp; row.badgeCount &gt; 0 &amp;&amp; row.badgeCount &lt; 10" ng-bind="row.badgeCount" theme-selector="badge"></span><span class="notification-badge animated zoomIn" ng-show="!row.display_empty_badge &amp;&amp; row.badgeCount &gt; 10" theme-selector="badge">9+</span><i class="media-object nav-list-item-icon" icon="row.render.icon" force-color="$ctrl.iconsColor"></i></div><div class="media-body" ng-bind="row.render.title | i18n"></div></div>';
},{}],347:[function(require,module,exports){
module.exports = '<div class="media nav-list-item row-text" ng-click="$ctrl.performRowActions(row)"><div class="media-body"><div class="nav-list-item-title" ng-if="::row.render.params.mapping.title" ng-bind="::row.render.params.mapping.title" style="color: {{::row.render.params.theme.title.color}}"></div><div class="nav-list-item-subtitle" ng-if="::row.render.params.mapping.subtitle" ng-bind="::row.render.params.mapping.subtitle" style="color: {{::row.render.params.theme.subtitle.color}}"></div><div class="nav-list-item-subsubtitle" ng-if="::row.render.params.mapping.body" ng-bind="::row.render.params.mapping.body" style="color: {{::row.render.params.theme.body.color}}"></div></div></div>';
},{}],348:[function(require,module,exports){
module.exports = '<universal-search-row config="::row" on-focus="$ctrl.searchFocused=true;" on-blur="$ctrl.searchFocused=false;" on-actions="$ctrl.performActions(row.actions)"></universal-search-row>';
},{}],349:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSessionLive = isSessionLive;
exports.isSessionPast = isSessionPast;
exports.selectNextSession = selectNextSession;
var _lodash = require("lodash");
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function selectNextSession(sessionsToday, nowSeconds) {
  var candidate;
  var _iterator = _createForOfIteratorHelper((0, _lodash.sortBy)(sessionsToday, function (s) {
      return s.start_ts;
    })),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var session = _step.value;
      var hasStarted = session.start_ts <= nowSeconds;
      if (hasStarted || !candidate) {
        candidate = session;
      }
      var hasEnded = session.end_ts < nowSeconds;
      if (hasEnded) {
        candidate = undefined;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return candidate;
}
function isSessionLive(session) {
  if (!session) {
    return false;
  }
  var now = (0, _momentTimezone.default)();
  var start = (0, _momentTimezone.default)(session.start_ts * 1000);
  var end = (0, _momentTimezone.default)(session.end_ts * 1000);
  return now.isBetween(start, end);
}
function isSessionPast(session) {
  if (!session) {
    return false;
  }
  var now = (0, _momentTimezone.default)();
  var end = (0, _momentTimezone.default)(session.end_ts * 1000);
  return now.isAfter(end);
}

},{"@babel/runtime/helpers/interopRequireDefault":382,"lodash":"lodash","moment-timezone":"moment-timezone"}],350:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
module.exports.getEventIconUrl = function (event) {
  var eid = event._id;
  var iconUrl = "/api/v1/eid/".concat(eid);
  return event.is_webinar ? "".concat(iconUrl, "/webapp/webinar-icon") : "".concat(iconUrl, "/event-icon");
};
module.exports.getStaticAsset = function (assetPath) {
  var basePath = window.WEBAPP.assetsPath;
  if (!basePath.endsWith('/') && !assetPath.startsWith('/')) {
    basePath += '/';
  }
  if (basePath.endsWith('/') && assetPath.startsWith('/')) {
    basePath = basePath.slice(0, -1);
  }
  return "".concat(basePath).concat(assetPath);
};
module.exports.checkIfImageLoads = function () {
  var _ref = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee(src) {
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", new Promise(function (resolve) {
            var image = new Image();
            image.addEventListener('load', function () {
              return resolve(true);
            });
            image.addEventListener('error', function () {
              return resolve(false);
            });
            image.src = src;
          }));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x) {
    return _ref.apply(this, arguments);
  };
}();

},{"@babel/runtime/helpers/asyncToGenerator":375,"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/regenerator":398}],351:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.timer = void 0;
var timer = function audioTimerLoop(callback, interval) {
  var skipFirstRound = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var dt = interval / 1000;
  var aCtx = new AudioContext();
  var silence = aCtx.createGain();
  silence.gain.value = 0;
  silence.connect(aCtx.destination);
  var stopped = false;
  function onOSCend() {
    if (stopped) {
      return;
    }
    var osc = aCtx.createOscillator();
    osc.onended = onOSCend;
    osc.connect(silence);
    osc.start(0);
    osc.stop(aCtx.currentTime + dt);
    if (!skipFirstRound) {
      callback(aCtx.currentTime);
    }
    skipFirstRound = false;
  }
  setTimeout(onOSCend);
  return function () {
    stopped = true;
    if (aCtx.state === 'running') {
      aCtx.close();
    }
  };
};
exports.timer = timer;

},{}],352:[function(require,module,exports){
"use strict";

module.exports.isUnsupported = function () {
  var isLegacyEdge = window.navigator.userAgent.indexOf('Edge') !== -1;
  return !!document.documentMode || isLegacyEdge;
};

},{}],353:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
function _default(obj) {
  var noMagic = {};
  for (var key in obj) {
    if (obj.hasOwnProperty(key) && key.indexOf('$') !== 0) {
      noMagic[key] = obj[key];
    }
  }
  return noMagic;
}

},{}],354:[function(require,module,exports){
"use strict";

var _lodash = require("lodash");
var TINT_COLOR_THRESHOLD = 10;
var tint = function tint(ctx, w, h, color) {
  var imageData = ctx.getImageData(0, 0, w, h);
  var data = imageData.data;
  for (var i = 0, size = data.length; i < size; i += 4) {
    var opacity = data[i + 3];
    if (opacity !== 0) {
      data[i] = color[0];
      data[i + 1] = color[1];
      data[i + 2] = color[2];
    }
  }
  ctx.putImageData(imageData, 0, 0);
};
function calculateMulticolor(img) {
  var canvas = document.createElement('canvas');
  var ctx = canvas.getContext('2d');
  ctx.drawImage(img, 0, 0);
  var imageData = ctx.getImageData(0, 0, img.naturalWidth, img.naturalHeight);
  var minR, minG, minB, maxR, maxG, maxB;
  minR = minG = minB = 255;
  maxR = maxG = maxB = 0;
  for (var i = 0; i < imageData.data.length; i += 4) {
    var r = imageData.data[i + 0];
    var g = imageData.data[i + 1];
    var b = imageData.data[i + 2];
    var a = imageData.data[i + 3];
    if (a <= 127) {
      continue;
    }
    if (r < minR) minR = r;
    if (g < minG) minG = g;
    if (b < minB) minB = b;
    if (r > maxR) maxR = r;
    if (g > maxG) maxG = g;
    if (b > maxB) maxB = b;
  }
  var distance = (maxR - minR ^ 2) + (maxG - minG ^ 2) + (maxB - minB ^ 2);
  var multicolor = distance > TINT_COLOR_THRESHOLD;
  return multicolor;
}
var isMulticolor = (0, _lodash.memoize)(calculateMulticolor, function (img) {
  return img.src;
});
var recolorize = (0, _lodash.memoize)(function (url, color, $q) {
  var deferred = $q.defer();
  var img = new Image();
  img.onload = function () {
    if (isMulticolor(img)) {
      console.log('Multicolor detected', img.src);
      deferred.resolve(img.src);
      return;
    }
    var canvas = document.createElement('canvas');
    canvas.width = img.naturalWidth;
    canvas.height = img.naturalHeight;
    var ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0);
    tint(ctx, img.naturalWidth, img.naturalHeight, hexToRgbArray(color) || [0, 0, 0]);
    deferred.resolve(canvas.toDataURL('image/png'));
  };
  img.onerror = deferred.reject;
  img.src = url;
  return deferred.promise;
}, function (url, color) {
  return "".concat(url).concat(color);
});
module.exports.recolorize = recolorize;
var hexShorthandToFull = function hexShorthandToFull(shorthand) {
  var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  return shorthand.replace(shorthandRegex, function (m, r, g, b) {
    return '#' + r + r + g + g + b + b;
  });
};
module.exports.hexShorthandToFull = hexShorthandToFull;
var hexToRgbArray = function hexToRgbArray(hex) {
  hex = hexShorthandToFull(hex);
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)] : null;
};
module.exports.hexToRgbArray = hexToRgbArray;
var sanitizeHex = function sanitizeHex(color) {
  if (color.length <= 7) return color;
  var ahex = color.split('#')[1];
  var hexa = ahex.substring(2) + ahex.substring(0, 2);
  return '#' + hexa;
};
module.exports.sanitizeHex = sanitizeHex;
var getLightFromHex = function getLightFromHex(hex) {
  var rgb = hexToRgbArray(hex);
  var r = rgb[0] / 255;
  var g = rgb[1] / 255;
  var b = rgb[2] / 255;
  return Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));
};
module.exports.getLightFromHex = getLightFromHex;

},{"lodash":"lodash"}],355:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addEventListener = addEventListener;
exports.exitNativeFullscreen = exitNativeFullscreen;
exports.replaceReferrer = replaceReferrer;
function addEventListener(element, event, handler) {
  element.addEventListener(event, handler);
  return function () {
    return element.removeEventListener(event, handler);
  };
}
function replaceReferrer(newReferrer) {
  console.log('[DOMUtils] replacing meta referrer content with ', newReferrer);
  var ref = document.querySelector('meta[name="referrer"]');
  var prevReferrerValue = ref.attributes.content.value;
  ref.attributes.content.value = newReferrer;
  return prevReferrerValue;
}
function exitNativeFullscreen() {
  if (!document.fullscreenElement) {
    return;
  }
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen();
  }
}

},{}],356:[function(require,module,exports){
"use strict";

var _browserRum = require("@datadog/browser-rum");
var register = function register() {};
var datadogAppId = undefined;
var datadogToken = undefined;
var env = "production";
var version = "1.156.0";
if (datadogAppId) {
  register = function register(branding, eid) {
    _browserRum.datadogRum.init({
      applicationId: datadogAppId,
      clientToken: datadogToken,
      site: 'datadoghq.com',
      service: 'webapp',
      env: env,
      version: version,
      sampleRate: 100,
      trackInteractions: true,
      defaultPrivacyLevel: 'allow'
    });
    _browserRum.datadogRum.addRumGlobalContext('eid', eid);
    _browserRum.datadogRum.addRumGlobalContext('branding', branding);
    _browserRum.datadogRum.startSessionReplayRecording();
  };
}
module.exports = {
  register: register
};

},{"@datadog/browser-rum":546}],357:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _lodash = require("lodash");
var EventEmitter = function () {
  function EventEmitter() {
    var $timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (handler) {
      return setTimeout(handler, 0);
    };
    (0, _classCallCheck2.default)(this, EventEmitter);
    this.$timeout = $timeout;
    this._eventListeners = {};
  }
  (0, _createClass2.default)(EventEmitter, [{
    key: "addEventListener",
    value: function addEventListener(eventType, listener) {
      var _this = this;
      if (!(0, _lodash.isFunction)(listener)) {
        return;
      }
      this._eventListeners[eventType] = this._eventListeners[eventType] || [];
      this._eventListeners[eventType].push(listener);
      return function () {
        return _this.removeEventListener(eventType, listener);
      };
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(eventType, listener) {
      if (this._eventListeners[eventType]) {
        this._eventListeners[eventType] = this._eventListeners[eventType].filter(function (l) {
          return l !== listener;
        });
      }
    }
  }, {
    key: "emit",
    value: function emit(eventType, payload) {
      var _this2 = this;
      var listeners = this._eventListeners[eventType] || [];
      listeners.forEach(function (listener) {
        return _this2.$timeout((0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee() {
          return _regenerator.default.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return listener(payload);
              case 2:
                return _context.abrupt("return", _context.sent);
              case 3:
              case "end":
                return _context.stop();
            }
          }, _callee);
        })));
      });
    }
  }, {
    key: "hasListeners",
    value: function hasListeners(eventType) {
      if (this._eventListeners[eventType]) {
        return this._eventListeners[eventType].length;
      }
      return false;
    }
  }, {
    key: "getListeners",
    value: function getListeners() {
      return this._eventListeners;
    }
  }]);
  return EventEmitter;
}();
exports.default = EventEmitter;

},{"@babel/runtime/helpers/asyncToGenerator":375,"@babel/runtime/helpers/classCallCheck":376,"@babel/runtime/helpers/createClass":377,"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/regenerator":398,"lodash":"lodash"}],358:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.googleCalendarUrl = googleCalendarUrl;
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var formatTimestamp = function formatTimestamp(ts, timezone) {
  var date = _momentTimezone.default.unix(ts);
  if (timezone) {
    return date.tz(timezone).format('YYYYMMDDTHHmmss');
  } else {
    return date.utc().format('YYYYMMDDTHHmmss') + 'Z';
  }
};
function googleCalendarUrl(config, timezone) {
  var name = config.name,
    start = config.start,
    end = config.end,
    location = config.location,
    content = config.content,
    _id = config._id;
  var timezoneToRemap = {
    'US/Eastern': 'America/New_York',
    'US/Central': 'America/Chicago',
    'US/Mountain': 'America/Phoenix',
    'US/Pacific': 'America/Los_Angeles',
    'EST5EDT': 'America/New_York',
    'EST': 'America/New_York',
    'EDT': 'America/New_York'
  };
  timezone = timezoneToRemap[timezone] || timezone;
  return 'https://www.google.com/calendar/render?action=TEMPLATE' + '&pli=1&sf=true&output=xml' + "&text=".concat(encodeURIComponent(name)) + "&dates=".concat(formatTimestamp(start, timezone), "/").concat(formatTimestamp(end ? end : start, timezone)) + "&ctz=".concat(encodeURIComponent(timezone)) + (location ? "&location=".concat(encodeURIComponent(location)) : '') + "&details=".concat(encodeURIComponent(content)) + "&uid=".concat(_id) + '#eventpage_6';
}

},{"@babel/runtime/helpers/interopRequireDefault":382,"moment-timezone":"moment-timezone"}],359:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = i18nWithFallback;
function i18nWithFallback($i18n, key, fallback, context) {
  var translated = $i18n(key);
  var label = translated === key ? fallback : translated;
  if (context) {
    label = label.replace(/\{\{([^\}]+)\}\}/gi, function (match, capture) {
      return context[capture] || '';
    });
  }
  return label;
}

},{}],360:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = localCache;
function localCache(cacheId) {
  var hasLocalStorage = function () {
    try {
      localStorage._test = 'true';
      if (localStorage._test !== 'true') {
        return false;
      }
      delete localStorage._test;
      return true;
    } catch (e) {
      return false;
    }
  }();
  var cache = hasLocalStorage ? JSON.parse(localStorage[cacheId] || '{}') : {};
  var noCommit = function noCommit() {};
  var commitToLocalStorage = function commitToLocalStorage() {
    return localStorage[cacheId] = angular.toJson(cache);
  };
  var commit = hasLocalStorage ? commitToLocalStorage : noCommit;
  return {
    get: function get(key, defaultValue) {
      return cache.hasOwnProperty(key) ? cache[key] : defaultValue;
    },
    put: function put(key, value) {
      if (cache[key] !== value) {
        cache[key] = value;
        commit();
      }
    },
    remove: function remove(key) {
      if (!cache.hasOwnProperty(key)) return;
      delete cache[key];
      commit();
    },
    reset: function reset() {
      cache = {};
      commit();
    }
  };
}

},{}],361:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = memoizeAsync;
function memoizeAsync(promFn, $q) {
  var cache = {};
  return function (key) {
    if (cache[key]) return $q.resolve(cache[key]);
    var prom = promFn.apply(null, arguments);
    prom.then(function (a) {
      return cache[key] = a;
    });
    return prom;
  };
}

},{}],362:[function(require,module,exports){
"use strict";

var _lodash = require("lodash");
function hasValidBadgeDs(item) {
  var ds = (0, _lodash.get)(item, 'badge.ds', {});
  var type = ds.type,
    path = ds.source;
  var validDs = type === 'javascript' && !(0, _lodash.isEmpty)(path);
  return validDs;
}
module.exports.getItemBadge = function (item, databaseService, callback) {
  if (!hasValidBadgeDs(item)) return;
  var ds = (0, _lodash.get)(item, 'badge.ds').source;
  return databaseService.runAppScript(ds.path, ds.params).then(function (_ref) {
    var response = _ref.data.response;
    return callback(item, response.badge);
  });
};

},{"lodash":"lodash"}],363:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = mergeWithoutArrays;
var _lodash = require("lodash");
function mergeWithoutArrays(target, obj1) {
  return (0, _lodash.merge)(target, obj1, function (a, b) {
    return (0, _lodash.isArray)(a) ? b : undefined;
  });
}

},{"lodash":"lodash"}],364:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = mixin;
var _lodash = require("lodash");
function mixin(target, source) {
  var targetProto = target.prototype;
  var sourceProto = source.prototype;
  var sourceProps = Object.getOwnPropertyNames(sourceProto);
  (0, _lodash.each)(sourceProps, function (name) {
    if (name !== 'constructor') {
      Object.defineProperty(targetProto, name, Object.getOwnPropertyDescriptor(sourceProto, name));
    }
  });
  if (source.$inject && source.$inject.length) {
    target.$inject = target.$inject || [];
    (0, _lodash.each)(source.$inject, function (dep) {
      if (target.$inject.indexOf(dep) === -1) {
        target.$inject.push(dep);
      }
    });
  }
  return target;
}

},{"lodash":"lodash"}],365:[function(require,module,exports){
"use strict";

var _require = require('lodash'),
  debounce = _require.debounce;
module.exports.debounceAndUnique = function (fn) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var randomJitter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var running = false;
  return debounce(function () {
    if (running) {
      console.log("".concat(fn.name, " is already running"));
      return running;
    }
    running = Promise.resolve(fn.apply(void 0, arguments));
    running.catch(function () {
      console.error('Failed to execute debounceAndUnique. Considering adding an error handler on the provided function');
    }).then(function () {
      return running = false;
    });
    return running;
  }, delay + Math.random() * randomJitter);
};

},{"lodash":"lodash"}],366:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stripHTML = stripHTML;
function stripHTML(content) {
  var div = document.createElement('div');
  div.innerHTML = content;
  return div.textContent || div.innerText || '';
}

},{}],367:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nowUnixTimestamp = nowUnixTimestamp;
function nowUnixTimestamp() {
  return Math.floor(Date.now() / 1000);
}

},{}],368:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = unflattenObject;
var _lodash = require("lodash");
var setPath = function setPath(source, path, value) {
  var keys = path.split('.');
  var lastKey = keys.pop();
  var current = source;
  (0, _lodash.each)(keys, function (key) {
    current[key] = current[key] || {};
    current = current[key];
  });
  current[lastKey] = value;
  return source;
};
function unflattenObject(obj, target) {
  return (0, _lodash.reduce)(obj, function (memo, value, key) {
    return setPath(memo, key, value);
  }, target);
}

},{"lodash":"lodash"}],369:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addQueryParamsToUrl = addQueryParamsToUrl;
exports.convertEmbedableUrl = convertEmbedableUrl;
exports.fromQueryString = fromQueryString;
exports.isPlayableVideoUrl = isPlayableVideoUrl;
exports.isSameUrlWithoutQuery = isSameUrlWithoutQuery;
exports.removeQueryString = removeQueryString;
exports.replaceHostIfHasWhiteLabelDomain = replaceHostIfHasWhiteLabelDomain;
exports.toQueryString = toQueryString;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
require("core-js/stable");
var _lodash = require("lodash");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function toQueryString(obj) {
  return new URLSearchParams(obj).toString();
}
function fromQueryString(str) {
  var parsed = new URLSearchParams(str);
  var map = {};
  var _iterator = _createForOfIteratorHelper(parsed),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = (0, _slicedToArray2.default)(_step.value, 2),
        key = _step$value[0],
        value = _step$value[1];
      map[key] = value;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return map;
}
function removeQueryString(url) {
  if (!url || !(0, _lodash.isString)(url)) {
    return url;
  }
  return url.split('?')[0] || '';
}
function convertEmbedableUrl(url) {
  var table = {
    youtube: {
      test: function test(url) {
        return /^https:\/\/((www|m)\.)?youtu(\.be|be\.com)\/watch(\?|\/)/.test(url);
      },
      id: function id(url) {
        return (0, _lodash.get)(url.match(/(\?|&)v=[a-zA-Z0-9]+/), '0', '').replace(/(\?|&)v=/, '');
      },
      convert: function convert(url, id) {
        return url.replace(/\/watch(\?|\/).*$/, "/embed/".concat(id));
      }
    },
    vimeo: {
      test: function test(url) {
        return /^https:\/\/((www|player)\.)?vimeo\.com\/[0-9]+/.test(url);
      },
      id: function id(url) {
        return (0, _lodash.get)(url.match(/[0-9]+$/), '0', '');
      },
      convert: function convert(_, id) {
        return "https://player.vimeo.com/video/".concat(id);
      }
    }
  };
  var converted = url;
  for (var _i = 0, _Object$keys = Object.keys(table); _i < _Object$keys.length; _i++) {
    var media = _Object$keys[_i];
    if (table[media].test(url)) {
      converted = table[media].convert(url, table[media].id(url));
      break;
    }
  }
  return converted;
}
function isPlayableVideoUrl() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var fullUrl = url.toString().startsWith('http') ? url : "https://spotme.com".concat(url);
  var path = new URL(fullUrl).pathname;
  return path.endsWith('m3u8') || path.endsWith('mpd') || path.endsWith('mp4');
}
function addQueryParamsToUrl(url) {
  var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!(0, _lodash.isString)(url)) {
    return url;
  }
  var _ref = url.includes('?') ? url.split('?') : [url, ''],
    _ref2 = (0, _slicedToArray2.default)(_ref, 2),
    urlWithoutQuery = _ref2[0],
    queryString = _ref2[1];
  var params = new URLSearchParams(queryString);
  Object.entries(query).forEach(function (_ref3) {
    var _ref4 = (0, _slicedToArray2.default)(_ref3, 2),
      key = _ref4[0],
      value = _ref4[1];
    return params.append(key, value);
  });
  return "".concat(urlWithoutQuery, "?").concat(params.toString());
}
function isSameUrlWithoutQuery(newUrl, oldUrl) {
  if (newUrl === oldUrl) {
    return true;
  }
  var newUrlWithoutQuery = removeQueryString(newUrl);
  var oldUrlWithoutQuery = removeQueryString(oldUrl);
  return newUrlWithoutQuery === oldUrlWithoutQuery;
}
function replaceHostIfHasWhiteLabelDomain(originalUrl, whiteLabelDomain) {
  if (!whiteLabelDomain) {
    return originalUrl;
  }
  return originalUrl.replace(new URL(originalUrl).host, whiteLabelDomain);
}

},{"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/helpers/slicedToArray":390,"core-js/stable":1092,"lodash":"lodash"}],370:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _lodash = _interopRequireDefault(require("lodash"));
var _handlebars = _interopRequireDefault(require("handlebars"));
var fixedSpotManOrder = {
  my_profile_row: 0.001,
  universal_search_row: 0.002,
  back_to_home_row: 0.003
};
var hiddenSpotmanRows = ['profile_separator_row'];
var stripTrLambda = function stripTrLambda(str) {
  if (!str) return;
  return str.replace(/\{{2,3}(\#|\/)spotme\.tr\}{2,3}/g, '');
};
var mergePlatformOverrides = function mergePlatformOverrides(el) {
  var overrides = (el.platform || {}).web;
  if (!overrides) {
    return el;
  }
  for (var key in overrides) {
    if (overrides.hasOwnProperty(key)) {
      var val = overrides[key];
      if (val === null) {
        delete el[key];
      } else {
        el[key] = val;
      }
    }
  }
  return el;
};
var extractIconFromImgPath = function extractIconFromImgPath(path) {
  if (typeof path !== 'string') return;
  return path.slice(path.indexOf('icon.'));
};
var getSpotManItemTitle = function getSpotManItemTitle(item, originalMappings) {
  return item.render.title || stripTrLambda(item.ds.source.title) || stripTrLambda(originalMappings.title) || 'Untitled';
};
var getSpotManItemIcon = function getSpotManItemIcon(item, originalMappings) {
  return item.render && item.render.icon || item.ds && item.ds.source && item.ds.source.img || extractIconFromImgPath(originalMappings.img);
};
var fixNativeSpotMan = function fixNativeSpotMan(spotman) {
  spotman.nav_type = 'spotman';
  spotman.ds = {
    type: 'enum',
    elements: []
  };
  var elements = _lodash.default.chain(spotman.el || []).filter(function (el) {
    if (hiddenSpotmanRows.indexOf(el._id) !== -1) {
      return false;
    }
    var navType = el.render && el.render.navtype;
    var platforms = el.platforms || [];
    if (navType === 'spotmansectionheaderrow_nav' && !platforms.length) {
      return true;
    }
    return platforms.indexOf('web') !== -1;
  }).map(function (el, i) {
    var originalMappings = (el.render || {}).mapping || {};
    mergePlatformOverrides(el);
    if (el.render && el.render.navtype === 'spotmansectionheaderrow_nav') {
      el.row_type = 'separator_row';
    }
    if (!el.row_type || el.visible === false) {
      return;
    }
    if (!el._id) {
      el._id = 'autogen_' + (Date.now() * Math.random()).toString(16);
    }
    el.order = el._id in fixedSpotManOrder ? fixedSpotManOrder[el._id] : i;
    if (el.row_type === 'separator_row') {
      return _lodash.default.pick(el, '_id', 'order', 'row_type');
    }
    el.ds = el.ds || {
      source: {}
    };
    el.render.title = getSpotManItemTitle(el, originalMappings);
    el.render.icon = getSpotManItemIcon(el, originalMappings);
    delete el.render.mapping;
    var element = _lodash.default.pick(el, '_id', 'order', 'row_type', 'render', 'actions', 'dataSources', 'is_in_nav_bar', 'badge');
    if (el.ds && el.ds.type === 'javascript') {
      element.ds = el.ds;
    }
    if (_lodash.default.get(el, 'dataSources.visible')) {
      element.visible = false;
    }
    return element;
  }).compact().sortBy('order').uniq('_id').value();
  elements = _lodash.default.filter(elements, function (el, i) {
    var nextEl = elements[i + 1];
    if (!nextEl) return true;
    if (el.row_type === 'separator_row' && nextEl.row_type === 'separator_row') {
      return false;
    }
    return true;
  });
  spotman.ds.elements = elements;
  delete spotman.el;
  return spotman;
};
var checkAndStripTrLambda = function checkAndStripTrLambda(obj, key) {
  var value = obj[key];
  if (value) {
    obj[key] = stripTrLambda(value);
  }
};
var normalizeNativeNav = function normalizeNativeNav(nav) {
  if (nav._id) {
    nav._id = nav._id.replace('webnav_', 'nav_');
  }
  var no_content = nav.no_content || nav.nocontent;
  if (no_content) {
    delete no_content.on;
    checkAndStripTrLambda(no_content, 'button_text');
    checkAndStripTrLambda(no_content, 'subtitle_text');
    checkAndStripTrLambda(no_content, 'title_text');
  }
  nav.no_content = no_content;
  if (!nav.nav_type && nav.navtype) {
    nav.nav_type = nav.navtype.replace('_nav', '');
  }
  checkAndStripTrLambda(nav, 'title');
  if (nav._id === 'nav_spotman' && nav.fp_type === 'nav') {
    nav = fixNativeSpotMan(nav);
  }
  if (nav.ds && nav.ds.type === 'javascript' && typeof nav.ds.source === 'string') {
    nav.ds.source = {
      path: nav.ds.source,
      params: nav.ds.params
    };
    delete nav.ds.params;
  }
  if (nav.render) {
    if (!nav.render.row_type && nav.render.navtype) {
      nav.render.row_type = nav.render.navtype.replace('row_nav', '_row');
    }
    if (!nav.render.params && nav.render.mapping) {
      nav.render.params = {
        mapping: nav.render.mapping
      };
      delete nav.render.mapping;
    }
  }
  if (nav._id === 'nav_fstg') {
    return _lodash.default.pick(nav, '_id', 'nav_type', 'page_params', 'title', 'route', 'model_route_param');
  }
  return _lodash.default.omit(nav, '_rev', 'fp_owner', 'fp_type', 'on', 'navtype', 'platform');
};
var parseTheme = function parseTheme(theme, event) {
  var parsedTheme = {};
  try {
    var toolbar = theme.layouts.navigation_bar;
    var spotman = theme.navs.nav_spotman;
    var spotmanListRow = spotman.list_row;
    var spotmanHeaderRow = spotman.spotmansectionheaderrow_nav;
    var home = theme.navs.nav_home || {
      view: {
        background_color: '#e6e6e6'
      }
    };
    var iconColor = spotmanListRow.title.font_color;
    var iconInfo = _lodash.default.get(spotmanListRow, 'image_view.icons_color') || {};
    if (iconInfo.enabled) {
      iconColor = iconInfo.color;
    } else if (iconInfo.enabled === false) {
      iconColor = null;
    }
    parsedTheme = {
      get: function get(path) {
        return _lodash.default.get(theme, path);
      },
      version: theme.theming_version,
      editorV2Enabled: event.theme_editor_v2_enabled,
      foregroundColor1: theme.foregroundColor1,
      foregroundColor2: theme.foregroundColor2,
      backgroundColor1: theme.backgroundColor1,
      backgroundColor2: theme.backgroundColor2,
      backgroundColor3: theme.backgroundColor3,
      backgroundColor4: theme.backgroundColor4,
      backgroundColor5: theme.backgroundColor5,
      contrastColor: theme.contrastColor,
      activeLinkStyle: theme.activeLinkStyle,
      primary_color: theme.primary_color || toolbar.background_color,
      toolbar: {
        background_color: toolbar.background_color,
        font_color: toolbar.title.font_color
      },
      spotman: {
        view: {
          background_color: spotmanListRow.background_color,
          font_color: spotmanListRow.title.font_color,
          icon_color: iconColor
        },
        alt_view: {
          background_color: spotmanHeaderRow.background_color,
          font_color: spotmanHeaderRow.title.font_color
        },
        badge: {
          font_color: theme.layouts.list_row.badge.font_color,
          background_color: theme.layouts.list_row.badge.inset_color
        }
      },
      home: {
        background_color: home.view.background_color
      }
    };
  } catch (e) {
    console.error('Error while parsing theme', e);
  }
  return parsedTheme;
};
var normalizeNavs = function normalizeNavs(allNavs) {
  var navs = {};
  for (var _i = 0, _Object$entries = Object.entries(allNavs); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = (0, _slicedToArray2.default)(_Object$entries[_i], 2),
      id = _Object$entries$_i[0],
      nav = _Object$entries$_i[1];
    if (nav.fp_type !== 'webnav') {
      navs[id] = normalizeNativeNav(nav);
    }
  }
  return navs;
};
var handlebarizeObject = function handlebarizeObject(obj) {
  return _lodash.default.chain(obj).map(function (value, param) {
    var isTemplate = _lodash.default.isString(value) && value.indexOf('{') !== -1;
    var valueType = isTemplate ? 'template' : _lodash.default.isObject(value) ? 'object' : 'const';
    var templateFn;
    switch (valueType) {
      case 'template':
        templateFn = _handlebars.default.compile(value);
        break;
      case 'object':
        templateFn = handlebarizeObject(value);
        break;
      default:
        templateFn = function templateFn() {
          return value;
        };
    }
    if (_lodash.default.isArray(value)) templateFn = _lodash.default.values(templateFn);
    return [param, templateFn];
  }).object().value();
};
var unHandlebarizeObject = function unHandlebarizeObject(obj, context) {
  if (!_lodash.default.isObject(obj)) return obj;
  var out = _lodash.default.chain(obj).map(function (value, param) {
    return [param, _lodash.default.isFunction(value) ? value(context) : unHandlebarizeObject(value, context)];
  }).object().value();
  return out[0] ? _lodash.default.values(out) : out;
};
var renderRows = function renderRows(config, rows) {
  return rows.map(function (row) {
    var rowContext = row || {};
    rowContext.doc = rowContext.doc || row;
    rowContext.value = rowContext.value || {};
    _lodash.default.extend(rowContext, rowContext.value);
    var renderParams = handlebarizeObject(config.render || {});
    var renderType = rowContext.$render_type;
    if (renderType && renderParams[renderType]) {
      renderParams = config.render[renderType] || {};
    }
    var actions = _lodash.default.map(config.actions, function (action) {
      return handlebarizeObject(action.params) || {};
    });
    var renderedRender, renderedActionParams;
    try {
      renderedRender = unHandlebarizeObject(renderParams, rowContext);
      renderedActionParams = unHandlebarizeObject(actions, rowContext);
    } catch (e) {
      console.log('Failed to render', renderParams);
      return row;
    }
    return {
      _id: rowContext._id || rowContext.id || rowContext.doc._id || Math.random(),
      key: rowContext.key || [],
      render: renderedRender,
      actionParams: renderedActionParams
    };
  });
};
module.exports = {
  parseTheme: parseTheme,
  normalizeNavs: normalizeNavs,
  renderRows: renderRows
};

},{"@babel/runtime/helpers/interopRequireDefault":382,"@babel/runtime/helpers/slicedToArray":390,"handlebars":"handlebars","lodash":"lodash"}],371:[function(require,module,exports){
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],372:[function(require,module,exports){
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],373:[function(require,module,exports){
var arrayLikeToArray = require("./arrayLikeToArray.js");
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}
module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"./arrayLikeToArray.js":371}],374:[function(require,module,exports){
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],375:[function(require,module,exports){
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
module.exports = _asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],376:[function(require,module,exports){
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],377:[function(require,module,exports){
var toPropertyKey = require("./toPropertyKey.js");
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"./toPropertyKey.js":395}],378:[function(require,module,exports){
var toPropertyKey = require("./toPropertyKey.js");
function _defineProperty(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"./toPropertyKey.js":395}],379:[function(require,module,exports){
var superPropBase = require("./superPropBase.js");
function _get() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    module.exports = _get = Reflect.get.bind(), module.exports.__esModule = true, module.exports["default"] = module.exports;
  } else {
    module.exports = _get = function _get(target, property, receiver) {
      var base = superPropBase(target, property);
      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  }
  return _get.apply(this, arguments);
}
module.exports = _get, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"./superPropBase.js":391}],380:[function(require,module,exports){
function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _getPrototypeOf(o);
}
module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],381:[function(require,module,exports){
var setPrototypeOf = require("./setPrototypeOf.js");
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}
module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"./setPrototypeOf.js":389}],382:[function(require,module,exports){
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],383:[function(require,module,exports){
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],384:[function(require,module,exports){
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],385:[function(require,module,exports){
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],386:[function(require,module,exports){
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],387:[function(require,module,exports){
var _typeof = require("./typeof.js")["default"];
var assertThisInitialized = require("./assertThisInitialized.js");
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return assertThisInitialized(self);
}
module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"./assertThisInitialized.js":374,"./typeof.js":396}],388:[function(require,module,exports){
var _typeof = require("./typeof.js")["default"];
function _regeneratorRuntime() {
  "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
    return exports;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function value(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function stop() {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"./typeof.js":396}],389:[function(require,module,exports){
function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _setPrototypeOf(o, p);
}
module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],390:[function(require,module,exports){
var arrayWithHoles = require("./arrayWithHoles.js");
var iterableToArrayLimit = require("./iterableToArrayLimit.js");
var unsupportedIterableToArray = require("./unsupportedIterableToArray.js");
var nonIterableRest = require("./nonIterableRest.js");
function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}
module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"./arrayWithHoles.js":372,"./iterableToArrayLimit.js":384,"./nonIterableRest.js":385,"./unsupportedIterableToArray.js":397}],391:[function(require,module,exports){
var getPrototypeOf = require("./getPrototypeOf.js");
function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = getPrototypeOf(object);
    if (object === null) break;
  }
  return object;
}
module.exports = _superPropBase, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"./getPrototypeOf.js":380}],392:[function(require,module,exports){
var arrayWithHoles = require("./arrayWithHoles.js");
var iterableToArray = require("./iterableToArray.js");
var unsupportedIterableToArray = require("./unsupportedIterableToArray.js");
var nonIterableRest = require("./nonIterableRest.js");
function _toArray(arr) {
  return arrayWithHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableRest();
}
module.exports = _toArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"./arrayWithHoles.js":372,"./iterableToArray.js":383,"./nonIterableRest.js":385,"./unsupportedIterableToArray.js":397}],393:[function(require,module,exports){
var arrayWithoutHoles = require("./arrayWithoutHoles.js");
var iterableToArray = require("./iterableToArray.js");
var unsupportedIterableToArray = require("./unsupportedIterableToArray.js");
var nonIterableSpread = require("./nonIterableSpread.js");
function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}
module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"./arrayWithoutHoles.js":373,"./iterableToArray.js":383,"./nonIterableSpread.js":386,"./unsupportedIterableToArray.js":397}],394:[function(require,module,exports){
var _typeof = require("./typeof.js")["default"];
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
module.exports = _toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"./typeof.js":396}],395:[function(require,module,exports){
var _typeof = require("./typeof.js")["default"];
var toPrimitive = require("./toPrimitive.js");
function _toPropertyKey(arg) {
  var key = toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
module.exports = _toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"./toPrimitive.js":394,"./typeof.js":396}],396:[function(require,module,exports){
function _typeof(obj) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],397:[function(require,module,exports){
var arrayLikeToArray = require("./arrayLikeToArray.js");
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}
module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"./arrayLikeToArray.js":371}],398:[function(require,module,exports){
// TODO(Babel 8): Remove this file.

var runtime = require("../helpers/regeneratorRuntime")();
module.exports = runtime;

// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}

},{"../helpers/regeneratorRuntime":388}],399:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineGlobal = exports.makePublicApi = void 0;
var catchUserErrors_1 = require("../tools/catchUserErrors");
var monitor_1 = require("../tools/monitor");
var utils_1 = require("../tools/utils");
function makePublicApi(stub) {
    var publicApi = (0, utils_1.assign)({
        version: "4.36.0",
        // This API method is intentionally not monitored, since the only thing executed is the
        // user-provided 'callback'.  All SDK usages executed in the callback should be monitored, and
        // we don't want to interfere with the user uncaught exceptions.
        onReady: function (callback) {
            callback();
        },
    }, stub);
    // Add a "hidden" property to set debug mode. We define it that way to hide it
    // as much as possible but of course it's not a real protection.
    Object.defineProperty(publicApi, '_setDebug', {
        get: function () {
            return monitor_1.setDebugMode;
        },
        enumerable: false,
    });
    return publicApi;
}
exports.makePublicApi = makePublicApi;
function defineGlobal(global, name, api) {
    var existingGlobalVariable = global[name];
    global[name] = api;
    if (existingGlobalVariable && existingGlobalVariable.q) {
        existingGlobalVariable.q.forEach(function (fn) { return (0, catchUserErrors_1.catchUserErrors)(fn, 'onReady callback threw an error:')(); });
    }
}
exports.defineGlobal = defineGlobal;

},{"../tools/catchUserErrors":435,"../tools/monitor":444,"../tools/utils":451}],400:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addEventListeners = exports.addEventListener = void 0;
var monitor_1 = require("../tools/monitor");
var getZoneJsOriginalValue_1 = require("../tools/getZoneJsOriginalValue");
/**
 * Add an event listener to an event target object (Window, Element, mock object...).  This provides
 * a few conveniences compared to using `element.addEventListener` directly:
 *
 * * supports IE11 by: using an option object only if needed and emulating the `once` option
 *
 * * wraps the listener with a `monitor` function
 *
 * * returns a `stop` function to remove the listener
 */
function addEventListener(eventTarget, event, listener, options) {
    return addEventListeners(eventTarget, [event], listener, options);
}
exports.addEventListener = addEventListener;
/**
 * Add event listeners to an event target object (Window, Element, mock object...).  This provides
 * a few conveniences compared to using `element.addEventListener` directly:
 *
 * * supports IE11 by: using an option object only if needed and emulating the `once` option
 *
 * * wraps the listener with a `monitor` function
 *
 * * returns a `stop` function to remove the listener
 *
 * * with `once: true`, the listener will be called at most once, even if different events are listened
 */
function addEventListeners(eventTarget, events, listener, _a) {
    var _b = _a === void 0 ? {} : _a, once = _b.once, capture = _b.capture, passive = _b.passive;
    var wrappedListener = (0, monitor_1.monitor)(once
        ? function (event) {
            stop();
            listener(event);
        }
        : listener);
    var options = passive ? { capture: capture, passive: passive } : capture;
    var add = (0, getZoneJsOriginalValue_1.getZoneJsOriginalValue)(eventTarget, 'addEventListener');
    events.forEach(function (event) { return add.call(eventTarget, event, wrappedListener, options); });
    function stop() {
        var remove = (0, getZoneJsOriginalValue_1.getZoneJsOriginalValue)(eventTarget, 'removeEventListener');
        events.forEach(function (event) { return remove.call(eventTarget, event, wrappedListener, options); });
    }
    return {
        stop: stop,
    };
}
exports.addEventListeners = addEventListeners;

},{"../tools/getZoneJsOriginalValue":441,"../tools/monitor":444}],401:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrentSite = exports.areCookiesAuthorized = exports.deleteCookie = exports.getCookie = exports.setCookie = exports.COOKIE_ACCESS_DELAY = void 0;
var display_1 = require("../tools/display");
var utils_1 = require("../tools/utils");
exports.COOKIE_ACCESS_DELAY = utils_1.ONE_SECOND;
function setCookie(name, value, expireDelay, options) {
    var date = new Date();
    date.setTime(date.getTime() + expireDelay);
    var expires = "expires=".concat(date.toUTCString());
    var sameSite = options && options.crossSite ? 'none' : 'strict';
    var domain = options && options.domain ? ";domain=".concat(options.domain) : '';
    var secure = options && options.secure ? ';secure' : '';
    document.cookie = "".concat(name, "=").concat(value, ";").concat(expires, ";path=/;samesite=").concat(sameSite).concat(domain).concat(secure);
}
exports.setCookie = setCookie;
function getCookie(name) {
    return (0, utils_1.findCommaSeparatedValue)(document.cookie, name);
}
exports.getCookie = getCookie;
function deleteCookie(name, options) {
    setCookie(name, '', 0, options);
}
exports.deleteCookie = deleteCookie;
function areCookiesAuthorized(options) {
    if (document.cookie === undefined || document.cookie === null) {
        return false;
    }
    try {
        // Use a unique cookie name to avoid issues when the SDK is initialized multiple times during
        // the test cookie lifetime
        var testCookieName = "dd_cookie_test_".concat((0, utils_1.generateUUID)());
        var testCookieValue = 'test';
        setCookie(testCookieName, testCookieValue, utils_1.ONE_MINUTE, options);
        var isCookieCorrectlySet = getCookie(testCookieName) === testCookieValue;
        deleteCookie(testCookieName, options);
        return isCookieCorrectlySet;
    }
    catch (error) {
        display_1.display.error(error);
        return false;
    }
}
exports.areCookiesAuthorized = areCookiesAuthorized;
/**
 * No API to retrieve it, number of levels for subdomain and suffix are unknown
 * strategy: find the minimal domain on which cookies are allowed to be set
 * https://web.dev/same-site-same-origin/#site
 */
var getCurrentSiteCache;
function getCurrentSite() {
    if (getCurrentSiteCache === undefined) {
        // Use a unique cookie name to avoid issues when the SDK is initialized multiple times during
        // the test cookie lifetime
        var testCookieName = "dd_site_test_".concat((0, utils_1.generateUUID)());
        var testCookieValue = 'test';
        var domainLevels = window.location.hostname.split('.');
        var candidateDomain = domainLevels.pop();
        while (domainLevels.length && !getCookie(testCookieName)) {
            candidateDomain = "".concat(domainLevels.pop(), ".").concat(candidateDomain);
            setCookie(testCookieName, testCookieValue, utils_1.ONE_SECOND, { domain: candidateDomain });
        }
        deleteCookie(testCookieName, { domain: candidateDomain });
        getCurrentSiteCache = candidateDomain;
    }
    return getCurrentSiteCache;
}
exports.getCurrentSite = getCurrentSite;

},{"../tools/display":439,"../tools/utils":451}],402:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initFetchObservable = void 0;
var instrumentMethod_1 = require("../tools/instrumentMethod");
var monitor_1 = require("../tools/monitor");
var observable_1 = require("../tools/observable");
var timeUtils_1 = require("../tools/timeUtils");
var urlPolyfill_1 = require("../tools/urlPolyfill");
var fetchObservable;
function initFetchObservable() {
    if (!fetchObservable) {
        fetchObservable = createFetchObservable();
    }
    return fetchObservable;
}
exports.initFetchObservable = initFetchObservable;
function createFetchObservable() {
    var observable = new observable_1.Observable(function () {
        if (!window.fetch) {
            return;
        }
        var stop = (0, instrumentMethod_1.instrumentMethod)(window, 'fetch', function (originalFetch) {
            return function (input, init) {
                var responsePromise;
                var context = (0, monitor_1.callMonitored)(beforeSend, null, [observable, input, init]);
                if (context) {
                    responsePromise = originalFetch.call(this, context.input, context.init);
                    (0, monitor_1.callMonitored)(afterSend, null, [observable, responsePromise, context]);
                }
                else {
                    responsePromise = originalFetch.call(this, input, init);
                }
                return responsePromise;
            };
        }).stop;
        return stop;
    });
    return observable;
}
function beforeSend(observable, input, init) {
    var method = (init && init.method) || (input instanceof Request && input.method) || 'GET';
    var url = input instanceof Request ? input.url : (0, urlPolyfill_1.normalizeUrl)(String(input));
    var startClocks = (0, timeUtils_1.clocksNow)();
    var context = {
        state: 'start',
        init: init,
        input: input,
        method: method,
        startClocks: startClocks,
        url: url,
    };
    observable.notify(context);
    return context;
}
function afterSend(observable, responsePromise, startContext) {
    var reportFetch = function (response) {
        var context = startContext;
        context.state = 'resolve';
        if ('stack' in response || response instanceof Error) {
            context.status = 0;
            context.isAborted = response instanceof DOMException && response.code === DOMException.ABORT_ERR;
            context.error = response;
        }
        else if ('status' in response) {
            context.response = response;
            context.responseType = response.type;
            context.status = response.status;
            context.isAborted = false;
        }
        observable.notify(context);
    };
    responsePromise.then((0, monitor_1.monitor)(reportFetch), (0, monitor_1.monitor)(reportFetch));
}

},{"../tools/instrumentMethod":442,"../tools/monitor":444,"../tools/observable":445,"../tools/timeUtils":449,"../tools/urlPolyfill":450}],403:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPageExitReason = exports.createPageExitObservable = exports.PageExitReason = void 0;
var configuration_1 = require("../domain/configuration");
var observable_1 = require("../tools/observable");
var utils_1 = require("../tools/utils");
var addEventListener_1 = require("./addEventListener");
exports.PageExitReason = {
    HIDDEN: 'visibility_hidden',
    UNLOADING: 'before_unload',
    PAGEHIDE: 'page_hide',
    FROZEN: 'page_frozen',
};
function createPageExitObservable() {
    var observable = new observable_1.Observable(function () {
        var pagehideEnabled = (0, configuration_1.isExperimentalFeatureEnabled)('pagehide');
        var stopListeners = (0, addEventListener_1.addEventListeners)(window, ["visibilitychange" /* VISIBILITY_CHANGE */, "freeze" /* FREEZE */, "pagehide" /* PAGE_HIDE */], function (event) {
            if (event.type === "pagehide" /* PAGE_HIDE */ && pagehideEnabled) {
                /**
                 * Only event that detect page unload events while being compatible with the back/forward cache (bfcache)
                 */
                observable.notify({ reason: exports.PageExitReason.PAGEHIDE });
            }
            else if (event.type === "visibilitychange" /* VISIBILITY_CHANGE */ && document.visibilityState === 'hidden') {
                /**
                 * Only event that guarantee to fire on mobile devices when the page transitions to background state
                 * (e.g. when user switches to a different application, goes to homescreen, etc), or is being unloaded.
                 */
                observable.notify({ reason: exports.PageExitReason.HIDDEN });
            }
            else if (event.type === "freeze" /* FREEZE */) {
                /**
                 * After transitioning in background a tab can be freezed to preserve resources. (cf: https://developer.chrome.com/blog/page-lifecycle-api)
                 * Allow to collect events happening between hidden and frozen state.
                 */
                observable.notify({ reason: exports.PageExitReason.FROZEN });
            }
        }, { capture: true }).stop;
        var stopBeforeUnloadListener = utils_1.noop;
        if (!pagehideEnabled) {
            stopBeforeUnloadListener = (0, addEventListener_1.addEventListener)(window, "beforeunload" /* BEFORE_UNLOAD */, function () {
                observable.notify({ reason: exports.PageExitReason.UNLOADING });
            }).stop;
        }
        return function () {
            stopListeners();
            stopBeforeUnloadListener();
        };
    });
    return observable;
}
exports.createPageExitObservable = createPageExitObservable;
function isPageExitReason(reason) {
    return (0, utils_1.includes)((0, utils_1.objectValues)(exports.PageExitReason), reason);
}
exports.isPageExitReason = isPageExitReason;

},{"../domain/configuration":409,"../tools/observable":445,"../tools/utils":451,"./addEventListener":400}],404:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearTimeout = exports.setTimeout = void 0;
var getZoneJsOriginalValue_1 = require("../tools/getZoneJsOriginalValue");
var monitor_1 = require("../tools/monitor");
function setTimeout(callback, delay) {
    return (0, getZoneJsOriginalValue_1.getZoneJsOriginalValue)(window, 'setTimeout')((0, monitor_1.monitor)(callback), delay);
}
exports.setTimeout = setTimeout;
function clearTimeout(timeoutId) {
    (0, getZoneJsOriginalValue_1.getZoneJsOriginalValue)(window, 'clearTimeout')(timeoutId);
}
exports.clearTimeout = clearTimeout;

},{"../tools/getZoneJsOriginalValue":441,"../tools/monitor":444}],405:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initXhrObservable = void 0;
var instrumentMethod_1 = require("../tools/instrumentMethod");
var monitor_1 = require("../tools/monitor");
var observable_1 = require("../tools/observable");
var timeUtils_1 = require("../tools/timeUtils");
var urlPolyfill_1 = require("../tools/urlPolyfill");
var utils_1 = require("../tools/utils");
var xhrObservable;
var xhrContexts = new WeakMap();
function initXhrObservable() {
    if (!xhrObservable) {
        xhrObservable = createXhrObservable();
    }
    return xhrObservable;
}
exports.initXhrObservable = initXhrObservable;
function createXhrObservable() {
    var observable = new observable_1.Observable(function () {
        var stopInstrumentingStart = (0, instrumentMethod_1.instrumentMethodAndCallOriginal)(XMLHttpRequest.prototype, 'open', {
            before: openXhr,
        }).stop;
        var stopInstrumentingSend = (0, instrumentMethod_1.instrumentMethodAndCallOriginal)(XMLHttpRequest.prototype, 'send', {
            before: function () {
                sendXhr.call(this, observable);
            },
        }).stop;
        var stopInstrumentingAbort = (0, instrumentMethod_1.instrumentMethodAndCallOriginal)(XMLHttpRequest.prototype, 'abort', {
            before: abortXhr,
        }).stop;
        return function () {
            stopInstrumentingStart();
            stopInstrumentingSend();
            stopInstrumentingAbort();
        };
    });
    return observable;
}
function openXhr(method, url) {
    xhrContexts.set(this, {
        state: 'open',
        method: method,
        url: (0, urlPolyfill_1.normalizeUrl)(String(url)),
    });
}
function sendXhr(observable) {
    var _this = this;
    var context = xhrContexts.get(this);
    if (!context) {
        return;
    }
    var startContext = context;
    startContext.state = 'start';
    startContext.startTime = (0, timeUtils_1.relativeNow)();
    startContext.startClocks = (0, timeUtils_1.clocksNow)();
    startContext.isAborted = false;
    startContext.xhr = this;
    var hasBeenReported = false;
    var stopInstrumentingOnReadyStateChange = (0, instrumentMethod_1.instrumentMethodAndCallOriginal)(this, 'onreadystatechange', {
        before: function () {
            if (this.readyState === XMLHttpRequest.DONE) {
                // Try to report the XHR as soon as possible, because the XHR may be mutated by the
                // application during a future event. For example, Angular is calling .abort() on
                // completed requests during a onreadystatechange event, so the status becomes '0'
                // before the request is collected.
                onEnd();
            }
        },
    }).stop;
    var onEnd = (0, monitor_1.monitor)(function () {
        _this.removeEventListener('loadend', onEnd);
        stopInstrumentingOnReadyStateChange();
        if (hasBeenReported) {
            return;
        }
        hasBeenReported = true;
        var completeContext = context;
        completeContext.state = 'complete';
        completeContext.duration = (0, timeUtils_1.elapsed)(startContext.startClocks.timeStamp, (0, timeUtils_1.timeStampNow)());
        completeContext.status = _this.status;
        observable.notify((0, utils_1.shallowClone)(completeContext));
    });
    this.addEventListener('loadend', onEnd);
    observable.notify(startContext);
}
function abortXhr() {
    var context = xhrContexts.get(this);
    if (context) {
        context.isAborted = true;
    }
}

},{"../tools/instrumentMethod":442,"../tools/monitor":444,"../tools/observable":445,"../tools/timeUtils":449,"../tools/urlPolyfill":450,"../tools/utils":451}],406:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeConfiguration = exports.buildCookieOptions = exports.validateAndBuildConfiguration = exports.DefaultPrivacyLevel = void 0;
var cookie_1 = require("../../browser/cookie");
var catchUserErrors_1 = require("../../tools/catchUserErrors");
var display_1 = require("../../tools/display");
var utils_1 = require("../../tools/utils");
var experimentalFeatures_1 = require("./experimentalFeatures");
var transportConfiguration_1 = require("./transportConfiguration");
exports.DefaultPrivacyLevel = {
    ALLOW: 'allow',
    MASK: 'mask',
    MASK_USER_INPUT: 'mask-user-input',
};
function validateAndBuildConfiguration(initConfiguration) {
    var _a, _b, _c;
    if (!initConfiguration || !initConfiguration.clientToken) {
        display_1.display.error('Client Token is not configured, we will not send any data.');
        return;
    }
    var sessionSampleRate = (_a = initConfiguration.sessionSampleRate) !== null && _a !== void 0 ? _a : initConfiguration.sampleRate;
    if (sessionSampleRate !== undefined && !(0, utils_1.isPercentage)(sessionSampleRate)) {
        display_1.display.error('Session Sample Rate should be a number between 0 and 100');
        return;
    }
    if (initConfiguration.telemetrySampleRate !== undefined && !(0, utils_1.isPercentage)(initConfiguration.telemetrySampleRate)) {
        display_1.display.error('Telemetry Sample Rate should be a number between 0 and 100');
        return;
    }
    if (initConfiguration.telemetryConfigurationSampleRate !== undefined &&
        !(0, utils_1.isPercentage)(initConfiguration.telemetryConfigurationSampleRate)) {
        display_1.display.error('Telemetry Configuration Sample Rate should be a number between 0 and 100');
        return;
    }
    // Set the experimental feature flags as early as possible, so we can use them in most places
    (0, experimentalFeatures_1.updateExperimentalFeatures)(initConfiguration.enableExperimentalFeatures);
    return (0, utils_1.assign)({
        beforeSend: initConfiguration.beforeSend && (0, catchUserErrors_1.catchUserErrors)(initConfiguration.beforeSend, 'beforeSend threw an error:'),
        cookieOptions: buildCookieOptions(initConfiguration),
        sessionSampleRate: sessionSampleRate !== null && sessionSampleRate !== void 0 ? sessionSampleRate : 100,
        telemetrySampleRate: (_b = initConfiguration.telemetrySampleRate) !== null && _b !== void 0 ? _b : 20,
        telemetryConfigurationSampleRate: (_c = initConfiguration.telemetryConfigurationSampleRate) !== null && _c !== void 0 ? _c : 5,
        service: initConfiguration.service,
        silentMultipleInit: !!initConfiguration.silentMultipleInit,
        /**
         * beacon payload max queue size implementation is 64kb
         * ensure that we leave room for logs, rum and potential other users
         */
        batchBytesLimit: 16 * utils_1.ONE_KIBI_BYTE,
        eventRateLimiterThreshold: 3000,
        maxTelemetryEventsPerPage: 15,
        /**
         * flush automatically, aim to be lower than ALB connection timeout
         * to maximize connection reuse.
         */
        flushTimeout: 30 * utils_1.ONE_SECOND,
        /**
         * Logs intake limit
         */
        batchMessagesLimit: 50,
        messageBytesLimit: 256 * utils_1.ONE_KIBI_BYTE,
    }, (0, transportConfiguration_1.computeTransportConfiguration)(initConfiguration));
}
exports.validateAndBuildConfiguration = validateAndBuildConfiguration;
function buildCookieOptions(initConfiguration) {
    var cookieOptions = {};
    cookieOptions.secure = mustUseSecureCookie(initConfiguration);
    cookieOptions.crossSite = !!initConfiguration.useCrossSiteSessionCookie;
    if (initConfiguration.trackSessionAcrossSubdomains) {
        cookieOptions.domain = (0, cookie_1.getCurrentSite)();
    }
    return cookieOptions;
}
exports.buildCookieOptions = buildCookieOptions;
function mustUseSecureCookie(initConfiguration) {
    return !!initConfiguration.useSecureSessionCookie || !!initConfiguration.useCrossSiteSessionCookie;
}
function serializeConfiguration(configuration) {
    var _a, _b;
    var proxy = (_a = configuration.proxy) !== null && _a !== void 0 ? _a : configuration.proxyUrl;
    return {
        session_sample_rate: (_b = configuration.sessionSampleRate) !== null && _b !== void 0 ? _b : configuration.sampleRate,
        telemetry_sample_rate: configuration.telemetrySampleRate,
        telemetry_configuration_sample_rate: configuration.telemetryConfigurationSampleRate,
        use_before_send: !!configuration.beforeSend,
        use_cross_site_session_cookie: configuration.useCrossSiteSessionCookie,
        use_secure_session_cookie: configuration.useSecureSessionCookie,
        use_proxy: proxy !== undefined ? !!proxy : undefined,
        silent_multiple_init: configuration.silentMultipleInit,
        track_session_across_subdomains: configuration.trackSessionAcrossSubdomains,
        track_resources: configuration.trackResources,
        track_long_task: configuration.trackLongTasks,
    };
}
exports.serializeConfiguration = serializeConfiguration;

},{"../../browser/cookie":401,"../../tools/catchUserErrors":435,"../../tools/display":439,"../../tools/utils":451,"./experimentalFeatures":408,"./transportConfiguration":412}],407:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEndpointBuilder = exports.ENDPOINTS = void 0;
var timeUtils_1 = require("../../tools/timeUtils");
var urlPolyfill_1 = require("../../tools/urlPolyfill");
var utils_1 = require("../../tools/utils");
var intakeSites_1 = require("./intakeSites");
var experimentalFeatures_1 = require("./experimentalFeatures");
exports.ENDPOINTS = {
    logs: 'logs',
    rum: 'rum',
    sessionReplay: 'session-replay',
};
var INTAKE_TRACKS = {
    logs: 'logs',
    rum: 'rum',
    sessionReplay: 'replay',
};
function createEndpointBuilder(initConfiguration, endpointType, configurationTags) {
    var buildUrlWithParameters = createEndpointUrlWithParametersBuilder(initConfiguration, endpointType);
    return {
        build: function (api, flushReason, retry) {
            var parameters = buildEndpointParameters(initConfiguration, endpointType, configurationTags, api, flushReason, retry);
            return buildUrlWithParameters(parameters);
        },
        urlPrefix: buildUrlWithParameters(''),
        endpointType: endpointType,
    };
}
exports.createEndpointBuilder = createEndpointBuilder;
/**
 * Create a function used to build a full endpoint url from provided parameters. The goal of this
 * function is to pre-compute some parts of the URL to avoid re-computing everything on every
 * request, as only parameters are changing.
 */
function createEndpointUrlWithParametersBuilder(initConfiguration, endpointType) {
    var path = "/api/v2/".concat(INTAKE_TRACKS[endpointType]);
    var proxy = initConfiguration.proxy, proxyUrl = initConfiguration.proxyUrl;
    if (proxy) {
        var normalizedProxyUrl_1 = (0, urlPolyfill_1.normalizeUrl)(proxy);
        return function (parameters) { return "".concat(normalizedProxyUrl_1, "?ddforward=").concat(encodeURIComponent("".concat(path, "?").concat(parameters))); };
    }
    var host = buildEndpointHost(initConfiguration, endpointType);
    if (proxy === undefined && proxyUrl) {
        // TODO: remove this in a future major.
        var normalizedProxyUrl_2 = (0, urlPolyfill_1.normalizeUrl)(proxyUrl);
        return function (parameters) {
            return "".concat(normalizedProxyUrl_2, "?ddforward=").concat(encodeURIComponent("https://".concat(host).concat(path, "?").concat(parameters)));
        };
    }
    return function (parameters) { return "https://".concat(host).concat(path, "?").concat(parameters); };
}
function buildEndpointHost(initConfiguration, endpointType) {
    var _a = initConfiguration.site, site = _a === void 0 ? intakeSites_1.INTAKE_SITE_US1 : _a, internalAnalyticsSubdomain = initConfiguration.internalAnalyticsSubdomain;
    if (internalAnalyticsSubdomain && site === intakeSites_1.INTAKE_SITE_US1) {
        return "".concat(internalAnalyticsSubdomain, ".").concat(intakeSites_1.INTAKE_SITE_US1);
    }
    var domainParts = site.split('.');
    var extension = domainParts.pop();
    var subdomain = site !== intakeSites_1.INTAKE_SITE_AP1 ? "".concat(exports.ENDPOINTS[endpointType], ".") : '';
    return "".concat(subdomain, "browser-intake-").concat(domainParts.join('-'), ".").concat(extension);
}
/**
 * Build parameters to be used for an intake request. Parameters should be re-built for each
 * request, as they change randomly.
 */
function buildEndpointParameters(_a, endpointType, configurationTags, api, flushReason, retry) {
    var clientToken = _a.clientToken, internalAnalyticsSubdomain = _a.internalAnalyticsSubdomain;
    var tags = ["sdk_version:".concat("4.36.0"), "api:".concat(api)].concat(configurationTags);
    if (flushReason && (0, experimentalFeatures_1.isExperimentalFeatureEnabled)('collect_flush_reason')) {
        tags.push("flush_reason:".concat(flushReason));
    }
    if (retry) {
        tags.push("retry_count:".concat(retry.count), "retry_after:".concat(retry.lastFailureStatus));
    }
    var parameters = [
        'ddsource=browser',
        "ddtags=".concat(encodeURIComponent(tags.join(','))),
        "dd-api-key=".concat(clientToken),
        "dd-evp-origin-version=".concat(encodeURIComponent("4.36.0")),
        'dd-evp-origin=browser',
        "dd-request-id=".concat((0, utils_1.generateUUID)()),
    ];
    if (endpointType === 'rum') {
        parameters.push("batch_time=".concat((0, timeUtils_1.timeStampNow)()));
    }
    if (internalAnalyticsSubdomain) {
        parameters.reverse();
    }
    return parameters.join('&');
}

},{"../../tools/timeUtils":449,"../../tools/urlPolyfill":450,"../../tools/utils":451,"./experimentalFeatures":408,"./intakeSites":410}],408:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExperimentalFeatures = exports.resetExperimentalFeatures = exports.isExperimentalFeatureEnabled = exports.updateExperimentalFeatures = void 0;
/**
 * LIMITATION:
 * For NPM setup, this feature flag singleton is shared between RUM and Logs product.
 * This means that an experimental flag set on the RUM product will be set on the Logs product.
 * So keep in mind that in certain configurations, your experimental feature flag may affect other products.
 */
var utils_1 = require("../../tools/utils");
var display_1 = require("../../tools/display");
var enabledExperimentalFeatures;
function updateExperimentalFeatures(enabledFeatures) {
    // Safely handle external data
    if (!Array.isArray(enabledFeatures)) {
        return;
    }
    if (!enabledExperimentalFeatures) {
        enabledExperimentalFeatures = new Set(enabledFeatures);
    }
    enabledFeatures
        .filter(function (flag) { return typeof flag === 'string'; })
        .forEach(function (flag) {
        if ((0, utils_1.includes)(flag, '-')) {
            display_1.display.warn("please use snake case for '".concat(flag, "'"));
        }
        enabledExperimentalFeatures.add(flag);
    });
}
exports.updateExperimentalFeatures = updateExperimentalFeatures;
function isExperimentalFeatureEnabled(featureName) {
    return !!enabledExperimentalFeatures && enabledExperimentalFeatures.has(featureName);
}
exports.isExperimentalFeatureEnabled = isExperimentalFeatureEnabled;
function resetExperimentalFeatures() {
    enabledExperimentalFeatures = new Set();
}
exports.resetExperimentalFeatures = resetExperimentalFeatures;
function getExperimentalFeatures() {
    return enabledExperimentalFeatures || new Set();
}
exports.getExperimentalFeatures = getExperimentalFeatures;

},{"../../tools/display":439,"../../tools/utils":451}],409:[function(require,module,exports){
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExperimentalFeatures = exports.resetExperimentalFeatures = exports.updateExperimentalFeatures = exports.isExperimentalFeatureEnabled = exports.createEndpointBuilder = exports.serializeConfiguration = exports.validateAndBuildConfiguration = exports.DefaultPrivacyLevel = exports.buildCookieOptions = void 0;
var configuration_1 = require("./configuration");
Object.defineProperty(exports, "buildCookieOptions", { enumerable: true, get: function () { return configuration_1.buildCookieOptions; } });
Object.defineProperty(exports, "DefaultPrivacyLevel", { enumerable: true, get: function () { return configuration_1.DefaultPrivacyLevel; } });
Object.defineProperty(exports, "validateAndBuildConfiguration", { enumerable: true, get: function () { return configuration_1.validateAndBuildConfiguration; } });
Object.defineProperty(exports, "serializeConfiguration", { enumerable: true, get: function () { return configuration_1.serializeConfiguration; } });
var endpointBuilder_1 = require("./endpointBuilder");
Object.defineProperty(exports, "createEndpointBuilder", { enumerable: true, get: function () { return endpointBuilder_1.createEndpointBuilder; } });
var experimentalFeatures_1 = require("./experimentalFeatures");
Object.defineProperty(exports, "isExperimentalFeatureEnabled", { enumerable: true, get: function () { return experimentalFeatures_1.isExperimentalFeatureEnabled; } });
Object.defineProperty(exports, "updateExperimentalFeatures", { enumerable: true, get: function () { return experimentalFeatures_1.updateExperimentalFeatures; } });
Object.defineProperty(exports, "resetExperimentalFeatures", { enumerable: true, get: function () { return experimentalFeatures_1.resetExperimentalFeatures; } });
Object.defineProperty(exports, "getExperimentalFeatures", { enumerable: true, get: function () { return experimentalFeatures_1.getExperimentalFeatures; } });
__exportStar(require("./intakeSites"), exports);

},{"./configuration":406,"./endpointBuilder":407,"./experimentalFeatures":408,"./intakeSites":410}],410:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INTAKE_SITE_US1_FED = exports.INTAKE_SITE_AP1 = exports.INTAKE_SITE_US1 = exports.INTAKE_SITE_STAGING = void 0;
exports.INTAKE_SITE_STAGING = 'datad0g.com';
exports.INTAKE_SITE_US1 = 'datadoghq.com';
exports.INTAKE_SITE_AP1 = 'ap1.datadoghq.com';
exports.INTAKE_SITE_US1_FED = 'ddog-gov.com';

},{}],411:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildTag = exports.buildTags = exports.TAG_SIZE_LIMIT = void 0;
var display_1 = require("../../tools/display");
exports.TAG_SIZE_LIMIT = 200;
function buildTags(configuration) {
    var env = configuration.env, service = configuration.service, version = configuration.version, datacenter = configuration.datacenter;
    var tags = [];
    if (env) {
        tags.push(buildTag('env', env));
    }
    if (service) {
        tags.push(buildTag('service', service));
    }
    if (version) {
        tags.push(buildTag('version', version));
    }
    if (datacenter) {
        tags.push(buildTag('datacenter', datacenter));
    }
    return tags;
}
exports.buildTags = buildTags;
var FORBIDDEN_CHARACTERS = /[^a-z0-9_:./-]/;
function buildTag(key, rawValue) {
    // See https://docs.datadoghq.com/getting_started/tagging/#defining-tags for tags syntax. Note
    // that the backend may not follow the exact same rules, so we only want to display an informal
    // warning.
    var valueSizeLimit = exports.TAG_SIZE_LIMIT - key.length - 1;
    if (rawValue.length > valueSizeLimit || FORBIDDEN_CHARACTERS.test(rawValue)) {
        display_1.display.warn("".concat(key, " value doesn't meet tag requirements and will be sanitized"));
    }
    // Let the backend do most of the sanitization, but still make sure multiple tags can't be crafted
    // by forging a value containing commas.
    var sanitizedValue = rawValue.replace(/,/g, '_');
    return "".concat(key, ":").concat(sanitizedValue);
}
exports.buildTag = buildTag;

},{"../../tools/display":439}],412:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeTransportConfiguration = void 0;
var utils_1 = require("../../tools/utils");
var endpointBuilder_1 = require("./endpointBuilder");
var tags_1 = require("./tags");
var intakeSites_1 = require("./intakeSites");
function computeTransportConfiguration(initConfiguration) {
    var tags = (0, tags_1.buildTags)(initConfiguration);
    var endpointBuilders = computeEndpointBuilders(initConfiguration, tags);
    var intakeUrlPrefixes = (0, utils_1.objectValues)(endpointBuilders).map(function (builder) { return builder.urlPrefix; });
    var replicaConfiguration = computeReplicaConfiguration(initConfiguration, intakeUrlPrefixes, tags);
    return (0, utils_1.assign)({
        isIntakeUrl: function (url) { return intakeUrlPrefixes.some(function (intakeEndpoint) { return url.indexOf(intakeEndpoint) === 0; }); },
        replica: replicaConfiguration,
        site: initConfiguration.site || intakeSites_1.INTAKE_SITE_US1,
    }, endpointBuilders);
}
exports.computeTransportConfiguration = computeTransportConfiguration;
function computeEndpointBuilders(initConfiguration, tags) {
    return {
        logsEndpointBuilder: (0, endpointBuilder_1.createEndpointBuilder)(initConfiguration, 'logs', tags),
        rumEndpointBuilder: (0, endpointBuilder_1.createEndpointBuilder)(initConfiguration, 'rum', tags),
        sessionReplayEndpointBuilder: (0, endpointBuilder_1.createEndpointBuilder)(initConfiguration, 'sessionReplay', tags),
    };
}
function computeReplicaConfiguration(initConfiguration, intakeUrlPrefixes, tags) {
    if (!initConfiguration.replica) {
        return;
    }
    var replicaConfiguration = (0, utils_1.assign)({}, initConfiguration, {
        site: intakeSites_1.INTAKE_SITE_US1,
        clientToken: initConfiguration.replica.clientToken,
    });
    var replicaEndpointBuilders = {
        logsEndpointBuilder: (0, endpointBuilder_1.createEndpointBuilder)(replicaConfiguration, 'logs', tags),
        rumEndpointBuilder: (0, endpointBuilder_1.createEndpointBuilder)(replicaConfiguration, 'rum', tags),
    };
    intakeUrlPrefixes.push.apply(intakeUrlPrefixes, (0, utils_1.objectValues)(replicaEndpointBuilders).map(function (builder) { return builder.urlPrefix; }));
    return (0, utils_1.assign)({ applicationId: initConfiguration.replica.applicationId }, replicaEndpointBuilders);
}

},{"../../tools/utils":451,"./endpointBuilder":407,"./intakeSites":410,"./tags":411}],413:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initConsoleObservable = void 0;
var tracekit_1 = require("../tracekit");
var error_1 = require("../../tools/error");
var observable_1 = require("../../tools/observable");
var utils_1 = require("../../tools/utils");
var display_1 = require("../../tools/display");
var monitor_1 = require("../../tools/monitor");
var consoleObservablesByApi = {};
function initConsoleObservable(apis) {
    var consoleObservables = apis.map(function (api) {
        if (!consoleObservablesByApi[api]) {
            consoleObservablesByApi[api] = createConsoleObservable(api);
        }
        return consoleObservablesByApi[api];
    });
    return observable_1.mergeObservables.apply(void 0, consoleObservables);
}
exports.initConsoleObservable = initConsoleObservable;
/* eslint-disable no-console */
function createConsoleObservable(api) {
    var observable = new observable_1.Observable(function () {
        var originalConsoleApi = console[api];
        console[api] = function () {
            var params = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                params[_i] = arguments[_i];
            }
            originalConsoleApi.apply(console, params);
            var handlingStack = (0, error_1.createHandlingStack)();
            (0, monitor_1.callMonitored)(function () {
                observable.notify(buildConsoleLog(params, api, handlingStack));
            });
        };
        return function () {
            console[api] = originalConsoleApi;
        };
    });
    return observable;
}
function buildConsoleLog(params, api, handlingStack) {
    // Todo: remove console error prefix in the next major version
    var message = params.map(function (param) { return formatConsoleParameters(param); }).join(' ');
    var stack;
    if (api === display_1.ConsoleApiName.error) {
        var firstErrorParam = (0, utils_1.find)(params, function (param) { return param instanceof Error; });
        stack = firstErrorParam ? (0, error_1.toStackTraceString)((0, tracekit_1.computeStackTrace)(firstErrorParam)) : undefined;
        message = "console error: ".concat(message);
    }
    return {
        api: api,
        message: message,
        stack: stack,
        handlingStack: handlingStack,
    };
}
function formatConsoleParameters(param) {
    if (typeof param === 'string') {
        return param;
    }
    if (param instanceof Error) {
        return (0, error_1.formatErrorMessage)((0, tracekit_1.computeStackTrace)(param));
    }
    return (0, utils_1.jsonStringify)(param, undefined, 2);
}

},{"../../tools/display":439,"../../tools/error":440,"../../tools/monitor":444,"../../tools/observable":445,"../../tools/utils":451,"../tracekit":427}],414:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackRuntimeError = void 0;
var error_1 = require("../../tools/error");
var timeUtils_1 = require("../../tools/timeUtils");
var tracekit_1 = require("../tracekit");
function trackRuntimeError(errorObservable) {
    return (0, tracekit_1.startUnhandledErrorCollection)(function (stackTrace, originalError) {
        errorObservable.notify((0, error_1.computeRawError)({
            stackTrace: stackTrace,
            originalError: originalError,
            startClocks: (0, timeUtils_1.clocksNow)(),
            nonErrorPrefix: 'Uncaught',
            source: error_1.ErrorSource.SOURCE,
            handling: "unhandled" /* UNHANDLED */,
        }));
    });
}
exports.trackRuntimeError = trackRuntimeError;

},{"../../tools/error":440,"../../tools/timeUtils":449,"../tracekit":427}],415:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initReportObservable = exports.RawReportType = void 0;
var error_1 = require("../../tools/error");
var monitor_1 = require("../../tools/monitor");
var observable_1 = require("../../tools/observable");
var utils_1 = require("../../tools/utils");
var addEventListener_1 = require("../../browser/addEventListener");
exports.RawReportType = {
    intervention: 'intervention',
    deprecation: 'deprecation',
    cspViolation: 'csp_violation',
};
function initReportObservable(apis) {
    var observables = [];
    if ((0, utils_1.includes)(apis, exports.RawReportType.cspViolation)) {
        observables.push(createCspViolationReportObservable());
    }
    var reportTypes = apis.filter(function (api) { return api !== exports.RawReportType.cspViolation; });
    if (reportTypes.length) {
        observables.push(createReportObservable(reportTypes));
    }
    return observable_1.mergeObservables.apply(void 0, observables);
}
exports.initReportObservable = initReportObservable;
function createReportObservable(reportTypes) {
    var observable = new observable_1.Observable(function () {
        if (!window.ReportingObserver) {
            return;
        }
        var handleReports = (0, monitor_1.monitor)(function (reports) {
            return reports.forEach(function (report) {
                observable.notify(buildRawReportFromReport(report));
            });
        });
        var observer = new window.ReportingObserver(handleReports, {
            types: reportTypes,
            buffered: true,
        });
        observer.observe();
        return function () {
            observer.disconnect();
        };
    });
    return observable;
}
function createCspViolationReportObservable() {
    var observable = new observable_1.Observable(function () {
        var handleCspViolation = (0, monitor_1.monitor)(function (event) {
            observable.notify(buildRawReportFromCspViolation(event));
        });
        var stop = (0, addEventListener_1.addEventListener)(document, "securitypolicyviolation" /* SECURITY_POLICY_VIOLATION */, handleCspViolation).stop;
        return stop;
    });
    return observable;
}
function buildRawReportFromReport(_a) {
    var type = _a.type, body = _a.body;
    return {
        type: type,
        subtype: body.id,
        message: "".concat(type, ": ").concat(body.message),
        stack: buildStack(body.id, body.message, body.sourceFile, body.lineNumber, body.columnNumber),
    };
}
function buildRawReportFromCspViolation(event) {
    var type = exports.RawReportType.cspViolation;
    var message = "'".concat(event.blockedURI, "' blocked by '").concat(event.effectiveDirective, "' directive");
    return {
        type: exports.RawReportType.cspViolation,
        subtype: event.effectiveDirective,
        message: "".concat(type, ": ").concat(message),
        stack: buildStack(event.effectiveDirective, event.originalPolicy
            ? "".concat(message, " of the policy \"").concat((0, utils_1.safeTruncate)(event.originalPolicy, 100, '...'), "\"")
            : 'no policy', event.sourceFile, event.lineNumber, event.columnNumber),
    };
}
function buildStack(name, message, sourceFile, lineNumber, columnNumber) {
    return (sourceFile &&
        (0, error_1.toStackTraceString)({
            name: name,
            message: message,
            stack: [
                {
                    func: '?',
                    url: sourceFile,
                    line: lineNumber,
                    column: columnNumber,
                },
            ],
        }));
}

},{"../../browser/addEventListener":400,"../../tools/error":440,"../../tools/monitor":444,"../../tools/observable":445,"../../tools/utils":451}],416:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tryOldCookiesMigration = exports.LOGS_SESSION_KEY = exports.RUM_SESSION_KEY = exports.OLD_LOGS_COOKIE_NAME = exports.OLD_RUM_COOKIE_NAME = exports.OLD_SESSION_COOKIE_NAME = void 0;
var cookie_1 = require("../../browser/cookie");
var sessionCookieStore_1 = require("./sessionCookieStore");
exports.OLD_SESSION_COOKIE_NAME = '_dd';
exports.OLD_RUM_COOKIE_NAME = '_dd_r';
exports.OLD_LOGS_COOKIE_NAME = '_dd_l';
// duplicate values to avoid dependency issues
exports.RUM_SESSION_KEY = 'rum';
exports.LOGS_SESSION_KEY = 'logs';
/**
 * This migration should remain in the codebase as long as older versions are available/live
 * to allow older sdk versions to be upgraded to newer versions without compatibility issues.
 */
function tryOldCookiesMigration(options) {
    var sessionString = (0, cookie_1.getCookie)(sessionCookieStore_1.SESSION_COOKIE_NAME);
    var oldSessionId = (0, cookie_1.getCookie)(exports.OLD_SESSION_COOKIE_NAME);
    var oldRumType = (0, cookie_1.getCookie)(exports.OLD_RUM_COOKIE_NAME);
    var oldLogsType = (0, cookie_1.getCookie)(exports.OLD_LOGS_COOKIE_NAME);
    if (!sessionString) {
        var session = {};
        if (oldSessionId) {
            session.id = oldSessionId;
        }
        if (oldLogsType && /^[01]$/.test(oldLogsType)) {
            session[exports.LOGS_SESSION_KEY] = oldLogsType;
        }
        if (oldRumType && /^[012]$/.test(oldRumType)) {
            session[exports.RUM_SESSION_KEY] = oldRumType;
        }
        (0, sessionCookieStore_1.persistSession)(session, options);
    }
}
exports.tryOldCookiesMigration = tryOldCookiesMigration;

},{"../../browser/cookie":401,"./sessionCookieStore":418}],417:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SESSION_EXPIRATION_DELAY = exports.SESSION_TIME_OUT_DELAY = void 0;
var utils_1 = require("../../tools/utils");
exports.SESSION_TIME_OUT_DELAY = 4 * utils_1.ONE_HOUR;
exports.SESSION_EXPIRATION_DELAY = 15 * utils_1.ONE_MINUTE;

},{"../../tools/utils":451}],418:[function(require,module,exports){
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.retrieveSession = exports.toSessionString = exports.persistSession = exports.withCookieLockAccess = exports.MAX_NUMBER_OF_LOCK_RETRIES = exports.LOCK_RETRY_DELAY = exports.SESSION_COOKIE_NAME = void 0;
var cookie_1 = require("../../browser/cookie");
var timer_1 = require("../../browser/timer");
var browserDetection_1 = require("../../tools/browserDetection");
var timeUtils_1 = require("../../tools/timeUtils");
var utils = __importStar(require("../../tools/utils"));
var sessionConstants_1 = require("./sessionConstants");
var SESSION_ENTRY_REGEXP = /^([a-z]+)=([a-z0-9-]+)$/;
var SESSION_ENTRY_SEPARATOR = '&';
exports.SESSION_COOKIE_NAME = '_dd_s';
// arbitrary values
exports.LOCK_RETRY_DELAY = 10;
exports.MAX_NUMBER_OF_LOCK_RETRIES = 100;
var bufferedOperations = [];
var ongoingOperations;
function withCookieLockAccess(operations, numberOfRetries) {
    var _a;
    if (numberOfRetries === void 0) { numberOfRetries = 0; }
    if (!ongoingOperations) {
        ongoingOperations = operations;
    }
    if (operations !== ongoingOperations) {
        bufferedOperations.push(operations);
        return;
    }
    if (numberOfRetries >= exports.MAX_NUMBER_OF_LOCK_RETRIES) {
        next();
        return;
    }
    var currentLock;
    var currentSession = retrieveSession();
    if (isCookieLockEnabled()) {
        // if someone has lock, retry later
        if (currentSession.lock) {
            retryLater(operations, numberOfRetries);
            return;
        }
        // acquire lock
        currentLock = utils.generateUUID();
        currentSession.lock = currentLock;
        setSession(currentSession, operations.options);
        // if lock is not acquired, retry later
        currentSession = retrieveSession();
        if (currentSession.lock !== currentLock) {
            retryLater(operations, numberOfRetries);
            return;
        }
    }
    var processedSession = operations.process(currentSession);
    if (isCookieLockEnabled()) {
        // if lock corrupted after process, retry later
        currentSession = retrieveSession();
        if (currentSession.lock !== currentLock) {
            retryLater(operations, numberOfRetries);
            return;
        }
    }
    if (processedSession) {
        persistSession(processedSession, operations.options);
    }
    if (isCookieLockEnabled()) {
        // correctly handle lock around expiration would require to handle this case properly at several levels
        // since we don't have evidence of lock issues around expiration, let's just not do the corruption check for it
        if (!(processedSession && isExpiredState(processedSession))) {
            // if lock corrupted after persist, retry later
            currentSession = retrieveSession();
            if (currentSession.lock !== currentLock) {
                retryLater(operations, numberOfRetries);
                return;
            }
            delete currentSession.lock;
            setSession(currentSession, operations.options);
            processedSession = currentSession;
        }
    }
    // call after even if session is not persisted in order to perform operations on
    // up-to-date cookie value, the value could have been modified by another tab
    (_a = operations.after) === null || _a === void 0 ? void 0 : _a.call(operations, processedSession || currentSession);
    next();
}
exports.withCookieLockAccess = withCookieLockAccess;
/**
 * Cookie lock strategy allows mitigating issues due to concurrent access to cookie.
 * This issue concerns only chromium browsers and enabling this on firefox increase cookie write failures.
 */
function isCookieLockEnabled() {
    return (0, browserDetection_1.isChromium)();
}
function retryLater(operations, currentNumberOfRetries) {
    (0, timer_1.setTimeout)(function () {
        withCookieLockAccess(operations, currentNumberOfRetries + 1);
    }, exports.LOCK_RETRY_DELAY);
}
function next() {
    ongoingOperations = undefined;
    var nextOperations = bufferedOperations.shift();
    if (nextOperations) {
        withCookieLockAccess(nextOperations);
    }
}
function persistSession(session, options) {
    if (isExpiredState(session)) {
        clearSession(options);
        return;
    }
    session.expire = String((0, timeUtils_1.dateNow)() + sessionConstants_1.SESSION_EXPIRATION_DELAY);
    setSession(session, options);
}
exports.persistSession = persistSession;
function setSession(session, options) {
    (0, cookie_1.setCookie)(exports.SESSION_COOKIE_NAME, toSessionString(session), sessionConstants_1.SESSION_EXPIRATION_DELAY, options);
}
function toSessionString(session) {
    return utils
        .objectEntries(session)
        .map(function (_a) {
        var key = _a[0], value = _a[1];
        return "".concat(key, "=").concat(value);
    })
        .join(SESSION_ENTRY_SEPARATOR);
}
exports.toSessionString = toSessionString;
function retrieveSession() {
    var sessionString = (0, cookie_1.getCookie)(exports.SESSION_COOKIE_NAME);
    var session = {};
    if (isValidSessionString(sessionString)) {
        sessionString.split(SESSION_ENTRY_SEPARATOR).forEach(function (entry) {
            var matches = SESSION_ENTRY_REGEXP.exec(entry);
            if (matches !== null) {
                var key = matches[1], value = matches[2];
                session[key] = value;
            }
        });
    }
    return session;
}
exports.retrieveSession = retrieveSession;
function isValidSessionString(sessionString) {
    return (sessionString !== undefined &&
        (sessionString.indexOf(SESSION_ENTRY_SEPARATOR) !== -1 || SESSION_ENTRY_REGEXP.test(sessionString)));
}
function isExpiredState(session) {
    return utils.isEmptyObject(session);
}
function clearSession(options) {
    (0, cookie_1.setCookie)(exports.SESSION_COOKIE_NAME, '', 0, options);
}

},{"../../browser/cookie":401,"../../browser/timer":404,"../../tools/browserDetection":434,"../../tools/timeUtils":449,"../../tools/utils":451,"./sessionConstants":417}],419:[function(require,module,exports){
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stopSessionManager = exports.startSessionManager = exports.VISIBILITY_CHECK_DELAY = void 0;
var utils = __importStar(require("../../tools/utils"));
var contextHistory_1 = require("../../tools/contextHistory");
var timeUtils_1 = require("../../tools/timeUtils");
var monitor_1 = require("../../tools/monitor");
var addEventListener_1 = require("../../browser/addEventListener");
var oldCookiesMigration_1 = require("./oldCookiesMigration");
var sessionStore_1 = require("./sessionStore");
var sessionConstants_1 = require("./sessionConstants");
exports.VISIBILITY_CHECK_DELAY = utils.ONE_MINUTE;
var SESSION_CONTEXT_TIMEOUT_DELAY = sessionConstants_1.SESSION_TIME_OUT_DELAY;
var stopCallbacks = [];
function startSessionManager(options, productKey, computeSessionState) {
    (0, oldCookiesMigration_1.tryOldCookiesMigration)(options);
    var sessionStore = (0, sessionStore_1.startSessionStore)(options, productKey, computeSessionState);
    stopCallbacks.push(function () { return sessionStore.stop(); });
    var sessionContextHistory = new contextHistory_1.ContextHistory(SESSION_CONTEXT_TIMEOUT_DELAY);
    stopCallbacks.push(function () { return sessionContextHistory.stop(); });
    sessionStore.renewObservable.subscribe(function () {
        sessionContextHistory.add(buildSessionContext(), (0, timeUtils_1.relativeNow)());
    });
    sessionStore.expireObservable.subscribe(function () {
        sessionContextHistory.closeActive((0, timeUtils_1.relativeNow)());
    });
    sessionStore.expandOrRenewSession();
    sessionContextHistory.add(buildSessionContext(), (0, timeUtils_1.clocksOrigin)().relative);
    trackActivity(function () { return sessionStore.expandOrRenewSession(); });
    trackVisibility(function () { return sessionStore.expandSession(); });
    function buildSessionContext() {
        return {
            id: sessionStore.getSession().id,
            trackingType: sessionStore.getSession()[productKey],
        };
    }
    return {
        findActiveSession: function (startTime) { return sessionContextHistory.find(startTime); },
        renewObservable: sessionStore.renewObservable,
        expireObservable: sessionStore.expireObservable,
    };
}
exports.startSessionManager = startSessionManager;
function stopSessionManager() {
    stopCallbacks.forEach(function (e) { return e(); });
    stopCallbacks = [];
}
exports.stopSessionManager = stopSessionManager;
function trackActivity(expandOrRenewSession) {
    var stop = (0, addEventListener_1.addEventListeners)(window, ["click" /* CLICK */, "touchstart" /* TOUCH_START */, "keydown" /* KEY_DOWN */, "scroll" /* SCROLL */], expandOrRenewSession, { capture: true, passive: true }).stop;
    stopCallbacks.push(stop);
}
function trackVisibility(expandSession) {
    var expandSessionWhenVisible = (0, monitor_1.monitor)(function () {
        if (document.visibilityState === 'visible') {
            expandSession();
        }
    });
    var stop = (0, addEventListener_1.addEventListener)(document, "visibilitychange" /* VISIBILITY_CHANGE */, expandSessionWhenVisible).stop;
    stopCallbacks.push(stop);
    var visibilityCheckInterval = setInterval(expandSessionWhenVisible, exports.VISIBILITY_CHECK_DELAY);
    stopCallbacks.push(function () {
        clearInterval(visibilityCheckInterval);
    });
}

},{"../../browser/addEventListener":400,"../../tools/contextHistory":436,"../../tools/monitor":444,"../../tools/timeUtils":449,"../../tools/utils":451,"./oldCookiesMigration":416,"./sessionConstants":417,"./sessionStore":420}],420:[function(require,module,exports){
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.startSessionStore = void 0;
var cookie_1 = require("../../browser/cookie");
var monitor_1 = require("../../tools/monitor");
var observable_1 = require("../../tools/observable");
var timeUtils_1 = require("../../tools/timeUtils");
var utils = __importStar(require("../../tools/utils"));
var sessionConstants_1 = require("./sessionConstants");
var sessionCookieStore_1 = require("./sessionCookieStore");
/**
 * Different session concepts:
 * - tracked, the session has an id and is updated along the user navigation
 * - not tracked, the session does not have an id but it is updated along the user navigation
 * - inactive, no session in store or session expired, waiting for a renew session
 */
function startSessionStore(options, productKey, computeSessionState) {
    var renewObservable = new observable_1.Observable();
    var expireObservable = new observable_1.Observable();
    var watchSessionTimeoutId = setInterval((0, monitor_1.monitor)(watchSession), cookie_1.COOKIE_ACCESS_DELAY);
    var sessionCache = retrieveActiveSession();
    function expandOrRenewSession() {
        var isTracked;
        (0, sessionCookieStore_1.withCookieLockAccess)({
            options: options,
            process: function (cookieSession) {
                var synchronizedSession = synchronizeSession(cookieSession);
                isTracked = expandOrRenewCookie(synchronizedSession);
                return synchronizedSession;
            },
            after: function (cookieSession) {
                if (isTracked && !hasSessionInCache()) {
                    renewSession(cookieSession);
                }
                sessionCache = cookieSession;
            },
        });
    }
    function expandSession() {
        (0, sessionCookieStore_1.withCookieLockAccess)({
            options: options,
            process: function (cookieSession) { return (hasSessionInCache() ? synchronizeSession(cookieSession) : undefined); },
        });
    }
    /**
     * allows two behaviors:
     * - if the session is active, synchronize the session cache without updating the session cookie
     * - if the session is not active, clear the session cookie and expire the session cache
     */
    function watchSession() {
        (0, sessionCookieStore_1.withCookieLockAccess)({
            options: options,
            process: function (cookieSession) { return (!isActiveSession(cookieSession) ? {} : undefined); },
            after: synchronizeSession,
        });
    }
    function synchronizeSession(cookieSession) {
        if (!isActiveSession(cookieSession)) {
            cookieSession = {};
        }
        if (hasSessionInCache()) {
            if (isSessionInCacheOutdated(cookieSession)) {
                expireSession();
            }
            else {
                sessionCache = cookieSession;
            }
        }
        return cookieSession;
    }
    function expandOrRenewCookie(cookieSession) {
        var _a = computeSessionState(cookieSession[productKey]), trackingType = _a.trackingType, isTracked = _a.isTracked;
        cookieSession[productKey] = trackingType;
        if (isTracked && !cookieSession.id) {
            cookieSession.id = utils.generateUUID();
            cookieSession.created = String((0, timeUtils_1.dateNow)());
        }
        return isTracked;
    }
    function hasSessionInCache() {
        return sessionCache[productKey] !== undefined;
    }
    function isSessionInCacheOutdated(cookieSession) {
        return sessionCache.id !== cookieSession.id || sessionCache[productKey] !== cookieSession[productKey];
    }
    function expireSession() {
        sessionCache = {};
        expireObservable.notify();
    }
    function renewSession(cookieSession) {
        sessionCache = cookieSession;
        renewObservable.notify();
    }
    function retrieveActiveSession() {
        var session = (0, sessionCookieStore_1.retrieveSession)();
        if (isActiveSession(session)) {
            return session;
        }
        return {};
    }
    function isActiveSession(session) {
        // created and expire can be undefined for versions which was not storing them
        // these checks could be removed when older versions will not be available/live anymore
        return ((session.created === undefined || (0, timeUtils_1.dateNow)() - Number(session.created) < sessionConstants_1.SESSION_TIME_OUT_DELAY) &&
            (session.expire === undefined || (0, timeUtils_1.dateNow)() < Number(session.expire)));
    }
    return {
        expandOrRenewSession: utils.throttle(expandOrRenewSession, cookie_1.COOKIE_ACCESS_DELAY).throttled,
        expandSession: expandSession,
        getSession: function () { return sessionCache; },
        renewObservable: renewObservable,
        expireObservable: expireObservable,
        stop: function () {
            clearInterval(watchSessionTimeoutId);
        },
    };
}
exports.startSessionStore = startSessionStore;

},{"../../browser/cookie":401,"../../tools/monitor":444,"../../tools/observable":445,"../../tools/timeUtils":449,"../../tools/utils":451,"./sessionConstants":417,"./sessionCookieStore":418}],421:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSyntheticsResultId = exports.getSyntheticsTestId = exports.willSyntheticsInjectRum = exports.SYNTHETICS_INJECTS_RUM_COOKIE_NAME = exports.SYNTHETICS_RESULT_ID_COOKIE_NAME = exports.SYNTHETICS_TEST_ID_COOKIE_NAME = void 0;
var cookie_1 = require("../../browser/cookie");
exports.SYNTHETICS_TEST_ID_COOKIE_NAME = 'datadog-synthetics-public-id';
exports.SYNTHETICS_RESULT_ID_COOKIE_NAME = 'datadog-synthetics-result-id';
exports.SYNTHETICS_INJECTS_RUM_COOKIE_NAME = 'datadog-synthetics-injects-rum';
function willSyntheticsInjectRum() {
    return Boolean(window._DATADOG_SYNTHETICS_INJECTS_RUM || (0, cookie_1.getCookie)(exports.SYNTHETICS_INJECTS_RUM_COOKIE_NAME));
}
exports.willSyntheticsInjectRum = willSyntheticsInjectRum;
function getSyntheticsTestId() {
    var value = window._DATADOG_SYNTHETICS_PUBLIC_ID || (0, cookie_1.getCookie)(exports.SYNTHETICS_TEST_ID_COOKIE_NAME);
    return typeof value === 'string' ? value : undefined;
}
exports.getSyntheticsTestId = getSyntheticsTestId;
function getSyntheticsResultId() {
    var value = window._DATADOG_SYNTHETICS_RESULT_ID || (0, cookie_1.getCookie)(exports.SYNTHETICS_RESULT_ID_COOKIE_NAME);
    return typeof value === 'string' ? value : undefined;
}
exports.getSyntheticsResultId = getSyntheticsResultId;

},{"../../browser/cookie":401}],422:[function(require,module,exports){
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addTelemetryConfiguration = exports.isTelemetryReplicationAllowed = exports.startTelemetry = exports.resetTelemetry = exports.startFakeTelemetry = exports.addTelemetryError = exports.addTelemetryDebug = void 0;
var telemetry_1 = require("./telemetry");
Object.defineProperty(exports, "addTelemetryDebug", { enumerable: true, get: function () { return telemetry_1.addTelemetryDebug; } });
Object.defineProperty(exports, "addTelemetryError", { enumerable: true, get: function () { return telemetry_1.addTelemetryError; } });
Object.defineProperty(exports, "startFakeTelemetry", { enumerable: true, get: function () { return telemetry_1.startFakeTelemetry; } });
Object.defineProperty(exports, "resetTelemetry", { enumerable: true, get: function () { return telemetry_1.resetTelemetry; } });
Object.defineProperty(exports, "startTelemetry", { enumerable: true, get: function () { return telemetry_1.startTelemetry; } });
Object.defineProperty(exports, "isTelemetryReplicationAllowed", { enumerable: true, get: function () { return telemetry_1.isTelemetryReplicationAllowed; } });
Object.defineProperty(exports, "addTelemetryConfiguration", { enumerable: true, get: function () { return telemetry_1.addTelemetryConfiguration; } });
__exportStar(require("./rawTelemetryEvent.types"), exports);
__exportStar(require("./telemetryEvent.types"), exports);

},{"./rawTelemetryEvent.types":423,"./telemetry":424,"./telemetryEvent.types":425}],423:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TelemetryType = void 0;
exports.TelemetryType = {
    log: 'log',
    configuration: 'configuration',
};

},{}],424:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scrubCustomerFrames = exports.formatError = exports.addTelemetryConfiguration = exports.addTelemetryError = exports.addTelemetryDebug = exports.isTelemetryReplicationAllowed = exports.resetTelemetry = exports.startFakeTelemetry = exports.startTelemetry = void 0;
var display_1 = require("../../tools/display");
var error_1 = require("../../tools/error");
var utils_1 = require("../../tools/utils");
var configuration_1 = require("../configuration");
var tracekit_1 = require("../tracekit");
var observable_1 = require("../../tools/observable");
var timeUtils_1 = require("../../tools/timeUtils");
var monitor_1 = require("../../tools/monitor");
var sendToExtension_1 = require("../../tools/sendToExtension");
var rawTelemetryEvent_types_1 = require("./rawTelemetryEvent.types");
var ALLOWED_FRAME_URLS = [
    'https://www.datadoghq-browser-agent.com',
    'https://www.datad0g-browser-agent.com',
    'http://localhost',
    '<anonymous>',
];
var TELEMETRY_EXCLUDED_SITES = [configuration_1.INTAKE_SITE_US1_FED];
var telemetryConfiguration = { maxEventsPerPage: 0, sentEventCount: 0, telemetryEnabled: false, telemetryConfigurationEnabled: false };
var onRawTelemetryEventCollected;
function startTelemetry(telemetryService, configuration) {
    var contextProvider;
    var observable = new observable_1.Observable();
    telemetryConfiguration.telemetryEnabled =
        !(0, utils_1.includes)(TELEMETRY_EXCLUDED_SITES, configuration.site) && (0, utils_1.performDraw)(configuration.telemetrySampleRate);
    telemetryConfiguration.telemetryConfigurationEnabled =
        telemetryConfiguration.telemetryEnabled && (0, utils_1.performDraw)(configuration.telemetryConfigurationSampleRate);
    onRawTelemetryEventCollected = function (rawEvent) {
        if (telemetryConfiguration.telemetryEnabled) {
            var event_1 = toTelemetryEvent(telemetryService, rawEvent);
            observable.notify(event_1);
            (0, sendToExtension_1.sendToExtension)('telemetry', event_1);
        }
    };
    (0, monitor_1.startMonitorErrorCollection)(addTelemetryError);
    (0, utils_1.assign)(telemetryConfiguration, {
        maxEventsPerPage: configuration.maxTelemetryEventsPerPage,
        sentEventCount: 0,
    });
    function toTelemetryEvent(telemetryService, event) {
        return (0, utils_1.combine)({
            type: 'telemetry',
            date: (0, timeUtils_1.timeStampNow)(),
            service: telemetryService,
            version: "4.36.0",
            source: 'browser',
            _dd: {
                format_version: 2,
            },
            telemetry: event,
            experimental_features: (0, utils_1.arrayFrom)((0, configuration_1.getExperimentalFeatures)()),
        }, contextProvider !== undefined ? contextProvider() : {});
    }
    return {
        setContextProvider: function (provider) {
            contextProvider = provider;
        },
        observable: observable,
        enabled: telemetryConfiguration.telemetryEnabled,
    };
}
exports.startTelemetry = startTelemetry;
function startFakeTelemetry() {
    var events = [];
    (0, utils_1.assign)(telemetryConfiguration, {
        maxEventsPerPage: Infinity,
        sentEventCount: 0,
    });
    onRawTelemetryEventCollected = function (event) {
        events.push(event);
    };
    return events;
}
exports.startFakeTelemetry = startFakeTelemetry;
function resetTelemetry() {
    onRawTelemetryEventCollected = undefined;
}
exports.resetTelemetry = resetTelemetry;
/**
 * Avoid mixing telemetry events from different data centers
 * but keep replicating staging events for reliability
 */
function isTelemetryReplicationAllowed(configuration) {
    return configuration.site === configuration_1.INTAKE_SITE_STAGING;
}
exports.isTelemetryReplicationAllowed = isTelemetryReplicationAllowed;
function addTelemetryDebug(message, context) {
    (0, monitor_1.displayIfDebugEnabled)(display_1.ConsoleApiName.debug, message, context);
    addTelemetry((0, utils_1.assign)({
        type: rawTelemetryEvent_types_1.TelemetryType.log,
        message: message,
        status: "debug" /* debug */,
    }, context));
}
exports.addTelemetryDebug = addTelemetryDebug;
function addTelemetryError(e) {
    addTelemetry((0, utils_1.assign)({
        type: rawTelemetryEvent_types_1.TelemetryType.log,
        status: "error" /* error */,
    }, formatError(e)));
}
exports.addTelemetryError = addTelemetryError;
function addTelemetryConfiguration(configuration) {
    if (telemetryConfiguration.telemetryConfigurationEnabled) {
        addTelemetry({
            type: rawTelemetryEvent_types_1.TelemetryType.configuration,
            configuration: configuration,
        });
    }
}
exports.addTelemetryConfiguration = addTelemetryConfiguration;
function addTelemetry(event) {
    if (onRawTelemetryEventCollected && telemetryConfiguration.sentEventCount < telemetryConfiguration.maxEventsPerPage) {
        telemetryConfiguration.sentEventCount += 1;
        onRawTelemetryEventCollected(event);
    }
}
function formatError(e) {
    if (e instanceof Error) {
        var stackTrace = (0, tracekit_1.computeStackTrace)(e);
        return {
            error: {
                kind: stackTrace.name,
                stack: (0, error_1.toStackTraceString)(scrubCustomerFrames(stackTrace)),
            },
            message: stackTrace.message,
        };
    }
    return {
        error: {
            stack: 'Not an instance of error',
        },
        message: "Uncaught ".concat((0, utils_1.jsonStringify)(e)),
    };
}
exports.formatError = formatError;
function scrubCustomerFrames(stackTrace) {
    stackTrace.stack = stackTrace.stack.filter(function (frame) { return !frame.url || ALLOWED_FRAME_URLS.some(function (allowedFrameUrl) { return (0, utils_1.startsWith)(frame.url, allowedFrameUrl); }); });
    return stackTrace;
}
exports.scrubCustomerFrames = scrubCustomerFrames;

},{"../../tools/display":439,"../../tools/error":440,"../../tools/monitor":444,"../../tools/observable":445,"../../tools/sendToExtension":448,"../../tools/timeUtils":449,"../../tools/utils":451,"../configuration":409,"../tracekit":427,"./rawTelemetryEvent.types":423}],425:[function(require,module,exports){
"use strict";
/* eslint-disable */
/**
 * DO NOT MODIFY IT BY HAND. Run `yarn rum-events-format:sync` instead.
 */
Object.defineProperty(exports, "__esModule", { value: true });

},{}],426:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeStackTrace = void 0;
var utils_1 = require("../../tools/utils");
var UNKNOWN_FUNCTION = '?';
/**
 * Computes a stack trace for an exception.
 */
function computeStackTrace(ex) {
    var stack = [];
    var stackProperty = tryToGetString(ex, 'stack');
    var exString = String(ex);
    if (stackProperty && (0, utils_1.startsWith)(stackProperty, exString)) {
        stackProperty = stackProperty.slice(exString.length);
    }
    if (stackProperty) {
        stackProperty.split('\n').forEach(function (line) {
            var stackFrame = parseChromeLine(line) || parseChromeAnonymousLine(line) || parseWinLine(line) || parseGeckoLine(line);
            if (stackFrame) {
                if (!stackFrame.func && stackFrame.line) {
                    stackFrame.func = UNKNOWN_FUNCTION;
                }
                stack.push(stackFrame);
            }
        });
    }
    return {
        message: tryToGetString(ex, 'message'),
        name: tryToGetString(ex, 'name'),
        stack: stack,
    };
}
exports.computeStackTrace = computeStackTrace;
var fileUrl = '((?:file|https?|blob|chrome-extension|native|eval|webpack|<anonymous>|\\w+\\.|\\/).*?)';
var filePosition = '(?::(\\d+))';
var CHROME_LINE_RE = new RegExp("^\\s*at (.*?) ?\\(".concat(fileUrl).concat(filePosition, "?").concat(filePosition, "?\\)?\\s*$"), 'i');
var CHROME_EVAL_RE = new RegExp("\\((\\S*)".concat(filePosition).concat(filePosition, "\\)"));
function parseChromeLine(line) {
    var parts = CHROME_LINE_RE.exec(line);
    if (!parts) {
        return;
    }
    var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
    var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
    var submatch = CHROME_EVAL_RE.exec(parts[2]);
    if (isEval && submatch) {
        // throw out eval line/column and use top-most line/column number
        parts[2] = submatch[1]; // url
        parts[3] = submatch[2]; // line
        parts[4] = submatch[3]; // column
    }
    return {
        args: isNative ? [parts[2]] : [],
        column: parts[4] ? +parts[4] : undefined,
        func: parts[1] || UNKNOWN_FUNCTION,
        line: parts[3] ? +parts[3] : undefined,
        url: !isNative ? parts[2] : undefined,
    };
}
var CHROME_ANONYMOUS_FUNCTION_RE = new RegExp("^\\s*at ?".concat(fileUrl).concat(filePosition, "?").concat(filePosition, "??\\s*$"), 'i');
function parseChromeAnonymousLine(line) {
    var parts = CHROME_ANONYMOUS_FUNCTION_RE.exec(line);
    if (!parts) {
        return;
    }
    return {
        args: [],
        column: parts[3] ? +parts[3] : undefined,
        func: UNKNOWN_FUNCTION,
        line: parts[2] ? +parts[2] : undefined,
        url: parts[1],
    };
}
var WINJS_LINE_RE = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
function parseWinLine(line) {
    var parts = WINJS_LINE_RE.exec(line);
    if (!parts) {
        return;
    }
    return {
        args: [],
        column: parts[4] ? +parts[4] : undefined,
        func: parts[1] || UNKNOWN_FUNCTION,
        line: +parts[3],
        url: parts[2],
    };
}
var GECKO_LINE_RE = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|capacitor|\[native).*?|[^@]*bundle)(?::(\d+))?(?::(\d+))?\s*$/i;
var GECKO_EVAL_RE = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
function parseGeckoLine(line) {
    var parts = GECKO_LINE_RE.exec(line);
    if (!parts) {
        return;
    }
    var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
    var submatch = GECKO_EVAL_RE.exec(parts[3]);
    if (isEval && submatch) {
        // throw out eval line/column and use top-most line number
        parts[3] = submatch[1];
        parts[4] = submatch[2];
        parts[5] = undefined; // no column when eval
    }
    return {
        args: parts[2] ? parts[2].split(',') : [],
        column: parts[5] ? +parts[5] : undefined,
        func: parts[1] || UNKNOWN_FUNCTION,
        line: parts[4] ? +parts[4] : undefined,
        url: parts[3],
    };
}
function tryToGetString(candidate, property) {
    if (typeof candidate !== 'object' || !candidate || !(property in candidate)) {
        return undefined;
    }
    var value = candidate[property];
    return typeof value === 'string' ? value : undefined;
}

},{"../../tools/utils":451}],427:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startUnhandledErrorCollection = exports.computeStackTrace = void 0;
var computeStackTrace_1 = require("./computeStackTrace");
Object.defineProperty(exports, "computeStackTrace", { enumerable: true, get: function () { return computeStackTrace_1.computeStackTrace; } });
var tracekit_1 = require("./tracekit");
Object.defineProperty(exports, "startUnhandledErrorCollection", { enumerable: true, get: function () { return tracekit_1.startUnhandledErrorCollection; } });

},{"./computeStackTrace":426,"./tracekit":428}],428:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startUnhandledErrorCollection = void 0;
var instrumentMethod_1 = require("../../tools/instrumentMethod");
var computeStackTrace_1 = require("./computeStackTrace");
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/;
/**
 * Cross-browser collection of unhandled errors
 *
 * Supports:
 * - Firefox: full stack trace with line numbers, plus column number
 * on top frame; column number is not guaranteed
 * - Opera: full stack trace with line and column numbers
 * - Chrome: full stack trace with line and column numbers
 * - Safari: line and column number for the top frame only; some frames
 * may be missing, and column number is not guaranteed
 * - IE: line and column number for the top frame only; some frames
 * may be missing, and column number is not guaranteed
 *
 * In theory, TraceKit should work on all of the following versions:
 * - IE5.5+ (only 8.0 tested)
 * - Firefox 0.9+ (only 3.5+ tested)
 * - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
 * Exceptions Have Stacktrace to be enabled in opera:config)
 * - Safari 3+ (only 4+ tested)
 * - Chrome 1+ (only 5+ tested)
 * - Konqueror 3.5+ (untested)
 *
 * Tries to catch all unhandled errors and report them to the
 * callback.
 *
 * Callbacks receive a StackTrace object as described in the
 * computeStackTrace docs.
 *
 * @memberof TraceKit
 * @namespace
 */
function startUnhandledErrorCollection(callback) {
    var stopInstrumentingOnError = instrumentOnError(callback).stop;
    var stopInstrumentingOnUnhandledRejection = instrumentUnhandledRejection(callback).stop;
    return {
        stop: function () {
            stopInstrumentingOnError();
            stopInstrumentingOnUnhandledRejection();
        },
    };
}
exports.startUnhandledErrorCollection = startUnhandledErrorCollection;
/**
 * Install a global onerror handler
 */
function instrumentOnError(callback) {
    return (0, instrumentMethod_1.instrumentMethodAndCallOriginal)(window, 'onerror', {
        before: function (message, url, lineNo, columnNo, errorObj) {
            var stack;
            if (errorObj) {
                stack = (0, computeStackTrace_1.computeStackTrace)(errorObj);
                callback(stack, errorObj);
            }
            else {
                var location_1 = {
                    url: url,
                    column: columnNo,
                    line: lineNo,
                };
                var name_1;
                var msg = message;
                if ({}.toString.call(message) === '[object String]') {
                    var groups = ERROR_TYPES_RE.exec(msg);
                    if (groups) {
                        name_1 = groups[1];
                        msg = groups[2];
                    }
                }
                stack = {
                    name: name_1,
                    message: typeof msg === 'string' ? msg : undefined,
                    stack: [location_1],
                };
                callback(stack, message);
            }
        },
    });
}
/**
 * Install a global onunhandledrejection handler
 */
function instrumentUnhandledRejection(callback) {
    return (0, instrumentMethod_1.instrumentMethodAndCallOriginal)(window, 'onunhandledrejection', {
        before: function (e) {
            var reason = e.reason || 'Empty reason';
            var stack = (0, computeStackTrace_1.computeStackTrace)(reason);
            callback(stack, reason);
        },
    });
}

},{"../../tools/instrumentMethod":442,"./computeStackTrace":426}],429:[function(require,module,exports){
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./user.types"), exports);
__exportStar(require("./user"), exports);

},{"./user":430,"./user.types":431}],430:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkUser = exports.sanitizeUser = void 0;
var display_1 = require("../../tools/display");
var utils_1 = require("../../tools/utils");
/**
 * Clone input data and ensure known user properties (id, name, email)
 * are strings, as defined here:
 * https://docs.datadoghq.com/logs/log_configuration/attributes_naming_convention/#user-related-attributes
 */
function sanitizeUser(newUser) {
    // We shallow clone only to prevent mutation of user data.
    var user = (0, utils_1.assign)({}, newUser);
    var keys = ['id', 'name', 'email'];
    keys.forEach(function (key) {
        if (key in user) {
            user[key] = String(user[key]);
        }
    });
    return user;
}
exports.sanitizeUser = sanitizeUser;
/**
 * Simple check to ensure user is valid
 */
function checkUser(newUser) {
    var isValid = (0, utils_1.getType)(newUser) === 'object';
    if (!isValid) {
        display_1.display.error('Unsupported user:', newUser);
    }
    return isValid;
}
exports.checkUser = checkUser;

},{"../../tools/display":439,"../../tools/utils":451}],431:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });

},{}],432:[function(require,module,exports){
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteCookie = exports.setCookie = exports.getCookie = exports.areCookiesAuthorized = exports.PROVIDED_ERROR_MESSAGE_PREFIX = exports.NO_ERROR_STACK_PRESENT_MESSAGE = exports.getFileFromStackTraceString = exports.toStackTraceString = exports.createHandlingStack = exports.computeRawError = exports.ErrorSource = exports.instrumentSetter = exports.instrumentMethodAndCallOriginal = exports.instrumentMethod = exports.getZoneJsOriginalValue = exports.runOnReadyState = exports.sendToExtension = exports.startBatchWithReplica = exports.getEventBridge = exports.canUseEventBridge = exports.Batch = exports.createHttpRequest = exports.SESSION_TIME_OUT_DELAY = exports.stopSessionManager = exports.startSessionManager = exports.Observable = exports.setDebugMode = exports.callMonitored = exports.monitor = exports.monitored = exports.addTelemetryConfiguration = exports.isTelemetryReplicationAllowed = exports.resetTelemetry = exports.startFakeTelemetry = exports.addTelemetryError = exports.addTelemetryDebug = exports.startTelemetry = exports.RawReportType = exports.initReportObservable = exports.makePublicApi = exports.defineGlobal = exports.computeStackTrace = exports.trackRuntimeError = exports.serializeConfiguration = exports.resetExperimentalFeatures = exports.updateExperimentalFeatures = exports.isExperimentalFeatureEnabled = exports.DefaultPrivacyLevel = exports.validateAndBuildConfiguration = exports.buildCookieOptions = void 0;
exports.sanitizeUser = exports.checkUser = exports.getSyntheticsResultId = exports.getSyntheticsTestId = exports.willSyntheticsInjectRum = exports.SESSION_COOKIE_NAME = exports.readBytesFromStream = exports.CLEAR_OLD_CONTEXTS_INTERVAL = exports.ContextHistory = exports.limitModification = exports.createContextManager = exports.catchUserErrors = exports.BoundedBuffer = exports.initConsoleObservable = exports.isPageExitReason = exports.PageExitReason = exports.createPageExitObservable = exports.initFetchObservable = exports.initXhrObservable = exports.COOKIE_ACCESS_DELAY = void 0;
var configuration_1 = require("./domain/configuration");
Object.defineProperty(exports, "buildCookieOptions", { enumerable: true, get: function () { return configuration_1.buildCookieOptions; } });
Object.defineProperty(exports, "validateAndBuildConfiguration", { enumerable: true, get: function () { return configuration_1.validateAndBuildConfiguration; } });
Object.defineProperty(exports, "DefaultPrivacyLevel", { enumerable: true, get: function () { return configuration_1.DefaultPrivacyLevel; } });
Object.defineProperty(exports, "isExperimentalFeatureEnabled", { enumerable: true, get: function () { return configuration_1.isExperimentalFeatureEnabled; } });
Object.defineProperty(exports, "updateExperimentalFeatures", { enumerable: true, get: function () { return configuration_1.updateExperimentalFeatures; } });
Object.defineProperty(exports, "resetExperimentalFeatures", { enumerable: true, get: function () { return configuration_1.resetExperimentalFeatures; } });
Object.defineProperty(exports, "serializeConfiguration", { enumerable: true, get: function () { return configuration_1.serializeConfiguration; } });
var trackRuntimeError_1 = require("./domain/error/trackRuntimeError");
Object.defineProperty(exports, "trackRuntimeError", { enumerable: true, get: function () { return trackRuntimeError_1.trackRuntimeError; } });
var tracekit_1 = require("./domain/tracekit");
Object.defineProperty(exports, "computeStackTrace", { enumerable: true, get: function () { return tracekit_1.computeStackTrace; } });
var init_1 = require("./boot/init");
Object.defineProperty(exports, "defineGlobal", { enumerable: true, get: function () { return init_1.defineGlobal; } });
Object.defineProperty(exports, "makePublicApi", { enumerable: true, get: function () { return init_1.makePublicApi; } });
var reportObservable_1 = require("./domain/report/reportObservable");
Object.defineProperty(exports, "initReportObservable", { enumerable: true, get: function () { return reportObservable_1.initReportObservable; } });
Object.defineProperty(exports, "RawReportType", { enumerable: true, get: function () { return reportObservable_1.RawReportType; } });
var telemetry_1 = require("./domain/telemetry");
Object.defineProperty(exports, "startTelemetry", { enumerable: true, get: function () { return telemetry_1.startTelemetry; } });
Object.defineProperty(exports, "addTelemetryDebug", { enumerable: true, get: function () { return telemetry_1.addTelemetryDebug; } });
Object.defineProperty(exports, "addTelemetryError", { enumerable: true, get: function () { return telemetry_1.addTelemetryError; } });
Object.defineProperty(exports, "startFakeTelemetry", { enumerable: true, get: function () { return telemetry_1.startFakeTelemetry; } });
Object.defineProperty(exports, "resetTelemetry", { enumerable: true, get: function () { return telemetry_1.resetTelemetry; } });
Object.defineProperty(exports, "isTelemetryReplicationAllowed", { enumerable: true, get: function () { return telemetry_1.isTelemetryReplicationAllowed; } });
Object.defineProperty(exports, "addTelemetryConfiguration", { enumerable: true, get: function () { return telemetry_1.addTelemetryConfiguration; } });
var monitor_1 = require("./tools/monitor");
Object.defineProperty(exports, "monitored", { enumerable: true, get: function () { return monitor_1.monitored; } });
Object.defineProperty(exports, "monitor", { enumerable: true, get: function () { return monitor_1.monitor; } });
Object.defineProperty(exports, "callMonitored", { enumerable: true, get: function () { return monitor_1.callMonitored; } });
Object.defineProperty(exports, "setDebugMode", { enumerable: true, get: function () { return monitor_1.setDebugMode; } });
var observable_1 = require("./tools/observable");
Object.defineProperty(exports, "Observable", { enumerable: true, get: function () { return observable_1.Observable; } });
var sessionManager_1 = require("./domain/session/sessionManager");
Object.defineProperty(exports, "startSessionManager", { enumerable: true, get: function () { return sessionManager_1.startSessionManager; } });
// Exposed for tests
Object.defineProperty(exports, "stopSessionManager", { enumerable: true, get: function () { return sessionManager_1.stopSessionManager; } });
var sessionConstants_1 = require("./domain/session/sessionConstants");
Object.defineProperty(exports, "SESSION_TIME_OUT_DELAY", { enumerable: true, get: function () { return sessionConstants_1.SESSION_TIME_OUT_DELAY; } });
var transport_1 = require("./transport");
Object.defineProperty(exports, "createHttpRequest", { enumerable: true, get: function () { return transport_1.createHttpRequest; } });
Object.defineProperty(exports, "Batch", { enumerable: true, get: function () { return transport_1.Batch; } });
Object.defineProperty(exports, "canUseEventBridge", { enumerable: true, get: function () { return transport_1.canUseEventBridge; } });
Object.defineProperty(exports, "getEventBridge", { enumerable: true, get: function () { return transport_1.getEventBridge; } });
Object.defineProperty(exports, "startBatchWithReplica", { enumerable: true, get: function () { return transport_1.startBatchWithReplica; } });
__exportStar(require("./tools/display"), exports);
__exportStar(require("./tools/urlPolyfill"), exports);
__exportStar(require("./tools/timeUtils"), exports);
__exportStar(require("./tools/utils"), exports);
__exportStar(require("./tools/createEventRateLimiter"), exports);
__exportStar(require("./tools/browserDetection"), exports);
var sendToExtension_1 = require("./tools/sendToExtension");
Object.defineProperty(exports, "sendToExtension", { enumerable: true, get: function () { return sendToExtension_1.sendToExtension; } });
var runOnReadyState_1 = require("./tools/runOnReadyState");
Object.defineProperty(exports, "runOnReadyState", { enumerable: true, get: function () { return runOnReadyState_1.runOnReadyState; } });
var getZoneJsOriginalValue_1 = require("./tools/getZoneJsOriginalValue");
Object.defineProperty(exports, "getZoneJsOriginalValue", { enumerable: true, get: function () { return getZoneJsOriginalValue_1.getZoneJsOriginalValue; } });
var instrumentMethod_1 = require("./tools/instrumentMethod");
Object.defineProperty(exports, "instrumentMethod", { enumerable: true, get: function () { return instrumentMethod_1.instrumentMethod; } });
Object.defineProperty(exports, "instrumentMethodAndCallOriginal", { enumerable: true, get: function () { return instrumentMethod_1.instrumentMethodAndCallOriginal; } });
Object.defineProperty(exports, "instrumentSetter", { enumerable: true, get: function () { return instrumentMethod_1.instrumentSetter; } });
var error_1 = require("./tools/error");
Object.defineProperty(exports, "ErrorSource", { enumerable: true, get: function () { return error_1.ErrorSource; } });
Object.defineProperty(exports, "computeRawError", { enumerable: true, get: function () { return error_1.computeRawError; } });
Object.defineProperty(exports, "createHandlingStack", { enumerable: true, get: function () { return error_1.createHandlingStack; } });
Object.defineProperty(exports, "toStackTraceString", { enumerable: true, get: function () { return error_1.toStackTraceString; } });
Object.defineProperty(exports, "getFileFromStackTraceString", { enumerable: true, get: function () { return error_1.getFileFromStackTraceString; } });
Object.defineProperty(exports, "NO_ERROR_STACK_PRESENT_MESSAGE", { enumerable: true, get: function () { return error_1.NO_ERROR_STACK_PRESENT_MESSAGE; } });
Object.defineProperty(exports, "PROVIDED_ERROR_MESSAGE_PREFIX", { enumerable: true, get: function () { return error_1.PROVIDED_ERROR_MESSAGE_PREFIX; } });
var cookie_1 = require("./browser/cookie");
Object.defineProperty(exports, "areCookiesAuthorized", { enumerable: true, get: function () { return cookie_1.areCookiesAuthorized; } });
Object.defineProperty(exports, "getCookie", { enumerable: true, get: function () { return cookie_1.getCookie; } });
Object.defineProperty(exports, "setCookie", { enumerable: true, get: function () { return cookie_1.setCookie; } });
Object.defineProperty(exports, "deleteCookie", { enumerable: true, get: function () { return cookie_1.deleteCookie; } });
Object.defineProperty(exports, "COOKIE_ACCESS_DELAY", { enumerable: true, get: function () { return cookie_1.COOKIE_ACCESS_DELAY; } });
var xhrObservable_1 = require("./browser/xhrObservable");
Object.defineProperty(exports, "initXhrObservable", { enumerable: true, get: function () { return xhrObservable_1.initXhrObservable; } });
var fetchObservable_1 = require("./browser/fetchObservable");
Object.defineProperty(exports, "initFetchObservable", { enumerable: true, get: function () { return fetchObservable_1.initFetchObservable; } });
var pageExitObservable_1 = require("./browser/pageExitObservable");
Object.defineProperty(exports, "createPageExitObservable", { enumerable: true, get: function () { return pageExitObservable_1.createPageExitObservable; } });
Object.defineProperty(exports, "PageExitReason", { enumerable: true, get: function () { return pageExitObservable_1.PageExitReason; } });
Object.defineProperty(exports, "isPageExitReason", { enumerable: true, get: function () { return pageExitObservable_1.isPageExitReason; } });
__exportStar(require("./browser/addEventListener"), exports);
__exportStar(require("./browser/timer"), exports);
var consoleObservable_1 = require("./domain/console/consoleObservable");
Object.defineProperty(exports, "initConsoleObservable", { enumerable: true, get: function () { return consoleObservable_1.initConsoleObservable; } });
var boundedBuffer_1 = require("./tools/boundedBuffer");
Object.defineProperty(exports, "BoundedBuffer", { enumerable: true, get: function () { return boundedBuffer_1.BoundedBuffer; } });
var catchUserErrors_1 = require("./tools/catchUserErrors");
Object.defineProperty(exports, "catchUserErrors", { enumerable: true, get: function () { return catchUserErrors_1.catchUserErrors; } });
var contextManager_1 = require("./tools/contextManager");
Object.defineProperty(exports, "createContextManager", { enumerable: true, get: function () { return contextManager_1.createContextManager; } });
var limitModification_1 = require("./tools/limitModification");
Object.defineProperty(exports, "limitModification", { enumerable: true, get: function () { return limitModification_1.limitModification; } });
var contextHistory_1 = require("./tools/contextHistory");
Object.defineProperty(exports, "ContextHistory", { enumerable: true, get: function () { return contextHistory_1.ContextHistory; } });
Object.defineProperty(exports, "CLEAR_OLD_CONTEXTS_INTERVAL", { enumerable: true, get: function () { return contextHistory_1.CLEAR_OLD_CONTEXTS_INTERVAL; } });
var readBytesFromStream_1 = require("./tools/readBytesFromStream");
Object.defineProperty(exports, "readBytesFromStream", { enumerable: true, get: function () { return readBytesFromStream_1.readBytesFromStream; } });
var sessionCookieStore_1 = require("./domain/session/sessionCookieStore");
Object.defineProperty(exports, "SESSION_COOKIE_NAME", { enumerable: true, get: function () { return sessionCookieStore_1.SESSION_COOKIE_NAME; } });
var syntheticsWorkerValues_1 = require("./domain/synthetics/syntheticsWorkerValues");
Object.defineProperty(exports, "willSyntheticsInjectRum", { enumerable: true, get: function () { return syntheticsWorkerValues_1.willSyntheticsInjectRum; } });
Object.defineProperty(exports, "getSyntheticsTestId", { enumerable: true, get: function () { return syntheticsWorkerValues_1.getSyntheticsTestId; } });
Object.defineProperty(exports, "getSyntheticsResultId", { enumerable: true, get: function () { return syntheticsWorkerValues_1.getSyntheticsResultId; } });
var user_1 = require("./domain/user");
Object.defineProperty(exports, "checkUser", { enumerable: true, get: function () { return user_1.checkUser; } });
Object.defineProperty(exports, "sanitizeUser", { enumerable: true, get: function () { return user_1.sanitizeUser; } });

},{"./boot/init":399,"./browser/addEventListener":400,"./browser/cookie":401,"./browser/fetchObservable":402,"./browser/pageExitObservable":403,"./browser/timer":404,"./browser/xhrObservable":405,"./domain/configuration":409,"./domain/console/consoleObservable":413,"./domain/error/trackRuntimeError":414,"./domain/report/reportObservable":415,"./domain/session/sessionConstants":417,"./domain/session/sessionCookieStore":418,"./domain/session/sessionManager":419,"./domain/synthetics/syntheticsWorkerValues":421,"./domain/telemetry":422,"./domain/tracekit":427,"./domain/user":429,"./tools/boundedBuffer":433,"./tools/browserDetection":434,"./tools/catchUserErrors":435,"./tools/contextHistory":436,"./tools/contextManager":437,"./tools/createEventRateLimiter":438,"./tools/display":439,"./tools/error":440,"./tools/getZoneJsOriginalValue":441,"./tools/instrumentMethod":442,"./tools/limitModification":443,"./tools/monitor":444,"./tools/observable":445,"./tools/readBytesFromStream":446,"./tools/runOnReadyState":447,"./tools/sendToExtension":448,"./tools/timeUtils":449,"./tools/urlPolyfill":450,"./tools/utils":451,"./transport":455}],433:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoundedBuffer = void 0;
var BUFFER_LIMIT = 500;
var BoundedBuffer = /** @class */ (function () {
    function BoundedBuffer() {
        this.buffer = [];
    }
    BoundedBuffer.prototype.add = function (callback) {
        var length = this.buffer.push(callback);
        if (length > BUFFER_LIMIT) {
            this.buffer.splice(0, 1);
        }
    };
    BoundedBuffer.prototype.drain = function () {
        this.buffer.forEach(function (callback) { return callback(); });
        this.buffer.length = 0;
    };
    return BoundedBuffer;
}());
exports.BoundedBuffer = BoundedBuffer;

},{}],434:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isChromium = exports.isIE = void 0;
function isIE() {
    return Boolean(document.documentMode);
}
exports.isIE = isIE;
function isChromium() {
    return !!window.chrome || /HeadlessChrome/.test(window.navigator.userAgent);
}
exports.isChromium = isChromium;

},{}],435:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.catchUserErrors = void 0;
var display_1 = require("./display");
function catchUserErrors(fn, errorMsg) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        try {
            return fn.apply(void 0, args);
        }
        catch (err) {
            display_1.display.error(errorMsg, err);
        }
    };
}
exports.catchUserErrors = catchUserErrors;

},{"./display":439}],436:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextHistory = exports.CLEAR_OLD_CONTEXTS_INTERVAL = void 0;
var timeUtils_1 = require("./timeUtils");
var utils_1 = require("./utils");
var END_OF_TIMES = Infinity;
exports.CLEAR_OLD_CONTEXTS_INTERVAL = utils_1.ONE_MINUTE;
/**
 * Store and keep track of contexts spans. This whole class assumes that contexts are added in
 * chronological order (i.e. all entries have an increasing start time).
 */
var ContextHistory = /** @class */ (function () {
    function ContextHistory(expireDelay) {
        var _this = this;
        this.expireDelay = expireDelay;
        this.entries = [];
        this.clearOldContextsInterval = setInterval(function () { return _this.clearOldContexts(); }, exports.CLEAR_OLD_CONTEXTS_INTERVAL);
    }
    /**
     * Add a context to the history associated with a start time. Returns a reference to this newly
     * added entry that can be removed or closed.
     */
    ContextHistory.prototype.add = function (context, startTime) {
        var _this = this;
        var entry = {
            context: context,
            startTime: startTime,
            endTime: END_OF_TIMES,
            remove: function () {
                var index = _this.entries.indexOf(entry);
                if (index >= 0) {
                    _this.entries.splice(index, 1);
                }
            },
            close: function (endTime) {
                entry.endTime = endTime;
            },
        };
        this.entries.unshift(entry);
        return entry;
    };
    /**
     * Return the latest context that was active during `startTime`, or the currently active context
     * if no `startTime` is provided. This method assumes that entries are not overlapping.
     */
    ContextHistory.prototype.find = function (startTime) {
        if (startTime === void 0) { startTime = END_OF_TIMES; }
        for (var _i = 0, _a = this.entries; _i < _a.length; _i++) {
            var entry = _a[_i];
            if (entry.startTime <= startTime) {
                if (startTime <= entry.endTime) {
                    return entry.context;
                }
                break;
            }
        }
    };
    /**
     * Helper function to close the currently active context, if any. This method assumes that entries
     * are not overlapping.
     */
    ContextHistory.prototype.closeActive = function (endTime) {
        var latestEntry = this.entries[0];
        if (latestEntry && latestEntry.endTime === END_OF_TIMES) {
            latestEntry.close(endTime);
        }
    };
    /**
     * Return all contexts that were active during `startTime`, or all currently active contexts if no
     * `startTime` is provided.
     */
    ContextHistory.prototype.findAll = function (startTime) {
        if (startTime === void 0) { startTime = END_OF_TIMES; }
        return this.entries
            .filter(function (entry) { return entry.startTime <= startTime && startTime <= entry.endTime; })
            .map(function (entry) { return entry.context; });
    };
    /**
     * Remove all entries from this collection.
     */
    ContextHistory.prototype.reset = function () {
        this.entries = [];
    };
    /**
     * Stop internal garbage collection of past entries.
     */
    ContextHistory.prototype.stop = function () {
        clearInterval(this.clearOldContextsInterval);
    };
    ContextHistory.prototype.clearOldContexts = function () {
        var oldTimeThreshold = (0, timeUtils_1.relativeNow)() - this.expireDelay;
        while (this.entries.length > 0 && this.entries[this.entries.length - 1].endTime < oldTimeThreshold) {
            this.entries.pop();
        }
    };
    return ContextHistory;
}());
exports.ContextHistory = ContextHistory;

},{"./timeUtils":449,"./utils":451}],437:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createContextManager = void 0;
var utils_1 = require("./utils");
function createContextManager(computeBytesCountImpl) {
    if (computeBytesCountImpl === void 0) { computeBytesCountImpl = utils_1.computeBytesCount; }
    var context = {};
    var bytesCountCache;
    return {
        getBytesCount: function () {
            if (bytesCountCache === undefined) {
                bytesCountCache = computeBytesCountImpl((0, utils_1.jsonStringify)(context));
            }
            return bytesCountCache;
        },
        /** @deprecated use getContext instead */
        get: function () { return context; },
        /** @deprecated use setContextProperty instead */
        add: function (key, value) {
            context[key] = value;
            bytesCountCache = undefined;
        },
        /** @deprecated renamed to removeContextProperty */
        remove: function (key) {
            delete context[key];
            bytesCountCache = undefined;
        },
        /** @deprecated use setContext instead */
        set: function (newContext) {
            context = newContext;
            bytesCountCache = undefined;
        },
        getContext: function () { return (0, utils_1.deepClone)(context); },
        setContext: function (newContext) {
            context = (0, utils_1.deepClone)(newContext);
            bytesCountCache = undefined;
        },
        setContextProperty: function (key, property) {
            context[key] = (0, utils_1.deepClone)(property);
            bytesCountCache = undefined;
        },
        removeContextProperty: function (key) {
            delete context[key];
            bytesCountCache = undefined;
        },
        clearContext: function () {
            context = {};
            bytesCountCache = undefined;
        },
    };
}
exports.createContextManager = createContextManager;

},{"./utils":451}],438:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEventRateLimiter = void 0;
var timer_1 = require("../browser/timer");
var error_1 = require("./error");
var timeUtils_1 = require("./timeUtils");
var utils_1 = require("./utils");
function createEventRateLimiter(eventType, limit, onLimitReached) {
    var eventCount = 0;
    var allowNextEvent = false;
    return {
        isLimitReached: function () {
            if (eventCount === 0) {
                (0, timer_1.setTimeout)(function () {
                    eventCount = 0;
                }, utils_1.ONE_MINUTE);
            }
            eventCount += 1;
            if (eventCount <= limit || allowNextEvent) {
                allowNextEvent = false;
                return false;
            }
            if (eventCount === limit + 1) {
                allowNextEvent = true;
                try {
                    onLimitReached({
                        message: "Reached max number of ".concat(eventType, "s by minute: ").concat(limit),
                        source: error_1.ErrorSource.AGENT,
                        startClocks: (0, timeUtils_1.clocksNow)(),
                    });
                }
                finally {
                    allowNextEvent = false;
                }
            }
            return true;
        },
    };
}
exports.createEventRateLimiter = createEventRateLimiter;

},{"../browser/timer":404,"./error":440,"./timeUtils":449,"./utils":451}],439:[function(require,module,exports){
"use strict";
/* eslint-disable no-console, local-rules/disallow-side-effects */
/**
 * Keep references on console methods to avoid triggering patched behaviors
 *
 * NB: in some setup, console could already be patched by another SDK.
 * In this case, some display messages can be sent by the other SDK
 * but we should be safe from infinite loop nonetheless.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.display = exports.ConsoleApiName = void 0;
exports.ConsoleApiName = {
    log: 'log',
    debug: 'debug',
    info: 'info',
    warn: 'warn',
    error: 'error',
};
var display = function (api) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (!Object.prototype.hasOwnProperty.call(exports.ConsoleApiName, api)) {
        api = exports.ConsoleApiName.log;
    }
    exports.display[api].apply(exports.display, args);
};
exports.display = display;
exports.display.debug = console.debug.bind(console);
exports.display.log = console.log.bind(console);
exports.display.info = console.info.bind(console);
exports.display.warn = console.warn.bind(console);
exports.display.error = console.error.bind(console);

},{}],440:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flattenErrorCauses = exports.createHandlingStack = exports.formatErrorMessage = exports.getFileFromStackTraceString = exports.toStackTraceString = exports.computeRawError = exports.ErrorSource = exports.PROVIDED_ERROR_MESSAGE_PREFIX = exports.NO_ERROR_STACK_PRESENT_MESSAGE = void 0;
var tracekit_1 = require("../domain/tracekit");
var monitor_1 = require("./monitor");
var utils_1 = require("./utils");
exports.NO_ERROR_STACK_PRESENT_MESSAGE = 'No stack, consider using an instance of Error';
exports.PROVIDED_ERROR_MESSAGE_PREFIX = 'Provided';
exports.ErrorSource = {
    AGENT: 'agent',
    CONSOLE: 'console',
    CUSTOM: 'custom',
    LOGGER: 'logger',
    NETWORK: 'network',
    SOURCE: 'source',
    REPORT: 'report',
};
function computeRawError(_a) {
    var stackTrace = _a.stackTrace, originalError = _a.originalError, handlingStack = _a.handlingStack, startClocks = _a.startClocks, nonErrorPrefix = _a.nonErrorPrefix, source = _a.source, handling = _a.handling;
    if (!stackTrace || (stackTrace.message === undefined && !(originalError instanceof Error))) {
        return {
            startClocks: startClocks,
            source: source,
            handling: handling,
            originalError: originalError,
            message: "".concat(nonErrorPrefix, " ").concat((0, utils_1.jsonStringify)(originalError)),
            stack: exports.NO_ERROR_STACK_PRESENT_MESSAGE,
            handlingStack: handlingStack,
            type: stackTrace && stackTrace.name,
        };
    }
    return {
        startClocks: startClocks,
        source: source,
        handling: handling,
        originalError: originalError,
        message: stackTrace.message || 'Empty message',
        stack: toStackTraceString(stackTrace),
        handlingStack: handlingStack,
        type: stackTrace.name,
        causes: flattenErrorCauses(originalError, source),
    };
}
exports.computeRawError = computeRawError;
function toStackTraceString(stack) {
    var result = formatErrorMessage(stack);
    stack.stack.forEach(function (frame) {
        var func = frame.func === '?' ? '<anonymous>' : frame.func;
        var args = frame.args && frame.args.length > 0 ? "(".concat(frame.args.join(', '), ")") : '';
        var line = frame.line ? ":".concat(frame.line) : '';
        var column = frame.line && frame.column ? ":".concat(frame.column) : '';
        result += "\n  at ".concat(func).concat(args, " @ ").concat(frame.url).concat(line).concat(column);
    });
    return result;
}
exports.toStackTraceString = toStackTraceString;
function getFileFromStackTraceString(stack) {
    var _a;
    return (_a = /@ (.+)/.exec(stack)) === null || _a === void 0 ? void 0 : _a[1];
}
exports.getFileFromStackTraceString = getFileFromStackTraceString;
function formatErrorMessage(stack) {
    return "".concat(stack.name || 'Error', ": ").concat(stack.message);
}
exports.formatErrorMessage = formatErrorMessage;
/**
 Creates a stacktrace without SDK internal frames.
 
 Constraints:
 - Has to be called at the utmost position of the call stack.
 - No monitored function should encapsulate it, that is why we need to use callMonitored inside it.
 */
function createHandlingStack() {
    /**
     * Skip the two internal frames:
     * - SDK API (console.error, ...)
     * - this function
     * in order to keep only the user calls
     */
    var internalFramesToSkip = 2;
    var error = new Error();
    var formattedStack;
    // IE needs to throw the error to fill in the stack trace
    if (!error.stack) {
        try {
            throw error;
        }
        catch (e) {
            (0, utils_1.noop)();
        }
    }
    (0, monitor_1.callMonitored)(function () {
        var stackTrace = (0, tracekit_1.computeStackTrace)(error);
        stackTrace.stack = stackTrace.stack.slice(internalFramesToSkip);
        formattedStack = toStackTraceString(stackTrace);
    });
    return formattedStack;
}
exports.createHandlingStack = createHandlingStack;
function flattenErrorCauses(error, parentSource) {
    var currentError = error;
    var causes = [];
    while ((currentError === null || currentError === void 0 ? void 0 : currentError.cause) instanceof Error && causes.length < 10) {
        var stackTrace = (0, tracekit_1.computeStackTrace)(currentError.cause);
        causes.push({
            message: currentError.cause.message,
            source: parentSource,
            type: stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.name,
            stack: stackTrace && toStackTraceString(stackTrace),
        });
        currentError = currentError.cause;
    }
    return causes.length ? causes : undefined;
}
exports.flattenErrorCauses = flattenErrorCauses;

},{"../domain/tracekit":427,"./monitor":444,"./utils":451}],441:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getZoneJsOriginalValue = void 0;
/**
 * Gets the original value for a DOM API that was potentially patched by Zone.js.
 *
 * Zone.js[1] is a library that patches a bunch of JS and DOM APIs. It usually stores the original
 * value of the patched functions/constructors/methods in a hidden property prefixed by
 * __zone_symbol__.
 *
 * In multiple occasions, we observed that Zone.js is the culprit of important issues leading to
 * browser resource exhaustion (memory leak, high CPU usage). This method is used as a workaround to
 * use the original DOM API instead of the one patched by Zone.js.
 *
 * [1]: https://github.com/angular/angular/tree/main/packages/zone.js
 */
function getZoneJsOriginalValue(target, name) {
    var browserWindow = window;
    var original;
    if (browserWindow.Zone && typeof browserWindow.Zone.__symbol__ === 'function') {
        original = target[browserWindow.Zone.__symbol__(name)];
    }
    if (!original) {
        original = target[name];
    }
    return original;
}
exports.getZoneJsOriginalValue = getZoneJsOriginalValue;

},{}],442:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.instrumentSetter = exports.instrumentMethodAndCallOriginal = exports.instrumentMethod = void 0;
var timer_1 = require("../browser/timer");
var monitor_1 = require("./monitor");
var utils_1 = require("./utils");
function instrumentMethod(object, method, instrumentationFactory) {
    var original = object[method];
    var instrumentation = instrumentationFactory(original);
    var instrumentationWrapper = function () {
        if (typeof instrumentation !== 'function') {
            return undefined;
        }
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return instrumentation.apply(this, arguments);
    };
    object[method] = instrumentationWrapper;
    return {
        stop: function () {
            if (object[method] === instrumentationWrapper) {
                object[method] = original;
            }
            else {
                instrumentation = original;
            }
        },
    };
}
exports.instrumentMethod = instrumentMethod;
function instrumentMethodAndCallOriginal(object, method, _a) {
    var before = _a.before, after = _a.after;
    return instrumentMethod(object, method, function (original) {
        return function () {
            var args = arguments;
            var result;
            if (before) {
                (0, monitor_1.callMonitored)(before, this, args);
            }
            if (typeof original === 'function') {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-call
                result = original.apply(this, args);
            }
            if (after) {
                (0, monitor_1.callMonitored)(after, this, args);
            }
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return result;
        };
    });
}
exports.instrumentMethodAndCallOriginal = instrumentMethodAndCallOriginal;
function instrumentSetter(object, property, after) {
    var originalDescriptor = Object.getOwnPropertyDescriptor(object, property);
    if (!originalDescriptor || !originalDescriptor.set || !originalDescriptor.configurable) {
        return { stop: utils_1.noop };
    }
    var instrumentation = function (thisObject, value) {
        // put hooked setter into event loop to avoid of set latency
        (0, timer_1.setTimeout)(function () {
            after(thisObject, value);
        }, 0);
    };
    var instrumentationWrapper = function (value) {
        originalDescriptor.set.call(this, value);
        instrumentation(this, value);
    };
    Object.defineProperty(object, property, {
        set: instrumentationWrapper,
    });
    return {
        stop: function () {
            var _a;
            if (((_a = Object.getOwnPropertyDescriptor(object, property)) === null || _a === void 0 ? void 0 : _a.set) === instrumentationWrapper) {
                Object.defineProperty(object, property, originalDescriptor);
            }
            else {
                instrumentation = utils_1.noop;
            }
        },
    };
}
exports.instrumentSetter = instrumentSetter;

},{"../browser/timer":404,"./monitor":444,"./utils":451}],443:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.limitModification = void 0;
var utils_1 = require("./utils");
/**
 * Current limitation:
 * - field path do not support array, 'a.b.c' only
 */
function limitModification(object, modifiableFieldPaths, modifier) {
    var clone = (0, utils_1.deepClone)(object);
    var result = modifier(clone);
    modifiableFieldPaths.forEach(function (path) {
        var originalValue = get(object, path);
        var newValue = get(clone, path);
        var originalType = (0, utils_1.getType)(originalValue);
        var newType = (0, utils_1.getType)(newValue);
        if (newType === originalType) {
            set(object, path, newValue);
        }
        else if (originalType === 'object' && (newType === 'undefined' || newType === 'null')) {
            set(object, path, {});
        }
    });
    return result;
}
exports.limitModification = limitModification;
function get(object, path) {
    var current = object;
    for (var _i = 0, _a = path.split('.'); _i < _a.length; _i++) {
        var field = _a[_i];
        if (!isValidObjectContaining(current, field)) {
            return;
        }
        current = current[field];
    }
    return current;
}
function set(object, path, value) {
    var current = object;
    var fields = path.split('.');
    for (var i = 0; i < fields.length; i += 1) {
        var field = fields[i];
        if (!isValidObjectContaining(current, field)) {
            return;
        }
        if (i !== fields.length - 1) {
            current = current[field];
        }
        else {
            current[field] = value;
        }
    }
}
function isValidObjectContaining(object, field) {
    return typeof object === 'object' && object !== null && Object.prototype.hasOwnProperty.call(object, field);
}

},{"./utils":451}],444:[function(require,module,exports){
"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.displayIfDebugEnabled = exports.callMonitored = exports.monitor = exports.monitored = exports.resetMonitor = exports.setDebugMode = exports.startMonitorErrorCollection = void 0;
var display_1 = require("./display");
var onMonitorErrorCollected;
var debugMode = false;
function startMonitorErrorCollection(newOnMonitorErrorCollected) {
    onMonitorErrorCollected = newOnMonitorErrorCollected;
}
exports.startMonitorErrorCollection = startMonitorErrorCollection;
function setDebugMode(newDebugMode) {
    debugMode = newDebugMode;
}
exports.setDebugMode = setDebugMode;
function resetMonitor() {
    onMonitorErrorCollected = undefined;
    debugMode = false;
}
exports.resetMonitor = resetMonitor;
function monitored(_, __, descriptor) {
    var originalMethod = descriptor.value;
    descriptor.value = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var decorated = onMonitorErrorCollected ? monitor(originalMethod) : originalMethod;
        return decorated.apply(this, args);
    };
}
exports.monitored = monitored;
function monitor(fn) {
    return function () {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return callMonitored(fn, this, arguments);
    }; // consider output type has input type
}
exports.monitor = monitor;
function callMonitored(fn, context, args) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return fn.apply(context, args);
    }
    catch (e) {
        displayIfDebugEnabled(display_1.ConsoleApiName.error, e);
        if (onMonitorErrorCollected) {
            try {
                onMonitorErrorCollected(e);
            }
            catch (e) {
                displayIfDebugEnabled(display_1.ConsoleApiName.error, e);
            }
        }
    }
}
exports.callMonitored = callMonitored;
function displayIfDebugEnabled(api) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (debugMode) {
        display_1.display.apply(void 0, __spreadArray([api, '[MONITOR]'], args, false));
    }
}
exports.displayIfDebugEnabled = displayIfDebugEnabled;

},{"./display":439}],445:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeObservables = exports.Observable = void 0;
var Observable = /** @class */ (function () {
    function Observable(onFirstSubscribe) {
        this.onFirstSubscribe = onFirstSubscribe;
        this.observers = [];
    }
    Observable.prototype.subscribe = function (f) {
        var _this = this;
        if (!this.observers.length && this.onFirstSubscribe) {
            this.onLastUnsubscribe = this.onFirstSubscribe() || undefined;
        }
        this.observers.push(f);
        return {
            unsubscribe: function () {
                _this.observers = _this.observers.filter(function (other) { return f !== other; });
                if (!_this.observers.length && _this.onLastUnsubscribe) {
                    _this.onLastUnsubscribe();
                }
            },
        };
    };
    Observable.prototype.notify = function (data) {
        this.observers.forEach(function (observer) { return observer(data); });
    };
    return Observable;
}());
exports.Observable = Observable;
function mergeObservables() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    var globalObservable = new Observable(function () {
        var subscriptions = observables.map(function (observable) {
            return observable.subscribe(function (data) { return globalObservable.notify(data); });
        });
        return function () { return subscriptions.forEach(function (subscription) { return subscription.unsubscribe(); }); };
    });
    return globalObservable;
}
exports.mergeObservables = mergeObservables;

},{}],446:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.readBytesFromStream = void 0;
var monitor_1 = require("./monitor");
var utils_1 = require("./utils");
/**
 * Read bytes from a ReadableStream until at least `limit` bytes have been read (or until the end of
 * the stream). The callback is invoked with the at most `limit` bytes, and indicates that the limit
 * has been exceeded if more bytes were available.
 */
function readBytesFromStream(stream, callback, options) {
    var reader = stream.getReader();
    var chunks = [];
    var readBytesCount = 0;
    readMore();
    function readMore() {
        reader.read().then((0, monitor_1.monitor)(function (result) {
            if (result.done) {
                onDone();
                return;
            }
            if (options.collectStreamBody) {
                chunks.push(result.value);
            }
            readBytesCount += result.value.length;
            if (readBytesCount > options.bytesLimit) {
                onDone();
            }
            else {
                readMore();
            }
        }), (0, monitor_1.monitor)(function (error) { return callback(error); }));
    }
    function onDone() {
        reader.cancel().catch(
        // we don't care if cancel fails, but we still need to catch the error to avoid reporting it
        // as an unhandled rejection
        utils_1.noop);
        var bytes;
        var limitExceeded;
        if (options.collectStreamBody) {
            var completeBuffer_1;
            if (chunks.length === 1) {
                // optimization: if the response is small enough to fit in a single buffer (provided by the browser), just
                // use it directly.
                completeBuffer_1 = chunks[0];
            }
            else {
                // else, we need to copy buffers into a larger buffer to concatenate them.
                completeBuffer_1 = new Uint8Array(readBytesCount);
                var offset_1 = 0;
                chunks.forEach(function (chunk) {
                    completeBuffer_1.set(chunk, offset_1);
                    offset_1 += chunk.length;
                });
            }
            bytes = completeBuffer_1.slice(0, options.bytesLimit);
            limitExceeded = completeBuffer_1.length > options.bytesLimit;
        }
        callback(undefined, bytes, limitExceeded);
    }
}
exports.readBytesFromStream = readBytesFromStream;

},{"./monitor":444,"./utils":451}],447:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.runOnReadyState = void 0;
var addEventListener_1 = require("../browser/addEventListener");
function runOnReadyState(expectedReadyState, callback) {
    if (document.readyState === expectedReadyState || document.readyState === 'complete') {
        callback();
    }
    else {
        var eventName = expectedReadyState === 'complete' ? "load" /* LOAD */ : "DOMContentLoaded" /* DOM_CONTENT_LOADED */;
        (0, addEventListener_1.addEventListener)(window, eventName, callback, { once: true });
    }
}
exports.runOnReadyState = runOnReadyState;

},{"../browser/addEventListener":400}],448:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendToExtension = void 0;
function sendToExtension(type, payload) {
    var callback = window.__ddBrowserSdkExtensionCallback;
    if (callback) {
        callback({ type: type, payload: payload });
    }
}
exports.sendToExtension = sendToExtension;

},{}],449:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetNavigationStart = exports.looksLikeRelativeTime = exports.getTimeStamp = exports.getRelativeTime = exports.addDuration = exports.elapsed = exports.clocksOrigin = exports.clocksNow = exports.relativeNow = exports.timeStampNow = exports.dateNow = exports.toServerDuration = exports.currentDrift = exports.relativeToClocks = void 0;
var utils_1 = require("./utils");
function relativeToClocks(relative) {
    return { relative: relative, timeStamp: getCorrectedTimeStamp(relative) };
}
exports.relativeToClocks = relativeToClocks;
function getCorrectedTimeStamp(relativeTime) {
    var correctedOrigin = (dateNow() - performance.now());
    // apply correction only for positive drift
    if (correctedOrigin > getNavigationStart()) {
        return Math.round(addDuration(correctedOrigin, relativeTime));
    }
    return getTimeStamp(relativeTime);
}
function currentDrift() {
    return Math.round(dateNow() - addDuration(getNavigationStart(), performance.now()));
}
exports.currentDrift = currentDrift;
function toServerDuration(duration) {
    if (!(0, utils_1.isNumber)(duration)) {
        return duration;
    }
    return (0, utils_1.round)(duration * 1e6, 0);
}
exports.toServerDuration = toServerDuration;
function dateNow() {
    // Do not use `Date.now` because sometimes websites are wrongly "polyfilling" it. For example, we
    // had some users using a very old version of `datejs`, which patched `Date.now` to return a Date
    // instance instead of a timestamp[1]. Those users are unlikely to fix this, so let's handle this
    // case ourselves.
    // [1]: https://github.com/datejs/Datejs/blob/97f5c7c58c5bc5accdab8aa7602b6ac56462d778/src/core-debug.js#L14-L16
    return new Date().getTime();
}
exports.dateNow = dateNow;
function timeStampNow() {
    return dateNow();
}
exports.timeStampNow = timeStampNow;
function relativeNow() {
    return performance.now();
}
exports.relativeNow = relativeNow;
function clocksNow() {
    return { relative: relativeNow(), timeStamp: timeStampNow() };
}
exports.clocksNow = clocksNow;
function clocksOrigin() {
    return { relative: 0, timeStamp: getNavigationStart() };
}
exports.clocksOrigin = clocksOrigin;
function elapsed(start, end) {
    return (end - start);
}
exports.elapsed = elapsed;
function addDuration(a, b) {
    return a + b;
}
exports.addDuration = addDuration;
/**
 * Get the time since the navigation was started.
 *
 * Note: this does not use `performance.timeOrigin` because it doesn't seem to reflect the actual
 * time on which the navigation has started: it may be much farther in the past, at least in Firefox 71.
 * Related issue in Firefox: https://bugzilla.mozilla.org/show_bug.cgi?id=1429926
 */
function getRelativeTime(timestamp) {
    return (timestamp - getNavigationStart());
}
exports.getRelativeTime = getRelativeTime;
function getTimeStamp(relativeTime) {
    return Math.round(addDuration(getNavigationStart(), relativeTime));
}
exports.getTimeStamp = getTimeStamp;
function looksLikeRelativeTime(time) {
    return time < utils_1.ONE_YEAR;
}
exports.looksLikeRelativeTime = looksLikeRelativeTime;
/**
 * Navigation start slightly change on some rare cases
 */
var navigationStart;
function getNavigationStart() {
    if (navigationStart === undefined) {
        navigationStart = performance.timing.navigationStart;
    }
    return navigationStart;
}
function resetNavigationStart() {
    navigationStart = undefined;
}
exports.resetNavigationStart = resetNavigationStart;

},{"./utils":451}],450:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildUrl = exports.getHash = exports.getSearch = exports.getPathName = exports.getOrigin = exports.haveSameOrigin = exports.isValidUrl = exports.normalizeUrl = void 0;
var utils_1 = require("./utils");
function normalizeUrl(url) {
    return buildUrl(url, (0, utils_1.getLocationOrigin)()).href;
}
exports.normalizeUrl = normalizeUrl;
function isValidUrl(url) {
    try {
        return !!buildUrl(url);
    }
    catch (_a) {
        return false;
    }
}
exports.isValidUrl = isValidUrl;
function haveSameOrigin(url1, url2) {
    return getOrigin(url1) === getOrigin(url2);
}
exports.haveSameOrigin = haveSameOrigin;
function getOrigin(url) {
    return (0, utils_1.getLinkElementOrigin)(buildUrl(url));
}
exports.getOrigin = getOrigin;
function getPathName(url) {
    var pathname = buildUrl(url).pathname;
    return pathname[0] === '/' ? pathname : "/".concat(pathname);
}
exports.getPathName = getPathName;
function getSearch(url) {
    return buildUrl(url).search;
}
exports.getSearch = getSearch;
function getHash(url) {
    return buildUrl(url).hash;
}
exports.getHash = getHash;
function buildUrl(url, base) {
    if (checkURLSupported()) {
        return base !== undefined ? new URL(url, base) : new URL(url);
    }
    if (base === undefined && !/:/.test(url)) {
        throw new Error("Invalid URL: '".concat(url, "'"));
    }
    var doc = document;
    var anchorElement = doc.createElement('a');
    if (base !== undefined) {
        doc = document.implementation.createHTMLDocument('');
        var baseElement = doc.createElement('base');
        baseElement.href = base;
        doc.head.appendChild(baseElement);
        doc.body.appendChild(anchorElement);
    }
    anchorElement.href = url;
    return anchorElement;
}
exports.buildUrl = buildUrl;
var isURLSupported;
function checkURLSupported() {
    if (isURLSupported !== undefined) {
        return isURLSupported;
    }
    try {
        var url = new URL('http://test/path');
        isURLSupported = url.href === 'http://test/path';
        return isURLSupported;
    }
    catch (_a) {
        isURLSupported = false;
    }
    return isURLSupported;
}

},{"./utils":451}],451:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tryToClone = exports.computeBytesCount = exports.cssEscape = exports.matchList = exports.isMatchOption = exports.removeDuplicates = exports.requestIdleCallback = exports.combine = exports.deepClone = exports.mergeInto = exports.getType = exports.elementMatches = exports.safeTruncate = exports.findCommaSeparatedValue = exports.getLinkElementOrigin = exports.getLocationOrigin = exports.getGlobalObject = exports.endsWith = exports.startsWith = exports.mapValues = exports.isEmptyObject = exports.objectEntries = exports.objectHasValue = exports.objectValues = exports.isNumber = exports.isPercentage = exports.findLast = exports.find = exports.arrayFrom = exports.includes = exports.jsonStringify = exports.noop = exports.round = exports.performDraw = exports.generateUUID = exports.shallowClone = exports.assign = exports.throttle = exports.ONE_MEBI_BYTE = exports.ONE_KIBI_BYTE = exports.ONE_YEAR = exports.ONE_DAY = exports.ONE_HOUR = exports.ONE_MINUTE = exports.ONE_SECOND = void 0;
var timer_1 = require("../browser/timer");
var display_1 = require("./display");
var monitor_1 = require("./monitor");
exports.ONE_SECOND = 1000;
exports.ONE_MINUTE = 60 * exports.ONE_SECOND;
exports.ONE_HOUR = 60 * exports.ONE_MINUTE;
exports.ONE_DAY = 24 * exports.ONE_HOUR;
exports.ONE_YEAR = 365 * exports.ONE_DAY;
exports.ONE_KIBI_BYTE = 1024;
exports.ONE_MEBI_BYTE = 1024 * exports.ONE_KIBI_BYTE;
// use lodash API
function throttle(fn, wait, options) {
    var needLeadingExecution = options && options.leading !== undefined ? options.leading : true;
    var needTrailingExecution = options && options.trailing !== undefined ? options.trailing : true;
    var inWaitPeriod = false;
    var pendingExecutionWithParameters;
    var pendingTimeoutId;
    return {
        throttled: function () {
            var parameters = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                parameters[_i] = arguments[_i];
            }
            if (inWaitPeriod) {
                pendingExecutionWithParameters = parameters;
                return;
            }
            if (needLeadingExecution) {
                fn.apply(void 0, parameters);
            }
            else {
                pendingExecutionWithParameters = parameters;
            }
            inWaitPeriod = true;
            pendingTimeoutId = (0, timer_1.setTimeout)(function () {
                if (needTrailingExecution && pendingExecutionWithParameters) {
                    fn.apply(void 0, pendingExecutionWithParameters);
                }
                inWaitPeriod = false;
                pendingExecutionWithParameters = undefined;
            }, wait);
        },
        cancel: function () {
            (0, timer_1.clearTimeout)(pendingTimeoutId);
            inWaitPeriod = false;
            pendingExecutionWithParameters = undefined;
        },
    };
}
exports.throttle = throttle;
function assign(target) {
    var toAssign = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        toAssign[_i - 1] = arguments[_i];
    }
    toAssign.forEach(function (source) {
        for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    });
    return target;
}
exports.assign = assign;
function shallowClone(object) {
    return assign({}, object);
}
exports.shallowClone = shallowClone;
/**
 * UUID v4
 * from https://gist.github.com/jed/982883
 */
function generateUUID(placeholder) {
    return placeholder
        ? // eslint-disable-next-line  no-bitwise
            (parseInt(placeholder, 10) ^ ((Math.random() * 16) >> (parseInt(placeholder, 10) / 4))).toString(16)
        : "".concat(1e7, "-").concat(1e3, "-").concat(4e3, "-").concat(8e3, "-").concat(1e11).replace(/[018]/g, generateUUID);
}
exports.generateUUID = generateUUID;
/**
 * Return true if the draw is successful
 * @param threshold between 0 and 100
 */
function performDraw(threshold) {
    return threshold !== 0 && Math.random() * 100 <= threshold;
}
exports.performDraw = performDraw;
function round(num, decimals) {
    return +num.toFixed(decimals);
}
exports.round = round;
// eslint-disable-next-line @typescript-eslint/no-empty-function
function noop() { }
exports.noop = noop;
/**
 * Custom implementation of JSON.stringify that ignores some toJSON methods. We need to do that
 * because some sites badly override toJSON on certain objects. Removing all toJSON methods from
 * nested values would be too costly, so we just detach them from the root value, and native classes
 * used to build JSON values (Array and Object).
 *
 * Note: this still assumes that JSON.stringify is correct.
 */
function jsonStringify(value, replacer, space) {
    if (typeof value !== 'object' || value === null) {
        return JSON.stringify(value);
    }
    // Note: The order matter here. We need to detach toJSON methods on parent classes before their
    // subclasses.
    var restoreObjectPrototypeToJson = detachToJsonMethod(Object.prototype);
    var restoreArrayPrototypeToJson = detachToJsonMethod(Array.prototype);
    var restoreValuePrototypeToJson = detachToJsonMethod(Object.getPrototypeOf(value));
    var restoreValueToJson = detachToJsonMethod(value);
    try {
        return JSON.stringify(value, replacer, space);
    }
    catch (_a) {
        return '<error: unable to serialize object>';
    }
    finally {
        restoreObjectPrototypeToJson();
        restoreArrayPrototypeToJson();
        restoreValuePrototypeToJson();
        restoreValueToJson();
    }
}
exports.jsonStringify = jsonStringify;
function detachToJsonMethod(value) {
    var object = value;
    var objectToJson = object.toJSON;
    if (objectToJson) {
        delete object.toJSON;
        return function () {
            object.toJSON = objectToJson;
        };
    }
    return noop;
}
function includes(candidate, search) {
    return candidate.indexOf(search) !== -1;
}
exports.includes = includes;
function arrayFrom(arrayLike) {
    if (Array.from) {
        return Array.from(arrayLike);
    }
    var array = [];
    if (arrayLike instanceof Set) {
        arrayLike.forEach(function (item) { return array.push(item); });
    }
    else {
        for (var i = 0; i < arrayLike.length; i++) {
            array.push(arrayLike[i]);
        }
    }
    return array;
}
exports.arrayFrom = arrayFrom;
function find(array, predicate) {
    for (var i = 0; i < array.length; i += 1) {
        var item = array[i];
        if (predicate(item, i)) {
            return item;
        }
    }
    return undefined;
}
exports.find = find;
function findLast(array, predicate) {
    for (var i = array.length - 1; i >= 0; i -= 1) {
        var item = array[i];
        if (predicate(item, i, array)) {
            return item;
        }
    }
    return undefined;
}
exports.findLast = findLast;
function isPercentage(value) {
    return isNumber(value) && value >= 0 && value <= 100;
}
exports.isPercentage = isPercentage;
function isNumber(value) {
    return typeof value === 'number';
}
exports.isNumber = isNumber;
function objectValues(object) {
    return Object.keys(object).map(function (key) { return object[key]; });
}
exports.objectValues = objectValues;
function objectHasValue(object, value) {
    return Object.keys(object).some(function (key) { return object[key] === value; });
}
exports.objectHasValue = objectHasValue;
function objectEntries(object) {
    return Object.keys(object).map(function (key) { return [key, object[key]]; });
}
exports.objectEntries = objectEntries;
function isEmptyObject(object) {
    return Object.keys(object).length === 0;
}
exports.isEmptyObject = isEmptyObject;
function mapValues(object, fn) {
    var newObject = {};
    for (var _i = 0, _a = Object.keys(object); _i < _a.length; _i++) {
        var key = _a[_i];
        newObject[key] = fn(object[key]);
    }
    return newObject;
}
exports.mapValues = mapValues;
function startsWith(candidate, search) {
    return candidate.slice(0, search.length) === search;
}
exports.startsWith = startsWith;
function endsWith(candidate, search) {
    return candidate.slice(-search.length) === search;
}
exports.endsWith = endsWith;
/**
 * inspired by https://mathiasbynens.be/notes/globalthis
 */
function getGlobalObject() {
    if (typeof globalThis === 'object') {
        return globalThis;
    }
    Object.defineProperty(Object.prototype, '_dd_temp_', {
        get: function () {
            return this;
        },
        configurable: true,
    });
    // @ts-ignore _dd_temp is defined using defineProperty
    var globalObject = _dd_temp_;
    // @ts-ignore _dd_temp is defined using defineProperty
    delete Object.prototype._dd_temp_;
    if (typeof globalObject !== 'object') {
        // on safari _dd_temp_ is available on window but not globally
        // fallback on other browser globals check
        if (typeof self === 'object') {
            globalObject = self;
        }
        else if (typeof window === 'object') {
            globalObject = window;
        }
        else {
            globalObject = {};
        }
    }
    return globalObject;
}
exports.getGlobalObject = getGlobalObject;
function getLocationOrigin() {
    return getLinkElementOrigin(window.location);
}
exports.getLocationOrigin = getLocationOrigin;
/**
 * IE fallback
 * https://developer.mozilla.org/en-US/docs/Web/API/HTMLHyperlinkElementUtils/origin
 */
function getLinkElementOrigin(element) {
    if (element.origin) {
        return element.origin;
    }
    var sanitizedHost = element.host.replace(/(:80|:443)$/, '');
    return "".concat(element.protocol, "//").concat(sanitizedHost);
}
exports.getLinkElementOrigin = getLinkElementOrigin;
function findCommaSeparatedValue(rawString, name) {
    var regex = new RegExp("(?:^|;)\\s*".concat(name, "\\s*=\\s*([^;]+)"));
    var matches = regex.exec(rawString);
    return matches ? matches[1] : undefined;
}
exports.findCommaSeparatedValue = findCommaSeparatedValue;
function safeTruncate(candidate, length, suffix) {
    if (suffix === void 0) { suffix = ''; }
    var lastChar = candidate.charCodeAt(length - 1);
    var isLastCharSurrogatePair = lastChar >= 0xd800 && lastChar <= 0xdbff;
    var correctedLength = isLastCharSurrogatePair ? length + 1 : length;
    if (candidate.length <= correctedLength) {
        return candidate;
    }
    return "".concat(candidate.slice(0, correctedLength)).concat(suffix);
}
exports.safeTruncate = safeTruncate;
function elementMatches(element, selector) {
    if (element.matches) {
        return element.matches(selector);
    }
    // IE11 support
    if (element.msMatchesSelector) {
        return element.msMatchesSelector(selector);
    }
    return false;
}
exports.elementMatches = elementMatches;
/**
 * Similar to `typeof`, but distinguish plain objects from `null` and arrays
 */
function getType(value) {
    if (value === null) {
        return 'null';
    }
    if (Array.isArray(value)) {
        return 'array';
    }
    return typeof value;
}
exports.getType = getType;
function createCircularReferenceChecker() {
    if (typeof WeakSet !== 'undefined') {
        var set_1 = new WeakSet();
        return {
            hasAlreadyBeenSeen: function (value) {
                var has = set_1.has(value);
                if (!has) {
                    set_1.add(value);
                }
                return has;
            },
        };
    }
    var array = [];
    return {
        hasAlreadyBeenSeen: function (value) {
            var has = array.indexOf(value) >= 0;
            if (!has) {
                array.push(value);
            }
            return has;
        },
    };
}
/**
 * Iterate over source and affect its sub values into destination, recursively.
 * If the source and destination can't be merged, return source.
 */
function mergeInto(destination, source, circularReferenceChecker) {
    if (circularReferenceChecker === void 0) { circularReferenceChecker = createCircularReferenceChecker(); }
    // ignore the source if it is undefined
    if (source === undefined) {
        return destination;
    }
    if (typeof source !== 'object' || source === null) {
        // primitive values - just return source
        return source;
    }
    else if (source instanceof Date) {
        return new Date(source.getTime());
    }
    else if (source instanceof RegExp) {
        var flags = source.flags ||
            // old browsers compatibility
            [
                source.global ? 'g' : '',
                source.ignoreCase ? 'i' : '',
                source.multiline ? 'm' : '',
                source.sticky ? 'y' : '',
                source.unicode ? 'u' : '',
            ].join('');
        return new RegExp(source.source, flags);
    }
    if (circularReferenceChecker.hasAlreadyBeenSeen(source)) {
        // remove circular references
        return undefined;
    }
    else if (Array.isArray(source)) {
        var merged_1 = Array.isArray(destination) ? destination : [];
        for (var i = 0; i < source.length; ++i) {
            merged_1[i] = mergeInto(merged_1[i], source[i], circularReferenceChecker);
        }
        return merged_1;
    }
    var merged = getType(destination) === 'object' ? destination : {};
    for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
            merged[key] = mergeInto(merged[key], source[key], circularReferenceChecker);
        }
    }
    return merged;
}
exports.mergeInto = mergeInto;
/**
 * A simplistic implementation of a deep clone algorithm.
 * Caveats:
 * - It doesn't maintain prototype chains - don't use with instances of custom classes.
 * - It doesn't handle Map and Set
 */
function deepClone(value) {
    return mergeInto(undefined, value);
}
exports.deepClone = deepClone;
function combine() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    var destination;
    for (var _a = 0, sources_1 = sources; _a < sources_1.length; _a++) {
        var source = sources_1[_a];
        // Ignore any undefined or null sources.
        if (source === undefined || source === null) {
            continue;
        }
        destination = mergeInto(destination, source);
    }
    return destination;
}
exports.combine = combine;
/**
 * Use 'requestIdleCallback' when available: it will throttle the mutation processing if the
 * browser is busy rendering frames (ex: when frames are below 60fps). When not available, the
 * fallback on 'requestAnimationFrame' will still ensure the mutations are processed after any
 * browser rendering process (Layout, Recalculate Style, etc.), so we can serialize DOM nodes efficiently.
 *
 * Note: check both 'requestIdleCallback' and 'cancelIdleCallback' existence because some polyfills only implement 'requestIdleCallback'.
 */
function requestIdleCallback(callback, opts) {
    if (window.requestIdleCallback && window.cancelIdleCallback) {
        var id_1 = window.requestIdleCallback((0, monitor_1.monitor)(callback), opts);
        return function () { return window.cancelIdleCallback(id_1); };
    }
    var id = window.requestAnimationFrame((0, monitor_1.monitor)(callback));
    return function () { return window.cancelAnimationFrame(id); };
}
exports.requestIdleCallback = requestIdleCallback;
function removeDuplicates(array) {
    var set = new Set();
    array.forEach(function (item) { return set.add(item); });
    return arrayFrom(set);
}
exports.removeDuplicates = removeDuplicates;
function isMatchOption(item) {
    var itemType = getType(item);
    return itemType === 'string' || itemType === 'function' || item instanceof RegExp;
}
exports.isMatchOption = isMatchOption;
/**
 * Returns true if value can be matched by at least one of the provided MatchOptions.
 * When comparing strings, setting useStartsWith to true will compare the value with the start of
 * the option, instead of requiring an exact match.
 */
function matchList(list, value, useStartsWith) {
    if (useStartsWith === void 0) { useStartsWith = false; }
    return list.some(function (item) {
        try {
            if (typeof item === 'function') {
                return item(value);
            }
            else if (item instanceof RegExp) {
                return item.test(value);
            }
            else if (typeof item === 'string') {
                return useStartsWith ? startsWith(value, item) : item === value;
            }
        }
        catch (e) {
            display_1.display.error(e);
        }
        return false;
    });
}
exports.matchList = matchList;
// https://github.com/jquery/jquery/blob/a684e6ba836f7c553968d7d026ed7941e1a612d8/src/selector/escapeSelector.js
function cssEscape(str) {
    if (window.CSS && window.CSS.escape) {
        return window.CSS.escape(str);
    }
    // eslint-disable-next-line no-control-regex
    return str.replace(/([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g, function (ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === '\0') {
                return '\uFFFD';
            }
            // Control characters and (dependent upon position) numbers get escaped as code points
            return "".concat(ch.slice(0, -1), "\\").concat(ch.charCodeAt(ch.length - 1).toString(16), " ");
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\".concat(ch);
    });
}
exports.cssEscape = cssEscape;
// eslint-disable-next-line no-control-regex
var HAS_MULTI_BYTES_CHARACTERS = /[^\u0000-\u007F]/;
function computeBytesCount(candidate) {
    // Accurate bytes count computations can degrade performances when there is a lot of events to process
    if (!HAS_MULTI_BYTES_CHARACTERS.test(candidate)) {
        return candidate.length;
    }
    if (window.TextEncoder !== undefined) {
        return new TextEncoder().encode(candidate).length;
    }
    return new Blob([candidate]).size;
}
exports.computeBytesCount = computeBytesCount;
function tryToClone(response) {
    try {
        return response.clone();
    }
    catch (e) {
        // clone can throw if the response has already been used by another instrumentation or is disturbed
        return;
    }
}
exports.tryToClone = tryToClone;

},{"../browser/timer":404,"./display":439,"./monitor":444}],452:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Batch = void 0;
var display_1 = require("../tools/display");
var utils_1 = require("../tools/utils");
var observable_1 = require("../tools/observable");
var timer_1 = require("../browser/timer");
var Batch = /** @class */ (function () {
    function Batch(request, batchMessagesLimit, batchBytesLimit, messageBytesLimit, flushTimeout, pageExitObservable) {
        var _this = this;
        this.request = request;
        this.batchMessagesLimit = batchMessagesLimit;
        this.batchBytesLimit = batchBytesLimit;
        this.messageBytesLimit = messageBytesLimit;
        this.flushTimeout = flushTimeout;
        this.pageExitObservable = pageExitObservable;
        this.flushObservable = new observable_1.Observable();
        this.pushOnlyBuffer = [];
        this.upsertBuffer = {};
        this.bufferBytesCount = 0;
        this.bufferMessagesCount = 0;
        pageExitObservable.subscribe(function (event) { return _this.flush(event.reason, _this.request.sendOnExit); });
        this.flushPeriodically();
    }
    Batch.prototype.add = function (message) {
        this.addOrUpdate(message);
    };
    Batch.prototype.upsert = function (message, key) {
        this.addOrUpdate(message, key);
    };
    Batch.prototype.flush = function (flushReason, sendFn) {
        if (sendFn === void 0) { sendFn = this.request.send; }
        if (this.bufferMessagesCount !== 0) {
            var messages = this.pushOnlyBuffer.concat((0, utils_1.objectValues)(this.upsertBuffer));
            var bytesCount = this.bufferBytesCount;
            this.flushObservable.notify({
                bufferBytesCount: this.bufferBytesCount,
                bufferMessagesCount: this.bufferMessagesCount,
            });
            this.pushOnlyBuffer = [];
            this.upsertBuffer = {};
            this.bufferBytesCount = 0;
            this.bufferMessagesCount = 0;
            sendFn({ data: messages.join('\n'), bytesCount: bytesCount, flushReason: flushReason });
        }
    };
    Batch.prototype.addOrUpdate = function (message, key) {
        var _a = this.process(message), processedMessage = _a.processedMessage, messageBytesCount = _a.messageBytesCount;
        if (messageBytesCount >= this.messageBytesLimit) {
            display_1.display.warn("Discarded a message whose size was bigger than the maximum allowed size ".concat(this.messageBytesLimit, "KB."));
            return;
        }
        if (this.hasMessageFor(key)) {
            this.remove(key);
        }
        if (this.willReachedBytesLimitWith(messageBytesCount)) {
            this.flush('batch_bytes_limit');
        }
        this.push(processedMessage, messageBytesCount, key);
        if (this.isFull()) {
            this.flush('batch_bytes_limit');
        }
    };
    Batch.prototype.process = function (message) {
        var processedMessage = (0, utils_1.jsonStringify)(message);
        var messageBytesCount = (0, utils_1.computeBytesCount)(processedMessage);
        return { processedMessage: processedMessage, messageBytesCount: messageBytesCount };
    };
    Batch.prototype.push = function (processedMessage, messageBytesCount, key) {
        if (this.bufferMessagesCount > 0) {
            // \n separator at serialization
            this.bufferBytesCount += 1;
        }
        if (key !== undefined) {
            this.upsertBuffer[key] = processedMessage;
        }
        else {
            this.pushOnlyBuffer.push(processedMessage);
        }
        this.bufferBytesCount += messageBytesCount;
        this.bufferMessagesCount += 1;
    };
    Batch.prototype.remove = function (key) {
        var removedMessage = this.upsertBuffer[key];
        delete this.upsertBuffer[key];
        var messageBytesCount = (0, utils_1.computeBytesCount)(removedMessage);
        this.bufferBytesCount -= messageBytesCount;
        this.bufferMessagesCount -= 1;
        if (this.bufferMessagesCount > 0) {
            this.bufferBytesCount -= 1;
        }
    };
    Batch.prototype.hasMessageFor = function (key) {
        return key !== undefined && this.upsertBuffer[key] !== undefined;
    };
    Batch.prototype.willReachedBytesLimitWith = function (messageBytesCount) {
        // byte of the separator at the end of the message
        return this.bufferBytesCount + messageBytesCount + 1 >= this.batchBytesLimit;
    };
    Batch.prototype.isFull = function () {
        return this.bufferMessagesCount === this.batchMessagesLimit || this.bufferBytesCount >= this.batchBytesLimit;
    };
    Batch.prototype.flushPeriodically = function () {
        var _this = this;
        (0, timer_1.setTimeout)(function () {
            _this.flush('batch_duration_limit');
            _this.flushPeriodically();
        }, this.flushTimeout);
    };
    return Batch;
}());
exports.Batch = Batch;

},{"../browser/timer":404,"../tools/display":439,"../tools/observable":445,"../tools/utils":451}],453:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canUseEventBridge = exports.getEventBridge = void 0;
var utils_1 = require("../tools/utils");
function getEventBridge() {
    var eventBridgeGlobal = getEventBridgeGlobal();
    if (!eventBridgeGlobal) {
        return;
    }
    return {
        getAllowedWebViewHosts: function () {
            return JSON.parse(eventBridgeGlobal.getAllowedWebViewHosts());
        },
        send: function (eventType, event) {
            eventBridgeGlobal.send(JSON.stringify({ eventType: eventType, event: event }));
        },
    };
}
exports.getEventBridge = getEventBridge;
function canUseEventBridge(currentHost) {
    var _a;
    if (currentHost === void 0) { currentHost = (_a = (0, utils_1.getGlobalObject)().location) === null || _a === void 0 ? void 0 : _a.hostname; }
    var bridge = getEventBridge();
    return (!!bridge &&
        bridge
            .getAllowedWebViewHosts()
            .some(function (allowedHost) { return currentHost === allowedHost || (0, utils_1.endsWith)(currentHost, ".".concat(allowedHost)); }));
}
exports.canUseEventBridge = canUseEventBridge;
function getEventBridgeGlobal() {
    return (0, utils_1.getGlobalObject)().DatadogEventBridge;
}

},{"../tools/utils":451}],454:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendXHR = exports.fetchKeepAliveStrategy = exports.createHttpRequest = void 0;
var telemetry_1 = require("../domain/telemetry");
var monitor_1 = require("../tools/monitor");
var sendWithRetryStrategy_1 = require("./sendWithRetryStrategy");
function createHttpRequest(endpointBuilder, bytesLimit, reportError) {
    var retryState = (0, sendWithRetryStrategy_1.newRetryState)();
    var sendStrategyForRetry = function (payload, onResponse) {
        return fetchKeepAliveStrategy(endpointBuilder, bytesLimit, payload, onResponse);
    };
    return {
        send: function (payload) {
            (0, sendWithRetryStrategy_1.sendWithRetryStrategy)(payload, retryState, sendStrategyForRetry, endpointBuilder.endpointType, reportError);
        },
        /**
         * Since fetch keepalive behaves like regular fetch on Firefox,
         * keep using sendBeaconStrategy on exit
         */
        sendOnExit: function (payload) {
            sendBeaconStrategy(endpointBuilder, bytesLimit, payload);
        },
    };
}
exports.createHttpRequest = createHttpRequest;
function sendBeaconStrategy(endpointBuilder, bytesLimit, _a) {
    var data = _a.data, bytesCount = _a.bytesCount, flushReason = _a.flushReason;
    var canUseBeacon = !!navigator.sendBeacon && bytesCount < bytesLimit;
    if (canUseBeacon) {
        try {
            var beaconUrl = endpointBuilder.build('beacon', flushReason);
            var isQueued = navigator.sendBeacon(beaconUrl, data);
            if (isQueued) {
                return;
            }
        }
        catch (e) {
            reportBeaconError(e);
        }
    }
    var xhrUrl = endpointBuilder.build('xhr', flushReason);
    sendXHR(xhrUrl, data);
}
var hasReportedBeaconError = false;
function reportBeaconError(e) {
    if (!hasReportedBeaconError) {
        hasReportedBeaconError = true;
        (0, telemetry_1.addTelemetryError)(e);
    }
}
function fetchKeepAliveStrategy(endpointBuilder, bytesLimit, _a, onResponse) {
    var data = _a.data, bytesCount = _a.bytesCount, flushReason = _a.flushReason, retry = _a.retry;
    var canUseKeepAlive = isKeepAliveSupported() && bytesCount < bytesLimit;
    if (canUseKeepAlive) {
        var fetchUrl = endpointBuilder.build('fetch', flushReason, retry);
        fetch(fetchUrl, { method: 'POST', body: data, keepalive: true, mode: 'cors' }).then((0, monitor_1.monitor)(function (response) { return onResponse === null || onResponse === void 0 ? void 0 : onResponse({ status: response.status, type: response.type }); }), (0, monitor_1.monitor)(function () {
            var xhrUrl = endpointBuilder.build('xhr', flushReason, retry);
            // failed to queue the request
            sendXHR(xhrUrl, data, onResponse);
        }));
    }
    else {
        var xhrUrl = endpointBuilder.build('xhr', flushReason, retry);
        sendXHR(xhrUrl, data, onResponse);
    }
}
exports.fetchKeepAliveStrategy = fetchKeepAliveStrategy;
function isKeepAliveSupported() {
    // Request can throw, cf https://developer.mozilla.org/en-US/docs/Web/API/Request/Request#errors
    try {
        return window.Request && 'keepalive' in new Request('http://a');
    }
    catch (_a) {
        return false;
    }
}
function sendXHR(url, data, onResponse) {
    var request = new XMLHttpRequest();
    var onLoadEnd = (0, monitor_1.monitor)(function () {
        // prevent multiple onResponse callbacks
        // if the xhr instance is reused by a third party
        request.removeEventListener('loadend', onLoadEnd);
        onResponse === null || onResponse === void 0 ? void 0 : onResponse({ status: request.status });
    });
    request.open('POST', url, true);
    request.addEventListener('loadend', onLoadEnd);
    request.send(data);
}
exports.sendXHR = sendXHR;

},{"../domain/telemetry":422,"../tools/monitor":444,"./sendWithRetryStrategy":456}],455:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startBatchWithReplica = exports.getEventBridge = exports.canUseEventBridge = exports.Batch = exports.createHttpRequest = void 0;
var httpRequest_1 = require("./httpRequest");
Object.defineProperty(exports, "createHttpRequest", { enumerable: true, get: function () { return httpRequest_1.createHttpRequest; } });
var batch_1 = require("./batch");
Object.defineProperty(exports, "Batch", { enumerable: true, get: function () { return batch_1.Batch; } });
var eventBridge_1 = require("./eventBridge");
Object.defineProperty(exports, "canUseEventBridge", { enumerable: true, get: function () { return eventBridge_1.canUseEventBridge; } });
Object.defineProperty(exports, "getEventBridge", { enumerable: true, get: function () { return eventBridge_1.getEventBridge; } });
var startBatchWithReplica_1 = require("./startBatchWithReplica");
Object.defineProperty(exports, "startBatchWithReplica", { enumerable: true, get: function () { return startBatchWithReplica_1.startBatchWithReplica; } });

},{"./batch":452,"./eventBridge":453,"./httpRequest":454,"./startBatchWithReplica":457}],456:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newRetryState = exports.sendWithRetryStrategy = exports.INITIAL_BACKOFF_TIME = exports.MAX_BACKOFF_TIME = exports.MAX_QUEUE_BYTES_COUNT = exports.MAX_ONGOING_REQUESTS = exports.MAX_ONGOING_BYTES_COUNT = void 0;
var timer_1 = require("../browser/timer");
var timeUtils_1 = require("../tools/timeUtils");
var utils_1 = require("../tools/utils");
var error_1 = require("../tools/error");
exports.MAX_ONGOING_BYTES_COUNT = 80 * utils_1.ONE_KIBI_BYTE;
exports.MAX_ONGOING_REQUESTS = 32;
exports.MAX_QUEUE_BYTES_COUNT = 3 * utils_1.ONE_MEBI_BYTE;
exports.MAX_BACKOFF_TIME = utils_1.ONE_MINUTE;
exports.INITIAL_BACKOFF_TIME = utils_1.ONE_SECOND;
function sendWithRetryStrategy(payload, state, sendStrategy, endpointType, reportError) {
    if (state.transportStatus === 0 /* UP */ &&
        state.queuedPayloads.size() === 0 &&
        state.bandwidthMonitor.canHandle(payload)) {
        send(payload, state, sendStrategy, {
            onSuccess: function () { return retryQueuedPayloads(0 /* AFTER_SUCCESS */, state, sendStrategy, endpointType, reportError); },
            onFailure: function () {
                state.queuedPayloads.enqueue(payload);
                scheduleRetry(state, sendStrategy, endpointType, reportError);
            },
        });
    }
    else {
        state.queuedPayloads.enqueue(payload);
    }
}
exports.sendWithRetryStrategy = sendWithRetryStrategy;
function scheduleRetry(state, sendStrategy, endpointType, reportError) {
    if (state.transportStatus !== 2 /* DOWN */) {
        return;
    }
    (0, timer_1.setTimeout)(function () {
        var payload = state.queuedPayloads.first();
        send(payload, state, sendStrategy, {
            onSuccess: function () {
                state.queuedPayloads.dequeue();
                state.currentBackoffTime = exports.INITIAL_BACKOFF_TIME;
                retryQueuedPayloads(1 /* AFTER_RESUME */, state, sendStrategy, endpointType, reportError);
            },
            onFailure: function () {
                state.currentBackoffTime = Math.min(exports.MAX_BACKOFF_TIME, state.currentBackoffTime * 2);
                scheduleRetry(state, sendStrategy, endpointType, reportError);
            },
        });
    }, state.currentBackoffTime);
}
function send(payload, state, sendStrategy, _a) {
    var onSuccess = _a.onSuccess, onFailure = _a.onFailure;
    state.bandwidthMonitor.add(payload);
    sendStrategy(payload, function (response) {
        state.bandwidthMonitor.remove(payload);
        if (!shouldRetryRequest(response)) {
            state.transportStatus = 0 /* UP */;
            onSuccess();
        }
        else {
            // do not consider transport down if another ongoing request could succeed
            state.transportStatus =
                state.bandwidthMonitor.ongoingRequestCount > 0 ? 1 /* FAILURE_DETECTED */ : 2 /* DOWN */;
            payload.retry = {
                count: payload.retry ? payload.retry.count + 1 : 1,
                lastFailureStatus: response.status,
            };
            onFailure();
        }
    });
}
function retryQueuedPayloads(reason, state, sendStrategy, endpointType, reportError) {
    if (reason === 0 /* AFTER_SUCCESS */ && state.queuedPayloads.isFull() && !state.queueFullReported) {
        reportError({
            message: "Reached max ".concat(endpointType, " events size queued for upload: ").concat(exports.MAX_QUEUE_BYTES_COUNT / utils_1.ONE_MEBI_BYTE, "MiB"),
            source: error_1.ErrorSource.AGENT,
            startClocks: (0, timeUtils_1.clocksNow)(),
        });
        state.queueFullReported = true;
    }
    var previousQueue = state.queuedPayloads;
    state.queuedPayloads = newPayloadQueue();
    while (previousQueue.size() > 0) {
        sendWithRetryStrategy(previousQueue.dequeue(), state, sendStrategy, endpointType, reportError);
    }
}
function shouldRetryRequest(response) {
    return (response.type !== 'opaque' &&
        ((response.status === 0 && !navigator.onLine) ||
            response.status === 408 ||
            response.status === 429 ||
            response.status >= 500));
}
function newRetryState() {
    return {
        transportStatus: 0 /* UP */,
        currentBackoffTime: exports.INITIAL_BACKOFF_TIME,
        bandwidthMonitor: newBandwidthMonitor(),
        queuedPayloads: newPayloadQueue(),
        queueFullReported: false,
    };
}
exports.newRetryState = newRetryState;
function newPayloadQueue() {
    var queue = [];
    return {
        bytesCount: 0,
        enqueue: function (payload) {
            if (this.isFull()) {
                return;
            }
            queue.push(payload);
            this.bytesCount += payload.bytesCount;
        },
        first: function () {
            return queue[0];
        },
        dequeue: function () {
            var payload = queue.shift();
            if (payload) {
                this.bytesCount -= payload.bytesCount;
            }
            return payload;
        },
        size: function () {
            return queue.length;
        },
        isFull: function () {
            return this.bytesCount >= exports.MAX_QUEUE_BYTES_COUNT;
        },
    };
}
function newBandwidthMonitor() {
    return {
        ongoingRequestCount: 0,
        ongoingByteCount: 0,
        canHandle: function (payload) {
            return (this.ongoingRequestCount === 0 ||
                (this.ongoingByteCount + payload.bytesCount <= exports.MAX_ONGOING_BYTES_COUNT &&
                    this.ongoingRequestCount < exports.MAX_ONGOING_REQUESTS));
        },
        add: function (payload) {
            this.ongoingRequestCount += 1;
            this.ongoingByteCount += payload.bytesCount;
        },
        remove: function (payload) {
            this.ongoingRequestCount -= 1;
            this.ongoingByteCount -= payload.bytesCount;
        },
    };
}

},{"../browser/timer":404,"../tools/error":440,"../tools/timeUtils":449,"../tools/utils":451}],457:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startBatchWithReplica = void 0;
var batch_1 = require("./batch");
var httpRequest_1 = require("./httpRequest");
function startBatchWithReplica(configuration, endpoint, reportError, pageExitObservable, replicaEndpoint) {
    var primaryBatch = createBatch(endpoint);
    var replicaBatch;
    if (replicaEndpoint) {
        replicaBatch = createBatch(replicaEndpoint);
    }
    function createBatch(endpointBuilder) {
        return new batch_1.Batch((0, httpRequest_1.createHttpRequest)(endpointBuilder, configuration.batchBytesLimit, reportError), configuration.batchMessagesLimit, configuration.batchBytesLimit, configuration.messageBytesLimit, configuration.flushTimeout, pageExitObservable);
    }
    return {
        add: function (message, replicated) {
            if (replicated === void 0) { replicated = true; }
            primaryBatch.add(message);
            if (replicaBatch && replicated) {
                replicaBatch.add(message);
            }
        },
    };
}
exports.startBatchWithReplica = startBatchWithReplica;

},{"./batch":452,"./httpRequest":454}],458:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeRumPublicApi = void 0;
var browser_core_1 = require("@datadog/browser-core");
var configuration_1 = require("../domain/configuration");
var commonContext_1 = require("../domain/contexts/commonContext");
function makeRumPublicApi(startRumImpl, recorderApi, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.ignoreInitIfSyntheticsWillInjectRum, ignoreInitIfSyntheticsWillInjectRum = _c === void 0 ? true : _c;
    var isAlreadyInitialized = false;
    var globalContextManager = (0, browser_core_1.createContextManager)();
    var userContextManager = (0, browser_core_1.createContextManager)();
    var getInternalContextStrategy = function () { return undefined; };
    var getInitConfigurationStrategy = function () { return undefined; };
    var bufferApiCalls = new browser_core_1.BoundedBuffer();
    var addTimingStrategy = function (name, time) {
        if (time === void 0) { time = (0, browser_core_1.timeStampNow)(); }
        bufferApiCalls.add(function () { return addTimingStrategy(name, time); });
    };
    var startViewStrategy = function (options, startClocks) {
        if (startClocks === void 0) { startClocks = (0, browser_core_1.clocksNow)(); }
        bufferApiCalls.add(function () { return startViewStrategy(options, startClocks); });
    };
    var addActionStrategy = function (action, commonContext) {
        if (commonContext === void 0) { commonContext = (0, commonContext_1.buildCommonContext)(globalContextManager, userContextManager, recorderApi); }
        bufferApiCalls.add(function () { return addActionStrategy(action, commonContext); });
    };
    var addErrorStrategy = function (providedError, commonContext) {
        if (commonContext === void 0) { commonContext = (0, commonContext_1.buildCommonContext)(globalContextManager, userContextManager, recorderApi); }
        bufferApiCalls.add(function () { return addErrorStrategy(providedError, commonContext); });
    };
    var addFeatureFlagEvaluationStrategy = function (key, value) {
        bufferApiCalls.add(function () { return addFeatureFlagEvaluationStrategy(key, value); });
    };
    function initRum(initConfiguration) {
        // This function should be available, regardless of initialization success.
        getInitConfigurationStrategy = function () { return (0, browser_core_1.deepClone)(initConfiguration); };
        // If we are in a Synthetics test configured to automatically inject a RUM instance, we want to
        // completely discard the customer application RUM instance by ignoring their init() call.  But,
        // we should not ignore the init() call from the Synthetics-injected RUM instance, so the
        // internal `ignoreInitIfSyntheticsWillInjectRum` option is here to bypass this condition.
        if (ignoreInitIfSyntheticsWillInjectRum && (0, browser_core_1.willSyntheticsInjectRum)()) {
            return;
        }
        if ((0, browser_core_1.canUseEventBridge)()) {
            initConfiguration = overrideInitConfigurationForBridge(initConfiguration);
        }
        else if (!canHandleSession(initConfiguration)) {
            return;
        }
        if (!canInitRum(initConfiguration)) {
            return;
        }
        var configuration = (0, configuration_1.validateAndBuildRumConfiguration)(initConfiguration);
        if (!configuration) {
            return;
        }
        if (!configuration.trackViewsManually) {
            doStartRum(initConfiguration, configuration);
        }
        else {
            // drain beforeInitCalls by buffering them until we start RUM
            // if we get a startView, drain re-buffered calls before continuing to drain beforeInitCalls
            // in order to ensure that calls are processed in order
            var beforeInitCalls = bufferApiCalls;
            bufferApiCalls = new browser_core_1.BoundedBuffer();
            startViewStrategy = function (options) {
                doStartRum(initConfiguration, configuration, options);
            };
            beforeInitCalls.drain();
        }
        isAlreadyInitialized = true;
    }
    function doStartRum(initConfiguration, configuration, initialViewOptions) {
        var startRumResults = startRumImpl(initConfiguration, configuration, recorderApi, globalContextManager, userContextManager, initialViewOptions);
        (startViewStrategy = startRumResults.startView, addActionStrategy = startRumResults.addAction, addErrorStrategy = startRumResults.addError, addTimingStrategy = startRumResults.addTiming, addFeatureFlagEvaluationStrategy = startRumResults.addFeatureFlagEvaluation, getInternalContextStrategy = startRumResults.getInternalContext);
        bufferApiCalls.drain();
        recorderApi.onRumStart(startRumResults.lifeCycle, configuration, startRumResults.session, startRumResults.viewContexts);
    }
    var startView = (0, browser_core_1.monitor)(function (options) {
        var sanitizedOptions = typeof options === 'object' ? options : { name: options };
        startViewStrategy(sanitizedOptions);
    });
    var rumPublicApi = (0, browser_core_1.makePublicApi)({
        init: (0, browser_core_1.monitor)(initRum),
        /** @deprecated: use setGlobalContextProperty instead */
        addRumGlobalContext: (0, browser_core_1.monitor)(globalContextManager.add),
        setGlobalContextProperty: (0, browser_core_1.monitor)(globalContextManager.setContextProperty),
        /** @deprecated: use removeGlobalContextProperty instead */
        removeRumGlobalContext: (0, browser_core_1.monitor)(globalContextManager.remove),
        removeGlobalContextProperty: (0, browser_core_1.monitor)(globalContextManager.removeContextProperty),
        /** @deprecated: use getGlobalContext instead */
        getRumGlobalContext: (0, browser_core_1.monitor)(globalContextManager.get),
        getGlobalContext: (0, browser_core_1.monitor)(globalContextManager.getContext),
        /** @deprecated: use setGlobalContext instead */
        setRumGlobalContext: (0, browser_core_1.monitor)(globalContextManager.set),
        setGlobalContext: (0, browser_core_1.monitor)(globalContextManager.setContext),
        clearGlobalContext: (0, browser_core_1.monitor)(globalContextManager.clearContext),
        getInternalContext: (0, browser_core_1.monitor)(function (startTime) { return getInternalContextStrategy(startTime); }),
        getInitConfiguration: (0, browser_core_1.monitor)(function () { return getInitConfigurationStrategy(); }),
        addAction: (0, browser_core_1.monitor)(function (name, context) {
            addActionStrategy({
                name: name,
                context: (0, browser_core_1.deepClone)(context),
                startClocks: (0, browser_core_1.clocksNow)(),
                type: "custom" /* CUSTOM */,
            });
        }),
        addError: function (error, context) {
            var handlingStack = (0, browser_core_1.createHandlingStack)();
            (0, browser_core_1.callMonitored)(function () {
                addErrorStrategy({
                    error: error,
                    handlingStack: handlingStack,
                    context: (0, browser_core_1.deepClone)(context),
                    startClocks: (0, browser_core_1.clocksNow)(),
                });
            });
        },
        addTiming: (0, browser_core_1.monitor)(function (name, time) {
            addTimingStrategy(name, time);
        }),
        setUser: (0, browser_core_1.monitor)(function (newUser) {
            if ((0, browser_core_1.checkUser)(newUser)) {
                userContextManager.setContext((0, browser_core_1.sanitizeUser)(newUser));
            }
        }),
        getUser: (0, browser_core_1.monitor)(userContextManager.getContext),
        setUserProperty: (0, browser_core_1.monitor)(function (key, property) {
            var _a;
            var sanitizedProperty = (0, browser_core_1.sanitizeUser)((_a = {}, _a[key] = property, _a))[key];
            userContextManager.setContextProperty(key, sanitizedProperty);
        }),
        removeUserProperty: (0, browser_core_1.monitor)(userContextManager.removeContextProperty),
        /** @deprecated: renamed to clearUser */
        removeUser: (0, browser_core_1.monitor)(userContextManager.clearContext),
        clearUser: (0, browser_core_1.monitor)(userContextManager.clearContext),
        startView: startView,
        startSessionReplayRecording: (0, browser_core_1.monitor)(recorderApi.start),
        stopSessionReplayRecording: (0, browser_core_1.monitor)(recorderApi.stop),
        /**
         * This feature is currently in beta. For more information see the full [feature flag tracking guide](https://docs.datadoghq.com/real_user_monitoring/feature_flag_tracking/).
         */
        addFeatureFlagEvaluation: (0, browser_core_1.monitor)(function (key, value) {
            addFeatureFlagEvaluationStrategy(key, value);
        }),
    });
    return rumPublicApi;
    function canHandleSession(initConfiguration) {
        if (!(0, browser_core_1.areCookiesAuthorized)((0, browser_core_1.buildCookieOptions)(initConfiguration))) {
            browser_core_1.display.warn('Cookies are not authorized, we will not send any data.');
            return false;
        }
        if (isLocalFile()) {
            browser_core_1.display.error('Execution is not allowed in the current context.');
            return false;
        }
        return true;
    }
    function canInitRum(initConfiguration) {
        if (isAlreadyInitialized) {
            if (!initConfiguration.silentMultipleInit) {
                browser_core_1.display.error('DD_RUM is already initialized.');
            }
            return false;
        }
        return true;
    }
    function overrideInitConfigurationForBridge(initConfiguration) {
        return (0, browser_core_1.assign)({}, initConfiguration, {
            applicationId: '00000000-aaaa-0000-aaaa-000000000000',
            clientToken: 'empty',
            sessionSampleRate: 100,
        });
    }
    function isLocalFile() {
        return window.location.protocol === 'file:';
    }
}
exports.makeRumPublicApi = makeRumPublicApi;

},{"../domain/configuration":466,"../domain/contexts/commonContext":468,"@datadog/browser-core":432}],459:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startRumEventCollection = exports.startRum = void 0;
var browser_core_1 = require("@datadog/browser-core");
var domMutationObservable_1 = require("../browser/domMutationObservable");
var performanceCollection_1 = require("../browser/performanceCollection");
var assembly_1 = require("../domain/assembly");
var foregroundContexts_1 = require("../domain/contexts/foregroundContexts");
var internalContext_1 = require("../domain/contexts/internalContext");
var lifeCycle_1 = require("../domain/lifeCycle");
var viewContexts_1 = require("../domain/contexts/viewContexts");
var requestCollection_1 = require("../domain/requestCollection");
var actionCollection_1 = require("../domain/rumEventsCollection/action/actionCollection");
var errorCollection_1 = require("../domain/rumEventsCollection/error/errorCollection");
var longTaskCollection_1 = require("../domain/rumEventsCollection/longTask/longTaskCollection");
var resourceCollection_1 = require("../domain/rumEventsCollection/resource/resourceCollection");
var viewCollection_1 = require("../domain/rumEventsCollection/view/viewCollection");
var rumSessionManager_1 = require("../domain/rumSessionManager");
var startRumBatch_1 = require("../transport/startRumBatch");
var startRumEventBridge_1 = require("../transport/startRumEventBridge");
var urlContexts_1 = require("../domain/contexts/urlContexts");
var locationChangeObservable_1 = require("../browser/locationChangeObservable");
var configuration_1 = require("../domain/configuration");
var featureFlagContext_1 = require("../domain/contexts/featureFlagContext");
var startCustomerDataTelemetry_1 = require("../domain/startCustomerDataTelemetry");
var pageStateHistory_1 = require("../domain/contexts/pageStateHistory");
var commonContext_1 = require("../domain/contexts/commonContext");
function startRum(initConfiguration, configuration, recorderApi, globalContextManager, userContextManager, initialViewOptions) {
    var lifeCycle = new lifeCycle_1.LifeCycle();
    lifeCycle.subscribe(11 /* RUM_EVENT_COLLECTED */, function (event) { return (0, browser_core_1.sendToExtension)('rum', event); });
    var telemetry = startRumTelemetry(configuration);
    telemetry.setContextProvider(function () {
        var _a, _b;
        return ({
            application: {
                id: configuration.applicationId,
            },
            session: {
                id: (_a = session.findTrackedSession()) === null || _a === void 0 ? void 0 : _a.id,
            },
            view: {
                id: (_b = viewContexts.findView()) === null || _b === void 0 ? void 0 : _b.id,
            },
            action: {
                id: actionContexts.findActionId(),
            },
        });
    });
    var reportError = function (error) {
        lifeCycle.notify(12 /* RAW_ERROR_COLLECTED */, { error: error });
    };
    var featureFlagContexts = (0, featureFlagContext_1.startFeatureFlagContexts)(lifeCycle);
    if (!(0, browser_core_1.canUseEventBridge)()) {
        var pageExitObservable = (0, browser_core_1.createPageExitObservable)();
        pageExitObservable.subscribe(function (event) {
            lifeCycle.notify(9 /* PAGE_EXITED */, event);
        });
        var batch = (0, startRumBatch_1.startRumBatch)(configuration, lifeCycle, telemetry.observable, reportError, pageExitObservable);
        (0, startCustomerDataTelemetry_1.startCustomerDataTelemetry)(configuration, telemetry, lifeCycle, globalContextManager, userContextManager, featureFlagContexts, batch.flushObservable);
    }
    else {
        (0, startRumEventBridge_1.startRumEventBridge)(lifeCycle);
    }
    var session = !(0, browser_core_1.canUseEventBridge)() ? (0, rumSessionManager_1.startRumSessionManager)(configuration, lifeCycle) : (0, rumSessionManager_1.startRumSessionManagerStub)();
    var domMutationObservable = (0, domMutationObservable_1.createDOMMutationObservable)();
    var locationChangeObservable = (0, locationChangeObservable_1.createLocationChangeObservable)(location);
    var _a = startRumEventCollection(lifeCycle, configuration, location, session, locationChangeObservable, domMutationObservable, function () { return (0, commonContext_1.buildCommonContext)(globalContextManager, userContextManager, recorderApi); }, reportError), viewContexts = _a.viewContexts, foregroundContexts = _a.foregroundContexts, urlContexts = _a.urlContexts, actionContexts = _a.actionContexts, addAction = _a.addAction;
    (0, browser_core_1.addTelemetryConfiguration)((0, configuration_1.serializeRumConfiguration)(initConfiguration));
    (0, longTaskCollection_1.startLongTaskCollection)(lifeCycle, session);
    var pageStateHistory = (0, pageStateHistory_1.startPageStateHistory)();
    (0, resourceCollection_1.startResourceCollection)(lifeCycle, configuration, session, pageStateHistory);
    var _b = (0, viewCollection_1.startViewCollection)(lifeCycle, configuration, location, domMutationObservable, locationChangeObservable, foregroundContexts, featureFlagContexts, recorderApi, initialViewOptions), addTiming = _b.addTiming, startView = _b.startView;
    var addError = (0, errorCollection_1.startErrorCollection)(lifeCycle, foregroundContexts, featureFlagContexts).addError;
    (0, requestCollection_1.startRequestCollection)(lifeCycle, configuration, session);
    (0, performanceCollection_1.startPerformanceCollection)(lifeCycle, configuration);
    var internalContext = (0, internalContext_1.startInternalContext)(configuration.applicationId, session, viewContexts, actionContexts, urlContexts);
    return {
        addAction: addAction,
        addError: addError,
        addTiming: addTiming,
        addFeatureFlagEvaluation: featureFlagContexts.addFeatureFlagEvaluation,
        startView: startView,
        lifeCycle: lifeCycle,
        viewContexts: viewContexts,
        session: session,
        getInternalContext: internalContext.get,
    };
}
exports.startRum = startRum;
function startRumTelemetry(configuration) {
    var telemetry = (0, browser_core_1.startTelemetry)("browser-rum-sdk" /* RUM */, configuration);
    if ((0, browser_core_1.canUseEventBridge)()) {
        var bridge_1 = (0, browser_core_1.getEventBridge)();
        telemetry.observable.subscribe(function (event) { return bridge_1.send('internal_telemetry', event); });
    }
    return telemetry;
}
function startRumEventCollection(lifeCycle, configuration, location, sessionManager, locationChangeObservable, domMutationObservable, buildCommonContext, reportError) {
    var viewContexts = (0, viewContexts_1.startViewContexts)(lifeCycle);
    var urlContexts = (0, urlContexts_1.startUrlContexts)(lifeCycle, locationChangeObservable, location);
    var foregroundContexts = (0, foregroundContexts_1.startForegroundContexts)();
    var _a = (0, actionCollection_1.startActionCollection)(lifeCycle, domMutationObservable, configuration, foregroundContexts), addAction = _a.addAction, actionContexts = _a.actionContexts;
    (0, assembly_1.startRumAssembly)(configuration, lifeCycle, sessionManager, viewContexts, urlContexts, actionContexts, buildCommonContext, reportError);
    return {
        viewContexts: viewContexts,
        foregroundContexts: foregroundContexts,
        urlContexts: urlContexts,
        addAction: addAction,
        actionContexts: actionContexts,
        stop: function () {
            viewContexts.stop();
            foregroundContexts.stop();
        },
    };
}
exports.startRumEventCollection = startRumEventCollection;

},{"../browser/domMutationObservable":460,"../browser/locationChangeObservable":462,"../browser/performanceCollection":463,"../domain/assembly":465,"../domain/configuration":466,"../domain/contexts/commonContext":468,"../domain/contexts/featureFlagContext":470,"../domain/contexts/foregroundContexts":471,"../domain/contexts/internalContext":472,"../domain/contexts/pageStateHistory":473,"../domain/contexts/urlContexts":475,"../domain/contexts/viewContexts":476,"../domain/lifeCycle":477,"../domain/requestCollection":478,"../domain/rumEventsCollection/action/actionCollection":479,"../domain/rumEventsCollection/error/errorCollection":486,"../domain/rumEventsCollection/longTask/longTaskCollection":489,"../domain/rumEventsCollection/resource/resourceCollection":491,"../domain/rumEventsCollection/view/viewCollection":498,"../domain/rumSessionManager":499,"../domain/startCustomerDataTelemetry":500,"../transport/startRumBatch":506,"../transport/startRumEventBridge":507,"@datadog/browser-core":432}],460:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMutationObserverConstructor = exports.createDOMMutationObservable = void 0;
var browser_core_1 = require("@datadog/browser-core");
function createDOMMutationObservable() {
    var MutationObserver = getMutationObserverConstructor();
    var observable = new browser_core_1.Observable(function () {
        if (!MutationObserver) {
            return;
        }
        var observer = new MutationObserver((0, browser_core_1.monitor)(function () { return observable.notify(); }));
        observer.observe(document, {
            attributes: true,
            characterData: true,
            childList: true,
            subtree: true,
        });
        return function () { return observer.disconnect(); };
    });
    return observable;
}
exports.createDOMMutationObservable = createDOMMutationObservable;
function getMutationObserverConstructor() {
    var constructor;
    var browserWindow = window;
    // Angular uses Zone.js to provide a context persisting across async tasks.  Zone.js replaces the
    // global MutationObserver constructor with a patched version to support the context propagation.
    // There is an ongoing issue[1][2] with this setup when using a MutationObserver within a Angular
    // component: on some occasions, the callback is being called in an infinite loop, causing the
    // page to freeze (even if the callback is completely empty).
    //
    // To work around this issue, we try to get the original MutationObserver constructor stored by
    // Zone.js.
    //
    // [1] https://github.com/angular/angular/issues/26948
    // [2] https://github.com/angular/angular/issues/31712
    if (browserWindow.Zone) {
        // Zone.js 0.8.6+ is storing original class constructors into the browser 'window' object[3].
        //
        // [3] https://github.com/angular/angular/blob/6375fa79875c0fe7b815efc45940a6e6f5c9c9eb/packages/zone.js/lib/common/utils.ts#L288
        constructor = (0, browser_core_1.getZoneJsOriginalValue)(browserWindow, 'MutationObserver');
        if (browserWindow.MutationObserver && constructor === browserWindow.MutationObserver) {
            // Anterior Zone.js versions (used in Angular 2) does not expose the original MutationObserver
            // in the 'window' object. Luckily, the patched MutationObserver class is storing an original
            // instance in its properties[4]. Let's get the original MutationObserver constructor from
            // there.
            //
            // [4] https://github.com/angular/zone.js/blob/v0.8.5/lib/common/utils.ts#L412
            var patchedInstance = new browserWindow.MutationObserver(browser_core_1.noop);
            var originalInstance = (0, browser_core_1.getZoneJsOriginalValue)(patchedInstance, 'originalInstance');
            constructor = originalInstance && originalInstance.constructor;
        }
    }
    if (!constructor) {
        constructor = browserWindow.MutationObserver;
    }
    return constructor;
}
exports.getMutationObserverConstructor = getMutationObserverConstructor;

},{"@datadog/browser-core":432}],461:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getParentNode = exports.getChildNodes = exports.isNodeShadowRoot = exports.isNodeShadowHost = exports.isElementNode = exports.isCommentNode = exports.isTextNode = void 0;
function isTextNode(node) {
    return node.nodeType === Node.TEXT_NODE;
}
exports.isTextNode = isTextNode;
function isCommentNode(node) {
    return node.nodeType === Node.COMMENT_NODE;
}
exports.isCommentNode = isCommentNode;
function isElementNode(node) {
    return node.nodeType === Node.ELEMENT_NODE;
}
exports.isElementNode = isElementNode;
function isNodeShadowHost(node) {
    return isElementNode(node) && Boolean(node.shadowRoot);
}
exports.isNodeShadowHost = isNodeShadowHost;
function isNodeShadowRoot(node) {
    var shadowRoot = node;
    return !!shadowRoot.host && shadowRoot.nodeType === Node.DOCUMENT_FRAGMENT_NODE && isElementNode(shadowRoot.host);
}
exports.isNodeShadowRoot = isNodeShadowRoot;
function getChildNodes(node) {
    return isNodeShadowHost(node) ? node.shadowRoot.childNodes : node.childNodes;
}
exports.getChildNodes = getChildNodes;
/**
 * Return `host` in case if the current node is a shadow root otherwise will return the `parentNode`
 */
function getParentNode(node) {
    return isNodeShadowRoot(node) ? node.host : node.parentNode;
}
exports.getParentNode = getParentNode;

},{}],462:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLocationChangeObservable = void 0;
var browser_core_1 = require("@datadog/browser-core");
function createLocationChangeObservable(location) {
    var currentLocation = (0, browser_core_1.shallowClone)(location);
    var observable = new browser_core_1.Observable(function () {
        var stopHistoryTracking = trackHistory(onLocationChange).stop;
        var stopHashTracking = trackHash(onLocationChange).stop;
        return function () {
            stopHistoryTracking();
            stopHashTracking();
        };
    });
    function onLocationChange() {
        if (currentLocation.href === location.href) {
            return;
        }
        var newLocation = (0, browser_core_1.shallowClone)(location);
        observable.notify({
            newLocation: newLocation,
            oldLocation: currentLocation,
        });
        currentLocation = newLocation;
    }
    return observable;
}
exports.createLocationChangeObservable = createLocationChangeObservable;
function trackHistory(onHistoryChange) {
    var stopInstrumentingPushState = (0, browser_core_1.instrumentMethodAndCallOriginal)(history, 'pushState', {
        after: onHistoryChange,
    }).stop;
    var stopInstrumentingReplaceState = (0, browser_core_1.instrumentMethodAndCallOriginal)(history, 'replaceState', {
        after: onHistoryChange,
    }).stop;
    var removeListener = (0, browser_core_1.addEventListener)(window, "popstate" /* POP_STATE */, onHistoryChange).stop;
    return {
        stop: function () {
            stopInstrumentingPushState();
            stopInstrumentingReplaceState();
            removeListener();
        },
    };
}
function trackHash(onHashChange) {
    return (0, browser_core_1.addEventListener)(window, "hashchange" /* HASH_CHANGE */, onHashChange);
}

},{"@datadog/browser-core":432}],463:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.retrieveInitialDocumentResourceTiming = exports.startPerformanceCollection = exports.supportPerformanceTimingEvent = void 0;
var browser_core_1 = require("@datadog/browser-core");
var resourceUtils_1 = require("../domain/rumEventsCollection/resource/resourceUtils");
var getDocumentTraceId_1 = require("../domain/tracing/getDocumentTraceId");
function supportPerformanceObject() {
    return window.performance !== undefined && 'getEntries' in performance;
}
function supportPerformanceTimingEvent(entryType) {
    return (window.PerformanceObserver &&
        PerformanceObserver.supportedEntryTypes !== undefined &&
        PerformanceObserver.supportedEntryTypes.includes(entryType));
}
exports.supportPerformanceTimingEvent = supportPerformanceTimingEvent;
function startPerformanceCollection(lifeCycle, configuration) {
    retrieveInitialDocumentResourceTiming(function (timing) {
        handleRumPerformanceEntries(lifeCycle, configuration, [timing]);
    });
    if (supportPerformanceObject()) {
        var performanceEntries_1 = performance.getEntries();
        // Because the performance entry list can be quite large
        // delay the computation to prevent the SDK from blocking the main thread on init
        (0, browser_core_1.setTimeout)(function () { return handleRumPerformanceEntries(lifeCycle, configuration, performanceEntries_1); });
    }
    if (window.PerformanceObserver) {
        var handlePerformanceEntryList_1 = (0, browser_core_1.monitor)(function (entries) {
            return handleRumPerformanceEntries(lifeCycle, configuration, entries.getEntries());
        });
        var mainEntries = ['resource', 'navigation', 'longtask', 'paint'];
        var experimentalEntries = ['largest-contentful-paint', 'first-input', 'layout-shift'];
        try {
            // Experimental entries are not retrieved by performance.getEntries()
            // use a single PerformanceObserver with buffered flag by type
            // to get values that could happen before SDK init
            experimentalEntries.forEach(function (type) {
                var observer = new PerformanceObserver(handlePerformanceEntryList_1);
                observer.observe({ type: type, buffered: true });
            });
        }
        catch (e) {
            // Some old browser versions (ex: chrome 67) don't support the PerformanceObserver type and buffered options
            // In these cases, fallback to PerformanceObserver with entryTypes
            mainEntries.push.apply(mainEntries, experimentalEntries);
        }
        var mainObserver = new PerformanceObserver(handlePerformanceEntryList_1);
        mainObserver.observe({ entryTypes: mainEntries });
        if (supportPerformanceObject() && 'addEventListener' in performance) {
            // https://bugzilla.mozilla.org/show_bug.cgi?id=1559377
            performance.addEventListener('resourcetimingbufferfull', function () {
                performance.clearResourceTimings();
            });
        }
    }
    if (!supportPerformanceTimingEvent('navigation')) {
        retrieveNavigationTiming(function (timing) {
            handleRumPerformanceEntries(lifeCycle, configuration, [timing]);
        });
    }
    if (!supportPerformanceTimingEvent('first-input')) {
        retrieveFirstInputTiming(function (timing) {
            handleRumPerformanceEntries(lifeCycle, configuration, [timing]);
        });
    }
}
exports.startPerformanceCollection = startPerformanceCollection;
function retrieveInitialDocumentResourceTiming(callback) {
    (0, browser_core_1.runOnReadyState)('interactive', function () {
        var timing;
        var forcedAttributes = {
            entryType: 'resource',
            initiatorType: resourceUtils_1.FAKE_INITIAL_DOCUMENT,
            traceId: (0, getDocumentTraceId_1.getDocumentTraceId)(document),
        };
        if (supportPerformanceTimingEvent('navigation') && performance.getEntriesByType('navigation').length > 0) {
            var navigationEntry = performance.getEntriesByType('navigation')[0];
            timing = (0, browser_core_1.assign)(navigationEntry.toJSON(), forcedAttributes);
        }
        else {
            var relativePerformanceTiming = computeRelativePerformanceTiming();
            timing = (0, browser_core_1.assign)(relativePerformanceTiming, {
                decodedBodySize: 0,
                duration: relativePerformanceTiming.responseEnd,
                name: window.location.href,
                startTime: 0,
            }, forcedAttributes);
        }
        callback(timing);
    });
}
exports.retrieveInitialDocumentResourceTiming = retrieveInitialDocumentResourceTiming;
function retrieveNavigationTiming(callback) {
    function sendFakeTiming() {
        callback((0, browser_core_1.assign)(computeRelativePerformanceTiming(), {
            entryType: 'navigation',
        }));
    }
    (0, browser_core_1.runOnReadyState)('complete', function () {
        // Send it a bit after the actual load event, so the "loadEventEnd" timing is accurate
        (0, browser_core_1.setTimeout)(sendFakeTiming);
    });
}
/**
 * first-input timing entry polyfill based on
 * https://github.com/GoogleChrome/web-vitals/blob/master/src/lib/polyfills/firstInputPolyfill.ts
 */
function retrieveFirstInputTiming(callback) {
    var startTimeStamp = (0, browser_core_1.dateNow)();
    var timingSent = false;
    var removeEventListeners = (0, browser_core_1.addEventListeners)(window, ["click" /* CLICK */, "mousedown" /* MOUSE_DOWN */, "keydown" /* KEY_DOWN */, "touchstart" /* TOUCH_START */, "pointerdown" /* POINTER_DOWN */], function (evt) {
        // Only count cancelable events, which should trigger behavior important to the user.
        if (!evt.cancelable) {
            return;
        }
        // This timing will be used to compute the "first Input delay", which is the delta between
        // when the system received the event (e.g. evt.timeStamp) and when it could run the callback
        // (e.g. performance.now()).
        var timing = {
            entryType: 'first-input',
            processingStart: (0, browser_core_1.relativeNow)(),
            startTime: evt.timeStamp,
        };
        if (evt.type === "pointerdown" /* POINTER_DOWN */) {
            sendTimingIfPointerIsNotCancelled(timing);
        }
        else {
            sendTiming(timing);
        }
    }, { passive: true, capture: true }).stop;
    /**
     * Pointer events are a special case, because they can trigger main or compositor thread behavior.
     * We differentiate these cases based on whether or not we see a pointercancel event, which are
     * fired when we scroll. If we're scrolling we don't need to report input delay since FID excludes
     * scrolling and pinch/zooming.
     */
    function sendTimingIfPointerIsNotCancelled(timing) {
        (0, browser_core_1.addEventListeners)(window, ["pointerup" /* POINTER_UP */, "pointercancel" /* POINTER_CANCEL */], function (event) {
            if (event.type === "pointerup" /* POINTER_UP */) {
                sendTiming(timing);
            }
        }, { once: true });
    }
    function sendTiming(timing) {
        if (!timingSent) {
            timingSent = true;
            removeEventListeners();
            // In some cases the recorded delay is clearly wrong, e.g. it's negative or it's larger than
            // the time between now and when the page was loaded.
            // - https://github.com/GoogleChromeLabs/first-input-delay/issues/4
            // - https://github.com/GoogleChromeLabs/first-input-delay/issues/6
            // - https://github.com/GoogleChromeLabs/first-input-delay/issues/7
            var delay = timing.processingStart - timing.startTime;
            if (delay >= 0 && delay < (0, browser_core_1.dateNow)() - startTimeStamp) {
                callback(timing);
            }
        }
    }
}
function computeRelativePerformanceTiming() {
    var result = {};
    var timing = performance.timing;
    for (var key in timing) {
        if ((0, browser_core_1.isNumber)(timing[key])) {
            var numberKey = key;
            var timingElement = timing[numberKey];
            result[numberKey] = timingElement === 0 ? 0 : (0, browser_core_1.getRelativeTime)(timingElement);
        }
    }
    return result;
}
function handleRumPerformanceEntries(lifeCycle, configuration, entries) {
    var rumPerformanceEntries = entries.filter(function (entry) {
        return entry.entryType === 'resource' ||
            entry.entryType === 'navigation' ||
            entry.entryType === 'paint' ||
            entry.entryType === 'longtask' ||
            entry.entryType === 'largest-contentful-paint' ||
            entry.entryType === 'first-input' ||
            entry.entryType === 'layout-shift';
    });
    var rumAllowedPerformanceEntries = rumPerformanceEntries.filter(function (entry) { return !isIncompleteNavigation(entry) && !isForbiddenResource(configuration, entry); });
    if (rumAllowedPerformanceEntries.length) {
        lifeCycle.notify(0 /* PERFORMANCE_ENTRIES_COLLECTED */, rumAllowedPerformanceEntries);
    }
}
function isIncompleteNavigation(entry) {
    return entry.entryType === 'navigation' && entry.loadEventEnd <= 0;
}
function isForbiddenResource(configuration, entry) {
    return entry.entryType === 'resource' && !(0, resourceUtils_1.isAllowedRequestUrl)(configuration, entry.name);
}

},{"../domain/rumEventsCollection/resource/resourceUtils":492,"../domain/tracing/getDocumentTraceId":501,"@datadog/browser-core":432}],464:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getViewportDimension = exports.createViewportObservable = exports.initViewportObservable = void 0;
var browser_core_1 = require("@datadog/browser-core");
var viewportObservable;
function initViewportObservable() {
    if (!viewportObservable) {
        viewportObservable = createViewportObservable();
    }
    return viewportObservable;
}
exports.initViewportObservable = initViewportObservable;
function createViewportObservable() {
    var observable = new browser_core_1.Observable(function () {
        var updateDimension = (0, browser_core_1.throttle)(function () {
            observable.notify(getViewportDimension());
        }, 200).throttled;
        return (0, browser_core_1.addEventListener)(window, "resize" /* RESIZE */, updateDimension, { capture: true, passive: true }).stop;
    });
    return observable;
}
exports.createViewportObservable = createViewportObservable;
// excludes the width and height of any rendered classic scrollbar that is fixed to the visual viewport
function getViewportDimension() {
    var visual = window.visualViewport;
    if (visual) {
        return {
            width: Number(visual.width * visual.scale),
            height: Number(visual.height * visual.scale),
        };
    }
    return {
        width: Number(window.innerWidth || 0),
        height: Number(window.innerHeight || 0),
    };
}
exports.getViewportDimension = getViewportDimension;

},{"@datadog/browser-core":432}],465:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startRumAssembly = void 0;
var browser_core_1 = require("@datadog/browser-core");
var syntheticsContext_1 = require("./contexts/syntheticsContext");
var ciTestContext_1 = require("./contexts/ciTestContext");
var displayContext_1 = require("./contexts/displayContext");
var VIEW_EVENTS_MODIFIABLE_FIELD_PATHS = [
    // Fields with sensitive data
    'view.url',
    'view.referrer',
    'action.target.name',
    'error.message',
    'error.stack',
    'error.resource.url',
    'resource.url',
];
var OTHER_EVENTS_MODIFIABLE_FIELD_PATHS = VIEW_EVENTS_MODIFIABLE_FIELD_PATHS.concat([
    // User-customizable field
    'context',
]);
function startRumAssembly(configuration, lifeCycle, sessionManager, viewContexts, urlContexts, actionContexts, buildCommonContext, reportError) {
    var _a;
    var eventRateLimiters = (_a = {},
        _a["error" /* ERROR */] = (0, browser_core_1.createEventRateLimiter)("error" /* ERROR */, configuration.eventRateLimiterThreshold, reportError),
        _a["action" /* ACTION */] = (0, browser_core_1.createEventRateLimiter)("action" /* ACTION */, configuration.eventRateLimiterThreshold, reportError),
        _a);
    var syntheticsContext = (0, syntheticsContext_1.getSyntheticsContext)();
    var ciTestContext = (0, ciTestContext_1.getCiTestContext)();
    lifeCycle.subscribe(10 /* RAW_RUM_EVENT_COLLECTED */, function (_a) {
        var startTime = _a.startTime, rawRumEvent = _a.rawRumEvent, domainContext = _a.domainContext, savedCommonContext = _a.savedCommonContext, customerContext = _a.customerContext;
        var viewContext = viewContexts.findView(startTime);
        var urlContext = urlContexts.findUrl(startTime);
        // allow to send events if the session was tracked when they start
        // except for views which are continuously updated
        // TODO: stop sending view updates when session is expired
        var session = sessionManager.findTrackedSession(rawRumEvent.type !== "view" /* VIEW */ ? startTime : undefined);
        if (session && viewContext && urlContext) {
            var commonContext = savedCommonContext || buildCommonContext();
            var actionId = actionContexts.findActionId(startTime);
            var rumContext = {
                _dd: {
                    format_version: 2,
                    drift: (0, browser_core_1.currentDrift)(),
                    session: {
                        plan: session.plan,
                    },
                    browser_sdk_version: (0, browser_core_1.canUseEventBridge)() ? "4.36.0" : undefined,
                },
                application: {
                    id: configuration.applicationId,
                },
                date: (0, browser_core_1.timeStampNow)(),
                service: viewContext.service || configuration.service,
                version: viewContext.version || configuration.version,
                source: 'browser',
                session: {
                    id: session.id,
                    type: syntheticsContext ? "synthetics" /* SYNTHETICS */ : ciTestContext ? "ci_test" /* CI_TEST */ : "user" /* USER */,
                },
                view: {
                    id: viewContext.id,
                    name: viewContext.name,
                    url: urlContext.url,
                    referrer: urlContext.referrer,
                },
                action: needToAssembleWithAction(rawRumEvent) && actionId ? { id: actionId } : undefined,
                synthetics: syntheticsContext,
                ci_test: ciTestContext,
                display: (0, displayContext_1.getDisplayContext)(),
            };
            var serverRumEvent = (0, browser_core_1.combine)(rumContext, rawRumEvent);
            serverRumEvent.context = (0, browser_core_1.combine)(commonContext.context, customerContext);
            if (!('has_replay' in serverRumEvent.session)) {
                ;
                serverRumEvent.session.has_replay = commonContext.hasReplay;
            }
            if (!(0, browser_core_1.isEmptyObject)(commonContext.user)) {
                ;
                serverRumEvent.usr = commonContext.user;
            }
            if (shouldSend(serverRumEvent, configuration.beforeSend, domainContext, eventRateLimiters)) {
                if ((0, browser_core_1.isEmptyObject)(serverRumEvent.context)) {
                    delete serverRumEvent.context;
                }
                lifeCycle.notify(11 /* RUM_EVENT_COLLECTED */, serverRumEvent);
            }
        }
    });
}
exports.startRumAssembly = startRumAssembly;
function shouldSend(event, beforeSend, domainContext, eventRateLimiters) {
    var _a;
    if (beforeSend) {
        var result = (0, browser_core_1.limitModification)(event, event.type === "view" /* VIEW */ ? VIEW_EVENTS_MODIFIABLE_FIELD_PATHS : OTHER_EVENTS_MODIFIABLE_FIELD_PATHS, function (event) { return beforeSend(event, domainContext); });
        if (result === false && event.type !== "view" /* VIEW */) {
            return false;
        }
        if (result === false) {
            browser_core_1.display.warn("Can't dismiss view events using beforeSend!");
        }
    }
    var rateLimitReached = (_a = eventRateLimiters[event.type]) === null || _a === void 0 ? void 0 : _a.isLimitReached();
    return !rateLimitReached;
}
function needToAssembleWithAction(event) {
    return ["error" /* ERROR */, "resource" /* RESOURCE */, "long_task" /* LONG_TASK */].indexOf(event.type) !== -1;
}

},{"./contexts/ciTestContext":467,"./contexts/displayContext":469,"./contexts/syntheticsContext":474,"@datadog/browser-core":432}],466:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeRumConfiguration = exports.validateAndBuildRumConfiguration = void 0;
var browser_core_1 = require("@datadog/browser-core");
var tracer_1 = require("./tracing/tracer");
function validateAndBuildRumConfiguration(initConfiguration) {
    var _a, _b, _c, _d, _e, _f;
    if (!initConfiguration.applicationId) {
        browser_core_1.display.error('Application ID is not configured, no RUM data will be collected.');
        return;
    }
    if (initConfiguration.sessionReplaySampleRate !== undefined &&
        !(0, browser_core_1.isPercentage)(initConfiguration.sessionReplaySampleRate)) {
        browser_core_1.display.error('Session Replay Sample Rate should be a number between 0 and 100');
        return;
    }
    // TODO remove fallback in next major
    var premiumSampleRate = (_a = initConfiguration.premiumSampleRate) !== null && _a !== void 0 ? _a : initConfiguration.replaySampleRate;
    if (premiumSampleRate !== undefined && initConfiguration.sessionReplaySampleRate !== undefined) {
        browser_core_1.display.warn('Ignoring Premium Sample Rate because Session Replay Sample Rate is set');
        premiumSampleRate = undefined;
    }
    if (premiumSampleRate !== undefined && !(0, browser_core_1.isPercentage)(premiumSampleRate)) {
        browser_core_1.display.error('Premium Sample Rate should be a number between 0 and 100');
        return;
    }
    var traceSampleRate = (_b = initConfiguration.traceSampleRate) !== null && _b !== void 0 ? _b : initConfiguration.tracingSampleRate;
    if (traceSampleRate !== undefined && !(0, browser_core_1.isPercentage)(traceSampleRate)) {
        browser_core_1.display.error('Trace Sample Rate should be a number between 0 and 100');
        return;
    }
    if (initConfiguration.excludedActivityUrls !== undefined && !Array.isArray(initConfiguration.excludedActivityUrls)) {
        browser_core_1.display.error('Excluded Activity Urls should be an array');
        return;
    }
    var allowedTracingUrls = validateAndBuildTracingOptions(initConfiguration);
    if (!allowedTracingUrls) {
        return;
    }
    var baseConfiguration = (0, browser_core_1.validateAndBuildConfiguration)(initConfiguration);
    if (!baseConfiguration) {
        return;
    }
    var trackUserInteractions = !!((_c = initConfiguration.trackUserInteractions) !== null && _c !== void 0 ? _c : initConfiguration.trackInteractions);
    var trackFrustrations = !!initConfiguration.trackFrustrations;
    return (0, browser_core_1.assign)({
        applicationId: initConfiguration.applicationId,
        version: initConfiguration.version,
        actionNameAttribute: initConfiguration.actionNameAttribute,
        sessionReplaySampleRate: (_e = (_d = initConfiguration.sessionReplaySampleRate) !== null && _d !== void 0 ? _d : premiumSampleRate) !== null && _e !== void 0 ? _e : 100,
        oldPlansBehavior: initConfiguration.sessionReplaySampleRate === undefined,
        traceSampleRate: traceSampleRate,
        allowedTracingUrls: allowedTracingUrls,
        excludedActivityUrls: (_f = initConfiguration.excludedActivityUrls) !== null && _f !== void 0 ? _f : [],
        trackUserInteractions: trackUserInteractions || trackFrustrations,
        trackFrustrations: trackFrustrations,
        trackViewsManually: !!initConfiguration.trackViewsManually,
        trackResources: initConfiguration.trackResources,
        trackLongTasks: initConfiguration.trackLongTasks,
        defaultPrivacyLevel: (0, browser_core_1.objectHasValue)(browser_core_1.DefaultPrivacyLevel, initConfiguration.defaultPrivacyLevel)
            ? initConfiguration.defaultPrivacyLevel
            : browser_core_1.DefaultPrivacyLevel.MASK_USER_INPUT,
        customerDataTelemetrySampleRate: 1,
    }, baseConfiguration);
}
exports.validateAndBuildRumConfiguration = validateAndBuildRumConfiguration;
/**
 * Handles allowedTracingUrls and processes legacy allowedTracingOrigins
 */
function validateAndBuildTracingOptions(initConfiguration) {
    // Advise about parameters precedence.
    if (initConfiguration.allowedTracingUrls !== undefined && initConfiguration.allowedTracingOrigins !== undefined) {
        browser_core_1.display.warn('Both allowedTracingUrls and allowedTracingOrigins (deprecated) have been defined. The parameter allowedTracingUrls will override allowedTracingOrigins.');
    }
    // Handle allowedTracingUrls first
    if (initConfiguration.allowedTracingUrls !== undefined) {
        if (!Array.isArray(initConfiguration.allowedTracingUrls)) {
            browser_core_1.display.error('Allowed Tracing URLs should be an array');
            return;
        }
        if (initConfiguration.allowedTracingUrls.length !== 0 && initConfiguration.service === undefined) {
            browser_core_1.display.error('Service needs to be configured when tracing is enabled');
            return;
        }
        // Convert from (MatchOption | TracingOption) to TracingOption, remove unknown properties
        var tracingOptions_1 = [];
        initConfiguration.allowedTracingUrls.forEach(function (option) {
            if ((0, browser_core_1.isMatchOption)(option)) {
                tracingOptions_1.push({ match: option, propagatorTypes: ['datadog'] });
            }
            else if ((0, tracer_1.isTracingOption)(option)) {
                tracingOptions_1.push(option);
            }
            else {
                browser_core_1.display.warn('Allowed Tracing Urls parameters should be a string, RegExp, function, or an object. Ignoring parameter', option);
            }
        });
        return tracingOptions_1;
    }
    // Handle conversion of allowedTracingOrigins to allowedTracingUrls
    if (initConfiguration.allowedTracingOrigins !== undefined) {
        if (!Array.isArray(initConfiguration.allowedTracingOrigins)) {
            browser_core_1.display.error('Allowed Tracing Origins should be an array');
            return;
        }
        if (initConfiguration.allowedTracingOrigins.length !== 0 && initConfiguration.service === undefined) {
            browser_core_1.display.error('Service needs to be configured when tracing is enabled');
            return;
        }
        var tracingOptions_2 = [];
        initConfiguration.allowedTracingOrigins.forEach(function (legacyMatchOption) {
            var tracingOption = convertLegacyMatchOptionToTracingOption(legacyMatchOption);
            if (tracingOption) {
                tracingOptions_2.push(tracingOption);
            }
        });
        return tracingOptions_2;
    }
    return [];
}
/**
 * Converts parameters from the deprecated allowedTracingOrigins
 * to allowedTracingUrls. Handles the change from origin to full URLs.
 */
function convertLegacyMatchOptionToTracingOption(item) {
    var match;
    if (typeof item === 'string') {
        match = item;
    }
    else if (item instanceof RegExp) {
        match = function (url) { return item.test((0, browser_core_1.getOrigin)(url)); };
    }
    else if (typeof item === 'function') {
        match = function (url) { return item((0, browser_core_1.getOrigin)(url)); };
    }
    if (match === undefined) {
        browser_core_1.display.warn('Allowed Tracing Origins parameters should be a string, RegExp or function. Ignoring parameter', item);
        return undefined;
    }
    return { match: match, propagatorTypes: ['datadog'] };
}
/**
 * Combines the selected tracing propagators from the different options in allowedTracingUrls,
 * and assumes 'datadog' has been selected when using allowedTracingOrigins
 */
function getSelectedTracingPropagators(configuration) {
    var usedTracingPropagators = new Set();
    if (Array.isArray(configuration.allowedTracingUrls) && configuration.allowedTracingUrls.length > 0) {
        configuration.allowedTracingUrls.forEach(function (option) {
            if ((0, browser_core_1.isMatchOption)(option)) {
                usedTracingPropagators.add('datadog');
            }
            else {
                option.propagatorTypes.forEach(function (propagatorType) { return usedTracingPropagators.add(propagatorType); });
            }
        });
    }
    if (Array.isArray(configuration.allowedTracingOrigins) && configuration.allowedTracingOrigins.length > 0) {
        usedTracingPropagators.add('datadog');
    }
    return (0, browser_core_1.arrayFrom)(usedTracingPropagators);
}
function serializeRumConfiguration(configuration) {
    var _a, _b;
    var baseSerializedConfiguration = (0, browser_core_1.serializeConfiguration)(configuration);
    return (0, browser_core_1.assign)({
        premium_sample_rate: configuration.premiumSampleRate,
        replay_sample_rate: configuration.replaySampleRate,
        session_replay_sample_rate: configuration.sessionReplaySampleRate,
        trace_sample_rate: (_a = configuration.traceSampleRate) !== null && _a !== void 0 ? _a : configuration.tracingSampleRate,
        action_name_attribute: configuration.actionNameAttribute,
        use_allowed_tracing_origins: Array.isArray(configuration.allowedTracingOrigins) && configuration.allowedTracingOrigins.length > 0,
        use_allowed_tracing_urls: Array.isArray(configuration.allowedTracingUrls) && configuration.allowedTracingUrls.length > 0,
        selected_tracing_propagators: getSelectedTracingPropagators(configuration),
        default_privacy_level: configuration.defaultPrivacyLevel,
        use_excluded_activity_urls: Array.isArray(configuration.allowedTracingOrigins) && configuration.allowedTracingOrigins.length > 0,
        track_frustrations: configuration.trackFrustrations,
        track_views_manually: configuration.trackViewsManually,
        track_user_interactions: (_b = configuration.trackUserInteractions) !== null && _b !== void 0 ? _b : configuration.trackInteractions,
    }, baseSerializedConfiguration);
}
exports.serializeRumConfiguration = serializeRumConfiguration;

},{"./tracing/tracer":502,"@datadog/browser-core":432}],467:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCiTestContext = void 0;
function getCiTestContext() {
    var _a;
    var testExecutionId = (_a = window.Cypress) === null || _a === void 0 ? void 0 : _a.env('traceId');
    if (typeof testExecutionId === 'string') {
        return {
            test_execution_id: testExecutionId,
        };
    }
}
exports.getCiTestContext = getCiTestContext;

},{}],468:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildCommonContext = void 0;
function buildCommonContext(globalContextManager, userContextManager, recorderApi) {
    return {
        context: globalContextManager.getContext(),
        user: userContextManager.getContext(),
        hasReplay: recorderApi.isRecording() ? true : undefined,
    };
}
exports.buildCommonContext = buildCommonContext;

},{}],469:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetDisplayContext = exports.getDisplayContext = void 0;
var browser_core_1 = require("@datadog/browser-core");
var viewportObservable_1 = require("../../browser/viewportObservable");
var viewport;
var stopListeners;
function getDisplayContext() {
    if (!(0, browser_core_1.isExperimentalFeatureEnabled)('clickmap')) {
        return;
    }
    if (!viewport) {
        viewport = (0, viewportObservable_1.getViewportDimension)();
        stopListeners = (0, viewportObservable_1.initViewportObservable)().subscribe(function (viewportDimension) {
            viewport = viewportDimension;
        }).unsubscribe;
    }
    return {
        viewport: viewport,
    };
}
exports.getDisplayContext = getDisplayContext;
function resetDisplayContext() {
    if (stopListeners) {
        stopListeners();
    }
    viewport = undefined;
}
exports.resetDisplayContext = resetDisplayContext;

},{"../../browser/viewportObservable":464,"@datadog/browser-core":432}],470:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startFeatureFlagContexts = exports.FEATURE_FLAG_CONTEXT_TIME_OUT_DELAY = void 0;
var browser_core_1 = require("@datadog/browser-core");
exports.FEATURE_FLAG_CONTEXT_TIME_OUT_DELAY = browser_core_1.SESSION_TIME_OUT_DELAY;
/**
 * Start feature flag contexts
 *
 * Feature flag contexts follow the life of views.
 * A new context is added when a view is created and ended when the view is ended
 *
 * Note: we choose not to add a new context at each evaluation to save memory
 */
function startFeatureFlagContexts(lifeCycle, computeBytesCountImpl) {
    if (computeBytesCountImpl === void 0) { computeBytesCountImpl = browser_core_1.computeBytesCount; }
    if (!(0, browser_core_1.isExperimentalFeatureEnabled)('feature_flags')) {
        return {
            findFeatureFlagEvaluations: function () { return undefined; },
            getFeatureFlagBytesCount: function () { return 0; },
            addFeatureFlagEvaluation: browser_core_1.noop,
        };
    }
    var featureFlagContexts = new browser_core_1.ContextHistory(exports.FEATURE_FLAG_CONTEXT_TIME_OUT_DELAY);
    var bytesCountCache;
    lifeCycle.subscribe(4 /* VIEW_ENDED */, function (_a) {
        var endClocks = _a.endClocks;
        featureFlagContexts.closeActive(endClocks.relative);
    });
    lifeCycle.subscribe(2 /* VIEW_CREATED */, function (_a) {
        var startClocks = _a.startClocks;
        featureFlagContexts.add({}, startClocks.relative);
        bytesCountCache = undefined;
    });
    return {
        findFeatureFlagEvaluations: function (startTime) { return featureFlagContexts.find(startTime); },
        getFeatureFlagBytesCount: function () {
            var currentContext = featureFlagContexts.find();
            if (!currentContext) {
                return 0;
            }
            if (bytesCountCache === undefined) {
                bytesCountCache = computeBytesCountImpl((0, browser_core_1.jsonStringify)(currentContext));
            }
            return bytesCountCache;
        },
        addFeatureFlagEvaluation: function (key, value) {
            var currentContext = featureFlagContexts.find();
            if (currentContext) {
                currentContext[key] = (0, browser_core_1.deepClone)(value);
                bytesCountCache = undefined;
            }
        },
    };
}
exports.startFeatureFlagContexts = startFeatureFlagContexts;

},{"@datadog/browser-core":432}],471:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.closeForegroundPeriod = exports.addNewForegroundPeriod = exports.startForegroundContexts = exports.MAX_NUMBER_OF_STORED_FOREGROUND_PERIODS = exports.MAX_NUMBER_OF_SELECTABLE_FOREGROUND_PERIODS = void 0;
var browser_core_1 = require("@datadog/browser-core");
// Arbitrary value to cap number of element mostly for backend & to save bandwidth
exports.MAX_NUMBER_OF_SELECTABLE_FOREGROUND_PERIODS = 500;
// Arbitrary value to cap number of element mostly for memory consumption in the browser
exports.MAX_NUMBER_OF_STORED_FOREGROUND_PERIODS = 2500;
var foregroundPeriods = [];
function startForegroundContexts() {
    if (document.hasFocus()) {
        addNewForegroundPeriod();
    }
    var stopForegroundTracking = trackFocus(addNewForegroundPeriod).stop;
    var stopBlurTracking = trackBlur(closeForegroundPeriod).stop;
    return {
        isInForegroundAt: isInForegroundAt,
        selectInForegroundPeriodsFor: selectInForegroundPeriodsFor,
        stop: function () {
            foregroundPeriods = [];
            stopForegroundTracking();
            stopBlurTracking();
        },
    };
}
exports.startForegroundContexts = startForegroundContexts;
function addNewForegroundPeriod() {
    if (foregroundPeriods.length > exports.MAX_NUMBER_OF_STORED_FOREGROUND_PERIODS) {
        return;
    }
    var currentForegroundPeriod = foregroundPeriods[foregroundPeriods.length - 1];
    var now = (0, browser_core_1.relativeNow)();
    if (currentForegroundPeriod !== undefined && currentForegroundPeriod.end === undefined) {
        return;
    }
    foregroundPeriods.push({
        start: now,
    });
}
exports.addNewForegroundPeriod = addNewForegroundPeriod;
function closeForegroundPeriod() {
    if (foregroundPeriods.length === 0) {
        return;
    }
    var currentForegroundPeriod = foregroundPeriods[foregroundPeriods.length - 1];
    var now = (0, browser_core_1.relativeNow)();
    if (currentForegroundPeriod.end !== undefined) {
        return;
    }
    currentForegroundPeriod.end = now;
}
exports.closeForegroundPeriod = closeForegroundPeriod;
function trackFocus(onFocusChange) {
    return (0, browser_core_1.addEventListener)(window, "focus" /* FOCUS */, function (event) {
        if (!event.isTrusted) {
            return;
        }
        onFocusChange();
    });
}
function trackBlur(onBlurChange) {
    return (0, browser_core_1.addEventListener)(window, "blur" /* BLUR */, function (event) {
        if (!event.isTrusted) {
            return;
        }
        onBlurChange();
    });
}
function isInForegroundAt(startTime) {
    for (var i = foregroundPeriods.length - 1; i >= 0; i--) {
        var foregroundPeriod = foregroundPeriods[i];
        if (foregroundPeriod.end !== undefined && startTime > foregroundPeriod.end) {
            break;
        }
        if (startTime > foregroundPeriod.start &&
            (foregroundPeriod.end === undefined || startTime < foregroundPeriod.end)) {
            return true;
        }
    }
    return false;
}
function selectInForegroundPeriodsFor(eventStartTime, duration) {
    var eventEndTime = (0, browser_core_1.addDuration)(eventStartTime, duration);
    var filteredForegroundPeriods = [];
    var earliestIndex = Math.max(0, foregroundPeriods.length - exports.MAX_NUMBER_OF_SELECTABLE_FOREGROUND_PERIODS);
    for (var i = foregroundPeriods.length - 1; i >= earliestIndex; i--) {
        var foregroundPeriod = foregroundPeriods[i];
        if (foregroundPeriod.end !== undefined && eventStartTime > foregroundPeriod.end) {
            // event starts after the end of the current focus period
            // since the array is sorted, we can stop looking for foreground periods
            break;
        }
        if (eventEndTime < foregroundPeriod.start) {
            // event ends before the start of the current focus period
            // continue to previous one
            continue;
        }
        var startTime = eventStartTime > foregroundPeriod.start ? eventStartTime : foregroundPeriod.start;
        var startDuration = (0, browser_core_1.elapsed)(eventStartTime, startTime);
        var endTime = foregroundPeriod.end === undefined || eventEndTime < foregroundPeriod.end ? eventEndTime : foregroundPeriod.end;
        var endDuration = (0, browser_core_1.elapsed)(startTime, endTime);
        filteredForegroundPeriods.unshift({
            start: (0, browser_core_1.toServerDuration)(startDuration),
            duration: (0, browser_core_1.toServerDuration)(endDuration),
        });
    }
    return filteredForegroundPeriods;
}

},{"@datadog/browser-core":432}],472:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startInternalContext = void 0;
/**
 * Internal context keep returning v1 format
 * to not break compatibility with logs data format
 */
function startInternalContext(applicationId, sessionManager, viewContexts, actionContexts, urlContexts) {
    return {
        get: function (startTime) {
            var viewContext = viewContexts.findView(startTime);
            var urlContext = urlContexts.findUrl(startTime);
            var session = sessionManager.findTrackedSession(startTime);
            if (session && viewContext && urlContext) {
                var actionId = actionContexts.findActionId(startTime);
                return {
                    application_id: applicationId,
                    session_id: session.id,
                    user_action: actionId ? { id: actionId } : undefined,
                    view: { id: viewContext.id, name: viewContext.name, referrer: urlContext.referrer, url: urlContext.url },
                };
            }
        },
    };
}
exports.startInternalContext = startInternalContext;

},{}],473:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetPageStates = exports.addPageState = exports.startPageStateHistory = exports.MAX_PAGE_STATE_ENTRIES = void 0;
var browser_core_1 = require("@datadog/browser-core");
exports.MAX_PAGE_STATE_ENTRIES = 500;
var pageStateEntries = [];
var currentPageState;
function startPageStateHistory() {
    addPageState(getPageState());
    var stop = (0, browser_core_1.addEventListeners)(window, [
        "pageshow" /* PAGE_SHOW */,
        "focus" /* FOCUS */,
        "blur" /* BLUR */,
        "visibilitychange" /* VISIBILITY_CHANGE */,
        "resume" /* RESUME */,
        "freeze" /* FREEZE */,
        "pagehide" /* PAGE_HIDE */,
    ], function (event) {
        // Only get events fired by the browser to avoid false currentPageState changes done with custom events
        // cf: developer extension auto flush: https://github.com/DataDog/browser-sdk/blob/2f72bf05a672794c9e33965351964382a94c72ba/developer-extension/src/panel/flushEvents.ts#L11-L12
        if (!event.isTrusted) {
            return;
        }
        if (event.type === "freeze" /* FREEZE */) {
            addPageState("frozen" /* FROZEN */);
        }
        else if (event.type === "pagehide" /* PAGE_HIDE */) {
            addPageState(event.persisted ? "frozen" /* FROZEN */ : "terminated" /* TERMINATED */);
        }
        else {
            addPageState(getPageState());
        }
    }, { capture: true }).stop;
    return {
        findAll: function (startTime, duration) {
            var entries = [];
            var endTime = (0, browser_core_1.addDuration)(startTime, duration);
            for (var i = pageStateEntries.length - 1; i >= 0; i--) {
                var stateStartTime = pageStateEntries[i].startTime;
                if (stateStartTime >= endTime) {
                    continue;
                }
                entries.unshift(pageStateEntries[i]);
                if (stateStartTime < startTime) {
                    break;
                }
            }
            return entries.length ? entries : undefined;
        },
        stop: stop,
    };
}
exports.startPageStateHistory = startPageStateHistory;
function getPageState() {
    if (document.visibilityState === 'hidden') {
        return "hidden" /* HIDDEN */;
    }
    if (document.hasFocus()) {
        return "active" /* ACTIVE */;
    }
    return "passive" /* PASSIVE */;
}
function addPageState(nextPageState, maxPageStateEntries) {
    if (maxPageStateEntries === void 0) { maxPageStateEntries = exports.MAX_PAGE_STATE_ENTRIES; }
    if (nextPageState === currentPageState) {
        return;
    }
    currentPageState = nextPageState;
    if (pageStateEntries.length === maxPageStateEntries) {
        pageStateEntries.shift();
    }
    pageStateEntries.push({ state: currentPageState, startTime: (0, browser_core_1.relativeNow)() });
}
exports.addPageState = addPageState;
function resetPageStates() {
    pageStateEntries = [];
    currentPageState = undefined;
}
exports.resetPageStates = resetPageStates;

},{"@datadog/browser-core":432}],474:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSyntheticsContext = void 0;
var browser_core_1 = require("@datadog/browser-core");
function getSyntheticsContext() {
    var testId = (0, browser_core_1.getSyntheticsTestId)();
    var resultId = (0, browser_core_1.getSyntheticsResultId)();
    if (testId && resultId) {
        return {
            test_id: testId,
            result_id: resultId,
            injected: (0, browser_core_1.willSyntheticsInjectRum)(),
        };
    }
}
exports.getSyntheticsContext = getSyntheticsContext;

},{"@datadog/browser-core":432}],475:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startUrlContexts = exports.URL_CONTEXT_TIME_OUT_DELAY = void 0;
var browser_core_1 = require("@datadog/browser-core");
/**
 * We want to attach to an event:
 * - the url corresponding to its start
 * - the referrer corresponding to the previous view url (or document referrer for initial view)
 */
exports.URL_CONTEXT_TIME_OUT_DELAY = browser_core_1.SESSION_TIME_OUT_DELAY;
function startUrlContexts(lifeCycle, locationChangeObservable, location) {
    var urlContextHistory = new browser_core_1.ContextHistory(exports.URL_CONTEXT_TIME_OUT_DELAY);
    var previousViewUrl;
    lifeCycle.subscribe(4 /* VIEW_ENDED */, function (_a) {
        var endClocks = _a.endClocks;
        urlContextHistory.closeActive(endClocks.relative);
    });
    lifeCycle.subscribe(2 /* VIEW_CREATED */, function (_a) {
        var startClocks = _a.startClocks;
        var viewUrl = location.href;
        urlContextHistory.add(buildUrlContext({
            url: viewUrl,
            referrer: !previousViewUrl ? document.referrer : previousViewUrl,
        }), startClocks.relative);
        previousViewUrl = viewUrl;
    });
    var locationChangeSubscription = locationChangeObservable.subscribe(function (_a) {
        var newLocation = _a.newLocation;
        var current = urlContextHistory.find();
        if (current) {
            var changeTime = (0, browser_core_1.relativeNow)();
            urlContextHistory.closeActive(changeTime);
            urlContextHistory.add(buildUrlContext({
                url: newLocation.href,
                referrer: current.referrer,
            }), changeTime);
        }
    });
    function buildUrlContext(_a) {
        var url = _a.url, referrer = _a.referrer;
        return {
            url: url,
            referrer: referrer,
        };
    }
    return {
        findUrl: function (startTime) { return urlContextHistory.find(startTime); },
        stop: function () {
            locationChangeSubscription.unsubscribe();
            urlContextHistory.stop();
        },
    };
}
exports.startUrlContexts = startUrlContexts;

},{"@datadog/browser-core":432}],476:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startViewContexts = exports.VIEW_CONTEXT_TIME_OUT_DELAY = void 0;
var browser_core_1 = require("@datadog/browser-core");
exports.VIEW_CONTEXT_TIME_OUT_DELAY = browser_core_1.SESSION_TIME_OUT_DELAY;
function startViewContexts(lifeCycle) {
    var viewContextHistory = new browser_core_1.ContextHistory(exports.VIEW_CONTEXT_TIME_OUT_DELAY);
    lifeCycle.subscribe(2 /* VIEW_CREATED */, function (view) {
        viewContextHistory.add(buildViewContext(view), view.startClocks.relative);
    });
    lifeCycle.subscribe(4 /* VIEW_ENDED */, function (_a) {
        var endClocks = _a.endClocks;
        viewContextHistory.closeActive(endClocks.relative);
    });
    lifeCycle.subscribe(8 /* SESSION_RENEWED */, function () {
        viewContextHistory.reset();
    });
    function buildViewContext(view) {
        return {
            service: view.service,
            version: view.version,
            id: view.id,
            name: view.name,
        };
    }
    return {
        findView: function (startTime) { return viewContextHistory.find(startTime); },
        stop: function () {
            viewContextHistory.stop();
        },
    };
}
exports.startViewContexts = startViewContexts;

},{"@datadog/browser-core":432}],477:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LifeCycle = void 0;
var LifeCycle = /** @class */ (function () {
    function LifeCycle() {
        this.callbacks = {};
    }
    LifeCycle.prototype.notify = function (eventType, data) {
        var eventCallbacks = this.callbacks[eventType];
        if (eventCallbacks) {
            eventCallbacks.forEach(function (callback) { return callback(data); });
        }
    };
    LifeCycle.prototype.subscribe = function (eventType, callback) {
        var _this = this;
        if (!this.callbacks[eventType]) {
            this.callbacks[eventType] = [];
        }
        this.callbacks[eventType].push(callback);
        return {
            unsubscribe: function () {
                _this.callbacks[eventType] = _this.callbacks[eventType].filter(function (other) { return callback !== other; });
            },
        };
    };
    return LifeCycle;
}());
exports.LifeCycle = LifeCycle;

},{}],478:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackFetch = exports.trackXhr = exports.startRequestCollection = void 0;
var browser_core_1 = require("@datadog/browser-core");
var resourceUtils_1 = require("./rumEventsCollection/resource/resourceUtils");
var tracer_1 = require("./tracing/tracer");
var nextRequestIndex = 1;
function startRequestCollection(lifeCycle, configuration, sessionManager) {
    var tracer = (0, tracer_1.startTracer)(configuration, sessionManager);
    trackXhr(lifeCycle, configuration, tracer);
    trackFetch(lifeCycle, configuration, tracer);
}
exports.startRequestCollection = startRequestCollection;
function trackXhr(lifeCycle, configuration, tracer) {
    var subscription = (0, browser_core_1.initXhrObservable)().subscribe(function (rawContext) {
        var context = rawContext;
        if (!(0, resourceUtils_1.isAllowedRequestUrl)(configuration, context.url)) {
            return;
        }
        switch (context.state) {
            case 'start':
                tracer.traceXhr(context, context.xhr);
                context.requestIndex = getNextRequestIndex();
                lifeCycle.notify(5 /* REQUEST_STARTED */, {
                    requestIndex: context.requestIndex,
                    url: context.url,
                });
                break;
            case 'complete':
                tracer.clearTracingIfNeeded(context);
                lifeCycle.notify(6 /* REQUEST_COMPLETED */, {
                    duration: context.duration,
                    method: context.method,
                    requestIndex: context.requestIndex,
                    spanId: context.spanId,
                    startClocks: context.startClocks,
                    status: context.status,
                    traceId: context.traceId,
                    traceSampled: context.traceSampled,
                    type: "xhr" /* XHR */,
                    url: context.url,
                    xhr: context.xhr,
                });
                break;
        }
    });
    return { stop: function () { return subscription.unsubscribe(); } };
}
exports.trackXhr = trackXhr;
function trackFetch(lifeCycle, configuration, tracer) {
    var subscription = (0, browser_core_1.initFetchObservable)().subscribe(function (rawContext) {
        var context = rawContext;
        if (!(0, resourceUtils_1.isAllowedRequestUrl)(configuration, context.url)) {
            return;
        }
        switch (context.state) {
            case 'start':
                tracer.traceFetch(context);
                context.requestIndex = getNextRequestIndex();
                lifeCycle.notify(5 /* REQUEST_STARTED */, {
                    requestIndex: context.requestIndex,
                    url: context.url,
                });
                break;
            case 'resolve':
                waitForResponseToComplete(context, function (duration) {
                    tracer.clearTracingIfNeeded(context);
                    lifeCycle.notify(6 /* REQUEST_COMPLETED */, {
                        duration: duration,
                        method: context.method,
                        requestIndex: context.requestIndex,
                        responseType: context.responseType,
                        spanId: context.spanId,
                        startClocks: context.startClocks,
                        status: context.status,
                        traceId: context.traceId,
                        traceSampled: context.traceSampled,
                        type: "fetch" /* FETCH */,
                        url: context.url,
                        response: context.response,
                        init: context.init,
                        input: context.input,
                    });
                });
                break;
        }
    });
    return { stop: function () { return subscription.unsubscribe(); } };
}
exports.trackFetch = trackFetch;
function getNextRequestIndex() {
    var result = nextRequestIndex;
    nextRequestIndex += 1;
    return result;
}
function waitForResponseToComplete(context, callback) {
    var clonedResponse = context.response && (0, browser_core_1.tryToClone)(context.response);
    if (!clonedResponse || !clonedResponse.body) {
        // do not try to wait for the response if the clone failed, fetch error or null body
        callback((0, browser_core_1.elapsed)(context.startClocks.timeStamp, (0, browser_core_1.timeStampNow)()));
    }
    else {
        (0, browser_core_1.readBytesFromStream)(clonedResponse.body, function () {
            callback((0, browser_core_1.elapsed)(context.startClocks.timeStamp, (0, browser_core_1.timeStampNow)()));
        }, {
            bytesLimit: Number.POSITIVE_INFINITY,
            collectStreamBody: false,
        });
    }
}

},{"./rumEventsCollection/resource/resourceUtils":492,"./tracing/tracer":502,"@datadog/browser-core":432}],479:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startActionCollection = void 0;
var browser_core_1 = require("@datadog/browser-core");
var trackClickActions_1 = require("./trackClickActions");
function startActionCollection(lifeCycle, domMutationObservable, configuration, foregroundContexts) {
    lifeCycle.subscribe(1 /* AUTO_ACTION_COMPLETED */, function (action) {
        return lifeCycle.notify(10 /* RAW_RUM_EVENT_COLLECTED */, processAction(action, foregroundContexts));
    });
    var actionContexts = { findActionId: browser_core_1.noop };
    if (configuration.trackUserInteractions) {
        actionContexts = (0, trackClickActions_1.trackClickActions)(lifeCycle, domMutationObservable, configuration).actionContexts;
    }
    return {
        addAction: function (action, savedCommonContext) {
            lifeCycle.notify(10 /* RAW_RUM_EVENT_COLLECTED */, (0, browser_core_1.assign)({
                savedCommonContext: savedCommonContext,
            }, processAction(action, foregroundContexts)));
        },
        actionContexts: actionContexts,
    };
}
exports.startActionCollection = startActionCollection;
function processAction(action, foregroundContexts) {
    var autoActionProperties = isAutoAction(action)
        ? {
            action: {
                id: action.id,
                loading_time: (0, browser_core_1.toServerDuration)(action.duration),
                frustration: {
                    type: action.frustrationTypes,
                },
                error: {
                    count: action.counts.errorCount,
                },
                long_task: {
                    count: action.counts.longTaskCount,
                },
                resource: {
                    count: action.counts.resourceCount,
                },
            },
            _dd: {
                action: {
                    target: action.target,
                    position: action.position,
                },
            },
        }
        : undefined;
    var customerContext = !isAutoAction(action) ? action.context : undefined;
    var actionEvent = (0, browser_core_1.combine)({
        action: {
            id: (0, browser_core_1.generateUUID)(),
            target: {
                name: action.name,
            },
            type: action.type,
        },
        date: action.startClocks.timeStamp,
        type: "action" /* ACTION */,
    }, autoActionProperties);
    var inForeground = foregroundContexts.isInForegroundAt(action.startClocks.relative);
    if (inForeground !== undefined) {
        actionEvent.view = { in_foreground: inForeground };
    }
    return {
        customerContext: customerContext,
        rawRumEvent: actionEvent,
        startTime: action.startClocks.relative,
        domainContext: isAutoAction(action) ? { event: action.event, events: action.events } : {},
    };
}
function isAutoAction(action) {
    return action.type !== "custom" /* CUSTOM */;
}

},{"./trackClickActions":485,"@datadog/browser-core":432}],480:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createClickChain = exports.MAX_DISTANCE_BETWEEN_CLICKS = exports.MAX_DURATION_BETWEEN_CLICKS = void 0;
var browser_core_1 = require("@datadog/browser-core");
exports.MAX_DURATION_BETWEEN_CLICKS = browser_core_1.ONE_SECOND;
exports.MAX_DISTANCE_BETWEEN_CLICKS = 100;
function createClickChain(firstClick, onFinalize) {
    var bufferedClicks = [];
    var status = 0 /* WaitingForMoreClicks */;
    var maxDurationBetweenClicksTimeout;
    appendClick(firstClick);
    function appendClick(click) {
        click.stopObservable.subscribe(tryFinalize);
        bufferedClicks.push(click);
        (0, browser_core_1.clearTimeout)(maxDurationBetweenClicksTimeout);
        maxDurationBetweenClicksTimeout = (0, browser_core_1.setTimeout)(dontAcceptMoreClick, exports.MAX_DURATION_BETWEEN_CLICKS);
    }
    function tryFinalize() {
        if (status === 1 /* WaitingForClicksToStop */ && bufferedClicks.every(function (click) { return click.isStopped(); })) {
            status = 2 /* Finalized */;
            onFinalize(bufferedClicks);
        }
    }
    function dontAcceptMoreClick() {
        (0, browser_core_1.clearTimeout)(maxDurationBetweenClicksTimeout);
        if (status === 0 /* WaitingForMoreClicks */) {
            status = 1 /* WaitingForClicksToStop */;
            tryFinalize();
        }
    }
    return {
        tryAppend: function (click) {
            if (status !== 0 /* WaitingForMoreClicks */) {
                return false;
            }
            if (bufferedClicks.length > 0 &&
                !areEventsSimilar(bufferedClicks[bufferedClicks.length - 1].event, click.event)) {
                dontAcceptMoreClick();
                return false;
            }
            appendClick(click);
            return true;
        },
        stop: function () {
            dontAcceptMoreClick();
        },
    };
}
exports.createClickChain = createClickChain;
/**
 * Checks whether two events are similar by comparing their target, position and timestamp
 */
function areEventsSimilar(first, second) {
    return (first.target === second.target &&
        mouseEventDistance(first, second) <= exports.MAX_DISTANCE_BETWEEN_CLICKS &&
        first.timeStamp - second.timeStamp <= exports.MAX_DURATION_BETWEEN_CLICKS);
}
function mouseEventDistance(origin, other) {
    return Math.sqrt(Math.pow(origin.clientX - other.clientX, 2) + Math.pow(origin.clientY - other.clientY, 2));
}

},{"@datadog/browser-core":432}],481:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDead = exports.isRage = exports.computeFrustration = void 0;
var browser_core_1 = require("@datadog/browser-core");
var MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE = 3;
function computeFrustration(clicks, rageClick) {
    if (isRage(clicks)) {
        rageClick.addFrustration("rage_click" /* RAGE_CLICK */);
        if (clicks.some(isDead)) {
            rageClick.addFrustration("dead_click" /* DEAD_CLICK */);
        }
        if (rageClick.hasError) {
            rageClick.addFrustration("error_click" /* ERROR_CLICK */);
        }
        return { isRage: true };
    }
    var hasSelectionChanged = clicks.some(function (click) { return click.getUserActivity().selection; });
    clicks.forEach(function (click) {
        if (click.hasError) {
            click.addFrustration("error_click" /* ERROR_CLICK */);
        }
        if (isDead(click) &&
            // Avoid considering clicks part of a double-click or triple-click selections as dead clicks
            !hasSelectionChanged) {
            click.addFrustration("dead_click" /* DEAD_CLICK */);
        }
    });
    return { isRage: false };
}
exports.computeFrustration = computeFrustration;
function isRage(clicks) {
    if (clicks.some(function (click) { return click.getUserActivity().selection; })) {
        return false;
    }
    for (var i = 0; i < clicks.length - (MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE - 1); i += 1) {
        if (clicks[i + MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE - 1].event.timeStamp - clicks[i].event.timeStamp <=
            browser_core_1.ONE_SECOND) {
            return true;
        }
    }
    return false;
}
exports.isRage = isRage;
var DEAD_CLICK_EXCLUDE_SELECTOR = 
// inputs that don't trigger a meaningful event like "input" when clicked, including textual
// inputs (using a negative selector is shorter here)
'input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]):not([type="reset"]):not([type="range"]),' +
    'textarea,' +
    'select,' +
    // contenteditable and their descendants don't always trigger meaningful changes when manipulated
    '[contenteditable],' +
    '[contenteditable] *,' +
    // canvas, as there is no good way to detect activity occurring on them
    'canvas,' +
    // links that are interactive (have an href attribute) or any of their descendants, as they can
    // open a new tab or navigate to a hash without triggering a meaningful event
    'a[href],' +
    'a[href] *';
function isDead(click) {
    if (click.hasPageActivity || click.getUserActivity().input) {
        return false;
    }
    return !(0, browser_core_1.elementMatches)(click.event.target, DEAD_CLICK_EXCLUDE_SELECTOR);
}
exports.isDead = isDead;

},{"@datadog/browser-core":432}],482:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getActionNameFromElement = exports.DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE = void 0;
var browser_core_1 = require("@datadog/browser-core");
/**
 * Get the action name from the attribute 'data-dd-action-name' on the element or any of its parent.
 * It can also be retrieved from a user defined attribute.
 */
exports.DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE = 'data-dd-action-name';
function getActionNameFromElement(element, userProgrammaticAttribute) {
    // Proceed to get the action name in two steps:
    // * first, get the name programmatically, explicitly defined by the user.
    // * then, use strategies that are known to return good results. Those strategies will be used on
    //   the element and a few parents, but it's likely that they won't succeed at all.
    // * if no name is found this way, use strategies returning less accurate names as a fallback.
    //   Those are much likely to succeed.
    return (getActionNameFromElementProgrammatically(element, exports.DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE) ||
        (userProgrammaticAttribute && getActionNameFromElementProgrammatically(element, userProgrammaticAttribute)) ||
        getActionNameFromElementForStrategies(element, userProgrammaticAttribute, priorityStrategies) ||
        getActionNameFromElementForStrategies(element, userProgrammaticAttribute, fallbackStrategies) ||
        '');
}
exports.getActionNameFromElement = getActionNameFromElement;
function getActionNameFromElementProgrammatically(targetElement, programmaticAttribute) {
    var elementWithAttribute;
    // We don't use getActionNameFromElementForStrategies here, because we want to consider all parents,
    // without limit. It is up to the user to declare a relevant naming strategy.
    // If available, use element.closest() to match get the attribute from the element or any of its
    // parent.  Else fallback to a more traditional implementation.
    if (supportsElementClosest()) {
        elementWithAttribute = targetElement.closest("[".concat(programmaticAttribute, "]"));
    }
    else {
        var element = targetElement;
        while (element) {
            if (element.hasAttribute(programmaticAttribute)) {
                elementWithAttribute = element;
                break;
            }
            element = element.parentElement;
        }
    }
    if (!elementWithAttribute) {
        return;
    }
    var name = elementWithAttribute.getAttribute(programmaticAttribute);
    return truncate(normalizeWhitespace(name.trim()));
}
var priorityStrategies = [
    // associated LABEL text
    function (element, userProgrammaticAttribute) {
        // IE does not support element.labels, so we fallback to a CSS selector based on the element id
        // instead
        if (supportsLabelProperty()) {
            if ('labels' in element && element.labels && element.labels.length > 0) {
                return getTextualContent(element.labels[0], userProgrammaticAttribute);
            }
        }
        else if (element.id) {
            var label = element.ownerDocument &&
                (0, browser_core_1.find)(element.ownerDocument.querySelectorAll('label'), function (label) { return label.htmlFor === element.id; });
            return label && getTextualContent(label, userProgrammaticAttribute);
        }
    },
    // INPUT button (and associated) value
    function (element) {
        if (element.nodeName === 'INPUT') {
            var input = element;
            var type = input.getAttribute('type');
            if (type === 'button' || type === 'submit' || type === 'reset') {
                return input.value;
            }
        }
    },
    // BUTTON, LABEL or button-like element text
    function (element, userProgrammaticAttribute) {
        if (element.nodeName === 'BUTTON' || element.nodeName === 'LABEL' || element.getAttribute('role') === 'button') {
            return getTextualContent(element, userProgrammaticAttribute);
        }
    },
    function (element) { return element.getAttribute('aria-label'); },
    // associated element text designated by the aria-labelledby attribute
    function (element, userProgrammaticAttribute) {
        var labelledByAttribute = element.getAttribute('aria-labelledby');
        if (labelledByAttribute) {
            return labelledByAttribute
                .split(/\s+/)
                .map(function (id) { return getElementById(element, id); })
                .filter(function (label) { return Boolean(label); })
                .map(function (element) { return getTextualContent(element, userProgrammaticAttribute); })
                .join(' ');
        }
    },
    function (element) { return element.getAttribute('alt'); },
    function (element) { return element.getAttribute('name'); },
    function (element) { return element.getAttribute('title'); },
    function (element) { return element.getAttribute('placeholder'); },
    // SELECT first OPTION text
    function (element, userProgrammaticAttribute) {
        if ('options' in element && element.options.length > 0) {
            return getTextualContent(element.options[0], userProgrammaticAttribute);
        }
    },
];
var fallbackStrategies = [
    function (element, userProgrammaticAttribute) { return getTextualContent(element, userProgrammaticAttribute); },
];
/**
 * Iterates over the target element and its parent, using the strategies list to get an action name.
 * Each strategies are applied on each element, stopping as soon as a non-empty value is returned.
 */
var MAX_PARENTS_TO_CONSIDER = 10;
function getActionNameFromElementForStrategies(targetElement, userProgrammaticAttribute, strategies) {
    var element = targetElement;
    var recursionCounter = 0;
    while (recursionCounter <= MAX_PARENTS_TO_CONSIDER &&
        element &&
        element.nodeName !== 'BODY' &&
        element.nodeName !== 'HTML' &&
        element.nodeName !== 'HEAD') {
        for (var _i = 0, strategies_1 = strategies; _i < strategies_1.length; _i++) {
            var strategy = strategies_1[_i];
            var name_1 = strategy(element, userProgrammaticAttribute);
            if (typeof name_1 === 'string') {
                var trimmedName = name_1.trim();
                if (trimmedName) {
                    return truncate(normalizeWhitespace(trimmedName));
                }
            }
        }
        // Consider a FORM as a contextual limit to get the action name.  This is experimental and may
        // be reconsidered in the future.
        if (element.nodeName === 'FORM') {
            break;
        }
        element = element.parentElement;
        recursionCounter += 1;
    }
}
function normalizeWhitespace(s) {
    return s.replace(/\s+/g, ' ');
}
function truncate(s) {
    return s.length > 100 ? "".concat((0, browser_core_1.safeTruncate)(s, 100), " [...]") : s;
}
function getElementById(refElement, id) {
    // Use the element ownerDocument here, because tests are executed in an iframe, so
    // document.getElementById won't work.
    return refElement.ownerDocument ? refElement.ownerDocument.getElementById(id) : null;
}
function getTextualContent(element, userProgrammaticAttribute) {
    if (element.isContentEditable) {
        return;
    }
    if ('innerText' in element) {
        var text_1 = element.innerText;
        var removeTextFromElements = function (query) {
            var list = element.querySelectorAll(query);
            for (var index = 0; index < list.length; index += 1) {
                var element_1 = list[index];
                if ('innerText' in element_1) {
                    var textToReplace = element_1.innerText;
                    if (textToReplace && textToReplace.trim().length > 0) {
                        text_1 = text_1.replace(textToReplace, '');
                    }
                }
            }
        };
        if (!supportsInnerTextScriptAndStyleRemoval()) {
            // remove the inner text of SCRIPT and STYLES from the result. This is a bit dirty, but should
            // be relatively fast and work in most cases.
            removeTextFromElements('script, style');
        }
        // remove the text of elements with programmatic attribute value
        removeTextFromElements("[".concat(exports.DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE, "]"));
        if (userProgrammaticAttribute) {
            removeTextFromElements("[".concat(userProgrammaticAttribute, "]"));
        }
        return text_1;
    }
    return element.textContent;
}
/**
 * Returns true if element.innerText excludes the text from inline SCRIPT and STYLE element. This
 * should be the case everywhere except on Internet Explorer 10 and 11 (see [1])
 *
 * The innerText property relies on what is actually rendered to compute its output, so to check if
 * it actually excludes SCRIPT and STYLE content, a solution would be to create a style element, set
 * its content to '*', inject it in the document body, and check if the style element innerText
 * property returns '*'. Using a new `document` instance won't work as it is not rendered.
 *
 * This solution requires specific CSP rules (see [2]) to be set by the customer. We want to avoid
 * this, so instead we rely on browser detection. In case of false negative, the impact should be
 * low, since we rely on this result to remove the SCRIPT and STYLE innerText (which will be empty)
 * from a parent element innerText.
 *
 * [1]: https://web.archive.org/web/20210602165716/http://perfectionkills.com/the-poor-misunderstood-innerText/#diff-with-textContent
 * [2]: https://github.com/DataDog/browser-sdk/issues/1084
 */
function supportsInnerTextScriptAndStyleRemoval() {
    return !(0, browser_core_1.isIE)();
}
/**
 * Returns true if the browser supports the element.labels property.  This should be the case
 * everywhere except on Internet Explorer.
 * Note: The result is computed lazily, because we don't want any DOM access when the SDK is
 * evaluated.
 */
var supportsLabelPropertyResult;
function supportsLabelProperty() {
    if (supportsLabelPropertyResult === undefined) {
        supportsLabelPropertyResult = 'labels' in HTMLInputElement.prototype;
    }
    return supportsLabelPropertyResult;
}
/**
 * Returns true if the browser supports the element.closest method.  This should be the case
 * everywhere except on Internet Explorer.
 * Note: The result is computed lazily, because we don't want any DOM access when the SDK is
 * evaluated.
 */
var supportsElementClosestResult;
function supportsElementClosest() {
    if (supportsElementClosestResult === undefined) {
        supportsElementClosestResult = 'closest' in HTMLElement.prototype;
    }
    return supportsElementClosestResult;
}

},{"@datadog/browser-core":432}],483:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.supportScopeSelector = exports.getSelectorFromElement = exports.STABLE_ATTRIBUTES = void 0;
var browser_core_1 = require("@datadog/browser-core");
var getActionNameFromElement_1 = require("./getActionNameFromElement");
/**
 * Stable attributes are attributes that are commonly used to identify parts of a UI (ex:
 * component). Those attribute values should not be generated randomly (hardcoded most of the time)
 * and stay the same across deploys. They are not necessarily unique across the document.
 */
exports.STABLE_ATTRIBUTES = [
    getActionNameFromElement_1.DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE,
    // Common test attributes (list provided by google recorder)
    'data-testid',
    'data-test',
    'data-qa',
    'data-cy',
    'data-test-id',
    'data-qa-id',
    'data-testing',
    // FullStory decorator attributes:
    'data-component',
    'data-element',
    'data-source-file',
];
// Selectors to use if they target a single element on the whole document. Those selectors are
// considered as "stable" and uniquely identify an element regardless of the page state. If we find
// one, we should consider the selector "complete" and stop iterating over ancestors.
var GLOBALLY_UNIQUE_SELECTOR_GETTERS = [getStableAttributeSelector, getIDSelector];
// Selectors to use if they target a single element among an element descendants. Those selectors
// are more brittle than "globally unique" selectors and should be combined with ancestor selectors
// to improve specificity.
var UNIQUE_AMONG_CHILDREN_SELECTOR_GETTERS = [
    getStableAttributeSelector,
    getClassSelector,
    getTagNameSelector,
];
function getSelectorFromElement(targetElement, actionNameAttribute) {
    var targetElementSelector = '';
    var element = targetElement;
    while (element && element.nodeName !== 'HTML') {
        var globallyUniqueSelector = findSelector(element, GLOBALLY_UNIQUE_SELECTOR_GETTERS, isSelectorUniqueGlobally, actionNameAttribute, targetElementSelector);
        if (globallyUniqueSelector) {
            return globallyUniqueSelector;
        }
        var uniqueSelectorAmongChildren = findSelector(element, UNIQUE_AMONG_CHILDREN_SELECTOR_GETTERS, isSelectorUniqueAmongSiblings, actionNameAttribute, targetElementSelector);
        targetElementSelector =
            uniqueSelectorAmongChildren || combineSelector(getPositionSelector(element), targetElementSelector);
        element = element.parentElement;
    }
    return targetElementSelector;
}
exports.getSelectorFromElement = getSelectorFromElement;
function isGeneratedValue(value) {
    // To compute the "URL path group", the backend replaces every URL path parts as a question mark
    // if it thinks the part is an identifier. The condition it uses is to checks whether a digit is
    // present.
    //
    // Here, we use the same strategy: if a the value contains a digit, we consider it generated. This
    // strategy might be a bit naive and fail in some cases, but there are many fallbacks to generate
    // CSS selectors so it should be fine most of the time. We might want to allow customers to
    // provide their own `isGeneratedValue` at some point.
    return /[0-9]/.test(value);
}
function getIDSelector(element) {
    if (element.id && !isGeneratedValue(element.id)) {
        return "#".concat((0, browser_core_1.cssEscape)(element.id));
    }
}
function getClassSelector(element) {
    if (element.tagName === 'BODY') {
        return;
    }
    if (element.classList.length > 0) {
        for (var i = 0; i < element.classList.length; i += 1) {
            var className = element.classList[i];
            if (isGeneratedValue(className)) {
                continue;
            }
            return "".concat(element.tagName, ".").concat((0, browser_core_1.cssEscape)(className));
        }
    }
}
function getTagNameSelector(element) {
    return element.tagName;
}
function getStableAttributeSelector(element, actionNameAttribute) {
    if (actionNameAttribute) {
        var selector = getAttributeSelector(actionNameAttribute);
        if (selector) {
            return selector;
        }
    }
    for (var _i = 0, STABLE_ATTRIBUTES_1 = exports.STABLE_ATTRIBUTES; _i < STABLE_ATTRIBUTES_1.length; _i++) {
        var attributeName = STABLE_ATTRIBUTES_1[_i];
        var selector = getAttributeSelector(attributeName);
        if (selector) {
            return selector;
        }
    }
    function getAttributeSelector(attributeName) {
        if (element.hasAttribute(attributeName)) {
            return "".concat(element.tagName, "[").concat(attributeName, "=\"").concat((0, browser_core_1.cssEscape)(element.getAttribute(attributeName)), "\"]");
        }
    }
}
function getPositionSelector(element) {
    var sibling = element.parentElement.firstElementChild;
    var elementIndex = 1;
    while (sibling && sibling !== element) {
        if (sibling.tagName === element.tagName) {
            elementIndex += 1;
        }
        sibling = sibling.nextElementSibling;
    }
    return "".concat(element.tagName, ":nth-of-type(").concat(elementIndex, ")");
}
function findSelector(element, selectorGetters, predicate, actionNameAttribute, childSelector) {
    for (var _i = 0, selectorGetters_1 = selectorGetters; _i < selectorGetters_1.length; _i++) {
        var selectorGetter = selectorGetters_1[_i];
        var elementSelector = selectorGetter(element, actionNameAttribute);
        if (!elementSelector) {
            continue;
        }
        var fullSelector = combineSelector(elementSelector, childSelector);
        if (predicate(element, fullSelector)) {
            return fullSelector;
        }
    }
}
/**
 * Check whether the selector is unique among the whole document.
 */
function isSelectorUniqueGlobally(element, selector) {
    return element.ownerDocument.querySelectorAll(selector).length === 1;
}
/**
 * Check whether the selector is unique among the element siblings. In other words, it returns true
 * if "ELEMENT_PARENT > SELECTOR" returns a single element.
 *
 * The result will be less accurate on browsers that don't support :scope (i. e. IE): it will check
 * for any element matching the selector contained in the parent (in other words,
 * "ELEMENT_PARENT SELECTOR" returns a single element), regardless of whether the selector is a
 * direct descendent of the element parent. This should not impact results too much: if it
 * inaccurately returns false, we'll just fall back to another strategy.
 */
function isSelectorUniqueAmongSiblings(element, selector) {
    return (element.parentElement.querySelectorAll(supportScopeSelector() ? combineSelector(':scope', selector) : selector)
        .length === 1);
}
function combineSelector(parent, child) {
    return child ? "".concat(parent, ">").concat(child) : parent;
}
var supportScopeSelectorCache;
function supportScopeSelector() {
    if (supportScopeSelectorCache === undefined) {
        try {
            document.querySelector(':scope');
            supportScopeSelectorCache = true;
        }
        catch (_a) {
            supportScopeSelectorCache = false;
        }
    }
    return supportScopeSelectorCache;
}
exports.supportScopeSelector = supportScopeSelector;

},{"./getActionNameFromElement":482,"@datadog/browser-core":432}],484:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listenActionEvents = void 0;
var browser_core_1 = require("@datadog/browser-core");
function listenActionEvents(_a) {
    var onPointerDown = _a.onPointerDown, onPointerUp = _a.onPointerUp;
    var selectionEmptyAtPointerDown;
    var userActivity = {
        selection: false,
        input: false,
    };
    var clickContext;
    var listeners = [
        (0, browser_core_1.addEventListener)(window, "pointerdown" /* POINTER_DOWN */, function (event) {
            if (isValidPointerEvent(event)) {
                selectionEmptyAtPointerDown = isSelectionEmpty();
                userActivity = {
                    selection: false,
                    input: false,
                };
                clickContext = onPointerDown(event);
            }
        }, { capture: true }),
        (0, browser_core_1.addEventListener)(window, "selectionchange" /* SELECTION_CHANGE */, function () {
            if (!selectionEmptyAtPointerDown || !isSelectionEmpty()) {
                userActivity.selection = true;
            }
        }, { capture: true }),
        (0, browser_core_1.addEventListener)(window, "pointerup" /* POINTER_UP */, function (event) {
            if (isValidPointerEvent(event) && clickContext) {
                // Use a scoped variable to make sure the value is not changed by other clicks
                var localUserActivity_1 = userActivity;
                onPointerUp(clickContext, event, function () { return localUserActivity_1; });
                clickContext = undefined;
            }
        }, { capture: true }),
        (0, browser_core_1.addEventListener)(window, "input" /* INPUT */, function () {
            userActivity.input = true;
        }, { capture: true }),
    ];
    return {
        stop: function () {
            listeners.forEach(function (listener) { return listener.stop(); });
        },
    };
}
exports.listenActionEvents = listenActionEvents;
function isSelectionEmpty() {
    var selection = window.getSelection();
    return !selection || selection.isCollapsed;
}
function isValidPointerEvent(event) {
    return (event.target instanceof Element &&
        // Only consider 'primary' pointer events for now. Multi-touch support could be implemented in
        // the future.
        event.isPrimary !== false);
}

},{"@datadog/browser-core":432}],485:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.finalizeClicks = exports.trackClickActions = exports.ACTION_CONTEXT_TIME_OUT_DELAY = exports.CLICK_ACTION_MAX_DURATION = void 0;
var browser_core_1 = require("@datadog/browser-core");
var trackEventCounts_1 = require("../../trackEventCounts");
var waitPageActivityEnd_1 = require("../../waitPageActivityEnd");
var clickChain_1 = require("./clickChain");
var getActionNameFromElement_1 = require("./getActionNameFromElement");
var getSelectorFromElement_1 = require("./getSelectorFromElement");
var listenActionEvents_1 = require("./listenActionEvents");
var computeFrustration_1 = require("./computeFrustration");
// Maximum duration for click actions
exports.CLICK_ACTION_MAX_DURATION = 10 * browser_core_1.ONE_SECOND;
exports.ACTION_CONTEXT_TIME_OUT_DELAY = 5 * browser_core_1.ONE_MINUTE; // arbitrary
function trackClickActions(lifeCycle, domMutationObservable, configuration) {
    var history = new browser_core_1.ContextHistory(exports.ACTION_CONTEXT_TIME_OUT_DELAY);
    var stopObservable = new browser_core_1.Observable();
    var currentClickChain;
    lifeCycle.subscribe(8 /* SESSION_RENEWED */, function () {
        history.reset();
    });
    lifeCycle.subscribe(4 /* VIEW_ENDED */, stopClickChain);
    var stopActionEventsListener = (0, listenActionEvents_1.listenActionEvents)({
        onPointerDown: function (pointerDownEvent) {
            return processPointerDown(configuration, lifeCycle, domMutationObservable, history, pointerDownEvent);
        },
        onPointerUp: function (_a, startEvent, getUserActivity) {
            var clickActionBase = _a.clickActionBase, hadActivityOnPointerDown = _a.hadActivityOnPointerDown;
            return startClickAction(configuration, lifeCycle, domMutationObservable, history, stopObservable, appendClickToClickChain, clickActionBase, startEvent, getUserActivity, hadActivityOnPointerDown);
        },
    }).stop;
    var actionContexts = {
        findActionId: function (startTime) {
            return configuration.trackFrustrations ? history.findAll(startTime) : history.find(startTime);
        },
    };
    return {
        stop: function () {
            stopClickChain();
            stopObservable.notify();
            stopActionEventsListener();
        },
        actionContexts: actionContexts,
    };
    function appendClickToClickChain(click) {
        if (!currentClickChain || !currentClickChain.tryAppend(click)) {
            var rageClick_1 = click.clone();
            currentClickChain = (0, clickChain_1.createClickChain)(click, function (clicks) {
                finalizeClicks(clicks, rageClick_1);
            });
        }
    }
    function stopClickChain() {
        if (currentClickChain) {
            currentClickChain.stop();
        }
    }
}
exports.trackClickActions = trackClickActions;
function processPointerDown(configuration, lifeCycle, domMutationObservable, history, pointerDownEvent) {
    if (!configuration.trackFrustrations && history.find()) {
        // TODO: remove this in a future major version. To keep retrocompatibility, ignore any new
        // action if another one is already occurring.
        return;
    }
    var clickActionBase = computeClickActionBase(pointerDownEvent, configuration.actionNameAttribute);
    if (!configuration.trackFrustrations && !clickActionBase.name) {
        // TODO: remove this in a future major version. To keep retrocompatibility, ignore any action
        // with a blank name
        return;
    }
    var hadActivityOnPointerDown = false;
    (0, waitPageActivityEnd_1.waitPageActivityEnd)(lifeCycle, domMutationObservable, configuration, function (pageActivityEndEvent) {
        hadActivityOnPointerDown = pageActivityEndEvent.hadActivity;
    }, 
    // We don't care about the activity duration, we just want to know whether an activity did happen
    // within the "validation delay" or not. Limit the duration so the callback is called sooner.
    waitPageActivityEnd_1.PAGE_ACTIVITY_VALIDATION_DELAY);
    return { clickActionBase: clickActionBase, hadActivityOnPointerDown: function () { return hadActivityOnPointerDown; } };
}
function startClickAction(configuration, lifeCycle, domMutationObservable, history, stopObservable, appendClickToClickChain, clickActionBase, startEvent, getUserActivity, hadActivityOnPointerDown) {
    var click = newClick(lifeCycle, history, getUserActivity, clickActionBase, startEvent);
    if (configuration.trackFrustrations) {
        appendClickToClickChain(click);
    }
    var stopWaitPageActivityEnd = (0, waitPageActivityEnd_1.waitPageActivityEnd)(lifeCycle, domMutationObservable, configuration, function (pageActivityEndEvent) {
        if (pageActivityEndEvent.hadActivity && pageActivityEndEvent.end < click.startClocks.timeStamp) {
            // If the clock is looking weird, just discard the click
            click.discard();
        }
        else {
            if (pageActivityEndEvent.hadActivity) {
                click.stop(pageActivityEndEvent.end);
            }
            else if (hadActivityOnPointerDown()) {
                click.stop(
                // using the click start as activity end, so the click will have some activity but its
                // duration will be 0 (as the activity started before the click start)
                click.startClocks.timeStamp);
            }
            else {
                click.stop();
            }
            // Validate or discard the click only if we don't track frustrations. It'll be done when
            // the click chain is finalized.
            if (!configuration.trackFrustrations) {
                if (!pageActivityEndEvent.hadActivity) {
                    // If we are not tracking frustrations, we should discard the click to keep backward
                    // compatibility.
                    click.discard();
                }
                else {
                    click.validate();
                }
            }
        }
    }, exports.CLICK_ACTION_MAX_DURATION).stop;
    var viewEndedSubscription = lifeCycle.subscribe(4 /* VIEW_ENDED */, function (_a) {
        var endClocks = _a.endClocks;
        click.stop(endClocks.timeStamp);
    });
    var stopSubscription = stopObservable.subscribe(function () {
        click.stop();
    });
    click.stopObservable.subscribe(function () {
        viewEndedSubscription.unsubscribe();
        stopWaitPageActivityEnd();
        stopSubscription.unsubscribe();
    });
}
function computeClickActionBase(event, actionNameAttribute) {
    var target;
    var position;
    if ((0, browser_core_1.isExperimentalFeatureEnabled)('clickmap')) {
        var rect = event.target.getBoundingClientRect();
        target = {
            width: Math.round(rect.width),
            height: Math.round(rect.height),
            selector: (0, getSelectorFromElement_1.getSelectorFromElement)(event.target, actionNameAttribute),
        };
        position = {
            // Use clientX and Y because for SVG element offsetX and Y are relatives to the <svg> element
            x: Math.round(event.clientX - rect.left),
            y: Math.round(event.clientY - rect.top),
        };
    }
    return {
        type: "click" /* CLICK */,
        target: target,
        position: position,
        name: (0, getActionNameFromElement_1.getActionNameFromElement)(event.target, actionNameAttribute),
    };
}
function newClick(lifeCycle, history, getUserActivity, clickActionBase, startEvent) {
    var id = (0, browser_core_1.generateUUID)();
    var startClocks = (0, browser_core_1.clocksNow)();
    var historyEntry = history.add(id, startClocks.relative);
    var eventCountsSubscription = (0, trackEventCounts_1.trackEventCounts)({
        lifeCycle: lifeCycle,
        isChildEvent: function (event) {
            return event.action !== undefined &&
                (Array.isArray(event.action.id) ? (0, browser_core_1.includes)(event.action.id, id) : event.action.id === id);
        },
    });
    var status = 0 /* ONGOING */;
    var activityEndTime;
    var frustrationTypes = [];
    var stopObservable = new browser_core_1.Observable();
    function stop(newActivityEndTime) {
        if (status !== 0 /* ONGOING */) {
            return;
        }
        activityEndTime = newActivityEndTime;
        status = 1 /* STOPPED */;
        if (activityEndTime) {
            historyEntry.close((0, browser_core_1.getRelativeTime)(activityEndTime));
        }
        else {
            historyEntry.remove();
        }
        eventCountsSubscription.stop();
        stopObservable.notify();
    }
    return {
        event: startEvent,
        stop: stop,
        stopObservable: stopObservable,
        get hasError() {
            return eventCountsSubscription.eventCounts.errorCount > 0;
        },
        get hasPageActivity() {
            return activityEndTime !== undefined;
        },
        getUserActivity: getUserActivity,
        addFrustration: function (frustrationType) {
            frustrationTypes.push(frustrationType);
        },
        startClocks: startClocks,
        isStopped: function () { return status === 1 /* STOPPED */ || status === 2 /* FINALIZED */; },
        clone: function () { return newClick(lifeCycle, history, getUserActivity, clickActionBase, startEvent); },
        validate: function (domEvents) {
            stop();
            if (status !== 1 /* STOPPED */) {
                return;
            }
            var _a = eventCountsSubscription.eventCounts, resourceCount = _a.resourceCount, errorCount = _a.errorCount, longTaskCount = _a.longTaskCount;
            var clickAction = (0, browser_core_1.assign)({
                type: "click" /* CLICK */,
                duration: activityEndTime && (0, browser_core_1.elapsed)(startClocks.timeStamp, activityEndTime),
                startClocks: startClocks,
                id: id,
                frustrationTypes: frustrationTypes,
                counts: {
                    resourceCount: resourceCount,
                    errorCount: errorCount,
                    longTaskCount: longTaskCount,
                },
                events: domEvents !== null && domEvents !== void 0 ? domEvents : [startEvent],
                event: startEvent,
            }, clickActionBase);
            lifeCycle.notify(1 /* AUTO_ACTION_COMPLETED */, clickAction);
            status = 2 /* FINALIZED */;
        },
        discard: function () {
            stop();
            status = 2 /* FINALIZED */;
        },
    };
}
function finalizeClicks(clicks, rageClick) {
    var isRage = (0, computeFrustration_1.computeFrustration)(clicks, rageClick).isRage;
    if (isRage) {
        clicks.forEach(function (click) { return click.discard(); });
        rageClick.stop((0, browser_core_1.timeStampNow)());
        rageClick.validate(clicks.map(function (click) { return click.event; }));
    }
    else {
        rageClick.discard();
        clicks.forEach(function (click) { return click.validate(); });
    }
}
exports.finalizeClicks = finalizeClicks;

},{"../../trackEventCounts":503,"../../waitPageActivityEnd":504,"./clickChain":480,"./computeFrustration":481,"./getActionNameFromElement":482,"./getSelectorFromElement":483,"./listenActionEvents":484,"@datadog/browser-core":432}],486:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.doStartErrorCollection = exports.startErrorCollection = void 0;
var browser_core_1 = require("@datadog/browser-core");
var trackConsoleError_1 = require("./trackConsoleError");
var trackReportError_1 = require("./trackReportError");
function startErrorCollection(lifeCycle, foregroundContexts, featureFlagContexts) {
    var errorObservable = new browser_core_1.Observable();
    (0, trackConsoleError_1.trackConsoleError)(errorObservable);
    (0, browser_core_1.trackRuntimeError)(errorObservable);
    (0, trackReportError_1.trackReportError)(errorObservable);
    errorObservable.subscribe(function (error) { return lifeCycle.notify(12 /* RAW_ERROR_COLLECTED */, { error: error }); });
    return doStartErrorCollection(lifeCycle, foregroundContexts, featureFlagContexts);
}
exports.startErrorCollection = startErrorCollection;
function doStartErrorCollection(lifeCycle, foregroundContexts, featureFlagContexts) {
    lifeCycle.subscribe(12 /* RAW_ERROR_COLLECTED */, function (_a) {
        var error = _a.error, customerContext = _a.customerContext, savedCommonContext = _a.savedCommonContext;
        lifeCycle.notify(10 /* RAW_RUM_EVENT_COLLECTED */, (0, browser_core_1.assign)({
            customerContext: customerContext,
            savedCommonContext: savedCommonContext,
        }, processError(error, foregroundContexts, featureFlagContexts)));
    });
    return {
        addError: function (_a, savedCommonContext) {
            var error = _a.error, handlingStack = _a.handlingStack, startClocks = _a.startClocks, customerContext = _a.context;
            var stackTrace = error instanceof Error ? (0, browser_core_1.computeStackTrace)(error) : undefined;
            var rawError = (0, browser_core_1.computeRawError)({
                stackTrace: stackTrace,
                originalError: error,
                handlingStack: handlingStack,
                startClocks: startClocks,
                nonErrorPrefix: browser_core_1.PROVIDED_ERROR_MESSAGE_PREFIX,
                source: browser_core_1.ErrorSource.CUSTOM,
                handling: "handled" /* HANDLED */,
            });
            lifeCycle.notify(12 /* RAW_ERROR_COLLECTED */, {
                customerContext: customerContext,
                savedCommonContext: savedCommonContext,
                error: rawError,
            });
        },
    };
}
exports.doStartErrorCollection = doStartErrorCollection;
function processError(error, foregroundContexts, featureFlagContexts) {
    var rawRumEvent = {
        date: error.startClocks.timeStamp,
        error: {
            id: (0, browser_core_1.generateUUID)(),
            message: error.message,
            source: error.source,
            stack: error.stack,
            handling_stack: error.handlingStack,
            type: error.type,
            handling: error.handling,
            causes: error.causes,
            source_type: 'browser',
        },
        type: "error" /* ERROR */,
    };
    var inForeground = foregroundContexts.isInForegroundAt(error.startClocks.relative);
    if (inForeground) {
        rawRumEvent.view = { in_foreground: inForeground };
    }
    var featureFlagContext = featureFlagContexts.findFeatureFlagEvaluations(error.startClocks.relative);
    if (featureFlagContext && !(0, browser_core_1.isEmptyObject)(featureFlagContext)) {
        rawRumEvent.feature_flags = featureFlagContext;
    }
    return {
        rawRumEvent: rawRumEvent,
        startTime: error.startClocks.relative,
        domainContext: {
            error: error.originalError,
        },
    };
}

},{"./trackConsoleError":487,"./trackReportError":488,"@datadog/browser-core":432}],487:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackConsoleError = void 0;
var browser_core_1 = require("@datadog/browser-core");
function trackConsoleError(errorObservable) {
    var subscription = (0, browser_core_1.initConsoleObservable)([browser_core_1.ConsoleApiName.error]).subscribe(function (consoleError) {
        return errorObservable.notify({
            startClocks: (0, browser_core_1.clocksNow)(),
            message: consoleError.message,
            stack: consoleError.stack,
            source: browser_core_1.ErrorSource.CONSOLE,
            handling: "handled" /* HANDLED */,
            handlingStack: consoleError.handlingStack,
        });
    });
    return {
        stop: function () {
            subscription.unsubscribe();
        },
    };
}
exports.trackConsoleError = trackConsoleError;

},{"@datadog/browser-core":432}],488:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackReportError = void 0;
var browser_core_1 = require("@datadog/browser-core");
function trackReportError(errorObservable) {
    var subscription = (0, browser_core_1.initReportObservable)([browser_core_1.RawReportType.cspViolation, browser_core_1.RawReportType.intervention]).subscribe(function (reportError) {
        return errorObservable.notify({
            startClocks: (0, browser_core_1.clocksNow)(),
            message: reportError.message,
            stack: reportError.stack,
            type: reportError.subtype,
            source: browser_core_1.ErrorSource.REPORT,
            handling: "unhandled" /* UNHANDLED */,
        });
    });
    return {
        stop: function () {
            subscription.unsubscribe();
        },
    };
}
exports.trackReportError = trackReportError;

},{"@datadog/browser-core":432}],489:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startLongTaskCollection = void 0;
var browser_core_1 = require("@datadog/browser-core");
function startLongTaskCollection(lifeCycle, sessionManager) {
    lifeCycle.subscribe(0 /* PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if (entry.entryType !== 'longtask') {
                break;
            }
            var session = sessionManager.findTrackedSession(entry.startTime);
            if (!session || !session.longTaskAllowed) {
                break;
            }
            var startClocks = (0, browser_core_1.relativeToClocks)(entry.startTime);
            var rawRumEvent = {
                date: startClocks.timeStamp,
                long_task: {
                    id: (0, browser_core_1.generateUUID)(),
                    duration: (0, browser_core_1.toServerDuration)(entry.duration),
                },
                type: "long_task" /* LONG_TASK */,
                _dd: {
                    discarded: false,
                },
            };
            lifeCycle.notify(10 /* RAW_RUM_EVENT_COLLECTED */, {
                rawRumEvent: rawRumEvent,
                startTime: startClocks.relative,
                domainContext: { performanceEntry: entry.toJSON() },
            });
        }
    });
}
exports.startLongTaskCollection = startLongTaskCollection;

},{"@datadog/browser-core":432}],490:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.matchRequestTiming = void 0;
var browser_core_1 = require("@datadog/browser-core");
var resourceUtils_1 = require("./resourceUtils");
/**
 * Look for corresponding timing in resource timing buffer
 *
 * Observations:
 * - Timing (start, end) are nested inside the request (start, end)
 * - Some timing can be not exactly nested, being off by < 1 ms
 *
 * Strategy:
 * - from valid nested entries (with 1 ms error margin)
 * - if a single timing match, return the timing
 * - otherwise we can't decide, return undefined
 */
function matchRequestTiming(request) {
    if (!performance || !('getEntriesByName' in performance)) {
        return;
    }
    var sameNameEntries = performance.getEntriesByName(request.url, 'resource');
    if (!sameNameEntries.length || !('toJSON' in sameNameEntries[0])) {
        return;
    }
    var candidates = sameNameEntries
        .map(function (entry) { return entry.toJSON(); })
        .filter(resourceUtils_1.toValidEntry)
        .filter(function (entry) {
        return isBetween(entry, request.startClocks.relative, endTime({ startTime: request.startClocks.relative, duration: request.duration }));
    });
    if (candidates.length === 1) {
        return candidates[0];
    }
    return;
}
exports.matchRequestTiming = matchRequestTiming;
function endTime(timing) {
    return (0, browser_core_1.addDuration)(timing.startTime, timing.duration);
}
function isBetween(timing, start, end) {
    var errorMargin = 1;
    return timing.startTime >= start - errorMargin && endTime(timing) <= (0, browser_core_1.addDuration)(end, errorMargin);
}

},{"./resourceUtils":492,"@datadog/browser-core":432}],491:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startResourceCollection = void 0;
var browser_core_1 = require("@datadog/browser-core");
var matchRequestTiming_1 = require("./matchRequestTiming");
var resourceUtils_1 = require("./resourceUtils");
function startResourceCollection(lifeCycle, configuration, sessionManager, pageStateHistory) {
    lifeCycle.subscribe(6 /* REQUEST_COMPLETED */, function (request) {
        lifeCycle.notify(10 /* RAW_RUM_EVENT_COLLECTED */, processRequest(request, configuration, sessionManager, pageStateHistory));
    });
    lifeCycle.subscribe(0 /* PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if (entry.entryType === 'resource' && !(0, resourceUtils_1.isRequestKind)(entry)) {
                lifeCycle.notify(10 /* RAW_RUM_EVENT_COLLECTED */, processResourceEntry(entry, configuration, sessionManager, pageStateHistory));
            }
        }
    });
}
exports.startResourceCollection = startResourceCollection;
function processRequest(request, configuration, sessionManager, pageStateHistory) {
    var _a;
    var type = request.type === "xhr" /* XHR */ ? "xhr" /* XHR */ : "fetch" /* FETCH */;
    var matchingTiming = (0, matchRequestTiming_1.matchRequestTiming)(request);
    var startClocks = matchingTiming ? (0, browser_core_1.relativeToClocks)(matchingTiming.startTime) : request.startClocks;
    var correspondingTimingOverrides = matchingTiming ? computePerformanceEntryMetrics(matchingTiming) : undefined;
    var tracingInfo = computeRequestTracingInfo(request, configuration);
    var indexingInfo = computeIndexingInfo(sessionManager, startClocks);
    var duration = (0, browser_core_1.toServerDuration)(request.duration);
    var durationOverrideInfo = computeDurationOverrideInfo(duration, correspondingTimingOverrides === null || correspondingTimingOverrides === void 0 ? void 0 : correspondingTimingOverrides.resource.duration);
    var pageStateInfo = computePageStateInfo(pageStateHistory, startClocks, (_a = matchingTiming === null || matchingTiming === void 0 ? void 0 : matchingTiming.duration) !== null && _a !== void 0 ? _a : request.duration);
    var resourceEvent = (0, browser_core_1.combine)({
        date: startClocks.timeStamp,
        resource: {
            id: (0, browser_core_1.generateUUID)(),
            type: type,
            duration: duration,
            method: request.method,
            status_code: request.status,
            url: request.url,
        },
        type: "resource" /* RESOURCE */,
    }, tracingInfo, correspondingTimingOverrides, indexingInfo, durationOverrideInfo, pageStateInfo);
    return {
        startTime: startClocks.relative,
        rawRumEvent: resourceEvent,
        domainContext: {
            performanceEntry: matchingTiming && toPerformanceEntryRepresentation(matchingTiming),
            xhr: request.xhr,
            response: request.response,
            requestInput: request.input,
            requestInit: request.init,
            error: request.error,
        },
    };
}
function processResourceEntry(entry, configuration, sessionManager, pageStateHistory) {
    var type = (0, resourceUtils_1.computeResourceKind)(entry);
    var entryMetrics = computePerformanceEntryMetrics(entry);
    var startClocks = (0, browser_core_1.relativeToClocks)(entry.startTime);
    var tracingInfo = computeEntryTracingInfo(entry, configuration);
    var indexingInfo = computeIndexingInfo(sessionManager, startClocks);
    var pageStateInfo = computePageStateInfo(pageStateHistory, startClocks, entry.duration);
    var resourceEvent = (0, browser_core_1.combine)({
        date: startClocks.timeStamp,
        resource: {
            id: (0, browser_core_1.generateUUID)(),
            type: type,
            url: entry.name,
        },
        type: "resource" /* RESOURCE */,
    }, tracingInfo, entryMetrics, indexingInfo, pageStateInfo);
    return {
        startTime: startClocks.relative,
        rawRumEvent: resourceEvent,
        domainContext: {
            performanceEntry: toPerformanceEntryRepresentation(entry),
        },
    };
}
function computePerformanceEntryMetrics(timing) {
    return {
        resource: (0, browser_core_1.assign)({
            duration: (0, resourceUtils_1.computePerformanceResourceDuration)(timing),
            size: (0, resourceUtils_1.computeSize)(timing),
        }, (0, resourceUtils_1.computePerformanceResourceDetails)(timing)),
    };
}
function computeRequestTracingInfo(request, configuration) {
    var hasBeenTraced = request.traceSampled && request.traceId && request.spanId;
    if (!hasBeenTraced) {
        return undefined;
    }
    return {
        _dd: {
            span_id: request.spanId.toDecimalString(),
            trace_id: request.traceId.toDecimalString(),
            rule_psr: getRulePsr(configuration),
        },
    };
}
function computeEntryTracingInfo(entry, configuration) {
    var hasBeenTraced = entry.traceId;
    if (!hasBeenTraced) {
        return undefined;
    }
    return {
        _dd: {
            trace_id: entry.traceId,
            rule_psr: getRulePsr(configuration),
        },
    };
}
function computeDurationOverrideInfo(computedDuration, performanceEntryDuration) {
    if (!(0, browser_core_1.isExperimentalFeatureEnabled)('resource_durations')) {
        return;
    }
    return {
        _dd: {
            computed_duration: computedDuration,
            performance_entry_duration: performanceEntryDuration,
            override_duration_diff: performanceEntryDuration ? computedDuration - performanceEntryDuration : undefined,
        },
    };
}
// TODO next major: use directly PerformanceEntry type in domain context
function toPerformanceEntryRepresentation(entry) {
    return entry;
}
/**
 * @returns number between 0 and 1 which represents trace sample rate
 */
function getRulePsr(configuration) {
    return (0, browser_core_1.isNumber)(configuration.traceSampleRate) ? configuration.traceSampleRate / 100 : undefined;
}
function computeIndexingInfo(sessionManager, resourceStart) {
    var session = sessionManager.findTrackedSession(resourceStart.relative);
    return {
        _dd: {
            discarded: !session || !session.resourceAllowed,
        },
    };
}
function computePageStateInfo(pageStateHistory, startClocks, duration) {
    if (!(0, browser_core_1.isExperimentalFeatureEnabled)('resource_page_states')) {
        return;
    }
    return {
        _dd: {
            page_states: pageStateHistory.findAll(startClocks.relative, duration),
            page_was_discarded: String(document.wasDiscarded),
        },
    };
}

},{"./matchRequestTiming":490,"./resourceUtils":492,"@datadog/browser-core":432}],492:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAllowedRequestUrl = exports.computeSize = exports.toValidEntry = exports.computePerformanceResourceDetails = exports.computePerformanceResourceDuration = exports.isRequestKind = exports.computeResourceKind = exports.FAKE_INITIAL_DOCUMENT = void 0;
var browser_core_1 = require("@datadog/browser-core");
exports.FAKE_INITIAL_DOCUMENT = 'initial_document';
var RESOURCE_TYPES = [
    ["document" /* DOCUMENT */, function (initiatorType) { return exports.FAKE_INITIAL_DOCUMENT === initiatorType; }],
    ["xhr" /* XHR */, function (initiatorType) { return 'xmlhttprequest' === initiatorType; }],
    ["fetch" /* FETCH */, function (initiatorType) { return 'fetch' === initiatorType; }],
    ["beacon" /* BEACON */, function (initiatorType) { return 'beacon' === initiatorType; }],
    ["css" /* CSS */, function (_, path) { return /\.css$/i.test(path); }],
    ["js" /* JS */, function (_, path) { return /\.js$/i.test(path); }],
    [
        "image" /* IMAGE */,
        function (initiatorType, path) {
            return (0, browser_core_1.includes)(['image', 'img', 'icon'], initiatorType) || /\.(gif|jpg|jpeg|tiff|png|svg|ico)$/i.exec(path) !== null;
        },
    ],
    ["font" /* FONT */, function (_, path) { return /\.(woff|eot|woff2|ttf)$/i.exec(path) !== null; }],
    [
        "media" /* MEDIA */,
        function (initiatorType, path) {
            return (0, browser_core_1.includes)(['audio', 'video'], initiatorType) || /\.(mp3|mp4)$/i.exec(path) !== null;
        },
    ],
];
function computeResourceKind(timing) {
    var url = timing.name;
    if (!(0, browser_core_1.isValidUrl)(url)) {
        (0, browser_core_1.addTelemetryDebug)("Failed to construct URL for \"".concat(timing.name, "\""));
        return "other" /* OTHER */;
    }
    var path = (0, browser_core_1.getPathName)(url);
    for (var _i = 0, RESOURCE_TYPES_1 = RESOURCE_TYPES; _i < RESOURCE_TYPES_1.length; _i++) {
        var _a = RESOURCE_TYPES_1[_i], type = _a[0], isType = _a[1];
        if (isType(timing.initiatorType, path)) {
            return type;
        }
    }
    return "other" /* OTHER */;
}
exports.computeResourceKind = computeResourceKind;
function areInOrder() {
    var numbers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        numbers[_i] = arguments[_i];
    }
    for (var i = 1; i < numbers.length; i += 1) {
        if (numbers[i - 1] > numbers[i]) {
            return false;
        }
    }
    return true;
}
function isRequestKind(timing) {
    return timing.initiatorType === 'xmlhttprequest' || timing.initiatorType === 'fetch';
}
exports.isRequestKind = isRequestKind;
function computePerformanceResourceDuration(entry) {
    var duration = entry.duration, startTime = entry.startTime, responseEnd = entry.responseEnd;
    // Safari duration is always 0 on timings blocked by cross origin policies.
    if (duration === 0 && startTime < responseEnd) {
        return (0, browser_core_1.toServerDuration)((0, browser_core_1.elapsed)(startTime, responseEnd));
    }
    return (0, browser_core_1.toServerDuration)(duration);
}
exports.computePerformanceResourceDuration = computePerformanceResourceDuration;
function computePerformanceResourceDetails(entry) {
    var validEntry = toValidEntry(entry);
    if (!validEntry) {
        return undefined;
    }
    var startTime = validEntry.startTime, fetchStart = validEntry.fetchStart, redirectStart = validEntry.redirectStart, redirectEnd = validEntry.redirectEnd, domainLookupStart = validEntry.domainLookupStart, domainLookupEnd = validEntry.domainLookupEnd, connectStart = validEntry.connectStart, secureConnectionStart = validEntry.secureConnectionStart, connectEnd = validEntry.connectEnd, requestStart = validEntry.requestStart, responseStart = validEntry.responseStart, responseEnd = validEntry.responseEnd;
    var details = {
        download: formatTiming(startTime, responseStart, responseEnd),
        first_byte: formatTiming(startTime, requestStart, responseStart),
    };
    // Make sure a connection occurred
    if (connectEnd !== fetchStart) {
        details.connect = formatTiming(startTime, connectStart, connectEnd);
        // Make sure a secure connection occurred
        if (areInOrder(connectStart, secureConnectionStart, connectEnd)) {
            details.ssl = formatTiming(startTime, secureConnectionStart, connectEnd);
        }
    }
    // Make sure a domain lookup occurred
    if (domainLookupEnd !== fetchStart) {
        details.dns = formatTiming(startTime, domainLookupStart, domainLookupEnd);
    }
    if (hasRedirection(entry)) {
        details.redirect = formatTiming(startTime, redirectStart, redirectEnd);
    }
    return details;
}
exports.computePerformanceResourceDetails = computePerformanceResourceDetails;
function toValidEntry(entry) {
    // Ensure timings are in the right order. On top of filtering out potential invalid
    // RumPerformanceResourceTiming, it will ignore entries from requests where timings cannot be
    // collected, for example cross origin requests without a "Timing-Allow-Origin" header allowing
    // it.
    if (!areInOrder(entry.startTime, entry.fetchStart, entry.domainLookupStart, entry.domainLookupEnd, entry.connectStart, entry.connectEnd, entry.requestStart, entry.responseStart, entry.responseEnd)) {
        return undefined;
    }
    if (!hasRedirection(entry)) {
        return entry;
    }
    var redirectStart = entry.redirectStart, redirectEnd = entry.redirectEnd;
    // Firefox doesn't provide redirect timings on cross origin requests.
    // Provide a default for those.
    if (redirectStart < entry.startTime) {
        redirectStart = entry.startTime;
    }
    if (redirectEnd < entry.startTime) {
        redirectEnd = entry.fetchStart;
    }
    // Make sure redirect timings are in order
    if (!areInOrder(entry.startTime, redirectStart, redirectEnd, entry.fetchStart)) {
        return undefined;
    }
    return (0, browser_core_1.assign)({}, entry, {
        redirectEnd: redirectEnd,
        redirectStart: redirectStart,
    });
}
exports.toValidEntry = toValidEntry;
function hasRedirection(entry) {
    // The only time fetchStart is different than startTime is if a redirection occurred.
    return entry.fetchStart !== entry.startTime;
}
function formatTiming(origin, start, end) {
    return {
        duration: (0, browser_core_1.toServerDuration)((0, browser_core_1.elapsed)(start, end)),
        start: (0, browser_core_1.toServerDuration)((0, browser_core_1.elapsed)(origin, start)),
    };
}
function computeSize(entry) {
    // Make sure a request actually occurred
    if (entry.startTime < entry.responseStart) {
        return entry.decodedBodySize;
    }
    return undefined;
}
exports.computeSize = computeSize;
function isAllowedRequestUrl(configuration, url) {
    return url && !configuration.isIntakeUrl(url);
}
exports.isAllowedRequestUrl = isAllowedRequestUrl;

},{"@datadog/browser-core":432}],493:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetFirstHidden = exports.trackFirstHidden = void 0;
var browser_core_1 = require("@datadog/browser-core");
var trackFirstHiddenSingleton;
var stopListeners;
function trackFirstHidden(eventTarget) {
    if (eventTarget === void 0) { eventTarget = window; }
    if (!trackFirstHiddenSingleton) {
        if (document.visibilityState === 'hidden') {
            trackFirstHiddenSingleton = {
                timeStamp: 0,
            };
        }
        else {
            trackFirstHiddenSingleton = {
                timeStamp: Infinity,
            };
            (stopListeners = (0, browser_core_1.addEventListeners)(eventTarget, ["pagehide" /* PAGE_HIDE */, "visibilitychange" /* VISIBILITY_CHANGE */], function (event) {
                if (event.type === 'pagehide' || document.visibilityState === 'hidden') {
                    trackFirstHiddenSingleton.timeStamp = event.timeStamp;
                    stopListeners();
                }
            }, { capture: true }).stop);
        }
    }
    return trackFirstHiddenSingleton;
}
exports.trackFirstHidden = trackFirstHidden;
function resetFirstHidden() {
    if (stopListeners) {
        stopListeners();
    }
    trackFirstHiddenSingleton = undefined;
}
exports.resetFirstHidden = resetFirstHidden;

},{"@datadog/browser-core":432}],494:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackFirstInputTimings = exports.trackLargestContentfulPaintTiming = exports.trackFirstContentfulPaintTiming = exports.trackNavigationTimings = exports.trackInitialViewTimings = exports.TIMING_MAXIMUM_DELAY = void 0;
var browser_core_1 = require("@datadog/browser-core");
var trackFirstHidden_1 = require("./trackFirstHidden");
// Discard LCP and FCP timings above a certain delay to avoid incorrect data
// It happens in some cases like sleep mode or some browser implementations
exports.TIMING_MAXIMUM_DELAY = 10 * browser_core_1.ONE_MINUTE;
function trackInitialViewTimings(lifeCycle, callback) {
    var timings = {};
    function setTimings(newTimings) {
        (0, browser_core_1.assign)(timings, newTimings);
        callback(timings);
    }
    var stopNavigationTracking = trackNavigationTimings(lifeCycle, setTimings).stop;
    var stopFCPTracking = trackFirstContentfulPaintTiming(lifeCycle, function (firstContentfulPaint) {
        return setTimings({ firstContentfulPaint: firstContentfulPaint });
    }).stop;
    var stopLCPTracking = trackLargestContentfulPaintTiming(lifeCycle, window, function (largestContentfulPaint) {
        setTimings({
            largestContentfulPaint: largestContentfulPaint,
        });
    }).stop;
    var stopFIDTracking = trackFirstInputTimings(lifeCycle, function (_a) {
        var firstInputDelay = _a.firstInputDelay, firstInputTime = _a.firstInputTime;
        setTimings({
            firstInputDelay: firstInputDelay,
            firstInputTime: firstInputTime,
        });
    }).stop;
    return {
        stop: function () {
            stopNavigationTracking();
            stopFCPTracking();
            stopLCPTracking();
            stopFIDTracking();
        },
    };
}
exports.trackInitialViewTimings = trackInitialViewTimings;
function trackNavigationTimings(lifeCycle, callback) {
    var stop = lifeCycle.subscribe(0 /* PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if (entry.entryType === 'navigation') {
                callback({
                    domComplete: entry.domComplete,
                    domContentLoaded: entry.domContentLoadedEventEnd,
                    domInteractive: entry.domInteractive,
                    loadEvent: entry.loadEventEnd,
                    // In some cases the value reported is negative or is larger
                    // than the current page time. Ignore these cases:
                    // https://github.com/GoogleChrome/web-vitals/issues/137
                    // https://github.com/GoogleChrome/web-vitals/issues/162
                    firstByte: entry.responseStart >= 0 && entry.responseStart <= (0, browser_core_1.relativeNow)() ? entry.responseStart : undefined,
                });
            }
        }
    }).unsubscribe;
    return { stop: stop };
}
exports.trackNavigationTimings = trackNavigationTimings;
function trackFirstContentfulPaintTiming(lifeCycle, callback) {
    var firstHidden = (0, trackFirstHidden_1.trackFirstHidden)();
    var stop = lifeCycle.subscribe(0 /* PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        var fcpEntry = (0, browser_core_1.find)(entries, function (entry) {
            return entry.entryType === 'paint' &&
                entry.name === 'first-contentful-paint' &&
                entry.startTime < firstHidden.timeStamp &&
                entry.startTime < exports.TIMING_MAXIMUM_DELAY;
        });
        if (fcpEntry) {
            callback(fcpEntry.startTime);
        }
    }).unsubscribe;
    return { stop: stop };
}
exports.trackFirstContentfulPaintTiming = trackFirstContentfulPaintTiming;
/**
 * Track the largest contentful paint (LCP) occurring during the initial View.  This can yield
 * multiple values, only the most recent one should be used.
 * Documentation: https://web.dev/lcp/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/getLCP.ts
 */
function trackLargestContentfulPaintTiming(lifeCycle, eventTarget, callback) {
    var firstHidden = (0, trackFirstHidden_1.trackFirstHidden)();
    // Ignore entries that come after the first user interaction.  According to the documentation, the
    // browser should not send largest-contentful-paint entries after a user interact with the page,
    // but the web-vitals reference implementation uses this as a safeguard.
    var firstInteractionTimestamp = Infinity;
    var stopEventListener = (0, browser_core_1.addEventListeners)(eventTarget, ["pointerdown" /* POINTER_DOWN */, "keydown" /* KEY_DOWN */], function (event) {
        firstInteractionTimestamp = event.timeStamp;
    }, { capture: true, once: true }).stop;
    var unsubscribeLifeCycle = lifeCycle.subscribe(0 /* PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        var lcpEntry = (0, browser_core_1.findLast)(entries, function (entry) {
            return entry.entryType === 'largest-contentful-paint' &&
                entry.startTime < firstInteractionTimestamp &&
                entry.startTime < firstHidden.timeStamp &&
                entry.startTime < exports.TIMING_MAXIMUM_DELAY;
        });
        if (lcpEntry) {
            callback(lcpEntry.startTime);
        }
    }).unsubscribe;
    return {
        stop: function () {
            stopEventListener();
            unsubscribeLifeCycle();
        },
    };
}
exports.trackLargestContentfulPaintTiming = trackLargestContentfulPaintTiming;
/**
 * Track the first input occurring during the initial View to return:
 * - First Input Delay
 * - First Input Time
 * Callback is called at most one time.
 * Documentation: https://web.dev/fid/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/getFID.ts
 */
function trackFirstInputTimings(lifeCycle, callback) {
    var firstHidden = (0, trackFirstHidden_1.trackFirstHidden)();
    var stop = lifeCycle.subscribe(0 /* PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        var firstInputEntry = (0, browser_core_1.find)(entries, function (entry) {
            return entry.entryType === 'first-input' && entry.startTime < firstHidden.timeStamp;
        });
        if (firstInputEntry) {
            var firstInputDelay = (0, browser_core_1.elapsed)(firstInputEntry.startTime, firstInputEntry.processingStart);
            callback({
                // Ensure firstInputDelay to be positive, see
                // https://bugs.chromium.org/p/chromium/issues/detail?id=1185815
                firstInputDelay: firstInputDelay >= 0 ? firstInputDelay : 0,
                firstInputTime: firstInputEntry.startTime,
            });
        }
    }).unsubscribe;
    return {
        stop: stop,
    };
}
exports.trackFirstInputTimings = trackFirstInputTimings;

},{"./trackFirstHidden":493,"@datadog/browser-core":432}],495:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackViewEventCounts = exports.KEEP_TRACKING_EVENT_COUNTS_AFTER_VIEW_DELAY = void 0;
var browser_core_1 = require("@datadog/browser-core");
var trackEventCounts_1 = require("../../trackEventCounts");
// Some events are not being counted as they transcend views. To reduce the occurrence;
// an arbitrary delay is added for stopping event counting after the view ends.
//
// Ideally, we would not stop and keep counting events until the end of the session.
// But this might have a small performance impact if there are many many views:
// we would need to go through each event to see if the related view matches.
// So let's have a fairly short delay to avoid impacting performances too much.
//
// In the future, we could have views stored in a data structure similar to ContextHistory. Whenever
// a child event is collected, we could look into this history to find the matching view and
// increase the associated and increase its counter. Having a centralized data structure for it
// would allow us to look for views more efficiently.
//
// For now, having a small cleanup delay will already improve the situation in most cases.
exports.KEEP_TRACKING_EVENT_COUNTS_AFTER_VIEW_DELAY = 5 * browser_core_1.ONE_MINUTE;
function trackViewEventCounts(lifeCycle, viewId, onChange) {
    var _a = (0, trackEventCounts_1.trackEventCounts)({
        lifeCycle: lifeCycle,
        isChildEvent: function (event) { return event.view.id === viewId; },
        onChange: onChange,
    }), stop = _a.stop, eventCounts = _a.eventCounts;
    return {
        scheduleStop: function () {
            (0, browser_core_1.setTimeout)(stop, exports.KEEP_TRACKING_EVENT_COUNTS_AFTER_VIEW_DELAY);
        },
        eventCounts: eventCounts,
    };
}
exports.trackViewEventCounts = trackViewEventCounts;

},{"../../trackEventCounts":503,"@datadog/browser-core":432}],496:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackViewMetrics = void 0;
var browser_core_1 = require("@datadog/browser-core");
var performanceCollection_1 = require("../../../browser/performanceCollection");
var waitPageActivityEnd_1 = require("../../waitPageActivityEnd");
function trackViewMetrics(lifeCycle, domMutationObservable, configuration, scheduleViewUpdate, loadingType, viewStart) {
    var viewMetrics = {};
    var _a = trackLoadingTime(lifeCycle, domMutationObservable, configuration, loadingType, viewStart, function (newLoadingTime) {
        viewMetrics.loadingTime = newLoadingTime;
        scheduleViewUpdate();
    }), stopLoadingTimeTracking = _a.stop, setLoadEvent = _a.setLoadEvent;
    var stopCLSTracking;
    if (isLayoutShiftSupported()) {
        viewMetrics.cumulativeLayoutShift = 0;
        (stopCLSTracking = trackCumulativeLayoutShift(lifeCycle, function (cumulativeLayoutShift) {
            viewMetrics.cumulativeLayoutShift = cumulativeLayoutShift;
            scheduleViewUpdate();
        }).stop);
    }
    else {
        stopCLSTracking = browser_core_1.noop;
    }
    return {
        stop: function () {
            stopLoadingTimeTracking();
            stopCLSTracking();
        },
        setLoadEvent: setLoadEvent,
        viewMetrics: viewMetrics,
    };
}
exports.trackViewMetrics = trackViewMetrics;
function trackLoadingTime(lifeCycle, domMutationObservable, configuration, loadType, viewStart, callback) {
    var isWaitingForLoadEvent = loadType === "initial_load" /* INITIAL_LOAD */;
    var isWaitingForActivityLoadingTime = true;
    var loadingTimeCandidates = [];
    function invokeCallbackIfAllCandidatesAreReceived() {
        if (!isWaitingForActivityLoadingTime && !isWaitingForLoadEvent && loadingTimeCandidates.length > 0) {
            callback(Math.max.apply(Math, loadingTimeCandidates));
        }
    }
    var stop = (0, waitPageActivityEnd_1.waitPageActivityEnd)(lifeCycle, domMutationObservable, configuration, function (event) {
        if (isWaitingForActivityLoadingTime) {
            isWaitingForActivityLoadingTime = false;
            if (event.hadActivity) {
                loadingTimeCandidates.push((0, browser_core_1.elapsed)(viewStart.timeStamp, event.end));
            }
            invokeCallbackIfAllCandidatesAreReceived();
        }
    }).stop;
    return {
        stop: stop,
        setLoadEvent: function (loadEvent) {
            if (isWaitingForLoadEvent) {
                isWaitingForLoadEvent = false;
                loadingTimeCandidates.push(loadEvent);
                invokeCallbackIfAllCandidatesAreReceived();
            }
        },
    };
}
/**
 * Track the cumulative layout shifts (CLS).
 * Layout shifts are grouped into session windows.
 * The minimum gap between session windows is 1 second.
 * The maximum duration of a session window is 5 second.
 * The session window layout shift value is the sum of layout shifts inside it.
 * The CLS value is the max of session windows values.
 *
 * This yields a new value whenever the CLS value is updated (a higher session window value is computed).
 *
 * See isLayoutShiftSupported to check for browser support.
 *
 * Documentation:
 * https://web.dev/cls/
 * https://web.dev/evolving-cls/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/getCLS.ts
 */
function trackCumulativeLayoutShift(lifeCycle, callback) {
    var maxClsValue = 0;
    var window = slidingSessionWindow();
    var stop = lifeCycle.subscribe(0 /* PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if (entry.entryType === 'layout-shift' && !entry.hadRecentInput) {
                window.update(entry);
                if (window.value() > maxClsValue) {
                    maxClsValue = window.value();
                    callback((0, browser_core_1.round)(maxClsValue, 4));
                }
            }
        }
    }).unsubscribe;
    return {
        stop: stop,
    };
}
function slidingSessionWindow() {
    var value = 0;
    var startTime;
    var endTime;
    return {
        update: function (entry) {
            var shouldCreateNewWindow = startTime === undefined ||
                entry.startTime - endTime >= browser_core_1.ONE_SECOND ||
                entry.startTime - startTime >= 5 * browser_core_1.ONE_SECOND;
            if (shouldCreateNewWindow) {
                startTime = endTime = entry.startTime;
                value = entry.value;
            }
            else {
                value += entry.value;
                endTime = entry.startTime;
            }
        },
        value: function () { return value; },
    };
}
/**
 * Check whether `layout-shift` is supported by the browser.
 */
function isLayoutShiftSupported() {
    return (0, performanceCollection_1.supportPerformanceTimingEvent)('layout-shift');
}

},{"../../../browser/performanceCollection":463,"../../waitPageActivityEnd":504,"@datadog/browser-core":432}],497:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackViews = exports.SESSION_KEEP_ALIVE_INTERVAL = exports.THROTTLE_VIEW_UPDATE_PERIOD = void 0;
var browser_core_1 = require("@datadog/browser-core");
var trackInitialViewTimings_1 = require("./trackInitialViewTimings");
var trackViewMetrics_1 = require("./trackViewMetrics");
var trackViewEventCounts_1 = require("./trackViewEventCounts");
exports.THROTTLE_VIEW_UPDATE_PERIOD = 3000;
exports.SESSION_KEEP_ALIVE_INTERVAL = 5 * browser_core_1.ONE_MINUTE;
function trackViews(location, lifeCycle, domMutationObservable, configuration, locationChangeObservable, areViewsTrackedAutomatically, initialViewOptions) {
    var _a = trackInitialView(initialViewOptions), stopInitialViewTracking = _a.stop, initialView = _a.initialView;
    var currentView = initialView;
    var stopViewLifeCycle = startViewLifeCycle().stop;
    var locationChangeSubscription;
    if (areViewsTrackedAutomatically) {
        locationChangeSubscription = renewViewOnLocationChange(locationChangeObservable);
    }
    function trackInitialView(options) {
        var initialView = newView(lifeCycle, domMutationObservable, configuration, location, "initial_load" /* INITIAL_LOAD */, (0, browser_core_1.clocksOrigin)(), options);
        var stop = (0, trackInitialViewTimings_1.trackInitialViewTimings)(lifeCycle, function (timings) {
            initialView.updateTimings(timings);
            initialView.scheduleUpdate();
        }).stop;
        return { initialView: initialView, stop: stop };
    }
    function trackViewChange(startClocks, viewOptions) {
        return newView(lifeCycle, domMutationObservable, configuration, location, "route_change" /* ROUTE_CHANGE */, startClocks, viewOptions);
    }
    function startViewLifeCycle() {
        lifeCycle.subscribe(8 /* SESSION_RENEWED */, function () {
            // do not trigger view update to avoid wrong data
            currentView.end();
            // Renew view on session renewal
            currentView = trackViewChange(undefined, {
                name: currentView.name,
                service: currentView.service,
                version: currentView.version,
            });
        });
        // End the current view on page unload
        lifeCycle.subscribe(9 /* PAGE_EXITED */, function (pageExitEvent) {
            if (pageExitEvent.reason === browser_core_1.PageExitReason.UNLOADING || pageExitEvent.reason === browser_core_1.PageExitReason.PAGEHIDE) {
                currentView.end();
                currentView.triggerUpdate();
            }
        });
        // Session keep alive
        var keepAliveInterval = window.setInterval((0, browser_core_1.monitor)(function () {
            currentView.triggerUpdate();
        }), exports.SESSION_KEEP_ALIVE_INTERVAL);
        return {
            stop: function () {
                clearInterval(keepAliveInterval);
            },
        };
    }
    function renewViewOnLocationChange(locationChangeObservable) {
        return locationChangeObservable.subscribe(function (_a) {
            var oldLocation = _a.oldLocation, newLocation = _a.newLocation;
            if (areDifferentLocation(oldLocation, newLocation)) {
                currentView.end();
                currentView.triggerUpdate();
                currentView = trackViewChange();
                return;
            }
        });
    }
    return {
        addTiming: function (name, time) {
            if (time === void 0) { time = (0, browser_core_1.timeStampNow)(); }
            currentView.addTiming(name, time);
            currentView.scheduleUpdate();
        },
        startView: function (options, startClocks) {
            currentView.end(startClocks);
            currentView.triggerUpdate();
            currentView = trackViewChange(startClocks, options);
        },
        stop: function () {
            locationChangeSubscription === null || locationChangeSubscription === void 0 ? void 0 : locationChangeSubscription.unsubscribe();
            stopInitialViewTracking();
            stopViewLifeCycle();
            currentView.end();
        },
    };
}
exports.trackViews = trackViews;
function newView(lifeCycle, domMutationObservable, configuration, initialLocation, loadingType, startClocks, viewOptions) {
    if (startClocks === void 0) { startClocks = (0, browser_core_1.clocksNow)(); }
    // Setup initial values
    var id = (0, browser_core_1.generateUUID)();
    var timings = {};
    var customTimings = {};
    var documentVersion = 0;
    var endClocks;
    var location = (0, browser_core_1.shallowClone)(initialLocation);
    var name;
    var service;
    var version;
    if (viewOptions) {
        name = viewOptions.name;
        service = viewOptions.service;
        version = viewOptions.version;
    }
    lifeCycle.notify(2 /* VIEW_CREATED */, {
        id: id,
        name: name,
        startClocks: startClocks,
        service: service,
        version: version,
    });
    // Update the view every time the measures are changing
    var _a = (0, browser_core_1.throttle)(triggerViewUpdate, exports.THROTTLE_VIEW_UPDATE_PERIOD, {
        leading: false,
    }), scheduleViewUpdate = _a.throttled, cancelScheduleViewUpdate = _a.cancel;
    var _b = (0, trackViewMetrics_1.trackViewMetrics)(lifeCycle, domMutationObservable, configuration, scheduleViewUpdate, loadingType, startClocks), setLoadEvent = _b.setLoadEvent, stopViewMetricsTracking = _b.stop, viewMetrics = _b.viewMetrics;
    var _c = (0, trackViewEventCounts_1.trackViewEventCounts)(lifeCycle, id, scheduleViewUpdate), scheduleStopEventCountsTracking = _c.scheduleStop, eventCounts = _c.eventCounts;
    // Initial view update
    triggerViewUpdate();
    function triggerViewUpdate() {
        documentVersion += 1;
        var currentEnd = endClocks === undefined ? (0, browser_core_1.timeStampNow)() : endClocks.timeStamp;
        lifeCycle.notify(3 /* VIEW_UPDATED */, (0, browser_core_1.assign)({
            customTimings: customTimings,
            documentVersion: documentVersion,
            id: id,
            name: name,
            service: service,
            version: version,
            loadingType: loadingType,
            location: location,
            startClocks: startClocks,
            timings: timings,
            duration: (0, browser_core_1.elapsed)(startClocks.timeStamp, currentEnd),
            isActive: endClocks === undefined,
            eventCounts: eventCounts,
        }, viewMetrics));
    }
    return {
        name: name,
        service: service,
        version: version,
        scheduleUpdate: scheduleViewUpdate,
        end: function (clocks) {
            if (clocks === void 0) { clocks = (0, browser_core_1.clocksNow)(); }
            endClocks = clocks;
            lifeCycle.notify(4 /* VIEW_ENDED */, { endClocks: endClocks });
            stopViewMetricsTracking();
            scheduleStopEventCountsTracking();
        },
        triggerUpdate: function () {
            // cancel any pending view updates execution
            cancelScheduleViewUpdate();
            triggerViewUpdate();
        },
        updateTimings: function (newTimings) {
            timings = newTimings;
            if (newTimings.loadEvent !== undefined) {
                setLoadEvent(newTimings.loadEvent);
            }
        },
        addTiming: function (name, time) {
            var relativeTime = (0, browser_core_1.looksLikeRelativeTime)(time) ? time : (0, browser_core_1.elapsed)(startClocks.timeStamp, time);
            customTimings[sanitizeTiming(name)] = relativeTime;
        },
    };
}
/**
 * Timing name is used as facet path that must contain only letters, digits, or the characters - _ . @ $
 */
function sanitizeTiming(name) {
    var sanitized = name.replace(/[^a-zA-Z0-9-_.@$]/g, '_');
    if (sanitized !== name) {
        browser_core_1.display.warn("Invalid timing name: ".concat(name, ", sanitized to: ").concat(sanitized));
    }
    return sanitized;
}
function areDifferentLocation(currentLocation, otherLocation) {
    return (currentLocation.pathname !== otherLocation.pathname ||
        (!isHashAnAnchor(otherLocation.hash) &&
            getPathFromHash(otherLocation.hash) !== getPathFromHash(currentLocation.hash)));
}
function isHashAnAnchor(hash) {
    var correspondingId = hash.substr(1);
    return !!document.getElementById(correspondingId);
}
function getPathFromHash(hash) {
    var index = hash.indexOf('?');
    return index < 0 ? hash : hash.slice(0, index);
}

},{"./trackInitialViewTimings":494,"./trackViewEventCounts":495,"./trackViewMetrics":496,"@datadog/browser-core":432}],498:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startViewCollection = void 0;
var browser_core_1 = require("@datadog/browser-core");
var trackViews_1 = require("./trackViews");
function startViewCollection(lifeCycle, configuration, location, domMutationObservable, locationChangeObservable, foregroundContexts, featureFlagContexts, recorderApi, initialViewOptions) {
    lifeCycle.subscribe(3 /* VIEW_UPDATED */, function (view) {
        return lifeCycle.notify(10 /* RAW_RUM_EVENT_COLLECTED */, processViewUpdate(view, foregroundContexts, featureFlagContexts, recorderApi));
    });
    return (0, trackViews_1.trackViews)(location, lifeCycle, domMutationObservable, configuration, locationChangeObservable, !configuration.trackViewsManually, initialViewOptions);
}
exports.startViewCollection = startViewCollection;
function processViewUpdate(view, foregroundContexts, featureFlagContexts, recorderApi) {
    var replayStats = recorderApi.getReplayStats(view.id);
    var featureFlagContext = featureFlagContexts.findFeatureFlagEvaluations(view.startClocks.relative);
    var viewEvent = {
        _dd: {
            document_version: view.documentVersion,
            replay_stats: replayStats,
        },
        date: view.startClocks.timeStamp,
        type: "view" /* VIEW */,
        view: {
            action: {
                count: view.eventCounts.actionCount,
            },
            frustration: {
                count: view.eventCounts.frustrationCount,
            },
            cumulative_layout_shift: view.cumulativeLayoutShift,
            first_byte: (0, browser_core_1.toServerDuration)(view.timings.firstByte),
            dom_complete: (0, browser_core_1.toServerDuration)(view.timings.domComplete),
            dom_content_loaded: (0, browser_core_1.toServerDuration)(view.timings.domContentLoaded),
            dom_interactive: (0, browser_core_1.toServerDuration)(view.timings.domInteractive),
            error: {
                count: view.eventCounts.errorCount,
            },
            first_contentful_paint: (0, browser_core_1.toServerDuration)(view.timings.firstContentfulPaint),
            first_input_delay: (0, browser_core_1.toServerDuration)(view.timings.firstInputDelay),
            first_input_time: (0, browser_core_1.toServerDuration)(view.timings.firstInputTime),
            is_active: view.isActive,
            name: view.name,
            largest_contentful_paint: (0, browser_core_1.toServerDuration)(view.timings.largestContentfulPaint),
            load_event: (0, browser_core_1.toServerDuration)(view.timings.loadEvent),
            loading_time: discardNegativeDuration((0, browser_core_1.toServerDuration)(view.loadingTime)),
            loading_type: view.loadingType,
            long_task: {
                count: view.eventCounts.longTaskCount,
            },
            resource: {
                count: view.eventCounts.resourceCount,
            },
            time_spent: (0, browser_core_1.toServerDuration)(view.duration),
            in_foreground_periods: foregroundContexts.selectInForegroundPeriodsFor(view.startClocks.relative, view.duration),
        },
        feature_flags: featureFlagContext && !(0, browser_core_1.isEmptyObject)(featureFlagContext) ? featureFlagContext : undefined,
        session: {
            has_replay: replayStats ? true : undefined,
        },
    };
    if (!(0, browser_core_1.isEmptyObject)(view.customTimings)) {
        viewEvent.view.custom_timings = (0, browser_core_1.mapValues)(view.customTimings, browser_core_1.toServerDuration);
    }
    return {
        rawRumEvent: viewEvent,
        startTime: view.startClocks.relative,
        domainContext: {
            location: view.location,
        },
    };
}
function discardNegativeDuration(duration) {
    return (0, browser_core_1.isNumber)(duration) && duration < 0 ? undefined : duration;
}

},{"./trackViews":497,"@datadog/browser-core":432}],499:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startRumSessionManagerStub = exports.startRumSessionManager = exports.RUM_SESSION_KEY = void 0;
var browser_core_1 = require("@datadog/browser-core");
exports.RUM_SESSION_KEY = 'rum';
function startRumSessionManager(configuration, lifeCycle) {
    var sessionManager = (0, browser_core_1.startSessionManager)(configuration.cookieOptions, exports.RUM_SESSION_KEY, function (rawTrackingType) {
        return computeSessionState(configuration, rawTrackingType);
    });
    sessionManager.expireObservable.subscribe(function () {
        lifeCycle.notify(7 /* SESSION_EXPIRED */);
    });
    sessionManager.renewObservable.subscribe(function () {
        lifeCycle.notify(8 /* SESSION_RENEWED */);
    });
    return {
        findTrackedSession: function (startTime) {
            var session = sessionManager.findActiveSession(startTime);
            if (!session || !isTypeTracked(session.trackingType)) {
                return;
            }
            var plan = session.trackingType === "1" /* TRACKED_WITH_SESSION_REPLAY */
                ? 2 /* WITH_SESSION_REPLAY */
                : 1 /* WITHOUT_SESSION_REPLAY */;
            return {
                id: session.id,
                plan: plan,
                sessionReplayAllowed: plan === 2 /* WITH_SESSION_REPLAY */,
                longTaskAllowed: configuration.trackLongTasks !== undefined
                    ? configuration.trackLongTasks
                    : configuration.oldPlansBehavior && plan === 2 /* WITH_SESSION_REPLAY */,
                resourceAllowed: configuration.trackResources !== undefined
                    ? configuration.trackResources
                    : configuration.oldPlansBehavior && plan === 2 /* WITH_SESSION_REPLAY */,
            };
        },
    };
}
exports.startRumSessionManager = startRumSessionManager;
/**
 * Start a tracked replay session stub
 */
function startRumSessionManagerStub() {
    var session = {
        id: '00000000-aaaa-0000-aaaa-000000000000',
        plan: 1 /* WITHOUT_SESSION_REPLAY */,
        sessionReplayAllowed: false,
        longTaskAllowed: true,
        resourceAllowed: true,
    };
    return {
        findTrackedSession: function () { return session; },
    };
}
exports.startRumSessionManagerStub = startRumSessionManagerStub;
function computeSessionState(configuration, rawTrackingType) {
    var trackingType;
    if (hasValidRumSession(rawTrackingType)) {
        trackingType = rawTrackingType;
    }
    else if (!(0, browser_core_1.performDraw)(configuration.sessionSampleRate)) {
        trackingType = "0" /* NOT_TRACKED */;
    }
    else if (!(0, browser_core_1.performDraw)(configuration.sessionReplaySampleRate)) {
        trackingType = "2" /* TRACKED_WITHOUT_SESSION_REPLAY */;
    }
    else {
        trackingType = "1" /* TRACKED_WITH_SESSION_REPLAY */;
    }
    return {
        trackingType: trackingType,
        isTracked: isTypeTracked(trackingType),
    };
}
function hasValidRumSession(trackingType) {
    return (trackingType === "0" /* NOT_TRACKED */ ||
        trackingType === "1" /* TRACKED_WITH_SESSION_REPLAY */ ||
        trackingType === "2" /* TRACKED_WITHOUT_SESSION_REPLAY */);
}
function isTypeTracked(rumSessionType) {
    return (rumSessionType === "2" /* TRACKED_WITHOUT_SESSION_REPLAY */ ||
        rumSessionType === "1" /* TRACKED_WITH_SESSION_REPLAY */);
}

},{"@datadog/browser-core":432}],500:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startCustomerDataTelemetry = exports.MEASURES_PERIOD_DURATION = void 0;
var browser_core_1 = require("@datadog/browser-core");
exports.MEASURES_PERIOD_DURATION = 10 * browser_core_1.ONE_SECOND;
var currentPeriodMeasures;
var currentBatchMeasures;
var batchHasRumEvent;
function startCustomerDataTelemetry(configuration, telemetry, lifeCycle, globalContextManager, userContextManager, featureFlagContexts, batchFlushObservable) {
    var customerDataTelemetryEnabled = telemetry.enabled && (0, browser_core_1.performDraw)(configuration.customerDataTelemetrySampleRate);
    if (!customerDataTelemetryEnabled) {
        return;
    }
    initCurrentPeriodMeasures();
    initCurrentBatchMeasures();
    // We measure the data of every view updates even if there could only be one per batch due to the upsert
    // It means that contexts bytes count sums can be higher than it really is
    lifeCycle.subscribe(11 /* RUM_EVENT_COLLECTED */, function (event) {
        batchHasRumEvent = true;
        updateMeasure(currentBatchMeasures.globalContextBytes, !(0, browser_core_1.isEmptyObject)(globalContextManager.get()) ? globalContextManager.getBytesCount() : 0);
        updateMeasure(currentBatchMeasures.userContextBytes, !(0, browser_core_1.isEmptyObject)(userContextManager.get()) ? userContextManager.getBytesCount() : 0);
        var featureFlagContext = featureFlagContexts.findFeatureFlagEvaluations();
        var hasFeatureFlagContext = (0, browser_core_1.includes)(["view" /* VIEW */, "error" /* ERROR */], event.type) &&
            featureFlagContext &&
            !(0, browser_core_1.isEmptyObject)(featureFlagContext);
        updateMeasure(currentBatchMeasures.featureFlagBytes, hasFeatureFlagContext ? featureFlagContexts.getFeatureFlagBytesCount() : 0);
    });
    batchFlushObservable.subscribe(function (_a) {
        var bufferBytesCount = _a.bufferBytesCount, bufferMessagesCount = _a.bufferMessagesCount;
        // Don't measure batch that only contains telemetry events to avoid batch sending loop
        // It could happen because after each batch we are adding a customer data measures telemetry event to the next one
        if (!batchHasRumEvent) {
            return;
        }
        currentPeriodMeasures.batchCount += 1;
        updateMeasure(currentPeriodMeasures.batchBytesCount, bufferBytesCount);
        updateMeasure(currentPeriodMeasures.batchMessagesCount, bufferMessagesCount);
        mergeMeasure(currentPeriodMeasures.globalContextBytes, currentBatchMeasures.globalContextBytes);
        mergeMeasure(currentPeriodMeasures.userContextBytes, currentBatchMeasures.userContextBytes);
        mergeMeasure(currentPeriodMeasures.featureFlagBytes, currentBatchMeasures.featureFlagBytes);
        initCurrentBatchMeasures();
    });
    setInterval((0, browser_core_1.monitor)(sendCurrentPeriodMeasures), exports.MEASURES_PERIOD_DURATION);
}
exports.startCustomerDataTelemetry = startCustomerDataTelemetry;
function sendCurrentPeriodMeasures() {
    if (currentPeriodMeasures.batchCount === 0) {
        return;
    }
    (0, browser_core_1.addTelemetryDebug)('Customer data measures', currentPeriodMeasures);
    initCurrentPeriodMeasures();
}
function createMeasure() {
    return { min: Infinity, max: 0, sum: 0 };
}
function updateMeasure(measure, value) {
    measure.sum += value;
    measure.min = Math.min(measure.min, value);
    measure.max = Math.max(measure.max, value);
}
function mergeMeasure(target, source) {
    target.sum += source.sum;
    target.min = Math.min(target.min, source.min);
    target.max = Math.max(target.max, source.max);
}
function initCurrentPeriodMeasures() {
    currentPeriodMeasures = {
        batchCount: 0,
        batchBytesCount: createMeasure(),
        batchMessagesCount: createMeasure(),
        globalContextBytes: createMeasure(),
        userContextBytes: createMeasure(),
        featureFlagBytes: createMeasure(),
    };
}
function initCurrentBatchMeasures() {
    batchHasRumEvent = false;
    currentBatchMeasures = {
        globalContextBytes: createMeasure(),
        userContextBytes: createMeasure(),
        featureFlagBytes: createMeasure(),
    };
}

},{"@datadog/browser-core":432}],501:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findTraceComment = exports.createDocumentTraceData = exports.getDocumentTraceDataFromComment = exports.getDocumentTraceDataFromMeta = exports.getDocumentTraceId = exports.INITIAL_DOCUMENT_OUTDATED_TRACE_ID_THRESHOLD = void 0;
var browser_core_1 = require("@datadog/browser-core");
var htmlDomUtils_1 = require("../../browser/htmlDomUtils");
exports.INITIAL_DOCUMENT_OUTDATED_TRACE_ID_THRESHOLD = 2 * browser_core_1.ONE_MINUTE;
function getDocumentTraceId(document) {
    var data = getDocumentTraceDataFromMeta(document) || getDocumentTraceDataFromComment(document);
    if (!data || data.traceTime <= (0, browser_core_1.dateNow)() - exports.INITIAL_DOCUMENT_OUTDATED_TRACE_ID_THRESHOLD) {
        return undefined;
    }
    return data.traceId;
}
exports.getDocumentTraceId = getDocumentTraceId;
function getDocumentTraceDataFromMeta(document) {
    var traceIdMeta = document.querySelector('meta[name=dd-trace-id]');
    var traceTimeMeta = document.querySelector('meta[name=dd-trace-time]');
    return createDocumentTraceData(traceIdMeta && traceIdMeta.content, traceTimeMeta && traceTimeMeta.content);
}
exports.getDocumentTraceDataFromMeta = getDocumentTraceDataFromMeta;
function getDocumentTraceDataFromComment(document) {
    var comment = findTraceComment(document);
    if (!comment) {
        return undefined;
    }
    return createDocumentTraceData((0, browser_core_1.findCommaSeparatedValue)(comment, 'trace-id'), (0, browser_core_1.findCommaSeparatedValue)(comment, 'trace-time'));
}
exports.getDocumentTraceDataFromComment = getDocumentTraceDataFromComment;
function createDocumentTraceData(traceId, rawTraceTime) {
    var traceTime = rawTraceTime && Number(rawTraceTime);
    if (!traceId || !traceTime) {
        return undefined;
    }
    return {
        traceId: traceId,
        traceTime: traceTime,
    };
}
exports.createDocumentTraceData = createDocumentTraceData;
function findTraceComment(document) {
    // 1. Try to find the comment as a direct child of the document
    // Note: TSLint advises to use a 'for of', but TS doesn't allow to use 'for of' if the iterated
    // value is not an array or string (here, a NodeList).
    for (var i = 0; i < document.childNodes.length; i += 1) {
        var comment = getTraceCommentFromNode(document.childNodes[i]);
        if (comment) {
            return comment;
        }
    }
    // 2. If the comment is placed after the </html> tag, but have some space or new lines before or
    // after, the DOM parser will lift it (and the surrounding text) at the end of the <body> tag.
    // Try to look for the comment at the end of the <body> by by iterating over its child nodes in
    // reverse order, stopping if we come across a non-text node.
    if (document.body) {
        for (var i = document.body.childNodes.length - 1; i >= 0; i -= 1) {
            var node = document.body.childNodes[i];
            var comment = getTraceCommentFromNode(node);
            if (comment) {
                return comment;
            }
            if (!(0, htmlDomUtils_1.isTextNode)(node)) {
                break;
            }
        }
    }
}
exports.findTraceComment = findTraceComment;
function getTraceCommentFromNode(node) {
    if (node && (0, htmlDomUtils_1.isCommentNode)(node)) {
        var match = /^\s*DATADOG;(.*?)\s*$/.exec(node.data);
        if (match) {
            return match[1];
        }
    }
}

},{"../../browser/htmlDomUtils":461,"@datadog/browser-core":432}],502:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TraceIdentifier = exports.isTracingSupported = exports.startTracer = exports.clearTracingIfNeeded = exports.isTracingOption = void 0;
var browser_core_1 = require("@datadog/browser-core");
function isTracingOption(item) {
    var expectedItem = item;
    return ((0, browser_core_1.getType)(expectedItem) === 'object' &&
        (0, browser_core_1.isMatchOption)(expectedItem.match) &&
        Array.isArray(expectedItem.propagatorTypes));
}
exports.isTracingOption = isTracingOption;
/**
 * Clear tracing information to avoid incomplete traces. Ideally, we should do it when the
 * request did not reach the server, but the browser does not expose this. So, we clear tracing
 * information if the request ended with status 0 without being aborted by the application.
 *
 * Reasoning:
 *
 * * Applications are usually aborting requests after a bit of time, for example when the user is
 * typing (autocompletion) or navigating away (in a SPA). With a performant device and good
 * network conditions, the request is likely to reach the server before being canceled.
 *
 * * Requests aborted otherwise (ex: lack of internet, CORS issue, blocked by a privacy extension)
 * are likely to finish quickly and without reaching the server.
 *
 * Of course, it might not be the case every time, but it should limit having incomplete traces a
 * bit.
 * */
function clearTracingIfNeeded(context) {
    if (context.status === 0 && !context.isAborted) {
        context.traceId = undefined;
        context.spanId = undefined;
        context.traceSampled = undefined;
    }
}
exports.clearTracingIfNeeded = clearTracingIfNeeded;
function startTracer(configuration, sessionManager) {
    return {
        clearTracingIfNeeded: clearTracingIfNeeded,
        traceFetch: function (context) {
            return injectHeadersIfTracingAllowed(configuration, context, sessionManager, function (tracingHeaders) {
                var _a;
                if (context.input instanceof Request && !((_a = context.init) === null || _a === void 0 ? void 0 : _a.headers)) {
                    context.input = new Request(context.input);
                    Object.keys(tracingHeaders).forEach(function (key) {
                        ;
                        context.input.headers.append(key, tracingHeaders[key]);
                    });
                }
                else {
                    context.init = (0, browser_core_1.shallowClone)(context.init);
                    var headers_1 = [];
                    if (context.init.headers instanceof Headers) {
                        context.init.headers.forEach(function (value, key) {
                            headers_1.push([key, value]);
                        });
                    }
                    else if (Array.isArray(context.init.headers)) {
                        context.init.headers.forEach(function (header) {
                            headers_1.push(header);
                        });
                    }
                    else if (context.init.headers) {
                        Object.keys(context.init.headers).forEach(function (key) {
                            headers_1.push([key, context.init.headers[key]]);
                        });
                    }
                    context.init.headers = headers_1.concat((0, browser_core_1.objectEntries)(tracingHeaders));
                }
            });
        },
        traceXhr: function (context, xhr) {
            return injectHeadersIfTracingAllowed(configuration, context, sessionManager, function (tracingHeaders) {
                Object.keys(tracingHeaders).forEach(function (name) {
                    xhr.setRequestHeader(name, tracingHeaders[name]);
                });
            });
        },
    };
}
exports.startTracer = startTracer;
function injectHeadersIfTracingAllowed(configuration, context, sessionManager, inject) {
    if (!isTracingSupported() || !sessionManager.findTrackedSession()) {
        return;
    }
    var tracingOption = (0, browser_core_1.find)(configuration.allowedTracingUrls, function (tracingOption) {
        return (0, browser_core_1.matchList)([tracingOption.match], context.url, true);
    });
    if (!tracingOption) {
        return;
    }
    context.traceId = new TraceIdentifier();
    context.spanId = new TraceIdentifier();
    context.traceSampled = !(0, browser_core_1.isNumber)(configuration.traceSampleRate) || (0, browser_core_1.performDraw)(configuration.traceSampleRate);
    inject(makeTracingHeaders(context.traceId, context.spanId, context.traceSampled, tracingOption.propagatorTypes));
}
function isTracingSupported() {
    return getCrypto() !== undefined;
}
exports.isTracingSupported = isTracingSupported;
function getCrypto() {
    return window.crypto || window.msCrypto;
}
/**
 * When trace is not sampled, set priority to '0' instead of not adding the tracing headers
 * to prepare the implementation for sampling delegation.
 */
function makeTracingHeaders(traceId, spanId, traceSampled, propagatorTypes) {
    var tracingHeaders = {};
    propagatorTypes.forEach(function (propagatorType) {
        switch (propagatorType) {
            case 'datadog': {
                (0, browser_core_1.assign)(tracingHeaders, {
                    'x-datadog-origin': 'rum',
                    'x-datadog-parent-id': spanId.toDecimalString(),
                    'x-datadog-sampling-priority': traceSampled ? '1' : '0',
                    'x-datadog-trace-id': traceId.toDecimalString(),
                });
                break;
            }
            // https://www.w3.org/TR/trace-context/
            case 'tracecontext': {
                (0, browser_core_1.assign)(tracingHeaders, {
                    traceparent: "00-0000000000000000".concat(traceId.toPaddedHexadecimalString(), "-").concat(spanId.toPaddedHexadecimalString(), "-0").concat(traceSampled ? '1' : '0'),
                });
                break;
            }
            // https://github.com/openzipkin/b3-propagation
            case 'b3': {
                (0, browser_core_1.assign)(tracingHeaders, {
                    b3: "".concat(traceId.toPaddedHexadecimalString(), "-").concat(spanId.toPaddedHexadecimalString(), "-").concat(traceSampled ? '1' : '0'),
                });
                break;
            }
            case 'b3multi': {
                (0, browser_core_1.assign)(tracingHeaders, {
                    'X-B3-TraceId': traceId.toPaddedHexadecimalString(),
                    'X-B3-SpanId': spanId.toPaddedHexadecimalString(),
                    'X-B3-Sampled': traceSampled ? '1' : '0',
                });
                break;
            }
        }
    });
    return tracingHeaders;
}
/* eslint-disable no-bitwise */
var TraceIdentifier = /** @class */ (function () {
    function TraceIdentifier() {
        this.buffer = new Uint8Array(8);
        getCrypto().getRandomValues(this.buffer);
        this.buffer[0] = this.buffer[0] & 0x7f; // force 63-bit
    }
    TraceIdentifier.prototype.toString = function (radix) {
        var high = this.readInt32(0);
        var low = this.readInt32(4);
        var str = '';
        do {
            var mod = (high % radix) * 4294967296 + low;
            high = Math.floor(high / radix);
            low = Math.floor(mod / radix);
            str = (mod % radix).toString(radix) + str;
        } while (high || low);
        return str;
    };
    /**
     * Format used everywhere except the trace intake
     */
    TraceIdentifier.prototype.toDecimalString = function () {
        return this.toString(10);
    };
    /**
     * Format used by OTel headers
     */
    TraceIdentifier.prototype.toPaddedHexadecimalString = function () {
        var traceId = this.toString(16);
        return Array(17 - traceId.length).join('0') + traceId;
    };
    TraceIdentifier.prototype.readInt32 = function (offset) {
        return (this.buffer[offset] * 16777216 +
            (this.buffer[offset + 1] << 16) +
            (this.buffer[offset + 2] << 8) +
            this.buffer[offset + 3]);
    };
    return TraceIdentifier;
}());
exports.TraceIdentifier = TraceIdentifier;
/* eslint-enable no-bitwise */

},{"@datadog/browser-core":432}],503:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackEventCounts = void 0;
var browser_core_1 = require("@datadog/browser-core");
function trackEventCounts(_a) {
    var lifeCycle = _a.lifeCycle, isChildEvent = _a.isChildEvent, _b = _a.onChange, callback = _b === void 0 ? browser_core_1.noop : _b;
    var eventCounts = {
        errorCount: 0,
        longTaskCount: 0,
        resourceCount: 0,
        actionCount: 0,
        frustrationCount: 0,
    };
    var subscription = lifeCycle.subscribe(11 /* RUM_EVENT_COLLECTED */, function (event) {
        if (event.type === 'view' || !isChildEvent(event)) {
            return;
        }
        switch (event.type) {
            case "error" /* ERROR */:
                eventCounts.errorCount += 1;
                callback();
                break;
            case "action" /* ACTION */:
                eventCounts.actionCount += 1;
                if (event.action.frustration) {
                    eventCounts.frustrationCount += event.action.frustration.type.length;
                }
                callback();
                break;
            case "long_task" /* LONG_TASK */:
                eventCounts.longTaskCount += 1;
                callback();
                break;
            case "resource" /* RESOURCE */:
                eventCounts.resourceCount += 1;
                callback();
                break;
        }
    });
    return {
        stop: function () {
            subscription.unsubscribe();
        },
        eventCounts: eventCounts,
    };
}
exports.trackEventCounts = trackEventCounts;

},{"@datadog/browser-core":432}],504:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPageActivityObservable = exports.doWaitPageActivityEnd = exports.waitPageActivityEnd = exports.PAGE_ACTIVITY_END_DELAY = exports.PAGE_ACTIVITY_VALIDATION_DELAY = void 0;
var browser_core_1 = require("@datadog/browser-core");
// Delay to wait for a page activity to validate the tracking process
exports.PAGE_ACTIVITY_VALIDATION_DELAY = 100;
// Delay to wait after a page activity to end the tracking process
exports.PAGE_ACTIVITY_END_DELAY = 100;
/**
 * Wait for the page activity end
 *
 * Detection lifecycle:
 * ```
 *                        Wait page activity end
 *              .-------------------'--------------------.
 *              v                                        v
 *     [Wait for a page activity ]          [Wait for a maximum duration]
 *     [timeout: VALIDATION_DELAY]          [  timeout: maxDuration     ]
 *          /                  \                           |
 *         v                    v                          |
 *  [No page activity]   [Page activity]                   |
 *         |                   |,----------------------.   |
 *         v                   v                       |   |
 *     (Discard)     [Wait for a page activity]        |   |
 *                   [   timeout: END_DELAY   ]        |   |
 *                       /                \            |   |
 *                      v                  v           |   |
 *             [No page activity]    [Page activity]   |   |
 *                      |                 |            |   |
 *                      |                 '------------'   |
 *                      '-----------. ,--------------------'
 *                                   v
 *                                 (End)
 * ```
 *
 * Note: by assuming that maxDuration is greater than VALIDATION_DELAY, we are sure that if the
 * process is still alive after maxDuration, it has been validated.
 */
function waitPageActivityEnd(lifeCycle, domMutationObservable, configuration, pageActivityEndCallback, maxDuration) {
    var pageActivityObservable = createPageActivityObservable(lifeCycle, domMutationObservable, configuration);
    return doWaitPageActivityEnd(pageActivityObservable, pageActivityEndCallback, maxDuration);
}
exports.waitPageActivityEnd = waitPageActivityEnd;
function doWaitPageActivityEnd(pageActivityObservable, pageActivityEndCallback, maxDuration) {
    var pageActivityEndTimeoutId;
    var hasCompleted = false;
    var validationTimeoutId = (0, browser_core_1.setTimeout)((0, browser_core_1.monitor)(function () { return complete({ hadActivity: false }); }), exports.PAGE_ACTIVITY_VALIDATION_DELAY);
    var maxDurationTimeoutId = maxDuration &&
        (0, browser_core_1.setTimeout)((0, browser_core_1.monitor)(function () { return complete({ hadActivity: true, end: (0, browser_core_1.timeStampNow)() }); }), maxDuration);
    var pageActivitySubscription = pageActivityObservable.subscribe(function (_a) {
        var isBusy = _a.isBusy;
        (0, browser_core_1.clearTimeout)(validationTimeoutId);
        (0, browser_core_1.clearTimeout)(pageActivityEndTimeoutId);
        var lastChangeTime = (0, browser_core_1.timeStampNow)();
        if (!isBusy) {
            pageActivityEndTimeoutId = (0, browser_core_1.setTimeout)((0, browser_core_1.monitor)(function () { return complete({ hadActivity: true, end: lastChangeTime }); }), exports.PAGE_ACTIVITY_END_DELAY);
        }
    });
    var stop = function () {
        hasCompleted = true;
        (0, browser_core_1.clearTimeout)(validationTimeoutId);
        (0, browser_core_1.clearTimeout)(pageActivityEndTimeoutId);
        (0, browser_core_1.clearTimeout)(maxDurationTimeoutId);
        pageActivitySubscription.unsubscribe();
    };
    function complete(event) {
        if (hasCompleted) {
            return;
        }
        stop();
        pageActivityEndCallback(event);
    }
    return { stop: stop };
}
exports.doWaitPageActivityEnd = doWaitPageActivityEnd;
function createPageActivityObservable(lifeCycle, domMutationObservable, configuration) {
    var observable = new browser_core_1.Observable(function () {
        var subscriptions = [];
        var firstRequestIndex;
        var pendingRequestsCount = 0;
        subscriptions.push(domMutationObservable.subscribe(notifyPageActivity), lifeCycle.subscribe(0 /* PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
            if (entries.some(function (entry) { return entry.entryType === 'resource' && !isExcludedUrl(configuration, entry.name); })) {
                notifyPageActivity();
            }
        }), lifeCycle.subscribe(5 /* REQUEST_STARTED */, function (startEvent) {
            if (isExcludedUrl(configuration, startEvent.url)) {
                return;
            }
            if (firstRequestIndex === undefined) {
                firstRequestIndex = startEvent.requestIndex;
            }
            pendingRequestsCount += 1;
            notifyPageActivity();
        }), lifeCycle.subscribe(6 /* REQUEST_COMPLETED */, function (request) {
            if (isExcludedUrl(configuration, request.url) ||
                firstRequestIndex === undefined ||
                // If the request started before the tracking start, ignore it
                request.requestIndex < firstRequestIndex) {
                return;
            }
            pendingRequestsCount -= 1;
            notifyPageActivity();
        }));
        var stopTrackingWindowOpen = trackWindowOpen(notifyPageActivity).stop;
        return function () {
            stopTrackingWindowOpen();
            subscriptions.forEach(function (s) { return s.unsubscribe(); });
        };
        function notifyPageActivity() {
            observable.notify({ isBusy: pendingRequestsCount > 0 });
        }
    });
    return observable;
}
exports.createPageActivityObservable = createPageActivityObservable;
function isExcludedUrl(configuration, requestUrl) {
    return (0, browser_core_1.matchList)(configuration.excludedActivityUrls, requestUrl);
}
function trackWindowOpen(callback) {
    return (0, browser_core_1.instrumentMethodAndCallOriginal)(window, 'open', { before: callback });
}

},{"@datadog/browser-core":432}],505:[function(require,module,exports){
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.STABLE_ATTRIBUTES = exports.DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE = exports.getViewportDimension = exports.initViewportObservable = exports.getMutationObserverConstructor = exports.LifeCycle = exports.startRum = exports.makeRumPublicApi = void 0;
var rumPublicApi_1 = require("./boot/rumPublicApi");
Object.defineProperty(exports, "makeRumPublicApi", { enumerable: true, get: function () { return rumPublicApi_1.makeRumPublicApi; } });
var startRum_1 = require("./boot/startRum");
Object.defineProperty(exports, "startRum", { enumerable: true, get: function () { return startRum_1.startRum; } });
var lifeCycle_1 = require("./domain/lifeCycle");
Object.defineProperty(exports, "LifeCycle", { enumerable: true, get: function () { return lifeCycle_1.LifeCycle; } });
var domMutationObservable_1 = require("./browser/domMutationObservable");
Object.defineProperty(exports, "getMutationObserverConstructor", { enumerable: true, get: function () { return domMutationObservable_1.getMutationObserverConstructor; } });
var viewportObservable_1 = require("./browser/viewportObservable");
Object.defineProperty(exports, "initViewportObservable", { enumerable: true, get: function () { return viewportObservable_1.initViewportObservable; } });
Object.defineProperty(exports, "getViewportDimension", { enumerable: true, get: function () { return viewportObservable_1.getViewportDimension; } });
var getActionNameFromElement_1 = require("./domain/rumEventsCollection/action/getActionNameFromElement");
Object.defineProperty(exports, "DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE", { enumerable: true, get: function () { return getActionNameFromElement_1.DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE; } });
var getSelectorFromElement_1 = require("./domain/rumEventsCollection/action/getSelectorFromElement");
Object.defineProperty(exports, "STABLE_ATTRIBUTES", { enumerable: true, get: function () { return getSelectorFromElement_1.STABLE_ATTRIBUTES; } });
__exportStar(require("./browser/htmlDomUtils"), exports);

},{"./boot/rumPublicApi":458,"./boot/startRum":459,"./browser/domMutationObservable":460,"./browser/htmlDomUtils":461,"./browser/viewportObservable":464,"./domain/lifeCycle":477,"./domain/rumEventsCollection/action/getActionNameFromElement":482,"./domain/rumEventsCollection/action/getSelectorFromElement":483}],506:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startRumBatch = void 0;
var browser_core_1 = require("@datadog/browser-core");
function startRumBatch(configuration, lifeCycle, telemetryEventObservable, reportError, pageExitObservable) {
    var batch = makeRumBatch(configuration, reportError, pageExitObservable);
    lifeCycle.subscribe(11 /* RUM_EVENT_COLLECTED */, function (serverRumEvent) {
        if (serverRumEvent.type === "view" /* VIEW */) {
            batch.upsert(serverRumEvent, serverRumEvent.view.id);
        }
        else {
            batch.add(serverRumEvent);
        }
    });
    telemetryEventObservable.subscribe(function (event) { return batch.add(event, (0, browser_core_1.isTelemetryReplicationAllowed)(configuration)); });
    return batch;
}
exports.startRumBatch = startRumBatch;
function makeRumBatch(configuration, reportError, pageExitObservable) {
    var primaryBatch = createRumBatch(configuration.rumEndpointBuilder);
    var replicaBatch;
    var replica = configuration.replica;
    if (replica !== undefined) {
        replicaBatch = createRumBatch(replica.rumEndpointBuilder);
    }
    function createRumBatch(endpointBuilder) {
        return new browser_core_1.Batch((0, browser_core_1.createHttpRequest)(endpointBuilder, configuration.batchBytesLimit, reportError), configuration.batchMessagesLimit, configuration.batchBytesLimit, configuration.messageBytesLimit, configuration.flushTimeout, pageExitObservable);
    }
    function withReplicaApplicationId(message) {
        return (0, browser_core_1.combine)(message, { application: { id: replica.applicationId } });
    }
    return {
        flushObservable: primaryBatch.flushObservable,
        add: function (message, replicated) {
            if (replicated === void 0) { replicated = true; }
            primaryBatch.add(message);
            if (replicaBatch && replicated) {
                replicaBatch.add(withReplicaApplicationId(message));
            }
        },
        upsert: function (message, key) {
            primaryBatch.upsert(message, key);
            if (replicaBatch) {
                replicaBatch.upsert(withReplicaApplicationId(message), key);
            }
        },
    };
}

},{"@datadog/browser-core":432}],507:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startRumEventBridge = void 0;
var browser_core_1 = require("@datadog/browser-core");
function startRumEventBridge(lifeCycle) {
    var bridge = (0, browser_core_1.getEventBridge)();
    lifeCycle.subscribe(11 /* RUM_EVENT_COLLECTED */, function (serverRumEvent) {
        bridge.send('rum', serverRumEvent);
    });
}
exports.startRumEventBridge = startRumEventBridge;

},{"@datadog/browser-core":432}],508:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeRecorderApi = void 0;
var browser_core_1 = require("@datadog/browser-core");
var replayStats_1 = require("../domain/replayStats");
var segmentCollection_1 = require("../domain/segmentCollection");
function makeRecorderApi(startRecordingImpl, startDeflateWorkerImpl) {
    if (startDeflateWorkerImpl === void 0) { startDeflateWorkerImpl = segmentCollection_1.startDeflateWorker; }
    if ((0, browser_core_1.canUseEventBridge)() || !isBrowserSupported()) {
        return {
            start: browser_core_1.noop,
            stop: browser_core_1.noop,
            getReplayStats: function () { return undefined; },
            onRumStart: browser_core_1.noop,
            isRecording: function () { return false; },
        };
    }
    var state = {
        status: 0 /* Stopped */,
    };
    var startStrategy = function () {
        state = { status: 1 /* IntentToStart */ };
    };
    var stopStrategy = function () {
        state = { status: 0 /* Stopped */ };
    };
    return {
        start: function () { return startStrategy(); },
        stop: function () { return stopStrategy(); },
        getReplayStats: replayStats_1.getReplayStats,
        onRumStart: function (lifeCycle, configuration, sessionManager, viewContexts) {
            lifeCycle.subscribe(7 /* SESSION_EXPIRED */, function () {
                if (state.status === 2 /* Starting */ || state.status === 3 /* Started */) {
                    stopStrategy();
                    state = { status: 1 /* IntentToStart */ };
                }
            });
            lifeCycle.subscribe(8 /* SESSION_RENEWED */, function () {
                if (state.status === 1 /* IntentToStart */) {
                    startStrategy();
                }
            });
            startStrategy = function () {
                var session = sessionManager.findTrackedSession();
                if (!session || !session.sessionReplayAllowed) {
                    state = { status: 1 /* IntentToStart */ };
                    return;
                }
                if (state.status === 2 /* Starting */ || state.status === 3 /* Started */) {
                    return;
                }
                state = { status: 2 /* Starting */ };
                (0, browser_core_1.runOnReadyState)('interactive', function () {
                    if (state.status !== 2 /* Starting */) {
                        return;
                    }
                    startDeflateWorkerImpl(function (worker) {
                        if (state.status !== 2 /* Starting */) {
                            return;
                        }
                        if (!worker) {
                            state = {
                                status: 0 /* Stopped */,
                            };
                            return;
                        }
                        var stopRecording = startRecordingImpl(lifeCycle, configuration, sessionManager, viewContexts, worker).stop;
                        state = {
                            status: 3 /* Started */,
                            stopRecording: stopRecording,
                        };
                    });
                });
            };
            stopStrategy = function () {
                if (state.status === 0 /* Stopped */) {
                    return;
                }
                if (state.status === 3 /* Started */) {
                    state.stopRecording();
                }
                state = {
                    status: 0 /* Stopped */,
                };
            };
            if (state.status === 1 /* IntentToStart */) {
                startStrategy();
            }
        },
        isRecording: function () { return state.status === 3 /* Started */; },
    };
}
exports.makeRecorderApi = makeRecorderApi;
/**
 * Test for Browser features used while recording
 */
function isBrowserSupported() {
    return (
    // Array.from is a bit less supported by browsers than CSSSupportsRule, but has higher chances
    // to be polyfilled. Test for both to be more confident. We could add more things if we find out
    // this test is not sufficient.
    typeof Array.from === 'function' && typeof CSSSupportsRule === 'function' && 'forEach' in NodeList.prototype);
}

},{"../domain/replayStats":539,"../domain/segmentCollection":542,"@datadog/browser-core":432}],509:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startRecording = void 0;
var browser_core_1 = require("@datadog/browser-core");
var record_1 = require("../domain/record");
var segmentCollection_1 = require("../domain/segmentCollection");
var types_1 = require("../types");
function startRecording(lifeCycle, configuration, sessionManager, viewContexts, worker, httpRequest) {
    var reportError = function (error) {
        lifeCycle.notify(12 /* RAW_ERROR_COLLECTED */, { error: error });
    };
    var replayRequest = httpRequest || (0, browser_core_1.createHttpRequest)(configuration.sessionReplayEndpointBuilder, segmentCollection_1.SEGMENT_BYTES_LIMIT, reportError);
    var _a = (0, segmentCollection_1.startSegmentCollection)(lifeCycle, configuration.applicationId, sessionManager, viewContexts, replayRequest, worker), addRecord = _a.addRecord, stopSegmentCollection = _a.stop;
    var _b = (0, record_1.record)({
        emit: addRecord,
        configuration: configuration,
        lifeCycle: lifeCycle,
    }), stopRecording = _b.stop, takeSubsequentFullSnapshot = _b.takeSubsequentFullSnapshot, flushMutations = _b.flushMutations;
    var unsubscribeViewEnded = lifeCycle.subscribe(4 /* VIEW_ENDED */, function () {
        flushMutations();
        addRecord({
            timestamp: (0, browser_core_1.timeStampNow)(),
            type: types_1.RecordType.ViewEnd,
        });
    }).unsubscribe;
    var unsubscribeViewCreated = lifeCycle.subscribe(2 /* VIEW_CREATED */, function (view) {
        takeSubsequentFullSnapshot(view.startClocks.timeStamp);
    }).unsubscribe;
    return {
        stop: function () {
            unsubscribeViewEnded();
            unsubscribeViewCreated();
            stopRecording();
            stopSegmentCollection();
        },
    };
}
exports.startRecording = startRecording;

},{"../domain/record":512,"../domain/segmentCollection":542,"../types":547,"@datadog/browser-core":432}],510:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FORM_PRIVATE_TAG_NAMES = exports.CENSORED_IMG_MARK = exports.CENSORED_STRING_MARK = exports.PRIVACY_CLASS_HIDDEN = exports.PRIVACY_CLASS_MASK_USER_INPUT = exports.PRIVACY_CLASS_MASK = exports.PRIVACY_CLASS_ALLOW = exports.PRIVACY_ATTR_VALUE_HIDDEN = exports.PRIVACY_ATTR_VALUE_MASK_USER_INPUT = exports.PRIVACY_ATTR_VALUE_MASK = exports.PRIVACY_ATTR_VALUE_ALLOW = exports.PRIVACY_ATTR_NAME = exports.NodePrivacyLevel = void 0;
var browser_core_1 = require("@datadog/browser-core");
exports.NodePrivacyLevel = {
    IGNORE: 'ignore',
    HIDDEN: 'hidden',
    ALLOW: browser_core_1.DefaultPrivacyLevel.ALLOW,
    MASK: browser_core_1.DefaultPrivacyLevel.MASK,
    MASK_USER_INPUT: browser_core_1.DefaultPrivacyLevel.MASK_USER_INPUT,
};
exports.PRIVACY_ATTR_NAME = 'data-dd-privacy';
// Privacy Attrs
exports.PRIVACY_ATTR_VALUE_ALLOW = 'allow';
exports.PRIVACY_ATTR_VALUE_MASK = 'mask';
exports.PRIVACY_ATTR_VALUE_MASK_USER_INPUT = 'mask-user-input';
exports.PRIVACY_ATTR_VALUE_HIDDEN = 'hidden';
// Privacy Classes - not all customers can set plain HTML attributes, so support classes too
exports.PRIVACY_CLASS_ALLOW = 'dd-privacy-allow';
exports.PRIVACY_CLASS_MASK = 'dd-privacy-mask';
exports.PRIVACY_CLASS_MASK_USER_INPUT = 'dd-privacy-mask-user-input';
exports.PRIVACY_CLASS_HIDDEN = 'dd-privacy-hidden';
// Private Replacement Templates
exports.CENSORED_STRING_MARK = '***';
exports.CENSORED_IMG_MARK = 'data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==';
exports.FORM_PRIVATE_TAG_NAMES = {
    INPUT: true,
    OUTPUT: true,
    TEXTAREA: true,
    SELECT: true,
    OPTION: true,
    DATALIST: true,
    OPTGROUP: true,
};

},{"@datadog/browser-core":432}],511:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createElementsScrollPositions = void 0;
function createElementsScrollPositions() {
    var scrollPositionsByElement = new WeakMap();
    return {
        set: function (element, scrollPositions) {
            if (element === document && !document.scrollingElement) {
                // cf https://drafts.csswg.org/cssom-view/#dom-document-scrollingelement,
                // in some cases scrolling elements can not be defined, we don't support those for now
                return;
            }
            scrollPositionsByElement.set(element === document ? document.scrollingElement : element, scrollPositions);
        },
        get: function (element) {
            return scrollPositionsByElement.get(element);
        },
        has: function (element) {
            return scrollPositionsByElement.has(element);
        },
    };
}
exports.createElementsScrollPositions = createElementsScrollPositions;

},{}],512:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createElementsScrollPositions = exports.serializeDocument = exports.serializeNodeWithId = exports.record = void 0;
var record_1 = require("./record");
Object.defineProperty(exports, "record", { enumerable: true, get: function () { return record_1.record; } });
var serialization_1 = require("./serialization");
Object.defineProperty(exports, "serializeNodeWithId", { enumerable: true, get: function () { return serialization_1.serializeNodeWithId; } });
Object.defineProperty(exports, "serializeDocument", { enumerable: true, get: function () { return serialization_1.serializeDocument; } });
var elementsScrollPositions_1 = require("./elementsScrollPositions");
Object.defineProperty(exports, "createElementsScrollPositions", { enumerable: true, get: function () { return elementsScrollPositions_1.createElementsScrollPositions; } });

},{"./elementsScrollPositions":511,"./record":528,"./serialization":529}],513:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMutationBatch = void 0;
var browser_core_1 = require("@datadog/browser-core");
/**
 * Maximum duration to wait before processing mutations. If the browser is idle, mutations will be
 * processed more quickly. If the browser is busy executing small tasks (ex: rendering frames), the
 * mutations will wait MUTATION_PROCESS_MAX_DELAY milliseconds before being processed. If the
 * browser is busy executing a longer task, mutations will be processed after this task.
 */
var MUTATION_PROCESS_MAX_DELAY = 100;
function createMutationBatch(processMutationBatch) {
    var cancelScheduledFlush = browser_core_1.noop;
    var pendingMutations = [];
    function flush() {
        cancelScheduledFlush();
        processMutationBatch(pendingMutations);
        pendingMutations = [];
    }
    return {
        addMutations: function (mutations) {
            if (pendingMutations.length === 0) {
                cancelScheduledFlush = (0, browser_core_1.requestIdleCallback)(flush, { timeout: MUTATION_PROCESS_MAX_DELAY });
            }
            pendingMutations.push.apply(pendingMutations, mutations);
        },
        flush: flush,
        stop: function () {
            cancelScheduledFlush();
        },
    };
}
exports.createMutationBatch = createMutationBatch;

},{"@datadog/browser-core":432}],514:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initFocusObserver = void 0;
var browser_core_1 = require("@datadog/browser-core");
function initFocusObserver(focusCb) {
    return (0, browser_core_1.addEventListeners)(window, ["focus" /* FOCUS */, "blur" /* BLUR */], function () {
        focusCb({ has_focus: document.hasFocus() });
    }).stop;
}
exports.initFocusObserver = initFocusObserver;

},{"@datadog/browser-core":432}],515:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initFrustrationObserver = void 0;
var types_1 = require("../../../types");
var utils_1 = require("./utils");
function initFrustrationObserver(lifeCycle, frustrationCb) {
    return lifeCycle.subscribe(10 /* RAW_RUM_EVENT_COLLECTED */, function (data) {
        var _a, _b, _c;
        if (data.rawRumEvent.type === "action" /* ACTION */ &&
            data.rawRumEvent.action.type === "click" /* CLICK */ &&
            ((_b = (_a = data.rawRumEvent.action.frustration) === null || _a === void 0 ? void 0 : _a.type) === null || _b === void 0 ? void 0 : _b.length) &&
            'events' in data.domainContext &&
            ((_c = data.domainContext.events) === null || _c === void 0 ? void 0 : _c.length)) {
            frustrationCb({
                timestamp: data.rawRumEvent.date,
                type: types_1.RecordType.FrustrationRecord,
                data: {
                    frustrationTypes: data.rawRumEvent.action.frustration.type,
                    recordIds: data.domainContext.events.map(function (e) { return (0, utils_1.getRecordIdForEvent)(e); }),
                },
            });
        }
    }).unsubscribe;
}
exports.initFrustrationObserver = initFrustrationObserver;

},{"../../../types":547,"./utils":525}],516:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initMutationObserver = exports.initInputObserver = exports.initObservers = void 0;
var observers_1 = require("./observers");
Object.defineProperty(exports, "initObservers", { enumerable: true, get: function () { return observers_1.initObservers; } });
var inputObserver_1 = require("./inputObserver");
Object.defineProperty(exports, "initInputObserver", { enumerable: true, get: function () { return inputObserver_1.initInputObserver; } });
var mutationObserver_1 = require("./mutationObserver");
Object.defineProperty(exports, "initMutationObserver", { enumerable: true, get: function () { return mutationObserver_1.initMutationObserver; } });

},{"./inputObserver":517,"./mutationObserver":521,"./observers":522}],517:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initInputObserver = void 0;
var browser_core_1 = require("@datadog/browser-core");
var constants_1 = require("../../../constants");
var privacy_1 = require("../privacy");
var serialization_1 = require("../serialization");
var utils_1 = require("./utils");
function initInputObserver(cb, defaultPrivacyLevel, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.domEvents, domEvents = _c === void 0 ? ["input" /* INPUT */, "change" /* CHANGE */] : _c, _d = _b.target, target = _d === void 0 ? document : _d;
    var lastInputStateMap = new WeakMap();
    function onElementChange(target) {
        var nodePrivacyLevel = (0, privacy_1.getNodePrivacyLevel)(target, defaultPrivacyLevel);
        if (nodePrivacyLevel === constants_1.NodePrivacyLevel.HIDDEN) {
            return;
        }
        var type = target.type;
        var inputState;
        if (type === 'radio' || type === 'checkbox') {
            if ((0, privacy_1.shouldMaskNode)(target, nodePrivacyLevel)) {
                return;
            }
            inputState = { isChecked: target.checked };
        }
        else {
            var value = (0, serialization_1.getElementInputValue)(target, nodePrivacyLevel);
            if (value === undefined) {
                return;
            }
            inputState = { text: value };
        }
        // Can be multiple changes on the same node within the same batched mutation observation.
        cbWithDedup(target, inputState);
        // If a radio was checked, other radios with the same name attribute will be unchecked.
        var name = target.name;
        if (type === 'radio' && name && target.checked) {
            (0, utils_1.forEach)(document.querySelectorAll("input[type=\"radio\"][name=\"".concat(name, "\"]")), function (el) {
                if (el !== target) {
                    // TODO: Consider the privacy implications for various differing input privacy levels
                    cbWithDedup(el, { isChecked: false });
                }
            });
        }
    }
    /**
     * There can be multiple changes on the same node within the same batched mutation observation.
     */
    function cbWithDedup(target, inputState) {
        if (!(0, serialization_1.hasSerializedNode)(target)) {
            return;
        }
        var lastInputState = lastInputStateMap.get(target);
        if (!lastInputState ||
            lastInputState.text !== inputState.text ||
            lastInputState.isChecked !== inputState.isChecked) {
            lastInputStateMap.set(target, inputState);
            cb((0, browser_core_1.assign)({
                id: (0, serialization_1.getSerializedNodeId)(target),
            }, inputState));
        }
    }
    var stopEventListeners = (0, browser_core_1.addEventListeners)(target, domEvents, function (event) {
        var target = (0, utils_1.getEventTarget)(event);
        if (target instanceof HTMLInputElement ||
            target instanceof HTMLTextAreaElement ||
            target instanceof HTMLSelectElement) {
            onElementChange(target);
        }
    }, {
        capture: true,
        passive: true,
    }).stop;
    var instrumentationStoppers = [
        (0, browser_core_1.instrumentSetter)(HTMLInputElement.prototype, 'value', onElementChange),
        (0, browser_core_1.instrumentSetter)(HTMLInputElement.prototype, 'checked', onElementChange),
        (0, browser_core_1.instrumentSetter)(HTMLSelectElement.prototype, 'value', onElementChange),
        (0, browser_core_1.instrumentSetter)(HTMLTextAreaElement.prototype, 'value', onElementChange),
        (0, browser_core_1.instrumentSetter)(HTMLSelectElement.prototype, 'selectedIndex', onElementChange),
    ];
    return function () {
        instrumentationStoppers.forEach(function (stopper) { return stopper.stop(); });
        stopEventListeners();
    };
}
exports.initInputObserver = initInputObserver;

},{"../../../constants":510,"../privacy":527,"../serialization":529,"./utils":525,"@datadog/browser-core":432}],518:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initMediaInteractionObserver = void 0;
var browser_core_1 = require("@datadog/browser-core");
var constants_1 = require("../../../constants");
var types_1 = require("../../../types");
var privacy_1 = require("../privacy");
var serialization_1 = require("../serialization");
var utils_1 = require("./utils");
function initMediaInteractionObserver(mediaInteractionCb, defaultPrivacyLevel) {
    var handler = function (event) {
        var target = (0, utils_1.getEventTarget)(event);
        if (!target ||
            (0, privacy_1.getNodePrivacyLevel)(target, defaultPrivacyLevel) === constants_1.NodePrivacyLevel.HIDDEN ||
            !(0, serialization_1.hasSerializedNode)(target)) {
            return;
        }
        mediaInteractionCb({
            id: (0, serialization_1.getSerializedNodeId)(target),
            type: event.type === "play" /* PLAY */ ? types_1.MediaInteractionType.Play : types_1.MediaInteractionType.Pause,
        });
    };
    return (0, browser_core_1.addEventListeners)(document, ["play" /* PLAY */, "pause" /* PAUSE */], handler, { capture: true, passive: true }).stop;
}
exports.initMediaInteractionObserver = initMediaInteractionObserver;

},{"../../../constants":510,"../../../types":547,"../privacy":527,"../serialization":529,"./utils":525,"@datadog/browser-core":432}],519:[function(require,module,exports){
"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.initMouseInteractionObserver = void 0;
var browser_core_1 = require("@datadog/browser-core");
var constants_1 = require("../../../constants");
var types_1 = require("../../../types");
var privacy_1 = require("../privacy");
var serialization_1 = require("../serialization");
var utils_1 = require("../utils");
var moveObserver_1 = require("./moveObserver");
var utils_2 = require("./utils");
var eventTypeToMouseInteraction = (_a = {},
    // Listen for pointerup DOM events instead of mouseup for MouseInteraction/MouseUp records. This
    // allows to reference such records from Frustration records.
    //
    // In the context of supporting Mobile Session Replay, we introduced `PointerInteraction` records
    // used by the Mobile SDKs in place of `MouseInteraction`. In the future, we should replace
    // `MouseInteraction` by `PointerInteraction` in the Browser SDK so we have an uniform way to
    // convey such interaction. This would cleanly solve the issue since we would have
    // `PointerInteraction/Up` records that we could reference from `Frustration` records.
    _a["pointerup" /* POINTER_UP */] = types_1.MouseInteractionType.MouseUp,
    _a["mousedown" /* MOUSE_DOWN */] = types_1.MouseInteractionType.MouseDown,
    _a["click" /* CLICK */] = types_1.MouseInteractionType.Click,
    _a["contextmenu" /* CONTEXT_MENU */] = types_1.MouseInteractionType.ContextMenu,
    _a["dblclick" /* DBL_CLICK */] = types_1.MouseInteractionType.DblClick,
    _a["focus" /* FOCUS */] = types_1.MouseInteractionType.Focus,
    _a["blur" /* BLUR */] = types_1.MouseInteractionType.Blur,
    _a["touchstart" /* TOUCH_START */] = types_1.MouseInteractionType.TouchStart,
    _a["touchend" /* TOUCH_END */] = types_1.MouseInteractionType.TouchEnd,
    _a);
function initMouseInteractionObserver(cb, defaultPrivacyLevel) {
    var handler = function (event) {
        var target = (0, utils_2.getEventTarget)(event);
        if ((0, privacy_1.getNodePrivacyLevel)(target, defaultPrivacyLevel) === constants_1.NodePrivacyLevel.HIDDEN || !(0, serialization_1.hasSerializedNode)(target)) {
            return;
        }
        var id = (0, serialization_1.getSerializedNodeId)(target);
        var type = eventTypeToMouseInteraction[event.type];
        var interaction;
        if (type !== types_1.MouseInteractionType.Blur && type !== types_1.MouseInteractionType.Focus) {
            var coordinates = (0, moveObserver_1.tryToComputeCoordinates)(event);
            if (!coordinates) {
                return;
            }
            interaction = { id: id, type: type, x: coordinates.x, y: coordinates.y };
        }
        else {
            interaction = { id: id, type: type };
        }
        var record = (0, browser_core_1.assign)({ id: (0, utils_2.getRecordIdForEvent)(event) }, (0, utils_1.assembleIncrementalSnapshot)(types_1.IncrementalSource.MouseInteraction, interaction));
        cb(record);
    };
    return (0, browser_core_1.addEventListeners)(document, Object.keys(eventTypeToMouseInteraction), handler, {
        capture: true,
        passive: true,
    }).stop;
}
exports.initMouseInteractionObserver = initMouseInteractionObserver;

},{"../../../constants":510,"../../../types":547,"../privacy":527,"../serialization":529,"../utils":537,"./moveObserver":520,"./utils":525,"@datadog/browser-core":432}],520:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tryToComputeCoordinates = exports.initMoveObserver = void 0;
var browser_core_1 = require("@datadog/browser-core");
var serialization_1 = require("../serialization");
var utils_1 = require("../utils");
var types_1 = require("../../../types");
var viewports_1 = require("../viewports");
var utils_2 = require("./utils");
var MOUSE_MOVE_OBSERVER_THRESHOLD = 50;
function initMoveObserver(cb) {
    var updatePosition = (0, browser_core_1.throttle)(function (event) {
        var target = (0, utils_2.getEventTarget)(event);
        if ((0, serialization_1.hasSerializedNode)(target)) {
            var coordinates = tryToComputeCoordinates(event);
            if (!coordinates) {
                return;
            }
            var position = {
                id: (0, serialization_1.getSerializedNodeId)(target),
                timeOffset: 0,
                x: coordinates.x,
                y: coordinates.y,
            };
            cb([position], (0, utils_1.isTouchEvent)(event) ? types_1.IncrementalSource.TouchMove : types_1.IncrementalSource.MouseMove);
        }
    }, MOUSE_MOVE_OBSERVER_THRESHOLD, {
        trailing: false,
    }).throttled;
    return (0, browser_core_1.addEventListeners)(document, ["mousemove" /* MOUSE_MOVE */, "touchmove" /* TOUCH_MOVE */], updatePosition, {
        capture: true,
        passive: true,
    }).stop;
}
exports.initMoveObserver = initMoveObserver;
function tryToComputeCoordinates(event) {
    var _a = (0, utils_1.isTouchEvent)(event) ? event.changedTouches[0] : event, x = _a.clientX, y = _a.clientY;
    if (window.visualViewport) {
        var _b = (0, viewports_1.convertMouseEventToLayoutCoordinates)(x, y), visualViewportX = _b.visualViewportX, visualViewportY = _b.visualViewportY;
        x = visualViewportX;
        y = visualViewportY;
    }
    if (!Number.isFinite(x) || !Number.isFinite(y)) {
        if (event.isTrusted) {
            (0, browser_core_1.addTelemetryDebug)('mouse/touch event without x/y');
        }
        return undefined;
    }
    return { x: x, y: y };
}
exports.tryToComputeCoordinates = tryToComputeCoordinates;

},{"../../../types":547,"../serialization":529,"../utils":537,"../viewports":538,"./utils":525,"@datadog/browser-core":432}],521:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortAddedAndMovedNodes = exports.initMutationObserver = void 0;
var browser_core_1 = require("@datadog/browser-core");
var browser_rum_core_1 = require("@datadog/browser-rum-core");
var constants_1 = require("../../../constants");
var privacy_1 = require("../privacy");
var serialization_1 = require("../serialization");
var mutationBatch_1 = require("../mutationBatch");
/**
 * Buffers and aggregate mutations generated by a MutationObserver into MutationPayload
 */
function initMutationObserver(mutationCallback, configuration, shadowRootsController, target) {
    var MutationObserver = (0, browser_rum_core_1.getMutationObserverConstructor)();
    if (!MutationObserver) {
        return { stop: browser_core_1.noop, flush: browser_core_1.noop };
    }
    var mutationBatch = (0, mutationBatch_1.createMutationBatch)(function (mutations) {
        processMutations(mutations.concat(observer.takeRecords()), mutationCallback, configuration, shadowRootsController, target);
    });
    var observer = new MutationObserver((0, browser_core_1.monitor)(mutationBatch.addMutations));
    observer.observe(target, {
        attributeOldValue: true,
        attributes: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true,
    });
    return {
        stop: function () {
            observer.disconnect();
            mutationBatch.stop();
        },
        flush: function () {
            mutationBatch.flush();
        },
    };
}
exports.initMutationObserver = initMutationObserver;
function processMutations(mutations, mutationCallback, configuration, shadowRootsController, target) {
    mutations
        .filter(function (mutation) { return mutation.type === 'childList'; })
        .forEach(function (mutation) {
        mutation.removedNodes.forEach(function (removedNode) {
            traverseRemovedShadowDom(removedNode, shadowRootsController.removeShadowRoot);
        });
    });
    // Discard any mutation with a 'target' node that:
    // * isn't injected in the current document or isn't known/serialized yet: those nodes are likely
    // part of a mutation occurring in a parent Node
    // * should be hidden or ignored
    var filteredMutations = mutations.filter(function (mutation) {
        return target.contains(mutation.target) &&
            (0, serialization_1.nodeAndAncestorsHaveSerializedNode)(mutation.target) &&
            (0, privacy_1.getNodePrivacyLevel)(mutation.target, configuration.defaultPrivacyLevel) !== constants_1.NodePrivacyLevel.HIDDEN;
    });
    var _a = processChildListMutations(filteredMutations.filter(function (mutation) { return mutation.type === 'childList'; }), configuration, shadowRootsController), adds = _a.adds, removes = _a.removes, hasBeenSerialized = _a.hasBeenSerialized;
    var texts = processCharacterDataMutations(filteredMutations.filter(function (mutation) {
        return mutation.type === 'characterData' && !hasBeenSerialized(mutation.target);
    }), configuration);
    var attributes = processAttributesMutations(filteredMutations.filter(function (mutation) {
        return mutation.type === 'attributes' && !hasBeenSerialized(mutation.target);
    }), configuration);
    if (!texts.length && !attributes.length && !removes.length && !adds.length) {
        return;
    }
    mutationCallback({
        adds: adds,
        removes: removes,
        texts: texts,
        attributes: attributes,
    });
}
function processChildListMutations(mutations, configuration, shadowRootsController) {
    // First, we iterate over mutations to collect:
    //
    // * nodes that have been added in the document and not removed by a subsequent mutation
    // * nodes that have been removed from the document but were not added in a previous mutation
    //
    // For this second category, we also collect their previous parent (mutation.target) because we'll
    // need it to emit a 'remove' mutation.
    //
    // Those two categories may overlap: if a node moved from a position to another, it is reported as
    // two mutation records, one with a "removedNodes" and the other with "addedNodes". In this case,
    // the node will be in both sets.
    var addedAndMovedNodes = new Set();
    var removedNodes = new Map();
    var _loop_1 = function (mutation) {
        mutation.addedNodes.forEach(function (node) {
            addedAndMovedNodes.add(node);
        });
        mutation.removedNodes.forEach(function (node) {
            if (!addedAndMovedNodes.has(node)) {
                removedNodes.set(node, mutation.target);
            }
            addedAndMovedNodes.delete(node);
        });
    };
    for (var _i = 0, mutations_1 = mutations; _i < mutations_1.length; _i++) {
        var mutation = mutations_1[_i];
        _loop_1(mutation);
    }
    // Then, we sort nodes that are still in the document by topological order, for two reasons:
    //
    // * We will serialize each added nodes with their descendants. We don't want to serialize a node
    // twice, so we need to iterate over the parent nodes first and skip any node that is contained in
    // a precedent node.
    //
    // * To emit "add" mutations, we need references to the parent and potential next sibling of each
    // added node. So we need to iterate over the parent nodes first, and when multiple nodes are
    // siblings, we want to iterate from last to first. This will ensure that any "next" node is
    // already serialized and have an id.
    var sortedAddedAndMovedNodes = Array.from(addedAndMovedNodes);
    sortAddedAndMovedNodes(sortedAddedAndMovedNodes);
    // Then, we iterate over our sorted node sets to emit mutations. We collect the newly serialized
    // node ids in a set to be able to skip subsequent related mutations.
    var serializedNodeIds = new Set();
    var addedNodeMutations = [];
    for (var _a = 0, sortedAddedAndMovedNodes_1 = sortedAddedAndMovedNodes; _a < sortedAddedAndMovedNodes_1.length; _a++) {
        var node = sortedAddedAndMovedNodes_1[_a];
        if (hasBeenSerialized(node)) {
            continue;
        }
        var parentNodePrivacyLevel = (0, privacy_1.getNodePrivacyLevel)(node.parentNode, configuration.defaultPrivacyLevel);
        if (parentNodePrivacyLevel === constants_1.NodePrivacyLevel.HIDDEN || parentNodePrivacyLevel === constants_1.NodePrivacyLevel.IGNORE) {
            continue;
        }
        var serializedNode = (0, serialization_1.serializeNodeWithId)(node, {
            serializedNodeIds: serializedNodeIds,
            parentNodePrivacyLevel: parentNodePrivacyLevel,
            serializationContext: { status: 2 /* MUTATION */, shadowRootsController: shadowRootsController },
            configuration: configuration,
        });
        if (!serializedNode) {
            continue;
        }
        var parentNode = (0, browser_rum_core_1.getParentNode)(node);
        addedNodeMutations.push({
            nextId: getNextSibling(node),
            parentId: (0, serialization_1.getSerializedNodeId)(parentNode),
            node: serializedNode,
        });
    }
    // Finally, we emit remove mutations.
    var removedNodeMutations = [];
    removedNodes.forEach(function (parent, node) {
        if ((0, serialization_1.hasSerializedNode)(node)) {
            removedNodeMutations.push({
                parentId: (0, serialization_1.getSerializedNodeId)(parent),
                id: (0, serialization_1.getSerializedNodeId)(node),
            });
        }
    });
    return { adds: addedNodeMutations, removes: removedNodeMutations, hasBeenSerialized: hasBeenSerialized };
    function hasBeenSerialized(node) {
        return (0, serialization_1.hasSerializedNode)(node) && serializedNodeIds.has((0, serialization_1.getSerializedNodeId)(node));
    }
    function getNextSibling(node) {
        var nextSibling = node.nextSibling;
        while (nextSibling) {
            if ((0, serialization_1.hasSerializedNode)(nextSibling)) {
                return (0, serialization_1.getSerializedNodeId)(nextSibling);
            }
            nextSibling = nextSibling.nextSibling;
        }
        return null;
    }
}
function processCharacterDataMutations(mutations, configuration) {
    var _a;
    var textMutations = [];
    // Deduplicate mutations based on their target node
    var handledNodes = new Set();
    var filteredMutations = mutations.filter(function (mutation) {
        if (handledNodes.has(mutation.target)) {
            return false;
        }
        handledNodes.add(mutation.target);
        return true;
    });
    // Emit mutations
    for (var _i = 0, filteredMutations_1 = filteredMutations; _i < filteredMutations_1.length; _i++) {
        var mutation = filteredMutations_1[_i];
        var value = mutation.target.textContent;
        if (value === mutation.oldValue) {
            continue;
        }
        var parentNodePrivacyLevel = (0, privacy_1.getNodePrivacyLevel)((0, browser_rum_core_1.getParentNode)(mutation.target), configuration.defaultPrivacyLevel);
        if (parentNodePrivacyLevel === constants_1.NodePrivacyLevel.HIDDEN || parentNodePrivacyLevel === constants_1.NodePrivacyLevel.IGNORE) {
            continue;
        }
        textMutations.push({
            id: (0, serialization_1.getSerializedNodeId)(mutation.target),
            // TODO: pass a valid "ignoreWhiteSpace" argument
            value: (_a = (0, privacy_1.getTextContent)(mutation.target, false, parentNodePrivacyLevel)) !== null && _a !== void 0 ? _a : null,
        });
    }
    return textMutations;
}
function processAttributesMutations(mutations, configuration) {
    var attributeMutations = [];
    // Deduplicate mutations based on their target node and changed attribute
    var handledElements = new Map();
    var filteredMutations = mutations.filter(function (mutation) {
        var handledAttributes = handledElements.get(mutation.target);
        if (handledAttributes === null || handledAttributes === void 0 ? void 0 : handledAttributes.has(mutation.attributeName)) {
            return false;
        }
        if (!handledAttributes) {
            handledElements.set(mutation.target, new Set([mutation.attributeName]));
        }
        else {
            handledAttributes.add(mutation.attributeName);
        }
        return true;
    });
    // Emit mutations
    var emittedMutations = new Map();
    for (var _i = 0, filteredMutations_2 = filteredMutations; _i < filteredMutations_2.length; _i++) {
        var mutation = filteredMutations_2[_i];
        var uncensoredValue = mutation.target.getAttribute(mutation.attributeName);
        if (uncensoredValue === mutation.oldValue) {
            continue;
        }
        var privacyLevel = (0, privacy_1.getNodePrivacyLevel)(mutation.target, configuration.defaultPrivacyLevel);
        var attributeValue = (0, serialization_1.serializeAttribute)(mutation.target, privacyLevel, mutation.attributeName, configuration);
        var transformedValue = void 0;
        if (mutation.attributeName === 'value') {
            var inputValue = (0, serialization_1.getElementInputValue)(mutation.target, privacyLevel);
            if (inputValue === undefined) {
                continue;
            }
            transformedValue = inputValue;
        }
        else if (typeof attributeValue === 'string') {
            transformedValue = attributeValue;
        }
        else {
            transformedValue = null;
        }
        var emittedMutation = emittedMutations.get(mutation.target);
        if (!emittedMutation) {
            emittedMutation = {
                id: (0, serialization_1.getSerializedNodeId)(mutation.target),
                attributes: {},
            };
            attributeMutations.push(emittedMutation);
            emittedMutations.set(mutation.target, emittedMutation);
        }
        emittedMutation.attributes[mutation.attributeName] = transformedValue;
    }
    return attributeMutations;
}
function sortAddedAndMovedNodes(nodes) {
    nodes.sort(function (a, b) {
        var position = a.compareDocumentPosition(b);
        /* eslint-disable no-bitwise */
        if (position & Node.DOCUMENT_POSITION_CONTAINED_BY) {
            return -1;
        }
        else if (position & Node.DOCUMENT_POSITION_CONTAINS) {
            return 1;
        }
        else if (position & Node.DOCUMENT_POSITION_FOLLOWING) {
            return 1;
        }
        else if (position & Node.DOCUMENT_POSITION_PRECEDING) {
            return -1;
        }
        /* eslint-enable no-bitwise */
        return 0;
    });
}
exports.sortAddedAndMovedNodes = sortAddedAndMovedNodes;
function traverseRemovedShadowDom(removedNode, shadowDomRemovedCallback) {
    if ((0, browser_rum_core_1.isNodeShadowHost)(removedNode)) {
        shadowDomRemovedCallback(removedNode.shadowRoot);
    }
    (0, browser_rum_core_1.getChildNodes)(removedNode).forEach(function (child) { return traverseRemovedShadowDom(child, shadowDomRemovedCallback); });
}

},{"../../../constants":510,"../mutationBatch":513,"../privacy":527,"../serialization":529,"@datadog/browser-core":432,"@datadog/browser-rum-core":505}],522:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initObservers = void 0;
var moveObserver_1 = require("./moveObserver");
var scrollObserver_1 = require("./scrollObserver");
var mouseInteractionObserver_1 = require("./mouseInteractionObserver");
var inputObserver_1 = require("./inputObserver");
var styleSheetObserver_1 = require("./styleSheetObserver");
var mediaInteractionObserver_1 = require("./mediaInteractionObserver");
var frustrationObserver_1 = require("./frustrationObserver");
var viewportResizeObserver_1 = require("./viewportResizeObserver");
var mutationObserver_1 = require("./mutationObserver");
var focusObserver_1 = require("./focusObserver");
function initObservers(o) {
    var mutationHandler = (0, mutationObserver_1.initMutationObserver)(o.mutationCb, o.configuration, o.shadowRootsController, document);
    var mousemoveHandler = (0, moveObserver_1.initMoveObserver)(o.mousemoveCb);
    var mouseInteractionHandler = (0, mouseInteractionObserver_1.initMouseInteractionObserver)(o.mouseInteractionCb, o.configuration.defaultPrivacyLevel);
    var scrollHandler = (0, scrollObserver_1.initScrollObserver)(o.scrollCb, o.configuration.defaultPrivacyLevel, o.elementsScrollPositions);
    var viewportResizeHandler = (0, viewportResizeObserver_1.initViewportResizeObserver)(o.viewportResizeCb);
    var inputHandler = (0, inputObserver_1.initInputObserver)(o.inputCb, o.configuration.defaultPrivacyLevel);
    var mediaInteractionHandler = (0, mediaInteractionObserver_1.initMediaInteractionObserver)(o.mediaInteractionCb, o.configuration.defaultPrivacyLevel);
    var styleSheetObserver = (0, styleSheetObserver_1.initStyleSheetObserver)(o.styleSheetCb);
    var focusHandler = (0, focusObserver_1.initFocusObserver)(o.focusCb);
    var visualViewportResizeHandler = (0, viewportResizeObserver_1.initVisualViewportResizeObserver)(o.visualViewportResizeCb);
    var frustrationHandler = (0, frustrationObserver_1.initFrustrationObserver)(o.lifeCycle, o.frustrationCb);
    return {
        flush: function () {
            mutationHandler.flush();
        },
        stop: function () {
            mutationHandler.stop();
            mousemoveHandler();
            mouseInteractionHandler();
            scrollHandler();
            viewportResizeHandler();
            inputHandler();
            mediaInteractionHandler();
            styleSheetObserver();
            focusHandler();
            visualViewportResizeHandler();
            frustrationHandler();
        },
    };
}
exports.initObservers = initObservers;

},{"./focusObserver":514,"./frustrationObserver":515,"./inputObserver":517,"./mediaInteractionObserver":518,"./mouseInteractionObserver":519,"./moveObserver":520,"./mutationObserver":521,"./scrollObserver":523,"./styleSheetObserver":524,"./viewportResizeObserver":526}],523:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initScrollObserver = void 0;
var browser_core_1 = require("@datadog/browser-core");
var privacy_1 = require("../privacy");
var serialization_1 = require("../serialization");
var viewports_1 = require("../viewports");
var constants_1 = require("../../../constants");
var utils_1 = require("./utils");
var SCROLL_OBSERVER_THRESHOLD = 100;
function initScrollObserver(cb, defaultPrivacyLevel, elementsScrollPositions) {
    var updatePosition = (0, browser_core_1.throttle)(function (event) {
        var target = (0, utils_1.getEventTarget)(event);
        if (!target ||
            (0, privacy_1.getNodePrivacyLevel)(target, defaultPrivacyLevel) === constants_1.NodePrivacyLevel.HIDDEN ||
            !(0, serialization_1.hasSerializedNode)(target)) {
            return;
        }
        var id = (0, serialization_1.getSerializedNodeId)(target);
        var scrollPositions = target === document
            ? {
                scrollTop: (0, viewports_1.getScrollY)(),
                scrollLeft: (0, viewports_1.getScrollX)(),
            }
            : {
                scrollTop: Math.round(target.scrollTop),
                scrollLeft: Math.round(target.scrollLeft),
            };
        elementsScrollPositions.set(target, scrollPositions);
        cb({
            id: id,
            x: scrollPositions.scrollLeft,
            y: scrollPositions.scrollTop,
        });
    }, SCROLL_OBSERVER_THRESHOLD).throttled;
    return (0, browser_core_1.addEventListener)(document, "scroll" /* SCROLL */, updatePosition, { capture: true, passive: true }).stop;
}
exports.initScrollObserver = initScrollObserver;

},{"../../../constants":510,"../privacy":527,"../serialization":529,"../viewports":538,"./utils":525,"@datadog/browser-core":432}],524:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initStyleSheetObserver = void 0;
var browser_core_1 = require("@datadog/browser-core");
var serialization_1 = require("../serialization");
var utils_1 = require("../utils");
function initStyleSheetObserver(cb) {
    function checkStyleSheetAndCallback(styleSheet, callback) {
        if (styleSheet && (0, serialization_1.hasSerializedNode)(styleSheet.ownerNode)) {
            callback((0, serialization_1.getSerializedNodeId)(styleSheet.ownerNode));
        }
    }
    var instrumentationStoppers = [
        (0, browser_core_1.instrumentMethodAndCallOriginal)(CSSStyleSheet.prototype, 'insertRule', {
            before: function (rule, index) {
                checkStyleSheetAndCallback(this, function (id) { return cb({ id: id, adds: [{ rule: rule, index: index }] }); });
            },
        }),
        (0, browser_core_1.instrumentMethodAndCallOriginal)(CSSStyleSheet.prototype, 'deleteRule', {
            before: function (index) {
                checkStyleSheetAndCallback(this, function (id) { return cb({ id: id, removes: [{ index: index }] }); });
            },
        }),
    ];
    if (typeof CSSGroupingRule !== 'undefined') {
        instrumentGroupingCSSRuleClass(CSSGroupingRule);
    }
    else {
        instrumentGroupingCSSRuleClass(CSSMediaRule);
        instrumentGroupingCSSRuleClass(CSSSupportsRule);
    }
    function instrumentGroupingCSSRuleClass(cls) {
        instrumentationStoppers.push((0, browser_core_1.instrumentMethodAndCallOriginal)(cls.prototype, 'insertRule', {
            before: function (rule, index) {
                var _this = this;
                checkStyleSheetAndCallback(this.parentStyleSheet, function (id) {
                    var path = (0, utils_1.getPathToNestedCSSRule)(_this);
                    if (path) {
                        path.push(index || 0);
                        cb({ id: id, adds: [{ rule: rule, index: path }] });
                    }
                });
            },
        }), (0, browser_core_1.instrumentMethodAndCallOriginal)(cls.prototype, 'deleteRule', {
            before: function (index) {
                var _this = this;
                checkStyleSheetAndCallback(this.parentStyleSheet, function (id) {
                    var path = (0, utils_1.getPathToNestedCSSRule)(_this);
                    if (path) {
                        path.push(index);
                        cb({ id: id, removes: [{ index: path }] });
                    }
                });
            },
        }));
    }
    return function () { return instrumentationStoppers.forEach(function (stopper) { return stopper.stop(); }); };
}
exports.initStyleSheetObserver = initStyleSheetObserver;

},{"../serialization":529,"../utils":537,"@datadog/browser-core":432}],525:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRecordIdForEvent = exports.getEventTarget = exports.forEach = void 0;
var browser_rum_core_1 = require("@datadog/browser-rum-core");
function forEach(list, callback) {
    Array.prototype.forEach.call(list, callback);
}
exports.forEach = forEach;
function getEventTarget(event) {
    if (event.composed === true && (0, browser_rum_core_1.isNodeShadowHost)(event.target)) {
        return event.composedPath()[0];
    }
    return event.target;
}
exports.getEventTarget = getEventTarget;
var recordIds = new WeakMap();
var nextId = 1;
function getRecordIdForEvent(event) {
    if (!recordIds.has(event)) {
        recordIds.set(event, nextId++);
    }
    return recordIds.get(event);
}
exports.getRecordIdForEvent = getRecordIdForEvent;

},{"@datadog/browser-rum-core":505}],526:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initVisualViewportResizeObserver = exports.initViewportResizeObserver = void 0;
var browser_core_1 = require("@datadog/browser-core");
var browser_rum_core_1 = require("@datadog/browser-rum-core");
var viewports_1 = require("../viewports");
var VISUAL_VIEWPORT_OBSERVER_THRESHOLD = 200;
function initViewportResizeObserver(cb) {
    return (0, browser_rum_core_1.initViewportObservable)().subscribe(cb).unsubscribe;
}
exports.initViewportResizeObserver = initViewportResizeObserver;
function initVisualViewportResizeObserver(cb) {
    if (!window.visualViewport) {
        return browser_core_1.noop;
    }
    var _a = (0, browser_core_1.throttle)(function () {
        cb((0, viewports_1.getVisualViewport)());
    }, VISUAL_VIEWPORT_OBSERVER_THRESHOLD, {
        trailing: false,
    }), updateDimension = _a.throttled, cancelThrottle = _a.cancel;
    var removeListener = (0, browser_core_1.addEventListeners)(window.visualViewport, ["resize" /* RESIZE */, "scroll" /* SCROLL */], updateDimension, {
        capture: true,
        passive: true,
    }).stop;
    return function stop() {
        removeListener();
        cancelThrottle();
    };
}
exports.initVisualViewportResizeObserver = initVisualViewportResizeObserver;

},{"../viewports":538,"@datadog/browser-core":432,"@datadog/browser-rum-core":505}],527:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldIgnoreElement = exports.getTextContent = exports.censorText = exports.shouldMaskNode = exports.getNodeSelfPrivacyLevel = exports.reducePrivacyLevel = exports.getNodePrivacyLevel = exports.MAX_ATTRIBUTE_VALUE_CHAR_LENGTH = void 0;
var browser_rum_core_1 = require("@datadog/browser-rum-core");
var constants_1 = require("../../constants");
exports.MAX_ATTRIBUTE_VALUE_CHAR_LENGTH = 100000;
var TEXT_MASKING_CHAR = 'x';
/**
 * Get node privacy level by iterating over its ancestors. When the direct parent privacy level is
 * know, it is best to use something like:
 *
 * derivePrivacyLevelGivenParent(getNodeSelfPrivacyLevel(node), parentNodePrivacyLevel)
 */
function getNodePrivacyLevel(node, defaultPrivacyLevel) {
    var parentNode = (0, browser_rum_core_1.getParentNode)(node);
    var parentNodePrivacyLevel = parentNode ? getNodePrivacyLevel(parentNode, defaultPrivacyLevel) : defaultPrivacyLevel;
    var selfNodePrivacyLevel = getNodeSelfPrivacyLevel(node);
    return reducePrivacyLevel(selfNodePrivacyLevel, parentNodePrivacyLevel);
}
exports.getNodePrivacyLevel = getNodePrivacyLevel;
/**
 * Reduces the next privacy level based on self + parent privacy levels
 */
function reducePrivacyLevel(childPrivacyLevel, parentNodePrivacyLevel) {
    switch (parentNodePrivacyLevel) {
        // These values cannot be overridden
        case constants_1.NodePrivacyLevel.HIDDEN:
        case constants_1.NodePrivacyLevel.IGNORE:
            return parentNodePrivacyLevel;
    }
    switch (childPrivacyLevel) {
        case constants_1.NodePrivacyLevel.ALLOW:
        case constants_1.NodePrivacyLevel.MASK:
        case constants_1.NodePrivacyLevel.MASK_USER_INPUT:
        case constants_1.NodePrivacyLevel.HIDDEN:
        case constants_1.NodePrivacyLevel.IGNORE:
            return childPrivacyLevel;
        default:
            return parentNodePrivacyLevel;
    }
}
exports.reducePrivacyLevel = reducePrivacyLevel;
/**
 * Determines the node's own privacy level without checking for ancestors.
 */
function getNodeSelfPrivacyLevel(node) {
    // Only Element types can have a privacy level set
    if (!(0, browser_rum_core_1.isElementNode)(node)) {
        return;
    }
    var privAttr = node.getAttribute(constants_1.PRIVACY_ATTR_NAME);
    // Overrules for replay purpose
    if (node.tagName === 'BASE') {
        return constants_1.NodePrivacyLevel.ALLOW;
    }
    // Overrules to enforce end-user protection
    if (node.tagName === 'INPUT') {
        var inputElement = node;
        if (inputElement.type === 'password' || inputElement.type === 'email' || inputElement.type === 'tel') {
            return constants_1.NodePrivacyLevel.MASK;
        }
        if (inputElement.type === 'hidden') {
            return constants_1.NodePrivacyLevel.MASK;
        }
        var autocomplete = inputElement.getAttribute('autocomplete');
        // Handle input[autocomplete=cc-number/cc-csc/cc-exp/cc-exp-month/cc-exp-year]
        if (autocomplete && autocomplete.indexOf('cc-') === 0) {
            return constants_1.NodePrivacyLevel.MASK;
        }
    }
    // Check HTML privacy attributes and classes
    if (privAttr === constants_1.PRIVACY_ATTR_VALUE_HIDDEN || node.classList.contains(constants_1.PRIVACY_CLASS_HIDDEN)) {
        return constants_1.NodePrivacyLevel.HIDDEN;
    }
    if (privAttr === constants_1.PRIVACY_ATTR_VALUE_MASK || node.classList.contains(constants_1.PRIVACY_CLASS_MASK)) {
        return constants_1.NodePrivacyLevel.MASK;
    }
    if (privAttr === constants_1.PRIVACY_ATTR_VALUE_MASK_USER_INPUT || node.classList.contains(constants_1.PRIVACY_CLASS_MASK_USER_INPUT)) {
        return constants_1.NodePrivacyLevel.MASK_USER_INPUT;
    }
    if (privAttr === constants_1.PRIVACY_ATTR_VALUE_ALLOW || node.classList.contains(constants_1.PRIVACY_CLASS_ALLOW)) {
        return constants_1.NodePrivacyLevel.ALLOW;
    }
    if (shouldIgnoreElement(node)) {
        return constants_1.NodePrivacyLevel.IGNORE;
    }
}
exports.getNodeSelfPrivacyLevel = getNodeSelfPrivacyLevel;
/**
 * Helper aiming to unify `mask` and `mask-user-input` privacy levels:
 *
 * In the `mask` case, it is trivial: we should mask the element.
 *
 * In the `mask-user-input` case, we should mask the element only if it is a "form" element or the
 * direct parent is a form element for text nodes).
 *
 * Other `shouldMaskNode` cases are edge cases that should not matter too much (ex: should we mask a
 * node if it is ignored or hidden? it doesn't matter since it won't be serialized).
 */
function shouldMaskNode(node, privacyLevel) {
    switch (privacyLevel) {
        case constants_1.NodePrivacyLevel.MASK:
        case constants_1.NodePrivacyLevel.HIDDEN:
        case constants_1.NodePrivacyLevel.IGNORE:
            return true;
        case constants_1.NodePrivacyLevel.MASK_USER_INPUT:
            return (0, browser_rum_core_1.isTextNode)(node) ? isFormElement(node.parentNode) : isFormElement(node);
        default:
            return false;
    }
}
exports.shouldMaskNode = shouldMaskNode;
function isFormElement(node) {
    if (!node || node.nodeType !== node.ELEMENT_NODE) {
        return false;
    }
    var element = node;
    if (element.tagName === 'INPUT') {
        switch (element.type) {
            case 'button':
            case 'color':
            case 'reset':
            case 'submit':
                return false;
        }
    }
    return !!constants_1.FORM_PRIVATE_TAG_NAMES[element.tagName];
}
/**
 * Text censoring non-destructively maintains whitespace characters in order to preserve text shape
 * during replay.
 */
var censorText = function (text) { return text.replace(/\S/g, TEXT_MASKING_CHAR); };
exports.censorText = censorText;
function getTextContent(textNode, ignoreWhiteSpace, parentNodePrivacyLevel) {
    var _a;
    // The parent node may not be a html element which has a tagName attribute.
    // So just let it be undefined which is ok in this use case.
    var parentTagName = (_a = textNode.parentElement) === null || _a === void 0 ? void 0 : _a.tagName;
    var textContent = textNode.textContent || '';
    if (ignoreWhiteSpace && !textContent.trim()) {
        return;
    }
    var nodePrivacyLevel = parentNodePrivacyLevel;
    var isStyle = parentTagName === 'STYLE' ? true : undefined;
    var isScript = parentTagName === 'SCRIPT';
    if (isScript) {
        // For perf reasons, we don't record script (heuristic)
        textContent = constants_1.CENSORED_STRING_MARK;
    }
    else if (nodePrivacyLevel === constants_1.NodePrivacyLevel.HIDDEN) {
        // Should never occur, but just in case, we set to CENSORED_MARK.
        textContent = constants_1.CENSORED_STRING_MARK;
    }
    else if (shouldMaskNode(textNode, nodePrivacyLevel) &&
        // Style tags are `overruled` (Use `hide` to enforce privacy)
        !isStyle) {
        if (
        // Scrambling the child list breaks text nodes for DATALIST/SELECT/OPTGROUP
        parentTagName === 'DATALIST' ||
            parentTagName === 'SELECT' ||
            parentTagName === 'OPTGROUP') {
            if (!textContent.trim()) {
                return;
            }
        }
        else if (parentTagName === 'OPTION') {
            // <Option> has low entropy in charset + text length, so use `CENSORED_STRING_MARK` when masked
            textContent = constants_1.CENSORED_STRING_MARK;
        }
        else {
            textContent = (0, exports.censorText)(textContent);
        }
    }
    return textContent;
}
exports.getTextContent = getTextContent;
/**
 * TODO: Preserve CSS element order, and record the presence of the tag, just don't render
 * We don't need this logic on the recorder side.
 * For security related meta's, customer can mask themmanually given they
 * are easy to identify in the HEAD tag.
 */
function shouldIgnoreElement(element) {
    if (element.nodeName === 'SCRIPT') {
        return true;
    }
    if (element.nodeName === 'LINK') {
        var relAttribute = getLowerCaseAttribute('rel');
        return (
        // Link as script - Ignore only when rel=preload, modulepreload or prefetch
        (/preload|prefetch/i.test(relAttribute) && getLowerCaseAttribute('as') === 'script') ||
            // Favicons
            relAttribute === 'shortcut icon' ||
            relAttribute === 'icon');
    }
    if (element.nodeName === 'META') {
        var nameAttribute = getLowerCaseAttribute('name');
        var relAttribute = getLowerCaseAttribute('rel');
        var propertyAttribute = getLowerCaseAttribute('property');
        return (
        // Favicons
        /^msapplication-tile(image|color)$/.test(nameAttribute) ||
            nameAttribute === 'application-name' ||
            relAttribute === 'icon' ||
            relAttribute === 'apple-touch-icon' ||
            relAttribute === 'shortcut icon' ||
            // Description
            nameAttribute === 'keywords' ||
            nameAttribute === 'description' ||
            // Social
            /^(og|twitter|fb):/.test(propertyAttribute) ||
            /^(og|twitter):/.test(nameAttribute) ||
            nameAttribute === 'pinterest' ||
            // Robots
            nameAttribute === 'robots' ||
            nameAttribute === 'googlebot' ||
            nameAttribute === 'bingbot' ||
            // Http headers. Ex: X-UA-Compatible, Content-Type, Content-Language, cache-control,
            // X-Translated-By
            element.hasAttribute('http-equiv') ||
            // Authorship
            nameAttribute === 'author' ||
            nameAttribute === 'generator' ||
            nameAttribute === 'framework' ||
            nameAttribute === 'publisher' ||
            nameAttribute === 'progid' ||
            /^article:/.test(propertyAttribute) ||
            /^product:/.test(propertyAttribute) ||
            // Verification
            nameAttribute === 'google-site-verification' ||
            nameAttribute === 'yandex-verification' ||
            nameAttribute === 'csrf-token' ||
            nameAttribute === 'p:domain_verify' ||
            nameAttribute === 'verify-v1' ||
            nameAttribute === 'verification' ||
            nameAttribute === 'shopify-checkout-api-token');
    }
    function getLowerCaseAttribute(name) {
        return (element.getAttribute(name) || '').toLowerCase();
    }
    return false;
}
exports.shouldIgnoreElement = shouldIgnoreElement;

},{"../../constants":510,"@datadog/browser-rum-core":505}],528:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.record = void 0;
var browser_core_1 = require("@datadog/browser-core");
var browser_rum_core_1 = require("@datadog/browser-rum-core");
var types_1 = require("../../types");
var serialization_1 = require("./serialization");
var observers_1 = require("./observers");
var viewports_1 = require("./viewports");
var utils_1 = require("./utils");
var elementsScrollPositions_1 = require("./elementsScrollPositions");
var shadowRootsController_1 = require("./shadowRootsController");
function record(options) {
    var emit = options.emit;
    // runtime checks for user options
    if (!emit) {
        throw new Error('emit function is required');
    }
    var elementsScrollPositions = (0, elementsScrollPositions_1.createElementsScrollPositions)();
    var mutationCb = function (mutation) {
        emit((0, utils_1.assembleIncrementalSnapshot)(types_1.IncrementalSource.Mutation, mutation));
    };
    var inputCb = function (s) { return emit((0, utils_1.assembleIncrementalSnapshot)(types_1.IncrementalSource.Input, s)); };
    var shadowRootsController = (0, shadowRootsController_1.initShadowRootsController)(options.configuration, { mutationCb: mutationCb, inputCb: inputCb });
    var takeFullSnapshot = function (timestamp, serializationContext) {
        if (timestamp === void 0) { timestamp = (0, browser_core_1.timeStampNow)(); }
        if (serializationContext === void 0) { serializationContext = {
            status: 0 /* INITIAL_FULL_SNAPSHOT */,
            elementsScrollPositions: elementsScrollPositions,
            shadowRootsController: shadowRootsController,
        }; }
        var _a = (0, browser_rum_core_1.getViewportDimension)(), width = _a.width, height = _a.height;
        emit({
            data: {
                height: height,
                href: window.location.href,
                width: width,
            },
            type: types_1.RecordType.Meta,
            timestamp: timestamp,
        });
        emit({
            data: {
                has_focus: document.hasFocus(),
            },
            type: types_1.RecordType.Focus,
            timestamp: timestamp,
        });
        emit({
            data: {
                node: (0, serialization_1.serializeDocument)(document, options.configuration, serializationContext),
                initialOffset: {
                    left: (0, viewports_1.getScrollX)(),
                    top: (0, viewports_1.getScrollY)(),
                },
            },
            type: types_1.RecordType.FullSnapshot,
            timestamp: timestamp,
        });
        if (window.visualViewport) {
            emit({
                data: (0, viewports_1.getVisualViewport)(),
                type: types_1.RecordType.VisualViewport,
                timestamp: timestamp,
            });
        }
    };
    takeFullSnapshot();
    var _a = (0, observers_1.initObservers)({
        lifeCycle: options.lifeCycle,
        configuration: options.configuration,
        elementsScrollPositions: elementsScrollPositions,
        inputCb: inputCb,
        mediaInteractionCb: function (p) {
            return emit((0, utils_1.assembleIncrementalSnapshot)(types_1.IncrementalSource.MediaInteraction, p));
        },
        mouseInteractionCb: function (mouseInteractionRecord) { return emit(mouseInteractionRecord); },
        mousemoveCb: function (positions, source) { return emit((0, utils_1.assembleIncrementalSnapshot)(source, { positions: positions })); },
        mutationCb: mutationCb,
        scrollCb: function (p) { return emit((0, utils_1.assembleIncrementalSnapshot)(types_1.IncrementalSource.Scroll, p)); },
        styleSheetCb: function (r) { return emit((0, utils_1.assembleIncrementalSnapshot)(types_1.IncrementalSource.StyleSheetRule, r)); },
        viewportResizeCb: function (d) { return emit((0, utils_1.assembleIncrementalSnapshot)(types_1.IncrementalSource.ViewportResize, d)); },
        frustrationCb: function (frustrationRecord) { return emit(frustrationRecord); },
        focusCb: function (data) {
            return emit({
                data: data,
                type: types_1.RecordType.Focus,
                timestamp: (0, browser_core_1.timeStampNow)(),
            });
        },
        visualViewportResizeCb: function (data) {
            emit({
                data: data,
                type: types_1.RecordType.VisualViewport,
                timestamp: (0, browser_core_1.timeStampNow)(),
            });
        },
        shadowRootsController: shadowRootsController,
    }), stopObservers = _a.stop, flushMutationsFromObservers = _a.flush;
    function flushMutations() {
        shadowRootsController.flush();
        flushMutationsFromObservers();
    }
    return {
        stop: function () {
            shadowRootsController.stop();
            stopObservers();
        },
        takeSubsequentFullSnapshot: function (timestamp) {
            flushMutations();
            takeFullSnapshot(timestamp, {
                shadowRootsController: shadowRootsController,
                status: 1 /* SUBSEQUENT_FULL_SNAPSHOT */,
                elementsScrollPositions: elementsScrollPositions,
            });
        },
        flushMutations: flushMutations,
        shadowRootsController: shadowRootsController,
    };
}
exports.record = record;

},{"../../types":547,"./elementsScrollPositions":511,"./observers":516,"./serialization":529,"./shadowRootsController":536,"./utils":537,"./viewports":538,"@datadog/browser-core":432,"@datadog/browser-rum-core":505}],529:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeAttribute = exports.serializeNodeWithId = exports.serializeDocument = exports.nodeAndAncestorsHaveSerializedNode = exports.hasSerializedNode = exports.getSerializedNodeId = exports.getElementInputValue = void 0;
var serializationUtils_1 = require("./serializationUtils");
Object.defineProperty(exports, "getElementInputValue", { enumerable: true, get: function () { return serializationUtils_1.getElementInputValue; } });
Object.defineProperty(exports, "getSerializedNodeId", { enumerable: true, get: function () { return serializationUtils_1.getSerializedNodeId; } });
Object.defineProperty(exports, "hasSerializedNode", { enumerable: true, get: function () { return serializationUtils_1.hasSerializedNode; } });
Object.defineProperty(exports, "nodeAndAncestorsHaveSerializedNode", { enumerable: true, get: function () { return serializationUtils_1.nodeAndAncestorsHaveSerializedNode; } });
var serializeDocument_1 = require("./serializeDocument");
Object.defineProperty(exports, "serializeDocument", { enumerable: true, get: function () { return serializeDocument_1.serializeDocument; } });
var serializeNode_1 = require("./serializeNode");
Object.defineProperty(exports, "serializeNodeWithId", { enumerable: true, get: function () { return serializeNode_1.serializeNodeWithId; } });
var serializeAttribute_1 = require("./serializeAttribute");
Object.defineProperty(exports, "serializeAttribute", { enumerable: true, get: function () { return serializeAttribute_1.serializeAttribute; } });

},{"./serializationUtils":530,"./serializeAttribute":531,"./serializeDocument":533,"./serializeNode":534}],530:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValidTagName = exports.makeUrlAbsolute = exports.switchToAbsoluteUrl = exports.DATA_URI = exports.ABSOLUTE_URL = exports.URL_IN_CSS_REF = exports.getElementInputValue = exports.setSerializedNodeId = exports.getSerializedNodeId = exports.nodeAndAncestorsHaveSerializedNode = exports.hasSerializedNode = void 0;
var browser_core_1 = require("@datadog/browser-core");
var browser_rum_core_1 = require("@datadog/browser-rum-core");
var constants_1 = require("../../../constants");
var privacy_1 = require("../privacy");
var serializedNodeIds = new WeakMap();
function hasSerializedNode(node) {
    return serializedNodeIds.has(node);
}
exports.hasSerializedNode = hasSerializedNode;
function nodeAndAncestorsHaveSerializedNode(node) {
    var current = node;
    while (current) {
        if (!hasSerializedNode(current) && !(0, browser_rum_core_1.isNodeShadowRoot)(current)) {
            return false;
        }
        current = (0, browser_rum_core_1.getParentNode)(current);
    }
    return true;
}
exports.nodeAndAncestorsHaveSerializedNode = nodeAndAncestorsHaveSerializedNode;
function getSerializedNodeId(node) {
    return serializedNodeIds.get(node);
}
exports.getSerializedNodeId = getSerializedNodeId;
function setSerializedNodeId(node, serializeNodeId) {
    serializedNodeIds.set(node, serializeNodeId);
}
exports.setSerializedNodeId = setSerializedNodeId;
/**
 * Get the element "value" to be serialized as an attribute or an input update record. It respects
 * the input privacy mode of the element.
 * PERFROMANCE OPTIMIZATION: Assumes that privacy level `HIDDEN` is never encountered because of earlier checks.
 */
function getElementInputValue(element, nodePrivacyLevel) {
    /*
     BROWSER SPEC NOTE: <input>, <select>
     For some <input> elements, the `value` is an exceptional property/attribute that has the
     value synced between el.value and el.getAttribute()
     input[type=button,checkbox,hidden,image,radio,reset,submit]
     */
    var tagName = element.tagName;
    var value = element.value;
    if ((0, privacy_1.shouldMaskNode)(element, nodePrivacyLevel)) {
        var type = element.type;
        if (tagName === 'INPUT' && (type === 'button' || type === 'submit' || type === 'reset')) {
            // Overrule `MASK` privacy level for button-like element values, as they are used during replay
            // to display their label. They can still be hidden via the "hidden" privacy attribute or class name.
            return value;
        }
        else if (!value || tagName === 'OPTION') {
            // <Option> value provides no benefit
            return;
        }
        return constants_1.CENSORED_STRING_MARK;
    }
    if (tagName === 'OPTION' || tagName === 'SELECT') {
        return element.value;
    }
    if (tagName !== 'INPUT' && tagName !== 'TEXTAREA') {
        return;
    }
    return value;
}
exports.getElementInputValue = getElementInputValue;
exports.URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")([^"]*)"|([^)]*))\)/gm;
exports.ABSOLUTE_URL = /^[A-Za-z]+:|^\/\//;
exports.DATA_URI = /^data:.*,/i;
function switchToAbsoluteUrl(cssText, cssHref) {
    return cssText.replace(exports.URL_IN_CSS_REF, function (matchingSubstring, singleQuote, urlWrappedInSingleQuotes, doubleQuote, urlWrappedInDoubleQuotes, urlNotWrappedInQuotes) {
        var url = urlWrappedInSingleQuotes || urlWrappedInDoubleQuotes || urlNotWrappedInQuotes;
        if (!cssHref || !url || exports.ABSOLUTE_URL.test(url) || exports.DATA_URI.test(url)) {
            return matchingSubstring;
        }
        var quote = singleQuote || doubleQuote || '';
        return "url(".concat(quote).concat(makeUrlAbsolute(url, cssHref)).concat(quote, ")");
    });
}
exports.switchToAbsoluteUrl = switchToAbsoluteUrl;
function makeUrlAbsolute(url, baseUrl) {
    try {
        return (0, browser_core_1.buildUrl)(url, baseUrl).href;
    }
    catch (_) {
        return url;
    }
}
exports.makeUrlAbsolute = makeUrlAbsolute;
var TAG_NAME_REGEX = /[^a-z1-6-_]/;
function getValidTagName(tagName) {
    var processedTagName = tagName.toLowerCase().trim();
    if (TAG_NAME_REGEX.test(processedTagName)) {
        // if the tag name is odd and we cannot extract
        // anything from the string, then we return a
        // generic div
        return 'div';
    }
    return processedTagName;
}
exports.getValidTagName = getValidTagName;

},{"../../../constants":510,"../privacy":527,"@datadog/browser-core":432,"@datadog/browser-rum-core":505}],531:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeAttribute = void 0;
var browser_core_1 = require("@datadog/browser-core");
var browser_rum_core_1 = require("@datadog/browser-rum-core");
var constants_1 = require("../../../constants");
var privacy_1 = require("../privacy");
function serializeAttribute(element, nodePrivacyLevel, attributeName, configuration) {
    if (nodePrivacyLevel === constants_1.NodePrivacyLevel.HIDDEN) {
        // dup condition for direct access case
        return null;
    }
    var attributeValue = element.getAttribute(attributeName);
    if (nodePrivacyLevel === constants_1.NodePrivacyLevel.MASK &&
        attributeName !== constants_1.PRIVACY_ATTR_NAME &&
        !browser_rum_core_1.STABLE_ATTRIBUTES.includes(attributeName) &&
        attributeName !== configuration.actionNameAttribute) {
        var tagName = element.tagName;
        switch (attributeName) {
            // Mask Attribute text content
            case 'title':
            case 'alt':
            case 'placeholder':
                return constants_1.CENSORED_STRING_MARK;
        }
        // mask image URLs
        if (tagName === 'IMG' || tagName === 'SOURCE') {
            if (attributeName === 'src' || attributeName === 'srcset') {
                return constants_1.CENSORED_IMG_MARK;
            }
        }
        // mask <a> URLs
        if (tagName === 'A' && attributeName === 'href') {
            return constants_1.CENSORED_STRING_MARK;
        }
        // mask data-* attributes
        if (attributeValue && (0, browser_core_1.startsWith)(attributeName, 'data-')) {
            // Exception: it's safe to reveal the `${PRIVACY_ATTR_NAME}` attr
            return constants_1.CENSORED_STRING_MARK;
        }
    }
    if (!attributeValue || typeof attributeValue !== 'string') {
        return attributeValue;
    }
    // Minimum Fix for customer.
    if (attributeValue.length > privacy_1.MAX_ATTRIBUTE_VALUE_CHAR_LENGTH && attributeValue.slice(0, 5) === 'data:') {
        return 'data:truncated';
    }
    return attributeValue;
}
exports.serializeAttribute = serializeAttribute;

},{"../../../constants":510,"../privacy":527,"@datadog/browser-core":432,"@datadog/browser-rum-core":505}],532:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeAttributes = void 0;
var constants_1 = require("../../../constants");
var privacy_1 = require("../privacy");
var serializationUtils_1 = require("./serializationUtils");
var serializeAttribute_1 = require("./serializeAttribute");
function serializeAttributes(element, nodePrivacyLevel, options) {
    var _a;
    if (nodePrivacyLevel === constants_1.NodePrivacyLevel.HIDDEN) {
        return {};
    }
    var safeAttrs = {};
    var tagName = (0, serializationUtils_1.getValidTagName)(element.tagName);
    var doc = element.ownerDocument;
    for (var i = 0; i < element.attributes.length; i += 1) {
        var attribute = element.attributes.item(i);
        var attributeName = attribute.name;
        var attributeValue = (0, serializeAttribute_1.serializeAttribute)(element, nodePrivacyLevel, attributeName, options.configuration);
        if (attributeValue !== null) {
            safeAttrs[attributeName] = attributeValue;
        }
    }
    if (element.value &&
        (tagName === 'textarea' || tagName === 'select' || tagName === 'option' || tagName === 'input')) {
        var formValue = (0, serializationUtils_1.getElementInputValue)(element, nodePrivacyLevel);
        if (formValue !== undefined) {
            safeAttrs.value = formValue;
        }
    }
    /**
     * <Option> can be selected, which occurs if its `value` matches ancestor `<Select>.value`
     */
    if (tagName === 'option' && nodePrivacyLevel === constants_1.NodePrivacyLevel.ALLOW) {
        // For privacy=`MASK`, all the values would be the same, so skip.
        var optionElement = element;
        if (optionElement.selected) {
            safeAttrs.selected = optionElement.selected;
        }
    }
    // remote css
    if (tagName === 'link') {
        var stylesheet = Array.from(doc.styleSheets).find(function (s) { return s.href === element.href; });
        var cssText = getCssRulesString(stylesheet);
        if (cssText && stylesheet) {
            safeAttrs._cssText = cssText;
        }
    }
    // dynamic stylesheet
    if (tagName === 'style' &&
        element.sheet &&
        // TODO: Currently we only try to get dynamic stylesheet when it is an empty style element
        !(element.innerText || element.textContent || '').trim().length) {
        var cssText = getCssRulesString(element.sheet);
        if (cssText) {
            safeAttrs._cssText = cssText;
        }
    }
    /**
     * Forms: input[type=checkbox,radio]
     * The `checked` property for <input> is a little bit special:
     * 1. el.checked is a setter that returns if truthy.
     * 2. getAttribute returns the string value
     * getAttribute('checked') does not sync with `Element.checked`, so use JS property
     * NOTE: `checked` property exists on `HTMLInputElement`. For serializer assumptions, we check for type=radio|check.
     */
    var inputElement = element;
    if (tagName === 'input' && (inputElement.type === 'radio' || inputElement.type === 'checkbox')) {
        if (nodePrivacyLevel === constants_1.NodePrivacyLevel.ALLOW) {
            safeAttrs.checked = !!inputElement.checked;
        }
        else if ((0, privacy_1.shouldMaskNode)(inputElement, nodePrivacyLevel)) {
            delete safeAttrs.checked;
        }
    }
    /**
     * Serialize the media playback state
     */
    if (tagName === 'audio' || tagName === 'video') {
        var mediaElement = element;
        safeAttrs.rr_mediaState = mediaElement.paused ? 'paused' : 'played';
    }
    /**
     * Serialize the scroll state for each element only for full snapshot
     */
    var scrollTop;
    var scrollLeft;
    var serializationContext = options.serializationContext;
    switch (serializationContext.status) {
        case 0 /* INITIAL_FULL_SNAPSHOT */:
            scrollTop = Math.round(element.scrollTop);
            scrollLeft = Math.round(element.scrollLeft);
            if (scrollTop || scrollLeft) {
                serializationContext.elementsScrollPositions.set(element, { scrollTop: scrollTop, scrollLeft: scrollLeft });
            }
            break;
        case 1 /* SUBSEQUENT_FULL_SNAPSHOT */:
            if (serializationContext.elementsScrollPositions.has(element)) {
                ;
                (_a = serializationContext.elementsScrollPositions.get(element), scrollTop = _a.scrollTop, scrollLeft = _a.scrollLeft);
            }
            break;
    }
    if (scrollLeft) {
        safeAttrs.rr_scrollLeft = scrollLeft;
    }
    if (scrollTop) {
        safeAttrs.rr_scrollTop = scrollTop;
    }
    return safeAttrs;
}
exports.serializeAttributes = serializeAttributes;
function getCssRulesString(cssStyleSheet) {
    if (!cssStyleSheet) {
        return null;
    }
    var rules;
    try {
        rules = cssStyleSheet.rules || cssStyleSheet.cssRules;
    }
    catch (_a) {
        // if css is protected by CORS we cannot access cssRules see: https://www.w3.org/TR/cssom-1/#the-cssstylesheet-interface
    }
    if (!rules) {
        return null;
    }
    var styleSheetCssText = Array.from(rules, getCssRuleString).join('');
    return (0, serializationUtils_1.switchToAbsoluteUrl)(styleSheetCssText, cssStyleSheet.href);
}
function getCssRuleString(rule) {
    return isCSSImportRule(rule) ? getCssRulesString(rule.styleSheet) || '' : rule.cssText;
}
function isCSSImportRule(rule) {
    return 'styleSheet' in rule;
}

},{"../../../constants":510,"../privacy":527,"./serializationUtils":530,"./serializeAttribute":531}],533:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeDocument = void 0;
var serializeNode_1 = require("./serializeNode");
function serializeDocument(document, configuration, serializationContext) {
    // We are sure that Documents are never ignored, so this function never returns null
    return (0, serializeNode_1.serializeNodeWithId)(document, {
        serializationContext: serializationContext,
        parentNodePrivacyLevel: configuration.defaultPrivacyLevel,
        configuration: configuration,
    });
}
exports.serializeDocument = serializeDocument;

},{"./serializeNode":534}],534:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeDocumentNode = exports.serializeChildNodes = exports.generateNextId = exports.serializeNodeWithId = void 0;
var browser_rum_core_1 = require("@datadog/browser-rum-core");
var browser_core_1 = require("@datadog/browser-core");
var types_1 = require("../../../types");
var constants_1 = require("../../../constants");
var privacy_1 = require("../privacy");
var serializationUtils_1 = require("./serializationUtils");
var serializeStyleSheets_1 = require("./serializeStyleSheets");
var serializeAttributes_1 = require("./serializeAttributes");
function serializeNodeWithId(node, options) {
    var serializedNode = serializeNode(node, options);
    if (!serializedNode) {
        return null;
    }
    // Try to reuse the previous id
    var id = (0, serializationUtils_1.getSerializedNodeId)(node) || generateNextId();
    var serializedNodeWithId = serializedNode;
    serializedNodeWithId.id = id;
    (0, serializationUtils_1.setSerializedNodeId)(node, id);
    if (options.serializedNodeIds) {
        options.serializedNodeIds.add(id);
    }
    return serializedNodeWithId;
}
exports.serializeNodeWithId = serializeNodeWithId;
var _nextId = 1;
function generateNextId() {
    return _nextId++;
}
exports.generateNextId = generateNextId;
function serializeChildNodes(node, options) {
    var result = [];
    node.childNodes.forEach(function (childNode) {
        var serializedChildNode = serializeNodeWithId(childNode, options);
        if (serializedChildNode) {
            result.push(serializedChildNode);
        }
    });
    return result;
}
exports.serializeChildNodes = serializeChildNodes;
function serializeNode(node, options) {
    switch (node.nodeType) {
        case node.DOCUMENT_NODE:
            return serializeDocumentNode(node, options);
        case node.DOCUMENT_FRAGMENT_NODE:
            return serializeDocumentFragmentNode(node, options);
        case node.DOCUMENT_TYPE_NODE:
            return serializeDocumentTypeNode(node);
        case node.ELEMENT_NODE:
            return serializeElementNode(node, options);
        case node.TEXT_NODE:
            return serializeTextNode(node, options);
        case node.CDATA_SECTION_NODE:
            return serializeCDataNode();
    }
}
function serializeDocumentNode(document, options) {
    return {
        type: types_1.NodeType.Document,
        childNodes: serializeChildNodes(document, options),
        adoptedStyleSheets: (0, serializeStyleSheets_1.serializeStyleSheets)(document.adoptedStyleSheets),
    };
}
exports.serializeDocumentNode = serializeDocumentNode;
function serializeDocumentFragmentNode(element, options) {
    var childNodes = [];
    if (element.childNodes.length) {
        childNodes = serializeChildNodes(element, options);
    }
    var isShadowRoot = (0, browser_rum_core_1.isNodeShadowRoot)(element);
    if (isShadowRoot) {
        options.serializationContext.shadowRootsController.addShadowRoot(element);
    }
    return {
        type: types_1.NodeType.DocumentFragment,
        childNodes: childNodes,
        isShadowRoot: isShadowRoot,
        adoptedStyleSheets: isShadowRoot
            ? (0, serializeStyleSheets_1.serializeStyleSheets)(element.adoptedStyleSheets)
            : undefined,
    };
}
function serializeDocumentTypeNode(documentType) {
    return {
        type: types_1.NodeType.DocumentType,
        name: documentType.name,
        publicId: documentType.publicId,
        systemId: documentType.systemId,
    };
}
/**
 * Serializing Element nodes involves capturing:
 * 1. HTML ATTRIBUTES:
 * 2. JS STATE:
 * - scroll offsets
 * - Form fields (input value, checkbox checked, option selection, range)
 * - Canvas state,
 * - Media (video/audio) play mode + currentTime
 * - iframe contents
 * - webcomponents
 * 3. CUSTOM PROPERTIES:
 * - height+width for when `hidden` to cover the element
 * 4. EXCLUDED INTERACTION STATE:
 * - focus (possible, but not worth perf impact)
 * - hover (tracked only via mouse activity)
 * - fullscreen mode
 */
function serializeElementNode(element, options) {
    var _a;
    var tagName = (0, serializationUtils_1.getValidTagName)(element.tagName);
    var isSVG = isSVGElement(element) || undefined;
    // For performance reason, we don't use getNodePrivacyLevel directly: we leverage the
    // parentNodePrivacyLevel option to avoid iterating over all parents
    var nodePrivacyLevel = (0, privacy_1.reducePrivacyLevel)((0, privacy_1.getNodeSelfPrivacyLevel)(element), options.parentNodePrivacyLevel);
    if (nodePrivacyLevel === constants_1.NodePrivacyLevel.HIDDEN) {
        var _b = element.getBoundingClientRect(), width = _b.width, height = _b.height;
        return {
            type: types_1.NodeType.Element,
            tagName: tagName,
            attributes: (_a = {
                    rr_width: "".concat(width, "px"),
                    rr_height: "".concat(height, "px")
                },
                _a[constants_1.PRIVACY_ATTR_NAME] = constants_1.PRIVACY_ATTR_VALUE_HIDDEN,
                _a),
            childNodes: [],
            isSVG: isSVG,
        };
    }
    // Ignore Elements like Script and some Link, Metas
    if (nodePrivacyLevel === constants_1.NodePrivacyLevel.IGNORE) {
        return;
    }
    var attributes = (0, serializeAttributes_1.serializeAttributes)(element, nodePrivacyLevel, options);
    var childNodes = [];
    if (element.childNodes.length) {
        // OBJECT POOLING OPTIMIZATION:
        // We should not create a new object systematically as it could impact performances. Try to reuse
        // the same object as much as possible, and clone it only if we need to.
        var childNodesSerializationOptions = void 0;
        if (options.parentNodePrivacyLevel === nodePrivacyLevel && options.ignoreWhiteSpace === (tagName === 'head')) {
            childNodesSerializationOptions = options;
        }
        else {
            childNodesSerializationOptions = (0, browser_core_1.assign)({}, options, {
                parentNodePrivacyLevel: nodePrivacyLevel,
                ignoreWhiteSpace: tagName === 'head',
            });
        }
        childNodes = serializeChildNodes(element, childNodesSerializationOptions);
    }
    if ((0, browser_rum_core_1.isNodeShadowHost)(element)) {
        var shadowRoot = serializeNodeWithId(element.shadowRoot, options);
        if (shadowRoot !== null) {
            childNodes.push(shadowRoot);
        }
    }
    return {
        type: types_1.NodeType.Element,
        tagName: tagName,
        attributes: attributes,
        childNodes: childNodes,
        isSVG: isSVG,
    };
}
function isSVGElement(el) {
    return el.tagName === 'svg' || el instanceof SVGElement;
}
/**
 * Text Nodes are dependant on Element nodes
 * Privacy levels are set on elements so we check the parentElement of a text node
 * for privacy level.
 */
function serializeTextNode(textNode, options) {
    var _a;
    // The parent node may not be a html element which has a tagName attribute.
    // So just let it be undefined which is ok in this use case.
    var parentTagName = (_a = textNode.parentElement) === null || _a === void 0 ? void 0 : _a.tagName;
    var textContent = (0, privacy_1.getTextContent)(textNode, options.ignoreWhiteSpace || false, options.parentNodePrivacyLevel);
    if (!textContent) {
        return;
    }
    return {
        type: types_1.NodeType.Text,
        textContent: textContent,
        isStyle: parentTagName === 'STYLE' ? true : undefined,
    };
}
function serializeCDataNode() {
    return {
        type: types_1.NodeType.CDATA,
        textContent: '',
    };
}

},{"../../../constants":510,"../../../types":547,"../privacy":527,"./serializationUtils":530,"./serializeAttributes":532,"./serializeStyleSheets":535,"@datadog/browser-core":432,"@datadog/browser-rum-core":505}],535:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeStyleSheets = void 0;
function serializeStyleSheets(cssStyleSheets) {
    if (cssStyleSheets === undefined || cssStyleSheets.length === 0) {
        return undefined;
    }
    return cssStyleSheets.map(function (cssStyleSheet) {
        var rules = cssStyleSheet.cssRules || cssStyleSheet.rules;
        var cssRules = Array.from(rules, function (cssRule) { return cssRule.cssText; });
        var styleSheet = {
            cssRules: cssRules,
            disabled: cssStyleSheet.disabled || undefined,
            media: cssStyleSheet.media.length > 0 ? Array.from(cssStyleSheet.media) : undefined,
        };
        return styleSheet;
    });
}
exports.serializeStyleSheets = serializeStyleSheets;

},{}],536:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initShadowRootsController = void 0;
var browser_core_1 = require("@datadog/browser-core");
var observers_1 = require("./observers");
var initShadowRootsController = function (configuration, _a) {
    var mutationCb = _a.mutationCb, inputCb = _a.inputCb;
    var controllerByShadowRoot = new Map();
    var shadowRootsController = {
        addShadowRoot: function (shadowRoot) {
            var _a = (0, observers_1.initMutationObserver)(mutationCb, configuration, shadowRootsController, shadowRoot), stopMutationObserver = _a.stop, flush = _a.flush;
            // the change event no do bubble up across the shadow root, we have to listen on the shadow root
            var stopInputObserver = (0, observers_1.initInputObserver)(inputCb, configuration.defaultPrivacyLevel, {
                target: shadowRoot,
                domEvents: ["change" /* CHANGE */],
            });
            controllerByShadowRoot.set(shadowRoot, {
                flush: flush,
                stop: function () {
                    stopMutationObserver();
                    stopInputObserver();
                },
            });
        },
        removeShadowRoot: function (shadowRoot) {
            var entry = controllerByShadowRoot.get(shadowRoot);
            if (!entry) {
                (0, browser_core_1.addTelemetryDebug)('no shadow root in map', {
                    shadowRoot: shadowRoot ? shadowRoot.nodeName : 'no node name',
                    childrenLength: shadowRoot ? shadowRoot.childElementCount : '-1',
                    controllerByShadowRootSize: controllerByShadowRoot.size,
                    html: shadowRoot && (0, browser_core_1.isExperimentalFeatureEnabled)('shadow_dom_debug')
                        ? shadowRoot.innerHTML.substring(0, 2000)
                        : undefined,
                });
                return;
            }
            entry.stop();
            controllerByShadowRoot.delete(shadowRoot);
        },
        stop: function () {
            controllerByShadowRoot.forEach(function (_a) {
                var stop = _a.stop;
                return stop();
            });
        },
        flush: function () {
            controllerByShadowRoot.forEach(function (_a) {
                var flush = _a.flush;
                return flush();
            });
        },
    };
    return shadowRootsController;
};
exports.initShadowRootsController = initShadowRootsController;

},{"./observers":516,"@datadog/browser-core":432}],537:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPathToNestedCSSRule = exports.assembleIncrementalSnapshot = exports.isTouchEvent = void 0;
var browser_core_1 = require("@datadog/browser-core");
var types_1 = require("../../types");
function isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
exports.isTouchEvent = isTouchEvent;
function assembleIncrementalSnapshot(source, data) {
    return {
        data: (0, browser_core_1.assign)({
            source: source,
        }, data),
        type: types_1.RecordType.IncrementalSnapshot,
        timestamp: (0, browser_core_1.timeStampNow)(),
    };
}
exports.assembleIncrementalSnapshot = assembleIncrementalSnapshot;
function getPathToNestedCSSRule(rule) {
    var path = [];
    var currentRule = rule;
    while (currentRule.parentRule) {
        var rules_1 = Array.from(currentRule.parentRule.cssRules);
        var index_1 = rules_1.indexOf(currentRule);
        path.unshift(index_1);
        currentRule = currentRule.parentRule;
    }
    // A rule may not be attached to a stylesheet
    if (!currentRule.parentStyleSheet) {
        return;
    }
    var rules = Array.from(currentRule.parentStyleSheet.cssRules);
    var index = rules.indexOf(currentRule);
    path.unshift(index);
    return path;
}
exports.getPathToNestedCSSRule = getPathToNestedCSSRule;

},{"../../types":547,"@datadog/browser-core":432}],538:[function(require,module,exports){
"use strict";
/**
 * Browsers have not standardized various dimension properties. Mobile devices typically report
 * dimensions in reference to the visual viewport, while desktop uses the layout viewport. For example,
 * Mobile Chrome will change innerWidth when a pinch zoom takes place, while Chrome Desktop (mac) will not.
 *
 * With the new Viewport API, we now calculate and normalize dimension properties to the layout viewport.
 * If the VisualViewport API is not supported by a browser, it isn't reasonably possible to detect or normalize
 * which viewport is being measured. Therefore these exported functions will fallback to assuming that the layout
 * viewport is being measured by the browser
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getScrollY = exports.getScrollX = exports.getVisualViewport = exports.convertMouseEventToLayoutCoordinates = void 0;
// Scrollbar widths vary across properties on different devices and browsers
var TOLERANCE = 25;
/**
 * Use the Visual Viewport API's properties to measure scrollX/Y in reference to the layout viewport
 * in order to determine if window.scrollX/Y is measuring the layout or visual viewport.
 * This finding corresponds to which viewport mouseEvent.clientX/Y and window.innerWidth/Height measures.
 */
function isVisualViewportFactoredIn() {
    var visual = window.visualViewport;
    return (Math.abs(visual.pageTop - visual.offsetTop - window.scrollY) > TOLERANCE ||
        Math.abs(visual.pageLeft - visual.offsetLeft - window.scrollX) > TOLERANCE);
}
var convertMouseEventToLayoutCoordinates = function (clientX, clientY) {
    var visual = window.visualViewport;
    var normalised = {
        layoutViewportX: clientX,
        layoutViewportY: clientY,
        visualViewportX: clientX,
        visualViewportY: clientY,
    };
    if (!visual) {
        // On old browsers, we cannot normalise, so fallback to clientX/Y
        return normalised;
    }
    else if (isVisualViewportFactoredIn()) {
        // Typically Mobile Devices
        normalised.layoutViewportX = Math.round(clientX + visual.offsetLeft);
        normalised.layoutViewportY = Math.round(clientY + visual.offsetTop);
    }
    else {
        // Typically Desktop Devices
        normalised.visualViewportX = Math.round(clientX - visual.offsetLeft);
        normalised.visualViewportY = Math.round(clientY - visual.offsetTop);
    }
    return normalised;
};
exports.convertMouseEventToLayoutCoordinates = convertMouseEventToLayoutCoordinates;
var getVisualViewport = function () {
    var visual = window.visualViewport;
    return {
        scale: visual.scale,
        offsetLeft: visual.offsetLeft,
        offsetTop: visual.offsetTop,
        pageLeft: visual.pageLeft,
        pageTop: visual.pageTop,
        height: visual.height,
        width: visual.width,
    };
};
exports.getVisualViewport = getVisualViewport;
function getScrollX() {
    var scrollX;
    var visual = window.visualViewport;
    if (visual) {
        scrollX = visual.pageLeft - visual.offsetLeft;
    }
    else if (window.scrollX !== undefined) {
        scrollX = window.scrollX;
    }
    else {
        scrollX = window.pageXOffset || 0;
    }
    return Math.round(scrollX);
}
exports.getScrollX = getScrollX;
function getScrollY() {
    var scrollY;
    var visual = window.visualViewport;
    if (visual) {
        scrollY = visual.pageTop - visual.offsetTop;
    }
    else if (window.scrollY !== undefined) {
        scrollY = window.scrollY;
    }
    else {
        scrollY = window.pageYOffset || 0;
    }
    return Math.round(scrollY);
}
exports.getScrollY = getScrollY;

},{}],539:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetReplayStats = exports.getReplayStats = exports.addWroteData = exports.addRecord = exports.addSegment = exports.getSegmentsCount = exports.MAX_STATS_HISTORY = void 0;
exports.MAX_STATS_HISTORY = 10;
var statsPerView;
function getSegmentsCount(viewId) {
    return getOrCreateReplayStats(viewId).segments_count;
}
exports.getSegmentsCount = getSegmentsCount;
function addSegment(viewId) {
    getOrCreateReplayStats(viewId).segments_count += 1;
}
exports.addSegment = addSegment;
function addRecord(viewId) {
    getOrCreateReplayStats(viewId).records_count += 1;
}
exports.addRecord = addRecord;
function addWroteData(viewId, additionalBytesCount) {
    getOrCreateReplayStats(viewId).segments_total_raw_size += additionalBytesCount;
}
exports.addWroteData = addWroteData;
function getReplayStats(viewId) {
    return statsPerView === null || statsPerView === void 0 ? void 0 : statsPerView.get(viewId);
}
exports.getReplayStats = getReplayStats;
function resetReplayStats() {
    statsPerView = undefined;
}
exports.resetReplayStats = resetReplayStats;
function getOrCreateReplayStats(viewId) {
    if (!statsPerView) {
        statsPerView = new Map();
    }
    var replayStats;
    if (statsPerView.has(viewId)) {
        replayStats = statsPerView.get(viewId);
    }
    else {
        replayStats = {
            records_count: 0,
            segments_count: 0,
            segments_total_raw_size: 0,
        };
        statsPerView.set(viewId, replayStats);
        if (statsPerView.size > exports.MAX_STATS_HISTORY) {
            deleteOldestStats();
        }
    }
    return replayStats;
}
function deleteOldestStats() {
    if (!statsPerView) {
        return;
    }
    if (statsPerView.keys) {
        statsPerView.delete(statsPerView.keys().next().value);
    }
    else {
        // IE11 doesn't support map.keys
        var isFirst_1 = true;
        statsPerView.forEach(function (_value, key) {
            if (isFirst_1) {
                statsPerView.delete(key);
                isFirst_1 = false;
            }
        });
    }
}

},{}],540:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toFormEntries = exports.buildReplayPayload = void 0;
var browser_core_1 = require("@datadog/browser-core");
function buildReplayPayload(data, metadata, rawSegmentBytesCount) {
    var formData = new FormData();
    formData.append('segment', new Blob([data], {
        type: 'application/octet-stream',
    }), "".concat(metadata.session.id, "-").concat(metadata.start));
    toFormEntries(metadata, function (key, value) { return formData.append(key, value); });
    formData.append('raw_segment_size', rawSegmentBytesCount.toString());
    return { data: formData, bytesCount: data.byteLength };
}
exports.buildReplayPayload = buildReplayPayload;
function toFormEntries(input, onEntry, prefix) {
    if (prefix === void 0) { prefix = ''; }
    (0, browser_core_1.objectEntries)(input).forEach(function (_a) {
        var key = _a[0], value = _a[1];
        if (typeof value === 'object' && value !== null) {
            toFormEntries(value, onEntry, "".concat(prefix).concat(key, "."));
        }
        else {
            onEntry("".concat(prefix).concat(key), String(value));
        }
    });
}
exports.toFormEntries = toFormEntries;

},{"@datadog/browser-core":432}],541:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDeflateWorker = void 0;
var workerURL;
function createDeflateWorker() {
    // Lazily compute the worker URL to allow importing the SDK in NodeJS
    if (!workerURL) {
        workerURL = URL.createObjectURL(new Blob(["(".concat(workerCodeFn, ")(self)")]));
    }
    return new Worker(workerURL);
}
exports.createDeflateWorker = createDeflateWorker;
function workerCodeFn() {
    monitor(function () {
        var _a = makePakoDeflate(), Deflate = _a.Deflate, constants = _a.constants, string2buf = _a.string2buf;
        var deflate = new Deflate();
        var rawBytesCount = 0;
        self.addEventListener('message', monitor(function (event) {
            var data = event.data;
            switch (data.action) {
                case 'init':
                    self.postMessage({
                        type: 'initialized',
                    });
                    break;
                case 'write': {
                    var additionalBytesCount = pushData(data.data);
                    self.postMessage({
                        type: 'wrote',
                        id: data.id,
                        compressedBytesCount: deflate.chunks.reduce(function (total, chunk) { return total + chunk.length; }, 0),
                        additionalBytesCount: additionalBytesCount,
                    });
                    break;
                }
                case 'flush': {
                    var additionalBytesCount = data.data ? pushData(data.data) : 0;
                    deflate.push('', constants.Z_FINISH);
                    self.postMessage({
                        type: 'flushed',
                        id: data.id,
                        result: deflate.result,
                        additionalBytesCount: additionalBytesCount,
                        rawBytesCount: rawBytesCount,
                    });
                    deflate = new Deflate();
                    rawBytesCount = 0;
                    break;
                }
            }
        }));
        function pushData(data) {
            // TextEncoder is not supported on old browser version like Edge 18, therefore we use string2buf
            var binaryData = string2buf(data);
            deflate.push(binaryData, constants.Z_SYNC_FLUSH);
            rawBytesCount += binaryData.length;
            return binaryData.length;
        }
    })();
    function monitor(fn) {
        return function () {
            try {
                return fn.apply(this, arguments);
            }
            catch (e) {
                try {
                    self.postMessage({
                        type: 'errored',
                        error: e,
                    });
                }
                catch (_) {
                    // DATA_CLONE_ERR, cf https://developer.mozilla.org/en-US/docs/Web/API/Web_Workers_API/Structured_clone_algorithm
                    self.postMessage({
                        type: 'errored',
                        error: "".concat(e),
                    });
                }
            }
        };
    }
    // https://github.com/nodeca/pako/blob/034669ba0f1a4c0590e45f7c2820128200f972b3/dist/pako_deflate.es5.js
    function makePakoDeflate() {
        /* eslint-disable camelcase, no-bitwise */
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.
        /* Public constants ========================================================== */
        /* =========================================================================== */
        // const Z_FILTERED          = 1;
        // const Z_HUFFMAN_ONLY      = 2;
        // const Z_RLE               = 3;
        var Z_FIXED = 4; // const Z_DEFAULT_STRATEGY  = 0;
        /* Possible values of the data_type field (though see inflate()) */
        var Z_BINARY = 0;
        var Z_TEXT = 1; // const Z_ASCII             = 1; // = Z_TEXT
        var Z_UNKNOWN = 2;
        /* ============================================================================ */
        function zero(buf) {
            var len = buf.length;
            while (--len >= 0) {
                buf[len] = 0;
            }
        } // From zutil.h
        var STORED_BLOCK = 0;
        var STATIC_TREES = 1;
        var DYN_TREES = 2;
        /* The three kinds of block type */
        var MIN_MATCH = 3;
        var MAX_MATCH = 258;
        /* The minimum and maximum match lengths */
        // From deflate.h
        /* ===========================================================================
         * Internal compression state.
         */
        var LENGTH_CODES = 29;
        /* number of length codes, not counting the special END_BLOCK code */
        var LITERALS = 256;
        /* number of literal bytes 0..255 */
        var L_CODES = LITERALS + 1 + LENGTH_CODES;
        /* number of Literal or Length codes, including the END_BLOCK code */
        var D_CODES = 30;
        /* number of distance codes */
        var BL_CODES = 19;
        /* number of codes used to transfer the bit lengths */
        var HEAP_SIZE = 2 * L_CODES + 1;
        /* maximum heap size */
        var MAX_BITS = 15;
        /* All codes must not exceed MAX_BITS bits */
        var Buf_size = 16;
        /* size of bit buffer in bi_buf */
        /* ===========================================================================
         * Constants
         */
        var MAX_BL_BITS = 7;
        /* Bit length codes must not exceed MAX_BL_BITS bits */
        var END_BLOCK = 256;
        /* end of block literal code */
        var REP_3_6 = 16;
        /* repeat previous bit length 3-6 times (2 bits of repeat count) */
        var REPZ_3_10 = 17;
        /* repeat a zero length 3-10 times  (3 bits of repeat count) */
        var REPZ_11_138 = 18;
        /* repeat a zero length 11-138 times  (7 bits of repeat count) */
        var extra_lbits = 
        /* extra bits for each length code */
        new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0]);
        var extra_dbits = 
        /* extra bits for each distance code */
        new Uint8Array([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13]);
        var extra_blbits = 
        /* extra bits for each bit length code */
        new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7]);
        var bl_order = new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
        /* eslint-enable comma-spacing,array-bracket-spacing */
        /* The lengths of the bit length codes are sent in order of decreasing
         * probability, to avoid transmitting the lengths for unused bit length codes.
         */
        /* ===========================================================================
         * Local data. These are initialized only once.
         */
        // We pre-fill arrays with 0 to avoid uninitialized gaps
        var DIST_CODE_LEN = 512;
        /* see definition of array dist_code below */
        // !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
        var static_ltree = new Array((L_CODES + 2) * 2);
        zero(static_ltree);
        /* The static literal tree. Since the bit lengths are imposed, there is no
         * need for the L_CODES extra codes used during heap construction. However
         * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
         * below).
         */
        var static_dtree = new Array(D_CODES * 2);
        zero(static_dtree);
        /* The static distance tree. (Actually a trivial tree since all codes use
         * 5 bits.)
         */
        var _dist_code = new Array(DIST_CODE_LEN);
        zero(_dist_code);
        /* Distance codes. The first 256 values correspond to the distances
         * 3 .. 258, the last 256 values correspond to the top 8 bits of
         * the 15 bit distances.
         */
        var _length_code = new Array(MAX_MATCH - MIN_MATCH + 1);
        zero(_length_code);
        /* length code for each normalized match length (0 == MIN_MATCH) */
        var base_length = new Array(LENGTH_CODES);
        zero(base_length);
        /* First normalized length for each code (0 = MIN_MATCH) */
        var base_dist = new Array(D_CODES);
        zero(base_dist);
        /* First normalized distance for each code (0 = distance of 1) */
        function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
            this.static_tree = static_tree;
            /* static tree or NULL */
            this.extra_bits = extra_bits;
            /* extra bits for each code or NULL */
            this.extra_base = extra_base;
            /* base index for extra_bits */
            this.elems = elems;
            /* max number of elements in the tree */
            this.max_length = max_length;
            /* max bit length for the codes */
            // show if `static_tree` has data or dummy - needed for monomorphic objects
            this.has_stree = static_tree && static_tree.length;
        }
        var static_l_desc;
        var static_d_desc;
        var static_bl_desc;
        function TreeDesc(dyn_tree, stat_desc) {
            this.dyn_tree = dyn_tree;
            /* the dynamic tree */
            this.max_code = 0;
            /* largest code with non zero frequency */
            this.stat_desc = stat_desc;
            /* the corresponding static tree */
        }
        var d_code = function d_code(dist) {
            return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
        };
        /* ===========================================================================
         * Output a short LSB first on the stream.
         * IN assertion: there is enough room in pendingBuf.
         */
        var put_short = function put_short(s, w) {
            //    put_byte(s, (uch)((w) & 0xff));
            //    put_byte(s, (uch)((ush)(w) >> 8));
            s.pending_buf[s.pending++] = w & 0xff;
            s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
        };
        /* ===========================================================================
         * Send a value on a given number of bits.
         * IN assertion: length <= 16 and value fits in length bits.
         */
        var send_bits = function send_bits(s, value, length) {
            if (s.bi_valid > Buf_size - length) {
                s.bi_buf |= (value << s.bi_valid) & 0xffff;
                put_short(s, s.bi_buf);
                s.bi_buf = value >> (Buf_size - s.bi_valid);
                s.bi_valid += length - Buf_size;
            }
            else {
                s.bi_buf |= (value << s.bi_valid) & 0xffff;
                s.bi_valid += length;
            }
        };
        var send_code = function send_code(s, c, tree) {
            send_bits(s, tree[c * 2], 
            /* .Code */
            tree[c * 2 + 1]
            /* .Len */
            );
        };
        /* ===========================================================================
         * Reverse the first len bits of a code, using straightforward code (a faster
         * method would use a table)
         * IN assertion: 1 <= len <= 15
         */
        var bi_reverse = function bi_reverse(code, len) {
            var res = 0;
            do {
                res |= code & 1;
                code >>>= 1;
                res <<= 1;
            } while (--len > 0);
            return res >>> 1;
        };
        /* ===========================================================================
         * Flush the bit buffer, keeping at most 7 bits in it.
         */
        var bi_flush = function bi_flush(s) {
            if (s.bi_valid === 16) {
                put_short(s, s.bi_buf);
                s.bi_buf = 0;
                s.bi_valid = 0;
            }
            else if (s.bi_valid >= 8) {
                s.pending_buf[s.pending++] = s.bi_buf & 0xff;
                s.bi_buf >>= 8;
                s.bi_valid -= 8;
            }
        };
        /* ===========================================================================
         * Compute the optimal bit lengths for a tree and update the total bit length
         * for the current block.
         * IN assertion: the fields freq and dad are set, heap[heap_max] and
         *    above are the tree nodes sorted by increasing frequency.
         * OUT assertions: the field len is set to the optimal bit length, the
         *     array bl_count contains the frequencies for each bit length.
         *     The length opt_len is updated; static_len is also updated if stree is
         *     not null.
         */
        var gen_bitlen = function gen_bitlen(s, desc //    deflate_state *s; //    tree_desc *desc;    /* the tree descriptor */
        ) {
            var tree = desc.dyn_tree;
            var max_code = desc.max_code;
            var stree = desc.stat_desc.static_tree;
            var has_stree = desc.stat_desc.has_stree;
            var extra = desc.stat_desc.extra_bits;
            var base = desc.stat_desc.extra_base;
            var max_length = desc.stat_desc.max_length;
            var h;
            /* heap index */
            var n;
            var m;
            /* iterate over the tree elements */
            var bits;
            /* bit length */
            var xbits;
            /* extra bits */
            var f;
            /* frequency */
            var overflow = 0;
            /* number of elements with bit length too large */
            for (bits = 0; bits <= MAX_BITS; bits++) {
                s.bl_count[bits] = 0;
            }
            /* In a first pass, compute the optimal bit lengths (which may
             * overflow in the case of the bit length tree).
             */
            tree[s.heap[s.heap_max] * 2 + 1] =
                /* .Len */
                0;
            /* root of the heap */
            for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
                n = s.heap[h];
                bits =
                    tree[tree[n * 2 + 1] *
                        /* .Dad */
                        2 +
                        1] +
                        /* .Len */
                        1;
                if (bits > max_length) {
                    bits = max_length;
                    overflow++;
                }
                tree[n * 2 + 1] =
                    /* .Len */
                    bits;
                /* We overwrite tree[n].Dad which is no longer needed */
                if (n > max_code) {
                    continue;
                }
                /* not a leaf node */
                s.bl_count[bits]++;
                xbits = 0;
                if (n >= base) {
                    xbits = extra[n - base];
                }
                f = tree[n * 2];
                /* .Freq */
                s.opt_len += f * (bits + xbits);
                if (has_stree) {
                    s.static_len +=
                        f *
                            (stree[n * 2 + 1] +
                                /* .Len */
                                xbits);
                }
            }
            if (overflow === 0) {
                return;
            } // Trace((stderr,"\nbit length overflow\n"));
            /* This happens for example on obj2 and pic of the Calgary corpus */
            /* Find the first bit length which could increase: */
            do {
                bits = max_length - 1;
                while (s.bl_count[bits] === 0) {
                    bits--;
                }
                s.bl_count[bits]--;
                /* move one leaf down the tree */
                s.bl_count[bits + 1] += 2;
                /* move one overflow item as its brother */
                s.bl_count[max_length]--;
                /* The brother of the overflow item also moves one step up,
                 * but this does not affect bl_count[max_length]
                 */
                overflow -= 2;
            } while (overflow > 0);
            /* Now recompute all bit lengths, scanning in increasing frequency.
             * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
             * lengths instead of fixing only the wrong ones. This idea is taken
             * from 'ar' written by Haruhiko Okumura.)
             */
            for (bits = max_length; bits !== 0; bits--) {
                n = s.bl_count[bits];
                while (n !== 0) {
                    m = s.heap[--h];
                    if (m > max_code) {
                        continue;
                    }
                    if (tree[m * 2 + 1] !==
                        /* .Len */
                        bits) {
                        // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                        s.opt_len +=
                            (bits - tree[m * 2 + 1]) *
                                /* .Len */
                                tree[m * 2];
                        /* .Freq */
                        tree[m * 2 + 1] =
                            /* .Len */
                            bits;
                    }
                    n--;
                }
            }
        };
        /* ===========================================================================
         * Generate the codes for a given tree and bit counts (which need not be
         * optimal).
         * IN assertion: the array bl_count contains the bit length statistics for
         * the given tree and the field len is set for all tree elements.
         * OUT assertion: the field code is set for all tree elements of non
         *     zero code length.
         */
        var gen_codes = function gen_codes(tree, max_code, bl_count
        //    ct_data *tree;             /* the tree to decorate */
        //    int max_code;              /* largest code with non zero frequency */
        //    ushf *bl_count;            /* number of codes at each bit length */
        ) {
            var next_code = new Array(MAX_BITS + 1);
            /* next code value for each bit length */
            var code = 0;
            /* running code value */
            var bits;
            /* bit index */
            var n;
            /* code index */
            /* The distribution counts are first used to generate the code values
             * without bit reversal.
             */
            for (bits = 1; bits <= MAX_BITS; bits++) {
                next_code[bits] = code = (code + bl_count[bits - 1]) << 1;
            }
            /* Check that the bit counts in bl_count are consistent. The last code
             * must be all ones.
             */
            // Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
            //        "inconsistent bit counts");
            // Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
            for (n = 0; n <= max_code; n++) {
                var len = tree[n * 2 + 1];
                /* .Len */
                if (len === 0) {
                    continue;
                }
                /* Now reverse the bits */
                tree[n * 2] =
                    /* .Code */
                    bi_reverse(next_code[len]++, len); // Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
                //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
            }
        };
        /* ===========================================================================
         * Initialize the various 'constant' tables.
         */
        var tr_static_init = function tr_static_init() {
            var n;
            /* iterates over tree elements */
            var bits;
            /* bit counter */
            var length;
            /* length value */
            var code;
            /* code value */
            var dist;
            /* distance index */
            var bl_count = new Array(MAX_BITS + 1);
            /* number of codes at each bit length for an optimal tree */
            // do check in _tr_init()
            // if (static_init_done) return;
            /* For some embedded targets, global variables are not initialized: */
            /* #ifdef NO_INIT_GLOBAL_POINTERS
            static_l_desc.static_tree = static_ltree;
            static_l_desc.extra_bits = extra_lbits;
            static_d_desc.static_tree = static_dtree;
            static_d_desc.extra_bits = extra_dbits;
            static_bl_desc.extra_bits = extra_blbits;
          #endif */
            /* Initialize the mapping length (0..255) -> length code (0..28) */
            length = 0;
            for (code = 0; code < LENGTH_CODES - 1; code++) {
                base_length[code] = length;
                for (n = 0; n < 1 << extra_lbits[code]; n++) {
                    _length_code[length++] = code;
                }
            } // Assert (length == 256, "tr_static_init: length != 256");
            /* Note that the length 255 (match length 258) can be represented
             * in two different ways: code 284 + 5 bits or code 285, so we
             * overwrite length_code[255] to use the best encoding:
             */
            _length_code[length - 1] = code;
            /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
            dist = 0;
            for (code = 0; code < 16; code++) {
                base_dist[code] = dist;
                for (n = 0; n < 1 << extra_dbits[code]; n++) {
                    _dist_code[dist++] = code;
                }
            } // Assert (dist == 256, "tr_static_init: dist != 256");
            dist >>= 7;
            /* from now on, all distances are divided by 128 */
            for (; code < D_CODES; code++) {
                base_dist[code] = dist << 7;
                for (n = 0; n < 1 << (extra_dbits[code] - 7); n++) {
                    _dist_code[256 + dist++] = code;
                }
            } // Assert (dist == 256, "tr_static_init: 256+dist != 512");
            /* Construct the codes of the static literal tree */
            for (bits = 0; bits <= MAX_BITS; bits++) {
                bl_count[bits] = 0;
            }
            n = 0;
            while (n <= 143) {
                static_ltree[n * 2 + 1] =
                    /* .Len */
                    8;
                n++;
                bl_count[8]++;
            }
            while (n <= 255) {
                static_ltree[n * 2 + 1] =
                    /* .Len */
                    9;
                n++;
                bl_count[9]++;
            }
            while (n <= 279) {
                static_ltree[n * 2 + 1] =
                    /* .Len */
                    7;
                n++;
                bl_count[7]++;
            }
            while (n <= 287) {
                static_ltree[n * 2 + 1] =
                    /* .Len */
                    8;
                n++;
                bl_count[8]++;
            }
            /* Codes 286 and 287 do not exist, but we must include them in the
             * tree construction to get a canonical Huffman tree (longest code
             * all ones)
             */
            gen_codes(static_ltree, L_CODES + 1, bl_count);
            /* The static distance tree is trivial: */
            for (n = 0; n < D_CODES; n++) {
                static_dtree[n * 2 + 1] =
                    /* .Len */
                    5;
                static_dtree[n * 2] =
                    /* .Code */
                    bi_reverse(n, 5);
            } // Now data ready and we can init static trees
            static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
            static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0, D_CODES, MAX_BITS);
            static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0, BL_CODES, MAX_BL_BITS);
            // static_init_done = true;
        };
        /* ===========================================================================
         * Initialize a new block.
         */
        var init_block = function init_block(s) {
            var n;
            /* iterates over tree elements */
            /* Initialize the trees. */
            for (n = 0; n < L_CODES; n++) {
                s.dyn_ltree[n * 2] =
                    /* .Freq */
                    0;
            }
            for (n = 0; n < D_CODES; n++) {
                s.dyn_dtree[n * 2] =
                    /* .Freq */
                    0;
            }
            for (n = 0; n < BL_CODES; n++) {
                s.bl_tree[n * 2] =
                    /* .Freq */
                    0;
            }
            s.dyn_ltree[END_BLOCK * 2] =
                /* .Freq */
                1;
            s.opt_len = s.static_len = 0;
            s.last_lit = s.matches = 0;
        };
        /* ===========================================================================
         * Flush the bit buffer and align the output on a byte boundary
         */
        var bi_windup = function bi_windup(s) {
            if (s.bi_valid > 8) {
                put_short(s, s.bi_buf);
            }
            else if (s.bi_valid > 0) {
                // put_byte(s, (Byte)s->bi_buf);
                s.pending_buf[s.pending++] = s.bi_buf;
            }
            s.bi_buf = 0;
            s.bi_valid = 0;
        };
        /* ===========================================================================
         * Copy a stored block, storing first the length and its
         * one's complement if requested.
         */
        var copy_block = function copy_block(s, buf, len, header
        // DeflateState *s;
        // charf    *buf;    /* the input data */
        // unsigned len;     /* its length */
        // int      header;  /* true if block header must be written */
        ) {
            bi_windup(s);
            /* align on byte boundary */
            if (header) {
                put_short(s, len);
                put_short(s, ~len);
            }
            //  while (len--) {
            //    put_byte(s, *buf++);
            //  }
            s.pending_buf.set(s.window.subarray(buf, buf + len), s.pending);
            s.pending += len;
        };
        /* ===========================================================================
         * Compares to subtrees, using the tree depth as tie breaker when
         * the subtrees have equal frequency. This minimizes the worst case length.
         */
        var smaller = function smaller(tree, n, m, depth) {
            var _n2 = n * 2;
            var _m2 = m * 2;
            return (tree[_n2] <
                /* .Freq */
                tree[_m2] ||
                /* .Freq */
                (tree[_n2] ===
                    /* .Freq */
                    tree[_m2] &&
                    /* .Freq */
                    depth[n] <= depth[m]));
        };
        /* ===========================================================================
         * Restore the heap property by moving down the tree starting at node k,
         * exchanging a node with the smallest of its two sons if necessary, stopping
         * when the heap property is re-established (each father smaller than its
         * two sons).
         */
        var pqdownheap = function pqdownheap(s, tree, k
        //    deflate_state *s;
        //    ct_data *tree;  /* the tree to restore */
        //    int k;               /* node to move down */
        ) {
            var v = s.heap[k];
            var j = k << 1;
            /* left son of k */
            while (j <= s.heap_len) {
                /* Set j to the smallest of the two sons: */
                if (j < s.heap_len && smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
                    j++;
                }
                /* Exit if v is smaller than both sons */
                if (smaller(tree, v, s.heap[j], s.depth)) {
                    break;
                }
                /* Exchange v with the smallest son */
                s.heap[k] = s.heap[j];
                k = j;
                /* And continue down the tree, setting j to the left son of k */
                j <<= 1;
            }
            s.heap[k] = v;
        }; // inlined manually
        // const SMALLEST = 1;
        /* ===========================================================================
         * Send the block data compressed using the given Huffman trees
         */
        var compress_block = function compress_block(s, ltree, dtree
        //    deflate_state *s;
        //    const ct_data *ltree; /* literal tree */
        //    const ct_data *dtree; /* distance tree */
        ) {
            var dist;
            /* distance of matched string */
            var lc;
            /* match length or unmatched char (if dist == 0) */
            var lx = 0;
            /* running index in l_buf */
            var code;
            /* the code to send */
            var extra;
            /* number of extra bits to send */
            if (s.last_lit !== 0) {
                do {
                    dist = (s.pending_buf[s.d_buf + lx * 2] << 8) | s.pending_buf[s.d_buf + lx * 2 + 1];
                    lc = s.pending_buf[s.l_buf + lx];
                    lx++;
                    if (dist === 0) {
                        send_code(s, lc, ltree);
                        /* send a literal byte */
                        // Tracecv(isgraph(lc), (stderr," '%c' ", lc));
                    }
                    else {
                        /* Here, lc is the match length - MIN_MATCH */
                        code = _length_code[lc];
                        send_code(s, code + LITERALS + 1, ltree);
                        /* send the length code */
                        extra = extra_lbits[code];
                        if (extra !== 0) {
                            lc -= base_length[code];
                            send_bits(s, lc, extra);
                            /* send the extra length bits */
                        }
                        dist--;
                        /* dist is now the match distance - 1 */
                        code = d_code(dist); // Assert (code < D_CODES, "bad d_code");
                        send_code(s, code, dtree);
                        /* send the distance code */
                        extra = extra_dbits[code];
                        if (extra !== 0) {
                            dist -= base_dist[code];
                            send_bits(s, dist, extra);
                            /* send the extra distance bits */
                        }
                    }
                    /* literal or match pair ? */
                    /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
                    // Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
                    //       "pendingBuf overflow");
                } while (lx < s.last_lit);
            }
            send_code(s, END_BLOCK, ltree);
        };
        /* ===========================================================================
         * Construct one Huffman tree and assigns the code bit strings and lengths.
         * Update the total bit length for the current block.
         * IN assertion: the field freq is set for all tree elements.
         * OUT assertions: the fields len and code are set to the optimal bit length
         *     and corresponding code. The length opt_len is updated; static_len is
         *     also updated if stree is not null. The field max_code is set.
         */
        var build_tree = function build_tree(s, desc //    deflate_state *s; //    tree_desc *desc; /* the tree descriptor */
        ) {
            var tree = desc.dyn_tree;
            var stree = desc.stat_desc.static_tree;
            var has_stree = desc.stat_desc.has_stree;
            var elems = desc.stat_desc.elems;
            var n;
            var m;
            /* iterate over heap elements */
            var max_code = -1;
            /* largest code with non zero frequency */
            var node;
            /* new node being created */
            /* Construct the initial heap, with least frequent element in
             * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
             * heap[0] is not used.
             */
            s.heap_len = 0;
            s.heap_max = HEAP_SIZE;
            for (n = 0; n < elems; n++) {
                if (tree[n * 2] !==
                    /* .Freq */
                    0) {
                    s.heap[++s.heap_len] = max_code = n;
                    s.depth[n] = 0;
                }
                else {
                    tree[n * 2 + 1] =
                        /* .Len */
                        0;
                }
            }
            /* The pkzip format requires that at least one distance code exists,
             * and that at least one bit should be sent even if there is only one
             * possible code. So to avoid special checks later on we force at least
             * two codes of non zero frequency.
             */
            while (s.heap_len < 2) {
                node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
                tree[node * 2] =
                    /* .Freq */
                    1;
                s.depth[node] = 0;
                s.opt_len--;
                if (has_stree) {
                    s.static_len -= stree[node * 2 + 1];
                    /* .Len */
                }
                /* node is 0 or 1 so it does not have extra bits */
            }
            desc.max_code = max_code;
            /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
             * establish sub-heaps of increasing lengths:
             */
            for (n = s.heap_len >> 1; 
            /* int /2 */
            n >= 1; n--) {
                pqdownheap(s, tree, n);
            }
            /* Construct the Huffman tree by repeatedly combining the least two
             * frequent nodes.
             */
            node = elems;
            /* next internal node of the tree */
            do {
                // pqremove(s, tree, n);  /* n = node of least frequency */
                /** * pqremove ** */
                n = s.heap[1];
                /* SMALLEST */
                s.heap[1] = s.heap[s.heap_len--];
                /* SMALLEST */
                pqdownheap(s, tree, 1
                /* SMALLEST */
                );
                /***/
                m = s.heap[1];
                /* SMALLEST */
                /* m = node of next least frequency */
                s.heap[--s.heap_max] = n;
                /* keep the nodes sorted by frequency */
                s.heap[--s.heap_max] = m;
                /* Create a new node father of n and m */
                tree[node * 2] =
                    /* .Freq */
                    tree[n * 2] +
                        /* .Freq */
                        tree[m * 2];
                /* .Freq */
                s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
                tree[n * 2 + 1] =
                    /* .Dad */
                    tree[m * 2 + 1] =
                        /* .Dad */
                        node;
                /* and insert the new node in the heap */
                s.heap[1] = node++;
                /* SMALLEST */
                pqdownheap(s, tree, 1
                /* SMALLEST */
                );
            } while (s.heap_len >= 2);
            s.heap[--s.heap_max] = s.heap[1];
            /* SMALLEST */
            /* At this point, the fields freq and dad are set. We can now
             * generate the bit lengths.
             */
            gen_bitlen(s, desc);
            /* The field len is now set, we can generate the bit codes */
            gen_codes(tree, max_code, s.bl_count);
        };
        /* ===========================================================================
         * Scan a literal or distance tree to determine the frequencies of the codes
         * in the bit length tree.
         */
        var scan_tree = function scan_tree(s, tree, max_code
        //    deflate_state *s;
        //    ct_data *tree;   /* the tree to be scanned */
        //    int max_code;    /* and its largest code of non zero frequency */
        ) {
            var n;
            /* iterates over all tree elements */
            var prevlen = -1;
            /* last emitted length */
            var curlen;
            /* length of current code */
            var nextlen = tree[0 * 2 + 1];
            /* .Len */
            /* length of next code */
            var count = 0;
            /* repeat count of the current code */
            var max_count = 7;
            /* max repeat count */
            var min_count = 4;
            /* min repeat count */
            if (nextlen === 0) {
                max_count = 138;
                min_count = 3;
            }
            tree[(max_code + 1) * 2 + 1] =
                /* .Len */
                0xffff;
            /* guard */
            for (n = 0; n <= max_code; n++) {
                curlen = nextlen;
                nextlen = tree[(n + 1) * 2 + 1];
                /* .Len */
                if (++count < max_count && curlen === nextlen) {
                    continue;
                }
                else if (count < min_count) {
                    s.bl_tree[curlen * 2] +=
                        /* .Freq */
                        count;
                }
                else if (curlen !== 0) {
                    if (curlen !== prevlen) {
                        s.bl_tree[curlen * 2] /* .Freq */++;
                    }
                    s.bl_tree[REP_3_6 * 2] /* .Freq */++;
                }
                else if (count <= 10) {
                    s.bl_tree[REPZ_3_10 * 2] /* .Freq */++;
                }
                else {
                    s.bl_tree[REPZ_11_138 * 2] /* .Freq */++;
                }
                count = 0;
                prevlen = curlen;
                if (nextlen === 0) {
                    max_count = 138;
                    min_count = 3;
                }
                else if (curlen === nextlen) {
                    max_count = 6;
                    min_count = 3;
                }
                else {
                    max_count = 7;
                    min_count = 4;
                }
            }
        };
        /* ===========================================================================
         * Send a literal or distance tree in compressed form, using the codes in
         * bl_tree.
         */
        var send_tree = function send_tree(s, tree, max_code
        //    deflate_state *s;
        //    ct_data *tree; /* the tree to be scanned */
        //    int max_code;       /* and its largest code of non zero frequency */
        ) {
            var n;
            /* iterates over all tree elements */
            var prevlen = -1;
            /* last emitted length */
            var curlen;
            /* length of current code */
            var nextlen = tree[0 * 2 + 1];
            /* .Len */
            /* length of next code */
            var count = 0;
            /* repeat count of the current code */
            var max_count = 7;
            /* max repeat count */
            var min_count = 4;
            /* min repeat count */
            /* tree[max_code+1].Len = -1; */
            /* guard already set */
            if (nextlen === 0) {
                max_count = 138;
                min_count = 3;
            }
            for (n = 0; n <= max_code; n++) {
                curlen = nextlen;
                nextlen = tree[(n + 1) * 2 + 1];
                /* .Len */
                if (++count < max_count && curlen === nextlen) {
                    continue;
                }
                else if (count < min_count) {
                    do {
                        send_code(s, curlen, s.bl_tree);
                    } while (--count !== 0);
                }
                else if (curlen !== 0) {
                    if (curlen !== prevlen) {
                        send_code(s, curlen, s.bl_tree);
                        count--;
                    } // Assert(count >= 3 && count <= 6, " 3_6?");
                    send_code(s, REP_3_6, s.bl_tree);
                    send_bits(s, count - 3, 2);
                }
                else if (count <= 10) {
                    send_code(s, REPZ_3_10, s.bl_tree);
                    send_bits(s, count - 3, 3);
                }
                else {
                    send_code(s, REPZ_11_138, s.bl_tree);
                    send_bits(s, count - 11, 7);
                }
                count = 0;
                prevlen = curlen;
                if (nextlen === 0) {
                    max_count = 138;
                    min_count = 3;
                }
                else if (curlen === nextlen) {
                    max_count = 6;
                    min_count = 3;
                }
                else {
                    max_count = 7;
                    min_count = 4;
                }
            }
        };
        /* ===========================================================================
         * Construct the Huffman tree for the bit lengths and return the index in
         * bl_order of the last bit length code to send.
         */
        var build_bl_tree = function build_bl_tree(s) {
            var max_blindex;
            /* index of last bit length code of non zero freq */
            /* Determine the bit length frequencies for literal and distance trees */
            scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
            scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
            /* Build the bit length tree: */
            build_tree(s, s.bl_desc);
            /* opt_len now includes the length of the tree representations, except
             * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
             */
            /* Determine the number of bit length codes to send. The pkzip format
             * requires that at least 4 bit length codes be sent. (appnote.txt says
             * 3 but the actual value used is 4.)
             */
            for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
                if (s.bl_tree[bl_order[max_blindex] * 2 + 1] !==
                    /* .Len */
                    0) {
                    break;
                }
            }
            /* Update opt_len to include the bit length tree and counts */
            s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4; // Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
            //        s->opt_len, s->static_len));
            return max_blindex;
        };
        /* ===========================================================================
         * Send the header for a block using dynamic Huffman trees: the counts, the
         * lengths of the bit length codes, the literal tree and the distance tree.
         * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
         */
        var send_all_trees = function send_all_trees(s, lcodes, dcodes, blcodes //    deflate_state *s; //    int lcodes, dcodes, blcodes; /* number of codes for each tree */
        ) {
            var rank;
            /* index in bl_order */
            // Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
            // Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
            //        "too many codes");
            // Tracev((stderr, "\nbl counts: "));
            send_bits(s, lcodes - 257, 5);
            /* not +255 as stated in appnote.txt */
            send_bits(s, dcodes - 1, 5);
            send_bits(s, blcodes - 4, 4);
            /* not -3 as stated in appnote.txt */
            for (rank = 0; rank < blcodes; rank++) {
                // Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
                send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1], 
                /* .Len */
                3);
            } // Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
            send_tree(s, s.dyn_ltree, lcodes - 1);
            /* literal tree */
            // Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
            send_tree(s, s.dyn_dtree, dcodes - 1);
            /* distance tree */
            // Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
        };
        /* ===========================================================================
         * Check if the data type is TEXT or BINARY, using the following algorithm:
         * - TEXT if the two conditions below are satisfied:
         *    a) There are no non-portable control characters belonging to the
         *       "black list" (0..6, 14..25, 28..31).
         *    b) There is at least one printable character belonging to the
         *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
         * - BINARY otherwise.
         * - The following partially-portable control characters form a
         *   "gray list" that is ignored in this detection algorithm:
         *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
         * IN assertion: the fields Freq of dyn_ltree are set.
         */
        var detect_data_type = function detect_data_type(s) {
            /* black_mask is the bit mask of black-listed bytes
             * set bits 0..6, 14..25, and 28..31
             * 0xf3ffc07f = binary 11110011111111111100000001111111
             */
            var black_mask = 0xf3ffc07f;
            var n;
            /* Check for non-textual ("black-listed") bytes. */
            for (n = 0; n <= 31; n++, black_mask >>>= 1) {
                if (black_mask & 1 &&
                    s.dyn_ltree[n * 2] !==
                        /* .Freq */
                        0) {
                    return Z_BINARY;
                }
            }
            /* Check for textual ("white-listed") bytes. */
            if (s.dyn_ltree[9 * 2] !==
                /* .Freq */
                0 ||
                s.dyn_ltree[10 * 2] !==
                    /* .Freq */
                    0 ||
                s.dyn_ltree[13 * 2] !==
                    /* .Freq */
                    0) {
                return Z_TEXT;
            }
            for (n = 32; n < LITERALS; n++) {
                if (s.dyn_ltree[n * 2] !==
                    /* .Freq */
                    0) {
                    return Z_TEXT;
                }
            }
            /* There are no "black-listed" or "white-listed" bytes:
             * this stream either is empty or has tolerated ("gray-listed") bytes only.
             */
            return Z_BINARY;
        };
        var static_init_done = false;
        /* ===========================================================================
         * Initialize the tree data structures for a new zlib stream.
         */
        var _tr_init = function _tr_init(s) {
            if (!static_init_done) {
                tr_static_init();
                static_init_done = true;
            }
            s.l_desc = new TreeDesc(s.dyn_ltree, static_l_desc);
            s.d_desc = new TreeDesc(s.dyn_dtree, static_d_desc);
            s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);
            s.bi_buf = 0;
            s.bi_valid = 0;
            /* Initialize the first block of the first file: */
            init_block(s);
        };
        /* ===========================================================================
         * Send a stored block
         */
        var _tr_stored_block = function _tr_stored_block(s, buf, stored_len, last
        // DeflateState *s;
        // charf *buf;       /* input block */
        // ulg stored_len;   /* length of input block */
        // int last;         /* one if this is the last block for a file */
        ) {
            send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);
            /* send block type */
            copy_block(s, buf, stored_len, true);
            /* with header */
        };
        /* ===========================================================================
         * Send one empty static block to give enough lookahead for inflate.
         * This takes 10 bits, of which 7 may remain in the bit buffer.
         */
        var _tr_align = function _tr_align(s) {
            send_bits(s, STATIC_TREES << 1, 3);
            send_code(s, END_BLOCK, static_ltree);
            bi_flush(s);
        };
        /* ===========================================================================
         * Determine the best encoding for the current block: dynamic trees, static
         * trees or store, and output the encoded block to the zip file.
         */
        var _tr_flush_block = function _tr_flush_block(s, buf, stored_len, last
        // DeflateState *s;
        // charf *buf;       /* input block, or NULL if too old */
        // ulg stored_len;   /* length of input block */
        // int last;         /* one if this is the last block for a file */
        ) {
            var opt_lenb;
            var static_lenb;
            /* opt_len and static_len in bytes */
            var max_blindex = 0;
            /* index of last bit length code of non zero freq */
            /* Build the Huffman trees unless a stored block is forced */
            if (s.level > 0) {
                /* Check if the file is binary or text */
                if (s.strm.data_type === Z_UNKNOWN) {
                    s.strm.data_type = detect_data_type(s);
                }
                /* Construct the literal and distance trees */
                build_tree(s, s.l_desc); // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
                //        s->static_len));
                build_tree(s, s.d_desc); // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
                //        s->static_len));
                /* At this point, opt_len and static_len are the total bit lengths of
                 * the compressed block data, excluding the tree representations.
                 */
                /* Build the bit length tree for the above two trees, and get the index
                 * in bl_order of the last bit length code to send.
                 */
                max_blindex = build_bl_tree(s);
                /* Determine the best encoding. Compute the block lengths in bytes. */
                opt_lenb = (s.opt_len + 3 + 7) >>> 3;
                static_lenb = (s.static_len + 3 + 7) >>> 3; // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
                //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
                //        s->last_lit));
                if (static_lenb <= opt_lenb) {
                    opt_lenb = static_lenb;
                }
            }
            else {
                // Assert(buf != (char*)0, "lost buf");
                opt_lenb = static_lenb = stored_len + 5;
                /* force a stored block */
            }
            if (stored_len + 4 <= opt_lenb && buf !== -1) {
                /* 4: two words for the lengths */
                /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
                 * Otherwise we can't have processed more than WSIZE input bytes since
                 * the last block flush, because compression would have been
                 * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
                 * transform a block into a stored block.
                 */
                _tr_stored_block(s, buf, stored_len, last);
            }
            else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {
                send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
                compress_block(s, static_ltree, static_dtree);
            }
            else {
                send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
                send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
                compress_block(s, s.dyn_ltree, s.dyn_dtree);
            } // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
            /* The above check is made mod 2^32, for files larger than 512 MB
             * and uLong implemented on 32 bits.
             */
            init_block(s);
            if (last) {
                bi_windup(s);
            } // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
            //       s->compressed_len-7*last));
        };
        /* ===========================================================================
         * Save the match info and tally the frequency counts. Return true if
         * the current block must be flushed.
         */
        var _tr_tally = function _tr_tally(s, dist, lc
        //    deflate_state *s;
        //    unsigned dist;  /* distance of matched string */
        //    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
        ) {
            // let out_length, in_length, dcode;
            s.pending_buf[s.d_buf + s.last_lit * 2] = (dist >>> 8) & 0xff;
            s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
            s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
            s.last_lit++;
            if (dist === 0) {
                /* lc is the unmatched char */
                s.dyn_ltree[lc * 2] /* .Freq */++;
            }
            else {
                s.matches++;
                /* Here, lc is the match length - MIN_MATCH */
                dist--;
                /* dist = match distance - 1 */
                // Assert((ush)dist < (ush)MAX_DIST(s) &&
                //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
                //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
                s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2] /* .Freq */++;
                s.dyn_dtree[d_code(dist) * 2] /* .Freq */++;
            } // (!) This block is disabled in zlib defaults,
            // don't enable it for binary compatibility
            // #ifdef TRUNCATE_BLOCK
            //  /* Try to guess if it is profitable to stop the current block here */
            //  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
            //    /* Compute an upper bound for the compressed length */
            //    out_length = s.last_lit*8;
            //    in_length = s.strstart - s.block_start;
            //
            //    for (dcode = 0; dcode < D_CODES; dcode++) {
            //      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
            //    }
            //    out_length >>>= 3;
            //    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
            //    //       s->last_lit, in_length, out_length,
            //    //       100L - out_length*100L/in_length));
            //    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
            //      return true;
            //    }
            //  }
            // #endif
            return s.last_lit === s.lit_bufsize - 1;
            /* We avoid equality with lit_bufsize because of wraparound at 64K
             * on 16 bit machines and because stored blocks are restricted to
             * 64K-1 bytes.
             */
        };
        var _tr_init_1 = _tr_init;
        var _tr_stored_block_1 = _tr_stored_block;
        var _tr_flush_block_1 = _tr_flush_block;
        var _tr_tally_1 = _tr_tally;
        var _tr_align_1 = _tr_align;
        var trees = {
            _tr_init: _tr_init_1,
            _tr_stored_block: _tr_stored_block_1,
            _tr_flush_block: _tr_flush_block_1,
            _tr_tally: _tr_tally_1,
            _tr_align: _tr_align_1,
        };
        // It isn't worth it to make additional optimizations as in original.
        // Small size is preferable.
        // (C) 1995-2013 Jean-loup Gailly and Mark Adler
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.
        var adler32 = function adler32(adler, buf, len, pos) {
            var s1 = (adler & 0xffff) | 0;
            var s2 = ((adler >>> 16) & 0xffff) | 0;
            var n = 0;
            while (len !== 0) {
                // Set limit ~ twice less than 5552, to keep
                // s2 in 31-bits, because we force signed ints.
                // in other case %= will fail.
                n = len > 2000 ? 2000 : len;
                len -= n;
                do {
                    s1 = (s1 + buf[pos++]) | 0;
                    s2 = (s2 + s1) | 0;
                } while (--n);
                s1 %= 65521;
                s2 %= 65521;
            }
            return s1 | (s2 << 16) | 0;
        };
        var adler32_1 = adler32;
        // So write code to minimize size - no pregenerated tables
        // and array tools dependencies.
        // (C) 1995-2013 Jean-loup Gailly and Mark Adler
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.
        // Use ordinary array, since untyped makes no boost here
        var makeTable = function makeTable() {
            var c;
            var table = [];
            for (var n = 0; n < 256; n++) {
                c = n;
                for (var k = 0; k < 8; k++) {
                    c = c & 1 ? 0xedb88320 ^ (c >>> 1) : c >>> 1;
                }
                table[n] = c;
            }
            return table;
        }; // Create table on load. Just 255 signed longs. Not a problem.
        var crcTable = new Uint32Array(makeTable());
        var crc32 = function crc32(crc, buf, len, pos) {
            var t = crcTable;
            var end = pos + len;
            crc ^= -1;
            for (var i = pos; i < end; i++) {
                crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xff];
            }
            return crc ^ -1; // >>> 0;
        };
        var crc32_1 = crc32;
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.
        var messages = {
            2: 'need dictionary',
            /* Z_NEED_DICT       2  */
            1: 'stream end',
            /* Z_STREAM_END      1  */
            0: '',
            /* Z_OK              0  */
            '-1': 'file error',
            /* Z_ERRNO         (-1) */
            '-2': 'stream error',
            /* Z_STREAM_ERROR  (-2) */
            '-3': 'data error',
            /* Z_DATA_ERROR    (-3) */
            '-4': 'insufficient memory',
            /* Z_MEM_ERROR     (-4) */
            '-5': 'buffer error',
            /* Z_BUF_ERROR     (-5) */
            '-6': 'incompatible version',
            /* Z_VERSION_ERROR (-6) */
        };
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.
        var constants = {
            /* Allowed flush values; see deflate() and inflate() below for details */
            Z_NO_FLUSH: 0,
            Z_PARTIAL_FLUSH: 1,
            Z_SYNC_FLUSH: 2,
            Z_FULL_FLUSH: 3,
            Z_FINISH: 4,
            Z_BLOCK: 5,
            Z_TREES: 6,
            /* Return codes for the compression/decompression functions. Negative values
             * are errors, positive values are used for special but normal events.
             */
            Z_OK: 0,
            Z_STREAM_END: 1,
            Z_NEED_DICT: 2,
            Z_ERRNO: -1,
            Z_STREAM_ERROR: -2,
            Z_DATA_ERROR: -3,
            Z_MEM_ERROR: -4,
            Z_BUF_ERROR: -5,
            // Z_VERSION_ERROR: -6,
            /* compression levels */
            Z_NO_COMPRESSION: 0,
            Z_BEST_SPEED: 1,
            Z_BEST_COMPRESSION: 9,
            Z_DEFAULT_COMPRESSION: -1,
            Z_FILTERED: 1,
            Z_HUFFMAN_ONLY: 2,
            Z_RLE: 3,
            Z_FIXED: 4,
            Z_DEFAULT_STRATEGY: 0,
            /* Possible values of the data_type field (though see inflate()) */
            Z_BINARY: 0,
            Z_TEXT: 1,
            // Z_ASCII:                1, // = Z_TEXT (deprecated)
            Z_UNKNOWN: 2,
            /* The deflate compression method */
            Z_DEFLATED: 8, // Z_NULL:                 null // Use -1 or null inline, depending on var type
        };
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.
        var _tr_init$1 = trees._tr_init;
        var _tr_stored_block$1 = trees._tr_stored_block;
        var _tr_flush_block$1 = trees._tr_flush_block;
        var _tr_tally$1 = trees._tr_tally;
        var _tr_align$1 = trees._tr_align;
        /* Public constants ========================================================== */
        /* =========================================================================== */
        var Z_NO_FLUSH = constants.Z_NO_FLUSH;
        var Z_PARTIAL_FLUSH = constants.Z_PARTIAL_FLUSH;
        var Z_FULL_FLUSH = constants.Z_FULL_FLUSH;
        var Z_FINISH = constants.Z_FINISH;
        var Z_BLOCK = constants.Z_BLOCK;
        var Z_OK = constants.Z_OK;
        var Z_STREAM_END = constants.Z_STREAM_END;
        var Z_STREAM_ERROR = constants.Z_STREAM_ERROR;
        var Z_DATA_ERROR = constants.Z_DATA_ERROR;
        var Z_BUF_ERROR = constants.Z_BUF_ERROR;
        var Z_DEFAULT_COMPRESSION = constants.Z_DEFAULT_COMPRESSION;
        var Z_FILTERED = constants.Z_FILTERED;
        var Z_HUFFMAN_ONLY = constants.Z_HUFFMAN_ONLY;
        var Z_RLE = constants.Z_RLE;
        var Z_FIXED$1 = constants.Z_FIXED;
        var Z_DEFAULT_STRATEGY = constants.Z_DEFAULT_STRATEGY;
        var Z_UNKNOWN$1 = constants.Z_UNKNOWN;
        var Z_DEFLATED = constants.Z_DEFLATED;
        /* ============================================================================ */
        var MAX_MEM_LEVEL = 9;
        /* Maximum value for memLevel in deflateInit2 */
        var MAX_WBITS = 15;
        /* 32K LZ77 window */
        var DEF_MEM_LEVEL = 8;
        var LENGTH_CODES$1 = 29;
        /* number of length codes, not counting the special END_BLOCK code */
        var LITERALS$1 = 256;
        /* number of literal bytes 0..255 */
        var L_CODES$1 = LITERALS$1 + 1 + LENGTH_CODES$1;
        /* number of Literal or Length codes, including the END_BLOCK code */
        var D_CODES$1 = 30;
        /* number of distance codes */
        var BL_CODES$1 = 19;
        /* number of codes used to transfer the bit lengths */
        var HEAP_SIZE$1 = 2 * L_CODES$1 + 1;
        /* maximum heap size */
        var MAX_BITS$1 = 15;
        /* All codes must not exceed MAX_BITS bits */
        var MIN_MATCH$1 = 3;
        var MAX_MATCH$1 = 258;
        var MIN_LOOKAHEAD = MAX_MATCH$1 + MIN_MATCH$1 + 1;
        var PRESET_DICT = 0x20;
        var INIT_STATE = 42;
        var EXTRA_STATE = 69;
        var NAME_STATE = 73;
        var COMMENT_STATE = 91;
        var HCRC_STATE = 103;
        var BUSY_STATE = 113;
        var FINISH_STATE = 666;
        var BS_NEED_MORE = 1;
        /* block not completed, need more input or more output */
        var BS_BLOCK_DONE = 2;
        /* block flush performed */
        var BS_FINISH_STARTED = 3;
        /* finish started, need only more output at next deflate */
        var BS_FINISH_DONE = 4;
        /* finish done, accept no more input or output */
        var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
        var err = function err(strm, errorCode) {
            strm.msg = messages[errorCode];
            return errorCode;
        };
        var rank = function rank(f) {
            return (f << 1) - (f > 4 ? 9 : 0);
        };
        var zero$1 = function zero(buf) {
            var len = buf.length;
            while (--len >= 0) {
                buf[len] = 0;
            }
        };
        var HASH_ZLIB = function HASH_ZLIB(s, prev, data) {
            return ((prev << s.hash_shift) ^ data) & s.hash_mask;
        }; // This hash causes less collisions, https://github.com/nodeca/pako/issues/135
        // But breaks binary compatibility
        // let HASH_FAST = (s, prev, data) => ((prev << 8) + (prev >> 8) + (data << 4)) & s.hash_mask;
        var HASH = HASH_ZLIB;
        /* =========================================================================
         * Flush as much pending output as possible. All deflate() output goes
         * through this function so some applications may wish to modify it
         * to avoid allocating a large strm->output buffer and copying into it.
         * (See also read_buf()).
         */
        var flush_pending = function flush_pending(strm) {
            var s = strm.state; // _tr_flush_bits(s);
            var len = s.pending;
            if (len > strm.avail_out) {
                len = strm.avail_out;
            }
            if (len === 0) {
                return;
            }
            strm.output.set(s.pending_buf.subarray(s.pending_out, s.pending_out + len), strm.next_out);
            strm.next_out += len;
            s.pending_out += len;
            strm.total_out += len;
            strm.avail_out -= len;
            s.pending -= len;
            if (s.pending === 0) {
                s.pending_out = 0;
            }
        };
        var flush_block_only = function flush_block_only(s, last) {
            _tr_flush_block$1(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
            s.block_start = s.strstart;
            flush_pending(s.strm);
        };
        var put_byte = function put_byte(s, b) {
            s.pending_buf[s.pending++] = b;
        };
        /* =========================================================================
         * Put a short in the pending buffer. The 16-bit value is put in MSB order.
         * IN assertion: the stream state is correct and there is enough room in
         * pending_buf.
         */
        var putShortMSB = function putShortMSB(s, b) {
            //  put_byte(s, (Byte)(b >> 8));
            //  put_byte(s, (Byte)(b & 0xff));
            s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
            s.pending_buf[s.pending++] = b & 0xff;
        };
        /* ===========================================================================
         * Read a new buffer from the current input stream, update the adler32
         * and total number of bytes read.  All deflate() input goes through
         * this function so some applications may wish to modify it to avoid
         * allocating a large strm->input buffer and copying from it.
         * (See also flush_pending()).
         */
        var read_buf = function read_buf(strm, buf, start, size) {
            var len = strm.avail_in;
            if (len > size) {
                len = size;
            }
            if (len === 0) {
                return 0;
            }
            strm.avail_in -= len; // zmemcpy(buf, strm->next_in, len);
            buf.set(strm.input.subarray(strm.next_in, strm.next_in + len), start);
            if (strm.state.wrap === 1) {
                strm.adler = adler32_1(strm.adler, buf, len, start);
            }
            else if (strm.state.wrap === 2) {
                strm.adler = crc32_1(strm.adler, buf, len, start);
            }
            strm.next_in += len;
            strm.total_in += len;
            return len;
        };
        /* ===========================================================================
         * Set match_start to the longest match starting at the given string and
         * return its length. Matches shorter or equal to prev_length are discarded,
         * in which case the result is equal to prev_length and match_start is
         * garbage.
         * IN assertions: cur_match is the head of the hash chain for the current
         *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
         * OUT assertion: the match length is not greater than s->lookahead.
         */
        var longest_match = function longest_match(s, cur_match) {
            var chain_length = s.max_chain_length;
            /* max hash chain length */
            var scan = s.strstart;
            /* current string */
            var match;
            /* matched string */
            var len;
            /* length of current match */
            var best_len = s.prev_length;
            /* best match length so far */
            var nice_match = s.nice_match;
            /* stop if match long enough */
            var limit = s.strstart > s.w_size - MIN_LOOKAHEAD ? s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0;
            /* NIL */
            var _win = s.window; // shortcut
            var wmask = s.w_mask;
            var prev = s.prev;
            /* Stop when cur_match becomes <= limit. To simplify the code,
             * we prevent matches with the string of window index 0.
             */
            var strend = s.strstart + MAX_MATCH$1;
            var scan_end1 = _win[scan + best_len - 1];
            var scan_end = _win[scan + best_len];
            /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
             * It is easy to get rid of this optimization if necessary.
             */
            // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
            /* Do not waste too much time if we already have a good match: */
            if (s.prev_length >= s.good_match) {
                chain_length >>= 2;
            }
            /* Do not look for matches beyond the end of the input. This is necessary
             * to make deflate deterministic.
             */
            if (nice_match > s.lookahead) {
                nice_match = s.lookahead;
            } // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
            do {
                // Assert(cur_match < s->strstart, "no future");
                match = cur_match;
                /* Skip to next match if the match length cannot increase
                 * or if the match length is less than 2.  Note that the checks below
                 * for insufficient lookahead only occur occasionally for performance
                 * reasons.  Therefore uninitialized memory will be accessed, and
                 * conditional jumps will be made that depend on those values.
                 * However the length of the match is limited to the lookahead, so
                 * the output of deflate is not affected by the uninitialized values.
                 */
                if (_win[match + best_len] !== scan_end ||
                    _win[match + best_len - 1] !== scan_end1 ||
                    _win[match] !== _win[scan] ||
                    _win[++match] !== _win[scan + 1]) {
                    continue;
                }
                /* The check at best_len-1 can be removed because it will be made
                 * again later. (This heuristic is not always a win.)
                 * It is not necessary to compare scan[2] and match[2] since they
                 * are always equal when the other bytes match, given that
                 * the hash keys are equal and that HASH_BITS >= 8.
                 */
                scan += 2;
                match++; // Assert(*scan == *match, "match[2]?");
                /* We check for insufficient lookahead only every 8th comparison;
                 * the 256th check will be made at strstart+258.
                 */
                do {
                    /* jshint noempty:false */
                } while (_win[++scan] === _win[++match] &&
                    _win[++scan] === _win[++match] &&
                    _win[++scan] === _win[++match] &&
                    _win[++scan] === _win[++match] &&
                    _win[++scan] === _win[++match] &&
                    _win[++scan] === _win[++match] &&
                    _win[++scan] === _win[++match] &&
                    _win[++scan] === _win[++match] &&
                    scan < strend); // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
                len = MAX_MATCH$1 - (strend - scan);
                scan = strend - MAX_MATCH$1;
                if (len > best_len) {
                    s.match_start = cur_match;
                    best_len = len;
                    if (len >= nice_match) {
                        break;
                    }
                    scan_end1 = _win[scan + best_len - 1];
                    scan_end = _win[scan + best_len];
                }
            } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
            if (best_len <= s.lookahead) {
                return best_len;
            }
            return s.lookahead;
        };
        /* ===========================================================================
         * Fill the window when the lookahead becomes insufficient.
         * Updates strstart and lookahead.
         *
         * IN assertion: lookahead < MIN_LOOKAHEAD
         * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
         *    At least one byte has been read, or avail_in == 0; reads are
         *    performed for at least two bytes (required for the zip translate_eol
         *    option -- not supported here).
         */
        var fill_window = function fill_window(s) {
            var _w_size = s.w_size;
            var p;
            var n;
            var m;
            var more;
            var str; // Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
            do {
                more = s.window_size - s.lookahead - s.strstart; // JS ints have 32 bit, block below not needed
                /* Deal with !@#$% 64K limit: */
                // if (sizeof(int) <= 2) {
                //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
                //        more = wsize;
                //
                //  } else if (more == (unsigned)(-1)) {
                //        /* Very unlikely, but possible on 16 bit machine if
                //         * strstart == 0 && lookahead == 1 (input done a byte at time)
                //         */
                //        more--;
                //    }
                // }
                /* If the window is almost full and there is insufficient lookahead,
                 * move the upper half to the lower one to make room in the upper half.
                 */
                if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
                    s.window.set(s.window.subarray(_w_size, _w_size + _w_size), 0);
                    s.match_start -= _w_size;
                    s.strstart -= _w_size;
                    /* we now have strstart >= MAX_DIST */
                    s.block_start -= _w_size;
                    /* Slide the hash table (could be avoided with 32 bit values
                   at the expense of memory usage). We slide even when level == 0
                   to keep the hash table consistent if we switch back to level > 0
                   later. (Using level 0 permanently is not an optimal usage of
                   zlib, so we don't care about this pathological case.)
                   */
                    n = s.hash_size;
                    p = n;
                    do {
                        m = s.head[--p];
                        s.head[p] = m >= _w_size ? m - _w_size : 0;
                    } while (--n);
                    n = _w_size;
                    p = n;
                    do {
                        m = s.prev[--p];
                        s.prev[p] = m >= _w_size ? m - _w_size : 0;
                        /* If n is not on any hash chain, prev[n] is garbage but
                         * its value will never be used.
                         */
                    } while (--n);
                    more += _w_size;
                }
                if (s.strm.avail_in === 0) {
                    break;
                }
                /* If there was no sliding:
                 *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
                 *    more == window_size - lookahead - strstart
                 * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
                 * => more >= window_size - 2*WSIZE + 2
                 * In the BIG_MEM or MMAP case (not yet supported),
                 *   window_size == input_size + MIN_LOOKAHEAD  &&
                 *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
                 * Otherwise, window_size == 2*WSIZE so more >= 2.
                 * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
                 */
                // Assert(more >= 2, "more < 2");
                n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
                s.lookahead += n;
                /* Initialize the hash value now that we have some input: */
                if (s.lookahead + s.insert >= MIN_MATCH$1) {
                    str = s.strstart - s.insert;
                    s.ins_h = s.window[str];
                    /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
                    s.ins_h = HASH(s, s.ins_h, s.window[str + 1]); // #if MIN_MATCH != 3
                    //        Call update_hash() MIN_MATCH-3 more times
                    // #endif
                    while (s.insert) {
                        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
                        s.ins_h = HASH(s, s.ins_h, s.window[str + MIN_MATCH$1 - 1]);
                        s.prev[str & s.w_mask] = s.head[s.ins_h];
                        s.head[s.ins_h] = str;
                        str++;
                        s.insert--;
                        if (s.lookahead + s.insert < MIN_MATCH$1) {
                            break;
                        }
                    }
                }
                /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
                 * but this is not important since only literal bytes will be emitted.
                 */
            } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);
            /* If the WIN_INIT bytes after the end of the current data have never been
             * written, then zero those bytes in order to avoid memory check reports of
             * the use of uninitialized (or uninitialised as Julian writes) bytes by
             * the longest match routines.  Update the high water mark for the next
             * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
             * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
             */
            //  if (s.high_water < s.window_size) {
            //    const curr = s.strstart + s.lookahead;
            //    let init = 0;
            //
            //    if (s.high_water < curr) {
            //      /* Previous high water mark below current data -- zero WIN_INIT
            //       * bytes or up to end of window, whichever is less.
            //       */
            //      init = s.window_size - curr;
            //      if (init > WIN_INIT)
            //        init = WIN_INIT;
            //      zmemzero(s->window + curr, (unsigned)init);
            //      s->high_water = curr + init;
            //    }
            //    else if (s->high_water < (ulg)curr + WIN_INIT) {
            //      /* High water mark at or above current data, but below current data
            //       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
            //       * to end of window, whichever is less.
            //       */
            //      init = (ulg)curr + WIN_INIT - s->high_water;
            //      if (init > s->window_size - s->high_water)
            //        init = s->window_size - s->high_water;
            //      zmemzero(s->window + s->high_water, (unsigned)init);
            //      s->high_water += init;
            //    }
            //  }
            //
            //  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
            //    "not enough room for search");
        };
        /* ===========================================================================
         * Copy without compression as much as possible from the input stream, return
         * the current block state.
         * This function does not insert new strings in the dictionary since
         * uncompressible data is probably not useful. This function is used
         * only for the level=0 compression option.
         * NOTE: this function should be optimized to avoid extra copying from
         * window to pending_buf.
         */
        var deflate_stored = function deflate_stored(s, flush) {
            /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
             * to pending_buf_size, and each stored block has a 5 byte header:
             */
            var max_block_size = 0xffff;
            if (max_block_size > s.pending_buf_size - 5) {
                max_block_size = s.pending_buf_size - 5;
            }
            /* Copy as much as possible from input to output: */
            for (;;) {
                /* Fill the window as much as possible: */
                if (s.lookahead <= 1) {
                    // Assert(s->strstart < s->w_size+MAX_DIST(s) ||
                    //  s->block_start >= (long)s->w_size, "slide too late");
                    //      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
                    //        s.block_start >= s.w_size)) {
                    //        throw  new Error("slide too late");
                    //      }
                    fill_window(s);
                    if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
                        return BS_NEED_MORE;
                    }
                    if (s.lookahead === 0) {
                        break;
                    }
                    /* flush the current block */
                } // Assert(s->block_start >= 0L, "block gone");
                //    if (s.block_start < 0) throw new Error("block gone");
                s.strstart += s.lookahead;
                s.lookahead = 0;
                /* Emit a stored block if pending_buf will be full: */
                var max_start = s.block_start + max_block_size;
                if (s.strstart === 0 || s.strstart >= max_start) {
                    /* strstart == 0 is possible when wraparound on 16-bit machine */
                    s.lookahead = s.strstart - max_start;
                    s.strstart = max_start;
                    /** * FLUSH_BLOCK(s, 0); ** */
                    flush_block_only(s, false);
                    if (s.strm.avail_out === 0) {
                        return BS_NEED_MORE;
                    }
                    /***/
                }
                /* Flush if we may have to slide, otherwise block_start may become
                 * negative and the data will be gone:
                 */
                if (s.strstart - s.block_start >= s.w_size - MIN_LOOKAHEAD) {
                    /** * FLUSH_BLOCK(s, 0); ** */
                    flush_block_only(s, false);
                    if (s.strm.avail_out === 0) {
                        return BS_NEED_MORE;
                    }
                    /***/
                }
            }
            s.insert = 0;
            if (flush === Z_FINISH) {
                /** * FLUSH_BLOCK(s, 1); ** */
                flush_block_only(s, true);
                if (s.strm.avail_out === 0) {
                    return BS_FINISH_STARTED;
                }
                /***/
                return BS_FINISH_DONE;
            }
            if (s.strstart > s.block_start) {
                /** * FLUSH_BLOCK(s, 0); ** */
                flush_block_only(s, false);
                if (s.strm.avail_out === 0) {
                    return BS_NEED_MORE;
                }
                /***/
            }
            return BS_NEED_MORE;
        };
        /* ===========================================================================
         * Compress as much as possible from the input stream, return the current
         * block state.
         * This function does not perform lazy evaluation of matches and inserts
         * new strings in the dictionary only for unmatched strings or for short
         * matches. It is used only for the fast compression options.
         */
        var deflate_fast = function deflate_fast(s, flush) {
            var hash_head;
            /* head of the hash chain */
            var bflush;
            /* set if current block must be flushed */
            for (;;) {
                /* Make sure that we always have enough lookahead, except
                 * at the end of the input file. We need MAX_MATCH bytes
                 * for the next match, plus MIN_MATCH bytes to insert the
                 * string following the next match.
                 */
                if (s.lookahead < MIN_LOOKAHEAD) {
                    fill_window(s);
                    if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
                        return BS_NEED_MORE;
                    }
                    if (s.lookahead === 0) {
                        break;
                        /* flush the current block */
                    }
                }
                /* Insert the string window[strstart .. strstart+2] in the
                 * dictionary, and set hash_head to the head of the hash chain:
                 */
                hash_head = 0;
                /* NIL */
                if (s.lookahead >= MIN_MATCH$1) {
                    /** * INSERT_STRING(s, s.strstart, hash_head); ** */
                    s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH$1 - 1]);
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                    /***/
                }
                /* Find the longest match, discarding those <= prev_length.
                 * At this point we have always match_length < MIN_MATCH
                 */
                if (hash_head !== 0 &&
                    /* NIL */
                    s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD) {
                    /* To simplify the code, we prevent matches with the string
                     * of window index 0 (in particular we have to avoid a match
                     * of the string with itself at the start of the input file).
                     */
                    s.match_length = longest_match(s, hash_head);
                    /* longest_match() sets match_start */
                }
                if (s.match_length >= MIN_MATCH$1) {
                    // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
                    /** * _tr_tally_dist(s, s.strstart - s.match_start,
                                 s.match_length - MIN_MATCH, bflush); ** */
                    bflush = _tr_tally$1(s, s.strstart - s.match_start, s.match_length - MIN_MATCH$1);
                    s.lookahead -= s.match_length;
                    /* Insert new strings in the hash table only if the match length
                     * is not too large. This saves time but degrades compression.
                     */
                    if (s.match_length <= s.max_lazy_match &&
                        /* max_insert_length */
                        s.lookahead >= MIN_MATCH$1) {
                        s.match_length--;
                        /* string at strstart already in table */
                        do {
                            s.strstart++;
                            /** * INSERT_STRING(s, s.strstart, hash_head); ** */
                            s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH$1 - 1]);
                            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                            s.head[s.ins_h] = s.strstart;
                            /***/
                            /* strstart never exceeds WSIZE-MAX_MATCH, so there are
                             * always MIN_MATCH bytes ahead.
                             */
                        } while (--s.match_length !== 0);
                        s.strstart++;
                    }
                    else {
                        s.strstart += s.match_length;
                        s.match_length = 0;
                        s.ins_h = s.window[s.strstart];
                        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
                        s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + 1]); // #if MIN_MATCH != 3
                        //                Call UPDATE_HASH() MIN_MATCH-3 more times
                        // #endif
                        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
                         * matter since it will be recomputed at next deflate call.
                         */
                    }
                }
                else {
                    /* No match, output a literal byte */
                    // Tracevv((stderr,"%c", s.window[s.strstart]));
                    /** * _tr_tally_lit(s, s.window[s.strstart], bflush); ** */
                    bflush = _tr_tally$1(s, 0, s.window[s.strstart]);
                    s.lookahead--;
                    s.strstart++;
                }
                if (bflush) {
                    /** * FLUSH_BLOCK(s, 0); ** */
                    flush_block_only(s, false);
                    if (s.strm.avail_out === 0) {
                        return BS_NEED_MORE;
                    }
                    /***/
                }
            }
            s.insert = s.strstart < MIN_MATCH$1 - 1 ? s.strstart : MIN_MATCH$1 - 1;
            if (flush === Z_FINISH) {
                /** * FLUSH_BLOCK(s, 1); ** */
                flush_block_only(s, true);
                if (s.strm.avail_out === 0) {
                    return BS_FINISH_STARTED;
                }
                /***/
                return BS_FINISH_DONE;
            }
            if (s.last_lit) {
                /** * FLUSH_BLOCK(s, 0); ** */
                flush_block_only(s, false);
                if (s.strm.avail_out === 0) {
                    return BS_NEED_MORE;
                }
                /***/
            }
            return BS_BLOCK_DONE;
        };
        /* ===========================================================================
         * Same as above, but achieves better compression. We use a lazy
         * evaluation for matches: a match is finally adopted only if there is
         * no better match at the next window position.
         */
        var deflate_slow = function deflate_slow(s, flush) {
            var hash_head;
            /* head of hash chain */
            var bflush;
            /* set if current block must be flushed */
            var max_insert;
            /* Process the input block. */
            for (;;) {
                /* Make sure that we always have enough lookahead, except
                 * at the end of the input file. We need MAX_MATCH bytes
                 * for the next match, plus MIN_MATCH bytes to insert the
                 * string following the next match.
                 */
                if (s.lookahead < MIN_LOOKAHEAD) {
                    fill_window(s);
                    if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
                        return BS_NEED_MORE;
                    }
                    if (s.lookahead === 0) {
                        break;
                    }
                    /* flush the current block */
                }
                /* Insert the string window[strstart .. strstart+2] in the
                 * dictionary, and set hash_head to the head of the hash chain:
                 */
                hash_head = 0;
                /* NIL */
                if (s.lookahead >= MIN_MATCH$1) {
                    /** * INSERT_STRING(s, s.strstart, hash_head); ** */
                    s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH$1 - 1]);
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                    /***/
                }
                /* Find the longest match, discarding those <= prev_length.
                 */
                s.prev_length = s.match_length;
                s.prev_match = s.match_start;
                s.match_length = MIN_MATCH$1 - 1;
                if (hash_head !== 0 &&
                    /* NIL */
                    s.prev_length < s.max_lazy_match &&
                    s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD
                /* MAX_DIST(s) */
                ) {
                    /* To simplify the code, we prevent matches with the string
                     * of window index 0 (in particular we have to avoid a match
                     * of the string with itself at the start of the input file).
                     */
                    s.match_length = longest_match(s, hash_head);
                    /* longest_match() sets match_start */
                    if (s.match_length <= 5 &&
                        (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH$1 && s.strstart - s.match_start > 4096))
                    /* TOO_FAR */
                    ) {
                        /* If prev_match is also MIN_MATCH, match_start is garbage
                         * but we will ignore the current match anyway.
                         */
                        s.match_length = MIN_MATCH$1 - 1;
                    }
                }
                /* If there was a match at the previous step and the current
                 * match is not better, output the previous match:
                 */
                if (s.prev_length >= MIN_MATCH$1 && s.match_length <= s.prev_length) {
                    max_insert = s.strstart + s.lookahead - MIN_MATCH$1;
                    /* Do not insert strings in hash table beyond this. */
                    // check_match(s, s.strstart-1, s.prev_match, s.prev_length);
                    /** *_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                                 s.prev_length - MIN_MATCH, bflush);** */
                    bflush = _tr_tally$1(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH$1);
                    /* Insert in hash table all strings up to the end of the match.
                     * strstart-1 and strstart are already inserted. If there is not
                     * enough lookahead, the last two strings are not inserted in
                     * the hash table.
                     */
                    s.lookahead -= s.prev_length - 1;
                    s.prev_length -= 2;
                    do {
                        if (++s.strstart <= max_insert) {
                            /** * INSERT_STRING(s, s.strstart, hash_head); ** */
                            s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH$1 - 1]);
                            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                            s.head[s.ins_h] = s.strstart;
                            /***/
                        }
                    } while (--s.prev_length !== 0);
                    s.match_available = 0;
                    s.match_length = MIN_MATCH$1 - 1;
                    s.strstart++;
                    if (bflush) {
                        /** * FLUSH_BLOCK(s, 0); ** */
                        flush_block_only(s, false);
                        if (s.strm.avail_out === 0) {
                            return BS_NEED_MORE;
                        }
                        /***/
                    }
                }
                else if (s.match_available) {
                    /* If there was no match at the previous position, output a
                     * single literal. If there was a match but the current match
                     * is longer, truncate the previous match to a single literal.
                     */
                    // Tracevv((stderr,"%c", s->window[s->strstart-1]));
                    /** * _tr_tally_lit(s, s.window[s.strstart-1], bflush); ** */
                    bflush = _tr_tally$1(s, 0, s.window[s.strstart - 1]);
                    if (bflush) {
                        /** * FLUSH_BLOCK_ONLY(s, 0) ** */
                        flush_block_only(s, false);
                        /***/
                    }
                    s.strstart++;
                    s.lookahead--;
                    if (s.strm.avail_out === 0) {
                        return BS_NEED_MORE;
                    }
                }
                else {
                    /* There is no previous match to compare with, wait for
                     * the next step to decide.
                     */
                    s.match_available = 1;
                    s.strstart++;
                    s.lookahead--;
                }
            } // Assert (flush != Z_NO_FLUSH, "no flush?");
            if (s.match_available) {
                // Tracevv((stderr,"%c", s->window[s->strstart-1]));
                /** * _tr_tally_lit(s, s.window[s.strstart-1], bflush); ** */
                bflush = _tr_tally$1(s, 0, s.window[s.strstart - 1]);
                s.match_available = 0;
            }
            s.insert = s.strstart < MIN_MATCH$1 - 1 ? s.strstart : MIN_MATCH$1 - 1;
            if (flush === Z_FINISH) {
                /** * FLUSH_BLOCK(s, 1); ** */
                flush_block_only(s, true);
                if (s.strm.avail_out === 0) {
                    return BS_FINISH_STARTED;
                }
                /***/
                return BS_FINISH_DONE;
            }
            if (s.last_lit) {
                /** * FLUSH_BLOCK(s, 0); ** */
                flush_block_only(s, false);
                if (s.strm.avail_out === 0) {
                    return BS_NEED_MORE;
                }
                /***/
            }
            return BS_BLOCK_DONE;
        };
        /* ===========================================================================
         * For Z_RLE, simply look for runs of bytes, generate matches only of distance
         * one.  Do not maintain a hash table.  (It will be regenerated if this run of
         * deflate switches away from Z_RLE.)
         */
        var deflate_rle = function deflate_rle(s, flush) {
            var bflush;
            /* set if current block must be flushed */
            var prev;
            /* byte at distance one to match */
            var scan;
            var strend;
            /* scan goes up to strend for length of run */
            var _win = s.window;
            for (;;) {
                /* Make sure that we always have enough lookahead, except
                 * at the end of the input file. We need MAX_MATCH bytes
                 * for the longest run, plus one for the unrolled loop.
                 */
                if (s.lookahead <= MAX_MATCH$1) {
                    fill_window(s);
                    if (s.lookahead <= MAX_MATCH$1 && flush === Z_NO_FLUSH) {
                        return BS_NEED_MORE;
                    }
                    if (s.lookahead === 0) {
                        break;
                    }
                    /* flush the current block */
                }
                /* See how many times the previous byte repeats */
                s.match_length = 0;
                if (s.lookahead >= MIN_MATCH$1 && s.strstart > 0) {
                    scan = s.strstart - 1;
                    prev = _win[scan];
                    if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                        strend = s.strstart + MAX_MATCH$1;
                        do {
                            /* jshint noempty:false */
                        } while (prev === _win[++scan] &&
                            prev === _win[++scan] &&
                            prev === _win[++scan] &&
                            prev === _win[++scan] &&
                            prev === _win[++scan] &&
                            prev === _win[++scan] &&
                            prev === _win[++scan] &&
                            prev === _win[++scan] &&
                            scan < strend);
                        s.match_length = MAX_MATCH$1 - (strend - scan);
                        if (s.match_length > s.lookahead) {
                            s.match_length = s.lookahead;
                        }
                    } // Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
                }
                /* Emit match if have run of MIN_MATCH or longer, else emit literal */
                if (s.match_length >= MIN_MATCH$1) {
                    // check_match(s, s.strstart, s.strstart - 1, s.match_length);
                    /** * _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ** */
                    bflush = _tr_tally$1(s, 1, s.match_length - MIN_MATCH$1);
                    s.lookahead -= s.match_length;
                    s.strstart += s.match_length;
                    s.match_length = 0;
                }
                else {
                    /* No match, output a literal byte */
                    // Tracevv((stderr,"%c", s->window[s->strstart]));
                    /** * _tr_tally_lit(s, s.window[s.strstart], bflush); ** */
                    bflush = _tr_tally$1(s, 0, s.window[s.strstart]);
                    s.lookahead--;
                    s.strstart++;
                }
                if (bflush) {
                    /** * FLUSH_BLOCK(s, 0); ** */
                    flush_block_only(s, false);
                    if (s.strm.avail_out === 0) {
                        return BS_NEED_MORE;
                    }
                    /***/
                }
            }
            s.insert = 0;
            if (flush === Z_FINISH) {
                /** * FLUSH_BLOCK(s, 1); ** */
                flush_block_only(s, true);
                if (s.strm.avail_out === 0) {
                    return BS_FINISH_STARTED;
                }
                /***/
                return BS_FINISH_DONE;
            }
            if (s.last_lit) {
                /** * FLUSH_BLOCK(s, 0); ** */
                flush_block_only(s, false);
                if (s.strm.avail_out === 0) {
                    return BS_NEED_MORE;
                }
                /***/
            }
            return BS_BLOCK_DONE;
        };
        /* ===========================================================================
         * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
         * (It will be regenerated if this run of deflate switches away from Huffman.)
         */
        var deflate_huff = function deflate_huff(s, flush) {
            var bflush;
            /* set if current block must be flushed */
            for (;;) {
                /* Make sure that we have a literal to write. */
                if (s.lookahead === 0) {
                    fill_window(s);
                    if (s.lookahead === 0) {
                        if (flush === Z_NO_FLUSH) {
                            return BS_NEED_MORE;
                        }
                        break;
                        /* flush the current block */
                    }
                }
                /* Output a literal byte */
                s.match_length = 0; // Tracevv((stderr,"%c", s->window[s->strstart]));
                /** * _tr_tally_lit(s, s.window[s.strstart], bflush); ** */
                bflush = _tr_tally$1(s, 0, s.window[s.strstart]);
                s.lookahead--;
                s.strstart++;
                if (bflush) {
                    /** * FLUSH_BLOCK(s, 0); ** */
                    flush_block_only(s, false);
                    if (s.strm.avail_out === 0) {
                        return BS_NEED_MORE;
                    }
                    /***/
                }
            }
            s.insert = 0;
            if (flush === Z_FINISH) {
                /** * FLUSH_BLOCK(s, 1); ** */
                flush_block_only(s, true);
                if (s.strm.avail_out === 0) {
                    return BS_FINISH_STARTED;
                }
                /***/
                return BS_FINISH_DONE;
            }
            if (s.last_lit) {
                /** * FLUSH_BLOCK(s, 0); ** */
                flush_block_only(s, false);
                if (s.strm.avail_out === 0) {
                    return BS_NEED_MORE;
                }
                /***/
            }
            return BS_BLOCK_DONE;
        };
        /* Values for max_lazy_match, good_match and max_chain_length, depending on
         * the desired pack level (0..9). The values given below have been tuned to
         * exclude worst case performance for pathological files. Better values may be
         * found for specific files.
         */
        function Config(good_length, max_lazy, nice_length, max_chain, func) {
            this.good_length = good_length;
            this.max_lazy = max_lazy;
            this.nice_length = nice_length;
            this.max_chain = max_chain;
            this.func = func;
        }
        var configuration_table = [
            /*      good lazy nice chain */
            new Config(0, 0, 0, 0, deflate_stored),
            /* 0 store only */
            new Config(4, 4, 8, 4, deflate_fast),
            /* 1 max speed, no lazy matches */
            new Config(4, 5, 16, 8, deflate_fast),
            /* 2 */
            new Config(4, 6, 32, 32, deflate_fast),
            /* 3 */
            new Config(4, 4, 16, 16, deflate_slow),
            /* 4 lazy matches */
            new Config(8, 16, 32, 32, deflate_slow),
            /* 5 */
            new Config(8, 16, 128, 128, deflate_slow),
            /* 6 */
            new Config(8, 32, 128, 256, deflate_slow),
            /* 7 */
            new Config(32, 128, 258, 1024, deflate_slow),
            /* 8 */
            new Config(32, 258, 258, 4096, deflate_slow),
            /* 9 max compression */
        ];
        /* ===========================================================================
         * Initialize the "longest match" routines for a new zlib stream
         */
        var lm_init = function lm_init(s) {
            s.window_size = 2 * s.w_size;
            /** * CLEAR_HASH(s); ** */
            zero$1(s.head); // Fill with NIL (= 0);
            /* Set the default configuration parameters:
             */
            s.max_lazy_match = configuration_table[s.level].max_lazy;
            s.good_match = configuration_table[s.level].good_length;
            s.nice_match = configuration_table[s.level].nice_length;
            s.max_chain_length = configuration_table[s.level].max_chain;
            s.strstart = 0;
            s.block_start = 0;
            s.lookahead = 0;
            s.insert = 0;
            s.match_length = s.prev_length = MIN_MATCH$1 - 1;
            s.match_available = 0;
            s.ins_h = 0;
        };
        function DeflateState() {
            this.strm = null;
            /* pointer back to this zlib stream */
            this.status = 0;
            /* as the name implies */
            this.pending_buf = null;
            /* output still pending */
            this.pending_buf_size = 0;
            /* size of pending_buf */
            this.pending_out = 0;
            /* next pending byte to output to the stream */
            this.pending = 0;
            /* nb of bytes in the pending buffer */
            this.wrap = 0;
            /* bit 0 true for zlib, bit 1 true for gzip */
            this.gzhead = null;
            /* gzip header information to write */
            this.gzindex = 0;
            /* where in extra, name, or comment */
            this.method = Z_DEFLATED;
            /* can only be DEFLATED */
            this.last_flush = -1;
            /* value of flush param for previous deflate call */
            this.w_size = 0;
            /* LZ77 window size (32K by default) */
            this.w_bits = 0;
            /* log2(w_size)  (8..16) */
            this.w_mask = 0;
            /* w_size - 1 */
            this.window = null;
            /* Sliding window. Input bytes are read into the second half of the window,
             * and move to the first half later to keep a dictionary of at least wSize
             * bytes. With this organization, matches are limited to a distance of
             * wSize-MAX_MATCH bytes, but this ensures that IO is always
             * performed with a length multiple of the block size.
             */
            this.window_size = 0;
            /* Actual size of window: 2*wSize, except when the user input buffer
             * is directly used as sliding window.
             */
            this.prev = null;
            /* Link to older string with same hash index. To limit the size of this
             * array to 64K, this link is maintained only for the last 32K strings.
             * An index in this array is thus a window index modulo 32K.
             */
            this.head = null;
            /* Heads of the hash chains or NIL. */
            this.ins_h = 0;
            /* hash index of string to be inserted */
            this.hash_size = 0;
            /* number of elements in hash table */
            this.hash_bits = 0;
            /* log2(hash_size) */
            this.hash_mask = 0;
            /* hash_size-1 */
            this.hash_shift = 0;
            /* Number of bits by which ins_h must be shifted at each input
             * step. It must be such that after MIN_MATCH steps, the oldest
             * byte no longer takes part in the hash key, that is:
             *   hash_shift * MIN_MATCH >= hash_bits
             */
            this.block_start = 0;
            /* Window position at the beginning of the current output block. Gets
             * negative when the window is moved backwards.
             */
            this.match_length = 0;
            /* length of best match */
            this.prev_match = 0;
            /* previous match */
            this.match_available = 0;
            /* set if previous match exists */
            this.strstart = 0;
            /* start of string to insert */
            this.match_start = 0;
            /* start of matching string */
            this.lookahead = 0;
            /* number of valid bytes ahead in window */
            this.prev_length = 0;
            /* Length of the best match at previous step. Matches not greater than this
             * are discarded. This is used in the lazy match evaluation.
             */
            this.max_chain_length = 0;
            /* To speed up deflation, hash chains are never searched beyond this
             * length.  A higher limit improves compression ratio but degrades the
             * speed.
             */
            this.max_lazy_match = 0;
            /* Attempt to find a better match only when the current match is strictly
             * smaller than this value. This mechanism is used only for compression
             * levels >= 4.
             */
            // That's alias to max_lazy_match, don't use directly
            // this.max_insert_length = 0;
            /* Insert new strings in the hash table only if the match length is not
             * greater than this length. This saves time but degrades compression.
             * max_insert_length is used only for compression levels <= 3.
             */
            this.level = 0;
            /* compression level (1..9) */
            this.strategy = 0;
            /* favor or force Huffman coding */
            this.good_match = 0;
            /* Use a faster search when the previous match is longer than this */
            this.nice_match = 0;
            /* Stop searching when current match exceeds this */
            /* used by trees.c: */
            /* Didn't use ct_data typedef below to suppress compiler warning */
            // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
            // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
            // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
            // Use flat array of DOUBLE size, with interleaved fata,
            // because JS does not support effective
            this.dyn_ltree = new Uint16Array(HEAP_SIZE$1 * 2);
            this.dyn_dtree = new Uint16Array((2 * D_CODES$1 + 1) * 2);
            this.bl_tree = new Uint16Array((2 * BL_CODES$1 + 1) * 2);
            zero$1(this.dyn_ltree);
            zero$1(this.dyn_dtree);
            zero$1(this.bl_tree);
            this.l_desc = null;
            /* desc. for literal tree */
            this.d_desc = null;
            /* desc. for distance tree */
            this.bl_desc = null;
            /* desc. for bit length tree */
            // ush bl_count[MAX_BITS+1];
            this.bl_count = new Uint16Array(MAX_BITS$1 + 1);
            /* number of codes at each bit length for an optimal tree */
            // int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
            this.heap = new Uint16Array(2 * L_CODES$1 + 1);
            /* heap used to build the Huffman trees */
            zero$1(this.heap);
            this.heap_len = 0;
            /* number of elements in the heap */
            this.heap_max = 0;
            /* element of largest frequency */
            /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
             * The same heap array is used to build all trees.
             */
            this.depth = new Uint16Array(2 * L_CODES$1 + 1); // uch depth[2*L_CODES+1];
            zero$1(this.depth);
            /* Depth of each subtree used as tie breaker for trees of equal frequency
             */
            this.l_buf = 0;
            /* buffer index for literals or lengths */
            this.lit_bufsize = 0;
            /* Size of match buffer for literals/lengths.  There are 4 reasons for
             * limiting lit_bufsize to 64K:
             *   - frequencies can be kept in 16 bit counters
             *   - if compression is not successful for the first block, all input
             *     data is still in the window so we can still emit a stored block even
             *     when input comes from standard input.  (This can also be done for
             *     all blocks if lit_bufsize is not greater than 32K.)
             *   - if compression is not successful for a file smaller than 64K, we can
             *     even emit a stored file instead of a stored block (saving 5 bytes).
             *     This is applicable only for zip (not gzip or zlib).
             *   - creating new Huffman trees less frequently may not provide fast
             *     adaptation to changes in the input data statistics. (Take for
             *     example a binary file with poorly compressible code followed by
             *     a highly compressible string table.) Smaller buffer sizes give
             *     fast adaptation but have of course the overhead of transmitting
             *     trees more frequently.
             *   - I can't count above 4
             */
            this.last_lit = 0;
            /* running index in l_buf */
            this.d_buf = 0;
            /* Buffer index for distances. To simplify the code, d_buf and l_buf have
             * the same number of elements. To use different lengths, an extra flag
             * array would be necessary.
             */
            this.opt_len = 0;
            /* bit length of current block with optimal trees */
            this.static_len = 0;
            /* bit length of current block with static trees */
            this.matches = 0;
            /* number of string matches in current block */
            this.insert = 0;
            /* bytes at end of window left to insert */
            this.bi_buf = 0;
            /* Output buffer. bits are inserted starting at the bottom (least
             * significant bits).
             */
            this.bi_valid = 0;
            /* Number of valid bits in bi_buf.  All bits above the last valid bit
             * are always zero.
             */
            // Used for window memory init. We safely ignore it for JS. That makes
            // sense only for pointers and memory check tools.
            // this.high_water = 0;
            /* High water mark offset in window for initialized bytes -- bytes above
             * this are set to zero in order to avoid memory check warnings when
             * longest match routines access bytes past the input.  This is then
             * updated to the new high water mark.
             */
        }
        var deflateResetKeep = function deflateResetKeep(strm) {
            if (!strm || !strm.state) {
                return err(strm, Z_STREAM_ERROR);
            }
            strm.total_in = strm.total_out = 0;
            strm.data_type = Z_UNKNOWN$1;
            var s = strm.state;
            s.pending = 0;
            s.pending_out = 0;
            if (s.wrap < 0) {
                s.wrap = -s.wrap;
                /* was made negative by deflate(..., Z_FINISH); */
            }
            s.status = s.wrap ? INIT_STATE : BUSY_STATE;
            strm.adler =
                s.wrap === 2
                    ? 0 // crc32(0, Z_NULL, 0)
                    : 1; // adler32(0, Z_NULL, 0)
            s.last_flush = Z_NO_FLUSH;
            _tr_init$1(s);
            return Z_OK;
        };
        var deflateReset = function deflateReset(strm) {
            var ret = deflateResetKeep(strm);
            if (ret === Z_OK) {
                lm_init(strm.state);
            }
            return ret;
        };
        var deflateSetHeader = function deflateSetHeader(strm, head) {
            if (!strm || !strm.state) {
                return Z_STREAM_ERROR;
            }
            if (strm.state.wrap !== 2) {
                return Z_STREAM_ERROR;
            }
            strm.state.gzhead = head;
            return Z_OK;
        };
        var deflateInit2 = function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
            if (!strm) {
                // === Z_NULL
                return Z_STREAM_ERROR;
            }
            var wrap = 1;
            if (level === Z_DEFAULT_COMPRESSION) {
                level = 6;
            }
            if (windowBits < 0) {
                /* suppress zlib wrapper */
                wrap = 0;
                windowBits = -windowBits;
            }
            else if (windowBits > 15) {
                wrap = 2;
                /* write gzip wrapper instead */
                windowBits -= 16;
            }
            if (memLevel < 1 ||
                memLevel > MAX_MEM_LEVEL ||
                method !== Z_DEFLATED ||
                windowBits < 8 ||
                windowBits > 15 ||
                level < 0 ||
                level > 9 ||
                strategy < 0 ||
                strategy > Z_FIXED$1) {
                return err(strm, Z_STREAM_ERROR);
            }
            if (windowBits === 8) {
                windowBits = 9;
            }
            /* until 256-byte window bug fixed */
            var s = new DeflateState();
            strm.state = s;
            s.strm = strm;
            s.wrap = wrap;
            s.gzhead = null;
            s.w_bits = windowBits;
            s.w_size = 1 << s.w_bits;
            s.w_mask = s.w_size - 1;
            s.hash_bits = memLevel + 7;
            s.hash_size = 1 << s.hash_bits;
            s.hash_mask = s.hash_size - 1;
            s.hash_shift = ~~((s.hash_bits + MIN_MATCH$1 - 1) / MIN_MATCH$1);
            s.window = new Uint8Array(s.w_size * 2);
            s.head = new Uint16Array(s.hash_size);
            s.prev = new Uint16Array(s.w_size); // Don't need mem init magic for JS.
            // s.high_water = 0;  /* nothing written to s->window yet */
            s.lit_bufsize = 1 << (memLevel + 6);
            /* 16K elements by default */
            s.pending_buf_size = s.lit_bufsize * 4;
            // overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
            // s->pending_buf = (uchf *) overlay;
            // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
            s.pending_buf = new Uint8Array(s.pending_buf_size);
            // s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
            s.d_buf = 1 * s.lit_bufsize; // s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
            s.l_buf = (1 + 2) * s.lit_bufsize;
            s.level = level;
            s.strategy = strategy;
            s.method = method;
            return deflateReset(strm);
        };
        var deflateInit = function deflateInit(strm, level) {
            return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
        };
        var deflate = function deflate(strm, flush) {
            var beg;
            var val; // for gzip header write only
            if (!strm || !strm.state || flush > Z_BLOCK || flush < 0) {
                return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
            }
            var s = strm.state;
            if (!strm.output || (!strm.input && strm.avail_in !== 0) || (s.status === FINISH_STATE && flush !== Z_FINISH)) {
                return err(strm, strm.avail_out === 0 ? Z_BUF_ERROR : Z_STREAM_ERROR);
            }
            s.strm = strm;
            /* just in case */
            var old_flush = s.last_flush;
            s.last_flush = flush;
            /* Write the header */
            if (s.status === INIT_STATE) {
                if (s.wrap === 2) {
                    // GZIP header
                    strm.adler = 0; // crc32(0L, Z_NULL, 0);
                    put_byte(s, 31);
                    put_byte(s, 139);
                    put_byte(s, 8);
                    if (!s.gzhead) {
                        // s->gzhead == Z_NULL
                        put_byte(s, 0);
                        put_byte(s, 0);
                        put_byte(s, 0);
                        put_byte(s, 0);
                        put_byte(s, 0);
                        put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                        put_byte(s, OS_CODE);
                        s.status = BUSY_STATE;
                    }
                    else {
                        put_byte(s, (s.gzhead.text ? 1 : 0) +
                            (s.gzhead.hcrc ? 2 : 0) +
                            (!s.gzhead.extra ? 0 : 4) +
                            (!s.gzhead.name ? 0 : 8) +
                            (!s.gzhead.comment ? 0 : 16));
                        put_byte(s, s.gzhead.time & 0xff);
                        put_byte(s, (s.gzhead.time >> 8) & 0xff);
                        put_byte(s, (s.gzhead.time >> 16) & 0xff);
                        put_byte(s, (s.gzhead.time >> 24) & 0xff);
                        put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                        put_byte(s, s.gzhead.os & 0xff);
                        if (s.gzhead.extra && s.gzhead.extra.length) {
                            put_byte(s, s.gzhead.extra.length & 0xff);
                            put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
                        }
                        if (s.gzhead.hcrc) {
                            strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending, 0);
                        }
                        s.gzindex = 0;
                        s.status = EXTRA_STATE;
                    }
                } // DEFLATE header
                else {
                    var header = (Z_DEFLATED + ((s.w_bits - 8) << 4)) << 8;
                    var level_flags = -1;
                    if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
                        level_flags = 0;
                    }
                    else if (s.level < 6) {
                        level_flags = 1;
                    }
                    else if (s.level === 6) {
                        level_flags = 2;
                    }
                    else {
                        level_flags = 3;
                    }
                    header |= level_flags << 6;
                    if (s.strstart !== 0) {
                        header |= PRESET_DICT;
                    }
                    header += 31 - (header % 31);
                    s.status = BUSY_STATE;
                    putShortMSB(s, header);
                    /* Save the adler32 of the preset dictionary: */
                    if (s.strstart !== 0) {
                        putShortMSB(s, strm.adler >>> 16);
                        putShortMSB(s, strm.adler & 0xffff);
                    }
                    strm.adler = 1; // adler32(0L, Z_NULL, 0);
                }
            } // #ifdef GZIP
            if (s.status === EXTRA_STATE) {
                if (s.gzhead.extra
                /* != Z_NULL */
                ) {
                    beg = s.pending;
                    /* start of bytes to update crc */
                    while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
                        if (s.pending === s.pending_buf_size) {
                            if (s.gzhead.hcrc && s.pending > beg) {
                                strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                            }
                            flush_pending(strm);
                            beg = s.pending;
                            if (s.pending === s.pending_buf_size) {
                                break;
                            }
                        }
                        put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
                        s.gzindex++;
                    }
                    if (s.gzhead.hcrc && s.pending > beg) {
                        strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    }
                    if (s.gzindex === s.gzhead.extra.length) {
                        s.gzindex = 0;
                        s.status = NAME_STATE;
                    }
                }
                else {
                    s.status = NAME_STATE;
                }
            }
            if (s.status === NAME_STATE) {
                if (s.gzhead.name
                /* != Z_NULL */
                ) {
                    beg = s.pending;
                    /* start of bytes to update crc */
                    // int val;
                    do {
                        if (s.pending === s.pending_buf_size) {
                            if (s.gzhead.hcrc && s.pending > beg) {
                                strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                            }
                            flush_pending(strm);
                            beg = s.pending;
                            if (s.pending === s.pending_buf_size) {
                                val = 1;
                                break;
                            }
                        } // JS specific: little magic to add zero terminator to end of string
                        if (s.gzindex < s.gzhead.name.length) {
                            val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                        }
                        else {
                            val = 0;
                        }
                        put_byte(s, val);
                    } while (val !== 0);
                    if (s.gzhead.hcrc && s.pending > beg) {
                        strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    }
                    if (val === 0) {
                        s.gzindex = 0;
                        s.status = COMMENT_STATE;
                    }
                }
                else {
                    s.status = COMMENT_STATE;
                }
            }
            if (s.status === COMMENT_STATE) {
                if (s.gzhead.comment
                /* != Z_NULL */
                ) {
                    beg = s.pending;
                    /* start of bytes to update crc */
                    // int val;
                    do {
                        if (s.pending === s.pending_buf_size) {
                            if (s.gzhead.hcrc && s.pending > beg) {
                                strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                            }
                            flush_pending(strm);
                            beg = s.pending;
                            if (s.pending === s.pending_buf_size) {
                                val = 1;
                                break;
                            }
                        } // JS specific: little magic to add zero terminator to end of string
                        if (s.gzindex < s.gzhead.comment.length) {
                            val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                        }
                        else {
                            val = 0;
                        }
                        put_byte(s, val);
                    } while (val !== 0);
                    if (s.gzhead.hcrc && s.pending > beg) {
                        strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    }
                    if (val === 0) {
                        s.status = HCRC_STATE;
                    }
                }
                else {
                    s.status = HCRC_STATE;
                }
            }
            if (s.status === HCRC_STATE) {
                if (s.gzhead.hcrc) {
                    if (s.pending + 2 > s.pending_buf_size) {
                        flush_pending(strm);
                    }
                    if (s.pending + 2 <= s.pending_buf_size) {
                        put_byte(s, strm.adler & 0xff);
                        put_byte(s, (strm.adler >> 8) & 0xff);
                        strm.adler = 0; // crc32(0L, Z_NULL, 0);
                        s.status = BUSY_STATE;
                    }
                }
                else {
                    s.status = BUSY_STATE;
                }
            } // #endif
            /* Flush as much pending output as possible */
            if (s.pending !== 0) {
                flush_pending(strm);
                if (strm.avail_out === 0) {
                    /* Since avail_out is 0, deflate will be called again with
                     * more output space, but possibly with both pending and
                     * avail_in equal to zero. There won't be anything to do,
                     * but this is not an error situation so make sure we
                     * return OK instead of BUF_ERROR at next call of deflate:
                     */
                    s.last_flush = -1;
                    return Z_OK;
                }
                /* Make sure there is something to do and avoid duplicate consecutive
                 * flushes. For repeated and useless calls with Z_FINISH, we keep
                 * returning Z_STREAM_END instead of Z_BUF_ERROR.
                 */
            }
            else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) && flush !== Z_FINISH) {
                return err(strm, Z_BUF_ERROR);
            }
            /* User must not provide more input after the first FINISH: */
            if (s.status === FINISH_STATE && strm.avail_in !== 0) {
                return err(strm, Z_BUF_ERROR);
            }
            /* Start a new block or continue the current one.
             */
            if (strm.avail_in !== 0 || s.lookahead !== 0 || (flush !== Z_NO_FLUSH && s.status !== FINISH_STATE)) {
                var bstate = s.strategy === Z_HUFFMAN_ONLY
                    ? deflate_huff(s, flush)
                    : s.strategy === Z_RLE
                        ? deflate_rle(s, flush)
                        : configuration_table[s.level].func(s, flush);
                if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
                    s.status = FINISH_STATE;
                }
                if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
                    if (strm.avail_out === 0) {
                        s.last_flush = -1;
                        /* avoid BUF_ERROR next call, see above */
                    }
                    return Z_OK;
                    /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
                     * of deflate should use the same flush parameter to make sure
                     * that the flush is complete. So we don't have to output an
                     * empty block here, this will be done at next call. This also
                     * ensures that for a very small output buffer, we emit at most
                     * one empty block.
                     */
                }
                if (bstate === BS_BLOCK_DONE) {
                    if (flush === Z_PARTIAL_FLUSH) {
                        _tr_align$1(s);
                    }
                    else if (flush !== Z_BLOCK) {
                        /* FULL_FLUSH or SYNC_FLUSH */
                        _tr_stored_block$1(s, 0, 0, false);
                        /* For a full flush, this empty block will be recognized
                         * as a special marker by inflate_sync().
                         */
                        if (flush === Z_FULL_FLUSH) {
                            /** * CLEAR_HASH(s); ** */
                            /* forget history */
                            zero$1(s.head); // Fill with NIL (= 0);
                            if (s.lookahead === 0) {
                                s.strstart = 0;
                                s.block_start = 0;
                                s.insert = 0;
                            }
                        }
                    }
                    flush_pending(strm);
                    if (strm.avail_out === 0) {
                        s.last_flush = -1;
                        /* avoid BUF_ERROR at next call, see above */
                        return Z_OK;
                    }
                }
            } // Assert(strm->avail_out > 0, "bug2");
            // if (strm.avail_out <= 0) { throw new Error("bug2");}
            if (flush !== Z_FINISH) {
                return Z_OK;
            }
            if (s.wrap <= 0) {
                return Z_STREAM_END;
            }
            /* Write the trailer */
            if (s.wrap === 2) {
                put_byte(s, strm.adler & 0xff);
                put_byte(s, (strm.adler >> 8) & 0xff);
                put_byte(s, (strm.adler >> 16) & 0xff);
                put_byte(s, (strm.adler >> 24) & 0xff);
                put_byte(s, strm.total_in & 0xff);
                put_byte(s, (strm.total_in >> 8) & 0xff);
                put_byte(s, (strm.total_in >> 16) & 0xff);
                put_byte(s, (strm.total_in >> 24) & 0xff);
            }
            else {
                putShortMSB(s, strm.adler >>> 16);
                putShortMSB(s, strm.adler & 0xffff);
            }
            flush_pending(strm);
            /* If avail_out is zero, the application will call deflate again
             * to flush the rest.
             */
            if (s.wrap > 0) {
                s.wrap = -s.wrap;
            }
            /* write the trailer only once! */
            return s.pending !== 0 ? Z_OK : Z_STREAM_END;
        };
        var deflateEnd = function deflateEnd(strm) {
            if (!strm ||
                /* == Z_NULL */
                !strm.state
            /* == Z_NULL */
            ) {
                return Z_STREAM_ERROR;
            }
            var status = strm.state.status;
            if (status !== INIT_STATE &&
                status !== EXTRA_STATE &&
                status !== NAME_STATE &&
                status !== COMMENT_STATE &&
                status !== HCRC_STATE &&
                status !== BUSY_STATE &&
                status !== FINISH_STATE) {
                return err(strm, Z_STREAM_ERROR);
            }
            strm.state = null;
            return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
        };
        /* =========================================================================
         * Initializes the compression dictionary from the given byte
         * sequence without producing any compressed output.
         */
        var deflateSetDictionary = function deflateSetDictionary(strm, dictionary) {
            var dictLength = dictionary.length;
            if (!strm ||
                /* == Z_NULL */
                !strm.state
            /* == Z_NULL */
            ) {
                return Z_STREAM_ERROR;
            }
            var s = strm.state;
            var wrap = s.wrap;
            if (wrap === 2 || (wrap === 1 && s.status !== INIT_STATE) || s.lookahead) {
                return Z_STREAM_ERROR;
            }
            /* when using zlib wrappers, compute Adler-32 for provided dictionary */
            if (wrap === 1) {
                /* adler32(strm->adler, dictionary, dictLength); */
                strm.adler = adler32_1(strm.adler, dictionary, dictLength, 0);
            }
            s.wrap = 0;
            /* avoid computing Adler-32 in read_buf */
            /* if dictionary would fill window, just replace the history */
            if (dictLength >= s.w_size) {
                if (wrap === 0) {
                    /* already empty otherwise */
                    /** * CLEAR_HASH(s); ** */
                    zero$1(s.head); // Fill with NIL (= 0);
                    s.strstart = 0;
                    s.block_start = 0;
                    s.insert = 0;
                }
                /* use the tail */
                // dictionary = dictionary.slice(dictLength - s.w_size);
                var tmpDict = new Uint8Array(s.w_size);
                tmpDict.set(dictionary.subarray(dictLength - s.w_size, dictLength), 0);
                dictionary = tmpDict;
                dictLength = s.w_size;
            }
            /* insert dictionary into window and hash */
            var avail = strm.avail_in;
            var next = strm.next_in;
            var input = strm.input;
            strm.avail_in = dictLength;
            strm.next_in = 0;
            strm.input = dictionary;
            fill_window(s);
            while (s.lookahead >= MIN_MATCH$1) {
                var str = s.strstart;
                var n = s.lookahead - (MIN_MATCH$1 - 1);
                do {
                    /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
                    s.ins_h = HASH(s, s.ins_h, s.window[str + MIN_MATCH$1 - 1]);
                    s.prev[str & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = str;
                    str++;
                } while (--n);
                s.strstart = str;
                s.lookahead = MIN_MATCH$1 - 1;
                fill_window(s);
            }
            s.strstart += s.lookahead;
            s.block_start = s.strstart;
            s.insert = s.lookahead;
            s.lookahead = 0;
            s.match_length = s.prev_length = MIN_MATCH$1 - 1;
            s.match_available = 0;
            strm.next_in = next;
            strm.input = input;
            strm.avail_in = avail;
            s.wrap = wrap;
            return Z_OK;
        };
        var deflateInit_1 = deflateInit;
        var deflateInit2_1 = deflateInit2;
        var deflateReset_1 = deflateReset;
        var deflateResetKeep_1 = deflateResetKeep;
        var deflateSetHeader_1 = deflateSetHeader;
        var deflate_2 = deflate;
        var deflateEnd_1 = deflateEnd;
        var deflateSetDictionary_1 = deflateSetDictionary;
        var deflateInfo = 'pako deflate (from Nodeca project)';
        /* Not implemented
      module.exports.deflateBound = deflateBound;
      module.exports.deflateCopy = deflateCopy;
      module.exports.deflateParams = deflateParams;
      module.exports.deflatePending = deflatePending;
      module.exports.deflatePrime = deflatePrime;
      module.exports.deflateTune = deflateTune;
      */
        var deflate_1 = {
            deflateInit: deflateInit_1,
            deflateInit2: deflateInit2_1,
            deflateReset: deflateReset_1,
            deflateResetKeep: deflateResetKeep_1,
            deflateSetHeader: deflateSetHeader_1,
            deflate: deflate_2,
            deflateEnd: deflateEnd_1,
            deflateSetDictionary: deflateSetDictionary_1,
            deflateInfo: deflateInfo,
        };
        // Join array of chunks to single array.
        function flattenChunks(chunks) {
            // calculate data length
            var len = 0;
            for (var i = 0, l = chunks.length; i < l; i++) {
                len += chunks[i].length;
            } // join chunks
            var result = new Uint8Array(len);
            for (var _i = 0, pos = 0, _l = chunks.length; _i < _l; _i++) {
                var chunk = chunks[_i];
                result.set(chunk, pos);
                pos += chunk.length;
            }
            return result;
        }
        // String encode/decode helpers
        //
        // - apply(Array) can fail on Android 2.2
        // - apply(Uint8Array) can fail on iOS 5.1 Safari
        //
        // Table with utf8 lengths (calculated by first byte of sequence)
        // Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
        // because max possible codepoint is 0x10ffff
        var _utf8len = new Uint8Array(256);
        for (var q = 0; q < 256; q++) {
            _utf8len[q] = q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1;
        }
        _utf8len[254] = _utf8len[254] = 1; // Invalid sequence start
        // convert string to array (typed, when possible)
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.
        function ZStream() {
            /* next input byte */
            this.input = null; // JS specific, because we have no pointers
            this.next_in = 0;
            /* number of bytes available at input */
            this.avail_in = 0;
            /* total number of input bytes read so far */
            this.total_in = 0;
            /* next output byte should be put there */
            this.output = null; // JS specific, because we have no pointers
            this.next_out = 0;
            /* remaining free space at output */
            this.avail_out = 0;
            /* total number of bytes output so far */
            this.total_out = 0;
            /* last error message, NULL if no error */
            this.msg = '';
            /* Z_NULL */
            /* not visible by applications */
            this.state = null;
            /* best guess about the data type: binary or text */
            this.data_type = 2;
            /* Z_UNKNOWN */
            /* adler32 value of the uncompressed data */
            this.adler = 0;
        }
        var zstream = ZStream;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var toString = Object.prototype.toString;
        /* Public constants ========================================================== */
        /* =========================================================================== */
        var Z_NO_FLUSH$1 = constants.Z_NO_FLUSH;
        var Z_SYNC_FLUSH = constants.Z_SYNC_FLUSH;
        var Z_FULL_FLUSH$1 = constants.Z_FULL_FLUSH;
        var Z_FINISH$1 = constants.Z_FINISH;
        var Z_OK$1 = constants.Z_OK;
        var Z_STREAM_END$1 = constants.Z_STREAM_END;
        var Z_DEFAULT_COMPRESSION$1 = constants.Z_DEFAULT_COMPRESSION;
        var Z_DEFAULT_STRATEGY$1 = constants.Z_DEFAULT_STRATEGY;
        var Z_DEFLATED$1 = constants.Z_DEFLATED;
        /* =========================================================================== */
        /**
         * class Deflate
         *
         * Generic JS-style wrapper for zlib calls. If you don't need
         * streaming behaviour - use more simple functions: [[deflate]],
         * [[deflateRaw]] and [[gzip]].
         * */
        /* internal
         * Deflate.chunks -> Array
         *
         * Chunks of output data, if [[Deflate#onData]] not overridden.
         * */
        /**
         * Deflate.result -> Uint8Array
         *
         * Compressed result, generated by default [[Deflate#onData]]
         * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
         * (call [[Deflate#push]] with `Z_FINISH` / `true` param).
         * */
        /**
         * Deflate.err -> Number
         *
         * Error code after deflate finished. 0 (Z_OK) on success.
         * You will not need it in real life, because deflate errors
         * are possible only on wrong options or bad `onData` / `onEnd`
         * custom handlers.
         * */
        /**
         * Deflate.msg -> String
         *
         * Error message, if [[Deflate.err]] != 0
         * */
        /**
         * new Deflate(options)
         * - options (Object): zlib deflate options.
         *
         * Creates new deflator instance with specified params. Throws exception
         * on bad params. Supported options:
         *
         * - `level`
         * - `windowBits`
         * - `memLevel`
         * - `strategy`
         * - `dictionary`
         *
         * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
         * for more information on these.
         *
         * Additional options, for internal needs:
         *
         * * `chunkSize` - size of generated data chunks (16K by default)
         * * `raw` (Boolean) - do raw deflate
         * * `gzip` (Boolean) - create gzip wrapper
         * * `header` (Object) - custom header for gzip
         * ** `text` (Boolean) - true if compressed data believed to be text
         * ** `time` (Number) - modification time, unix timestamp
         * ** `os` (Number) - operation system code
         * ** `extra` (Array) - array of bytes with extra data (max 65536)
         * ** `name` (String) - file name (binary string)
         * ** `comment` (String) - comment (binary string)
         * ** `hcrc` (Boolean) - true if header crc should be added
         *
         * ##### Example:
         *
         * ```javascript
         * const pako = require('pako')
         *   , chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
         *   , chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
         *
         * const deflate = new pako.Deflate({ level: 3});
         *
         * deflate.push(chunk1, false);
         * deflate.push(chunk2, true);  // true -> last chunk
         *
         * if (deflate.err) { throw new Error(deflate.err); }
         *
         * console.log(deflate.result);
         * ```
         * */
        function Deflate() {
            this.options = {
                level: Z_DEFAULT_COMPRESSION$1,
                method: Z_DEFLATED$1,
                chunkSize: 16384,
                windowBits: 15,
                memLevel: 8,
                strategy: Z_DEFAULT_STRATEGY$1,
            };
            var opt = this.options;
            if (opt.raw && opt.windowBits > 0) {
                opt.windowBits = -opt.windowBits;
            }
            else if (opt.gzip && opt.windowBits > 0 && opt.windowBits < 16) {
                opt.windowBits += 16;
            }
            this.err = 0; // error code, if happens (0 = Z_OK)
            this.msg = ''; // error message
            this.ended = false; // used to avoid multiple onEnd() calls
            this.chunks = []; // chunks of compressed data
            this.strm = new zstream();
            this.strm.avail_out = 0;
            var status = deflate_1.deflateInit2(this.strm, opt.level, opt.method, opt.windowBits, opt.memLevel, opt.strategy);
            if (status !== Z_OK$1) {
                throw new Error(messages[status]);
            }
            if (opt.header) {
                deflate_1.deflateSetHeader(this.strm, opt.header);
            }
            if (opt.dictionary) {
                var dict; // Convert data if needed
                if (toString.call(opt.dictionary) === '[object ArrayBuffer]') {
                    dict = new Uint8Array(opt.dictionary);
                }
                else {
                    dict = opt.dictionary;
                }
                status = deflate_1.deflateSetDictionary(this.strm, dict);
                if (status !== Z_OK$1) {
                    throw new Error(messages[status]);
                }
                this._dict_set = true;
            }
        }
        /**
         * Deflate#push(data[, flush_mode]) -> Boolean
         * - data (Uint8Array|ArrayBuffer|String): input data. Strings will be
         * converted to utf8 byte sequence.
         * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
         * See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
         *
         * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
         * new compressed chunks. Returns `true` on success. The last data block must
         * have `flush_mode` Z_FINISH (or `true`). That will flush internal pending
         * buffers and call [[Deflate#onEnd]].
         *
         * On fail call [[Deflate#onEnd]] with error code and return false.
         *
         * ##### Example
         *
         * ```javascript
         * push(chunk, false); // push one of data chunks
         * ...
         * push(chunk, true);  // push last chunk
         * ```
         * */
        Deflate.prototype.push = function (data, flush_mode) {
            var strm = this.strm;
            var chunkSize = this.options.chunkSize;
            var status;
            var _flush_mode;
            if (this.ended) {
                return false;
            }
            if (flush_mode === ~~flush_mode) {
                _flush_mode = flush_mode;
            }
            else {
                _flush_mode = flush_mode === true ? Z_FINISH$1 : Z_NO_FLUSH$1;
            } // Convert data if needed
            if (toString.call(data) === '[object ArrayBuffer]') {
                strm.input = new Uint8Array(data);
            }
            else {
                strm.input = data;
            }
            strm.next_in = 0;
            strm.avail_in = strm.input.length;
            for (;;) {
                if (strm.avail_out === 0) {
                    strm.output = new Uint8Array(chunkSize);
                    strm.next_out = 0;
                    strm.avail_out = chunkSize;
                } // Make sure avail_out > 6 to avoid repeating markers
                if ((_flush_mode === Z_SYNC_FLUSH || _flush_mode === Z_FULL_FLUSH$1) && strm.avail_out <= 6) {
                    this.onData(strm.output.subarray(0, strm.next_out));
                    strm.avail_out = 0;
                    continue;
                }
                status = deflate_1.deflate(strm, _flush_mode); // Ended => flush and finish
                if (status === Z_STREAM_END$1) {
                    if (strm.next_out > 0) {
                        this.onData(strm.output.subarray(0, strm.next_out));
                    }
                    status = deflate_1.deflateEnd(this.strm);
                    this.onEnd(status);
                    this.ended = true;
                    return status === Z_OK$1;
                } // Flush if out buffer full
                if (strm.avail_out === 0) {
                    this.onData(strm.output);
                    continue;
                } // Flush if requested and has data
                if (_flush_mode > 0 && strm.next_out > 0) {
                    this.onData(strm.output.subarray(0, strm.next_out));
                    strm.avail_out = 0;
                    continue;
                }
                if (strm.avail_in === 0) {
                    break;
                }
            }
            return true;
        };
        /**
         * Deflate#onData(chunk) -> Void
         * - chunk (Uint8Array): output data.
         *
         * By default, stores data blocks in `chunks[]` property and glue
         * those in `onEnd`. Override this handler, if you need another behaviour.
         * */
        Deflate.prototype.onData = function (chunk) {
            this.chunks.push(chunk);
        };
        /**
         * Deflate#onEnd(status) -> Void
         * - status (Number): deflate status. 0 (Z_OK) on success,
         * other if not.
         *
         * Called once after you tell deflate that the input stream is
         * complete (Z_FINISH). By default - join collected chunks,
         * free memory and fill `results` / `err` properties.
         * */
        Deflate.prototype.onEnd = function (status) {
            // On success - join
            if (status === Z_OK$1) {
                this.result = flattenChunks(this.chunks);
            }
            this.chunks = [];
            this.err = status;
            this.msg = this.strm.msg;
        };
        // https://github.com/nodeca/pako/blob/26dff4fb3472c5532b3bd8856421146d35ab7592/lib/utils/strings.js#L26
        function string2buf(str) {
            if (typeof TextEncoder === 'function' && TextEncoder.prototype.encode) {
                return new TextEncoder().encode(str);
            }
            var buf;
            var c;
            var c2;
            var m_pos;
            var i;
            var str_len = str.length;
            var buf_len = 0;
            // count binary size
            for (m_pos = 0; m_pos < str_len; m_pos++) {
                c = str.charCodeAt(m_pos);
                if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
                    c2 = str.charCodeAt(m_pos + 1);
                    if ((c2 & 0xfc00) === 0xdc00) {
                        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
                        m_pos++;
                    }
                }
                buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
            }
            // allocate buffer
            buf = new Uint8Array(buf_len);
            // convert
            for (i = 0, m_pos = 0; i < buf_len; m_pos++) {
                c = str.charCodeAt(m_pos);
                if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
                    c2 = str.charCodeAt(m_pos + 1);
                    if ((c2 & 0xfc00) === 0xdc00) {
                        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
                        m_pos++;
                    }
                }
                if (c < 0x80) {
                    /* one byte */
                    buf[i++] = c;
                }
                else if (c < 0x800) {
                    /* two bytes */
                    buf[i++] = 0xc0 | (c >>> 6);
                    buf[i++] = 0x80 | (c & 0x3f);
                }
                else if (c < 0x10000) {
                    /* three bytes */
                    buf[i++] = 0xe0 | (c >>> 12);
                    buf[i++] = 0x80 | ((c >>> 6) & 0x3f);
                    buf[i++] = 0x80 | (c & 0x3f);
                }
                else {
                    /* four bytes */
                    buf[i++] = 0xf0 | (c >>> 18);
                    buf[i++] = 0x80 | ((c >>> 12) & 0x3f);
                    buf[i++] = 0x80 | ((c >>> 6) & 0x3f);
                    buf[i++] = 0x80 | (c & 0x3f);
                }
            }
            return buf;
        }
        return { Deflate: Deflate, constants: constants, string2buf: string2buf };
    }
}

},{}],542:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEGMENT_BYTES_LIMIT = exports.startDeflateWorker = exports.setSegmentBytesLimit = exports.startSegmentCollection = void 0;
var segmentCollection_1 = require("./segmentCollection");
Object.defineProperty(exports, "startSegmentCollection", { enumerable: true, get: function () { return segmentCollection_1.startSegmentCollection; } });
Object.defineProperty(exports, "setSegmentBytesLimit", { enumerable: true, get: function () { return segmentCollection_1.setSegmentBytesLimit; } });
var startDeflateWorker_1 = require("./startDeflateWorker");
Object.defineProperty(exports, "startDeflateWorker", { enumerable: true, get: function () { return startDeflateWorker_1.startDeflateWorker; } });
var segmentCollection_2 = require("./segmentCollection");
Object.defineProperty(exports, "SEGMENT_BYTES_LIMIT", { enumerable: true, get: function () { return segmentCollection_2.SEGMENT_BYTES_LIMIT; } });

},{"./segmentCollection":544,"./startDeflateWorker":545}],543:[function(require,module,exports){
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Segment = void 0;
var browser_core_1 = require("@datadog/browser-core");
var types_1 = require("../../types");
var replayStats = __importStar(require("../replayStats"));
var nextId = 0;
var Segment = /** @class */ (function () {
    function Segment(worker, context, creationReason, initialRecord, onWrote, onFlushed) {
        var _this = this;
        this.worker = worker;
        this.id = nextId++;
        var viewId = context.view.id;
        this.metadata = (0, browser_core_1.assign)({
            start: initialRecord.timestamp,
            end: initialRecord.timestamp,
            creation_reason: creationReason,
            records_count: 1,
            has_full_snapshot: initialRecord.type === types_1.RecordType.FullSnapshot,
            index_in_view: replayStats.getSegmentsCount(viewId),
            source: 'browser',
        }, context);
        replayStats.addSegment(viewId);
        replayStats.addRecord(viewId);
        var listener = (0, browser_core_1.monitor)(function (_a) {
            var data = _a.data;
            if (data.type === 'errored' || data.type === 'initialized') {
                return;
            }
            if (data.id === _this.id) {
                replayStats.addWroteData(viewId, data.additionalBytesCount);
                if (data.type === 'flushed') {
                    onFlushed(data.result, data.rawBytesCount);
                    worker.removeEventListener('message', listener);
                }
                else {
                    onWrote(data.compressedBytesCount);
                }
            }
            else if (data.id > _this.id) {
                // Messages should be received in the same order as they are sent, so if we receive a
                // message with an id superior to this Segment instance id, we know that another, more
                // recent Segment instance is being used.
                //
                // In theory, a "flush" response should have been received at this point, so the listener
                // should already have been removed. But if something goes wrong and we didn't receive a
                // "flush" response, remove the listener to avoid any leak, and send a monitor message to
                // help investigate the issue.
                worker.removeEventListener('message', listener);
                (0, browser_core_1.addTelemetryDebug)("Segment did not receive a 'flush' response before being replaced.");
            }
        });
        worker.addEventListener('message', listener);
        (0, browser_core_1.sendToExtension)('record', { record: initialRecord, segment: this.metadata });
        this.worker.postMessage({ data: "{\"records\":[".concat(JSON.stringify(initialRecord)), id: this.id, action: 'write' });
    }
    Segment.prototype.addRecord = function (record) {
        var _a;
        this.metadata.start = Math.min(this.metadata.start, record.timestamp);
        this.metadata.end = Math.max(this.metadata.end, record.timestamp);
        this.metadata.records_count += 1;
        replayStats.addRecord(this.metadata.view.id);
        (_a = this.metadata).has_full_snapshot || (_a.has_full_snapshot = record.type === types_1.RecordType.FullSnapshot);
        (0, browser_core_1.sendToExtension)('record', { record: record, segment: this.metadata });
        this.worker.postMessage({ data: ",".concat(JSON.stringify(record)), id: this.id, action: 'write' });
    };
    Segment.prototype.flush = function (reason) {
        this.worker.postMessage({
            data: "],".concat(JSON.stringify(this.metadata).slice(1), "\n"),
            id: this.id,
            action: 'flush',
        });
        this.flushReason = reason;
    };
    return Segment;
}());
exports.Segment = Segment;

},{"../../types":547,"../replayStats":539,"@datadog/browser-core":432}],544:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setSegmentBytesLimit = exports.computeSegmentContext = exports.doStartSegmentCollection = exports.startSegmentCollection = exports.SEGMENT_BYTES_LIMIT = exports.SEGMENT_DURATION_LIMIT = void 0;
var browser_core_1 = require("@datadog/browser-core");
var buildReplayPayload_1 = require("./buildReplayPayload");
var segment_1 = require("./segment");
exports.SEGMENT_DURATION_LIMIT = 30 * browser_core_1.ONE_SECOND;
/**
 * beacon payload max queue size implementation is 64kb
 * ensure that we leave room for logs, rum and potential other users
 */
exports.SEGMENT_BYTES_LIMIT = 60000;
// Segments are the main data structure for session replays. They contain context information used
// for indexing or UI needs, and a list of records (RRWeb 'events', renamed to avoid confusing
// namings). They are stored without any processing from the intake, and fetched one after the
// other while a session is being replayed. Their encoding (deflate) are carefully crafted to allow
// concatenating multiple segments together. Segments have a size overhead (metadata), so our goal is to
// build segments containing as many records as possible while complying with the various flush
// strategies to guarantee a good replay quality.
//
// When the recording starts, a segment is initially created.  The segment is flushed (finalized and
// sent) based on various events (non-exhaustive list):
//
// * the page visibility change or becomes to unload
// * the segment duration reaches a limit
// * the encoded segment bytes count reaches a limit
// * ...
//
// A segment cannot be created without its context.  If the RUM session ends and no session id is
// available when creating a new segment, records will be ignored, until the session is renewed and
// a new session id is available.
//
// Empty segments (segments with no record) aren't useful and should be ignored.
//
// To help investigate session replays issues, each segment is created with a "creation reason",
// indicating why the session has been created.
function startSegmentCollection(lifeCycle, applicationId, sessionManager, viewContexts, httpRequest, worker) {
    return doStartSegmentCollection(lifeCycle, function () { return computeSegmentContext(applicationId, sessionManager, viewContexts); }, httpRequest, worker);
}
exports.startSegmentCollection = startSegmentCollection;
function doStartSegmentCollection(lifeCycle, getSegmentContext, httpRequest, worker) {
    var state = {
        status: 0 /* WaitingForInitialRecord */,
        nextSegmentCreationReason: 'init',
    };
    var unsubscribeViewCreated = lifeCycle.subscribe(2 /* VIEW_CREATED */, function () {
        flushSegment('view_change');
    }).unsubscribe;
    var unsubscribePageExited = lifeCycle.subscribe(9 /* PAGE_EXITED */, function (pageExitEvent) {
        flushSegment(pageExitEvent.reason);
    }).unsubscribe;
    function flushSegment(flushReason) {
        if (state.status === 1 /* SegmentPending */) {
            state.segment.flush(flushReason);
            (0, browser_core_1.clearTimeout)(state.expirationTimeoutId);
        }
        if (flushReason !== 'stop') {
            state = {
                status: 0 /* WaitingForInitialRecord */,
                nextSegmentCreationReason: flushReason,
            };
        }
        else {
            state = {
                status: 2 /* Stopped */,
            };
        }
    }
    function createNewSegment(creationReason, initialRecord) {
        var context = getSegmentContext();
        if (!context) {
            return;
        }
        var segment = new segment_1.Segment(worker, context, creationReason, initialRecord, function (compressedSegmentBytesCount) {
            if (!segment.flushReason && compressedSegmentBytesCount > exports.SEGMENT_BYTES_LIMIT) {
                flushSegment('segment_bytes_limit');
            }
        }, function (data, rawSegmentBytesCount) {
            var payload = (0, buildReplayPayload_1.buildReplayPayload)(data, segment.metadata, rawSegmentBytesCount);
            if ((0, browser_core_1.isPageExitReason)(segment.flushReason)) {
                httpRequest.sendOnExit(payload);
            }
            else {
                httpRequest.send(payload);
            }
        });
        state = {
            status: 1 /* SegmentPending */,
            segment: segment,
            expirationTimeoutId: (0, browser_core_1.setTimeout)(function () {
                flushSegment('segment_duration_limit');
            }, exports.SEGMENT_DURATION_LIMIT),
        };
    }
    return {
        addRecord: function (record) {
            switch (state.status) {
                case 0 /* WaitingForInitialRecord */:
                    createNewSegment(state.nextSegmentCreationReason, record);
                    break;
                case 1 /* SegmentPending */:
                    state.segment.addRecord(record);
                    break;
            }
        },
        stop: function () {
            flushSegment('stop');
            unsubscribeViewCreated();
            unsubscribePageExited();
        },
    };
}
exports.doStartSegmentCollection = doStartSegmentCollection;
function computeSegmentContext(applicationId, sessionManager, viewContexts) {
    var session = sessionManager.findTrackedSession();
    var viewContext = viewContexts.findView();
    if (!session || !viewContext) {
        return undefined;
    }
    return {
        application: {
            id: applicationId,
        },
        session: {
            id: session.id,
        },
        view: {
            id: viewContext.id,
        },
    };
}
exports.computeSegmentContext = computeSegmentContext;
function setSegmentBytesLimit(newSegmentBytesLimit) {
    if (newSegmentBytesLimit === void 0) { newSegmentBytesLimit = 60000; }
    exports.SEGMENT_BYTES_LIMIT = newSegmentBytesLimit;
}
exports.setSegmentBytesLimit = setSegmentBytesLimit;

},{"./buildReplayPayload":540,"./segment":543,"@datadog/browser-core":432}],545:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.doStartDeflateWorker = exports.resetDeflateWorkerState = exports.startDeflateWorker = void 0;
var browser_core_1 = require("@datadog/browser-core");
var deflateWorker_1 = require("./deflateWorker");
var state = { status: 0 /* Nil */ };
function startDeflateWorker(callback, createDeflateWorkerImpl) {
    if (createDeflateWorkerImpl === void 0) { createDeflateWorkerImpl = deflateWorker_1.createDeflateWorker; }
    switch (state.status) {
        case 0 /* Nil */:
            state = { status: 1 /* Loading */, callbacks: [callback] };
            doStartDeflateWorker(createDeflateWorkerImpl);
            break;
        case 1 /* Loading */:
            state.callbacks.push(callback);
            break;
        case 2 /* Error */:
            callback();
            break;
        case 3 /* Initialized */:
            callback(state.worker);
            break;
    }
}
exports.startDeflateWorker = startDeflateWorker;
function resetDeflateWorkerState() {
    state = { status: 0 /* Nil */ };
}
exports.resetDeflateWorkerState = resetDeflateWorkerState;
/**
 * Starts the deflate worker and handle messages and errors
 *
 * The spec allow browsers to handle worker errors differently:
 * - Chromium throws an exception
 * - Firefox fires an error event
 *
 * more details: https://bugzilla.mozilla.org/show_bug.cgi?id=1736865#c2
 */
function doStartDeflateWorker(createDeflateWorkerImpl) {
    if (createDeflateWorkerImpl === void 0) { createDeflateWorkerImpl = deflateWorker_1.createDeflateWorker; }
    try {
        var worker_1 = createDeflateWorkerImpl();
        worker_1.addEventListener('error', (0, browser_core_1.monitor)(onError));
        worker_1.addEventListener('message', (0, browser_core_1.monitor)(function (_a) {
            var data = _a.data;
            if (data.type === 'errored') {
                onError(data.error);
            }
            else if (data.type === 'initialized') {
                onInitialized(worker_1);
            }
        }));
        worker_1.postMessage({ action: 'init' });
        return worker_1;
    }
    catch (error) {
        onError(error);
    }
}
exports.doStartDeflateWorker = doStartDeflateWorker;
function onInitialized(worker) {
    if (state.status === 1 /* Loading */) {
        state.callbacks.forEach(function (callback) { return callback(worker); });
        state = { status: 3 /* Initialized */, worker: worker };
    }
}
function onError(error) {
    if (state.status === 1 /* Loading */) {
        browser_core_1.display.error('Session Replay recording failed to start: an error occurred while creating the Worker:', error);
        if (error instanceof Event || (error instanceof Error && isMessageCspRelated(error.message))) {
            browser_core_1.display.error('Please make sure CSP is correctly configured ' +
                'https://docs.datadoghq.com/real_user_monitoring/faq/content_security_policy');
        }
        else {
            (0, browser_core_1.addTelemetryError)(error);
        }
        state.callbacks.forEach(function (callback) { return callback(); });
        state = { status: 2 /* Error */ };
    }
    else {
        (0, browser_core_1.addTelemetryError)(error);
    }
}
function isMessageCspRelated(message) {
    return ((0, browser_core_1.includes)(message, 'Content Security Policy') ||
        // Related to `require-trusted-types-for` CSP: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy/require-trusted-types-for
        (0, browser_core_1.includes)(message, "requires 'TrustedScriptURL'"));
}

},{"./deflateWorker":541,"@datadog/browser-core":432}],546:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.datadogRum = exports.DefaultPrivacyLevel = void 0;
// Keep the following in sync with packages/rum-slim/src/entries/main.ts
var browser_core_1 = require("@datadog/browser-core");
var browser_rum_core_1 = require("@datadog/browser-rum-core");
var startRecording_1 = require("../boot/startRecording");
var recorderApi_1 = require("../boot/recorderApi");
var browser_core_2 = require("@datadog/browser-core");
Object.defineProperty(exports, "DefaultPrivacyLevel", { enumerable: true, get: function () { return browser_core_2.DefaultPrivacyLevel; } });
var recorderApi = (0, recorderApi_1.makeRecorderApi)(startRecording_1.startRecording);
exports.datadogRum = (0, browser_rum_core_1.makeRumPublicApi)(browser_rum_core_1.startRum, recorderApi);
(0, browser_core_1.defineGlobal)((0, browser_core_1.getGlobalObject)(), 'DD_RUM', exports.datadogRum);

},{"../boot/recorderApi":508,"../boot/startRecording":509,"@datadog/browser-core":432,"@datadog/browser-rum-core":505}],547:[function(require,module,exports){
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./sessionReplay"), exports);
__exportStar(require("./sessionReplayConstants"), exports);

},{"./sessionReplay":548,"./sessionReplayConstants":549}],548:[function(require,module,exports){
"use strict";
/* eslint-disable */
/**
 * DO NOT MODIFY IT BY HAND. Run `yarn rum-events-format:sync` instead.
 */
Object.defineProperty(exports, "__esModule", { value: true });

},{}],549:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaInteractionType = exports.MouseInteractionType = exports.IncrementalSource = exports.NodeType = exports.RecordType = void 0;
exports.RecordType = {
    FullSnapshot: 2,
    IncrementalSnapshot: 3,
    Meta: 4,
    Focus: 6,
    ViewEnd: 7,
    VisualViewport: 8,
    FrustrationRecord: 9,
};
exports.NodeType = {
    Document: 0,
    DocumentType: 1,
    Element: 2,
    Text: 3,
    CDATA: 4,
    DocumentFragment: 11,
};
exports.IncrementalSource = {
    Mutation: 0,
    MouseMove: 1,
    MouseInteraction: 2,
    Scroll: 3,
    ViewportResize: 4,
    Input: 5,
    TouchMove: 6,
    MediaInteraction: 7,
    StyleSheetRule: 8,
    // CanvasMutation : 9,
    // Font : 10,
};
exports.MouseInteractionType = {
    MouseUp: 0,
    MouseDown: 1,
    Click: 2,
    ContextMenu: 3,
    DblClick: 4,
    Focus: 5,
    Blur: 6,
    TouchStart: 7,
    TouchEnd: 9,
};
exports.MediaInteractionType = {
    Play: 0,
    Pause: 1,
};

},{}],550:[function(require,module,exports){
/**
 * @license AngularJS v1.8.3
 * (c) 2010-2020 Google LLC. http://angularjs.org
 * License: MIT
 */
(function(window, angular) {'use strict';

/**
 * @ngdoc module
 * @name ngCookies
 * @description
 *
 * The `ngCookies` module provides a convenient wrapper for reading and writing browser cookies.
 *
 * See {@link ngCookies.$cookies `$cookies`} for usage.
 */


angular.module('ngCookies', ['ng']).
  info({ angularVersion: '1.8.3' }).
  /**
   * @ngdoc provider
   * @name $cookiesProvider
   * @description
   * Use `$cookiesProvider` to change the default behavior of the {@link ngCookies.$cookies $cookies} service.
   * */
   provider('$cookies', [/** @this */function $CookiesProvider() {
    /**
     * @ngdoc property
     * @name $cookiesProvider#defaults
     * @description
     *
     * Object containing default options to pass when setting cookies.
     *
     * The object may have following properties:
     *
     * - **path** - `{string}` - The cookie will be available only for this path and its
     *   sub-paths. By default, this is the URL that appears in your `<base>` tag.
     * - **domain** - `{string}` - The cookie will be available only for this domain and
     *   its sub-domains. For security reasons the user agent will not accept the cookie
     *   if the current domain is not a sub-domain of this domain or equal to it.
     * - **expires** - `{string|Date}` - String of the form "Wdy, DD Mon YYYY HH:MM:SS GMT"
     *   or a Date object indicating the exact date/time this cookie will expire.
     * - **secure** - `{boolean}` - If `true`, then the cookie will only be available through a
     *   secured connection.
     * - **samesite** - `{string}` - prevents the browser from sending the cookie along with cross-site requests.
     *   Accepts the values `lax` and `strict`. See the [OWASP Wiki](https://www.owasp.org/index.php/SameSite)
     *   for more info. Note that as of May 2018, not all browsers support `SameSite`,
     *   so it cannot be used as a single measure against Cross-Site-Request-Forgery (CSRF) attacks.
     *
     * Note: By default, the address that appears in your `<base>` tag will be used as the path.
     * This is important so that cookies will be visible for all routes when html5mode is enabled.
     *
     * @example
     *
     * ```js
     * angular.module('cookiesProviderExample', ['ngCookies'])
     *   .config(['$cookiesProvider', function($cookiesProvider) {
     *     // Setting default options
     *     $cookiesProvider.defaults.domain = 'foo.com';
     *     $cookiesProvider.defaults.secure = true;
     *   }]);
     * ```
     **/
    var defaults = this.defaults = {};

    function calcOptions(options) {
      return options ? angular.extend({}, defaults, options) : defaults;
    }

    /**
     * @ngdoc service
     * @name $cookies
     *
     * @description
     * Provides read/write access to browser's cookies.
     *
     * <div class="alert alert-info">
     * Up until AngularJS 1.3, `$cookies` exposed properties that represented the
     * current browser cookie values. In version 1.4, this behavior has changed, and
     * `$cookies` now provides a standard api of getters, setters etc.
     * </div>
     *
     * Requires the {@link ngCookies `ngCookies`} module to be installed.
     *
     * @example
     *
     * ```js
     * angular.module('cookiesExample', ['ngCookies'])
     *   .controller('ExampleController', ['$cookies', function($cookies) {
     *     // Retrieving a cookie
     *     var favoriteCookie = $cookies.get('myFavorite');
     *     // Setting a cookie
     *     $cookies.put('myFavorite', 'oatmeal');
     *   }]);
     * ```
     */
    this.$get = ['$$cookieReader', '$$cookieWriter', function($$cookieReader, $$cookieWriter) {
      return {
        /**
         * @ngdoc method
         * @name $cookies#get
         *
         * @description
         * Returns the value of given cookie key
         *
         * @param {string} key Id to use for lookup.
         * @returns {string} Raw cookie value.
         */
        get: function(key) {
          return $$cookieReader()[key];
        },

        /**
         * @ngdoc method
         * @name $cookies#getObject
         *
         * @description
         * Returns the deserialized value of given cookie key
         *
         * @param {string} key Id to use for lookup.
         * @returns {Object} Deserialized cookie value.
         */
        getObject: function(key) {
          var value = this.get(key);
          return value ? angular.fromJson(value) : value;
        },

        /**
         * @ngdoc method
         * @name $cookies#getAll
         *
         * @description
         * Returns a key value object with all the cookies
         *
         * @returns {Object} All cookies
         */
        getAll: function() {
          return $$cookieReader();
        },

        /**
         * @ngdoc method
         * @name $cookies#put
         *
         * @description
         * Sets a value for given cookie key
         *
         * @param {string} key Id for the `value`.
         * @param {string} value Raw value to be stored.
         * @param {Object=} options Options object.
         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
         */
        put: function(key, value, options) {
          $$cookieWriter(key, value, calcOptions(options));
        },

        /**
         * @ngdoc method
         * @name $cookies#putObject
         *
         * @description
         * Serializes and sets a value for given cookie key
         *
         * @param {string} key Id for the `value`.
         * @param {Object} value Value to be stored.
         * @param {Object=} options Options object.
         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
         */
        putObject: function(key, value, options) {
          this.put(key, angular.toJson(value), options);
        },

        /**
         * @ngdoc method
         * @name $cookies#remove
         *
         * @description
         * Remove given cookie
         *
         * @param {string} key Id of the key-value pair to delete.
         * @param {Object=} options Options object.
         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
         */
        remove: function(key, options) {
          $$cookieWriter(key, undefined, calcOptions(options));
        }
      };
    }];
  }]);

/**
 * @name $$cookieWriter
 * @requires $document
 *
 * @description
 * This is a private service for writing cookies
 *
 * @param {string} name Cookie name
 * @param {string=} value Cookie value (if undefined, cookie will be deleted)
 * @param {Object=} options Object with options that need to be stored for the cookie.
 */
function $$CookieWriter($document, $log, $browser) {
  var cookiePath = $browser.baseHref();
  var rawDocument = $document[0];

  function buildCookieString(name, value, options) {
    var path, expires;
    options = options || {};
    expires = options.expires;
    path = angular.isDefined(options.path) ? options.path : cookiePath;
    if (angular.isUndefined(value)) {
      expires = 'Thu, 01 Jan 1970 00:00:00 GMT';
      value = '';
    }
    if (angular.isString(expires)) {
      expires = new Date(expires);
    }

    var str = encodeURIComponent(name) + '=' + encodeURIComponent(value);
    str += path ? ';path=' + path : '';
    str += options.domain ? ';domain=' + options.domain : '';
    str += expires ? ';expires=' + expires.toUTCString() : '';
    str += options.secure ? ';secure' : '';
    str += options.samesite ? ';samesite=' + options.samesite : '';

    // per http://www.ietf.org/rfc/rfc2109.txt browser must allow at minimum:
    // - 300 cookies
    // - 20 cookies per unique domain
    // - 4096 bytes per cookie
    var cookieLength = str.length + 1;
    if (cookieLength > 4096) {
      $log.warn('Cookie \'' + name +
        '\' possibly not set or overflowed because it was too large (' +
        cookieLength + ' > 4096 bytes)!');
    }

    return str;
  }

  return function(name, value, options) {
    rawDocument.cookie = buildCookieString(name, value, options);
  };
}

$$CookieWriter.$inject = ['$document', '$log', '$browser'];

angular.module('ngCookies').provider('$$cookieWriter', /** @this */ function $$CookieWriterProvider() {
  this.$get = $$CookieWriter;
});


})(window, window.angular);

},{}],551:[function(require,module,exports){
require('./angular-cookies');
module.exports = 'ngCookies';

},{"./angular-cookies":550}],552:[function(require,module,exports){
/**
 * @license AngularJS v1.8.3
 * (c) 2010-2020 Google LLC. http://angularjs.org
 * License: MIT
 */
(function(window, angular) {'use strict';

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables likes document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

var $sanitizeMinErr = angular.$$minErr('$sanitize');
var bind;
var extend;
var forEach;
var isArray;
var isDefined;
var lowercase;
var noop;
var nodeContains;
var htmlParser;
var htmlSanitizeWriter;

/**
 * @ngdoc module
 * @name ngSanitize
 * @description
 *
 * The `ngSanitize` module provides functionality to sanitize HTML.
 *
 * See {@link ngSanitize.$sanitize `$sanitize`} for usage.
 */

/**
 * @ngdoc service
 * @name $sanitize
 * @kind function
 *
 * @description
 *   Sanitizes an html string by stripping all potentially dangerous tokens.
 *
 *   The input is sanitized by parsing the HTML into tokens. All safe tokens (from a trusted URI list) are
 *   then serialized back to a properly escaped HTML string. This means that no unsafe input can make
 *   it into the returned string.
 *
 *   The trusted URIs for URL sanitization of attribute values is configured using the functions
 *   `aHrefSanitizationTrustedUrlList` and `imgSrcSanitizationTrustedUrlList` of {@link $compileProvider}.
 *
 *   The input may also contain SVG markup if this is enabled via {@link $sanitizeProvider}.
 *
 * @param {string} html HTML input.
 * @returns {string} Sanitized HTML.
 *
 * @example
   <example module="sanitizeExample" deps="angular-sanitize.js" name="sanitize-service">
   <file name="index.html">
     <script>
         angular.module('sanitizeExample', ['ngSanitize'])
           .controller('ExampleController', ['$scope', '$sce', function($scope, $sce) {
             $scope.snippet =
               '<p style="color:blue">an html\n' +
               '<em onmouseover="this.textContent=\'PWN3D!\'">click here</em>\n' +
               'snippet</p>';
             $scope.deliberatelyTrustDangerousSnippet = function() {
               return $sce.trustAsHtml($scope.snippet);
             };
           }]);
     </script>
     <div ng-controller="ExampleController">
        Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
       <table>
         <tr>
           <td>Directive</td>
           <td>How</td>
           <td>Source</td>
           <td>Rendered</td>
         </tr>
         <tr id="bind-html-with-sanitize">
           <td>ng-bind-html</td>
           <td>Automatically uses $sanitize</td>
           <td><pre>&lt;div ng-bind-html="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
           <td><div ng-bind-html="snippet"></div></td>
         </tr>
         <tr id="bind-html-with-trust">
           <td>ng-bind-html</td>
           <td>Bypass $sanitize by explicitly trusting the dangerous value</td>
           <td>
           <pre>&lt;div ng-bind-html="deliberatelyTrustDangerousSnippet()"&gt;
&lt;/div&gt;</pre>
           </td>
           <td><div ng-bind-html="deliberatelyTrustDangerousSnippet()"></div></td>
         </tr>
         <tr id="bind-default">
           <td>ng-bind</td>
           <td>Automatically escapes</td>
           <td><pre>&lt;div ng-bind="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
           <td><div ng-bind="snippet"></div></td>
         </tr>
       </table>
       </div>
   </file>
   <file name="protractor.js" type="protractor">
     it('should sanitize the html snippet by default', function() {
       expect(element(by.css('#bind-html-with-sanitize div')).getAttribute('innerHTML')).
         toBe('<p>an html\n<em>click here</em>\nsnippet</p>');
     });

     it('should inline raw snippet if bound to a trusted value', function() {
       expect(element(by.css('#bind-html-with-trust div')).getAttribute('innerHTML')).
         toBe("<p style=\"color:blue\">an html\n" +
              "<em onmouseover=\"this.textContent='PWN3D!'\">click here</em>\n" +
              "snippet</p>");
     });

     it('should escape snippet without any filter', function() {
       expect(element(by.css('#bind-default div')).getAttribute('innerHTML')).
         toBe("&lt;p style=\"color:blue\"&gt;an html\n" +
              "&lt;em onmouseover=\"this.textContent='PWN3D!'\"&gt;click here&lt;/em&gt;\n" +
              "snippet&lt;/p&gt;");
     });

     it('should update', function() {
       element(by.model('snippet')).clear();
       element(by.model('snippet')).sendKeys('new <b onclick="alert(1)">text</b>');
       expect(element(by.css('#bind-html-with-sanitize div')).getAttribute('innerHTML')).
         toBe('new <b>text</b>');
       expect(element(by.css('#bind-html-with-trust div')).getAttribute('innerHTML')).toBe(
         'new <b onclick="alert(1)">text</b>');
       expect(element(by.css('#bind-default div')).getAttribute('innerHTML')).toBe(
         "new &lt;b onclick=\"alert(1)\"&gt;text&lt;/b&gt;");
     });
   </file>
   </example>
 */


/**
 * @ngdoc provider
 * @name $sanitizeProvider
 * @this
 *
 * @description
 * Creates and configures {@link $sanitize} instance.
 */
function $SanitizeProvider() {
  var hasBeenInstantiated = false;
  var svgEnabled = false;

  this.$get = ['$$sanitizeUri', function($$sanitizeUri) {
    hasBeenInstantiated = true;
    if (svgEnabled) {
      extend(validElements, svgElements);
    }
    return function(html) {
      var buf = [];
      htmlParser(html, htmlSanitizeWriter(buf, function(uri, isImage) {
        return !/^unsafe:/.test($$sanitizeUri(uri, isImage));
      }));
      return buf.join('');
    };
  }];


  /**
   * @ngdoc method
   * @name $sanitizeProvider#enableSvg
   * @kind function
   *
   * @description
   * Enables a subset of svg to be supported by the sanitizer.
   *
   * <div class="alert alert-warning">
   *   <p>By enabling this setting without taking other precautions, you might expose your
   *   application to click-hijacking attacks. In these attacks, sanitized svg elements could be positioned
   *   outside of the containing element and be rendered over other elements on the page (e.g. a login
   *   link). Such behavior can then result in phishing incidents.</p>
   *
   *   <p>To protect against these, explicitly setup `overflow: hidden` css rule for all potential svg
   *   tags within the sanitized content:</p>
   *
   *   <br>
   *
   *   <pre><code>
   *   .rootOfTheIncludedContent svg {
   *     overflow: hidden !important;
   *   }
   *   </code></pre>
   * </div>
   *
   * @param {boolean=} flag Enable or disable SVG support in the sanitizer.
   * @returns {boolean|$sanitizeProvider} Returns the currently configured value if called
   *    without an argument or self for chaining otherwise.
   */
  this.enableSvg = function(enableSvg) {
    if (isDefined(enableSvg)) {
      svgEnabled = enableSvg;
      return this;
    } else {
      return svgEnabled;
    }
  };


  /**
   * @ngdoc method
   * @name $sanitizeProvider#addValidElements
   * @kind function
   *
   * @description
   * Extends the built-in lists of valid HTML/SVG elements, i.e. elements that are considered safe
   * and are not stripped off during sanitization. You can extend the following lists of elements:
   *
   * - `htmlElements`: A list of elements (tag names) to extend the current list of safe HTML
   *   elements. HTML elements considered safe will not be removed during sanitization. All other
   *   elements will be stripped off.
   *
   * - `htmlVoidElements`: This is similar to `htmlElements`, but marks the elements as
   *   "void elements" (similar to HTML
   *   [void elements](https://rawgit.com/w3c/html/html5.1-2/single-page.html#void-elements)). These
   *   elements have no end tag and cannot have content.
   *
   * - `svgElements`: This is similar to `htmlElements`, but for SVG elements. This list is only
   *   taken into account if SVG is {@link ngSanitize.$sanitizeProvider#enableSvg enabled} for
   *   `$sanitize`.
   *
   * <div class="alert alert-info">
   *   This method must be called during the {@link angular.Module#config config} phase. Once the
   *   `$sanitize` service has been instantiated, this method has no effect.
   * </div>
   *
   * <div class="alert alert-warning">
   *   Keep in mind that extending the built-in lists of elements may expose your app to XSS or
   *   other vulnerabilities. Be very mindful of the elements you add.
   * </div>
   *
   * @param {Array<String>|Object} elements - A list of valid HTML elements or an object with one or
   *   more of the following properties:
   *   - **htmlElements** - `{Array<String>}` - A list of elements to extend the current list of
   *     HTML elements.
   *   - **htmlVoidElements** - `{Array<String>}` - A list of elements to extend the current list of
   *     void HTML elements; i.e. elements that do not have an end tag.
   *   - **svgElements** - `{Array<String>}` - A list of elements to extend the current list of SVG
   *     elements. The list of SVG elements is only taken into account if SVG is
   *     {@link ngSanitize.$sanitizeProvider#enableSvg enabled} for `$sanitize`.
   *
   * Passing an array (`[...]`) is equivalent to passing `{htmlElements: [...]}`.
   *
   * @return {$sanitizeProvider} Returns self for chaining.
   */
  this.addValidElements = function(elements) {
    if (!hasBeenInstantiated) {
      if (isArray(elements)) {
        elements = {htmlElements: elements};
      }

      addElementsTo(svgElements, elements.svgElements);
      addElementsTo(voidElements, elements.htmlVoidElements);
      addElementsTo(validElements, elements.htmlVoidElements);
      addElementsTo(validElements, elements.htmlElements);
    }

    return this;
  };


  /**
   * @ngdoc method
   * @name $sanitizeProvider#addValidAttrs
   * @kind function
   *
   * @description
   * Extends the built-in list of valid attributes, i.e. attributes that are considered safe and are
   * not stripped off during sanitization.
   *
   * **Note**:
   * The new attributes will not be treated as URI attributes, which means their values will not be
   * sanitized as URIs using `$compileProvider`'s
   * {@link ng.$compileProvider#aHrefSanitizationTrustedUrlList aHrefSanitizationTrustedUrlList} and
   * {@link ng.$compileProvider#imgSrcSanitizationTrustedUrlList imgSrcSanitizationTrustedUrlList}.
   *
   * <div class="alert alert-info">
   *   This method must be called during the {@link angular.Module#config config} phase. Once the
   *   `$sanitize` service has been instantiated, this method has no effect.
   * </div>
   *
   * <div class="alert alert-warning">
   *   Keep in mind that extending the built-in list of attributes may expose your app to XSS or
   *   other vulnerabilities. Be very mindful of the attributes you add.
   * </div>
   *
   * @param {Array<String>} attrs - A list of valid attributes.
   *
   * @returns {$sanitizeProvider} Returns self for chaining.
   */
  this.addValidAttrs = function(attrs) {
    if (!hasBeenInstantiated) {
      extend(validAttrs, arrayToMap(attrs, true));
    }
    return this;
  };

  //////////////////////////////////////////////////////////////////////////////////////////////////
  // Private stuff
  //////////////////////////////////////////////////////////////////////////////////////////////////

  bind = angular.bind;
  extend = angular.extend;
  forEach = angular.forEach;
  isArray = angular.isArray;
  isDefined = angular.isDefined;
  lowercase = angular.$$lowercase;
  noop = angular.noop;

  htmlParser = htmlParserImpl;
  htmlSanitizeWriter = htmlSanitizeWriterImpl;

  nodeContains = window.Node.prototype.contains || /** @this */ function(arg) {
    // eslint-disable-next-line no-bitwise
    return !!(this.compareDocumentPosition(arg) & 16);
  };

  // Regular Expressions for parsing tags and attributes
  var SURROGATE_PAIR_REGEXP = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
    // Match everything outside of normal chars and " (quote character)
    NON_ALPHANUMERIC_REGEXP = /([^#-~ |!])/g;


  // Good source of info about elements and attributes
  // http://dev.w3.org/html5/spec/Overview.html#semantics
  // http://simon.html5.org/html-elements

  // Safe Void Elements - HTML5
  // http://dev.w3.org/html5/spec/Overview.html#void-elements
  var voidElements = stringToMap('area,br,col,hr,img,wbr');

  // Elements that you can, intentionally, leave open (and which close themselves)
  // http://dev.w3.org/html5/spec/Overview.html#optional-tags
  var optionalEndTagBlockElements = stringToMap('colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr'),
      optionalEndTagInlineElements = stringToMap('rp,rt'),
      optionalEndTagElements = extend({},
                                              optionalEndTagInlineElements,
                                              optionalEndTagBlockElements);

  // Safe Block Elements - HTML5
  var blockElements = extend({}, optionalEndTagBlockElements, stringToMap('address,article,' +
          'aside,blockquote,caption,center,del,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5,' +
          'h6,header,hgroup,hr,ins,map,menu,nav,ol,pre,section,table,ul'));

  // Inline Elements - HTML5
  var inlineElements = extend({}, optionalEndTagInlineElements, stringToMap('a,abbr,acronym,b,' +
          'bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,q,ruby,rp,rt,s,' +
          'samp,small,span,strike,strong,sub,sup,time,tt,u,var'));

  // SVG Elements
  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Elements
  // Note: the elements animate,animateColor,animateMotion,animateTransform,set are intentionally omitted.
  // They can potentially allow for arbitrary javascript to be executed. See #11290
  var svgElements = stringToMap('circle,defs,desc,ellipse,font-face,font-face-name,font-face-src,g,glyph,' +
          'hkern,image,linearGradient,line,marker,metadata,missing-glyph,mpath,path,polygon,polyline,' +
          'radialGradient,rect,stop,svg,switch,text,title,tspan');

  // Blocked Elements (will be stripped)
  var blockedElements = stringToMap('script,style');

  var validElements = extend({},
                                     voidElements,
                                     blockElements,
                                     inlineElements,
                                     optionalEndTagElements);

  //Attributes that have href and hence need to be sanitized
  var uriAttrs = stringToMap('background,cite,href,longdesc,src,xlink:href,xml:base');

  var htmlAttrs = stringToMap('abbr,align,alt,axis,bgcolor,border,cellpadding,cellspacing,class,clear,' +
      'color,cols,colspan,compact,coords,dir,face,headers,height,hreflang,hspace,' +
      'ismap,lang,language,nohref,nowrap,rel,rev,rows,rowspan,rules,' +
      'scope,scrolling,shape,size,span,start,summary,tabindex,target,title,type,' +
      'valign,value,vspace,width');

  // SVG attributes (without "id" and "name" attributes)
  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Attributes
  var svgAttrs = stringToMap('accent-height,accumulate,additive,alphabetic,arabic-form,ascent,' +
      'baseProfile,bbox,begin,by,calcMode,cap-height,class,color,color-rendering,content,' +
      'cx,cy,d,dx,dy,descent,display,dur,end,fill,fill-rule,font-family,font-size,font-stretch,' +
      'font-style,font-variant,font-weight,from,fx,fy,g1,g2,glyph-name,gradientUnits,hanging,' +
      'height,horiz-adv-x,horiz-origin-x,ideographic,k,keyPoints,keySplines,keyTimes,lang,' +
      'marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mathematical,' +
      'max,min,offset,opacity,orient,origin,overline-position,overline-thickness,panose-1,' +
      'path,pathLength,points,preserveAspectRatio,r,refX,refY,repeatCount,repeatDur,' +
      'requiredExtensions,requiredFeatures,restart,rotate,rx,ry,slope,stemh,stemv,stop-color,' +
      'stop-opacity,strikethrough-position,strikethrough-thickness,stroke,stroke-dasharray,' +
      'stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,' +
      'stroke-width,systemLanguage,target,text-anchor,to,transform,type,u1,u2,underline-position,' +
      'underline-thickness,unicode,unicode-range,units-per-em,values,version,viewBox,visibility,' +
      'width,widths,x,x-height,x1,x2,xlink:actuate,xlink:arcrole,xlink:role,xlink:show,xlink:title,' +
      'xlink:type,xml:base,xml:lang,xml:space,xmlns,xmlns:xlink,y,y1,y2,zoomAndPan', true);

  var validAttrs = extend({},
                                  uriAttrs,
                                  svgAttrs,
                                  htmlAttrs);

  function stringToMap(str, lowercaseKeys) {
    return arrayToMap(str.split(','), lowercaseKeys);
  }

  function arrayToMap(items, lowercaseKeys) {
    var obj = {}, i;
    for (i = 0; i < items.length; i++) {
      obj[lowercaseKeys ? lowercase(items[i]) : items[i]] = true;
    }
    return obj;
  }

  function addElementsTo(elementsMap, newElements) {
    if (newElements && newElements.length) {
      extend(elementsMap, arrayToMap(newElements));
    }
  }

  /**
   * Create an inert document that contains the dirty HTML that needs sanitizing.
   * We use the DOMParser API by default and fall back to createHTMLDocument if DOMParser is not
   * available.
   */
  var getInertBodyElement /* function(html: string): HTMLBodyElement */ = (function(window, document) {
    if (isDOMParserAvailable()) {
      return getInertBodyElement_DOMParser;
    }

    if (!document || !document.implementation) {
      throw $sanitizeMinErr('noinert', 'Can\'t create an inert html document');
    }
    var inertDocument = document.implementation.createHTMLDocument('inert');
    var inertBodyElement = (inertDocument.documentElement || inertDocument.getDocumentElement()).querySelector('body');
    return getInertBodyElement_InertDocument;

    function isDOMParserAvailable() {
      try {
        return !!getInertBodyElement_DOMParser('');
      } catch (e) {
        return false;
      }
    }

    function getInertBodyElement_DOMParser(html) {
      // We add this dummy element to ensure that the rest of the content is parsed as expected
      // e.g. leading whitespace is maintained and tags like `<meta>` do not get hoisted to the `<head>` tag.
      html = '<remove></remove>' + html;
      try {
        var body = new window.DOMParser().parseFromString(html, 'text/html').body;
        body.firstChild.remove();
        return body;
      } catch (e) {
        return undefined;
      }
    }

    function getInertBodyElement_InertDocument(html) {
      inertBodyElement.innerHTML = html;

      // Support: IE 9-11 only
      // strip custom-namespaced attributes on IE<=11
      if (document.documentMode) {
        stripCustomNsAttrs(inertBodyElement);
      }

      return inertBodyElement;
    }
  })(window, window.document);

  /**
   * @example
   * htmlParser(htmlString, {
   *     start: function(tag, attrs) {},
   *     end: function(tag) {},
   *     chars: function(text) {},
   *     comment: function(text) {}
   * });
   *
   * @param {string} html string
   * @param {object} handler
   */
  function htmlParserImpl(html, handler) {
    if (html === null || html === undefined) {
      html = '';
    } else if (typeof html !== 'string') {
      html = '' + html;
    }

    var inertBodyElement = getInertBodyElement(html);
    if (!inertBodyElement) return '';

    //mXSS protection
    var mXSSAttempts = 5;
    do {
      if (mXSSAttempts === 0) {
        throw $sanitizeMinErr('uinput', 'Failed to sanitize html because the input is unstable');
      }
      mXSSAttempts--;

      // trigger mXSS if it is going to happen by reading and writing the innerHTML
      html = inertBodyElement.innerHTML;
      inertBodyElement = getInertBodyElement(html);
    } while (html !== inertBodyElement.innerHTML);

    var node = inertBodyElement.firstChild;
    while (node) {
      switch (node.nodeType) {
        case 1: // ELEMENT_NODE
          handler.start(node.nodeName.toLowerCase(), attrToMap(node.attributes));
          break;
        case 3: // TEXT NODE
          handler.chars(node.textContent);
          break;
      }

      var nextNode;
      if (!(nextNode = node.firstChild)) {
        if (node.nodeType === 1) {
          handler.end(node.nodeName.toLowerCase());
        }
        nextNode = getNonDescendant('nextSibling', node);
        if (!nextNode) {
          while (nextNode == null) {
            node = getNonDescendant('parentNode', node);
            if (node === inertBodyElement) break;
            nextNode = getNonDescendant('nextSibling', node);
            if (node.nodeType === 1) {
              handler.end(node.nodeName.toLowerCase());
            }
          }
        }
      }
      node = nextNode;
    }

    while ((node = inertBodyElement.firstChild)) {
      inertBodyElement.removeChild(node);
    }
  }

  function attrToMap(attrs) {
    var map = {};
    for (var i = 0, ii = attrs.length; i < ii; i++) {
      var attr = attrs[i];
      map[attr.name] = attr.value;
    }
    return map;
  }


  /**
   * Escapes all potentially dangerous characters, so that the
   * resulting string can be safely inserted into attribute or
   * element text.
   * @param value
   * @returns {string} escaped text
   */
  function encodeEntities(value) {
    return value.
      replace(/&/g, '&amp;').
      replace(SURROGATE_PAIR_REGEXP, function(value) {
        var hi = value.charCodeAt(0);
        var low = value.charCodeAt(1);
        return '&#' + (((hi - 0xD800) * 0x400) + (low - 0xDC00) + 0x10000) + ';';
      }).
      replace(NON_ALPHANUMERIC_REGEXP, function(value) {
        return '&#' + value.charCodeAt(0) + ';';
      }).
      replace(/</g, '&lt;').
      replace(/>/g, '&gt;');
  }

  /**
   * create an HTML/XML writer which writes to buffer
   * @param {Array} buf use buf.join('') to get out sanitized html string
   * @returns {object} in the form of {
   *     start: function(tag, attrs) {},
   *     end: function(tag) {},
   *     chars: function(text) {},
   *     comment: function(text) {}
   * }
   */
  function htmlSanitizeWriterImpl(buf, uriValidator) {
    var ignoreCurrentElement = false;
    var out = bind(buf, buf.push);
    return {
      start: function(tag, attrs) {
        tag = lowercase(tag);
        if (!ignoreCurrentElement && blockedElements[tag]) {
          ignoreCurrentElement = tag;
        }
        if (!ignoreCurrentElement && validElements[tag] === true) {
          out('<');
          out(tag);
          forEach(attrs, function(value, key) {
            var lkey = lowercase(key);
            var isImage = (tag === 'img' && lkey === 'src') || (lkey === 'background');
            if (validAttrs[lkey] === true &&
              (uriAttrs[lkey] !== true || uriValidator(value, isImage))) {
              out(' ');
              out(key);
              out('="');
              out(encodeEntities(value));
              out('"');
            }
          });
          out('>');
        }
      },
      end: function(tag) {
        tag = lowercase(tag);
        if (!ignoreCurrentElement && validElements[tag] === true && voidElements[tag] !== true) {
          out('</');
          out(tag);
          out('>');
        }
        // eslint-disable-next-line eqeqeq
        if (tag == ignoreCurrentElement) {
          ignoreCurrentElement = false;
        }
      },
      chars: function(chars) {
        if (!ignoreCurrentElement) {
          out(encodeEntities(chars));
        }
      }
    };
  }


  /**
   * When IE9-11 comes across an unknown namespaced attribute e.g. 'xlink:foo' it adds 'xmlns:ns1' attribute to declare
   * ns1 namespace and prefixes the attribute with 'ns1' (e.g. 'ns1:xlink:foo'). This is undesirable since we don't want
   * to allow any of these custom attributes. This method strips them all.
   *
   * @param node Root element to process
   */
  function stripCustomNsAttrs(node) {
    while (node) {
      if (node.nodeType === window.Node.ELEMENT_NODE) {
        var attrs = node.attributes;
        for (var i = 0, l = attrs.length; i < l; i++) {
          var attrNode = attrs[i];
          var attrName = attrNode.name.toLowerCase();
          if (attrName === 'xmlns:ns1' || attrName.lastIndexOf('ns1:', 0) === 0) {
            node.removeAttributeNode(attrNode);
            i--;
            l--;
          }
        }
      }

      var nextNode = node.firstChild;
      if (nextNode) {
        stripCustomNsAttrs(nextNode);
      }

      node = getNonDescendant('nextSibling', node);
    }
  }

  function getNonDescendant(propName, node) {
    // An element is clobbered if its `propName` property points to one of its descendants
    var nextNode = node[propName];
    if (nextNode && nodeContains.call(node, nextNode)) {
      throw $sanitizeMinErr('elclob', 'Failed to sanitize html because the element is clobbered: {0}', node.outerHTML || node.outerText);
    }
    return nextNode;
  }
}

function sanitizeText(chars) {
  var buf = [];
  var writer = htmlSanitizeWriter(buf, noop);
  writer.chars(chars);
  return buf.join('');
}


// define ngSanitize module and register $sanitize service
angular.module('ngSanitize', [])
  .provider('$sanitize', $SanitizeProvider)
  .info({ angularVersion: '1.8.3' });

/**
 * @ngdoc filter
 * @name linky
 * @kind function
 *
 * @description
 * Finds links in text input and turns them into html links. Supports `http/https/ftp/sftp/mailto` and
 * plain email address links.
 *
 * Requires the {@link ngSanitize `ngSanitize`} module to be installed.
 *
 * @param {string} text Input text.
 * @param {string} [target] Window (`_blank|_self|_parent|_top`) or named frame to open links in.
 * @param {object|function(url)} [attributes] Add custom attributes to the link element.
 *
 *    Can be one of:
 *
 *    - `object`: A map of attributes
 *    - `function`: Takes the url as a parameter and returns a map of attributes
 *
 *    If the map of attributes contains a value for `target`, it overrides the value of
 *    the target parameter.
 *
 *
 * @returns {string} Html-linkified and {@link $sanitize sanitized} text.
 *
 * @usage
   <span ng-bind-html="linky_expression | linky"></span>
 *
 * @example
   <example module="linkyExample" deps="angular-sanitize.js" name="linky-filter">
     <file name="index.html">
       <div ng-controller="ExampleController">
       Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
       <table>
         <tr>
           <th>Filter</th>
           <th>Source</th>
           <th>Rendered</th>
         </tr>
         <tr id="linky-filter">
           <td>linky filter</td>
           <td>
             <pre>&lt;div ng-bind-html="snippet | linky"&gt;<br>&lt;/div&gt;</pre>
           </td>
           <td>
             <div ng-bind-html="snippet | linky"></div>
           </td>
         </tr>
         <tr id="linky-target">
          <td>linky target</td>
          <td>
            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_blank'"&gt;<br>&lt;/div&gt;</pre>
          </td>
          <td>
            <div ng-bind-html="snippetWithSingleURL | linky:'_blank'"></div>
          </td>
         </tr>
         <tr id="linky-custom-attributes">
          <td>linky custom attributes</td>
          <td>
            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"&gt;<br>&lt;/div&gt;</pre>
          </td>
          <td>
            <div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"></div>
          </td>
         </tr>
         <tr id="escaped-html">
           <td>no filter</td>
           <td><pre>&lt;div ng-bind="snippet"&gt;<br>&lt;/div&gt;</pre></td>
           <td><div ng-bind="snippet"></div></td>
         </tr>
       </table>
     </file>
     <file name="script.js">
       angular.module('linkyExample', ['ngSanitize'])
         .controller('ExampleController', ['$scope', function($scope) {
           $scope.snippet =
             'Pretty text with some links:\n' +
             'http://angularjs.org/,\n' +
             'mailto:us@somewhere.org,\n' +
             'another@somewhere.org,\n' +
             'and one more: ftp://127.0.0.1/.';
           $scope.snippetWithSingleURL = 'http://angularjs.org/';
         }]);
     </file>
     <file name="protractor.js" type="protractor">
       it('should linkify the snippet with urls', function() {
         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
             toBe('Pretty text with some links: http://angularjs.org/, us@somewhere.org, ' +
                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
         expect(element.all(by.css('#linky-filter a')).count()).toEqual(4);
       });

       it('should not linkify snippet without the linky filter', function() {
         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText()).
             toBe('Pretty text with some links: http://angularjs.org/, mailto:us@somewhere.org, ' +
                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
         expect(element.all(by.css('#escaped-html a')).count()).toEqual(0);
       });

       it('should update', function() {
         element(by.model('snippet')).clear();
         element(by.model('snippet')).sendKeys('new http://link.');
         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
             toBe('new http://link.');
         expect(element.all(by.css('#linky-filter a')).count()).toEqual(1);
         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText())
             .toBe('new http://link.');
       });

       it('should work with the target property', function() {
        expect(element(by.id('linky-target')).
            element(by.binding("snippetWithSingleURL | linky:'_blank'")).getText()).
            toBe('http://angularjs.org/');
        expect(element(by.css('#linky-target a')).getAttribute('target')).toEqual('_blank');
       });

       it('should optionally add custom attributes', function() {
        expect(element(by.id('linky-custom-attributes')).
            element(by.binding("snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}")).getText()).
            toBe('http://angularjs.org/');
        expect(element(by.css('#linky-custom-attributes a')).getAttribute('rel')).toEqual('nofollow');
       });
     </file>
   </example>
 */
angular.module('ngSanitize').filter('linky', ['$sanitize', function($sanitize) {
  var LINKY_URL_REGEXP =
        /((s?ftp|https?):\/\/|(www\.)|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>"\u201d\u2019]/i,
      MAILTO_REGEXP = /^mailto:/i;

  var linkyMinErr = angular.$$minErr('linky');
  var isDefined = angular.isDefined;
  var isFunction = angular.isFunction;
  var isObject = angular.isObject;
  var isString = angular.isString;

  return function(text, target, attributes) {
    if (text == null || text === '') return text;
    if (!isString(text)) throw linkyMinErr('notstring', 'Expected string but received: {0}', text);

    var attributesFn =
      isFunction(attributes) ? attributes :
      isObject(attributes) ? function getAttributesObject() {return attributes;} :
      function getEmptyAttributesObject() {return {};};

    var match;
    var raw = text;
    var html = [];
    var url;
    var i;
    while ((match = raw.match(LINKY_URL_REGEXP))) {
      // We can not end in these as they are sometimes found at the end of the sentence
      url = match[0];
      // if we did not match ftp/http/www/mailto then assume mailto
      if (!match[2] && !match[4]) {
        url = (match[3] ? 'http://' : 'mailto:') + url;
      }
      i = match.index;
      addText(raw.substr(0, i));
      addLink(url, match[0].replace(MAILTO_REGEXP, ''));
      raw = raw.substring(i + match[0].length);
    }
    addText(raw);
    return $sanitize(html.join(''));

    function addText(text) {
      if (!text) {
        return;
      }
      html.push(sanitizeText(text));
    }

    function addLink(url, text) {
      var key, linkAttributes = attributesFn(url);
      html.push('<a ');

      for (key in linkAttributes) {
        html.push(key + '="' + linkAttributes[key] + '" ');
      }

      if (isDefined(target) && !('target' in linkAttributes)) {
        html.push('target="',
                  target,
                  '" ');
      }
      html.push('href="',
                url.replace(/"/g, '&quot;'),
                '">');
      addText(text);
      html.push('</a>');
    }
  };
}]);


})(window, window.angular);

},{}],553:[function(require,module,exports){
require('./angular-sanitize');
module.exports = 'ngSanitize';

},{"./angular-sanitize":552}],554:[function(require,module,exports){
/*!
 * angular-slick-carousel
 * DevMark <hc.devmark@gmail.com>
 * https://github.com/devmark/angular-slick-carousel
 * Version: 3.1.7 - 2016-08-04T06:43:29.508Z
 * License: MIT
 */


'use strict';

angular
  .module('slickCarousel', [])
  //global config
  .constant('slickCarouselConfig', {
    method: {},
    event: {}
  })
  .directive('slick', [
    '$timeout', 'slickCarouselConfig', function ($timeout, slickCarouselConfig) {
      var slickMethodList, slickEventList;
      slickMethodList = ['slickGoTo', 'slickNext', 'slickPrev', 'slickPause', 'slickPlay', 'slickAdd', 'slickRemove', 'slickFilter', 'slickUnfilter', 'unslick'];
      slickEventList = ['afterChange', 'beforeChange', 'breakpoint', 'destroy', 'edge', 'init', 'reInit', 'setPosition', 'swipe', 'lazyLoaded', 'lazyLoadError'];

      return {
        scope: {
          settings: '=',
          enabled: '@',
          accessibility: '@',
          adaptiveHeight: '@',
          autoplay: '@',
          autoplaySpeed: '@',
          arrows: '@',
          asNavFor: '@',
          appendArrows: '@',
          prevArrow: '@',
          nextArrow: '@',
          centerMode: '@',
          centerPadding: '@',
          cssEase: '@',
          customPaging: '&',
          dots: '@',
          draggable: '@',
          fade: '@',
          focusOnSelect: '@',
          easing: '@',
          edgeFriction: '@',
          infinite: '@',
          initialSlide: '@',
          lazyLoad: '@',
          mobileFirst: '@',
          pauseOnHover: '@',
          pauseOnDotsHover: '@',
          respondTo: '@',
          responsive: '=?',
          rows: '@',
          slide: '@',
          slidesPerRow: '@',
          slidesToShow: '@',
          slidesToScroll: '@',
          speed: '@',
          swipe: '@',
          swipeToSlide: '@',
          touchMove: '@',
          touchThreshold: '@',
          useCSS: '@',
          variableWidth: '@',
          vertical: '@',
          verticalSwiping: '@',
          rtl: '@'
        },
        restrict: 'AE',
        link: function (scope, element, attr) {
          //hide slider
          angular.element(element).css('display', 'none');

          var options, initOptions, destroy, init, destroyAndInit, currentIndex;

          initOptions = function () {
            options = angular.extend(angular.copy(slickCarouselConfig), {
              enabled: scope.enabled !== 'false',
              accessibility: scope.accessibility !== 'false',
              adaptiveHeight: scope.adaptiveHeight === 'true',
              autoplay: scope.autoplay === 'true',
              autoplaySpeed: scope.autoplaySpeed != null ? parseInt(scope.autoplaySpeed, 10) : 3000,
              arrows: scope.arrows !== 'false',
              asNavFor: scope.asNavFor ? scope.asNavFor : void 0,
              appendArrows: scope.appendArrows ? angular.element(scope.appendArrows) : angular.element(element),
              prevArrow: scope.prevArrow ? angular.element(scope.prevArrow) : void 0,
              nextArrow: scope.nextArrow ? angular.element(scope.nextArrow) : void 0,
              centerMode: scope.centerMode === 'true',
              centerPadding: scope.centerPadding || '50px',
              cssEase: scope.cssEase || 'ease',
              customPaging: attr.customPaging ? function (slick, index) {
                return scope.customPaging({slick: slick, index: index});
              } : void 0,
              dots: scope.dots === 'true',
              draggable: scope.draggable !== 'false',
              fade: scope.fade === 'true',
              focusOnSelect: scope.focusOnSelect === 'true',
              easing: scope.easing || 'linear',
              edgeFriction: scope.edgeFriction || 0.15,
              infinite: scope.infinite !== 'false',
              initialSlide: parseInt(scope.initialSlide) || 0,
              lazyLoad: scope.lazyLoad || 'ondemand',
              mobileFirst: scope.mobileFirst === 'true',
              pauseOnHover: scope.pauseOnHover !== 'false',
              pauseOnDotsHover: scope.pauseOnDotsHover === "true",
              respondTo: scope.respondTo != null ? scope.respondTo : 'window',
              responsive: scope.responsive || void 0,
              rows: scope.rows != null ? parseInt(scope.rows, 10) : 1,
              slide: scope.slide || '',
              slidesPerRow: scope.slidesPerRow != null ? parseInt(scope.slidesPerRow, 10) : 1,
              slidesToShow: scope.slidesToShow != null ? parseInt(scope.slidesToShow, 10) : 1,
              slidesToScroll: scope.slidesToScroll != null ? parseInt(scope.slidesToScroll, 10) : 1,
              speed: scope.speed != null ? parseInt(scope.speed, 10) : 300,
              swipe: scope.swipe !== 'false',
              swipeToSlide: scope.swipeToSlide === 'true',
              touchMove: scope.touchMove !== 'false',
              touchThreshold: scope.touchThreshold ? parseInt(scope.touchThreshold, 10) : 5,
              useCSS: scope.useCSS !== 'false',
              variableWidth: scope.variableWidth === 'true',
              vertical: scope.vertical === 'true',
              verticalSwiping: scope.verticalSwiping === 'true',
              rtl: scope.rtl === 'true'
            }, scope.settings);

          };

          destroy = function () {
            var slickness = angular.element(element);
            if (slickness.hasClass('slick-initialized')) {
              slickness.remove('slick-list');
              slickness.slick('unslick');
            }

            return slickness;
          };

          init = function () {
            initOptions();

            var slickness = angular.element(element);

            if (angular.element(element).hasClass('slick-initialized')) {
              if (options.enabled) {
                return slickness.slick('getSlick');
              } else {
                destroy();
              }
            } else {
              if (!options.enabled) {
                return;
              }
              // Event
              slickness.on('init', function (event, slick) {
                if (typeof options.event.init !== 'undefined') {
                  options.event.init(event, slick);
                }
                if (typeof currentIndex !== 'undefined') {
                  return slick.slideHandler(currentIndex);
                }
              });

              $timeout(function () {
                angular.element(element).css('display', 'block');
                slickness.not('.slick-initialized').slick(options);
              });
            }

            scope.internalControl = options.method || {};

            // Method
            slickMethodList.forEach(function (value) {
              scope.internalControl[value] = function () {
                var args;
                args = Array.prototype.slice.call(arguments);
                args.unshift(value);
                slickness.slick.apply(element, args);
              };
            });

            // Event
            slickness.on('afterChange', function (event, slick, currentSlide) {
              currentIndex = currentSlide;
              if (typeof options.event.afterChange !== 'undefined') {
                $timeout(function () {
                  scope.$apply(function () {
                    options.event.afterChange(event, slick, currentSlide);
                  });
                });
              }
            });

            slickness.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
              if (typeof options.event.beforeChange !== 'undefined') {
                $timeout(function () {
                  $timeout(function () {
                    scope.$apply(function () {
                      options.event.beforeChange(event, slick, currentSlide, nextSlide);
                    });
                  });
                });
              }
            });

            slickness.on('reInit', function (event, slick) {
              if (typeof options.event.reInit !== 'undefined') {
                $timeout(function () {
                  scope.$apply(function () {
                    options.event.reInit(event, slick);
                  });
                });
              }
            });

            if (typeof options.event.breakpoint !== 'undefined') {
              slickness.on('breakpoint', function (event, slick, breakpoint) {
                $timeout(function () {
                  scope.$apply(function () {
                    options.event.breakpoint(event, slick, breakpoint);
                  });
                });
              });
            }
            if (typeof options.event.destroy !== 'undefined') {
              slickness.on('destroy', function (event, slick) {
                $timeout(function () {
                  scope.$apply(function () {
                    options.event.destroy(event, slick);
                  });
                });
              });
            }
            if (typeof options.event.edge !== 'undefined') {
              slickness.on('edge', function (event, slick, direction) {
                $timeout(function () {
                  scope.$apply(function () {
                    options.event.edge(event, slick, direction);
                  });
                });
              });
            }

            if (typeof options.event.setPosition !== 'undefined') {
              slickness.on('setPosition', function (event, slick) {
                $timeout(function () {
                  scope.$apply(function () {
                    options.event.setPosition(event, slick);
                  });
                });
              });
            }
            if (typeof options.event.swipe !== 'undefined') {
              slickness.on('swipe', function (event, slick, direction) {
                $timeout(function () {
                  scope.$apply(function () {
                    options.event.swipe(event, slick, direction);
                  });
                });
              });
            }
            if (typeof options.event.lazyLoaded !== 'undefined') {
              slickness.on('lazyLoaded', function (event, slick, image, imageSource) {
                $timeout(function () {
                  scope.$apply(function () {
                    options.event.lazyLoaded(event, slick, image, imageSource);
                  });
                });
              });
            }
            if (typeof options.event.lazyLoadError !== 'undefined') {
              slickness.on('lazyLoadError', function (event, slick, image, imageSource) {
                $timeout(function () {
                  scope.$apply(function () {
                    options.event.lazyLoadError(event, slick, image, imageSource);
                  });
                });
              });
            }
          };

          destroyAndInit = function () {
            destroy();
            init();
          };

          element.one('$destroy', function () {
            destroy();
          });

          return scope.$watch('settings', function (newVal, oldVal) {
            if (newVal !== null) {
              return destroyAndInit();
            }
          }, true);

        }
      };
    }
  ]);

},{}],555:[function(require,module,exports){
/**
 * @license AngularJS v1.8.3
 * (c) 2010-2020 Google LLC. http://angularjs.org
 * License: MIT
 */
(function(window) {'use strict';

/* exported
  minErrConfig,
  errorHandlingConfig,
  isValidObjectMaxDepth
*/

var minErrConfig = {
  objectMaxDepth: 5,
  urlErrorParamsEnabled: true
};

/**
 * @ngdoc function
 * @name angular.errorHandlingConfig
 * @module ng
 * @kind function
 *
 * @description
 * Configure several aspects of error handling in AngularJS if used as a setter or return the
 * current configuration if used as a getter. The following options are supported:
 *
 * - **objectMaxDepth**: The maximum depth to which objects are traversed when stringified for error messages.
 *
 * Omitted or undefined options will leave the corresponding configuration values unchanged.
 *
 * @param {Object=} config - The configuration object. May only contain the options that need to be
 *     updated. Supported keys:
 *
 * * `objectMaxDepth`  **{Number}** - The max depth for stringifying objects. Setting to a
 *   non-positive or non-numeric value, removes the max depth limit.
 *   Default: 5
 *
 * * `urlErrorParamsEnabled`  **{Boolean}** - Specifies whether the generated error url will
 *   contain the parameters of the thrown error. Disabling the parameters can be useful if the
 *   generated error url is very long.
 *
 *   Default: true. When used without argument, it returns the current value.
 */
function errorHandlingConfig(config) {
  if (isObject(config)) {
    if (isDefined(config.objectMaxDepth)) {
      minErrConfig.objectMaxDepth = isValidObjectMaxDepth(config.objectMaxDepth) ? config.objectMaxDepth : NaN;
    }
    if (isDefined(config.urlErrorParamsEnabled) && isBoolean(config.urlErrorParamsEnabled)) {
      minErrConfig.urlErrorParamsEnabled = config.urlErrorParamsEnabled;
    }
  } else {
    return minErrConfig;
  }
}

/**
 * @private
 * @param {Number} maxDepth
 * @return {boolean}
 */
function isValidObjectMaxDepth(maxDepth) {
  return isNumber(maxDepth) && maxDepth > 0;
}


/**
 * @description
 *
 * This object provides a utility for producing rich Error messages within
 * AngularJS. It can be called as follows:
 *
 * var exampleMinErr = minErr('example');
 * throw exampleMinErr('one', 'This {0} is {1}', foo, bar);
 *
 * The above creates an instance of minErr in the example namespace. The
 * resulting error will have a namespaced error code of example.one.  The
 * resulting error will replace {0} with the value of foo, and {1} with the
 * value of bar. The object is not restricted in the number of arguments it can
 * take.
 *
 * If fewer arguments are specified than necessary for interpolation, the extra
 * interpolation markers will be preserved in the final string.
 *
 * Since data will be parsed statically during a build step, some restrictions
 * are applied with respect to how minErr instances are created and called.
 * Instances should have names of the form namespaceMinErr for a minErr created
 * using minErr('namespace'). Error codes, namespaces and template strings
 * should all be static strings, not variables or general expressions.
 *
 * @param {string} module The namespace to use for the new minErr instance.
 * @param {function} ErrorConstructor Custom error constructor to be instantiated when returning
 *   error from returned function, for cases when a particular type of error is useful.
 * @returns {function(code:string, template:string, ...templateArgs): Error} minErr instance
 */

function minErr(module, ErrorConstructor) {
  ErrorConstructor = ErrorConstructor || Error;

  var url = 'https://errors.angularjs.org/1.8.3/';
  var regex = url.replace('.', '\\.') + '[\\s\\S]*';
  var errRegExp = new RegExp(regex, 'g');

  return function() {
    var code = arguments[0],
      template = arguments[1],
      message = '[' + (module ? module + ':' : '') + code + '] ',
      templateArgs = sliceArgs(arguments, 2).map(function(arg) {
        return toDebugString(arg, minErrConfig.objectMaxDepth);
      }),
      paramPrefix, i;

    // A minErr message has two parts: the message itself and the url that contains the
    // encoded message.
    // The message's parameters can contain other error messages which also include error urls.
    // To prevent the messages from getting too long, we strip the error urls from the parameters.

    message += template.replace(/\{\d+\}/g, function(match) {
      var index = +match.slice(1, -1);

      if (index < templateArgs.length) {
        return templateArgs[index].replace(errRegExp, '');
      }

      return match;
    });

    message += '\n' + url + (module ? module + '/' : '') + code;

    if (minErrConfig.urlErrorParamsEnabled) {
      for (i = 0, paramPrefix = '?'; i < templateArgs.length; i++, paramPrefix = '&') {
        message += paramPrefix + 'p' + i + '=' + encodeURIComponent(templateArgs[i]);
      }
    }

    return new ErrorConstructor(message);
  };
}

/* We need to tell ESLint what variables are being exported */
/* exported
  angular,
  msie,
  jqLite,
  jQuery,
  slice,
  splice,
  push,
  toString,
  minErrConfig,
  errorHandlingConfig,
  isValidObjectMaxDepth,
  ngMinErr,
  angularModule,
  uid,
  REGEX_STRING_REGEXP,
  VALIDITY_STATE_PROPERTY,

  lowercase,
  uppercase,
  nodeName_,
  isArrayLike,
  forEach,
  forEachSorted,
  reverseParams,
  nextUid,
  setHashKey,
  extend,
  toInt,
  inherit,
  merge,
  noop,
  identity,
  valueFn,
  isUndefined,
  isDefined,
  isObject,
  isBlankObject,
  isString,
  isNumber,
  isNumberNaN,
  isDate,
  isError,
  isArray,
  isFunction,
  isRegExp,
  isWindow,
  isScope,
  isFile,
  isFormData,
  isBlob,
  isBoolean,
  isPromiseLike,
  trim,
  escapeForRegexp,
  isElement,
  makeMap,
  includes,
  arrayRemove,
  copy,
  simpleCompare,
  equals,
  csp,
  jq,
  concat,
  sliceArgs,
  bind,
  toJsonReplacer,
  toJson,
  fromJson,
  convertTimezoneToLocal,
  timezoneToOffset,
  addDateMinutes,
  startingTag,
  tryDecodeURIComponent,
  parseKeyValue,
  toKeyValue,
  encodeUriSegment,
  encodeUriQuery,
  angularInit,
  bootstrap,
  getTestability,
  snake_case,
  bindJQuery,
  assertArg,
  assertArgFn,
  assertNotHasOwnProperty,
  getter,
  getBlockNodes,
  hasOwnProperty,
  createMap,
  stringify,
  UNSAFE_restoreLegacyJqLiteXHTMLReplacement,

  NODE_TYPE_ELEMENT,
  NODE_TYPE_ATTRIBUTE,
  NODE_TYPE_TEXT,
  NODE_TYPE_COMMENT,
  NODE_TYPE_DOCUMENT,
  NODE_TYPE_DOCUMENT_FRAGMENT
*/

////////////////////////////////////

/**
 * @ngdoc module
 * @name ng
 * @module ng
 * @installation
 * @description
 *
 * The ng module is loaded by default when an AngularJS application is started. The module itself
 * contains the essential components for an AngularJS application to function. The table below
 * lists a high level breakdown of each of the services/factories, filters, directives and testing
 * components available within this core module.
 *
 */

var REGEX_STRING_REGEXP = /^\/(.+)\/([a-z]*)$/;

// The name of a form control's ValidityState property.
// This is used so that it's possible for internal tests to create mock ValidityStates.
var VALIDITY_STATE_PROPERTY = 'validity';


var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * @private
 *
 * @description Converts the specified string to lowercase.
 * @param {string} string String to be converted to lowercase.
 * @returns {string} Lowercased string.
 */
var lowercase = function(string) {return isString(string) ? string.toLowerCase() : string;};

/**
 * @private
 *
 * @description Converts the specified string to uppercase.
 * @param {string} string String to be converted to uppercase.
 * @returns {string} Uppercased string.
 */
var uppercase = function(string) {return isString(string) ? string.toUpperCase() : string;};


var
    msie,             // holds major version number for IE, or NaN if UA is not IE.
    jqLite,           // delay binding since jQuery could be loaded after us.
    jQuery,           // delay binding
    slice             = [].slice,
    splice            = [].splice,
    push              = [].push,
    toString          = Object.prototype.toString,
    getPrototypeOf    = Object.getPrototypeOf,
    ngMinErr          = minErr('ng'),

    /** @name angular */
    angular           = window.angular || (window.angular = {}),
    angularModule,
    uid               = 0;

// Support: IE 9-11 only
/**
 * documentMode is an IE-only property
 * http://msdn.microsoft.com/en-us/library/ie/cc196988(v=vs.85).aspx
 */
msie = window.document.documentMode;


/**
 * @private
 * @param {*} obj
 * @return {boolean} Returns true if `obj` is an array or array-like object (NodeList, Arguments,
 *                   String ...)
 */
function isArrayLike(obj) {

  // `null`, `undefined` and `window` are not array-like
  if (obj == null || isWindow(obj)) return false;

  // arrays, strings and jQuery/jqLite objects are array like
  // * jqLite is either the jQuery or jqLite constructor function
  // * we have to check the existence of jqLite first as this method is called
  //   via the forEach method when constructing the jqLite object in the first place
  if (isArray(obj) || isString(obj) || (jqLite && obj instanceof jqLite)) return true;

  // Support: iOS 8.2 (not reproducible in simulator)
  // "length" in obj used to prevent JIT error (gh-11508)
  var length = 'length' in Object(obj) && obj.length;

  // NodeList objects (with `item` method) and
  // other objects with suitable length characteristics are array-like
  return isNumber(length) && (length >= 0 && (length - 1) in obj || typeof obj.item === 'function');

}

/**
 * @ngdoc function
 * @name angular.forEach
 * @module ng
 * @kind function
 *
 * @description
 * Invokes the `iterator` function once for each item in `obj` collection, which can be either an
 * object or an array. The `iterator` function is invoked with `iterator(value, key, obj)`, where `value`
 * is the value of an object property or an array element, `key` is the object property key or
 * array element index and obj is the `obj` itself. Specifying a `context` for the function is optional.
 *
 * It is worth noting that `.forEach` does not iterate over inherited properties because it filters
 * using the `hasOwnProperty` method.
 *
 * Unlike ES262's
 * [Array.prototype.forEach](http://www.ecma-international.org/ecma-262/5.1/#sec-15.4.4.18),
 * providing 'undefined' or 'null' values for `obj` will not throw a TypeError, but rather just
 * return the value provided.
 *
   ```js
     var values = {name: 'misko', gender: 'male'};
     var log = [];
     angular.forEach(values, function(value, key) {
       this.push(key + ': ' + value);
     }, log);
     expect(log).toEqual(['name: misko', 'gender: male']);
   ```
 *
 * @param {Object|Array} obj Object to iterate over.
 * @param {Function} iterator Iterator function.
 * @param {Object=} context Object to become context (`this`) for the iterator function.
 * @returns {Object|Array} Reference to `obj`.
 */

function forEach(obj, iterator, context) {
  var key, length;
  if (obj) {
    if (isFunction(obj)) {
      for (key in obj) {
        if (key !== 'prototype' && key !== 'length' && key !== 'name' && obj.hasOwnProperty(key)) {
          iterator.call(context, obj[key], key, obj);
        }
      }
    } else if (isArray(obj) || isArrayLike(obj)) {
      var isPrimitive = typeof obj !== 'object';
      for (key = 0, length = obj.length; key < length; key++) {
        if (isPrimitive || key in obj) {
          iterator.call(context, obj[key], key, obj);
        }
      }
    } else if (obj.forEach && obj.forEach !== forEach) {
        obj.forEach(iterator, context, obj);
    } else if (isBlankObject(obj)) {
      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
      for (key in obj) {
        iterator.call(context, obj[key], key, obj);
      }
    } else if (typeof obj.hasOwnProperty === 'function') {
      // Slow path for objects inheriting Object.prototype, hasOwnProperty check needed
      for (key in obj) {
        if (obj.hasOwnProperty(key)) {
          iterator.call(context, obj[key], key, obj);
        }
      }
    } else {
      // Slow path for objects which do not have a method `hasOwnProperty`
      for (key in obj) {
        if (hasOwnProperty.call(obj, key)) {
          iterator.call(context, obj[key], key, obj);
        }
      }
    }
  }
  return obj;
}

function forEachSorted(obj, iterator, context) {
  var keys = Object.keys(obj).sort();
  for (var i = 0; i < keys.length; i++) {
    iterator.call(context, obj[keys[i]], keys[i]);
  }
  return keys;
}


/**
 * when using forEach the params are value, key, but it is often useful to have key, value.
 * @param {function(string, *)} iteratorFn
 * @returns {function(*, string)}
 */
function reverseParams(iteratorFn) {
  return function(value, key) {iteratorFn(key, value);};
}

/**
 * A consistent way of creating unique IDs in angular.
 *
 * Using simple numbers allows us to generate 28.6 million unique ids per second for 10 years before
 * we hit number precision issues in JavaScript.
 *
 * Math.pow(2,53) / 60 / 60 / 24 / 365 / 10 = 28.6M
 *
 * @returns {number} an unique alpha-numeric string
 */
function nextUid() {
  return ++uid;
}


/**
 * Set or clear the hashkey for an object.
 * @param obj object
 * @param h the hashkey (!truthy to delete the hashkey)
 */
function setHashKey(obj, h) {
  if (h) {
    obj.$$hashKey = h;
  } else {
    delete obj.$$hashKey;
  }
}


function baseExtend(dst, objs, deep) {
  var h = dst.$$hashKey;

  for (var i = 0, ii = objs.length; i < ii; ++i) {
    var obj = objs[i];
    if (!isObject(obj) && !isFunction(obj)) continue;
    var keys = Object.keys(obj);
    for (var j = 0, jj = keys.length; j < jj; j++) {
      var key = keys[j];
      var src = obj[key];

      if (deep && isObject(src)) {
        if (isDate(src)) {
          dst[key] = new Date(src.valueOf());
        } else if (isRegExp(src)) {
          dst[key] = new RegExp(src);
        } else if (src.nodeName) {
          dst[key] = src.cloneNode(true);
        } else if (isElement(src)) {
          dst[key] = src.clone();
        } else {
          if (key !== '__proto__') {
            if (!isObject(dst[key])) dst[key] = isArray(src) ? [] : {};
            baseExtend(dst[key], [src], true);
          }
        }
      } else {
        dst[key] = src;
      }
    }
  }

  setHashKey(dst, h);
  return dst;
}

/**
 * @ngdoc function
 * @name angular.extend
 * @module ng
 * @kind function
 *
 * @description
 * Extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
 * to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
 * by passing an empty object as the target: `var object = angular.extend({}, object1, object2)`.
 *
 * **Note:** Keep in mind that `angular.extend` does not support recursive merge (deep copy). Use
 * {@link angular.merge} for this.
 *
 * @param {Object} dst Destination object.
 * @param {...Object} src Source object(s).
 * @returns {Object} Reference to `dst`.
 */
function extend(dst) {
  return baseExtend(dst, slice.call(arguments, 1), false);
}


/**
* @ngdoc function
* @name angular.merge
* @module ng
* @kind function
*
* @description
* Deeply extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
* to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
* by passing an empty object as the target: `var object = angular.merge({}, object1, object2)`.
*
* Unlike {@link angular.extend extend()}, `merge()` recursively descends into object properties of source
* objects, performing a deep copy.
*
* @deprecated
* sinceVersion="1.6.5"
* This function is deprecated, but will not be removed in the 1.x lifecycle.
* There are edge cases (see {@link angular.merge#known-issues known issues}) that are not
* supported by this function. We suggest using another, similar library for all-purpose merging,
* such as [lodash's merge()](https://lodash.com/docs/4.17.4#merge).
*
* @knownIssue
* This is a list of (known) object types that are not handled correctly by this function:
* - [`Blob`](https://developer.mozilla.org/docs/Web/API/Blob)
* - [`MediaStream`](https://developer.mozilla.org/docs/Web/API/MediaStream)
* - [`CanvasGradient`](https://developer.mozilla.org/docs/Web/API/CanvasGradient)
* - AngularJS {@link $rootScope.Scope scopes};
*
* `angular.merge` also does not support merging objects with circular references.
*
* @param {Object} dst Destination object.
* @param {...Object} src Source object(s).
* @returns {Object} Reference to `dst`.
*/
function merge(dst) {
  return baseExtend(dst, slice.call(arguments, 1), true);
}



function toInt(str) {
  return parseInt(str, 10);
}

var isNumberNaN = Number.isNaN || function isNumberNaN(num) {
  // eslint-disable-next-line no-self-compare
  return num !== num;
};


function inherit(parent, extra) {
  return extend(Object.create(parent), extra);
}

/**
 * @ngdoc function
 * @name angular.noop
 * @module ng
 * @kind function
 *
 * @description
 * A function that performs no operations. This function can be useful when writing code in the
 * functional style.
   ```js
     function foo(callback) {
       var result = calculateResult();
       (callback || angular.noop)(result);
     }
   ```
 */
function noop() {}
noop.$inject = [];


/**
 * @ngdoc function
 * @name angular.identity
 * @module ng
 * @kind function
 *
 * @description
 * A function that returns its first argument. This function is useful when writing code in the
 * functional style.
 *
   ```js
   function transformer(transformationFn, value) {
     return (transformationFn || angular.identity)(value);
   };

   // E.g.
   function getResult(fn, input) {
     return (fn || angular.identity)(input);
   };

   getResult(function(n) { return n * 2; }, 21);   // returns 42
   getResult(null, 21);                            // returns 21
   getResult(undefined, 21);                       // returns 21
   ```
 *
 * @param {*} value to be returned.
 * @returns {*} the value passed in.
 */
function identity($) {return $;}
identity.$inject = [];


function valueFn(value) {return function valueRef() {return value;};}

function hasCustomToString(obj) {
  return isFunction(obj.toString) && obj.toString !== toString;
}


/**
 * @ngdoc function
 * @name angular.isUndefined
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is undefined.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is undefined.
 */
function isUndefined(value) {return typeof value === 'undefined';}


/**
 * @ngdoc function
 * @name angular.isDefined
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is defined.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is defined.
 */
function isDefined(value) {return typeof value !== 'undefined';}


/**
 * @ngdoc function
 * @name angular.isObject
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is an `Object`. Unlike `typeof` in JavaScript, `null`s are not
 * considered to be objects. Note that JavaScript arrays are objects.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is an `Object` but not `null`.
 */
function isObject(value) {
  // http://jsperf.com/isobject4
  return value !== null && typeof value === 'object';
}


/**
 * Determine if a value is an object with a null prototype
 *
 * @returns {boolean} True if `value` is an `Object` with a null prototype
 */
function isBlankObject(value) {
  return value !== null && typeof value === 'object' && !getPrototypeOf(value);
}


/**
 * @ngdoc function
 * @name angular.isString
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is a `String`.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `String`.
 */
function isString(value) {return typeof value === 'string';}


/**
 * @ngdoc function
 * @name angular.isNumber
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is a `Number`.
 *
 * This includes the "special" numbers `NaN`, `+Infinity` and `-Infinity`.
 *
 * If you wish to exclude these then you can use the native
 * [`isFinite'](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/isFinite)
 * method.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `Number`.
 */
function isNumber(value) {return typeof value === 'number';}


/**
 * @ngdoc function
 * @name angular.isDate
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a value is a date.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `Date`.
 */
function isDate(value) {
  return toString.call(value) === '[object Date]';
}


/**
 * @ngdoc function
 * @name angular.isArray
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is an `Array`.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is an `Array`.
 */
function isArray(arr) {
  return Array.isArray(arr) || arr instanceof Array;
}

/**
 * @description
 * Determines if a reference is an `Error`.
 * Loosely based on https://www.npmjs.com/package/iserror
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is an `Error`.
 */
function isError(value) {
  var tag = toString.call(value);
  switch (tag) {
    case '[object Error]': return true;
    case '[object Exception]': return true;
    case '[object DOMException]': return true;
    default: return value instanceof Error;
  }
}

/**
 * @ngdoc function
 * @name angular.isFunction
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is a `Function`.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `Function`.
 */
function isFunction(value) {return typeof value === 'function';}


/**
 * Determines if a value is a regular expression object.
 *
 * @private
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `RegExp`.
 */
function isRegExp(value) {
  return toString.call(value) === '[object RegExp]';
}


/**
 * Checks if `obj` is a window object.
 *
 * @private
 * @param {*} obj Object to check
 * @returns {boolean} True if `obj` is a window obj.
 */
function isWindow(obj) {
  return obj && obj.window === obj;
}


function isScope(obj) {
  return obj && obj.$evalAsync && obj.$watch;
}


function isFile(obj) {
  return toString.call(obj) === '[object File]';
}


function isFormData(obj) {
  return toString.call(obj) === '[object FormData]';
}


function isBlob(obj) {
  return toString.call(obj) === '[object Blob]';
}


function isBoolean(value) {
  return typeof value === 'boolean';
}


function isPromiseLike(obj) {
  return obj && isFunction(obj.then);
}


var TYPED_ARRAY_REGEXP = /^\[object (?:Uint8|Uint8Clamped|Uint16|Uint32|Int8|Int16|Int32|Float32|Float64)Array]$/;
function isTypedArray(value) {
  return value && isNumber(value.length) && TYPED_ARRAY_REGEXP.test(toString.call(value));
}

function isArrayBuffer(obj) {
  return toString.call(obj) === '[object ArrayBuffer]';
}


var trim = function(value) {
  return isString(value) ? value.trim() : value;
};

// Copied from:
// http://docs.closure-library.googlecode.com/git/local_closure_goog_string_string.js.source.html#line1021
// Prereq: s is a string.
var escapeForRegexp = function(s) {
  return s
    .replace(/([-()[\]{}+?*.$^|,:#<!\\])/g, '\\$1')
    // eslint-disable-next-line no-control-regex
    .replace(/\x08/g, '\\x08');
};


/**
 * @ngdoc function
 * @name angular.isElement
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is a DOM element (or wrapped jQuery element).
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a DOM element (or wrapped jQuery element).
 */
function isElement(node) {
  return !!(node &&
    (node.nodeName  // We are a direct element.
    || (node.prop && node.attr && node.find)));  // We have an on and find method part of jQuery API.
}

/**
 * @param str 'key1,key2,...'
 * @returns {object} in the form of {key1:true, key2:true, ...}
 */
function makeMap(str) {
  var obj = {}, items = str.split(','), i;
  for (i = 0; i < items.length; i++) {
    obj[items[i]] = true;
  }
  return obj;
}


function nodeName_(element) {
  return lowercase(element.nodeName || (element[0] && element[0].nodeName));
}

function includes(array, obj) {
  return Array.prototype.indexOf.call(array, obj) !== -1;
}

function arrayRemove(array, value) {
  var index = array.indexOf(value);
  if (index >= 0) {
    array.splice(index, 1);
  }
  return index;
}

/**
 * @ngdoc function
 * @name angular.copy
 * @module ng
 * @kind function
 *
 * @description
 * Creates a deep copy of `source`, which should be an object or an array. This functions is used
 * internally, mostly in the change-detection code. It is not intended as an all-purpose copy
 * function, and has several limitations (see below).
 *
 * * If no destination is supplied, a copy of the object or array is created.
 * * If a destination is provided, all of its elements (for arrays) or properties (for objects)
 *   are deleted and then all elements/properties from the source are copied to it.
 * * If `source` is not an object or array (inc. `null` and `undefined`), `source` is returned.
 * * If `source` is identical to `destination` an exception will be thrown.
 *
 * <br />
 *
 * <div class="alert alert-warning">
 *   Only enumerable properties are taken into account. Non-enumerable properties (both on `source`
 *   and on `destination`) will be ignored.
 * </div>
 *
 * <div class="alert alert-warning">
 *   `angular.copy` does not check if destination and source are of the same type. It's the
 *   developer's responsibility to make sure they are compatible.
 * </div>
 *
 * @knownIssue
 * This is a non-exhaustive list of object types / features that are not handled correctly by
 * `angular.copy`. Note that since this functions is used by the change detection code, this
 * means binding or watching objects of these types (or that include these types) might not work
 * correctly.
 * - [`File`](https://developer.mozilla.org/docs/Web/API/File)
 * - [`Map`](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Map)
 * - [`ImageData`](https://developer.mozilla.org/docs/Web/API/ImageData)
 * - [`MediaStream`](https://developer.mozilla.org/docs/Web/API/MediaStream)
 * - [`Set`](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Set)
 * - [`WeakMap`](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/WeakMap)
 * - [`getter`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/get)/
 *   [`setter`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/set)
 *
 * @param {*} source The source that will be used to make a copy. Can be any type, including
 *     primitives, `null`, and `undefined`.
 * @param {(Object|Array)=} destination Destination into which the source is copied. If provided,
 *     must be of the same type as `source`.
 * @returns {*} The copy or updated `destination`, if `destination` was specified.
 *
 * @example
  <example module="copyExample" name="angular-copy">
    <file name="index.html">
      <div ng-controller="ExampleController">
        <form novalidate class="simple-form">
          <label>Name: <input type="text" ng-model="user.name" /></label><br />
          <label>Age:  <input type="number" ng-model="user.age" /></label><br />
          Gender: <label><input type="radio" ng-model="user.gender" value="male" />male</label>
                  <label><input type="radio" ng-model="user.gender" value="female" />female</label><br />
          <button ng-click="reset()">RESET</button>
          <button ng-click="update(user)">SAVE</button>
        </form>
        <pre>form = {{user | json}}</pre>
        <pre>leader = {{leader | json}}</pre>
      </div>
    </file>
    <file name="script.js">
      // Module: copyExample
      angular.
        module('copyExample', []).
        controller('ExampleController', ['$scope', function($scope) {
          $scope.leader = {};

          $scope.reset = function() {
            // Example with 1 argument
            $scope.user = angular.copy($scope.leader);
          };

          $scope.update = function(user) {
            // Example with 2 arguments
            angular.copy(user, $scope.leader);
          };

          $scope.reset();
        }]);
    </file>
  </example>
 */
function copy(source, destination, maxDepth) {
  var stackSource = [];
  var stackDest = [];
  maxDepth = isValidObjectMaxDepth(maxDepth) ? maxDepth : NaN;

  if (destination) {
    if (isTypedArray(destination) || isArrayBuffer(destination)) {
      throw ngMinErr('cpta', 'Can\'t copy! TypedArray destination cannot be mutated.');
    }
    if (source === destination) {
      throw ngMinErr('cpi', 'Can\'t copy! Source and destination are identical.');
    }

    // Empty the destination object
    if (isArray(destination)) {
      destination.length = 0;
    } else {
      forEach(destination, function(value, key) {
        if (key !== '$$hashKey') {
          delete destination[key];
        }
      });
    }

    stackSource.push(source);
    stackDest.push(destination);
    return copyRecurse(source, destination, maxDepth);
  }

  return copyElement(source, maxDepth);

  function copyRecurse(source, destination, maxDepth) {
    maxDepth--;
    if (maxDepth < 0) {
      return '...';
    }
    var h = destination.$$hashKey;
    var key;
    if (isArray(source)) {
      for (var i = 0, ii = source.length; i < ii; i++) {
        destination.push(copyElement(source[i], maxDepth));
      }
    } else if (isBlankObject(source)) {
      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
      for (key in source) {
        destination[key] = copyElement(source[key], maxDepth);
      }
    } else if (source && typeof source.hasOwnProperty === 'function') {
      // Slow path, which must rely on hasOwnProperty
      for (key in source) {
        if (source.hasOwnProperty(key)) {
          destination[key] = copyElement(source[key], maxDepth);
        }
      }
    } else {
      // Slowest path --- hasOwnProperty can't be called as a method
      for (key in source) {
        if (hasOwnProperty.call(source, key)) {
          destination[key] = copyElement(source[key], maxDepth);
        }
      }
    }
    setHashKey(destination, h);
    return destination;
  }

  function copyElement(source, maxDepth) {
    // Simple values
    if (!isObject(source)) {
      return source;
    }

    // Already copied values
    var index = stackSource.indexOf(source);
    if (index !== -1) {
      return stackDest[index];
    }

    if (isWindow(source) || isScope(source)) {
      throw ngMinErr('cpws',
        'Can\'t copy! Making copies of Window or Scope instances is not supported.');
    }

    var needsRecurse = false;
    var destination = copyType(source);

    if (destination === undefined) {
      destination = isArray(source) ? [] : Object.create(getPrototypeOf(source));
      needsRecurse = true;
    }

    stackSource.push(source);
    stackDest.push(destination);

    return needsRecurse
      ? copyRecurse(source, destination, maxDepth)
      : destination;
  }

  function copyType(source) {
    switch (toString.call(source)) {
      case '[object Int8Array]':
      case '[object Int16Array]':
      case '[object Int32Array]':
      case '[object Float32Array]':
      case '[object Float64Array]':
      case '[object Uint8Array]':
      case '[object Uint8ClampedArray]':
      case '[object Uint16Array]':
      case '[object Uint32Array]':
        return new source.constructor(copyElement(source.buffer), source.byteOffset, source.length);

      case '[object ArrayBuffer]':
        // Support: IE10
        if (!source.slice) {
          // If we're in this case we know the environment supports ArrayBuffer
          /* eslint-disable no-undef */
          var copied = new ArrayBuffer(source.byteLength);
          new Uint8Array(copied).set(new Uint8Array(source));
          /* eslint-enable */
          return copied;
        }
        return source.slice(0);

      case '[object Boolean]':
      case '[object Number]':
      case '[object String]':
      case '[object Date]':
        return new source.constructor(source.valueOf());

      case '[object RegExp]':
        var re = new RegExp(source.source, source.toString().match(/[^/]*$/)[0]);
        re.lastIndex = source.lastIndex;
        return re;

      case '[object Blob]':
        return new source.constructor([source], {type: source.type});
    }

    if (isFunction(source.cloneNode)) {
      return source.cloneNode(true);
    }
  }
}


// eslint-disable-next-line no-self-compare
function simpleCompare(a, b) { return a === b || (a !== a && b !== b); }


/**
 * @ngdoc function
 * @name angular.equals
 * @module ng
 * @kind function
 *
 * @description
 * Determines if two objects or two values are equivalent. Supports value types, regular
 * expressions, arrays and objects.
 *
 * Two objects or values are considered equivalent if at least one of the following is true:
 *
 * * Both objects or values pass `===` comparison.
 * * Both objects or values are of the same type and all of their properties are equal by
 *   comparing them with `angular.equals`.
 * * Both values are NaN. (In JavaScript, NaN == NaN => false. But we consider two NaN as equal)
 * * Both values represent the same regular expression (In JavaScript,
 *   /abc/ == /abc/ => false. But we consider two regular expressions as equal when their textual
 *   representation matches).
 *
 * During a property comparison, properties of `function` type and properties with names
 * that begin with `$` are ignored.
 *
 * Scope and DOMWindow objects are being compared only by identify (`===`).
 *
 * @param {*} o1 Object or value to compare.
 * @param {*} o2 Object or value to compare.
 * @returns {boolean} True if arguments are equal.
 *
 * @example
   <example module="equalsExample" name="equalsExample">
     <file name="index.html">
      <div ng-controller="ExampleController">
        <form novalidate>
          <h3>User 1</h3>
          Name: <input type="text" ng-model="user1.name">
          Age: <input type="number" ng-model="user1.age">

          <h3>User 2</h3>
          Name: <input type="text" ng-model="user2.name">
          Age: <input type="number" ng-model="user2.age">

          <div>
            <br/>
            <input type="button" value="Compare" ng-click="compare()">
          </div>
          User 1: <pre>{{user1 | json}}</pre>
          User 2: <pre>{{user2 | json}}</pre>
          Equal: <pre>{{result}}</pre>
        </form>
      </div>
    </file>
    <file name="script.js">
        angular.module('equalsExample', []).controller('ExampleController', ['$scope', function($scope) {
          $scope.user1 = {};
          $scope.user2 = {};
          $scope.compare = function() {
            $scope.result = angular.equals($scope.user1, $scope.user2);
          };
        }]);
    </file>
  </example>
 */
function equals(o1, o2) {
  if (o1 === o2) return true;
  if (o1 === null || o2 === null) return false;
  // eslint-disable-next-line no-self-compare
  if (o1 !== o1 && o2 !== o2) return true; // NaN === NaN
  var t1 = typeof o1, t2 = typeof o2, length, key, keySet;
  if (t1 === t2 && t1 === 'object') {
    if (isArray(o1)) {
      if (!isArray(o2)) return false;
      if ((length = o1.length) === o2.length) {
        for (key = 0; key < length; key++) {
          if (!equals(o1[key], o2[key])) return false;
        }
        return true;
      }
    } else if (isDate(o1)) {
      if (!isDate(o2)) return false;
      return simpleCompare(o1.getTime(), o2.getTime());
    } else if (isRegExp(o1)) {
      if (!isRegExp(o2)) return false;
      return o1.toString() === o2.toString();
    } else {
      if (isScope(o1) || isScope(o2) || isWindow(o1) || isWindow(o2) ||
        isArray(o2) || isDate(o2) || isRegExp(o2)) return false;
      keySet = createMap();
      for (key in o1) {
        if (key.charAt(0) === '$' || isFunction(o1[key])) continue;
        if (!equals(o1[key], o2[key])) return false;
        keySet[key] = true;
      }
      for (key in o2) {
        if (!(key in keySet) &&
            key.charAt(0) !== '$' &&
            isDefined(o2[key]) &&
            !isFunction(o2[key])) return false;
      }
      return true;
    }
  }
  return false;
}

var csp = function() {
  if (!isDefined(csp.rules)) {


    var ngCspElement = (window.document.querySelector('[ng-csp]') ||
                    window.document.querySelector('[data-ng-csp]'));

    if (ngCspElement) {
      var ngCspAttribute = ngCspElement.getAttribute('ng-csp') ||
                    ngCspElement.getAttribute('data-ng-csp');
      csp.rules = {
        noUnsafeEval: !ngCspAttribute || (ngCspAttribute.indexOf('no-unsafe-eval') !== -1),
        noInlineStyle: !ngCspAttribute || (ngCspAttribute.indexOf('no-inline-style') !== -1)
      };
    } else {
      csp.rules = {
        noUnsafeEval: noUnsafeEval(),
        noInlineStyle: false
      };
    }
  }

  return csp.rules;

  function noUnsafeEval() {
    try {
      // eslint-disable-next-line no-new, no-new-func
      new Function('');
      return false;
    } catch (e) {
      return true;
    }
  }
};

/**
 * @ngdoc directive
 * @module ng
 * @name ngJq
 *
 * @element ANY
 * @param {string=} ngJq the name of the library available under `window`
 * to be used for angular.element
 * @description
 * Use this directive to force the angular.element library.  This should be
 * used to force either jqLite by leaving ng-jq blank or setting the name of
 * the jquery variable under window (eg. jQuery).
 *
 * Since AngularJS looks for this directive when it is loaded (doesn't wait for the
 * DOMContentLoaded event), it must be placed on an element that comes before the script
 * which loads angular. Also, only the first instance of `ng-jq` will be used and all
 * others ignored.
 *
 * @example
 * This example shows how to force jqLite using the `ngJq` directive to the `html` tag.
 ```html
 <!doctype html>
 <html ng-app ng-jq>
 ...
 ...
 </html>
 ```
 * @example
 * This example shows how to use a jQuery based library of a different name.
 * The library name must be available at the top most 'window'.
 ```html
 <!doctype html>
 <html ng-app ng-jq="jQueryLib">
 ...
 ...
 </html>
 ```
 */
var jq = function() {
  if (isDefined(jq.name_)) return jq.name_;
  var el;
  var i, ii = ngAttrPrefixes.length, prefix, name;
  for (i = 0; i < ii; ++i) {
    prefix = ngAttrPrefixes[i];
    el = window.document.querySelector('[' + prefix.replace(':', '\\:') + 'jq]');
    if (el) {
      name = el.getAttribute(prefix + 'jq');
      break;
    }
  }

  return (jq.name_ = name);
};

function concat(array1, array2, index) {
  return array1.concat(slice.call(array2, index));
}

function sliceArgs(args, startIndex) {
  return slice.call(args, startIndex || 0);
}


/**
 * @ngdoc function
 * @name angular.bind
 * @module ng
 * @kind function
 *
 * @description
 * Returns a function which calls function `fn` bound to `self` (`self` becomes the `this` for
 * `fn`). You can supply optional `args` that are prebound to the function. This feature is also
 * known as [partial application](http://en.wikipedia.org/wiki/Partial_application), as
 * distinguished from [function currying](http://en.wikipedia.org/wiki/Currying#Contrast_with_partial_function_application).
 *
 * @param {Object} self Context which `fn` should be evaluated in.
 * @param {function()} fn Function to be bound.
 * @param {...*} args Optional arguments to be prebound to the `fn` function call.
 * @returns {function()} Function that wraps the `fn` with all the specified bindings.
 */
function bind(self, fn) {
  var curryArgs = arguments.length > 2 ? sliceArgs(arguments, 2) : [];
  if (isFunction(fn) && !(fn instanceof RegExp)) {
    return curryArgs.length
      ? function() {
          return arguments.length
            ? fn.apply(self, concat(curryArgs, arguments, 0))
            : fn.apply(self, curryArgs);
        }
      : function() {
          return arguments.length
            ? fn.apply(self, arguments)
            : fn.call(self);
        };
  } else {
    // In IE, native methods are not functions so they cannot be bound (note: they don't need to be).
    return fn;
  }
}


function toJsonReplacer(key, value) {
  var val = value;

  if (typeof key === 'string' && key.charAt(0) === '$' && key.charAt(1) === '$') {
    val = undefined;
  } else if (isWindow(value)) {
    val = '$WINDOW';
  } else if (value &&  window.document === value) {
    val = '$DOCUMENT';
  } else if (isScope(value)) {
    val = '$SCOPE';
  }

  return val;
}


/**
 * @ngdoc function
 * @name angular.toJson
 * @module ng
 * @kind function
 *
 * @description
 * Serializes input into a JSON-formatted string. Properties with leading $$ characters will be
 * stripped since AngularJS uses this notation internally.
 *
 * @param {Object|Array|Date|string|number|boolean} obj Input to be serialized into JSON.
 * @param {boolean|number} [pretty=2] If set to true, the JSON output will contain newlines and whitespace.
 *    If set to an integer, the JSON output will contain that many spaces per indentation.
 * @returns {string|undefined} JSON-ified string representing `obj`.
 * @knownIssue
 *
 * The Safari browser throws a `RangeError` instead of returning `null` when it tries to stringify a `Date`
 * object with an invalid date value. The only reliable way to prevent this is to monkeypatch the
 * `Date.prototype.toJSON` method as follows:
 *
 * ```
 * var _DatetoJSON = Date.prototype.toJSON;
 * Date.prototype.toJSON = function() {
 *   try {
 *     return _DatetoJSON.call(this);
 *   } catch(e) {
 *     if (e instanceof RangeError) {
 *       return null;
 *     }
 *     throw e;
 *   }
 * };
 * ```
 *
 * See https://github.com/angular/angular.js/pull/14221 for more information.
 */
function toJson(obj, pretty) {
  if (isUndefined(obj)) return undefined;
  if (!isNumber(pretty)) {
    pretty = pretty ? 2 : null;
  }
  return JSON.stringify(obj, toJsonReplacer, pretty);
}


/**
 * @ngdoc function
 * @name angular.fromJson
 * @module ng
 * @kind function
 *
 * @description
 * Deserializes a JSON string.
 *
 * @param {string} json JSON string to deserialize.
 * @returns {Object|Array|string|number} Deserialized JSON string.
 */
function fromJson(json) {
  return isString(json)
      ? JSON.parse(json)
      : json;
}


var ALL_COLONS = /:/g;
function timezoneToOffset(timezone, fallback) {
  // Support: IE 9-11 only, Edge 13-15+
  // IE/Edge do not "understand" colon (`:`) in timezone
  timezone = timezone.replace(ALL_COLONS, '');
  var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
  return isNumberNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
}


function addDateMinutes(date, minutes) {
  date = new Date(date.getTime());
  date.setMinutes(date.getMinutes() + minutes);
  return date;
}


function convertTimezoneToLocal(date, timezone, reverse) {
  reverse = reverse ? -1 : 1;
  var dateTimezoneOffset = date.getTimezoneOffset();
  var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
  return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
}


/**
 * @returns {string} Returns the string representation of the element.
 */
function startingTag(element) {
  element = jqLite(element).clone().empty();
  var elemHtml = jqLite('<div></div>').append(element).html();
  try {
    return element[0].nodeType === NODE_TYPE_TEXT ? lowercase(elemHtml) :
        elemHtml.
          match(/^(<[^>]+>)/)[1].
          replace(/^<([\w-]+)/, function(match, nodeName) {return '<' + lowercase(nodeName);});
  } catch (e) {
    return lowercase(elemHtml);
  }

}


/////////////////////////////////////////////////

/**
 * Tries to decode the URI component without throwing an exception.
 *
 * @private
 * @param str value potential URI component to check.
 * @returns {boolean} True if `value` can be decoded
 * with the decodeURIComponent function.
 */
function tryDecodeURIComponent(value) {
  try {
    return decodeURIComponent(value);
  } catch (e) {
    // Ignore any invalid uri component.
  }
}


/**
 * Parses an escaped url query string into key-value pairs.
 * @returns {Object.<string,boolean|Array>}
 */
function parseKeyValue(/**string*/keyValue) {
  var obj = {};
  forEach((keyValue || '').split('&'), function(keyValue) {
    var splitPoint, key, val;
    if (keyValue) {
      key = keyValue = keyValue.replace(/\+/g,'%20');
      splitPoint = keyValue.indexOf('=');
      if (splitPoint !== -1) {
        key = keyValue.substring(0, splitPoint);
        val = keyValue.substring(splitPoint + 1);
      }
      key = tryDecodeURIComponent(key);
      if (isDefined(key)) {
        val = isDefined(val) ? tryDecodeURIComponent(val) : true;
        if (!hasOwnProperty.call(obj, key)) {
          obj[key] = val;
        } else if (isArray(obj[key])) {
          obj[key].push(val);
        } else {
          obj[key] = [obj[key],val];
        }
      }
    }
  });
  return obj;
}

function toKeyValue(obj) {
  var parts = [];
  forEach(obj, function(value, key) {
    if (isArray(value)) {
      forEach(value, function(arrayValue) {
        parts.push(encodeUriQuery(key, true) +
                   (arrayValue === true ? '' : '=' + encodeUriQuery(arrayValue, true)));
      });
    } else {
    parts.push(encodeUriQuery(key, true) +
               (value === true ? '' : '=' + encodeUriQuery(value, true)));
    }
  });
  return parts.length ? parts.join('&') : '';
}


/**
 * We need our custom method because encodeURIComponent is too aggressive and doesn't follow
 * http://www.ietf.org/rfc/rfc3986.txt with regards to the character set (pchar) allowed in path
 * segments:
 *    segment       = *pchar
 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
 *    pct-encoded   = "%" HEXDIG HEXDIG
 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
 *                     / "*" / "+" / "," / ";" / "="
 */
function encodeUriSegment(val) {
  return encodeUriQuery(val, true).
             replace(/%26/gi, '&').
             replace(/%3D/gi, '=').
             replace(/%2B/gi, '+');
}


/**
 * This method is intended for encoding *key* or *value* parts of query component. We need a custom
 * method because encodeURIComponent is too aggressive and encodes stuff that doesn't have to be
 * encoded per http://tools.ietf.org/html/rfc3986:
 *    query         = *( pchar / "/" / "?" )
 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
 *    pct-encoded   = "%" HEXDIG HEXDIG
 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
 *                     / "*" / "+" / "," / ";" / "="
 */
function encodeUriQuery(val, pctEncodeSpaces) {
  return encodeURIComponent(val).
             replace(/%40/gi, '@').
             replace(/%3A/gi, ':').
             replace(/%24/g, '$').
             replace(/%2C/gi, ',').
             replace(/%3B/gi, ';').
             replace(/%20/g, (pctEncodeSpaces ? '%20' : '+'));
}

var ngAttrPrefixes = ['ng-', 'data-ng-', 'ng:', 'x-ng-'];

function getNgAttribute(element, ngAttr) {
  var attr, i, ii = ngAttrPrefixes.length;
  for (i = 0; i < ii; ++i) {
    attr = ngAttrPrefixes[i] + ngAttr;
    if (isString(attr = element.getAttribute(attr))) {
      return attr;
    }
  }
  return null;
}

function allowAutoBootstrap(document) {
  var script = document.currentScript;

  if (!script) {
    // Support: IE 9-11 only
    // IE does not have `document.currentScript`
    return true;
  }

  // If the `currentScript` property has been clobbered just return false, since this indicates a probable attack
  if (!(script instanceof window.HTMLScriptElement || script instanceof window.SVGScriptElement)) {
    return false;
  }

  var attributes = script.attributes;
  var srcs = [attributes.getNamedItem('src'), attributes.getNamedItem('href'), attributes.getNamedItem('xlink:href')];

  return srcs.every(function(src) {
    if (!src) {
      return true;
    }
    if (!src.value) {
      return false;
    }

    var link = document.createElement('a');
    link.href = src.value;

    if (document.location.origin === link.origin) {
      // Same-origin resources are always allowed, even for banned URL schemes.
      return true;
    }
    // Disabled bootstrapping unless angular.js was loaded from a known scheme used on the web.
    // This is to prevent angular.js bundled with browser extensions from being used to bypass the
    // content security policy in web pages and other browser extensions.
    switch (link.protocol) {
      case 'http:':
      case 'https:':
      case 'ftp:':
      case 'blob:':
      case 'file:':
      case 'data:':
        return true;
      default:
        return false;
    }
  });
}

// Cached as it has to run during loading so that document.currentScript is available.
var isAutoBootstrapAllowed = allowAutoBootstrap(window.document);

/**
 * @ngdoc directive
 * @name ngApp
 * @module ng
 *
 * @element ANY
 * @param {angular.Module} ngApp an optional application
 *   {@link angular.module module} name to load.
 * @param {boolean=} ngStrictDi if this attribute is present on the app element, the injector will be
 *   created in "strict-di" mode. This means that the application will fail to invoke functions which
 *   do not use explicit function annotation (and are thus unsuitable for minification), as described
 *   in {@link guide/di the Dependency Injection guide}, and useful debugging info will assist in
 *   tracking down the root of these bugs.
 *
 * @description
 *
 * Use this directive to **auto-bootstrap** an AngularJS application. The `ngApp` directive
 * designates the **root element** of the application and is typically placed near the root element
 * of the page - e.g. on the `<body>` or `<html>` tags.
 *
 * There are a few things to keep in mind when using `ngApp`:
 * - only one AngularJS application can be auto-bootstrapped per HTML document. The first `ngApp`
 *   found in the document will be used to define the root element to auto-bootstrap as an
 *   application. To run multiple applications in an HTML document you must manually bootstrap them using
 *   {@link angular.bootstrap} instead.
 * - AngularJS applications cannot be nested within each other.
 * - Do not use a directive that uses {@link ng.$compile#transclusion transclusion} on the same element as `ngApp`.
 *   This includes directives such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and
 *   {@link ngRoute.ngView `ngView`}.
 *   Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
 *   causing animations to stop working and making the injector inaccessible from outside the app.
 *
 * You can specify an **AngularJS module** to be used as the root module for the application.  This
 * module will be loaded into the {@link auto.$injector} when the application is bootstrapped. It
 * should contain the application code needed or have dependencies on other modules that will
 * contain the code. See {@link angular.module} for more information.
 *
 * In the example below if the `ngApp` directive were not placed on the `html` element then the
 * document would not be compiled, the `AppController` would not be instantiated and the `{{ a+b }}`
 * would not be resolved to `3`.
 *
 * @example
 *
 * ### Simple Usage
 *
 * `ngApp` is the easiest, and most common way to bootstrap an application.
 *
 <example module="ngAppDemo" name="ng-app">
   <file name="index.html">
   <div ng-controller="ngAppDemoController">
     I can add: {{a}} + {{b}} =  {{ a+b }}
   </div>
   </file>
   <file name="script.js">
   angular.module('ngAppDemo', []).controller('ngAppDemoController', function($scope) {
     $scope.a = 1;
     $scope.b = 2;
   });
   </file>
 </example>
 *
 * @example
 *
 * ### With `ngStrictDi`
 *
 * Using `ngStrictDi`, you would see something like this:
 *
 <example ng-app-included="true" name="strict-di">
   <file name="index.html">
   <div ng-app="ngAppStrictDemo" ng-strict-di>
       <div ng-controller="GoodController1">
           I can add: {{a}} + {{b}} =  {{ a+b }}

           <p>This renders because the controller does not fail to
              instantiate, by using explicit annotation style (see
              script.js for details)
           </p>
       </div>

       <div ng-controller="GoodController2">
           Name: <input ng-model="name"><br />
           Hello, {{name}}!

           <p>This renders because the controller does not fail to
              instantiate, by using explicit annotation style
              (see script.js for details)
           </p>
       </div>

       <div ng-controller="BadController">
           I can add: {{a}} + {{b}} =  {{ a+b }}

           <p>The controller could not be instantiated, due to relying
              on automatic function annotations (which are disabled in
              strict mode). As such, the content of this section is not
              interpolated, and there should be an error in your web console.
           </p>
       </div>
   </div>
   </file>
   <file name="script.js">
   angular.module('ngAppStrictDemo', [])
     // BadController will fail to instantiate, due to relying on automatic function annotation,
     // rather than an explicit annotation
     .controller('BadController', function($scope) {
       $scope.a = 1;
       $scope.b = 2;
     })
     // Unlike BadController, GoodController1 and GoodController2 will not fail to be instantiated,
     // due to using explicit annotations using the array style and $inject property, respectively.
     .controller('GoodController1', ['$scope', function($scope) {
       $scope.a = 1;
       $scope.b = 2;
     }])
     .controller('GoodController2', GoodController2);
     function GoodController2($scope) {
       $scope.name = 'World';
     }
     GoodController2.$inject = ['$scope'];
   </file>
   <file name="style.css">
   div[ng-controller] {
       margin-bottom: 1em;
       -webkit-border-radius: 4px;
       border-radius: 4px;
       border: 1px solid;
       padding: .5em;
   }
   div[ng-controller^=Good] {
       border-color: #d6e9c6;
       background-color: #dff0d8;
       color: #3c763d;
   }
   div[ng-controller^=Bad] {
       border-color: #ebccd1;
       background-color: #f2dede;
       color: #a94442;
       margin-bottom: 0;
   }
   </file>
 </example>
 */
function angularInit(element, bootstrap) {
  var appElement,
      module,
      config = {};

  // The element `element` has priority over any other element.
  forEach(ngAttrPrefixes, function(prefix) {
    var name = prefix + 'app';

    if (!appElement && element.hasAttribute && element.hasAttribute(name)) {
      appElement = element;
      module = element.getAttribute(name);
    }
  });
  forEach(ngAttrPrefixes, function(prefix) {
    var name = prefix + 'app';
    var candidate;

    if (!appElement && (candidate = element.querySelector('[' + name.replace(':', '\\:') + ']'))) {
      appElement = candidate;
      module = candidate.getAttribute(name);
    }
  });
  if (appElement) {
    if (!isAutoBootstrapAllowed) {
      window.console.error('AngularJS: disabling automatic bootstrap. <script> protocol indicates ' +
          'an extension, document.location.href does not match.');
      return;
    }
    config.strictDi = getNgAttribute(appElement, 'strict-di') !== null;
    bootstrap(appElement, module ? [module] : [], config);
  }
}

/**
 * @ngdoc function
 * @name angular.bootstrap
 * @module ng
 * @description
 * Use this function to manually start up AngularJS application.
 *
 * For more information, see the {@link guide/bootstrap Bootstrap guide}.
 *
 * AngularJS will detect if it has been loaded into the browser more than once and only allow the
 * first loaded script to be bootstrapped and will report a warning to the browser console for
 * each of the subsequent scripts. This prevents strange results in applications, where otherwise
 * multiple instances of AngularJS try to work on the DOM.
 *
 * <div class="alert alert-warning">
 * **Note:** Protractor based end-to-end tests cannot use this function to bootstrap manually.
 * They must use {@link ng.directive:ngApp ngApp}.
 * </div>
 *
 * <div class="alert alert-warning">
 * **Note:** Do not bootstrap the app on an element with a directive that uses {@link ng.$compile#transclusion transclusion},
 * such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and {@link ngRoute.ngView `ngView`}.
 * Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
 * causing animations to stop working and making the injector inaccessible from outside the app.
 * </div>
 *
 * ```html
 * <!doctype html>
 * <html>
 * <body>
 * <div ng-controller="WelcomeController">
 *   {{greeting}}
 * </div>
 *
 * <script src="angular.js"></script>
 * <script>
 *   var app = angular.module('demo', [])
 *   .controller('WelcomeController', function($scope) {
 *       $scope.greeting = 'Welcome!';
 *   });
 *   angular.bootstrap(document, ['demo']);
 * </script>
 * </body>
 * </html>
 * ```
 *
 * @param {DOMElement} element DOM element which is the root of AngularJS application.
 * @param {Array<String|Function|Array>=} modules an array of modules to load into the application.
 *     Each item in the array should be the name of a predefined module or a (DI annotated)
 *     function that will be invoked by the injector as a `config` block.
 *     See: {@link angular.module modules}
 * @param {Object=} config an object for defining configuration options for the application. The
 *     following keys are supported:
 *
 * * `strictDi` - disable automatic function annotation for the application. This is meant to
 *   assist in finding bugs which break minified code. Defaults to `false`.
 *
 * @returns {auto.$injector} Returns the newly created injector for this app.
 */
function bootstrap(element, modules, config) {
  if (!isObject(config)) config = {};
  var defaultConfig = {
    strictDi: false
  };
  config = extend(defaultConfig, config);
  var doBootstrap = function() {
    element = jqLite(element);

    if (element.injector()) {
      var tag = (element[0] === window.document) ? 'document' : startingTag(element);
      // Encode angle brackets to prevent input from being sanitized to empty string #8683.
      throw ngMinErr(
          'btstrpd',
          'App already bootstrapped with this element \'{0}\'',
          tag.replace(/</,'&lt;').replace(/>/,'&gt;'));
    }

    modules = modules || [];
    modules.unshift(['$provide', function($provide) {
      $provide.value('$rootElement', element);
    }]);

    if (config.debugInfoEnabled) {
      // Pushing so that this overrides `debugInfoEnabled` setting defined in user's `modules`.
      modules.push(['$compileProvider', function($compileProvider) {
        $compileProvider.debugInfoEnabled(true);
      }]);
    }

    modules.unshift('ng');
    var injector = createInjector(modules, config.strictDi);
    injector.invoke(['$rootScope', '$rootElement', '$compile', '$injector',
       function bootstrapApply(scope, element, compile, injector) {
        scope.$apply(function() {
          element.data('$injector', injector);
          compile(element)(scope);
        });
      }]
    );
    return injector;
  };

  var NG_ENABLE_DEBUG_INFO = /^NG_ENABLE_DEBUG_INFO!/;
  var NG_DEFER_BOOTSTRAP = /^NG_DEFER_BOOTSTRAP!/;

  if (window && NG_ENABLE_DEBUG_INFO.test(window.name)) {
    config.debugInfoEnabled = true;
    window.name = window.name.replace(NG_ENABLE_DEBUG_INFO, '');
  }

  if (window && !NG_DEFER_BOOTSTRAP.test(window.name)) {
    return doBootstrap();
  }

  window.name = window.name.replace(NG_DEFER_BOOTSTRAP, '');
  angular.resumeBootstrap = function(extraModules) {
    forEach(extraModules, function(module) {
      modules.push(module);
    });
    return doBootstrap();
  };

  if (isFunction(angular.resumeDeferredBootstrap)) {
    angular.resumeDeferredBootstrap();
  }
}

/**
 * @ngdoc function
 * @name angular.reloadWithDebugInfo
 * @module ng
 * @description
 * Use this function to reload the current application with debug information turned on.
 * This takes precedence over a call to `$compileProvider.debugInfoEnabled(false)`.
 *
 * See {@link ng.$compileProvider#debugInfoEnabled} for more.
 */
function reloadWithDebugInfo() {
  window.name = 'NG_ENABLE_DEBUG_INFO!' + window.name;
  window.location.reload();
}

/**
 * @name angular.getTestability
 * @module ng
 * @description
 * Get the testability service for the instance of AngularJS on the given
 * element.
 * @param {DOMElement} element DOM element which is the root of AngularJS application.
 */
function getTestability(rootElement) {
  var injector = angular.element(rootElement).injector();
  if (!injector) {
    throw ngMinErr('test',
      'no injector found for element argument to getTestability');
  }
  return injector.get('$$testability');
}

var SNAKE_CASE_REGEXP = /[A-Z]/g;
function snake_case(name, separator) {
  separator = separator || '_';
  return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
    return (pos ? separator : '') + letter.toLowerCase();
  });
}

var bindJQueryFired = false;
function bindJQuery() {
  var originalCleanData;

  if (bindJQueryFired) {
    return;
  }

  // bind to jQuery if present;
  var jqName = jq();
  jQuery = isUndefined(jqName) ? window.jQuery :   // use jQuery (if present)
           !jqName             ? undefined     :   // use jqLite
                                 window[jqName];   // use jQuery specified by `ngJq`

  // Use jQuery if it exists with proper functionality, otherwise default to us.
  // AngularJS 1.2+ requires jQuery 1.7+ for on()/off() support.
  // AngularJS 1.3+ technically requires at least jQuery 2.1+ but it may work with older
  // versions. It will not work for sure with jQuery <1.7, though.
  if (jQuery && jQuery.fn.on) {
    jqLite = jQuery;
    extend(jQuery.fn, {
      scope: JQLitePrototype.scope,
      isolateScope: JQLitePrototype.isolateScope,
      controller: /** @type {?} */ (JQLitePrototype).controller,
      injector: JQLitePrototype.injector,
      inheritedData: JQLitePrototype.inheritedData
    });
  } else {
    jqLite = JQLite;
  }

  // All nodes removed from the DOM via various jqLite/jQuery APIs like .remove()
  // are passed through jqLite/jQuery.cleanData. Monkey-patch this method to fire
  // the $destroy event on all removed nodes.
  originalCleanData = jqLite.cleanData;
  jqLite.cleanData = function(elems) {
    var events;
    for (var i = 0, elem; (elem = elems[i]) != null; i++) {
      events = (jqLite._data(elem) || {}).events;
      if (events && events.$destroy) {
        jqLite(elem).triggerHandler('$destroy');
      }
    }
    originalCleanData(elems);
  };

  angular.element = jqLite;

  // Prevent double-proxying.
  bindJQueryFired = true;
}

/**
 * @ngdoc function
 * @name angular.UNSAFE_restoreLegacyJqLiteXHTMLReplacement
 * @module ng
 * @kind function
 *
 * @description
 * Restores the pre-1.8 behavior of jqLite that turns XHTML-like strings like
 * `<div /><span />` to `<div></div><span></span>` instead of `<div><span></span></div>`.
 * The new behavior is a security fix. Thus, if you need to call this function, please try to adjust
 * your code for this change and remove your use of this function as soon as possible.

 * Note that this only patches jqLite. If you use jQuery 3.5.0 or newer, please read the
 * [jQuery 3.5 upgrade guide](https://jquery.com/upgrade-guide/3.5/) for more details
 * about the workarounds.
 */
function UNSAFE_restoreLegacyJqLiteXHTMLReplacement() {
  JQLite.legacyXHTMLReplacement = true;
}

/**
 * throw error if the argument is falsy.
 */
function assertArg(arg, name, reason) {
  if (!arg) {
    throw ngMinErr('areq', 'Argument \'{0}\' is {1}', (name || '?'), (reason || 'required'));
  }
  return arg;
}

function assertArgFn(arg, name, acceptArrayAnnotation) {
  if (acceptArrayAnnotation && isArray(arg)) {
      arg = arg[arg.length - 1];
  }

  assertArg(isFunction(arg), name, 'not a function, got ' +
      (arg && typeof arg === 'object' ? arg.constructor.name || 'Object' : typeof arg));
  return arg;
}

/**
 * throw error if the name given is hasOwnProperty
 * @param  {String} name    the name to test
 * @param  {String} context the context in which the name is used, such as module or directive
 */
function assertNotHasOwnProperty(name, context) {
  if (name === 'hasOwnProperty') {
    throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
  }
}

/**
 * Return the value accessible from the object by path. Any undefined traversals are ignored
 * @param {Object} obj starting object
 * @param {String} path path to traverse
 * @param {boolean} [bindFnToScope=true]
 * @returns {Object} value as accessible by path
 */
//TODO(misko): this function needs to be removed
function getter(obj, path, bindFnToScope) {
  if (!path) return obj;
  var keys = path.split('.');
  var key;
  var lastInstance = obj;
  var len = keys.length;

  for (var i = 0; i < len; i++) {
    key = keys[i];
    if (obj) {
      obj = (lastInstance = obj)[key];
    }
  }
  if (!bindFnToScope && isFunction(obj)) {
    return bind(lastInstance, obj);
  }
  return obj;
}

/**
 * Return the DOM siblings between the first and last node in the given array.
 * @param {Array} array like object
 * @returns {Array} the inputted object or a jqLite collection containing the nodes
 */
function getBlockNodes(nodes) {
  // TODO(perf): update `nodes` instead of creating a new object?
  var node = nodes[0];
  var endNode = nodes[nodes.length - 1];
  var blockNodes;

  for (var i = 1; node !== endNode && (node = node.nextSibling); i++) {
    if (blockNodes || nodes[i] !== node) {
      if (!blockNodes) {
        blockNodes = jqLite(slice.call(nodes, 0, i));
      }
      blockNodes.push(node);
    }
  }

  return blockNodes || nodes;
}


/**
 * Creates a new object without a prototype. This object is useful for lookup without having to
 * guard against prototypically inherited properties via hasOwnProperty.
 *
 * Related micro-benchmarks:
 * - http://jsperf.com/object-create2
 * - http://jsperf.com/proto-map-lookup/2
 * - http://jsperf.com/for-in-vs-object-keys2
 *
 * @returns {Object}
 */
function createMap() {
  return Object.create(null);
}

function stringify(value) {
  if (value == null) { // null || undefined
    return '';
  }
  switch (typeof value) {
    case 'string':
      break;
    case 'number':
      value = '' + value;
      break;
    default:
      if (hasCustomToString(value) && !isArray(value) && !isDate(value)) {
        value = value.toString();
      } else {
        value = toJson(value);
      }
  }

  return value;
}

var NODE_TYPE_ELEMENT = 1;
var NODE_TYPE_ATTRIBUTE = 2;
var NODE_TYPE_TEXT = 3;
var NODE_TYPE_COMMENT = 8;
var NODE_TYPE_DOCUMENT = 9;
var NODE_TYPE_DOCUMENT_FRAGMENT = 11;

/**
 * @ngdoc type
 * @name angular.Module
 * @module ng
 * @description
 *
 * Interface for configuring AngularJS {@link angular.module modules}.
 */

function setupModuleLoader(window) {

  var $injectorMinErr = minErr('$injector');
  var ngMinErr = minErr('ng');

  function ensure(obj, name, factory) {
    return obj[name] || (obj[name] = factory());
  }

  var angular = ensure(window, 'angular', Object);

  // We need to expose `angular.$$minErr` to modules such as `ngResource` that reference it during bootstrap
  angular.$$minErr = angular.$$minErr || minErr;

  return ensure(angular, 'module', function() {
    /** @type {Object.<string, angular.Module>} */
    var modules = {};

    /**
     * @ngdoc function
     * @name angular.module
     * @module ng
     * @description
     *
     * The `angular.module` is a global place for creating, registering and retrieving AngularJS
     * modules.
     * All modules (AngularJS core or 3rd party) that should be available to an application must be
     * registered using this mechanism.
     *
     * Passing one argument retrieves an existing {@link angular.Module},
     * whereas passing more than one argument creates a new {@link angular.Module}
     *
     *
     * # Module
     *
     * A module is a collection of services, directives, controllers, filters, and configuration information.
     * `angular.module` is used to configure the {@link auto.$injector $injector}.
     *
     * ```js
     * // Create a new module
     * var myModule = angular.module('myModule', []);
     *
     * // register a new service
     * myModule.value('appName', 'MyCoolApp');
     *
     * // configure existing services inside initialization blocks.
     * myModule.config(['$locationProvider', function($locationProvider) {
     *   // Configure existing providers
     *   $locationProvider.hashPrefix('!');
     * }]);
     * ```
     *
     * Then you can create an injector and load your modules like this:
     *
     * ```js
     * var injector = angular.injector(['ng', 'myModule'])
     * ```
     *
     * However it's more likely that you'll just use
     * {@link ng.directive:ngApp ngApp} or
     * {@link angular.bootstrap} to simplify this process for you.
     *
     * @param {!string} name The name of the module to create or retrieve.
     * @param {!Array.<string>=} requires If specified then new module is being created. If
     *        unspecified then the module is being retrieved for further configuration.
     * @param {Function=} configFn Optional configuration function for the module. Same as
     *        {@link angular.Module#config Module#config()}.
     * @returns {angular.Module} new module with the {@link angular.Module} api.
     */
    return function module(name, requires, configFn) {

      var info = {};

      var assertNotHasOwnProperty = function(name, context) {
        if (name === 'hasOwnProperty') {
          throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
        }
      };

      assertNotHasOwnProperty(name, 'module');
      if (requires && modules.hasOwnProperty(name)) {
        modules[name] = null;
      }
      return ensure(modules, name, function() {
        if (!requires) {
          throw $injectorMinErr('nomod', 'Module \'{0}\' is not available! You either misspelled ' +
             'the module name or forgot to load it. If registering a module ensure that you ' +
             'specify the dependencies as the second argument.', name);
        }

        /** @type {!Array.<Array.<*>>} */
        var invokeQueue = [];

        /** @type {!Array.<Function>} */
        var configBlocks = [];

        /** @type {!Array.<Function>} */
        var runBlocks = [];

        var config = invokeLater('$injector', 'invoke', 'push', configBlocks);

        /** @type {angular.Module} */
        var moduleInstance = {
          // Private state
          _invokeQueue: invokeQueue,
          _configBlocks: configBlocks,
          _runBlocks: runBlocks,

          /**
           * @ngdoc method
           * @name angular.Module#info
           * @module ng
           *
           * @param {Object=} info Information about the module
           * @returns {Object|Module} The current info object for this module if called as a getter,
           *                          or `this` if called as a setter.
           *
           * @description
           * Read and write custom information about this module.
           * For example you could put the version of the module in here.
           *
           * ```js
           * angular.module('myModule', []).info({ version: '1.0.0' });
           * ```
           *
           * The version could then be read back out by accessing the module elsewhere:
           *
           * ```
           * var version = angular.module('myModule').info().version;
           * ```
           *
           * You can also retrieve this information during runtime via the
           * {@link $injector#modules `$injector.modules`} property:
           *
           * ```js
           * var version = $injector.modules['myModule'].info().version;
           * ```
           */
          info: function(value) {
            if (isDefined(value)) {
              if (!isObject(value)) throw ngMinErr('aobj', 'Argument \'{0}\' must be an object', 'value');
              info = value;
              return this;
            }
            return info;
          },

          /**
           * @ngdoc property
           * @name angular.Module#requires
           * @module ng
           *
           * @description
           * Holds the list of modules which the injector will load before the current module is
           * loaded.
           */
          requires: requires,

          /**
           * @ngdoc property
           * @name angular.Module#name
           * @module ng
           *
           * @description
           * Name of the module.
           */
          name: name,


          /**
           * @ngdoc method
           * @name angular.Module#provider
           * @module ng
           * @param {string} name service name
           * @param {Function} providerType Construction function for creating new instance of the
           *                                service.
           * @description
           * See {@link auto.$provide#provider $provide.provider()}.
           */
          provider: invokeLaterAndSetModuleName('$provide', 'provider'),

          /**
           * @ngdoc method
           * @name angular.Module#factory
           * @module ng
           * @param {string} name service name
           * @param {Function} providerFunction Function for creating new instance of the service.
           * @description
           * See {@link auto.$provide#factory $provide.factory()}.
           */
          factory: invokeLaterAndSetModuleName('$provide', 'factory'),

          /**
           * @ngdoc method
           * @name angular.Module#service
           * @module ng
           * @param {string} name service name
           * @param {Function} constructor A constructor function that will be instantiated.
           * @description
           * See {@link auto.$provide#service $provide.service()}.
           */
          service: invokeLaterAndSetModuleName('$provide', 'service'),

          /**
           * @ngdoc method
           * @name angular.Module#value
           * @module ng
           * @param {string} name service name
           * @param {*} object Service instance object.
           * @description
           * See {@link auto.$provide#value $provide.value()}.
           */
          value: invokeLater('$provide', 'value'),

          /**
           * @ngdoc method
           * @name angular.Module#constant
           * @module ng
           * @param {string} name constant name
           * @param {*} object Constant value.
           * @description
           * Because the constants are fixed, they get applied before other provide methods.
           * See {@link auto.$provide#constant $provide.constant()}.
           */
          constant: invokeLater('$provide', 'constant', 'unshift'),

           /**
           * @ngdoc method
           * @name angular.Module#decorator
           * @module ng
           * @param {string} name The name of the service to decorate.
           * @param {Function} decorFn This function will be invoked when the service needs to be
           *                           instantiated and should return the decorated service instance.
           * @description
           * See {@link auto.$provide#decorator $provide.decorator()}.
           */
          decorator: invokeLaterAndSetModuleName('$provide', 'decorator', configBlocks),

          /**
           * @ngdoc method
           * @name angular.Module#animation
           * @module ng
           * @param {string} name animation name
           * @param {Function} animationFactory Factory function for creating new instance of an
           *                                    animation.
           * @description
           *
           * **NOTE**: animations take effect only if the **ngAnimate** module is loaded.
           *
           *
           * Defines an animation hook that can be later used with
           * {@link $animate $animate} service and directives that use this service.
           *
           * ```js
           * module.animation('.animation-name', function($inject1, $inject2) {
           *   return {
           *     eventName : function(element, done) {
           *       //code to run the animation
           *       //once complete, then run done()
           *       return function cancellationFunction(element) {
           *         //code to cancel the animation
           *       }
           *     }
           *   }
           * })
           * ```
           *
           * See {@link ng.$animateProvider#register $animateProvider.register()} and
           * {@link ngAnimate ngAnimate module} for more information.
           */
          animation: invokeLaterAndSetModuleName('$animateProvider', 'register'),

          /**
           * @ngdoc method
           * @name angular.Module#filter
           * @module ng
           * @param {string} name Filter name - this must be a valid AngularJS expression identifier
           * @param {Function} filterFactory Factory function for creating new instance of filter.
           * @description
           * See {@link ng.$filterProvider#register $filterProvider.register()}.
           *
           * <div class="alert alert-warning">
           * **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
           * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
           * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
           * (`myapp_subsection_filterx`).
           * </div>
           */
          filter: invokeLaterAndSetModuleName('$filterProvider', 'register'),

          /**
           * @ngdoc method
           * @name angular.Module#controller
           * @module ng
           * @param {string|Object} name Controller name, or an object map of controllers where the
           *    keys are the names and the values are the constructors.
           * @param {Function} constructor Controller constructor function.
           * @description
           * See {@link ng.$controllerProvider#register $controllerProvider.register()}.
           */
          controller: invokeLaterAndSetModuleName('$controllerProvider', 'register'),

          /**
           * @ngdoc method
           * @name angular.Module#directive
           * @module ng
           * @param {string|Object} name Directive name, or an object map of directives where the
           *    keys are the names and the values are the factories.
           * @param {Function} directiveFactory Factory function for creating new instance of
           * directives.
           * @description
           * See {@link ng.$compileProvider#directive $compileProvider.directive()}.
           */
          directive: invokeLaterAndSetModuleName('$compileProvider', 'directive'),

          /**
           * @ngdoc method
           * @name angular.Module#component
           * @module ng
           * @param {string|Object} name Name of the component in camelCase (i.e. `myComp` which will match `<my-comp>`),
           *    or an object map of components where the keys are the names and the values are the component definition objects.
           * @param {Object} options Component definition object (a simplified
           *    {@link ng.$compile#directive-definition-object directive definition object})
           *
           * @description
           * See {@link ng.$compileProvider#component $compileProvider.component()}.
           */
          component: invokeLaterAndSetModuleName('$compileProvider', 'component'),

          /**
           * @ngdoc method
           * @name angular.Module#config
           * @module ng
           * @param {Function} configFn Execute this function on module load. Useful for service
           *    configuration.
           * @description
           * Use this method to configure services by injecting their
           * {@link angular.Module#provider `providers`}, e.g. for adding routes to the
           * {@link ngRoute.$routeProvider $routeProvider}.
           *
           * Note that you can only inject {@link angular.Module#provider `providers`} and
           * {@link angular.Module#constant `constants`} into this function.
           *
           * For more about how to configure services, see
           * {@link providers#provider-recipe Provider Recipe}.
           */
          config: config,

          /**
           * @ngdoc method
           * @name angular.Module#run
           * @module ng
           * @param {Function} initializationFn Execute this function after injector creation.
           *    Useful for application initialization.
           * @description
           * Use this method to register work which should be performed when the injector is done
           * loading all modules.
           */
          run: function(block) {
            runBlocks.push(block);
            return this;
          }
        };

        if (configFn) {
          config(configFn);
        }

        return moduleInstance;

        /**
         * @param {string} provider
         * @param {string} method
         * @param {String=} insertMethod
         * @returns {angular.Module}
         */
        function invokeLater(provider, method, insertMethod, queue) {
          if (!queue) queue = invokeQueue;
          return function() {
            queue[insertMethod || 'push']([provider, method, arguments]);
            return moduleInstance;
          };
        }

        /**
         * @param {string} provider
         * @param {string} method
         * @returns {angular.Module}
         */
        function invokeLaterAndSetModuleName(provider, method, queue) {
          if (!queue) queue = invokeQueue;
          return function(recipeName, factoryFunction) {
            if (factoryFunction && isFunction(factoryFunction)) factoryFunction.$$moduleName = name;
            queue.push([provider, method, arguments]);
            return moduleInstance;
          };
        }
      });
    };
  });

}

/* global shallowCopy: true */

/**
 * Creates a shallow copy of an object, an array or a primitive.
 *
 * Assumes that there are no proto properties for objects.
 */
function shallowCopy(src, dst) {
  if (isArray(src)) {
    dst = dst || [];

    for (var i = 0, ii = src.length; i < ii; i++) {
      dst[i] = src[i];
    }
  } else if (isObject(src)) {
    dst = dst || {};

    for (var key in src) {
      if (!(key.charAt(0) === '$' && key.charAt(1) === '$')) {
        dst[key] = src[key];
      }
    }
  }

  return dst || src;
}

/* exported toDebugString */

function serializeObject(obj, maxDepth) {
  var seen = [];

  // There is no direct way to stringify object until reaching a specific depth
  // and a very deep object can cause a performance issue, so we copy the object
  // based on this specific depth and then stringify it.
  if (isValidObjectMaxDepth(maxDepth)) {
    // This file is also included in `angular-loader`, so `copy()` might not always be available in
    // the closure. Therefore, it is lazily retrieved as `angular.copy()` when needed.
    obj = angular.copy(obj, null, maxDepth);
  }
  return JSON.stringify(obj, function(key, val) {
    val = toJsonReplacer(key, val);
    if (isObject(val)) {

      if (seen.indexOf(val) >= 0) return '...';

      seen.push(val);
    }
    return val;
  });
}

function toDebugString(obj, maxDepth) {
  if (typeof obj === 'function') {
    return obj.toString().replace(/ \{[\s\S]*$/, '');
  } else if (isUndefined(obj)) {
    return 'undefined';
  } else if (typeof obj !== 'string') {
    return serializeObject(obj, maxDepth);
  }
  return obj;
}

/* global angularModule: true,
  version: true,

  $CompileProvider,

  htmlAnchorDirective,
  inputDirective,
  hiddenInputBrowserCacheDirective,
  formDirective,
  scriptDirective,
  selectDirective,
  optionDirective,
  ngBindDirective,
  ngBindHtmlDirective,
  ngBindTemplateDirective,
  ngClassDirective,
  ngClassEvenDirective,
  ngClassOddDirective,
  ngCloakDirective,
  ngControllerDirective,
  ngFormDirective,
  ngHideDirective,
  ngIfDirective,
  ngIncludeDirective,
  ngIncludeFillContentDirective,
  ngInitDirective,
  ngNonBindableDirective,
  ngPluralizeDirective,
  ngRefDirective,
  ngRepeatDirective,
  ngShowDirective,
  ngStyleDirective,
  ngSwitchDirective,
  ngSwitchWhenDirective,
  ngSwitchDefaultDirective,
  ngOptionsDirective,
  ngTranscludeDirective,
  ngModelDirective,
  ngListDirective,
  ngChangeDirective,
  patternDirective,
  patternDirective,
  requiredDirective,
  requiredDirective,
  minlengthDirective,
  minlengthDirective,
  maxlengthDirective,
  maxlengthDirective,
  ngValueDirective,
  ngModelOptionsDirective,
  ngAttributeAliasDirectives,
  ngEventDirectives,

  $AnchorScrollProvider,
  $AnimateProvider,
  $CoreAnimateCssProvider,
  $$CoreAnimateJsProvider,
  $$CoreAnimateQueueProvider,
  $$AnimateRunnerFactoryProvider,
  $$AnimateAsyncRunFactoryProvider,
  $BrowserProvider,
  $CacheFactoryProvider,
  $ControllerProvider,
  $DateProvider,
  $DocumentProvider,
  $$IsDocumentHiddenProvider,
  $ExceptionHandlerProvider,
  $FilterProvider,
  $$ForceReflowProvider,
  $InterpolateProvider,
  $$IntervalFactoryProvider,
  $IntervalProvider,
  $HttpProvider,
  $HttpParamSerializerProvider,
  $HttpParamSerializerJQLikeProvider,
  $HttpBackendProvider,
  $xhrFactoryProvider,
  $jsonpCallbacksProvider,
  $LocationProvider,
  $LogProvider,
  $$MapProvider,
  $ParseProvider,
  $RootScopeProvider,
  $QProvider,
  $$QProvider,
  $$SanitizeUriProvider,
  $SceProvider,
  $SceDelegateProvider,
  $SnifferProvider,
  $$TaskTrackerFactoryProvider,
  $TemplateCacheProvider,
  $TemplateRequestProvider,
  $$TestabilityProvider,
  $TimeoutProvider,
  $$RAFProvider,
  $WindowProvider,
  $$jqLiteProvider,
  $$CookieReaderProvider
*/


/**
 * @ngdoc object
 * @name angular.version
 * @module ng
 * @description
 * An object that contains information about the current AngularJS version.
 *
 * This object has the following properties:
 *
 * - `full` – `{string}` – Full version string, such as "0.9.18".
 * - `major` – `{number}` – Major version number, such as "0".
 * - `minor` – `{number}` – Minor version number, such as "9".
 * - `dot` – `{number}` – Dot version number, such as "18".
 * - `codeName` – `{string}` – Code name of the release, such as "jiggling-armfat".
 */
var version = {
  // These placeholder strings will be replaced by grunt's `build` task.
  // They need to be double- or single-quoted.
  full: '1.8.3',
  major: 1,
  minor: 8,
  dot: 3,
  codeName: 'ultimate-farewell'
};


function publishExternalAPI(angular) {
  extend(angular, {
    'errorHandlingConfig': errorHandlingConfig,
    'bootstrap': bootstrap,
    'copy': copy,
    'extend': extend,
    'merge': merge,
    'equals': equals,
    'element': jqLite,
    'forEach': forEach,
    'injector': createInjector,
    'noop': noop,
    'bind': bind,
    'toJson': toJson,
    'fromJson': fromJson,
    'identity': identity,
    'isUndefined': isUndefined,
    'isDefined': isDefined,
    'isString': isString,
    'isFunction': isFunction,
    'isObject': isObject,
    'isNumber': isNumber,
    'isElement': isElement,
    'isArray': isArray,
    'version': version,
    'isDate': isDate,
    'callbacks': {$$counter: 0},
    'getTestability': getTestability,
    'reloadWithDebugInfo': reloadWithDebugInfo,
    'UNSAFE_restoreLegacyJqLiteXHTMLReplacement': UNSAFE_restoreLegacyJqLiteXHTMLReplacement,
    '$$minErr': minErr,
    '$$csp': csp,
    '$$encodeUriSegment': encodeUriSegment,
    '$$encodeUriQuery': encodeUriQuery,
    '$$lowercase': lowercase,
    '$$stringify': stringify,
    '$$uppercase': uppercase
  });

  angularModule = setupModuleLoader(window);

  angularModule('ng', ['ngLocale'], ['$provide',
    function ngModule($provide) {
      // $$sanitizeUriProvider needs to be before $compileProvider as it is used by it.
      $provide.provider({
        $$sanitizeUri: $$SanitizeUriProvider
      });
      $provide.provider('$compile', $CompileProvider).
        directive({
            a: htmlAnchorDirective,
            input: inputDirective,
            textarea: inputDirective,
            form: formDirective,
            script: scriptDirective,
            select: selectDirective,
            option: optionDirective,
            ngBind: ngBindDirective,
            ngBindHtml: ngBindHtmlDirective,
            ngBindTemplate: ngBindTemplateDirective,
            ngClass: ngClassDirective,
            ngClassEven: ngClassEvenDirective,
            ngClassOdd: ngClassOddDirective,
            ngCloak: ngCloakDirective,
            ngController: ngControllerDirective,
            ngForm: ngFormDirective,
            ngHide: ngHideDirective,
            ngIf: ngIfDirective,
            ngInclude: ngIncludeDirective,
            ngInit: ngInitDirective,
            ngNonBindable: ngNonBindableDirective,
            ngPluralize: ngPluralizeDirective,
            ngRef: ngRefDirective,
            ngRepeat: ngRepeatDirective,
            ngShow: ngShowDirective,
            ngStyle: ngStyleDirective,
            ngSwitch: ngSwitchDirective,
            ngSwitchWhen: ngSwitchWhenDirective,
            ngSwitchDefault: ngSwitchDefaultDirective,
            ngOptions: ngOptionsDirective,
            ngTransclude: ngTranscludeDirective,
            ngModel: ngModelDirective,
            ngList: ngListDirective,
            ngChange: ngChangeDirective,
            pattern: patternDirective,
            ngPattern: patternDirective,
            required: requiredDirective,
            ngRequired: requiredDirective,
            minlength: minlengthDirective,
            ngMinlength: minlengthDirective,
            maxlength: maxlengthDirective,
            ngMaxlength: maxlengthDirective,
            ngValue: ngValueDirective,
            ngModelOptions: ngModelOptionsDirective
        }).
        directive({
          ngInclude: ngIncludeFillContentDirective,
          input: hiddenInputBrowserCacheDirective
        }).
        directive(ngAttributeAliasDirectives).
        directive(ngEventDirectives);
      $provide.provider({
        $anchorScroll: $AnchorScrollProvider,
        $animate: $AnimateProvider,
        $animateCss: $CoreAnimateCssProvider,
        $$animateJs: $$CoreAnimateJsProvider,
        $$animateQueue: $$CoreAnimateQueueProvider,
        $$AnimateRunner: $$AnimateRunnerFactoryProvider,
        $$animateAsyncRun: $$AnimateAsyncRunFactoryProvider,
        $browser: $BrowserProvider,
        $cacheFactory: $CacheFactoryProvider,
        $controller: $ControllerProvider,
        $document: $DocumentProvider,
        $$isDocumentHidden: $$IsDocumentHiddenProvider,
        $exceptionHandler: $ExceptionHandlerProvider,
        $filter: $FilterProvider,
        $$forceReflow: $$ForceReflowProvider,
        $interpolate: $InterpolateProvider,
        $interval: $IntervalProvider,
        $$intervalFactory: $$IntervalFactoryProvider,
        $http: $HttpProvider,
        $httpParamSerializer: $HttpParamSerializerProvider,
        $httpParamSerializerJQLike: $HttpParamSerializerJQLikeProvider,
        $httpBackend: $HttpBackendProvider,
        $xhrFactory: $xhrFactoryProvider,
        $jsonpCallbacks: $jsonpCallbacksProvider,
        $location: $LocationProvider,
        $log: $LogProvider,
        $parse: $ParseProvider,
        $rootScope: $RootScopeProvider,
        $q: $QProvider,
        $$q: $$QProvider,
        $sce: $SceProvider,
        $sceDelegate: $SceDelegateProvider,
        $sniffer: $SnifferProvider,
        $$taskTrackerFactory: $$TaskTrackerFactoryProvider,
        $templateCache: $TemplateCacheProvider,
        $templateRequest: $TemplateRequestProvider,
        $$testability: $$TestabilityProvider,
        $timeout: $TimeoutProvider,
        $window: $WindowProvider,
        $$rAF: $$RAFProvider,
        $$jqLite: $$jqLiteProvider,
        $$Map: $$MapProvider,
        $$cookieReader: $$CookieReaderProvider
      });
    }
  ])
  .info({ angularVersion: '1.8.3' });
}

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables likes document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

/* global
  JQLitePrototype: true,
  BOOLEAN_ATTR: true,
  ALIASED_ATTR: true
*/

//////////////////////////////////
//JQLite
//////////////////////////////////

/**
 * @ngdoc function
 * @name angular.element
 * @module ng
 * @kind function
 *
 * @description
 * Wraps a raw DOM element or HTML string as a [jQuery](http://jquery.com) element.
 *
 * If jQuery is available, `angular.element` is an alias for the
 * [jQuery](http://api.jquery.com/jQuery/) function. If jQuery is not available, `angular.element`
 * delegates to AngularJS's built-in subset of jQuery, called "jQuery lite" or **jqLite**.
 *
 * jqLite is a tiny, API-compatible subset of jQuery that allows
 * AngularJS to manipulate the DOM in a cross-browser compatible way. jqLite implements only the most
 * commonly needed functionality with the goal of having a very small footprint.
 *
 * To use `jQuery`, simply ensure it is loaded before the `angular.js` file. You can also use the
 * {@link ngJq `ngJq`} directive to specify that jqlite should be used over jQuery, or to use a
 * specific version of jQuery if multiple versions exist on the page.
 *
 * <div class="alert alert-info">**Note:** All element references in AngularJS are always wrapped with jQuery or
 * jqLite (such as the element argument in a directive's compile / link function). They are never raw DOM references.</div>
 *
 * <div class="alert alert-warning">**Note:** Keep in mind that this function will not find elements
 * by tag name / CSS selector. For lookups by tag name, try instead `angular.element(document).find(...)`
 * or `$document.find()`, or use the standard DOM APIs, e.g. `document.querySelectorAll()`.</div>
 *
 * ## AngularJS's jqLite
 * jqLite provides only the following jQuery methods:
 *
 * - [`addClass()`](http://api.jquery.com/addClass/) - Does not support a function as first argument
 * - [`after()`](http://api.jquery.com/after/)
 * - [`append()`](http://api.jquery.com/append/) - Contrary to jQuery, this doesn't clone elements
 *   so will not work correctly when invoked on a jqLite object containing more than one DOM node
 * - [`attr()`](http://api.jquery.com/attr/) - Does not support functions as parameters
 * - [`bind()`](http://api.jquery.com/bind/) (_deprecated_, use [`on()`](http://api.jquery.com/on/)) - Does not support namespaces, selectors or eventData
 * - [`children()`](http://api.jquery.com/children/) - Does not support selectors
 * - [`clone()`](http://api.jquery.com/clone/)
 * - [`contents()`](http://api.jquery.com/contents/)
 * - [`css()`](http://api.jquery.com/css/) - Only retrieves inline-styles, does not call `getComputedStyle()`.
 *   As a setter, does not convert numbers to strings or append 'px', and also does not have automatic property prefixing.
 * - [`data()`](http://api.jquery.com/data/)
 * - [`detach()`](http://api.jquery.com/detach/)
 * - [`empty()`](http://api.jquery.com/empty/)
 * - [`eq()`](http://api.jquery.com/eq/)
 * - [`find()`](http://api.jquery.com/find/) - Limited to lookups by tag name
 * - [`hasClass()`](http://api.jquery.com/hasClass/)
 * - [`html()`](http://api.jquery.com/html/)
 * - [`next()`](http://api.jquery.com/next/) - Does not support selectors
 * - [`on()`](http://api.jquery.com/on/) - Does not support namespaces, selectors or eventData
 * - [`off()`](http://api.jquery.com/off/) - Does not support namespaces, selectors or event object as parameter
 * - [`one()`](http://api.jquery.com/one/) - Does not support namespaces or selectors
 * - [`parent()`](http://api.jquery.com/parent/) - Does not support selectors
 * - [`prepend()`](http://api.jquery.com/prepend/)
 * - [`prop()`](http://api.jquery.com/prop/)
 * - [`ready()`](http://api.jquery.com/ready/) (_deprecated_, use `angular.element(callback)` instead of `angular.element(document).ready(callback)`)
 * - [`remove()`](http://api.jquery.com/remove/)
 * - [`removeAttr()`](http://api.jquery.com/removeAttr/) - Does not support multiple attributes
 * - [`removeClass()`](http://api.jquery.com/removeClass/) - Does not support a function as first argument
 * - [`removeData()`](http://api.jquery.com/removeData/)
 * - [`replaceWith()`](http://api.jquery.com/replaceWith/)
 * - [`text()`](http://api.jquery.com/text/)
 * - [`toggleClass()`](http://api.jquery.com/toggleClass/) - Does not support a function as first argument
 * - [`triggerHandler()`](http://api.jquery.com/triggerHandler/) - Passes a dummy event object to handlers
 * - [`unbind()`](http://api.jquery.com/unbind/) (_deprecated_, use [`off()`](http://api.jquery.com/off/)) - Does not support namespaces or event object as parameter
 * - [`val()`](http://api.jquery.com/val/)
 * - [`wrap()`](http://api.jquery.com/wrap/)
 *
 * jqLite also provides a method restoring pre-1.8 insecure treatment of XHTML-like tags.
 * This legacy behavior turns input like `<div /><span />` to `<div></div><span></span>`
 * instead of `<div><span></span></div>` like version 1.8 & newer do. To restore it, invoke:
 * ```js
 * angular.UNSAFE_restoreLegacyJqLiteXHTMLReplacement();
 * ```
 * Note that this only patches jqLite. If you use jQuery 3.5.0 or newer, please read the
 * [jQuery 3.5 upgrade guide](https://jquery.com/upgrade-guide/3.5/) for more details
 * about the workarounds.
 *
 * ## jQuery/jqLite Extras
 * AngularJS also provides the following additional methods and events to both jQuery and jqLite:
 *
 * ### Events
 * - `$destroy` - AngularJS intercepts all jqLite/jQuery's DOM destruction apis and fires this event
 *    on all DOM nodes being removed.  This can be used to clean up any 3rd party bindings to the DOM
 *    element before it is removed.
 *
 * ### Methods
 * - `controller(name)` - retrieves the controller of the current element or its parent. By default
 *   retrieves controller associated with the `ngController` directive. If `name` is provided as
 *   camelCase directive name, then the controller for this directive will be retrieved (e.g.
 *   `'ngModel'`).
 * - `injector()` - retrieves the injector of the current element or its parent.
 * - `scope()` - retrieves the {@link ng.$rootScope.Scope scope} of the current
 *   element or its parent. Requires {@link guide/production#disabling-debug-data Debug Data} to
 *   be enabled.
 * - `isolateScope()` - retrieves an isolate {@link ng.$rootScope.Scope scope} if one is attached directly to the
 *   current element. This getter should be used only on elements that contain a directive which starts a new isolate
 *   scope. Calling `scope()` on this element always returns the original non-isolate scope.
 *   Requires {@link guide/production#disabling-debug-data Debug Data} to be enabled.
 * - `inheritedData()` - same as `data()`, but walks up the DOM until a value is found or the top
 *   parent element is reached.
 *
 * @knownIssue You cannot spy on `angular.element` if you are using Jasmine version 1.x. See
 * https://github.com/angular/angular.js/issues/14251 for more information.
 *
 * @param {string|DOMElement} element HTML string or DOMElement to be wrapped into jQuery.
 * @returns {Object} jQuery object.
 */

JQLite.expando = 'ng339';

var jqCache = JQLite.cache = {},
    jqId = 1;

/*
 * !!! This is an undocumented "private" function !!!
 */
JQLite._data = function(node) {
  //jQuery always returns an object on cache miss
  return this.cache[node[this.expando]] || {};
};

function jqNextId() { return ++jqId; }


var DASH_LOWERCASE_REGEXP = /-([a-z])/g;
var MS_HACK_REGEXP = /^-ms-/;
var MOUSE_EVENT_MAP = { mouseleave: 'mouseout', mouseenter: 'mouseover' };
var jqLiteMinErr = minErr('jqLite');

/**
 * Converts kebab-case to camelCase.
 * There is also a special case for the ms prefix starting with a lowercase letter.
 * @param name Name to normalize
 */
function cssKebabToCamel(name) {
    return kebabToCamel(name.replace(MS_HACK_REGEXP, 'ms-'));
}

function fnCamelCaseReplace(all, letter) {
  return letter.toUpperCase();
}

/**
 * Converts kebab-case to camelCase.
 * @param name Name to normalize
 */
function kebabToCamel(name) {
  return name
    .replace(DASH_LOWERCASE_REGEXP, fnCamelCaseReplace);
}

var SINGLE_TAG_REGEXP = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/;
var HTML_REGEXP = /<|&#?\w+;/;
var TAG_NAME_REGEXP = /<([\w:-]+)/;
var XHTML_TAG_REGEXP = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi;

// Table parts need to be wrapped with `<table>` or they're
// stripped to their contents when put in a div.
// XHTML parsers do not magically insert elements in the
// same way that tag soup parsers do, so we cannot shorten
// this by omitting <tbody> or other required elements.
var wrapMap = {
  thead: ['table'],
  col: ['colgroup', 'table'],
  tr: ['tbody', 'table'],
  td: ['tr', 'tbody', 'table']
};

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

// Support: IE <10 only
// IE 9 requires an option wrapper & it needs to have the whole table structure
// set up in advance; assigning `"<td></td>"` to `tr.innerHTML` doesn't work, etc.
var wrapMapIE9 = {
  option: [1, '<select multiple="multiple">', '</select>'],
  _default: [0, '', '']
};

for (var key in wrapMap) {
  var wrapMapValueClosing = wrapMap[key];
  var wrapMapValue = wrapMapValueClosing.slice().reverse();
  wrapMapIE9[key] = [wrapMapValue.length, '<' + wrapMapValue.join('><') + '>', '</' + wrapMapValueClosing.join('></') + '>'];
}

wrapMapIE9.optgroup = wrapMapIE9.option;

function jqLiteIsTextNode(html) {
  return !HTML_REGEXP.test(html);
}

function jqLiteAcceptsData(node) {
  // The window object can accept data but has no nodeType
  // Otherwise we are only interested in elements (1) and documents (9)
  var nodeType = node.nodeType;
  return nodeType === NODE_TYPE_ELEMENT || !nodeType || nodeType === NODE_TYPE_DOCUMENT;
}

function jqLiteHasData(node) {
  for (var key in jqCache[node.ng339]) {
    return true;
  }
  return false;
}

function jqLiteBuildFragment(html, context) {
  var tmp, tag, wrap, finalHtml,
      fragment = context.createDocumentFragment(),
      nodes = [], i;

  if (jqLiteIsTextNode(html)) {
    // Convert non-html into a text node
    nodes.push(context.createTextNode(html));
  } else {
    // Convert html into DOM nodes
    tmp = fragment.appendChild(context.createElement('div'));
    tag = (TAG_NAME_REGEXP.exec(html) || ['', ''])[1].toLowerCase();
    finalHtml = JQLite.legacyXHTMLReplacement ?
      html.replace(XHTML_TAG_REGEXP, '<$1></$2>') :
      html;

    if (msie < 10) {
      wrap = wrapMapIE9[tag] || wrapMapIE9._default;
      tmp.innerHTML = wrap[1] + finalHtml + wrap[2];

      // Descend through wrappers to the right content
      i = wrap[0];
      while (i--) {
        tmp = tmp.firstChild;
      }
    } else {
      wrap = wrapMap[tag] || [];

      // Create wrappers & descend into them
      i = wrap.length;
      while (--i > -1) {
        tmp.appendChild(window.document.createElement(wrap[i]));
        tmp = tmp.firstChild;
      }

      tmp.innerHTML = finalHtml;
    }

    nodes = concat(nodes, tmp.childNodes);

    tmp = fragment.firstChild;
    tmp.textContent = '';
  }

  // Remove wrapper from fragment
  fragment.textContent = '';
  fragment.innerHTML = ''; // Clear inner HTML
  forEach(nodes, function(node) {
    fragment.appendChild(node);
  });

  return fragment;
}

function jqLiteParseHTML(html, context) {
  context = context || window.document;
  var parsed;

  if ((parsed = SINGLE_TAG_REGEXP.exec(html))) {
    return [context.createElement(parsed[1])];
  }

  if ((parsed = jqLiteBuildFragment(html, context))) {
    return parsed.childNodes;
  }

  return [];
}

function jqLiteWrapNode(node, wrapper) {
  var parent = node.parentNode;

  if (parent) {
    parent.replaceChild(wrapper, node);
  }

  wrapper.appendChild(node);
}


// IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
var jqLiteContains = window.Node.prototype.contains || /** @this */ function(arg) {
  // eslint-disable-next-line no-bitwise
  return !!(this.compareDocumentPosition(arg) & 16);
};

/////////////////////////////////////////////
function JQLite(element) {
  if (element instanceof JQLite) {
    return element;
  }

  var argIsString;

  if (isString(element)) {
    element = trim(element);
    argIsString = true;
  }
  if (!(this instanceof JQLite)) {
    if (argIsString && element.charAt(0) !== '<') {
      throw jqLiteMinErr('nosel', 'Looking up elements via selectors is not supported by jqLite! See: http://docs.angularjs.org/api/angular.element');
    }
    return new JQLite(element);
  }

  if (argIsString) {
    jqLiteAddNodes(this, jqLiteParseHTML(element));
  } else if (isFunction(element)) {
    jqLiteReady(element);
  } else {
    jqLiteAddNodes(this, element);
  }
}

function jqLiteClone(element) {
  return element.cloneNode(true);
}

function jqLiteDealoc(element, onlyDescendants) {
  if (!onlyDescendants && jqLiteAcceptsData(element)) jqLite.cleanData([element]);

  if (element.querySelectorAll) {
    jqLite.cleanData(element.querySelectorAll('*'));
  }
}

function isEmptyObject(obj) {
  var name;

  for (name in obj) {
    return false;
  }
  return true;
}

function removeIfEmptyData(element) {
  var expandoId = element.ng339;
  var expandoStore = expandoId && jqCache[expandoId];

  var events = expandoStore && expandoStore.events;
  var data = expandoStore && expandoStore.data;

  if ((!data || isEmptyObject(data)) && (!events || isEmptyObject(events))) {
    delete jqCache[expandoId];
    element.ng339 = undefined; // don't delete DOM expandos. IE and Chrome don't like it
  }
}

function jqLiteOff(element, type, fn, unsupported) {
  if (isDefined(unsupported)) throw jqLiteMinErr('offargs', 'jqLite#off() does not support the `selector` argument');

  var expandoStore = jqLiteExpandoStore(element);
  var events = expandoStore && expandoStore.events;
  var handle = expandoStore && expandoStore.handle;

  if (!handle) return; //no listeners registered

  if (!type) {
    for (type in events) {
      if (type !== '$destroy') {
        element.removeEventListener(type, handle);
      }
      delete events[type];
    }
  } else {

    var removeHandler = function(type) {
      var listenerFns = events[type];
      if (isDefined(fn)) {
        arrayRemove(listenerFns || [], fn);
      }
      if (!(isDefined(fn) && listenerFns && listenerFns.length > 0)) {
        element.removeEventListener(type, handle);
        delete events[type];
      }
    };

    forEach(type.split(' '), function(type) {
      removeHandler(type);
      if (MOUSE_EVENT_MAP[type]) {
        removeHandler(MOUSE_EVENT_MAP[type]);
      }
    });
  }

  removeIfEmptyData(element);
}

function jqLiteRemoveData(element, name) {
  var expandoId = element.ng339;
  var expandoStore = expandoId && jqCache[expandoId];

  if (expandoStore) {
    if (name) {
      delete expandoStore.data[name];
    } else {
      expandoStore.data = {};
    }

    removeIfEmptyData(element);
  }
}


function jqLiteExpandoStore(element, createIfNecessary) {
  var expandoId = element.ng339,
      expandoStore = expandoId && jqCache[expandoId];

  if (createIfNecessary && !expandoStore) {
    element.ng339 = expandoId = jqNextId();
    expandoStore = jqCache[expandoId] = {events: {}, data: {}, handle: undefined};
  }

  return expandoStore;
}


function jqLiteData(element, key, value) {
  if (jqLiteAcceptsData(element)) {
    var prop;

    var isSimpleSetter = isDefined(value);
    var isSimpleGetter = !isSimpleSetter && key && !isObject(key);
    var massGetter = !key;
    var expandoStore = jqLiteExpandoStore(element, !isSimpleGetter);
    var data = expandoStore && expandoStore.data;

    if (isSimpleSetter) { // data('key', value)
      data[kebabToCamel(key)] = value;
    } else {
      if (massGetter) {  // data()
        return data;
      } else {
        if (isSimpleGetter) { // data('key')
          // don't force creation of expandoStore if it doesn't exist yet
          return data && data[kebabToCamel(key)];
        } else { // mass-setter: data({key1: val1, key2: val2})
          for (prop in key) {
            data[kebabToCamel(prop)] = key[prop];
          }
        }
      }
    }
  }
}

function jqLiteHasClass(element, selector) {
  if (!element.getAttribute) return false;
  return ((' ' + (element.getAttribute('class') || '') + ' ').replace(/[\n\t]/g, ' ').
      indexOf(' ' + selector + ' ') > -1);
}

function jqLiteRemoveClass(element, cssClasses) {
  if (cssClasses && element.setAttribute) {
    var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ')
                            .replace(/[\n\t]/g, ' ');
    var newClasses = existingClasses;

    forEach(cssClasses.split(' '), function(cssClass) {
      cssClass = trim(cssClass);
      newClasses = newClasses.replace(' ' + cssClass + ' ', ' ');
    });

    if (newClasses !== existingClasses) {
      element.setAttribute('class', trim(newClasses));
    }
  }
}

function jqLiteAddClass(element, cssClasses) {
  if (cssClasses && element.setAttribute) {
    var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ')
                            .replace(/[\n\t]/g, ' ');
    var newClasses = existingClasses;

    forEach(cssClasses.split(' '), function(cssClass) {
      cssClass = trim(cssClass);
      if (newClasses.indexOf(' ' + cssClass + ' ') === -1) {
        newClasses += cssClass + ' ';
      }
    });

    if (newClasses !== existingClasses) {
      element.setAttribute('class', trim(newClasses));
    }
  }
}


function jqLiteAddNodes(root, elements) {
  // THIS CODE IS VERY HOT. Don't make changes without benchmarking.

  if (elements) {

    // if a Node (the most common case)
    if (elements.nodeType) {
      root[root.length++] = elements;
    } else {
      var length = elements.length;

      // if an Array or NodeList and not a Window
      if (typeof length === 'number' && elements.window !== elements) {
        if (length) {
          for (var i = 0; i < length; i++) {
            root[root.length++] = elements[i];
          }
        }
      } else {
        root[root.length++] = elements;
      }
    }
  }
}


function jqLiteController(element, name) {
  return jqLiteInheritedData(element, '$' + (name || 'ngController') + 'Controller');
}

function jqLiteInheritedData(element, name, value) {
  // if element is the document object work with the html element instead
  // this makes $(document).scope() possible
  if (element.nodeType === NODE_TYPE_DOCUMENT) {
    element = element.documentElement;
  }
  var names = isArray(name) ? name : [name];

  while (element) {
    for (var i = 0, ii = names.length; i < ii; i++) {
      if (isDefined(value = jqLite.data(element, names[i]))) return value;
    }

    // If dealing with a document fragment node with a host element, and no parent, use the host
    // element as the parent. This enables directives within a Shadow DOM or polyfilled Shadow DOM
    // to lookup parent controllers.
    element = element.parentNode || (element.nodeType === NODE_TYPE_DOCUMENT_FRAGMENT && element.host);
  }
}

function jqLiteEmpty(element) {
  jqLiteDealoc(element, true);
  while (element.firstChild) {
    element.removeChild(element.firstChild);
  }
}

function jqLiteRemove(element, keepData) {
  if (!keepData) jqLiteDealoc(element);
  var parent = element.parentNode;
  if (parent) parent.removeChild(element);
}


function jqLiteDocumentLoaded(action, win) {
  win = win || window;
  if (win.document.readyState === 'complete') {
    // Force the action to be run async for consistent behavior
    // from the action's point of view
    // i.e. it will definitely not be in a $apply
    win.setTimeout(action);
  } else {
    // No need to unbind this handler as load is only ever called once
    jqLite(win).on('load', action);
  }
}

function jqLiteReady(fn) {
  function trigger() {
    window.document.removeEventListener('DOMContentLoaded', trigger);
    window.removeEventListener('load', trigger);
    fn();
  }

  // check if document is already loaded
  if (window.document.readyState === 'complete') {
    window.setTimeout(fn);
  } else {
    // We can not use jqLite since we are not done loading and jQuery could be loaded later.

    // Works for modern browsers and IE9
    window.document.addEventListener('DOMContentLoaded', trigger);

    // Fallback to window.onload for others
    window.addEventListener('load', trigger);
  }
}

//////////////////////////////////////////
// Functions which are declared directly.
//////////////////////////////////////////
var JQLitePrototype = JQLite.prototype = {
  ready: jqLiteReady,
  toString: function() {
    var value = [];
    forEach(this, function(e) { value.push('' + e);});
    return '[' + value.join(', ') + ']';
  },

  eq: function(index) {
      return (index >= 0) ? jqLite(this[index]) : jqLite(this[this.length + index]);
  },

  length: 0,
  push: push,
  sort: [].sort,
  splice: [].splice
};

//////////////////////////////////////////
// Functions iterating getter/setters.
// these functions return self on setter and
// value on get.
//////////////////////////////////////////
var BOOLEAN_ATTR = {};
forEach('multiple,selected,checked,disabled,readOnly,required,open'.split(','), function(value) {
  BOOLEAN_ATTR[lowercase(value)] = value;
});
var BOOLEAN_ELEMENTS = {};
forEach('input,select,option,textarea,button,form,details'.split(','), function(value) {
  BOOLEAN_ELEMENTS[value] = true;
});
var ALIASED_ATTR = {
  'ngMinlength': 'minlength',
  'ngMaxlength': 'maxlength',
  'ngMin': 'min',
  'ngMax': 'max',
  'ngPattern': 'pattern',
  'ngStep': 'step'
};

function getBooleanAttrName(element, name) {
  // check dom last since we will most likely fail on name
  var booleanAttr = BOOLEAN_ATTR[name.toLowerCase()];

  // booleanAttr is here twice to minimize DOM access
  return booleanAttr && BOOLEAN_ELEMENTS[nodeName_(element)] && booleanAttr;
}

function getAliasedAttrName(name) {
  return ALIASED_ATTR[name];
}

forEach({
  data: jqLiteData,
  removeData: jqLiteRemoveData,
  hasData: jqLiteHasData,
  cleanData: function jqLiteCleanData(nodes) {
    for (var i = 0, ii = nodes.length; i < ii; i++) {
      jqLiteRemoveData(nodes[i]);
      jqLiteOff(nodes[i]);
    }
  }
}, function(fn, name) {
  JQLite[name] = fn;
});

forEach({
  data: jqLiteData,
  inheritedData: jqLiteInheritedData,

  scope: function(element) {
    // Can't use jqLiteData here directly so we stay compatible with jQuery!
    return jqLite.data(element, '$scope') || jqLiteInheritedData(element.parentNode || element, ['$isolateScope', '$scope']);
  },

  isolateScope: function(element) {
    // Can't use jqLiteData here directly so we stay compatible with jQuery!
    return jqLite.data(element, '$isolateScope') || jqLite.data(element, '$isolateScopeNoTemplate');
  },

  controller: jqLiteController,

  injector: function(element) {
    return jqLiteInheritedData(element, '$injector');
  },

  removeAttr: function(element, name) {
    element.removeAttribute(name);
  },

  hasClass: jqLiteHasClass,

  css: function(element, name, value) {
    name = cssKebabToCamel(name);

    if (isDefined(value)) {
      element.style[name] = value;
    } else {
      return element.style[name];
    }
  },

  attr: function(element, name, value) {
    var ret;
    var nodeType = element.nodeType;
    if (nodeType === NODE_TYPE_TEXT || nodeType === NODE_TYPE_ATTRIBUTE || nodeType === NODE_TYPE_COMMENT ||
      !element.getAttribute) {
      return;
    }

    var lowercasedName = lowercase(name);
    var isBooleanAttr = BOOLEAN_ATTR[lowercasedName];

    if (isDefined(value)) {
      // setter

      if (value === null || (value === false && isBooleanAttr)) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, isBooleanAttr ? lowercasedName : value);
      }
    } else {
      // getter

      ret = element.getAttribute(name);

      if (isBooleanAttr && ret !== null) {
        ret = lowercasedName;
      }
      // Normalize non-existing attributes to undefined (as jQuery).
      return ret === null ? undefined : ret;
    }
  },

  prop: function(element, name, value) {
    if (isDefined(value)) {
      element[name] = value;
    } else {
      return element[name];
    }
  },

  text: (function() {
    getText.$dv = '';
    return getText;

    function getText(element, value) {
      if (isUndefined(value)) {
        var nodeType = element.nodeType;
        return (nodeType === NODE_TYPE_ELEMENT || nodeType === NODE_TYPE_TEXT) ? element.textContent : '';
      }
      element.textContent = value;
    }
  })(),

  val: function(element, value) {
    if (isUndefined(value)) {
      if (element.multiple && nodeName_(element) === 'select') {
        var result = [];
        forEach(element.options, function(option) {
          if (option.selected) {
            result.push(option.value || option.text);
          }
        });
        return result;
      }
      return element.value;
    }
    element.value = value;
  },

  html: function(element, value) {
    if (isUndefined(value)) {
      return element.innerHTML;
    }
    jqLiteDealoc(element, true);
    element.innerHTML = value;
  },

  empty: jqLiteEmpty
}, function(fn, name) {
  /**
   * Properties: writes return selection, reads return first value
   */
  JQLite.prototype[name] = function(arg1, arg2) {
    var i, key;
    var nodeCount = this.length;

    // jqLiteHasClass has only two arguments, but is a getter-only fn, so we need to special-case it
    // in a way that survives minification.
    // jqLiteEmpty takes no arguments but is a setter.
    if (fn !== jqLiteEmpty &&
        (isUndefined((fn.length === 2 && (fn !== jqLiteHasClass && fn !== jqLiteController)) ? arg1 : arg2))) {
      if (isObject(arg1)) {

        // we are a write, but the object properties are the key/values
        for (i = 0; i < nodeCount; i++) {
          if (fn === jqLiteData) {
            // data() takes the whole object in jQuery
            fn(this[i], arg1);
          } else {
            for (key in arg1) {
              fn(this[i], key, arg1[key]);
            }
          }
        }
        // return self for chaining
        return this;
      } else {
        // we are a read, so read the first child.
        // TODO: do we still need this?
        var value = fn.$dv;
        // Only if we have $dv do we iterate over all, otherwise it is just the first element.
        var jj = (isUndefined(value)) ? Math.min(nodeCount, 1) : nodeCount;
        for (var j = 0; j < jj; j++) {
          var nodeValue = fn(this[j], arg1, arg2);
          value = value ? value + nodeValue : nodeValue;
        }
        return value;
      }
    } else {
      // we are a write, so apply to all children
      for (i = 0; i < nodeCount; i++) {
        fn(this[i], arg1, arg2);
      }
      // return self for chaining
      return this;
    }
  };
});

function createEventHandler(element, events) {
  var eventHandler = function(event, type) {
    // jQuery specific api
    event.isDefaultPrevented = function() {
      return event.defaultPrevented;
    };

    var eventFns = events[type || event.type];
    var eventFnsLength = eventFns ? eventFns.length : 0;

    if (!eventFnsLength) return;

    if (isUndefined(event.immediatePropagationStopped)) {
      var originalStopImmediatePropagation = event.stopImmediatePropagation;
      event.stopImmediatePropagation = function() {
        event.immediatePropagationStopped = true;

        if (event.stopPropagation) {
          event.stopPropagation();
        }

        if (originalStopImmediatePropagation) {
          originalStopImmediatePropagation.call(event);
        }
      };
    }

    event.isImmediatePropagationStopped = function() {
      return event.immediatePropagationStopped === true;
    };

    // Some events have special handlers that wrap the real handler
    var handlerWrapper = eventFns.specialHandlerWrapper || defaultHandlerWrapper;

    // Copy event handlers in case event handlers array is modified during execution.
    if ((eventFnsLength > 1)) {
      eventFns = shallowCopy(eventFns);
    }

    for (var i = 0; i < eventFnsLength; i++) {
      if (!event.isImmediatePropagationStopped()) {
        handlerWrapper(element, event, eventFns[i]);
      }
    }
  };

  // TODO: this is a hack for angularMocks/clearDataCache that makes it possible to deregister all
  //       events on `element`
  eventHandler.elem = element;
  return eventHandler;
}

function defaultHandlerWrapper(element, event, handler) {
  handler.call(element, event);
}

function specialMouseHandlerWrapper(target, event, handler) {
  // Refer to jQuery's implementation of mouseenter & mouseleave
  // Read about mouseenter and mouseleave:
  // http://www.quirksmode.org/js/events_mouse.html#link8
  var related = event.relatedTarget;
  // For mousenter/leave call the handler if related is outside the target.
  // NB: No relatedTarget if the mouse left/entered the browser window
  if (!related || (related !== target && !jqLiteContains.call(target, related))) {
    handler.call(target, event);
  }
}

//////////////////////////////////////////
// Functions iterating traversal.
// These functions chain results into a single
// selector.
//////////////////////////////////////////
forEach({
  removeData: jqLiteRemoveData,

  on: function jqLiteOn(element, type, fn, unsupported) {
    if (isDefined(unsupported)) throw jqLiteMinErr('onargs', 'jqLite#on() does not support the `selector` or `eventData` parameters');

    // Do not add event handlers to non-elements because they will not be cleaned up.
    if (!jqLiteAcceptsData(element)) {
      return;
    }

    var expandoStore = jqLiteExpandoStore(element, true);
    var events = expandoStore.events;
    var handle = expandoStore.handle;

    if (!handle) {
      handle = expandoStore.handle = createEventHandler(element, events);
    }

    // http://jsperf.com/string-indexof-vs-split
    var types = type.indexOf(' ') >= 0 ? type.split(' ') : [type];
    var i = types.length;

    var addHandler = function(type, specialHandlerWrapper, noEventListener) {
      var eventFns = events[type];

      if (!eventFns) {
        eventFns = events[type] = [];
        eventFns.specialHandlerWrapper = specialHandlerWrapper;
        if (type !== '$destroy' && !noEventListener) {
          element.addEventListener(type, handle);
        }
      }

      eventFns.push(fn);
    };

    while (i--) {
      type = types[i];
      if (MOUSE_EVENT_MAP[type]) {
        addHandler(MOUSE_EVENT_MAP[type], specialMouseHandlerWrapper);
        addHandler(type, undefined, true);
      } else {
        addHandler(type);
      }
    }
  },

  off: jqLiteOff,

  one: function(element, type, fn) {
    element = jqLite(element);

    //add the listener twice so that when it is called
    //you can remove the original function and still be
    //able to call element.off(ev, fn) normally
    element.on(type, function onFn() {
      element.off(type, fn);
      element.off(type, onFn);
    });
    element.on(type, fn);
  },

  replaceWith: function(element, replaceNode) {
    var index, parent = element.parentNode;
    jqLiteDealoc(element);
    forEach(new JQLite(replaceNode), function(node) {
      if (index) {
        parent.insertBefore(node, index.nextSibling);
      } else {
        parent.replaceChild(node, element);
      }
      index = node;
    });
  },

  children: function(element) {
    var children = [];
    forEach(element.childNodes, function(element) {
      if (element.nodeType === NODE_TYPE_ELEMENT) {
        children.push(element);
      }
    });
    return children;
  },

  contents: function(element) {
    return element.contentDocument || element.childNodes || [];
  },

  append: function(element, node) {
    var nodeType = element.nodeType;
    if (nodeType !== NODE_TYPE_ELEMENT && nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT) return;

    node = new JQLite(node);

    for (var i = 0, ii = node.length; i < ii; i++) {
      var child = node[i];
      element.appendChild(child);
    }
  },

  prepend: function(element, node) {
    if (element.nodeType === NODE_TYPE_ELEMENT) {
      var index = element.firstChild;
      forEach(new JQLite(node), function(child) {
        element.insertBefore(child, index);
      });
    }
  },

  wrap: function(element, wrapNode) {
    jqLiteWrapNode(element, jqLite(wrapNode).eq(0).clone()[0]);
  },

  remove: jqLiteRemove,

  detach: function(element) {
    jqLiteRemove(element, true);
  },

  after: function(element, newElement) {
    var index = element, parent = element.parentNode;

    if (parent) {
      newElement = new JQLite(newElement);

      for (var i = 0, ii = newElement.length; i < ii; i++) {
        var node = newElement[i];
        parent.insertBefore(node, index.nextSibling);
        index = node;
      }
    }
  },

  addClass: jqLiteAddClass,
  removeClass: jqLiteRemoveClass,

  toggleClass: function(element, selector, condition) {
    if (selector) {
      forEach(selector.split(' '), function(className) {
        var classCondition = condition;
        if (isUndefined(classCondition)) {
          classCondition = !jqLiteHasClass(element, className);
        }
        (classCondition ? jqLiteAddClass : jqLiteRemoveClass)(element, className);
      });
    }
  },

  parent: function(element) {
    var parent = element.parentNode;
    return parent && parent.nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT ? parent : null;
  },

  next: function(element) {
    return element.nextElementSibling;
  },

  find: function(element, selector) {
    if (element.getElementsByTagName) {
      return element.getElementsByTagName(selector);
    } else {
      return [];
    }
  },

  clone: jqLiteClone,

  triggerHandler: function(element, event, extraParameters) {

    var dummyEvent, eventFnsCopy, handlerArgs;
    var eventName = event.type || event;
    var expandoStore = jqLiteExpandoStore(element);
    var events = expandoStore && expandoStore.events;
    var eventFns = events && events[eventName];

    if (eventFns) {
      // Create a dummy event to pass to the handlers
      dummyEvent = {
        preventDefault: function() { this.defaultPrevented = true; },
        isDefaultPrevented: function() { return this.defaultPrevented === true; },
        stopImmediatePropagation: function() { this.immediatePropagationStopped = true; },
        isImmediatePropagationStopped: function() { return this.immediatePropagationStopped === true; },
        stopPropagation: noop,
        type: eventName,
        target: element
      };

      // If a custom event was provided then extend our dummy event with it
      if (event.type) {
        dummyEvent = extend(dummyEvent, event);
      }

      // Copy event handlers in case event handlers array is modified during execution.
      eventFnsCopy = shallowCopy(eventFns);
      handlerArgs = extraParameters ? [dummyEvent].concat(extraParameters) : [dummyEvent];

      forEach(eventFnsCopy, function(fn) {
        if (!dummyEvent.isImmediatePropagationStopped()) {
          fn.apply(element, handlerArgs);
        }
      });
    }
  }
}, function(fn, name) {
  /**
   * chaining functions
   */
  JQLite.prototype[name] = function(arg1, arg2, arg3) {
    var value;

    for (var i = 0, ii = this.length; i < ii; i++) {
      if (isUndefined(value)) {
        value = fn(this[i], arg1, arg2, arg3);
        if (isDefined(value)) {
          // any function which returns a value needs to be wrapped
          value = jqLite(value);
        }
      } else {
        jqLiteAddNodes(value, fn(this[i], arg1, arg2, arg3));
      }
    }
    return isDefined(value) ? value : this;
  };
});

// bind legacy bind/unbind to on/off
JQLite.prototype.bind = JQLite.prototype.on;
JQLite.prototype.unbind = JQLite.prototype.off;


// Provider for private $$jqLite service
/** @this */
function $$jqLiteProvider() {
  this.$get = function $$jqLite() {
    return extend(JQLite, {
      hasClass: function(node, classes) {
        if (node.attr) node = node[0];
        return jqLiteHasClass(node, classes);
      },
      addClass: function(node, classes) {
        if (node.attr) node = node[0];
        return jqLiteAddClass(node, classes);
      },
      removeClass: function(node, classes) {
        if (node.attr) node = node[0];
        return jqLiteRemoveClass(node, classes);
      }
    });
  };
}

/**
 * Computes a hash of an 'obj'.
 * Hash of a:
 *  string is string
 *  number is number as string
 *  object is either result of calling $$hashKey function on the object or uniquely generated id,
 *         that is also assigned to the $$hashKey property of the object.
 *
 * @param obj
 * @returns {string} hash string such that the same input will have the same hash string.
 *         The resulting string key is in 'type:hashKey' format.
 */
function hashKey(obj, nextUidFn) {
  var key = obj && obj.$$hashKey;

  if (key) {
    if (typeof key === 'function') {
      key = obj.$$hashKey();
    }
    return key;
  }

  var objType = typeof obj;
  if (objType === 'function' || (objType === 'object' && obj !== null)) {
    key = obj.$$hashKey = objType + ':' + (nextUidFn || nextUid)();
  } else {
    key = objType + ':' + obj;
  }

  return key;
}

// A minimal ES2015 Map implementation.
// Should be bug/feature equivalent to the native implementations of supported browsers
// (for the features required in Angular).
// See https://kangax.github.io/compat-table/es6/#test-Map
var nanKey = Object.create(null);
function NgMapShim() {
  this._keys = [];
  this._values = [];
  this._lastKey = NaN;
  this._lastIndex = -1;
}
NgMapShim.prototype = {
  _idx: function(key) {
    if (key !== this._lastKey) {
      this._lastKey = key;
      this._lastIndex = this._keys.indexOf(key);
    }
    return this._lastIndex;
  },
  _transformKey: function(key) {
    return isNumberNaN(key) ? nanKey : key;
  },
  get: function(key) {
    key = this._transformKey(key);
    var idx = this._idx(key);
    if (idx !== -1) {
      return this._values[idx];
    }
  },
  has: function(key) {
    key = this._transformKey(key);
    var idx = this._idx(key);
    return idx !== -1;
  },
  set: function(key, value) {
    key = this._transformKey(key);
    var idx = this._idx(key);
    if (idx === -1) {
      idx = this._lastIndex = this._keys.length;
    }
    this._keys[idx] = key;
    this._values[idx] = value;

    // Support: IE11
    // Do not `return this` to simulate the partial IE11 implementation
  },
  delete: function(key) {
    key = this._transformKey(key);
    var idx = this._idx(key);
    if (idx === -1) {
      return false;
    }
    this._keys.splice(idx, 1);
    this._values.splice(idx, 1);
    this._lastKey = NaN;
    this._lastIndex = -1;
    return true;
  }
};

// For now, always use `NgMapShim`, even if `window.Map` is available. Some native implementations
// are still buggy (often in subtle ways) and can cause hard-to-debug failures. When native `Map`
// implementations get more stable, we can reconsider switching to `window.Map` (when available).
var NgMap = NgMapShim;

var $$MapProvider = [/** @this */function() {
  this.$get = [function() {
    return NgMap;
  }];
}];

/**
 * @ngdoc function
 * @module ng
 * @name angular.injector
 * @kind function
 *
 * @description
 * Creates an injector object that can be used for retrieving services as well as for
 * dependency injection (see {@link guide/di dependency injection}).
 *
 * @param {Array.<string|Function>} modules A list of module functions or their aliases. See
 *     {@link angular.module}. The `ng` module must be explicitly added.
 * @param {boolean=} [strictDi=false] Whether the injector should be in strict mode, which
 *     disallows argument name annotation inference.
 * @returns {injector} Injector object. See {@link auto.$injector $injector}.
 *
 * @example
 * Typical usage
 * ```js
 *   // create an injector
 *   var $injector = angular.injector(['ng']);
 *
 *   // use the injector to kick off your application
 *   // use the type inference to auto inject arguments, or use implicit injection
 *   $injector.invoke(function($rootScope, $compile, $document) {
 *     $compile($document)($rootScope);
 *     $rootScope.$digest();
 *   });
 * ```
 *
 * Sometimes you want to get access to the injector of a currently running AngularJS app
 * from outside AngularJS. Perhaps, you want to inject and compile some markup after the
 * application has been bootstrapped. You can do this using the extra `injector()` added
 * to JQuery/jqLite elements. See {@link angular.element}.
 *
 * *This is fairly rare but could be the case if a third party library is injecting the
 * markup.*
 *
 * In the following example a new block of HTML containing a `ng-controller`
 * directive is added to the end of the document body by JQuery. We then compile and link
 * it into the current AngularJS scope.
 *
 * ```js
 * var $div = $('<div ng-controller="MyCtrl">{{content.label}}</div>');
 * $(document.body).append($div);
 *
 * angular.element(document).injector().invoke(function($compile) {
 *   var scope = angular.element($div).scope();
 *   $compile($div)(scope);
 * });
 * ```
 */


/**
 * @ngdoc module
 * @name auto
 * @installation
 * @description
 *
 * Implicit module which gets automatically added to each {@link auto.$injector $injector}.
 */

var ARROW_ARG = /^([^(]+?)=>/;
var FN_ARGS = /^[^(]*\(\s*([^)]*)\)/m;
var FN_ARG_SPLIT = /,/;
var FN_ARG = /^\s*(_?)(\S+?)\1\s*$/;
var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
var $injectorMinErr = minErr('$injector');

function stringifyFn(fn) {
  return Function.prototype.toString.call(fn);
}

function extractArgs(fn) {
  var fnText = stringifyFn(fn).replace(STRIP_COMMENTS, ''),
      args = fnText.match(ARROW_ARG) || fnText.match(FN_ARGS);
  return args;
}

function anonFn(fn) {
  // For anonymous functions, showing at the very least the function signature can help in
  // debugging.
  var args = extractArgs(fn);
  if (args) {
    return 'function(' + (args[1] || '').replace(/[\s\r\n]+/, ' ') + ')';
  }
  return 'fn';
}

function annotate(fn, strictDi, name) {
  var $inject,
      argDecl,
      last;

  if (typeof fn === 'function') {
    if (!($inject = fn.$inject)) {
      $inject = [];
      if (fn.length) {
        if (strictDi) {
          if (!isString(name) || !name) {
            name = fn.name || anonFn(fn);
          }
          throw $injectorMinErr('strictdi',
            '{0} is not using explicit annotation and cannot be invoked in strict mode', name);
        }
        argDecl = extractArgs(fn);
        forEach(argDecl[1].split(FN_ARG_SPLIT), function(arg) {
          arg.replace(FN_ARG, function(all, underscore, name) {
            $inject.push(name);
          });
        });
      }
      fn.$inject = $inject;
    }
  } else if (isArray(fn)) {
    last = fn.length - 1;
    assertArgFn(fn[last], 'fn');
    $inject = fn.slice(0, last);
  } else {
    assertArgFn(fn, 'fn', true);
  }
  return $inject;
}

///////////////////////////////////////

/**
 * @ngdoc service
 * @name $injector
 *
 * @description
 *
 * `$injector` is used to retrieve object instances as defined by
 * {@link auto.$provide provider}, instantiate types, invoke methods,
 * and load modules.
 *
 * The following always holds true:
 *
 * ```js
 *   var $injector = angular.injector();
 *   expect($injector.get('$injector')).toBe($injector);
 *   expect($injector.invoke(function($injector) {
 *     return $injector;
 *   })).toBe($injector);
 * ```
 *
 * ## Injection Function Annotation
 *
 * JavaScript does not have annotations, and annotations are needed for dependency injection. The
 * following are all valid ways of annotating function with injection arguments and are equivalent.
 *
 * ```js
 *   // inferred (only works if code not minified/obfuscated)
 *   $injector.invoke(function(serviceA){});
 *
 *   // annotated
 *   function explicit(serviceA) {};
 *   explicit.$inject = ['serviceA'];
 *   $injector.invoke(explicit);
 *
 *   // inline
 *   $injector.invoke(['serviceA', function(serviceA){}]);
 * ```
 *
 * ### Inference
 *
 * In JavaScript calling `toString()` on a function returns the function definition. The definition
 * can then be parsed and the function arguments can be extracted. This method of discovering
 * annotations is disallowed when the injector is in strict mode.
 * *NOTE:* This does not work with minification, and obfuscation tools since these tools change the
 * argument names.
 *
 * ### `$inject` Annotation
 * By adding an `$inject` property onto a function the injection parameters can be specified.
 *
 * ### Inline
 * As an array of injection names, where the last item in the array is the function to call.
 */

/**
 * @ngdoc property
 * @name $injector#modules
 * @type {Object}
 * @description
 * A hash containing all the modules that have been loaded into the
 * $injector.
 *
 * You can use this property to find out information about a module via the
 * {@link angular.Module#info `myModule.info(...)`} method.
 *
 * For example:
 *
 * ```
 * var info = $injector.modules['ngAnimate'].info();
 * ```
 *
 * **Do not use this property to attempt to modify the modules after the application
 * has been bootstrapped.**
 */


/**
 * @ngdoc method
 * @name $injector#get
 *
 * @description
 * Return an instance of the service.
 *
 * @param {string} name The name of the instance to retrieve.
 * @param {string=} caller An optional string to provide the origin of the function call for error messages.
 * @return {*} The instance.
 */

/**
 * @ngdoc method
 * @name $injector#invoke
 *
 * @description
 * Invoke the method and supply the method arguments from the `$injector`.
 *
 * @param {Function|Array.<string|Function>} fn The injectable function to invoke. Function parameters are
 *   injected according to the {@link guide/di $inject Annotation} rules.
 * @param {Object=} self The `this` for the invoked method.
 * @param {Object=} locals Optional object. If preset then any argument names are read from this
 *                         object first, before the `$injector` is consulted.
 * @returns {*} the value returned by the invoked `fn` function.
 */

/**
 * @ngdoc method
 * @name $injector#has
 *
 * @description
 * Allows the user to query if the particular service exists.
 *
 * @param {string} name Name of the service to query.
 * @returns {boolean} `true` if injector has given service.
 */

/**
 * @ngdoc method
 * @name $injector#instantiate
 * @description
 * Create a new instance of JS type. The method takes a constructor function, invokes the new
 * operator, and supplies all of the arguments to the constructor function as specified by the
 * constructor annotation.
 *
 * @param {Function} Type Annotated constructor function.
 * @param {Object=} locals Optional object. If preset then any argument names are read from this
 * object first, before the `$injector` is consulted.
 * @returns {Object} new instance of `Type`.
 */

/**
 * @ngdoc method
 * @name $injector#annotate
 *
 * @description
 * Returns an array of service names which the function is requesting for injection. This API is
 * used by the injector to determine which services need to be injected into the function when the
 * function is invoked. There are three ways in which the function can be annotated with the needed
 * dependencies.
 *
 * #### Argument names
 *
 * The simplest form is to extract the dependencies from the arguments of the function. This is done
 * by converting the function into a string using `toString()` method and extracting the argument
 * names.
 * ```js
 *   // Given
 *   function MyController($scope, $route) {
 *     // ...
 *   }
 *
 *   // Then
 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
 * ```
 *
 * You can disallow this method by using strict injection mode.
 *
 * This method does not work with code minification / obfuscation. For this reason the following
 * annotation strategies are supported.
 *
 * #### The `$inject` property
 *
 * If a function has an `$inject` property and its value is an array of strings, then the strings
 * represent names of services to be injected into the function.
 * ```js
 *   // Given
 *   var MyController = function(obfuscatedScope, obfuscatedRoute) {
 *     // ...
 *   }
 *   // Define function dependencies
 *   MyController['$inject'] = ['$scope', '$route'];
 *
 *   // Then
 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
 * ```
 *
 * #### The array notation
 *
 * It is often desirable to inline Injected functions and that's when setting the `$inject` property
 * is very inconvenient. In these situations using the array notation to specify the dependencies in
 * a way that survives minification is a better choice:
 *
 * ```js
 *   // We wish to write this (not minification / obfuscation safe)
 *   injector.invoke(function($compile, $rootScope) {
 *     // ...
 *   });
 *
 *   // We are forced to write break inlining
 *   var tmpFn = function(obfuscatedCompile, obfuscatedRootScope) {
 *     // ...
 *   };
 *   tmpFn.$inject = ['$compile', '$rootScope'];
 *   injector.invoke(tmpFn);
 *
 *   // To better support inline function the inline annotation is supported
 *   injector.invoke(['$compile', '$rootScope', function(obfCompile, obfRootScope) {
 *     // ...
 *   }]);
 *
 *   // Therefore
 *   expect(injector.annotate(
 *      ['$compile', '$rootScope', function(obfus_$compile, obfus_$rootScope) {}])
 *    ).toEqual(['$compile', '$rootScope']);
 * ```
 *
 * @param {Function|Array.<string|Function>} fn Function for which dependent service names need to
 * be retrieved as described above.
 *
 * @param {boolean=} [strictDi=false] Disallow argument name annotation inference.
 *
 * @returns {Array.<string>} The names of the services which the function requires.
 */
/**
 * @ngdoc method
 * @name $injector#loadNewModules
 *
 * @description
 *
 * **This is a dangerous API, which you use at your own risk!**
 *
 * Add the specified modules to the current injector.
 *
 * This method will add each of the injectables to the injector and execute all of the config and run
 * blocks for each module passed to the method.
 *
 * If a module has already been loaded into the injector then it will not be loaded again.
 *
 * * The application developer is responsible for loading the code containing the modules; and for
 * ensuring that lazy scripts are not downloaded and executed more often that desired.
 * * Previously compiled HTML will not be affected by newly loaded directives, filters and components.
 * * Modules cannot be unloaded.
 *
 * You can use {@link $injector#modules `$injector.modules`} to check whether a module has been loaded
 * into the injector, which may indicate whether the script has been executed already.
 *
 * @example
 * Here is an example of loading a bundle of modules, with a utility method called `getScript`:
 *
 * ```javascript
 * app.factory('loadModule', function($injector) {
 *   return function loadModule(moduleName, bundleUrl) {
 *     return getScript(bundleUrl).then(function() { $injector.loadNewModules([moduleName]); });
 *   };
 * })
 * ```
 *
 * @param {Array<String|Function|Array>=} mods an array of modules to load into the application.
 *     Each item in the array should be the name of a predefined module or a (DI annotated)
 *     function that will be invoked by the injector as a `config` block.
 *     See: {@link angular.module modules}
 */


/**
 * @ngdoc service
 * @name $provide
 *
 * @description
 *
 * The {@link auto.$provide $provide} service has a number of methods for registering components
 * with the {@link auto.$injector $injector}. Many of these functions are also exposed on
 * {@link angular.Module}.
 *
 * An AngularJS **service** is a singleton object created by a **service factory**.  These **service
 * factories** are functions which, in turn, are created by a **service provider**.
 * The **service providers** are constructor functions. When instantiated they must contain a
 * property called `$get`, which holds the **service factory** function.
 *
 * When you request a service, the {@link auto.$injector $injector} is responsible for finding the
 * correct **service provider**, instantiating it and then calling its `$get` **service factory**
 * function to get the instance of the **service**.
 *
 * Often services have no configuration options and there is no need to add methods to the service
 * provider.  The provider will be no more than a constructor function with a `$get` property. For
 * these cases the {@link auto.$provide $provide} service has additional helper methods to register
 * services without specifying a provider.
 *
 * * {@link auto.$provide#provider provider(name, provider)} - registers a **service provider** with the
 *     {@link auto.$injector $injector}
 * * {@link auto.$provide#constant constant(name, obj)} - registers a value/object that can be accessed by
 *     providers and services.
 * * {@link auto.$provide#value value(name, obj)} - registers a value/object that can only be accessed by
 *     services, not providers.
 * * {@link auto.$provide#factory factory(name, fn)} - registers a service **factory function**
 *     that will be wrapped in a **service provider** object, whose `$get` property will contain the
 *     given factory function.
 * * {@link auto.$provide#service service(name, Fn)} - registers a **constructor function**
 *     that will be wrapped in a **service provider** object, whose `$get` property will instantiate
 *      a new object using the given constructor function.
 * * {@link auto.$provide#decorator decorator(name, decorFn)} - registers a **decorator function** that
 *      will be able to modify or replace the implementation of another service.
 *
 * See the individual methods for more information and examples.
 */

/**
 * @ngdoc method
 * @name $provide#provider
 * @description
 *
 * Register a **provider function** with the {@link auto.$injector $injector}. Provider functions
 * are constructor functions, whose instances are responsible for "providing" a factory for a
 * service.
 *
 * Service provider names start with the name of the service they provide followed by `Provider`.
 * For example, the {@link ng.$log $log} service has a provider called
 * {@link ng.$logProvider $logProvider}.
 *
 * Service provider objects can have additional methods which allow configuration of the provider
 * and its service. Importantly, you can configure what kind of service is created by the `$get`
 * method, or how that service will act. For example, the {@link ng.$logProvider $logProvider} has a
 * method {@link ng.$logProvider#debugEnabled debugEnabled}
 * which lets you specify whether the {@link ng.$log $log} service will log debug messages to the
 * console or not.
 *
 * It is possible to inject other providers into the provider function,
 * but the injected provider must have been defined before the one that requires it.
 *
 * @param {string} name The name of the instance. NOTE: the provider will be available under `name +
                        'Provider'` key.
 * @param {(Object|function())} provider If the provider is:
 *
 *   - `Object`: then it should have a `$get` method. The `$get` method will be invoked using
 *     {@link auto.$injector#invoke $injector.invoke()} when an instance needs to be created.
 *   - `Constructor`: a new instance of the provider will be created using
 *     {@link auto.$injector#instantiate $injector.instantiate()}, then treated as `object`.
 *
 * @returns {Object} registered provider instance

 * @example
 *
 * The following example shows how to create a simple event tracking service and register it using
 * {@link auto.$provide#provider $provide.provider()}.
 *
 * ```js
 *  // Define the eventTracker provider
 *  function EventTrackerProvider() {
 *    var trackingUrl = '/track';
 *
 *    // A provider method for configuring where the tracked events should been saved
 *    this.setTrackingUrl = function(url) {
 *      trackingUrl = url;
 *    };
 *
 *    // The service factory function
 *    this.$get = ['$http', function($http) {
 *      var trackedEvents = {};
 *      return {
 *        // Call this to track an event
 *        event: function(event) {
 *          var count = trackedEvents[event] || 0;
 *          count += 1;
 *          trackedEvents[event] = count;
 *          return count;
 *        },
 *        // Call this to save the tracked events to the trackingUrl
 *        save: function() {
 *          $http.post(trackingUrl, trackedEvents);
 *        }
 *      };
 *    }];
 *  }
 *
 *  describe('eventTracker', function() {
 *    var postSpy;
 *
 *    beforeEach(module(function($provide) {
 *      // Register the eventTracker provider
 *      $provide.provider('eventTracker', EventTrackerProvider);
 *    }));
 *
 *    beforeEach(module(function(eventTrackerProvider) {
 *      // Configure eventTracker provider
 *      eventTrackerProvider.setTrackingUrl('/custom-track');
 *    }));
 *
 *    it('tracks events', inject(function(eventTracker) {
 *      expect(eventTracker.event('login')).toEqual(1);
 *      expect(eventTracker.event('login')).toEqual(2);
 *    }));
 *
 *    it('saves to the tracking url', inject(function(eventTracker, $http) {
 *      postSpy = spyOn($http, 'post');
 *      eventTracker.event('login');
 *      eventTracker.save();
 *      expect(postSpy).toHaveBeenCalled();
 *      expect(postSpy.mostRecentCall.args[0]).not.toEqual('/track');
 *      expect(postSpy.mostRecentCall.args[0]).toEqual('/custom-track');
 *      expect(postSpy.mostRecentCall.args[1]).toEqual({ 'login': 1 });
 *    }));
 *  });
 * ```
 */

/**
 * @ngdoc method
 * @name $provide#factory
 * @description
 *
 * Register a **service factory**, which will be called to return the service instance.
 * This is short for registering a service where its provider consists of only a `$get` property,
 * which is the given service factory function.
 * You should use {@link auto.$provide#factory $provide.factory(getFn)} if you do not need to
 * configure your service in a provider.
 *
 * @param {string} name The name of the instance.
 * @param {Function|Array.<string|Function>} $getFn The injectable $getFn for the instance creation.
 *                      Internally this is a short hand for `$provide.provider(name, {$get: $getFn})`.
 * @returns {Object} registered provider instance
 *
 * @example
 * Here is an example of registering a service
 * ```js
 *   $provide.factory('ping', ['$http', function($http) {
 *     return function ping() {
 *       return $http.send('/ping');
 *     };
 *   }]);
 * ```
 * You would then inject and use this service like this:
 * ```js
 *   someModule.controller('Ctrl', ['ping', function(ping) {
 *     ping();
 *   }]);
 * ```
 */


/**
 * @ngdoc method
 * @name $provide#service
 * @description
 *
 * Register a **service constructor**, which will be invoked with `new` to create the service
 * instance.
 * This is short for registering a service where its provider's `$get` property is a factory
 * function that returns an instance instantiated by the injector from the service constructor
 * function.
 *
 * Internally it looks a bit like this:
 *
 * ```
 * {
 *   $get: function() {
 *     return $injector.instantiate(constructor);
 *   }
 * }
 * ```
 *
 *
 * You should use {@link auto.$provide#service $provide.service(class)} if you define your service
 * as a type/class.
 *
 * @param {string} name The name of the instance.
 * @param {Function|Array.<string|Function>} constructor An injectable class (constructor function)
 *     that will be instantiated.
 * @returns {Object} registered provider instance
 *
 * @example
 * Here is an example of registering a service using
 * {@link auto.$provide#service $provide.service(class)}.
 * ```js
 *   var Ping = function($http) {
 *     this.$http = $http;
 *   };
 *
 *   Ping.$inject = ['$http'];
 *
 *   Ping.prototype.send = function() {
 *     return this.$http.get('/ping');
 *   };
 *   $provide.service('ping', Ping);
 * ```
 * You would then inject and use this service like this:
 * ```js
 *   someModule.controller('Ctrl', ['ping', function(ping) {
 *     ping.send();
 *   }]);
 * ```
 */


/**
 * @ngdoc method
 * @name $provide#value
 * @description
 *
 * Register a **value service** with the {@link auto.$injector $injector}, such as a string, a
 * number, an array, an object or a function. This is short for registering a service where its
 * provider's `$get` property is a factory function that takes no arguments and returns the **value
 * service**. That also means it is not possible to inject other services into a value service.
 *
 * Value services are similar to constant services, except that they cannot be injected into a
 * module configuration function (see {@link angular.Module#config}) but they can be overridden by
 * an AngularJS {@link auto.$provide#decorator decorator}.
 *
 * @param {string} name The name of the instance.
 * @param {*} value The value.
 * @returns {Object} registered provider instance
 *
 * @example
 * Here are some examples of creating value services.
 * ```js
 *   $provide.value('ADMIN_USER', 'admin');
 *
 *   $provide.value('RoleLookup', { admin: 0, writer: 1, reader: 2 });
 *
 *   $provide.value('halfOf', function(value) {
 *     return value / 2;
 *   });
 * ```
 */


/**
 * @ngdoc method
 * @name $provide#constant
 * @description
 *
 * Register a **constant service** with the {@link auto.$injector $injector}, such as a string,
 * a number, an array, an object or a function. Like the {@link auto.$provide#value value}, it is not
 * possible to inject other services into a constant.
 *
 * But unlike {@link auto.$provide#value value}, a constant can be
 * injected into a module configuration function (see {@link angular.Module#config}) and it cannot
 * be overridden by an AngularJS {@link auto.$provide#decorator decorator}.
 *
 * @param {string} name The name of the constant.
 * @param {*} value The constant value.
 * @returns {Object} registered instance
 *
 * @example
 * Here a some examples of creating constants:
 * ```js
 *   $provide.constant('SHARD_HEIGHT', 306);
 *
 *   $provide.constant('MY_COLOURS', ['red', 'blue', 'grey']);
 *
 *   $provide.constant('double', function(value) {
 *     return value * 2;
 *   });
 * ```
 */


/**
 * @ngdoc method
 * @name $provide#decorator
 * @description
 *
 * Register a **decorator function** with the {@link auto.$injector $injector}. A decorator function
 * intercepts the creation of a service, allowing it to override or modify the behavior of the
 * service. The return value of the decorator function may be the original service, or a new service
 * that replaces (or wraps and delegates to) the original service.
 *
 * You can find out more about using decorators in the {@link guide/decorators} guide.
 *
 * @param {string} name The name of the service to decorate.
 * @param {Function|Array.<string|Function>} decorator This function will be invoked when the service needs to be
 *    provided and should return the decorated service instance. The function is called using
 *    the {@link auto.$injector#invoke injector.invoke} method and is therefore fully injectable.
 *    Local injection arguments:
 *
 *    * `$delegate` - The original service instance, which can be replaced, monkey patched, configured,
 *      decorated or delegated to.
 *
 * @example
 * Here we decorate the {@link ng.$log $log} service to convert warnings to errors by intercepting
 * calls to {@link ng.$log#error $log.warn()}.
 * ```js
 *   $provide.decorator('$log', ['$delegate', function($delegate) {
 *     $delegate.warn = $delegate.error;
 *     return $delegate;
 *   }]);
 * ```
 */


function createInjector(modulesToLoad, strictDi) {
  strictDi = (strictDi === true);
  var INSTANTIATING = {},
      providerSuffix = 'Provider',
      path = [],
      loadedModules = new NgMap(),
      providerCache = {
        $provide: {
            provider: supportObject(provider),
            factory: supportObject(factory),
            service: supportObject(service),
            value: supportObject(value),
            constant: supportObject(constant),
            decorator: decorator
          }
      },
      providerInjector = (providerCache.$injector =
          createInternalInjector(providerCache, function(serviceName, caller) {
            if (angular.isString(caller)) {
              path.push(caller);
            }
            throw $injectorMinErr('unpr', 'Unknown provider: {0}', path.join(' <- '));
          })),
      instanceCache = {},
      protoInstanceInjector =
          createInternalInjector(instanceCache, function(serviceName, caller) {
            var provider = providerInjector.get(serviceName + providerSuffix, caller);
            return instanceInjector.invoke(
                provider.$get, provider, undefined, serviceName);
          }),
      instanceInjector = protoInstanceInjector;

  providerCache['$injector' + providerSuffix] = { $get: valueFn(protoInstanceInjector) };
  instanceInjector.modules = providerInjector.modules = createMap();
  var runBlocks = loadModules(modulesToLoad);
  instanceInjector = protoInstanceInjector.get('$injector');
  instanceInjector.strictDi = strictDi;
  forEach(runBlocks, function(fn) { if (fn) instanceInjector.invoke(fn); });

  instanceInjector.loadNewModules = function(mods) {
    forEach(loadModules(mods), function(fn) { if (fn) instanceInjector.invoke(fn); });
  };


  return instanceInjector;

  ////////////////////////////////////
  // $provider
  ////////////////////////////////////

  function supportObject(delegate) {
    return function(key, value) {
      if (isObject(key)) {
        forEach(key, reverseParams(delegate));
      } else {
        return delegate(key, value);
      }
    };
  }

  function provider(name, provider_) {
    assertNotHasOwnProperty(name, 'service');
    if (isFunction(provider_) || isArray(provider_)) {
      provider_ = providerInjector.instantiate(provider_);
    }
    if (!provider_.$get) {
      throw $injectorMinErr('pget', 'Provider \'{0}\' must define $get factory method.', name);
    }
    return (providerCache[name + providerSuffix] = provider_);
  }

  function enforceReturnValue(name, factory) {
    return /** @this */ function enforcedReturnValue() {
      var result = instanceInjector.invoke(factory, this);
      if (isUndefined(result)) {
        throw $injectorMinErr('undef', 'Provider \'{0}\' must return a value from $get factory method.', name);
      }
      return result;
    };
  }

  function factory(name, factoryFn, enforce) {
    return provider(name, {
      $get: enforce !== false ? enforceReturnValue(name, factoryFn) : factoryFn
    });
  }

  function service(name, constructor) {
    return factory(name, ['$injector', function($injector) {
      return $injector.instantiate(constructor);
    }]);
  }

  function value(name, val) { return factory(name, valueFn(val), false); }

  function constant(name, value) {
    assertNotHasOwnProperty(name, 'constant');
    providerCache[name] = value;
    instanceCache[name] = value;
  }

  function decorator(serviceName, decorFn) {
    var origProvider = providerInjector.get(serviceName + providerSuffix),
        orig$get = origProvider.$get;

    origProvider.$get = function() {
      var origInstance = instanceInjector.invoke(orig$get, origProvider);
      return instanceInjector.invoke(decorFn, null, {$delegate: origInstance});
    };
  }

  ////////////////////////////////////
  // Module Loading
  ////////////////////////////////////
  function loadModules(modulesToLoad) {
    assertArg(isUndefined(modulesToLoad) || isArray(modulesToLoad), 'modulesToLoad', 'not an array');
    var runBlocks = [], moduleFn;
    forEach(modulesToLoad, function(module) {
      if (loadedModules.get(module)) return;
      loadedModules.set(module, true);

      function runInvokeQueue(queue) {
        var i, ii;
        for (i = 0, ii = queue.length; i < ii; i++) {
          var invokeArgs = queue[i],
              provider = providerInjector.get(invokeArgs[0]);

          provider[invokeArgs[1]].apply(provider, invokeArgs[2]);
        }
      }

      try {
        if (isString(module)) {
          moduleFn = angularModule(module);
          instanceInjector.modules[module] = moduleFn;
          runBlocks = runBlocks.concat(loadModules(moduleFn.requires)).concat(moduleFn._runBlocks);
          runInvokeQueue(moduleFn._invokeQueue);
          runInvokeQueue(moduleFn._configBlocks);
        } else if (isFunction(module)) {
            runBlocks.push(providerInjector.invoke(module));
        } else if (isArray(module)) {
            runBlocks.push(providerInjector.invoke(module));
        } else {
          assertArgFn(module, 'module');
        }
      } catch (e) {
        if (isArray(module)) {
          module = module[module.length - 1];
        }
        if (e.message && e.stack && e.stack.indexOf(e.message) === -1) {
          // Safari & FF's stack traces don't contain error.message content
          // unlike those of Chrome and IE
          // So if stack doesn't contain message, we create a new string that contains both.
          // Since error.stack is read-only in Safari, I'm overriding e and not e.stack here.
          // eslint-disable-next-line no-ex-assign
          e = e.message + '\n' + e.stack;
        }
        throw $injectorMinErr('modulerr', 'Failed to instantiate module {0} due to:\n{1}',
                  module, e.stack || e.message || e);
      }
    });
    return runBlocks;
  }

  ////////////////////////////////////
  // internal Injector
  ////////////////////////////////////

  function createInternalInjector(cache, factory) {

    function getService(serviceName, caller) {
      if (cache.hasOwnProperty(serviceName)) {
        if (cache[serviceName] === INSTANTIATING) {
          throw $injectorMinErr('cdep', 'Circular dependency found: {0}',
                    serviceName + ' <- ' + path.join(' <- '));
        }
        return cache[serviceName];
      } else {
        try {
          path.unshift(serviceName);
          cache[serviceName] = INSTANTIATING;
          cache[serviceName] = factory(serviceName, caller);
          return cache[serviceName];
        } catch (err) {
          if (cache[serviceName] === INSTANTIATING) {
            delete cache[serviceName];
          }
          throw err;
        } finally {
          path.shift();
        }
      }
    }


    function injectionArgs(fn, locals, serviceName) {
      var args = [],
          $inject = createInjector.$$annotate(fn, strictDi, serviceName);

      for (var i = 0, length = $inject.length; i < length; i++) {
        var key = $inject[i];
        if (typeof key !== 'string') {
          throw $injectorMinErr('itkn',
                  'Incorrect injection token! Expected service name as string, got {0}', key);
        }
        args.push(locals && locals.hasOwnProperty(key) ? locals[key] :
                                                         getService(key, serviceName));
      }
      return args;
    }

    function isClass(func) {
      // Support: IE 9-11 only
      // IE 9-11 do not support classes and IE9 leaks with the code below.
      if (msie || typeof func !== 'function') {
        return false;
      }
      var result = func.$$ngIsClass;
      if (!isBoolean(result)) {
        result = func.$$ngIsClass = /^class\b/.test(stringifyFn(func));
      }
      return result;
    }

    function invoke(fn, self, locals, serviceName) {
      if (typeof locals === 'string') {
        serviceName = locals;
        locals = null;
      }

      var args = injectionArgs(fn, locals, serviceName);
      if (isArray(fn)) {
        fn = fn[fn.length - 1];
      }

      if (!isClass(fn)) {
        // http://jsperf.com/angularjs-invoke-apply-vs-switch
        // #5388
        return fn.apply(self, args);
      } else {
        args.unshift(null);
        return new (Function.prototype.bind.apply(fn, args))();
      }
    }


    function instantiate(Type, locals, serviceName) {
      // Check if Type is annotated and use just the given function at n-1 as parameter
      // e.g. someModule.factory('greeter', ['$window', function(renamed$window) {}]);
      var ctor = (isArray(Type) ? Type[Type.length - 1] : Type);
      var args = injectionArgs(Type, locals, serviceName);
      // Empty object at position 0 is ignored for invocation with `new`, but required.
      args.unshift(null);
      return new (Function.prototype.bind.apply(ctor, args))();
    }


    return {
      invoke: invoke,
      instantiate: instantiate,
      get: getService,
      annotate: createInjector.$$annotate,
      has: function(name) {
        return providerCache.hasOwnProperty(name + providerSuffix) || cache.hasOwnProperty(name);
      }
    };
  }
}

createInjector.$$annotate = annotate;

/**
 * @ngdoc provider
 * @name $anchorScrollProvider
 * @this
 *
 * @description
 * Use `$anchorScrollProvider` to disable automatic scrolling whenever
 * {@link ng.$location#hash $location.hash()} changes.
 */
function $AnchorScrollProvider() {

  var autoScrollingEnabled = true;

  /**
   * @ngdoc method
   * @name $anchorScrollProvider#disableAutoScrolling
   *
   * @description
   * By default, {@link ng.$anchorScroll $anchorScroll()} will automatically detect changes to
   * {@link ng.$location#hash $location.hash()} and scroll to the element matching the new hash.<br />
   * Use this method to disable automatic scrolling.
   *
   * If automatic scrolling is disabled, one must explicitly call
   * {@link ng.$anchorScroll $anchorScroll()} in order to scroll to the element related to the
   * current hash.
   */
  this.disableAutoScrolling = function() {
    autoScrollingEnabled = false;
  };

  /**
   * @ngdoc service
   * @name $anchorScroll
   * @kind function
   * @requires $window
   * @requires $location
   * @requires $rootScope
   *
   * @description
   * When called, it scrolls to the element related to the specified `hash` or (if omitted) to the
   * current value of {@link ng.$location#hash $location.hash()}, according to the rules specified
   * in the
   * [HTML5 spec](http://www.w3.org/html/wg/drafts/html/master/browsers.html#an-indicated-part-of-the-document).
   *
   * It also watches the {@link ng.$location#hash $location.hash()} and automatically scrolls to
   * match any anchor whenever it changes. This can be disabled by calling
   * {@link ng.$anchorScrollProvider#disableAutoScrolling $anchorScrollProvider.disableAutoScrolling()}.
   *
   * Additionally, you can use its {@link ng.$anchorScroll#yOffset yOffset} property to specify a
   * vertical scroll-offset (either fixed or dynamic).
   *
   * @param {string=} hash The hash specifying the element to scroll to. If omitted, the value of
   *                       {@link ng.$location#hash $location.hash()} will be used.
   *
   * @property {(number|function|jqLite)} yOffset
   * If set, specifies a vertical scroll-offset. This is often useful when there are fixed
   * positioned elements at the top of the page, such as navbars, headers etc.
   *
   * `yOffset` can be specified in various ways:
   * - **number**: A fixed number of pixels to be used as offset.<br /><br />
   * - **function**: A getter function called everytime `$anchorScroll()` is executed. Must return
   *   a number representing the offset (in pixels).<br /><br />
   * - **jqLite**: A jqLite/jQuery element to be used for specifying the offset. The distance from
   *   the top of the page to the element's bottom will be used as offset.<br />
   *   **Note**: The element will be taken into account only as long as its `position` is set to
   *   `fixed`. This option is useful, when dealing with responsive navbars/headers that adjust
   *   their height and/or positioning according to the viewport's size.
   *
   * <br />
   * <div class="alert alert-warning">
   * In order for `yOffset` to work properly, scrolling should take place on the document's root and
   * not some child element.
   * </div>
   *
   * @example
     <example module="anchorScrollExample" name="anchor-scroll">
       <file name="index.html">
         <div id="scrollArea" ng-controller="ScrollController">
           <a ng-click="gotoBottom()">Go to bottom</a>
           <a id="bottom"></a> You're at the bottom!
         </div>
       </file>
       <file name="script.js">
         angular.module('anchorScrollExample', [])
           .controller('ScrollController', ['$scope', '$location', '$anchorScroll',
             function($scope, $location, $anchorScroll) {
               $scope.gotoBottom = function() {
                 // set the location.hash to the id of
                 // the element you wish to scroll to.
                 $location.hash('bottom');

                 // call $anchorScroll()
                 $anchorScroll();
               };
             }]);
       </file>
       <file name="style.css">
         #scrollArea {
           height: 280px;
           overflow: auto;
         }

         #bottom {
           display: block;
           margin-top: 2000px;
         }
       </file>
     </example>
   *
   * <hr />
   * The example below illustrates the use of a vertical scroll-offset (specified as a fixed value).
   * See {@link ng.$anchorScroll#yOffset $anchorScroll.yOffset} for more details.
   *
   * @example
     <example module="anchorScrollOffsetExample" name="anchor-scroll-offset">
       <file name="index.html">
         <div class="fixed-header" ng-controller="headerCtrl">
           <a href="" ng-click="gotoAnchor(x)" ng-repeat="x in [1,2,3,4,5]">
             Go to anchor {{x}}
           </a>
         </div>
         <div id="anchor{{x}}" class="anchor" ng-repeat="x in [1,2,3,4,5]">
           Anchor {{x}} of 5
         </div>
       </file>
       <file name="script.js">
         angular.module('anchorScrollOffsetExample', [])
           .run(['$anchorScroll', function($anchorScroll) {
             $anchorScroll.yOffset = 50;   // always scroll by 50 extra pixels
           }])
           .controller('headerCtrl', ['$anchorScroll', '$location', '$scope',
             function($anchorScroll, $location, $scope) {
               $scope.gotoAnchor = function(x) {
                 var newHash = 'anchor' + x;
                 if ($location.hash() !== newHash) {
                   // set the $location.hash to `newHash` and
                   // $anchorScroll will automatically scroll to it
                   $location.hash('anchor' + x);
                 } else {
                   // call $anchorScroll() explicitly,
                   // since $location.hash hasn't changed
                   $anchorScroll();
                 }
               };
             }
           ]);
       </file>
       <file name="style.css">
         body {
           padding-top: 50px;
         }

         .anchor {
           border: 2px dashed DarkOrchid;
           padding: 10px 10px 200px 10px;
         }

         .fixed-header {
           background-color: rgba(0, 0, 0, 0.2);
           height: 50px;
           position: fixed;
           top: 0; left: 0; right: 0;
         }

         .fixed-header > a {
           display: inline-block;
           margin: 5px 15px;
         }
       </file>
     </example>
   */
  this.$get = ['$window', '$location', '$rootScope', function($window, $location, $rootScope) {
    var document = $window.document;

    // Helper function to get first anchor from a NodeList
    // (using `Array#some()` instead of `angular#forEach()` since it's more performant
    //  and working in all supported browsers.)
    function getFirstAnchor(list) {
      var result = null;
      Array.prototype.some.call(list, function(element) {
        if (nodeName_(element) === 'a') {
          result = element;
          return true;
        }
      });
      return result;
    }

    function getYOffset() {

      var offset = scroll.yOffset;

      if (isFunction(offset)) {
        offset = offset();
      } else if (isElement(offset)) {
        var elem = offset[0];
        var style = $window.getComputedStyle(elem);
        if (style.position !== 'fixed') {
          offset = 0;
        } else {
          offset = elem.getBoundingClientRect().bottom;
        }
      } else if (!isNumber(offset)) {
        offset = 0;
      }

      return offset;
    }

    function scrollTo(elem) {
      if (elem) {
        elem.scrollIntoView();

        var offset = getYOffset();

        if (offset) {
          // `offset` is the number of pixels we should scroll UP in order to align `elem` properly.
          // This is true ONLY if the call to `elem.scrollIntoView()` initially aligns `elem` at the
          // top of the viewport.
          //
          // IF the number of pixels from the top of `elem` to the end of the page's content is less
          // than the height of the viewport, then `elem.scrollIntoView()` will align the `elem` some
          // way down the page.
          //
          // This is often the case for elements near the bottom of the page.
          //
          // In such cases we do not need to scroll the whole `offset` up, just the difference between
          // the top of the element and the offset, which is enough to align the top of `elem` at the
          // desired position.
          var elemTop = elem.getBoundingClientRect().top;
          $window.scrollBy(0, elemTop - offset);
        }
      } else {
        $window.scrollTo(0, 0);
      }
    }

    function scroll(hash) {
      // Allow numeric hashes
      hash = isString(hash) ? hash : isNumber(hash) ? hash.toString() : $location.hash();
      var elm;

      // empty hash, scroll to the top of the page
      if (!hash) scrollTo(null);

      // element with given id
      else if ((elm = document.getElementById(hash))) scrollTo(elm);

      // first anchor with given name :-D
      else if ((elm = getFirstAnchor(document.getElementsByName(hash)))) scrollTo(elm);

      // no element and hash === 'top', scroll to the top of the page
      else if (hash === 'top') scrollTo(null);
    }

    // does not scroll when user clicks on anchor link that is currently on
    // (no url change, no $location.hash() change), browser native does scroll
    if (autoScrollingEnabled) {
      $rootScope.$watch(function autoScrollWatch() {return $location.hash();},
        function autoScrollWatchAction(newVal, oldVal) {
          // skip the initial scroll if $location.hash is empty
          if (newVal === oldVal && newVal === '') return;

          jqLiteDocumentLoaded(function() {
            $rootScope.$evalAsync(scroll);
          });
        });
    }

    return scroll;
  }];
}

var $animateMinErr = minErr('$animate');
var ELEMENT_NODE = 1;
var NG_ANIMATE_CLASSNAME = 'ng-animate';

function mergeClasses(a,b) {
  if (!a && !b) return '';
  if (!a) return b;
  if (!b) return a;
  if (isArray(a)) a = a.join(' ');
  if (isArray(b)) b = b.join(' ');
  return a + ' ' + b;
}

function extractElementNode(element) {
  for (var i = 0; i < element.length; i++) {
    var elm = element[i];
    if (elm.nodeType === ELEMENT_NODE) {
      return elm;
    }
  }
}

function splitClasses(classes) {
  if (isString(classes)) {
    classes = classes.split(' ');
  }

  // Use createMap() to prevent class assumptions involving property names in
  // Object.prototype
  var obj = createMap();
  forEach(classes, function(klass) {
    // sometimes the split leaves empty string values
    // incase extra spaces were applied to the options
    if (klass.length) {
      obj[klass] = true;
    }
  });
  return obj;
}

// if any other type of options value besides an Object value is
// passed into the $animate.method() animation then this helper code
// will be run which will ignore it. While this patch is not the
// greatest solution to this, a lot of existing plugins depend on
// $animate to either call the callback (< 1.2) or return a promise
// that can be changed. This helper function ensures that the options
// are wiped clean incase a callback function is provided.
function prepareAnimateOptions(options) {
  return isObject(options)
      ? options
      : {};
}

var $$CoreAnimateJsProvider = /** @this */ function() {
  this.$get = noop;
};

// this is prefixed with Core since it conflicts with
// the animateQueueProvider defined in ngAnimate/animateQueue.js
var $$CoreAnimateQueueProvider = /** @this */ function() {
  var postDigestQueue = new NgMap();
  var postDigestElements = [];

  this.$get = ['$$AnimateRunner', '$rootScope',
       function($$AnimateRunner,   $rootScope) {
    return {
      enabled: noop,
      on: noop,
      off: noop,
      pin: noop,

      push: function(element, event, options, domOperation) {
        if (domOperation) {
          domOperation();
        }

        options = options || {};
        if (options.from) {
          element.css(options.from);
        }
        if (options.to) {
          element.css(options.to);
        }

        if (options.addClass || options.removeClass) {
          addRemoveClassesPostDigest(element, options.addClass, options.removeClass);
        }

        var runner = new $$AnimateRunner();

        // since there are no animations to run the runner needs to be
        // notified that the animation call is complete.
        runner.complete();
        return runner;
      }
    };


    function updateData(data, classes, value) {
      var changed = false;
      if (classes) {
        classes = isString(classes) ? classes.split(' ') :
                  isArray(classes) ? classes : [];
        forEach(classes, function(className) {
          if (className) {
            changed = true;
            data[className] = value;
          }
        });
      }
      return changed;
    }

    function handleCSSClassChanges() {
      forEach(postDigestElements, function(element) {
        var data = postDigestQueue.get(element);
        if (data) {
          var existing = splitClasses(element.attr('class'));
          var toAdd = '';
          var toRemove = '';
          forEach(data, function(status, className) {
            var hasClass = !!existing[className];
            if (status !== hasClass) {
              if (status) {
                toAdd += (toAdd.length ? ' ' : '') + className;
              } else {
                toRemove += (toRemove.length ? ' ' : '') + className;
              }
            }
          });

          forEach(element, function(elm) {
            if (toAdd) {
              jqLiteAddClass(elm, toAdd);
            }
            if (toRemove) {
              jqLiteRemoveClass(elm, toRemove);
            }
          });
          postDigestQueue.delete(element);
        }
      });
      postDigestElements.length = 0;
    }


    function addRemoveClassesPostDigest(element, add, remove) {
      var data = postDigestQueue.get(element) || {};

      var classesAdded = updateData(data, add, true);
      var classesRemoved = updateData(data, remove, false);

      if (classesAdded || classesRemoved) {

        postDigestQueue.set(element, data);
        postDigestElements.push(element);

        if (postDigestElements.length === 1) {
          $rootScope.$$postDigest(handleCSSClassChanges);
        }
      }
    }
  }];
};

/**
 * @ngdoc provider
 * @name $animateProvider
 *
 * @description
 * Default implementation of $animate that doesn't perform any animations, instead just
 * synchronously performs DOM updates and resolves the returned runner promise.
 *
 * In order to enable animations the `ngAnimate` module has to be loaded.
 *
 * To see the functional implementation check out `src/ngAnimate/animate.js`.
 */
var $AnimateProvider = ['$provide', /** @this */ function($provide) {
  var provider = this;
  var classNameFilter = null;
  var customFilter = null;

  this.$$registeredAnimations = Object.create(null);

   /**
   * @ngdoc method
   * @name $animateProvider#register
   *
   * @description
   * Registers a new injectable animation factory function. The factory function produces the
   * animation object which contains callback functions for each event that is expected to be
   * animated.
   *
   *   * `eventFn`: `function(element, ... , doneFunction, options)`
   *   The element to animate, the `doneFunction` and the options fed into the animation. Depending
   *   on the type of animation additional arguments will be injected into the animation function. The
   *   list below explains the function signatures for the different animation methods:
   *
   *   - setClass: function(element, addedClasses, removedClasses, doneFunction, options)
   *   - addClass: function(element, addedClasses, doneFunction, options)
   *   - removeClass: function(element, removedClasses, doneFunction, options)
   *   - enter, leave, move: function(element, doneFunction, options)
   *   - animate: function(element, fromStyles, toStyles, doneFunction, options)
   *
   *   Make sure to trigger the `doneFunction` once the animation is fully complete.
   *
   * ```js
   *   return {
   *     //enter, leave, move signature
   *     eventFn : function(element, done, options) {
   *       //code to run the animation
   *       //once complete, then run done()
   *       return function endFunction(wasCancelled) {
   *         //code to cancel the animation
   *       }
   *     }
   *   }
   * ```
   *
   * @param {string} name The name of the animation (this is what the class-based CSS value will be compared to).
   * @param {Function} factory The factory function that will be executed to return the animation
   *                           object.
   */
  this.register = function(name, factory) {
    if (name && name.charAt(0) !== '.') {
      throw $animateMinErr('notcsel', 'Expecting class selector starting with \'.\' got \'{0}\'.', name);
    }

    var key = name + '-animation';
    provider.$$registeredAnimations[name.substr(1)] = key;
    $provide.factory(key, factory);
  };

  /**
   * @ngdoc method
   * @name $animateProvider#customFilter
   *
   * @description
   * Sets and/or returns the custom filter function that is used to "filter" animations, i.e.
   * determine if an animation is allowed or not. When no filter is specified (the default), no
   * animation will be blocked. Setting the `customFilter` value will only allow animations for
   * which the filter function's return value is truthy.
   *
   * This allows to easily create arbitrarily complex rules for filtering animations, such as
   * allowing specific events only, or enabling animations on specific subtrees of the DOM, etc.
   * Filtering animations can also boost performance for low-powered devices, as well as
   * applications containing a lot of structural operations.
   *
   * <div class="alert alert-success">
   *   **Best Practice:**
   *   Keep the filtering function as lean as possible, because it will be called for each DOM
   *   action (e.g. insertion, removal, class change) performed by "animation-aware" directives.
   *   See {@link guide/animations#which-directives-support-animations- here} for a list of built-in
   *   directives that support animations.
   *   Performing computationally expensive or time-consuming operations on each call of the
   *   filtering function can make your animations sluggish.
   * </div>
   *
   * **Note:** If present, `customFilter` will be checked before
   * {@link $animateProvider#classNameFilter classNameFilter}.
   *
   * @param {Function=} filterFn - The filter function which will be used to filter all animations.
   *   If a falsy value is returned, no animation will be performed. The function will be called
   *   with the following arguments:
   *   - **node** `{DOMElement}` - The DOM element to be animated.
   *   - **event** `{String}` - The name of the animation event (e.g. `enter`, `leave`, `addClass`
   *     etc).
   *   - **options** `{Object}` - A collection of options/styles used for the animation.
   * @return {Function} The current filter function or `null` if there is none set.
   */
  this.customFilter = function(filterFn) {
    if (arguments.length === 1) {
      customFilter = isFunction(filterFn) ? filterFn : null;
    }

    return customFilter;
  };

  /**
   * @ngdoc method
   * @name $animateProvider#classNameFilter
   *
   * @description
   * Sets and/or returns the CSS class regular expression that is checked when performing
   * an animation. Upon bootstrap the classNameFilter value is not set at all and will
   * therefore enable $animate to attempt to perform an animation on any element that is triggered.
   * When setting the `classNameFilter` value, animations will only be performed on elements
   * that successfully match the filter expression. This in turn can boost performance
   * for low-powered devices as well as applications containing a lot of structural operations.
   *
   * **Note:** If present, `classNameFilter` will be checked after
   * {@link $animateProvider#customFilter customFilter}. If `customFilter` is present and returns
   * false, `classNameFilter` will not be checked.
   *
   * @param {RegExp=} expression The className expression which will be checked against all animations
   * @return {RegExp} The current CSS className expression value. If null then there is no expression value
   */
  this.classNameFilter = function(expression) {
    if (arguments.length === 1) {
      classNameFilter = (expression instanceof RegExp) ? expression : null;
      if (classNameFilter) {
        var reservedRegex = new RegExp('[(\\s|\\/)]' + NG_ANIMATE_CLASSNAME + '[(\\s|\\/)]');
        if (reservedRegex.test(classNameFilter.toString())) {
          classNameFilter = null;
          throw $animateMinErr('nongcls', '$animateProvider.classNameFilter(regex) prohibits accepting a regex value which matches/contains the "{0}" CSS class.', NG_ANIMATE_CLASSNAME);
        }
      }
    }
    return classNameFilter;
  };

  this.$get = ['$$animateQueue', function($$animateQueue) {
    function domInsert(element, parentElement, afterElement) {
      // if for some reason the previous element was removed
      // from the dom sometime before this code runs then let's
      // just stick to using the parent element as the anchor
      if (afterElement) {
        var afterNode = extractElementNode(afterElement);
        if (afterNode && !afterNode.parentNode && !afterNode.previousElementSibling) {
          afterElement = null;
        }
      }
      if (afterElement) {
        afterElement.after(element);
      } else {
        parentElement.prepend(element);
      }
    }

    /**
     * @ngdoc service
     * @name $animate
     * @description The $animate service exposes a series of DOM utility methods that provide support
     * for animation hooks. The default behavior is the application of DOM operations, however,
     * when an animation is detected (and animations are enabled), $animate will do the heavy lifting
     * to ensure that animation runs with the triggered DOM operation.
     *
     * By default $animate doesn't trigger any animations. This is because the `ngAnimate` module isn't
     * included and only when it is active then the animation hooks that `$animate` triggers will be
     * functional. Once active then all structural `ng-` directives will trigger animations as they perform
     * their DOM-related operations (enter, leave and move). Other directives such as `ngClass`,
     * `ngShow`, `ngHide` and `ngMessages` also provide support for animations.
     *
     * It is recommended that the`$animate` service is always used when executing DOM-related procedures within directives.
     *
     * To learn more about enabling animation support, click here to visit the
     * {@link ngAnimate ngAnimate module page}.
     */
    return {
      // we don't call it directly since non-existant arguments may
      // be interpreted as null within the sub enabled function

      /**
       *
       * @ngdoc method
       * @name $animate#on
       * @kind function
       * @description Sets up an event listener to fire whenever the animation event (enter, leave, move, etc...)
       *    has fired on the given element or among any of its children. Once the listener is fired, the provided callback
       *    is fired with the following params:
       *
       * ```js
       * $animate.on('enter', container,
       *    function callback(element, phase) {
       *      // cool we detected an enter animation within the container
       *    }
       * );
       * ```
       *
       * <div class="alert alert-warning">
       * **Note**: Generally, the events that are fired correspond 1:1 to `$animate` method names,
       * e.g. {@link ng.$animate#addClass addClass()} will fire `addClass`, and {@link ng.ngClass}
       * will fire `addClass` if classes are added, and `removeClass` if classes are removed.
       * However, there are two exceptions:
       *
       * <ul>
       *   <li>if both an {@link ng.$animate#addClass addClass()} and a
       *   {@link ng.$animate#removeClass removeClass()} action are performed during the same
       *   animation, the event fired will be `setClass`. This is true even for `ngClass`.</li>
       *   <li>an {@link ng.$animate#animate animate()} call that adds and removes classes will fire
       *   the `setClass` event, but if it either removes or adds classes,
       *   it will fire `animate` instead.</li>
       * </ul>
       *
       * </div>
       *
       * @param {string} event the animation event that will be captured (e.g. enter, leave, move, addClass, removeClass, etc...)
       * @param {DOMElement} container the container element that will capture each of the animation events that are fired on itself
       *     as well as among its children
       * @param {Function} callback the callback function that will be fired when the listener is triggered.
       *
       * The arguments present in the callback function are:
       * * `element` - The captured DOM element that the animation was fired on.
       * * `phase` - The phase of the animation. The two possible phases are **start** (when the animation starts) and **close** (when it ends).
       * * `data` - an object with these properties:
       *     * addClass - `{string|null}` - space-separated CSS classes to add to the element
       *     * removeClass - `{string|null}` - space-separated CSS classes to remove from the element
       *     * from - `{Object|null}` - CSS properties & values at the beginning of the animation
       *     * to - `{Object|null}` - CSS properties & values at the end of the animation
       *
       * Note that the callback does not trigger a scope digest. Wrap your call into a
       * {@link $rootScope.Scope#$apply scope.$apply} to propagate changes to the scope.
       */
      on: $$animateQueue.on,

      /**
       *
       * @ngdoc method
       * @name $animate#off
       * @kind function
       * @description Deregisters an event listener based on the event which has been associated with the provided element. This method
       * can be used in three different ways depending on the arguments:
       *
       * ```js
       * // remove all the animation event listeners listening for `enter`
       * $animate.off('enter');
       *
       * // remove listeners for all animation events from the container element
       * $animate.off(container);
       *
       * // remove all the animation event listeners listening for `enter` on the given element and its children
       * $animate.off('enter', container);
       *
       * // remove the event listener function provided by `callback` that is set
       * // to listen for `enter` on the given `container` as well as its children
       * $animate.off('enter', container, callback);
       * ```
       *
       * @param {string|DOMElement} event|container the animation event (e.g. enter, leave, move,
       * addClass, removeClass, etc...), or the container element. If it is the element, all other
       * arguments are ignored.
       * @param {DOMElement=} container the container element the event listener was placed on
       * @param {Function=} callback the callback function that was registered as the listener
       */
      off: $$animateQueue.off,

      /**
       * @ngdoc method
       * @name $animate#pin
       * @kind function
       * @description Associates the provided element with a host parent element to allow the element to be animated even if it exists
       *    outside of the DOM structure of the AngularJS application. By doing so, any animation triggered via `$animate` can be issued on the
       *    element despite being outside the realm of the application or within another application. Say for example if the application
       *    was bootstrapped on an element that is somewhere inside of the `<body>` tag, but we wanted to allow for an element to be situated
       *    as a direct child of `document.body`, then this can be achieved by pinning the element via `$animate.pin(element)`. Keep in mind
       *    that calling `$animate.pin(element, parentElement)` will not actually insert into the DOM anywhere; it will just create the association.
       *
       *    Note that this feature is only active when the `ngAnimate` module is used.
       *
       * @param {DOMElement} element the external element that will be pinned
       * @param {DOMElement} parentElement the host parent element that will be associated with the external element
       */
      pin: $$animateQueue.pin,

      /**
       *
       * @ngdoc method
       * @name $animate#enabled
       * @kind function
       * @description Used to get and set whether animations are enabled or not on the entire application or on an element and its children. This
       * function can be called in four ways:
       *
       * ```js
       * // returns true or false
       * $animate.enabled();
       *
       * // changes the enabled state for all animations
       * $animate.enabled(false);
       * $animate.enabled(true);
       *
       * // returns true or false if animations are enabled for an element
       * $animate.enabled(element);
       *
       * // changes the enabled state for an element and its children
       * $animate.enabled(element, true);
       * $animate.enabled(element, false);
       * ```
       *
       * @param {DOMElement=} element the element that will be considered for checking/setting the enabled state
       * @param {boolean=} enabled whether or not the animations will be enabled for the element
       *
       * @return {boolean} whether or not animations are enabled
       */
      enabled: $$animateQueue.enabled,

      /**
       * @ngdoc method
       * @name $animate#cancel
       * @kind function
       * @description Cancels the provided animation and applies the end state of the animation.
       * Note that this does not cancel the underlying operation, e.g. the setting of classes or
       * adding the element to the DOM.
       *
       * @param {animationRunner} animationRunner An animation runner returned by an $animate function.
       *
       * @example
        <example module="animationExample" deps="angular-animate.js" animations="true" name="animate-cancel">
          <file name="app.js">
            angular.module('animationExample', ['ngAnimate']).component('cancelExample', {
              templateUrl: 'template.html',
              controller: function($element, $animate) {
                this.runner = null;

                this.addClass = function() {
                  this.runner = $animate.addClass($element.find('div'), 'red');
                  var ctrl = this;
                  this.runner.finally(function() {
                    ctrl.runner = null;
                  });
                };

                this.removeClass = function() {
                  this.runner = $animate.removeClass($element.find('div'), 'red');
                  var ctrl = this;
                  this.runner.finally(function() {
                    ctrl.runner = null;
                  });
                };

                this.cancel = function() {
                  $animate.cancel(this.runner);
                };
              }
            });
          </file>
          <file name="template.html">
            <p>
              <button id="add" ng-click="$ctrl.addClass()">Add</button>
              <button ng-click="$ctrl.removeClass()">Remove</button>
              <br>
              <button id="cancel" ng-click="$ctrl.cancel()" ng-disabled="!$ctrl.runner">Cancel</button>
              <br>
              <div id="target">CSS-Animated Text</div>
            </p>
          </file>
          <file name="index.html">
            <cancel-example></cancel-example>
          </file>
          <file name="style.css">
            .red-add, .red-remove {
              transition: all 4s cubic-bezier(0.250, 0.460, 0.450, 0.940);
            }

            .red,
            .red-add.red-add-active {
              color: #FF0000;
              font-size: 40px;
            }

            .red-remove.red-remove-active {
              font-size: 10px;
              color: black;
            }

          </file>
        </example>
       */
      cancel: function(runner) {
        if (runner.cancel) {
          runner.cancel();
        }
      },

      /**
       *
       * @ngdoc method
       * @name $animate#enter
       * @kind function
       * @description Inserts the element into the DOM either after the `after` element (if provided) or
       *   as the first child within the `parent` element and then triggers an animation.
       *   A promise is returned that will be resolved during the next digest once the animation
       *   has completed.
       *
       * @param {DOMElement} element the element which will be inserted into the DOM
       * @param {DOMElement} parent the parent element which will append the element as
       *   a child (so long as the after element is not present)
       * @param {DOMElement=} after the sibling element after which the element will be appended
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Runner} the animation runner
       */
      enter: function(element, parent, after, options) {
        parent = parent && jqLite(parent);
        after = after && jqLite(after);
        parent = parent || after.parent();
        domInsert(element, parent, after);
        return $$animateQueue.push(element, 'enter', prepareAnimateOptions(options));
      },

      /**
       *
       * @ngdoc method
       * @name $animate#move
       * @kind function
       * @description Inserts (moves) the element into its new position in the DOM either after
       *   the `after` element (if provided) or as the first child within the `parent` element
       *   and then triggers an animation. A promise is returned that will be resolved
       *   during the next digest once the animation has completed.
       *
       * @param {DOMElement} element the element which will be moved into the new DOM position
       * @param {DOMElement} parent the parent element which will append the element as
       *   a child (so long as the after element is not present)
       * @param {DOMElement=} after the sibling element after which the element will be appended
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Runner} the animation runner
       */
      move: function(element, parent, after, options) {
        parent = parent && jqLite(parent);
        after = after && jqLite(after);
        parent = parent || after.parent();
        domInsert(element, parent, after);
        return $$animateQueue.push(element, 'move', prepareAnimateOptions(options));
      },

      /**
       * @ngdoc method
       * @name $animate#leave
       * @kind function
       * @description Triggers an animation and then removes the element from the DOM.
       * When the function is called a promise is returned that will be resolved during the next
       * digest once the animation has completed.
       *
       * @param {DOMElement} element the element which will be removed from the DOM
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Runner} the animation runner
       */
      leave: function(element, options) {
        return $$animateQueue.push(element, 'leave', prepareAnimateOptions(options), function() {
          element.remove();
        });
      },

      /**
       * @ngdoc method
       * @name $animate#addClass
       * @kind function
       *
       * @description Triggers an addClass animation surrounding the addition of the provided CSS class(es). Upon
       *   execution, the addClass operation will only be handled after the next digest and it will not trigger an
       *   animation if element already contains the CSS class or if the class is removed at a later step.
       *   Note that class-based animations are treated differently compared to structural animations
       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
       *   depending if CSS or JavaScript animations are used.
       *
       * @param {DOMElement} element the element which the CSS classes will be applied to
       * @param {string} className the CSS class(es) that will be added (multiple classes are separated via spaces)
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Runner} animationRunner the animation runner
       */
      addClass: function(element, className, options) {
        options = prepareAnimateOptions(options);
        options.addClass = mergeClasses(options.addclass, className);
        return $$animateQueue.push(element, 'addClass', options);
      },

      /**
       * @ngdoc method
       * @name $animate#removeClass
       * @kind function
       *
       * @description Triggers a removeClass animation surrounding the removal of the provided CSS class(es). Upon
       *   execution, the removeClass operation will only be handled after the next digest and it will not trigger an
       *   animation if element does not contain the CSS class or if the class is added at a later step.
       *   Note that class-based animations are treated differently compared to structural animations
       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
       *   depending if CSS or JavaScript animations are used.
       *
       * @param {DOMElement} element the element which the CSS classes will be applied to
       * @param {string} className the CSS class(es) that will be removed (multiple classes are separated via spaces)
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Runner} the animation runner
       */
      removeClass: function(element, className, options) {
        options = prepareAnimateOptions(options);
        options.removeClass = mergeClasses(options.removeClass, className);
        return $$animateQueue.push(element, 'removeClass', options);
      },

      /**
       * @ngdoc method
       * @name $animate#setClass
       * @kind function
       *
       * @description Performs both the addition and removal of a CSS classes on an element and (during the process)
       *    triggers an animation surrounding the class addition/removal. Much like `$animate.addClass` and
       *    `$animate.removeClass`, `setClass` will only evaluate the classes being added/removed once a digest has
       *    passed. Note that class-based animations are treated differently compared to structural animations
       *    (like enter, move and leave) since the CSS classes may be added/removed at different points
       *    depending if CSS or JavaScript animations are used.
       *
       * @param {DOMElement} element the element which the CSS classes will be applied to
       * @param {string} add the CSS class(es) that will be added (multiple classes are separated via spaces)
       * @param {string} remove the CSS class(es) that will be removed (multiple classes are separated via spaces)
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Runner} the animation runner
       */
      setClass: function(element, add, remove, options) {
        options = prepareAnimateOptions(options);
        options.addClass = mergeClasses(options.addClass, add);
        options.removeClass = mergeClasses(options.removeClass, remove);
        return $$animateQueue.push(element, 'setClass', options);
      },

      /**
       * @ngdoc method
       * @name $animate#animate
       * @kind function
       *
       * @description Performs an inline animation on the element which applies the provided to and from CSS styles to the element.
       * If any detected CSS transition, keyframe or JavaScript matches the provided className value, then the animation will take
       * on the provided styles. For example, if a transition animation is set for the given className, then the provided `from` and
       * `to` styles will be applied alongside the given transition. If the CSS style provided in `from` does not have a corresponding
       * style in `to`, the style in `from` is applied immediately, and no animation is run.
       * If a JavaScript animation is detected then the provided styles will be given in as function parameters into the `animate`
       * method (or as part of the `options` parameter):
       *
       * ```js
       * ngModule.animation('.my-inline-animation', function() {
       *   return {
       *     animate : function(element, from, to, done, options) {
       *       //animation
       *       done();
       *     }
       *   }
       * });
       * ```
       *
       * @param {DOMElement} element the element which the CSS styles will be applied to
       * @param {object} from the from (starting) CSS styles that will be applied to the element and across the animation.
       * @param {object} to the to (destination) CSS styles that will be applied to the element and across the animation.
       * @param {string=} className an optional CSS class that will be applied to the element for the duration of the animation. If
       *    this value is left as empty then a CSS class of `ng-inline-animate` will be applied to the element.
       *    (Note that if no animation is detected then this value will not be applied to the element.)
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Runner} the animation runner
       */
      animate: function(element, from, to, className, options) {
        options = prepareAnimateOptions(options);
        options.from = options.from ? extend(options.from, from) : from;
        options.to   = options.to   ? extend(options.to, to)     : to;

        className = className || 'ng-inline-animate';
        options.tempClasses = mergeClasses(options.tempClasses, className);
        return $$animateQueue.push(element, 'animate', options);
      }
    };
  }];
}];

var $$AnimateAsyncRunFactoryProvider = /** @this */ function() {
  this.$get = ['$$rAF', function($$rAF) {
    var waitQueue = [];

    function waitForTick(fn) {
      waitQueue.push(fn);
      if (waitQueue.length > 1) return;
      $$rAF(function() {
        for (var i = 0; i < waitQueue.length; i++) {
          waitQueue[i]();
        }
        waitQueue = [];
      });
    }

    return function() {
      var passed = false;
      waitForTick(function() {
        passed = true;
      });
      return function(callback) {
        if (passed) {
          callback();
        } else {
          waitForTick(callback);
        }
      };
    };
  }];
};

var $$AnimateRunnerFactoryProvider = /** @this */ function() {
  this.$get = ['$q', '$sniffer', '$$animateAsyncRun', '$$isDocumentHidden', '$timeout',
       function($q,   $sniffer,   $$animateAsyncRun,   $$isDocumentHidden,   $timeout) {

    var INITIAL_STATE = 0;
    var DONE_PENDING_STATE = 1;
    var DONE_COMPLETE_STATE = 2;

    AnimateRunner.chain = function(chain, callback) {
      var index = 0;

      next();
      function next() {
        if (index === chain.length) {
          callback(true);
          return;
        }

        chain[index](function(response) {
          if (response === false) {
            callback(false);
            return;
          }
          index++;
          next();
        });
      }
    };

    AnimateRunner.all = function(runners, callback) {
      var count = 0;
      var status = true;
      forEach(runners, function(runner) {
        runner.done(onProgress);
      });

      function onProgress(response) {
        status = status && response;
        if (++count === runners.length) {
          callback(status);
        }
      }
    };

    function AnimateRunner(host) {
      this.setHost(host);

      var rafTick = $$animateAsyncRun();
      var timeoutTick = function(fn) {
        $timeout(fn, 0, false);
      };

      this._doneCallbacks = [];
      this._tick = function(fn) {
        if ($$isDocumentHidden()) {
          timeoutTick(fn);
        } else {
          rafTick(fn);
        }
      };
      this._state = 0;
    }

    AnimateRunner.prototype = {
      setHost: function(host) {
        this.host = host || {};
      },

      done: function(fn) {
        if (this._state === DONE_COMPLETE_STATE) {
          fn();
        } else {
          this._doneCallbacks.push(fn);
        }
      },

      progress: noop,

      getPromise: function() {
        if (!this.promise) {
          var self = this;
          this.promise = $q(function(resolve, reject) {
            self.done(function(status) {
              if (status === false) {
                reject();
              } else {
                resolve();
              }
            });
          });
        }
        return this.promise;
      },

      then: function(resolveHandler, rejectHandler) {
        return this.getPromise().then(resolveHandler, rejectHandler);
      },

      'catch': function(handler) {
        return this.getPromise()['catch'](handler);
      },

      'finally': function(handler) {
        return this.getPromise()['finally'](handler);
      },

      pause: function() {
        if (this.host.pause) {
          this.host.pause();
        }
      },

      resume: function() {
        if (this.host.resume) {
          this.host.resume();
        }
      },

      end: function() {
        if (this.host.end) {
          this.host.end();
        }
        this._resolve(true);
      },

      cancel: function() {
        if (this.host.cancel) {
          this.host.cancel();
        }
        this._resolve(false);
      },

      complete: function(response) {
        var self = this;
        if (self._state === INITIAL_STATE) {
          self._state = DONE_PENDING_STATE;
          self._tick(function() {
            self._resolve(response);
          });
        }
      },

      _resolve: function(response) {
        if (this._state !== DONE_COMPLETE_STATE) {
          forEach(this._doneCallbacks, function(fn) {
            fn(response);
          });
          this._doneCallbacks.length = 0;
          this._state = DONE_COMPLETE_STATE;
        }
      }
    };

    return AnimateRunner;
  }];
};

/* exported $CoreAnimateCssProvider */

/**
 * @ngdoc service
 * @name $animateCss
 * @kind object
 * @this
 *
 * @description
 * This is the core version of `$animateCss`. By default, only when the `ngAnimate` is included,
 * then the `$animateCss` service will actually perform animations.
 *
 * Click here {@link ngAnimate.$animateCss to read the documentation for $animateCss}.
 */
var $CoreAnimateCssProvider = function() {
  this.$get = ['$$rAF', '$q', '$$AnimateRunner', function($$rAF, $q, $$AnimateRunner) {

    return function(element, initialOptions) {
      // all of the animation functions should create
      // a copy of the options data, however, if a
      // parent service has already created a copy then
      // we should stick to using that
      var options = initialOptions || {};
      if (!options.$$prepared) {
        options = copy(options);
      }

      // there is no point in applying the styles since
      // there is no animation that goes on at all in
      // this version of $animateCss.
      if (options.cleanupStyles) {
        options.from = options.to = null;
      }

      if (options.from) {
        element.css(options.from);
        options.from = null;
      }

      var closed, runner = new $$AnimateRunner();
      return {
        start: run,
        end: run
      };

      function run() {
        $$rAF(function() {
          applyAnimationContents();
          if (!closed) {
            runner.complete();
          }
          closed = true;
        });
        return runner;
      }

      function applyAnimationContents() {
        if (options.addClass) {
          element.addClass(options.addClass);
          options.addClass = null;
        }
        if (options.removeClass) {
          element.removeClass(options.removeClass);
          options.removeClass = null;
        }
        if (options.to) {
          element.css(options.to);
          options.to = null;
        }
      }
    };
  }];
};

/* global getHash: true, stripHash: false */

function getHash(url) {
  var index = url.indexOf('#');
  return index === -1 ? '' : url.substr(index);
}

function trimEmptyHash(url) {
  return url.replace(/#$/, '');
}

/**
 * ! This is a private undocumented service !
 *
 * @name $browser
 * @requires $log
 * @description
 * This object has two goals:
 *
 * - hide all the global state in the browser caused by the window object
 * - abstract away all the browser specific features and inconsistencies
 *
 * For tests we provide {@link ngMock.$browser mock implementation} of the `$browser`
 * service, which can be used for convenient testing of the application without the interaction with
 * the real browser apis.
 */
/**
 * @param {object} window The global window object.
 * @param {object} document jQuery wrapped document.
 * @param {object} $log window.console or an object with the same interface.
 * @param {object} $sniffer $sniffer service
 */
function Browser(window, document, $log, $sniffer, $$taskTrackerFactory) {
  var self = this,
      location = window.location,
      history = window.history,
      setTimeout = window.setTimeout,
      clearTimeout = window.clearTimeout,
      pendingDeferIds = {},
      taskTracker = $$taskTrackerFactory($log);

  self.isMock = false;

  //////////////////////////////////////////////////////////////
  // Task-tracking API
  //////////////////////////////////////////////////////////////

  // TODO(vojta): remove this temporary api
  self.$$completeOutstandingRequest = taskTracker.completeTask;
  self.$$incOutstandingRequestCount = taskTracker.incTaskCount;

  // TODO(vojta): prefix this method with $$ ?
  self.notifyWhenNoOutstandingRequests = taskTracker.notifyWhenNoPendingTasks;

  //////////////////////////////////////////////////////////////
  // URL API
  //////////////////////////////////////////////////////////////

  var cachedState, lastHistoryState,
      lastBrowserUrl = location.href,
      baseElement = document.find('base'),
      pendingLocation = null,
      getCurrentState = !$sniffer.history ? noop : function getCurrentState() {
        try {
          return history.state;
        } catch (e) {
          // MSIE can reportedly throw when there is no state (UNCONFIRMED).
        }
      };

  cacheState();

  /**
   * @name $browser#url
   *
   * @description
   * GETTER:
   * Without any argument, this method just returns current value of `location.href` (with a
   * trailing `#` stripped of if the hash is empty).
   *
   * SETTER:
   * With at least one argument, this method sets url to new value.
   * If html5 history api supported, `pushState`/`replaceState` is used, otherwise
   * `location.href`/`location.replace` is used.
   * Returns its own instance to allow chaining.
   *
   * NOTE: this api is intended for use only by the `$location` service. Please use the
   * {@link ng.$location $location service} to change url.
   *
   * @param {string} url New url (when used as setter)
   * @param {boolean=} replace Should new url replace current history record?
   * @param {object=} state State object to use with `pushState`/`replaceState`
   */
  self.url = function(url, replace, state) {
    // In modern browsers `history.state` is `null` by default; treating it separately
    // from `undefined` would cause `$browser.url('/foo')` to change `history.state`
    // to undefined via `pushState`. Instead, let's change `undefined` to `null` here.
    if (isUndefined(state)) {
      state = null;
    }

    // Android Browser BFCache causes location, history reference to become stale.
    if (location !== window.location) location = window.location;
    if (history !== window.history) history = window.history;

    // setter
    if (url) {
      var sameState = lastHistoryState === state;

      // Normalize the inputted URL
      url = urlResolve(url).href;

      // Don't change anything if previous and current URLs and states match. This also prevents
      // IE<10 from getting into redirect loop when in LocationHashbangInHtml5Url mode.
      // See https://github.com/angular/angular.js/commit/ffb2701
      if (lastBrowserUrl === url && (!$sniffer.history || sameState)) {
        return self;
      }
      var sameBase = lastBrowserUrl && stripHash(lastBrowserUrl) === stripHash(url);
      lastBrowserUrl = url;
      lastHistoryState = state;
      // Don't use history API if only the hash changed
      // due to a bug in IE10/IE11 which leads
      // to not firing a `hashchange` nor `popstate` event
      // in some cases (see #9143).
      if ($sniffer.history && (!sameBase || !sameState)) {
        history[replace ? 'replaceState' : 'pushState'](state, '', url);
        cacheState();
      } else {
        if (!sameBase) {
          pendingLocation = url;
        }
        if (replace) {
          location.replace(url);
        } else if (!sameBase) {
          location.href = url;
        } else {
          location.hash = getHash(url);
        }
        if (location.href !== url) {
          pendingLocation = url;
        }
      }
      if (pendingLocation) {
        pendingLocation = url;
      }
      return self;
    // getter
    } else {
      // - pendingLocation is needed as browsers don't allow to read out
      //   the new location.href if a reload happened or if there is a bug like in iOS 9 (see
      //   https://openradar.appspot.com/22186109).
      return trimEmptyHash(pendingLocation || location.href);
    }
  };

  /**
   * @name $browser#state
   *
   * @description
   * This method is a getter.
   *
   * Return history.state or null if history.state is undefined.
   *
   * @returns {object} state
   */
  self.state = function() {
    return cachedState;
  };

  var urlChangeListeners = [],
      urlChangeInit = false;

  function cacheStateAndFireUrlChange() {
    pendingLocation = null;
    fireStateOrUrlChange();
  }

  // This variable should be used *only* inside the cacheState function.
  var lastCachedState = null;
  function cacheState() {
    // This should be the only place in $browser where `history.state` is read.
    cachedState = getCurrentState();
    cachedState = isUndefined(cachedState) ? null : cachedState;

    // Prevent callbacks fo fire twice if both hashchange & popstate were fired.
    if (equals(cachedState, lastCachedState)) {
      cachedState = lastCachedState;
    }

    lastCachedState = cachedState;
    lastHistoryState = cachedState;
  }

  function fireStateOrUrlChange() {
    var prevLastHistoryState = lastHistoryState;
    cacheState();

    if (lastBrowserUrl === self.url() && prevLastHistoryState === cachedState) {
      return;
    }

    lastBrowserUrl = self.url();
    lastHistoryState = cachedState;
    forEach(urlChangeListeners, function(listener) {
      listener(self.url(), cachedState);
    });
  }

  /**
   * @name $browser#onUrlChange
   *
   * @description
   * Register callback function that will be called, when url changes.
   *
   * It's only called when the url is changed from outside of AngularJS:
   * - user types different url into address bar
   * - user clicks on history (forward/back) button
   * - user clicks on a link
   *
   * It's not called when url is changed by $browser.url() method
   *
   * The listener gets called with new url as parameter.
   *
   * NOTE: this api is intended for use only by the $location service. Please use the
   * {@link ng.$location $location service} to monitor url changes in AngularJS apps.
   *
   * @param {function(string)} listener Listener function to be called when url changes.
   * @return {function(string)} Returns the registered listener fn - handy if the fn is anonymous.
   */
  self.onUrlChange = function(callback) {
    // TODO(vojta): refactor to use node's syntax for events
    if (!urlChangeInit) {
      // We listen on both (hashchange/popstate) when available, as some browsers don't
      // fire popstate when user changes the address bar and don't fire hashchange when url
      // changed by push/replaceState

      // html5 history api - popstate event
      if ($sniffer.history) jqLite(window).on('popstate', cacheStateAndFireUrlChange);
      // hashchange event
      jqLite(window).on('hashchange', cacheStateAndFireUrlChange);

      urlChangeInit = true;
    }

    urlChangeListeners.push(callback);
    return callback;
  };

  /**
   * @private
   * Remove popstate and hashchange handler from window.
   *
   * NOTE: this api is intended for use only by $rootScope.
   */
  self.$$applicationDestroyed = function() {
    jqLite(window).off('hashchange popstate', cacheStateAndFireUrlChange);
  };

  /**
   * Checks whether the url has changed outside of AngularJS.
   * Needs to be exported to be able to check for changes that have been done in sync,
   * as hashchange/popstate events fire in async.
   */
  self.$$checkUrlChange = fireStateOrUrlChange;

  //////////////////////////////////////////////////////////////
  // Misc API
  //////////////////////////////////////////////////////////////

  /**
   * @name $browser#baseHref
   *
   * @description
   * Returns current <base href>
   * (always relative - without domain)
   *
   * @returns {string} The current base href
   */
  self.baseHref = function() {
    var href = baseElement.attr('href');
    return href ? href.replace(/^(https?:)?\/\/[^/]*/, '') : '';
  };

  /**
   * @name $browser#defer
   * @param {function()} fn A function, who's execution should be deferred.
   * @param {number=} [delay=0] Number of milliseconds to defer the function execution.
   * @param {string=} [taskType=DEFAULT_TASK_TYPE] The type of task that is deferred.
   * @returns {*} DeferId that can be used to cancel the task via `$browser.defer.cancel()`.
   *
   * @description
   * Executes a fn asynchronously via `setTimeout(fn, delay)`.
   *
   * Unlike when calling `setTimeout` directly, in test this function is mocked and instead of using
   * `setTimeout` in tests, the fns are queued in an array, which can be programmatically flushed
   * via `$browser.defer.flush()`.
   *
   */
  self.defer = function(fn, delay, taskType) {
    var timeoutId;

    delay = delay || 0;
    taskType = taskType || taskTracker.DEFAULT_TASK_TYPE;

    taskTracker.incTaskCount(taskType);
    timeoutId = setTimeout(function() {
      delete pendingDeferIds[timeoutId];
      taskTracker.completeTask(fn, taskType);
    }, delay);
    pendingDeferIds[timeoutId] = taskType;

    return timeoutId;
  };


  /**
   * @name $browser#defer.cancel
   *
   * @description
   * Cancels a deferred task identified with `deferId`.
   *
   * @param {*} deferId Token returned by the `$browser.defer` function.
   * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
   *                    canceled.
   */
  self.defer.cancel = function(deferId) {
    if (pendingDeferIds.hasOwnProperty(deferId)) {
      var taskType = pendingDeferIds[deferId];
      delete pendingDeferIds[deferId];
      clearTimeout(deferId);
      taskTracker.completeTask(noop, taskType);
      return true;
    }
    return false;
  };

}

/** @this */
function $BrowserProvider() {
  this.$get = ['$window', '$log', '$sniffer', '$document', '$$taskTrackerFactory',
       function($window,   $log,   $sniffer,   $document,   $$taskTrackerFactory) {
    return new Browser($window, $document, $log, $sniffer, $$taskTrackerFactory);
  }];
}

/**
 * @ngdoc service
 * @name $cacheFactory
 * @this
 *
 * @description
 * Factory that constructs {@link $cacheFactory.Cache Cache} objects and gives access to
 * them.
 *
 * ```js
 *
 *  var cache = $cacheFactory('cacheId');
 *  expect($cacheFactory.get('cacheId')).toBe(cache);
 *  expect($cacheFactory.get('noSuchCacheId')).not.toBeDefined();
 *
 *  cache.put("key", "value");
 *  cache.put("another key", "another value");
 *
 *  // We've specified no options on creation
 *  expect(cache.info()).toEqual({id: 'cacheId', size: 2});
 *
 * ```
 *
 *
 * @param {string} cacheId Name or id of the newly created cache.
 * @param {object=} options Options object that specifies the cache behavior. Properties:
 *
 *   - `{number=}` `capacity` — turns the cache into LRU cache.
 *
 * @returns {object} Newly created cache object with the following set of methods:
 *
 * - `{object}` `info()` — Returns id, size, and options of cache.
 * - `{{*}}` `put({string} key, {*} value)` — Puts a new key-value pair into the cache and returns
 *   it.
 * - `{{*}}` `get({string} key)` — Returns cached value for `key` or undefined for cache miss.
 * - `{void}` `remove({string} key)` — Removes a key-value pair from the cache.
 * - `{void}` `removeAll()` — Removes all cached values.
 * - `{void}` `destroy()` — Removes references to this cache from $cacheFactory.
 *
 * @example
   <example module="cacheExampleApp" name="cache-factory">
     <file name="index.html">
       <div ng-controller="CacheController">
         <input ng-model="newCacheKey" placeholder="Key">
         <input ng-model="newCacheValue" placeholder="Value">
         <button ng-click="put(newCacheKey, newCacheValue)">Cache</button>

         <p ng-if="keys.length">Cached Values</p>
         <div ng-repeat="key in keys">
           <span ng-bind="key"></span>
           <span>: </span>
           <b ng-bind="cache.get(key)"></b>
         </div>

         <p>Cache Info</p>
         <div ng-repeat="(key, value) in cache.info()">
           <span ng-bind="key"></span>
           <span>: </span>
           <b ng-bind="value"></b>
         </div>
       </div>
     </file>
     <file name="script.js">
       angular.module('cacheExampleApp', []).
         controller('CacheController', ['$scope', '$cacheFactory', function($scope, $cacheFactory) {
           $scope.keys = [];
           $scope.cache = $cacheFactory('cacheId');
           $scope.put = function(key, value) {
             if (angular.isUndefined($scope.cache.get(key))) {
               $scope.keys.push(key);
             }
             $scope.cache.put(key, angular.isUndefined(value) ? null : value);
           };
         }]);
     </file>
     <file name="style.css">
       p {
         margin: 10px 0 3px;
       }
     </file>
   </example>
 */
function $CacheFactoryProvider() {

  this.$get = function() {
    var caches = {};

    function cacheFactory(cacheId, options) {
      if (cacheId in caches) {
        throw minErr('$cacheFactory')('iid', 'CacheId \'{0}\' is already taken!', cacheId);
      }

      var size = 0,
          stats = extend({}, options, {id: cacheId}),
          data = createMap(),
          capacity = (options && options.capacity) || Number.MAX_VALUE,
          lruHash = createMap(),
          freshEnd = null,
          staleEnd = null;

      /**
       * @ngdoc type
       * @name $cacheFactory.Cache
       *
       * @description
       * A cache object used to store and retrieve data, primarily used by
       * {@link $templateRequest $templateRequest} and the {@link ng.directive:script script}
       * directive to cache templates and other data.
       *
       * ```js
       *  angular.module('superCache')
       *    .factory('superCache', ['$cacheFactory', function($cacheFactory) {
       *      return $cacheFactory('super-cache');
       *    }]);
       * ```
       *
       * Example test:
       *
       * ```js
       *  it('should behave like a cache', inject(function(superCache) {
       *    superCache.put('key', 'value');
       *    superCache.put('another key', 'another value');
       *
       *    expect(superCache.info()).toEqual({
       *      id: 'super-cache',
       *      size: 2
       *    });
       *
       *    superCache.remove('another key');
       *    expect(superCache.get('another key')).toBeUndefined();
       *
       *    superCache.removeAll();
       *    expect(superCache.info()).toEqual({
       *      id: 'super-cache',
       *      size: 0
       *    });
       *  }));
       * ```
       */
      return (caches[cacheId] = {

        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#put
         * @kind function
         *
         * @description
         * Inserts a named entry into the {@link $cacheFactory.Cache Cache} object to be
         * retrieved later, and incrementing the size of the cache if the key was not already
         * present in the cache. If behaving like an LRU cache, it will also remove stale
         * entries from the set.
         *
         * It will not insert undefined values into the cache.
         *
         * @param {string} key the key under which the cached data is stored.
         * @param {*} value the value to store alongside the key. If it is undefined, the key
         *    will not be stored.
         * @returns {*} the value stored.
         */
        put: function(key, value) {
          if (isUndefined(value)) return;
          if (capacity < Number.MAX_VALUE) {
            var lruEntry = lruHash[key] || (lruHash[key] = {key: key});

            refresh(lruEntry);
          }

          if (!(key in data)) size++;
          data[key] = value;

          if (size > capacity) {
            this.remove(staleEnd.key);
          }

          return value;
        },

        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#get
         * @kind function
         *
         * @description
         * Retrieves named data stored in the {@link $cacheFactory.Cache Cache} object.
         *
         * @param {string} key the key of the data to be retrieved
         * @returns {*} the value stored.
         */
        get: function(key) {
          if (capacity < Number.MAX_VALUE) {
            var lruEntry = lruHash[key];

            if (!lruEntry) return;

            refresh(lruEntry);
          }

          return data[key];
        },


        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#remove
         * @kind function
         *
         * @description
         * Removes an entry from the {@link $cacheFactory.Cache Cache} object.
         *
         * @param {string} key the key of the entry to be removed
         */
        remove: function(key) {
          if (capacity < Number.MAX_VALUE) {
            var lruEntry = lruHash[key];

            if (!lruEntry) return;

            if (lruEntry === freshEnd) freshEnd = lruEntry.p;
            if (lruEntry === staleEnd) staleEnd = lruEntry.n;
            link(lruEntry.n,lruEntry.p);

            delete lruHash[key];
          }

          if (!(key in data)) return;

          delete data[key];
          size--;
        },


        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#removeAll
         * @kind function
         *
         * @description
         * Clears the cache object of any entries.
         */
        removeAll: function() {
          data = createMap();
          size = 0;
          lruHash = createMap();
          freshEnd = staleEnd = null;
        },


        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#destroy
         * @kind function
         *
         * @description
         * Destroys the {@link $cacheFactory.Cache Cache} object entirely,
         * removing it from the {@link $cacheFactory $cacheFactory} set.
         */
        destroy: function() {
          data = null;
          stats = null;
          lruHash = null;
          delete caches[cacheId];
        },


        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#info
         * @kind function
         *
         * @description
         * Retrieve information regarding a particular {@link $cacheFactory.Cache Cache}.
         *
         * @returns {object} an object with the following properties:
         *   <ul>
         *     <li>**id**: the id of the cache instance</li>
         *     <li>**size**: the number of entries kept in the cache instance</li>
         *     <li>**...**: any additional properties from the options object when creating the
         *       cache.</li>
         *   </ul>
         */
        info: function() {
          return extend({}, stats, {size: size});
        }
      });


      /**
       * makes the `entry` the freshEnd of the LRU linked list
       */
      function refresh(entry) {
        if (entry !== freshEnd) {
          if (!staleEnd) {
            staleEnd = entry;
          } else if (staleEnd === entry) {
            staleEnd = entry.n;
          }

          link(entry.n, entry.p);
          link(entry, freshEnd);
          freshEnd = entry;
          freshEnd.n = null;
        }
      }


      /**
       * bidirectionally links two entries of the LRU linked list
       */
      function link(nextEntry, prevEntry) {
        if (nextEntry !== prevEntry) {
          if (nextEntry) nextEntry.p = prevEntry; //p stands for previous, 'prev' didn't minify
          if (prevEntry) prevEntry.n = nextEntry; //n stands for next, 'next' didn't minify
        }
      }
    }


  /**
   * @ngdoc method
   * @name $cacheFactory#info
   *
   * @description
   * Get information about all the caches that have been created
   *
   * @returns {Object} - key-value map of `cacheId` to the result of calling `cache#info`
   */
    cacheFactory.info = function() {
      var info = {};
      forEach(caches, function(cache, cacheId) {
        info[cacheId] = cache.info();
      });
      return info;
    };


  /**
   * @ngdoc method
   * @name $cacheFactory#get
   *
   * @description
   * Get access to a cache object by the `cacheId` used when it was created.
   *
   * @param {string} cacheId Name or id of a cache to access.
   * @returns {object} Cache object identified by the cacheId or undefined if no such cache.
   */
    cacheFactory.get = function(cacheId) {
      return caches[cacheId];
    };


    return cacheFactory;
  };
}

/**
 * @ngdoc service
 * @name $templateCache
 * @this
 *
 * @description
 * `$templateCache` is a {@link $cacheFactory.Cache Cache object} created by the
 * {@link ng.$cacheFactory $cacheFactory}.
 *
 * The first time a template is used, it is loaded in the template cache for quick retrieval. You
 * can load templates directly into the cache in a `script` tag, by using {@link $templateRequest},
 * or by consuming the `$templateCache` service directly.
 *
 * Adding via the `script` tag:
 *
 * ```html
 *   <script type="text/ng-template" id="templateId.html">
 *     <p>This is the content of the template</p>
 *   </script>
 * ```
 *
 * **Note:** the `script` tag containing the template does not need to be included in the `head` of
 * the document, but it must be a descendent of the {@link ng.$rootElement $rootElement} (e.g.
 * element with {@link ngApp} attribute), otherwise the template will be ignored.
 *
 * Adding via the `$templateCache` service:
 *
 * ```js
 * var myApp = angular.module('myApp', []);
 * myApp.run(function($templateCache) {
 *   $templateCache.put('templateId.html', 'This is the content of the template');
 * });
 * ```
 *
 * To retrieve the template later, simply use it in your component:
 * ```js
 * myApp.component('myComponent', {
 *    templateUrl: 'templateId.html'
 * });
 * ```
 *
 * or get it via the `$templateCache` service:
 * ```js
 * $templateCache.get('templateId.html')
 * ```
 *
 */
function $TemplateCacheProvider() {
  this.$get = ['$cacheFactory', function($cacheFactory) {
    return $cacheFactory('templates');
  }];
}

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables like document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

/* ! VARIABLE/FUNCTION NAMING CONVENTIONS THAT APPLY TO THIS FILE!
 *
 * DOM-related variables:
 *
 * - "node" - DOM Node
 * - "element" - DOM Element or Node
 * - "$node" or "$element" - jqLite-wrapped node or element
 *
 *
 * Compiler related stuff:
 *
 * - "linkFn" - linking fn of a single directive
 * - "nodeLinkFn" - function that aggregates all linking fns for a particular node
 * - "childLinkFn" -  function that aggregates all linking fns for child nodes of a particular node
 * - "compositeLinkFn" - function that aggregates all linking fns for a compilation root (nodeList)
 */


/**
 * @ngdoc service
 * @name $compile
 * @kind function
 *
 * @description
 * Compiles an HTML string or DOM into a template and produces a template function, which
 * can then be used to link {@link ng.$rootScope.Scope `scope`} and the template together.
 *
 * The compilation is a process of walking the DOM tree and matching DOM elements to
 * {@link ng.$compileProvider#directive directives}.
 *
 * <div class="alert alert-warning">
 * **Note:** This document is an in-depth reference of all directive options.
 * For a gentle introduction to directives with examples of common use cases,
 * see the {@link guide/directive directive guide}.
 * </div>
 *
 * ## Comprehensive Directive API
 *
 * There are many different options for a directive.
 *
 * The difference resides in the return value of the factory function.
 * You can either return a {@link $compile#directive-definition-object Directive Definition Object (see below)}
 * that defines the directive properties, or just the `postLink` function (all other properties will have
 * the default values).
 *
 * <div class="alert alert-success">
 * **Best Practice:** It's recommended to use the "directive definition object" form.
 * </div>
 *
 * Here's an example directive declared with a Directive Definition Object:
 *
 * ```js
 *   var myModule = angular.module(...);
 *
 *   myModule.directive('directiveName', function factory(injectables) {
 *     var directiveDefinitionObject = {
 *       {@link $compile#-priority- priority}: 0,
 *       {@link $compile#-template- template}: '<div></div>', // or // function(tElement, tAttrs) { ... },
 *       // or
 *       // {@link $compile#-templateurl- templateUrl}: 'directive.html', // or // function(tElement, tAttrs) { ... },
 *       {@link $compile#-transclude- transclude}: false,
 *       {@link $compile#-restrict- restrict}: 'A',
 *       {@link $compile#-templatenamespace- templateNamespace}: 'html',
 *       {@link $compile#-scope- scope}: false,
 *       {@link $compile#-controller- controller}: function($scope, $element, $attrs, $transclude, otherInjectables) { ... },
 *       {@link $compile#-controlleras- controllerAs}: 'stringIdentifier',
 *       {@link $compile#-bindtocontroller- bindToController}: false,
 *       {@link $compile#-require- require}: 'siblingDirectiveName', // or // ['^parentDirectiveName', '?optionalDirectiveName', '?^optionalParent'],
 *       {@link $compile#-multielement- multiElement}: false,
 *       {@link $compile#-compile- compile}: function compile(tElement, tAttrs, transclude) {
 *         return {
 *            {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
 *            {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
 *         }
 *         // or
 *         // return function postLink( ... ) { ... }
 *       },
 *       // or
 *       // {@link $compile#-link- link}: {
 *       //  {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
 *       //  {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
 *       // }
 *       // or
 *       // {@link $compile#-link- link}: function postLink( ... ) { ... }
 *     };
 *     return directiveDefinitionObject;
 *   });
 * ```
 *
 * <div class="alert alert-warning">
 * **Note:** Any unspecified options will use the default value. You can see the default values below.
 * </div>
 *
 * Therefore the above can be simplified as:
 *
 * ```js
 *   var myModule = angular.module(...);
 *
 *   myModule.directive('directiveName', function factory(injectables) {
 *     var directiveDefinitionObject = {
 *       link: function postLink(scope, iElement, iAttrs) { ... }
 *     };
 *     return directiveDefinitionObject;
 *     // or
 *     // return function postLink(scope, iElement, iAttrs) { ... }
 *   });
 * ```
 *
 * ### Life-cycle hooks
 * Directive controllers can provide the following methods that are called by AngularJS at points in the life-cycle of the
 * directive:
 * * `$onInit()` - Called on each controller after all the controllers on an element have been constructed and
 *   had their bindings initialized (and before the pre &amp; post linking functions for the directives on
 *   this element). This is a good place to put initialization code for your controller.
 * * `$onChanges(changesObj)` - Called whenever one-way (`<`) or interpolation (`@`) bindings are updated. The
 *   `changesObj` is a hash whose keys are the names of the bound properties that have changed, and the values are an
 *   object of the form `{ currentValue, previousValue, isFirstChange() }`. Use this hook to trigger updates within a
 *   component such as cloning the bound value to prevent accidental mutation of the outer value. Note that this will
 *   also be called when your bindings are initialized.
 * * `$doCheck()` - Called on each turn of the digest cycle. Provides an opportunity to detect and act on
 *   changes. Any actions that you wish to take in response to the changes that you detect must be
 *   invoked from this hook; implementing this has no effect on when `$onChanges` is called. For example, this hook
 *   could be useful if you wish to perform a deep equality check, or to check a Date object, changes to which would not
 *   be detected by AngularJS's change detector and thus not trigger `$onChanges`. This hook is invoked with no arguments;
 *   if detecting changes, you must store the previous value(s) for comparison to the current values.
 * * `$onDestroy()` - Called on a controller when its containing scope is destroyed. Use this hook for releasing
 *   external resources, watches and event handlers. Note that components have their `$onDestroy()` hooks called in
 *   the same order as the `$scope.$broadcast` events are triggered, which is top down. This means that parent
 *   components will have their `$onDestroy()` hook called before child components.
 * * `$postLink()` - Called after this controller's element and its children have been linked. Similar to the post-link
 *   function this hook can be used to set up DOM event handlers and do direct DOM manipulation.
 *   Note that child elements that contain `templateUrl` directives will not have been compiled and linked since
 *   they are waiting for their template to load asynchronously and their own compilation and linking has been
 *   suspended until that occurs.
 *
 * #### Comparison with life-cycle hooks in the new Angular
 * The new Angular also uses life-cycle hooks for its components. While the AngularJS life-cycle hooks are similar there are
 * some differences that you should be aware of, especially when it comes to moving your code from AngularJS to Angular:
 *
 * * AngularJS hooks are prefixed with `$`, such as `$onInit`. Angular hooks are prefixed with `ng`, such as `ngOnInit`.
 * * AngularJS hooks can be defined on the controller prototype or added to the controller inside its constructor.
 *   In Angular you can only define hooks on the prototype of the Component class.
 * * Due to the differences in change-detection, you may get many more calls to `$doCheck` in AngularJS than you would to
 *   `ngDoCheck` in Angular.
 * * Changes to the model inside `$doCheck` will trigger new turns of the digest loop, which will cause the changes to be
 *   propagated throughout the application.
 *   Angular does not allow the `ngDoCheck` hook to trigger a change outside of the component. It will either throw an
 *   error or do nothing depending upon the state of `enableProdMode()`.
 *
 * #### Life-cycle hook examples
 *
 * This example shows how you can check for mutations to a Date object even though the identity of the object
 * has not changed.
 *
 * <example name="doCheckDateExample" module="do-check-module">
 *   <file name="app.js">
 *     angular.module('do-check-module', [])
 *       .component('app', {
 *         template:
 *           'Month: <input ng-model="$ctrl.month" ng-change="$ctrl.updateDate()">' +
 *           'Date: {{ $ctrl.date }}' +
 *           '<test date="$ctrl.date"></test>',
 *         controller: function() {
 *           this.date = new Date();
 *           this.month = this.date.getMonth();
 *           this.updateDate = function() {
 *             this.date.setMonth(this.month);
 *           };
 *         }
 *       })
 *       .component('test', {
 *         bindings: { date: '<' },
 *         template:
 *           '<pre>{{ $ctrl.log | json }}</pre>',
 *         controller: function() {
 *           var previousValue;
 *           this.log = [];
 *           this.$doCheck = function() {
 *             var currentValue = this.date && this.date.valueOf();
 *             if (previousValue !== currentValue) {
 *               this.log.push('doCheck: date mutated: ' + this.date);
 *               previousValue = currentValue;
 *             }
 *           };
 *         }
 *       });
 *   </file>
 *   <file name="index.html">
 *     <app></app>
 *   </file>
 * </example>
 *
 * This example show how you might use `$doCheck` to trigger changes in your component's inputs even if the
 * actual identity of the component doesn't change. (Be aware that cloning and deep equality checks on large
 * arrays or objects can have a negative impact on your application performance.)
 *
 * <example name="doCheckArrayExample" module="do-check-module">
 *   <file name="index.html">
 *     <div ng-init="items = []">
 *       <button ng-click="items.push(items.length)">Add Item</button>
 *       <button ng-click="items = []">Reset Items</button>
 *       <pre>{{ items }}</pre>
 *       <test items="items"></test>
 *     </div>
 *   </file>
 *   <file name="app.js">
 *      angular.module('do-check-module', [])
 *        .component('test', {
 *          bindings: { items: '<' },
 *          template:
 *            '<pre>{{ $ctrl.log | json }}</pre>',
 *          controller: function() {
 *            this.log = [];
 *
 *            this.$doCheck = function() {
 *              if (this.items_ref !== this.items) {
 *                this.log.push('doCheck: items changed');
 *                this.items_ref = this.items;
 *              }
 *              if (!angular.equals(this.items_clone, this.items)) {
 *                this.log.push('doCheck: items mutated');
 *                this.items_clone = angular.copy(this.items);
 *              }
 *            };
 *          }
 *        });
 *   </file>
 * </example>
 *
 *
 * ### Directive Definition Object
 *
 * The directive definition object provides instructions to the {@link ng.$compile
 * compiler}. The attributes are:
 *
 * #### `multiElement`
 * When this property is set to true (default is `false`), the HTML compiler will collect DOM nodes between
 * nodes with the attributes `directive-name-start` and `directive-name-end`, and group them
 * together as the directive elements. It is recommended that this feature be used on directives
 * which are not strictly behavioral (such as {@link ngClick}), and which
 * do not manipulate or replace child nodes (such as {@link ngInclude}).
 *
 * #### `priority`
 * When there are multiple directives defined on a single DOM element, sometimes it
 * is necessary to specify the order in which the directives are applied. The `priority` is used
 * to sort the directives before their `compile` functions get called. Priority is defined as a
 * number. Directives with greater numerical `priority` are compiled first. Pre-link functions
 * are also run in priority order, but post-link functions are run in reverse order. The order
 * of directives with the same priority is undefined. The default priority is `0`.
 *
 * #### `terminal`
 * If set to true then the current `priority` will be the last set of directives
 * which will execute (any directives at the current priority will still execute
 * as the order of execution on same `priority` is undefined). Note that expressions
 * and other directives used in the directive's template will also be excluded from execution.
 *
 * #### `scope`
 * The scope property can be `false`, `true`, or an object:
 *
 * * **`false` (default):** No scope will be created for the directive. The directive will use its
 * parent's scope.
 *
 * * **`true`:** A new child scope that prototypically inherits from its parent will be created for
 * the directive's element. If multiple directives on the same element request a new scope,
 * only one new scope is created.
 *
 * * **`{...}` (an object hash):** A new "isolate" scope is created for the directive's template.
 * The 'isolate' scope differs from normal scope in that it does not prototypically
 * inherit from its parent scope. This is useful when creating reusable components, which should not
 * accidentally read or modify data in the parent scope. Note that an isolate scope
 * directive without a `template` or `templateUrl` will not apply the isolate scope
 * to its children elements.
 *
 * The 'isolate' scope object hash defines a set of local scope properties derived from attributes on the
 * directive's element. These local properties are useful for aliasing values for templates. The keys in
 * the object hash map to the name of the property on the isolate scope; the values define how the property
 * is bound to the parent scope, via matching attributes on the directive's element:
 *
 * * `@` or `@attr` - bind a local scope property to the value of DOM attribute. The result is
 *   always a string since DOM attributes are strings. If no `attr` name is specified then the
 *   attribute name is assumed to be the same as the local name. Given `<my-component
 *   my-attr="hello {{name}}">` and the isolate scope definition `scope: { localName:'@myAttr' }`,
 *   the directive's scope property `localName` will reflect the interpolated value of `hello
 *   {{name}}`. As the `name` attribute changes so will the `localName` property on the directive's
 *   scope. The `name` is read from the parent scope (not the directive's scope).
 *
 * * `=` or `=attr` - set up a bidirectional binding between a local scope property and an expression
 *   passed via the attribute `attr`. The expression is evaluated in the context of the parent scope.
 *   If no `attr` name is specified then the attribute name is assumed to be the same as the local
 *   name. Given `<my-component my-attr="parentModel">` and the isolate scope definition `scope: {
 *   localModel: '=myAttr' }`, the property `localModel` on the directive's scope will reflect the
 *   value of `parentModel` on the parent scope. Changes to `parentModel` will be reflected in
 *   `localModel` and vice versa. If the binding expression is non-assignable, or if the attribute
 *   isn't  optional and doesn't exist, an exception
 *   ({@link error/$compile/nonassign `$compile:nonassign`}) will be thrown upon discovering changes
 *   to the local value, since it will be impossible to sync them back to the parent scope.
 *
 *   By default, the {@link ng.$rootScope.Scope#$watch `$watch`}
 *   method is used for tracking changes, and the equality check is based on object identity.
 *   However, if an object literal or an array literal is passed as the binding expression, the
 *   equality check is done by value (using the {@link angular.equals} function). It's also possible
 *   to watch the evaluated value shallowly with {@link ng.$rootScope.Scope#$watchCollection
 *   `$watchCollection`}: use `=*` or `=*attr`
 *
  * * `<` or `<attr` - set up a one-way (one-directional) binding between a local scope property and an
 *   expression passed via the attribute `attr`. The expression is evaluated in the context of the
 *   parent scope. If no `attr` name is specified then the attribute name is assumed to be the same as the
 *   local name.
 *
 *   For example, given `<my-component my-attr="parentModel">` and directive definition of
 *   `scope: { localModel:'<myAttr' }`, then the isolated scope property `localModel` will reflect the
 *   value of `parentModel` on the parent scope. Any changes to `parentModel` will be reflected
 *   in `localModel`, but changes in `localModel` will not reflect in `parentModel`. There are however
 *   two caveats:
 *     1. one-way binding does not copy the value from the parent to the isolate scope, it simply
 *     sets the same value. That means if your bound value is an object, changes to its properties
 *     in the isolated scope will be reflected in the parent scope (because both reference the same object).
 *     2. one-way binding watches changes to the **identity** of the parent value. That means the
 *     {@link ng.$rootScope.Scope#$watch `$watch`} on the parent value only fires if the reference
 *     to the value has changed. In most cases, this should not be of concern, but can be important
 *     to know if you one-way bind to an object, and then replace that object in the isolated scope.
 *     If you now change a property of the object in your parent scope, the change will not be
 *     propagated to the isolated scope, because the identity of the object on the parent scope
 *     has not changed. Instead you must assign a new object.
 *
 *   One-way binding is useful if you do not plan to propagate changes to your isolated scope bindings
 *   back to the parent. However, it does not make this completely impossible.
 *
 *   By default, the {@link ng.$rootScope.Scope#$watch `$watch`}
 *   method is used for tracking changes, and the equality check is based on object identity.
 *   It's also possible to watch the evaluated value shallowly with
 *   {@link ng.$rootScope.Scope#$watchCollection `$watchCollection`}: use `<*` or `<*attr`
 *
 * * `&` or `&attr` - provides a way to execute an expression in the context of the parent scope. If
 *   no `attr` name is specified then the attribute name is assumed to be the same as the local name.
 *   Given `<my-component my-attr="count = count + value">` and the isolate scope definition `scope: {
 *   localFn:'&myAttr' }`, the isolate scope property `localFn` will point to a function wrapper for
 *   the `count = count + value` expression. Often it's desirable to pass data from the isolated scope
 *   via an expression to the parent scope. This can be done by passing a map of local variable names
 *   and values into the expression wrapper fn. For example, if the expression is `increment(amount)`
 *   then we can specify the amount value by calling the `localFn` as `localFn({amount: 22})`.
 *
 * All 4 kinds of bindings (`@`, `=`, `<`, and `&`) can be made optional by adding `?` to the expression.
 * The marker must come after the mode and before the attribute name.
 * See the {@link error/$compile/iscp Invalid Isolate Scope Definition error} for definition examples.
 * This is useful to refine the interface directives provide.
 * One subtle difference between optional and non-optional happens **when the binding attribute is not
 * set**:
 * - the binding is optional: the property will not be defined
 * - the binding is not optional: the property is defined
 *
 * ```js
 *app.directive('testDir', function() {
    return {
      scope: {
        notoptional: '=',
        optional: '=?',
      },
      bindToController: true,
      controller: function() {
        this.$onInit = function() {
          console.log(this.hasOwnProperty('notoptional')) // true
          console.log(this.hasOwnProperty('optional')) // false
        }
      }
    }
  })
 *```
 *
 *
 * ##### Combining directives with different scope defintions
 *
 * In general it's possible to apply more than one directive to one element, but there might be limitations
 * depending on the type of scope required by the directives. The following points will help explain these limitations.
 * For simplicity only two directives are taken into account, but it is also applicable for several directives:
 *
 * * **no scope** + **no scope** => Two directives which don't require their own scope will use their parent's scope
 * * **child scope** + **no scope** =>  Both directives will share one single child scope
 * * **child scope** + **child scope** =>  Both directives will share one single child scope
 * * **isolated scope** + **no scope** =>  The isolated directive will use it's own created isolated scope. The other directive will use
 * its parent's scope
 * * **isolated scope** + **child scope** =>  **Won't work!** Only one scope can be related to one element. Therefore these directives cannot
 * be applied to the same element.
 * * **isolated scope** + **isolated scope**  =>  **Won't work!** Only one scope can be related to one element. Therefore these directives
 * cannot be applied to the same element.
 *
 *
 * #### `bindToController`
 * This property is used to bind scope properties directly to the controller. It can be either
 * `true` or an object hash with the same format as the `scope` property.
 *
 * When an isolate scope is used for a directive (see above), `bindToController: true` will
 * allow a component to have its properties bound to the controller, rather than to scope.
 *
 * After the controller is instantiated, the initial values of the isolate scope bindings will be bound to the controller
 * properties. You can access these bindings once they have been initialized by providing a controller method called
 * `$onInit`, which is called after all the controllers on an element have been constructed and had their bindings
 * initialized.
 *
 * It is also possible to set `bindToController` to an object hash with the same format as the `scope` property.
 * This will set up the scope bindings to the controller directly. Note that `scope` can still be used
 * to define which kind of scope is created. By default, no scope is created. Use `scope: {}` to create an isolate
 * scope (useful for component directives).
 *
 * If both `bindToController` and `scope` are defined and have object hashes, `bindToController` overrides `scope`.
 *
 *
 * #### `controller`
 * Controller constructor function. The controller is instantiated before the
 * pre-linking phase and can be accessed by other directives (see
 * `require` attribute). This allows the directives to communicate with each other and augment
 * each other's behavior. The controller is injectable (and supports bracket notation) with the following locals:
 *
 * * `$scope` - Current scope associated with the element
 * * `$element` - Current element
 * * `$attrs` - Current attributes object for the element
 * * `$transclude` - A transclude linking function pre-bound to the correct transclusion scope:
 *   `function([scope], cloneLinkingFn, futureParentElement, slotName)`:
 *    * `scope`: (optional) override the scope.
 *    * `cloneLinkingFn`: (optional) argument to create clones of the original transcluded content.
 *    * `futureParentElement` (optional):
 *        * defines the parent to which the `cloneLinkingFn` will add the cloned elements.
 *        * default: `$element.parent()` resp. `$element` for `transclude:'element'` resp. `transclude:true`.
 *        * only needed for transcludes that are allowed to contain non html elements (e.g. SVG elements)
 *          and when the `cloneLinkingFn` is passed,
 *          as those elements need to created and cloned in a special way when they are defined outside their
 *          usual containers (e.g. like `<svg>`).
 *        * See also the `directive.templateNamespace` property.
 *    * `slotName`: (optional) the name of the slot to transclude. If falsy (e.g. `null`, `undefined` or `''`)
 *      then the default transclusion is provided.
 *    The `$transclude` function also has a method on it, `$transclude.isSlotFilled(slotName)`, which returns
 *    `true` if the specified slot contains content (i.e. one or more DOM nodes).
 *
 * #### `require`
 * Require another directive and inject its controller as the fourth argument to the linking function. The
 * `require` property can be a string, an array or an object:
 * * a **string** containing the name of the directive to pass to the linking function
 * * an **array** containing the names of directives to pass to the linking function. The argument passed to the
 * linking function will be an array of controllers in the same order as the names in the `require` property
 * * an **object** whose property values are the names of the directives to pass to the linking function. The argument
 * passed to the linking function will also be an object with matching keys, whose values will hold the corresponding
 * controllers.
 *
 * If the `require` property is an object and `bindToController` is truthy, then the required controllers are
 * bound to the controller using the keys of the `require` property. This binding occurs after all the controllers
 * have been constructed but before `$onInit` is called.
 * If the name of the required controller is the same as the local name (the key), the name can be
 * omitted. For example, `{parentDir: '^^'}` is equivalent to `{parentDir: '^^parentDir'}`.
 * See the {@link $compileProvider#component} helper for an example of how this can be used.
 * If no such required directive(s) can be found, or if the directive does not have a controller, then an error is
 * raised (unless no link function is specified and the required controllers are not being bound to the directive
 * controller, in which case error checking is skipped). The name can be prefixed with:
 *
 * * (no prefix) - Locate the required controller on the current element. Throw an error if not found.
 * * `?` - Attempt to locate the required controller or pass `null` to the `link` fn if not found.
 * * `^` - Locate the required controller by searching the element and its parents. Throw an error if not found.
 * * `^^` - Locate the required controller by searching the element's parents. Throw an error if not found.
 * * `?^` - Attempt to locate the required controller by searching the element and its parents or pass
 *   `null` to the `link` fn if not found.
 * * `?^^` - Attempt to locate the required controller by searching the element's parents, or pass
 *   `null` to the `link` fn if not found.
 *
 *
 * #### `controllerAs`
 * Identifier name for a reference to the controller in the directive's scope.
 * This allows the controller to be referenced from the directive template. This is especially
 * useful when a directive is used as component, i.e. with an `isolate` scope. It's also possible
 * to use it in a directive without an `isolate` / `new` scope, but you need to be aware that the
 * `controllerAs` reference might overwrite a property that already exists on the parent scope.
 *
 *
 * #### `restrict`
 * String of subset of `EACM` which restricts the directive to a specific directive
 * declaration style. If omitted, the defaults (elements and attributes) are used.
 *
 * * `E` - Element name (default): `<my-directive></my-directive>`
 * * `A` - Attribute (default): `<div my-directive="exp"></div>`
 * * `C` - Class: `<div class="my-directive: exp;"></div>`
 * * `M` - Comment: `<!-- directive: my-directive exp -->`
 *
 *
 * #### `templateNamespace`
 * String representing the document type used by the markup in the template.
 * AngularJS needs this information as those elements need to be created and cloned
 * in a special way when they are defined outside their usual containers like `<svg>` and `<math>`.
 *
 * * `html` - All root nodes in the template are HTML. Root nodes may also be
 *   top-level elements such as `<svg>` or `<math>`.
 * * `svg` - The root nodes in the template are SVG elements (excluding `<math>`).
 * * `math` - The root nodes in the template are MathML elements (excluding `<svg>`).
 *
 * If no `templateNamespace` is specified, then the namespace is considered to be `html`.
 *
 * #### `template`
 * HTML markup that may:
 * * Replace the contents of the directive's element (default).
 * * Replace the directive's element itself (if `replace` is true - DEPRECATED).
 * * Wrap the contents of the directive's element (if `transclude` is true).
 *
 * Value may be:
 *
 * * A string. For example `<div red-on-hover>{{delete_str}}</div>`.
 * * A function which takes two arguments `tElement` and `tAttrs` (described in the `compile`
 *   function api below) and returns a string value.
 *
 *
 * #### `templateUrl`
 * This is similar to `template` but the template is loaded from the specified URL, asynchronously.
 *
 * Because template loading is asynchronous the compiler will suspend compilation of directives on that element
 * for later when the template has been resolved.  In the meantime it will continue to compile and link
 * sibling and parent elements as though this element had not contained any directives.
 *
 * The compiler does not suspend the entire compilation to wait for templates to be loaded because this
 * would result in the whole app "stalling" until all templates are loaded asynchronously - even in the
 * case when only one deeply nested directive has `templateUrl`.
 *
 * Template loading is asynchronous even if the template has been preloaded into the {@link $templateCache}.
 *
 * You can specify `templateUrl` as a string representing the URL or as a function which takes two
 * arguments `tElement` and `tAttrs` (described in the `compile` function api below) and returns
 * a string value representing the url.  In either case, the template URL is passed through {@link
 * $sce#getTrustedResourceUrl $sce.getTrustedResourceUrl}.
 *
 *
 * #### `replace`
 * <div class="alert alert-danger">
 * **Note:** `replace` is deprecated in AngularJS and has been removed in the new Angular (v2+).
 * </div>
 *
 * Specifies what the template should replace. Defaults to `false`.
 *
 * * `true` - the template will replace the directive's element.
 * * `false` - the template will replace the contents of the directive's element.
 *
 * The replacement process migrates all of the attributes / classes from the old element to the new
 * one. See the {@link guide/directive#template-expanding-directive
 * Directives Guide} for an example.
 *
 * There are very few scenarios where element replacement is required for the application function,
 * the main one being reusable custom components that are used within SVG contexts
 * (because SVG doesn't work with custom elements in the DOM tree).
 *
 * #### `transclude`
 * Extract the contents of the element where the directive appears and make it available to the directive.
 * The contents are compiled and provided to the directive as a **transclusion function**. See the
 * {@link $compile#transclusion Transclusion} section below.
 *
 *
 * #### `compile`
 *
 * ```js
 *   function compile(tElement, tAttrs, transclude) { ... }
 * ```
 *
 * The compile function deals with transforming the template DOM. Since most directives do not do
 * template transformation, it is not used often. The compile function takes the following arguments:
 *
 *   * `tElement` - template element - The element where the directive has been declared. It is
 *     safe to do template transformation on the element and child elements only.
 *
 *   * `tAttrs` - template attributes - Normalized list of attributes declared on this element shared
 *     between all directive compile functions.
 *
 *   * `transclude` -  [*DEPRECATED*!] A transclude linking function: `function(scope, cloneLinkingFn)`
 *
 * <div class="alert alert-warning">
 * **Note:** The template instance and the link instance may be different objects if the template has
 * been cloned. For this reason it is **not** safe to do anything other than DOM transformations that
 * apply to all cloned DOM nodes within the compile function. Specifically, DOM listener registration
 * should be done in a linking function rather than in a compile function.
 * </div>

 * <div class="alert alert-warning">
 * **Note:** The compile function cannot handle directives that recursively use themselves in their
 * own templates or compile functions. Compiling these directives results in an infinite loop and
 * stack overflow errors.
 *
 * This can be avoided by manually using `$compile` in the postLink function to imperatively compile
 * a directive's template instead of relying on automatic template compilation via `template` or
 * `templateUrl` declaration or manual compilation inside the compile function.
 * </div>
 *
 * <div class="alert alert-danger">
 * **Note:** The `transclude` function that is passed to the compile function is deprecated, as it
 *   e.g. does not know about the right outer scope. Please use the transclude function that is passed
 *   to the link function instead.
 * </div>

 * A compile function can have a return value which can be either a function or an object.
 *
 * * returning a (post-link) function - is equivalent to registering the linking function via the
 *   `link` property of the config object when the compile function is empty.
 *
 * * returning an object with function(s) registered via `pre` and `post` properties - allows you to
 *   control when a linking function should be called during the linking phase. See info about
 *   pre-linking and post-linking functions below.
 *
 *
 * #### `link`
 * This property is used only if the `compile` property is not defined.
 *
 * ```js
 *   function link(scope, iElement, iAttrs, controller, transcludeFn) { ... }
 * ```
 *
 * The link function is responsible for registering DOM listeners as well as updating the DOM. It is
 * executed after the template has been cloned. This is where most of the directive logic will be
 * put.
 *
 *   * `scope` - {@link ng.$rootScope.Scope Scope} - The scope to be used by the
 *     directive for registering {@link ng.$rootScope.Scope#$watch watches}.
 *
 *   * `iElement` - instance element - The element where the directive is to be used. It is safe to
 *     manipulate the children of the element only in `postLink` function since the children have
 *     already been linked.
 *
 *   * `iAttrs` - instance attributes - Normalized list of attributes declared on this element shared
 *     between all directive linking functions.
 *
 *   * `controller` - the directive's required controller instance(s) - Instances are shared
 *     among all directives, which allows the directives to use the controllers as a communication
 *     channel. The exact value depends on the directive's `require` property:
 *       * no controller(s) required: the directive's own controller, or `undefined` if it doesn't have one
 *       * `string`: the controller instance
 *       * `array`: array of controller instances
 *
 *     If a required controller cannot be found, and it is optional, the instance is `null`,
 *     otherwise the {@link error:$compile:ctreq Missing Required Controller} error is thrown.
 *
 *     Note that you can also require the directive's own controller - it will be made available like
 *     any other controller.
 *
 *   * `transcludeFn` - A transclude linking function pre-bound to the correct transclusion scope.
 *     This is the same as the `$transclude` parameter of directive controllers,
 *     see {@link ng.$compile#-controller- the controller section for details}.
 *     `function([scope], cloneLinkingFn, futureParentElement)`.
 *
 * #### Pre-linking function
 *
 * Executed before the child elements are linked. Not safe to do DOM transformation since the
 * compiler linking function will fail to locate the correct elements for linking.
 *
 * #### Post-linking function
 *
 * Executed after the child elements are linked.
 *
 * Note that child elements that contain `templateUrl` directives will not have been compiled
 * and linked since they are waiting for their template to load asynchronously and their own
 * compilation and linking has been suspended until that occurs.
 *
 * It is safe to do DOM transformation in the post-linking function on elements that are not waiting
 * for their async templates to be resolved.
 *
 *
 * ### Transclusion
 *
 * Transclusion is the process of extracting a collection of DOM elements from one part of the DOM and
 * copying them to another part of the DOM, while maintaining their connection to the original AngularJS
 * scope from where they were taken.
 *
 * Transclusion is used (often with {@link ngTransclude}) to insert the
 * original contents of a directive's element into a specified place in the template of the directive.
 * The benefit of transclusion, over simply moving the DOM elements manually, is that the transcluded
 * content has access to the properties on the scope from which it was taken, even if the directive
 * has isolated scope.
 * See the {@link guide/directive#creating-a-directive-that-wraps-other-elements Directives Guide}.
 *
 * This makes it possible for the widget to have private state for its template, while the transcluded
 * content has access to its originating scope.
 *
 * <div class="alert alert-warning">
 * **Note:** When testing an element transclude directive you must not place the directive at the root of the
 * DOM fragment that is being compiled. See {@link guide/unit-testing#testing-transclusion-directives
 * Testing Transclusion Directives}.
 * </div>
 *
 * There are three kinds of transclusion depending upon whether you want to transclude just the contents of the
 * directive's element, the entire element or multiple parts of the element contents:
 *
 * * `true` - transclude the content (i.e. the child nodes) of the directive's element.
 * * `'element'` - transclude the whole of the directive's element including any directives on this
 *   element that are defined at a lower priority than this directive. When used, the `template`
 *   property is ignored.
 * * **`{...}` (an object hash):** - map elements of the content onto transclusion "slots" in the template.
 *
 * **Multi-slot transclusion** is declared by providing an object for the `transclude` property.
 *
 * This object is a map where the keys are the name of the slot to fill and the value is an element selector
 * used to match the HTML to the slot. The element selector should be in normalized form (e.g. `myElement`)
 * and will match the standard element variants (e.g. `my-element`, `my:element`, `data-my-element`, etc).
 *
 * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}.
 *
 * If the element selector is prefixed with a `?` then that slot is optional.
 *
 * For example, the transclude object `{ slotA: '?myCustomElement' }` maps `<my-custom-element>` elements to
 * the `slotA` slot, which can be accessed via the `$transclude` function or via the {@link ngTransclude} directive.
 *
 * Slots that are not marked as optional (`?`) will trigger a compile time error if there are no matching elements
 * in the transclude content. If you wish to know if an optional slot was filled with content, then you can call
 * `$transclude.isSlotFilled(slotName)` on the transclude function passed to the directive's link function and
 * injectable into the directive's controller.
 *
 *
 * #### Transclusion Functions
 *
 * When a directive requests transclusion, the compiler extracts its contents and provides a **transclusion
 * function** to the directive's `link` function and `controller`. This transclusion function is a special
 * **linking function** that will return the compiled contents linked to a new transclusion scope.
 *
 * <div class="alert alert-info">
 * If you are just using {@link ngTransclude} then you don't need to worry about this function, since
 * ngTransclude will deal with it for us.
 * </div>
 *
 * If you want to manually control the insertion and removal of the transcluded content in your directive
 * then you must use this transclude function. When you call a transclude function it returns a jqLite/JQuery
 * object that contains the compiled DOM, which is linked to the correct transclusion scope.
 *
 * When you call a transclusion function you can pass in a **clone attach function**. This function accepts
 * two parameters, `function(clone, scope) { ... }`, where the `clone` is a fresh compiled copy of your transcluded
 * content and the `scope` is the newly created transclusion scope, which the clone will be linked to.
 *
 * <div class="alert alert-info">
 * **Best Practice**: Always provide a `cloneFn` (clone attach function) when you call a transclude function
 * since you then get a fresh clone of the original DOM and also have access to the new transclusion scope.
 * </div>
 *
 * It is normal practice to attach your transcluded content (`clone`) to the DOM inside your **clone
 * attach function**:
 *
 * ```js
 * var transcludedContent, transclusionScope;
 *
 * $transclude(function(clone, scope) {
 *   element.append(clone);
 *   transcludedContent = clone;
 *   transclusionScope = scope;
 * });
 * ```
 *
 * Later, if you want to remove the transcluded content from your DOM then you should also destroy the
 * associated transclusion scope:
 *
 * ```js
 * transcludedContent.remove();
 * transclusionScope.$destroy();
 * ```
 *
 * <div class="alert alert-info">
 * **Best Practice**: if you intend to add and remove transcluded content manually in your directive
 * (by calling the transclude function to get the DOM and calling `element.remove()` to remove it),
 * then you are also responsible for calling `$destroy` on the transclusion scope.
 * </div>
 *
 * The built-in DOM manipulation directives, such as {@link ngIf}, {@link ngSwitch} and {@link ngRepeat}
 * automatically destroy their transcluded clones as necessary so you do not need to worry about this if
 * you are simply using {@link ngTransclude} to inject the transclusion into your directive.
 *
 *
 * #### Transclusion Scopes
 *
 * When you call a transclude function it returns a DOM fragment that is pre-bound to a **transclusion
 * scope**. This scope is special, in that it is a child of the directive's scope (and so gets destroyed
 * when the directive's scope gets destroyed) but it inherits the properties of the scope from which it
 * was taken.
 *
 * For example consider a directive that uses transclusion and isolated scope. The DOM hierarchy might look
 * like this:
 *
 * ```html
 * <div ng-app>
 *   <div isolate>
 *     <div transclusion>
 *     </div>
 *   </div>
 * </div>
 * ```
 *
 * The `$parent` scope hierarchy will look like this:
 *
   ```
   - $rootScope
     - isolate
       - transclusion
   ```
 *
 * but the scopes will inherit prototypically from different scopes to their `$parent`.
 *
   ```
   - $rootScope
     - transclusion
   - isolate
   ```
 *
 *
 * ### Attributes
 *
 * The {@link ng.$compile.directive.Attributes Attributes} object - passed as a parameter in the
 * `link()` or `compile()` functions. It has a variety of uses.
 *
 * * *Accessing normalized attribute names:* Directives like `ngBind` can be expressed in many ways:
 *   `ng:bind`, `data-ng-bind`, or `x-ng-bind`. The attributes object allows for normalized access
 *   to the attributes.
 *
 * * *Directive inter-communication:* All directives share the same instance of the attributes
 *   object which allows the directives to use the attributes object as inter directive
 *   communication.
 *
 * * *Supports interpolation:* Interpolation attributes are assigned to the attribute object
 *   allowing other directives to read the interpolated value.
 *
 * * *Observing interpolated attributes:* Use `$observe` to observe the value changes of attributes
 *   that contain interpolation (e.g. `src="{{bar}}"`). Not only is this very efficient but it's also
 *   the only way to easily get the actual value because during the linking phase the interpolation
 *   hasn't been evaluated yet and so the value is at this time set to `undefined`.
 *
 * ```js
 * function linkingFn(scope, elm, attrs, ctrl) {
 *   // get the attribute value
 *   console.log(attrs.ngModel);
 *
 *   // change the attribute
 *   attrs.$set('ngModel', 'new value');
 *
 *   // observe changes to interpolated attribute
 *   attrs.$observe('ngModel', function(value) {
 *     console.log('ngModel has changed value to ' + value);
 *   });
 * }
 * ```
 *
 * ## Example
 *
 * <div class="alert alert-warning">
 * **Note**: Typically directives are registered with `module.directive`. The example below is
 * to illustrate how `$compile` works.
 * </div>
 *
 <example module="compileExample" name="compile">
   <file name="index.html">
    <script>
      angular.module('compileExample', [], function($compileProvider) {
        // Configure new 'compile' directive by passing a directive
        // factory function. The factory function injects '$compile'.
        $compileProvider.directive('compile', function($compile) {
          // The directive factory creates a link function.
          return function(scope, element, attrs) {
            scope.$watch(
              function(scope) {
                // Watch the 'compile' expression for changes.
                return scope.$eval(attrs.compile);
              },
              function(value) {
                // When the 'compile' expression changes
                // assign it into the current DOM.
                element.html(value);

                // Compile the new DOM and link it to the current scope.
                // NOTE: we only compile '.childNodes' so that we
                // don't get into an infinite loop compiling ourselves.
                $compile(element.contents())(scope);
              }
            );
          };
        });
      })
      .controller('GreeterController', ['$scope', function($scope) {
        $scope.name = 'AngularJS';
        $scope.html = 'Hello {{name}}';
      }]);
    </script>
    <div ng-controller="GreeterController">
      <input ng-model="name"> <br/>
      <textarea ng-model="html"></textarea> <br/>
      <div compile="html"></div>
    </div>
   </file>
   <file name="protractor.js" type="protractor">
     it('should auto compile', function() {
       var textarea = $('textarea');
       var output = $('div[compile]');
       // The initial state reads 'Hello AngularJS'.
       expect(output.getText()).toBe('Hello AngularJS');
       textarea.clear();
       textarea.sendKeys('{{name}}!');
       expect(output.getText()).toBe('AngularJS!');
     });
   </file>
 </example>

 *
 *
 * @param {string|DOMElement} element Element or HTML string to compile into a template function.
 * @param {function(angular.Scope, cloneAttachFn=)} transclude function available to directives - DEPRECATED.
 *
 * <div class="alert alert-danger">
 * **Note:** Passing a `transclude` function to the $compile function is deprecated, as it
 *   e.g. will not use the right outer scope. Please pass the transclude function as a
 *   `parentBoundTranscludeFn` to the link function instead.
 * </div>
 *
 * @param {number} maxPriority only apply directives lower than given priority (Only effects the
 *                 root element(s), not their children)
 * @returns {function(scope, cloneAttachFn=, options=)} a link function which is used to bind template
 * (a DOM element/tree) to a scope. Where:
 *
 *  * `scope` - A {@link ng.$rootScope.Scope Scope} to bind to.
 *  * `cloneAttachFn` - If `cloneAttachFn` is provided, then the link function will clone the
 *  `template` and call the `cloneAttachFn` function allowing the caller to attach the
 *  cloned elements to the DOM document at the appropriate place. The `cloneAttachFn` is
 *  called as: <br/> `cloneAttachFn(clonedElement, scope)` where:
 *
 *      * `clonedElement` - is a clone of the original `element` passed into the compiler.
 *      * `scope` - is the current scope with which the linking function is working with.
 *
 *  * `options` - An optional object hash with linking options. If `options` is provided, then the following
 *  keys may be used to control linking behavior:
 *
 *      * `parentBoundTranscludeFn` - the transclude function made available to
 *        directives; if given, it will be passed through to the link functions of
 *        directives found in `element` during compilation.
 *      * `transcludeControllers` - an object hash with keys that map controller names
 *        to a hash with the key `instance`, which maps to the controller instance;
 *        if given, it will make the controllers available to directives on the compileNode:
 *        ```
 *        {
 *          parent: {
 *            instance: parentControllerInstance
 *          }
 *        }
 *        ```
 *      * `futureParentElement` - defines the parent to which the `cloneAttachFn` will add
 *        the cloned elements; only needed for transcludes that are allowed to contain non HTML
 *        elements (e.g. SVG elements). See also the `directive.controller` property.
 *
 * Calling the linking function returns the element of the template. It is either the original
 * element passed in, or the clone of the element if the `cloneAttachFn` is provided.
 *
 * After linking the view is not updated until after a call to `$digest`, which typically is done by
 * AngularJS automatically.
 *
 * If you need access to the bound view, there are two ways to do it:
 *
 * - If you are not asking the linking function to clone the template, create the DOM element(s)
 *   before you send them to the compiler and keep this reference around.
 *   ```js
 *     var element = angular.element('<p>{{total}}</p>');
 *     $compile(element)(scope);
 *   ```
 *
 * - if on the other hand, you need the element to be cloned, the view reference from the original
 *   example would not point to the clone, but rather to the original template that was cloned. In
 *   this case, you can access the clone either via the `cloneAttachFn` or the value returned by the
 *   linking function:
 *   ```js
 *     var templateElement = angular.element('<p>{{total}}</p>');
 *     var clonedElement = $compile(templateElement)(scope, function(clonedElement, scope) {
 *       // Attach the clone to DOM document at the right place.
 *     });
 *
 *     // Now we have reference to the cloned DOM via `clonedElement`.
 *     // NOTE: The `clonedElement` returned by the linking function is the same as the
 *     //       `clonedElement` passed to `cloneAttachFn`.
 *   ```
 *
 *
 * For information on how the compiler works, see the
 * {@link guide/compiler AngularJS HTML Compiler} section of the Developer Guide.
 *
 * @knownIssue
 *
 * ### Double Compilation
 *
   Double compilation occurs when an already compiled part of the DOM gets
   compiled again. This is an undesired effect and can lead to misbehaving directives, performance issues,
   and memory leaks. Refer to the Compiler Guide {@link guide/compiler#double-compilation-and-how-to-avoid-it
   section on double compilation} for an in-depth explanation and ways to avoid it.

 * @knownIssue

   ### Issues with `replace: true`
 *
 * <div class="alert alert-danger">
 *   **Note**: {@link $compile#-replace- `replace: true`} is deprecated and not recommended to use,
 *   mainly due to the issues listed here. It has been completely removed in the new Angular.
 * </div>
 *
 * #### Attribute values are not merged
 *
 * When a `replace` directive encounters the same attribute on the original and the replace node,
 * it will simply deduplicate the attribute and join the values with a space or with a `;` in case of
 * the `style` attribute.
 * ```html
 * Original Node: <span class="original" style="color: red;"></span>
 * Replace Template: <span class="replaced" style="background: blue;"></span>
 * Result: <span class="original replaced" style="color: red; background: blue;"></span>
 * ```
 *
 * That means attributes that contain AngularJS expressions will not be merged correctly, e.g.
 * {@link ngShow} or {@link ngClass} will cause a {@link $parse} error:
 *
 * ```html
 * Original Node: <span ng-class="{'something': something}" ng-show="!condition"></span>
 * Replace Template: <span ng-class="{'else': else}" ng-show="otherCondition"></span>
 * Result: <span ng-class="{'something': something} {'else': else}" ng-show="!condition otherCondition"></span>
 * ```
 *
 * See issue [#5695](https://github.com/angular/angular.js/issues/5695).
 *
 * #### Directives are not deduplicated before compilation
 *
 * When the original node and the replace template declare the same directive(s), they will be
 * {@link guide/compiler#double-compilation-and-how-to-avoid-it compiled twice} because the compiler
 * does not deduplicate them. In many cases, this is not noticeable, but e.g. {@link ngModel} will
 * attach `$formatters` and `$parsers` twice.
 *
 * See issue [#2573](https://github.com/angular/angular.js/issues/2573).
 *
 * #### `transclude: element` in the replace template root can have unexpected effects
 *
 * When the replace template has a directive at the root node that uses
 * {@link $compile#-transclude- `transclude: element`}, e.g.
 * {@link ngIf} or {@link ngRepeat}, the DOM structure or scope inheritance can be incorrect.
 * See the following issues:
 *
 * - Incorrect scope on replaced element:
 * [#9837](https://github.com/angular/angular.js/issues/9837)
 * - Different DOM between `template` and `templateUrl`:
 * [#10612](https://github.com/angular/angular.js/issues/14326)
 *
 */

/**
 * @ngdoc directive
 * @name ngProp
 * @restrict A
 * @element ANY
 *
 * @usage
 *
 * ```html
 * <ANY ng-prop-propname="expression">
 * </ANY>
 * ```
 *
 * or with uppercase letters in property (e.g. "propName"):
 *
 *
 * ```html
 * <ANY ng-prop-prop_name="expression">
 * </ANY>
 * ```
 *
 *
 * @description
 * The `ngProp` directive binds an expression to a DOM element property.
 * `ngProp` allows writing to arbitrary properties by including
 * the property name in the attribute, e.g. `ng-prop-value="'my value'"` binds 'my value' to
 * the `value` property.
 *
 * Usually, it's not necessary to write to properties in AngularJS, as the built-in directives
 * handle the most common use cases (instead of the above example, you would use {@link ngValue}).
 *
 * However, [custom elements](https://developer.mozilla.org/docs/Web/Web_Components/Using_custom_elements)
 * often use custom properties to hold data, and `ngProp` can be used to provide input to these
 * custom elements.
 *
 * ## Binding to camelCase properties
 *
 * Since HTML attributes are case-insensitive, camelCase properties like `innerHTML` must be escaped.
 * AngularJS uses the underscore (_) in front of a character to indicate that it is uppercase, so
 * `innerHTML`  must be written as `ng-prop-inner_h_t_m_l="expression"` (Note that this is just an
 * example, and for binding HTML {@link ngBindHtml} should be used.
 *
 * ## Security
 *
 * Binding expressions to arbitrary properties poses a security risk, as  properties like `innerHTML`
 * can insert potentially dangerous HTML into the application, e.g. script tags that execute
 * malicious code.
 * For this reason, `ngProp` applies Strict Contextual Escaping with the {@link ng.$sce $sce service}.
 * This means vulnerable properties require their content to be "trusted", based on the
 * context of the property. For example, the `innerHTML` is in the `HTML` context, and the
 * `iframe.src` property is in the `RESOURCE_URL` context, which requires that values written to
 * this property are trusted as a `RESOURCE_URL`.
 *
 * This can be set explicitly by calling $sce.trustAs(type, value) on the value that is
 * trusted before passing it to the `ng-prop-*` directive. There are exist shorthand methods for
 * each context type in the form of {@link ng.$sce#trustAsResourceUrl $sce.trustAsResourceUrl()} et al.
 *
 * In some cases you can also rely upon automatic sanitization of untrusted values - see below.
 *
 * Based on the context, other options may exist to mark a value as trusted / configure the behavior
 * of {@link ng.$sce}. For example, to restrict the `RESOURCE_URL` context to specific origins, use
 * the {@link $sceDelegateProvider#trustedResourceUrlList trustedResourceUrlList()}
 * and {@link $sceDelegateProvider#bannedResourceUrlList bannedResourceUrlList()}.
 *
 * {@link ng.$sce#what-trusted-context-types-are-supported- Find out more about the different context types}.
 *
 * ### HTML Sanitization
 *
 * By default, `$sce` will throw an error if it detects untrusted HTML content, and will not bind the
 * content.
 * However, if you include the {@link ngSanitize ngSanitize module}, it will try to sanitize the
 * potentially dangerous HTML, e.g. strip non-trusted tags and attributes when binding to
 * `innerHTML`.
 *
 * @example
 * ### Binding to different contexts
 *
 * <example name="ngProp" module="exampleNgProp">
 *   <file name="app.js">
 *     angular.module('exampleNgProp', [])
 *       .component('main', {
 *         templateUrl: 'main.html',
 *         controller: function($sce) {
 *           this.safeContent = '<strong>Safe content</strong>';
 *           this.unsafeContent = '<button onclick="alert(\'Hello XSS!\')">Click for XSS</button>';
 *           this.trustedUnsafeContent = $sce.trustAsHtml(this.unsafeContent);
 *         }
 *       });
 *   </file>
 *   <file name="main.html">
 *     <div>
 *       <div class="prop-unit">
 *         Binding to a property without security context:
 *         <div class="prop-binding" ng-prop-inner_text="$ctrl.safeContent"></div>
 *         <span class="prop-note">innerText</span> (safeContent)
 *       </div>
 *
 *       <div class="prop-unit">
 *         "Safe" content that requires a security context will throw because the contents could potentially be dangerous ...
 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.safeContent"></div>
 *         <span class="prop-note">innerHTML</span> (safeContent)
 *       </div>
 *
 *       <div class="prop-unit">
 *         ... so that actually dangerous content cannot be executed:
 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.unsafeContent"></div>
 *         <span class="prop-note">innerHTML</span> (unsafeContent)
 *       </div>
 *
 *       <div class="prop-unit">
 *         ... but unsafe Content that has been trusted explicitly works - only do this if you are 100% sure!
 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.trustedUnsafeContent"></div>
 *         <span class="prop-note">innerHTML</span> (trustedUnsafeContent)
 *       </div>
 *     </div>
 *   </file>
 *   <file name="index.html">
 *     <main></main>
 *   </file>
 *   <file name="styles.css">
 *     .prop-unit {
 *       margin-bottom: 10px;
 *     }
 *
 *     .prop-binding {
 *       min-height: 30px;
 *       border: 1px solid blue;
 *     }
 *
 *     .prop-note {
 *       font-family: Monospace;
 *     }
 *   </file>
 * </example>
 *
 *
 * @example
 * ### Binding to innerHTML with ngSanitize
 *
 * <example name="ngProp" module="exampleNgProp" deps="angular-sanitize.js">
 *   <file name="app.js">
 *     angular.module('exampleNgProp', ['ngSanitize'])
 *       .component('main', {
 *         templateUrl: 'main.html',
 *         controller: function($sce) {
 *           this.safeContent = '<strong>Safe content</strong>';
 *           this.unsafeContent = '<button onclick="alert(\'Hello XSS!\')">Click for XSS</button>';
 *           this.trustedUnsafeContent = $sce.trustAsHtml(this.unsafeContent);
 *         }
 *       });
 *   </file>
 *   <file name="main.html">
 *     <div>
 *       <div class="prop-unit">
 *         "Safe" content will be sanitized ...
 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.safeContent"></div>
 *         <span class="prop-note">innerHTML</span> (safeContent)
 *       </div>
 *
 *       <div class="prop-unit">
 *         ... as will dangerous content:
 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.unsafeContent"></div>
 *         <span class="prop-note">innerHTML</span> (unsafeContent)
 *       </div>
 *
 *       <div class="prop-unit">
 *         ... and content that has been trusted explicitly works the same as without ngSanitize:
 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.trustedUnsafeContent"></div>
 *         <span class="prop-note">innerHTML</span> (trustedUnsafeContent)
 *       </div>
 *     </div>
 *   </file>
 *   <file name="index.html">
 *     <main></main>
 *   </file>
 *   <file name="styles.css">
 *     .prop-unit {
 *       margin-bottom: 10px;
 *     }
 *
 *     .prop-binding {
 *       min-height: 30px;
 *       border: 1px solid blue;
 *     }
 *
 *     .prop-note {
 *       font-family: Monospace;
 *     }
 *   </file>
 * </example>
 *
 */

/** @ngdoc directive
 * @name ngOn
 * @restrict A
 * @element ANY
 *
 * @usage
 *
 * ```html
 * <ANY ng-on-eventname="expression">
 * </ANY>
 * ```
 *
 * or with uppercase letters in property (e.g. "eventName"):
 *
 *
 * ```html
 * <ANY ng-on-event_name="expression">
 * </ANY>
 * ```
 *
 * @description
 * The `ngOn` directive adds an event listener to a DOM element via
 * {@link angular.element angular.element().on()}, and evaluates an expression when the event is
 * fired.
 * `ngOn` allows adding listeners for arbitrary events by including
 * the event name in the attribute, e.g. `ng-on-drop="onDrop()"` executes the 'onDrop()' expression
 * when the `drop` event is fired.
 *
 * AngularJS provides specific directives for many events, such as {@link ngClick}, so in most
 * cases it is not necessary to use `ngOn`. However, AngularJS does not support all events
 * (e.g. the `drop` event in the example above), and new events might be introduced in later DOM
 * standards.
 *
 * Another use-case for `ngOn` is listening to
 * [custom events](https://developer.mozilla.org/docs/Web/Guide/Events/Creating_and_triggering_events)
 * fired by
 * [custom elements](https://developer.mozilla.org/docs/Web/Web_Components/Using_custom_elements).
 *
 * ## Binding to camelCase properties
 *
 * Since HTML attributes are case-insensitive, camelCase properties like `myEvent` must be escaped.
 * AngularJS uses the underscore (_) in front of a character to indicate that it is uppercase, so
 * `myEvent` must be written as `ng-on-my_event="expression"`.
 *
 * @example
 * ### Bind to built-in DOM events
 *
 * <example name="ngOn" module="exampleNgOn">
 *   <file name="app.js">
 *     angular.module('exampleNgOn', [])
 *       .component('main', {
 *         templateUrl: 'main.html',
 *         controller: function() {
 *           this.clickCount = 0;
 *           this.mouseoverCount = 0;
 *
 *           this.loadingState = 0;
 *         }
 *       });
 *   </file>
 *   <file name="main.html">
 *     <div>
 *       This is equivalent to `ngClick` and `ngMouseover`:<br>
 *       <button
 *         ng-on-click="$ctrl.clickCount = $ctrl.clickCount + 1"
 *         ng-on-mouseover="$ctrl.mouseoverCount = $ctrl.mouseoverCount + 1">Click or mouseover</button><br>
 *       clickCount: {{$ctrl.clickCount}}<br>
 *       mouseover: {{$ctrl.mouseoverCount}}
 *
 *       <hr>
 *
 *       For the `error` and `load` event on images no built-in AngularJS directives exist:<br>
 *       <img src="thisimagedoesnotexist.png" ng-on-error="$ctrl.loadingState = -1" ng-on-load="$ctrl.loadingState = 1"><br>
 *       <div ng-switch="$ctrl.loadingState">
 *         <span ng-switch-when="0">Image is loading</span>
 *         <span ng-switch-when="-1">Image load error</span>
 *         <span ng-switch-when="1">Image loaded successfully</span>
 *       </div>
 *     </div>
 *   </file>
 *   <file name="index.html">
 *     <main></main>
 *   </file>
 * </example>
 *
 *
 * @example
 * ### Bind to custom DOM events
 *
 * <example name="ngOnCustom" module="exampleNgOn">
 *   <file name="app.js">
 *     angular.module('exampleNgOn', [])
 *       .component('main', {
 *         templateUrl: 'main.html',
 *         controller: function() {
 *           this.eventLog = '';
 *
 *           this.listener = function($event) {
 *             this.eventLog = 'Event with type "' + $event.type + '" fired at ' + $event.detail;
 *           };
 *         }
 *       })
 *       .component('childComponent', {
 *         templateUrl: 'child.html',
 *         controller: function($element) {
 *           this.fireEvent = function() {
 *             var event = new CustomEvent('customtype', { detail: new Date()});
 *
 *             $element[0].dispatchEvent(event);
 *           };
 *         }
 *       });
 *   </file>
 *   <file name="main.html">
 *     <child-component ng-on-customtype="$ctrl.listener($event)"></child-component><br>
 *     <span>Event log: {{$ctrl.eventLog}}</span>
 *   </file>
 *   <file name="child.html">
      <button ng-click="$ctrl.fireEvent()">Fire custom event</button>
 *   </file>
 *   <file name="index.html">
 *     <main></main>
 *   </file>
 * </example>
 */

var $compileMinErr = minErr('$compile');

function UNINITIALIZED_VALUE() {}
var _UNINITIALIZED_VALUE = new UNINITIALIZED_VALUE();

/**
 * @ngdoc provider
 * @name $compileProvider
 *
 * @description
 */
$CompileProvider.$inject = ['$provide', '$$sanitizeUriProvider'];
/** @this */
function $CompileProvider($provide, $$sanitizeUriProvider) {
  var hasDirectives = {},
      Suffix = 'Directive',
      COMMENT_DIRECTIVE_REGEXP = /^\s*directive:\s*([\w-]+)\s+(.*)$/,
      CLASS_DIRECTIVE_REGEXP = /(([\w-]+)(?::([^;]+))?;?)/,
      ALL_OR_NOTHING_ATTRS = makeMap('ngSrc,ngSrcset,src,srcset'),
      REQUIRE_PREFIX_REGEXP = /^(?:(\^\^?)?(\?)?(\^\^?)?)?/;

  // Ref: http://developers.whatwg.org/webappapis.html#event-handler-idl-attributes
  // The assumption is that future DOM event attribute names will begin with
  // 'on' and be composed of only English letters.
  var EVENT_HANDLER_ATTR_REGEXP = /^(on[a-z]+|formaction)$/;
  var bindingCache = createMap();

  function parseIsolateBindings(scope, directiveName, isController) {
    var LOCAL_REGEXP = /^([@&]|[=<](\*?))(\??)\s*([\w$]*)$/;

    var bindings = createMap();

    forEach(scope, function(definition, scopeName) {
      definition = definition.trim();

      if (definition in bindingCache) {
        bindings[scopeName] = bindingCache[definition];
        return;
      }
      var match = definition.match(LOCAL_REGEXP);

      if (!match) {
        throw $compileMinErr('iscp',
            'Invalid {3} for directive \'{0}\'.' +
            ' Definition: {... {1}: \'{2}\' ...}',
            directiveName, scopeName, definition,
            (isController ? 'controller bindings definition' :
            'isolate scope definition'));
      }

      bindings[scopeName] = {
        mode: match[1][0],
        collection: match[2] === '*',
        optional: match[3] === '?',
        attrName: match[4] || scopeName
      };
      if (match[4]) {
        bindingCache[definition] = bindings[scopeName];
      }
    });

    return bindings;
  }

  function parseDirectiveBindings(directive, directiveName) {
    var bindings = {
      isolateScope: null,
      bindToController: null
    };
    if (isObject(directive.scope)) {
      if (directive.bindToController === true) {
        bindings.bindToController = parseIsolateBindings(directive.scope,
                                                         directiveName, true);
        bindings.isolateScope = {};
      } else {
        bindings.isolateScope = parseIsolateBindings(directive.scope,
                                                     directiveName, false);
      }
    }
    if (isObject(directive.bindToController)) {
      bindings.bindToController =
          parseIsolateBindings(directive.bindToController, directiveName, true);
    }
    if (bindings.bindToController && !directive.controller) {
      // There is no controller
      throw $compileMinErr('noctrl',
            'Cannot bind to controller without directive \'{0}\'s controller.',
            directiveName);
    }
    return bindings;
  }

  function assertValidDirectiveName(name) {
    var letter = name.charAt(0);
    if (!letter || letter !== lowercase(letter)) {
      throw $compileMinErr('baddir', 'Directive/Component name \'{0}\' is invalid. The first character must be a lowercase letter', name);
    }
    if (name !== name.trim()) {
      throw $compileMinErr('baddir',
            'Directive/Component name \'{0}\' is invalid. The name should not contain leading or trailing whitespaces',
            name);
    }
  }

  function getDirectiveRequire(directive) {
    var require = directive.require || (directive.controller && directive.name);

    if (!isArray(require) && isObject(require)) {
      forEach(require, function(value, key) {
        var match = value.match(REQUIRE_PREFIX_REGEXP);
        var name = value.substring(match[0].length);
        if (!name) require[key] = match[0] + key;
      });
    }

    return require;
  }

  function getDirectiveRestrict(restrict, name) {
    if (restrict && !(isString(restrict) && /[EACM]/.test(restrict))) {
      throw $compileMinErr('badrestrict',
          'Restrict property \'{0}\' of directive \'{1}\' is invalid',
          restrict,
          name);
    }

    return restrict || 'EA';
  }

  /**
   * @ngdoc method
   * @name $compileProvider#directive
   * @kind function
   *
   * @description
   * Register a new directive with the compiler.
   *
   * @param {string|Object} name Name of the directive in camel-case (i.e. `ngBind` which will match
   *    as `ng-bind`), or an object map of directives where the keys are the names and the values
   *    are the factories.
   * @param {Function|Array} directiveFactory An injectable directive factory function. See the
   *    {@link guide/directive directive guide} and the {@link $compile compile API} for more info.
   * @returns {ng.$compileProvider} Self for chaining.
   */
  this.directive = function registerDirective(name, directiveFactory) {
    assertArg(name, 'name');
    assertNotHasOwnProperty(name, 'directive');
    if (isString(name)) {
      assertValidDirectiveName(name);
      assertArg(directiveFactory, 'directiveFactory');
      if (!hasDirectives.hasOwnProperty(name)) {
        hasDirectives[name] = [];
        $provide.factory(name + Suffix, ['$injector', '$exceptionHandler',
          function($injector, $exceptionHandler) {
            var directives = [];
            forEach(hasDirectives[name], function(directiveFactory, index) {
              try {
                var directive = $injector.invoke(directiveFactory);
                if (isFunction(directive)) {
                  directive = { compile: valueFn(directive) };
                } else if (!directive.compile && directive.link) {
                  directive.compile = valueFn(directive.link);
                }
                directive.priority = directive.priority || 0;
                directive.index = index;
                directive.name = directive.name || name;
                directive.require = getDirectiveRequire(directive);
                directive.restrict = getDirectiveRestrict(directive.restrict, name);
                directive.$$moduleName = directiveFactory.$$moduleName;
                directives.push(directive);
              } catch (e) {
                $exceptionHandler(e);
              }
            });
            return directives;
          }]);
      }
      hasDirectives[name].push(directiveFactory);
    } else {
      forEach(name, reverseParams(registerDirective));
    }
    return this;
  };

  /**
   * @ngdoc method
   * @name $compileProvider#component
   * @module ng
   * @param {string|Object} name Name of the component in camelCase (i.e. `myComp` which will match `<my-comp>`),
   *    or an object map of components where the keys are the names and the values are the component definition objects.
   * @param {Object} options Component definition object (a simplified
   *    {@link ng.$compile#directive-definition-object directive definition object}),
   *    with the following properties (all optional):
   *
   *    - `controller` – `{(string|function()=}` – controller constructor function that should be
   *      associated with newly created scope or the name of a {@link ng.$compile#-controller-
   *      registered controller} if passed as a string. An empty `noop` function by default.
   *    - `controllerAs` – `{string=}` – identifier name for to reference the controller in the component's scope.
   *      If present, the controller will be published to scope under the `controllerAs` name.
   *      If not present, this will default to be `$ctrl`.
   *    - `template` – `{string=|function()=}` – html template as a string or a function that
   *      returns an html template as a string which should be used as the contents of this component.
   *      Empty string by default.
   *
   *      If `template` is a function, then it is {@link auto.$injector#invoke injected} with
   *      the following locals:
   *
   *      - `$element` - Current element
   *      - `$attrs` - Current attributes object for the element
   *
   *    - `templateUrl` – `{string=|function()=}` – path or function that returns a path to an html
   *      template that should be used  as the contents of this component.
   *
   *      If `templateUrl` is a function, then it is {@link auto.$injector#invoke injected} with
   *      the following locals:
   *
   *      - `$element` - Current element
   *      - `$attrs` - Current attributes object for the element
   *
   *    - `bindings` – `{object=}` – defines bindings between DOM attributes and component properties.
   *      Component properties are always bound to the component controller and not to the scope.
   *      See {@link ng.$compile#-bindtocontroller- `bindToController`}.
   *    - `transclude` – `{boolean=}` – whether {@link $compile#transclusion content transclusion} is enabled.
   *      Disabled by default.
   *    - `require` - `{Object<string, string>=}` - requires the controllers of other directives and binds them to
   *      this component's controller. The object keys specify the property names under which the required
   *      controllers (object values) will be bound. See {@link ng.$compile#-require- `require`}.
   *    - `$...` – additional properties to attach to the directive factory function and the controller
   *      constructor function. (This is used by the component router to annotate)
   *
   * @returns {ng.$compileProvider} the compile provider itself, for chaining of function calls.
   * @description
   * Register a **component definition** with the compiler. This is a shorthand for registering a special
   * type of directive, which represents a self-contained UI component in your application. Such components
   * are always isolated (i.e. `scope: {}`) and are always restricted to elements (i.e. `restrict: 'E'`).
   *
   * Component definitions are very simple and do not require as much configuration as defining general
   * directives. Component definitions usually consist only of a template and a controller backing it.
   *
   * In order to make the definition easier, components enforce best practices like use of `controllerAs`,
   * `bindToController`. They always have **isolate scope** and are restricted to elements.
   *
   * Here are a few examples of how you would usually define components:
   *
   * ```js
   *   var myMod = angular.module(...);
   *   myMod.component('myComp', {
   *     template: '<div>My name is {{$ctrl.name}}</div>',
   *     controller: function() {
   *       this.name = 'shahar';
   *     }
   *   });
   *
   *   myMod.component('myComp', {
   *     template: '<div>My name is {{$ctrl.name}}</div>',
   *     bindings: {name: '@'}
   *   });
   *
   *   myMod.component('myComp', {
   *     templateUrl: 'views/my-comp.html',
   *     controller: 'MyCtrl',
   *     controllerAs: 'ctrl',
   *     bindings: {name: '@'}
   *   });
   *
   * ```
   * For more examples, and an in-depth guide, see the {@link guide/component component guide}.
   *
   * <br />
   * See also {@link ng.$compileProvider#directive $compileProvider.directive()}.
   */
  this.component = function registerComponent(name, options) {
    if (!isString(name)) {
      forEach(name, reverseParams(bind(this, registerComponent)));
      return this;
    }

    var controller = options.controller || function() {};

    function factory($injector) {
      function makeInjectable(fn) {
        if (isFunction(fn) || isArray(fn)) {
          return /** @this */ function(tElement, tAttrs) {
            return $injector.invoke(fn, this, {$element: tElement, $attrs: tAttrs});
          };
        } else {
          return fn;
        }
      }

      var template = (!options.template && !options.templateUrl ? '' : options.template);
      var ddo = {
        controller: controller,
        controllerAs: identifierForController(options.controller) || options.controllerAs || '$ctrl',
        template: makeInjectable(template),
        templateUrl: makeInjectable(options.templateUrl),
        transclude: options.transclude,
        scope: {},
        bindToController: options.bindings || {},
        restrict: 'E',
        require: options.require
      };

      // Copy annotations (starting with $) over to the DDO
      forEach(options, function(val, key) {
        if (key.charAt(0) === '$') ddo[key] = val;
      });

      return ddo;
    }

    // TODO(pete) remove the following `forEach` before we release 1.6.0
    // The component-router@0.2.0 looks for the annotations on the controller constructor
    // Nothing in AngularJS looks for annotations on the factory function but we can't remove
    // it from 1.5.x yet.

    // Copy any annotation properties (starting with $) over to the factory and controller constructor functions
    // These could be used by libraries such as the new component router
    forEach(options, function(val, key) {
      if (key.charAt(0) === '$') {
        factory[key] = val;
        // Don't try to copy over annotations to named controller
        if (isFunction(controller)) controller[key] = val;
      }
    });

    factory.$inject = ['$injector'];

    return this.directive(name, factory);
  };


  /**
   * @ngdoc method
   * @name $compileProvider#aHrefSanitizationTrustedUrlList
   * @kind function
   *
   * @description
   * Retrieves or overrides the default regular expression that is used for determining trusted safe
   * urls during a[href] sanitization.
   *
   * The sanitization is a security measure aimed at preventing XSS attacks via html links.
   *
   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationTrustedUrlList`
   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
   *
   * @param {RegExp=} regexp New regexp to trust urls with.
   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
   *    chaining otherwise.
   */
  this.aHrefSanitizationTrustedUrlList = function(regexp) {
    if (isDefined(regexp)) {
      $$sanitizeUriProvider.aHrefSanitizationTrustedUrlList(regexp);
      return this;
    } else {
      return $$sanitizeUriProvider.aHrefSanitizationTrustedUrlList();
    }
  };


  /**
   * @ngdoc method
   * @name $compileProvider#aHrefSanitizationWhitelist
   * @kind function
   *
   * @deprecated
   * sinceVersion="1.8.1"
   *
   * This method is deprecated. Use {@link $compileProvider#aHrefSanitizationTrustedUrlList
   * aHrefSanitizationTrustedUrlList} instead.
   */
  Object.defineProperty(this, 'aHrefSanitizationWhitelist', {
    get: function() {
      return this.aHrefSanitizationTrustedUrlList;
    },
    set: function(value) {
      this.aHrefSanitizationTrustedUrlList = value;
    }
  });


  /**
   * @ngdoc method
   * @name $compileProvider#imgSrcSanitizationTrustedUrlList
   * @kind function
   *
   * @description
   * Retrieves or overrides the default regular expression that is used for determining trusted safe
   * urls during img[src] sanitization.
   *
   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
   *
   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationTrustedUrlList`
   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
   *
   * @param {RegExp=} regexp New regexp to trust urls with.
   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
   *    chaining otherwise.
   */
  this.imgSrcSanitizationTrustedUrlList = function(regexp) {
    if (isDefined(regexp)) {
      $$sanitizeUriProvider.imgSrcSanitizationTrustedUrlList(regexp);
      return this;
    } else {
      return $$sanitizeUriProvider.imgSrcSanitizationTrustedUrlList();
    }
  };


  /**
   * @ngdoc method
   * @name $compileProvider#imgSrcSanitizationWhitelist
   * @kind function
   *
   * @deprecated
   * sinceVersion="1.8.1"
   *
   * This method is deprecated. Use {@link $compileProvider#imgSrcSanitizationTrustedUrlList
   * imgSrcSanitizationTrustedUrlList} instead.
   */
  Object.defineProperty(this, 'imgSrcSanitizationWhitelist', {
    get: function() {
      return this.imgSrcSanitizationTrustedUrlList;
    },
    set: function(value) {
      this.imgSrcSanitizationTrustedUrlList = value;
    }
  });

  /**
   * @ngdoc method
   * @name  $compileProvider#debugInfoEnabled
   *
   * @param {boolean=} enabled update the debugInfoEnabled state if provided, otherwise just return the
   * current debugInfoEnabled state
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   *
   * @kind function
   *
   * @description
   * Call this method to enable/disable various debug runtime information in the compiler such as adding
   * binding information and a reference to the current scope on to DOM elements.
   * If enabled, the compiler will add the following to DOM elements that have been bound to the scope
   * * `ng-binding` CSS class
   * * `ng-scope` and `ng-isolated-scope` CSS classes
   * * `$binding` data property containing an array of the binding expressions
   * * Data properties used by the {@link angular.element#methods `scope()`/`isolateScope()` methods} to return
   *   the element's scope.
   * * Placeholder comments will contain information about what directive and binding caused the placeholder.
   *   E.g. `<!-- ngIf: shouldShow() -->`.
   *
   * You may want to disable this in production for a significant performance boost. See
   * {@link guide/production#disabling-debug-data Disabling Debug Data} for more.
   *
   * The default value is true.
   */
  var debugInfoEnabled = true;
  this.debugInfoEnabled = function(enabled) {
    if (isDefined(enabled)) {
      debugInfoEnabled = enabled;
      return this;
    }
    return debugInfoEnabled;
  };

  /**
   * @ngdoc method
   * @name  $compileProvider#strictComponentBindingsEnabled
   *
   * @param {boolean=} enabled update the strictComponentBindingsEnabled state if provided,
   * otherwise return the current strictComponentBindingsEnabled state.
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   *
   * @kind function
   *
   * @description
   * Call this method to enable / disable the strict component bindings check. If enabled, the
   * compiler will enforce that all scope / controller bindings of a
   * {@link $compileProvider#directive directive} / {@link $compileProvider#component component}
   * that are not set as optional with `?`, must be provided when the directive is instantiated.
   * If not provided, the compiler will throw the
   * {@link error/$compile/missingattr $compile:missingattr error}.
   *
   * The default value is false.
   */
  var strictComponentBindingsEnabled = false;
  this.strictComponentBindingsEnabled = function(enabled) {
    if (isDefined(enabled)) {
      strictComponentBindingsEnabled = enabled;
      return this;
    }
    return strictComponentBindingsEnabled;
  };

  var TTL = 10;
  /**
   * @ngdoc method
   * @name $compileProvider#onChangesTtl
   * @description
   *
   * Sets the number of times `$onChanges` hooks can trigger new changes before giving up and
   * assuming that the model is unstable.
   *
   * The current default is 10 iterations.
   *
   * In complex applications it's possible that dependencies between `$onChanges` hooks and bindings will result
   * in several iterations of calls to these hooks. However if an application needs more than the default 10
   * iterations to stabilize then you should investigate what is causing the model to continuously change during
   * the `$onChanges` hook execution.
   *
   * Increasing the TTL could have performance implications, so you should not change it without proper justification.
   *
   * @param {number} limit The number of `$onChanges` hook iterations.
   * @returns {number|object} the current limit (or `this` if called as a setter for chaining)
   */
  this.onChangesTtl = function(value) {
    if (arguments.length) {
      TTL = value;
      return this;
    }
    return TTL;
  };

  var commentDirectivesEnabledConfig = true;
  /**
   * @ngdoc method
   * @name $compileProvider#commentDirectivesEnabled
   * @description
   *
   * It indicates to the compiler
   * whether or not directives on comments should be compiled.
   * Defaults to `true`.
   *
   * Calling this function with false disables the compilation of directives
   * on comments for the whole application.
   * This results in a compilation performance gain,
   * as the compiler doesn't have to check comments when looking for directives.
   * This should however only be used if you are sure that no comment directives are used in
   * the application (including any 3rd party directives).
   *
   * @param {boolean} enabled `false` if the compiler may ignore directives on comments
   * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
   */
  this.commentDirectivesEnabled = function(value) {
    if (arguments.length) {
      commentDirectivesEnabledConfig = value;
      return this;
    }
    return commentDirectivesEnabledConfig;
  };


  var cssClassDirectivesEnabledConfig = true;
  /**
   * @ngdoc method
   * @name $compileProvider#cssClassDirectivesEnabled
   * @description
   *
   * It indicates to the compiler
   * whether or not directives on element classes should be compiled.
   * Defaults to `true`.
   *
   * Calling this function with false disables the compilation of directives
   * on element classes for the whole application.
   * This results in a compilation performance gain,
   * as the compiler doesn't have to check element classes when looking for directives.
   * This should however only be used if you are sure that no class directives are used in
   * the application (including any 3rd party directives).
   *
   * @param {boolean} enabled `false` if the compiler may ignore directives on element classes
   * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
   */
  this.cssClassDirectivesEnabled = function(value) {
    if (arguments.length) {
      cssClassDirectivesEnabledConfig = value;
      return this;
    }
    return cssClassDirectivesEnabledConfig;
  };


  /**
   * The security context of DOM Properties.
   * @private
   */
  var PROP_CONTEXTS = createMap();

  /**
   * @ngdoc method
   * @name $compileProvider#addPropertySecurityContext
   * @description
   *
   * Defines the security context for DOM properties bound by ng-prop-*.
   *
   * @param {string} elementName The element name or '*' to match any element.
   * @param {string} propertyName The DOM property name.
   * @param {string} ctx The {@link $sce} security context in which this value is safe for use, e.g. `$sce.URL`
   * @returns {object} `this` for chaining
   */
  this.addPropertySecurityContext = function(elementName, propertyName, ctx) {
    var key = (elementName.toLowerCase() + '|' + propertyName.toLowerCase());

    if (key in PROP_CONTEXTS && PROP_CONTEXTS[key] !== ctx) {
      throw $compileMinErr('ctxoverride', 'Property context \'{0}.{1}\' already set to \'{2}\', cannot override to \'{3}\'.', elementName, propertyName, PROP_CONTEXTS[key], ctx);
    }

    PROP_CONTEXTS[key] = ctx;
    return this;
  };

  /* Default property contexts.
   *
   * Copy of https://github.com/angular/angular/blob/6.0.6/packages/compiler/src/schema/dom_security_schema.ts#L31-L58
   * Changing:
   * - SecurityContext.* => SCE_CONTEXTS/$sce.*
   * - STYLE => CSS
   * - various URL => MEDIA_URL
   * - *|formAction, form|action URL => RESOURCE_URL (like the attribute)
   */
  (function registerNativePropertyContexts() {
    function registerContext(ctx, values) {
      forEach(values, function(v) { PROP_CONTEXTS[v.toLowerCase()] = ctx; });
    }

    registerContext(SCE_CONTEXTS.HTML, [
      'iframe|srcdoc',
      '*|innerHTML',
      '*|outerHTML'
    ]);
    registerContext(SCE_CONTEXTS.CSS, ['*|style']);
    registerContext(SCE_CONTEXTS.URL, [
      'area|href',       'area|ping',
      'a|href',          'a|ping',
      'blockquote|cite',
      'body|background',
      'del|cite',
      'input|src',
      'ins|cite',
      'q|cite'
    ]);
    registerContext(SCE_CONTEXTS.MEDIA_URL, [
      'audio|src',
      'img|src',    'img|srcset',
      'source|src', 'source|srcset',
      'track|src',
      'video|src',  'video|poster'
    ]);
    registerContext(SCE_CONTEXTS.RESOURCE_URL, [
      '*|formAction',
      'applet|code',      'applet|codebase',
      'base|href',
      'embed|src',
      'frame|src',
      'form|action',
      'head|profile',
      'html|manifest',
      'iframe|src',
      'link|href',
      'media|src',
      'object|codebase',  'object|data',
      'script|src'
    ]);
  })();


  this.$get = [
            '$injector', '$interpolate', '$exceptionHandler', '$templateRequest', '$parse',
            '$controller', '$rootScope', '$sce', '$animate',
    function($injector,   $interpolate,   $exceptionHandler,   $templateRequest,   $parse,
             $controller,   $rootScope,   $sce,   $animate) {

    var SIMPLE_ATTR_NAME = /^\w/;
    var specialAttrHolder = window.document.createElement('div');


    var commentDirectivesEnabled = commentDirectivesEnabledConfig;
    var cssClassDirectivesEnabled = cssClassDirectivesEnabledConfig;


    var onChangesTtl = TTL;
    // The onChanges hooks should all be run together in a single digest
    // When changes occur, the call to trigger their hooks will be added to this queue
    var onChangesQueue;

    // This function is called in a $$postDigest to trigger all the onChanges hooks in a single digest
    function flushOnChangesQueue() {
      try {
        if (!(--onChangesTtl)) {
          // We have hit the TTL limit so reset everything
          onChangesQueue = undefined;
          throw $compileMinErr('infchng', '{0} $onChanges() iterations reached. Aborting!\n', TTL);
        }
        // We must run this hook in an apply since the $$postDigest runs outside apply
        $rootScope.$apply(function() {
          for (var i = 0, ii = onChangesQueue.length; i < ii; ++i) {
            try {
              onChangesQueue[i]();
            } catch (e) {
              $exceptionHandler(e);
            }
          }
          // Reset the queue to trigger a new schedule next time there is a change
          onChangesQueue = undefined;
        });
      } finally {
        onChangesTtl++;
      }
    }


    function sanitizeSrcset(value, invokeType) {
      if (!value) {
        return value;
      }
      if (!isString(value)) {
        throw $compileMinErr('srcset', 'Can\'t pass trusted values to `{0}`: "{1}"', invokeType, value.toString());
      }

      // Such values are a bit too complex to handle automatically inside $sce.
      // Instead, we sanitize each of the URIs individually, which works, even dynamically.

      // It's not possible to work around this using `$sce.trustAsMediaUrl`.
      // If you want to programmatically set explicitly trusted unsafe URLs, you should use
      // `$sce.trustAsHtml` on the whole `img` tag and inject it into the DOM using the
      // `ng-bind-html` directive.

      var result = '';

      // first check if there are spaces because it's not the same pattern
      var trimmedSrcset = trim(value);
      //                (   999x   ,|   999w   ,|   ,|,   )
      var srcPattern = /(\s+\d+x\s*,|\s+\d+w\s*,|\s+,|,\s+)/;
      var pattern = /\s/.test(trimmedSrcset) ? srcPattern : /(,)/;

      // split srcset into tuple of uri and descriptor except for the last item
      var rawUris = trimmedSrcset.split(pattern);

      // for each tuples
      var nbrUrisWith2parts = Math.floor(rawUris.length / 2);
      for (var i = 0; i < nbrUrisWith2parts; i++) {
        var innerIdx = i * 2;
        // sanitize the uri
        result += $sce.getTrustedMediaUrl(trim(rawUris[innerIdx]));
        // add the descriptor
        result += ' ' + trim(rawUris[innerIdx + 1]);
      }

      // split the last item into uri and descriptor
      var lastTuple = trim(rawUris[i * 2]).split(/\s/);

      // sanitize the last uri
      result += $sce.getTrustedMediaUrl(trim(lastTuple[0]));

      // and add the last descriptor if any
      if (lastTuple.length === 2) {
        result += (' ' + trim(lastTuple[1]));
      }
      return result;
    }


    function Attributes(element, attributesToCopy) {
      if (attributesToCopy) {
        var keys = Object.keys(attributesToCopy);
        var i, l, key;

        for (i = 0, l = keys.length; i < l; i++) {
          key = keys[i];
          this[key] = attributesToCopy[key];
        }
      } else {
        this.$attr = {};
      }

      this.$$element = element;
    }

    Attributes.prototype = {
      /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$normalize
       * @kind function
       *
       * @description
       * Converts an attribute name (e.g. dash/colon/underscore-delimited string, optionally prefixed with `x-` or
       * `data-`) to its normalized, camelCase form.
       *
       * Also there is special case for Moz prefix starting with upper case letter.
       *
       * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
       *
       * @param {string} name Name to normalize
       */
      $normalize: directiveNormalize,


      /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$addClass
       * @kind function
       *
       * @description
       * Adds the CSS class value specified by the classVal parameter to the element. If animations
       * are enabled then an animation will be triggered for the class addition.
       *
       * @param {string} classVal The className value that will be added to the element
       */
      $addClass: function(classVal) {
        if (classVal && classVal.length > 0) {
          $animate.addClass(this.$$element, classVal);
        }
      },

      /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$removeClass
       * @kind function
       *
       * @description
       * Removes the CSS class value specified by the classVal parameter from the element. If
       * animations are enabled then an animation will be triggered for the class removal.
       *
       * @param {string} classVal The className value that will be removed from the element
       */
      $removeClass: function(classVal) {
        if (classVal && classVal.length > 0) {
          $animate.removeClass(this.$$element, classVal);
        }
      },

      /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$updateClass
       * @kind function
       *
       * @description
       * Adds and removes the appropriate CSS class values to the element based on the difference
       * between the new and old CSS class values (specified as newClasses and oldClasses).
       *
       * @param {string} newClasses The current CSS className value
       * @param {string} oldClasses The former CSS className value
       */
      $updateClass: function(newClasses, oldClasses) {
        var toAdd = tokenDifference(newClasses, oldClasses);
        if (toAdd && toAdd.length) {
          $animate.addClass(this.$$element, toAdd);
        }

        var toRemove = tokenDifference(oldClasses, newClasses);
        if (toRemove && toRemove.length) {
          $animate.removeClass(this.$$element, toRemove);
        }
      },

      /**
       * Set a normalized attribute on the element in a way such that all directives
       * can share the attribute. This function properly handles boolean attributes.
       * @param {string} key Normalized key. (ie ngAttribute)
       * @param {string|boolean} value The value to set. If `null` attribute will be deleted.
       * @param {boolean=} writeAttr If false, does not write the value to DOM element attribute.
       *     Defaults to true.
       * @param {string=} attrName Optional none normalized name. Defaults to key.
       */
      $set: function(key, value, writeAttr, attrName) {
        // TODO: decide whether or not to throw an error if "class"
        // is set through this function since it may cause $updateClass to
        // become unstable.

        var node = this.$$element[0],
            booleanKey = getBooleanAttrName(node, key),
            aliasedKey = getAliasedAttrName(key),
            observer = key,
            nodeName;

        if (booleanKey) {
          this.$$element.prop(key, value);
          attrName = booleanKey;
        } else if (aliasedKey) {
          this[aliasedKey] = value;
          observer = aliasedKey;
        }

        this[key] = value;

        // translate normalized key to actual key
        if (attrName) {
          this.$attr[key] = attrName;
        } else {
          attrName = this.$attr[key];
          if (!attrName) {
            this.$attr[key] = attrName = snake_case(key, '-');
          }
        }

        nodeName = nodeName_(this.$$element);

        // Sanitize img[srcset] values.
        if (nodeName === 'img' && key === 'srcset') {
          this[key] = value = sanitizeSrcset(value, '$set(\'srcset\', value)');
        }

        if (writeAttr !== false) {
          if (value === null || isUndefined(value)) {
            this.$$element.removeAttr(attrName);
          } else {
            if (SIMPLE_ATTR_NAME.test(attrName)) {
              // jQuery skips special boolean attrs treatment in XML nodes for
              // historical reasons and hence AngularJS cannot freely call
              // `.attr(attrName, false) with such attributes. To avoid issues
              // in XHTML, call `removeAttr` in such cases instead.
              // See https://github.com/jquery/jquery/issues/4249
              if (booleanKey && value === false) {
                this.$$element.removeAttr(attrName);
              } else {
                this.$$element.attr(attrName, value);
              }
            } else {
              setSpecialAttr(this.$$element[0], attrName, value);
            }
          }
        }

        // fire observers
        var $$observers = this.$$observers;
        if ($$observers) {
          forEach($$observers[observer], function(fn) {
            try {
              fn(value);
            } catch (e) {
              $exceptionHandler(e);
            }
          });
        }
      },


      /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$observe
       * @kind function
       *
       * @description
       * Observes an interpolated attribute.
       *
       * The observer function will be invoked once during the next `$digest` following
       * compilation. The observer is then invoked whenever the interpolated value
       * changes.
       *
       * @param {string} key Normalized key. (ie ngAttribute) .
       * @param {function(interpolatedValue)} fn Function that will be called whenever
                the interpolated value of the attribute changes.
       *        See the {@link guide/interpolation#how-text-and-attribute-bindings-work Interpolation
       *        guide} for more info.
       * @returns {function()} Returns a deregistration function for this observer.
       */
      $observe: function(key, fn) {
        var attrs = this,
            $$observers = (attrs.$$observers || (attrs.$$observers = createMap())),
            listeners = ($$observers[key] || ($$observers[key] = []));

        listeners.push(fn);
        $rootScope.$evalAsync(function() {
          if (!listeners.$$inter && attrs.hasOwnProperty(key) && !isUndefined(attrs[key])) {
            // no one registered attribute interpolation function, so lets call it manually
            fn(attrs[key]);
          }
        });

        return function() {
          arrayRemove(listeners, fn);
        };
      }
    };

    function setSpecialAttr(element, attrName, value) {
      // Attributes names that do not start with letters (such as `(click)`) cannot be set using `setAttribute`
      // so we have to jump through some hoops to get such an attribute
      // https://github.com/angular/angular.js/pull/13318
      specialAttrHolder.innerHTML = '<span ' + attrName + '>';
      var attributes = specialAttrHolder.firstChild.attributes;
      var attribute = attributes[0];
      // We have to remove the attribute from its container element before we can add it to the destination element
      attributes.removeNamedItem(attribute.name);
      attribute.value = value;
      element.attributes.setNamedItem(attribute);
    }

    function safeAddClass($element, className) {
      try {
        $element.addClass(className);
      } catch (e) {
        // ignore, since it means that we are trying to set class on
        // SVG element, where class name is read-only.
      }
    }


    var startSymbol = $interpolate.startSymbol(),
        endSymbol = $interpolate.endSymbol(),
        denormalizeTemplate = (startSymbol === '{{' && endSymbol  === '}}')
            ? identity
            : function denormalizeTemplate(template) {
              return template.replace(/\{\{/g, startSymbol).replace(/}}/g, endSymbol);
        },
        NG_PREFIX_BINDING = /^ng(Attr|Prop|On)([A-Z].*)$/;
    var MULTI_ELEMENT_DIR_RE = /^(.+)Start$/;

    compile.$$addBindingInfo = debugInfoEnabled ? function $$addBindingInfo($element, binding) {
      var bindings = $element.data('$binding') || [];

      if (isArray(binding)) {
        bindings = bindings.concat(binding);
      } else {
        bindings.push(binding);
      }

      $element.data('$binding', bindings);
    } : noop;

    compile.$$addBindingClass = debugInfoEnabled ? function $$addBindingClass($element) {
      safeAddClass($element, 'ng-binding');
    } : noop;

    compile.$$addScopeInfo = debugInfoEnabled ? function $$addScopeInfo($element, scope, isolated, noTemplate) {
      var dataName = isolated ? (noTemplate ? '$isolateScopeNoTemplate' : '$isolateScope') : '$scope';
      $element.data(dataName, scope);
    } : noop;

    compile.$$addScopeClass = debugInfoEnabled ? function $$addScopeClass($element, isolated) {
      safeAddClass($element, isolated ? 'ng-isolate-scope' : 'ng-scope');
    } : noop;

    compile.$$createComment = function(directiveName, comment) {
      var content = '';
      if (debugInfoEnabled) {
        content = ' ' + (directiveName || '') + ': ';
        if (comment) content += comment + ' ';
      }
      return window.document.createComment(content);
    };

    return compile;

    //================================

    function compile($compileNodes, transcludeFn, maxPriority, ignoreDirective,
                        previousCompileContext) {
      if (!($compileNodes instanceof jqLite)) {
        // jquery always rewraps, whereas we need to preserve the original selector so that we can
        // modify it.
        $compileNodes = jqLite($compileNodes);
      }
      var compositeLinkFn =
              compileNodes($compileNodes, transcludeFn, $compileNodes,
                           maxPriority, ignoreDirective, previousCompileContext);
      compile.$$addScopeClass($compileNodes);
      var namespace = null;
      return function publicLinkFn(scope, cloneConnectFn, options) {
        if (!$compileNodes) {
          throw $compileMinErr('multilink', 'This element has already been linked.');
        }
        assertArg(scope, 'scope');

        if (previousCompileContext && previousCompileContext.needsNewScope) {
          // A parent directive did a replace and a directive on this element asked
          // for transclusion, which caused us to lose a layer of element on which
          // we could hold the new transclusion scope, so we will create it manually
          // here.
          scope = scope.$parent.$new();
        }

        options = options || {};
        var parentBoundTranscludeFn = options.parentBoundTranscludeFn,
          transcludeControllers = options.transcludeControllers,
          futureParentElement = options.futureParentElement;

        // When `parentBoundTranscludeFn` is passed, it is a
        // `controllersBoundTransclude` function (it was previously passed
        // as `transclude` to directive.link) so we must unwrap it to get
        // its `boundTranscludeFn`
        if (parentBoundTranscludeFn && parentBoundTranscludeFn.$$boundTransclude) {
          parentBoundTranscludeFn = parentBoundTranscludeFn.$$boundTransclude;
        }

        if (!namespace) {
          namespace = detectNamespaceForChildElements(futureParentElement);
        }
        var $linkNode;
        if (namespace !== 'html') {
          // When using a directive with replace:true and templateUrl the $compileNodes
          // (or a child element inside of them)
          // might change, so we need to recreate the namespace adapted compileNodes
          // for call to the link function.
          // Note: This will already clone the nodes...
          $linkNode = jqLite(
            wrapTemplate(namespace, jqLite('<div></div>').append($compileNodes).html())
          );
        } else if (cloneConnectFn) {
          // important!!: we must call our jqLite.clone() since the jQuery one is trying to be smart
          // and sometimes changes the structure of the DOM.
          $linkNode = JQLitePrototype.clone.call($compileNodes);
        } else {
          $linkNode = $compileNodes;
        }

        if (transcludeControllers) {
          for (var controllerName in transcludeControllers) {
            $linkNode.data('$' + controllerName + 'Controller', transcludeControllers[controllerName].instance);
          }
        }

        compile.$$addScopeInfo($linkNode, scope);

        if (cloneConnectFn) cloneConnectFn($linkNode, scope);
        if (compositeLinkFn) compositeLinkFn(scope, $linkNode, $linkNode, parentBoundTranscludeFn);

        if (!cloneConnectFn) {
          $compileNodes = compositeLinkFn = null;
        }
        return $linkNode;
      };
    }

    function detectNamespaceForChildElements(parentElement) {
      // TODO: Make this detect MathML as well...
      var node = parentElement && parentElement[0];
      if (!node) {
        return 'html';
      } else {
        return nodeName_(node) !== 'foreignobject' && toString.call(node).match(/SVG/) ? 'svg' : 'html';
      }
    }

    /**
     * Compile function matches each node in nodeList against the directives. Once all directives
     * for a particular node are collected their compile functions are executed. The compile
     * functions return values - the linking functions - are combined into a composite linking
     * function, which is the a linking function for the node.
     *
     * @param {NodeList} nodeList an array of nodes or NodeList to compile
     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
     *        scope argument is auto-generated to the new child of the transcluded parent scope.
     * @param {DOMElement=} $rootElement If the nodeList is the root of the compilation tree then
     *        the rootElement must be set the jqLite collection of the compile root. This is
     *        needed so that the jqLite collection items can be replaced with widgets.
     * @param {number=} maxPriority Max directive priority.
     * @returns {Function} A composite linking function of all of the matched directives or null.
     */
    function compileNodes(nodeList, transcludeFn, $rootElement, maxPriority, ignoreDirective,
                            previousCompileContext) {
      var linkFns = [],
          // `nodeList` can be either an element's `.childNodes` (live NodeList)
          // or a jqLite/jQuery collection or an array
          notLiveList = isArray(nodeList) || (nodeList instanceof jqLite),
          attrs, directives, nodeLinkFn, childNodes, childLinkFn, linkFnFound, nodeLinkFnFound;


      for (var i = 0; i < nodeList.length; i++) {
        attrs = new Attributes();

        // Support: IE 11 only
        // Workaround for #11781 and #14924
        if (msie === 11) {
          mergeConsecutiveTextNodes(nodeList, i, notLiveList);
        }

        // We must always refer to `nodeList[i]` hereafter,
        // since the nodes can be replaced underneath us.
        directives = collectDirectives(nodeList[i], [], attrs, i === 0 ? maxPriority : undefined,
                                        ignoreDirective);

        nodeLinkFn = (directives.length)
            ? applyDirectivesToNode(directives, nodeList[i], attrs, transcludeFn, $rootElement,
                                      null, [], [], previousCompileContext)
            : null;

        if (nodeLinkFn && nodeLinkFn.scope) {
          compile.$$addScopeClass(attrs.$$element);
        }

        childLinkFn = (nodeLinkFn && nodeLinkFn.terminal ||
                      !(childNodes = nodeList[i].childNodes) ||
                      !childNodes.length)
            ? null
            : compileNodes(childNodes,
                 nodeLinkFn ? (
                  (nodeLinkFn.transcludeOnThisElement || !nodeLinkFn.templateOnThisElement)
                     && nodeLinkFn.transclude) : transcludeFn);

        if (nodeLinkFn || childLinkFn) {
          linkFns.push(i, nodeLinkFn, childLinkFn);
          linkFnFound = true;
          nodeLinkFnFound = nodeLinkFnFound || nodeLinkFn;
        }

        //use the previous context only for the first element in the virtual group
        previousCompileContext = null;
      }

      // return a linking function if we have found anything, null otherwise
      return linkFnFound ? compositeLinkFn : null;

      function compositeLinkFn(scope, nodeList, $rootElement, parentBoundTranscludeFn) {
        var nodeLinkFn, childLinkFn, node, childScope, i, ii, idx, childBoundTranscludeFn;
        var stableNodeList;


        if (nodeLinkFnFound) {
          // copy nodeList so that if a nodeLinkFn removes or adds an element at this DOM level our
          // offsets don't get screwed up
          var nodeListLength = nodeList.length;
          stableNodeList = new Array(nodeListLength);

          // create a sparse array by only copying the elements which have a linkFn
          for (i = 0; i < linkFns.length; i += 3) {
            idx = linkFns[i];
            stableNodeList[idx] = nodeList[idx];
          }
        } else {
          stableNodeList = nodeList;
        }

        for (i = 0, ii = linkFns.length; i < ii;) {
          node = stableNodeList[linkFns[i++]];
          nodeLinkFn = linkFns[i++];
          childLinkFn = linkFns[i++];

          if (nodeLinkFn) {
            if (nodeLinkFn.scope) {
              childScope = scope.$new();
              compile.$$addScopeInfo(jqLite(node), childScope);
            } else {
              childScope = scope;
            }

            if (nodeLinkFn.transcludeOnThisElement) {
              childBoundTranscludeFn = createBoundTranscludeFn(
                  scope, nodeLinkFn.transclude, parentBoundTranscludeFn);

            } else if (!nodeLinkFn.templateOnThisElement && parentBoundTranscludeFn) {
              childBoundTranscludeFn = parentBoundTranscludeFn;

            } else if (!parentBoundTranscludeFn && transcludeFn) {
              childBoundTranscludeFn = createBoundTranscludeFn(scope, transcludeFn);

            } else {
              childBoundTranscludeFn = null;
            }

            nodeLinkFn(childLinkFn, childScope, node, $rootElement, childBoundTranscludeFn);

          } else if (childLinkFn) {
            childLinkFn(scope, node.childNodes, undefined, parentBoundTranscludeFn);
          }
        }
      }
    }

    function mergeConsecutiveTextNodes(nodeList, idx, notLiveList) {
      var node = nodeList[idx];
      var parent = node.parentNode;
      var sibling;

      if (node.nodeType !== NODE_TYPE_TEXT) {
        return;
      }

      while (true) {
        sibling = parent ? node.nextSibling : nodeList[idx + 1];
        if (!sibling || sibling.nodeType !== NODE_TYPE_TEXT) {
          break;
        }

        node.nodeValue = node.nodeValue + sibling.nodeValue;

        if (sibling.parentNode) {
          sibling.parentNode.removeChild(sibling);
        }
        if (notLiveList && sibling === nodeList[idx + 1]) {
          nodeList.splice(idx + 1, 1);
        }
      }
    }

    function createBoundTranscludeFn(scope, transcludeFn, previousBoundTranscludeFn) {
      function boundTranscludeFn(transcludedScope, cloneFn, controllers, futureParentElement, containingScope) {

        if (!transcludedScope) {
          transcludedScope = scope.$new(false, containingScope);
          transcludedScope.$$transcluded = true;
        }

        return transcludeFn(transcludedScope, cloneFn, {
          parentBoundTranscludeFn: previousBoundTranscludeFn,
          transcludeControllers: controllers,
          futureParentElement: futureParentElement
        });
      }

      // We need  to attach the transclusion slots onto the `boundTranscludeFn`
      // so that they are available inside the `controllersBoundTransclude` function
      var boundSlots = boundTranscludeFn.$$slots = createMap();
      for (var slotName in transcludeFn.$$slots) {
        if (transcludeFn.$$slots[slotName]) {
          boundSlots[slotName] = createBoundTranscludeFn(scope, transcludeFn.$$slots[slotName], previousBoundTranscludeFn);
        } else {
          boundSlots[slotName] = null;
        }
      }

      return boundTranscludeFn;
    }

    /**
     * Looks for directives on the given node and adds them to the directive collection which is
     * sorted.
     *
     * @param node Node to search.
     * @param directives An array to which the directives are added to. This array is sorted before
     *        the function returns.
     * @param attrs The shared attrs object which is used to populate the normalized attributes.
     * @param {number=} maxPriority Max directive priority.
     */
    function collectDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
      var nodeType = node.nodeType,
          attrsMap = attrs.$attr,
          match,
          nodeName,
          className;

      switch (nodeType) {
        case NODE_TYPE_ELEMENT: /* Element */

          nodeName = nodeName_(node);

          // use the node name: <directive>
          addDirective(directives,
              directiveNormalize(nodeName), 'E', maxPriority, ignoreDirective);

          // iterate over the attributes
          for (var attr, name, nName, value, ngPrefixMatch, nAttrs = node.attributes,
                   j = 0, jj = nAttrs && nAttrs.length; j < jj; j++) {
            var attrStartName = false;
            var attrEndName = false;

            var isNgAttr = false, isNgProp = false, isNgEvent = false;
            var multiElementMatch;

            attr = nAttrs[j];
            name = attr.name;
            value = attr.value;

            nName = directiveNormalize(name.toLowerCase());

            // Support ng-attr-*, ng-prop-* and ng-on-*
            if ((ngPrefixMatch = nName.match(NG_PREFIX_BINDING))) {
              isNgAttr = ngPrefixMatch[1] === 'Attr';
              isNgProp = ngPrefixMatch[1] === 'Prop';
              isNgEvent = ngPrefixMatch[1] === 'On';

              // Normalize the non-prefixed name
              name = name.replace(PREFIX_REGEXP, '')
                .toLowerCase()
                .substr(4 + ngPrefixMatch[1].length).replace(/_(.)/g, function(match, letter) {
                  return letter.toUpperCase();
                });

            // Support *-start / *-end multi element directives
            } else if ((multiElementMatch = nName.match(MULTI_ELEMENT_DIR_RE)) && directiveIsMultiElement(multiElementMatch[1])) {
              attrStartName = name;
              attrEndName = name.substr(0, name.length - 5) + 'end';
              name = name.substr(0, name.length - 6);
            }

            if (isNgProp || isNgEvent) {
              attrs[nName] = value;
              attrsMap[nName] = attr.name;

              if (isNgProp) {
                addPropertyDirective(node, directives, nName, name);
              } else {
                addEventDirective(directives, nName, name);
              }
            } else {
              // Update nName for cases where a prefix was removed
              // NOTE: the .toLowerCase() is unnecessary and causes https://github.com/angular/angular.js/issues/16624 for ng-attr-*
              nName = directiveNormalize(name.toLowerCase());
              attrsMap[nName] = name;

              if (isNgAttr || !attrs.hasOwnProperty(nName)) {
                attrs[nName] = value;
                if (getBooleanAttrName(node, nName)) {
                  attrs[nName] = true; // presence means true
                }
              }

              addAttrInterpolateDirective(node, directives, value, nName, isNgAttr);
              addDirective(directives, nName, 'A', maxPriority, ignoreDirective, attrStartName,
                            attrEndName);
            }
          }

          if (nodeName === 'input' && node.getAttribute('type') === 'hidden') {
            // Hidden input elements can have strange behaviour when navigating back to the page
            // This tells the browser not to try to cache and reinstate previous values
            node.setAttribute('autocomplete', 'off');
          }

          // use class as directive
          if (!cssClassDirectivesEnabled) break;
          className = node.className;
          if (isObject(className)) {
              // Maybe SVGAnimatedString
              className = className.animVal;
          }
          if (isString(className) && className !== '') {
            while ((match = CLASS_DIRECTIVE_REGEXP.exec(className))) {
              nName = directiveNormalize(match[2]);
              if (addDirective(directives, nName, 'C', maxPriority, ignoreDirective)) {
                attrs[nName] = trim(match[3]);
              }
              className = className.substr(match.index + match[0].length);
            }
          }
          break;
        case NODE_TYPE_TEXT: /* Text Node */
          addTextInterpolateDirective(directives, node.nodeValue);
          break;
        case NODE_TYPE_COMMENT: /* Comment */
          if (!commentDirectivesEnabled) break;
          collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective);
          break;
      }

      directives.sort(byPriority);
      return directives;
    }

    function collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
      // function created because of performance, try/catch disables
      // the optimization of the whole function #14848
      try {
        var match = COMMENT_DIRECTIVE_REGEXP.exec(node.nodeValue);
        if (match) {
          var nName = directiveNormalize(match[1]);
          if (addDirective(directives, nName, 'M', maxPriority, ignoreDirective)) {
            attrs[nName] = trim(match[2]);
          }
        }
      } catch (e) {
        // turns out that under some circumstances IE9 throws errors when one attempts to read
        // comment's node value.
        // Just ignore it and continue. (Can't seem to reproduce in test case.)
      }
    }

    /**
     * Given a node with a directive-start it collects all of the siblings until it finds
     * directive-end.
     * @param node
     * @param attrStart
     * @param attrEnd
     * @returns {*}
     */
    function groupScan(node, attrStart, attrEnd) {
      var nodes = [];
      var depth = 0;
      if (attrStart && node.hasAttribute && node.hasAttribute(attrStart)) {
        do {
          if (!node) {
            throw $compileMinErr('uterdir',
                      'Unterminated attribute, found \'{0}\' but no matching \'{1}\' found.',
                      attrStart, attrEnd);
          }
          if (node.nodeType === NODE_TYPE_ELEMENT) {
            if (node.hasAttribute(attrStart)) depth++;
            if (node.hasAttribute(attrEnd)) depth--;
          }
          nodes.push(node);
          node = node.nextSibling;
        } while (depth > 0);
      } else {
        nodes.push(node);
      }

      return jqLite(nodes);
    }

    /**
     * Wrapper for linking function which converts normal linking function into a grouped
     * linking function.
     * @param linkFn
     * @param attrStart
     * @param attrEnd
     * @returns {Function}
     */
    function groupElementsLinkFnWrapper(linkFn, attrStart, attrEnd) {
      return function groupedElementsLink(scope, element, attrs, controllers, transcludeFn) {
        element = groupScan(element[0], attrStart, attrEnd);
        return linkFn(scope, element, attrs, controllers, transcludeFn);
      };
    }

    /**
     * A function generator that is used to support both eager and lazy compilation
     * linking function.
     * @param eager
     * @param $compileNodes
     * @param transcludeFn
     * @param maxPriority
     * @param ignoreDirective
     * @param previousCompileContext
     * @returns {Function}
     */
    function compilationGenerator(eager, $compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext) {
      var compiled;

      if (eager) {
        return compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
      }
      return /** @this */ function lazyCompilation() {
        if (!compiled) {
          compiled = compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);

          // Null out all of these references in order to make them eligible for garbage collection
          // since this is a potentially long lived closure
          $compileNodes = transcludeFn = previousCompileContext = null;
        }
        return compiled.apply(this, arguments);
      };
    }

    /**
     * Once the directives have been collected, their compile functions are executed. This method
     * is responsible for inlining directive templates as well as terminating the application
     * of the directives if the terminal directive has been reached.
     *
     * @param {Array} directives Array of collected directives to execute their compile function.
     *        this needs to be pre-sorted by priority order.
     * @param {Node} compileNode The raw DOM node to apply the compile functions to
     * @param {Object} templateAttrs The shared attribute function
     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
     *                                                  scope argument is auto-generated to the new
     *                                                  child of the transcluded parent scope.
     * @param {JQLite} jqCollection If we are working on the root of the compile tree then this
     *                              argument has the root jqLite array so that we can replace nodes
     *                              on it.
     * @param {Object=} originalReplaceDirective An optional directive that will be ignored when
     *                                           compiling the transclusion.
     * @param {Array.<Function>} preLinkFns
     * @param {Array.<Function>} postLinkFns
     * @param {Object} previousCompileContext Context used for previous compilation of the current
     *                                        node
     * @returns {Function} linkFn
     */
    function applyDirectivesToNode(directives, compileNode, templateAttrs, transcludeFn,
                                   jqCollection, originalReplaceDirective, preLinkFns, postLinkFns,
                                   previousCompileContext) {
      previousCompileContext = previousCompileContext || {};

      var terminalPriority = -Number.MAX_VALUE,
          newScopeDirective = previousCompileContext.newScopeDirective,
          controllerDirectives = previousCompileContext.controllerDirectives,
          newIsolateScopeDirective = previousCompileContext.newIsolateScopeDirective,
          templateDirective = previousCompileContext.templateDirective,
          nonTlbTranscludeDirective = previousCompileContext.nonTlbTranscludeDirective,
          hasTranscludeDirective = false,
          hasTemplate = false,
          hasElementTranscludeDirective = previousCompileContext.hasElementTranscludeDirective,
          $compileNode = templateAttrs.$$element = jqLite(compileNode),
          directive,
          directiveName,
          $template,
          replaceDirective = originalReplaceDirective,
          childTranscludeFn = transcludeFn,
          linkFn,
          didScanForMultipleTransclusion = false,
          mightHaveMultipleTransclusionError = false,
          directiveValue;

      // executes all directives on the current element
      for (var i = 0, ii = directives.length; i < ii; i++) {
        directive = directives[i];
        var attrStart = directive.$$start;
        var attrEnd = directive.$$end;

        // collect multiblock sections
        if (attrStart) {
          $compileNode = groupScan(compileNode, attrStart, attrEnd);
        }
        $template = undefined;

        if (terminalPriority > directive.priority) {
          break; // prevent further processing of directives
        }

        directiveValue = directive.scope;

        if (directiveValue) {

          // skip the check for directives with async templates, we'll check the derived sync
          // directive when the template arrives
          if (!directive.templateUrl) {
            if (isObject(directiveValue)) {
              // This directive is trying to add an isolated scope.
              // Check that there is no scope of any kind already
              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective || newScopeDirective,
                                directive, $compileNode);
              newIsolateScopeDirective = directive;
            } else {
              // This directive is trying to add a child scope.
              // Check that there is no isolated scope already
              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective, directive,
                                $compileNode);
            }
          }

          newScopeDirective = newScopeDirective || directive;
        }

        directiveName = directive.name;

        // If we encounter a condition that can result in transclusion on the directive,
        // then scan ahead in the remaining directives for others that may cause a multiple
        // transclusion error to be thrown during the compilation process.  If a matching directive
        // is found, then we know that when we encounter a transcluded directive, we need to eagerly
        // compile the `transclude` function rather than doing it lazily in order to throw
        // exceptions at the correct time
        if (!didScanForMultipleTransclusion && ((directive.replace && (directive.templateUrl || directive.template))
            || (directive.transclude && !directive.$$tlb))) {
                var candidateDirective;

                for (var scanningIndex = i + 1; (candidateDirective = directives[scanningIndex++]);) {
                    if ((candidateDirective.transclude && !candidateDirective.$$tlb)
                        || (candidateDirective.replace && (candidateDirective.templateUrl || candidateDirective.template))) {
                        mightHaveMultipleTransclusionError = true;
                        break;
                    }
                }

                didScanForMultipleTransclusion = true;
        }

        if (!directive.templateUrl && directive.controller) {
          controllerDirectives = controllerDirectives || createMap();
          assertNoDuplicate('\'' + directiveName + '\' controller',
              controllerDirectives[directiveName], directive, $compileNode);
          controllerDirectives[directiveName] = directive;
        }

        directiveValue = directive.transclude;

        if (directiveValue) {
          hasTranscludeDirective = true;

          // Special case ngIf and ngRepeat so that we don't complain about duplicate transclusion.
          // This option should only be used by directives that know how to safely handle element transclusion,
          // where the transcluded nodes are added or replaced after linking.
          if (!directive.$$tlb) {
            assertNoDuplicate('transclusion', nonTlbTranscludeDirective, directive, $compileNode);
            nonTlbTranscludeDirective = directive;
          }

          if (directiveValue === 'element') {
            hasElementTranscludeDirective = true;
            terminalPriority = directive.priority;
            $template = $compileNode;
            $compileNode = templateAttrs.$$element =
                jqLite(compile.$$createComment(directiveName, templateAttrs[directiveName]));
            compileNode = $compileNode[0];
            replaceWith(jqCollection, sliceArgs($template), compileNode);

            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, terminalPriority,
                                        replaceDirective && replaceDirective.name, {
                                          // Don't pass in:
                                          // - controllerDirectives - otherwise we'll create duplicates controllers
                                          // - newIsolateScopeDirective or templateDirective - combining templates with
                                          //   element transclusion doesn't make sense.
                                          //
                                          // We need only nonTlbTranscludeDirective so that we prevent putting transclusion
                                          // on the same element more than once.
                                          nonTlbTranscludeDirective: nonTlbTranscludeDirective
                                        });
          } else {

            var slots = createMap();

            if (!isObject(directiveValue)) {
              $template = jqLite(jqLiteClone(compileNode)).contents();
            } else {

              // We have transclusion slots,
              // collect them up, compile them and store their transclusion functions
              $template = window.document.createDocumentFragment();

              var slotMap = createMap();
              var filledSlots = createMap();

              // Parse the element selectors
              forEach(directiveValue, function(elementSelector, slotName) {
                // If an element selector starts with a ? then it is optional
                var optional = (elementSelector.charAt(0) === '?');
                elementSelector = optional ? elementSelector.substring(1) : elementSelector;

                slotMap[elementSelector] = slotName;

                // We explicitly assign `null` since this implies that a slot was defined but not filled.
                // Later when calling boundTransclusion functions with a slot name we only error if the
                // slot is `undefined`
                slots[slotName] = null;

                // filledSlots contains `true` for all slots that are either optional or have been
                // filled. This is used to check that we have not missed any required slots
                filledSlots[slotName] = optional;
              });

              // Add the matching elements into their slot
              forEach($compileNode.contents(), function(node) {
                var slotName = slotMap[directiveNormalize(nodeName_(node))];
                if (slotName) {
                  filledSlots[slotName] = true;
                  slots[slotName] = slots[slotName] || window.document.createDocumentFragment();
                  slots[slotName].appendChild(node);
                } else {
                  $template.appendChild(node);
                }
              });

              // Check for required slots that were not filled
              forEach(filledSlots, function(filled, slotName) {
                if (!filled) {
                  throw $compileMinErr('reqslot', 'Required transclusion slot `{0}` was not filled.', slotName);
                }
              });

              for (var slotName in slots) {
                if (slots[slotName]) {
                  // Only define a transclusion function if the slot was filled
                  var slotCompileNodes = jqLite(slots[slotName].childNodes);
                  slots[slotName] = compilationGenerator(mightHaveMultipleTransclusionError, slotCompileNodes, transcludeFn);
                }
              }

              $template = jqLite($template.childNodes);
            }

            $compileNode.empty(); // clear contents
            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, undefined,
                undefined, { needsNewScope: directive.$$isolateScope || directive.$$newScope});
            childTranscludeFn.$$slots = slots;
          }
        }

        if (directive.template) {
          hasTemplate = true;
          assertNoDuplicate('template', templateDirective, directive, $compileNode);
          templateDirective = directive;

          directiveValue = (isFunction(directive.template))
              ? directive.template($compileNode, templateAttrs)
              : directive.template;

          directiveValue = denormalizeTemplate(directiveValue);

          if (directive.replace) {
            replaceDirective = directive;
            if (jqLiteIsTextNode(directiveValue)) {
              $template = [];
            } else {
              $template = removeComments(wrapTemplate(directive.templateNamespace, trim(directiveValue)));
            }
            compileNode = $template[0];

            if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
              throw $compileMinErr('tplrt',
                  'Template for directive \'{0}\' must have exactly one root element. {1}',
                  directiveName, '');
            }

            replaceWith(jqCollection, $compileNode, compileNode);

            var newTemplateAttrs = {$attr: {}};

            // combine directives from the original node and from the template:
            // - take the array of directives for this element
            // - split it into two parts, those that already applied (processed) and those that weren't (unprocessed)
            // - collect directives from the template and sort them by priority
            // - combine directives as: processed + template + unprocessed
            var templateDirectives = collectDirectives(compileNode, [], newTemplateAttrs);
            var unprocessedDirectives = directives.splice(i + 1, directives.length - (i + 1));

            if (newIsolateScopeDirective || newScopeDirective) {
              // The original directive caused the current element to be replaced but this element
              // also needs to have a new scope, so we need to tell the template directives
              // that they would need to get their scope from further up, if they require transclusion
              markDirectiveScope(templateDirectives, newIsolateScopeDirective, newScopeDirective);
            }
            directives = directives.concat(templateDirectives).concat(unprocessedDirectives);
            mergeTemplateAttributes(templateAttrs, newTemplateAttrs);

            ii = directives.length;
          } else {
            $compileNode.html(directiveValue);
          }
        }

        if (directive.templateUrl) {
          hasTemplate = true;
          assertNoDuplicate('template', templateDirective, directive, $compileNode);
          templateDirective = directive;

          if (directive.replace) {
            replaceDirective = directive;
          }

          // eslint-disable-next-line no-func-assign
          nodeLinkFn = compileTemplateUrl(directives.splice(i, directives.length - i), $compileNode,
              templateAttrs, jqCollection, hasTranscludeDirective && childTranscludeFn, preLinkFns, postLinkFns, {
                controllerDirectives: controllerDirectives,
                newScopeDirective: (newScopeDirective !== directive) && newScopeDirective,
                newIsolateScopeDirective: newIsolateScopeDirective,
                templateDirective: templateDirective,
                nonTlbTranscludeDirective: nonTlbTranscludeDirective
              });
          ii = directives.length;
        } else if (directive.compile) {
          try {
            linkFn = directive.compile($compileNode, templateAttrs, childTranscludeFn);
            var context = directive.$$originalDirective || directive;
            if (isFunction(linkFn)) {
              addLinkFns(null, bind(context, linkFn), attrStart, attrEnd);
            } else if (linkFn) {
              addLinkFns(bind(context, linkFn.pre), bind(context, linkFn.post), attrStart, attrEnd);
            }
          } catch (e) {
            $exceptionHandler(e, startingTag($compileNode));
          }
        }

        if (directive.terminal) {
          nodeLinkFn.terminal = true;
          terminalPriority = Math.max(terminalPriority, directive.priority);
        }

      }

      nodeLinkFn.scope = newScopeDirective && newScopeDirective.scope === true;
      nodeLinkFn.transcludeOnThisElement = hasTranscludeDirective;
      nodeLinkFn.templateOnThisElement = hasTemplate;
      nodeLinkFn.transclude = childTranscludeFn;

      previousCompileContext.hasElementTranscludeDirective = hasElementTranscludeDirective;

      // might be normal or delayed nodeLinkFn depending on if templateUrl is present
      return nodeLinkFn;

      ////////////////////

      function addLinkFns(pre, post, attrStart, attrEnd) {
        if (pre) {
          if (attrStart) pre = groupElementsLinkFnWrapper(pre, attrStart, attrEnd);
          pre.require = directive.require;
          pre.directiveName = directiveName;
          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
            pre = cloneAndAnnotateFn(pre, {isolateScope: true});
          }
          preLinkFns.push(pre);
        }
        if (post) {
          if (attrStart) post = groupElementsLinkFnWrapper(post, attrStart, attrEnd);
          post.require = directive.require;
          post.directiveName = directiveName;
          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
            post = cloneAndAnnotateFn(post, {isolateScope: true});
          }
          postLinkFns.push(post);
        }
      }

      function nodeLinkFn(childLinkFn, scope, linkNode, $rootElement, boundTranscludeFn) {
        var i, ii, linkFn, isolateScope, controllerScope, elementControllers, transcludeFn, $element,
            attrs, scopeBindingInfo;

        if (compileNode === linkNode) {
          attrs = templateAttrs;
          $element = templateAttrs.$$element;
        } else {
          $element = jqLite(linkNode);
          attrs = new Attributes($element, templateAttrs);
        }

        controllerScope = scope;
        if (newIsolateScopeDirective) {
          isolateScope = scope.$new(true);
        } else if (newScopeDirective) {
          controllerScope = scope.$parent;
        }

        if (boundTranscludeFn) {
          // track `boundTranscludeFn` so it can be unwrapped if `transcludeFn`
          // is later passed as `parentBoundTranscludeFn` to `publicLinkFn`
          transcludeFn = controllersBoundTransclude;
          transcludeFn.$$boundTransclude = boundTranscludeFn;
          // expose the slots on the `$transclude` function
          transcludeFn.isSlotFilled = function(slotName) {
            return !!boundTranscludeFn.$$slots[slotName];
          };
        }

        if (controllerDirectives) {
          elementControllers = setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective);
        }

        if (newIsolateScopeDirective) {
          // Initialize isolate scope bindings for new isolate scope directive.
          compile.$$addScopeInfo($element, isolateScope, true, !(templateDirective && (templateDirective === newIsolateScopeDirective ||
              templateDirective === newIsolateScopeDirective.$$originalDirective)));
          compile.$$addScopeClass($element, true);
          isolateScope.$$isolateBindings =
              newIsolateScopeDirective.$$isolateBindings;
          scopeBindingInfo = initializeDirectiveBindings(scope, attrs, isolateScope,
                                        isolateScope.$$isolateBindings,
                                        newIsolateScopeDirective);
          if (scopeBindingInfo.removeWatches) {
            isolateScope.$on('$destroy', scopeBindingInfo.removeWatches);
          }
        }

        // Initialize bindToController bindings
        for (var name in elementControllers) {
          var controllerDirective = controllerDirectives[name];
          var controller = elementControllers[name];
          var bindings = controllerDirective.$$bindings.bindToController;

          controller.instance = controller();
          $element.data('$' + controllerDirective.name + 'Controller', controller.instance);
          controller.bindingInfo =
            initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
          }

        // Bind the required controllers to the controller, if `require` is an object and `bindToController` is truthy
        forEach(controllerDirectives, function(controllerDirective, name) {
          var require = controllerDirective.require;
          if (controllerDirective.bindToController && !isArray(require) && isObject(require)) {
            extend(elementControllers[name].instance, getControllers(name, require, $element, elementControllers));
          }
        });

        // Handle the init and destroy lifecycle hooks on all controllers that have them
        forEach(elementControllers, function(controller) {
          var controllerInstance = controller.instance;
          if (isFunction(controllerInstance.$onChanges)) {
            try {
              controllerInstance.$onChanges(controller.bindingInfo.initialChanges);
            } catch (e) {
              $exceptionHandler(e);
            }
          }
          if (isFunction(controllerInstance.$onInit)) {
            try {
              controllerInstance.$onInit();
            } catch (e) {
              $exceptionHandler(e);
            }
          }
          if (isFunction(controllerInstance.$doCheck)) {
            controllerScope.$watch(function() { controllerInstance.$doCheck(); });
            controllerInstance.$doCheck();
          }
          if (isFunction(controllerInstance.$onDestroy)) {
            controllerScope.$on('$destroy', function callOnDestroyHook() {
              controllerInstance.$onDestroy();
            });
          }
        });

        // PRELINKING
        for (i = 0, ii = preLinkFns.length; i < ii; i++) {
          linkFn = preLinkFns[i];
          invokeLinkFn(linkFn,
              linkFn.isolateScope ? isolateScope : scope,
              $element,
              attrs,
              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
              transcludeFn
          );
        }

        // RECURSION
        // We only pass the isolate scope, if the isolate directive has a template,
        // otherwise the child elements do not belong to the isolate directive.
        var scopeToChild = scope;
        if (newIsolateScopeDirective && (newIsolateScopeDirective.template || newIsolateScopeDirective.templateUrl === null)) {
          scopeToChild = isolateScope;
        }
        if (childLinkFn) {
          childLinkFn(scopeToChild, linkNode.childNodes, undefined, boundTranscludeFn);
        }

        // POSTLINKING
        for (i = postLinkFns.length - 1; i >= 0; i--) {
          linkFn = postLinkFns[i];
          invokeLinkFn(linkFn,
              linkFn.isolateScope ? isolateScope : scope,
              $element,
              attrs,
              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
              transcludeFn
          );
        }

        // Trigger $postLink lifecycle hooks
        forEach(elementControllers, function(controller) {
          var controllerInstance = controller.instance;
          if (isFunction(controllerInstance.$postLink)) {
            controllerInstance.$postLink();
          }
        });

        // This is the function that is injected as `$transclude`.
        // Note: all arguments are optional!
        function controllersBoundTransclude(scope, cloneAttachFn, futureParentElement, slotName) {
          var transcludeControllers;
          // No scope passed in:
          if (!isScope(scope)) {
            slotName = futureParentElement;
            futureParentElement = cloneAttachFn;
            cloneAttachFn = scope;
            scope = undefined;
          }

          if (hasElementTranscludeDirective) {
            transcludeControllers = elementControllers;
          }
          if (!futureParentElement) {
            futureParentElement = hasElementTranscludeDirective ? $element.parent() : $element;
          }
          if (slotName) {
            // slotTranscludeFn can be one of three things:
            //  * a transclude function - a filled slot
            //  * `null` - an optional slot that was not filled
            //  * `undefined` - a slot that was not declared (i.e. invalid)
            var slotTranscludeFn = boundTranscludeFn.$$slots[slotName];
            if (slotTranscludeFn) {
              return slotTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
            } else if (isUndefined(slotTranscludeFn)) {
              throw $compileMinErr('noslot',
               'No parent directive that requires a transclusion with slot name "{0}". ' +
               'Element: {1}',
               slotName, startingTag($element));
            }
          } else {
            return boundTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
          }
        }
      }
    }

    function getControllers(directiveName, require, $element, elementControllers) {
      var value;

      if (isString(require)) {
        var match = require.match(REQUIRE_PREFIX_REGEXP);
        var name = require.substring(match[0].length);
        var inheritType = match[1] || match[3];
        var optional = match[2] === '?';

        //If only parents then start at the parent element
        if (inheritType === '^^') {
          $element = $element.parent();
        //Otherwise attempt getting the controller from elementControllers in case
        //the element is transcluded (and has no data) and to avoid .data if possible
        } else {
          value = elementControllers && elementControllers[name];
          value = value && value.instance;
        }

        if (!value) {
          var dataName = '$' + name + 'Controller';

          if (inheritType === '^^' && $element[0] && $element[0].nodeType === NODE_TYPE_DOCUMENT) {
            // inheritedData() uses the documentElement when it finds the document, so we would
            // require from the element itself.
            value = null;
          } else {
            value = inheritType ? $element.inheritedData(dataName) : $element.data(dataName);
          }
        }

        if (!value && !optional) {
          throw $compileMinErr('ctreq',
              'Controller \'{0}\', required by directive \'{1}\', can\'t be found!',
              name, directiveName);
        }
      } else if (isArray(require)) {
        value = [];
        for (var i = 0, ii = require.length; i < ii; i++) {
          value[i] = getControllers(directiveName, require[i], $element, elementControllers);
        }
      } else if (isObject(require)) {
        value = {};
        forEach(require, function(controller, property) {
          value[property] = getControllers(directiveName, controller, $element, elementControllers);
        });
      }

      return value || null;
    }

    function setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective) {
      var elementControllers = createMap();
      for (var controllerKey in controllerDirectives) {
        var directive = controllerDirectives[controllerKey];
        var locals = {
          $scope: directive === newIsolateScopeDirective || directive.$$isolateScope ? isolateScope : scope,
          $element: $element,
          $attrs: attrs,
          $transclude: transcludeFn
        };

        var controller = directive.controller;
        if (controller === '@') {
          controller = attrs[directive.name];
        }

        var controllerInstance = $controller(controller, locals, true, directive.controllerAs);

        // For directives with element transclusion the element is a comment.
        // In this case .data will not attach any data.
        // Instead, we save the controllers for the element in a local hash and attach to .data
        // later, once we have the actual element.
        elementControllers[directive.name] = controllerInstance;
        $element.data('$' + directive.name + 'Controller', controllerInstance.instance);
      }
      return elementControllers;
    }

    // Depending upon the context in which a directive finds itself it might need to have a new isolated
    // or child scope created. For instance:
    // * if the directive has been pulled into a template because another directive with a higher priority
    // asked for element transclusion
    // * if the directive itself asks for transclusion but it is at the root of a template and the original
    // element was replaced. See https://github.com/angular/angular.js/issues/12936
    function markDirectiveScope(directives, isolateScope, newScope) {
      for (var j = 0, jj = directives.length; j < jj; j++) {
        directives[j] = inherit(directives[j], {$$isolateScope: isolateScope, $$newScope: newScope});
      }
    }

    /**
     * looks up the directive and decorates it with exception handling and proper parameters. We
     * call this the boundDirective.
     *
     * @param {string} name name of the directive to look up.
     * @param {string} location The directive must be found in specific format.
     *   String containing any of theses characters:
     *
     *   * `E`: element name
     *   * `A': attribute
     *   * `C`: class
     *   * `M`: comment
     * @returns {boolean} true if directive was added.
     */
    function addDirective(tDirectives, name, location, maxPriority, ignoreDirective, startAttrName,
                          endAttrName) {
      if (name === ignoreDirective) return null;
      var match = null;
      if (hasDirectives.hasOwnProperty(name)) {
        for (var directive, directives = $injector.get(name + Suffix),
            i = 0, ii = directives.length; i < ii; i++) {
          directive = directives[i];
          if ((isUndefined(maxPriority) || maxPriority > directive.priority) &&
               directive.restrict.indexOf(location) !== -1) {
            if (startAttrName) {
              directive = inherit(directive, {$$start: startAttrName, $$end: endAttrName});
            }
            if (!directive.$$bindings) {
              var bindings = directive.$$bindings =
                  parseDirectiveBindings(directive, directive.name);
              if (isObject(bindings.isolateScope)) {
                directive.$$isolateBindings = bindings.isolateScope;
              }
            }
            tDirectives.push(directive);
            match = directive;
          }
        }
      }
      return match;
    }


    /**
     * looks up the directive and returns true if it is a multi-element directive,
     * and therefore requires DOM nodes between -start and -end markers to be grouped
     * together.
     *
     * @param {string} name name of the directive to look up.
     * @returns true if directive was registered as multi-element.
     */
    function directiveIsMultiElement(name) {
      if (hasDirectives.hasOwnProperty(name)) {
        for (var directive, directives = $injector.get(name + Suffix),
            i = 0, ii = directives.length; i < ii; i++) {
          directive = directives[i];
          if (directive.multiElement) {
            return true;
          }
        }
      }
      return false;
    }

    /**
     * When the element is replaced with HTML template then the new attributes
     * on the template need to be merged with the existing attributes in the DOM.
     * The desired effect is to have both of the attributes present.
     *
     * @param {object} dst destination attributes (original DOM)
     * @param {object} src source attributes (from the directive template)
     */
    function mergeTemplateAttributes(dst, src) {
      var srcAttr = src.$attr,
          dstAttr = dst.$attr;

      // reapply the old attributes to the new element
      forEach(dst, function(value, key) {
        if (key.charAt(0) !== '$') {
          if (src[key] && src[key] !== value) {
            if (value.length) {
              value += (key === 'style' ? ';' : ' ') + src[key];
            } else {
              value = src[key];
            }
          }
          dst.$set(key, value, true, srcAttr[key]);
        }
      });

      // copy the new attributes on the old attrs object
      forEach(src, function(value, key) {
        // Check if we already set this attribute in the loop above.
        // `dst` will never contain hasOwnProperty as DOM parser won't let it.
        // You will get an "InvalidCharacterError: DOM Exception 5" error if you
        // have an attribute like "has-own-property" or "data-has-own-property", etc.
        if (!dst.hasOwnProperty(key) && key.charAt(0) !== '$') {
          dst[key] = value;

          if (key !== 'class' && key !== 'style') {
            dstAttr[key] = srcAttr[key];
          }
        }
      });
    }


    function compileTemplateUrl(directives, $compileNode, tAttrs,
        $rootElement, childTranscludeFn, preLinkFns, postLinkFns, previousCompileContext) {
      var linkQueue = [],
          afterTemplateNodeLinkFn,
          afterTemplateChildLinkFn,
          beforeTemplateCompileNode = $compileNode[0],
          origAsyncDirective = directives.shift(),
          derivedSyncDirective = inherit(origAsyncDirective, {
            templateUrl: null, transclude: null, replace: null, $$originalDirective: origAsyncDirective
          }),
          templateUrl = (isFunction(origAsyncDirective.templateUrl))
              ? origAsyncDirective.templateUrl($compileNode, tAttrs)
              : origAsyncDirective.templateUrl,
          templateNamespace = origAsyncDirective.templateNamespace;

      $compileNode.empty();

      $templateRequest(templateUrl)
        .then(function(content) {
          var compileNode, tempTemplateAttrs, $template, childBoundTranscludeFn;

          content = denormalizeTemplate(content);

          if (origAsyncDirective.replace) {
            if (jqLiteIsTextNode(content)) {
              $template = [];
            } else {
              $template = removeComments(wrapTemplate(templateNamespace, trim(content)));
            }
            compileNode = $template[0];

            if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
              throw $compileMinErr('tplrt',
                  'Template for directive \'{0}\' must have exactly one root element. {1}',
                  origAsyncDirective.name, templateUrl);
            }

            tempTemplateAttrs = {$attr: {}};
            replaceWith($rootElement, $compileNode, compileNode);
            var templateDirectives = collectDirectives(compileNode, [], tempTemplateAttrs);

            if (isObject(origAsyncDirective.scope)) {
              // the original directive that caused the template to be loaded async required
              // an isolate scope
              markDirectiveScope(templateDirectives, true);
            }
            directives = templateDirectives.concat(directives);
            mergeTemplateAttributes(tAttrs, tempTemplateAttrs);
          } else {
            compileNode = beforeTemplateCompileNode;
            $compileNode.html(content);
          }

          directives.unshift(derivedSyncDirective);

          afterTemplateNodeLinkFn = applyDirectivesToNode(directives, compileNode, tAttrs,
              childTranscludeFn, $compileNode, origAsyncDirective, preLinkFns, postLinkFns,
              previousCompileContext);
          forEach($rootElement, function(node, i) {
            if (node === compileNode) {
              $rootElement[i] = $compileNode[0];
            }
          });
          afterTemplateChildLinkFn = compileNodes($compileNode[0].childNodes, childTranscludeFn);

          while (linkQueue.length) {
            var scope = linkQueue.shift(),
                beforeTemplateLinkNode = linkQueue.shift(),
                linkRootElement = linkQueue.shift(),
                boundTranscludeFn = linkQueue.shift(),
                linkNode = $compileNode[0];

            if (scope.$$destroyed) continue;

            if (beforeTemplateLinkNode !== beforeTemplateCompileNode) {
              var oldClasses = beforeTemplateLinkNode.className;

              if (!(previousCompileContext.hasElementTranscludeDirective &&
                  origAsyncDirective.replace)) {
                // it was cloned therefore we have to clone as well.
                linkNode = jqLiteClone(compileNode);
              }
              replaceWith(linkRootElement, jqLite(beforeTemplateLinkNode), linkNode);

              // Copy in CSS classes from original node
              safeAddClass(jqLite(linkNode), oldClasses);
            }
            if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
              childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
            } else {
              childBoundTranscludeFn = boundTranscludeFn;
            }
            afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, linkNode, $rootElement,
              childBoundTranscludeFn);
          }
          linkQueue = null;
        }).catch(function(error) {
          if (isError(error)) {
            $exceptionHandler(error);
          }
        });

      return function delayedNodeLinkFn(ignoreChildLinkFn, scope, node, rootElement, boundTranscludeFn) {
        var childBoundTranscludeFn = boundTranscludeFn;
        if (scope.$$destroyed) return;
        if (linkQueue) {
          linkQueue.push(scope,
                         node,
                         rootElement,
                         childBoundTranscludeFn);
        } else {
          if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
            childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
          }
          afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, node, rootElement, childBoundTranscludeFn);
        }
      };
    }


    /**
     * Sorting function for bound directives.
     */
    function byPriority(a, b) {
      var diff = b.priority - a.priority;
      if (diff !== 0) return diff;
      if (a.name !== b.name) return (a.name < b.name) ? -1 : 1;
      return a.index - b.index;
    }

    function assertNoDuplicate(what, previousDirective, directive, element) {

      function wrapModuleNameIfDefined(moduleName) {
        return moduleName ?
          (' (module: ' + moduleName + ')') :
          '';
      }

      if (previousDirective) {
        throw $compileMinErr('multidir', 'Multiple directives [{0}{1}, {2}{3}] asking for {4} on: {5}',
            previousDirective.name, wrapModuleNameIfDefined(previousDirective.$$moduleName),
            directive.name, wrapModuleNameIfDefined(directive.$$moduleName), what, startingTag(element));
      }
    }


    function addTextInterpolateDirective(directives, text) {
      var interpolateFn = $interpolate(text, true);
      if (interpolateFn) {
        directives.push({
          priority: 0,
          compile: function textInterpolateCompileFn(templateNode) {
            var templateNodeParent = templateNode.parent(),
                hasCompileParent = !!templateNodeParent.length;

            // When transcluding a template that has bindings in the root
            // we don't have a parent and thus need to add the class during linking fn.
            if (hasCompileParent) compile.$$addBindingClass(templateNodeParent);

            return function textInterpolateLinkFn(scope, node) {
              var parent = node.parent();
              if (!hasCompileParent) compile.$$addBindingClass(parent);
              compile.$$addBindingInfo(parent, interpolateFn.expressions);
              scope.$watch(interpolateFn, function interpolateFnWatchAction(value) {
                node[0].nodeValue = value;
              });
            };
          }
        });
      }
    }


    function wrapTemplate(type, template) {
      type = lowercase(type || 'html');
      switch (type) {
      case 'svg':
      case 'math':
        var wrapper = window.document.createElement('div');
        wrapper.innerHTML = '<' + type + '>' + template + '</' + type + '>';
        return wrapper.childNodes[0].childNodes;
      default:
        return template;
      }
    }


    function getTrustedAttrContext(nodeName, attrNormalizedName) {
      if (attrNormalizedName === 'srcdoc') {
        return $sce.HTML;
      }
      // All nodes with src attributes require a RESOURCE_URL value, except for
      // img and various html5 media nodes, which require the MEDIA_URL context.
      if (attrNormalizedName === 'src' || attrNormalizedName === 'ngSrc') {
        if (['img', 'video', 'audio', 'source', 'track'].indexOf(nodeName) === -1) {
          return $sce.RESOURCE_URL;
        }
        return $sce.MEDIA_URL;
      } else if (attrNormalizedName === 'xlinkHref') {
        // Some xlink:href are okay, most aren't
        if (nodeName === 'image') return $sce.MEDIA_URL;
        if (nodeName === 'a') return $sce.URL;
        return $sce.RESOURCE_URL;
      } else if (
          // Formaction
          (nodeName === 'form' && attrNormalizedName === 'action') ||
          // If relative URLs can go where they are not expected to, then
          // all sorts of trust issues can arise.
          (nodeName === 'base' && attrNormalizedName === 'href') ||
          // links can be stylesheets or imports, which can run script in the current origin
          (nodeName === 'link' && attrNormalizedName === 'href')
      ) {
        return $sce.RESOURCE_URL;
      } else if (nodeName === 'a' && (attrNormalizedName === 'href' ||
                                 attrNormalizedName === 'ngHref')) {
        return $sce.URL;
      }
    }

    function getTrustedPropContext(nodeName, propNormalizedName) {
      var prop = propNormalizedName.toLowerCase();
      return PROP_CONTEXTS[nodeName + '|' + prop] || PROP_CONTEXTS['*|' + prop];
    }

    function sanitizeSrcsetPropertyValue(value) {
      return sanitizeSrcset($sce.valueOf(value), 'ng-prop-srcset');
    }
    function addPropertyDirective(node, directives, attrName, propName) {
      if (EVENT_HANDLER_ATTR_REGEXP.test(propName)) {
        throw $compileMinErr('nodomevents', 'Property bindings for HTML DOM event properties are disallowed');
      }

      var nodeName = nodeName_(node);
      var trustedContext = getTrustedPropContext(nodeName, propName);

      var sanitizer = identity;
      // Sanitize img[srcset] + source[srcset] values.
      if (propName === 'srcset' && (nodeName === 'img' || nodeName === 'source')) {
        sanitizer = sanitizeSrcsetPropertyValue;
      } else if (trustedContext) {
        sanitizer = $sce.getTrusted.bind($sce, trustedContext);
      }

      directives.push({
        priority: 100,
        compile: function ngPropCompileFn(_, attr) {
          var ngPropGetter = $parse(attr[attrName]);
          var ngPropWatch = $parse(attr[attrName], function sceValueOf(val) {
            // Unwrap the value to compare the actual inner safe value, not the wrapper object.
            return $sce.valueOf(val);
          });

          return {
            pre: function ngPropPreLinkFn(scope, $element) {
              function applyPropValue() {
                var propValue = ngPropGetter(scope);
                $element[0][propName] = sanitizer(propValue);
              }

              applyPropValue();
              scope.$watch(ngPropWatch, applyPropValue);
            }
          };
        }
      });
    }

    function addEventDirective(directives, attrName, eventName) {
      directives.push(
        createEventDirective($parse, $rootScope, $exceptionHandler, attrName, eventName, /*forceAsync=*/false)
      );
    }

    function addAttrInterpolateDirective(node, directives, value, name, isNgAttr) {
      var nodeName = nodeName_(node);
      var trustedContext = getTrustedAttrContext(nodeName, name);
      var mustHaveExpression = !isNgAttr;
      var allOrNothing = ALL_OR_NOTHING_ATTRS[name] || isNgAttr;

      var interpolateFn = $interpolate(value, mustHaveExpression, trustedContext, allOrNothing);

      // no interpolation found -> ignore
      if (!interpolateFn) return;

      if (name === 'multiple' && nodeName === 'select') {
        throw $compileMinErr('selmulti',
            'Binding to the \'multiple\' attribute is not supported. Element: {0}',
            startingTag(node));
      }

      if (EVENT_HANDLER_ATTR_REGEXP.test(name)) {
        throw $compileMinErr('nodomevents', 'Interpolations for HTML DOM event attributes are disallowed');
      }

      directives.push({
        priority: 100,
        compile: function() {
            return {
              pre: function attrInterpolatePreLinkFn(scope, element, attr) {
                var $$observers = (attr.$$observers || (attr.$$observers = createMap()));

                // If the attribute has changed since last $interpolate()ed
                var newValue = attr[name];
                if (newValue !== value) {
                  // we need to interpolate again since the attribute value has been updated
                  // (e.g. by another directive's compile function)
                  // ensure unset/empty values make interpolateFn falsy
                  interpolateFn = newValue && $interpolate(newValue, true, trustedContext, allOrNothing);
                  value = newValue;
                }

                // if attribute was updated so that there is no interpolation going on we don't want to
                // register any observers
                if (!interpolateFn) return;

                // initialize attr object so that it's ready in case we need the value for isolate
                // scope initialization, otherwise the value would not be available from isolate
                // directive's linking fn during linking phase
                attr[name] = interpolateFn(scope);

                ($$observers[name] || ($$observers[name] = [])).$$inter = true;
                (attr.$$observers && attr.$$observers[name].$$scope || scope).
                  $watch(interpolateFn, function interpolateFnWatchAction(newValue, oldValue) {
                    //special case for class attribute addition + removal
                    //so that class changes can tap into the animation
                    //hooks provided by the $animate service. Be sure to
                    //skip animations when the first digest occurs (when
                    //both the new and the old values are the same) since
                    //the CSS classes are the non-interpolated values
                    if (name === 'class' && newValue !== oldValue) {
                      attr.$updateClass(newValue, oldValue);
                    } else {
                      attr.$set(name, newValue);
                    }
                  });
              }
            };
          }
      });
    }


    /**
     * This is a special jqLite.replaceWith, which can replace items which
     * have no parents, provided that the containing jqLite collection is provided.
     *
     * @param {JqLite=} $rootElement The root of the compile tree. Used so that we can replace nodes
     *                               in the root of the tree.
     * @param {JqLite} elementsToRemove The jqLite element which we are going to replace. We keep
     *                                  the shell, but replace its DOM node reference.
     * @param {Node} newNode The new DOM node.
     */
    function replaceWith($rootElement, elementsToRemove, newNode) {
      var firstElementToRemove = elementsToRemove[0],
          removeCount = elementsToRemove.length,
          parent = firstElementToRemove.parentNode,
          i, ii;

      if ($rootElement) {
        for (i = 0, ii = $rootElement.length; i < ii; i++) {
          if ($rootElement[i] === firstElementToRemove) {
            $rootElement[i++] = newNode;
            for (var j = i, j2 = j + removeCount - 1,
                     jj = $rootElement.length;
                 j < jj; j++, j2++) {
              if (j2 < jj) {
                $rootElement[j] = $rootElement[j2];
              } else {
                delete $rootElement[j];
              }
            }
            $rootElement.length -= removeCount - 1;

            // If the replaced element is also the jQuery .context then replace it
            // .context is a deprecated jQuery api, so we should set it only when jQuery set it
            // http://api.jquery.com/context/
            if ($rootElement.context === firstElementToRemove) {
              $rootElement.context = newNode;
            }
            break;
          }
        }
      }

      if (parent) {
        parent.replaceChild(newNode, firstElementToRemove);
      }

      // Append all the `elementsToRemove` to a fragment. This will...
      // - remove them from the DOM
      // - allow them to still be traversed with .nextSibling
      // - allow a single fragment.qSA to fetch all elements being removed
      var fragment = window.document.createDocumentFragment();
      for (i = 0; i < removeCount; i++) {
        fragment.appendChild(elementsToRemove[i]);
      }

      if (jqLite.hasData(firstElementToRemove)) {
        // Copy over user data (that includes AngularJS's $scope etc.). Don't copy private
        // data here because there's no public interface in jQuery to do that and copying over
        // event listeners (which is the main use of private data) wouldn't work anyway.
        jqLite.data(newNode, jqLite.data(firstElementToRemove));

        // Remove $destroy event listeners from `firstElementToRemove`
        jqLite(firstElementToRemove).off('$destroy');
      }

      // Cleanup any data/listeners on the elements and children.
      // This includes invoking the $destroy event on any elements with listeners.
      jqLite.cleanData(fragment.querySelectorAll('*'));

      // Update the jqLite collection to only contain the `newNode`
      for (i = 1; i < removeCount; i++) {
        delete elementsToRemove[i];
      }
      elementsToRemove[0] = newNode;
      elementsToRemove.length = 1;
    }


    function cloneAndAnnotateFn(fn, annotation) {
      return extend(function() { return fn.apply(null, arguments); }, fn, annotation);
    }


    function invokeLinkFn(linkFn, scope, $element, attrs, controllers, transcludeFn) {
      try {
        linkFn(scope, $element, attrs, controllers, transcludeFn);
      } catch (e) {
        $exceptionHandler(e, startingTag($element));
      }
    }

    function strictBindingsCheck(attrName, directiveName) {
      if (strictComponentBindingsEnabled) {
        throw $compileMinErr('missingattr',
          'Attribute \'{0}\' of \'{1}\' is non-optional and must be set!',
          attrName, directiveName);
      }
    }

    // Set up $watches for isolate scope and controller bindings.
    function initializeDirectiveBindings(scope, attrs, destination, bindings, directive) {
      var removeWatchCollection = [];
      var initialChanges = {};
      var changes;

      forEach(bindings, function initializeBinding(definition, scopeName) {
        var attrName = definition.attrName,
        optional = definition.optional,
        mode = definition.mode, // @, =, <, or &
        lastValue,
        parentGet, parentSet, compare, removeWatch;

        switch (mode) {

          case '@':
            if (!optional && !hasOwnProperty.call(attrs, attrName)) {
              strictBindingsCheck(attrName, directive.name);
              destination[scopeName] = attrs[attrName] = undefined;

            }
            removeWatch = attrs.$observe(attrName, function(value) {
              if (isString(value) || isBoolean(value)) {
                var oldValue = destination[scopeName];
                recordChanges(scopeName, value, oldValue);
                destination[scopeName] = value;
              }
            });
            attrs.$$observers[attrName].$$scope = scope;
            lastValue = attrs[attrName];
            if (isString(lastValue)) {
              // If the attribute has been provided then we trigger an interpolation to ensure
              // the value is there for use in the link fn
              destination[scopeName] = $interpolate(lastValue)(scope);
            } else if (isBoolean(lastValue)) {
              // If the attributes is one of the BOOLEAN_ATTR then AngularJS will have converted
              // the value to boolean rather than a string, so we special case this situation
              destination[scopeName] = lastValue;
            }
            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
            removeWatchCollection.push(removeWatch);
            break;

          case '=':
            if (!hasOwnProperty.call(attrs, attrName)) {
              if (optional) break;
              strictBindingsCheck(attrName, directive.name);
              attrs[attrName] = undefined;
            }
            if (optional && !attrs[attrName]) break;

            parentGet = $parse(attrs[attrName]);
            if (parentGet.literal) {
              compare = equals;
            } else {
              compare = simpleCompare;
            }
            parentSet = parentGet.assign || function() {
              // reset the change, or we will throw this exception on every $digest
              lastValue = destination[scopeName] = parentGet(scope);
              throw $compileMinErr('nonassign',
                  'Expression \'{0}\' in attribute \'{1}\' used with directive \'{2}\' is non-assignable!',
                  attrs[attrName], attrName, directive.name);
            };
            lastValue = destination[scopeName] = parentGet(scope);
            var parentValueWatch = function parentValueWatch(parentValue) {
              if (!compare(parentValue, destination[scopeName])) {
                // we are out of sync and need to copy
                if (!compare(parentValue, lastValue)) {
                  // parent changed and it has precedence
                  destination[scopeName] = parentValue;
                } else {
                  // if the parent can be assigned then do so
                  parentSet(scope, parentValue = destination[scopeName]);
                }
              }
              lastValue = parentValue;
              return lastValue;
            };
            parentValueWatch.$stateful = true;
            if (definition.collection) {
              removeWatch = scope.$watchCollection(attrs[attrName], parentValueWatch);
            } else {
              removeWatch = scope.$watch($parse(attrs[attrName], parentValueWatch), null, parentGet.literal);
            }
            removeWatchCollection.push(removeWatch);
            break;

          case '<':
            if (!hasOwnProperty.call(attrs, attrName)) {
              if (optional) break;
              strictBindingsCheck(attrName, directive.name);
              attrs[attrName] = undefined;
            }
            if (optional && !attrs[attrName]) break;

            parentGet = $parse(attrs[attrName]);
            var isLiteral = parentGet.literal;

            var initialValue = destination[scopeName] = parentGet(scope);
            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);

            removeWatch = scope[definition.collection ? '$watchCollection' : '$watch'](parentGet, function parentValueWatchAction(newValue, oldValue) {
              if (oldValue === newValue) {
                if (oldValue === initialValue || (isLiteral && equals(oldValue, initialValue))) {
                  return;
                }
                oldValue = initialValue;
              }
              recordChanges(scopeName, newValue, oldValue);
              destination[scopeName] = newValue;
            });

            removeWatchCollection.push(removeWatch);
            break;

          case '&':
            if (!optional && !hasOwnProperty.call(attrs, attrName)) {
              strictBindingsCheck(attrName, directive.name);
            }
            // Don't assign Object.prototype method to scope
            parentGet = attrs.hasOwnProperty(attrName) ? $parse(attrs[attrName]) : noop;

            // Don't assign noop to destination if expression is not valid
            if (parentGet === noop && optional) break;

            destination[scopeName] = function(locals) {
              return parentGet(scope, locals);
            };
            break;
        }
      });

      function recordChanges(key, currentValue, previousValue) {
        if (isFunction(destination.$onChanges) && !simpleCompare(currentValue, previousValue)) {
          // If we have not already scheduled the top level onChangesQueue handler then do so now
          if (!onChangesQueue) {
            scope.$$postDigest(flushOnChangesQueue);
            onChangesQueue = [];
          }
          // If we have not already queued a trigger of onChanges for this controller then do so now
          if (!changes) {
            changes = {};
            onChangesQueue.push(triggerOnChangesHook);
          }
          // If the has been a change on this property already then we need to reuse the previous value
          if (changes[key]) {
            previousValue = changes[key].previousValue;
          }
          // Store this change
          changes[key] = new SimpleChange(previousValue, currentValue);
        }
      }

      function triggerOnChangesHook() {
        destination.$onChanges(changes);
        // Now clear the changes so that we schedule onChanges when more changes arrive
        changes = undefined;
      }

      return {
        initialChanges: initialChanges,
        removeWatches: removeWatchCollection.length && function removeWatches() {
          for (var i = 0, ii = removeWatchCollection.length; i < ii; ++i) {
            removeWatchCollection[i]();
          }
        }
      };
    }
  }];
}

function SimpleChange(previous, current) {
  this.previousValue = previous;
  this.currentValue = current;
}
SimpleChange.prototype.isFirstChange = function() { return this.previousValue === _UNINITIALIZED_VALUE; };


var PREFIX_REGEXP = /^((?:x|data)[:\-_])/i;
var SPECIAL_CHARS_REGEXP = /[:\-_]+(.)/g;

/**
 * Converts all accepted directives format into proper directive name.
 * @param name Name to normalize
 */
function directiveNormalize(name) {
  return name
    .replace(PREFIX_REGEXP, '')
    .replace(SPECIAL_CHARS_REGEXP, function(_, letter, offset) {
      return offset ? letter.toUpperCase() : letter;
    });
}

/**
 * @ngdoc type
 * @name $compile.directive.Attributes
 *
 * @description
 * A shared object between directive compile / linking functions which contains normalized DOM
 * element attributes. The values reflect current binding state `{{ }}`. The normalization is
 * needed since all of these are treated as equivalent in AngularJS:
 *
 * ```
 *    <span ng:bind="a" ng-bind="a" data-ng-bind="a" x-ng-bind="a">
 * ```
 */

/**
 * @ngdoc property
 * @name $compile.directive.Attributes#$attr
 *
 * @description
 * A map of DOM element attribute names to the normalized name. This is
 * needed to do reverse lookup from normalized name back to actual name.
 */


/**
 * @ngdoc method
 * @name $compile.directive.Attributes#$set
 * @kind function
 *
 * @description
 * Set DOM element attribute value.
 *
 *
 * @param {string} name Normalized element attribute name of the property to modify. The name is
 *          reverse-translated using the {@link ng.$compile.directive.Attributes#$attr $attr}
 *          property to the original name.
 * @param {string} value Value to set the attribute to. The value can be an interpolated string.
 */



/**
 * Closure compiler type information
 */

function nodesetLinkingFn(
  /* angular.Scope */ scope,
  /* NodeList */ nodeList,
  /* Element */ rootElement,
  /* function(Function) */ boundTranscludeFn
) {}

function directiveLinkingFn(
  /* nodesetLinkingFn */ nodesetLinkingFn,
  /* angular.Scope */ scope,
  /* Node */ node,
  /* Element */ rootElement,
  /* function(Function) */ boundTranscludeFn
) {}

function tokenDifference(str1, str2) {
  var values = '',
      tokens1 = str1.split(/\s+/),
      tokens2 = str2.split(/\s+/);

  outer:
  for (var i = 0; i < tokens1.length; i++) {
    var token = tokens1[i];
    for (var j = 0; j < tokens2.length; j++) {
      if (token === tokens2[j]) continue outer;
    }
    values += (values.length > 0 ? ' ' : '') + token;
  }
  return values;
}

function removeComments(jqNodes) {
  jqNodes = jqLite(jqNodes);
  var i = jqNodes.length;

  if (i <= 1) {
    return jqNodes;
  }

  while (i--) {
    var node = jqNodes[i];
    if (node.nodeType === NODE_TYPE_COMMENT ||
       (node.nodeType === NODE_TYPE_TEXT && node.nodeValue.trim() === '')) {
         splice.call(jqNodes, i, 1);
    }
  }
  return jqNodes;
}

var $controllerMinErr = minErr('$controller');


var CNTRL_REG = /^(\S+)(\s+as\s+([\w$]+))?$/;
function identifierForController(controller, ident) {
  if (ident && isString(ident)) return ident;
  if (isString(controller)) {
    var match = CNTRL_REG.exec(controller);
    if (match) return match[3];
  }
}


/**
 * @ngdoc provider
 * @name $controllerProvider
 * @this
 *
 * @description
 * The {@link ng.$controller $controller service} is used by AngularJS to create new
 * controllers.
 *
 * This provider allows controller registration via the
 * {@link ng.$controllerProvider#register register} method.
 */
function $ControllerProvider() {
  var controllers = {};

  /**
   * @ngdoc method
   * @name $controllerProvider#has
   * @param {string} name Controller name to check.
   */
  this.has = function(name) {
    return controllers.hasOwnProperty(name);
  };

  /**
   * @ngdoc method
   * @name $controllerProvider#register
   * @param {string|Object} name Controller name, or an object map of controllers where the keys are
   *    the names and the values are the constructors.
   * @param {Function|Array} constructor Controller constructor fn (optionally decorated with DI
   *    annotations in the array notation).
   */
  this.register = function(name, constructor) {
    assertNotHasOwnProperty(name, 'controller');
    if (isObject(name)) {
      extend(controllers, name);
    } else {
      controllers[name] = constructor;
    }
  };

  this.$get = ['$injector', function($injector) {

    /**
     * @ngdoc service
     * @name $controller
     * @requires $injector
     *
     * @param {Function|string} constructor If called with a function then it's considered to be the
     *    controller constructor function. Otherwise it's considered to be a string which is used
     *    to retrieve the controller constructor using the following steps:
     *
     *    * check if a controller with given name is registered via `$controllerProvider`
     *    * check if evaluating the string on the current scope returns a constructor
     *
     *    The string can use the `controller as property` syntax, where the controller instance is published
     *    as the specified property on the `scope`; the `scope` must be injected into `locals` param for this
     *    to work correctly.
     *
     * @param {Object} locals Injection locals for Controller.
     * @return {Object} Instance of given controller.
     *
     * @description
     * `$controller` service is responsible for instantiating controllers.
     *
     * It's just a simple call to {@link auto.$injector $injector}, but extracted into
     * a service, so that one can override this service with [BC version](https://gist.github.com/1649788).
     */
    return function $controller(expression, locals, later, ident) {
      // PRIVATE API:
      //   param `later` --- indicates that the controller's constructor is invoked at a later time.
      //                     If true, $controller will allocate the object with the correct
      //                     prototype chain, but will not invoke the controller until a returned
      //                     callback is invoked.
      //   param `ident` --- An optional label which overrides the label parsed from the controller
      //                     expression, if any.
      var instance, match, constructor, identifier;
      later = later === true;
      if (ident && isString(ident)) {
        identifier = ident;
      }

      if (isString(expression)) {
        match = expression.match(CNTRL_REG);
        if (!match) {
          throw $controllerMinErr('ctrlfmt',
            'Badly formed controller string \'{0}\'. ' +
            'Must match `__name__ as __id__` or `__name__`.', expression);
        }
        constructor = match[1];
        identifier = identifier || match[3];
        expression = controllers.hasOwnProperty(constructor)
            ? controllers[constructor]
            : getter(locals.$scope, constructor, true);

        if (!expression) {
          throw $controllerMinErr('ctrlreg',
            'The controller with the name \'{0}\' is not registered.', constructor);
        }

        assertArgFn(expression, constructor, true);
      }

      if (later) {
        // Instantiate controller later:
        // This machinery is used to create an instance of the object before calling the
        // controller's constructor itself.
        //
        // This allows properties to be added to the controller before the constructor is
        // invoked. Primarily, this is used for isolate scope bindings in $compile.
        //
        // This feature is not intended for use by applications, and is thus not documented
        // publicly.
        // Object creation: http://jsperf.com/create-constructor/2
        var controllerPrototype = (isArray(expression) ?
          expression[expression.length - 1] : expression).prototype;
        instance = Object.create(controllerPrototype || null);

        if (identifier) {
          addIdentifier(locals, identifier, instance, constructor || expression.name);
        }

        return extend(function $controllerInit() {
          var result = $injector.invoke(expression, instance, locals, constructor);
          if (result !== instance && (isObject(result) || isFunction(result))) {
            instance = result;
            if (identifier) {
              // If result changed, re-assign controllerAs value to scope.
              addIdentifier(locals, identifier, instance, constructor || expression.name);
            }
          }
          return instance;
        }, {
          instance: instance,
          identifier: identifier
        });
      }

      instance = $injector.instantiate(expression, locals, constructor);

      if (identifier) {
        addIdentifier(locals, identifier, instance, constructor || expression.name);
      }

      return instance;
    };

    function addIdentifier(locals, identifier, instance, name) {
      if (!(locals && isObject(locals.$scope))) {
        throw minErr('$controller')('noscp',
          'Cannot export controller \'{0}\' as \'{1}\'! No $scope object provided via `locals`.',
          name, identifier);
      }

      locals.$scope[identifier] = instance;
    }
  }];
}

/**
 * @ngdoc service
 * @name $document
 * @requires $window
 * @this
 *
 * @description
 * A {@link angular.element jQuery or jqLite} wrapper for the browser's `window.document` object.
 *
 * @example
   <example module="documentExample" name="document">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <p>$document title: <b ng-bind="title"></b></p>
         <p>window.document title: <b ng-bind="windowTitle"></b></p>
       </div>
     </file>
     <file name="script.js">
       angular.module('documentExample', [])
         .controller('ExampleController', ['$scope', '$document', function($scope, $document) {
           $scope.title = $document[0].title;
           $scope.windowTitle = angular.element(window.document)[0].title;
         }]);
     </file>
   </example>
 */
function $DocumentProvider() {
  this.$get = ['$window', function(window) {
    return jqLite(window.document);
  }];
}


/**
 * @private
 * @this
 * Listens for document visibility change and makes the current status accessible.
 */
function $$IsDocumentHiddenProvider() {
  this.$get = ['$document', '$rootScope', function($document, $rootScope) {
    var doc = $document[0];
    var hidden = doc && doc.hidden;

    $document.on('visibilitychange', changeListener);

    $rootScope.$on('$destroy', function() {
      $document.off('visibilitychange', changeListener);
    });

    function changeListener() {
      hidden = doc.hidden;
    }

    return function() {
      return hidden;
    };
  }];
}

/**
 * @ngdoc service
 * @name $exceptionHandler
 * @requires ng.$log
 * @this
 *
 * @description
 * Any uncaught exception in AngularJS expressions is delegated to this service.
 * The default implementation simply delegates to `$log.error` which logs it into
 * the browser console.
 *
 * In unit tests, if `angular-mocks.js` is loaded, this service is overridden by
 * {@link ngMock.$exceptionHandler mock $exceptionHandler} which aids in testing.
 *
 * ## Example:
 *
 * The example below will overwrite the default `$exceptionHandler` in order to (a) log uncaught
 * errors to the backend for later inspection by the developers and (b) to use `$log.warn()` instead
 * of `$log.error()`.
 *
 * ```js
 *   angular.
 *     module('exceptionOverwrite', []).
 *     factory('$exceptionHandler', ['$log', 'logErrorsToBackend', function($log, logErrorsToBackend) {
 *       return function myExceptionHandler(exception, cause) {
 *         logErrorsToBackend(exception, cause);
 *         $log.warn(exception, cause);
 *       };
 *     }]);
 * ```
 *
 * <hr />
 * Note, that code executed in event-listeners (even those registered using jqLite's `on`/`bind`
 * methods) does not delegate exceptions to the {@link ng.$exceptionHandler $exceptionHandler}
 * (unless executed during a digest).
 *
 * If you wish, you can manually delegate exceptions, e.g.
 * `try { ... } catch(e) { $exceptionHandler(e); }`
 *
 * @param {Error} exception Exception associated with the error.
 * @param {string=} cause Optional information about the context in which
 *       the error was thrown.
 *
 */
function $ExceptionHandlerProvider() {
  this.$get = ['$log', function($log) {
    return function(exception, cause) {
      $log.error.apply($log, arguments);
    };
  }];
}

var $$ForceReflowProvider = /** @this */ function() {
  this.$get = ['$document', function($document) {
    return function(domNode) {
      //the line below will force the browser to perform a repaint so
      //that all the animated elements within the animation frame will
      //be properly updated and drawn on screen. This is required to
      //ensure that the preparation animation is properly flushed so that
      //the active state picks up from there. DO NOT REMOVE THIS LINE.
      //DO NOT OPTIMIZE THIS LINE. THE MINIFIER WILL REMOVE IT OTHERWISE WHICH
      //WILL RESULT IN AN UNPREDICTABLE BUG THAT IS VERY HARD TO TRACK DOWN AND
      //WILL TAKE YEARS AWAY FROM YOUR LIFE.
      if (domNode) {
        if (!domNode.nodeType && domNode instanceof jqLite) {
          domNode = domNode[0];
        }
      } else {
        domNode = $document[0].body;
      }
      return domNode.offsetWidth + 1;
    };
  }];
};

var APPLICATION_JSON = 'application/json';
var CONTENT_TYPE_APPLICATION_JSON = {'Content-Type': APPLICATION_JSON + ';charset=utf-8'};
var JSON_START = /^\[|^\{(?!\{)/;
var JSON_ENDS = {
  '[': /]$/,
  '{': /}$/
};
var JSON_PROTECTION_PREFIX = /^\)]\}',?\n/;
var $httpMinErr = minErr('$http');

function serializeValue(v) {
  if (isObject(v)) {
    return isDate(v) ? v.toISOString() : toJson(v);
  }
  return v;
}


/** @this */
function $HttpParamSerializerProvider() {
  /**
   * @ngdoc service
   * @name $httpParamSerializer
   * @description
   *
   * Default {@link $http `$http`} params serializer that converts objects to strings
   * according to the following rules:
   *
   * * `{'foo': 'bar'}` results in `foo=bar`
   * * `{'foo': Date.now()}` results in `foo=2015-04-01T09%3A50%3A49.262Z` (`toISOString()` and encoded representation of a Date object)
   * * `{'foo': ['bar', 'baz']}` results in `foo=bar&foo=baz` (repeated key for each array element)
   * * `{'foo': {'bar':'baz'}}` results in `foo=%7B%22bar%22%3A%22baz%22%7D` (stringified and encoded representation of an object)
   *
   * Note that serializer will sort the request parameters alphabetically.
   */

  this.$get = function() {
    return function ngParamSerializer(params) {
      if (!params) return '';
      var parts = [];
      forEachSorted(params, function(value, key) {
        if (value === null || isUndefined(value) || isFunction(value)) return;
        if (isArray(value)) {
          forEach(value, function(v) {
            parts.push(encodeUriQuery(key)  + '=' + encodeUriQuery(serializeValue(v)));
          });
        } else {
          parts.push(encodeUriQuery(key) + '=' + encodeUriQuery(serializeValue(value)));
        }
      });

      return parts.join('&');
    };
  };
}

/** @this */
function $HttpParamSerializerJQLikeProvider() {
  /**
   * @ngdoc service
   * @name $httpParamSerializerJQLike
   *
   * @description
   *
   * Alternative {@link $http `$http`} params serializer that follows
   * jQuery's [`param()`](http://api.jquery.com/jquery.param/) method logic.
   * The serializer will also sort the params alphabetically.
   *
   * To use it for serializing `$http` request parameters, set it as the `paramSerializer` property:
   *
   * ```js
   * $http({
   *   url: myUrl,
   *   method: 'GET',
   *   params: myParams,
   *   paramSerializer: '$httpParamSerializerJQLike'
   * });
   * ```
   *
   * It is also possible to set it as the default `paramSerializer` in the
   * {@link $httpProvider#defaults `$httpProvider`}.
   *
   * Additionally, you can inject the serializer and use it explicitly, for example to serialize
   * form data for submission:
   *
   * ```js
   * .controller(function($http, $httpParamSerializerJQLike) {
   *   //...
   *
   *   $http({
   *     url: myUrl,
   *     method: 'POST',
   *     data: $httpParamSerializerJQLike(myData),
   *     headers: {
   *       'Content-Type': 'application/x-www-form-urlencoded'
   *     }
   *   });
   *
   * });
   * ```
   *
   */
  this.$get = function() {
    return function jQueryLikeParamSerializer(params) {
      if (!params) return '';
      var parts = [];
      serialize(params, '', true);
      return parts.join('&');

      function serialize(toSerialize, prefix, topLevel) {
        if (isArray(toSerialize)) {
          forEach(toSerialize, function(value, index) {
            serialize(value, prefix + '[' + (isObject(value) ? index : '') + ']');
          });
        } else if (isObject(toSerialize) && !isDate(toSerialize)) {
          forEachSorted(toSerialize, function(value, key) {
            serialize(value, prefix +
                (topLevel ? '' : '[') +
                key +
                (topLevel ? '' : ']'));
          });
        } else {
          if (isFunction(toSerialize)) {
            toSerialize = toSerialize();
          }
          parts.push(encodeUriQuery(prefix) + '=' +
              (toSerialize == null ? '' : encodeUriQuery(serializeValue(toSerialize))));
        }
      }
    };
  };
}

function defaultHttpResponseTransform(data, headers) {
  if (isString(data)) {
    // Strip json vulnerability protection prefix and trim whitespace
    var tempData = data.replace(JSON_PROTECTION_PREFIX, '').trim();

    if (tempData) {
      var contentType = headers('Content-Type');
      var hasJsonContentType = contentType && (contentType.indexOf(APPLICATION_JSON) === 0);

      if (hasJsonContentType || isJsonLike(tempData)) {
        try {
          data = fromJson(tempData);
        } catch (e) {
          if (!hasJsonContentType) {
            return data;
          }
          throw $httpMinErr('baddata', 'Data must be a valid JSON object. Received: "{0}". ' +
          'Parse error: "{1}"', data, e);
        }
      }
    }
  }

  return data;
}

function isJsonLike(str) {
    var jsonStart = str.match(JSON_START);
    return jsonStart && JSON_ENDS[jsonStart[0]].test(str);
}

/**
 * Parse headers into key value object
 *
 * @param {string} headers Raw headers as a string
 * @returns {Object} Parsed headers as key value object
 */
function parseHeaders(headers) {
  var parsed = createMap(), i;

  function fillInParsed(key, val) {
    if (key) {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  }

  if (isString(headers)) {
    forEach(headers.split('\n'), function(line) {
      i = line.indexOf(':');
      fillInParsed(lowercase(trim(line.substr(0, i))), trim(line.substr(i + 1)));
    });
  } else if (isObject(headers)) {
    forEach(headers, function(headerVal, headerKey) {
      fillInParsed(lowercase(headerKey), trim(headerVal));
    });
  }

  return parsed;
}


/**
 * Returns a function that provides access to parsed headers.
 *
 * Headers are lazy parsed when first requested.
 * @see parseHeaders
 *
 * @param {(string|Object)} headers Headers to provide access to.
 * @returns {function(string=)} Returns a getter function which if called with:
 *
 *   - if called with an argument returns a single header value or null
 *   - if called with no arguments returns an object containing all headers.
 */
function headersGetter(headers) {
  var headersObj;

  return function(name) {
    if (!headersObj) headersObj =  parseHeaders(headers);

    if (name) {
      var value = headersObj[lowercase(name)];
      if (value === undefined) {
        value = null;
      }
      return value;
    }

    return headersObj;
  };
}


/**
 * Chain all given functions
 *
 * This function is used for both request and response transforming
 *
 * @param {*} data Data to transform.
 * @param {function(string=)} headers HTTP headers getter fn.
 * @param {number} status HTTP status code of the response.
 * @param {(Function|Array.<Function>)} fns Function or an array of functions.
 * @returns {*} Transformed data.
 */
function transformData(data, headers, status, fns) {
  if (isFunction(fns)) {
    return fns(data, headers, status);
  }

  forEach(fns, function(fn) {
    data = fn(data, headers, status);
  });

  return data;
}


function isSuccess(status) {
  return 200 <= status && status < 300;
}


/**
 * @ngdoc provider
 * @name $httpProvider
 * @this
 *
 * @description
 * Use `$httpProvider` to change the default behavior of the {@link ng.$http $http} service.
 */
function $HttpProvider() {
  /**
   * @ngdoc property
   * @name $httpProvider#defaults
   * @description
   *
   * Object containing default values for all {@link ng.$http $http} requests.
   *
   * - **`defaults.cache`** - {boolean|Object} - A boolean value or object created with
   * {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of HTTP responses
   * by default. See {@link $http#caching $http Caching} for more information.
   *
   * - **`defaults.headers`** - {Object} - Default headers for all $http requests.
   * Refer to {@link ng.$http#setting-http-headers $http} for documentation on
   * setting default headers.
   *     - **`defaults.headers.common`**
   *     - **`defaults.headers.post`**
   *     - **`defaults.headers.put`**
   *     - **`defaults.headers.patch`**
   *
   * - **`defaults.jsonpCallbackParam`** - `{string}` - the name of the query parameter that passes the name of the
   * callback in a JSONP request. The value of this parameter will be replaced with the expression generated by the
   * {@link $jsonpCallbacks} service. Defaults to `'callback'`.
   *
   * - **`defaults.paramSerializer`** - `{string|function(Object<string,string>):string}` - A function
   *  used to the prepare string representation of request parameters (specified as an object).
   *  If specified as string, it is interpreted as a function registered with the {@link auto.$injector $injector}.
   *  Defaults to {@link ng.$httpParamSerializer $httpParamSerializer}.
   *
   * - **`defaults.transformRequest`** -
   * `{Array<function(data, headersGetter)>|function(data, headersGetter)}` -
   * An array of functions (or a single function) which are applied to the request data.
   * By default, this is an array with one request transformation function:
   *
   *   - If the `data` property of the request configuration object contains an object, serialize it
   *     into JSON format.
   *
   * - **`defaults.transformResponse`** -
   * `{Array<function(data, headersGetter, status)>|function(data, headersGetter, status)}` -
   * An array of functions (or a single function) which are applied to the response data. By default,
   * this is an array which applies one response transformation function that does two things:
   *
   *  - If XSRF prefix is detected, strip it
   *    (see {@link ng.$http#security-considerations Security Considerations in the $http docs}).
   *  - If the `Content-Type` is `application/json` or the response looks like JSON,
   *    deserialize it using a JSON parser.
   *
   * - **`defaults.xsrfCookieName`** - {string} - Name of cookie containing the XSRF token.
   * Defaults value is `'XSRF-TOKEN'`.
   *
   * - **`defaults.xsrfHeaderName`** - {string} - Name of HTTP header to populate with the
   * XSRF token. Defaults value is `'X-XSRF-TOKEN'`.
   *
   */
  var defaults = this.defaults = {
    // transform incoming response data
    transformResponse: [defaultHttpResponseTransform],

    // transform outgoing request data
    transformRequest: [function(d) {
      return isObject(d) && !isFile(d) && !isBlob(d) && !isFormData(d) ? toJson(d) : d;
    }],

    // default headers
    headers: {
      common: {
        'Accept': 'application/json, text/plain, */*'
      },
      post:   shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
      put:    shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
      patch:  shallowCopy(CONTENT_TYPE_APPLICATION_JSON)
    },

    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',

    paramSerializer: '$httpParamSerializer',

    jsonpCallbackParam: 'callback'
  };

  var useApplyAsync = false;
  /**
   * @ngdoc method
   * @name $httpProvider#useApplyAsync
   * @description
   *
   * Configure $http service to combine processing of multiple http responses received at around
   * the same time via {@link ng.$rootScope.Scope#$applyAsync $rootScope.$applyAsync}. This can result in
   * significant performance improvement for bigger applications that make many HTTP requests
   * concurrently (common during application bootstrap).
   *
   * Defaults to false. If no value is specified, returns the current configured value.
   *
   * @param {boolean=} value If true, when requests are loaded, they will schedule a deferred
   *    "apply" on the next tick, giving time for subsequent requests in a roughly ~10ms window
   *    to load and share the same digest cycle.
   *
   * @returns {boolean|Object} If a value is specified, returns the $httpProvider for chaining.
   *    otherwise, returns the current configured value.
   */
  this.useApplyAsync = function(value) {
    if (isDefined(value)) {
      useApplyAsync = !!value;
      return this;
    }
    return useApplyAsync;
  };

  /**
   * @ngdoc property
   * @name $httpProvider#interceptors
   * @description
   *
   * Array containing service factories for all synchronous or asynchronous {@link ng.$http $http}
   * pre-processing of request or postprocessing of responses.
   *
   * These service factories are ordered by request, i.e. they are applied in the same order as the
   * array, on request, but reverse order, on response.
   *
   * {@link ng.$http#interceptors Interceptors detailed info}
   */
  var interceptorFactories = this.interceptors = [];

  /**
   * @ngdoc property
   * @name $httpProvider#xsrfTrustedOrigins
   * @description
   *
   * Array containing URLs whose origins are trusted to receive the XSRF token. See the
   * {@link ng.$http#security-considerations Security Considerations} sections for more details on
   * XSRF.
   *
   * **Note:** An "origin" consists of the [URI scheme](https://en.wikipedia.org/wiki/URI_scheme),
   * the [hostname](https://en.wikipedia.org/wiki/Hostname) and the
   * [port number](https://en.wikipedia.org/wiki/Port_(computer_networking). For `http:` and
   * `https:`, the port number can be omitted if using th default ports (80 and 443 respectively).
   * Examples: `http://example.com`, `https://api.example.com:9876`
   *
   * <div class="alert alert-warning">
   *   It is not possible to trust specific URLs/paths. The `path`, `query` and `fragment` parts
   *   of a URL will be ignored. For example, `https://foo.com/path/bar?query=baz#fragment` will be
   *   treated as `https://foo.com`, meaning that **all** requests to URLs starting with
   *   `https://foo.com/` will include the XSRF token.
   * </div>
   *
   * @example
   *
   * ```js
   * // App served from `https://example.com/`.
   * angular.
   *   module('xsrfTrustedOriginsExample', []).
   *   config(['$httpProvider', function($httpProvider) {
   *     $httpProvider.xsrfTrustedOrigins.push('https://api.example.com');
   *   }]).
   *   run(['$http', function($http) {
   *     // The XSRF token will be sent.
   *     $http.get('https://api.example.com/preferences').then(...);
   *
   *     // The XSRF token will NOT be sent.
   *     $http.get('https://stats.example.com/activity').then(...);
   *   }]);
   * ```
   */
  var xsrfTrustedOrigins = this.xsrfTrustedOrigins = [];

  /**
   * @ngdoc property
   * @name $httpProvider#xsrfWhitelistedOrigins
   * @description
   *
   * @deprecated
   * sinceVersion="1.8.1"
   *
   * This property is deprecated. Use {@link $httpProvider#xsrfTrustedOrigins xsrfTrustedOrigins}
   * instead.
   */
  Object.defineProperty(this, 'xsrfWhitelistedOrigins', {
    get: function() {
      return this.xsrfTrustedOrigins;
    },
    set: function(origins) {
      this.xsrfTrustedOrigins = origins;
    }
  });

  this.$get = ['$browser', '$httpBackend', '$$cookieReader', '$cacheFactory', '$rootScope', '$q', '$injector', '$sce',
      function($browser, $httpBackend, $$cookieReader, $cacheFactory, $rootScope, $q, $injector, $sce) {

    var defaultCache = $cacheFactory('$http');

    /**
     * Make sure that default param serializer is exposed as a function
     */
    defaults.paramSerializer = isString(defaults.paramSerializer) ?
      $injector.get(defaults.paramSerializer) : defaults.paramSerializer;

    /**
     * Interceptors stored in reverse order. Inner interceptors before outer interceptors.
     * The reversal is needed so that we can build up the interception chain around the
     * server request.
     */
    var reversedInterceptors = [];

    forEach(interceptorFactories, function(interceptorFactory) {
      reversedInterceptors.unshift(isString(interceptorFactory)
          ? $injector.get(interceptorFactory) : $injector.invoke(interceptorFactory));
    });

    /**
     * A function to check request URLs against a list of allowed origins.
     */
    var urlIsAllowedOrigin = urlIsAllowedOriginFactory(xsrfTrustedOrigins);

    /**
     * @ngdoc service
     * @kind function
     * @name $http
     * @requires ng.$httpBackend
     * @requires $cacheFactory
     * @requires $rootScope
     * @requires $q
     * @requires $injector
     *
     * @description
     * The `$http` service is a core AngularJS service that facilitates communication with the remote
     * HTTP servers via the browser's [XMLHttpRequest](https://developer.mozilla.org/en/xmlhttprequest)
     * object or via [JSONP](http://en.wikipedia.org/wiki/JSONP).
     *
     * For unit testing applications that use `$http` service, see
     * {@link ngMock.$httpBackend $httpBackend mock}.
     *
     * For a higher level of abstraction, please check out the {@link ngResource.$resource
     * $resource} service.
     *
     * The $http API is based on the {@link ng.$q deferred/promise APIs} exposed by
     * the $q service. While for simple usage patterns this doesn't matter much, for advanced usage
     * it is important to familiarize yourself with these APIs and the guarantees they provide.
     *
     *
     * ## General usage
     * The `$http` service is a function which takes a single argument — a {@link $http#usage configuration object} —
     * that is used to generate an HTTP request and returns  a {@link ng.$q promise} that is
     * resolved (request success) or rejected (request failure) with a
     * {@link ng.$http#$http-returns response} object.
     *
     * ```js
     *   // Simple GET request example:
     *   $http({
     *     method: 'GET',
     *     url: '/someUrl'
     *   }).then(function successCallback(response) {
     *       // this callback will be called asynchronously
     *       // when the response is available
     *     }, function errorCallback(response) {
     *       // called asynchronously if an error occurs
     *       // or server returns response with an error status.
     *     });
     * ```
     *
     *
     * ## Shortcut methods
     *
     * Shortcut methods are also available. All shortcut methods require passing in the URL, and
     * request data must be passed in for POST/PUT requests. An optional config can be passed as the
     * last argument.
     *
     * ```js
     *   $http.get('/someUrl', config).then(successCallback, errorCallback);
     *   $http.post('/someUrl', data, config).then(successCallback, errorCallback);
     * ```
     *
     * Complete list of shortcut methods:
     *
     * - {@link ng.$http#get $http.get}
     * - {@link ng.$http#head $http.head}
     * - {@link ng.$http#post $http.post}
     * - {@link ng.$http#put $http.put}
     * - {@link ng.$http#delete $http.delete}
     * - {@link ng.$http#jsonp $http.jsonp}
     * - {@link ng.$http#patch $http.patch}
     *
     *
     * ## Writing Unit Tests that use $http
     * When unit testing (using {@link ngMock ngMock}), it is necessary to call
     * {@link ngMock.$httpBackend#flush $httpBackend.flush()} to flush each pending
     * request using trained responses.
     *
     * ```
     * $httpBackend.expectGET(...);
     * $http.get(...);
     * $httpBackend.flush();
     * ```
     *
     * ## Setting HTTP Headers
     *
     * The $http service will automatically add certain HTTP headers to all requests. These defaults
     * can be fully configured by accessing the `$httpProvider.defaults.headers` configuration
     * object, which currently contains this default configuration:
     *
     * - `$httpProvider.defaults.headers.common` (headers that are common for all requests):
     *   - <code>Accept: application/json, text/plain, \*&#65279;/&#65279;\*</code>
     * - `$httpProvider.defaults.headers.post`: (header defaults for POST requests)
     *   - `Content-Type: application/json`
     * - `$httpProvider.defaults.headers.put` (header defaults for PUT requests)
     *   - `Content-Type: application/json`
     *
     * To add or overwrite these defaults, simply add or remove a property from these configuration
     * objects. To add headers for an HTTP method other than POST or PUT, simply add a new object
     * with the lowercased HTTP method name as the key, e.g.
     * `$httpProvider.defaults.headers.get = { 'My-Header' : 'value' }`.
     *
     * The defaults can also be set at runtime via the `$http.defaults` object in the same
     * fashion. For example:
     *
     * ```
     * module.run(function($http) {
     *   $http.defaults.headers.common.Authorization = 'Basic YmVlcDpib29w';
     * });
     * ```
     *
     * In addition, you can supply a `headers` property in the config object passed when
     * calling `$http(config)`, which overrides the defaults without changing them globally.
     *
     * To explicitly remove a header automatically added via $httpProvider.defaults.headers on a per request basis,
     * Use the `headers` property, setting the desired header to `undefined`. For example:
     *
     * ```js
     * var req = {
     *  method: 'POST',
     *  url: 'http://example.com',
     *  headers: {
     *    'Content-Type': undefined
     *  },
     *  data: { test: 'test' }
     * }
     *
     * $http(req).then(function(){...}, function(){...});
     * ```
     *
     * ## Transforming Requests and Responses
     *
     * Both requests and responses can be transformed using transformation functions: `transformRequest`
     * and `transformResponse`. These properties can be a single function that returns
     * the transformed value (`function(data, headersGetter, status)`) or an array of such transformation functions,
     * which allows you to `push` or `unshift` a new transformation function into the transformation chain.
     *
     * <div class="alert alert-warning">
     * **Note:** AngularJS does not make a copy of the `data` parameter before it is passed into the `transformRequest` pipeline.
     * That means changes to the properties of `data` are not local to the transform function (since Javascript passes objects by reference).
     * For example, when calling `$http.get(url, $scope.myObject)`, modifications to the object's properties in a transformRequest
     * function will be reflected on the scope and in any templates where the object is data-bound.
     * To prevent this, transform functions should have no side-effects.
     * If you need to modify properties, it is recommended to make a copy of the data, or create new object to return.
     * </div>
     *
     * ### Default Transformations
     *
     * The `$httpProvider` provider and `$http` service expose `defaults.transformRequest` and
     * `defaults.transformResponse` properties. If a request does not provide its own transformations
     * then these will be applied.
     *
     * You can augment or replace the default transformations by modifying these properties by adding to or
     * replacing the array.
     *
     * AngularJS provides the following default transformations:
     *
     * Request transformations (`$httpProvider.defaults.transformRequest` and `$http.defaults.transformRequest`) is
     * an array with one function that does the following:
     *
     * - If the `data` property of the request configuration object contains an object, serialize it
     *   into JSON format.
     *
     * Response transformations (`$httpProvider.defaults.transformResponse` and `$http.defaults.transformResponse`) is
     * an array with one function that does the following:
     *
     *  - If XSRF prefix is detected, strip it (see Security Considerations section below).
     *  - If the `Content-Type` is `application/json` or the response looks like JSON,
   *      deserialize it using a JSON parser.
     *
     *
     * ### Overriding the Default Transformations Per Request
     *
     * If you wish to override the request/response transformations only for a single request then provide
     * `transformRequest` and/or `transformResponse` properties on the configuration object passed
     * into `$http`.
     *
     * Note that if you provide these properties on the config object the default transformations will be
     * overwritten. If you wish to augment the default transformations then you must include them in your
     * local transformation array.
     *
     * The following code demonstrates adding a new response transformation to be run after the default response
     * transformations have been run.
     *
     * ```js
     * function appendTransform(defaults, transform) {
     *
     *   // We can't guarantee that the default transformation is an array
     *   defaults = angular.isArray(defaults) ? defaults : [defaults];
     *
     *   // Append the new transformation to the defaults
     *   return defaults.concat(transform);
     * }
     *
     * $http({
     *   url: '...',
     *   method: 'GET',
     *   transformResponse: appendTransform($http.defaults.transformResponse, function(value) {
     *     return doTransform(value);
     *   })
     * });
     * ```
     *
     *
     * ## Caching
     *
     * {@link ng.$http `$http`} responses are not cached by default. To enable caching, you must
     * set the config.cache value or the default cache value to TRUE or to a cache object (created
     * with {@link ng.$cacheFactory `$cacheFactory`}). If defined, the value of config.cache takes
     * precedence over the default cache value.
     *
     * In order to:
     *   * cache all responses - set the default cache value to TRUE or to a cache object
     *   * cache a specific response - set config.cache value to TRUE or to a cache object
     *
     * If caching is enabled, but neither the default cache nor config.cache are set to a cache object,
     * then the default `$cacheFactory("$http")` object is used.
     *
     * The default cache value can be set by updating the
     * {@link ng.$http#defaults `$http.defaults.cache`} property or the
     * {@link $httpProvider#defaults `$httpProvider.defaults.cache`} property.
     *
     * When caching is enabled, {@link ng.$http `$http`} stores the response from the server using
     * the relevant cache object. The next time the same request is made, the response is returned
     * from the cache without sending a request to the server.
     *
     * Take note that:
     *
     *   * Only GET and JSONP requests are cached.
     *   * The cache key is the request URL including search parameters; headers are not considered.
     *   * Cached responses are returned asynchronously, in the same way as responses from the server.
     *   * If multiple identical requests are made using the same cache, which is not yet populated,
     *     one request will be made to the server and remaining requests will return the same response.
     *   * A cache-control header on the response does not affect if or how responses are cached.
     *
     *
     * ## Interceptors
     *
     * Before you start creating interceptors, be sure to understand the
     * {@link ng.$q $q and deferred/promise APIs}.
     *
     * For purposes of global error handling, authentication, or any kind of synchronous or
     * asynchronous pre-processing of request or postprocessing of responses, it is desirable to be
     * able to intercept requests before they are handed to the server and
     * responses before they are handed over to the application code that
     * initiated these requests. The interceptors leverage the {@link ng.$q
     * promise APIs} to fulfill this need for both synchronous and asynchronous pre-processing.
     *
     * The interceptors are service factories that are registered with the `$httpProvider` by
     * adding them to the `$httpProvider.interceptors` array. The factory is called and
     * injected with dependencies (if specified) and returns the interceptor.
     *
     * There are two kinds of interceptors (and two kinds of rejection interceptors):
     *
     *   * `request`: interceptors get called with a http {@link $http#usage config} object. The function is free to
     *     modify the `config` object or create a new one. The function needs to return the `config`
     *     object directly, or a promise containing the `config` or a new `config` object.
     *   * `requestError`: interceptor gets called when a previous interceptor threw an error or
     *     resolved with a rejection.
     *   * `response`: interceptors get called with http `response` object. The function is free to
     *     modify the `response` object or create a new one. The function needs to return the `response`
     *     object directly, or as a promise containing the `response` or a new `response` object.
     *   * `responseError`: interceptor gets called when a previous interceptor threw an error or
     *     resolved with a rejection.
     *
     *
     * ```js
     *   // register the interceptor as a service
     *   $provide.factory('myHttpInterceptor', function($q, dependency1, dependency2) {
     *     return {
     *       // optional method
     *       'request': function(config) {
     *         // do something on success
     *         return config;
     *       },
     *
     *       // optional method
     *      'requestError': function(rejection) {
     *         // do something on error
     *         if (canRecover(rejection)) {
     *           return responseOrNewPromise
     *         }
     *         return $q.reject(rejection);
     *       },
     *
     *
     *
     *       // optional method
     *       'response': function(response) {
     *         // do something on success
     *         return response;
     *       },
     *
     *       // optional method
     *      'responseError': function(rejection) {
     *         // do something on error
     *         if (canRecover(rejection)) {
     *           return responseOrNewPromise
     *         }
     *         return $q.reject(rejection);
     *       }
     *     };
     *   });
     *
     *   $httpProvider.interceptors.push('myHttpInterceptor');
     *
     *
     *   // alternatively, register the interceptor via an anonymous factory
     *   $httpProvider.interceptors.push(function($q, dependency1, dependency2) {
     *     return {
     *      'request': function(config) {
     *          // same as above
     *       },
     *
     *       'response': function(response) {
     *          // same as above
     *       }
     *     };
     *   });
     * ```
     *
     * ## Security Considerations
     *
     * When designing web applications, consider security threats from:
     *
     * - [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
     * - [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery)
     *
     * Both server and the client must cooperate in order to eliminate these threats. AngularJS comes
     * pre-configured with strategies that address these issues, but for this to work backend server
     * cooperation is required.
     *
     * ### JSON Vulnerability Protection
     *
     * A [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
     * allows third party website to turn your JSON resource URL into
     * [JSONP](http://en.wikipedia.org/wiki/JSONP) request under some conditions. To
     * counter this your server can prefix all JSON requests with following string `")]}',\n"`.
     * AngularJS will automatically strip the prefix before processing it as JSON.
     *
     * For example if your server needs to return:
     * ```js
     * ['one','two']
     * ```
     *
     * which is vulnerable to attack, your server can return:
     * ```js
     * )]}',
     * ['one','two']
     * ```
     *
     * AngularJS will strip the prefix, before processing the JSON.
     *
     *
     * ### Cross Site Request Forgery (XSRF) Protection
     *
     * [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery) is an attack technique by
     * which the attacker can trick an authenticated user into unknowingly executing actions on your
     * website. AngularJS provides a mechanism to counter XSRF. When performing XHR requests, the
     * $http service reads a token from a cookie (by default, `XSRF-TOKEN`) and sets it as an HTTP
     * header (by default `X-XSRF-TOKEN`). Since only JavaScript that runs on your domain could read
     * the cookie, your server can be assured that the XHR came from JavaScript running on your
     * domain.
     *
     * To take advantage of this, your server needs to set a token in a JavaScript readable session
     * cookie called `XSRF-TOKEN` on the first HTTP GET request. On subsequent XHR requests the
     * server can verify that the cookie matches the `X-XSRF-TOKEN` HTTP header, and therefore be
     * sure that only JavaScript running on your domain could have sent the request. The token must
     * be unique for each user and must be verifiable by the server (to prevent the JavaScript from
     * making up its own tokens). We recommend that the token is a digest of your site's
     * authentication cookie with a [salt](https://en.wikipedia.org/wiki/Salt_(cryptography&#41;)
     * for added security.
     *
     * The header will &mdash; by default &mdash; **not** be set for cross-domain requests. This
     * prevents unauthorized servers (e.g. malicious or compromised 3rd-party APIs) from gaining
     * access to your users' XSRF tokens and exposing them to Cross Site Request Forgery. If you
     * want to, you can trust additional origins to also receive the XSRF token, by adding them
     * to {@link ng.$httpProvider#xsrfTrustedOrigins xsrfTrustedOrigins}. This might be
     * useful, for example, if your application, served from `example.com`, needs to access your API
     * at `api.example.com`.
     * See {@link ng.$httpProvider#xsrfTrustedOrigins $httpProvider.xsrfTrustedOrigins} for
     * more details.
     *
     * <div class="alert alert-danger">
     *   **Warning**<br />
     *   Only trusted origins that you have control over and make sure you understand the
     *   implications of doing so.
     * </div>
     *
     * The name of the cookie and the header can be specified using the `xsrfCookieName` and
     * `xsrfHeaderName` properties of either `$httpProvider.defaults` at config-time,
     * `$http.defaults` at run-time, or the per-request config object.
     *
     * In order to prevent collisions in environments where multiple AngularJS apps share the
     * same domain or subdomain, we recommend that each application uses a unique cookie name.
     *
     *
     * @param {object} config Object describing the request to be made and how it should be
     *    processed. The object has following properties:
     *
     *    - **method** – `{string}` – HTTP method (e.g. 'GET', 'POST', etc)
     *    - **url** – `{string|TrustedObject}` – Absolute or relative URL of the resource that is being requested;
     *      or an object created by a call to `$sce.trustAsResourceUrl(url)`.
     *    - **params** – `{Object.<string|Object>}` – Map of strings or objects which will be serialized
     *      with the `paramSerializer` and appended as GET parameters.
     *    - **data** – `{string|Object}` – Data to be sent as the request message data.
     *    - **headers** – `{Object}` – Map of strings or functions which return strings representing
     *      HTTP headers to send to the server. If the return value of a function is null, the
     *      header will not be sent. Functions accept a config object as an argument.
     *    - **eventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest object.
     *      To bind events to the XMLHttpRequest upload object, use `uploadEventHandlers`.
     *      The handler will be called in the context of a `$apply` block.
     *    - **uploadEventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest upload
     *      object. To bind events to the XMLHttpRequest object, use `eventHandlers`.
     *      The handler will be called in the context of a `$apply` block.
     *    - **xsrfHeaderName** – `{string}` – Name of HTTP header to populate with the XSRF token.
     *    - **xsrfCookieName** – `{string}` – Name of cookie containing the XSRF token.
     *    - **transformRequest** –
     *      `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
     *      transform function or an array of such functions. The transform function takes the http
     *      request body and headers and returns its transformed (typically serialized) version.
     *      See {@link ng.$http#overriding-the-default-transformations-per-request
     *      Overriding the Default Transformations}
     *    - **transformResponse** –
     *      `{function(data, headersGetter, status)|Array.<function(data, headersGetter, status)>}` –
     *      transform function or an array of such functions. The transform function takes the http
     *      response body, headers and status and returns its transformed (typically deserialized) version.
     *      See {@link ng.$http#overriding-the-default-transformations-per-request
     *      Overriding the Default Transformations}
     *    - **paramSerializer** - `{string|function(Object<string,string>):string}` - A function used to
     *      prepare the string representation of request parameters (specified as an object).
     *      If specified as string, it is interpreted as function registered with the
     *      {@link $injector $injector}, which means you can create your own serializer
     *      by registering it as a {@link auto.$provide#service service}.
     *      The default serializer is the {@link $httpParamSerializer $httpParamSerializer};
     *      alternatively, you can use the {@link $httpParamSerializerJQLike $httpParamSerializerJQLike}
     *    - **cache** – `{boolean|Object}` – A boolean value or object created with
     *      {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of the HTTP response.
     *      See {@link $http#caching $http Caching} for more information.
     *    - **timeout** – `{number|Promise}` – timeout in milliseconds, or {@link ng.$q promise}
     *      that should abort the request when resolved.
     *
     *      A numerical timeout or a promise returned from {@link ng.$timeout $timeout}, will set
     *      the `xhrStatus` in the {@link $http#$http-returns response} to "timeout", and any other
     *      resolved promise will set it to "abort", following standard XMLHttpRequest behavior.
     *
     *    - **withCredentials** - `{boolean}` - whether to set the `withCredentials` flag on the
     *      XHR object. See [requests with credentials](https://developer.mozilla.org/docs/Web/HTTP/Access_control_CORS#Requests_with_credentials)
     *      for more information.
     *    - **responseType** - `{string}` - see
     *      [XMLHttpRequest.responseType](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#xmlhttprequest-responsetype).
     *
     * @returns {HttpPromise} A {@link ng.$q `Promise}` that will be resolved (request success)
     *   or rejected (request failure) with a response object.
     *
     *   The response object has these properties:
     *
     *   - **data** – `{string|Object}` – The response body transformed with
     *     the transform functions.
     *   - **status** – `{number}` – HTTP status code of the response.
     *   - **headers** – `{function([headerName])}` – Header getter function.
     *   - **config** – `{Object}` – The configuration object that was used
     *     to generate the request.
     *   - **statusText** – `{string}` – HTTP status text of the response.
     *   - **xhrStatus** – `{string}` – Status of the XMLHttpRequest
     *     (`complete`, `error`, `timeout` or `abort`).
     *
     *
     *   A response status code between 200 and 299 is considered a success status
     *   and will result in the success callback being called. Any response status
     *   code outside of that range is considered an error status and will result
     *   in the error callback being called.
     *   Also, status codes less than -1 are normalized to zero. -1 usually means
     *   the request was aborted, e.g. using a `config.timeout`. More information
     *   about the status might be available in the `xhrStatus` property.
     *
     *   Note that if the response is a redirect, XMLHttpRequest will transparently
     *   follow it, meaning that the outcome (success or error) will be determined
     *   by the final response status code.
     *
     *
     * @property {Array.<Object>} pendingRequests Array of config objects for currently pending
     *   requests. This is primarily meant to be used for debugging purposes.
     *
     *
     * @example
<example module="httpExample" name="http-service">
<file name="index.html">
  <div ng-controller="FetchController">
    <select ng-model="method" aria-label="Request method">
      <option>GET</option>
      <option>JSONP</option>
    </select>
    <input type="text" ng-model="url" size="80" aria-label="URL" />
    <button id="fetchbtn" ng-click="fetch()">fetch</button><br>
    <button id="samplegetbtn" ng-click="updateModel('GET', 'http-hello.html')">Sample GET</button>
    <button id="samplejsonpbtn"
      ng-click="updateModel('JSONP',
                    'https://angularjs.org/greet.php?name=Super%20Hero')">
      Sample JSONP
    </button>
    <button id="invalidjsonpbtn"
      ng-click="updateModel('JSONP', 'https://angularjs.org/doesntexist')">
        Invalid JSONP
      </button>
    <pre>http status code: {{status}}</pre>
    <pre>http response data: {{data}}</pre>
  </div>
</file>
<file name="script.js">
  angular.module('httpExample', [])
    .config(['$sceDelegateProvider', function($sceDelegateProvider) {
      // We must add the JSONP endpoint that we are using to the trusted list to show that we trust it
      $sceDelegateProvider.trustedResourceUrlList([
        'self',
        'https://angularjs.org/**'
      ]);
    }])
    .controller('FetchController', ['$scope', '$http', '$templateCache',
      function($scope, $http, $templateCache) {
        $scope.method = 'GET';
        $scope.url = 'http-hello.html';

        $scope.fetch = function() {
          $scope.code = null;
          $scope.response = null;

          $http({method: $scope.method, url: $scope.url, cache: $templateCache}).
            then(function(response) {
              $scope.status = response.status;
              $scope.data = response.data;
            }, function(response) {
              $scope.data = response.data || 'Request failed';
              $scope.status = response.status;
          });
        };

        $scope.updateModel = function(method, url) {
          $scope.method = method;
          $scope.url = url;
        };
      }]);
</file>
<file name="http-hello.html">
  Hello, $http!
</file>
<file name="protractor.js" type="protractor">
  var status = element(by.binding('status'));
  var data = element(by.binding('data'));
  var fetchBtn = element(by.id('fetchbtn'));
  var sampleGetBtn = element(by.id('samplegetbtn'));
  var invalidJsonpBtn = element(by.id('invalidjsonpbtn'));

  it('should make an xhr GET request', function() {
    sampleGetBtn.click();
    fetchBtn.click();
    expect(status.getText()).toMatch('200');
    expect(data.getText()).toMatch(/Hello, \$http!/);
  });

// Commented out due to flakes. See https://github.com/angular/angular.js/issues/9185
// it('should make a JSONP request to angularjs.org', function() {
//   var sampleJsonpBtn = element(by.id('samplejsonpbtn'));
//   sampleJsonpBtn.click();
//   fetchBtn.click();
//   expect(status.getText()).toMatch('200');
//   expect(data.getText()).toMatch(/Super Hero!/);
// });

  it('should make JSONP request to invalid URL and invoke the error handler',
      function() {
    invalidJsonpBtn.click();
    fetchBtn.click();
    expect(status.getText()).toMatch('0');
    expect(data.getText()).toMatch('Request failed');
  });
</file>
</example>
     */
    function $http(requestConfig) {

      if (!isObject(requestConfig)) {
        throw minErr('$http')('badreq', 'Http request configuration must be an object.  Received: {0}', requestConfig);
      }

      if (!isString($sce.valueOf(requestConfig.url))) {
        throw minErr('$http')('badreq', 'Http request configuration url must be a string or a $sce trusted object.  Received: {0}', requestConfig.url);
      }

      var config = extend({
        method: 'get',
        transformRequest: defaults.transformRequest,
        transformResponse: defaults.transformResponse,
        paramSerializer: defaults.paramSerializer,
        jsonpCallbackParam: defaults.jsonpCallbackParam
      }, requestConfig);

      config.headers = mergeHeaders(requestConfig);
      config.method = uppercase(config.method);
      config.paramSerializer = isString(config.paramSerializer) ?
          $injector.get(config.paramSerializer) : config.paramSerializer;

      $browser.$$incOutstandingRequestCount('$http');

      var requestInterceptors = [];
      var responseInterceptors = [];
      var promise = $q.resolve(config);

      // apply interceptors
      forEach(reversedInterceptors, function(interceptor) {
        if (interceptor.request || interceptor.requestError) {
          requestInterceptors.unshift(interceptor.request, interceptor.requestError);
        }
        if (interceptor.response || interceptor.responseError) {
          responseInterceptors.push(interceptor.response, interceptor.responseError);
        }
      });

      promise = chainInterceptors(promise, requestInterceptors);
      promise = promise.then(serverRequest);
      promise = chainInterceptors(promise, responseInterceptors);
      promise = promise.finally(completeOutstandingRequest);

      return promise;


      function chainInterceptors(promise, interceptors) {
        for (var i = 0, ii = interceptors.length; i < ii;) {
          var thenFn = interceptors[i++];
          var rejectFn = interceptors[i++];

          promise = promise.then(thenFn, rejectFn);
        }

        interceptors.length = 0;

        return promise;
      }

      function completeOutstandingRequest() {
        $browser.$$completeOutstandingRequest(noop, '$http');
      }

      function executeHeaderFns(headers, config) {
        var headerContent, processedHeaders = {};

        forEach(headers, function(headerFn, header) {
          if (isFunction(headerFn)) {
            headerContent = headerFn(config);
            if (headerContent != null) {
              processedHeaders[header] = headerContent;
            }
          } else {
            processedHeaders[header] = headerFn;
          }
        });

        return processedHeaders;
      }

      function mergeHeaders(config) {
        var defHeaders = defaults.headers,
            reqHeaders = extend({}, config.headers),
            defHeaderName, lowercaseDefHeaderName, reqHeaderName;

        defHeaders = extend({}, defHeaders.common, defHeaders[lowercase(config.method)]);

        // using for-in instead of forEach to avoid unnecessary iteration after header has been found
        defaultHeadersIteration:
        for (defHeaderName in defHeaders) {
          lowercaseDefHeaderName = lowercase(defHeaderName);

          for (reqHeaderName in reqHeaders) {
            if (lowercase(reqHeaderName) === lowercaseDefHeaderName) {
              continue defaultHeadersIteration;
            }
          }

          reqHeaders[defHeaderName] = defHeaders[defHeaderName];
        }

        // execute if header value is a function for merged headers
        return executeHeaderFns(reqHeaders, shallowCopy(config));
      }

      function serverRequest(config) {
        var headers = config.headers;
        var reqData = transformData(config.data, headersGetter(headers), undefined, config.transformRequest);

        // strip content-type if data is undefined
        if (isUndefined(reqData)) {
          forEach(headers, function(value, header) {
            if (lowercase(header) === 'content-type') {
              delete headers[header];
            }
          });
        }

        if (isUndefined(config.withCredentials) && !isUndefined(defaults.withCredentials)) {
          config.withCredentials = defaults.withCredentials;
        }

        // send request
        return sendReq(config, reqData).then(transformResponse, transformResponse);
      }

      function transformResponse(response) {
        // make a copy since the response must be cacheable
        var resp = extend({}, response);
        resp.data = transformData(response.data, response.headers, response.status,
                                  config.transformResponse);
        return (isSuccess(response.status))
          ? resp
          : $q.reject(resp);
      }
    }

    $http.pendingRequests = [];

    /**
     * @ngdoc method
     * @name $http#get
     *
     * @description
     * Shortcut method to perform `GET` request.
     *
     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
     * See {@link ng.$http#$http-returns `$http()` return value}.
     */

    /**
     * @ngdoc method
     * @name $http#delete
     *
     * @description
     * Shortcut method to perform `DELETE` request.
     *
     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
     * See {@link ng.$http#$http-returns `$http()` return value}.
     */

    /**
     * @ngdoc method
     * @name $http#head
     *
     * @description
     * Shortcut method to perform `HEAD` request.
     *
     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
     * See {@link ng.$http#$http-returns `$http()` return value}.
     */

    /**
     * @ngdoc method
     * @name $http#jsonp
     *
     * @description
     * Shortcut method to perform `JSONP` request.
     *
     * Note that, since JSONP requests are sensitive because the response is given full access to the browser,
     * the url must be declared, via {@link $sce} as a trusted resource URL.
     * You can trust a URL by adding it to the trusted resource URL list via
     * {@link $sceDelegateProvider#trustedResourceUrlList  `$sceDelegateProvider.trustedResourceUrlList`} or
     * by explicitly trusting the URL via {@link $sce#trustAsResourceUrl `$sce.trustAsResourceUrl(url)`}.
     *
     * You should avoid generating the URL for the JSONP request from user provided data.
     * Provide additional query parameters via `params` property of the `config` parameter, rather than
     * modifying the URL itself.
     *
     * JSONP requests must specify a callback to be used in the response from the server. This callback
     * is passed as a query parameter in the request. You must specify the name of this parameter by
     * setting the `jsonpCallbackParam` property on the request config object.
     *
     * ```
     * $http.jsonp('some/trusted/url', {jsonpCallbackParam: 'callback'})
     * ```
     *
     * You can also specify a default callback parameter name in `$http.defaults.jsonpCallbackParam`.
     * Initially this is set to `'callback'`.
     *
     * <div class="alert alert-danger">
     * You can no longer use the `JSON_CALLBACK` string as a placeholder for specifying where the callback
     * parameter value should go.
     * </div>
     *
     * If you would like to customise where and how the callbacks are stored then try overriding
     * or decorating the {@link $jsonpCallbacks} service.
     *
     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
     * See {@link ng.$http#$http-returns `$http()` return value}.
     */
    createShortMethods('get', 'delete', 'head', 'jsonp');

    /**
     * @ngdoc method
     * @name $http#post
     *
     * @description
     * Shortcut method to perform `POST` request.
     *
     * @param {string} url Relative or absolute URL specifying the destination of the request
     * @param {*} data Request content
     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
     * See {@link ng.$http#$http-returns `$http()` return value}.
     */

    /**
     * @ngdoc method
     * @name $http#put
     *
     * @description
     * Shortcut method to perform `PUT` request.
     *
     * @param {string} url Relative or absolute URL specifying the destination of the request
     * @param {*} data Request content
     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
     * See {@link ng.$http#$http-returns `$http()` return value}.
     */

     /**
      * @ngdoc method
      * @name $http#patch
      *
      * @description
      * Shortcut method to perform `PATCH` request.
      *
      * @param {string} url Relative or absolute URL specifying the destination of the request
      * @param {*} data Request content
      * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
      * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
      * See {@link ng.$http#$http-returns `$http()` return value}.
      */
    createShortMethodsWithData('post', 'put', 'patch');

        /**
         * @ngdoc property
         * @name $http#defaults
         *
         * @description
         * Runtime equivalent of the `$httpProvider.defaults` property. Allows configuration of
         * default headers, withCredentials as well as request and response transformations.
         *
         * See "Setting HTTP Headers" and "Transforming Requests and Responses" sections above.
         */
    $http.defaults = defaults;


    return $http;


    function createShortMethods(names) {
      forEach(arguments, function(name) {
        $http[name] = function(url, config) {
          return $http(extend({}, config || {}, {
            method: name,
            url: url
          }));
        };
      });
    }


    function createShortMethodsWithData(name) {
      forEach(arguments, function(name) {
        $http[name] = function(url, data, config) {
          return $http(extend({}, config || {}, {
            method: name,
            url: url,
            data: data
          }));
        };
      });
    }


    /**
     * Makes the request.
     *
     * !!! ACCESSES CLOSURE VARS:
     * $httpBackend, defaults, $log, $rootScope, defaultCache, $http.pendingRequests
     */
    function sendReq(config, reqData) {
      var deferred = $q.defer(),
          promise = deferred.promise,
          cache,
          cachedResp,
          reqHeaders = config.headers,
          isJsonp = lowercase(config.method) === 'jsonp',
          url = config.url;

      if (isJsonp) {
        // JSONP is a pretty sensitive operation where we're allowing a script to have full access to
        // our DOM and JS space.  So we require that the URL satisfies SCE.RESOURCE_URL.
        url = $sce.getTrustedResourceUrl(url);
      } else if (!isString(url)) {
        // If it is not a string then the URL must be a $sce trusted object
        url = $sce.valueOf(url);
      }

      url = buildUrl(url, config.paramSerializer(config.params));

      if (isJsonp) {
        // Check the url and add the JSONP callback placeholder
        url = sanitizeJsonpCallbackParam(url, config.jsonpCallbackParam);
      }

      $http.pendingRequests.push(config);
      promise.then(removePendingReq, removePendingReq);

      if ((config.cache || defaults.cache) && config.cache !== false &&
          (config.method === 'GET' || config.method === 'JSONP')) {
        cache = isObject(config.cache) ? config.cache
            : isObject(/** @type {?} */ (defaults).cache)
              ? /** @type {?} */ (defaults).cache
              : defaultCache;
      }

      if (cache) {
        cachedResp = cache.get(url);
        if (isDefined(cachedResp)) {
          if (isPromiseLike(cachedResp)) {
            // cached request has already been sent, but there is no response yet
            cachedResp.then(resolvePromiseWithResult, resolvePromiseWithResult);
          } else {
            // serving from cache
            if (isArray(cachedResp)) {
              resolvePromise(cachedResp[1], cachedResp[0], shallowCopy(cachedResp[2]), cachedResp[3], cachedResp[4]);
            } else {
              resolvePromise(cachedResp, 200, {}, 'OK', 'complete');
            }
          }
        } else {
          // put the promise for the non-transformed response into cache as a placeholder
          cache.put(url, promise);
        }
      }


      // if we won't have the response in cache, set the xsrf headers and
      // send the request to the backend
      if (isUndefined(cachedResp)) {
        var xsrfValue = urlIsAllowedOrigin(config.url)
            ? $$cookieReader()[config.xsrfCookieName || defaults.xsrfCookieName]
            : undefined;
        if (xsrfValue) {
          reqHeaders[(config.xsrfHeaderName || defaults.xsrfHeaderName)] = xsrfValue;
        }

        $httpBackend(config.method, url, reqData, done, reqHeaders, config.timeout,
            config.withCredentials, config.responseType,
            createApplyHandlers(config.eventHandlers),
            createApplyHandlers(config.uploadEventHandlers));
      }

      return promise;

      function createApplyHandlers(eventHandlers) {
        if (eventHandlers) {
          var applyHandlers = {};
          forEach(eventHandlers, function(eventHandler, key) {
            applyHandlers[key] = function(event) {
              if (useApplyAsync) {
                $rootScope.$applyAsync(callEventHandler);
              } else if ($rootScope.$$phase) {
                callEventHandler();
              } else {
                $rootScope.$apply(callEventHandler);
              }

              function callEventHandler() {
                eventHandler(event);
              }
            };
          });
          return applyHandlers;
        }
      }


      /**
       * Callback registered to $httpBackend():
       *  - caches the response if desired
       *  - resolves the raw $http promise
       *  - calls $apply
       */
      function done(status, response, headersString, statusText, xhrStatus) {
        if (cache) {
          if (isSuccess(status)) {
            cache.put(url, [status, response, parseHeaders(headersString), statusText, xhrStatus]);
          } else {
            // remove promise from the cache
            cache.remove(url);
          }
        }

        function resolveHttpPromise() {
          resolvePromise(response, status, headersString, statusText, xhrStatus);
        }

        if (useApplyAsync) {
          $rootScope.$applyAsync(resolveHttpPromise);
        } else {
          resolveHttpPromise();
          if (!$rootScope.$$phase) $rootScope.$apply();
        }
      }


      /**
       * Resolves the raw $http promise.
       */
      function resolvePromise(response, status, headers, statusText, xhrStatus) {
        //status: HTTP response status code, 0, -1 (aborted by timeout / promise)
        status = status >= -1 ? status : 0;

        (isSuccess(status) ? deferred.resolve : deferred.reject)({
          data: response,
          status: status,
          headers: headersGetter(headers),
          config: config,
          statusText: statusText,
          xhrStatus: xhrStatus
        });
      }

      function resolvePromiseWithResult(result) {
        resolvePromise(result.data, result.status, shallowCopy(result.headers()), result.statusText, result.xhrStatus);
      }

      function removePendingReq() {
        var idx = $http.pendingRequests.indexOf(config);
        if (idx !== -1) $http.pendingRequests.splice(idx, 1);
      }
    }


    function buildUrl(url, serializedParams) {
      if (serializedParams.length > 0) {
        url += ((url.indexOf('?') === -1) ? '?' : '&') + serializedParams;
      }
      return url;
    }

    function sanitizeJsonpCallbackParam(url, cbKey) {
      var parts = url.split('?');
      if (parts.length > 2) {
        // Throw if the url contains more than one `?` query indicator
        throw $httpMinErr('badjsonp', 'Illegal use more than one "?", in url, "{1}"', url);
      }
      var params = parseKeyValue(parts[1]);
      forEach(params, function(value, key) {
        if (value === 'JSON_CALLBACK') {
          // Throw if the url already contains a reference to JSON_CALLBACK
          throw $httpMinErr('badjsonp', 'Illegal use of JSON_CALLBACK in url, "{0}"', url);
        }
        if (key === cbKey) {
          // Throw if the callback param was already provided
          throw $httpMinErr('badjsonp', 'Illegal use of callback param, "{0}", in url, "{1}"', cbKey, url);
        }
      });

      // Add in the JSON_CALLBACK callback param value
      url += ((url.indexOf('?') === -1) ? '?' : '&') + cbKey + '=JSON_CALLBACK';

      return url;
    }
  }];
}

/**
 * @ngdoc service
 * @name $xhrFactory
 * @this
 *
 * @description
 * Factory function used to create XMLHttpRequest objects.
 *
 * Replace or decorate this service to create your own custom XMLHttpRequest objects.
 *
 * ```
 * angular.module('myApp', [])
 * .factory('$xhrFactory', function() {
 *   return function createXhr(method, url) {
 *     return new window.XMLHttpRequest({mozSystem: true});
 *   };
 * });
 * ```
 *
 * @param {string} method HTTP method of the request (GET, POST, PUT, ..)
 * @param {string} url URL of the request.
 */
function $xhrFactoryProvider() {
  this.$get = function() {
    return function createXhr() {
      return new window.XMLHttpRequest();
    };
  };
}

/**
 * @ngdoc service
 * @name $httpBackend
 * @requires $jsonpCallbacks
 * @requires $document
 * @requires $xhrFactory
 * @this
 *
 * @description
 * HTTP backend used by the {@link ng.$http service} that delegates to
 * XMLHttpRequest object or JSONP and deals with browser incompatibilities.
 *
 * You should never need to use this service directly, instead use the higher-level abstractions:
 * {@link ng.$http $http} or {@link ngResource.$resource $resource}.
 *
 * During testing this implementation is swapped with {@link ngMock.$httpBackend mock
 * $httpBackend} which can be trained with responses.
 */
function $HttpBackendProvider() {
  this.$get = ['$browser', '$jsonpCallbacks', '$document', '$xhrFactory', function($browser, $jsonpCallbacks, $document, $xhrFactory) {
    return createHttpBackend($browser, $xhrFactory, $browser.defer, $jsonpCallbacks, $document[0]);
  }];
}

function createHttpBackend($browser, createXhr, $browserDefer, callbacks, rawDocument) {
  // TODO(vojta): fix the signature
  return function(method, url, post, callback, headers, timeout, withCredentials, responseType, eventHandlers, uploadEventHandlers) {
    url = url || $browser.url();

    if (lowercase(method) === 'jsonp') {
      var callbackPath = callbacks.createCallback(url);
      var jsonpDone = jsonpReq(url, callbackPath, function(status, text) {
        // jsonpReq only ever sets status to 200 (OK), 404 (ERROR) or -1 (WAITING)
        var response = (status === 200) && callbacks.getResponse(callbackPath);
        completeRequest(callback, status, response, '', text, 'complete');
        callbacks.removeCallback(callbackPath);
      });
    } else {

      var xhr = createXhr(method, url);
      var abortedByTimeout = false;

      xhr.open(method, url, true);
      forEach(headers, function(value, key) {
        if (isDefined(value)) {
            xhr.setRequestHeader(key, value);
        }
      });

      xhr.onload = function requestLoaded() {
        var statusText = xhr.statusText || '';

        // responseText is the old-school way of retrieving response (supported by IE9)
        // response/responseType properties were introduced in XHR Level2 spec (supported by IE10)
        var response = ('response' in xhr) ? xhr.response : xhr.responseText;

        // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
        var status = xhr.status === 1223 ? 204 : xhr.status;

        // fix status code when it is 0 (0 status is undocumented).
        // Occurs when accessing file resources or on Android 4.1 stock browser
        // while retrieving files from application cache.
        if (status === 0) {
          status = response ? 200 : urlResolve(url).protocol === 'file' ? 404 : 0;
        }

        completeRequest(callback,
            status,
            response,
            xhr.getAllResponseHeaders(),
            statusText,
            'complete');
      };

      var requestError = function() {
        // The response is always empty
        // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
        completeRequest(callback, -1, null, null, '', 'error');
      };

      var requestAborted = function() {
        completeRequest(callback, -1, null, null, '', abortedByTimeout ? 'timeout' : 'abort');
      };

      var requestTimeout = function() {
        // The response is always empty
        // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
        completeRequest(callback, -1, null, null, '', 'timeout');
      };

      xhr.onerror = requestError;
      xhr.ontimeout = requestTimeout;
      xhr.onabort = requestAborted;

      forEach(eventHandlers, function(value, key) {
        xhr.addEventListener(key, value);
      });

      forEach(uploadEventHandlers, function(value, key) {
        xhr.upload.addEventListener(key, value);
      });

      if (withCredentials) {
        xhr.withCredentials = true;
      }

      if (responseType) {
        try {
          xhr.responseType = responseType;
        } catch (e) {
          // WebKit added support for the json responseType value on 09/03/2013
          // https://bugs.webkit.org/show_bug.cgi?id=73648. Versions of Safari prior to 7 are
          // known to throw when setting the value "json" as the response type. Other older
          // browsers implementing the responseType
          //
          // The json response type can be ignored if not supported, because JSON payloads are
          // parsed on the client-side regardless.
          if (responseType !== 'json') {
            throw e;
          }
        }
      }

      xhr.send(isUndefined(post) ? null : post);
    }

    // Since we are using xhr.abort() when a request times out, we have to set a flag that
    // indicates to requestAborted if the request timed out or was aborted.
    //
    // http.timeout = numerical timeout   timeout
    // http.timeout = $timeout            timeout
    // http.timeout = promise             abort
    // xhr.abort()                        abort (The xhr object is normally inaccessible, but
    //                                    can be exposed with the xhrFactory)
    if (timeout > 0) {
      var timeoutId = $browserDefer(function() {
        timeoutRequest('timeout');
      }, timeout);
    } else if (isPromiseLike(timeout)) {
      timeout.then(function() {
        timeoutRequest(isDefined(timeout.$$timeoutId) ? 'timeout' : 'abort');
      });
    }

    function timeoutRequest(reason) {
      abortedByTimeout = reason === 'timeout';
      if (jsonpDone) {
        jsonpDone();
      }
      if (xhr) {
        xhr.abort();
      }
    }

    function completeRequest(callback, status, response, headersString, statusText, xhrStatus) {
      // cancel timeout and subsequent timeout promise resolution
      if (isDefined(timeoutId)) {
        $browserDefer.cancel(timeoutId);
      }
      jsonpDone = xhr = null;

      callback(status, response, headersString, statusText, xhrStatus);
    }
  };

  function jsonpReq(url, callbackPath, done) {
    url = url.replace('JSON_CALLBACK', callbackPath);
    // we can't use jQuery/jqLite here because jQuery does crazy stuff with script elements, e.g.:
    // - fetches local scripts via XHR and evals them
    // - adds and immediately removes script elements from the document
    var script = rawDocument.createElement('script'), callback = null;
    script.type = 'text/javascript';
    script.src = url;
    script.async = true;

    callback = function(event) {
      script.removeEventListener('load', callback);
      script.removeEventListener('error', callback);
      rawDocument.body.removeChild(script);
      script = null;
      var status = -1;
      var text = 'unknown';

      if (event) {
        if (event.type === 'load' && !callbacks.wasCalled(callbackPath)) {
          event = { type: 'error' };
        }
        text = event.type;
        status = event.type === 'error' ? 404 : 200;
      }

      if (done) {
        done(status, text);
      }
    };

    script.addEventListener('load', callback);
    script.addEventListener('error', callback);
    rawDocument.body.appendChild(script);
    return callback;
  }
}

var $interpolateMinErr = angular.$interpolateMinErr = minErr('$interpolate');
$interpolateMinErr.throwNoconcat = function(text) {
  throw $interpolateMinErr('noconcat',
      'Error while interpolating: {0}\nStrict Contextual Escaping disallows ' +
      'interpolations that concatenate multiple expressions when a trusted value is ' +
      'required.  See http://docs.angularjs.org/api/ng.$sce', text);
};

$interpolateMinErr.interr = function(text, err) {
  return $interpolateMinErr('interr', 'Can\'t interpolate: {0}\n{1}', text, err.toString());
};

/**
 * @ngdoc provider
 * @name $interpolateProvider
 * @this
 *
 * @description
 *
 * Used for configuring the interpolation markup. Defaults to `{{` and `}}`.
 *
 * <div class="alert alert-danger">
 * This feature is sometimes used to mix different markup languages, e.g. to wrap an AngularJS
 * template within a Python Jinja template (or any other template language). Mixing templating
 * languages is **very dangerous**. The embedding template language will not safely escape AngularJS
 * expressions, so any user-controlled values in the template will cause Cross Site Scripting (XSS)
 * security bugs!
 * </div>
 *
 * @example
<example name="custom-interpolation-markup" module="customInterpolationApp">
<file name="index.html">
<script>
  var customInterpolationApp = angular.module('customInterpolationApp', []);

  customInterpolationApp.config(function($interpolateProvider) {
    $interpolateProvider.startSymbol('//');
    $interpolateProvider.endSymbol('//');
  });


  customInterpolationApp.controller('DemoController', function() {
      this.label = "This binding is brought you by // interpolation symbols.";
  });
</script>
<div ng-controller="DemoController as demo">
    //demo.label//
</div>
</file>
<file name="protractor.js" type="protractor">
  it('should interpolate binding with custom symbols', function() {
    expect(element(by.binding('demo.label')).getText()).toBe('This binding is brought you by // interpolation symbols.');
  });
</file>
</example>
 */
function $InterpolateProvider() {
  var startSymbol = '{{';
  var endSymbol = '}}';

  /**
   * @ngdoc method
   * @name $interpolateProvider#startSymbol
   * @description
   * Symbol to denote start of expression in the interpolated string. Defaults to `{{`.
   *
   * @param {string=} value new value to set the starting symbol to.
   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
   */
  this.startSymbol = function(value) {
    if (value) {
      startSymbol = value;
      return this;
    }
    return startSymbol;
  };

  /**
   * @ngdoc method
   * @name $interpolateProvider#endSymbol
   * @description
   * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
   *
   * @param {string=} value new value to set the ending symbol to.
   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
   */
  this.endSymbol = function(value) {
    if (value) {
      endSymbol = value;
      return this;
    }
    return endSymbol;
  };


  this.$get = ['$parse', '$exceptionHandler', '$sce', function($parse, $exceptionHandler, $sce) {
    var startSymbolLength = startSymbol.length,
        endSymbolLength = endSymbol.length,
        escapedStartRegexp = new RegExp(startSymbol.replace(/./g, escape), 'g'),
        escapedEndRegexp = new RegExp(endSymbol.replace(/./g, escape), 'g');

    function escape(ch) {
      return '\\\\\\' + ch;
    }

    function unescapeText(text) {
      return text.replace(escapedStartRegexp, startSymbol).
        replace(escapedEndRegexp, endSymbol);
    }

    // TODO: this is the same as the constantWatchDelegate in parse.js
    function constantWatchDelegate(scope, listener, objectEquality, constantInterp) {
      var unwatch = scope.$watch(function constantInterpolateWatch(scope) {
        unwatch();
        return constantInterp(scope);
      }, listener, objectEquality);
      return unwatch;
    }

    /**
     * @ngdoc service
     * @name $interpolate
     * @kind function
     *
     * @requires $parse
     * @requires $sce
     *
     * @description
     *
     * Compiles a string with markup into an interpolation function. This service is used by the
     * HTML {@link ng.$compile $compile} service for data binding. See
     * {@link ng.$interpolateProvider $interpolateProvider} for configuring the
     * interpolation markup.
     *
     *
     * ```js
     *   var $interpolate = ...; // injected
     *   var exp = $interpolate('Hello {{name | uppercase}}!');
     *   expect(exp({name:'AngularJS'})).toEqual('Hello ANGULARJS!');
     * ```
     *
     * `$interpolate` takes an optional fourth argument, `allOrNothing`. If `allOrNothing` is
     * `true`, the interpolation function will return `undefined` unless all embedded expressions
     * evaluate to a value other than `undefined`.
     *
     * ```js
     *   var $interpolate = ...; // injected
     *   var context = {greeting: 'Hello', name: undefined };
     *
     *   // default "forgiving" mode
     *   var exp = $interpolate('{{greeting}} {{name}}!');
     *   expect(exp(context)).toEqual('Hello !');
     *
     *   // "allOrNothing" mode
     *   exp = $interpolate('{{greeting}} {{name}}!', false, null, true);
     *   expect(exp(context)).toBeUndefined();
     *   context.name = 'AngularJS';
     *   expect(exp(context)).toEqual('Hello AngularJS!');
     * ```
     *
     * `allOrNothing` is useful for interpolating URLs. `ngSrc` and `ngSrcset` use this behavior.
     *
     * #### Escaped Interpolation
     * $interpolate provides a mechanism for escaping interpolation markers. Start and end markers
     * can be escaped by preceding each of their characters with a REVERSE SOLIDUS U+005C (backslash).
     * It will be rendered as a regular start/end marker, and will not be interpreted as an expression
     * or binding.
     *
     * This enables web-servers to prevent script injection attacks and defacing attacks, to some
     * degree, while also enabling code examples to work without relying on the
     * {@link ng.directive:ngNonBindable ngNonBindable} directive.
     *
     * **For security purposes, it is strongly encouraged that web servers escape user-supplied data,
     * replacing angle brackets (&lt;, &gt;) with &amp;lt; and &amp;gt; respectively, and replacing all
     * interpolation start/end markers with their escaped counterparts.**
     *
     * Escaped interpolation markers are only replaced with the actual interpolation markers in rendered
     * output when the $interpolate service processes the text. So, for HTML elements interpolated
     * by {@link ng.$compile $compile}, or otherwise interpolated with the `mustHaveExpression` parameter
     * set to `true`, the interpolated text must contain an unescaped interpolation expression. As such,
     * this is typically useful only when user-data is used in rendering a template from the server, or
     * when otherwise untrusted data is used by a directive.
     *
     * <example name="interpolation">
     *  <file name="index.html">
     *    <div ng-init="username='A user'">
     *      <p ng-init="apptitle='Escaping demo'">{{apptitle}}: \{\{ username = "defaced value"; \}\}
     *        </p>
     *      <p><strong>{{username}}</strong> attempts to inject code which will deface the
     *        application, but fails to accomplish their task, because the server has correctly
     *        escaped the interpolation start/end markers with REVERSE SOLIDUS U+005C (backslash)
     *        characters.</p>
     *      <p>Instead, the result of the attempted script injection is visible, and can be removed
     *        from the database by an administrator.</p>
     *    </div>
     *  </file>
     * </example>
     *
     * @knownIssue
     * It is currently not possible for an interpolated expression to contain the interpolation end
     * symbol. For example, `{{ '}}' }}` will be incorrectly interpreted as `{{ ' }}` + `' }}`, i.e.
     * an interpolated expression consisting of a single-quote (`'`) and the `' }}` string.
     *
     * @knownIssue
     * All directives and components must use the standard `{{` `}}` interpolation symbols
     * in their templates. If you change the application interpolation symbols the {@link $compile}
     * service will attempt to denormalize the standard symbols to the custom symbols.
     * The denormalization process is not clever enough to know not to replace instances of the standard
     * symbols where they would not normally be treated as interpolation symbols. For example in the following
     * code snippet the closing braces of the literal object will get incorrectly denormalized:
     *
     * ```
     * <div data-context='{"context":{"id":3,"type":"page"}}">
     * ```
     *
     * The workaround is to ensure that such instances are separated by whitespace:
     * ```
     * <div data-context='{"context":{"id":3,"type":"page"} }">
     * ```
     *
     * See https://github.com/angular/angular.js/pull/14610#issuecomment-219401099 for more information.
     *
     * @param {string} text The text with markup to interpolate.
     * @param {boolean=} mustHaveExpression if set to true then the interpolation string must have
     *    embedded expression in order to return an interpolation function. Strings with no
     *    embedded expression will return null for the interpolation function.
     * @param {string=} trustedContext when provided, the returned function passes the interpolated
     *    result through {@link ng.$sce#getTrusted $sce.getTrusted(interpolatedResult,
     *    trustedContext)} before returning it.  Refer to the {@link ng.$sce $sce} service that
     *    provides Strict Contextual Escaping for details.
     * @param {boolean=} allOrNothing if `true`, then the returned function returns undefined
     *    unless all embedded expressions evaluate to a value other than `undefined`.
     * @returns {function(context)} an interpolation function which is used to compute the
     *    interpolated string. The function has these parameters:
     *
     * - `context`: evaluation context for all expressions embedded in the interpolated text
     */
    function $interpolate(text, mustHaveExpression, trustedContext, allOrNothing) {
      var contextAllowsConcatenation = trustedContext === $sce.URL || trustedContext === $sce.MEDIA_URL;

      // Provide a quick exit and simplified result function for text with no interpolation
      if (!text.length || text.indexOf(startSymbol) === -1) {
        if (mustHaveExpression) return;

        var unescapedText = unescapeText(text);
        if (contextAllowsConcatenation) {
          unescapedText = $sce.getTrusted(trustedContext, unescapedText);
        }
        var constantInterp = valueFn(unescapedText);
        constantInterp.exp = text;
        constantInterp.expressions = [];
        constantInterp.$$watchDelegate = constantWatchDelegate;

        return constantInterp;
      }

      allOrNothing = !!allOrNothing;
      var startIndex,
          endIndex,
          index = 0,
          expressions = [],
          parseFns,
          textLength = text.length,
          exp,
          concat = [],
          expressionPositions = [],
          singleExpression;


      while (index < textLength) {
        if (((startIndex = text.indexOf(startSymbol, index)) !== -1) &&
             ((endIndex = text.indexOf(endSymbol, startIndex + startSymbolLength)) !== -1)) {
          if (index !== startIndex) {
            concat.push(unescapeText(text.substring(index, startIndex)));
          }
          exp = text.substring(startIndex + startSymbolLength, endIndex);
          expressions.push(exp);
          index = endIndex + endSymbolLength;
          expressionPositions.push(concat.length);
          concat.push(''); // Placeholder that will get replaced with the evaluated expression.
        } else {
          // we did not find an interpolation, so we have to add the remainder to the separators array
          if (index !== textLength) {
            concat.push(unescapeText(text.substring(index)));
          }
          break;
        }
      }

      singleExpression = concat.length === 1 && expressionPositions.length === 1;
      // Intercept expression if we need to stringify concatenated inputs, which may be SCE trusted
      // objects rather than simple strings
      // (we don't modify the expression if the input consists of only a single trusted input)
      var interceptor = contextAllowsConcatenation && singleExpression ? undefined : parseStringifyInterceptor;
      parseFns = expressions.map(function(exp) { return $parse(exp, interceptor); });

      // Concatenating expressions makes it hard to reason about whether some combination of
      // concatenated values are unsafe to use and could easily lead to XSS.  By requiring that a
      // single expression be used for some $sce-managed secure contexts (RESOURCE_URLs mostly),
      // we ensure that the value that's used is assigned or constructed by some JS code somewhere
      // that is more testable or make it obvious that you bound the value to some user controlled
      // value.  This helps reduce the load when auditing for XSS issues.

      // Note that URL and MEDIA_URL $sce contexts do not need this, since `$sce` can sanitize the values
      // passed to it. In that case, `$sce.getTrusted` will be called on either the single expression
      // or on the overall concatenated string (losing trusted types used in the mix, by design).
      // Both these methods will sanitize plain strings. Also, HTML could be included, but since it's
      // only used in srcdoc attributes, this would not be very useful.

      if (!mustHaveExpression || expressions.length) {
        var compute = function(values) {
          for (var i = 0, ii = expressions.length; i < ii; i++) {
            if (allOrNothing && isUndefined(values[i])) return;
            concat[expressionPositions[i]] = values[i];
          }

          if (contextAllowsConcatenation) {
            // If `singleExpression` then `concat[0]` might be a "trusted" value or `null`, rather than a string
            return $sce.getTrusted(trustedContext, singleExpression ? concat[0] : concat.join(''));
          } else if (trustedContext && concat.length > 1) {
            // This context does not allow more than one part, e.g. expr + string or exp + exp.
            $interpolateMinErr.throwNoconcat(text);
          }
          // In an unprivileged context or only one part: just concatenate and return.
          return concat.join('');
        };

        return extend(function interpolationFn(context) {
            var i = 0;
            var ii = expressions.length;
            var values = new Array(ii);

            try {
              for (; i < ii; i++) {
                values[i] = parseFns[i](context);
              }

              return compute(values);
            } catch (err) {
              $exceptionHandler($interpolateMinErr.interr(text, err));
            }

          }, {
          // all of these properties are undocumented for now
          exp: text, //just for compatibility with regular watchers created via $watch
          expressions: expressions,
          $$watchDelegate: function(scope, listener) {
            var lastValue;
            return scope.$watchGroup(parseFns, /** @this */ function interpolateFnWatcher(values, oldValues) {
              var currValue = compute(values);
              listener.call(this, currValue, values !== oldValues ? lastValue : currValue, scope);
              lastValue = currValue;
            });
          }
        });
      }

      function parseStringifyInterceptor(value) {
        try {
          // In concatenable contexts, getTrusted comes at the end, to avoid sanitizing individual
          // parts of a full URL. We don't care about losing the trustedness here.
          // In non-concatenable contexts, where there is only one expression, this interceptor is
          // not applied to the expression.
          value = (trustedContext && !contextAllowsConcatenation) ?
                    $sce.getTrusted(trustedContext, value) :
                    $sce.valueOf(value);
          return allOrNothing && !isDefined(value) ? value : stringify(value);
        } catch (err) {
          $exceptionHandler($interpolateMinErr.interr(text, err));
        }
      }
    }


    /**
     * @ngdoc method
     * @name $interpolate#startSymbol
     * @description
     * Symbol to denote the start of expression in the interpolated string. Defaults to `{{`.
     *
     * Use {@link ng.$interpolateProvider#startSymbol `$interpolateProvider.startSymbol`} to change
     * the symbol.
     *
     * @returns {string} start symbol.
     */
    $interpolate.startSymbol = function() {
      return startSymbol;
    };


    /**
     * @ngdoc method
     * @name $interpolate#endSymbol
     * @description
     * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
     *
     * Use {@link ng.$interpolateProvider#endSymbol `$interpolateProvider.endSymbol`} to change
     * the symbol.
     *
     * @returns {string} end symbol.
     */
    $interpolate.endSymbol = function() {
      return endSymbol;
    };

    return $interpolate;
  }];
}

var $intervalMinErr = minErr('$interval');

/** @this */
function $IntervalProvider() {
  this.$get = ['$$intervalFactory', '$window',
       function($$intervalFactory,   $window) {
    var intervals = {};
    var setIntervalFn = function(tick, delay, deferred) {
      var id = $window.setInterval(tick, delay);
      intervals[id] = deferred;
      return id;
    };
    var clearIntervalFn = function(id) {
      $window.clearInterval(id);
      delete intervals[id];
    };

    /**
     * @ngdoc service
     * @name $interval
     *
     * @description
     * AngularJS's wrapper for `window.setInterval`. The `fn` function is executed every `delay`
     * milliseconds.
     *
     * The return value of registering an interval function is a promise. This promise will be
     * notified upon each tick of the interval, and will be resolved after `count` iterations, or
     * run indefinitely if `count` is not defined. The value of the notification will be the
     * number of iterations that have run.
     * To cancel an interval, call `$interval.cancel(promise)`.
     *
     * In tests you can use {@link ngMock.$interval#flush `$interval.flush(millis)`} to
     * move forward by `millis` milliseconds and trigger any functions scheduled to run in that
     * time.
     *
     * <div class="alert alert-warning">
     * **Note**: Intervals created by this service must be explicitly destroyed when you are finished
     * with them.  In particular they are not automatically destroyed when a controller's scope or a
     * directive's element are destroyed.
     * You should take this into consideration and make sure to always cancel the interval at the
     * appropriate moment.  See the example below for more details on how and when to do this.
     * </div>
     *
     * @param {function()} fn A function that should be called repeatedly. If no additional arguments
     *   are passed (see below), the function is called with the current iteration count.
     * @param {number} delay Number of milliseconds between each function call.
     * @param {number=} [count=0] Number of times to repeat. If not set, or 0, will repeat
     *   indefinitely.
     * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
     *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
     * @param {...*=} Pass additional parameters to the executed function.
     * @returns {promise} A promise which will be notified on each iteration. It will resolve once all iterations of the interval complete.
     *
     * @example
     * <example module="intervalExample" name="interval-service">
     * <file name="index.html">
     *   <script>
     *     angular.module('intervalExample', [])
     *       .controller('ExampleController', ['$scope', '$interval',
     *         function($scope, $interval) {
     *           $scope.format = 'M/d/yy h:mm:ss a';
     *           $scope.blood_1 = 100;
     *           $scope.blood_2 = 120;
     *
     *           var stop;
     *           $scope.fight = function() {
     *             // Don't start a new fight if we are already fighting
     *             if ( angular.isDefined(stop) ) return;
     *
     *             stop = $interval(function() {
     *               if ($scope.blood_1 > 0 && $scope.blood_2 > 0) {
     *                 $scope.blood_1 = $scope.blood_1 - 3;
     *                 $scope.blood_2 = $scope.blood_2 - 4;
     *               } else {
     *                 $scope.stopFight();
     *               }
     *             }, 100);
     *           };
     *
     *           $scope.stopFight = function() {
     *             if (angular.isDefined(stop)) {
     *               $interval.cancel(stop);
     *               stop = undefined;
     *             }
     *           };
     *
     *           $scope.resetFight = function() {
     *             $scope.blood_1 = 100;
     *             $scope.blood_2 = 120;
     *           };
     *
     *           $scope.$on('$destroy', function() {
     *             // Make sure that the interval is destroyed too
     *             $scope.stopFight();
     *           });
     *         }])
     *       // Register the 'myCurrentTime' directive factory method.
     *       // We inject $interval and dateFilter service since the factory method is DI.
     *       .directive('myCurrentTime', ['$interval', 'dateFilter',
     *         function($interval, dateFilter) {
     *           // return the directive link function. (compile function not needed)
     *           return function(scope, element, attrs) {
     *             var format,  // date format
     *                 stopTime; // so that we can cancel the time updates
     *
     *             // used to update the UI
     *             function updateTime() {
     *               element.text(dateFilter(new Date(), format));
     *             }
     *
     *             // watch the expression, and update the UI on change.
     *             scope.$watch(attrs.myCurrentTime, function(value) {
     *               format = value;
     *               updateTime();
     *             });
     *
     *             stopTime = $interval(updateTime, 1000);
     *
     *             // listen on DOM destroy (removal) event, and cancel the next UI update
     *             // to prevent updating time after the DOM element was removed.
     *             element.on('$destroy', function() {
     *               $interval.cancel(stopTime);
     *             });
     *           }
     *         }]);
     *   </script>
     *
     *   <div>
     *     <div ng-controller="ExampleController">
     *       <label>Date format: <input ng-model="format"></label> <hr/>
     *       Current time is: <span my-current-time="format"></span>
     *       <hr/>
     *       Blood 1 : <font color='red'>{{blood_1}}</font>
     *       Blood 2 : <font color='red'>{{blood_2}}</font>
     *       <button type="button" data-ng-click="fight()">Fight</button>
     *       <button type="button" data-ng-click="stopFight()">StopFight</button>
     *       <button type="button" data-ng-click="resetFight()">resetFight</button>
     *     </div>
     *   </div>
     *
     * </file>
     * </example>
     */
    var interval = $$intervalFactory(setIntervalFn, clearIntervalFn);

    /**
     * @ngdoc method
     * @name $interval#cancel
     *
     * @description
     * Cancels a task associated with the `promise`.
     *
     * @param {Promise=} promise returned by the `$interval` function.
     * @returns {boolean} Returns `true` if the task was successfully canceled.
     */
    interval.cancel = function(promise) {
      if (!promise) return false;

      if (!promise.hasOwnProperty('$$intervalId')) {
        throw $intervalMinErr('badprom',
            '`$interval.cancel()` called with a promise that was not generated by `$interval()`.');
      }

      if (!intervals.hasOwnProperty(promise.$$intervalId)) return false;

      var id = promise.$$intervalId;
      var deferred = intervals[id];

      // Interval cancels should not report an unhandled promise.
      markQExceptionHandled(deferred.promise);
      deferred.reject('canceled');
      clearIntervalFn(id);

      return true;
    };

    return interval;
  }];
}

/** @this */
function $$IntervalFactoryProvider() {
  this.$get = ['$browser', '$q', '$$q', '$rootScope',
       function($browser,   $q,   $$q,   $rootScope) {
    return function intervalFactory(setIntervalFn, clearIntervalFn) {
      return function intervalFn(fn, delay, count, invokeApply) {
        var hasParams = arguments.length > 4,
            args = hasParams ? sliceArgs(arguments, 4) : [],
            iteration = 0,
            skipApply = isDefined(invokeApply) && !invokeApply,
            deferred = (skipApply ? $$q : $q).defer(),
            promise = deferred.promise;

        count = isDefined(count) ? count : 0;

        function callback() {
          if (!hasParams) {
            fn(iteration);
          } else {
            fn.apply(null, args);
          }
        }

        function tick() {
          if (skipApply) {
            $browser.defer(callback);
          } else {
            $rootScope.$evalAsync(callback);
          }
          deferred.notify(iteration++);

          if (count > 0 && iteration >= count) {
            deferred.resolve(iteration);
            clearIntervalFn(promise.$$intervalId);
          }

          if (!skipApply) $rootScope.$apply();
        }

        promise.$$intervalId = setIntervalFn(tick, delay, deferred, skipApply);

        return promise;
      };
    };
  }];
}

/**
 * @ngdoc service
 * @name $jsonpCallbacks
 * @requires $window
 * @description
 * This service handles the lifecycle of callbacks to handle JSONP requests.
 * Override this service if you wish to customise where the callbacks are stored and
 * how they vary compared to the requested url.
 */
var $jsonpCallbacksProvider = /** @this */ function() {
  this.$get = function() {
    var callbacks = angular.callbacks;
    var callbackMap = {};

    function createCallback(callbackId) {
      var callback = function(data) {
        callback.data = data;
        callback.called = true;
      };
      callback.id = callbackId;
      return callback;
    }

    return {
      /**
       * @ngdoc method
       * @name $jsonpCallbacks#createCallback
       * @param {string} url the url of the JSONP request
       * @returns {string} the callback path to send to the server as part of the JSONP request
       * @description
       * {@link $httpBackend} calls this method to create a callback and get hold of the path to the callback
       * to pass to the server, which will be used to call the callback with its payload in the JSONP response.
       */
      createCallback: function(url) {
        var callbackId = '_' + (callbacks.$$counter++).toString(36);
        var callbackPath = 'angular.callbacks.' + callbackId;
        var callback = createCallback(callbackId);
        callbackMap[callbackPath] = callbacks[callbackId] = callback;
        return callbackPath;
      },
      /**
       * @ngdoc method
       * @name $jsonpCallbacks#wasCalled
       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
       * @returns {boolean} whether the callback has been called, as a result of the JSONP response
       * @description
       * {@link $httpBackend} calls this method to find out whether the JSONP response actually called the
       * callback that was passed in the request.
       */
      wasCalled: function(callbackPath) {
        return callbackMap[callbackPath].called;
      },
      /**
       * @ngdoc method
       * @name $jsonpCallbacks#getResponse
       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
       * @returns {*} the data received from the response via the registered callback
       * @description
       * {@link $httpBackend} calls this method to get hold of the data that was provided to the callback
       * in the JSONP response.
       */
      getResponse: function(callbackPath) {
        return callbackMap[callbackPath].data;
      },
      /**
       * @ngdoc method
       * @name $jsonpCallbacks#removeCallback
       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
       * @description
       * {@link $httpBackend} calls this method to remove the callback after the JSONP request has
       * completed or timed-out.
       */
      removeCallback: function(callbackPath) {
        var callback = callbackMap[callbackPath];
        delete callbacks[callback.id];
        delete callbackMap[callbackPath];
      }
    };
  };
};

/**
 * @ngdoc service
 * @name $locale
 *
 * @description
 * $locale service provides localization rules for various AngularJS components. As of right now the
 * only public api is:
 *
 * * `id` – `{string}` – locale id formatted as `languageId-countryId` (e.g. `en-us`)
 */

/* global stripHash: true */

var PATH_MATCH = /^([^?#]*)(\?([^#]*))?(#(.*))?$/,
    DEFAULT_PORTS = {'http': 80, 'https': 443, 'ftp': 21};
var $locationMinErr = minErr('$location');


/**
 * Encode path using encodeUriSegment, ignoring forward slashes
 *
 * @param {string} path Path to encode
 * @returns {string}
 */
function encodePath(path) {
  var segments = path.split('/'),
      i = segments.length;

  while (i--) {
    // decode forward slashes to prevent them from being double encoded
    segments[i] = encodeUriSegment(segments[i].replace(/%2F/g, '/'));
  }

  return segments.join('/');
}

function decodePath(path, html5Mode) {
  var segments = path.split('/'),
      i = segments.length;

  while (i--) {
    segments[i] = decodeURIComponent(segments[i]);
    if (html5Mode) {
      // encode forward slashes to prevent them from being mistaken for path separators
      segments[i] = segments[i].replace(/\//g, '%2F');
    }
  }

  return segments.join('/');
}

function normalizePath(pathValue, searchValue, hashValue) {
  var search = toKeyValue(searchValue),
    hash = hashValue ? '#' + encodeUriSegment(hashValue) : '',
    path = encodePath(pathValue);

  return path + (search ? '?' + search : '') + hash;
}

function parseAbsoluteUrl(absoluteUrl, locationObj) {
  var parsedUrl = urlResolve(absoluteUrl);

  locationObj.$$protocol = parsedUrl.protocol;
  locationObj.$$host = parsedUrl.hostname;
  locationObj.$$port = toInt(parsedUrl.port) || DEFAULT_PORTS[parsedUrl.protocol] || null;
}

var DOUBLE_SLASH_REGEX = /^\s*[\\/]{2,}/;
function parseAppUrl(url, locationObj, html5Mode) {

  if (DOUBLE_SLASH_REGEX.test(url)) {
    throw $locationMinErr('badpath', 'Invalid url "{0}".', url);
  }

  var prefixed = (url.charAt(0) !== '/');
  if (prefixed) {
    url = '/' + url;
  }
  var match = urlResolve(url);
  var path = prefixed && match.pathname.charAt(0) === '/' ? match.pathname.substring(1) : match.pathname;
  locationObj.$$path = decodePath(path, html5Mode);
  locationObj.$$search = parseKeyValue(match.search);
  locationObj.$$hash = decodeURIComponent(match.hash);

  // make sure path starts with '/';
  if (locationObj.$$path && locationObj.$$path.charAt(0) !== '/') {
    locationObj.$$path = '/' + locationObj.$$path;
  }
}

function startsWith(str, search) {
  return str.slice(0, search.length) === search;
}

/**
 *
 * @param {string} base
 * @param {string} url
 * @returns {string} returns text from `url` after `base` or `undefined` if it does not begin with
 *                   the expected string.
 */
function stripBaseUrl(base, url) {
  if (startsWith(url, base)) {
    return url.substr(base.length);
  }
}

function stripHash(url) {
  var index = url.indexOf('#');
  return index === -1 ? url : url.substr(0, index);
}

function stripFile(url) {
  return url.substr(0, stripHash(url).lastIndexOf('/') + 1);
}

/* return the server only (scheme://host:port) */
function serverBase(url) {
  return url.substring(0, url.indexOf('/', url.indexOf('//') + 2));
}


/**
 * LocationHtml5Url represents a URL
 * This object is exposed as $location service when HTML5 mode is enabled and supported
 *
 * @constructor
 * @param {string} appBase application base URL
 * @param {string} appBaseNoFile application base URL stripped of any filename
 * @param {string} basePrefix URL path prefix
 */
function LocationHtml5Url(appBase, appBaseNoFile, basePrefix) {
  this.$$html5 = true;
  basePrefix = basePrefix || '';
  parseAbsoluteUrl(appBase, this);


  /**
   * Parse given HTML5 (regular) URL string into properties
   * @param {string} url HTML5 URL
   * @private
   */
  this.$$parse = function(url) {
    var pathUrl = stripBaseUrl(appBaseNoFile, url);
    if (!isString(pathUrl)) {
      throw $locationMinErr('ipthprfx', 'Invalid url "{0}", missing path prefix "{1}".', url,
          appBaseNoFile);
    }

    parseAppUrl(pathUrl, this, true);

    if (!this.$$path) {
      this.$$path = '/';
    }

    this.$$compose();
  };

  this.$$normalizeUrl = function(url) {
    return appBaseNoFile + url.substr(1); // first char is always '/'
  };

  this.$$parseLinkUrl = function(url, relHref) {
    if (relHref && relHref[0] === '#') {
      // special case for links to hash fragments:
      // keep the old url and only replace the hash fragment
      this.hash(relHref.slice(1));
      return true;
    }
    var appUrl, prevAppUrl;
    var rewrittenUrl;


    if (isDefined(appUrl = stripBaseUrl(appBase, url))) {
      prevAppUrl = appUrl;
      if (basePrefix && isDefined(appUrl = stripBaseUrl(basePrefix, appUrl))) {
        rewrittenUrl = appBaseNoFile + (stripBaseUrl('/', appUrl) || appUrl);
      } else {
        rewrittenUrl = appBase + prevAppUrl;
      }
    } else if (isDefined(appUrl = stripBaseUrl(appBaseNoFile, url))) {
      rewrittenUrl = appBaseNoFile + appUrl;
    } else if (appBaseNoFile === url + '/') {
      rewrittenUrl = appBaseNoFile;
    }
    if (rewrittenUrl) {
      this.$$parse(rewrittenUrl);
    }
    return !!rewrittenUrl;
  };
}


/**
 * LocationHashbangUrl represents URL
 * This object is exposed as $location service when developer doesn't opt into html5 mode.
 * It also serves as the base class for html5 mode fallback on legacy browsers.
 *
 * @constructor
 * @param {string} appBase application base URL
 * @param {string} appBaseNoFile application base URL stripped of any filename
 * @param {string} hashPrefix hashbang prefix
 */
function LocationHashbangUrl(appBase, appBaseNoFile, hashPrefix) {

  parseAbsoluteUrl(appBase, this);


  /**
   * Parse given hashbang URL into properties
   * @param {string} url Hashbang URL
   * @private
   */
  this.$$parse = function(url) {
    var withoutBaseUrl = stripBaseUrl(appBase, url) || stripBaseUrl(appBaseNoFile, url);
    var withoutHashUrl;

    if (!isUndefined(withoutBaseUrl) && withoutBaseUrl.charAt(0) === '#') {

      // The rest of the URL starts with a hash so we have
      // got either a hashbang path or a plain hash fragment
      withoutHashUrl = stripBaseUrl(hashPrefix, withoutBaseUrl);
      if (isUndefined(withoutHashUrl)) {
        // There was no hashbang prefix so we just have a hash fragment
        withoutHashUrl = withoutBaseUrl;
      }

    } else {
      // There was no hashbang path nor hash fragment:
      // If we are in HTML5 mode we use what is left as the path;
      // Otherwise we ignore what is left
      if (this.$$html5) {
        withoutHashUrl = withoutBaseUrl;
      } else {
        withoutHashUrl = '';
        if (isUndefined(withoutBaseUrl)) {
          appBase = url;
          /** @type {?} */ (this).replace();
        }
      }
    }

    parseAppUrl(withoutHashUrl, this, false);

    this.$$path = removeWindowsDriveName(this.$$path, withoutHashUrl, appBase);

    this.$$compose();

    /*
     * In Windows, on an anchor node on documents loaded from
     * the filesystem, the browser will return a pathname
     * prefixed with the drive name ('/C:/path') when a
     * pathname without a drive is set:
     *  * a.setAttribute('href', '/foo')
     *   * a.pathname === '/C:/foo' //true
     *
     * Inside of AngularJS, we're always using pathnames that
     * do not include drive names for routing.
     */
    function removeWindowsDriveName(path, url, base) {
      /*
      Matches paths for file protocol on windows,
      such as /C:/foo/bar, and captures only /foo/bar.
      */
      var windowsFilePathExp = /^\/[A-Z]:(\/.*)/;

      var firstPathSegmentMatch;

      //Get the relative path from the input URL.
      if (startsWith(url, base)) {
        url = url.replace(base, '');
      }

      // The input URL intentionally contains a first path segment that ends with a colon.
      if (windowsFilePathExp.exec(url)) {
        return path;
      }

      firstPathSegmentMatch = windowsFilePathExp.exec(path);
      return firstPathSegmentMatch ? firstPathSegmentMatch[1] : path;
    }
  };

  this.$$normalizeUrl = function(url) {
    return appBase + (url ? hashPrefix + url : '');
  };

  this.$$parseLinkUrl = function(url, relHref) {
    if (stripHash(appBase) === stripHash(url)) {
      this.$$parse(url);
      return true;
    }
    return false;
  };
}


/**
 * LocationHashbangUrl represents URL
 * This object is exposed as $location service when html5 history api is enabled but the browser
 * does not support it.
 *
 * @constructor
 * @param {string} appBase application base URL
 * @param {string} appBaseNoFile application base URL stripped of any filename
 * @param {string} hashPrefix hashbang prefix
 */
function LocationHashbangInHtml5Url(appBase, appBaseNoFile, hashPrefix) {
  this.$$html5 = true;
  LocationHashbangUrl.apply(this, arguments);

  this.$$parseLinkUrl = function(url, relHref) {
    if (relHref && relHref[0] === '#') {
      // special case for links to hash fragments:
      // keep the old url and only replace the hash fragment
      this.hash(relHref.slice(1));
      return true;
    }

    var rewrittenUrl;
    var appUrl;

    if (appBase === stripHash(url)) {
      rewrittenUrl = url;
    } else if ((appUrl = stripBaseUrl(appBaseNoFile, url))) {
      rewrittenUrl = appBase + hashPrefix + appUrl;
    } else if (appBaseNoFile === url + '/') {
      rewrittenUrl = appBaseNoFile;
    }
    if (rewrittenUrl) {
      this.$$parse(rewrittenUrl);
    }
    return !!rewrittenUrl;
  };

  this.$$normalizeUrl = function(url) {
    // include hashPrefix in $$absUrl when $$url is empty so IE9 does not reload page because of removal of '#'
    return appBase + hashPrefix + url;
  };
}


var locationPrototype = {

  /**
   * Ensure absolute URL is initialized.
   * @private
   */
  $$absUrl:'',

  /**
   * Are we in html5 mode?
   * @private
   */
  $$html5: false,

  /**
   * Has any change been replacing?
   * @private
   */
  $$replace: false,

  /**
   * Compose url and update `url` and `absUrl` property
   * @private
   */
  $$compose: function() {
    this.$$url = normalizePath(this.$$path, this.$$search, this.$$hash);
    this.$$absUrl = this.$$normalizeUrl(this.$$url);
    this.$$urlUpdatedByLocation = true;
  },

  /**
   * @ngdoc method
   * @name $location#absUrl
   *
   * @description
   * This method is getter only.
   *
   * Return full URL representation with all segments encoded according to rules specified in
   * [RFC 3986](http://www.ietf.org/rfc/rfc3986.txt).
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var absUrl = $location.absUrl();
   * // => "http://example.com/#/some/path?foo=bar&baz=xoxo"
   * ```
   *
   * @return {string} full URL
   */
  absUrl: locationGetter('$$absUrl'),

  /**
   * @ngdoc method
   * @name $location#url
   *
   * @description
   * This method is getter / setter.
   *
   * Return URL (e.g. `/path?a=b#hash`) when called without any parameter.
   *
   * Change path, search and hash, when called with parameter and return `$location`.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var url = $location.url();
   * // => "/some/path?foo=bar&baz=xoxo"
   * ```
   *
   * @param {string=} url New URL without base prefix (e.g. `/path?a=b#hash`)
   * @return {string} url
   */
  url: function(url) {
    if (isUndefined(url)) {
      return this.$$url;
    }

    var match = PATH_MATCH.exec(url);
    if (match[1] || url === '') this.path(decodeURIComponent(match[1]));
    if (match[2] || match[1] || url === '') this.search(match[3] || '');
    this.hash(match[5] || '');

    return this;
  },

  /**
   * @ngdoc method
   * @name $location#protocol
   *
   * @description
   * This method is getter only.
   *
   * Return protocol of current URL.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var protocol = $location.protocol();
   * // => "http"
   * ```
   *
   * @return {string} protocol of current URL
   */
  protocol: locationGetter('$$protocol'),

  /**
   * @ngdoc method
   * @name $location#host
   *
   * @description
   * This method is getter only.
   *
   * Return host of current URL.
   *
   * Note: compared to the non-AngularJS version `location.host` which returns `hostname:port`, this returns the `hostname` portion only.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var host = $location.host();
   * // => "example.com"
   *
   * // given URL http://user:password@example.com:8080/#/some/path?foo=bar&baz=xoxo
   * host = $location.host();
   * // => "example.com"
   * host = location.host;
   * // => "example.com:8080"
   * ```
   *
   * @return {string} host of current URL.
   */
  host: locationGetter('$$host'),

  /**
   * @ngdoc method
   * @name $location#port
   *
   * @description
   * This method is getter only.
   *
   * Return port of current URL.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var port = $location.port();
   * // => 80
   * ```
   *
   * @return {Number} port
   */
  port: locationGetter('$$port'),

  /**
   * @ngdoc method
   * @name $location#path
   *
   * @description
   * This method is getter / setter.
   *
   * Return path of current URL when called without any parameter.
   *
   * Change path when called with parameter and return `$location`.
   *
   * Note: Path should always begin with forward slash (/), this method will add the forward slash
   * if it is missing.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var path = $location.path();
   * // => "/some/path"
   * ```
   *
   * @param {(string|number)=} path New path
   * @return {(string|object)} path if called with no parameters, or `$location` if called with a parameter
   */
  path: locationGetterSetter('$$path', function(path) {
    path = path !== null ? path.toString() : '';
    return path.charAt(0) === '/' ? path : '/' + path;
  }),

  /**
   * @ngdoc method
   * @name $location#search
   *
   * @description
   * This method is getter / setter.
   *
   * Return search part (as object) of current URL when called without any parameter.
   *
   * Change search part when called with parameter and return `$location`.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var searchObject = $location.search();
   * // => {foo: 'bar', baz: 'xoxo'}
   *
   * // set foo to 'yipee'
   * $location.search('foo', 'yipee');
   * // $location.search() => {foo: 'yipee', baz: 'xoxo'}
   * ```
   *
   * @param {string|Object.<string>|Object.<Array.<string>>} search New search params - string or
   * hash object.
   *
   * When called with a single argument the method acts as a setter, setting the `search` component
   * of `$location` to the specified value.
   *
   * If the argument is a hash object containing an array of values, these values will be encoded
   * as duplicate search parameters in the URL.
   *
   * @param {(string|Number|Array<string>|boolean)=} paramValue If `search` is a string or number, then `paramValue`
   * will override only a single search property.
   *
   * If `paramValue` is an array, it will override the property of the `search` component of
   * `$location` specified via the first argument.
   *
   * If `paramValue` is `null`, the property specified via the first argument will be deleted.
   *
   * If `paramValue` is `true`, the property specified via the first argument will be added with no
   * value nor trailing equal sign.
   *
   * @return {Object} If called with no arguments returns the parsed `search` object. If called with
   * one or more arguments returns `$location` object itself.
   */
  search: function(search, paramValue) {
    switch (arguments.length) {
      case 0:
        return this.$$search;
      case 1:
        if (isString(search) || isNumber(search)) {
          search = search.toString();
          this.$$search = parseKeyValue(search);
        } else if (isObject(search)) {
          search = copy(search, {});
          // remove object undefined or null properties
          forEach(search, function(value, key) {
            if (value == null) delete search[key];
          });

          this.$$search = search;
        } else {
          throw $locationMinErr('isrcharg',
              'The first argument of the `$location#search()` call must be a string or an object.');
        }
        break;
      default:
        if (isUndefined(paramValue) || paramValue === null) {
          delete this.$$search[search];
        } else {
          this.$$search[search] = paramValue;
        }
    }

    this.$$compose();
    return this;
  },

  /**
   * @ngdoc method
   * @name $location#hash
   *
   * @description
   * This method is getter / setter.
   *
   * Returns the hash fragment when called without any parameters.
   *
   * Changes the hash fragment when called with a parameter and returns `$location`.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo#hashValue
   * var hash = $location.hash();
   * // => "hashValue"
   * ```
   *
   * @param {(string|number)=} hash New hash fragment
   * @return {string} hash
   */
  hash: locationGetterSetter('$$hash', function(hash) {
    return hash !== null ? hash.toString() : '';
  }),

  /**
   * @ngdoc method
   * @name $location#replace
   *
   * @description
   * If called, all changes to $location during the current `$digest` will replace the current history
   * record, instead of adding a new one.
   */
  replace: function() {
    this.$$replace = true;
    return this;
  }
};

forEach([LocationHashbangInHtml5Url, LocationHashbangUrl, LocationHtml5Url], function(Location) {
  Location.prototype = Object.create(locationPrototype);

  /**
   * @ngdoc method
   * @name $location#state
   *
   * @description
   * This method is getter / setter.
   *
   * Return the history state object when called without any parameter.
   *
   * Change the history state object when called with one parameter and return `$location`.
   * The state object is later passed to `pushState` or `replaceState`.
   *
   * NOTE: This method is supported only in HTML5 mode and only in browsers supporting
   * the HTML5 History API (i.e. methods `pushState` and `replaceState`). If you need to support
   * older browsers (like IE9 or Android < 4.0), don't use this method.
   *
   * @param {object=} state State object for pushState or replaceState
   * @return {object} state
   */
  Location.prototype.state = function(state) {
    if (!arguments.length) {
      return this.$$state;
    }

    if (Location !== LocationHtml5Url || !this.$$html5) {
      throw $locationMinErr('nostate', 'History API state support is available only ' +
        'in HTML5 mode and only in browsers supporting HTML5 History API');
    }
    // The user might modify `stateObject` after invoking `$location.state(stateObject)`
    // but we're changing the $$state reference to $browser.state() during the $digest
    // so the modification window is narrow.
    this.$$state = isUndefined(state) ? null : state;
    this.$$urlUpdatedByLocation = true;

    return this;
  };
});


function locationGetter(property) {
  return /** @this */ function() {
    return this[property];
  };
}


function locationGetterSetter(property, preprocess) {
  return /** @this */ function(value) {
    if (isUndefined(value)) {
      return this[property];
    }

    this[property] = preprocess(value);
    this.$$compose();

    return this;
  };
}


/**
 * @ngdoc service
 * @name $location
 *
 * @requires $rootElement
 *
 * @description
 * The $location service parses the URL in the browser address bar (based on the
 * [window.location](https://developer.mozilla.org/en/window.location)) and makes the URL
 * available to your application. Changes to the URL in the address bar are reflected into
 * $location service and changes to $location are reflected into the browser address bar.
 *
 * **The $location service:**
 *
 * - Exposes the current URL in the browser address bar, so you can
 *   - Watch and observe the URL.
 *   - Change the URL.
 * - Synchronizes the URL with the browser when the user
 *   - Changes the address bar.
 *   - Clicks the back or forward button (or clicks a History link).
 *   - Clicks on a link.
 * - Represents the URL object as a set of methods (protocol, host, port, path, search, hash).
 *
 * For more information see {@link guide/$location Developer Guide: Using $location}
 */

/**
 * @ngdoc provider
 * @name $locationProvider
 * @this
 *
 * @description
 * Use the `$locationProvider` to configure how the application deep linking paths are stored.
 */
function $LocationProvider() {
  var hashPrefix = '!',
      html5Mode = {
        enabled: false,
        requireBase: true,
        rewriteLinks: true
      };

  /**
   * @ngdoc method
   * @name $locationProvider#hashPrefix
   * @description
   * The default value for the prefix is `'!'`.
   * @param {string=} prefix Prefix for hash part (containing path and search)
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   */
  this.hashPrefix = function(prefix) {
    if (isDefined(prefix)) {
      hashPrefix = prefix;
      return this;
    } else {
      return hashPrefix;
    }
  };

  /**
   * @ngdoc method
   * @name $locationProvider#html5Mode
   * @description
   * @param {(boolean|Object)=} mode If boolean, sets `html5Mode.enabled` to value.
   *   If object, sets `enabled`, `requireBase` and `rewriteLinks` to respective values. Supported
   *   properties:
   *   - **enabled** – `{boolean}` – (default: false) If true, will rely on `history.pushState` to
   *     change urls where supported. Will fall back to hash-prefixed paths in browsers that do not
   *     support `pushState`.
   *   - **requireBase** - `{boolean}` - (default: `true`) When html5Mode is enabled, specifies
   *     whether or not a <base> tag is required to be present. If `enabled` and `requireBase` are
   *     true, and a base tag is not present, an error will be thrown when `$location` is injected.
   *     See the {@link guide/$location $location guide for more information}
   *   - **rewriteLinks** - `{boolean|string}` - (default: `true`) When html5Mode is enabled,
   *     enables/disables URL rewriting for relative links. If set to a string, URL rewriting will
   *     only happen on links with an attribute that matches the given string. For example, if set
   *     to `'internal-link'`, then the URL will only be rewritten for `<a internal-link>` links.
   *     Note that [attribute name normalization](guide/directive#normalization) does not apply
   *     here, so `'internalLink'` will **not** match `'internal-link'`.
   *
   * @returns {Object} html5Mode object if used as getter or itself (chaining) if used as setter
   */
  this.html5Mode = function(mode) {
    if (isBoolean(mode)) {
      html5Mode.enabled = mode;
      return this;
    } else if (isObject(mode)) {

      if (isBoolean(mode.enabled)) {
        html5Mode.enabled = mode.enabled;
      }

      if (isBoolean(mode.requireBase)) {
        html5Mode.requireBase = mode.requireBase;
      }

      if (isBoolean(mode.rewriteLinks) || isString(mode.rewriteLinks)) {
        html5Mode.rewriteLinks = mode.rewriteLinks;
      }

      return this;
    } else {
      return html5Mode;
    }
  };

  /**
   * @ngdoc event
   * @name $location#$locationChangeStart
   * @eventType broadcast on root scope
   * @description
   * Broadcasted before a URL will change.
   *
   * This change can be prevented by calling
   * `preventDefault` method of the event. See {@link ng.$rootScope.Scope#$on} for more
   * details about event object. Upon successful change
   * {@link ng.$location#$locationChangeSuccess $locationChangeSuccess} is fired.
   *
   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
   * the browser supports the HTML5 History API.
   *
   * @param {Object} angularEvent Synthetic event object.
   * @param {string} newUrl New URL
   * @param {string=} oldUrl URL that was before it was changed.
   * @param {string=} newState New history state object
   * @param {string=} oldState History state object that was before it was changed.
   */

  /**
   * @ngdoc event
   * @name $location#$locationChangeSuccess
   * @eventType broadcast on root scope
   * @description
   * Broadcasted after a URL was changed.
   *
   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
   * the browser supports the HTML5 History API.
   *
   * @param {Object} angularEvent Synthetic event object.
   * @param {string} newUrl New URL
   * @param {string=} oldUrl URL that was before it was changed.
   * @param {string=} newState New history state object
   * @param {string=} oldState History state object that was before it was changed.
   */

  this.$get = ['$rootScope', '$browser', '$sniffer', '$rootElement', '$window',
      function($rootScope, $browser, $sniffer, $rootElement, $window) {
    var $location,
        LocationMode,
        baseHref = $browser.baseHref(), // if base[href] is undefined, it defaults to ''
        initialUrl = $browser.url(),
        appBase;

    if (html5Mode.enabled) {
      if (!baseHref && html5Mode.requireBase) {
        throw $locationMinErr('nobase',
          '$location in HTML5 mode requires a <base> tag to be present!');
      }
      appBase = serverBase(initialUrl) + (baseHref || '/');
      LocationMode = $sniffer.history ? LocationHtml5Url : LocationHashbangInHtml5Url;
    } else {
      appBase = stripHash(initialUrl);
      LocationMode = LocationHashbangUrl;
    }
    var appBaseNoFile = stripFile(appBase);

    $location = new LocationMode(appBase, appBaseNoFile, '#' + hashPrefix);
    $location.$$parseLinkUrl(initialUrl, initialUrl);

    $location.$$state = $browser.state();

    var IGNORE_URI_REGEXP = /^\s*(javascript|mailto):/i;

    // Determine if two URLs are equal despite potentially having different encoding/normalizing
    //  such as $location.absUrl() vs $browser.url()
    // See https://github.com/angular/angular.js/issues/16592
    function urlsEqual(a, b) {
      return a === b || urlResolve(a).href === urlResolve(b).href;
    }

    function setBrowserUrlWithFallback(url, replace, state) {
      var oldUrl = $location.url();
      var oldState = $location.$$state;
      try {
        $browser.url(url, replace, state);

        // Make sure $location.state() returns referentially identical (not just deeply equal)
        // state object; this makes possible quick checking if the state changed in the digest
        // loop. Checking deep equality would be too expensive.
        $location.$$state = $browser.state();
      } catch (e) {
        // Restore old values if pushState fails
        $location.url(oldUrl);
        $location.$$state = oldState;

        throw e;
      }
    }

    $rootElement.on('click', function(event) {
      var rewriteLinks = html5Mode.rewriteLinks;
      // TODO(vojta): rewrite link when opening in new tab/window (in legacy browser)
      // currently we open nice url link and redirect then

      if (!rewriteLinks || event.ctrlKey || event.metaKey || event.shiftKey || event.which === 2 || event.button === 2) return;

      var elm = jqLite(event.target);

      // traverse the DOM up to find first A tag
      while (nodeName_(elm[0]) !== 'a') {
        // ignore rewriting if no A tag (reached root element, or no parent - removed from document)
        if (elm[0] === $rootElement[0] || !(elm = elm.parent())[0]) return;
      }

      if (isString(rewriteLinks) && isUndefined(elm.attr(rewriteLinks))) return;

      var absHref = elm.prop('href');
      // get the actual href attribute - see
      // http://msdn.microsoft.com/en-us/library/ie/dd347148(v=vs.85).aspx
      var relHref = elm.attr('href') || elm.attr('xlink:href');

      if (isObject(absHref) && absHref.toString() === '[object SVGAnimatedString]') {
        // SVGAnimatedString.animVal should be identical to SVGAnimatedString.baseVal, unless during
        // an animation.
        absHref = urlResolve(absHref.animVal).href;
      }

      // Ignore when url is started with javascript: or mailto:
      if (IGNORE_URI_REGEXP.test(absHref)) return;

      if (absHref && !elm.attr('target') && !event.isDefaultPrevented()) {
        if ($location.$$parseLinkUrl(absHref, relHref)) {
          // We do a preventDefault for all urls that are part of the AngularJS application,
          // in html5mode and also without, so that we are able to abort navigation without
          // getting double entries in the location history.
          event.preventDefault();
          // update location manually
          if ($location.absUrl() !== $browser.url()) {
            $rootScope.$apply();
          }
        }
      }
    });


    // rewrite hashbang url <> html5 url
    if ($location.absUrl() !== initialUrl) {
      $browser.url($location.absUrl(), true);
    }

    var initializing = true;

    // update $location when $browser url changes
    $browser.onUrlChange(function(newUrl, newState) {

      if (!startsWith(newUrl, appBaseNoFile)) {
        // If we are navigating outside of the app then force a reload
        $window.location.href = newUrl;
        return;
      }

      $rootScope.$evalAsync(function() {
        var oldUrl = $location.absUrl();
        var oldState = $location.$$state;
        var defaultPrevented;
        $location.$$parse(newUrl);
        $location.$$state = newState;

        defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
            newState, oldState).defaultPrevented;

        // if the location was changed by a `$locationChangeStart` handler then stop
        // processing this location change
        if ($location.absUrl() !== newUrl) return;

        if (defaultPrevented) {
          $location.$$parse(oldUrl);
          $location.$$state = oldState;
          setBrowserUrlWithFallback(oldUrl, false, oldState);
        } else {
          initializing = false;
          afterLocationChange(oldUrl, oldState);
        }
      });
      if (!$rootScope.$$phase) $rootScope.$digest();
    });

    // update browser
    $rootScope.$watch(function $locationWatch() {
      if (initializing || $location.$$urlUpdatedByLocation) {
        $location.$$urlUpdatedByLocation = false;

        var oldUrl = $browser.url();
        var newUrl = $location.absUrl();
        var oldState = $browser.state();
        var currentReplace = $location.$$replace;
        var urlOrStateChanged = !urlsEqual(oldUrl, newUrl) ||
          ($location.$$html5 && $sniffer.history && oldState !== $location.$$state);

        if (initializing || urlOrStateChanged) {
          initializing = false;

          $rootScope.$evalAsync(function() {
            var newUrl = $location.absUrl();
            var defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
                $location.$$state, oldState).defaultPrevented;

            // if the location was changed by a `$locationChangeStart` handler then stop
            // processing this location change
            if ($location.absUrl() !== newUrl) return;

            if (defaultPrevented) {
              $location.$$parse(oldUrl);
              $location.$$state = oldState;
            } else {
              if (urlOrStateChanged) {
                setBrowserUrlWithFallback(newUrl, currentReplace,
                                          oldState === $location.$$state ? null : $location.$$state);
              }
              afterLocationChange(oldUrl, oldState);
            }
          });
        }
      }

      $location.$$replace = false;

      // we don't need to return anything because $evalAsync will make the digest loop dirty when
      // there is a change
    });

    return $location;

    function afterLocationChange(oldUrl, oldState) {
      $rootScope.$broadcast('$locationChangeSuccess', $location.absUrl(), oldUrl,
        $location.$$state, oldState);
    }
}];
}

/**
 * @ngdoc service
 * @name $log
 * @requires $window
 *
 * @description
 * Simple service for logging. Default implementation safely writes the message
 * into the browser's console (if present).
 *
 * The main purpose of this service is to simplify debugging and troubleshooting.
 *
 * To reveal the location of the calls to `$log` in the JavaScript console,
 * you can "blackbox" the AngularJS source in your browser:
 *
 * [Mozilla description of blackboxing](https://developer.mozilla.org/en-US/docs/Tools/Debugger/How_to/Black_box_a_source).
 * [Chrome description of blackboxing](https://developer.chrome.com/devtools/docs/blackboxing).
 *
 * Note: Not all browsers support blackboxing.
 *
 * The default is to log `debug` messages. You can use
 * {@link ng.$logProvider ng.$logProvider#debugEnabled} to change this.
 *
 * @example
   <example module="logExample" name="log-service">
     <file name="script.js">
       angular.module('logExample', [])
         .controller('LogController', ['$scope', '$log', function($scope, $log) {
           $scope.$log = $log;
           $scope.message = 'Hello World!';
         }]);
     </file>
     <file name="index.html">
       <div ng-controller="LogController">
         <p>Reload this page with open console, enter text and hit the log button...</p>
         <label>Message:
         <input type="text" ng-model="message" /></label>
         <button ng-click="$log.log(message)">log</button>
         <button ng-click="$log.warn(message)">warn</button>
         <button ng-click="$log.info(message)">info</button>
         <button ng-click="$log.error(message)">error</button>
         <button ng-click="$log.debug(message)">debug</button>
       </div>
     </file>
   </example>
 */

/**
 * @ngdoc provider
 * @name $logProvider
 * @this
 *
 * @description
 * Use the `$logProvider` to configure how the application logs messages
 */
function $LogProvider() {
  var debug = true,
      self = this;

  /**
   * @ngdoc method
   * @name $logProvider#debugEnabled
   * @description
   * @param {boolean=} flag enable or disable debug level messages
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   */
  this.debugEnabled = function(flag) {
    if (isDefined(flag)) {
      debug = flag;
      return this;
    } else {
      return debug;
    }
  };

  this.$get = ['$window', function($window) {
    // Support: IE 9-11, Edge 12-14+
    // IE/Edge display errors in such a way that it requires the user to click in 4 places
    // to see the stack trace. There is no way to feature-detect it so there's a chance
    // of the user agent sniffing to go wrong but since it's only about logging, this shouldn't
    // break apps. Other browsers display errors in a sensible way and some of them map stack
    // traces along source maps if available so it makes sense to let browsers display it
    // as they want.
    var formatStackTrace = msie || /\bEdge\//.test($window.navigator && $window.navigator.userAgent);

    return {
      /**
       * @ngdoc method
       * @name $log#log
       *
       * @description
       * Write a log message
       */
      log: consoleLog('log'),

      /**
       * @ngdoc method
       * @name $log#info
       *
       * @description
       * Write an information message
       */
      info: consoleLog('info'),

      /**
       * @ngdoc method
       * @name $log#warn
       *
       * @description
       * Write a warning message
       */
      warn: consoleLog('warn'),

      /**
       * @ngdoc method
       * @name $log#error
       *
       * @description
       * Write an error message
       */
      error: consoleLog('error'),

      /**
       * @ngdoc method
       * @name $log#debug
       *
       * @description
       * Write a debug message
       */
      debug: (function() {
        var fn = consoleLog('debug');

        return function() {
          if (debug) {
            fn.apply(self, arguments);
          }
        };
      })()
    };

    function formatError(arg) {
      if (isError(arg)) {
        if (arg.stack && formatStackTrace) {
          arg = (arg.message && arg.stack.indexOf(arg.message) === -1)
              ? 'Error: ' + arg.message + '\n' + arg.stack
              : arg.stack;
        } else if (arg.sourceURL) {
          arg = arg.message + '\n' + arg.sourceURL + ':' + arg.line;
        }
      }
      return arg;
    }

    function consoleLog(type) {
      var console = $window.console || {},
          logFn = console[type] || console.log || noop;

      return function() {
        var args = [];
        forEach(arguments, function(arg) {
          args.push(formatError(arg));
        });
        // Support: IE 9 only
        // console methods don't inherit from Function.prototype in IE 9 so we can't
        // call `logFn.apply(console, args)` directly.
        return Function.prototype.apply.call(logFn, console, args);
      };
    }
  }];
}

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables likes document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

var $parseMinErr = minErr('$parse');

var objectValueOf = {}.constructor.prototype.valueOf;

// Sandboxing AngularJS Expressions
// ------------------------------
// AngularJS expressions are no longer sandboxed. So it is now even easier to access arbitrary JS code by
// various means such as obtaining a reference to native JS functions like the Function constructor.
//
// As an example, consider the following AngularJS expression:
//
//   {}.toString.constructor('alert("evil JS code")')
//
// It is important to realize that if you create an expression from a string that contains user provided
// content then it is possible that your application contains a security vulnerability to an XSS style attack.
//
// See https://docs.angularjs.org/guide/security


function getStringValue(name) {
  // Property names must be strings. This means that non-string objects cannot be used
  // as keys in an object. Any non-string object, including a number, is typecasted
  // into a string via the toString method.
  // -- MDN, https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Operators/Property_accessors#Property_names
  //
  // So, to ensure that we are checking the same `name` that JavaScript would use, we cast it
  // to a string. It's not always possible. If `name` is an object and its `toString` method is
  // 'broken' (doesn't return a string, isn't a function, etc.), an error will be thrown:
  //
  // TypeError: Cannot convert object to primitive value
  //
  // For performance reasons, we don't catch this error here and allow it to propagate up the call
  // stack. Note that you'll get the same error in JavaScript if you try to access a property using
  // such a 'broken' object as a key.
  return name + '';
}


var OPERATORS = createMap();
forEach('+ - * / % === !== == != < > <= >= && || ! = |'.split(' '), function(operator) { OPERATORS[operator] = true; });
var ESCAPE = {'n':'\n', 'f':'\f', 'r':'\r', 't':'\t', 'v':'\v', '\'':'\'', '"':'"'};


/////////////////////////////////////////


/**
 * @constructor
 */
var Lexer = function Lexer(options) {
  this.options = options;
};

Lexer.prototype = {
  constructor: Lexer,

  lex: function(text) {
    this.text = text;
    this.index = 0;
    this.tokens = [];

    while (this.index < this.text.length) {
      var ch = this.text.charAt(this.index);
      if (ch === '"' || ch === '\'') {
        this.readString(ch);
      } else if (this.isNumber(ch) || ch === '.' && this.isNumber(this.peek())) {
        this.readNumber();
      } else if (this.isIdentifierStart(this.peekMultichar())) {
        this.readIdent();
      } else if (this.is(ch, '(){}[].,;:?')) {
        this.tokens.push({index: this.index, text: ch});
        this.index++;
      } else if (this.isWhitespace(ch)) {
        this.index++;
      } else {
        var ch2 = ch + this.peek();
        var ch3 = ch2 + this.peek(2);
        var op1 = OPERATORS[ch];
        var op2 = OPERATORS[ch2];
        var op3 = OPERATORS[ch3];
        if (op1 || op2 || op3) {
          var token = op3 ? ch3 : (op2 ? ch2 : ch);
          this.tokens.push({index: this.index, text: token, operator: true});
          this.index += token.length;
        } else {
          this.throwError('Unexpected next character ', this.index, this.index + 1);
        }
      }
    }
    return this.tokens;
  },

  is: function(ch, chars) {
    return chars.indexOf(ch) !== -1;
  },

  peek: function(i) {
    var num = i || 1;
    return (this.index + num < this.text.length) ? this.text.charAt(this.index + num) : false;
  },

  isNumber: function(ch) {
    return ('0' <= ch && ch <= '9') && typeof ch === 'string';
  },

  isWhitespace: function(ch) {
    // IE treats non-breaking space as \u00A0
    return (ch === ' ' || ch === '\r' || ch === '\t' ||
            ch === '\n' || ch === '\v' || ch === '\u00A0');
  },

  isIdentifierStart: function(ch) {
    return this.options.isIdentifierStart ?
        this.options.isIdentifierStart(ch, this.codePointAt(ch)) :
        this.isValidIdentifierStart(ch);
  },

  isValidIdentifierStart: function(ch) {
    return ('a' <= ch && ch <= 'z' ||
            'A' <= ch && ch <= 'Z' ||
            '_' === ch || ch === '$');
  },

  isIdentifierContinue: function(ch) {
    return this.options.isIdentifierContinue ?
        this.options.isIdentifierContinue(ch, this.codePointAt(ch)) :
        this.isValidIdentifierContinue(ch);
  },

  isValidIdentifierContinue: function(ch, cp) {
    return this.isValidIdentifierStart(ch, cp) || this.isNumber(ch);
  },

  codePointAt: function(ch) {
    if (ch.length === 1) return ch.charCodeAt(0);
    // eslint-disable-next-line no-bitwise
    return (ch.charCodeAt(0) << 10) + ch.charCodeAt(1) - 0x35FDC00;
  },

  peekMultichar: function() {
    var ch = this.text.charAt(this.index);
    var peek = this.peek();
    if (!peek) {
      return ch;
    }
    var cp1 = ch.charCodeAt(0);
    var cp2 = peek.charCodeAt(0);
    if (cp1 >= 0xD800 && cp1 <= 0xDBFF && cp2 >= 0xDC00 && cp2 <= 0xDFFF) {
      return ch + peek;
    }
    return ch;
  },

  isExpOperator: function(ch) {
    return (ch === '-' || ch === '+' || this.isNumber(ch));
  },

  throwError: function(error, start, end) {
    end = end || this.index;
    var colStr = (isDefined(start)
            ? 's ' + start +  '-' + this.index + ' [' + this.text.substring(start, end) + ']'
            : ' ' + end);
    throw $parseMinErr('lexerr', 'Lexer Error: {0} at column{1} in expression [{2}].',
        error, colStr, this.text);
  },

  readNumber: function() {
    var number = '';
    var start = this.index;
    while (this.index < this.text.length) {
      var ch = lowercase(this.text.charAt(this.index));
      if (ch === '.' || this.isNumber(ch)) {
        number += ch;
      } else {
        var peekCh = this.peek();
        if (ch === 'e' && this.isExpOperator(peekCh)) {
          number += ch;
        } else if (this.isExpOperator(ch) &&
            peekCh && this.isNumber(peekCh) &&
            number.charAt(number.length - 1) === 'e') {
          number += ch;
        } else if (this.isExpOperator(ch) &&
            (!peekCh || !this.isNumber(peekCh)) &&
            number.charAt(number.length - 1) === 'e') {
          this.throwError('Invalid exponent');
        } else {
          break;
        }
      }
      this.index++;
    }
    this.tokens.push({
      index: start,
      text: number,
      constant: true,
      value: Number(number)
    });
  },

  readIdent: function() {
    var start = this.index;
    this.index += this.peekMultichar().length;
    while (this.index < this.text.length) {
      var ch = this.peekMultichar();
      if (!this.isIdentifierContinue(ch)) {
        break;
      }
      this.index += ch.length;
    }
    this.tokens.push({
      index: start,
      text: this.text.slice(start, this.index),
      identifier: true
    });
  },

  readString: function(quote) {
    var start = this.index;
    this.index++;
    var string = '';
    var rawString = quote;
    var escape = false;
    while (this.index < this.text.length) {
      var ch = this.text.charAt(this.index);
      rawString += ch;
      if (escape) {
        if (ch === 'u') {
          var hex = this.text.substring(this.index + 1, this.index + 5);
          if (!hex.match(/[\da-f]{4}/i)) {
            this.throwError('Invalid unicode escape [\\u' + hex + ']');
          }
          this.index += 4;
          string += String.fromCharCode(parseInt(hex, 16));
        } else {
          var rep = ESCAPE[ch];
          string = string + (rep || ch);
        }
        escape = false;
      } else if (ch === '\\') {
        escape = true;
      } else if (ch === quote) {
        this.index++;
        this.tokens.push({
          index: start,
          text: rawString,
          constant: true,
          value: string
        });
        return;
      } else {
        string += ch;
      }
      this.index++;
    }
    this.throwError('Unterminated quote', start);
  }
};

var AST = function AST(lexer, options) {
  this.lexer = lexer;
  this.options = options;
};

AST.Program = 'Program';
AST.ExpressionStatement = 'ExpressionStatement';
AST.AssignmentExpression = 'AssignmentExpression';
AST.ConditionalExpression = 'ConditionalExpression';
AST.LogicalExpression = 'LogicalExpression';
AST.BinaryExpression = 'BinaryExpression';
AST.UnaryExpression = 'UnaryExpression';
AST.CallExpression = 'CallExpression';
AST.MemberExpression = 'MemberExpression';
AST.Identifier = 'Identifier';
AST.Literal = 'Literal';
AST.ArrayExpression = 'ArrayExpression';
AST.Property = 'Property';
AST.ObjectExpression = 'ObjectExpression';
AST.ThisExpression = 'ThisExpression';
AST.LocalsExpression = 'LocalsExpression';

// Internal use only
AST.NGValueParameter = 'NGValueParameter';

AST.prototype = {
  ast: function(text) {
    this.text = text;
    this.tokens = this.lexer.lex(text);

    var value = this.program();

    if (this.tokens.length !== 0) {
      this.throwError('is an unexpected token', this.tokens[0]);
    }

    return value;
  },

  program: function() {
    var body = [];
    while (true) {
      if (this.tokens.length > 0 && !this.peek('}', ')', ';', ']'))
        body.push(this.expressionStatement());
      if (!this.expect(';')) {
        return { type: AST.Program, body: body};
      }
    }
  },

  expressionStatement: function() {
    return { type: AST.ExpressionStatement, expression: this.filterChain() };
  },

  filterChain: function() {
    var left = this.expression();
    while (this.expect('|')) {
      left = this.filter(left);
    }
    return left;
  },

  expression: function() {
    return this.assignment();
  },

  assignment: function() {
    var result = this.ternary();
    if (this.expect('=')) {
      if (!isAssignable(result)) {
        throw $parseMinErr('lval', 'Trying to assign a value to a non l-value');
      }

      result = { type: AST.AssignmentExpression, left: result, right: this.assignment(), operator: '='};
    }
    return result;
  },

  ternary: function() {
    var test = this.logicalOR();
    var alternate;
    var consequent;
    if (this.expect('?')) {
      alternate = this.expression();
      if (this.consume(':')) {
        consequent = this.expression();
        return { type: AST.ConditionalExpression, test: test, alternate: alternate, consequent: consequent};
      }
    }
    return test;
  },

  logicalOR: function() {
    var left = this.logicalAND();
    while (this.expect('||')) {
      left = { type: AST.LogicalExpression, operator: '||', left: left, right: this.logicalAND() };
    }
    return left;
  },

  logicalAND: function() {
    var left = this.equality();
    while (this.expect('&&')) {
      left = { type: AST.LogicalExpression, operator: '&&', left: left, right: this.equality()};
    }
    return left;
  },

  equality: function() {
    var left = this.relational();
    var token;
    while ((token = this.expect('==','!=','===','!=='))) {
      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.relational() };
    }
    return left;
  },

  relational: function() {
    var left = this.additive();
    var token;
    while ((token = this.expect('<', '>', '<=', '>='))) {
      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.additive() };
    }
    return left;
  },

  additive: function() {
    var left = this.multiplicative();
    var token;
    while ((token = this.expect('+','-'))) {
      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.multiplicative() };
    }
    return left;
  },

  multiplicative: function() {
    var left = this.unary();
    var token;
    while ((token = this.expect('*','/','%'))) {
      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.unary() };
    }
    return left;
  },

  unary: function() {
    var token;
    if ((token = this.expect('+', '-', '!'))) {
      return { type: AST.UnaryExpression, operator: token.text, prefix: true, argument: this.unary() };
    } else {
      return this.primary();
    }
  },

  primary: function() {
    var primary;
    if (this.expect('(')) {
      primary = this.filterChain();
      this.consume(')');
    } else if (this.expect('[')) {
      primary = this.arrayDeclaration();
    } else if (this.expect('{')) {
      primary = this.object();
    } else if (this.selfReferential.hasOwnProperty(this.peek().text)) {
      primary = copy(this.selfReferential[this.consume().text]);
    } else if (this.options.literals.hasOwnProperty(this.peek().text)) {
      primary = { type: AST.Literal, value: this.options.literals[this.consume().text]};
    } else if (this.peek().identifier) {
      primary = this.identifier();
    } else if (this.peek().constant) {
      primary = this.constant();
    } else {
      this.throwError('not a primary expression', this.peek());
    }

    var next;
    while ((next = this.expect('(', '[', '.'))) {
      if (next.text === '(') {
        primary = {type: AST.CallExpression, callee: primary, arguments: this.parseArguments() };
        this.consume(')');
      } else if (next.text === '[') {
        primary = { type: AST.MemberExpression, object: primary, property: this.expression(), computed: true };
        this.consume(']');
      } else if (next.text === '.') {
        primary = { type: AST.MemberExpression, object: primary, property: this.identifier(), computed: false };
      } else {
        this.throwError('IMPOSSIBLE');
      }
    }
    return primary;
  },

  filter: function(baseExpression) {
    var args = [baseExpression];
    var result = {type: AST.CallExpression, callee: this.identifier(), arguments: args, filter: true};

    while (this.expect(':')) {
      args.push(this.expression());
    }

    return result;
  },

  parseArguments: function() {
    var args = [];
    if (this.peekToken().text !== ')') {
      do {
        args.push(this.filterChain());
      } while (this.expect(','));
    }
    return args;
  },

  identifier: function() {
    var token = this.consume();
    if (!token.identifier) {
      this.throwError('is not a valid identifier', token);
    }
    return { type: AST.Identifier, name: token.text };
  },

  constant: function() {
    // TODO check that it is a constant
    return { type: AST.Literal, value: this.consume().value };
  },

  arrayDeclaration: function() {
    var elements = [];
    if (this.peekToken().text !== ']') {
      do {
        if (this.peek(']')) {
          // Support trailing commas per ES5.1.
          break;
        }
        elements.push(this.expression());
      } while (this.expect(','));
    }
    this.consume(']');

    return { type: AST.ArrayExpression, elements: elements };
  },

  object: function() {
    var properties = [], property;
    if (this.peekToken().text !== '}') {
      do {
        if (this.peek('}')) {
          // Support trailing commas per ES5.1.
          break;
        }
        property = {type: AST.Property, kind: 'init'};
        if (this.peek().constant) {
          property.key = this.constant();
          property.computed = false;
          this.consume(':');
          property.value = this.expression();
        } else if (this.peek().identifier) {
          property.key = this.identifier();
          property.computed = false;
          if (this.peek(':')) {
            this.consume(':');
            property.value = this.expression();
          } else {
            property.value = property.key;
          }
        } else if (this.peek('[')) {
          this.consume('[');
          property.key = this.expression();
          this.consume(']');
          property.computed = true;
          this.consume(':');
          property.value = this.expression();
        } else {
          this.throwError('invalid key', this.peek());
        }
        properties.push(property);
      } while (this.expect(','));
    }
    this.consume('}');

    return {type: AST.ObjectExpression, properties: properties };
  },

  throwError: function(msg, token) {
    throw $parseMinErr('syntax',
        'Syntax Error: Token \'{0}\' {1} at column {2} of the expression [{3}] starting at [{4}].',
          token.text, msg, (token.index + 1), this.text, this.text.substring(token.index));
  },

  consume: function(e1) {
    if (this.tokens.length === 0) {
      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
    }

    var token = this.expect(e1);
    if (!token) {
      this.throwError('is unexpected, expecting [' + e1 + ']', this.peek());
    }
    return token;
  },

  peekToken: function() {
    if (this.tokens.length === 0) {
      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
    }
    return this.tokens[0];
  },

  peek: function(e1, e2, e3, e4) {
    return this.peekAhead(0, e1, e2, e3, e4);
  },

  peekAhead: function(i, e1, e2, e3, e4) {
    if (this.tokens.length > i) {
      var token = this.tokens[i];
      var t = token.text;
      if (t === e1 || t === e2 || t === e3 || t === e4 ||
          (!e1 && !e2 && !e3 && !e4)) {
        return token;
      }
    }
    return false;
  },

  expect: function(e1, e2, e3, e4) {
    var token = this.peek(e1, e2, e3, e4);
    if (token) {
      this.tokens.shift();
      return token;
    }
    return false;
  },

  selfReferential: {
    'this': {type: AST.ThisExpression },
    '$locals': {type: AST.LocalsExpression }
  }
};

function ifDefined(v, d) {
  return typeof v !== 'undefined' ? v : d;
}

function plusFn(l, r) {
  if (typeof l === 'undefined') return r;
  if (typeof r === 'undefined') return l;
  return l + r;
}

function isStateless($filter, filterName) {
  var fn = $filter(filterName);
  return !fn.$stateful;
}

var PURITY_ABSOLUTE = 1;
var PURITY_RELATIVE = 2;

// Detect nodes which could depend on non-shallow state of objects
function isPure(node, parentIsPure) {
  switch (node.type) {
    // Computed members might invoke a stateful toString()
    case AST.MemberExpression:
      if (node.computed) {
        return false;
      }
      break;

    // Unary always convert to primative
    case AST.UnaryExpression:
      return PURITY_ABSOLUTE;

    // The binary + operator can invoke a stateful toString().
    case AST.BinaryExpression:
      return node.operator !== '+' ? PURITY_ABSOLUTE : false;

    // Functions / filters probably read state from within objects
    case AST.CallExpression:
      return false;
  }

  return (undefined === parentIsPure) ? PURITY_RELATIVE : parentIsPure;
}

function findConstantAndWatchExpressions(ast, $filter, parentIsPure) {
  var allConstants;
  var argsToWatch;
  var isStatelessFilter;

  var astIsPure = ast.isPure = isPure(ast, parentIsPure);

  switch (ast.type) {
  case AST.Program:
    allConstants = true;
    forEach(ast.body, function(expr) {
      findConstantAndWatchExpressions(expr.expression, $filter, astIsPure);
      allConstants = allConstants && expr.expression.constant;
    });
    ast.constant = allConstants;
    break;
  case AST.Literal:
    ast.constant = true;
    ast.toWatch = [];
    break;
  case AST.UnaryExpression:
    findConstantAndWatchExpressions(ast.argument, $filter, astIsPure);
    ast.constant = ast.argument.constant;
    ast.toWatch = ast.argument.toWatch;
    break;
  case AST.BinaryExpression:
    findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
    findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
    ast.constant = ast.left.constant && ast.right.constant;
    ast.toWatch = ast.left.toWatch.concat(ast.right.toWatch);
    break;
  case AST.LogicalExpression:
    findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
    findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
    ast.constant = ast.left.constant && ast.right.constant;
    ast.toWatch = ast.constant ? [] : [ast];
    break;
  case AST.ConditionalExpression:
    findConstantAndWatchExpressions(ast.test, $filter, astIsPure);
    findConstantAndWatchExpressions(ast.alternate, $filter, astIsPure);
    findConstantAndWatchExpressions(ast.consequent, $filter, astIsPure);
    ast.constant = ast.test.constant && ast.alternate.constant && ast.consequent.constant;
    ast.toWatch = ast.constant ? [] : [ast];
    break;
  case AST.Identifier:
    ast.constant = false;
    ast.toWatch = [ast];
    break;
  case AST.MemberExpression:
    findConstantAndWatchExpressions(ast.object, $filter, astIsPure);
    if (ast.computed) {
      findConstantAndWatchExpressions(ast.property, $filter, astIsPure);
    }
    ast.constant = ast.object.constant && (!ast.computed || ast.property.constant);
    ast.toWatch = ast.constant ? [] : [ast];
    break;
  case AST.CallExpression:
    isStatelessFilter = ast.filter ? isStateless($filter, ast.callee.name) : false;
    allConstants = isStatelessFilter;
    argsToWatch = [];
    forEach(ast.arguments, function(expr) {
      findConstantAndWatchExpressions(expr, $filter, astIsPure);
      allConstants = allConstants && expr.constant;
      argsToWatch.push.apply(argsToWatch, expr.toWatch);
    });
    ast.constant = allConstants;
    ast.toWatch = isStatelessFilter ? argsToWatch : [ast];
    break;
  case AST.AssignmentExpression:
    findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
    findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
    ast.constant = ast.left.constant && ast.right.constant;
    ast.toWatch = [ast];
    break;
  case AST.ArrayExpression:
    allConstants = true;
    argsToWatch = [];
    forEach(ast.elements, function(expr) {
      findConstantAndWatchExpressions(expr, $filter, astIsPure);
      allConstants = allConstants && expr.constant;
      argsToWatch.push.apply(argsToWatch, expr.toWatch);
    });
    ast.constant = allConstants;
    ast.toWatch = argsToWatch;
    break;
  case AST.ObjectExpression:
    allConstants = true;
    argsToWatch = [];
    forEach(ast.properties, function(property) {
      findConstantAndWatchExpressions(property.value, $filter, astIsPure);
      allConstants = allConstants && property.value.constant;
      argsToWatch.push.apply(argsToWatch, property.value.toWatch);
      if (property.computed) {
        //`{[key]: value}` implicitly does `key.toString()` which may be non-pure
        findConstantAndWatchExpressions(property.key, $filter, /*parentIsPure=*/false);
        allConstants = allConstants && property.key.constant;
        argsToWatch.push.apply(argsToWatch, property.key.toWatch);
      }
    });
    ast.constant = allConstants;
    ast.toWatch = argsToWatch;
    break;
  case AST.ThisExpression:
    ast.constant = false;
    ast.toWatch = [];
    break;
  case AST.LocalsExpression:
    ast.constant = false;
    ast.toWatch = [];
    break;
  }
}

function getInputs(body) {
  if (body.length !== 1) return;
  var lastExpression = body[0].expression;
  var candidate = lastExpression.toWatch;
  if (candidate.length !== 1) return candidate;
  return candidate[0] !== lastExpression ? candidate : undefined;
}

function isAssignable(ast) {
  return ast.type === AST.Identifier || ast.type === AST.MemberExpression;
}

function assignableAST(ast) {
  if (ast.body.length === 1 && isAssignable(ast.body[0].expression)) {
    return {type: AST.AssignmentExpression, left: ast.body[0].expression, right: {type: AST.NGValueParameter}, operator: '='};
  }
}

function isLiteral(ast) {
  return ast.body.length === 0 ||
      ast.body.length === 1 && (
      ast.body[0].expression.type === AST.Literal ||
      ast.body[0].expression.type === AST.ArrayExpression ||
      ast.body[0].expression.type === AST.ObjectExpression);
}

function isConstant(ast) {
  return ast.constant;
}

function ASTCompiler($filter) {
  this.$filter = $filter;
}

ASTCompiler.prototype = {
  compile: function(ast) {
    var self = this;
    this.state = {
      nextId: 0,
      filters: {},
      fn: {vars: [], body: [], own: {}},
      assign: {vars: [], body: [], own: {}},
      inputs: []
    };
    findConstantAndWatchExpressions(ast, self.$filter);
    var extra = '';
    var assignable;
    this.stage = 'assign';
    if ((assignable = assignableAST(ast))) {
      this.state.computing = 'assign';
      var result = this.nextId();
      this.recurse(assignable, result);
      this.return_(result);
      extra = 'fn.assign=' + this.generateFunction('assign', 's,v,l');
    }
    var toWatch = getInputs(ast.body);
    self.stage = 'inputs';
    forEach(toWatch, function(watch, key) {
      var fnKey = 'fn' + key;
      self.state[fnKey] = {vars: [], body: [], own: {}};
      self.state.computing = fnKey;
      var intoId = self.nextId();
      self.recurse(watch, intoId);
      self.return_(intoId);
      self.state.inputs.push({name: fnKey, isPure: watch.isPure});
      watch.watchId = key;
    });
    this.state.computing = 'fn';
    this.stage = 'main';
    this.recurse(ast);
    var fnString =
      // The build and minification steps remove the string "use strict" from the code, but this is done using a regex.
      // This is a workaround for this until we do a better job at only removing the prefix only when we should.
      '"' + this.USE + ' ' + this.STRICT + '";\n' +
      this.filterPrefix() +
      'var fn=' + this.generateFunction('fn', 's,l,a,i') +
      extra +
      this.watchFns() +
      'return fn;';

    // eslint-disable-next-line no-new-func
    var fn = (new Function('$filter',
        'getStringValue',
        'ifDefined',
        'plus',
        fnString))(
          this.$filter,
          getStringValue,
          ifDefined,
          plusFn);
    this.state = this.stage = undefined;
    return fn;
  },

  USE: 'use',

  STRICT: 'strict',

  watchFns: function() {
    var result = [];
    var inputs = this.state.inputs;
    var self = this;
    forEach(inputs, function(input) {
      result.push('var ' + input.name + '=' + self.generateFunction(input.name, 's'));
      if (input.isPure) {
        result.push(input.name, '.isPure=' + JSON.stringify(input.isPure) + ';');
      }
    });
    if (inputs.length) {
      result.push('fn.inputs=[' + inputs.map(function(i) { return i.name; }).join(',') + '];');
    }
    return result.join('');
  },

  generateFunction: function(name, params) {
    return 'function(' + params + '){' +
        this.varsPrefix(name) +
        this.body(name) +
        '};';
  },

  filterPrefix: function() {
    var parts = [];
    var self = this;
    forEach(this.state.filters, function(id, filter) {
      parts.push(id + '=$filter(' + self.escape(filter) + ')');
    });
    if (parts.length) return 'var ' + parts.join(',') + ';';
    return '';
  },

  varsPrefix: function(section) {
    return this.state[section].vars.length ? 'var ' + this.state[section].vars.join(',') + ';' : '';
  },

  body: function(section) {
    return this.state[section].body.join('');
  },

  recurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
    var left, right, self = this, args, expression, computed;
    recursionFn = recursionFn || noop;
    if (!skipWatchIdCheck && isDefined(ast.watchId)) {
      intoId = intoId || this.nextId();
      this.if_('i',
        this.lazyAssign(intoId, this.computedMember('i', ast.watchId)),
        this.lazyRecurse(ast, intoId, nameId, recursionFn, create, true)
      );
      return;
    }
    switch (ast.type) {
    case AST.Program:
      forEach(ast.body, function(expression, pos) {
        self.recurse(expression.expression, undefined, undefined, function(expr) { right = expr; });
        if (pos !== ast.body.length - 1) {
          self.current().body.push(right, ';');
        } else {
          self.return_(right);
        }
      });
      break;
    case AST.Literal:
      expression = this.escape(ast.value);
      this.assign(intoId, expression);
      recursionFn(intoId || expression);
      break;
    case AST.UnaryExpression:
      this.recurse(ast.argument, undefined, undefined, function(expr) { right = expr; });
      expression = ast.operator + '(' + this.ifDefined(right, 0) + ')';
      this.assign(intoId, expression);
      recursionFn(expression);
      break;
    case AST.BinaryExpression:
      this.recurse(ast.left, undefined, undefined, function(expr) { left = expr; });
      this.recurse(ast.right, undefined, undefined, function(expr) { right = expr; });
      if (ast.operator === '+') {
        expression = this.plus(left, right);
      } else if (ast.operator === '-') {
        expression = this.ifDefined(left, 0) + ast.operator + this.ifDefined(right, 0);
      } else {
        expression = '(' + left + ')' + ast.operator + '(' + right + ')';
      }
      this.assign(intoId, expression);
      recursionFn(expression);
      break;
    case AST.LogicalExpression:
      intoId = intoId || this.nextId();
      self.recurse(ast.left, intoId);
      self.if_(ast.operator === '&&' ? intoId : self.not(intoId), self.lazyRecurse(ast.right, intoId));
      recursionFn(intoId);
      break;
    case AST.ConditionalExpression:
      intoId = intoId || this.nextId();
      self.recurse(ast.test, intoId);
      self.if_(intoId, self.lazyRecurse(ast.alternate, intoId), self.lazyRecurse(ast.consequent, intoId));
      recursionFn(intoId);
      break;
    case AST.Identifier:
      intoId = intoId || this.nextId();
      if (nameId) {
        nameId.context = self.stage === 'inputs' ? 's' : this.assign(this.nextId(), this.getHasOwnProperty('l', ast.name) + '?l:s');
        nameId.computed = false;
        nameId.name = ast.name;
      }
      self.if_(self.stage === 'inputs' || self.not(self.getHasOwnProperty('l', ast.name)),
        function() {
          self.if_(self.stage === 'inputs' || 's', function() {
            if (create && create !== 1) {
              self.if_(
                self.isNull(self.nonComputedMember('s', ast.name)),
                self.lazyAssign(self.nonComputedMember('s', ast.name), '{}'));
            }
            self.assign(intoId, self.nonComputedMember('s', ast.name));
          });
        }, intoId && self.lazyAssign(intoId, self.nonComputedMember('l', ast.name))
        );
      recursionFn(intoId);
      break;
    case AST.MemberExpression:
      left = nameId && (nameId.context = this.nextId()) || this.nextId();
      intoId = intoId || this.nextId();
      self.recurse(ast.object, left, undefined, function() {
        self.if_(self.notNull(left), function() {
          if (ast.computed) {
            right = self.nextId();
            self.recurse(ast.property, right);
            self.getStringValue(right);
            if (create && create !== 1) {
              self.if_(self.not(self.computedMember(left, right)), self.lazyAssign(self.computedMember(left, right), '{}'));
            }
            expression = self.computedMember(left, right);
            self.assign(intoId, expression);
            if (nameId) {
              nameId.computed = true;
              nameId.name = right;
            }
          } else {
            if (create && create !== 1) {
              self.if_(self.isNull(self.nonComputedMember(left, ast.property.name)), self.lazyAssign(self.nonComputedMember(left, ast.property.name), '{}'));
            }
            expression = self.nonComputedMember(left, ast.property.name);
            self.assign(intoId, expression);
            if (nameId) {
              nameId.computed = false;
              nameId.name = ast.property.name;
            }
          }
        }, function() {
          self.assign(intoId, 'undefined');
        });
        recursionFn(intoId);
      }, !!create);
      break;
    case AST.CallExpression:
      intoId = intoId || this.nextId();
      if (ast.filter) {
        right = self.filter(ast.callee.name);
        args = [];
        forEach(ast.arguments, function(expr) {
          var argument = self.nextId();
          self.recurse(expr, argument);
          args.push(argument);
        });
        expression = right + '(' + args.join(',') + ')';
        self.assign(intoId, expression);
        recursionFn(intoId);
      } else {
        right = self.nextId();
        left = {};
        args = [];
        self.recurse(ast.callee, right, left, function() {
          self.if_(self.notNull(right), function() {
            forEach(ast.arguments, function(expr) {
              self.recurse(expr, ast.constant ? undefined : self.nextId(), undefined, function(argument) {
                args.push(argument);
              });
            });
            if (left.name) {
              expression = self.member(left.context, left.name, left.computed) + '(' + args.join(',') + ')';
            } else {
              expression = right + '(' + args.join(',') + ')';
            }
            self.assign(intoId, expression);
          }, function() {
            self.assign(intoId, 'undefined');
          });
          recursionFn(intoId);
        });
      }
      break;
    case AST.AssignmentExpression:
      right = this.nextId();
      left = {};
      this.recurse(ast.left, undefined, left, function() {
        self.if_(self.notNull(left.context), function() {
          self.recurse(ast.right, right);
          expression = self.member(left.context, left.name, left.computed) + ast.operator + right;
          self.assign(intoId, expression);
          recursionFn(intoId || expression);
        });
      }, 1);
      break;
    case AST.ArrayExpression:
      args = [];
      forEach(ast.elements, function(expr) {
        self.recurse(expr, ast.constant ? undefined : self.nextId(), undefined, function(argument) {
          args.push(argument);
        });
      });
      expression = '[' + args.join(',') + ']';
      this.assign(intoId, expression);
      recursionFn(intoId || expression);
      break;
    case AST.ObjectExpression:
      args = [];
      computed = false;
      forEach(ast.properties, function(property) {
        if (property.computed) {
          computed = true;
        }
      });
      if (computed) {
        intoId = intoId || this.nextId();
        this.assign(intoId, '{}');
        forEach(ast.properties, function(property) {
          if (property.computed) {
            left = self.nextId();
            self.recurse(property.key, left);
          } else {
            left = property.key.type === AST.Identifier ?
                       property.key.name :
                       ('' + property.key.value);
          }
          right = self.nextId();
          self.recurse(property.value, right);
          self.assign(self.member(intoId, left, property.computed), right);
        });
      } else {
        forEach(ast.properties, function(property) {
          self.recurse(property.value, ast.constant ? undefined : self.nextId(), undefined, function(expr) {
            args.push(self.escape(
                property.key.type === AST.Identifier ? property.key.name :
                  ('' + property.key.value)) +
                ':' + expr);
          });
        });
        expression = '{' + args.join(',') + '}';
        this.assign(intoId, expression);
      }
      recursionFn(intoId || expression);
      break;
    case AST.ThisExpression:
      this.assign(intoId, 's');
      recursionFn(intoId || 's');
      break;
    case AST.LocalsExpression:
      this.assign(intoId, 'l');
      recursionFn(intoId || 'l');
      break;
    case AST.NGValueParameter:
      this.assign(intoId, 'v');
      recursionFn(intoId || 'v');
      break;
    }
  },

  getHasOwnProperty: function(element, property) {
    var key = element + '.' + property;
    var own = this.current().own;
    if (!own.hasOwnProperty(key)) {
      own[key] = this.nextId(false, element + '&&(' + this.escape(property) + ' in ' + element + ')');
    }
    return own[key];
  },

  assign: function(id, value) {
    if (!id) return;
    this.current().body.push(id, '=', value, ';');
    return id;
  },

  filter: function(filterName) {
    if (!this.state.filters.hasOwnProperty(filterName)) {
      this.state.filters[filterName] = this.nextId(true);
    }
    return this.state.filters[filterName];
  },

  ifDefined: function(id, defaultValue) {
    return 'ifDefined(' + id + ',' + this.escape(defaultValue) + ')';
  },

  plus: function(left, right) {
    return 'plus(' + left + ',' + right + ')';
  },

  return_: function(id) {
    this.current().body.push('return ', id, ';');
  },

  if_: function(test, alternate, consequent) {
    if (test === true) {
      alternate();
    } else {
      var body = this.current().body;
      body.push('if(', test, '){');
      alternate();
      body.push('}');
      if (consequent) {
        body.push('else{');
        consequent();
        body.push('}');
      }
    }
  },

  not: function(expression) {
    return '!(' + expression + ')';
  },

  isNull: function(expression) {
    return expression + '==null';
  },

  notNull: function(expression) {
    return expression + '!=null';
  },

  nonComputedMember: function(left, right) {
    var SAFE_IDENTIFIER = /^[$_a-zA-Z][$_a-zA-Z0-9]*$/;
    var UNSAFE_CHARACTERS = /[^$_a-zA-Z0-9]/g;
    if (SAFE_IDENTIFIER.test(right)) {
      return left + '.' + right;
    } else {
      return left  + '["' + right.replace(UNSAFE_CHARACTERS, this.stringEscapeFn) + '"]';
    }
  },

  computedMember: function(left, right) {
    return left + '[' + right + ']';
  },

  member: function(left, right, computed) {
    if (computed) return this.computedMember(left, right);
    return this.nonComputedMember(left, right);
  },

  getStringValue: function(item) {
    this.assign(item, 'getStringValue(' + item + ')');
  },

  lazyRecurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
    var self = this;
    return function() {
      self.recurse(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck);
    };
  },

  lazyAssign: function(id, value) {
    var self = this;
    return function() {
      self.assign(id, value);
    };
  },

  stringEscapeRegex: /[^ a-zA-Z0-9]/g,

  stringEscapeFn: function(c) {
    return '\\u' + ('0000' + c.charCodeAt(0).toString(16)).slice(-4);
  },

  escape: function(value) {
    if (isString(value)) return '\'' + value.replace(this.stringEscapeRegex, this.stringEscapeFn) + '\'';
    if (isNumber(value)) return value.toString();
    if (value === true) return 'true';
    if (value === false) return 'false';
    if (value === null) return 'null';
    if (typeof value === 'undefined') return 'undefined';

    throw $parseMinErr('esc', 'IMPOSSIBLE');
  },

  nextId: function(skip, init) {
    var id = 'v' + (this.state.nextId++);
    if (!skip) {
      this.current().vars.push(id + (init ? '=' + init : ''));
    }
    return id;
  },

  current: function() {
    return this.state[this.state.computing];
  }
};


function ASTInterpreter($filter) {
  this.$filter = $filter;
}

ASTInterpreter.prototype = {
  compile: function(ast) {
    var self = this;
    findConstantAndWatchExpressions(ast, self.$filter);
    var assignable;
    var assign;
    if ((assignable = assignableAST(ast))) {
      assign = this.recurse(assignable);
    }
    var toWatch = getInputs(ast.body);
    var inputs;
    if (toWatch) {
      inputs = [];
      forEach(toWatch, function(watch, key) {
        var input = self.recurse(watch);
        input.isPure = watch.isPure;
        watch.input = input;
        inputs.push(input);
        watch.watchId = key;
      });
    }
    var expressions = [];
    forEach(ast.body, function(expression) {
      expressions.push(self.recurse(expression.expression));
    });
    var fn = ast.body.length === 0 ? noop :
             ast.body.length === 1 ? expressions[0] :
             function(scope, locals) {
               var lastValue;
               forEach(expressions, function(exp) {
                 lastValue = exp(scope, locals);
               });
               return lastValue;
             };
    if (assign) {
      fn.assign = function(scope, value, locals) {
        return assign(scope, locals, value);
      };
    }
    if (inputs) {
      fn.inputs = inputs;
    }
    return fn;
  },

  recurse: function(ast, context, create) {
    var left, right, self = this, args;
    if (ast.input) {
      return this.inputs(ast.input, ast.watchId);
    }
    switch (ast.type) {
    case AST.Literal:
      return this.value(ast.value, context);
    case AST.UnaryExpression:
      right = this.recurse(ast.argument);
      return this['unary' + ast.operator](right, context);
    case AST.BinaryExpression:
      left = this.recurse(ast.left);
      right = this.recurse(ast.right);
      return this['binary' + ast.operator](left, right, context);
    case AST.LogicalExpression:
      left = this.recurse(ast.left);
      right = this.recurse(ast.right);
      return this['binary' + ast.operator](left, right, context);
    case AST.ConditionalExpression:
      return this['ternary?:'](
        this.recurse(ast.test),
        this.recurse(ast.alternate),
        this.recurse(ast.consequent),
        context
      );
    case AST.Identifier:
      return self.identifier(ast.name, context, create);
    case AST.MemberExpression:
      left = this.recurse(ast.object, false, !!create);
      if (!ast.computed) {
        right = ast.property.name;
      }
      if (ast.computed) right = this.recurse(ast.property);
      return ast.computed ?
        this.computedMember(left, right, context, create) :
        this.nonComputedMember(left, right, context, create);
    case AST.CallExpression:
      args = [];
      forEach(ast.arguments, function(expr) {
        args.push(self.recurse(expr));
      });
      if (ast.filter) right = this.$filter(ast.callee.name);
      if (!ast.filter) right = this.recurse(ast.callee, true);
      return ast.filter ?
        function(scope, locals, assign, inputs) {
          var values = [];
          for (var i = 0; i < args.length; ++i) {
            values.push(args[i](scope, locals, assign, inputs));
          }
          var value = right.apply(undefined, values, inputs);
          return context ? {context: undefined, name: undefined, value: value} : value;
        } :
        function(scope, locals, assign, inputs) {
          var rhs = right(scope, locals, assign, inputs);
          var value;
          if (rhs.value != null) {
            var values = [];
            for (var i = 0; i < args.length; ++i) {
              values.push(args[i](scope, locals, assign, inputs));
            }
            value = rhs.value.apply(rhs.context, values);
          }
          return context ? {value: value} : value;
        };
    case AST.AssignmentExpression:
      left = this.recurse(ast.left, true, 1);
      right = this.recurse(ast.right);
      return function(scope, locals, assign, inputs) {
        var lhs = left(scope, locals, assign, inputs);
        var rhs = right(scope, locals, assign, inputs);
        lhs.context[lhs.name] = rhs;
        return context ? {value: rhs} : rhs;
      };
    case AST.ArrayExpression:
      args = [];
      forEach(ast.elements, function(expr) {
        args.push(self.recurse(expr));
      });
      return function(scope, locals, assign, inputs) {
        var value = [];
        for (var i = 0; i < args.length; ++i) {
          value.push(args[i](scope, locals, assign, inputs));
        }
        return context ? {value: value} : value;
      };
    case AST.ObjectExpression:
      args = [];
      forEach(ast.properties, function(property) {
        if (property.computed) {
          args.push({key: self.recurse(property.key),
                     computed: true,
                     value: self.recurse(property.value)
          });
        } else {
          args.push({key: property.key.type === AST.Identifier ?
                          property.key.name :
                          ('' + property.key.value),
                     computed: false,
                     value: self.recurse(property.value)
          });
        }
      });
      return function(scope, locals, assign, inputs) {
        var value = {};
        for (var i = 0; i < args.length; ++i) {
          if (args[i].computed) {
            value[args[i].key(scope, locals, assign, inputs)] = args[i].value(scope, locals, assign, inputs);
          } else {
            value[args[i].key] = args[i].value(scope, locals, assign, inputs);
          }
        }
        return context ? {value: value} : value;
      };
    case AST.ThisExpression:
      return function(scope) {
        return context ? {value: scope} : scope;
      };
    case AST.LocalsExpression:
      return function(scope, locals) {
        return context ? {value: locals} : locals;
      };
    case AST.NGValueParameter:
      return function(scope, locals, assign) {
        return context ? {value: assign} : assign;
      };
    }
  },

  'unary+': function(argument, context) {
    return function(scope, locals, assign, inputs) {
      var arg = argument(scope, locals, assign, inputs);
      if (isDefined(arg)) {
        arg = +arg;
      } else {
        arg = 0;
      }
      return context ? {value: arg} : arg;
    };
  },
  'unary-': function(argument, context) {
    return function(scope, locals, assign, inputs) {
      var arg = argument(scope, locals, assign, inputs);
      if (isDefined(arg)) {
        arg = -arg;
      } else {
        arg = -0;
      }
      return context ? {value: arg} : arg;
    };
  },
  'unary!': function(argument, context) {
    return function(scope, locals, assign, inputs) {
      var arg = !argument(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary+': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var lhs = left(scope, locals, assign, inputs);
      var rhs = right(scope, locals, assign, inputs);
      var arg = plusFn(lhs, rhs);
      return context ? {value: arg} : arg;
    };
  },
  'binary-': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var lhs = left(scope, locals, assign, inputs);
      var rhs = right(scope, locals, assign, inputs);
      var arg = (isDefined(lhs) ? lhs : 0) - (isDefined(rhs) ? rhs : 0);
      return context ? {value: arg} : arg;
    };
  },
  'binary*': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) * right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary/': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) / right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary%': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) % right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary===': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) === right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary!==': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) !== right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary==': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      // eslint-disable-next-line eqeqeq
      var arg = left(scope, locals, assign, inputs) == right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary!=': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      // eslint-disable-next-line eqeqeq
      var arg = left(scope, locals, assign, inputs) != right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary<': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) < right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary>': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) > right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary<=': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) <= right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary>=': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) >= right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary&&': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) && right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary||': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) || right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'ternary?:': function(test, alternate, consequent, context) {
    return function(scope, locals, assign, inputs) {
      var arg = test(scope, locals, assign, inputs) ? alternate(scope, locals, assign, inputs) : consequent(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  value: function(value, context) {
    return function() { return context ? {context: undefined, name: undefined, value: value} : value; };
  },
  identifier: function(name, context, create) {
    return function(scope, locals, assign, inputs) {
      var base = locals && (name in locals) ? locals : scope;
      if (create && create !== 1 && base && base[name] == null) {
        base[name] = {};
      }
      var value = base ? base[name] : undefined;
      if (context) {
        return {context: base, name: name, value: value};
      } else {
        return value;
      }
    };
  },
  computedMember: function(left, right, context, create) {
    return function(scope, locals, assign, inputs) {
      var lhs = left(scope, locals, assign, inputs);
      var rhs;
      var value;
      if (lhs != null) {
        rhs = right(scope, locals, assign, inputs);
        rhs = getStringValue(rhs);
        if (create && create !== 1) {
          if (lhs && !(lhs[rhs])) {
            lhs[rhs] = {};
          }
        }
        value = lhs[rhs];
      }
      if (context) {
        return {context: lhs, name: rhs, value: value};
      } else {
        return value;
      }
    };
  },
  nonComputedMember: function(left, right, context, create) {
    return function(scope, locals, assign, inputs) {
      var lhs = left(scope, locals, assign, inputs);
      if (create && create !== 1) {
        if (lhs && lhs[right] == null) {
          lhs[right] = {};
        }
      }
      var value = lhs != null ? lhs[right] : undefined;
      if (context) {
        return {context: lhs, name: right, value: value};
      } else {
        return value;
      }
    };
  },
  inputs: function(input, watchId) {
    return function(scope, value, locals, inputs) {
      if (inputs) return inputs[watchId];
      return input(scope, value, locals);
    };
  }
};

/**
 * @constructor
 */
function Parser(lexer, $filter, options) {
  this.ast = new AST(lexer, options);
  this.astCompiler = options.csp ? new ASTInterpreter($filter) :
                                   new ASTCompiler($filter);
}

Parser.prototype = {
  constructor: Parser,

  parse: function(text) {
    var ast = this.getAst(text);
    var fn = this.astCompiler.compile(ast.ast);
    fn.literal = isLiteral(ast.ast);
    fn.constant = isConstant(ast.ast);
    fn.oneTime = ast.oneTime;
    return fn;
  },

  getAst: function(exp) {
    var oneTime = false;
    exp = exp.trim();

    if (exp.charAt(0) === ':' && exp.charAt(1) === ':') {
      oneTime = true;
      exp = exp.substring(2);
    }
    return {
      ast: this.ast.ast(exp),
      oneTime: oneTime
    };
  }
};

function getValueOf(value) {
  return isFunction(value.valueOf) ? value.valueOf() : objectValueOf.call(value);
}

///////////////////////////////////

/**
 * @ngdoc service
 * @name $parse
 * @kind function
 *
 * @description
 *
 * Converts AngularJS {@link guide/expression expression} into a function.
 *
 * ```js
 *   var getter = $parse('user.name');
 *   var setter = getter.assign;
 *   var context = {user:{name:'AngularJS'}};
 *   var locals = {user:{name:'local'}};
 *
 *   expect(getter(context)).toEqual('AngularJS');
 *   setter(context, 'newValue');
 *   expect(context.user.name).toEqual('newValue');
 *   expect(getter(context, locals)).toEqual('local');
 * ```
 *
 *
 * @param {string} expression String expression to compile.
 * @returns {function(context, locals)} a function which represents the compiled expression:
 *
 *    * `context` – `{object}` – an object against which any expressions embedded in the strings
 *      are evaluated against (typically a scope object).
 *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
 *      `context`.
 *
 *    The returned function also has the following properties:
 *      * `literal` – `{boolean}` – whether the expression's top-level node is a JavaScript
 *        literal.
 *      * `constant` – `{boolean}` – whether the expression is made entirely of JavaScript
 *        constant literals.
 *      * `assign` – `{?function(context, value)}` – if the expression is assignable, this will be
 *        set to a function to change its value on the given context.
 *
 */


/**
 * @ngdoc provider
 * @name $parseProvider
 * @this
 *
 * @description
 * `$parseProvider` can be used for configuring the default behavior of the {@link ng.$parse $parse}
 *  service.
 */
function $ParseProvider() {
  var cache = createMap();
  var literals = {
    'true': true,
    'false': false,
    'null': null,
    'undefined': undefined
  };
  var identStart, identContinue;

  /**
   * @ngdoc method
   * @name $parseProvider#addLiteral
   * @description
   *
   * Configure $parse service to add literal values that will be present as literal at expressions.
   *
   * @param {string} literalName Token for the literal value. The literal name value must be a valid literal name.
   * @param {*} literalValue Value for this literal. All literal values must be primitives or `undefined`.
   *
   **/
  this.addLiteral = function(literalName, literalValue) {
    literals[literalName] = literalValue;
  };

 /**
  * @ngdoc method
  * @name $parseProvider#setIdentifierFns
  *
  * @description
  *
  * Allows defining the set of characters that are allowed in AngularJS expressions. The function
  * `identifierStart` will get called to know if a given character is a valid character to be the
  * first character for an identifier. The function `identifierContinue` will get called to know if
  * a given character is a valid character to be a follow-up identifier character. The functions
  * `identifierStart` and `identifierContinue` will receive as arguments the single character to be
  * identifier and the character code point. These arguments will be `string` and `numeric`. Keep in
  * mind that the `string` parameter can be two characters long depending on the character
  * representation. It is expected for the function to return `true` or `false`, whether that
  * character is allowed or not.
  *
  * Since this function will be called extensively, keep the implementation of these functions fast,
  * as the performance of these functions have a direct impact on the expressions parsing speed.
  *
  * @param {function=} identifierStart The function that will decide whether the given character is
  *   a valid identifier start character.
  * @param {function=} identifierContinue The function that will decide whether the given character is
  *   a valid identifier continue character.
  */
  this.setIdentifierFns = function(identifierStart, identifierContinue) {
    identStart = identifierStart;
    identContinue = identifierContinue;
    return this;
  };

  this.$get = ['$filter', function($filter) {
    var noUnsafeEval = csp().noUnsafeEval;
    var $parseOptions = {
          csp: noUnsafeEval,
          literals: copy(literals),
          isIdentifierStart: isFunction(identStart) && identStart,
          isIdentifierContinue: isFunction(identContinue) && identContinue
        };
    $parse.$$getAst = $$getAst;
    return $parse;

    function $parse(exp, interceptorFn) {
      var parsedExpression, cacheKey;

      switch (typeof exp) {
        case 'string':
          exp = exp.trim();
          cacheKey = exp;

          parsedExpression = cache[cacheKey];

          if (!parsedExpression) {
            var lexer = new Lexer($parseOptions);
            var parser = new Parser(lexer, $filter, $parseOptions);
            parsedExpression = parser.parse(exp);

            cache[cacheKey] = addWatchDelegate(parsedExpression);
          }
          return addInterceptor(parsedExpression, interceptorFn);

        case 'function':
          return addInterceptor(exp, interceptorFn);

        default:
          return addInterceptor(noop, interceptorFn);
      }
    }

    function $$getAst(exp) {
      var lexer = new Lexer($parseOptions);
      var parser = new Parser(lexer, $filter, $parseOptions);
      return parser.getAst(exp).ast;
    }

    function expressionInputDirtyCheck(newValue, oldValueOfValue, compareObjectIdentity) {

      if (newValue == null || oldValueOfValue == null) { // null/undefined
        return newValue === oldValueOfValue;
      }

      if (typeof newValue === 'object') {

        // attempt to convert the value to a primitive type
        // TODO(docs): add a note to docs that by implementing valueOf even objects and arrays can
        //             be cheaply dirty-checked
        newValue = getValueOf(newValue);

        if (typeof newValue === 'object' && !compareObjectIdentity) {
          // objects/arrays are not supported - deep-watching them would be too expensive
          return false;
        }

        // fall-through to the primitive equality check
      }

      //Primitive or NaN
      // eslint-disable-next-line no-self-compare
      return newValue === oldValueOfValue || (newValue !== newValue && oldValueOfValue !== oldValueOfValue);
    }

    function inputsWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
      var inputExpressions = parsedExpression.inputs;
      var lastResult;

      if (inputExpressions.length === 1) {
        var oldInputValueOf = expressionInputDirtyCheck; // init to something unique so that equals check fails
        inputExpressions = inputExpressions[0];
        return scope.$watch(function expressionInputWatch(scope) {
          var newInputValue = inputExpressions(scope);
          if (!expressionInputDirtyCheck(newInputValue, oldInputValueOf, inputExpressions.isPure)) {
            lastResult = parsedExpression(scope, undefined, undefined, [newInputValue]);
            oldInputValueOf = newInputValue && getValueOf(newInputValue);
          }
          return lastResult;
        }, listener, objectEquality, prettyPrintExpression);
      }

      var oldInputValueOfValues = [];
      var oldInputValues = [];
      for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
        oldInputValueOfValues[i] = expressionInputDirtyCheck; // init to something unique so that equals check fails
        oldInputValues[i] = null;
      }

      return scope.$watch(function expressionInputsWatch(scope) {
        var changed = false;

        for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
          var newInputValue = inputExpressions[i](scope);
          if (changed || (changed = !expressionInputDirtyCheck(newInputValue, oldInputValueOfValues[i], inputExpressions[i].isPure))) {
            oldInputValues[i] = newInputValue;
            oldInputValueOfValues[i] = newInputValue && getValueOf(newInputValue);
          }
        }

        if (changed) {
          lastResult = parsedExpression(scope, undefined, undefined, oldInputValues);
        }

        return lastResult;
      }, listener, objectEquality, prettyPrintExpression);
    }

    function oneTimeWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
      var isDone = parsedExpression.literal ? isAllDefined : isDefined;
      var unwatch, lastValue;

      var exp = parsedExpression.$$intercepted || parsedExpression;
      var post = parsedExpression.$$interceptor || identity;

      var useInputs = parsedExpression.inputs && !exp.inputs;

      // Propagate the literal/inputs/constant attributes
      // ... but not oneTime since we are handling it
      oneTimeWatch.literal = parsedExpression.literal;
      oneTimeWatch.constant = parsedExpression.constant;
      oneTimeWatch.inputs = parsedExpression.inputs;

      // Allow other delegates to run on this wrapped expression
      addWatchDelegate(oneTimeWatch);

      unwatch = scope.$watch(oneTimeWatch, listener, objectEquality, prettyPrintExpression);

      return unwatch;

      function unwatchIfDone() {
        if (isDone(lastValue)) {
          unwatch();
        }
      }

      function oneTimeWatch(scope, locals, assign, inputs) {
        lastValue = useInputs && inputs ? inputs[0] : exp(scope, locals, assign, inputs);
        if (isDone(lastValue)) {
          scope.$$postDigest(unwatchIfDone);
        }
        return post(lastValue);
      }
    }

    function isAllDefined(value) {
      var allDefined = true;
      forEach(value, function(val) {
        if (!isDefined(val)) allDefined = false;
      });
      return allDefined;
    }

    function constantWatchDelegate(scope, listener, objectEquality, parsedExpression) {
      var unwatch = scope.$watch(function constantWatch(scope) {
        unwatch();
        return parsedExpression(scope);
      }, listener, objectEquality);
      return unwatch;
    }

    function addWatchDelegate(parsedExpression) {
      if (parsedExpression.constant) {
        parsedExpression.$$watchDelegate = constantWatchDelegate;
      } else if (parsedExpression.oneTime) {
        parsedExpression.$$watchDelegate = oneTimeWatchDelegate;
      } else if (parsedExpression.inputs) {
        parsedExpression.$$watchDelegate = inputsWatchDelegate;
      }

      return parsedExpression;
    }

    function chainInterceptors(first, second) {
      function chainedInterceptor(value) {
        return second(first(value));
      }
      chainedInterceptor.$stateful = first.$stateful || second.$stateful;
      chainedInterceptor.$$pure = first.$$pure && second.$$pure;

      return chainedInterceptor;
    }

    function addInterceptor(parsedExpression, interceptorFn) {
      if (!interceptorFn) return parsedExpression;

      // Extract any existing interceptors out of the parsedExpression
      // to ensure the original parsedExpression is always the $$intercepted
      if (parsedExpression.$$interceptor) {
        interceptorFn = chainInterceptors(parsedExpression.$$interceptor, interceptorFn);
        parsedExpression = parsedExpression.$$intercepted;
      }

      var useInputs = false;

      var fn = function interceptedExpression(scope, locals, assign, inputs) {
        var value = useInputs && inputs ? inputs[0] : parsedExpression(scope, locals, assign, inputs);
        return interceptorFn(value);
      };

      // Maintain references to the interceptor/intercepted
      fn.$$intercepted = parsedExpression;
      fn.$$interceptor = interceptorFn;

      // Propagate the literal/oneTime/constant attributes
      fn.literal = parsedExpression.literal;
      fn.oneTime = parsedExpression.oneTime;
      fn.constant = parsedExpression.constant;

      // Treat the interceptor like filters.
      // If it is not $stateful then only watch its inputs.
      // If the expression itself has no inputs then use the full expression as an input.
      if (!interceptorFn.$stateful) {
        useInputs = !parsedExpression.inputs;
        fn.inputs = parsedExpression.inputs ? parsedExpression.inputs : [parsedExpression];

        if (!interceptorFn.$$pure) {
          fn.inputs = fn.inputs.map(function(e) {
              // Remove the isPure flag of inputs when it is not absolute because they are now wrapped in a
              // non-pure interceptor function.
              if (e.isPure === PURITY_RELATIVE) {
                return function depurifier(s) { return e(s); };
              }
              return e;
            });
        }
      }

      return addWatchDelegate(fn);
    }
  }];
}

/**
 * @ngdoc service
 * @name $q
 * @requires $rootScope
 *
 * @description
 * A service that helps you run functions asynchronously, and use their return values (or exceptions)
 * when they are done processing.
 *
 * This is a [Promises/A+](https://promisesaplus.com/)-compliant implementation of promises/deferred
 * objects inspired by [Kris Kowal's Q](https://github.com/kriskowal/q).
 *
 * $q can be used in two fashions --- one which is more similar to Kris Kowal's Q or jQuery's Deferred
 * implementations, and the other which resembles ES6 (ES2015) promises to some degree.
 *
 * ## $q constructor
 *
 * The streamlined ES6 style promise is essentially just using $q as a constructor which takes a `resolver`
 * function as the first argument. This is similar to the native Promise implementation from ES6,
 * see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
 *
 * While the constructor-style use is supported, not all of the supporting methods from ES6 promises are
 * available yet.
 *
 * It can be used like so:
 *
 * ```js
 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
 *   // are available in the current lexical scope (they could have been injected or passed in).
 *
 *   function asyncGreet(name) {
 *     // perform some asynchronous operation, resolve or reject the promise when appropriate.
 *     return $q(function(resolve, reject) {
 *       setTimeout(function() {
 *         if (okToGreet(name)) {
 *           resolve('Hello, ' + name + '!');
 *         } else {
 *           reject('Greeting ' + name + ' is not allowed.');
 *         }
 *       }, 1000);
 *     });
 *   }
 *
 *   var promise = asyncGreet('Robin Hood');
 *   promise.then(function(greeting) {
 *     alert('Success: ' + greeting);
 *   }, function(reason) {
 *     alert('Failed: ' + reason);
 *   });
 * ```
 *
 * Note: progress/notify callbacks are not currently supported via the ES6-style interface.
 *
 * Note: unlike ES6 behavior, an exception thrown in the constructor function will NOT implicitly reject the promise.
 *
 * However, the more traditional CommonJS-style usage is still available, and documented below.
 *
 * [The CommonJS Promise proposal](http://wiki.commonjs.org/wiki/Promises) describes a promise as an
 * interface for interacting with an object that represents the result of an action that is
 * performed asynchronously, and may or may not be finished at any given point in time.
 *
 * From the perspective of dealing with error handling, deferred and promise APIs are to
 * asynchronous programming what `try`, `catch` and `throw` keywords are to synchronous programming.
 *
 * ```js
 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
 *   // are available in the current lexical scope (they could have been injected or passed in).
 *
 *   function asyncGreet(name) {
 *     var deferred = $q.defer();
 *
 *     setTimeout(function() {
 *       deferred.notify('About to greet ' + name + '.');
 *
 *       if (okToGreet(name)) {
 *         deferred.resolve('Hello, ' + name + '!');
 *       } else {
 *         deferred.reject('Greeting ' + name + ' is not allowed.');
 *       }
 *     }, 1000);
 *
 *     return deferred.promise;
 *   }
 *
 *   var promise = asyncGreet('Robin Hood');
 *   promise.then(function(greeting) {
 *     alert('Success: ' + greeting);
 *   }, function(reason) {
 *     alert('Failed: ' + reason);
 *   }, function(update) {
 *     alert('Got notification: ' + update);
 *   });
 * ```
 *
 * At first it might not be obvious why this extra complexity is worth the trouble. The payoff
 * comes in the way of guarantees that promise and deferred APIs make, see
 * https://github.com/kriskowal/uncommonjs/blob/master/promises/specification.md.
 *
 * Additionally the promise api allows for composition that is very hard to do with the
 * traditional callback ([CPS](http://en.wikipedia.org/wiki/Continuation-passing_style)) approach.
 * For more on this please see the [Q documentation](https://github.com/kriskowal/q) especially the
 * section on serial or parallel joining of promises.
 *
 * ## The Deferred API
 *
 * A new instance of deferred is constructed by calling `$q.defer()`.
 *
 * The purpose of the deferred object is to expose the associated Promise instance as well as APIs
 * that can be used for signaling the successful or unsuccessful completion, as well as the status
 * of the task.
 *
 * **Methods**
 *
 * - `resolve(value)` – resolves the derived promise with the `value`. If the value is a rejection
 *   constructed via `$q.reject`, the promise will be rejected instead.
 * - `reject(reason)` – rejects the derived promise with the `reason`. This is equivalent to
 *   resolving it with a rejection constructed via `$q.reject`.
 * - `notify(value)` - provides updates on the status of the promise's execution. This may be called
 *   multiple times before the promise is either resolved or rejected.
 *
 * **Properties**
 *
 * - promise – `{Promise}` – promise object associated with this deferred.
 *
 *
 * ## The Promise API
 *
 * A new promise instance is created when a deferred instance is created and can be retrieved by
 * calling `deferred.promise`.
 *
 * The purpose of the promise object is to allow for interested parties to get access to the result
 * of the deferred task when it completes.
 *
 * **Methods**
 *
 * - `then(successCallback, [errorCallback], [notifyCallback])` – regardless of when the promise was or
 *   will be resolved or rejected, `then` calls one of the success or error callbacks asynchronously
 *   as soon as the result is available. The callbacks are called with a single argument: the result
 *   or rejection reason. Additionally, the notify callback may be called zero or more times to
 *   provide a progress indication, before the promise is resolved or rejected.
 *
 *   This method *returns a new promise* which is resolved or rejected via the return value of the
 *   `successCallback`, `errorCallback` (unless that value is a promise, in which case it is resolved
 *   with the value which is resolved in that promise using
 *   [promise chaining](http://www.html5rocks.com/en/tutorials/es6/promises/#toc-promises-queues)).
 *   It also notifies via the return value of the `notifyCallback` method. The promise cannot be
 *   resolved or rejected from the notifyCallback method. The errorCallback and notifyCallback
 *   arguments are optional.
 *
 * - `catch(errorCallback)` – shorthand for `promise.then(null, errorCallback)`
 *
 * - `finally(callback, notifyCallback)` – allows you to observe either the fulfillment or rejection of a promise,
 *   but to do so without modifying the final value. This is useful to release resources or do some
 *   clean-up that needs to be done whether the promise was rejected or resolved. See the [full
 *   specification](https://github.com/kriskowal/q/wiki/API-Reference#promisefinallycallback) for
 *   more information.
 *
 * ## Chaining promises
 *
 * Because calling the `then` method of a promise returns a new derived promise, it is easily
 * possible to create a chain of promises:
 *
 * ```js
 *   promiseB = promiseA.then(function(result) {
 *     return result + 1;
 *   });
 *
 *   // promiseB will be resolved immediately after promiseA is resolved and its value
 *   // will be the result of promiseA incremented by 1
 * ```
 *
 * It is possible to create chains of any length and since a promise can be resolved with another
 * promise (which will defer its resolution further), it is possible to pause/defer resolution of
 * the promises at any point in the chain. This makes it possible to implement powerful APIs like
 * $http's response interceptors.
 *
 *
 * ## Differences between Kris Kowal's Q and $q
 *
 *  There are two main differences:
 *
 * - $q is integrated with the {@link ng.$rootScope.Scope} Scope model observation
 *   mechanism in AngularJS, which means faster propagation of resolution or rejection into your
 *   models and avoiding unnecessary browser repaints, which would result in flickering UI.
 * - Q has many more features than $q, but that comes at a cost of bytes. $q is tiny, but contains
 *   all the important functionality needed for common async tasks.
 *
 * ## Testing
 *
 *  ```js
 *    it('should simulate promise', inject(function($q, $rootScope) {
 *      var deferred = $q.defer();
 *      var promise = deferred.promise;
 *      var resolvedValue;
 *
 *      promise.then(function(value) { resolvedValue = value; });
 *      expect(resolvedValue).toBeUndefined();
 *
 *      // Simulate resolving of promise
 *      deferred.resolve(123);
 *      // Note that the 'then' function does not get called synchronously.
 *      // This is because we want the promise API to always be async, whether or not
 *      // it got called synchronously or asynchronously.
 *      expect(resolvedValue).toBeUndefined();
 *
 *      // Propagate promise resolution to 'then' functions using $apply().
 *      $rootScope.$apply();
 *      expect(resolvedValue).toEqual(123);
 *    }));
 *  ```
 *
 * @param {function(function, function)} resolver Function which is responsible for resolving or
 *   rejecting the newly created promise. The first parameter is a function which resolves the
 *   promise, the second parameter is a function which rejects the promise.
 *
 * @returns {Promise} The newly created promise.
 */
/**
 * @ngdoc provider
 * @name $qProvider
 * @this
 *
 * @description
 */
function $QProvider() {
  var errorOnUnhandledRejections = true;
  this.$get = ['$rootScope', '$exceptionHandler', function($rootScope, $exceptionHandler) {
    return qFactory(function(callback) {
      $rootScope.$evalAsync(callback);
    }, $exceptionHandler, errorOnUnhandledRejections);
  }];

  /**
   * @ngdoc method
   * @name $qProvider#errorOnUnhandledRejections
   * @kind function
   *
   * @description
   * Retrieves or overrides whether to generate an error when a rejected promise is not handled.
   * This feature is enabled by default.
   *
   * @param {boolean=} value Whether to generate an error when a rejected promise is not handled.
   * @returns {boolean|ng.$qProvider} Current value when called without a new value or self for
   *    chaining otherwise.
   */
  this.errorOnUnhandledRejections = function(value) {
    if (isDefined(value)) {
      errorOnUnhandledRejections = value;
      return this;
    } else {
      return errorOnUnhandledRejections;
    }
  };
}

/** @this */
function $$QProvider() {
  var errorOnUnhandledRejections = true;
  this.$get = ['$browser', '$exceptionHandler', function($browser, $exceptionHandler) {
    return qFactory(function(callback) {
      $browser.defer(callback);
    }, $exceptionHandler, errorOnUnhandledRejections);
  }];

  this.errorOnUnhandledRejections = function(value) {
    if (isDefined(value)) {
      errorOnUnhandledRejections = value;
      return this;
    } else {
      return errorOnUnhandledRejections;
    }
  };
}

/**
 * Constructs a promise manager.
 *
 * @param {function(function)} nextTick Function for executing functions in the next turn.
 * @param {function(...*)} exceptionHandler Function into which unexpected exceptions are passed for
 *     debugging purposes.
 * @param {boolean=} errorOnUnhandledRejections Whether an error should be generated on unhandled
 *     promises rejections.
 * @returns {object} Promise manager.
 */
function qFactory(nextTick, exceptionHandler, errorOnUnhandledRejections) {
  var $qMinErr = minErr('$q', TypeError);
  var queueSize = 0;
  var checkQueue = [];

  /**
   * @ngdoc method
   * @name ng.$q#defer
   * @kind function
   *
   * @description
   * Creates a `Deferred` object which represents a task which will finish in the future.
   *
   * @returns {Deferred} Returns a new instance of deferred.
   */
  function defer() {
    return new Deferred();
  }

  function Deferred() {
    var promise = this.promise = new Promise();
    //Non prototype methods necessary to support unbound execution :/
    this.resolve = function(val) { resolvePromise(promise, val); };
    this.reject = function(reason) { rejectPromise(promise, reason); };
    this.notify = function(progress) { notifyPromise(promise, progress); };
  }


  function Promise() {
    this.$$state = { status: 0 };
  }

  extend(Promise.prototype, {
    then: function(onFulfilled, onRejected, progressBack) {
      if (isUndefined(onFulfilled) && isUndefined(onRejected) && isUndefined(progressBack)) {
        return this;
      }
      var result = new Promise();

      this.$$state.pending = this.$$state.pending || [];
      this.$$state.pending.push([result, onFulfilled, onRejected, progressBack]);
      if (this.$$state.status > 0) scheduleProcessQueue(this.$$state);

      return result;
    },

    'catch': function(callback) {
      return this.then(null, callback);
    },

    'finally': function(callback, progressBack) {
      return this.then(function(value) {
        return handleCallback(value, resolve, callback);
      }, function(error) {
        return handleCallback(error, reject, callback);
      }, progressBack);
    }
  });

  function processQueue(state) {
    var fn, promise, pending;

    pending = state.pending;
    state.processScheduled = false;
    state.pending = undefined;
    try {
      for (var i = 0, ii = pending.length; i < ii; ++i) {
        markQStateExceptionHandled(state);
        promise = pending[i][0];
        fn = pending[i][state.status];
        try {
          if (isFunction(fn)) {
            resolvePromise(promise, fn(state.value));
          } else if (state.status === 1) {
            resolvePromise(promise, state.value);
          } else {
            rejectPromise(promise, state.value);
          }
        } catch (e) {
          rejectPromise(promise, e);
          // This error is explicitly marked for being passed to the $exceptionHandler
          if (e && e.$$passToExceptionHandler === true) {
            exceptionHandler(e);
          }
        }
      }
    } finally {
      --queueSize;
      if (errorOnUnhandledRejections && queueSize === 0) {
        nextTick(processChecks);
      }
    }
  }

  function processChecks() {
    // eslint-disable-next-line no-unmodified-loop-condition
    while (!queueSize && checkQueue.length) {
      var toCheck = checkQueue.shift();
      if (!isStateExceptionHandled(toCheck)) {
        markQStateExceptionHandled(toCheck);
        var errorMessage = 'Possibly unhandled rejection: ' + toDebugString(toCheck.value);
        if (isError(toCheck.value)) {
          exceptionHandler(toCheck.value, errorMessage);
        } else {
          exceptionHandler(errorMessage);
        }
      }
    }
  }

  function scheduleProcessQueue(state) {
    if (errorOnUnhandledRejections && !state.pending && state.status === 2 && !isStateExceptionHandled(state)) {
      if (queueSize === 0 && checkQueue.length === 0) {
        nextTick(processChecks);
      }
      checkQueue.push(state);
    }
    if (state.processScheduled || !state.pending) return;
    state.processScheduled = true;
    ++queueSize;
    nextTick(function() { processQueue(state); });
  }

  function resolvePromise(promise, val) {
    if (promise.$$state.status) return;
    if (val === promise) {
      $$reject(promise, $qMinErr(
        'qcycle',
        'Expected promise to be resolved with value other than itself \'{0}\'',
        val));
    } else {
      $$resolve(promise, val);
    }

  }

  function $$resolve(promise, val) {
    var then;
    var done = false;
    try {
      if (isObject(val) || isFunction(val)) then = val.then;
      if (isFunction(then)) {
        promise.$$state.status = -1;
        then.call(val, doResolve, doReject, doNotify);
      } else {
        promise.$$state.value = val;
        promise.$$state.status = 1;
        scheduleProcessQueue(promise.$$state);
      }
    } catch (e) {
      doReject(e);
    }

    function doResolve(val) {
      if (done) return;
      done = true;
      $$resolve(promise, val);
    }
    function doReject(val) {
      if (done) return;
      done = true;
      $$reject(promise, val);
    }
    function doNotify(progress) {
      notifyPromise(promise, progress);
    }
  }

  function rejectPromise(promise, reason) {
    if (promise.$$state.status) return;
    $$reject(promise, reason);
  }

  function $$reject(promise, reason) {
    promise.$$state.value = reason;
    promise.$$state.status = 2;
    scheduleProcessQueue(promise.$$state);
  }

  function notifyPromise(promise, progress) {
    var callbacks = promise.$$state.pending;

    if ((promise.$$state.status <= 0) && callbacks && callbacks.length) {
      nextTick(function() {
        var callback, result;
        for (var i = 0, ii = callbacks.length; i < ii; i++) {
          result = callbacks[i][0];
          callback = callbacks[i][3];
          try {
            notifyPromise(result, isFunction(callback) ? callback(progress) : progress);
          } catch (e) {
            exceptionHandler(e);
          }
        }
      });
    }
  }

  /**
   * @ngdoc method
   * @name $q#reject
   * @kind function
   *
   * @description
   * Creates a promise that is resolved as rejected with the specified `reason`. This api should be
   * used to forward rejection in a chain of promises. If you are dealing with the last promise in
   * a promise chain, you don't need to worry about it.
   *
   * When comparing deferreds/promises to the familiar behavior of try/catch/throw, think of
   * `reject` as the `throw` keyword in JavaScript. This also means that if you "catch" an error via
   * a promise error callback and you want to forward the error to the promise derived from the
   * current promise, you have to "rethrow" the error by returning a rejection constructed via
   * `reject`.
   *
   * ```js
   *   promiseB = promiseA.then(function(result) {
   *     // success: do something and resolve promiseB
   *     //          with the old or a new result
   *     return result;
   *   }, function(reason) {
   *     // error: handle the error if possible and
   *     //        resolve promiseB with newPromiseOrValue,
   *     //        otherwise forward the rejection to promiseB
   *     if (canHandle(reason)) {
   *      // handle the error and recover
   *      return newPromiseOrValue;
   *     }
   *     return $q.reject(reason);
   *   });
   * ```
   *
   * @param {*} reason Constant, message, exception or an object representing the rejection reason.
   * @returns {Promise} Returns a promise that was already resolved as rejected with the `reason`.
   */
  function reject(reason) {
    var result = new Promise();
    rejectPromise(result, reason);
    return result;
  }

  function handleCallback(value, resolver, callback) {
    var callbackOutput = null;
    try {
      if (isFunction(callback)) callbackOutput = callback();
    } catch (e) {
      return reject(e);
    }
    if (isPromiseLike(callbackOutput)) {
      return callbackOutput.then(function() {
        return resolver(value);
      }, reject);
    } else {
      return resolver(value);
    }
  }

  /**
   * @ngdoc method
   * @name $q#when
   * @kind function
   *
   * @description
   * Wraps an object that might be a value or a (3rd party) then-able promise into a $q promise.
   * This is useful when you are dealing with an object that might or might not be a promise, or if
   * the promise comes from a source that can't be trusted.
   *
   * @param {*} value Value or a promise
   * @param {Function=} successCallback
   * @param {Function=} errorCallback
   * @param {Function=} progressCallback
   * @returns {Promise} Returns a promise of the passed value or promise
   */


  function when(value, callback, errback, progressBack) {
    var result = new Promise();
    resolvePromise(result, value);
    return result.then(callback, errback, progressBack);
  }

  /**
   * @ngdoc method
   * @name $q#resolve
   * @kind function
   *
   * @description
   * Alias of {@link ng.$q#when when} to maintain naming consistency with ES6.
   *
   * @param {*} value Value or a promise
   * @param {Function=} successCallback
   * @param {Function=} errorCallback
   * @param {Function=} progressCallback
   * @returns {Promise} Returns a promise of the passed value or promise
   */
  var resolve = when;

  /**
   * @ngdoc method
   * @name $q#all
   * @kind function
   *
   * @description
   * Combines multiple promises into a single promise that is resolved when all of the input
   * promises are resolved.
   *
   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
   * @returns {Promise} Returns a single promise that will be resolved with an array/hash of values,
   *   each value corresponding to the promise at the same index/key in the `promises` array/hash.
   *   If any of the promises is resolved with a rejection, this resulting promise will be rejected
   *   with the same rejection value.
   */

  function all(promises) {
    var result = new Promise(),
        counter = 0,
        results = isArray(promises) ? [] : {};

    forEach(promises, function(promise, key) {
      counter++;
      when(promise).then(function(value) {
        results[key] = value;
        if (!(--counter)) resolvePromise(result, results);
      }, function(reason) {
        rejectPromise(result, reason);
      });
    });

    if (counter === 0) {
      resolvePromise(result, results);
    }

    return result;
  }

  /**
   * @ngdoc method
   * @name $q#race
   * @kind function
   *
   * @description
   * Returns a promise that resolves or rejects as soon as one of those promises
   * resolves or rejects, with the value or reason from that promise.
   *
   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
   * @returns {Promise} a promise that resolves or rejects as soon as one of the `promises`
   * resolves or rejects, with the value or reason from that promise.
   */

  function race(promises) {
    var deferred = defer();

    forEach(promises, function(promise) {
      when(promise).then(deferred.resolve, deferred.reject);
    });

    return deferred.promise;
  }

  function $Q(resolver) {
    if (!isFunction(resolver)) {
      throw $qMinErr('norslvr', 'Expected resolverFn, got \'{0}\'', resolver);
    }

    var promise = new Promise();

    function resolveFn(value) {
      resolvePromise(promise, value);
    }

    function rejectFn(reason) {
      rejectPromise(promise, reason);
    }

    resolver(resolveFn, rejectFn);

    return promise;
  }

  // Let's make the instanceof operator work for promises, so that
  // `new $q(fn) instanceof $q` would evaluate to true.
  $Q.prototype = Promise.prototype;

  $Q.defer = defer;
  $Q.reject = reject;
  $Q.when = when;
  $Q.resolve = resolve;
  $Q.all = all;
  $Q.race = race;

  return $Q;
}

function isStateExceptionHandled(state) {
  return !!state.pur;
}
function markQStateExceptionHandled(state) {
  state.pur = true;
}
function markQExceptionHandled(q) {
  // Built-in `$q` promises will always have a `$$state` property. This check is to allow
  // overwriting `$q` with a different promise library (e.g. Bluebird + angular-bluebird-promises).
  // (Currently, this is the only method that might be called with a promise, even if it is not
  // created by the built-in `$q`.)
  if (q.$$state) {
    markQStateExceptionHandled(q.$$state);
  }
}

/** @this */
function $$RAFProvider() { //rAF
  this.$get = ['$window', '$timeout', function($window, $timeout) {
    var requestAnimationFrame = $window.requestAnimationFrame ||
                                $window.webkitRequestAnimationFrame;

    var cancelAnimationFrame = $window.cancelAnimationFrame ||
                               $window.webkitCancelAnimationFrame ||
                               $window.webkitCancelRequestAnimationFrame;

    var rafSupported = !!requestAnimationFrame;
    var raf = rafSupported
      ? function(fn) {
          var id = requestAnimationFrame(fn);
          return function() {
            cancelAnimationFrame(id);
          };
        }
      : function(fn) {
          var timer = $timeout(fn, 16.66, false); // 1000 / 60 = 16.666
          return function() {
            $timeout.cancel(timer);
          };
        };

    raf.supported = rafSupported;

    return raf;
  }];
}

/**
 * DESIGN NOTES
 *
 * The design decisions behind the scope are heavily favored for speed and memory consumption.
 *
 * The typical use of scope is to watch the expressions, which most of the time return the same
 * value as last time so we optimize the operation.
 *
 * Closures construction is expensive in terms of speed as well as memory:
 *   - No closures, instead use prototypical inheritance for API
 *   - Internal state needs to be stored on scope directly, which means that private state is
 *     exposed as $$____ properties
 *
 * Loop operations are optimized by using while(count--) { ... }
 *   - This means that in order to keep the same order of execution as addition we have to add
 *     items to the array at the beginning (unshift) instead of at the end (push)
 *
 * Child scopes are created and removed often
 *   - Using an array would be slow since inserts in the middle are expensive; so we use linked lists
 *
 * There are fewer watches than observers. This is why you don't want the observer to be implemented
 * in the same way as watch. Watch requires return of the initialization function which is expensive
 * to construct.
 */


/**
 * @ngdoc provider
 * @name $rootScopeProvider
 * @description
 *
 * Provider for the $rootScope service.
 */

/**
 * @ngdoc method
 * @name $rootScopeProvider#digestTtl
 * @description
 *
 * Sets the number of `$digest` iterations the scope should attempt to execute before giving up and
 * assuming that the model is unstable.
 *
 * The current default is 10 iterations.
 *
 * In complex applications it's possible that the dependencies between `$watch`s will result in
 * several digest iterations. However if an application needs more than the default 10 digest
 * iterations for its model to stabilize then you should investigate what is causing the model to
 * continuously change during the digest.
 *
 * Increasing the TTL could have performance implications, so you should not change it without
 * proper justification.
 *
 * @param {number} limit The number of digest iterations.
 */


/**
 * @ngdoc service
 * @name $rootScope
 * @this
 *
 * @description
 *
 * Every application has a single root {@link ng.$rootScope.Scope scope}.
 * All other scopes are descendant scopes of the root scope. Scopes provide separation
 * between the model and the view, via a mechanism for watching the model for changes.
 * They also provide event emission/broadcast and subscription facility. See the
 * {@link guide/scope developer guide on scopes}.
 */
function $RootScopeProvider() {
  var TTL = 10;
  var $rootScopeMinErr = minErr('$rootScope');
  var lastDirtyWatch = null;
  var applyAsyncId = null;

  this.digestTtl = function(value) {
    if (arguments.length) {
      TTL = value;
    }
    return TTL;
  };

  function createChildScopeClass(parent) {
    function ChildScope() {
      this.$$watchers = this.$$nextSibling =
          this.$$childHead = this.$$childTail = null;
      this.$$listeners = {};
      this.$$listenerCount = {};
      this.$$watchersCount = 0;
      this.$id = nextUid();
      this.$$ChildScope = null;
      this.$$suspended = false;
    }
    ChildScope.prototype = parent;
    return ChildScope;
  }

  this.$get = ['$exceptionHandler', '$parse', '$browser',
      function($exceptionHandler, $parse, $browser) {

    function destroyChildScope($event) {
        $event.currentScope.$$destroyed = true;
    }

    function cleanUpScope($scope) {

      // Support: IE 9 only
      if (msie === 9) {
        // There is a memory leak in IE9 if all child scopes are not disconnected
        // completely when a scope is destroyed. So this code will recurse up through
        // all this scopes children
        //
        // See issue https://github.com/angular/angular.js/issues/10706
        if ($scope.$$childHead) {
          cleanUpScope($scope.$$childHead);
        }
        if ($scope.$$nextSibling) {
          cleanUpScope($scope.$$nextSibling);
        }
      }

      // The code below works around IE9 and V8's memory leaks
      //
      // See:
      // - https://code.google.com/p/v8/issues/detail?id=2073#c26
      // - https://github.com/angular/angular.js/issues/6794#issuecomment-38648909
      // - https://github.com/angular/angular.js/issues/1313#issuecomment-10378451

      $scope.$parent = $scope.$$nextSibling = $scope.$$prevSibling = $scope.$$childHead =
          $scope.$$childTail = $scope.$root = $scope.$$watchers = null;
    }

    /**
     * @ngdoc type
     * @name $rootScope.Scope
     *
     * @description
     * A root scope can be retrieved using the {@link ng.$rootScope $rootScope} key from the
     * {@link auto.$injector $injector}. Child scopes are created using the
     * {@link ng.$rootScope.Scope#$new $new()} method. (Most scopes are created automatically when
     * compiled HTML template is executed.) See also the {@link guide/scope Scopes guide} for
     * an in-depth introduction and usage examples.
     *
     *
     * ## Inheritance
     * A scope can inherit from a parent scope, as in this example:
     * ```js
         var parent = $rootScope;
         var child = parent.$new();

         parent.salutation = "Hello";
         expect(child.salutation).toEqual('Hello');

         child.salutation = "Welcome";
         expect(child.salutation).toEqual('Welcome');
         expect(parent.salutation).toEqual('Hello');
     * ```
     *
     * When interacting with `Scope` in tests, additional helper methods are available on the
     * instances of `Scope` type. See {@link ngMock.$rootScope.Scope ngMock Scope} for additional
     * details.
     *
     *
     * @param {Object.<string, function()>=} providers Map of service factory which need to be
     *                                       provided for the current scope. Defaults to {@link ng}.
     * @param {Object.<string, *>=} instanceCache Provides pre-instantiated services which should
     *                              append/override services provided by `providers`. This is handy
     *                              when unit-testing and having the need to override a default
     *                              service.
     * @returns {Object} Newly created scope.
     *
     */
    function Scope() {
      this.$id = nextUid();
      this.$$phase = this.$parent = this.$$watchers =
                     this.$$nextSibling = this.$$prevSibling =
                     this.$$childHead = this.$$childTail = null;
      this.$root = this;
      this.$$destroyed = false;
      this.$$suspended = false;
      this.$$listeners = {};
      this.$$listenerCount = {};
      this.$$watchersCount = 0;
      this.$$isolateBindings = null;
    }

    /**
     * @ngdoc property
     * @name $rootScope.Scope#$id
     *
     * @description
     * Unique scope ID (monotonically increasing) useful for debugging.
     */

     /**
      * @ngdoc property
      * @name $rootScope.Scope#$parent
      *
      * @description
      * Reference to the parent scope.
      */

      /**
       * @ngdoc property
       * @name $rootScope.Scope#$root
       *
       * @description
       * Reference to the root scope.
       */

    Scope.prototype = {
      constructor: Scope,
      /**
       * @ngdoc method
       * @name $rootScope.Scope#$new
       * @kind function
       *
       * @description
       * Creates a new child {@link ng.$rootScope.Scope scope}.
       *
       * The parent scope will propagate the {@link ng.$rootScope.Scope#$digest $digest()} event.
       * The scope can be removed from the scope hierarchy using {@link ng.$rootScope.Scope#$destroy $destroy()}.
       *
       * {@link ng.$rootScope.Scope#$destroy $destroy()} must be called on a scope when it is
       * desired for the scope and its child scopes to be permanently detached from the parent and
       * thus stop participating in model change detection and listener notification by invoking.
       *
       * @param {boolean} isolate If true, then the scope does not prototypically inherit from the
       *         parent scope. The scope is isolated, as it can not see parent scope properties.
       *         When creating widgets, it is useful for the widget to not accidentally read parent
       *         state.
       *
       * @param {Scope} [parent=this] The {@link ng.$rootScope.Scope `Scope`} that will be the `$parent`
       *                              of the newly created scope. Defaults to `this` scope if not provided.
       *                              This is used when creating a transclude scope to correctly place it
       *                              in the scope hierarchy while maintaining the correct prototypical
       *                              inheritance.
       *
       * @returns {Object} The newly created child scope.
       *
       */
      $new: function(isolate, parent) {
        var child;

        parent = parent || this;

        if (isolate) {
          child = new Scope();
          child.$root = this.$root;
        } else {
          // Only create a child scope class if somebody asks for one,
          // but cache it to allow the VM to optimize lookups.
          if (!this.$$ChildScope) {
            this.$$ChildScope = createChildScopeClass(this);
          }
          child = new this.$$ChildScope();
        }
        child.$parent = parent;
        child.$$prevSibling = parent.$$childTail;
        if (parent.$$childHead) {
          parent.$$childTail.$$nextSibling = child;
          parent.$$childTail = child;
        } else {
          parent.$$childHead = parent.$$childTail = child;
        }

        // When the new scope is not isolated or we inherit from `this`, and
        // the parent scope is destroyed, the property `$$destroyed` is inherited
        // prototypically. In all other cases, this property needs to be set
        // when the parent scope is destroyed.
        // The listener needs to be added after the parent is set
        if (isolate || parent !== this) child.$on('$destroy', destroyChildScope);

        return child;
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$watch
       * @kind function
       *
       * @description
       * Registers a `listener` callback to be executed whenever the `watchExpression` changes.
       *
       * - The `watchExpression` is called on every call to {@link ng.$rootScope.Scope#$digest
       *   $digest()} and should return the value that will be watched. (`watchExpression` should not change
       *   its value when executed multiple times with the same input because it may be executed multiple
       *   times by {@link ng.$rootScope.Scope#$digest $digest()}. That is, `watchExpression` should be
       *   [idempotent](http://en.wikipedia.org/wiki/Idempotence).)
       * - The `listener` is called only when the value from the current `watchExpression` and the
       *   previous call to `watchExpression` are not equal (with the exception of the initial run,
       *   see below). Inequality is determined according to reference inequality,
       *   [strict comparison](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Comparison_Operators)
       *    via the `!==` Javascript operator, unless `objectEquality == true`
       *   (see next point)
       * - When `objectEquality == true`, inequality of the `watchExpression` is determined
       *   according to the {@link angular.equals} function. To save the value of the object for
       *   later comparison, the {@link angular.copy} function is used. This therefore means that
       *   watching complex objects will have adverse memory and performance implications.
       * - This should not be used to watch for changes in objects that are (or contain)
       *   [File](https://developer.mozilla.org/docs/Web/API/File) objects due to limitations with {@link angular.copy `angular.copy`}.
       * - The watch `listener` may change the model, which may trigger other `listener`s to fire.
       *   This is achieved by rerunning the watchers until no changes are detected. The rerun
       *   iteration limit is 10 to prevent an infinite loop deadlock.
       *
       *
       * If you want to be notified whenever {@link ng.$rootScope.Scope#$digest $digest} is called,
       * you can register a `watchExpression` function with no `listener`. (Be prepared for
       * multiple calls to your `watchExpression` because it will execute multiple times in a
       * single {@link ng.$rootScope.Scope#$digest $digest} cycle if a change is detected.)
       *
       * After a watcher is registered with the scope, the `listener` fn is called asynchronously
       * (via {@link ng.$rootScope.Scope#$evalAsync $evalAsync}) to initialize the
       * watcher. In rare cases, this is undesirable because the listener is called when the result
       * of `watchExpression` didn't change. To detect this scenario within the `listener` fn, you
       * can compare the `newVal` and `oldVal`. If these two values are identical (`===`) then the
       * listener was called due to initialization.
       *
       *
       *
       * @example
       * ```js
           // let's assume that scope was dependency injected as the $rootScope
           var scope = $rootScope;
           scope.name = 'misko';
           scope.counter = 0;

           expect(scope.counter).toEqual(0);
           scope.$watch('name', function(newValue, oldValue) {
             scope.counter = scope.counter + 1;
           });
           expect(scope.counter).toEqual(0);

           scope.$digest();
           // the listener is always called during the first $digest loop after it was registered
           expect(scope.counter).toEqual(1);

           scope.$digest();
           // but now it will not be called unless the value changes
           expect(scope.counter).toEqual(1);

           scope.name = 'adam';
           scope.$digest();
           expect(scope.counter).toEqual(2);



           // Using a function as a watchExpression
           var food;
           scope.foodCounter = 0;
           expect(scope.foodCounter).toEqual(0);
           scope.$watch(
             // This function returns the value being watched. It is called for each turn of the $digest loop
             function() { return food; },
             // This is the change listener, called when the value returned from the above function changes
             function(newValue, oldValue) {
               if ( newValue !== oldValue ) {
                 // Only increment the counter if the value changed
                 scope.foodCounter = scope.foodCounter + 1;
               }
             }
           );
           // No digest has been run so the counter will be zero
           expect(scope.foodCounter).toEqual(0);

           // Run the digest but since food has not changed count will still be zero
           scope.$digest();
           expect(scope.foodCounter).toEqual(0);

           // Update food and run digest.  Now the counter will increment
           food = 'cheeseburger';
           scope.$digest();
           expect(scope.foodCounter).toEqual(1);

       * ```
       *
       *
       *
       * @param {(function()|string)} watchExpression Expression that is evaluated on each
       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. A change in the return value triggers
       *    a call to the `listener`.
       *
       *    - `string`: Evaluated as {@link guide/expression expression}
       *    - `function(scope)`: called with current `scope` as a parameter.
       * @param {function(newVal, oldVal, scope)} listener Callback called whenever the value
       *    of `watchExpression` changes.
       *
       *    - `newVal` contains the current value of the `watchExpression`
       *    - `oldVal` contains the previous value of the `watchExpression`
       *    - `scope` refers to the current scope
       * @param {boolean=} [objectEquality=false] Compare for object equality using {@link angular.equals} instead of
       *     comparing for reference equality.
       * @returns {function()} Returns a deregistration function for this listener.
       */
      $watch: function(watchExp, listener, objectEquality, prettyPrintExpression) {
        var get = $parse(watchExp);
        var fn = isFunction(listener) ? listener : noop;

        if (get.$$watchDelegate) {
          return get.$$watchDelegate(this, fn, objectEquality, get, watchExp);
        }
        var scope = this,
            array = scope.$$watchers,
            watcher = {
              fn: fn,
              last: initWatchVal,
              get: get,
              exp: prettyPrintExpression || watchExp,
              eq: !!objectEquality
            };

        lastDirtyWatch = null;

        if (!array) {
          array = scope.$$watchers = [];
          array.$$digestWatchIndex = -1;
        }
        // we use unshift since we use a while loop in $digest for speed.
        // the while loop reads in reverse order.
        array.unshift(watcher);
        array.$$digestWatchIndex++;
        incrementWatchersCount(this, 1);

        return function deregisterWatch() {
          var index = arrayRemove(array, watcher);
          if (index >= 0) {
            incrementWatchersCount(scope, -1);
            if (index < array.$$digestWatchIndex) {
              array.$$digestWatchIndex--;
            }
          }
          lastDirtyWatch = null;
        };
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$watchGroup
       * @kind function
       *
       * @description
       * A variant of {@link ng.$rootScope.Scope#$watch $watch()} where it watches an array of `watchExpressions`.
       * If any one expression in the collection changes the `listener` is executed.
       *
       * - The items in the `watchExpressions` array are observed via the standard `$watch` operation. Their return
       *   values are examined for changes on every call to `$digest`.
       * - The `listener` is called whenever any expression in the `watchExpressions` array changes.
       *
       * @param {Array.<string|Function(scope)>} watchExpressions Array of expressions that will be individually
       * watched using {@link ng.$rootScope.Scope#$watch $watch()}
       *
       * @param {function(newValues, oldValues, scope)} listener Callback called whenever the return value of any
       *    expression in `watchExpressions` changes
       *    The `newValues` array contains the current values of the `watchExpressions`, with the indexes matching
       *    those of `watchExpression`
       *    and the `oldValues` array contains the previous values of the `watchExpressions`, with the indexes matching
       *    those of `watchExpression`
       *    The `scope` refers to the current scope.
       * @returns {function()} Returns a de-registration function for all listeners.
       */
      $watchGroup: function(watchExpressions, listener) {
        var oldValues = new Array(watchExpressions.length);
        var newValues = new Array(watchExpressions.length);
        var deregisterFns = [];
        var self = this;
        var changeReactionScheduled = false;
        var firstRun = true;

        if (!watchExpressions.length) {
          // No expressions means we call the listener ASAP
          var shouldCall = true;
          self.$evalAsync(function() {
            if (shouldCall) listener(newValues, newValues, self);
          });
          return function deregisterWatchGroup() {
            shouldCall = false;
          };
        }

        if (watchExpressions.length === 1) {
          // Special case size of one
          return this.$watch(watchExpressions[0], function watchGroupAction(value, oldValue, scope) {
            newValues[0] = value;
            oldValues[0] = oldValue;
            listener(newValues, (value === oldValue) ? newValues : oldValues, scope);
          });
        }

        forEach(watchExpressions, function(expr, i) {
          var unwatchFn = self.$watch(expr, function watchGroupSubAction(value) {
            newValues[i] = value;
            if (!changeReactionScheduled) {
              changeReactionScheduled = true;
              self.$evalAsync(watchGroupAction);
            }
          });
          deregisterFns.push(unwatchFn);
        });

        function watchGroupAction() {
          changeReactionScheduled = false;

          try {
            if (firstRun) {
              firstRun = false;
              listener(newValues, newValues, self);
            } else {
              listener(newValues, oldValues, self);
            }
          } finally {
            for (var i = 0; i < watchExpressions.length; i++) {
              oldValues[i] = newValues[i];
            }
          }
        }

        return function deregisterWatchGroup() {
          while (deregisterFns.length) {
            deregisterFns.shift()();
          }
        };
      },


      /**
       * @ngdoc method
       * @name $rootScope.Scope#$watchCollection
       * @kind function
       *
       * @description
       * Shallow watches the properties of an object and fires whenever any of the properties change
       * (for arrays, this implies watching the array items; for object maps, this implies watching
       * the properties). If a change is detected, the `listener` callback is fired.
       *
       * - The `obj` collection is observed via standard $watch operation and is examined on every
       *   call to $digest() to see if any items have been added, removed, or moved.
       * - The `listener` is called whenever anything within the `obj` has changed. Examples include
       *   adding, removing, and moving items belonging to an object or array.
       *
       *
       * @example
       * ```js
          $scope.names = ['igor', 'matias', 'misko', 'james'];
          $scope.dataCount = 4;

          $scope.$watchCollection('names', function(newNames, oldNames) {
            $scope.dataCount = newNames.length;
          });

          expect($scope.dataCount).toEqual(4);
          $scope.$digest();

          //still at 4 ... no changes
          expect($scope.dataCount).toEqual(4);

          $scope.names.pop();
          $scope.$digest();

          //now there's been a change
          expect($scope.dataCount).toEqual(3);
       * ```
       *
       *
       * @param {string|function(scope)} obj Evaluated as {@link guide/expression expression}. The
       *    expression value should evaluate to an object or an array which is observed on each
       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. Any shallow change within the
       *    collection will trigger a call to the `listener`.
       *
       * @param {function(newCollection, oldCollection, scope)} listener a callback function called
       *    when a change is detected.
       *    - The `newCollection` object is the newly modified data obtained from the `obj` expression
       *    - The `oldCollection` object is a copy of the former collection data.
       *      Due to performance considerations, the`oldCollection` value is computed only if the
       *      `listener` function declares two or more arguments.
       *    - The `scope` argument refers to the current scope.
       *
       * @returns {function()} Returns a de-registration function for this listener. When the
       *    de-registration function is executed, the internal watch operation is terminated.
       */
      $watchCollection: function(obj, listener) {
        // Mark the interceptor as
        // ... $$pure when literal since the instance will change when any input changes
        $watchCollectionInterceptor.$$pure = $parse(obj).literal;
        // ... $stateful when non-literal since we must read the state of the collection
        $watchCollectionInterceptor.$stateful = !$watchCollectionInterceptor.$$pure;

        var self = this;
        // the current value, updated on each dirty-check run
        var newValue;
        // a shallow copy of the newValue from the last dirty-check run,
        // updated to match newValue during dirty-check run
        var oldValue;
        // a shallow copy of the newValue from when the last change happened
        var veryOldValue;
        // only track veryOldValue if the listener is asking for it
        var trackVeryOldValue = (listener.length > 1);
        var changeDetected = 0;
        var changeDetector = $parse(obj, $watchCollectionInterceptor);
        var internalArray = [];
        var internalObject = {};
        var initRun = true;
        var oldLength = 0;

        function $watchCollectionInterceptor(_value) {
          newValue = _value;
          var newLength, key, bothNaN, newItem, oldItem;

          // If the new value is undefined, then return undefined as the watch may be a one-time watch
          if (isUndefined(newValue)) return;

          if (!isObject(newValue)) { // if primitive
            if (oldValue !== newValue) {
              oldValue = newValue;
              changeDetected++;
            }
          } else if (isArrayLike(newValue)) {
            if (oldValue !== internalArray) {
              // we are transitioning from something which was not an array into array.
              oldValue = internalArray;
              oldLength = oldValue.length = 0;
              changeDetected++;
            }

            newLength = newValue.length;

            if (oldLength !== newLength) {
              // if lengths do not match we need to trigger change notification
              changeDetected++;
              oldValue.length = oldLength = newLength;
            }
            // copy the items to oldValue and look for changes.
            for (var i = 0; i < newLength; i++) {
              oldItem = oldValue[i];
              newItem = newValue[i];

              // eslint-disable-next-line no-self-compare
              bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
              if (!bothNaN && (oldItem !== newItem)) {
                changeDetected++;
                oldValue[i] = newItem;
              }
            }
          } else {
            if (oldValue !== internalObject) {
              // we are transitioning from something which was not an object into object.
              oldValue = internalObject = {};
              oldLength = 0;
              changeDetected++;
            }
            // copy the items to oldValue and look for changes.
            newLength = 0;
            for (key in newValue) {
              if (hasOwnProperty.call(newValue, key)) {
                newLength++;
                newItem = newValue[key];
                oldItem = oldValue[key];

                if (key in oldValue) {
                  // eslint-disable-next-line no-self-compare
                  bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
                  if (!bothNaN && (oldItem !== newItem)) {
                    changeDetected++;
                    oldValue[key] = newItem;
                  }
                } else {
                  oldLength++;
                  oldValue[key] = newItem;
                  changeDetected++;
                }
              }
            }
            if (oldLength > newLength) {
              // we used to have more keys, need to find them and destroy them.
              changeDetected++;
              for (key in oldValue) {
                if (!hasOwnProperty.call(newValue, key)) {
                  oldLength--;
                  delete oldValue[key];
                }
              }
            }
          }
          return changeDetected;
        }

        function $watchCollectionAction() {
          if (initRun) {
            initRun = false;
            listener(newValue, newValue, self);
          } else {
            listener(newValue, veryOldValue, self);
          }

          // make a copy for the next time a collection is changed
          if (trackVeryOldValue) {
            if (!isObject(newValue)) {
              //primitive
              veryOldValue = newValue;
            } else if (isArrayLike(newValue)) {
              veryOldValue = new Array(newValue.length);
              for (var i = 0; i < newValue.length; i++) {
                veryOldValue[i] = newValue[i];
              }
            } else { // if object
              veryOldValue = {};
              for (var key in newValue) {
                if (hasOwnProperty.call(newValue, key)) {
                  veryOldValue[key] = newValue[key];
                }
              }
            }
          }
        }

        return this.$watch(changeDetector, $watchCollectionAction);
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$digest
       * @kind function
       *
       * @description
       * Processes all of the {@link ng.$rootScope.Scope#$watch watchers} of the current scope and
       * its children. Because a {@link ng.$rootScope.Scope#$watch watcher}'s listener can change
       * the model, the `$digest()` keeps calling the {@link ng.$rootScope.Scope#$watch watchers}
       * until no more listeners are firing. This means that it is possible to get into an infinite
       * loop. This function will throw `'Maximum iteration limit exceeded.'` if the number of
       * iterations exceeds 10.
       *
       * Usually, you don't call `$digest()` directly in
       * {@link ng.directive:ngController controllers} or in
       * {@link ng.$compileProvider#directive directives}.
       * Instead, you should call {@link ng.$rootScope.Scope#$apply $apply()} (typically from within
       * a {@link ng.$compileProvider#directive directive}), which will force a `$digest()`.
       *
       * If you want to be notified whenever `$digest()` is called,
       * you can register a `watchExpression` function with
       * {@link ng.$rootScope.Scope#$watch $watch()} with no `listener`.
       *
       * In unit tests, you may need to call `$digest()` to simulate the scope life cycle.
       *
       * @example
       * ```js
           var scope = ...;
           scope.name = 'misko';
           scope.counter = 0;

           expect(scope.counter).toEqual(0);
           scope.$watch('name', function(newValue, oldValue) {
             scope.counter = scope.counter + 1;
           });
           expect(scope.counter).toEqual(0);

           scope.$digest();
           // the listener is always called during the first $digest loop after it was registered
           expect(scope.counter).toEqual(1);

           scope.$digest();
           // but now it will not be called unless the value changes
           expect(scope.counter).toEqual(1);

           scope.name = 'adam';
           scope.$digest();
           expect(scope.counter).toEqual(2);
       * ```
       *
       */
      $digest: function() {
        var watch, value, last, fn, get,
            watchers,
            dirty, ttl = TTL,
            next, current, target = asyncQueue.length ? $rootScope : this,
            watchLog = [],
            logIdx, asyncTask;

        beginPhase('$digest');
        // Check for changes to browser url that happened in sync before the call to $digest
        $browser.$$checkUrlChange();

        if (this === $rootScope && applyAsyncId !== null) {
          // If this is the root scope, and $applyAsync has scheduled a deferred $apply(), then
          // cancel the scheduled $apply and flush the queue of expressions to be evaluated.
          $browser.defer.cancel(applyAsyncId);
          flushApplyAsync();
        }

        lastDirtyWatch = null;

        do { // "while dirty" loop
          dirty = false;
          current = target;

          // It's safe for asyncQueuePosition to be a local variable here because this loop can't
          // be reentered recursively. Calling $digest from a function passed to $evalAsync would
          // lead to a '$digest already in progress' error.
          for (var asyncQueuePosition = 0; asyncQueuePosition < asyncQueue.length; asyncQueuePosition++) {
            try {
              asyncTask = asyncQueue[asyncQueuePosition];
              fn = asyncTask.fn;
              fn(asyncTask.scope, asyncTask.locals);
            } catch (e) {
              $exceptionHandler(e);
            }
            lastDirtyWatch = null;
          }
          asyncQueue.length = 0;

          traverseScopesLoop:
          do { // "traverse the scopes" loop
            if ((watchers = !current.$$suspended && current.$$watchers)) {
              // process our watches
              watchers.$$digestWatchIndex = watchers.length;
              while (watchers.$$digestWatchIndex--) {
                try {
                  watch = watchers[watchers.$$digestWatchIndex];
                  // Most common watches are on primitives, in which case we can short
                  // circuit it with === operator, only when === fails do we use .equals
                  if (watch) {
                    get = watch.get;
                    if ((value = get(current)) !== (last = watch.last) &&
                        !(watch.eq
                            ? equals(value, last)
                            : (isNumberNaN(value) && isNumberNaN(last)))) {
                      dirty = true;
                      lastDirtyWatch = watch;
                      watch.last = watch.eq ? copy(value, null) : value;
                      fn = watch.fn;
                      fn(value, ((last === initWatchVal) ? value : last), current);
                      if (ttl < 5) {
                        logIdx = 4 - ttl;
                        if (!watchLog[logIdx]) watchLog[logIdx] = [];
                        watchLog[logIdx].push({
                          msg: isFunction(watch.exp) ? 'fn: ' + (watch.exp.name || watch.exp.toString()) : watch.exp,
                          newVal: value,
                          oldVal: last
                        });
                      }
                    } else if (watch === lastDirtyWatch) {
                      // If the most recently dirty watcher is now clean, short circuit since the remaining watchers
                      // have already been tested.
                      dirty = false;
                      break traverseScopesLoop;
                    }
                  }
                } catch (e) {
                  $exceptionHandler(e);
                }
              }
            }

            // Insanity Warning: scope depth-first traversal
            // yes, this code is a bit crazy, but it works and we have tests to prove it!
            // this piece should be kept in sync with the traversal in $broadcast
            // (though it differs due to having the extra check for $$suspended and does not
            // check $$listenerCount)
            if (!(next = ((!current.$$suspended && current.$$watchersCount && current.$$childHead) ||
                (current !== target && current.$$nextSibling)))) {
              while (current !== target && !(next = current.$$nextSibling)) {
                current = current.$parent;
              }
            }
          } while ((current = next));

          // `break traverseScopesLoop;` takes us to here

          if ((dirty || asyncQueue.length) && !(ttl--)) {
            clearPhase();
            throw $rootScopeMinErr('infdig',
                '{0} $digest() iterations reached. Aborting!\n' +
                'Watchers fired in the last 5 iterations: {1}',
                TTL, watchLog);
          }

        } while (dirty || asyncQueue.length);

        clearPhase();

        // postDigestQueuePosition isn't local here because this loop can be reentered recursively.
        while (postDigestQueuePosition < postDigestQueue.length) {
          try {
            postDigestQueue[postDigestQueuePosition++]();
          } catch (e) {
            $exceptionHandler(e);
          }
        }
        postDigestQueue.length = postDigestQueuePosition = 0;

        // Check for changes to browser url that happened during the $digest
        // (for which no event is fired; e.g. via `history.pushState()`)
        $browser.$$checkUrlChange();
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$suspend
       * @kind function
       *
       * @description
       * Suspend watchers of this scope subtree so that they will not be invoked during digest.
       *
       * This can be used to optimize your application when you know that running those watchers
       * is redundant.
       *
       * **Warning**
       *
       * Suspending scopes from the digest cycle can have unwanted and difficult to debug results.
       * Only use this approach if you are confident that you know what you are doing and have
       * ample tests to ensure that bindings get updated as you expect.
       *
       * Some of the things to consider are:
       *
       * * Any external event on a directive/component will not trigger a digest while the hosting
       *   scope is suspended - even if the event handler calls `$apply()` or `$rootScope.$digest()`.
       * * Transcluded content exists on a scope that inherits from outside a directive but exists
       *   as a child of the directive's containing scope. If the containing scope is suspended the
       *   transcluded scope will also be suspended, even if the scope from which the transcluded
       *   scope inherits is not suspended.
       * * Multiple directives trying to manage the suspended status of a scope can confuse each other:
       *    * A call to `$suspend()` on an already suspended scope is a no-op.
       *    * A call to `$resume()` on a non-suspended scope is a no-op.
       *    * If two directives suspend a scope, then one of them resumes the scope, the scope will no
       *      longer be suspended. This could result in the other directive believing a scope to be
       *      suspended when it is not.
       * * If a parent scope is suspended then all its descendants will be also excluded from future
       *   digests whether or not they have been suspended themselves. Note that this also applies to
       *   isolate child scopes.
       * * Calling `$digest()` directly on a descendant of a suspended scope will still run the watchers
       *   for that scope and its descendants. When digesting we only check whether the current scope is
       *   locally suspended, rather than checking whether it has a suspended ancestor.
       * * Calling `$resume()` on a scope that has a suspended ancestor will not cause the scope to be
       *   included in future digests until all its ancestors have been resumed.
       * * Resolved promises, e.g. from explicit `$q` deferreds and `$http` calls, trigger `$apply()`
       *   against the `$rootScope` and so will still trigger a global digest even if the promise was
       *   initiated by a component that lives on a suspended scope.
       */
      $suspend: function() {
        this.$$suspended = true;
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$isSuspended
       * @kind function
       *
       * @description
       * Call this method to determine if this scope has been explicitly suspended. It will not
       * tell you whether an ancestor has been suspended.
       * To determine if this scope will be excluded from a digest triggered at the $rootScope,
       * for example, you must check all its ancestors:
       *
       * ```
       * function isExcludedFromDigest(scope) {
       *   while(scope) {
       *     if (scope.$isSuspended()) return true;
       *     scope = scope.$parent;
       *   }
       *   return false;
       * ```
       *
       * Be aware that a scope may not be included in digests if it has a suspended ancestor,
       * even if `$isSuspended()` returns false.
       *
       * @returns true if the current scope has been suspended.
       */
      $isSuspended: function() {
        return this.$$suspended;
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$resume
       * @kind function
       *
       * @description
       * Resume watchers of this scope subtree in case it was suspended.
       *
       * See {@link $rootScope.Scope#$suspend} for information about the dangers of using this approach.
       */
      $resume: function() {
        this.$$suspended = false;
      },

      /**
       * @ngdoc event
       * @name $rootScope.Scope#$destroy
       * @eventType broadcast on scope being destroyed
       *
       * @description
       * Broadcasted when a scope and its children are being destroyed.
       *
       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
       * clean up DOM bindings before an element is removed from the DOM.
       */

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$destroy
       * @kind function
       *
       * @description
       * Removes the current scope (and all of its children) from the parent scope. Removal implies
       * that calls to {@link ng.$rootScope.Scope#$digest $digest()} will no longer
       * propagate to the current scope and its children. Removal also implies that the current
       * scope is eligible for garbage collection.
       *
       * The `$destroy()` is usually used by directives such as
       * {@link ng.directive:ngRepeat ngRepeat} for managing the
       * unrolling of the loop.
       *
       * Just before a scope is destroyed, a `$destroy` event is broadcasted on this scope.
       * Application code can register a `$destroy` event handler that will give it a chance to
       * perform any necessary cleanup.
       *
       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
       * clean up DOM bindings before an element is removed from the DOM.
       */
      $destroy: function() {
        // We can't destroy a scope that has been already destroyed.
        if (this.$$destroyed) return;
        var parent = this.$parent;

        this.$broadcast('$destroy');
        this.$$destroyed = true;

        if (this === $rootScope) {
          //Remove handlers attached to window when $rootScope is removed
          $browser.$$applicationDestroyed();
        }

        incrementWatchersCount(this, -this.$$watchersCount);
        for (var eventName in this.$$listenerCount) {
          decrementListenerCount(this, this.$$listenerCount[eventName], eventName);
        }

        // sever all the references to parent scopes (after this cleanup, the current scope should
        // not be retained by any of our references and should be eligible for garbage collection)
        if (parent && parent.$$childHead === this) parent.$$childHead = this.$$nextSibling;
        if (parent && parent.$$childTail === this) parent.$$childTail = this.$$prevSibling;
        if (this.$$prevSibling) this.$$prevSibling.$$nextSibling = this.$$nextSibling;
        if (this.$$nextSibling) this.$$nextSibling.$$prevSibling = this.$$prevSibling;

        // Disable listeners, watchers and apply/digest methods
        this.$destroy = this.$digest = this.$apply = this.$evalAsync = this.$applyAsync = noop;
        this.$on = this.$watch = this.$watchGroup = function() { return noop; };
        this.$$listeners = {};

        // Disconnect the next sibling to prevent `cleanUpScope` destroying those too
        this.$$nextSibling = null;
        cleanUpScope(this);
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$eval
       * @kind function
       *
       * @description
       * Executes the `expression` on the current scope and returns the result. Any exceptions in
       * the expression are propagated (uncaught). This is useful when evaluating AngularJS
       * expressions.
       *
       * @example
       * ```js
           var scope = ng.$rootScope.Scope();
           scope.a = 1;
           scope.b = 2;

           expect(scope.$eval('a+b')).toEqual(3);
           expect(scope.$eval(function(scope){ return scope.a + scope.b; })).toEqual(3);
       * ```
       *
       * @param {(string|function())=} expression An AngularJS expression to be executed.
       *
       *    - `string`: execute using the rules as defined in  {@link guide/expression expression}.
       *    - `function(scope)`: execute the function with the current `scope` parameter.
       *
       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
       * @returns {*} The result of evaluating the expression.
       */
      $eval: function(expr, locals) {
        return $parse(expr)(this, locals);
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$evalAsync
       * @kind function
       *
       * @description
       * Executes the expression on the current scope at a later point in time.
       *
       * The `$evalAsync` makes no guarantees as to when the `expression` will be executed, only
       * that:
       *
       *   - it will execute after the function that scheduled the evaluation (preferably before DOM
       *     rendering).
       *   - at least one {@link ng.$rootScope.Scope#$digest $digest cycle} will be performed after
       *     `expression` execution.
       *
       * Any exceptions from the execution of the expression are forwarded to the
       * {@link ng.$exceptionHandler $exceptionHandler} service.
       *
       * __Note:__ if this function is called outside of a `$digest` cycle, a new `$digest` cycle
       * will be scheduled. However, it is encouraged to always call code that changes the model
       * from within an `$apply` call. That includes code evaluated via `$evalAsync`.
       *
       * @param {(string|function())=} expression An AngularJS expression to be executed.
       *
       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
       *    - `function(scope)`: execute the function with the current `scope` parameter.
       *
       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
       */
      $evalAsync: function(expr, locals) {
        // if we are outside of an $digest loop and this is the first time we are scheduling async
        // task also schedule async auto-flush
        if (!$rootScope.$$phase && !asyncQueue.length) {
          $browser.defer(function() {
            if (asyncQueue.length) {
              $rootScope.$digest();
            }
          }, null, '$evalAsync');
        }

        asyncQueue.push({scope: this, fn: $parse(expr), locals: locals});
      },

      $$postDigest: function(fn) {
        postDigestQueue.push(fn);
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$apply
       * @kind function
       *
       * @description
       * `$apply()` is used to execute an expression in AngularJS from outside of the AngularJS
       * framework. (For example from browser DOM events, setTimeout, XHR or third party libraries).
       * Because we are calling into the AngularJS framework we need to perform proper scope life
       * cycle of {@link ng.$exceptionHandler exception handling},
       * {@link ng.$rootScope.Scope#$digest executing watches}.
       *
       * **Life cycle: Pseudo-Code of `$apply()`**
       *
       * ```js
           function $apply(expr) {
             try {
               return $eval(expr);
             } catch (e) {
               $exceptionHandler(e);
             } finally {
               $root.$digest();
             }
           }
       * ```
       *
       *
       * Scope's `$apply()` method transitions through the following stages:
       *
       * 1. The {@link guide/expression expression} is executed using the
       *    {@link ng.$rootScope.Scope#$eval $eval()} method.
       * 2. Any exceptions from the execution of the expression are forwarded to the
       *    {@link ng.$exceptionHandler $exceptionHandler} service.
       * 3. The {@link ng.$rootScope.Scope#$watch watch} listeners are fired immediately after the
       *    expression was executed using the {@link ng.$rootScope.Scope#$digest $digest()} method.
       *
       *
       * @param {(string|function())=} exp An AngularJS expression to be executed.
       *
       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
       *    - `function(scope)`: execute the function with current `scope` parameter.
       *
       * @returns {*} The result of evaluating the expression.
       */
      $apply: function(expr) {
        try {
          beginPhase('$apply');
          try {
            return this.$eval(expr);
          } finally {
            clearPhase();
          }
        } catch (e) {
          $exceptionHandler(e);
        } finally {
          try {
            $rootScope.$digest();
          } catch (e) {
            $exceptionHandler(e);
            // eslint-disable-next-line no-unsafe-finally
            throw e;
          }
        }
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$applyAsync
       * @kind function
       *
       * @description
       * Schedule the invocation of $apply to occur at a later time. The actual time difference
       * varies across browsers, but is typically around ~10 milliseconds.
       *
       * This can be used to queue up multiple expressions which need to be evaluated in the same
       * digest.
       *
       * @param {(string|function())=} exp An AngularJS expression to be executed.
       *
       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
       *    - `function(scope)`: execute the function with current `scope` parameter.
       */
      $applyAsync: function(expr) {
        var scope = this;
        if (expr) {
          applyAsyncQueue.push($applyAsyncExpression);
        }
        expr = $parse(expr);
        scheduleApplyAsync();

        function $applyAsyncExpression() {
          scope.$eval(expr);
        }
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$on
       * @kind function
       *
       * @description
       * Listens on events of a given type. See {@link ng.$rootScope.Scope#$emit $emit} for
       * discussion of event life cycle.
       *
       * The event listener function format is: `function(event, args...)`. The `event` object
       * passed into the listener has the following attributes:
       *
       *   - `targetScope` - `{Scope}`: the scope on which the event was `$emit`-ed or
       *     `$broadcast`-ed.
       *   - `currentScope` - `{Scope}`: the scope that is currently handling the event. Once the
       *     event propagates through the scope hierarchy, this property is set to null.
       *   - `name` - `{string}`: name of the event.
       *   - `stopPropagation` - `{function=}`: calling `stopPropagation` function will cancel
       *     further event propagation (available only for events that were `$emit`-ed).
       *   - `preventDefault` - `{function}`: calling `preventDefault` sets `defaultPrevented` flag
       *     to true.
       *   - `defaultPrevented` - `{boolean}`: true if `preventDefault` was called.
       *
       * @param {string} name Event name to listen on.
       * @param {function(event, ...args)} listener Function to call when the event is emitted.
       * @returns {function()} Returns a deregistration function for this listener.
       */
      $on: function(name, listener) {
        var namedListeners = this.$$listeners[name];
        if (!namedListeners) {
          this.$$listeners[name] = namedListeners = [];
        }
        namedListeners.push(listener);

        var current = this;
        do {
          if (!current.$$listenerCount[name]) {
            current.$$listenerCount[name] = 0;
          }
          current.$$listenerCount[name]++;
        } while ((current = current.$parent));

        var self = this;
        return function() {
          var indexOfListener = namedListeners.indexOf(listener);
          if (indexOfListener !== -1) {
            // Use delete in the hope of the browser deallocating the memory for the array entry,
            // while not shifting the array indexes of other listeners.
            // See issue https://github.com/angular/angular.js/issues/16135
            delete namedListeners[indexOfListener];
            decrementListenerCount(self, 1, name);
          }
        };
      },


      /**
       * @ngdoc method
       * @name $rootScope.Scope#$emit
       * @kind function
       *
       * @description
       * Dispatches an event `name` upwards through the scope hierarchy notifying the
       * registered {@link ng.$rootScope.Scope#$on} listeners.
       *
       * The event life cycle starts at the scope on which `$emit` was called. All
       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
       * notified. Afterwards, the event traverses upwards toward the root scope and calls all
       * registered listeners along the way. The event will stop propagating if one of the listeners
       * cancels it.
       *
       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
       *
       * @param {string} name Event name to emit.
       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
       * @return {Object} Event object (see {@link ng.$rootScope.Scope#$on}).
       */
      $emit: function(name, args) {
        var empty = [],
            namedListeners,
            scope = this,
            stopPropagation = false,
            event = {
              name: name,
              targetScope: scope,
              stopPropagation: function() {stopPropagation = true;},
              preventDefault: function() {
                event.defaultPrevented = true;
              },
              defaultPrevented: false
            },
            listenerArgs = concat([event], arguments, 1),
            i, length;

        do {
          namedListeners = scope.$$listeners[name] || empty;
          event.currentScope = scope;
          for (i = 0, length = namedListeners.length; i < length; i++) {

            // if listeners were deregistered, defragment the array
            if (!namedListeners[i]) {
              namedListeners.splice(i, 1);
              i--;
              length--;
              continue;
            }
            try {
              //allow all listeners attached to the current scope to run
              namedListeners[i].apply(null, listenerArgs);
            } catch (e) {
              $exceptionHandler(e);
            }
          }
          //if any listener on the current scope stops propagation, prevent bubbling
          if (stopPropagation) {
            break;
          }
          //traverse upwards
          scope = scope.$parent;
        } while (scope);

        event.currentScope = null;

        return event;
      },


      /**
       * @ngdoc method
       * @name $rootScope.Scope#$broadcast
       * @kind function
       *
       * @description
       * Dispatches an event `name` downwards to all child scopes (and their children) notifying the
       * registered {@link ng.$rootScope.Scope#$on} listeners.
       *
       * The event life cycle starts at the scope on which `$broadcast` was called. All
       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
       * notified. Afterwards, the event propagates to all direct and indirect scopes of the current
       * scope and calls all registered listeners along the way. The event cannot be canceled.
       *
       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
       *
       * @param {string} name Event name to broadcast.
       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
       * @return {Object} Event object, see {@link ng.$rootScope.Scope#$on}
       */
      $broadcast: function(name, args) {
        var target = this,
            current = target,
            next = target,
            event = {
              name: name,
              targetScope: target,
              preventDefault: function() {
                event.defaultPrevented = true;
              },
              defaultPrevented: false
            };

        if (!target.$$listenerCount[name]) return event;

        var listenerArgs = concat([event], arguments, 1),
            listeners, i, length;

        //down while you can, then up and next sibling or up and next sibling until back at root
        while ((current = next)) {
          event.currentScope = current;
          listeners = current.$$listeners[name] || [];
          for (i = 0, length = listeners.length; i < length; i++) {
            // if listeners were deregistered, defragment the array
            if (!listeners[i]) {
              listeners.splice(i, 1);
              i--;
              length--;
              continue;
            }

            try {
              listeners[i].apply(null, listenerArgs);
            } catch (e) {
              $exceptionHandler(e);
            }
          }

          // Insanity Warning: scope depth-first traversal
          // yes, this code is a bit crazy, but it works and we have tests to prove it!
          // this piece should be kept in sync with the traversal in $digest
          // (though it differs due to having the extra check for $$listenerCount and
          // does not check $$suspended)
          if (!(next = ((current.$$listenerCount[name] && current.$$childHead) ||
              (current !== target && current.$$nextSibling)))) {
            while (current !== target && !(next = current.$$nextSibling)) {
              current = current.$parent;
            }
          }
        }

        event.currentScope = null;
        return event;
      }
    };

    var $rootScope = new Scope();

    //The internal queues. Expose them on the $rootScope for debugging/testing purposes.
    var asyncQueue = $rootScope.$$asyncQueue = [];
    var postDigestQueue = $rootScope.$$postDigestQueue = [];
    var applyAsyncQueue = $rootScope.$$applyAsyncQueue = [];

    var postDigestQueuePosition = 0;

    return $rootScope;


    function beginPhase(phase) {
      if ($rootScope.$$phase) {
        throw $rootScopeMinErr('inprog', '{0} already in progress', $rootScope.$$phase);
      }

      $rootScope.$$phase = phase;
    }

    function clearPhase() {
      $rootScope.$$phase = null;
    }

    function incrementWatchersCount(current, count) {
      do {
        current.$$watchersCount += count;
      } while ((current = current.$parent));
    }

    function decrementListenerCount(current, count, name) {
      do {
        current.$$listenerCount[name] -= count;

        if (current.$$listenerCount[name] === 0) {
          delete current.$$listenerCount[name];
        }
      } while ((current = current.$parent));
    }

    /**
     * function used as an initial value for watchers.
     * because it's unique we can easily tell it apart from other values
     */
    function initWatchVal() {}

    function flushApplyAsync() {
      while (applyAsyncQueue.length) {
        try {
          applyAsyncQueue.shift()();
        } catch (e) {
          $exceptionHandler(e);
        }
      }
      applyAsyncId = null;
    }

    function scheduleApplyAsync() {
      if (applyAsyncId === null) {
        applyAsyncId = $browser.defer(function() {
          $rootScope.$apply(flushApplyAsync);
        }, null, '$applyAsync');
      }
    }
  }];
}

/**
 * @ngdoc service
 * @name $rootElement
 *
 * @description
 * The root element of AngularJS application. This is either the element where {@link
 * ng.directive:ngApp ngApp} was declared or the element passed into
 * {@link angular.bootstrap}. The element represents the root element of application. It is also the
 * location where the application's {@link auto.$injector $injector} service gets
 * published, and can be retrieved using `$rootElement.injector()`.
 */


// the implementation is in angular.bootstrap

/**
 * @this
 * @description
 * Private service to sanitize uris for links and images. Used by $compile and $sanitize.
 */
function $$SanitizeUriProvider() {

  var aHrefSanitizationTrustedUrlList = /^\s*(https?|s?ftp|mailto|tel|file):/,
    imgSrcSanitizationTrustedUrlList = /^\s*((https?|ftp|file|blob):|data:image\/)/;

  /**
   * @description
   * Retrieves or overrides the default regular expression that is used for determining trusted safe
   * urls during a[href] sanitization.
   *
   * The sanitization is a security measure aimed at prevent XSS attacks via HTML anchor links.
   *
   * Any url due to be assigned to an `a[href]` attribute via interpolation is marked as requiring
   * the $sce.URL security context. When interpolation occurs a call is made to `$sce.trustAsUrl(url)`
   * which in turn may call `$$sanitizeUri(url, isMedia)` to sanitize the potentially malicious URL.
   *
   * If the URL matches the `aHrefSanitizationTrustedUrlList` regular expression, it is returned unchanged.
   *
   * If there is no match the URL is returned prefixed with `'unsafe:'` to ensure that when it is written
   * to the DOM it is inactive and potentially malicious code will not be executed.
   *
   * @param {RegExp=} regexp New regexp to trust urls with.
   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
   *    chaining otherwise.
   */
  this.aHrefSanitizationTrustedUrlList = function(regexp) {
    if (isDefined(regexp)) {
      aHrefSanitizationTrustedUrlList = regexp;
      return this;
    }
    return aHrefSanitizationTrustedUrlList;
  };


  /**
   * @description
   * Retrieves or overrides the default regular expression that is used for determining trusted safe
   * urls during img[src] sanitization.
   *
   * The sanitization is a security measure aimed at prevent XSS attacks via HTML image src links.
   *
   * Any URL due to be assigned to an `img[src]` attribute via interpolation is marked as requiring
   * the $sce.MEDIA_URL security context. When interpolation occurs a call is made to
   * `$sce.trustAsMediaUrl(url)` which in turn may call `$$sanitizeUri(url, isMedia)` to sanitize
   * the potentially malicious URL.
   *
   * If the URL matches the `imgSrcSanitizationTrustedUrlList` regular expression, it is returned
   * unchanged.
   *
   * If there is no match the URL is returned prefixed with `'unsafe:'` to ensure that when it is written
   * to the DOM it is inactive and potentially malicious code will not be executed.
   *
   * @param {RegExp=} regexp New regexp to trust urls with.
   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
   *    chaining otherwise.
   */
  this.imgSrcSanitizationTrustedUrlList = function(regexp) {
    if (isDefined(regexp)) {
      imgSrcSanitizationTrustedUrlList = regexp;
      return this;
    }
    return imgSrcSanitizationTrustedUrlList;
  };

  this.$get = function() {
    return function sanitizeUri(uri, isMediaUrl) {
      // if (!uri) return uri;
      var regex = isMediaUrl ? imgSrcSanitizationTrustedUrlList : aHrefSanitizationTrustedUrlList;
      var normalizedVal = urlResolve(uri && uri.trim()).href;
      if (normalizedVal !== '' && !normalizedVal.match(regex)) {
        return 'unsafe:' + normalizedVal;
      }
      return uri;
    };
  };
}

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables likes document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

/* exported $SceProvider, $SceDelegateProvider */

var $sceMinErr = minErr('$sce');

var SCE_CONTEXTS = {
  // HTML is used when there's HTML rendered (e.g. ng-bind-html, iframe srcdoc binding).
  HTML: 'html',

  // Style statements or stylesheets. Currently unused in AngularJS.
  CSS: 'css',

  // An URL used in a context where it refers to the source of media, which are not expected to be run
  // as scripts, such as an image, audio, video, etc.
  MEDIA_URL: 'mediaUrl',

  // An URL used in a context where it does not refer to a resource that loads code.
  // A value that can be trusted as a URL can also trusted as a MEDIA_URL.
  URL: 'url',

  // RESOURCE_URL is a subtype of URL used where the referred-to resource could be interpreted as
  // code. (e.g. ng-include, script src binding, templateUrl)
  // A value that can be trusted as a RESOURCE_URL, can also trusted as a URL and a MEDIA_URL.
  RESOURCE_URL: 'resourceUrl',

  // Script. Currently unused in AngularJS.
  JS: 'js'
};

// Helper functions follow.

var UNDERSCORE_LOWERCASE_REGEXP = /_([a-z])/g;

function snakeToCamel(name) {
  return name
    .replace(UNDERSCORE_LOWERCASE_REGEXP, fnCamelCaseReplace);
}

function adjustMatcher(matcher) {
  if (matcher === 'self') {
    return matcher;
  } else if (isString(matcher)) {
    // Strings match exactly except for 2 wildcards - '*' and '**'.
    // '*' matches any character except those from the set ':/.?&'.
    // '**' matches any character (like .* in a RegExp).
    // More than 2 *'s raises an error as it's ill defined.
    if (matcher.indexOf('***') > -1) {
      throw $sceMinErr('iwcard',
          'Illegal sequence *** in string matcher.  String: {0}', matcher);
    }
    matcher = escapeForRegexp(matcher).
                  replace(/\\\*\\\*/g, '.*').
                  replace(/\\\*/g, '[^:/.?&;]*');
    return new RegExp('^' + matcher + '$');
  } else if (isRegExp(matcher)) {
    // The only other type of matcher allowed is a Regexp.
    // Match entire URL / disallow partial matches.
    // Flags are reset (i.e. no global, ignoreCase or multiline)
    return new RegExp('^' + matcher.source + '$');
  } else {
    throw $sceMinErr('imatcher',
        'Matchers may only be "self", string patterns or RegExp objects');
  }
}


function adjustMatchers(matchers) {
  var adjustedMatchers = [];
  if (isDefined(matchers)) {
    forEach(matchers, function(matcher) {
      adjustedMatchers.push(adjustMatcher(matcher));
    });
  }
  return adjustedMatchers;
}


/**
 * @ngdoc service
 * @name $sceDelegate
 * @kind function
 *
 * @description
 *
 * `$sceDelegate` is a service that is used by the `$sce` service to provide {@link ng.$sce Strict
 * Contextual Escaping (SCE)} services to AngularJS.
 *
 * For an overview of this service and the functionnality it provides in AngularJS, see the main
 * page for {@link ng.$sce SCE}. The current page is targeted for developers who need to alter how
 * SCE works in their application, which shouldn't be needed in most cases.
 *
 * <div class="alert alert-danger">
 * AngularJS strongly relies on contextual escaping for the security of bindings: disabling or
 * modifying this might cause cross site scripting (XSS) vulnerabilities. For libraries owners,
 * changes to this service will also influence users, so be extra careful and document your changes.
 * </div>
 *
 * Typically, you would configure or override the {@link ng.$sceDelegate $sceDelegate} instead of
 * the `$sce` service to customize the way Strict Contextual Escaping works in AngularJS.  This is
 * because, while the `$sce` provides numerous shorthand methods, etc., you really only need to
 * override 3 core functions (`trustAs`, `getTrusted` and `valueOf`) to replace the way things
 * work because `$sce` delegates to `$sceDelegate` for these operations.
 *
 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} to configure this service.
 *
 * The default instance of `$sceDelegate` should work out of the box with little pain.  While you
 * can override it completely to change the behavior of `$sce`, the common case would
 * involve configuring the {@link ng.$sceDelegateProvider $sceDelegateProvider} instead by setting
 * your own trusted and banned resource lists for trusting URLs used for loading AngularJS resources
 * such as templates.  Refer {@link ng.$sceDelegateProvider#trustedResourceUrlList
 * $sceDelegateProvider.trustedResourceUrlList} and {@link
 * ng.$sceDelegateProvider#bannedResourceUrlList $sceDelegateProvider.bannedResourceUrlList}
 */

/**
 * @ngdoc provider
 * @name $sceDelegateProvider
 * @this
 *
 * @description
 *
 * The `$sceDelegateProvider` provider allows developers to configure the {@link ng.$sceDelegate
 * $sceDelegate service}, used as a delegate for {@link ng.$sce Strict Contextual Escaping (SCE)}.
 *
 * The `$sceDelegateProvider` allows one to get/set the `trustedResourceUrlList` and
 * `bannedResourceUrlList` used to ensure that the URLs used for sourcing AngularJS templates and
 * other script-running URLs are safe (all places that use the `$sce.RESOURCE_URL` context). See
 * {@link ng.$sceDelegateProvider#trustedResourceUrlList
 * $sceDelegateProvider.trustedResourceUrlList} and
 * {@link ng.$sceDelegateProvider#bannedResourceUrlList $sceDelegateProvider.bannedResourceUrlList},
 *
 * For the general details about this service in AngularJS, read the main page for {@link ng.$sce
 * Strict Contextual Escaping (SCE)}.
 *
 * **Example**:  Consider the following case. <a name="example"></a>
 *
 * - your app is hosted at url `http://myapp.example.com/`
 * - but some of your templates are hosted on other domains you control such as
 *   `http://srv01.assets.example.com/`, `http://srv02.assets.example.com/`, etc.
 * - and you have an open redirect at `http://myapp.example.com/clickThru?...`.
 *
 * Here is what a secure configuration for this scenario might look like:
 *
 * ```
 *  angular.module('myApp', []).config(function($sceDelegateProvider) {
 *    $sceDelegateProvider.trustedResourceUrlList([
 *      // Allow same origin resource loads.
 *      'self',
 *      // Allow loading from our assets domain.  Notice the difference between * and **.
 *      'http://srv*.assets.example.com/**'
 *    ]);
 *
 *    // The banned resource URL list overrides the trusted resource URL list so the open redirect
 *    // here is blocked.
 *    $sceDelegateProvider.bannedResourceUrlList([
 *      'http://myapp.example.com/clickThru**'
 *    ]);
 *  });
 * ```
 * Note that an empty trusted resource URL list will block every resource URL from being loaded, and will require
 * you to manually mark each one as trusted with `$sce.trustAsResourceUrl`. However, templates
 * requested by {@link ng.$templateRequest $templateRequest} that are present in
 * {@link ng.$templateCache $templateCache} will not go through this check. If you have a mechanism
 * to populate your templates in that cache at config time, then it is a good idea to remove 'self'
 * from the trusted resource URL lsit. This helps to mitigate the security impact of certain types
 * of issues, like for instance attacker-controlled `ng-includes`.
 */

function $SceDelegateProvider() {
  this.SCE_CONTEXTS = SCE_CONTEXTS;

  // Resource URLs can also be trusted by policy.
  var trustedResourceUrlList = ['self'],
      bannedResourceUrlList = [];

  /**
   * @ngdoc method
   * @name $sceDelegateProvider#trustedResourceUrlList
   * @kind function
   *
   * @param {Array=} trustedResourceUrlList When provided, replaces the trustedResourceUrlList with
   *     the value provided.  This must be an array or null.  A snapshot of this array is used so
   *     further changes to the array are ignored.
   *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
   *     allowed in this array.
   *
   * @return {Array} The currently set trusted resource URL array.
   *
   * @description
   * Sets/Gets the list trusted of resource URLs.
   *
   * The **default value** when no `trustedResourceUrlList` has been explicitly set is `['self']`
   * allowing only same origin resource requests.
   *
   * <div class="alert alert-warning">
   * **Note:** the default `trustedResourceUrlList` of 'self' is not recommended if your app shares
   * its origin with other apps! It is a good idea to limit it to only your application's directory.
   * </div>
   */
  this.trustedResourceUrlList = function(value) {
    if (arguments.length) {
      trustedResourceUrlList = adjustMatchers(value);
    }
    return trustedResourceUrlList;
  };

  /**
   * @ngdoc method
   * @name $sceDelegateProvider#resourceUrlWhitelist
   * @kind function
   *
   * @deprecated
   * sinceVersion="1.8.1"
   *
   * This method is deprecated. Use {@link $sceDelegateProvider#trustedResourceUrlList
   * trustedResourceUrlList} instead.
   */
  Object.defineProperty(this, 'resourceUrlWhitelist', {
    get: function() {
      return this.trustedResourceUrlList;
    },
    set: function(value) {
      this.trustedResourceUrlList = value;
    }
  });

  /**
   * @ngdoc method
   * @name $sceDelegateProvider#bannedResourceUrlList
   * @kind function
   *
   * @param {Array=} bannedResourceUrlList When provided, replaces the `bannedResourceUrlList` with
   *     the value provided. This must be an array or null. A snapshot of this array is used so
   *     further changes to the array are ignored.</p><p>
   *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
   *     allowed in this array.</p><p>
   *     The typical usage for the `bannedResourceUrlList` is to **block
   *     [open redirects](http://cwe.mitre.org/data/definitions/601.html)** served by your domain as
   *     these would otherwise be trusted but actually return content from the redirected domain.
   *     </p><p>
   *     Finally, **the banned resource URL list overrides the trusted resource URL list** and has
   *     the final say.
   *
   * @return {Array} The currently set `bannedResourceUrlList` array.
   *
   * @description
   * Sets/Gets the `bannedResourceUrlList` of trusted resource URLs.
   *
   * The **default value** when no trusted resource URL list has been explicitly set is the empty
   * array (i.e. there is no `bannedResourceUrlList`.)
   */
  this.bannedResourceUrlList = function(value) {
    if (arguments.length) {
      bannedResourceUrlList = adjustMatchers(value);
    }
    return bannedResourceUrlList;
  };

  /**
   * @ngdoc method
   * @name $sceDelegateProvider#resourceUrlBlacklist
   * @kind function
   *
   * @deprecated
   * sinceVersion="1.8.1"
   *
   * This method is deprecated. Use {@link $sceDelegateProvider#bannedResourceUrlList
   * bannedResourceUrlList} instead.
   */
  Object.defineProperty(this, 'resourceUrlBlacklist', {
    get: function() {
      return this.bannedResourceUrlList;
    },
    set: function(value) {
      this.bannedResourceUrlList = value;
    }
  });

  this.$get = ['$injector', '$$sanitizeUri', function($injector, $$sanitizeUri) {

    var htmlSanitizer = function htmlSanitizer(html) {
      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
    };

    if ($injector.has('$sanitize')) {
      htmlSanitizer = $injector.get('$sanitize');
    }


    function matchUrl(matcher, parsedUrl) {
      if (matcher === 'self') {
        return urlIsSameOrigin(parsedUrl) || urlIsSameOriginAsBaseUrl(parsedUrl);
      } else {
        // definitely a regex.  See adjustMatchers()
        return !!matcher.exec(parsedUrl.href);
      }
    }

    function isResourceUrlAllowedByPolicy(url) {
      var parsedUrl = urlResolve(url.toString());
      var i, n, allowed = false;
      // Ensure that at least one item from the trusted resource URL list allows this url.
      for (i = 0, n = trustedResourceUrlList.length; i < n; i++) {
        if (matchUrl(trustedResourceUrlList[i], parsedUrl)) {
          allowed = true;
          break;
        }
      }
      if (allowed) {
        // Ensure that no item from the banned resource URL list has blocked this url.
        for (i = 0, n = bannedResourceUrlList.length; i < n; i++) {
          if (matchUrl(bannedResourceUrlList[i], parsedUrl)) {
            allowed = false;
            break;
          }
        }
      }
      return allowed;
    }

    function generateHolderType(Base) {
      var holderType = function TrustedValueHolderType(trustedValue) {
        this.$$unwrapTrustedValue = function() {
          return trustedValue;
        };
      };
      if (Base) {
        holderType.prototype = new Base();
      }
      holderType.prototype.valueOf = function sceValueOf() {
        return this.$$unwrapTrustedValue();
      };
      holderType.prototype.toString = function sceToString() {
        return this.$$unwrapTrustedValue().toString();
      };
      return holderType;
    }

    var trustedValueHolderBase = generateHolderType(),
        byType = {};

    byType[SCE_CONTEXTS.HTML] = generateHolderType(trustedValueHolderBase);
    byType[SCE_CONTEXTS.CSS] = generateHolderType(trustedValueHolderBase);
    byType[SCE_CONTEXTS.MEDIA_URL] = generateHolderType(trustedValueHolderBase);
    byType[SCE_CONTEXTS.URL] = generateHolderType(byType[SCE_CONTEXTS.MEDIA_URL]);
    byType[SCE_CONTEXTS.JS] = generateHolderType(trustedValueHolderBase);
    byType[SCE_CONTEXTS.RESOURCE_URL] = generateHolderType(byType[SCE_CONTEXTS.URL]);

    /**
     * @ngdoc method
     * @name $sceDelegate#trustAs
     *
     * @description
     * Returns a trusted representation of the parameter for the specified context. This trusted
     * object will later on be used as-is, without any security check, by bindings or directives
     * that require this security context.
     * For instance, marking a string as trusted for the `$sce.HTML` context will entirely bypass
     * the potential `$sanitize` call in corresponding `$sce.HTML` bindings or directives, such as
     * `ng-bind-html`. Note that in most cases you won't need to call this function: if you have the
     * sanitizer loaded, passing the value itself will render all the HTML that does not pose a
     * security risk.
     *
     * See {@link ng.$sceDelegate#getTrusted getTrusted} for the function that will consume those
     * trusted values, and {@link ng.$sce $sce} for general documentation about strict contextual
     * escaping.
     *
     * @param {string} type The context in which this value is safe for use, e.g. `$sce.URL`,
     *     `$sce.RESOURCE_URL`, `$sce.HTML`, `$sce.JS` or `$sce.CSS`.
     *
     * @param {*} value The value that should be considered trusted.
     * @return {*} A trusted representation of value, that can be used in the given context.
     */
    function trustAs(type, trustedValue) {
      var Constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
      if (!Constructor) {
        throw $sceMinErr('icontext',
            'Attempted to trust a value in invalid context. Context: {0}; Value: {1}',
            type, trustedValue);
      }
      if (trustedValue === null || isUndefined(trustedValue) || trustedValue === '') {
        return trustedValue;
      }
      // All the current contexts in SCE_CONTEXTS happen to be strings.  In order to avoid trusting
      // mutable objects, we ensure here that the value passed in is actually a string.
      if (typeof trustedValue !== 'string') {
        throw $sceMinErr('itype',
            'Attempted to trust a non-string value in a content requiring a string: Context: {0}',
            type);
      }
      return new Constructor(trustedValue);
    }

    /**
     * @ngdoc method
     * @name $sceDelegate#valueOf
     *
     * @description
     * If the passed parameter had been returned by a prior call to {@link ng.$sceDelegate#trustAs
     * `$sceDelegate.trustAs`}, returns the value that had been passed to {@link
     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.
     *
     * If the passed parameter is not a value that had been returned by {@link
     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}, it must be returned as-is.
     *
     * @param {*} value The result of a prior {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}
     *     call or anything else.
     * @return {*} The `value` that was originally provided to {@link ng.$sceDelegate#trustAs
     *     `$sceDelegate.trustAs`} if `value` is the result of such a call.  Otherwise, returns
     *     `value` unchanged.
     */
    function valueOf(maybeTrusted) {
      if (maybeTrusted instanceof trustedValueHolderBase) {
        return maybeTrusted.$$unwrapTrustedValue();
      } else {
        return maybeTrusted;
      }
    }

    /**
     * @ngdoc method
     * @name $sceDelegate#getTrusted
     *
     * @description
     * Given an object and a security context in which to assign it, returns a value that's safe to
     * use in this context, which was represented by the parameter. To do so, this function either
     * unwraps the safe type it has been given (for instance, a {@link ng.$sceDelegate#trustAs
     * `$sceDelegate.trustAs`} result), or it might try to sanitize the value given, depending on
     * the context and sanitizer availablility.
     *
     * The contexts that can be sanitized are $sce.MEDIA_URL, $sce.URL and $sce.HTML. The first two are available
     * by default, and the third one relies on the `$sanitize` service (which may be loaded through
     * the `ngSanitize` module). Furthermore, for $sce.RESOURCE_URL context, a plain string may be
     * accepted if the resource url policy defined by {@link ng.$sceDelegateProvider#trustedResourceUrlList
     * `$sceDelegateProvider.trustedResourceUrlList`} and {@link ng.$sceDelegateProvider#bannedResourceUrlList
     * `$sceDelegateProvider.bannedResourceUrlList`} accepts that resource.
     *
     * This function will throw if the safe type isn't appropriate for this context, or if the
     * value given cannot be accepted in the context (which might be caused by sanitization not
     * being available, or the value not being recognized as safe).
     *
     * <div class="alert alert-danger">
     * Disabling auto-escaping is extremely dangerous, it usually creates a Cross Site Scripting
     * (XSS) vulnerability in your application.
     * </div>
     *
     * @param {string} type The context in which this value is to be used (such as `$sce.HTML`).
     * @param {*} maybeTrusted The result of a prior {@link ng.$sceDelegate#trustAs
     *     `$sceDelegate.trustAs`} call, or anything else (which will not be considered trusted.)
     * @return {*} A version of the value that's safe to use in the given context, or throws an
     *     exception if this is impossible.
     */
    function getTrusted(type, maybeTrusted) {
      if (maybeTrusted === null || isUndefined(maybeTrusted) || maybeTrusted === '') {
        return maybeTrusted;
      }
      var constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
      // If maybeTrusted is a trusted class instance or subclass instance, then unwrap and return
      // as-is.
      if (constructor && maybeTrusted instanceof constructor) {
        return maybeTrusted.$$unwrapTrustedValue();
      }

      // If maybeTrusted is a trusted class instance but not of the correct trusted type
      // then unwrap it and allow it to pass through to the rest of the checks
      if (isFunction(maybeTrusted.$$unwrapTrustedValue)) {
        maybeTrusted = maybeTrusted.$$unwrapTrustedValue();
      }

      // If we get here, then we will either sanitize the value or throw an exception.
      if (type === SCE_CONTEXTS.MEDIA_URL || type === SCE_CONTEXTS.URL) {
        // we attempt to sanitize non-resource URLs
        return $$sanitizeUri(maybeTrusted.toString(), type === SCE_CONTEXTS.MEDIA_URL);
      } else if (type === SCE_CONTEXTS.RESOURCE_URL) {
        if (isResourceUrlAllowedByPolicy(maybeTrusted)) {
          return maybeTrusted;
        } else {
          throw $sceMinErr('insecurl',
              'Blocked loading resource from url not allowed by $sceDelegate policy.  URL: {0}',
              maybeTrusted.toString());
        }
      } else if (type === SCE_CONTEXTS.HTML) {
        // htmlSanitizer throws its own error when no sanitizer is available.
        return htmlSanitizer(maybeTrusted);
      }
      // Default error when the $sce service has no way to make the input safe.
      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
    }

    return { trustAs: trustAs,
             getTrusted: getTrusted,
             valueOf: valueOf };
  }];
}


/**
 * @ngdoc provider
 * @name $sceProvider
 * @this
 *
 * @description
 *
 * The $sceProvider provider allows developers to configure the {@link ng.$sce $sce} service.
 * -   enable/disable Strict Contextual Escaping (SCE) in a module
 * -   override the default implementation with a custom delegate
 *
 * Read more about {@link ng.$sce Strict Contextual Escaping (SCE)}.
 */

/**
 * @ngdoc service
 * @name $sce
 * @kind function
 *
 * @description
 *
 * `$sce` is a service that provides Strict Contextual Escaping services to AngularJS.
 *
 * ## Strict Contextual Escaping
 *
 * Strict Contextual Escaping (SCE) is a mode in which AngularJS constrains bindings to only render
 * trusted values. Its goal is to assist in writing code in a way that (a) is secure by default, and
 * (b) makes auditing for security vulnerabilities such as XSS, clickjacking, etc. a lot easier.
 *
 * ### Overview
 *
 * To systematically block XSS security bugs, AngularJS treats all values as untrusted by default in
 * HTML or sensitive URL bindings. When binding untrusted values, AngularJS will automatically
 * run security checks on them (sanitizations, trusted URL resource, depending on context), or throw
 * when it cannot guarantee the security of the result. That behavior depends strongly on contexts:
 * HTML can be sanitized, but template URLs cannot, for instance.
 *
 * To illustrate this, consider the `ng-bind-html` directive. It renders its value directly as HTML:
 * we call that the *context*. When given an untrusted input, AngularJS will attempt to sanitize it
 * before rendering if a sanitizer is available, and throw otherwise. To bypass sanitization and
 * render the input as-is, you will need to mark it as trusted for that context before attempting
 * to bind it.
 *
 * As of version 1.2, AngularJS ships with SCE enabled by default.
 *
 * ### In practice
 *
 * Here's an example of a binding in a privileged context:
 *
 * ```
 * <input ng-model="userHtml" aria-label="User input">
 * <div ng-bind-html="userHtml"></div>
 * ```
 *
 * Notice that `ng-bind-html` is bound to `userHtml` controlled by the user.  With SCE
 * disabled, this application allows the user to render arbitrary HTML into the DIV, which would
 * be an XSS security bug. In a more realistic example, one may be rendering user comments, blog
 * articles, etc. via bindings. (HTML is just one example of a context where rendering user
 * controlled input creates security vulnerabilities.)
 *
 * For the case of HTML, you might use a library, either on the client side, or on the server side,
 * to sanitize unsafe HTML before binding to the value and rendering it in the document.
 *
 * How would you ensure that every place that used these types of bindings was bound to a value that
 * was sanitized by your library (or returned as safe for rendering by your server?)  How can you
 * ensure that you didn't accidentally delete the line that sanitized the value, or renamed some
 * properties/fields and forgot to update the binding to the sanitized value?
 *
 * To be secure by default, AngularJS makes sure bindings go through that sanitization, or
 * any similar validation process, unless there's a good reason to trust the given value in this
 * context.  That trust is formalized with a function call. This means that as a developer, you
 * can assume all untrusted bindings are safe. Then, to audit your code for binding security issues,
 * you just need to ensure the values you mark as trusted indeed are safe - because they were
 * received from your server, sanitized by your library, etc. You can organize your codebase to
 * help with this - perhaps allowing only the files in a specific directory to do this.
 * Ensuring that the internal API exposed by that code doesn't markup arbitrary values as safe then
 * becomes a more manageable task.
 *
 * In the case of AngularJS' SCE service, one uses {@link ng.$sce#trustAs $sce.trustAs}
 * (and shorthand methods such as {@link ng.$sce#trustAsHtml $sce.trustAsHtml}, etc.) to
 * build the trusted versions of your values.
 *
 * ### How does it work?
 *
 * In privileged contexts, directives and code will bind to the result of {@link ng.$sce#getTrusted
 * $sce.getTrusted(context, value)} rather than to the value directly.  Think of this function as
 * a way to enforce the required security context in your data sink. Directives use {@link
 * ng.$sce#parseAs $sce.parseAs} rather than `$parse` to watch attribute bindings, which performs
 * the {@link ng.$sce#getTrusted $sce.getTrusted} behind the scenes on non-constant literals. Also,
 * when binding without directives, AngularJS will understand the context of your bindings
 * automatically.
 *
 * As an example, {@link ng.directive:ngBindHtml ngBindHtml} uses {@link
 * ng.$sce#parseAsHtml $sce.parseAsHtml(binding expression)}.  Here's the actual code (slightly
 * simplified):
 *
 * ```
 * var ngBindHtmlDirective = ['$sce', function($sce) {
 *   return function(scope, element, attr) {
 *     scope.$watch($sce.parseAsHtml(attr.ngBindHtml), function(value) {
 *       element.html(value || '');
 *     });
 *   };
 * }];
 * ```
 *
 * ### Impact on loading templates
 *
 * This applies both to the {@link ng.directive:ngInclude `ng-include`} directive as well as
 * `templateUrl`'s specified by {@link guide/directive directives}.
 *
 * By default, AngularJS only loads templates from the same domain and protocol as the application
 * document.  This is done by calling {@link ng.$sce#getTrustedResourceUrl
 * $sce.getTrustedResourceUrl} on the template URL.  To load templates from other domains and/or
 * protocols, you may either add them to the {@link ng.$sceDelegateProvider#trustedResourceUrlList
 * trustedResourceUrlList} or {@link ng.$sce#trustAsResourceUrl wrap them} into trusted values.
 *
 * *Please note*:
 * The browser's
 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
 * policy apply in addition to this and may further restrict whether the template is successfully
 * loaded.  This means that without the right CORS policy, loading templates from a different domain
 * won't work on all browsers.  Also, loading templates from `file://` URL does not work on some
 * browsers.
 *
 * ### This feels like too much overhead
 *
 * It's important to remember that SCE only applies to interpolation expressions.
 *
 * If your expressions are constant literals, they're automatically trusted and you don't need to
 * call `$sce.trustAs` on them (e.g.
 * `<div ng-bind-html="'<b>implicitly trusted</b>'"></div>`) just works (remember to include the
 * `ngSanitize` module). The `$sceDelegate` will also use the `$sanitize` service if it is available
 * when binding untrusted values to `$sce.HTML` context.
 * AngularJS provides an implementation in `angular-sanitize.js`, and if you
 * wish to use it, you will also need to depend on the {@link ngSanitize `ngSanitize`} module in
 * your application.
 *
 * The included {@link ng.$sceDelegate $sceDelegate} comes with sane defaults to allow you to load
 * templates in `ng-include` from your application's domain without having to even know about SCE.
 * It blocks loading templates from other domains or loading templates over http from an https
 * served document.  You can change these by setting your own custom {@link
 * ng.$sceDelegateProvider#trustedResourceUrlList trusted resource URL list} and {@link
 * ng.$sceDelegateProvider#bannedResourceUrlList banned resource URL list} for matching such URLs.
 *
 * This significantly reduces the overhead.  It is far easier to pay the small overhead and have an
 * application that's secure and can be audited to verify that with much more ease than bolting
 * security onto an application later.
 *
 * <a name="contexts"></a>
 * ### What trusted context types are supported?
 *
 * | Context             | Notes          |
 * |---------------------|----------------|
 * | `$sce.HTML`         | For HTML that's safe to source into the application.  The {@link ng.directive:ngBindHtml ngBindHtml} directive uses this context for bindings. If an unsafe value is encountered and the {@link ngSanitize $sanitize} module is present this will sanitize the value instead of throwing an error. |
 * | `$sce.CSS`          | For CSS that's safe to source into the application.  Currently unused.  Feel free to use it in your own directives. |
 * | `$sce.MEDIA_URL`    | For URLs that are safe to render as media. Is automatically converted from string by sanitizing when needed. |
 * | `$sce.URL`          | For URLs that are safe to follow as links. Is automatically converted from string by sanitizing when needed. Note that `$sce.URL` makes a stronger statement about the URL than `$sce.MEDIA_URL` does and therefore contexts requiring values trusted for `$sce.URL` can be used anywhere that values trusted for `$sce.MEDIA_URL` are required.|
 * | `$sce.RESOURCE_URL` | For URLs that are not only safe to follow as links, but whose contents are also safe to include in your application.  Examples include `ng-include`, `src` / `ngSrc` bindings for tags other than `IMG` (e.g. `IFRAME`, `OBJECT`, etc.)  <br><br>Note that `$sce.RESOURCE_URL` makes a stronger statement about the URL than `$sce.URL` or `$sce.MEDIA_URL` do and therefore contexts requiring values trusted for `$sce.RESOURCE_URL` can be used anywhere that values trusted for `$sce.URL` or `$sce.MEDIA_URL` are required. <br><br> The {@link $sceDelegateProvider#trustedResourceUrlList $sceDelegateProvider#trustedResourceUrlList()} and {@link $sceDelegateProvider#bannedResourceUrlList $sceDelegateProvider#bannedResourceUrlList()} can be used to restrict trusted origins for `RESOURCE_URL` |
 * | `$sce.JS`           | For JavaScript that is safe to execute in your application's context.  Currently unused.  Feel free to use it in your own directives. |
 *
 *
 * <div class="alert alert-warning">
 * Be aware that, before AngularJS 1.7.0, `a[href]` and `img[src]` used to sanitize their
 * interpolated values directly rather than rely upon {@link ng.$sce#getTrusted `$sce.getTrusted`}.
 *
 * **As of 1.7.0, this is no longer the case.**
 *
 * Now such interpolations are marked as requiring `$sce.URL` (for `a[href]`) or `$sce.MEDIA_URL`
 * (for `img[src]`), so that the sanitization happens (via `$sce.getTrusted...`) when the `$interpolate`
 * service evaluates the expressions.
 * </div>
 *
 * There are no CSS or JS context bindings in AngularJS currently, so their corresponding `$sce.trustAs`
 * functions aren't useful yet. This might evolve.
 *
 * ### Format of items in {@link ng.$sceDelegateProvider#trustedResourceUrlList trustedResourceUrlList}/{@link ng.$sceDelegateProvider#bannedResourceUrlList bannedResourceUrlList} <a name="resourceUrlPatternItem"></a>
 *
 *  Each element in these arrays must be one of the following:
 *
 *  - **'self'**
 *    - The special **string**, `'self'`, can be used to match against all URLs of the **same
 *      domain** as the application document using the **same protocol**.
 *  - **String** (except the special value `'self'`)
 *    - The string is matched against the full *normalized / absolute URL* of the resource
 *      being tested (substring matches are not good enough.)
 *    - There are exactly **two wildcard sequences** - `*` and `**`.  All other characters
 *      match themselves.
 *    - `*`: matches zero or more occurrences of any character other than one of the following 6
 *      characters: '`:`', '`/`', '`.`', '`?`', '`&`' and '`;`'.  It's a useful wildcard for use
 *      for matching resource URL lists.
 *    - `**`: matches zero or more occurrences of *any* character.  As such, it's not
 *      appropriate for use in a scheme, domain, etc. as it would match too much.  (e.g.
 *      http://**.example.com/ would match http://evil.com/?ignore=.example.com/ and that might
 *      not have been the intention.)  Its usage at the very end of the path is ok.  (e.g.
 *      http://foo.example.com/templates/**).
 *  - **RegExp** (*see caveat below*)
 *    - *Caveat*:  While regular expressions are powerful and offer great flexibility,  their syntax
 *      (and all the inevitable escaping) makes them *harder to maintain*.  It's easy to
 *      accidentally introduce a bug when one updates a complex expression (imho, all regexes should
 *      have good test coverage).  For instance, the use of `.` in the regex is correct only in a
 *      small number of cases.  A `.` character in the regex used when matching the scheme or a
 *      subdomain could be matched against a `:` or literal `.` that was likely not intended.   It
 *      is highly recommended to use the string patterns and only fall back to regular expressions
 *      as a last resort.
 *    - The regular expression must be an instance of RegExp (i.e. not a string.)  It is
 *      matched against the **entire** *normalized / absolute URL* of the resource being tested
 *      (even when the RegExp did not have the `^` and `$` codes.)  In addition, any flags
 *      present on the RegExp (such as multiline, global, ignoreCase) are ignored.
 *    - If you are generating your JavaScript from some other templating engine (not
 *      recommended, e.g. in issue [#4006](https://github.com/angular/angular.js/issues/4006)),
 *      remember to escape your regular expression (and be aware that you might need more than
 *      one level of escaping depending on your templating engine and the way you interpolated
 *      the value.)  Do make use of your platform's escaping mechanism as it might be good
 *      enough before coding your own.  E.g. Ruby has
 *      [Regexp.escape(str)](http://www.ruby-doc.org/core-2.0.0/Regexp.html#method-c-escape)
 *      and Python has [re.escape](http://docs.python.org/library/re.html#re.escape).
 *      Javascript lacks a similar built in function for escaping.  Take a look at Google
 *      Closure library's [goog.string.regExpEscape(s)](
 *      http://docs.closure-library.googlecode.com/git/closure_goog_string_string.js.source.html#line962).
 *
 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} for an example.
 *
 * ### Show me an example using SCE.
 *
 * <example module="mySceApp" deps="angular-sanitize.js" name="sce-service">
 * <file name="index.html">
 *   <div ng-controller="AppController as myCtrl">
 *     <i ng-bind-html="myCtrl.explicitlyTrustedHtml" id="explicitlyTrustedHtml"></i><br><br>
 *     <b>User comments</b><br>
 *     By default, HTML that isn't explicitly trusted (e.g. Alice's comment) is sanitized when
 *     $sanitize is available.  If $sanitize isn't available, this results in an error instead of an
 *     exploit.
 *     <div class="well">
 *       <div ng-repeat="userComment in myCtrl.userComments">
 *         <b>{{userComment.name}}</b>:
 *         <span ng-bind-html="userComment.htmlComment" class="htmlComment"></span>
 *         <br>
 *       </div>
 *     </div>
 *   </div>
 * </file>
 *
 * <file name="script.js">
 *   angular.module('mySceApp', ['ngSanitize'])
 *     .controller('AppController', ['$http', '$templateCache', '$sce',
 *       function AppController($http, $templateCache, $sce) {
 *         var self = this;
 *         $http.get('test_data.json', {cache: $templateCache}).then(function(response) {
 *           self.userComments = response.data;
 *         });
 *         self.explicitlyTrustedHtml = $sce.trustAsHtml(
 *             '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
 *             'sanitization.&quot;">Hover over this text.</span>');
 *       }]);
 * </file>
 *
 * <file name="test_data.json">
 * [
 *   { "name": "Alice",
 *     "htmlComment":
 *         "<span onmouseover='this.textContent=\"PWN3D!\"'>Is <i>anyone</i> reading this?</span>"
 *   },
 *   { "name": "Bob",
 *     "htmlComment": "<i>Yes!</i>  Am I the only other one?"
 *   }
 * ]
 * </file>
 *
 * <file name="protractor.js" type="protractor">
 *   describe('SCE doc demo', function() {
 *     it('should sanitize untrusted values', function() {
 *       expect(element.all(by.css('.htmlComment')).first().getAttribute('innerHTML'))
 *           .toBe('<span>Is <i>anyone</i> reading this?</span>');
 *     });
 *
 *     it('should NOT sanitize explicitly trusted values', function() {
 *       expect(element(by.id('explicitlyTrustedHtml')).getAttribute('innerHTML')).toBe(
 *           '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
 *           'sanitization.&quot;">Hover over this text.</span>');
 *     });
 *   });
 * </file>
 * </example>
 *
 *
 *
 * ## Can I disable SCE completely?
 *
 * Yes, you can.  However, this is strongly discouraged.  SCE gives you a lot of security benefits
 * for little coding overhead.  It will be much harder to take an SCE disabled application and
 * either secure it on your own or enable SCE at a later stage.  It might make sense to disable SCE
 * for cases where you have a lot of existing code that was written before SCE was introduced and
 * you're migrating them a module at a time. Also do note that this is an app-wide setting, so if
 * you are writing a library, you will cause security bugs applications using it.
 *
 * That said, here's how you can completely disable SCE:
 *
 * ```
 * angular.module('myAppWithSceDisabledmyApp', []).config(function($sceProvider) {
 *   // Completely disable SCE.  For demonstration purposes only!
 *   // Do not use in new projects or libraries.
 *   $sceProvider.enabled(false);
 * });
 * ```
 *
 */

function $SceProvider() {
  var enabled = true;

  /**
   * @ngdoc method
   * @name $sceProvider#enabled
   * @kind function
   *
   * @param {boolean=} value If provided, then enables/disables SCE application-wide.
   * @return {boolean} True if SCE is enabled, false otherwise.
   *
   * @description
   * Enables/disables SCE and returns the current value.
   */
  this.enabled = function(value) {
    if (arguments.length) {
      enabled = !!value;
    }
    return enabled;
  };


  /* Design notes on the default implementation for SCE.
   *
   * The API contract for the SCE delegate
   * -------------------------------------
   * The SCE delegate object must provide the following 3 methods:
   *
   * - trustAs(contextEnum, value)
   *     This method is used to tell the SCE service that the provided value is OK to use in the
   *     contexts specified by contextEnum.  It must return an object that will be accepted by
   *     getTrusted() for a compatible contextEnum and return this value.
   *
   * - valueOf(value)
   *     For values that were not produced by trustAs(), return them as is.  For values that were
   *     produced by trustAs(), return the corresponding input value to trustAs.  Basically, if
   *     trustAs is wrapping the given values into some type, this operation unwraps it when given
   *     such a value.
   *
   * - getTrusted(contextEnum, value)
   *     This function should return the value that is safe to use in the context specified by
   *     contextEnum or throw and exception otherwise.
   *
   * NOTE: This contract deliberately does NOT state that values returned by trustAs() must be
   * opaque or wrapped in some holder object.  That happens to be an implementation detail.  For
   * instance, an implementation could maintain a registry of all trusted objects by context.  In
   * such a case, trustAs() would return the same object that was passed in.  getTrusted() would
   * return the same object passed in if it was found in the registry under a compatible context or
   * throw an exception otherwise.  An implementation might only wrap values some of the time based
   * on some criteria.  getTrusted() might return a value and not throw an exception for special
   * constants or objects even if not wrapped.  All such implementations fulfill this contract.
   *
   *
   * A note on the inheritance model for SCE contexts
   * ------------------------------------------------
   * I've used inheritance and made RESOURCE_URL wrapped types a subtype of URL wrapped types.  This
   * is purely an implementation details.
   *
   * The contract is simply this:
   *
   *     getTrusted($sce.RESOURCE_URL, value) succeeding implies that getTrusted($sce.URL, value)
   *     will also succeed.
   *
   * Inheritance happens to capture this in a natural way. In some future, we may not use
   * inheritance anymore. That is OK because no code outside of sce.js and sceSpecs.js would need to
   * be aware of this detail.
   */

  this.$get = ['$parse', '$sceDelegate', function(
                $parse,   $sceDelegate) {
    // Support: IE 9-11 only
    // Prereq: Ensure that we're not running in IE<11 quirks mode.  In that mode, IE < 11 allow
    // the "expression(javascript expression)" syntax which is insecure.
    if (enabled && msie < 8) {
      throw $sceMinErr('iequirks',
        'Strict Contextual Escaping does not support Internet Explorer version < 11 in quirks ' +
        'mode.  You can fix this by adding the text <!doctype html> to the top of your HTML ' +
        'document.  See http://docs.angularjs.org/api/ng.$sce for more information.');
    }

    var sce = shallowCopy(SCE_CONTEXTS);

    /**
     * @ngdoc method
     * @name $sce#isEnabled
     * @kind function
     *
     * @return {Boolean} True if SCE is enabled, false otherwise.  If you want to set the value, you
     *     have to do it at module config time on {@link ng.$sceProvider $sceProvider}.
     *
     * @description
     * Returns a boolean indicating if SCE is enabled.
     */
    sce.isEnabled = function() {
      return enabled;
    };
    sce.trustAs = $sceDelegate.trustAs;
    sce.getTrusted = $sceDelegate.getTrusted;
    sce.valueOf = $sceDelegate.valueOf;

    if (!enabled) {
      sce.trustAs = sce.getTrusted = function(type, value) { return value; };
      sce.valueOf = identity;
    }

    /**
     * @ngdoc method
     * @name $sce#parseAs
     *
     * @description
     * Converts AngularJS {@link guide/expression expression} into a function.  This is like {@link
     * ng.$parse $parse} and is identical when the expression is a literal constant.  Otherwise, it
     * wraps the expression in a call to {@link ng.$sce#getTrusted $sce.getTrusted(*type*,
     * *result*)}
     *
     * @param {string} type The SCE context in which this result will be used.
     * @param {string} expression String expression to compile.
     * @return {function(context, locals)} A function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the
     *      strings are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
     *      in `context`.
     */
    sce.parseAs = function sceParseAs(type, expr) {
      var parsed = $parse(expr);
      if (parsed.literal && parsed.constant) {
        return parsed;
      } else {
        return $parse(expr, function(value) {
          return sce.getTrusted(type, value);
        });
      }
    };

    /**
     * @ngdoc method
     * @name $sce#trustAs
     *
     * @description
     * Delegates to {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}. As such, returns a
     * wrapped object that represents your value, and the trust you have in its safety for the given
     * context. AngularJS can then use that value as-is in bindings of the specified secure context.
     * This is used in bindings for `ng-bind-html`, `ng-include`, and most `src` attribute
     * interpolations. See {@link ng.$sce $sce} for strict contextual escaping.
     *
     * @param {string} type The context in which this value is safe for use, e.g. `$sce.URL`,
     *     `$sce.RESOURCE_URL`, `$sce.HTML`, `$sce.JS` or `$sce.CSS`.
     *
     * @param {*} value The value that that should be considered trusted.
     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
     *     in the context you specified.
     */

    /**
     * @ngdoc method
     * @name $sce#trustAsHtml
     *
     * @description
     * Shorthand method.  `$sce.trustAsHtml(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.HTML, value)`}
     *
     * @param {*} value The value to mark as trusted for `$sce.HTML` context.
     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
     *     in `$sce.HTML` context (like `ng-bind-html`).
     */

    /**
     * @ngdoc method
     * @name $sce#trustAsCss
     *
     * @description
     * Shorthand method.  `$sce.trustAsCss(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.CSS, value)`}
     *
     * @param {*} value The value to mark as trusted for `$sce.CSS` context.
     * @return {*} A wrapped version of value that can be used as a trusted variant
     *     of your `value` in `$sce.CSS` context. This context is currently unused, so there are
     *     almost no reasons to use this function so far.
     */

    /**
     * @ngdoc method
     * @name $sce#trustAsUrl
     *
     * @description
     * Shorthand method.  `$sce.trustAsUrl(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.URL, value)`}
     *
     * @param {*} value The value to mark as trusted for `$sce.URL` context.
     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
     *     in `$sce.URL` context. That context is currently unused, so there are almost no reasons
     *     to use this function so far.
     */

    /**
     * @ngdoc method
     * @name $sce#trustAsResourceUrl
     *
     * @description
     * Shorthand method.  `$sce.trustAsResourceUrl(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.RESOURCE_URL, value)`}
     *
     * @param {*} value The value to mark as trusted for `$sce.RESOURCE_URL` context.
     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
     *     in `$sce.RESOURCE_URL` context (template URLs in `ng-include`, most `src` attribute
     *     bindings, ...)
     */

    /**
     * @ngdoc method
     * @name $sce#trustAsJs
     *
     * @description
     * Shorthand method.  `$sce.trustAsJs(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.JS, value)`}
     *
     * @param {*} value The value to mark as trusted for `$sce.JS` context.
     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
     *     in `$sce.JS` context. That context is currently unused, so there are almost no reasons to
     *     use this function so far.
     */

    /**
     * @ngdoc method
     * @name $sce#getTrusted
     *
     * @description
     * Delegates to {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted`}.  As such,
     * takes any input, and either returns a value that's safe to use in the specified context,
     * or throws an exception. This function is aware of trusted values created by the `trustAs`
     * function and its shorthands, and when contexts are appropriate, returns the unwrapped value
     * as-is. Finally, this function can also throw when there is no way to turn `maybeTrusted` in a
     * safe value (e.g., no sanitization is available or possible.)
     *
     * @param {string} type The context in which this value is to be used.
     * @param {*} maybeTrusted The result of a prior {@link ng.$sce#trustAs
     *     `$sce.trustAs`} call, or anything else (which will not be considered trusted.)
     * @return {*} A version of the value that's safe to use in the given context, or throws an
     *     exception if this is impossible.
     */

    /**
     * @ngdoc method
     * @name $sce#getTrustedHtml
     *
     * @description
     * Shorthand method.  `$sce.getTrustedHtml(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.HTML, value)`}
     *
     * @param {*} value The value to pass to `$sce.getTrusted`.
     * @return {*} The return value of `$sce.getTrusted($sce.HTML, value)`
     */

    /**
     * @ngdoc method
     * @name $sce#getTrustedCss
     *
     * @description
     * Shorthand method.  `$sce.getTrustedCss(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.CSS, value)`}
     *
     * @param {*} value The value to pass to `$sce.getTrusted`.
     * @return {*} The return value of `$sce.getTrusted($sce.CSS, value)`
     */

    /**
     * @ngdoc method
     * @name $sce#getTrustedUrl
     *
     * @description
     * Shorthand method.  `$sce.getTrustedUrl(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.URL, value)`}
     *
     * @param {*} value The value to pass to `$sce.getTrusted`.
     * @return {*} The return value of `$sce.getTrusted($sce.URL, value)`
     */

    /**
     * @ngdoc method
     * @name $sce#getTrustedResourceUrl
     *
     * @description
     * Shorthand method.  `$sce.getTrustedResourceUrl(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.RESOURCE_URL, value)`}
     *
     * @param {*} value The value to pass to `$sceDelegate.getTrusted`.
     * @return {*} The return value of `$sce.getTrusted($sce.RESOURCE_URL, value)`
     */

    /**
     * @ngdoc method
     * @name $sce#getTrustedJs
     *
     * @description
     * Shorthand method.  `$sce.getTrustedJs(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.JS, value)`}
     *
     * @param {*} value The value to pass to `$sce.getTrusted`.
     * @return {*} The return value of `$sce.getTrusted($sce.JS, value)`
     */

    /**
     * @ngdoc method
     * @name $sce#parseAsHtml
     *
     * @description
     * Shorthand method.  `$sce.parseAsHtml(expression string)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.HTML, value)`}
     *
     * @param {string} expression String expression to compile.
     * @return {function(context, locals)} A function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the
     *      strings are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
     *      in `context`.
     */

    /**
     * @ngdoc method
     * @name $sce#parseAsCss
     *
     * @description
     * Shorthand method.  `$sce.parseAsCss(value)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.CSS, value)`}
     *
     * @param {string} expression String expression to compile.
     * @return {function(context, locals)} A function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the
     *      strings are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
     *      in `context`.
     */

    /**
     * @ngdoc method
     * @name $sce#parseAsUrl
     *
     * @description
     * Shorthand method.  `$sce.parseAsUrl(value)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.URL, value)`}
     *
     * @param {string} expression String expression to compile.
     * @return {function(context, locals)} A function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the
     *      strings are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
     *      in `context`.
     */

    /**
     * @ngdoc method
     * @name $sce#parseAsResourceUrl
     *
     * @description
     * Shorthand method.  `$sce.parseAsResourceUrl(value)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.RESOURCE_URL, value)`}
     *
     * @param {string} expression String expression to compile.
     * @return {function(context, locals)} A function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the
     *      strings are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
     *      in `context`.
     */

    /**
     * @ngdoc method
     * @name $sce#parseAsJs
     *
     * @description
     * Shorthand method.  `$sce.parseAsJs(value)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.JS, value)`}
     *
     * @param {string} expression String expression to compile.
     * @return {function(context, locals)} A function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the
     *      strings are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
     *      in `context`.
     */

    // Shorthand delegations.
    var parse = sce.parseAs,
        getTrusted = sce.getTrusted,
        trustAs = sce.trustAs;

    forEach(SCE_CONTEXTS, function(enumValue, name) {
      var lName = lowercase(name);
      sce[snakeToCamel('parse_as_' + lName)] = function(expr) {
        return parse(enumValue, expr);
      };
      sce[snakeToCamel('get_trusted_' + lName)] = function(value) {
        return getTrusted(enumValue, value);
      };
      sce[snakeToCamel('trust_as_' + lName)] = function(value) {
        return trustAs(enumValue, value);
      };
    });

    return sce;
  }];
}

/* exported $SnifferProvider */

/**
 * !!! This is an undocumented "private" service !!!
 *
 * @name $sniffer
 * @requires $window
 * @requires $document
 * @this
 *
 * @property {boolean} history Does the browser support html5 history api ?
 * @property {boolean} transitions Does the browser support CSS transition events ?
 * @property {boolean} animations Does the browser support CSS animation events ?
 *
 * @description
 * This is very simple implementation of testing browser's features.
 */
function $SnifferProvider() {
  this.$get = ['$window', '$document', function($window, $document) {
    var eventSupport = {},
        // Chrome Packaged Apps are not allowed to access `history.pushState`.
        // If not sandboxed, they can be detected by the presence of `chrome.app.runtime`
        // (see https://developer.chrome.com/apps/api_index). If sandboxed, they can be detected by
        // the presence of an extension runtime ID and the absence of other Chrome runtime APIs
        // (see https://developer.chrome.com/apps/manifest/sandbox).
        // (NW.js apps have access to Chrome APIs, but do support `history`.)
        isNw = $window.nw && $window.nw.process,
        isChromePackagedApp =
            !isNw &&
            $window.chrome &&
            ($window.chrome.app && $window.chrome.app.runtime ||
                !$window.chrome.app && $window.chrome.runtime && $window.chrome.runtime.id),
        hasHistoryPushState = !isChromePackagedApp && $window.history && $window.history.pushState,
        android =
          toInt((/android (\d+)/.exec(lowercase(($window.navigator || {}).userAgent)) || [])[1]),
        boxee = /Boxee/i.test(($window.navigator || {}).userAgent),
        document = $document[0] || {},
        bodyStyle = document.body && document.body.style,
        transitions = false,
        animations = false;

    if (bodyStyle) {
      // Support: Android <5, Blackberry Browser 10, default Chrome in Android 4.4.x
      // Mentioned browsers need a -webkit- prefix for transitions & animations.
      transitions = !!('transition' in bodyStyle || 'webkitTransition' in bodyStyle);
      animations = !!('animation' in bodyStyle || 'webkitAnimation' in bodyStyle);
    }


    return {
      // Android has history.pushState, but it does not update location correctly
      // so let's not use the history API at all.
      // http://code.google.com/p/android/issues/detail?id=17471
      // https://github.com/angular/angular.js/issues/904

      // older webkit browser (533.9) on Boxee box has exactly the same problem as Android has
      // so let's not use the history API also
      // We are purposefully using `!(android < 4)` to cover the case when `android` is undefined
      history: !!(hasHistoryPushState && !(android < 4) && !boxee),
      hasEvent: function(event) {
        // Support: IE 9-11 only
        // IE9 implements 'input' event it's so fubared that we rather pretend that it doesn't have
        // it. In particular the event is not fired when backspace or delete key are pressed or
        // when cut operation is performed.
        // IE10+ implements 'input' event but it erroneously fires under various situations,
        // e.g. when placeholder changes, or a form is focused.
        if (event === 'input' && msie) return false;

        if (isUndefined(eventSupport[event])) {
          var divElm = document.createElement('div');
          eventSupport[event] = 'on' + event in divElm;
        }

        return eventSupport[event];
      },
      csp: csp(),
      transitions: transitions,
      animations: animations,
      android: android
    };
  }];
}

/**
 * ! This is a private undocumented service !
 *
 * @name $$taskTrackerFactory
 * @description
 * A function to create `TaskTracker` instances.
 *
 * A `TaskTracker` can keep track of pending tasks (grouped by type) and can notify interested
 * parties when all pending tasks (or tasks of a specific type) have been completed.
 *
 * @param {$log} log - A logger instance (such as `$log`). Used to log error during callback
 *     execution.
 *
 * @this
 */
function $$TaskTrackerFactoryProvider() {
  this.$get = valueFn(function(log) { return new TaskTracker(log); });
}

function TaskTracker(log) {
  var self = this;
  var taskCounts = {};
  var taskCallbacks = [];

  var ALL_TASKS_TYPE = self.ALL_TASKS_TYPE = '$$all$$';
  var DEFAULT_TASK_TYPE = self.DEFAULT_TASK_TYPE = '$$default$$';

  /**
   * Execute the specified function and decrement the appropriate `taskCounts` counter.
   * If the counter reaches 0, all corresponding `taskCallbacks` are executed.
   *
   * @param {Function} fn - The function to execute.
   * @param {string=} [taskType=DEFAULT_TASK_TYPE] - The type of task that is being completed.
   */
  self.completeTask = completeTask;

  /**
   * Increase the task count for the specified task type (or the default task type if non is
   * specified).
   *
   * @param {string=} [taskType=DEFAULT_TASK_TYPE] - The type of task whose count will be increased.
   */
  self.incTaskCount = incTaskCount;

  /**
   * Execute the specified callback when all pending tasks have been completed.
   *
   * If there are no pending tasks, the callback is executed immediately. You can optionally limit
   * the tasks that will be waited for to a specific type, by passing a `taskType`.
   *
   * @param {function} callback - The function to call when there are no pending tasks.
   * @param {string=} [taskType=ALL_TASKS_TYPE] - The type of tasks that will be waited for.
   */
  self.notifyWhenNoPendingTasks = notifyWhenNoPendingTasks;

  function completeTask(fn, taskType) {
    taskType = taskType || DEFAULT_TASK_TYPE;

    try {
      fn();
    } finally {
      decTaskCount(taskType);

      var countForType = taskCounts[taskType];
      var countForAll = taskCounts[ALL_TASKS_TYPE];

      // If at least one of the queues (`ALL_TASKS_TYPE` or `taskType`) is empty, run callbacks.
      if (!countForAll || !countForType) {
        var getNextCallback = !countForAll ? getLastCallback : getLastCallbackForType;
        var nextCb;

        while ((nextCb = getNextCallback(taskType))) {
          try {
            nextCb();
          } catch (e) {
            log.error(e);
          }
        }
      }
    }
  }

  function decTaskCount(taskType) {
    taskType = taskType || DEFAULT_TASK_TYPE;
    if (taskCounts[taskType]) {
      taskCounts[taskType]--;
      taskCounts[ALL_TASKS_TYPE]--;
    }
  }

  function getLastCallback() {
    var cbInfo = taskCallbacks.pop();
    return cbInfo && cbInfo.cb;
  }

  function getLastCallbackForType(taskType) {
    for (var i = taskCallbacks.length - 1; i >= 0; --i) {
      var cbInfo = taskCallbacks[i];
      if (cbInfo.type === taskType) {
        taskCallbacks.splice(i, 1);
        return cbInfo.cb;
      }
    }
  }

  function incTaskCount(taskType) {
    taskType = taskType || DEFAULT_TASK_TYPE;
    taskCounts[taskType] = (taskCounts[taskType] || 0) + 1;
    taskCounts[ALL_TASKS_TYPE] = (taskCounts[ALL_TASKS_TYPE] || 0) + 1;
  }

  function notifyWhenNoPendingTasks(callback, taskType) {
    taskType = taskType || ALL_TASKS_TYPE;
    if (!taskCounts[taskType]) {
      callback();
    } else {
      taskCallbacks.push({type: taskType, cb: callback});
    }
  }
}

var $templateRequestMinErr = minErr('$templateRequest');

/**
 * @ngdoc provider
 * @name $templateRequestProvider
 * @this
 *
 * @description
 * Used to configure the options passed to the {@link $http} service when making a template request.
 *
 * For example, it can be used for specifying the "Accept" header that is sent to the server, when
 * requesting a template.
 */
function $TemplateRequestProvider() {

  var httpOptions;

  /**
   * @ngdoc method
   * @name $templateRequestProvider#httpOptions
   * @description
   * The options to be passed to the {@link $http} service when making the request.
   * You can use this to override options such as the "Accept" header for template requests.
   *
   * The {@link $templateRequest} will set the `cache` and the `transformResponse` properties of the
   * options if not overridden here.
   *
   * @param {string=} value new value for the {@link $http} options.
   * @returns {string|self} Returns the {@link $http} options when used as getter and self if used as setter.
   */
  this.httpOptions = function(val) {
    if (val) {
      httpOptions = val;
      return this;
    }
    return httpOptions;
  };

  /**
   * @ngdoc service
   * @name $templateRequest
   *
   * @description
   * The `$templateRequest` service runs security checks then downloads the provided template using
   * `$http` and, upon success, stores the contents inside of `$templateCache`. If the HTTP request
   * fails or the response data of the HTTP request is empty, a `$compile` error will be thrown (the
   * exception can be thwarted by setting the 2nd parameter of the function to true). Note that the
   * contents of `$templateCache` are trusted, so the call to `$sce.getTrustedUrl(tpl)` is omitted
   * when `tpl` is of type string and `$templateCache` has the matching entry.
   *
   * If you want to pass custom options to the `$http` service, such as setting the Accept header you
   * can configure this via {@link $templateRequestProvider#httpOptions}.
   *
   * `$templateRequest` is used internally by {@link $compile}, {@link ngRoute.$route}, and directives such
   * as {@link ngInclude} to download and cache templates.
   *
   * 3rd party modules should use `$templateRequest` if their services or directives are loading
   * templates.
   *
   * @param {string|TrustedResourceUrl} tpl The HTTP request template URL
   * @param {boolean=} ignoreRequestError Whether or not to ignore the exception when the request fails or the template is empty
   *
   * @return {Promise} a promise for the HTTP response data of the given URL.
   *
   * @property {number} totalPendingRequests total amount of pending template requests being downloaded.
   */
  this.$get = ['$exceptionHandler', '$templateCache', '$http', '$q', '$sce',
    function($exceptionHandler, $templateCache, $http, $q, $sce) {

      function handleRequestFn(tpl, ignoreRequestError) {
        handleRequestFn.totalPendingRequests++;

        // We consider the template cache holds only trusted templates, so
        // there's no need to go through adding the template again to the trusted
        // resources for keys that already are included in there. This also makes
        // AngularJS accept any script directive, no matter its name. However, we
        // still need to unwrap trusted types.
        if (!isString(tpl) || isUndefined($templateCache.get(tpl))) {
          tpl = $sce.getTrustedResourceUrl(tpl);
        }

        var transformResponse = $http.defaults && $http.defaults.transformResponse;

        if (isArray(transformResponse)) {
          transformResponse = transformResponse.filter(function(transformer) {
            return transformer !== defaultHttpResponseTransform;
          });
        } else if (transformResponse === defaultHttpResponseTransform) {
          transformResponse = null;
        }

        return $http.get(tpl, extend({
            cache: $templateCache,
            transformResponse: transformResponse
          }, httpOptions))
          .finally(function() {
            handleRequestFn.totalPendingRequests--;
          })
          .then(function(response) {
            return $templateCache.put(tpl, response.data);
          }, handleError);

        function handleError(resp) {
          if (!ignoreRequestError) {
            resp = $templateRequestMinErr('tpload',
                'Failed to load template: {0} (HTTP status: {1} {2})',
                tpl, resp.status, resp.statusText);

            $exceptionHandler(resp);
          }

          return $q.reject(resp);
        }
      }

      handleRequestFn.totalPendingRequests = 0;

      return handleRequestFn;
    }
  ];
}

/** @this */
function $$TestabilityProvider() {
  this.$get = ['$rootScope', '$browser', '$location',
       function($rootScope,   $browser,   $location) {

    /**
     * @name $testability
     *
     * @description
     * The private $$testability service provides a collection of methods for use when debugging
     * or by automated test and debugging tools.
     */
    var testability = {};

    /**
     * @name $$testability#findBindings
     *
     * @description
     * Returns an array of elements that are bound (via ng-bind or {{}})
     * to expressions matching the input.
     *
     * @param {Element} element The element root to search from.
     * @param {string} expression The binding expression to match.
     * @param {boolean} opt_exactMatch If true, only returns exact matches
     *     for the expression. Filters and whitespace are ignored.
     */
    testability.findBindings = function(element, expression, opt_exactMatch) {
      var bindings = element.getElementsByClassName('ng-binding');
      var matches = [];
      forEach(bindings, function(binding) {
        var dataBinding = angular.element(binding).data('$binding');
        if (dataBinding) {
          forEach(dataBinding, function(bindingName) {
            if (opt_exactMatch) {
              var matcher = new RegExp('(^|\\s)' + escapeForRegexp(expression) + '(\\s|\\||$)');
              if (matcher.test(bindingName)) {
                matches.push(binding);
              }
            } else {
              if (bindingName.indexOf(expression) !== -1) {
                matches.push(binding);
              }
            }
          });
        }
      });
      return matches;
    };

    /**
     * @name $$testability#findModels
     *
     * @description
     * Returns an array of elements that are two-way found via ng-model to
     * expressions matching the input.
     *
     * @param {Element} element The element root to search from.
     * @param {string} expression The model expression to match.
     * @param {boolean} opt_exactMatch If true, only returns exact matches
     *     for the expression.
     */
    testability.findModels = function(element, expression, opt_exactMatch) {
      var prefixes = ['ng-', 'data-ng-', 'ng\\:'];
      for (var p = 0; p < prefixes.length; ++p) {
        var attributeEquals = opt_exactMatch ? '=' : '*=';
        var selector = '[' + prefixes[p] + 'model' + attributeEquals + '"' + expression + '"]';
        var elements = element.querySelectorAll(selector);
        if (elements.length) {
          return elements;
        }
      }
    };

    /**
     * @name $$testability#getLocation
     *
     * @description
     * Shortcut for getting the location in a browser agnostic way. Returns
     *     the path, search, and hash. (e.g. /path?a=b#hash)
     */
    testability.getLocation = function() {
      return $location.url();
    };

    /**
     * @name $$testability#setLocation
     *
     * @description
     * Shortcut for navigating to a location without doing a full page reload.
     *
     * @param {string} url The location url (path, search and hash,
     *     e.g. /path?a=b#hash) to go to.
     */
    testability.setLocation = function(url) {
      if (url !== $location.url()) {
        $location.url(url);
        $rootScope.$digest();
      }
    };

    /**
     * @name $$testability#whenStable
     *
     * @description
     * Calls the callback when all pending tasks are completed.
     *
     * Types of tasks waited for include:
     * - Pending timeouts (via {@link $timeout}).
     * - Pending HTTP requests (via {@link $http}).
     * - In-progress route transitions (via {@link $route}).
     * - Pending tasks scheduled via {@link $rootScope#$applyAsync}.
     * - Pending tasks scheduled via {@link $rootScope#$evalAsync}.
     *   These include tasks scheduled via `$evalAsync()` indirectly (such as {@link $q} promises).
     *
     * @param {function} callback
     */
    testability.whenStable = function(callback) {
      $browser.notifyWhenNoOutstandingRequests(callback);
    };

    return testability;
  }];
}

var $timeoutMinErr = minErr('$timeout');

/** @this */
function $TimeoutProvider() {
  this.$get = ['$rootScope', '$browser', '$q', '$$q', '$exceptionHandler',
       function($rootScope,   $browser,   $q,   $$q,   $exceptionHandler) {

    var deferreds = {};


    /**
     * @ngdoc service
     * @name $timeout
     *
     * @description
     * AngularJS's wrapper for `window.setTimeout`. The `fn` function is wrapped into a try/catch
     * block and delegates any exceptions to
     * {@link ng.$exceptionHandler $exceptionHandler} service.
     *
     * The return value of calling `$timeout` is a promise, which will be resolved when
     * the delay has passed and the timeout function, if provided, is executed.
     *
     * To cancel a timeout request, call `$timeout.cancel(promise)`.
     *
     * In tests you can use {@link ngMock.$timeout `$timeout.flush()`} to
     * synchronously flush the queue of deferred functions.
     *
     * If you only want a promise that will be resolved after some specified delay
     * then you can call `$timeout` without the `fn` function.
     *
     * @param {function()=} fn A function, whose execution should be delayed.
     * @param {number=} [delay=0] Delay in milliseconds.
     * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
     *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
     * @param {...*=} Pass additional parameters to the executed function.
     * @returns {Promise} Promise that will be resolved when the timeout is reached. The promise
     *   will be resolved with the return value of the `fn` function.
     *
     */
    function timeout(fn, delay, invokeApply) {
      if (!isFunction(fn)) {
        invokeApply = delay;
        delay = fn;
        fn = noop;
      }

      var args = sliceArgs(arguments, 3),
          skipApply = (isDefined(invokeApply) && !invokeApply),
          deferred = (skipApply ? $$q : $q).defer(),
          promise = deferred.promise,
          timeoutId;

      timeoutId = $browser.defer(function() {
        try {
          deferred.resolve(fn.apply(null, args));
        } catch (e) {
          deferred.reject(e);
          $exceptionHandler(e);
        } finally {
          delete deferreds[promise.$$timeoutId];
        }

        if (!skipApply) $rootScope.$apply();
      }, delay, '$timeout');

      promise.$$timeoutId = timeoutId;
      deferreds[timeoutId] = deferred;

      return promise;
    }


    /**
     * @ngdoc method
     * @name $timeout#cancel
     *
     * @description
     * Cancels a task associated with the `promise`. As a result of this, the promise will be
     * resolved with a rejection.
     *
     * @param {Promise=} promise Promise returned by the `$timeout` function.
     * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
     *   canceled.
     */
    timeout.cancel = function(promise) {
      if (!promise) return false;

      if (!promise.hasOwnProperty('$$timeoutId')) {
        throw $timeoutMinErr('badprom',
            '`$timeout.cancel()` called with a promise that was not generated by `$timeout()`.');
      }

      if (!deferreds.hasOwnProperty(promise.$$timeoutId)) return false;

      var id = promise.$$timeoutId;
      var deferred = deferreds[id];

      // Timeout cancels should not report an unhandled promise.
      markQExceptionHandled(deferred.promise);
      deferred.reject('canceled');
      delete deferreds[id];

      return $browser.defer.cancel(id);
    };

    return timeout;
  }];
}

// NOTE:  The usage of window and document instead of $window and $document here is
// deliberate.  This service depends on the specific behavior of anchor nodes created by the
// browser (resolving and parsing URLs) that is unlikely to be provided by mock objects and
// cause us to break tests.  In addition, when the browser resolves a URL for XHR, it
// doesn't know about mocked locations and resolves URLs to the real document - which is
// exactly the behavior needed here.  There is little value is mocking these out for this
// service.
var urlParsingNode = window.document.createElement('a');
var originUrl = urlResolve(window.location.href);
var baseUrlParsingNode;

urlParsingNode.href = 'http://[::1]';

// Support: IE 9-11 only, Edge 16-17 only (fixed in 18 Preview)
// IE/Edge don't wrap IPv6 addresses' hostnames in square brackets
// when parsed out of an anchor element.
var ipv6InBrackets = urlParsingNode.hostname === '[::1]';

/**
 *
 * Implementation Notes for non-IE browsers
 * ----------------------------------------
 * Assigning a URL to the href property of an anchor DOM node, even one attached to the DOM,
 * results both in the normalizing and parsing of the URL.  Normalizing means that a relative
 * URL will be resolved into an absolute URL in the context of the application document.
 * Parsing means that the anchor node's host, hostname, protocol, port, pathname and related
 * properties are all populated to reflect the normalized URL.  This approach has wide
 * compatibility - Safari 1+, Mozilla 1+ etc.  See
 * http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
 *
 * Implementation Notes for IE
 * ---------------------------
 * IE <= 10 normalizes the URL when assigned to the anchor node similar to the other
 * browsers.  However, the parsed components will not be set if the URL assigned did not specify
 * them.  (e.g. if you assign a.href = "foo", then a.protocol, a.host, etc. will be empty.)  We
 * work around that by performing the parsing in a 2nd step by taking a previously normalized
 * URL (e.g. by assigning to a.href) and assigning it a.href again.  This correctly populates the
 * properties such as protocol, hostname, port, etc.
 *
 * References:
 *   http://developer.mozilla.org/en-US/docs/Web/API/HTMLAnchorElement
 *   http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
 *   http://url.spec.whatwg.org/#urlutils
 *   https://github.com/angular/angular.js/pull/2902
 *   http://james.padolsey.com/javascript/parsing-urls-with-the-dom/
 *
 * @kind function
 * @param {string|object} url The URL to be parsed. If `url` is not a string, it will be returned
 *     unchanged.
 * @description Normalizes and parses a URL.
 * @returns {object} Returns the normalized URL as a dictionary.
 *
 *   | member name   | Description                                                            |
 *   |---------------|------------------------------------------------------------------------|
 *   | href          | A normalized version of the provided URL if it was not an absolute URL |
 *   | protocol      | The protocol without the trailing colon                                |
 *   | host          | The host and port (if the port is non-default) of the normalizedUrl    |
 *   | search        | The search params, minus the question mark                             |
 *   | hash          | The hash string, minus the hash symbol                                 |
 *   | hostname      | The hostname                                                           |
 *   | port          | The port, without ":"                                                  |
 *   | pathname      | The pathname, beginning with "/"                                       |
 *
 */
function urlResolve(url) {
  if (!isString(url)) return url;

  var href = url;

  // Support: IE 9-11 only
  if (msie) {
    // Normalize before parse.  Refer Implementation Notes on why this is
    // done in two steps on IE.
    urlParsingNode.setAttribute('href', href);
    href = urlParsingNode.href;
  }

  urlParsingNode.setAttribute('href', href);

  var hostname = urlParsingNode.hostname;

  if (!ipv6InBrackets && hostname.indexOf(':') > -1) {
    hostname = '[' + hostname + ']';
  }

  return {
    href: urlParsingNode.href,
    protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
    host: urlParsingNode.host,
    search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
    hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
    hostname: hostname,
    port: urlParsingNode.port,
    pathname: (urlParsingNode.pathname.charAt(0) === '/')
      ? urlParsingNode.pathname
      : '/' + urlParsingNode.pathname
  };
}

/**
 * Parse a request URL and determine whether this is a same-origin request as the application
 * document.
 *
 * @param {string|object} requestUrl The url of the request as a string that will be resolved
 * or a parsed URL object.
 * @returns {boolean} Whether the request is for the same origin as the application document.
 */
function urlIsSameOrigin(requestUrl) {
  return urlsAreSameOrigin(requestUrl, originUrl);
}

/**
 * Parse a request URL and determine whether it is same-origin as the current document base URL.
 *
 * Note: The base URL is usually the same as the document location (`location.href`) but can
 * be overriden by using the `<base>` tag.
 *
 * @param {string|object} requestUrl The url of the request as a string that will be resolved
 * or a parsed URL object.
 * @returns {boolean} Whether the URL is same-origin as the document base URL.
 */
function urlIsSameOriginAsBaseUrl(requestUrl) {
  return urlsAreSameOrigin(requestUrl, getBaseUrl());
}

/**
 * Create a function that can check a URL's origin against a list of allowed/trusted origins.
 * The current location's origin is implicitly trusted.
 *
 * @param {string[]} trustedOriginUrls - A list of URLs (strings), whose origins are trusted.
 *
 * @returns {Function} - A function that receives a URL (string or parsed URL object) and returns
 *     whether it is of an allowed origin.
 */
function urlIsAllowedOriginFactory(trustedOriginUrls) {
  var parsedAllowedOriginUrls = [originUrl].concat(trustedOriginUrls.map(urlResolve));

  /**
   * Check whether the specified URL (string or parsed URL object) has an origin that is allowed
   * based on a list of trusted-origin URLs. The current location's origin is implicitly
   * trusted.
   *
   * @param {string|Object} requestUrl - The URL to be checked (provided as a string that will be
   *     resolved or a parsed URL object).
   *
   * @returns {boolean} - Whether the specified URL is of an allowed origin.
   */
  return function urlIsAllowedOrigin(requestUrl) {
    var parsedUrl = urlResolve(requestUrl);
    return parsedAllowedOriginUrls.some(urlsAreSameOrigin.bind(null, parsedUrl));
  };
}

/**
 * Determine if two URLs share the same origin.
 *
 * @param {string|Object} url1 - First URL to compare as a string or a normalized URL in the form of
 *     a dictionary object returned by `urlResolve()`.
 * @param {string|object} url2 - Second URL to compare as a string or a normalized URL in the form
 *     of a dictionary object returned by `urlResolve()`.
 *
 * @returns {boolean} - True if both URLs have the same origin, and false otherwise.
 */
function urlsAreSameOrigin(url1, url2) {
  url1 = urlResolve(url1);
  url2 = urlResolve(url2);

  return (url1.protocol === url2.protocol &&
          url1.host === url2.host);
}

/**
 * Returns the current document base URL.
 * @returns {string}
 */
function getBaseUrl() {
  if (window.document.baseURI) {
    return window.document.baseURI;
  }

  // `document.baseURI` is available everywhere except IE
  if (!baseUrlParsingNode) {
    baseUrlParsingNode = window.document.createElement('a');
    baseUrlParsingNode.href = '.';

    // Work-around for IE bug described in Implementation Notes. The fix in `urlResolve()` is not
    // suitable here because we need to track changes to the base URL.
    baseUrlParsingNode = baseUrlParsingNode.cloneNode(false);
  }
  return baseUrlParsingNode.href;
}

/**
 * @ngdoc service
 * @name $window
 * @this
 *
 * @description
 * A reference to the browser's `window` object. While `window`
 * is globally available in JavaScript, it causes testability problems, because
 * it is a global variable. In AngularJS we always refer to it through the
 * `$window` service, so it may be overridden, removed or mocked for testing.
 *
 * Expressions, like the one defined for the `ngClick` directive in the example
 * below, are evaluated with respect to the current scope.  Therefore, there is
 * no risk of inadvertently coding in a dependency on a global value in such an
 * expression.
 *
 * @example
   <example module="windowExample" name="window-service">
     <file name="index.html">
       <script>
         angular.module('windowExample', [])
           .controller('ExampleController', ['$scope', '$window', function($scope, $window) {
             $scope.greeting = 'Hello, World!';
             $scope.doGreeting = function(greeting) {
               $window.alert(greeting);
             };
           }]);
       </script>
       <div ng-controller="ExampleController">
         <input type="text" ng-model="greeting" aria-label="greeting" />
         <button ng-click="doGreeting(greeting)">ALERT</button>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
      it('should display the greeting in the input box', function() {
       element(by.model('greeting')).sendKeys('Hello, E2E Tests');
       // If we click the button it will block the test runner
       // element(':button').click();
      });
     </file>
   </example>
 */
function $WindowProvider() {
  this.$get = valueFn(window);
}

/**
 * @name $$cookieReader
 * @requires $document
 *
 * @description
 * This is a private service for reading cookies used by $http and ngCookies
 *
 * @return {Object} a key/value map of the current cookies
 */
function $$CookieReader($document) {
  var rawDocument = $document[0] || {};
  var lastCookies = {};
  var lastCookieString = '';

  function safeGetCookie(rawDocument) {
    try {
      return rawDocument.cookie || '';
    } catch (e) {
      return '';
    }
  }

  function safeDecodeURIComponent(str) {
    try {
      return decodeURIComponent(str);
    } catch (e) {
      return str;
    }
  }

  return function() {
    var cookieArray, cookie, i, index, name;
    var currentCookieString = safeGetCookie(rawDocument);

    if (currentCookieString !== lastCookieString) {
      lastCookieString = currentCookieString;
      cookieArray = lastCookieString.split('; ');
      lastCookies = {};

      for (i = 0; i < cookieArray.length; i++) {
        cookie = cookieArray[i];
        index = cookie.indexOf('=');
        if (index > 0) { //ignore nameless cookies
          name = safeDecodeURIComponent(cookie.substring(0, index));
          // the first value that is seen for a cookie is the most
          // specific one.  values for the same cookie name that
          // follow are for less specific paths.
          if (isUndefined(lastCookies[name])) {
            lastCookies[name] = safeDecodeURIComponent(cookie.substring(index + 1));
          }
        }
      }
    }
    return lastCookies;
  };
}

$$CookieReader.$inject = ['$document'];

/** @this */
function $$CookieReaderProvider() {
  this.$get = $$CookieReader;
}

/* global currencyFilter: true,
 dateFilter: true,
 filterFilter: true,
 jsonFilter: true,
 limitToFilter: true,
 lowercaseFilter: true,
 numberFilter: true,
 orderByFilter: true,
 uppercaseFilter: true,
 */

/**
 * @ngdoc provider
 * @name $filterProvider
 * @description
 *
 * Filters are just functions which transform input to an output. However filters need to be
 * Dependency Injected. To achieve this a filter definition consists of a factory function which is
 * annotated with dependencies and is responsible for creating a filter function.
 *
 * <div class="alert alert-warning">
 * **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
 * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
 * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
 * (`myapp_subsection_filterx`).
 * </div>
 *
 * ```js
 *   // Filter registration
 *   function MyModule($provide, $filterProvider) {
 *     // create a service to demonstrate injection (not always needed)
 *     $provide.value('greet', function(name){
 *       return 'Hello ' + name + '!';
 *     });
 *
 *     // register a filter factory which uses the
 *     // greet service to demonstrate DI.
 *     $filterProvider.register('greet', function(greet){
 *       // return the filter function which uses the greet service
 *       // to generate salutation
 *       return function(text) {
 *         // filters need to be forgiving so check input validity
 *         return text && greet(text) || text;
 *       };
 *     });
 *   }
 * ```
 *
 * The filter function is registered with the `$injector` under the filter name suffix with
 * `Filter`.
 *
 * ```js
 *   it('should be the same instance', inject(
 *     function($filterProvider) {
 *       $filterProvider.register('reverse', function(){
 *         return ...;
 *       });
 *     },
 *     function($filter, reverseFilter) {
 *       expect($filter('reverse')).toBe(reverseFilter);
 *     });
 * ```
 *
 *
 * For more information about how AngularJS filters work, and how to create your own filters, see
 * {@link guide/filter Filters} in the AngularJS Developer Guide.
 */

/**
 * @ngdoc service
 * @name $filter
 * @kind function
 * @description
 * Filters are used for formatting data displayed to the user.
 *
 * They can be used in view templates, controllers or services. AngularJS comes
 * with a collection of [built-in filters](api/ng/filter), but it is easy to
 * define your own as well.
 *
 * The general syntax in templates is as follows:
 *
 * ```html
 * {{ expression [| filter_name[:parameter_value] ... ] }}
 * ```
 *
 * @param {String} name Name of the filter function to retrieve
 * @return {Function} the filter function
 * @example
   <example name="$filter" module="filterExample">
     <file name="index.html">
       <div ng-controller="MainCtrl">
        <h3>{{ originalText }}</h3>
        <h3>{{ filteredText }}</h3>
       </div>
     </file>

     <file name="script.js">
      angular.module('filterExample', [])
      .controller('MainCtrl', function($scope, $filter) {
        $scope.originalText = 'hello';
        $scope.filteredText = $filter('uppercase')($scope.originalText);
      });
     </file>
   </example>
  */
$FilterProvider.$inject = ['$provide'];
/** @this */
function $FilterProvider($provide) {
  var suffix = 'Filter';

  /**
   * @ngdoc method
   * @name $filterProvider#register
   * @param {string|Object} name Name of the filter function, or an object map of filters where
   *    the keys are the filter names and the values are the filter factories.
   *
   *    <div class="alert alert-warning">
   *    **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
   *    Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
   *    your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
   *    (`myapp_subsection_filterx`).
   *    </div>
    * @param {Function} factory If the first argument was a string, a factory function for the filter to be registered.
   * @returns {Object} Registered filter instance, or if a map of filters was provided then a map
   *    of the registered filter instances.
   */
  function register(name, factory) {
    if (isObject(name)) {
      var filters = {};
      forEach(name, function(filter, key) {
        filters[key] = register(key, filter);
      });
      return filters;
    } else {
      return $provide.factory(name + suffix, factory);
    }
  }
  this.register = register;

  this.$get = ['$injector', function($injector) {
    return function(name) {
      return $injector.get(name + suffix);
    };
  }];

  ////////////////////////////////////////

  /* global
    currencyFilter: false,
    dateFilter: false,
    filterFilter: false,
    jsonFilter: false,
    limitToFilter: false,
    lowercaseFilter: false,
    numberFilter: false,
    orderByFilter: false,
    uppercaseFilter: false
  */

  register('currency', currencyFilter);
  register('date', dateFilter);
  register('filter', filterFilter);
  register('json', jsonFilter);
  register('limitTo', limitToFilter);
  register('lowercase', lowercaseFilter);
  register('number', numberFilter);
  register('orderBy', orderByFilter);
  register('uppercase', uppercaseFilter);
}

/**
 * @ngdoc filter
 * @name filter
 * @kind function
 *
 * @description
 * Selects a subset of items from `array` and returns it as a new array.
 *
 * @param {Array} array The source array.
 * <div class="alert alert-info">
 *   **Note**: If the array contains objects that reference themselves, filtering is not possible.
 * </div>
 * @param {string|Object|function()} expression The predicate to be used for selecting items from
 *   `array`.
 *
 *   Can be one of:
 *
 *   - `string`: The string is used for matching against the contents of the `array`. All strings or
 *     objects with string properties in `array` that match this string will be returned. This also
 *     applies to nested object properties.
 *     The predicate can be negated by prefixing the string with `!`.
 *
 *   - `Object`: A pattern object can be used to filter specific properties on objects contained
 *     by `array`. For example `{name:"M", phone:"1"}` predicate will return an array of items
 *     which have property `name` containing "M" and property `phone` containing "1". A special
 *     property name (`$` by default) can be used (e.g. as in `{$: "text"}`) to accept a match
 *     against any property of the object or its nested object properties. That's equivalent to the
 *     simple substring match with a `string` as described above. The special property name can be
 *     overwritten, using the `anyPropertyKey` parameter.
 *     The predicate can be negated by prefixing the string with `!`.
 *     For example `{name: "!M"}` predicate will return an array of items which have property `name`
 *     not containing "M".
 *
 *     Note that a named property will match properties on the same level only, while the special
 *     `$` property will match properties on the same level or deeper. E.g. an array item like
 *     `{name: {first: 'John', last: 'Doe'}}` will **not** be matched by `{name: 'John'}`, but
 *     **will** be matched by `{$: 'John'}`.
 *
 *   - `function(value, index, array)`: A predicate function can be used to write arbitrary filters.
 *     The function is called for each element of the array, with the element, its index, and
 *     the entire array itself as arguments.
 *
 *     The final result is an array of those elements that the predicate returned true for.
 *
 * @param {function(actual, expected)|true|false} [comparator] Comparator which is used in
 *     determining if values retrieved using `expression` (when it is not a function) should be
 *     considered a match based on the expected value (from the filter expression) and actual
 *     value (from the object in the array).
 *
 *   Can be one of:
 *
 *   - `function(actual, expected)`:
 *     The function will be given the object value and the predicate value to compare and
 *     should return true if both values should be considered equal.
 *
 *   - `true`: A shorthand for `function(actual, expected) { return angular.equals(actual, expected)}`.
 *     This is essentially strict comparison of expected and actual.
 *
 *   - `false`: A short hand for a function which will look for a substring match in a case
 *     insensitive way. Primitive values are converted to strings. Objects are not compared against
 *     primitives, unless they have a custom `toString` method (e.g. `Date` objects).
 *
 *
 *   Defaults to `false`.
 *
 * @param {string} [anyPropertyKey] The special property name that matches against any property.
 *     By default `$`.
 *
 * @example
   <example name="filter-filter">
     <file name="index.html">
       <div ng-init="friends = [{name:'John', phone:'555-1276'},
                                {name:'Mary', phone:'800-BIG-MARY'},
                                {name:'Mike', phone:'555-4321'},
                                {name:'Adam', phone:'555-5678'},
                                {name:'Julie', phone:'555-8765'},
                                {name:'Juliette', phone:'555-5678'}]"></div>

       <label>Search: <input ng-model="searchText"></label>
       <table id="searchTextResults">
         <tr><th>Name</th><th>Phone</th></tr>
         <tr ng-repeat="friend in friends | filter:searchText">
           <td>{{friend.name}}</td>
           <td>{{friend.phone}}</td>
         </tr>
       </table>
       <hr>
       <label>Any: <input ng-model="search.$"></label> <br>
       <label>Name only <input ng-model="search.name"></label><br>
       <label>Phone only <input ng-model="search.phone"></label><br>
       <label>Equality <input type="checkbox" ng-model="strict"></label><br>
       <table id="searchObjResults">
         <tr><th>Name</th><th>Phone</th></tr>
         <tr ng-repeat="friendObj in friends | filter:search:strict">
           <td>{{friendObj.name}}</td>
           <td>{{friendObj.phone}}</td>
         </tr>
       </table>
     </file>
     <file name="protractor.js" type="protractor">
       var expectFriendNames = function(expectedNames, key) {
         element.all(by.repeater(key + ' in friends').column(key + '.name')).then(function(arr) {
           arr.forEach(function(wd, i) {
             expect(wd.getText()).toMatch(expectedNames[i]);
           });
         });
       };

       it('should search across all fields when filtering with a string', function() {
         var searchText = element(by.model('searchText'));
         searchText.clear();
         searchText.sendKeys('m');
         expectFriendNames(['Mary', 'Mike', 'Adam'], 'friend');

         searchText.clear();
         searchText.sendKeys('76');
         expectFriendNames(['John', 'Julie'], 'friend');
       });

       it('should search in specific fields when filtering with a predicate object', function() {
         var searchAny = element(by.model('search.$'));
         searchAny.clear();
         searchAny.sendKeys('i');
         expectFriendNames(['Mary', 'Mike', 'Julie', 'Juliette'], 'friendObj');
       });
       it('should use a equal comparison when comparator is true', function() {
         var searchName = element(by.model('search.name'));
         var strict = element(by.model('strict'));
         searchName.clear();
         searchName.sendKeys('Julie');
         strict.click();
         expectFriendNames(['Julie'], 'friendObj');
       });
     </file>
   </example>
 */

function filterFilter() {
  return function(array, expression, comparator, anyPropertyKey) {
    if (!isArrayLike(array)) {
      if (array == null) {
        return array;
      } else {
        throw minErr('filter')('notarray', 'Expected array but received: {0}', array);
      }
    }

    anyPropertyKey = anyPropertyKey || '$';
    var expressionType = getTypeForFilter(expression);
    var predicateFn;
    var matchAgainstAnyProp;

    switch (expressionType) {
      case 'function':
        predicateFn = expression;
        break;
      case 'boolean':
      case 'null':
      case 'number':
      case 'string':
        matchAgainstAnyProp = true;
        // falls through
      case 'object':
        predicateFn = createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp);
        break;
      default:
        return array;
    }

    return Array.prototype.filter.call(array, predicateFn);
  };
}

// Helper functions for `filterFilter`
function createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp) {
  var shouldMatchPrimitives = isObject(expression) && (anyPropertyKey in expression);
  var predicateFn;

  if (comparator === true) {
    comparator = equals;
  } else if (!isFunction(comparator)) {
    comparator = function(actual, expected) {
      if (isUndefined(actual)) {
        // No substring matching against `undefined`
        return false;
      }
      if ((actual === null) || (expected === null)) {
        // No substring matching against `null`; only match against `null`
        return actual === expected;
      }
      if (isObject(expected) || (isObject(actual) && !hasCustomToString(actual))) {
        // Should not compare primitives against objects, unless they have custom `toString` method
        return false;
      }

      actual = lowercase('' + actual);
      expected = lowercase('' + expected);
      return actual.indexOf(expected) !== -1;
    };
  }

  predicateFn = function(item) {
    if (shouldMatchPrimitives && !isObject(item)) {
      return deepCompare(item, expression[anyPropertyKey], comparator, anyPropertyKey, false);
    }
    return deepCompare(item, expression, comparator, anyPropertyKey, matchAgainstAnyProp);
  };

  return predicateFn;
}

function deepCompare(actual, expected, comparator, anyPropertyKey, matchAgainstAnyProp, dontMatchWholeObject) {
  var actualType = getTypeForFilter(actual);
  var expectedType = getTypeForFilter(expected);

  if ((expectedType === 'string') && (expected.charAt(0) === '!')) {
    return !deepCompare(actual, expected.substring(1), comparator, anyPropertyKey, matchAgainstAnyProp);
  } else if (isArray(actual)) {
    // In case `actual` is an array, consider it a match
    // if ANY of it's items matches `expected`
    return actual.some(function(item) {
      return deepCompare(item, expected, comparator, anyPropertyKey, matchAgainstAnyProp);
    });
  }

  switch (actualType) {
    case 'object':
      var key;
      if (matchAgainstAnyProp) {
        for (key in actual) {
          // Under certain, rare, circumstances, key may not be a string and `charAt` will be undefined
          // See: https://github.com/angular/angular.js/issues/15644
          if (key.charAt && (key.charAt(0) !== '$') &&
              deepCompare(actual[key], expected, comparator, anyPropertyKey, true)) {
            return true;
          }
        }
        return dontMatchWholeObject ? false : deepCompare(actual, expected, comparator, anyPropertyKey, false);
      } else if (expectedType === 'object') {
        for (key in expected) {
          var expectedVal = expected[key];
          if (isFunction(expectedVal) || isUndefined(expectedVal)) {
            continue;
          }

          var matchAnyProperty = key === anyPropertyKey;
          var actualVal = matchAnyProperty ? actual : actual[key];
          if (!deepCompare(actualVal, expectedVal, comparator, anyPropertyKey, matchAnyProperty, matchAnyProperty)) {
            return false;
          }
        }
        return true;
      } else {
        return comparator(actual, expected);
      }
    case 'function':
      return false;
    default:
      return comparator(actual, expected);
  }
}

// Used for easily differentiating between `null` and actual `object`
function getTypeForFilter(val) {
  return (val === null) ? 'null' : typeof val;
}

var MAX_DIGITS = 22;
var DECIMAL_SEP = '.';
var ZERO_CHAR = '0';

/**
 * @ngdoc filter
 * @name currency
 * @kind function
 *
 * @description
 * Formats a number as a currency (ie $1,234.56). When no currency symbol is provided, default
 * symbol for current locale is used.
 *
 * @param {number} amount Input to filter.
 * @param {string=} symbol Currency symbol or identifier to be displayed.
 * @param {number=} fractionSize Number of decimal places to round the amount to, defaults to default max fraction size for current locale
 * @returns {string} Formatted number.
 *
 *
 * @example
   <example module="currencyExample" name="currency-filter">
     <file name="index.html">
       <script>
         angular.module('currencyExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.amount = 1234.56;
           }]);
       </script>
       <div ng-controller="ExampleController">
         <input type="number" ng-model="amount" aria-label="amount"> <br>
         default currency symbol ($): <span id="currency-default">{{amount | currency}}</span><br>
         custom currency identifier (USD$): <span id="currency-custom">{{amount | currency:"USD$"}}</span><br>
         no fractions (0): <span id="currency-no-fractions">{{amount | currency:"USD$":0}}</span>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should init with 1234.56', function() {
         expect(element(by.id('currency-default')).getText()).toBe('$1,234.56');
         expect(element(by.id('currency-custom')).getText()).toBe('USD$1,234.56');
         expect(element(by.id('currency-no-fractions')).getText()).toBe('USD$1,235');
       });
       it('should update', function() {
         if (browser.params.browser === 'safari') {
           // Safari does not understand the minus key. See
           // https://github.com/angular/protractor/issues/481
           return;
         }
         element(by.model('amount')).clear();
         element(by.model('amount')).sendKeys('-1234');
         expect(element(by.id('currency-default')).getText()).toBe('-$1,234.00');
         expect(element(by.id('currency-custom')).getText()).toBe('-USD$1,234.00');
         expect(element(by.id('currency-no-fractions')).getText()).toBe('-USD$1,234');
       });
     </file>
   </example>
 */
currencyFilter.$inject = ['$locale'];
function currencyFilter($locale) {
  var formats = $locale.NUMBER_FORMATS;
  return function(amount, currencySymbol, fractionSize) {
    if (isUndefined(currencySymbol)) {
      currencySymbol = formats.CURRENCY_SYM;
    }

    if (isUndefined(fractionSize)) {
      fractionSize = formats.PATTERNS[1].maxFrac;
    }

    // If the currency symbol is empty, trim whitespace around the symbol
    var currencySymbolRe = !currencySymbol ? /\s*\u00A4\s*/g : /\u00A4/g;

    // if null or undefined pass it through
    return (amount == null)
        ? amount
        : formatNumber(amount, formats.PATTERNS[1], formats.GROUP_SEP, formats.DECIMAL_SEP, fractionSize).
            replace(currencySymbolRe, currencySymbol);
  };
}

/**
 * @ngdoc filter
 * @name number
 * @kind function
 *
 * @description
 * Formats a number as text.
 *
 * If the input is null or undefined, it will just be returned.
 * If the input is infinite (Infinity or -Infinity), the Infinity symbol '∞' or '-∞' is returned, respectively.
 * If the input is not a number an empty string is returned.
 *
 *
 * @param {number|string} number Number to format.
 * @param {(number|string)=} fractionSize Number of decimal places to round the number to.
 * If this is not provided then the fraction size is computed from the current locale's number
 * formatting pattern. In the case of the default locale, it will be 3.
 * @returns {string} Number rounded to `fractionSize` appropriately formatted based on the current
 *                   locale (e.g., in the en_US locale it will have "." as the decimal separator and
 *                   include "," group separators after each third digit).
 *
 * @example
   <example module="numberFilterExample" name="number-filter">
     <file name="index.html">
       <script>
         angular.module('numberFilterExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.val = 1234.56789;
           }]);
       </script>
       <div ng-controller="ExampleController">
         <label>Enter number: <input ng-model='val'></label><br>
         Default formatting: <span id='number-default'>{{val | number}}</span><br>
         No fractions: <span>{{val | number:0}}</span><br>
         Negative number: <span>{{-val | number:4}}</span>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should format numbers', function() {
         expect(element(by.id('number-default')).getText()).toBe('1,234.568');
         expect(element(by.binding('val | number:0')).getText()).toBe('1,235');
         expect(element(by.binding('-val | number:4')).getText()).toBe('-1,234.5679');
       });

       it('should update', function() {
         element(by.model('val')).clear();
         element(by.model('val')).sendKeys('3374.333');
         expect(element(by.id('number-default')).getText()).toBe('3,374.333');
         expect(element(by.binding('val | number:0')).getText()).toBe('3,374');
         expect(element(by.binding('-val | number:4')).getText()).toBe('-3,374.3330');
      });
     </file>
   </example>
 */
numberFilter.$inject = ['$locale'];
function numberFilter($locale) {
  var formats = $locale.NUMBER_FORMATS;
  return function(number, fractionSize) {

    // if null or undefined pass it through
    return (number == null)
        ? number
        : formatNumber(number, formats.PATTERNS[0], formats.GROUP_SEP, formats.DECIMAL_SEP,
                       fractionSize);
  };
}

/**
 * Parse a number (as a string) into three components that can be used
 * for formatting the number.
 *
 * (Significant bits of this parse algorithm came from https://github.com/MikeMcl/big.js/)
 *
 * @param  {string} numStr The number to parse
 * @return {object} An object describing this number, containing the following keys:
 *  - d : an array of digits containing leading zeros as necessary
 *  - i : the number of the digits in `d` that are to the left of the decimal point
 *  - e : the exponent for numbers that would need more than `MAX_DIGITS` digits in `d`
 *
 */
function parse(numStr) {
  var exponent = 0, digits, numberOfIntegerDigits;
  var i, j, zeros;

  // Decimal point?
  if ((numberOfIntegerDigits = numStr.indexOf(DECIMAL_SEP)) > -1) {
    numStr = numStr.replace(DECIMAL_SEP, '');
  }

  // Exponential form?
  if ((i = numStr.search(/e/i)) > 0) {
    // Work out the exponent.
    if (numberOfIntegerDigits < 0) numberOfIntegerDigits = i;
    numberOfIntegerDigits += +numStr.slice(i + 1);
    numStr = numStr.substring(0, i);
  } else if (numberOfIntegerDigits < 0) {
    // There was no decimal point or exponent so it is an integer.
    numberOfIntegerDigits = numStr.length;
  }

  // Count the number of leading zeros.
  for (i = 0; numStr.charAt(i) === ZERO_CHAR; i++) { /* empty */ }

  if (i === (zeros = numStr.length)) {
    // The digits are all zero.
    digits = [0];
    numberOfIntegerDigits = 1;
  } else {
    // Count the number of trailing zeros
    zeros--;
    while (numStr.charAt(zeros) === ZERO_CHAR) zeros--;

    // Trailing zeros are insignificant so ignore them
    numberOfIntegerDigits -= i;
    digits = [];
    // Convert string to array of digits without leading/trailing zeros.
    for (j = 0; i <= zeros; i++, j++) {
      digits[j] = +numStr.charAt(i);
    }
  }

  // If the number overflows the maximum allowed digits then use an exponent.
  if (numberOfIntegerDigits > MAX_DIGITS) {
    digits = digits.splice(0, MAX_DIGITS - 1);
    exponent = numberOfIntegerDigits - 1;
    numberOfIntegerDigits = 1;
  }

  return { d: digits, e: exponent, i: numberOfIntegerDigits };
}

/**
 * Round the parsed number to the specified number of decimal places
 * This function changed the parsedNumber in-place
 */
function roundNumber(parsedNumber, fractionSize, minFrac, maxFrac) {
    var digits = parsedNumber.d;
    var fractionLen = digits.length - parsedNumber.i;

    // determine fractionSize if it is not specified; `+fractionSize` converts it to a number
    fractionSize = (isUndefined(fractionSize)) ? Math.min(Math.max(minFrac, fractionLen), maxFrac) : +fractionSize;

    // The index of the digit to where rounding is to occur
    var roundAt = fractionSize + parsedNumber.i;
    var digit = digits[roundAt];

    if (roundAt > 0) {
      // Drop fractional digits beyond `roundAt`
      digits.splice(Math.max(parsedNumber.i, roundAt));

      // Set non-fractional digits beyond `roundAt` to 0
      for (var j = roundAt; j < digits.length; j++) {
        digits[j] = 0;
      }
    } else {
      // We rounded to zero so reset the parsedNumber
      fractionLen = Math.max(0, fractionLen);
      parsedNumber.i = 1;
      digits.length = Math.max(1, roundAt = fractionSize + 1);
      digits[0] = 0;
      for (var i = 1; i < roundAt; i++) digits[i] = 0;
    }

    if (digit >= 5) {
      if (roundAt - 1 < 0) {
        for (var k = 0; k > roundAt; k--) {
          digits.unshift(0);
          parsedNumber.i++;
        }
        digits.unshift(1);
        parsedNumber.i++;
      } else {
        digits[roundAt - 1]++;
      }
    }

    // Pad out with zeros to get the required fraction length
    for (; fractionLen < Math.max(0, fractionSize); fractionLen++) digits.push(0);


    // Do any carrying, e.g. a digit was rounded up to 10
    var carry = digits.reduceRight(function(carry, d, i, digits) {
      d = d + carry;
      digits[i] = d % 10;
      return Math.floor(d / 10);
    }, 0);
    if (carry) {
      digits.unshift(carry);
      parsedNumber.i++;
    }
}

/**
 * Format a number into a string
 * @param  {number} number       The number to format
 * @param  {{
 *           minFrac, // the minimum number of digits required in the fraction part of the number
 *           maxFrac, // the maximum number of digits required in the fraction part of the number
 *           gSize,   // number of digits in each group of separated digits
 *           lgSize,  // number of digits in the last group of digits before the decimal separator
 *           negPre,  // the string to go in front of a negative number (e.g. `-` or `(`))
 *           posPre,  // the string to go in front of a positive number
 *           negSuf,  // the string to go after a negative number (e.g. `)`)
 *           posSuf   // the string to go after a positive number
 *         }} pattern
 * @param  {string} groupSep     The string to separate groups of number (e.g. `,`)
 * @param  {string} decimalSep   The string to act as the decimal separator (e.g. `.`)
 * @param  {[type]} fractionSize The size of the fractional part of the number
 * @return {string}              The number formatted as a string
 */
function formatNumber(number, pattern, groupSep, decimalSep, fractionSize) {

  if (!(isString(number) || isNumber(number)) || isNaN(number)) return '';

  var isInfinity = !isFinite(number);
  var isZero = false;
  var numStr = Math.abs(number) + '',
      formattedText = '',
      parsedNumber;

  if (isInfinity) {
    formattedText = '\u221e';
  } else {
    parsedNumber = parse(numStr);

    roundNumber(parsedNumber, fractionSize, pattern.minFrac, pattern.maxFrac);

    var digits = parsedNumber.d;
    var integerLen = parsedNumber.i;
    var exponent = parsedNumber.e;
    var decimals = [];
    isZero = digits.reduce(function(isZero, d) { return isZero && !d; }, true);

    // pad zeros for small numbers
    while (integerLen < 0) {
      digits.unshift(0);
      integerLen++;
    }

    // extract decimals digits
    if (integerLen > 0) {
      decimals = digits.splice(integerLen, digits.length);
    } else {
      decimals = digits;
      digits = [0];
    }

    // format the integer digits with grouping separators
    var groups = [];
    if (digits.length >= pattern.lgSize) {
      groups.unshift(digits.splice(-pattern.lgSize, digits.length).join(''));
    }
    while (digits.length > pattern.gSize) {
      groups.unshift(digits.splice(-pattern.gSize, digits.length).join(''));
    }
    if (digits.length) {
      groups.unshift(digits.join(''));
    }
    formattedText = groups.join(groupSep);

    // append the decimal digits
    if (decimals.length) {
      formattedText += decimalSep + decimals.join('');
    }

    if (exponent) {
      formattedText += 'e+' + exponent;
    }
  }
  if (number < 0 && !isZero) {
    return pattern.negPre + formattedText + pattern.negSuf;
  } else {
    return pattern.posPre + formattedText + pattern.posSuf;
  }
}

function padNumber(num, digits, trim, negWrap) {
  var neg = '';
  if (num < 0 || (negWrap && num <= 0)) {
    if (negWrap) {
      num = -num + 1;
    } else {
      num = -num;
      neg = '-';
    }
  }
  num = '' + num;
  while (num.length < digits) num = ZERO_CHAR + num;
  if (trim) {
    num = num.substr(num.length - digits);
  }
  return neg + num;
}


function dateGetter(name, size, offset, trim, negWrap) {
  offset = offset || 0;
  return function(date) {
    var value = date['get' + name]();
    if (offset > 0 || value > -offset) {
      value += offset;
    }
    if (value === 0 && offset === -12) value = 12;
    return padNumber(value, size, trim, negWrap);
  };
}

function dateStrGetter(name, shortForm, standAlone) {
  return function(date, formats) {
    var value = date['get' + name]();
    var propPrefix = (standAlone ? 'STANDALONE' : '') + (shortForm ? 'SHORT' : '');
    var get = uppercase(propPrefix + name);

    return formats[get][value];
  };
}

function timeZoneGetter(date, formats, offset) {
  var zone = -1 * offset;
  var paddedZone = (zone >= 0) ? '+' : '';

  paddedZone += padNumber(Math[zone > 0 ? 'floor' : 'ceil'](zone / 60), 2) +
                padNumber(Math.abs(zone % 60), 2);

  return paddedZone;
}

function getFirstThursdayOfYear(year) {
    // 0 = index of January
    var dayOfWeekOnFirst = (new Date(year, 0, 1)).getDay();
    // 4 = index of Thursday (+1 to account for 1st = 5)
    // 11 = index of *next* Thursday (+1 account for 1st = 12)
    return new Date(year, 0, ((dayOfWeekOnFirst <= 4) ? 5 : 12) - dayOfWeekOnFirst);
}

function getThursdayThisWeek(datetime) {
    return new Date(datetime.getFullYear(), datetime.getMonth(),
      // 4 = index of Thursday
      datetime.getDate() + (4 - datetime.getDay()));
}

function weekGetter(size) {
   return function(date) {
      var firstThurs = getFirstThursdayOfYear(date.getFullYear()),
         thisThurs = getThursdayThisWeek(date);

      var diff = +thisThurs - +firstThurs,
         result = 1 + Math.round(diff / 6.048e8); // 6.048e8 ms per week

      return padNumber(result, size);
   };
}

function ampmGetter(date, formats) {
  return date.getHours() < 12 ? formats.AMPMS[0] : formats.AMPMS[1];
}

function eraGetter(date, formats) {
  return date.getFullYear() <= 0 ? formats.ERAS[0] : formats.ERAS[1];
}

function longEraGetter(date, formats) {
  return date.getFullYear() <= 0 ? formats.ERANAMES[0] : formats.ERANAMES[1];
}

var DATE_FORMATS = {
  yyyy: dateGetter('FullYear', 4, 0, false, true),
    yy: dateGetter('FullYear', 2, 0, true, true),
     y: dateGetter('FullYear', 1, 0, false, true),
  MMMM: dateStrGetter('Month'),
   MMM: dateStrGetter('Month', true),
    MM: dateGetter('Month', 2, 1),
     M: dateGetter('Month', 1, 1),
  LLLL: dateStrGetter('Month', false, true),
    dd: dateGetter('Date', 2),
     d: dateGetter('Date', 1),
    HH: dateGetter('Hours', 2),
     H: dateGetter('Hours', 1),
    hh: dateGetter('Hours', 2, -12),
     h: dateGetter('Hours', 1, -12),
    mm: dateGetter('Minutes', 2),
     m: dateGetter('Minutes', 1),
    ss: dateGetter('Seconds', 2),
     s: dateGetter('Seconds', 1),
     // while ISO 8601 requires fractions to be prefixed with `.` or `,`
     // we can be just safely rely on using `sss` since we currently don't support single or two digit fractions
   sss: dateGetter('Milliseconds', 3),
  EEEE: dateStrGetter('Day'),
   EEE: dateStrGetter('Day', true),
     a: ampmGetter,
     Z: timeZoneGetter,
    ww: weekGetter(2),
     w: weekGetter(1),
     G: eraGetter,
     GG: eraGetter,
     GGG: eraGetter,
     GGGG: longEraGetter
};

var DATE_FORMATS_SPLIT = /((?:[^yMLdHhmsaZEwG']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|L+|d+|H+|h+|m+|s+|a|Z|G+|w+))([\s\S]*)/,
    NUMBER_STRING = /^-?\d+$/;

/**
 * @ngdoc filter
 * @name date
 * @kind function
 *
 * @description
 *   Formats `date` to a string based on the requested `format`.
 *
 *   `format` string can be composed of the following elements:
 *
 *   * `'yyyy'`: 4 digit representation of year (e.g. AD 1 => 0001, AD 2010 => 2010)
 *   * `'yy'`: 2 digit representation of year, padded (00-99). (e.g. AD 2001 => 01, AD 2010 => 10)
 *   * `'y'`: 1 digit representation of year, e.g. (AD 1 => 1, AD 199 => 199)
 *   * `'MMMM'`: Month in year (January-December)
 *   * `'MMM'`: Month in year (Jan-Dec)
 *   * `'MM'`: Month in year, padded (01-12)
 *   * `'M'`: Month in year (1-12)
 *   * `'LLLL'`: Stand-alone month in year (January-December)
 *   * `'dd'`: Day in month, padded (01-31)
 *   * `'d'`: Day in month (1-31)
 *   * `'EEEE'`: Day in Week,(Sunday-Saturday)
 *   * `'EEE'`: Day in Week, (Sun-Sat)
 *   * `'HH'`: Hour in day, padded (00-23)
 *   * `'H'`: Hour in day (0-23)
 *   * `'hh'`: Hour in AM/PM, padded (01-12)
 *   * `'h'`: Hour in AM/PM, (1-12)
 *   * `'mm'`: Minute in hour, padded (00-59)
 *   * `'m'`: Minute in hour (0-59)
 *   * `'ss'`: Second in minute, padded (00-59)
 *   * `'s'`: Second in minute (0-59)
 *   * `'sss'`: Millisecond in second, padded (000-999)
 *   * `'a'`: AM/PM marker
 *   * `'Z'`: 4 digit (+sign) representation of the timezone offset (-1200-+1200)
 *   * `'ww'`: Week of year, padded (00-53). Week 01 is the week with the first Thursday of the year
 *   * `'w'`: Week of year (0-53). Week 1 is the week with the first Thursday of the year
 *   * `'G'`, `'GG'`, `'GGG'`: The abbreviated form of the era string (e.g. 'AD')
 *   * `'GGGG'`: The long form of the era string (e.g. 'Anno Domini')
 *
 *   `format` string can also be one of the following predefined
 *   {@link guide/i18n localizable formats}:
 *
 *   * `'medium'`: equivalent to `'MMM d, y h:mm:ss a'` for en_US locale
 *     (e.g. Sep 3, 2010 12:05:08 PM)
 *   * `'short'`: equivalent to `'M/d/yy h:mm a'` for en_US  locale (e.g. 9/3/10 12:05 PM)
 *   * `'fullDate'`: equivalent to `'EEEE, MMMM d, y'` for en_US  locale
 *     (e.g. Friday, September 3, 2010)
 *   * `'longDate'`: equivalent to `'MMMM d, y'` for en_US  locale (e.g. September 3, 2010)
 *   * `'mediumDate'`: equivalent to `'MMM d, y'` for en_US  locale (e.g. Sep 3, 2010)
 *   * `'shortDate'`: equivalent to `'M/d/yy'` for en_US locale (e.g. 9/3/10)
 *   * `'mediumTime'`: equivalent to `'h:mm:ss a'` for en_US locale (e.g. 12:05:08 PM)
 *   * `'shortTime'`: equivalent to `'h:mm a'` for en_US locale (e.g. 12:05 PM)
 *
 *   `format` string can contain literal values. These need to be escaped by surrounding with single quotes (e.g.
 *   `"h 'in the morning'"`). In order to output a single quote, escape it - i.e., two single quotes in a sequence
 *   (e.g. `"h 'o''clock'"`).
 *
 *   Any other characters in the `format` string will be output as-is.
 *
 * @param {(Date|number|string)} date Date to format either as Date object, milliseconds (string or
 *    number) or various ISO 8601 datetime string formats (e.g. yyyy-MM-ddTHH:mm:ss.sssZ and its
 *    shorter versions like yyyy-MM-ddTHH:mmZ, yyyy-MM-dd or yyyyMMddTHHmmssZ). If no timezone is
 *    specified in the string input, the time is considered to be in the local timezone.
 * @param {string=} format Formatting rules (see Description). If not specified,
 *    `mediumDate` is used.
 * @param {string=} timezone Timezone to be used for formatting. It understands UTC/GMT and the
 *    continental US time zone abbreviations, but for general use, use a time zone offset, for
 *    example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
 *    If not specified, the timezone of the browser will be used.
 * @returns {string} Formatted string or the input if input is not recognized as date/millis.
 *
 * @example
   <example name="filter-date">
     <file name="index.html">
       <span ng-non-bindable>{{1288323623006 | date:'medium'}}</span>:
           <span>{{1288323623006 | date:'medium'}}</span><br>
       <span ng-non-bindable>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span>:
          <span>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span><br>
       <span ng-non-bindable>{{1288323623006 | date:'MM/dd/yyyy @ h:mma'}}</span>:
          <span>{{'1288323623006' | date:'MM/dd/yyyy @ h:mma'}}</span><br>
       <span ng-non-bindable>{{1288323623006 | date:"MM/dd/yyyy 'at' h:mma"}}</span>:
          <span>{{'1288323623006' | date:"MM/dd/yyyy 'at' h:mma"}}</span><br>
     </file>
     <file name="protractor.js" type="protractor">
       it('should format date', function() {
         expect(element(by.binding("1288323623006 | date:'medium'")).getText()).
            toMatch(/Oct 2\d, 2010 \d{1,2}:\d{2}:\d{2} (AM|PM)/);
         expect(element(by.binding("1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'")).getText()).
            toMatch(/2010-10-2\d \d{2}:\d{2}:\d{2} (-|\+)?\d{4}/);
         expect(element(by.binding("'1288323623006' | date:'MM/dd/yyyy @ h:mma'")).getText()).
            toMatch(/10\/2\d\/2010 @ \d{1,2}:\d{2}(AM|PM)/);
         expect(element(by.binding("'1288323623006' | date:\"MM/dd/yyyy 'at' h:mma\"")).getText()).
            toMatch(/10\/2\d\/2010 at \d{1,2}:\d{2}(AM|PM)/);
       });
     </file>
   </example>
 */
dateFilter.$inject = ['$locale'];
function dateFilter($locale) {


  var R_ISO8601_STR = /^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;
                     // 1        2       3         4          5          6          7          8  9     10      11
  function jsonStringToDate(string) {
    var match;
    if ((match = string.match(R_ISO8601_STR))) {
      var date = new Date(0),
          tzHour = 0,
          tzMin  = 0,
          dateSetter = match[8] ? date.setUTCFullYear : date.setFullYear,
          timeSetter = match[8] ? date.setUTCHours : date.setHours;

      if (match[9]) {
        tzHour = toInt(match[9] + match[10]);
        tzMin = toInt(match[9] + match[11]);
      }
      dateSetter.call(date, toInt(match[1]), toInt(match[2]) - 1, toInt(match[3]));
      var h = toInt(match[4] || 0) - tzHour;
      var m = toInt(match[5] || 0) - tzMin;
      var s = toInt(match[6] || 0);
      var ms = Math.round(parseFloat('0.' + (match[7] || 0)) * 1000);
      timeSetter.call(date, h, m, s, ms);
      return date;
    }
    return string;
  }


  return function(date, format, timezone) {
    var text = '',
        parts = [],
        fn, match;

    format = format || 'mediumDate';
    format = $locale.DATETIME_FORMATS[format] || format;
    if (isString(date)) {
      date = NUMBER_STRING.test(date) ? toInt(date) : jsonStringToDate(date);
    }

    if (isNumber(date)) {
      date = new Date(date);
    }

    if (!isDate(date) || !isFinite(date.getTime())) {
      return date;
    }

    while (format) {
      match = DATE_FORMATS_SPLIT.exec(format);
      if (match) {
        parts = concat(parts, match, 1);
        format = parts.pop();
      } else {
        parts.push(format);
        format = null;
      }
    }

    var dateTimezoneOffset = date.getTimezoneOffset();
    if (timezone) {
      dateTimezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
      date = convertTimezoneToLocal(date, timezone, true);
    }
    forEach(parts, function(value) {
      fn = DATE_FORMATS[value];
      text += fn ? fn(date, $locale.DATETIME_FORMATS, dateTimezoneOffset)
                 : value === '\'\'' ? '\'' : value.replace(/(^'|'$)/g, '').replace(/''/g, '\'');
    });

    return text;
  };
}


/**
 * @ngdoc filter
 * @name json
 * @kind function
 *
 * @description
 *   Allows you to convert a JavaScript object into JSON string.
 *
 *   This filter is mostly useful for debugging. When using the double curly {{value}} notation
 *   the binding is automatically converted to JSON.
 *
 * @param {*} object Any JavaScript object (including arrays and primitive types) to filter.
 * @param {number=} spacing The number of spaces to use per indentation, defaults to 2.
 * @returns {string} JSON string.
 *
 *
 * @example
   <example name="filter-json">
     <file name="index.html">
       <pre id="default-spacing">{{ {'name':'value'} | json }}</pre>
       <pre id="custom-spacing">{{ {'name':'value'} | json:4 }}</pre>
     </file>
     <file name="protractor.js" type="protractor">
       it('should jsonify filtered objects', function() {
         expect(element(by.id('default-spacing')).getText()).toMatch(/\{\n {2}"name": ?"value"\n}/);
         expect(element(by.id('custom-spacing')).getText()).toMatch(/\{\n {4}"name": ?"value"\n}/);
       });
     </file>
   </example>
 *
 */
function jsonFilter() {
  return function(object, spacing) {
    if (isUndefined(spacing)) {
        spacing = 2;
    }
    return toJson(object, spacing);
  };
}


/**
 * @ngdoc filter
 * @name lowercase
 * @kind function
 * @description
 * Converts string to lowercase.
 *
 * See the {@link ng.uppercase uppercase filter documentation} for a functionally identical example.
 *
 * @see angular.lowercase
 */
var lowercaseFilter = valueFn(lowercase);


/**
 * @ngdoc filter
 * @name uppercase
 * @kind function
 * @description
 * Converts string to uppercase.
 * @example
   <example module="uppercaseFilterExample" name="filter-uppercase">
     <file name="index.html">
       <script>
         angular.module('uppercaseFilterExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.title = 'This is a title';
           }]);
       </script>
       <div ng-controller="ExampleController">
         <!-- This title should be formatted normally -->
         <h1>{{title}}</h1>
         <!-- This title should be capitalized -->
         <h1>{{title | uppercase}}</h1>
       </div>
     </file>
   </example>
 */
var uppercaseFilter = valueFn(uppercase);

/**
 * @ngdoc filter
 * @name limitTo
 * @kind function
 *
 * @description
 * Creates a new array or string containing only a specified number of elements. The elements are
 * taken from either the beginning or the end of the source array, string or number, as specified by
 * the value and sign (positive or negative) of `limit`. Other array-like objects are also supported
 * (e.g. array subclasses, NodeLists, jqLite/jQuery collections etc). If a number is used as input,
 * it is converted to a string.
 *
 * @param {Array|ArrayLike|string|number} input - Array/array-like, string or number to be limited.
 * @param {string|number} limit - The length of the returned array or string. If the `limit` number
 *     is positive, `limit` number of items from the beginning of the source array/string are copied.
 *     If the number is negative, `limit` number  of items from the end of the source array/string
 *     are copied. The `limit` will be trimmed if it exceeds `array.length`. If `limit` is undefined,
 *     the input will be returned unchanged.
 * @param {(string|number)=} begin - Index at which to begin limitation. As a negative index,
 *     `begin` indicates an offset from the end of `input`. Defaults to `0`.
 * @returns {Array|string} A new sub-array or substring of length `limit` or less if the input had
 *     less than `limit` elements.
 *
 * @example
   <example module="limitToExample" name="limit-to-filter">
     <file name="index.html">
       <script>
         angular.module('limitToExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.numbers = [1,2,3,4,5,6,7,8,9];
             $scope.letters = "abcdefghi";
             $scope.longNumber = 2345432342;
             $scope.numLimit = 3;
             $scope.letterLimit = 3;
             $scope.longNumberLimit = 3;
           }]);
       </script>
       <div ng-controller="ExampleController">
         <label>
            Limit {{numbers}} to:
            <input type="number" step="1" ng-model="numLimit">
         </label>
         <p>Output numbers: {{ numbers | limitTo:numLimit }}</p>
         <label>
            Limit {{letters}} to:
            <input type="number" step="1" ng-model="letterLimit">
         </label>
         <p>Output letters: {{ letters | limitTo:letterLimit }}</p>
         <label>
            Limit {{longNumber}} to:
            <input type="number" step="1" ng-model="longNumberLimit">
         </label>
         <p>Output long number: {{ longNumber | limitTo:longNumberLimit }}</p>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       var numLimitInput = element(by.model('numLimit'));
       var letterLimitInput = element(by.model('letterLimit'));
       var longNumberLimitInput = element(by.model('longNumberLimit'));
       var limitedNumbers = element(by.binding('numbers | limitTo:numLimit'));
       var limitedLetters = element(by.binding('letters | limitTo:letterLimit'));
       var limitedLongNumber = element(by.binding('longNumber | limitTo:longNumberLimit'));

       it('should limit the number array to first three items', function() {
         expect(numLimitInput.getAttribute('value')).toBe('3');
         expect(letterLimitInput.getAttribute('value')).toBe('3');
         expect(longNumberLimitInput.getAttribute('value')).toBe('3');
         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3]');
         expect(limitedLetters.getText()).toEqual('Output letters: abc');
         expect(limitedLongNumber.getText()).toEqual('Output long number: 234');
       });

       // There is a bug in safari and protractor that doesn't like the minus key
       // it('should update the output when -3 is entered', function() {
       //   numLimitInput.clear();
       //   numLimitInput.sendKeys('-3');
       //   letterLimitInput.clear();
       //   letterLimitInput.sendKeys('-3');
       //   longNumberLimitInput.clear();
       //   longNumberLimitInput.sendKeys('-3');
       //   expect(limitedNumbers.getText()).toEqual('Output numbers: [7,8,9]');
       //   expect(limitedLetters.getText()).toEqual('Output letters: ghi');
       //   expect(limitedLongNumber.getText()).toEqual('Output long number: 342');
       // });

       it('should not exceed the maximum size of input array', function() {
         numLimitInput.clear();
         numLimitInput.sendKeys('100');
         letterLimitInput.clear();
         letterLimitInput.sendKeys('100');
         longNumberLimitInput.clear();
         longNumberLimitInput.sendKeys('100');
         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3,4,5,6,7,8,9]');
         expect(limitedLetters.getText()).toEqual('Output letters: abcdefghi');
         expect(limitedLongNumber.getText()).toEqual('Output long number: 2345432342');
       });
     </file>
   </example>
*/
function limitToFilter() {
  return function(input, limit, begin) {
    if (Math.abs(Number(limit)) === Infinity) {
      limit = Number(limit);
    } else {
      limit = toInt(limit);
    }
    if (isNumberNaN(limit)) return input;

    if (isNumber(input)) input = input.toString();
    if (!isArrayLike(input)) return input;

    begin = (!begin || isNaN(begin)) ? 0 : toInt(begin);
    begin = (begin < 0) ? Math.max(0, input.length + begin) : begin;

    if (limit >= 0) {
      return sliceFn(input, begin, begin + limit);
    } else {
      if (begin === 0) {
        return sliceFn(input, limit, input.length);
      } else {
        return sliceFn(input, Math.max(0, begin + limit), begin);
      }
    }
  };
}

function sliceFn(input, begin, end) {
  if (isString(input)) return input.slice(begin, end);

  return slice.call(input, begin, end);
}

/**
 * @ngdoc filter
 * @name orderBy
 * @kind function
 *
 * @description
 * Returns an array containing the items from the specified `collection`, ordered by a `comparator`
 * function based on the values computed using the `expression` predicate.
 *
 * For example, `[{id: 'foo'}, {id: 'bar'}] | orderBy:'id'` would result in
 * `[{id: 'bar'}, {id: 'foo'}]`.
 *
 * The `collection` can be an Array or array-like object (e.g. NodeList, jQuery object, TypedArray,
 * String, etc).
 *
 * The `expression` can be a single predicate, or a list of predicates each serving as a tie-breaker
 * for the preceding one. The `expression` is evaluated against each item and the output is used
 * for comparing with other items.
 *
 * You can change the sorting order by setting `reverse` to `true`. By default, items are sorted in
 * ascending order.
 *
 * The comparison is done using the `comparator` function. If none is specified, a default, built-in
 * comparator is used (see below for details - in a nutshell, it compares numbers numerically and
 * strings alphabetically).
 *
 * ### Under the hood
 *
 * Ordering the specified `collection` happens in two phases:
 *
 * 1. All items are passed through the predicate (or predicates), and the returned values are saved
 *    along with their type (`string`, `number` etc). For example, an item `{label: 'foo'}`, passed
 *    through a predicate that extracts the value of the `label` property, would be transformed to:
 *    ```
 *    {
 *      value: 'foo',
 *      type: 'string',
 *      index: ...
 *    }
 *    ```
 *    **Note:** `null` values use `'null'` as their type.
 * 2. The comparator function is used to sort the items, based on the derived values, types and
 *    indices.
 *
 * If you use a custom comparator, it will be called with pairs of objects of the form
 * `{value: ..., type: '...', index: ...}` and is expected to return `0` if the objects are equal
 * (as far as the comparator is concerned), `-1` if the 1st one should be ranked higher than the
 * second, or `1` otherwise.
 *
 * In order to ensure that the sorting will be deterministic across platforms, if none of the
 * specified predicates can distinguish between two items, `orderBy` will automatically introduce a
 * dummy predicate that returns the item's index as `value`.
 * (If you are using a custom comparator, make sure it can handle this predicate as well.)
 *
 * If a custom comparator still can't distinguish between two items, then they will be sorted based
 * on their index using the built-in comparator.
 *
 * Finally, in an attempt to simplify things, if a predicate returns an object as the extracted
 * value for an item, `orderBy` will try to convert that object to a primitive value, before passing
 * it to the comparator. The following rules govern the conversion:
 *
 * 1. If the object has a `valueOf()` method that returns a primitive, its return value will be
 *    used instead.<br />
 *    (If the object has a `valueOf()` method that returns another object, then the returned object
 *    will be used in subsequent steps.)
 * 2. If the object has a custom `toString()` method (i.e. not the one inherited from `Object`) that
 *    returns a primitive, its return value will be used instead.<br />
 *    (If the object has a `toString()` method that returns another object, then the returned object
 *    will be used in subsequent steps.)
 * 3. No conversion; the object itself is used.
 *
 * ### The default comparator
 *
 * The default, built-in comparator should be sufficient for most usecases. In short, it compares
 * numbers numerically, strings alphabetically (and case-insensitively), for objects falls back to
 * using their index in the original collection, sorts values of different types by type and puts
 * `undefined` and `null` values at the end of the sorted list.
 *
 * More specifically, it follows these steps to determine the relative order of items:
 *
 * 1. If the compared values are of different types:
 *    - If one of the values is undefined, consider it "greater than" the other.
 *    - Else if one of the values is null, consider it "greater than" the other.
 *    - Else compare the types themselves alphabetically.
 * 2. If both values are of type `string`, compare them alphabetically in a case- and
 *    locale-insensitive way.
 * 3. If both values are objects, compare their indices instead.
 * 4. Otherwise, return:
 *    -  `0`, if the values are equal (by strict equality comparison, i.e. using `===`).
 *    - `-1`, if the 1st value is "less than" the 2nd value (compared using the `<` operator).
 *    -  `1`, otherwise.
 *
 * **Note:** If you notice numbers not being sorted as expected, make sure they are actually being
 *           saved as numbers and not strings.
 * **Note:** For the purpose of sorting, `null` and `undefined` are considered "greater than"
 *           any other value (with undefined "greater than" null). This effectively means that `null`
 *           and `undefined` values end up at the end of a list sorted in ascending order.
 * **Note:** `null` values use `'null'` as their type to be able to distinguish them from objects.
 *
 * @param {Array|ArrayLike} collection - The collection (array or array-like object) to sort.
 * @param {(Function|string|Array.<Function|string>)=} expression - A predicate (or list of
 *    predicates) to be used by the comparator to determine the order of elements.
 *
 *    Can be one of:
 *
 *    - `Function`: A getter function. This function will be called with each item as argument and
 *      the return value will be used for sorting.
 *    - `string`: An AngularJS expression. This expression will be evaluated against each item and the
 *      result will be used for sorting. For example, use `'label'` to sort by a property called
 *      `label` or `'label.substring(0, 3)'` to sort by the first 3 characters of the `label`
 *      property.<br />
 *      (The result of a constant expression is interpreted as a property name to be used for
 *      comparison. For example, use `'"special name"'` (note the extra pair of quotes) to sort by a
 *      property called `special name`.)<br />
 *      An expression can be optionally prefixed with `+` or `-` to control the sorting direction,
 *      ascending or descending. For example, `'+label'` or `'-label'`. If no property is provided,
 *      (e.g. `'+'` or `'-'`), the collection element itself is used in comparisons.
 *    - `Array`: An array of function and/or string predicates. If a predicate cannot determine the
 *      relative order of two items, the next predicate is used as a tie-breaker.
 *
 * **Note:** If the predicate is missing or empty then it defaults to `'+'`.
 *
 * @param {boolean=} reverse - If `true`, reverse the sorting order.
 * @param {(Function)=} comparator - The comparator function used to determine the relative order of
 *    value pairs. If omitted, the built-in comparator will be used.
 *
 * @returns {Array} - The sorted array.
 *
 *
 * @example
 * ### Ordering a table with `ngRepeat`
 *
 * The example below demonstrates a simple {@link ngRepeat ngRepeat}, where the data is sorted by
 * age in descending order (expression is set to `'-age'`). The `comparator` is not set, which means
 * it defaults to the built-in comparator.
 *
   <example name="orderBy-static" module="orderByExample1">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <table class="friends">
           <tr>
             <th>Name</th>
             <th>Phone Number</th>
             <th>Age</th>
           </tr>
           <tr ng-repeat="friend in friends | orderBy:'-age'">
             <td>{{friend.name}}</td>
             <td>{{friend.phone}}</td>
             <td>{{friend.age}}</td>
           </tr>
         </table>
       </div>
     </file>
     <file name="script.js">
       angular.module('orderByExample1', [])
         .controller('ExampleController', ['$scope', function($scope) {
           $scope.friends = [
             {name: 'John',   phone: '555-1212',  age: 10},
             {name: 'Mary',   phone: '555-9876',  age: 19},
             {name: 'Mike',   phone: '555-4321',  age: 21},
             {name: 'Adam',   phone: '555-5678',  age: 35},
             {name: 'Julie',  phone: '555-8765',  age: 29}
           ];
         }]);
     </file>
     <file name="style.css">
       .friends {
         border-collapse: collapse;
       }

       .friends th {
         border-bottom: 1px solid;
       }
       .friends td, .friends th {
         border-left: 1px solid;
         padding: 5px 10px;
       }
       .friends td:first-child, .friends th:first-child {
         border-left: none;
       }
     </file>
     <file name="protractor.js" type="protractor">
       // Element locators
       var names = element.all(by.repeater('friends').column('friend.name'));

       it('should sort friends by age in reverse order', function() {
         expect(names.get(0).getText()).toBe('Adam');
         expect(names.get(1).getText()).toBe('Julie');
         expect(names.get(2).getText()).toBe('Mike');
         expect(names.get(3).getText()).toBe('Mary');
         expect(names.get(4).getText()).toBe('John');
       });
     </file>
   </example>
 * <hr />
 *
 * @example
 * ### Changing parameters dynamically
 *
 * All parameters can be changed dynamically. The next example shows how you can make the columns of
 * a table sortable, by binding the `expression` and `reverse` parameters to scope properties.
 *
   <example name="orderBy-dynamic" module="orderByExample2">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
         <hr/>
         <button ng-click="propertyName = null; reverse = false">Set to unsorted</button>
         <hr/>
         <table class="friends">
           <tr>
             <th>
               <button ng-click="sortBy('name')">Name</button>
               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
             </th>
             <th>
               <button ng-click="sortBy('phone')">Phone Number</button>
               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
             </th>
             <th>
               <button ng-click="sortBy('age')">Age</button>
               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
             </th>
           </tr>
           <tr ng-repeat="friend in friends | orderBy:propertyName:reverse">
             <td>{{friend.name}}</td>
             <td>{{friend.phone}}</td>
             <td>{{friend.age}}</td>
           </tr>
         </table>
       </div>
     </file>
     <file name="script.js">
       angular.module('orderByExample2', [])
         .controller('ExampleController', ['$scope', function($scope) {
           var friends = [
             {name: 'John',   phone: '555-1212',  age: 10},
             {name: 'Mary',   phone: '555-9876',  age: 19},
             {name: 'Mike',   phone: '555-4321',  age: 21},
             {name: 'Adam',   phone: '555-5678',  age: 35},
             {name: 'Julie',  phone: '555-8765',  age: 29}
           ];

           $scope.propertyName = 'age';
           $scope.reverse = true;
           $scope.friends = friends;

           $scope.sortBy = function(propertyName) {
             $scope.reverse = ($scope.propertyName === propertyName) ? !$scope.reverse : false;
             $scope.propertyName = propertyName;
           };
         }]);
     </file>
     <file name="style.css">
       .friends {
         border-collapse: collapse;
       }

       .friends th {
         border-bottom: 1px solid;
       }
       .friends td, .friends th {
         border-left: 1px solid;
         padding: 5px 10px;
       }
       .friends td:first-child, .friends th:first-child {
         border-left: none;
       }

       .sortorder:after {
         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
       }
       .sortorder.reverse:after {
         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
       }
     </file>
     <file name="protractor.js" type="protractor">
       // Element locators
       var unsortButton = element(by.partialButtonText('unsorted'));
       var nameHeader = element(by.partialButtonText('Name'));
       var phoneHeader = element(by.partialButtonText('Phone'));
       var ageHeader = element(by.partialButtonText('Age'));
       var firstName = element(by.repeater('friends').column('friend.name').row(0));
       var lastName = element(by.repeater('friends').column('friend.name').row(4));

       it('should sort friends by some property, when clicking on the column header', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         phoneHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Mary');

         nameHeader.click();
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('Mike');

         ageHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Adam');
       });

       it('should sort friends in reverse order, when clicking on the same column', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         ageHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Adam');

         ageHeader.click();
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');
       });

       it('should restore the original order, when clicking "Set to unsorted"', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         unsortButton.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Julie');
       });
     </file>
   </example>
 * <hr />
 *
 * @example
 * ### Using `orderBy` inside a controller
 *
 * It is also possible to call the `orderBy` filter manually, by injecting `orderByFilter`, and
 * calling it with the desired parameters. (Alternatively, you could inject the `$filter` factory
 * and retrieve the `orderBy` filter with `$filter('orderBy')`.)
 *
   <example name="orderBy-call-manually" module="orderByExample3">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
         <hr/>
         <button ng-click="sortBy(null)">Set to unsorted</button>
         <hr/>
         <table class="friends">
           <tr>
             <th>
               <button ng-click="sortBy('name')">Name</button>
               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
             </th>
             <th>
               <button ng-click="sortBy('phone')">Phone Number</button>
               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
             </th>
             <th>
               <button ng-click="sortBy('age')">Age</button>
               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
             </th>
           </tr>
           <tr ng-repeat="friend in friends">
             <td>{{friend.name}}</td>
             <td>{{friend.phone}}</td>
             <td>{{friend.age}}</td>
           </tr>
         </table>
       </div>
     </file>
     <file name="script.js">
       angular.module('orderByExample3', [])
         .controller('ExampleController', ['$scope', 'orderByFilter', function($scope, orderBy) {
           var friends = [
             {name: 'John',   phone: '555-1212',  age: 10},
             {name: 'Mary',   phone: '555-9876',  age: 19},
             {name: 'Mike',   phone: '555-4321',  age: 21},
             {name: 'Adam',   phone: '555-5678',  age: 35},
             {name: 'Julie',  phone: '555-8765',  age: 29}
           ];

           $scope.propertyName = 'age';
           $scope.reverse = true;
           $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);

           $scope.sortBy = function(propertyName) {
             $scope.reverse = (propertyName !== null && $scope.propertyName === propertyName)
                 ? !$scope.reverse : false;
             $scope.propertyName = propertyName;
             $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
           };
         }]);
     </file>
     <file name="style.css">
       .friends {
         border-collapse: collapse;
       }

       .friends th {
         border-bottom: 1px solid;
       }
       .friends td, .friends th {
         border-left: 1px solid;
         padding: 5px 10px;
       }
       .friends td:first-child, .friends th:first-child {
         border-left: none;
       }

       .sortorder:after {
         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
       }
       .sortorder.reverse:after {
         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
       }
     </file>
     <file name="protractor.js" type="protractor">
       // Element locators
       var unsortButton = element(by.partialButtonText('unsorted'));
       var nameHeader = element(by.partialButtonText('Name'));
       var phoneHeader = element(by.partialButtonText('Phone'));
       var ageHeader = element(by.partialButtonText('Age'));
       var firstName = element(by.repeater('friends').column('friend.name').row(0));
       var lastName = element(by.repeater('friends').column('friend.name').row(4));

       it('should sort friends by some property, when clicking on the column header', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         phoneHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Mary');

         nameHeader.click();
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('Mike');

         ageHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Adam');
       });

       it('should sort friends in reverse order, when clicking on the same column', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         ageHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Adam');

         ageHeader.click();
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');
       });

       it('should restore the original order, when clicking "Set to unsorted"', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         unsortButton.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Julie');
       });
     </file>
   </example>
 * <hr />
 *
 * @example
 * ### Using a custom comparator
 *
 * If you have very specific requirements about the way items are sorted, you can pass your own
 * comparator function. For example, you might need to compare some strings in a locale-sensitive
 * way. (When specifying a custom comparator, you also need to pass a value for the `reverse`
 * argument - passing `false` retains the default sorting order, i.e. ascending.)
 *
   <example name="orderBy-custom-comparator" module="orderByExample4">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <div class="friends-container custom-comparator">
           <h3>Locale-sensitive Comparator</h3>
           <table class="friends">
             <tr>
               <th>Name</th>
               <th>Favorite Letter</th>
             </tr>
             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter':false:localeSensitiveComparator">
               <td>{{friend.name}}</td>
               <td>{{friend.favoriteLetter}}</td>
             </tr>
           </table>
         </div>
         <div class="friends-container default-comparator">
           <h3>Default Comparator</h3>
           <table class="friends">
             <tr>
               <th>Name</th>
               <th>Favorite Letter</th>
             </tr>
             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter'">
               <td>{{friend.name}}</td>
               <td>{{friend.favoriteLetter}}</td>
             </tr>
           </table>
         </div>
       </div>
     </file>
     <file name="script.js">
       angular.module('orderByExample4', [])
         .controller('ExampleController', ['$scope', function($scope) {
           $scope.friends = [
             {name: 'John',   favoriteLetter: 'Ä'},
             {name: 'Mary',   favoriteLetter: 'Ü'},
             {name: 'Mike',   favoriteLetter: 'Ö'},
             {name: 'Adam',   favoriteLetter: 'H'},
             {name: 'Julie',  favoriteLetter: 'Z'}
           ];

           $scope.localeSensitiveComparator = function(v1, v2) {
             // If we don't get strings, just compare by index
             if (v1.type !== 'string' || v2.type !== 'string') {
               return (v1.index < v2.index) ? -1 : 1;
             }

             // Compare strings alphabetically, taking locale into account
             return v1.value.localeCompare(v2.value);
           };
         }]);
     </file>
     <file name="style.css">
       .friends-container {
         display: inline-block;
         margin: 0 30px;
       }

       .friends {
         border-collapse: collapse;
       }

       .friends th {
         border-bottom: 1px solid;
       }
       .friends td, .friends th {
         border-left: 1px solid;
         padding: 5px 10px;
       }
       .friends td:first-child, .friends th:first-child {
         border-left: none;
       }
     </file>
     <file name="protractor.js" type="protractor">
       // Element locators
       var container = element(by.css('.custom-comparator'));
       var names = container.all(by.repeater('friends').column('friend.name'));

       it('should sort friends by favorite letter (in correct alphabetical order)', function() {
         expect(names.get(0).getText()).toBe('John');
         expect(names.get(1).getText()).toBe('Adam');
         expect(names.get(2).getText()).toBe('Mike');
         expect(names.get(3).getText()).toBe('Mary');
         expect(names.get(4).getText()).toBe('Julie');
       });
     </file>
   </example>
 *
 */
orderByFilter.$inject = ['$parse'];
function orderByFilter($parse) {
  return function(array, sortPredicate, reverseOrder, compareFn) {

    if (array == null) return array;
    if (!isArrayLike(array)) {
      throw minErr('orderBy')('notarray', 'Expected array but received: {0}', array);
    }

    if (!isArray(sortPredicate)) { sortPredicate = [sortPredicate]; }
    if (sortPredicate.length === 0) { sortPredicate = ['+']; }

    var predicates = processPredicates(sortPredicate);

    var descending = reverseOrder ? -1 : 1;

    // Define the `compare()` function. Use a default comparator if none is specified.
    var compare = isFunction(compareFn) ? compareFn : defaultCompare;

    // The next three lines are a version of a Swartzian Transform idiom from Perl
    // (sometimes called the Decorate-Sort-Undecorate idiom)
    // See https://en.wikipedia.org/wiki/Schwartzian_transform
    var compareValues = Array.prototype.map.call(array, getComparisonObject);
    compareValues.sort(doComparison);
    array = compareValues.map(function(item) { return item.value; });

    return array;

    function getComparisonObject(value, index) {
      // NOTE: We are adding an extra `tieBreaker` value based on the element's index.
      // This will be used to keep the sort stable when none of the input predicates can
      // distinguish between two elements.
      return {
        value: value,
        tieBreaker: {value: index, type: 'number', index: index},
        predicateValues: predicates.map(function(predicate) {
          return getPredicateValue(predicate.get(value), index);
        })
      };
    }

    function doComparison(v1, v2) {
      for (var i = 0, ii = predicates.length; i < ii; i++) {
        var result = compare(v1.predicateValues[i], v2.predicateValues[i]);
        if (result) {
          return result * predicates[i].descending * descending;
        }
      }

      return (compare(v1.tieBreaker, v2.tieBreaker) || defaultCompare(v1.tieBreaker, v2.tieBreaker)) * descending;
    }
  };

  function processPredicates(sortPredicates) {
    return sortPredicates.map(function(predicate) {
      var descending = 1, get = identity;

      if (isFunction(predicate)) {
        get = predicate;
      } else if (isString(predicate)) {
        if ((predicate.charAt(0) === '+' || predicate.charAt(0) === '-')) {
          descending = predicate.charAt(0) === '-' ? -1 : 1;
          predicate = predicate.substring(1);
        }
        if (predicate !== '') {
          get = $parse(predicate);
          if (get.constant) {
            var key = get();
            get = function(value) { return value[key]; };
          }
        }
      }
      return {get: get, descending: descending};
    });
  }

  function isPrimitive(value) {
    switch (typeof value) {
      case 'number': /* falls through */
      case 'boolean': /* falls through */
      case 'string':
        return true;
      default:
        return false;
    }
  }

  function objectValue(value) {
    // If `valueOf` is a valid function use that
    if (isFunction(value.valueOf)) {
      value = value.valueOf();
      if (isPrimitive(value)) return value;
    }
    // If `toString` is a valid function and not the one from `Object.prototype` use that
    if (hasCustomToString(value)) {
      value = value.toString();
      if (isPrimitive(value)) return value;
    }

    return value;
  }

  function getPredicateValue(value, index) {
    var type = typeof value;
    if (value === null) {
      type = 'null';
    } else if (type === 'object') {
      value = objectValue(value);
    }
    return {value: value, type: type, index: index};
  }

  function defaultCompare(v1, v2) {
    var result = 0;
    var type1 = v1.type;
    var type2 = v2.type;

    if (type1 === type2) {
      var value1 = v1.value;
      var value2 = v2.value;

      if (type1 === 'string') {
        // Compare strings case-insensitively
        value1 = value1.toLowerCase();
        value2 = value2.toLowerCase();
      } else if (type1 === 'object') {
        // For basic objects, use the position of the object
        // in the collection instead of the value
        if (isObject(value1)) value1 = v1.index;
        if (isObject(value2)) value2 = v2.index;
      }

      if (value1 !== value2) {
        result = value1 < value2 ? -1 : 1;
      }
    } else {
      result = (type1 === 'undefined') ? 1 :
        (type2 === 'undefined') ? -1 :
        (type1 === 'null') ? 1 :
        (type2 === 'null') ? -1 :
        (type1 < type2) ? -1 : 1;
    }

    return result;
  }
}

function ngDirective(directive) {
  if (isFunction(directive)) {
    directive = {
      link: directive
    };
  }
  directive.restrict = directive.restrict || 'AC';
  return valueFn(directive);
}

/**
 * @ngdoc directive
 * @name a
 * @restrict E
 *
 * @description
 * Modifies the default behavior of the html a tag so that the default action is prevented when
 * the href attribute is empty.
 *
 * For dynamically creating `href` attributes for a tags, see the {@link ng.ngHref `ngHref`} directive.
 */
var htmlAnchorDirective = valueFn({
  restrict: 'E',
  compile: function(element, attr) {
    if (!attr.href && !attr.xlinkHref) {
      return function(scope, element) {
        // If the linked element is not an anchor tag anymore, do nothing
        if (element[0].nodeName.toLowerCase() !== 'a') return;

        // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
        var href = toString.call(element.prop('href')) === '[object SVGAnimatedString]' ?
                   'xlink:href' : 'href';
        element.on('click', function(event) {
          // if we have no href url, then don't navigate anywhere.
          if (!element.attr(href)) {
            event.preventDefault();
          }
        });
      };
    }
  }
});

/**
 * @ngdoc directive
 * @name ngHref
 * @restrict A
 * @priority 99
 *
 * @description
 * Using AngularJS markup like `{{hash}}` in an href attribute will
 * make the link go to the wrong URL if the user clicks it before
 * AngularJS has a chance to replace the `{{hash}}` markup with its
 * value. Until AngularJS replaces the markup the link will be broken
 * and will most likely return a 404 error. The `ngHref` directive
 * solves this problem.
 *
 * The wrong way to write it:
 * ```html
 * <a href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
 * ```
 *
 * The correct way to write it:
 * ```html
 * <a ng-href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
 * ```
 *
 * @element A
 * @param {template} ngHref any string which can contain `{{}}` markup.
 *
 * @example
 * This example shows various combinations of `href`, `ng-href` and `ng-click` attributes
 * in links and their different behaviors:
    <example name="ng-href">
      <file name="index.html">
        <input ng-model="value" /><br />
        <a id="link-1" href ng-click="value = 1">link 1</a> (link, don't reload)<br />
        <a id="link-2" href="" ng-click="value = 2">link 2</a> (link, don't reload)<br />
        <a id="link-3" ng-href="/{{'123'}}">link 3</a> (link, reload!)<br />
        <a id="link-4" href="" name="xx" ng-click="value = 4">anchor</a> (link, don't reload)<br />
        <a id="link-5" name="xxx" ng-click="value = 5">anchor</a> (no link)<br />
        <a id="link-6" ng-href="{{value}}">link</a> (link, change location)
      </file>
      <file name="protractor.js" type="protractor">
        it('should execute ng-click but not reload when href without value', function() {
          element(by.id('link-1')).click();
          expect(element(by.model('value')).getAttribute('value')).toEqual('1');
          expect(element(by.id('link-1')).getAttribute('href')).toBe('');
        });

        it('should execute ng-click but not reload when href empty string', function() {
          element(by.id('link-2')).click();
          expect(element(by.model('value')).getAttribute('value')).toEqual('2');
          expect(element(by.id('link-2')).getAttribute('href')).toBe('');
        });

        it('should execute ng-click and change url when ng-href specified', function() {
          expect(element(by.id('link-3')).getAttribute('href')).toMatch(/\/123$/);

          element(by.id('link-3')).click();

          // At this point, we navigate away from an AngularJS page, so we need
          // to use browser.driver to get the base webdriver.

          browser.wait(function() {
            return browser.driver.getCurrentUrl().then(function(url) {
              return url.match(/\/123$/);
            });
          }, 5000, 'page should navigate to /123');
        });

        it('should execute ng-click but not reload when href empty string and name specified', function() {
          element(by.id('link-4')).click();
          expect(element(by.model('value')).getAttribute('value')).toEqual('4');
          expect(element(by.id('link-4')).getAttribute('href')).toBe('');
        });

        it('should execute ng-click but not reload when no href but name specified', function() {
          element(by.id('link-5')).click();
          expect(element(by.model('value')).getAttribute('value')).toEqual('5');
          expect(element(by.id('link-5')).getAttribute('href')).toBe(null);
        });

        it('should only change url when only ng-href', function() {
          element(by.model('value')).clear();
          element(by.model('value')).sendKeys('6');
          expect(element(by.id('link-6')).getAttribute('href')).toMatch(/\/6$/);

          element(by.id('link-6')).click();

          // At this point, we navigate away from an AngularJS page, so we need
          // to use browser.driver to get the base webdriver.
          browser.wait(function() {
            return browser.driver.getCurrentUrl().then(function(url) {
              return url.match(/\/6$/);
            });
          }, 5000, 'page should navigate to /6');
        });
      </file>
    </example>
 */

/**
 * @ngdoc directive
 * @name ngSrc
 * @restrict A
 * @priority 99
 *
 * @description
 * Using AngularJS markup like `{{hash}}` in a `src` attribute doesn't
 * work right: The browser will fetch from the URL with the literal
 * text `{{hash}}` until AngularJS replaces the expression inside
 * `{{hash}}`. The `ngSrc` directive solves this problem.
 *
 * The buggy way to write it:
 * ```html
 * <img src="http://www.gravatar.com/avatar/{{hash}}" alt="Description"/>
 * ```
 *
 * The correct way to write it:
 * ```html
 * <img ng-src="http://www.gravatar.com/avatar/{{hash}}" alt="Description" />
 * ```
 *
 * @element IMG
 * @param {template} ngSrc any string which can contain `{{}}` markup.
 */

/**
 * @ngdoc directive
 * @name ngSrcset
 * @restrict A
 * @priority 99
 *
 * @description
 * Using AngularJS markup like `{{hash}}` in a `srcset` attribute doesn't
 * work right: The browser will fetch from the URL with the literal
 * text `{{hash}}` until AngularJS replaces the expression inside
 * `{{hash}}`. The `ngSrcset` directive solves this problem.
 *
 * The buggy way to write it:
 * ```html
 * <img srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description"/>
 * ```
 *
 * The correct way to write it:
 * ```html
 * <img ng-srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description" />
 * ```
 *
 * @element IMG
 * @param {template} ngSrcset any string which can contain `{{}}` markup.
 */

/**
 * @ngdoc directive
 * @name ngDisabled
 * @restrict A
 * @priority 100
 *
 * @description
 *
 * This directive sets the `disabled` attribute on the element (typically a form control,
 * e.g. `input`, `button`, `select` etc.) if the
 * {@link guide/expression expression} inside `ngDisabled` evaluates to truthy.
 *
 * A special directive is necessary because we cannot use interpolation inside the `disabled`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * @example
    <example name="ng-disabled">
      <file name="index.html">
        <label>Click me to toggle: <input type="checkbox" ng-model="checked"></label><br/>
        <button ng-model="button" ng-disabled="checked">Button</button>
      </file>
      <file name="protractor.js" type="protractor">
        it('should toggle button', function() {
          expect(element(by.css('button')).getAttribute('disabled')).toBeFalsy();
          element(by.model('checked')).click();
          expect(element(by.css('button')).getAttribute('disabled')).toBeTruthy();
        });
      </file>
    </example>
 *
 * @param {expression} ngDisabled If the {@link guide/expression expression} is truthy,
 *     then the `disabled` attribute will be set on the element
 */


/**
 * @ngdoc directive
 * @name ngChecked
 * @restrict A
 * @priority 100
 *
 * @description
 * Sets the `checked` attribute on the element, if the expression inside `ngChecked` is truthy.
 *
 * Note that this directive should not be used together with {@link ngModel `ngModel`},
 * as this can lead to unexpected behavior.
 *
 * A special directive is necessary because we cannot use interpolation inside the `checked`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * @example
    <example name="ng-checked">
      <file name="index.html">
        <label>Check me to check both: <input type="checkbox" ng-model="leader"></label><br/>
        <input id="checkFollower" type="checkbox" ng-checked="leader" aria-label="Follower input">
      </file>
      <file name="protractor.js" type="protractor">
        it('should check both checkBoxes', function() {
          expect(element(by.id('checkFollower')).getAttribute('checked')).toBeFalsy();
          element(by.model('leader')).click();
          expect(element(by.id('checkFollower')).getAttribute('checked')).toBeTruthy();
        });
      </file>
    </example>
 *
 * @element INPUT
 * @param {expression} ngChecked If the {@link guide/expression expression} is truthy,
 *     then the `checked` attribute will be set on the element
 */


/**
 * @ngdoc directive
 * @name ngReadonly
 * @restrict A
 * @priority 100
 *
 * @description
 *
 * Sets the `readonly` attribute on the element, if the expression inside `ngReadonly` is truthy.
 * Note that `readonly` applies only to `input` elements with specific types. [See the input docs on
 * MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-readonly) for more information.
 *
 * A special directive is necessary because we cannot use interpolation inside the `readonly`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * @example
    <example name="ng-readonly">
      <file name="index.html">
        <label>Check me to make text readonly: <input type="checkbox" ng-model="checked"></label><br/>
        <input type="text" ng-readonly="checked" value="I'm AngularJS" aria-label="Readonly field" />
      </file>
      <file name="protractor.js" type="protractor">
        it('should toggle readonly attr', function() {
          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeFalsy();
          element(by.model('checked')).click();
          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeTruthy();
        });
      </file>
    </example>
 *
 * @element INPUT
 * @param {expression} ngReadonly If the {@link guide/expression expression} is truthy,
 *     then special attribute "readonly" will be set on the element
 */


/**
 * @ngdoc directive
 * @name ngSelected
 * @restrict A
 * @priority 100
 *
 * @description
 *
 * Sets the `selected` attribute on the element, if the expression inside `ngSelected` is truthy.
 *
 * A special directive is necessary because we cannot use interpolation inside the `selected`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * <div class="alert alert-warning">
 *   **Note:** `ngSelected` does not interact with the `select` and `ngModel` directives, it only
 *   sets the `selected` attribute on the element. If you are using `ngModel` on the select, you
 *   should not use `ngSelected` on the options, as `ngModel` will set the select value and
 *   selected options.
 * </div>
 *
 * @example
    <example name="ng-selected">
      <file name="index.html">
        <label>Check me to select: <input type="checkbox" ng-model="selected"></label><br/>
        <select aria-label="ngSelected demo">
          <option>Hello!</option>
          <option id="greet" ng-selected="selected">Greetings!</option>
        </select>
      </file>
      <file name="protractor.js" type="protractor">
        it('should select Greetings!', function() {
          expect(element(by.id('greet')).getAttribute('selected')).toBeFalsy();
          element(by.model('selected')).click();
          expect(element(by.id('greet')).getAttribute('selected')).toBeTruthy();
        });
      </file>
    </example>
 *
 * @element OPTION
 * @param {expression} ngSelected If the {@link guide/expression expression} is truthy,
 *     then special attribute "selected" will be set on the element
 */

/**
 * @ngdoc directive
 * @name ngOpen
 * @restrict A
 * @priority 100
 *
 * @description
 *
 * Sets the `open` attribute on the element, if the expression inside `ngOpen` is truthy.
 *
 * A special directive is necessary because we cannot use interpolation inside the `open`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * ## A note about browser compatibility
 *
 * Internet Explorer and Edge do not support the `details` element, it is
 * recommended to use {@link ng.ngShow} and {@link ng.ngHide} instead.
 *
 * @example
     <example name="ng-open">
       <file name="index.html">
         <label>Toggle details: <input type="checkbox" ng-model="open"></label><br/>
         <details id="details" ng-open="open">
            <summary>List</summary>
            <ul>
              <li>Apple</li>
              <li>Orange</li>
              <li>Durian</li>
            </ul>
         </details>
       </file>
       <file name="protractor.js" type="protractor">
         it('should toggle open', function() {
           expect(element(by.id('details')).getAttribute('open')).toBeFalsy();
           element(by.model('open')).click();
           expect(element(by.id('details')).getAttribute('open')).toBeTruthy();
         });
       </file>
     </example>
 *
 * @element DETAILS
 * @param {expression} ngOpen If the {@link guide/expression expression} is truthy,
 *     then special attribute "open" will be set on the element
 */

var ngAttributeAliasDirectives = {};

// boolean attrs are evaluated
forEach(BOOLEAN_ATTR, function(propName, attrName) {
  // binding to multiple is not supported
  if (propName === 'multiple') return;

  function defaultLinkFn(scope, element, attr) {
    scope.$watch(attr[normalized], function ngBooleanAttrWatchAction(value) {
      attr.$set(attrName, !!value);
    });
  }

  var normalized = directiveNormalize('ng-' + attrName);
  var linkFn = defaultLinkFn;

  if (propName === 'checked') {
    linkFn = function(scope, element, attr) {
      // ensuring ngChecked doesn't interfere with ngModel when both are set on the same input
      if (attr.ngModel !== attr[normalized]) {
        defaultLinkFn(scope, element, attr);
      }
    };
  }

  ngAttributeAliasDirectives[normalized] = function() {
    return {
      restrict: 'A',
      priority: 100,
      link: linkFn
    };
  };
});

// aliased input attrs are evaluated
forEach(ALIASED_ATTR, function(htmlAttr, ngAttr) {
  ngAttributeAliasDirectives[ngAttr] = function() {
    return {
      priority: 100,
      link: function(scope, element, attr) {
        //special case ngPattern when a literal regular expression value
        //is used as the expression (this way we don't have to watch anything).
        if (ngAttr === 'ngPattern' && attr.ngPattern.charAt(0) === '/') {
          var match = attr.ngPattern.match(REGEX_STRING_REGEXP);
          if (match) {
            attr.$set('ngPattern', new RegExp(match[1], match[2]));
            return;
          }
        }

        scope.$watch(attr[ngAttr], function ngAttrAliasWatchAction(value) {
          attr.$set(ngAttr, value);
        });
      }
    };
  };
});

// ng-src, ng-srcset, ng-href are interpolated
forEach(['src', 'srcset', 'href'], function(attrName) {
  var normalized = directiveNormalize('ng-' + attrName);
  ngAttributeAliasDirectives[normalized] = ['$sce', function($sce) {
    return {
      priority: 99, // it needs to run after the attributes are interpolated
      link: function(scope, element, attr) {
        var propName = attrName,
            name = attrName;

        if (attrName === 'href' &&
            toString.call(element.prop('href')) === '[object SVGAnimatedString]') {
          name = 'xlinkHref';
          attr.$attr[name] = 'xlink:href';
          propName = null;
        }

        // We need to sanitize the url at least once, in case it is a constant
        // non-interpolated attribute.
        attr.$set(normalized, $sce.getTrustedMediaUrl(attr[normalized]));

        attr.$observe(normalized, function(value) {
          if (!value) {
            if (attrName === 'href') {
              attr.$set(name, null);
            }
            return;
          }

          attr.$set(name, value);

          // Support: IE 9-11 only
          // On IE, if "ng:src" directive declaration is used and "src" attribute doesn't exist
          // then calling element.setAttribute('src', 'foo') doesn't do anything, so we need
          // to set the property as well to achieve the desired effect.
          // We use attr[attrName] value since $set might have sanitized the url.
          if (msie && propName) element.prop(propName, attr[name]);
        });
      }
    };
  }];
});

/* global -nullFormCtrl, -PENDING_CLASS, -SUBMITTED_CLASS
 */
var nullFormCtrl = {
  $addControl: noop,
  $getControls: valueFn([]),
  $$renameControl: nullFormRenameControl,
  $removeControl: noop,
  $setValidity: noop,
  $setDirty: noop,
  $setPristine: noop,
  $setSubmitted: noop,
  $$setSubmitted: noop
},
PENDING_CLASS = 'ng-pending',
SUBMITTED_CLASS = 'ng-submitted';

function nullFormRenameControl(control, name) {
  control.$name = name;
}

/**
 * @ngdoc type
 * @name form.FormController
 *
 * @property {boolean} $pristine True if user has not interacted with the form yet.
 * @property {boolean} $dirty True if user has already interacted with the form.
 * @property {boolean} $valid True if all of the containing forms and controls are valid.
 * @property {boolean} $invalid True if at least one containing control or form is invalid.
 * @property {boolean} $submitted True if user has submitted the form even if its invalid.
 *
 * @property {Object} $pending An object hash, containing references to controls or forms with
 *  pending validators, where:
 *
 *  - keys are validations tokens (error names).
 *  - values are arrays of controls or forms that have a pending validator for the given error name.
 *
 * See {@link form.FormController#$error $error} for a list of built-in validation tokens.
 *
 * @property {Object} $error An object hash, containing references to controls or forms with failing
 *  validators, where:
 *
 *  - keys are validation tokens (error names),
 *  - values are arrays of controls or forms that have a failing validator for the given error name.
 *
 *  Built-in validation tokens:
 *  - `email`
 *  - `max`
 *  - `maxlength`
 *  - `min`
 *  - `minlength`
 *  - `number`
 *  - `pattern`
 *  - `required`
 *  - `url`
 *  - `date`
 *  - `datetimelocal`
 *  - `time`
 *  - `week`
 *  - `month`
 *
 * @description
 * `FormController` keeps track of all its controls and nested forms as well as the state of them,
 * such as being valid/invalid or dirty/pristine.
 *
 * Each {@link ng.directive:form form} directive creates an instance
 * of `FormController`.
 *
 */
//asks for $scope to fool the BC controller module
FormController.$inject = ['$element', '$attrs', '$scope', '$animate', '$interpolate'];
function FormController($element, $attrs, $scope, $animate, $interpolate) {
  this.$$controls = [];

  // init state
  this.$error = {};
  this.$$success = {};
  this.$pending = undefined;
  this.$name = $interpolate($attrs.name || $attrs.ngForm || '')($scope);
  this.$dirty = false;
  this.$pristine = true;
  this.$valid = true;
  this.$invalid = false;
  this.$submitted = false;
  this.$$parentForm = nullFormCtrl;

  this.$$element = $element;
  this.$$animate = $animate;

  setupValidity(this);
}

FormController.prototype = {
  /**
   * @ngdoc method
   * @name form.FormController#$rollbackViewValue
   *
   * @description
   * Rollback all form controls pending updates to the `$modelValue`.
   *
   * Updates may be pending by a debounced event or because the input is waiting for a some future
   * event defined in `ng-model-options`. This method is typically needed by the reset button of
   * a form that uses `ng-model-options` to pend updates.
   */
  $rollbackViewValue: function() {
    forEach(this.$$controls, function(control) {
      control.$rollbackViewValue();
    });
  },

  /**
   * @ngdoc method
   * @name form.FormController#$commitViewValue
   *
   * @description
   * Commit all form controls pending updates to the `$modelValue`.
   *
   * Updates may be pending by a debounced event or because the input is waiting for a some future
   * event defined in `ng-model-options`. This method is rarely needed as `NgModelController`
   * usually handles calling this in response to input events.
   */
  $commitViewValue: function() {
    forEach(this.$$controls, function(control) {
      control.$commitViewValue();
    });
  },

  /**
   * @ngdoc method
   * @name form.FormController#$addControl
   * @param {object} control control object, either a {@link form.FormController} or an
   * {@link ngModel.NgModelController}
   *
   * @description
   * Register a control with the form. Input elements using ngModelController do this automatically
   * when they are linked.
   *
   * Note that the current state of the control will not be reflected on the new parent form. This
   * is not an issue with normal use, as freshly compiled and linked controls are in a `$pristine`
   * state.
   *
   * However, if the method is used programmatically, for example by adding dynamically created controls,
   * or controls that have been previously removed without destroying their corresponding DOM element,
   * it's the developers responsibility to make sure the current state propagates to the parent form.
   *
   * For example, if an input control is added that is already `$dirty` and has `$error` properties,
   * calling `$setDirty()` and `$validate()` afterwards will propagate the state to the parent form.
   */
  $addControl: function(control) {
    // Breaking change - before, inputs whose name was "hasOwnProperty" were quietly ignored
    // and not added to the scope.  Now we throw an error.
    assertNotHasOwnProperty(control.$name, 'input');
    this.$$controls.push(control);

    if (control.$name) {
      this[control.$name] = control;
    }

    control.$$parentForm = this;
  },

  /**
   * @ngdoc method
   * @name form.FormController#$getControls
   * @returns {Array} the controls that are currently part of this form
   *
   * @description
   * This method returns a **shallow copy** of the controls that are currently part of this form.
   * The controls can be instances of {@link form.FormController `FormController`}
   * ({@link ngForm "child-forms"}) and of {@link ngModel.NgModelController `NgModelController`}.
   * If you need access to the controls of child-forms, you have to call `$getControls()`
   * recursively on them.
   * This can be used for example to iterate over all controls to validate them.
   *
   * The controls can be accessed normally, but adding to, or removing controls from the array has
   * no effect on the form. Instead, use {@link form.FormController#$addControl `$addControl()`} and
   * {@link form.FormController#$removeControl `$removeControl()`} for this use-case.
   * Likewise, adding a control to, or removing a control from the form is not reflected
   * in the shallow copy. That means you should get a fresh copy from `$getControls()` every time
   * you need access to the controls.
   */
  $getControls: function() {
    return shallowCopy(this.$$controls);
  },

  // Private API: rename a form control
  $$renameControl: function(control, newName) {
    var oldName = control.$name;

    if (this[oldName] === control) {
      delete this[oldName];
    }
    this[newName] = control;
    control.$name = newName;
  },

  /**
   * @ngdoc method
   * @name form.FormController#$removeControl
   * @param {object} control control object, either a {@link form.FormController} or an
   * {@link ngModel.NgModelController}
   *
   * @description
   * Deregister a control from the form.
   *
   * Input elements using ngModelController do this automatically when they are destroyed.
   *
   * Note that only the removed control's validation state (`$errors`etc.) will be removed from the
   * form. `$dirty`, `$submitted` states will not be changed, because the expected behavior can be
   * different from case to case. For example, removing the only `$dirty` control from a form may or
   * may not mean that the form is still `$dirty`.
   */
  $removeControl: function(control) {
    if (control.$name && this[control.$name] === control) {
      delete this[control.$name];
    }
    forEach(this.$pending, function(value, name) {
      // eslint-disable-next-line no-invalid-this
      this.$setValidity(name, null, control);
    }, this);
    forEach(this.$error, function(value, name) {
      // eslint-disable-next-line no-invalid-this
      this.$setValidity(name, null, control);
    }, this);
    forEach(this.$$success, function(value, name) {
      // eslint-disable-next-line no-invalid-this
      this.$setValidity(name, null, control);
    }, this);

    arrayRemove(this.$$controls, control);
    control.$$parentForm = nullFormCtrl;
  },

  /**
   * @ngdoc method
   * @name form.FormController#$setDirty
   *
   * @description
   * Sets the form to a dirty state.
   *
   * This method can be called to add the 'ng-dirty' class and set the form to a dirty
   * state (ng-dirty class). This method will also propagate to parent forms.
   */
  $setDirty: function() {
    this.$$animate.removeClass(this.$$element, PRISTINE_CLASS);
    this.$$animate.addClass(this.$$element, DIRTY_CLASS);
    this.$dirty = true;
    this.$pristine = false;
    this.$$parentForm.$setDirty();
  },

  /**
   * @ngdoc method
   * @name form.FormController#$setPristine
   *
   * @description
   * Sets the form to its pristine state.
   *
   * This method sets the form's `$pristine` state to true, the `$dirty` state to false, removes
   * the `ng-dirty` class and adds the `ng-pristine` class. Additionally, it sets the `$submitted`
   * state to false.
   *
   * This method will also propagate to all the controls contained in this form.
   *
   * Setting a form back to a pristine state is often useful when we want to 'reuse' a form after
   * saving or resetting it.
   */
  $setPristine: function() {
    this.$$animate.setClass(this.$$element, PRISTINE_CLASS, DIRTY_CLASS + ' ' + SUBMITTED_CLASS);
    this.$dirty = false;
    this.$pristine = true;
    this.$submitted = false;
    forEach(this.$$controls, function(control) {
      control.$setPristine();
    });
  },

  /**
   * @ngdoc method
   * @name form.FormController#$setUntouched
   *
   * @description
   * Sets the form to its untouched state.
   *
   * This method can be called to remove the 'ng-touched' class and set the form controls to their
   * untouched state (ng-untouched class).
   *
   * Setting a form controls back to their untouched state is often useful when setting the form
   * back to its pristine state.
   */
  $setUntouched: function() {
    forEach(this.$$controls, function(control) {
      control.$setUntouched();
    });
  },

  /**
   * @ngdoc method
   * @name form.FormController#$setSubmitted
   *
   * @description
   * Sets the form to its `$submitted` state. This will also set `$submitted` on all child and
   * parent forms of the form.
   */
  $setSubmitted: function() {
    var rootForm = this;
    while (rootForm.$$parentForm && (rootForm.$$parentForm !== nullFormCtrl)) {
      rootForm = rootForm.$$parentForm;
    }
    rootForm.$$setSubmitted();
  },

  $$setSubmitted: function() {
    this.$$animate.addClass(this.$$element, SUBMITTED_CLASS);
    this.$submitted = true;
    forEach(this.$$controls, function(control) {
      if (control.$$setSubmitted) {
        control.$$setSubmitted();
      }
    });
  }
};

/**
 * @ngdoc method
 * @name form.FormController#$setValidity
 *
 * @description
 * Change the validity state of the form, and notify the parent form (if any).
 *
 * Application developers will rarely need to call this method directly. It is used internally, by
 * {@link ngModel.NgModelController#$setValidity NgModelController.$setValidity()}, to propagate a
 * control's validity state to the parent `FormController`.
 *
 * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be
 *        assigned to either `$error[validationErrorKey]` or `$pending[validationErrorKey]` (for
 *        unfulfilled `$asyncValidators`), so that it is available for data-binding. The
 *        `validationErrorKey` should be in camelCase and will get converted into dash-case for
 *        class name. Example: `myError` will result in `ng-valid-my-error` and
 *        `ng-invalid-my-error` classes and can be bound to as `{{ someForm.$error.myError }}`.
 * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending
 *        (undefined),  or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
 *        Skipped is used by AngularJS when validators do not run because of parse errors and when
 *        `$asyncValidators` do not run because any of the `$validators` failed.
 * @param {NgModelController | FormController} controller - The controller whose validity state is
 *        triggering the change.
 */
addSetValidityMethod({
  clazz: FormController,
  set: function(object, property, controller) {
    var list = object[property];
    if (!list) {
      object[property] = [controller];
    } else {
      var index = list.indexOf(controller);
      if (index === -1) {
        list.push(controller);
      }
    }
  },
  unset: function(object, property, controller) {
    var list = object[property];
    if (!list) {
      return;
    }
    arrayRemove(list, controller);
    if (list.length === 0) {
      delete object[property];
    }
  }
});

/**
 * @ngdoc directive
 * @name ngForm
 * @restrict EAC
 *
 * @description
 * Helper directive that makes it possible to create control groups inside a
 * {@link ng.directive:form `form`} directive.
 * These "child forms" can be used, for example, to determine the validity of a sub-group of
 * controls.
 *
 * <div class="alert alert-danger">
 * **Note**: `ngForm` cannot be used as a replacement for `<form>`, because it lacks its
 * [built-in HTML functionality](https://html.spec.whatwg.org/#the-form-element).
 * Specifically, you cannot submit `ngForm` like a `<form>` tag. That means,
 * you cannot send data to the server with `ngForm`, or integrate it with
 * {@link ng.directive:ngSubmit `ngSubmit`}.
 * </div>
 *
 * @param {string=} ngForm|name Name of the form. If specified, the form controller will
 *                              be published into the related scope, under this name.
 *
 */

 /**
 * @ngdoc directive
 * @name form
 * @restrict E
 *
 * @description
 * Directive that instantiates
 * {@link form.FormController FormController}.
 *
 * If the `name` attribute is specified, the form controller is published onto the current scope under
 * this name.
 *
 * ## Alias: {@link ng.directive:ngForm `ngForm`}
 *
 * In AngularJS, forms can be nested. This means that the outer form is valid when all of the child
 * forms are valid as well. However, browsers do not allow nesting of `<form>` elements, so
 * AngularJS provides the {@link ng.directive:ngForm `ngForm`} directive, which behaves identically to
 * `form` but can be nested. Nested forms can be useful, for example, if the validity of a sub-group
 * of controls needs to be determined.
 *
 * ## CSS classes
 *  - `ng-valid` is set if the form is valid.
 *  - `ng-invalid` is set if the form is invalid.
 *  - `ng-pending` is set if the form is pending.
 *  - `ng-pristine` is set if the form is pristine.
 *  - `ng-dirty` is set if the form is dirty.
 *  - `ng-submitted` is set if the form was submitted.
 *
 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
 *
 *
 * ## Submitting a form and preventing the default action
 *
 * Since the role of forms in client-side AngularJS applications is different than in classical
 * roundtrip apps, it is desirable for the browser not to translate the form submission into a full
 * page reload that sends the data to the server. Instead some javascript logic should be triggered
 * to handle the form submission in an application-specific way.
 *
 * For this reason, AngularJS prevents the default action (form submission to the server) unless the
 * `<form>` element has an `action` attribute specified.
 *
 * You can use one of the following two ways to specify what javascript method should be called when
 * a form is submitted:
 *
 * - {@link ng.directive:ngSubmit ngSubmit} directive on the form element
 * - {@link ng.directive:ngClick ngClick} directive on the first
  *  button or input field of type submit (input[type=submit])
 *
 * To prevent double execution of the handler, use only one of the {@link ng.directive:ngSubmit ngSubmit}
 * or {@link ng.directive:ngClick ngClick} directives.
 * This is because of the following form submission rules in the HTML specification:
 *
 * - If a form has only one input field then hitting enter in this field triggers form submit
 * (`ngSubmit`)
 * - if a form has 2+ input fields and no buttons or input[type=submit] then hitting enter
 * doesn't trigger submit
 * - if a form has one or more input fields and one or more buttons or input[type=submit] then
 * hitting enter in any of the input fields will trigger the click handler on the *first* button or
 * input[type=submit] (`ngClick`) *and* a submit handler on the enclosing form (`ngSubmit`)
 *
 * Any pending `ngModelOptions` changes will take place immediately when an enclosing form is
 * submitted. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
 * to have access to the updated model.
 *
 * @animations
 * Animations in ngForm are triggered when any of the associated CSS classes are added and removed.
 * These classes are: `.ng-pristine`, `.ng-dirty`, `.ng-invalid` and `.ng-valid` as well as any
 * other validations that are performed within the form. Animations in ngForm are similar to how
 * they work in ngClass and animations can be hooked into using CSS transitions, keyframes as well
 * as JS animations.
 *
 * The following example shows a simple way to utilize CSS transitions to style a form element
 * that has been rendered as invalid after it has been validated:
 *
 * <pre>
 * //be sure to include ngAnimate as a module to hook into more
 * //advanced animations
 * .my-form {
 *   transition:0.5s linear all;
 *   background: white;
 * }
 * .my-form.ng-invalid {
 *   background: red;
 *   color:white;
 * }
 * </pre>
 *
 * @example
    <example name="ng-form" deps="angular-animate.js" animations="true" fixBase="true" module="formExample">
      <file name="index.html">
       <script>
         angular.module('formExample', [])
           .controller('FormController', ['$scope', function($scope) {
             $scope.userType = 'guest';
           }]);
       </script>
       <style>
        .my-form {
          transition:all linear 0.5s;
          background: transparent;
        }
        .my-form.ng-invalid {
          background: red;
        }
       </style>
       <form name="myForm" ng-controller="FormController" class="my-form">
         userType: <input name="input" ng-model="userType" required>
         <span class="error" ng-show="myForm.input.$error.required">Required!</span><br>
         <code>userType = {{userType}}</code><br>
         <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br>
         <code>myForm.input.$error = {{myForm.input.$error}}</code><br>
         <code>myForm.$valid = {{myForm.$valid}}</code><br>
         <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br>
        </form>
      </file>
      <file name="protractor.js" type="protractor">
        it('should initialize to model', function() {
          var userType = element(by.binding('userType'));
          var valid = element(by.binding('myForm.input.$valid'));

          expect(userType.getText()).toContain('guest');
          expect(valid.getText()).toContain('true');
        });

        it('should be invalid if empty', function() {
          var userType = element(by.binding('userType'));
          var valid = element(by.binding('myForm.input.$valid'));
          var userInput = element(by.model('userType'));

          userInput.clear();
          userInput.sendKeys('');

          expect(userType.getText()).toEqual('userType =');
          expect(valid.getText()).toContain('false');
        });
      </file>
    </example>
 *
 * @param {string=} name Name of the form. If specified, the form controller will be published into
 *                       related scope, under this name.
 */
var formDirectiveFactory = function(isNgForm) {
  return ['$timeout', '$parse', function($timeout, $parse) {
    var formDirective = {
      name: 'form',
      restrict: isNgForm ? 'EAC' : 'E',
      require: ['form', '^^?form'], //first is the form's own ctrl, second is an optional parent form
      controller: FormController,
      compile: function ngFormCompile(formElement, attr) {
        // Setup initial state of the control
        formElement.addClass(PRISTINE_CLASS).addClass(VALID_CLASS);

        var nameAttr = attr.name ? 'name' : (isNgForm && attr.ngForm ? 'ngForm' : false);

        return {
          pre: function ngFormPreLink(scope, formElement, attr, ctrls) {
            var controller = ctrls[0];

            // if `action` attr is not present on the form, prevent the default action (submission)
            if (!('action' in attr)) {
              // we can't use jq events because if a form is destroyed during submission the default
              // action is not prevented. see #1238
              //
              // IE 9 is not affected because it doesn't fire a submit event and try to do a full
              // page reload if the form was destroyed by submission of the form via a click handler
              // on a button in the form. Looks like an IE9 specific bug.
              var handleFormSubmission = function(event) {
                scope.$apply(function() {
                  controller.$commitViewValue();
                  controller.$setSubmitted();
                });

                event.preventDefault();
              };

              formElement[0].addEventListener('submit', handleFormSubmission);

              // unregister the preventDefault listener so that we don't not leak memory but in a
              // way that will achieve the prevention of the default action.
              formElement.on('$destroy', function() {
                $timeout(function() {
                  formElement[0].removeEventListener('submit', handleFormSubmission);
                }, 0, false);
              });
            }

            var parentFormCtrl = ctrls[1] || controller.$$parentForm;
            parentFormCtrl.$addControl(controller);

            var setter = nameAttr ? getSetter(controller.$name) : noop;

            if (nameAttr) {
              setter(scope, controller);
              attr.$observe(nameAttr, function(newValue) {
                if (controller.$name === newValue) return;
                setter(scope, undefined);
                controller.$$parentForm.$$renameControl(controller, newValue);
                setter = getSetter(controller.$name);
                setter(scope, controller);
              });
            }
            formElement.on('$destroy', function() {
              controller.$$parentForm.$removeControl(controller);
              setter(scope, undefined);
              extend(controller, nullFormCtrl); //stop propagating child destruction handlers upwards
            });
          }
        };
      }
    };

    return formDirective;

    function getSetter(expression) {
      if (expression === '') {
        //create an assignable expression, so forms with an empty name can be renamed later
        return $parse('this[""]').assign;
      }
      return $parse(expression).assign || noop;
    }
  }];
};

var formDirective = formDirectiveFactory();
var ngFormDirective = formDirectiveFactory(true);



// helper methods
function setupValidity(instance) {
  instance.$$classCache = {};
  instance.$$classCache[INVALID_CLASS] = !(instance.$$classCache[VALID_CLASS] = instance.$$element.hasClass(VALID_CLASS));
}
function addSetValidityMethod(context) {
  var clazz = context.clazz,
      set = context.set,
      unset = context.unset;

  clazz.prototype.$setValidity = function(validationErrorKey, state, controller) {
    if (isUndefined(state)) {
      createAndSet(this, '$pending', validationErrorKey, controller);
    } else {
      unsetAndCleanup(this, '$pending', validationErrorKey, controller);
    }
    if (!isBoolean(state)) {
      unset(this.$error, validationErrorKey, controller);
      unset(this.$$success, validationErrorKey, controller);
    } else {
      if (state) {
        unset(this.$error, validationErrorKey, controller);
        set(this.$$success, validationErrorKey, controller);
      } else {
        set(this.$error, validationErrorKey, controller);
        unset(this.$$success, validationErrorKey, controller);
      }
    }
    if (this.$pending) {
      cachedToggleClass(this, PENDING_CLASS, true);
      this.$valid = this.$invalid = undefined;
      toggleValidationCss(this, '', null);
    } else {
      cachedToggleClass(this, PENDING_CLASS, false);
      this.$valid = isObjectEmpty(this.$error);
      this.$invalid = !this.$valid;
      toggleValidationCss(this, '', this.$valid);
    }

    // re-read the state as the set/unset methods could have
    // combined state in this.$error[validationError] (used for forms),
    // where setting/unsetting only increments/decrements the value,
    // and does not replace it.
    var combinedState;
    if (this.$pending && this.$pending[validationErrorKey]) {
      combinedState = undefined;
    } else if (this.$error[validationErrorKey]) {
      combinedState = false;
    } else if (this.$$success[validationErrorKey]) {
      combinedState = true;
    } else {
      combinedState = null;
    }

    toggleValidationCss(this, validationErrorKey, combinedState);
    this.$$parentForm.$setValidity(validationErrorKey, combinedState, this);
  };

  function createAndSet(ctrl, name, value, controller) {
    if (!ctrl[name]) {
      ctrl[name] = {};
    }
    set(ctrl[name], value, controller);
  }

  function unsetAndCleanup(ctrl, name, value, controller) {
    if (ctrl[name]) {
      unset(ctrl[name], value, controller);
    }
    if (isObjectEmpty(ctrl[name])) {
      ctrl[name] = undefined;
    }
  }

  function cachedToggleClass(ctrl, className, switchValue) {
    if (switchValue && !ctrl.$$classCache[className]) {
      ctrl.$$animate.addClass(ctrl.$$element, className);
      ctrl.$$classCache[className] = true;
    } else if (!switchValue && ctrl.$$classCache[className]) {
      ctrl.$$animate.removeClass(ctrl.$$element, className);
      ctrl.$$classCache[className] = false;
    }
  }

  function toggleValidationCss(ctrl, validationErrorKey, isValid) {
    validationErrorKey = validationErrorKey ? '-' + snake_case(validationErrorKey, '-') : '';

    cachedToggleClass(ctrl, VALID_CLASS + validationErrorKey, isValid === true);
    cachedToggleClass(ctrl, INVALID_CLASS + validationErrorKey, isValid === false);
  }
}

function isObjectEmpty(obj) {
  if (obj) {
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        return false;
      }
    }
  }
  return true;
}

/* global
  VALID_CLASS: false,
  INVALID_CLASS: false,
  PRISTINE_CLASS: false,
  DIRTY_CLASS: false,
  ngModelMinErr: false
*/

// Regex code was initially obtained from SO prior to modification: https://stackoverflow.com/questions/3143070/javascript-regex-iso-datetime#answer-3143231
var ISO_DATE_REGEXP = /^\d{4,}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+(?:[+-][0-2]\d:[0-5]\d|Z)$/;
// See valid URLs in RFC3987 (http://tools.ietf.org/html/rfc3987)
// Note: We are being more lenient, because browsers are too.
//   1. Scheme
//   2. Slashes
//   3. Username
//   4. Password
//   5. Hostname
//   6. Port
//   7. Path
//   8. Query
//   9. Fragment
//                 1111111111111111 222   333333    44444        55555555555555555555555     666     77777777     8888888     999
var URL_REGEXP = /^[a-z][a-z\d.+-]*:\/*(?:[^:@]+(?::[^@]+)?@)?(?:[^\s:/?#]+|\[[a-f\d:]+])(?::\d+)?(?:\/[^?#]*)?(?:\?[^#]*)?(?:#.*)?$/i;
// eslint-disable-next-line max-len
var EMAIL_REGEXP = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;
var NUMBER_REGEXP = /^\s*(-|\+)?(\d+|(\d*(\.\d*)))([eE][+-]?\d+)?\s*$/;
var DATE_REGEXP = /^(\d{4,})-(\d{2})-(\d{2})$/;
var DATETIMELOCAL_REGEXP = /^(\d{4,})-(\d\d)-(\d\d)T(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
var WEEK_REGEXP = /^(\d{4,})-W(\d\d)$/;
var MONTH_REGEXP = /^(\d{4,})-(\d\d)$/;
var TIME_REGEXP = /^(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;

var PARTIAL_VALIDATION_EVENTS = 'keydown wheel mousedown';
var PARTIAL_VALIDATION_TYPES = createMap();
forEach('date,datetime-local,month,time,week'.split(','), function(type) {
  PARTIAL_VALIDATION_TYPES[type] = true;
});

var inputType = {

  /**
   * @ngdoc input
   * @name input[text]
   *
   * @description
   * Standard HTML text input with AngularJS data binding, inherited by most of the `input` elements.
   *
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} required Adds `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
   *    any length.
   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
   *    that contains the regular expression body that will be converted to a regular expression
   *    as in the ngPattern directive.
   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
   *    If the expression evaluates to a RegExp object, then this is used directly.
   *    If the expression evaluates to a string, then it will be converted to a RegExp
   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
   *    `new RegExp('^abc$')`.<br />
   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
   *    start at the index of the last search's match, thus not taking the whole input value into
   *    account.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
   *    This parameter is ignored for input[type=password] controls, which will never trim the
   *    input.
   *
   * @example
      <example name="text-input-directive" module="textInputExample">
        <file name="index.html">
         <script>
           angular.module('textInputExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.example = {
                 text: 'guest',
                 word: /^\s*\w*\s*$/
               };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>Single word:
             <input type="text" name="input" ng-model="example.text"
                    ng-pattern="example.word" required ng-trim="false">
           </label>
           <div role="alert">
             <span class="error" ng-show="myForm.input.$error.required">
               Required!</span>
             <span class="error" ng-show="myForm.input.$error.pattern">
               Single word only!</span>
           </div>
           <code>text = {{example.text}}</code><br/>
           <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br/>
           <code>myForm.input.$error = {{myForm.input.$error}}</code><br/>
           <code>myForm.$valid = {{myForm.$valid}}</code><br/>
           <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br/>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          var text = element(by.binding('example.text'));
          var valid = element(by.binding('myForm.input.$valid'));
          var input = element(by.model('example.text'));

          it('should initialize to model', function() {
            expect(text.getText()).toContain('guest');
            expect(valid.getText()).toContain('true');
          });

          it('should be invalid if empty', function() {
            input.clear();
            input.sendKeys('');

            expect(text.getText()).toEqual('text =');
            expect(valid.getText()).toContain('false');
          });

          it('should be invalid if multi word', function() {
            input.clear();
            input.sendKeys('hello world');

            expect(valid.getText()).toContain('false');
          });
        </file>
      </example>
   */
  'text': textInputType,

    /**
     * @ngdoc input
     * @name input[date]
     *
     * @description
     * Input with date validation and transformation. In browsers that do not yet support
     * the HTML5 date input, a text element will be used. In that case, text must be entered in a valid ISO-8601
     * date format (yyyy-MM-dd), for example: `2009-01-06`. Since many
     * modern browsers do not yet support this input type, it is important to provide cues to users on the
     * expected input format via a placeholder or label.
     *
     * The model must always be a Date object, otherwise AngularJS will throw an error.
     * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
     *
     * The timezone to be used to read/write the `Date` instance in the model can be defined using
     * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
     *
     * @param {string} ngModel Assignable AngularJS expression to data-bind to.
     * @param {string=} name Property name of the form under which the control is published.
     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
     *   valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
     *   (e.g. `min="{{minDate | date:'yyyy-MM-dd'}}"`). Note that `min` will also add native HTML5
     *   constraint validation.
     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be
     *   a valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
     *   (e.g. `max="{{maxDate | date:'yyyy-MM-dd'}}"`). Note that `max` will also add native HTML5
     *   constraint validation.
     * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO date string
     *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
     * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO date string
     *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
     * @param {string=} required Sets `required` validation error key if the value is not entered.
     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
     *    `required` when you want to data-bind to the `required` attribute.
     * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
     *    interaction with the input element.
     *
     * @example
     <example name="date-input-directive" module="dateInputExample">
     <file name="index.html">
       <script>
          angular.module('dateInputExample', [])
            .controller('DateController', ['$scope', function($scope) {
              $scope.example = {
                value: new Date(2013, 9, 22)
              };
            }]);
       </script>
       <form name="myForm" ng-controller="DateController as dateCtrl">
          <label for="exampleInput">Pick a date in 2013:</label>
          <input type="date" id="exampleInput" name="input" ng-model="example.value"
              placeholder="yyyy-MM-dd" min="2013-01-01" max="2013-12-31" required />
          <div role="alert">
            <span class="error" ng-show="myForm.input.$error.required">
                Required!</span>
            <span class="error" ng-show="myForm.input.$error.date">
                Not a valid date!</span>
           </div>
           <tt>value = {{example.value | date: "yyyy-MM-dd"}}</tt><br/>
           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
       </form>
     </file>
     <file name="protractor.js" type="protractor">
        var value = element(by.binding('example.value | date: "yyyy-MM-dd"'));
        var valid = element(by.binding('myForm.input.$valid'));

        // currently protractor/webdriver does not support
        // sending keys to all known HTML5 input controls
        // for various browsers (see https://github.com/angular/protractor/issues/562).
        function setInput(val) {
          // set the value of the element and force validation.
          var scr = "var ipt = document.getElementById('exampleInput'); " +
          "ipt.value = '" + val + "';" +
          "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
          browser.executeScript(scr);
        }

        it('should initialize to model', function() {
          expect(value.getText()).toContain('2013-10-22');
          expect(valid.getText()).toContain('myForm.input.$valid = true');
        });

        it('should be invalid if empty', function() {
          setInput('');
          expect(value.getText()).toEqual('value =');
          expect(valid.getText()).toContain('myForm.input.$valid = false');
        });

        it('should be invalid if over max', function() {
          setInput('2015-01-01');
          expect(value.getText()).toContain('');
          expect(valid.getText()).toContain('myForm.input.$valid = false');
        });
     </file>
     </example>
     */
  'date': createDateInputType('date', DATE_REGEXP,
         createDateParser(DATE_REGEXP, ['yyyy', 'MM', 'dd']),
         'yyyy-MM-dd'),

   /**
    * @ngdoc input
    * @name input[datetime-local]
    *
    * @description
    * Input with datetime validation and transformation. In browsers that do not yet support
    * the HTML5 date input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
    * local datetime format (yyyy-MM-ddTHH:mm:ss), for example: `2010-12-28T14:57:00`.
    *
    * The model must always be a Date object, otherwise AngularJS will throw an error.
    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
    *
    * The timezone to be used to read/write the `Date` instance in the model can be defined using
    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
    *
    * The format of the displayed time can be adjusted with the
    * {@link ng.directive:ngModelOptions#ngModelOptions-arguments ngModelOptions} `timeSecondsFormat`
    * and `timeStripZeroSeconds`.
    *
    * @param {string} ngModel Assignable AngularJS expression to data-bind to.
    * @param {string=} name Property name of the form under which the control is published.
    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
    *   inside this attribute (e.g. `min="{{minDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
    *   Note that `min` will also add native HTML5 constraint validation.
    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
    *   inside this attribute (e.g. `max="{{maxDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
    *   Note that `max` will also add native HTML5 constraint validation.
    * @param {(date|string)=} ngMin Sets the `min` validation error key to the Date / ISO datetime string
    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
    * @param {(date|string)=} ngMax Sets the `max` validation error key to the Date / ISO datetime string
    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
    * @param {string=} required Sets `required` validation error key if the value is not entered.
    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
    *    `required` when you want to data-bind to the `required` attribute.
    * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
    *    interaction with the input element.
    *
    * @example
    <example name="datetimelocal-input-directive" module="dateExample">
    <file name="index.html">
      <script>
        angular.module('dateExample', [])
          .controller('DateController', ['$scope', function($scope) {
            $scope.example = {
              value: new Date(2010, 11, 28, 14, 57)
            };
          }]);
      </script>
      <form name="myForm" ng-controller="DateController as dateCtrl">
        <label for="exampleInput">Pick a date between in 2013:</label>
        <input type="datetime-local" id="exampleInput" name="input" ng-model="example.value"
            placeholder="yyyy-MM-ddTHH:mm:ss" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" required />
        <div role="alert">
          <span class="error" ng-show="myForm.input.$error.required">
              Required!</span>
          <span class="error" ng-show="myForm.input.$error.datetimelocal">
              Not a valid date!</span>
        </div>
        <tt>value = {{example.value | date: "yyyy-MM-ddTHH:mm:ss"}}</tt><br/>
        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
      </form>
    </file>
    <file name="protractor.js" type="protractor">
      var value = element(by.binding('example.value | date: "yyyy-MM-ddTHH:mm:ss"'));
      var valid = element(by.binding('myForm.input.$valid'));

      // currently protractor/webdriver does not support
      // sending keys to all known HTML5 input controls
      // for various browsers (https://github.com/angular/protractor/issues/562).
      function setInput(val) {
        // set the value of the element and force validation.
        var scr = "var ipt = document.getElementById('exampleInput'); " +
        "ipt.value = '" + val + "';" +
        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
        browser.executeScript(scr);
      }

      it('should initialize to model', function() {
        expect(value.getText()).toContain('2010-12-28T14:57:00');
        expect(valid.getText()).toContain('myForm.input.$valid = true');
      });

      it('should be invalid if empty', function() {
        setInput('');
        expect(value.getText()).toEqual('value =');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });

      it('should be invalid if over max', function() {
        setInput('2015-01-01T23:59:00');
        expect(value.getText()).toContain('');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });
    </file>
    </example>
    */
  'datetime-local': createDateInputType('datetimelocal', DATETIMELOCAL_REGEXP,
      createDateParser(DATETIMELOCAL_REGEXP, ['yyyy', 'MM', 'dd', 'HH', 'mm', 'ss', 'sss']),
      'yyyy-MM-ddTHH:mm:ss.sss'),

  /**
   * @ngdoc input
   * @name input[time]
   *
   * @description
   * Input with time validation and transformation. In browsers that do not yet support
   * the HTML5 time input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
   * local time format (HH:mm:ss), for example: `14:57:00`. Model must be a Date object. This binding will always output a
   * Date object to the model of January 1, 1970, or local date `new Date(1970, 0, 1, HH, mm, ss)`.
   *
   * The model must always be a Date object, otherwise AngularJS will throw an error.
   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
   *
   * The timezone to be used to read/write the `Date` instance in the model can be defined using
   * {@link ng.directive:ngModelOptions#ngModelOptions-arguments ngModelOptions}. By default,
   * this is the timezone of the browser.
   *
   * The format of the displayed time can be adjusted with the
   * {@link ng.directive:ngModelOptions#ngModelOptions-arguments ngModelOptions} `timeSecondsFormat`
   * and `timeStripZeroSeconds`.
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
   *   attribute (e.g. `min="{{minTime | date:'HH:mm:ss'}}"`). Note that `min` will also add
   *   native HTML5 constraint validation.
   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
   *   attribute (e.g. `max="{{maxTime | date:'HH:mm:ss'}}"`). Note that `max` will also add
   *   native HTML5 constraint validation.
   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO time string the
   *   `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO time string the
   *   `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
   <example name="time-input-directive" module="timeExample">
   <file name="index.html">
     <script>
      angular.module('timeExample', [])
        .controller('DateController', ['$scope', function($scope) {
          $scope.example = {
            value: new Date(1970, 0, 1, 14, 57, 0)
          };
        }]);
     </script>
     <form name="myForm" ng-controller="DateController as dateCtrl">
        <label for="exampleInput">Pick a time between 8am and 5pm:</label>
        <input type="time" id="exampleInput" name="input" ng-model="example.value"
            placeholder="HH:mm:ss" min="08:00:00" max="17:00:00" required />
        <div role="alert">
          <span class="error" ng-show="myForm.input.$error.required">
              Required!</span>
          <span class="error" ng-show="myForm.input.$error.time">
              Not a valid date!</span>
        </div>
        <tt>value = {{example.value | date: "HH:mm:ss"}}</tt><br/>
        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
     </form>
   </file>
   <file name="protractor.js" type="protractor">
      var value = element(by.binding('example.value | date: "HH:mm:ss"'));
      var valid = element(by.binding('myForm.input.$valid'));

      // currently protractor/webdriver does not support
      // sending keys to all known HTML5 input controls
      // for various browsers (https://github.com/angular/protractor/issues/562).
      function setInput(val) {
        // set the value of the element and force validation.
        var scr = "var ipt = document.getElementById('exampleInput'); " +
        "ipt.value = '" + val + "';" +
        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
        browser.executeScript(scr);
      }

      it('should initialize to model', function() {
        expect(value.getText()).toContain('14:57:00');
        expect(valid.getText()).toContain('myForm.input.$valid = true');
      });

      it('should be invalid if empty', function() {
        setInput('');
        expect(value.getText()).toEqual('value =');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });

      it('should be invalid if over max', function() {
        setInput('23:59:00');
        expect(value.getText()).toContain('');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });
   </file>
   </example>
   */
  'time': createDateInputType('time', TIME_REGEXP,
      createDateParser(TIME_REGEXP, ['HH', 'mm', 'ss', 'sss']),
     'HH:mm:ss.sss'),

   /**
    * @ngdoc input
    * @name input[week]
    *
    * @description
    * Input with week-of-the-year validation and transformation to Date. In browsers that do not yet support
    * the HTML5 week input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
    * week format (yyyy-W##), for example: `2013-W02`.
    *
    * The model must always be a Date object, otherwise AngularJS will throw an error.
    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
    *
    * The value of the resulting Date object will be set to Thursday at 00:00:00 of the requested week,
    * due to ISO-8601 week numbering standards. Information on ISO's system for numbering the weeks of the
    * year can be found at: https://en.wikipedia.org/wiki/ISO_8601#Week_dates
    *
    * The timezone to be used to read/write the `Date` instance in the model can be defined using
    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
    *
    * @param {string} ngModel Assignable AngularJS expression to data-bind to.
    * @param {string=} name Property name of the form under which the control is published.
    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
    *   attribute (e.g. `min="{{minWeek | date:'yyyy-Www'}}"`). Note that `min` will also add
    *   native HTML5 constraint validation.
    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
    *   attribute (e.g. `max="{{maxWeek | date:'yyyy-Www'}}"`). Note that `max` will also add
    *   native HTML5 constraint validation.
    * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
    * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
    * @param {string=} required Sets `required` validation error key if the value is not entered.
    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
    *    `required` when you want to data-bind to the `required` attribute.
    * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
    *    interaction with the input element.
    *
    * @example
    <example name="week-input-directive" module="weekExample">
    <file name="index.html">
      <script>
      angular.module('weekExample', [])
        .controller('DateController', ['$scope', function($scope) {
          $scope.example = {
            value: new Date(2013, 0, 3)
          };
        }]);
      </script>
      <form name="myForm" ng-controller="DateController as dateCtrl">
        <label>Pick a date between in 2013:
          <input id="exampleInput" type="week" name="input" ng-model="example.value"
                 placeholder="YYYY-W##" min="2012-W32"
                 max="2013-W52" required />
        </label>
        <div role="alert">
          <span class="error" ng-show="myForm.input.$error.required">
              Required!</span>
          <span class="error" ng-show="myForm.input.$error.week">
              Not a valid date!</span>
        </div>
        <tt>value = {{example.value | date: "yyyy-Www"}}</tt><br/>
        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
      </form>
    </file>
    <file name="protractor.js" type="protractor">
      var value = element(by.binding('example.value | date: "yyyy-Www"'));
      var valid = element(by.binding('myForm.input.$valid'));

      // currently protractor/webdriver does not support
      // sending keys to all known HTML5 input controls
      // for various browsers (https://github.com/angular/protractor/issues/562).
      function setInput(val) {
        // set the value of the element and force validation.
        var scr = "var ipt = document.getElementById('exampleInput'); " +
        "ipt.value = '" + val + "';" +
        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
        browser.executeScript(scr);
      }

      it('should initialize to model', function() {
        expect(value.getText()).toContain('2013-W01');
        expect(valid.getText()).toContain('myForm.input.$valid = true');
      });

      it('should be invalid if empty', function() {
        setInput('');
        expect(value.getText()).toEqual('value =');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });

      it('should be invalid if over max', function() {
        setInput('2015-W01');
        expect(value.getText()).toContain('');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });
    </file>
    </example>
    */
  'week': createDateInputType('week', WEEK_REGEXP, weekParser, 'yyyy-Www'),

  /**
   * @ngdoc input
   * @name input[month]
   *
   * @description
   * Input with month validation and transformation. In browsers that do not yet support
   * the HTML5 month input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
   * month format (yyyy-MM), for example: `2009-01`.
   *
   * The model must always be a Date object, otherwise AngularJS will throw an error.
   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
   * If the model is not set to the first of the month, the next view to model update will set it
   * to the first of the month.
   *
   * The timezone to be used to read/write the `Date` instance in the model can be defined using
   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
   *   attribute (e.g. `min="{{minMonth | date:'yyyy-MM'}}"`). Note that `min` will also add
   *   native HTML5 constraint validation.
   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
   *   attribute (e.g. `max="{{maxMonth | date:'yyyy-MM'}}"`). Note that `max` will also add
   *   native HTML5 constraint validation.
   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
   *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
   *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.

   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
   <example name="month-input-directive" module="monthExample">
   <file name="index.html">
     <script>
      angular.module('monthExample', [])
        .controller('DateController', ['$scope', function($scope) {
          $scope.example = {
            value: new Date(2013, 9, 1)
          };
        }]);
     </script>
     <form name="myForm" ng-controller="DateController as dateCtrl">
       <label for="exampleInput">Pick a month in 2013:</label>
       <input id="exampleInput" type="month" name="input" ng-model="example.value"
          placeholder="yyyy-MM" min="2013-01" max="2013-12" required />
       <div role="alert">
         <span class="error" ng-show="myForm.input.$error.required">
            Required!</span>
         <span class="error" ng-show="myForm.input.$error.month">
            Not a valid month!</span>
       </div>
       <tt>value = {{example.value | date: "yyyy-MM"}}</tt><br/>
       <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
       <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
       <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
       <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
     </form>
   </file>
   <file name="protractor.js" type="protractor">
      var value = element(by.binding('example.value | date: "yyyy-MM"'));
      var valid = element(by.binding('myForm.input.$valid'));

      // currently protractor/webdriver does not support
      // sending keys to all known HTML5 input controls
      // for various browsers (https://github.com/angular/protractor/issues/562).
      function setInput(val) {
        // set the value of the element and force validation.
        var scr = "var ipt = document.getElementById('exampleInput'); " +
        "ipt.value = '" + val + "';" +
        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
        browser.executeScript(scr);
      }

      it('should initialize to model', function() {
        expect(value.getText()).toContain('2013-10');
        expect(valid.getText()).toContain('myForm.input.$valid = true');
      });

      it('should be invalid if empty', function() {
        setInput('');
        expect(value.getText()).toEqual('value =');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });

      it('should be invalid if over max', function() {
        setInput('2015-01');
        expect(value.getText()).toContain('');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });
   </file>
   </example>
   */
  'month': createDateInputType('month', MONTH_REGEXP,
     createDateParser(MONTH_REGEXP, ['yyyy', 'MM']),
     'yyyy-MM'),

  /**
   * @ngdoc input
   * @name input[number]
   *
   * @description
   * Text input with number validation and transformation. Sets the `number` validation
   * error if not a valid number.
   *
   * <div class="alert alert-warning">
   * The model must always be of type `number` otherwise AngularJS will throw an error.
   * Be aware that a string containing a number is not enough. See the {@link ngModel:numfmt}
   * error docs for more information and an example of how to convert your model if necessary.
   * </div>
   *
   *
   *
   * @knownIssue
   *
   * ### HTML5 constraint validation and `allowInvalid`
   *
   * In browsers that follow the
   * [HTML5 specification](https://html.spec.whatwg.org/multipage/forms.html#number-state-%28type=number%29),
   * `input[number]` does not work as expected with {@link ngModelOptions `ngModelOptions.allowInvalid`}.
   * If a non-number is entered in the input, the browser will report the value as an empty string,
   * which means the view / model values in `ngModel` and subsequently the scope value
   * will also be an empty string.
   *
   * @knownIssue
   *
   * ### Large numbers and `step` validation
   *
   * The `step` validation will not work correctly for very large numbers (e.g. 9999999999) due to
   * Javascript's arithmetic limitations. If you need to handle large numbers, purpose-built
   * libraries (e.g. https://github.com/MikeMcl/big.js/), can be included into AngularJS by
   * {@link guide/forms#modifying-built-in-validators overwriting the validators}
   * for `number` and / or `step`, or by {@link guide/forms#custom-validation applying custom validators}
   * to an `input[text]` element. The source for `input[number]` type can be used as a starting
   * point for both implementations.
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
   *    Can be interpolated.
   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
   *    Can be interpolated.
   * @param {string=} ngMin Like `min`, sets the `min` validation error key if the value entered is less than `ngMin`,
   *    but does not trigger HTML5 native validation. Takes an expression.
   * @param {string=} ngMax Like `max`, sets the `max` validation error key if the value entered is greater than `ngMax`,
   *    but does not trigger HTML5 native validation. Takes an expression.
   * @param {string=} step Sets the `step` validation error key if the value entered does not fit the `step` constraint.
   *    Can be interpolated.
   * @param {string=} ngStep Like `step`, sets the `step` validation error key if the value entered does not fit the `ngStep` constraint,
   *    but does not trigger HTML5 native validation. Takes an expression.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
   *    any length.
   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
   *    that contains the regular expression body that will be converted to a regular expression
   *    as in the ngPattern directive.
   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
   *    If the expression evaluates to a RegExp object, then this is used directly.
   *    If the expression evaluates to a string, then it will be converted to a RegExp
   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
   *    `new RegExp('^abc$')`.<br />
   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
   *    start at the index of the last search's match, thus not taking the whole input value into
   *    account.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
      <example name="number-input-directive" module="numberExample">
        <file name="index.html">
         <script>
           angular.module('numberExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.example = {
                 value: 12
               };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>Number:
             <input type="number" name="input" ng-model="example.value"
                    min="0" max="99" required>
          </label>
           <div role="alert">
             <span class="error" ng-show="myForm.input.$error.required">
               Required!</span>
             <span class="error" ng-show="myForm.input.$error.number">
               Not valid number!</span>
           </div>
           <tt>value = {{example.value}}</tt><br/>
           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          var value = element(by.binding('example.value'));
          var valid = element(by.binding('myForm.input.$valid'));
          var input = element(by.model('example.value'));

          it('should initialize to model', function() {
            expect(value.getText()).toContain('12');
            expect(valid.getText()).toContain('true');
          });

          it('should be invalid if empty', function() {
            input.clear();
            input.sendKeys('');
            expect(value.getText()).toEqual('value =');
            expect(valid.getText()).toContain('false');
          });

          it('should be invalid if over max', function() {
            input.clear();
            input.sendKeys('123');
            expect(value.getText()).toEqual('value =');
            expect(valid.getText()).toContain('false');
          });
        </file>
      </example>
   */
  'number': numberInputType,


  /**
   * @ngdoc input
   * @name input[url]
   *
   * @description
   * Text input with URL validation. Sets the `url` validation error key if the content is not a
   * valid URL.
   *
   * <div class="alert alert-warning">
   * **Note:** `input[url]` uses a regex to validate urls that is derived from the regex
   * used in Chromium. If you need stricter validation, you can use `ng-pattern` or modify
   * the built-in validators (see the {@link guide/forms Forms guide})
   * </div>
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
   *    any length.
   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
   *    that contains the regular expression body that will be converted to a regular expression
   *    as in the ngPattern directive.
   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
   *    If the expression evaluates to a RegExp object, then this is used directly.
   *    If the expression evaluates to a string, then it will be converted to a RegExp
   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
   *    `new RegExp('^abc$')`.<br />
   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
   *    start at the index of the last search's match, thus not taking the whole input value into
   *    account.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
      <example name="url-input-directive" module="urlExample">
        <file name="index.html">
         <script>
           angular.module('urlExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.url = {
                 text: 'http://google.com'
               };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>URL:
             <input type="url" name="input" ng-model="url.text" required>
           <label>
           <div role="alert">
             <span class="error" ng-show="myForm.input.$error.required">
               Required!</span>
             <span class="error" ng-show="myForm.input.$error.url">
               Not valid url!</span>
           </div>
           <tt>text = {{url.text}}</tt><br/>
           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
           <tt>myForm.$error.url = {{!!myForm.$error.url}}</tt><br/>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          var text = element(by.binding('url.text'));
          var valid = element(by.binding('myForm.input.$valid'));
          var input = element(by.model('url.text'));

          it('should initialize to model', function() {
            expect(text.getText()).toContain('http://google.com');
            expect(valid.getText()).toContain('true');
          });

          it('should be invalid if empty', function() {
            input.clear();
            input.sendKeys('');

            expect(text.getText()).toEqual('text =');
            expect(valid.getText()).toContain('false');
          });

          it('should be invalid if not url', function() {
            input.clear();
            input.sendKeys('box');

            expect(valid.getText()).toContain('false');
          });
        </file>
      </example>
   */
  'url': urlInputType,


  /**
   * @ngdoc input
   * @name input[email]
   *
   * @description
   * Text input with email validation. Sets the `email` validation error key if not a valid email
   * address.
   *
   * <div class="alert alert-warning">
   * **Note:** `input[email]` uses a regex to validate email addresses that is derived from the regex
   * used in Chromium, which may not fulfill your app's requirements.
   * If you need stricter (e.g. requiring a top-level domain), or more relaxed validation
   * (e.g. allowing IPv6 address literals) you can use `ng-pattern` or
   * modify the built-in validators (see the {@link guide/forms Forms guide}).
   * </div>
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
   *    any length.
   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
   *    that contains the regular expression body that will be converted to a regular expression
   *    as in the ngPattern directive.
   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
   *    If the expression evaluates to a RegExp object, then this is used directly.
   *    If the expression evaluates to a string, then it will be converted to a RegExp
   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
   *    `new RegExp('^abc$')`.<br />
   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
   *    start at the index of the last search's match, thus not taking the whole input value into
   *    account.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
      <example name="email-input-directive" module="emailExample">
        <file name="index.html">
         <script>
           angular.module('emailExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.email = {
                 text: 'me@example.com'
               };
             }]);
         </script>
           <form name="myForm" ng-controller="ExampleController">
             <label>Email:
               <input type="email" name="input" ng-model="email.text" required>
             </label>
             <div role="alert">
               <span class="error" ng-show="myForm.input.$error.required">
                 Required!</span>
               <span class="error" ng-show="myForm.input.$error.email">
                 Not valid email!</span>
             </div>
             <tt>text = {{email.text}}</tt><br/>
             <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
             <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
             <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
             <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
             <tt>myForm.$error.email = {{!!myForm.$error.email}}</tt><br/>
           </form>
         </file>
        <file name="protractor.js" type="protractor">
          var text = element(by.binding('email.text'));
          var valid = element(by.binding('myForm.input.$valid'));
          var input = element(by.model('email.text'));

          it('should initialize to model', function() {
            expect(text.getText()).toContain('me@example.com');
            expect(valid.getText()).toContain('true');
          });

          it('should be invalid if empty', function() {
            input.clear();
            input.sendKeys('');
            expect(text.getText()).toEqual('text =');
            expect(valid.getText()).toContain('false');
          });

          it('should be invalid if not email', function() {
            input.clear();
            input.sendKeys('xxx');

            expect(valid.getText()).toContain('false');
          });
        </file>
      </example>
   */
  'email': emailInputType,


  /**
   * @ngdoc input
   * @name input[radio]
   *
   * @description
   * HTML radio button.
   *
   * **Note:**<br>
   * All inputs controlled by {@link ngModel ngModel} (including those of type `radio`) will use the
   * value of their `name` attribute to determine the property under which their
   * {@link ngModel.NgModelController NgModelController} will be published on the parent
   * {@link form.FormController FormController}. Thus, if you use the same `name` for multiple
   * inputs of a form (e.g. a group of radio inputs), only _one_ `NgModelController` will be
   * published on the parent `FormController` under that name. The rest of the controllers will
   * continue to work as expected, but you won't be able to access them as properties on the parent
   * `FormController`.
   *
   * <div class="alert alert-info">
   *   <p>
   *     In plain HTML forms, the `name` attribute is used to identify groups of radio inputs, so
   *     that the browser can manage their state (checked/unchecked) based on the state of other
   *     inputs in the same group.
   *   </p>
   *   <p>
   *     In AngularJS forms, this is not necessary. The input's state will be updated based on the
   *     value of the underlying model data.
   *   </p>
   * </div>
   *
   * <div class="alert alert-success">
   *   If you omit the `name` attribute on a radio input, `ngModel` will automatically assign it a
   *   unique name.
   * </div>
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string} value The value to which the `ngModel` expression should be set when selected.
   *    Note that `value` only supports `string` values, i.e. the scope model needs to be a string,
   *    too. Use `ngValue` if you need complex models (`number`, `object`, ...).
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   * @param {string} ngValue AngularJS expression to which `ngModel` will be be set when the radio
   *    is selected. Should be used instead of the `value` attribute if you need
   *    a non-string `ngModel` (`boolean`, `array`, ...).
   *
   * @example
      <example name="radio-input-directive" module="radioExample">
        <file name="index.html">
         <script>
           angular.module('radioExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.color = {
                 name: 'blue'
               };
               $scope.specialValue = {
                 "id": "12345",
                 "value": "green"
               };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>
             <input type="radio" ng-model="color.name" value="red">
             Red
           </label><br/>
           <label>
             <input type="radio" ng-model="color.name" ng-value="specialValue">
             Green
           </label><br/>
           <label>
             <input type="radio" ng-model="color.name" value="blue">
             Blue
           </label><br/>
           <tt>color = {{color.name | json}}</tt><br/>
          </form>
          Note that `ng-value="specialValue"` sets radio item's value to be the value of `$scope.specialValue`.
        </file>
        <file name="protractor.js" type="protractor">
          it('should change state', function() {
            var inputs = element.all(by.model('color.name'));
            var color = element(by.binding('color.name'));

            expect(color.getText()).toContain('blue');

            inputs.get(0).click();
            expect(color.getText()).toContain('red');

            inputs.get(1).click();
            expect(color.getText()).toContain('green');
          });
        </file>
      </example>
   */
  'radio': radioInputType,

  /**
   * @ngdoc input
   * @name input[range]
   *
   * @description
   * Native range input with validation and transformation.
   *
   * The model for the range input must always be a `Number`.
   *
   * IE9 and other browsers that do not support the `range` type fall back
   * to a text input without any default values for `min`, `max` and `step`. Model binding,
   * validation and number parsing are nevertheless supported.
   *
   * Browsers that support range (latest Chrome, Safari, Firefox, Edge) treat `input[range]`
   * in a way that never allows the input to hold an invalid value. That means:
   * - any non-numerical value is set to `(max + min) / 2`.
   * - any numerical value that is less than the current min val, or greater than the current max val
   * is set to the min / max val respectively.
   * - additionally, the current `step` is respected, so the nearest value that satisfies a step
   * is used.
   *
   * See the [HTML Spec on input[type=range]](https://www.w3.org/TR/html5/forms.html#range-state-(type=range))
   * for more info.
   *
   * This has the following consequences for AngularJS:
   *
   * Since the element value should always reflect the current model value, a range input
   * will set the bound ngModel expression to the value that the browser has set for the
   * input element. For example, in the following input `<input type="range" ng-model="model.value">`,
   * if the application sets `model.value = null`, the browser will set the input to `'50'`.
   * AngularJS will then set the model to `50`, to prevent input and model value being out of sync.
   *
   * That means the model for range will immediately be set to `50` after `ngModel` has been
   * initialized. It also means a range input can never have the required error.
   *
   * This does not only affect changes to the model value, but also to the values of the `min`,
   * `max`, and `step` attributes. When these change in a way that will cause the browser to modify
   * the input value, AngularJS will also update the model value.
   *
   * Automatic value adjustment also means that a range input element can never have the `required`,
   * `min`, or `max` errors.
   *
   * However, `step` is currently only fully implemented by Firefox. Other browsers have problems
   * when the step value changes dynamically - they do not adjust the element value correctly, but
   * instead may set the `stepMismatch` error. If that's the case, the AngularJS will set the `step`
   * error on the input, and set the model to `undefined`.
   *
   * Note that `input[range]` is not compatible with`ngMax`, `ngMin`, and `ngStep`, because they do
   * not set the `min` and `max` attributes, which means that the browser won't automatically adjust
   * the input value based on their values, and will always assume min = 0, max = 100, and step = 1.
   *
   * @param {string}  ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} min Sets the `min` validation to ensure that the value entered is greater
   *                  than `min`. Can be interpolated.
   * @param {string=} max Sets the `max` validation to ensure that the value entered is less than `max`.
   *                  Can be interpolated.
   * @param {string=} step Sets the `step` validation to ensure that the value entered matches the `step`
   *                  Can be interpolated.
   * @param {expression=} ngChange AngularJS expression to be executed when the ngModel value changes due
   *                      to user interaction with the input element.
   * @param {expression=} ngChecked If the expression is truthy, then the `checked` attribute will be set on the
   *                      element. **Note** : `ngChecked` should not be used alongside `ngModel`.
   *                      Checkout {@link ng.directive:ngChecked ngChecked} for usage.
   *
   * @example
      <example name="range-input-directive" module="rangeExample">
        <file name="index.html">
          <script>
            angular.module('rangeExample', [])
              .controller('ExampleController', ['$scope', function($scope) {
                $scope.value = 75;
                $scope.min = 10;
                $scope.max = 90;
              }]);
          </script>
          <form name="myForm" ng-controller="ExampleController">

            Model as range: <input type="range" name="range" ng-model="value" min="{{min}}"  max="{{max}}">
            <hr>
            Model as number: <input type="number" ng-model="value"><br>
            Min: <input type="number" ng-model="min"><br>
            Max: <input type="number" ng-model="max"><br>
            value = <code>{{value}}</code><br/>
            myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
            myForm.range.$error = <code>{{myForm.range.$error}}</code>
          </form>
        </file>
      </example>

   * ## Range Input with ngMin & ngMax attributes

   * @example
      <example name="range-input-directive-ng" module="rangeExample">
        <file name="index.html">
          <script>
            angular.module('rangeExample', [])
              .controller('ExampleController', ['$scope', function($scope) {
                $scope.value = 75;
                $scope.min = 10;
                $scope.max = 90;
              }]);
          </script>
          <form name="myForm" ng-controller="ExampleController">
            Model as range: <input type="range" name="range" ng-model="value" ng-min="min" ng-max="max">
            <hr>
            Model as number: <input type="number" ng-model="value"><br>
            Min: <input type="number" ng-model="min"><br>
            Max: <input type="number" ng-model="max"><br>
            value = <code>{{value}}</code><br/>
            myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
            myForm.range.$error = <code>{{myForm.range.$error}}</code>
          </form>
        </file>
      </example>

   */
  'range': rangeInputType,

  /**
   * @ngdoc input
   * @name input[checkbox]
   *
   * @description
   * HTML checkbox.
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {expression=} ngTrueValue The value to which the expression should be set when selected.
   * @param {expression=} ngFalseValue The value to which the expression should be set when not selected.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
      <example name="checkbox-input-directive" module="checkboxExample">
        <file name="index.html">
         <script>
           angular.module('checkboxExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.checkboxModel = {
                value1 : true,
                value2 : 'YES'
              };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>Value1:
             <input type="checkbox" ng-model="checkboxModel.value1">
           </label><br/>
           <label>Value2:
             <input type="checkbox" ng-model="checkboxModel.value2"
                    ng-true-value="'YES'" ng-false-value="'NO'">
            </label><br/>
           <tt>value1 = {{checkboxModel.value1}}</tt><br/>
           <tt>value2 = {{checkboxModel.value2}}</tt><br/>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          it('should change state', function() {
            var value1 = element(by.binding('checkboxModel.value1'));
            var value2 = element(by.binding('checkboxModel.value2'));

            expect(value1.getText()).toContain('true');
            expect(value2.getText()).toContain('YES');

            element(by.model('checkboxModel.value1')).click();
            element(by.model('checkboxModel.value2')).click();

            expect(value1.getText()).toContain('false');
            expect(value2.getText()).toContain('NO');
          });
        </file>
      </example>
   */
  'checkbox': checkboxInputType,

  'hidden': noop,
  'button': noop,
  'submit': noop,
  'reset': noop,
  'file': noop
};

function stringBasedInputType(ctrl) {
  ctrl.$formatters.push(function(value) {
    return ctrl.$isEmpty(value) ? value : value.toString();
  });
}

function textInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
  stringBasedInputType(ctrl);
}

function baseInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  var type = lowercase(element[0].type);

  // In composition mode, users are still inputting intermediate text buffer,
  // hold the listener until composition is done.
  // More about composition events: https://developer.mozilla.org/en-US/docs/Web/API/CompositionEvent
  if (!$sniffer.android) {
    var composing = false;

    element.on('compositionstart', function() {
      composing = true;
    });

    // Support: IE9+
    element.on('compositionupdate', function(ev) {
      // End composition when ev.data is empty string on 'compositionupdate' event.
      // When the input de-focusses (e.g. by clicking away), IE triggers 'compositionupdate'
      // instead of 'compositionend'.
      if (isUndefined(ev.data) || ev.data === '') {
        composing = false;
      }
    });

    element.on('compositionend', function() {
      composing = false;
      listener();
    });
  }

  var timeout;

  var listener = function(ev) {
    if (timeout) {
      $browser.defer.cancel(timeout);
      timeout = null;
    }
    if (composing) return;
    var value = element.val(),
        event = ev && ev.type;

    // By default we will trim the value
    // If the attribute ng-trim exists we will avoid trimming
    // If input type is 'password', the value is never trimmed
    if (type !== 'password' && (!attr.ngTrim || attr.ngTrim !== 'false')) {
      value = trim(value);
    }

    // If a control is suffering from bad input (due to native validators), browsers discard its
    // value, so it may be necessary to revalidate (by calling $setViewValue again) even if the
    // control's value is the same empty value twice in a row.
    if (ctrl.$viewValue !== value || (value === '' && ctrl.$$hasNativeValidators)) {
      ctrl.$setViewValue(value, event);
    }
  };

  // if the browser does support "input" event, we are fine - except on IE9 which doesn't fire the
  // input event on backspace, delete or cut
  if ($sniffer.hasEvent('input')) {
    element.on('input', listener);
  } else {
    var deferListener = function(ev, input, origValue) {
      if (!timeout) {
        timeout = $browser.defer(function() {
          timeout = null;
          if (!input || input.value !== origValue) {
            listener(ev);
          }
        });
      }
    };

    element.on('keydown', /** @this */ function(event) {
      var key = event.keyCode;

      // ignore
      //    command            modifiers                   arrows
      if (key === 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) return;

      deferListener(event, this, this.value);
    });

    // if user modifies input value using context menu in IE, we need "paste", "cut" and "drop" events to catch it
    if ($sniffer.hasEvent('paste')) {
      element.on('paste cut drop', deferListener);
    }
  }

  // if user paste into input using mouse on older browser
  // or form autocomplete on newer browser, we need "change" event to catch it
  element.on('change', listener);

  // Some native input types (date-family) have the ability to change validity without
  // firing any input/change events.
  // For these event types, when native validators are present and the browser supports the type,
  // check for validity changes on various DOM events.
  if (PARTIAL_VALIDATION_TYPES[type] && ctrl.$$hasNativeValidators && type === attr.type) {
    element.on(PARTIAL_VALIDATION_EVENTS, /** @this */ function(ev) {
      if (!timeout) {
        var validity = this[VALIDITY_STATE_PROPERTY];
        var origBadInput = validity.badInput;
        var origTypeMismatch = validity.typeMismatch;
        timeout = $browser.defer(function() {
          timeout = null;
          if (validity.badInput !== origBadInput || validity.typeMismatch !== origTypeMismatch) {
            listener(ev);
          }
        });
      }
    });
  }

  ctrl.$render = function() {
    // Workaround for Firefox validation #12102.
    var value = ctrl.$isEmpty(ctrl.$viewValue) ? '' : ctrl.$viewValue;
    if (element.val() !== value) {
      element.val(value);
    }
  };
}

function weekParser(isoWeek, existingDate) {
  if (isDate(isoWeek)) {
    return isoWeek;
  }

  if (isString(isoWeek)) {
    WEEK_REGEXP.lastIndex = 0;
    var parts = WEEK_REGEXP.exec(isoWeek);
    if (parts) {
      var year = +parts[1],
          week = +parts[2],
          hours = 0,
          minutes = 0,
          seconds = 0,
          milliseconds = 0,
          firstThurs = getFirstThursdayOfYear(year),
          addDays = (week - 1) * 7;

      if (existingDate) {
        hours = existingDate.getHours();
        minutes = existingDate.getMinutes();
        seconds = existingDate.getSeconds();
        milliseconds = existingDate.getMilliseconds();
      }

      return new Date(year, 0, firstThurs.getDate() + addDays, hours, minutes, seconds, milliseconds);
    }
  }

  return NaN;
}

function createDateParser(regexp, mapping) {
  return function(iso, previousDate) {
    var parts, map;

    if (isDate(iso)) {
      return iso;
    }

    if (isString(iso)) {
      // When a date is JSON'ified to wraps itself inside of an extra
      // set of double quotes. This makes the date parsing code unable
      // to match the date string and parse it as a date.
      if (iso.charAt(0) === '"' && iso.charAt(iso.length - 1) === '"') {
        iso = iso.substring(1, iso.length - 1);
      }
      if (ISO_DATE_REGEXP.test(iso)) {
        return new Date(iso);
      }
      regexp.lastIndex = 0;
      parts = regexp.exec(iso);

      if (parts) {
        parts.shift();
        if (previousDate) {
          map = {
            yyyy: previousDate.getFullYear(),
            MM: previousDate.getMonth() + 1,
            dd: previousDate.getDate(),
            HH: previousDate.getHours(),
            mm: previousDate.getMinutes(),
            ss: previousDate.getSeconds(),
            sss: previousDate.getMilliseconds() / 1000
          };
        } else {
          map = { yyyy: 1970, MM: 1, dd: 1, HH: 0, mm: 0, ss: 0, sss: 0 };
        }

        forEach(parts, function(part, index) {
          if (index < mapping.length) {
            map[mapping[index]] = +part;
          }
        });

        var date = new Date(map.yyyy, map.MM - 1, map.dd, map.HH, map.mm, map.ss || 0, map.sss * 1000 || 0);
        if (map.yyyy < 100) {
          // In the constructor, 2-digit years map to 1900-1999.
          // Use `setFullYear()` to set the correct year.
          date.setFullYear(map.yyyy);
        }

        return date;
      }
    }

    return NaN;
  };
}

function createDateInputType(type, regexp, parseDate, format) {
  return function dynamicDateInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
    badInputChecker(scope, element, attr, ctrl, type);
    baseInputType(scope, element, attr, ctrl, $sniffer, $browser);

    var isTimeType = type === 'time' || type === 'datetimelocal';
    var previousDate;
    var previousTimezone;

    ctrl.$parsers.push(function(value) {
      if (ctrl.$isEmpty(value)) return null;

      if (regexp.test(value)) {
        // Note: We cannot read ctrl.$modelValue, as there might be a different
        // parser/formatter in the processing chain so that the model
        // contains some different data format!
        return parseDateAndConvertTimeZoneToLocal(value, previousDate);
      }
      ctrl.$$parserName = type;
      return undefined;
    });

    ctrl.$formatters.push(function(value) {
      if (value && !isDate(value)) {
        throw ngModelMinErr('datefmt', 'Expected `{0}` to be a date', value);
      }
      if (isValidDate(value)) {
        previousDate = value;
        var timezone = ctrl.$options.getOption('timezone');

        if (timezone) {
          previousTimezone = timezone;
          previousDate = convertTimezoneToLocal(previousDate, timezone, true);
        }

        return formatter(value, timezone);
      } else {
        previousDate = null;
        previousTimezone = null;
        return '';
      }
    });

    if (isDefined(attr.min) || attr.ngMin) {
      var minVal = attr.min || $parse(attr.ngMin)(scope);
      var parsedMinVal = parseObservedDateValue(minVal);

      ctrl.$validators.min = function(value) {
        return !isValidDate(value) || isUndefined(parsedMinVal) || parseDate(value) >= parsedMinVal;
      };
      attr.$observe('min', function(val) {
        if (val !== minVal) {
          parsedMinVal = parseObservedDateValue(val);
          minVal = val;
          ctrl.$validate();
        }
      });
    }

    if (isDefined(attr.max) || attr.ngMax) {
      var maxVal = attr.max || $parse(attr.ngMax)(scope);
      var parsedMaxVal = parseObservedDateValue(maxVal);

      ctrl.$validators.max = function(value) {
        return !isValidDate(value) || isUndefined(parsedMaxVal) || parseDate(value) <= parsedMaxVal;
      };
      attr.$observe('max', function(val) {
        if (val !== maxVal) {
          parsedMaxVal = parseObservedDateValue(val);
          maxVal = val;
          ctrl.$validate();
        }
      });
    }

    function isValidDate(value) {
      // Invalid Date: getTime() returns NaN
      return value && !(value.getTime && value.getTime() !== value.getTime());
    }

    function parseObservedDateValue(val) {
      return isDefined(val) && !isDate(val) ? parseDateAndConvertTimeZoneToLocal(val) || undefined : val;
    }

    function parseDateAndConvertTimeZoneToLocal(value, previousDate) {
      var timezone = ctrl.$options.getOption('timezone');

      if (previousTimezone && previousTimezone !== timezone) {
        // If the timezone has changed, adjust the previousDate to the default timezone
        // so that the new date is converted with the correct timezone offset
        previousDate = addDateMinutes(previousDate, timezoneToOffset(previousTimezone));
      }

      var parsedDate = parseDate(value, previousDate);

      if (!isNaN(parsedDate) && timezone) {
        parsedDate = convertTimezoneToLocal(parsedDate, timezone);
      }
      return parsedDate;
    }

    function formatter(value, timezone) {
      var targetFormat = format;

      if (isTimeType && isString(ctrl.$options.getOption('timeSecondsFormat'))) {
        targetFormat = format
          .replace('ss.sss', ctrl.$options.getOption('timeSecondsFormat'))
          .replace(/:$/, '');
      }

      var formatted =  $filter('date')(value, targetFormat, timezone);

      if (isTimeType && ctrl.$options.getOption('timeStripZeroSeconds')) {
        formatted = formatted.replace(/(?::00)?(?:\.000)?$/, '');
      }

      return formatted;
    }
  };
}

function badInputChecker(scope, element, attr, ctrl, parserName) {
  var node = element[0];
  var nativeValidation = ctrl.$$hasNativeValidators = isObject(node.validity);
  if (nativeValidation) {
    ctrl.$parsers.push(function(value) {
      var validity = element.prop(VALIDITY_STATE_PROPERTY) || {};
      if (validity.badInput || validity.typeMismatch) {
        ctrl.$$parserName = parserName;
        return undefined;
      }

      return value;
    });
  }
}

function numberFormatterParser(ctrl) {
  ctrl.$parsers.push(function(value) {
    if (ctrl.$isEmpty(value))      return null;
    if (NUMBER_REGEXP.test(value)) return parseFloat(value);

    ctrl.$$parserName = 'number';
    return undefined;
  });

  ctrl.$formatters.push(function(value) {
    if (!ctrl.$isEmpty(value)) {
      if (!isNumber(value)) {
        throw ngModelMinErr('numfmt', 'Expected `{0}` to be a number', value);
      }
      value = value.toString();
    }
    return value;
  });
}

function parseNumberAttrVal(val) {
  if (isDefined(val) && !isNumber(val)) {
    val = parseFloat(val);
  }
  return !isNumberNaN(val) ? val : undefined;
}

function isNumberInteger(num) {
  // See http://stackoverflow.com/questions/14636536/how-to-check-if-a-variable-is-an-integer-in-javascript#14794066
  // (minus the assumption that `num` is a number)

  // eslint-disable-next-line no-bitwise
  return (num | 0) === num;
}

function countDecimals(num) {
  var numString = num.toString();
  var decimalSymbolIndex = numString.indexOf('.');

  if (decimalSymbolIndex === -1) {
    if (-1 < num && num < 1) {
      // It may be in the exponential notation format (`1e-X`)
      var match = /e-(\d+)$/.exec(numString);

      if (match) {
        return Number(match[1]);
      }
    }

    return 0;
  }

  return numString.length - decimalSymbolIndex - 1;
}

function isValidForStep(viewValue, stepBase, step) {
  // At this point `stepBase` and `step` are expected to be non-NaN values
  // and `viewValue` is expected to be a valid stringified number.
  var value = Number(viewValue);

  var isNonIntegerValue = !isNumberInteger(value);
  var isNonIntegerStepBase = !isNumberInteger(stepBase);
  var isNonIntegerStep = !isNumberInteger(step);

  // Due to limitations in Floating Point Arithmetic (e.g. `0.3 - 0.2 !== 0.1` or
  // `0.5 % 0.1 !== 0`), we need to convert all numbers to integers.
  if (isNonIntegerValue || isNonIntegerStepBase || isNonIntegerStep) {
    var valueDecimals = isNonIntegerValue ? countDecimals(value) : 0;
    var stepBaseDecimals = isNonIntegerStepBase ? countDecimals(stepBase) : 0;
    var stepDecimals = isNonIntegerStep ? countDecimals(step) : 0;

    var decimalCount = Math.max(valueDecimals, stepBaseDecimals, stepDecimals);
    var multiplier = Math.pow(10, decimalCount);

    value = value * multiplier;
    stepBase = stepBase * multiplier;
    step = step * multiplier;

    if (isNonIntegerValue) value = Math.round(value);
    if (isNonIntegerStepBase) stepBase = Math.round(stepBase);
    if (isNonIntegerStep) step = Math.round(step);
  }

  return (value - stepBase) % step === 0;
}

function numberInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
  badInputChecker(scope, element, attr, ctrl, 'number');
  numberFormatterParser(ctrl);
  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);

  var parsedMinVal;

  if (isDefined(attr.min) || attr.ngMin) {
    var minVal = attr.min || $parse(attr.ngMin)(scope);
    parsedMinVal = parseNumberAttrVal(minVal);

    ctrl.$validators.min = function(modelValue, viewValue) {
      return ctrl.$isEmpty(viewValue) || isUndefined(parsedMinVal) || viewValue >= parsedMinVal;
    };

    attr.$observe('min', function(val) {
      if (val !== minVal) {
        parsedMinVal = parseNumberAttrVal(val);
        minVal = val;
        // TODO(matsko): implement validateLater to reduce number of validations
        ctrl.$validate();
      }
    });
  }

  if (isDefined(attr.max) || attr.ngMax) {
    var maxVal = attr.max || $parse(attr.ngMax)(scope);
    var parsedMaxVal = parseNumberAttrVal(maxVal);

    ctrl.$validators.max = function(modelValue, viewValue) {
      return ctrl.$isEmpty(viewValue) || isUndefined(parsedMaxVal) || viewValue <= parsedMaxVal;
    };

    attr.$observe('max', function(val) {
      if (val !== maxVal) {
        parsedMaxVal = parseNumberAttrVal(val);
        maxVal = val;
        // TODO(matsko): implement validateLater to reduce number of validations
        ctrl.$validate();
      }
    });
  }

  if (isDefined(attr.step) || attr.ngStep) {
    var stepVal = attr.step || $parse(attr.ngStep)(scope);
    var parsedStepVal = parseNumberAttrVal(stepVal);

    ctrl.$validators.step = function(modelValue, viewValue) {
      return ctrl.$isEmpty(viewValue) || isUndefined(parsedStepVal) ||
        isValidForStep(viewValue, parsedMinVal || 0, parsedStepVal);
    };

    attr.$observe('step', function(val) {
      // TODO(matsko): implement validateLater to reduce number of validations
      if (val !== stepVal) {
        parsedStepVal = parseNumberAttrVal(val);
        stepVal = val;
        ctrl.$validate();
      }

    });

  }
}

function rangeInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  badInputChecker(scope, element, attr, ctrl, 'range');
  numberFormatterParser(ctrl);
  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);

  var supportsRange = ctrl.$$hasNativeValidators && element[0].type === 'range',
      minVal = supportsRange ? 0 : undefined,
      maxVal = supportsRange ? 100 : undefined,
      stepVal = supportsRange ? 1 : undefined,
      validity = element[0].validity,
      hasMinAttr = isDefined(attr.min),
      hasMaxAttr = isDefined(attr.max),
      hasStepAttr = isDefined(attr.step);

  var originalRender = ctrl.$render;

  ctrl.$render = supportsRange && isDefined(validity.rangeUnderflow) && isDefined(validity.rangeOverflow) ?
    //Browsers that implement range will set these values automatically, but reading the adjusted values after
    //$render would cause the min / max validators to be applied with the wrong value
    function rangeRender() {
      originalRender();
      ctrl.$setViewValue(element.val());
    } :
    originalRender;

  if (hasMinAttr) {
    minVal = parseNumberAttrVal(attr.min);

    ctrl.$validators.min = supportsRange ?
      // Since all browsers set the input to a valid value, we don't need to check validity
      function noopMinValidator() { return true; } :
      // non-support browsers validate the min val
      function minValidator(modelValue, viewValue) {
        return ctrl.$isEmpty(viewValue) || isUndefined(minVal) || viewValue >= minVal;
      };

    setInitialValueAndObserver('min', minChange);
  }

  if (hasMaxAttr) {
    maxVal = parseNumberAttrVal(attr.max);

    ctrl.$validators.max = supportsRange ?
      // Since all browsers set the input to a valid value, we don't need to check validity
      function noopMaxValidator() { return true; } :
      // non-support browsers validate the max val
      function maxValidator(modelValue, viewValue) {
        return ctrl.$isEmpty(viewValue) || isUndefined(maxVal) || viewValue <= maxVal;
      };

    setInitialValueAndObserver('max', maxChange);
  }

  if (hasStepAttr) {
    stepVal = parseNumberAttrVal(attr.step);

    ctrl.$validators.step = supportsRange ?
      function nativeStepValidator() {
        // Currently, only FF implements the spec on step change correctly (i.e. adjusting the
        // input element value to a valid value). It's possible that other browsers set the stepMismatch
        // validity error instead, so we can at least report an error in that case.
        return !validity.stepMismatch;
      } :
      // ngStep doesn't set the setp attr, so the browser doesn't adjust the input value as setting step would
      function stepValidator(modelValue, viewValue) {
        return ctrl.$isEmpty(viewValue) || isUndefined(stepVal) ||
               isValidForStep(viewValue, minVal || 0, stepVal);
      };

    setInitialValueAndObserver('step', stepChange);
  }

  function setInitialValueAndObserver(htmlAttrName, changeFn) {
    // interpolated attributes set the attribute value only after a digest, but we need the
    // attribute value when the input is first rendered, so that the browser can adjust the
    // input value based on the min/max value
    element.attr(htmlAttrName, attr[htmlAttrName]);
    var oldVal = attr[htmlAttrName];
    attr.$observe(htmlAttrName, function wrappedObserver(val) {
      if (val !== oldVal) {
        oldVal = val;
        changeFn(val);
      }
    });
  }

  function minChange(val) {
    minVal = parseNumberAttrVal(val);
    // ignore changes before model is initialized
    if (isNumberNaN(ctrl.$modelValue)) {
      return;
    }

    if (supportsRange) {
      var elVal = element.val();
      // IE11 doesn't set the el val correctly if the minVal is greater than the element value
      if (minVal > elVal) {
        elVal = minVal;
        element.val(elVal);
      }
      ctrl.$setViewValue(elVal);
    } else {
      // TODO(matsko): implement validateLater to reduce number of validations
      ctrl.$validate();
    }
  }

  function maxChange(val) {
    maxVal = parseNumberAttrVal(val);
    // ignore changes before model is initialized
    if (isNumberNaN(ctrl.$modelValue)) {
      return;
    }

    if (supportsRange) {
      var elVal = element.val();
      // IE11 doesn't set the el val correctly if the maxVal is less than the element value
      if (maxVal < elVal) {
        element.val(maxVal);
        // IE11 and Chrome don't set the value to the minVal when max < min
        elVal = maxVal < minVal ? minVal : maxVal;
      }
      ctrl.$setViewValue(elVal);
    } else {
      // TODO(matsko): implement validateLater to reduce number of validations
      ctrl.$validate();
    }
  }

  function stepChange(val) {
    stepVal = parseNumberAttrVal(val);
    // ignore changes before model is initialized
    if (isNumberNaN(ctrl.$modelValue)) {
      return;
    }

    // Some browsers don't adjust the input value correctly, but set the stepMismatch error
    if (!supportsRange) {
      // TODO(matsko): implement validateLater to reduce number of validations
      ctrl.$validate();
    } else if (ctrl.$viewValue !== element.val()) {
      ctrl.$setViewValue(element.val());
    }
  }
}

function urlInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  // Note: no badInputChecker here by purpose as `url` is only a validation
  // in browsers, i.e. we can always read out input.value even if it is not valid!
  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
  stringBasedInputType(ctrl);

  ctrl.$validators.url = function(modelValue, viewValue) {
    var value = modelValue || viewValue;
    return ctrl.$isEmpty(value) || URL_REGEXP.test(value);
  };
}

function emailInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  // Note: no badInputChecker here by purpose as `url` is only a validation
  // in browsers, i.e. we can always read out input.value even if it is not valid!
  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
  stringBasedInputType(ctrl);

  ctrl.$validators.email = function(modelValue, viewValue) {
    var value = modelValue || viewValue;
    return ctrl.$isEmpty(value) || EMAIL_REGEXP.test(value);
  };
}

function radioInputType(scope, element, attr, ctrl) {
  var doTrim = !attr.ngTrim || trim(attr.ngTrim) !== 'false';
  // make the name unique, if not defined
  if (isUndefined(attr.name)) {
    element.attr('name', nextUid());
  }

  var listener = function(ev) {
    var value;
    if (element[0].checked) {
      value = attr.value;
      if (doTrim) {
        value = trim(value);
      }
      ctrl.$setViewValue(value, ev && ev.type);
    }
  };

  element.on('change', listener);

  ctrl.$render = function() {
    var value = attr.value;
    if (doTrim) {
      value = trim(value);
    }
    element[0].checked = (value === ctrl.$viewValue);
  };

  attr.$observe('value', ctrl.$render);
}

function parseConstantExpr($parse, context, name, expression, fallback) {
  var parseFn;
  if (isDefined(expression)) {
    parseFn = $parse(expression);
    if (!parseFn.constant) {
      throw ngModelMinErr('constexpr', 'Expected constant expression for `{0}`, but saw ' +
                                   '`{1}`.', name, expression);
    }
    return parseFn(context);
  }
  return fallback;
}

function checkboxInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
  var trueValue = parseConstantExpr($parse, scope, 'ngTrueValue', attr.ngTrueValue, true);
  var falseValue = parseConstantExpr($parse, scope, 'ngFalseValue', attr.ngFalseValue, false);

  var listener = function(ev) {
    ctrl.$setViewValue(element[0].checked, ev && ev.type);
  };

  element.on('change', listener);

  ctrl.$render = function() {
    element[0].checked = ctrl.$viewValue;
  };

  // Override the standard `$isEmpty` because the $viewValue of an empty checkbox is always set to `false`
  // This is because of the parser below, which compares the `$modelValue` with `trueValue` to convert
  // it to a boolean.
  ctrl.$isEmpty = function(value) {
    return value === false;
  };

  ctrl.$formatters.push(function(value) {
    return equals(value, trueValue);
  });

  ctrl.$parsers.push(function(value) {
    return value ? trueValue : falseValue;
  });
}


/**
 * @ngdoc directive
 * @name textarea
 * @restrict E
 *
 * @description
 * HTML textarea element control with AngularJS data-binding. The data-binding and validation
 * properties of this element are exactly the same as those of the
 * {@link ng.directive:input input element}.
 *
 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
 * @param {string=} name Property name of the form under which the control is published.
 * @param {string=} required Sets `required` validation error key if the value is not entered.
 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
 *    `required` when you want to data-bind to the `required` attribute.
 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
 *    minlength.
 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
 *    length.
 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
 *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
 *    If the expression evaluates to a RegExp object, then this is used directly.
 *    If the expression evaluates to a string, then it will be converted to a RegExp
 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
 *    `new RegExp('^abc$')`.<br />
 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
 *    start at the index of the last search's match, thus not taking the whole input value into
 *    account.
 * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
 *    interaction with the input element.
 * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
 *
 * @knownIssue
 *
 * When specifying the `placeholder` attribute of `<textarea>`, Internet Explorer will temporarily
 * insert the placeholder value as the textarea's content. If the placeholder value contains
 * interpolation (`{{ ... }}`), an error will be logged in the console when AngularJS tries to update
 * the value of the by-then-removed text node. This doesn't affect the functionality of the
 * textarea, but can be undesirable.
 *
 * You can work around this Internet Explorer issue by using `ng-attr-placeholder` instead of
 * `placeholder` on textareas, whenever you need interpolation in the placeholder value. You can
 * find more details on `ngAttr` in the
 * [Interpolation](guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes) section of the
 * Developer Guide.
 */


/**
 * @ngdoc directive
 * @name input
 * @restrict E
 *
 * @description
 * HTML input element control. When used together with {@link ngModel `ngModel`}, it provides data-binding,
 * input state control, and validation.
 * Input control follows HTML5 input types and polyfills the HTML5 validation behavior for older browsers.
 *
 * <div class="alert alert-warning">
 * **Note:** Not every feature offered is available for all input types.
 * Specifically, data binding and event handling via `ng-model` is unsupported for `input[file]`.
 * </div>
 *
 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
 * @param {string=} name Property name of the form under which the control is published.
 * @param {string=} required Sets `required` validation error key if the value is not entered.
 * @param {boolean=} ngRequired Sets `required` attribute if set to true
 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
 *    minlength.
 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
 *    length.
 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
 *    value does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
 *    If the expression evaluates to a RegExp object, then this is used directly.
 *    If the expression evaluates to a string, then it will be converted to a RegExp
 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
 *    `new RegExp('^abc$')`.<br />
 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
 *    start at the index of the last search's match, thus not taking the whole input value into
 *    account.
 * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
 *    interaction with the input element.
 * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
 *    This parameter is ignored for input[type=password] controls, which will never trim the
 *    input.
 *
 * @example
    <example name="input-directive" module="inputExample">
      <file name="index.html">
       <script>
          angular.module('inputExample', [])
            .controller('ExampleController', ['$scope', function($scope) {
              $scope.user = {name: 'guest', last: 'visitor'};
            }]);
       </script>
       <div ng-controller="ExampleController">
         <form name="myForm">
           <label>
              User name:
              <input type="text" name="userName" ng-model="user.name" required>
           </label>
           <div role="alert">
             <span class="error" ng-show="myForm.userName.$error.required">
              Required!</span>
           </div>
           <label>
              Last name:
              <input type="text" name="lastName" ng-model="user.last"
              ng-minlength="3" ng-maxlength="10">
           </label>
           <div role="alert">
             <span class="error" ng-show="myForm.lastName.$error.minlength">
               Too short!</span>
             <span class="error" ng-show="myForm.lastName.$error.maxlength">
               Too long!</span>
           </div>
         </form>
         <hr>
         <tt>user = {{user}}</tt><br/>
         <tt>myForm.userName.$valid = {{myForm.userName.$valid}}</tt><br/>
         <tt>myForm.userName.$error = {{myForm.userName.$error}}</tt><br/>
         <tt>myForm.lastName.$valid = {{myForm.lastName.$valid}}</tt><br/>
         <tt>myForm.lastName.$error = {{myForm.lastName.$error}}</tt><br/>
         <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
         <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
         <tt>myForm.$error.minlength = {{!!myForm.$error.minlength}}</tt><br/>
         <tt>myForm.$error.maxlength = {{!!myForm.$error.maxlength}}</tt><br/>
       </div>
      </file>
      <file name="protractor.js" type="protractor">
        var user = element(by.exactBinding('user'));
        var userNameValid = element(by.binding('myForm.userName.$valid'));
        var lastNameValid = element(by.binding('myForm.lastName.$valid'));
        var lastNameError = element(by.binding('myForm.lastName.$error'));
        var formValid = element(by.binding('myForm.$valid'));
        var userNameInput = element(by.model('user.name'));
        var userLastInput = element(by.model('user.last'));

        it('should initialize to model', function() {
          expect(user.getText()).toContain('{"name":"guest","last":"visitor"}');
          expect(userNameValid.getText()).toContain('true');
          expect(formValid.getText()).toContain('true');
        });

        it('should be invalid if empty when required', function() {
          userNameInput.clear();
          userNameInput.sendKeys('');

          expect(user.getText()).toContain('{"last":"visitor"}');
          expect(userNameValid.getText()).toContain('false');
          expect(formValid.getText()).toContain('false');
        });

        it('should be valid if empty when min length is set', function() {
          userLastInput.clear();
          userLastInput.sendKeys('');

          expect(user.getText()).toContain('{"name":"guest","last":""}');
          expect(lastNameValid.getText()).toContain('true');
          expect(formValid.getText()).toContain('true');
        });

        it('should be invalid if less than required min length', function() {
          userLastInput.clear();
          userLastInput.sendKeys('xx');

          expect(user.getText()).toContain('{"name":"guest"}');
          expect(lastNameValid.getText()).toContain('false');
          expect(lastNameError.getText()).toContain('minlength');
          expect(formValid.getText()).toContain('false');
        });

        it('should be invalid if longer than max length', function() {
          userLastInput.clear();
          userLastInput.sendKeys('some ridiculously long name');

          expect(user.getText()).toContain('{"name":"guest"}');
          expect(lastNameValid.getText()).toContain('false');
          expect(lastNameError.getText()).toContain('maxlength');
          expect(formValid.getText()).toContain('false');
        });
      </file>
    </example>
 */
var inputDirective = ['$browser', '$sniffer', '$filter', '$parse',
    function($browser, $sniffer, $filter, $parse) {
  return {
    restrict: 'E',
    require: ['?ngModel'],
    link: {
      pre: function(scope, element, attr, ctrls) {
        if (ctrls[0]) {
          (inputType[lowercase(attr.type)] || inputType.text)(scope, element, attr, ctrls[0], $sniffer,
                                                              $browser, $filter, $parse);
        }
      }
    }
  };
}];


var hiddenInputBrowserCacheDirective = function() {
  var valueProperty = {
    configurable: true,
    enumerable: false,
    get: function() {
      return this.getAttribute('value') || '';
    },
    set: function(val) {
      this.setAttribute('value', val);
    }
  };

  return {
    restrict: 'E',
    priority: 200,
    compile: function(_, attr) {
      if (lowercase(attr.type) !== 'hidden') {
        return;
      }

      return {
        pre: function(scope, element, attr, ctrls) {
          var node = element[0];

          // Support: Edge
          // Moving the DOM around prevents autofillling
          if (node.parentNode) {
            node.parentNode.insertBefore(node, node.nextSibling);
          }

          // Support: FF, IE
          // Avoiding direct assignment to .value prevents autofillling
          if (Object.defineProperty) {
            Object.defineProperty(node, 'value', valueProperty);
          }
        }
      };
    }
  };
};



var CONSTANT_VALUE_REGEXP = /^(true|false|\d+)$/;
/**
 * @ngdoc directive
 * @name ngValue
 * @restrict A
 * @priority 100
 *
 * @description
 * Binds the given expression to the value of the element.
 *
 * It is mainly used on {@link input[radio] `input[radio]`} and option elements,
 * so that when the element is selected, the {@link ngModel `ngModel`} of that element (or its
 * {@link select `select`} parent element) is set to the bound value. It is especially useful
 * for dynamically generated lists using {@link ngRepeat `ngRepeat`}, as shown below.
 *
 * It can also be used to achieve one-way binding of a given expression to an input element
 * such as an `input[text]` or a `textarea`, when that element does not use ngModel.
 *
 * @element ANY
 * @param {string=} ngValue AngularJS expression, whose value will be bound to the `value` attribute
 * and `value` property of the element.
 *
 * @example
    <example name="ngValue-directive" module="valueExample">
      <file name="index.html">
       <script>
          angular.module('valueExample', [])
            .controller('ExampleController', ['$scope', function($scope) {
              $scope.names = ['pizza', 'unicorns', 'robots'];
              $scope.my = { favorite: 'unicorns' };
            }]);
       </script>
        <form ng-controller="ExampleController">
          <h2>Which is your favorite?</h2>
            <label ng-repeat="name in names" for="{{name}}">
              {{name}}
              <input type="radio"
                     ng-model="my.favorite"
                     ng-value="name"
                     id="{{name}}"
                     name="favorite">
            </label>
          <div>You chose {{my.favorite}}</div>
        </form>
      </file>
      <file name="protractor.js" type="protractor">
        var favorite = element(by.binding('my.favorite'));

        it('should initialize to model', function() {
          expect(favorite.getText()).toContain('unicorns');
        });
        it('should bind the values to the inputs', function() {
          element.all(by.model('my.favorite')).get(0).click();
          expect(favorite.getText()).toContain('pizza');
        });
      </file>
    </example>
 */
var ngValueDirective = function() {
  /**
   *  inputs use the value attribute as their default value if the value property is not set.
   *  Once the value property has been set (by adding input), it will not react to changes to
   *  the value attribute anymore. Setting both attribute and property fixes this behavior, and
   *  makes it possible to use ngValue as a sort of one-way bind.
   */
  function updateElementValue(element, attr, value) {
    // Support: IE9 only
    // In IE9 values are converted to string (e.g. `input.value = null` results in `input.value === 'null'`).
    var propValue = isDefined(value) ? value : (msie === 9) ? '' : null;
    element.prop('value', propValue);
    attr.$set('value', value);
  }

  return {
    restrict: 'A',
    priority: 100,
    compile: function(tpl, tplAttr) {
      if (CONSTANT_VALUE_REGEXP.test(tplAttr.ngValue)) {
        return function ngValueConstantLink(scope, elm, attr) {
          var value = scope.$eval(attr.ngValue);
          updateElementValue(elm, attr, value);
        };
      } else {
        return function ngValueLink(scope, elm, attr) {
          scope.$watch(attr.ngValue, function valueWatchAction(value) {
            updateElementValue(elm, attr, value);
          });
        };
      }
    }
  };
};

/**
 * @ngdoc directive
 * @name ngBind
 * @restrict AC
 *
 * @description
 * The `ngBind` attribute tells AngularJS to replace the text content of the specified HTML element
 * with the value of a given expression, and to update the text content when the value of that
 * expression changes.
 *
 * Typically, you don't use `ngBind` directly, but instead you use the double curly markup like
 * `{{ expression }}` which is similar but less verbose.
 *
 * It is preferable to use `ngBind` instead of `{{ expression }}` if a template is momentarily
 * displayed by the browser in its raw state before AngularJS compiles it. Since `ngBind` is an
 * element attribute, it makes the bindings invisible to the user while the page is loading.
 *
 * An alternative solution to this problem would be using the
 * {@link ng.directive:ngCloak ngCloak} directive.
 *
 *
 * @element ANY
 * @param {expression} ngBind {@link guide/expression Expression} to evaluate.
 *
 * @example
 * Enter a name in the Live Preview text box; the greeting below the text box changes instantly.
   <example module="bindExample" name="ng-bind">
     <file name="index.html">
       <script>
         angular.module('bindExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.name = 'Whirled';
           }]);
       </script>
       <div ng-controller="ExampleController">
         <label>Enter name: <input type="text" ng-model="name"></label><br>
         Hello <span ng-bind="name"></span>!
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-bind', function() {
         var nameInput = element(by.model('name'));

         expect(element(by.binding('name')).getText()).toBe('Whirled');
         nameInput.clear();
         nameInput.sendKeys('world');
         expect(element(by.binding('name')).getText()).toBe('world');
       });
     </file>
   </example>
 */
var ngBindDirective = ['$compile', function($compile) {
  return {
    restrict: 'AC',
    compile: function ngBindCompile(templateElement) {
      $compile.$$addBindingClass(templateElement);
      return function ngBindLink(scope, element, attr) {
        $compile.$$addBindingInfo(element, attr.ngBind);
        element = element[0];
        scope.$watch(attr.ngBind, function ngBindWatchAction(value) {
          element.textContent = stringify(value);
        });
      };
    }
  };
}];


/**
 * @ngdoc directive
 * @name ngBindTemplate
 *
 * @description
 * The `ngBindTemplate` directive specifies that the element
 * text content should be replaced with the interpolation of the template
 * in the `ngBindTemplate` attribute.
 * Unlike `ngBind`, the `ngBindTemplate` can contain multiple `{{` `}}`
 * expressions. This directive is needed since some HTML elements
 * (such as TITLE and OPTION) cannot contain SPAN elements.
 *
 * @element ANY
 * @param {string} ngBindTemplate template of form
 *   <tt>{{</tt> <tt>expression</tt> <tt>}}</tt> to eval.
 *
 * @example
 * Try it here: enter text in text box and watch the greeting change.
   <example module="bindExample" name="ng-bind-template">
     <file name="index.html">
       <script>
         angular.module('bindExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.salutation = 'Hello';
             $scope.name = 'World';
           }]);
       </script>
       <div ng-controller="ExampleController">
        <label>Salutation: <input type="text" ng-model="salutation"></label><br>
        <label>Name: <input type="text" ng-model="name"></label><br>
        <pre ng-bind-template="{{salutation}} {{name}}!"></pre>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-bind', function() {
         var salutationElem = element(by.binding('salutation'));
         var salutationInput = element(by.model('salutation'));
         var nameInput = element(by.model('name'));

         expect(salutationElem.getText()).toBe('Hello World!');

         salutationInput.clear();
         salutationInput.sendKeys('Greetings');
         nameInput.clear();
         nameInput.sendKeys('user');

         expect(salutationElem.getText()).toBe('Greetings user!');
       });
     </file>
   </example>
 */
var ngBindTemplateDirective = ['$interpolate', '$compile', function($interpolate, $compile) {
  return {
    compile: function ngBindTemplateCompile(templateElement) {
      $compile.$$addBindingClass(templateElement);
      return function ngBindTemplateLink(scope, element, attr) {
        var interpolateFn = $interpolate(element.attr(attr.$attr.ngBindTemplate));
        $compile.$$addBindingInfo(element, interpolateFn.expressions);
        element = element[0];
        attr.$observe('ngBindTemplate', function(value) {
          element.textContent = isUndefined(value) ? '' : value;
        });
      };
    }
  };
}];


/**
 * @ngdoc directive
 * @name ngBindHtml
 *
 * @description
 * Evaluates the expression and inserts the resulting HTML into the element in a secure way. By default,
 * the resulting HTML content will be sanitized using the {@link ngSanitize.$sanitize $sanitize} service.
 * To utilize this functionality, ensure that `$sanitize` is available, for example, by including {@link
 * ngSanitize} in your module's dependencies (not in core AngularJS). In order to use {@link ngSanitize}
 * in your module's dependencies, you need to include "angular-sanitize.js" in your application.
 *
 * You may also bypass sanitization for values you know are safe. To do so, bind to
 * an explicitly trusted value via {@link ng.$sce#trustAsHtml $sce.trustAsHtml}.  See the example
 * under {@link ng.$sce#show-me-an-example-using-sce- Strict Contextual Escaping (SCE)}.
 *
 * Note: If a `$sanitize` service is unavailable and the bound value isn't explicitly trusted, you
 * will have an exception (instead of an exploit.)
 *
 * @element ANY
 * @param {expression} ngBindHtml {@link guide/expression Expression} to evaluate.
 *
 * @example

   <example module="bindHtmlExample" deps="angular-sanitize.js" name="ng-bind-html">
     <file name="index.html">
       <div ng-controller="ExampleController">
        <p ng-bind-html="myHTML"></p>
       </div>
     </file>

     <file name="script.js">
       angular.module('bindHtmlExample', ['ngSanitize'])
         .controller('ExampleController', ['$scope', function($scope) {
           $scope.myHTML =
              'I am an <code>HTML</code>string with ' +
              '<a href="#">links!</a> and other <em>stuff</em>';
         }]);
     </file>

     <file name="protractor.js" type="protractor">
       it('should check ng-bind-html', function() {
         expect(element(by.binding('myHTML')).getText()).toBe(
             'I am an HTMLstring with links! and other stuff');
       });
     </file>
   </example>
 */
var ngBindHtmlDirective = ['$sce', '$parse', '$compile', function($sce, $parse, $compile) {
  return {
    restrict: 'A',
    compile: function ngBindHtmlCompile(tElement, tAttrs) {
      var ngBindHtmlGetter = $parse(tAttrs.ngBindHtml);
      var ngBindHtmlWatch = $parse(tAttrs.ngBindHtml, function sceValueOf(val) {
        // Unwrap the value to compare the actual inner safe value, not the wrapper object.
        return $sce.valueOf(val);
      });
      $compile.$$addBindingClass(tElement);

      return function ngBindHtmlLink(scope, element, attr) {
        $compile.$$addBindingInfo(element, attr.ngBindHtml);

        scope.$watch(ngBindHtmlWatch, function ngBindHtmlWatchAction() {
          // The watched value is the unwrapped value. To avoid re-escaping, use the direct getter.
          var value = ngBindHtmlGetter(scope);
          element.html($sce.getTrustedHtml(value) || '');
        });
      };
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngChange
 * @restrict A
 *
 * @description
 * Evaluate the given expression when the user changes the input.
 * The expression is evaluated immediately, unlike the JavaScript onchange event
 * which only triggers at the end of a change (usually, when the user leaves the
 * form element or presses the return key).
 *
 * The `ngChange` expression is only evaluated when a change in the input value causes
 * a new value to be committed to the model.
 *
 * It will not be evaluated:
 * * if the value returned from the `$parsers` transformation pipeline has not changed
 * * if the input has continued to be invalid since the model will stay `null`
 * * if the model is changed programmatically and not by a change to the input value
 *
 *
 * Note, this directive requires `ngModel` to be present.
 *
 * @element ANY
 * @param {expression} ngChange {@link guide/expression Expression} to evaluate upon change
 * in input value.
 *
 * @example
 * <example name="ngChange-directive" module="changeExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('changeExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.counter = 0;
 *           $scope.change = function() {
 *             $scope.counter++;
 *           };
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <input type="checkbox" ng-model="confirmed" ng-change="change()" id="ng-change-example1" />
 *       <input type="checkbox" ng-model="confirmed" id="ng-change-example2" />
 *       <label for="ng-change-example2">Confirmed</label><br />
 *       <tt>debug = {{confirmed}}</tt><br/>
 *       <tt>counter = {{counter}}</tt><br/>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     var counter = element(by.binding('counter'));
 *     var debug = element(by.binding('confirmed'));
 *
 *     it('should evaluate the expression if changing from view', function() {
 *       expect(counter.getText()).toContain('0');
 *
 *       element(by.id('ng-change-example1')).click();
 *
 *       expect(counter.getText()).toContain('1');
 *       expect(debug.getText()).toContain('true');
 *     });
 *
 *     it('should not evaluate the expression if changing from model', function() {
 *       element(by.id('ng-change-example2')).click();

 *       expect(counter.getText()).toContain('0');
 *       expect(debug.getText()).toContain('true');
 *     });
 *   </file>
 * </example>
 */
var ngChangeDirective = valueFn({
  restrict: 'A',
  require: 'ngModel',
  link: function(scope, element, attr, ctrl) {
    ctrl.$viewChangeListeners.push(function() {
      scope.$eval(attr.ngChange);
    });
  }
});

/* exported
  ngClassDirective,
  ngClassEvenDirective,
  ngClassOddDirective
*/

function classDirective(name, selector) {
  name = 'ngClass' + name;
  var indexWatchExpression;

  return ['$parse', function($parse) {
    return {
      restrict: 'AC',
      link: function(scope, element, attr) {
        var classCounts = element.data('$classCounts');
        var oldModulo = true;
        var oldClassString;

        if (!classCounts) {
          // Use createMap() to prevent class assumptions involving property
          // names in Object.prototype
          classCounts = createMap();
          element.data('$classCounts', classCounts);
        }

        if (name !== 'ngClass') {
          if (!indexWatchExpression) {
            indexWatchExpression = $parse('$index', function moduloTwo($index) {
              // eslint-disable-next-line no-bitwise
              return $index & 1;
            });
          }

          scope.$watch(indexWatchExpression, ngClassIndexWatchAction);
        }

        scope.$watch($parse(attr[name], toClassString), ngClassWatchAction);

        function addClasses(classString) {
          classString = digestClassCounts(split(classString), 1);
          attr.$addClass(classString);
        }

        function removeClasses(classString) {
          classString = digestClassCounts(split(classString), -1);
          attr.$removeClass(classString);
        }

        function updateClasses(oldClassString, newClassString) {
          var oldClassArray = split(oldClassString);
          var newClassArray = split(newClassString);

          var toRemoveArray = arrayDifference(oldClassArray, newClassArray);
          var toAddArray = arrayDifference(newClassArray, oldClassArray);

          var toRemoveString = digestClassCounts(toRemoveArray, -1);
          var toAddString = digestClassCounts(toAddArray, 1);

          attr.$addClass(toAddString);
          attr.$removeClass(toRemoveString);
        }

        function digestClassCounts(classArray, count) {
          var classesToUpdate = [];

          forEach(classArray, function(className) {
            if (count > 0 || classCounts[className]) {
              classCounts[className] = (classCounts[className] || 0) + count;
              if (classCounts[className] === +(count > 0)) {
                classesToUpdate.push(className);
              }
            }
          });

          return classesToUpdate.join(' ');
        }

        function ngClassIndexWatchAction(newModulo) {
          // This watch-action should run before the `ngClassWatchAction()`, thus it
          // adds/removes `oldClassString`. If the `ngClass` expression has changed as well, the
          // `ngClassWatchAction()` will update the classes.
          if (newModulo === selector) {
            addClasses(oldClassString);
          } else {
            removeClasses(oldClassString);
          }

          oldModulo = newModulo;
        }

        function ngClassWatchAction(newClassString) {
          if (oldModulo === selector) {
            updateClasses(oldClassString, newClassString);
          }

          oldClassString = newClassString;
        }
      }
    };
  }];

  // Helpers
  function arrayDifference(tokens1, tokens2) {
    if (!tokens1 || !tokens1.length) return [];
    if (!tokens2 || !tokens2.length) return tokens1;

    var values = [];

    outer:
    for (var i = 0; i < tokens1.length; i++) {
      var token = tokens1[i];
      for (var j = 0; j < tokens2.length; j++) {
        if (token === tokens2[j]) continue outer;
      }
      values.push(token);
    }

    return values;
  }

  function split(classString) {
    return classString && classString.split(' ');
  }

  function toClassString(classValue) {
    if (!classValue) return classValue;

    var classString = classValue;

    if (isArray(classValue)) {
      classString = classValue.map(toClassString).join(' ');
    } else if (isObject(classValue)) {
      classString = Object.keys(classValue).
        filter(function(key) { return classValue[key]; }).
        join(' ');
    } else if (!isString(classValue)) {
      classString = classValue + '';
    }

    return classString;
  }
}

/**
 * @ngdoc directive
 * @name ngClass
 * @restrict AC
 * @element ANY
 *
 * @description
 * The `ngClass` directive allows you to dynamically set CSS classes on an HTML element by databinding
 * an expression that represents all classes to be added.
 *
 * The directive operates in three different ways, depending on which of three types the expression
 * evaluates to:
 *
 * 1. If the expression evaluates to a string, the string should be one or more space-delimited class
 * names.
 *
 * 2. If the expression evaluates to an object, then for each key-value pair of the
 * object with a truthy value the corresponding key is used as a class name.
 *
 * 3. If the expression evaluates to an array, each element of the array should either be a string as in
 * type 1 or an object as in type 2. This means that you can mix strings and objects together in an array
 * to give you more control over what CSS classes appear. See the code below for an example of this.
 *
 *
 * The directive won't add duplicate classes if a particular class was already set.
 *
 * When the expression changes, the previously added classes are removed and only then are the
 * new classes added.
 *
 * @knownIssue
 * You should not use {@link guide/interpolation interpolation} in the value of the `class`
 * attribute, when using the `ngClass` directive on the same element.
 * See {@link guide/interpolation#known-issues here} for more info.
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
 * | {@link ng.$animate#setClass setClass} | just before classes are added and classes are removed from the element at the same time |
 *
 * ### ngClass and pre-existing CSS3 Transitions/Animations
   The ngClass directive still supports CSS3 Transitions/Animations even if they do not follow the ngAnimate CSS naming structure.
   Upon animation ngAnimate will apply supplementary CSS classes to track the start and end of an animation, but this will not hinder
   any pre-existing CSS transitions already on the element. To get an idea of what happens during a class-based animation, be sure
   to view the step by step details of {@link $animate#addClass $animate.addClass} and
   {@link $animate#removeClass $animate.removeClass}.
 *
 * @param {expression} ngClass {@link guide/expression Expression} to eval. The result
 *   of the evaluation can be a string representing space delimited class
 *   names, an array, or a map of class names to boolean values. In the case of a map, the
 *   names of the properties whose values are truthy will be added as css classes to the
 *   element.
 *
 * @example
 * ### Basic
   <example name="ng-class">
     <file name="index.html">
       <p ng-class="{strike: deleted, bold: important, 'has-error': error}">Map Syntax Example</p>
       <label>
          <input type="checkbox" ng-model="deleted">
          deleted (apply "strike" class)
       </label><br>
       <label>
          <input type="checkbox" ng-model="important">
          important (apply "bold" class)
       </label><br>
       <label>
          <input type="checkbox" ng-model="error">
          error (apply "has-error" class)
       </label>
       <hr>
       <p ng-class="style">Using String Syntax</p>
       <input type="text" ng-model="style"
              placeholder="Type: bold strike red" aria-label="Type: bold strike red">
       <hr>
       <p ng-class="[style1, style2, style3]">Using Array Syntax</p>
       <input ng-model="style1"
              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red"><br>
       <input ng-model="style2"
              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 2"><br>
       <input ng-model="style3"
              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 3"><br>
       <hr>
       <p ng-class="[style4, {orange: warning}]">Using Array and Map Syntax</p>
       <input ng-model="style4" placeholder="Type: bold, strike" aria-label="Type: bold, strike"><br>
       <label><input type="checkbox" ng-model="warning"> warning (apply "orange" class)</label>
     </file>
     <file name="style.css">
       .strike {
           text-decoration: line-through;
       }
       .bold {
           font-weight: bold;
       }
       .red {
           color: red;
       }
       .has-error {
           color: red;
           background-color: yellow;
       }
       .orange {
           color: orange;
       }
     </file>
     <file name="protractor.js" type="protractor">
       var ps = element.all(by.css('p'));

       it('should let you toggle the class', function() {

         expect(ps.first().getAttribute('class')).not.toMatch(/bold/);
         expect(ps.first().getAttribute('class')).not.toMatch(/has-error/);

         element(by.model('important')).click();
         expect(ps.first().getAttribute('class')).toMatch(/bold/);

         element(by.model('error')).click();
         expect(ps.first().getAttribute('class')).toMatch(/has-error/);
       });

       it('should let you toggle string example', function() {
         expect(ps.get(1).getAttribute('class')).toBe('');
         element(by.model('style')).clear();
         element(by.model('style')).sendKeys('red');
         expect(ps.get(1).getAttribute('class')).toBe('red');
       });

       it('array example should have 3 classes', function() {
         expect(ps.get(2).getAttribute('class')).toBe('');
         element(by.model('style1')).sendKeys('bold');
         element(by.model('style2')).sendKeys('strike');
         element(by.model('style3')).sendKeys('red');
         expect(ps.get(2).getAttribute('class')).toBe('bold strike red');
       });

       it('array with map example should have 2 classes', function() {
         expect(ps.last().getAttribute('class')).toBe('');
         element(by.model('style4')).sendKeys('bold');
         element(by.model('warning')).click();
         expect(ps.last().getAttribute('class')).toBe('bold orange');
       });
     </file>
   </example>

   @example
   ### Animations

   The example below demonstrates how to perform animations using ngClass.

   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class">
     <file name="index.html">
      <input id="setbtn" type="button" value="set" ng-click="myVar='my-class'">
      <input id="clearbtn" type="button" value="clear" ng-click="myVar=''">
      <br>
      <span class="base-class" ng-class="myVar">Sample Text</span>
     </file>
     <file name="style.css">
       .base-class {
         transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
       }

       .base-class.my-class {
         color: red;
         font-size:3em;
       }
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-class', function() {
         expect(element(by.css('.base-class')).getAttribute('class')).not.
           toMatch(/my-class/);

         element(by.id('setbtn')).click();

         expect(element(by.css('.base-class')).getAttribute('class')).
           toMatch(/my-class/);

         element(by.id('clearbtn')).click();

         expect(element(by.css('.base-class')).getAttribute('class')).not.
           toMatch(/my-class/);
       });
     </file>
   </example>
 */
var ngClassDirective = classDirective('', true);

/**
 * @ngdoc directive
 * @name ngClassOdd
 * @restrict AC
 *
 * @description
 * The `ngClassOdd` and `ngClassEven` directives work exactly as
 * {@link ng.directive:ngClass ngClass}, except they work in
 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
 *
 * This directive can be applied only within the scope of an
 * {@link ng.directive:ngRepeat ngRepeat}.
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
 *
 * @element ANY
 * @param {expression} ngClassOdd {@link guide/expression Expression} to eval. The result
 *   of the evaluation can be a string representing space delimited class names or an array.
 *
 * @example
   <example name="ng-class-odd">
     <file name="index.html">
        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
          <li ng-repeat="name in names">
           <span ng-class-odd="'odd'" ng-class-even="'even'">
             {{name}}
           </span>
          </li>
        </ol>
     </file>
     <file name="style.css">
       .odd {
         color: red;
       }
       .even {
         color: blue;
       }
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-class-odd and ng-class-even', function() {
         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
           toMatch(/odd/);
         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
           toMatch(/even/);
       });
     </file>
   </example>
 *
 * <hr />
 * @example
 * An example on how to implement animations using `ngClassOdd`:
 *
   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class-odd-animate">
     <file name="index.html">
       <div ng-init="items=['Item 3', 'Item 2', 'Item 1', 'Item 0']">
         <button ng-click="items.unshift('Item ' + items.length)">Add item</button>
         <hr />
         <table>
           <tr ng-repeat="item in items" ng-class-odd="'odd'">
             <td>{{ item }}</td>
           </tr>
         </table>
       </div>
     </file>
     <file name="style.css">
       .odd {
         background: rgba(255, 255, 0, 0.25);
       }

       .odd-add, .odd-remove {
         transition: 1.5s;
       }
     </file>
     <file name="protractor.js" type="protractor">
       it('should add new entries to the beginning of the list', function() {
         var button = element(by.buttonText('Add item'));
         var rows = element.all(by.repeater('item in items'));

         expect(rows.count()).toBe(4);
         expect(rows.get(0).getText()).toBe('Item 3');
         expect(rows.get(1).getText()).toBe('Item 2');

         button.click();

         expect(rows.count()).toBe(5);
         expect(rows.get(0).getText()).toBe('Item 4');
         expect(rows.get(1).getText()).toBe('Item 3');
       });

       it('should add odd class to odd entries', function() {
         var button = element(by.buttonText('Add item'));
         var rows = element.all(by.repeater('item in items'));

         expect(rows.get(0).getAttribute('class')).toMatch(/odd/);
         expect(rows.get(1).getAttribute('class')).not.toMatch(/odd/);

         button.click();

         expect(rows.get(0).getAttribute('class')).toMatch(/odd/);
         expect(rows.get(1).getAttribute('class')).not.toMatch(/odd/);
       });
     </file>
   </example>
 */
var ngClassOddDirective = classDirective('Odd', 0);

/**
 * @ngdoc directive
 * @name ngClassEven
 * @restrict AC
 *
 * @description
 * The `ngClassOdd` and `ngClassEven` directives work exactly as
 * {@link ng.directive:ngClass ngClass}, except they work in
 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
 *
 * This directive can be applied only within the scope of an
 * {@link ng.directive:ngRepeat ngRepeat}.
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
 *
 * @element ANY
 * @param {expression} ngClassEven {@link guide/expression Expression} to eval. The
 *   result of the evaluation can be a string representing space delimited class names or an array.
 *
 * @example
   <example name="ng-class-even">
     <file name="index.html">
        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
          <li ng-repeat="name in names">
           <span ng-class-odd="'odd'" ng-class-even="'even'">
             {{name}} &nbsp; &nbsp; &nbsp;
           </span>
          </li>
        </ol>
     </file>
     <file name="style.css">
       .odd {
         color: red;
       }
       .even {
         color: blue;
       }
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-class-odd and ng-class-even', function() {
         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
           toMatch(/odd/);
         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
           toMatch(/even/);
       });
     </file>
   </example>
 *
 * <hr />
 * @example
 * An example on how to implement animations using `ngClassEven`:
 *
   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class-even-animate">
     <file name="index.html">
       <div ng-init="items=['Item 3', 'Item 2', 'Item 1', 'Item 0']">
         <button ng-click="items.unshift('Item ' + items.length)">Add item</button>
         <hr />
         <table>
           <tr ng-repeat="item in items" ng-class-even="'even'">
             <td>{{ item }}</td>
           </tr>
         </table>
       </div>
     </file>
     <file name="style.css">
       .even {
         background: rgba(255, 255, 0, 0.25);
       }

       .even-add, .even-remove {
         transition: 1.5s;
       }
     </file>
     <file name="protractor.js" type="protractor">
       it('should add new entries to the beginning of the list', function() {
         var button = element(by.buttonText('Add item'));
         var rows = element.all(by.repeater('item in items'));

         expect(rows.count()).toBe(4);
         expect(rows.get(0).getText()).toBe('Item 3');
         expect(rows.get(1).getText()).toBe('Item 2');

         button.click();

         expect(rows.count()).toBe(5);
         expect(rows.get(0).getText()).toBe('Item 4');
         expect(rows.get(1).getText()).toBe('Item 3');
       });

       it('should add even class to even entries', function() {
         var button = element(by.buttonText('Add item'));
         var rows = element.all(by.repeater('item in items'));

         expect(rows.get(0).getAttribute('class')).not.toMatch(/even/);
         expect(rows.get(1).getAttribute('class')).toMatch(/even/);

         button.click();

         expect(rows.get(0).getAttribute('class')).not.toMatch(/even/);
         expect(rows.get(1).getAttribute('class')).toMatch(/even/);
       });
     </file>
   </example>
 */
var ngClassEvenDirective = classDirective('Even', 1);

/**
 * @ngdoc directive
 * @name ngCloak
 * @restrict AC
 *
 * @description
 * The `ngCloak` directive is used to prevent the AngularJS html template from being briefly
 * displayed by the browser in its raw (uncompiled) form while your application is loading. Use this
 * directive to avoid the undesirable flicker effect caused by the html template display.
 *
 * The directive can be applied to the `<body>` element, but the preferred usage is to apply
 * multiple `ngCloak` directives to small portions of the page to permit progressive rendering
 * of the browser view.
 *
 * `ngCloak` works in cooperation with the following css rule embedded within `angular.js` and
 * `angular.min.js`.
 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
 *
 * ```css
 * [ng\:cloak], [ng-cloak], [data-ng-cloak], [x-ng-cloak], .ng-cloak, .x-ng-cloak {
 *   display: none !important;
 * }
 * ```
 *
 * When this css rule is loaded by the browser, all html elements (including their children) that
 * are tagged with the `ngCloak` directive are hidden. When AngularJS encounters this directive
 * during the compilation of the template it deletes the `ngCloak` element attribute, making
 * the compiled element visible.
 *
 * For the best result, the `angular.js` script must be loaded in the head section of the html
 * document; alternatively, the css rule above must be included in the external stylesheet of the
 * application.
 *
 * @element ANY
 *
 * @example
   <example name="ng-cloak">
     <file name="index.html">
        <div id="template1" ng-cloak>{{ 'hello' }}</div>
        <div id="template2" class="ng-cloak">{{ 'world' }}</div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should remove the template directive and css class', function() {
         expect($('#template1').getAttribute('ng-cloak')).
           toBeNull();
         expect($('#template2').getAttribute('ng-cloak')).
           toBeNull();
       });
     </file>
   </example>
 *
 */
var ngCloakDirective = ngDirective({
  compile: function(element, attr) {
    attr.$set('ngCloak', undefined);
    element.removeClass('ng-cloak');
  }
});

/**
 * @ngdoc directive
 * @name ngController
 *
 * @description
 * The `ngController` directive attaches a controller class to the view. This is a key aspect of how angular
 * supports the principles behind the Model-View-Controller design pattern.
 *
 * MVC components in angular:
 *
 * * Model — Models are the properties of a scope; scopes are attached to the DOM where scope properties
 *   are accessed through bindings.
 * * View — The template (HTML with data bindings) that is rendered into the View.
 * * Controller — The `ngController` directive specifies a Controller class; the class contains business
 *   logic behind the application to decorate the scope with functions and values
 *
 * Note that you can also attach controllers to the DOM by declaring it in a route definition
 * via the {@link ngRoute.$route $route} service. A common mistake is to declare the controller
 * again using `ng-controller` in the template itself.  This will cause the controller to be attached
 * and executed twice.
 *
 * @element ANY
 * @scope
 * @priority 500
 * @param {expression} ngController Name of a constructor function registered with the current
 * {@link ng.$controllerProvider $controllerProvider} or an {@link guide/expression expression}
 * that on the current scope evaluates to a constructor function.
 *
 * The controller instance can be published into a scope property by specifying
 * `ng-controller="as propertyName"`.
 *
 * @example
 * Here is a simple form for editing user contact information. Adding, removing, clearing, and
 * greeting are methods declared on the controller (see source tab). These methods can
 * easily be called from the AngularJS markup. Any changes to the data are automatically reflected
 * in the View without the need for a manual update.
 *
 * Two different declaration styles are included below:
 *
 * * one binds methods and properties directly onto the controller using `this`:
 * `ng-controller="SettingsController1 as settings"`
 * * one injects `$scope` into the controller:
 * `ng-controller="SettingsController2"`
 *
 * The second option is more common in the AngularJS community, and is generally used in boilerplates
 * and in this guide. However, there are advantages to binding properties directly to the controller
 * and avoiding scope.
 *
 * * Using `controller as` makes it obvious which controller you are accessing in the template when
 * multiple controllers apply to an element.
 * * If you are writing your controllers as classes you have easier access to the properties and
 * methods, which will appear on the scope, from inside the controller code.
 * * Since there is always a `.` in the bindings, you don't have to worry about prototypal
 * inheritance masking primitives.
 *
 * This example demonstrates the `controller as` syntax.
 *
 * <example name="ngControllerAs" module="controllerAsExample">
 *   <file name="index.html">
 *    <div id="ctrl-as-exmpl" ng-controller="SettingsController1 as settings">
 *      <label>Name: <input type="text" ng-model="settings.name"/></label>
 *      <button ng-click="settings.greet()">greet</button><br/>
 *      Contact:
 *      <ul>
 *        <li ng-repeat="contact in settings.contacts">
 *          <select ng-model="contact.type" aria-label="Contact method" id="select_{{$index}}">
 *             <option>phone</option>
 *             <option>email</option>
 *          </select>
 *          <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
 *          <button ng-click="settings.clearContact(contact)">clear</button>
 *          <button ng-click="settings.removeContact(contact)" aria-label="Remove">X</button>
 *        </li>
 *        <li><button ng-click="settings.addContact()">add</button></li>
 *     </ul>
 *    </div>
 *   </file>
 *   <file name="app.js">
 *    angular.module('controllerAsExample', [])
 *      .controller('SettingsController1', SettingsController1);
 *
 *    function SettingsController1() {
 *      this.name = 'John Smith';
 *      this.contacts = [
 *        {type: 'phone', value: '408 555 1212'},
 *        {type: 'email', value: 'john.smith@example.org'}
 *      ];
 *    }
 *
 *    SettingsController1.prototype.greet = function() {
 *      alert(this.name);
 *    };
 *
 *    SettingsController1.prototype.addContact = function() {
 *      this.contacts.push({type: 'email', value: 'yourname@example.org'});
 *    };
 *
 *    SettingsController1.prototype.removeContact = function(contactToRemove) {
 *     var index = this.contacts.indexOf(contactToRemove);
 *      this.contacts.splice(index, 1);
 *    };
 *
 *    SettingsController1.prototype.clearContact = function(contact) {
 *      contact.type = 'phone';
 *      contact.value = '';
 *    };
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     it('should check controller as', function() {
 *       var container = element(by.id('ctrl-as-exmpl'));
 *         expect(container.element(by.model('settings.name'))
 *           .getAttribute('value')).toBe('John Smith');
 *
 *       var firstRepeat =
 *           container.element(by.repeater('contact in settings.contacts').row(0));
 *       var secondRepeat =
 *           container.element(by.repeater('contact in settings.contacts').row(1));
 *
 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
 *           .toBe('408 555 1212');
 *
 *       expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
 *           .toBe('john.smith@example.org');
 *
 *       firstRepeat.element(by.buttonText('clear')).click();
 *
 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
 *           .toBe('');
 *
 *       container.element(by.buttonText('add')).click();
 *
 *       expect(container.element(by.repeater('contact in settings.contacts').row(2))
 *           .element(by.model('contact.value'))
 *           .getAttribute('value'))
 *           .toBe('yourname@example.org');
 *     });
 *   </file>
 * </example>
 *
 * This example demonstrates the "attach to `$scope`" style of controller.
 *
 * <example name="ngController" module="controllerExample">
 *  <file name="index.html">
 *   <div id="ctrl-exmpl" ng-controller="SettingsController2">
 *     <label>Name: <input type="text" ng-model="name"/></label>
 *     <button ng-click="greet()">greet</button><br/>
 *     Contact:
 *     <ul>
 *       <li ng-repeat="contact in contacts">
 *         <select ng-model="contact.type" id="select_{{$index}}">
 *            <option>phone</option>
 *            <option>email</option>
 *         </select>
 *         <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
 *         <button ng-click="clearContact(contact)">clear</button>
 *         <button ng-click="removeContact(contact)">X</button>
 *       </li>
 *       <li>[ <button ng-click="addContact()">add</button> ]</li>
 *    </ul>
 *   </div>
 *  </file>
 *  <file name="app.js">
 *   angular.module('controllerExample', [])
 *     .controller('SettingsController2', ['$scope', SettingsController2]);
 *
 *   function SettingsController2($scope) {
 *     $scope.name = 'John Smith';
 *     $scope.contacts = [
 *       {type:'phone', value:'408 555 1212'},
 *       {type:'email', value:'john.smith@example.org'}
 *     ];
 *
 *     $scope.greet = function() {
 *       alert($scope.name);
 *     };
 *
 *     $scope.addContact = function() {
 *       $scope.contacts.push({type:'email', value:'yourname@example.org'});
 *     };
 *
 *     $scope.removeContact = function(contactToRemove) {
 *       var index = $scope.contacts.indexOf(contactToRemove);
 *       $scope.contacts.splice(index, 1);
 *     };
 *
 *     $scope.clearContact = function(contact) {
 *       contact.type = 'phone';
 *       contact.value = '';
 *     };
 *   }
 *  </file>
 *  <file name="protractor.js" type="protractor">
 *    it('should check controller', function() {
 *      var container = element(by.id('ctrl-exmpl'));
 *
 *      expect(container.element(by.model('name'))
 *          .getAttribute('value')).toBe('John Smith');
 *
 *      var firstRepeat =
 *          container.element(by.repeater('contact in contacts').row(0));
 *      var secondRepeat =
 *          container.element(by.repeater('contact in contacts').row(1));
 *
 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
 *          .toBe('408 555 1212');
 *      expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
 *          .toBe('john.smith@example.org');
 *
 *      firstRepeat.element(by.buttonText('clear')).click();
 *
 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
 *          .toBe('');
 *
 *      container.element(by.buttonText('add')).click();
 *
 *      expect(container.element(by.repeater('contact in contacts').row(2))
 *          .element(by.model('contact.value'))
 *          .getAttribute('value'))
 *          .toBe('yourname@example.org');
 *    });
 *  </file>
 *</example>

 */
var ngControllerDirective = [function() {
  return {
    restrict: 'A',
    scope: true,
    controller: '@',
    priority: 500
  };
}];

/**
 * @ngdoc directive
 * @name ngCsp
 *
 * @restrict A
 * @element ANY
 * @description
 *
 * AngularJS has some features that can conflict with certain restrictions that are applied when using
 * [CSP (Content Security Policy)](https://developer.mozilla.org/en/Security/CSP) rules.
 *
 * If you intend to implement CSP with these rules then you must tell AngularJS not to use these
 * features.
 *
 * This is necessary when developing things like Google Chrome Extensions or Universal Windows Apps.
 *
 *
 * The following default rules in CSP affect AngularJS:
 *
 * * The use of `eval()`, `Function(string)` and similar functions to dynamically create and execute
 * code from strings is forbidden. AngularJS makes use of this in the {@link $parse} service to
 * provide a 30% increase in the speed of evaluating AngularJS expressions. (This CSP rule can be
 * disabled with the CSP keyword `unsafe-eval`, but it is generally not recommended as it would
 * weaken the protections offered by CSP.)
 *
 * * The use of inline resources, such as inline `<script>` and `<style>` elements, are forbidden.
 * This prevents apps from injecting custom styles directly into the document. AngularJS makes use of
 * this to include some CSS rules (e.g. {@link ngCloak} and {@link ngHide}). To make these
 * directives work when a CSP rule is blocking inline styles, you must link to the `angular-csp.css`
 * in your HTML manually. (This CSP rule can be disabled with the CSP keyword `unsafe-inline`, but
 * it is generally not recommended as it would weaken the protections offered by CSP.)
 *
 * If you do not provide `ngCsp` then AngularJS tries to autodetect if CSP is blocking dynamic code
 * creation from strings (e.g., `unsafe-eval` not specified in CSP header) and automatically
 * deactivates this feature in the {@link $parse} service. This autodetection, however, triggers a
 * CSP error to be logged in the console:
 *
 * ```
 * Refused to evaluate a string as JavaScript because 'unsafe-eval' is not an allowed source of
 * script in the following Content Security Policy directive: "default-src 'self'". Note that
 * 'script-src' was not explicitly set, so 'default-src' is used as a fallback.
 * ```
 *
 * This error is harmless but annoying. To prevent the error from showing up, put the `ngCsp`
 * directive on an element of the HTML document that appears before the `<script>` tag that loads
 * the `angular.js` file.
 *
 * *Note: This directive is only available in the `ng-csp` and `data-ng-csp` attribute form.*
 *
 * You can specify which of the CSP related AngularJS features should be deactivated by providing
 * a value for the `ng-csp` attribute. The options are as follows:
 *
 * * no-inline-style: this stops AngularJS from injecting CSS styles into the DOM
 *
 * * no-unsafe-eval: this stops AngularJS from optimizing $parse with unsafe eval of strings
 *
 * You can use these values in the following combinations:
 *
 *
 * * No declaration means that AngularJS will assume that you can do inline styles, but it will do
 * a runtime check for unsafe-eval. E.g. `<body>`. This is backwardly compatible with previous
 * versions of AngularJS.
 *
 * * A simple `ng-csp` (or `data-ng-csp`) attribute will tell AngularJS to deactivate both inline
 * styles and unsafe eval. E.g. `<body ng-csp>`. This is backwardly compatible with previous
 * versions of AngularJS.
 *
 * * Specifying only `no-unsafe-eval` tells AngularJS that we must not use eval, but that we can
 * inject inline styles. E.g. `<body ng-csp="no-unsafe-eval">`.
 *
 * * Specifying only `no-inline-style` tells AngularJS that we must not inject styles, but that we can
 * run eval - no automatic check for unsafe eval will occur. E.g. `<body ng-csp="no-inline-style">`
 *
 * * Specifying both `no-unsafe-eval` and `no-inline-style` tells AngularJS that we must not inject
 * styles nor use eval, which is the same as an empty: ng-csp.
 * E.g.`<body ng-csp="no-inline-style;no-unsafe-eval">`
 *
 * @example
 *
 * This example shows how to apply the `ngCsp` directive to the `html` tag.
   ```html
     <!doctype html>
     <html ng-app ng-csp>
     ...
     ...
     </html>
   ```

  <!-- Note: the `.csp` suffix in the example name triggers CSP mode in our http server! -->
  <example name="example.csp" module="cspExample" ng-csp="true">
    <file name="index.html">
      <div ng-controller="MainController as ctrl">
        <div>
          <button ng-click="ctrl.inc()" id="inc">Increment</button>
          <span id="counter">
            {{ctrl.counter}}
          </span>
        </div>

        <div>
          <button ng-click="ctrl.evil()" id="evil">Evil</button>
          <span id="evilError">
            {{ctrl.evilError}}
          </span>
        </div>
      </div>
    </file>
    <file name="script.js">
       angular.module('cspExample', [])
         .controller('MainController', function MainController() {
            this.counter = 0;
            this.inc = function() {
              this.counter++;
            };
            this.evil = function() {
              try {
                eval('1+2'); // eslint-disable-line no-eval
              } catch (e) {
                this.evilError = e.message;
              }
            };
          });
    </file>
    <file name="protractor.js" type="protractor">
      var util, webdriver;

      var incBtn = element(by.id('inc'));
      var counter = element(by.id('counter'));
      var evilBtn = element(by.id('evil'));
      var evilError = element(by.id('evilError'));

      function getAndClearSevereErrors() {
        return browser.manage().logs().get('browser').then(function(browserLog) {
          return browserLog.filter(function(logEntry) {
            return logEntry.level.value > webdriver.logging.Level.WARNING.value;
          });
        });
      }

      function clearErrors() {
        getAndClearSevereErrors();
      }

      function expectNoErrors() {
        getAndClearSevereErrors().then(function(filteredLog) {
          expect(filteredLog.length).toEqual(0);
          if (filteredLog.length) {
            console.log('browser console errors: ' + util.inspect(filteredLog));
          }
        });
      }

      function expectError(regex) {
        getAndClearSevereErrors().then(function(filteredLog) {
          var found = false;
          filteredLog.forEach(function(log) {
            if (log.message.match(regex)) {
              found = true;
            }
          });
          if (!found) {
            throw new Error('expected an error that matches ' + regex);
          }
        });
      }

      beforeEach(function() {
        util = require('util');
        webdriver = require('selenium-webdriver');
      });

      // For now, we only test on Chrome,
      // as Safari does not load the page with Protractor's injected scripts,
      // and Firefox webdriver always disables content security policy (#6358)
      if (browser.params.browser !== 'chrome') {
        return;
      }

      it('should not report errors when the page is loaded', function() {
        // clear errors so we are not dependent on previous tests
        clearErrors();
        // Need to reload the page as the page is already loaded when
        // we come here
        browser.driver.getCurrentUrl().then(function(url) {
          browser.get(url);
        });
        expectNoErrors();
      });

      it('should evaluate expressions', function() {
        expect(counter.getText()).toEqual('0');
        incBtn.click();
        expect(counter.getText()).toEqual('1');
        expectNoErrors();
      });

      it('should throw and report an error when using "eval"', function() {
        evilBtn.click();
        expect(evilError.getText()).toMatch(/Content Security Policy/);
        expectError(/Content Security Policy/);
      });
    </file>
  </example>
  */

// `ngCsp` is not implemented as a proper directive any more, because we need it be processed while
// we bootstrap the app (before `$parse` is instantiated). For this reason, we just have the `csp()`
// fn that looks for the `ng-csp` attribute anywhere in the current doc.

/**
 * @ngdoc directive
 * @name ngClick
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * The ngClick directive allows you to specify custom behavior when
 * an element is clicked.
 *
 * @param {expression} ngClick {@link guide/expression Expression} to evaluate upon
 * click. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-click">
     <file name="index.html">
      <button ng-click="count = count + 1" ng-init="count=0">
        Increment
      </button>
      <span>
        count: {{count}}
      </span>
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-click', function() {
         expect(element(by.binding('count')).getText()).toMatch('0');
         element(by.css('button')).click();
         expect(element(by.binding('count')).getText()).toMatch('1');
       });
     </file>
   </example>
 */
/*
 * A collection of directives that allows creation of custom event handlers that are defined as
 * AngularJS expressions and are compiled and executed within the current scope.
 */
var ngEventDirectives = {};

// For events that might fire synchronously during DOM manipulation
// we need to execute their event handlers asynchronously using $evalAsync,
// so that they are not executed in an inconsistent state.
var forceAsyncEvents = {
  'blur': true,
  'focus': true
};
forEach(
  'click dblclick mousedown mouseup mouseover mouseout mousemove mouseenter mouseleave keydown keyup keypress submit focus blur copy cut paste'.split(' '),
  function(eventName) {
    var directiveName = directiveNormalize('ng-' + eventName);
    ngEventDirectives[directiveName] = ['$parse', '$rootScope', '$exceptionHandler', function($parse, $rootScope, $exceptionHandler) {
      return createEventDirective($parse, $rootScope, $exceptionHandler, directiveName, eventName, forceAsyncEvents[eventName]);
    }];
  }
);

function createEventDirective($parse, $rootScope, $exceptionHandler, directiveName, eventName, forceAsync) {
  return {
    restrict: 'A',
    compile: function($element, attr) {
      // NOTE:
      // We expose the powerful `$event` object on the scope that provides access to the Window,
      // etc. This is OK, because expressions are not sandboxed any more (and the expression
      // sandbox was never meant to be a security feature anyway).
      var fn = $parse(attr[directiveName]);
      return function ngEventHandler(scope, element) {
        element.on(eventName, function(event) {
          var callback = function() {
            fn(scope, {$event: event});
          };

          if (!$rootScope.$$phase) {
            scope.$apply(callback);
          } else if (forceAsync) {
            scope.$evalAsync(callback);
          } else {
            try {
              callback();
            } catch (error) {
              $exceptionHandler(error);
            }
          }
        });
      };
    }
  };
}

/**
 * @ngdoc directive
 * @name ngDblclick
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * The `ngDblclick` directive allows you to specify custom behavior on a dblclick event.
 *
 * @param {expression} ngDblclick {@link guide/expression Expression} to evaluate upon
 * a dblclick. (The Event object is available as `$event`)
 *
 * @example
   <example name="ng-dblclick">
     <file name="index.html">
      <button ng-dblclick="count = count + 1" ng-init="count=0">
        Increment (on double click)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngMousedown
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * The ngMousedown directive allows you to specify custom behavior on mousedown event.
 *
 * @param {expression} ngMousedown {@link guide/expression Expression} to evaluate upon
 * mousedown. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mousedown">
     <file name="index.html">
      <button ng-mousedown="count = count + 1" ng-init="count=0">
        Increment (on mouse down)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngMouseup
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on mouseup event.
 *
 * @param {expression} ngMouseup {@link guide/expression Expression} to evaluate upon
 * mouseup. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mouseup">
     <file name="index.html">
      <button ng-mouseup="count = count + 1" ng-init="count=0">
        Increment (on mouse up)
      </button>
      count: {{count}}
     </file>
   </example>
 */

/**
 * @ngdoc directive
 * @name ngMouseover
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on mouseover event.
 *
 * @param {expression} ngMouseover {@link guide/expression Expression} to evaluate upon
 * mouseover. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mouseover">
     <file name="index.html">
      <button ng-mouseover="count = count + 1" ng-init="count=0">
        Increment (when mouse is over)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngMouseenter
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on mouseenter event.
 *
 * @param {expression} ngMouseenter {@link guide/expression Expression} to evaluate upon
 * mouseenter. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mouseenter">
     <file name="index.html">
      <button ng-mouseenter="count = count + 1" ng-init="count=0">
        Increment (when mouse enters)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngMouseleave
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on mouseleave event.
 *
 * @param {expression} ngMouseleave {@link guide/expression Expression} to evaluate upon
 * mouseleave. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mouseleave">
     <file name="index.html">
      <button ng-mouseleave="count = count + 1" ng-init="count=0">
        Increment (when mouse leaves)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngMousemove
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on mousemove event.
 *
 * @param {expression} ngMousemove {@link guide/expression Expression} to evaluate upon
 * mousemove. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mousemove">
     <file name="index.html">
      <button ng-mousemove="count = count + 1" ng-init="count=0">
        Increment (when mouse moves)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngKeydown
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on keydown event.
 *
 * @param {expression} ngKeydown {@link guide/expression Expression} to evaluate upon
 * keydown. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
 *
 * @example
   <example name="ng-keydown">
     <file name="index.html">
      <input ng-keydown="count = count + 1" ng-init="count=0">
      key down count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngKeyup
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on keyup event.
 *
 * @param {expression} ngKeyup {@link guide/expression Expression} to evaluate upon
 * keyup. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
 *
 * @example
   <example name="ng-keyup">
     <file name="index.html">
       <p>Typing in the input box below updates the key count</p>
       <input ng-keyup="count = count + 1" ng-init="count=0"> key up count: {{count}}

       <p>Typing in the input box below updates the keycode</p>
       <input ng-keyup="event=$event">
       <p>event keyCode: {{ event.keyCode }}</p>
       <p>event altKey: {{ event.altKey }}</p>
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngKeypress
 * @restrict A
 * @element ANY
 *
 * @description
 * Specify custom behavior on keypress event.
 *
 * @param {expression} ngKeypress {@link guide/expression Expression} to evaluate upon
 * keypress. ({@link guide/expression#-event- Event object is available as `$event`}
 * and can be interrogated for keyCode, altKey, etc.)
 *
 * @example
   <example name="ng-keypress">
     <file name="index.html">
      <input ng-keypress="count = count + 1" ng-init="count=0">
      key press count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngSubmit
 * @restrict A
 * @element form
 * @priority 0
 *
 * @description
 * Enables binding AngularJS expressions to onsubmit events.
 *
 * Additionally it prevents the default action (which for form means sending the request to the
 * server and reloading the current page), but only if the form does not contain `action`,
 * `data-action`, or `x-action` attributes.
 *
 * <div class="alert alert-warning">
 * **Warning:** Be careful not to cause "double-submission" by using both the `ngClick` and
 * `ngSubmit` handlers together. See the
 * {@link form#submitting-a-form-and-preventing-the-default-action `form` directive documentation}
 * for a detailed discussion of when `ngSubmit` may be triggered.
 * </div>
 *
 * @param {expression} ngSubmit {@link guide/expression Expression} to eval.
 * ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example module="submitExample" name="ng-submit">
     <file name="index.html">
      <script>
        angular.module('submitExample', [])
          .controller('ExampleController', ['$scope', function($scope) {
            $scope.list = [];
            $scope.text = 'hello';
            $scope.submit = function() {
              if ($scope.text) {
                $scope.list.push(this.text);
                $scope.text = '';
              }
            };
          }]);
      </script>
      <form ng-submit="submit()" ng-controller="ExampleController">
        Enter text and hit enter:
        <input type="text" ng-model="text" name="text" />
        <input type="submit" id="submit" value="Submit" />
        <pre>list={{list}}</pre>
      </form>
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-submit', function() {
         expect(element(by.binding('list')).getText()).toBe('list=[]');
         element(by.css('#submit')).click();
         expect(element(by.binding('list')).getText()).toContain('hello');
         expect(element(by.model('text')).getAttribute('value')).toBe('');
       });
       it('should ignore empty strings', function() {
         expect(element(by.binding('list')).getText()).toBe('list=[]');
         element(by.css('#submit')).click();
         element(by.css('#submit')).click();
         expect(element(by.binding('list')).getText()).toContain('hello');
        });
     </file>
   </example>
 */

/**
 * @ngdoc directive
 * @name ngFocus
 * @restrict A
 * @element window, input, select, textarea, a
 * @priority 0
 *
 * @description
 * Specify custom behavior on focus event.
 *
 * Note: As the `focus` event is executed synchronously when calling `input.focus()`
 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
 * during an `$apply` to ensure a consistent state.
 *
 * @param {expression} ngFocus {@link guide/expression Expression} to evaluate upon
 * focus. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
 * See {@link ng.directive:ngClick ngClick}
 */

/**
 * @ngdoc directive
 * @name ngBlur
 * @restrict A
 * @element window, input, select, textarea, a
 * @priority 0
 *
 * @description
 * Specify custom behavior on blur event.
 *
 * A [blur event](https://developer.mozilla.org/en-US/docs/Web/Events/blur) fires when
 * an element has lost focus.
 *
 * Note: As the `blur` event is executed synchronously also during DOM manipulations
 * (e.g. removing a focussed input),
 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
 * during an `$apply` to ensure a consistent state.
 *
 * @param {expression} ngBlur {@link guide/expression Expression} to evaluate upon
 * blur. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
 * See {@link ng.directive:ngClick ngClick}
 */

/**
 * @ngdoc directive
 * @name ngCopy
 * @restrict A
 * @element window, input, select, textarea, a
 * @priority 0
 *
 * @description
 * Specify custom behavior on copy event.
 *
 * @param {expression} ngCopy {@link guide/expression Expression} to evaluate upon
 * copy. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-copy">
     <file name="index.html">
      <input ng-copy="copied=true" ng-init="copied=false; value='copy me'" ng-model="value">
      copied: {{copied}}
     </file>
   </example>
 */

/**
 * @ngdoc directive
 * @name ngCut
 * @restrict A
 * @element window, input, select, textarea, a
 * @priority 0
 *
 * @description
 * Specify custom behavior on cut event.
 *
 * @param {expression} ngCut {@link guide/expression Expression} to evaluate upon
 * cut. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-cut">
     <file name="index.html">
      <input ng-cut="cut=true" ng-init="cut=false; value='cut me'" ng-model="value">
      cut: {{cut}}
     </file>
   </example>
 */

/**
 * @ngdoc directive
 * @name ngPaste
 * @restrict A
 * @element window, input, select, textarea, a
 * @priority 0
 *
 * @description
 * Specify custom behavior on paste event.
 *
 * @param {expression} ngPaste {@link guide/expression Expression} to evaluate upon
 * paste. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-paste">
     <file name="index.html">
      <input ng-paste="paste=true" ng-init="paste=false" placeholder='paste here'>
      pasted: {{paste}}
     </file>
   </example>
 */

/**
 * @ngdoc directive
 * @name ngIf
 * @restrict A
 * @multiElement
 *
 * @description
 * The `ngIf` directive removes or recreates a portion of the DOM tree based on an
 * {expression}. If the expression assigned to `ngIf` evaluates to a false
 * value then the element is removed from the DOM, otherwise a clone of the
 * element is reinserted into the DOM.
 *
 * `ngIf` differs from `ngShow` and `ngHide` in that `ngIf` completely removes and recreates the
 * element in the DOM rather than changing its visibility via the `display` css property.  A common
 * case when this difference is significant is when using css selectors that rely on an element's
 * position within the DOM, such as the `:first-child` or `:last-child` pseudo-classes.
 *
 * Note that when an element is removed using `ngIf` its scope is destroyed and a new scope
 * is created when the element is restored.  The scope created within `ngIf` inherits from
 * its parent scope using
 * [prototypal inheritance](https://github.com/angular/angular.js/wiki/Understanding-Scopes#javascript-prototypal-inheritance).
 * An important implication of this is if `ngModel` is used within `ngIf` to bind to
 * a javascript primitive defined in the parent scope. In this case any modifications made to the
 * variable within the child scope will override (hide) the value in the parent scope.
 *
 * Also, `ngIf` recreates elements using their compiled state. An example of this behavior
 * is if an element's class attribute is directly modified after it's compiled, using something like
 * jQuery's `.addClass()` method, and the element is later removed. When `ngIf` recreates the element
 * the added class will be lost because the original compiled state is used to regenerate the element.
 *
 * Additionally, you can provide animations via the `ngAnimate` module to animate the `enter`
 * and `leave` effects.
 *
 * @animations
 * | Animation                        | Occurs                               |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#enter enter}  | just after the `ngIf` contents change and a new DOM element is created and injected into the `ngIf` container |
 * | {@link ng.$animate#leave leave}  | just before the `ngIf` contents are removed from the DOM |
 *
 * @element ANY
 * @scope
 * @priority 600
 * @param {expression} ngIf If the {@link guide/expression expression} is falsy then
 *     the element is removed from the DOM tree. If it is truthy a copy of the compiled
 *     element is added to the DOM tree.
 *
 * @example
  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-if">
    <file name="index.html">
      <label>Click me: <input type="checkbox" ng-model="checked" ng-init="checked=true" /></label><br/>
      Show when checked:
      <span ng-if="checked" class="animate-if">
        This is removed when the checkbox is unchecked.
      </span>
    </file>
    <file name="animations.css">
      .animate-if {
        background:white;
        border:1px solid black;
        padding:10px;
      }

      .animate-if.ng-enter, .animate-if.ng-leave {
        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
      }

      .animate-if.ng-enter,
      .animate-if.ng-leave.ng-leave-active {
        opacity:0;
      }

      .animate-if.ng-leave,
      .animate-if.ng-enter.ng-enter-active {
        opacity:1;
      }
    </file>
  </example>
 */
var ngIfDirective = ['$animate', '$compile', function($animate, $compile) {
  return {
    multiElement: true,
    transclude: 'element',
    priority: 600,
    terminal: true,
    restrict: 'A',
    $$tlb: true,
    link: function($scope, $element, $attr, ctrl, $transclude) {
        var block, childScope, previousElements;
        $scope.$watch($attr.ngIf, function ngIfWatchAction(value) {

          if (value) {
            if (!childScope) {
              $transclude(function(clone, newScope) {
                childScope = newScope;
                clone[clone.length++] = $compile.$$createComment('end ngIf', $attr.ngIf);
                // Note: We only need the first/last node of the cloned nodes.
                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
                // by a directive with templateUrl when its template arrives.
                block = {
                  clone: clone
                };
                $animate.enter(clone, $element.parent(), $element);
              });
            }
          } else {
            if (previousElements) {
              previousElements.remove();
              previousElements = null;
            }
            if (childScope) {
              childScope.$destroy();
              childScope = null;
            }
            if (block) {
              previousElements = getBlockNodes(block.clone);
              $animate.leave(previousElements).done(function(response) {
                if (response !== false) previousElements = null;
              });
              block = null;
            }
          }
        });
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngInclude
 * @restrict ECA
 * @scope
 * @priority -400
 *
 * @description
 * Fetches, compiles and includes an external HTML fragment.
 *
 * By default, the template URL is restricted to the same domain and protocol as the
 * application document. This is done by calling {@link $sce#getTrustedResourceUrl
 * $sce.getTrustedResourceUrl} on it. To load templates from other domains or protocols
 * you may either add them to your {@link ng.$sceDelegateProvider#trustedResourceUrlList trusted
 * resource URL list} or {@link $sce#trustAsResourceUrl wrap them} as trusted values. Refer to
 * AngularJS's {@link ng.$sce Strict Contextual Escaping}.
 *
 * In addition, the browser's
 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
 * policy may further restrict whether the template is successfully loaded.
 * For example, `ngInclude` won't work for cross-domain requests on all browsers and for `file://`
 * access on some browsers.
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#enter enter}  | when the expression changes, on the new include |
 * | {@link ng.$animate#leave leave}  | when the expression changes, on the old include |
 *
 * The enter and leave animation occur concurrently.
 *
 * @param {string} ngInclude|src AngularJS expression evaluating to URL. If the source is a string constant,
 *                 make sure you wrap it in **single** quotes, e.g. `src="'myPartialTemplate.html'"`.
 * @param {string=} onload Expression to evaluate when a new partial is loaded.
 *                  <div class="alert alert-warning">
 *                  **Note:** When using onload on SVG elements in IE11, the browser will try to call
 *                  a function with the name on the window element, which will usually throw a
 *                  "function is undefined" error. To fix this, you can instead use `data-onload` or a
 *                  different form that {@link guide/directive#normalization matches} `onload`.
 *                  </div>
   *
 * @param {string=} autoscroll Whether `ngInclude` should call {@link ng.$anchorScroll
 *                  $anchorScroll} to scroll the viewport after the content is loaded.
 *
 *                  - If the attribute is not set, disable scrolling.
 *                  - If the attribute is set without value, enable scrolling.
 *                  - Otherwise enable scrolling only if the expression evaluates to truthy value.
 *
 * @example
  <example module="includeExample" deps="angular-animate.js" animations="true" name="ng-include">
    <file name="index.html">
     <div ng-controller="ExampleController">
       <select ng-model="template" ng-options="t.name for t in templates">
        <option value="">(blank)</option>
       </select>
       url of the template: <code>{{template.url}}</code>
       <hr/>
       <div class="slide-animate-container">
         <div class="slide-animate" ng-include="template.url"></div>
       </div>
     </div>
    </file>
    <file name="script.js">
      angular.module('includeExample', ['ngAnimate'])
        .controller('ExampleController', ['$scope', function($scope) {
          $scope.templates =
            [{ name: 'template1.html', url: 'template1.html'},
             { name: 'template2.html', url: 'template2.html'}];
          $scope.template = $scope.templates[0];
        }]);
     </file>
    <file name="template1.html">
      Content of template1.html
    </file>
    <file name="template2.html">
      Content of template2.html
    </file>
    <file name="animations.css">
      .slide-animate-container {
        position:relative;
        background:white;
        border:1px solid black;
        height:40px;
        overflow:hidden;
      }

      .slide-animate {
        padding:10px;
      }

      .slide-animate.ng-enter, .slide-animate.ng-leave {
        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;

        position:absolute;
        top:0;
        left:0;
        right:0;
        bottom:0;
        display:block;
        padding:10px;
      }

      .slide-animate.ng-enter {
        top:-50px;
      }
      .slide-animate.ng-enter.ng-enter-active {
        top:0;
      }

      .slide-animate.ng-leave {
        top:0;
      }
      .slide-animate.ng-leave.ng-leave-active {
        top:50px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      var templateSelect = element(by.model('template'));
      var includeElem = element(by.css('[ng-include]'));

      it('should load template1.html', function() {
        expect(includeElem.getText()).toMatch(/Content of template1.html/);
      });

      it('should load template2.html', function() {
        if (browser.params.browser === 'firefox') {
          // Firefox can't handle using selects
          // See https://github.com/angular/protractor/issues/480
          return;
        }
        templateSelect.click();
        templateSelect.all(by.css('option')).get(2).click();
        expect(includeElem.getText()).toMatch(/Content of template2.html/);
      });

      it('should change to blank', function() {
        if (browser.params.browser === 'firefox') {
          // Firefox can't handle using selects
          return;
        }
        templateSelect.click();
        templateSelect.all(by.css('option')).get(0).click();
        expect(includeElem.isPresent()).toBe(false);
      });
    </file>
  </example>
 */


/**
 * @ngdoc event
 * @name ngInclude#$includeContentRequested
 * @eventType emit on the scope ngInclude was declared in
 * @description
 * Emitted every time the ngInclude content is requested.
 *
 * @param {Object} angularEvent Synthetic event object.
 * @param {String} src URL of content to load.
 */


/**
 * @ngdoc event
 * @name ngInclude#$includeContentLoaded
 * @eventType emit on the current ngInclude scope
 * @description
 * Emitted every time the ngInclude content is reloaded.
 *
 * @param {Object} angularEvent Synthetic event object.
 * @param {String} src URL of content to load.
 */


/**
 * @ngdoc event
 * @name ngInclude#$includeContentError
 * @eventType emit on the scope ngInclude was declared in
 * @description
 * Emitted when a template HTTP request yields an erroneous response (status < 200 || status > 299)
 *
 * @param {Object} angularEvent Synthetic event object.
 * @param {String} src URL of content to load.
 */
var ngIncludeDirective = ['$templateRequest', '$anchorScroll', '$animate',
                  function($templateRequest,   $anchorScroll,   $animate) {
  return {
    restrict: 'ECA',
    priority: 400,
    terminal: true,
    transclude: 'element',
    controller: angular.noop,
    compile: function(element, attr) {
      var srcExp = attr.ngInclude || attr.src,
          onloadExp = attr.onload || '',
          autoScrollExp = attr.autoscroll;

      return function(scope, $element, $attr, ctrl, $transclude) {
        var changeCounter = 0,
            currentScope,
            previousElement,
            currentElement;

        var cleanupLastIncludeContent = function() {
          if (previousElement) {
            previousElement.remove();
            previousElement = null;
          }
          if (currentScope) {
            currentScope.$destroy();
            currentScope = null;
          }
          if (currentElement) {
            $animate.leave(currentElement).done(function(response) {
              if (response !== false) previousElement = null;
            });
            previousElement = currentElement;
            currentElement = null;
          }
        };

        scope.$watch(srcExp, function ngIncludeWatchAction(src) {
          var afterAnimation = function(response) {
            if (response !== false && isDefined(autoScrollExp) &&
              (!autoScrollExp || scope.$eval(autoScrollExp))) {
                $anchorScroll();
            }
          };
          var thisChangeId = ++changeCounter;

          if (src) {
            //set the 2nd param to true to ignore the template request error so that the inner
            //contents and scope can be cleaned up.
            $templateRequest(src, true).then(function(response) {
              if (scope.$$destroyed) return;

              if (thisChangeId !== changeCounter) return;
              var newScope = scope.$new();
              ctrl.template = response;

              // Note: This will also link all children of ng-include that were contained in the original
              // html. If that content contains controllers, ... they could pollute/change the scope.
              // However, using ng-include on an element with additional content does not make sense...
              // Note: We can't remove them in the cloneAttchFn of $transclude as that
              // function is called before linking the content, which would apply child
              // directives to non existing elements.
              var clone = $transclude(newScope, function(clone) {
                cleanupLastIncludeContent();
                $animate.enter(clone, null, $element).done(afterAnimation);
              });

              currentScope = newScope;
              currentElement = clone;

              currentScope.$emit('$includeContentLoaded', src);
              scope.$eval(onloadExp);
            }, function() {
              if (scope.$$destroyed) return;

              if (thisChangeId === changeCounter) {
                cleanupLastIncludeContent();
                scope.$emit('$includeContentError', src);
              }
            });
            scope.$emit('$includeContentRequested', src);
          } else {
            cleanupLastIncludeContent();
            ctrl.template = null;
          }
        });
      };
    }
  };
}];

// This directive is called during the $transclude call of the first `ngInclude` directive.
// It will replace and compile the content of the element with the loaded template.
// We need this directive so that the element content is already filled when
// the link function of another directive on the same element as ngInclude
// is called.
var ngIncludeFillContentDirective = ['$compile',
  function($compile) {
    return {
      restrict: 'ECA',
      priority: -400,
      require: 'ngInclude',
      link: function(scope, $element, $attr, ctrl) {
        if (toString.call($element[0]).match(/SVG/)) {
          // WebKit: https://bugs.webkit.org/show_bug.cgi?id=135698 --- SVG elements do not
          // support innerHTML, so detect this here and try to generate the contents
          // specially.
          $element.empty();
          $compile(jqLiteBuildFragment(ctrl.template, window.document).childNodes)(scope,
              function namespaceAdaptedClone(clone) {
            $element.append(clone);
          }, {futureParentElement: $element});
          return;
        }

        $element.html(ctrl.template);
        $compile($element.contents())(scope);
      }
    };
  }];

/**
 * @ngdoc directive
 * @name ngInit
 * @restrict AC
 * @priority 450
 * @element ANY
 *
 * @param {expression} ngInit {@link guide/expression Expression} to eval.
 *
 * @description
 * The `ngInit` directive allows you to evaluate an expression in the
 * current scope.
 *
 * <div class="alert alert-danger">
 * This directive can be abused to add unnecessary amounts of logic into your templates.
 * There are only a few appropriate uses of `ngInit`:
 * <ul>
 *   <li>aliasing special properties of {@link ng.directive:ngRepeat `ngRepeat`},
 *     as seen in the demo below.</li>
 *   <li>initializing data during development, or for examples, as seen throughout these docs.</li>
 *   <li>injecting data via server side scripting.</li>
 * </ul>
 *
 * Besides these few cases, you should use {@link guide/component Components} or
 * {@link guide/controller Controllers} rather than `ngInit` to initialize values on a scope.
 * </div>
 *
 * <div class="alert alert-warning">
 * **Note**: If you have assignment in `ngInit` along with a {@link ng.$filter `filter`}, make
 * sure you have parentheses to ensure correct operator precedence:
 * <pre class="prettyprint">
 * `<div ng-init="test1 = ($index | toString)"></div>`
 * </pre>
 * </div>
 *
 * @example
   <example module="initExample" name="ng-init">
     <file name="index.html">
   <script>
     angular.module('initExample', [])
       .controller('ExampleController', ['$scope', function($scope) {
         $scope.list = [['a', 'b'], ['c', 'd']];
       }]);
   </script>
   <div ng-controller="ExampleController">
     <div ng-repeat="innerList in list" ng-init="outerIndex = $index">
       <div ng-repeat="value in innerList" ng-init="innerIndex = $index">
          <span class="example-init">list[ {{outerIndex}} ][ {{innerIndex}} ] = {{value}};</span>
       </div>
     </div>
   </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should alias index positions', function() {
         var elements = element.all(by.css('.example-init'));
         expect(elements.get(0).getText()).toBe('list[ 0 ][ 0 ] = a;');
         expect(elements.get(1).getText()).toBe('list[ 0 ][ 1 ] = b;');
         expect(elements.get(2).getText()).toBe('list[ 1 ][ 0 ] = c;');
         expect(elements.get(3).getText()).toBe('list[ 1 ][ 1 ] = d;');
       });
     </file>
   </example>
 */
var ngInitDirective = ngDirective({
  priority: 450,
  compile: function() {
    return {
      pre: function(scope, element, attrs) {
        scope.$eval(attrs.ngInit);
      }
    };
  }
});

/**
 * @ngdoc directive
 * @name ngList
 * @restrict A
 * @priority 100
 *
 * @param {string=} ngList optional delimiter that should be used to split the value.
 *
 * @description
 * Text input that converts between a delimited string and an array of strings. The default
 * delimiter is a comma followed by a space - equivalent to `ng-list=", "`. You can specify a custom
 * delimiter as the value of the `ngList` attribute - for example, `ng-list=" | "`.
 *
 * The behaviour of the directive is affected by the use of the `ngTrim` attribute.
 * * If `ngTrim` is set to `"false"` then whitespace around both the separator and each
 *   list item is respected. This implies that the user of the directive is responsible for
 *   dealing with whitespace but also allows you to use whitespace as a delimiter, such as a
 *   tab or newline character.
 * * Otherwise whitespace around the delimiter is ignored when splitting (although it is respected
 *   when joining the list items back together) and whitespace around each list item is stripped
 *   before it is added to the model.
 *
 * @example
 * ### Validation
 *
 * <example name="ngList-directive" module="listExample">
 *   <file name="app.js">
 *      angular.module('listExample', [])
 *        .controller('ExampleController', ['$scope', function($scope) {
 *          $scope.names = ['morpheus', 'neo', 'trinity'];
 *        }]);
 *   </file>
 *   <file name="index.html">
 *    <form name="myForm" ng-controller="ExampleController">
 *      <label>List: <input name="namesInput" ng-model="names" ng-list required></label>
 *      <span role="alert">
 *        <span class="error" ng-show="myForm.namesInput.$error.required">
 *        Required!</span>
 *      </span>
 *      <br>
 *      <tt>names = {{names}}</tt><br/>
 *      <tt>myForm.namesInput.$valid = {{myForm.namesInput.$valid}}</tt><br/>
 *      <tt>myForm.namesInput.$error = {{myForm.namesInput.$error}}</tt><br/>
 *      <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
 *      <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
 *     </form>
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     var listInput = element(by.model('names'));
 *     var names = element(by.exactBinding('names'));
 *     var valid = element(by.binding('myForm.namesInput.$valid'));
 *     var error = element(by.css('span.error'));
 *
 *     it('should initialize to model', function() {
 *       expect(names.getText()).toContain('["morpheus","neo","trinity"]');
 *       expect(valid.getText()).toContain('true');
 *       expect(error.getCssValue('display')).toBe('none');
 *     });
 *
 *     it('should be invalid if empty', function() {
 *       listInput.clear();
 *       listInput.sendKeys('');
 *
 *       expect(names.getText()).toContain('');
 *       expect(valid.getText()).toContain('false');
 *       expect(error.getCssValue('display')).not.toBe('none');
 *     });
 *   </file>
 * </example>
 *
 * @example
 * ### Splitting on newline
 *
 * <example name="ngList-directive-newlines">
 *   <file name="index.html">
 *    <textarea ng-model="list" ng-list="&#10;" ng-trim="false"></textarea>
 *    <pre>{{ list | json }}</pre>
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     it("should split the text by newlines", function() {
 *       var listInput = element(by.model('list'));
 *       var output = element(by.binding('list | json'));
 *       listInput.sendKeys('abc\ndef\nghi');
 *       expect(output.getText()).toContain('[\n  "abc",\n  "def",\n  "ghi"\n]');
 *     });
 *   </file>
 * </example>
 *
 */
var ngListDirective = function() {
  return {
    restrict: 'A',
    priority: 100,
    require: 'ngModel',
    link: function(scope, element, attr, ctrl) {
      var ngList = attr.ngList || ', ';
      var trimValues = attr.ngTrim !== 'false';
      var separator = trimValues ? trim(ngList) : ngList;

      var parse = function(viewValue) {
        // If the viewValue is invalid (say required but empty) it will be `undefined`
        if (isUndefined(viewValue)) return;

        var list = [];

        if (viewValue) {
          forEach(viewValue.split(separator), function(value) {
            if (value) list.push(trimValues ? trim(value) : value);
          });
        }

        return list;
      };

      ctrl.$parsers.push(parse);
      ctrl.$formatters.push(function(value) {
        if (isArray(value)) {
          return value.join(ngList);
        }

        return undefined;
      });

      // Override the standard $isEmpty because an empty array means the input is empty.
      ctrl.$isEmpty = function(value) {
        return !value || !value.length;
      };
    }
  };
};

/* global VALID_CLASS: true,
  INVALID_CLASS: true,
  PRISTINE_CLASS: true,
  DIRTY_CLASS: true,
  UNTOUCHED_CLASS: true,
  TOUCHED_CLASS: true,
  PENDING_CLASS: true,
  addSetValidityMethod: true,
  setupValidity: true,
  defaultModelOptions: false
*/


var VALID_CLASS = 'ng-valid',
    INVALID_CLASS = 'ng-invalid',
    PRISTINE_CLASS = 'ng-pristine',
    DIRTY_CLASS = 'ng-dirty',
    UNTOUCHED_CLASS = 'ng-untouched',
    TOUCHED_CLASS = 'ng-touched',
    EMPTY_CLASS = 'ng-empty',
    NOT_EMPTY_CLASS = 'ng-not-empty';

var ngModelMinErr = minErr('ngModel');

/**
 * @ngdoc type
 * @name ngModel.NgModelController
 * @property {*} $viewValue The actual value from the control's view. For `input` elements, this is a
 * String. See {@link ngModel.NgModelController#$setViewValue} for information about when the $viewValue
 * is set.
 *
 * @property {*} $modelValue The value in the model that the control is bound to.
 *
 * @property {Array.<Function>} $parsers Array of functions to execute, as a pipeline, whenever
 *  the control updates the ngModelController with a new {@link ngModel.NgModelController#$viewValue
    `$viewValue`} from the DOM, usually via user input.
    See {@link ngModel.NgModelController#$setViewValue `$setViewValue()`} for a detailed lifecycle explanation.
    Note that the `$parsers` are not called when the bound ngModel expression changes programmatically.

  The functions are called in array order, each passing
    its return value through to the next. The last return value is forwarded to the
    {@link ngModel.NgModelController#$validators `$validators`} collection.

  Parsers are used to sanitize / convert the {@link ngModel.NgModelController#$viewValue
    `$viewValue`}.

  Returning `undefined` from a parser means a parse error occurred. In that case,
    no {@link ngModel.NgModelController#$validators `$validators`} will run and the `ngModel`
    will be set to `undefined` unless {@link ngModelOptions `ngModelOptions.allowInvalid`}
    is set to `true`. The parse error is stored in `ngModel.$error.parse`.

  This simple example shows a parser that would convert text input value to lowercase:
 * ```js
 * function parse(value) {
 *   if (value) {
 *     return value.toLowerCase();
 *   }
 * }
 * ngModelController.$parsers.push(parse);
 * ```

 *
 * @property {Array.<Function>} $formatters Array of functions to execute, as a pipeline, whenever
    the bound ngModel expression changes programmatically. The `$formatters` are not called when the
    value of the control is changed by user interaction.

  Formatters are used to format / convert the {@link ngModel.NgModelController#$modelValue
    `$modelValue`} for display in the control.

  The functions are called in reverse array order, each passing the value through to the
    next. The last return value is used as the actual DOM value.

  This simple example shows a formatter that would convert the model value to uppercase:

 * ```js
 * function format(value) {
 *   if (value) {
 *     return value.toUpperCase();
 *   }
 * }
 * ngModel.$formatters.push(format);
 * ```
 *
 * @property {Object.<string, function>} $validators A collection of validators that are applied
 *      whenever the model value changes. The key value within the object refers to the name of the
 *      validator while the function refers to the validation operation. The validation operation is
 *      provided with the model value as an argument and must return a true or false value depending
 *      on the response of that validation.
 *
 * ```js
 * ngModel.$validators.validCharacters = function(modelValue, viewValue) {
 *   var value = modelValue || viewValue;
 *   return /[0-9]+/.test(value) &&
 *          /[a-z]+/.test(value) &&
 *          /[A-Z]+/.test(value) &&
 *          /\W+/.test(value);
 * };
 * ```
 *
 * @property {Object.<string, function>} $asyncValidators A collection of validations that are expected to
 *      perform an asynchronous validation (e.g. a HTTP request). The validation function that is provided
 *      is expected to return a promise when it is run during the model validation process. Once the promise
 *      is delivered then the validation status will be set to true when fulfilled and false when rejected.
 *      When the asynchronous validators are triggered, each of the validators will run in parallel and the model
 *      value will only be updated once all validators have been fulfilled. As long as an asynchronous validator
 *      is unfulfilled, its key will be added to the controllers `$pending` property. Also, all asynchronous validators
 *      will only run once all synchronous validators have passed.
 *
 * Please note that if $http is used then it is important that the server returns a success HTTP response code
 * in order to fulfill the validation and a status level of `4xx` in order to reject the validation.
 *
 * ```js
 * ngModel.$asyncValidators.uniqueUsername = function(modelValue, viewValue) {
 *   var value = modelValue || viewValue;
 *
 *   // Lookup user by username
 *   return $http.get('/api/users/' + value).
 *      then(function resolved() {
 *        //username exists, this means validation fails
 *        return $q.reject('exists');
 *      }, function rejected() {
 *        //username does not exist, therefore this validation passes
 *        return true;
 *      });
 * };
 * ```
 *
 * @property {Array.<Function>} $viewChangeListeners Array of functions to execute whenever
 *     a change to {@link ngModel.NgModelController#$viewValue `$viewValue`} has caused a change
 *     to {@link ngModel.NgModelController#$modelValue `$modelValue`}.
 *     It is called with no arguments, and its return value is ignored.
 *     This can be used in place of additional $watches against the model value.
 *
 * @property {Object} $error An object hash with all failing validator ids as keys.
 * @property {Object} $pending An object hash with all pending validator ids as keys.
 *
 * @property {boolean} $untouched True if control has not lost focus yet.
 * @property {boolean} $touched True if control has lost focus.
 * @property {boolean} $pristine True if user has not interacted with the control yet.
 * @property {boolean} $dirty True if user has already interacted with the control.
 * @property {boolean} $valid True if there is no error.
 * @property {boolean} $invalid True if at least one error on the control.
 * @property {string} $name The name attribute of the control.
 *
 * @description
 *
 * `NgModelController` provides API for the {@link ngModel `ngModel`} directive.
 * The controller contains services for data-binding, validation, CSS updates, and value formatting
 * and parsing. It purposefully does not contain any logic which deals with DOM rendering or
 * listening to DOM events.
 * Such DOM related logic should be provided by other directives which make use of
 * `NgModelController` for data-binding to control elements.
 * AngularJS provides this DOM logic for most {@link input `input`} elements.
 * At the end of this page you can find a {@link ngModel.NgModelController#custom-control-example
 * custom control example} that uses `ngModelController` to bind to `contenteditable` elements.
 *
 * @example
 * ### Custom Control Example
 * This example shows how to use `NgModelController` with a custom control to achieve
 * data-binding. Notice how different directives (`contenteditable`, `ng-model`, and `required`)
 * collaborate together to achieve the desired result.
 *
 * `contenteditable` is an HTML5 attribute, which tells the browser to let the element
 * contents be edited in place by the user.
 *
 * We are using the {@link ng.service:$sce $sce} service here and include the {@link ngSanitize $sanitize}
 * module to automatically remove "bad" content like inline event listener (e.g. `<span onclick="...">`).
 * However, as we are using `$sce` the model can still decide to provide unsafe content if it marks
 * that content using the `$sce` service.
 *
 * <example name="NgModelController" module="customControl" deps="angular-sanitize.js">
    <file name="style.css">
      [contenteditable] {
        border: 1px solid black;
        background-color: white;
        min-height: 20px;
      }

      .ng-invalid {
        border: 1px solid red;
      }

    </file>
    <file name="script.js">
      angular.module('customControl', ['ngSanitize']).
        directive('contenteditable', ['$sce', function($sce) {
          return {
            restrict: 'A', // only activate on element attribute
            require: '?ngModel', // get a hold of NgModelController
            link: function(scope, element, attrs, ngModel) {
              if (!ngModel) return; // do nothing if no ng-model

              // Specify how UI should be updated
              ngModel.$render = function() {
                element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
              };

              // Listen for change events to enable binding
              element.on('blur keyup change', function() {
                scope.$evalAsync(read);
              });
              read(); // initialize

              // Write data to the model
              function read() {
                var html = element.html();
                // When we clear the content editable the browser leaves a <br> behind
                // If strip-br attribute is provided then we strip this out
                if (attrs.stripBr && html === '<br>') {
                  html = '';
                }
                ngModel.$setViewValue(html);
              }
            }
          };
        }]);
    </file>
    <file name="index.html">
      <form name="myForm">
       <div contenteditable
            name="myWidget" ng-model="userContent"
            strip-br="true"
            required>Change me!</div>
        <span ng-show="myForm.myWidget.$error.required">Required!</span>
       <hr>
       <textarea ng-model="userContent" aria-label="Dynamic textarea"></textarea>
      </form>
    </file>
    <file name="protractor.js" type="protractor">
    it('should data-bind and become invalid', function() {
      if (browser.params.browser === 'safari' || browser.params.browser === 'firefox') {
        // SafariDriver can't handle contenteditable
        // and Firefox driver can't clear contenteditables very well
        return;
      }
      var contentEditable = element(by.css('[contenteditable]'));
      var content = 'Change me!';

      expect(contentEditable.getText()).toEqual(content);

      contentEditable.clear();
      contentEditable.sendKeys(protractor.Key.BACK_SPACE);
      expect(contentEditable.getText()).toEqual('');
      expect(contentEditable.getAttribute('class')).toMatch(/ng-invalid-required/);
    });
    </file>
 * </example>
 *
 *
 */
NgModelController.$inject = ['$scope', '$exceptionHandler', '$attrs', '$element', '$parse', '$animate', '$timeout', '$q', '$interpolate'];
function NgModelController($scope, $exceptionHandler, $attr, $element, $parse, $animate, $timeout, $q, $interpolate) {
  this.$viewValue = Number.NaN;
  this.$modelValue = Number.NaN;
  this.$$rawModelValue = undefined; // stores the parsed modelValue / model set from scope regardless of validity.
  this.$validators = {};
  this.$asyncValidators = {};
  this.$parsers = [];
  this.$formatters = [];
  this.$viewChangeListeners = [];
  this.$untouched = true;
  this.$touched = false;
  this.$pristine = true;
  this.$dirty = false;
  this.$valid = true;
  this.$invalid = false;
  this.$error = {}; // keep invalid keys here
  this.$$success = {}; // keep valid keys here
  this.$pending = undefined; // keep pending keys here
  this.$name = $interpolate($attr.name || '', false)($scope);
  this.$$parentForm = nullFormCtrl;
  this.$options = defaultModelOptions;
  this.$$updateEvents = '';
  // Attach the correct context to the event handler function for updateOn
  this.$$updateEventHandler = this.$$updateEventHandler.bind(this);

  this.$$parsedNgModel = $parse($attr.ngModel);
  this.$$parsedNgModelAssign = this.$$parsedNgModel.assign;
  this.$$ngModelGet = this.$$parsedNgModel;
  this.$$ngModelSet = this.$$parsedNgModelAssign;
  this.$$pendingDebounce = null;
  this.$$parserValid = undefined;
  this.$$parserName = 'parse';

  this.$$currentValidationRunId = 0;

  this.$$scope = $scope;
  this.$$rootScope = $scope.$root;
  this.$$attr = $attr;
  this.$$element = $element;
  this.$$animate = $animate;
  this.$$timeout = $timeout;
  this.$$parse = $parse;
  this.$$q = $q;
  this.$$exceptionHandler = $exceptionHandler;

  setupValidity(this);
  setupModelWatcher(this);
}

NgModelController.prototype = {
  $$initGetterSetters: function() {
    if (this.$options.getOption('getterSetter')) {
      var invokeModelGetter = this.$$parse(this.$$attr.ngModel + '()'),
          invokeModelSetter = this.$$parse(this.$$attr.ngModel + '($$$p)');

      this.$$ngModelGet = function($scope) {
        var modelValue = this.$$parsedNgModel($scope);
        if (isFunction(modelValue)) {
          modelValue = invokeModelGetter($scope);
        }
        return modelValue;
      };
      this.$$ngModelSet = function($scope, newValue) {
        if (isFunction(this.$$parsedNgModel($scope))) {
          invokeModelSetter($scope, {$$$p: newValue});
        } else {
          this.$$parsedNgModelAssign($scope, newValue);
        }
      };
    } else if (!this.$$parsedNgModel.assign) {
      throw ngModelMinErr('nonassign', 'Expression \'{0}\' is non-assignable. Element: {1}',
          this.$$attr.ngModel, startingTag(this.$$element));
    }
  },


  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$render
   *
   * @description
   * Called when the view needs to be updated. It is expected that the user of the ng-model
   * directive will implement this method.
   *
   * The `$render()` method is invoked in the following situations:
   *
   * * `$rollbackViewValue()` is called.  If we are rolling back the view value to the last
   *   committed value then `$render()` is called to update the input control.
   * * The value referenced by `ng-model` is changed programmatically and both the `$modelValue` and
   *   the `$viewValue` are different from last time.
   *
   * Since `ng-model` does not do a deep watch, `$render()` is only invoked if the values of
   * `$modelValue` and `$viewValue` are actually different from their previous values. If `$modelValue`
   * or `$viewValue` are objects (rather than a string or number) then `$render()` will not be
   * invoked if you only change a property on the objects.
   */
  $render: noop,

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$isEmpty
   *
   * @description
   * This is called when we need to determine if the value of an input is empty.
   *
   * For instance, the required directive does this to work out if the input has data or not.
   *
   * The default `$isEmpty` function checks whether the value is `undefined`, `''`, `null` or `NaN`.
   *
   * You can override this for input directives whose concept of being empty is different from the
   * default. The `checkboxInputType` directive does this because in its case a value of `false`
   * implies empty.
   *
   * @param {*} value The value of the input to check for emptiness.
   * @returns {boolean} True if `value` is "empty".
   */
  $isEmpty: function(value) {
    // eslint-disable-next-line no-self-compare
    return isUndefined(value) || value === '' || value === null || value !== value;
  },

  $$updateEmptyClasses: function(value) {
    if (this.$isEmpty(value)) {
      this.$$animate.removeClass(this.$$element, NOT_EMPTY_CLASS);
      this.$$animate.addClass(this.$$element, EMPTY_CLASS);
    } else {
      this.$$animate.removeClass(this.$$element, EMPTY_CLASS);
      this.$$animate.addClass(this.$$element, NOT_EMPTY_CLASS);
    }
  },

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setPristine
   *
   * @description
   * Sets the control to its pristine state.
   *
   * This method can be called to remove the `ng-dirty` class and set the control to its pristine
   * state (`ng-pristine` class). A model is considered to be pristine when the control
   * has not been changed from when first compiled.
   */
  $setPristine: function() {
    this.$dirty = false;
    this.$pristine = true;
    this.$$animate.removeClass(this.$$element, DIRTY_CLASS);
    this.$$animate.addClass(this.$$element, PRISTINE_CLASS);
  },

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setDirty
   *
   * @description
   * Sets the control to its dirty state.
   *
   * This method can be called to remove the `ng-pristine` class and set the control to its dirty
   * state (`ng-dirty` class). A model is considered to be dirty when the control has been changed
   * from when first compiled.
   */
  $setDirty: function() {
    this.$dirty = true;
    this.$pristine = false;
    this.$$animate.removeClass(this.$$element, PRISTINE_CLASS);
    this.$$animate.addClass(this.$$element, DIRTY_CLASS);
    this.$$parentForm.$setDirty();
  },

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setUntouched
   *
   * @description
   * Sets the control to its untouched state.
   *
   * This method can be called to remove the `ng-touched` class and set the control to its
   * untouched state (`ng-untouched` class). Upon compilation, a model is set as untouched
   * by default, however this function can be used to restore that state if the model has
   * already been touched by the user.
   */
  $setUntouched: function() {
    this.$touched = false;
    this.$untouched = true;
    this.$$animate.setClass(this.$$element, UNTOUCHED_CLASS, TOUCHED_CLASS);
  },

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setTouched
   *
   * @description
   * Sets the control to its touched state.
   *
   * This method can be called to remove the `ng-untouched` class and set the control to its
   * touched state (`ng-touched` class). A model is considered to be touched when the user has
   * first focused the control element and then shifted focus away from the control (blur event).
   */
  $setTouched: function() {
    this.$touched = true;
    this.$untouched = false;
    this.$$animate.setClass(this.$$element, TOUCHED_CLASS, UNTOUCHED_CLASS);
  },

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$rollbackViewValue
   *
   * @description
   * Cancel an update and reset the input element's value to prevent an update to the `$modelValue`,
   * which may be caused by a pending debounced event or because the input is waiting for some
   * future event.
   *
   * If you have an input that uses `ng-model-options` to set up debounced updates or updates that
   * depend on special events such as `blur`, there can be a period when the `$viewValue` is out of
   * sync with the ngModel's `$modelValue`.
   *
   * In this case, you can use `$rollbackViewValue()` to manually cancel the debounced / future update
   * and reset the input to the last committed view value.
   *
   * It is also possible that you run into difficulties if you try to update the ngModel's `$modelValue`
   * programmatically before these debounced/future events have resolved/occurred, because AngularJS's
   * dirty checking mechanism is not able to tell whether the model has actually changed or not.
   *
   * The `$rollbackViewValue()` method should be called before programmatically changing the model of an
   * input which may have such events pending. This is important in order to make sure that the
   * input field will be updated with the new model value and any pending operations are cancelled.
   *
   * @example
   * <example name="ng-model-cancel-update" module="cancel-update-example">
   *   <file name="app.js">
   *     angular.module('cancel-update-example', [])
   *
   *     .controller('CancelUpdateController', ['$scope', function($scope) {
   *       $scope.model = {value1: '', value2: ''};
   *
   *       $scope.setEmpty = function(e, value, rollback) {
   *         if (e.keyCode === 27) {
   *           e.preventDefault();
   *           if (rollback) {
   *             $scope.myForm[value].$rollbackViewValue();
   *           }
   *           $scope.model[value] = '';
   *         }
   *       };
   *     }]);
   *   </file>
   *   <file name="index.html">
   *     <div ng-controller="CancelUpdateController">
   *       <p>Both of these inputs are only updated if they are blurred. Hitting escape should
   *       empty them. Follow these steps and observe the difference:</p>
   *       <ol>
   *         <li>Type something in the input. You will see that the model is not yet updated</li>
   *         <li>Press the Escape key.
   *           <ol>
   *             <li> In the first example, nothing happens, because the model is already '', and no
   *             update is detected. If you blur the input, the model will be set to the current view.
   *             </li>
   *             <li> In the second example, the pending update is cancelled, and the input is set back
   *             to the last committed view value (''). Blurring the input does nothing.
   *             </li>
   *           </ol>
   *         </li>
   *       </ol>
   *
   *       <form name="myForm" ng-model-options="{ updateOn: 'blur' }">
   *         <div>
   *           <p id="inputDescription1">Without $rollbackViewValue():</p>
   *           <input name="value1" aria-describedby="inputDescription1" ng-model="model.value1"
   *                  ng-keydown="setEmpty($event, 'value1')">
   *           value1: "{{ model.value1 }}"
   *         </div>
   *
   *         <div>
   *           <p id="inputDescription2">With $rollbackViewValue():</p>
   *           <input name="value2" aria-describedby="inputDescription2" ng-model="model.value2"
   *                  ng-keydown="setEmpty($event, 'value2', true)">
   *           value2: "{{ model.value2 }}"
   *         </div>
   *       </form>
   *     </div>
   *   </file>
       <file name="style.css">
          div {
            display: table-cell;
          }
          div:nth-child(1) {
            padding-right: 30px;
          }

        </file>
   * </example>
   */
  $rollbackViewValue: function() {
    this.$$timeout.cancel(this.$$pendingDebounce);
    this.$viewValue = this.$$lastCommittedViewValue;
    this.$render();
  },

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$validate
   *
   * @description
   * Runs each of the registered validators (first synchronous validators and then
   * asynchronous validators).
   * If the validity changes to invalid, the model will be set to `undefined`,
   * unless {@link ngModelOptions `ngModelOptions.allowInvalid`} is `true`.
   * If the validity changes to valid, it will set the model to the last available valid
   * `$modelValue`, i.e. either the last parsed value or the last value set from the scope.
   */
  $validate: function() {

    // ignore $validate before model is initialized
    if (isNumberNaN(this.$modelValue)) {
      return;
    }

    var viewValue = this.$$lastCommittedViewValue;
    // Note: we use the $$rawModelValue as $modelValue might have been
    // set to undefined during a view -> model update that found validation
    // errors. We can't parse the view here, since that could change
    // the model although neither viewValue nor the model on the scope changed
    var modelValue = this.$$rawModelValue;

    var prevValid = this.$valid;
    var prevModelValue = this.$modelValue;

    var allowInvalid = this.$options.getOption('allowInvalid');

    var that = this;
    this.$$runValidators(modelValue, viewValue, function(allValid) {
      // If there was no change in validity, don't update the model
      // This prevents changing an invalid modelValue to undefined
      if (!allowInvalid && prevValid !== allValid) {
        // Note: Don't check this.$valid here, as we could have
        // external validators (e.g. calculated on the server),
        // that just call $setValidity and need the model value
        // to calculate their validity.
        that.$modelValue = allValid ? modelValue : undefined;

        if (that.$modelValue !== prevModelValue) {
          that.$$writeModelToScope();
        }
      }
    });
  },

  $$runValidators: function(modelValue, viewValue, doneCallback) {
    this.$$currentValidationRunId++;
    var localValidationRunId = this.$$currentValidationRunId;
    var that = this;

    // check parser error
    if (!processParseErrors()) {
      validationDone(false);
      return;
    }
    if (!processSyncValidators()) {
      validationDone(false);
      return;
    }
    processAsyncValidators();

    function processParseErrors() {
      var errorKey = that.$$parserName;

      if (isUndefined(that.$$parserValid)) {
        setValidity(errorKey, null);
      } else {
        if (!that.$$parserValid) {
          forEach(that.$validators, function(v, name) {
            setValidity(name, null);
          });
          forEach(that.$asyncValidators, function(v, name) {
            setValidity(name, null);
          });
        }

        // Set the parse error last, to prevent unsetting it, should a $validators key == parserName
        setValidity(errorKey, that.$$parserValid);
        return that.$$parserValid;
      }
      return true;
    }

    function processSyncValidators() {
      var syncValidatorsValid = true;
      forEach(that.$validators, function(validator, name) {
        var result = Boolean(validator(modelValue, viewValue));
        syncValidatorsValid = syncValidatorsValid && result;
        setValidity(name, result);
      });
      if (!syncValidatorsValid) {
        forEach(that.$asyncValidators, function(v, name) {
          setValidity(name, null);
        });
        return false;
      }
      return true;
    }

    function processAsyncValidators() {
      var validatorPromises = [];
      var allValid = true;
      forEach(that.$asyncValidators, function(validator, name) {
        var promise = validator(modelValue, viewValue);
        if (!isPromiseLike(promise)) {
          throw ngModelMinErr('nopromise',
            'Expected asynchronous validator to return a promise but got \'{0}\' instead.', promise);
        }
        setValidity(name, undefined);
        validatorPromises.push(promise.then(function() {
          setValidity(name, true);
        }, function() {
          allValid = false;
          setValidity(name, false);
        }));
      });
      if (!validatorPromises.length) {
        validationDone(true);
      } else {
        that.$$q.all(validatorPromises).then(function() {
          validationDone(allValid);
        }, noop);
      }
    }

    function setValidity(name, isValid) {
      if (localValidationRunId === that.$$currentValidationRunId) {
        that.$setValidity(name, isValid);
      }
    }

    function validationDone(allValid) {
      if (localValidationRunId === that.$$currentValidationRunId) {

        doneCallback(allValid);
      }
    }
  },

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$commitViewValue
   *
   * @description
   * Commit a pending update to the `$modelValue`.
   *
   * Updates may be pending by a debounced event or because the input is waiting for a some future
   * event defined in `ng-model-options`. this method is rarely needed as `NgModelController`
   * usually handles calling this in response to input events.
   */
  $commitViewValue: function() {
    var viewValue = this.$viewValue;

    this.$$timeout.cancel(this.$$pendingDebounce);

    // If the view value has not changed then we should just exit, except in the case where there is
    // a native validator on the element. In this case the validation state may have changed even though
    // the viewValue has stayed empty.
    if (this.$$lastCommittedViewValue === viewValue && (viewValue !== '' || !this.$$hasNativeValidators)) {
      return;
    }
    this.$$updateEmptyClasses(viewValue);
    this.$$lastCommittedViewValue = viewValue;

    // change to dirty
    if (this.$pristine) {
      this.$setDirty();
    }
    this.$$parseAndValidate();
  },

  $$parseAndValidate: function() {
    var viewValue = this.$$lastCommittedViewValue;
    var modelValue = viewValue;
    var that = this;

    this.$$parserValid = isUndefined(modelValue) ? undefined : true;

    // Reset any previous parse error
    this.$setValidity(this.$$parserName, null);
    this.$$parserName = 'parse';

    if (this.$$parserValid) {
      for (var i = 0; i < this.$parsers.length; i++) {
        modelValue = this.$parsers[i](modelValue);
        if (isUndefined(modelValue)) {
          this.$$parserValid = false;
          break;
        }
      }
    }
    if (isNumberNaN(this.$modelValue)) {
      // this.$modelValue has not been touched yet...
      this.$modelValue = this.$$ngModelGet(this.$$scope);
    }
    var prevModelValue = this.$modelValue;
    var allowInvalid = this.$options.getOption('allowInvalid');
    this.$$rawModelValue = modelValue;

    if (allowInvalid) {
      this.$modelValue = modelValue;
      writeToModelIfNeeded();
    }

    // Pass the $$lastCommittedViewValue here, because the cached viewValue might be out of date.
    // This can happen if e.g. $setViewValue is called from inside a parser
    this.$$runValidators(modelValue, this.$$lastCommittedViewValue, function(allValid) {
      if (!allowInvalid) {
        // Note: Don't check this.$valid here, as we could have
        // external validators (e.g. calculated on the server),
        // that just call $setValidity and need the model value
        // to calculate their validity.
        that.$modelValue = allValid ? modelValue : undefined;
        writeToModelIfNeeded();
      }
    });

    function writeToModelIfNeeded() {
      if (that.$modelValue !== prevModelValue) {
        that.$$writeModelToScope();
      }
    }
  },

  $$writeModelToScope: function() {
    this.$$ngModelSet(this.$$scope, this.$modelValue);
    forEach(this.$viewChangeListeners, function(listener) {
      try {
        listener();
      } catch (e) {
        // eslint-disable-next-line no-invalid-this
        this.$$exceptionHandler(e);
      }
    }, this);
  },

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setViewValue
   *
   * @description
   * Update the view value.
   *
   * This method should be called when a control wants to change the view value; typically,
   * this is done from within a DOM event handler. For example, the {@link ng.directive:input input}
   * directive calls it when the value of the input changes and {@link ng.directive:select select}
   * calls it when an option is selected.
   *
   * When `$setViewValue` is called, the new `value` will be staged for committing through the `$parsers`
   * and `$validators` pipelines. If there are no special {@link ngModelOptions} specified then the staged
   * value is sent directly for processing through the `$parsers` pipeline. After this, the `$validators` and
   * `$asyncValidators` are called and the value is applied to `$modelValue`.
   * Finally, the value is set to the **expression** specified in the `ng-model` attribute and
   * all the registered change listeners, in the `$viewChangeListeners` list are called.
   *
   * In case the {@link ng.directive:ngModelOptions ngModelOptions} directive is used with `updateOn`
   * and the `default` trigger is not listed, all those actions will remain pending until one of the
   * `updateOn` events is triggered on the DOM element.
   * All these actions will be debounced if the {@link ng.directive:ngModelOptions ngModelOptions}
   * directive is used with a custom debounce for this particular event.
   * Note that a `$digest` is only triggered once the `updateOn` events are fired, or if `debounce`
   * is specified, once the timer runs out.
   *
   * When used with standard inputs, the view value will always be a string (which is in some cases
   * parsed into another type, such as a `Date` object for `input[date]`.)
   * However, custom controls might also pass objects to this method. In this case, we should make
   * a copy of the object before passing it to `$setViewValue`. This is because `ngModel` does not
   * perform a deep watch of objects, it only looks for a change of identity. If you only change
   * the property of the object then ngModel will not realize that the object has changed and
   * will not invoke the `$parsers` and `$validators` pipelines. For this reason, you should
   * not change properties of the copy once it has been passed to `$setViewValue`.
   * Otherwise you may cause the model value on the scope to change incorrectly.
   *
   * <div class="alert alert-info">
   * In any case, the value passed to the method should always reflect the current value
   * of the control. For example, if you are calling `$setViewValue` for an input element,
   * you should pass the input DOM value. Otherwise, the control and the scope model become
   * out of sync. It's also important to note that `$setViewValue` does not call `$render` or change
   * the control's DOM value in any way. If we want to change the control's DOM value
   * programmatically, we should update the `ngModel` scope expression. Its new value will be
   * picked up by the model controller, which will run it through the `$formatters`, `$render` it
   * to update the DOM, and finally call `$validate` on it.
   * </div>
   *
   * @param {*} value value from the view.
   * @param {string} trigger Event that triggered the update.
   */
  $setViewValue: function(value, trigger) {
    this.$viewValue = value;
    if (this.$options.getOption('updateOnDefault')) {
      this.$$debounceViewValueCommit(trigger);
    }
  },

  $$debounceViewValueCommit: function(trigger) {
    var debounceDelay = this.$options.getOption('debounce');

    if (isNumber(debounceDelay[trigger])) {
      debounceDelay = debounceDelay[trigger];
    } else if (isNumber(debounceDelay['default']) &&
      this.$options.getOption('updateOn').indexOf(trigger) === -1
    ) {
      debounceDelay = debounceDelay['default'];
    } else if (isNumber(debounceDelay['*'])) {
      debounceDelay = debounceDelay['*'];
    }

    this.$$timeout.cancel(this.$$pendingDebounce);
    var that = this;
    if (debounceDelay > 0) { // this fails if debounceDelay is an object
      this.$$pendingDebounce = this.$$timeout(function() {
        that.$commitViewValue();
      }, debounceDelay);
    } else if (this.$$rootScope.$$phase) {
      this.$commitViewValue();
    } else {
      this.$$scope.$apply(function() {
        that.$commitViewValue();
      });
    }
  },

  /**
   * @ngdoc method
   *
   * @name ngModel.NgModelController#$overrideModelOptions
   *
   * @description
   *
   * Override the current model options settings programmatically.
   *
   * The previous `ModelOptions` value will not be modified. Instead, a
   * new `ModelOptions` object will inherit from the previous one overriding
   * or inheriting settings that are defined in the given parameter.
   *
   * See {@link ngModelOptions} for information about what options can be specified
   * and how model option inheritance works.
   *
   * <div class="alert alert-warning">
   * **Note:** this function only affects the options set on the `ngModelController`,
   * and not the options on the {@link ngModelOptions} directive from which they might have been
   * obtained initially.
   * </div>
   *
   * <div class="alert alert-danger">
   * **Note:** it is not possible to override the `getterSetter` option.
   * </div>
   *
   * @param {Object} options a hash of settings to override the previous options
   *
   */
  $overrideModelOptions: function(options) {
    this.$options = this.$options.createChild(options);
    this.$$setUpdateOnEvents();
  },

  /**
   * @ngdoc method
   *
   * @name  ngModel.NgModelController#$processModelValue

   * @description
   *
   * Runs the model -> view pipeline on the current
   * {@link ngModel.NgModelController#$modelValue $modelValue}.
   *
   * The following actions are performed by this method:
   *
   * - the `$modelValue` is run through the {@link ngModel.NgModelController#$formatters $formatters}
   * and the result is set to the {@link ngModel.NgModelController#$viewValue $viewValue}
   * - the `ng-empty` or `ng-not-empty` class is set on the element
   * - if the `$viewValue` has changed:
   *   - {@link ngModel.NgModelController#$render $render} is called on the control
   *   - the {@link ngModel.NgModelController#$validators $validators} are run and
   *   the validation status is set.
   *
   * This method is called by ngModel internally when the bound scope value changes.
   * Application developers usually do not have to call this function themselves.
   *
   * This function can be used when the `$viewValue` or the rendered DOM value are not correctly
   * formatted and the `$modelValue` must be run through the `$formatters` again.
   *
   * @example
   * Consider a text input with an autocomplete list (for fruit), where the items are
   * objects with a name and an id.
   * A user enters `ap` and then selects `Apricot` from the list.
   * Based on this, the autocomplete widget will call `$setViewValue({name: 'Apricot', id: 443})`,
   * but the rendered value will still be `ap`.
   * The widget can then call `ctrl.$processModelValue()` to run the model -> view
   * pipeline again, which formats the object to the string `Apricot`,
   * then updates the `$viewValue`, and finally renders it in the DOM.
   *
   * <example module="inputExample" name="ng-model-process">
     <file name="index.html">
      <div ng-controller="inputController" style="display: flex;">
        <div style="margin-right: 30px;">
          Search Fruit:
          <basic-autocomplete items="items" on-select="selectedFruit = item"></basic-autocomplete>
        </div>
        <div>
          Model:<br>
          <pre>{{selectedFruit | json}}</pre>
        </div>
      </div>
     </file>
     <file name="app.js">
      angular.module('inputExample', [])
        .controller('inputController', function($scope) {
          $scope.items = [
            {name: 'Apricot', id: 443},
            {name: 'Clementine', id: 972},
            {name: 'Durian', id: 169},
            {name: 'Jackfruit', id: 982},
            {name: 'Strawberry', id: 863}
          ];
        })
        .component('basicAutocomplete', {
          bindings: {
            items: '<',
            onSelect: '&'
          },
          templateUrl: 'autocomplete.html',
          controller: function($element, $scope) {
            var that = this;
            var ngModel;

            that.$postLink = function() {
              ngModel = $element.find('input').controller('ngModel');

              ngModel.$formatters.push(function(value) {
                return (value && value.name) || value;
              });

              ngModel.$parsers.push(function(value) {
                var match = value;
                for (var i = 0; i < that.items.length; i++) {
                  if (that.items[i].name === value) {
                    match = that.items[i];
                    break;
                  }
                }

                return match;
              });
            };

            that.selectItem = function(item) {
              ngModel.$setViewValue(item);
              ngModel.$processModelValue();
              that.onSelect({item: item});
            };
          }
        });
     </file>
     <file name="autocomplete.html">
       <div>
         <input type="search" ng-model="$ctrl.searchTerm" />
         <ul>
           <li ng-repeat="item in $ctrl.items | filter:$ctrl.searchTerm">
             <button ng-click="$ctrl.selectItem(item)">{{ item.name }}</button>
           </li>
         </ul>
       </div>
     </file>
   * </example>
   *
   */
  $processModelValue: function() {
    var viewValue = this.$$format();

    if (this.$viewValue !== viewValue) {
      this.$$updateEmptyClasses(viewValue);
      this.$viewValue = this.$$lastCommittedViewValue = viewValue;
      this.$render();
      // It is possible that model and view value have been updated during render
      this.$$runValidators(this.$modelValue, this.$viewValue, noop);
    }
  },

  /**
   * This method is called internally to run the $formatters on the $modelValue
   */
  $$format: function() {
    var formatters = this.$formatters,
        idx = formatters.length;

    var viewValue = this.$modelValue;
    while (idx--) {
      viewValue = formatters[idx](viewValue);
    }

    return viewValue;
  },

  /**
   * This method is called internally when the bound scope value changes.
   */
  $$setModelValue: function(modelValue) {
    this.$modelValue = this.$$rawModelValue = modelValue;
    this.$$parserValid = undefined;
    this.$processModelValue();
  },

  $$setUpdateOnEvents: function() {
    if (this.$$updateEvents) {
      this.$$element.off(this.$$updateEvents, this.$$updateEventHandler);
    }

    this.$$updateEvents = this.$options.getOption('updateOn');
    if (this.$$updateEvents) {
      this.$$element.on(this.$$updateEvents, this.$$updateEventHandler);
    }
  },

  $$updateEventHandler: function(ev) {
    this.$$debounceViewValueCommit(ev && ev.type);
  }
};

function setupModelWatcher(ctrl) {
  // model -> value
  // Note: we cannot use a normal scope.$watch as we want to detect the following:
  // 1. scope value is 'a'
  // 2. user enters 'b'
  // 3. ng-change kicks in and reverts scope value to 'a'
  //    -> scope value did not change since the last digest as
  //       ng-change executes in apply phase
  // 4. view should be changed back to 'a'
  ctrl.$$scope.$watch(function ngModelWatch(scope) {
    var modelValue = ctrl.$$ngModelGet(scope);

    // if scope model value and ngModel value are out of sync
    // This cannot be moved to the action function, because it would not catch the
    // case where the model is changed in the ngChange function or the model setter
    if (modelValue !== ctrl.$modelValue &&
      // checks for NaN is needed to allow setting the model to NaN when there's an asyncValidator
      // eslint-disable-next-line no-self-compare
      (ctrl.$modelValue === ctrl.$modelValue || modelValue === modelValue)
    ) {
      ctrl.$$setModelValue(modelValue);
    }

    return modelValue;
  });
}

/**
 * @ngdoc method
 * @name ngModel.NgModelController#$setValidity
 *
 * @description
 * Change the validity state, and notify the form.
 *
 * This method can be called within $parsers/$formatters or a custom validation implementation.
 * However, in most cases it should be sufficient to use the `ngModel.$validators` and
 * `ngModel.$asyncValidators` collections which will call `$setValidity` automatically.
 *
 * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be assigned
 *        to either `$error[validationErrorKey]` or `$pending[validationErrorKey]`
 *        (for unfulfilled `$asyncValidators`), so that it is available for data-binding.
 *        The `validationErrorKey` should be in camelCase and will get converted into dash-case
 *        for class name. Example: `myError` will result in `ng-valid-my-error` and `ng-invalid-my-error`
 *        classes and can be bound to as `{{ someForm.someControl.$error.myError }}`.
 * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending (undefined),
 *                          or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
 *                          Skipped is used by AngularJS when validators do not run because of parse errors and
 *                          when `$asyncValidators` do not run because any of the `$validators` failed.
 */
addSetValidityMethod({
  clazz: NgModelController,
  set: function(object, property) {
    object[property] = true;
  },
  unset: function(object, property) {
    delete object[property];
  }
});


/**
 * @ngdoc directive
 * @name ngModel
 * @restrict A
 * @priority 1
 * @param {expression} ngModel assignable {@link guide/expression Expression} to bind to.
 *
 * @description
 * The `ngModel` directive binds an `input`,`select`, `textarea` (or custom form control) to a
 * property on the scope using {@link ngModel.NgModelController NgModelController},
 * which is created and exposed by this directive.
 *
 * `ngModel` is responsible for:
 *
 * - Binding the view into the model, which other directives such as `input`, `textarea` or `select`
 *   require.
 * - Providing validation behavior (i.e. required, number, email, url).
 * - Keeping the state of the control (valid/invalid, dirty/pristine, touched/untouched, validation errors).
 * - Setting related css classes on the element (`ng-valid`, `ng-invalid`, `ng-dirty`, `ng-pristine`, `ng-touched`,
 *   `ng-untouched`, `ng-empty`, `ng-not-empty`) including animations.
 * - Registering the control with its parent {@link ng.directive:form form}.
 *
 * Note: `ngModel` will try to bind to the property given by evaluating the expression on the
 * current scope. If the property doesn't already exist on this scope, it will be created
 * implicitly and added to the scope.
 *
 * For best practices on using `ngModel`, see:
 *
 *  - [Understanding Scopes](https://github.com/angular/angular.js/wiki/Understanding-Scopes)
 *
 * For basic examples, how to use `ngModel`, see:
 *
 *  - {@link ng.directive:input input}
 *    - {@link input[text] text}
 *    - {@link input[checkbox] checkbox}
 *    - {@link input[radio] radio}
 *    - {@link input[number] number}
 *    - {@link input[email] email}
 *    - {@link input[url] url}
 *    - {@link input[date] date}
 *    - {@link input[datetime-local] datetime-local}
 *    - {@link input[time] time}
 *    - {@link input[month] month}
 *    - {@link input[week] week}
 *  - {@link ng.directive:select select}
 *  - {@link ng.directive:textarea textarea}
 *
 * ## Complex Models (objects or collections)
 *
 * By default, `ngModel` watches the model by reference, not value. This is important to know when
 * binding inputs to models that are objects (e.g. `Date`) or collections (e.g. arrays). If only properties of the
 * object or collection change, `ngModel` will not be notified and so the input will not be  re-rendered.
 *
 * The model must be assigned an entirely new object or collection before a re-rendering will occur.
 *
 * Some directives have options that will cause them to use a custom `$watchCollection` on the model expression
 * - for example, `ngOptions` will do so when a `track by` clause is included in the comprehension expression or
 * if the select is given the `multiple` attribute.
 *
 * The `$watchCollection()` method only does a shallow comparison, meaning that changing properties deeper than the
 * first level of the object (or only changing the properties of an item in the collection if it's an array) will still
 * not trigger a re-rendering of the model.
 *
 * ## CSS classes
 * The following CSS classes are added and removed on the associated input/select/textarea element
 * depending on the validity of the model.
 *
 *  - `ng-valid`: the model is valid
 *  - `ng-invalid`: the model is invalid
 *  - `ng-valid-[key]`: for each valid key added by `$setValidity`
 *  - `ng-invalid-[key]`: for each invalid key added by `$setValidity`
 *  - `ng-pristine`: the control hasn't been interacted with yet
 *  - `ng-dirty`: the control has been interacted with
 *  - `ng-touched`: the control has been blurred
 *  - `ng-untouched`: the control hasn't been blurred
 *  - `ng-pending`: any `$asyncValidators` are unfulfilled
 *  - `ng-empty`: the view does not contain a value or the value is deemed "empty", as defined
 *     by the {@link ngModel.NgModelController#$isEmpty} method
 *  - `ng-not-empty`: the view contains a non-empty value
 *
 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
 *
 * @animations
 * Animations within models are triggered when any of the associated CSS classes are added and removed
 * on the input element which is attached to the model. These classes include: `.ng-pristine`, `.ng-dirty`,
 * `.ng-invalid` and `.ng-valid` as well as any other validations that are performed on the model itself.
 * The animations that are triggered within ngModel are similar to how they work in ngClass and
 * animations can be hooked into using CSS transitions, keyframes as well as JS animations.
 *
 * The following example shows a simple way to utilize CSS transitions to style an input element
 * that has been rendered as invalid after it has been validated:
 *
 * <pre>
 * //be sure to include ngAnimate as a module to hook into more
 * //advanced animations
 * .my-input {
 *   transition:0.5s linear all;
 *   background: white;
 * }
 * .my-input.ng-invalid {
 *   background: red;
 *   color:white;
 * }
 * </pre>
 *
 * @example
 * ### Basic Usage
 * <example deps="angular-animate.js" animations="true" fixBase="true" module="inputExample" name="ng-model">
     <file name="index.html">
       <script>
        angular.module('inputExample', [])
          .controller('ExampleController', ['$scope', function($scope) {
            $scope.val = '1';
          }]);
       </script>
       <style>
         .my-input {
           transition:all linear 0.5s;
           background: transparent;
         }
         .my-input.ng-invalid {
           color:white;
           background: red;
         }
       </style>
       <p id="inputDescription">
        Update input to see transitions when valid/invalid.
        Integer is a valid value.
       </p>
       <form name="testForm" ng-controller="ExampleController">
         <input ng-model="val" ng-pattern="/^\d+$/" name="anim" class="my-input"
                aria-describedby="inputDescription" />
       </form>
     </file>
 * </example>
 *
 * @example
 * ### Binding to a getter/setter
 *
 * Sometimes it's helpful to bind `ngModel` to a getter/setter function.  A getter/setter is a
 * function that returns a representation of the model when called with zero arguments, and sets
 * the internal state of a model when called with an argument. It's sometimes useful to use this
 * for models that have an internal representation that's different from what the model exposes
 * to the view.
 *
 * <div class="alert alert-success">
 * **Best Practice:** It's best to keep getters fast because AngularJS is likely to call them more
 * frequently than other parts of your code.
 * </div>
 *
 * You use this behavior by adding `ng-model-options="{ getterSetter: true }"` to an element that
 * has `ng-model` attached to it. You can also add `ng-model-options="{ getterSetter: true }"` to
 * a `<form>`, which will enable this behavior for all `<input>`s within it. See
 * {@link ng.directive:ngModelOptions `ngModelOptions`} for more.
 *
 * The following example shows how to use `ngModel` with a getter/setter:
 *
 * @example
 * <example name="ngModel-getter-setter" module="getterSetterExample">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <form name="userForm">
           <label>Name:
             <input type="text" name="userName"
                    ng-model="user.name"
                    ng-model-options="{ getterSetter: true }" />
           </label>
         </form>
         <pre>user.name = <span ng-bind="user.name()"></span></pre>
       </div>
     </file>
     <file name="app.js">
       angular.module('getterSetterExample', [])
         .controller('ExampleController', ['$scope', function($scope) {
           var _name = 'Brian';
           $scope.user = {
             name: function(newName) {
              // Note that newName can be undefined for two reasons:
              // 1. Because it is called as a getter and thus called with no arguments
              // 2. Because the property should actually be set to undefined. This happens e.g. if the
              //    input is invalid
              return arguments.length ? (_name = newName) : _name;
             }
           };
         }]);
     </file>
 * </example>
 */
var ngModelDirective = ['$rootScope', function($rootScope) {
  return {
    restrict: 'A',
    require: ['ngModel', '^?form', '^?ngModelOptions'],
    controller: NgModelController,
    // Prelink needs to run before any input directive
    // so that we can set the NgModelOptions in NgModelController
    // before anyone else uses it.
    priority: 1,
    compile: function ngModelCompile(element) {
      // Setup initial state of the control
      element.addClass(PRISTINE_CLASS).addClass(UNTOUCHED_CLASS).addClass(VALID_CLASS);

      return {
        pre: function ngModelPreLink(scope, element, attr, ctrls) {
          var modelCtrl = ctrls[0],
              formCtrl = ctrls[1] || modelCtrl.$$parentForm,
              optionsCtrl = ctrls[2];

          if (optionsCtrl) {
            modelCtrl.$options = optionsCtrl.$options;
          }

          modelCtrl.$$initGetterSetters();

          // notify others, especially parent forms
          formCtrl.$addControl(modelCtrl);

          attr.$observe('name', function(newValue) {
            if (modelCtrl.$name !== newValue) {
              modelCtrl.$$parentForm.$$renameControl(modelCtrl, newValue);
            }
          });

          scope.$on('$destroy', function() {
            modelCtrl.$$parentForm.$removeControl(modelCtrl);
          });
        },
        post: function ngModelPostLink(scope, element, attr, ctrls) {
          var modelCtrl = ctrls[0];
          modelCtrl.$$setUpdateOnEvents();

          function setTouched() {
            modelCtrl.$setTouched();
          }

          element.on('blur', function() {
            if (modelCtrl.$touched) return;

            if ($rootScope.$$phase) {
              scope.$evalAsync(setTouched);
            } else {
              scope.$apply(setTouched);
            }
          });
        }
      };
    }
  };
}];

/* exported defaultModelOptions */
var defaultModelOptions;
var DEFAULT_REGEXP = /(\s+|^)default(\s+|$)/;

/**
 * @ngdoc type
 * @name ModelOptions
 * @description
 * A container for the options set by the {@link ngModelOptions} directive
 */
function ModelOptions(options) {
  this.$$options = options;
}

ModelOptions.prototype = {

  /**
   * @ngdoc method
   * @name ModelOptions#getOption
   * @param {string} name the name of the option to retrieve
   * @returns {*} the value of the option
   * @description
   * Returns the value of the given option
   */
  getOption: function(name) {
    return this.$$options[name];
  },

  /**
   * @ngdoc method
   * @name ModelOptions#createChild
   * @param {Object} options a hash of options for the new child that will override the parent's options
   * @return {ModelOptions} a new `ModelOptions` object initialized with the given options.
   */
  createChild: function(options) {
    var inheritAll = false;

    // make a shallow copy
    options = extend({}, options);

    // Inherit options from the parent if specified by the value `"$inherit"`
    forEach(options, /** @this */ function(option, key) {
      if (option === '$inherit') {
        if (key === '*') {
          inheritAll = true;
        } else {
          options[key] = this.$$options[key];
          // `updateOn` is special so we must also inherit the `updateOnDefault` option
          if (key === 'updateOn') {
            options.updateOnDefault = this.$$options.updateOnDefault;
          }
        }
      } else {
        if (key === 'updateOn') {
          // If the `updateOn` property contains the `default` event then we have to remove
          // it from the event list and set the `updateOnDefault` flag.
          options.updateOnDefault = false;
          options[key] = trim(option.replace(DEFAULT_REGEXP, function() {
            options.updateOnDefault = true;
            return ' ';
          }));
        }
      }
    }, this);

    if (inheritAll) {
      // We have a property of the form: `"*": "$inherit"`
      delete options['*'];
      defaults(options, this.$$options);
    }

    // Finally add in any missing defaults
    defaults(options, defaultModelOptions.$$options);

    return new ModelOptions(options);
  }
};


defaultModelOptions = new ModelOptions({
  updateOn: '',
  updateOnDefault: true,
  debounce: 0,
  getterSetter: false,
  allowInvalid: false,
  timezone: null
});


/**
 * @ngdoc directive
 * @name ngModelOptions
 * @restrict A
 * @priority 10
 *
 * @description
 * This directive allows you to modify the behaviour of {@link ngModel} directives within your
 * application. You can specify an `ngModelOptions` directive on any element. All {@link ngModel}
 * directives will use the options of their nearest `ngModelOptions` ancestor.
 *
 * The `ngModelOptions` settings are found by evaluating the value of the attribute directive as
 * an AngularJS expression. This expression should evaluate to an object, whose properties contain
 * the settings. For example: `<div ng-model-options="{ debounce: 100 }"`.
 *
 * ## Inheriting Options
 *
 * You can specify that an `ngModelOptions` setting should be inherited from a parent `ngModelOptions`
 * directive by giving it the value of `"$inherit"`.
 * Then it will inherit that setting from the first `ngModelOptions` directive found by traversing up the
 * DOM tree. If there is no ancestor element containing an `ngModelOptions` directive then default settings
 * will be used.
 *
 * For example given the following fragment of HTML
 *
 *
 * ```html
 * <div ng-model-options="{ allowInvalid: true, debounce: 200 }">
 *   <form ng-model-options="{ updateOn: 'blur', allowInvalid: '$inherit' }">
 *     <input ng-model-options="{ updateOn: 'default', allowInvalid: '$inherit' }" />
 *   </form>
 * </div>
 * ```
 *
 * the `input` element will have the following settings
 *
 * ```js
 * { allowInvalid: true, updateOn: 'default', debounce: 0 }
 * ```
 *
 * Notice that the `debounce` setting was not inherited and used the default value instead.
 *
 * You can specify that all undefined settings are automatically inherited from an ancestor by
 * including a property with key of `"*"` and value of `"$inherit"`.
 *
 * For example given the following fragment of HTML
 *
 *
 * ```html
 * <div ng-model-options="{ allowInvalid: true, debounce: 200 }">
 *   <form ng-model-options="{ updateOn: 'blur', "*": '$inherit' }">
 *     <input ng-model-options="{ updateOn: 'default', "*": '$inherit' }" />
 *   </form>
 * </div>
 * ```
 *
 * the `input` element will have the following settings
 *
 * ```js
 * { allowInvalid: true, updateOn: 'default', debounce: 200 }
 * ```
 *
 * Notice that the `debounce` setting now inherits the value from the outer `<div>` element.
 *
 * If you are creating a reusable component then you should be careful when using `"*": "$inherit"`
 * since you may inadvertently inherit a setting in the future that changes the behavior of your component.
 *
 *
 * ## Triggering and debouncing model updates
 *
 * The `updateOn` and `debounce` properties allow you to specify a custom list of events that will
 * trigger a model update and/or a debouncing delay so that the actual update only takes place when
 * a timer expires; this timer will be reset after another change takes place.
 *
 * Given the nature of `ngModelOptions`, the value displayed inside input fields in the view might
 * be different from the value in the actual model. This means that if you update the model you
 * should also invoke {@link ngModel.NgModelController#$rollbackViewValue} on the relevant input field in
 * order to make sure it is synchronized with the model and that any debounced action is canceled.
 *
 * The easiest way to reference the control's {@link ngModel.NgModelController#$rollbackViewValue}
 * method is by making sure the input is placed inside a form that has a `name` attribute. This is
 * important because `form` controllers are published to the related scope under the name in their
 * `name` attribute.
 *
 * Any pending changes will take place immediately when an enclosing form is submitted via the
 * `submit` event. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
 * to have access to the updated model.
 *
 * ### Overriding immediate updates
 *
 * The following example shows how to override immediate updates. Changes on the inputs within the
 * form will update the model only when the control loses focus (blur event). If `escape` key is
 * pressed while the input field is focused, the value is reset to the value in the current model.
 *
 * <example name="ngModelOptions-directive-blur" module="optionsExample">
 *   <file name="index.html">
 *     <div ng-controller="ExampleController">
 *       <form name="userForm">
 *         <label>
 *           Name:
 *           <input type="text" name="userName"
 *                  ng-model="user.name"
 *                  ng-model-options="{ updateOn: 'blur' }"
 *                  ng-keyup="cancel($event)" />
 *         </label><br />
 *         <label>
 *           Other data:
 *           <input type="text" ng-model="user.data" />
 *         </label><br />
 *       </form>
 *       <pre>user.name = <span ng-bind="user.name"></span></pre>
 *     </div>
 *   </file>
 *   <file name="app.js">
 *     angular.module('optionsExample', [])
 *       .controller('ExampleController', ['$scope', function($scope) {
 *         $scope.user = { name: 'say', data: '' };
 *
 *         $scope.cancel = function(e) {
 *           if (e.keyCode === 27) {
 *             $scope.userForm.userName.$rollbackViewValue();
 *           }
 *         };
 *       }]);
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     var model = element(by.binding('user.name'));
 *     var input = element(by.model('user.name'));
 *     var other = element(by.model('user.data'));
 *
 *     it('should allow custom events', function() {
 *       input.sendKeys(' hello');
 *       input.click();
 *       expect(model.getText()).toEqual('say');
 *       other.click();
 *       expect(model.getText()).toEqual('say hello');
 *     });
 *
 *     it('should $rollbackViewValue when model changes', function() {
 *       input.sendKeys(' hello');
 *       expect(input.getAttribute('value')).toEqual('say hello');
 *       input.sendKeys(protractor.Key.ESCAPE);
 *       expect(input.getAttribute('value')).toEqual('say');
 *       other.click();
 *       expect(model.getText()).toEqual('say');
 *     });
 *   </file>
 * </example>
 *
 * ### Debouncing updates
 *
 * The next example shows how to debounce model changes. Model will be updated only 1 sec after last change.
 * If the `Clear` button is pressed, any debounced action is canceled and the value becomes empty.
 *
 * <example name="ngModelOptions-directive-debounce" module="optionsExample">
 *   <file name="index.html">
 *     <div ng-controller="ExampleController">
 *       <form name="userForm">
 *         Name:
 *         <input type="text" name="userName"
 *                ng-model="user.name"
 *                ng-model-options="{ debounce: 1000 }" />
 *         <button ng-click="userForm.userName.$rollbackViewValue(); user.name=''">Clear</button><br />
 *       </form>
 *       <pre>user.name = <span ng-bind="user.name"></span></pre>
 *     </div>
 *   </file>
 *   <file name="app.js">
 *     angular.module('optionsExample', [])
 *       .controller('ExampleController', ['$scope', function($scope) {
 *         $scope.user = { name: 'say' };
 *       }]);
 *   </file>
 * </example>
 *
 * ### Default events, extra triggers, and catch-all debounce values
 *
 * This example shows the relationship between "default" update events and
 * additional `updateOn` triggers.
 *
 * `default` events are those that are bound to the control, and when fired, update the `$viewValue`
 * via {@link ngModel.NgModelController#$setViewValue $setViewValue}. Every event that is not listed
 * in `updateOn` is considered a "default" event, since different control types have different
 * default events.
 *
 * The control in this example updates by "default", "click", and "blur", with different `debounce`
 * values. You can see that "click" doesn't have an individual `debounce` value -
 * therefore it uses the `*` debounce value.
 *
 * There is also a button that calls {@link ngModel.NgModelController#$setViewValue $setViewValue}
 * directly with a "custom" event. Since "custom" is not defined in the `updateOn` list,
 * it is considered a "default" event and will update the
 * control if "default" is defined in `updateOn`, and will receive the "default" debounce value.
 * Note that this is just to illustrate how custom controls would possibly call `$setViewValue`.
 *
 * You can change the `updateOn` and `debounce` configuration to test different scenarios. This
 * is done with {@link ngModel.NgModelController#$overrideModelOptions $overrideModelOptions}.
 *
  <example name="ngModelOptions-advanced" module="optionsExample">
    <file name="index.html">
       <model-update-demo></model-update-demo>
    </file>
    <file name="app.js">
      angular.module('optionsExample', [])
        .component('modelUpdateDemo', {
          templateUrl: 'template.html',
          controller: function() {
            this.name = 'Chinua';

            this.options = {
              updateOn: 'default blur click',
              debounce: {
                default: 2000,
                blur: 0,
                '*': 1000
              }
            };

            this.updateEvents = function() {
              var eventList = this.options.updateOn.split(' ');
              eventList.push('*');
              var events = {};

              for (var i = 0; i < eventList.length; i++) {
                events[eventList[i]] = this.options.debounce[eventList[i]];
              }

              this.events = events;
            };

            this.updateOptions = function() {
              var options = angular.extend(this.options, {
                updateOn: Object.keys(this.events).join(' ').replace('*', ''),
                debounce: this.events
              });

              this.form.input.$overrideModelOptions(options);
            };

            // Initialize the event form
            this.updateEvents();
          }
        });
    </file>
    <file name="template.html">
      <form name="$ctrl.form">
        Input: <input type="text" name="input" ng-model="$ctrl.name" ng-model-options="$ctrl.options" />
      </form>
      Model: <tt>{{$ctrl.name}}</tt>
      <hr>
      <button ng-click="$ctrl.form.input.$setViewValue('some value', 'custom')">Trigger setViewValue with 'some value' and 'custom' event</button>

      <hr>
      <form ng-submit="$ctrl.updateOptions()">
        <b>updateOn</b><br>
        <input type="text" ng-model="$ctrl.options.updateOn" ng-change="$ctrl.updateEvents()" ng-model-options="{debounce: 500}">

        <table>
          <tr>
            <th>Option</th>
            <th>Debounce value</th>
          </tr>
          <tr ng-repeat="(key, value) in $ctrl.events">
            <td>{{key}}</td>
            <td><input type="number" ng-model="$ctrl.events[key]" /></td>
          </tr>
        </table>

        <br>
        <input type="submit" value="Update options">
      </form>
    </file>
  </example>
 *
 *
 * ## Model updates and validation
 *
 * The default behaviour in `ngModel` is that the model value is set to `undefined` when the
 * validation determines that the value is invalid. By setting the `allowInvalid` property to true,
 * the model will still be updated even if the value is invalid.
 *
 *
 * ## Connecting to the scope
 *
 * By setting the `getterSetter` property to true you are telling ngModel that the `ngModel` expression
 * on the scope refers to a "getter/setter" function rather than the value itself.
 *
 * The following example shows how to bind to getter/setters:
 *
 * <example name="ngModelOptions-directive-getter-setter" module="getterSetterExample">
 *   <file name="index.html">
 *     <div ng-controller="ExampleController">
 *       <form name="userForm">
 *         <label>
 *           Name:
 *           <input type="text" name="userName"
 *                  ng-model="user.name"
 *                  ng-model-options="{ getterSetter: true }" />
 *         </label>
 *       </form>
 *       <pre>user.name = <span ng-bind="user.name()"></span></pre>
 *     </div>
 *   </file>
 *   <file name="app.js">
 *     angular.module('getterSetterExample', [])
 *       .controller('ExampleController', ['$scope', function($scope) {
 *         var _name = 'Brian';
 *         $scope.user = {
 *           name: function(newName) {
 *             return angular.isDefined(newName) ? (_name = newName) : _name;
 *           }
 *         };
 *       }]);
 *   </file>
 * </example>
 *
 *
 * ## Programmatically changing options
 *
 * The `ngModelOptions` expression is only evaluated once when the directive is linked; it is not
 * watched for changes. However, it is possible to override the options on a single
 * {@link ngModel.NgModelController} instance with
 * {@link ngModel.NgModelController#$overrideModelOptions `NgModelController#$overrideModelOptions()`}.
 * See also the example for
 * {@link ngModelOptions#default-events-extra-triggers-and-catch-all-debounce-values
 * Default events, extra triggers, and catch-all debounce values}.
 *
 *
 * ## Specifying timezones
 *
 * You can specify the timezone that date/time input directives expect by providing its name in the
 * `timezone` property.
 *
 *
 * ## Formatting the value of `time` and `datetime-local`
 *
 * With the options `timeSecondsFormat` and `timeStripZeroSeconds` it is possible to adjust the value
 * that is displayed in the control. Note that browsers may apply their own formatting
 * in the user interface.
 *
   <example name="ngModelOptions-time-format" module="timeExample">
     <file name="index.html">
       <time-example></time-example>
     </file>
     <file name="script.js">
        angular.module('timeExample', [])
          .component('timeExample', {
            templateUrl: 'timeExample.html',
            controller: function() {
              this.time = new Date(1970, 0, 1, 14, 57, 0);

              this.options = {
                timeSecondsFormat: 'ss',
                timeStripZeroSeconds: true
              };

              this.optionChange = function() {
                this.timeForm.timeFormatted.$overrideModelOptions(this.options);
                this.time = new Date(this.time);
              };
            }
          });
     </file>
     <file name="timeExample.html">
       <form name="$ctrl.timeForm">
         <strong>Default</strong>:
         <input type="time" ng-model="$ctrl.time" step="any" /><br>
         <strong>With options</strong>:
         <input type="time" name="timeFormatted" ng-model="$ctrl.time" step="any" ng-model-options="$ctrl.options" />
         <br>

         Options:<br>
         <code>timeSecondsFormat</code>:
         <input
           type="text"
           ng-model="$ctrl.options.timeSecondsFormat"
           ng-change="$ctrl.optionChange()">
         <br>
         <code>timeStripZeroSeconds</code>:
         <input
           type="checkbox"
           ng-model="$ctrl.options.timeStripZeroSeconds"
           ng-change="$ctrl.optionChange()">
        </form>
      </file>
 *  </example>
 *
 * @param {Object} ngModelOptions options to apply to {@link ngModel} directives on this element and
 *   and its descendents.
 *
 * **General options**:
 *
 *   - `updateOn`: string specifying which event should the input be bound to. You can set several
 *     events using an space delimited list. There is a special event called `default` that
 *     matches the default events belonging to the control. These are the events that are bound to
 *     the control, and when fired, update the `$viewValue` via `$setViewValue`.
 *
 *     `ngModelOptions` considers every event that is not listed in `updateOn` a "default" event,
 *     since different control types use different default events.
 *
 *     See also the section {@link ngModelOptions#triggering-and-debouncing-model-updates
 *     Triggering and debouncing model updates}.
 *
 *   - `debounce`: integer value which contains the debounce model update value in milliseconds. A
 *     value of 0 triggers an immediate update. If an object is supplied instead, you can specify a
 *     custom value for each event. For example:
 *     ```
 *     ng-model-options="{
 *       updateOn: 'default blur',
 *       debounce: { 'default': 500, 'blur': 0 }
 *     }"
 *     ```
 *     You can use the `*` key to specify a debounce value that applies to all events that are not
 *     specifically listed. In the following example, `mouseup` would have a debounce delay of 1000:
 *     ```
 *     ng-model-options="{
 *       updateOn: 'default blur mouseup',
 *       debounce: { 'default': 500, 'blur': 0, '*': 1000 }
 *     }"
 *     ```
 *   - `allowInvalid`: boolean value which indicates that the model can be set with values that did
 *     not validate correctly instead of the default behavior of setting the model to undefined.
 *   - `getterSetter`: boolean value which determines whether or not to treat functions bound to
 *     `ngModel` as getters/setters.
 *
 *
 *  **Input-type specific options**:
 *
 *   - `timezone`: Defines the timezone to be used to read/write the `Date` instance in the model for
 *     `<input type="date" />`, `<input type="time" />`, ... . It understands UTC/GMT and the
 *     continental US time zone abbreviations, but for general use, use a time zone offset, for
 *     example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
 *     If not specified, the timezone of the browser will be used.
 *     Note that changing the timezone will have no effect on the current date, and is only applied after
 *     the next input / model change.
 *
 *   - `timeSecondsFormat`: Defines if the `time` and `datetime-local` types should show seconds and
 *     milliseconds. The option follows the format string of {@link date date filter}.
 *     By default, the options is `undefined` which is equal to `'ss.sss'` (seconds and milliseconds).
 *     The other options are `'ss'` (strips milliseconds), and `''` (empty string), which strips both
 *     seconds and milliseconds.
 *     Note that browsers that support `time` and `datetime-local` require the hour and minutes
 *     part of the time string, and may show the value differently in the user interface.
 *     {@link ngModelOptions#formatting-the-value-of-time-and-datetime-local- See the example}.
 *
 *   - `timeStripZeroSeconds`: Defines if the `time` and `datetime-local` types should strip the
 *     seconds and milliseconds from the formatted value if they are zero. This option is applied
 *     after `timeSecondsFormat`.
 *     This option can be used to make the formatting consistent over different browsers, as some
 *     browsers with support for `time` will natively hide the milliseconds and
 *     seconds if they are zero, but others won't, and browsers that don't implement these input
 *     types will always show the full string.
 *     {@link ngModelOptions#formatting-the-value-of-time-and-datetime-local- See the example}.
 *
 */
var ngModelOptionsDirective = function() {
  NgModelOptionsController.$inject = ['$attrs', '$scope'];
  function NgModelOptionsController($attrs, $scope) {
    this.$$attrs = $attrs;
    this.$$scope = $scope;
  }
  NgModelOptionsController.prototype = {
    $onInit: function() {
      var parentOptions = this.parentCtrl ? this.parentCtrl.$options : defaultModelOptions;
      var modelOptionsDefinition = this.$$scope.$eval(this.$$attrs.ngModelOptions);

      this.$options = parentOptions.createChild(modelOptionsDefinition);
    }
  };

  return {
    restrict: 'A',
    // ngModelOptions needs to run before ngModel and input directives
    priority: 10,
    require: {parentCtrl: '?^^ngModelOptions'},
    bindToController: true,
    controller: NgModelOptionsController
  };
};


// shallow copy over values from `src` that are not already specified on `dst`
function defaults(dst, src) {
  forEach(src, function(value, key) {
    if (!isDefined(dst[key])) {
      dst[key] = value;
    }
  });
}

/**
 * @ngdoc directive
 * @name ngNonBindable
 * @restrict AC
 * @priority 1000
 * @element ANY
 *
 * @description
 * The `ngNonBindable` directive tells AngularJS not to compile or bind the contents of the current
 * DOM element, including directives on the element itself that have a lower priority than
 * `ngNonBindable`. This is useful if the element contains what appears to be AngularJS directives
 * and bindings but which should be ignored by AngularJS. This could be the case if you have a site
 * that displays snippets of code, for instance.
 *
 * @example
 * In this example there are two locations where a simple interpolation binding (`{{}}`) is present,
 * but the one wrapped in `ngNonBindable` is left alone.
 *
  <example name="ng-non-bindable">
    <file name="index.html">
      <div>Normal: {{1 + 2}}</div>
      <div ng-non-bindable>Ignored: {{1 + 2}}</div>
    </file>
    <file name="protractor.js" type="protractor">
     it('should check ng-non-bindable', function() {
       expect(element(by.binding('1 + 2')).getText()).toContain('3');
       expect(element.all(by.css('div')).last().getText()).toMatch(/1 \+ 2/);
     });
    </file>
  </example>
 */
var ngNonBindableDirective = ngDirective({ terminal: true, priority: 1000 });

/* exported ngOptionsDirective */

/* global jqLiteRemove */

var ngOptionsMinErr = minErr('ngOptions');

/**
 * @ngdoc directive
 * @name ngOptions
 * @restrict A
 *
 * @description
 *
 * The `ngOptions` attribute can be used to dynamically generate a list of `<option>`
 * elements for the `<select>` element using the array or object obtained by evaluating the
 * `ngOptions` comprehension expression.
 *
 * In many cases, {@link ng.directive:ngRepeat ngRepeat} can be used on `<option>` elements instead of
 * `ngOptions` to achieve a similar result. However, `ngOptions` provides some benefits:
 * - more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
 * comprehension expression
 * - reduced memory consumption by not creating a new scope for each repeated instance
 * - increased render speed by creating the options in a documentFragment instead of individually
 *
 * When an item in the `<select>` menu is selected, the array element or object property
 * represented by the selected option will be bound to the model identified by the `ngModel`
 * directive.
 *
 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
 * option. See example below for demonstration.
 *
 * ## Complex Models (objects or collections)
 *
 * By default, `ngModel` watches the model by reference, not value. This is important to know when
 * binding the select to a model that is an object or a collection.
 *
 * One issue occurs if you want to preselect an option. For example, if you set
 * the model to an object that is equal to an object in your collection, `ngOptions` won't be able to set the selection,
 * because the objects are not identical. So by default, you should always reference the item in your collection
 * for preselections, e.g.: `$scope.selected = $scope.collection[3]`.
 *
 * Another solution is to use a `track by` clause, because then `ngOptions` will track the identity
 * of the item not by reference, but by the result of the `track by` expression. For example, if your
 * collection items have an id property, you would `track by item.id`.
 *
 * A different issue with objects or collections is that ngModel won't detect if an object property or
 * a collection item changes. For that reason, `ngOptions` additionally watches the model using
 * `$watchCollection`, when the expression contains a `track by` clause or the the select has the `multiple` attribute.
 * This allows ngOptions to trigger a re-rendering of the options even if the actual object/collection
 * has not changed identity, but only a property on the object or an item in the collection changes.
 *
 * Note that `$watchCollection` does a shallow comparison of the properties of the object (or the items in the collection
 * if the model is an array). This means that changing a property deeper than the first level inside the
 * object/collection will not trigger a re-rendering.
 *
 * ## `select` **`as`**
 *
 * Using `select` **`as`** will bind the result of the `select` expression to the model, but
 * the value of the `<select>` and `<option>` html elements will be either the index (for array data sources)
 * or property name (for object data sources) of the value within the collection. If a **`track by`** expression
 * is used, the result of that expression will be set as the value of the `option` and `select` elements.
 *
 *
 * ### `select` **`as`** and **`track by`**
 *
 * <div class="alert alert-warning">
 * Be careful when using `select` **`as`** and **`track by`** in the same expression.
 * </div>
 *
 * Given this array of items on the $scope:
 *
 * ```js
 * $scope.items = [{
 *   id: 1,
 *   label: 'aLabel',
 *   subItem: { name: 'aSubItem' }
 * }, {
 *   id: 2,
 *   label: 'bLabel',
 *   subItem: { name: 'bSubItem' }
 * }];
 * ```
 *
 * This will work:
 *
 * ```html
 * <select ng-options="item as item.label for item in items track by item.id" ng-model="selected"></select>
 * ```
 * ```js
 * $scope.selected = $scope.items[0];
 * ```
 *
 * but this will not work:
 *
 * ```html
 * <select ng-options="item.subItem as item.label for item in items track by item.id" ng-model="selected"></select>
 * ```
 * ```js
 * $scope.selected = $scope.items[0].subItem;
 * ```
 *
 * In both examples, the **`track by`** expression is applied successfully to each `item` in the
 * `items` array. Because the selected option has been set programmatically in the controller, the
 * **`track by`** expression is also applied to the `ngModel` value. In the first example, the
 * `ngModel` value is `items[0]` and the **`track by`** expression evaluates to `items[0].id` with
 * no issue. In the second example, the `ngModel` value is `items[0].subItem` and the **`track by`**
 * expression evaluates to `items[0].subItem.id` (which is undefined). As a result, the model value
 * is not matched against any `<option>` and the `<select>` appears as having no selected value.
 *
 *
 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
 * @param {comprehension_expression} ngOptions in one of the following forms:
 *
 *   * for array data sources:
 *     * `label` **`for`** `value` **`in`** `array`
 *     * `select` **`as`** `label` **`for`** `value` **`in`** `array`
 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array`
 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array`
 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
 *     * `label` **`for`** `value` **`in`** `array` | orderBy:`orderexpr` **`track by`** `trackexpr`
 *        (for including a filter with `track by`)
 *   * for object data sources:
 *     * `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
 *     * `select` **`as`** `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
 *     * `label` **`group by`** `group` **`for (`**`key`**`,`** `value`**`) in`** `object`
 *     * `label` **`disable when`** `disable` **`for (`**`key`**`,`** `value`**`) in`** `object`
 *     * `select` **`as`** `label` **`group by`** `group`
 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
 *     * `select` **`as`** `label` **`disable when`** `disable`
 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
 *
 * Where:
 *
 *   * `array` / `object`: an expression which evaluates to an array / object to iterate over.
 *   * `value`: local variable which will refer to each item in the `array` or each property value
 *      of `object` during iteration.
 *   * `key`: local variable which will refer to a property name in `object` during iteration.
 *   * `label`: The result of this expression will be the label for `<option>` element. The
 *     `expression` will most likely refer to the `value` variable (e.g. `value.propertyName`).
 *   * `select`: The result of this expression will be bound to the model of the parent `<select>`
 *      element. If not specified, `select` expression will default to `value`.
 *   * `group`: The result of this expression will be used to group options using the `<optgroup>`
 *      DOM element.
 *   * `disable`: The result of this expression will be used to disable the rendered `<option>`
 *      element. Return `true` to disable.
 *   * `trackexpr`: Used when working with an array of objects. The result of this expression will be
 *      used to identify the objects in the array. The `trackexpr` will most likely refer to the
 *     `value` variable (e.g. `value.propertyName`). With this the selection is preserved
 *      even when the options are recreated (e.g. reloaded from the server).
 * @param {string=} name Property name of the form under which the control is published.
 * @param {string=} required The control is considered valid only if value is entered.
 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
 *    `required` when you want to data-bind to the `required` attribute.
 * @param {string=} ngAttrSize sets the size of the select element dynamically. Uses the
 * {@link guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes ngAttr} directive.
 *
 * @example
    <example module="selectExample" name="select">
      <file name="index.html">
        <script>
        angular.module('selectExample', [])
          .controller('ExampleController', ['$scope', function($scope) {
            $scope.colors = [
              {name:'black', shade:'dark'},
              {name:'white', shade:'light', notAnOption: true},
              {name:'red', shade:'dark'},
              {name:'blue', shade:'dark', notAnOption: true},
              {name:'yellow', shade:'light', notAnOption: false}
            ];
            $scope.myColor = $scope.colors[2]; // red
          }]);
        </script>
        <div ng-controller="ExampleController">
          <ul>
            <li ng-repeat="color in colors">
              <label>Name: <input ng-model="color.name"></label>
              <label><input type="checkbox" ng-model="color.notAnOption"> Disabled?</label>
              <button ng-click="colors.splice($index, 1)" aria-label="Remove">X</button>
            </li>
            <li>
              <button ng-click="colors.push({})">add</button>
            </li>
          </ul>
          <hr/>
          <label>Color (null not allowed):
            <select ng-model="myColor" ng-options="color.name for color in colors"></select>
          </label><br/>
          <label>Color (null allowed):
          <span  class="nullable">
            <select ng-model="myColor" ng-options="color.name for color in colors">
              <option value="">-- choose color --</option>
            </select>
          </span></label><br/>

          <label>Color grouped by shade:
            <select ng-model="myColor" ng-options="color.name group by color.shade for color in colors">
            </select>
          </label><br/>

          <label>Color grouped by shade, with some disabled:
            <select ng-model="myColor"
                  ng-options="color.name group by color.shade disable when color.notAnOption for color in colors">
            </select>
          </label><br/>



          Select <button ng-click="myColor = { name:'not in list', shade: 'other' }">bogus</button>.
          <br/>
          <hr/>
          Currently selected: {{ {selected_color:myColor} }}
          <div style="border:solid 1px black; height:20px"
               ng-style="{'background-color':myColor.name}">
          </div>
        </div>
      </file>
      <file name="protractor.js" type="protractor">
         it('should check ng-options', function() {
           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('red');
           element.all(by.model('myColor')).first().click();
           element.all(by.css('select[ng-model="myColor"] option')).first().click();
           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('black');
           element(by.css('.nullable select[ng-model="myColor"]')).click();
           element.all(by.css('.nullable select[ng-model="myColor"] option')).first().click();
           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('null');
         });
      </file>
    </example>
 */

/* eslint-disable max-len */
//                     //00001111111111000000000002222222222000000000000000000000333333333300000000000000000000000004444444444400000000000005555555555555000000000666666666666600000007777777777777000000000000000888888888800000000000000000009999999999
var NG_OPTIONS_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+group\s+by\s+([\s\S]+?))?(?:\s+disable\s+when\s+([\s\S]+?))?\s+for\s+(?:([$\w][$\w]*)|(?:\(\s*([$\w][$\w]*)\s*,\s*([$\w][$\w]*)\s*\)))\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/;
                        // 1: value expression (valueFn)
                        // 2: label expression (displayFn)
                        // 3: group by expression (groupByFn)
                        // 4: disable when expression (disableWhenFn)
                        // 5: array item variable name
                        // 6: object item key variable name
                        // 7: object item value variable name
                        // 8: collection expression
                        // 9: track by expression
/* eslint-enable */


var ngOptionsDirective = ['$compile', '$document', '$parse', function($compile, $document, $parse) {

  function parseOptionsExpression(optionsExp, selectElement, scope) {

    var match = optionsExp.match(NG_OPTIONS_REGEXP);
    if (!(match)) {
      throw ngOptionsMinErr('iexp',
        'Expected expression in form of ' +
        '\'_select_ (as _label_)? for (_key_,)?_value_ in _collection_\'' +
        ' but got \'{0}\'. Element: {1}',
        optionsExp, startingTag(selectElement));
    }

    // Extract the parts from the ngOptions expression

    // The variable name for the value of the item in the collection
    var valueName = match[5] || match[7];
    // The variable name for the key of the item in the collection
    var keyName = match[6];

    // An expression that generates the viewValue for an option if there is a label expression
    var selectAs = / as /.test(match[0]) && match[1];
    // An expression that is used to track the id of each object in the options collection
    var trackBy = match[9];
    // An expression that generates the viewValue for an option if there is no label expression
    var valueFn = $parse(match[2] ? match[1] : valueName);
    var selectAsFn = selectAs && $parse(selectAs);
    var viewValueFn = selectAsFn || valueFn;
    var trackByFn = trackBy && $parse(trackBy);

    // Get the value by which we are going to track the option
    // if we have a trackFn then use that (passing scope and locals)
    // otherwise just hash the given viewValue
    var getTrackByValueFn = trackBy ?
                              function(value, locals) { return trackByFn(scope, locals); } :
                              function getHashOfValue(value) { return hashKey(value); };
    var getTrackByValue = function(value, key) {
      return getTrackByValueFn(value, getLocals(value, key));
    };

    var displayFn = $parse(match[2] || match[1]);
    var groupByFn = $parse(match[3] || '');
    var disableWhenFn = $parse(match[4] || '');
    var valuesFn = $parse(match[8]);

    var locals = {};
    var getLocals = keyName ? function(value, key) {
      locals[keyName] = key;
      locals[valueName] = value;
      return locals;
    } : function(value) {
      locals[valueName] = value;
      return locals;
    };


    function Option(selectValue, viewValue, label, group, disabled) {
      this.selectValue = selectValue;
      this.viewValue = viewValue;
      this.label = label;
      this.group = group;
      this.disabled = disabled;
    }

    function getOptionValuesKeys(optionValues) {
      var optionValuesKeys;

      if (!keyName && isArrayLike(optionValues)) {
        optionValuesKeys = optionValues;
      } else {
        // if object, extract keys, in enumeration order, unsorted
        optionValuesKeys = [];
        for (var itemKey in optionValues) {
          if (optionValues.hasOwnProperty(itemKey) && itemKey.charAt(0) !== '$') {
            optionValuesKeys.push(itemKey);
          }
        }
      }
      return optionValuesKeys;
    }

    return {
      trackBy: trackBy,
      getTrackByValue: getTrackByValue,
      getWatchables: $parse(valuesFn, function(optionValues) {
        // Create a collection of things that we would like to watch (watchedArray)
        // so that they can all be watched using a single $watchCollection
        // that only runs the handler once if anything changes
        var watchedArray = [];
        optionValues = optionValues || [];

        var optionValuesKeys = getOptionValuesKeys(optionValues);
        var optionValuesLength = optionValuesKeys.length;
        for (var index = 0; index < optionValuesLength; index++) {
          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
          var value = optionValues[key];

          var locals = getLocals(value, key);
          var selectValue = getTrackByValueFn(value, locals);
          watchedArray.push(selectValue);

          // Only need to watch the displayFn if there is a specific label expression
          if (match[2] || match[1]) {
            var label = displayFn(scope, locals);
            watchedArray.push(label);
          }

          // Only need to watch the disableWhenFn if there is a specific disable expression
          if (match[4]) {
            var disableWhen = disableWhenFn(scope, locals);
            watchedArray.push(disableWhen);
          }
        }
        return watchedArray;
      }),

      getOptions: function() {

        var optionItems = [];
        var selectValueMap = {};

        // The option values were already computed in the `getWatchables` fn,
        // which must have been called to trigger `getOptions`
        var optionValues = valuesFn(scope) || [];
        var optionValuesKeys = getOptionValuesKeys(optionValues);
        var optionValuesLength = optionValuesKeys.length;

        for (var index = 0; index < optionValuesLength; index++) {
          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
          var value = optionValues[key];
          var locals = getLocals(value, key);
          var viewValue = viewValueFn(scope, locals);
          var selectValue = getTrackByValueFn(viewValue, locals);
          var label = displayFn(scope, locals);
          var group = groupByFn(scope, locals);
          var disabled = disableWhenFn(scope, locals);
          var optionItem = new Option(selectValue, viewValue, label, group, disabled);

          optionItems.push(optionItem);
          selectValueMap[selectValue] = optionItem;
        }

        return {
          items: optionItems,
          selectValueMap: selectValueMap,
          getOptionFromViewValue: function(value) {
            return selectValueMap[getTrackByValue(value)];
          },
          getViewValueFromOption: function(option) {
            // If the viewValue could be an object that may be mutated by the application,
            // we need to make a copy and not return the reference to the value on the option.
            return trackBy ? copy(option.viewValue) : option.viewValue;
          }
        };
      }
    };
  }


  // Support: IE 9 only
  // We can't just jqLite('<option>') since jqLite is not smart enough
  // to create it in <select> and IE barfs otherwise.
  var optionTemplate = window.document.createElement('option'),
      optGroupTemplate = window.document.createElement('optgroup');

    function ngOptionsPostLink(scope, selectElement, attr, ctrls) {

      var selectCtrl = ctrls[0];
      var ngModelCtrl = ctrls[1];
      var multiple = attr.multiple;

      // The emptyOption allows the application developer to provide their own custom "empty"
      // option when the viewValue does not match any of the option values.
      for (var i = 0, children = selectElement.children(), ii = children.length; i < ii; i++) {
        if (children[i].value === '') {
          selectCtrl.hasEmptyOption = true;
          selectCtrl.emptyOption = children.eq(i);
          break;
        }
      }

      // The empty option will be compiled and rendered before we first generate the options
      selectElement.empty();

      var providedEmptyOption = !!selectCtrl.emptyOption;

      var unknownOption = jqLite(optionTemplate.cloneNode(false));
      unknownOption.val('?');

      var options;
      var ngOptions = parseOptionsExpression(attr.ngOptions, selectElement, scope);
      // This stores the newly created options before they are appended to the select.
      // Since the contents are removed from the fragment when it is appended,
      // we only need to create it once.
      var listFragment = $document[0].createDocumentFragment();

      // Overwrite the implementation. ngOptions doesn't use hashes
      selectCtrl.generateUnknownOptionValue = function(val) {
        return '?';
      };

      // Update the controller methods for multiple selectable options
      if (!multiple) {

        selectCtrl.writeValue = function writeNgOptionsValue(value) {
          // The options might not be defined yet when ngModel tries to render
          if (!options) return;

          var selectedOption = selectElement[0].options[selectElement[0].selectedIndex];
          var option = options.getOptionFromViewValue(value);

          // Make sure to remove the selected attribute from the previously selected option
          // Otherwise, screen readers might get confused
          if (selectedOption) selectedOption.removeAttribute('selected');

          if (option) {
            // Don't update the option when it is already selected.
            // For example, the browser will select the first option by default. In that case,
            // most properties are set automatically - except the `selected` attribute, which we
            // set always

            if (selectElement[0].value !== option.selectValue) {
              selectCtrl.removeUnknownOption();

              selectElement[0].value = option.selectValue;
              option.element.selected = true;
            }

            option.element.setAttribute('selected', 'selected');
          } else {
            selectCtrl.selectUnknownOrEmptyOption(value);
          }
        };

        selectCtrl.readValue = function readNgOptionsValue() {

          var selectedOption = options.selectValueMap[selectElement.val()];

          if (selectedOption && !selectedOption.disabled) {
            selectCtrl.unselectEmptyOption();
            selectCtrl.removeUnknownOption();
            return options.getViewValueFromOption(selectedOption);
          }
          return null;
        };

        // If we are using `track by` then we must watch the tracked value on the model
        // since ngModel only watches for object identity change
        // FIXME: When a user selects an option, this watch will fire needlessly
        if (ngOptions.trackBy) {
          scope.$watch(
            function() { return ngOptions.getTrackByValue(ngModelCtrl.$viewValue); },
            function() { ngModelCtrl.$render(); }
          );
        }

      } else {

        selectCtrl.writeValue = function writeNgOptionsMultiple(values) {
          // The options might not be defined yet when ngModel tries to render
          if (!options) return;

          // Only set `<option>.selected` if necessary, in order to prevent some browsers from
          // scrolling to `<option>` elements that are outside the `<select>` element's viewport.
          var selectedOptions = values && values.map(getAndUpdateSelectedOption) || [];

          options.items.forEach(function(option) {
            if (option.element.selected && !includes(selectedOptions, option)) {
              option.element.selected = false;
            }
          });
        };


        selectCtrl.readValue = function readNgOptionsMultiple() {
          var selectedValues = selectElement.val() || [],
              selections = [];

          forEach(selectedValues, function(value) {
            var option = options.selectValueMap[value];
            if (option && !option.disabled) selections.push(options.getViewValueFromOption(option));
          });

          return selections;
        };

        // If we are using `track by` then we must watch these tracked values on the model
        // since ngModel only watches for object identity change
        if (ngOptions.trackBy) {

          scope.$watchCollection(function() {
            if (isArray(ngModelCtrl.$viewValue)) {
              return ngModelCtrl.$viewValue.map(function(value) {
                return ngOptions.getTrackByValue(value);
              });
            }
          }, function() {
            ngModelCtrl.$render();
          });

        }
      }

      if (providedEmptyOption) {

        // compile the element since there might be bindings in it
        $compile(selectCtrl.emptyOption)(scope);

        selectElement.prepend(selectCtrl.emptyOption);

        if (selectCtrl.emptyOption[0].nodeType === NODE_TYPE_COMMENT) {
          // This means the empty option has currently no actual DOM node, probably because
          // it has been modified by a transclusion directive.
          selectCtrl.hasEmptyOption = false;

          // Redefine the registerOption function, which will catch
          // options that are added by ngIf etc. (rendering of the node is async because of
          // lazy transclusion)
          selectCtrl.registerOption = function(optionScope, optionEl) {
            if (optionEl.val() === '') {
              selectCtrl.hasEmptyOption = true;
              selectCtrl.emptyOption = optionEl;
              selectCtrl.emptyOption.removeClass('ng-scope');
              // This ensures the new empty option is selected if previously no option was selected
              ngModelCtrl.$render();

              optionEl.on('$destroy', function() {
                var needsRerender = selectCtrl.$isEmptyOptionSelected();

                selectCtrl.hasEmptyOption = false;
                selectCtrl.emptyOption = undefined;

                if (needsRerender) ngModelCtrl.$render();
              });
            }
          };

        } else {
          // remove the class, which is added automatically because we recompile the element and it
          // becomes the compilation root
          selectCtrl.emptyOption.removeClass('ng-scope');
        }

      }

      // We will re-render the option elements if the option values or labels change
      scope.$watchCollection(ngOptions.getWatchables, updateOptions);

      // ------------------------------------------------------------------ //

      function addOptionElement(option, parent) {
        var optionElement = optionTemplate.cloneNode(false);
        parent.appendChild(optionElement);
        updateOptionElement(option, optionElement);
      }

      function getAndUpdateSelectedOption(viewValue) {
        var option = options.getOptionFromViewValue(viewValue);
        var element = option && option.element;

        if (element && !element.selected) element.selected = true;

        return option;
      }

      function updateOptionElement(option, element) {
        option.element = element;
        element.disabled = option.disabled;
        // Support: IE 11 only, Edge 12-13 only
        // NOTE: The label must be set before the value, otherwise IE 11 & Edge create unresponsive
        // selects in certain circumstances when multiple selects are next to each other and display
        // the option list in listbox style, i.e. the select is [multiple], or specifies a [size].
        // See https://github.com/angular/angular.js/issues/11314 for more info.
        // This is unfortunately untestable with unit / e2e tests
        if (option.label !== element.label) {
          element.label = option.label;
          element.textContent = option.label;
        }
        element.value = option.selectValue;
      }

      function updateOptions() {
        var previousValue = options && selectCtrl.readValue();

        // We must remove all current options, but cannot simply set innerHTML = null
        // since the providedEmptyOption might have an ngIf on it that inserts comments which we
        // must preserve.
        // Instead, iterate over the current option elements and remove them or their optgroup
        // parents
        if (options) {

          for (var i = options.items.length - 1; i >= 0; i--) {
            var option = options.items[i];
            if (isDefined(option.group)) {
              jqLiteRemove(option.element.parentNode);
            } else {
              jqLiteRemove(option.element);
            }
          }
        }

        options = ngOptions.getOptions();

        var groupElementMap = {};

        options.items.forEach(function addOption(option) {
          var groupElement;

          if (isDefined(option.group)) {

            // This option is to live in a group
            // See if we have already created this group
            groupElement = groupElementMap[option.group];

            if (!groupElement) {

              groupElement = optGroupTemplate.cloneNode(false);
              listFragment.appendChild(groupElement);

              // Update the label on the group element
              // "null" is special cased because of Safari
              groupElement.label = option.group === null ? 'null' : option.group;

              // Store it for use later
              groupElementMap[option.group] = groupElement;
            }

            addOptionElement(option, groupElement);

          } else {

            // This option is not in a group
            addOptionElement(option, listFragment);
          }
        });

        selectElement[0].appendChild(listFragment);

        ngModelCtrl.$render();

        // Check to see if the value has changed due to the update to the options
        if (!ngModelCtrl.$isEmpty(previousValue)) {
          var nextValue = selectCtrl.readValue();
          var isNotPrimitive = ngOptions.trackBy || multiple;
          if (isNotPrimitive ? !equals(previousValue, nextValue) : previousValue !== nextValue) {
            ngModelCtrl.$setViewValue(nextValue);
            ngModelCtrl.$render();
          }
        }
      }
  }

  return {
    restrict: 'A',
    terminal: true,
    require: ['select', 'ngModel'],
    link: {
      pre: function ngOptionsPreLink(scope, selectElement, attr, ctrls) {
        // Deactivate the SelectController.register method to prevent
        // option directives from accidentally registering themselves
        // (and unwanted $destroy handlers etc.)
        ctrls[0].registerOption = noop;
      },
      post: ngOptionsPostLink
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngPluralize
 * @restrict EA
 *
 * @description
 * `ngPluralize` is a directive that displays messages according to en-US localization rules.
 * These rules are bundled with angular.js, but can be overridden
 * (see {@link guide/i18n AngularJS i18n} dev guide). You configure ngPluralize directive
 * by specifying the mappings between
 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
 * and the strings to be displayed.
 *
 * ## Plural categories and explicit number rules
 * There are two
 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
 * in AngularJS's default en-US locale: "one" and "other".
 *
 * While a plural category may match many numbers (for example, in en-US locale, "other" can match
 * any number that is not 1), an explicit number rule can only match one number. For example, the
 * explicit number rule for "3" matches the number 3. There are examples of plural categories
 * and explicit number rules throughout the rest of this documentation.
 *
 * ## Configuring ngPluralize
 * You configure ngPluralize by providing 2 attributes: `count` and `when`.
 * You can also provide an optional attribute, `offset`.
 *
 * The value of the `count` attribute can be either a string or an {@link guide/expression
 * AngularJS expression}; these are evaluated on the current scope for its bound value.
 *
 * The `when` attribute specifies the mappings between plural categories and the actual
 * string to be displayed. The value of the attribute should be a JSON object.
 *
 * The following example shows how to configure ngPluralize:
 *
 * ```html
 * <ng-pluralize count="personCount"
                 when="{'0': 'Nobody is viewing.',
 *                      'one': '1 person is viewing.',
 *                      'other': '{} people are viewing.'}">
 * </ng-pluralize>
 *```
 *
 * In the example, `"0: Nobody is viewing."` is an explicit number rule. If you did not
 * specify this rule, 0 would be matched to the "other" category and "0 people are viewing"
 * would be shown instead of "Nobody is viewing". You can specify an explicit number rule for
 * other numbers, for example 12, so that instead of showing "12 people are viewing", you can
 * show "a dozen people are viewing".
 *
 * You can use a set of closed braces (`{}`) as a placeholder for the number that you want substituted
 * into pluralized strings. In the previous example, AngularJS will replace `{}` with
 * <span ng-non-bindable>`{{personCount}}`</span>. The closed braces `{}` is a placeholder
 * for <span ng-non-bindable>{{numberExpression}}</span>.
 *
 * If no rule is defined for a category, then an empty string is displayed and a warning is generated.
 * Note that some locales define more categories than `one` and `other`. For example, fr-fr defines `few` and `many`.
 *
 * ## Configuring ngPluralize with offset
 * The `offset` attribute allows further customization of pluralized text, which can result in
 * a better user experience. For example, instead of the message "4 people are viewing this document",
 * you might display "John, Kate and 2 others are viewing this document".
 * The offset attribute allows you to offset a number by any desired value.
 * Let's take a look at an example:
 *
 * ```html
 * <ng-pluralize count="personCount" offset=2
 *               when="{'0': 'Nobody is viewing.',
 *                      '1': '{{person1}} is viewing.',
 *                      '2': '{{person1}} and {{person2}} are viewing.',
 *                      'one': '{{person1}}, {{person2}} and one other person are viewing.',
 *                      'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
 * </ng-pluralize>
 * ```
 *
 * Notice that we are still using two plural categories(one, other), but we added
 * three explicit number rules 0, 1 and 2.
 * When one person, perhaps John, views the document, "John is viewing" will be shown.
 * When three people view the document, no explicit number rule is found, so
 * an offset of 2 is taken off 3, and AngularJS uses 1 to decide the plural category.
 * In this case, plural category 'one' is matched and "John, Mary and one other person are viewing"
 * is shown.
 *
 * Note that when you specify offsets, you must provide explicit number rules for
 * numbers from 0 up to and including the offset. If you use an offset of 3, for example,
 * you must provide explicit number rules for 0, 1, 2 and 3. You must also provide plural strings for
 * plural categories "one" and "other".
 *
 * @param {string|expression} count The variable to be bound to.
 * @param {string} when The mapping between plural category to its corresponding strings.
 * @param {number=} offset Offset to deduct from the total number.
 *
 * @example
    <example module="pluralizeExample" name="ng-pluralize">
      <file name="index.html">
        <script>
          angular.module('pluralizeExample', [])
            .controller('ExampleController', ['$scope', function($scope) {
              $scope.person1 = 'Igor';
              $scope.person2 = 'Misko';
              $scope.personCount = 1;
            }]);
        </script>
        <div ng-controller="ExampleController">
          <label>Person 1:<input type="text" ng-model="person1" value="Igor" /></label><br/>
          <label>Person 2:<input type="text" ng-model="person2" value="Misko" /></label><br/>
          <label>Number of People:<input type="text" ng-model="personCount" value="1" /></label><br/>

          <!--- Example with simple pluralization rules for en locale --->
          Without Offset:
          <ng-pluralize count="personCount"
                        when="{'0': 'Nobody is viewing.',
                               'one': '1 person is viewing.',
                               'other': '{} people are viewing.'}">
          </ng-pluralize><br>

          <!--- Example with offset --->
          With Offset(2):
          <ng-pluralize count="personCount" offset=2
                        when="{'0': 'Nobody is viewing.',
                               '1': '{{person1}} is viewing.',
                               '2': '{{person1}} and {{person2}} are viewing.',
                               'one': '{{person1}}, {{person2}} and one other person are viewing.',
                               'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
          </ng-pluralize>
        </div>
      </file>
      <file name="protractor.js" type="protractor">
        it('should show correct pluralized string', function() {
          var withoutOffset = element.all(by.css('ng-pluralize')).get(0);
          var withOffset = element.all(by.css('ng-pluralize')).get(1);
          var countInput = element(by.model('personCount'));

          expect(withoutOffset.getText()).toEqual('1 person is viewing.');
          expect(withOffset.getText()).toEqual('Igor is viewing.');

          countInput.clear();
          countInput.sendKeys('0');

          expect(withoutOffset.getText()).toEqual('Nobody is viewing.');
          expect(withOffset.getText()).toEqual('Nobody is viewing.');

          countInput.clear();
          countInput.sendKeys('2');

          expect(withoutOffset.getText()).toEqual('2 people are viewing.');
          expect(withOffset.getText()).toEqual('Igor and Misko are viewing.');

          countInput.clear();
          countInput.sendKeys('3');

          expect(withoutOffset.getText()).toEqual('3 people are viewing.');
          expect(withOffset.getText()).toEqual('Igor, Misko and one other person are viewing.');

          countInput.clear();
          countInput.sendKeys('4');

          expect(withoutOffset.getText()).toEqual('4 people are viewing.');
          expect(withOffset.getText()).toEqual('Igor, Misko and 2 other people are viewing.');
        });
        it('should show data-bound names', function() {
          var withOffset = element.all(by.css('ng-pluralize')).get(1);
          var personCount = element(by.model('personCount'));
          var person1 = element(by.model('person1'));
          var person2 = element(by.model('person2'));
          personCount.clear();
          personCount.sendKeys('4');
          person1.clear();
          person1.sendKeys('Di');
          person2.clear();
          person2.sendKeys('Vojta');
          expect(withOffset.getText()).toEqual('Di, Vojta and 2 other people are viewing.');
        });
      </file>
    </example>
 */
var ngPluralizeDirective = ['$locale', '$interpolate', '$log', function($locale, $interpolate, $log) {
  var BRACE = /{}/g,
      IS_WHEN = /^when(Minus)?(.+)$/;

  return {
    link: function(scope, element, attr) {
      var numberExp = attr.count,
          whenExp = attr.$attr.when && element.attr(attr.$attr.when), // we have {{}} in attrs
          offset = attr.offset || 0,
          whens = scope.$eval(whenExp) || {},
          whensExpFns = {},
          startSymbol = $interpolate.startSymbol(),
          endSymbol = $interpolate.endSymbol(),
          braceReplacement = startSymbol + numberExp + '-' + offset + endSymbol,
          watchRemover = angular.noop,
          lastCount;

      forEach(attr, function(expression, attributeName) {
        var tmpMatch = IS_WHEN.exec(attributeName);
        if (tmpMatch) {
          var whenKey = (tmpMatch[1] ? '-' : '') + lowercase(tmpMatch[2]);
          whens[whenKey] = element.attr(attr.$attr[attributeName]);
        }
      });
      forEach(whens, function(expression, key) {
        whensExpFns[key] = $interpolate(expression.replace(BRACE, braceReplacement));

      });

      scope.$watch(numberExp, function ngPluralizeWatchAction(newVal) {
        var count = parseFloat(newVal);
        var countIsNaN = isNumberNaN(count);

        if (!countIsNaN && !(count in whens)) {
          // If an explicit number rule such as 1, 2, 3... is defined, just use it.
          // Otherwise, check it against pluralization rules in $locale service.
          count = $locale.pluralCat(count - offset);
        }

        // If both `count` and `lastCount` are NaN, we don't need to re-register a watch.
        // In JS `NaN !== NaN`, so we have to explicitly check.
        if ((count !== lastCount) && !(countIsNaN && isNumberNaN(lastCount))) {
          watchRemover();
          var whenExpFn = whensExpFns[count];
          if (isUndefined(whenExpFn)) {
            if (newVal != null) {
              $log.debug('ngPluralize: no rule defined for \'' + count + '\' in ' + whenExp);
            }
            watchRemover = noop;
            updateElementText();
          } else {
            watchRemover = scope.$watch(whenExpFn, updateElementText);
          }
          lastCount = count;
        }
      });

      function updateElementText(newText) {
        element.text(newText || '');
      }
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngRef
 * @restrict A
 *
 * @description
 * The `ngRef` attribute tells AngularJS to assign the controller of a component (or a directive)
 * to the given property in the current scope. It is also possible to add the jqlite-wrapped DOM
 * element to the scope.
 *
 * If the element with `ngRef` is destroyed `null` is assigned to the property.
 *
 * Note that if you want to assign from a child into the parent scope, you must initialize the
 * target property on the parent scope, otherwise `ngRef` will assign on the child scope.
 * This commonly happens when assigning elements or components wrapped in {@link ngIf} or
 * {@link ngRepeat}. See the second example below.
 *
 *
 * @element ANY
 * @param {string} ngRef property name - A valid AngularJS expression identifier to which the
 *                       controller or jqlite-wrapped DOM element will be bound.
 * @param {string=} ngRefRead read value - The name of a directive (or component) on this element,
 *                            or the special string `$element`. If a name is provided, `ngRef` will
 *                            assign the matching controller. If `$element` is provided, the element
 *                            itself is assigned (even if a controller is available).
 *
 *
 * @example
 * ### Simple toggle
 * This example shows how the controller of the component toggle
 * is reused in the template through the scope to use its logic.
 * <example name="ng-ref-component" module="myApp">
 *   <file name="index.html">
 *     <my-toggle ng-ref="myToggle"></my-toggle>
 *     <button ng-click="myToggle.toggle()">Toggle</button>
 *     <div ng-show="myToggle.isOpen()">
 *       You are using a component in the same template to show it.
 *     </div>
 *   </file>
 *   <file name="index.js">
 *     angular.module('myApp', [])
 *     .component('myToggle', {
 *       controller: function ToggleController() {
 *         var opened = false;
 *         this.isOpen = function() { return opened; };
 *         this.toggle = function() { opened = !opened; };
 *       }
 *     });
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *      it('should publish the toggle into the scope', function() {
 *        var toggle = element(by.buttonText('Toggle'));
 *        expect(toggle.evaluate('myToggle.isOpen()')).toEqual(false);
 *        toggle.click();
 *        expect(toggle.evaluate('myToggle.isOpen()')).toEqual(true);
 *      });
 *   </file>
 * </example>
 *
 * @example
 * ### ngRef inside scopes
 * This example shows how `ngRef` works with child scopes. The `ngRepeat`-ed `myWrapper` components
 * are assigned to the scope of `myRoot`, because the `toggles` property has been initialized.
 * The repeated `myToggle` components are published to the child scopes created by `ngRepeat`.
 * `ngIf` behaves similarly - the assignment of `myToggle` happens in the `ngIf` child scope,
 * because the target property has not been initialized on the `myRoot` component controller.
 *
 * <example name="ng-ref-scopes" module="myApp">
 *   <file name="index.html">
 *     <my-root></my-root>
 *   </file>
 *   <file name="index.js">
 *     angular.module('myApp', [])
 *     .component('myRoot', {
 *       templateUrl: 'root.html',
 *       controller: function() {
 *         this.wrappers = []; // initialize the array so that the wrappers are assigned into the parent scope
 *       }
 *     })
 *     .component('myToggle', {
 *       template: '<strong>myToggle</strong><button ng-click="$ctrl.toggle()" ng-transclude></button>',
 *       transclude: true,
 *       controller: function ToggleController() {
 *         var opened = false;
 *         this.isOpen = function() { return opened; };
 *         this.toggle = function() { opened = !opened; };
 *       }
 *     })
 *     .component('myWrapper', {
 *       transclude: true,
 *       template: '<strong>myWrapper</strong>' +
 *         '<div>ngRepeatToggle.isOpen(): {{$ctrl.ngRepeatToggle.isOpen() | json}}</div>' +
 *         '<my-toggle ng-ref="$ctrl.ngRepeatToggle"><ng-transclude></ng-transclude></my-toggle>'
 *     });
 *   </file>
 *   <file name="root.html">
 *     <strong>myRoot</strong>
 *     <my-toggle ng-ref="$ctrl.outerToggle">Outer Toggle</my-toggle>
 *     <div>outerToggle.isOpen(): {{$ctrl.outerToggle.isOpen() | json}}</div>
 *     <div><em>wrappers assigned to root</em><br>
 *     <div ng-repeat="wrapper in $ctrl.wrappers">
 *       wrapper.ngRepeatToggle.isOpen(): {{wrapper.ngRepeatToggle.isOpen() | json}}
 *     </div>
 *
 *     <ul>
 *       <li ng-repeat="(index, value) in [1,2,3]">
 *         <strong>ngRepeat</strong>
 *         <div>outerToggle.isOpen(): {{$ctrl.outerToggle.isOpen() | json}}</div>
 *         <my-wrapper ng-ref="$ctrl.wrappers[index]">ngRepeat Toggle {{$index + 1}}</my-wrapper>
 *       </li>
 *     </ul>
 *
 *     <div>ngIfToggle.isOpen(): {{ngIfToggle.isOpen()}} // This is always undefined because it's
 *       assigned to the child scope created by ngIf.
 *     </div>
 *     <div ng-if="true">
          <strong>ngIf</strong>
 *        <my-toggle ng-ref="ngIfToggle">ngIf Toggle</my-toggle>
 *        <div>ngIfToggle.isOpen(): {{ngIfToggle.isOpen() | json}}</div>
 *        <div>outerToggle.isOpen(): {{$ctrl.outerToggle.isOpen() | json}}</div>
 *     </div>
 *   </file>
 *   <file name="styles.css">
 *     ul {
 *       list-style: none;
 *       padding-left: 0;
 *     }
 *
 *     li[ng-repeat] {
 *       background: lightgreen;
 *       padding: 8px;
 *       margin: 8px;
 *     }
 *
 *     [ng-if] {
 *       background: lightgrey;
 *       padding: 8px;
 *     }
 *
 *     my-root {
 *       background: lightgoldenrodyellow;
 *       padding: 8px;
 *       display: block;
 *     }
 *
 *     my-wrapper {
 *       background: lightsalmon;
 *       padding: 8px;
 *       display: block;
 *     }
 *
 *     my-toggle {
 *       background: lightblue;
 *       padding: 8px;
 *       display: block;
 *     }
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *      var OuterToggle = function() {
 *        this.toggle = function() {
 *          element(by.buttonText('Outer Toggle')).click();
 *        };
 *        this.isOpen = function() {
 *          return element.all(by.binding('outerToggle.isOpen()')).first().getText();
 *        };
 *      };
 *      var NgRepeatToggle = function(i) {
 *        var parent = element.all(by.repeater('(index, value) in [1,2,3]')).get(i - 1);
 *        this.toggle = function() {
 *          element(by.buttonText('ngRepeat Toggle ' + i)).click();
 *        };
 *        this.isOpen = function() {
 *          return parent.element(by.binding('ngRepeatToggle.isOpen() | json')).getText();
 *        };
 *        this.isOuterOpen = function() {
 *          return parent.element(by.binding('outerToggle.isOpen() | json')).getText();
 *        };
 *      };
 *      var NgRepeatToggles = function() {
 *        var toggles = [1,2,3].map(function(i) { return new NgRepeatToggle(i); });
 *        this.forEach = function(fn) {
 *          toggles.forEach(fn);
 *        };
 *        this.isOuterOpen = function(i) {
 *          return toggles[i - 1].isOuterOpen();
 *        };
 *      };
 *      var NgIfToggle = function() {
 *        var parent = element(by.css('[ng-if]'));
 *        this.toggle = function() {
 *          element(by.buttonText('ngIf Toggle')).click();
 *        };
 *        this.isOpen = function() {
 *          return by.binding('ngIfToggle.isOpen() | json').getText();
 *        };
 *        this.isOuterOpen = function() {
 *          return parent.element(by.binding('outerToggle.isOpen() | json')).getText();
 *        };
 *      };
 *
 *      it('should toggle the outer toggle', function() {
 *        var outerToggle = new OuterToggle();
 *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): false');
 *        outerToggle.toggle();
 *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): true');
 *      });
 *
 *      it('should toggle all outer toggles', function() {
 *        var outerToggle = new OuterToggle();
 *        var repeatToggles = new NgRepeatToggles();
 *        var ifToggle = new NgIfToggle();
 *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): false');
 *        expect(repeatToggles.isOuterOpen(1)).toEqual('outerToggle.isOpen(): false');
 *        expect(repeatToggles.isOuterOpen(2)).toEqual('outerToggle.isOpen(): false');
 *        expect(repeatToggles.isOuterOpen(3)).toEqual('outerToggle.isOpen(): false');
 *        expect(ifToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): false');
 *        outerToggle.toggle();
 *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): true');
 *        expect(repeatToggles.isOuterOpen(1)).toEqual('outerToggle.isOpen(): true');
 *        expect(repeatToggles.isOuterOpen(2)).toEqual('outerToggle.isOpen(): true');
 *        expect(repeatToggles.isOuterOpen(3)).toEqual('outerToggle.isOpen(): true');
 *        expect(ifToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): true');
 *      });
 *
 *      it('should toggle each repeat iteration separately', function() {
 *        var repeatToggles = new NgRepeatToggles();
 *
 *        repeatToggles.forEach(function(repeatToggle) {
 *          expect(repeatToggle.isOpen()).toEqual('ngRepeatToggle.isOpen(): false');
 *          expect(repeatToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): false');
 *          repeatToggle.toggle();
 *          expect(repeatToggle.isOpen()).toEqual('ngRepeatToggle.isOpen(): true');
 *          expect(repeatToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): false');
 *        });
 *      });
 *   </file>
 * </example>
 *
 */

var ngRefMinErr = minErr('ngRef');

var ngRefDirective = ['$parse', function($parse) {
  return {
    priority: -1, // Needed for compatibility with element transclusion on the same element
    restrict: 'A',
    compile: function(tElement, tAttrs) {
      // Get the expected controller name, converts <data-some-thing> into "someThing"
      var controllerName = directiveNormalize(nodeName_(tElement));

      // Get the expression for value binding
      var getter = $parse(tAttrs.ngRef);
      var setter = getter.assign || function() {
        throw ngRefMinErr('nonassign', 'Expression in ngRef="{0}" is non-assignable!', tAttrs.ngRef);
      };

      return function(scope, element, attrs) {
        var refValue;

        if (attrs.hasOwnProperty('ngRefRead')) {
          if (attrs.ngRefRead === '$element') {
            refValue = element;
          } else {
            refValue = element.data('$' + attrs.ngRefRead + 'Controller');

            if (!refValue) {
              throw ngRefMinErr(
                'noctrl',
                'The controller for ngRefRead="{0}" could not be found on ngRef="{1}"',
                attrs.ngRefRead,
                tAttrs.ngRef
              );
            }
          }
        } else {
          refValue = element.data('$' + controllerName + 'Controller');
        }

        refValue = refValue || element;

        setter(scope, refValue);

        // when the element is removed, remove it (nullify it)
        element.on('$destroy', function() {
          // only remove it if value has not changed,
          // because animations (and other procedures) may duplicate elements
          if (getter(scope) === refValue) {
            setter(scope, null);
          }
        });
      };
    }
  };
}];

/* exported ngRepeatDirective */

/**
 * @ngdoc directive
 * @name ngRepeat
 * @multiElement
 * @restrict A
 *
 * @description
 * The `ngRepeat` directive instantiates a template once per item from a collection. Each template
 * instance gets its own scope, where the given loop variable is set to the current collection item,
 * and `$index` is set to the item index or key.
 *
 * Special properties are exposed on the local scope of each template instance, including:
 *
 * | Variable  | Type            | Details                                                                     |
 * |-----------|-----------------|-----------------------------------------------------------------------------|
 * | `$index`  | {@type number}  | iterator offset of the repeated element (0..length-1)                       |
 * | `$first`  | {@type boolean} | true if the repeated element is first in the iterator.                      |
 * | `$middle` | {@type boolean} | true if the repeated element is between the first and last in the iterator. |
 * | `$last`   | {@type boolean} | true if the repeated element is last in the iterator.                       |
 * | `$even`   | {@type boolean} | true if the iterator position `$index` is even (otherwise false).           |
 * | `$odd`    | {@type boolean} | true if the iterator position `$index` is odd (otherwise false).            |
 *
 * <div class="alert alert-info">
 *   Creating aliases for these properties is possible with {@link ng.directive:ngInit `ngInit`}.
 *   This may be useful when, for instance, nesting ngRepeats.
 * </div>
 *
 *
 * ## Iterating over object properties
 *
 * It is possible to get `ngRepeat` to iterate over the properties of an object using the following
 * syntax:
 *
 * ```js
 * <div ng-repeat="(key, value) in myObj"> ... </div>
 * ```
 *
 * However, there are a few limitations compared to array iteration:
 *
 * - The JavaScript specification does not define the order of keys
 *   returned for an object, so AngularJS relies on the order returned by the browser
 *   when running `for key in myObj`. Browsers generally follow the strategy of providing
 *   keys in the order in which they were defined, although there are exceptions when keys are deleted
 *   and reinstated. See the
 *   [MDN page on `delete` for more info](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/delete#Cross-browser_notes).
 *
 * - `ngRepeat` will silently *ignore* object keys starting with `$`, because
 *   it's a prefix used by AngularJS for public (`$`) and private (`$$`) properties.
 *
 * - The built-in filters {@link ng.orderBy orderBy} and {@link ng.filter filter} do not work with
 *   objects, and will throw an error if used with one.
 *
 * If you are hitting any of these limitations, the recommended workaround is to convert your object into an array
 * that is sorted into the order that you prefer before providing it to `ngRepeat`. You could
 * do this with a filter such as [toArrayFilter](http://ngmodules.org/modules/angular-toArrayFilter)
 * or implement a `$watch` on the object yourself.
 *
 *
 * ## Tracking and Duplicates
 *
 * `ngRepeat` uses {@link $rootScope.Scope#$watchCollection $watchCollection} to detect changes in
 * the collection. When a change happens, `ngRepeat` then makes the corresponding changes to the DOM:
 *
 * * When an item is added, a new instance of the template is added to the DOM.
 * * When an item is removed, its template instance is removed from the DOM.
 * * When items are reordered, their respective templates are reordered in the DOM.
 *
 * To minimize creation of DOM elements, `ngRepeat` uses a function
 * to "keep track" of all items in the collection and their corresponding DOM elements.
 * For example, if an item is added to the collection, `ngRepeat` will know that all other items
 * already have DOM elements, and will not re-render them.
 *
 * All different types of tracking functions, their syntax, and their support for duplicate
 * items in collections can be found in the
 * {@link ngRepeat#ngRepeat-arguments ngRepeat expression description}.
 *
 * <div class="alert alert-success">
 * **Best Practice:** If you are working with objects that have a unique identifier property, you
 * should track by this identifier instead of the object instance,
 * e.g. `item in items track by item.id`.
 * Should you reload your data later, `ngRepeat` will not have to rebuild the DOM elements for items
 * it has already rendered, even if the JavaScript objects in the collection have been substituted
 * for new ones. For large collections, this significantly improves rendering performance.
 * </div>
 *
 * ### Effects of DOM Element re-use
 *
 * When DOM elements are re-used, ngRepeat updates the scope for the element, which will
 * automatically update any active bindings on the template. However, other
 * functionality will not be updated, because the element is not re-created:
 *
 * - Directives are not re-compiled
 * - {@link guide/expression#one-time-binding one-time expressions} on the repeated template are not
 * updated if they have stabilized.
 *
 * The above affects all kinds of element re-use due to tracking, but may be especially visible
 * when tracking by `$index` due to the way ngRepeat re-uses elements.
 *
 * The following example shows the effects of different actions with tracking:

  <example module="ngRepeat" name="ngRepeat-tracking" deps="angular-animate.js" animations="true">
    <file name="script.js">
      angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
        var friends = [
          {name:'John', age:25},
          {name:'Mary', age:40},
          {name:'Peter', age:85}
        ];

        $scope.removeFirst = function() {
          $scope.friends.shift();
        };

        $scope.updateAge = function() {
          $scope.friends.forEach(function(el) {
            el.age = el.age + 5;
          });
        };

        $scope.copy = function() {
          $scope.friends = angular.copy($scope.friends);
        };

        $scope.reset = function() {
          $scope.friends = angular.copy(friends);
        };

        $scope.reset();
      });
    </file>
    <file name="index.html">
      <div ng-controller="repeatController">
        <ol>
          <li>When you click "Update Age", only the first list updates the age, because all others have
          a one-time binding on the age property. If you then click "Copy", the current friend list
          is copied, and now the second list updates the age, because the identity of the collection items
          has changed and the list must be re-rendered. The 3rd and 4th list stay the same, because all the
          items are already known according to their tracking functions.
          </li>
          <li>When you click "Remove First", the 4th list has the wrong age on both remaining items. This is
          due to tracking by $index: when the first collection item is removed, ngRepeat reuses the first
          DOM element for the new first collection item, and so on. Since the age property is one-time
          bound, the value remains from the collection item which was previously at this index.
          </li>
        </ol>

        <button ng-click="removeFirst()">Remove First</button>
        <button ng-click="updateAge()">Update Age</button>
        <button ng-click="copy()">Copy</button>
        <br><button ng-click="reset()">Reset List</button>
        <br>
        <code>track by $id(friend)</code> (default):
        <ul class="example-animate-container">
          <li class="animate-repeat" ng-repeat="friend in friends">
            {{friend.name}} is {{friend.age}} years old.
          </li>
        </ul>
        <code>track by $id(friend)</code> (default), with age one-time binding:
        <ul class="example-animate-container">
          <li class="animate-repeat" ng-repeat="friend in friends">
            {{friend.name}} is {{::friend.age}} years old.
          </li>
        </ul>
        <code>track by friend.name</code>, with age one-time binding:
        <ul class="example-animate-container">
          <li class="animate-repeat" ng-repeat="friend in friends track by friend.name">
            {{friend.name}}  is {{::friend.age}} years old.
          </li>
        </ul>
        <code>track by $index</code>, with age one-time binding:
        <ul class="example-animate-container">
          <li class="animate-repeat" ng-repeat="friend in friends track by $index">
            {{friend.name}} is {{::friend.age}} years old.
          </li>
        </ul>
      </div>
    </file>
    <file name="animations.css">
      .example-animate-container {
        background:white;
        border:1px solid black;
        list-style:none;
        margin:0;
        padding:0 10px;
      }

      .animate-repeat {
        line-height:30px;
        list-style:none;
        box-sizing:border-box;
      }

      .animate-repeat.ng-move,
      .animate-repeat.ng-enter,
      .animate-repeat.ng-leave {
        transition:all linear 0.5s;
      }

      .animate-repeat.ng-leave.ng-leave-active,
      .animate-repeat.ng-move,
      .animate-repeat.ng-enter {
        opacity:0;
        max-height:0;
      }

      .animate-repeat.ng-leave,
      .animate-repeat.ng-move.ng-move-active,
      .animate-repeat.ng-enter.ng-enter-active {
        opacity:1;
        max-height:30px;
      }
    </file>
  </example>

 *
 * ## Special repeat start and end points
 * To repeat a series of elements instead of just one parent element, ngRepeat (as well as other ng directives) supports extending
 * the range of the repeater by defining explicit start and end points by using **ng-repeat-start** and **ng-repeat-end** respectively.
 * The **ng-repeat-start** directive works the same as **ng-repeat**, but will repeat all the HTML code (including the tag it's defined on)
 * up to and including the ending HTML tag where **ng-repeat-end** is placed.
 *
 * The example below makes use of this feature:
 * ```html
 *   <header ng-repeat-start="item in items">
 *     Header {{ item }}
 *   </header>
 *   <div class="body">
 *     Body {{ item }}
 *   </div>
 *   <footer ng-repeat-end>
 *     Footer {{ item }}
 *   </footer>
 * ```
 *
 * And with an input of {@type ['A','B']} for the items variable in the example above, the output will evaluate to:
 * ```html
 *   <header>
 *     Header A
 *   </header>
 *   <div class="body">
 *     Body A
 *   </div>
 *   <footer>
 *     Footer A
 *   </footer>
 *   <header>
 *     Header B
 *   </header>
 *   <div class="body">
 *     Body B
 *   </div>
 *   <footer>
 *     Footer B
 *   </footer>
 * ```
 *
 * The custom start and end points for ngRepeat also support all other HTML directive syntax flavors provided in AngularJS (such
 * as **data-ng-repeat-start**, **x-ng-repeat-start** and **ng:repeat-start**).
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#enter enter} | when a new item is added to the list or when an item is revealed after a filter |
 * | {@link ng.$animate#leave leave} | when an item is removed from the list or when an item is filtered out |
 * | {@link ng.$animate#move move } | when an adjacent item is filtered out causing a reorder or when the item contents are reordered |
 *
 * See the example below for defining CSS animations with ngRepeat.
 *
 * @element ANY
 * @scope
 * @priority 1000
 * @param {repeat_expression} ngRepeat The expression indicating how to enumerate a collection. These
 *   formats are currently supported:
 *
 *   * `variable in expression` – where variable is the user defined loop variable and `expression`
 *     is a scope expression giving the collection to enumerate.
 *
 *     For example: `album in artist.albums`.
 *
 *   * `(key, value) in expression` – where `key` and `value` can be any user defined identifiers,
 *     and `expression` is the scope expression giving the collection to enumerate.
 *
 *     For example: `(name, age) in {'adam':10, 'amalie':12}`.
 *
 *   * `variable in expression track by tracking_expression` – You can also provide an optional tracking expression
 *     which can be used to associate the objects in the collection with the DOM elements. If no tracking expression
 *     is specified, ng-repeat associates elements by identity. It is an error to have
 *     more than one tracking expression value resolve to the same key. (This would mean that two distinct objects are
 *     mapped to the same DOM element, which is not possible.)
 *
 *     *Default tracking: $id()*: `item in items` is equivalent to `item in items track by $id(item)`.
 *     This implies that the DOM elements will be associated by item identity in the collection.
 *
 *     The built-in `$id()` function can be used to assign a unique
 *     `$$hashKey` property to each item in the collection. This property is then used as a key to associated DOM elements
 *     with the corresponding item in the collection by identity. Moving the same object would move
 *     the DOM element in the same way in the DOM.
 *     Note that the default id function does not support duplicate primitive values (`number`, `string`),
 *     but supports duplictae non-primitive values (`object`) that are *equal* in shape.
 *
 *     *Custom Expression*: It is possible to use any AngularJS expression to compute the tracking
 *     id, for example with a function, or using a property on the collection items.
 *     `item in items track by item.id` is a typical pattern when the items have a unique identifier,
 *     e.g. database id. In this case the object identity does not matter. Two objects are considered
 *     equivalent as long as their `id` property is same.
 *     Tracking by unique identifier is the most performant way and should be used whenever possible.
 *
 *     *$index*: This special property tracks the collection items by their index, and
 *     re-uses the DOM elements that match that index, e.g. `item in items track by $index`. This can
 *     be used for a performance improvement if no unique identfier is available and the identity of
 *     the collection items cannot be easily computed. It also allows duplicates.
 *
 *     <div class="alert alert-warning">
 *       <strong>Note:</strong> Re-using DOM elements can have unforeseen effects. Read the
 *       {@link ngRepeat#tracking-and-duplicates section on tracking and duplicates} for
 *       more info.
 *     </div>
 *
 *     <div class="alert alert-warning">
 *       <strong>Note:</strong> the `track by` expression must come last - after any filters, and the alias expression:
 *       `item in items | filter:searchText as results  track by item.id`
 *     </div>
 *
 *   * `variable in expression as alias_expression` – You can also provide an optional alias expression which will then store the
 *     intermediate results of the repeater after the filters have been applied. Typically this is used to render a special message
 *     when a filter is active on the repeater, but the filtered result set is empty.
 *
 *     For example: `item in items | filter:x as results` will store the fragment of the repeated items as `results`, but only after
 *     the items have been processed through the filter.
 *
 *     Please note that `as [variable name]` is not an operator but rather a part of ngRepeat
 *     micro-syntax so it can be used only after all filters (and not as operator, inside an expression).
 *
 *     For example: `item in items | filter : x | orderBy : order | limitTo : limit as results track by item.id` .
 *
 * @example
 * This example uses `ngRepeat` to display a list of people. A filter is used to restrict the displayed
 * results by name or by age. New (entering) and removed (leaving) items are animated.
  <example module="ngRepeat" name="ngRepeat" deps="angular-animate.js" animations="true">
    <file name="index.html">
      <div ng-controller="repeatController">
        I have {{friends.length}} friends. They are:
        <input type="search" ng-model="q" placeholder="filter friends..." aria-label="filter friends" />
        <ul class="example-animate-container">
          <li class="animate-repeat" ng-repeat="friend in friends | filter:q as results track by friend.name">
            [{{$index + 1}}] {{friend.name}} who is {{friend.age}} years old.
          </li>
          <li class="animate-repeat" ng-if="results.length === 0">
            <strong>No results found...</strong>
          </li>
        </ul>
      </div>
    </file>
    <file name="script.js">
      angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
        $scope.friends = [
          {name:'John', age:25, gender:'boy'},
          {name:'Jessie', age:30, gender:'girl'},
          {name:'Johanna', age:28, gender:'girl'},
          {name:'Joy', age:15, gender:'girl'},
          {name:'Mary', age:28, gender:'girl'},
          {name:'Peter', age:95, gender:'boy'},
          {name:'Sebastian', age:50, gender:'boy'},
          {name:'Erika', age:27, gender:'girl'},
          {name:'Patrick', age:40, gender:'boy'},
          {name:'Samantha', age:60, gender:'girl'}
        ];
      });
    </file>
    <file name="animations.css">
      .example-animate-container {
        background:white;
        border:1px solid black;
        list-style:none;
        margin:0;
        padding:0 10px;
      }

      .animate-repeat {
        line-height:30px;
        list-style:none;
        box-sizing:border-box;
      }

      .animate-repeat.ng-move,
      .animate-repeat.ng-enter,
      .animate-repeat.ng-leave {
        transition:all linear 0.5s;
      }

      .animate-repeat.ng-leave.ng-leave-active,
      .animate-repeat.ng-move,
      .animate-repeat.ng-enter {
        opacity:0;
        max-height:0;
      }

      .animate-repeat.ng-leave,
      .animate-repeat.ng-move.ng-move-active,
      .animate-repeat.ng-enter.ng-enter-active {
        opacity:1;
        max-height:30px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      var friends = element.all(by.repeater('friend in friends'));

      it('should render initial data set', function() {
        expect(friends.count()).toBe(10);
        expect(friends.get(0).getText()).toEqual('[1] John who is 25 years old.');
        expect(friends.get(1).getText()).toEqual('[2] Jessie who is 30 years old.');
        expect(friends.last().getText()).toEqual('[10] Samantha who is 60 years old.');
        expect(element(by.binding('friends.length')).getText())
            .toMatch("I have 10 friends. They are:");
      });

       it('should update repeater when filter predicate changes', function() {
         expect(friends.count()).toBe(10);

         element(by.model('q')).sendKeys('ma');

         expect(friends.count()).toBe(2);
         expect(friends.get(0).getText()).toEqual('[1] Mary who is 28 years old.');
         expect(friends.last().getText()).toEqual('[2] Samantha who is 60 years old.');
       });
      </file>
    </example>
 */
var ngRepeatDirective = ['$parse', '$animate', '$compile', function($parse, $animate, $compile) {
  var NG_REMOVED = '$$NG_REMOVED';
  var ngRepeatMinErr = minErr('ngRepeat');

  var updateScope = function(scope, index, valueIdentifier, value, keyIdentifier, key, arrayLength) {
    // TODO(perf): generate setters to shave off ~40ms or 1-1.5%
    scope[valueIdentifier] = value;
    if (keyIdentifier) scope[keyIdentifier] = key;
    scope.$index = index;
    scope.$first = (index === 0);
    scope.$last = (index === (arrayLength - 1));
    scope.$middle = !(scope.$first || scope.$last);
    // eslint-disable-next-line no-bitwise
    scope.$odd = !(scope.$even = (index & 1) === 0);
  };

  var getBlockStart = function(block) {
    return block.clone[0];
  };

  var getBlockEnd = function(block) {
    return block.clone[block.clone.length - 1];
  };

  var trackByIdArrayFn = function($scope, key, value) {
    return hashKey(value);
  };

  var trackByIdObjFn = function($scope, key) {
    return key;
  };

  return {
    restrict: 'A',
    multiElement: true,
    transclude: 'element',
    priority: 1000,
    terminal: true,
    $$tlb: true,
    compile: function ngRepeatCompile($element, $attr) {
      var expression = $attr.ngRepeat;
      var ngRepeatEndComment = $compile.$$createComment('end ngRepeat', expression);

      var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);

      if (!match) {
        throw ngRepeatMinErr('iexp', 'Expected expression in form of \'_item_ in _collection_[ track by _id_]\' but got \'{0}\'.',
            expression);
      }

      var lhs = match[1];
      var rhs = match[2];
      var aliasAs = match[3];
      var trackByExp = match[4];

      match = lhs.match(/^(?:(\s*[$\w]+)|\(\s*([$\w]+)\s*,\s*([$\w]+)\s*\))$/);

      if (!match) {
        throw ngRepeatMinErr('iidexp', '\'_item_\' in \'_item_ in _collection_\' should be an identifier or \'(_key_, _value_)\' expression, but got \'{0}\'.',
            lhs);
      }
      var valueIdentifier = match[3] || match[1];
      var keyIdentifier = match[2];

      if (aliasAs && (!/^[$a-zA-Z_][$a-zA-Z0-9_]*$/.test(aliasAs) ||
          /^(null|undefined|this|\$index|\$first|\$middle|\$last|\$even|\$odd|\$parent|\$root|\$id)$/.test(aliasAs))) {
        throw ngRepeatMinErr('badident', 'alias \'{0}\' is invalid --- must be a valid JS identifier which is not a reserved name.',
          aliasAs);
      }

      var trackByIdExpFn;

      if (trackByExp) {
        var hashFnLocals = {$id: hashKey};
        var trackByExpGetter = $parse(trackByExp);

        trackByIdExpFn = function($scope, key, value, index) {
          // assign key, value, and $index to the locals so that they can be used in hash functions
          if (keyIdentifier) hashFnLocals[keyIdentifier] = key;
          hashFnLocals[valueIdentifier] = value;
          hashFnLocals.$index = index;
          return trackByExpGetter($scope, hashFnLocals);
        };
      }

      return function ngRepeatLink($scope, $element, $attr, ctrl, $transclude) {

        // Store a list of elements from previous run. This is a hash where key is the item from the
        // iterator, and the value is objects with following properties.
        //   - scope: bound scope
        //   - clone: previous element.
        //   - index: position
        //
        // We are using no-proto object so that we don't need to guard against inherited props via
        // hasOwnProperty.
        var lastBlockMap = createMap();

        //watch props
        $scope.$watchCollection(rhs, function ngRepeatAction(collection) {
          var index, length,
              previousNode = $element[0],     // node that cloned nodes should be inserted after
                                              // initialized to the comment node anchor
              nextNode,
              // Same as lastBlockMap but it has the current state. It will become the
              // lastBlockMap on the next iteration.
              nextBlockMap = createMap(),
              collectionLength,
              key, value, // key/value of iteration
              trackById,
              trackByIdFn,
              collectionKeys,
              block,       // last object information {scope, element, id}
              nextBlockOrder,
              elementsToRemove;

          if (aliasAs) {
            $scope[aliasAs] = collection;
          }

          if (isArrayLike(collection)) {
            collectionKeys = collection;
            trackByIdFn = trackByIdExpFn || trackByIdArrayFn;
          } else {
            trackByIdFn = trackByIdExpFn || trackByIdObjFn;
            // if object, extract keys, in enumeration order, unsorted
            collectionKeys = [];
            for (var itemKey in collection) {
              if (hasOwnProperty.call(collection, itemKey) && itemKey.charAt(0) !== '$') {
                collectionKeys.push(itemKey);
              }
            }
          }

          collectionLength = collectionKeys.length;
          nextBlockOrder = new Array(collectionLength);

          // locate existing items
          for (index = 0; index < collectionLength; index++) {
            key = (collection === collectionKeys) ? index : collectionKeys[index];
            value = collection[key];
            trackById = trackByIdFn($scope, key, value, index);
            if (lastBlockMap[trackById]) {
              // found previously seen block
              block = lastBlockMap[trackById];
              delete lastBlockMap[trackById];
              nextBlockMap[trackById] = block;
              nextBlockOrder[index] = block;
            } else if (nextBlockMap[trackById]) {
              // if collision detected. restore lastBlockMap and throw an error
              forEach(nextBlockOrder, function(block) {
                if (block && block.scope) lastBlockMap[block.id] = block;
              });
              throw ngRepeatMinErr('dupes',
                  'Duplicates in a repeater are not allowed. Use \'track by\' expression to specify unique keys. Repeater: {0}, Duplicate key: {1}, Duplicate value: {2}',
                  expression, trackById, value);
            } else {
              // new never before seen block
              nextBlockOrder[index] = {id: trackById, scope: undefined, clone: undefined};
              nextBlockMap[trackById] = true;
            }
          }

          // Clear the value property from the hashFnLocals object to prevent a reference to the last value
          // being leaked into the ngRepeatCompile function scope
          if (hashFnLocals) {
            hashFnLocals[valueIdentifier] = undefined;
          }

          // remove leftover items
          for (var blockKey in lastBlockMap) {
            block = lastBlockMap[blockKey];
            elementsToRemove = getBlockNodes(block.clone);
            $animate.leave(elementsToRemove);
            if (elementsToRemove[0].parentNode) {
              // if the element was not removed yet because of pending animation, mark it as deleted
              // so that we can ignore it later
              for (index = 0, length = elementsToRemove.length; index < length; index++) {
                elementsToRemove[index][NG_REMOVED] = true;
              }
            }
            block.scope.$destroy();
          }

          // we are not using forEach for perf reasons (trying to avoid #call)
          for (index = 0; index < collectionLength; index++) {
            key = (collection === collectionKeys) ? index : collectionKeys[index];
            value = collection[key];
            block = nextBlockOrder[index];

            if (block.scope) {
              // if we have already seen this object, then we need to reuse the
              // associated scope/element

              nextNode = previousNode;

              // skip nodes that are already pending removal via leave animation
              do {
                nextNode = nextNode.nextSibling;
              } while (nextNode && nextNode[NG_REMOVED]);

              if (getBlockStart(block) !== nextNode) {
                // existing item which got moved
                $animate.move(getBlockNodes(block.clone), null, previousNode);
              }
              previousNode = getBlockEnd(block);
              updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
            } else {
              // new item which we don't know about
              $transclude(function ngRepeatTransclude(clone, scope) {
                block.scope = scope;
                // http://jsperf.com/clone-vs-createcomment
                var endNode = ngRepeatEndComment.cloneNode(false);
                clone[clone.length++] = endNode;

                $animate.enter(clone, null, previousNode);
                previousNode = endNode;
                // Note: We only need the first/last node of the cloned nodes.
                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
                // by a directive with templateUrl when its template arrives.
                block.clone = clone;
                nextBlockMap[block.id] = block;
                updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
              });
            }
          }
          lastBlockMap = nextBlockMap;
        });
      };
    }
  };
}];

var NG_HIDE_CLASS = 'ng-hide';
var NG_HIDE_IN_PROGRESS_CLASS = 'ng-hide-animate';
/**
 * @ngdoc directive
 * @name ngShow
 * @multiElement
 *
 * @description
 * The `ngShow` directive shows or hides the given HTML element based on the expression provided to
 * the `ngShow` attribute.
 *
 * The element is shown or hidden by removing or adding the `.ng-hide` CSS class onto the element.
 * The `.ng-hide` CSS class is predefined in AngularJS and sets the display style to none (using an
 * `!important` flag). For CSP mode please add `angular-csp.css` to your HTML file (see
 * {@link ng.directive:ngCsp ngCsp}).
 *
 * ```html
 * <!-- when $scope.myValue is truthy (element is visible) -->
 * <div ng-show="myValue"></div>
 *
 * <!-- when $scope.myValue is falsy (element is hidden) -->
 * <div ng-show="myValue" class="ng-hide"></div>
 * ```
 *
 * When the `ngShow` expression evaluates to a falsy value then the `.ng-hide` CSS class is added
 * to the class attribute on the element causing it to become hidden. When truthy, the `.ng-hide`
 * CSS class is removed from the element causing the element not to appear hidden.
 *
 * ## Why is `!important` used?
 *
 * You may be wondering why `!important` is used for the `.ng-hide` CSS class. This is because the
 * `.ng-hide` selector can be easily overridden by heavier selectors. For example, something as
 * simple as changing the display style on a HTML list item would make hidden elements appear
 * visible. This also becomes a bigger issue when dealing with CSS frameworks.
 *
 * By using `!important`, the show and hide behavior will work as expected despite any clash between
 * CSS selector specificity (when `!important` isn't used with any conflicting styles). If a
 * developer chooses to override the styling to change how to hide an element then it is just a
 * matter of using `!important` in their own CSS code.
 *
 * ### Overriding `.ng-hide`
 *
 * By default, the `.ng-hide` class will style the element with `display: none !important`. If you
 * wish to change the hide behavior with `ngShow`/`ngHide`, you can simply overwrite the styles for
 * the `.ng-hide` CSS class. Note that the selector that needs to be used is actually
 * `.ng-hide:not(.ng-hide-animate)` to cope with extra animation classes that can be added.
 *
 * ```css
 * .ng-hide:not(.ng-hide-animate) {
 *   /&#42; These are just alternative ways of hiding an element &#42;/
 *   display: block!important;
 *   position: absolute;
 *   top: -9999px;
 *   left: -9999px;
 * }
 * ```
 *
 * By default you don't need to override anything in CSS and the animations will work around the
 * display style.
 *
 * @animations
 * | Animation                                           | Occurs                                                                                                        |
 * |-----------------------------------------------------|---------------------------------------------------------------------------------------------------------------|
 * | {@link $animate#addClass addClass} `.ng-hide`       | After the `ngShow` expression evaluates to a non truthy value and just before the contents are set to hidden. |
 * | {@link $animate#removeClass removeClass} `.ng-hide` | After the `ngShow` expression evaluates to a truthy value and just before contents are set to visible.        |
 *
 * Animations in `ngShow`/`ngHide` work with the show and hide events that are triggered when the
 * directive expression is true and false. This system works like the animation system present with
 * `ngClass` except that you must also include the `!important` flag to override the display
 * property so that the elements are not actually hidden during the animation.
 *
 * ```css
 * /&#42; A working example can be found at the bottom of this page. &#42;/
 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
 *   transition: all 0.5s linear;
 * }
 *
 * .my-element.ng-hide-add { ... }
 * .my-element.ng-hide-add.ng-hide-add-active { ... }
 * .my-element.ng-hide-remove { ... }
 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
 * ```
 *
 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display property
 * to block during animation states - ngAnimate will automatically handle the style toggling for you.
 *
 * @element ANY
 * @param {expression} ngShow If the {@link guide/expression expression} is truthy/falsy then the
 *                            element is shown/hidden respectively.
 *
 * @example
 * A simple example, animating the element's opacity:
 *
  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show-simple">
    <file name="index.html">
      Show: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br />
      <div class="check-element animate-show-hide" ng-show="checked">
        I show up when your checkbox is checked.
      </div>
    </file>
    <file name="animations.css">
      .animate-show-hide.ng-hide {
        opacity: 0;
      }

      .animate-show-hide.ng-hide-add,
      .animate-show-hide.ng-hide-remove {
        transition: all linear 0.5s;
      }

      .check-element {
        border: 1px solid black;
        opacity: 1;
        padding: 10px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      it('should check ngShow', function() {
        var checkbox = element(by.model('checked'));
        var checkElem = element(by.css('.check-element'));

        expect(checkElem.isDisplayed()).toBe(false);
        checkbox.click();
        expect(checkElem.isDisplayed()).toBe(true);
      });
    </file>
  </example>
 *
 * <hr />
 * @example
 * A more complex example, featuring different show/hide animations:
 *
  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show-complex">
    <file name="index.html">
      Show: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br />
      <div class="check-element funky-show-hide" ng-show="checked">
        I show up when your checkbox is checked.
      </div>
    </file>
    <file name="animations.css">
      body {
        overflow: hidden;
        perspective: 1000px;
      }

      .funky-show-hide.ng-hide-add {
        transform: rotateZ(0);
        transform-origin: right;
        transition: all 0.5s ease-in-out;
      }

      .funky-show-hide.ng-hide-add.ng-hide-add-active {
        transform: rotateZ(-135deg);
      }

      .funky-show-hide.ng-hide-remove {
        transform: rotateY(90deg);
        transform-origin: left;
        transition: all 0.5s ease;
      }

      .funky-show-hide.ng-hide-remove.ng-hide-remove-active {
        transform: rotateY(0);
      }

      .check-element {
        border: 1px solid black;
        opacity: 1;
        padding: 10px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      it('should check ngShow', function() {
        var checkbox = element(by.model('checked'));
        var checkElem = element(by.css('.check-element'));

        expect(checkElem.isDisplayed()).toBe(false);
        checkbox.click();
        expect(checkElem.isDisplayed()).toBe(true);
      });
    </file>
  </example>
 *
 * @knownIssue
 *
 * ### Flickering when using ngShow to toggle between elements
 *
 * When using {@link ngShow} and / or {@link ngHide} to toggle between elements, it can
 * happen that both the element to show and the element to hide are visible for a very short time.
 *
 * This usually happens when the {@link ngAnimate ngAnimate module} is included, but no actual animations
 * are defined for {@link ngShow} / {@link ngHide}. Internet Explorer is affected more often than
 * other browsers.
 *
 * There are several way to mitigate this problem:
 *
 * - {@link guide/animations#how-to-selectively-enable-disable-and-skip-animations Disable animations on the affected elements}.
 * - Use {@link ngIf} or {@link ngSwitch} instead of {@link ngShow} / {@link ngHide}.
 * - Use the special CSS selector `ng-hide.ng-hide-animate` to set `{display: none}` or similar on the affected elements.
 * - Use `ng-class="{'ng-hide': expression}` instead of instead of {@link ngShow} / {@link ngHide}.
 * - Define an animation on the affected elements.
 */
var ngShowDirective = ['$animate', function($animate) {
  return {
    restrict: 'A',
    multiElement: true,
    link: function(scope, element, attr) {
      scope.$watch(attr.ngShow, function ngShowWatchAction(value) {
        // we're adding a temporary, animation-specific class for ng-hide since this way
        // we can control when the element is actually displayed on screen without having
        // to have a global/greedy CSS selector that breaks when other animations are run.
        // Read: https://github.com/angular/angular.js/issues/9103#issuecomment-58335845
        $animate[value ? 'removeClass' : 'addClass'](element, NG_HIDE_CLASS, {
          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
        });
      });
    }
  };
}];


/**
 * @ngdoc directive
 * @name ngHide
 * @multiElement
 *
 * @description
 * The `ngHide` directive shows or hides the given HTML element based on the expression provided to
 * the `ngHide` attribute.
 *
 * The element is shown or hidden by removing or adding the `.ng-hide` CSS class onto the element.
 * The `.ng-hide` CSS class is predefined in AngularJS and sets the display style to none (using an
 * `!important` flag). For CSP mode please add `angular-csp.css` to your HTML file (see
 * {@link ng.directive:ngCsp ngCsp}).
 *
 * ```html
 * <!-- when $scope.myValue is truthy (element is hidden) -->
 * <div ng-hide="myValue" class="ng-hide"></div>
 *
 * <!-- when $scope.myValue is falsy (element is visible) -->
 * <div ng-hide="myValue"></div>
 * ```
 *
 * When the `ngHide` expression evaluates to a truthy value then the `.ng-hide` CSS class is added
 * to the class attribute on the element causing it to become hidden. When falsy, the `.ng-hide`
 * CSS class is removed from the element causing the element not to appear hidden.
 *
 * ## Why is `!important` used?
 *
 * You may be wondering why `!important` is used for the `.ng-hide` CSS class. This is because the
 * `.ng-hide` selector can be easily overridden by heavier selectors. For example, something as
 * simple as changing the display style on a HTML list item would make hidden elements appear
 * visible. This also becomes a bigger issue when dealing with CSS frameworks.
 *
 * By using `!important`, the show and hide behavior will work as expected despite any clash between
 * CSS selector specificity (when `!important` isn't used with any conflicting styles). If a
 * developer chooses to override the styling to change how to hide an element then it is just a
 * matter of using `!important` in their own CSS code.
 *
 * ### Overriding `.ng-hide`
 *
 * By default, the `.ng-hide` class will style the element with `display: none !important`. If you
 * wish to change the hide behavior with `ngShow`/`ngHide`, you can simply overwrite the styles for
 * the `.ng-hide` CSS class. Note that the selector that needs to be used is actually
 * `.ng-hide:not(.ng-hide-animate)` to cope with extra animation classes that can be added.
 *
 * ```css
 * .ng-hide:not(.ng-hide-animate) {
 *   /&#42; These are just alternative ways of hiding an element &#42;/
 *   display: block!important;
 *   position: absolute;
 *   top: -9999px;
 *   left: -9999px;
 * }
 * ```
 *
 * By default you don't need to override in CSS anything and the animations will work around the
 * display style.
 *
 * @animations
 * | Animation                                           | Occurs                                                                                                     |
 * |-----------------------------------------------------|------------------------------------------------------------------------------------------------------------|
 * | {@link $animate#addClass addClass} `.ng-hide`       | After the `ngHide` expression evaluates to a truthy value and just before the contents are set to hidden.  |
 * | {@link $animate#removeClass removeClass} `.ng-hide` | After the `ngHide` expression evaluates to a non truthy value and just before contents are set to visible. |
 *
 * Animations in `ngShow`/`ngHide` work with the show and hide events that are triggered when the
 * directive expression is true and false. This system works like the animation system present with
 * `ngClass` except that you must also include the `!important` flag to override the display
 * property so that the elements are not actually hidden during the animation.
 *
 * ```css
 * /&#42; A working example can be found at the bottom of this page. &#42;/
 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
 *   transition: all 0.5s linear;
 * }
 *
 * .my-element.ng-hide-add { ... }
 * .my-element.ng-hide-add.ng-hide-add-active { ... }
 * .my-element.ng-hide-remove { ... }
 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
 * ```
 *
 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display property
 * to block during animation states - ngAnimate will automatically handle the style toggling for you.
 *
 * @element ANY
 * @param {expression} ngHide If the {@link guide/expression expression} is truthy/falsy then the
 *                            element is hidden/shown respectively.
 *
 * @example
 * A simple example, animating the element's opacity:
 *
  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide-simple">
    <file name="index.html">
      Hide: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br />
      <div class="check-element animate-show-hide" ng-hide="checked">
        I hide when your checkbox is checked.
      </div>
    </file>
    <file name="animations.css">
      .animate-show-hide.ng-hide {
        opacity: 0;
      }

      .animate-show-hide.ng-hide-add,
      .animate-show-hide.ng-hide-remove {
        transition: all linear 0.5s;
      }

      .check-element {
        border: 1px solid black;
        opacity: 1;
        padding: 10px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      it('should check ngHide', function() {
        var checkbox = element(by.model('checked'));
        var checkElem = element(by.css('.check-element'));

        expect(checkElem.isDisplayed()).toBe(true);
        checkbox.click();
        expect(checkElem.isDisplayed()).toBe(false);
      });
    </file>
  </example>
 *
 * <hr />
 * @example
 * A more complex example, featuring different show/hide animations:
 *
  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide-complex">
    <file name="index.html">
      Hide: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br />
      <div class="check-element funky-show-hide" ng-hide="checked">
        I hide when your checkbox is checked.
      </div>
    </file>
    <file name="animations.css">
      body {
        overflow: hidden;
        perspective: 1000px;
      }

      .funky-show-hide.ng-hide-add {
        transform: rotateZ(0);
        transform-origin: right;
        transition: all 0.5s ease-in-out;
      }

      .funky-show-hide.ng-hide-add.ng-hide-add-active {
        transform: rotateZ(-135deg);
      }

      .funky-show-hide.ng-hide-remove {
        transform: rotateY(90deg);
        transform-origin: left;
        transition: all 0.5s ease;
      }

      .funky-show-hide.ng-hide-remove.ng-hide-remove-active {
        transform: rotateY(0);
      }

      .check-element {
        border: 1px solid black;
        opacity: 1;
        padding: 10px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      it('should check ngHide', function() {
        var checkbox = element(by.model('checked'));
        var checkElem = element(by.css('.check-element'));

        expect(checkElem.isDisplayed()).toBe(true);
        checkbox.click();
        expect(checkElem.isDisplayed()).toBe(false);
      });
    </file>
  </example>
 *
 * @knownIssue
 *
 * ### Flickering when using ngHide to toggle between elements
 *
 * When using {@link ngShow} and / or {@link ngHide} to toggle between elements, it can
 * happen that both the element to show and the element to hide are visible for a very short time.
 *
 * This usually happens when the {@link ngAnimate ngAnimate module} is included, but no actual animations
 * are defined for {@link ngShow} / {@link ngHide}. Internet Explorer is affected more often than
 * other browsers.
 *
 * There are several way to mitigate this problem:
 *
 * - {@link guide/animations#how-to-selectively-enable-disable-and-skip-animations Disable animations on the affected elements}.
 * - Use {@link ngIf} or {@link ngSwitch} instead of {@link ngShow} / {@link ngHide}.
 * - Use the special CSS selector `ng-hide.ng-hide-animate` to set `{display: none}` or similar on the affected elements.
 * - Use `ng-class="{'ng-hide': expression}` instead of instead of {@link ngShow} / {@link ngHide}.
 * - Define an animation on the affected elements.
 */
var ngHideDirective = ['$animate', function($animate) {
  return {
    restrict: 'A',
    multiElement: true,
    link: function(scope, element, attr) {
      scope.$watch(attr.ngHide, function ngHideWatchAction(value) {
        // The comment inside of the ngShowDirective explains why we add and
        // remove a temporary class for the show/hide animation
        $animate[value ? 'addClass' : 'removeClass'](element,NG_HIDE_CLASS, {
          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
        });
      });
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngStyle
 * @restrict AC
 *
 * @description
 * The `ngStyle` directive allows you to set CSS style on an HTML element conditionally.
 *
 * @knownIssue
 * You should not use {@link guide/interpolation interpolation} in the value of the `style`
 * attribute, when using the `ngStyle` directive on the same element.
 * See {@link guide/interpolation#known-issues here} for more info.
 *
 * @element ANY
 * @param {expression} ngStyle
 *
 * {@link guide/expression Expression} which evals to an
 * object whose keys are CSS style names and values are corresponding values for those CSS
 * keys.
 *
 * Since some CSS style names are not valid keys for an object, they must be quoted.
 * See the 'background-color' style in the example below.
 *
 * @example
   <example name="ng-style">
     <file name="index.html">
        <input type="button" value="set color" ng-click="myStyle={color:'red'}">
        <input type="button" value="set background" ng-click="myStyle={'background-color':'blue'}">
        <input type="button" value="clear" ng-click="myStyle={}">
        <br/>
        <span ng-style="myStyle">Sample Text</span>
        <pre>myStyle={{myStyle}}</pre>
     </file>
     <file name="style.css">
       span {
         color: black;
       }
     </file>
     <file name="protractor.js" type="protractor">
       var colorSpan = element(by.css('span'));

       it('should check ng-style', function() {
         expect(colorSpan.getCssValue('color')).toMatch(/rgba\(0, 0, 0, 1\)|rgb\(0, 0, 0\)/);
         element(by.css('input[value=\'set color\']')).click();
         expect(colorSpan.getCssValue('color')).toMatch(/rgba\(255, 0, 0, 1\)|rgb\(255, 0, 0\)/);
         element(by.css('input[value=clear]')).click();
         expect(colorSpan.getCssValue('color')).toMatch(/rgba\(0, 0, 0, 1\)|rgb\(0, 0, 0\)/);
       });
     </file>
   </example>
 */
var ngStyleDirective = ngDirective(function(scope, element, attr) {
  scope.$watchCollection(attr.ngStyle, function ngStyleWatchAction(newStyles, oldStyles) {
    if (oldStyles && (newStyles !== oldStyles)) {
      forEach(oldStyles, function(val, style) { element.css(style, ''); });
    }
    if (newStyles) element.css(newStyles);
  });
});

/**
 * @ngdoc directive
 * @name ngSwitch
 * @restrict EA
 *
 * @description
 * The `ngSwitch` directive is used to conditionally swap DOM structure on your template based on a scope expression.
 * Elements within `ngSwitch` but without `ngSwitchWhen` or `ngSwitchDefault` directives will be preserved at the location
 * as specified in the template.
 *
 * The directive itself works similar to ngInclude, however, instead of downloading template code (or loading it
 * from the template cache), `ngSwitch` simply chooses one of the nested elements and makes it visible based on which element
 * matches the value obtained from the evaluated expression. In other words, you define a container element
 * (where you place the directive), place an expression on the **`on="..."` attribute**
 * (or the **`ng-switch="..."` attribute**), define any inner elements inside of the directive and place
 * a when attribute per element. The when attribute is used to inform ngSwitch which element to display when the on
 * expression is evaluated. If a matching expression is not found via a when attribute then an element with the default
 * attribute is displayed.
 *
 * <div class="alert alert-info">
 * Be aware that the attribute values to match against cannot be expressions. They are interpreted
 * as literal string values to match against.
 * For example, **`ng-switch-when="someVal"`** will match against the string `"someVal"` not against the
 * value of the expression `$scope.someVal`.
 * </div>

 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#enter enter}  | after the ngSwitch contents change and the matched child element is placed inside the container |
 * | {@link ng.$animate#leave leave}  | after the ngSwitch contents change and just before the former contents are removed from the DOM |
 *
 * @usage
 *
 * ```
 * <ANY ng-switch="expression">
 *   <ANY ng-switch-when="matchValue1">...</ANY>
 *   <ANY ng-switch-when="matchValue2">...</ANY>
 *   <ANY ng-switch-default>...</ANY>
 * </ANY>
 * ```
 *
 *
 * @scope
 * @priority 1200
 * @param {*} ngSwitch|on expression to match against <code>ng-switch-when</code>.
 * On child elements add:
 *
 * * `ngSwitchWhen`: the case statement to match against. If match then this
 *   case will be displayed. If the same match appears multiple times, all the
 *   elements will be displayed. It is possible to associate multiple values to
 *   the same `ngSwitchWhen` by defining the optional attribute
 *   `ngSwitchWhenSeparator`. The separator will be used to split the value of
 *   the `ngSwitchWhen` attribute into multiple tokens, and the element will show
 *   if any of the `ngSwitch` evaluates to any of these tokens.
 * * `ngSwitchDefault`: the default case when no other case match. If there
 *   are multiple default cases, all of them will be displayed when no other
 *   case match.
 *
 *
 * @example
  <example module="switchExample" deps="angular-animate.js" animations="true" name="ng-switch">
    <file name="index.html">
      <div ng-controller="ExampleController">
        <select ng-model="selection" ng-options="item for item in items">
        </select>
        <code>selection={{selection}}</code>
        <hr/>
        <div class="animate-switch-container"
          ng-switch on="selection">
            <div class="animate-switch" ng-switch-when="settings|options" ng-switch-when-separator="|">Settings Div</div>
            <div class="animate-switch" ng-switch-when="home">Home Span</div>
            <div class="animate-switch" ng-switch-default>default</div>
        </div>
      </div>
    </file>
    <file name="script.js">
      angular.module('switchExample', ['ngAnimate'])
        .controller('ExampleController', ['$scope', function($scope) {
          $scope.items = ['settings', 'home', 'options', 'other'];
          $scope.selection = $scope.items[0];
        }]);
    </file>
    <file name="animations.css">
      .animate-switch-container {
        position:relative;
        background:white;
        border:1px solid black;
        height:40px;
        overflow:hidden;
      }

      .animate-switch {
        padding:10px;
      }

      .animate-switch.ng-animate {
        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;

        position:absolute;
        top:0;
        left:0;
        right:0;
        bottom:0;
      }

      .animate-switch.ng-leave.ng-leave-active,
      .animate-switch.ng-enter {
        top:-50px;
      }
      .animate-switch.ng-leave,
      .animate-switch.ng-enter.ng-enter-active {
        top:0;
      }
    </file>
    <file name="protractor.js" type="protractor">
      var switchElem = element(by.css('[ng-switch]'));
      var select = element(by.model('selection'));

      it('should start in settings', function() {
        expect(switchElem.getText()).toMatch(/Settings Div/);
      });
      it('should change to home', function() {
        select.all(by.css('option')).get(1).click();
        expect(switchElem.getText()).toMatch(/Home Span/);
      });
      it('should change to settings via "options"', function() {
        select.all(by.css('option')).get(2).click();
        expect(switchElem.getText()).toMatch(/Settings Div/);
      });
      it('should select default', function() {
        select.all(by.css('option')).get(3).click();
        expect(switchElem.getText()).toMatch(/default/);
      });
    </file>
  </example>
 */
var ngSwitchDirective = ['$animate', '$compile', function($animate, $compile) {
  return {
    require: 'ngSwitch',

    // asks for $scope to fool the BC controller module
    controller: ['$scope', function NgSwitchController() {
     this.cases = {};
    }],
    link: function(scope, element, attr, ngSwitchController) {
      var watchExpr = attr.ngSwitch || attr.on,
          selectedTranscludes = [],
          selectedElements = [],
          previousLeaveAnimations = [],
          selectedScopes = [];

      var spliceFactory = function(array, index) {
          return function(response) {
            if (response !== false) array.splice(index, 1);
          };
      };

      scope.$watch(watchExpr, function ngSwitchWatchAction(value) {
        var i, ii;

        // Start with the last, in case the array is modified during the loop
        while (previousLeaveAnimations.length) {
          $animate.cancel(previousLeaveAnimations.pop());
        }

        for (i = 0, ii = selectedScopes.length; i < ii; ++i) {
          var selected = getBlockNodes(selectedElements[i].clone);
          selectedScopes[i].$destroy();
          var runner = previousLeaveAnimations[i] = $animate.leave(selected);
          runner.done(spliceFactory(previousLeaveAnimations, i));
        }

        selectedElements.length = 0;
        selectedScopes.length = 0;

        if ((selectedTranscludes = ngSwitchController.cases['!' + value] || ngSwitchController.cases['?'])) {
          forEach(selectedTranscludes, function(selectedTransclude) {
            selectedTransclude.transclude(function(caseElement, selectedScope) {
              selectedScopes.push(selectedScope);
              var anchor = selectedTransclude.element;
              caseElement[caseElement.length++] = $compile.$$createComment('end ngSwitchWhen');
              var block = { clone: caseElement };

              selectedElements.push(block);
              $animate.enter(caseElement, anchor.parent(), anchor);
            });
          });
        }
      });
    }
  };
}];

var ngSwitchWhenDirective = ngDirective({
  transclude: 'element',
  priority: 1200,
  require: '^ngSwitch',
  multiElement: true,
  link: function(scope, element, attrs, ctrl, $transclude) {

    var cases = attrs.ngSwitchWhen.split(attrs.ngSwitchWhenSeparator).sort().filter(
      // Filter duplicate cases
      function(element, index, array) { return array[index - 1] !== element; }
    );

    forEach(cases, function(whenCase) {
      ctrl.cases['!' + whenCase] = (ctrl.cases['!' + whenCase] || []);
      ctrl.cases['!' + whenCase].push({ transclude: $transclude, element: element });
    });
  }
});

var ngSwitchDefaultDirective = ngDirective({
  transclude: 'element',
  priority: 1200,
  require: '^ngSwitch',
  multiElement: true,
  link: function(scope, element, attr, ctrl, $transclude) {
    ctrl.cases['?'] = (ctrl.cases['?'] || []);
    ctrl.cases['?'].push({ transclude: $transclude, element: element });
   }
});

/**
 * @ngdoc directive
 * @name ngTransclude
 * @restrict EAC
 *
 * @description
 * Directive that marks the insertion point for the transcluded DOM of the nearest parent directive that uses transclusion.
 *
 * You can specify that you want to insert a named transclusion slot, instead of the default slot, by providing the slot name
 * as the value of the `ng-transclude` or `ng-transclude-slot` attribute.
 *
 * If the transcluded content is not empty (i.e. contains one or more DOM nodes, including whitespace text nodes), any existing
 * content of this element will be removed before the transcluded content is inserted.
 * If the transcluded content is empty (or only whitespace), the existing content is left intact. This lets you provide fallback
 * content in the case that no transcluded content is provided.
 *
 * @element ANY
 *
 * @param {string} ngTransclude|ngTranscludeSlot the name of the slot to insert at this point. If this is not provided, is empty
 *                                               or its value is the same as the name of the attribute then the default slot is used.
 *
 * @example
 * ### Basic transclusion
 * This example demonstrates basic transclusion of content into a component directive.
 * <example name="simpleTranscludeExample" module="transcludeExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('transcludeExample', [])
 *        .directive('pane', function(){
 *           return {
 *             restrict: 'E',
 *             transclude: true,
 *             scope: { title:'@' },
 *             template: '<div style="border: 1px solid black;">' +
 *                         '<div style="background-color: gray">{{title}}</div>' +
 *                         '<ng-transclude></ng-transclude>' +
 *                       '</div>'
 *           };
 *       })
 *       .controller('ExampleController', ['$scope', function($scope) {
 *         $scope.title = 'Lorem Ipsum';
 *         $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
 *       }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <input ng-model="title" aria-label="title"> <br/>
 *       <textarea ng-model="text" aria-label="text"></textarea> <br/>
 *       <pane title="{{title}}"><span>{{text}}</span></pane>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *      it('should have transcluded', function() {
 *        var titleElement = element(by.model('title'));
 *        titleElement.clear();
 *        titleElement.sendKeys('TITLE');
 *        var textElement = element(by.model('text'));
 *        textElement.clear();
 *        textElement.sendKeys('TEXT');
 *        expect(element(by.binding('title')).getText()).toEqual('TITLE');
 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
 *      });
 *   </file>
 * </example>
 *
 * @example
 * ### Transclude fallback content
 * This example shows how to use `NgTransclude` with fallback content, that
 * is displayed if no transcluded content is provided.
 *
 * <example module="transcludeFallbackContentExample" name="ng-transclude">
 * <file name="index.html">
 * <script>
 * angular.module('transcludeFallbackContentExample', [])
 * .directive('myButton', function(){
 *             return {
 *               restrict: 'E',
 *               transclude: true,
 *               scope: true,
 *               template: '<button style="cursor: pointer;">' +
 *                           '<ng-transclude>' +
 *                             '<b style="color: red;">Button1</b>' +
 *                           '</ng-transclude>' +
 *                         '</button>'
 *             };
 *         });
 * </script>
 * <!-- fallback button content -->
 * <my-button id="fallback"></my-button>
 * <!-- modified button content -->
 * <my-button id="modified">
 *   <i style="color: green;">Button2</i>
 * </my-button>
 * </file>
 * <file name="protractor.js" type="protractor">
 * it('should have different transclude element content', function() {
 *          expect(element(by.id('fallback')).getText()).toBe('Button1');
 *          expect(element(by.id('modified')).getText()).toBe('Button2');
 *        });
 * </file>
 * </example>
 *
 * @example
 * ### Multi-slot transclusion
 * This example demonstrates using multi-slot transclusion in a component directive.
 * <example name="multiSlotTranscludeExample" module="multiSlotTranscludeExample">
 *   <file name="index.html">
 *    <style>
 *      .title, .footer {
 *        background-color: gray
 *      }
 *    </style>
 *    <div ng-controller="ExampleController">
 *      <input ng-model="title" aria-label="title"> <br/>
 *      <textarea ng-model="text" aria-label="text"></textarea> <br/>
 *      <pane>
 *        <pane-title><a ng-href="{{link}}">{{title}}</a></pane-title>
 *        <pane-body><p>{{text}}</p></pane-body>
 *      </pane>
 *    </div>
 *   </file>
 *   <file name="app.js">
 *    angular.module('multiSlotTranscludeExample', [])
 *     .directive('pane', function() {
 *        return {
 *          restrict: 'E',
 *          transclude: {
 *            'title': '?paneTitle',
 *            'body': 'paneBody',
 *            'footer': '?paneFooter'
 *          },
 *          template: '<div style="border: 1px solid black;">' +
 *                      '<div class="title" ng-transclude="title">Fallback Title</div>' +
 *                      '<div ng-transclude="body"></div>' +
 *                      '<div class="footer" ng-transclude="footer">Fallback Footer</div>' +
 *                    '</div>'
 *        };
 *    })
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.title = 'Lorem Ipsum';
 *      $scope.link = 'https://google.com';
 *      $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
 *    }]);
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *      it('should have transcluded the title and the body', function() {
 *        var titleElement = element(by.model('title'));
 *        titleElement.clear();
 *        titleElement.sendKeys('TITLE');
 *        var textElement = element(by.model('text'));
 *        textElement.clear();
 *        textElement.sendKeys('TEXT');
 *        expect(element(by.css('.title')).getText()).toEqual('TITLE');
 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
 *        expect(element(by.css('.footer')).getText()).toEqual('Fallback Footer');
 *      });
 *   </file>
 * </example>
 */
var ngTranscludeMinErr = minErr('ngTransclude');
var ngTranscludeDirective = ['$compile', function($compile) {
  return {
    restrict: 'EAC',
    compile: function ngTranscludeCompile(tElement) {

      // Remove and cache any original content to act as a fallback
      var fallbackLinkFn = $compile(tElement.contents());
      tElement.empty();

      return function ngTranscludePostLink($scope, $element, $attrs, controller, $transclude) {

        if (!$transclude) {
          throw ngTranscludeMinErr('orphan',
          'Illegal use of ngTransclude directive in the template! ' +
          'No parent directive that requires a transclusion found. ' +
          'Element: {0}',
          startingTag($element));
        }


        // If the attribute is of the form: `ng-transclude="ng-transclude"` then treat it like the default
        if ($attrs.ngTransclude === $attrs.$attr.ngTransclude) {
          $attrs.ngTransclude = '';
        }
        var slotName = $attrs.ngTransclude || $attrs.ngTranscludeSlot;

        // If the slot is required and no transclusion content is provided then this call will throw an error
        $transclude(ngTranscludeCloneAttachFn, null, slotName);

        // If the slot is optional and no transclusion content is provided then use the fallback content
        if (slotName && !$transclude.isSlotFilled(slotName)) {
          useFallbackContent();
        }

        function ngTranscludeCloneAttachFn(clone, transcludedScope) {
          if (clone.length && notWhitespace(clone)) {
            $element.append(clone);
          } else {
            useFallbackContent();
            // There is nothing linked against the transcluded scope since no content was available,
            // so it should be safe to clean up the generated scope.
            transcludedScope.$destroy();
          }
        }

        function useFallbackContent() {
          // Since this is the fallback content rather than the transcluded content,
          // we link against the scope of this directive rather than the transcluded scope
          fallbackLinkFn($scope, function(clone) {
            $element.append(clone);
          });
        }

        function notWhitespace(nodes) {
          for (var i = 0, ii = nodes.length; i < ii; i++) {
            var node = nodes[i];
            if (node.nodeType !== NODE_TYPE_TEXT || node.nodeValue.trim()) {
              return true;
            }
          }
        }
      };
    }
  };
}];

/**
 * @ngdoc directive
 * @name script
 * @restrict E
 *
 * @description
 * Load the content of a `<script>` element into {@link ng.$templateCache `$templateCache`}, so that the
 * template can be used by {@link ng.directive:ngInclude `ngInclude`},
 * {@link ngRoute.directive:ngView `ngView`}, or {@link guide/directive directives}. The type of the
 * `<script>` element must be specified as `text/ng-template`, and a cache name for the template must be
 * assigned through the element's `id`, which can then be used as a directive's `templateUrl`.
 *
 * @param {string} type Must be set to `'text/ng-template'`.
 * @param {string} id Cache name of the template.
 *
 * @example
  <example  name="script-tag">
    <file name="index.html">
      <script type="text/ng-template" id="/tpl.html">
        Content of the template.
      </script>

      <a ng-click="currentTpl='/tpl.html'" id="tpl-link">Load inlined template</a>
      <div id="tpl-content" ng-include src="currentTpl"></div>
    </file>
    <file name="protractor.js" type="protractor">
      it('should load template defined inside script tag', function() {
        element(by.css('#tpl-link')).click();
        expect(element(by.css('#tpl-content')).getText()).toMatch(/Content of the template/);
      });
    </file>
  </example>
 */
var scriptDirective = ['$templateCache', function($templateCache) {
  return {
    restrict: 'E',
    terminal: true,
    compile: function(element, attr) {
      if (attr.type === 'text/ng-template') {
        var templateUrl = attr.id,
            text = element[0].text;

        $templateCache.put(templateUrl, text);
      }
    }
  };
}];

/* exported selectDirective, optionDirective */

var noopNgModelController = { $setViewValue: noop, $render: noop };

function setOptionSelectedStatus(optionEl, value) {
  optionEl.prop('selected', value);
  /**
   * When unselecting an option, setting the property to null / false should be enough
   * However, screenreaders might react to the selected attribute instead, see
   * https://github.com/angular/angular.js/issues/14419
   * Note: "selected" is a boolean attr and will be removed when the "value" arg in attr() is false
   * or null
   */
  optionEl.attr('selected', value);
}

/**
 * @ngdoc type
 * @name  select.SelectController
 *
 * @description
 * The controller for the {@link ng.select select} directive. The controller exposes
 * a few utility methods that can be used to augment the behavior of a regular or an
 * {@link ng.ngOptions ngOptions} select element.
 *
 * @example
 * ### Set a custom error when the unknown option is selected
 *
 * This example sets a custom error "unknownValue" on the ngModelController
 * when the select element's unknown option is selected, i.e. when the model is set to a value
 * that is not matched by any option.
 *
 * <example name="select-unknown-value-error" module="staticSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="testSelect"> Single select: </label><br>
 *     <select name="testSelect" ng-model="selected" unknown-value-error>
 *       <option value="option-1">Option 1</option>
 *       <option value="option-2">Option 2</option>
 *     </select><br>
 *     <span class="error" ng-if="myForm.testSelect.$error.unknownValue">
 *       Error: The current model doesn't match any option</span><br>
 *
 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
 *   </form>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('staticSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.selected = null;
 *
 *      $scope.forceUnknownOption = function() {
 *        $scope.selected = 'nonsense';
 *      };
 *   }])
 *   .directive('unknownValueError', function() {
 *     return {
 *       require: ['ngModel', 'select'],
 *       link: function(scope, element, attrs, ctrls) {
 *         var ngModelCtrl = ctrls[0];
 *         var selectCtrl = ctrls[1];
 *
 *         ngModelCtrl.$validators.unknownValue = function(modelValue, viewValue) {
 *           if (selectCtrl.$isUnknownOptionSelected()) {
 *             return false;
 *           }
 *
 *           return true;
 *         };
 *       }
 *
 *     };
 *   });
 * </file>
 *</example>
 *
 *
 * @example
 * ### Set the "required" error when the unknown option is selected.
 *
 * By default, the "required" error on the ngModelController is only set on a required select
 * when the empty option is selected. This example adds a custom directive that also sets the
 * error when the unknown option is selected.
 *
 * <example name="select-unknown-value-required" module="staticSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="testSelect"> Select: </label><br>
 *     <select name="testSelect" ng-model="selected" required unknown-value-required>
 *       <option value="option-1">Option 1</option>
 *       <option value="option-2">Option 2</option>
 *     </select><br>
 *     <span class="error" ng-if="myForm.testSelect.$error.required">Error: Please select a value</span><br>
 *
 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
 *   </form>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('staticSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.selected = null;
 *
 *      $scope.forceUnknownOption = function() {
 *        $scope.selected = 'nonsense';
 *      };
 *   }])
 *   .directive('unknownValueRequired', function() {
 *     return {
 *       priority: 1, // This directive must run after the required directive has added its validator
 *       require: ['ngModel', 'select'],
 *       link: function(scope, element, attrs, ctrls) {
 *         var ngModelCtrl = ctrls[0];
 *         var selectCtrl = ctrls[1];
 *
 *         var originalRequiredValidator = ngModelCtrl.$validators.required;
 *
 *         ngModelCtrl.$validators.required = function() {
 *           if (attrs.required && selectCtrl.$isUnknownOptionSelected()) {
 *             return false;
 *           }
 *
 *           return originalRequiredValidator.apply(this, arguments);
 *         };
 *       }
 *     };
 *   });
 * </file>
 * <file name="protractor.js" type="protractor">
 *  it('should show the error message when the unknown option is selected', function() {

      var error = element(by.className('error'));

      expect(error.getText()).toBe('Error: Please select a value');

      element(by.cssContainingText('option', 'Option 1')).click();

      expect(error.isPresent()).toBe(false);

      element(by.tagName('button')).click();

      expect(error.getText()).toBe('Error: Please select a value');
    });
 * </file>
 *</example>
 *
 *
 */
var SelectController =
        ['$element', '$scope', /** @this */ function($element, $scope) {

  var self = this,
      optionsMap = new NgMap();

  self.selectValueMap = {}; // Keys are the hashed values, values the original values

  // If the ngModel doesn't get provided then provide a dummy noop version to prevent errors
  self.ngModelCtrl = noopNgModelController;
  self.multiple = false;

  // The "unknown" option is one that is prepended to the list if the viewValue
  // does not match any of the options. When it is rendered the value of the unknown
  // option is '? XXX ?' where XXX is the hashKey of the value that is not known.
  //
  // Support: IE 9 only
  // We can't just jqLite('<option>') since jqLite is not smart enough
  // to create it in <select> and IE barfs otherwise.
  self.unknownOption = jqLite(window.document.createElement('option'));

  // The empty option is an option with the value '' that the application developer can
  // provide inside the select. It is always selectable and indicates that a "null" selection has
  // been made by the user.
  // If the select has an empty option, and the model of the select is set to "undefined" or "null",
  // the empty option is selected.
  // If the model is set to a different unmatched value, the unknown option is rendered and
  // selected, i.e both are present, because a "null" selection and an unknown value are different.
  self.hasEmptyOption = false;
  self.emptyOption = undefined;

  self.renderUnknownOption = function(val) {
    var unknownVal = self.generateUnknownOptionValue(val);
    self.unknownOption.val(unknownVal);
    $element.prepend(self.unknownOption);
    setOptionSelectedStatus(self.unknownOption, true);
    $element.val(unknownVal);
  };

  self.updateUnknownOption = function(val) {
    var unknownVal = self.generateUnknownOptionValue(val);
    self.unknownOption.val(unknownVal);
    setOptionSelectedStatus(self.unknownOption, true);
    $element.val(unknownVal);
  };

  self.generateUnknownOptionValue = function(val) {
    return '? ' + hashKey(val) + ' ?';
  };

  self.removeUnknownOption = function() {
    if (self.unknownOption.parent()) self.unknownOption.remove();
  };

  self.selectEmptyOption = function() {
    if (self.emptyOption) {
      $element.val('');
      setOptionSelectedStatus(self.emptyOption, true);
    }
  };

  self.unselectEmptyOption = function() {
    if (self.hasEmptyOption) {
      setOptionSelectedStatus(self.emptyOption, false);
    }
  };

  $scope.$on('$destroy', function() {
    // disable unknown option so that we don't do work when the whole select is being destroyed
    self.renderUnknownOption = noop;
  });

  // Read the value of the select control, the implementation of this changes depending
  // upon whether the select can have multiple values and whether ngOptions is at work.
  self.readValue = function readSingleValue() {
    var val = $element.val();
    // ngValue added option values are stored in the selectValueMap, normal interpolations are not
    var realVal = val in self.selectValueMap ? self.selectValueMap[val] : val;

    if (self.hasOption(realVal)) {
      return realVal;
    }

    return null;
  };


  // Write the value to the select control, the implementation of this changes depending
  // upon whether the select can have multiple values and whether ngOptions is at work.
  self.writeValue = function writeSingleValue(value) {
    // Make sure to remove the selected attribute from the previously selected option
    // Otherwise, screen readers might get confused
    var currentlySelectedOption = $element[0].options[$element[0].selectedIndex];
    if (currentlySelectedOption) setOptionSelectedStatus(jqLite(currentlySelectedOption), false);

    if (self.hasOption(value)) {
      self.removeUnknownOption();

      var hashedVal = hashKey(value);
      $element.val(hashedVal in self.selectValueMap ? hashedVal : value);

      // Set selected attribute and property on selected option for screen readers
      var selectedOption = $element[0].options[$element[0].selectedIndex];
      setOptionSelectedStatus(jqLite(selectedOption), true);
    } else {
      self.selectUnknownOrEmptyOption(value);
    }
  };


  // Tell the select control that an option, with the given value, has been added
  self.addOption = function(value, element) {
    // Skip comment nodes, as they only pollute the `optionsMap`
    if (element[0].nodeType === NODE_TYPE_COMMENT) return;

    assertNotHasOwnProperty(value, '"option value"');
    if (value === '') {
      self.hasEmptyOption = true;
      self.emptyOption = element;
    }
    var count = optionsMap.get(value) || 0;
    optionsMap.set(value, count + 1);
    // Only render at the end of a digest. This improves render performance when many options
    // are added during a digest and ensures all relevant options are correctly marked as selected
    scheduleRender();
  };

  // Tell the select control that an option, with the given value, has been removed
  self.removeOption = function(value) {
    var count = optionsMap.get(value);
    if (count) {
      if (count === 1) {
        optionsMap.delete(value);
        if (value === '') {
          self.hasEmptyOption = false;
          self.emptyOption = undefined;
        }
      } else {
        optionsMap.set(value, count - 1);
      }
    }
  };

  // Check whether the select control has an option matching the given value
  self.hasOption = function(value) {
    return !!optionsMap.get(value);
  };

  /**
   * @ngdoc method
   * @name select.SelectController#$hasEmptyOption
   *
   * @description
   *
   * Returns `true` if the select element currently has an empty option
   * element, i.e. an option that signifies that the select is empty / the selection is null.
   *
   */
  self.$hasEmptyOption = function() {
    return self.hasEmptyOption;
  };

  /**
   * @ngdoc method
   * @name select.SelectController#$isUnknownOptionSelected
   *
   * @description
   *
   * Returns `true` if the select element's unknown option is selected. The unknown option is added
   * and automatically selected whenever the select model doesn't match any option.
   *
   */
  self.$isUnknownOptionSelected = function() {
    // Presence of the unknown option means it is selected
    return $element[0].options[0] === self.unknownOption[0];
  };

  /**
   * @ngdoc method
   * @name select.SelectController#$isEmptyOptionSelected
   *
   * @description
   *
   * Returns `true` if the select element has an empty option and this empty option is currently
   * selected. Returns `false` if the select element has no empty option or it is not selected.
   *
   */
  self.$isEmptyOptionSelected = function() {
    return self.hasEmptyOption && $element[0].options[$element[0].selectedIndex] === self.emptyOption[0];
  };

  self.selectUnknownOrEmptyOption = function(value) {
    if (value == null && self.emptyOption) {
      self.removeUnknownOption();
      self.selectEmptyOption();
    } else if (self.unknownOption.parent().length) {
      self.updateUnknownOption(value);
    } else {
      self.renderUnknownOption(value);
    }
  };

  var renderScheduled = false;
  function scheduleRender() {
    if (renderScheduled) return;
    renderScheduled = true;
    $scope.$$postDigest(function() {
      renderScheduled = false;
      self.ngModelCtrl.$render();
    });
  }

  var updateScheduled = false;
  function scheduleViewValueUpdate(renderAfter) {
    if (updateScheduled) return;

    updateScheduled = true;

    $scope.$$postDigest(function() {
      if ($scope.$$destroyed) return;

      updateScheduled = false;
      self.ngModelCtrl.$setViewValue(self.readValue());
      if (renderAfter) self.ngModelCtrl.$render();
    });
  }


  self.registerOption = function(optionScope, optionElement, optionAttrs, interpolateValueFn, interpolateTextFn) {

    if (optionAttrs.$attr.ngValue) {
      // The value attribute is set by ngValue
      var oldVal, hashedVal;
      optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {

        var removal;
        var previouslySelected = optionElement.prop('selected');

        if (isDefined(hashedVal)) {
          self.removeOption(oldVal);
          delete self.selectValueMap[hashedVal];
          removal = true;
        }

        hashedVal = hashKey(newVal);
        oldVal = newVal;
        self.selectValueMap[hashedVal] = newVal;
        self.addOption(newVal, optionElement);
        // Set the attribute directly instead of using optionAttrs.$set - this stops the observer
        // from firing a second time. Other $observers on value will also get the result of the
        // ngValue expression, not the hashed value
        optionElement.attr('value', hashedVal);

        if (removal && previouslySelected) {
          scheduleViewValueUpdate();
        }

      });
    } else if (interpolateValueFn) {
      // The value attribute is interpolated
      optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {
        // This method is overwritten in ngOptions and has side-effects!
        self.readValue();

        var removal;
        var previouslySelected = optionElement.prop('selected');

        if (isDefined(oldVal)) {
          self.removeOption(oldVal);
          removal = true;
        }
        oldVal = newVal;
        self.addOption(newVal, optionElement);

        if (removal && previouslySelected) {
          scheduleViewValueUpdate();
        }
      });
    } else if (interpolateTextFn) {
      // The text content is interpolated
      optionScope.$watch(interpolateTextFn, function interpolateWatchAction(newVal, oldVal) {
        optionAttrs.$set('value', newVal);
        var previouslySelected = optionElement.prop('selected');
        if (oldVal !== newVal) {
          self.removeOption(oldVal);
        }
        self.addOption(newVal, optionElement);

        if (oldVal && previouslySelected) {
          scheduleViewValueUpdate();
        }
      });
    } else {
      // The value attribute is static
      self.addOption(optionAttrs.value, optionElement);
    }


    optionAttrs.$observe('disabled', function(newVal) {

      // Since model updates will also select disabled options (like ngOptions),
      // we only have to handle options becoming disabled, not enabled

      if (newVal === 'true' || newVal && optionElement.prop('selected')) {
        if (self.multiple) {
          scheduleViewValueUpdate(true);
        } else {
          self.ngModelCtrl.$setViewValue(null);
          self.ngModelCtrl.$render();
        }
      }
    });

    optionElement.on('$destroy', function() {
      var currentValue = self.readValue();
      var removeValue = optionAttrs.value;

      self.removeOption(removeValue);
      scheduleRender();

      if (self.multiple && currentValue && currentValue.indexOf(removeValue) !== -1 ||
          currentValue === removeValue
      ) {
        // When multiple (selected) options are destroyed at the same time, we don't want
        // to run a model update for each of them. Instead, run a single update in the $$postDigest
        scheduleViewValueUpdate(true);
      }
    });
  };
}];

/**
 * @ngdoc directive
 * @name select
 * @restrict E
 *
 * @description
 * HTML `select` element with AngularJS data-binding.
 *
 * The `select` directive is used together with {@link ngModel `ngModel`} to provide data-binding
 * between the scope and the `<select>` control (including setting default values).
 * It also handles dynamic `<option>` elements, which can be added using the {@link ngRepeat `ngRepeat}` or
 * {@link ngOptions `ngOptions`} directives.
 *
 * When an item in the `<select>` menu is selected, the value of the selected option will be bound
 * to the model identified by the `ngModel` directive. With static or repeated options, this is
 * the content of the `value` attribute or the textContent of the `<option>`, if the value attribute is missing.
 * Value and textContent can be interpolated.
 *
 * The {@link select.SelectController select controller} exposes utility functions that can be used
 * to manipulate the select's behavior.
 *
 * ## Matching model and option values
 *
 * In general, the match between the model and an option is evaluated by strictly comparing the model
 * value against the value of the available options.
 *
 * If you are setting the option value with the option's `value` attribute, or textContent, the
 * value will always be a `string` which means that the model value must also be a string.
 * Otherwise the `select` directive cannot match them correctly.
 *
 * To bind the model to a non-string value, you can use one of the following strategies:
 * - the {@link ng.ngOptions `ngOptions`} directive
 *   ({@link ng.select#using-select-with-ngoptions-and-setting-a-default-value})
 * - the {@link ng.ngValue `ngValue`} directive, which allows arbitrary expressions to be
 *   option values ({@link ng.select#using-ngvalue-to-bind-the-model-to-an-array-of-objects Example})
 * - model $parsers / $formatters to convert the string value
 *   ({@link ng.select#binding-select-to-a-non-string-value-via-ngmodel-parsing-formatting Example})
 *
 * If the viewValue of `ngModel` does not match any of the options, then the control
 * will automatically add an "unknown" option, which it then removes when the mismatch is resolved.
 *
 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
 * option. See example below for demonstration.
 *
 * ## Choosing between `ngRepeat` and `ngOptions`
 *
 * In many cases, `ngRepeat` can be used on `<option>` elements instead of {@link ng.directive:ngOptions
 * ngOptions} to achieve a similar result. However, `ngOptions` provides some benefits:
 * - more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
 * comprehension expression
 * - reduced memory consumption by not creating a new scope for each repeated instance
 * - increased render speed by creating the options in a documentFragment instead of individually
 *
 * Specifically, select with repeated options slows down significantly starting at 2000 options in
 * Chrome and Internet Explorer / Edge.
 *
 *
 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
 * @param {string=} name Property name of the form under which the control is published.
 * @param {string=} multiple Allows multiple options to be selected. The selected values will be
 *     bound to the model as an array.
 * @param {string=} required Sets `required` validation error key if the value is not entered.
 * @param {string=} ngRequired Adds required attribute and required validation constraint to
 * the element when the ngRequired expression evaluates to true. Use ngRequired instead of required
 * when you want to data-bind to the required attribute.
 * @param {string=} ngChange AngularJS expression to be executed when selected option(s) changes due to user
 *    interaction with the select element.
 * @param {string=} ngOptions sets the options that the select is populated with and defines what is
 * set on the model on selection. See {@link ngOptions `ngOptions`}.
 * @param {string=} ngAttrSize sets the size of the select element dynamically. Uses the
 * {@link guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes ngAttr} directive.
 *
 *
 * @example
 * ### Simple `select` elements with static options
 *
 * <example name="static-select" module="staticSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="singleSelect"> Single select: </label><br>
 *     <select name="singleSelect" ng-model="data.singleSelect">
 *       <option value="option-1">Option 1</option>
 *       <option value="option-2">Option 2</option>
 *     </select><br>
 *
 *     <label for="singleSelect"> Single select with "not selected" option and dynamic option values: </label><br>
 *     <select name="singleSelect" id="singleSelect" ng-model="data.singleSelect">
 *       <option value="">---Please select---</option> <!-- not selected / blank option -->
 *       <option value="{{data.option1}}">Option 1</option> <!-- interpolation -->
 *       <option value="option-2">Option 2</option>
 *     </select><br>
 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
 *     <tt>singleSelect = {{data.singleSelect}}</tt>
 *
 *     <hr>
 *     <label for="multipleSelect"> Multiple select: </label><br>
 *     <select name="multipleSelect" id="multipleSelect" ng-model="data.multipleSelect" multiple>
 *       <option value="option-1">Option 1</option>
 *       <option value="option-2">Option 2</option>
 *       <option value="option-3">Option 3</option>
 *     </select><br>
 *     <tt>multipleSelect = {{data.multipleSelect}}</tt><br/>
 *   </form>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('staticSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.data = {
 *       singleSelect: null,
 *       multipleSelect: [],
 *       option1: 'option-1'
 *      };
 *
 *      $scope.forceUnknownOption = function() {
 *        $scope.data.singleSelect = 'nonsense';
 *      };
 *   }]);
 * </file>
 *</example>
 *
 * @example
 * ### Using `ngRepeat` to generate `select` options
 * <example name="select-ngrepeat" module="ngrepeatSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="repeatSelect"> Repeat select: </label>
 *     <select name="repeatSelect" id="repeatSelect" ng-model="data.model">
 *       <option ng-repeat="option in data.availableOptions" value="{{option.id}}">{{option.name}}</option>
 *     </select>
 *   </form>
 *   <hr>
 *   <tt>model = {{data.model}}</tt><br/>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('ngrepeatSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.data = {
 *       model: null,
 *       availableOptions: [
 *         {id: '1', name: 'Option A'},
 *         {id: '2', name: 'Option B'},
 *         {id: '3', name: 'Option C'}
 *       ]
 *      };
 *   }]);
 * </file>
 *</example>
 *
 * @example
 * ### Using `ngValue` to bind the model to an array of objects
 * <example name="select-ngvalue" module="ngvalueSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="ngvalueselect"> ngvalue select: </label>
 *     <select size="6" name="ngvalueselect" ng-model="data.model" multiple>
 *       <option ng-repeat="option in data.availableOptions" ng-value="option.value">{{option.name}}</option>
 *     </select>
 *   </form>
 *   <hr>
 *   <pre>model = {{data.model | json}}</pre><br/>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('ngvalueSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.data = {
 *       model: null,
 *       availableOptions: [
           {value: 'myString', name: 'string'},
           {value: 1, name: 'integer'},
           {value: true, name: 'boolean'},
           {value: null, name: 'null'},
           {value: {prop: 'value'}, name: 'object'},
           {value: ['a'], name: 'array'}
 *       ]
 *      };
 *   }]);
 * </file>
 *</example>
 *
 * @example
 * ### Using `select` with `ngOptions` and setting a default value
 * See the {@link ngOptions ngOptions documentation} for more `ngOptions` usage examples.
 *
 * <example name="select-with-default-values" module="defaultValueSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="mySelect">Make a choice:</label>
 *     <select name="mySelect" id="mySelect"
 *       ng-options="option.name for option in data.availableOptions track by option.id"
 *       ng-model="data.selectedOption"></select>
 *   </form>
 *   <hr>
 *   <tt>option = {{data.selectedOption}}</tt><br/>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('defaultValueSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.data = {
 *       availableOptions: [
 *         {id: '1', name: 'Option A'},
 *         {id: '2', name: 'Option B'},
 *         {id: '3', name: 'Option C'}
 *       ],
 *       selectedOption: {id: '3', name: 'Option C'} //This sets the default value of the select in the ui
 *       };
 *   }]);
 * </file>
 *</example>
 *
 * @example
 * ### Binding `select` to a non-string value via `ngModel` parsing / formatting
 *
 * <example name="select-with-non-string-options" module="nonStringSelect">
 *   <file name="index.html">
 *     <select ng-model="model.id" convert-to-number>
 *       <option value="0">Zero</option>
 *       <option value="1">One</option>
 *       <option value="2">Two</option>
 *     </select>
 *     {{ model }}
 *   </file>
 *   <file name="app.js">
 *     angular.module('nonStringSelect', [])
 *       .run(function($rootScope) {
 *         $rootScope.model = { id: 2 };
 *       })
 *       .directive('convertToNumber', function() {
 *         return {
 *           require: 'ngModel',
 *           link: function(scope, element, attrs, ngModel) {
 *             ngModel.$parsers.push(function(val) {
 *               return parseInt(val, 10);
 *             });
 *             ngModel.$formatters.push(function(val) {
 *               return '' + val;
 *             });
 *           }
 *         };
 *       });
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     it('should initialize to model', function() {
 *       expect(element(by.model('model.id')).$('option:checked').getText()).toEqual('Two');
 *     });
 *   </file>
 * </example>
 *
 */
var selectDirective = function() {

  return {
    restrict: 'E',
    require: ['select', '?ngModel'],
    controller: SelectController,
    priority: 1,
    link: {
      pre: selectPreLink,
      post: selectPostLink
    }
  };

  function selectPreLink(scope, element, attr, ctrls) {

      var selectCtrl = ctrls[0];
      var ngModelCtrl = ctrls[1];

      // if ngModel is not defined, we don't need to do anything but set the registerOption
      // function to noop, so options don't get added internally
      if (!ngModelCtrl) {
        selectCtrl.registerOption = noop;
        return;
      }


      selectCtrl.ngModelCtrl = ngModelCtrl;

      // When the selected item(s) changes we delegate getting the value of the select control
      // to the `readValue` method, which can be changed if the select can have multiple
      // selected values or if the options are being generated by `ngOptions`
      element.on('change', function() {
        selectCtrl.removeUnknownOption();
        scope.$apply(function() {
          ngModelCtrl.$setViewValue(selectCtrl.readValue());
        });
      });

      // If the select allows multiple values then we need to modify how we read and write
      // values from and to the control; also what it means for the value to be empty and
      // we have to add an extra watch since ngModel doesn't work well with arrays - it
      // doesn't trigger rendering if only an item in the array changes.
      if (attr.multiple) {
        selectCtrl.multiple = true;

        // Read value now needs to check each option to see if it is selected
        selectCtrl.readValue = function readMultipleValue() {
          var array = [];
          forEach(element.find('option'), function(option) {
            if (option.selected && !option.disabled) {
              var val = option.value;
              array.push(val in selectCtrl.selectValueMap ? selectCtrl.selectValueMap[val] : val);
            }
          });
          return array;
        };

        // Write value now needs to set the selected property of each matching option
        selectCtrl.writeValue = function writeMultipleValue(value) {
          forEach(element.find('option'), function(option) {
            var shouldBeSelected = !!value && (includes(value, option.value) ||
                                               includes(value, selectCtrl.selectValueMap[option.value]));
            var currentlySelected = option.selected;

            // Support: IE 9-11 only, Edge 12-15+
            // In IE and Edge adding options to the selection via shift+click/UP/DOWN
            // will de-select already selected options if "selected" on those options was set
            // more than once (i.e. when the options were already selected)
            // So we only modify the selected property if necessary.
            // Note: this behavior cannot be replicated via unit tests because it only shows in the
            // actual user interface.
            if (shouldBeSelected !== currentlySelected) {
              setOptionSelectedStatus(jqLite(option), shouldBeSelected);
            }

          });
        };

        // we have to do it on each watch since ngModel watches reference, but
        // we need to work of an array, so we need to see if anything was inserted/removed
        var lastView, lastViewRef = NaN;
        scope.$watch(function selectMultipleWatch() {
          if (lastViewRef === ngModelCtrl.$viewValue && !equals(lastView, ngModelCtrl.$viewValue)) {
            lastView = shallowCopy(ngModelCtrl.$viewValue);
            ngModelCtrl.$render();
          }
          lastViewRef = ngModelCtrl.$viewValue;
        });

        // If we are a multiple select then value is now a collection
        // so the meaning of $isEmpty changes
        ngModelCtrl.$isEmpty = function(value) {
          return !value || value.length === 0;
        };

      }
    }

    function selectPostLink(scope, element, attrs, ctrls) {
      // if ngModel is not defined, we don't need to do anything
      var ngModelCtrl = ctrls[1];
      if (!ngModelCtrl) return;

      var selectCtrl = ctrls[0];

      // We delegate rendering to the `writeValue` method, which can be changed
      // if the select can have multiple selected values or if the options are being
      // generated by `ngOptions`.
      // This must be done in the postLink fn to prevent $render to be called before
      // all nodes have been linked correctly.
      ngModelCtrl.$render = function() {
        selectCtrl.writeValue(ngModelCtrl.$viewValue);
      };
    }
};


// The option directive is purely designed to communicate the existence (or lack of)
// of dynamically created (and destroyed) option elements to their containing select
// directive via its controller.
var optionDirective = ['$interpolate', function($interpolate) {
  return {
    restrict: 'E',
    priority: 100,
    compile: function(element, attr) {
      var interpolateValueFn, interpolateTextFn;

      if (isDefined(attr.ngValue)) {
        // Will be handled by registerOption
      } else if (isDefined(attr.value)) {
        // If the value attribute is defined, check if it contains an interpolation
        interpolateValueFn = $interpolate(attr.value, true);
      } else {
        // If the value attribute is not defined then we fall back to the
        // text content of the option element, which may be interpolated
        interpolateTextFn = $interpolate(element.text(), true);
        if (!interpolateTextFn) {
          attr.$set('value', element.text());
        }
      }

      return function(scope, element, attr) {
        // This is an optimization over using ^^ since we don't want to have to search
        // all the way to the root of the DOM for every single option element
        var selectCtrlName = '$selectController',
            parent = element.parent(),
            selectCtrl = parent.data(selectCtrlName) ||
              parent.parent().data(selectCtrlName); // in case we are in optgroup

        if (selectCtrl) {
          selectCtrl.registerOption(scope, element, attr, interpolateValueFn, interpolateTextFn);
        }
      };
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngRequired
 * @restrict A
 *
 * @param {expression} ngRequired AngularJS expression. If it evaluates to `true`, it sets the
 *                                `required` attribute to the element and adds the `required`
 *                                {@link ngModel.NgModelController#$validators `validator`}.
 *
 * @description
 *
 * ngRequired adds the required {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
 * It is most often used for {@link input `input`} and {@link select `select`} controls, but can also be
 * applied to custom controls.
 *
 * The directive sets the `required` attribute on the element if the AngularJS expression inside
 * `ngRequired` evaluates to true. A special directive for setting `required` is necessary because we
 * cannot use interpolation inside `required`. See the {@link guide/interpolation interpolation guide}
 * for more info.
 *
 * The validator will set the `required` error key to true if the `required` attribute is set and
 * calling {@link ngModel.NgModelController#$isEmpty `NgModelController.$isEmpty`} with the
 * {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`} returns `true`. For example, the
 * `$isEmpty()` implementation for `input[text]` checks the length of the `$viewValue`. When developing
 * custom controls, `$isEmpty()` can be overwritten to account for a $viewValue that is not string-based.
 *
 * @example
 * <example name="ngRequiredDirective" module="ngRequiredExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('ngRequiredExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.required = true;
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <form name="form">
 *         <label for="required">Toggle required: </label>
 *         <input type="checkbox" ng-model="required" id="required" />
 *         <br>
 *         <label for="input">This input must be filled if `required` is true: </label>
 *         <input type="text" ng-model="model" id="input" name="input" ng-required="required" /><br>
 *         <hr>
 *         required error set? = <code>{{form.input.$error.required}}</code><br>
 *         model = <code>{{model}}</code>
 *       </form>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
       var required = element(by.binding('form.input.$error.required'));
       var model = element(by.binding('model'));
       var input = element(by.id('input'));

       it('should set the required error', function() {
         expect(required.getText()).toContain('true');

         input.sendKeys('123');
         expect(required.getText()).not.toContain('true');
         expect(model.getText()).toContain('123');
       });
 *   </file>
 * </example>
 */
var requiredDirective = ['$parse', function($parse) {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function(scope, elm, attr, ctrl) {
      if (!ctrl) return;
      // For boolean attributes like required, presence means true
      var value = attr.hasOwnProperty('required') || $parse(attr.ngRequired)(scope);

      if (!attr.ngRequired) {
        // force truthy in case we are on non input element
        // (input elements do this automatically for boolean attributes like required)
        attr.required = true;
      }

      ctrl.$validators.required = function(modelValue, viewValue) {
        return !value || !ctrl.$isEmpty(viewValue);
      };

      attr.$observe('required', function(newVal) {

        if (value !== newVal) {
          value = newVal;
          ctrl.$validate();
        }
      });
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngPattern
 * @restrict A
 *
 * @param {expression|RegExp} ngPattern AngularJS expression that must evaluate to a `RegExp` or a `String`
 *                                      parsable into a `RegExp`, or a `RegExp` literal. See above for
 *                                      more details.
 *
 * @description
 *
 * ngPattern adds the pattern {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
 *
 * The validator sets the `pattern` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
 * does not match a RegExp which is obtained from the `ngPattern` attribute value:
 * - the value is an AngularJS expression:
 *   - If the expression evaluates to a RegExp object, then this is used directly.
 *   - If the expression evaluates to a string, then it will be converted to a RegExp after wrapping it
 *     in `^` and `$` characters. For instance, `"abc"` will be converted to `new RegExp('^abc$')`.
 * - If the value is a RegExp literal, e.g. `ngPattern="/^\d+$/"`, it is used directly.
 *
 * <div class="alert alert-info">
 * **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
 * start at the index of the last search's match, thus not taking the whole input value into
 * account.
 * </div>
 *
 * <div class="alert alert-info">
 * **Note:** This directive is also added when the plain `pattern` attribute is used, with two
 * differences:
 * <ol>
 *   <li>
 *     `ngPattern` does not set the `pattern` attribute and therefore HTML5 constraint validation is
 *     not available.
 *   </li>
 *   <li>
 *     The `ngPattern` attribute must be an expression, while the `pattern` value must be
 *     interpolated.
 *   </li>
 * </ol>
 * </div>
 *
 * @example
 * <example name="ngPatternDirective" module="ngPatternExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('ngPatternExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.regex = '\\d+';
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <form name="form">
 *         <label for="regex">Set a pattern (regex string): </label>
 *         <input type="text" ng-model="regex" id="regex" />
 *         <br>
 *         <label for="input">This input is restricted by the current pattern: </label>
 *         <input type="text" ng-model="model" id="input" name="input" ng-pattern="regex" /><br>
 *         <hr>
 *         input valid? = <code>{{form.input.$valid}}</code><br>
 *         model = <code>{{model}}</code>
 *       </form>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
       var model = element(by.binding('model'));
       var input = element(by.id('input'));

       it('should validate the input with the default pattern', function() {
         input.sendKeys('aaa');
         expect(model.getText()).not.toContain('aaa');

         input.clear().then(function() {
           input.sendKeys('123');
           expect(model.getText()).toContain('123');
         });
       });
 *   </file>
 * </example>
 */
var patternDirective = ['$parse', function($parse) {
  return {
    restrict: 'A',
    require: '?ngModel',
    compile: function(tElm, tAttr) {
      var patternExp;
      var parseFn;

      if (tAttr.ngPattern) {
        patternExp = tAttr.ngPattern;

        // ngPattern might be a scope expression, or an inlined regex, which is not parsable.
        // We get value of the attribute here, so we can compare the old and the new value
        // in the observer to avoid unnecessary validations
        if (tAttr.ngPattern.charAt(0) === '/' && REGEX_STRING_REGEXP.test(tAttr.ngPattern)) {
          parseFn = function() { return tAttr.ngPattern; };
        } else {
          parseFn = $parse(tAttr.ngPattern);
        }
      }

      return function(scope, elm, attr, ctrl) {
        if (!ctrl) return;

        var attrVal = attr.pattern;

        if (attr.ngPattern) {
          attrVal = parseFn(scope);
        } else {
          patternExp = attr.pattern;
        }

        var regexp = parsePatternAttr(attrVal, patternExp, elm);

        attr.$observe('pattern', function(newVal) {
          var oldRegexp = regexp;

          regexp = parsePatternAttr(newVal, patternExp, elm);

          if ((oldRegexp && oldRegexp.toString()) !== (regexp && regexp.toString())) {
            ctrl.$validate();
          }
        });

        ctrl.$validators.pattern = function(modelValue, viewValue) {
          // HTML5 pattern constraint validates the input value, so we validate the viewValue
          return ctrl.$isEmpty(viewValue) || isUndefined(regexp) || regexp.test(viewValue);
        };
      };
    }

  };
}];

/**
 * @ngdoc directive
 * @name ngMaxlength
 * @restrict A
 *
 * @param {expression} ngMaxlength AngularJS expression that must evaluate to a `Number` or `String`
 *                                 parsable into a `Number`. Used as value for the `maxlength`
 *                                 {@link ngModel.NgModelController#$validators validator}.
 *
 * @description
 *
 * ngMaxlength adds the maxlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
 *
 * The validator sets the `maxlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
 * is longer than the integer obtained by evaluating the AngularJS expression given in the
 * `ngMaxlength` attribute value.
 *
 * <div class="alert alert-info">
 * **Note:** This directive is also added when the plain `maxlength` attribute is used, with two
 * differences:
 * <ol>
 *   <li>
 *     `ngMaxlength` does not set the `maxlength` attribute and therefore HTML5 constraint
 *     validation is not available.
 *   </li>
 *   <li>
 *     The `ngMaxlength` attribute must be an expression, while the `maxlength` value must be
 *     interpolated.
 *   </li>
 * </ol>
 * </div>
 *
 * @example
 * <example name="ngMaxlengthDirective" module="ngMaxlengthExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('ngMaxlengthExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.maxlength = 5;
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <form name="form">
 *         <label for="maxlength">Set a maxlength: </label>
 *         <input type="number" ng-model="maxlength" id="maxlength" />
 *         <br>
 *         <label for="input">This input is restricted by the current maxlength: </label>
 *         <input type="text" ng-model="model" id="input" name="input" ng-maxlength="maxlength" /><br>
 *         <hr>
 *         input valid? = <code>{{form.input.$valid}}</code><br>
 *         model = <code>{{model}}</code>
 *       </form>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
       var model = element(by.binding('model'));
       var input = element(by.id('input'));

       it('should validate the input with the default maxlength', function() {
         input.sendKeys('abcdef');
         expect(model.getText()).not.toContain('abcdef');

         input.clear().then(function() {
           input.sendKeys('abcde');
           expect(model.getText()).toContain('abcde');
         });
       });
 *   </file>
 * </example>
 */
var maxlengthDirective = ['$parse', function($parse) {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function(scope, elm, attr, ctrl) {
      if (!ctrl) return;

      var maxlength = attr.maxlength || $parse(attr.ngMaxlength)(scope);
      var maxlengthParsed = parseLength(maxlength);

      attr.$observe('maxlength', function(value) {
        if (maxlength !== value) {
          maxlengthParsed = parseLength(value);
          maxlength = value;
          ctrl.$validate();
        }
      });
      ctrl.$validators.maxlength = function(modelValue, viewValue) {
        return (maxlengthParsed < 0) || ctrl.$isEmpty(viewValue) || (viewValue.length <= maxlengthParsed);
      };
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngMinlength
 * @restrict A
 *
 * @param {expression} ngMinlength AngularJS expression that must evaluate to a `Number` or `String`
 *                                 parsable into a `Number`. Used as value for the `minlength`
 *                                 {@link ngModel.NgModelController#$validators validator}.
 *
 * @description
 *
 * ngMinlength adds the minlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
 *
 * The validator sets the `minlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
 * is shorter than the integer obtained by evaluating the AngularJS expression given in the
 * `ngMinlength` attribute value.
 *
 * <div class="alert alert-info">
 * **Note:** This directive is also added when the plain `minlength` attribute is used, with two
 * differences:
 * <ol>
 *   <li>
 *     `ngMinlength` does not set the `minlength` attribute and therefore HTML5 constraint
 *     validation is not available.
 *   </li>
 *   <li>
 *     The `ngMinlength` value must be an expression, while the `minlength` value must be
 *     interpolated.
 *   </li>
 * </ol>
 * </div>
 *
 * @example
 * <example name="ngMinlengthDirective" module="ngMinlengthExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('ngMinlengthExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.minlength = 3;
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <form name="form">
 *         <label for="minlength">Set a minlength: </label>
 *         <input type="number" ng-model="minlength" id="minlength" />
 *         <br>
 *         <label for="input">This input is restricted by the current minlength: </label>
 *         <input type="text" ng-model="model" id="input" name="input" ng-minlength="minlength" /><br>
 *         <hr>
 *         input valid? = <code>{{form.input.$valid}}</code><br>
 *         model = <code>{{model}}</code>
 *       </form>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
       var model = element(by.binding('model'));
       var input = element(by.id('input'));

       it('should validate the input with the default minlength', function() {
         input.sendKeys('ab');
         expect(model.getText()).not.toContain('ab');

         input.sendKeys('abc');
         expect(model.getText()).toContain('abc');
       });
 *   </file>
 * </example>
 */
var minlengthDirective = ['$parse', function($parse) {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function(scope, elm, attr, ctrl) {
      if (!ctrl) return;

      var minlength = attr.minlength || $parse(attr.ngMinlength)(scope);
      var minlengthParsed = parseLength(minlength) || -1;

      attr.$observe('minlength', function(value) {
        if (minlength !== value) {
          minlengthParsed = parseLength(value) || -1;
          minlength = value;
          ctrl.$validate();
        }

      });
      ctrl.$validators.minlength = function(modelValue, viewValue) {
        return ctrl.$isEmpty(viewValue) || viewValue.length >= minlengthParsed;
      };
    }
  };
}];


function parsePatternAttr(regex, patternExp, elm) {
  if (!regex) return undefined;

  if (isString(regex)) {
    regex = new RegExp('^' + regex + '$');
  }

  if (!regex.test) {
    throw minErr('ngPattern')('noregexp',
      'Expected {0} to be a RegExp but was {1}. Element: {2}', patternExp,
      regex, startingTag(elm));
  }

  return regex;
}

function parseLength(val) {
  var intVal = toInt(val);
  return isNumberNaN(intVal) ? -1 : intVal;
}

if (window.angular.bootstrap) {
  // AngularJS is already loaded, so we can return here...
  if (window.console) {
    console.log('WARNING: Tried to load AngularJS more than once.');
  }
  return;
}

// try to bind to jquery now so that one can write jqLite(fn)
// but we will rebind on bootstrap again.
bindJQuery();

publishExternalAPI(angular);

angular.module("ngLocale", [], ["$provide", function($provide) {
var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
function getDecimals(n) {
  n = n + '';
  var i = n.indexOf('.');
  return (i == -1) ? 0 : n.length - i - 1;
}

function getVF(n, opt_precision) {
  var v = opt_precision;

  if (undefined === v) {
    v = Math.min(getDecimals(n), 3);
  }

  var base = Math.pow(10, v);
  var f = ((n * base) | 0) % base;
  return {v: v, f: f};
}

$provide.value("$locale", {
  "DATETIME_FORMATS": {
    "AMPMS": [
      "AM",
      "PM"
    ],
    "DAY": [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ],
    "ERANAMES": [
      "Before Christ",
      "Anno Domini"
    ],
    "ERAS": [
      "BC",
      "AD"
    ],
    "FIRSTDAYOFWEEK": 6,
    "MONTH": [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "SHORTDAY": [
      "Sun",
      "Mon",
      "Tue",
      "Wed",
      "Thu",
      "Fri",
      "Sat"
    ],
    "SHORTMONTH": [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    "STANDALONEMONTH": [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "WEEKENDRANGE": [
      5,
      6
    ],
    "fullDate": "EEEE, MMMM d, y",
    "longDate": "MMMM d, y",
    "medium": "MMM d, y h:mm:ss a",
    "mediumDate": "MMM d, y",
    "mediumTime": "h:mm:ss a",
    "short": "M/d/yy h:mm a",
    "shortDate": "M/d/yy",
    "shortTime": "h:mm a"
  },
  "NUMBER_FORMATS": {
    "CURRENCY_SYM": "$",
    "DECIMAL_SEP": ".",
    "GROUP_SEP": ",",
    "PATTERNS": [
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 3,
        "minFrac": 0,
        "minInt": 1,
        "negPre": "-",
        "negSuf": "",
        "posPre": "",
        "posSuf": ""
      },
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 2,
        "minFrac": 2,
        "minInt": 1,
        "negPre": "-\u00a4",
        "negSuf": "",
        "posPre": "\u00a4",
        "posSuf": ""
      }
    ]
  },
  "id": "en-us",
  "localeID": "en_US",
  "pluralCat": function(n, opt_precision) {  var i = n | 0;  var vf = getVF(n, opt_precision);  if (i == 1 && vf.v == 0) {    return PLURAL_CATEGORY.ONE;  }  return PLURAL_CATEGORY.OTHER;}
});
}]);

  jqLite(function() {
    angularInit(window.document, bootstrap);
  });

})(window);

!window.angular.$$csp().noInlineStyle && window.angular.element(document.head).prepend(window.angular.element('<style>').text('@charset "UTF-8";[ng\\:cloak],[ng-cloak],[data-ng-cloak],[x-ng-cloak],.ng-cloak,.x-ng-cloak,.ng-hide:not(.ng-hide-animate){display:none !important;}ng\\:form{display:block;}.ng-animate-shim{visibility:hidden;}.ng-anchor{position:absolute;}'));
},{}],556:[function(require,module,exports){
/** See the file "LICENSE" for the full license governing this code.
 *
 * @author Dale "Ducky" Lotts
 * @since 9/11/16.
 */

require('./src/js/datetimepicker');
require('./src/js/datetimepicker.templates');

module.exports = 'ui.bootstrap.datetimepicker';

},{"./src/js/datetimepicker":557,"./src/js/datetimepicker.templates":558}],557:[function(require,module,exports){
/* globals define, jQuery, module, require, angular, moment */
/* jslint vars:true */

/**
 * @license angularjs-bootstrap-datetimepicker
 * Copyright 2016 Knight Rider Consulting, Inc. http://www.knightrider.com
 * License: MIT
 *
 * @author        Dale "Ducky" Lotts
 * @since        2013-Jul-8
 */

;(function (root, factory) {
  'use strict'
  /* istanbul ignore if */
  if (typeof module !== 'undefined' && module.exports) {
    var ng = typeof angular === 'undefined' ? require('angular') : angular
    var mt = typeof moment === 'undefined' ? require('moment') : moment
    factory(ng, mt)
    module.exports = 'ui.bootstrap.datetimepicker'
    /* istanbul ignore next */
  } else if (typeof define === 'function' && /* istanbul ignore next */ define.amd) {
    define(['angular', 'moment'], factory)
  } else {
    factory(root.angular, root.moment)
  }
}(this, function (angular, moment) {
  'use strict'
  angular.module('ui.bootstrap.datetimepicker', [])
    .service('dateTimePickerConfig', DateTimePickerConfigProvider)
    .service('dateTimePickerValidator', DateTimePickerValidatorService)
    .directive('datetimepicker', DatetimepickerDirective)

  DatetimepickerDirective.$inject = ['dateTimePickerConfig', 'dateTimePickerValidator']

  function DatetimepickerDirective (defaultConfig, configurationValidator) {
    var directiveDefinition = {
      bindToController: false,
      controller: DirectiveController,
      controllerAs: 'dateTimePickerController',
      replace: true,
      require: 'ngModel',
      restrict: 'E',
      scope: {
        beforeRender: '&',
        onSetTime: '&'
      },
      templateUrl: 'templates/datetimepicker.html'
    }

    DirectiveController.$inject = ['$scope', '$element', '$attrs']

    function DirectiveController ($scope, $element, $attrs) {
      // Configuration
      var ngModelController = $element.controller('ngModel')

      var configuration = createConfiguration()
      $scope.screenReader = configuration.screenReader

      // Behavior
      $scope.changeView = changeView
      ngModelController.$render = $render

      if (configuration.configureOn) {
        $scope.$on(configuration.configureOn, function () {
          configuration = createConfiguration()
          $scope.screenReader = configuration.screenReader
          ngModelController.$render()
        })
      }

      if (configuration.renderOn) {
        $scope.$on(configuration.renderOn, ngModelController.$render)
      }

      // Implementation

      var viewToModelFactory = {
        year: yearModelFactory,

        month: monthModelFactory,

        day: dayModelFactory,

        hour: hourModelFactory,

        minute: minuteModelFactory,

        setTime: setTime
      }

      function changeView (viewName, dateObject, event) {
        if (event) {
          event.stopPropagation()
          event.preventDefault()
        }

        if (viewName && (dateObject.utcDateValue > -Infinity) && dateObject.selectable && viewToModelFactory[viewName]) {
          var result = viewToModelFactory[viewName](dateObject.utcDateValue)

          var weekDates = []
          if (result.weeks) {
            for (var i = 0; i < result.weeks.length; i += 1) {
              var week = result.weeks[i]
              for (var j = 0; j < week.dates.length; j += 1) {
                var weekDate = week.dates[j]
                weekDates.push(weekDate)
              }
            }
          }

          $scope.beforeRender({
            $view: result.currentView,
            $dates: result.dates || weekDates,
            $leftDate: result.leftDate,
            $upDate: result.previousViewDate,
            $rightDate: result.rightDate
          })

          $scope.data = result
        }
      }

      function yearModelFactory (milliseconds) {
        var selectedDate = moment.utc(milliseconds).startOf('year')
        // View starts one year before the decade starts and ends one year after the decade ends
        // i.e. passing in a date of 1/1/2013 will give a range of 2009 to 2020
        // Truncate the last digit from the current year and subtract 1 to get the start of the decade
        var startDecade = (parseInt(selectedDate.year() / 10, 10) * 10)
        var startDate = moment.utc(startOfDecade(milliseconds)).subtract(1, 'year').startOf('year')

        var yearFormat = 'YYYY'
        var activeFormat = formatValue(ngModelController.$modelValue, yearFormat)
        var currentFormat = moment().format(yearFormat)

        var result = {
          'currentView': 'year',
          'nextView': configuration.minView === 'year' ? 'setTime' : 'month',
          'previousViewDate': new DateObject({
            utcDateValue: null,
            display: startDecade + '-' + (startDecade + 9)
          }),
          'leftDate': new DateObject({utcDateValue: moment.utc(startDate).subtract(9, 'year').valueOf()}),
          'rightDate': new DateObject({utcDateValue: moment.utc(startDate).add(11, 'year').valueOf()}),
          'dates': []
        }

        for (var i = 0; i < 12; i += 1) {
          var yearMoment = moment.utc(startDate).add(i, 'years')
          var dateValue = {
            'active': yearMoment.format(yearFormat) === activeFormat,
            'current': yearMoment.format(yearFormat) === currentFormat,
            'display': yearMoment.format(yearFormat),
            'future': yearMoment.year() > startDecade + 9,
            'past': yearMoment.year() < startDecade,
            'utcDateValue': yearMoment.valueOf()
          }

          result.dates.push(new DateObject(dateValue))
        }

        return result
      }

      function monthModelFactory (milliseconds) {
        var startDate = moment.utc(milliseconds).startOf('year')
        var previousViewDate = startOfDecade(milliseconds)

        var monthFormat = 'YYYY-MMM'
        var activeFormat = formatValue(ngModelController.$modelValue, monthFormat)
        var currentFormat = moment().format(monthFormat)

        var result = {
          'previousView': 'year',
          'currentView': 'month',
          'nextView': configuration.minView === 'month' ? 'setTime' : 'day',
          'previousViewDate': new DateObject({
            utcDateValue: previousViewDate.valueOf(),
            display: startDate.format('YYYY')
          }),
          'leftDate': new DateObject({utcDateValue: moment.utc(startDate).subtract(1, 'year').valueOf()}),
          'rightDate': new DateObject({utcDateValue: moment.utc(startDate).add(1, 'year').valueOf()}),
          'dates': []
        }

        for (var i = 0; i < 12; i += 1) {
          var monthMoment = moment.utc(startDate).add(i, 'months')
          var dateValue = {
            'active': monthMoment.format(monthFormat) === activeFormat,
            'current': monthMoment.format(monthFormat) === currentFormat,
            'display': monthMoment.format('MMM'),
            'utcDateValue': monthMoment.valueOf()
          }

          result.dates.push(new DateObject(dateValue))
        }

        return result
      }

      function dayModelFactory (milliseconds) {
        var selectedDate = moment.utc(milliseconds)
        var startOfMonth = moment.utc(selectedDate).startOf('month')
        var previousViewDate = moment.utc(selectedDate).startOf('year')
        var endOfMonth = moment.utc(selectedDate).endOf('month')

        var startDate = moment.utc(startOfMonth).subtract(Math.abs(startOfMonth.weekday()), 'days')

        var dayFormat = 'YYYY-MMM-DD'
        var activeFormat = formatValue(ngModelController.$modelValue, dayFormat)
        var currentFormat = moment().format(dayFormat)

        var result = {
          'previousView': 'month',
          'currentView': 'day',
          'nextView': configuration.minView === 'day' ? 'setTime' : 'hour',
          'previousViewDate': new DateObject({
            utcDateValue: previousViewDate.valueOf(),
            display: startOfMonth.format('YYYY-MMM')
          }),
          'leftDate': new DateObject({utcDateValue: moment.utc(startOfMonth).subtract(1, 'months').valueOf()}),
          'rightDate': new DateObject({utcDateValue: moment.utc(startOfMonth).add(1, 'months').valueOf()}),
          'dayNames': [],
          'weeks': []
        }

        for (var dayNumber = 0; dayNumber < 7; dayNumber += 1) {
          result.dayNames.push(moment.utc().weekday(dayNumber).format('dd'))
        }

        for (var i = 0; i < 6; i += 1) {
          var week = {dates: []}
          for (var j = 0; j < 7; j += 1) {
            var dayMoment = moment.utc(startDate).add((i * 7) + j, 'days')
            var dateValue = {
              'active': dayMoment.format(dayFormat) === activeFormat,
              'current': dayMoment.format(dayFormat) === currentFormat,
              'display': dayMoment.format('D'),
              'future': dayMoment.isAfter(endOfMonth),
              'past': dayMoment.isBefore(startOfMonth),
              'utcDateValue': dayMoment.valueOf()
            }
            week.dates.push(new DateObject(dateValue))
          }
          result.weeks.push(week)
        }

        return result
      }

      function hourModelFactory (milliseconds) {
        var selectedDate = moment.utc(milliseconds).startOf('day')
        var previousViewDate = moment.utc(selectedDate).startOf('month')

        var hourFormat = 'YYYY-MM-DD H'
        var activeFormat = formatValue(ngModelController.$modelValue, hourFormat)
        var currentFormat = moment().format(hourFormat)

        var result = {
          'previousView': 'day',
          'currentView': 'hour',
          'nextView': configuration.minView === 'hour' ? 'setTime' : 'minute',
          'previousViewDate': new DateObject({
            utcDateValue: previousViewDate.valueOf(),
            display: selectedDate.format('ll')
          }),
          'leftDate': new DateObject({utcDateValue: moment.utc(selectedDate).subtract(1, 'days').valueOf()}),
          'rightDate': new DateObject({utcDateValue: moment.utc(selectedDate).add(1, 'days').valueOf()}),
          'dates': []
        }

        for (var i = 0; i < 24; i += 1) {
          var hourMoment = moment.utc(selectedDate).add(i, 'hours')
          var dateValue = {
            'active': hourMoment.format(hourFormat) === activeFormat,
            'current': hourMoment.format(hourFormat) === currentFormat,
            'display': hourMoment.format('LT'),
            'utcDateValue': hourMoment.valueOf()
          }

          result.dates.push(new DateObject(dateValue))
        }

        return result
      }

      function minuteModelFactory (milliseconds) {
        var selectedDate = moment.utc(milliseconds).startOf('hour')
        var previousViewDate = moment.utc(selectedDate).startOf('day')

        var minuteFormat = 'YYYY-MM-DD H:mm'
        var activeFormat = formatValue(ngModelController.$modelValue, minuteFormat)
        var currentFormat = moment().format(minuteFormat)

        var result = {
          'previousView': 'hour',
          'currentView': 'minute',
          'nextView': 'setTime',
          'previousViewDate': new DateObject({
            utcDateValue: previousViewDate.valueOf(),
            display: selectedDate.format('lll')
          }),
          'leftDate': new DateObject({utcDateValue: moment.utc(selectedDate).subtract(1, 'hours').valueOf()}),
          'rightDate': new DateObject({utcDateValue: moment.utc(selectedDate).add(1, 'hours').valueOf()}),
          'dates': []
        }

        var limit = 60 / configuration.minuteStep

        for (var i = 0; i < limit; i += 1) {
          var hourMoment = moment.utc(selectedDate).add(i * configuration.minuteStep, 'minute')
          var dateValue = {
            'active': hourMoment.format(minuteFormat) === activeFormat,
            'current': hourMoment.format(minuteFormat) === currentFormat,
            'display': hourMoment.format('LT'),
            'utcDateValue': hourMoment.valueOf()
          }

          result.dates.push(new DateObject(dateValue))
        }

        return result
      }

      function setTime (milliseconds) {
        var tempDate = new Date(milliseconds)
        var newDate = new Date(tempDate.getUTCFullYear(), tempDate.getUTCMonth(), tempDate.getUTCDate(), tempDate.getUTCHours(), tempDate.getUTCMinutes(), tempDate.getUTCSeconds(), tempDate.getUTCMilliseconds())

        switch (configuration.modelType) {
          case 'Date':
            // No additional work needed
            break
          case 'moment':
            newDate = moment([tempDate.getUTCFullYear(), tempDate.getUTCMonth(), tempDate.getUTCDate(), tempDate.getUTCHours(), tempDate.getUTCMinutes(), tempDate.getUTCSeconds(), tempDate.getUTCMilliseconds()])
            break
          case 'milliseconds':
            newDate = milliseconds
            break
          default: // It is assumed that the modelType is a formatting string.
            newDate = moment([tempDate.getUTCFullYear(), tempDate.getUTCMonth(), tempDate.getUTCDate(), tempDate.getUTCHours(), tempDate.getUTCMinutes(), tempDate.getUTCSeconds(), tempDate.getUTCMilliseconds()]).format(configuration.modelType)
        }

        var oldDate = ngModelController.$modelValue
        ngModelController.$setViewValue(newDate)

        if (configuration.dropdownSelector) {
          jQuery(configuration.dropdownSelector).dropdown('toggle')
        }

        $scope.onSetTime({newDate: newDate, oldDate: oldDate})

        return viewToModelFactory[configuration.startView](milliseconds)
      }

      function $render () {
        $scope.changeView(configuration.startView, new DateObject({utcDateValue: getUTCTime(ngModelController.$viewValue)}))
      }

      function startOfDecade (milliseconds) {
        var startYear = (parseInt(moment.utc(milliseconds).year() / 10, 10) * 10)
        return moment.utc(milliseconds).year(startYear).startOf('year')
      }

      function formatValue (timeValue, formatString) {
        if (timeValue) {
          return getMoment(timeValue).format(formatString)
        } else {
          return ''
        }
      }

      /**
       * Converts a time value into a moment.
       *
       * This function is now necessary because moment logs a warning when parsing a string without a format.
       * @param modelValue
       *  a time value in any of the supported formats (Date, moment, milliseconds, and string)
       * @returns {moment}
       *  representing the specified time value.
       */

      function getMoment (modelValue) {
        return moment(modelValue, angular.isString(modelValue) ? configuration.parseFormat : undefined)
      }

      /**
       * Converts a time value to UCT/GMT time.
       * @param modelValue
       *  a time value in any of the supported formats (Date, moment, milliseconds, and string)
       * @returns {number}
       *  number of milliseconds since 1/1/1970
       */

      function getUTCTime (modelValue) {
        var tempDate = new Date()
        if (modelValue) {
          var tempMoment = getMoment(modelValue)
          if (tempMoment.isValid()) {
            tempDate = tempMoment.toDate()
          } else {
            throw new Error('Invalid date: ' + modelValue)
          }
        }
        return tempDate.getTime() - (tempDate.getTimezoneOffset() * 60000)
      }

      function createConfiguration () {
        var directiveConfig = {}

        if ($attrs.datetimepickerConfig) {
          directiveConfig = $scope.$parent.$eval($attrs.datetimepickerConfig)
        }

        var configuration = angular.extend({}, defaultConfig, directiveConfig)

        configurationValidator.validate(configuration)

        return configuration
      }
    }

    function DateObject () {
      var tempDate = new Date(arguments[0].utcDateValue)
      var localOffset = tempDate.getTimezoneOffset() * 60000

      this.utcDateValue = tempDate.getTime()
      this.selectable = true

      this.localDateValue = function localDateValue () {
        return this.utcDateValue + localOffset
      }

      var validProperties = ['active', 'current', 'display', 'future', 'past', 'selectable', 'utcDateValue']

      var constructorObject = arguments[0]

      Object.keys(constructorObject).filter(function (key) {
        return validProperties.indexOf(key) >= 0
      }).forEach(function (key) {
        this[key] = constructorObject[key]
      }, this)
    }

    return directiveDefinition
  }

  function DateTimePickerConfigProvider () {
    var defaultConfiguration = {
      configureOn: null,
      dropdownSelector: null,
      minuteStep: 5,
      minView: 'minute',
      modelType: 'Date',
      parseFormat: 'YYYY-MM-DDTHH:mm:ss.SSSZZ',
      renderOn: null,
      startView: 'day'
    }

    var defaultLocalization = {
      'bg': {previous: 'предишна', next: 'следваща'},
      'ca': {previous: 'anterior', next: 'següent'},
      'da': {previous: 'forrige', next: 'næste'},
      'de': {previous: 'vorige', next: 'weiter'},
      'en-au': {previous: 'previous', next: 'next'},
      'en-gb': {previous: 'previous', next: 'next'},
      'en': {previous: 'previous', next: 'next'},
      'es-us': {previous: 'atrás', next: 'siguiente'},
      'es': {previous: 'atrás', next: 'siguiente'},
      'fi': {previous: 'edellinen', next: 'seuraava'},
      'fr': {previous: 'précédent', next: 'suivant'},
      'hu': {previous: 'előző', next: 'következő'},
      'it': {previous: 'precedente', next: 'successivo'},
      'ja': {previous: '前へ', next: '次へ'},
      'ml': {previous: 'മുൻപുള്ളത്', next: 'അടുത്തത്'},
      'nl': {previous: 'vorige', next: 'volgende'},
      'pl': {previous: 'poprzednia', next: 'następna'},
      'pt-br': {previous: 'anteriores', next: 'próximos'},
      'pt': {previous: 'anterior', next: 'próximo'},
      'ro': {previous: 'anterior', next: 'următor'},
      'ru': {previous: 'предыдущая', next: 'следующая'},
      'sk': {previous: 'predošlá', next: 'ďalšia'},
      'sv': {previous: 'föregående', next: 'nästa'},
      'tr': {previous: 'önceki', next: 'sonraki'},
      'uk': {previous: 'назад', next: 'далі'},
      'zh-cn': {previous: '上一页', next: '下一页'},
      'zh-tw': {previous: '上一頁', next: '下一頁'}
    }

    var screenReader = defaultLocalization[moment.locale().toLowerCase()]

    return angular.extend({}, defaultConfiguration, {screenReader: screenReader})
  }

  DateTimePickerValidatorService.$inject = ['$log']

  function DateTimePickerValidatorService ($log) {
    return {
      validate: validator
    }

    function validator (configuration) {
      var validOptions = [
        'configureOn',
        'dropdownSelector',
        'minuteStep',
        'minView',
        'modelType',
        'parseFormat',
        'renderOn',
        'startView',
        'screenReader'
      ]

      var invalidOptions = Object.keys(configuration).filter(function (key) {
        return (validOptions.indexOf(key) < 0)
      })

      if (invalidOptions.length) {
        throw new Error('Invalid options: ' + invalidOptions.join(', '))
      }

      // Order of the elements in the validViews array is significant.
      var validViews = ['minute', 'hour', 'day', 'month', 'year']

      if (validViews.indexOf(configuration.startView) < 0) {
        throw new Error('invalid startView value: ' + configuration.startView)
      }

      if (validViews.indexOf(configuration.minView) < 0) {
        throw new Error('invalid minView value: ' + configuration.minView)
      }

      if (validViews.indexOf(configuration.minView) > validViews.indexOf(configuration.startView)) {
        throw new Error('startView must be greater than minView')
      }

      if (!angular.isNumber(configuration.minuteStep)) {
        throw new Error('minuteStep must be numeric')
      }
      if (configuration.minuteStep <= 0 || configuration.minuteStep >= 60) {
        throw new Error('minuteStep must be greater than zero and less than 60')
      }
      if (configuration.configureOn !== null && !angular.isString(configuration.configureOn)) {
        throw new Error('configureOn must be a string')
      }
      if (configuration.configureOn !== null && configuration.configureOn.length < 1) {
        throw new Error('configureOn must not be an empty string')
      }
      if (configuration.renderOn !== null && !angular.isString(configuration.renderOn)) {
        throw new Error('renderOn must be a string')
      }
      if (configuration.renderOn !== null && configuration.renderOn.length < 1) {
        throw new Error('renderOn must not be an empty string')
      }
      if (configuration.modelType !== null && !angular.isString(configuration.modelType)) {
        throw new Error('modelType must be a string')
      }
      if (configuration.modelType !== null && configuration.modelType.length < 1) {
        throw new Error('modelType must not be an empty string')
      }
      if (configuration.modelType !== 'Date' && configuration.modelType !== 'moment' && configuration.modelType !== 'milliseconds') {
        // modelType contains string format, overriding parseFormat with modelType
        configuration.parseFormat = configuration.modelType
      }
      if (configuration.dropdownSelector !== null && !angular.isString(configuration.dropdownSelector)) {
        throw new Error('dropdownSelector must be a string')
      }

      /* istanbul ignore next */
      if (configuration.dropdownSelector !== null && ((typeof jQuery === 'undefined') || (typeof jQuery().dropdown !== 'function'))) {
        $log.error('Please DO NOT specify the dropdownSelector option unless you are using jQuery AND Bootstrap.js. ' +
          'Please include jQuery AND Bootstrap.js, or write code to close the dropdown in the on-set-time callback. \n\n' +
          'The dropdownSelector configuration option is being removed because it will not function properly.')
        delete configuration.dropdownSelector
      }
    }
  }
})); // eslint-disable-line semi

},{"angular":"angular","moment":"moment"}],558:[function(require,module,exports){
angular.module('ui.bootstrap.datetimepicker').run(['$templateCache', function($templateCache) {$templateCache.put('templates/datetimepicker.html','<div class="datetimepicker table-responsive">\n    <table class="table table-condensed {{ data.currentView }}-view">\n        <thead>\n        <tr>\n            <th class="left" data-ng-click="changeView(data.currentView, data.leftDate, $event)" data-ng-show="data.leftDate.selectable"><i class="glyphicon glyphicon-arrow-left"><span class="sr-only">{{ screenReader.previous }}</span></i>\n            </th>\n            <th class="switch" colspan="5" data-ng-show="data.previousViewDate.selectable" data-ng-click="changeView(data.previousView, data.previousViewDate, $event)">{{ data.previousViewDate.display }}</th>\n            <th class="right" data-ng-click="changeView(data.currentView, data.rightDate, $event)" data-ng-show="data.rightDate.selectable"><i class="glyphicon glyphicon-arrow-right"><span class="sr-only">{{ screenReader.next }}</span></i>\n            </th>\n        </tr>\n        <tr>\n            <th class="dow" data-ng-repeat="day in data.dayNames">{{ day }}</th>\n        </tr>\n        </thead>\n        <tbody>\n        <tr data-ng-if="data.currentView !== \'day\'">\n            <td colspan="7">\n                          <span class="{{ data.currentView }}" data-ng-repeat="dateObject in data.dates" data-ng-class="{current: dateObject.current, active: dateObject.active, past: dateObject.past, future: dateObject.future, disabled: !dateObject.selectable}" data-ng-click="changeView(data.nextView, dateObject, $event)">{{ dateObject.display }}</span></td>\n        </tr>\n        <tr data-ng-if="data.currentView === \'day\'" data-ng-repeat="week in data.weeks">\n            <td data-ng-repeat="dateObject in week.dates" data-ng-click="changeView(data.nextView, dateObject, $event)" class="day" data-ng-class="{current: dateObject.current, active: dateObject.active, past: dateObject.past, future: dateObject.future, disabled: !dateObject.selectable}">{{ dateObject.display }}</td>\n        </tr>\n        </tbody>\n    </table>\n</div>\n');}]);
},{}],559:[function(require,module,exports){
/* angularjs Scroll Glue
 * version 2.1.0
 * https://github.com/Luegg/angularjs-scroll-glue
 * An AngularJs directive that automatically scrolls to the bottom of an element on changes in it's scope.
*/

// Allow module to be loaded via require when using common js. e.g. npm
if(typeof module === "object" && module.exports){
    module.exports = 'luegg.directives';
}

(function(angular, undefined){
    'use strict';

    function createActivationState($parse, attr, scope){
        function unboundState(initValue){
            var activated = initValue;
            return {
                getValue: function(){
                    return activated;
                },
                setValue: function(value){
                    activated = value;
                }
            };
        }

        function oneWayBindingState(getter, scope){
            return {
                getValue: function(){
                    return getter(scope);
                },
                setValue: function(){}
            };
        }

        function twoWayBindingState(getter, setter, scope){
            return {
                getValue: function(){
                    return getter(scope);
                },
                setValue: function(value){
                    if(value !== getter(scope)){
                        scope.$apply(function(){
                            setter(scope, value);
                        });
                    }
                }
            };
        }

        if(attr !== ""){
            var getter = $parse(attr);
            if(getter.assign !== undefined){
                return twoWayBindingState(getter, getter.assign, scope);
            } else {
                return oneWayBindingState(getter, scope);
            }
        } else {
            return unboundState(true);
        }
    }

    function createDirective(module, attrName, direction){
        module.directive(attrName, ['$parse', '$window', '$timeout', function($parse, $window, $timeout){
            return {
                priority: 1,
                restrict: 'A',
                link: function(scope, $el, attrs){
                    var el = $el[0],
                        activationState = createActivationState($parse, attrs[attrName], scope);

                    function scrollIfGlued() {
                        if(activationState.getValue() && !direction.isAttached(el)){
                            // Ensures scroll after angular template digest
                            $timeout(function() {
                              direction.scroll(el);
                            });
                        }
                    }

                    function onScroll() {
                        activationState.setValue(direction.isAttached(el));
                    }

                    $timeout(scrollIfGlued, 0, false);

                    if (!$el[0].hasAttribute('force-glue')) {
                      $el.on('scroll', onScroll);
                    }

                    var hasAnchor = false;
                    angular.forEach($el.children(), function(child) {
                      if (child.hasAttribute('scroll-glue-anchor')) {
                        hasAnchor = true;
                        scope.$watch(function() { return child.offsetHeight }, function() {
                          scrollIfGlued();
                        });
                      }
                    });

                    if (!hasAnchor) {
                      scope.$watch(scrollIfGlued);
                      $window.addEventListener('resize', scrollIfGlued, false);
                    }

                    // Remove listeners on directive destroy
                    $el.on('$destroy', function() {
                        $el.unbind('scroll', onScroll);
                    });

                    scope.$on('$destroy', function() {
                        $window.removeEventListener('resize', scrollIfGlued, false);
                    });
                }
            };
        }]);
    }

    var bottom = {
        isAttached: function(el){
            // + 1 catches off by one errors in chrome
            return el.scrollTop + el.clientHeight + 1 >= el.scrollHeight;
        },
        scroll: function(el){
            el.scrollTop = el.scrollHeight;
        }
    };

    var top = {
        isAttached: function(el){
            return el.scrollTop <= 1;
        },
        scroll: function(el){
            el.scrollTop = 0;
        }
    };

    var right = {
        isAttached: function(el){
            return el.scrollLeft + el.clientWidth + 1 >= el.scrollWidth;
        },
        scroll: function(el){
            el.scrollLeft = el.scrollWidth;
        }
    };

    var left = {
        isAttached: function(el){
            return el.scrollLeft <= 1;
        },
        scroll: function(el){
            el.scrollLeft = 0;
        }
    };

    var module = angular.module('luegg.directives', []);

    createDirective(module, 'scrollGlue', bottom);
    createDirective(module, 'scrollGlueTop', top);
    createDirective(module, 'scrollGlueBottom', bottom);
    createDirective(module, 'scrollGlueLeft', left);
    createDirective(module, 'scrollGlueRight', right);
}(angular));

},{}],560:[function(require,module,exports){
(function (global){(function (){
'use strict';

var objectAssign = require('object-assign');

// compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:

/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
function compare(a, b) {
  if (a === b) {
    return 0;
  }

  var x = a.length;
  var y = b.length;

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i];
      y = b[i];
      break;
    }
  }

  if (x < y) {
    return -1;
  }
  if (y < x) {
    return 1;
  }
  return 0;
}
function isBuffer(b) {
  if (global.Buffer && typeof global.Buffer.isBuffer === 'function') {
    return global.Buffer.isBuffer(b);
  }
  return !!(b != null && b._isBuffer);
}

// based on node assert, original notice:
// NB: The URL to the CommonJS spec is kept just for tradition.
//     node-assert has evolved a lot since then, both in API and behavior.

// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
//
// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
//
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var util = require('util/');
var hasOwn = Object.prototype.hasOwnProperty;
var pSlice = Array.prototype.slice;
var functionsHaveNames = (function () {
  return function foo() {}.name === 'foo';
}());
function pToString (obj) {
  return Object.prototype.toString.call(obj);
}
function isView(arrbuf) {
  if (isBuffer(arrbuf)) {
    return false;
  }
  if (typeof global.ArrayBuffer !== 'function') {
    return false;
  }
  if (typeof ArrayBuffer.isView === 'function') {
    return ArrayBuffer.isView(arrbuf);
  }
  if (!arrbuf) {
    return false;
  }
  if (arrbuf instanceof DataView) {
    return true;
  }
  if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
    return true;
  }
  return false;
}
// 1. The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.

var assert = module.exports = ok;

// 2. The AssertionError is defined in assert.
// new assert.AssertionError({ message: message,
//                             actual: actual,
//                             expected: expected })

var regex = /\s*function\s+([^\(\s]*)\s*/;
// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
function getName(func) {
  if (!util.isFunction(func)) {
    return;
  }
  if (functionsHaveNames) {
    return func.name;
  }
  var str = func.toString();
  var match = str.match(regex);
  return match && match[1];
}
assert.AssertionError = function AssertionError(options) {
  this.name = 'AssertionError';
  this.actual = options.actual;
  this.expected = options.expected;
  this.operator = options.operator;
  if (options.message) {
    this.message = options.message;
    this.generatedMessage = false;
  } else {
    this.message = getMessage(this);
    this.generatedMessage = true;
  }
  var stackStartFunction = options.stackStartFunction || fail;
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, stackStartFunction);
  } else {
    // non v8 browsers so we can have a stacktrace
    var err = new Error();
    if (err.stack) {
      var out = err.stack;

      // try to strip useless frames
      var fn_name = getName(stackStartFunction);
      var idx = out.indexOf('\n' + fn_name);
      if (idx >= 0) {
        // once we have located the function frame
        // we need to strip out everything before it (and its line)
        var next_line = out.indexOf('\n', idx + 1);
        out = out.substring(next_line + 1);
      }

      this.stack = out;
    }
  }
};

// assert.AssertionError instanceof Error
util.inherits(assert.AssertionError, Error);

function truncate(s, n) {
  if (typeof s === 'string') {
    return s.length < n ? s : s.slice(0, n);
  } else {
    return s;
  }
}
function inspect(something) {
  if (functionsHaveNames || !util.isFunction(something)) {
    return util.inspect(something);
  }
  var rawname = getName(something);
  var name = rawname ? ': ' + rawname : '';
  return '[Function' +  name + ']';
}
function getMessage(self) {
  return truncate(inspect(self.actual), 128) + ' ' +
         self.operator + ' ' +
         truncate(inspect(self.expected), 128);
}

// At present only the three keys mentioned above are used and
// understood by the spec. Implementations or sub modules can pass
// other keys to the AssertionError's constructor - they will be
// ignored.

// 3. All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided.  All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.

function fail(actual, expected, message, operator, stackStartFunction) {
  throw new assert.AssertionError({
    message: message,
    actual: actual,
    expected: expected,
    operator: operator,
    stackStartFunction: stackStartFunction
  });
}

// EXTENSION! allows for well behaved errors defined elsewhere.
assert.fail = fail;

// 4. Pure assertion tests whether a value is truthy, as determined
// by !!guard.
// assert.ok(guard, message_opt);
// This statement is equivalent to assert.equal(true, !!guard,
// message_opt);. To test strictly for the value true, use
// assert.strictEqual(true, guard, message_opt);.

function ok(value, message) {
  if (!value) fail(value, true, message, '==', assert.ok);
}
assert.ok = ok;

// 5. The equality assertion tests shallow, coercive equality with
// ==.
// assert.equal(actual, expected, message_opt);

assert.equal = function equal(actual, expected, message) {
  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
};

// 6. The non-equality assertion tests for whether two objects are not equal
// with != assert.notEqual(actual, expected, message_opt);

assert.notEqual = function notEqual(actual, expected, message) {
  if (actual == expected) {
    fail(actual, expected, message, '!=', assert.notEqual);
  }
};

// 7. The equivalence assertion tests a deep equality relation.
// assert.deepEqual(actual, expected, message_opt);

assert.deepEqual = function deepEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected, false)) {
    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
  }
};

assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected, true)) {
    fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
  }
};

function _deepEqual(actual, expected, strict, memos) {
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;
  } else if (isBuffer(actual) && isBuffer(expected)) {
    return compare(actual, expected) === 0;

  // 7.2. If the expected value is a Date object, the actual value is
  // equivalent if it is also a Date object that refers to the same time.
  } else if (util.isDate(actual) && util.isDate(expected)) {
    return actual.getTime() === expected.getTime();

  // 7.3 If the expected value is a RegExp object, the actual value is
  // equivalent if it is also a RegExp object with the same source and
  // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
    return actual.source === expected.source &&
           actual.global === expected.global &&
           actual.multiline === expected.multiline &&
           actual.lastIndex === expected.lastIndex &&
           actual.ignoreCase === expected.ignoreCase;

  // 7.4. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if ((actual === null || typeof actual !== 'object') &&
             (expected === null || typeof expected !== 'object')) {
    return strict ? actual === expected : actual == expected;

  // If both values are instances of typed arrays, wrap their underlying
  // ArrayBuffers in a Buffer each to increase performance
  // This optimization requires the arrays to have the same type as checked by
  // Object.prototype.toString (aka pToString). Never perform binary
  // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
  // bit patterns are not identical.
  } else if (isView(actual) && isView(expected) &&
             pToString(actual) === pToString(expected) &&
             !(actual instanceof Float32Array ||
               actual instanceof Float64Array)) {
    return compare(new Uint8Array(actual.buffer),
                   new Uint8Array(expected.buffer)) === 0;

  // 7.5 For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else if (isBuffer(actual) !== isBuffer(expected)) {
    return false;
  } else {
    memos = memos || {actual: [], expected: []};

    var actualIndex = memos.actual.indexOf(actual);
    if (actualIndex !== -1) {
      if (actualIndex === memos.expected.indexOf(expected)) {
        return true;
      }
    }

    memos.actual.push(actual);
    memos.expected.push(expected);

    return objEquiv(actual, expected, strict, memos);
  }
}

function isArguments(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
}

function objEquiv(a, b, strict, actualVisitedObjects) {
  if (a === null || a === undefined || b === null || b === undefined)
    return false;
  // if one is a primitive, the other must be same
  if (util.isPrimitive(a) || util.isPrimitive(b))
    return a === b;
  if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
    return false;
  var aIsArgs = isArguments(a);
  var bIsArgs = isArguments(b);
  if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
    return false;
  if (aIsArgs) {
    a = pSlice.call(a);
    b = pSlice.call(b);
    return _deepEqual(a, b, strict);
  }
  var ka = objectKeys(a);
  var kb = objectKeys(b);
  var key, i;
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length !== kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] !== kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
      return false;
  }
  return true;
}

// 8. The non-equivalence assertion tests for any deep inequality.
// assert.notDeepEqual(actual, expected, message_opt);

assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
  if (_deepEqual(actual, expected, false)) {
    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
  }
};

assert.notDeepStrictEqual = notDeepStrictEqual;
function notDeepStrictEqual(actual, expected, message) {
  if (_deepEqual(actual, expected, true)) {
    fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
  }
}


// 9. The strict equality assertion tests strict equality, as determined by ===.
// assert.strictEqual(actual, expected, message_opt);

assert.strictEqual = function strictEqual(actual, expected, message) {
  if (actual !== expected) {
    fail(actual, expected, message, '===', assert.strictEqual);
  }
};

// 10. The strict non-equality assertion tests for strict inequality, as
// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);

assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
  if (actual === expected) {
    fail(actual, expected, message, '!==', assert.notStrictEqual);
  }
};

function expectedException(actual, expected) {
  if (!actual || !expected) {
    return false;
  }

  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
    return expected.test(actual);
  }

  try {
    if (actual instanceof expected) {
      return true;
    }
  } catch (e) {
    // Ignore.  The instanceof check doesn't work for arrow functions.
  }

  if (Error.isPrototypeOf(expected)) {
    return false;
  }

  return expected.call({}, actual) === true;
}

function _tryBlock(block) {
  var error;
  try {
    block();
  } catch (e) {
    error = e;
  }
  return error;
}

function _throws(shouldThrow, block, expected, message) {
  var actual;

  if (typeof block !== 'function') {
    throw new TypeError('"block" argument must be a function');
  }

  if (typeof expected === 'string') {
    message = expected;
    expected = null;
  }

  actual = _tryBlock(block);

  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
            (message ? ' ' + message : '.');

  if (shouldThrow && !actual) {
    fail(actual, expected, 'Missing expected exception' + message);
  }

  var userProvidedMessage = typeof message === 'string';
  var isUnwantedException = !shouldThrow && util.isError(actual);
  var isUnexpectedException = !shouldThrow && actual && !expected;

  if ((isUnwantedException &&
      userProvidedMessage &&
      expectedException(actual, expected)) ||
      isUnexpectedException) {
    fail(actual, expected, 'Got unwanted exception' + message);
  }

  if ((shouldThrow && actual && expected &&
      !expectedException(actual, expected)) || (!shouldThrow && actual)) {
    throw actual;
  }
}

// 11. Expected to throw an error:
// assert.throws(block, Error_opt, message_opt);

assert.throws = function(block, /*optional*/error, /*optional*/message) {
  _throws(true, block, error, message);
};

// EXTENSION! This is annoying to write outside this module.
assert.doesNotThrow = function(block, /*optional*/error, /*optional*/message) {
  _throws(false, block, error, message);
};

assert.ifError = function(err) { if (err) throw err; };

// Expose a strict only variant of assert
function strict(value, message) {
  if (!value) fail(value, true, message, '==', strict);
}
assert.strict = objectAssign(strict, assert, {
  equal: assert.strictEqual,
  deepEqual: assert.deepStrictEqual,
  notEqual: assert.notStrictEqual,
  notDeepEqual: assert.notDeepStrictEqual
});
assert.strict.strict = assert.strict;

var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    if (hasOwn.call(obj, key)) keys.push(key);
  }
  return keys;
};

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"object-assign":1168,"util/":563}],561:[function(require,module,exports){
if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}

},{}],562:[function(require,module,exports){
module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}
},{}],563:[function(require,module,exports){
(function (process,global){(function (){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  // Allow for deprecating things in the process of starting up.
  if (isUndefined(global.process)) {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  if (process.noDeprecation === true) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = process.env.NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = require('./support/isBuffer');

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = require('inherits');

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./support/isBuffer":562,"_process":1185,"inherits":561}],564:[function(require,module,exports){
(function (global){(function (){
'use strict';

var possibleNames = [
	'BigInt64Array',
	'BigUint64Array',
	'Float32Array',
	'Float64Array',
	'Int16Array',
	'Int32Array',
	'Int8Array',
	'Uint16Array',
	'Uint32Array',
	'Uint8Array',
	'Uint8ClampedArray'
];

var g = typeof globalThis === 'undefined' ? global : globalThis;

module.exports = function availableTypedArrays() {
	var out = [];
	for (var i = 0; i < possibleNames.length; i++) {
		if (typeof g[possibleNames[i]] === 'function') {
			out[out.length] = possibleNames[i];
		}
	}
	return out;
};

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],565:[function(require,module,exports){
'use strict'

exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}

},{}],566:[function(require,module,exports){

},{}],567:[function(require,module,exports){
(function (process,Buffer){(function (){
'use strict';
/* eslint camelcase: "off" */

var assert = require('assert');

var Zstream = require('pako/lib/zlib/zstream');
var zlib_deflate = require('pako/lib/zlib/deflate.js');
var zlib_inflate = require('pako/lib/zlib/inflate.js');
var constants = require('pako/lib/zlib/constants');

for (var key in constants) {
  exports[key] = constants[key];
}

// zlib modes
exports.NONE = 0;
exports.DEFLATE = 1;
exports.INFLATE = 2;
exports.GZIP = 3;
exports.GUNZIP = 4;
exports.DEFLATERAW = 5;
exports.INFLATERAW = 6;
exports.UNZIP = 7;

var GZIP_HEADER_ID1 = 0x1f;
var GZIP_HEADER_ID2 = 0x8b;

/**
 * Emulate Node's zlib C++ layer for use by the JS layer in index.js
 */
function Zlib(mode) {
  if (typeof mode !== 'number' || mode < exports.DEFLATE || mode > exports.UNZIP) {
    throw new TypeError('Bad argument');
  }

  this.dictionary = null;
  this.err = 0;
  this.flush = 0;
  this.init_done = false;
  this.level = 0;
  this.memLevel = 0;
  this.mode = mode;
  this.strategy = 0;
  this.windowBits = 0;
  this.write_in_progress = false;
  this.pending_close = false;
  this.gzip_id_bytes_read = 0;
}

Zlib.prototype.close = function () {
  if (this.write_in_progress) {
    this.pending_close = true;
    return;
  }

  this.pending_close = false;

  assert(this.init_done, 'close before init');
  assert(this.mode <= exports.UNZIP);

  if (this.mode === exports.DEFLATE || this.mode === exports.GZIP || this.mode === exports.DEFLATERAW) {
    zlib_deflate.deflateEnd(this.strm);
  } else if (this.mode === exports.INFLATE || this.mode === exports.GUNZIP || this.mode === exports.INFLATERAW || this.mode === exports.UNZIP) {
    zlib_inflate.inflateEnd(this.strm);
  }

  this.mode = exports.NONE;

  this.dictionary = null;
};

Zlib.prototype.write = function (flush, input, in_off, in_len, out, out_off, out_len) {
  return this._write(true, flush, input, in_off, in_len, out, out_off, out_len);
};

Zlib.prototype.writeSync = function (flush, input, in_off, in_len, out, out_off, out_len) {
  return this._write(false, flush, input, in_off, in_len, out, out_off, out_len);
};

Zlib.prototype._write = function (async, flush, input, in_off, in_len, out, out_off, out_len) {
  assert.equal(arguments.length, 8);

  assert(this.init_done, 'write before init');
  assert(this.mode !== exports.NONE, 'already finalized');
  assert.equal(false, this.write_in_progress, 'write already in progress');
  assert.equal(false, this.pending_close, 'close is pending');

  this.write_in_progress = true;

  assert.equal(false, flush === undefined, 'must provide flush value');

  this.write_in_progress = true;

  if (flush !== exports.Z_NO_FLUSH && flush !== exports.Z_PARTIAL_FLUSH && flush !== exports.Z_SYNC_FLUSH && flush !== exports.Z_FULL_FLUSH && flush !== exports.Z_FINISH && flush !== exports.Z_BLOCK) {
    throw new Error('Invalid flush value');
  }

  if (input == null) {
    input = Buffer.alloc(0);
    in_len = 0;
    in_off = 0;
  }

  this.strm.avail_in = in_len;
  this.strm.input = input;
  this.strm.next_in = in_off;
  this.strm.avail_out = out_len;
  this.strm.output = out;
  this.strm.next_out = out_off;
  this.flush = flush;

  if (!async) {
    // sync version
    this._process();

    if (this._checkError()) {
      return this._afterSync();
    }
    return;
  }

  // async version
  var self = this;
  process.nextTick(function () {
    self._process();
    self._after();
  });

  return this;
};

Zlib.prototype._afterSync = function () {
  var avail_out = this.strm.avail_out;
  var avail_in = this.strm.avail_in;

  this.write_in_progress = false;

  return [avail_in, avail_out];
};

Zlib.prototype._process = function () {
  var next_expected_header_byte = null;

  // If the avail_out is left at 0, then it means that it ran out
  // of room.  If there was avail_out left over, then it means
  // that all of the input was consumed.
  switch (this.mode) {
    case exports.DEFLATE:
    case exports.GZIP:
    case exports.DEFLATERAW:
      this.err = zlib_deflate.deflate(this.strm, this.flush);
      break;
    case exports.UNZIP:
      if (this.strm.avail_in > 0) {
        next_expected_header_byte = this.strm.next_in;
      }

      switch (this.gzip_id_bytes_read) {
        case 0:
          if (next_expected_header_byte === null) {
            break;
          }

          if (this.strm.input[next_expected_header_byte] === GZIP_HEADER_ID1) {
            this.gzip_id_bytes_read = 1;
            next_expected_header_byte++;

            if (this.strm.avail_in === 1) {
              // The only available byte was already read.
              break;
            }
          } else {
            this.mode = exports.INFLATE;
            break;
          }

        // fallthrough
        case 1:
          if (next_expected_header_byte === null) {
            break;
          }

          if (this.strm.input[next_expected_header_byte] === GZIP_HEADER_ID2) {
            this.gzip_id_bytes_read = 2;
            this.mode = exports.GUNZIP;
          } else {
            // There is no actual difference between INFLATE and INFLATERAW
            // (after initialization).
            this.mode = exports.INFLATE;
          }

          break;
        default:
          throw new Error('invalid number of gzip magic number bytes read');
      }

    // fallthrough
    case exports.INFLATE:
    case exports.GUNZIP:
    case exports.INFLATERAW:
      this.err = zlib_inflate.inflate(this.strm, this.flush

      // If data was encoded with dictionary
      );if (this.err === exports.Z_NEED_DICT && this.dictionary) {
        // Load it
        this.err = zlib_inflate.inflateSetDictionary(this.strm, this.dictionary);
        if (this.err === exports.Z_OK) {
          // And try to decode again
          this.err = zlib_inflate.inflate(this.strm, this.flush);
        } else if (this.err === exports.Z_DATA_ERROR) {
          // Both inflateSetDictionary() and inflate() return Z_DATA_ERROR.
          // Make it possible for After() to tell a bad dictionary from bad
          // input.
          this.err = exports.Z_NEED_DICT;
        }
      }
      while (this.strm.avail_in > 0 && this.mode === exports.GUNZIP && this.err === exports.Z_STREAM_END && this.strm.next_in[0] !== 0x00) {
        // Bytes remain in input buffer. Perhaps this is another compressed
        // member in the same archive, or just trailing garbage.
        // Trailing zero bytes are okay, though, since they are frequently
        // used for padding.

        this.reset();
        this.err = zlib_inflate.inflate(this.strm, this.flush);
      }
      break;
    default:
      throw new Error('Unknown mode ' + this.mode);
  }
};

Zlib.prototype._checkError = function () {
  // Acceptable error states depend on the type of zlib stream.
  switch (this.err) {
    case exports.Z_OK:
    case exports.Z_BUF_ERROR:
      if (this.strm.avail_out !== 0 && this.flush === exports.Z_FINISH) {
        this._error('unexpected end of file');
        return false;
      }
      break;
    case exports.Z_STREAM_END:
      // normal statuses, not fatal
      break;
    case exports.Z_NEED_DICT:
      if (this.dictionary == null) {
        this._error('Missing dictionary');
      } else {
        this._error('Bad dictionary');
      }
      return false;
    default:
      // something else.
      this._error('Zlib error');
      return false;
  }

  return true;
};

Zlib.prototype._after = function () {
  if (!this._checkError()) {
    return;
  }

  var avail_out = this.strm.avail_out;
  var avail_in = this.strm.avail_in;

  this.write_in_progress = false;

  // call the write() cb
  this.callback(avail_in, avail_out);

  if (this.pending_close) {
    this.close();
  }
};

Zlib.prototype._error = function (message) {
  if (this.strm.msg) {
    message = this.strm.msg;
  }
  this.onerror(message, this.err

  // no hope of rescue.
  );this.write_in_progress = false;
  if (this.pending_close) {
    this.close();
  }
};

Zlib.prototype.init = function (windowBits, level, memLevel, strategy, dictionary) {
  assert(arguments.length === 4 || arguments.length === 5, 'init(windowBits, level, memLevel, strategy, [dictionary])');

  assert(windowBits >= 8 && windowBits <= 15, 'invalid windowBits');
  assert(level >= -1 && level <= 9, 'invalid compression level');

  assert(memLevel >= 1 && memLevel <= 9, 'invalid memlevel');

  assert(strategy === exports.Z_FILTERED || strategy === exports.Z_HUFFMAN_ONLY || strategy === exports.Z_RLE || strategy === exports.Z_FIXED || strategy === exports.Z_DEFAULT_STRATEGY, 'invalid strategy');

  this._init(level, windowBits, memLevel, strategy, dictionary);
  this._setDictionary();
};

Zlib.prototype.params = function () {
  throw new Error('deflateParams Not supported');
};

Zlib.prototype.reset = function () {
  this._reset();
  this._setDictionary();
};

Zlib.prototype._init = function (level, windowBits, memLevel, strategy, dictionary) {
  this.level = level;
  this.windowBits = windowBits;
  this.memLevel = memLevel;
  this.strategy = strategy;

  this.flush = exports.Z_NO_FLUSH;

  this.err = exports.Z_OK;

  if (this.mode === exports.GZIP || this.mode === exports.GUNZIP) {
    this.windowBits += 16;
  }

  if (this.mode === exports.UNZIP) {
    this.windowBits += 32;
  }

  if (this.mode === exports.DEFLATERAW || this.mode === exports.INFLATERAW) {
    this.windowBits = -1 * this.windowBits;
  }

  this.strm = new Zstream();

  switch (this.mode) {
    case exports.DEFLATE:
    case exports.GZIP:
    case exports.DEFLATERAW:
      this.err = zlib_deflate.deflateInit2(this.strm, this.level, exports.Z_DEFLATED, this.windowBits, this.memLevel, this.strategy);
      break;
    case exports.INFLATE:
    case exports.GUNZIP:
    case exports.INFLATERAW:
    case exports.UNZIP:
      this.err = zlib_inflate.inflateInit2(this.strm, this.windowBits);
      break;
    default:
      throw new Error('Unknown mode ' + this.mode);
  }

  if (this.err !== exports.Z_OK) {
    this._error('Init error');
  }

  this.dictionary = dictionary;

  this.write_in_progress = false;
  this.init_done = true;
};

Zlib.prototype._setDictionary = function () {
  if (this.dictionary == null) {
    return;
  }

  this.err = exports.Z_OK;

  switch (this.mode) {
    case exports.DEFLATE:
    case exports.DEFLATERAW:
      this.err = zlib_deflate.deflateSetDictionary(this.strm, this.dictionary);
      break;
    default:
      break;
  }

  if (this.err !== exports.Z_OK) {
    this._error('Failed to set dictionary');
  }
};

Zlib.prototype._reset = function () {
  this.err = exports.Z_OK;

  switch (this.mode) {
    case exports.DEFLATE:
    case exports.DEFLATERAW:
    case exports.GZIP:
      this.err = zlib_deflate.deflateReset(this.strm);
      break;
    case exports.INFLATE:
    case exports.INFLATERAW:
    case exports.GUNZIP:
      this.err = zlib_inflate.inflateReset(this.strm);
      break;
    default:
      break;
  }

  if (this.err !== exports.Z_OK) {
    this._error('Failed to reset stream');
  }
};

exports.Zlib = Zlib;
}).call(this)}).call(this,require('_process'),require("buffer").Buffer)
},{"_process":1185,"assert":560,"buffer":570,"pako/lib/zlib/constants":1172,"pako/lib/zlib/deflate.js":1174,"pako/lib/zlib/inflate.js":1176,"pako/lib/zlib/zstream":1180}],568:[function(require,module,exports){
(function (process){(function (){
'use strict';

var Buffer = require('buffer').Buffer;
var Transform = require('stream').Transform;
var binding = require('./binding');
var util = require('util');
var assert = require('assert').ok;
var kMaxLength = require('buffer').kMaxLength;
var kRangeErrorMessage = 'Cannot create final Buffer. It would be larger ' + 'than 0x' + kMaxLength.toString(16) + ' bytes';

// zlib doesn't provide these, so kludge them in following the same
// const naming scheme zlib uses.
binding.Z_MIN_WINDOWBITS = 8;
binding.Z_MAX_WINDOWBITS = 15;
binding.Z_DEFAULT_WINDOWBITS = 15;

// fewer than 64 bytes per chunk is stupid.
// technically it could work with as few as 8, but even 64 bytes
// is absurdly low.  Usually a MB or more is best.
binding.Z_MIN_CHUNK = 64;
binding.Z_MAX_CHUNK = Infinity;
binding.Z_DEFAULT_CHUNK = 16 * 1024;

binding.Z_MIN_MEMLEVEL = 1;
binding.Z_MAX_MEMLEVEL = 9;
binding.Z_DEFAULT_MEMLEVEL = 8;

binding.Z_MIN_LEVEL = -1;
binding.Z_MAX_LEVEL = 9;
binding.Z_DEFAULT_LEVEL = binding.Z_DEFAULT_COMPRESSION;

// expose all the zlib constants
var bkeys = Object.keys(binding);
for (var bk = 0; bk < bkeys.length; bk++) {
  var bkey = bkeys[bk];
  if (bkey.match(/^Z/)) {
    Object.defineProperty(exports, bkey, {
      enumerable: true, value: binding[bkey], writable: false
    });
  }
}

// translation table for return codes.
var codes = {
  Z_OK: binding.Z_OK,
  Z_STREAM_END: binding.Z_STREAM_END,
  Z_NEED_DICT: binding.Z_NEED_DICT,
  Z_ERRNO: binding.Z_ERRNO,
  Z_STREAM_ERROR: binding.Z_STREAM_ERROR,
  Z_DATA_ERROR: binding.Z_DATA_ERROR,
  Z_MEM_ERROR: binding.Z_MEM_ERROR,
  Z_BUF_ERROR: binding.Z_BUF_ERROR,
  Z_VERSION_ERROR: binding.Z_VERSION_ERROR
};

var ckeys = Object.keys(codes);
for (var ck = 0; ck < ckeys.length; ck++) {
  var ckey = ckeys[ck];
  codes[codes[ckey]] = ckey;
}

Object.defineProperty(exports, 'codes', {
  enumerable: true, value: Object.freeze(codes), writable: false
});

exports.Deflate = Deflate;
exports.Inflate = Inflate;
exports.Gzip = Gzip;
exports.Gunzip = Gunzip;
exports.DeflateRaw = DeflateRaw;
exports.InflateRaw = InflateRaw;
exports.Unzip = Unzip;

exports.createDeflate = function (o) {
  return new Deflate(o);
};

exports.createInflate = function (o) {
  return new Inflate(o);
};

exports.createDeflateRaw = function (o) {
  return new DeflateRaw(o);
};

exports.createInflateRaw = function (o) {
  return new InflateRaw(o);
};

exports.createGzip = function (o) {
  return new Gzip(o);
};

exports.createGunzip = function (o) {
  return new Gunzip(o);
};

exports.createUnzip = function (o) {
  return new Unzip(o);
};

// Convenience methods.
// compress/decompress a string or buffer in one step.
exports.deflate = function (buffer, opts, callback) {
  if (typeof opts === 'function') {
    callback = opts;
    opts = {};
  }
  return zlibBuffer(new Deflate(opts), buffer, callback);
};

exports.deflateSync = function (buffer, opts) {
  return zlibBufferSync(new Deflate(opts), buffer);
};

exports.gzip = function (buffer, opts, callback) {
  if (typeof opts === 'function') {
    callback = opts;
    opts = {};
  }
  return zlibBuffer(new Gzip(opts), buffer, callback);
};

exports.gzipSync = function (buffer, opts) {
  return zlibBufferSync(new Gzip(opts), buffer);
};

exports.deflateRaw = function (buffer, opts, callback) {
  if (typeof opts === 'function') {
    callback = opts;
    opts = {};
  }
  return zlibBuffer(new DeflateRaw(opts), buffer, callback);
};

exports.deflateRawSync = function (buffer, opts) {
  return zlibBufferSync(new DeflateRaw(opts), buffer);
};

exports.unzip = function (buffer, opts, callback) {
  if (typeof opts === 'function') {
    callback = opts;
    opts = {};
  }
  return zlibBuffer(new Unzip(opts), buffer, callback);
};

exports.unzipSync = function (buffer, opts) {
  return zlibBufferSync(new Unzip(opts), buffer);
};

exports.inflate = function (buffer, opts, callback) {
  if (typeof opts === 'function') {
    callback = opts;
    opts = {};
  }
  return zlibBuffer(new Inflate(opts), buffer, callback);
};

exports.inflateSync = function (buffer, opts) {
  return zlibBufferSync(new Inflate(opts), buffer);
};

exports.gunzip = function (buffer, opts, callback) {
  if (typeof opts === 'function') {
    callback = opts;
    opts = {};
  }
  return zlibBuffer(new Gunzip(opts), buffer, callback);
};

exports.gunzipSync = function (buffer, opts) {
  return zlibBufferSync(new Gunzip(opts), buffer);
};

exports.inflateRaw = function (buffer, opts, callback) {
  if (typeof opts === 'function') {
    callback = opts;
    opts = {};
  }
  return zlibBuffer(new InflateRaw(opts), buffer, callback);
};

exports.inflateRawSync = function (buffer, opts) {
  return zlibBufferSync(new InflateRaw(opts), buffer);
};

function zlibBuffer(engine, buffer, callback) {
  var buffers = [];
  var nread = 0;

  engine.on('error', onError);
  engine.on('end', onEnd);

  engine.end(buffer);
  flow();

  function flow() {
    var chunk;
    while (null !== (chunk = engine.read())) {
      buffers.push(chunk);
      nread += chunk.length;
    }
    engine.once('readable', flow);
  }

  function onError(err) {
    engine.removeListener('end', onEnd);
    engine.removeListener('readable', flow);
    callback(err);
  }

  function onEnd() {
    var buf;
    var err = null;

    if (nread >= kMaxLength) {
      err = new RangeError(kRangeErrorMessage);
    } else {
      buf = Buffer.concat(buffers, nread);
    }

    buffers = [];
    engine.close();
    callback(err, buf);
  }
}

function zlibBufferSync(engine, buffer) {
  if (typeof buffer === 'string') buffer = Buffer.from(buffer);

  if (!Buffer.isBuffer(buffer)) throw new TypeError('Not a string or buffer');

  var flushFlag = engine._finishFlushFlag;

  return engine._processChunk(buffer, flushFlag);
}

// generic zlib
// minimal 2-byte header
function Deflate(opts) {
  if (!(this instanceof Deflate)) return new Deflate(opts);
  Zlib.call(this, opts, binding.DEFLATE);
}

function Inflate(opts) {
  if (!(this instanceof Inflate)) return new Inflate(opts);
  Zlib.call(this, opts, binding.INFLATE);
}

// gzip - bigger header, same deflate compression
function Gzip(opts) {
  if (!(this instanceof Gzip)) return new Gzip(opts);
  Zlib.call(this, opts, binding.GZIP);
}

function Gunzip(opts) {
  if (!(this instanceof Gunzip)) return new Gunzip(opts);
  Zlib.call(this, opts, binding.GUNZIP);
}

// raw - no header
function DeflateRaw(opts) {
  if (!(this instanceof DeflateRaw)) return new DeflateRaw(opts);
  Zlib.call(this, opts, binding.DEFLATERAW);
}

function InflateRaw(opts) {
  if (!(this instanceof InflateRaw)) return new InflateRaw(opts);
  Zlib.call(this, opts, binding.INFLATERAW);
}

// auto-detect header.
function Unzip(opts) {
  if (!(this instanceof Unzip)) return new Unzip(opts);
  Zlib.call(this, opts, binding.UNZIP);
}

function isValidFlushFlag(flag) {
  return flag === binding.Z_NO_FLUSH || flag === binding.Z_PARTIAL_FLUSH || flag === binding.Z_SYNC_FLUSH || flag === binding.Z_FULL_FLUSH || flag === binding.Z_FINISH || flag === binding.Z_BLOCK;
}

// the Zlib class they all inherit from
// This thing manages the queue of requests, and returns
// true or false if there is anything in the queue when
// you call the .write() method.

function Zlib(opts, mode) {
  var _this = this;

  this._opts = opts = opts || {};
  this._chunkSize = opts.chunkSize || exports.Z_DEFAULT_CHUNK;

  Transform.call(this, opts);

  if (opts.flush && !isValidFlushFlag(opts.flush)) {
    throw new Error('Invalid flush flag: ' + opts.flush);
  }
  if (opts.finishFlush && !isValidFlushFlag(opts.finishFlush)) {
    throw new Error('Invalid flush flag: ' + opts.finishFlush);
  }

  this._flushFlag = opts.flush || binding.Z_NO_FLUSH;
  this._finishFlushFlag = typeof opts.finishFlush !== 'undefined' ? opts.finishFlush : binding.Z_FINISH;

  if (opts.chunkSize) {
    if (opts.chunkSize < exports.Z_MIN_CHUNK || opts.chunkSize > exports.Z_MAX_CHUNK) {
      throw new Error('Invalid chunk size: ' + opts.chunkSize);
    }
  }

  if (opts.windowBits) {
    if (opts.windowBits < exports.Z_MIN_WINDOWBITS || opts.windowBits > exports.Z_MAX_WINDOWBITS) {
      throw new Error('Invalid windowBits: ' + opts.windowBits);
    }
  }

  if (opts.level) {
    if (opts.level < exports.Z_MIN_LEVEL || opts.level > exports.Z_MAX_LEVEL) {
      throw new Error('Invalid compression level: ' + opts.level);
    }
  }

  if (opts.memLevel) {
    if (opts.memLevel < exports.Z_MIN_MEMLEVEL || opts.memLevel > exports.Z_MAX_MEMLEVEL) {
      throw new Error('Invalid memLevel: ' + opts.memLevel);
    }
  }

  if (opts.strategy) {
    if (opts.strategy != exports.Z_FILTERED && opts.strategy != exports.Z_HUFFMAN_ONLY && opts.strategy != exports.Z_RLE && opts.strategy != exports.Z_FIXED && opts.strategy != exports.Z_DEFAULT_STRATEGY) {
      throw new Error('Invalid strategy: ' + opts.strategy);
    }
  }

  if (opts.dictionary) {
    if (!Buffer.isBuffer(opts.dictionary)) {
      throw new Error('Invalid dictionary: it should be a Buffer instance');
    }
  }

  this._handle = new binding.Zlib(mode);

  var self = this;
  this._hadError = false;
  this._handle.onerror = function (message, errno) {
    // there is no way to cleanly recover.
    // continuing only obscures problems.
    _close(self);
    self._hadError = true;

    var error = new Error(message);
    error.errno = errno;
    error.code = exports.codes[errno];
    self.emit('error', error);
  };

  var level = exports.Z_DEFAULT_COMPRESSION;
  if (typeof opts.level === 'number') level = opts.level;

  var strategy = exports.Z_DEFAULT_STRATEGY;
  if (typeof opts.strategy === 'number') strategy = opts.strategy;

  this._handle.init(opts.windowBits || exports.Z_DEFAULT_WINDOWBITS, level, opts.memLevel || exports.Z_DEFAULT_MEMLEVEL, strategy, opts.dictionary);

  this._buffer = Buffer.allocUnsafe(this._chunkSize);
  this._offset = 0;
  this._level = level;
  this._strategy = strategy;

  this.once('end', this.close);

  Object.defineProperty(this, '_closed', {
    get: function () {
      return !_this._handle;
    },
    configurable: true,
    enumerable: true
  });
}

util.inherits(Zlib, Transform);

Zlib.prototype.params = function (level, strategy, callback) {
  if (level < exports.Z_MIN_LEVEL || level > exports.Z_MAX_LEVEL) {
    throw new RangeError('Invalid compression level: ' + level);
  }
  if (strategy != exports.Z_FILTERED && strategy != exports.Z_HUFFMAN_ONLY && strategy != exports.Z_RLE && strategy != exports.Z_FIXED && strategy != exports.Z_DEFAULT_STRATEGY) {
    throw new TypeError('Invalid strategy: ' + strategy);
  }

  if (this._level !== level || this._strategy !== strategy) {
    var self = this;
    this.flush(binding.Z_SYNC_FLUSH, function () {
      assert(self._handle, 'zlib binding closed');
      self._handle.params(level, strategy);
      if (!self._hadError) {
        self._level = level;
        self._strategy = strategy;
        if (callback) callback();
      }
    });
  } else {
    process.nextTick(callback);
  }
};

Zlib.prototype.reset = function () {
  assert(this._handle, 'zlib binding closed');
  return this._handle.reset();
};

// This is the _flush function called by the transform class,
// internally, when the last chunk has been written.
Zlib.prototype._flush = function (callback) {
  this._transform(Buffer.alloc(0), '', callback);
};

Zlib.prototype.flush = function (kind, callback) {
  var _this2 = this;

  var ws = this._writableState;

  if (typeof kind === 'function' || kind === undefined && !callback) {
    callback = kind;
    kind = binding.Z_FULL_FLUSH;
  }

  if (ws.ended) {
    if (callback) process.nextTick(callback);
  } else if (ws.ending) {
    if (callback) this.once('end', callback);
  } else if (ws.needDrain) {
    if (callback) {
      this.once('drain', function () {
        return _this2.flush(kind, callback);
      });
    }
  } else {
    this._flushFlag = kind;
    this.write(Buffer.alloc(0), '', callback);
  }
};

Zlib.prototype.close = function (callback) {
  _close(this, callback);
  process.nextTick(emitCloseNT, this);
};

function _close(engine, callback) {
  if (callback) process.nextTick(callback);

  // Caller may invoke .close after a zlib error (which will null _handle).
  if (!engine._handle) return;

  engine._handle.close();
  engine._handle = null;
}

function emitCloseNT(self) {
  self.emit('close');
}

Zlib.prototype._transform = function (chunk, encoding, cb) {
  var flushFlag;
  var ws = this._writableState;
  var ending = ws.ending || ws.ended;
  var last = ending && (!chunk || ws.length === chunk.length);

  if (chunk !== null && !Buffer.isBuffer(chunk)) return cb(new Error('invalid input'));

  if (!this._handle) return cb(new Error('zlib binding closed'));

  // If it's the last chunk, or a final flush, we use the Z_FINISH flush flag
  // (or whatever flag was provided using opts.finishFlush).
  // If it's explicitly flushing at some other time, then we use
  // Z_FULL_FLUSH. Otherwise, use Z_NO_FLUSH for maximum compression
  // goodness.
  if (last) flushFlag = this._finishFlushFlag;else {
    flushFlag = this._flushFlag;
    // once we've flushed the last of the queue, stop flushing and
    // go back to the normal behavior.
    if (chunk.length >= ws.length) {
      this._flushFlag = this._opts.flush || binding.Z_NO_FLUSH;
    }
  }

  this._processChunk(chunk, flushFlag, cb);
};

Zlib.prototype._processChunk = function (chunk, flushFlag, cb) {
  var availInBefore = chunk && chunk.length;
  var availOutBefore = this._chunkSize - this._offset;
  var inOff = 0;

  var self = this;

  var async = typeof cb === 'function';

  if (!async) {
    var buffers = [];
    var nread = 0;

    var error;
    this.on('error', function (er) {
      error = er;
    });

    assert(this._handle, 'zlib binding closed');
    do {
      var res = this._handle.writeSync(flushFlag, chunk, // in
      inOff, // in_off
      availInBefore, // in_len
      this._buffer, // out
      this._offset, //out_off
      availOutBefore); // out_len
    } while (!this._hadError && callback(res[0], res[1]));

    if (this._hadError) {
      throw error;
    }

    if (nread >= kMaxLength) {
      _close(this);
      throw new RangeError(kRangeErrorMessage);
    }

    var buf = Buffer.concat(buffers, nread);
    _close(this);

    return buf;
  }

  assert(this._handle, 'zlib binding closed');
  var req = this._handle.write(flushFlag, chunk, // in
  inOff, // in_off
  availInBefore, // in_len
  this._buffer, // out
  this._offset, //out_off
  availOutBefore); // out_len

  req.buffer = chunk;
  req.callback = callback;

  function callback(availInAfter, availOutAfter) {
    // When the callback is used in an async write, the callback's
    // context is the `req` object that was created. The req object
    // is === this._handle, and that's why it's important to null
    // out the values after they are done being used. `this._handle`
    // can stay in memory longer than the callback and buffer are needed.
    if (this) {
      this.buffer = null;
      this.callback = null;
    }

    if (self._hadError) return;

    var have = availOutBefore - availOutAfter;
    assert(have >= 0, 'have should not go down');

    if (have > 0) {
      var out = self._buffer.slice(self._offset, self._offset + have);
      self._offset += have;
      // serve some output to the consumer.
      if (async) {
        self.push(out);
      } else {
        buffers.push(out);
        nread += out.length;
      }
    }

    // exhausted the output buffer, or used all the input create a new one.
    if (availOutAfter === 0 || self._offset >= self._chunkSize) {
      availOutBefore = self._chunkSize;
      self._offset = 0;
      self._buffer = Buffer.allocUnsafe(self._chunkSize);
    }

    if (availOutAfter === 0) {
      // Not actually done.  Need to reprocess.
      // Also, update the availInBefore to the availInAfter value,
      // so that if we have to hit it a third (fourth, etc.) time,
      // it'll have the correct byte counts.
      inOff += availInBefore - availInAfter;
      availInBefore = availInAfter;

      if (!async) return true;

      var newReq = self._handle.write(flushFlag, chunk, inOff, availInBefore, self._buffer, self._offset, self._chunkSize);
      newReq.callback = callback; // this same function
      newReq.buffer = chunk;
      return;
    }

    if (!async) return false;

    // finished with the chunk.
    cb();
  }
};

util.inherits(Deflate, Zlib);
util.inherits(Inflate, Zlib);
util.inherits(Gzip, Zlib);
util.inherits(Gunzip, Zlib);
util.inherits(DeflateRaw, Zlib);
util.inherits(InflateRaw, Zlib);
util.inherits(Unzip, Zlib);
}).call(this)}).call(this,require('_process'))
},{"./binding":567,"_process":1185,"assert":560,"buffer":570,"stream":1200,"util":1221}],569:[function(require,module,exports){
arguments[4][566][0].apply(exports,arguments)
},{"dup":566}],570:[function(require,module,exports){
(function (Buffer){(function (){
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */

'use strict'

var base64 = require('base64-js')
var ieee754 = require('ieee754')

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

var K_MAX_LENGTH = 0x7fffffff
exports.kMaxLength = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = { __proto__: Uint8Array.prototype, foo: function () { return 42 } }
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  var buf = new Uint8Array(length)
  buf.__proto__ = Buffer.prototype
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

// Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
if (typeof Symbol !== 'undefined' && Symbol.species != null &&
    Buffer[Symbol.species] === Buffer) {
  Object.defineProperty(Buffer, Symbol.species, {
    value: null,
    configurable: true,
    enumerable: false,
    writable: false
  })
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayLike(value)
  }

  if (value == null) {
    throw TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  var valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  var b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(
      value[Symbol.toPrimitive]('string'), encodingOrOffset, length
    )
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Buffer.prototype.__proto__ = Uint8Array.prototype
Buffer.__proto__ = Uint8Array

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  var length = byteLength(string, encoding) | 0
  var buf = createBuffer(length)

  var actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  var buf = createBuffer(length)
  for (var i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  var buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  buf.__proto__ = Buffer.prototype
  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    var buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      buf = Buffer.from(buf)
    }
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  var len = string.length
  var mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  var strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
        : (firstByte > 0xBF) ? 2
          : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  newBuf.__proto__ = Buffer.prototype
  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (var i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    var len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

}).call(this)}).call(this,require("buffer").Buffer)
},{"base64-js":565,"buffer":570,"ieee754":1158}],571:[function(require,module,exports){
'use strict';

var GetIntrinsic = require('get-intrinsic');

var callBind = require('./');

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};

},{"./":572,"get-intrinsic":1118}],572:[function(require,module,exports){
'use strict';

var bind = require('function-bind');
var GetIntrinsic = require('get-intrinsic');
var setFunctionLength = require('set-function-length');

var $TypeError = require('es-errors/type');
var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $defineProperty = require('es-define-property');
var $max = GetIntrinsic('%Math.max%');

module.exports = function callBind(originalFunction) {
	if (typeof originalFunction !== 'function') {
		throw new $TypeError('a function is required');
	}
	var func = $reflectApply(bind, $call, arguments);
	return setFunctionLength(
		func,
		1 + $max(0, originalFunction.length - (arguments.length - 1)),
		true
	);
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}

},{"es-define-property":1094,"es-errors/type":1100,"function-bind":1117,"get-intrinsic":1118,"set-function-length":1187}],573:[function(require,module,exports){
var isCallable = require('../internals/is-callable');
var tryToString = require('../internals/try-to-string');

var $TypeError = TypeError;

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw $TypeError(tryToString(argument) + ' is not a function');
};

},{"../internals/is-callable":688,"../internals/try-to-string":795}],574:[function(require,module,exports){
var isConstructor = require('../internals/is-constructor');
var tryToString = require('../internals/try-to-string');

var $TypeError = TypeError;

// `Assert: IsConstructor(argument) is true`
module.exports = function (argument) {
  if (isConstructor(argument)) return argument;
  throw $TypeError(tryToString(argument) + ' is not a constructor');
};

},{"../internals/is-constructor":689,"../internals/try-to-string":795}],575:[function(require,module,exports){
var isCallable = require('../internals/is-callable');

var $String = String;
var $TypeError = TypeError;

module.exports = function (argument) {
  if (typeof argument == 'object' || isCallable(argument)) return argument;
  throw $TypeError("Can't set " + $String(argument) + ' as a prototype');
};

},{"../internals/is-callable":688}],576:[function(require,module,exports){
var wellKnownSymbol = require('../internals/well-known-symbol');
var create = require('../internals/object-create');
var defineProperty = require('../internals/object-define-property').f;

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  defineProperty(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};

},{"../internals/object-create":721,"../internals/object-define-property":723,"../internals/well-known-symbol":809}],577:[function(require,module,exports){
'use strict';
var charAt = require('../internals/string-multibyte').charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};

},{"../internals/string-multibyte":766}],578:[function(require,module,exports){
var isPrototypeOf = require('../internals/object-is-prototype-of');

var $TypeError = TypeError;

module.exports = function (it, Prototype) {
  if (isPrototypeOf(Prototype, it)) return it;
  throw $TypeError('Incorrect invocation');
};

},{"../internals/object-is-prototype-of":730}],579:[function(require,module,exports){
var isObject = require('../internals/is-object');

var $String = String;
var $TypeError = TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw $TypeError($String(argument) + ' is not an object');
};

},{"../internals/is-object":694}],580:[function(require,module,exports){
// eslint-disable-next-line es/no-typed-arrays -- safe
module.exports = typeof ArrayBuffer != 'undefined' && typeof DataView != 'undefined';

},{}],581:[function(require,module,exports){
// FF26- bug: ArrayBuffers are non-extensible, but Object.isExtensible does not report it
var fails = require('../internals/fails');

module.exports = fails(function () {
  if (typeof ArrayBuffer == 'function') {
    var buffer = new ArrayBuffer(8);
    // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe
    if (Object.isExtensible(buffer)) Object.defineProperty(buffer, 'a', { value: 8 });
  }
});

},{"../internals/fails":653}],582:[function(require,module,exports){
'use strict';
var NATIVE_ARRAY_BUFFER = require('../internals/array-buffer-basic-detection');
var DESCRIPTORS = require('../internals/descriptors');
var global = require('../internals/global');
var isCallable = require('../internals/is-callable');
var isObject = require('../internals/is-object');
var hasOwn = require('../internals/has-own-property');
var classof = require('../internals/classof');
var tryToString = require('../internals/try-to-string');
var createNonEnumerableProperty = require('../internals/create-non-enumerable-property');
var defineBuiltIn = require('../internals/define-built-in');
var defineBuiltInAccessor = require('../internals/define-built-in-accessor');
var isPrototypeOf = require('../internals/object-is-prototype-of');
var getPrototypeOf = require('../internals/object-get-prototype-of');
var setPrototypeOf = require('../internals/object-set-prototype-of');
var wellKnownSymbol = require('../internals/well-known-symbol');
var uid = require('../internals/uid');
var InternalStateModule = require('../internals/internal-state');

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
var Int8Array = global.Int8Array;
var Int8ArrayPrototype = Int8Array && Int8Array.prototype;
var Uint8ClampedArray = global.Uint8ClampedArray;
var Uint8ClampedArrayPrototype = Uint8ClampedArray && Uint8ClampedArray.prototype;
var TypedArray = Int8Array && getPrototypeOf(Int8Array);
var TypedArrayPrototype = Int8ArrayPrototype && getPrototypeOf(Int8ArrayPrototype);
var ObjectPrototype = Object.prototype;
var TypeError = global.TypeError;

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var TYPED_ARRAY_TAG = uid('TYPED_ARRAY_TAG');
var TYPED_ARRAY_CONSTRUCTOR = 'TypedArrayConstructor';
// Fixing native typed arrays in Opera Presto crashes the browser, see #595
var NATIVE_ARRAY_BUFFER_VIEWS = NATIVE_ARRAY_BUFFER && !!setPrototypeOf && classof(global.opera) !== 'Opera';
var TYPED_ARRAY_TAG_REQUIRED = false;
var NAME, Constructor, Prototype;

var TypedArrayConstructorsList = {
  Int8Array: 1,
  Uint8Array: 1,
  Uint8ClampedArray: 1,
  Int16Array: 2,
  Uint16Array: 2,
  Int32Array: 4,
  Uint32Array: 4,
  Float32Array: 4,
  Float64Array: 8
};

var BigIntArrayConstructorsList = {
  BigInt64Array: 8,
  BigUint64Array: 8
};

var isView = function isView(it) {
  if (!isObject(it)) return false;
  var klass = classof(it);
  return klass === 'DataView'
    || hasOwn(TypedArrayConstructorsList, klass)
    || hasOwn(BigIntArrayConstructorsList, klass);
};

var getTypedArrayConstructor = function (it) {
  var proto = getPrototypeOf(it);
  if (!isObject(proto)) return;
  var state = getInternalState(proto);
  return (state && hasOwn(state, TYPED_ARRAY_CONSTRUCTOR)) ? state[TYPED_ARRAY_CONSTRUCTOR] : getTypedArrayConstructor(proto);
};

var isTypedArray = function (it) {
  if (!isObject(it)) return false;
  var klass = classof(it);
  return hasOwn(TypedArrayConstructorsList, klass)
    || hasOwn(BigIntArrayConstructorsList, klass);
};

var aTypedArray = function (it) {
  if (isTypedArray(it)) return it;
  throw TypeError('Target is not a typed array');
};

var aTypedArrayConstructor = function (C) {
  if (isCallable(C) && (!setPrototypeOf || isPrototypeOf(TypedArray, C))) return C;
  throw TypeError(tryToString(C) + ' is not a typed array constructor');
};

var exportTypedArrayMethod = function (KEY, property, forced, options) {
  if (!DESCRIPTORS) return;
  if (forced) for (var ARRAY in TypedArrayConstructorsList) {
    var TypedArrayConstructor = global[ARRAY];
    if (TypedArrayConstructor && hasOwn(TypedArrayConstructor.prototype, KEY)) try {
      delete TypedArrayConstructor.prototype[KEY];
    } catch (error) {
      // old WebKit bug - some methods are non-configurable
      try {
        TypedArrayConstructor.prototype[KEY] = property;
      } catch (error2) { /* empty */ }
    }
  }
  if (!TypedArrayPrototype[KEY] || forced) {
    defineBuiltIn(TypedArrayPrototype, KEY, forced ? property
      : NATIVE_ARRAY_BUFFER_VIEWS && Int8ArrayPrototype[KEY] || property, options);
  }
};

var exportTypedArrayStaticMethod = function (KEY, property, forced) {
  var ARRAY, TypedArrayConstructor;
  if (!DESCRIPTORS) return;
  if (setPrototypeOf) {
    if (forced) for (ARRAY in TypedArrayConstructorsList) {
      TypedArrayConstructor = global[ARRAY];
      if (TypedArrayConstructor && hasOwn(TypedArrayConstructor, KEY)) try {
        delete TypedArrayConstructor[KEY];
      } catch (error) { /* empty */ }
    }
    if (!TypedArray[KEY] || forced) {
      // V8 ~ Chrome 49-50 `%TypedArray%` methods are non-writable non-configurable
      try {
        return defineBuiltIn(TypedArray, KEY, forced ? property : NATIVE_ARRAY_BUFFER_VIEWS && TypedArray[KEY] || property);
      } catch (error) { /* empty */ }
    } else return;
  }
  for (ARRAY in TypedArrayConstructorsList) {
    TypedArrayConstructor = global[ARRAY];
    if (TypedArrayConstructor && (!TypedArrayConstructor[KEY] || forced)) {
      defineBuiltIn(TypedArrayConstructor, KEY, property);
    }
  }
};

for (NAME in TypedArrayConstructorsList) {
  Constructor = global[NAME];
  Prototype = Constructor && Constructor.prototype;
  if (Prototype) enforceInternalState(Prototype)[TYPED_ARRAY_CONSTRUCTOR] = Constructor;
  else NATIVE_ARRAY_BUFFER_VIEWS = false;
}

for (NAME in BigIntArrayConstructorsList) {
  Constructor = global[NAME];
  Prototype = Constructor && Constructor.prototype;
  if (Prototype) enforceInternalState(Prototype)[TYPED_ARRAY_CONSTRUCTOR] = Constructor;
}

// WebKit bug - typed arrays constructors prototype is Object.prototype
if (!NATIVE_ARRAY_BUFFER_VIEWS || !isCallable(TypedArray) || TypedArray === Function.prototype) {
  // eslint-disable-next-line no-shadow -- safe
  TypedArray = function TypedArray() {
    throw TypeError('Incorrect invocation');
  };
  if (NATIVE_ARRAY_BUFFER_VIEWS) for (NAME in TypedArrayConstructorsList) {
    if (global[NAME]) setPrototypeOf(global[NAME], TypedArray);
  }
}

if (!NATIVE_ARRAY_BUFFER_VIEWS || !TypedArrayPrototype || TypedArrayPrototype === ObjectPrototype) {
  TypedArrayPrototype = TypedArray.prototype;
  if (NATIVE_ARRAY_BUFFER_VIEWS) for (NAME in TypedArrayConstructorsList) {
    if (global[NAME]) setPrototypeOf(global[NAME].prototype, TypedArrayPrototype);
  }
}

// WebKit bug - one more object in Uint8ClampedArray prototype chain
if (NATIVE_ARRAY_BUFFER_VIEWS && getPrototypeOf(Uint8ClampedArrayPrototype) !== TypedArrayPrototype) {
  setPrototypeOf(Uint8ClampedArrayPrototype, TypedArrayPrototype);
}

if (DESCRIPTORS && !hasOwn(TypedArrayPrototype, TO_STRING_TAG)) {
  TYPED_ARRAY_TAG_REQUIRED = true;
  defineBuiltInAccessor(TypedArrayPrototype, TO_STRING_TAG, {
    configurable: true,
    get: function () {
      return isObject(this) ? this[TYPED_ARRAY_TAG] : undefined;
    }
  });
  for (NAME in TypedArrayConstructorsList) if (global[NAME]) {
    createNonEnumerableProperty(global[NAME], TYPED_ARRAY_TAG, NAME);
  }
}

module.exports = {
  NATIVE_ARRAY_BUFFER_VIEWS: NATIVE_ARRAY_BUFFER_VIEWS,
  TYPED_ARRAY_TAG: TYPED_ARRAY_TAG_REQUIRED && TYPED_ARRAY_TAG,
  aTypedArray: aTypedArray,
  aTypedArrayConstructor: aTypedArrayConstructor,
  exportTypedArrayMethod: exportTypedArrayMethod,
  exportTypedArrayStaticMethod: exportTypedArrayStaticMethod,
  getTypedArrayConstructor: getTypedArrayConstructor,
  isView: isView,
  isTypedArray: isTypedArray,
  TypedArray: TypedArray,
  TypedArrayPrototype: TypedArrayPrototype
};

},{"../internals/array-buffer-basic-detection":580,"../internals/classof":608,"../internals/create-non-enumerable-property":617,"../internals/define-built-in":623,"../internals/define-built-in-accessor":622,"../internals/descriptors":627,"../internals/global":672,"../internals/has-own-property":673,"../internals/internal-state":684,"../internals/is-callable":688,"../internals/is-object":694,"../internals/object-get-prototype-of":728,"../internals/object-is-prototype-of":730,"../internals/object-set-prototype-of":735,"../internals/try-to-string":795,"../internals/uid":801,"../internals/well-known-symbol":809}],583:[function(require,module,exports){
'use strict';
var global = require('../internals/global');
var uncurryThis = require('../internals/function-uncurry-this');
var DESCRIPTORS = require('../internals/descriptors');
var NATIVE_ARRAY_BUFFER = require('../internals/array-buffer-basic-detection');
var FunctionName = require('../internals/function-name');
var createNonEnumerableProperty = require('../internals/create-non-enumerable-property');
var defineBuiltInAccessor = require('../internals/define-built-in-accessor');
var defineBuiltIns = require('../internals/define-built-ins');
var fails = require('../internals/fails');
var anInstance = require('../internals/an-instance');
var toIntegerOrInfinity = require('../internals/to-integer-or-infinity');
var toLength = require('../internals/to-length');
var toIndex = require('../internals/to-index');
var IEEE754 = require('../internals/ieee754');
var getPrototypeOf = require('../internals/object-get-prototype-of');
var setPrototypeOf = require('../internals/object-set-prototype-of');
var getOwnPropertyNames = require('../internals/object-get-own-property-names').f;
var arrayFill = require('../internals/array-fill');
var arraySlice = require('../internals/array-slice-simple');
var setToStringTag = require('../internals/set-to-string-tag');
var InternalStateModule = require('../internals/internal-state');

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length';
var WRONG_INDEX = 'Wrong index';
var getInternalArrayBufferState = InternalStateModule.getterFor(ARRAY_BUFFER);
var getInternalDataViewState = InternalStateModule.getterFor(DATA_VIEW);
var setInternalState = InternalStateModule.set;
var NativeArrayBuffer = global[ARRAY_BUFFER];
var $ArrayBuffer = NativeArrayBuffer;
var ArrayBufferPrototype = $ArrayBuffer && $ArrayBuffer[PROTOTYPE];
var $DataView = global[DATA_VIEW];
var DataViewPrototype = $DataView && $DataView[PROTOTYPE];
var ObjectPrototype = Object.prototype;
var Array = global.Array;
var RangeError = global.RangeError;
var fill = uncurryThis(arrayFill);
var reverse = uncurryThis([].reverse);

var packIEEE754 = IEEE754.pack;
var unpackIEEE754 = IEEE754.unpack;

var packInt8 = function (number) {
  return [number & 0xFF];
};

var packInt16 = function (number) {
  return [number & 0xFF, number >> 8 & 0xFF];
};

var packInt32 = function (number) {
  return [number & 0xFF, number >> 8 & 0xFF, number >> 16 & 0xFF, number >> 24 & 0xFF];
};

var unpackInt32 = function (buffer) {
  return buffer[3] << 24 | buffer[2] << 16 | buffer[1] << 8 | buffer[0];
};

var packFloat32 = function (number) {
  return packIEEE754(number, 23, 4);
};

var packFloat64 = function (number) {
  return packIEEE754(number, 52, 8);
};

var addGetter = function (Constructor, key, getInternalState) {
  defineBuiltInAccessor(Constructor[PROTOTYPE], key, {
    configurable: true,
    get: function () {
      return getInternalState(this)[key];
    }
  });
};

var get = function (view, count, index, isLittleEndian) {
  var intIndex = toIndex(index);
  var store = getInternalDataViewState(view);
  if (intIndex + count > store.byteLength) throw RangeError(WRONG_INDEX);
  var bytes = store.bytes;
  var start = intIndex + store.byteOffset;
  var pack = arraySlice(bytes, start, start + count);
  return isLittleEndian ? pack : reverse(pack);
};

var set = function (view, count, index, conversion, value, isLittleEndian) {
  var intIndex = toIndex(index);
  var store = getInternalDataViewState(view);
  if (intIndex + count > store.byteLength) throw RangeError(WRONG_INDEX);
  var bytes = store.bytes;
  var start = intIndex + store.byteOffset;
  var pack = conversion(+value);
  for (var i = 0; i < count; i++) bytes[start + i] = pack[isLittleEndian ? i : count - i - 1];
};

if (!NATIVE_ARRAY_BUFFER) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, ArrayBufferPrototype);
    var byteLength = toIndex(length);
    setInternalState(this, {
      type: ARRAY_BUFFER,
      bytes: fill(Array(byteLength), 0),
      byteLength: byteLength
    });
    if (!DESCRIPTORS) {
      this.byteLength = byteLength;
      this.detached = false;
    }
  };

  ArrayBufferPrototype = $ArrayBuffer[PROTOTYPE];

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, DataViewPrototype);
    anInstance(buffer, ArrayBufferPrototype);
    var bufferState = getInternalArrayBufferState(buffer);
    var bufferLength = bufferState.byteLength;
    var offset = toIntegerOrInfinity(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    setInternalState(this, {
      type: DATA_VIEW,
      buffer: buffer,
      byteLength: byteLength,
      byteOffset: offset,
      bytes: bufferState.bytes
    });
    if (!DESCRIPTORS) {
      this.buffer = buffer;
      this.byteLength = byteLength;
      this.byteOffset = offset;
    }
  };

  DataViewPrototype = $DataView[PROTOTYPE];

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, 'byteLength', getInternalArrayBufferState);
    addGetter($DataView, 'buffer', getInternalDataViewState);
    addGetter($DataView, 'byteLength', getInternalDataViewState);
    addGetter($DataView, 'byteOffset', getInternalDataViewState);
  }

  defineBuiltIns(DataViewPrototype, {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : undefined);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : undefined);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackInt32(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackInt32(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined)) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined), 23);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments.length > 1 ? arguments[1] : undefined), 52);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packInt8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packInt8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packFloat32, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packFloat64, value, arguments.length > 2 ? arguments[2] : undefined);
    }
  });
} else {
  var INCORRECT_ARRAY_BUFFER_NAME = PROPER_FUNCTION_NAME && NativeArrayBuffer.name !== ARRAY_BUFFER;
  /* eslint-disable no-new -- required for testing */
  if (!fails(function () {
    NativeArrayBuffer(1);
  }) || !fails(function () {
    new NativeArrayBuffer(-1);
  }) || fails(function () {
    new NativeArrayBuffer();
    new NativeArrayBuffer(1.5);
    new NativeArrayBuffer(NaN);
    return NativeArrayBuffer.length != 1 || INCORRECT_ARRAY_BUFFER_NAME && !CONFIGURABLE_FUNCTION_NAME;
  })) {
    /* eslint-enable no-new -- required for testing */
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, ArrayBufferPrototype);
      return new NativeArrayBuffer(toIndex(length));
    };

    $ArrayBuffer[PROTOTYPE] = ArrayBufferPrototype;

    for (var keys = getOwnPropertyNames(NativeArrayBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) {
        createNonEnumerableProperty($ArrayBuffer, key, NativeArrayBuffer[key]);
      }
    }

    ArrayBufferPrototype.constructor = $ArrayBuffer;
  } else if (INCORRECT_ARRAY_BUFFER_NAME && CONFIGURABLE_FUNCTION_NAME) {
    createNonEnumerableProperty(NativeArrayBuffer, 'name', ARRAY_BUFFER);
  }

  // WebKit bug - the same parent prototype for typed arrays and data view
  if (setPrototypeOf && getPrototypeOf(DataViewPrototype) !== ObjectPrototype) {
    setPrototypeOf(DataViewPrototype, ObjectPrototype);
  }

  // iOS Safari 7.x bug
  var testView = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = uncurryThis(DataViewPrototype.setInt8);
  testView.setInt8(0, 2147483648);
  testView.setInt8(1, 2147483649);
  if (testView.getInt8(0) || !testView.getInt8(1)) defineBuiltIns(DataViewPrototype, {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8(this, byteOffset, value << 24 >> 24);
    }
  }, { unsafe: true });
}

setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);

module.exports = {
  ArrayBuffer: $ArrayBuffer,
  DataView: $DataView
};

},{"../internals/an-instance":578,"../internals/array-buffer-basic-detection":580,"../internals/array-fill":585,"../internals/array-slice-simple":597,"../internals/create-non-enumerable-property":617,"../internals/define-built-in-accessor":622,"../internals/define-built-ins":624,"../internals/descriptors":627,"../internals/fails":653,"../internals/function-name":662,"../internals/function-uncurry-this":665,"../internals/global":672,"../internals/ieee754":678,"../internals/internal-state":684,"../internals/object-get-own-property-names":726,"../internals/object-get-prototype-of":728,"../internals/object-set-prototype-of":735,"../internals/set-to-string-tag":760,"../internals/to-index":783,"../internals/to-integer-or-infinity":785,"../internals/to-length":786}],584:[function(require,module,exports){
'use strict';
var toObject = require('../internals/to-object');
var toAbsoluteIndex = require('../internals/to-absolute-index');
var lengthOfArrayLike = require('../internals/length-of-array-like');
var deletePropertyOrThrow = require('../internals/delete-property-or-throw');

var min = Math.min;

// `Array.prototype.copyWithin` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.copywithin
// eslint-disable-next-line es/no-array-prototype-copywithin -- safe
module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = lengthOfArrayLike(O);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else deletePropertyOrThrow(O, to);
    to += inc;
    from += inc;
  } return O;
};

},{"../internals/delete-property-or-throw":626,"../internals/length-of-array-like":704,"../internals/to-absolute-index":781,"../internals/to-object":787}],585:[function(require,module,exports){
'use strict';
var toObject = require('../internals/to-object');
var toAbsoluteIndex = require('../internals/to-absolute-index');
var lengthOfArrayLike = require('../internals/length-of-array-like');

// `Array.prototype.fill` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.fill
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = lengthOfArrayLike(O);
  var argumentsLength = arguments.length;
  var index = toAbsoluteIndex(argumentsLength > 1 ? arguments[1] : undefined, length);
  var end = argumentsLength > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};

},{"../internals/length-of-array-like":704,"../internals/to-absolute-index":781,"../internals/to-object":787}],586:[function(require,module,exports){
'use strict';
var $forEach = require('../internals/array-iteration').forEach;
var arrayMethodIsStrict = require('../internals/array-method-is-strict');

var STRICT_METHOD = arrayMethodIsStrict('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
module.exports = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;

},{"../internals/array-iteration":591,"../internals/array-method-is-strict":594}],587:[function(require,module,exports){
var lengthOfArrayLike = require('../internals/length-of-array-like');

module.exports = function (Constructor, list) {
  var index = 0;
  var length = lengthOfArrayLike(list);
  var result = new Constructor(length);
  while (length > index) result[index] = list[index++];
  return result;
};

},{"../internals/length-of-array-like":704}],588:[function(require,module,exports){
'use strict';
var bind = require('../internals/function-bind-context');
var call = require('../internals/function-call');
var toObject = require('../internals/to-object');
var callWithSafeIterationClosing = require('../internals/call-with-safe-iteration-closing');
var isArrayIteratorMethod = require('../internals/is-array-iterator-method');
var isConstructor = require('../internals/is-constructor');
var lengthOfArrayLike = require('../internals/length-of-array-like');
var createProperty = require('../internals/create-property');
var getIterator = require('../internals/get-iterator');
var getIteratorMethod = require('../internals/get-iterator-method');

var $Array = Array;

// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject(arrayLike);
  var IS_CONSTRUCTOR = isConstructor(this);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
  var iteratorMethod = getIteratorMethod(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod && !(this === $Array && isArrayIteratorMethod(iteratorMethod))) {
    iterator = getIterator(O, iteratorMethod);
    next = iterator.next;
    result = IS_CONSTRUCTOR ? new this() : [];
    for (;!(step = call(next, iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = lengthOfArrayLike(O);
    result = IS_CONSTRUCTOR ? new this(length) : $Array(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }
  result.length = index;
  return result;
};

},{"../internals/call-with-safe-iteration-closing":605,"../internals/create-property":619,"../internals/function-bind-context":658,"../internals/function-call":661,"../internals/get-iterator":668,"../internals/get-iterator-method":667,"../internals/is-array-iterator-method":685,"../internals/is-constructor":689,"../internals/length-of-array-like":704,"../internals/to-object":787}],589:[function(require,module,exports){
var toIndexedObject = require('../internals/to-indexed-object');
var toAbsoluteIndex = require('../internals/to-absolute-index');
var lengthOfArrayLike = require('../internals/length-of-array-like');

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};

},{"../internals/length-of-array-like":704,"../internals/to-absolute-index":781,"../internals/to-indexed-object":784}],590:[function(require,module,exports){
var bind = require('../internals/function-bind-context');
var IndexedObject = require('../internals/indexed-object');
var toObject = require('../internals/to-object');
var lengthOfArrayLike = require('../internals/length-of-array-like');

// `Array.prototype.{ findLast, findLastIndex }` methods implementation
var createMethod = function (TYPE) {
  var IS_FIND_LAST_INDEX = TYPE == 1;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that);
    var index = lengthOfArrayLike(self);
    var value, result;
    while (index-- > 0) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (result) switch (TYPE) {
        case 0: return value; // findLast
        case 1: return index; // findLastIndex
      }
    }
    return IS_FIND_LAST_INDEX ? -1 : undefined;
  };
};

module.exports = {
  // `Array.prototype.findLast` method
  // https://github.com/tc39/proposal-array-find-from-last
  findLast: createMethod(0),
  // `Array.prototype.findLastIndex` method
  // https://github.com/tc39/proposal-array-find-from-last
  findLastIndex: createMethod(1)
};

},{"../internals/function-bind-context":658,"../internals/indexed-object":679,"../internals/length-of-array-like":704,"../internals/to-object":787}],591:[function(require,module,exports){
var bind = require('../internals/function-bind-context');
var uncurryThis = require('../internals/function-uncurry-this');
var IndexedObject = require('../internals/indexed-object');
var toObject = require('../internals/to-object');
var lengthOfArrayLike = require('../internals/length-of-array-like');
var arraySpeciesCreate = require('../internals/array-species-create');

var push = uncurryThis([].push);

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_REJECT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that);
    var length = lengthOfArrayLike(self);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push(target, value);      // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push(target, value);      // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod(7)
};

},{"../internals/array-species-create":601,"../internals/function-bind-context":658,"../internals/function-uncurry-this":665,"../internals/indexed-object":679,"../internals/length-of-array-like":704,"../internals/to-object":787}],592:[function(require,module,exports){
'use strict';
/* eslint-disable es/no-array-prototype-lastindexof -- safe */
var apply = require('../internals/function-apply');
var toIndexedObject = require('../internals/to-indexed-object');
var toIntegerOrInfinity = require('../internals/to-integer-or-infinity');
var lengthOfArrayLike = require('../internals/length-of-array-like');
var arrayMethodIsStrict = require('../internals/array-method-is-strict');

var min = Math.min;
var $lastIndexOf = [].lastIndexOf;
var NEGATIVE_ZERO = !!$lastIndexOf && 1 / [1].lastIndexOf(1, -0) < 0;
var STRICT_METHOD = arrayMethodIsStrict('lastIndexOf');
var FORCED = NEGATIVE_ZERO || !STRICT_METHOD;

// `Array.prototype.lastIndexOf` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
module.exports = FORCED ? function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
  // convert -0 to +0
  if (NEGATIVE_ZERO) return apply($lastIndexOf, this, arguments) || 0;
  var O = toIndexedObject(this);
  var length = lengthOfArrayLike(O);
  var index = length - 1;
  if (arguments.length > 1) index = min(index, toIntegerOrInfinity(arguments[1]));
  if (index < 0) index = length + index;
  for (;index >= 0; index--) if (index in O && O[index] === searchElement) return index || 0;
  return -1;
} : $lastIndexOf;

},{"../internals/array-method-is-strict":594,"../internals/function-apply":657,"../internals/length-of-array-like":704,"../internals/to-indexed-object":784,"../internals/to-integer-or-infinity":785}],593:[function(require,module,exports){
var fails = require('../internals/fails');
var wellKnownSymbol = require('../internals/well-known-symbol');
var V8_VERSION = require('../internals/engine-v8-version');

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};

},{"../internals/engine-v8-version":644,"../internals/fails":653,"../internals/well-known-symbol":809}],594:[function(require,module,exports){
'use strict';
var fails = require('../internals/fails');

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () { return 1; }, 1);
  });
};

},{"../internals/fails":653}],595:[function(require,module,exports){
var aCallable = require('../internals/a-callable');
var toObject = require('../internals/to-object');
var IndexedObject = require('../internals/indexed-object');
var lengthOfArrayLike = require('../internals/length-of-array-like');

var $TypeError = TypeError;

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aCallable(callbackfn);
    var O = toObject(that);
    var self = IndexedObject(O);
    var length = lengthOfArrayLike(O);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw $TypeError('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

module.exports = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: createMethod(true)
};

},{"../internals/a-callable":573,"../internals/indexed-object":679,"../internals/length-of-array-like":704,"../internals/to-object":787}],596:[function(require,module,exports){
'use strict';
var DESCRIPTORS = require('../internals/descriptors');
var isArray = require('../internals/is-array');

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Safari < 13 does not throw an error in this case
var SILENT_ON_NON_WRITABLE_LENGTH_SET = DESCRIPTORS && !function () {
  // makes no sense without proper strict mode support
  if (this !== undefined) return true;
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).length = 1;
  } catch (error) {
    return error instanceof TypeError;
  }
}();

module.exports = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function (O, length) {
  if (isArray(O) && !getOwnPropertyDescriptor(O, 'length').writable) {
    throw $TypeError('Cannot set read only .length');
  } return O.length = length;
} : function (O, length) {
  return O.length = length;
};

},{"../internals/descriptors":627,"../internals/is-array":686}],597:[function(require,module,exports){
var toAbsoluteIndex = require('../internals/to-absolute-index');
var lengthOfArrayLike = require('../internals/length-of-array-like');
var createProperty = require('../internals/create-property');

var $Array = Array;
var max = Math.max;

module.exports = function (O, start, end) {
  var length = lengthOfArrayLike(O);
  var k = toAbsoluteIndex(start, length);
  var fin = toAbsoluteIndex(end === undefined ? length : end, length);
  var result = $Array(max(fin - k, 0));
  for (var n = 0; k < fin; k++, n++) createProperty(result, n, O[k]);
  result.length = n;
  return result;
};

},{"../internals/create-property":619,"../internals/length-of-array-like":704,"../internals/to-absolute-index":781}],598:[function(require,module,exports){
var uncurryThis = require('../internals/function-uncurry-this');

module.exports = uncurryThis([].slice);

},{"../internals/function-uncurry-this":665}],599:[function(require,module,exports){
var arraySlice = require('../internals/array-slice-simple');

var floor = Math.floor;

var mergeSort = function (array, comparefn) {
  var length = array.length;
  var middle = floor(length / 2);
  return length < 8 ? insertionSort(array, comparefn) : merge(
    array,
    mergeSort(arraySlice(array, 0, middle), comparefn),
    mergeSort(arraySlice(array, middle), comparefn),
    comparefn
  );
};

var insertionSort = function (array, comparefn) {
  var length = array.length;
  var i = 1;
  var element, j;

  while (i < length) {
    j = i;
    element = array[i];
    while (j && comparefn(array[j - 1], element) > 0) {
      array[j] = array[--j];
    }
    if (j !== i++) array[j] = element;
  } return array;
};

var merge = function (array, left, right, comparefn) {
  var llength = left.length;
  var rlength = right.length;
  var lindex = 0;
  var rindex = 0;

  while (lindex < llength || rindex < rlength) {
    array[lindex + rindex] = (lindex < llength && rindex < rlength)
      ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++]
      : lindex < llength ? left[lindex++] : right[rindex++];
  } return array;
};

module.exports = mergeSort;

},{"../internals/array-slice-simple":597}],600:[function(require,module,exports){
var isArray = require('../internals/is-array');
var isConstructor = require('../internals/is-constructor');
var isObject = require('../internals/is-object');
var wellKnownSymbol = require('../internals/well-known-symbol');

var SPECIES = wellKnownSymbol('species');
var $Array = Array;

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === $Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? $Array : C;
};

},{"../internals/is-array":686,"../internals/is-constructor":689,"../internals/is-object":694,"../internals/well-known-symbol":809}],601:[function(require,module,exports){
var arraySpeciesConstructor = require('../internals/array-species-constructor');

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};

},{"../internals/array-species-constructor":600}],602:[function(require,module,exports){
var lengthOfArrayLike = require('../internals/length-of-array-like');

// https://tc39.es/proposal-change-array-by-copy/#sec-array.prototype.toReversed
// https://tc39.es/proposal-change-array-by-copy/#sec-%typedarray%.prototype.toReversed
module.exports = function (O, C) {
  var len = lengthOfArrayLike(O);
  var A = new C(len);
  var k = 0;
  for (; k < len; k++) A[k] = O[len - k - 1];
  return A;
};

},{"../internals/length-of-array-like":704}],603:[function(require,module,exports){
var lengthOfArrayLike = require('../internals/length-of-array-like');
var toIntegerOrInfinity = require('../internals/to-integer-or-infinity');

var $RangeError = RangeError;

// https://tc39.es/proposal-change-array-by-copy/#sec-array.prototype.with
// https://tc39.es/proposal-change-array-by-copy/#sec-%typedarray%.prototype.with
module.exports = function (O, C, index, value) {
  var len = lengthOfArrayLike(O);
  var relativeIndex = toIntegerOrInfinity(index);
  var actualIndex = relativeIndex < 0 ? len + relativeIndex : relativeIndex;
  if (actualIndex >= len || actualIndex < 0) throw $RangeError('Incorrect index');
  var A = new C(len);
  var k = 0;
  for (; k < len; k++) A[k] = k === actualIndex ? value : O[k];
  return A;
};

},{"../internals/length-of-array-like":704,"../internals/to-integer-or-infinity":785}],604:[function(require,module,exports){
var itoc = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
var ctoi = {};

for (var index = 0; index < 66; index++) ctoi[itoc.charAt(index)] = index;

module.exports = {
  itoc: itoc,
  ctoi: ctoi
};

},{}],605:[function(require,module,exports){
var anObject = require('../internals/an-object');
var iteratorClose = require('../internals/iterator-close');

// call something on iterator step with safe closing on error
module.exports = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose(iterator, 'throw', error);
  }
};

},{"../internals/an-object":579,"../internals/iterator-close":699}],606:[function(require,module,exports){
var wellKnownSymbol = require('../internals/well-known-symbol');

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};

},{"../internals/well-known-symbol":809}],607:[function(require,module,exports){
var uncurryThis = require('../internals/function-uncurry-this');

var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};

},{"../internals/function-uncurry-this":665}],608:[function(require,module,exports){
var TO_STRING_TAG_SUPPORT = require('../internals/to-string-tag-support');
var isCallable = require('../internals/is-callable');
var classofRaw = require('../internals/classof-raw');
var wellKnownSymbol = require('../internals/well-known-symbol');

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};

},{"../internals/classof-raw":607,"../internals/is-callable":688,"../internals/to-string-tag-support":792,"../internals/well-known-symbol":809}],609:[function(require,module,exports){
'use strict';
var create = require('../internals/object-create');
var defineBuiltInAccessor = require('../internals/define-built-in-accessor');
var defineBuiltIns = require('../internals/define-built-ins');
var bind = require('../internals/function-bind-context');
var anInstance = require('../internals/an-instance');
var isNullOrUndefined = require('../internals/is-null-or-undefined');
var iterate = require('../internals/iterate');
var defineIterator = require('../internals/iterator-define');
var createIterResultObject = require('../internals/create-iter-result-object');
var setSpecies = require('../internals/set-species');
var DESCRIPTORS = require('../internals/descriptors');
var fastKey = require('../internals/internal-metadata').fastKey;
var InternalStateModule = require('../internals/internal-state');

var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;

module.exports = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var Constructor = wrapper(function (that, iterable) {
      anInstance(that, Prototype);
      setInternalState(that, {
        type: CONSTRUCTOR_NAME,
        index: create(null),
        first: undefined,
        last: undefined,
        size: 0
      });
      if (!DESCRIPTORS) that.size = 0;
      if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
    });

    var Prototype = Constructor.prototype;

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var entry = getEntry(that, key);
      var previous, index;
      // change existing entry
      if (entry) {
        entry.value = value;
      // create new entry
      } else {
        state.last = entry = {
          index: index = fastKey(key, true),
          key: key,
          value: value,
          previous: previous = state.last,
          next: undefined,
          removed: false
        };
        if (!state.first) state.first = entry;
        if (previous) previous.next = entry;
        if (DESCRIPTORS) state.size++;
        else that.size++;
        // add to index
        if (index !== 'F') state.index[index] = entry;
      } return that;
    };

    var getEntry = function (that, key) {
      var state = getInternalState(that);
      // fast case
      var index = fastKey(key);
      var entry;
      if (index !== 'F') return state.index[index];
      // frozen object case
      for (entry = state.first; entry; entry = entry.next) {
        if (entry.key == key) return entry;
      }
    };

    defineBuiltIns(Prototype, {
      // `{ Map, Set }.prototype.clear()` methods
      // https://tc39.es/ecma262/#sec-map.prototype.clear
      // https://tc39.es/ecma262/#sec-set.prototype.clear
      clear: function clear() {
        var that = this;
        var state = getInternalState(that);
        var data = state.index;
        var entry = state.first;
        while (entry) {
          entry.removed = true;
          if (entry.previous) entry.previous = entry.previous.next = undefined;
          delete data[entry.index];
          entry = entry.next;
        }
        state.first = state.last = undefined;
        if (DESCRIPTORS) state.size = 0;
        else that.size = 0;
      },
      // `{ Map, Set }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.delete
      // https://tc39.es/ecma262/#sec-set.prototype.delete
      'delete': function (key) {
        var that = this;
        var state = getInternalState(that);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.next;
          var prev = entry.previous;
          delete state.index[entry.index];
          entry.removed = true;
          if (prev) prev.next = next;
          if (next) next.previous = prev;
          if (state.first == entry) state.first = next;
          if (state.last == entry) state.last = prev;
          if (DESCRIPTORS) state.size--;
          else that.size--;
        } return !!entry;
      },
      // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.foreach
      // https://tc39.es/ecma262/#sec-set.prototype.foreach
      forEach: function forEach(callbackfn /* , that = undefined */) {
        var state = getInternalState(this);
        var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var entry;
        while (entry = entry ? entry.next : state.first) {
          boundFunction(entry.value, entry.key, this);
          // revert to the last existing entry
          while (entry && entry.removed) entry = entry.previous;
        }
      },
      // `{ Map, Set}.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.has
      // https://tc39.es/ecma262/#sec-set.prototype.has
      has: function has(key) {
        return !!getEntry(this, key);
      }
    });

    defineBuiltIns(Prototype, IS_MAP ? {
      // `Map.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-map.prototype.get
      get: function get(key) {
        var entry = getEntry(this, key);
        return entry && entry.value;
      },
      // `Map.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-map.prototype.set
      set: function set(key, value) {
        return define(this, key === 0 ? 0 : key, value);
      }
    } : {
      // `Set.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-set.prototype.add
      add: function add(value) {
        return define(this, value = value === 0 ? 0 : value, value);
      }
    });
    if (DESCRIPTORS) defineBuiltInAccessor(Prototype, 'size', {
      configurable: true,
      get: function () {
        return getInternalState(this).size;
      }
    });
    return Constructor;
  },
  setStrong: function (Constructor, CONSTRUCTOR_NAME, IS_MAP) {
    var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
    var getInternalCollectionState = internalStateGetterFor(CONSTRUCTOR_NAME);
    var getInternalIteratorState = internalStateGetterFor(ITERATOR_NAME);
    // `{ Map, Set }.prototype.{ keys, values, entries, @@iterator }()` methods
    // https://tc39.es/ecma262/#sec-map.prototype.entries
    // https://tc39.es/ecma262/#sec-map.prototype.keys
    // https://tc39.es/ecma262/#sec-map.prototype.values
    // https://tc39.es/ecma262/#sec-map.prototype-@@iterator
    // https://tc39.es/ecma262/#sec-set.prototype.entries
    // https://tc39.es/ecma262/#sec-set.prototype.keys
    // https://tc39.es/ecma262/#sec-set.prototype.values
    // https://tc39.es/ecma262/#sec-set.prototype-@@iterator
    defineIterator(Constructor, CONSTRUCTOR_NAME, function (iterated, kind) {
      setInternalState(this, {
        type: ITERATOR_NAME,
        target: iterated,
        state: getInternalCollectionState(iterated),
        kind: kind,
        last: undefined
      });
    }, function () {
      var state = getInternalIteratorState(this);
      var kind = state.kind;
      var entry = state.last;
      // revert to the last existing entry
      while (entry && entry.removed) entry = entry.previous;
      // get next entry
      if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
        // or finish the iteration
        state.target = undefined;
        return createIterResultObject(undefined, true);
      }
      // return step by kind
      if (kind == 'keys') return createIterResultObject(entry.key, false);
      if (kind == 'values') return createIterResultObject(entry.value, false);
      return createIterResultObject([entry.key, entry.value], false);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // `{ Map, Set }.prototype[@@species]` accessors
    // https://tc39.es/ecma262/#sec-get-map-@@species
    // https://tc39.es/ecma262/#sec-get-set-@@species
    setSpecies(CONSTRUCTOR_NAME);
  }
};

},{"../internals/an-instance":578,"../internals/create-iter-result-object":616,"../internals/define-built-in-accessor":622,"../internals/define-built-ins":624,"../internals/descriptors":627,"../internals/function-bind-context":658,"../internals/internal-metadata":683,"../internals/internal-state":684,"../internals/is-null-or-undefined":693,"../internals/iterate":698,"../internals/iterator-define":701,"../internals/object-create":721,"../internals/set-species":759}],610:[function(require,module,exports){
'use strict';
var uncurryThis = require('../internals/function-uncurry-this');
var defineBuiltIns = require('../internals/define-built-ins');
var getWeakData = require('../internals/internal-metadata').getWeakData;
var anInstance = require('../internals/an-instance');
var anObject = require('../internals/an-object');
var isNullOrUndefined = require('../internals/is-null-or-undefined');
var isObject = require('../internals/is-object');
var iterate = require('../internals/iterate');
var ArrayIterationModule = require('../internals/array-iteration');
var hasOwn = require('../internals/has-own-property');
var InternalStateModule = require('../internals/internal-state');

var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;
var find = ArrayIterationModule.find;
var findIndex = ArrayIterationModule.findIndex;
var splice = uncurryThis([].splice);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (state) {
  return state.frozen || (state.frozen = new UncaughtFrozenStore());
};

var UncaughtFrozenStore = function () {
  this.entries = [];
};

var findUncaughtFrozen = function (store, key) {
  return find(store.entries, function (it) {
    return it[0] === key;
  });
};

UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.entries.push([key, value]);
  },
  'delete': function (key) {
    var index = findIndex(this.entries, function (it) {
      return it[0] === key;
    });
    if (~index) splice(this.entries, index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var Constructor = wrapper(function (that, iterable) {
      anInstance(that, Prototype);
      setInternalState(that, {
        type: CONSTRUCTOR_NAME,
        id: id++,
        frozen: undefined
      });
      if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
    });

    var Prototype = Constructor.prototype;

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var data = getWeakData(anObject(key), true);
      if (data === true) uncaughtFrozenStore(state).set(key, value);
      else data[state.id] = value;
      return that;
    };

    defineBuiltIns(Prototype, {
      // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
      // https://tc39.es/ecma262/#sec-weakset.prototype.delete
      'delete': function (key) {
        var state = getInternalState(this);
        if (!isObject(key)) return false;
        var data = getWeakData(key);
        if (data === true) return uncaughtFrozenStore(state)['delete'](key);
        return data && hasOwn(data, state.id) && delete data[state.id];
      },
      // `{ WeakMap, WeakSet }.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-weakmap.prototype.has
      // https://tc39.es/ecma262/#sec-weakset.prototype.has
      has: function has(key) {
        var state = getInternalState(this);
        if (!isObject(key)) return false;
        var data = getWeakData(key);
        if (data === true) return uncaughtFrozenStore(state).has(key);
        return data && hasOwn(data, state.id);
      }
    });

    defineBuiltIns(Prototype, IS_MAP ? {
      // `WeakMap.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-weakmap.prototype.get
      get: function get(key) {
        var state = getInternalState(this);
        if (isObject(key)) {
          var data = getWeakData(key);
          if (data === true) return uncaughtFrozenStore(state).get(key);
          return data ? data[state.id] : undefined;
        }
      },
      // `WeakMap.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-weakmap.prototype.set
      set: function set(key, value) {
        return define(this, key, value);
      }
    } : {
      // `WeakSet.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-weakset.prototype.add
      add: function add(value) {
        return define(this, value, true);
      }
    });

    return Constructor;
  }
};

},{"../internals/an-instance":578,"../internals/an-object":579,"../internals/array-iteration":591,"../internals/define-built-ins":624,"../internals/function-uncurry-this":665,"../internals/has-own-property":673,"../internals/internal-metadata":683,"../internals/internal-state":684,"../internals/is-null-or-undefined":693,"../internals/is-object":694,"../internals/iterate":698}],611:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var global = require('../internals/global');
var uncurryThis = require('../internals/function-uncurry-this');
var isForced = require('../internals/is-forced');
var defineBuiltIn = require('../internals/define-built-in');
var InternalMetadataModule = require('../internals/internal-metadata');
var iterate = require('../internals/iterate');
var anInstance = require('../internals/an-instance');
var isCallable = require('../internals/is-callable');
var isNullOrUndefined = require('../internals/is-null-or-undefined');
var isObject = require('../internals/is-object');
var fails = require('../internals/fails');
var checkCorrectnessOfIteration = require('../internals/check-correctness-of-iteration');
var setToStringTag = require('../internals/set-to-string-tag');
var inheritIfRequired = require('../internals/inherit-if-required');

module.exports = function (CONSTRUCTOR_NAME, wrapper, common) {
  var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
  var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
  var ADDER = IS_MAP ? 'set' : 'add';
  var NativeConstructor = global[CONSTRUCTOR_NAME];
  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
  var Constructor = NativeConstructor;
  var exported = {};

  var fixMethod = function (KEY) {
    var uncurriedNativeMethod = uncurryThis(NativePrototype[KEY]);
    defineBuiltIn(NativePrototype, KEY,
      KEY == 'add' ? function add(value) {
        uncurriedNativeMethod(this, value === 0 ? 0 : value);
        return this;
      } : KEY == 'delete' ? function (key) {
        return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : KEY == 'get' ? function get(key) {
        return IS_WEAK && !isObject(key) ? undefined : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : KEY == 'has' ? function has(key) {
        return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : function set(key, value) {
        uncurriedNativeMethod(this, key === 0 ? 0 : key, value);
        return this;
      }
    );
  };

  var REPLACE = isForced(
    CONSTRUCTOR_NAME,
    !isCallable(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !fails(function () {
      new NativeConstructor().entries().next();
    }))
  );

  if (REPLACE) {
    // create collection constructor
    Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
    InternalMetadataModule.enable();
  } else if (isForced(CONSTRUCTOR_NAME, true)) {
    var instance = new Constructor();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    // eslint-disable-next-line no-new -- required for testing
    var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function (iterable) { new NativeConstructor(iterable); });
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new NativeConstructor();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });

    if (!ACCEPT_ITERABLES) {
      Constructor = wrapper(function (dummy, iterable) {
        anInstance(dummy, NativePrototype);
        var that = inheritIfRequired(new NativeConstructor(), dummy, Constructor);
        if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
        return that;
      });
      Constructor.prototype = NativePrototype;
      NativePrototype.constructor = Constructor;
    }

    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }

    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);

    // weak collections should not contains .clear method
    if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
  }

  exported[CONSTRUCTOR_NAME] = Constructor;
  $({ global: true, constructor: true, forced: Constructor != NativeConstructor }, exported);

  setToStringTag(Constructor, CONSTRUCTOR_NAME);

  if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);

  return Constructor;
};

},{"../internals/an-instance":578,"../internals/check-correctness-of-iteration":606,"../internals/define-built-in":623,"../internals/export":652,"../internals/fails":653,"../internals/function-uncurry-this":665,"../internals/global":672,"../internals/inherit-if-required":680,"../internals/internal-metadata":683,"../internals/is-callable":688,"../internals/is-forced":691,"../internals/is-null-or-undefined":693,"../internals/is-object":694,"../internals/iterate":698,"../internals/set-to-string-tag":760}],612:[function(require,module,exports){
var hasOwn = require('../internals/has-own-property');
var ownKeys = require('../internals/own-keys');
var getOwnPropertyDescriptorModule = require('../internals/object-get-own-property-descriptor');
var definePropertyModule = require('../internals/object-define-property');

module.exports = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

},{"../internals/has-own-property":673,"../internals/object-define-property":723,"../internals/object-get-own-property-descriptor":724,"../internals/own-keys":739}],613:[function(require,module,exports){
var wellKnownSymbol = require('../internals/well-known-symbol');

var MATCH = wellKnownSymbol('match');

module.exports = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};

},{"../internals/well-known-symbol":809}],614:[function(require,module,exports){
var fails = require('../internals/fails');

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

},{"../internals/fails":653}],615:[function(require,module,exports){
var uncurryThis = require('../internals/function-uncurry-this');
var requireObjectCoercible = require('../internals/require-object-coercible');
var toString = require('../internals/to-string');

var quot = /"/g;
var replace = uncurryThis(''.replace);

// `CreateHTML` abstract operation
// https://tc39.es/ecma262/#sec-createhtml
module.exports = function (string, tag, attribute, value) {
  var S = toString(requireObjectCoercible(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + replace(toString(value), quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};

},{"../internals/function-uncurry-this":665,"../internals/require-object-coercible":755,"../internals/to-string":793}],616:[function(require,module,exports){
// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
module.exports = function (value, done) {
  return { value: value, done: done };
};

},{}],617:[function(require,module,exports){
var DESCRIPTORS = require('../internals/descriptors');
var definePropertyModule = require('../internals/object-define-property');
var createPropertyDescriptor = require('../internals/create-property-descriptor');

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

},{"../internals/create-property-descriptor":618,"../internals/descriptors":627,"../internals/object-define-property":723}],618:[function(require,module,exports){
module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

},{}],619:[function(require,module,exports){
'use strict';
var toPropertyKey = require('../internals/to-property-key');
var definePropertyModule = require('../internals/object-define-property');
var createPropertyDescriptor = require('../internals/create-property-descriptor');

module.exports = function (object, key, value) {
  var propertyKey = toPropertyKey(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};

},{"../internals/create-property-descriptor":618,"../internals/object-define-property":723,"../internals/to-property-key":791}],620:[function(require,module,exports){
'use strict';
var uncurryThis = require('../internals/function-uncurry-this');
var fails = require('../internals/fails');
var padStart = require('../internals/string-pad').start;

var $RangeError = RangeError;
var $isFinite = isFinite;
var abs = Math.abs;
var DatePrototype = Date.prototype;
var nativeDateToISOString = DatePrototype.toISOString;
var thisTimeValue = uncurryThis(DatePrototype.getTime);
var getUTCDate = uncurryThis(DatePrototype.getUTCDate);
var getUTCFullYear = uncurryThis(DatePrototype.getUTCFullYear);
var getUTCHours = uncurryThis(DatePrototype.getUTCHours);
var getUTCMilliseconds = uncurryThis(DatePrototype.getUTCMilliseconds);
var getUTCMinutes = uncurryThis(DatePrototype.getUTCMinutes);
var getUTCMonth = uncurryThis(DatePrototype.getUTCMonth);
var getUTCSeconds = uncurryThis(DatePrototype.getUTCSeconds);

// `Date.prototype.toISOString` method implementation
// https://tc39.es/ecma262/#sec-date.prototype.toisostring
// PhantomJS / old WebKit fails here:
module.exports = (fails(function () {
  return nativeDateToISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  nativeDateToISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!$isFinite(thisTimeValue(this))) throw $RangeError('Invalid time value');
  var date = this;
  var year = getUTCFullYear(date);
  var milliseconds = getUTCMilliseconds(date);
  var sign = year < 0 ? '-' : year > 9999 ? '+' : '';
  return sign + padStart(abs(year), sign ? 6 : 4, 0) +
    '-' + padStart(getUTCMonth(date) + 1, 2, 0) +
    '-' + padStart(getUTCDate(date), 2, 0) +
    'T' + padStart(getUTCHours(date), 2, 0) +
    ':' + padStart(getUTCMinutes(date), 2, 0) +
    ':' + padStart(getUTCSeconds(date), 2, 0) +
    '.' + padStart(milliseconds, 3, 0) +
    'Z';
} : nativeDateToISOString;

},{"../internals/fails":653,"../internals/function-uncurry-this":665,"../internals/string-pad":768}],621:[function(require,module,exports){
'use strict';
var anObject = require('../internals/an-object');
var ordinaryToPrimitive = require('../internals/ordinary-to-primitive');

var $TypeError = TypeError;

// `Date.prototype[@@toPrimitive](hint)` method implementation
// https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive
module.exports = function (hint) {
  anObject(this);
  if (hint === 'string' || hint === 'default') hint = 'string';
  else if (hint !== 'number') throw $TypeError('Incorrect hint');
  return ordinaryToPrimitive(this, hint);
};

},{"../internals/an-object":579,"../internals/ordinary-to-primitive":738}],622:[function(require,module,exports){
var makeBuiltIn = require('../internals/make-built-in');
var defineProperty = require('../internals/object-define-property');

module.exports = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
  return defineProperty.f(target, name, descriptor);
};

},{"../internals/make-built-in":705,"../internals/object-define-property":723}],623:[function(require,module,exports){
var isCallable = require('../internals/is-callable');
var definePropertyModule = require('../internals/object-define-property');
var makeBuiltIn = require('../internals/make-built-in');
var defineGlobalProperty = require('../internals/define-global-property');

module.exports = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};

},{"../internals/define-global-property":625,"../internals/is-callable":688,"../internals/make-built-in":705,"../internals/object-define-property":723}],624:[function(require,module,exports){
var defineBuiltIn = require('../internals/define-built-in');

module.exports = function (target, src, options) {
  for (var key in src) defineBuiltIn(target, key, src[key], options);
  return target;
};

},{"../internals/define-built-in":623}],625:[function(require,module,exports){
var global = require('../internals/global');

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

module.exports = function (key, value) {
  try {
    defineProperty(global, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global[key] = value;
  } return value;
};

},{"../internals/global":672}],626:[function(require,module,exports){
'use strict';
var tryToString = require('../internals/try-to-string');

var $TypeError = TypeError;

module.exports = function (O, P) {
  if (!delete O[P]) throw $TypeError('Cannot delete property ' + tryToString(P) + ' of ' + tryToString(O));
};

},{"../internals/try-to-string":795}],627:[function(require,module,exports){
var fails = require('../internals/fails');

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

},{"../internals/fails":653}],628:[function(require,module,exports){
var documentAll = typeof document == 'object' && document.all;

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var IS_HTMLDDA = typeof documentAll == 'undefined' && documentAll !== undefined;

module.exports = {
  all: documentAll,
  IS_HTMLDDA: IS_HTMLDDA
};

},{}],629:[function(require,module,exports){
var global = require('../internals/global');
var isObject = require('../internals/is-object');

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};

},{"../internals/global":672,"../internals/is-object":694}],630:[function(require,module,exports){
var $TypeError = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

module.exports = function (it) {
  if (it > MAX_SAFE_INTEGER) throw $TypeError('Maximum allowed index exceeded');
  return it;
};

},{}],631:[function(require,module,exports){
module.exports = {
  IndexSizeError: { s: 'INDEX_SIZE_ERR', c: 1, m: 1 },
  DOMStringSizeError: { s: 'DOMSTRING_SIZE_ERR', c: 2, m: 0 },
  HierarchyRequestError: { s: 'HIERARCHY_REQUEST_ERR', c: 3, m: 1 },
  WrongDocumentError: { s: 'WRONG_DOCUMENT_ERR', c: 4, m: 1 },
  InvalidCharacterError: { s: 'INVALID_CHARACTER_ERR', c: 5, m: 1 },
  NoDataAllowedError: { s: 'NO_DATA_ALLOWED_ERR', c: 6, m: 0 },
  NoModificationAllowedError: { s: 'NO_MODIFICATION_ALLOWED_ERR', c: 7, m: 1 },
  NotFoundError: { s: 'NOT_FOUND_ERR', c: 8, m: 1 },
  NotSupportedError: { s: 'NOT_SUPPORTED_ERR', c: 9, m: 1 },
  InUseAttributeError: { s: 'INUSE_ATTRIBUTE_ERR', c: 10, m: 1 },
  InvalidStateError: { s: 'INVALID_STATE_ERR', c: 11, m: 1 },
  SyntaxError: { s: 'SYNTAX_ERR', c: 12, m: 1 },
  InvalidModificationError: { s: 'INVALID_MODIFICATION_ERR', c: 13, m: 1 },
  NamespaceError: { s: 'NAMESPACE_ERR', c: 14, m: 1 },
  InvalidAccessError: { s: 'INVALID_ACCESS_ERR', c: 15, m: 1 },
  ValidationError: { s: 'VALIDATION_ERR', c: 16, m: 0 },
  TypeMismatchError: { s: 'TYPE_MISMATCH_ERR', c: 17, m: 1 },
  SecurityError: { s: 'SECURITY_ERR', c: 18, m: 1 },
  NetworkError: { s: 'NETWORK_ERR', c: 19, m: 1 },
  AbortError: { s: 'ABORT_ERR', c: 20, m: 1 },
  URLMismatchError: { s: 'URL_MISMATCH_ERR', c: 21, m: 1 },
  QuotaExceededError: { s: 'QUOTA_EXCEEDED_ERR', c: 22, m: 1 },
  TimeoutError: { s: 'TIMEOUT_ERR', c: 23, m: 1 },
  InvalidNodeTypeError: { s: 'INVALID_NODE_TYPE_ERR', c: 24, m: 1 },
  DataCloneError: { s: 'DATA_CLONE_ERR', c: 25, m: 1 }
};

},{}],632:[function(require,module,exports){
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

},{}],633:[function(require,module,exports){
// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = require('../internals/document-create-element');

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;

module.exports = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;

},{"../internals/document-create-element":629}],634:[function(require,module,exports){
var userAgent = require('../internals/engine-user-agent');

var firefox = userAgent.match(/firefox\/(\d+)/i);

module.exports = !!firefox && +firefox[1];

},{"../internals/engine-user-agent":643}],635:[function(require,module,exports){
var IS_DENO = require('../internals/engine-is-deno');
var IS_NODE = require('../internals/engine-is-node');

module.exports = !IS_DENO && !IS_NODE
  && typeof window == 'object'
  && typeof document == 'object';

},{"../internals/engine-is-deno":637,"../internals/engine-is-node":641}],636:[function(require,module,exports){
/* global Bun -- Deno case */
module.exports = typeof Bun == 'function' && Bun && typeof Bun.version == 'string';

},{}],637:[function(require,module,exports){
/* global Deno -- Deno case */
module.exports = typeof Deno == 'object' && Deno && typeof Deno.version == 'object';

},{}],638:[function(require,module,exports){
var UA = require('../internals/engine-user-agent');

module.exports = /MSIE|Trident/.test(UA);

},{"../internals/engine-user-agent":643}],639:[function(require,module,exports){
var userAgent = require('../internals/engine-user-agent');

module.exports = /ipad|iphone|ipod/i.test(userAgent) && typeof Pebble != 'undefined';

},{"../internals/engine-user-agent":643}],640:[function(require,module,exports){
var userAgent = require('../internals/engine-user-agent');

// eslint-disable-next-line redos/no-vulnerable -- safe
module.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent);

},{"../internals/engine-user-agent":643}],641:[function(require,module,exports){
(function (process){(function (){
var classof = require('../internals/classof-raw');

module.exports = typeof process != 'undefined' && classof(process) == 'process';

}).call(this)}).call(this,require('_process'))
},{"../internals/classof-raw":607,"_process":1185}],642:[function(require,module,exports){
var userAgent = require('../internals/engine-user-agent');

module.exports = /web0s(?!.*chrome)/i.test(userAgent);

},{"../internals/engine-user-agent":643}],643:[function(require,module,exports){
module.exports = typeof navigator != 'undefined' && String(navigator.userAgent) || '';

},{}],644:[function(require,module,exports){
var global = require('../internals/global');
var userAgent = require('../internals/engine-user-agent');

var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

module.exports = version;

},{"../internals/engine-user-agent":643,"../internals/global":672}],645:[function(require,module,exports){
var userAgent = require('../internals/engine-user-agent');

var webkit = userAgent.match(/AppleWebKit\/(\d+)\./);

module.exports = !!webkit && +webkit[1];

},{"../internals/engine-user-agent":643}],646:[function(require,module,exports){
var global = require('../internals/global');

module.exports = function (CONSTRUCTOR) {
  return global[CONSTRUCTOR].prototype;
};

},{"../internals/global":672}],647:[function(require,module,exports){
// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

},{}],648:[function(require,module,exports){
var uncurryThis = require('../internals/function-uncurry-this');

var $Error = Error;
var replace = uncurryThis(''.replace);

var TEST = (function (arg) { return String($Error(arg).stack); })('zxcasd');
// eslint-disable-next-line redos/no-vulnerable -- safe
var V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
var IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST);

module.exports = function (stack, dropEntries) {
  if (IS_V8_OR_CHAKRA_STACK && typeof stack == 'string' && !$Error.prepareStackTrace) {
    while (dropEntries--) stack = replace(stack, V8_OR_CHAKRA_STACK_ENTRY, '');
  } return stack;
};

},{"../internals/function-uncurry-this":665}],649:[function(require,module,exports){
var createNonEnumerableProperty = require('../internals/create-non-enumerable-property');
var clearErrorStack = require('../internals/error-stack-clear');
var ERROR_STACK_INSTALLABLE = require('../internals/error-stack-installable');

// non-standard V8
var captureStackTrace = Error.captureStackTrace;

module.exports = function (error, C, stack, dropEntries) {
  if (ERROR_STACK_INSTALLABLE) {
    if (captureStackTrace) captureStackTrace(error, C);
    else createNonEnumerableProperty(error, 'stack', clearErrorStack(stack, dropEntries));
  }
};

},{"../internals/create-non-enumerable-property":617,"../internals/error-stack-clear":648,"../internals/error-stack-installable":650}],650:[function(require,module,exports){
var fails = require('../internals/fails');
var createPropertyDescriptor = require('../internals/create-property-descriptor');

module.exports = !fails(function () {
  var error = Error('a');
  if (!('stack' in error)) return true;
  // eslint-disable-next-line es/no-object-defineproperty -- safe
  Object.defineProperty(error, 'stack', createPropertyDescriptor(1, 7));
  return error.stack !== 7;
});

},{"../internals/create-property-descriptor":618,"../internals/fails":653}],651:[function(require,module,exports){
'use strict';
var DESCRIPTORS = require('../internals/descriptors');
var fails = require('../internals/fails');
var anObject = require('../internals/an-object');
var create = require('../internals/object-create');
var normalizeStringArgument = require('../internals/normalize-string-argument');

var nativeErrorToString = Error.prototype.toString;

var INCORRECT_TO_STRING = fails(function () {
  if (DESCRIPTORS) {
    // Chrome 32- incorrectly call accessor
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    var object = create(Object.defineProperty({}, 'name', { get: function () {
      return this === object;
    } }));
    if (nativeErrorToString.call(object) !== 'true') return true;
  }
  // FF10- does not properly handle non-strings
  return nativeErrorToString.call({ message: 1, name: 2 }) !== '2: 1'
    // IE8 does not properly handle defaults
    || nativeErrorToString.call({}) !== 'Error';
});

module.exports = INCORRECT_TO_STRING ? function toString() {
  var O = anObject(this);
  var name = normalizeStringArgument(O.name, 'Error');
  var message = normalizeStringArgument(O.message);
  return !name ? message : !message ? name : name + ': ' + message;
} : nativeErrorToString;

},{"../internals/an-object":579,"../internals/descriptors":627,"../internals/fails":653,"../internals/normalize-string-argument":715,"../internals/object-create":721}],652:[function(require,module,exports){
var global = require('../internals/global');
var getOwnPropertyDescriptor = require('../internals/object-get-own-property-descriptor').f;
var createNonEnumerableProperty = require('../internals/create-non-enumerable-property');
var defineBuiltIn = require('../internals/define-built-in');
var defineGlobalProperty = require('../internals/define-global-property');
var copyConstructorProperties = require('../internals/copy-constructor-properties');
var isForced = require('../internals/is-forced');

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    defineBuiltIn(target, key, sourceProperty, options);
  }
};

},{"../internals/copy-constructor-properties":612,"../internals/create-non-enumerable-property":617,"../internals/define-built-in":623,"../internals/define-global-property":625,"../internals/global":672,"../internals/is-forced":691,"../internals/object-get-own-property-descriptor":724}],653:[function(require,module,exports){
module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

},{}],654:[function(require,module,exports){
'use strict';
// TODO: Remove from `core-js@4` since it's moved to entry points
require('../modules/es.regexp.exec');
var uncurryThis = require('../internals/function-uncurry-this-clause');
var defineBuiltIn = require('../internals/define-built-in');
var regexpExec = require('../internals/regexp-exec');
var fails = require('../internals/fails');
var wellKnownSymbol = require('../internals/well-known-symbol');
var createNonEnumerableProperty = require('../internals/create-non-enumerable-property');

var SPECIES = wellKnownSymbol('species');
var RegExpPrototype = RegExp.prototype;

module.exports = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var uncurriedNativeRegExpMethod = uncurryThis(/./[SYMBOL]);
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var uncurriedNativeMethod = uncurryThis(nativeMethod);
      var $exec = regexp.exec;
      if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: uncurriedNativeRegExpMethod(regexp, str, arg2) };
        }
        return { done: true, value: uncurriedNativeMethod(str, regexp, arg2) };
      }
      return { done: false };
    });

    defineBuiltIn(String.prototype, KEY, methods[0]);
    defineBuiltIn(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
};

},{"../internals/create-non-enumerable-property":617,"../internals/define-built-in":623,"../internals/fails":653,"../internals/function-uncurry-this-clause":664,"../internals/regexp-exec":749,"../internals/well-known-symbol":809,"../modules/es.regexp.exec":964}],655:[function(require,module,exports){
'use strict';
var isArray = require('../internals/is-array');
var lengthOfArrayLike = require('../internals/length-of-array-like');
var doesNotExceedSafeInteger = require('../internals/does-not-exceed-safe-integer');
var bind = require('../internals/function-bind-context');

// `FlattenIntoArray` abstract operation
// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var flattenIntoArray = function (target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? bind(mapper, thisArg) : false;
  var element, elementLen;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      if (depth > 0 && isArray(element)) {
        elementLen = lengthOfArrayLike(element);
        targetIndex = flattenIntoArray(target, original, element, elementLen, targetIndex, depth - 1) - 1;
      } else {
        doesNotExceedSafeInteger(targetIndex + 1);
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
};

module.exports = flattenIntoArray;

},{"../internals/does-not-exceed-safe-integer":630,"../internals/function-bind-context":658,"../internals/is-array":686,"../internals/length-of-array-like":704}],656:[function(require,module,exports){
var fails = require('../internals/fails');

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
  return Object.isExtensible(Object.preventExtensions({}));
});

},{"../internals/fails":653}],657:[function(require,module,exports){
var NATIVE_BIND = require('../internals/function-bind-native');

var FunctionPrototype = Function.prototype;
var apply = FunctionPrototype.apply;
var call = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
module.exports = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call.bind(apply) : function () {
  return call.apply(apply, arguments);
});

},{"../internals/function-bind-native":659}],658:[function(require,module,exports){
var uncurryThis = require('../internals/function-uncurry-this-clause');
var aCallable = require('../internals/a-callable');
var NATIVE_BIND = require('../internals/function-bind-native');

var bind = uncurryThis(uncurryThis.bind);

// optional / simple context binding
module.exports = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : NATIVE_BIND ? bind(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

},{"../internals/a-callable":573,"../internals/function-bind-native":659,"../internals/function-uncurry-this-clause":664}],659:[function(require,module,exports){
var fails = require('../internals/fails');

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

},{"../internals/fails":653}],660:[function(require,module,exports){
'use strict';
var uncurryThis = require('../internals/function-uncurry-this');
var aCallable = require('../internals/a-callable');
var isObject = require('../internals/is-object');
var hasOwn = require('../internals/has-own-property');
var arraySlice = require('../internals/array-slice');
var NATIVE_BIND = require('../internals/function-bind-native');

var $Function = Function;
var concat = uncurryThis([].concat);
var join = uncurryThis([].join);
var factories = {};

var construct = function (C, argsLength, args) {
  if (!hasOwn(factories, argsLength)) {
    for (var list = [], i = 0; i < argsLength; i++) list[i] = 'a[' + i + ']';
    factories[argsLength] = $Function('C,a', 'return new C(' + join(list, ',') + ')');
  } return factories[argsLength](C, args);
};

// `Function.prototype.bind` method implementation
// https://tc39.es/ecma262/#sec-function.prototype.bind
// eslint-disable-next-line es/no-function-prototype-bind -- detection
module.exports = NATIVE_BIND ? $Function.bind : function bind(that /* , ...args */) {
  var F = aCallable(this);
  var Prototype = F.prototype;
  var partArgs = arraySlice(arguments, 1);
  var boundFunction = function bound(/* args... */) {
    var args = concat(partArgs, arraySlice(arguments));
    return this instanceof boundFunction ? construct(F, args.length, args) : F.apply(that, args);
  };
  if (isObject(Prototype)) boundFunction.prototype = Prototype;
  return boundFunction;
};

},{"../internals/a-callable":573,"../internals/array-slice":598,"../internals/function-bind-native":659,"../internals/function-uncurry-this":665,"../internals/has-own-property":673,"../internals/is-object":694}],661:[function(require,module,exports){
var NATIVE_BIND = require('../internals/function-bind-native');

var call = Function.prototype.call;

module.exports = NATIVE_BIND ? call.bind(call) : function () {
  return call.apply(call, arguments);
};

},{"../internals/function-bind-native":659}],662:[function(require,module,exports){
var DESCRIPTORS = require('../internals/descriptors');
var hasOwn = require('../internals/has-own-property');

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

},{"../internals/descriptors":627,"../internals/has-own-property":673}],663:[function(require,module,exports){
var uncurryThis = require('../internals/function-uncurry-this');
var aCallable = require('../internals/a-callable');

module.exports = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return uncurryThis(aCallable(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) { /* empty */ }
};

},{"../internals/a-callable":573,"../internals/function-uncurry-this":665}],664:[function(require,module,exports){
var classofRaw = require('../internals/classof-raw');
var uncurryThis = require('../internals/function-uncurry-this');

module.exports = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return uncurryThis(fn);
};

},{"../internals/classof-raw":607,"../internals/function-uncurry-this":665}],665:[function(require,module,exports){
var NATIVE_BIND = require('../internals/function-bind-native');

var FunctionPrototype = Function.prototype;
var call = FunctionPrototype.call;
var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);

module.exports = NATIVE_BIND ? uncurryThisWithBind : function (fn) {
  return function () {
    return call.apply(fn, arguments);
  };
};

},{"../internals/function-bind-native":659}],666:[function(require,module,exports){
var global = require('../internals/global');
var isCallable = require('../internals/is-callable');

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
};

},{"../internals/global":672,"../internals/is-callable":688}],667:[function(require,module,exports){
var classof = require('../internals/classof');
var getMethod = require('../internals/get-method');
var isNullOrUndefined = require('../internals/is-null-or-undefined');
var Iterators = require('../internals/iterators');
var wellKnownSymbol = require('../internals/well-known-symbol');

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (!isNullOrUndefined(it)) return getMethod(it, ITERATOR)
    || getMethod(it, '@@iterator')
    || Iterators[classof(it)];
};

},{"../internals/classof":608,"../internals/get-method":670,"../internals/is-null-or-undefined":693,"../internals/iterators":703,"../internals/well-known-symbol":809}],668:[function(require,module,exports){
var call = require('../internals/function-call');
var aCallable = require('../internals/a-callable');
var anObject = require('../internals/an-object');
var tryToString = require('../internals/try-to-string');
var getIteratorMethod = require('../internals/get-iterator-method');

var $TypeError = TypeError;

module.exports = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
  if (aCallable(iteratorMethod)) return anObject(call(iteratorMethod, argument));
  throw $TypeError(tryToString(argument) + ' is not iterable');
};

},{"../internals/a-callable":573,"../internals/an-object":579,"../internals/function-call":661,"../internals/get-iterator-method":667,"../internals/try-to-string":795}],669:[function(require,module,exports){
var uncurryThis = require('../internals/function-uncurry-this');
var isArray = require('../internals/is-array');
var isCallable = require('../internals/is-callable');
var classof = require('../internals/classof-raw');
var toString = require('../internals/to-string');

var push = uncurryThis([].push);

module.exports = function (replacer) {
  if (isCallable(replacer)) return replacer;
  if (!isArray(replacer)) return;
  var rawLength = replacer.length;
  var keys = [];
  for (var i = 0; i < rawLength; i++) {
    var element = replacer[i];
    if (typeof element == 'string') push(keys, element);
    else if (typeof element == 'number' || classof(element) == 'Number' || classof(element) == 'String') push(keys, toString(element));
  }
  var keysLength = keys.length;
  var root = true;
  return function (key, value) {
    if (root) {
      root = false;
      return value;
    }
    if (isArray(this)) return value;
    for (var j = 0; j < keysLength; j++) if (keys[j] === key) return value;
  };
};

},{"../internals/classof-raw":607,"../internals/function-uncurry-this":665,"../internals/is-array":686,"../internals/is-callable":688,"../internals/to-string":793}],670:[function(require,module,exports){
var aCallable = require('../internals/a-callable');
var isNullOrUndefined = require('../internals/is-null-or-undefined');

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable(func);
};

},{"../internals/a-callable":573,"../internals/is-null-or-undefined":693}],671:[function(require,module,exports){
var uncurryThis = require('../internals/function-uncurry-this');
var toObject = require('../internals/to-object');

var floor = Math.floor;
var charAt = uncurryThis(''.charAt);
var replace = uncurryThis(''.replace);
var stringSlice = uncurryThis(''.slice);
// eslint-disable-next-line redos/no-vulnerable -- safe
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
module.exports = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace(replacement, symbols, function (match, ch) {
    var capture;
    switch (charAt(ch, 0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return stringSlice(str, 0, position);
      case "'": return stringSlice(str, tailPos);
      case '<':
        capture = namedCaptures[stringSlice(ch, 1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? charAt(ch, 1) : captures[f - 1] + charAt(ch, 1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};

},{"../internals/function-uncurry-this":665,"../internals/to-object":787}],672:[function(require,module,exports){
(function (global){(function (){
var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],673:[function(require,module,exports){
var uncurryThis = require('../internals/function-uncurry-this');
var toObject = require('../internals/to-object');

var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};

},{"../internals/function-uncurry-this":665,"../internals/to-object":787}],674:[function(require,module,exports){
module.exports = {};

},{}],675:[function(require,module,exports){
module.exports = function (a, b) {
  try {
    // eslint-disable-next-line no-console -- safe
    arguments.length == 1 ? console.error(a) : console.error(a, b);
  } catch (error) { /* empty */ }
};

},{}],676:[function(require,module,exports){
var getBuiltIn = require('../internals/get-built-in');

module.exports = getBuiltIn('document', 'documentElement');

},{"../internals/get-built-in":666}],677:[function(require,module,exports){
var DESCRIPTORS = require('../internals/descriptors');
var fails = require('../internals/fails');
var createElement = require('../internals/document-create-element');

// Thanks to IE8 for its funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

},{"../internals/descriptors":627,"../internals/document-create-element":629,"../internals/fails":653}],678:[function(require,module,exports){
// IEEE754 conversions based on https://github.com/feross/ieee754
var $Array = Array;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;

var pack = function (number, mantissaLength, bytes) {
  var buffer = $Array(bytes);
  var exponentLength = bytes * 8 - mantissaLength - 1;
  var eMax = (1 << exponentLength) - 1;
  var eBias = eMax >> 1;
  var rt = mantissaLength === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var sign = number < 0 || number === 0 && 1 / number < 0 ? 1 : 0;
  var index = 0;
  var exponent, mantissa, c;
  number = abs(number);
  // eslint-disable-next-line no-self-compare -- NaN check
  if (number != number || number === Infinity) {
    // eslint-disable-next-line no-self-compare -- NaN check
    mantissa = number != number ? 1 : 0;
    exponent = eMax;
  } else {
    exponent = floor(log(number) / LN2);
    c = pow(2, -exponent);
    if (number * c < 1) {
      exponent--;
      c *= 2;
    }
    if (exponent + eBias >= 1) {
      number += rt / c;
    } else {
      number += rt * pow(2, 1 - eBias);
    }
    if (number * c >= 2) {
      exponent++;
      c /= 2;
    }
    if (exponent + eBias >= eMax) {
      mantissa = 0;
      exponent = eMax;
    } else if (exponent + eBias >= 1) {
      mantissa = (number * c - 1) * pow(2, mantissaLength);
      exponent = exponent + eBias;
    } else {
      mantissa = number * pow(2, eBias - 1) * pow(2, mantissaLength);
      exponent = 0;
    }
  }
  while (mantissaLength >= 8) {
    buffer[index++] = mantissa & 255;
    mantissa /= 256;
    mantissaLength -= 8;
  }
  exponent = exponent << mantissaLength | mantissa;
  exponentLength += mantissaLength;
  while (exponentLength > 0) {
    buffer[index++] = exponent & 255;
    exponent /= 256;
    exponentLength -= 8;
  }
  buffer[--index] |= sign * 128;
  return buffer;
};

var unpack = function (buffer, mantissaLength) {
  var bytes = buffer.length;
  var exponentLength = bytes * 8 - mantissaLength - 1;
  var eMax = (1 << exponentLength) - 1;
  var eBias = eMax >> 1;
  var nBits = exponentLength - 7;
  var index = bytes - 1;
  var sign = buffer[index--];
  var exponent = sign & 127;
  var mantissa;
  sign >>= 7;
  while (nBits > 0) {
    exponent = exponent * 256 + buffer[index--];
    nBits -= 8;
  }
  mantissa = exponent & (1 << -nBits) - 1;
  exponent >>= -nBits;
  nBits += mantissaLength;
  while (nBits > 0) {
    mantissa = mantissa * 256 + buffer[index--];
    nBits -= 8;
  }
  if (exponent === 0) {
    exponent = 1 - eBias;
  } else if (exponent === eMax) {
    return mantissa ? NaN : sign ? -Infinity : Infinity;
  } else {
    mantissa = mantissa + pow(2, mantissaLength);
    exponent = exponent - eBias;
  } return (sign ? -1 : 1) * mantissa * pow(2, exponent - mantissaLength);
};

module.exports = {
  pack: pack,
  unpack: unpack
};

},{}],679:[function(require,module,exports){
var uncurryThis = require('../internals/function-uncurry-this');
var fails = require('../internals/fails');
var classof = require('../internals/classof-raw');

var $Object = Object;
var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split(it, '') : $Object(it);
} : $Object;

},{"../internals/classof-raw":607,"../internals/fails":653,"../internals/function-uncurry-this":665}],680:[function(require,module,exports){
var isCallable = require('../internals/is-callable');
var isObject = require('../internals/is-object');
var setPrototypeOf = require('../internals/object-set-prototype-of');

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};

},{"../internals/is-callable":688,"../internals/is-object":694,"../internals/object-set-prototype-of":735}],681:[function(require,module,exports){
var uncurryThis = require('../internals/function-uncurry-this');
var isCallable = require('../internals/is-callable');
var store = require('../internals/shared-store');

var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

module.exports = store.inspectSource;

},{"../internals/function-uncurry-this":665,"../internals/is-callable":688,"../internals/shared-store":762}],682:[function(require,module,exports){
var isObject = require('../internals/is-object');
var createNonEnumerableProperty = require('../internals/create-non-enumerable-property');

// `InstallErrorCause` abstract operation
// https://tc39.es/proposal-error-cause/#sec-errorobjects-install-error-cause
module.exports = function (O, options) {
  if (isObject(options) && 'cause' in options) {
    createNonEnumerableProperty(O, 'cause', options.cause);
  }
};

},{"../internals/create-non-enumerable-property":617,"../internals/is-object":694}],683:[function(require,module,exports){
var $ = require('../internals/export');
var uncurryThis = require('../internals/function-uncurry-this');
var hiddenKeys = require('../internals/hidden-keys');
var isObject = require('../internals/is-object');
var hasOwn = require('../internals/has-own-property');
var defineProperty = require('../internals/object-define-property').f;
var getOwnPropertyNamesModule = require('../internals/object-get-own-property-names');
var getOwnPropertyNamesExternalModule = require('../internals/object-get-own-property-names-external');
var isExtensible = require('../internals/object-is-extensible');
var uid = require('../internals/uid');
var FREEZING = require('../internals/freezing');

var REQUIRED = false;
var METADATA = uid('meta');
var id = 0;

var setMetadata = function (it) {
  defineProperty(it, METADATA, { value: {
    objectID: 'O' + id++, // object ID
    weakData: {}          // weak collections IDs
  } });
};

var fastKey = function (it, create) {
  // return a primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!hasOwn(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMetadata(it);
  // return object ID
  } return it[METADATA].objectID;
};

var getWeakData = function (it, create) {
  if (!hasOwn(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMetadata(it);
  // return the store of weak collections IDs
  } return it[METADATA].weakData;
};

// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZING && REQUIRED && isExtensible(it) && !hasOwn(it, METADATA)) setMetadata(it);
  return it;
};

var enable = function () {
  meta.enable = function () { /* empty */ };
  REQUIRED = true;
  var getOwnPropertyNames = getOwnPropertyNamesModule.f;
  var splice = uncurryThis([].splice);
  var test = {};
  test[METADATA] = 1;

  // prevent exposing of metadata key
  if (getOwnPropertyNames(test).length) {
    getOwnPropertyNamesModule.f = function (it) {
      var result = getOwnPropertyNames(it);
      for (var i = 0, length = result.length; i < length; i++) {
        if (result[i] === METADATA) {
          splice(result, i, 1);
          break;
        }
      } return result;
    };

    $({ target: 'Object', stat: true, forced: true }, {
      getOwnPropertyNames: getOwnPropertyNamesExternalModule.f
    });
  }
};

var meta = module.exports = {
  enable: enable,
  fastKey: fastKey,
  getWeakData: getWeakData,
  onFreeze: onFreeze
};

hiddenKeys[METADATA] = true;

},{"../internals/export":652,"../internals/freezing":656,"../internals/function-uncurry-this":665,"../internals/has-own-property":673,"../internals/hidden-keys":674,"../internals/is-object":694,"../internals/object-define-property":723,"../internals/object-get-own-property-names":726,"../internals/object-get-own-property-names-external":725,"../internals/object-is-extensible":729,"../internals/uid":801}],684:[function(require,module,exports){
var NATIVE_WEAK_MAP = require('../internals/weak-map-basic-detection');
var global = require('../internals/global');
var isObject = require('../internals/is-object');
var createNonEnumerableProperty = require('../internals/create-non-enumerable-property');
var hasOwn = require('../internals/has-own-property');
var shared = require('../internals/shared-store');
var sharedKey = require('../internals/shared-key');
var hiddenKeys = require('../internals/hidden-keys');

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = global.TypeError;
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store.has(it)) throw TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn(it, STATE)) throw TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

},{"../internals/create-non-enumerable-property":617,"../internals/global":672,"../internals/has-own-property":673,"../internals/hidden-keys":674,"../internals/is-object":694,"../internals/shared-key":761,"../internals/shared-store":762,"../internals/weak-map-basic-detection":806}],685:[function(require,module,exports){
var wellKnownSymbol = require('../internals/well-known-symbol');
var Iterators = require('../internals/iterators');

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};

},{"../internals/iterators":703,"../internals/well-known-symbol":809}],686:[function(require,module,exports){
var classof = require('../internals/classof-raw');

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
  return classof(argument) == 'Array';
};

},{"../internals/classof-raw":607}],687:[function(require,module,exports){
var classof = require('../internals/classof');

module.exports = function (it) {
  var klass = classof(it);
  return klass == 'BigInt64Array' || klass == 'BigUint64Array';
};

},{"../internals/classof":608}],688:[function(require,module,exports){
var $documentAll = require('../internals/document-all');

var documentAll = $documentAll.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = $documentAll.IS_HTMLDDA ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};

},{"../internals/document-all":628}],689:[function(require,module,exports){
var uncurryThis = require('../internals/function-uncurry-this');
var fails = require('../internals/fails');
var isCallable = require('../internals/is-callable');
var classof = require('../internals/classof');
var getBuiltIn = require('../internals/get-built-in');
var inspectSource = require('../internals/inspect-source');

var noop = function () { /* empty */ };
var empty = [];
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(noop, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !construct || fails(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;

},{"../internals/classof":608,"../internals/fails":653,"../internals/function-uncurry-this":665,"../internals/get-built-in":666,"../internals/inspect-source":681,"../internals/is-callable":688}],690:[function(require,module,exports){
var hasOwn = require('../internals/has-own-property');

module.exports = function (descriptor) {
  return descriptor !== undefined && (hasOwn(descriptor, 'value') || hasOwn(descriptor, 'writable'));
};

},{"../internals/has-own-property":673}],691:[function(require,module,exports){
var fails = require('../internals/fails');
var isCallable = require('../internals/is-callable');

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;

},{"../internals/fails":653,"../internals/is-callable":688}],692:[function(require,module,exports){
var isObject = require('../internals/is-object');

var floor = Math.floor;

// `IsIntegralNumber` abstract operation
// https://tc39.es/ecma262/#sec-isintegralnumber
// eslint-disable-next-line es/no-number-isinteger -- safe
module.exports = Number.isInteger || function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};

},{"../internals/is-object":694}],693:[function(require,module,exports){
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function (it) {
  return it === null || it === undefined;
};

},{}],694:[function(require,module,exports){
var isCallable = require('../internals/is-callable');
var $documentAll = require('../internals/document-all');

var documentAll = $documentAll.all;

module.exports = $documentAll.IS_HTMLDDA ? function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it) || it === documentAll;
} : function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};

},{"../internals/document-all":628,"../internals/is-callable":688}],695:[function(require,module,exports){
module.exports = false;

},{}],696:[function(require,module,exports){
var isObject = require('../internals/is-object');
var classof = require('../internals/classof-raw');
var wellKnownSymbol = require('../internals/well-known-symbol');

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
};

},{"../internals/classof-raw":607,"../internals/is-object":694,"../internals/well-known-symbol":809}],697:[function(require,module,exports){
var getBuiltIn = require('../internals/get-built-in');
var isCallable = require('../internals/is-callable');
var isPrototypeOf = require('../internals/object-is-prototype-of');
var USE_SYMBOL_AS_UID = require('../internals/use-symbol-as-uid');

var $Object = Object;

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
};

},{"../internals/get-built-in":666,"../internals/is-callable":688,"../internals/object-is-prototype-of":730,"../internals/use-symbol-as-uid":803}],698:[function(require,module,exports){
var bind = require('../internals/function-bind-context');
var call = require('../internals/function-call');
var anObject = require('../internals/an-object');
var tryToString = require('../internals/try-to-string');
var isArrayIteratorMethod = require('../internals/is-array-iterator-method');
var lengthOfArrayLike = require('../internals/length-of-array-like');
var isPrototypeOf = require('../internals/object-is-prototype-of');
var getIterator = require('../internals/get-iterator');
var getIteratorMethod = require('../internals/get-iterator-method');
var iteratorClose = require('../internals/iterator-close');

var $TypeError = TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

module.exports = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw $TypeError(tryToString(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = IS_RECORD ? iterable.next : iterator.next;
  while (!(step = call(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf(ResultPrototype, result)) return result;
  } return new Result(false);
};

},{"../internals/an-object":579,"../internals/function-bind-context":658,"../internals/function-call":661,"../internals/get-iterator":668,"../internals/get-iterator-method":667,"../internals/is-array-iterator-method":685,"../internals/iterator-close":699,"../internals/length-of-array-like":704,"../internals/object-is-prototype-of":730,"../internals/try-to-string":795}],699:[function(require,module,exports){
var call = require('../internals/function-call');
var anObject = require('../internals/an-object');
var getMethod = require('../internals/get-method');

module.exports = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject(innerResult);
  return value;
};

},{"../internals/an-object":579,"../internals/function-call":661,"../internals/get-method":670}],700:[function(require,module,exports){
'use strict';
var IteratorPrototype = require('../internals/iterators-core').IteratorPrototype;
var create = require('../internals/object-create');
var createPropertyDescriptor = require('../internals/create-property-descriptor');
var setToStringTag = require('../internals/set-to-string-tag');
var Iterators = require('../internals/iterators');

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};

},{"../internals/create-property-descriptor":618,"../internals/iterators":703,"../internals/iterators-core":702,"../internals/object-create":721,"../internals/set-to-string-tag":760}],701:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var call = require('../internals/function-call');
var IS_PURE = require('../internals/is-pure');
var FunctionName = require('../internals/function-name');
var isCallable = require('../internals/is-callable');
var createIteratorConstructor = require('../internals/iterator-create-constructor');
var getPrototypeOf = require('../internals/object-get-prototype-of');
var setPrototypeOf = require('../internals/object-set-prototype-of');
var setToStringTag = require('../internals/set-to-string-tag');
var createNonEnumerableProperty = require('../internals/create-non-enumerable-property');
var defineBuiltIn = require('../internals/define-built-in');
var wellKnownSymbol = require('../internals/well-known-symbol');
var Iterators = require('../internals/iterators');
var IteratorsCore = require('../internals/iterators-core');

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) {
          defineBuiltIn(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    defineBuiltIn(IterablePrototype, ITERATOR, defaultIterator, { name: DEFAULT });
  }
  Iterators[NAME] = defaultIterator;

  return methods;
};

},{"../internals/create-non-enumerable-property":617,"../internals/define-built-in":623,"../internals/export":652,"../internals/function-call":661,"../internals/function-name":662,"../internals/is-callable":688,"../internals/is-pure":695,"../internals/iterator-create-constructor":700,"../internals/iterators":703,"../internals/iterators-core":702,"../internals/object-get-prototype-of":728,"../internals/object-set-prototype-of":735,"../internals/set-to-string-tag":760,"../internals/well-known-symbol":809}],702:[function(require,module,exports){
'use strict';
var fails = require('../internals/fails');
var isCallable = require('../internals/is-callable');
var isObject = require('../internals/is-object');
var create = require('../internals/object-create');
var getPrototypeOf = require('../internals/object-get-prototype-of');
var defineBuiltIn = require('../internals/define-built-in');
var wellKnownSymbol = require('../internals/well-known-symbol');
var IS_PURE = require('../internals/is-pure');

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject(IteratorPrototype) || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable(IteratorPrototype[ITERATOR])) {
  defineBuiltIn(IteratorPrototype, ITERATOR, function () {
    return this;
  });
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};

},{"../internals/define-built-in":623,"../internals/fails":653,"../internals/is-callable":688,"../internals/is-object":694,"../internals/is-pure":695,"../internals/object-create":721,"../internals/object-get-prototype-of":728,"../internals/well-known-symbol":809}],703:[function(require,module,exports){
arguments[4][674][0].apply(exports,arguments)
},{"dup":674}],704:[function(require,module,exports){
var toLength = require('../internals/to-length');

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};

},{"../internals/to-length":786}],705:[function(require,module,exports){
var uncurryThis = require('../internals/function-uncurry-this');
var fails = require('../internals/fails');
var isCallable = require('../internals/is-callable');
var hasOwn = require('../internals/has-own-property');
var DESCRIPTORS = require('../internals/descriptors');
var CONFIGURABLE_FUNCTION_NAME = require('../internals/function-name').CONFIGURABLE;
var inspectSource = require('../internals/inspect-source');
var InternalStateModule = require('../internals/internal-state');

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
var $String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;
var stringSlice = uncurryThis(''.slice);
var replace = uncurryThis(''.replace);
var join = uncurryThis([].join);

var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function () {
  return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn = module.exports = function (value, name, options) {
  if (stringSlice($String(name), 0, 7) === 'Symbol(') {
    name = '[' + replace($String(name), /^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    if (DESCRIPTORS) defineProperty(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn(options, 'arity') && value.length !== options.arity) {
    defineProperty(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS) defineProperty(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn(state, 'source')) {
    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn(function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
}, 'toString');

},{"../internals/descriptors":627,"../internals/fails":653,"../internals/function-name":662,"../internals/function-uncurry-this":665,"../internals/has-own-property":673,"../internals/inspect-source":681,"../internals/internal-state":684,"../internals/is-callable":688}],706:[function(require,module,exports){
var uncurryThis = require('../internals/function-uncurry-this');

// eslint-disable-next-line es/no-map -- safe
var MapPrototype = Map.prototype;

module.exports = {
  // eslint-disable-next-line es/no-map -- safe
  Map: Map,
  set: uncurryThis(MapPrototype.set),
  get: uncurryThis(MapPrototype.get),
  has: uncurryThis(MapPrototype.has),
  remove: uncurryThis(MapPrototype['delete']),
  proto: MapPrototype
};

},{"../internals/function-uncurry-this":665}],707:[function(require,module,exports){
// eslint-disable-next-line es/no-math-expm1 -- safe
var $expm1 = Math.expm1;
var exp = Math.exp;

// `Math.expm1` method implementation
// https://tc39.es/ecma262/#sec-math.expm1
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  var n = +x;
  return n == 0 ? n : n > -1e-6 && n < 1e-6 ? n + n * n / 2 : exp(n) - 1;
} : $expm1;

},{}],708:[function(require,module,exports){
var sign = require('../internals/math-sign');

var abs = Math.abs;
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

// `Math.fround` method implementation
// https://tc39.es/ecma262/#sec-math.fround
// eslint-disable-next-line es/no-math-fround -- safe
module.exports = Math.fround || function fround(x) {
  var n = +x;
  var $abs = abs(n);
  var $sign = sign(n);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare -- NaN check
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};

},{"../internals/math-sign":711}],709:[function(require,module,exports){
var log = Math.log;
var LOG10E = Math.LOG10E;

// eslint-disable-next-line es/no-math-log10 -- safe
module.exports = Math.log10 || function log10(x) {
  return log(x) * LOG10E;
};

},{}],710:[function(require,module,exports){
var log = Math.log;

// `Math.log1p` method implementation
// https://tc39.es/ecma262/#sec-math.log1p
// eslint-disable-next-line es/no-math-log1p -- safe
module.exports = Math.log1p || function log1p(x) {
  var n = +x;
  return n > -1e-8 && n < 1e-8 ? n - n * n / 2 : log(1 + n);
};

},{}],711:[function(require,module,exports){
// `Math.sign` method implementation
// https://tc39.es/ecma262/#sec-math.sign
// eslint-disable-next-line es/no-math-sign -- safe
module.exports = Math.sign || function sign(x) {
  var n = +x;
  // eslint-disable-next-line no-self-compare -- NaN check
  return n == 0 || n != n ? n : n < 0 ? -1 : 1;
};

},{}],712:[function(require,module,exports){
var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};

},{}],713:[function(require,module,exports){
var global = require('../internals/global');
var bind = require('../internals/function-bind-context');
var getOwnPropertyDescriptor = require('../internals/object-get-own-property-descriptor').f;
var macrotask = require('../internals/task').set;
var Queue = require('../internals/queue');
var IS_IOS = require('../internals/engine-is-ios');
var IS_IOS_PEBBLE = require('../internals/engine-is-ios-pebble');
var IS_WEBOS_WEBKIT = require('../internals/engine-is-webos-webkit');
var IS_NODE = require('../internals/engine-is-node');

var MutationObserver = global.MutationObserver || global.WebKitMutationObserver;
var document = global.document;
var process = global.process;
var Promise = global.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global, 'queueMicrotask');
var microtask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;
var notify, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!microtask) {
  var queue = new Queue();

  var flush = function () {
    var parent, fn;
    if (IS_NODE && (parent = process.domain)) parent.exit();
    while (fn = queue.get()) try {
      fn();
    } catch (error) {
      if (queue.head) notify();
      throw error;
    }
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE && !IS_WEBOS_WEBKIT && MutationObserver && document) {
    toggle = true;
    node = document.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (!IS_IOS_PEBBLE && Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise;
    then = bind(promise.then, promise);
    notify = function () {
      then(flush);
    };
  // Node.js without promises
  } else if (IS_NODE) {
    notify = function () {
      process.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessage
  // - onreadystatechange
  // - setTimeout
  } else {
    // `webpack` dev server bug on IE global methods - use bind(fn, global)
    macrotask = bind(macrotask, global);
    notify = function () {
      macrotask(flush);
    };
  }

  microtask = function (fn) {
    if (!queue.head) notify();
    queue.add(fn);
  };
}

module.exports = microtask;

},{"../internals/engine-is-ios":640,"../internals/engine-is-ios-pebble":639,"../internals/engine-is-node":641,"../internals/engine-is-webos-webkit":642,"../internals/function-bind-context":658,"../internals/global":672,"../internals/object-get-own-property-descriptor":724,"../internals/queue":747,"../internals/task":779}],714:[function(require,module,exports){
'use strict';
var aCallable = require('../internals/a-callable');

var $TypeError = TypeError;

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw $TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable(resolve);
  this.reject = aCallable(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
module.exports.f = function (C) {
  return new PromiseCapability(C);
};

},{"../internals/a-callable":573}],715:[function(require,module,exports){
var toString = require('../internals/to-string');

module.exports = function (argument, $default) {
  return argument === undefined ? arguments.length < 2 ? '' : $default : toString(argument);
};

},{"../internals/to-string":793}],716:[function(require,module,exports){
var isRegExp = require('../internals/is-regexp');

var $TypeError = TypeError;

module.exports = function (it) {
  if (isRegExp(it)) {
    throw $TypeError("The method doesn't accept regular expressions");
  } return it;
};

},{"../internals/is-regexp":696}],717:[function(require,module,exports){
var global = require('../internals/global');

var globalIsFinite = global.isFinite;

// `Number.isFinite` method
// https://tc39.es/ecma262/#sec-number.isfinite
// eslint-disable-next-line es/no-number-isfinite -- safe
module.exports = Number.isFinite || function isFinite(it) {
  return typeof it == 'number' && globalIsFinite(it);
};

},{"../internals/global":672}],718:[function(require,module,exports){
var global = require('../internals/global');
var fails = require('../internals/fails');
var uncurryThis = require('../internals/function-uncurry-this');
var toString = require('../internals/to-string');
var trim = require('../internals/string-trim').trim;
var whitespaces = require('../internals/whitespaces');

var charAt = uncurryThis(''.charAt);
var $parseFloat = global.parseFloat;
var Symbol = global.Symbol;
var ITERATOR = Symbol && Symbol.iterator;
var FORCED = 1 / $parseFloat(whitespaces + '-0') !== -Infinity
  // MS Edge 18- broken with boxed symbols
  || (ITERATOR && !fails(function () { $parseFloat(Object(ITERATOR)); }));

// `parseFloat` method
// https://tc39.es/ecma262/#sec-parsefloat-string
module.exports = FORCED ? function parseFloat(string) {
  var trimmedString = trim(toString(string));
  var result = $parseFloat(trimmedString);
  return result === 0 && charAt(trimmedString, 0) == '-' ? -0 : result;
} : $parseFloat;

},{"../internals/fails":653,"../internals/function-uncurry-this":665,"../internals/global":672,"../internals/string-trim":774,"../internals/to-string":793,"../internals/whitespaces":810}],719:[function(require,module,exports){
var global = require('../internals/global');
var fails = require('../internals/fails');
var uncurryThis = require('../internals/function-uncurry-this');
var toString = require('../internals/to-string');
var trim = require('../internals/string-trim').trim;
var whitespaces = require('../internals/whitespaces');

var $parseInt = global.parseInt;
var Symbol = global.Symbol;
var ITERATOR = Symbol && Symbol.iterator;
var hex = /^[+-]?0x/i;
var exec = uncurryThis(hex.exec);
var FORCED = $parseInt(whitespaces + '08') !== 8 || $parseInt(whitespaces + '0x16') !== 22
  // MS Edge 18- broken with boxed symbols
  || (ITERATOR && !fails(function () { $parseInt(Object(ITERATOR)); }));

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
module.exports = FORCED ? function parseInt(string, radix) {
  var S = trim(toString(string));
  return $parseInt(S, (radix >>> 0) || (exec(hex, S) ? 16 : 10));
} : $parseInt;

},{"../internals/fails":653,"../internals/function-uncurry-this":665,"../internals/global":672,"../internals/string-trim":774,"../internals/to-string":793,"../internals/whitespaces":810}],720:[function(require,module,exports){
'use strict';
var DESCRIPTORS = require('../internals/descriptors');
var uncurryThis = require('../internals/function-uncurry-this');
var call = require('../internals/function-call');
var fails = require('../internals/fails');
var objectKeys = require('../internals/object-keys');
var getOwnPropertySymbolsModule = require('../internals/object-get-own-property-symbols');
var propertyIsEnumerableModule = require('../internals/object-property-is-enumerable');
var toObject = require('../internals/to-object');
var IndexedObject = require('../internals/indexed-object');

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty = Object.defineProperty;
var concat = uncurryThis([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
module.exports = !$assign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && $assign({ b: 1 }, $assign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || call(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

},{"../internals/descriptors":627,"../internals/fails":653,"../internals/function-call":661,"../internals/function-uncurry-this":665,"../internals/indexed-object":679,"../internals/object-get-own-property-symbols":727,"../internals/object-keys":732,"../internals/object-property-is-enumerable":733,"../internals/to-object":787}],721:[function(require,module,exports){
/* global ActiveXObject -- old IE, WSH */
var anObject = require('../internals/an-object');
var definePropertiesModule = require('../internals/object-define-properties');
var enumBugKeys = require('../internals/enum-bug-keys');
var hiddenKeys = require('../internals/hidden-keys');
var html = require('../internals/html');
var documentCreateElement = require('../internals/document-create-element');
var sharedKey = require('../internals/shared-key');

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};

},{"../internals/an-object":579,"../internals/document-create-element":629,"../internals/enum-bug-keys":647,"../internals/hidden-keys":674,"../internals/html":676,"../internals/object-define-properties":722,"../internals/shared-key":761}],722:[function(require,module,exports){
var DESCRIPTORS = require('../internals/descriptors');
var V8_PROTOTYPE_DEFINE_BUG = require('../internals/v8-prototype-define-bug');
var definePropertyModule = require('../internals/object-define-property');
var anObject = require('../internals/an-object');
var toIndexedObject = require('../internals/to-indexed-object');
var objectKeys = require('../internals/object-keys');

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
exports.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};

},{"../internals/an-object":579,"../internals/descriptors":627,"../internals/object-define-property":723,"../internals/object-keys":732,"../internals/to-indexed-object":784,"../internals/v8-prototype-define-bug":804}],723:[function(require,module,exports){
var DESCRIPTORS = require('../internals/descriptors');
var IE8_DOM_DEFINE = require('../internals/ie8-dom-define');
var V8_PROTOTYPE_DEFINE_BUG = require('../internals/v8-prototype-define-bug');
var anObject = require('../internals/an-object');
var toPropertyKey = require('../internals/to-property-key');

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

},{"../internals/an-object":579,"../internals/descriptors":627,"../internals/ie8-dom-define":677,"../internals/to-property-key":791,"../internals/v8-prototype-define-bug":804}],724:[function(require,module,exports){
var DESCRIPTORS = require('../internals/descriptors');
var call = require('../internals/function-call');
var propertyIsEnumerableModule = require('../internals/object-property-is-enumerable');
var createPropertyDescriptor = require('../internals/create-property-descriptor');
var toIndexedObject = require('../internals/to-indexed-object');
var toPropertyKey = require('../internals/to-property-key');
var hasOwn = require('../internals/has-own-property');
var IE8_DOM_DEFINE = require('../internals/ie8-dom-define');

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};

},{"../internals/create-property-descriptor":618,"../internals/descriptors":627,"../internals/function-call":661,"../internals/has-own-property":673,"../internals/ie8-dom-define":677,"../internals/object-property-is-enumerable":733,"../internals/to-indexed-object":784,"../internals/to-property-key":791}],725:[function(require,module,exports){
/* eslint-disable es/no-object-getownpropertynames -- safe */
var classof = require('../internals/classof-raw');
var toIndexedObject = require('../internals/to-indexed-object');
var $getOwnPropertyNames = require('../internals/object-get-own-property-names').f;
var arraySlice = require('../internals/array-slice-simple');

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return $getOwnPropertyNames(it);
  } catch (error) {
    return arraySlice(windowNames);
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && classof(it) == 'Window'
    ? getWindowNames(it)
    : $getOwnPropertyNames(toIndexedObject(it));
};

},{"../internals/array-slice-simple":597,"../internals/classof-raw":607,"../internals/object-get-own-property-names":726,"../internals/to-indexed-object":784}],726:[function(require,module,exports){
var internalObjectKeys = require('../internals/object-keys-internal');
var enumBugKeys = require('../internals/enum-bug-keys');

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};

},{"../internals/enum-bug-keys":647,"../internals/object-keys-internal":731}],727:[function(require,module,exports){
// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;

},{}],728:[function(require,module,exports){
var hasOwn = require('../internals/has-own-property');
var isCallable = require('../internals/is-callable');
var toObject = require('../internals/to-object');
var sharedKey = require('../internals/shared-key');
var CORRECT_PROTOTYPE_GETTER = require('../internals/correct-prototype-getter');

var IE_PROTO = sharedKey('IE_PROTO');
var $Object = Object;
var ObjectPrototype = $Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object ? ObjectPrototype : null;
};

},{"../internals/correct-prototype-getter":614,"../internals/has-own-property":673,"../internals/is-callable":688,"../internals/shared-key":761,"../internals/to-object":787}],729:[function(require,module,exports){
var fails = require('../internals/fails');
var isObject = require('../internals/is-object');
var classof = require('../internals/classof-raw');
var ARRAY_BUFFER_NON_EXTENSIBLE = require('../internals/array-buffer-non-extensible');

// eslint-disable-next-line es/no-object-isextensible -- safe
var $isExtensible = Object.isExtensible;
var FAILS_ON_PRIMITIVES = fails(function () { $isExtensible(1); });

// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
module.exports = (FAILS_ON_PRIMITIVES || ARRAY_BUFFER_NON_EXTENSIBLE) ? function isExtensible(it) {
  if (!isObject(it)) return false;
  if (ARRAY_BUFFER_NON_EXTENSIBLE && classof(it) == 'ArrayBuffer') return false;
  return $isExtensible ? $isExtensible(it) : true;
} : $isExtensible;

},{"../internals/array-buffer-non-extensible":581,"../internals/classof-raw":607,"../internals/fails":653,"../internals/is-object":694}],730:[function(require,module,exports){
var uncurryThis = require('../internals/function-uncurry-this');

module.exports = uncurryThis({}.isPrototypeOf);

},{"../internals/function-uncurry-this":665}],731:[function(require,module,exports){
var uncurryThis = require('../internals/function-uncurry-this');
var hasOwn = require('../internals/has-own-property');
var toIndexedObject = require('../internals/to-indexed-object');
var indexOf = require('../internals/array-includes').indexOf;
var hiddenKeys = require('../internals/hidden-keys');

var push = uncurryThis([].push);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};

},{"../internals/array-includes":589,"../internals/function-uncurry-this":665,"../internals/has-own-property":673,"../internals/hidden-keys":674,"../internals/to-indexed-object":784}],732:[function(require,module,exports){
var internalObjectKeys = require('../internals/object-keys-internal');
var enumBugKeys = require('../internals/enum-bug-keys');

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};

},{"../internals/enum-bug-keys":647,"../internals/object-keys-internal":731}],733:[function(require,module,exports){
'use strict';
var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

},{}],734:[function(require,module,exports){
'use strict';
var IS_PURE = require('../internals/is-pure');
var global = require('../internals/global');
var fails = require('../internals/fails');
var WEBKIT = require('../internals/engine-webkit-version');

// Forced replacement object prototype accessors methods
module.exports = IS_PURE || !fails(function () {
  // This feature detection crashes old WebKit
  // https://github.com/zloirock/core-js/issues/232
  if (WEBKIT && WEBKIT < 535) return;
  var key = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call, es/no-legacy-object-prototype-accessor-methods -- required for testing
  __defineSetter__.call(null, key, function () { /* empty */ });
  delete global[key];
});

},{"../internals/engine-webkit-version":645,"../internals/fails":653,"../internals/global":672,"../internals/is-pure":695}],735:[function(require,module,exports){
/* eslint-disable no-proto -- safe */
var uncurryThisAccessor = require('../internals/function-uncurry-this-accessor');
var anObject = require('../internals/an-object');
var aPossiblePrototype = require('../internals/a-possible-prototype');

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

},{"../internals/a-possible-prototype":575,"../internals/an-object":579,"../internals/function-uncurry-this-accessor":663}],736:[function(require,module,exports){
var DESCRIPTORS = require('../internals/descriptors');
var uncurryThis = require('../internals/function-uncurry-this');
var objectKeys = require('../internals/object-keys');
var toIndexedObject = require('../internals/to-indexed-object');
var $propertyIsEnumerable = require('../internals/object-property-is-enumerable').f;

var propertyIsEnumerable = uncurryThis($propertyIsEnumerable);
var push = uncurryThis([].push);

// `Object.{ entries, values }` methods implementation
var createMethod = function (TO_ENTRIES) {
  return function (it) {
    var O = toIndexedObject(it);
    var keys = objectKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || propertyIsEnumerable(O, key)) {
        push(result, TO_ENTRIES ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

module.exports = {
  // `Object.entries` method
  // https://tc39.es/ecma262/#sec-object.entries
  entries: createMethod(true),
  // `Object.values` method
  // https://tc39.es/ecma262/#sec-object.values
  values: createMethod(false)
};

},{"../internals/descriptors":627,"../internals/function-uncurry-this":665,"../internals/object-keys":732,"../internals/object-property-is-enumerable":733,"../internals/to-indexed-object":784}],737:[function(require,module,exports){
'use strict';
var TO_STRING_TAG_SUPPORT = require('../internals/to-string-tag-support');
var classof = require('../internals/classof');

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};

},{"../internals/classof":608,"../internals/to-string-tag-support":792}],738:[function(require,module,exports){
var call = require('../internals/function-call');
var isCallable = require('../internals/is-callable');
var isObject = require('../internals/is-object');

var $TypeError = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  throw $TypeError("Can't convert object to primitive value");
};

},{"../internals/function-call":661,"../internals/is-callable":688,"../internals/is-object":694}],739:[function(require,module,exports){
var getBuiltIn = require('../internals/get-built-in');
var uncurryThis = require('../internals/function-uncurry-this');
var getOwnPropertyNamesModule = require('../internals/object-get-own-property-names');
var getOwnPropertySymbolsModule = require('../internals/object-get-own-property-symbols');
var anObject = require('../internals/an-object');

var concat = uncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};

},{"../internals/an-object":579,"../internals/function-uncurry-this":665,"../internals/get-built-in":666,"../internals/object-get-own-property-names":726,"../internals/object-get-own-property-symbols":727}],740:[function(require,module,exports){
var global = require('../internals/global');

module.exports = global;

},{"../internals/global":672}],741:[function(require,module,exports){
module.exports = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};

},{}],742:[function(require,module,exports){
var global = require('../internals/global');
var NativePromiseConstructor = require('../internals/promise-native-constructor');
var isCallable = require('../internals/is-callable');
var isForced = require('../internals/is-forced');
var inspectSource = require('../internals/inspect-source');
var wellKnownSymbol = require('../internals/well-known-symbol');
var IS_BROWSER = require('../internals/engine-is-browser');
var IS_DENO = require('../internals/engine-is-deno');
var IS_PURE = require('../internals/is-pure');
var V8_VERSION = require('../internals/engine-v8-version');

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
var SPECIES = wellKnownSymbol('species');
var SUBCLASSING = false;
var NATIVE_PROMISE_REJECTION_EVENT = isCallable(global.PromiseRejectionEvent);

var FORCED_PROMISE_CONSTRUCTOR = isForced('Promise', function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(NativePromiseConstructor);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(NativePromiseConstructor);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  // We need Promise#{ catch, finally } in the pure version for preventing prototype pollution
  if (IS_PURE && !(NativePromisePrototype['catch'] && NativePromisePrototype['finally'])) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (!V8_VERSION || V8_VERSION < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
    // Detect correctness of subclassing with @@species support
    var promise = new NativePromiseConstructor(function (resolve) { resolve(1); });
    var FakePromise = function (exec) {
      exec(function () { /* empty */ }, function () { /* empty */ });
    };
    var constructor = promise.constructor = {};
    constructor[SPECIES] = FakePromise;
    SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
    if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  } return !GLOBAL_CORE_JS_PROMISE && (IS_BROWSER || IS_DENO) && !NATIVE_PROMISE_REJECTION_EVENT;
});

module.exports = {
  CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR,
  REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT,
  SUBCLASSING: SUBCLASSING
};

},{"../internals/engine-is-browser":635,"../internals/engine-is-deno":637,"../internals/engine-v8-version":644,"../internals/global":672,"../internals/inspect-source":681,"../internals/is-callable":688,"../internals/is-forced":691,"../internals/is-pure":695,"../internals/promise-native-constructor":743,"../internals/well-known-symbol":809}],743:[function(require,module,exports){
var global = require('../internals/global');

module.exports = global.Promise;

},{"../internals/global":672}],744:[function(require,module,exports){
var anObject = require('../internals/an-object');
var isObject = require('../internals/is-object');
var newPromiseCapability = require('../internals/new-promise-capability');

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

},{"../internals/an-object":579,"../internals/is-object":694,"../internals/new-promise-capability":714}],745:[function(require,module,exports){
var NativePromiseConstructor = require('../internals/promise-native-constructor');
var checkCorrectnessOfIteration = require('../internals/check-correctness-of-iteration');
var FORCED_PROMISE_CONSTRUCTOR = require('../internals/promise-constructor-detection').CONSTRUCTOR;

module.exports = FORCED_PROMISE_CONSTRUCTOR || !checkCorrectnessOfIteration(function (iterable) {
  NativePromiseConstructor.all(iterable).then(undefined, function () { /* empty */ });
});

},{"../internals/check-correctness-of-iteration":606,"../internals/promise-constructor-detection":742,"../internals/promise-native-constructor":743}],746:[function(require,module,exports){
var defineProperty = require('../internals/object-define-property').f;

module.exports = function (Target, Source, key) {
  key in Target || defineProperty(Target, key, {
    configurable: true,
    get: function () { return Source[key]; },
    set: function (it) { Source[key] = it; }
  });
};

},{"../internals/object-define-property":723}],747:[function(require,module,exports){
var Queue = function () {
  this.head = null;
  this.tail = null;
};

Queue.prototype = {
  add: function (item) {
    var entry = { item: item, next: null };
    var tail = this.tail;
    if (tail) tail.next = entry;
    else this.head = entry;
    this.tail = entry;
  },
  get: function () {
    var entry = this.head;
    if (entry) {
      var next = this.head = entry.next;
      if (next === null) this.tail = null;
      return entry.item;
    }
  }
};

module.exports = Queue;

},{}],748:[function(require,module,exports){
var call = require('../internals/function-call');
var anObject = require('../internals/an-object');
var isCallable = require('../internals/is-callable');
var classof = require('../internals/classof-raw');
var regexpExec = require('../internals/regexp-exec');

var $TypeError = TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (isCallable(exec)) {
    var result = call(exec, R, S);
    if (result !== null) anObject(result);
    return result;
  }
  if (classof(R) === 'RegExp') return call(regexpExec, R, S);
  throw $TypeError('RegExp#exec called on incompatible receiver');
};

},{"../internals/an-object":579,"../internals/classof-raw":607,"../internals/function-call":661,"../internals/is-callable":688,"../internals/regexp-exec":749}],749:[function(require,module,exports){
'use strict';
/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var call = require('../internals/function-call');
var uncurryThis = require('../internals/function-uncurry-this');
var toString = require('../internals/to-string');
var regexpFlags = require('../internals/regexp-flags');
var stickyHelpers = require('../internals/regexp-sticky-helpers');
var shared = require('../internals/shared');
var create = require('../internals/object-create');
var getInternalState = require('../internals/internal-state').get;
var UNSUPPORTED_DOT_ALL = require('../internals/regexp-unsupported-dot-all');
var UNSUPPORTED_NCG = require('../internals/regexp-unsupported-ncg');

var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt = uncurryThis(''.charAt);
var indexOf = uncurryThis(''.indexOf);
var replace = uncurryThis(''.replace);
var stringSlice = uncurryThis(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  call(nativeExec, re1, 'a');
  call(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState(re);
    var str = toString(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = call(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = call(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace(flags, 'y', '');
      if (indexOf(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = call(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice(match.input, charsAdded);
        match[0] = stringSlice(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
      call(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

module.exports = patchedExec;

},{"../internals/function-call":661,"../internals/function-uncurry-this":665,"../internals/internal-state":684,"../internals/object-create":721,"../internals/regexp-flags":750,"../internals/regexp-sticky-helpers":752,"../internals/regexp-unsupported-dot-all":753,"../internals/regexp-unsupported-ncg":754,"../internals/shared":763,"../internals/to-string":793}],750:[function(require,module,exports){
'use strict';
var anObject = require('../internals/an-object');

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};

},{"../internals/an-object":579}],751:[function(require,module,exports){
var call = require('../internals/function-call');
var hasOwn = require('../internals/has-own-property');
var isPrototypeOf = require('../internals/object-is-prototype-of');
var regExpFlags = require('../internals/regexp-flags');

var RegExpPrototype = RegExp.prototype;

module.exports = function (R) {
  var flags = R.flags;
  return flags === undefined && !('flags' in RegExpPrototype) && !hasOwn(R, 'flags') && isPrototypeOf(RegExpPrototype, R)
    ? call(regExpFlags, R) : flags;
};

},{"../internals/function-call":661,"../internals/has-own-property":673,"../internals/object-is-prototype-of":730,"../internals/regexp-flags":750}],752:[function(require,module,exports){
var fails = require('../internals/fails');
var global = require('../internals/global');

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp = global.RegExp;

var UNSUPPORTED_Y = fails(function () {
  var re = $RegExp('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY = UNSUPPORTED_Y || fails(function () {
  return !$RegExp('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y || fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});

module.exports = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY,
  UNSUPPORTED_Y: UNSUPPORTED_Y
};

},{"../internals/fails":653,"../internals/global":672}],753:[function(require,module,exports){
var fails = require('../internals/fails');
var global = require('../internals/global');

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp = global.RegExp;

module.exports = fails(function () {
  var re = $RegExp('.', 's');
  return !(re.dotAll && re.exec('\n') && re.flags === 's');
});

},{"../internals/fails":653,"../internals/global":672}],754:[function(require,module,exports){
var fails = require('../internals/fails');
var global = require('../internals/global');

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = global.RegExp;

module.exports = fails(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});

},{"../internals/fails":653,"../internals/global":672}],755:[function(require,module,exports){
var isNullOrUndefined = require('../internals/is-null-or-undefined');

var $TypeError = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (isNullOrUndefined(it)) throw $TypeError("Can't call method on " + it);
  return it;
};

},{"../internals/is-null-or-undefined":693}],756:[function(require,module,exports){
// `SameValue` abstract operation
// https://tc39.es/ecma262/#sec-samevalue
// eslint-disable-next-line es/no-object-is -- safe
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare -- NaN check
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};

},{}],757:[function(require,module,exports){
'use strict';
var global = require('../internals/global');
var apply = require('../internals/function-apply');
var isCallable = require('../internals/is-callable');
var ENGINE_IS_BUN = require('../internals/engine-is-bun');
var USER_AGENT = require('../internals/engine-user-agent');
var arraySlice = require('../internals/array-slice');
var validateArgumentsLength = require('../internals/validate-arguments-length');

var Function = global.Function;
// dirty IE9- and Bun 0.3.0- checks
var WRAP = /MSIE .\./.test(USER_AGENT) || ENGINE_IS_BUN && (function () {
  var version = global.Bun.version.split('.');
  return version.length < 3 || version[0] == 0 && (version[1] < 3 || version[1] == 3 && version[2] == 0);
})();

// IE9- / Bun 0.3.0- setTimeout / setInterval / setImmediate additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
// https://github.com/oven-sh/bun/issues/1633
module.exports = function (scheduler, hasTimeArg) {
  var firstParamIndex = hasTimeArg ? 2 : 1;
  return WRAP ? function (handler, timeout /* , ...arguments */) {
    var boundArgs = validateArgumentsLength(arguments.length, 1) > firstParamIndex;
    var fn = isCallable(handler) ? handler : Function(handler);
    var params = boundArgs ? arraySlice(arguments, firstParamIndex) : [];
    var callback = boundArgs ? function () {
      apply(fn, this, params);
    } : fn;
    return hasTimeArg ? scheduler(callback, timeout) : scheduler(callback);
  } : scheduler;
};

},{"../internals/array-slice":598,"../internals/engine-is-bun":636,"../internals/engine-user-agent":643,"../internals/function-apply":657,"../internals/global":672,"../internals/is-callable":688,"../internals/validate-arguments-length":805}],758:[function(require,module,exports){
var uncurryThis = require('../internals/function-uncurry-this');

// eslint-disable-next-line es/no-set -- safe
var SetPrototype = Set.prototype;

module.exports = {
  // eslint-disable-next-line es/no-set -- safe
  Set: Set,
  add: uncurryThis(SetPrototype.add),
  has: uncurryThis(SetPrototype.has),
  remove: uncurryThis(SetPrototype['delete']),
  proto: SetPrototype,
  $has: SetPrototype.has,
  $keys: SetPrototype.keys
};

},{"../internals/function-uncurry-this":665}],759:[function(require,module,exports){
'use strict';
var getBuiltIn = require('../internals/get-built-in');
var defineBuiltInAccessor = require('../internals/define-built-in-accessor');
var wellKnownSymbol = require('../internals/well-known-symbol');
var DESCRIPTORS = require('../internals/descriptors');

var SPECIES = wellKnownSymbol('species');

module.exports = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
    defineBuiltInAccessor(Constructor, SPECIES, {
      configurable: true,
      get: function () { return this; }
    });
  }
};

},{"../internals/define-built-in-accessor":622,"../internals/descriptors":627,"../internals/get-built-in":666,"../internals/well-known-symbol":809}],760:[function(require,module,exports){
var defineProperty = require('../internals/object-define-property').f;
var hasOwn = require('../internals/has-own-property');
var wellKnownSymbol = require('../internals/well-known-symbol');

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn(target, TO_STRING_TAG)) {
    defineProperty(target, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};

},{"../internals/has-own-property":673,"../internals/object-define-property":723,"../internals/well-known-symbol":809}],761:[function(require,module,exports){
var shared = require('../internals/shared');
var uid = require('../internals/uid');

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

},{"../internals/shared":763,"../internals/uid":801}],762:[function(require,module,exports){
var global = require('../internals/global');
var defineGlobalProperty = require('../internals/define-global-property');

var SHARED = '__core-js_shared__';
var store = global[SHARED] || defineGlobalProperty(SHARED, {});

module.exports = store;

},{"../internals/define-global-property":625,"../internals/global":672}],763:[function(require,module,exports){
var IS_PURE = require('../internals/is-pure');
var store = require('../internals/shared-store');

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.29.1',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2014-2023 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.29.1/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});

},{"../internals/is-pure":695,"../internals/shared-store":762}],764:[function(require,module,exports){
var anObject = require('../internals/an-object');
var aConstructor = require('../internals/a-constructor');
var isNullOrUndefined = require('../internals/is-null-or-undefined');
var wellKnownSymbol = require('../internals/well-known-symbol');

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || isNullOrUndefined(S = anObject(C)[SPECIES]) ? defaultConstructor : aConstructor(S);
};

},{"../internals/a-constructor":574,"../internals/an-object":579,"../internals/is-null-or-undefined":693,"../internals/well-known-symbol":809}],765:[function(require,module,exports){
var fails = require('../internals/fails');

// check the existence of a method, lowercase
// of a tag and escaping quotes in arguments
module.exports = function (METHOD_NAME) {
  return fails(function () {
    var test = ''[METHOD_NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  });
};

},{"../internals/fails":653}],766:[function(require,module,exports){
var uncurryThis = require('../internals/function-uncurry-this');
var toIntegerOrInfinity = require('../internals/to-integer-or-infinity');
var toString = require('../internals/to-string');
var requireObjectCoercible = require('../internals/require-object-coercible');

var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var stringSlice = uncurryThis(''.slice);

var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString(requireObjectCoercible($this));
    var position = toIntegerOrInfinity(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};

},{"../internals/function-uncurry-this":665,"../internals/require-object-coercible":755,"../internals/to-integer-or-infinity":785,"../internals/to-string":793}],767:[function(require,module,exports){
// https://github.com/zloirock/core-js/issues/280
var userAgent = require('../internals/engine-user-agent');

module.exports = /Version\/10(?:\.\d+){1,2}(?: [\w./]+)?(?: Mobile\/\w+)? Safari\//.test(userAgent);

},{"../internals/engine-user-agent":643}],768:[function(require,module,exports){
// https://github.com/tc39/proposal-string-pad-start-end
var uncurryThis = require('../internals/function-uncurry-this');
var toLength = require('../internals/to-length');
var toString = require('../internals/to-string');
var $repeat = require('../internals/string-repeat');
var requireObjectCoercible = require('../internals/require-object-coercible');

var repeat = uncurryThis($repeat);
var stringSlice = uncurryThis(''.slice);
var ceil = Math.ceil;

// `String.prototype.{ padStart, padEnd }` methods implementation
var createMethod = function (IS_END) {
  return function ($this, maxLength, fillString) {
    var S = toString(requireObjectCoercible($this));
    var intMaxLength = toLength(maxLength);
    var stringLength = S.length;
    var fillStr = fillString === undefined ? ' ' : toString(fillString);
    var fillLen, stringFiller;
    if (intMaxLength <= stringLength || fillStr == '') return S;
    fillLen = intMaxLength - stringLength;
    stringFiller = repeat(fillStr, ceil(fillLen / fillStr.length));
    if (stringFiller.length > fillLen) stringFiller = stringSlice(stringFiller, 0, fillLen);
    return IS_END ? S + stringFiller : stringFiller + S;
  };
};

module.exports = {
  // `String.prototype.padStart` method
  // https://tc39.es/ecma262/#sec-string.prototype.padstart
  start: createMethod(false),
  // `String.prototype.padEnd` method
  // https://tc39.es/ecma262/#sec-string.prototype.padend
  end: createMethod(true)
};

},{"../internals/function-uncurry-this":665,"../internals/require-object-coercible":755,"../internals/string-repeat":770,"../internals/to-length":786,"../internals/to-string":793}],769:[function(require,module,exports){
// based on https://github.com/bestiejs/punycode.js/blob/master/punycode.js
var uncurryThis = require('../internals/function-uncurry-this');

var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
var base = 36;
var tMin = 1;
var tMax = 26;
var skew = 38;
var damp = 700;
var initialBias = 72;
var initialN = 128; // 0x80
var delimiter = '-'; // '\x2D'
var regexNonASCII = /[^\0-\u007E]/; // non-ASCII chars
var regexSeparators = /[.\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
var OVERFLOW_ERROR = 'Overflow: input needs wider integers to process';
var baseMinusTMin = base - tMin;

var $RangeError = RangeError;
var exec = uncurryThis(regexSeparators.exec);
var floor = Math.floor;
var fromCharCode = String.fromCharCode;
var charCodeAt = uncurryThis(''.charCodeAt);
var join = uncurryThis([].join);
var push = uncurryThis([].push);
var replace = uncurryThis(''.replace);
var split = uncurryThis(''.split);
var toLowerCase = uncurryThis(''.toLowerCase);

/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 */
var ucs2decode = function (string) {
  var output = [];
  var counter = 0;
  var length = string.length;
  while (counter < length) {
    var value = charCodeAt(string, counter++);
    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
      // It's a high surrogate, and there is a next character.
      var extra = charCodeAt(string, counter++);
      if ((extra & 0xFC00) == 0xDC00) { // Low surrogate.
        push(output, ((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
      } else {
        // It's an unmatched surrogate; only append this code unit, in case the
        // next code unit is the high surrogate of a surrogate pair.
        push(output, value);
        counter--;
      }
    } else {
      push(output, value);
    }
  }
  return output;
};

/**
 * Converts a digit/integer into a basic code point.
 */
var digitToBasic = function (digit) {
  //  0..25 map to ASCII a..z or A..Z
  // 26..35 map to ASCII 0..9
  return digit + 22 + 75 * (digit < 26);
};

/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 */
var adapt = function (delta, numPoints, firstTime) {
  var k = 0;
  delta = firstTime ? floor(delta / damp) : delta >> 1;
  delta += floor(delta / numPoints);
  while (delta > baseMinusTMin * tMax >> 1) {
    delta = floor(delta / baseMinusTMin);
    k += base;
  }
  return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
};

/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 */
var encode = function (input) {
  var output = [];

  // Convert the input in UCS-2 to an array of Unicode code points.
  input = ucs2decode(input);

  // Cache the length.
  var inputLength = input.length;

  // Initialize the state.
  var n = initialN;
  var delta = 0;
  var bias = initialBias;
  var i, currentValue;

  // Handle the basic code points.
  for (i = 0; i < input.length; i++) {
    currentValue = input[i];
    if (currentValue < 0x80) {
      push(output, fromCharCode(currentValue));
    }
  }

  var basicLength = output.length; // number of basic code points.
  var handledCPCount = basicLength; // number of code points that have been handled;

  // Finish the basic string with a delimiter unless it's empty.
  if (basicLength) {
    push(output, delimiter);
  }

  // Main encoding loop:
  while (handledCPCount < inputLength) {
    // All non-basic code points < n have been handled already. Find the next larger one:
    var m = maxInt;
    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue >= n && currentValue < m) {
        m = currentValue;
      }
    }

    // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>, but guard against overflow.
    var handledCPCountPlusOne = handledCPCount + 1;
    if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
      throw $RangeError(OVERFLOW_ERROR);
    }

    delta += (m - n) * handledCPCountPlusOne;
    n = m;

    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue < n && ++delta > maxInt) {
        throw $RangeError(OVERFLOW_ERROR);
      }
      if (currentValue == n) {
        // Represent delta as a generalized variable-length integer.
        var q = delta;
        var k = base;
        while (true) {
          var t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
          if (q < t) break;
          var qMinusT = q - t;
          var baseMinusT = base - t;
          push(output, fromCharCode(digitToBasic(t + qMinusT % baseMinusT)));
          q = floor(qMinusT / baseMinusT);
          k += base;
        }

        push(output, fromCharCode(digitToBasic(q)));
        bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
        delta = 0;
        handledCPCount++;
      }
    }

    delta++;
    n++;
  }
  return join(output, '');
};

module.exports = function (input) {
  var encoded = [];
  var labels = split(replace(toLowerCase(input), regexSeparators, '\u002E'), '.');
  var i, label;
  for (i = 0; i < labels.length; i++) {
    label = labels[i];
    push(encoded, exec(regexNonASCII, label) ? 'xn--' + encode(label) : label);
  }
  return join(encoded, '.');
};

},{"../internals/function-uncurry-this":665}],770:[function(require,module,exports){
'use strict';
var toIntegerOrInfinity = require('../internals/to-integer-or-infinity');
var toString = require('../internals/to-string');
var requireObjectCoercible = require('../internals/require-object-coercible');

var $RangeError = RangeError;

// `String.prototype.repeat` method implementation
// https://tc39.es/ecma262/#sec-string.prototype.repeat
module.exports = function repeat(count) {
  var str = toString(requireObjectCoercible(this));
  var result = '';
  var n = toIntegerOrInfinity(count);
  if (n < 0 || n == Infinity) throw $RangeError('Wrong number of repetitions');
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) result += str;
  return result;
};

},{"../internals/require-object-coercible":755,"../internals/to-integer-or-infinity":785,"../internals/to-string":793}],771:[function(require,module,exports){
'use strict';
var $trimEnd = require('../internals/string-trim').end;
var forcedStringTrimMethod = require('../internals/string-trim-forced');

// `String.prototype.{ trimEnd, trimRight }` method
// https://tc39.es/ecma262/#sec-string.prototype.trimend
// https://tc39.es/ecma262/#String.prototype.trimright
module.exports = forcedStringTrimMethod('trimEnd') ? function trimEnd() {
  return $trimEnd(this);
// eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
} : ''.trimEnd;

},{"../internals/string-trim":774,"../internals/string-trim-forced":772}],772:[function(require,module,exports){
var PROPER_FUNCTION_NAME = require('../internals/function-name').PROPER;
var fails = require('../internals/fails');
var whitespaces = require('../internals/whitespaces');

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
module.exports = function (METHOD_NAME) {
  return fails(function () {
    return !!whitespaces[METHOD_NAME]()
      || non[METHOD_NAME]() !== non
      || (PROPER_FUNCTION_NAME && whitespaces[METHOD_NAME].name !== METHOD_NAME);
  });
};

},{"../internals/fails":653,"../internals/function-name":662,"../internals/whitespaces":810}],773:[function(require,module,exports){
'use strict';
var $trimStart = require('../internals/string-trim').start;
var forcedStringTrimMethod = require('../internals/string-trim-forced');

// `String.prototype.{ trimStart, trimLeft }` method
// https://tc39.es/ecma262/#sec-string.prototype.trimstart
// https://tc39.es/ecma262/#String.prototype.trimleft
module.exports = forcedStringTrimMethod('trimStart') ? function trimStart() {
  return $trimStart(this);
// eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
} : ''.trimStart;

},{"../internals/string-trim":774,"../internals/string-trim-forced":772}],774:[function(require,module,exports){
var uncurryThis = require('../internals/function-uncurry-this');
var requireObjectCoercible = require('../internals/require-object-coercible');
var toString = require('../internals/to-string');
var whitespaces = require('../internals/whitespaces');

var replace = uncurryThis(''.replace);
var ltrim = RegExp('^[' + whitespaces + ']+');
var rtrim = RegExp('(^|[^' + whitespaces + '])[' + whitespaces + ']+$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = toString(requireObjectCoercible($this));
    if (TYPE & 1) string = replace(string, ltrim, '');
    if (TYPE & 2) string = replace(string, rtrim, '$1');
    return string;
  };
};

module.exports = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};

},{"../internals/function-uncurry-this":665,"../internals/require-object-coercible":755,"../internals/to-string":793,"../internals/whitespaces":810}],775:[function(require,module,exports){
var global = require('../internals/global');
var fails = require('../internals/fails');
var V8 = require('../internals/engine-v8-version');
var IS_BROWSER = require('../internals/engine-is-browser');
var IS_DENO = require('../internals/engine-is-deno');
var IS_NODE = require('../internals/engine-is-node');

var structuredClone = global.structuredClone;

module.exports = !!structuredClone && !fails(function () {
  // prevent V8 ArrayBufferDetaching protector cell invalidation and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if ((IS_DENO && V8 > 92) || (IS_NODE && V8 > 94) || (IS_BROWSER && V8 > 97)) return false;
  var buffer = new ArrayBuffer(8);
  var clone = structuredClone(buffer, { transfer: [buffer] });
  return buffer.byteLength != 0 || clone.byteLength != 8;
});

},{"../internals/engine-is-browser":635,"../internals/engine-is-deno":637,"../internals/engine-is-node":641,"../internals/engine-v8-version":644,"../internals/fails":653,"../internals/global":672}],776:[function(require,module,exports){
/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = require('../internals/engine-v8-version');
var fails = require('../internals/fails');

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});

},{"../internals/engine-v8-version":644,"../internals/fails":653}],777:[function(require,module,exports){
var call = require('../internals/function-call');
var getBuiltIn = require('../internals/get-built-in');
var wellKnownSymbol = require('../internals/well-known-symbol');
var defineBuiltIn = require('../internals/define-built-in');

module.exports = function () {
  var Symbol = getBuiltIn('Symbol');
  var SymbolPrototype = Symbol && Symbol.prototype;
  var valueOf = SymbolPrototype && SymbolPrototype.valueOf;
  var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

  if (SymbolPrototype && !SymbolPrototype[TO_PRIMITIVE]) {
    // `Symbol.prototype[@@toPrimitive]` method
    // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
    // eslint-disable-next-line no-unused-vars -- required for .length
    defineBuiltIn(SymbolPrototype, TO_PRIMITIVE, function (hint) {
      return call(valueOf, this);
    }, { arity: 1 });
  }
};

},{"../internals/define-built-in":623,"../internals/function-call":661,"../internals/get-built-in":666,"../internals/well-known-symbol":809}],778:[function(require,module,exports){
var NATIVE_SYMBOL = require('../internals/symbol-constructor-detection');

/* eslint-disable es/no-symbol -- safe */
module.exports = NATIVE_SYMBOL && !!Symbol['for'] && !!Symbol.keyFor;

},{"../internals/symbol-constructor-detection":776}],779:[function(require,module,exports){
var global = require('../internals/global');
var apply = require('../internals/function-apply');
var bind = require('../internals/function-bind-context');
var isCallable = require('../internals/is-callable');
var hasOwn = require('../internals/has-own-property');
var fails = require('../internals/fails');
var html = require('../internals/html');
var arraySlice = require('../internals/array-slice');
var createElement = require('../internals/document-create-element');
var validateArgumentsLength = require('../internals/validate-arguments-length');
var IS_IOS = require('../internals/engine-is-ios');
var IS_NODE = require('../internals/engine-is-node');

var set = global.setImmediate;
var clear = global.clearImmediate;
var process = global.process;
var Dispatch = global.Dispatch;
var Function = global.Function;
var MessageChannel = global.MessageChannel;
var String = global.String;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var $location, defer, channel, port;

fails(function () {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  $location = global.location;
});

var run = function (id) {
  if (hasOwn(queue, id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var eventListener = function (event) {
  run(event.data);
};

var globalPostMessageDefer = function (id) {
  // old engines have not location.origin
  global.postMessage(String(id), $location.protocol + '//' + $location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(handler) {
    validateArgumentsLength(arguments.length, 1);
    var fn = isCallable(handler) ? handler : Function(handler);
    var args = arraySlice(arguments, 1);
    queue[++counter] = function () {
      apply(fn, undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (IS_NODE) {
    defer = function (id) {
      process.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = eventListener;
    defer = bind(port.postMessage, port);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global.addEventListener &&
    isCallable(global.postMessage) &&
    !global.importScripts &&
    $location && $location.protocol !== 'file:' &&
    !fails(globalPostMessageDefer)
  ) {
    defer = globalPostMessageDefer;
    global.addEventListener('message', eventListener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

module.exports = {
  set: set,
  clear: clear
};

},{"../internals/array-slice":598,"../internals/document-create-element":629,"../internals/engine-is-ios":640,"../internals/engine-is-node":641,"../internals/fails":653,"../internals/function-apply":657,"../internals/function-bind-context":658,"../internals/global":672,"../internals/has-own-property":673,"../internals/html":676,"../internals/is-callable":688,"../internals/validate-arguments-length":805}],780:[function(require,module,exports){
var uncurryThis = require('../internals/function-uncurry-this');

// `thisNumberValue` abstract operation
// https://tc39.es/ecma262/#sec-thisnumbervalue
module.exports = uncurryThis(1.0.valueOf);

},{"../internals/function-uncurry-this":665}],781:[function(require,module,exports){
var toIntegerOrInfinity = require('../internals/to-integer-or-infinity');

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};

},{"../internals/to-integer-or-infinity":785}],782:[function(require,module,exports){
var toPrimitive = require('../internals/to-primitive');

var $TypeError = TypeError;

// `ToBigInt` abstract operation
// https://tc39.es/ecma262/#sec-tobigint
module.exports = function (argument) {
  var prim = toPrimitive(argument, 'number');
  if (typeof prim == 'number') throw $TypeError("Can't convert number to bigint");
  // eslint-disable-next-line es/no-bigint -- safe
  return BigInt(prim);
};

},{"../internals/to-primitive":790}],783:[function(require,module,exports){
var toIntegerOrInfinity = require('../internals/to-integer-or-infinity');
var toLength = require('../internals/to-length');

var $RangeError = RangeError;

// `ToIndex` abstract operation
// https://tc39.es/ecma262/#sec-toindex
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toIntegerOrInfinity(it);
  var length = toLength(number);
  if (number !== length) throw $RangeError('Wrong length or index');
  return length;
};

},{"../internals/to-integer-or-infinity":785,"../internals/to-length":786}],784:[function(require,module,exports){
// toObject with fallback for non-array-like ES3 strings
var IndexedObject = require('../internals/indexed-object');
var requireObjectCoercible = require('../internals/require-object-coercible');

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};

},{"../internals/indexed-object":679,"../internals/require-object-coercible":755}],785:[function(require,module,exports){
var trunc = require('../internals/math-trunc');

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};

},{"../internals/math-trunc":712}],786:[function(require,module,exports){
var toIntegerOrInfinity = require('../internals/to-integer-or-infinity');

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

},{"../internals/to-integer-or-infinity":785}],787:[function(require,module,exports){
var requireObjectCoercible = require('../internals/require-object-coercible');

var $Object = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return $Object(requireObjectCoercible(argument));
};

},{"../internals/require-object-coercible":755}],788:[function(require,module,exports){
var toPositiveInteger = require('../internals/to-positive-integer');

var $RangeError = RangeError;

module.exports = function (it, BYTES) {
  var offset = toPositiveInteger(it);
  if (offset % BYTES) throw $RangeError('Wrong offset');
  return offset;
};

},{"../internals/to-positive-integer":789}],789:[function(require,module,exports){
var toIntegerOrInfinity = require('../internals/to-integer-or-infinity');

var $RangeError = RangeError;

module.exports = function (it) {
  var result = toIntegerOrInfinity(it);
  if (result < 0) throw $RangeError("The argument can't be less than 0");
  return result;
};

},{"../internals/to-integer-or-infinity":785}],790:[function(require,module,exports){
var call = require('../internals/function-call');
var isObject = require('../internals/is-object');
var isSymbol = require('../internals/is-symbol');
var getMethod = require('../internals/get-method');
var ordinaryToPrimitive = require('../internals/ordinary-to-primitive');
var wellKnownSymbol = require('../internals/well-known-symbol');

var $TypeError = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw $TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

},{"../internals/function-call":661,"../internals/get-method":670,"../internals/is-object":694,"../internals/is-symbol":697,"../internals/ordinary-to-primitive":738,"../internals/well-known-symbol":809}],791:[function(require,module,exports){
var toPrimitive = require('../internals/to-primitive');
var isSymbol = require('../internals/is-symbol');

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

},{"../internals/is-symbol":697,"../internals/to-primitive":790}],792:[function(require,module,exports){
var wellKnownSymbol = require('../internals/well-known-symbol');

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';

},{"../internals/well-known-symbol":809}],793:[function(require,module,exports){
var classof = require('../internals/classof');

var $String = String;

module.exports = function (argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};

},{"../internals/classof":608}],794:[function(require,module,exports){
var IS_NODE = require('../internals/engine-is-node');

module.exports = function (name) {
  try {
    // eslint-disable-next-line no-new-func -- safe
    if (IS_NODE) return Function('return require("' + name + '")')();
  } catch (error) { /* empty */ }
};

},{"../internals/engine-is-node":641}],795:[function(require,module,exports){
var $String = String;

module.exports = function (argument) {
  try {
    return $String(argument);
  } catch (error) {
    return 'Object';
  }
};

},{}],796:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var global = require('../internals/global');
var call = require('../internals/function-call');
var DESCRIPTORS = require('../internals/descriptors');
var TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS = require('../internals/typed-array-constructors-require-wrappers');
var ArrayBufferViewCore = require('../internals/array-buffer-view-core');
var ArrayBufferModule = require('../internals/array-buffer');
var anInstance = require('../internals/an-instance');
var createPropertyDescriptor = require('../internals/create-property-descriptor');
var createNonEnumerableProperty = require('../internals/create-non-enumerable-property');
var isIntegralNumber = require('../internals/is-integral-number');
var toLength = require('../internals/to-length');
var toIndex = require('../internals/to-index');
var toOffset = require('../internals/to-offset');
var toPropertyKey = require('../internals/to-property-key');
var hasOwn = require('../internals/has-own-property');
var classof = require('../internals/classof');
var isObject = require('../internals/is-object');
var isSymbol = require('../internals/is-symbol');
var create = require('../internals/object-create');
var isPrototypeOf = require('../internals/object-is-prototype-of');
var setPrototypeOf = require('../internals/object-set-prototype-of');
var getOwnPropertyNames = require('../internals/object-get-own-property-names').f;
var typedArrayFrom = require('../internals/typed-array-from');
var forEach = require('../internals/array-iteration').forEach;
var setSpecies = require('../internals/set-species');
var defineBuiltInAccessor = require('../internals/define-built-in-accessor');
var definePropertyModule = require('../internals/object-define-property');
var getOwnPropertyDescriptorModule = require('../internals/object-get-own-property-descriptor');
var InternalStateModule = require('../internals/internal-state');
var inheritIfRequired = require('../internals/inherit-if-required');

var getInternalState = InternalStateModule.get;
var setInternalState = InternalStateModule.set;
var enforceInternalState = InternalStateModule.enforce;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var round = Math.round;
var RangeError = global.RangeError;
var ArrayBuffer = ArrayBufferModule.ArrayBuffer;
var ArrayBufferPrototype = ArrayBuffer.prototype;
var DataView = ArrayBufferModule.DataView;
var NATIVE_ARRAY_BUFFER_VIEWS = ArrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS;
var TYPED_ARRAY_TAG = ArrayBufferViewCore.TYPED_ARRAY_TAG;
var TypedArray = ArrayBufferViewCore.TypedArray;
var TypedArrayPrototype = ArrayBufferViewCore.TypedArrayPrototype;
var aTypedArrayConstructor = ArrayBufferViewCore.aTypedArrayConstructor;
var isTypedArray = ArrayBufferViewCore.isTypedArray;
var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
var WRONG_LENGTH = 'Wrong length';

var fromList = function (C, list) {
  aTypedArrayConstructor(C);
  var index = 0;
  var length = list.length;
  var result = new C(length);
  while (length > index) result[index] = list[index++];
  return result;
};

var addGetter = function (it, key) {
  defineBuiltInAccessor(it, key, {
    configurable: true,
    get: function () {
      return getInternalState(this)[key];
    }
  });
};

var isArrayBuffer = function (it) {
  var klass;
  return isPrototypeOf(ArrayBufferPrototype, it) || (klass = classof(it)) == 'ArrayBuffer' || klass == 'SharedArrayBuffer';
};

var isTypedArrayIndex = function (target, key) {
  return isTypedArray(target)
    && !isSymbol(key)
    && key in target
    && isIntegralNumber(+key)
    && key >= 0;
};

var wrappedGetOwnPropertyDescriptor = function getOwnPropertyDescriptor(target, key) {
  key = toPropertyKey(key);
  return isTypedArrayIndex(target, key)
    ? createPropertyDescriptor(2, target[key])
    : nativeGetOwnPropertyDescriptor(target, key);
};

var wrappedDefineProperty = function defineProperty(target, key, descriptor) {
  key = toPropertyKey(key);
  if (isTypedArrayIndex(target, key)
    && isObject(descriptor)
    && hasOwn(descriptor, 'value')
    && !hasOwn(descriptor, 'get')
    && !hasOwn(descriptor, 'set')
    // TODO: add validation descriptor w/o calling accessors
    && !descriptor.configurable
    && (!hasOwn(descriptor, 'writable') || descriptor.writable)
    && (!hasOwn(descriptor, 'enumerable') || descriptor.enumerable)
  ) {
    target[key] = descriptor.value;
    return target;
  } return nativeDefineProperty(target, key, descriptor);
};

if (DESCRIPTORS) {
  if (!NATIVE_ARRAY_BUFFER_VIEWS) {
    getOwnPropertyDescriptorModule.f = wrappedGetOwnPropertyDescriptor;
    definePropertyModule.f = wrappedDefineProperty;
    addGetter(TypedArrayPrototype, 'buffer');
    addGetter(TypedArrayPrototype, 'byteOffset');
    addGetter(TypedArrayPrototype, 'byteLength');
    addGetter(TypedArrayPrototype, 'length');
  }

  $({ target: 'Object', stat: true, forced: !NATIVE_ARRAY_BUFFER_VIEWS }, {
    getOwnPropertyDescriptor: wrappedGetOwnPropertyDescriptor,
    defineProperty: wrappedDefineProperty
  });

  module.exports = function (TYPE, wrapper, CLAMPED) {
    var BYTES = TYPE.match(/\d+/)[0] / 8;
    var CONSTRUCTOR_NAME = TYPE + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + TYPE;
    var SETTER = 'set' + TYPE;
    var NativeTypedArrayConstructor = global[CONSTRUCTOR_NAME];
    var TypedArrayConstructor = NativeTypedArrayConstructor;
    var TypedArrayConstructorPrototype = TypedArrayConstructor && TypedArrayConstructor.prototype;
    var exported = {};

    var getter = function (that, index) {
      var data = getInternalState(that);
      return data.view[GETTER](index * BYTES + data.byteOffset, true);
    };

    var setter = function (that, index, value) {
      var data = getInternalState(that);
      if (CLAMPED) value = (value = round(value)) < 0 ? 0 : value > 0xFF ? 0xFF : value & 0xFF;
      data.view[SETTER](index * BYTES + data.byteOffset, value, true);
    };

    var addElement = function (that, index) {
      nativeDefineProperty(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };

    if (!NATIVE_ARRAY_BUFFER_VIEWS) {
      TypedArrayConstructor = wrapper(function (that, data, offset, $length) {
        anInstance(that, TypedArrayConstructorPrototype);
        var index = 0;
        var byteOffset = 0;
        var buffer, byteLength, length;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new ArrayBuffer(byteLength);
        } else if (isArrayBuffer(data)) {
          buffer = data;
          byteOffset = toOffset(offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - byteOffset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + byteOffset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (isTypedArray(data)) {
          return fromList(TypedArrayConstructor, data);
        } else {
          return call(typedArrayFrom, TypedArrayConstructor, data);
        }
        setInternalState(that, {
          buffer: buffer,
          byteOffset: byteOffset,
          byteLength: byteLength,
          length: length,
          view: new DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });

      if (setPrototypeOf) setPrototypeOf(TypedArrayConstructor, TypedArray);
      TypedArrayConstructorPrototype = TypedArrayConstructor.prototype = create(TypedArrayPrototype);
    } else if (TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS) {
      TypedArrayConstructor = wrapper(function (dummy, data, typedArrayOffset, $length) {
        anInstance(dummy, TypedArrayConstructorPrototype);
        return inheritIfRequired(function () {
          if (!isObject(data)) return new NativeTypedArrayConstructor(toIndex(data));
          if (isArrayBuffer(data)) return $length !== undefined
            ? new NativeTypedArrayConstructor(data, toOffset(typedArrayOffset, BYTES), $length)
            : typedArrayOffset !== undefined
              ? new NativeTypedArrayConstructor(data, toOffset(typedArrayOffset, BYTES))
              : new NativeTypedArrayConstructor(data);
          if (isTypedArray(data)) return fromList(TypedArrayConstructor, data);
          return call(typedArrayFrom, TypedArrayConstructor, data);
        }(), dummy, TypedArrayConstructor);
      });

      if (setPrototypeOf) setPrototypeOf(TypedArrayConstructor, TypedArray);
      forEach(getOwnPropertyNames(NativeTypedArrayConstructor), function (key) {
        if (!(key in TypedArrayConstructor)) {
          createNonEnumerableProperty(TypedArrayConstructor, key, NativeTypedArrayConstructor[key]);
        }
      });
      TypedArrayConstructor.prototype = TypedArrayConstructorPrototype;
    }

    if (TypedArrayConstructorPrototype.constructor !== TypedArrayConstructor) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, 'constructor', TypedArrayConstructor);
    }

    enforceInternalState(TypedArrayConstructorPrototype).TypedArrayConstructor = TypedArrayConstructor;

    if (TYPED_ARRAY_TAG) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, TYPED_ARRAY_TAG, CONSTRUCTOR_NAME);
    }

    var FORCED = TypedArrayConstructor != NativeTypedArrayConstructor;

    exported[CONSTRUCTOR_NAME] = TypedArrayConstructor;

    $({ global: true, constructor: true, forced: FORCED, sham: !NATIVE_ARRAY_BUFFER_VIEWS }, exported);

    if (!(BYTES_PER_ELEMENT in TypedArrayConstructor)) {
      createNonEnumerableProperty(TypedArrayConstructor, BYTES_PER_ELEMENT, BYTES);
    }

    if (!(BYTES_PER_ELEMENT in TypedArrayConstructorPrototype)) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, BYTES_PER_ELEMENT, BYTES);
    }

    setSpecies(CONSTRUCTOR_NAME);
  };
} else module.exports = function () { /* empty */ };

},{"../internals/an-instance":578,"../internals/array-buffer":583,"../internals/array-buffer-view-core":582,"../internals/array-iteration":591,"../internals/classof":608,"../internals/create-non-enumerable-property":617,"../internals/create-property-descriptor":618,"../internals/define-built-in-accessor":622,"../internals/descriptors":627,"../internals/export":652,"../internals/function-call":661,"../internals/global":672,"../internals/has-own-property":673,"../internals/inherit-if-required":680,"../internals/internal-state":684,"../internals/is-integral-number":692,"../internals/is-object":694,"../internals/is-symbol":697,"../internals/object-create":721,"../internals/object-define-property":723,"../internals/object-get-own-property-descriptor":724,"../internals/object-get-own-property-names":726,"../internals/object-is-prototype-of":730,"../internals/object-set-prototype-of":735,"../internals/set-species":759,"../internals/to-index":783,"../internals/to-length":786,"../internals/to-offset":788,"../internals/to-property-key":791,"../internals/typed-array-constructors-require-wrappers":797,"../internals/typed-array-from":799}],797:[function(require,module,exports){
/* eslint-disable no-new -- required for testing */
var global = require('../internals/global');
var fails = require('../internals/fails');
var checkCorrectnessOfIteration = require('../internals/check-correctness-of-iteration');
var NATIVE_ARRAY_BUFFER_VIEWS = require('../internals/array-buffer-view-core').NATIVE_ARRAY_BUFFER_VIEWS;

var ArrayBuffer = global.ArrayBuffer;
var Int8Array = global.Int8Array;

module.exports = !NATIVE_ARRAY_BUFFER_VIEWS || !fails(function () {
  Int8Array(1);
}) || !fails(function () {
  new Int8Array(-1);
}) || !checkCorrectnessOfIteration(function (iterable) {
  new Int8Array();
  new Int8Array(null);
  new Int8Array(1.5);
  new Int8Array(iterable);
}, true) || fails(function () {
  // Safari (11+) bug - a reason why even Safari 13 should load a typed array polyfill
  return new Int8Array(new ArrayBuffer(2), 1, undefined).length !== 1;
});

},{"../internals/array-buffer-view-core":582,"../internals/check-correctness-of-iteration":606,"../internals/fails":653,"../internals/global":672}],798:[function(require,module,exports){
var arrayFromConstructorAndList = require('../internals/array-from-constructor-and-list');
var typedArraySpeciesConstructor = require('../internals/typed-array-species-constructor');

module.exports = function (instance, list) {
  return arrayFromConstructorAndList(typedArraySpeciesConstructor(instance), list);
};

},{"../internals/array-from-constructor-and-list":587,"../internals/typed-array-species-constructor":800}],799:[function(require,module,exports){
var bind = require('../internals/function-bind-context');
var call = require('../internals/function-call');
var aConstructor = require('../internals/a-constructor');
var toObject = require('../internals/to-object');
var lengthOfArrayLike = require('../internals/length-of-array-like');
var getIterator = require('../internals/get-iterator');
var getIteratorMethod = require('../internals/get-iterator-method');
var isArrayIteratorMethod = require('../internals/is-array-iterator-method');
var isBigIntArray = require('../internals/is-big-int-array');
var aTypedArrayConstructor = require('../internals/array-buffer-view-core').aTypedArrayConstructor;
var toBigInt = require('../internals/to-big-int');

module.exports = function from(source /* , mapfn, thisArg */) {
  var C = aConstructor(this);
  var O = toObject(source);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  var iteratorMethod = getIteratorMethod(O);
  var i, length, result, thisIsBigIntArray, value, step, iterator, next;
  if (iteratorMethod && !isArrayIteratorMethod(iteratorMethod)) {
    iterator = getIterator(O, iteratorMethod);
    next = iterator.next;
    O = [];
    while (!(step = call(next, iterator)).done) {
      O.push(step.value);
    }
  }
  if (mapping && argumentsLength > 2) {
    mapfn = bind(mapfn, arguments[2]);
  }
  length = lengthOfArrayLike(O);
  result = new (aTypedArrayConstructor(C))(length);
  thisIsBigIntArray = isBigIntArray(result);
  for (i = 0; length > i; i++) {
    value = mapping ? mapfn(O[i], i) : O[i];
    // FF30- typed arrays doesn't properly convert objects to typed array values
    result[i] = thisIsBigIntArray ? toBigInt(value) : +value;
  }
  return result;
};

},{"../internals/a-constructor":574,"../internals/array-buffer-view-core":582,"../internals/function-bind-context":658,"../internals/function-call":661,"../internals/get-iterator":668,"../internals/get-iterator-method":667,"../internals/is-array-iterator-method":685,"../internals/is-big-int-array":687,"../internals/length-of-array-like":704,"../internals/to-big-int":782,"../internals/to-object":787}],800:[function(require,module,exports){
var ArrayBufferViewCore = require('../internals/array-buffer-view-core');
var speciesConstructor = require('../internals/species-constructor');

var aTypedArrayConstructor = ArrayBufferViewCore.aTypedArrayConstructor;
var getTypedArrayConstructor = ArrayBufferViewCore.getTypedArrayConstructor;

// a part of `TypedArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#typedarray-species-create
module.exports = function (originalArray) {
  return aTypedArrayConstructor(speciesConstructor(originalArray, getTypedArrayConstructor(originalArray)));
};

},{"../internals/array-buffer-view-core":582,"../internals/species-constructor":764}],801:[function(require,module,exports){
var uncurryThis = require('../internals/function-uncurry-this');

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};

},{"../internals/function-uncurry-this":665}],802:[function(require,module,exports){
var fails = require('../internals/fails');
var wellKnownSymbol = require('../internals/well-known-symbol');
var DESCRIPTORS = require('../internals/descriptors');
var IS_PURE = require('../internals/is-pure');

var ITERATOR = wellKnownSymbol('iterator');

module.exports = !fails(function () {
  // eslint-disable-next-line unicorn/relative-url-style -- required for testing
  var url = new URL('b?a=1&b=2&c=3', 'http://a');
  var searchParams = url.searchParams;
  var result = '';
  url.pathname = 'c%20d';
  searchParams.forEach(function (value, key) {
    searchParams['delete']('b');
    result += key + value;
  });
  return (IS_PURE && !url.toJSON)
    || (!searchParams.size && (IS_PURE || !DESCRIPTORS))
    || !searchParams.sort
    || url.href !== 'http://a/c%20d?a=1&c=3'
    || searchParams.get('c') !== '3'
    || String(new URLSearchParams('?a=1')) !== 'a=1'
    || !searchParams[ITERATOR]
    // throws in Edge
    || new URL('https://a@b').username !== 'a'
    || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b'
    // not punycoded in Edge
    || new URL('http://тест').host !== 'xn--e1aybc'
    // not escaped in Chrome 62-
    || new URL('http://a#б').hash !== '#%D0%B1'
    // fails in Chrome 66-
    || result !== 'a1c3'
    // throws in Safari
    || new URL('http://x', undefined).host !== 'x';
});

},{"../internals/descriptors":627,"../internals/fails":653,"../internals/is-pure":695,"../internals/well-known-symbol":809}],803:[function(require,module,exports){
/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = require('../internals/symbol-constructor-detection');

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

},{"../internals/symbol-constructor-detection":776}],804:[function(require,module,exports){
var DESCRIPTORS = require('../internals/descriptors');
var fails = require('../internals/fails');

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});

},{"../internals/descriptors":627,"../internals/fails":653}],805:[function(require,module,exports){
var $TypeError = TypeError;

module.exports = function (passed, required) {
  if (passed < required) throw $TypeError('Not enough arguments');
  return passed;
};

},{}],806:[function(require,module,exports){
var global = require('../internals/global');
var isCallable = require('../internals/is-callable');

var WeakMap = global.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(String(WeakMap));

},{"../internals/global":672,"../internals/is-callable":688}],807:[function(require,module,exports){
var path = require('../internals/path');
var hasOwn = require('../internals/has-own-property');
var wrappedWellKnownSymbolModule = require('../internals/well-known-symbol-wrapped');
var defineProperty = require('../internals/object-define-property').f;

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!hasOwn(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};

},{"../internals/has-own-property":673,"../internals/object-define-property":723,"../internals/path":740,"../internals/well-known-symbol-wrapped":808}],808:[function(require,module,exports){
var wellKnownSymbol = require('../internals/well-known-symbol');

exports.f = wellKnownSymbol;

},{"../internals/well-known-symbol":809}],809:[function(require,module,exports){
var global = require('../internals/global');
var shared = require('../internals/shared');
var hasOwn = require('../internals/has-own-property');
var uid = require('../internals/uid');
var NATIVE_SYMBOL = require('../internals/symbol-constructor-detection');
var USE_SYMBOL_AS_UID = require('../internals/use-symbol-as-uid');

var Symbol = global.Symbol;
var WellKnownSymbolsStore = shared('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol['for'] || Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn(Symbol, name)
      ? Symbol[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};

},{"../internals/global":672,"../internals/has-own-property":673,"../internals/shared":763,"../internals/symbol-constructor-detection":776,"../internals/uid":801,"../internals/use-symbol-as-uid":803}],810:[function(require,module,exports){
// a string of all valid unicode whitespaces
module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

},{}],811:[function(require,module,exports){
'use strict';
var getBuiltIn = require('../internals/get-built-in');
var hasOwn = require('../internals/has-own-property');
var createNonEnumerableProperty = require('../internals/create-non-enumerable-property');
var isPrototypeOf = require('../internals/object-is-prototype-of');
var setPrototypeOf = require('../internals/object-set-prototype-of');
var copyConstructorProperties = require('../internals/copy-constructor-properties');
var proxyAccessor = require('../internals/proxy-accessor');
var inheritIfRequired = require('../internals/inherit-if-required');
var normalizeStringArgument = require('../internals/normalize-string-argument');
var installErrorCause = require('../internals/install-error-cause');
var installErrorStack = require('../internals/error-stack-install');
var DESCRIPTORS = require('../internals/descriptors');
var IS_PURE = require('../internals/is-pure');

module.exports = function (FULL_NAME, wrapper, FORCED, IS_AGGREGATE_ERROR) {
  var STACK_TRACE_LIMIT = 'stackTraceLimit';
  var OPTIONS_POSITION = IS_AGGREGATE_ERROR ? 2 : 1;
  var path = FULL_NAME.split('.');
  var ERROR_NAME = path[path.length - 1];
  var OriginalError = getBuiltIn.apply(null, path);

  if (!OriginalError) return;

  var OriginalErrorPrototype = OriginalError.prototype;

  // V8 9.3- bug https://bugs.chromium.org/p/v8/issues/detail?id=12006
  if (!IS_PURE && hasOwn(OriginalErrorPrototype, 'cause')) delete OriginalErrorPrototype.cause;

  if (!FORCED) return OriginalError;

  var BaseError = getBuiltIn('Error');

  var WrappedError = wrapper(function (a, b) {
    var message = normalizeStringArgument(IS_AGGREGATE_ERROR ? b : a, undefined);
    var result = IS_AGGREGATE_ERROR ? new OriginalError(a) : new OriginalError();
    if (message !== undefined) createNonEnumerableProperty(result, 'message', message);
    installErrorStack(result, WrappedError, result.stack, 2);
    if (this && isPrototypeOf(OriginalErrorPrototype, this)) inheritIfRequired(result, this, WrappedError);
    if (arguments.length > OPTIONS_POSITION) installErrorCause(result, arguments[OPTIONS_POSITION]);
    return result;
  });

  WrappedError.prototype = OriginalErrorPrototype;

  if (ERROR_NAME !== 'Error') {
    if (setPrototypeOf) setPrototypeOf(WrappedError, BaseError);
    else copyConstructorProperties(WrappedError, BaseError, { name: true });
  } else if (DESCRIPTORS && STACK_TRACE_LIMIT in OriginalError) {
    proxyAccessor(WrappedError, OriginalError, STACK_TRACE_LIMIT);
    proxyAccessor(WrappedError, OriginalError, 'prepareStackTrace');
  }

  copyConstructorProperties(WrappedError, OriginalError);

  if (!IS_PURE) try {
    // Safari 13- bug: WebAssembly errors does not have a proper `.name`
    if (OriginalErrorPrototype.name !== ERROR_NAME) {
      createNonEnumerableProperty(OriginalErrorPrototype, 'name', ERROR_NAME);
    }
    OriginalErrorPrototype.constructor = WrappedError;
  } catch (error) { /* empty */ }

  return WrappedError;
};

},{"../internals/copy-constructor-properties":612,"../internals/create-non-enumerable-property":617,"../internals/descriptors":627,"../internals/error-stack-install":649,"../internals/get-built-in":666,"../internals/has-own-property":673,"../internals/inherit-if-required":680,"../internals/install-error-cause":682,"../internals/is-pure":695,"../internals/normalize-string-argument":715,"../internals/object-is-prototype-of":730,"../internals/object-set-prototype-of":735,"../internals/proxy-accessor":746}],812:[function(require,module,exports){
var $ = require('../internals/export');
var getBuiltIn = require('../internals/get-built-in');
var apply = require('../internals/function-apply');
var fails = require('../internals/fails');
var wrapErrorConstructorWithCause = require('../internals/wrap-error-constructor-with-cause');

var AGGREGATE_ERROR = 'AggregateError';
var $AggregateError = getBuiltIn(AGGREGATE_ERROR);

var FORCED = !fails(function () {
  return $AggregateError([1]).errors[0] !== 1;
}) && fails(function () {
  return $AggregateError([1], AGGREGATE_ERROR, { cause: 7 }).cause !== 7;
});

// https://github.com/tc39/proposal-error-cause
$({ global: true, constructor: true, arity: 2, forced: FORCED }, {
  AggregateError: wrapErrorConstructorWithCause(AGGREGATE_ERROR, function (init) {
    // eslint-disable-next-line no-unused-vars -- required for functions `.length`
    return function AggregateError(errors, message) { return apply(init, this, arguments); };
  }, FORCED, true)
});

},{"../internals/export":652,"../internals/fails":653,"../internals/function-apply":657,"../internals/get-built-in":666,"../internals/wrap-error-constructor-with-cause":811}],813:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var isPrototypeOf = require('../internals/object-is-prototype-of');
var getPrototypeOf = require('../internals/object-get-prototype-of');
var setPrototypeOf = require('../internals/object-set-prototype-of');
var copyConstructorProperties = require('../internals/copy-constructor-properties');
var create = require('../internals/object-create');
var createNonEnumerableProperty = require('../internals/create-non-enumerable-property');
var createPropertyDescriptor = require('../internals/create-property-descriptor');
var installErrorCause = require('../internals/install-error-cause');
var installErrorStack = require('../internals/error-stack-install');
var iterate = require('../internals/iterate');
var normalizeStringArgument = require('../internals/normalize-string-argument');
var wellKnownSymbol = require('../internals/well-known-symbol');

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var $Error = Error;
var push = [].push;

var $AggregateError = function AggregateError(errors, message /* , options */) {
  var isInstance = isPrototypeOf(AggregateErrorPrototype, this);
  var that;
  if (setPrototypeOf) {
    that = setPrototypeOf($Error(), isInstance ? getPrototypeOf(this) : AggregateErrorPrototype);
  } else {
    that = isInstance ? this : create(AggregateErrorPrototype);
    createNonEnumerableProperty(that, TO_STRING_TAG, 'Error');
  }
  if (message !== undefined) createNonEnumerableProperty(that, 'message', normalizeStringArgument(message));
  installErrorStack(that, $AggregateError, that.stack, 1);
  if (arguments.length > 2) installErrorCause(that, arguments[2]);
  var errorsArray = [];
  iterate(errors, push, { that: errorsArray });
  createNonEnumerableProperty(that, 'errors', errorsArray);
  return that;
};

if (setPrototypeOf) setPrototypeOf($AggregateError, $Error);
else copyConstructorProperties($AggregateError, $Error, { name: true });

var AggregateErrorPrototype = $AggregateError.prototype = create($Error.prototype, {
  constructor: createPropertyDescriptor(1, $AggregateError),
  message: createPropertyDescriptor(1, ''),
  name: createPropertyDescriptor(1, 'AggregateError')
});

// `AggregateError` constructor
// https://tc39.es/ecma262/#sec-aggregate-error-constructor
$({ global: true, constructor: true, arity: 2 }, {
  AggregateError: $AggregateError
});

},{"../internals/copy-constructor-properties":612,"../internals/create-non-enumerable-property":617,"../internals/create-property-descriptor":618,"../internals/error-stack-install":649,"../internals/export":652,"../internals/install-error-cause":682,"../internals/iterate":698,"../internals/normalize-string-argument":715,"../internals/object-create":721,"../internals/object-get-prototype-of":728,"../internals/object-is-prototype-of":730,"../internals/object-set-prototype-of":735,"../internals/well-known-symbol":809}],814:[function(require,module,exports){
// TODO: Remove this module from `core-js@4` since it's replaced to module below
require('../modules/es.aggregate-error.constructor');

},{"../modules/es.aggregate-error.constructor":813}],815:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var global = require('../internals/global');
var arrayBufferModule = require('../internals/array-buffer');
var setSpecies = require('../internals/set-species');

var ARRAY_BUFFER = 'ArrayBuffer';
var ArrayBuffer = arrayBufferModule[ARRAY_BUFFER];
var NativeArrayBuffer = global[ARRAY_BUFFER];

// `ArrayBuffer` constructor
// https://tc39.es/ecma262/#sec-arraybuffer-constructor
$({ global: true, constructor: true, forced: NativeArrayBuffer !== ArrayBuffer }, {
  ArrayBuffer: ArrayBuffer
});

setSpecies(ARRAY_BUFFER);

},{"../internals/array-buffer":583,"../internals/export":652,"../internals/global":672,"../internals/set-species":759}],816:[function(require,module,exports){
var $ = require('../internals/export');
var ArrayBufferViewCore = require('../internals/array-buffer-view-core');

var NATIVE_ARRAY_BUFFER_VIEWS = ArrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS;

// `ArrayBuffer.isView` method
// https://tc39.es/ecma262/#sec-arraybuffer.isview
$({ target: 'ArrayBuffer', stat: true, forced: !NATIVE_ARRAY_BUFFER_VIEWS }, {
  isView: ArrayBufferViewCore.isView
});

},{"../internals/array-buffer-view-core":582,"../internals/export":652}],817:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var uncurryThis = require('../internals/function-uncurry-this-clause');
var fails = require('../internals/fails');
var ArrayBufferModule = require('../internals/array-buffer');
var anObject = require('../internals/an-object');
var toAbsoluteIndex = require('../internals/to-absolute-index');
var toLength = require('../internals/to-length');
var speciesConstructor = require('../internals/species-constructor');

var ArrayBuffer = ArrayBufferModule.ArrayBuffer;
var DataView = ArrayBufferModule.DataView;
var DataViewPrototype = DataView.prototype;
var nativeArrayBufferSlice = uncurryThis(ArrayBuffer.prototype.slice);
var getUint8 = uncurryThis(DataViewPrototype.getUint8);
var setUint8 = uncurryThis(DataViewPrototype.setUint8);

var INCORRECT_SLICE = fails(function () {
  return !new ArrayBuffer(2).slice(1, undefined).byteLength;
});

// `ArrayBuffer.prototype.slice` method
// https://tc39.es/ecma262/#sec-arraybuffer.prototype.slice
$({ target: 'ArrayBuffer', proto: true, unsafe: true, forced: INCORRECT_SLICE }, {
  slice: function slice(start, end) {
    if (nativeArrayBufferSlice && end === undefined) {
      return nativeArrayBufferSlice(anObject(this), start); // FF fix
    }
    var length = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    var result = new (speciesConstructor(this, ArrayBuffer))(toLength(fin - first));
    var viewSource = new DataView(this);
    var viewTarget = new DataView(result);
    var index = 0;
    while (first < fin) {
      setUint8(viewTarget, index++, getUint8(viewSource, first++));
    } return result;
  }
});

},{"../internals/an-object":579,"../internals/array-buffer":583,"../internals/export":652,"../internals/fails":653,"../internals/function-uncurry-this-clause":664,"../internals/species-constructor":764,"../internals/to-absolute-index":781,"../internals/to-length":786}],818:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var toObject = require('../internals/to-object');
var lengthOfArrayLike = require('../internals/length-of-array-like');
var toIntegerOrInfinity = require('../internals/to-integer-or-infinity');
var addToUnscopables = require('../internals/add-to-unscopables');

// `Array.prototype.at` method
// https://github.com/tc39/proposal-relative-indexing-method
$({ target: 'Array', proto: true }, {
  at: function at(index) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var relativeIndex = toIntegerOrInfinity(index);
    var k = relativeIndex >= 0 ? relativeIndex : len + relativeIndex;
    return (k < 0 || k >= len) ? undefined : O[k];
  }
});

addToUnscopables('at');

},{"../internals/add-to-unscopables":576,"../internals/export":652,"../internals/length-of-array-like":704,"../internals/to-integer-or-infinity":785,"../internals/to-object":787}],819:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var fails = require('../internals/fails');
var isArray = require('../internals/is-array');
var isObject = require('../internals/is-object');
var toObject = require('../internals/to-object');
var lengthOfArrayLike = require('../internals/length-of-array-like');
var doesNotExceedSafeInteger = require('../internals/does-not-exceed-safe-integer');
var createProperty = require('../internals/create-property');
var arraySpeciesCreate = require('../internals/array-species-create');
var arrayMethodHasSpeciesSupport = require('../internals/array-method-has-species-support');
var wellKnownSymbol = require('../internals/well-known-symbol');
var V8_VERSION = require('../internals/engine-v8-version');

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !arrayMethodHasSpeciesSupport('concat');

// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = lengthOfArrayLike(E);
        doesNotExceedSafeInteger(n + len);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        doesNotExceedSafeInteger(n + 1);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});

},{"../internals/array-method-has-species-support":593,"../internals/array-species-create":601,"../internals/create-property":619,"../internals/does-not-exceed-safe-integer":630,"../internals/engine-v8-version":644,"../internals/export":652,"../internals/fails":653,"../internals/is-array":686,"../internals/is-object":694,"../internals/length-of-array-like":704,"../internals/to-object":787,"../internals/well-known-symbol":809}],820:[function(require,module,exports){
var $ = require('../internals/export');
var copyWithin = require('../internals/array-copy-within');
var addToUnscopables = require('../internals/add-to-unscopables');

// `Array.prototype.copyWithin` method
// https://tc39.es/ecma262/#sec-array.prototype.copywithin
$({ target: 'Array', proto: true }, {
  copyWithin: copyWithin
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('copyWithin');

},{"../internals/add-to-unscopables":576,"../internals/array-copy-within":584,"../internals/export":652}],821:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var $every = require('../internals/array-iteration').every;
var arrayMethodIsStrict = require('../internals/array-method-is-strict');

var STRICT_METHOD = arrayMethodIsStrict('every');

// `Array.prototype.every` method
// https://tc39.es/ecma262/#sec-array.prototype.every
$({ target: 'Array', proto: true, forced: !STRICT_METHOD }, {
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

},{"../internals/array-iteration":591,"../internals/array-method-is-strict":594,"../internals/export":652}],822:[function(require,module,exports){
var $ = require('../internals/export');
var fill = require('../internals/array-fill');
var addToUnscopables = require('../internals/add-to-unscopables');

// `Array.prototype.fill` method
// https://tc39.es/ecma262/#sec-array.prototype.fill
$({ target: 'Array', proto: true }, {
  fill: fill
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('fill');

},{"../internals/add-to-unscopables":576,"../internals/array-fill":585,"../internals/export":652}],823:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var $filter = require('../internals/array-iteration').filter;
var arrayMethodHasSpeciesSupport = require('../internals/array-method-has-species-support');

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');

// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

},{"../internals/array-iteration":591,"../internals/array-method-has-species-support":593,"../internals/export":652}],824:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var $findIndex = require('../internals/array-iteration').findIndex;
var addToUnscopables = require('../internals/add-to-unscopables');

var FIND_INDEX = 'findIndex';
var SKIPS_HOLES = true;

// Shouldn't skip holes
if (FIND_INDEX in []) Array(1)[FIND_INDEX](function () { SKIPS_HOLES = false; });

// `Array.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-array.prototype.findindex
$({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND_INDEX);

},{"../internals/add-to-unscopables":576,"../internals/array-iteration":591,"../internals/export":652}],825:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var $findLastIndex = require('../internals/array-iteration-from-last').findLastIndex;
var addToUnscopables = require('../internals/add-to-unscopables');

// `Array.prototype.findLastIndex` method
// https://github.com/tc39/proposal-array-find-from-last
$({ target: 'Array', proto: true }, {
  findLastIndex: function findLastIndex(callbackfn /* , that = undefined */) {
    return $findLastIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

addToUnscopables('findLastIndex');

},{"../internals/add-to-unscopables":576,"../internals/array-iteration-from-last":590,"../internals/export":652}],826:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var $findLast = require('../internals/array-iteration-from-last').findLast;
var addToUnscopables = require('../internals/add-to-unscopables');

// `Array.prototype.findLast` method
// https://github.com/tc39/proposal-array-find-from-last
$({ target: 'Array', proto: true }, {
  findLast: function findLast(callbackfn /* , that = undefined */) {
    return $findLast(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

addToUnscopables('findLast');

},{"../internals/add-to-unscopables":576,"../internals/array-iteration-from-last":590,"../internals/export":652}],827:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var $find = require('../internals/array-iteration').find;
var addToUnscopables = require('../internals/add-to-unscopables');

var FIND = 'find';
var SKIPS_HOLES = true;

// Shouldn't skip holes
if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES = false; });

// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
$({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND);

},{"../internals/add-to-unscopables":576,"../internals/array-iteration":591,"../internals/export":652}],828:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var flattenIntoArray = require('../internals/flatten-into-array');
var aCallable = require('../internals/a-callable');
var toObject = require('../internals/to-object');
var lengthOfArrayLike = require('../internals/length-of-array-like');
var arraySpeciesCreate = require('../internals/array-species-create');

// `Array.prototype.flatMap` method
// https://tc39.es/ecma262/#sec-array.prototype.flatmap
$({ target: 'Array', proto: true }, {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen = lengthOfArrayLike(O);
    var A;
    aCallable(callbackfn);
    A = arraySpeciesCreate(O, 0);
    A.length = flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    return A;
  }
});

},{"../internals/a-callable":573,"../internals/array-species-create":601,"../internals/export":652,"../internals/flatten-into-array":655,"../internals/length-of-array-like":704,"../internals/to-object":787}],829:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var flattenIntoArray = require('../internals/flatten-into-array');
var toObject = require('../internals/to-object');
var lengthOfArrayLike = require('../internals/length-of-array-like');
var toIntegerOrInfinity = require('../internals/to-integer-or-infinity');
var arraySpeciesCreate = require('../internals/array-species-create');

// `Array.prototype.flat` method
// https://tc39.es/ecma262/#sec-array.prototype.flat
$({ target: 'Array', proto: true }, {
  flat: function flat(/* depthArg = 1 */) {
    var depthArg = arguments.length ? arguments[0] : undefined;
    var O = toObject(this);
    var sourceLen = lengthOfArrayLike(O);
    var A = arraySpeciesCreate(O, 0);
    A.length = flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toIntegerOrInfinity(depthArg));
    return A;
  }
});

},{"../internals/array-species-create":601,"../internals/export":652,"../internals/flatten-into-array":655,"../internals/length-of-array-like":704,"../internals/to-integer-or-infinity":785,"../internals/to-object":787}],830:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var forEach = require('../internals/array-for-each');

// `Array.prototype.forEach` method
// https://tc39.es/ecma262/#sec-array.prototype.foreach
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
$({ target: 'Array', proto: true, forced: [].forEach != forEach }, {
  forEach: forEach
});

},{"../internals/array-for-each":586,"../internals/export":652}],831:[function(require,module,exports){
var $ = require('../internals/export');
var from = require('../internals/array-from');
var checkCorrectnessOfIteration = require('../internals/check-correctness-of-iteration');

var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
  // eslint-disable-next-line es/no-array-from -- required for testing
  Array.from(iterable);
});

// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
$({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
  from: from
});

},{"../internals/array-from":588,"../internals/check-correctness-of-iteration":606,"../internals/export":652}],832:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var $includes = require('../internals/array-includes').includes;
var fails = require('../internals/fails');
var addToUnscopables = require('../internals/add-to-unscopables');

// FF99+ bug
var BROKEN_ON_SPARSE = fails(function () {
  // eslint-disable-next-line es/no-array-prototype-includes -- detection
  return !Array(1).includes();
});

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$({ target: 'Array', proto: true, forced: BROKEN_ON_SPARSE }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');

},{"../internals/add-to-unscopables":576,"../internals/array-includes":589,"../internals/export":652,"../internals/fails":653}],833:[function(require,module,exports){
'use strict';
/* eslint-disable es/no-array-prototype-indexof -- required for testing */
var $ = require('../internals/export');
var uncurryThis = require('../internals/function-uncurry-this-clause');
var $indexOf = require('../internals/array-includes').indexOf;
var arrayMethodIsStrict = require('../internals/array-method-is-strict');

var nativeIndexOf = uncurryThis([].indexOf);

var NEGATIVE_ZERO = !!nativeIndexOf && 1 / nativeIndexOf([1], 1, -0) < 0;
var FORCED = NEGATIVE_ZERO || !arrayMethodIsStrict('indexOf');

// `Array.prototype.indexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.indexof
$({ target: 'Array', proto: true, forced: FORCED }, {
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    var fromIndex = arguments.length > 1 ? arguments[1] : undefined;
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? nativeIndexOf(this, searchElement, fromIndex) || 0
      : $indexOf(this, searchElement, fromIndex);
  }
});

},{"../internals/array-includes":589,"../internals/array-method-is-strict":594,"../internals/export":652,"../internals/function-uncurry-this-clause":664}],834:[function(require,module,exports){
var $ = require('../internals/export');
var isArray = require('../internals/is-array');

// `Array.isArray` method
// https://tc39.es/ecma262/#sec-array.isarray
$({ target: 'Array', stat: true }, {
  isArray: isArray
});

},{"../internals/export":652,"../internals/is-array":686}],835:[function(require,module,exports){
'use strict';
var toIndexedObject = require('../internals/to-indexed-object');
var addToUnscopables = require('../internals/add-to-unscopables');
var Iterators = require('../internals/iterators');
var InternalStateModule = require('../internals/internal-state');
var defineProperty = require('../internals/object-define-property').f;
var defineIterator = require('../internals/iterator-define');
var createIterResultObject = require('../internals/create-iter-result-object');
var IS_PURE = require('../internals/is-pure');
var DESCRIPTORS = require('../internals/descriptors');

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return createIterResultObject(undefined, true);
  }
  if (kind == 'keys') return createIterResultObject(index, false);
  if (kind == 'values') return createIterResultObject(target[index], false);
  return createIterResultObject([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

// V8 ~ Chrome 45- bug
if (!IS_PURE && DESCRIPTORS && values.name !== 'values') try {
  defineProperty(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }

},{"../internals/add-to-unscopables":576,"../internals/create-iter-result-object":616,"../internals/descriptors":627,"../internals/internal-state":684,"../internals/is-pure":695,"../internals/iterator-define":701,"../internals/iterators":703,"../internals/object-define-property":723,"../internals/to-indexed-object":784}],836:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var uncurryThis = require('../internals/function-uncurry-this');
var IndexedObject = require('../internals/indexed-object');
var toIndexedObject = require('../internals/to-indexed-object');
var arrayMethodIsStrict = require('../internals/array-method-is-strict');

var nativeJoin = uncurryThis([].join);

var ES3_STRINGS = IndexedObject != Object;
var FORCED = ES3_STRINGS || !arrayMethodIsStrict('join', ',');

// `Array.prototype.join` method
// https://tc39.es/ecma262/#sec-array.prototype.join
$({ target: 'Array', proto: true, forced: FORCED }, {
  join: function join(separator) {
    return nativeJoin(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});

},{"../internals/array-method-is-strict":594,"../internals/export":652,"../internals/function-uncurry-this":665,"../internals/indexed-object":679,"../internals/to-indexed-object":784}],837:[function(require,module,exports){
var $ = require('../internals/export');
var lastIndexOf = require('../internals/array-last-index-of');

// `Array.prototype.lastIndexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
// eslint-disable-next-line es/no-array-prototype-lastindexof -- required for testing
$({ target: 'Array', proto: true, forced: lastIndexOf !== [].lastIndexOf }, {
  lastIndexOf: lastIndexOf
});

},{"../internals/array-last-index-of":592,"../internals/export":652}],838:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var $map = require('../internals/array-iteration').map;
var arrayMethodHasSpeciesSupport = require('../internals/array-method-has-species-support');

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');

// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

},{"../internals/array-iteration":591,"../internals/array-method-has-species-support":593,"../internals/export":652}],839:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var fails = require('../internals/fails');
var isConstructor = require('../internals/is-constructor');
var createProperty = require('../internals/create-property');

var $Array = Array;

var ISNT_GENERIC = fails(function () {
  function F() { /* empty */ }
  // eslint-disable-next-line es/no-array-of -- safe
  return !($Array.of.call(F) instanceof F);
});

// `Array.of` method
// https://tc39.es/ecma262/#sec-array.of
// WebKit Array.of isn't generic
$({ target: 'Array', stat: true, forced: ISNT_GENERIC }, {
  of: function of(/* ...args */) {
    var index = 0;
    var argumentsLength = arguments.length;
    var result = new (isConstructor(this) ? this : $Array)(argumentsLength);
    while (argumentsLength > index) createProperty(result, index, arguments[index++]);
    result.length = argumentsLength;
    return result;
  }
});

},{"../internals/create-property":619,"../internals/export":652,"../internals/fails":653,"../internals/is-constructor":689}],840:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var toObject = require('../internals/to-object');
var lengthOfArrayLike = require('../internals/length-of-array-like');
var setArrayLength = require('../internals/array-set-length');
var doesNotExceedSafeInteger = require('../internals/does-not-exceed-safe-integer');
var fails = require('../internals/fails');

var INCORRECT_TO_LENGTH = fails(function () {
  return [].push.call({ length: 0x100000000 }, 1) !== 4294967297;
});

// V8 and Safari <= 15.4, FF < 23 throws InternalError
// https://bugs.chromium.org/p/v8/issues/detail?id=12681
var properErrorOnNonWritableLength = function () {
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).push();
  } catch (error) {
    return error instanceof TypeError;
  }
};

var FORCED = INCORRECT_TO_LENGTH || !properErrorOnNonWritableLength();

// `Array.prototype.push` method
// https://tc39.es/ecma262/#sec-array.prototype.push
$({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  push: function push(item) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var argCount = arguments.length;
    doesNotExceedSafeInteger(len + argCount);
    for (var i = 0; i < argCount; i++) {
      O[len] = arguments[i];
      len++;
    }
    setArrayLength(O, len);
    return len;
  }
});

},{"../internals/array-set-length":596,"../internals/does-not-exceed-safe-integer":630,"../internals/export":652,"../internals/fails":653,"../internals/length-of-array-like":704,"../internals/to-object":787}],841:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var $reduceRight = require('../internals/array-reduce').right;
var arrayMethodIsStrict = require('../internals/array-method-is-strict');
var CHROME_VERSION = require('../internals/engine-v8-version');
var IS_NODE = require('../internals/engine-is-node');

// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83;
var FORCED = CHROME_BUG || !arrayMethodIsStrict('reduceRight');

// `Array.prototype.reduceRight` method
// https://tc39.es/ecma262/#sec-array.prototype.reduceright
$({ target: 'Array', proto: true, forced: FORCED }, {
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduceRight(this, callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
  }
});

},{"../internals/array-method-is-strict":594,"../internals/array-reduce":595,"../internals/engine-is-node":641,"../internals/engine-v8-version":644,"../internals/export":652}],842:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var $reduce = require('../internals/array-reduce').left;
var arrayMethodIsStrict = require('../internals/array-method-is-strict');
var CHROME_VERSION = require('../internals/engine-v8-version');
var IS_NODE = require('../internals/engine-is-node');

// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83;
var FORCED = CHROME_BUG || !arrayMethodIsStrict('reduce');

// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$({ target: 'Array', proto: true, forced: FORCED }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    var length = arguments.length;
    return $reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
  }
});

},{"../internals/array-method-is-strict":594,"../internals/array-reduce":595,"../internals/engine-is-node":641,"../internals/engine-v8-version":644,"../internals/export":652}],843:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var uncurryThis = require('../internals/function-uncurry-this');
var isArray = require('../internals/is-array');

var nativeReverse = uncurryThis([].reverse);
var test = [1, 2];

// `Array.prototype.reverse` method
// https://tc39.es/ecma262/#sec-array.prototype.reverse
// fix for Safari 12.0 bug
// https://bugs.webkit.org/show_bug.cgi?id=188794
$({ target: 'Array', proto: true, forced: String(test) === String(test.reverse()) }, {
  reverse: function reverse() {
    // eslint-disable-next-line no-self-assign -- dirty hack
    if (isArray(this)) this.length = this.length;
    return nativeReverse(this);
  }
});

},{"../internals/export":652,"../internals/function-uncurry-this":665,"../internals/is-array":686}],844:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var isArray = require('../internals/is-array');
var isConstructor = require('../internals/is-constructor');
var isObject = require('../internals/is-object');
var toAbsoluteIndex = require('../internals/to-absolute-index');
var lengthOfArrayLike = require('../internals/length-of-array-like');
var toIndexedObject = require('../internals/to-indexed-object');
var createProperty = require('../internals/create-property');
var wellKnownSymbol = require('../internals/well-known-symbol');
var arrayMethodHasSpeciesSupport = require('../internals/array-method-has-species-support');
var nativeSlice = require('../internals/array-slice');

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');

var SPECIES = wellKnownSymbol('species');
var $Array = Array;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = lengthOfArrayLike(O);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (isConstructor(Constructor) && (Constructor === $Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === $Array || Constructor === undefined) {
        return nativeSlice(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? $Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});

},{"../internals/array-method-has-species-support":593,"../internals/array-slice":598,"../internals/create-property":619,"../internals/export":652,"../internals/is-array":686,"../internals/is-constructor":689,"../internals/is-object":694,"../internals/length-of-array-like":704,"../internals/to-absolute-index":781,"../internals/to-indexed-object":784,"../internals/well-known-symbol":809}],845:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var $some = require('../internals/array-iteration').some;
var arrayMethodIsStrict = require('../internals/array-method-is-strict');

var STRICT_METHOD = arrayMethodIsStrict('some');

// `Array.prototype.some` method
// https://tc39.es/ecma262/#sec-array.prototype.some
$({ target: 'Array', proto: true, forced: !STRICT_METHOD }, {
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

},{"../internals/array-iteration":591,"../internals/array-method-is-strict":594,"../internals/export":652}],846:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var uncurryThis = require('../internals/function-uncurry-this');
var aCallable = require('../internals/a-callable');
var toObject = require('../internals/to-object');
var lengthOfArrayLike = require('../internals/length-of-array-like');
var deletePropertyOrThrow = require('../internals/delete-property-or-throw');
var toString = require('../internals/to-string');
var fails = require('../internals/fails');
var internalSort = require('../internals/array-sort');
var arrayMethodIsStrict = require('../internals/array-method-is-strict');
var FF = require('../internals/engine-ff-version');
var IE_OR_EDGE = require('../internals/engine-is-ie-or-edge');
var V8 = require('../internals/engine-v8-version');
var WEBKIT = require('../internals/engine-webkit-version');

var test = [];
var nativeSort = uncurryThis(test.sort);
var push = uncurryThis(test.push);

// IE8-
var FAILS_ON_UNDEFINED = fails(function () {
  test.sort(undefined);
});
// V8 bug
var FAILS_ON_NULL = fails(function () {
  test.sort(null);
});
// Old WebKit
var STRICT_METHOD = arrayMethodIsStrict('sort');

var STABLE_SORT = !fails(function () {
  // feature detection can be too slow, so check engines versions
  if (V8) return V8 < 70;
  if (FF && FF > 3) return;
  if (IE_OR_EDGE) return true;
  if (WEBKIT) return WEBKIT < 603;

  var result = '';
  var code, chr, value, index;

  // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
  for (code = 65; code < 76; code++) {
    chr = String.fromCharCode(code);

    switch (code) {
      case 66: case 69: case 70: case 72: value = 3; break;
      case 68: case 71: value = 4; break;
      default: value = 2;
    }

    for (index = 0; index < 47; index++) {
      test.push({ k: chr + index, v: value });
    }
  }

  test.sort(function (a, b) { return b.v - a.v; });

  for (index = 0; index < test.length; index++) {
    chr = test[index].k.charAt(0);
    if (result.charAt(result.length - 1) !== chr) result += chr;
  }

  return result !== 'DGBEFHACIJK';
});

var FORCED = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD || !STABLE_SORT;

var getSortCompare = function (comparefn) {
  return function (x, y) {
    if (y === undefined) return -1;
    if (x === undefined) return 1;
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    return toString(x) > toString(y) ? 1 : -1;
  };
};

// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
$({ target: 'Array', proto: true, forced: FORCED }, {
  sort: function sort(comparefn) {
    if (comparefn !== undefined) aCallable(comparefn);

    var array = toObject(this);

    if (STABLE_SORT) return comparefn === undefined ? nativeSort(array) : nativeSort(array, comparefn);

    var items = [];
    var arrayLength = lengthOfArrayLike(array);
    var itemsLength, index;

    for (index = 0; index < arrayLength; index++) {
      if (index in array) push(items, array[index]);
    }

    internalSort(items, getSortCompare(comparefn));

    itemsLength = lengthOfArrayLike(items);
    index = 0;

    while (index < itemsLength) array[index] = items[index++];
    while (index < arrayLength) deletePropertyOrThrow(array, index++);

    return array;
  }
});

},{"../internals/a-callable":573,"../internals/array-method-is-strict":594,"../internals/array-sort":599,"../internals/delete-property-or-throw":626,"../internals/engine-ff-version":634,"../internals/engine-is-ie-or-edge":638,"../internals/engine-v8-version":644,"../internals/engine-webkit-version":645,"../internals/export":652,"../internals/fails":653,"../internals/function-uncurry-this":665,"../internals/length-of-array-like":704,"../internals/to-object":787,"../internals/to-string":793}],847:[function(require,module,exports){
var setSpecies = require('../internals/set-species');

// `Array[@@species]` getter
// https://tc39.es/ecma262/#sec-get-array-@@species
setSpecies('Array');

},{"../internals/set-species":759}],848:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var toObject = require('../internals/to-object');
var toAbsoluteIndex = require('../internals/to-absolute-index');
var toIntegerOrInfinity = require('../internals/to-integer-or-infinity');
var lengthOfArrayLike = require('../internals/length-of-array-like');
var setArrayLength = require('../internals/array-set-length');
var doesNotExceedSafeInteger = require('../internals/does-not-exceed-safe-integer');
var arraySpeciesCreate = require('../internals/array-species-create');
var createProperty = require('../internals/create-property');
var deletePropertyOrThrow = require('../internals/delete-property-or-throw');
var arrayMethodHasSpeciesSupport = require('../internals/array-method-has-species-support');

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('splice');

var max = Math.max;
var min = Math.min;

// `Array.prototype.splice` method
// https://tc39.es/ecma262/#sec-array.prototype.splice
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  splice: function splice(start, deleteCount /* , ...items */) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var actualStart = toAbsoluteIndex(start, len);
    var argumentsLength = arguments.length;
    var insertCount, actualDeleteCount, A, k, from, to;
    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min(max(toIntegerOrInfinity(deleteCount), 0), len - actualStart);
    }
    doesNotExceedSafeInteger(len + insertCount - actualDeleteCount);
    A = arraySpeciesCreate(O, actualDeleteCount);
    for (k = 0; k < actualDeleteCount; k++) {
      from = actualStart + k;
      if (from in O) createProperty(A, k, O[from]);
    }
    A.length = actualDeleteCount;
    if (insertCount < actualDeleteCount) {
      for (k = actualStart; k < len - actualDeleteCount; k++) {
        from = k + actualDeleteCount;
        to = k + insertCount;
        if (from in O) O[to] = O[from];
        else deletePropertyOrThrow(O, to);
      }
      for (k = len; k > len - actualDeleteCount + insertCount; k--) deletePropertyOrThrow(O, k - 1);
    } else if (insertCount > actualDeleteCount) {
      for (k = len - actualDeleteCount; k > actualStart; k--) {
        from = k + actualDeleteCount - 1;
        to = k + insertCount - 1;
        if (from in O) O[to] = O[from];
        else deletePropertyOrThrow(O, to);
      }
    }
    for (k = 0; k < insertCount; k++) {
      O[k + actualStart] = arguments[k + 2];
    }
    setArrayLength(O, len - actualDeleteCount + insertCount);
    return A;
  }
});

},{"../internals/array-method-has-species-support":593,"../internals/array-set-length":596,"../internals/array-species-create":601,"../internals/create-property":619,"../internals/delete-property-or-throw":626,"../internals/does-not-exceed-safe-integer":630,"../internals/export":652,"../internals/length-of-array-like":704,"../internals/to-absolute-index":781,"../internals/to-integer-or-infinity":785,"../internals/to-object":787}],849:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var arrayToReversed = require('../internals/array-to-reversed');
var toIndexedObject = require('../internals/to-indexed-object');
var addToUnscopables = require('../internals/add-to-unscopables');

var $Array = Array;

// `Array.prototype.toReversed` method
// https://tc39.es/proposal-change-array-by-copy/#sec-array.prototype.toReversed
$({ target: 'Array', proto: true }, {
  toReversed: function toReversed() {
    return arrayToReversed(toIndexedObject(this), $Array);
  }
});

addToUnscopables('toReversed');

},{"../internals/add-to-unscopables":576,"../internals/array-to-reversed":602,"../internals/export":652,"../internals/to-indexed-object":784}],850:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var uncurryThis = require('../internals/function-uncurry-this');
var aCallable = require('../internals/a-callable');
var toIndexedObject = require('../internals/to-indexed-object');
var arrayFromConstructorAndList = require('../internals/array-from-constructor-and-list');
var getVirtual = require('../internals/entry-virtual');
var addToUnscopables = require('../internals/add-to-unscopables');

var $Array = Array;
var sort = uncurryThis(getVirtual('Array').sort);

// `Array.prototype.toSorted` method
// https://tc39.es/proposal-change-array-by-copy/#sec-array.prototype.toSorted
$({ target: 'Array', proto: true }, {
  toSorted: function toSorted(compareFn) {
    if (compareFn !== undefined) aCallable(compareFn);
    var O = toIndexedObject(this);
    var A = arrayFromConstructorAndList($Array, O);
    return sort(A, compareFn);
  }
});

addToUnscopables('toSorted');

},{"../internals/a-callable":573,"../internals/add-to-unscopables":576,"../internals/array-from-constructor-and-list":587,"../internals/entry-virtual":646,"../internals/export":652,"../internals/function-uncurry-this":665,"../internals/to-indexed-object":784}],851:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var addToUnscopables = require('../internals/add-to-unscopables');
var doesNotExceedSafeInteger = require('../internals/does-not-exceed-safe-integer');
var lengthOfArrayLike = require('../internals/length-of-array-like');
var toAbsoluteIndex = require('../internals/to-absolute-index');
var toIndexedObject = require('../internals/to-indexed-object');
var toIntegerOrInfinity = require('../internals/to-integer-or-infinity');

var $Array = Array;
var max = Math.max;
var min = Math.min;

// `Array.prototype.toSpliced` method
// https://tc39.es/proposal-change-array-by-copy/#sec-array.prototype.toSpliced
$({ target: 'Array', proto: true }, {
  toSpliced: function toSpliced(start, deleteCount /* , ...items */) {
    var O = toIndexedObject(this);
    var len = lengthOfArrayLike(O);
    var actualStart = toAbsoluteIndex(start, len);
    var argumentsLength = arguments.length;
    var k = 0;
    var insertCount, actualDeleteCount, newLen, A;
    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min(max(toIntegerOrInfinity(deleteCount), 0), len - actualStart);
    }
    newLen = doesNotExceedSafeInteger(len + insertCount - actualDeleteCount);
    A = $Array(newLen);

    for (; k < actualStart; k++) A[k] = O[k];
    for (; k < actualStart + insertCount; k++) A[k] = arguments[k - actualStart + 2];
    for (; k < newLen; k++) A[k] = O[k + actualDeleteCount - insertCount];

    return A;
  }
});

addToUnscopables('toSpliced');

},{"../internals/add-to-unscopables":576,"../internals/does-not-exceed-safe-integer":630,"../internals/export":652,"../internals/length-of-array-like":704,"../internals/to-absolute-index":781,"../internals/to-indexed-object":784,"../internals/to-integer-or-infinity":785}],852:[function(require,module,exports){
// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module
var addToUnscopables = require('../internals/add-to-unscopables');

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('flatMap');

},{"../internals/add-to-unscopables":576}],853:[function(require,module,exports){
// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module
var addToUnscopables = require('../internals/add-to-unscopables');

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('flat');

},{"../internals/add-to-unscopables":576}],854:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var toObject = require('../internals/to-object');
var lengthOfArrayLike = require('../internals/length-of-array-like');
var setArrayLength = require('../internals/array-set-length');
var deletePropertyOrThrow = require('../internals/delete-property-or-throw');
var doesNotExceedSafeInteger = require('../internals/does-not-exceed-safe-integer');

// IE8-
var INCORRECT_RESULT = [].unshift(0) !== 1;

// V8 ~ Chrome < 71 and Safari <= 15.4, FF < 23 throws InternalError
var properErrorOnNonWritableLength = function () {
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).unshift();
  } catch (error) {
    return error instanceof TypeError;
  }
};

var FORCED = INCORRECT_RESULT || !properErrorOnNonWritableLength();

// `Array.prototype.unshift` method
// https://tc39.es/ecma262/#sec-array.prototype.unshift
$({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  unshift: function unshift(item) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var argCount = arguments.length;
    if (argCount) {
      doesNotExceedSafeInteger(len + argCount);
      var k = len;
      while (k--) {
        var to = k + argCount;
        if (k in O) O[to] = O[k];
        else deletePropertyOrThrow(O, to);
      }
      for (var j = 0; j < argCount; j++) {
        O[j] = arguments[j];
      }
    } return setArrayLength(O, len + argCount);
  }
});

},{"../internals/array-set-length":596,"../internals/delete-property-or-throw":626,"../internals/does-not-exceed-safe-integer":630,"../internals/export":652,"../internals/length-of-array-like":704,"../internals/to-object":787}],855:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var arrayWith = require('../internals/array-with');
var toIndexedObject = require('../internals/to-indexed-object');

var $Array = Array;

// `Array.prototype.with` method
// https://tc39.es/proposal-change-array-by-copy/#sec-array.prototype.with
$({ target: 'Array', proto: true }, {
  'with': function (index, value) {
    return arrayWith(toIndexedObject(this), $Array, index, value);
  }
});

},{"../internals/array-with":603,"../internals/export":652,"../internals/to-indexed-object":784}],856:[function(require,module,exports){
var $ = require('../internals/export');
var ArrayBufferModule = require('../internals/array-buffer');
var NATIVE_ARRAY_BUFFER = require('../internals/array-buffer-basic-detection');

// `DataView` constructor
// https://tc39.es/ecma262/#sec-dataview-constructor
$({ global: true, constructor: true, forced: !NATIVE_ARRAY_BUFFER }, {
  DataView: ArrayBufferModule.DataView
});

},{"../internals/array-buffer":583,"../internals/array-buffer-basic-detection":580,"../internals/export":652}],857:[function(require,module,exports){
// TODO: Remove this module from `core-js@4` since it's replaced to module below
require('../modules/es.data-view.constructor');

},{"../modules/es.data-view.constructor":856}],858:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var uncurryThis = require('../internals/function-uncurry-this');
var fails = require('../internals/fails');

// IE8- non-standard case
var FORCED = fails(function () {
  // eslint-disable-next-line es/no-date-prototype-getyear-setyear -- detection
  return new Date(16e11).getYear() !== 120;
});

var getFullYear = uncurryThis(Date.prototype.getFullYear);

// `Date.prototype.getYear` method
// https://tc39.es/ecma262/#sec-date.prototype.getyear
$({ target: 'Date', proto: true, forced: FORCED }, {
  getYear: function getYear() {
    return getFullYear(this) - 1900;
  }
});

},{"../internals/export":652,"../internals/fails":653,"../internals/function-uncurry-this":665}],859:[function(require,module,exports){
// TODO: Remove from `core-js@4`
var $ = require('../internals/export');
var uncurryThis = require('../internals/function-uncurry-this');

var $Date = Date;
var thisTimeValue = uncurryThis($Date.prototype.getTime);

// `Date.now` method
// https://tc39.es/ecma262/#sec-date.now
$({ target: 'Date', stat: true }, {
  now: function now() {
    return thisTimeValue(new $Date());
  }
});

},{"../internals/export":652,"../internals/function-uncurry-this":665}],860:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var uncurryThis = require('../internals/function-uncurry-this');
var toIntegerOrInfinity = require('../internals/to-integer-or-infinity');

var DatePrototype = Date.prototype;
var thisTimeValue = uncurryThis(DatePrototype.getTime);
var setFullYear = uncurryThis(DatePrototype.setFullYear);

// `Date.prototype.setYear` method
// https://tc39.es/ecma262/#sec-date.prototype.setyear
$({ target: 'Date', proto: true }, {
  setYear: function setYear(year) {
    // validate
    thisTimeValue(this);
    var yi = toIntegerOrInfinity(year);
    var yyyy = 0 <= yi && yi <= 99 ? yi + 1900 : yi;
    return setFullYear(this, yyyy);
  }
});

},{"../internals/export":652,"../internals/function-uncurry-this":665,"../internals/to-integer-or-infinity":785}],861:[function(require,module,exports){
var $ = require('../internals/export');

// `Date.prototype.toGMTString` method
// https://tc39.es/ecma262/#sec-date.prototype.togmtstring
$({ target: 'Date', proto: true }, {
  toGMTString: Date.prototype.toUTCString
});

},{"../internals/export":652}],862:[function(require,module,exports){
var $ = require('../internals/export');
var toISOString = require('../internals/date-to-iso-string');

// `Date.prototype.toISOString` method
// https://tc39.es/ecma262/#sec-date.prototype.toisostring
// PhantomJS / old WebKit has a broken implementations
$({ target: 'Date', proto: true, forced: Date.prototype.toISOString !== toISOString }, {
  toISOString: toISOString
});

},{"../internals/date-to-iso-string":620,"../internals/export":652}],863:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var fails = require('../internals/fails');
var toObject = require('../internals/to-object');
var toPrimitive = require('../internals/to-primitive');

var FORCED = fails(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
});

// `Date.prototype.toJSON` method
// https://tc39.es/ecma262/#sec-date.prototype.tojson
$({ target: 'Date', proto: true, arity: 1, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O, 'number');
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});

},{"../internals/export":652,"../internals/fails":653,"../internals/to-object":787,"../internals/to-primitive":790}],864:[function(require,module,exports){
var hasOwn = require('../internals/has-own-property');
var defineBuiltIn = require('../internals/define-built-in');
var dateToPrimitive = require('../internals/date-to-primitive');
var wellKnownSymbol = require('../internals/well-known-symbol');

var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
var DatePrototype = Date.prototype;

// `Date.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive
if (!hasOwn(DatePrototype, TO_PRIMITIVE)) {
  defineBuiltIn(DatePrototype, TO_PRIMITIVE, dateToPrimitive);
}

},{"../internals/date-to-primitive":621,"../internals/define-built-in":623,"../internals/has-own-property":673,"../internals/well-known-symbol":809}],865:[function(require,module,exports){
// TODO: Remove from `core-js@4`
var uncurryThis = require('../internals/function-uncurry-this');
var defineBuiltIn = require('../internals/define-built-in');

var DatePrototype = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var nativeDateToString = uncurryThis(DatePrototype[TO_STRING]);
var thisTimeValue = uncurryThis(DatePrototype.getTime);

// `Date.prototype.toString` method
// https://tc39.es/ecma262/#sec-date.prototype.tostring
if (String(new Date(NaN)) != INVALID_DATE) {
  defineBuiltIn(DatePrototype, TO_STRING, function toString() {
    var value = thisTimeValue(this);
    // eslint-disable-next-line no-self-compare -- NaN check
    return value === value ? nativeDateToString(this) : INVALID_DATE;
  });
}

},{"../internals/define-built-in":623,"../internals/function-uncurry-this":665}],866:[function(require,module,exports){
/* eslint-disable no-unused-vars -- required for functions `.length` */
var $ = require('../internals/export');
var global = require('../internals/global');
var apply = require('../internals/function-apply');
var wrapErrorConstructorWithCause = require('../internals/wrap-error-constructor-with-cause');

var WEB_ASSEMBLY = 'WebAssembly';
var WebAssembly = global[WEB_ASSEMBLY];

var FORCED = Error('e', { cause: 7 }).cause !== 7;

var exportGlobalErrorCauseWrapper = function (ERROR_NAME, wrapper) {
  var O = {};
  O[ERROR_NAME] = wrapErrorConstructorWithCause(ERROR_NAME, wrapper, FORCED);
  $({ global: true, constructor: true, arity: 1, forced: FORCED }, O);
};

var exportWebAssemblyErrorCauseWrapper = function (ERROR_NAME, wrapper) {
  if (WebAssembly && WebAssembly[ERROR_NAME]) {
    var O = {};
    O[ERROR_NAME] = wrapErrorConstructorWithCause(WEB_ASSEMBLY + '.' + ERROR_NAME, wrapper, FORCED);
    $({ target: WEB_ASSEMBLY, stat: true, constructor: true, arity: 1, forced: FORCED }, O);
  }
};

// https://tc39.es/ecma262/#sec-nativeerror
// https://github.com/tc39/proposal-error-cause
exportGlobalErrorCauseWrapper('Error', function (init) {
  return function Error(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('EvalError', function (init) {
  return function EvalError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('RangeError', function (init) {
  return function RangeError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('ReferenceError', function (init) {
  return function ReferenceError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('SyntaxError', function (init) {
  return function SyntaxError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('TypeError', function (init) {
  return function TypeError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('URIError', function (init) {
  return function URIError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('CompileError', function (init) {
  return function CompileError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('LinkError', function (init) {
  return function LinkError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('RuntimeError', function (init) {
  return function RuntimeError(message) { return apply(init, this, arguments); };
});

},{"../internals/export":652,"../internals/function-apply":657,"../internals/global":672,"../internals/wrap-error-constructor-with-cause":811}],867:[function(require,module,exports){
var defineBuiltIn = require('../internals/define-built-in');
var errorToString = require('../internals/error-to-string');

var ErrorPrototype = Error.prototype;

// `Error.prototype.toString` method fix
// https://tc39.es/ecma262/#sec-error.prototype.tostring
if (ErrorPrototype.toString !== errorToString) {
  defineBuiltIn(ErrorPrototype, 'toString', errorToString);
}

},{"../internals/define-built-in":623,"../internals/error-to-string":651}],868:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var uncurryThis = require('../internals/function-uncurry-this');
var toString = require('../internals/to-string');

var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var exec = uncurryThis(/./.exec);
var numberToString = uncurryThis(1.0.toString);
var toUpperCase = uncurryThis(''.toUpperCase);

var raw = /[\w*+\-./@]/;

var hex = function (code, length) {
  var result = numberToString(code, 16);
  while (result.length < length) result = '0' + result;
  return result;
};

// `escape` method
// https://tc39.es/ecma262/#sec-escape-string
$({ global: true }, {
  escape: function escape(string) {
    var str = toString(string);
    var result = '';
    var length = str.length;
    var index = 0;
    var chr, code;
    while (index < length) {
      chr = charAt(str, index++);
      if (exec(raw, chr)) {
        result += chr;
      } else {
        code = charCodeAt(chr, 0);
        if (code < 256) {
          result += '%' + hex(code, 2);
        } else {
          result += '%u' + toUpperCase(hex(code, 4));
        }
      }
    } return result;
  }
});

},{"../internals/export":652,"../internals/function-uncurry-this":665,"../internals/to-string":793}],869:[function(require,module,exports){
// TODO: Remove from `core-js@4`
var $ = require('../internals/export');
var bind = require('../internals/function-bind');

// `Function.prototype.bind` method
// https://tc39.es/ecma262/#sec-function.prototype.bind
// eslint-disable-next-line es/no-function-prototype-bind -- detection
$({ target: 'Function', proto: true, forced: Function.bind !== bind }, {
  bind: bind
});

},{"../internals/export":652,"../internals/function-bind":660}],870:[function(require,module,exports){
'use strict';
var isCallable = require('../internals/is-callable');
var isObject = require('../internals/is-object');
var definePropertyModule = require('../internals/object-define-property');
var getPrototypeOf = require('../internals/object-get-prototype-of');
var wellKnownSymbol = require('../internals/well-known-symbol');
var makeBuiltIn = require('../internals/make-built-in');

var HAS_INSTANCE = wellKnownSymbol('hasInstance');
var FunctionPrototype = Function.prototype;

// `Function.prototype[@@hasInstance]` method
// https://tc39.es/ecma262/#sec-function.prototype-@@hasinstance
if (!(HAS_INSTANCE in FunctionPrototype)) {
  definePropertyModule.f(FunctionPrototype, HAS_INSTANCE, { value: makeBuiltIn(function (O) {
    if (!isCallable(this) || !isObject(O)) return false;
    var P = this.prototype;
    if (!isObject(P)) return O instanceof this;
    // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
    while (O = getPrototypeOf(O)) if (P === O) return true;
    return false;
  }, HAS_INSTANCE) });
}

},{"../internals/is-callable":688,"../internals/is-object":694,"../internals/make-built-in":705,"../internals/object-define-property":723,"../internals/object-get-prototype-of":728,"../internals/well-known-symbol":809}],871:[function(require,module,exports){
var DESCRIPTORS = require('../internals/descriptors');
var FUNCTION_NAME_EXISTS = require('../internals/function-name').EXISTS;
var uncurryThis = require('../internals/function-uncurry-this');
var defineBuiltInAccessor = require('../internals/define-built-in-accessor');

var FunctionPrototype = Function.prototype;
var functionToString = uncurryThis(FunctionPrototype.toString);
var nameRE = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/;
var regExpExec = uncurryThis(nameRE.exec);
var NAME = 'name';

// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if (DESCRIPTORS && !FUNCTION_NAME_EXISTS) {
  defineBuiltInAccessor(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return regExpExec(nameRE, functionToString(this))[1];
      } catch (error) {
        return '';
      }
    }
  });
}

},{"../internals/define-built-in-accessor":622,"../internals/descriptors":627,"../internals/function-name":662,"../internals/function-uncurry-this":665}],872:[function(require,module,exports){
var $ = require('../internals/export');
var global = require('../internals/global');

// `globalThis` object
// https://tc39.es/ecma262/#sec-globalthis
$({ global: true, forced: global.globalThis !== global }, {
  globalThis: global
});

},{"../internals/export":652,"../internals/global":672}],873:[function(require,module,exports){
var $ = require('../internals/export');
var getBuiltIn = require('../internals/get-built-in');
var apply = require('../internals/function-apply');
var call = require('../internals/function-call');
var uncurryThis = require('../internals/function-uncurry-this');
var fails = require('../internals/fails');
var isCallable = require('../internals/is-callable');
var isSymbol = require('../internals/is-symbol');
var arraySlice = require('../internals/array-slice');
var getReplacerFunction = require('../internals/get-json-replacer-function');
var NATIVE_SYMBOL = require('../internals/symbol-constructor-detection');

var $String = String;
var $stringify = getBuiltIn('JSON', 'stringify');
var exec = uncurryThis(/./.exec);
var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var replace = uncurryThis(''.replace);
var numberToString = uncurryThis(1.0.toString);

var tester = /[\uD800-\uDFFF]/g;
var low = /^[\uD800-\uDBFF]$/;
var hi = /^[\uDC00-\uDFFF]$/;

var WRONG_SYMBOLS_CONVERSION = !NATIVE_SYMBOL || fails(function () {
  var symbol = getBuiltIn('Symbol')();
  // MS Edge converts symbol values to JSON as {}
  return $stringify([symbol]) != '[null]'
    // WebKit converts symbol values to JSON as null
    || $stringify({ a: symbol }) != '{}'
    // V8 throws on boxed symbols
    || $stringify(Object(symbol)) != '{}';
});

// https://github.com/tc39/proposal-well-formed-stringify
var ILL_FORMED_UNICODE = fails(function () {
  return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"'
    || $stringify('\uDEAD') !== '"\\udead"';
});

var stringifyWithSymbolsFix = function (it, replacer) {
  var args = arraySlice(arguments);
  var $replacer = getReplacerFunction(replacer);
  if (!isCallable($replacer) && (it === undefined || isSymbol(it))) return; // IE8 returns string on undefined
  args[1] = function (key, value) {
    // some old implementations (like WebKit) could pass numbers as keys
    if (isCallable($replacer)) value = call($replacer, this, $String(key), value);
    if (!isSymbol(value)) return value;
  };
  return apply($stringify, null, args);
};

var fixIllFormed = function (match, offset, string) {
  var prev = charAt(string, offset - 1);
  var next = charAt(string, offset + 1);
  if ((exec(low, match) && !exec(hi, next)) || (exec(hi, match) && !exec(low, prev))) {
    return '\\u' + numberToString(charCodeAt(match, 0), 16);
  } return match;
};

if ($stringify) {
  // `JSON.stringify` method
  // https://tc39.es/ecma262/#sec-json.stringify
  $({ target: 'JSON', stat: true, arity: 3, forced: WRONG_SYMBOLS_CONVERSION || ILL_FORMED_UNICODE }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = arraySlice(arguments);
      var result = apply(WRONG_SYMBOLS_CONVERSION ? stringifyWithSymbolsFix : $stringify, null, args);
      return ILL_FORMED_UNICODE && typeof result == 'string' ? replace(result, tester, fixIllFormed) : result;
    }
  });
}

},{"../internals/array-slice":598,"../internals/export":652,"../internals/fails":653,"../internals/function-apply":657,"../internals/function-call":661,"../internals/function-uncurry-this":665,"../internals/get-built-in":666,"../internals/get-json-replacer-function":669,"../internals/is-callable":688,"../internals/is-symbol":697,"../internals/symbol-constructor-detection":776}],874:[function(require,module,exports){
var global = require('../internals/global');
var setToStringTag = require('../internals/set-to-string-tag');

// JSON[@@toStringTag] property
// https://tc39.es/ecma262/#sec-json-@@tostringtag
setToStringTag(global.JSON, 'JSON', true);

},{"../internals/global":672,"../internals/set-to-string-tag":760}],875:[function(require,module,exports){
'use strict';
var collection = require('../internals/collection');
var collectionStrong = require('../internals/collection-strong');

// `Map` constructor
// https://tc39.es/ecma262/#sec-map-objects
collection('Map', function (init) {
  return function Map() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);

},{"../internals/collection":611,"../internals/collection-strong":609}],876:[function(require,module,exports){
// TODO: Remove this module from `core-js@4` since it's replaced to module below
require('../modules/es.map.constructor');

},{"../modules/es.map.constructor":875}],877:[function(require,module,exports){
var $ = require('../internals/export');
var log1p = require('../internals/math-log1p');

// eslint-disable-next-line es/no-math-acosh -- required for testing
var $acosh = Math.acosh;
var log = Math.log;
var sqrt = Math.sqrt;
var LN2 = Math.LN2;

var FORCED = !$acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  || Math.floor($acosh(Number.MAX_VALUE)) != 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  || $acosh(Infinity) != Infinity;

// `Math.acosh` method
// https://tc39.es/ecma262/#sec-math.acosh
$({ target: 'Math', stat: true, forced: FORCED }, {
  acosh: function acosh(x) {
    var n = +x;
    return n < 1 ? NaN : n > 94906265.62425156
      ? log(n) + LN2
      : log1p(n - 1 + sqrt(n - 1) * sqrt(n + 1));
  }
});

},{"../internals/export":652,"../internals/math-log1p":710}],878:[function(require,module,exports){
var $ = require('../internals/export');

// eslint-disable-next-line es/no-math-asinh -- required for testing
var $asinh = Math.asinh;
var log = Math.log;
var sqrt = Math.sqrt;

function asinh(x) {
  var n = +x;
  return !isFinite(n) || n == 0 ? n : n < 0 ? -asinh(-n) : log(n + sqrt(n * n + 1));
}

var FORCED = !($asinh && 1 / $asinh(0) > 0);

// `Math.asinh` method
// https://tc39.es/ecma262/#sec-math.asinh
// Tor Browser bug: Math.asinh(0) -> -0
$({ target: 'Math', stat: true, forced: FORCED }, {
  asinh: asinh
});

},{"../internals/export":652}],879:[function(require,module,exports){
var $ = require('../internals/export');

// eslint-disable-next-line es/no-math-atanh -- required for testing
var $atanh = Math.atanh;
var log = Math.log;

var FORCED = !($atanh && 1 / $atanh(-0) < 0);

// `Math.atanh` method
// https://tc39.es/ecma262/#sec-math.atanh
// Tor Browser bug: Math.atanh(-0) -> 0
$({ target: 'Math', stat: true, forced: FORCED }, {
  atanh: function atanh(x) {
    var n = +x;
    return n == 0 ? n : log((1 + n) / (1 - n)) / 2;
  }
});

},{"../internals/export":652}],880:[function(require,module,exports){
var $ = require('../internals/export');
var sign = require('../internals/math-sign');

var abs = Math.abs;
var pow = Math.pow;

// `Math.cbrt` method
// https://tc39.es/ecma262/#sec-math.cbrt
$({ target: 'Math', stat: true }, {
  cbrt: function cbrt(x) {
    var n = +x;
    return sign(n) * pow(abs(n), 1 / 3);
  }
});

},{"../internals/export":652,"../internals/math-sign":711}],881:[function(require,module,exports){
var $ = require('../internals/export');

var floor = Math.floor;
var log = Math.log;
var LOG2E = Math.LOG2E;

// `Math.clz32` method
// https://tc39.es/ecma262/#sec-math.clz32
$({ target: 'Math', stat: true }, {
  clz32: function clz32(x) {
    var n = x >>> 0;
    return n ? 31 - floor(log(n + 0.5) * LOG2E) : 32;
  }
});

},{"../internals/export":652}],882:[function(require,module,exports){
var $ = require('../internals/export');
var expm1 = require('../internals/math-expm1');

// eslint-disable-next-line es/no-math-cosh -- required for testing
var $cosh = Math.cosh;
var abs = Math.abs;
var E = Math.E;

var FORCED = !$cosh || $cosh(710) === Infinity;

// `Math.cosh` method
// https://tc39.es/ecma262/#sec-math.cosh
$({ target: 'Math', stat: true, forced: FORCED }, {
  cosh: function cosh(x) {
    var t = expm1(abs(x) - 1) + 1;
    return (t + 1 / (t * E * E)) * (E / 2);
  }
});

},{"../internals/export":652,"../internals/math-expm1":707}],883:[function(require,module,exports){
var $ = require('../internals/export');
var expm1 = require('../internals/math-expm1');

// `Math.expm1` method
// https://tc39.es/ecma262/#sec-math.expm1
// eslint-disable-next-line es/no-math-expm1 -- required for testing
$({ target: 'Math', stat: true, forced: expm1 != Math.expm1 }, { expm1: expm1 });

},{"../internals/export":652,"../internals/math-expm1":707}],884:[function(require,module,exports){
var $ = require('../internals/export');
var fround = require('../internals/math-fround');

// `Math.fround` method
// https://tc39.es/ecma262/#sec-math.fround
$({ target: 'Math', stat: true }, { fround: fround });

},{"../internals/export":652,"../internals/math-fround":708}],885:[function(require,module,exports){
var $ = require('../internals/export');

// eslint-disable-next-line es/no-math-hypot -- required for testing
var $hypot = Math.hypot;
var abs = Math.abs;
var sqrt = Math.sqrt;

// Chrome 77 bug
// https://bugs.chromium.org/p/v8/issues/detail?id=9546
var FORCED = !!$hypot && $hypot(Infinity, NaN) !== Infinity;

// `Math.hypot` method
// https://tc39.es/ecma262/#sec-math.hypot
$({ target: 'Math', stat: true, arity: 2, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  hypot: function hypot(value1, value2) {
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * sqrt(sum);
  }
});

},{"../internals/export":652}],886:[function(require,module,exports){
var $ = require('../internals/export');
var fails = require('../internals/fails');

// eslint-disable-next-line es/no-math-imul -- required for testing
var $imul = Math.imul;

var FORCED = fails(function () {
  return $imul(0xFFFFFFFF, 5) != -5 || $imul.length != 2;
});

// `Math.imul` method
// https://tc39.es/ecma262/#sec-math.imul
// some WebKit versions fails with big numbers, some has wrong arity
$({ target: 'Math', stat: true, forced: FORCED }, {
  imul: function imul(x, y) {
    var UINT16 = 0xFFFF;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});

},{"../internals/export":652,"../internals/fails":653}],887:[function(require,module,exports){
var $ = require('../internals/export');
var log10 = require('../internals/math-log10');

// `Math.log10` method
// https://tc39.es/ecma262/#sec-math.log10
$({ target: 'Math', stat: true }, {
  log10: log10
});

},{"../internals/export":652,"../internals/math-log10":709}],888:[function(require,module,exports){
var $ = require('../internals/export');
var log1p = require('../internals/math-log1p');

// `Math.log1p` method
// https://tc39.es/ecma262/#sec-math.log1p
$({ target: 'Math', stat: true }, { log1p: log1p });

},{"../internals/export":652,"../internals/math-log1p":710}],889:[function(require,module,exports){
var $ = require('../internals/export');

var log = Math.log;
var LN2 = Math.LN2;

// `Math.log2` method
// https://tc39.es/ecma262/#sec-math.log2
$({ target: 'Math', stat: true }, {
  log2: function log2(x) {
    return log(x) / LN2;
  }
});

},{"../internals/export":652}],890:[function(require,module,exports){
var $ = require('../internals/export');
var sign = require('../internals/math-sign');

// `Math.sign` method
// https://tc39.es/ecma262/#sec-math.sign
$({ target: 'Math', stat: true }, {
  sign: sign
});

},{"../internals/export":652,"../internals/math-sign":711}],891:[function(require,module,exports){
var $ = require('../internals/export');
var fails = require('../internals/fails');
var expm1 = require('../internals/math-expm1');

var abs = Math.abs;
var exp = Math.exp;
var E = Math.E;

var FORCED = fails(function () {
  // eslint-disable-next-line es/no-math-sinh -- required for testing
  return Math.sinh(-2e-17) != -2e-17;
});

// `Math.sinh` method
// https://tc39.es/ecma262/#sec-math.sinh
// V8 near Chromium 38 has a problem with very small numbers
$({ target: 'Math', stat: true, forced: FORCED }, {
  sinh: function sinh(x) {
    var n = +x;
    return abs(n) < 1 ? (expm1(n) - expm1(-n)) / 2 : (exp(n - 1) - exp(-n - 1)) * (E / 2);
  }
});

},{"../internals/export":652,"../internals/fails":653,"../internals/math-expm1":707}],892:[function(require,module,exports){
var $ = require('../internals/export');
var expm1 = require('../internals/math-expm1');

var exp = Math.exp;

// `Math.tanh` method
// https://tc39.es/ecma262/#sec-math.tanh
$({ target: 'Math', stat: true }, {
  tanh: function tanh(x) {
    var n = +x;
    var a = expm1(n);
    var b = expm1(-n);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(n) + exp(-n));
  }
});

},{"../internals/export":652,"../internals/math-expm1":707}],893:[function(require,module,exports){
var setToStringTag = require('../internals/set-to-string-tag');

// Math[@@toStringTag] property
// https://tc39.es/ecma262/#sec-math-@@tostringtag
setToStringTag(Math, 'Math', true);

},{"../internals/set-to-string-tag":760}],894:[function(require,module,exports){
var $ = require('../internals/export');
var trunc = require('../internals/math-trunc');

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
$({ target: 'Math', stat: true }, {
  trunc: trunc
});

},{"../internals/export":652,"../internals/math-trunc":712}],895:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var IS_PURE = require('../internals/is-pure');
var DESCRIPTORS = require('../internals/descriptors');
var global = require('../internals/global');
var path = require('../internals/path');
var uncurryThis = require('../internals/function-uncurry-this');
var isForced = require('../internals/is-forced');
var hasOwn = require('../internals/has-own-property');
var inheritIfRequired = require('../internals/inherit-if-required');
var isPrototypeOf = require('../internals/object-is-prototype-of');
var isSymbol = require('../internals/is-symbol');
var toPrimitive = require('../internals/to-primitive');
var fails = require('../internals/fails');
var getOwnPropertyNames = require('../internals/object-get-own-property-names').f;
var getOwnPropertyDescriptor = require('../internals/object-get-own-property-descriptor').f;
var defineProperty = require('../internals/object-define-property').f;
var thisNumberValue = require('../internals/this-number-value');
var trim = require('../internals/string-trim').trim;

var NUMBER = 'Number';
var NativeNumber = global[NUMBER];
var PureNumberNamespace = path[NUMBER];
var NumberPrototype = NativeNumber.prototype;
var TypeError = global.TypeError;
var stringSlice = uncurryThis(''.slice);
var charCodeAt = uncurryThis(''.charCodeAt);

// `ToNumeric` abstract operation
// https://tc39.es/ecma262/#sec-tonumeric
var toNumeric = function (value) {
  var primValue = toPrimitive(value, 'number');
  return typeof primValue == 'bigint' ? primValue : toNumber(primValue);
};

// `ToNumber` abstract operation
// https://tc39.es/ecma262/#sec-tonumber
var toNumber = function (argument) {
  var it = toPrimitive(argument, 'number');
  var first, third, radix, maxCode, digits, length, index, code;
  if (isSymbol(it)) throw TypeError('Cannot convert a Symbol value to a number');
  if (typeof it == 'string' && it.length > 2) {
    it = trim(it);
    first = charCodeAt(it, 0);
    if (first === 43 || first === 45) {
      third = charCodeAt(it, 2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (charCodeAt(it, 1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal of /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal of /^0o[0-7]+$/i
        default: return +it;
      }
      digits = stringSlice(it, 2);
      length = digits.length;
      for (index = 0; index < length; index++) {
        code = charCodeAt(digits, index);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

var FORCED = isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'));

var calledWithNew = function (dummy) {
  // includes check on 1..constructor(foo) case
  return isPrototypeOf(NumberPrototype, dummy) && fails(function () { thisNumberValue(dummy); });
};

// `Number` constructor
// https://tc39.es/ecma262/#sec-number-constructor
var NumberWrapper = function Number(value) {
  var n = arguments.length < 1 ? 0 : NativeNumber(toNumeric(value));
  return calledWithNew(this) ? inheritIfRequired(Object(n), this, NumberWrapper) : n;
};

NumberWrapper.prototype = NumberPrototype;
if (FORCED && !IS_PURE) NumberPrototype.constructor = NumberWrapper;

$({ global: true, constructor: true, wrap: true, forced: FORCED }, {
  Number: NumberWrapper
});

// Use `internal/copy-constructor-properties` helper in `core-js@4`
var copyConstructorProperties = function (target, source) {
  for (var keys = DESCRIPTORS ? getOwnPropertyNames(source) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES2015 (in case, if modules with ES2015 Number statics required before):
    'EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,' +
    // ESNext
    'fromString,range'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (hasOwn(source, key = keys[j]) && !hasOwn(target, key)) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

if (IS_PURE && PureNumberNamespace) copyConstructorProperties(path[NUMBER], PureNumberNamespace);
if (FORCED || IS_PURE) copyConstructorProperties(path[NUMBER], NativeNumber);

},{"../internals/descriptors":627,"../internals/export":652,"../internals/fails":653,"../internals/function-uncurry-this":665,"../internals/global":672,"../internals/has-own-property":673,"../internals/inherit-if-required":680,"../internals/is-forced":691,"../internals/is-pure":695,"../internals/is-symbol":697,"../internals/object-define-property":723,"../internals/object-get-own-property-descriptor":724,"../internals/object-get-own-property-names":726,"../internals/object-is-prototype-of":730,"../internals/path":740,"../internals/string-trim":774,"../internals/this-number-value":780,"../internals/to-primitive":790}],896:[function(require,module,exports){
var $ = require('../internals/export');

// `Number.EPSILON` constant
// https://tc39.es/ecma262/#sec-number.epsilon
$({ target: 'Number', stat: true, nonConfigurable: true, nonWritable: true }, {
  EPSILON: Math.pow(2, -52)
});

},{"../internals/export":652}],897:[function(require,module,exports){
var $ = require('../internals/export');
var numberIsFinite = require('../internals/number-is-finite');

// `Number.isFinite` method
// https://tc39.es/ecma262/#sec-number.isfinite
$({ target: 'Number', stat: true }, { isFinite: numberIsFinite });

},{"../internals/export":652,"../internals/number-is-finite":717}],898:[function(require,module,exports){
var $ = require('../internals/export');
var isIntegralNumber = require('../internals/is-integral-number');

// `Number.isInteger` method
// https://tc39.es/ecma262/#sec-number.isinteger
$({ target: 'Number', stat: true }, {
  isInteger: isIntegralNumber
});

},{"../internals/export":652,"../internals/is-integral-number":692}],899:[function(require,module,exports){
var $ = require('../internals/export');

// `Number.isNaN` method
// https://tc39.es/ecma262/#sec-number.isnan
$({ target: 'Number', stat: true }, {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare -- NaN check
    return number != number;
  }
});

},{"../internals/export":652}],900:[function(require,module,exports){
var $ = require('../internals/export');
var isIntegralNumber = require('../internals/is-integral-number');

var abs = Math.abs;

// `Number.isSafeInteger` method
// https://tc39.es/ecma262/#sec-number.issafeinteger
$({ target: 'Number', stat: true }, {
  isSafeInteger: function isSafeInteger(number) {
    return isIntegralNumber(number) && abs(number) <= 0x1FFFFFFFFFFFFF;
  }
});

},{"../internals/export":652,"../internals/is-integral-number":692}],901:[function(require,module,exports){
var $ = require('../internals/export');

// `Number.MAX_SAFE_INTEGER` constant
// https://tc39.es/ecma262/#sec-number.max_safe_integer
$({ target: 'Number', stat: true, nonConfigurable: true, nonWritable: true }, {
  MAX_SAFE_INTEGER: 0x1FFFFFFFFFFFFF
});

},{"../internals/export":652}],902:[function(require,module,exports){
var $ = require('../internals/export');

// `Number.MIN_SAFE_INTEGER` constant
// https://tc39.es/ecma262/#sec-number.min_safe_integer
$({ target: 'Number', stat: true, nonConfigurable: true, nonWritable: true }, {
  MIN_SAFE_INTEGER: -0x1FFFFFFFFFFFFF
});

},{"../internals/export":652}],903:[function(require,module,exports){
var $ = require('../internals/export');
var parseFloat = require('../internals/number-parse-float');

// `Number.parseFloat` method
// https://tc39.es/ecma262/#sec-number.parseFloat
// eslint-disable-next-line es/no-number-parsefloat -- required for testing
$({ target: 'Number', stat: true, forced: Number.parseFloat != parseFloat }, {
  parseFloat: parseFloat
});

},{"../internals/export":652,"../internals/number-parse-float":718}],904:[function(require,module,exports){
var $ = require('../internals/export');
var parseInt = require('../internals/number-parse-int');

// `Number.parseInt` method
// https://tc39.es/ecma262/#sec-number.parseint
// eslint-disable-next-line es/no-number-parseint -- required for testing
$({ target: 'Number', stat: true, forced: Number.parseInt != parseInt }, {
  parseInt: parseInt
});

},{"../internals/export":652,"../internals/number-parse-int":719}],905:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var uncurryThis = require('../internals/function-uncurry-this');
var toIntegerOrInfinity = require('../internals/to-integer-or-infinity');
var thisNumberValue = require('../internals/this-number-value');
var $repeat = require('../internals/string-repeat');
var log10 = require('../internals/math-log10');
var fails = require('../internals/fails');

var $RangeError = RangeError;
var $String = String;
var $isFinite = isFinite;
var abs = Math.abs;
var floor = Math.floor;
var pow = Math.pow;
var round = Math.round;
var nativeToExponential = uncurryThis(1.0.toExponential);
var repeat = uncurryThis($repeat);
var stringSlice = uncurryThis(''.slice);

// Edge 17-
var ROUNDS_PROPERLY = nativeToExponential(-6.9e-11, 4) === '-6.9000e-11'
  // IE11- && Edge 14-
  && nativeToExponential(1.255, 2) === '1.25e+0'
  // FF86-, V8 ~ Chrome 49-50
  && nativeToExponential(12345, 3) === '1.235e+4'
  // FF86-, V8 ~ Chrome 49-50
  && nativeToExponential(25, 0) === '3e+1';

// IE8-
var throwsOnInfinityFraction = function () {
  return fails(function () {
    nativeToExponential(1, Infinity);
  }) && fails(function () {
    nativeToExponential(1, -Infinity);
  });
};

// Safari <11 && FF <50
var properNonFiniteThisCheck = function () {
  return !fails(function () {
    nativeToExponential(Infinity, Infinity);
    nativeToExponential(NaN, Infinity);
  });
};

var FORCED = !ROUNDS_PROPERLY || !throwsOnInfinityFraction() || !properNonFiniteThisCheck();

// `Number.prototype.toExponential` method
// https://tc39.es/ecma262/#sec-number.prototype.toexponential
$({ target: 'Number', proto: true, forced: FORCED }, {
  toExponential: function toExponential(fractionDigits) {
    var x = thisNumberValue(this);
    if (fractionDigits === undefined) return nativeToExponential(x);
    var f = toIntegerOrInfinity(fractionDigits);
    if (!$isFinite(x)) return String(x);
    // TODO: ES2018 increased the maximum number of fraction digits to 100, need to improve the implementation
    if (f < 0 || f > 20) throw $RangeError('Incorrect fraction digits');
    if (ROUNDS_PROPERLY) return nativeToExponential(x, f);
    var s = '';
    var m = '';
    var e = 0;
    var c = '';
    var d = '';
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x === 0) {
      e = 0;
      m = repeat('0', f + 1);
    } else {
      // this block is based on https://gist.github.com/SheetJSDev/1100ad56b9f856c95299ed0e068eea08
      // TODO: improve accuracy with big fraction digits
      var l = log10(x);
      e = floor(l);
      var n = 0;
      var w = pow(10, e - f);
      n = round(x / w);
      if (2 * x >= (2 * n + 1) * w) {
        n += 1;
      }
      if (n >= pow(10, f + 1)) {
        n /= 10;
        e += 1;
      }
      m = $String(n);
    }
    if (f !== 0) {
      m = stringSlice(m, 0, 1) + '.' + stringSlice(m, 1);
    }
    if (e === 0) {
      c = '+';
      d = '0';
    } else {
      c = e > 0 ? '+' : '-';
      d = $String(abs(e));
    }
    m += 'e' + c + d;
    return s + m;
  }
});

},{"../internals/export":652,"../internals/fails":653,"../internals/function-uncurry-this":665,"../internals/math-log10":709,"../internals/string-repeat":770,"../internals/this-number-value":780,"../internals/to-integer-or-infinity":785}],906:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var uncurryThis = require('../internals/function-uncurry-this');
var toIntegerOrInfinity = require('../internals/to-integer-or-infinity');
var thisNumberValue = require('../internals/this-number-value');
var $repeat = require('../internals/string-repeat');
var fails = require('../internals/fails');

var $RangeError = RangeError;
var $String = String;
var floor = Math.floor;
var repeat = uncurryThis($repeat);
var stringSlice = uncurryThis(''.slice);
var nativeToFixed = uncurryThis(1.0.toFixed);

var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};

var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

var multiply = function (data, n, c) {
  var index = -1;
  var c2 = c;
  while (++index < 6) {
    c2 += n * data[index];
    data[index] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};

var divide = function (data, n) {
  var index = 6;
  var c = 0;
  while (--index >= 0) {
    c += data[index];
    data[index] = floor(c / n);
    c = (c % n) * 1e7;
  }
};

var dataToString = function (data) {
  var index = 6;
  var s = '';
  while (--index >= 0) {
    if (s !== '' || index === 0 || data[index] !== 0) {
      var t = $String(data[index]);
      s = s === '' ? t : s + repeat('0', 7 - t.length) + t;
    }
  } return s;
};

var FORCED = fails(function () {
  return nativeToFixed(0.00008, 3) !== '0.000' ||
    nativeToFixed(0.9, 0) !== '1' ||
    nativeToFixed(1.255, 2) !== '1.25' ||
    nativeToFixed(1000000000000000128.0, 0) !== '1000000000000000128';
}) || !fails(function () {
  // V8 ~ Android 4.3-
  nativeToFixed({});
});

// `Number.prototype.toFixed` method
// https://tc39.es/ecma262/#sec-number.prototype.tofixed
$({ target: 'Number', proto: true, forced: FORCED }, {
  toFixed: function toFixed(fractionDigits) {
    var number = thisNumberValue(this);
    var fractDigits = toIntegerOrInfinity(fractionDigits);
    var data = [0, 0, 0, 0, 0, 0];
    var sign = '';
    var result = '0';
    var e, z, j, k;

    // TODO: ES2018 increased the maximum number of fraction digits to 100, need to improve the implementation
    if (fractDigits < 0 || fractDigits > 20) throw $RangeError('Incorrect fraction digits');
    // eslint-disable-next-line no-self-compare -- NaN check
    if (number != number) return 'NaN';
    if (number <= -1e21 || number >= 1e21) return $String(number);
    if (number < 0) {
      sign = '-';
      number = -number;
    }
    if (number > 1e-21) {
      e = log(number * pow(2, 69, 1)) - 69;
      z = e < 0 ? number * pow(2, -e, 1) : number / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(data, 0, z);
        j = fractDigits;
        while (j >= 7) {
          multiply(data, 1e7, 0);
          j -= 7;
        }
        multiply(data, pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(data, 1 << 23);
          j -= 23;
        }
        divide(data, 1 << j);
        multiply(data, 1, 1);
        divide(data, 2);
        result = dataToString(data);
      } else {
        multiply(data, 0, z);
        multiply(data, 1 << -e, 0);
        result = dataToString(data) + repeat('0', fractDigits);
      }
    }
    if (fractDigits > 0) {
      k = result.length;
      result = sign + (k <= fractDigits
        ? '0.' + repeat('0', fractDigits - k) + result
        : stringSlice(result, 0, k - fractDigits) + '.' + stringSlice(result, k - fractDigits));
    } else {
      result = sign + result;
    } return result;
  }
});

},{"../internals/export":652,"../internals/fails":653,"../internals/function-uncurry-this":665,"../internals/string-repeat":770,"../internals/this-number-value":780,"../internals/to-integer-or-infinity":785}],907:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var uncurryThis = require('../internals/function-uncurry-this');
var fails = require('../internals/fails');
var thisNumberValue = require('../internals/this-number-value');

var nativeToPrecision = uncurryThis(1.0.toPrecision);

var FORCED = fails(function () {
  // IE7-
  return nativeToPrecision(1, undefined) !== '1';
}) || !fails(function () {
  // V8 ~ Android 4.3-
  nativeToPrecision({});
});

// `Number.prototype.toPrecision` method
// https://tc39.es/ecma262/#sec-number.prototype.toprecision
$({ target: 'Number', proto: true, forced: FORCED }, {
  toPrecision: function toPrecision(precision) {
    return precision === undefined
      ? nativeToPrecision(thisNumberValue(this))
      : nativeToPrecision(thisNumberValue(this), precision);
  }
});

},{"../internals/export":652,"../internals/fails":653,"../internals/function-uncurry-this":665,"../internals/this-number-value":780}],908:[function(require,module,exports){
var $ = require('../internals/export');
var assign = require('../internals/object-assign');

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign }, {
  assign: assign
});

},{"../internals/export":652,"../internals/object-assign":720}],909:[function(require,module,exports){
// TODO: Remove from `core-js@4`
var $ = require('../internals/export');
var DESCRIPTORS = require('../internals/descriptors');
var create = require('../internals/object-create');

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
$({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
  create: create
});

},{"../internals/descriptors":627,"../internals/export":652,"../internals/object-create":721}],910:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var DESCRIPTORS = require('../internals/descriptors');
var FORCED = require('../internals/object-prototype-accessors-forced');
var aCallable = require('../internals/a-callable');
var toObject = require('../internals/to-object');
var definePropertyModule = require('../internals/object-define-property');

// `Object.prototype.__defineGetter__` method
// https://tc39.es/ecma262/#sec-object.prototype.__defineGetter__
if (DESCRIPTORS) {
  $({ target: 'Object', proto: true, forced: FORCED }, {
    __defineGetter__: function __defineGetter__(P, getter) {
      definePropertyModule.f(toObject(this), P, { get: aCallable(getter), enumerable: true, configurable: true });
    }
  });
}

},{"../internals/a-callable":573,"../internals/descriptors":627,"../internals/export":652,"../internals/object-define-property":723,"../internals/object-prototype-accessors-forced":734,"../internals/to-object":787}],911:[function(require,module,exports){
var $ = require('../internals/export');
var DESCRIPTORS = require('../internals/descriptors');
var defineProperties = require('../internals/object-define-properties').f;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
$({ target: 'Object', stat: true, forced: Object.defineProperties !== defineProperties, sham: !DESCRIPTORS }, {
  defineProperties: defineProperties
});

},{"../internals/descriptors":627,"../internals/export":652,"../internals/object-define-properties":722}],912:[function(require,module,exports){
var $ = require('../internals/export');
var DESCRIPTORS = require('../internals/descriptors');
var defineProperty = require('../internals/object-define-property').f;

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
// eslint-disable-next-line es/no-object-defineproperty -- safe
$({ target: 'Object', stat: true, forced: Object.defineProperty !== defineProperty, sham: !DESCRIPTORS }, {
  defineProperty: defineProperty
});

},{"../internals/descriptors":627,"../internals/export":652,"../internals/object-define-property":723}],913:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var DESCRIPTORS = require('../internals/descriptors');
var FORCED = require('../internals/object-prototype-accessors-forced');
var aCallable = require('../internals/a-callable');
var toObject = require('../internals/to-object');
var definePropertyModule = require('../internals/object-define-property');

// `Object.prototype.__defineSetter__` method
// https://tc39.es/ecma262/#sec-object.prototype.__defineSetter__
if (DESCRIPTORS) {
  $({ target: 'Object', proto: true, forced: FORCED }, {
    __defineSetter__: function __defineSetter__(P, setter) {
      definePropertyModule.f(toObject(this), P, { set: aCallable(setter), enumerable: true, configurable: true });
    }
  });
}

},{"../internals/a-callable":573,"../internals/descriptors":627,"../internals/export":652,"../internals/object-define-property":723,"../internals/object-prototype-accessors-forced":734,"../internals/to-object":787}],914:[function(require,module,exports){
var $ = require('../internals/export');
var $entries = require('../internals/object-to-array').entries;

// `Object.entries` method
// https://tc39.es/ecma262/#sec-object.entries
$({ target: 'Object', stat: true }, {
  entries: function entries(O) {
    return $entries(O);
  }
});

},{"../internals/export":652,"../internals/object-to-array":736}],915:[function(require,module,exports){
var $ = require('../internals/export');
var FREEZING = require('../internals/freezing');
var fails = require('../internals/fails');
var isObject = require('../internals/is-object');
var onFreeze = require('../internals/internal-metadata').onFreeze;

// eslint-disable-next-line es/no-object-freeze -- safe
var $freeze = Object.freeze;
var FAILS_ON_PRIMITIVES = fails(function () { $freeze(1); });

// `Object.freeze` method
// https://tc39.es/ecma262/#sec-object.freeze
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !FREEZING }, {
  freeze: function freeze(it) {
    return $freeze && isObject(it) ? $freeze(onFreeze(it)) : it;
  }
});

},{"../internals/export":652,"../internals/fails":653,"../internals/freezing":656,"../internals/internal-metadata":683,"../internals/is-object":694}],916:[function(require,module,exports){
var $ = require('../internals/export');
var iterate = require('../internals/iterate');
var createProperty = require('../internals/create-property');

// `Object.fromEntries` method
// https://github.com/tc39/proposal-object-from-entries
$({ target: 'Object', stat: true }, {
  fromEntries: function fromEntries(iterable) {
    var obj = {};
    iterate(iterable, function (k, v) {
      createProperty(obj, k, v);
    }, { AS_ENTRIES: true });
    return obj;
  }
});

},{"../internals/create-property":619,"../internals/export":652,"../internals/iterate":698}],917:[function(require,module,exports){
var $ = require('../internals/export');
var fails = require('../internals/fails');
var toIndexedObject = require('../internals/to-indexed-object');
var nativeGetOwnPropertyDescriptor = require('../internals/object-get-own-property-descriptor').f;
var DESCRIPTORS = require('../internals/descriptors');

var FORCED = !DESCRIPTORS || fails(function () { nativeGetOwnPropertyDescriptor(1); });

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$({ target: 'Object', stat: true, forced: FORCED, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
  }
});

},{"../internals/descriptors":627,"../internals/export":652,"../internals/fails":653,"../internals/object-get-own-property-descriptor":724,"../internals/to-indexed-object":784}],918:[function(require,module,exports){
var $ = require('../internals/export');
var DESCRIPTORS = require('../internals/descriptors');
var ownKeys = require('../internals/own-keys');
var toIndexedObject = require('../internals/to-indexed-object');
var getOwnPropertyDescriptorModule = require('../internals/object-get-own-property-descriptor');
var createProperty = require('../internals/create-property');

// `Object.getOwnPropertyDescriptors` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
$({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIndexedObject(object);
    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
    var keys = ownKeys(O);
    var result = {};
    var index = 0;
    var key, descriptor;
    while (keys.length > index) {
      descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
      if (descriptor !== undefined) createProperty(result, key, descriptor);
    }
    return result;
  }
});

},{"../internals/create-property":619,"../internals/descriptors":627,"../internals/export":652,"../internals/object-get-own-property-descriptor":724,"../internals/own-keys":739,"../internals/to-indexed-object":784}],919:[function(require,module,exports){
var $ = require('../internals/export');
var fails = require('../internals/fails');
var getOwnPropertyNames = require('../internals/object-get-own-property-names-external').f;

// eslint-disable-next-line es/no-object-getownpropertynames -- required for testing
var FAILS_ON_PRIMITIVES = fails(function () { return !Object.getOwnPropertyNames(1); });

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  getOwnPropertyNames: getOwnPropertyNames
});

},{"../internals/export":652,"../internals/fails":653,"../internals/object-get-own-property-names-external":725}],920:[function(require,module,exports){
var $ = require('../internals/export');
var NATIVE_SYMBOL = require('../internals/symbol-constructor-detection');
var fails = require('../internals/fails');
var getOwnPropertySymbolsModule = require('../internals/object-get-own-property-symbols');
var toObject = require('../internals/to-object');

// V8 ~ Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FORCED = !NATIVE_SYMBOL || fails(function () { getOwnPropertySymbolsModule.f(1); });

// `Object.getOwnPropertySymbols` method
// https://tc39.es/ecma262/#sec-object.getownpropertysymbols
$({ target: 'Object', stat: true, forced: FORCED }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    var $getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
    return $getOwnPropertySymbols ? $getOwnPropertySymbols(toObject(it)) : [];
  }
});

},{"../internals/export":652,"../internals/fails":653,"../internals/object-get-own-property-symbols":727,"../internals/symbol-constructor-detection":776,"../internals/to-object":787}],921:[function(require,module,exports){
var $ = require('../internals/export');
var fails = require('../internals/fails');
var toObject = require('../internals/to-object');
var nativeGetPrototypeOf = require('../internals/object-get-prototype-of');
var CORRECT_PROTOTYPE_GETTER = require('../internals/correct-prototype-getter');

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetPrototypeOf(1); });

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !CORRECT_PROTOTYPE_GETTER }, {
  getPrototypeOf: function getPrototypeOf(it) {
    return nativeGetPrototypeOf(toObject(it));
  }
});


},{"../internals/correct-prototype-getter":614,"../internals/export":652,"../internals/fails":653,"../internals/object-get-prototype-of":728,"../internals/to-object":787}],922:[function(require,module,exports){
var $ = require('../internals/export');
var hasOwn = require('../internals/has-own-property');

// `Object.hasOwn` method
// https://github.com/tc39/proposal-accessible-object-hasownproperty
$({ target: 'Object', stat: true }, {
  hasOwn: hasOwn
});

},{"../internals/export":652,"../internals/has-own-property":673}],923:[function(require,module,exports){
var $ = require('../internals/export');
var $isExtensible = require('../internals/object-is-extensible');

// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
// eslint-disable-next-line es/no-object-isextensible -- safe
$({ target: 'Object', stat: true, forced: Object.isExtensible !== $isExtensible }, {
  isExtensible: $isExtensible
});

},{"../internals/export":652,"../internals/object-is-extensible":729}],924:[function(require,module,exports){
var $ = require('../internals/export');
var fails = require('../internals/fails');
var isObject = require('../internals/is-object');
var classof = require('../internals/classof-raw');
var ARRAY_BUFFER_NON_EXTENSIBLE = require('../internals/array-buffer-non-extensible');

// eslint-disable-next-line es/no-object-isfrozen -- safe
var $isFrozen = Object.isFrozen;

var FORCED = ARRAY_BUFFER_NON_EXTENSIBLE || fails(function () { $isFrozen(1); });

// `Object.isFrozen` method
// https://tc39.es/ecma262/#sec-object.isfrozen
$({ target: 'Object', stat: true, forced: FORCED }, {
  isFrozen: function isFrozen(it) {
    if (!isObject(it)) return true;
    if (ARRAY_BUFFER_NON_EXTENSIBLE && classof(it) == 'ArrayBuffer') return true;
    return $isFrozen ? $isFrozen(it) : false;
  }
});

},{"../internals/array-buffer-non-extensible":581,"../internals/classof-raw":607,"../internals/export":652,"../internals/fails":653,"../internals/is-object":694}],925:[function(require,module,exports){
var $ = require('../internals/export');
var fails = require('../internals/fails');
var isObject = require('../internals/is-object');
var classof = require('../internals/classof-raw');
var ARRAY_BUFFER_NON_EXTENSIBLE = require('../internals/array-buffer-non-extensible');

// eslint-disable-next-line es/no-object-issealed -- safe
var $isSealed = Object.isSealed;

var FORCED = ARRAY_BUFFER_NON_EXTENSIBLE || fails(function () { $isSealed(1); });

// `Object.isSealed` method
// https://tc39.es/ecma262/#sec-object.issealed
$({ target: 'Object', stat: true, forced: FORCED }, {
  isSealed: function isSealed(it) {
    if (!isObject(it)) return true;
    if (ARRAY_BUFFER_NON_EXTENSIBLE && classof(it) == 'ArrayBuffer') return true;
    return $isSealed ? $isSealed(it) : false;
  }
});

},{"../internals/array-buffer-non-extensible":581,"../internals/classof-raw":607,"../internals/export":652,"../internals/fails":653,"../internals/is-object":694}],926:[function(require,module,exports){
var $ = require('../internals/export');
var is = require('../internals/same-value');

// `Object.is` method
// https://tc39.es/ecma262/#sec-object.is
$({ target: 'Object', stat: true }, {
  is: is
});

},{"../internals/export":652,"../internals/same-value":756}],927:[function(require,module,exports){
var $ = require('../internals/export');
var toObject = require('../internals/to-object');
var nativeKeys = require('../internals/object-keys');
var fails = require('../internals/fails');

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});

},{"../internals/export":652,"../internals/fails":653,"../internals/object-keys":732,"../internals/to-object":787}],928:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var DESCRIPTORS = require('../internals/descriptors');
var FORCED = require('../internals/object-prototype-accessors-forced');
var toObject = require('../internals/to-object');
var toPropertyKey = require('../internals/to-property-key');
var getPrototypeOf = require('../internals/object-get-prototype-of');
var getOwnPropertyDescriptor = require('../internals/object-get-own-property-descriptor').f;

// `Object.prototype.__lookupGetter__` method
// https://tc39.es/ecma262/#sec-object.prototype.__lookupGetter__
if (DESCRIPTORS) {
  $({ target: 'Object', proto: true, forced: FORCED }, {
    __lookupGetter__: function __lookupGetter__(P) {
      var O = toObject(this);
      var key = toPropertyKey(P);
      var desc;
      do {
        if (desc = getOwnPropertyDescriptor(O, key)) return desc.get;
      } while (O = getPrototypeOf(O));
    }
  });
}

},{"../internals/descriptors":627,"../internals/export":652,"../internals/object-get-own-property-descriptor":724,"../internals/object-get-prototype-of":728,"../internals/object-prototype-accessors-forced":734,"../internals/to-object":787,"../internals/to-property-key":791}],929:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var DESCRIPTORS = require('../internals/descriptors');
var FORCED = require('../internals/object-prototype-accessors-forced');
var toObject = require('../internals/to-object');
var toPropertyKey = require('../internals/to-property-key');
var getPrototypeOf = require('../internals/object-get-prototype-of');
var getOwnPropertyDescriptor = require('../internals/object-get-own-property-descriptor').f;

// `Object.prototype.__lookupSetter__` method
// https://tc39.es/ecma262/#sec-object.prototype.__lookupSetter__
if (DESCRIPTORS) {
  $({ target: 'Object', proto: true, forced: FORCED }, {
    __lookupSetter__: function __lookupSetter__(P) {
      var O = toObject(this);
      var key = toPropertyKey(P);
      var desc;
      do {
        if (desc = getOwnPropertyDescriptor(O, key)) return desc.set;
      } while (O = getPrototypeOf(O));
    }
  });
}

},{"../internals/descriptors":627,"../internals/export":652,"../internals/object-get-own-property-descriptor":724,"../internals/object-get-prototype-of":728,"../internals/object-prototype-accessors-forced":734,"../internals/to-object":787,"../internals/to-property-key":791}],930:[function(require,module,exports){
var $ = require('../internals/export');
var isObject = require('../internals/is-object');
var onFreeze = require('../internals/internal-metadata').onFreeze;
var FREEZING = require('../internals/freezing');
var fails = require('../internals/fails');

// eslint-disable-next-line es/no-object-preventextensions -- safe
var $preventExtensions = Object.preventExtensions;
var FAILS_ON_PRIMITIVES = fails(function () { $preventExtensions(1); });

// `Object.preventExtensions` method
// https://tc39.es/ecma262/#sec-object.preventextensions
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !FREEZING }, {
  preventExtensions: function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(onFreeze(it)) : it;
  }
});

},{"../internals/export":652,"../internals/fails":653,"../internals/freezing":656,"../internals/internal-metadata":683,"../internals/is-object":694}],931:[function(require,module,exports){
'use strict';
var DESCRIPTORS = require('../internals/descriptors');
var defineBuiltInAccessor = require('../internals/define-built-in-accessor');
var isObject = require('../internals/is-object');
var toObject = require('../internals/to-object');
var requireObjectCoercible = require('../internals/require-object-coercible');

// eslint-disable-next-line es/no-object-getprototypeof -- safe
var getPrototypeOf = Object.getPrototypeOf;
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var setPrototypeOf = Object.setPrototypeOf;
var ObjectPrototype = Object.prototype;
var PROTO = '__proto__';

// `Object.prototype.__proto__` accessor
// https://tc39.es/ecma262/#sec-object.prototype.__proto__
if (DESCRIPTORS && getPrototypeOf && setPrototypeOf && !(PROTO in ObjectPrototype)) try {
  defineBuiltInAccessor(ObjectPrototype, PROTO, {
    configurable: true,
    get: function __proto__() {
      return getPrototypeOf(toObject(this));
    },
    set: function __proto__(proto) {
      var O = requireObjectCoercible(this);
      if (!isObject(proto) && proto !== null || !isObject(O)) return;
      setPrototypeOf(O, proto);
    }
  });
} catch (error) { /* empty */ }

},{"../internals/define-built-in-accessor":622,"../internals/descriptors":627,"../internals/is-object":694,"../internals/require-object-coercible":755,"../internals/to-object":787}],932:[function(require,module,exports){
var $ = require('../internals/export');
var isObject = require('../internals/is-object');
var onFreeze = require('../internals/internal-metadata').onFreeze;
var FREEZING = require('../internals/freezing');
var fails = require('../internals/fails');

// eslint-disable-next-line es/no-object-seal -- safe
var $seal = Object.seal;
var FAILS_ON_PRIMITIVES = fails(function () { $seal(1); });

// `Object.seal` method
// https://tc39.es/ecma262/#sec-object.seal
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !FREEZING }, {
  seal: function seal(it) {
    return $seal && isObject(it) ? $seal(onFreeze(it)) : it;
  }
});

},{"../internals/export":652,"../internals/fails":653,"../internals/freezing":656,"../internals/internal-metadata":683,"../internals/is-object":694}],933:[function(require,module,exports){
var $ = require('../internals/export');
var setPrototypeOf = require('../internals/object-set-prototype-of');

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
$({ target: 'Object', stat: true }, {
  setPrototypeOf: setPrototypeOf
});

},{"../internals/export":652,"../internals/object-set-prototype-of":735}],934:[function(require,module,exports){
var TO_STRING_TAG_SUPPORT = require('../internals/to-string-tag-support');
var defineBuiltIn = require('../internals/define-built-in');
var toString = require('../internals/object-to-string');

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  defineBuiltIn(Object.prototype, 'toString', toString, { unsafe: true });
}

},{"../internals/define-built-in":623,"../internals/object-to-string":737,"../internals/to-string-tag-support":792}],935:[function(require,module,exports){
var $ = require('../internals/export');
var $values = require('../internals/object-to-array').values;

// `Object.values` method
// https://tc39.es/ecma262/#sec-object.values
$({ target: 'Object', stat: true }, {
  values: function values(O) {
    return $values(O);
  }
});

},{"../internals/export":652,"../internals/object-to-array":736}],936:[function(require,module,exports){
var $ = require('../internals/export');
var $parseFloat = require('../internals/number-parse-float');

// `parseFloat` method
// https://tc39.es/ecma262/#sec-parsefloat-string
$({ global: true, forced: parseFloat != $parseFloat }, {
  parseFloat: $parseFloat
});

},{"../internals/export":652,"../internals/number-parse-float":718}],937:[function(require,module,exports){
var $ = require('../internals/export');
var $parseInt = require('../internals/number-parse-int');

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$({ global: true, forced: parseInt != $parseInt }, {
  parseInt: $parseInt
});

},{"../internals/export":652,"../internals/number-parse-int":719}],938:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var call = require('../internals/function-call');
var aCallable = require('../internals/a-callable');
var newPromiseCapabilityModule = require('../internals/new-promise-capability');
var perform = require('../internals/perform');
var iterate = require('../internals/iterate');
var PROMISE_STATICS_INCORRECT_ITERATION = require('../internals/promise-statics-incorrect-iteration');

// `Promise.allSettled` method
// https://tc39.es/ecma262/#sec-promise.allsettled
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  allSettled: function allSettled(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var promiseResolve = aCallable(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call(promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = { status: 'fulfilled', value: value };
          --remaining || resolve(values);
        }, function (error) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = { status: 'rejected', reason: error };
          --remaining || resolve(values);
        });
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

},{"../internals/a-callable":573,"../internals/export":652,"../internals/function-call":661,"../internals/iterate":698,"../internals/new-promise-capability":714,"../internals/perform":741,"../internals/promise-statics-incorrect-iteration":745}],939:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var call = require('../internals/function-call');
var aCallable = require('../internals/a-callable');
var newPromiseCapabilityModule = require('../internals/new-promise-capability');
var perform = require('../internals/perform');
var iterate = require('../internals/iterate');
var PROMISE_STATICS_INCORRECT_ITERATION = require('../internals/promise-statics-incorrect-iteration');

// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

},{"../internals/a-callable":573,"../internals/export":652,"../internals/function-call":661,"../internals/iterate":698,"../internals/new-promise-capability":714,"../internals/perform":741,"../internals/promise-statics-incorrect-iteration":745}],940:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var call = require('../internals/function-call');
var aCallable = require('../internals/a-callable');
var getBuiltIn = require('../internals/get-built-in');
var newPromiseCapabilityModule = require('../internals/new-promise-capability');
var perform = require('../internals/perform');
var iterate = require('../internals/iterate');
var PROMISE_STATICS_INCORRECT_ITERATION = require('../internals/promise-statics-incorrect-iteration');

var PROMISE_ANY_ERROR = 'No one promise resolved';

// `Promise.any` method
// https://tc39.es/ecma262/#sec-promise.any
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  any: function any(iterable) {
    var C = this;
    var AggregateError = getBuiltIn('AggregateError');
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var promiseResolve = aCallable(C.resolve);
      var errors = [];
      var counter = 0;
      var remaining = 1;
      var alreadyResolved = false;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyRejected = false;
        remaining++;
        call(promiseResolve, C, promise).then(function (value) {
          if (alreadyRejected || alreadyResolved) return;
          alreadyResolved = true;
          resolve(value);
        }, function (error) {
          if (alreadyRejected || alreadyResolved) return;
          alreadyRejected = true;
          errors[index] = error;
          --remaining || reject(new AggregateError(errors, PROMISE_ANY_ERROR));
        });
      });
      --remaining || reject(new AggregateError(errors, PROMISE_ANY_ERROR));
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

},{"../internals/a-callable":573,"../internals/export":652,"../internals/function-call":661,"../internals/get-built-in":666,"../internals/iterate":698,"../internals/new-promise-capability":714,"../internals/perform":741,"../internals/promise-statics-incorrect-iteration":745}],941:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var IS_PURE = require('../internals/is-pure');
var FORCED_PROMISE_CONSTRUCTOR = require('../internals/promise-constructor-detection').CONSTRUCTOR;
var NativePromiseConstructor = require('../internals/promise-native-constructor');
var getBuiltIn = require('../internals/get-built-in');
var isCallable = require('../internals/is-callable');
var defineBuiltIn = require('../internals/define-built-in');

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;

// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$({ target: 'Promise', proto: true, forced: FORCED_PROMISE_CONSTRUCTOR, real: true }, {
  'catch': function (onRejected) {
    return this.then(undefined, onRejected);
  }
});

// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (!IS_PURE && isCallable(NativePromiseConstructor)) {
  var method = getBuiltIn('Promise').prototype['catch'];
  if (NativePromisePrototype['catch'] !== method) {
    defineBuiltIn(NativePromisePrototype, 'catch', method, { unsafe: true });
  }
}

},{"../internals/define-built-in":623,"../internals/export":652,"../internals/get-built-in":666,"../internals/is-callable":688,"../internals/is-pure":695,"../internals/promise-constructor-detection":742,"../internals/promise-native-constructor":743}],942:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var IS_PURE = require('../internals/is-pure');
var IS_NODE = require('../internals/engine-is-node');
var global = require('../internals/global');
var call = require('../internals/function-call');
var defineBuiltIn = require('../internals/define-built-in');
var setPrototypeOf = require('../internals/object-set-prototype-of');
var setToStringTag = require('../internals/set-to-string-tag');
var setSpecies = require('../internals/set-species');
var aCallable = require('../internals/a-callable');
var isCallable = require('../internals/is-callable');
var isObject = require('../internals/is-object');
var anInstance = require('../internals/an-instance');
var speciesConstructor = require('../internals/species-constructor');
var task = require('../internals/task').set;
var microtask = require('../internals/microtask');
var hostReportErrors = require('../internals/host-report-errors');
var perform = require('../internals/perform');
var Queue = require('../internals/queue');
var InternalStateModule = require('../internals/internal-state');
var NativePromiseConstructor = require('../internals/promise-native-constructor');
var PromiseConstructorDetection = require('../internals/promise-constructor-detection');
var newPromiseCapabilityModule = require('../internals/new-promise-capability');

var PROMISE = 'Promise';
var FORCED_PROMISE_CONSTRUCTOR = PromiseConstructorDetection.CONSTRUCTOR;
var NATIVE_PROMISE_REJECTION_EVENT = PromiseConstructorDetection.REJECTION_EVENT;
var NATIVE_PROMISE_SUBCLASSING = PromiseConstructorDetection.SUBCLASSING;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var setInternalState = InternalStateModule.set;
var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
var PromiseConstructor = NativePromiseConstructor;
var PromisePrototype = NativePromisePrototype;
var TypeError = global.TypeError;
var document = global.document;
var process = global.process;
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;

var DISPATCH_EVENT = !!(document && document.createEvent && global.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;

var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && isCallable(then = it.then) ? then : false;
};

var callReaction = function (reaction, state) {
  var value = state.value;
  var ok = state.state == FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;
  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
        state.rejection = HANDLED;
      }
      if (handler === true) result = value;
      else {
        if (domain) domain.enter();
        result = handler(value); // can throw
        if (domain) {
          domain.exit();
          exited = true;
        }
      }
      if (result === reaction.promise) {
        reject(TypeError('Promise-chain cycle'));
      } else if (then = isThenable(result)) {
        call(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask(function () {
    var reactions = state.reactions;
    var reaction;
    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_PROMISE_REJECTION_EVENT && (handler = global['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  call(task, global, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  call(task, global, function () {
    var promise = state.facade;
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw TypeError("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          call(then, value,
            bind(internalResolve, wrapper, state),
            bind(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED_PROMISE_CONSTRUCTOR) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromisePrototype);
    aCallable(executor);
    call(Internal, this);
    var state = getInternalPromiseState(this);
    try {
      executor(bind(internalResolve, state), bind(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };

  PromisePrototype = PromiseConstructor.prototype;

  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: new Queue(),
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };

  // `Promise.prototype.then` method
  // https://tc39.es/ecma262/#sec-promise.prototype.then
  Internal.prototype = defineBuiltIn(PromisePrototype, 'then', function then(onFulfilled, onRejected) {
    var state = getInternalPromiseState(this);
    var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
    state.parent = true;
    reaction.ok = isCallable(onFulfilled) ? onFulfilled : true;
    reaction.fail = isCallable(onRejected) && onRejected;
    reaction.domain = IS_NODE ? process.domain : undefined;
    if (state.state == PENDING) state.reactions.add(reaction);
    else microtask(function () {
      callReaction(reaction, state);
    });
    return reaction.promise;
  });

  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalPromiseState(promise);
    this.promise = promise;
    this.resolve = bind(internalResolve, state);
    this.reject = bind(internalReject, state);
  };

  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (!IS_PURE && isCallable(NativePromiseConstructor) && NativePromisePrototype !== Object.prototype) {
    nativeThen = NativePromisePrototype.then;

    if (!NATIVE_PROMISE_SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      defineBuiltIn(NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          call(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf) {
      setPrototypeOf(NativePromisePrototype, PromisePrototype);
    }
  }
}

$({ global: true, constructor: true, wrap: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false, true);
setSpecies(PROMISE);

},{"../internals/a-callable":573,"../internals/an-instance":578,"../internals/define-built-in":623,"../internals/engine-is-node":641,"../internals/export":652,"../internals/function-call":661,"../internals/global":672,"../internals/host-report-errors":675,"../internals/internal-state":684,"../internals/is-callable":688,"../internals/is-object":694,"../internals/is-pure":695,"../internals/microtask":713,"../internals/new-promise-capability":714,"../internals/object-set-prototype-of":735,"../internals/perform":741,"../internals/promise-constructor-detection":742,"../internals/promise-native-constructor":743,"../internals/queue":747,"../internals/set-species":759,"../internals/set-to-string-tag":760,"../internals/species-constructor":764,"../internals/task":779}],943:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var IS_PURE = require('../internals/is-pure');
var NativePromiseConstructor = require('../internals/promise-native-constructor');
var fails = require('../internals/fails');
var getBuiltIn = require('../internals/get-built-in');
var isCallable = require('../internals/is-callable');
var speciesConstructor = require('../internals/species-constructor');
var promiseResolve = require('../internals/promise-resolve');
var defineBuiltIn = require('../internals/define-built-in');

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;

// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var NON_GENERIC = !!NativePromiseConstructor && fails(function () {
  // eslint-disable-next-line unicorn/no-thenable -- required for testing
  NativePromisePrototype['finally'].call({ then: function () { /* empty */ } }, function () { /* empty */ });
});

// `Promise.prototype.finally` method
// https://tc39.es/ecma262/#sec-promise.prototype.finally
$({ target: 'Promise', proto: true, real: true, forced: NON_GENERIC }, {
  'finally': function (onFinally) {
    var C = speciesConstructor(this, getBuiltIn('Promise'));
    var isFunction = isCallable(onFinally);
    return this.then(
      isFunction ? function (x) {
        return promiseResolve(C, onFinally()).then(function () { return x; });
      } : onFinally,
      isFunction ? function (e) {
        return promiseResolve(C, onFinally()).then(function () { throw e; });
      } : onFinally
    );
  }
});

// makes sure that native promise-based APIs `Promise#finally` properly works with patched `Promise#then`
if (!IS_PURE && isCallable(NativePromiseConstructor)) {
  var method = getBuiltIn('Promise').prototype['finally'];
  if (NativePromisePrototype['finally'] !== method) {
    defineBuiltIn(NativePromisePrototype, 'finally', method, { unsafe: true });
  }
}

},{"../internals/define-built-in":623,"../internals/export":652,"../internals/fails":653,"../internals/get-built-in":666,"../internals/is-callable":688,"../internals/is-pure":695,"../internals/promise-native-constructor":743,"../internals/promise-resolve":744,"../internals/species-constructor":764}],944:[function(require,module,exports){
// TODO: Remove this module from `core-js@4` since it's split to modules listed below
require('../modules/es.promise.constructor');
require('../modules/es.promise.all');
require('../modules/es.promise.catch');
require('../modules/es.promise.race');
require('../modules/es.promise.reject');
require('../modules/es.promise.resolve');

},{"../modules/es.promise.all":939,"../modules/es.promise.catch":941,"../modules/es.promise.constructor":942,"../modules/es.promise.race":945,"../modules/es.promise.reject":946,"../modules/es.promise.resolve":947}],945:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var call = require('../internals/function-call');
var aCallable = require('../internals/a-callable');
var newPromiseCapabilityModule = require('../internals/new-promise-capability');
var perform = require('../internals/perform');
var iterate = require('../internals/iterate');
var PROMISE_STATICS_INCORRECT_ITERATION = require('../internals/promise-statics-incorrect-iteration');

// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      iterate(iterable, function (promise) {
        call($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

},{"../internals/a-callable":573,"../internals/export":652,"../internals/function-call":661,"../internals/iterate":698,"../internals/new-promise-capability":714,"../internals/perform":741,"../internals/promise-statics-incorrect-iteration":745}],946:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var call = require('../internals/function-call');
var newPromiseCapabilityModule = require('../internals/new-promise-capability');
var FORCED_PROMISE_CONSTRUCTOR = require('../internals/promise-constructor-detection').CONSTRUCTOR;

// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  reject: function reject(r) {
    var capability = newPromiseCapabilityModule.f(this);
    call(capability.reject, undefined, r);
    return capability.promise;
  }
});

},{"../internals/export":652,"../internals/function-call":661,"../internals/new-promise-capability":714,"../internals/promise-constructor-detection":742}],947:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var getBuiltIn = require('../internals/get-built-in');
var IS_PURE = require('../internals/is-pure');
var NativePromiseConstructor = require('../internals/promise-native-constructor');
var FORCED_PROMISE_CONSTRUCTOR = require('../internals/promise-constructor-detection').CONSTRUCTOR;
var promiseResolve = require('../internals/promise-resolve');

var PromiseConstructorWrapper = getBuiltIn('Promise');
var CHECK_WRAPPER = IS_PURE && !FORCED_PROMISE_CONSTRUCTOR;

// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$({ target: 'Promise', stat: true, forced: IS_PURE || FORCED_PROMISE_CONSTRUCTOR }, {
  resolve: function resolve(x) {
    return promiseResolve(CHECK_WRAPPER && this === PromiseConstructorWrapper ? NativePromiseConstructor : this, x);
  }
});

},{"../internals/export":652,"../internals/get-built-in":666,"../internals/is-pure":695,"../internals/promise-constructor-detection":742,"../internals/promise-native-constructor":743,"../internals/promise-resolve":744}],948:[function(require,module,exports){
var $ = require('../internals/export');
var functionApply = require('../internals/function-apply');
var aCallable = require('../internals/a-callable');
var anObject = require('../internals/an-object');
var fails = require('../internals/fails');

// MS Edge argumentsList argument is optional
var OPTIONAL_ARGUMENTS_LIST = !fails(function () {
  // eslint-disable-next-line es/no-reflect -- required for testing
  Reflect.apply(function () { /* empty */ });
});

// `Reflect.apply` method
// https://tc39.es/ecma262/#sec-reflect.apply
$({ target: 'Reflect', stat: true, forced: OPTIONAL_ARGUMENTS_LIST }, {
  apply: function apply(target, thisArgument, argumentsList) {
    return functionApply(aCallable(target), thisArgument, anObject(argumentsList));
  }
});

},{"../internals/a-callable":573,"../internals/an-object":579,"../internals/export":652,"../internals/fails":653,"../internals/function-apply":657}],949:[function(require,module,exports){
var $ = require('../internals/export');
var getBuiltIn = require('../internals/get-built-in');
var apply = require('../internals/function-apply');
var bind = require('../internals/function-bind');
var aConstructor = require('../internals/a-constructor');
var anObject = require('../internals/an-object');
var isObject = require('../internals/is-object');
var create = require('../internals/object-create');
var fails = require('../internals/fails');

var nativeConstruct = getBuiltIn('Reflect', 'construct');
var ObjectPrototype = Object.prototype;
var push = [].push;

// `Reflect.construct` method
// https://tc39.es/ecma262/#sec-reflect.construct
// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(nativeConstruct(function () { /* empty */ }, [], F) instanceof F);
});

var ARGS_BUG = !fails(function () {
  nativeConstruct(function () { /* empty */ });
});

var FORCED = NEW_TARGET_BUG || ARGS_BUG;

$({ target: 'Reflect', stat: true, forced: FORCED, sham: FORCED }, {
  construct: function construct(Target, args /* , newTarget */) {
    aConstructor(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aConstructor(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return nativeConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      apply(push, $args, args);
      return new (apply(bind, Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : ObjectPrototype);
    var result = apply(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});

},{"../internals/a-constructor":574,"../internals/an-object":579,"../internals/export":652,"../internals/fails":653,"../internals/function-apply":657,"../internals/function-bind":660,"../internals/get-built-in":666,"../internals/is-object":694,"../internals/object-create":721}],950:[function(require,module,exports){
var $ = require('../internals/export');
var DESCRIPTORS = require('../internals/descriptors');
var anObject = require('../internals/an-object');
var toPropertyKey = require('../internals/to-property-key');
var definePropertyModule = require('../internals/object-define-property');
var fails = require('../internals/fails');

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
var ERROR_INSTEAD_OF_FALSE = fails(function () {
  // eslint-disable-next-line es/no-reflect -- required for testing
  Reflect.defineProperty(definePropertyModule.f({}, 1, { value: 1 }), 1, { value: 2 });
});

// `Reflect.defineProperty` method
// https://tc39.es/ecma262/#sec-reflect.defineproperty
$({ target: 'Reflect', stat: true, forced: ERROR_INSTEAD_OF_FALSE, sham: !DESCRIPTORS }, {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    var key = toPropertyKey(propertyKey);
    anObject(attributes);
    try {
      definePropertyModule.f(target, key, attributes);
      return true;
    } catch (error) {
      return false;
    }
  }
});

},{"../internals/an-object":579,"../internals/descriptors":627,"../internals/export":652,"../internals/fails":653,"../internals/object-define-property":723,"../internals/to-property-key":791}],951:[function(require,module,exports){
var $ = require('../internals/export');
var anObject = require('../internals/an-object');
var getOwnPropertyDescriptor = require('../internals/object-get-own-property-descriptor').f;

// `Reflect.deleteProperty` method
// https://tc39.es/ecma262/#sec-reflect.deleteproperty
$({ target: 'Reflect', stat: true }, {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var descriptor = getOwnPropertyDescriptor(anObject(target), propertyKey);
    return descriptor && !descriptor.configurable ? false : delete target[propertyKey];
  }
});

},{"../internals/an-object":579,"../internals/export":652,"../internals/object-get-own-property-descriptor":724}],952:[function(require,module,exports){
var $ = require('../internals/export');
var DESCRIPTORS = require('../internals/descriptors');
var anObject = require('../internals/an-object');
var getOwnPropertyDescriptorModule = require('../internals/object-get-own-property-descriptor');

// `Reflect.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-reflect.getownpropertydescriptor
$({ target: 'Reflect', stat: true, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return getOwnPropertyDescriptorModule.f(anObject(target), propertyKey);
  }
});

},{"../internals/an-object":579,"../internals/descriptors":627,"../internals/export":652,"../internals/object-get-own-property-descriptor":724}],953:[function(require,module,exports){
var $ = require('../internals/export');
var anObject = require('../internals/an-object');
var objectGetPrototypeOf = require('../internals/object-get-prototype-of');
var CORRECT_PROTOTYPE_GETTER = require('../internals/correct-prototype-getter');

// `Reflect.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-reflect.getprototypeof
$({ target: 'Reflect', stat: true, sham: !CORRECT_PROTOTYPE_GETTER }, {
  getPrototypeOf: function getPrototypeOf(target) {
    return objectGetPrototypeOf(anObject(target));
  }
});

},{"../internals/an-object":579,"../internals/correct-prototype-getter":614,"../internals/export":652,"../internals/object-get-prototype-of":728}],954:[function(require,module,exports){
var $ = require('../internals/export');
var call = require('../internals/function-call');
var isObject = require('../internals/is-object');
var anObject = require('../internals/an-object');
var isDataDescriptor = require('../internals/is-data-descriptor');
var getOwnPropertyDescriptorModule = require('../internals/object-get-own-property-descriptor');
var getPrototypeOf = require('../internals/object-get-prototype-of');

// `Reflect.get` method
// https://tc39.es/ecma262/#sec-reflect.get
function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var descriptor, prototype;
  if (anObject(target) === receiver) return target[propertyKey];
  descriptor = getOwnPropertyDescriptorModule.f(target, propertyKey);
  if (descriptor) return isDataDescriptor(descriptor)
    ? descriptor.value
    : descriptor.get === undefined ? undefined : call(descriptor.get, receiver);
  if (isObject(prototype = getPrototypeOf(target))) return get(prototype, propertyKey, receiver);
}

$({ target: 'Reflect', stat: true }, {
  get: get
});

},{"../internals/an-object":579,"../internals/export":652,"../internals/function-call":661,"../internals/is-data-descriptor":690,"../internals/is-object":694,"../internals/object-get-own-property-descriptor":724,"../internals/object-get-prototype-of":728}],955:[function(require,module,exports){
var $ = require('../internals/export');

// `Reflect.has` method
// https://tc39.es/ecma262/#sec-reflect.has
$({ target: 'Reflect', stat: true }, {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});

},{"../internals/export":652}],956:[function(require,module,exports){
var $ = require('../internals/export');
var anObject = require('../internals/an-object');
var $isExtensible = require('../internals/object-is-extensible');

// `Reflect.isExtensible` method
// https://tc39.es/ecma262/#sec-reflect.isextensible
$({ target: 'Reflect', stat: true }, {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible(target);
  }
});

},{"../internals/an-object":579,"../internals/export":652,"../internals/object-is-extensible":729}],957:[function(require,module,exports){
var $ = require('../internals/export');
var ownKeys = require('../internals/own-keys');

// `Reflect.ownKeys` method
// https://tc39.es/ecma262/#sec-reflect.ownkeys
$({ target: 'Reflect', stat: true }, {
  ownKeys: ownKeys
});

},{"../internals/export":652,"../internals/own-keys":739}],958:[function(require,module,exports){
var $ = require('../internals/export');
var getBuiltIn = require('../internals/get-built-in');
var anObject = require('../internals/an-object');
var FREEZING = require('../internals/freezing');

// `Reflect.preventExtensions` method
// https://tc39.es/ecma262/#sec-reflect.preventextensions
$({ target: 'Reflect', stat: true, sham: !FREEZING }, {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      var objectPreventExtensions = getBuiltIn('Object', 'preventExtensions');
      if (objectPreventExtensions) objectPreventExtensions(target);
      return true;
    } catch (error) {
      return false;
    }
  }
});

},{"../internals/an-object":579,"../internals/export":652,"../internals/freezing":656,"../internals/get-built-in":666}],959:[function(require,module,exports){
var $ = require('../internals/export');
var anObject = require('../internals/an-object');
var aPossiblePrototype = require('../internals/a-possible-prototype');
var objectSetPrototypeOf = require('../internals/object-set-prototype-of');

// `Reflect.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-reflect.setprototypeof
if (objectSetPrototypeOf) $({ target: 'Reflect', stat: true }, {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    anObject(target);
    aPossiblePrototype(proto);
    try {
      objectSetPrototypeOf(target, proto);
      return true;
    } catch (error) {
      return false;
    }
  }
});

},{"../internals/a-possible-prototype":575,"../internals/an-object":579,"../internals/export":652,"../internals/object-set-prototype-of":735}],960:[function(require,module,exports){
var $ = require('../internals/export');
var call = require('../internals/function-call');
var anObject = require('../internals/an-object');
var isObject = require('../internals/is-object');
var isDataDescriptor = require('../internals/is-data-descriptor');
var fails = require('../internals/fails');
var definePropertyModule = require('../internals/object-define-property');
var getOwnPropertyDescriptorModule = require('../internals/object-get-own-property-descriptor');
var getPrototypeOf = require('../internals/object-get-prototype-of');
var createPropertyDescriptor = require('../internals/create-property-descriptor');

// `Reflect.set` method
// https://tc39.es/ecma262/#sec-reflect.set
function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDescriptor = getOwnPropertyDescriptorModule.f(anObject(target), propertyKey);
  var existingDescriptor, prototype, setter;
  if (!ownDescriptor) {
    if (isObject(prototype = getPrototypeOf(target))) {
      return set(prototype, propertyKey, V, receiver);
    }
    ownDescriptor = createPropertyDescriptor(0);
  }
  if (isDataDescriptor(ownDescriptor)) {
    if (ownDescriptor.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = getOwnPropertyDescriptorModule.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      definePropertyModule.f(receiver, propertyKey, existingDescriptor);
    } else definePropertyModule.f(receiver, propertyKey, createPropertyDescriptor(0, V));
  } else {
    setter = ownDescriptor.set;
    if (setter === undefined) return false;
    call(setter, receiver, V);
  } return true;
}

// MS Edge 17-18 Reflect.set allows setting the property to object
// with non-writable property on the prototype
var MS_EDGE_BUG = fails(function () {
  var Constructor = function () { /* empty */ };
  var object = definePropertyModule.f(new Constructor(), 'a', { configurable: true });
  // eslint-disable-next-line es/no-reflect -- required for testing
  return Reflect.set(Constructor.prototype, 'a', 1, object) !== false;
});

$({ target: 'Reflect', stat: true, forced: MS_EDGE_BUG }, {
  set: set
});

},{"../internals/an-object":579,"../internals/create-property-descriptor":618,"../internals/export":652,"../internals/fails":653,"../internals/function-call":661,"../internals/is-data-descriptor":690,"../internals/is-object":694,"../internals/object-define-property":723,"../internals/object-get-own-property-descriptor":724,"../internals/object-get-prototype-of":728}],961:[function(require,module,exports){
var $ = require('../internals/export');
var global = require('../internals/global');
var setToStringTag = require('../internals/set-to-string-tag');

$({ global: true }, { Reflect: {} });

// Reflect[@@toStringTag] property
// https://tc39.es/ecma262/#sec-reflect-@@tostringtag
setToStringTag(global.Reflect, 'Reflect', true);

},{"../internals/export":652,"../internals/global":672,"../internals/set-to-string-tag":760}],962:[function(require,module,exports){
var DESCRIPTORS = require('../internals/descriptors');
var global = require('../internals/global');
var uncurryThis = require('../internals/function-uncurry-this');
var isForced = require('../internals/is-forced');
var inheritIfRequired = require('../internals/inherit-if-required');
var createNonEnumerableProperty = require('../internals/create-non-enumerable-property');
var getOwnPropertyNames = require('../internals/object-get-own-property-names').f;
var isPrototypeOf = require('../internals/object-is-prototype-of');
var isRegExp = require('../internals/is-regexp');
var toString = require('../internals/to-string');
var getRegExpFlags = require('../internals/regexp-get-flags');
var stickyHelpers = require('../internals/regexp-sticky-helpers');
var proxyAccessor = require('../internals/proxy-accessor');
var defineBuiltIn = require('../internals/define-built-in');
var fails = require('../internals/fails');
var hasOwn = require('../internals/has-own-property');
var enforceInternalState = require('../internals/internal-state').enforce;
var setSpecies = require('../internals/set-species');
var wellKnownSymbol = require('../internals/well-known-symbol');
var UNSUPPORTED_DOT_ALL = require('../internals/regexp-unsupported-dot-all');
var UNSUPPORTED_NCG = require('../internals/regexp-unsupported-ncg');

var MATCH = wellKnownSymbol('match');
var NativeRegExp = global.RegExp;
var RegExpPrototype = NativeRegExp.prototype;
var SyntaxError = global.SyntaxError;
var exec = uncurryThis(RegExpPrototype.exec);
var charAt = uncurryThis(''.charAt);
var replace = uncurryThis(''.replace);
var stringIndexOf = uncurryThis(''.indexOf);
var stringSlice = uncurryThis(''.slice);
// TODO: Use only proper RegExpIdentifierName
var IS_NCG = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/;
var re1 = /a/g;
var re2 = /a/g;

// "new" should create a new object, old webkit bug
var CORRECT_NEW = new NativeRegExp(re1) !== re1;

var MISSED_STICKY = stickyHelpers.MISSED_STICKY;
var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;

var BASE_FORCED = DESCRIPTORS &&
  (!CORRECT_NEW || MISSED_STICKY || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG || fails(function () {
    re2[MATCH] = false;
    // RegExp constructor can alter flags and IsRegExp works correct with @@match
    return NativeRegExp(re1) != re1 || NativeRegExp(re2) == re2 || NativeRegExp(re1, 'i') != '/a/i';
  }));

var handleDotAll = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var brackets = false;
  var chr;
  for (; index <= length; index++) {
    chr = charAt(string, index);
    if (chr === '\\') {
      result += chr + charAt(string, ++index);
      continue;
    }
    if (!brackets && chr === '.') {
      result += '[\\s\\S]';
    } else {
      if (chr === '[') {
        brackets = true;
      } else if (chr === ']') {
        brackets = false;
      } result += chr;
    }
  } return result;
};

var handleNCG = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var named = [];
  var names = {};
  var brackets = false;
  var ncg = false;
  var groupid = 0;
  var groupname = '';
  var chr;
  for (; index <= length; index++) {
    chr = charAt(string, index);
    if (chr === '\\') {
      chr = chr + charAt(string, ++index);
    } else if (chr === ']') {
      brackets = false;
    } else if (!brackets) switch (true) {
      case chr === '[':
        brackets = true;
        break;
      case chr === '(':
        if (exec(IS_NCG, stringSlice(string, index + 1))) {
          index += 2;
          ncg = true;
        }
        result += chr;
        groupid++;
        continue;
      case chr === '>' && ncg:
        if (groupname === '' || hasOwn(names, groupname)) {
          throw new SyntaxError('Invalid capture group name');
        }
        names[groupname] = true;
        named[named.length] = [groupname, groupid];
        ncg = false;
        groupname = '';
        continue;
    }
    if (ncg) groupname += chr;
    else result += chr;
  } return [result, named];
};

// `RegExp` constructor
// https://tc39.es/ecma262/#sec-regexp-constructor
if (isForced('RegExp', BASE_FORCED)) {
  var RegExpWrapper = function RegExp(pattern, flags) {
    var thisIsRegExp = isPrototypeOf(RegExpPrototype, this);
    var patternIsRegExp = isRegExp(pattern);
    var flagsAreUndefined = flags === undefined;
    var groups = [];
    var rawPattern = pattern;
    var rawFlags, dotAll, sticky, handled, result, state;

    if (!thisIsRegExp && patternIsRegExp && flagsAreUndefined && pattern.constructor === RegExpWrapper) {
      return pattern;
    }

    if (patternIsRegExp || isPrototypeOf(RegExpPrototype, pattern)) {
      pattern = pattern.source;
      if (flagsAreUndefined) flags = getRegExpFlags(rawPattern);
    }

    pattern = pattern === undefined ? '' : toString(pattern);
    flags = flags === undefined ? '' : toString(flags);
    rawPattern = pattern;

    if (UNSUPPORTED_DOT_ALL && 'dotAll' in re1) {
      dotAll = !!flags && stringIndexOf(flags, 's') > -1;
      if (dotAll) flags = replace(flags, /s/g, '');
    }

    rawFlags = flags;

    if (MISSED_STICKY && 'sticky' in re1) {
      sticky = !!flags && stringIndexOf(flags, 'y') > -1;
      if (sticky && UNSUPPORTED_Y) flags = replace(flags, /y/g, '');
    }

    if (UNSUPPORTED_NCG) {
      handled = handleNCG(pattern);
      pattern = handled[0];
      groups = handled[1];
    }

    result = inheritIfRequired(NativeRegExp(pattern, flags), thisIsRegExp ? this : RegExpPrototype, RegExpWrapper);

    if (dotAll || sticky || groups.length) {
      state = enforceInternalState(result);
      if (dotAll) {
        state.dotAll = true;
        state.raw = RegExpWrapper(handleDotAll(pattern), rawFlags);
      }
      if (sticky) state.sticky = true;
      if (groups.length) state.groups = groups;
    }

    if (pattern !== rawPattern) try {
      // fails in old engines, but we have no alternatives for unsupported regex syntax
      createNonEnumerableProperty(result, 'source', rawPattern === '' ? '(?:)' : rawPattern);
    } catch (error) { /* empty */ }

    return result;
  };

  for (var keys = getOwnPropertyNames(NativeRegExp), index = 0; keys.length > index;) {
    proxyAccessor(RegExpWrapper, NativeRegExp, keys[index++]);
  }

  RegExpPrototype.constructor = RegExpWrapper;
  RegExpWrapper.prototype = RegExpPrototype;
  defineBuiltIn(global, 'RegExp', RegExpWrapper, { constructor: true });
}

// https://tc39.es/ecma262/#sec-get-regexp-@@species
setSpecies('RegExp');

},{"../internals/create-non-enumerable-property":617,"../internals/define-built-in":623,"../internals/descriptors":627,"../internals/fails":653,"../internals/function-uncurry-this":665,"../internals/global":672,"../internals/has-own-property":673,"../internals/inherit-if-required":680,"../internals/internal-state":684,"../internals/is-forced":691,"../internals/is-regexp":696,"../internals/object-get-own-property-names":726,"../internals/object-is-prototype-of":730,"../internals/proxy-accessor":746,"../internals/regexp-get-flags":751,"../internals/regexp-sticky-helpers":752,"../internals/regexp-unsupported-dot-all":753,"../internals/regexp-unsupported-ncg":754,"../internals/set-species":759,"../internals/to-string":793,"../internals/well-known-symbol":809}],963:[function(require,module,exports){
var DESCRIPTORS = require('../internals/descriptors');
var UNSUPPORTED_DOT_ALL = require('../internals/regexp-unsupported-dot-all');
var classof = require('../internals/classof-raw');
var defineBuiltInAccessor = require('../internals/define-built-in-accessor');
var getInternalState = require('../internals/internal-state').get;

var RegExpPrototype = RegExp.prototype;
var $TypeError = TypeError;

// `RegExp.prototype.dotAll` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.dotall
if (DESCRIPTORS && UNSUPPORTED_DOT_ALL) {
  defineBuiltInAccessor(RegExpPrototype, 'dotAll', {
    configurable: true,
    get: function dotAll() {
      if (this === RegExpPrototype) return undefined;
      // We can't use InternalStateModule.getterFor because
      // we don't add metadata for regexps created by a literal.
      if (classof(this) === 'RegExp') {
        return !!getInternalState(this).dotAll;
      }
      throw $TypeError('Incompatible receiver, RegExp required');
    }
  });
}

},{"../internals/classof-raw":607,"../internals/define-built-in-accessor":622,"../internals/descriptors":627,"../internals/internal-state":684,"../internals/regexp-unsupported-dot-all":753}],964:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var exec = require('../internals/regexp-exec');

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});

},{"../internals/export":652,"../internals/regexp-exec":749}],965:[function(require,module,exports){
var global = require('../internals/global');
var DESCRIPTORS = require('../internals/descriptors');
var defineBuiltInAccessor = require('../internals/define-built-in-accessor');
var regExpFlags = require('../internals/regexp-flags');
var fails = require('../internals/fails');

// babel-minify and Closure Compiler transpiles RegExp('.', 'd') -> /./d and it causes SyntaxError
var RegExp = global.RegExp;
var RegExpPrototype = RegExp.prototype;

var FORCED = DESCRIPTORS && fails(function () {
  var INDICES_SUPPORT = true;
  try {
    RegExp('.', 'd');
  } catch (error) {
    INDICES_SUPPORT = false;
  }

  var O = {};
  // modern V8 bug
  var calls = '';
  var expected = INDICES_SUPPORT ? 'dgimsy' : 'gimsy';

  var addGetter = function (key, chr) {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty(O, key, { get: function () {
      calls += chr;
      return true;
    } });
  };

  var pairs = {
    dotAll: 's',
    global: 'g',
    ignoreCase: 'i',
    multiline: 'm',
    sticky: 'y'
  };

  if (INDICES_SUPPORT) pairs.hasIndices = 'd';

  for (var key in pairs) addGetter(key, pairs[key]);

  // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
  var result = Object.getOwnPropertyDescriptor(RegExpPrototype, 'flags').get.call(O);

  return result !== expected || calls !== expected;
});

// `RegExp.prototype.flags` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
if (FORCED) defineBuiltInAccessor(RegExpPrototype, 'flags', {
  configurable: true,
  get: regExpFlags
});

},{"../internals/define-built-in-accessor":622,"../internals/descriptors":627,"../internals/fails":653,"../internals/global":672,"../internals/regexp-flags":750}],966:[function(require,module,exports){
var DESCRIPTORS = require('../internals/descriptors');
var MISSED_STICKY = require('../internals/regexp-sticky-helpers').MISSED_STICKY;
var classof = require('../internals/classof-raw');
var defineBuiltInAccessor = require('../internals/define-built-in-accessor');
var getInternalState = require('../internals/internal-state').get;

var RegExpPrototype = RegExp.prototype;
var $TypeError = TypeError;

// `RegExp.prototype.sticky` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.sticky
if (DESCRIPTORS && MISSED_STICKY) {
  defineBuiltInAccessor(RegExpPrototype, 'sticky', {
    configurable: true,
    get: function sticky() {
      if (this === RegExpPrototype) return;
      // We can't use InternalStateModule.getterFor because
      // we don't add metadata for regexps created by a literal.
      if (classof(this) === 'RegExp') {
        return !!getInternalState(this).sticky;
      }
      throw $TypeError('Incompatible receiver, RegExp required');
    }
  });
}

},{"../internals/classof-raw":607,"../internals/define-built-in-accessor":622,"../internals/descriptors":627,"../internals/internal-state":684,"../internals/regexp-sticky-helpers":752}],967:[function(require,module,exports){
'use strict';
// TODO: Remove from `core-js@4` since it's moved to entry points
require('../modules/es.regexp.exec');
var $ = require('../internals/export');
var call = require('../internals/function-call');
var isCallable = require('../internals/is-callable');
var anObject = require('../internals/an-object');
var toString = require('../internals/to-string');

var DELEGATES_TO_EXEC = function () {
  var execCalled = false;
  var re = /[ac]/;
  re.exec = function () {
    execCalled = true;
    return /./.exec.apply(this, arguments);
  };
  return re.test('abc') === true && execCalled;
}();

var nativeTest = /./.test;

// `RegExp.prototype.test` method
// https://tc39.es/ecma262/#sec-regexp.prototype.test
$({ target: 'RegExp', proto: true, forced: !DELEGATES_TO_EXEC }, {
  test: function (S) {
    var R = anObject(this);
    var string = toString(S);
    var exec = R.exec;
    if (!isCallable(exec)) return call(nativeTest, R, string);
    var result = call(exec, R, string);
    if (result === null) return false;
    anObject(result);
    return true;
  }
});

},{"../internals/an-object":579,"../internals/export":652,"../internals/function-call":661,"../internals/is-callable":688,"../internals/to-string":793,"../modules/es.regexp.exec":964}],968:[function(require,module,exports){
'use strict';
var PROPER_FUNCTION_NAME = require('../internals/function-name').PROPER;
var defineBuiltIn = require('../internals/define-built-in');
var anObject = require('../internals/an-object');
var $toString = require('../internals/to-string');
var fails = require('../internals/fails');
var getRegExpFlags = require('../internals/regexp-get-flags');

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var nativeToString = RegExpPrototype[TO_STRING];

var NOT_GENERIC = fails(function () { return nativeToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME && nativeToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  defineBuiltIn(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var pattern = $toString(R.source);
    var flags = $toString(getRegExpFlags(R));
    return '/' + pattern + '/' + flags;
  }, { unsafe: true });
}

},{"../internals/an-object":579,"../internals/define-built-in":623,"../internals/fails":653,"../internals/function-name":662,"../internals/regexp-get-flags":751,"../internals/to-string":793}],969:[function(require,module,exports){
'use strict';
var collection = require('../internals/collection');
var collectionStrong = require('../internals/collection-strong');

// `Set` constructor
// https://tc39.es/ecma262/#sec-set-objects
collection('Set', function (init) {
  return function Set() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);

},{"../internals/collection":611,"../internals/collection-strong":609}],970:[function(require,module,exports){
// TODO: Remove this module from `core-js@4` since it's replaced to module below
require('../modules/es.set.constructor');

},{"../modules/es.set.constructor":969}],971:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var createHTML = require('../internals/create-html');
var forcedStringHTMLMethod = require('../internals/string-html-forced');

// `String.prototype.anchor` method
// https://tc39.es/ecma262/#sec-string.prototype.anchor
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('anchor') }, {
  anchor: function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  }
});

},{"../internals/create-html":615,"../internals/export":652,"../internals/string-html-forced":765}],972:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var uncurryThis = require('../internals/function-uncurry-this');
var requireObjectCoercible = require('../internals/require-object-coercible');
var toIntegerOrInfinity = require('../internals/to-integer-or-infinity');
var toString = require('../internals/to-string');
var fails = require('../internals/fails');

var charAt = uncurryThis(''.charAt);

var FORCED = fails(function () {
  // eslint-disable-next-line es/no-array-string-prototype-at -- safe
  return '𠮷'.at(-2) !== '\uD842';
});

// `String.prototype.at` method
// https://github.com/tc39/proposal-relative-indexing-method
$({ target: 'String', proto: true, forced: FORCED }, {
  at: function at(index) {
    var S = toString(requireObjectCoercible(this));
    var len = S.length;
    var relativeIndex = toIntegerOrInfinity(index);
    var k = relativeIndex >= 0 ? relativeIndex : len + relativeIndex;
    return (k < 0 || k >= len) ? undefined : charAt(S, k);
  }
});

},{"../internals/export":652,"../internals/fails":653,"../internals/function-uncurry-this":665,"../internals/require-object-coercible":755,"../internals/to-integer-or-infinity":785,"../internals/to-string":793}],973:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var createHTML = require('../internals/create-html');
var forcedStringHTMLMethod = require('../internals/string-html-forced');

// `String.prototype.big` method
// https://tc39.es/ecma262/#sec-string.prototype.big
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('big') }, {
  big: function big() {
    return createHTML(this, 'big', '', '');
  }
});

},{"../internals/create-html":615,"../internals/export":652,"../internals/string-html-forced":765}],974:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var createHTML = require('../internals/create-html');
var forcedStringHTMLMethod = require('../internals/string-html-forced');

// `String.prototype.blink` method
// https://tc39.es/ecma262/#sec-string.prototype.blink
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('blink') }, {
  blink: function blink() {
    return createHTML(this, 'blink', '', '');
  }
});

},{"../internals/create-html":615,"../internals/export":652,"../internals/string-html-forced":765}],975:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var createHTML = require('../internals/create-html');
var forcedStringHTMLMethod = require('../internals/string-html-forced');

// `String.prototype.bold` method
// https://tc39.es/ecma262/#sec-string.prototype.bold
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('bold') }, {
  bold: function bold() {
    return createHTML(this, 'b', '', '');
  }
});

},{"../internals/create-html":615,"../internals/export":652,"../internals/string-html-forced":765}],976:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var codeAt = require('../internals/string-multibyte').codeAt;

// `String.prototype.codePointAt` method
// https://tc39.es/ecma262/#sec-string.prototype.codepointat
$({ target: 'String', proto: true }, {
  codePointAt: function codePointAt(pos) {
    return codeAt(this, pos);
  }
});

},{"../internals/export":652,"../internals/string-multibyte":766}],977:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var uncurryThis = require('../internals/function-uncurry-this-clause');
var getOwnPropertyDescriptor = require('../internals/object-get-own-property-descriptor').f;
var toLength = require('../internals/to-length');
var toString = require('../internals/to-string');
var notARegExp = require('../internals/not-a-regexp');
var requireObjectCoercible = require('../internals/require-object-coercible');
var correctIsRegExpLogic = require('../internals/correct-is-regexp-logic');
var IS_PURE = require('../internals/is-pure');

// eslint-disable-next-line es/no-string-prototype-endswith -- safe
var nativeEndsWith = uncurryThis(''.endsWith);
var slice = uncurryThis(''.slice);
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('endsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'endsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.endsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.endswith
$({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = toString(requireObjectCoercible(this));
    notARegExp(searchString);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = that.length;
    var end = endPosition === undefined ? len : min(toLength(endPosition), len);
    var search = toString(searchString);
    return nativeEndsWith
      ? nativeEndsWith(that, search, end)
      : slice(that, end - search.length, end) === search;
  }
});

},{"../internals/correct-is-regexp-logic":613,"../internals/export":652,"../internals/function-uncurry-this-clause":664,"../internals/is-pure":695,"../internals/not-a-regexp":716,"../internals/object-get-own-property-descriptor":724,"../internals/require-object-coercible":755,"../internals/to-length":786,"../internals/to-string":793}],978:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var createHTML = require('../internals/create-html');
var forcedStringHTMLMethod = require('../internals/string-html-forced');

// `String.prototype.fixed` method
// https://tc39.es/ecma262/#sec-string.prototype.fixed
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('fixed') }, {
  fixed: function fixed() {
    return createHTML(this, 'tt', '', '');
  }
});

},{"../internals/create-html":615,"../internals/export":652,"../internals/string-html-forced":765}],979:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var createHTML = require('../internals/create-html');
var forcedStringHTMLMethod = require('../internals/string-html-forced');

// `String.prototype.fontcolor` method
// https://tc39.es/ecma262/#sec-string.prototype.fontcolor
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('fontcolor') }, {
  fontcolor: function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  }
});

},{"../internals/create-html":615,"../internals/export":652,"../internals/string-html-forced":765}],980:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var createHTML = require('../internals/create-html');
var forcedStringHTMLMethod = require('../internals/string-html-forced');

// `String.prototype.fontsize` method
// https://tc39.es/ecma262/#sec-string.prototype.fontsize
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('fontsize') }, {
  fontsize: function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  }
});

},{"../internals/create-html":615,"../internals/export":652,"../internals/string-html-forced":765}],981:[function(require,module,exports){
var $ = require('../internals/export');
var uncurryThis = require('../internals/function-uncurry-this');
var toAbsoluteIndex = require('../internals/to-absolute-index');

var $RangeError = RangeError;
var fromCharCode = String.fromCharCode;
// eslint-disable-next-line es/no-string-fromcodepoint -- required for testing
var $fromCodePoint = String.fromCodePoint;
var join = uncurryThis([].join);

// length should be 1, old FF problem
var INCORRECT_LENGTH = !!$fromCodePoint && $fromCodePoint.length != 1;

// `String.fromCodePoint` method
// https://tc39.es/ecma262/#sec-string.fromcodepoint
$({ target: 'String', stat: true, arity: 1, forced: INCORRECT_LENGTH }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  fromCodePoint: function fromCodePoint(x) {
    var elements = [];
    var length = arguments.length;
    var i = 0;
    var code;
    while (length > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10FFFF) !== code) throw $RangeError(code + ' is not a valid code point');
      elements[i] = code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xD800, code % 0x400 + 0xDC00);
    } return join(elements, '');
  }
});

},{"../internals/export":652,"../internals/function-uncurry-this":665,"../internals/to-absolute-index":781}],982:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var uncurryThis = require('../internals/function-uncurry-this');
var notARegExp = require('../internals/not-a-regexp');
var requireObjectCoercible = require('../internals/require-object-coercible');
var toString = require('../internals/to-string');
var correctIsRegExpLogic = require('../internals/correct-is-regexp-logic');

var stringIndexOf = uncurryThis(''.indexOf);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~stringIndexOf(
      toString(requireObjectCoercible(this)),
      toString(notARegExp(searchString)),
      arguments.length > 1 ? arguments[1] : undefined
    );
  }
});

},{"../internals/correct-is-regexp-logic":613,"../internals/export":652,"../internals/function-uncurry-this":665,"../internals/not-a-regexp":716,"../internals/require-object-coercible":755,"../internals/to-string":793}],983:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var createHTML = require('../internals/create-html');
var forcedStringHTMLMethod = require('../internals/string-html-forced');

// `String.prototype.italics` method
// https://tc39.es/ecma262/#sec-string.prototype.italics
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('italics') }, {
  italics: function italics() {
    return createHTML(this, 'i', '', '');
  }
});

},{"../internals/create-html":615,"../internals/export":652,"../internals/string-html-forced":765}],984:[function(require,module,exports){
'use strict';
var charAt = require('../internals/string-multibyte').charAt;
var toString = require('../internals/to-string');
var InternalStateModule = require('../internals/internal-state');
var defineIterator = require('../internals/iterator-define');
var createIterResultObject = require('../internals/create-iter-result-object');

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: toString(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return createIterResultObject(undefined, true);
  point = charAt(string, index);
  state.index += point.length;
  return createIterResultObject(point, false);
});

},{"../internals/create-iter-result-object":616,"../internals/internal-state":684,"../internals/iterator-define":701,"../internals/string-multibyte":766,"../internals/to-string":793}],985:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var createHTML = require('../internals/create-html');
var forcedStringHTMLMethod = require('../internals/string-html-forced');

// `String.prototype.link` method
// https://tc39.es/ecma262/#sec-string.prototype.link
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('link') }, {
  link: function link(url) {
    return createHTML(this, 'a', 'href', url);
  }
});

},{"../internals/create-html":615,"../internals/export":652,"../internals/string-html-forced":765}],986:[function(require,module,exports){
'use strict';
/* eslint-disable es/no-string-prototype-matchall -- safe */
var $ = require('../internals/export');
var call = require('../internals/function-call');
var uncurryThis = require('../internals/function-uncurry-this-clause');
var createIteratorConstructor = require('../internals/iterator-create-constructor');
var createIterResultObject = require('../internals/create-iter-result-object');
var requireObjectCoercible = require('../internals/require-object-coercible');
var toLength = require('../internals/to-length');
var toString = require('../internals/to-string');
var anObject = require('../internals/an-object');
var isNullOrUndefined = require('../internals/is-null-or-undefined');
var classof = require('../internals/classof-raw');
var isRegExp = require('../internals/is-regexp');
var getRegExpFlags = require('../internals/regexp-get-flags');
var getMethod = require('../internals/get-method');
var defineBuiltIn = require('../internals/define-built-in');
var fails = require('../internals/fails');
var wellKnownSymbol = require('../internals/well-known-symbol');
var speciesConstructor = require('../internals/species-constructor');
var advanceStringIndex = require('../internals/advance-string-index');
var regExpExec = require('../internals/regexp-exec-abstract');
var InternalStateModule = require('../internals/internal-state');
var IS_PURE = require('../internals/is-pure');

var MATCH_ALL = wellKnownSymbol('matchAll');
var REGEXP_STRING = 'RegExp String';
var REGEXP_STRING_ITERATOR = REGEXP_STRING + ' Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(REGEXP_STRING_ITERATOR);
var RegExpPrototype = RegExp.prototype;
var $TypeError = TypeError;
var stringIndexOf = uncurryThis(''.indexOf);
var nativeMatchAll = uncurryThis(''.matchAll);

var WORKS_WITH_NON_GLOBAL_REGEX = !!nativeMatchAll && !fails(function () {
  nativeMatchAll('a', /./);
});

var $RegExpStringIterator = createIteratorConstructor(function RegExpStringIterator(regexp, string, $global, fullUnicode) {
  setInternalState(this, {
    type: REGEXP_STRING_ITERATOR,
    regexp: regexp,
    string: string,
    global: $global,
    unicode: fullUnicode,
    done: false
  });
}, REGEXP_STRING, function next() {
  var state = getInternalState(this);
  if (state.done) return createIterResultObject(undefined, true);
  var R = state.regexp;
  var S = state.string;
  var match = regExpExec(R, S);
  if (match === null) {
    state.done = true;
    return createIterResultObject(undefined, true);
  }
  if (state.global) {
    if (toString(match[0]) === '') R.lastIndex = advanceStringIndex(S, toLength(R.lastIndex), state.unicode);
    return createIterResultObject(match, false);
  }
  state.done = true;
  return createIterResultObject(match, false);
});

var $matchAll = function (string) {
  var R = anObject(this);
  var S = toString(string);
  var C = speciesConstructor(R, RegExp);
  var flags = toString(getRegExpFlags(R));
  var matcher, $global, fullUnicode;
  matcher = new C(C === RegExp ? R.source : R, flags);
  $global = !!~stringIndexOf(flags, 'g');
  fullUnicode = !!~stringIndexOf(flags, 'u');
  matcher.lastIndex = toLength(R.lastIndex);
  return new $RegExpStringIterator(matcher, S, $global, fullUnicode);
};

// `String.prototype.matchAll` method
// https://tc39.es/ecma262/#sec-string.prototype.matchall
$({ target: 'String', proto: true, forced: WORKS_WITH_NON_GLOBAL_REGEX }, {
  matchAll: function matchAll(regexp) {
    var O = requireObjectCoercible(this);
    var flags, S, matcher, rx;
    if (!isNullOrUndefined(regexp)) {
      if (isRegExp(regexp)) {
        flags = toString(requireObjectCoercible(getRegExpFlags(regexp)));
        if (!~stringIndexOf(flags, 'g')) throw $TypeError('`.matchAll` does not allow non-global regexes');
      }
      if (WORKS_WITH_NON_GLOBAL_REGEX) return nativeMatchAll(O, regexp);
      matcher = getMethod(regexp, MATCH_ALL);
      if (matcher === undefined && IS_PURE && classof(regexp) == 'RegExp') matcher = $matchAll;
      if (matcher) return call(matcher, regexp, O);
    } else if (WORKS_WITH_NON_GLOBAL_REGEX) return nativeMatchAll(O, regexp);
    S = toString(O);
    rx = new RegExp(regexp, 'g');
    return IS_PURE ? call($matchAll, rx, S) : rx[MATCH_ALL](S);
  }
});

IS_PURE || MATCH_ALL in RegExpPrototype || defineBuiltIn(RegExpPrototype, MATCH_ALL, $matchAll);

},{"../internals/advance-string-index":577,"../internals/an-object":579,"../internals/classof-raw":607,"../internals/create-iter-result-object":616,"../internals/define-built-in":623,"../internals/export":652,"../internals/fails":653,"../internals/function-call":661,"../internals/function-uncurry-this-clause":664,"../internals/get-method":670,"../internals/internal-state":684,"../internals/is-null-or-undefined":693,"../internals/is-pure":695,"../internals/is-regexp":696,"../internals/iterator-create-constructor":700,"../internals/regexp-exec-abstract":748,"../internals/regexp-get-flags":751,"../internals/require-object-coercible":755,"../internals/species-constructor":764,"../internals/to-length":786,"../internals/to-string":793,"../internals/well-known-symbol":809}],987:[function(require,module,exports){
'use strict';
var call = require('../internals/function-call');
var fixRegExpWellKnownSymbolLogic = require('../internals/fix-regexp-well-known-symbol-logic');
var anObject = require('../internals/an-object');
var isNullOrUndefined = require('../internals/is-null-or-undefined');
var toLength = require('../internals/to-length');
var toString = require('../internals/to-string');
var requireObjectCoercible = require('../internals/require-object-coercible');
var getMethod = require('../internals/get-method');
var advanceStringIndex = require('../internals/advance-string-index');
var regExpExec = require('../internals/regexp-exec-abstract');

// @@match logic
fixRegExpWellKnownSymbolLogic('match', function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.es/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible(this);
      var matcher = isNullOrUndefined(regexp) ? undefined : getMethod(regexp, MATCH);
      return matcher ? call(matcher, regexp, O) : new RegExp(regexp)[MATCH](toString(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
    function (string) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(nativeMatch, rx, S);

      if (res.done) return res.value;

      if (!rx.global) return regExpExec(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = toString(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});

},{"../internals/advance-string-index":577,"../internals/an-object":579,"../internals/fix-regexp-well-known-symbol-logic":654,"../internals/function-call":661,"../internals/get-method":670,"../internals/is-null-or-undefined":693,"../internals/regexp-exec-abstract":748,"../internals/require-object-coercible":755,"../internals/to-length":786,"../internals/to-string":793}],988:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var $padEnd = require('../internals/string-pad').end;
var WEBKIT_BUG = require('../internals/string-pad-webkit-bug');

// `String.prototype.padEnd` method
// https://tc39.es/ecma262/#sec-string.prototype.padend
$({ target: 'String', proto: true, forced: WEBKIT_BUG }, {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $padEnd(this, maxLength, arguments.length > 1 ? arguments[1] : undefined);
  }
});

},{"../internals/export":652,"../internals/string-pad":768,"../internals/string-pad-webkit-bug":767}],989:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var $padStart = require('../internals/string-pad').start;
var WEBKIT_BUG = require('../internals/string-pad-webkit-bug');

// `String.prototype.padStart` method
// https://tc39.es/ecma262/#sec-string.prototype.padstart
$({ target: 'String', proto: true, forced: WEBKIT_BUG }, {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $padStart(this, maxLength, arguments.length > 1 ? arguments[1] : undefined);
  }
});

},{"../internals/export":652,"../internals/string-pad":768,"../internals/string-pad-webkit-bug":767}],990:[function(require,module,exports){
var $ = require('../internals/export');
var uncurryThis = require('../internals/function-uncurry-this');
var toIndexedObject = require('../internals/to-indexed-object');
var toObject = require('../internals/to-object');
var toString = require('../internals/to-string');
var lengthOfArrayLike = require('../internals/length-of-array-like');

var push = uncurryThis([].push);
var join = uncurryThis([].join);

// `String.raw` method
// https://tc39.es/ecma262/#sec-string.raw
$({ target: 'String', stat: true }, {
  raw: function raw(template) {
    var rawTemplate = toIndexedObject(toObject(template).raw);
    var literalSegments = lengthOfArrayLike(rawTemplate);
    if (!literalSegments) return '';
    var argumentsLength = arguments.length;
    var elements = [];
    var i = 0;
    while (true) {
      push(elements, toString(rawTemplate[i++]));
      if (i === literalSegments) return join(elements, '');
      if (i < argumentsLength) push(elements, toString(arguments[i]));
    }
  }
});

},{"../internals/export":652,"../internals/function-uncurry-this":665,"../internals/length-of-array-like":704,"../internals/to-indexed-object":784,"../internals/to-object":787,"../internals/to-string":793}],991:[function(require,module,exports){
var $ = require('../internals/export');
var repeat = require('../internals/string-repeat');

// `String.prototype.repeat` method
// https://tc39.es/ecma262/#sec-string.prototype.repeat
$({ target: 'String', proto: true }, {
  repeat: repeat
});

},{"../internals/export":652,"../internals/string-repeat":770}],992:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var call = require('../internals/function-call');
var uncurryThis = require('../internals/function-uncurry-this');
var requireObjectCoercible = require('../internals/require-object-coercible');
var isCallable = require('../internals/is-callable');
var isNullOrUndefined = require('../internals/is-null-or-undefined');
var isRegExp = require('../internals/is-regexp');
var toString = require('../internals/to-string');
var getMethod = require('../internals/get-method');
var getRegExpFlags = require('../internals/regexp-get-flags');
var getSubstitution = require('../internals/get-substitution');
var wellKnownSymbol = require('../internals/well-known-symbol');
var IS_PURE = require('../internals/is-pure');

var REPLACE = wellKnownSymbol('replace');
var $TypeError = TypeError;
var indexOf = uncurryThis(''.indexOf);
var replace = uncurryThis(''.replace);
var stringSlice = uncurryThis(''.slice);
var max = Math.max;

var stringIndexOf = function (string, searchValue, fromIndex) {
  if (fromIndex > string.length) return -1;
  if (searchValue === '') return fromIndex;
  return indexOf(string, searchValue, fromIndex);
};

// `String.prototype.replaceAll` method
// https://tc39.es/ecma262/#sec-string.prototype.replaceall
$({ target: 'String', proto: true }, {
  replaceAll: function replaceAll(searchValue, replaceValue) {
    var O = requireObjectCoercible(this);
    var IS_REG_EXP, flags, replacer, string, searchString, functionalReplace, searchLength, advanceBy, replacement;
    var position = 0;
    var endOfLastMatch = 0;
    var result = '';
    if (!isNullOrUndefined(searchValue)) {
      IS_REG_EXP = isRegExp(searchValue);
      if (IS_REG_EXP) {
        flags = toString(requireObjectCoercible(getRegExpFlags(searchValue)));
        if (!~indexOf(flags, 'g')) throw $TypeError('`.replaceAll` does not allow non-global regexes');
      }
      replacer = getMethod(searchValue, REPLACE);
      if (replacer) {
        return call(replacer, searchValue, O, replaceValue);
      } else if (IS_PURE && IS_REG_EXP) {
        return replace(toString(O), searchValue, replaceValue);
      }
    }
    string = toString(O);
    searchString = toString(searchValue);
    functionalReplace = isCallable(replaceValue);
    if (!functionalReplace) replaceValue = toString(replaceValue);
    searchLength = searchString.length;
    advanceBy = max(1, searchLength);
    position = stringIndexOf(string, searchString, 0);
    while (position !== -1) {
      replacement = functionalReplace
        ? toString(replaceValue(searchString, position, string))
        : getSubstitution(searchString, string, position, [], undefined, replaceValue);
      result += stringSlice(string, endOfLastMatch, position) + replacement;
      endOfLastMatch = position + searchLength;
      position = stringIndexOf(string, searchString, position + advanceBy);
    }
    if (endOfLastMatch < string.length) {
      result += stringSlice(string, endOfLastMatch);
    }
    return result;
  }
});

},{"../internals/export":652,"../internals/function-call":661,"../internals/function-uncurry-this":665,"../internals/get-method":670,"../internals/get-substitution":671,"../internals/is-callable":688,"../internals/is-null-or-undefined":693,"../internals/is-pure":695,"../internals/is-regexp":696,"../internals/regexp-get-flags":751,"../internals/require-object-coercible":755,"../internals/to-string":793,"../internals/well-known-symbol":809}],993:[function(require,module,exports){
'use strict';
var apply = require('../internals/function-apply');
var call = require('../internals/function-call');
var uncurryThis = require('../internals/function-uncurry-this');
var fixRegExpWellKnownSymbolLogic = require('../internals/fix-regexp-well-known-symbol-logic');
var fails = require('../internals/fails');
var anObject = require('../internals/an-object');
var isCallable = require('../internals/is-callable');
var isNullOrUndefined = require('../internals/is-null-or-undefined');
var toIntegerOrInfinity = require('../internals/to-integer-or-infinity');
var toLength = require('../internals/to-length');
var toString = require('../internals/to-string');
var requireObjectCoercible = require('../internals/require-object-coercible');
var advanceStringIndex = require('../internals/advance-string-index');
var getMethod = require('../internals/get-method');
var getSubstitution = require('../internals/get-substitution');
var regExpExec = require('../internals/regexp-exec-abstract');
var wellKnownSymbol = require('../internals/well-known-symbol');

var REPLACE = wellKnownSymbol('replace');
var max = Math.max;
var min = Math.min;
var concat = uncurryThis([].concat);
var push = uncurryThis([].push);
var stringIndexOf = uncurryThis(''.indexOf);
var stringSlice = uncurryThis(''.slice);

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegExpWellKnownSymbolLogic('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = isNullOrUndefined(searchValue) ? undefined : getMethod(searchValue, REPLACE);
      return replacer
        ? call(replacer, searchValue, O, replaceValue)
        : call(nativeReplace, toString(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      var rx = anObject(this);
      var S = toString(string);

      if (
        typeof replaceValue == 'string' &&
        stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 &&
        stringIndexOf(replaceValue, '$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
        if (res.done) return res.value;
      }

      var functionalReplace = isCallable(replaceValue);
      if (!functionalReplace) replaceValue = toString(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;

        push(results, result);
        if (!global) break;

        var matchStr = toString(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = toString(result[0]);
        var position = max(min(toIntegerOrInfinity(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) push(captures, maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = concat([matched], captures, position, S);
          if (namedCaptures !== undefined) push(replacerArgs, namedCaptures);
          var replacement = toString(apply(replaceValue, undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += stringSlice(S, nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + stringSlice(S, nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);

},{"../internals/advance-string-index":577,"../internals/an-object":579,"../internals/fails":653,"../internals/fix-regexp-well-known-symbol-logic":654,"../internals/function-apply":657,"../internals/function-call":661,"../internals/function-uncurry-this":665,"../internals/get-method":670,"../internals/get-substitution":671,"../internals/is-callable":688,"../internals/is-null-or-undefined":693,"../internals/regexp-exec-abstract":748,"../internals/require-object-coercible":755,"../internals/to-integer-or-infinity":785,"../internals/to-length":786,"../internals/to-string":793,"../internals/well-known-symbol":809}],994:[function(require,module,exports){
'use strict';
var call = require('../internals/function-call');
var fixRegExpWellKnownSymbolLogic = require('../internals/fix-regexp-well-known-symbol-logic');
var anObject = require('../internals/an-object');
var isNullOrUndefined = require('../internals/is-null-or-undefined');
var requireObjectCoercible = require('../internals/require-object-coercible');
var sameValue = require('../internals/same-value');
var toString = require('../internals/to-string');
var getMethod = require('../internals/get-method');
var regExpExec = require('../internals/regexp-exec-abstract');

// @@search logic
fixRegExpWellKnownSymbolLogic('search', function (SEARCH, nativeSearch, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.es/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = requireObjectCoercible(this);
      var searcher = isNullOrUndefined(regexp) ? undefined : getMethod(regexp, SEARCH);
      return searcher ? call(searcher, regexp, O) : new RegExp(regexp)[SEARCH](toString(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
    function (string) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(nativeSearch, rx, S);

      if (res.done) return res.value;

      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});

},{"../internals/an-object":579,"../internals/fix-regexp-well-known-symbol-logic":654,"../internals/function-call":661,"../internals/get-method":670,"../internals/is-null-or-undefined":693,"../internals/regexp-exec-abstract":748,"../internals/require-object-coercible":755,"../internals/same-value":756,"../internals/to-string":793}],995:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var createHTML = require('../internals/create-html');
var forcedStringHTMLMethod = require('../internals/string-html-forced');

// `String.prototype.small` method
// https://tc39.es/ecma262/#sec-string.prototype.small
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('small') }, {
  small: function small() {
    return createHTML(this, 'small', '', '');
  }
});

},{"../internals/create-html":615,"../internals/export":652,"../internals/string-html-forced":765}],996:[function(require,module,exports){
'use strict';
var apply = require('../internals/function-apply');
var call = require('../internals/function-call');
var uncurryThis = require('../internals/function-uncurry-this');
var fixRegExpWellKnownSymbolLogic = require('../internals/fix-regexp-well-known-symbol-logic');
var anObject = require('../internals/an-object');
var isNullOrUndefined = require('../internals/is-null-or-undefined');
var isRegExp = require('../internals/is-regexp');
var requireObjectCoercible = require('../internals/require-object-coercible');
var speciesConstructor = require('../internals/species-constructor');
var advanceStringIndex = require('../internals/advance-string-index');
var toLength = require('../internals/to-length');
var toString = require('../internals/to-string');
var getMethod = require('../internals/get-method');
var arraySlice = require('../internals/array-slice-simple');
var callRegExpExec = require('../internals/regexp-exec-abstract');
var regexpExec = require('../internals/regexp-exec');
var stickyHelpers = require('../internals/regexp-sticky-helpers');
var fails = require('../internals/fails');

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;
var MAX_UINT32 = 0xFFFFFFFF;
var min = Math.min;
var $push = [].push;
var exec = uncurryThis(/./.exec);
var push = uncurryThis($push);
var stringSlice = uncurryThis(''.slice);

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  // eslint-disable-next-line regexp/no-empty-group -- required for testing
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

// @@split logic
fixRegExpWellKnownSymbolLogic('split', function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'.split(/(b)*/)[1] == 'c' ||
    // eslint-disable-next-line regexp/no-empty-group -- required for testing
    'test'.split(/(?:)/, -1).length != 4 ||
    'ab'.split(/(?:ab)*/).length != 2 ||
    '.'.split(/(.?)(.?)/).length != 4 ||
    // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
    '.'.split(/()()/).length > 1 ||
    ''.split(/.?/).length
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = toString(requireObjectCoercible(this));
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) {
        return call(nativeSplit, string, separator, lim);
      }
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = call(regexpExec, separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;
        if (lastIndex > lastLastIndex) {
          push(output, stringSlice(string, lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) apply($push, output, arraySlice(match, 1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }
        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }
      if (lastLastIndex === string.length) {
        if (lastLength || !exec(separatorCopy, '')) push(output, '');
      } else push(output, stringSlice(string, lastLastIndex));
      return output.length > lim ? arraySlice(output, 0, lim) : output;
    };
  // Chakra, V8
  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : call(nativeSplit, this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.es/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible(this);
      var splitter = isNullOrUndefined(separator) ? undefined : getMethod(separator, SPLIT);
      return splitter
        ? call(splitter, separator, O, limit)
        : call(internalSplit, toString(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (string, limit) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);

      if (res.done) return res.value;

      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (UNSUPPORTED_Y ? 'g' : 'y');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(UNSUPPORTED_Y ? '^(?:' + rx.source + ')' : rx, flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = UNSUPPORTED_Y ? 0 : q;
        var z = callRegExpExec(splitter, UNSUPPORTED_Y ? stringSlice(S, q) : S);
        var e;
        if (
          z === null ||
          (e = min(toLength(splitter.lastIndex + (UNSUPPORTED_Y ? q : 0)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          push(A, stringSlice(S, p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            push(A, z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      push(A, stringSlice(S, p));
      return A;
    }
  ];
}, !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y);

},{"../internals/advance-string-index":577,"../internals/an-object":579,"../internals/array-slice-simple":597,"../internals/fails":653,"../internals/fix-regexp-well-known-symbol-logic":654,"../internals/function-apply":657,"../internals/function-call":661,"../internals/function-uncurry-this":665,"../internals/get-method":670,"../internals/is-null-or-undefined":693,"../internals/is-regexp":696,"../internals/regexp-exec":749,"../internals/regexp-exec-abstract":748,"../internals/regexp-sticky-helpers":752,"../internals/require-object-coercible":755,"../internals/species-constructor":764,"../internals/to-length":786,"../internals/to-string":793}],997:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var uncurryThis = require('../internals/function-uncurry-this-clause');
var getOwnPropertyDescriptor = require('../internals/object-get-own-property-descriptor').f;
var toLength = require('../internals/to-length');
var toString = require('../internals/to-string');
var notARegExp = require('../internals/not-a-regexp');
var requireObjectCoercible = require('../internals/require-object-coercible');
var correctIsRegExpLogic = require('../internals/correct-is-regexp-logic');
var IS_PURE = require('../internals/is-pure');

// eslint-disable-next-line es/no-string-prototype-startswith -- safe
var nativeStartsWith = uncurryThis(''.startsWith);
var stringSlice = uncurryThis(''.slice);
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('startsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'startsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.startsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.startswith
$({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = toString(requireObjectCoercible(this));
    notARegExp(searchString);
    var index = toLength(min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = toString(searchString);
    return nativeStartsWith
      ? nativeStartsWith(that, search, index)
      : stringSlice(that, index, index + search.length) === search;
  }
});

},{"../internals/correct-is-regexp-logic":613,"../internals/export":652,"../internals/function-uncurry-this-clause":664,"../internals/is-pure":695,"../internals/not-a-regexp":716,"../internals/object-get-own-property-descriptor":724,"../internals/require-object-coercible":755,"../internals/to-length":786,"../internals/to-string":793}],998:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var createHTML = require('../internals/create-html');
var forcedStringHTMLMethod = require('../internals/string-html-forced');

// `String.prototype.strike` method
// https://tc39.es/ecma262/#sec-string.prototype.strike
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('strike') }, {
  strike: function strike() {
    return createHTML(this, 'strike', '', '');
  }
});

},{"../internals/create-html":615,"../internals/export":652,"../internals/string-html-forced":765}],999:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var createHTML = require('../internals/create-html');
var forcedStringHTMLMethod = require('../internals/string-html-forced');

// `String.prototype.sub` method
// https://tc39.es/ecma262/#sec-string.prototype.sub
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('sub') }, {
  sub: function sub() {
    return createHTML(this, 'sub', '', '');
  }
});

},{"../internals/create-html":615,"../internals/export":652,"../internals/string-html-forced":765}],1000:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var uncurryThis = require('../internals/function-uncurry-this');
var requireObjectCoercible = require('../internals/require-object-coercible');
var toIntegerOrInfinity = require('../internals/to-integer-or-infinity');
var toString = require('../internals/to-string');

var stringSlice = uncurryThis(''.slice);
var max = Math.max;
var min = Math.min;

// eslint-disable-next-line unicorn/prefer-string-slice -- required for testing
var FORCED = !''.substr || 'ab'.substr(-1) !== 'b';

// `String.prototype.substr` method
// https://tc39.es/ecma262/#sec-string.prototype.substr
$({ target: 'String', proto: true, forced: FORCED }, {
  substr: function substr(start, length) {
    var that = toString(requireObjectCoercible(this));
    var size = that.length;
    var intStart = toIntegerOrInfinity(start);
    var intLength, intEnd;
    if (intStart === Infinity) intStart = 0;
    if (intStart < 0) intStart = max(size + intStart, 0);
    intLength = length === undefined ? size : toIntegerOrInfinity(length);
    if (intLength <= 0 || intLength === Infinity) return '';
    intEnd = min(intStart + intLength, size);
    return intStart >= intEnd ? '' : stringSlice(that, intStart, intEnd);
  }
});

},{"../internals/export":652,"../internals/function-uncurry-this":665,"../internals/require-object-coercible":755,"../internals/to-integer-or-infinity":785,"../internals/to-string":793}],1001:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var createHTML = require('../internals/create-html');
var forcedStringHTMLMethod = require('../internals/string-html-forced');

// `String.prototype.sup` method
// https://tc39.es/ecma262/#sec-string.prototype.sup
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('sup') }, {
  sup: function sup() {
    return createHTML(this, 'sup', '', '');
  }
});

},{"../internals/create-html":615,"../internals/export":652,"../internals/string-html-forced":765}],1002:[function(require,module,exports){
// TODO: Remove this line from `core-js@4`
require('../modules/es.string.trim-right');
var $ = require('../internals/export');
var trimEnd = require('../internals/string-trim-end');

// `String.prototype.trimEnd` method
// https://tc39.es/ecma262/#sec-string.prototype.trimend
// eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
$({ target: 'String', proto: true, name: 'trimEnd', forced: ''.trimEnd !== trimEnd }, {
  trimEnd: trimEnd
});

},{"../internals/export":652,"../internals/string-trim-end":771,"../modules/es.string.trim-right":1004}],1003:[function(require,module,exports){
var $ = require('../internals/export');
var trimStart = require('../internals/string-trim-start');

// `String.prototype.trimLeft` method
// https://tc39.es/ecma262/#sec-string.prototype.trimleft
// eslint-disable-next-line es/no-string-prototype-trimleft-trimright -- safe
$({ target: 'String', proto: true, name: 'trimStart', forced: ''.trimLeft !== trimStart }, {
  trimLeft: trimStart
});

},{"../internals/export":652,"../internals/string-trim-start":773}],1004:[function(require,module,exports){
var $ = require('../internals/export');
var trimEnd = require('../internals/string-trim-end');

// `String.prototype.trimRight` method
// https://tc39.es/ecma262/#sec-string.prototype.trimend
// eslint-disable-next-line es/no-string-prototype-trimleft-trimright -- safe
$({ target: 'String', proto: true, name: 'trimEnd', forced: ''.trimRight !== trimEnd }, {
  trimRight: trimEnd
});

},{"../internals/export":652,"../internals/string-trim-end":771}],1005:[function(require,module,exports){
// TODO: Remove this line from `core-js@4`
require('../modules/es.string.trim-left');
var $ = require('../internals/export');
var trimStart = require('../internals/string-trim-start');

// `String.prototype.trimStart` method
// https://tc39.es/ecma262/#sec-string.prototype.trimstart
// eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
$({ target: 'String', proto: true, name: 'trimStart', forced: ''.trimStart !== trimStart }, {
  trimStart: trimStart
});

},{"../internals/export":652,"../internals/string-trim-start":773,"../modules/es.string.trim-left":1003}],1006:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var $trim = require('../internals/string-trim').trim;
var forcedStringTrimMethod = require('../internals/string-trim-forced');

// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});

},{"../internals/export":652,"../internals/string-trim":774,"../internals/string-trim-forced":772}],1007:[function(require,module,exports){
var defineWellKnownSymbol = require('../internals/well-known-symbol-define');

// `Symbol.asyncIterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.asynciterator
defineWellKnownSymbol('asyncIterator');

},{"../internals/well-known-symbol-define":807}],1008:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var global = require('../internals/global');
var call = require('../internals/function-call');
var uncurryThis = require('../internals/function-uncurry-this');
var IS_PURE = require('../internals/is-pure');
var DESCRIPTORS = require('../internals/descriptors');
var NATIVE_SYMBOL = require('../internals/symbol-constructor-detection');
var fails = require('../internals/fails');
var hasOwn = require('../internals/has-own-property');
var isPrototypeOf = require('../internals/object-is-prototype-of');
var anObject = require('../internals/an-object');
var toIndexedObject = require('../internals/to-indexed-object');
var toPropertyKey = require('../internals/to-property-key');
var $toString = require('../internals/to-string');
var createPropertyDescriptor = require('../internals/create-property-descriptor');
var nativeObjectCreate = require('../internals/object-create');
var objectKeys = require('../internals/object-keys');
var getOwnPropertyNamesModule = require('../internals/object-get-own-property-names');
var getOwnPropertyNamesExternal = require('../internals/object-get-own-property-names-external');
var getOwnPropertySymbolsModule = require('../internals/object-get-own-property-symbols');
var getOwnPropertyDescriptorModule = require('../internals/object-get-own-property-descriptor');
var definePropertyModule = require('../internals/object-define-property');
var definePropertiesModule = require('../internals/object-define-properties');
var propertyIsEnumerableModule = require('../internals/object-property-is-enumerable');
var defineBuiltIn = require('../internals/define-built-in');
var defineBuiltInAccessor = require('../internals/define-built-in-accessor');
var shared = require('../internals/shared');
var sharedKey = require('../internals/shared-key');
var hiddenKeys = require('../internals/hidden-keys');
var uid = require('../internals/uid');
var wellKnownSymbol = require('../internals/well-known-symbol');
var wrappedWellKnownSymbolModule = require('../internals/well-known-symbol-wrapped');
var defineWellKnownSymbol = require('../internals/well-known-symbol-define');
var defineSymbolToPrimitive = require('../internals/symbol-define-to-primitive');
var setToStringTag = require('../internals/set-to-string-tag');
var InternalStateModule = require('../internals/internal-state');
var $forEach = require('../internals/array-iteration').forEach;

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';

var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);

var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var SymbolPrototype = $Symbol && $Symbol[PROTOTYPE];
var TypeError = global.TypeError;
var QObject = global.QObject;
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var push = uncurryThis([].push);

var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var WellKnownSymbolsStore = shared('wks');

// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate(SymbolPrototype);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPropertyKey(P);
  anObject(Attributes);
  if (hasOwn(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!hasOwn(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (hasOwn(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || call($propertyIsEnumerable, properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPropertyKey(V);
  var enumerable = call(nativePropertyIsEnumerable, this, P);
  if (this === ObjectPrototype && hasOwn(AllSymbols, P) && !hasOwn(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !hasOwn(this, P) || !hasOwn(AllSymbols, P) || hasOwn(this, HIDDEN) && this[HIDDEN][P]
    ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPropertyKey(P);
  if (it === ObjectPrototype && hasOwn(AllSymbols, key) && !hasOwn(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && hasOwn(AllSymbols, key) && !(hasOwn(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!hasOwn(AllSymbols, key) && !hasOwn(hiddenKeys, key)) push(result, key);
  });
  return result;
};

var $getOwnPropertySymbols = function (O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (hasOwn(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || hasOwn(ObjectPrototype, key))) {
      push(result, AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (isPrototypeOf(SymbolPrototype, this)) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : $toString(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype) call(setter, ObjectPrototypeSymbols, value);
      if (hasOwn(this, HIDDEN) && hasOwn(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  SymbolPrototype = $Symbol[PROTOTYPE];

  defineBuiltIn(SymbolPrototype, 'toString', function toString() {
    return getInternalState(this).tag;
  });

  defineBuiltIn($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  definePropertiesModule.f = $defineProperties;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    defineBuiltInAccessor(SymbolPrototype, 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      defineBuiltIn(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$({ global: true, constructor: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames
});

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
defineSymbolToPrimitive();

// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;

},{"../internals/an-object":579,"../internals/array-iteration":591,"../internals/create-property-descriptor":618,"../internals/define-built-in":623,"../internals/define-built-in-accessor":622,"../internals/descriptors":627,"../internals/export":652,"../internals/fails":653,"../internals/function-call":661,"../internals/function-uncurry-this":665,"../internals/global":672,"../internals/has-own-property":673,"../internals/hidden-keys":674,"../internals/internal-state":684,"../internals/is-pure":695,"../internals/object-create":721,"../internals/object-define-properties":722,"../internals/object-define-property":723,"../internals/object-get-own-property-descriptor":724,"../internals/object-get-own-property-names":726,"../internals/object-get-own-property-names-external":725,"../internals/object-get-own-property-symbols":727,"../internals/object-is-prototype-of":730,"../internals/object-keys":732,"../internals/object-property-is-enumerable":733,"../internals/set-to-string-tag":760,"../internals/shared":763,"../internals/shared-key":761,"../internals/symbol-constructor-detection":776,"../internals/symbol-define-to-primitive":777,"../internals/to-indexed-object":784,"../internals/to-property-key":791,"../internals/to-string":793,"../internals/uid":801,"../internals/well-known-symbol":809,"../internals/well-known-symbol-define":807,"../internals/well-known-symbol-wrapped":808}],1009:[function(require,module,exports){
// `Symbol.prototype.description` getter
// https://tc39.es/ecma262/#sec-symbol.prototype.description
'use strict';
var $ = require('../internals/export');
var DESCRIPTORS = require('../internals/descriptors');
var global = require('../internals/global');
var uncurryThis = require('../internals/function-uncurry-this');
var hasOwn = require('../internals/has-own-property');
var isCallable = require('../internals/is-callable');
var isPrototypeOf = require('../internals/object-is-prototype-of');
var toString = require('../internals/to-string');
var defineBuiltInAccessor = require('../internals/define-built-in-accessor');
var copyConstructorProperties = require('../internals/copy-constructor-properties');

var NativeSymbol = global.Symbol;
var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;

if (DESCRIPTORS && isCallable(NativeSymbol) && (!('description' in SymbolPrototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString(arguments[0]);
    var result = isPrototypeOf(SymbolPrototype, this)
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };

  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  SymbolWrapper.prototype = SymbolPrototype;
  SymbolPrototype.constructor = SymbolWrapper;

  var NATIVE_SYMBOL = String(NativeSymbol('test')) == 'Symbol(test)';
  var thisSymbolValue = uncurryThis(SymbolPrototype.valueOf);
  var symbolDescriptiveString = uncurryThis(SymbolPrototype.toString);
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  var replace = uncurryThis(''.replace);
  var stringSlice = uncurryThis(''.slice);

  defineBuiltInAccessor(SymbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = thisSymbolValue(this);
      if (hasOwn(EmptyStringDescriptionStore, symbol)) return '';
      var string = symbolDescriptiveString(symbol);
      var desc = NATIVE_SYMBOL ? stringSlice(string, 7, -1) : replace(string, regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, constructor: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}

},{"../internals/copy-constructor-properties":612,"../internals/define-built-in-accessor":622,"../internals/descriptors":627,"../internals/export":652,"../internals/function-uncurry-this":665,"../internals/global":672,"../internals/has-own-property":673,"../internals/is-callable":688,"../internals/object-is-prototype-of":730,"../internals/to-string":793}],1010:[function(require,module,exports){
var $ = require('../internals/export');
var getBuiltIn = require('../internals/get-built-in');
var hasOwn = require('../internals/has-own-property');
var toString = require('../internals/to-string');
var shared = require('../internals/shared');
var NATIVE_SYMBOL_REGISTRY = require('../internals/symbol-registry-detection');

var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');

// `Symbol.for` method
// https://tc39.es/ecma262/#sec-symbol.for
$({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
  'for': function (key) {
    var string = toString(key);
    if (hasOwn(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = getBuiltIn('Symbol')(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  }
});

},{"../internals/export":652,"../internals/get-built-in":666,"../internals/has-own-property":673,"../internals/shared":763,"../internals/symbol-registry-detection":778,"../internals/to-string":793}],1011:[function(require,module,exports){
var defineWellKnownSymbol = require('../internals/well-known-symbol-define');

// `Symbol.hasInstance` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.hasinstance
defineWellKnownSymbol('hasInstance');

},{"../internals/well-known-symbol-define":807}],1012:[function(require,module,exports){
var defineWellKnownSymbol = require('../internals/well-known-symbol-define');

// `Symbol.isConcatSpreadable` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.isconcatspreadable
defineWellKnownSymbol('isConcatSpreadable');

},{"../internals/well-known-symbol-define":807}],1013:[function(require,module,exports){
var defineWellKnownSymbol = require('../internals/well-known-symbol-define');

// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');

},{"../internals/well-known-symbol-define":807}],1014:[function(require,module,exports){
// TODO: Remove this module from `core-js@4` since it's split to modules listed below
require('../modules/es.symbol.constructor');
require('../modules/es.symbol.for');
require('../modules/es.symbol.key-for');
require('../modules/es.json.stringify');
require('../modules/es.object.get-own-property-symbols');

},{"../modules/es.json.stringify":873,"../modules/es.object.get-own-property-symbols":920,"../modules/es.symbol.constructor":1008,"../modules/es.symbol.for":1010,"../modules/es.symbol.key-for":1015}],1015:[function(require,module,exports){
var $ = require('../internals/export');
var hasOwn = require('../internals/has-own-property');
var isSymbol = require('../internals/is-symbol');
var tryToString = require('../internals/try-to-string');
var shared = require('../internals/shared');
var NATIVE_SYMBOL_REGISTRY = require('../internals/symbol-registry-detection');

var SymbolToStringRegistry = shared('symbol-to-string-registry');

// `Symbol.keyFor` method
// https://tc39.es/ecma262/#sec-symbol.keyfor
$({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(tryToString(sym) + ' is not a symbol');
    if (hasOwn(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  }
});

},{"../internals/export":652,"../internals/has-own-property":673,"../internals/is-symbol":697,"../internals/shared":763,"../internals/symbol-registry-detection":778,"../internals/try-to-string":795}],1016:[function(require,module,exports){
var defineWellKnownSymbol = require('../internals/well-known-symbol-define');

// `Symbol.matchAll` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.matchall
defineWellKnownSymbol('matchAll');

},{"../internals/well-known-symbol-define":807}],1017:[function(require,module,exports){
var defineWellKnownSymbol = require('../internals/well-known-symbol-define');

// `Symbol.match` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.match
defineWellKnownSymbol('match');

},{"../internals/well-known-symbol-define":807}],1018:[function(require,module,exports){
var defineWellKnownSymbol = require('../internals/well-known-symbol-define');

// `Symbol.replace` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.replace
defineWellKnownSymbol('replace');

},{"../internals/well-known-symbol-define":807}],1019:[function(require,module,exports){
var defineWellKnownSymbol = require('../internals/well-known-symbol-define');

// `Symbol.search` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.search
defineWellKnownSymbol('search');

},{"../internals/well-known-symbol-define":807}],1020:[function(require,module,exports){
var defineWellKnownSymbol = require('../internals/well-known-symbol-define');

// `Symbol.species` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.species
defineWellKnownSymbol('species');

},{"../internals/well-known-symbol-define":807}],1021:[function(require,module,exports){
var defineWellKnownSymbol = require('../internals/well-known-symbol-define');

// `Symbol.split` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.split
defineWellKnownSymbol('split');

},{"../internals/well-known-symbol-define":807}],1022:[function(require,module,exports){
var defineWellKnownSymbol = require('../internals/well-known-symbol-define');
var defineSymbolToPrimitive = require('../internals/symbol-define-to-primitive');

// `Symbol.toPrimitive` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.toprimitive
defineWellKnownSymbol('toPrimitive');

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
defineSymbolToPrimitive();

},{"../internals/symbol-define-to-primitive":777,"../internals/well-known-symbol-define":807}],1023:[function(require,module,exports){
var getBuiltIn = require('../internals/get-built-in');
var defineWellKnownSymbol = require('../internals/well-known-symbol-define');
var setToStringTag = require('../internals/set-to-string-tag');

// `Symbol.toStringTag` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.tostringtag
defineWellKnownSymbol('toStringTag');

// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag(getBuiltIn('Symbol'), 'Symbol');

},{"../internals/get-built-in":666,"../internals/set-to-string-tag":760,"../internals/well-known-symbol-define":807}],1024:[function(require,module,exports){
var defineWellKnownSymbol = require('../internals/well-known-symbol-define');

// `Symbol.unscopables` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.unscopables
defineWellKnownSymbol('unscopables');

},{"../internals/well-known-symbol-define":807}],1025:[function(require,module,exports){
'use strict';
var ArrayBufferViewCore = require('../internals/array-buffer-view-core');
var lengthOfArrayLike = require('../internals/length-of-array-like');
var toIntegerOrInfinity = require('../internals/to-integer-or-infinity');

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.at` method
// https://github.com/tc39/proposal-relative-indexing-method
exportTypedArrayMethod('at', function at(index) {
  var O = aTypedArray(this);
  var len = lengthOfArrayLike(O);
  var relativeIndex = toIntegerOrInfinity(index);
  var k = relativeIndex >= 0 ? relativeIndex : len + relativeIndex;
  return (k < 0 || k >= len) ? undefined : O[k];
});

},{"../internals/array-buffer-view-core":582,"../internals/length-of-array-like":704,"../internals/to-integer-or-infinity":785}],1026:[function(require,module,exports){
'use strict';
var uncurryThis = require('../internals/function-uncurry-this');
var ArrayBufferViewCore = require('../internals/array-buffer-view-core');
var $ArrayCopyWithin = require('../internals/array-copy-within');

var u$ArrayCopyWithin = uncurryThis($ArrayCopyWithin);
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.copyWithin` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.copywithin
exportTypedArrayMethod('copyWithin', function copyWithin(target, start /* , end */) {
  return u$ArrayCopyWithin(aTypedArray(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
});

},{"../internals/array-buffer-view-core":582,"../internals/array-copy-within":584,"../internals/function-uncurry-this":665}],1027:[function(require,module,exports){
'use strict';
var ArrayBufferViewCore = require('../internals/array-buffer-view-core');
var $every = require('../internals/array-iteration').every;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.every` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.every
exportTypedArrayMethod('every', function every(callbackfn /* , thisArg */) {
  return $every(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});

},{"../internals/array-buffer-view-core":582,"../internals/array-iteration":591}],1028:[function(require,module,exports){
'use strict';
var ArrayBufferViewCore = require('../internals/array-buffer-view-core');
var $fill = require('../internals/array-fill');
var toBigInt = require('../internals/to-big-int');
var classof = require('../internals/classof');
var call = require('../internals/function-call');
var uncurryThis = require('../internals/function-uncurry-this');
var fails = require('../internals/fails');

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var slice = uncurryThis(''.slice);

// V8 ~ Chrome < 59, Safari < 14.1, FF < 55, Edge <=18
var CONVERSION_BUG = fails(function () {
  var count = 0;
  // eslint-disable-next-line es/no-typed-arrays -- safe
  new Int8Array(2).fill({ valueOf: function () { return count++; } });
  return count !== 1;
});

// `%TypedArray%.prototype.fill` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.fill
exportTypedArrayMethod('fill', function fill(value /* , start, end */) {
  var length = arguments.length;
  aTypedArray(this);
  var actualValue = slice(classof(this), 0, 3) === 'Big' ? toBigInt(value) : +value;
  return call($fill, this, actualValue, length > 1 ? arguments[1] : undefined, length > 2 ? arguments[2] : undefined);
}, CONVERSION_BUG);

},{"../internals/array-buffer-view-core":582,"../internals/array-fill":585,"../internals/classof":608,"../internals/fails":653,"../internals/function-call":661,"../internals/function-uncurry-this":665,"../internals/to-big-int":782}],1029:[function(require,module,exports){
'use strict';
var ArrayBufferViewCore = require('../internals/array-buffer-view-core');
var $filter = require('../internals/array-iteration').filter;
var fromSpeciesAndList = require('../internals/typed-array-from-species-and-list');

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.filter` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.filter
exportTypedArrayMethod('filter', function filter(callbackfn /* , thisArg */) {
  var list = $filter(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  return fromSpeciesAndList(this, list);
});

},{"../internals/array-buffer-view-core":582,"../internals/array-iteration":591,"../internals/typed-array-from-species-and-list":798}],1030:[function(require,module,exports){
'use strict';
var ArrayBufferViewCore = require('../internals/array-buffer-view-core');
var $findIndex = require('../internals/array-iteration').findIndex;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.findindex
exportTypedArrayMethod('findIndex', function findIndex(predicate /* , thisArg */) {
  return $findIndex(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});

},{"../internals/array-buffer-view-core":582,"../internals/array-iteration":591}],1031:[function(require,module,exports){
'use strict';
var ArrayBufferViewCore = require('../internals/array-buffer-view-core');
var $findLastIndex = require('../internals/array-iteration-from-last').findLastIndex;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.findLastIndex` method
// https://github.com/tc39/proposal-array-find-from-last
exportTypedArrayMethod('findLastIndex', function findLastIndex(predicate /* , thisArg */) {
  return $findLastIndex(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});

},{"../internals/array-buffer-view-core":582,"../internals/array-iteration-from-last":590}],1032:[function(require,module,exports){
'use strict';
var ArrayBufferViewCore = require('../internals/array-buffer-view-core');
var $findLast = require('../internals/array-iteration-from-last').findLast;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.findLast` method
// https://github.com/tc39/proposal-array-find-from-last
exportTypedArrayMethod('findLast', function findLast(predicate /* , thisArg */) {
  return $findLast(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});

},{"../internals/array-buffer-view-core":582,"../internals/array-iteration-from-last":590}],1033:[function(require,module,exports){
'use strict';
var ArrayBufferViewCore = require('../internals/array-buffer-view-core');
var $find = require('../internals/array-iteration').find;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.find` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.find
exportTypedArrayMethod('find', function find(predicate /* , thisArg */) {
  return $find(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});

},{"../internals/array-buffer-view-core":582,"../internals/array-iteration":591}],1034:[function(require,module,exports){
var createTypedArrayConstructor = require('../internals/typed-array-constructor');

// `Float32Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Float32', function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"../internals/typed-array-constructor":796}],1035:[function(require,module,exports){
var createTypedArrayConstructor = require('../internals/typed-array-constructor');

// `Float64Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Float64', function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"../internals/typed-array-constructor":796}],1036:[function(require,module,exports){
'use strict';
var ArrayBufferViewCore = require('../internals/array-buffer-view-core');
var $forEach = require('../internals/array-iteration').forEach;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.forEach` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.foreach
exportTypedArrayMethod('forEach', function forEach(callbackfn /* , thisArg */) {
  $forEach(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});

},{"../internals/array-buffer-view-core":582,"../internals/array-iteration":591}],1037:[function(require,module,exports){
'use strict';
var TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS = require('../internals/typed-array-constructors-require-wrappers');
var exportTypedArrayStaticMethod = require('../internals/array-buffer-view-core').exportTypedArrayStaticMethod;
var typedArrayFrom = require('../internals/typed-array-from');

// `%TypedArray%.from` method
// https://tc39.es/ecma262/#sec-%typedarray%.from
exportTypedArrayStaticMethod('from', typedArrayFrom, TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS);

},{"../internals/array-buffer-view-core":582,"../internals/typed-array-constructors-require-wrappers":797,"../internals/typed-array-from":799}],1038:[function(require,module,exports){
'use strict';
var ArrayBufferViewCore = require('../internals/array-buffer-view-core');
var $includes = require('../internals/array-includes').includes;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.includes` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.includes
exportTypedArrayMethod('includes', function includes(searchElement /* , fromIndex */) {
  return $includes(aTypedArray(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
});

},{"../internals/array-buffer-view-core":582,"../internals/array-includes":589}],1039:[function(require,module,exports){
'use strict';
var ArrayBufferViewCore = require('../internals/array-buffer-view-core');
var $indexOf = require('../internals/array-includes').indexOf;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.indexOf` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.indexof
exportTypedArrayMethod('indexOf', function indexOf(searchElement /* , fromIndex */) {
  return $indexOf(aTypedArray(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
});

},{"../internals/array-buffer-view-core":582,"../internals/array-includes":589}],1040:[function(require,module,exports){
var createTypedArrayConstructor = require('../internals/typed-array-constructor');

// `Int16Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Int16', function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"../internals/typed-array-constructor":796}],1041:[function(require,module,exports){
var createTypedArrayConstructor = require('../internals/typed-array-constructor');

// `Int32Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Int32', function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"../internals/typed-array-constructor":796}],1042:[function(require,module,exports){
var createTypedArrayConstructor = require('../internals/typed-array-constructor');

// `Int8Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Int8', function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"../internals/typed-array-constructor":796}],1043:[function(require,module,exports){
'use strict';
var global = require('../internals/global');
var fails = require('../internals/fails');
var uncurryThis = require('../internals/function-uncurry-this');
var ArrayBufferViewCore = require('../internals/array-buffer-view-core');
var ArrayIterators = require('../modules/es.array.iterator');
var wellKnownSymbol = require('../internals/well-known-symbol');

var ITERATOR = wellKnownSymbol('iterator');
var Uint8Array = global.Uint8Array;
var arrayValues = uncurryThis(ArrayIterators.values);
var arrayKeys = uncurryThis(ArrayIterators.keys);
var arrayEntries = uncurryThis(ArrayIterators.entries);
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var TypedArrayPrototype = Uint8Array && Uint8Array.prototype;

var GENERIC = !fails(function () {
  TypedArrayPrototype[ITERATOR].call([1]);
});

var ITERATOR_IS_VALUES = !!TypedArrayPrototype
  && TypedArrayPrototype.values
  && TypedArrayPrototype[ITERATOR] === TypedArrayPrototype.values
  && TypedArrayPrototype.values.name === 'values';

var typedArrayValues = function values() {
  return arrayValues(aTypedArray(this));
};

// `%TypedArray%.prototype.entries` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.entries
exportTypedArrayMethod('entries', function entries() {
  return arrayEntries(aTypedArray(this));
}, GENERIC);
// `%TypedArray%.prototype.keys` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.keys
exportTypedArrayMethod('keys', function keys() {
  return arrayKeys(aTypedArray(this));
}, GENERIC);
// `%TypedArray%.prototype.values` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.values
exportTypedArrayMethod('values', typedArrayValues, GENERIC || !ITERATOR_IS_VALUES, { name: 'values' });
// `%TypedArray%.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype-@@iterator
exportTypedArrayMethod(ITERATOR, typedArrayValues, GENERIC || !ITERATOR_IS_VALUES, { name: 'values' });

},{"../internals/array-buffer-view-core":582,"../internals/fails":653,"../internals/function-uncurry-this":665,"../internals/global":672,"../internals/well-known-symbol":809,"../modules/es.array.iterator":835}],1044:[function(require,module,exports){
'use strict';
var ArrayBufferViewCore = require('../internals/array-buffer-view-core');
var uncurryThis = require('../internals/function-uncurry-this');

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var $join = uncurryThis([].join);

// `%TypedArray%.prototype.join` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.join
exportTypedArrayMethod('join', function join(separator) {
  return $join(aTypedArray(this), separator);
});

},{"../internals/array-buffer-view-core":582,"../internals/function-uncurry-this":665}],1045:[function(require,module,exports){
'use strict';
var ArrayBufferViewCore = require('../internals/array-buffer-view-core');
var apply = require('../internals/function-apply');
var $lastIndexOf = require('../internals/array-last-index-of');

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.lastIndexOf` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.lastindexof
exportTypedArrayMethod('lastIndexOf', function lastIndexOf(searchElement /* , fromIndex */) {
  var length = arguments.length;
  return apply($lastIndexOf, aTypedArray(this), length > 1 ? [searchElement, arguments[1]] : [searchElement]);
});

},{"../internals/array-buffer-view-core":582,"../internals/array-last-index-of":592,"../internals/function-apply":657}],1046:[function(require,module,exports){
'use strict';
var ArrayBufferViewCore = require('../internals/array-buffer-view-core');
var $map = require('../internals/array-iteration').map;
var typedArraySpeciesConstructor = require('../internals/typed-array-species-constructor');

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.map` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.map
exportTypedArrayMethod('map', function map(mapfn /* , thisArg */) {
  return $map(aTypedArray(this), mapfn, arguments.length > 1 ? arguments[1] : undefined, function (O, length) {
    return new (typedArraySpeciesConstructor(O))(length);
  });
});

},{"../internals/array-buffer-view-core":582,"../internals/array-iteration":591,"../internals/typed-array-species-constructor":800}],1047:[function(require,module,exports){
'use strict';
var ArrayBufferViewCore = require('../internals/array-buffer-view-core');
var TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS = require('../internals/typed-array-constructors-require-wrappers');

var aTypedArrayConstructor = ArrayBufferViewCore.aTypedArrayConstructor;
var exportTypedArrayStaticMethod = ArrayBufferViewCore.exportTypedArrayStaticMethod;

// `%TypedArray%.of` method
// https://tc39.es/ecma262/#sec-%typedarray%.of
exportTypedArrayStaticMethod('of', function of(/* ...items */) {
  var index = 0;
  var length = arguments.length;
  var result = new (aTypedArrayConstructor(this))(length);
  while (length > index) result[index] = arguments[index++];
  return result;
}, TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS);

},{"../internals/array-buffer-view-core":582,"../internals/typed-array-constructors-require-wrappers":797}],1048:[function(require,module,exports){
'use strict';
var ArrayBufferViewCore = require('../internals/array-buffer-view-core');
var $reduceRight = require('../internals/array-reduce').right;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.reduceRight` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reduceright
exportTypedArrayMethod('reduceRight', function reduceRight(callbackfn /* , initialValue */) {
  var length = arguments.length;
  return $reduceRight(aTypedArray(this), callbackfn, length, length > 1 ? arguments[1] : undefined);
});

},{"../internals/array-buffer-view-core":582,"../internals/array-reduce":595}],1049:[function(require,module,exports){
'use strict';
var ArrayBufferViewCore = require('../internals/array-buffer-view-core');
var $reduce = require('../internals/array-reduce').left;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.reduce` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reduce
exportTypedArrayMethod('reduce', function reduce(callbackfn /* , initialValue */) {
  var length = arguments.length;
  return $reduce(aTypedArray(this), callbackfn, length, length > 1 ? arguments[1] : undefined);
});

},{"../internals/array-buffer-view-core":582,"../internals/array-reduce":595}],1050:[function(require,module,exports){
'use strict';
var ArrayBufferViewCore = require('../internals/array-buffer-view-core');

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var floor = Math.floor;

// `%TypedArray%.prototype.reverse` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reverse
exportTypedArrayMethod('reverse', function reverse() {
  var that = this;
  var length = aTypedArray(that).length;
  var middle = floor(length / 2);
  var index = 0;
  var value;
  while (index < middle) {
    value = that[index];
    that[index++] = that[--length];
    that[length] = value;
  } return that;
});

},{"../internals/array-buffer-view-core":582}],1051:[function(require,module,exports){
'use strict';
var global = require('../internals/global');
var call = require('../internals/function-call');
var ArrayBufferViewCore = require('../internals/array-buffer-view-core');
var lengthOfArrayLike = require('../internals/length-of-array-like');
var toOffset = require('../internals/to-offset');
var toIndexedObject = require('../internals/to-object');
var fails = require('../internals/fails');

var RangeError = global.RangeError;
var Int8Array = global.Int8Array;
var Int8ArrayPrototype = Int8Array && Int8Array.prototype;
var $set = Int8ArrayPrototype && Int8ArrayPrototype.set;
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

var WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS = !fails(function () {
  // eslint-disable-next-line es/no-typed-arrays -- required for testing
  var array = new Uint8ClampedArray(2);
  call($set, array, { length: 1, 0: 3 }, 1);
  return array[1] !== 3;
});

// https://bugs.chromium.org/p/v8/issues/detail?id=11294 and other
var TO_OBJECT_BUG = WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS && ArrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS && fails(function () {
  var array = new Int8Array(2);
  array.set(1);
  array.set('2', 1);
  return array[0] !== 0 || array[1] !== 2;
});

// `%TypedArray%.prototype.set` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.set
exportTypedArrayMethod('set', function set(arrayLike /* , offset */) {
  aTypedArray(this);
  var offset = toOffset(arguments.length > 1 ? arguments[1] : undefined, 1);
  var src = toIndexedObject(arrayLike);
  if (WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS) return call($set, this, src, offset);
  var length = this.length;
  var len = lengthOfArrayLike(src);
  var index = 0;
  if (len + offset > length) throw RangeError('Wrong length');
  while (index < len) this[offset + index] = src[index++];
}, !WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS || TO_OBJECT_BUG);

},{"../internals/array-buffer-view-core":582,"../internals/fails":653,"../internals/function-call":661,"../internals/global":672,"../internals/length-of-array-like":704,"../internals/to-object":787,"../internals/to-offset":788}],1052:[function(require,module,exports){
'use strict';
var ArrayBufferViewCore = require('../internals/array-buffer-view-core');
var typedArraySpeciesConstructor = require('../internals/typed-array-species-constructor');
var fails = require('../internals/fails');
var arraySlice = require('../internals/array-slice');

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

var FORCED = fails(function () {
  // eslint-disable-next-line es/no-typed-arrays -- required for testing
  new Int8Array(1).slice();
});

// `%TypedArray%.prototype.slice` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.slice
exportTypedArrayMethod('slice', function slice(start, end) {
  var list = arraySlice(aTypedArray(this), start, end);
  var C = typedArraySpeciesConstructor(this);
  var index = 0;
  var length = list.length;
  var result = new C(length);
  while (length > index) result[index] = list[index++];
  return result;
}, FORCED);

},{"../internals/array-buffer-view-core":582,"../internals/array-slice":598,"../internals/fails":653,"../internals/typed-array-species-constructor":800}],1053:[function(require,module,exports){
'use strict';
var ArrayBufferViewCore = require('../internals/array-buffer-view-core');
var $some = require('../internals/array-iteration').some;

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.some` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.some
exportTypedArrayMethod('some', function some(callbackfn /* , thisArg */) {
  return $some(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});

},{"../internals/array-buffer-view-core":582,"../internals/array-iteration":591}],1054:[function(require,module,exports){
'use strict';
var global = require('../internals/global');
var uncurryThis = require('../internals/function-uncurry-this-clause');
var fails = require('../internals/fails');
var aCallable = require('../internals/a-callable');
var internalSort = require('../internals/array-sort');
var ArrayBufferViewCore = require('../internals/array-buffer-view-core');
var FF = require('../internals/engine-ff-version');
var IE_OR_EDGE = require('../internals/engine-is-ie-or-edge');
var V8 = require('../internals/engine-v8-version');
var WEBKIT = require('../internals/engine-webkit-version');

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var Uint16Array = global.Uint16Array;
var nativeSort = Uint16Array && uncurryThis(Uint16Array.prototype.sort);

// WebKit
var ACCEPT_INCORRECT_ARGUMENTS = !!nativeSort && !(fails(function () {
  nativeSort(new Uint16Array(2), null);
}) && fails(function () {
  nativeSort(new Uint16Array(2), {});
}));

var STABLE_SORT = !!nativeSort && !fails(function () {
  // feature detection can be too slow, so check engines versions
  if (V8) return V8 < 74;
  if (FF) return FF < 67;
  if (IE_OR_EDGE) return true;
  if (WEBKIT) return WEBKIT < 602;

  var array = new Uint16Array(516);
  var expected = Array(516);
  var index, mod;

  for (index = 0; index < 516; index++) {
    mod = index % 4;
    array[index] = 515 - index;
    expected[index] = index - 2 * mod + 3;
  }

  nativeSort(array, function (a, b) {
    return (a / 4 | 0) - (b / 4 | 0);
  });

  for (index = 0; index < 516; index++) {
    if (array[index] !== expected[index]) return true;
  }
});

var getSortCompare = function (comparefn) {
  return function (x, y) {
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    // eslint-disable-next-line no-self-compare -- NaN check
    if (y !== y) return -1;
    // eslint-disable-next-line no-self-compare -- NaN check
    if (x !== x) return 1;
    if (x === 0 && y === 0) return 1 / x > 0 && 1 / y < 0 ? 1 : -1;
    return x > y;
  };
};

// `%TypedArray%.prototype.sort` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.sort
exportTypedArrayMethod('sort', function sort(comparefn) {
  if (comparefn !== undefined) aCallable(comparefn);
  if (STABLE_SORT) return nativeSort(this, comparefn);

  return internalSort(aTypedArray(this), getSortCompare(comparefn));
}, !STABLE_SORT || ACCEPT_INCORRECT_ARGUMENTS);

},{"../internals/a-callable":573,"../internals/array-buffer-view-core":582,"../internals/array-sort":599,"../internals/engine-ff-version":634,"../internals/engine-is-ie-or-edge":638,"../internals/engine-v8-version":644,"../internals/engine-webkit-version":645,"../internals/fails":653,"../internals/function-uncurry-this-clause":664,"../internals/global":672}],1055:[function(require,module,exports){
'use strict';
var ArrayBufferViewCore = require('../internals/array-buffer-view-core');
var toLength = require('../internals/to-length');
var toAbsoluteIndex = require('../internals/to-absolute-index');
var typedArraySpeciesConstructor = require('../internals/typed-array-species-constructor');

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.subarray` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.subarray
exportTypedArrayMethod('subarray', function subarray(begin, end) {
  var O = aTypedArray(this);
  var length = O.length;
  var beginIndex = toAbsoluteIndex(begin, length);
  var C = typedArraySpeciesConstructor(O);
  return new C(
    O.buffer,
    O.byteOffset + beginIndex * O.BYTES_PER_ELEMENT,
    toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - beginIndex)
  );
});

},{"../internals/array-buffer-view-core":582,"../internals/to-absolute-index":781,"../internals/to-length":786,"../internals/typed-array-species-constructor":800}],1056:[function(require,module,exports){
'use strict';
var global = require('../internals/global');
var apply = require('../internals/function-apply');
var ArrayBufferViewCore = require('../internals/array-buffer-view-core');
var fails = require('../internals/fails');
var arraySlice = require('../internals/array-slice');

var Int8Array = global.Int8Array;
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var $toLocaleString = [].toLocaleString;

// iOS Safari 6.x fails here
var TO_LOCALE_STRING_BUG = !!Int8Array && fails(function () {
  $toLocaleString.call(new Int8Array(1));
});

var FORCED = fails(function () {
  return [1, 2].toLocaleString() != new Int8Array([1, 2]).toLocaleString();
}) || !fails(function () {
  Int8Array.prototype.toLocaleString.call([1, 2]);
});

// `%TypedArray%.prototype.toLocaleString` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tolocalestring
exportTypedArrayMethod('toLocaleString', function toLocaleString() {
  return apply(
    $toLocaleString,
    TO_LOCALE_STRING_BUG ? arraySlice(aTypedArray(this)) : aTypedArray(this),
    arraySlice(arguments)
  );
}, FORCED);

},{"../internals/array-buffer-view-core":582,"../internals/array-slice":598,"../internals/fails":653,"../internals/function-apply":657,"../internals/global":672}],1057:[function(require,module,exports){
'use strict';
var arrayToReversed = require('../internals/array-to-reversed');
var ArrayBufferViewCore = require('../internals/array-buffer-view-core');

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var getTypedArrayConstructor = ArrayBufferViewCore.getTypedArrayConstructor;

// `%TypedArray%.prototype.toReversed` method
// https://tc39.es/proposal-change-array-by-copy/#sec-%typedarray%.prototype.toReversed
exportTypedArrayMethod('toReversed', function toReversed() {
  return arrayToReversed(aTypedArray(this), getTypedArrayConstructor(this));
});

},{"../internals/array-buffer-view-core":582,"../internals/array-to-reversed":602}],1058:[function(require,module,exports){
'use strict';
var ArrayBufferViewCore = require('../internals/array-buffer-view-core');
var uncurryThis = require('../internals/function-uncurry-this');
var aCallable = require('../internals/a-callable');
var arrayFromConstructorAndList = require('../internals/array-from-constructor-and-list');

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var getTypedArrayConstructor = ArrayBufferViewCore.getTypedArrayConstructor;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var sort = uncurryThis(ArrayBufferViewCore.TypedArrayPrototype.sort);

// `%TypedArray%.prototype.toSorted` method
// https://tc39.es/proposal-change-array-by-copy/#sec-%typedarray%.prototype.toSorted
exportTypedArrayMethod('toSorted', function toSorted(compareFn) {
  if (compareFn !== undefined) aCallable(compareFn);
  var O = aTypedArray(this);
  var A = arrayFromConstructorAndList(getTypedArrayConstructor(O), O);
  return sort(A, compareFn);
});

},{"../internals/a-callable":573,"../internals/array-buffer-view-core":582,"../internals/array-from-constructor-and-list":587,"../internals/function-uncurry-this":665}],1059:[function(require,module,exports){
'use strict';
var exportTypedArrayMethod = require('../internals/array-buffer-view-core').exportTypedArrayMethod;
var fails = require('../internals/fails');
var global = require('../internals/global');
var uncurryThis = require('../internals/function-uncurry-this');

var Uint8Array = global.Uint8Array;
var Uint8ArrayPrototype = Uint8Array && Uint8Array.prototype || {};
var arrayToString = [].toString;
var join = uncurryThis([].join);

if (fails(function () { arrayToString.call({}); })) {
  arrayToString = function toString() {
    return join(this);
  };
}

var IS_NOT_ARRAY_METHOD = Uint8ArrayPrototype.toString != arrayToString;

// `%TypedArray%.prototype.toString` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tostring
exportTypedArrayMethod('toString', arrayToString, IS_NOT_ARRAY_METHOD);

},{"../internals/array-buffer-view-core":582,"../internals/fails":653,"../internals/function-uncurry-this":665,"../internals/global":672}],1060:[function(require,module,exports){
var createTypedArrayConstructor = require('../internals/typed-array-constructor');

// `Uint16Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Uint16', function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"../internals/typed-array-constructor":796}],1061:[function(require,module,exports){
var createTypedArrayConstructor = require('../internals/typed-array-constructor');

// `Uint32Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Uint32', function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"../internals/typed-array-constructor":796}],1062:[function(require,module,exports){
var createTypedArrayConstructor = require('../internals/typed-array-constructor');

// `Uint8Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Uint8', function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"../internals/typed-array-constructor":796}],1063:[function(require,module,exports){
var createTypedArrayConstructor = require('../internals/typed-array-constructor');

// `Uint8ClampedArray` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Uint8', function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);

},{"../internals/typed-array-constructor":796}],1064:[function(require,module,exports){
'use strict';
var arrayWith = require('../internals/array-with');
var ArrayBufferViewCore = require('../internals/array-buffer-view-core');
var isBigIntArray = require('../internals/is-big-int-array');
var toIntegerOrInfinity = require('../internals/to-integer-or-infinity');
var toBigInt = require('../internals/to-big-int');

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var getTypedArrayConstructor = ArrayBufferViewCore.getTypedArrayConstructor;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

var PROPER_ORDER = !!function () {
  try {
    // eslint-disable-next-line no-throw-literal, es/no-typed-arrays, es/no-array-prototype-with -- required for testing
    new Int8Array(1)['with'](2, { valueOf: function () { throw 8; } });
  } catch (error) {
    // some early implementations, like WebKit, does not follow the final semantic
    // https://github.com/tc39/proposal-change-array-by-copy/pull/86
    return error === 8;
  }
}();

// `%TypedArray%.prototype.with` method
// https://tc39.es/proposal-change-array-by-copy/#sec-%typedarray%.prototype.with
exportTypedArrayMethod('with', { 'with': function (index, value) {
  var O = aTypedArray(this);
  var relativeIndex = toIntegerOrInfinity(index);
  var actualValue = isBigIntArray(O) ? toBigInt(value) : +value;
  return arrayWith(O, getTypedArrayConstructor(O), relativeIndex, actualValue);
} }['with'], !PROPER_ORDER);

},{"../internals/array-buffer-view-core":582,"../internals/array-with":603,"../internals/is-big-int-array":687,"../internals/to-big-int":782,"../internals/to-integer-or-infinity":785}],1065:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var uncurryThis = require('../internals/function-uncurry-this');
var toString = require('../internals/to-string');

var fromCharCode = String.fromCharCode;
var charAt = uncurryThis(''.charAt);
var exec = uncurryThis(/./.exec);
var stringSlice = uncurryThis(''.slice);

var hex2 = /^[\da-f]{2}$/i;
var hex4 = /^[\da-f]{4}$/i;

// `unescape` method
// https://tc39.es/ecma262/#sec-unescape-string
$({ global: true }, {
  unescape: function unescape(string) {
    var str = toString(string);
    var result = '';
    var length = str.length;
    var index = 0;
    var chr, part;
    while (index < length) {
      chr = charAt(str, index++);
      if (chr === '%') {
        if (charAt(str, index) === 'u') {
          part = stringSlice(str, index + 1, index + 5);
          if (exec(hex4, part)) {
            result += fromCharCode(parseInt(part, 16));
            index += 5;
            continue;
          }
        } else {
          part = stringSlice(str, index, index + 2);
          if (exec(hex2, part)) {
            result += fromCharCode(parseInt(part, 16));
            index += 2;
            continue;
          }
        }
      }
      result += chr;
    } return result;
  }
});

},{"../internals/export":652,"../internals/function-uncurry-this":665,"../internals/to-string":793}],1066:[function(require,module,exports){
'use strict';
var FREEZING = require('../internals/freezing');
var global = require('../internals/global');
var uncurryThis = require('../internals/function-uncurry-this');
var defineBuiltIns = require('../internals/define-built-ins');
var InternalMetadataModule = require('../internals/internal-metadata');
var collection = require('../internals/collection');
var collectionWeak = require('../internals/collection-weak');
var isObject = require('../internals/is-object');
var enforceInternalState = require('../internals/internal-state').enforce;
var fails = require('../internals/fails');
var NATIVE_WEAK_MAP = require('../internals/weak-map-basic-detection');

var $Object = Object;
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray = Array.isArray;
// eslint-disable-next-line es/no-object-isextensible -- safe
var isExtensible = $Object.isExtensible;
// eslint-disable-next-line es/no-object-isfrozen -- safe
var isFrozen = $Object.isFrozen;
// eslint-disable-next-line es/no-object-issealed -- safe
var isSealed = $Object.isSealed;
// eslint-disable-next-line es/no-object-freeze -- safe
var freeze = $Object.freeze;
// eslint-disable-next-line es/no-object-seal -- safe
var seal = $Object.seal;

var FROZEN = {};
var SEALED = {};
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var InternalWeakMap;

var wrapper = function (init) {
  return function WeakMap() {
    return init(this, arguments.length ? arguments[0] : undefined);
  };
};

// `WeakMap` constructor
// https://tc39.es/ecma262/#sec-weakmap-constructor
var $WeakMap = collection('WeakMap', wrapper, collectionWeak);
var WeakMapPrototype = $WeakMap.prototype;
var nativeSet = uncurryThis(WeakMapPrototype.set);

// Chakra Edge bug: adding frozen arrays to WeakMap unfreeze them
var hasMSEdgeFreezingBug = function () {
  return FREEZING && fails(function () {
    var frozenArray = freeze([]);
    nativeSet(new $WeakMap(), frozenArray, 1);
    return !isFrozen(frozenArray);
  });
};

// IE11 WeakMap frozen keys fix
// We can't use feature detection because it crash some old IE builds
// https://github.com/zloirock/core-js/issues/485
if (NATIVE_WEAK_MAP) if (IS_IE11) {
  InternalWeakMap = collectionWeak.getConstructor(wrapper, 'WeakMap', true);
  InternalMetadataModule.enable();
  var nativeDelete = uncurryThis(WeakMapPrototype['delete']);
  var nativeHas = uncurryThis(WeakMapPrototype.has);
  var nativeGet = uncurryThis(WeakMapPrototype.get);
  defineBuiltIns(WeakMapPrototype, {
    'delete': function (key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceInternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeDelete(this, key) || state.frozen['delete'](key);
      } return nativeDelete(this, key);
    },
    has: function has(key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceInternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeHas(this, key) || state.frozen.has(key);
      } return nativeHas(this, key);
    },
    get: function get(key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceInternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeHas(this, key) ? nativeGet(this, key) : state.frozen.get(key);
      } return nativeGet(this, key);
    },
    set: function set(key, value) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceInternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        nativeHas(this, key) ? nativeSet(this, key, value) : state.frozen.set(key, value);
      } else nativeSet(this, key, value);
      return this;
    }
  });
// Chakra Edge frozen keys fix
} else if (hasMSEdgeFreezingBug()) {
  defineBuiltIns(WeakMapPrototype, {
    set: function set(key, value) {
      var arrayIntegrityLevel;
      if (isArray(key)) {
        if (isFrozen(key)) arrayIntegrityLevel = FROZEN;
        else if (isSealed(key)) arrayIntegrityLevel = SEALED;
      }
      nativeSet(this, key, value);
      if (arrayIntegrityLevel == FROZEN) freeze(key);
      if (arrayIntegrityLevel == SEALED) seal(key);
      return this;
    }
  });
}

},{"../internals/collection":611,"../internals/collection-weak":610,"../internals/define-built-ins":624,"../internals/fails":653,"../internals/freezing":656,"../internals/function-uncurry-this":665,"../internals/global":672,"../internals/internal-metadata":683,"../internals/internal-state":684,"../internals/is-object":694,"../internals/weak-map-basic-detection":806}],1067:[function(require,module,exports){
// TODO: Remove this module from `core-js@4` since it's replaced to module below
require('../modules/es.weak-map.constructor');

},{"../modules/es.weak-map.constructor":1066}],1068:[function(require,module,exports){
'use strict';
var collection = require('../internals/collection');
var collectionWeak = require('../internals/collection-weak');

// `WeakSet` constructor
// https://tc39.es/ecma262/#sec-weakset-constructor
collection('WeakSet', function (init) {
  return function WeakSet() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionWeak);

},{"../internals/collection":611,"../internals/collection-weak":610}],1069:[function(require,module,exports){
// TODO: Remove this module from `core-js@4` since it's replaced to module below
require('../modules/es.weak-set.constructor');

},{"../modules/es.weak-set.constructor":1068}],1070:[function(require,module,exports){
var $ = require('../internals/export');
var global = require('../internals/global');
var getBuiltIn = require('../internals/get-built-in');
var uncurryThis = require('../internals/function-uncurry-this');
var call = require('../internals/function-call');
var fails = require('../internals/fails');
var toString = require('../internals/to-string');
var hasOwn = require('../internals/has-own-property');
var validateArgumentsLength = require('../internals/validate-arguments-length');
var ctoi = require('../internals/base64-map').ctoi;

var disallowed = /[^\d+/a-z]/i;
var whitespaces = /[\t\n\f\r ]+/g;
var finalEq = /[=]{1,2}$/;

var $atob = getBuiltIn('atob');
var fromCharCode = String.fromCharCode;
var charAt = uncurryThis(''.charAt);
var replace = uncurryThis(''.replace);
var exec = uncurryThis(disallowed.exec);

var NO_SPACES_IGNORE = fails(function () {
  return $atob(' ') !== '';
});

var NO_ENCODING_CHECK = !fails(function () {
  $atob('a');
});

var NO_ARG_RECEIVING_CHECK = !NO_SPACES_IGNORE && !NO_ENCODING_CHECK && !fails(function () {
  $atob();
});

var WRONG_ARITY = !NO_SPACES_IGNORE && !NO_ENCODING_CHECK && $atob.length !== 1;

// `atob` method
// https://html.spec.whatwg.org/multipage/webappapis.html#dom-atob
$({ global: true, bind: true, enumerable: true, forced: NO_SPACES_IGNORE || NO_ENCODING_CHECK || NO_ARG_RECEIVING_CHECK || WRONG_ARITY }, {
  atob: function atob(data) {
    validateArgumentsLength(arguments.length, 1);
    // `webpack` dev server bug on IE global methods - use call(fn, global, ...)
    if (NO_ARG_RECEIVING_CHECK || WRONG_ARITY) return call($atob, global, data);
    var string = replace(toString(data), whitespaces, '');
    var output = '';
    var position = 0;
    var bc = 0;
    var chr, bs;
    if (string.length % 4 == 0) {
      string = replace(string, finalEq, '');
    }
    if (string.length % 4 == 1 || exec(disallowed, string)) {
      throw new (getBuiltIn('DOMException'))('The string is not correctly encoded', 'InvalidCharacterError');
    }
    while (chr = charAt(string, position++)) {
      if (hasOwn(ctoi, chr)) {
        bs = bc % 4 ? bs * 64 + ctoi[chr] : ctoi[chr];
        if (bc++ % 4) output += fromCharCode(255 & bs >> (-2 * bc & 6));
      }
    } return output;
  }
});

},{"../internals/base64-map":604,"../internals/export":652,"../internals/fails":653,"../internals/function-call":661,"../internals/function-uncurry-this":665,"../internals/get-built-in":666,"../internals/global":672,"../internals/has-own-property":673,"../internals/to-string":793,"../internals/validate-arguments-length":805}],1071:[function(require,module,exports){
var $ = require('../internals/export');
var global = require('../internals/global');
var getBuiltIn = require('../internals/get-built-in');
var uncurryThis = require('../internals/function-uncurry-this');
var call = require('../internals/function-call');
var fails = require('../internals/fails');
var toString = require('../internals/to-string');
var validateArgumentsLength = require('../internals/validate-arguments-length');
var itoc = require('../internals/base64-map').itoc;

var $btoa = getBuiltIn('btoa');
var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);

var NO_ARG_RECEIVING_CHECK = !!$btoa && !fails(function () {
  $btoa();
});

var WRONG_ARG_CONVERSION = !!$btoa && fails(function () {
  return $btoa(null) !== 'bnVsbA==';
});

var WRONG_ARITY = !!$btoa && $btoa.length !== 1;

// `btoa` method
// https://html.spec.whatwg.org/multipage/webappapis.html#dom-btoa
$({ global: true, bind: true, enumerable: true, forced: NO_ARG_RECEIVING_CHECK || WRONG_ARG_CONVERSION || WRONG_ARITY }, {
  btoa: function btoa(data) {
    validateArgumentsLength(arguments.length, 1);
    // `webpack` dev server bug on IE global methods - use call(fn, global, ...)
    if (NO_ARG_RECEIVING_CHECK || WRONG_ARG_CONVERSION || WRONG_ARITY) return call($btoa, global, toString(data));
    var string = toString(data);
    var output = '';
    var position = 0;
    var map = itoc;
    var block, charCode;
    while (charAt(string, position) || (map = '=', position % 1)) {
      charCode = charCodeAt(string, position += 3 / 4);
      if (charCode > 0xFF) {
        throw new (getBuiltIn('DOMException'))('The string contains characters outside of the Latin1 range', 'InvalidCharacterError');
      }
      block = block << 8 | charCode;
      output += charAt(map, 63 & block >> 8 - position % 1 * 8);
    } return output;
  }
});

},{"../internals/base64-map":604,"../internals/export":652,"../internals/fails":653,"../internals/function-call":661,"../internals/function-uncurry-this":665,"../internals/get-built-in":666,"../internals/global":672,"../internals/to-string":793,"../internals/validate-arguments-length":805}],1072:[function(require,module,exports){
var $ = require('../internals/export');
var global = require('../internals/global');
var clearImmediate = require('../internals/task').clear;

// `clearImmediate` method
// http://w3c.github.io/setImmediate/#si-clearImmediate
$({ global: true, bind: true, enumerable: true, forced: global.clearImmediate !== clearImmediate }, {
  clearImmediate: clearImmediate
});

},{"../internals/export":652,"../internals/global":672,"../internals/task":779}],1073:[function(require,module,exports){
var global = require('../internals/global');
var DOMIterables = require('../internals/dom-iterables');
var DOMTokenListPrototype = require('../internals/dom-token-list-prototype');
var forEach = require('../internals/array-for-each');
var createNonEnumerableProperty = require('../internals/create-non-enumerable-property');

var handlePrototype = function (CollectionPrototype) {
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
  } catch (error) {
    CollectionPrototype.forEach = forEach;
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  if (DOMIterables[COLLECTION_NAME]) {
    handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype);
  }
}

handlePrototype(DOMTokenListPrototype);

},{"../internals/array-for-each":586,"../internals/create-non-enumerable-property":617,"../internals/dom-iterables":632,"../internals/dom-token-list-prototype":633,"../internals/global":672}],1074:[function(require,module,exports){
var global = require('../internals/global');
var DOMIterables = require('../internals/dom-iterables');
var DOMTokenListPrototype = require('../internals/dom-token-list-prototype');
var ArrayIteratorMethods = require('../modules/es.array.iterator');
var createNonEnumerableProperty = require('../internals/create-non-enumerable-property');
var wellKnownSymbol = require('../internals/well-known-symbol');

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');

},{"../internals/create-non-enumerable-property":617,"../internals/dom-iterables":632,"../internals/dom-token-list-prototype":633,"../internals/global":672,"../internals/well-known-symbol":809,"../modules/es.array.iterator":835}],1075:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var tryNodeRequire = require('../internals/try-node-require');
var getBuiltIn = require('../internals/get-built-in');
var fails = require('../internals/fails');
var create = require('../internals/object-create');
var createPropertyDescriptor = require('../internals/create-property-descriptor');
var defineProperty = require('../internals/object-define-property').f;
var defineBuiltIn = require('../internals/define-built-in');
var defineBuiltInAccessor = require('../internals/define-built-in-accessor');
var hasOwn = require('../internals/has-own-property');
var anInstance = require('../internals/an-instance');
var anObject = require('../internals/an-object');
var errorToString = require('../internals/error-to-string');
var normalizeStringArgument = require('../internals/normalize-string-argument');
var DOMExceptionConstants = require('../internals/dom-exception-constants');
var clearErrorStack = require('../internals/error-stack-clear');
var InternalStateModule = require('../internals/internal-state');
var DESCRIPTORS = require('../internals/descriptors');
var IS_PURE = require('../internals/is-pure');

var DOM_EXCEPTION = 'DOMException';
var DATA_CLONE_ERR = 'DATA_CLONE_ERR';
var Error = getBuiltIn('Error');
// NodeJS < 17.0 does not expose `DOMException` to global
var NativeDOMException = getBuiltIn(DOM_EXCEPTION) || (function () {
  try {
    // NodeJS < 15.0 does not expose `MessageChannel` to global
    var MessageChannel = getBuiltIn('MessageChannel') || tryNodeRequire('worker_threads').MessageChannel;
    // eslint-disable-next-line es/no-weak-map, unicorn/require-post-message-target-origin -- safe
    new MessageChannel().port1.postMessage(new WeakMap());
  } catch (error) {
    if (error.name == DATA_CLONE_ERR && error.code == 25) return error.constructor;
  }
})();
var NativeDOMExceptionPrototype = NativeDOMException && NativeDOMException.prototype;
var ErrorPrototype = Error.prototype;
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(DOM_EXCEPTION);
var HAS_STACK = 'stack' in Error(DOM_EXCEPTION);

var codeFor = function (name) {
  return hasOwn(DOMExceptionConstants, name) && DOMExceptionConstants[name].m ? DOMExceptionConstants[name].c : 0;
};

var $DOMException = function DOMException() {
  anInstance(this, DOMExceptionPrototype);
  var argumentsLength = arguments.length;
  var message = normalizeStringArgument(argumentsLength < 1 ? undefined : arguments[0]);
  var name = normalizeStringArgument(argumentsLength < 2 ? undefined : arguments[1], 'Error');
  var code = codeFor(name);
  setInternalState(this, {
    type: DOM_EXCEPTION,
    name: name,
    message: message,
    code: code
  });
  if (!DESCRIPTORS) {
    this.name = name;
    this.message = message;
    this.code = code;
  }
  if (HAS_STACK) {
    var error = Error(message);
    error.name = DOM_EXCEPTION;
    defineProperty(this, 'stack', createPropertyDescriptor(1, clearErrorStack(error.stack, 1)));
  }
};

var DOMExceptionPrototype = $DOMException.prototype = create(ErrorPrototype);

var createGetterDescriptor = function (get) {
  return { enumerable: true, configurable: true, get: get };
};

var getterFor = function (key) {
  return createGetterDescriptor(function () {
    return getInternalState(this)[key];
  });
};

if (DESCRIPTORS) {
  // `DOMException.prototype.code` getter
  defineBuiltInAccessor(DOMExceptionPrototype, 'code', getterFor('code'));
  // `DOMException.prototype.message` getter
  defineBuiltInAccessor(DOMExceptionPrototype, 'message', getterFor('message'));
  // `DOMException.prototype.name` getter
  defineBuiltInAccessor(DOMExceptionPrototype, 'name', getterFor('name'));
}

defineProperty(DOMExceptionPrototype, 'constructor', createPropertyDescriptor(1, $DOMException));

// FF36- DOMException is a function, but can't be constructed
var INCORRECT_CONSTRUCTOR = fails(function () {
  return !(new NativeDOMException() instanceof Error);
});

// Safari 10.1 / Chrome 32- / IE8- DOMException.prototype.toString bugs
var INCORRECT_TO_STRING = INCORRECT_CONSTRUCTOR || fails(function () {
  return ErrorPrototype.toString !== errorToString || String(new NativeDOMException(1, 2)) !== '2: 1';
});

// Deno 1.6.3- DOMException.prototype.code just missed
var INCORRECT_CODE = INCORRECT_CONSTRUCTOR || fails(function () {
  return new NativeDOMException(1, 'DataCloneError').code !== 25;
});

// Deno 1.6.3- DOMException constants just missed
var MISSED_CONSTANTS = INCORRECT_CONSTRUCTOR
  || NativeDOMException[DATA_CLONE_ERR] !== 25
  || NativeDOMExceptionPrototype[DATA_CLONE_ERR] !== 25;

var FORCED_CONSTRUCTOR = IS_PURE ? INCORRECT_TO_STRING || INCORRECT_CODE || MISSED_CONSTANTS : INCORRECT_CONSTRUCTOR;

// `DOMException` constructor
// https://webidl.spec.whatwg.org/#idl-DOMException
$({ global: true, constructor: true, forced: FORCED_CONSTRUCTOR }, {
  DOMException: FORCED_CONSTRUCTOR ? $DOMException : NativeDOMException
});

var PolyfilledDOMException = getBuiltIn(DOM_EXCEPTION);
var PolyfilledDOMExceptionPrototype = PolyfilledDOMException.prototype;

if (INCORRECT_TO_STRING && (IS_PURE || NativeDOMException === PolyfilledDOMException)) {
  defineBuiltIn(PolyfilledDOMExceptionPrototype, 'toString', errorToString);
}

if (INCORRECT_CODE && DESCRIPTORS && NativeDOMException === PolyfilledDOMException) {
  defineBuiltInAccessor(PolyfilledDOMExceptionPrototype, 'code', createGetterDescriptor(function () {
    return codeFor(anObject(this).name);
  }));
}

// `DOMException` constants
for (var key in DOMExceptionConstants) if (hasOwn(DOMExceptionConstants, key)) {
  var constant = DOMExceptionConstants[key];
  var constantName = constant.s;
  var descriptor = createPropertyDescriptor(6, constant.c);
  if (!hasOwn(PolyfilledDOMException, constantName)) {
    defineProperty(PolyfilledDOMException, constantName, descriptor);
  }
  if (!hasOwn(PolyfilledDOMExceptionPrototype, constantName)) {
    defineProperty(PolyfilledDOMExceptionPrototype, constantName, descriptor);
  }
}

},{"../internals/an-instance":578,"../internals/an-object":579,"../internals/create-property-descriptor":618,"../internals/define-built-in":623,"../internals/define-built-in-accessor":622,"../internals/descriptors":627,"../internals/dom-exception-constants":631,"../internals/error-stack-clear":648,"../internals/error-to-string":651,"../internals/export":652,"../internals/fails":653,"../internals/get-built-in":666,"../internals/has-own-property":673,"../internals/internal-state":684,"../internals/is-pure":695,"../internals/normalize-string-argument":715,"../internals/object-create":721,"../internals/object-define-property":723,"../internals/try-node-require":794}],1076:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var global = require('../internals/global');
var getBuiltIn = require('../internals/get-built-in');
var createPropertyDescriptor = require('../internals/create-property-descriptor');
var defineProperty = require('../internals/object-define-property').f;
var hasOwn = require('../internals/has-own-property');
var anInstance = require('../internals/an-instance');
var inheritIfRequired = require('../internals/inherit-if-required');
var normalizeStringArgument = require('../internals/normalize-string-argument');
var DOMExceptionConstants = require('../internals/dom-exception-constants');
var clearErrorStack = require('../internals/error-stack-clear');
var DESCRIPTORS = require('../internals/descriptors');
var IS_PURE = require('../internals/is-pure');

var DOM_EXCEPTION = 'DOMException';
var Error = getBuiltIn('Error');
var NativeDOMException = getBuiltIn(DOM_EXCEPTION);

var $DOMException = function DOMException() {
  anInstance(this, DOMExceptionPrototype);
  var argumentsLength = arguments.length;
  var message = normalizeStringArgument(argumentsLength < 1 ? undefined : arguments[0]);
  var name = normalizeStringArgument(argumentsLength < 2 ? undefined : arguments[1], 'Error');
  var that = new NativeDOMException(message, name);
  var error = Error(message);
  error.name = DOM_EXCEPTION;
  defineProperty(that, 'stack', createPropertyDescriptor(1, clearErrorStack(error.stack, 1)));
  inheritIfRequired(that, this, $DOMException);
  return that;
};

var DOMExceptionPrototype = $DOMException.prototype = NativeDOMException.prototype;

var ERROR_HAS_STACK = 'stack' in Error(DOM_EXCEPTION);
var DOM_EXCEPTION_HAS_STACK = 'stack' in new NativeDOMException(1, 2);

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var descriptor = NativeDOMException && DESCRIPTORS && Object.getOwnPropertyDescriptor(global, DOM_EXCEPTION);

// Bun ~ 0.1.1 DOMException have incorrect descriptor and we can't redefine it
// https://github.com/Jarred-Sumner/bun/issues/399
var BUGGY_DESCRIPTOR = !!descriptor && !(descriptor.writable && descriptor.configurable);

var FORCED_CONSTRUCTOR = ERROR_HAS_STACK && !BUGGY_DESCRIPTOR && !DOM_EXCEPTION_HAS_STACK;

// `DOMException` constructor patch for `.stack` where it's required
// https://webidl.spec.whatwg.org/#es-DOMException-specialness
$({ global: true, constructor: true, forced: IS_PURE || FORCED_CONSTRUCTOR }, { // TODO: fix export logic
  DOMException: FORCED_CONSTRUCTOR ? $DOMException : NativeDOMException
});

var PolyfilledDOMException = getBuiltIn(DOM_EXCEPTION);
var PolyfilledDOMExceptionPrototype = PolyfilledDOMException.prototype;

if (PolyfilledDOMExceptionPrototype.constructor !== PolyfilledDOMException) {
  if (!IS_PURE) {
    defineProperty(PolyfilledDOMExceptionPrototype, 'constructor', createPropertyDescriptor(1, PolyfilledDOMException));
  }

  for (var key in DOMExceptionConstants) if (hasOwn(DOMExceptionConstants, key)) {
    var constant = DOMExceptionConstants[key];
    var constantName = constant.s;
    if (!hasOwn(PolyfilledDOMException, constantName)) {
      defineProperty(PolyfilledDOMException, constantName, createPropertyDescriptor(6, constant.c));
    }
  }
}

},{"../internals/an-instance":578,"../internals/create-property-descriptor":618,"../internals/descriptors":627,"../internals/dom-exception-constants":631,"../internals/error-stack-clear":648,"../internals/export":652,"../internals/get-built-in":666,"../internals/global":672,"../internals/has-own-property":673,"../internals/inherit-if-required":680,"../internals/is-pure":695,"../internals/normalize-string-argument":715,"../internals/object-define-property":723}],1077:[function(require,module,exports){
var getBuiltIn = require('../internals/get-built-in');
var setToStringTag = require('../internals/set-to-string-tag');

var DOM_EXCEPTION = 'DOMException';

// `DOMException.prototype[@@toStringTag]` property
setToStringTag(getBuiltIn(DOM_EXCEPTION), DOM_EXCEPTION);

},{"../internals/get-built-in":666,"../internals/set-to-string-tag":760}],1078:[function(require,module,exports){
// TODO: Remove this module from `core-js@4` since it's split to modules listed below
require('../modules/web.clear-immediate');
require('../modules/web.set-immediate');

},{"../modules/web.clear-immediate":1072,"../modules/web.set-immediate":1081}],1079:[function(require,module,exports){
var $ = require('../internals/export');
var global = require('../internals/global');
var microtask = require('../internals/microtask');
var aCallable = require('../internals/a-callable');
var validateArgumentsLength = require('../internals/validate-arguments-length');
var IS_NODE = require('../internals/engine-is-node');

var process = global.process;

// `queueMicrotask` method
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-queuemicrotask
$({ global: true, enumerable: true, dontCallGetSet: true }, {
  queueMicrotask: function queueMicrotask(fn) {
    validateArgumentsLength(arguments.length, 1);
    aCallable(fn);
    var domain = IS_NODE && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});

},{"../internals/a-callable":573,"../internals/engine-is-node":641,"../internals/export":652,"../internals/global":672,"../internals/microtask":713,"../internals/validate-arguments-length":805}],1080:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var global = require('../internals/global');
var defineBuiltInAccessor = require('../internals/define-built-in-accessor');
var DESCRIPTORS = require('../internals/descriptors');

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;
var INCORRECT_VALUE = global.self !== global;

// `self` getter
// https://html.spec.whatwg.org/multipage/window-object.html#dom-self
try {
  if (DESCRIPTORS) {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    var descriptor = Object.getOwnPropertyDescriptor(global, 'self');
    // some engines have `self`, but with incorrect descriptor
    // https://github.com/denoland/deno/issues/15765
    if (INCORRECT_VALUE || !descriptor || !descriptor.get || !descriptor.enumerable) {
      defineBuiltInAccessor(global, 'self', {
        get: function self() {
          return global;
        },
        set: function self(value) {
          if (this !== global) throw $TypeError('Illegal invocation');
          defineProperty(global, 'self', {
            value: value,
            writable: true,
            configurable: true,
            enumerable: true
          });
        },
        configurable: true,
        enumerable: true
      });
    }
  } else $({ global: true, simple: true, forced: INCORRECT_VALUE }, {
    self: global
  });
} catch (error) { /* empty */ }

},{"../internals/define-built-in-accessor":622,"../internals/descriptors":627,"../internals/export":652,"../internals/global":672}],1081:[function(require,module,exports){
var $ = require('../internals/export');
var global = require('../internals/global');
var setTask = require('../internals/task').set;
var schedulersFix = require('../internals/schedulers-fix');

// https://github.com/oven-sh/bun/issues/1633
var setImmediate = global.setImmediate ? schedulersFix(setTask, false) : setTask;

// `setImmediate` method
// http://w3c.github.io/setImmediate/#si-setImmediate
$({ global: true, bind: true, enumerable: true, forced: global.setImmediate !== setImmediate }, {
  setImmediate: setImmediate
});

},{"../internals/export":652,"../internals/global":672,"../internals/schedulers-fix":757,"../internals/task":779}],1082:[function(require,module,exports){
var $ = require('../internals/export');
var global = require('../internals/global');
var schedulersFix = require('../internals/schedulers-fix');

var setInterval = schedulersFix(global.setInterval, true);

// Bun / IE9- setInterval additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-setinterval
$({ global: true, bind: true, forced: global.setInterval !== setInterval }, {
  setInterval: setInterval
});

},{"../internals/export":652,"../internals/global":672,"../internals/schedulers-fix":757}],1083:[function(require,module,exports){
var $ = require('../internals/export');
var global = require('../internals/global');
var schedulersFix = require('../internals/schedulers-fix');

var setTimeout = schedulersFix(global.setTimeout, true);

// Bun / IE9- setTimeout additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-settimeout
$({ global: true, bind: true, forced: global.setTimeout !== setTimeout }, {
  setTimeout: setTimeout
});

},{"../internals/export":652,"../internals/global":672,"../internals/schedulers-fix":757}],1084:[function(require,module,exports){
var IS_PURE = require('../internals/is-pure');
var $ = require('../internals/export');
var global = require('../internals/global');
var getBuiltin = require('../internals/get-built-in');
var uncurryThis = require('../internals/function-uncurry-this');
var fails = require('../internals/fails');
var uid = require('../internals/uid');
var isCallable = require('../internals/is-callable');
var isConstructor = require('../internals/is-constructor');
var isNullOrUndefined = require('../internals/is-null-or-undefined');
var isObject = require('../internals/is-object');
var isSymbol = require('../internals/is-symbol');
var iterate = require('../internals/iterate');
var anObject = require('../internals/an-object');
var classof = require('../internals/classof');
var hasOwn = require('../internals/has-own-property');
var createProperty = require('../internals/create-property');
var createNonEnumerableProperty = require('../internals/create-non-enumerable-property');
var lengthOfArrayLike = require('../internals/length-of-array-like');
var validateArgumentsLength = require('../internals/validate-arguments-length');
var getRegExpFlags = require('../internals/regexp-get-flags');
var MapHelpers = require('../internals/map-helpers');
var SetHelpers = require('../internals/set-helpers');
var ERROR_STACK_INSTALLABLE = require('../internals/error-stack-installable');
var PROPER_TRANSFER = require('../internals/structured-clone-proper-transfer');

var Object = global.Object;
var Array = global.Array;
var Date = global.Date;
var Error = global.Error;
var EvalError = global.EvalError;
var RangeError = global.RangeError;
var ReferenceError = global.ReferenceError;
var SyntaxError = global.SyntaxError;
var TypeError = global.TypeError;
var URIError = global.URIError;
var PerformanceMark = global.PerformanceMark;
var WebAssembly = global.WebAssembly;
var CompileError = WebAssembly && WebAssembly.CompileError || Error;
var LinkError = WebAssembly && WebAssembly.LinkError || Error;
var RuntimeError = WebAssembly && WebAssembly.RuntimeError || Error;
var DOMException = getBuiltin('DOMException');
var Map = MapHelpers.Map;
var mapHas = MapHelpers.has;
var mapGet = MapHelpers.get;
var mapSet = MapHelpers.set;
var Set = SetHelpers.Set;
var setAdd = SetHelpers.add;
var objectKeys = getBuiltin('Object', 'keys');
var push = uncurryThis([].push);
var thisBooleanValue = uncurryThis(true.valueOf);
var thisNumberValue = uncurryThis(1.0.valueOf);
var thisStringValue = uncurryThis(''.valueOf);
var thisTimeValue = uncurryThis(Date.prototype.getTime);
var PERFORMANCE_MARK = uid('structuredClone');
var DATA_CLONE_ERROR = 'DataCloneError';
var TRANSFERRING = 'Transferring';

var checkBasicSemantic = function (structuredCloneImplementation) {
  return !fails(function () {
    var set1 = new global.Set([7]);
    var set2 = structuredCloneImplementation(set1);
    var number = structuredCloneImplementation(Object(7));
    return set2 == set1 || !set2.has(7) || typeof number != 'object' || number != 7;
  }) && structuredCloneImplementation;
};

var checkErrorsCloning = function (structuredCloneImplementation, $Error) {
  return !fails(function () {
    var error = new $Error();
    var test = structuredCloneImplementation({ a: error, b: error });
    return !(test && test.a === test.b && test.a instanceof $Error && test.a.stack === error.stack);
  });
};

// https://github.com/whatwg/html/pull/5749
var checkNewErrorsCloningSemantic = function (structuredCloneImplementation) {
  return !fails(function () {
    var test = structuredCloneImplementation(new global.AggregateError([1], PERFORMANCE_MARK, { cause: 3 }));
    return test.name != 'AggregateError' || test.errors[0] != 1 || test.message != PERFORMANCE_MARK || test.cause != 3;
  });
};

// FF94+, Safari 15.4+, Chrome 98+, NodeJS 17.0+, Deno 1.13+
// FF<103 and Safari implementations can't clone errors
// https://bugzilla.mozilla.org/show_bug.cgi?id=1556604
// FF103 can clone errors, but `.stack` of clone is an empty string
// https://bugzilla.mozilla.org/show_bug.cgi?id=1778762
// FF104+ fixed it on usual errors, but not on DOMExceptions
// https://bugzilla.mozilla.org/show_bug.cgi?id=1777321
// Chrome <102 returns `null` if cloned object contains multiple references to one error
// https://bugs.chromium.org/p/v8/issues/detail?id=12542
// NodeJS implementation can't clone DOMExceptions
// https://github.com/nodejs/node/issues/41038
// only FF103+ supports new (html/5749) error cloning semantic
var nativeStructuredClone = global.structuredClone;

var FORCED_REPLACEMENT = IS_PURE
  || !checkErrorsCloning(nativeStructuredClone, Error)
  || !checkErrorsCloning(nativeStructuredClone, DOMException)
  || !checkNewErrorsCloningSemantic(nativeStructuredClone);

// Chrome 82+, Safari 14.1+, Deno 1.11+
// Chrome 78-81 implementation swaps `.name` and `.message` of cloned `DOMException`
// Chrome returns `null` if cloned object contains multiple references to one error
// Safari 14.1 implementation doesn't clone some `RegExp` flags, so requires a workaround
// Safari implementation can't clone errors
// Deno 1.2-1.10 implementations too naive
// NodeJS 16.0+ does not have `PerformanceMark` constructor
// NodeJS <17.2 structured cloning implementation from `performance.mark` is too naive
// and can't clone, for example, `RegExp` or some boxed primitives
// https://github.com/nodejs/node/issues/40840
// no one of those implementations supports new (html/5749) error cloning semantic
var structuredCloneFromMark = !nativeStructuredClone && checkBasicSemantic(function (value) {
  return new PerformanceMark(PERFORMANCE_MARK, { detail: value }).detail;
});

var nativeRestrictedStructuredClone = checkBasicSemantic(nativeStructuredClone) || structuredCloneFromMark;

var throwUncloneable = function (type) {
  throw new DOMException('Uncloneable type: ' + type, DATA_CLONE_ERROR);
};

var throwUnpolyfillable = function (type, action) {
  throw new DOMException((action || 'Cloning') + ' of ' + type + ' cannot be properly polyfilled in this engine', DATA_CLONE_ERROR);
};

var createDataTransfer = function () {
  var dataTransfer;
  try {
    dataTransfer = new global.DataTransfer();
  } catch (error) {
    try {
      dataTransfer = new global.ClipboardEvent('').clipboardData;
    } catch (error2) { /* empty */ }
  }
  return dataTransfer && dataTransfer.items && dataTransfer.files ? dataTransfer : null;
};

var structuredCloneInternal = function (value, map) {
  if (isSymbol(value)) throwUncloneable('Symbol');
  if (!isObject(value)) return value;
  // effectively preserves circular references
  if (map) {
    if (mapHas(map, value)) return mapGet(map, value);
  } else map = new Map();

  var type = classof(value);
  var deep = false;
  var C, name, cloned, dataTransfer, i, length, keys, key, source, target, options;

  switch (type) {
    case 'Array':
      cloned = Array(lengthOfArrayLike(value));
      deep = true;
      break;
    case 'Object':
      cloned = {};
      deep = true;
      break;
    case 'Map':
      cloned = new Map();
      deep = true;
      break;
    case 'Set':
      cloned = new Set();
      deep = true;
      break;
    case 'RegExp':
      // in this block because of a Safari 14.1 bug
      // old FF does not clone regexes passed to the constructor, so get the source and flags directly
      cloned = new RegExp(value.source, getRegExpFlags(value));
      break;
    case 'Error':
      name = value.name;
      switch (name) {
        case 'AggregateError':
          cloned = getBuiltin('AggregateError')([]);
          break;
        case 'EvalError':
          cloned = EvalError();
          break;
        case 'RangeError':
          cloned = RangeError();
          break;
        case 'ReferenceError':
          cloned = ReferenceError();
          break;
        case 'SyntaxError':
          cloned = SyntaxError();
          break;
        case 'TypeError':
          cloned = TypeError();
          break;
        case 'URIError':
          cloned = URIError();
          break;
        case 'CompileError':
          cloned = CompileError();
          break;
        case 'LinkError':
          cloned = LinkError();
          break;
        case 'RuntimeError':
          cloned = RuntimeError();
          break;
        default:
          cloned = Error();
      }
      deep = true;
      break;
    case 'DOMException':
      cloned = new DOMException(value.message, value.name);
      deep = true;
      break;
    case 'DataView':
    case 'Int8Array':
    case 'Uint8Array':
    case 'Uint8ClampedArray':
    case 'Int16Array':
    case 'Uint16Array':
    case 'Int32Array':
    case 'Uint32Array':
    case 'Float32Array':
    case 'Float64Array':
    case 'BigInt64Array':
    case 'BigUint64Array':
      C = global[type];
      // in some old engines like Safari 9, typeof C is 'object'
      // on Uint8ClampedArray or some other constructors
      if (!isObject(C)) throwUnpolyfillable(type);
      cloned = new C(
        // this is safe, since arraybuffer cannot have circular references
        structuredCloneInternal(value.buffer, map),
        value.byteOffset,
        type === 'DataView' ? value.byteLength : value.length
      );
      break;
    case 'DOMQuad':
      try {
        cloned = new DOMQuad(
          structuredCloneInternal(value.p1, map),
          structuredCloneInternal(value.p2, map),
          structuredCloneInternal(value.p3, map),
          structuredCloneInternal(value.p4, map)
        );
      } catch (error) {
        if (nativeRestrictedStructuredClone) {
          cloned = nativeRestrictedStructuredClone(value);
        } else throwUnpolyfillable(type);
      }
      break;
    case 'FileList':
      dataTransfer = createDataTransfer();
      if (dataTransfer) {
        for (i = 0, length = lengthOfArrayLike(value); i < length; i++) {
          dataTransfer.items.add(structuredCloneInternal(value[i], map));
        }
        cloned = dataTransfer.files;
      } else if (nativeRestrictedStructuredClone) {
        cloned = nativeRestrictedStructuredClone(value);
      } else throwUnpolyfillable(type);
      break;
    case 'ImageData':
      // Safari 9 ImageData is a constructor, but typeof ImageData is 'object'
      try {
        cloned = new ImageData(
          structuredCloneInternal(value.data, map),
          value.width,
          value.height,
          { colorSpace: value.colorSpace }
        );
      } catch (error) {
        if (nativeRestrictedStructuredClone) {
          cloned = nativeRestrictedStructuredClone(value);
        } else throwUnpolyfillable(type);
      } break;
    default:
      if (nativeRestrictedStructuredClone) {
        cloned = nativeRestrictedStructuredClone(value);
      } else switch (type) {
        case 'BigInt':
          // can be a 3rd party polyfill
          cloned = Object(value.valueOf());
          break;
        case 'Boolean':
          cloned = Object(thisBooleanValue(value));
          break;
        case 'Number':
          cloned = Object(thisNumberValue(value));
          break;
        case 'String':
          cloned = Object(thisStringValue(value));
          break;
        case 'Date':
          cloned = new Date(thisTimeValue(value));
          break;
        case 'ArrayBuffer':
          C = global.DataView;
          // `ArrayBuffer#slice` is not available in IE10
          // `ArrayBuffer#slice` and `DataView` are not available in old FF
          if (!C && typeof value.slice != 'function') throwUnpolyfillable(type);
          // detached buffers throws in `DataView` and `.slice`
          try {
            if (typeof value.slice == 'function' && !value.resizable) {
              cloned = value.slice(0);
            } else {
              length = value.byteLength;
              options = 'maxByteLength' in value ? { maxByteLength: value.maxByteLength } : undefined;
              cloned = new ArrayBuffer(length, options);
              source = new C(value);
              target = new C(cloned);
              for (i = 0; i < length; i++) {
                target.setUint8(i, source.getUint8(i));
              }
            }
          } catch (error) {
            throw new DOMException('ArrayBuffer is detached', DATA_CLONE_ERROR);
          } break;
        case 'SharedArrayBuffer':
          // SharedArrayBuffer should use shared memory, we can't polyfill it, so return the original
          cloned = value;
          break;
        case 'Blob':
          try {
            cloned = value.slice(0, value.size, value.type);
          } catch (error) {
            throwUnpolyfillable(type);
          } break;
        case 'DOMPoint':
        case 'DOMPointReadOnly':
          C = global[type];
          try {
            cloned = C.fromPoint
              ? C.fromPoint(value)
              : new C(value.x, value.y, value.z, value.w);
          } catch (error) {
            throwUnpolyfillable(type);
          } break;
        case 'DOMRect':
        case 'DOMRectReadOnly':
          C = global[type];
          try {
            cloned = C.fromRect
              ? C.fromRect(value)
              : new C(value.x, value.y, value.width, value.height);
          } catch (error) {
            throwUnpolyfillable(type);
          } break;
        case 'DOMMatrix':
        case 'DOMMatrixReadOnly':
          C = global[type];
          try {
            cloned = C.fromMatrix
              ? C.fromMatrix(value)
              : new C(value);
          } catch (error) {
            throwUnpolyfillable(type);
          } break;
        case 'AudioData':
        case 'VideoFrame':
          if (!isCallable(value.clone)) throwUnpolyfillable(type);
          try {
            cloned = value.clone();
          } catch (error) {
            throwUncloneable(type);
          } break;
        case 'File':
          try {
            cloned = new File([value], value.name, value);
          } catch (error) {
            throwUnpolyfillable(type);
          } break;
        case 'CropTarget':
        case 'CryptoKey':
        case 'FileSystemDirectoryHandle':
        case 'FileSystemFileHandle':
        case 'FileSystemHandle':
        case 'GPUCompilationInfo':
        case 'GPUCompilationMessage':
        case 'ImageBitmap':
        case 'RTCCertificate':
        case 'WebAssembly.Module':
          throwUnpolyfillable(type);
          // break omitted
        default:
          throwUncloneable(type);
      }
  }

  mapSet(map, value, cloned);

  if (deep) switch (type) {
    case 'Array':
    case 'Object':
      keys = objectKeys(value);
      for (i = 0, length = lengthOfArrayLike(keys); i < length; i++) {
        key = keys[i];
        createProperty(cloned, key, structuredCloneInternal(value[key], map));
      } break;
    case 'Map':
      value.forEach(function (v, k) {
        mapSet(cloned, structuredCloneInternal(k, map), structuredCloneInternal(v, map));
      });
      break;
    case 'Set':
      value.forEach(function (v) {
        setAdd(cloned, structuredCloneInternal(v, map));
      });
      break;
    case 'Error':
      createNonEnumerableProperty(cloned, 'message', structuredCloneInternal(value.message, map));
      if (hasOwn(value, 'cause')) {
        createNonEnumerableProperty(cloned, 'cause', structuredCloneInternal(value.cause, map));
      }
      if (name == 'AggregateError') {
        cloned.errors = structuredCloneInternal(value.errors, map);
      } // break omitted
    case 'DOMException':
      if (ERROR_STACK_INSTALLABLE) {
        createNonEnumerableProperty(cloned, 'stack', structuredCloneInternal(value.stack, map));
      }
  }

  return cloned;
};

var tryToTransfer = function (rawTransfer, map) {
  if (!isObject(rawTransfer)) throw TypeError('Transfer option cannot be converted to a sequence');

  var transfer = [];

  iterate(rawTransfer, function (value) {
    push(transfer, anObject(value));
  });

  var i = 0;
  var length = lengthOfArrayLike(transfer);
  var value, type, C, transferredArray, transferred, canvas, context;

  if (PROPER_TRANSFER) {
    transferredArray = nativeStructuredClone(transfer, { transfer: transfer });
    while (i < length) mapSet(map, transfer[i], transferredArray[i++]);
  } else while (i < length) {
    value = transfer[i++];
    if (mapHas(map, value)) throw new DOMException('Duplicate transferable', DATA_CLONE_ERROR);

    type = classof(value);

    switch (type) {
      case 'ImageBitmap':
        C = global.OffscreenCanvas;
        if (!isConstructor(C)) throwUnpolyfillable(type, TRANSFERRING);
        try {
          canvas = new C(value.width, value.height);
          context = canvas.getContext('bitmaprenderer');
          context.transferFromImageBitmap(value);
          transferred = canvas.transferToImageBitmap();
        } catch (error) { /* empty */ }
        break;
      case 'AudioData':
      case 'VideoFrame':
        if (!isCallable(value.clone) || !isCallable(value.close)) throwUnpolyfillable(type, TRANSFERRING);
        try {
          transferred = value.clone();
          value.close();
        } catch (error) { /* empty */ }
        break;
      case 'ArrayBuffer':
        if (!isCallable(value.transfer)) throwUnpolyfillable(type, TRANSFERRING);
        transferred = value.transfer();
        break;
      case 'MediaSourceHandle':
      case 'MessagePort':
      case 'OffscreenCanvas':
      case 'ReadableStream':
      case 'TransformStream':
      case 'WritableStream':
        throwUnpolyfillable(type, TRANSFERRING);
    }

    if (transferred === undefined) throw new DOMException('This object cannot be transferred: ' + type, DATA_CLONE_ERROR);
    mapSet(map, value, transferred);
  }
};

// `structuredClone` method
// https://html.spec.whatwg.org/multipage/structured-data.html#dom-structuredclone
$({ global: true, enumerable: true, sham: !PROPER_TRANSFER, forced: FORCED_REPLACEMENT }, {
  structuredClone: function structuredClone(value /* , { transfer } */) {
    var options = validateArgumentsLength(arguments.length, 1) > 1 && !isNullOrUndefined(arguments[1]) ? anObject(arguments[1]) : undefined;
    var transfer = options ? options.transfer : undefined;
    var map;

    if (transfer !== undefined) {
      map = new Map();
      tryToTransfer(transfer, map);
    }

    return structuredCloneInternal(value, map);
  }
});

},{"../internals/an-object":579,"../internals/classof":608,"../internals/create-non-enumerable-property":617,"../internals/create-property":619,"../internals/error-stack-installable":650,"../internals/export":652,"../internals/fails":653,"../internals/function-uncurry-this":665,"../internals/get-built-in":666,"../internals/global":672,"../internals/has-own-property":673,"../internals/is-callable":688,"../internals/is-constructor":689,"../internals/is-null-or-undefined":693,"../internals/is-object":694,"../internals/is-pure":695,"../internals/is-symbol":697,"../internals/iterate":698,"../internals/length-of-array-like":704,"../internals/map-helpers":706,"../internals/regexp-get-flags":751,"../internals/set-helpers":758,"../internals/structured-clone-proper-transfer":775,"../internals/uid":801,"../internals/validate-arguments-length":805}],1085:[function(require,module,exports){
// TODO: Remove this module from `core-js@4` since it's split to modules listed below
require('../modules/web.set-interval');
require('../modules/web.set-timeout');

},{"../modules/web.set-interval":1082,"../modules/web.set-timeout":1083}],1086:[function(require,module,exports){
'use strict';
// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
require('../modules/es.array.iterator');
var $ = require('../internals/export');
var global = require('../internals/global');
var call = require('../internals/function-call');
var uncurryThis = require('../internals/function-uncurry-this');
var DESCRIPTORS = require('../internals/descriptors');
var USE_NATIVE_URL = require('../internals/url-constructor-detection');
var defineBuiltIn = require('../internals/define-built-in');
var defineBuiltInAccessor = require('../internals/define-built-in-accessor');
var defineBuiltIns = require('../internals/define-built-ins');
var setToStringTag = require('../internals/set-to-string-tag');
var createIteratorConstructor = require('../internals/iterator-create-constructor');
var InternalStateModule = require('../internals/internal-state');
var anInstance = require('../internals/an-instance');
var isCallable = require('../internals/is-callable');
var hasOwn = require('../internals/has-own-property');
var bind = require('../internals/function-bind-context');
var classof = require('../internals/classof');
var anObject = require('../internals/an-object');
var isObject = require('../internals/is-object');
var $toString = require('../internals/to-string');
var create = require('../internals/object-create');
var createPropertyDescriptor = require('../internals/create-property-descriptor');
var getIterator = require('../internals/get-iterator');
var getIteratorMethod = require('../internals/get-iterator-method');
var validateArgumentsLength = require('../internals/validate-arguments-length');
var wellKnownSymbol = require('../internals/well-known-symbol');
var arraySort = require('../internals/array-sort');

var ITERATOR = wellKnownSymbol('iterator');
var URL_SEARCH_PARAMS = 'URLSearchParams';
var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + 'Iterator';
var setInternalState = InternalStateModule.set;
var getInternalParamsState = InternalStateModule.getterFor(URL_SEARCH_PARAMS);
var getInternalIteratorState = InternalStateModule.getterFor(URL_SEARCH_PARAMS_ITERATOR);
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Avoid NodeJS experimental warning
var safeGetBuiltIn = function (name) {
  if (!DESCRIPTORS) return global[name];
  var descriptor = getOwnPropertyDescriptor(global, name);
  return descriptor && descriptor.value;
};

var nativeFetch = safeGetBuiltIn('fetch');
var NativeRequest = safeGetBuiltIn('Request');
var Headers = safeGetBuiltIn('Headers');
var RequestPrototype = NativeRequest && NativeRequest.prototype;
var HeadersPrototype = Headers && Headers.prototype;
var RegExp = global.RegExp;
var TypeError = global.TypeError;
var decodeURIComponent = global.decodeURIComponent;
var encodeURIComponent = global.encodeURIComponent;
var charAt = uncurryThis(''.charAt);
var join = uncurryThis([].join);
var push = uncurryThis([].push);
var replace = uncurryThis(''.replace);
var shift = uncurryThis([].shift);
var splice = uncurryThis([].splice);
var split = uncurryThis(''.split);
var stringSlice = uncurryThis(''.slice);

var plus = /\+/g;
var sequences = Array(4);

var percentSequence = function (bytes) {
  return sequences[bytes - 1] || (sequences[bytes - 1] = RegExp('((?:%[\\da-f]{2}){' + bytes + '})', 'gi'));
};

var percentDecode = function (sequence) {
  try {
    return decodeURIComponent(sequence);
  } catch (error) {
    return sequence;
  }
};

var deserialize = function (it) {
  var result = replace(it, plus, ' ');
  var bytes = 4;
  try {
    return decodeURIComponent(result);
  } catch (error) {
    while (bytes) {
      result = replace(result, percentSequence(bytes--), percentDecode);
    }
    return result;
  }
};

var find = /[!'()~]|%20/g;

var replacements = {
  '!': '%21',
  "'": '%27',
  '(': '%28',
  ')': '%29',
  '~': '%7E',
  '%20': '+'
};

var replacer = function (match) {
  return replacements[match];
};

var serialize = function (it) {
  return replace(encodeURIComponent(it), find, replacer);
};

var URLSearchParamsIterator = createIteratorConstructor(function Iterator(params, kind) {
  setInternalState(this, {
    type: URL_SEARCH_PARAMS_ITERATOR,
    iterator: getIterator(getInternalParamsState(params).entries),
    kind: kind
  });
}, 'Iterator', function next() {
  var state = getInternalIteratorState(this);
  var kind = state.kind;
  var step = state.iterator.next();
  var entry = step.value;
  if (!step.done) {
    step.value = kind === 'keys' ? entry.key : kind === 'values' ? entry.value : [entry.key, entry.value];
  } return step;
}, true);

var URLSearchParamsState = function (init) {
  this.entries = [];
  this.url = null;

  if (init !== undefined) {
    if (isObject(init)) this.parseObject(init);
    else this.parseQuery(typeof init == 'string' ? charAt(init, 0) === '?' ? stringSlice(init, 1) : init : $toString(init));
  }
};

URLSearchParamsState.prototype = {
  type: URL_SEARCH_PARAMS,
  bindURL: function (url) {
    this.url = url;
    this.update();
  },
  parseObject: function (object) {
    var iteratorMethod = getIteratorMethod(object);
    var iterator, next, step, entryIterator, entryNext, first, second;

    if (iteratorMethod) {
      iterator = getIterator(object, iteratorMethod);
      next = iterator.next;
      while (!(step = call(next, iterator)).done) {
        entryIterator = getIterator(anObject(step.value));
        entryNext = entryIterator.next;
        if (
          (first = call(entryNext, entryIterator)).done ||
          (second = call(entryNext, entryIterator)).done ||
          !call(entryNext, entryIterator).done
        ) throw TypeError('Expected sequence with length 2');
        push(this.entries, { key: $toString(first.value), value: $toString(second.value) });
      }
    } else for (var key in object) if (hasOwn(object, key)) {
      push(this.entries, { key: key, value: $toString(object[key]) });
    }
  },
  parseQuery: function (query) {
    if (query) {
      var attributes = split(query, '&');
      var index = 0;
      var attribute, entry;
      while (index < attributes.length) {
        attribute = attributes[index++];
        if (attribute.length) {
          entry = split(attribute, '=');
          push(this.entries, {
            key: deserialize(shift(entry)),
            value: deserialize(join(entry, '='))
          });
        }
      }
    }
  },
  serialize: function () {
    var entries = this.entries;
    var result = [];
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      push(result, serialize(entry.key) + '=' + serialize(entry.value));
    } return join(result, '&');
  },
  update: function () {
    this.entries.length = 0;
    this.parseQuery(this.url.query);
  },
  updateURL: function () {
    if (this.url) this.url.update();
  }
};

// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var URLSearchParamsConstructor = function URLSearchParams(/* init */) {
  anInstance(this, URLSearchParamsPrototype);
  var init = arguments.length > 0 ? arguments[0] : undefined;
  var state = setInternalState(this, new URLSearchParamsState(init));
  if (!DESCRIPTORS) this.length = state.entries.length;
};

var URLSearchParamsPrototype = URLSearchParamsConstructor.prototype;

defineBuiltIns(URLSearchParamsPrototype, {
  // `URLSearchParams.prototype.append` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
  append: function append(name, value) {
    validateArgumentsLength(arguments.length, 2);
    var state = getInternalParamsState(this);
    push(state.entries, { key: $toString(name), value: $toString(value) });
    if (!DESCRIPTORS) this.length++;
    state.updateURL();
  },
  // `URLSearchParams.prototype.delete` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
  'delete': function (name) {
    validateArgumentsLength(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var key = $toString(name);
    var index = 0;
    while (index < entries.length) {
      if (entries[index].key === key) splice(entries, index, 1);
      else index++;
    }
    if (!DESCRIPTORS) this.length = entries.length;
    state.updateURL();
  },
  // `URLSearchParams.prototype.get` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
  get: function get(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = $toString(name);
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) return entries[index].value;
    }
    return null;
  },
  // `URLSearchParams.prototype.getAll` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
  getAll: function getAll(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = $toString(name);
    var result = [];
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) push(result, entries[index].value);
    }
    return result;
  },
  // `URLSearchParams.prototype.has` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
  has: function has(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = $toString(name);
    var index = 0;
    while (index < entries.length) {
      if (entries[index++].key === key) return true;
    }
    return false;
  },
  // `URLSearchParams.prototype.set` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
  set: function set(name, value) {
    validateArgumentsLength(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var found = false;
    var key = $toString(name);
    var val = $toString(value);
    var index = 0;
    var entry;
    for (; index < entries.length; index++) {
      entry = entries[index];
      if (entry.key === key) {
        if (found) splice(entries, index--, 1);
        else {
          found = true;
          entry.value = val;
        }
      }
    }
    if (!found) push(entries, { key: key, value: val });
    if (!DESCRIPTORS) this.length = entries.length;
    state.updateURL();
  },
  // `URLSearchParams.prototype.sort` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
  sort: function sort() {
    var state = getInternalParamsState(this);
    arraySort(state.entries, function (a, b) {
      return a.key > b.key ? 1 : -1;
    });
    state.updateURL();
  },
  // `URLSearchParams.prototype.forEach` method
  forEach: function forEach(callback /* , thisArg */) {
    var entries = getInternalParamsState(this).entries;
    var boundFunction = bind(callback, arguments.length > 1 ? arguments[1] : undefined);
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      boundFunction(entry.value, entry.key, this);
    }
  },
  // `URLSearchParams.prototype.keys` method
  keys: function keys() {
    return new URLSearchParamsIterator(this, 'keys');
  },
  // `URLSearchParams.prototype.values` method
  values: function values() {
    return new URLSearchParamsIterator(this, 'values');
  },
  // `URLSearchParams.prototype.entries` method
  entries: function entries() {
    return new URLSearchParamsIterator(this, 'entries');
  }
}, { enumerable: true });

// `URLSearchParams.prototype[@@iterator]` method
defineBuiltIn(URLSearchParamsPrototype, ITERATOR, URLSearchParamsPrototype.entries, { name: 'entries' });

// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
defineBuiltIn(URLSearchParamsPrototype, 'toString', function toString() {
  return getInternalParamsState(this).serialize();
}, { enumerable: true });

// `URLSearchParams.prototype.size` getter
// https://github.com/whatwg/url/pull/734
if (DESCRIPTORS) defineBuiltInAccessor(URLSearchParamsPrototype, 'size', {
  get: function size() {
    return getInternalParamsState(this).entries.length;
  },
  configurable: true,
  enumerable: true
});

setToStringTag(URLSearchParamsConstructor, URL_SEARCH_PARAMS);

$({ global: true, constructor: true, forced: !USE_NATIVE_URL }, {
  URLSearchParams: URLSearchParamsConstructor
});

// Wrap `fetch` and `Request` for correct work with polyfilled `URLSearchParams`
if (!USE_NATIVE_URL && isCallable(Headers)) {
  var headersHas = uncurryThis(HeadersPrototype.has);
  var headersSet = uncurryThis(HeadersPrototype.set);

  var wrapRequestOptions = function (init) {
    if (isObject(init)) {
      var body = init.body;
      var headers;
      if (classof(body) === URL_SEARCH_PARAMS) {
        headers = init.headers ? new Headers(init.headers) : new Headers();
        if (!headersHas(headers, 'content-type')) {
          headersSet(headers, 'content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
        return create(init, {
          body: createPropertyDescriptor(0, $toString(body)),
          headers: createPropertyDescriptor(0, headers)
        });
      }
    } return init;
  };

  if (isCallable(nativeFetch)) {
    $({ global: true, enumerable: true, dontCallGetSet: true, forced: true }, {
      fetch: function fetch(input /* , init */) {
        return nativeFetch(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
      }
    });
  }

  if (isCallable(NativeRequest)) {
    var RequestConstructor = function Request(input /* , init */) {
      anInstance(this, RequestPrototype);
      return new NativeRequest(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
    };

    RequestPrototype.constructor = RequestConstructor;
    RequestConstructor.prototype = RequestPrototype;

    $({ global: true, constructor: true, dontCallGetSet: true, forced: true }, {
      Request: RequestConstructor
    });
  }
}

module.exports = {
  URLSearchParams: URLSearchParamsConstructor,
  getState: getInternalParamsState
};

},{"../internals/an-instance":578,"../internals/an-object":579,"../internals/array-sort":599,"../internals/classof":608,"../internals/create-property-descriptor":618,"../internals/define-built-in":623,"../internals/define-built-in-accessor":622,"../internals/define-built-ins":624,"../internals/descriptors":627,"../internals/export":652,"../internals/function-bind-context":658,"../internals/function-call":661,"../internals/function-uncurry-this":665,"../internals/get-iterator":668,"../internals/get-iterator-method":667,"../internals/global":672,"../internals/has-own-property":673,"../internals/internal-state":684,"../internals/is-callable":688,"../internals/is-object":694,"../internals/iterator-create-constructor":700,"../internals/object-create":721,"../internals/set-to-string-tag":760,"../internals/to-string":793,"../internals/url-constructor-detection":802,"../internals/validate-arguments-length":805,"../internals/well-known-symbol":809,"../modules/es.array.iterator":835}],1087:[function(require,module,exports){
// TODO: Remove this module from `core-js@4` since it's replaced to module below
require('../modules/web.url-search-params.constructor');

},{"../modules/web.url-search-params.constructor":1086}],1088:[function(require,module,exports){
'use strict';
var DESCRIPTORS = require('../internals/descriptors');
var uncurryThis = require('../internals/function-uncurry-this');
var defineBuiltInAccessor = require('../internals/define-built-in-accessor');

var URLSearchParamsPrototype = URLSearchParams.prototype;
var forEach = uncurryThis(URLSearchParamsPrototype.forEach);

// `URLSearchParams.prototype.size` getter
// https://github.com/whatwg/url/pull/734
if (DESCRIPTORS && !('size' in URLSearchParamsPrototype)) {
  defineBuiltInAccessor(URLSearchParamsPrototype, 'size', {
    get: function size() {
      var count = 0;
      forEach(this, function () { count++; });
      return count;
    },
    configurable: true,
    enumerable: true
  });
}

},{"../internals/define-built-in-accessor":622,"../internals/descriptors":627,"../internals/function-uncurry-this":665}],1089:[function(require,module,exports){
'use strict';
// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
require('../modules/es.string.iterator');
var $ = require('../internals/export');
var DESCRIPTORS = require('../internals/descriptors');
var USE_NATIVE_URL = require('../internals/url-constructor-detection');
var global = require('../internals/global');
var bind = require('../internals/function-bind-context');
var uncurryThis = require('../internals/function-uncurry-this');
var defineBuiltIn = require('../internals/define-built-in');
var defineBuiltInAccessor = require('../internals/define-built-in-accessor');
var anInstance = require('../internals/an-instance');
var hasOwn = require('../internals/has-own-property');
var assign = require('../internals/object-assign');
var arrayFrom = require('../internals/array-from');
var arraySlice = require('../internals/array-slice-simple');
var codeAt = require('../internals/string-multibyte').codeAt;
var toASCII = require('../internals/string-punycode-to-ascii');
var $toString = require('../internals/to-string');
var setToStringTag = require('../internals/set-to-string-tag');
var validateArgumentsLength = require('../internals/validate-arguments-length');
var URLSearchParamsModule = require('../modules/web.url-search-params.constructor');
var InternalStateModule = require('../internals/internal-state');

var setInternalState = InternalStateModule.set;
var getInternalURLState = InternalStateModule.getterFor('URL');
var URLSearchParams = URLSearchParamsModule.URLSearchParams;
var getInternalSearchParamsState = URLSearchParamsModule.getState;

var NativeURL = global.URL;
var TypeError = global.TypeError;
var parseInt = global.parseInt;
var floor = Math.floor;
var pow = Math.pow;
var charAt = uncurryThis(''.charAt);
var exec = uncurryThis(/./.exec);
var join = uncurryThis([].join);
var numberToString = uncurryThis(1.0.toString);
var pop = uncurryThis([].pop);
var push = uncurryThis([].push);
var replace = uncurryThis(''.replace);
var shift = uncurryThis([].shift);
var split = uncurryThis(''.split);
var stringSlice = uncurryThis(''.slice);
var toLowerCase = uncurryThis(''.toLowerCase);
var unshift = uncurryThis([].unshift);

var INVALID_AUTHORITY = 'Invalid authority';
var INVALID_SCHEME = 'Invalid scheme';
var INVALID_HOST = 'Invalid host';
var INVALID_PORT = 'Invalid port';

var ALPHA = /[a-z]/i;
// eslint-disable-next-line regexp/no-obscure-range -- safe
var ALPHANUMERIC = /[\d+-.a-z]/i;
var DIGIT = /\d/;
var HEX_START = /^0x/i;
var OCT = /^[0-7]+$/;
var DEC = /^\d+$/;
var HEX = /^[\da-f]+$/i;
/* eslint-disable regexp/no-control-character -- safe */
var FORBIDDEN_HOST_CODE_POINT = /[\0\t\n\r #%/:<>?@[\\\]^|]/;
var FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT = /[\0\t\n\r #/:<>?@[\\\]^|]/;
var LEADING_C0_CONTROL_OR_SPACE = /^[\u0000-\u0020]+/;
var TRAILING_C0_CONTROL_OR_SPACE = /(^|[^\u0000-\u0020])[\u0000-\u0020]+$/;
var TAB_AND_NEW_LINE = /[\t\n\r]/g;
/* eslint-enable regexp/no-control-character -- safe */
var EOF;

// https://url.spec.whatwg.org/#ipv4-number-parser
var parseIPv4 = function (input) {
  var parts = split(input, '.');
  var partsLength, numbers, index, part, radix, number, ipv4;
  if (parts.length && parts[parts.length - 1] == '') {
    parts.length--;
  }
  partsLength = parts.length;
  if (partsLength > 4) return input;
  numbers = [];
  for (index = 0; index < partsLength; index++) {
    part = parts[index];
    if (part == '') return input;
    radix = 10;
    if (part.length > 1 && charAt(part, 0) == '0') {
      radix = exec(HEX_START, part) ? 16 : 8;
      part = stringSlice(part, radix == 8 ? 1 : 2);
    }
    if (part === '') {
      number = 0;
    } else {
      if (!exec(radix == 10 ? DEC : radix == 8 ? OCT : HEX, part)) return input;
      number = parseInt(part, radix);
    }
    push(numbers, number);
  }
  for (index = 0; index < partsLength; index++) {
    number = numbers[index];
    if (index == partsLength - 1) {
      if (number >= pow(256, 5 - partsLength)) return null;
    } else if (number > 255) return null;
  }
  ipv4 = pop(numbers);
  for (index = 0; index < numbers.length; index++) {
    ipv4 += numbers[index] * pow(256, 3 - index);
  }
  return ipv4;
};

// https://url.spec.whatwg.org/#concept-ipv6-parser
// eslint-disable-next-line max-statements -- TODO
var parseIPv6 = function (input) {
  var address = [0, 0, 0, 0, 0, 0, 0, 0];
  var pieceIndex = 0;
  var compress = null;
  var pointer = 0;
  var value, length, numbersSeen, ipv4Piece, number, swaps, swap;

  var chr = function () {
    return charAt(input, pointer);
  };

  if (chr() == ':') {
    if (charAt(input, 1) != ':') return;
    pointer += 2;
    pieceIndex++;
    compress = pieceIndex;
  }
  while (chr()) {
    if (pieceIndex == 8) return;
    if (chr() == ':') {
      if (compress !== null) return;
      pointer++;
      pieceIndex++;
      compress = pieceIndex;
      continue;
    }
    value = length = 0;
    while (length < 4 && exec(HEX, chr())) {
      value = value * 16 + parseInt(chr(), 16);
      pointer++;
      length++;
    }
    if (chr() == '.') {
      if (length == 0) return;
      pointer -= length;
      if (pieceIndex > 6) return;
      numbersSeen = 0;
      while (chr()) {
        ipv4Piece = null;
        if (numbersSeen > 0) {
          if (chr() == '.' && numbersSeen < 4) pointer++;
          else return;
        }
        if (!exec(DIGIT, chr())) return;
        while (exec(DIGIT, chr())) {
          number = parseInt(chr(), 10);
          if (ipv4Piece === null) ipv4Piece = number;
          else if (ipv4Piece == 0) return;
          else ipv4Piece = ipv4Piece * 10 + number;
          if (ipv4Piece > 255) return;
          pointer++;
        }
        address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
        numbersSeen++;
        if (numbersSeen == 2 || numbersSeen == 4) pieceIndex++;
      }
      if (numbersSeen != 4) return;
      break;
    } else if (chr() == ':') {
      pointer++;
      if (!chr()) return;
    } else if (chr()) return;
    address[pieceIndex++] = value;
  }
  if (compress !== null) {
    swaps = pieceIndex - compress;
    pieceIndex = 7;
    while (pieceIndex != 0 && swaps > 0) {
      swap = address[pieceIndex];
      address[pieceIndex--] = address[compress + swaps - 1];
      address[compress + --swaps] = swap;
    }
  } else if (pieceIndex != 8) return;
  return address;
};

var findLongestZeroSequence = function (ipv6) {
  var maxIndex = null;
  var maxLength = 1;
  var currStart = null;
  var currLength = 0;
  var index = 0;
  for (; index < 8; index++) {
    if (ipv6[index] !== 0) {
      if (currLength > maxLength) {
        maxIndex = currStart;
        maxLength = currLength;
      }
      currStart = null;
      currLength = 0;
    } else {
      if (currStart === null) currStart = index;
      ++currLength;
    }
  }
  if (currLength > maxLength) {
    maxIndex = currStart;
    maxLength = currLength;
  }
  return maxIndex;
};

// https://url.spec.whatwg.org/#host-serializing
var serializeHost = function (host) {
  var result, index, compress, ignore0;
  // ipv4
  if (typeof host == 'number') {
    result = [];
    for (index = 0; index < 4; index++) {
      unshift(result, host % 256);
      host = floor(host / 256);
    } return join(result, '.');
  // ipv6
  } else if (typeof host == 'object') {
    result = '';
    compress = findLongestZeroSequence(host);
    for (index = 0; index < 8; index++) {
      if (ignore0 && host[index] === 0) continue;
      if (ignore0) ignore0 = false;
      if (compress === index) {
        result += index ? ':' : '::';
        ignore0 = true;
      } else {
        result += numberToString(host[index], 16);
        if (index < 7) result += ':';
      }
    }
    return '[' + result + ']';
  } return host;
};

var C0ControlPercentEncodeSet = {};
var fragmentPercentEncodeSet = assign({}, C0ControlPercentEncodeSet, {
  ' ': 1, '"': 1, '<': 1, '>': 1, '`': 1
});
var pathPercentEncodeSet = assign({}, fragmentPercentEncodeSet, {
  '#': 1, '?': 1, '{': 1, '}': 1
});
var userinfoPercentEncodeSet = assign({}, pathPercentEncodeSet, {
  '/': 1, ':': 1, ';': 1, '=': 1, '@': 1, '[': 1, '\\': 1, ']': 1, '^': 1, '|': 1
});

var percentEncode = function (chr, set) {
  var code = codeAt(chr, 0);
  return code > 0x20 && code < 0x7F && !hasOwn(set, chr) ? chr : encodeURIComponent(chr);
};

// https://url.spec.whatwg.org/#special-scheme
var specialSchemes = {
  ftp: 21,
  file: null,
  http: 80,
  https: 443,
  ws: 80,
  wss: 443
};

// https://url.spec.whatwg.org/#windows-drive-letter
var isWindowsDriveLetter = function (string, normalized) {
  var second;
  return string.length == 2 && exec(ALPHA, charAt(string, 0))
    && ((second = charAt(string, 1)) == ':' || (!normalized && second == '|'));
};

// https://url.spec.whatwg.org/#start-with-a-windows-drive-letter
var startsWithWindowsDriveLetter = function (string) {
  var third;
  return string.length > 1 && isWindowsDriveLetter(stringSlice(string, 0, 2)) && (
    string.length == 2 ||
    ((third = charAt(string, 2)) === '/' || third === '\\' || third === '?' || third === '#')
  );
};

// https://url.spec.whatwg.org/#single-dot-path-segment
var isSingleDot = function (segment) {
  return segment === '.' || toLowerCase(segment) === '%2e';
};

// https://url.spec.whatwg.org/#double-dot-path-segment
var isDoubleDot = function (segment) {
  segment = toLowerCase(segment);
  return segment === '..' || segment === '%2e.' || segment === '.%2e' || segment === '%2e%2e';
};

// States:
var SCHEME_START = {};
var SCHEME = {};
var NO_SCHEME = {};
var SPECIAL_RELATIVE_OR_AUTHORITY = {};
var PATH_OR_AUTHORITY = {};
var RELATIVE = {};
var RELATIVE_SLASH = {};
var SPECIAL_AUTHORITY_SLASHES = {};
var SPECIAL_AUTHORITY_IGNORE_SLASHES = {};
var AUTHORITY = {};
var HOST = {};
var HOSTNAME = {};
var PORT = {};
var FILE = {};
var FILE_SLASH = {};
var FILE_HOST = {};
var PATH_START = {};
var PATH = {};
var CANNOT_BE_A_BASE_URL_PATH = {};
var QUERY = {};
var FRAGMENT = {};

var URLState = function (url, isBase, base) {
  var urlString = $toString(url);
  var baseState, failure, searchParams;
  if (isBase) {
    failure = this.parse(urlString);
    if (failure) throw TypeError(failure);
    this.searchParams = null;
  } else {
    if (base !== undefined) baseState = new URLState(base, true);
    failure = this.parse(urlString, null, baseState);
    if (failure) throw TypeError(failure);
    searchParams = getInternalSearchParamsState(new URLSearchParams());
    searchParams.bindURL(this);
    this.searchParams = searchParams;
  }
};

URLState.prototype = {
  type: 'URL',
  // https://url.spec.whatwg.org/#url-parsing
  // eslint-disable-next-line max-statements -- TODO
  parse: function (input, stateOverride, base) {
    var url = this;
    var state = stateOverride || SCHEME_START;
    var pointer = 0;
    var buffer = '';
    var seenAt = false;
    var seenBracket = false;
    var seenPasswordToken = false;
    var codePoints, chr, bufferCodePoints, failure;

    input = $toString(input);

    if (!stateOverride) {
      url.scheme = '';
      url.username = '';
      url.password = '';
      url.host = null;
      url.port = null;
      url.path = [];
      url.query = null;
      url.fragment = null;
      url.cannotBeABaseURL = false;
      input = replace(input, LEADING_C0_CONTROL_OR_SPACE, '');
      input = replace(input, TRAILING_C0_CONTROL_OR_SPACE, '$1');
    }

    input = replace(input, TAB_AND_NEW_LINE, '');

    codePoints = arrayFrom(input);

    while (pointer <= codePoints.length) {
      chr = codePoints[pointer];
      switch (state) {
        case SCHEME_START:
          if (chr && exec(ALPHA, chr)) {
            buffer += toLowerCase(chr);
            state = SCHEME;
          } else if (!stateOverride) {
            state = NO_SCHEME;
            continue;
          } else return INVALID_SCHEME;
          break;

        case SCHEME:
          if (chr && (exec(ALPHANUMERIC, chr) || chr == '+' || chr == '-' || chr == '.')) {
            buffer += toLowerCase(chr);
          } else if (chr == ':') {
            if (stateOverride && (
              (url.isSpecial() != hasOwn(specialSchemes, buffer)) ||
              (buffer == 'file' && (url.includesCredentials() || url.port !== null)) ||
              (url.scheme == 'file' && !url.host)
            )) return;
            url.scheme = buffer;
            if (stateOverride) {
              if (url.isSpecial() && specialSchemes[url.scheme] == url.port) url.port = null;
              return;
            }
            buffer = '';
            if (url.scheme == 'file') {
              state = FILE;
            } else if (url.isSpecial() && base && base.scheme == url.scheme) {
              state = SPECIAL_RELATIVE_OR_AUTHORITY;
            } else if (url.isSpecial()) {
              state = SPECIAL_AUTHORITY_SLASHES;
            } else if (codePoints[pointer + 1] == '/') {
              state = PATH_OR_AUTHORITY;
              pointer++;
            } else {
              url.cannotBeABaseURL = true;
              push(url.path, '');
              state = CANNOT_BE_A_BASE_URL_PATH;
            }
          } else if (!stateOverride) {
            buffer = '';
            state = NO_SCHEME;
            pointer = 0;
            continue;
          } else return INVALID_SCHEME;
          break;

        case NO_SCHEME:
          if (!base || (base.cannotBeABaseURL && chr != '#')) return INVALID_SCHEME;
          if (base.cannotBeABaseURL && chr == '#') {
            url.scheme = base.scheme;
            url.path = arraySlice(base.path);
            url.query = base.query;
            url.fragment = '';
            url.cannotBeABaseURL = true;
            state = FRAGMENT;
            break;
          }
          state = base.scheme == 'file' ? FILE : RELATIVE;
          continue;

        case SPECIAL_RELATIVE_OR_AUTHORITY:
          if (chr == '/' && codePoints[pointer + 1] == '/') {
            state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
            pointer++;
          } else {
            state = RELATIVE;
            continue;
          } break;

        case PATH_OR_AUTHORITY:
          if (chr == '/') {
            state = AUTHORITY;
            break;
          } else {
            state = PATH;
            continue;
          }

        case RELATIVE:
          url.scheme = base.scheme;
          if (chr == EOF) {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.query = base.query;
          } else if (chr == '/' || (chr == '\\' && url.isSpecial())) {
            state = RELATIVE_SLASH;
          } else if (chr == '?') {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.query = '';
            state = QUERY;
          } else if (chr == '#') {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.query = base.query;
            url.fragment = '';
            state = FRAGMENT;
          } else {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.path.length--;
            state = PATH;
            continue;
          } break;

        case RELATIVE_SLASH:
          if (url.isSpecial() && (chr == '/' || chr == '\\')) {
            state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          } else if (chr == '/') {
            state = AUTHORITY;
          } else {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            state = PATH;
            continue;
          } break;

        case SPECIAL_AUTHORITY_SLASHES:
          state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          if (chr != '/' || charAt(buffer, pointer + 1) != '/') continue;
          pointer++;
          break;

        case SPECIAL_AUTHORITY_IGNORE_SLASHES:
          if (chr != '/' && chr != '\\') {
            state = AUTHORITY;
            continue;
          } break;

        case AUTHORITY:
          if (chr == '@') {
            if (seenAt) buffer = '%40' + buffer;
            seenAt = true;
            bufferCodePoints = arrayFrom(buffer);
            for (var i = 0; i < bufferCodePoints.length; i++) {
              var codePoint = bufferCodePoints[i];
              if (codePoint == ':' && !seenPasswordToken) {
                seenPasswordToken = true;
                continue;
              }
              var encodedCodePoints = percentEncode(codePoint, userinfoPercentEncodeSet);
              if (seenPasswordToken) url.password += encodedCodePoints;
              else url.username += encodedCodePoints;
            }
            buffer = '';
          } else if (
            chr == EOF || chr == '/' || chr == '?' || chr == '#' ||
            (chr == '\\' && url.isSpecial())
          ) {
            if (seenAt && buffer == '') return INVALID_AUTHORITY;
            pointer -= arrayFrom(buffer).length + 1;
            buffer = '';
            state = HOST;
          } else buffer += chr;
          break;

        case HOST:
        case HOSTNAME:
          if (stateOverride && url.scheme == 'file') {
            state = FILE_HOST;
            continue;
          } else if (chr == ':' && !seenBracket) {
            if (buffer == '') return INVALID_HOST;
            failure = url.parseHost(buffer);
            if (failure) return failure;
            buffer = '';
            state = PORT;
            if (stateOverride == HOSTNAME) return;
          } else if (
            chr == EOF || chr == '/' || chr == '?' || chr == '#' ||
            (chr == '\\' && url.isSpecial())
          ) {
            if (url.isSpecial() && buffer == '') return INVALID_HOST;
            if (stateOverride && buffer == '' && (url.includesCredentials() || url.port !== null)) return;
            failure = url.parseHost(buffer);
            if (failure) return failure;
            buffer = '';
            state = PATH_START;
            if (stateOverride) return;
            continue;
          } else {
            if (chr == '[') seenBracket = true;
            else if (chr == ']') seenBracket = false;
            buffer += chr;
          } break;

        case PORT:
          if (exec(DIGIT, chr)) {
            buffer += chr;
          } else if (
            chr == EOF || chr == '/' || chr == '?' || chr == '#' ||
            (chr == '\\' && url.isSpecial()) ||
            stateOverride
          ) {
            if (buffer != '') {
              var port = parseInt(buffer, 10);
              if (port > 0xFFFF) return INVALID_PORT;
              url.port = (url.isSpecial() && port === specialSchemes[url.scheme]) ? null : port;
              buffer = '';
            }
            if (stateOverride) return;
            state = PATH_START;
            continue;
          } else return INVALID_PORT;
          break;

        case FILE:
          url.scheme = 'file';
          if (chr == '/' || chr == '\\') state = FILE_SLASH;
          else if (base && base.scheme == 'file') {
            if (chr == EOF) {
              url.host = base.host;
              url.path = arraySlice(base.path);
              url.query = base.query;
            } else if (chr == '?') {
              url.host = base.host;
              url.path = arraySlice(base.path);
              url.query = '';
              state = QUERY;
            } else if (chr == '#') {
              url.host = base.host;
              url.path = arraySlice(base.path);
              url.query = base.query;
              url.fragment = '';
              state = FRAGMENT;
            } else {
              if (!startsWithWindowsDriveLetter(join(arraySlice(codePoints, pointer), ''))) {
                url.host = base.host;
                url.path = arraySlice(base.path);
                url.shortenPath();
              }
              state = PATH;
              continue;
            }
          } else {
            state = PATH;
            continue;
          } break;

        case FILE_SLASH:
          if (chr == '/' || chr == '\\') {
            state = FILE_HOST;
            break;
          }
          if (base && base.scheme == 'file' && !startsWithWindowsDriveLetter(join(arraySlice(codePoints, pointer), ''))) {
            if (isWindowsDriveLetter(base.path[0], true)) push(url.path, base.path[0]);
            else url.host = base.host;
          }
          state = PATH;
          continue;

        case FILE_HOST:
          if (chr == EOF || chr == '/' || chr == '\\' || chr == '?' || chr == '#') {
            if (!stateOverride && isWindowsDriveLetter(buffer)) {
              state = PATH;
            } else if (buffer == '') {
              url.host = '';
              if (stateOverride) return;
              state = PATH_START;
            } else {
              failure = url.parseHost(buffer);
              if (failure) return failure;
              if (url.host == 'localhost') url.host = '';
              if (stateOverride) return;
              buffer = '';
              state = PATH_START;
            } continue;
          } else buffer += chr;
          break;

        case PATH_START:
          if (url.isSpecial()) {
            state = PATH;
            if (chr != '/' && chr != '\\') continue;
          } else if (!stateOverride && chr == '?') {
            url.query = '';
            state = QUERY;
          } else if (!stateOverride && chr == '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr != EOF) {
            state = PATH;
            if (chr != '/') continue;
          } break;

        case PATH:
          if (
            chr == EOF || chr == '/' ||
            (chr == '\\' && url.isSpecial()) ||
            (!stateOverride && (chr == '?' || chr == '#'))
          ) {
            if (isDoubleDot(buffer)) {
              url.shortenPath();
              if (chr != '/' && !(chr == '\\' && url.isSpecial())) {
                push(url.path, '');
              }
            } else if (isSingleDot(buffer)) {
              if (chr != '/' && !(chr == '\\' && url.isSpecial())) {
                push(url.path, '');
              }
            } else {
              if (url.scheme == 'file' && !url.path.length && isWindowsDriveLetter(buffer)) {
                if (url.host) url.host = '';
                buffer = charAt(buffer, 0) + ':'; // normalize windows drive letter
              }
              push(url.path, buffer);
            }
            buffer = '';
            if (url.scheme == 'file' && (chr == EOF || chr == '?' || chr == '#')) {
              while (url.path.length > 1 && url.path[0] === '') {
                shift(url.path);
              }
            }
            if (chr == '?') {
              url.query = '';
              state = QUERY;
            } else if (chr == '#') {
              url.fragment = '';
              state = FRAGMENT;
            }
          } else {
            buffer += percentEncode(chr, pathPercentEncodeSet);
          } break;

        case CANNOT_BE_A_BASE_URL_PATH:
          if (chr == '?') {
            url.query = '';
            state = QUERY;
          } else if (chr == '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr != EOF) {
            url.path[0] += percentEncode(chr, C0ControlPercentEncodeSet);
          } break;

        case QUERY:
          if (!stateOverride && chr == '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr != EOF) {
            if (chr == "'" && url.isSpecial()) url.query += '%27';
            else if (chr == '#') url.query += '%23';
            else url.query += percentEncode(chr, C0ControlPercentEncodeSet);
          } break;

        case FRAGMENT:
          if (chr != EOF) url.fragment += percentEncode(chr, fragmentPercentEncodeSet);
          break;
      }

      pointer++;
    }
  },
  // https://url.spec.whatwg.org/#host-parsing
  parseHost: function (input) {
    var result, codePoints, index;
    if (charAt(input, 0) == '[') {
      if (charAt(input, input.length - 1) != ']') return INVALID_HOST;
      result = parseIPv6(stringSlice(input, 1, -1));
      if (!result) return INVALID_HOST;
      this.host = result;
    // opaque host
    } else if (!this.isSpecial()) {
      if (exec(FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT, input)) return INVALID_HOST;
      result = '';
      codePoints = arrayFrom(input);
      for (index = 0; index < codePoints.length; index++) {
        result += percentEncode(codePoints[index], C0ControlPercentEncodeSet);
      }
      this.host = result;
    } else {
      input = toASCII(input);
      if (exec(FORBIDDEN_HOST_CODE_POINT, input)) return INVALID_HOST;
      result = parseIPv4(input);
      if (result === null) return INVALID_HOST;
      this.host = result;
    }
  },
  // https://url.spec.whatwg.org/#cannot-have-a-username-password-port
  cannotHaveUsernamePasswordPort: function () {
    return !this.host || this.cannotBeABaseURL || this.scheme == 'file';
  },
  // https://url.spec.whatwg.org/#include-credentials
  includesCredentials: function () {
    return this.username != '' || this.password != '';
  },
  // https://url.spec.whatwg.org/#is-special
  isSpecial: function () {
    return hasOwn(specialSchemes, this.scheme);
  },
  // https://url.spec.whatwg.org/#shorten-a-urls-path
  shortenPath: function () {
    var path = this.path;
    var pathSize = path.length;
    if (pathSize && (this.scheme != 'file' || pathSize != 1 || !isWindowsDriveLetter(path[0], true))) {
      path.length--;
    }
  },
  // https://url.spec.whatwg.org/#concept-url-serializer
  serialize: function () {
    var url = this;
    var scheme = url.scheme;
    var username = url.username;
    var password = url.password;
    var host = url.host;
    var port = url.port;
    var path = url.path;
    var query = url.query;
    var fragment = url.fragment;
    var output = scheme + ':';
    if (host !== null) {
      output += '//';
      if (url.includesCredentials()) {
        output += username + (password ? ':' + password : '') + '@';
      }
      output += serializeHost(host);
      if (port !== null) output += ':' + port;
    } else if (scheme == 'file') output += '//';
    output += url.cannotBeABaseURL ? path[0] : path.length ? '/' + join(path, '/') : '';
    if (query !== null) output += '?' + query;
    if (fragment !== null) output += '#' + fragment;
    return output;
  },
  // https://url.spec.whatwg.org/#dom-url-href
  setHref: function (href) {
    var failure = this.parse(href);
    if (failure) throw TypeError(failure);
    this.searchParams.update();
  },
  // https://url.spec.whatwg.org/#dom-url-origin
  getOrigin: function () {
    var scheme = this.scheme;
    var port = this.port;
    if (scheme == 'blob') try {
      return new URLConstructor(scheme.path[0]).origin;
    } catch (error) {
      return 'null';
    }
    if (scheme == 'file' || !this.isSpecial()) return 'null';
    return scheme + '://' + serializeHost(this.host) + (port !== null ? ':' + port : '');
  },
  // https://url.spec.whatwg.org/#dom-url-protocol
  getProtocol: function () {
    return this.scheme + ':';
  },
  setProtocol: function (protocol) {
    this.parse($toString(protocol) + ':', SCHEME_START);
  },
  // https://url.spec.whatwg.org/#dom-url-username
  getUsername: function () {
    return this.username;
  },
  setUsername: function (username) {
    var codePoints = arrayFrom($toString(username));
    if (this.cannotHaveUsernamePasswordPort()) return;
    this.username = '';
    for (var i = 0; i < codePoints.length; i++) {
      this.username += percentEncode(codePoints[i], userinfoPercentEncodeSet);
    }
  },
  // https://url.spec.whatwg.org/#dom-url-password
  getPassword: function () {
    return this.password;
  },
  setPassword: function (password) {
    var codePoints = arrayFrom($toString(password));
    if (this.cannotHaveUsernamePasswordPort()) return;
    this.password = '';
    for (var i = 0; i < codePoints.length; i++) {
      this.password += percentEncode(codePoints[i], userinfoPercentEncodeSet);
    }
  },
  // https://url.spec.whatwg.org/#dom-url-host
  getHost: function () {
    var host = this.host;
    var port = this.port;
    return host === null ? ''
      : port === null ? serializeHost(host)
      : serializeHost(host) + ':' + port;
  },
  setHost: function (host) {
    if (this.cannotBeABaseURL) return;
    this.parse(host, HOST);
  },
  // https://url.spec.whatwg.org/#dom-url-hostname
  getHostname: function () {
    var host = this.host;
    return host === null ? '' : serializeHost(host);
  },
  setHostname: function (hostname) {
    if (this.cannotBeABaseURL) return;
    this.parse(hostname, HOSTNAME);
  },
  // https://url.spec.whatwg.org/#dom-url-port
  getPort: function () {
    var port = this.port;
    return port === null ? '' : $toString(port);
  },
  setPort: function (port) {
    if (this.cannotHaveUsernamePasswordPort()) return;
    port = $toString(port);
    if (port == '') this.port = null;
    else this.parse(port, PORT);
  },
  // https://url.spec.whatwg.org/#dom-url-pathname
  getPathname: function () {
    var path = this.path;
    return this.cannotBeABaseURL ? path[0] : path.length ? '/' + join(path, '/') : '';
  },
  setPathname: function (pathname) {
    if (this.cannotBeABaseURL) return;
    this.path = [];
    this.parse(pathname, PATH_START);
  },
  // https://url.spec.whatwg.org/#dom-url-search
  getSearch: function () {
    var query = this.query;
    return query ? '?' + query : '';
  },
  setSearch: function (search) {
    search = $toString(search);
    if (search == '') {
      this.query = null;
    } else {
      if ('?' == charAt(search, 0)) search = stringSlice(search, 1);
      this.query = '';
      this.parse(search, QUERY);
    }
    this.searchParams.update();
  },
  // https://url.spec.whatwg.org/#dom-url-searchparams
  getSearchParams: function () {
    return this.searchParams.facade;
  },
  // https://url.spec.whatwg.org/#dom-url-hash
  getHash: function () {
    var fragment = this.fragment;
    return fragment ? '#' + fragment : '';
  },
  setHash: function (hash) {
    hash = $toString(hash);
    if (hash == '') {
      this.fragment = null;
      return;
    }
    if ('#' == charAt(hash, 0)) hash = stringSlice(hash, 1);
    this.fragment = '';
    this.parse(hash, FRAGMENT);
  },
  update: function () {
    this.query = this.searchParams.serialize() || null;
  }
};

// `URL` constructor
// https://url.spec.whatwg.org/#url-class
var URLConstructor = function URL(url /* , base */) {
  var that = anInstance(this, URLPrototype);
  var base = validateArgumentsLength(arguments.length, 1) > 1 ? arguments[1] : undefined;
  var state = setInternalState(that, new URLState(url, false, base));
  if (!DESCRIPTORS) {
    that.href = state.serialize();
    that.origin = state.getOrigin();
    that.protocol = state.getProtocol();
    that.username = state.getUsername();
    that.password = state.getPassword();
    that.host = state.getHost();
    that.hostname = state.getHostname();
    that.port = state.getPort();
    that.pathname = state.getPathname();
    that.search = state.getSearch();
    that.searchParams = state.getSearchParams();
    that.hash = state.getHash();
  }
};

var URLPrototype = URLConstructor.prototype;

var accessorDescriptor = function (getter, setter) {
  return {
    get: function () {
      return getInternalURLState(this)[getter]();
    },
    set: setter && function (value) {
      return getInternalURLState(this)[setter](value);
    },
    configurable: true,
    enumerable: true
  };
};

if (DESCRIPTORS) {
  // `URL.prototype.href` accessors pair
  // https://url.spec.whatwg.org/#dom-url-href
  defineBuiltInAccessor(URLPrototype, 'href', accessorDescriptor('serialize', 'setHref'));
  // `URL.prototype.origin` getter
  // https://url.spec.whatwg.org/#dom-url-origin
  defineBuiltInAccessor(URLPrototype, 'origin', accessorDescriptor('getOrigin'));
  // `URL.prototype.protocol` accessors pair
  // https://url.spec.whatwg.org/#dom-url-protocol
  defineBuiltInAccessor(URLPrototype, 'protocol', accessorDescriptor('getProtocol', 'setProtocol'));
  // `URL.prototype.username` accessors pair
  // https://url.spec.whatwg.org/#dom-url-username
  defineBuiltInAccessor(URLPrototype, 'username', accessorDescriptor('getUsername', 'setUsername'));
  // `URL.prototype.password` accessors pair
  // https://url.spec.whatwg.org/#dom-url-password
  defineBuiltInAccessor(URLPrototype, 'password', accessorDescriptor('getPassword', 'setPassword'));
  // `URL.prototype.host` accessors pair
  // https://url.spec.whatwg.org/#dom-url-host
  defineBuiltInAccessor(URLPrototype, 'host', accessorDescriptor('getHost', 'setHost'));
  // `URL.prototype.hostname` accessors pair
  // https://url.spec.whatwg.org/#dom-url-hostname
  defineBuiltInAccessor(URLPrototype, 'hostname', accessorDescriptor('getHostname', 'setHostname'));
  // `URL.prototype.port` accessors pair
  // https://url.spec.whatwg.org/#dom-url-port
  defineBuiltInAccessor(URLPrototype, 'port', accessorDescriptor('getPort', 'setPort'));
  // `URL.prototype.pathname` accessors pair
  // https://url.spec.whatwg.org/#dom-url-pathname
  defineBuiltInAccessor(URLPrototype, 'pathname', accessorDescriptor('getPathname', 'setPathname'));
  // `URL.prototype.search` accessors pair
  // https://url.spec.whatwg.org/#dom-url-search
  defineBuiltInAccessor(URLPrototype, 'search', accessorDescriptor('getSearch', 'setSearch'));
  // `URL.prototype.searchParams` getter
  // https://url.spec.whatwg.org/#dom-url-searchparams
  defineBuiltInAccessor(URLPrototype, 'searchParams', accessorDescriptor('getSearchParams'));
  // `URL.prototype.hash` accessors pair
  // https://url.spec.whatwg.org/#dom-url-hash
  defineBuiltInAccessor(URLPrototype, 'hash', accessorDescriptor('getHash', 'setHash'));
}

// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
defineBuiltIn(URLPrototype, 'toJSON', function toJSON() {
  return getInternalURLState(this).serialize();
}, { enumerable: true });

// `URL.prototype.toString` method
// https://url.spec.whatwg.org/#URL-stringification-behavior
defineBuiltIn(URLPrototype, 'toString', function toString() {
  return getInternalURLState(this).serialize();
}, { enumerable: true });

if (NativeURL) {
  var nativeCreateObjectURL = NativeURL.createObjectURL;
  var nativeRevokeObjectURL = NativeURL.revokeObjectURL;
  // `URL.createObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
  if (nativeCreateObjectURL) defineBuiltIn(URLConstructor, 'createObjectURL', bind(nativeCreateObjectURL, NativeURL));
  // `URL.revokeObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL
  if (nativeRevokeObjectURL) defineBuiltIn(URLConstructor, 'revokeObjectURL', bind(nativeRevokeObjectURL, NativeURL));
}

setToStringTag(URLConstructor, 'URL');

$({ global: true, constructor: true, forced: !USE_NATIVE_URL, sham: !DESCRIPTORS }, {
  URL: URLConstructor
});

},{"../internals/an-instance":578,"../internals/array-from":588,"../internals/array-slice-simple":597,"../internals/define-built-in":623,"../internals/define-built-in-accessor":622,"../internals/descriptors":627,"../internals/export":652,"../internals/function-bind-context":658,"../internals/function-uncurry-this":665,"../internals/global":672,"../internals/has-own-property":673,"../internals/internal-state":684,"../internals/object-assign":720,"../internals/set-to-string-tag":760,"../internals/string-multibyte":766,"../internals/string-punycode-to-ascii":769,"../internals/to-string":793,"../internals/url-constructor-detection":802,"../internals/validate-arguments-length":805,"../modules/es.string.iterator":984,"../modules/web.url-search-params.constructor":1086}],1090:[function(require,module,exports){
// TODO: Remove this module from `core-js@4` since it's replaced to module below
require('../modules/web.url.constructor');

},{"../modules/web.url.constructor":1089}],1091:[function(require,module,exports){
'use strict';
var $ = require('../internals/export');
var call = require('../internals/function-call');

// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
$({ target: 'URL', proto: true, enumerable: true }, {
  toJSON: function toJSON() {
    return call(URL.prototype.toString, this);
  }
});

},{"../internals/export":652,"../internals/function-call":661}],1092:[function(require,module,exports){
require('../modules/es.symbol');
require('../modules/es.symbol.description');
require('../modules/es.symbol.async-iterator');
require('../modules/es.symbol.has-instance');
require('../modules/es.symbol.is-concat-spreadable');
require('../modules/es.symbol.iterator');
require('../modules/es.symbol.match');
require('../modules/es.symbol.match-all');
require('../modules/es.symbol.replace');
require('../modules/es.symbol.search');
require('../modules/es.symbol.species');
require('../modules/es.symbol.split');
require('../modules/es.symbol.to-primitive');
require('../modules/es.symbol.to-string-tag');
require('../modules/es.symbol.unscopables');
require('../modules/es.error.cause');
require('../modules/es.error.to-string');
require('../modules/es.aggregate-error');
require('../modules/es.aggregate-error.cause');
require('../modules/es.array.at');
require('../modules/es.array.concat');
require('../modules/es.array.copy-within');
require('../modules/es.array.every');
require('../modules/es.array.fill');
require('../modules/es.array.filter');
require('../modules/es.array.find');
require('../modules/es.array.find-index');
require('../modules/es.array.find-last');
require('../modules/es.array.find-last-index');
require('../modules/es.array.flat');
require('../modules/es.array.flat-map');
require('../modules/es.array.for-each');
require('../modules/es.array.from');
require('../modules/es.array.includes');
require('../modules/es.array.index-of');
require('../modules/es.array.is-array');
require('../modules/es.array.iterator');
require('../modules/es.array.join');
require('../modules/es.array.last-index-of');
require('../modules/es.array.map');
require('../modules/es.array.of');
require('../modules/es.array.push');
require('../modules/es.array.reduce');
require('../modules/es.array.reduce-right');
require('../modules/es.array.reverse');
require('../modules/es.array.slice');
require('../modules/es.array.some');
require('../modules/es.array.sort');
require('../modules/es.array.species');
require('../modules/es.array.splice');
require('../modules/es.array.to-reversed');
require('../modules/es.array.to-sorted');
require('../modules/es.array.to-spliced');
require('../modules/es.array.unscopables.flat');
require('../modules/es.array.unscopables.flat-map');
require('../modules/es.array.unshift');
require('../modules/es.array.with');
require('../modules/es.array-buffer.constructor');
require('../modules/es.array-buffer.is-view');
require('../modules/es.array-buffer.slice');
require('../modules/es.data-view');
require('../modules/es.date.get-year');
require('../modules/es.date.now');
require('../modules/es.date.set-year');
require('../modules/es.date.to-gmt-string');
require('../modules/es.date.to-iso-string');
require('../modules/es.date.to-json');
require('../modules/es.date.to-primitive');
require('../modules/es.date.to-string');
require('../modules/es.escape');
require('../modules/es.function.bind');
require('../modules/es.function.has-instance');
require('../modules/es.function.name');
require('../modules/es.global-this');
require('../modules/es.json.stringify');
require('../modules/es.json.to-string-tag');
require('../modules/es.map');
require('../modules/es.math.acosh');
require('../modules/es.math.asinh');
require('../modules/es.math.atanh');
require('../modules/es.math.cbrt');
require('../modules/es.math.clz32');
require('../modules/es.math.cosh');
require('../modules/es.math.expm1');
require('../modules/es.math.fround');
require('../modules/es.math.hypot');
require('../modules/es.math.imul');
require('../modules/es.math.log10');
require('../modules/es.math.log1p');
require('../modules/es.math.log2');
require('../modules/es.math.sign');
require('../modules/es.math.sinh');
require('../modules/es.math.tanh');
require('../modules/es.math.to-string-tag');
require('../modules/es.math.trunc');
require('../modules/es.number.constructor');
require('../modules/es.number.epsilon');
require('../modules/es.number.is-finite');
require('../modules/es.number.is-integer');
require('../modules/es.number.is-nan');
require('../modules/es.number.is-safe-integer');
require('../modules/es.number.max-safe-integer');
require('../modules/es.number.min-safe-integer');
require('../modules/es.number.parse-float');
require('../modules/es.number.parse-int');
require('../modules/es.number.to-exponential');
require('../modules/es.number.to-fixed');
require('../modules/es.number.to-precision');
require('../modules/es.object.assign');
require('../modules/es.object.create');
require('../modules/es.object.define-getter');
require('../modules/es.object.define-properties');
require('../modules/es.object.define-property');
require('../modules/es.object.define-setter');
require('../modules/es.object.entries');
require('../modules/es.object.freeze');
require('../modules/es.object.from-entries');
require('../modules/es.object.get-own-property-descriptor');
require('../modules/es.object.get-own-property-descriptors');
require('../modules/es.object.get-own-property-names');
require('../modules/es.object.get-prototype-of');
require('../modules/es.object.has-own');
require('../modules/es.object.is');
require('../modules/es.object.is-extensible');
require('../modules/es.object.is-frozen');
require('../modules/es.object.is-sealed');
require('../modules/es.object.keys');
require('../modules/es.object.lookup-getter');
require('../modules/es.object.lookup-setter');
require('../modules/es.object.prevent-extensions');
require('../modules/es.object.proto');
require('../modules/es.object.seal');
require('../modules/es.object.set-prototype-of');
require('../modules/es.object.to-string');
require('../modules/es.object.values');
require('../modules/es.parse-float');
require('../modules/es.parse-int');
require('../modules/es.promise');
require('../modules/es.promise.all-settled');
require('../modules/es.promise.any');
require('../modules/es.promise.finally');
require('../modules/es.reflect.apply');
require('../modules/es.reflect.construct');
require('../modules/es.reflect.define-property');
require('../modules/es.reflect.delete-property');
require('../modules/es.reflect.get');
require('../modules/es.reflect.get-own-property-descriptor');
require('../modules/es.reflect.get-prototype-of');
require('../modules/es.reflect.has');
require('../modules/es.reflect.is-extensible');
require('../modules/es.reflect.own-keys');
require('../modules/es.reflect.prevent-extensions');
require('../modules/es.reflect.set');
require('../modules/es.reflect.set-prototype-of');
require('../modules/es.reflect.to-string-tag');
require('../modules/es.regexp.constructor');
require('../modules/es.regexp.dot-all');
require('../modules/es.regexp.exec');
require('../modules/es.regexp.flags');
require('../modules/es.regexp.sticky');
require('../modules/es.regexp.test');
require('../modules/es.regexp.to-string');
require('../modules/es.set');
require('../modules/es.string.at-alternative');
require('../modules/es.string.code-point-at');
require('../modules/es.string.ends-with');
require('../modules/es.string.from-code-point');
require('../modules/es.string.includes');
require('../modules/es.string.iterator');
require('../modules/es.string.match');
require('../modules/es.string.match-all');
require('../modules/es.string.pad-end');
require('../modules/es.string.pad-start');
require('../modules/es.string.raw');
require('../modules/es.string.repeat');
require('../modules/es.string.replace');
require('../modules/es.string.replace-all');
require('../modules/es.string.search');
require('../modules/es.string.split');
require('../modules/es.string.starts-with');
require('../modules/es.string.substr');
require('../modules/es.string.trim');
require('../modules/es.string.trim-end');
require('../modules/es.string.trim-start');
require('../modules/es.string.anchor');
require('../modules/es.string.big');
require('../modules/es.string.blink');
require('../modules/es.string.bold');
require('../modules/es.string.fixed');
require('../modules/es.string.fontcolor');
require('../modules/es.string.fontsize');
require('../modules/es.string.italics');
require('../modules/es.string.link');
require('../modules/es.string.small');
require('../modules/es.string.strike');
require('../modules/es.string.sub');
require('../modules/es.string.sup');
require('../modules/es.typed-array.float32-array');
require('../modules/es.typed-array.float64-array');
require('../modules/es.typed-array.int8-array');
require('../modules/es.typed-array.int16-array');
require('../modules/es.typed-array.int32-array');
require('../modules/es.typed-array.uint8-array');
require('../modules/es.typed-array.uint8-clamped-array');
require('../modules/es.typed-array.uint16-array');
require('../modules/es.typed-array.uint32-array');
require('../modules/es.typed-array.at');
require('../modules/es.typed-array.copy-within');
require('../modules/es.typed-array.every');
require('../modules/es.typed-array.fill');
require('../modules/es.typed-array.filter');
require('../modules/es.typed-array.find');
require('../modules/es.typed-array.find-index');
require('../modules/es.typed-array.find-last');
require('../modules/es.typed-array.find-last-index');
require('../modules/es.typed-array.for-each');
require('../modules/es.typed-array.from');
require('../modules/es.typed-array.includes');
require('../modules/es.typed-array.index-of');
require('../modules/es.typed-array.iterator');
require('../modules/es.typed-array.join');
require('../modules/es.typed-array.last-index-of');
require('../modules/es.typed-array.map');
require('../modules/es.typed-array.of');
require('../modules/es.typed-array.reduce');
require('../modules/es.typed-array.reduce-right');
require('../modules/es.typed-array.reverse');
require('../modules/es.typed-array.set');
require('../modules/es.typed-array.slice');
require('../modules/es.typed-array.some');
require('../modules/es.typed-array.sort');
require('../modules/es.typed-array.subarray');
require('../modules/es.typed-array.to-locale-string');
require('../modules/es.typed-array.to-reversed');
require('../modules/es.typed-array.to-sorted');
require('../modules/es.typed-array.to-string');
require('../modules/es.typed-array.with');
require('../modules/es.unescape');
require('../modules/es.weak-map');
require('../modules/es.weak-set');
require('../modules/web.atob');
require('../modules/web.btoa');
require('../modules/web.dom-collections.for-each');
require('../modules/web.dom-collections.iterator');
require('../modules/web.dom-exception.constructor');
require('../modules/web.dom-exception.stack');
require('../modules/web.dom-exception.to-string-tag');
require('../modules/web.immediate');
require('../modules/web.queue-microtask');
require('../modules/web.self');
require('../modules/web.structured-clone');
require('../modules/web.timers');
require('../modules/web.url');
require('../modules/web.url.to-json');
require('../modules/web.url-search-params');
require('../modules/web.url-search-params.size');

module.exports = require('../internals/path');

},{"../internals/path":740,"../modules/es.aggregate-error":814,"../modules/es.aggregate-error.cause":812,"../modules/es.array-buffer.constructor":815,"../modules/es.array-buffer.is-view":816,"../modules/es.array-buffer.slice":817,"../modules/es.array.at":818,"../modules/es.array.concat":819,"../modules/es.array.copy-within":820,"../modules/es.array.every":821,"../modules/es.array.fill":822,"../modules/es.array.filter":823,"../modules/es.array.find":827,"../modules/es.array.find-index":824,"../modules/es.array.find-last":826,"../modules/es.array.find-last-index":825,"../modules/es.array.flat":829,"../modules/es.array.flat-map":828,"../modules/es.array.for-each":830,"../modules/es.array.from":831,"../modules/es.array.includes":832,"../modules/es.array.index-of":833,"../modules/es.array.is-array":834,"../modules/es.array.iterator":835,"../modules/es.array.join":836,"../modules/es.array.last-index-of":837,"../modules/es.array.map":838,"../modules/es.array.of":839,"../modules/es.array.push":840,"../modules/es.array.reduce":842,"../modules/es.array.reduce-right":841,"../modules/es.array.reverse":843,"../modules/es.array.slice":844,"../modules/es.array.some":845,"../modules/es.array.sort":846,"../modules/es.array.species":847,"../modules/es.array.splice":848,"../modules/es.array.to-reversed":849,"../modules/es.array.to-sorted":850,"../modules/es.array.to-spliced":851,"../modules/es.array.unscopables.flat":853,"../modules/es.array.unscopables.flat-map":852,"../modules/es.array.unshift":854,"../modules/es.array.with":855,"../modules/es.data-view":857,"../modules/es.date.get-year":858,"../modules/es.date.now":859,"../modules/es.date.set-year":860,"../modules/es.date.to-gmt-string":861,"../modules/es.date.to-iso-string":862,"../modules/es.date.to-json":863,"../modules/es.date.to-primitive":864,"../modules/es.date.to-string":865,"../modules/es.error.cause":866,"../modules/es.error.to-string":867,"../modules/es.escape":868,"../modules/es.function.bind":869,"../modules/es.function.has-instance":870,"../modules/es.function.name":871,"../modules/es.global-this":872,"../modules/es.json.stringify":873,"../modules/es.json.to-string-tag":874,"../modules/es.map":876,"../modules/es.math.acosh":877,"../modules/es.math.asinh":878,"../modules/es.math.atanh":879,"../modules/es.math.cbrt":880,"../modules/es.math.clz32":881,"../modules/es.math.cosh":882,"../modules/es.math.expm1":883,"../modules/es.math.fround":884,"../modules/es.math.hypot":885,"../modules/es.math.imul":886,"../modules/es.math.log10":887,"../modules/es.math.log1p":888,"../modules/es.math.log2":889,"../modules/es.math.sign":890,"../modules/es.math.sinh":891,"../modules/es.math.tanh":892,"../modules/es.math.to-string-tag":893,"../modules/es.math.trunc":894,"../modules/es.number.constructor":895,"../modules/es.number.epsilon":896,"../modules/es.number.is-finite":897,"../modules/es.number.is-integer":898,"../modules/es.number.is-nan":899,"../modules/es.number.is-safe-integer":900,"../modules/es.number.max-safe-integer":901,"../modules/es.number.min-safe-integer":902,"../modules/es.number.parse-float":903,"../modules/es.number.parse-int":904,"../modules/es.number.to-exponential":905,"../modules/es.number.to-fixed":906,"../modules/es.number.to-precision":907,"../modules/es.object.assign":908,"../modules/es.object.create":909,"../modules/es.object.define-getter":910,"../modules/es.object.define-properties":911,"../modules/es.object.define-property":912,"../modules/es.object.define-setter":913,"../modules/es.object.entries":914,"../modules/es.object.freeze":915,"../modules/es.object.from-entries":916,"../modules/es.object.get-own-property-descriptor":917,"../modules/es.object.get-own-property-descriptors":918,"../modules/es.object.get-own-property-names":919,"../modules/es.object.get-prototype-of":921,"../modules/es.object.has-own":922,"../modules/es.object.is":926,"../modules/es.object.is-extensible":923,"../modules/es.object.is-frozen":924,"../modules/es.object.is-sealed":925,"../modules/es.object.keys":927,"../modules/es.object.lookup-getter":928,"../modules/es.object.lookup-setter":929,"../modules/es.object.prevent-extensions":930,"../modules/es.object.proto":931,"../modules/es.object.seal":932,"../modules/es.object.set-prototype-of":933,"../modules/es.object.to-string":934,"../modules/es.object.values":935,"../modules/es.parse-float":936,"../modules/es.parse-int":937,"../modules/es.promise":944,"../modules/es.promise.all-settled":938,"../modules/es.promise.any":940,"../modules/es.promise.finally":943,"../modules/es.reflect.apply":948,"../modules/es.reflect.construct":949,"../modules/es.reflect.define-property":950,"../modules/es.reflect.delete-property":951,"../modules/es.reflect.get":954,"../modules/es.reflect.get-own-property-descriptor":952,"../modules/es.reflect.get-prototype-of":953,"../modules/es.reflect.has":955,"../modules/es.reflect.is-extensible":956,"../modules/es.reflect.own-keys":957,"../modules/es.reflect.prevent-extensions":958,"../modules/es.reflect.set":960,"../modules/es.reflect.set-prototype-of":959,"../modules/es.reflect.to-string-tag":961,"../modules/es.regexp.constructor":962,"../modules/es.regexp.dot-all":963,"../modules/es.regexp.exec":964,"../modules/es.regexp.flags":965,"../modules/es.regexp.sticky":966,"../modules/es.regexp.test":967,"../modules/es.regexp.to-string":968,"../modules/es.set":970,"../modules/es.string.anchor":971,"../modules/es.string.at-alternative":972,"../modules/es.string.big":973,"../modules/es.string.blink":974,"../modules/es.string.bold":975,"../modules/es.string.code-point-at":976,"../modules/es.string.ends-with":977,"../modules/es.string.fixed":978,"../modules/es.string.fontcolor":979,"../modules/es.string.fontsize":980,"../modules/es.string.from-code-point":981,"../modules/es.string.includes":982,"../modules/es.string.italics":983,"../modules/es.string.iterator":984,"../modules/es.string.link":985,"../modules/es.string.match":987,"../modules/es.string.match-all":986,"../modules/es.string.pad-end":988,"../modules/es.string.pad-start":989,"../modules/es.string.raw":990,"../modules/es.string.repeat":991,"../modules/es.string.replace":993,"../modules/es.string.replace-all":992,"../modules/es.string.search":994,"../modules/es.string.small":995,"../modules/es.string.split":996,"../modules/es.string.starts-with":997,"../modules/es.string.strike":998,"../modules/es.string.sub":999,"../modules/es.string.substr":1000,"../modules/es.string.sup":1001,"../modules/es.string.trim":1006,"../modules/es.string.trim-end":1002,"../modules/es.string.trim-start":1005,"../modules/es.symbol":1014,"../modules/es.symbol.async-iterator":1007,"../modules/es.symbol.description":1009,"../modules/es.symbol.has-instance":1011,"../modules/es.symbol.is-concat-spreadable":1012,"../modules/es.symbol.iterator":1013,"../modules/es.symbol.match":1017,"../modules/es.symbol.match-all":1016,"../modules/es.symbol.replace":1018,"../modules/es.symbol.search":1019,"../modules/es.symbol.species":1020,"../modules/es.symbol.split":1021,"../modules/es.symbol.to-primitive":1022,"../modules/es.symbol.to-string-tag":1023,"../modules/es.symbol.unscopables":1024,"../modules/es.typed-array.at":1025,"../modules/es.typed-array.copy-within":1026,"../modules/es.typed-array.every":1027,"../modules/es.typed-array.fill":1028,"../modules/es.typed-array.filter":1029,"../modules/es.typed-array.find":1033,"../modules/es.typed-array.find-index":1030,"../modules/es.typed-array.find-last":1032,"../modules/es.typed-array.find-last-index":1031,"../modules/es.typed-array.float32-array":1034,"../modules/es.typed-array.float64-array":1035,"../modules/es.typed-array.for-each":1036,"../modules/es.typed-array.from":1037,"../modules/es.typed-array.includes":1038,"../modules/es.typed-array.index-of":1039,"../modules/es.typed-array.int16-array":1040,"../modules/es.typed-array.int32-array":1041,"../modules/es.typed-array.int8-array":1042,"../modules/es.typed-array.iterator":1043,"../modules/es.typed-array.join":1044,"../modules/es.typed-array.last-index-of":1045,"../modules/es.typed-array.map":1046,"../modules/es.typed-array.of":1047,"../modules/es.typed-array.reduce":1049,"../modules/es.typed-array.reduce-right":1048,"../modules/es.typed-array.reverse":1050,"../modules/es.typed-array.set":1051,"../modules/es.typed-array.slice":1052,"../modules/es.typed-array.some":1053,"../modules/es.typed-array.sort":1054,"../modules/es.typed-array.subarray":1055,"../modules/es.typed-array.to-locale-string":1056,"../modules/es.typed-array.to-reversed":1057,"../modules/es.typed-array.to-sorted":1058,"../modules/es.typed-array.to-string":1059,"../modules/es.typed-array.uint16-array":1060,"../modules/es.typed-array.uint32-array":1061,"../modules/es.typed-array.uint8-array":1062,"../modules/es.typed-array.uint8-clamped-array":1063,"../modules/es.typed-array.with":1064,"../modules/es.unescape":1065,"../modules/es.weak-map":1067,"../modules/es.weak-set":1069,"../modules/web.atob":1070,"../modules/web.btoa":1071,"../modules/web.dom-collections.for-each":1073,"../modules/web.dom-collections.iterator":1074,"../modules/web.dom-exception.constructor":1075,"../modules/web.dom-exception.stack":1076,"../modules/web.dom-exception.to-string-tag":1077,"../modules/web.immediate":1078,"../modules/web.queue-microtask":1079,"../modules/web.self":1080,"../modules/web.structured-clone":1084,"../modules/web.timers":1085,"../modules/web.url":1090,"../modules/web.url-search-params":1087,"../modules/web.url-search-params.size":1088,"../modules/web.url.to-json":1091}],1093:[function(require,module,exports){
'use strict';

var $defineProperty = require('es-define-property');

var $SyntaxError = require('es-errors/syntax');
var $TypeError = require('es-errors/type');

var gopd = require('gopd');

/** @type {import('.')} */
module.exports = function defineDataProperty(
	obj,
	property,
	value
) {
	if (!obj || (typeof obj !== 'object' && typeof obj !== 'function')) {
		throw new $TypeError('`obj` must be an object or a function`');
	}
	if (typeof property !== 'string' && typeof property !== 'symbol') {
		throw new $TypeError('`property` must be a string or a symbol`');
	}
	if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) {
		throw new $TypeError('`nonEnumerable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) {
		throw new $TypeError('`nonWritable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) {
		throw new $TypeError('`nonConfigurable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 6 && typeof arguments[6] !== 'boolean') {
		throw new $TypeError('`loose`, if provided, must be a boolean');
	}

	var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
	var nonWritable = arguments.length > 4 ? arguments[4] : null;
	var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
	var loose = arguments.length > 6 ? arguments[6] : false;

	/* @type {false | TypedPropertyDescriptor<unknown>} */
	var desc = !!gopd && gopd(obj, property);

	if ($defineProperty) {
		$defineProperty(obj, property, {
			configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
			enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
			value: value,
			writable: nonWritable === null && desc ? desc.writable : !nonWritable
		});
	} else if (loose || (!nonEnumerable && !nonWritable && !nonConfigurable)) {
		// must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
		obj[property] = value; // eslint-disable-line no-param-reassign
	} else {
		throw new $SyntaxError('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
	}
};

},{"es-define-property":1094,"es-errors/syntax":1099,"es-errors/type":1100,"gopd":1119}],1094:[function(require,module,exports){
'use strict';

var GetIntrinsic = require('get-intrinsic');

/** @type {import('.')} */
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true) || false;
if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = false;
	}
}

module.exports = $defineProperty;

},{"get-intrinsic":1118}],1095:[function(require,module,exports){
'use strict';

/** @type {import('./eval')} */
module.exports = EvalError;

},{}],1096:[function(require,module,exports){
'use strict';

/** @type {import('.')} */
module.exports = Error;

},{}],1097:[function(require,module,exports){
'use strict';

/** @type {import('./range')} */
module.exports = RangeError;

},{}],1098:[function(require,module,exports){
'use strict';

/** @type {import('./ref')} */
module.exports = ReferenceError;

},{}],1099:[function(require,module,exports){
'use strict';

/** @type {import('./syntax')} */
module.exports = SyntaxError;

},{}],1100:[function(require,module,exports){
'use strict';

/** @type {import('./type')} */
module.exports = TypeError;

},{}],1101:[function(require,module,exports){
'use strict';

/** @type {import('./uri')} */
module.exports = URIError;

},{}],1102:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

function checkListener(listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function _getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  checkListener(listener);

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
      return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      checkListener(listener);
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      checkListener(listener);

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function once(emitter, name) {
  return new Promise(function (resolve, reject) {
    function errorListener(err) {
      emitter.removeListener(name, resolver);
      reject(err);
    }

    function resolver() {
      if (typeof emitter.removeListener === 'function') {
        emitter.removeListener('error', errorListener);
      }
      resolve([].slice.call(arguments));
    };

    eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
    if (name !== 'error') {
      addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
    }
  });
}

function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
  if (typeof emitter.on === 'function') {
    eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
  }
}

function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
  if (typeof emitter.on === 'function') {
    if (flags.once) {
      emitter.once(name, listener);
    } else {
      emitter.on(name, listener);
    }
  } else if (typeof emitter.addEventListener === 'function') {
    // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
      // IE does not have builtin `{ once: true }` support so we
      // have to do it manually.
      if (flags.once) {
        emitter.removeEventListener(name, wrapListener);
      }
      listener(arg);
    });
  } else {
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
  }
}

},{}],1103:[function(require,module,exports){
'use strict';

var isCallable = require('is-callable');

var toStr = Object.prototype.toString;
var hasOwnProperty = Object.prototype.hasOwnProperty;

var forEachArray = function forEachArray(array, iterator, receiver) {
    for (var i = 0, len = array.length; i < len; i++) {
        if (hasOwnProperty.call(array, i)) {
            if (receiver == null) {
                iterator(array[i], i, array);
            } else {
                iterator.call(receiver, array[i], i, array);
            }
        }
    }
};

var forEachString = function forEachString(string, iterator, receiver) {
    for (var i = 0, len = string.length; i < len; i++) {
        // no such thing as a sparse string.
        if (receiver == null) {
            iterator(string.charAt(i), i, string);
        } else {
            iterator.call(receiver, string.charAt(i), i, string);
        }
    }
};

var forEachObject = function forEachObject(object, iterator, receiver) {
    for (var k in object) {
        if (hasOwnProperty.call(object, k)) {
            if (receiver == null) {
                iterator(object[k], k, object);
            } else {
                iterator.call(receiver, object[k], k, object);
            }
        }
    }
};

var forEach = function forEach(list, iterator, thisArg) {
    if (!isCallable(iterator)) {
        throw new TypeError('iterator must be a function');
    }

    var receiver;
    if (arguments.length >= 3) {
        receiver = thisArg;
    }

    if (toStr.call(list) === '[object Array]') {
        forEachArray(list, iterator, receiver);
    } else if (typeof list === 'string') {
        forEachString(list, iterator, receiver);
    } else {
        forEachObject(list, iterator, receiver);
    }
};

module.exports = forEach;

},{"is-callable":1161}],1104:[function(require,module,exports){
(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,setImmediate){(function (){
(function(iT,LU){typeof exports=="object"&&typeof module<"u"?LU(exports):typeof define=="function"&&define.amd?define(["exports"],LU):(iT=typeof globalThis<"u"?globalThis:iT||self,LU(iT["frontend-real-time-com-toolkit"]={}))})(this,function(iT){"use strict";function LU(t,e){for(var i=0;i<e.length;i++){const r=e[i];if(typeof r!="string"&&!Array.isArray(r)){for(const o in r)if(o!=="default"&&!(o in t)){const l=Object.getOwnPropertyDescriptor(r,o);l&&Object.defineProperty(t,o,l.get?l:{enumerable:!0,get:()=>r[o]})}}}return Object.freeze(Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}))}var MCe=typeof globalThis<"u"?globalThis:typeof window<"u"?window:typeof global<"u"?global:typeof self<"u"?self:{};function cL(t){return t&&t.__esModule&&Object.prototype.hasOwnProperty.call(t,"default")?t.default:t}function _q(t){if(Object.prototype.hasOwnProperty.call(t,"__esModule"))return t;var e=t.default;if(typeof e=="function"){var i=function r(){return this instanceof r?Reflect.construct(e,arguments,this.constructor):e.apply(this,arguments)};i.prototype=e.prototype}else i={};return Object.defineProperty(i,"__esModule",{value:!0}),Object.keys(t).forEach(function(r){var o=Object.getOwnPropertyDescriptor(t,r);Object.defineProperty(i,r,o.get?o:{enumerable:!0,get:function(){return t[r]}})}),i}var Eq={exports:{}},Nl={};/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */var PCe;function BQe(){if(PCe)return Nl;PCe=1;var t=Symbol.for("react.element"),e=Symbol.for("react.portal"),i=Symbol.for("react.fragment"),r=Symbol.for("react.strict_mode"),o=Symbol.for("react.profiler"),l=Symbol.for("react.provider"),d=Symbol.for("react.context"),h=Symbol.for("react.forward_ref"),p=Symbol.for("react.suspense"),g=Symbol.for("react.memo"),f=Symbol.for("react.lazy"),y=Symbol.iterator;function T(X){return X===null||typeof X!="object"?null:(X=y&&X[y]||X["@@iterator"],typeof X=="function"?X:null)}var C={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E=Object.assign,I={};function w(X,ve,Te){this.props=X,this.context=ve,this.refs=I,this.updater=Te||C}w.prototype.isReactComponent={},w.prototype.setState=function(X,ve){if(typeof X!="object"&&typeof X!="function"&&X!=null)throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");this.updater.enqueueSetState(this,X,ve,"setState")},w.prototype.forceUpdate=function(X){this.updater.enqueueForceUpdate(this,X,"forceUpdate")};function D(){}D.prototype=w.prototype;function F(X,ve,Te){this.props=X,this.context=ve,this.refs=I,this.updater=Te||C}var x=F.prototype=new D;x.constructor=F,E(x,w.prototype),x.isPureReactComponent=!0;var B=Array.isArray,L=Object.prototype.hasOwnProperty,z={current:null},H={key:!0,ref:!0,__self:!0,__source:!0};function j(X,ve,Te){var Be,qe={},Ge=null,tt=null;if(ve!=null)for(Be in ve.ref!==void 0&&(tt=ve.ref),ve.key!==void 0&&(Ge=""+ve.key),ve)L.call(ve,Be)&&!H.hasOwnProperty(Be)&&(qe[Be]=ve[Be]);var ct=arguments.length-2;if(ct===1)qe.children=Te;else if(1<ct){for(var Mt=Array(ct),ht=0;ht<ct;ht++)Mt[ht]=arguments[ht+2];qe.children=Mt}if(X&&X.defaultProps)for(Be in ct=X.defaultProps,ct)qe[Be]===void 0&&(qe[Be]=ct[Be]);return{$$typeof:t,type:X,key:Ge,ref:tt,props:qe,_owner:z.current}}function J(X,ve){return{$$typeof:t,type:X.type,key:ve,ref:X.ref,props:X.props,_owner:X._owner}}function Z(X){return typeof X=="object"&&X!==null&&X.$$typeof===t}function re(X){var ve={"=":"=0",":":"=2"};return"$"+X.replace(/[=:]/g,function(Te){return ve[Te]})}var ne=/\/+/g;function le(X,ve){return typeof X=="object"&&X!==null&&X.key!=null?re(""+X.key):ve.toString(36)}function he(X,ve,Te,Be,qe){var Ge=typeof X;(Ge==="undefined"||Ge==="boolean")&&(X=null);var tt=!1;if(X===null)tt=!0;else switch(Ge){case"string":case"number":tt=!0;break;case"object":switch(X.$$typeof){case t:case e:tt=!0}}if(tt)return tt=X,qe=qe(tt),X=Be===""?"."+le(tt,0):Be,B(qe)?(Te="",X!=null&&(Te=X.replace(ne,"$&/")+"/"),he(qe,ve,Te,"",function(ht){return ht})):qe!=null&&(Z(qe)&&(qe=J(qe,Te+(!qe.key||tt&&tt.key===qe.key?"":(""+qe.key).replace(ne,"$&/")+"/")+X)),ve.push(qe)),1;if(tt=0,Be=Be===""?".":Be+":",B(X))for(var ct=0;ct<X.length;ct++){Ge=X[ct];var Mt=Be+le(Ge,ct);tt+=he(Ge,ve,Te,Mt,qe)}else if(Mt=T(X),typeof Mt=="function")for(X=Mt.call(X),ct=0;!(Ge=X.next()).done;)Ge=Ge.value,Mt=Be+le(Ge,ct++),tt+=he(Ge,ve,Te,Mt,qe);else if(Ge==="object")throw ve=String(X),Error("Objects are not valid as a React child (found: "+(ve==="[object Object]"?"object with keys {"+Object.keys(X).join(", ")+"}":ve)+"). If you meant to render a collection of children, use an array instead.");return tt}function Me(X,ve,Te){if(X==null)return X;var Be=[],qe=0;return he(X,Be,"","",function(Ge){return ve.call(Te,Ge,qe++)}),Be}function Le(X){if(X._status===-1){var ve=X._result;ve=ve(),ve.then(function(Te){(X._status===0||X._status===-1)&&(X._status=1,X._result=Te)},function(Te){(X._status===0||X._status===-1)&&(X._status=2,X._result=Te)}),X._status===-1&&(X._status=0,X._result=ve)}if(X._status===1)return X._result.default;throw X._result}var pe={current:null},te={transition:null},Se={ReactCurrentDispatcher:pe,ReactCurrentBatchConfig:te,ReactCurrentOwner:z};function ce(){throw Error("act(...) is not supported in production builds of React.")}return Nl.Children={map:Me,forEach:function(X,ve,Te){Me(X,function(){ve.apply(this,arguments)},Te)},count:function(X){var ve=0;return Me(X,function(){ve++}),ve},toArray:function(X){return Me(X,function(ve){return ve})||[]},only:function(X){if(!Z(X))throw Error("React.Children.only expected to receive a single React element child.");return X}},Nl.Component=w,Nl.Fragment=i,Nl.Profiler=o,Nl.PureComponent=F,Nl.StrictMode=r,Nl.Suspense=p,Nl.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=Se,Nl.act=ce,Nl.cloneElement=function(X,ve,Te){if(X==null)throw Error("React.cloneElement(...): The argument must be a React element, but you passed "+X+".");var Be=E({},X.props),qe=X.key,Ge=X.ref,tt=X._owner;if(ve!=null){if(ve.ref!==void 0&&(Ge=ve.ref,tt=z.current),ve.key!==void 0&&(qe=""+ve.key),X.type&&X.type.defaultProps)var ct=X.type.defaultProps;for(Mt in ve)L.call(ve,Mt)&&!H.hasOwnProperty(Mt)&&(Be[Mt]=ve[Mt]===void 0&&ct!==void 0?ct[Mt]:ve[Mt])}var Mt=arguments.length-2;if(Mt===1)Be.children=Te;else if(1<Mt){ct=Array(Mt);for(var ht=0;ht<Mt;ht++)ct[ht]=arguments[ht+2];Be.children=ct}return{$$typeof:t,type:X.type,key:qe,ref:Ge,props:Be,_owner:tt}},Nl.createContext=function(X){return X={$$typeof:d,_currentValue:X,_currentValue2:X,_threadCount:0,Provider:null,Consumer:null,_defaultValue:null,_globalName:null},X.Provider={$$typeof:l,_context:X},X.Consumer=X},Nl.createElement=j,Nl.createFactory=function(X){var ve=j.bind(null,X);return ve.type=X,ve},Nl.createRef=function(){return{current:null}},Nl.forwardRef=function(X){return{$$typeof:h,render:X}},Nl.isValidElement=Z,Nl.lazy=function(X){return{$$typeof:f,_payload:{_status:-1,_result:X},_init:Le}},Nl.memo=function(X,ve){return{$$typeof:g,type:X,compare:ve===void 0?null:ve}},Nl.startTransition=function(X){var ve=te.transition;te.transition={};try{X()}finally{te.transition=ve}},Nl.unstable_act=ce,Nl.useCallback=function(X,ve){return pe.current.useCallback(X,ve)},Nl.useContext=function(X){return pe.current.useContext(X)},Nl.useDebugValue=function(){},Nl.useDeferredValue=function(X){return pe.current.useDeferredValue(X)},Nl.useEffect=function(X,ve){return pe.current.useEffect(X,ve)},Nl.useId=function(){return pe.current.useId()},Nl.useImperativeHandle=function(X,ve,Te){return pe.current.useImperativeHandle(X,ve,Te)},Nl.useInsertionEffect=function(X,ve){return pe.current.useInsertionEffect(X,ve)},Nl.useLayoutEffect=function(X,ve){return pe.current.useLayoutEffect(X,ve)},Nl.useMemo=function(X,ve){return pe.current.useMemo(X,ve)},Nl.useReducer=function(X,ve,Te){return pe.current.useReducer(X,ve,Te)},Nl.useRef=function(X){return pe.current.useRef(X)},Nl.useState=function(X){return pe.current.useState(X)},Nl.useSyncExternalStore=function(X,ve,Te){return pe.current.useSyncExternalStore(X,ve,Te)},Nl.useTransition=function(){return pe.current.useTransition()},Nl.version="18.3.1",Nl}var O$={exports:{}};/**
 * @license React
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */O$.exports;var DCe;function FQe(){return DCe||(DCe=1,function(t,e){process.env.NODE_ENV!=="production"&&function(){typeof __REACT_DEVTOOLS_GLOBAL_HOOK__<"u"&&typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart=="function"&&__REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error);var i="18.3.1",r=Symbol.for("react.element"),o=Symbol.for("react.portal"),l=Symbol.for("react.fragment"),d=Symbol.for("react.strict_mode"),h=Symbol.for("react.profiler"),p=Symbol.for("react.provider"),g=Symbol.for("react.context"),f=Symbol.for("react.forward_ref"),y=Symbol.for("react.suspense"),T=Symbol.for("react.suspense_list"),C=Symbol.for("react.memo"),E=Symbol.for("react.lazy"),I=Symbol.for("react.offscreen"),w=Symbol.iterator,D="@@iterator";function F(st){if(st===null||typeof st!="object")return null;var di=w&&st[w]||st[D];return typeof di=="function"?di:null}var x={current:null},B={transition:null},L={current:null,isBatchingLegacy:!1,didScheduleLegacyUpdate:!1},z={current:null},H={},j=null;function J(st){j=st}H.setExtraStackFrame=function(st){j=st},H.getCurrentStack=null,H.getStackAddendum=function(){var st="";j&&(st+=j);var di=H.getCurrentStack;return di&&(st+=di()||""),st};var Z=!1,re=!1,ne=!1,le=!1,he=!1,Me={ReactCurrentDispatcher:x,ReactCurrentBatchConfig:B,ReactCurrentOwner:z};Me.ReactDebugCurrentFrame=H,Me.ReactCurrentActQueue=L;function Le(st){{for(var di=arguments.length,Gi=new Array(di>1?di-1:0),un=1;un<di;un++)Gi[un-1]=arguments[un];te("warn",st,Gi)}}function pe(st){{for(var di=arguments.length,Gi=new Array(di>1?di-1:0),un=1;un<di;un++)Gi[un-1]=arguments[un];te("error",st,Gi)}}function te(st,di,Gi){{var un=Me.ReactDebugCurrentFrame,jn=un.getStackAddendum();jn!==""&&(di+="%s",Gi=Gi.concat([jn]));var no=Gi.map(function(Oa){return String(Oa)});no.unshift("Warning: "+di),Function.prototype.apply.call(console[st],console,no)}}var Se={};function ce(st,di){{var Gi=st.constructor,un=Gi&&(Gi.displayName||Gi.name)||"ReactClass",jn=un+"."+di;if(Se[jn])return;pe("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.",di,un),Se[jn]=!0}}var X={isMounted:function(st){return!1},enqueueForceUpdate:function(st,di,Gi){ce(st,"forceUpdate")},enqueueReplaceState:function(st,di,Gi,un){ce(st,"replaceState")},enqueueSetState:function(st,di,Gi,un){ce(st,"setState")}},ve=Object.assign,Te={};Object.freeze(Te);function Be(st,di,Gi){this.props=st,this.context=di,this.refs=Te,this.updater=Gi||X}Be.prototype.isReactComponent={},Be.prototype.setState=function(st,di){if(typeof st!="object"&&typeof st!="function"&&st!=null)throw new Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");this.updater.enqueueSetState(this,st,di,"setState")},Be.prototype.forceUpdate=function(st){this.updater.enqueueForceUpdate(this,st,"forceUpdate")};{var qe={isMounted:["isMounted","Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."],replaceState:["replaceState","Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."]},Ge=function(st,di){Object.defineProperty(Be.prototype,st,{get:function(){Le("%s(...) is deprecated in plain JavaScript React classes. %s",di[0],di[1])}})};for(var tt in qe)qe.hasOwnProperty(tt)&&Ge(tt,qe[tt])}function ct(){}ct.prototype=Be.prototype;function Mt(st,di,Gi){this.props=st,this.context=di,this.refs=Te,this.updater=Gi||X}var ht=Mt.prototype=new ct;ht.constructor=Mt,ve(ht,Be.prototype),ht.isPureReactComponent=!0;function vt(){var st={current:null};return Object.seal(st),st}var Pt=Array.isArray;function ni(st){return Pt(st)}function Zt(st){{var di=typeof Symbol=="function"&&Symbol.toStringTag,Gi=di&&st[Symbol.toStringTag]||st.constructor.name||"Object";return Gi}}function it(st){try{return Ke(st),!1}catch{return!0}}function Ke(st){return""+st}function ot(st){if(it(st))return pe("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.",Zt(st)),Ke(st)}function Ht(st,di,Gi){var un=st.displayName;if(un)return un;var jn=di.displayName||di.name||"";return jn!==""?Gi+"("+jn+")":Gi}function jt(st){return st.displayName||"Context"}function Nt(st){if(st==null)return null;if(typeof st.tag=="number"&&pe("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."),typeof st=="function")return st.displayName||st.name||null;if(typeof st=="string")return st;switch(st){case l:return"Fragment";case o:return"Portal";case h:return"Profiler";case d:return"StrictMode";case y:return"Suspense";case T:return"SuspenseList"}if(typeof st=="object")switch(st.$$typeof){case g:var di=st;return jt(di)+".Consumer";case p:var Gi=st;return jt(Gi._context)+".Provider";case f:return Ht(st,st.render,"ForwardRef");case C:var un=st.displayName||null;return un!==null?un:Nt(st.type)||"Memo";case E:{var jn=st,no=jn._payload,Oa=jn._init;try{return Nt(Oa(no))}catch{return null}}}return null}var Vt=Object.prototype.hasOwnProperty,$t={key:!0,ref:!0,__self:!0,__source:!0},dt,yt,kt;kt={};function je(st){if(Vt.call(st,"ref")){var di=Object.getOwnPropertyDescriptor(st,"ref").get;if(di&&di.isReactWarning)return!1}return st.ref!==void 0}function Ae(st){if(Vt.call(st,"key")){var di=Object.getOwnPropertyDescriptor(st,"key").get;if(di&&di.isReactWarning)return!1}return st.key!==void 0}function xe(st,di){var Gi=function(){dt||(dt=!0,pe("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)",di))};Gi.isReactWarning=!0,Object.defineProperty(st,"key",{get:Gi,configurable:!0})}function gt(st,di){var Gi=function(){yt||(yt=!0,pe("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)",di))};Gi.isReactWarning=!0,Object.defineProperty(st,"ref",{get:Gi,configurable:!0})}function Ye(st){if(typeof st.ref=="string"&&z.current&&st.__self&&z.current.stateNode!==st.__self){var di=Nt(z.current.type);kt[di]||(pe('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref',di,st.ref),kt[di]=!0)}}var Fe=function(st,di,Gi,un,jn,no,Oa){var Nr={$$typeof:r,type:st,key:di,ref:Gi,props:Oa,_owner:no};return Nr._store={},Object.defineProperty(Nr._store,"validated",{configurable:!1,enumerable:!1,writable:!0,value:!1}),Object.defineProperty(Nr,"_self",{configurable:!1,enumerable:!1,writable:!1,value:un}),Object.defineProperty(Nr,"_source",{configurable:!1,enumerable:!1,writable:!1,value:jn}),Object.freeze&&(Object.freeze(Nr.props),Object.freeze(Nr)),Nr};function St(st,di,Gi){var un,jn={},no=null,Oa=null,Nr=null,go=null;if(di!=null){je(di)&&(Oa=di.ref,Ye(di)),Ae(di)&&(ot(di.key),no=""+di.key),Nr=di.__self===void 0?null:di.__self,go=di.__source===void 0?null:di.__source;for(un in di)Vt.call(di,un)&&!$t.hasOwnProperty(un)&&(jn[un]=di[un])}var _s=arguments.length-2;if(_s===1)jn.children=Gi;else if(_s>1){for(var _o=Array(_s),Ks=0;Ks<_s;Ks++)_o[Ks]=arguments[Ks+2];Object.freeze&&Object.freeze(_o),jn.children=_o}if(st&&st.defaultProps){var Ko=st.defaultProps;for(un in Ko)jn[un]===void 0&&(jn[un]=Ko[un])}if(no||Oa){var Ql=typeof st=="function"?st.displayName||st.name||"Unknown":st;no&&xe(jn,Ql),Oa&&gt(jn,Ql)}return Fe(st,no,Oa,Nr,go,z.current,jn)}function Wt(st,di){var Gi=Fe(st.type,di,st.ref,st._self,st._source,st._owner,st.props);return Gi}function Ii(st,di,Gi){if(st==null)throw new Error("React.cloneElement(...): The argument must be a React element, but you passed "+st+".");var un,jn=ve({},st.props),no=st.key,Oa=st.ref,Nr=st._self,go=st._source,_s=st._owner;if(di!=null){je(di)&&(Oa=di.ref,_s=z.current),Ae(di)&&(ot(di.key),no=""+di.key);var _o;st.type&&st.type.defaultProps&&(_o=st.type.defaultProps);for(un in di)Vt.call(di,un)&&!$t.hasOwnProperty(un)&&(di[un]===void 0&&_o!==void 0?jn[un]=_o[un]:jn[un]=di[un])}var Ks=arguments.length-2;if(Ks===1)jn.children=Gi;else if(Ks>1){for(var Ko=Array(Ks),Ql=0;Ql<Ks;Ql++)Ko[Ql]=arguments[Ql+2];jn.children=Ko}return Fe(st.type,no,Oa,Nr,go,_s,jn)}function en(st){return typeof st=="object"&&st!==null&&st.$$typeof===r}var sn=".",Qi=":";function qt(st){var di=/[=:]/g,Gi={"=":"=0",":":"=2"},un=st.replace(di,function(jn){return Gi[jn]});return"$"+un}var ri=!1,Ti=/\/+/g;function rn(st){return st.replace(Ti,"$&/")}function Hn(st,di){return typeof st=="object"&&st!==null&&st.key!=null?(ot(st.key),qt(""+st.key)):di.toString(36)}function ha(st,di,Gi,un,jn){var no=typeof st;(no==="undefined"||no==="boolean")&&(st=null);var Oa=!1;if(st===null)Oa=!0;else switch(no){case"string":case"number":Oa=!0;break;case"object":switch(st.$$typeof){case r:case o:Oa=!0}}if(Oa){var Nr=st,go=jn(Nr),_s=un===""?sn+Hn(Nr,0):un;if(ni(go)){var _o="";_s!=null&&(_o=rn(_s)+"/"),ha(go,di,_o,"",function(Wm){return Wm})}else go!=null&&(en(go)&&(go.key&&(!Nr||Nr.key!==go.key)&&ot(go.key),go=Wt(go,Gi+(go.key&&(!Nr||Nr.key!==go.key)?rn(""+go.key)+"/":"")+_s)),di.push(go));return 1}var Ks,Ko,Ql=0,hs=un===""?sn:un+Qi;if(ni(st))for(var mb=0;mb<st.length;mb++)Ks=st[mb],Ko=hs+Hn(Ks,mb),Ql+=ha(Ks,di,Gi,Ko,jn);else{var QA=F(st);if(typeof QA=="function"){var Jv=st;QA===Jv.entries&&(ri||Le("Using Maps as children is not supported. Use an array of keyed ReactElements instead."),ri=!0);for(var XE=QA.call(Jv),aS,nm=0;!(aS=XE.next()).done;)Ks=aS.value,Ko=hs+Hn(Ks,nm++),Ql+=ha(Ks,di,Gi,Ko,jn)}else if(no==="object"){var Ok=String(st);throw new Error("Objects are not valid as a React child (found: "+(Ok==="[object Object]"?"object with keys {"+Object.keys(st).join(", ")+"}":Ok)+"). If you meant to render a collection of children, use an array instead.")}}return Ql}function hr(st,di,Gi){if(st==null)return st;var un=[],jn=0;return ha(st,un,"","",function(no){return di.call(Gi,no,jn++)}),un}function yn(st){var di=0;return hr(st,function(){di++}),di}function pr(st,di,Gi){hr(st,function(){di.apply(this,arguments)},Gi)}function Ho(st){return hr(st,function(di){return di})||[]}function Rr(st){if(!en(st))throw new Error("React.Children.only expected to receive a single React element child.");return st}function La(st){var di={$$typeof:g,_currentValue:st,_currentValue2:st,_threadCount:0,Provider:null,Consumer:null,_defaultValue:null,_globalName:null};di.Provider={$$typeof:p,_context:di};var Gi=!1,un=!1,jn=!1;{var no={$$typeof:g,_context:di};Object.defineProperties(no,{Provider:{get:function(){return un||(un=!0,pe("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?")),di.Provider},set:function(Oa){di.Provider=Oa}},_currentValue:{get:function(){return di._currentValue},set:function(Oa){di._currentValue=Oa}},_currentValue2:{get:function(){return di._currentValue2},set:function(Oa){di._currentValue2=Oa}},_threadCount:{get:function(){return di._threadCount},set:function(Oa){di._threadCount=Oa}},Consumer:{get:function(){return Gi||(Gi=!0,pe("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?")),di.Consumer}},displayName:{get:function(){return di.displayName},set:function(Oa){jn||(Le("Setting `displayName` on Context.Consumer has no effect. You should set it directly on the context with Context.displayName = '%s'.",Oa),jn=!0)}}}),di.Consumer=no}return di._currentRenderer=null,di._currentRenderer2=null,di}var us=-1,al=0,Us=1,$r=2;function Zd(st){if(st._status===us){var di=st._result,Gi=di();if(Gi.then(function(no){if(st._status===al||st._status===us){var Oa=st;Oa._status=Us,Oa._result=no}},function(no){if(st._status===al||st._status===us){var Oa=st;Oa._status=$r,Oa._result=no}}),st._status===us){var un=st;un._status=al,un._result=Gi}}if(st._status===Us){var jn=st._result;return jn===void 0&&pe(`lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))

Did you accidentally put curly braces around the import?`,jn),"default"in jn||pe(`lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))`,jn),jn.default}else throw st._result}function rc(st){var di={_status:us,_result:st},Gi={$$typeof:E,_payload:di,_init:Zd};{var un,jn;Object.defineProperties(Gi,{defaultProps:{configurable:!0,get:function(){return un},set:function(no){pe("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."),un=no,Object.defineProperty(Gi,"defaultProps",{enumerable:!0})}},propTypes:{configurable:!0,get:function(){return jn},set:function(no){pe("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."),jn=no,Object.defineProperty(Gi,"propTypes",{enumerable:!0})}}})}return Gi}function Yl(st){st!=null&&st.$$typeof===C?pe("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...))."):typeof st!="function"?pe("forwardRef requires a render function but was given %s.",st===null?"null":typeof st):st.length!==0&&st.length!==2&&pe("forwardRef render functions accept exactly two parameters: props and ref. %s",st.length===1?"Did you forget to use the ref parameter?":"Any additional parameter will be undefined."),st!=null&&(st.defaultProps!=null||st.propTypes!=null)&&pe("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?");var di={$$typeof:f,render:st};{var Gi;Object.defineProperty(di,"displayName",{enumerable:!1,configurable:!0,get:function(){return Gi},set:function(un){Gi=un,!st.name&&!st.displayName&&(st.displayName=un)}})}return di}var ci;ci=Symbol.for("react.module.reference");function Ai(st){return!!(typeof st=="string"||typeof st=="function"||st===l||st===h||he||st===d||st===y||st===T||le||st===I||Z||re||ne||typeof st=="object"&&st!==null&&(st.$$typeof===E||st.$$typeof===C||st.$$typeof===p||st.$$typeof===g||st.$$typeof===f||st.$$typeof===ci||st.getModuleId!==void 0))}function pn(st,di){Ai(st)||pe("memo: The first argument must be a component. Instead received: %s",st===null?"null":typeof st);var Gi={$$typeof:C,type:st,compare:di===void 0?null:di};{var un;Object.defineProperty(Gi,"displayName",{enumerable:!1,configurable:!0,get:function(){return un},set:function(jn){un=jn,!st.name&&!st.displayName&&(st.displayName=jn)}})}return Gi}function Bn(){var st=x.current;return st===null&&pe(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`),st}function Pa(st){var di=Bn();if(st._context!==void 0){var Gi=st._context;Gi.Consumer===st?pe("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?"):Gi.Provider===st&&pe("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?")}return di.useContext(st)}function qa(st){var di=Bn();return di.useState(st)}function kr(st,di,Gi){var un=Bn();return un.useReducer(st,di,Gi)}function Sa(st){var di=Bn();return di.useRef(st)}function aa(st,di){var Gi=Bn();return Gi.useEffect(st,di)}function ti(st,di){var Gi=Bn();return Gi.useInsertionEffect(st,di)}function on(st,di){var Gi=Bn();return Gi.useLayoutEffect(st,di)}function Fn(st,di){var Gi=Bn();return Gi.useCallback(st,di)}function Or(st,di){var Gi=Bn();return Gi.useMemo(st,di)}function Co(st,di,Gi){var un=Bn();return un.useImperativeHandle(st,di,Gi)}function za(st,di){{var Gi=Bn();return Gi.useDebugValue(st,di)}}function Za(){var st=Bn();return st.useTransition()}function ns(st){var di=Bn();return di.useDeferredValue(st)}function Uu(){var st=Bn();return st.useId()}function ml(st,di,Gi){var un=Bn();return un.useSyncExternalStore(st,di,Gi)}var Cu=0,Xd,Il,Pp,as,td,YA,bl;function rl(){}rl.__reactDisabledLog=!0;function db(){{if(Cu===0){Xd=console.log,Il=console.info,Pp=console.warn,as=console.error,td=console.group,YA=console.groupCollapsed,bl=console.groupEnd;var st={configurable:!0,enumerable:!0,value:rl,writable:!0};Object.defineProperties(console,{info:st,log:st,warn:st,error:st,group:st,groupCollapsed:st,groupEnd:st})}Cu++}}function Dp(){{if(Cu--,Cu===0){var st={configurable:!0,enumerable:!0,writable:!0};Object.defineProperties(console,{log:ve({},st,{value:Xd}),info:ve({},st,{value:Il}),warn:ve({},st,{value:Pp}),error:ve({},st,{value:as}),group:ve({},st,{value:td}),groupCollapsed:ve({},st,{value:YA}),groupEnd:ve({},st,{value:bl})})}Cu<0&&pe("disabledDepth fell below zero. This is a bug in React. Please file an issue.")}}var Zf=Me.ReactCurrentDispatcher,im;function Ld(st,di,Gi){{if(im===void 0)try{throw Error()}catch(jn){var un=jn.stack.trim().match(/\n( *(at )?)/);im=un&&un[1]||""}return`
`+im+st}}var Xo=!1,Qh;{var jo=typeof WeakMap=="function"?WeakMap:Map;Qh=new jo}function ZE(st,di){if(!st||Xo)return"";{var Gi=Qh.get(st);if(Gi!==void 0)return Gi}var un;Xo=!0;var jn=Error.prepareStackTrace;Error.prepareStackTrace=void 0;var no;no=Zf.current,Zf.current=null,db();try{if(di){var Oa=function(){throw Error()};if(Object.defineProperty(Oa.prototype,"props",{set:function(){throw Error()}}),typeof Reflect=="object"&&Reflect.construct){try{Reflect.construct(Oa,[])}catch(hs){un=hs}Reflect.construct(st,[],Oa)}else{try{Oa.call()}catch(hs){un=hs}st.call(Oa.prototype)}}else{try{throw Error()}catch(hs){un=hs}st()}}catch(hs){if(hs&&un&&typeof hs.stack=="string"){for(var Nr=hs.stack.split(`
`),go=un.stack.split(`
`),_s=Nr.length-1,_o=go.length-1;_s>=1&&_o>=0&&Nr[_s]!==go[_o];)_o--;for(;_s>=1&&_o>=0;_s--,_o--)if(Nr[_s]!==go[_o]){if(_s!==1||_o!==1)do if(_s--,_o--,_o<0||Nr[_s]!==go[_o]){var Ks=`
`+Nr[_s].replace(" at new "," at ");return st.displayName&&Ks.includes("<anonymous>")&&(Ks=Ks.replace("<anonymous>",st.displayName)),typeof st=="function"&&Qh.set(st,Ks),Ks}while(_s>=1&&_o>=0);break}}}finally{Xo=!1,Zf.current=no,Dp(),Error.prepareStackTrace=jn}var Ko=st?st.displayName||st.name:"",Ql=Ko?Ld(Ko):"";return typeof st=="function"&&Qh.set(st,Ql),Ql}function Zh(st,di,Gi){return ZE(st,!1)}function Kv(st){var di=st.prototype;return!!(di&&di.isReactComponent)}function iS(st,di,Gi){if(st==null)return"";if(typeof st=="function")return ZE(st,Kv(st));if(typeof st=="string")return Ld(st);switch(st){case y:return Ld("Suspense");case T:return Ld("SuspenseList")}if(typeof st=="object")switch(st.$$typeof){case f:return Zh(st.render);case C:return iS(st.type,di,Gi);case E:{var un=st,jn=un._payload,no=un._init;try{return iS(no(jn),di,Gi)}catch{}}}return""}var fl={},i_=Me.ReactDebugCurrentFrame;function ol(st){if(st){var di=st._owner,Gi=iS(st.type,st._source,di?di.type:null);i_.setExtraStackFrame(Gi)}else i_.setExtraStackFrame(null)}function Xh(st,di,Gi,un,jn){{var no=Function.call.bind(Vt);for(var Oa in st)if(no(st,Oa)){var Nr=void 0;try{if(typeof st[Oa]!="function"){var go=Error((un||"React class")+": "+Gi+" type `"+Oa+"` is invalid; it must be a function, usually from the `prop-types` package, but received `"+typeof st[Oa]+"`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");throw go.name="Invariant Violation",go}Nr=st[Oa](di,Oa,un,Gi,null,"SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED")}catch(_s){Nr=_s}Nr&&!(Nr instanceof Error)&&(ol(jn),pe("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).",un||"React class",Gi,Oa,typeof Nr),ol(null)),Nr instanceof Error&&!(Nr.message in fl)&&(fl[Nr.message]=!0,ol(jn),pe("Failed %s type: %s",Gi,Nr.message),ol(null))}}}function ch(st){if(st){var di=st._owner,Gi=iS(st.type,st._source,di?di.type:null);J(Gi)}else J(null)}var Do;Do=!1;function sl(){if(z.current){var st=Nt(z.current.type);if(st)return`

Check the render method of \``+st+"`."}return""}function zu(st){if(st!==void 0){var di=st.fileName.replace(/^.*[\\\/]/,""),Gi=st.lineNumber;return`

Check your code at `+di+":"+Gi+"."}return""}function jm(st){return st!=null?zu(st.__source):""}var Od={};function nS(st){var di=sl();if(!di){var Gi=typeof st=="string"?st:st.displayName||st.name;Gi&&(di=`

Check the top-level render call using <`+Gi+">.")}return di}function yo(st,di){if(!(!st._store||st._store.validated||st.key!=null)){st._store.validated=!0;var Gi=nS(di);if(!Od[Gi]){Od[Gi]=!0;var un="";st&&st._owner&&st._owner!==z.current&&(un=" It was passed a child from "+Nt(st._owner.type)+"."),ch(st),pe('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.',Gi,un),ch(null)}}}function oc(st,di){if(typeof st=="object"){if(ni(st))for(var Gi=0;Gi<st.length;Gi++){var un=st[Gi];en(un)&&yo(un,di)}else if(en(st))st._store&&(st._store.validated=!0);else if(st){var jn=F(st);if(typeof jn=="function"&&jn!==st.entries)for(var no=jn.call(st),Oa;!(Oa=no.next()).done;)en(Oa.value)&&yo(Oa.value,di)}}}function ub(st){{var di=st.type;if(di==null||typeof di=="string")return;var Gi;if(typeof di=="function")Gi=di.propTypes;else if(typeof di=="object"&&(di.$$typeof===f||di.$$typeof===C))Gi=di.propTypes;else return;if(Gi){var un=Nt(di);Xh(Gi,st.props,"prop",un,st)}else if(di.PropTypes!==void 0&&!Do){Do=!0;var jn=Nt(di);pe("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?",jn||"Unknown")}typeof di.getDefaultProps=="function"&&!di.getDefaultProps.isReactClassApproved&&pe("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.")}}function Go(st){{for(var di=Object.keys(st.props),Gi=0;Gi<di.length;Gi++){var un=di[Gi];if(un!=="children"&&un!=="key"){ch(st),pe("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.",un),ch(null);break}}st.ref!==null&&(ch(st),pe("Invalid attribute `ref` supplied to `React.Fragment`."),ch(null))}}function So(st,di,Gi){var un=Ai(st);if(!un){var jn="";(st===void 0||typeof st=="object"&&st!==null&&Object.keys(st).length===0)&&(jn+=" You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");var no=jm(di);no?jn+=no:jn+=sl();var Oa;st===null?Oa="null":ni(st)?Oa="array":st!==void 0&&st.$$typeof===r?(Oa="<"+(Nt(st.type)||"Unknown")+" />",jn=" Did you accidentally export a JSX literal instead of a component?"):Oa=typeof st,pe("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s",Oa,jn)}var Nr=St.apply(this,arguments);if(Nr==null)return Nr;if(un)for(var go=2;go<arguments.length;go++)oc(arguments[go],st);return st===l?Go(Nr):ub(Nr),Nr}var Xf=!1;function zs(st){var di=So.bind(null,st);return di.type=st,Xf||(Xf=!0,Le("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.")),Object.defineProperty(di,"type",{enumerable:!1,get:function(){return Le("Factory.type is deprecated. Access the class directly before passing it to createFactory."),Object.defineProperty(this,"type",{value:st}),st}}),di}function mg(st,di,Gi){for(var un=Ii.apply(this,arguments),jn=2;jn<arguments.length;jn++)oc(arguments[jn],un.type);return ub(un),un}function fg(st,di){var Gi=B.transition;B.transition={};var un=B.transition;B.transition._updatedFibers=new Set;try{st()}finally{if(B.transition=Gi,Gi===null&&un._updatedFibers){var jn=un._updatedFibers.size;jn>10&&Le("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."),un._updatedFibers.clear()}}}var hb=!1,n_=null;function Lk(st){if(n_===null)try{var di=("require"+Math.random()).slice(0,7),Gi=t&&t[di];n_=Gi.call(t,"timers").setImmediate}catch{n_=function(jn){hb===!1&&(hb=!0,typeof MessageChannel>"u"&&pe("This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning."));var no=new MessageChannel;no.port1.onmessage=jn,no.port2.postMessage(void 0)}}return n_(st)}var Gm=0,Os=!1;function dh(st){{var di=Gm;Gm++,L.current===null&&(L.current=[]);var Gi=L.isBatchingLegacy,un;try{if(L.isBatchingLegacy=!0,un=st(),!Gi&&L.didScheduleLegacyUpdate){var jn=L.current;jn!==null&&(L.didScheduleLegacyUpdate=!1,uh(jn))}}catch(Ko){throw bd(di),Ko}finally{L.isBatchingLegacy=Gi}if(un!==null&&typeof un=="object"&&typeof un.then=="function"){var no=un,Oa=!1,Nr={then:function(Ko,Ql){Oa=!0,no.then(function(hs){bd(di),Gm===0?pb(hs,Ko,Ql):Ko(hs)},function(hs){bd(di),Ql(hs)})}};return!Os&&typeof Promise<"u"&&Promise.resolve().then(function(){}).then(function(){Oa||(Os=!0,pe("You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);"))}),Nr}else{var go=un;if(bd(di),Gm===0){var _s=L.current;_s!==null&&(uh(_s),L.current=null);var _o={then:function(Ko,Ql){L.current===null?(L.current=[],pb(go,Ko,Ql)):Ko(go)}};return _o}else{var Ks={then:function(Ko,Ql){Ko(go)}};return Ks}}}}function bd(st){st!==Gm-1&&pe("You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. "),Gm=st}function pb(st,di,Gi){{var un=L.current;if(un!==null)try{uh(un),Lk(function(){un.length===0?(L.current=null,di(st)):pb(st,di,Gi)})}catch(jn){Gi(jn)}else di(st)}}var bT=!1;function uh(st){if(!bT){bT=!0;var di=0;try{for(;di<st.length;di++){var Gi=st[di];do Gi=Gi(!0);while(Gi!==null)}st.length=0}catch(un){throw st=st.slice(di+1),un}finally{bT=!1}}}var TT=So,a_=mg,gb=zs,qm={map:hr,forEach:pr,count:yn,toArray:Ho,only:Rr};e.Children=qm,e.Component=Be,e.Fragment=l,e.Profiler=h,e.PureComponent=Mt,e.StrictMode=d,e.Suspense=y,e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=Me,e.act=dh,e.cloneElement=a_,e.createContext=La,e.createElement=TT,e.createFactory=gb,e.createRef=vt,e.forwardRef=Yl,e.isValidElement=en,e.lazy=rc,e.memo=pn,e.startTransition=fg,e.unstable_act=dh,e.useCallback=Fn,e.useContext=Pa,e.useDebugValue=za,e.useDeferredValue=ns,e.useEffect=aa,e.useId=Uu,e.useImperativeHandle=Co,e.useInsertionEffect=ti,e.useLayoutEffect=on,e.useMemo=Or,e.useReducer=kr,e.useRef=Sa,e.useState=qa,e.useSyncExternalStore=ml,e.useTransition=Za,e.version=i,typeof __REACT_DEVTOOLS_GLOBAL_HOOK__<"u"&&typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop=="function"&&__REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error)}()}(O$,O$.exports)),O$.exports}var LCe;function fM(){return LCe||(LCe=1,process.env.NODE_ENV==="production"?Eq.exports=BQe():Eq.exports=FQe()),Eq.exports}var $=fM();const U=cL($),vM=LU({__proto__:null,default:U},[$]);var OU={},Aq={exports:{}},nT={},Iq={exports:{}},Mae={};/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */var OCe;function UQe(){return OCe||(OCe=1,function(t){function e(te,Se){var ce=te.length;te.push(Se);e:for(;0<ce;){var X=ce-1>>>1,ve=te[X];if(0<o(ve,Se))te[X]=Se,te[ce]=ve,ce=X;else break e}}function i(te){return te.length===0?null:te[0]}function r(te){if(te.length===0)return null;var Se=te[0],ce=te.pop();if(ce!==Se){te[0]=ce;e:for(var X=0,ve=te.length,Te=ve>>>1;X<Te;){var Be=2*(X+1)-1,qe=te[Be],Ge=Be+1,tt=te[Ge];if(0>o(qe,ce))Ge<ve&&0>o(tt,qe)?(te[X]=tt,te[Ge]=ce,X=Ge):(te[X]=qe,te[Be]=ce,X=Be);else if(Ge<ve&&0>o(tt,ce))te[X]=tt,te[Ge]=ce,X=Ge;else break e}}return Se}function o(te,Se){var ce=te.sortIndex-Se.sortIndex;return ce!==0?ce:te.id-Se.id}if(typeof performance=="object"&&typeof performance.now=="function"){var l=performance;t.unstable_now=function(){return l.now()}}else{var d=Date,h=d.now();t.unstable_now=function(){return d.now()-h}}var p=[],g=[],f=1,y=null,T=3,C=!1,E=!1,I=!1,w=typeof setTimeout=="function"?setTimeout:null,D=typeof clearTimeout=="function"?clearTimeout:null,F=typeof setImmediate<"u"?setImmediate:null;typeof navigator<"u"&&navigator.scheduling!==void 0&&navigator.scheduling.isInputPending!==void 0&&navigator.scheduling.isInputPending.bind(navigator.scheduling);function x(te){for(var Se=i(g);Se!==null;){if(Se.callback===null)r(g);else if(Se.startTime<=te)r(g),Se.sortIndex=Se.expirationTime,e(p,Se);else break;Se=i(g)}}function B(te){if(I=!1,x(te),!E)if(i(p)!==null)E=!0,Le(L);else{var Se=i(g);Se!==null&&pe(B,Se.startTime-te)}}function L(te,Se){E=!1,I&&(I=!1,D(j),j=-1),C=!0;var ce=T;try{for(x(Se),y=i(p);y!==null&&(!(y.expirationTime>Se)||te&&!re());){var X=y.callback;if(typeof X=="function"){y.callback=null,T=y.priorityLevel;var ve=X(y.expirationTime<=Se);Se=t.unstable_now(),typeof ve=="function"?y.callback=ve:y===i(p)&&r(p),x(Se)}else r(p);y=i(p)}if(y!==null)var Te=!0;else{var Be=i(g);Be!==null&&pe(B,Be.startTime-Se),Te=!1}return Te}finally{y=null,T=ce,C=!1}}var z=!1,H=null,j=-1,J=5,Z=-1;function re(){return!(t.unstable_now()-Z<J)}function ne(){if(H!==null){var te=t.unstable_now();Z=te;var Se=!0;try{Se=H(!0,te)}finally{Se?le():(z=!1,H=null)}}else z=!1}var le;if(typeof F=="function")le=function(){F(ne)};else if(typeof MessageChannel<"u"){var he=new MessageChannel,Me=he.port2;he.port1.onmessage=ne,le=function(){Me.postMessage(null)}}else le=function(){w(ne,0)};function Le(te){H=te,z||(z=!0,le())}function pe(te,Se){j=w(function(){te(t.unstable_now())},Se)}t.unstable_IdlePriority=5,t.unstable_ImmediatePriority=1,t.unstable_LowPriority=4,t.unstable_NormalPriority=3,t.unstable_Profiling=null,t.unstable_UserBlockingPriority=2,t.unstable_cancelCallback=function(te){te.callback=null},t.unstable_continueExecution=function(){E||C||(E=!0,Le(L))},t.unstable_forceFrameRate=function(te){0>te||125<te?console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"):J=0<te?Math.floor(1e3/te):5},t.unstable_getCurrentPriorityLevel=function(){return T},t.unstable_getFirstCallbackNode=function(){return i(p)},t.unstable_next=function(te){switch(T){case 1:case 2:case 3:var Se=3;break;default:Se=T}var ce=T;T=Se;try{return te()}finally{T=ce}},t.unstable_pauseExecution=function(){},t.unstable_requestPaint=function(){},t.unstable_runWithPriority=function(te,Se){switch(te){case 1:case 2:case 3:case 4:case 5:break;default:te=3}var ce=T;T=te;try{return Se()}finally{T=ce}},t.unstable_scheduleCallback=function(te,Se,ce){var X=t.unstable_now();switch(typeof ce=="object"&&ce!==null?(ce=ce.delay,ce=typeof ce=="number"&&0<ce?X+ce:X):ce=X,te){case 1:var ve=-1;break;case 2:ve=250;break;case 5:ve=1073741823;break;case 4:ve=1e4;break;default:ve=5e3}return ve=ce+ve,te={id:f++,callback:Se,priorityLevel:te,startTime:ce,expirationTime:ve,sortIndex:-1},ce>X?(te.sortIndex=ce,e(g,te),i(p)===null&&te===i(g)&&(I?(D(j),j=-1):I=!0,pe(B,ce-X))):(te.sortIndex=ve,e(p,te),E||C||(E=!0,Le(L))),te},t.unstable_shouldYield=re,t.unstable_wrapCallback=function(te){var Se=T;return function(){var ce=T;T=Se;try{return te.apply(this,arguments)}finally{T=ce}}}}(Mae)),Mae}var Pae={};/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */var NCe;function zQe(){return NCe||(NCe=1,function(t){process.env.NODE_ENV!=="production"&&function(){typeof __REACT_DEVTOOLS_GLOBAL_HOOK__<"u"&&typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart=="function"&&__REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error);var e=!1,i=5;function r(Ye,Fe){var St=Ye.length;Ye.push(Fe),d(Ye,Fe,St)}function o(Ye){return Ye.length===0?null:Ye[0]}function l(Ye){if(Ye.length===0)return null;var Fe=Ye[0],St=Ye.pop();return St!==Fe&&(Ye[0]=St,h(Ye,St,0)),Fe}function d(Ye,Fe,St){for(var Wt=St;Wt>0;){var Ii=Wt-1>>>1,en=Ye[Ii];if(p(en,Fe)>0)Ye[Ii]=Fe,Ye[Wt]=en,Wt=Ii;else return}}function h(Ye,Fe,St){for(var Wt=St,Ii=Ye.length,en=Ii>>>1;Wt<en;){var sn=(Wt+1)*2-1,Qi=Ye[sn],qt=sn+1,ri=Ye[qt];if(p(Qi,Fe)<0)qt<Ii&&p(ri,Qi)<0?(Ye[Wt]=ri,Ye[qt]=Fe,Wt=qt):(Ye[Wt]=Qi,Ye[sn]=Fe,Wt=sn);else if(qt<Ii&&p(ri,Fe)<0)Ye[Wt]=ri,Ye[qt]=Fe,Wt=qt;else return}}function p(Ye,Fe){var St=Ye.sortIndex-Fe.sortIndex;return St!==0?St:Ye.id-Fe.id}var g=1,f=2,y=3,T=4,C=5;function E(Ye,Fe){}var I=typeof performance=="object"&&typeof performance.now=="function";if(I){var w=performance;t.unstable_now=function(){return w.now()}}else{var D=Date,F=D.now();t.unstable_now=function(){return D.now()-F}}var x=1073741823,B=-1,L=250,z=5e3,H=1e4,j=x,J=[],Z=[],re=1,ne=null,le=y,he=!1,Me=!1,Le=!1,pe=typeof setTimeout=="function"?setTimeout:null,te=typeof clearTimeout=="function"?clearTimeout:null,Se=typeof setImmediate<"u"?setImmediate:null;typeof navigator<"u"&&navigator.scheduling!==void 0&&navigator.scheduling.isInputPending!==void 0&&navigator.scheduling.isInputPending.bind(navigator.scheduling);function ce(Ye){for(var Fe=o(Z);Fe!==null;){if(Fe.callback===null)l(Z);else if(Fe.startTime<=Ye)l(Z),Fe.sortIndex=Fe.expirationTime,r(J,Fe);else return;Fe=o(Z)}}function X(Ye){if(Le=!1,ce(Ye),!Me)if(o(J)!==null)Me=!0,kt(ve);else{var Fe=o(Z);Fe!==null&&je(X,Fe.startTime-Ye)}}function ve(Ye,Fe){Me=!1,Le&&(Le=!1,Ae()),he=!0;var St=le;try{var Wt;if(!e)return Te(Ye,Fe)}finally{ne=null,le=St,he=!1}}function Te(Ye,Fe){var St=Fe;for(ce(St),ne=o(J);ne!==null&&!(ne.expirationTime>St&&(!Ye||Ht()));){var Wt=ne.callback;if(typeof Wt=="function"){ne.callback=null,le=ne.priorityLevel;var Ii=ne.expirationTime<=St,en=Wt(Ii);St=t.unstable_now(),typeof en=="function"?ne.callback=en:ne===o(J)&&l(J),ce(St)}else l(J);ne=o(J)}if(ne!==null)return!0;var sn=o(Z);return sn!==null&&je(X,sn.startTime-St),!1}function Be(Ye,Fe){switch(Ye){case g:case f:case y:case T:case C:break;default:Ye=y}var St=le;le=Ye;try{return Fe()}finally{le=St}}function qe(Ye){var Fe;switch(le){case g:case f:case y:Fe=y;break;default:Fe=le;break}var St=le;le=Fe;try{return Ye()}finally{le=St}}function Ge(Ye){var Fe=le;return function(){var St=le;le=Fe;try{return Ye.apply(this,arguments)}finally{le=St}}}function tt(Ye,Fe,St){var Wt=t.unstable_now(),Ii;if(typeof St=="object"&&St!==null){var en=St.delay;typeof en=="number"&&en>0?Ii=Wt+en:Ii=Wt}else Ii=Wt;var sn;switch(Ye){case g:sn=B;break;case f:sn=L;break;case C:sn=j;break;case T:sn=H;break;case y:default:sn=z;break}var Qi=Ii+sn,qt={id:re++,callback:Fe,priorityLevel:Ye,startTime:Ii,expirationTime:Qi,sortIndex:-1};return Ii>Wt?(qt.sortIndex=Ii,r(Z,qt),o(J)===null&&qt===o(Z)&&(Le?Ae():Le=!0,je(X,Ii-Wt))):(qt.sortIndex=Qi,r(J,qt),!Me&&!he&&(Me=!0,kt(ve))),qt}function ct(){}function Mt(){!Me&&!he&&(Me=!0,kt(ve))}function ht(){return o(J)}function vt(Ye){Ye.callback=null}function Pt(){return le}var ni=!1,Zt=null,it=-1,Ke=i,ot=-1;function Ht(){var Ye=t.unstable_now()-ot;return!(Ye<Ke)}function jt(){}function Nt(Ye){if(Ye<0||Ye>125){console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");return}Ye>0?Ke=Math.floor(1e3/Ye):Ke=i}var Vt=function(){if(Zt!==null){var Ye=t.unstable_now();ot=Ye;var Fe=!0,St=!0;try{St=Zt(Fe,Ye)}finally{St?$t():(ni=!1,Zt=null)}}else ni=!1},$t;if(typeof Se=="function")$t=function(){Se(Vt)};else if(typeof MessageChannel<"u"){var dt=new MessageChannel,yt=dt.port2;dt.port1.onmessage=Vt,$t=function(){yt.postMessage(null)}}else $t=function(){pe(Vt,0)};function kt(Ye){Zt=Ye,ni||(ni=!0,$t())}function je(Ye,Fe){it=pe(function(){Ye(t.unstable_now())},Fe)}function Ae(){te(it),it=-1}var xe=jt,gt=null;t.unstable_IdlePriority=C,t.unstable_ImmediatePriority=g,t.unstable_LowPriority=T,t.unstable_NormalPriority=y,t.unstable_Profiling=gt,t.unstable_UserBlockingPriority=f,t.unstable_cancelCallback=vt,t.unstable_continueExecution=Mt,t.unstable_forceFrameRate=Nt,t.unstable_getCurrentPriorityLevel=Pt,t.unstable_getFirstCallbackNode=ht,t.unstable_next=qe,t.unstable_pauseExecution=ct,t.unstable_requestPaint=xe,t.unstable_runWithPriority=Be,t.unstable_scheduleCallback=tt,t.unstable_shouldYield=Ht,t.unstable_wrapCallback=Ge,typeof __REACT_DEVTOOLS_GLOBAL_HOOK__<"u"&&typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop=="function"&&__REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error)}()}(Pae)),Pae}var xCe;function BCe(){return xCe||(xCe=1,process.env.NODE_ENV==="production"?Iq.exports=UQe():Iq.exports=zQe()),Iq.exports}/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */var FCe;function VQe(){if(FCe)return nT;FCe=1;var t=fM(),e=BCe();function i(A){for(var R="https://reactjs.org/docs/error-decoder.html?invariant="+A,K=1;K<arguments.length;K++)R+="&args[]="+encodeURIComponent(arguments[K]);return"Minified React error #"+A+"; visit "+R+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}var r=new Set,o={};function l(A,R){d(A,R),d(A+"Capture",R)}function d(A,R){for(o[A]=R,A=0;A<R.length;A++)r.add(R[A])}var h=!(typeof window>"u"||typeof window.document>"u"||typeof window.document.createElement>"u"),p=Object.prototype.hasOwnProperty,g=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,f={},y={};function T(A){return p.call(y,A)?!0:p.call(f,A)?!1:g.test(A)?y[A]=!0:(f[A]=!0,!1)}function C(A,R,K,ae){if(K!==null&&K.type===0)return!1;switch(typeof R){case"function":case"symbol":return!0;case"boolean":return ae?!1:K!==null?!K.acceptsBooleans:(A=A.toLowerCase().slice(0,5),A!=="data-"&&A!=="aria-");default:return!1}}function E(A,R,K,ae){if(R===null||typeof R>"u"||C(A,R,K,ae))return!0;if(ae)return!1;if(K!==null)switch(K.type){case 3:return!R;case 4:return R===!1;case 5:return isNaN(R);case 6:return isNaN(R)||1>R}return!1}function I(A,R,K,ae,Ce,Ve,mt){this.acceptsBooleans=R===2||R===3||R===4,this.attributeName=ae,this.attributeNamespace=Ce,this.mustUseProperty=K,this.propertyName=A,this.type=R,this.sanitizeURL=Ve,this.removeEmptyString=mt}var w={};"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(A){w[A]=new I(A,0,!1,A,null,!1,!1)}),[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(A){var R=A[0];w[R]=new I(R,1,!1,A[1],null,!1,!1)}),["contentEditable","draggable","spellCheck","value"].forEach(function(A){w[A]=new I(A,2,!1,A.toLowerCase(),null,!1,!1)}),["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(A){w[A]=new I(A,2,!1,A,null,!1,!1)}),"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(A){w[A]=new I(A,3,!1,A.toLowerCase(),null,!1,!1)}),["checked","multiple","muted","selected"].forEach(function(A){w[A]=new I(A,3,!0,A,null,!1,!1)}),["capture","download"].forEach(function(A){w[A]=new I(A,4,!1,A,null,!1,!1)}),["cols","rows","size","span"].forEach(function(A){w[A]=new I(A,6,!1,A,null,!1,!1)}),["rowSpan","start"].forEach(function(A){w[A]=new I(A,5,!1,A.toLowerCase(),null,!1,!1)});var D=/[\-:]([a-z])/g;function F(A){return A[1].toUpperCase()}"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(A){var R=A.replace(D,F);w[R]=new I(R,1,!1,A,null,!1,!1)}),"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(A){var R=A.replace(D,F);w[R]=new I(R,1,!1,A,"http://www.w3.org/1999/xlink",!1,!1)}),["xml:base","xml:lang","xml:space"].forEach(function(A){var R=A.replace(D,F);w[R]=new I(R,1,!1,A,"http://www.w3.org/XML/1998/namespace",!1,!1)}),["tabIndex","crossOrigin"].forEach(function(A){w[A]=new I(A,1,!1,A.toLowerCase(),null,!1,!1)}),w.xlinkHref=new I("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0,!1),["src","href","action","formAction"].forEach(function(A){w[A]=new I(A,1,!1,A.toLowerCase(),null,!0,!0)});function x(A,R,K,ae){var Ce=w.hasOwnProperty(R)?w[R]:null;(Ce!==null?Ce.type!==0:ae||!(2<R.length)||R[0]!=="o"&&R[0]!=="O"||R[1]!=="n"&&R[1]!=="N")&&(E(R,K,Ce,ae)&&(K=null),ae||Ce===null?T(R)&&(K===null?A.removeAttribute(R):A.setAttribute(R,""+K)):Ce.mustUseProperty?A[Ce.propertyName]=K===null?Ce.type===3?!1:"":K:(R=Ce.attributeName,ae=Ce.attributeNamespace,K===null?A.removeAttribute(R):(Ce=Ce.type,K=Ce===3||Ce===4&&K===!0?"":""+K,ae?A.setAttributeNS(ae,R,K):A.setAttribute(R,K))))}var B=t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,L=Symbol.for("react.element"),z=Symbol.for("react.portal"),H=Symbol.for("react.fragment"),j=Symbol.for("react.strict_mode"),J=Symbol.for("react.profiler"),Z=Symbol.for("react.provider"),re=Symbol.for("react.context"),ne=Symbol.for("react.forward_ref"),le=Symbol.for("react.suspense"),he=Symbol.for("react.suspense_list"),Me=Symbol.for("react.memo"),Le=Symbol.for("react.lazy"),pe=Symbol.for("react.offscreen"),te=Symbol.iterator;function Se(A){return A===null||typeof A!="object"?null:(A=te&&A[te]||A["@@iterator"],typeof A=="function"?A:null)}var ce=Object.assign,X;function ve(A){if(X===void 0)try{throw Error()}catch(K){var R=K.stack.trim().match(/\n( *(at )?)/);X=R&&R[1]||""}return`
`+X+A}var Te=!1;function Be(A,R){if(!A||Te)return"";Te=!0;var K=Error.prepareStackTrace;Error.prepareStackTrace=void 0;try{if(R)if(R=function(){throw Error()},Object.defineProperty(R.prototype,"props",{set:function(){throw Error()}}),typeof Reflect=="object"&&Reflect.construct){try{Reflect.construct(R,[])}catch(Zi){var ae=Zi}Reflect.construct(A,[],R)}else{try{R.call()}catch(Zi){ae=Zi}A.call(R.prototype)}else{try{throw Error()}catch(Zi){ae=Zi}A()}}catch(Zi){if(Zi&&ae&&typeof Zi.stack=="string"){for(var Ce=Zi.stack.split(`
`),Ve=ae.stack.split(`
`),mt=Ce.length-1,Xt=Ve.length-1;1<=mt&&0<=Xt&&Ce[mt]!==Ve[Xt];)Xt--;for(;1<=mt&&0<=Xt;mt--,Xt--)if(Ce[mt]!==Ve[Xt]){if(mt!==1||Xt!==1)do if(mt--,Xt--,0>Xt||Ce[mt]!==Ve[Xt]){var Si=`
`+Ce[mt].replace(" at new "," at ");return A.displayName&&Si.includes("<anonymous>")&&(Si=Si.replace("<anonymous>",A.displayName)),Si}while(1<=mt&&0<=Xt);break}}}finally{Te=!1,Error.prepareStackTrace=K}return(A=A?A.displayName||A.name:"")?ve(A):""}function qe(A){switch(A.tag){case 5:return ve(A.type);case 16:return ve("Lazy");case 13:return ve("Suspense");case 19:return ve("SuspenseList");case 0:case 2:case 15:return A=Be(A.type,!1),A;case 11:return A=Be(A.type.render,!1),A;case 1:return A=Be(A.type,!0),A;default:return""}}function Ge(A){if(A==null)return null;if(typeof A=="function")return A.displayName||A.name||null;if(typeof A=="string")return A;switch(A){case H:return"Fragment";case z:return"Portal";case J:return"Profiler";case j:return"StrictMode";case le:return"Suspense";case he:return"SuspenseList"}if(typeof A=="object")switch(A.$$typeof){case re:return(A.displayName||"Context")+".Consumer";case Z:return(A._context.displayName||"Context")+".Provider";case ne:var R=A.render;return A=A.displayName,A||(A=R.displayName||R.name||"",A=A!==""?"ForwardRef("+A+")":"ForwardRef"),A;case Me:return R=A.displayName||null,R!==null?R:Ge(A.type)||"Memo";case Le:R=A._payload,A=A._init;try{return Ge(A(R))}catch{}}return null}function tt(A){var R=A.type;switch(A.tag){case 24:return"Cache";case 9:return(R.displayName||"Context")+".Consumer";case 10:return(R._context.displayName||"Context")+".Provider";case 18:return"DehydratedFragment";case 11:return A=R.render,A=A.displayName||A.name||"",R.displayName||(A!==""?"ForwardRef("+A+")":"ForwardRef");case 7:return"Fragment";case 5:return R;case 4:return"Portal";case 3:return"Root";case 6:return"Text";case 16:return Ge(R);case 8:return R===j?"StrictMode":"Mode";case 22:return"Offscreen";case 12:return"Profiler";case 21:return"Scope";case 13:return"Suspense";case 19:return"SuspenseList";case 25:return"TracingMarker";case 1:case 0:case 17:case 2:case 14:case 15:if(typeof R=="function")return R.displayName||R.name||null;if(typeof R=="string")return R}return null}function ct(A){switch(typeof A){case"boolean":case"number":case"string":case"undefined":return A;case"object":return A;default:return""}}function Mt(A){var R=A.type;return(A=A.nodeName)&&A.toLowerCase()==="input"&&(R==="checkbox"||R==="radio")}function ht(A){var R=Mt(A)?"checked":"value",K=Object.getOwnPropertyDescriptor(A.constructor.prototype,R),ae=""+A[R];if(!A.hasOwnProperty(R)&&typeof K<"u"&&typeof K.get=="function"&&typeof K.set=="function"){var Ce=K.get,Ve=K.set;return Object.defineProperty(A,R,{configurable:!0,get:function(){return Ce.call(this)},set:function(mt){ae=""+mt,Ve.call(this,mt)}}),Object.defineProperty(A,R,{enumerable:K.enumerable}),{getValue:function(){return ae},setValue:function(mt){ae=""+mt},stopTracking:function(){A._valueTracker=null,delete A[R]}}}}function vt(A){A._valueTracker||(A._valueTracker=ht(A))}function Pt(A){if(!A)return!1;var R=A._valueTracker;if(!R)return!0;var K=R.getValue(),ae="";return A&&(ae=Mt(A)?A.checked?"true":"false":A.value),A=ae,A!==K?(R.setValue(A),!0):!1}function ni(A){if(A=A||(typeof document<"u"?document:void 0),typeof A>"u")return null;try{return A.activeElement||A.body}catch{return A.body}}function Zt(A,R){var K=R.checked;return ce({},R,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:K??A._wrapperState.initialChecked})}function it(A,R){var K=R.defaultValue==null?"":R.defaultValue,ae=R.checked!=null?R.checked:R.defaultChecked;K=ct(R.value!=null?R.value:K),A._wrapperState={initialChecked:ae,initialValue:K,controlled:R.type==="checkbox"||R.type==="radio"?R.checked!=null:R.value!=null}}function Ke(A,R){R=R.checked,R!=null&&x(A,"checked",R,!1)}function ot(A,R){Ke(A,R);var K=ct(R.value),ae=R.type;if(K!=null)ae==="number"?(K===0&&A.value===""||A.value!=K)&&(A.value=""+K):A.value!==""+K&&(A.value=""+K);else if(ae==="submit"||ae==="reset"){A.removeAttribute("value");return}R.hasOwnProperty("value")?jt(A,R.type,K):R.hasOwnProperty("defaultValue")&&jt(A,R.type,ct(R.defaultValue)),R.checked==null&&R.defaultChecked!=null&&(A.defaultChecked=!!R.defaultChecked)}function Ht(A,R,K){if(R.hasOwnProperty("value")||R.hasOwnProperty("defaultValue")){var ae=R.type;if(!(ae!=="submit"&&ae!=="reset"||R.value!==void 0&&R.value!==null))return;R=""+A._wrapperState.initialValue,K||R===A.value||(A.value=R),A.defaultValue=R}K=A.name,K!==""&&(A.name=""),A.defaultChecked=!!A._wrapperState.initialChecked,K!==""&&(A.name=K)}function jt(A,R,K){(R!=="number"||ni(A.ownerDocument)!==A)&&(K==null?A.defaultValue=""+A._wrapperState.initialValue:A.defaultValue!==""+K&&(A.defaultValue=""+K))}var Nt=Array.isArray;function Vt(A,R,K,ae){if(A=A.options,R){R={};for(var Ce=0;Ce<K.length;Ce++)R["$"+K[Ce]]=!0;for(K=0;K<A.length;K++)Ce=R.hasOwnProperty("$"+A[K].value),A[K].selected!==Ce&&(A[K].selected=Ce),Ce&&ae&&(A[K].defaultSelected=!0)}else{for(K=""+ct(K),R=null,Ce=0;Ce<A.length;Ce++){if(A[Ce].value===K){A[Ce].selected=!0,ae&&(A[Ce].defaultSelected=!0);return}R!==null||A[Ce].disabled||(R=A[Ce])}R!==null&&(R.selected=!0)}}function $t(A,R){if(R.dangerouslySetInnerHTML!=null)throw Error(i(91));return ce({},R,{value:void 0,defaultValue:void 0,children:""+A._wrapperState.initialValue})}function dt(A,R){var K=R.value;if(K==null){if(K=R.children,R=R.defaultValue,K!=null){if(R!=null)throw Error(i(92));if(Nt(K)){if(1<K.length)throw Error(i(93));K=K[0]}R=K}R==null&&(R=""),K=R}A._wrapperState={initialValue:ct(K)}}function yt(A,R){var K=ct(R.value),ae=ct(R.defaultValue);K!=null&&(K=""+K,K!==A.value&&(A.value=K),R.defaultValue==null&&A.defaultValue!==K&&(A.defaultValue=K)),ae!=null&&(A.defaultValue=""+ae)}function kt(A){var R=A.textContent;R===A._wrapperState.initialValue&&R!==""&&R!==null&&(A.value=R)}function je(A){switch(A){case"svg":return"http://www.w3.org/2000/svg";case"math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ae(A,R){return A==null||A==="http://www.w3.org/1999/xhtml"?je(R):A==="http://www.w3.org/2000/svg"&&R==="foreignObject"?"http://www.w3.org/1999/xhtml":A}var xe,gt=function(A){return typeof MSApp<"u"&&MSApp.execUnsafeLocalFunction?function(R,K,ae,Ce){MSApp.execUnsafeLocalFunction(function(){return A(R,K,ae,Ce)})}:A}(function(A,R){if(A.namespaceURI!=="http://www.w3.org/2000/svg"||"innerHTML"in A)A.innerHTML=R;else{for(xe=xe||document.createElement("div"),xe.innerHTML="<svg>"+R.valueOf().toString()+"</svg>",R=xe.firstChild;A.firstChild;)A.removeChild(A.firstChild);for(;R.firstChild;)A.appendChild(R.firstChild)}});function Ye(A,R){if(R){var K=A.firstChild;if(K&&K===A.lastChild&&K.nodeType===3){K.nodeValue=R;return}}A.textContent=R}var Fe={animationIterationCount:!0,aspectRatio:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},St=["Webkit","ms","Moz","O"];Object.keys(Fe).forEach(function(A){St.forEach(function(R){R=R+A.charAt(0).toUpperCase()+A.substring(1),Fe[R]=Fe[A]})});function Wt(A,R,K){return R==null||typeof R=="boolean"||R===""?"":K||typeof R!="number"||R===0||Fe.hasOwnProperty(A)&&Fe[A]?(""+R).trim():R+"px"}function Ii(A,R){A=A.style;for(var K in R)if(R.hasOwnProperty(K)){var ae=K.indexOf("--")===0,Ce=Wt(K,R[K],ae);K==="float"&&(K="cssFloat"),ae?A.setProperty(K,Ce):A[K]=Ce}}var en=ce({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});function sn(A,R){if(R){if(en[A]&&(R.children!=null||R.dangerouslySetInnerHTML!=null))throw Error(i(137,A));if(R.dangerouslySetInnerHTML!=null){if(R.children!=null)throw Error(i(60));if(typeof R.dangerouslySetInnerHTML!="object"||!("__html"in R.dangerouslySetInnerHTML))throw Error(i(61))}if(R.style!=null&&typeof R.style!="object")throw Error(i(62))}}function Qi(A,R){if(A.indexOf("-")===-1)return typeof R.is=="string";switch(A){case"annotation-xml":case"color-profile":case"font-face":case"font-face-src":case"font-face-uri":case"font-face-format":case"font-face-name":case"missing-glyph":return!1;default:return!0}}var qt=null;function ri(A){return A=A.target||A.srcElement||window,A.correspondingUseElement&&(A=A.correspondingUseElement),A.nodeType===3?A.parentNode:A}var Ti=null,rn=null,Hn=null;function ha(A){if(A=Ia(A)){if(typeof Ti!="function")throw Error(i(280));var R=A.stateNode;R&&(R=Nd(R),Ti(A.stateNode,A.type,R))}}function hr(A){rn?Hn?Hn.push(A):Hn=[A]:rn=A}function yn(){if(rn){var A=rn,R=Hn;if(Hn=rn=null,ha(A),R)for(A=0;A<R.length;A++)ha(R[A])}}function pr(A,R){return A(R)}function Ho(){}var Rr=!1;function La(A,R,K){if(Rr)return A(R,K);Rr=!0;try{return pr(A,R,K)}finally{Rr=!1,(rn!==null||Hn!==null)&&(Ho(),yn())}}function us(A,R){var K=A.stateNode;if(K===null)return null;var ae=Nd(K);if(ae===null)return null;K=ae[R];e:switch(R){case"onClick":case"onClickCapture":case"onDoubleClick":case"onDoubleClickCapture":case"onMouseDown":case"onMouseDownCapture":case"onMouseMove":case"onMouseMoveCapture":case"onMouseUp":case"onMouseUpCapture":case"onMouseEnter":(ae=!ae.disabled)||(A=A.type,ae=!(A==="button"||A==="input"||A==="select"||A==="textarea")),A=!ae;break e;default:A=!1}if(A)return null;if(K&&typeof K!="function")throw Error(i(231,R,typeof K));return K}var al=!1;if(h)try{var Us={};Object.defineProperty(Us,"passive",{get:function(){al=!0}}),window.addEventListener("test",Us,Us),window.removeEventListener("test",Us,Us)}catch{al=!1}function $r(A,R,K,ae,Ce,Ve,mt,Xt,Si){var Zi=Array.prototype.slice.call(arguments,3);try{R.apply(K,Zi)}catch(Kn){this.onError(Kn)}}var Zd=!1,rc=null,Yl=!1,ci=null,Ai={onError:function(A){Zd=!0,rc=A}};function pn(A,R,K,ae,Ce,Ve,mt,Xt,Si){Zd=!1,rc=null,$r.apply(Ai,arguments)}function Bn(A,R,K,ae,Ce,Ve,mt,Xt,Si){if(pn.apply(this,arguments),Zd){if(Zd){var Zi=rc;Zd=!1,rc=null}else throw Error(i(198));Yl||(Yl=!0,ci=Zi)}}function Pa(A){var R=A,K=A;if(A.alternate)for(;R.return;)R=R.return;else{A=R;do R=A,(R.flags&4098)!==0&&(K=R.return),A=R.return;while(A)}return R.tag===3?K:null}function qa(A){if(A.tag===13){var R=A.memoizedState;if(R===null&&(A=A.alternate,A!==null&&(R=A.memoizedState)),R!==null)return R.dehydrated}return null}function kr(A){if(Pa(A)!==A)throw Error(i(188))}function Sa(A){var R=A.alternate;if(!R){if(R=Pa(A),R===null)throw Error(i(188));return R!==A?null:A}for(var K=A,ae=R;;){var Ce=K.return;if(Ce===null)break;var Ve=Ce.alternate;if(Ve===null){if(ae=Ce.return,ae!==null){K=ae;continue}break}if(Ce.child===Ve.child){for(Ve=Ce.child;Ve;){if(Ve===K)return kr(Ce),A;if(Ve===ae)return kr(Ce),R;Ve=Ve.sibling}throw Error(i(188))}if(K.return!==ae.return)K=Ce,ae=Ve;else{for(var mt=!1,Xt=Ce.child;Xt;){if(Xt===K){mt=!0,K=Ce,ae=Ve;break}if(Xt===ae){mt=!0,ae=Ce,K=Ve;break}Xt=Xt.sibling}if(!mt){for(Xt=Ve.child;Xt;){if(Xt===K){mt=!0,K=Ve,ae=Ce;break}if(Xt===ae){mt=!0,ae=Ve,K=Ce;break}Xt=Xt.sibling}if(!mt)throw Error(i(189))}}if(K.alternate!==ae)throw Error(i(190))}if(K.tag!==3)throw Error(i(188));return K.stateNode.current===K?A:R}function aa(A){return A=Sa(A),A!==null?ti(A):null}function ti(A){if(A.tag===5||A.tag===6)return A;for(A=A.child;A!==null;){var R=ti(A);if(R!==null)return R;A=A.sibling}return null}var on=e.unstable_scheduleCallback,Fn=e.unstable_cancelCallback,Or=e.unstable_shouldYield,Co=e.unstable_requestPaint,za=e.unstable_now,Za=e.unstable_getCurrentPriorityLevel,ns=e.unstable_ImmediatePriority,Uu=e.unstable_UserBlockingPriority,ml=e.unstable_NormalPriority,Cu=e.unstable_LowPriority,Xd=e.unstable_IdlePriority,Il=null,Pp=null;function as(A){if(Pp&&typeof Pp.onCommitFiberRoot=="function")try{Pp.onCommitFiberRoot(Il,A,void 0,(A.current.flags&128)===128)}catch{}}var td=Math.clz32?Math.clz32:rl,YA=Math.log,bl=Math.LN2;function rl(A){return A>>>=0,A===0?32:31-(YA(A)/bl|0)|0}var db=64,Dp=4194304;function Zf(A){switch(A&-A){case 1:return 1;case 2:return 2;case 4:return 4;case 8:return 8;case 16:return 16;case 32:return 32;case 64:case 128:case 256:case 512:case 1024:case 2048:case 4096:case 8192:case 16384:case 32768:case 65536:case 131072:case 262144:case 524288:case 1048576:case 2097152:return A&4194240;case 4194304:case 8388608:case 16777216:case 33554432:case 67108864:return A&130023424;case 134217728:return 134217728;case 268435456:return 268435456;case 536870912:return 536870912;case 1073741824:return 1073741824;default:return A}}function im(A,R){var K=A.pendingLanes;if(K===0)return 0;var ae=0,Ce=A.suspendedLanes,Ve=A.pingedLanes,mt=K&268435455;if(mt!==0){var Xt=mt&~Ce;Xt!==0?ae=Zf(Xt):(Ve&=mt,Ve!==0&&(ae=Zf(Ve)))}else mt=K&~Ce,mt!==0?ae=Zf(mt):Ve!==0&&(ae=Zf(Ve));if(ae===0)return 0;if(R!==0&&R!==ae&&(R&Ce)===0&&(Ce=ae&-ae,Ve=R&-R,Ce>=Ve||Ce===16&&(Ve&4194240)!==0))return R;if((ae&4)!==0&&(ae|=K&16),R=A.entangledLanes,R!==0)for(A=A.entanglements,R&=ae;0<R;)K=31-td(R),Ce=1<<K,ae|=A[K],R&=~Ce;return ae}function Ld(A,R){switch(A){case 1:case 2:case 4:return R+250;case 8:case 16:case 32:case 64:case 128:case 256:case 512:case 1024:case 2048:case 4096:case 8192:case 16384:case 32768:case 65536:case 131072:case 262144:case 524288:case 1048576:case 2097152:return R+5e3;case 4194304:case 8388608:case 16777216:case 33554432:case 67108864:return-1;case 134217728:case 268435456:case 536870912:case 1073741824:return-1;default:return-1}}function Xo(A,R){for(var K=A.suspendedLanes,ae=A.pingedLanes,Ce=A.expirationTimes,Ve=A.pendingLanes;0<Ve;){var mt=31-td(Ve),Xt=1<<mt,Si=Ce[mt];Si===-1?((Xt&K)===0||(Xt&ae)!==0)&&(Ce[mt]=Ld(Xt,R)):Si<=R&&(A.expiredLanes|=Xt),Ve&=~Xt}}function Qh(A){return A=A.pendingLanes&-1073741825,A!==0?A:A&1073741824?1073741824:0}function jo(){var A=db;return db<<=1,(db&4194240)===0&&(db=64),A}function ZE(A){for(var R=[],K=0;31>K;K++)R.push(A);return R}function Zh(A,R,K){A.pendingLanes|=R,R!==536870912&&(A.suspendedLanes=0,A.pingedLanes=0),A=A.eventTimes,R=31-td(R),A[R]=K}function Kv(A,R){var K=A.pendingLanes&~R;A.pendingLanes=R,A.suspendedLanes=0,A.pingedLanes=0,A.expiredLanes&=R,A.mutableReadLanes&=R,A.entangledLanes&=R,R=A.entanglements;var ae=A.eventTimes;for(A=A.expirationTimes;0<K;){var Ce=31-td(K),Ve=1<<Ce;R[Ce]=0,ae[Ce]=-1,A[Ce]=-1,K&=~Ve}}function iS(A,R){var K=A.entangledLanes|=R;for(A=A.entanglements;K;){var ae=31-td(K),Ce=1<<ae;Ce&R|A[ae]&R&&(A[ae]|=R),K&=~Ce}}var fl=0;function i_(A){return A&=-A,1<A?4<A?(A&268435455)!==0?16:536870912:4:1}var ol,Xh,ch,Do,sl,zu=!1,jm=[],Od=null,nS=null,yo=null,oc=new Map,ub=new Map,Go=[],So="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");function Xf(A,R){switch(A){case"focusin":case"focusout":Od=null;break;case"dragenter":case"dragleave":nS=null;break;case"mouseover":case"mouseout":yo=null;break;case"pointerover":case"pointerout":oc.delete(R.pointerId);break;case"gotpointercapture":case"lostpointercapture":ub.delete(R.pointerId)}}function zs(A,R,K,ae,Ce,Ve){return A===null||A.nativeEvent!==Ve?(A={blockedOn:R,domEventName:K,eventSystemFlags:ae,nativeEvent:Ve,targetContainers:[Ce]},R!==null&&(R=Ia(R),R!==null&&Xh(R)),A):(A.eventSystemFlags|=ae,R=A.targetContainers,Ce!==null&&R.indexOf(Ce)===-1&&R.push(Ce),A)}function mg(A,R,K,ae,Ce){switch(R){case"focusin":return Od=zs(Od,A,R,K,ae,Ce),!0;case"dragenter":return nS=zs(nS,A,R,K,ae,Ce),!0;case"mouseover":return yo=zs(yo,A,R,K,ae,Ce),!0;case"pointerover":var Ve=Ce.pointerId;return oc.set(Ve,zs(oc.get(Ve)||null,A,R,K,ae,Ce)),!0;case"gotpointercapture":return Ve=Ce.pointerId,ub.set(Ve,zs(ub.get(Ve)||null,A,R,K,ae,Ce)),!0}return!1}function fg(A){var R=Cb(A.target);if(R!==null){var K=Pa(R);if(K!==null){if(R=K.tag,R===13){if(R=qa(K),R!==null){A.blockedOn=R,sl(A.priority,function(){ch(K)});return}}else if(R===3&&K.stateNode.current.memoizedState.isDehydrated){A.blockedOn=K.tag===3?K.stateNode.containerInfo:null;return}}}A.blockedOn=null}function hb(A){if(A.blockedOn!==null)return!1;for(var R=A.targetContainers;0<R.length;){var K=a_(A.domEventName,A.eventSystemFlags,R[0],A.nativeEvent);if(K===null){K=A.nativeEvent;var ae=new K.constructor(K.type,K);qt=ae,K.target.dispatchEvent(ae),qt=null}else return R=Ia(K),R!==null&&Xh(R),A.blockedOn=K,!1;R.shift()}return!0}function n_(A,R,K){hb(A)&&K.delete(R)}function Lk(){zu=!1,Od!==null&&hb(Od)&&(Od=null),nS!==null&&hb(nS)&&(nS=null),yo!==null&&hb(yo)&&(yo=null),oc.forEach(n_),ub.forEach(n_)}function Gm(A,R){A.blockedOn===R&&(A.blockedOn=null,zu||(zu=!0,e.unstable_scheduleCallback(e.unstable_NormalPriority,Lk)))}function Os(A){function R(Ce){return Gm(Ce,A)}if(0<jm.length){Gm(jm[0],A);for(var K=1;K<jm.length;K++){var ae=jm[K];ae.blockedOn===A&&(ae.blockedOn=null)}}for(Od!==null&&Gm(Od,A),nS!==null&&Gm(nS,A),yo!==null&&Gm(yo,A),oc.forEach(R),ub.forEach(R),K=0;K<Go.length;K++)ae=Go[K],ae.blockedOn===A&&(ae.blockedOn=null);for(;0<Go.length&&(K=Go[0],K.blockedOn===null);)fg(K),K.blockedOn===null&&Go.shift()}var dh=B.ReactCurrentBatchConfig,bd=!0;function pb(A,R,K,ae){var Ce=fl,Ve=dh.transition;dh.transition=null;try{fl=1,uh(A,R,K,ae)}finally{fl=Ce,dh.transition=Ve}}function bT(A,R,K,ae){var Ce=fl,Ve=dh.transition;dh.transition=null;try{fl=4,uh(A,R,K,ae)}finally{fl=Ce,dh.transition=Ve}}function uh(A,R,K,ae){if(bd){var Ce=a_(A,R,K,ae);if(Ce===null)h_(A,R,ae,TT,K),Xf(A,ae);else if(mg(Ce,A,R,K,ae))ae.stopPropagation();else if(Xf(A,ae),R&4&&-1<So.indexOf(A)){for(;Ce!==null;){var Ve=Ia(Ce);if(Ve!==null&&ol(Ve),Ve=a_(A,R,K,ae),Ve===null&&h_(A,R,ae,TT,K),Ve===Ce)break;Ce=Ve}Ce!==null&&ae.stopPropagation()}else h_(A,R,ae,null,K)}}var TT=null;function a_(A,R,K,ae){if(TT=null,A=ri(ae),A=Cb(A),A!==null)if(R=Pa(A),R===null)A=null;else if(K=R.tag,K===13){if(A=qa(R),A!==null)return A;A=null}else if(K===3){if(R.stateNode.current.memoizedState.isDehydrated)return R.tag===3?R.stateNode.containerInfo:null;A=null}else R!==A&&(A=null);return TT=A,null}function gb(A){switch(A){case"cancel":case"click":case"close":case"contextmenu":case"copy":case"cut":case"auxclick":case"dblclick":case"dragend":case"dragstart":case"drop":case"focusin":case"focusout":case"input":case"invalid":case"keydown":case"keypress":case"keyup":case"mousedown":case"mouseup":case"paste":case"pause":case"play":case"pointercancel":case"pointerdown":case"pointerup":case"ratechange":case"reset":case"resize":case"seeked":case"submit":case"touchcancel":case"touchend":case"touchstart":case"volumechange":case"change":case"selectionchange":case"textInput":case"compositionstart":case"compositionend":case"compositionupdate":case"beforeblur":case"afterblur":case"beforeinput":case"blur":case"fullscreenchange":case"focus":case"hashchange":case"popstate":case"select":case"selectstart":return 1;case"drag":case"dragenter":case"dragexit":case"dragleave":case"dragover":case"mousemove":case"mouseout":case"mouseover":case"pointermove":case"pointerout":case"pointerover":case"scroll":case"toggle":case"touchmove":case"wheel":case"mouseenter":case"mouseleave":case"pointerenter":case"pointerleave":return 4;case"message":switch(Za()){case ns:return 1;case Uu:return 4;case ml:case Cu:return 16;case Xd:return 536870912;default:return 16}default:return 16}}var qm=null,st=null,di=null;function Gi(){if(di)return di;var A,R=st,K=R.length,ae,Ce="value"in qm?qm.value:qm.textContent,Ve=Ce.length;for(A=0;A<K&&R[A]===Ce[A];A++);var mt=K-A;for(ae=1;ae<=mt&&R[K-ae]===Ce[Ve-ae];ae++);return di=Ce.slice(A,1<ae?1-ae:void 0)}function un(A){var R=A.keyCode;return"charCode"in A?(A=A.charCode,A===0&&R===13&&(A=13)):A=R,A===10&&(A=13),32<=A||A===13?A:0}function jn(){return!0}function no(){return!1}function Oa(A){function R(K,ae,Ce,Ve,mt){this._reactName=K,this._targetInst=Ce,this.type=ae,this.nativeEvent=Ve,this.target=mt,this.currentTarget=null;for(var Xt in A)A.hasOwnProperty(Xt)&&(K=A[Xt],this[Xt]=K?K(Ve):Ve[Xt]);return this.isDefaultPrevented=(Ve.defaultPrevented!=null?Ve.defaultPrevented:Ve.returnValue===!1)?jn:no,this.isPropagationStopped=no,this}return ce(R.prototype,{preventDefault:function(){this.defaultPrevented=!0;var K=this.nativeEvent;K&&(K.preventDefault?K.preventDefault():typeof K.returnValue!="unknown"&&(K.returnValue=!1),this.isDefaultPrevented=jn)},stopPropagation:function(){var K=this.nativeEvent;K&&(K.stopPropagation?K.stopPropagation():typeof K.cancelBubble!="unknown"&&(K.cancelBubble=!0),this.isPropagationStopped=jn)},persist:function(){},isPersistent:jn}),R}var Nr={eventPhase:0,bubbles:0,cancelable:0,timeStamp:function(A){return A.timeStamp||Date.now()},defaultPrevented:0,isTrusted:0},go=Oa(Nr),_s=ce({},Nr,{view:0,detail:0}),_o=Oa(_s),Ks,Ko,Ql,hs=ce({},_s,{screenX:0,screenY:0,clientX:0,clientY:0,pageX:0,pageY:0,ctrlKey:0,shiftKey:0,altKey:0,metaKey:0,getModifierState:wP,button:0,buttons:0,relatedTarget:function(A){return A.relatedTarget===void 0?A.fromElement===A.srcElement?A.toElement:A.fromElement:A.relatedTarget},movementX:function(A){return"movementX"in A?A.movementX:(A!==Ql&&(Ql&&A.type==="mousemove"?(Ks=A.screenX-Ql.screenX,Ko=A.screenY-Ql.screenY):Ko=Ks=0,Ql=A),Ks)},movementY:function(A){return"movementY"in A?A.movementY:Ko}}),mb=Oa(hs),QA=ce({},hs,{dataTransfer:0}),Jv=Oa(QA),XE=ce({},_s,{relatedTarget:0}),aS=Oa(XE),nm=ce({},Nr,{animationName:0,elapsedTime:0,pseudoElement:0}),Ok=Oa(nm),Wm=ce({},Nr,{clipboardData:function(A){return"clipboardData"in A?A.clipboardData:window.clipboardData}}),r_=Oa(Wm),e0=ce({},Nr,{data:0}),CT=Oa(e0),_T={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Vu={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},Nk={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function hh(A){var R=this.nativeEvent;return R.getModifierState?R.getModifierState(A):(A=Nk[A])?!!R[A]:!1}function wP(){return hh}var ev=ce({},_s,{key:function(A){if(A.key){var R=_T[A.key]||A.key;if(R!=="Unidentified")return R}return A.type==="keypress"?(A=un(A),A===13?"Enter":String.fromCharCode(A)):A.type==="keydown"||A.type==="keyup"?Vu[A.keyCode]||"Unidentified":""},code:0,location:0,ctrlKey:0,shiftKey:0,altKey:0,metaKey:0,repeat:0,locale:0,getModifierState:wP,charCode:function(A){return A.type==="keypress"?un(A):0},keyCode:function(A){return A.type==="keydown"||A.type==="keyup"?A.keyCode:0},which:function(A){return A.type==="keypress"?un(A):A.type==="keydown"||A.type==="keyup"?A.keyCode:0}}),vg=Oa(ev),fb=ce({},hs,{pointerId:0,width:0,height:0,pressure:0,tangentialPressure:0,tiltX:0,tiltY:0,twist:0,pointerType:0,isPrimary:0}),o_=Oa(fb),ET=ce({},_s,{touches:0,targetTouches:0,changedTouches:0,altKey:0,metaKey:0,ctrlKey:0,shiftKey:0,getModifierState:wP}),Yv=Oa(ET),am=ce({},Nr,{propertyName:0,elapsedTime:0,pseudoElement:0}),tv=Oa(am),$u=ce({},hs,{deltaX:function(A){return"deltaX"in A?A.deltaX:"wheelDeltaX"in A?-A.wheelDeltaX:0},deltaY:function(A){return"deltaY"in A?A.deltaY:"wheelDeltaY"in A?-A.wheelDeltaY:"wheelDelta"in A?-A.wheelDelta:0},deltaZ:0,deltaMode:0}),vb=Oa($u),kP=[9,13,27,32],rm=h&&"CompositionEvent"in window,yb=null;h&&"documentMode"in document&&(yb=document.documentMode);var s_=h&&"TextEvent"in window&&!yb,t0=h&&(!rm||yb&&8<yb&&11>=yb),RP=" ",iv=!1;function rS(A,R){switch(A){case"keyup":return kP.indexOf(R.keyCode)!==-1;case"keydown":return R.keyCode!==229;case"keypress":case"mousedown":case"focusout":return!0;default:return!1}}function oS(A){return A=A.detail,typeof A=="object"&&"data"in A?A.data:null}var Va=!1;function om(A,R){switch(A){case"compositionend":return oS(R);case"keypress":return R.which!==32?null:(iv=!0,RP);case"textInput":return A=R.data,A===RP&&iv?null:A;default:return null}}function AT(A,R){if(Va)return A==="compositionend"||!rm&&rS(A,R)?(A=Gi(),di=st=qm=null,Va=!1,A):null;switch(A){case"paste":return null;case"keypress":if(!(R.ctrlKey||R.altKey||R.metaKey)||R.ctrlKey&&R.altKey){if(R.char&&1<R.char.length)return R.char;if(R.which)return String.fromCharCode(R.which)}return null;case"compositionend":return t0&&R.locale!=="ko"?null:R.data;default:return null}}var Qv={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function ZA(A){var R=A&&A.nodeName&&A.nodeName.toLowerCase();return R==="input"?!!Qv[A.type]:R==="textarea"}function MP(A,R,K,ae){hr(ae),R=kT(R,"onChange"),0<R.length&&(K=new go("onChange","change",null,K,ae),A.push({event:K,listeners:R}))}var ep=null,l_=null;function PP(A){yg(A,0)}function XA(A){var R=Ym(A);if(Pt(R))return A}function c_(A,R){if(A==="change")return R}var Oi=!1;if(h){var gn;if(h){var Tn="oninput"in document;if(!Tn){var Aa=document.createElement("div");Aa.setAttribute("oninput","return;"),Tn=typeof Aa.oninput=="function"}gn=Tn}else gn=!1;Oi=gn&&(!document.documentMode||9<document.documentMode)}function ko(){ep&&(ep.detachEvent("onpropertychange",vl),l_=ep=null)}function vl(A){if(A.propertyName==="value"&&XA(l_)){var R=[];MP(R,l_,A,ri(A)),La(PP,R)}}function tp(A,R,K){A==="focusin"?(ko(),ep=R,l_=K,ep.attachEvent("onpropertychange",vl)):A==="focusout"&&ko()}function eu(A){if(A==="selectionchange"||A==="keyup"||A==="keydown")return XA(l_)}function Js(A,R){if(A==="click")return XA(R)}function xk(A,R){if(A==="input"||A==="change")return XA(R)}function WO(A,R){return A===R&&(A!==0||1/A===1/R)||A!==A&&R!==R}var tu=typeof Object.is=="function"?Object.is:WO;function sS(A,R){if(tu(A,R))return!0;if(typeof A!="object"||A===null||typeof R!="object"||R===null)return!1;var K=Object.keys(A),ae=Object.keys(R);if(K.length!==ae.length)return!1;for(ae=0;ae<K.length;ae++){var Ce=K[ae];if(!p.call(R,Ce)||!tu(A[Ce],R[Ce]))return!1}return!0}function DP(A){for(;A&&A.firstChild;)A=A.firstChild;return A}function Sb(A,R){var K=DP(A);A=0;for(var ae;K;){if(K.nodeType===3){if(ae=A+K.textContent.length,A<=R&&ae>=R)return{node:K,offset:R-A};A=ae}e:{for(;K;){if(K.nextSibling){K=K.nextSibling;break e}K=K.parentNode}K=void 0}K=DP(K)}}function Zv(A,R){return A&&R?A===R?!0:A&&A.nodeType===3?!1:R&&R.nodeType===3?Zv(A,R.parentNode):"contains"in A?A.contains(R):A.compareDocumentPosition?!!(A.compareDocumentPosition(R)&16):!1:!1}function IT(){for(var A=window,R=ni();R instanceof A.HTMLIFrameElement;){try{var K=typeof R.contentWindow.location.href=="string"}catch{K=!1}if(K)A=R.contentWindow;else break;R=ni(A.document)}return R}function Vl(A){var R=A&&A.nodeName&&A.nodeName.toLowerCase();return R&&(R==="input"&&(A.type==="text"||A.type==="search"||A.type==="tel"||A.type==="url"||A.type==="password")||R==="textarea"||A.contentEditable==="true")}function i0(A){var R=IT(),K=A.focusedElem,ae=A.selectionRange;if(R!==K&&K&&K.ownerDocument&&Zv(K.ownerDocument.documentElement,K)){if(ae!==null&&Vl(K)){if(R=ae.start,A=ae.end,A===void 0&&(A=R),"selectionStart"in K)K.selectionStart=R,K.selectionEnd=Math.min(A,K.value.length);else if(A=(R=K.ownerDocument||document)&&R.defaultView||window,A.getSelection){A=A.getSelection();var Ce=K.textContent.length,Ve=Math.min(ae.start,Ce);ae=ae.end===void 0?Ve:Math.min(ae.end,Ce),!A.extend&&Ve>ae&&(Ce=ae,ae=Ve,Ve=Ce),Ce=Sb(K,Ve);var mt=Sb(K,ae);Ce&&mt&&(A.rangeCount!==1||A.anchorNode!==Ce.node||A.anchorOffset!==Ce.offset||A.focusNode!==mt.node||A.focusOffset!==mt.offset)&&(R=R.createRange(),R.setStart(Ce.node,Ce.offset),A.removeAllRanges(),Ve>ae?(A.addRange(R),A.extend(mt.node,mt.offset)):(R.setEnd(mt.node,mt.offset),A.addRange(R)))}}for(R=[],A=K;A=A.parentNode;)A.nodeType===1&&R.push({element:A,left:A.scrollLeft,top:A.scrollTop});for(typeof K.focus=="function"&&K.focus(),K=0;K<R.length;K++)A=R[K],A.element.scrollLeft=A.left,A.element.scrollTop=A.top}}var LP=h&&"documentMode"in document&&11>=document.documentMode,bb=null,Bk=null,eI=null,OP=!1;function n0(A,R,K){var ae=K.window===K?K.document:K.nodeType===9?K:K.ownerDocument;OP||bb==null||bb!==ni(ae)||(ae=bb,"selectionStart"in ae&&Vl(ae)?ae={start:ae.selectionStart,end:ae.selectionEnd}:(ae=(ae.ownerDocument&&ae.ownerDocument.defaultView||window).getSelection(),ae={anchorNode:ae.anchorNode,anchorOffset:ae.anchorOffset,focusNode:ae.focusNode,focusOffset:ae.focusOffset}),eI&&sS(eI,ae)||(eI=ae,ae=kT(Bk,"onSelect"),0<ae.length&&(R=new go("onSelect","select",null,R,K),A.push({event:R,listeners:ae}),R.target=bb)))}function Xv(A,R){var K={};return K[A.toLowerCase()]=R.toLowerCase(),K["Webkit"+A]="webkit"+R,K["Moz"+A]="moz"+R,K}var Km={animationend:Xv("Animation","AnimationEnd"),animationiteration:Xv("Animation","AnimationIteration"),animationstart:Xv("Animation","AnimationStart"),transitionend:Xv("Transition","TransitionEnd")},Td={},a0={};h&&(a0=document.createElement("div").style,"AnimationEvent"in window||(delete Km.animationend.animation,delete Km.animationiteration.animation,delete Km.animationstart.animation),"TransitionEvent"in window||delete Km.transitionend.transition);function d_(A){if(Td[A])return Td[A];if(!Km[A])return A;var R=Km[A],K;for(K in R)if(R.hasOwnProperty(K)&&K in a0)return Td[A]=R[K];return A}var tI=d_("animationend"),u_=d_("animationiteration"),NP=d_("animationstart"),r0=d_("transitionend"),ey=new Map,nv="abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");function av(A,R){ey.set(A,R),l(R,[A])}for(var xP=0;xP<nv.length;xP++){var lS=nv[xP],Fk=lS.toLowerCase(),iI=lS[0].toUpperCase()+lS.slice(1);av(Fk,"on"+iI)}av(tI,"onAnimationEnd"),av(u_,"onAnimationIteration"),av(NP,"onAnimationStart"),av("dblclick","onDoubleClick"),av("focusin","onFocus"),av("focusout","onBlur"),av(r0,"onTransitionEnd"),d("onMouseEnter",["mouseout","mouseover"]),d("onMouseLeave",["mouseout","mouseover"]),d("onPointerEnter",["pointerout","pointerover"]),d("onPointerLeave",["pointerout","pointerover"]),l("onChange","change click focusin focusout input keydown keyup selectionchange".split(" ")),l("onSelect","focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")),l("onBeforeInput",["compositionend","keypress","textInput","paste"]),l("onCompositionEnd","compositionend focusout keydown keypress keyup mousedown".split(" ")),l("onCompositionStart","compositionstart focusout keydown keypress keyup mousedown".split(" ")),l("onCompositionUpdate","compositionupdate focusout keydown keypress keyup mousedown".split(" "));var _u="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),Uk=new Set("cancel close invalid load scroll toggle".split(" ").concat(_u));function wT(A,R,K){var ae=A.type||"unknown-event";A.currentTarget=K,Bn(ae,R,void 0,A),A.currentTarget=null}function yg(A,R){R=(R&4)!==0;for(var K=0;K<A.length;K++){var ae=A[K],Ce=ae.event;ae=ae.listeners;e:{var Ve=void 0;if(R)for(var mt=ae.length-1;0<=mt;mt--){var Xt=ae[mt],Si=Xt.instance,Zi=Xt.currentTarget;if(Xt=Xt.listener,Si!==Ve&&Ce.isPropagationStopped())break e;wT(Ce,Xt,Zi),Ve=Si}else for(mt=0;mt<ae.length;mt++){if(Xt=ae[mt],Si=Xt.instance,Zi=Xt.currentTarget,Xt=Xt.listener,Si!==Ve&&Ce.isPropagationStopped())break e;wT(Ce,Xt,Zi),Ve=Si}}}if(Yl)throw A=ci,Yl=!1,ci=null,A}function wl(A,R){var K=R[sI];K===void 0&&(K=R[sI]=new Set);var ae=A+"__bubble";K.has(ae)||(KO(R,A,2,!1),K.add(ae))}function id(A,R,K){var ae=0;R&&(ae|=4),KO(K,A,ae,R)}var Eu="_reactListening"+Math.random().toString(36).slice(2);function ty(A){if(!A[Eu]){A[Eu]=!0,r.forEach(function(K){K!=="selectionchange"&&(Uk.has(K)||id(K,!1,A),id(K,!0,A))});var R=A.nodeType===9?A:A.ownerDocument;R===null||R[Eu]||(R[Eu]=!0,id("selectionchange",!1,R))}}function KO(A,R,K,ae){switch(gb(R)){case 1:var Ce=pb;break;case 4:Ce=bT;break;default:Ce=uh}K=Ce.bind(null,R,K,A),Ce=void 0,!al||R!=="touchstart"&&R!=="touchmove"&&R!=="wheel"||(Ce=!0),ae?Ce!==void 0?A.addEventListener(R,K,{capture:!0,passive:Ce}):A.addEventListener(R,K,!0):Ce!==void 0?A.addEventListener(R,K,{passive:Ce}):A.addEventListener(R,K,!1)}function h_(A,R,K,ae,Ce){var Ve=ae;if((R&1)===0&&(R&2)===0&&ae!==null)e:for(;;){if(ae===null)return;var mt=ae.tag;if(mt===3||mt===4){var Xt=ae.stateNode.containerInfo;if(Xt===Ce||Xt.nodeType===8&&Xt.parentNode===Ce)break;if(mt===4)for(mt=ae.return;mt!==null;){var Si=mt.tag;if((Si===3||Si===4)&&(Si=mt.stateNode.containerInfo,Si===Ce||Si.nodeType===8&&Si.parentNode===Ce))return;mt=mt.return}for(;Xt!==null;){if(mt=Cb(Xt),mt===null)return;if(Si=mt.tag,Si===5||Si===6){ae=Ve=mt;continue e}Xt=Xt.parentNode}}ae=ae.return}La(function(){var Zi=Ve,Kn=ri(K),Zn=[];e:{var Gn=ey.get(A);if(Gn!==void 0){var Ka=go,br=A;switch(A){case"keypress":if(un(K)===0)break e;case"keydown":case"keyup":Ka=vg;break;case"focusin":br="focus",Ka=aS;break;case"focusout":br="blur",Ka=aS;break;case"beforeblur":case"afterblur":Ka=aS;break;case"click":if(K.button===2)break e;case"auxclick":case"dblclick":case"mousedown":case"mousemove":case"mouseup":case"mouseout":case"mouseover":case"contextmenu":Ka=mb;break;case"drag":case"dragend":case"dragenter":case"dragexit":case"dragleave":case"dragover":case"dragstart":case"drop":Ka=Jv;break;case"touchcancel":case"touchend":case"touchmove":case"touchstart":Ka=Yv;break;case tI:case u_:case NP:Ka=Ok;break;case r0:Ka=tv;break;case"scroll":Ka=_o;break;case"wheel":Ka=vb;break;case"copy":case"cut":case"paste":Ka=r_;break;case"gotpointercapture":case"lostpointercapture":case"pointercancel":case"pointerdown":case"pointermove":case"pointerout":case"pointerover":case"pointerup":Ka=o_}var Tr=(R&4)!==0,Ud=!Tr&&A==="scroll",Vi=Tr?Gn!==null?Gn+"Capture":null:Gn;Tr=[];for(var Mi=Zi,Yi;Mi!==null;){Yi=Mi;var Jn=Yi.stateNode;if(Yi.tag===5&&Jn!==null&&(Yi=Jn,Vi!==null&&(Jn=us(Mi,Vi),Jn!=null&&Tr.push(cS(Mi,Jn,Yi)))),Ud)break;Mi=Mi.return}0<Tr.length&&(Gn=new Ka(Gn,br,null,K,Kn),Zn.push({event:Gn,listeners:Tr}))}}if((R&7)===0){e:{if(Gn=A==="mouseover"||A==="pointerover",Ka=A==="mouseout"||A==="pointerout",Gn&&K!==qt&&(br=K.relatedTarget||K.fromElement)&&(Cb(br)||br[Tb]))break e;if((Ka||Gn)&&(Gn=Kn.window===Kn?Kn:(Gn=Kn.ownerDocument)?Gn.defaultView||Gn.parentWindow:window,Ka?(br=K.relatedTarget||K.toElement,Ka=Zi,br=br?Cb(br):null,br!==null&&(Ud=Pa(br),br!==Ud||br.tag!==5&&br.tag!==6)&&(br=null)):(Ka=null,br=Zi),Ka!==br)){if(Tr=mb,Jn="onMouseLeave",Vi="onMouseEnter",Mi="mouse",(A==="pointerout"||A==="pointerover")&&(Tr=o_,Jn="onPointerLeave",Vi="onPointerEnter",Mi="pointer"),Ud=Ka==null?Gn:Ym(Ka),Yi=br==null?Gn:Ym(br),Gn=new Tr(Jn,Mi+"leave",Ka,K,Kn),Gn.target=Ud,Gn.relatedTarget=Yi,Jn=null,Cb(Kn)===Zi&&(Tr=new Tr(Vi,Mi+"enter",br,K,Kn),Tr.target=Yi,Tr.relatedTarget=Ud,Jn=Tr),Ud=Jn,Ka&&br)t:{for(Tr=Ka,Vi=br,Mi=0,Yi=Tr;Yi;Yi=Jm(Yi))Mi++;for(Yi=0,Jn=Vi;Jn;Jn=Jm(Jn))Yi++;for(;0<Mi-Yi;)Tr=Jm(Tr),Mi--;for(;0<Yi-Mi;)Vi=Jm(Vi),Yi--;for(;Mi--;){if(Tr===Vi||Vi!==null&&Tr===Vi.alternate)break t;Tr=Jm(Tr),Vi=Jm(Vi)}Tr=null}else Tr=null;Ka!==null&&o0(Zn,Gn,Ka,Tr,!1),br!==null&&Ud!==null&&o0(Zn,Ud,br,Tr,!0)}}e:{if(Gn=Zi?Ym(Zi):window,Ka=Gn.nodeName&&Gn.nodeName.toLowerCase(),Ka==="select"||Ka==="input"&&Gn.type==="file")var Cr=c_;else if(ZA(Gn))if(Oi)Cr=xk;else{Cr=eu;var lo=tp}else(Ka=Gn.nodeName)&&Ka.toLowerCase()==="input"&&(Gn.type==="checkbox"||Gn.type==="radio")&&(Cr=Js);if(Cr&&(Cr=Cr(A,Zi))){MP(Zn,Cr,K,Kn);break e}lo&&lo(A,Gn,Zi),A==="focusout"&&(lo=Gn._wrapperState)&&lo.controlled&&Gn.type==="number"&&jt(Gn,"number",Gn.value)}switch(lo=Zi?Ym(Zi):window,A){case"focusin":(ZA(lo)||lo.contentEditable==="true")&&(bb=lo,Bk=Zi,eI=null);break;case"focusout":eI=Bk=bb=null;break;case"mousedown":OP=!0;break;case"contextmenu":case"mouseup":case"dragend":OP=!1,n0(Zn,K,Kn);break;case"selectionchange":if(LP)break;case"keydown":case"keyup":n0(Zn,K,Kn)}var ho;if(rm)e:{switch(A){case"compositionstart":var Hr="onCompositionStart";break e;case"compositionend":Hr="onCompositionEnd";break e;case"compositionupdate":Hr="onCompositionUpdate";break e}Hr=void 0}else Va?rS(A,K)&&(Hr="onCompositionEnd"):A==="keydown"&&K.keyCode===229&&(Hr="onCompositionStart");Hr&&(t0&&K.locale!=="ko"&&(Va||Hr!=="onCompositionStart"?Hr==="onCompositionEnd"&&Va&&(ho=Gi()):(qm=Kn,st="value"in qm?qm.value:qm.textContent,Va=!0)),lo=kT(Zi,Hr),0<lo.length&&(Hr=new CT(Hr,A,null,K,Kn),Zn.push({event:Hr,listeners:lo}),ho?Hr.data=ho:(ho=oS(K),ho!==null&&(Hr.data=ho)))),(ho=s_?om(A,K):AT(A,K))&&(Zi=kT(Zi,"onBeforeInput"),0<Zi.length&&(Kn=new CT("onBeforeInput","beforeinput",null,K,Kn),Zn.push({event:Kn,listeners:Zi}),Kn.data=ho))}yg(Zn,R)})}function cS(A,R,K){return{instance:A,listener:R,currentTarget:K}}function kT(A,R){for(var K=R+"Capture",ae=[];A!==null;){var Ce=A,Ve=Ce.stateNode;Ce.tag===5&&Ve!==null&&(Ce=Ve,Ve=us(A,K),Ve!=null&&ae.unshift(cS(A,Ve,Ce)),Ve=us(A,R),Ve!=null&&ae.push(cS(A,Ve,Ce))),A=A.return}return ae}function Jm(A){if(A===null)return null;do A=A.return;while(A&&A.tag!==5);return A||null}function o0(A,R,K,ae,Ce){for(var Ve=R._reactName,mt=[];K!==null&&K!==ae;){var Xt=K,Si=Xt.alternate,Zi=Xt.stateNode;if(Si!==null&&Si===ae)break;Xt.tag===5&&Zi!==null&&(Xt=Zi,Ce?(Si=us(K,Ve),Si!=null&&mt.unshift(cS(K,Si,Xt))):Ce||(Si=us(K,Ve),Si!=null&&mt.push(cS(K,Si,Xt)))),K=K.return}mt.length!==0&&A.push({event:R,listeners:mt})}var dS=/\r\n?/g,s0=/\u0000|\uFFFD/g;function RT(A){return(typeof A=="string"?A:""+A).replace(dS,`
`).replace(s0,"")}function uS(A,R,K){if(R=RT(R),RT(A)!==R&&K)throw Error(i(425))}function Sg(){}var p_=null,iy=null;function nI(A,R){return A==="textarea"||A==="noscript"||typeof R.children=="string"||typeof R.children=="number"||typeof R.dangerouslySetInnerHTML=="object"&&R.dangerouslySetInnerHTML!==null&&R.dangerouslySetInnerHTML.__html!=null}var aI=typeof setTimeout=="function"?setTimeout:void 0,rI=typeof clearTimeout=="function"?clearTimeout:void 0,MT=typeof Promise=="function"?Promise:void 0,rv=typeof queueMicrotask=="function"?queueMicrotask:typeof MT<"u"?function(A){return MT.resolve(null).then(A).catch(ny)}:aI;function ny(A){setTimeout(function(){throw A})}function Tt(A,R){var K=R,ae=0;do{var Ce=K.nextSibling;if(A.removeChild(K),Ce&&Ce.nodeType===8)if(K=Ce.data,K==="/$"){if(ae===0){A.removeChild(Ce),Os(R);return}ae--}else K!=="$"&&K!=="$?"&&K!=="$!"||ae++;K=Ce}while(K);Os(R)}function ip(A){for(;A!=null;A=A.nextSibling){var R=A.nodeType;if(R===1||R===3)break;if(R===8){if(R=A.data,R==="$"||R==="$!"||R==="$?")break;if(R==="/$")return null}}return A}function PT(A){A=A.previousSibling;for(var R=0;A;){if(A.nodeType===8){var K=A.data;if(K==="$"||K==="$!"||K==="$?"){if(R===0)return A;R--}else K==="/$"&&R++}A=A.previousSibling}return null}var ph=Math.random().toString(36).slice(2),Lo="__reactFiber$"+ph,oI="__reactProps$"+ph,Tb="__reactContainer$"+ph,sI="__reactEvents$"+ph,ov="__reactListeners$"+ph,SF="__reactHandles$"+ph;function Cb(A){var R=A[Lo];if(R)return R;for(var K=A.parentNode;K;){if(R=K[Tb]||K[Lo]){if(K=R.alternate,R.child!==null||K!==null&&K.child!==null)for(A=PT(A);A!==null;){if(K=A[Lo])return K;A=PT(A)}return R}A=K,K=A.parentNode}return null}function Ia(A){return A=A[Lo]||A[Tb],!A||A.tag!==5&&A.tag!==6&&A.tag!==13&&A.tag!==3?null:A}function Ym(A){if(A.tag===5||A.tag===6)return A.stateNode;throw Error(i(33))}function Nd(A){return A[oI]||null}var Kr=[],Mh=-1;function Qm(A){return{current:A}}function fc(A){0>Mh||(A.current=Kr[Mh],Kr[Mh]=null,Mh--)}function ra(A,R){Mh++,Kr[Mh]=A.current,A.current=R}var np={},kl=Qm(np),iu=Qm(!1),Ph=np;function ap(A,R){var K=A.type.contextTypes;if(!K)return np;var ae=A.stateNode;if(ae&&ae.__reactInternalMemoizedUnmaskedChildContext===R)return ae.__reactInternalMemoizedMaskedChildContext;var Ce={},Ve;for(Ve in K)Ce[Ve]=R[Ve];return ae&&(A=A.stateNode,A.__reactInternalMemoizedUnmaskedChildContext=R,A.__reactInternalMemoizedMaskedChildContext=Ce),Ce}function Dc(A){return A=A.childContextTypes,A!=null}function Hc(){fc(iu),fc(kl)}function ay(A,R,K){if(kl.current!==np)throw Error(i(168));ra(kl,R),ra(iu,K)}function $l(A,R,K){var ae=A.stateNode;if(R=R.childContextTypes,typeof ae.getChildContext!="function")return K;ae=ae.getChildContext();for(var Ce in ae)if(!(Ce in R))throw Error(i(108,tt(A)||"Unknown",Ce));return ce({},K,ae)}function Dh(A){return A=(A=A.stateNode)&&A.__reactInternalMemoizedMergedChildContext||np,Ph=kl.current,ra(kl,A),ra(iu,iu.current),!0}function bg(A,R,K){var ae=A.stateNode;if(!ae)throw Error(i(169));K?(A=$l(A,R,Ph),ae.__reactInternalMemoizedMergedChildContext=A,fc(iu),fc(kl),ra(kl,A)):fc(iu),ra(iu,K)}var Tg=null,hS=!1,Lp=!1;function g_(A){Tg===null?Tg=[A]:Tg.push(A)}function ry(A){hS=!0,g_(A)}function Hu(){if(!Lp&&Tg!==null){Lp=!0;var A=0,R=fl;try{var K=Tg;for(fl=1;A<K.length;A++){var ae=K[A];do ae=ae(!0);while(ae!==null)}Tg=null,hS=!1}catch(Ce){throw Tg!==null&&(Tg=Tg.slice(A+1)),on(ns,Hu),Ce}finally{fl=R,Lp=!1}}return null}var sv=[],lv=0,_b=null,rp=0,vc=[],yc=0,sm=null,Op=1,oy="";function nu(A,R){sv[lv++]=rp,sv[lv++]=_b,_b=A,rp=R}function m_(A,R,K){vc[yc++]=Op,vc[yc++]=oy,vc[yc++]=sm,sm=A;var ae=Op;A=oy;var Ce=32-td(ae)-1;ae&=~(1<<Ce),K+=1;var Ve=32-td(R)+Ce;if(30<Ve){var mt=Ce-Ce%5;Ve=(ae&(1<<mt)-1).toString(32),ae>>=mt,Ce-=mt,Op=1<<32-td(R)+Ce|K<<Ce|ae,oy=Ve+A}else Op=1<<Ve|K<<Ce|ae,oy=A}function sy(A){A.return!==null&&(nu(A,1),m_(A,1,0))}function Np(A){for(;A===_b;)_b=sv[--lv],sv[lv]=null,rp=sv[--lv],sv[lv]=null;for(;A===sm;)sm=vc[--yc],vc[yc]=null,oy=vc[--yc],vc[yc]=null,Op=vc[--yc],vc[yc]=null}var ju=null,xd=null,Ac=!1,au=null;function Cg(A,R){var K=Wp(5,null,null,0);K.elementType="DELETED",K.stateNode=R,K.return=A,R=A.deletions,R===null?(A.deletions=[K],A.flags|=16):R.push(K)}function ly(A,R){switch(A.tag){case 5:var K=A.type;return R=R.nodeType!==1||K.toLowerCase()!==R.nodeName.toLowerCase()?null:R,R!==null?(A.stateNode=R,ju=A,xd=ip(R.firstChild),!0):!1;case 6:return R=A.pendingProps===""||R.nodeType!==3?null:R,R!==null?(A.stateNode=R,ju=A,xd=null,!0):!1;case 13:return R=R.nodeType!==8?null:R,R!==null?(K=sm!==null?{id:Op,overflow:oy}:null,A.memoizedState={dehydrated:R,treeContext:K,retryLane:1073741824},K=Wp(18,null,null,0),K.stateNode=R,K.return=A,A.child=K,ju=A,xd=null,!0):!1;default:return!1}}function l0(A){return(A.mode&1)!==0&&(A.flags&128)===0}function pS(A){if(Ac){var R=xd;if(R){var K=R;if(!ly(A,R)){if(l0(A))throw Error(i(418));R=ip(K.nextSibling);var ae=ju;R&&ly(A,R)?Cg(ae,K):(A.flags=A.flags&-4097|2,Ac=!1,ju=A)}}else{if(l0(A))throw Error(i(418));A.flags=A.flags&-4097|2,Ac=!1,ju=A}}}function Ic(A){for(A=A.return;A!==null&&A.tag!==5&&A.tag!==3&&A.tag!==13;)A=A.return;ju=A}function Eb(A){if(A!==ju)return!1;if(!Ac)return Ic(A),Ac=!0,!1;var R;if((R=A.tag!==3)&&!(R=A.tag!==5)&&(R=A.type,R=R!=="head"&&R!=="body"&&!nI(A.type,A.memoizedProps)),R&&(R=xd)){if(l0(A))throw ru(),Error(i(418));for(;R;)Cg(A,R),R=ip(R.nextSibling)}if(Ic(A),A.tag===13){if(A=A.memoizedState,A=A!==null?A.dehydrated:null,!A)throw Error(i(317));e:{for(A=A.nextSibling,R=0;A;){if(A.nodeType===8){var K=A.data;if(K==="/$"){if(R===0){xd=ip(A.nextSibling);break e}R--}else K!=="$"&&K!=="$!"&&K!=="$?"||R++}A=A.nextSibling}xd=null}}else xd=ju?ip(A.stateNode.nextSibling):null;return!0}function ru(){for(var A=xd;A;)A=ip(A.nextSibling)}function cv(){xd=ju=null,Ac=!1}function Zm(A){au===null?au=[A]:au.push(A)}var dv=B.ReactCurrentBatchConfig;function _g(A,R,K){if(A=K.ref,A!==null&&typeof A!="function"&&typeof A!="object"){if(K._owner){if(K=K._owner,K){if(K.tag!==1)throw Error(i(309));var ae=K.stateNode}if(!ae)throw Error(i(147,A));var Ce=ae,Ve=""+A;return R!==null&&R.ref!==null&&typeof R.ref=="function"&&R.ref._stringRef===Ve?R.ref:(R=function(mt){var Xt=Ce.refs;mt===null?delete Xt[Ve]:Xt[Ve]=mt},R._stringRef=Ve,R)}if(typeof A!="string")throw Error(i(284));if(!K._owner)throw Error(i(290,A))}return A}function f_(A,R){throw A=Object.prototype.toString.call(R),Error(i(31,A==="[object Object]"?"object with keys {"+Object.keys(R).join(", ")+"}":A))}function xp(A){var R=A._init;return R(A._payload)}function gS(A){function R(Vi,Mi){if(A){var Yi=Vi.deletions;Yi===null?(Vi.deletions=[Mi],Vi.flags|=16):Yi.push(Mi)}}function K(Vi,Mi){if(!A)return null;for(;Mi!==null;)R(Vi,Mi),Mi=Mi.sibling;return null}function ae(Vi,Mi){for(Vi=new Map;Mi!==null;)Mi.key!==null?Vi.set(Mi.key,Mi):Vi.set(Mi.index,Mi),Mi=Mi.sibling;return Vi}function Ce(Vi,Mi){return Vi=Db(Vi,Mi),Vi.index=0,Vi.sibling=null,Vi}function Ve(Vi,Mi,Yi){return Vi.index=Yi,A?(Yi=Vi.alternate,Yi!==null?(Yi=Yi.index,Yi<Mi?(Vi.flags|=2,Mi):Yi):(Vi.flags|=2,Mi)):(Vi.flags|=1048576,Mi)}function mt(Vi){return A&&Vi.alternate===null&&(Vi.flags|=2),Vi}function Xt(Vi,Mi,Yi,Jn){return Mi===null||Mi.tag!==6?(Mi=aR(Yi,Vi.mode,Jn),Mi.return=Vi,Mi):(Mi=Ce(Mi,Yi),Mi.return=Vi,Mi)}function Si(Vi,Mi,Yi,Jn){var Cr=Yi.type;return Cr===H?Kn(Vi,Mi,Yi.props.children,Jn,Yi.key):Mi!==null&&(Mi.elementType===Cr||typeof Cr=="object"&&Cr!==null&&Cr.$$typeof===Le&&xp(Cr)===Mi.type)?(Jn=Ce(Mi,Yi.props),Jn.ref=_g(Vi,Mi,Yi),Jn.return=Vi,Jn):(Jn=N_(Yi.type,Yi.key,Yi.props,null,Vi.mode,Jn),Jn.ref=_g(Vi,Mi,Yi),Jn.return=Vi,Jn)}function Zi(Vi,Mi,Yi,Jn){return Mi===null||Mi.tag!==4||Mi.stateNode.containerInfo!==Yi.containerInfo||Mi.stateNode.implementation!==Yi.implementation?(Mi=R0(Yi,Vi.mode,Jn),Mi.return=Vi,Mi):(Mi=Ce(Mi,Yi.children||[]),Mi.return=Vi,Mi)}function Kn(Vi,Mi,Yi,Jn,Cr){return Mi===null||Mi.tag!==7?(Mi=lu(Yi,Vi.mode,Jn,Cr),Mi.return=Vi,Mi):(Mi=Ce(Mi,Yi),Mi.return=Vi,Mi)}function Zn(Vi,Mi,Yi){if(typeof Mi=="string"&&Mi!==""||typeof Mi=="number")return Mi=aR(""+Mi,Vi.mode,Yi),Mi.return=Vi,Mi;if(typeof Mi=="object"&&Mi!==null){switch(Mi.$$typeof){case L:return Yi=N_(Mi.type,Mi.key,Mi.props,null,Vi.mode,Yi),Yi.ref=_g(Vi,null,Mi),Yi.return=Vi,Yi;case z:return Mi=R0(Mi,Vi.mode,Yi),Mi.return=Vi,Mi;case Le:var Jn=Mi._init;return Zn(Vi,Jn(Mi._payload),Yi)}if(Nt(Mi)||Se(Mi))return Mi=lu(Mi,Vi.mode,Yi,null),Mi.return=Vi,Mi;f_(Vi,Mi)}return null}function Gn(Vi,Mi,Yi,Jn){var Cr=Mi!==null?Mi.key:null;if(typeof Yi=="string"&&Yi!==""||typeof Yi=="number")return Cr!==null?null:Xt(Vi,Mi,""+Yi,Jn);if(typeof Yi=="object"&&Yi!==null){switch(Yi.$$typeof){case L:return Yi.key===Cr?Si(Vi,Mi,Yi,Jn):null;case z:return Yi.key===Cr?Zi(Vi,Mi,Yi,Jn):null;case Le:return Cr=Yi._init,Gn(Vi,Mi,Cr(Yi._payload),Jn)}if(Nt(Yi)||Se(Yi))return Cr!==null?null:Kn(Vi,Mi,Yi,Jn,null);f_(Vi,Yi)}return null}function Ka(Vi,Mi,Yi,Jn,Cr){if(typeof Jn=="string"&&Jn!==""||typeof Jn=="number")return Vi=Vi.get(Yi)||null,Xt(Mi,Vi,""+Jn,Cr);if(typeof Jn=="object"&&Jn!==null){switch(Jn.$$typeof){case L:return Vi=Vi.get(Jn.key===null?Yi:Jn.key)||null,Si(Mi,Vi,Jn,Cr);case z:return Vi=Vi.get(Jn.key===null?Yi:Jn.key)||null,Zi(Mi,Vi,Jn,Cr);case Le:var lo=Jn._init;return Ka(Vi,Mi,Yi,lo(Jn._payload),Cr)}if(Nt(Jn)||Se(Jn))return Vi=Vi.get(Yi)||null,Kn(Mi,Vi,Jn,Cr,null);f_(Mi,Jn)}return null}function br(Vi,Mi,Yi,Jn){for(var Cr=null,lo=null,ho=Mi,Hr=Mi=0,yh=null;ho!==null&&Hr<Yi.length;Hr++){ho.index>Hr?(yh=ho,ho=null):yh=ho.sibling;var Tl=Gn(Vi,ho,Yi[Hr],Jn);if(Tl===null){ho===null&&(ho=yh);break}A&&ho&&Tl.alternate===null&&R(Vi,ho),Mi=Ve(Tl,Mi,Hr),lo===null?Cr=Tl:lo.sibling=Tl,lo=Tl,ho=yh}if(Hr===Yi.length)return K(Vi,ho),Ac&&nu(Vi,Hr),Cr;if(ho===null){for(;Hr<Yi.length;Hr++)ho=Zn(Vi,Yi[Hr],Jn),ho!==null&&(Mi=Ve(ho,Mi,Hr),lo===null?Cr=ho:lo.sibling=ho,lo=ho);return Ac&&nu(Vi,Hr),Cr}for(ho=ae(Vi,ho);Hr<Yi.length;Hr++)yh=Ka(ho,Vi,Hr,Yi[Hr],Jn),yh!==null&&(A&&yh.alternate!==null&&ho.delete(yh.key===null?Hr:yh.key),Mi=Ve(yh,Mi,Hr),lo===null?Cr=yh:lo.sibling=yh,lo=yh);return A&&ho.forEach(function(YT){return R(Vi,YT)}),Ac&&nu(Vi,Hr),Cr}function Tr(Vi,Mi,Yi,Jn){var Cr=Se(Yi);if(typeof Cr!="function")throw Error(i(150));if(Yi=Cr.call(Yi),Yi==null)throw Error(i(151));for(var lo=Cr=null,ho=Mi,Hr=Mi=0,yh=null,Tl=Yi.next();ho!==null&&!Tl.done;Hr++,Tl=Yi.next()){ho.index>Hr?(yh=ho,ho=null):yh=ho.sibling;var YT=Gn(Vi,ho,Tl.value,Jn);if(YT===null){ho===null&&(ho=yh);break}A&&ho&&YT.alternate===null&&R(Vi,ho),Mi=Ve(YT,Mi,Hr),lo===null?Cr=YT:lo.sibling=YT,lo=YT,ho=yh}if(Tl.done)return K(Vi,ho),Ac&&nu(Vi,Hr),Cr;if(ho===null){for(;!Tl.done;Hr++,Tl=Yi.next())Tl=Zn(Vi,Tl.value,Jn),Tl!==null&&(Mi=Ve(Tl,Mi,Hr),lo===null?Cr=Tl:lo.sibling=Tl,lo=Tl);return Ac&&nu(Vi,Hr),Cr}for(ho=ae(Vi,ho);!Tl.done;Hr++,Tl=Yi.next())Tl=Ka(ho,Vi,Hr,Tl.value,Jn),Tl!==null&&(A&&Tl.alternate!==null&&ho.delete(Tl.key===null?Hr:Tl.key),Mi=Ve(Tl,Mi,Hr),lo===null?Cr=Tl:lo.sibling=Tl,lo=Tl);return A&&ho.forEach(function(JP){return R(Vi,JP)}),Ac&&nu(Vi,Hr),Cr}function Ud(Vi,Mi,Yi,Jn){if(typeof Yi=="object"&&Yi!==null&&Yi.type===H&&Yi.key===null&&(Yi=Yi.props.children),typeof Yi=="object"&&Yi!==null){switch(Yi.$$typeof){case L:e:{for(var Cr=Yi.key,lo=Mi;lo!==null;){if(lo.key===Cr){if(Cr=Yi.type,Cr===H){if(lo.tag===7){K(Vi,lo.sibling),Mi=Ce(lo,Yi.props.children),Mi.return=Vi,Vi=Mi;break e}}else if(lo.elementType===Cr||typeof Cr=="object"&&Cr!==null&&Cr.$$typeof===Le&&xp(Cr)===lo.type){K(Vi,lo.sibling),Mi=Ce(lo,Yi.props),Mi.ref=_g(Vi,lo,Yi),Mi.return=Vi,Vi=Mi;break e}K(Vi,lo);break}else R(Vi,lo);lo=lo.sibling}Yi.type===H?(Mi=lu(Yi.props.children,Vi.mode,Jn,Yi.key),Mi.return=Vi,Vi=Mi):(Jn=N_(Yi.type,Yi.key,Yi.props,null,Vi.mode,Jn),Jn.ref=_g(Vi,Mi,Yi),Jn.return=Vi,Vi=Jn)}return mt(Vi);case z:e:{for(lo=Yi.key;Mi!==null;){if(Mi.key===lo)if(Mi.tag===4&&Mi.stateNode.containerInfo===Yi.containerInfo&&Mi.stateNode.implementation===Yi.implementation){K(Vi,Mi.sibling),Mi=Ce(Mi,Yi.children||[]),Mi.return=Vi,Vi=Mi;break e}else{K(Vi,Mi);break}else R(Vi,Mi);Mi=Mi.sibling}Mi=R0(Yi,Vi.mode,Jn),Mi.return=Vi,Vi=Mi}return mt(Vi);case Le:return lo=Yi._init,Ud(Vi,Mi,lo(Yi._payload),Jn)}if(Nt(Yi))return br(Vi,Mi,Yi,Jn);if(Se(Yi))return Tr(Vi,Mi,Yi,Jn);f_(Vi,Yi)}return typeof Yi=="string"&&Yi!==""||typeof Yi=="number"?(Yi=""+Yi,Mi!==null&&Mi.tag===6?(K(Vi,Mi.sibling),Mi=Ce(Mi,Yi),Mi.return=Vi,Vi=Mi):(K(Vi,Mi),Mi=aR(Yi,Vi.mode,Jn),Mi.return=Vi,Vi=Mi),mt(Vi)):K(Vi,Mi)}return Ud}var Ns=gS(!0),Na=gS(!1),lm=Qm(null),Bp=null,cy=null,mS=null;function uv(){mS=cy=Bp=null}function Ab(A){var R=lm.current;fc(lm),A._currentValue=R}function DT(A,R,K){for(;A!==null;){var ae=A.alternate;if((A.childLanes&R)!==R?(A.childLanes|=R,ae!==null&&(ae.childLanes|=R)):ae!==null&&(ae.childLanes&R)!==R&&(ae.childLanes|=R),A===K)break;A=A.return}}function Cd(A,R){Bp=A,mS=cy=null,A=A.dependencies,A!==null&&A.firstContext!==null&&((A.lanes&R)!==0&&(ou=!0),A.firstContext=null)}function cm(A){var R=A._currentValue;if(mS!==A)if(A={context:A,memoizedValue:R,next:null},cy===null){if(Bp===null)throw Error(i(308));cy=A,Bp.dependencies={lanes:0,firstContext:A}}else cy=cy.next=A;return R}var Fp=null;function zk(A){Fp===null?Fp=[A]:Fp.push(A)}function Vk(A,R,K,ae){var Ce=R.interleaved;return Ce===null?(K.next=K,zk(R)):(K.next=Ce.next,Ce.next=K),R.interleaved=K,Up(A,ae)}function Up(A,R){A.lanes|=R;var K=A.alternate;for(K!==null&&(K.lanes|=R),K=A,A=A.return;A!==null;)A.childLanes|=R,K=A.alternate,K!==null&&(K.childLanes|=R),K=A,A=A.return;return K.tag===3?K.stateNode:null}var Eg=!1;function BP(A){A.updateQueue={baseState:A.memoizedState,firstBaseUpdate:null,lastBaseUpdate:null,shared:{pending:null,interleaved:null,lanes:0},effects:null}}function lI(A,R){A=A.updateQueue,R.updateQueue===A&&(R.updateQueue={baseState:A.baseState,firstBaseUpdate:A.firstBaseUpdate,lastBaseUpdate:A.lastBaseUpdate,shared:A.shared,effects:A.effects})}function fS(A,R){return{eventTime:A,lane:R,tag:0,payload:null,callback:null,next:null}}function hv(A,R,K){var ae=A.updateQueue;if(ae===null)return null;if(ae=ae.shared,(gs&2)!==0){var Ce=ae.pending;return Ce===null?R.next=R:(R.next=Ce.next,Ce.next=R),ae.pending=R,Up(A,K)}return Ce=ae.interleaved,Ce===null?(R.next=R,zk(ae)):(R.next=Ce.next,Ce.next=R),ae.interleaved=R,Up(A,K)}function v_(A,R,K){if(R=R.updateQueue,R!==null&&(R=R.shared,(K&4194240)!==0)){var ae=R.lanes;ae&=A.pendingLanes,K|=ae,R.lanes=K,iS(A,K)}}function cI(A,R){var K=A.updateQueue,ae=A.alternate;if(ae!==null&&(ae=ae.updateQueue,K===ae)){var Ce=null,Ve=null;if(K=K.firstBaseUpdate,K!==null){do{var mt={eventTime:K.eventTime,lane:K.lane,tag:K.tag,payload:K.payload,callback:K.callback,next:null};Ve===null?Ce=Ve=mt:Ve=Ve.next=mt,K=K.next}while(K!==null);Ve===null?Ce=Ve=R:Ve=Ve.next=R}else Ce=Ve=R;K={baseState:ae.baseState,firstBaseUpdate:Ce,lastBaseUpdate:Ve,shared:ae.shared,effects:ae.effects},A.updateQueue=K;return}A=K.lastBaseUpdate,A===null?K.firstBaseUpdate=R:A.next=R,K.lastBaseUpdate=R}function LT(A,R,K,ae){var Ce=A.updateQueue;Eg=!1;var Ve=Ce.firstBaseUpdate,mt=Ce.lastBaseUpdate,Xt=Ce.shared.pending;if(Xt!==null){Ce.shared.pending=null;var Si=Xt,Zi=Si.next;Si.next=null,mt===null?Ve=Zi:mt.next=Zi,mt=Si;var Kn=A.alternate;Kn!==null&&(Kn=Kn.updateQueue,Xt=Kn.lastBaseUpdate,Xt!==mt&&(Xt===null?Kn.firstBaseUpdate=Zi:Xt.next=Zi,Kn.lastBaseUpdate=Si))}if(Ve!==null){var Zn=Ce.baseState;mt=0,Kn=Zi=Si=null,Xt=Ve;do{var Gn=Xt.lane,Ka=Xt.eventTime;if((ae&Gn)===Gn){Kn!==null&&(Kn=Kn.next={eventTime:Ka,lane:0,tag:Xt.tag,payload:Xt.payload,callback:Xt.callback,next:null});e:{var br=A,Tr=Xt;switch(Gn=R,Ka=K,Tr.tag){case 1:if(br=Tr.payload,typeof br=="function"){Zn=br.call(Ka,Zn,Gn);break e}Zn=br;break e;case 3:br.flags=br.flags&-65537|128;case 0:if(br=Tr.payload,Gn=typeof br=="function"?br.call(Ka,Zn,Gn):br,Gn==null)break e;Zn=ce({},Zn,Gn);break e;case 2:Eg=!0}}Xt.callback!==null&&Xt.lane!==0&&(A.flags|=64,Gn=Ce.effects,Gn===null?Ce.effects=[Xt]:Gn.push(Xt))}else Ka={eventTime:Ka,lane:Gn,tag:Xt.tag,payload:Xt.payload,callback:Xt.callback,next:null},Kn===null?(Zi=Kn=Ka,Si=Zn):Kn=Kn.next=Ka,mt|=Gn;if(Xt=Xt.next,Xt===null){if(Xt=Ce.shared.pending,Xt===null)break;Gn=Xt,Xt=Gn.next,Gn.next=null,Ce.lastBaseUpdate=Gn,Ce.shared.pending=null}}while(!0);if(Kn===null&&(Si=Zn),Ce.baseState=Si,Ce.firstBaseUpdate=Zi,Ce.lastBaseUpdate=Kn,R=Ce.shared.interleaved,R!==null){Ce=R;do mt|=Ce.lane,Ce=Ce.next;while(Ce!==R)}else Ve===null&&(Ce.shared.lanes=0);CS|=mt,A.lanes=mt,A.memoizedState=Zn}}function dI(A,R,K){if(A=R.effects,R.effects=null,A!==null)for(R=0;R<A.length;R++){var ae=A[R],Ce=ae.callback;if(Ce!==null){if(ae.callback=null,ae=K,typeof Ce!="function")throw Error(i(191,Ce));Ce.call(ae)}}}var c0={},dy=Qm(c0),vS=Qm(c0),y_=Qm(c0);function yS(A){if(A===c0)throw Error(i(174));return A}function uI(A,R){switch(ra(y_,R),ra(vS,A),ra(dy,c0),A=R.nodeType,A){case 9:case 11:R=(R=R.documentElement)?R.namespaceURI:Ae(null,"");break;default:A=A===8?R.parentNode:R,R=A.namespaceURI||null,A=A.tagName,R=Ae(R,A)}fc(dy),ra(dy,R)}function S_(){fc(dy),fc(vS),fc(y_)}function $k(A){yS(y_.current);var R=yS(dy.current),K=Ae(R,A.type);R!==K&&(ra(vS,A),ra(dy,K))}function Hk(A){vS.current===A&&(fc(dy),fc(vS))}var nd=Qm(0);function d0(A){for(var R=A;R!==null;){if(R.tag===13){var K=R.memoizedState;if(K!==null&&(K=K.dehydrated,K===null||K.data==="$?"||K.data==="$!"))return R}else if(R.tag===19&&R.memoizedProps.revealOrder!==void 0){if((R.flags&128)!==0)return R}else if(R.child!==null){R.child.return=R,R=R.child;continue}if(R===A)break;for(;R.sibling===null;){if(R.return===null||R.return===A)return null;R=R.return}R.sibling.return=R.return,R=R.sibling}return null}var b_=[];function Jr(){for(var A=0;A<b_.length;A++)b_[A]._workInProgressVersionPrimary=null;b_.length=0}var ps=B.ReactCurrentDispatcher,nr=B.ReactCurrentBatchConfig,Sc=0,Hl=null,Zl=null,gh=null,Xm=!1,ll=!1,_d=0,En=0;function Vs(){throw Error(i(321))}function ao(A,R){if(R===null)return!1;for(var K=0;K<R.length&&K<A.length;K++)if(!tu(A[K],R[K]))return!1;return!0}function dm(A,R,K,ae,Ce,Ve){if(Sc=Ve,Hl=R,R.memoizedState=null,R.updateQueue=null,R.lanes=0,ps.current=A===null||A.memoizedState===null?zT:gI,A=K(ae,Ce),ll){Ve=0;do{if(ll=!1,_d=0,25<=Ve)throw Error(i(301));Ve+=1,gh=Zl=null,R.updateQueue=null,ps.current=E_,A=K(ae,Ce)}while(ll)}if(ps.current=gv,R=Zl!==null&&Zl.next!==null,Sc=0,gh=Zl=Hl=null,Xm=!1,R)throw Error(i(300));return A}function op(){var A=_d!==0;return _d=0,A}function Ys(){var A={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};return gh===null?Hl.memoizedState=gh=A:gh=gh.next=A,gh}function Xl(){if(Zl===null){var A=Hl.alternate;A=A!==null?A.memoizedState:null}else A=Zl.next;var R=gh===null?Hl.memoizedState:gh.next;if(R!==null)gh=R,Zl=A;else{if(A===null)throw Error(i(310));Zl=A,A={memoizedState:Zl.memoizedState,baseState:Zl.baseState,baseQueue:Zl.baseQueue,queue:Zl.queue,next:null},gh===null?Hl.memoizedState=gh=A:gh=gh.next=A}return gh}function um(A,R){return typeof R=="function"?R(A):R}function ef(A){var R=Xl(),K=R.queue;if(K===null)throw Error(i(311));K.lastRenderedReducer=A;var ae=Zl,Ce=ae.baseQueue,Ve=K.pending;if(Ve!==null){if(Ce!==null){var mt=Ce.next;Ce.next=Ve.next,Ve.next=mt}ae.baseQueue=Ce=Ve,K.pending=null}if(Ce!==null){Ve=Ce.next,ae=ae.baseState;var Xt=mt=null,Si=null,Zi=Ve;do{var Kn=Zi.lane;if((Sc&Kn)===Kn)Si!==null&&(Si=Si.next={lane:0,action:Zi.action,hasEagerState:Zi.hasEagerState,eagerState:Zi.eagerState,next:null}),ae=Zi.hasEagerState?Zi.eagerState:A(ae,Zi.action);else{var Zn={lane:Kn,action:Zi.action,hasEagerState:Zi.hasEagerState,eagerState:Zi.eagerState,next:null};Si===null?(Xt=Si=Zn,mt=ae):Si=Si.next=Zn,Hl.lanes|=Kn,CS|=Kn}Zi=Zi.next}while(Zi!==null&&Zi!==Ve);Si===null?mt=ae:Si.next=Xt,tu(ae,R.memoizedState)||(ou=!0),R.memoizedState=ae,R.baseState=mt,R.baseQueue=Si,K.lastRenderedState=ae}if(A=K.interleaved,A!==null){Ce=A;do Ve=Ce.lane,Hl.lanes|=Ve,CS|=Ve,Ce=Ce.next;while(Ce!==A)}else Ce===null&&(K.lanes=0);return[R.memoizedState,K.dispatch]}function tf(A){var R=Xl(),K=R.queue;if(K===null)throw Error(i(311));K.lastRenderedReducer=A;var ae=K.dispatch,Ce=K.pending,Ve=R.memoizedState;if(Ce!==null){K.pending=null;var mt=Ce=Ce.next;do Ve=A(Ve,mt.action),mt=mt.next;while(mt!==Ce);tu(Ve,R.memoizedState)||(ou=!0),R.memoizedState=Ve,R.baseQueue===null&&(R.baseState=Ve),K.lastRenderedState=Ve}return[Ve,ae]}function uy(){}function OT(A,R){var K=Hl,ae=Xl(),Ce=R(),Ve=!tu(ae.memoizedState,Ce);if(Ve&&(ae.memoizedState=Ce,ou=!0),ae=ae.queue,Lh(Ib.bind(null,K,ae,A),[A]),ae.getSnapshot!==R||Ve||gh!==null&&gh.memoizedState.tag&1){if(K.flags|=2048,xT(9,NT.bind(null,K,ae,Ce,R),void 0,null),Fd===null)throw Error(i(349));(Sc&30)!==0||T_(K,R,Ce)}return Ce}function T_(A,R,K){A.flags|=16384,A={getSnapshot:R,value:K},R=Hl.updateQueue,R===null?(R={lastEffect:null,stores:null},Hl.updateQueue=R,R.stores=[A]):(K=R.stores,K===null?R.stores=[A]:K.push(A))}function NT(A,R,K,ae){R.value=K,R.getSnapshot=ae,nf(R)&&u0(A)}function Ib(A,R,K){return K(function(){nf(R)&&u0(A)})}function nf(A){var R=A.getSnapshot;A=A.value;try{var K=R();return!tu(A,K)}catch{return!0}}function u0(A){var R=Up(A,1);R!==null&&sp(R,A,1,-1)}function hy(A){var R=Ys();return typeof A=="function"&&(A=A()),R.memoizedState=R.baseState=A,A={pending:null,interleaved:null,lanes:0,dispatch:null,lastRenderedReducer:um,lastRenderedState:A},R.queue=A,A=A.dispatch=wb.bind(null,Hl,A),[R.memoizedState,A]}function xT(A,R,K,ae){return A={tag:A,create:R,destroy:K,deps:ae,next:null},R=Hl.updateQueue,R===null?(R={lastEffect:null,stores:null},Hl.updateQueue=R,R.lastEffect=A.next=A):(K=R.lastEffect,K===null?R.lastEffect=A.next=A:(ae=K.next,K.next=A,A.next=ae,R.lastEffect=A)),A}function hI(){return Xl().memoizedState}function BT(A,R,K,ae){var Ce=Ys();Hl.flags|=A,Ce.memoizedState=xT(1|R,K,void 0,ae===void 0?null:ae)}function FT(A,R,K,ae){var Ce=Xl();ae=ae===void 0?null:ae;var Ve=void 0;if(Zl!==null){var mt=Zl.memoizedState;if(Ve=mt.destroy,ae!==null&&ao(ae,mt.deps)){Ce.memoizedState=xT(R,K,Ve,ae);return}}Hl.flags|=A,Ce.memoizedState=xT(1|R,K,Ve,ae)}function h0(A,R){return BT(8390656,8,A,R)}function Lh(A,R){return FT(2048,8,A,R)}function C_(A,R){return FT(4,2,A,R)}function __(A,R){return FT(4,4,A,R)}function pv(A,R){if(typeof R=="function")return A=A(),R(A),function(){R(null)};if(R!=null)return A=A(),R.current=A,function(){R.current=null}}function pI(A,R,K){return K=K!=null?K.concat([A]):null,FT(4,4,pv.bind(null,R,A),K)}function p0(){}function Gu(A,R){var K=Xl();R=R===void 0?null:R;var ae=K.memoizedState;return ae!==null&&R!==null&&ao(R,ae[1])?ae[0]:(K.memoizedState=[A,R],A)}function hm(A,R){var K=Xl();R=R===void 0?null:R;var ae=K.memoizedState;return ae!==null&&R!==null&&ao(R,ae[1])?ae[0]:(A=A(),K.memoizedState=[A,R],A)}function UT(A,R,K){return(Sc&21)===0?(A.baseState&&(A.baseState=!1,ou=!0),A.memoizedState=K):(tu(K,R)||(K=jo(),Hl.lanes|=K,CS|=K,A.baseState=!0),R)}function g0(A,R){var K=fl;fl=K!==0&&4>K?K:4,A(!0);var ae=nr.transition;nr.transition={};try{A(!1),R()}finally{fl=K,nr.transition=ae}}function py(){return Xl().memoizedState}function SS(A,R,K){var ae=yy(A);if(K={lane:ae,action:K,hasEagerState:!1,eagerState:null,next:null},Ag(A))JO(R,K);else if(K=Vk(A,R,K,ae),K!==null){var Ce=Iu();sp(K,A,ae,Ce),bc(K,R,ae)}}function wb(A,R,K){var ae=yy(A),Ce={lane:ae,action:K,hasEagerState:!1,eagerState:null,next:null};if(Ag(A))JO(R,Ce);else{var Ve=A.alternate;if(A.lanes===0&&(Ve===null||Ve.lanes===0)&&(Ve=R.lastRenderedReducer,Ve!==null))try{var mt=R.lastRenderedState,Xt=Ve(mt,K);if(Ce.hasEagerState=!0,Ce.eagerState=Xt,tu(Xt,mt)){var Si=R.interleaved;Si===null?(Ce.next=Ce,zk(R)):(Ce.next=Si.next,Si.next=Ce),R.interleaved=Ce;return}}catch{}finally{}K=Vk(A,R,Ce,ae),K!==null&&(Ce=Iu(),sp(K,A,ae,Ce),bc(K,R,ae))}}function Ag(A){var R=A.alternate;return A===Hl||R!==null&&R===Hl}function JO(A,R){ll=Xm=!0;var K=A.pending;K===null?R.next=R:(R.next=K.next,K.next=R),A.pending=R}function bc(A,R,K){if((K&4194240)!==0){var ae=R.lanes;ae&=A.pendingLanes,K|=ae,R.lanes=K,iS(A,K)}}var gv={readContext:cm,useCallback:Vs,useContext:Vs,useEffect:Vs,useImperativeHandle:Vs,useInsertionEffect:Vs,useLayoutEffect:Vs,useMemo:Vs,useReducer:Vs,useRef:Vs,useState:Vs,useDebugValue:Vs,useDeferredValue:Vs,useTransition:Vs,useMutableSource:Vs,useSyncExternalStore:Vs,useId:Vs,unstable_isNewReconciler:!1},zT={readContext:cm,useCallback:function(A,R){return Ys().memoizedState=[A,R===void 0?null:R],A},useContext:cm,useEffect:h0,useImperativeHandle:function(A,R,K){return K=K!=null?K.concat([A]):null,BT(4194308,4,pv.bind(null,R,A),K)},useLayoutEffect:function(A,R){return BT(4194308,4,A,R)},useInsertionEffect:function(A,R){return BT(4,2,A,R)},useMemo:function(A,R){var K=Ys();return R=R===void 0?null:R,A=A(),K.memoizedState=[A,R],A},useReducer:function(A,R,K){var ae=Ys();return R=K!==void 0?K(R):R,ae.memoizedState=ae.baseState=R,A={pending:null,interleaved:null,lanes:0,dispatch:null,lastRenderedReducer:A,lastRenderedState:R},ae.queue=A,A=A.dispatch=SS.bind(null,Hl,A),[ae.memoizedState,A]},useRef:function(A){var R=Ys();return A={current:A},R.memoizedState=A},useState:hy,useDebugValue:p0,useDeferredValue:function(A){return Ys().memoizedState=A},useTransition:function(){var A=hy(!1),R=A[0];return A=g0.bind(null,A[1]),Ys().memoizedState=A,[R,A]},useMutableSource:function(){},useSyncExternalStore:function(A,R,K){var ae=Hl,Ce=Ys();if(Ac){if(K===void 0)throw Error(i(407));K=K()}else{if(K=R(),Fd===null)throw Error(i(349));(Sc&30)!==0||T_(ae,R,K)}Ce.memoizedState=K;var Ve={value:K,getSnapshot:R};return Ce.queue=Ve,h0(Ib.bind(null,ae,Ve,A),[A]),ae.flags|=2048,xT(9,NT.bind(null,ae,Ve,K,R),void 0,null),K},useId:function(){var A=Ys(),R=Fd.identifierPrefix;if(Ac){var K=oy,ae=Op;K=(ae&~(1<<32-td(ae)-1)).toString(32)+K,R=":"+R+"R"+K,K=_d++,0<K&&(R+="H"+K.toString(32)),R+=":"}else K=En++,R=":"+R+"r"+K.toString(32)+":";return A.memoizedState=R},unstable_isNewReconciler:!1},gI={readContext:cm,useCallback:Gu,useContext:cm,useEffect:Lh,useImperativeHandle:pI,useInsertionEffect:C_,useLayoutEffect:__,useMemo:hm,useReducer:ef,useRef:hI,useState:function(){return ef(um)},useDebugValue:p0,useDeferredValue:function(A){var R=Xl();return UT(R,Zl.memoizedState,A)},useTransition:function(){var A=ef(um)[0],R=Xl().memoizedState;return[A,R]},useMutableSource:uy,useSyncExternalStore:OT,useId:py,unstable_isNewReconciler:!1},E_={readContext:cm,useCallback:Gu,useContext:cm,useEffect:Lh,useImperativeHandle:pI,useInsertionEffect:C_,useLayoutEffect:__,useMemo:hm,useReducer:tf,useRef:hI,useState:function(){return tf(um)},useDebugValue:p0,useDeferredValue:function(A){var R=Xl();return Zl===null?R.memoizedState=A:UT(R,Zl.memoizedState,A)},useTransition:function(){var A=tf(um)[0],R=Xl().memoizedState;return[A,R]},useMutableSource:uy,useSyncExternalStore:OT,useId:py,unstable_isNewReconciler:!1};function mv(A,R){if(A&&A.defaultProps){R=ce({},R),A=A.defaultProps;for(var K in A)R[K]===void 0&&(R[K]=A[K]);return R}return R}function m0(A,R,K,ae){R=A.memoizedState,K=K(ae,R),K=K==null?R:ce({},R,K),A.memoizedState=K,A.lanes===0&&(A.updateQueue.baseState=K)}var mI={isMounted:function(A){return(A=A._reactInternals)?Pa(A)===A:!1},enqueueSetState:function(A,R,K){A=A._reactInternals;var ae=Iu(),Ce=yy(A),Ve=fS(ae,Ce);Ve.payload=R,K!=null&&(Ve.callback=K),R=hv(A,Ve,Ce),R!==null&&(sp(R,A,Ce,ae),v_(R,A,Ce))},enqueueReplaceState:function(A,R,K){A=A._reactInternals;var ae=Iu(),Ce=yy(A),Ve=fS(ae,Ce);Ve.tag=1,Ve.payload=R,K!=null&&(Ve.callback=K),R=hv(A,Ve,Ce),R!==null&&(sp(R,A,Ce,ae),v_(R,A,Ce))},enqueueForceUpdate:function(A,R){A=A._reactInternals;var K=Iu(),ae=yy(A),Ce=fS(K,ae);Ce.tag=2,R!=null&&(Ce.callback=R),R=hv(A,Ce,ae),R!==null&&(sp(R,A,ae,K),v_(R,A,ae))}};function VT(A,R,K,ae,Ce,Ve,mt){return A=A.stateNode,typeof A.shouldComponentUpdate=="function"?A.shouldComponentUpdate(ae,Ve,mt):R.prototype&&R.prototype.isPureReactComponent?!sS(K,ae)||!sS(Ce,Ve):!0}function f0(A,R,K){var ae=!1,Ce=np,Ve=R.contextType;return typeof Ve=="object"&&Ve!==null?Ve=cm(Ve):(Ce=Dc(R)?Ph:kl.current,ae=R.contextTypes,Ve=(ae=ae!=null)?ap(A,Ce):np),R=new R(K,Ve),A.memoizedState=R.state!==null&&R.state!==void 0?R.state:null,R.updater=mI,A.stateNode=R,R._reactInternals=A,ae&&(A=A.stateNode,A.__reactInternalMemoizedUnmaskedChildContext=Ce,A.__reactInternalMemoizedMaskedChildContext=Ve),R}function fI(A,R,K,ae){A=R.state,typeof R.componentWillReceiveProps=="function"&&R.componentWillReceiveProps(K,ae),typeof R.UNSAFE_componentWillReceiveProps=="function"&&R.UNSAFE_componentWillReceiveProps(K,ae),R.state!==A&&mI.enqueueReplaceState(R,R.state,null)}function v0(A,R,K,ae){var Ce=A.stateNode;Ce.props=K,Ce.state=A.memoizedState,Ce.refs={},BP(A);var Ve=R.contextType;typeof Ve=="object"&&Ve!==null?Ce.context=cm(Ve):(Ve=Dc(R)?Ph:kl.current,Ce.context=ap(A,Ve)),Ce.state=A.memoizedState,Ve=R.getDerivedStateFromProps,typeof Ve=="function"&&(m0(A,R,Ve,K),Ce.state=A.memoizedState),typeof R.getDerivedStateFromProps=="function"||typeof Ce.getSnapshotBeforeUpdate=="function"||typeof Ce.UNSAFE_componentWillMount!="function"&&typeof Ce.componentWillMount!="function"||(R=Ce.state,typeof Ce.componentWillMount=="function"&&Ce.componentWillMount(),typeof Ce.UNSAFE_componentWillMount=="function"&&Ce.UNSAFE_componentWillMount(),R!==Ce.state&&mI.enqueueReplaceState(Ce,Ce.state,null),LT(A,K,Ce,ae),Ce.state=A.memoizedState),typeof Ce.componentDidMount=="function"&&(A.flags|=4194308)}function $T(A,R){try{var K="",ae=R;do K+=qe(ae),ae=ae.return;while(ae);var Ce=K}catch(Ve){Ce=`
Error generating stack: `+Ve.message+`
`+Ve.stack}return{value:A,source:R,stack:Ce,digest:null}}function y0(A,R,K){return{value:A,source:null,stack:K??null,digest:R??null}}function jk(A,R){try{console.error(R.value)}catch(K){setTimeout(function(){throw K})}}var S0=typeof WeakMap=="function"?WeakMap:Map;function YO(A,R,K){K=fS(-1,K),K.tag=3,K.payload={element:null};var ae=R.value;return K.callback=function(){GT||(GT=!0,_S=ae),jk(A,R)},K}function vI(A,R,K){K=fS(-1,K),K.tag=3;var ae=A.type.getDerivedStateFromError;if(typeof ae=="function"){var Ce=R.value;K.payload=function(){return ae(Ce)},K.callback=function(){jk(A,R)}}var Ve=A.stateNode;return Ve!==null&&typeof Ve.componentDidCatch=="function"&&(K.callback=function(){jk(A,R),typeof ae!="function"&&(ES===null?ES=new Set([this]):ES.add(this));var mt=R.stack;this.componentDidCatch(R.value,{componentStack:mt!==null?mt:""})}),K}function af(A,R,K){var ae=A.pingCache;if(ae===null){ae=A.pingCache=new S0;var Ce=new Set;ae.set(R,Ce)}else Ce=ae.get(R),Ce===void 0&&(Ce=new Set,ae.set(R,Ce));Ce.has(K)||(Ce.add(K),A=i1.bind(null,A,R,K),R.then(A,A))}function Gk(A){do{var R;if((R=A.tag===13)&&(R=A.memoizedState,R=R!==null?R.dehydrated!==null:!0),R)return A;A=A.return}while(A!==null);return null}function rf(A,R,K,ae,Ce){return(A.mode&1)===0?(A===R?A.flags|=65536:(A.flags|=128,K.flags|=131072,K.flags&=-52805,K.tag===1&&(K.alternate===null?K.tag=17:(R=fS(-1,1),R.tag=2,hv(K,R,1))),K.lanes|=1),A):(A.flags|=65536,A.lanes=Ce,A)}var A_=B.ReactCurrentOwner,ou=!1;function qu(A,R,K,ae){R.child=A===null?Na(R,null,K,ae):Ns(R,A.child,K,ae)}function pm(A,R,K,ae,Ce){K=K.render;var Ve=R.ref;return Cd(R,Ce),ae=dm(A,R,K,ae,Ve,Ce),K=op(),A!==null&&!ou?(R.updateQueue=A.updateQueue,R.flags&=-2053,A.lanes&=~Ce,Vp(A,R,Ce)):(Ac&&K&&sy(R),R.flags|=1,qu(A,R,ae,Ce),R.child)}function zp(A,R,K,ae,Ce){if(A===null){var Ve=K.type;return typeof Ve=="function"&&!qP(Ve)&&Ve.defaultProps===void 0&&K.compare===null&&K.defaultProps===void 0?(R.tag=15,R.type=Ve,Jo(A,R,Ve,ae,Ce)):(A=N_(K.type,null,ae,R,R.mode,Ce),A.ref=R.ref,A.return=R,R.child=A)}if(Ve=A.child,(A.lanes&Ce)===0){var mt=Ve.memoizedProps;if(K=K.compare,K=K!==null?K:sS,K(mt,ae)&&A.ref===R.ref)return Vp(A,R,Ce)}return R.flags|=1,A=Db(Ve,ae),A.ref=R.ref,A.return=R,R.child=A}function Jo(A,R,K,ae,Ce){if(A!==null){var Ve=A.memoizedProps;if(sS(Ve,ae)&&A.ref===R.ref)if(ou=!1,R.pendingProps=ae=Ve,(A.lanes&Ce)!==0)(A.flags&131072)!==0&&(ou=!0);else return R.lanes=A.lanes,Vp(A,R,Ce)}return b0(A,R,K,ae,Ce)}function I_(A,R,K){var ae=R.pendingProps,Ce=ae.children,Ve=A!==null?A.memoizedState:null;if(ae.mode==="hidden")if((R.mode&1)===0)R.memoizedState={baseLanes:0,cachePool:null,transitions:null},ra(A0,Gp),Gp|=K;else{if((K&1073741824)===0)return A=Ve!==null?Ve.baseLanes|K:K,R.lanes=R.childLanes=1073741824,R.memoizedState={baseLanes:A,cachePool:null,transitions:null},R.updateQueue=null,ra(A0,Gp),Gp|=A,null;R.memoizedState={baseLanes:0,cachePool:null,transitions:null},ae=Ve!==null?Ve.baseLanes:K,ra(A0,Gp),Gp|=ae}else Ve!==null?(ae=Ve.baseLanes|K,R.memoizedState=null):ae=K,ra(A0,Gp),Gp|=ae;return qu(A,R,Ce,K),R.child}function yI(A,R){var K=R.ref;(A===null&&K!==null||A!==null&&A.ref!==K)&&(R.flags|=512,R.flags|=2097152)}function b0(A,R,K,ae,Ce){var Ve=Dc(K)?Ph:kl.current;return Ve=ap(R,Ve),Cd(R,Ce),K=dm(A,R,K,ae,Ve,Ce),ae=op(),A!==null&&!ou?(R.updateQueue=A.updateQueue,R.flags&=-2053,A.lanes&=~Ce,Vp(A,R,Ce)):(Ac&&ae&&sy(R),R.flags|=1,qu(A,R,K,Ce),R.child)}function kb(A,R,K,ae,Ce){if(Dc(K)){var Ve=!0;Dh(R)}else Ve=!1;if(Cd(R,Ce),R.stateNode===null)of(A,R),f0(R,K,ae),v0(R,K,ae,Ce),ae=!0;else if(A===null){var mt=R.stateNode,Xt=R.memoizedProps;mt.props=Xt;var Si=mt.context,Zi=K.contextType;typeof Zi=="object"&&Zi!==null?Zi=cm(Zi):(Zi=Dc(K)?Ph:kl.current,Zi=ap(R,Zi));var Kn=K.getDerivedStateFromProps,Zn=typeof Kn=="function"||typeof mt.getSnapshotBeforeUpdate=="function";Zn||typeof mt.UNSAFE_componentWillReceiveProps!="function"&&typeof mt.componentWillReceiveProps!="function"||(Xt!==ae||Si!==Zi)&&fI(R,mt,ae,Zi),Eg=!1;var Gn=R.memoizedState;mt.state=Gn,LT(R,ae,mt,Ce),Si=R.memoizedState,Xt!==ae||Gn!==Si||iu.current||Eg?(typeof Kn=="function"&&(m0(R,K,Kn,ae),Si=R.memoizedState),(Xt=Eg||VT(R,K,Xt,ae,Gn,Si,Zi))?(Zn||typeof mt.UNSAFE_componentWillMount!="function"&&typeof mt.componentWillMount!="function"||(typeof mt.componentWillMount=="function"&&mt.componentWillMount(),typeof mt.UNSAFE_componentWillMount=="function"&&mt.UNSAFE_componentWillMount()),typeof mt.componentDidMount=="function"&&(R.flags|=4194308)):(typeof mt.componentDidMount=="function"&&(R.flags|=4194308),R.memoizedProps=ae,R.memoizedState=Si),mt.props=ae,mt.state=Si,mt.context=Zi,ae=Xt):(typeof mt.componentDidMount=="function"&&(R.flags|=4194308),ae=!1)}else{mt=R.stateNode,lI(A,R),Xt=R.memoizedProps,Zi=R.type===R.elementType?Xt:mv(R.type,Xt),mt.props=Zi,Zn=R.pendingProps,Gn=mt.context,Si=K.contextType,typeof Si=="object"&&Si!==null?Si=cm(Si):(Si=Dc(K)?Ph:kl.current,Si=ap(R,Si));var Ka=K.getDerivedStateFromProps;(Kn=typeof Ka=="function"||typeof mt.getSnapshotBeforeUpdate=="function")||typeof mt.UNSAFE_componentWillReceiveProps!="function"&&typeof mt.componentWillReceiveProps!="function"||(Xt!==Zn||Gn!==Si)&&fI(R,mt,ae,Si),Eg=!1,Gn=R.memoizedState,mt.state=Gn,LT(R,ae,mt,Ce);var br=R.memoizedState;Xt!==Zn||Gn!==br||iu.current||Eg?(typeof Ka=="function"&&(m0(R,K,Ka,ae),br=R.memoizedState),(Zi=Eg||VT(R,K,Zi,ae,Gn,br,Si)||!1)?(Kn||typeof mt.UNSAFE_componentWillUpdate!="function"&&typeof mt.componentWillUpdate!="function"||(typeof mt.componentWillUpdate=="function"&&mt.componentWillUpdate(ae,br,Si),typeof mt.UNSAFE_componentWillUpdate=="function"&&mt.UNSAFE_componentWillUpdate(ae,br,Si)),typeof mt.componentDidUpdate=="function"&&(R.flags|=4),typeof mt.getSnapshotBeforeUpdate=="function"&&(R.flags|=1024)):(typeof mt.componentDidUpdate!="function"||Xt===A.memoizedProps&&Gn===A.memoizedState||(R.flags|=4),typeof mt.getSnapshotBeforeUpdate!="function"||Xt===A.memoizedProps&&Gn===A.memoizedState||(R.flags|=1024),R.memoizedProps=ae,R.memoizedState=br),mt.props=ae,mt.state=br,mt.context=Si,ae=Zi):(typeof mt.componentDidUpdate!="function"||Xt===A.memoizedProps&&Gn===A.memoizedState||(R.flags|=4),typeof mt.getSnapshotBeforeUpdate!="function"||Xt===A.memoizedProps&&Gn===A.memoizedState||(R.flags|=1024),ae=!1)}return Yr(A,R,K,ae,Ve,Ce)}function Yr(A,R,K,ae,Ce,Ve){yI(A,R);var mt=(R.flags&128)!==0;if(!ae&&!mt)return Ce&&bg(R,K,!1),Vp(A,R,Ve);ae=R.stateNode,A_.current=R;var Xt=mt&&typeof K.getDerivedStateFromError!="function"?null:ae.render();return R.flags|=1,A!==null&&mt?(R.child=Ns(R,A.child,null,Ve),R.child=Ns(R,null,Xt,Ve)):qu(A,R,Xt,Ve),R.memoizedState=ae.state,Ce&&bg(R,K,!0),R.child}function bS(A){var R=A.stateNode;R.pendingContext?ay(A,R.pendingContext,R.pendingContext!==R.context):R.context&&ay(A,R.context,!1),uI(A,R.containerInfo)}function qk(A,R,K,ae,Ce){return cv(),Zm(Ce),R.flags|=256,qu(A,R,K,ae),R.child}var gy={dehydrated:null,treeContext:null,retryLane:0};function Wk(A){return{baseLanes:A,cachePool:null,transitions:null}}function fv(A,R,K){var ae=R.pendingProps,Ce=nd.current,Ve=!1,mt=(R.flags&128)!==0,Xt;if((Xt=mt)||(Xt=A!==null&&A.memoizedState===null?!1:(Ce&2)!==0),Xt?(Ve=!0,R.flags&=-129):(A===null||A.memoizedState!==null)&&(Ce|=1),ra(nd,Ce&1),A===null)return pS(R),A=R.memoizedState,A!==null&&(A=A.dehydrated,A!==null)?((R.mode&1)===0?R.lanes=1:A.data==="$!"?R.lanes=8:R.lanes=1073741824,null):(mt=ae.children,A=ae.fallback,Ve?(ae=R.mode,Ve=R.child,mt={mode:"hidden",children:mt},(ae&1)===0&&Ve!==null?(Ve.childLanes=0,Ve.pendingProps=mt):Ve=WT(mt,ae,0,null),A=lu(A,ae,K,null),Ve.return=R,A.return=R,Ve.sibling=A,R.child=Ve,R.child.memoizedState=Wk(K),R.memoizedState=gy,A):SI(R,mt));if(Ce=A.memoizedState,Ce!==null&&(Xt=Ce.dehydrated,Xt!==null))return FP(A,R,mt,ae,Xt,Ce,K);if(Ve){Ve=ae.fallback,mt=R.mode,Ce=A.child,Xt=Ce.sibling;var Si={mode:"hidden",children:ae.children};return(mt&1)===0&&R.child!==Ce?(ae=R.child,ae.childLanes=0,ae.pendingProps=Si,R.deletions=null):(ae=Db(Ce,Si),ae.subtreeFlags=Ce.subtreeFlags&14680064),Xt!==null?Ve=Db(Xt,Ve):(Ve=lu(Ve,mt,K,null),Ve.flags|=2),Ve.return=R,ae.return=R,ae.sibling=Ve,R.child=ae,ae=Ve,Ve=R.child,mt=A.child.memoizedState,mt=mt===null?Wk(K):{baseLanes:mt.baseLanes|K,cachePool:null,transitions:mt.transitions},Ve.memoizedState=mt,Ve.childLanes=A.childLanes&~K,R.memoizedState=gy,ae}return Ve=A.child,A=Ve.sibling,ae=Db(Ve,{mode:"visible",children:ae.children}),(R.mode&1)===0&&(ae.lanes=K),ae.return=R,ae.sibling=null,A!==null&&(K=R.deletions,K===null?(R.deletions=[A],R.flags|=16):K.push(A)),R.child=ae,R.memoizedState=null,ae}function SI(A,R){return R=WT({mode:"visible",children:R},A.mode,0,null),R.return=A,A.child=R}function Au(A,R,K,ae){return ae!==null&&Zm(ae),Ns(R,A.child,null,K),A=SI(R,R.pendingProps.children),A.flags|=2,R.memoizedState=null,A}function FP(A,R,K,ae,Ce,Ve,mt){if(K)return R.flags&256?(R.flags&=-257,ae=y0(Error(i(422))),Au(A,R,mt,ae)):R.memoizedState!==null?(R.child=A.child,R.flags|=128,null):(Ve=ae.fallback,Ce=R.mode,ae=WT({mode:"visible",children:ae.children},Ce,0,null),Ve=lu(Ve,Ce,mt,null),Ve.flags|=2,ae.return=R,Ve.return=R,ae.sibling=Ve,R.child=ae,(R.mode&1)!==0&&Ns(R,A.child,null,mt),R.child.memoizedState=Wk(mt),R.memoizedState=gy,Ve);if((R.mode&1)===0)return Au(A,R,mt,null);if(Ce.data==="$!"){if(ae=Ce.nextSibling&&Ce.nextSibling.dataset,ae)var Xt=ae.dgst;return ae=Xt,Ve=Error(i(419)),ae=y0(Ve,ae,void 0),Au(A,R,mt,ae)}if(Xt=(mt&A.childLanes)!==0,ou||Xt){if(ae=Fd,ae!==null){switch(mt&-mt){case 4:Ce=2;break;case 16:Ce=8;break;case 64:case 128:case 256:case 512:case 1024:case 2048:case 4096:case 8192:case 16384:case 32768:case 65536:case 131072:case 262144:case 524288:case 1048576:case 2097152:case 4194304:case 8388608:case 16777216:case 33554432:case 67108864:Ce=32;break;case 536870912:Ce=268435456;break;default:Ce=0}Ce=(Ce&(ae.suspendedLanes|mt))!==0?0:Ce,Ce!==0&&Ce!==Ve.retryLane&&(Ve.retryLane=Ce,Up(A,Ce),sp(ae,A,Ce,-1))}return tR(),ae=y0(Error(i(421))),Au(A,R,mt,ae)}return Ce.data==="$?"?(R.flags|=128,R.child=A.child,R=iR.bind(null,A),Ce._reactRetry=R,null):(A=Ve.treeContext,xd=ip(Ce.nextSibling),ju=R,Ac=!0,au=null,A!==null&&(vc[yc++]=Op,vc[yc++]=oy,vc[yc++]=sm,Op=A.id,oy=A.overflow,sm=R),R=SI(R,ae.children),R.flags|=4096,R)}function T0(A,R,K){A.lanes|=R;var ae=A.alternate;ae!==null&&(ae.lanes|=R),DT(A.return,R,K)}function mh(A,R,K,ae,Ce){var Ve=A.memoizedState;Ve===null?A.memoizedState={isBackwards:R,rendering:null,renderingStartTime:0,last:ae,tail:K,tailMode:Ce}:(Ve.isBackwards=R,Ve.rendering=null,Ve.renderingStartTime=0,Ve.last=ae,Ve.tail=K,Ve.tailMode=Ce)}function TS(A,R,K){var ae=R.pendingProps,Ce=ae.revealOrder,Ve=ae.tail;if(qu(A,R,ae.children,K),ae=nd.current,(ae&2)!==0)ae=ae&1|2,R.flags|=128;else{if(A!==null&&(A.flags&128)!==0)e:for(A=R.child;A!==null;){if(A.tag===13)A.memoizedState!==null&&T0(A,K,R);else if(A.tag===19)T0(A,K,R);else if(A.child!==null){A.child.return=A,A=A.child;continue}if(A===R)break e;for(;A.sibling===null;){if(A.return===null||A.return===R)break e;A=A.return}A.sibling.return=A.return,A=A.sibling}ae&=1}if(ra(nd,ae),(R.mode&1)===0)R.memoizedState=null;else switch(Ce){case"forwards":for(K=R.child,Ce=null;K!==null;)A=K.alternate,A!==null&&d0(A)===null&&(Ce=K),K=K.sibling;K=Ce,K===null?(Ce=R.child,R.child=null):(Ce=K.sibling,K.sibling=null),mh(R,!1,Ce,K,Ve);break;case"backwards":for(K=null,Ce=R.child,R.child=null;Ce!==null;){if(A=Ce.alternate,A!==null&&d0(A)===null){R.child=Ce;break}A=Ce.sibling,Ce.sibling=K,K=Ce,Ce=A}mh(R,!0,K,null,Ve);break;case"together":mh(R,!1,null,null,void 0);break;default:R.memoizedState=null}return R.child}function of(A,R){(R.mode&1)===0&&A!==null&&(A.alternate=null,R.alternate=null,R.flags|=2)}function Vp(A,R,K){if(A!==null&&(R.dependencies=A.dependencies),CS|=R.lanes,(K&R.childLanes)===0)return null;if(A!==null&&R.child!==A.child)throw Error(i(153));if(R.child!==null){for(A=R.child,K=Db(A,A.pendingProps),R.child=K,K.return=R;A.sibling!==null;)A=A.sibling,K=K.sibling=Db(A,A.pendingProps),K.return=R;K.sibling=null}return R.child}function bI(A,R,K){switch(R.tag){case 3:bS(R),cv();break;case 5:$k(R);break;case 1:Dc(R.type)&&Dh(R);break;case 4:uI(R,R.stateNode.containerInfo);break;case 10:var ae=R.type._context,Ce=R.memoizedProps.value;ra(lm,ae._currentValue),ae._currentValue=Ce;break;case 13:if(ae=R.memoizedState,ae!==null)return ae.dehydrated!==null?(ra(nd,nd.current&1),R.flags|=128,null):(K&R.child.childLanes)!==0?fv(A,R,K):(ra(nd,nd.current&1),A=Vp(A,R,K),A!==null?A.sibling:null);ra(nd,nd.current&1);break;case 19:if(ae=(K&R.childLanes)!==0,(A.flags&128)!==0){if(ae)return TS(A,R,K);R.flags|=128}if(Ce=R.memoizedState,Ce!==null&&(Ce.rendering=null,Ce.tail=null,Ce.lastEffect=null),ra(nd,nd.current),ae)break;return null;case 22:case 23:return R.lanes=0,I_(A,R,K)}return Vp(A,R,K)}var gm,Tc,$p,Kk;gm=function(A,R){for(var K=R.child;K!==null;){if(K.tag===5||K.tag===6)A.appendChild(K.stateNode);else if(K.tag!==4&&K.child!==null){K.child.return=K,K=K.child;continue}if(K===R)break;for(;K.sibling===null;){if(K.return===null||K.return===R)return;K=K.return}K.sibling.return=K.return,K=K.sibling}},Tc=function(){},$p=function(A,R,K,ae){var Ce=A.memoizedProps;if(Ce!==ae){A=R.stateNode,yS(dy.current);var Ve=null;switch(K){case"input":Ce=Zt(A,Ce),ae=Zt(A,ae),Ve=[];break;case"select":Ce=ce({},Ce,{value:void 0}),ae=ce({},ae,{value:void 0}),Ve=[];break;case"textarea":Ce=$t(A,Ce),ae=$t(A,ae),Ve=[];break;default:typeof Ce.onClick!="function"&&typeof ae.onClick=="function"&&(A.onclick=Sg)}sn(K,ae);var mt;K=null;for(Zi in Ce)if(!ae.hasOwnProperty(Zi)&&Ce.hasOwnProperty(Zi)&&Ce[Zi]!=null)if(Zi==="style"){var Xt=Ce[Zi];for(mt in Xt)Xt.hasOwnProperty(mt)&&(K||(K={}),K[mt]="")}else Zi!=="dangerouslySetInnerHTML"&&Zi!=="children"&&Zi!=="suppressContentEditableWarning"&&Zi!=="suppressHydrationWarning"&&Zi!=="autoFocus"&&(o.hasOwnProperty(Zi)?Ve||(Ve=[]):(Ve=Ve||[]).push(Zi,null));for(Zi in ae){var Si=ae[Zi];if(Xt=Ce?.[Zi],ae.hasOwnProperty(Zi)&&Si!==Xt&&(Si!=null||Xt!=null))if(Zi==="style")if(Xt){for(mt in Xt)!Xt.hasOwnProperty(mt)||Si&&Si.hasOwnProperty(mt)||(K||(K={}),K[mt]="");for(mt in Si)Si.hasOwnProperty(mt)&&Xt[mt]!==Si[mt]&&(K||(K={}),K[mt]=Si[mt])}else K||(Ve||(Ve=[]),Ve.push(Zi,K)),K=Si;else Zi==="dangerouslySetInnerHTML"?(Si=Si?Si.__html:void 0,Xt=Xt?Xt.__html:void 0,Si!=null&&Xt!==Si&&(Ve=Ve||[]).push(Zi,Si)):Zi==="children"?typeof Si!="string"&&typeof Si!="number"||(Ve=Ve||[]).push(Zi,""+Si):Zi!=="suppressContentEditableWarning"&&Zi!=="suppressHydrationWarning"&&(o.hasOwnProperty(Zi)?(Si!=null&&Zi==="onScroll"&&wl("scroll",A),Ve||Xt===Si||(Ve=[])):(Ve=Ve||[]).push(Zi,Si))}K&&(Ve=Ve||[]).push("style",K);var Zi=Ve;(R.updateQueue=Zi)&&(R.flags|=4)}},Kk=function(A,R,K,ae){K!==ae&&(R.flags|=4)};function C0(A,R){if(!Ac)switch(A.tailMode){case"hidden":R=A.tail;for(var K=null;R!==null;)R.alternate!==null&&(K=R),R=R.sibling;K===null?A.tail=null:K.sibling=null;break;case"collapsed":K=A.tail;for(var ae=null;K!==null;)K.alternate!==null&&(ae=K),K=K.sibling;ae===null?R||A.tail===null?A.tail=null:A.tail.sibling=null:ae.sibling=null}}function Wu(A){var R=A.alternate!==null&&A.alternate.child===A.child,K=0,ae=0;if(R)for(var Ce=A.child;Ce!==null;)K|=Ce.lanes|Ce.childLanes,ae|=Ce.subtreeFlags&14680064,ae|=Ce.flags&14680064,Ce.return=A,Ce=Ce.sibling;else for(Ce=A.child;Ce!==null;)K|=Ce.lanes|Ce.childLanes,ae|=Ce.subtreeFlags,ae|=Ce.flags,Ce.return=A,Ce=Ce.sibling;return A.subtreeFlags|=ae,A.childLanes=K,R}function w_(A,R,K){var ae=R.pendingProps;switch(Np(R),R.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return Wu(R),null;case 1:return Dc(R.type)&&Hc(),Wu(R),null;case 3:return ae=R.stateNode,S_(),fc(iu),fc(kl),Jr(),ae.pendingContext&&(ae.context=ae.pendingContext,ae.pendingContext=null),(A===null||A.child===null)&&(Eb(R)?R.flags|=4:A===null||A.memoizedState.isDehydrated&&(R.flags&256)===0||(R.flags|=1024,au!==null&&(yv(au),au=null))),Tc(A,R),Wu(R),null;case 5:Hk(R);var Ce=yS(y_.current);if(K=R.type,A!==null&&R.stateNode!=null)$p(A,R,K,ae,Ce),A.ref!==R.ref&&(R.flags|=512,R.flags|=2097152);else{if(!ae){if(R.stateNode===null)throw Error(i(166));return Wu(R),null}if(A=yS(dy.current),Eb(R)){ae=R.stateNode,K=R.type;var Ve=R.memoizedProps;switch(ae[Lo]=R,ae[oI]=Ve,A=(R.mode&1)!==0,K){case"dialog":wl("cancel",ae),wl("close",ae);break;case"iframe":case"object":case"embed":wl("load",ae);break;case"video":case"audio":for(Ce=0;Ce<_u.length;Ce++)wl(_u[Ce],ae);break;case"source":wl("error",ae);break;case"img":case"image":case"link":wl("error",ae),wl("load",ae);break;case"details":wl("toggle",ae);break;case"input":it(ae,Ve),wl("invalid",ae);break;case"select":ae._wrapperState={wasMultiple:!!Ve.multiple},wl("invalid",ae);break;case"textarea":dt(ae,Ve),wl("invalid",ae)}sn(K,Ve),Ce=null;for(var mt in Ve)if(Ve.hasOwnProperty(mt)){var Xt=Ve[mt];mt==="children"?typeof Xt=="string"?ae.textContent!==Xt&&(Ve.suppressHydrationWarning!==!0&&uS(ae.textContent,Xt,A),Ce=["children",Xt]):typeof Xt=="number"&&ae.textContent!==""+Xt&&(Ve.suppressHydrationWarning!==!0&&uS(ae.textContent,Xt,A),Ce=["children",""+Xt]):o.hasOwnProperty(mt)&&Xt!=null&&mt==="onScroll"&&wl("scroll",ae)}switch(K){case"input":vt(ae),Ht(ae,Ve,!0);break;case"textarea":vt(ae),kt(ae);break;case"select":case"option":break;default:typeof Ve.onClick=="function"&&(ae.onclick=Sg)}ae=Ce,R.updateQueue=ae,ae!==null&&(R.flags|=4)}else{mt=Ce.nodeType===9?Ce:Ce.ownerDocument,A==="http://www.w3.org/1999/xhtml"&&(A=je(K)),A==="http://www.w3.org/1999/xhtml"?K==="script"?(A=mt.createElement("div"),A.innerHTML="<script><\/script>",A=A.removeChild(A.firstChild)):typeof ae.is=="string"?A=mt.createElement(K,{is:ae.is}):(A=mt.createElement(K),K==="select"&&(mt=A,ae.multiple?mt.multiple=!0:ae.size&&(mt.size=ae.size))):A=mt.createElementNS(A,K),A[Lo]=R,A[oI]=ae,gm(A,R,!1,!1),R.stateNode=A;e:{switch(mt=Qi(K,ae),K){case"dialog":wl("cancel",A),wl("close",A),Ce=ae;break;case"iframe":case"object":case"embed":wl("load",A),Ce=ae;break;case"video":case"audio":for(Ce=0;Ce<_u.length;Ce++)wl(_u[Ce],A);Ce=ae;break;case"source":wl("error",A),Ce=ae;break;case"img":case"image":case"link":wl("error",A),wl("load",A),Ce=ae;break;case"details":wl("toggle",A),Ce=ae;break;case"input":it(A,ae),Ce=Zt(A,ae),wl("invalid",A);break;case"option":Ce=ae;break;case"select":A._wrapperState={wasMultiple:!!ae.multiple},Ce=ce({},ae,{value:void 0}),wl("invalid",A);break;case"textarea":dt(A,ae),Ce=$t(A,ae),wl("invalid",A);break;default:Ce=ae}sn(K,Ce),Xt=Ce;for(Ve in Xt)if(Xt.hasOwnProperty(Ve)){var Si=Xt[Ve];Ve==="style"?Ii(A,Si):Ve==="dangerouslySetInnerHTML"?(Si=Si?Si.__html:void 0,Si!=null&&gt(A,Si)):Ve==="children"?typeof Si=="string"?(K!=="textarea"||Si!=="")&&Ye(A,Si):typeof Si=="number"&&Ye(A,""+Si):Ve!=="suppressContentEditableWarning"&&Ve!=="suppressHydrationWarning"&&Ve!=="autoFocus"&&(o.hasOwnProperty(Ve)?Si!=null&&Ve==="onScroll"&&wl("scroll",A):Si!=null&&x(A,Ve,Si,mt))}switch(K){case"input":vt(A),Ht(A,ae,!1);break;case"textarea":vt(A),kt(A);break;case"option":ae.value!=null&&A.setAttribute("value",""+ct(ae.value));break;case"select":A.multiple=!!ae.multiple,Ve=ae.value,Ve!=null?Vt(A,!!ae.multiple,Ve,!1):ae.defaultValue!=null&&Vt(A,!!ae.multiple,ae.defaultValue,!0);break;default:typeof Ce.onClick=="function"&&(A.onclick=Sg)}switch(K){case"button":case"input":case"select":case"textarea":ae=!!ae.autoFocus;break e;case"img":ae=!0;break e;default:ae=!1}}ae&&(R.flags|=4)}R.ref!==null&&(R.flags|=512,R.flags|=2097152)}return Wu(R),null;case 6:if(A&&R.stateNode!=null)Kk(A,R,A.memoizedProps,ae);else{if(typeof ae!="string"&&R.stateNode===null)throw Error(i(166));if(K=yS(y_.current),yS(dy.current),Eb(R)){if(ae=R.stateNode,K=R.memoizedProps,ae[Lo]=R,(Ve=ae.nodeValue!==K)&&(A=ju,A!==null))switch(A.tag){case 3:uS(ae.nodeValue,K,(A.mode&1)!==0);break;case 5:A.memoizedProps.suppressHydrationWarning!==!0&&uS(ae.nodeValue,K,(A.mode&1)!==0)}Ve&&(R.flags|=4)}else ae=(K.nodeType===9?K:K.ownerDocument).createTextNode(ae),ae[Lo]=R,R.stateNode=ae}return Wu(R),null;case 13:if(fc(nd),ae=R.memoizedState,A===null||A.memoizedState!==null&&A.memoizedState.dehydrated!==null){if(Ac&&xd!==null&&(R.mode&1)!==0&&(R.flags&128)===0)ru(),cv(),R.flags|=98560,Ve=!1;else if(Ve=Eb(R),ae!==null&&ae.dehydrated!==null){if(A===null){if(!Ve)throw Error(i(318));if(Ve=R.memoizedState,Ve=Ve!==null?Ve.dehydrated:null,!Ve)throw Error(i(317));Ve[Lo]=R}else cv(),(R.flags&128)===0&&(R.memoizedState=null),R.flags|=4;Wu(R),Ve=!1}else au!==null&&(yv(au),au=null),Ve=!0;if(!Ve)return R.flags&65536?R:null}return(R.flags&128)!==0?(R.lanes=K,R):(ae=ae!==null,ae!==(A!==null&&A.memoizedState!==null)&&ae&&(R.child.flags|=8192,(R.mode&1)!==0&&(A===null||(nd.current&1)!==0?su===0&&(su=3):tR())),R.updateQueue!==null&&(R.flags|=4),Wu(R),null);case 4:return S_(),Tc(A,R),A===null&&ty(R.stateNode.containerInfo),Wu(R),null;case 10:return Ab(R.type._context),Wu(R),null;case 17:return Dc(R.type)&&Hc(),Wu(R),null;case 19:if(fc(nd),Ve=R.memoizedState,Ve===null)return Wu(R),null;if(ae=(R.flags&128)!==0,mt=Ve.rendering,mt===null)if(ae)C0(Ve,!1);else{if(su!==0||A!==null&&(A.flags&128)!==0)for(A=R.child;A!==null;){if(mt=d0(A),mt!==null){for(R.flags|=128,C0(Ve,!1),ae=mt.updateQueue,ae!==null&&(R.updateQueue=ae,R.flags|=4),R.subtreeFlags=0,ae=K,K=R.child;K!==null;)Ve=K,A=ae,Ve.flags&=14680066,mt=Ve.alternate,mt===null?(Ve.childLanes=0,Ve.lanes=A,Ve.child=null,Ve.subtreeFlags=0,Ve.memoizedProps=null,Ve.memoizedState=null,Ve.updateQueue=null,Ve.dependencies=null,Ve.stateNode=null):(Ve.childLanes=mt.childLanes,Ve.lanes=mt.lanes,Ve.child=mt.child,Ve.subtreeFlags=0,Ve.deletions=null,Ve.memoizedProps=mt.memoizedProps,Ve.memoizedState=mt.memoizedState,Ve.updateQueue=mt.updateQueue,Ve.type=mt.type,A=mt.dependencies,Ve.dependencies=A===null?null:{lanes:A.lanes,firstContext:A.firstContext}),K=K.sibling;return ra(nd,nd.current&1|2),R.child}A=A.sibling}Ve.tail!==null&&za()>w0&&(R.flags|=128,ae=!0,C0(Ve,!1),R.lanes=4194304)}else{if(!ae)if(A=d0(mt),A!==null){if(R.flags|=128,ae=!0,K=A.updateQueue,K!==null&&(R.updateQueue=K,R.flags|=4),C0(Ve,!0),Ve.tail===null&&Ve.tailMode==="hidden"&&!mt.alternate&&!Ac)return Wu(R),null}else 2*za()-Ve.renderingStartTime>w0&&K!==1073741824&&(R.flags|=128,ae=!0,C0(Ve,!1),R.lanes=4194304);Ve.isBackwards?(mt.sibling=R.child,R.child=mt):(K=Ve.last,K!==null?K.sibling=mt:R.child=mt,Ve.last=mt)}return Ve.tail!==null?(R=Ve.tail,Ve.rendering=R,Ve.tail=R.sibling,Ve.renderingStartTime=za(),R.sibling=null,K=nd.current,ra(nd,ae?K&1|2:K&1),R):(Wu(R),null);case 22:case 23:return VP(),ae=R.memoizedState!==null,A!==null&&A.memoizedState!==null!==ae&&(R.flags|=8192),ae&&(R.mode&1)!==0?(Gp&1073741824)!==0&&(Wu(R),R.subtreeFlags&6&&(R.flags|=8192)):Wu(R),null;case 24:return null;case 25:return null}throw Error(i(156,R.tag))}function TI(A,R){switch(Np(R),R.tag){case 1:return Dc(R.type)&&Hc(),A=R.flags,A&65536?(R.flags=A&-65537|128,R):null;case 3:return S_(),fc(iu),fc(kl),Jr(),A=R.flags,(A&65536)!==0&&(A&128)===0?(R.flags=A&-65537|128,R):null;case 5:return Hk(R),null;case 13:if(fc(nd),A=R.memoizedState,A!==null&&A.dehydrated!==null){if(R.alternate===null)throw Error(i(340));cv()}return A=R.flags,A&65536?(R.flags=A&-65537|128,R):null;case 19:return fc(nd),null;case 4:return S_(),null;case 10:return Ab(R.type._context),null;case 22:case 23:return VP(),null;case 24:return null;default:return null}}var vv=!1,Oh=!1,Jk=typeof WeakSet=="function"?WeakSet:Set,ar=null;function sf(A,R){var K=A.ref;if(K!==null)if(typeof K=="function")try{K(null)}catch(ae){od(A,R,ae)}else K.current=null}function CI(A,R,K){try{K()}catch(ae){od(A,R,ae)}}var QO=!1;function Yk(A,R){if(p_=bd,A=IT(),Vl(A)){if("selectionStart"in A)var K={start:A.selectionStart,end:A.selectionEnd};else e:{K=(K=A.ownerDocument)&&K.defaultView||window;var ae=K.getSelection&&K.getSelection();if(ae&&ae.rangeCount!==0){K=ae.anchorNode;var Ce=ae.anchorOffset,Ve=ae.focusNode;ae=ae.focusOffset;try{K.nodeType,Ve.nodeType}catch{K=null;break e}var mt=0,Xt=-1,Si=-1,Zi=0,Kn=0,Zn=A,Gn=null;t:for(;;){for(var Ka;Zn!==K||Ce!==0&&Zn.nodeType!==3||(Xt=mt+Ce),Zn!==Ve||ae!==0&&Zn.nodeType!==3||(Si=mt+ae),Zn.nodeType===3&&(mt+=Zn.nodeValue.length),(Ka=Zn.firstChild)!==null;)Gn=Zn,Zn=Ka;for(;;){if(Zn===A)break t;if(Gn===K&&++Zi===Ce&&(Xt=mt),Gn===Ve&&++Kn===ae&&(Si=mt),(Ka=Zn.nextSibling)!==null)break;Zn=Gn,Gn=Zn.parentNode}Zn=Ka}K=Xt===-1||Si===-1?null:{start:Xt,end:Si}}else K=null}K=K||{start:0,end:0}}else K=null;for(iy={focusedElem:A,selectionRange:K},bd=!1,ar=R;ar!==null;)if(R=ar,A=R.child,(R.subtreeFlags&1028)!==0&&A!==null)A.return=R,ar=A;else for(;ar!==null;){R=ar;try{var br=R.alternate;if((R.flags&1024)!==0)switch(R.tag){case 0:case 11:case 15:break;case 1:if(br!==null){var Tr=br.memoizedProps,Ud=br.memoizedState,Vi=R.stateNode,Mi=Vi.getSnapshotBeforeUpdate(R.elementType===R.type?Tr:mv(R.type,Tr),Ud);Vi.__reactInternalSnapshotBeforeUpdate=Mi}break;case 3:var Yi=R.stateNode.containerInfo;Yi.nodeType===1?Yi.textContent="":Yi.nodeType===9&&Yi.documentElement&&Yi.removeChild(Yi.documentElement);break;case 5:case 6:case 4:case 17:break;default:throw Error(i(163))}}catch(Jn){od(R,R.return,Jn)}if(A=R.sibling,A!==null){A.return=R.return,ar=A;break}ar=R.return}return br=QO,QO=!1,br}function k_(A,R,K){var ae=R.updateQueue;if(ae=ae!==null?ae.lastEffect:null,ae!==null){var Ce=ae=ae.next;do{if((Ce.tag&A)===A){var Ve=Ce.destroy;Ce.destroy=void 0,Ve!==void 0&&CI(R,K,Ve)}Ce=Ce.next}while(Ce!==ae)}}function _I(A,R){if(R=R.updateQueue,R=R!==null?R.lastEffect:null,R!==null){var K=R=R.next;do{if((K.tag&A)===A){var ae=K.create;K.destroy=ae()}K=K.next}while(K!==R)}}function R_(A){var R=A.ref;if(R!==null){var K=A.stateNode;switch(A.tag){case 5:A=K;break;default:A=K}typeof R=="function"?R(A):R.current=A}}function _0(A){var R=A.alternate;R!==null&&(A.alternate=null,_0(R)),A.child=null,A.deletions=null,A.sibling=null,A.tag===5&&(R=A.stateNode,R!==null&&(delete R[Lo],delete R[oI],delete R[sI],delete R[ov],delete R[SF])),A.stateNode=null,A.return=null,A.dependencies=null,A.memoizedProps=null,A.memoizedState=null,A.pendingProps=null,A.stateNode=null,A.updateQueue=null}function Rb(A){return A.tag===5||A.tag===3||A.tag===4}function Ig(A){e:for(;;){for(;A.sibling===null;){if(A.return===null||Rb(A.return))return null;A=A.return}for(A.sibling.return=A.return,A=A.sibling;A.tag!==5&&A.tag!==6&&A.tag!==18;){if(A.flags&2||A.child===null||A.tag===4)continue e;A.child.return=A,A=A.child}if(!(A.flags&2))return A.stateNode}}function my(A,R,K){var ae=A.tag;if(ae===5||ae===6)A=A.stateNode,R?K.nodeType===8?K.parentNode.insertBefore(A,R):K.insertBefore(A,R):(K.nodeType===8?(R=K.parentNode,R.insertBefore(A,K)):(R=K,R.appendChild(A)),K=K._reactRootContainer,K!=null||R.onclick!==null||(R.onclick=Sg));else if(ae!==4&&(A=A.child,A!==null))for(my(A,R,K),A=A.sibling;A!==null;)my(A,R,K),A=A.sibling}function mm(A,R,K){var ae=A.tag;if(ae===5||ae===6)A=A.stateNode,R?K.insertBefore(A,R):K.appendChild(A);else if(ae!==4&&(A=A.child,A!==null))for(mm(A,R,K),A=A.sibling;A!==null;)mm(A,R,K),A=A.sibling}var Ed=null,fh=!1;function jc(A,R,K){for(K=K.child;K!==null;)fy(A,R,K),K=K.sibling}function fy(A,R,K){if(Pp&&typeof Pp.onCommitFiberUnmount=="function")try{Pp.onCommitFiberUnmount(Il,K)}catch{}switch(K.tag){case 5:Oh||sf(K,R);case 6:var ae=Ed,Ce=fh;Ed=null,jc(A,R,K),Ed=ae,fh=Ce,Ed!==null&&(fh?(A=Ed,K=K.stateNode,A.nodeType===8?A.parentNode.removeChild(K):A.removeChild(K)):Ed.removeChild(K.stateNode));break;case 18:Ed!==null&&(fh?(A=Ed,K=K.stateNode,A.nodeType===8?Tt(A.parentNode,K):A.nodeType===1&&Tt(A,K),Os(A)):Tt(Ed,K.stateNode));break;case 4:ae=Ed,Ce=fh,Ed=K.stateNode.containerInfo,fh=!0,jc(A,R,K),Ed=ae,fh=Ce;break;case 0:case 11:case 14:case 15:if(!Oh&&(ae=K.updateQueue,ae!==null&&(ae=ae.lastEffect,ae!==null))){Ce=ae=ae.next;do{var Ve=Ce,mt=Ve.destroy;Ve=Ve.tag,mt!==void 0&&((Ve&2)!==0||(Ve&4)!==0)&&CI(K,R,mt),Ce=Ce.next}while(Ce!==ae)}jc(A,R,K);break;case 1:if(!Oh&&(sf(K,R),ae=K.stateNode,typeof ae.componentWillUnmount=="function"))try{ae.props=K.memoizedProps,ae.state=K.memoizedState,ae.componentWillUnmount()}catch(Xt){od(K,R,Xt)}jc(A,R,K);break;case 21:jc(A,R,K);break;case 22:K.mode&1?(Oh=(ae=Oh)||K.memoizedState!==null,jc(A,R,K),Oh=ae):jc(A,R,K);break;default:jc(A,R,K)}}function E0(A){var R=A.updateQueue;if(R!==null){A.updateQueue=null;var K=A.stateNode;K===null&&(K=A.stateNode=new Jk),R.forEach(function(ae){var Ce=Pb.bind(null,A,ae);K.has(ae)||(K.add(ae),ae.then(Ce,Ce))})}}function Hp(A,R){var K=R.deletions;if(K!==null)for(var ae=0;ae<K.length;ae++){var Ce=K[ae];try{var Ve=A,mt=R,Xt=mt;e:for(;Xt!==null;){switch(Xt.tag){case 5:Ed=Xt.stateNode,fh=!1;break e;case 3:Ed=Xt.stateNode.containerInfo,fh=!0;break e;case 4:Ed=Xt.stateNode.containerInfo,fh=!0;break e}Xt=Xt.return}if(Ed===null)throw Error(i(160));fy(Ve,mt,Ce),Ed=null,fh=!1;var Si=Ce.alternate;Si!==null&&(Si.return=null),Ce.return=null}catch(Zi){od(Ce,R,Zi)}}if(R.subtreeFlags&12854)for(R=R.child;R!==null;)UP(R,A),R=R.sibling}function UP(A,R){var K=A.alternate,ae=A.flags;switch(A.tag){case 0:case 11:case 14:case 15:if(Hp(R,A),fm(A),ae&4){try{k_(3,A,A.return),_I(3,A)}catch(Tr){od(A,A.return,Tr)}try{k_(5,A,A.return)}catch(Tr){od(A,A.return,Tr)}}break;case 1:Hp(R,A),fm(A),ae&512&&K!==null&&sf(K,K.return);break;case 5:if(Hp(R,A),fm(A),ae&512&&K!==null&&sf(K,K.return),A.flags&32){var Ce=A.stateNode;try{Ye(Ce,"")}catch(Tr){od(A,A.return,Tr)}}if(ae&4&&(Ce=A.stateNode,Ce!=null)){var Ve=A.memoizedProps,mt=K!==null?K.memoizedProps:Ve,Xt=A.type,Si=A.updateQueue;if(A.updateQueue=null,Si!==null)try{Xt==="input"&&Ve.type==="radio"&&Ve.name!=null&&Ke(Ce,Ve),Qi(Xt,mt);var Zi=Qi(Xt,Ve);for(mt=0;mt<Si.length;mt+=2){var Kn=Si[mt],Zn=Si[mt+1];Kn==="style"?Ii(Ce,Zn):Kn==="dangerouslySetInnerHTML"?gt(Ce,Zn):Kn==="children"?Ye(Ce,Zn):x(Ce,Kn,Zn,Zi)}switch(Xt){case"input":ot(Ce,Ve);break;case"textarea":yt(Ce,Ve);break;case"select":var Gn=Ce._wrapperState.wasMultiple;Ce._wrapperState.wasMultiple=!!Ve.multiple;var Ka=Ve.value;Ka!=null?Vt(Ce,!!Ve.multiple,Ka,!1):Gn!==!!Ve.multiple&&(Ve.defaultValue!=null?Vt(Ce,!!Ve.multiple,Ve.defaultValue,!0):Vt(Ce,!!Ve.multiple,Ve.multiple?[]:"",!1))}Ce[oI]=Ve}catch(Tr){od(A,A.return,Tr)}}break;case 6:if(Hp(R,A),fm(A),ae&4){if(A.stateNode===null)throw Error(i(162));Ce=A.stateNode,Ve=A.memoizedProps;try{Ce.nodeValue=Ve}catch(Tr){od(A,A.return,Tr)}}break;case 3:if(Hp(R,A),fm(A),ae&4&&K!==null&&K.memoizedState.isDehydrated)try{Os(R.containerInfo)}catch(Tr){od(A,A.return,Tr)}break;case 4:Hp(R,A),fm(A);break;case 13:Hp(R,A),fm(A),Ce=A.child,Ce.flags&8192&&(Ve=Ce.memoizedState!==null,Ce.stateNode.isHidden=Ve,!Ve||Ce.alternate!==null&&Ce.alternate.memoizedState!==null||(ym=za())),ae&4&&E0(A);break;case 22:if(Kn=K!==null&&K.memoizedState!==null,A.mode&1?(Oh=(Zi=Oh)||Kn,Hp(R,A),Oh=Zi):Hp(R,A),fm(A),ae&8192){if(Zi=A.memoizedState!==null,(A.stateNode.isHidden=Zi)&&!Kn&&(A.mode&1)!==0)for(ar=A,Kn=A.child;Kn!==null;){for(Zn=ar=Kn;ar!==null;){switch(Gn=ar,Ka=Gn.child,Gn.tag){case 0:case 11:case 14:case 15:k_(4,Gn,Gn.return);break;case 1:sf(Gn,Gn.return);var br=Gn.stateNode;if(typeof br.componentWillUnmount=="function"){ae=Gn,K=Gn.return;try{R=ae,br.props=R.memoizedProps,br.state=R.memoizedState,br.componentWillUnmount()}catch(Tr){od(ae,K,Tr)}}break;case 5:sf(Gn,Gn.return);break;case 22:if(Gn.memoizedState!==null){Bd(Zn);continue}}Ka!==null?(Ka.return=Gn,ar=Ka):Bd(Zn)}Kn=Kn.sibling}e:for(Kn=null,Zn=A;;){if(Zn.tag===5){if(Kn===null){Kn=Zn;try{Ce=Zn.stateNode,Zi?(Ve=Ce.style,typeof Ve.setProperty=="function"?Ve.setProperty("display","none","important"):Ve.display="none"):(Xt=Zn.stateNode,Si=Zn.memoizedProps.style,mt=Si!=null&&Si.hasOwnProperty("display")?Si.display:null,Xt.style.display=Wt("display",mt))}catch(Tr){od(A,A.return,Tr)}}}else if(Zn.tag===6){if(Kn===null)try{Zn.stateNode.nodeValue=Zi?"":Zn.memoizedProps}catch(Tr){od(A,A.return,Tr)}}else if((Zn.tag!==22&&Zn.tag!==23||Zn.memoizedState===null||Zn===A)&&Zn.child!==null){Zn.child.return=Zn,Zn=Zn.child;continue}if(Zn===A)break e;for(;Zn.sibling===null;){if(Zn.return===null||Zn.return===A)break e;Kn===Zn&&(Kn=null),Zn=Zn.return}Kn===Zn&&(Kn=null),Zn.sibling.return=Zn.return,Zn=Zn.sibling}}break;case 19:Hp(R,A),fm(A),ae&4&&E0(A);break;case 21:break;default:Hp(R,A),fm(A)}}function fm(A){var R=A.flags;if(R&2){try{e:{for(var K=A.return;K!==null;){if(Rb(K)){var ae=K;break e}K=K.return}throw Error(i(160))}switch(ae.tag){case 5:var Ce=ae.stateNode;ae.flags&32&&(Ye(Ce,""),ae.flags&=-33);var Ve=Ig(A);mm(A,Ve,Ce);break;case 3:case 4:var mt=ae.stateNode.containerInfo,Xt=Ig(A);my(A,Xt,mt);break;default:throw Error(i(161))}}catch(Si){od(A,A.return,Si)}A.flags&=-3}R&4096&&(A.flags&=-4097)}function bF(A,R,K){ar=A,zP(A)}function zP(A,R,K){for(var ae=(A.mode&1)!==0;ar!==null;){var Ce=ar,Ve=Ce.child;if(Ce.tag===22&&ae){var mt=Ce.memoizedState!==null||vv;if(!mt){var Xt=Ce.alternate,Si=Xt!==null&&Xt.memoizedState!==null||Oh;Xt=vv;var Zi=Oh;if(vv=mt,(Oh=Si)&&!Zi)for(ar=Ce;ar!==null;)mt=ar,Si=mt.child,mt.tag===22&&mt.memoizedState!==null?M_(Ce):Si!==null?(Si.return=mt,ar=Si):M_(Ce);for(;Ve!==null;)ar=Ve,zP(Ve),Ve=Ve.sibling;ar=Ce,vv=Xt,Oh=Zi}jp(A)}else(Ce.subtreeFlags&8772)!==0&&Ve!==null?(Ve.return=Ce,ar=Ve):jp(A)}}function jp(A){for(;ar!==null;){var R=ar;if((R.flags&8772)!==0){var K=R.alternate;try{if((R.flags&8772)!==0)switch(R.tag){case 0:case 11:case 15:Oh||_I(5,R);break;case 1:var ae=R.stateNode;if(R.flags&4&&!Oh)if(K===null)ae.componentDidMount();else{var Ce=R.elementType===R.type?K.memoizedProps:mv(R.type,K.memoizedProps);ae.componentDidUpdate(Ce,K.memoizedState,ae.__reactInternalSnapshotBeforeUpdate)}var Ve=R.updateQueue;Ve!==null&&dI(R,Ve,ae);break;case 3:var mt=R.updateQueue;if(mt!==null){if(K=null,R.child!==null)switch(R.child.tag){case 5:K=R.child.stateNode;break;case 1:K=R.child.stateNode}dI(R,mt,K)}break;case 5:var Xt=R.stateNode;if(K===null&&R.flags&4){K=Xt;var Si=R.memoizedProps;switch(R.type){case"button":case"input":case"select":case"textarea":Si.autoFocus&&K.focus();break;case"img":Si.src&&(K.src=Si.src)}}break;case 6:break;case 4:break;case 12:break;case 13:if(R.memoizedState===null){var Zi=R.alternate;if(Zi!==null){var Kn=Zi.memoizedState;if(Kn!==null){var Zn=Kn.dehydrated;Zn!==null&&Os(Zn)}}}break;case 19:case 17:case 21:case 22:case 23:case 25:break;default:throw Error(i(163))}Oh||R.flags&512&&R_(R)}catch(Gn){od(R,R.return,Gn)}}if(R===A){ar=null;break}if(K=R.sibling,K!==null){K.return=R.return,ar=K;break}ar=R.return}}function Bd(A){for(;ar!==null;){var R=ar;if(R===A){ar=null;break}var K=R.sibling;if(K!==null){K.return=R.return,ar=K;break}ar=R.return}}function M_(A){for(;ar!==null;){var R=ar;try{switch(R.tag){case 0:case 11:case 15:var K=R.return;try{_I(4,R)}catch(Si){od(R,K,Si)}break;case 1:var ae=R.stateNode;if(typeof ae.componentDidMount=="function"){var Ce=R.return;try{ae.componentDidMount()}catch(Si){od(R,Ce,Si)}}var Ve=R.return;try{R_(R)}catch(Si){od(R,Ve,Si)}break;case 5:var mt=R.return;try{R_(R)}catch(Si){od(R,mt,Si)}}}catch(Si){od(R,R.return,Si)}if(R===A){ar=null;break}var Xt=R.sibling;if(Xt!==null){Xt.return=R.return,ar=Xt;break}ar=R.return}}var ZO=Math.ceil,HT=B.ReactCurrentDispatcher,jT=B.ReactCurrentOwner,Lc=B.ReactCurrentBatchConfig,gs=0,Fd=null,ad=null,vh=0,Gp=0,A0=Qm(0),su=0,I0=null,CS=0,P_=0,Qk=0,EI=null,vm=null,ym=0,w0=1/0,Sm=null,GT=!1,_S=null,ES=null,AI=!1,wg=null,AS=0,vy=0,cl=null,Mb=-1,rd=0;function Iu(){return(gs&6)!==0?za():Mb!==-1?Mb:Mb=za()}function yy(A){return(A.mode&1)===0?1:(gs&2)!==0&&vh!==0?vh&-vh:dv.transition!==null?(rd===0&&(rd=jo()),rd):(A=fl,A!==0||(A=window.event,A=A===void 0?16:gb(A.type)),A)}function sp(A,R,K,ae){if(50<vy)throw vy=0,cl=null,Error(i(185));Zh(A,K,ae),((gs&2)===0||A!==Fd)&&(A===Fd&&((gs&2)===0&&(P_|=K),su===4&&lf(A,vh)),qp(A,ae),K===1&&gs===0&&(R.mode&1)===0&&(w0=za()+500,hS&&Hu()))}function qp(A,R){var K=A.callbackNode;Xo(A,R);var ae=im(A,A===Fd?vh:0);if(ae===0)K!==null&&Fn(K),A.callbackNode=null,A.callbackPriority=0;else if(R=ae&-ae,A.callbackPriority!==R){if(K!=null&&Fn(K),R===1)A.tag===0?ry(Xk.bind(null,A)):g_(Xk.bind(null,A)),rv(function(){(gs&6)===0&&Hu()}),K=null;else{switch(i_(ae)){case 1:K=ns;break;case 4:K=Uu;break;case 16:K=ml;break;case 536870912:K=Xd;break;default:K=ml}K=O_(K,II.bind(null,A))}A.callbackPriority=R,A.callbackNode=K}}function II(A,R){if(Mb=-1,rd=0,(gs&6)!==0)throw Error(i(327));var K=A.callbackNode;if(L_()&&A.callbackNode!==K)return null;var ae=im(A,A===Fd?vh:0);if(ae===0)return null;if((ae&30)!==0||(ae&A.expiredLanes)!==0||R)R=k0(A,ae);else{R=ae;var Ce=gs;gs|=2;var Ve=wI();(Fd!==A||vh!==R)&&(Sm=null,w0=za()+500,Sy(A,R));do try{HP();break}catch(Xt){XO(A,Xt)}while(!0);uv(),HT.current=Ve,gs=Ce,ad!==null?R=0:(Fd=null,vh=0,R=su)}if(R!==0){if(R===2&&(Ce=Qh(A),Ce!==0&&(ae=Ce,R=D_(A,Ce))),R===1)throw K=I0,Sy(A,0),lf(A,ae),qp(A,za()),K;if(R===6)lf(A,ae);else{if(Ce=A.current.alternate,(ae&30)===0&&!Zk(Ce)&&(R=k0(A,ae),R===2&&(Ve=Qh(A),Ve!==0&&(ae=Ve,R=D_(A,Ve))),R===1))throw K=I0,Sy(A,0),lf(A,ae),qp(A,za()),K;switch(A.finishedWork=Ce,A.finishedLanes=ae,R){case 0:case 1:throw Error(i(345));case 2:qT(A,vm,Sm);break;case 3:if(lf(A,ae),(ae&130023424)===ae&&(R=ym+500-za(),10<R)){if(im(A,0)!==0)break;if(Ce=A.suspendedLanes,(Ce&ae)!==ae){Iu(),A.pingedLanes|=A.suspendedLanes&Ce;break}A.timeoutHandle=aI(qT.bind(null,A,vm,Sm),R);break}qT(A,vm,Sm);break;case 4:if(lf(A,ae),(ae&4194240)===ae)break;for(R=A.eventTimes,Ce=-1;0<ae;){var mt=31-td(ae);Ve=1<<mt,mt=R[mt],mt>Ce&&(Ce=mt),ae&=~Ve}if(ae=Ce,ae=za()-ae,ae=(120>ae?120:480>ae?480:1080>ae?1080:1920>ae?1920:3e3>ae?3e3:4320>ae?4320:1960*ZO(ae/1960))-ae,10<ae){A.timeoutHandle=aI(qT.bind(null,A,vm,Sm),ae);break}qT(A,vm,Sm);break;case 5:qT(A,vm,Sm);break;default:throw Error(i(329))}}}return qp(A,za()),A.callbackNode===K?II.bind(null,A):null}function D_(A,R){var K=EI;return A.current.memoizedState.isDehydrated&&(Sy(A,R).flags|=256),A=k0(A,R),A!==2&&(R=vm,vm=K,R!==null&&yv(R)),A}function yv(A){vm===null?vm=A:vm.push.apply(vm,A)}function Zk(A){for(var R=A;;){if(R.flags&16384){var K=R.updateQueue;if(K!==null&&(K=K.stores,K!==null))for(var ae=0;ae<K.length;ae++){var Ce=K[ae],Ve=Ce.getSnapshot;Ce=Ce.value;try{if(!tu(Ve(),Ce))return!1}catch{return!1}}}if(K=R.child,R.subtreeFlags&16384&&K!==null)K.return=R,R=K;else{if(R===A)break;for(;R.sibling===null;){if(R.return===null||R.return===A)return!0;R=R.return}R.sibling.return=R.return,R=R.sibling}}return!0}function lf(A,R){for(R&=~Qk,R&=~P_,A.suspendedLanes|=R,A.pingedLanes&=~R,A=A.expirationTimes;0<R;){var K=31-td(R),ae=1<<K;A[K]=-1,R&=~ae}}function Xk(A){if((gs&6)!==0)throw Error(i(327));L_();var R=im(A,0);if((R&1)===0)return qp(A,za()),null;var K=k0(A,R);if(A.tag!==0&&K===2){var ae=Qh(A);ae!==0&&(R=ae,K=D_(A,ae))}if(K===1)throw K=I0,Sy(A,0),lf(A,R),qp(A,za()),K;if(K===6)throw Error(i(345));return A.finishedWork=A.current.alternate,A.finishedLanes=R,qT(A,vm,Sm),qp(A,za()),null}function eR(A,R){var K=gs;gs|=1;try{return A(R)}finally{gs=K,gs===0&&(w0=za()+500,hS&&Hu())}}function IS(A){wg!==null&&wg.tag===0&&(gs&6)===0&&L_();var R=gs;gs|=1;var K=Lc.transition,ae=fl;try{if(Lc.transition=null,fl=1,A)return A()}finally{fl=ae,Lc.transition=K,gs=R,(gs&6)===0&&Hu()}}function VP(){Gp=A0.current,fc(A0)}function Sy(A,R){A.finishedWork=null,A.finishedLanes=0;var K=A.timeoutHandle;if(K!==-1&&(A.timeoutHandle=-1,rI(K)),ad!==null)for(K=ad.return;K!==null;){var ae=K;switch(Np(ae),ae.tag){case 1:ae=ae.type.childContextTypes,ae!=null&&Hc();break;case 3:S_(),fc(iu),fc(kl),Jr();break;case 5:Hk(ae);break;case 4:S_();break;case 13:fc(nd);break;case 19:fc(nd);break;case 10:Ab(ae.type._context);break;case 22:case 23:VP()}K=K.return}if(Fd=A,ad=A=Db(A.current,null),vh=Gp=R,su=0,I0=null,Qk=P_=CS=0,vm=EI=null,Fp!==null){for(R=0;R<Fp.length;R++)if(K=Fp[R],ae=K.interleaved,ae!==null){K.interleaved=null;var Ce=ae.next,Ve=K.pending;if(Ve!==null){var mt=Ve.next;Ve.next=Ce,ae.next=mt}K.pending=ae}Fp=null}return A}function XO(A,R){do{var K=ad;try{if(uv(),ps.current=gv,Xm){for(var ae=Hl.memoizedState;ae!==null;){var Ce=ae.queue;Ce!==null&&(Ce.pending=null),ae=ae.next}Xm=!1}if(Sc=0,gh=Zl=Hl=null,ll=!1,_d=0,jT.current=null,K===null||K.return===null){su=1,I0=R,ad=null;break}e:{var Ve=A,mt=K.return,Xt=K,Si=R;if(R=vh,Xt.flags|=32768,Si!==null&&typeof Si=="object"&&typeof Si.then=="function"){var Zi=Si,Kn=Xt,Zn=Kn.tag;if((Kn.mode&1)===0&&(Zn===0||Zn===11||Zn===15)){var Gn=Kn.alternate;Gn?(Kn.updateQueue=Gn.updateQueue,Kn.memoizedState=Gn.memoizedState,Kn.lanes=Gn.lanes):(Kn.updateQueue=null,Kn.memoizedState=null)}var Ka=Gk(mt);if(Ka!==null){Ka.flags&=-257,rf(Ka,mt,Xt,Ve,R),Ka.mode&1&&af(Ve,Zi,R),R=Ka,Si=Zi;var br=R.updateQueue;if(br===null){var Tr=new Set;Tr.add(Si),R.updateQueue=Tr}else br.add(Si);break e}else{if((R&1)===0){af(Ve,Zi,R),tR();break e}Si=Error(i(426))}}else if(Ac&&Xt.mode&1){var Ud=Gk(mt);if(Ud!==null){(Ud.flags&65536)===0&&(Ud.flags|=256),rf(Ud,mt,Xt,Ve,R),Zm($T(Si,Xt));break e}}Ve=Si=$T(Si,Xt),su!==4&&(su=2),EI===null?EI=[Ve]:EI.push(Ve),Ve=mt;do{switch(Ve.tag){case 3:Ve.flags|=65536,R&=-R,Ve.lanes|=R;var Vi=YO(Ve,Si,R);cI(Ve,Vi);break e;case 1:Xt=Si;var Mi=Ve.type,Yi=Ve.stateNode;if((Ve.flags&128)===0&&(typeof Mi.getDerivedStateFromError=="function"||Yi!==null&&typeof Yi.componentDidCatch=="function"&&(ES===null||!ES.has(Yi)))){Ve.flags|=65536,R&=-R,Ve.lanes|=R;var Jn=vI(Ve,Xt,R);cI(Ve,Jn);break e}}Ve=Ve.return}while(Ve!==null)}jP(K)}catch(Cr){R=Cr,ad===K&&K!==null&&(ad=K=K.return);continue}break}while(!0)}function wI(){var A=HT.current;return HT.current=gv,A===null?gv:A}function tR(){(su===0||su===3||su===2)&&(su=4),Fd===null||(CS&268435455)===0&&(P_&268435455)===0||lf(Fd,vh)}function k0(A,R){var K=gs;gs|=2;var ae=wI();(Fd!==A||vh!==R)&&(Sm=null,Sy(A,R));do try{$P();break}catch(Ce){XO(A,Ce)}while(!0);if(uv(),gs=K,HT.current=ae,ad!==null)throw Error(i(261));return Fd=null,vh=0,su}function $P(){for(;ad!==null;)kI(ad)}function HP(){for(;ad!==null&&!Or();)kI(ad)}function kI(A){var R=RI(A.alternate,A,Gp);A.memoizedProps=A.pendingProps,R===null?jP(A):ad=R,jT.current=null}function jP(A){var R=A;do{var K=R.alternate;if(A=R.return,(R.flags&32768)===0){if(K=w_(K,R,Gp),K!==null){ad=K;return}}else{if(K=TI(K,R),K!==null){K.flags&=32767,ad=K;return}if(A!==null)A.flags|=32768,A.subtreeFlags=0,A.deletions=null;else{su=6,ad=null;return}}if(R=R.sibling,R!==null){ad=R;return}ad=R=A}while(R!==null);su===0&&(su=5)}function qT(A,R,K){var ae=fl,Ce=Lc.transition;try{Lc.transition=null,fl=1,e1(A,R,K,ae)}finally{Lc.transition=Ce,fl=ae}return null}function e1(A,R,K,ae){do L_();while(wg!==null);if((gs&6)!==0)throw Error(i(327));K=A.finishedWork;var Ce=A.finishedLanes;if(K===null)return null;if(A.finishedWork=null,A.finishedLanes=0,K===A.current)throw Error(i(177));A.callbackNode=null,A.callbackPriority=0;var Ve=K.lanes|K.childLanes;if(Kv(A,Ve),A===Fd&&(ad=Fd=null,vh=0),(K.subtreeFlags&2064)===0&&(K.flags&2064)===0||AI||(AI=!0,O_(ml,function(){return L_(),null})),Ve=(K.flags&15990)!==0,(K.subtreeFlags&15990)!==0||Ve){Ve=Lc.transition,Lc.transition=null;var mt=fl;fl=1;var Xt=gs;gs|=4,jT.current=null,Yk(A,K),UP(K,A),i0(iy),bd=!!p_,iy=p_=null,A.current=K,bF(K),Co(),gs=Xt,fl=mt,Lc.transition=Ve}else A.current=K;if(AI&&(AI=!1,wg=A,AS=Ce),Ve=A.pendingLanes,Ve===0&&(ES=null),as(K.stateNode),qp(A,za()),R!==null)for(ae=A.onRecoverableError,K=0;K<R.length;K++)Ce=R[K],ae(Ce.value,{componentStack:Ce.stack,digest:Ce.digest});if(GT)throw GT=!1,A=_S,_S=null,A;return(AS&1)!==0&&A.tag!==0&&L_(),Ve=A.pendingLanes,(Ve&1)!==0?A===cl?vy++:(vy=0,cl=A):vy=0,Hu(),null}function L_(){if(wg!==null){var A=i_(AS),R=Lc.transition,K=fl;try{if(Lc.transition=null,fl=16>A?16:A,wg===null)var ae=!1;else{if(A=wg,wg=null,AS=0,(gs&6)!==0)throw Error(i(331));var Ce=gs;for(gs|=4,ar=A.current;ar!==null;){var Ve=ar,mt=Ve.child;if((ar.flags&16)!==0){var Xt=Ve.deletions;if(Xt!==null){for(var Si=0;Si<Xt.length;Si++){var Zi=Xt[Si];for(ar=Zi;ar!==null;){var Kn=ar;switch(Kn.tag){case 0:case 11:case 15:k_(8,Kn,Ve)}var Zn=Kn.child;if(Zn!==null)Zn.return=Kn,ar=Zn;else for(;ar!==null;){Kn=ar;var Gn=Kn.sibling,Ka=Kn.return;if(_0(Kn),Kn===Zi){ar=null;break}if(Gn!==null){Gn.return=Ka,ar=Gn;break}ar=Ka}}}var br=Ve.alternate;if(br!==null){var Tr=br.child;if(Tr!==null){br.child=null;do{var Ud=Tr.sibling;Tr.sibling=null,Tr=Ud}while(Tr!==null)}}ar=Ve}}if((Ve.subtreeFlags&2064)!==0&&mt!==null)mt.return=Ve,ar=mt;else e:for(;ar!==null;){if(Ve=ar,(Ve.flags&2048)!==0)switch(Ve.tag){case 0:case 11:case 15:k_(9,Ve,Ve.return)}var Vi=Ve.sibling;if(Vi!==null){Vi.return=Ve.return,ar=Vi;break e}ar=Ve.return}}var Mi=A.current;for(ar=Mi;ar!==null;){mt=ar;var Yi=mt.child;if((mt.subtreeFlags&2064)!==0&&Yi!==null)Yi.return=mt,ar=Yi;else e:for(mt=Mi;ar!==null;){if(Xt=ar,(Xt.flags&2048)!==0)try{switch(Xt.tag){case 0:case 11:case 15:_I(9,Xt)}}catch(Cr){od(Xt,Xt.return,Cr)}if(Xt===mt){ar=null;break e}var Jn=Xt.sibling;if(Jn!==null){Jn.return=Xt.return,ar=Jn;break e}ar=Xt.return}}if(gs=Ce,Hu(),Pp&&typeof Pp.onPostCommitFiberRoot=="function")try{Pp.onPostCommitFiberRoot(Il,A)}catch{}ae=!0}return ae}finally{fl=K,Lc.transition=R}}return!1}function t1(A,R,K){R=$T(K,R),R=YO(A,R,1),A=hv(A,R,1),R=Iu(),A!==null&&(Zh(A,1,R),qp(A,R))}function od(A,R,K){if(A.tag===3)t1(A,A,K);else for(;R!==null;){if(R.tag===3){t1(R,A,K);break}else if(R.tag===1){var ae=R.stateNode;if(typeof R.type.getDerivedStateFromError=="function"||typeof ae.componentDidCatch=="function"&&(ES===null||!ES.has(ae))){A=$T(K,A),A=vI(R,A,1),R=hv(R,A,1),A=Iu(),R!==null&&(Zh(R,1,A),qp(R,A));break}}R=R.return}}function i1(A,R,K){var ae=A.pingCache;ae!==null&&ae.delete(R),R=Iu(),A.pingedLanes|=A.suspendedLanes&K,Fd===A&&(vh&K)===K&&(su===4||su===3&&(vh&130023424)===vh&&500>za()-ym?Sy(A,0):Qk|=K),qp(A,R)}function n1(A,R){R===0&&((A.mode&1)===0?R=1:(R=Dp,Dp<<=1,(Dp&130023424)===0&&(Dp=4194304)));var K=Iu();A=Up(A,R),A!==null&&(Zh(A,R,K),qp(A,K))}function iR(A){var R=A.memoizedState,K=0;R!==null&&(K=R.retryLane),n1(A,K)}function Pb(A,R){var K=0;switch(A.tag){case 13:var ae=A.stateNode,Ce=A.memoizedState;Ce!==null&&(K=Ce.retryLane);break;case 19:ae=A.stateNode;break;default:throw Error(i(314))}ae!==null&&ae.delete(R),n1(A,K)}var RI;RI=function(A,R,K){if(A!==null)if(A.memoizedProps!==R.pendingProps||iu.current)ou=!0;else{if((A.lanes&K)===0&&(R.flags&128)===0)return ou=!1,bI(A,R,K);ou=(A.flags&131072)!==0}else ou=!1,Ac&&(R.flags&1048576)!==0&&m_(R,rp,R.index);switch(R.lanes=0,R.tag){case 2:var ae=R.type;of(A,R),A=R.pendingProps;var Ce=ap(R,kl.current);Cd(R,K),Ce=dm(null,R,ae,A,Ce,K);var Ve=op();return R.flags|=1,typeof Ce=="object"&&Ce!==null&&typeof Ce.render=="function"&&Ce.$$typeof===void 0?(R.tag=1,R.memoizedState=null,R.updateQueue=null,Dc(ae)?(Ve=!0,Dh(R)):Ve=!1,R.memoizedState=Ce.state!==null&&Ce.state!==void 0?Ce.state:null,BP(R),Ce.updater=mI,R.stateNode=Ce,Ce._reactInternals=R,v0(R,ae,A,K),R=Yr(null,R,ae,!0,Ve,K)):(R.tag=0,Ac&&Ve&&sy(R),qu(null,R,Ce,K),R=R.child),R;case 16:ae=R.elementType;e:{switch(of(A,R),A=R.pendingProps,Ce=ae._init,ae=Ce(ae._payload),R.type=ae,Ce=R.tag=nR(ae),A=mv(ae,A),Ce){case 0:R=b0(null,R,ae,A,K);break e;case 1:R=kb(null,R,ae,A,K);break e;case 11:R=pm(null,R,ae,A,K);break e;case 14:R=zp(null,R,ae,mv(ae.type,A),K);break e}throw Error(i(306,ae,""))}return R;case 0:return ae=R.type,Ce=R.pendingProps,Ce=R.elementType===ae?Ce:mv(ae,Ce),b0(A,R,ae,Ce,K);case 1:return ae=R.type,Ce=R.pendingProps,Ce=R.elementType===ae?Ce:mv(ae,Ce),kb(A,R,ae,Ce,K);case 3:e:{if(bS(R),A===null)throw Error(i(387));ae=R.pendingProps,Ve=R.memoizedState,Ce=Ve.element,lI(A,R),LT(R,ae,null,K);var mt=R.memoizedState;if(ae=mt.element,Ve.isDehydrated)if(Ve={element:ae,isDehydrated:!1,cache:mt.cache,pendingSuspenseBoundaries:mt.pendingSuspenseBoundaries,transitions:mt.transitions},R.updateQueue.baseState=Ve,R.memoizedState=Ve,R.flags&256){Ce=$T(Error(i(423)),R),R=qk(A,R,ae,K,Ce);break e}else if(ae!==Ce){Ce=$T(Error(i(424)),R),R=qk(A,R,ae,K,Ce);break e}else for(xd=ip(R.stateNode.containerInfo.firstChild),ju=R,Ac=!0,au=null,K=Na(R,null,ae,K),R.child=K;K;)K.flags=K.flags&-3|4096,K=K.sibling;else{if(cv(),ae===Ce){R=Vp(A,R,K);break e}qu(A,R,ae,K)}R=R.child}return R;case 5:return $k(R),A===null&&pS(R),ae=R.type,Ce=R.pendingProps,Ve=A!==null?A.memoizedProps:null,mt=Ce.children,nI(ae,Ce)?mt=null:Ve!==null&&nI(ae,Ve)&&(R.flags|=32),yI(A,R),qu(A,R,mt,K),R.child;case 6:return A===null&&pS(R),null;case 13:return fv(A,R,K);case 4:return uI(R,R.stateNode.containerInfo),ae=R.pendingProps,A===null?R.child=Ns(R,null,ae,K):qu(A,R,ae,K),R.child;case 11:return ae=R.type,Ce=R.pendingProps,Ce=R.elementType===ae?Ce:mv(ae,Ce),pm(A,R,ae,Ce,K);case 7:return qu(A,R,R.pendingProps,K),R.child;case 8:return qu(A,R,R.pendingProps.children,K),R.child;case 12:return qu(A,R,R.pendingProps.children,K),R.child;case 10:e:{if(ae=R.type._context,Ce=R.pendingProps,Ve=R.memoizedProps,mt=Ce.value,ra(lm,ae._currentValue),ae._currentValue=mt,Ve!==null)if(tu(Ve.value,mt)){if(Ve.children===Ce.children&&!iu.current){R=Vp(A,R,K);break e}}else for(Ve=R.child,Ve!==null&&(Ve.return=R);Ve!==null;){var Xt=Ve.dependencies;if(Xt!==null){mt=Ve.child;for(var Si=Xt.firstContext;Si!==null;){if(Si.context===ae){if(Ve.tag===1){Si=fS(-1,K&-K),Si.tag=2;var Zi=Ve.updateQueue;if(Zi!==null){Zi=Zi.shared;var Kn=Zi.pending;Kn===null?Si.next=Si:(Si.next=Kn.next,Kn.next=Si),Zi.pending=Si}}Ve.lanes|=K,Si=Ve.alternate,Si!==null&&(Si.lanes|=K),DT(Ve.return,K,R),Xt.lanes|=K;break}Si=Si.next}}else if(Ve.tag===10)mt=Ve.type===R.type?null:Ve.child;else if(Ve.tag===18){if(mt=Ve.return,mt===null)throw Error(i(341));mt.lanes|=K,Xt=mt.alternate,Xt!==null&&(Xt.lanes|=K),DT(mt,K,R),mt=Ve.sibling}else mt=Ve.child;if(mt!==null)mt.return=Ve;else for(mt=Ve;mt!==null;){if(mt===R){mt=null;break}if(Ve=mt.sibling,Ve!==null){Ve.return=mt.return,mt=Ve;break}mt=mt.return}Ve=mt}qu(A,R,Ce.children,K),R=R.child}return R;case 9:return Ce=R.type,ae=R.pendingProps.children,Cd(R,K),Ce=cm(Ce),ae=ae(Ce),R.flags|=1,qu(A,R,ae,K),R.child;case 14:return ae=R.type,Ce=mv(ae,R.pendingProps),Ce=mv(ae.type,Ce),zp(A,R,ae,Ce,K);case 15:return Jo(A,R,R.type,R.pendingProps,K);case 17:return ae=R.type,Ce=R.pendingProps,Ce=R.elementType===ae?Ce:mv(ae,Ce),of(A,R),R.tag=1,Dc(ae)?(A=!0,Dh(R)):A=!1,Cd(R,K),f0(R,ae,Ce),v0(R,ae,Ce,K),Yr(null,R,ae,!0,A,K);case 19:return TS(A,R,K);case 22:return I_(A,R,K)}throw Error(i(156,R.tag))};function O_(A,R){return on(A,R)}function GP(A,R,K,ae){this.tag=A,this.key=K,this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null,this.index=0,this.ref=null,this.pendingProps=R,this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null,this.mode=ae,this.subtreeFlags=this.flags=0,this.deletions=null,this.childLanes=this.lanes=0,this.alternate=null}function Wp(A,R,K,ae){return new GP(A,R,K,ae)}function qP(A){return A=A.prototype,!(!A||!A.isReactComponent)}function nR(A){if(typeof A=="function")return qP(A)?1:0;if(A!=null){if(A=A.$$typeof,A===ne)return 11;if(A===Me)return 14}return 2}function Db(A,R){var K=A.alternate;return K===null?(K=Wp(A.tag,R,A.key,A.mode),K.elementType=A.elementType,K.type=A.type,K.stateNode=A.stateNode,K.alternate=A,A.alternate=K):(K.pendingProps=R,K.type=A.type,K.flags=0,K.subtreeFlags=0,K.deletions=null),K.flags=A.flags&14680064,K.childLanes=A.childLanes,K.lanes=A.lanes,K.child=A.child,K.memoizedProps=A.memoizedProps,K.memoizedState=A.memoizedState,K.updateQueue=A.updateQueue,R=A.dependencies,K.dependencies=R===null?null:{lanes:R.lanes,firstContext:R.firstContext},K.sibling=A.sibling,K.index=A.index,K.ref=A.ref,K}function N_(A,R,K,ae,Ce,Ve){var mt=2;if(ae=A,typeof A=="function")qP(A)&&(mt=1);else if(typeof A=="string")mt=5;else e:switch(A){case H:return lu(K.children,Ce,Ve,R);case j:mt=8,Ce|=8;break;case J:return A=Wp(12,K,R,Ce|2),A.elementType=J,A.lanes=Ve,A;case le:return A=Wp(13,K,R,Ce),A.elementType=le,A.lanes=Ve,A;case he:return A=Wp(19,K,R,Ce),A.elementType=he,A.lanes=Ve,A;case pe:return WT(K,Ce,Ve,R);default:if(typeof A=="object"&&A!==null)switch(A.$$typeof){case Z:mt=10;break e;case re:mt=9;break e;case ne:mt=11;break e;case Me:mt=14;break e;case Le:mt=16,ae=null;break e}throw Error(i(130,A==null?A:typeof A,""))}return R=Wp(mt,K,R,Ce),R.elementType=A,R.type=ae,R.lanes=Ve,R}function lu(A,R,K,ae){return A=Wp(7,A,ae,R),A.lanes=K,A}function WT(A,R,K,ae){return A=Wp(22,A,ae,R),A.elementType=pe,A.lanes=K,A.stateNode={isHidden:!1},A}function aR(A,R,K){return A=Wp(6,A,null,R),A.lanes=K,A}function R0(A,R,K){return R=Wp(4,A.children!==null?A.children:[],A.key,R),R.lanes=K,R.stateNode={containerInfo:A.containerInfo,pendingChildren:null,implementation:A.implementation},R}function a1(A,R,K,ae,Ce){this.tag=R,this.containerInfo=A,this.finishedWork=this.pingCache=this.current=this.pendingChildren=null,this.timeoutHandle=-1,this.callbackNode=this.pendingContext=this.context=null,this.callbackPriority=0,this.eventTimes=ZE(0),this.expirationTimes=ZE(-1),this.entangledLanes=this.finishedLanes=this.mutableReadLanes=this.expiredLanes=this.pingedLanes=this.suspendedLanes=this.pendingLanes=0,this.entanglements=ZE(0),this.identifierPrefix=ae,this.onRecoverableError=Ce,this.mutableSourceEagerHydrationData=null}function rR(A,R,K,ae,Ce,Ve,mt,Xt,Si){return A=new a1(A,R,K,Xt,Si),R===1?(R=1,Ve===!0&&(R|=8)):R=0,Ve=Wp(3,null,null,R),A.current=Ve,Ve.stateNode=A,Ve.memoizedState={element:ae,isDehydrated:K,cache:null,transitions:null,pendingSuspenseBoundaries:null},BP(Ve),A}function r1(A,R,K){var ae=3<arguments.length&&arguments[3]!==void 0?arguments[3]:null;return{$$typeof:z,key:ae==null?null:""+ae,children:A,containerInfo:R,implementation:K}}function MI(A){if(!A)return np;A=A._reactInternals;e:{if(Pa(A)!==A||A.tag!==1)throw Error(i(170));var R=A;do{switch(R.tag){case 3:R=R.stateNode.context;break e;case 1:if(Dc(R.type)){R=R.stateNode.__reactInternalMemoizedMergedChildContext;break e}}R=R.return}while(R!==null);throw Error(i(171))}if(A.tag===1){var K=A.type;if(Dc(K))return $l(A,K,R)}return R}function oR(A,R,K,ae,Ce,Ve,mt,Xt,Si){return A=rR(K,ae,!0,A,Ce,Ve,mt,Xt,Si),A.context=MI(null),K=A.current,ae=Iu(),Ce=yy(K),Ve=fS(ae,Ce),Ve.callback=R??null,hv(K,Ve,Ce),A.current.lanes=Ce,Zh(A,Ce,ae),qp(A,ae),A}function sR(A,R,K,ae){var Ce=R.current,Ve=Iu(),mt=yy(Ce);return K=MI(K),R.context===null?R.context=K:R.pendingContext=K,R=fS(Ve,mt),R.payload={element:A},ae=ae===void 0?null:ae,ae!==null&&(R.callback=ae),A=hv(Ce,R,mt),A!==null&&(sp(A,Ce,mt,Ve),v_(A,Ce,mt)),mt}function wS(A){if(A=A.current,!A.child)return null;switch(A.child.tag){case 5:return A.child.stateNode;default:return A.child.stateNode}}function lR(A,R){if(A=A.memoizedState,A!==null&&A.dehydrated!==null){var K=A.retryLane;A.retryLane=K!==0&&K<R?K:R}}function M0(A,R){lR(A,R),(A=A.alternate)&&lR(A,R)}function PI(){return null}var KT=typeof reportError=="function"?reportError:function(A){console.error(A)};function WP(A){this._internalRoot=A}DI.prototype.render=WP.prototype.render=function(A){var R=this._internalRoot;if(R===null)throw Error(i(409));sR(A,R,null,null)},DI.prototype.unmount=WP.prototype.unmount=function(){var A=this._internalRoot;if(A!==null){this._internalRoot=null;var R=A.containerInfo;IS(function(){sR(null,A,null,null)}),R[Tb]=null}};function DI(A){this._internalRoot=A}DI.prototype.unstable_scheduleHydration=function(A){if(A){var R=Do();A={blockedOn:null,target:A,priority:R};for(var K=0;K<Go.length&&R!==0&&R<Go[K].priority;K++);Go.splice(K,0,A),K===0&&fg(A)}};function cR(A){return!(!A||A.nodeType!==1&&A.nodeType!==9&&A.nodeType!==11)}function LI(A){return!(!A||A.nodeType!==1&&A.nodeType!==9&&A.nodeType!==11&&(A.nodeType!==8||A.nodeValue!==" react-mount-point-unstable "))}function o1(){}function KP(A,R,K,ae,Ce){if(Ce){if(typeof ae=="function"){var Ve=ae;ae=function(){var Zi=wS(mt);Ve.call(Zi)}}var mt=oR(R,ae,A,0,null,!1,!1,"",o1);return A._reactRootContainer=mt,A[Tb]=mt.current,ty(A.nodeType===8?A.parentNode:A),IS(),mt}for(;Ce=A.lastChild;)A.removeChild(Ce);if(typeof ae=="function"){var Xt=ae;ae=function(){var Zi=wS(Si);Xt.call(Zi)}}var Si=rR(A,0,!1,null,null,!1,!1,"",o1);return A._reactRootContainer=Si,A[Tb]=Si.current,ty(A.nodeType===8?A.parentNode:A),IS(function(){sR(R,Si,K,ae)}),Si}function by(A,R,K,ae,Ce){var Ve=K._reactRootContainer;if(Ve){var mt=Ve;if(typeof Ce=="function"){var Xt=Ce;Ce=function(){var Si=wS(mt);Xt.call(Si)}}sR(R,mt,A,Ce)}else mt=KP(K,R,A,Ce,ae);return wS(mt)}ol=function(A){switch(A.tag){case 3:var R=A.stateNode;if(R.current.memoizedState.isDehydrated){var K=Zf(R.pendingLanes);K!==0&&(iS(R,K|1),qp(R,za()),(gs&6)===0&&(w0=za()+500,Hu()))}break;case 13:IS(function(){var ae=Up(A,1);if(ae!==null){var Ce=Iu();sp(ae,A,1,Ce)}}),M0(A,1)}},Xh=function(A){if(A.tag===13){var R=Up(A,134217728);if(R!==null){var K=Iu();sp(R,A,134217728,K)}M0(A,134217728)}},ch=function(A){if(A.tag===13){var R=yy(A),K=Up(A,R);if(K!==null){var ae=Iu();sp(K,A,R,ae)}M0(A,R)}},Do=function(){return fl},sl=function(A,R){var K=fl;try{return fl=A,R()}finally{fl=K}},Ti=function(A,R,K){switch(R){case"input":if(ot(A,K),R=K.name,K.type==="radio"&&R!=null){for(K=A;K.parentNode;)K=K.parentNode;for(K=K.querySelectorAll("input[name="+JSON.stringify(""+R)+'][type="radio"]'),R=0;R<K.length;R++){var ae=K[R];if(ae!==A&&ae.form===A.form){var Ce=Nd(ae);if(!Ce)throw Error(i(90));Pt(ae),ot(ae,Ce)}}}break;case"textarea":yt(A,K);break;case"select":R=K.value,R!=null&&Vt(A,!!K.multiple,R,!1)}},pr=eR,Ho=IS;var dR={usingClientEntryPoint:!1,Events:[Ia,Ym,Nd,hr,yn,eR]},x_={findFiberByHostInstance:Cb,bundleType:0,version:"18.3.1",rendererPackageName:"react-dom"},JT={bundleType:x_.bundleType,version:x_.version,rendererPackageName:x_.rendererPackageName,rendererConfig:x_.rendererConfig,overrideHookState:null,overrideHookStateDeletePath:null,overrideHookStateRenamePath:null,overrideProps:null,overridePropsDeletePath:null,overridePropsRenamePath:null,setErrorHandler:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:B.ReactCurrentDispatcher,findHostInstanceByFiber:function(A){return A=aa(A),A===null?null:A.stateNode},findFiberByHostInstance:x_.findFiberByHostInstance||PI,findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null,reconcilerVersion:"18.3.1-next-f1338f8080-20240426"};if(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__<"u"){var Ty=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(!Ty.isDisabled&&Ty.supportsFiber)try{Il=Ty.inject(JT),Pp=Ty}catch{}}return nT.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=dR,nT.createPortal=function(A,R){var K=2<arguments.length&&arguments[2]!==void 0?arguments[2]:null;if(!cR(R))throw Error(i(200));return r1(A,R,null,K)},nT.createRoot=function(A,R){if(!cR(A))throw Error(i(299));var K=!1,ae="",Ce=KT;return R!=null&&(R.unstable_strictMode===!0&&(K=!0),R.identifierPrefix!==void 0&&(ae=R.identifierPrefix),R.onRecoverableError!==void 0&&(Ce=R.onRecoverableError)),R=rR(A,1,!1,null,null,K,!1,ae,Ce),A[Tb]=R.current,ty(A.nodeType===8?A.parentNode:A),new WP(R)},nT.findDOMNode=function(A){if(A==null)return null;if(A.nodeType===1)return A;var R=A._reactInternals;if(R===void 0)throw typeof A.render=="function"?Error(i(188)):(A=Object.keys(A).join(","),Error(i(268,A)));return A=aa(R),A=A===null?null:A.stateNode,A},nT.flushSync=function(A){return IS(A)},nT.hydrate=function(A,R,K){if(!LI(R))throw Error(i(200));return by(null,A,R,!0,K)},nT.hydrateRoot=function(A,R,K){if(!cR(A))throw Error(i(405));var ae=K!=null&&K.hydratedSources||null,Ce=!1,Ve="",mt=KT;if(K!=null&&(K.unstable_strictMode===!0&&(Ce=!0),K.identifierPrefix!==void 0&&(Ve=K.identifierPrefix),K.onRecoverableError!==void 0&&(mt=K.onRecoverableError)),R=oR(R,null,A,1,K??null,Ce,!1,Ve,mt),A[Tb]=R.current,ty(A),ae)for(A=0;A<ae.length;A++)K=ae[A],Ce=K._getVersion,Ce=Ce(K._source),R.mutableSourceEagerHydrationData==null?R.mutableSourceEagerHydrationData=[K,Ce]:R.mutableSourceEagerHydrationData.push(K,Ce);return new DI(R)},nT.render=function(A,R,K){if(!LI(R))throw Error(i(200));return by(null,A,R,!1,K)},nT.unmountComponentAtNode=function(A){if(!LI(A))throw Error(i(40));return A._reactRootContainer?(IS(function(){by(null,null,A,!1,function(){A._reactRootContainer=null,A[Tb]=null})}),!0):!1},nT.unstable_batchedUpdates=eR,nT.unstable_renderSubtreeIntoContainer=function(A,R,K,ae){if(!LI(K))throw Error(i(200));if(A==null||A._reactInternals===void 0)throw Error(i(38));return by(A,R,K,!1,ae)},nT.version="18.3.1-next-f1338f8080-20240426",nT}var aT={};/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */var UCe;function $Qe(){return UCe||(UCe=1,process.env.NODE_ENV!=="production"&&function(){typeof __REACT_DEVTOOLS_GLOBAL_HOOK__<"u"&&typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart=="function"&&__REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error);var t=fM(),e=BCe(),i=t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,r=!1;function o(v){r=v}function l(v){if(!r){for(var S=arguments.length,P=new Array(S>1?S-1:0),G=1;G<S;G++)P[G-1]=arguments[G];h("warn",v,P)}}function d(v){if(!r){for(var S=arguments.length,P=new Array(S>1?S-1:0),G=1;G<S;G++)P[G-1]=arguments[G];h("error",v,P)}}function h(v,S,P){{var G=i.ReactDebugCurrentFrame,Q=G.getStackAddendum();Q!==""&&(S+="%s",P=P.concat([Q]));var me=P.map(function(De){return String(De)});me.unshift("Warning: "+S),Function.prototype.apply.call(console[v],console,me)}}var p=0,g=1,f=2,y=3,T=4,C=5,E=6,I=7,w=8,D=9,F=10,x=11,B=12,L=13,z=14,H=15,j=16,J=17,Z=18,re=19,ne=21,le=22,he=23,Me=24,Le=25,pe=!0,te=!1,Se=!1,ce=!1,X=!1,ve=!0,Te=!0,Be=!0,qe=!0,Ge=new Set,tt={},ct={};function Mt(v,S){ht(v,S),ht(v+"Capture",S)}function ht(v,S){tt[v]&&d("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.",v),tt[v]=S;{var P=v.toLowerCase();ct[P]=v,v==="onDoubleClick"&&(ct.ondblclick=v)}for(var G=0;G<S.length;G++)Ge.add(S[G])}var vt=typeof window<"u"&&typeof window.document<"u"&&typeof window.document.createElement<"u",Pt=Object.prototype.hasOwnProperty;function ni(v){{var S=typeof Symbol=="function"&&Symbol.toStringTag,P=S&&v[Symbol.toStringTag]||v.constructor.name||"Object";return P}}function Zt(v){try{return it(v),!1}catch{return!0}}function it(v){return""+v}function Ke(v,S){if(Zt(v))return d("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.",S,ni(v)),it(v)}function ot(v){if(Zt(v))return d("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.",ni(v)),it(v)}function Ht(v,S){if(Zt(v))return d("The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.",S,ni(v)),it(v)}function jt(v,S){if(Zt(v))return d("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.",S,ni(v)),it(v)}function Nt(v){if(Zt(v))return d("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.",ni(v)),it(v)}function Vt(v){if(Zt(v))return d("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before before using it here.",ni(v)),it(v)}var $t=0,dt=1,yt=2,kt=3,je=4,Ae=5,xe=6,gt=":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD",Ye=gt+"\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040",Fe=new RegExp("^["+gt+"]["+Ye+"]*$"),St={},Wt={};function Ii(v){return Pt.call(Wt,v)?!0:Pt.call(St,v)?!1:Fe.test(v)?(Wt[v]=!0,!0):(St[v]=!0,d("Invalid attribute name: `%s`",v),!1)}function en(v,S,P){return S!==null?S.type===$t:P?!1:v.length>2&&(v[0]==="o"||v[0]==="O")&&(v[1]==="n"||v[1]==="N")}function sn(v,S,P,G){if(P!==null&&P.type===$t)return!1;switch(typeof S){case"function":case"symbol":return!0;case"boolean":{if(G)return!1;if(P!==null)return!P.acceptsBooleans;var Q=v.toLowerCase().slice(0,5);return Q!=="data-"&&Q!=="aria-"}default:return!1}}function Qi(v,S,P,G){if(S===null||typeof S>"u"||sn(v,S,P,G))return!0;if(G)return!1;if(P!==null)switch(P.type){case kt:return!S;case je:return S===!1;case Ae:return isNaN(S);case xe:return isNaN(S)||S<1}return!1}function qt(v){return Ti.hasOwnProperty(v)?Ti[v]:null}function ri(v,S,P,G,Q,me,De){this.acceptsBooleans=S===yt||S===kt||S===je,this.attributeName=G,this.attributeNamespace=Q,this.mustUseProperty=P,this.propertyName=v,this.type=S,this.sanitizeURL=me,this.removeEmptyString=De}var Ti={},rn=["children","dangerouslySetInnerHTML","defaultValue","defaultChecked","innerHTML","suppressContentEditableWarning","suppressHydrationWarning","style"];rn.forEach(function(v){Ti[v]=new ri(v,$t,!1,v,null,!1,!1)}),[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(v){var S=v[0],P=v[1];Ti[S]=new ri(S,dt,!1,P,null,!1,!1)}),["contentEditable","draggable","spellCheck","value"].forEach(function(v){Ti[v]=new ri(v,yt,!1,v.toLowerCase(),null,!1,!1)}),["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(v){Ti[v]=new ri(v,yt,!1,v,null,!1,!1)}),["allowFullScreen","async","autoFocus","autoPlay","controls","default","defer","disabled","disablePictureInPicture","disableRemotePlayback","formNoValidate","hidden","loop","noModule","noValidate","open","playsInline","readOnly","required","reversed","scoped","seamless","itemScope"].forEach(function(v){Ti[v]=new ri(v,kt,!1,v.toLowerCase(),null,!1,!1)}),["checked","multiple","muted","selected"].forEach(function(v){Ti[v]=new ri(v,kt,!0,v,null,!1,!1)}),["capture","download"].forEach(function(v){Ti[v]=new ri(v,je,!1,v,null,!1,!1)}),["cols","rows","size","span"].forEach(function(v){Ti[v]=new ri(v,xe,!1,v,null,!1,!1)}),["rowSpan","start"].forEach(function(v){Ti[v]=new ri(v,Ae,!1,v.toLowerCase(),null,!1,!1)});var Hn=/[\-\:]([a-z])/g,ha=function(v){return v[1].toUpperCase()};["accent-height","alignment-baseline","arabic-form","baseline-shift","cap-height","clip-path","clip-rule","color-interpolation","color-interpolation-filters","color-profile","color-rendering","dominant-baseline","enable-background","fill-opacity","fill-rule","flood-color","flood-opacity","font-family","font-size","font-size-adjust","font-stretch","font-style","font-variant","font-weight","glyph-name","glyph-orientation-horizontal","glyph-orientation-vertical","horiz-adv-x","horiz-origin-x","image-rendering","letter-spacing","lighting-color","marker-end","marker-mid","marker-start","overline-position","overline-thickness","paint-order","panose-1","pointer-events","rendering-intent","shape-rendering","stop-color","stop-opacity","strikethrough-position","strikethrough-thickness","stroke-dasharray","stroke-dashoffset","stroke-linecap","stroke-linejoin","stroke-miterlimit","stroke-opacity","stroke-width","text-anchor","text-decoration","text-rendering","underline-position","underline-thickness","unicode-bidi","unicode-range","units-per-em","v-alphabetic","v-hanging","v-ideographic","v-mathematical","vector-effect","vert-adv-y","vert-origin-x","vert-origin-y","word-spacing","writing-mode","xmlns:xlink","x-height"].forEach(function(v){var S=v.replace(Hn,ha);Ti[S]=new ri(S,dt,!1,v,null,!1,!1)}),["xlink:actuate","xlink:arcrole","xlink:role","xlink:show","xlink:title","xlink:type"].forEach(function(v){var S=v.replace(Hn,ha);Ti[S]=new ri(S,dt,!1,v,"http://www.w3.org/1999/xlink",!1,!1)}),["xml:base","xml:lang","xml:space"].forEach(function(v){var S=v.replace(Hn,ha);Ti[S]=new ri(S,dt,!1,v,"http://www.w3.org/XML/1998/namespace",!1,!1)}),["tabIndex","crossOrigin"].forEach(function(v){Ti[v]=new ri(v,dt,!1,v.toLowerCase(),null,!1,!1)});var hr="xlinkHref";Ti[hr]=new ri("xlinkHref",dt,!1,"xlink:href","http://www.w3.org/1999/xlink",!0,!1),["src","href","action","formAction"].forEach(function(v){Ti[v]=new ri(v,dt,!1,v.toLowerCase(),null,!0,!0)});var yn=/^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i,pr=!1;function Ho(v){!pr&&yn.test(v)&&(pr=!0,d("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.",JSON.stringify(v)))}function Rr(v,S,P,G){if(G.mustUseProperty){var Q=G.propertyName;return v[Q]}else{Ke(P,S),G.sanitizeURL&&Ho(""+P);var me=G.attributeName,De=null;if(G.type===je){if(v.hasAttribute(me)){var We=v.getAttribute(me);return We===""?!0:Qi(S,P,G,!1)?We:We===""+P?P:We}}else if(v.hasAttribute(me)){if(Qi(S,P,G,!1))return v.getAttribute(me);if(G.type===kt)return P;De=v.getAttribute(me)}return Qi(S,P,G,!1)?De===null?P:De:De===""+P?P:De}}function La(v,S,P,G){{if(!Ii(S))return;if(!v.hasAttribute(S))return P===void 0?void 0:null;var Q=v.getAttribute(S);return Ke(P,S),Q===""+P?P:Q}}function us(v,S,P,G){var Q=qt(S);if(!en(S,Q,G)){if(Qi(S,P,Q,G)&&(P=null),G||Q===null){if(Ii(S)){var me=S;P===null?v.removeAttribute(me):(Ke(P,S),v.setAttribute(me,""+P))}return}var De=Q.mustUseProperty;if(De){var We=Q.propertyName;if(P===null){var rt=Q.type;v[We]=rt===kt?!1:""}else v[We]=P;return}var _t=Q.attributeName,Ut=Q.attributeNamespace;if(P===null)v.removeAttribute(_t);else{var Di=Q.type,Ri;Di===kt||Di===je&&P===!0?Ri="":(Ke(P,_t),Ri=""+P,Q.sanitizeURL&&Ho(Ri.toString())),Ut?v.setAttributeNS(Ut,_t,Ri):v.setAttribute(_t,Ri)}}}var al=Symbol.for("react.element"),Us=Symbol.for("react.portal"),$r=Symbol.for("react.fragment"),Zd=Symbol.for("react.strict_mode"),rc=Symbol.for("react.profiler"),Yl=Symbol.for("react.provider"),ci=Symbol.for("react.context"),Ai=Symbol.for("react.forward_ref"),pn=Symbol.for("react.suspense"),Bn=Symbol.for("react.suspense_list"),Pa=Symbol.for("react.memo"),qa=Symbol.for("react.lazy"),kr=Symbol.for("react.scope"),Sa=Symbol.for("react.debug_trace_mode"),aa=Symbol.for("react.offscreen"),ti=Symbol.for("react.legacy_hidden"),on=Symbol.for("react.cache"),Fn=Symbol.for("react.tracing_marker"),Or=Symbol.iterator,Co="@@iterator";function za(v){if(v===null||typeof v!="object")return null;var S=Or&&v[Or]||v[Co];return typeof S=="function"?S:null}var Za=Object.assign,ns=0,Uu,ml,Cu,Xd,Il,Pp,as;function td(){}td.__reactDisabledLog=!0;function YA(){{if(ns===0){Uu=console.log,ml=console.info,Cu=console.warn,Xd=console.error,Il=console.group,Pp=console.groupCollapsed,as=console.groupEnd;var v={configurable:!0,enumerable:!0,value:td,writable:!0};Object.defineProperties(console,{info:v,log:v,warn:v,error:v,group:v,groupCollapsed:v,groupEnd:v})}ns++}}function bl(){{if(ns--,ns===0){var v={configurable:!0,enumerable:!0,writable:!0};Object.defineProperties(console,{log:Za({},v,{value:Uu}),info:Za({},v,{value:ml}),warn:Za({},v,{value:Cu}),error:Za({},v,{value:Xd}),group:Za({},v,{value:Il}),groupCollapsed:Za({},v,{value:Pp}),groupEnd:Za({},v,{value:as})})}ns<0&&d("disabledDepth fell below zero. This is a bug in React. Please file an issue.")}}var rl=i.ReactCurrentDispatcher,db;function Dp(v,S,P){{if(db===void 0)try{throw Error()}catch(Q){var G=Q.stack.trim().match(/\n( *(at )?)/);db=G&&G[1]||""}return`
`+db+v}}var Zf=!1,im;{var Ld=typeof WeakMap=="function"?WeakMap:Map;im=new Ld}function Xo(v,S){if(!v||Zf)return"";{var P=im.get(v);if(P!==void 0)return P}var G;Zf=!0;var Q=Error.prepareStackTrace;Error.prepareStackTrace=void 0;var me;me=rl.current,rl.current=null,YA();try{if(S){var De=function(){throw Error()};if(Object.defineProperty(De.prototype,"props",{set:function(){throw Error()}}),typeof Reflect=="object"&&Reflect.construct){try{Reflect.construct(De,[])}catch(tn){G=tn}Reflect.construct(v,[],De)}else{try{De.call()}catch(tn){G=tn}v.call(De.prototype)}}else{try{throw Error()}catch(tn){G=tn}v()}}catch(tn){if(tn&&G&&typeof tn.stack=="string"){for(var We=tn.stack.split(`
`),rt=G.stack.split(`
`),_t=We.length-1,Ut=rt.length-1;_t>=1&&Ut>=0&&We[_t]!==rt[Ut];)Ut--;for(;_t>=1&&Ut>=0;_t--,Ut--)if(We[_t]!==rt[Ut]){if(_t!==1||Ut!==1)do if(_t--,Ut--,Ut<0||We[_t]!==rt[Ut]){var Di=`
`+We[_t].replace(" at new "," at ");return v.displayName&&Di.includes("<anonymous>")&&(Di=Di.replace("<anonymous>",v.displayName)),typeof v=="function"&&im.set(v,Di),Di}while(_t>=1&&Ut>=0);break}}}finally{Zf=!1,rl.current=me,bl(),Error.prepareStackTrace=Q}var Ri=v?v.displayName||v.name:"",Xi=Ri?Dp(Ri):"";return typeof v=="function"&&im.set(v,Xi),Xi}function Qh(v,S,P){return Xo(v,!0)}function jo(v,S,P){return Xo(v,!1)}function ZE(v){var S=v.prototype;return!!(S&&S.isReactComponent)}function Zh(v,S,P){if(v==null)return"";if(typeof v=="function")return Xo(v,ZE(v));if(typeof v=="string")return Dp(v);switch(v){case pn:return Dp("Suspense");case Bn:return Dp("SuspenseList")}if(typeof v=="object")switch(v.$$typeof){case Ai:return jo(v.render);case Pa:return Zh(v.type,S,P);case qa:{var G=v,Q=G._payload,me=G._init;try{return Zh(me(Q),S,P)}catch{}}}return""}function Kv(v){switch(v._debugOwner&&v._debugOwner.type,v._debugSource,v.tag){case C:return Dp(v.type);case j:return Dp("Lazy");case L:return Dp("Suspense");case re:return Dp("SuspenseList");case p:case f:case H:return jo(v.type);case x:return jo(v.type.render);case g:return Qh(v.type);default:return""}}function iS(v){try{var S="",P=v;do S+=Kv(P),P=P.return;while(P);return S}catch(G){return`
Error generating stack: `+G.message+`
`+G.stack}}function fl(v,S,P){var G=v.displayName;if(G)return G;var Q=S.displayName||S.name||"";return Q!==""?P+"("+Q+")":P}function i_(v){return v.displayName||"Context"}function ol(v){if(v==null)return null;if(typeof v.tag=="number"&&d("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."),typeof v=="function")return v.displayName||v.name||null;if(typeof v=="string")return v;switch(v){case $r:return"Fragment";case Us:return"Portal";case rc:return"Profiler";case Zd:return"StrictMode";case pn:return"Suspense";case Bn:return"SuspenseList"}if(typeof v=="object")switch(v.$$typeof){case ci:var S=v;return i_(S)+".Consumer";case Yl:var P=v;return i_(P._context)+".Provider";case Ai:return fl(v,v.render,"ForwardRef");case Pa:var G=v.displayName||null;return G!==null?G:ol(v.type)||"Memo";case qa:{var Q=v,me=Q._payload,De=Q._init;try{return ol(De(me))}catch{return null}}}return null}function Xh(v,S,P){var G=S.displayName||S.name||"";return v.displayName||(G!==""?P+"("+G+")":P)}function ch(v){return v.displayName||"Context"}function Do(v){var S=v.tag,P=v.type;switch(S){case Me:return"Cache";case D:var G=P;return ch(G)+".Consumer";case F:var Q=P;return ch(Q._context)+".Provider";case Z:return"DehydratedFragment";case x:return Xh(P,P.render,"ForwardRef");case I:return"Fragment";case C:return P;case T:return"Portal";case y:return"Root";case E:return"Text";case j:return ol(P);case w:return P===Zd?"StrictMode":"Mode";case le:return"Offscreen";case B:return"Profiler";case ne:return"Scope";case L:return"Suspense";case re:return"SuspenseList";case Le:return"TracingMarker";case g:case p:case J:case f:case z:case H:if(typeof P=="function")return P.displayName||P.name||null;if(typeof P=="string")return P;break}return null}var sl=i.ReactDebugCurrentFrame,zu=null,jm=!1;function Od(){{if(zu===null)return null;var v=zu._debugOwner;if(v!==null&&typeof v<"u")return Do(v)}return null}function nS(){return zu===null?"":iS(zu)}function yo(){sl.getCurrentStack=null,zu=null,jm=!1}function oc(v){sl.getCurrentStack=v===null?null:nS,zu=v,jm=!1}function ub(){return zu}function Go(v){jm=v}function So(v){return""+v}function Xf(v){switch(typeof v){case"boolean":case"number":case"string":case"undefined":return v;case"object":return Vt(v),v;default:return""}}var zs={button:!0,checkbox:!0,image:!0,hidden:!0,radio:!0,reset:!0,submit:!0};function mg(v,S){zs[S.type]||S.onChange||S.onInput||S.readOnly||S.disabled||S.value==null||d("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."),S.onChange||S.readOnly||S.disabled||S.checked==null||d("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.")}function fg(v){var S=v.type,P=v.nodeName;return P&&P.toLowerCase()==="input"&&(S==="checkbox"||S==="radio")}function hb(v){return v._valueTracker}function n_(v){v._valueTracker=null}function Lk(v){var S="";return v&&(fg(v)?S=v.checked?"true":"false":S=v.value),S}function Gm(v){var S=fg(v)?"checked":"value",P=Object.getOwnPropertyDescriptor(v.constructor.prototype,S);Vt(v[S]);var G=""+v[S];if(!(v.hasOwnProperty(S)||typeof P>"u"||typeof P.get!="function"||typeof P.set!="function")){var Q=P.get,me=P.set;Object.defineProperty(v,S,{configurable:!0,get:function(){return Q.call(this)},set:function(We){Vt(We),G=""+We,me.call(this,We)}}),Object.defineProperty(v,S,{enumerable:P.enumerable});var De={getValue:function(){return G},setValue:function(We){Vt(We),G=""+We},stopTracking:function(){n_(v),delete v[S]}};return De}}function Os(v){hb(v)||(v._valueTracker=Gm(v))}function dh(v){if(!v)return!1;var S=hb(v);if(!S)return!0;var P=S.getValue(),G=Lk(v);return G!==P?(S.setValue(G),!0):!1}function bd(v){if(v=v||(typeof document<"u"?document:void 0),typeof v>"u")return null;try{return v.activeElement||v.body}catch{return v.body}}var pb=!1,bT=!1,uh=!1,TT=!1;function a_(v){var S=v.type==="checkbox"||v.type==="radio";return S?v.checked!=null:v.value!=null}function gb(v,S){var P=v,G=S.checked,Q=Za({},S,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:G??P._wrapperState.initialChecked});return Q}function qm(v,S){mg("input",S),S.checked!==void 0&&S.defaultChecked!==void 0&&!bT&&(d("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components",Od()||"A component",S.type),bT=!0),S.value!==void 0&&S.defaultValue!==void 0&&!pb&&(d("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components",Od()||"A component",S.type),pb=!0);var P=v,G=S.defaultValue==null?"":S.defaultValue;P._wrapperState={initialChecked:S.checked!=null?S.checked:S.defaultChecked,initialValue:Xf(S.value!=null?S.value:G),controlled:a_(S)}}function st(v,S){var P=v,G=S.checked;G!=null&&us(P,"checked",G,!1)}function di(v,S){var P=v;{var G=a_(S);!P._wrapperState.controlled&&G&&!TT&&(d("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"),TT=!0),P._wrapperState.controlled&&!G&&!uh&&(d("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"),uh=!0)}st(v,S);var Q=Xf(S.value),me=S.type;if(Q!=null)me==="number"?(Q===0&&P.value===""||P.value!=Q)&&(P.value=So(Q)):P.value!==So(Q)&&(P.value=So(Q));else if(me==="submit"||me==="reset"){P.removeAttribute("value");return}S.hasOwnProperty("value")?no(P,S.type,Q):S.hasOwnProperty("defaultValue")&&no(P,S.type,Xf(S.defaultValue)),S.checked==null&&S.defaultChecked!=null&&(P.defaultChecked=!!S.defaultChecked)}function Gi(v,S,P){var G=v;if(S.hasOwnProperty("value")||S.hasOwnProperty("defaultValue")){var Q=S.type,me=Q==="submit"||Q==="reset";if(me&&(S.value===void 0||S.value===null))return;var De=So(G._wrapperState.initialValue);P||De!==G.value&&(G.value=De),G.defaultValue=De}var We=G.name;We!==""&&(G.name=""),G.defaultChecked=!G.defaultChecked,G.defaultChecked=!!G._wrapperState.initialChecked,We!==""&&(G.name=We)}function un(v,S){var P=v;di(P,S),jn(P,S)}function jn(v,S){var P=S.name;if(S.type==="radio"&&P!=null){for(var G=v;G.parentNode;)G=G.parentNode;Ke(P,"name");for(var Q=G.querySelectorAll("input[name="+JSON.stringify(""+P)+'][type="radio"]'),me=0;me<Q.length;me++){var De=Q[me];if(!(De===v||De.form!==v.form)){var We=dl(De);if(!We)throw new Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");dh(De),di(De,We)}}}}function no(v,S,P){(S!=="number"||bd(v.ownerDocument)!==v)&&(P==null?v.defaultValue=So(v._wrapperState.initialValue):v.defaultValue!==So(P)&&(v.defaultValue=So(P)))}var Oa=!1,Nr=!1,go=!1;function _s(v,S){S.value==null&&(typeof S.children=="object"&&S.children!==null?t.Children.forEach(S.children,function(P){P!=null&&(typeof P=="string"||typeof P=="number"||Nr||(Nr=!0,d("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.")))}):S.dangerouslySetInnerHTML!=null&&(go||(go=!0,d("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.")))),S.selected!=null&&!Oa&&(d("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."),Oa=!0)}function _o(v,S){S.value!=null&&v.setAttribute("value",So(Xf(S.value)))}var Ks=Array.isArray;function Ko(v){return Ks(v)}var Ql;Ql=!1;function hs(){var v=Od();return v?`

Check the render method of \``+v+"`.":""}var mb=["value","defaultValue"];function QA(v){{mg("select",v);for(var S=0;S<mb.length;S++){var P=mb[S];if(v[P]!=null){var G=Ko(v[P]);v.multiple&&!G?d("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s",P,hs()):!v.multiple&&G&&d("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s",P,hs())}}}}function Jv(v,S,P,G){var Q=v.options;if(S){for(var me=P,De={},We=0;We<me.length;We++)De["$"+me[We]]=!0;for(var rt=0;rt<Q.length;rt++){var _t=De.hasOwnProperty("$"+Q[rt].value);Q[rt].selected!==_t&&(Q[rt].selected=_t),_t&&G&&(Q[rt].defaultSelected=!0)}}else{for(var Ut=So(Xf(P)),Di=null,Ri=0;Ri<Q.length;Ri++){if(Q[Ri].value===Ut){Q[Ri].selected=!0,G&&(Q[Ri].defaultSelected=!0);return}Di===null&&!Q[Ri].disabled&&(Di=Q[Ri])}Di!==null&&(Di.selected=!0)}}function XE(v,S){return Za({},S,{value:void 0})}function aS(v,S){var P=v;QA(S),P._wrapperState={wasMultiple:!!S.multiple},S.value!==void 0&&S.defaultValue!==void 0&&!Ql&&(d("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"),Ql=!0)}function nm(v,S){var P=v;P.multiple=!!S.multiple;var G=S.value;G!=null?Jv(P,!!S.multiple,G,!1):S.defaultValue!=null&&Jv(P,!!S.multiple,S.defaultValue,!0)}function Ok(v,S){var P=v,G=P._wrapperState.wasMultiple;P._wrapperState.wasMultiple=!!S.multiple;var Q=S.value;Q!=null?Jv(P,!!S.multiple,Q,!1):G!==!!S.multiple&&(S.defaultValue!=null?Jv(P,!!S.multiple,S.defaultValue,!0):Jv(P,!!S.multiple,S.multiple?[]:"",!1))}function Wm(v,S){var P=v,G=S.value;G!=null&&Jv(P,!!S.multiple,G,!1)}var r_=!1;function e0(v,S){var P=v;if(S.dangerouslySetInnerHTML!=null)throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");var G=Za({},S,{value:void 0,defaultValue:void 0,children:So(P._wrapperState.initialValue)});return G}function CT(v,S){var P=v;mg("textarea",S),S.value!==void 0&&S.defaultValue!==void 0&&!r_&&(d("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components",Od()||"A component"),r_=!0);var G=S.value;if(G==null){var Q=S.children,me=S.defaultValue;if(Q!=null){d("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");{if(me!=null)throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");if(Ko(Q)){if(Q.length>1)throw new Error("<textarea> can only have at most one child.");Q=Q[0]}me=Q}}me==null&&(me=""),G=me}P._wrapperState={initialValue:Xf(G)}}function _T(v,S){var P=v,G=Xf(S.value),Q=Xf(S.defaultValue);if(G!=null){var me=So(G);me!==P.value&&(P.value=me),S.defaultValue==null&&P.defaultValue!==me&&(P.defaultValue=me)}Q!=null&&(P.defaultValue=So(Q))}function Vu(v,S){var P=v,G=P.textContent;G===P._wrapperState.initialValue&&G!==""&&G!==null&&(P.value=G)}function Nk(v,S){_T(v,S)}var hh="http://www.w3.org/1999/xhtml",wP="http://www.w3.org/1998/Math/MathML",ev="http://www.w3.org/2000/svg";function vg(v){switch(v){case"svg":return ev;case"math":return wP;default:return hh}}function fb(v,S){return v==null||v===hh?vg(S):v===ev&&S==="foreignObject"?hh:v}var o_=function(v){return typeof MSApp<"u"&&MSApp.execUnsafeLocalFunction?function(S,P,G,Q){MSApp.execUnsafeLocalFunction(function(){return v(S,P,G,Q)})}:v},ET,Yv=o_(function(v,S){if(v.namespaceURI===ev&&!("innerHTML"in v)){ET=ET||document.createElement("div"),ET.innerHTML="<svg>"+S.valueOf().toString()+"</svg>";for(var P=ET.firstChild;v.firstChild;)v.removeChild(v.firstChild);for(;P.firstChild;)v.appendChild(P.firstChild);return}v.innerHTML=S}),am=1,tv=3,$u=8,vb=9,kP=11,rm=function(v,S){if(S){var P=v.firstChild;if(P&&P===v.lastChild&&P.nodeType===tv){P.nodeValue=S;return}}v.textContent=S},yb={animation:["animationDelay","animationDirection","animationDuration","animationFillMode","animationIterationCount","animationName","animationPlayState","animationTimingFunction"],background:["backgroundAttachment","backgroundClip","backgroundColor","backgroundImage","backgroundOrigin","backgroundPositionX","backgroundPositionY","backgroundRepeat","backgroundSize"],backgroundPosition:["backgroundPositionX","backgroundPositionY"],border:["borderBottomColor","borderBottomStyle","borderBottomWidth","borderImageOutset","borderImageRepeat","borderImageSlice","borderImageSource","borderImageWidth","borderLeftColor","borderLeftStyle","borderLeftWidth","borderRightColor","borderRightStyle","borderRightWidth","borderTopColor","borderTopStyle","borderTopWidth"],borderBlockEnd:["borderBlockEndColor","borderBlockEndStyle","borderBlockEndWidth"],borderBlockStart:["borderBlockStartColor","borderBlockStartStyle","borderBlockStartWidth"],borderBottom:["borderBottomColor","borderBottomStyle","borderBottomWidth"],borderColor:["borderBottomColor","borderLeftColor","borderRightColor","borderTopColor"],borderImage:["borderImageOutset","borderImageRepeat","borderImageSlice","borderImageSource","borderImageWidth"],borderInlineEnd:["borderInlineEndColor","borderInlineEndStyle","borderInlineEndWidth"],borderInlineStart:["borderInlineStartColor","borderInlineStartStyle","borderInlineStartWidth"],borderLeft:["borderLeftColor","borderLeftStyle","borderLeftWidth"],borderRadius:["borderBottomLeftRadius","borderBottomRightRadius","borderTopLeftRadius","borderTopRightRadius"],borderRight:["borderRightColor","borderRightStyle","borderRightWidth"],borderStyle:["borderBottomStyle","borderLeftStyle","borderRightStyle","borderTopStyle"],borderTop:["borderTopColor","borderTopStyle","borderTopWidth"],borderWidth:["borderBottomWidth","borderLeftWidth","borderRightWidth","borderTopWidth"],columnRule:["columnRuleColor","columnRuleStyle","columnRuleWidth"],columns:["columnCount","columnWidth"],flex:["flexBasis","flexGrow","flexShrink"],flexFlow:["flexDirection","flexWrap"],font:["fontFamily","fontFeatureSettings","fontKerning","fontLanguageOverride","fontSize","fontSizeAdjust","fontStretch","fontStyle","fontVariant","fontVariantAlternates","fontVariantCaps","fontVariantEastAsian","fontVariantLigatures","fontVariantNumeric","fontVariantPosition","fontWeight","lineHeight"],fontVariant:["fontVariantAlternates","fontVariantCaps","fontVariantEastAsian","fontVariantLigatures","fontVariantNumeric","fontVariantPosition"],gap:["columnGap","rowGap"],grid:["gridAutoColumns","gridAutoFlow","gridAutoRows","gridTemplateAreas","gridTemplateColumns","gridTemplateRows"],gridArea:["gridColumnEnd","gridColumnStart","gridRowEnd","gridRowStart"],gridColumn:["gridColumnEnd","gridColumnStart"],gridColumnGap:["columnGap"],gridGap:["columnGap","rowGap"],gridRow:["gridRowEnd","gridRowStart"],gridRowGap:["rowGap"],gridTemplate:["gridTemplateAreas","gridTemplateColumns","gridTemplateRows"],listStyle:["listStyleImage","listStylePosition","listStyleType"],margin:["marginBottom","marginLeft","marginRight","marginTop"],marker:["markerEnd","markerMid","markerStart"],mask:["maskClip","maskComposite","maskImage","maskMode","maskOrigin","maskPositionX","maskPositionY","maskRepeat","maskSize"],maskPosition:["maskPositionX","maskPositionY"],outline:["outlineColor","outlineStyle","outlineWidth"],overflow:["overflowX","overflowY"],padding:["paddingBottom","paddingLeft","paddingRight","paddingTop"],placeContent:["alignContent","justifyContent"],placeItems:["alignItems","justifyItems"],placeSelf:["alignSelf","justifySelf"],textDecoration:["textDecorationColor","textDecorationLine","textDecorationStyle"],textEmphasis:["textEmphasisColor","textEmphasisStyle"],transition:["transitionDelay","transitionDuration","transitionProperty","transitionTimingFunction"],wordWrap:["overflowWrap"]},s_={animationIterationCount:!0,aspectRatio:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0};function t0(v,S){return v+S.charAt(0).toUpperCase()+S.substring(1)}var RP=["Webkit","ms","Moz","O"];Object.keys(s_).forEach(function(v){RP.forEach(function(S){s_[t0(S,v)]=s_[v]})});function iv(v,S,P){var G=S==null||typeof S=="boolean"||S==="";return G?"":!P&&typeof S=="number"&&S!==0&&!(s_.hasOwnProperty(v)&&s_[v])?S+"px":(jt(S,v),(""+S).trim())}var rS=/([A-Z])/g,oS=/^ms-/;function Va(v){return v.replace(rS,"-$1").toLowerCase().replace(oS,"-ms-")}var om=function(){};{var AT=/^(?:webkit|moz|o)[A-Z]/,Qv=/^-ms-/,ZA=/-(.)/g,MP=/;\s*$/,ep={},l_={},PP=!1,XA=!1,c_=function(v){return v.replace(ZA,function(S,P){return P.toUpperCase()})},Oi=function(v){ep.hasOwnProperty(v)&&ep[v]||(ep[v]=!0,d("Unsupported style property %s. Did you mean %s?",v,c_(v.replace(Qv,"ms-"))))},gn=function(v){ep.hasOwnProperty(v)&&ep[v]||(ep[v]=!0,d("Unsupported vendor-prefixed style property %s. Did you mean %s?",v,v.charAt(0).toUpperCase()+v.slice(1)))},Tn=function(v,S){l_.hasOwnProperty(S)&&l_[S]||(l_[S]=!0,d(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`,v,S.replace(MP,"")))},Aa=function(v,S){PP||(PP=!0,d("`NaN` is an invalid value for the `%s` css style property.",v))},ko=function(v,S){XA||(XA=!0,d("`Infinity` is an invalid value for the `%s` css style property.",v))};om=function(v,S){v.indexOf("-")>-1?Oi(v):AT.test(v)?gn(v):MP.test(S)&&Tn(v,S),typeof S=="number"&&(isNaN(S)?Aa(v,S):isFinite(S)||ko(v,S))}}var vl=om;function tp(v){{var S="",P="";for(var G in v)if(v.hasOwnProperty(G)){var Q=v[G];if(Q!=null){var me=G.indexOf("--")===0;S+=P+(me?G:Va(G))+":",S+=iv(G,Q,me),P=";"}}return S||null}}function eu(v,S){var P=v.style;for(var G in S)if(S.hasOwnProperty(G)){var Q=G.indexOf("--")===0;Q||vl(G,S[G]);var me=iv(G,S[G],Q);G==="float"&&(G="cssFloat"),Q?P.setProperty(G,me):P[G]=me}}function Js(v){return v==null||typeof v=="boolean"||v===""}function xk(v){var S={};for(var P in v)for(var G=yb[P]||[P],Q=0;Q<G.length;Q++)S[G[Q]]=P;return S}function WO(v,S){{if(!S)return;var P=xk(v),G=xk(S),Q={};for(var me in P){var De=P[me],We=G[me];if(We&&De!==We){var rt=De+","+We;if(Q[rt])continue;Q[rt]=!0,d("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.",Js(v[De])?"Removing":"Updating",De,We)}}}}var tu={area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0},sS=Za({menuitem:!0},tu),DP="__html";function Sb(v,S){if(S){if(sS[v]&&(S.children!=null||S.dangerouslySetInnerHTML!=null))throw new Error(v+" is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");if(S.dangerouslySetInnerHTML!=null){if(S.children!=null)throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");if(typeof S.dangerouslySetInnerHTML!="object"||!(DP in S.dangerouslySetInnerHTML))throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.")}if(!S.suppressContentEditableWarning&&S.contentEditable&&S.children!=null&&d("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."),S.style!=null&&typeof S.style!="object")throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.")}}function Zv(v,S){if(v.indexOf("-")===-1)return typeof S.is=="string";switch(v){case"annotation-xml":case"color-profile":case"font-face":case"font-face-src":case"font-face-uri":case"font-face-format":case"font-face-name":case"missing-glyph":return!1;default:return!0}}var IT={accept:"accept",acceptcharset:"acceptCharset","accept-charset":"acceptCharset",accesskey:"accessKey",action:"action",allowfullscreen:"allowFullScreen",alt:"alt",as:"as",async:"async",autocapitalize:"autoCapitalize",autocomplete:"autoComplete",autocorrect:"autoCorrect",autofocus:"autoFocus",autoplay:"autoPlay",autosave:"autoSave",capture:"capture",cellpadding:"cellPadding",cellspacing:"cellSpacing",challenge:"challenge",charset:"charSet",checked:"checked",children:"children",cite:"cite",class:"className",classid:"classID",classname:"className",cols:"cols",colspan:"colSpan",content:"content",contenteditable:"contentEditable",contextmenu:"contextMenu",controls:"controls",controlslist:"controlsList",coords:"coords",crossorigin:"crossOrigin",dangerouslysetinnerhtml:"dangerouslySetInnerHTML",data:"data",datetime:"dateTime",default:"default",defaultchecked:"defaultChecked",defaultvalue:"defaultValue",defer:"defer",dir:"dir",disabled:"disabled",disablepictureinpicture:"disablePictureInPicture",disableremoteplayback:"disableRemotePlayback",download:"download",draggable:"draggable",enctype:"encType",enterkeyhint:"enterKeyHint",for:"htmlFor",form:"form",formmethod:"formMethod",formaction:"formAction",formenctype:"formEncType",formnovalidate:"formNoValidate",formtarget:"formTarget",frameborder:"frameBorder",headers:"headers",height:"height",hidden:"hidden",high:"high",href:"href",hreflang:"hrefLang",htmlfor:"htmlFor",httpequiv:"httpEquiv","http-equiv":"httpEquiv",icon:"icon",id:"id",imagesizes:"imageSizes",imagesrcset:"imageSrcSet",innerhtml:"innerHTML",inputmode:"inputMode",integrity:"integrity",is:"is",itemid:"itemID",itemprop:"itemProp",itemref:"itemRef",itemscope:"itemScope",itemtype:"itemType",keyparams:"keyParams",keytype:"keyType",kind:"kind",label:"label",lang:"lang",list:"list",loop:"loop",low:"low",manifest:"manifest",marginwidth:"marginWidth",marginheight:"marginHeight",max:"max",maxlength:"maxLength",media:"media",mediagroup:"mediaGroup",method:"method",min:"min",minlength:"minLength",multiple:"multiple",muted:"muted",name:"name",nomodule:"noModule",nonce:"nonce",novalidate:"noValidate",open:"open",optimum:"optimum",pattern:"pattern",placeholder:"placeholder",playsinline:"playsInline",poster:"poster",preload:"preload",profile:"profile",radiogroup:"radioGroup",readonly:"readOnly",referrerpolicy:"referrerPolicy",rel:"rel",required:"required",reversed:"reversed",role:"role",rows:"rows",rowspan:"rowSpan",sandbox:"sandbox",scope:"scope",scoped:"scoped",scrolling:"scrolling",seamless:"seamless",selected:"selected",shape:"shape",size:"size",sizes:"sizes",span:"span",spellcheck:"spellCheck",src:"src",srcdoc:"srcDoc",srclang:"srcLang",srcset:"srcSet",start:"start",step:"step",style:"style",summary:"summary",tabindex:"tabIndex",target:"target",title:"title",type:"type",usemap:"useMap",value:"value",width:"width",wmode:"wmode",wrap:"wrap",about:"about",accentheight:"accentHeight","accent-height":"accentHeight",accumulate:"accumulate",additive:"additive",alignmentbaseline:"alignmentBaseline","alignment-baseline":"alignmentBaseline",allowreorder:"allowReorder",alphabetic:"alphabetic",amplitude:"amplitude",arabicform:"arabicForm","arabic-form":"arabicForm",ascent:"ascent",attributename:"attributeName",attributetype:"attributeType",autoreverse:"autoReverse",azimuth:"azimuth",basefrequency:"baseFrequency",baselineshift:"baselineShift","baseline-shift":"baselineShift",baseprofile:"baseProfile",bbox:"bbox",begin:"begin",bias:"bias",by:"by",calcmode:"calcMode",capheight:"capHeight","cap-height":"capHeight",clip:"clip",clippath:"clipPath","clip-path":"clipPath",clippathunits:"clipPathUnits",cliprule:"clipRule","clip-rule":"clipRule",color:"color",colorinterpolation:"colorInterpolation","color-interpolation":"colorInterpolation",colorinterpolationfilters:"colorInterpolationFilters","color-interpolation-filters":"colorInterpolationFilters",colorprofile:"colorProfile","color-profile":"colorProfile",colorrendering:"colorRendering","color-rendering":"colorRendering",contentscripttype:"contentScriptType",contentstyletype:"contentStyleType",cursor:"cursor",cx:"cx",cy:"cy",d:"d",datatype:"datatype",decelerate:"decelerate",descent:"descent",diffuseconstant:"diffuseConstant",direction:"direction",display:"display",divisor:"divisor",dominantbaseline:"dominantBaseline","dominant-baseline":"dominantBaseline",dur:"dur",dx:"dx",dy:"dy",edgemode:"edgeMode",elevation:"elevation",enablebackground:"enableBackground","enable-background":"enableBackground",end:"end",exponent:"exponent",externalresourcesrequired:"externalResourcesRequired",fill:"fill",fillopacity:"fillOpacity","fill-opacity":"fillOpacity",fillrule:"fillRule","fill-rule":"fillRule",filter:"filter",filterres:"filterRes",filterunits:"filterUnits",floodopacity:"floodOpacity","flood-opacity":"floodOpacity",floodcolor:"floodColor","flood-color":"floodColor",focusable:"focusable",fontfamily:"fontFamily","font-family":"fontFamily",fontsize:"fontSize","font-size":"fontSize",fontsizeadjust:"fontSizeAdjust","font-size-adjust":"fontSizeAdjust",fontstretch:"fontStretch","font-stretch":"fontStretch",fontstyle:"fontStyle","font-style":"fontStyle",fontvariant:"fontVariant","font-variant":"fontVariant",fontweight:"fontWeight","font-weight":"fontWeight",format:"format",from:"from",fx:"fx",fy:"fy",g1:"g1",g2:"g2",glyphname:"glyphName","glyph-name":"glyphName",glyphorientationhorizontal:"glyphOrientationHorizontal","glyph-orientation-horizontal":"glyphOrientationHorizontal",glyphorientationvertical:"glyphOrientationVertical","glyph-orientation-vertical":"glyphOrientationVertical",glyphref:"glyphRef",gradienttransform:"gradientTransform",gradientunits:"gradientUnits",hanging:"hanging",horizadvx:"horizAdvX","horiz-adv-x":"horizAdvX",horizoriginx:"horizOriginX","horiz-origin-x":"horizOriginX",ideographic:"ideographic",imagerendering:"imageRendering","image-rendering":"imageRendering",in2:"in2",in:"in",inlist:"inlist",intercept:"intercept",k1:"k1",k2:"k2",k3:"k3",k4:"k4",k:"k",kernelmatrix:"kernelMatrix",kernelunitlength:"kernelUnitLength",kerning:"kerning",keypoints:"keyPoints",keysplines:"keySplines",keytimes:"keyTimes",lengthadjust:"lengthAdjust",letterspacing:"letterSpacing","letter-spacing":"letterSpacing",lightingcolor:"lightingColor","lighting-color":"lightingColor",limitingconeangle:"limitingConeAngle",local:"local",markerend:"markerEnd","marker-end":"markerEnd",markerheight:"markerHeight",markermid:"markerMid","marker-mid":"markerMid",markerstart:"markerStart","marker-start":"markerStart",markerunits:"markerUnits",markerwidth:"markerWidth",mask:"mask",maskcontentunits:"maskContentUnits",maskunits:"maskUnits",mathematical:"mathematical",mode:"mode",numoctaves:"numOctaves",offset:"offset",opacity:"opacity",operator:"operator",order:"order",orient:"orient",orientation:"orientation",origin:"origin",overflow:"overflow",overlineposition:"overlinePosition","overline-position":"overlinePosition",overlinethickness:"overlineThickness","overline-thickness":"overlineThickness",paintorder:"paintOrder","paint-order":"paintOrder",panose1:"panose1","panose-1":"panose1",pathlength:"pathLength",patterncontentunits:"patternContentUnits",patterntransform:"patternTransform",patternunits:"patternUnits",pointerevents:"pointerEvents","pointer-events":"pointerEvents",points:"points",pointsatx:"pointsAtX",pointsaty:"pointsAtY",pointsatz:"pointsAtZ",prefix:"prefix",preservealpha:"preserveAlpha",preserveaspectratio:"preserveAspectRatio",primitiveunits:"primitiveUnits",property:"property",r:"r",radius:"radius",refx:"refX",refy:"refY",renderingintent:"renderingIntent","rendering-intent":"renderingIntent",repeatcount:"repeatCount",repeatdur:"repeatDur",requiredextensions:"requiredExtensions",requiredfeatures:"requiredFeatures",resource:"resource",restart:"restart",result:"result",results:"results",rotate:"rotate",rx:"rx",ry:"ry",scale:"scale",security:"security",seed:"seed",shaperendering:"shapeRendering","shape-rendering":"shapeRendering",slope:"slope",spacing:"spacing",specularconstant:"specularConstant",specularexponent:"specularExponent",speed:"speed",spreadmethod:"spreadMethod",startoffset:"startOffset",stddeviation:"stdDeviation",stemh:"stemh",stemv:"stemv",stitchtiles:"stitchTiles",stopcolor:"stopColor","stop-color":"stopColor",stopopacity:"stopOpacity","stop-opacity":"stopOpacity",strikethroughposition:"strikethroughPosition","strikethrough-position":"strikethroughPosition",strikethroughthickness:"strikethroughThickness","strikethrough-thickness":"strikethroughThickness",string:"string",stroke:"stroke",strokedasharray:"strokeDasharray","stroke-dasharray":"strokeDasharray",strokedashoffset:"strokeDashoffset","stroke-dashoffset":"strokeDashoffset",strokelinecap:"strokeLinecap","stroke-linecap":"strokeLinecap",strokelinejoin:"strokeLinejoin","stroke-linejoin":"strokeLinejoin",strokemiterlimit:"strokeMiterlimit","stroke-miterlimit":"strokeMiterlimit",strokewidth:"strokeWidth","stroke-width":"strokeWidth",strokeopacity:"strokeOpacity","stroke-opacity":"strokeOpacity",suppresscontenteditablewarning:"suppressContentEditableWarning",suppresshydrationwarning:"suppressHydrationWarning",surfacescale:"surfaceScale",systemlanguage:"systemLanguage",tablevalues:"tableValues",targetx:"targetX",targety:"targetY",textanchor:"textAnchor","text-anchor":"textAnchor",textdecoration:"textDecoration","text-decoration":"textDecoration",textlength:"textLength",textrendering:"textRendering","text-rendering":"textRendering",to:"to",transform:"transform",typeof:"typeof",u1:"u1",u2:"u2",underlineposition:"underlinePosition","underline-position":"underlinePosition",underlinethickness:"underlineThickness","underline-thickness":"underlineThickness",unicode:"unicode",unicodebidi:"unicodeBidi","unicode-bidi":"unicodeBidi",unicoderange:"unicodeRange","unicode-range":"unicodeRange",unitsperem:"unitsPerEm","units-per-em":"unitsPerEm",unselectable:"unselectable",valphabetic:"vAlphabetic","v-alphabetic":"vAlphabetic",values:"values",vectoreffect:"vectorEffect","vector-effect":"vectorEffect",version:"version",vertadvy:"vertAdvY","vert-adv-y":"vertAdvY",vertoriginx:"vertOriginX","vert-origin-x":"vertOriginX",vertoriginy:"vertOriginY","vert-origin-y":"vertOriginY",vhanging:"vHanging","v-hanging":"vHanging",videographic:"vIdeographic","v-ideographic":"vIdeographic",viewbox:"viewBox",viewtarget:"viewTarget",visibility:"visibility",vmathematical:"vMathematical","v-mathematical":"vMathematical",vocab:"vocab",widths:"widths",wordspacing:"wordSpacing","word-spacing":"wordSpacing",writingmode:"writingMode","writing-mode":"writingMode",x1:"x1",x2:"x2",x:"x",xchannelselector:"xChannelSelector",xheight:"xHeight","x-height":"xHeight",xlinkactuate:"xlinkActuate","xlink:actuate":"xlinkActuate",xlinkarcrole:"xlinkArcrole","xlink:arcrole":"xlinkArcrole",xlinkhref:"xlinkHref","xlink:href":"xlinkHref",xlinkrole:"xlinkRole","xlink:role":"xlinkRole",xlinkshow:"xlinkShow","xlink:show":"xlinkShow",xlinktitle:"xlinkTitle","xlink:title":"xlinkTitle",xlinktype:"xlinkType","xlink:type":"xlinkType",xmlbase:"xmlBase","xml:base":"xmlBase",xmllang:"xmlLang","xml:lang":"xmlLang",xmlns:"xmlns","xml:space":"xmlSpace",xmlnsxlink:"xmlnsXlink","xmlns:xlink":"xmlnsXlink",xmlspace:"xmlSpace",y1:"y1",y2:"y2",y:"y",ychannelselector:"yChannelSelector",z:"z",zoomandpan:"zoomAndPan"},Vl={"aria-current":0,"aria-description":0,"aria-details":0,"aria-disabled":0,"aria-hidden":0,"aria-invalid":0,"aria-keyshortcuts":0,"aria-label":0,"aria-roledescription":0,"aria-autocomplete":0,"aria-checked":0,"aria-expanded":0,"aria-haspopup":0,"aria-level":0,"aria-modal":0,"aria-multiline":0,"aria-multiselectable":0,"aria-orientation":0,"aria-placeholder":0,"aria-pressed":0,"aria-readonly":0,"aria-required":0,"aria-selected":0,"aria-sort":0,"aria-valuemax":0,"aria-valuemin":0,"aria-valuenow":0,"aria-valuetext":0,"aria-atomic":0,"aria-busy":0,"aria-live":0,"aria-relevant":0,"aria-dropeffect":0,"aria-grabbed":0,"aria-activedescendant":0,"aria-colcount":0,"aria-colindex":0,"aria-colspan":0,"aria-controls":0,"aria-describedby":0,"aria-errormessage":0,"aria-flowto":0,"aria-labelledby":0,"aria-owns":0,"aria-posinset":0,"aria-rowcount":0,"aria-rowindex":0,"aria-rowspan":0,"aria-setsize":0},i0={},LP=new RegExp("^(aria)-["+Ye+"]*$"),bb=new RegExp("^(aria)[A-Z]["+Ye+"]*$");function Bk(v,S){{if(Pt.call(i0,S)&&i0[S])return!0;if(bb.test(S)){var P="aria-"+S.slice(4).toLowerCase(),G=Vl.hasOwnProperty(P)?P:null;if(G==null)return d("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.",S),i0[S]=!0,!0;if(S!==G)return d("Invalid ARIA attribute `%s`. Did you mean `%s`?",S,G),i0[S]=!0,!0}if(LP.test(S)){var Q=S.toLowerCase(),me=Vl.hasOwnProperty(Q)?Q:null;if(me==null)return i0[S]=!0,!1;if(S!==me)return d("Unknown ARIA attribute `%s`. Did you mean `%s`?",S,me),i0[S]=!0,!0}}return!0}function eI(v,S){{var P=[];for(var G in S){var Q=Bk(v,G);Q||P.push(G)}var me=P.map(function(De){return"`"+De+"`"}).join(", ");P.length===1?d("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props",me,v):P.length>1&&d("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props",me,v)}}function OP(v,S){Zv(v,S)||eI(v,S)}var n0=!1;function Xv(v,S){{if(v!=="input"&&v!=="textarea"&&v!=="select")return;S!=null&&S.value===null&&!n0&&(n0=!0,v==="select"&&S.multiple?d("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.",v):d("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.",v))}}var Km=function(){};{var Td={},a0=/^on./,d_=/^on[^A-Z]/,tI=new RegExp("^(aria)-["+Ye+"]*$"),u_=new RegExp("^(aria)[A-Z]["+Ye+"]*$");Km=function(v,S,P,G){if(Pt.call(Td,S)&&Td[S])return!0;var Q=S.toLowerCase();if(Q==="onfocusin"||Q==="onfocusout")return d("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."),Td[S]=!0,!0;if(G!=null){var me=G.registrationNameDependencies,De=G.possibleRegistrationNames;if(me.hasOwnProperty(S))return!0;var We=De.hasOwnProperty(Q)?De[Q]:null;if(We!=null)return d("Invalid event handler property `%s`. Did you mean `%s`?",S,We),Td[S]=!0,!0;if(a0.test(S))return d("Unknown event handler property `%s`. It will be ignored.",S),Td[S]=!0,!0}else if(a0.test(S))return d_.test(S)&&d("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.",S),Td[S]=!0,!0;if(tI.test(S)||u_.test(S))return!0;if(Q==="innerhtml")return d("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."),Td[S]=!0,!0;if(Q==="aria")return d("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."),Td[S]=!0,!0;if(Q==="is"&&P!==null&&P!==void 0&&typeof P!="string")return d("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.",typeof P),Td[S]=!0,!0;if(typeof P=="number"&&isNaN(P))return d("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.",S),Td[S]=!0,!0;var rt=qt(S),_t=rt!==null&&rt.type===$t;if(IT.hasOwnProperty(Q)){var Ut=IT[Q];if(Ut!==S)return d("Invalid DOM property `%s`. Did you mean `%s`?",S,Ut),Td[S]=!0,!0}else if(!_t&&S!==Q)return d("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.",S,Q),Td[S]=!0,!0;return typeof P=="boolean"&&sn(S,P,rt,!1)?(P?d('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.',P,S,S,P,S):d('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.',P,S,S,P,S,S,S),Td[S]=!0,!0):_t?!0:sn(S,P,rt,!1)?(Td[S]=!0,!1):((P==="false"||P==="true")&&rt!==null&&rt.type===kt&&(d("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?",P,S,P==="false"?"The browser will interpret it as a truthy value.":'Although this works, it will not work as expected if you pass the string "false".',S,P),Td[S]=!0),!0)}}var NP=function(v,S,P){{var G=[];for(var Q in S){var me=Km(v,Q,S[Q],P);me||G.push(Q)}var De=G.map(function(We){return"`"+We+"`"}).join(", ");G.length===1?d("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ",De,v):G.length>1&&d("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ",De,v)}};function r0(v,S,P){Zv(v,S)||NP(v,S,P)}var ey=1,nv=2,av=4,xP=ey|nv|av,lS=null;function Fk(v){lS!==null&&d("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue."),lS=v}function iI(){lS===null&&d("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue."),lS=null}function _u(v){return v===lS}function Uk(v){var S=v.target||v.srcElement||window;return S.correspondingUseElement&&(S=S.correspondingUseElement),S.nodeType===tv?S.parentNode:S}var wT=null,yg=null,wl=null;function id(v){var S=Oo(v);if(S){if(typeof wT!="function")throw new Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");var P=S.stateNode;if(P){var G=dl(P);wT(S.stateNode,S.type,G)}}}function Eu(v){wT=v}function ty(v){yg?wl?wl.push(v):wl=[v]:yg=v}function KO(){return yg!==null||wl!==null}function h_(){if(yg){var v=yg,S=wl;if(yg=null,wl=null,id(v),S)for(var P=0;P<S.length;P++)id(S[P])}}var cS=function(v,S){return v(S)},kT=function(){},Jm=!1;function o0(){var v=KO();v&&(kT(),h_())}function dS(v,S,P){if(Jm)return v(S,P);Jm=!0;try{return cS(v,S,P)}finally{Jm=!1,o0()}}function s0(v,S,P){cS=v,kT=P}function RT(v){return v==="button"||v==="input"||v==="select"||v==="textarea"}function uS(v,S,P){switch(v){case"onClick":case"onClickCapture":case"onDoubleClick":case"onDoubleClickCapture":case"onMouseDown":case"onMouseDownCapture":case"onMouseMove":case"onMouseMoveCapture":case"onMouseUp":case"onMouseUpCapture":case"onMouseEnter":return!!(P.disabled&&RT(S));default:return!1}}function Sg(v,S){var P=v.stateNode;if(P===null)return null;var G=dl(P);if(G===null)return null;var Q=G[S];if(uS(S,v.type,G))return null;if(Q&&typeof Q!="function")throw new Error("Expected `"+S+"` listener to be a function, instead got a value of `"+typeof Q+"` type.");return Q}var p_=!1;if(vt)try{var iy={};Object.defineProperty(iy,"passive",{get:function(){p_=!0}}),window.addEventListener("test",iy,iy),window.removeEventListener("test",iy,iy)}catch{p_=!1}function nI(v,S,P,G,Q,me,De,We,rt){var _t=Array.prototype.slice.call(arguments,3);try{S.apply(P,_t)}catch(Ut){this.onError(Ut)}}var aI=nI;if(typeof window<"u"&&typeof window.dispatchEvent=="function"&&typeof document<"u"&&typeof document.createEvent=="function"){var rI=document.createElement("react");aI=function(S,P,G,Q,me,De,We,rt,_t){if(typeof document>"u"||document===null)throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");var Ut=document.createEvent("Event"),Di=!1,Ri=!0,Xi=window.event,tn=Object.getOwnPropertyDescriptor(window,"event");function Cn(){rI.removeEventListener(bn,po,!1),typeof window.event<"u"&&window.hasOwnProperty("event")&&(window.event=Xi)}var Ja=Array.prototype.slice.call(arguments,3);function po(){Di=!0,Cn(),P.apply(G,Ja),Ri=!1}var Gr,Dl=!1,hl=!1;function qi(Wi){if(Gr=Wi.error,Dl=!0,Gr===null&&Wi.colno===0&&Wi.lineno===0&&(hl=!0),Wi.defaultPrevented&&Gr!=null&&typeof Gr=="object")try{Gr._suppressLogging=!0}catch{}}var bn="react-"+(S||"invokeguardedcallback");if(window.addEventListener("error",qi),rI.addEventListener(bn,po,!1),Ut.initEvent(bn,!1,!1),rI.dispatchEvent(Ut),tn&&Object.defineProperty(window,"event",tn),Di&&Ri&&(Dl?hl&&(Gr=new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.")):Gr=new Error(`An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the "Pause on exceptions" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.`),this.onError(Gr)),window.removeEventListener("error",qi),!Di)return Cn(),nI.apply(this,arguments)}}var MT=aI,rv=!1,ny=null,Tt=!1,ip=null,PT={onError:function(v){rv=!0,ny=v}};function ph(v,S,P,G,Q,me,De,We,rt){rv=!1,ny=null,MT.apply(PT,arguments)}function Lo(v,S,P,G,Q,me,De,We,rt){if(ph.apply(this,arguments),rv){var _t=sI();Tt||(Tt=!0,ip=_t)}}function oI(){if(Tt){var v=ip;throw Tt=!1,ip=null,v}}function Tb(){return rv}function sI(){if(rv){var v=ny;return rv=!1,ny=null,v}else throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.")}function ov(v){return v._reactInternals}function SF(v){return v._reactInternals!==void 0}function Cb(v,S){v._reactInternals=S}var Ia=0,Ym=1,Nd=2,Kr=4,Mh=16,Qm=32,fc=64,ra=128,np=256,kl=512,iu=1024,Ph=2048,ap=4096,Dc=8192,Hc=16384,ay=32767,$l=32768,Dh=65536,bg=131072,Tg=1048576,hS=2097152,Lp=4194304,g_=8388608,ry=16777216,Hu=33554432,sv=Kr|iu|0,lv=Nd|Kr|Mh|Qm|kl|ap|Dc,_b=Kr|fc|kl|Dc,rp=Ph|Mh,vc=Lp|g_|hS,yc=i.ReactCurrentOwner;function sm(v){var S=v,P=v;if(v.alternate)for(;S.return;)S=S.return;else{var G=S;do S=G,(S.flags&(Nd|ap))!==Ia&&(P=S.return),G=S.return;while(G)}return S.tag===y?P:null}function Op(v){if(v.tag===L){var S=v.memoizedState;if(S===null){var P=v.alternate;P!==null&&(S=P.memoizedState)}if(S!==null)return S.dehydrated}return null}function oy(v){return v.tag===y?v.stateNode.containerInfo:null}function nu(v){return sm(v)===v}function m_(v){{var S=yc.current;if(S!==null&&S.tag===g){var P=S,G=P.stateNode;G._warnedAboutRefsInRender||d("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.",Do(P)||"A component"),G._warnedAboutRefsInRender=!0}}var Q=ov(v);return Q?sm(Q)===Q:!1}function sy(v){if(sm(v)!==v)throw new Error("Unable to find node on an unmounted component.")}function Np(v){var S=v.alternate;if(!S){var P=sm(v);if(P===null)throw new Error("Unable to find node on an unmounted component.");return P!==v?null:v}for(var G=v,Q=S;;){var me=G.return;if(me===null)break;var De=me.alternate;if(De===null){var We=me.return;if(We!==null){G=Q=We;continue}break}if(me.child===De.child){for(var rt=me.child;rt;){if(rt===G)return sy(me),v;if(rt===Q)return sy(me),S;rt=rt.sibling}throw new Error("Unable to find node on an unmounted component.")}if(G.return!==Q.return)G=me,Q=De;else{for(var _t=!1,Ut=me.child;Ut;){if(Ut===G){_t=!0,G=me,Q=De;break}if(Ut===Q){_t=!0,Q=me,G=De;break}Ut=Ut.sibling}if(!_t){for(Ut=De.child;Ut;){if(Ut===G){_t=!0,G=De,Q=me;break}if(Ut===Q){_t=!0,Q=De,G=me;break}Ut=Ut.sibling}if(!_t)throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.")}}if(G.alternate!==Q)throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.")}if(G.tag!==y)throw new Error("Unable to find node on an unmounted component.");return G.stateNode.current===G?v:S}function ju(v){var S=Np(v);return S!==null?xd(S):null}function xd(v){if(v.tag===C||v.tag===E)return v;for(var S=v.child;S!==null;){var P=xd(S);if(P!==null)return P;S=S.sibling}return null}function Ac(v){var S=Np(v);return S!==null?au(S):null}function au(v){if(v.tag===C||v.tag===E)return v;for(var S=v.child;S!==null;){if(S.tag!==T){var P=au(S);if(P!==null)return P}S=S.sibling}return null}var Cg=e.unstable_scheduleCallback,ly=e.unstable_cancelCallback,l0=e.unstable_shouldYield,pS=e.unstable_requestPaint,Ic=e.unstable_now,Eb=e.unstable_getCurrentPriorityLevel,ru=e.unstable_ImmediatePriority,cv=e.unstable_UserBlockingPriority,Zm=e.unstable_NormalPriority,dv=e.unstable_LowPriority,_g=e.unstable_IdlePriority,f_=e.unstable_yieldValue,xp=e.unstable_setDisableYieldValue,gS=null,Ns=null,Na=null,lm=!1,Bp=typeof __REACT_DEVTOOLS_GLOBAL_HOOK__<"u";function cy(v){if(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__>"u")return!1;var S=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(S.isDisabled)return!0;if(!S.supportsFiber)return d("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools"),!0;try{Te&&(v=Za({},v,{getLaneLabelMap:Fp,injectProfilingHooks:cm})),gS=S.inject(v),Ns=S}catch(P){d("React instrumentation encountered an error: %s.",P)}return!!S.checkDCE}function mS(v,S){if(Ns&&typeof Ns.onScheduleFiberRoot=="function")try{Ns.onScheduleFiberRoot(gS,v,S)}catch(P){lm||(lm=!0,d("React instrumentation encountered an error: %s",P))}}function uv(v,S){if(Ns&&typeof Ns.onCommitFiberRoot=="function")try{var P=(v.current.flags&ra)===ra;if(Be){var G;switch(S){case mh:G=ru;break;case TS:G=cv;break;case of:G=Zm;break;case Vp:G=_g;break;default:G=Zm;break}Ns.onCommitFiberRoot(gS,v,G,P)}}catch(Q){lm||(lm=!0,d("React instrumentation encountered an error: %s",Q))}}function Ab(v){if(Ns&&typeof Ns.onPostCommitFiberRoot=="function")try{Ns.onPostCommitFiberRoot(gS,v)}catch(S){lm||(lm=!0,d("React instrumentation encountered an error: %s",S))}}function DT(v){if(Ns&&typeof Ns.onCommitFiberUnmount=="function")try{Ns.onCommitFiberUnmount(gS,v)}catch(S){lm||(lm=!0,d("React instrumentation encountered an error: %s",S))}}function Cd(v){if(typeof f_=="function"&&(xp(v),o(v)),Ns&&typeof Ns.setStrictMode=="function")try{Ns.setStrictMode(gS,v)}catch(S){lm||(lm=!0,d("React instrumentation encountered an error: %s",S))}}function cm(v){Na=v}function Fp(){{for(var v=new Map,S=1,P=0;P<_d;P++){var G=JO(S);v.set(S,G),S*=2}return v}}function zk(v){Na!==null&&typeof Na.markCommitStarted=="function"&&Na.markCommitStarted(v)}function Vk(){Na!==null&&typeof Na.markCommitStopped=="function"&&Na.markCommitStopped()}function Up(v){Na!==null&&typeof Na.markComponentRenderStarted=="function"&&Na.markComponentRenderStarted(v)}function Eg(){Na!==null&&typeof Na.markComponentRenderStopped=="function"&&Na.markComponentRenderStopped()}function BP(v){Na!==null&&typeof Na.markComponentPassiveEffectMountStarted=="function"&&Na.markComponentPassiveEffectMountStarted(v)}function lI(){Na!==null&&typeof Na.markComponentPassiveEffectMountStopped=="function"&&Na.markComponentPassiveEffectMountStopped()}function fS(v){Na!==null&&typeof Na.markComponentPassiveEffectUnmountStarted=="function"&&Na.markComponentPassiveEffectUnmountStarted(v)}function hv(){Na!==null&&typeof Na.markComponentPassiveEffectUnmountStopped=="function"&&Na.markComponentPassiveEffectUnmountStopped()}function v_(v){Na!==null&&typeof Na.markComponentLayoutEffectMountStarted=="function"&&Na.markComponentLayoutEffectMountStarted(v)}function cI(){Na!==null&&typeof Na.markComponentLayoutEffectMountStopped=="function"&&Na.markComponentLayoutEffectMountStopped()}function LT(v){Na!==null&&typeof Na.markComponentLayoutEffectUnmountStarted=="function"&&Na.markComponentLayoutEffectUnmountStarted(v)}function dI(){Na!==null&&typeof Na.markComponentLayoutEffectUnmountStopped=="function"&&Na.markComponentLayoutEffectUnmountStopped()}function c0(v,S,P){Na!==null&&typeof Na.markComponentErrored=="function"&&Na.markComponentErrored(v,S,P)}function dy(v,S,P){Na!==null&&typeof Na.markComponentSuspended=="function"&&Na.markComponentSuspended(v,S,P)}function vS(v){Na!==null&&typeof Na.markLayoutEffectsStarted=="function"&&Na.markLayoutEffectsStarted(v)}function y_(){Na!==null&&typeof Na.markLayoutEffectsStopped=="function"&&Na.markLayoutEffectsStopped()}function yS(v){Na!==null&&typeof Na.markPassiveEffectsStarted=="function"&&Na.markPassiveEffectsStarted(v)}function uI(){Na!==null&&typeof Na.markPassiveEffectsStopped=="function"&&Na.markPassiveEffectsStopped()}function S_(v){Na!==null&&typeof Na.markRenderStarted=="function"&&Na.markRenderStarted(v)}function $k(){Na!==null&&typeof Na.markRenderYielded=="function"&&Na.markRenderYielded()}function Hk(){Na!==null&&typeof Na.markRenderStopped=="function"&&Na.markRenderStopped()}function nd(v){Na!==null&&typeof Na.markRenderScheduled=="function"&&Na.markRenderScheduled(v)}function d0(v,S){Na!==null&&typeof Na.markForceUpdateScheduled=="function"&&Na.markForceUpdateScheduled(v,S)}function b_(v,S){Na!==null&&typeof Na.markStateUpdateScheduled=="function"&&Na.markStateUpdateScheduled(v,S)}var Jr=0,ps=1,nr=2,Sc=8,Hl=16,Zl=Math.clz32?Math.clz32:ll,gh=Math.log,Xm=Math.LN2;function ll(v){var S=v>>>0;return S===0?32:31-(gh(S)/Xm|0)|0}var _d=31,En=0,Vs=0,ao=1,dm=2,op=4,Ys=8,Xl=16,um=32,ef=4194240,tf=64,uy=128,OT=256,T_=512,NT=1024,Ib=2048,nf=4096,u0=8192,hy=16384,xT=32768,hI=65536,BT=131072,FT=262144,h0=524288,Lh=1048576,C_=2097152,__=130023424,pv=4194304,pI=8388608,p0=16777216,Gu=33554432,hm=67108864,UT=pv,g0=134217728,py=268435455,SS=268435456,wb=536870912,Ag=1073741824;function JO(v){{if(v&ao)return"Sync";if(v&dm)return"InputContinuousHydration";if(v&op)return"InputContinuous";if(v&Ys)return"DefaultHydration";if(v&Xl)return"Default";if(v&um)return"TransitionHydration";if(v&ef)return"Transition";if(v&__)return"Retry";if(v&g0)return"SelectiveHydration";if(v&SS)return"IdleHydration";if(v&wb)return"Idle";if(v&Ag)return"Offscreen"}}var bc=-1,gv=tf,zT=pv;function gI(v){switch(rf(v)){case ao:return ao;case dm:return dm;case op:return op;case Ys:return Ys;case Xl:return Xl;case um:return um;case tf:case uy:case OT:case T_:case NT:case Ib:case nf:case u0:case hy:case xT:case hI:case BT:case FT:case h0:case Lh:case C_:return v&ef;case pv:case pI:case p0:case Gu:case hm:return v&__;case g0:return g0;case SS:return SS;case wb:return wb;case Ag:return Ag;default:return d("Should have found matching lanes. This is a bug in React."),v}}function E_(v,S){var P=v.pendingLanes;if(P===En)return En;var G=En,Q=v.suspendedLanes,me=v.pingedLanes,De=P&py;if(De!==En){var We=De&~Q;if(We!==En)G=gI(We);else{var rt=De&me;rt!==En&&(G=gI(rt))}}else{var _t=P&~Q;_t!==En?G=gI(_t):me!==En&&(G=gI(me))}if(G===En)return En;if(S!==En&&S!==G&&(S&Q)===En){var Ut=rf(G),Di=rf(S);if(Ut>=Di||Ut===Xl&&(Di&ef)!==En)return S}(G&op)!==En&&(G|=P&Xl);var Ri=v.entangledLanes;if(Ri!==En)for(var Xi=v.entanglements,tn=G&Ri;tn>0;){var Cn=ou(tn),Ja=1<<Cn;G|=Xi[Cn],tn&=~Ja}return G}function mv(v,S){for(var P=v.eventTimes,G=bc;S>0;){var Q=ou(S),me=1<<Q,De=P[Q];De>G&&(G=De),S&=~me}return G}function m0(v,S){switch(v){case ao:case dm:case op:return S+250;case Ys:case Xl:case um:case tf:case uy:case OT:case T_:case NT:case Ib:case nf:case u0:case hy:case xT:case hI:case BT:case FT:case h0:case Lh:case C_:return S+5e3;case pv:case pI:case p0:case Gu:case hm:return bc;case g0:case SS:case wb:case Ag:return bc;default:return d("Should have found matching lanes. This is a bug in React."),bc}}function mI(v,S){for(var P=v.pendingLanes,G=v.suspendedLanes,Q=v.pingedLanes,me=v.expirationTimes,De=P;De>0;){var We=ou(De),rt=1<<We,_t=me[We];_t===bc?((rt&G)===En||(rt&Q)!==En)&&(me[We]=m0(rt,S)):_t<=S&&(v.expiredLanes|=rt),De&=~rt}}function VT(v){return gI(v.pendingLanes)}function f0(v){var S=v.pendingLanes&-1073741825;return S!==En?S:S&Ag?Ag:En}function fI(v){return(v&ao)!==En}function v0(v){return(v&py)!==En}function $T(v){return(v&__)===v}function y0(v){var S=ao|op|Xl;return(v&S)===En}function jk(v){return(v&ef)===v}function S0(v,S){var P=dm|op|Ys|Xl;return(S&P)!==En}function YO(v,S){return(S&v.expiredLanes)!==En}function vI(v){return(v&ef)!==En}function af(){var v=gv;return gv<<=1,(gv&ef)===En&&(gv=tf),v}function Gk(){var v=zT;return zT<<=1,(zT&__)===En&&(zT=pv),v}function rf(v){return v&-v}function A_(v){return rf(v)}function ou(v){return 31-Zl(v)}function qu(v){return ou(v)}function pm(v,S){return(v&S)!==En}function zp(v,S){return(v&S)===S}function Jo(v,S){return v|S}function I_(v,S){return v&~S}function yI(v,S){return v&S}function b0(v){return v}function kb(v,S){return v!==Vs&&v<S?v:S}function Yr(v){for(var S=[],P=0;P<_d;P++)S.push(v);return S}function bS(v,S,P){v.pendingLanes|=S,S!==wb&&(v.suspendedLanes=En,v.pingedLanes=En);var G=v.eventTimes,Q=qu(S);G[Q]=P}function qk(v,S){v.suspendedLanes|=S,v.pingedLanes&=~S;for(var P=v.expirationTimes,G=S;G>0;){var Q=ou(G),me=1<<Q;P[Q]=bc,G&=~me}}function gy(v,S,P){v.pingedLanes|=v.suspendedLanes&S}function Wk(v,S){var P=v.pendingLanes&~S;v.pendingLanes=S,v.suspendedLanes=En,v.pingedLanes=En,v.expiredLanes&=S,v.mutableReadLanes&=S,v.entangledLanes&=S;for(var G=v.entanglements,Q=v.eventTimes,me=v.expirationTimes,De=P;De>0;){var We=ou(De),rt=1<<We;G[We]=En,Q[We]=bc,me[We]=bc,De&=~rt}}function fv(v,S){for(var P=v.entangledLanes|=S,G=v.entanglements,Q=P;Q;){var me=ou(Q),De=1<<me;De&S|G[me]&S&&(G[me]|=S),Q&=~De}}function SI(v,S){var P=rf(S),G;switch(P){case op:G=dm;break;case Xl:G=Ys;break;case tf:case uy:case OT:case T_:case NT:case Ib:case nf:case u0:case hy:case xT:case hI:case BT:case FT:case h0:case Lh:case C_:case pv:case pI:case p0:case Gu:case hm:G=um;break;case wb:G=SS;break;default:G=Vs;break}return(G&(v.suspendedLanes|S))!==Vs?Vs:G}function Au(v,S,P){if(Bp)for(var G=v.pendingUpdatersLaneMap;P>0;){var Q=qu(P),me=1<<Q,De=G[Q];De.add(S),P&=~me}}function FP(v,S){if(Bp)for(var P=v.pendingUpdatersLaneMap,G=v.memoizedUpdaters;S>0;){var Q=qu(S),me=1<<Q,De=P[Q];De.size>0&&(De.forEach(function(We){var rt=We.alternate;(rt===null||!G.has(rt))&&G.add(We)}),De.clear()),S&=~me}}function T0(v,S){return null}var mh=ao,TS=op,of=Xl,Vp=wb,bI=Vs;function gm(){return bI}function Tc(v){bI=v}function $p(v,S){var P=bI;try{return bI=v,S()}finally{bI=P}}function Kk(v,S){return v!==0&&v<S?v:S}function C0(v,S){return v>S?v:S}function Wu(v,S){return v!==0&&v<S}function w_(v){var S=rf(v);return Wu(mh,S)?Wu(TS,S)?v0(S)?of:Vp:TS:mh}function TI(v){var S=v.current.memoizedState;return S.isDehydrated}var vv;function Oh(v){vv=v}function Jk(v){vv(v)}var ar;function sf(v){ar=v}var CI;function QO(v){CI=v}var Yk;function k_(v){Yk=v}var _I;function R_(v){_I=v}var _0=!1,Rb=[],Ig=null,my=null,mm=null,Ed=new Map,fh=new Map,jc=[],fy=["mousedown","mouseup","touchcancel","touchend","touchstart","auxclick","dblclick","pointercancel","pointerdown","pointerup","dragend","dragstart","drop","compositionend","compositionstart","keydown","keypress","keyup","input","textInput","copy","cut","paste","click","change","contextmenu","reset","submit"];function E0(v){return fy.indexOf(v)>-1}function Hp(v,S,P,G,Q){return{blockedOn:v,domEventName:S,eventSystemFlags:P,nativeEvent:Q,targetContainers:[G]}}function UP(v,S){switch(v){case"focusin":case"focusout":Ig=null;break;case"dragenter":case"dragleave":my=null;break;case"mouseover":case"mouseout":mm=null;break;case"pointerover":case"pointerout":{var P=S.pointerId;Ed.delete(P);break}case"gotpointercapture":case"lostpointercapture":{var G=S.pointerId;fh.delete(G);break}}}function fm(v,S,P,G,Q,me){if(v===null||v.nativeEvent!==me){var De=Hp(S,P,G,Q,me);if(S!==null){var We=Oo(S);We!==null&&ar(We)}return De}v.eventSystemFlags|=G;var rt=v.targetContainers;return Q!==null&&rt.indexOf(Q)===-1&&rt.push(Q),v}function bF(v,S,P,G,Q){switch(S){case"focusin":{var me=Q;return Ig=fm(Ig,v,S,P,G,me),!0}case"dragenter":{var De=Q;return my=fm(my,v,S,P,G,De),!0}case"mouseover":{var We=Q;return mm=fm(mm,v,S,P,G,We),!0}case"pointerover":{var rt=Q,_t=rt.pointerId;return Ed.set(_t,fm(Ed.get(_t)||null,v,S,P,G,rt)),!0}case"gotpointercapture":{var Ut=Q,Di=Ut.pointerId;return fh.set(Di,fm(fh.get(Di)||null,v,S,P,G,Ut)),!0}}return!1}function zP(v){var S=Qo(v.target);if(S!==null){var P=sm(S);if(P!==null){var G=P.tag;if(G===L){var Q=Op(P);if(Q!==null){v.blockedOn=Q,_I(v.priority,function(){CI(P)});return}}else if(G===y){var me=P.stateNode;if(TI(me)){v.blockedOn=oy(P);return}}}}v.blockedOn=null}function jp(v){for(var S=Yk(),P={blockedOn:null,target:v,priority:S},G=0;G<jc.length&&Wu(S,jc[G].priority);G++);jc.splice(G,0,P),G===0&&zP(P)}function Bd(v){if(v.blockedOn!==null)return!1;for(var S=v.targetContainers;S.length>0;){var P=S[0],G=P_(v.domEventName,v.eventSystemFlags,P,v.nativeEvent);if(G===null){var Q=v.nativeEvent,me=new Q.constructor(Q.type,Q);Fk(me),Q.target.dispatchEvent(me),iI()}else{var De=Oo(G);return De!==null&&ar(De),v.blockedOn=G,!1}S.shift()}return!0}function M_(v,S,P){Bd(v)&&P.delete(S)}function ZO(){_0=!1,Ig!==null&&Bd(Ig)&&(Ig=null),my!==null&&Bd(my)&&(my=null),mm!==null&&Bd(mm)&&(mm=null),Ed.forEach(M_),fh.forEach(M_)}function HT(v,S){v.blockedOn===S&&(v.blockedOn=null,_0||(_0=!0,e.unstable_scheduleCallback(e.unstable_NormalPriority,ZO)))}function jT(v){if(Rb.length>0){HT(Rb[0],v);for(var S=1;S<Rb.length;S++){var P=Rb[S];P.blockedOn===v&&(P.blockedOn=null)}}Ig!==null&&HT(Ig,v),my!==null&&HT(my,v),mm!==null&&HT(mm,v);var G=function(We){return HT(We,v)};Ed.forEach(G),fh.forEach(G);for(var Q=0;Q<jc.length;Q++){var me=jc[Q];me.blockedOn===v&&(me.blockedOn=null)}for(;jc.length>0;){var De=jc[0];if(De.blockedOn!==null)break;zP(De),De.blockedOn===null&&jc.shift()}}var Lc=i.ReactCurrentBatchConfig,gs=!0;function Fd(v){gs=!!v}function ad(){return gs}function vh(v,S,P){var G=Qk(S),Q;switch(G){case mh:Q=Gp;break;case TS:Q=A0;break;case of:default:Q=su;break}return Q.bind(null,S,P,v)}function Gp(v,S,P,G){var Q=gm(),me=Lc.transition;Lc.transition=null;try{Tc(mh),su(v,S,P,G)}finally{Tc(Q),Lc.transition=me}}function A0(v,S,P,G){var Q=gm(),me=Lc.transition;Lc.transition=null;try{Tc(TS),su(v,S,P,G)}finally{Tc(Q),Lc.transition=me}}function su(v,S,P,G){gs&&I0(v,S,P,G)}function I0(v,S,P,G){var Q=P_(v,S,P,G);if(Q===null){Sh(v,S,G,CS,P),UP(v,G);return}if(bF(Q,v,S,P,G)){G.stopPropagation();return}if(UP(v,G),S&av&&E0(v)){for(;Q!==null;){var me=Oo(Q);me!==null&&Jk(me);var De=P_(v,S,P,G);if(De===null&&Sh(v,S,G,CS,P),De===Q)break;Q=De}Q!==null&&G.stopPropagation();return}Sh(v,S,G,null,P)}var CS=null;function P_(v,S,P,G){CS=null;var Q=Uk(G),me=Qo(Q);if(me!==null){var De=sm(me);if(De===null)me=null;else{var We=De.tag;if(We===L){var rt=Op(De);if(rt!==null)return rt;me=null}else if(We===y){var _t=De.stateNode;if(TI(_t))return oy(De);me=null}else De!==me&&(me=null)}}return CS=me,null}function Qk(v){switch(v){case"cancel":case"click":case"close":case"contextmenu":case"copy":case"cut":case"auxclick":case"dblclick":case"dragend":case"dragstart":case"drop":case"focusin":case"focusout":case"input":case"invalid":case"keydown":case"keypress":case"keyup":case"mousedown":case"mouseup":case"paste":case"pause":case"play":case"pointercancel":case"pointerdown":case"pointerup":case"ratechange":case"reset":case"resize":case"seeked":case"submit":case"touchcancel":case"touchend":case"touchstart":case"volumechange":case"change":case"selectionchange":case"textInput":case"compositionstart":case"compositionend":case"compositionupdate":case"beforeblur":case"afterblur":case"beforeinput":case"blur":case"fullscreenchange":case"focus":case"hashchange":case"popstate":case"select":case"selectstart":return mh;case"drag":case"dragenter":case"dragexit":case"dragleave":case"dragover":case"mousemove":case"mouseout":case"mouseover":case"pointermove":case"pointerout":case"pointerover":case"scroll":case"toggle":case"touchmove":case"wheel":case"mouseenter":case"mouseleave":case"pointerenter":case"pointerleave":return TS;case"message":{var S=Eb();switch(S){case ru:return mh;case cv:return TS;case Zm:case dv:return of;case _g:return Vp;default:return of}}default:return of}}function EI(v,S,P){return v.addEventListener(S,P,!1),P}function vm(v,S,P){return v.addEventListener(S,P,!0),P}function ym(v,S,P,G){return v.addEventListener(S,P,{capture:!0,passive:G}),P}function w0(v,S,P,G){return v.addEventListener(S,P,{passive:G}),P}var Sm=null,GT=null,_S=null;function ES(v){return Sm=v,GT=AS(),!0}function AI(){Sm=null,GT=null,_S=null}function wg(){if(_S)return _S;var v,S=GT,P=S.length,G,Q=AS(),me=Q.length;for(v=0;v<P&&S[v]===Q[v];v++);var De=P-v;for(G=1;G<=De&&S[P-G]===Q[me-G];G++);var We=G>1?1-G:void 0;return _S=Q.slice(v,We),_S}function AS(){return"value"in Sm?Sm.value:Sm.textContent}function vy(v){var S,P=v.keyCode;return"charCode"in v?(S=v.charCode,S===0&&P===13&&(S=13)):S=P,S===10&&(S=13),S>=32||S===13?S:0}function cl(){return!0}function Mb(){return!1}function rd(v){function S(P,G,Q,me,De){this._reactName=P,this._targetInst=Q,this.type=G,this.nativeEvent=me,this.target=De,this.currentTarget=null;for(var We in v)if(v.hasOwnProperty(We)){var rt=v[We];rt?this[We]=rt(me):this[We]=me[We]}var _t=me.defaultPrevented!=null?me.defaultPrevented:me.returnValue===!1;return _t?this.isDefaultPrevented=cl:this.isDefaultPrevented=Mb,this.isPropagationStopped=Mb,this}return Za(S.prototype,{preventDefault:function(){this.defaultPrevented=!0;var P=this.nativeEvent;P&&(P.preventDefault?P.preventDefault():typeof P.returnValue!="unknown"&&(P.returnValue=!1),this.isDefaultPrevented=cl)},stopPropagation:function(){var P=this.nativeEvent;P&&(P.stopPropagation?P.stopPropagation():typeof P.cancelBubble!="unknown"&&(P.cancelBubble=!0),this.isPropagationStopped=cl)},persist:function(){},isPersistent:cl}),S}var Iu={eventPhase:0,bubbles:0,cancelable:0,timeStamp:function(v){return v.timeStamp||Date.now()},defaultPrevented:0,isTrusted:0},yy=rd(Iu),sp=Za({},Iu,{view:0,detail:0}),qp=rd(sp),II,D_,yv;function Zk(v){v!==yv&&(yv&&v.type==="mousemove"?(II=v.screenX-yv.screenX,D_=v.screenY-yv.screenY):(II=0,D_=0),yv=v)}var lf=Za({},sp,{screenX:0,screenY:0,clientX:0,clientY:0,pageX:0,pageY:0,ctrlKey:0,shiftKey:0,altKey:0,metaKey:0,getModifierState:od,button:0,buttons:0,relatedTarget:function(v){return v.relatedTarget===void 0?v.fromElement===v.srcElement?v.toElement:v.fromElement:v.relatedTarget},movementX:function(v){return"movementX"in v?v.movementX:(Zk(v),II)},movementY:function(v){return"movementY"in v?v.movementY:D_}}),Xk=rd(lf),eR=Za({},lf,{dataTransfer:0}),IS=rd(eR),VP=Za({},sp,{relatedTarget:0}),Sy=rd(VP),XO=Za({},Iu,{animationName:0,elapsedTime:0,pseudoElement:0}),wI=rd(XO),tR=Za({},Iu,{clipboardData:function(v){return"clipboardData"in v?v.clipboardData:window.clipboardData}}),k0=rd(tR),$P=Za({},Iu,{data:0}),HP=rd($P),kI=HP,jP={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qT={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"};function e1(v){if(v.key){var S=jP[v.key]||v.key;if(S!=="Unidentified")return S}if(v.type==="keypress"){var P=vy(v);return P===13?"Enter":String.fromCharCode(P)}return v.type==="keydown"||v.type==="keyup"?qT[v.keyCode]||"Unidentified":""}var L_={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function t1(v){var S=this,P=S.nativeEvent;if(P.getModifierState)return P.getModifierState(v);var G=L_[v];return G?!!P[G]:!1}function od(v){return t1}var i1=Za({},sp,{key:e1,code:0,location:0,ctrlKey:0,shiftKey:0,altKey:0,metaKey:0,repeat:0,locale:0,getModifierState:od,charCode:function(v){return v.type==="keypress"?vy(v):0},keyCode:function(v){return v.type==="keydown"||v.type==="keyup"?v.keyCode:0},which:function(v){return v.type==="keypress"?vy(v):v.type==="keydown"||v.type==="keyup"?v.keyCode:0}}),n1=rd(i1),iR=Za({},lf,{pointerId:0,width:0,height:0,pressure:0,tangentialPressure:0,tiltX:0,tiltY:0,twist:0,pointerType:0,isPrimary:0}),Pb=rd(iR),RI=Za({},sp,{touches:0,targetTouches:0,changedTouches:0,altKey:0,metaKey:0,ctrlKey:0,shiftKey:0,getModifierState:od}),O_=rd(RI),GP=Za({},Iu,{propertyName:0,elapsedTime:0,pseudoElement:0}),Wp=rd(GP),qP=Za({},lf,{deltaX:function(v){return"deltaX"in v?v.deltaX:"wheelDeltaX"in v?-v.wheelDeltaX:0},deltaY:function(v){return"deltaY"in v?v.deltaY:"wheelDeltaY"in v?-v.wheelDeltaY:"wheelDelta"in v?-v.wheelDelta:0},deltaZ:0,deltaMode:0}),nR=rd(qP),Db=[9,13,27,32],N_=229,lu=vt&&"CompositionEvent"in window,WT=null;vt&&"documentMode"in document&&(WT=document.documentMode);var aR=vt&&"TextEvent"in window&&!WT,R0=vt&&(!lu||WT&&WT>8&&WT<=11),a1=32,rR=String.fromCharCode(a1);function r1(){Mt("onBeforeInput",["compositionend","keypress","textInput","paste"]),Mt("onCompositionEnd",["compositionend","focusout","keydown","keypress","keyup","mousedown"]),Mt("onCompositionStart",["compositionstart","focusout","keydown","keypress","keyup","mousedown"]),Mt("onCompositionUpdate",["compositionupdate","focusout","keydown","keypress","keyup","mousedown"])}var MI=!1;function oR(v){return(v.ctrlKey||v.altKey||v.metaKey)&&!(v.ctrlKey&&v.altKey)}function sR(v){switch(v){case"compositionstart":return"onCompositionStart";case"compositionend":return"onCompositionEnd";case"compositionupdate":return"onCompositionUpdate"}}function wS(v,S){return v==="keydown"&&S.keyCode===N_}function lR(v,S){switch(v){case"keyup":return Db.indexOf(S.keyCode)!==-1;case"keydown":return S.keyCode!==N_;case"keypress":case"mousedown":case"focusout":return!0;default:return!1}}function M0(v){var S=v.detail;return typeof S=="object"&&"data"in S?S.data:null}function PI(v){return v.locale==="ko"}var KT=!1;function WP(v,S,P,G,Q){var me,De;if(lu?me=sR(S):KT?lR(S,G)&&(me="onCompositionEnd"):wS(S,G)&&(me="onCompositionStart"),!me)return null;R0&&!PI(G)&&(!KT&&me==="onCompositionStart"?KT=ES(Q):me==="onCompositionEnd"&&KT&&(De=wg()));var We=jl(P,me);if(We.length>0){var rt=new HP(me,S,null,G,Q);if(v.push({event:rt,listeners:We}),De)rt.data=De;else{var _t=M0(G);_t!==null&&(rt.data=_t)}}}function DI(v,S){switch(v){case"compositionend":return M0(S);case"keypress":var P=S.which;return P!==a1?null:(MI=!0,rR);case"textInput":var G=S.data;return G===rR&&MI?null:G;default:return null}}function cR(v,S){if(KT){if(v==="compositionend"||!lu&&lR(v,S)){var P=wg();return AI(),KT=!1,P}return null}switch(v){case"paste":return null;case"keypress":if(!oR(S)){if(S.char&&S.char.length>1)return S.char;if(S.which)return String.fromCharCode(S.which)}return null;case"compositionend":return R0&&!PI(S)?null:S.data;default:return null}}function LI(v,S,P,G,Q){var me;if(aR?me=DI(S,G):me=cR(S,G),!me)return null;var De=jl(P,"onBeforeInput");if(De.length>0){var We=new kI("onBeforeInput","beforeinput",null,G,Q);v.push({event:We,listeners:De}),We.data=me}}function o1(v,S,P,G,Q,me,De){WP(v,S,P,G,Q),LI(v,S,P,G,Q)}var KP={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function by(v){var S=v&&v.nodeName&&v.nodeName.toLowerCase();return S==="input"?!!KP[v.type]:S==="textarea"}/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */function dR(v){if(!vt)return!1;var S="on"+v,P=S in document;if(!P){var G=document.createElement("div");G.setAttribute(S,"return;"),P=typeof G[S]=="function"}return P}function x_(){Mt("onChange",["change","click","focusin","focusout","input","keydown","keyup","selectionchange"])}function JT(v,S,P,G){ty(G);var Q=jl(S,"onChange");if(Q.length>0){var me=new yy("onChange","change",null,P,G);v.push({event:me,listeners:Q})}}var Ty=null,A=null;function R(v){var S=v.nodeName&&v.nodeName.toLowerCase();return S==="select"||S==="input"&&v.type==="file"}function K(v){var S=[];JT(S,A,v,Uk(v)),dS(ae,S)}function ae(v){z_(v,0)}function Ce(v){var S=ec(v);if(dh(S))return v}function Ve(v,S){if(v==="change")return S}var mt=!1;vt&&(mt=dR("input")&&(!document.documentMode||document.documentMode>9));function Xt(v,S){Ty=v,A=S,Ty.attachEvent("onpropertychange",Zi)}function Si(){Ty&&(Ty.detachEvent("onpropertychange",Zi),Ty=null,A=null)}function Zi(v){v.propertyName==="value"&&Ce(A)&&K(v)}function Kn(v,S,P){v==="focusin"?(Si(),Xt(S,P)):v==="focusout"&&Si()}function Zn(v,S){if(v==="selectionchange"||v==="keyup"||v==="keydown")return Ce(A)}function Gn(v){var S=v.nodeName;return S&&S.toLowerCase()==="input"&&(v.type==="checkbox"||v.type==="radio")}function Ka(v,S){if(v==="click")return Ce(S)}function br(v,S){if(v==="input"||v==="change")return Ce(S)}function Tr(v){var S=v._wrapperState;!S||!S.controlled||v.type!=="number"||no(v,"number",v.value)}function Ud(v,S,P,G,Q,me,De){var We=P?ec(P):window,rt,_t;if(R(We)?rt=Ve:by(We)?mt?rt=br:(rt=Zn,_t=Kn):Gn(We)&&(rt=Ka),rt){var Ut=rt(S,P);if(Ut){JT(v,Ut,G,Q);return}}_t&&_t(S,We,P),S==="focusout"&&Tr(We)}function Vi(){ht("onMouseEnter",["mouseout","mouseover"]),ht("onMouseLeave",["mouseout","mouseover"]),ht("onPointerEnter",["pointerout","pointerover"]),ht("onPointerLeave",["pointerout","pointerover"])}function Mi(v,S,P,G,Q,me,De){var We=S==="mouseover"||S==="pointerover",rt=S==="mouseout"||S==="pointerout";if(We&&!_u(G)){var _t=G.relatedTarget||G.fromElement;if(_t&&(Qo(_t)||bo(_t)))return}if(!(!rt&&!We)){var Ut;if(Q.window===Q)Ut=Q;else{var Di=Q.ownerDocument;Di?Ut=Di.defaultView||Di.parentWindow:Ut=window}var Ri,Xi;if(rt){var tn=G.relatedTarget||G.toElement;if(Ri=P,Xi=tn?Qo(tn):null,Xi!==null){var Cn=sm(Xi);(Xi!==Cn||Xi.tag!==C&&Xi.tag!==E)&&(Xi=null)}}else Ri=null,Xi=P;if(Ri!==Xi){var Ja=Xk,po="onMouseLeave",Gr="onMouseEnter",Dl="mouse";(S==="pointerout"||S==="pointerover")&&(Ja=Pb,po="onPointerLeave",Gr="onPointerEnter",Dl="pointer");var hl=Ri==null?Ut:ec(Ri),qi=Xi==null?Ut:ec(Xi),bn=new Ja(po,Dl+"leave",Ri,G,Q);bn.target=hl,bn.relatedTarget=qi;var Wi=null,ca=Qo(Q);if(ca===P){var fr=new Ja(Gr,Dl+"enter",Xi,G,Q);fr.target=qi,fr.relatedTarget=hl,Wi=fr}iz(v,bn,Wi,Ri,Xi)}}}function Yi(v,S){return v===S&&(v!==0||1/v===1/S)||v!==v&&S!==S}var Jn=typeof Object.is=="function"?Object.is:Yi;function Cr(v,S){if(Jn(v,S))return!0;if(typeof v!="object"||v===null||typeof S!="object"||S===null)return!1;var P=Object.keys(v),G=Object.keys(S);if(P.length!==G.length)return!1;for(var Q=0;Q<P.length;Q++){var me=P[Q];if(!Pt.call(S,me)||!Jn(v[me],S[me]))return!1}return!0}function lo(v){for(;v&&v.firstChild;)v=v.firstChild;return v}function ho(v){for(;v;){if(v.nextSibling)return v.nextSibling;v=v.parentNode}}function Hr(v,S){for(var P=lo(v),G=0,Q=0;P;){if(P.nodeType===tv){if(Q=G+P.textContent.length,G<=S&&Q>=S)return{node:P,offset:S-G};G=Q}P=lo(ho(P))}}function yh(v){var S=v.ownerDocument,P=S&&S.defaultView||window,G=P.getSelection&&P.getSelection();if(!G||G.rangeCount===0)return null;var Q=G.anchorNode,me=G.anchorOffset,De=G.focusNode,We=G.focusOffset;try{Q.nodeType,De.nodeType}catch{return null}return Tl(v,Q,me,De,We)}function Tl(v,S,P,G,Q){var me=0,De=-1,We=-1,rt=0,_t=0,Ut=v,Di=null;e:for(;;){for(var Ri=null;Ut===S&&(P===0||Ut.nodeType===tv)&&(De=me+P),Ut===G&&(Q===0||Ut.nodeType===tv)&&(We=me+Q),Ut.nodeType===tv&&(me+=Ut.nodeValue.length),(Ri=Ut.firstChild)!==null;)Di=Ut,Ut=Ri;for(;;){if(Ut===v)break e;if(Di===S&&++rt===P&&(De=me),Di===G&&++_t===Q&&(We=me),(Ri=Ut.nextSibling)!==null)break;Ut=Di,Di=Ut.parentNode}Ut=Ri}return De===-1||We===-1?null:{start:De,end:We}}function YT(v,S){var P=v.ownerDocument||document,G=P&&P.defaultView||window;if(G.getSelection){var Q=G.getSelection(),me=v.textContent.length,De=Math.min(S.start,me),We=S.end===void 0?De:Math.min(S.end,me);if(!Q.extend&&De>We){var rt=We;We=De,De=rt}var _t=Hr(v,De),Ut=Hr(v,We);if(_t&&Ut){if(Q.rangeCount===1&&Q.anchorNode===_t.node&&Q.anchorOffset===_t.offset&&Q.focusNode===Ut.node&&Q.focusOffset===Ut.offset)return;var Di=P.createRange();Di.setStart(_t.node,_t.offset),Q.removeAllRanges(),De>We?(Q.addRange(Di),Q.extend(Ut.node,Ut.offset)):(Di.setEnd(Ut.node,Ut.offset),Q.addRange(Di))}}}function JP(v){return v&&v.nodeType===tv}function Cy(v,S){return!v||!S?!1:v===S?!0:JP(v)?!1:JP(S)?Cy(v,S.parentNode):"contains"in v?v.contains(S):v.compareDocumentPosition?!!(v.compareDocumentPosition(S)&16):!1}function J4(v){return v&&v.ownerDocument&&Cy(v.ownerDocument.documentElement,v)}function Y4(v){try{return typeof v.contentWindow.location.href=="string"}catch{return!1}}function B_(){for(var v=window,S=bd();S instanceof v.HTMLIFrameElement;){if(Y4(S))v=S.contentWindow;else return S;S=bd(v.document)}return S}function Yo(v){var S=v&&v.nodeName&&v.nodeName.toLowerCase();return S&&(S==="input"&&(v.type==="text"||v.type==="search"||v.type==="tel"||v.type==="url"||v.type==="password")||S==="textarea"||v.contentEditable==="true")}function YP(){var v=B_();return{focusedElem:v,selectionRange:Yo(v)?Ku(v):null}}function kg(v){var S=B_(),P=v.focusedElem,G=v.selectionRange;if(S!==P&&J4(P)){G!==null&&Yo(P)&&Q4(P,G);for(var Q=[],me=P;me=me.parentNode;)me.nodeType===am&&Q.push({element:me,left:me.scrollLeft,top:me.scrollTop});typeof P.focus=="function"&&P.focus();for(var De=0;De<Q.length;De++){var We=Q[De];We.element.scrollLeft=We.left,We.element.scrollTop=We.top}}}function Ku(v){var S;return"selectionStart"in v?S={start:v.selectionStart,end:v.selectionEnd}:S=yh(v),S||{start:0,end:0}}function Q4(v,S){var P=S.start,G=S.end;G===void 0&&(G=P),"selectionStart"in v?(v.selectionStart=P,v.selectionEnd=Math.min(G,v.value.length)):YT(v,S)}var F_=vt&&"documentMode"in document&&document.documentMode<=11;function Z4(){Mt("onSelect",["focusout","contextmenu","dragend","focusin","keydown","keyup","mousedown","mouseup","selectionchange"])}var OI=null,TF=null,QP=null,CF=!1;function uR(v){if("selectionStart"in v&&Yo(v))return{start:v.selectionStart,end:v.selectionEnd};var S=v.ownerDocument&&v.ownerDocument.defaultView||window,P=S.getSelection();return{anchorNode:P.anchorNode,anchorOffset:P.anchorOffset,focusNode:P.focusNode,focusOffset:P.focusOffset}}function i7(v){return v.window===v?v.document:v.nodeType===vb?v:v.ownerDocument}function Lb(v,S,P){var G=i7(P);if(!(CF||OI==null||OI!==bd(G))){var Q=uR(OI);if(!QP||!Cr(QP,Q)){QP=Q;var me=jl(TF,"onSelect");if(me.length>0){var De=new yy("onSelect","select",null,S,P);v.push({event:De,listeners:me}),De.target=OI}}}}function s1(v,S,P,G,Q,me,De){var We=P?ec(P):window;switch(S){case"focusin":(by(We)||We.contentEditable==="true")&&(OI=We,TF=P,QP=null);break;case"focusout":OI=null,TF=null,QP=null;break;case"mousedown":CF=!0;break;case"contextmenu":case"mouseup":case"dragend":CF=!1,Lb(v,G,Q);break;case"selectionchange":if(F_)break;case"keydown":case"keyup":Lb(v,G,Q)}}function P0(v,S){var P={};return P[v.toLowerCase()]=S.toLowerCase(),P["Webkit"+v]="webkit"+S,P["Moz"+v]="moz"+S,P}var Oc={animationend:P0("Animation","AnimationEnd"),animationiteration:P0("Animation","AnimationIteration"),animationstart:P0("Animation","AnimationStart"),transitionend:P0("Transition","TransitionEnd")},cu={},l1={};vt&&(l1=document.createElement("div").style,"AnimationEvent"in window||(delete Oc.animationend.animation,delete Oc.animationiteration.animation,delete Oc.animationstart.animation),"TransitionEvent"in window||delete Oc.transitionend.transition);function c1(v){if(cu[v])return cu[v];if(!Oc[v])return v;var S=Oc[v];for(var P in S)if(S.hasOwnProperty(P)&&P in l1)return cu[v]=S[P];return v}var hR=c1("animationend"),d1=c1("animationiteration"),u1=c1("animationstart"),X4=c1("transitionend"),ez=new Map,D0=["abort","auxClick","cancel","canPlay","canPlayThrough","click","close","contextMenu","copy","cut","drag","dragEnd","dragEnter","dragExit","dragLeave","dragOver","dragStart","drop","durationChange","emptied","encrypted","ended","error","gotPointerCapture","input","invalid","keyDown","keyPress","keyUp","load","loadedData","loadedMetadata","loadStart","lostPointerCapture","mouseDown","mouseMove","mouseOut","mouseOver","mouseUp","paste","pause","play","playing","pointerCancel","pointerDown","pointerMove","pointerOut","pointerOver","pointerUp","progress","rateChange","reset","resize","seeked","seeking","stalled","submit","suspend","timeUpdate","touchCancel","touchEnd","touchStart","volumeChange","scroll","toggle","touchMove","waiting","wheel"];function kS(v,S){ez.set(v,S),Mt(S,[v])}function NI(){for(var v=0;v<D0.length;v++){var S=D0[v],P=S.toLowerCase(),G=S[0].toUpperCase()+S.slice(1);kS(P,"on"+G)}kS(hR,"onAnimationEnd"),kS(d1,"onAnimationIteration"),kS(u1,"onAnimationStart"),kS("dblclick","onDoubleClick"),kS("focusin","onFocus"),kS("focusout","onBlur"),kS(X4,"onTransitionEnd")}function n7(v,S,P,G,Q,me,De){var We=ez.get(S);if(We!==void 0){var rt=yy,_t=S;switch(S){case"keypress":if(vy(G)===0)return;case"keydown":case"keyup":rt=n1;break;case"focusin":_t="focus",rt=Sy;break;case"focusout":_t="blur",rt=Sy;break;case"beforeblur":case"afterblur":rt=Sy;break;case"click":if(G.button===2)return;case"auxclick":case"dblclick":case"mousedown":case"mousemove":case"mouseup":case"mouseout":case"mouseover":case"contextmenu":rt=Xk;break;case"drag":case"dragend":case"dragenter":case"dragexit":case"dragleave":case"dragover":case"dragstart":case"drop":rt=IS;break;case"touchcancel":case"touchend":case"touchmove":case"touchstart":rt=O_;break;case hR:case d1:case u1:rt=wI;break;case X4:rt=Wp;break;case"scroll":rt=qp;break;case"wheel":rt=nR;break;case"copy":case"cut":case"paste":rt=k0;break;case"gotpointercapture":case"lostpointercapture":case"pointercancel":case"pointerdown":case"pointermove":case"pointerout":case"pointerover":case"pointerup":rt=Pb;break}var Ut=(me&av)!==0;{var Di=!Ut&&S==="scroll",Ri=RS(P,We,G.type,Ut,Di);if(Ri.length>0){var Xi=new rt(We,_t,null,G,Q);v.push({event:Xi,listeners:Ri})}}}}NI(),Vi(),x_(),Z4(),r1();function tz(v,S,P,G,Q,me,De){n7(v,S,P,G,Q,me);var We=(me&xP)===0;We&&(Mi(v,S,P,G,Q),Ud(v,S,P,G,Q),s1(v,S,P,G,Q),o1(v,S,P,G,Q))}var U_=["abort","canplay","canplaythrough","durationchange","emptied","encrypted","ended","error","loadeddata","loadedmetadata","loadstart","pause","play","playing","progress","ratechange","resize","seeked","seeking","stalled","suspend","timeupdate","volumechange","waiting"],cf=new Set(["cancel","close","invalid","load","scroll","toggle"].concat(U_));function L0(v,S,P){var G=v.type||"unknown-event";v.currentTarget=P,Lo(G,S,void 0,v),v.currentTarget=null}function a7(v,S,P){var G;if(P)for(var Q=S.length-1;Q>=0;Q--){var me=S[Q],De=me.instance,We=me.currentTarget,rt=me.listener;if(De!==G&&v.isPropagationStopped())return;L0(v,rt,We),G=De}else for(var _t=0;_t<S.length;_t++){var Ut=S[_t],Di=Ut.instance,Ri=Ut.currentTarget,Xi=Ut.listener;if(Di!==G&&v.isPropagationStopped())return;L0(v,Xi,Ri),G=Di}}function z_(v,S){for(var P=(S&av)!==0,G=0;G<v.length;G++){var Q=v[G],me=Q.event,De=Q.listeners;a7(me,De,P)}oI()}function pR(v,S,P,G,Q){var me=Uk(P),De=[];tz(De,v,G,P,me,S),z_(De,S)}function zd(v,S){cf.has(v)||d('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.',v);var P=!1,G=Ay(S),Q=r7(v);G.has(Q)||(Es(S,v,nv,P),G.add(Q))}function h1(v,S,P){cf.has(v)&&!S&&d('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.',v);var G=0;S&&(G|=av),Es(P,v,G,S)}var xI="_reactListening"+Math.random().toString(36).slice(2);function Sv(v){if(!v[xI]){v[xI]=!0,Ge.forEach(function(P){P!=="selectionchange"&&(cf.has(P)||h1(P,!1,v),h1(P,!0,v))});var S=v.nodeType===vb?v:v.ownerDocument;S!==null&&(S[xI]||(S[xI]=!0,h1("selectionchange",!1,S)))}}function Es(v,S,P,G,Q){var me=vh(v,S,P),De=void 0;p_&&(S==="touchstart"||S==="touchmove"||S==="wheel")&&(De=!0),v=v,G?De!==void 0?ym(v,S,me,De):vm(v,S,me):De!==void 0?w0(v,S,me,De):EI(v,S,me)}function _F(v,S){return v===S||v.nodeType===$u&&v.parentNode===S}function Sh(v,S,P,G,Q){var me=G;if((S&ey)===0&&(S&nv)===0){var De=Q;if(G!==null){var We=G;e:for(;;){if(We===null)return;var rt=We.tag;if(rt===y||rt===T){var _t=We.stateNode.containerInfo;if(_F(_t,De))break;if(rt===T)for(var Ut=We.return;Ut!==null;){var Di=Ut.tag;if(Di===y||Di===T){var Ri=Ut.stateNode.containerInfo;if(_F(Ri,De))return}Ut=Ut.return}for(;_t!==null;){var Xi=Qo(_t);if(Xi===null)return;var tn=Xi.tag;if(tn===C||tn===E){We=me=Xi;continue e}_t=_t.parentNode}}We=We.return}}}dS(function(){return pR(v,S,P,me)})}function BI(v,S,P){return{instance:v,listener:S,currentTarget:P}}function RS(v,S,P,G,Q,me){for(var De=S!==null?S+"Capture":null,We=G?De:S,rt=[],_t=v,Ut=null;_t!==null;){var Di=_t,Ri=Di.stateNode,Xi=Di.tag;if(Xi===C&&Ri!==null&&(Ut=Ri,We!==null)){var tn=Sg(_t,We);tn!=null&&rt.push(BI(_t,tn,Ut))}if(Q)break;_t=_t.return}return rt}function jl(v,S){for(var P=S+"Capture",G=[],Q=v;Q!==null;){var me=Q,De=me.stateNode,We=me.tag;if(We===C&&De!==null){var rt=De,_t=Sg(Q,P);_t!=null&&G.unshift(BI(Q,_t,rt));var Ut=Sg(Q,S);Ut!=null&&G.push(BI(Q,Ut,rt))}Q=Q.return}return G}function O0(v){if(v===null)return null;do v=v.return;while(v&&v.tag!==C);return v||null}function p1(v,S){for(var P=v,G=S,Q=0,me=P;me;me=O0(me))Q++;for(var De=0,We=G;We;We=O0(We))De++;for(;Q-De>0;)P=O0(P),Q--;for(;De-Q>0;)G=O0(G),De--;for(var rt=Q;rt--;){if(P===G||G!==null&&P===G.alternate)return P;P=O0(P),G=O0(G)}return null}function gR(v,S,P,G,Q){for(var me=S._reactName,De=[],We=P;We!==null&&We!==G;){var rt=We,_t=rt.alternate,Ut=rt.stateNode,Di=rt.tag;if(_t!==null&&_t===G)break;if(Di===C&&Ut!==null){var Ri=Ut;if(Q){var Xi=Sg(We,me);Xi!=null&&De.unshift(BI(We,Xi,Ri))}else if(!Q){var tn=Sg(We,me);tn!=null&&De.push(BI(We,tn,Ri))}}We=We.return}De.length!==0&&v.push({event:S,listeners:De})}function iz(v,S,P,G,Q){var me=G&&Q?p1(G,Q):null;G!==null&&gR(v,S,G,me,!1),Q!==null&&P!==null&&gR(v,P,Q,me,!0)}function r7(v,S){return v+"__bubble"}var bh=!1,ZP="dangerouslySetInnerHTML",g1="suppressContentEditableWarning",N0="suppressHydrationWarning",EF="autoFocus",_y="children",x0="style",FI="__html",MS,m1,XP,f1,UI,mR,nz;MS={dialog:!0,webview:!0},m1=function(v,S){OP(v,S),Xv(v,S),r0(v,S,{registrationNameDependencies:tt,possibleRegistrationNames:ct})},mR=vt&&!document.documentMode,XP=function(v,S,P){if(!bh){var G=Th(P),Q=Th(S);Q!==G&&(bh=!0,d("Prop `%s` did not match. Server: %s Client: %s",v,JSON.stringify(Q),JSON.stringify(G)))}},f1=function(v){if(!bh){bh=!0;var S=[];v.forEach(function(P){S.push(P)}),d("Extra attributes from the server: %s",S)}},UI=function(v,S){S===!1?d("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.",v,v,v):d("Expected `%s` listener to be a function, instead got a value of `%s` type.",v,typeof S)},nz=function(v,S){var P=v.namespaceURI===hh?v.ownerDocument.createElement(v.tagName):v.ownerDocument.createElementNS(v.namespaceURI,v.tagName);return P.innerHTML=S,P.innerHTML};var eD=/\r\n?/g,o7=/\u0000|\uFFFD/g;function Th(v){Nt(v);var S=typeof v=="string"?v:""+v;return S.replace(eD,`
`).replace(o7,"")}function Rg(v,S,P,G){var Q=Th(S),me=Th(v);if(me!==Q&&(G&&(bh||(bh=!0,d('Text content did not match. Server: "%s" Client: "%s"',me,Q))),P&&pe))throw new Error("Text content does not match server-rendered HTML.")}function az(v){return v.nodeType===vb?v:v.ownerDocument}function s7(){}function zI(v){v.onclick=s7}function rz(v,S,P,G,Q){for(var me in G)if(G.hasOwnProperty(me)){var De=G[me];if(me===x0)De&&Object.freeze(De),eu(S,De);else if(me===ZP){var We=De?De[FI]:void 0;We!=null&&Yv(S,We)}else if(me===_y)if(typeof De=="string"){var rt=v!=="textarea"||De!=="";rt&&rm(S,De)}else typeof De=="number"&&rm(S,""+De);else me===g1||me===N0||me===EF||(tt.hasOwnProperty(me)?De!=null&&(typeof De!="function"&&UI(me,De),me==="onScroll"&&zd("scroll",S)):De!=null&&us(S,me,De,Q))}}function l7(v,S,P,G){for(var Q=0;Q<S.length;Q+=2){var me=S[Q],De=S[Q+1];me===x0?eu(v,De):me===ZP?Yv(v,De):me===_y?rm(v,De):us(v,me,De,G)}}function B0(v,S,P,G){var Q,me=az(P),De,We=G;if(We===hh&&(We=vg(v)),We===hh){if(Q=Zv(v,S),!Q&&v!==v.toLowerCase()&&d("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.",v),v==="script"){var rt=me.createElement("div");rt.innerHTML="<script><\/script>";var _t=rt.firstChild;De=rt.removeChild(_t)}else if(typeof S.is=="string")De=me.createElement(v,{is:S.is});else if(De=me.createElement(v),v==="select"){var Ut=De;S.multiple?Ut.multiple=!0:S.size&&(Ut.size=S.size)}}else De=me.createElementNS(We,v);return We===hh&&!Q&&Object.prototype.toString.call(De)==="[object HTMLUnknownElement]"&&!Pt.call(MS,v)&&(MS[v]=!0,d("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.",v)),De}function AF(v,S){return az(S).createTextNode(v)}function oz(v,S,P,G){var Q=Zv(S,P);m1(S,P);var me;switch(S){case"dialog":zd("cancel",v),zd("close",v),me=P;break;case"iframe":case"object":case"embed":zd("load",v),me=P;break;case"video":case"audio":for(var De=0;De<U_.length;De++)zd(U_[De],v);me=P;break;case"source":zd("error",v),me=P;break;case"img":case"image":case"link":zd("error",v),zd("load",v),me=P;break;case"details":zd("toggle",v),me=P;break;case"input":qm(v,P),me=gb(v,P),zd("invalid",v);break;case"option":_s(v,P),me=P;break;case"select":aS(v,P),me=XE(v,P),zd("invalid",v);break;case"textarea":CT(v,P),me=e0(v,P),zd("invalid",v);break;default:me=P}switch(Sb(S,me),rz(S,v,G,me,Q),S){case"input":Os(v),Gi(v,P,!1);break;case"textarea":Os(v),Vu(v);break;case"option":_o(v,P);break;case"select":nm(v,P);break;default:typeof me.onClick=="function"&&zI(v);break}}function sz(v,S,P,G,Q){m1(S,G);var me=null,De,We;switch(S){case"input":De=gb(v,P),We=gb(v,G),me=[];break;case"select":De=XE(v,P),We=XE(v,G),me=[];break;case"textarea":De=e0(v,P),We=e0(v,G),me=[];break;default:De=P,We=G,typeof De.onClick!="function"&&typeof We.onClick=="function"&&zI(v);break}Sb(S,We);var rt,_t,Ut=null;for(rt in De)if(!(We.hasOwnProperty(rt)||!De.hasOwnProperty(rt)||De[rt]==null))if(rt===x0){var Di=De[rt];for(_t in Di)Di.hasOwnProperty(_t)&&(Ut||(Ut={}),Ut[_t]="")}else rt===ZP||rt===_y||rt===g1||rt===N0||rt===EF||(tt.hasOwnProperty(rt)?me||(me=[]):(me=me||[]).push(rt,null));for(rt in We){var Ri=We[rt],Xi=De?.[rt];if(!(!We.hasOwnProperty(rt)||Ri===Xi||Ri==null&&Xi==null))if(rt===x0)if(Ri&&Object.freeze(Ri),Xi){for(_t in Xi)Xi.hasOwnProperty(_t)&&(!Ri||!Ri.hasOwnProperty(_t))&&(Ut||(Ut={}),Ut[_t]="");for(_t in Ri)Ri.hasOwnProperty(_t)&&Xi[_t]!==Ri[_t]&&(Ut||(Ut={}),Ut[_t]=Ri[_t])}else Ut||(me||(me=[]),me.push(rt,Ut)),Ut=Ri;else if(rt===ZP){var tn=Ri?Ri[FI]:void 0,Cn=Xi?Xi[FI]:void 0;tn!=null&&Cn!==tn&&(me=me||[]).push(rt,tn)}else rt===_y?(typeof Ri=="string"||typeof Ri=="number")&&(me=me||[]).push(rt,""+Ri):rt===g1||rt===N0||(tt.hasOwnProperty(rt)?(Ri!=null&&(typeof Ri!="function"&&UI(rt,Ri),rt==="onScroll"&&zd("scroll",v)),!me&&Xi!==Ri&&(me=[])):(me=me||[]).push(rt,Ri))}return Ut&&(WO(Ut,We[x0]),(me=me||[]).push(x0,Ut)),me}function c7(v,S,P,G,Q){P==="input"&&Q.type==="radio"&&Q.name!=null&&st(v,Q);var me=Zv(P,G),De=Zv(P,Q);switch(l7(v,S,me,De),P){case"input":di(v,Q);break;case"textarea":_T(v,Q);break;case"select":Ok(v,Q);break}}function d7(v){{var S=v.toLowerCase();return IT.hasOwnProperty(S)&&IT[S]||null}}function IF(v,S,P,G,Q,me,De){var We,rt;switch(We=Zv(S,P),m1(S,P),S){case"dialog":zd("cancel",v),zd("close",v);break;case"iframe":case"object":case"embed":zd("load",v);break;case"video":case"audio":for(var _t=0;_t<U_.length;_t++)zd(U_[_t],v);break;case"source":zd("error",v);break;case"img":case"image":case"link":zd("error",v),zd("load",v);break;case"details":zd("toggle",v);break;case"input":qm(v,P),zd("invalid",v);break;case"option":_s(v,P);break;case"select":aS(v,P),zd("invalid",v);break;case"textarea":CT(v,P),zd("invalid",v);break}Sb(S,P);{rt=new Set;for(var Ut=v.attributes,Di=0;Di<Ut.length;Di++){var Ri=Ut[Di].name.toLowerCase();switch(Ri){case"value":break;case"checked":break;case"selected":break;default:rt.add(Ut[Di].name)}}}var Xi=null;for(var tn in P)if(P.hasOwnProperty(tn)){var Cn=P[tn];if(tn===_y)typeof Cn=="string"?v.textContent!==Cn&&(P[N0]!==!0&&Rg(v.textContent,Cn,me,De),Xi=[_y,Cn]):typeof Cn=="number"&&v.textContent!==""+Cn&&(P[N0]!==!0&&Rg(v.textContent,Cn,me,De),Xi=[_y,""+Cn]);else if(tt.hasOwnProperty(tn))Cn!=null&&(typeof Cn!="function"&&UI(tn,Cn),tn==="onScroll"&&zd("scroll",v));else if(De&&typeof We=="boolean"){var Ja=void 0,po=qt(tn);if(P[N0]!==!0){if(!(tn===g1||tn===N0||tn==="value"||tn==="checked"||tn==="selected")){if(tn===ZP){var Gr=v.innerHTML,Dl=Cn?Cn[FI]:void 0;if(Dl!=null){var hl=nz(v,Dl);hl!==Gr&&XP(tn,Gr,hl)}}else if(tn===x0){if(rt.delete(tn),mR){var qi=tp(Cn);Ja=v.getAttribute("style"),qi!==Ja&&XP(tn,Ja,qi)}}else if(We)rt.delete(tn.toLowerCase()),Ja=La(v,tn,Cn),Cn!==Ja&&XP(tn,Ja,Cn);else if(!en(tn,po,We)&&!Qi(tn,Cn,po,We)){var bn=!1;if(po!==null)rt.delete(po.attributeName),Ja=Rr(v,tn,Cn,po);else{var Wi=G;if(Wi===hh&&(Wi=vg(S)),Wi===hh)rt.delete(tn.toLowerCase());else{var ca=d7(tn);ca!==null&&ca!==tn&&(bn=!0,rt.delete(ca)),rt.delete(tn)}Ja=La(v,tn,Cn)}var fr=X;!fr&&Cn!==Ja&&!bn&&XP(tn,Ja,Cn)}}}}}switch(De&&rt.size>0&&P[N0]!==!0&&f1(rt),S){case"input":Os(v),Gi(v,P,!0);break;case"textarea":Os(v),Vu(v);break;case"select":case"option":break;default:typeof P.onClick=="function"&&zI(v);break}return Xi}function v1(v,S,P){var G=v.nodeValue!==S;return G}function fR(v,S){{if(bh)return;bh=!0,d("Did not expect server HTML to contain a <%s> in <%s>.",S.nodeName.toLowerCase(),v.nodeName.toLowerCase())}}function VI(v,S){{if(bh)return;bh=!0,d('Did not expect server HTML to contain the text node "%s" in <%s>.',S.nodeValue,v.nodeName.toLowerCase())}}function wF(v,S,P){{if(bh)return;bh=!0,d("Expected server HTML to contain a matching <%s> in <%s>.",S,v.nodeName.toLowerCase())}}function kF(v,S){{if(S===""||bh)return;bh=!0,d('Expected server HTML to contain a matching text node for "%s" in <%s>.',S,v.nodeName.toLowerCase())}}function vR(v,S,P){switch(S){case"input":un(v,P);return;case"textarea":Nk(v,P);return;case"select":Wm(v,P);return}}var $I=function(){},yR=function(){};{var RF=["address","applet","area","article","aside","base","basefont","bgsound","blockquote","body","br","button","caption","center","col","colgroup","dd","details","dir","div","dl","dt","embed","fieldset","figcaption","figure","footer","form","frame","frameset","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","iframe","img","input","isindex","li","link","listing","main","marquee","menu","menuitem","meta","nav","noembed","noframes","noscript","object","ol","p","param","plaintext","pre","script","section","select","source","style","summary","table","tbody","td","template","textarea","tfoot","th","thead","title","tr","track","ul","wbr","xmp"],y1=["applet","caption","html","table","td","th","marquee","object","template","foreignObject","desc","title"],MF=y1.concat(["button"]),S1=["dd","dt","li","option","optgroup","p","rp","rt"],b1={current:null,formTag:null,aTagInScope:null,buttonTagInScope:null,nobrTagInScope:null,pTagInButtonScope:null,listItemTagAutoclosing:null,dlItemTagAutoclosing:null};yR=function(v,S){var P=Za({},v||b1),G={tag:S};return y1.indexOf(S)!==-1&&(P.aTagInScope=null,P.buttonTagInScope=null,P.nobrTagInScope=null),MF.indexOf(S)!==-1&&(P.pTagInButtonScope=null),RF.indexOf(S)!==-1&&S!=="address"&&S!=="div"&&S!=="p"&&(P.listItemTagAutoclosing=null,P.dlItemTagAutoclosing=null),P.current=G,S==="form"&&(P.formTag=G),S==="a"&&(P.aTagInScope=G),S==="button"&&(P.buttonTagInScope=G),S==="nobr"&&(P.nobrTagInScope=G),S==="p"&&(P.pTagInButtonScope=G),S==="li"&&(P.listItemTagAutoclosing=G),(S==="dd"||S==="dt")&&(P.dlItemTagAutoclosing=G),P};var lz=function(v,S){switch(S){case"select":return v==="option"||v==="optgroup"||v==="#text";case"optgroup":return v==="option"||v==="#text";case"option":return v==="#text";case"tr":return v==="th"||v==="td"||v==="style"||v==="script"||v==="template";case"tbody":case"thead":case"tfoot":return v==="tr"||v==="style"||v==="script"||v==="template";case"colgroup":return v==="col"||v==="template";case"table":return v==="caption"||v==="colgroup"||v==="tbody"||v==="tfoot"||v==="thead"||v==="style"||v==="script"||v==="template";case"head":return v==="base"||v==="basefont"||v==="bgsound"||v==="link"||v==="meta"||v==="title"||v==="noscript"||v==="noframes"||v==="style"||v==="script"||v==="template";case"html":return v==="head"||v==="body"||v==="frameset";case"frameset":return v==="frame";case"#document":return v==="html"}switch(v){case"h1":case"h2":case"h3":case"h4":case"h5":case"h6":return S!=="h1"&&S!=="h2"&&S!=="h3"&&S!=="h4"&&S!=="h5"&&S!=="h6";case"rp":case"rt":return S1.indexOf(S)===-1;case"body":case"caption":case"col":case"colgroup":case"frameset":case"frame":case"head":case"html":case"tbody":case"td":case"tfoot":case"th":case"thead":case"tr":return S==null}return!0},u7=function(v,S){switch(v){case"address":case"article":case"aside":case"blockquote":case"center":case"details":case"dialog":case"dir":case"div":case"dl":case"fieldset":case"figcaption":case"figure":case"footer":case"header":case"hgroup":case"main":case"menu":case"nav":case"ol":case"p":case"section":case"summary":case"ul":case"pre":case"listing":case"table":case"hr":case"xmp":case"h1":case"h2":case"h3":case"h4":case"h5":case"h6":return S.pTagInButtonScope;case"form":return S.formTag||S.pTagInButtonScope;case"li":return S.listItemTagAutoclosing;case"dd":case"dt":return S.dlItemTagAutoclosing;case"button":return S.buttonTagInScope;case"a":return S.aTagInScope;case"nobr":return S.nobrTagInScope}return null},tD={};$I=function(v,S,P){P=P||b1;var G=P.current,Q=G&&G.tag;S!=null&&(v!=null&&d("validateDOMNesting: when childText is passed, childTag should be null"),v="#text");var me=lz(v,Q)?null:G,De=me?null:u7(v,P),We=me||De;if(We){var rt=We.tag,_t=!!me+"|"+v+"|"+rt;if(!tD[_t]){tD[_t]=!0;var Ut=v,Di="";if(v==="#text"?/\S/.test(S)?Ut="Text nodes":(Ut="Whitespace text nodes",Di=" Make sure you don't have any extra whitespace between tags on each line of your source code."):Ut="<"+v+">",me){var Ri="";rt==="table"&&v==="tr"&&(Ri+=" Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."),d("validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s",Ut,rt,Di,Ri)}else d("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.",Ut,rt)}}}}var iD="suppressHydrationWarning",SR="$",bR="/$",TR="$?",CR="$!",cz="style",nD=null,$s=null;function HI(v){var S,P,G=v.nodeType;switch(G){case vb:case kP:{S=G===vb?"#document":"#fragment";var Q=v.documentElement;P=Q?Q.namespaceURI:fb(null,"");break}default:{var me=G===$u?v.parentNode:v,De=me.namespaceURI||null;S=me.tagName,P=fb(De,S);break}}{var We=S.toLowerCase(),rt=yR(null,We);return{namespace:P,ancestorInfo:rt}}}function QT(v,S,P){{var G=v,Q=fb(G.namespace,S),me=yR(G.ancestorInfo,S);return{namespace:Q,ancestorInfo:me}}}function Kp(v){return v}function jI(v){nD=ad(),$s=YP();var S=null;return Fd(!1),S}function df(v){kg($s),Fd(nD),nD=null,$s=null}function _R(v,S,P,G,Q){var me;{var De=G;if($I(v,null,De.ancestorInfo),typeof S.children=="string"||typeof S.children=="number"){var We=""+S.children,rt=yR(De.ancestorInfo,v);$I(null,We,rt)}me=De.namespace}var _t=B0(v,S,P,me);return Yn(Q,_t),Jp(_t,S),_t}function T1(v,S){v.appendChild(S)}function PF(v,S,P,G,Q){switch(oz(v,S,P,G),S){case"button":case"input":case"select":case"textarea":return!!P.autoFocus;case"img":return!0;default:return!1}}function ER(v,S,P,G,Q,me){{var De=me;if(typeof G.children!=typeof P.children&&(typeof G.children=="string"||typeof G.children=="number")){var We=""+G.children,rt=yR(De.ancestorInfo,S);$I(null,We,rt)}}return sz(v,S,P,G)}function aD(v,S){return v==="textarea"||v==="noscript"||typeof S.children=="string"||typeof S.children=="number"||typeof S.dangerouslySetInnerHTML=="object"&&S.dangerouslySetInnerHTML!==null&&S.dangerouslySetInnerHTML.__html!=null}function rD(v,S,P,G){{var Q=P;$I(null,v,Q.ancestorInfo)}var me=AF(v,S);return Yn(G,me),me}function dz(){var v=window.event;return v===void 0?of:Qk(v.type)}var C1=typeof setTimeout=="function"?setTimeout:void 0,h7=typeof clearTimeout=="function"?clearTimeout:void 0,AR=-1,_1=typeof Promise=="function"?Promise:void 0,uz=typeof queueMicrotask=="function"?queueMicrotask:typeof _1<"u"?function(v){return _1.resolve(null).then(v).catch(p7)}:C1;function p7(v){setTimeout(function(){throw v})}function DF(v,S,P,G){switch(S){case"button":case"input":case"select":case"textarea":P.autoFocus&&v.focus();return;case"img":{P.src&&(v.src=P.src);return}}}function hz(v,S,P,G,Q,me){c7(v,S,P,G,Q),Jp(v,Q)}function oD(v){rm(v,"")}function g7(v,S,P){v.nodeValue=P}function m7(v,S){v.appendChild(S)}function pz(v,S){var P;v.nodeType===$u?(P=v.parentNode,P.insertBefore(S,v)):(P=v,P.appendChild(S));var G=v._reactRootContainer;G==null&&P.onclick===null&&zI(P)}function uf(v,S,P){v.insertBefore(S,P)}function LF(v,S,P){v.nodeType===$u?v.parentNode.insertBefore(S,P):v.insertBefore(S,P)}function gz(v,S){v.removeChild(S)}function mz(v,S){v.nodeType===$u?v.parentNode.removeChild(S):v.removeChild(S)}function sD(v,S){var P=S,G=0;do{var Q=P.nextSibling;if(v.removeChild(P),Q&&Q.nodeType===$u){var me=Q.data;if(me===bR)if(G===0){v.removeChild(Q),jT(S);return}else G--;else(me===SR||me===TR||me===CR)&&G++}P=Q}while(P);jT(S)}function OF(v,S){v.nodeType===$u?sD(v.parentNode,S):v.nodeType===am&&sD(v,S),jT(v)}function E1(v){v=v;var S=v.style;typeof S.setProperty=="function"?S.setProperty("display","none","important"):S.display="none"}function ZT(v){v.nodeValue=""}function GI(v,S){v=v;var P=S[cz],G=P!=null&&P.hasOwnProperty("display")?P.display:null;v.style.display=iv("display",G)}function fz(v,S){v.nodeValue=S}function bv(v){v.nodeType===am?v.textContent="":v.nodeType===vb&&v.documentElement&&v.removeChild(v.documentElement)}function Ey(v,S,P){return v.nodeType!==am||S.toLowerCase()!==v.nodeName.toLowerCase()?null:v}function NF(v,S){return S===""||v.nodeType!==tv?null:v}function A1(v){return v.nodeType!==$u?null:v}function lD(v){return v.data===TR}function I1(v){return v.data===CR}function xF(v){var S=v.nextSibling&&v.nextSibling.dataset,P,G,Q;return S&&(P=S.dgst,G=S.msg,Q=S.stck),{message:G,digest:P,stack:Q}}function BF(v,S){v._reactRetry=S}function qI(v){for(;v!=null;v=v.nextSibling){var S=v.nodeType;if(S===am||S===tv)break;if(S===$u){var P=v.data;if(P===SR||P===CR||P===TR)break;if(P===bR)return null}}return v}function WI(v){return qI(v.nextSibling)}function w1(v){return qI(v.firstChild)}function vz(v){return qI(v.firstChild)}function k1(v){return qI(v.nextSibling)}function FF(v,S,P,G,Q,me,De){Yn(me,v),Jp(v,P);var We;{var rt=Q;We=rt.namespace}var _t=(me.mode&ps)!==Jr;return IF(v,S,P,We,G,_t,De)}function UF(v,S,P,G){return Yn(P,v),P.mode&ps,v1(v,S)}function R1(v,S){Yn(S,v)}function f7(v){for(var S=v.nextSibling,P=0;S;){if(S.nodeType===$u){var G=S.data;if(G===bR){if(P===0)return WI(S);P--}else(G===SR||G===CR||G===TR)&&P++}S=S.nextSibling}return null}function M1(v){for(var S=v.previousSibling,P=0;S;){if(S.nodeType===$u){var G=S.data;if(G===SR||G===CR||G===TR){if(P===0)return S;P--}else G===bR&&P++}S=S.previousSibling}return null}function yz(v){jT(v)}function Sz(v){jT(v)}function P1(v){return v!=="head"&&v!=="body"}function v7(v,S,P,G){var Q=!0;Rg(S.nodeValue,P,G,Q)}function y7(v,S,P,G,Q,me){if(S[iD]!==!0){var De=!0;Rg(G.nodeValue,Q,me,De)}}function bz(v,S){S.nodeType===am?fR(v,S):S.nodeType===$u||VI(v,S)}function Tz(v,S){{var P=v.parentNode;P!==null&&(S.nodeType===am?fR(P,S):S.nodeType===$u||VI(P,S))}}function zF(v,S,P,G,Q){(Q||S[iD]!==!0)&&(G.nodeType===am?fR(P,G):G.nodeType===$u||VI(P,G))}function S7(v,S,P){wF(v,S)}function b7(v,S){kF(v,S)}function VF(v,S,P){{var G=v.parentNode;G!==null&&wF(G,S)}}function D1(v,S){{var P=v.parentNode;P!==null&&kF(P,S)}}function KI(v,S,P,G,Q,me){(me||S[iD]!==!0)&&wF(P,G)}function O(v,S,P,G,Q){(Q||S[iD]!==!0)&&kF(P,G)}function q(v){d("An error occurred during hydration. The server HTML was replaced with client content in <%s>.",v.nodeName.toLowerCase())}function fe(v){Sv(v)}var $e=Math.random().toString(36).slice(2),ut="__reactFiber$"+$e,Dt="__reactProps$"+$e,si="__reactContainer$"+$e,Ei="__reactEvents$"+$e,Ui="__reactListeners$"+$e,Nn="__reactHandles$"+$e;function Pn(v){delete v[ut],delete v[Dt],delete v[Ei],delete v[Ui],delete v[Nn]}function Yn(v,S){S[ut]=v}function Wa(v,S){S[si]=v}function _r(v){v[si]=null}function bo(v){return!!v[si]}function Qo(v){var S=v[ut];if(S)return S;for(var P=v.parentNode;P;){if(S=P[si]||P[ut],S){var G=S.alternate;if(S.child!==null||G!==null&&G.child!==null)for(var Q=M1(v);Q!==null;){var me=Q[ut];if(me)return me;Q=M1(Q)}return S}v=P,P=v.parentNode}return null}function Oo(v){var S=v[ut]||v[si];return S&&(S.tag===C||S.tag===E||S.tag===L||S.tag===y)?S:null}function ec(v){if(v.tag===C||v.tag===E)return v.stateNode;throw new Error("getNodeFromInstance: Invalid argument.")}function dl(v){return v[Dt]||null}function Jp(v,S){v[Dt]=S}function Ay(v){var S=v[Ei];return S===void 0&&(S=v[Ei]=new Set),S}var V_={},Ju=i.ReactDebugCurrentFrame;function hf(v){if(v){var S=v._owner,P=Zh(v.type,v._source,S?S.type:null);Ju.setExtraStackFrame(P)}else Ju.setExtraStackFrame(null)}function Yp(v,S,P,G,Q){{var me=Function.call.bind(Pt);for(var De in v)if(me(v,De)){var We=void 0;try{if(typeof v[De]!="function"){var rt=Error((G||"React class")+": "+P+" type `"+De+"` is invalid; it must be a function, usually from the `prop-types` package, but received `"+typeof v[De]+"`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");throw rt.name="Invariant Violation",rt}We=v[De](S,De,G,P,null,"SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED")}catch(_t){We=_t}We&&!(We instanceof Error)&&(hf(Q),d("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).",G||"React class",P,De,typeof We),hf(null)),We instanceof Error&&!(We.message in V_)&&(V_[We.message]=!0,hf(Q),d("Failed %s type: %s",P,We.message),hf(null))}}}var $F=[],Cz;Cz=[];var JI=-1;function IR(v){return{current:v}}function bm(v,S){if(JI<0){d("Unexpected pop.");return}S!==Cz[JI]&&d("Unexpected Fiber popped."),v.current=$F[JI],$F[JI]=null,Cz[JI]=null,JI--}function Tm(v,S,P){JI++,$F[JI]=v.current,Cz[JI]=P,v.current=S}var YI;YI={};var Tv={};Object.freeze(Tv);var PS=IR(Tv),F0=IR(!1),T7=Tv;function L1(v,S,P){return P&&$_(S)?T7:PS.current}function VX(v,S,P){{var G=v.stateNode;G.__reactInternalMemoizedUnmaskedChildContext=S,G.__reactInternalMemoizedMaskedChildContext=P}}function cD(v,S){{var P=v.type,G=P.contextTypes;if(!G)return Tv;var Q=v.stateNode;if(Q&&Q.__reactInternalMemoizedUnmaskedChildContext===S)return Q.__reactInternalMemoizedMaskedChildContext;var me={};for(var De in G)me[De]=S[De];{var We=Do(v)||"Unknown";Yp(G,me,"context",We)}return Q&&VX(v,S,me),me}}function _z(){return F0.current}function $_(v){{var S=v.childContextTypes;return S!=null}}function HF(v){bm(F0,v),bm(PS,v)}function C7(v){bm(F0,v),bm(PS,v)}function _7(v,S,P){{if(PS.current!==Tv)throw new Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");Tm(PS,S,v),Tm(F0,P,v)}}function $X(v,S,P){{var G=v.stateNode,Q=S.childContextTypes;if(typeof G.getChildContext!="function"){{var me=Do(v)||"Unknown";YI[me]||(YI[me]=!0,d("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.",me,me))}return P}var De=G.getChildContext();for(var We in De)if(!(We in Q))throw new Error((Do(v)||"Unknown")+'.getChildContext(): key "'+We+'" is not defined in childContextTypes.');{var rt=Do(v)||"Unknown";Yp(Q,De,"child context",rt)}return Za({},P,De)}}function O1(v){{var S=v.stateNode,P=S&&S.__reactInternalMemoizedMergedChildContext||Tv;return T7=PS.current,Tm(PS,P,v),Tm(F0,F0.current,v),!0}}function wR(v,S,P){{var G=v.stateNode;if(!G)throw new Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");if(P){var Q=$X(v,S,T7);G.__reactInternalMemoizedMergedChildContext=Q,bm(F0,v),bm(PS,v),Tm(PS,Q,v),Tm(F0,P,v)}else bm(F0,v),Tm(F0,P,v)}}function HX(v){{if(!nu(v)||v.tag!==g)throw new Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");var S=v;do{switch(S.tag){case y:return S.stateNode.context;case g:{var P=S.type;if($_(P))return S.stateNode.__reactInternalMemoizedMergedChildContext;break}}S=S.return}while(S!==null);throw new Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.")}}var du=0,Ez=1,QI=null,dD=!1,E7=!1;function A7(v){QI===null?QI=[v]:QI.push(v)}function I7(v){dD=!0,A7(v)}function jX(){dD&&kR()}function kR(){if(!E7&&QI!==null){E7=!0;var v=0,S=gm();try{var P=!0,G=QI;for(Tc(mh);v<G.length;v++){var Q=G[v];do Q=Q(P);while(Q!==null)}QI=null,dD=!1}catch(me){throw QI!==null&&(QI=QI.slice(v+1)),Cg(ru,kR),me}finally{Tc(S),E7=!1}}return null}var N1=[],x1=0,B1=null,Az=0,Nc=[],Yu=0,pf=null,Iy=1,Ob="";function Kfe(v){return RR(),(v.flags&Tg)!==Ia}function Jfe(v){return RR(),Az}function Yfe(){var v=Ob,S=Iy,P=S&~Qfe(S);return P.toString(32)+v}function ZI(v,S){RR(),N1[x1++]=Az,N1[x1++]=B1,B1=v,Az=S}function GX(v,S,P){RR(),Nc[Yu++]=Iy,Nc[Yu++]=Ob,Nc[Yu++]=pf,pf=v;var G=Iy,Q=Ob,me=U0(G)-1,De=G&~(1<<me),We=P+1,rt=U0(S)+me;if(rt>30){var _t=me-me%5,Ut=(1<<_t)-1,Di=(De&Ut).toString(32),Ri=De>>_t,Xi=me-_t,tn=U0(S)+Xi,Cn=We<<Xi,Ja=Cn|Ri,po=Di+Q;Iy=1<<tn|Ja,Ob=po}else{var Gr=We<<me,Dl=Gr|De,hl=Q;Iy=1<<rt|Dl,Ob=hl}}function H_(v){RR();var S=v.return;if(S!==null){var P=1,G=0;ZI(v,P),GX(v,P,G)}}function U0(v){return 32-Zl(v)}function Qfe(v){return 1<<U0(v)-1}function w7(v){for(;v===B1;)B1=N1[--x1],N1[x1]=null,Az=N1[--x1],N1[x1]=null;for(;v===pf;)pf=Nc[--Yu],Nc[Yu]=null,Ob=Nc[--Yu],Nc[Yu]=null,Iy=Nc[--Yu],Nc[Yu]=null}function qX(){return RR(),pf!==null?{id:Iy,overflow:Ob}:null}function WX(v,S){RR(),Nc[Yu++]=Iy,Nc[Yu++]=Ob,Nc[Yu++]=pf,Iy=S.id,Ob=S.overflow,pf=v}function RR(){mf()||d("Expected to be hydrating. This is a bug in React. Please file an issue.")}var gf=null,XT=null,j_=!1,uD=!1,XI=null;function KX(){j_&&d("We should not be hydrating here. This is a bug in React. Please file a bug.")}function JX(){uD=!0}function k7(){return uD}function YX(v){var S=v.stateNode.containerInfo;return XT=vz(S),gf=v,j_=!0,XI=null,uD=!1,!0}function Zfe(v,S,P){return XT=k1(S),gf=v,j_=!0,XI=null,uD=!1,P!==null&&WX(v,P),!0}function QX(v,S){switch(v.tag){case y:{bz(v.stateNode.containerInfo,S);break}case C:{var P=(v.mode&ps)!==Jr;zF(v.type,v.memoizedProps,v.stateNode,S,P);break}case L:{var G=v.memoizedState;G.dehydrated!==null&&Tz(G.dehydrated,S);break}}}function R7(v,S){QX(v,S);var P=gte();P.stateNode=S,P.return=v;var G=v.deletions;G===null?(v.deletions=[P],v.flags|=Mh):G.push(P)}function M7(v,S){{if(uD)return;switch(v.tag){case y:{var P=v.stateNode.containerInfo;switch(S.tag){case C:var G=S.type;S.pendingProps,S7(P,G);break;case E:var Q=S.pendingProps;b7(P,Q);break}break}case C:{var me=v.type,De=v.memoizedProps,We=v.stateNode;switch(S.tag){case C:{var rt=S.type,_t=S.pendingProps,Ut=(v.mode&ps)!==Jr;KI(me,De,We,rt,_t,Ut);break}case E:{var Di=S.pendingProps,Ri=(v.mode&ps)!==Jr;O(me,De,We,Di,Ri);break}}break}case L:{var Xi=v.memoizedState,tn=Xi.dehydrated;if(tn!==null)switch(S.tag){case C:var Cn=S.type;S.pendingProps,VF(tn,Cn);break;case E:var Ja=S.pendingProps;D1(tn,Ja);break}break}default:return}}}function ZX(v,S){S.flags=S.flags&-4097|Nd,M7(v,S)}function XX(v,S){switch(v.tag){case C:{var P=v.type;v.pendingProps;var G=Ey(S,P);return G!==null?(v.stateNode=G,gf=v,XT=w1(G),!0):!1}case E:{var Q=v.pendingProps,me=NF(S,Q);return me!==null?(v.stateNode=me,gf=v,XT=null,!0):!1}case L:{var De=A1(S);if(De!==null){var We={dehydrated:De,treeContext:qX(),retryLane:Ag};v.memoizedState=We;var rt=Xr(De);return rt.return=v,v.child=rt,gf=v,XT=null,!0}return!1}default:return!1}}function P7(v){return(v.mode&ps)!==Jr&&(v.flags&ra)===Ia}function D7(v){throw new Error("Hydration failed because the initial UI does not match what was rendered on the server.")}function L7(v){if(j_){var S=XT;if(!S){P7(v)&&(M7(gf,v),D7()),ZX(gf,v),j_=!1,gf=v;return}var P=S;if(!XX(v,S)){P7(v)&&(M7(gf,v),D7()),S=WI(P);var G=gf;if(!S||!XX(v,S)){ZX(gf,v),j_=!1,gf=v;return}R7(G,P)}}}function MR(v,S,P){var G=v.stateNode,Q=!uD,me=FF(G,v.type,v.memoizedProps,S,P,v,Q);return v.updateQueue=me,me!==null}function eee(v){var S=v.stateNode,P=v.memoizedProps,G=UF(S,P,v);if(G){var Q=gf;if(Q!==null)switch(Q.tag){case y:{var me=Q.stateNode.containerInfo,De=(Q.mode&ps)!==Jr;v7(me,S,P,De);break}case C:{var We=Q.type,rt=Q.memoizedProps,_t=Q.stateNode,Ut=(Q.mode&ps)!==Jr;y7(We,rt,_t,S,P,Ut);break}}}return G}function Xfe(v){var S=v.memoizedState,P=S!==null?S.dehydrated:null;if(!P)throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");R1(P,v)}function tee(v){var S=v.memoizedState,P=S!==null?S.dehydrated:null;if(!P)throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");return f7(P)}function hD(v){for(var S=v.return;S!==null&&S.tag!==C&&S.tag!==y&&S.tag!==L;)S=S.return;gf=S}function jF(v){if(v!==gf)return!1;if(!j_)return hD(v),j_=!0,!1;if(v.tag!==y&&(v.tag!==C||P1(v.type)&&!aD(v.type,v.memoizedProps))){var S=XT;if(S)if(P7(v))iee(v),D7();else for(;S;)R7(v,S),S=WI(S)}return hD(v),v.tag===L?XT=tee(v):XT=gf?WI(v.stateNode):null,!0}function eve(){return j_&&XT!==null}function iee(v){for(var S=XT;S;)QX(v,S),S=WI(S)}function pD(){gf=null,XT=null,j_=!1,uD=!1}function nee(){XI!==null&&(R2(XI),XI=null)}function mf(){return j_}function Iz(v){XI===null?XI=[v]:XI.push(v)}var aee=i.ReactCurrentBatchConfig,O7=null;function tve(){return aee.transition}var G_={recordUnsafeLifecycleWarnings:function(v,S){},flushPendingUnsafeLifecycleWarnings:function(){},recordLegacyContextWarning:function(v,S){},flushLegacyContextWarning:function(){},discardPendingWarnings:function(){}};{var ive=function(v){for(var S=null,P=v;P!==null;)P.mode&Sc&&(S=P),P=P.return;return S},gD=function(v){var S=[];return v.forEach(function(P){S.push(P)}),S.sort().join(", ")},F1=[],GF=[],qF=[],WF=[],KF=[],JF=[],mD=new Set;G_.recordUnsafeLifecycleWarnings=function(v,S){mD.has(v.type)||(typeof S.componentWillMount=="function"&&S.componentWillMount.__suppressDeprecationWarning!==!0&&F1.push(v),v.mode&Sc&&typeof S.UNSAFE_componentWillMount=="function"&&GF.push(v),typeof S.componentWillReceiveProps=="function"&&S.componentWillReceiveProps.__suppressDeprecationWarning!==!0&&qF.push(v),v.mode&Sc&&typeof S.UNSAFE_componentWillReceiveProps=="function"&&WF.push(v),typeof S.componentWillUpdate=="function"&&S.componentWillUpdate.__suppressDeprecationWarning!==!0&&KF.push(v),v.mode&Sc&&typeof S.UNSAFE_componentWillUpdate=="function"&&JF.push(v))},G_.flushPendingUnsafeLifecycleWarnings=function(){var v=new Set;F1.length>0&&(F1.forEach(function(Ri){v.add(Do(Ri)||"Component"),mD.add(Ri.type)}),F1=[]);var S=new Set;GF.length>0&&(GF.forEach(function(Ri){S.add(Do(Ri)||"Component"),mD.add(Ri.type)}),GF=[]);var P=new Set;qF.length>0&&(qF.forEach(function(Ri){P.add(Do(Ri)||"Component"),mD.add(Ri.type)}),qF=[]);var G=new Set;WF.length>0&&(WF.forEach(function(Ri){G.add(Do(Ri)||"Component"),mD.add(Ri.type)}),WF=[]);var Q=new Set;KF.length>0&&(KF.forEach(function(Ri){Q.add(Do(Ri)||"Component"),mD.add(Ri.type)}),KF=[]);var me=new Set;if(JF.length>0&&(JF.forEach(function(Ri){me.add(Do(Ri)||"Component"),mD.add(Ri.type)}),JF=[]),S.size>0){var De=gD(S);d(`Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.

Please update the following components: %s`,De)}if(G.size>0){var We=gD(G);d(`Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state

Please update the following components: %s`,We)}if(me.size>0){var rt=gD(me);d(`Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.

Please update the following components: %s`,rt)}if(v.size>0){var _t=gD(v);l(`componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.
* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`,_t)}if(P.size>0){var Ut=gD(P);l(`componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state
* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`,Ut)}if(Q.size>0){var Di=gD(Q);l(`componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`,Di)}};var wz=new Map,N7=new Set;G_.recordLegacyContextWarning=function(v,S){var P=ive(v);if(P===null){d("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");return}if(!N7.has(v.type)){var G=wz.get(P);(v.type.contextTypes!=null||v.type.childContextTypes!=null||S!==null&&typeof S.getChildContext=="function")&&(G===void 0&&(G=[],wz.set(P,G)),G.push(v))}},G_.flushLegacyContextWarning=function(){wz.forEach(function(v,S){if(v.length!==0){var P=v[0],G=new Set;v.forEach(function(me){G.add(Do(me)||"Component"),N7.add(me.type)});var Q=gD(G);try{oc(P),d(`Legacy context API has been detected within a strict-mode tree.

The old API will be supported in all 16.x releases, but applications using it should migrate to the new version.

Please update the following components: %s

Learn more about this warning here: https://reactjs.org/link/legacy-context`,Q)}finally{yo()}}})},G_.discardPendingWarnings=function(){F1=[],GF=[],qF=[],WF=[],KF=[],JF=[],wz=new Map}}var U1,kz,Rz,YF,QF,x7=function(v,S){};U1=!1,kz=!1,Rz={},YF={},QF={},x7=function(v,S){if(!(v===null||typeof v!="object")&&!(!v._store||v._store.validated||v.key!=null)){if(typeof v._store!="object")throw new Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");v._store.validated=!0;var P=Do(S)||"Component";YF[P]||(YF[P]=!0,d('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.'))}};function nve(v){return v.prototype&&v.prototype.isReactComponent}function ZF(v,S,P){var G=P.ref;if(G!==null&&typeof G!="function"&&typeof G!="object"){if((v.mode&Sc||ve)&&!(P._owner&&P._self&&P._owner.stateNode!==P._self)&&!(P._owner&&P._owner.tag!==g)&&!(typeof P.type=="function"&&!nve(P.type))&&P._owner){var Q=Do(v)||"Component";Rz[Q]||(d('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref',Q,G),Rz[Q]=!0)}if(P._owner){var me=P._owner,De;if(me){var We=me;if(We.tag!==g)throw new Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");De=We.stateNode}if(!De)throw new Error("Missing owner for string ref "+G+". This error is likely caused by a bug in React. Please file an issue.");var rt=De;Ht(G,"ref");var _t=""+G;if(S!==null&&S.ref!==null&&typeof S.ref=="function"&&S.ref._stringRef===_t)return S.ref;var Ut=function(Di){var Ri=rt.refs;Di===null?delete Ri[_t]:Ri[_t]=Di};return Ut._stringRef=_t,Ut}else{if(typeof G!="string")throw new Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");if(!P._owner)throw new Error("Element ref was specified as a string ("+G+`) but no owner was set. This could happen for one of the following reasons:
1. You may be adding a ref to a function component
2. You may be adding a ref to a component that was not created inside a component's render method
3. You have multiple copies of React loaded
See https://reactjs.org/link/refs-must-have-owner for more information.`)}}return G}function Mz(v,S){var P=Object.prototype.toString.call(S);throw new Error("Objects are not valid as a React child (found: "+(P==="[object Object]"?"object with keys {"+Object.keys(S).join(", ")+"}":P)+"). If you meant to render a collection of children, use an array instead.")}function Pz(v){{var S=Do(v)||"Component";if(QF[S])return;QF[S]=!0,d("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.")}}function ree(v){var S=v._payload,P=v._init;return P(S)}function oee(v){function S(qi,bn){if(v){var Wi=qi.deletions;Wi===null?(qi.deletions=[bn],qi.flags|=Mh):Wi.push(bn)}}function P(qi,bn){if(!v)return null;for(var Wi=bn;Wi!==null;)S(qi,Wi),Wi=Wi.sibling;return null}function G(qi,bn){for(var Wi=new Map,ca=bn;ca!==null;)ca.key!==null?Wi.set(ca.key,ca):Wi.set(ca.index,ca),ca=ca.sibling;return Wi}function Q(qi,bn){var Wi=fw(qi,bn);return Wi.index=0,Wi.sibling=null,Wi}function me(qi,bn,Wi){if(qi.index=Wi,!v)return qi.flags|=Tg,bn;var ca=qi.alternate;if(ca!==null){var fr=ca.index;return fr<bn?(qi.flags|=Nd,bn):fr}else return qi.flags|=Nd,bn}function De(qi){return v&&qi.alternate===null&&(qi.flags|=Nd),qi}function We(qi,bn,Wi,ca){if(bn===null||bn.tag!==E){var fr=ei(Wi,qi.mode,ca);return fr.return=qi,fr}else{var or=Q(bn,Wi);return or.return=qi,or}}function rt(qi,bn,Wi,ca){var fr=Wi.type;if(fr===$r)return Ut(qi,bn,Wi.props.children,ca,Wi.key);if(bn!==null&&(bn.elementType===fr||ote(bn,Wi)||typeof fr=="object"&&fr!==null&&fr.$$typeof===qa&&ree(fr)===bn.type)){var or=Q(bn,Wi.props);return or.ref=ZF(qi,bn,Wi),or.return=qi,or._debugSource=Wi._source,or._debugOwner=Wi._owner,or}var Bo=L2(Wi,qi.mode,ca);return Bo.ref=ZF(qi,bn,Wi),Bo.return=qi,Bo}function _t(qi,bn,Wi,ca){if(bn===null||bn.tag!==T||bn.stateNode.containerInfo!==Wi.containerInfo||bn.stateNode.implementation!==Wi.implementation){var fr=GG(Wi,qi.mode,ca);return fr.return=qi,fr}else{var or=Q(bn,Wi.children||[]);return or.return=qi,or}}function Ut(qi,bn,Wi,ca,fr){if(bn===null||bn.tag!==I){var or=vw(Wi,qi.mode,ca,fr);return or.return=qi,or}else{var Bo=Q(bn,Wi);return Bo.return=qi,Bo}}function Di(qi,bn,Wi){if(typeof bn=="string"&&bn!==""||typeof bn=="number"){var ca=ei(""+bn,qi.mode,Wi);return ca.return=qi,ca}if(typeof bn=="object"&&bn!==null){switch(bn.$$typeof){case al:{var fr=L2(bn,qi.mode,Wi);return fr.ref=ZF(qi,null,bn),fr.return=qi,fr}case Us:{var or=GG(bn,qi.mode,Wi);return or.return=qi,or}case qa:{var Bo=bn._payload,rs=bn._init;return Di(qi,rs(Bo),Wi)}}if(Ko(bn)||za(bn)){var Bc=vw(bn,qi.mode,Wi,null);return Bc.return=qi,Bc}Mz(qi,bn)}return typeof bn=="function"&&Pz(qi),null}function Ri(qi,bn,Wi,ca){var fr=bn!==null?bn.key:null;if(typeof Wi=="string"&&Wi!==""||typeof Wi=="number")return fr!==null?null:We(qi,bn,""+Wi,ca);if(typeof Wi=="object"&&Wi!==null){switch(Wi.$$typeof){case al:return Wi.key===fr?rt(qi,bn,Wi,ca):null;case Us:return Wi.key===fr?_t(qi,bn,Wi,ca):null;case qa:{var or=Wi._payload,Bo=Wi._init;return Ri(qi,bn,Bo(or),ca)}}if(Ko(Wi)||za(Wi))return fr!==null?null:Ut(qi,bn,Wi,ca,null);Mz(qi,Wi)}return typeof Wi=="function"&&Pz(qi),null}function Xi(qi,bn,Wi,ca,fr){if(typeof ca=="string"&&ca!==""||typeof ca=="number"){var or=qi.get(Wi)||null;return We(bn,or,""+ca,fr)}if(typeof ca=="object"&&ca!==null){switch(ca.$$typeof){case al:{var Bo=qi.get(ca.key===null?Wi:ca.key)||null;return rt(bn,Bo,ca,fr)}case Us:{var rs=qi.get(ca.key===null?Wi:ca.key)||null;return _t(bn,rs,ca,fr)}case qa:var Bc=ca._payload,cc=ca._init;return Xi(qi,bn,Wi,cc(Bc),fr)}if(Ko(ca)||za(ca)){var vp=qi.get(Wi)||null;return Ut(bn,vp,ca,fr,null)}Mz(bn,ca)}return typeof ca=="function"&&Pz(bn),null}function tn(qi,bn,Wi){{if(typeof qi!="object"||qi===null)return bn;switch(qi.$$typeof){case al:case Us:x7(qi,Wi);var ca=qi.key;if(typeof ca!="string")break;if(bn===null){bn=new Set,bn.add(ca);break}if(!bn.has(ca)){bn.add(ca);break}d("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.",ca);break;case qa:var fr=qi._payload,or=qi._init;tn(or(fr),bn,Wi);break}}return bn}function Cn(qi,bn,Wi,ca){for(var fr=null,or=0;or<Wi.length;or++){var Bo=Wi[or];fr=tn(Bo,fr,qi)}for(var rs=null,Bc=null,cc=bn,vp=0,dc=0,zh=null;cc!==null&&dc<Wi.length;dc++){cc.index>dc?(zh=cc,cc=null):zh=cc.sibling;var Iv=Ri(qi,cc,Wi[dc],ca);if(Iv===null){cc===null&&(cc=zh);break}v&&cc&&Iv.alternate===null&&S(qi,cc),vp=me(Iv,vp,dc),Bc===null?rs=Iv:Bc.sibling=Iv,Bc=Iv,cc=zh}if(dc===Wi.length){if(P(qi,cc),mf()){var If=dc;ZI(qi,If)}return rs}if(cc===null){for(;dc<Wi.length;dc++){var $b=Di(qi,Wi[dc],ca);$b!==null&&(vp=me($b,vp,dc),Bc===null?rs=$b:Bc.sibling=$b,Bc=$b)}if(mf()){var Py=dc;ZI(qi,Py)}return rs}for(var Dy=G(qi,cc);dc<Wi.length;dc++){var wv=Xi(Dy,qi,dc,Wi[dc],ca);wv!==null&&(v&&wv.alternate!==null&&Dy.delete(wv.key===null?dc:wv.key),vp=me(wv,vp,dc),Bc===null?rs=wv:Bc.sibling=wv,Bc=wv)}if(v&&Dy.forEach(function(EN){return S(qi,EN)}),mf()){var yw=dc;ZI(qi,yw)}return rs}function Ja(qi,bn,Wi,ca){var fr=za(Wi);if(typeof fr!="function")throw new Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");{typeof Symbol=="function"&&Wi[Symbol.toStringTag]==="Generator"&&(kz||d("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."),kz=!0),Wi.entries===fr&&(U1||d("Using Maps as children is not supported. Use an array of keyed ReactElements instead."),U1=!0);var or=fr.call(Wi);if(or)for(var Bo=null,rs=or.next();!rs.done;rs=or.next()){var Bc=rs.value;Bo=tn(Bc,Bo,qi)}}var cc=fr.call(Wi);if(cc==null)throw new Error("An iterable object provided no iterator.");for(var vp=null,dc=null,zh=bn,Iv=0,If=0,$b=null,Py=cc.next();zh!==null&&!Py.done;If++,Py=cc.next()){zh.index>If?($b=zh,zh=null):$b=zh.sibling;var Dy=Ri(qi,zh,Py.value,ca);if(Dy===null){zh===null&&(zh=$b);break}v&&zh&&Dy.alternate===null&&S(qi,zh),Iv=me(Dy,Iv,If),dc===null?vp=Dy:dc.sibling=Dy,dc=Dy,zh=$b}if(Py.done){if(P(qi,zh),mf()){var wv=If;ZI(qi,wv)}return vp}if(zh===null){for(;!Py.done;If++,Py=cc.next()){var yw=Di(qi,Py.value,ca);yw!==null&&(Iv=me(yw,Iv,If),dc===null?vp=yw:dc.sibling=yw,dc=yw)}if(mf()){var EN=If;ZI(qi,EN)}return vp}for(var F2=G(qi,zh);!Py.done;If++,Py=cc.next()){var eA=Xi(F2,qi,If,Py.value,ca);eA!==null&&(v&&eA.alternate!==null&&F2.delete(eA.key===null?If:eA.key),Iv=me(eA,Iv,If),dc===null?vp=eA:dc.sibling=eA,dc=eA)}if(v&&F2.forEach(function(oye){return S(qi,oye)}),mf()){var rye=If;ZI(qi,rye)}return vp}function po(qi,bn,Wi,ca){if(bn!==null&&bn.tag===E){P(qi,bn.sibling);var fr=Q(bn,Wi);return fr.return=qi,fr}P(qi,bn);var or=ei(Wi,qi.mode,ca);return or.return=qi,or}function Gr(qi,bn,Wi,ca){for(var fr=Wi.key,or=bn;or!==null;){if(or.key===fr){var Bo=Wi.type;if(Bo===$r){if(or.tag===I){P(qi,or.sibling);var rs=Q(or,Wi.props.children);return rs.return=qi,rs._debugSource=Wi._source,rs._debugOwner=Wi._owner,rs}}else if(or.elementType===Bo||ote(or,Wi)||typeof Bo=="object"&&Bo!==null&&Bo.$$typeof===qa&&ree(Bo)===or.type){P(qi,or.sibling);var Bc=Q(or,Wi.props);return Bc.ref=ZF(qi,or,Wi),Bc.return=qi,Bc._debugSource=Wi._source,Bc._debugOwner=Wi._owner,Bc}P(qi,or);break}else S(qi,or);or=or.sibling}if(Wi.type===$r){var cc=vw(Wi.props.children,qi.mode,ca,Wi.key);return cc.return=qi,cc}else{var vp=L2(Wi,qi.mode,ca);return vp.ref=ZF(qi,bn,Wi),vp.return=qi,vp}}function Dl(qi,bn,Wi,ca){for(var fr=Wi.key,or=bn;or!==null;){if(or.key===fr)if(or.tag===T&&or.stateNode.containerInfo===Wi.containerInfo&&or.stateNode.implementation===Wi.implementation){P(qi,or.sibling);var Bo=Q(or,Wi.children||[]);return Bo.return=qi,Bo}else{P(qi,or);break}else S(qi,or);or=or.sibling}var rs=GG(Wi,qi.mode,ca);return rs.return=qi,rs}function hl(qi,bn,Wi,ca){var fr=typeof Wi=="object"&&Wi!==null&&Wi.type===$r&&Wi.key===null;if(fr&&(Wi=Wi.props.children),typeof Wi=="object"&&Wi!==null){switch(Wi.$$typeof){case al:return De(Gr(qi,bn,Wi,ca));case Us:return De(Dl(qi,bn,Wi,ca));case qa:var or=Wi._payload,Bo=Wi._init;return hl(qi,bn,Bo(or),ca)}if(Ko(Wi))return Cn(qi,bn,Wi,ca);if(za(Wi))return Ja(qi,bn,Wi,ca);Mz(qi,Wi)}return typeof Wi=="string"&&Wi!==""||typeof Wi=="number"?De(po(qi,bn,""+Wi,ca)):(typeof Wi=="function"&&Pz(qi),P(qi,bn))}return hl}var z1=oee(!0),see=oee(!1);function Nb(v,S){if(v!==null&&S.child!==v.child)throw new Error("Resuming work not yet implemented.");if(S.child!==null){var P=S.child,G=fw(P,P.pendingProps);for(S.child=G,G.return=S;P.sibling!==null;)P=P.sibling,G=G.sibling=fw(P,P.pendingProps),G.return=S;G.sibling=null}}function Dz(v,S){for(var P=v.child;P!==null;)xve(P,S),P=P.sibling}var B7=IR(null),F7;F7={};var Lz=null,V1=null,U7=null,q_=!1;function Oz(){Lz=null,V1=null,U7=null,q_=!1}function lee(){q_=!0}function cee(){q_=!1}function dee(v,S,P){Tm(B7,S._currentValue,v),S._currentValue=P,S._currentRenderer!==void 0&&S._currentRenderer!==null&&S._currentRenderer!==F7&&d("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."),S._currentRenderer=F7}function z7(v,S){var P=B7.current;bm(B7,S),v._currentValue=P}function V7(v,S,P){for(var G=v;G!==null;){var Q=G.alternate;if(zp(G.childLanes,S)?Q!==null&&!zp(Q.childLanes,S)&&(Q.childLanes=Jo(Q.childLanes,S)):(G.childLanes=Jo(G.childLanes,S),Q!==null&&(Q.childLanes=Jo(Q.childLanes,S))),G===P)break;G=G.return}G!==P&&d("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.")}function uee(v,S,P){ave(v,S,P)}function ave(v,S,P){var G=v.child;for(G!==null&&(G.return=v);G!==null;){var Q=void 0,me=G.dependencies;if(me!==null){Q=G.child;for(var De=me.firstContext;De!==null;){if(De.context===S){if(G.tag===g){var We=A_(P),rt=ew(bc,We);rt.tag=xz;var _t=G.updateQueue;if(_t!==null){var Ut=_t.shared,Di=Ut.pending;Di===null?rt.next=rt:(rt.next=Di.next,Di.next=rt),Ut.pending=rt}}G.lanes=Jo(G.lanes,P);var Ri=G.alternate;Ri!==null&&(Ri.lanes=Jo(Ri.lanes,P)),V7(G.return,P,v),me.lanes=Jo(me.lanes,P);break}De=De.next}}else if(G.tag===F)Q=G.type===v.type?null:G.child;else if(G.tag===Z){var Xi=G.return;if(Xi===null)throw new Error("We just came from a parent so we must have had a parent. This is a bug in React.");Xi.lanes=Jo(Xi.lanes,P);var tn=Xi.alternate;tn!==null&&(tn.lanes=Jo(tn.lanes,P)),V7(Xi,P,v),Q=G.sibling}else Q=G.child;if(Q!==null)Q.return=G;else for(Q=G;Q!==null;){if(Q===v){Q=null;break}var Cn=Q.sibling;if(Cn!==null){Cn.return=Q.return,Q=Cn;break}Q=Q.return}G=Q}}function PR(v,S){Lz=v,V1=null,U7=null;var P=v.dependencies;if(P!==null){var G=P.firstContext;G!==null&&(pm(P.lanes,S)&&Sf(),P.firstContext=null)}}function lp(v){q_&&d("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");var S=v._currentValue;if(U7!==v){var P={context:v,memoizedValue:S,next:null};if(V1===null){if(Lz===null)throw new Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");V1=P,Lz.dependencies={lanes:En,firstContext:P}}else V1=V1.next=P}return S}var fD=null;function $7(v){fD===null?fD=[v]:fD.push(v)}function rve(){if(fD!==null){for(var v=0;v<fD.length;v++){var S=fD[v],P=S.interleaved;if(P!==null){S.interleaved=null;var G=P.next,Q=S.pending;if(Q!==null){var me=Q.next;Q.next=G,P.next=me}S.pending=P}}fD=null}}function DR(v,S,P,G){var Q=S.interleaved;return Q===null?(P.next=P,$7(S)):(P.next=Q.next,Q.next=P),S.interleaved=P,vD(v,G)}function ove(v,S,P,G){var Q=S.interleaved;Q===null?(P.next=P,$7(S)):(P.next=Q.next,Q.next=P),S.interleaved=P}function sve(v,S,P,G){var Q=S.interleaved;return Q===null?(P.next=P,$7(S)):(P.next=Q.next,Q.next=P),S.interleaved=P,vD(v,G)}function Qp(v,S){return vD(v,S)}var lve=vD;function vD(v,S){v.lanes=Jo(v.lanes,S);var P=v.alternate;P!==null&&(P.lanes=Jo(P.lanes,S)),P===null&&(v.flags&(Nd|ap))!==Ia&&tr(v);for(var G=v,Q=v.return;Q!==null;)Q.childLanes=Jo(Q.childLanes,S),P=Q.alternate,P!==null?P.childLanes=Jo(P.childLanes,S):(Q.flags&(Nd|ap))!==Ia&&tr(v),G=Q,Q=Q.return;if(G.tag===y){var me=G.stateNode;return me}else return null}var hee=0,Nz=1,xz=2,H7=3,$1=!1,XF,Bz;XF=!1,Bz=null;function Fz(v){var S={baseState:v.memoizedState,firstBaseUpdate:null,lastBaseUpdate:null,shared:{pending:null,interleaved:null,lanes:En},effects:null};v.updateQueue=S}function j7(v,S){var P=S.updateQueue,G=v.updateQueue;if(P===G){var Q={baseState:G.baseState,firstBaseUpdate:G.firstBaseUpdate,lastBaseUpdate:G.lastBaseUpdate,shared:G.shared,effects:G.effects};S.updateQueue=Q}}function ew(v,S){var P={eventTime:v,lane:S,tag:hee,payload:null,callback:null,next:null};return P}function LR(v,S,P){var G=v.updateQueue;if(G===null)return null;var Q=G.shared;if(Bz===Q&&!XF&&(d("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback."),XF=!0),va()){var me=Q.pending;return me===null?S.next=S:(S.next=me.next,me.next=S),Q.pending=S,lve(v,P)}else return sve(v,Q,S,P)}function Uz(v,S,P){var G=S.updateQueue;if(G!==null){var Q=G.shared;if(vI(P)){var me=Q.lanes;me=yI(me,v.pendingLanes);var De=Jo(me,P);Q.lanes=De,fv(v,De)}}}function zz(v,S){var P=v.updateQueue,G=v.alternate;if(G!==null){var Q=G.updateQueue;if(P===Q){var me=null,De=null,We=P.firstBaseUpdate;if(We!==null){var rt=We;do{var _t={eventTime:rt.eventTime,lane:rt.lane,tag:rt.tag,payload:rt.payload,callback:rt.callback,next:null};De===null?me=De=_t:(De.next=_t,De=_t),rt=rt.next}while(rt!==null);De===null?me=De=S:(De.next=S,De=S)}else me=De=S;P={baseState:Q.baseState,firstBaseUpdate:me,lastBaseUpdate:De,shared:Q.shared,effects:Q.effects},v.updateQueue=P;return}}var Ut=P.lastBaseUpdate;Ut===null?P.firstBaseUpdate=S:Ut.next=S,P.lastBaseUpdate=S}function pee(v,S,P,G,Q,me){switch(P.tag){case Nz:{var De=P.payload;if(typeof De=="function"){lee();var We=De.call(me,G,Q);{if(v.mode&Sc){Cd(!0);try{De.call(me,G,Q)}finally{Cd(!1)}}cee()}return We}return De}case H7:v.flags=v.flags&-65537|ra;case hee:{var rt=P.payload,_t;if(typeof rt=="function"){lee(),_t=rt.call(me,G,Q);{if(v.mode&Sc){Cd(!0);try{rt.call(me,G,Q)}finally{Cd(!1)}}cee()}}else _t=rt;return _t==null?G:Za({},G,_t)}case xz:return $1=!0,G}return G}function Vz(v,S,P,G){var Q=v.updateQueue;$1=!1,Bz=Q.shared;var me=Q.firstBaseUpdate,De=Q.lastBaseUpdate,We=Q.shared.pending;if(We!==null){Q.shared.pending=null;var rt=We,_t=rt.next;rt.next=null,De===null?me=_t:De.next=_t,De=rt;var Ut=v.alternate;if(Ut!==null){var Di=Ut.updateQueue,Ri=Di.lastBaseUpdate;Ri!==De&&(Ri===null?Di.firstBaseUpdate=_t:Ri.next=_t,Di.lastBaseUpdate=rt)}}if(me!==null){var Xi=Q.baseState,tn=En,Cn=null,Ja=null,po=null,Gr=me;do{var Dl=Gr.lane,hl=Gr.eventTime;if(zp(G,Dl)){if(po!==null){var bn={eventTime:hl,lane:Vs,tag:Gr.tag,payload:Gr.payload,callback:Gr.callback,next:null};po=po.next=bn}Xi=pee(v,Q,Gr,Xi,S,P);var Wi=Gr.callback;if(Wi!==null&&Gr.lane!==Vs){v.flags|=fc;var ca=Q.effects;ca===null?Q.effects=[Gr]:ca.push(Gr)}}else{var qi={eventTime:hl,lane:Dl,tag:Gr.tag,payload:Gr.payload,callback:Gr.callback,next:null};po===null?(Ja=po=qi,Cn=Xi):po=po.next=qi,tn=Jo(tn,Dl)}if(Gr=Gr.next,Gr===null){if(We=Q.shared.pending,We===null)break;var fr=We,or=fr.next;fr.next=null,Gr=or,Q.lastBaseUpdate=fr,Q.shared.pending=null}}while(!0);po===null&&(Cn=Xi),Q.baseState=Cn,Q.firstBaseUpdate=Ja,Q.lastBaseUpdate=po;var Bo=Q.shared.interleaved;if(Bo!==null){var rs=Bo;do tn=Jo(tn,rs.lane),rs=rs.next;while(rs!==Bo)}else me===null&&(Q.shared.lanes=En);er(tn),v.lanes=tn,v.memoizedState=Xi}Bz=null}function cve(v,S){if(typeof v!="function")throw new Error("Invalid argument passed as callback. Expected a function. Instead "+("received: "+v));v.call(S)}function gee(){$1=!1}function $z(){return $1}function mee(v,S,P){var G=S.effects;if(S.effects=null,G!==null)for(var Q=0;Q<G.length;Q++){var me=G[Q],De=me.callback;De!==null&&(me.callback=null,cve(De,P))}}var H1={},OR=IR(H1),j1=IR(H1),yD=IR(H1);function G1(v){if(v===H1)throw new Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");return v}function fee(){var v=G1(yD.current);return v}function G7(v,S){Tm(yD,S,v),Tm(j1,v,v),Tm(OR,H1,v);var P=HI(S);bm(OR,v),Tm(OR,P,v)}function q1(v){bm(OR,v),bm(j1,v),bm(yD,v)}function q7(){var v=G1(OR.current);return v}function vee(v){G1(yD.current);var S=G1(OR.current),P=QT(S,v.type);S!==P&&(Tm(j1,v,v),Tm(OR,P,v))}function Hz(v){j1.current===v&&(bm(OR,v),bm(j1,v))}var yee=0,See=1,bee=1,e2=2,eC=IR(yee);function W7(v,S){return(v&S)!==0}function NR(v){return v&See}function W1(v,S){return v&See|S}function K7(v,S){return v|S}function xR(v,S){Tm(eC,S,v)}function K1(v){bm(eC,v)}function dve(v,S){var P=v.memoizedState;return P!==null?P.dehydrated!==null:(v.memoizedProps,!0)}function J1(v){for(var S=v;S!==null;){if(S.tag===L){var P=S.memoizedState;if(P!==null){var G=P.dehydrated;if(G===null||lD(G)||I1(G))return S}}else if(S.tag===re&&S.memoizedProps.revealOrder!==void 0){var Q=(S.flags&ra)!==Ia;if(Q)return S}else if(S.child!==null){S.child.return=S,S=S.child;continue}if(S===v)return null;for(;S.sibling===null;){if(S.return===null||S.return===v)return null;S=S.return}S.sibling.return=S.return,S=S.sibling}return null}var DS=0,Nh=1,z0=2,Mg=4,ff=8,J7=[];function Y7(){for(var v=0;v<J7.length;v++){var S=J7[v];S._workInProgressVersionPrimary=null}J7.length=0}function uve(v,S){var P=S._getVersion,G=P(S._source);v.mutableSourceEagerHydrationData==null?v.mutableSourceEagerHydrationData=[S,G]:v.mutableSourceEagerHydrationData.push(S,G)}var gr=i.ReactCurrentDispatcher,t2=i.ReactCurrentBatchConfig,Q7,Y1;Q7=new Set;var SD=En,Gc=null,Pg=null,Dg=null,jz=!1,i2=!1,n2=0,Tee=0,Cee=25,Dn=null,tC=null,BR=-1,Z7=!1;function wc(){{var v=Dn;tC===null?tC=[v]:tC.push(v)}}function xa(){{var v=Dn;tC!==null&&(BR++,tC[BR]!==v&&_ee(v))}}function FR(v){v!=null&&!Ko(v)&&d("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.",Dn,typeof v)}function _ee(v){{var S=Do(Gc);if(!Q7.has(S)&&(Q7.add(S),tC!==null)){for(var P="",G=30,Q=0;Q<=BR;Q++){for(var me=tC[Q],De=Q===BR?v:me,We=Q+1+". "+me;We.length<G;)We+=" ";We+=De+`
`,P+=We}d(`React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks

   Previous render            Next render
   ------------------------------------------------------
%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
`,S,P)}}}function Cv(){throw new Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`)}function X7(v,S){if(Z7)return!1;if(S===null)return d("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.",Dn),!1;v.length!==S.length&&d(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`,Dn,"["+S.join(", ")+"]","["+v.join(", ")+"]");for(var P=0;P<S.length&&P<v.length;P++)if(!Jn(v[P],S[P]))return!1;return!0}function bD(v,S,P,G,Q,me){SD=me,Gc=S,tC=v!==null?v._debugHookTypes:null,BR=-1,Z7=v!==null&&v.type!==S.type,S.memoizedState=null,S.updateQueue=null,S.lanes=En,v!==null&&v.memoizedState!==null?gr.current=Qr:tC!==null?gr.current=Ba:gr.current=ka;var De=P(G,Q);if(i2){var We=0;do{if(i2=!1,n2=0,We>=Cee)throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");We+=1,Z7=!1,Pg=null,Dg=null,S.updateQueue=null,BR=-1,gr.current=la,De=P(G,Q)}while(i2)}gr.current=lr,S._debugHookTypes=tC;var rt=Pg!==null&&Pg.next!==null;if(SD=En,Gc=null,Pg=null,Dg=null,Dn=null,tC=null,BR=-1,v!==null&&(v.flags&vc)!==(S.flags&vc)&&(v.mode&ps)!==Jr&&d("Internal React error: Expected static flag was missing. Please notify the React team."),jz=!1,rt)throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");return De}function Q1(){var v=n2!==0;return n2=0,v}function eG(v,S,P){S.updateQueue=v.updateQueue,(S.mode&Hl)!==Jr?S.flags&=-50333701:S.flags&=-2053,v.lanes=I_(v.lanes,P)}function Eee(){if(gr.current=lr,jz){for(var v=Gc.memoizedState;v!==null;){var S=v.queue;S!==null&&(S.pending=null),v=v.next}jz=!1}SD=En,Gc=null,Pg=null,Dg=null,tC=null,BR=-1,Dn=null,sa=!1,i2=!1,n2=0}function V0(){var v={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};return Dg===null?Gc.memoizedState=Dg=v:Dg=Dg.next=v,Dg}function LS(){var v;if(Pg===null){var S=Gc.alternate;S!==null?v=S.memoizedState:v=null}else v=Pg.next;var P;if(Dg===null?P=Gc.memoizedState:P=Dg.next,P!==null)Dg=P,P=Dg.next,Pg=v;else{if(v===null)throw new Error("Rendered more hooks than during the previous render.");Pg=v;var G={memoizedState:Pg.memoizedState,baseState:Pg.baseState,baseQueue:Pg.baseQueue,queue:Pg.queue,next:null};Dg===null?Gc.memoizedState=Dg=G:Dg=Dg.next=G}return Dg}function Aee(){return{lastEffect:null,stores:null}}function Gz(v,S){return typeof S=="function"?S(v):S}function qz(v,S,P){var G=V0(),Q;P!==void 0?Q=P(S):Q=S,G.memoizedState=G.baseState=Q;var me={pending:null,interleaved:null,lanes:En,dispatch:null,lastRenderedReducer:v,lastRenderedState:Q};G.queue=me;var De=me.dispatch=Ir.bind(null,Gc,me);return[G.memoizedState,De]}function tG(v,S,P){var G=LS(),Q=G.queue;if(Q===null)throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");Q.lastRenderedReducer=v;var me=Pg,De=me.baseQueue,We=Q.pending;if(We!==null){if(De!==null){var rt=De.next,_t=We.next;De.next=_t,We.next=rt}me.baseQueue!==De&&d("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React."),me.baseQueue=De=We,Q.pending=null}if(De!==null){var Ut=De.next,Di=me.baseState,Ri=null,Xi=null,tn=null,Cn=Ut;do{var Ja=Cn.lane;if(zp(SD,Ja)){if(tn!==null){var Gr={lane:Vs,action:Cn.action,hasEagerState:Cn.hasEagerState,eagerState:Cn.eagerState,next:null};tn=tn.next=Gr}if(Cn.hasEagerState)Di=Cn.eagerState;else{var Dl=Cn.action;Di=v(Di,Dl)}}else{var po={lane:Ja,action:Cn.action,hasEagerState:Cn.hasEagerState,eagerState:Cn.eagerState,next:null};tn===null?(Xi=tn=po,Ri=Di):tn=tn.next=po,Gc.lanes=Jo(Gc.lanes,Ja),er(Ja)}Cn=Cn.next}while(Cn!==null&&Cn!==Ut);tn===null?Ri=Di:tn.next=Xi,Jn(Di,G.memoizedState)||Sf(),G.memoizedState=Di,G.baseState=Ri,G.baseQueue=tn,Q.lastRenderedState=Di}var hl=Q.interleaved;if(hl!==null){var qi=hl;do{var bn=qi.lane;Gc.lanes=Jo(Gc.lanes,bn),er(bn),qi=qi.next}while(qi!==hl)}else De===null&&(Q.lanes=En);var Wi=Q.dispatch;return[G.memoizedState,Wi]}function Wz(v,S,P){var G=LS(),Q=G.queue;if(Q===null)throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");Q.lastRenderedReducer=v;var me=Q.dispatch,De=Q.pending,We=G.memoizedState;if(De!==null){Q.pending=null;var rt=De.next,_t=rt;do{var Ut=_t.action;We=v(We,Ut),_t=_t.next}while(_t!==rt);Jn(We,G.memoizedState)||Sf(),G.memoizedState=We,G.baseQueue===null&&(G.baseState=We),Q.lastRenderedState=We}return[We,me]}function Iee(v,S,P){}function F8e(v,S,P){}function iG(v,S,P){var G=Gc,Q=V0(),me,De=mf();if(De){if(P===void 0)throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");me=P(),Y1||me!==P()&&(d("The result of getServerSnapshot should be cached to avoid an infinite loop"),Y1=!0)}else{if(me=S(),!Y1){var We=S();Jn(me,We)||(d("The result of getSnapshot should be cached to avoid an infinite loop"),Y1=!0)}var rt=DD();if(rt===null)throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");S0(rt,SD)||a2(G,S,me)}Q.memoizedState=me;var _t={value:me,getSnapshot:S};return Q.queue=_t,Qz(kee.bind(null,G,_t,v),[v]),G.flags|=Ph,TD(Nh|ff,wee.bind(null,G,_t,me,S),void 0,null),me}function Z1(v,S,P){var G=Gc,Q=LS(),me=S();if(!Y1){var De=S();Jn(me,De)||(d("The result of getSnapshot should be cached to avoid an infinite loop"),Y1=!0)}var We=Q.memoizedState,rt=!Jn(We,me);rt&&(Q.memoizedState=me,Sf());var _t=Q.queue;if(M(kee.bind(null,G,_t,v),[v]),_t.getSnapshot!==S||rt||Dg!==null&&Dg.memoizedState.tag&Nh){G.flags|=Ph,TD(Nh|ff,wee.bind(null,G,_t,me,S),void 0,null);var Ut=DD();if(Ut===null)throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");S0(Ut,SD)||a2(G,S,me)}return me}function a2(v,S,P){v.flags|=Hc;var G={getSnapshot:S,value:P},Q=Gc.updateQueue;if(Q===null)Q=Aee(),Gc.updateQueue=Q,Q.stores=[G];else{var me=Q.stores;me===null?Q.stores=[G]:me.push(G)}}function wee(v,S,P,G){S.value=P,S.getSnapshot=G,nG(S)&&aG(v)}function kee(v,S,P){var G=function(){nG(S)&&aG(v)};return P(G)}function nG(v){var S=v.getSnapshot,P=v.value;try{var G=S();return!Jn(P,G)}catch{return!0}}function aG(v){var S=Qp(v,ao);S!==null&&mp(S,v,ao,bc)}function r2(v){var S=V0();typeof v=="function"&&(v=v()),S.memoizedState=S.baseState=v;var P={pending:null,interleaved:null,lanes:En,dispatch:null,lastRenderedReducer:Gz,lastRenderedState:v};S.queue=P;var G=P.dispatch=fn.bind(null,Gc,P);return[S.memoizedState,G]}function rG(v){return tG(Gz)}function Kz(v){return Wz(Gz)}function TD(v,S,P,G){var Q={tag:v,create:S,destroy:P,deps:G,next:null},me=Gc.updateQueue;if(me===null)me=Aee(),Gc.updateQueue=me,me.lastEffect=Q.next=Q;else{var De=me.lastEffect;if(De===null)me.lastEffect=Q.next=Q;else{var We=De.next;De.next=Q,Q.next=We,me.lastEffect=Q}}return Q}function oG(v){var S=V0();{var P={current:v};return S.memoizedState=P,P}}function Jz(v){var S=LS();return S.memoizedState}function X1(v,S,P,G){var Q=V0(),me=G===void 0?null:G;Gc.flags|=v,Q.memoizedState=TD(Nh|S,P,void 0,me)}function Yz(v,S,P,G){var Q=LS(),me=G===void 0?null:G,De=void 0;if(Pg!==null){var We=Pg.memoizedState;if(De=We.destroy,me!==null){var rt=We.deps;if(X7(me,rt)){Q.memoizedState=TD(S,P,De,me);return}}}Gc.flags|=v,Q.memoizedState=TD(Nh|S,P,De,me)}function Qz(v,S){return(Gc.mode&Hl)!==Jr?X1(Hu|Ph|g_,ff,v,S):X1(Ph|g_,ff,v,S)}function M(v,S){return Yz(Ph,ff,v,S)}function V(v,S){return X1(Kr,z0,v,S)}function Y(v,S){return Yz(Kr,z0,v,S)}function ie(v,S){var P=Kr;return P|=Lp,(Gc.mode&Hl)!==Jr&&(P|=ry),X1(P,Mg,v,S)}function ye(v,S){return Yz(Kr,Mg,v,S)}function _e(v,S){if(typeof S=="function"){var P=S,G=v();return P(G),function(){P(null)}}else if(S!=null){var Q=S;Q.hasOwnProperty("current")||d("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.","an object with keys {"+Object.keys(Q).join(", ")+"}");var me=v();return Q.current=me,function(){Q.current=null}}}function Ue(v,S,P){typeof S!="function"&&d("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.",S!==null?typeof S:"null");var G=P!=null?P.concat([v]):null,Q=Kr;return Q|=Lp,(Gc.mode&Hl)!==Jr&&(Q|=ry),X1(Q,Mg,_e.bind(null,S,v),G)}function et(v,S,P){typeof S!="function"&&d("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.",S!==null?typeof S:"null");var G=P!=null?P.concat([v]):null;return Yz(Kr,Mg,_e.bind(null,S,v),G)}function nt(v,S){}var lt=nt;function Ct(v,S){var P=V0(),G=S===void 0?null:S;return P.memoizedState=[v,G],v}function zt(v,S){var P=LS(),G=S===void 0?null:S,Q=P.memoizedState;if(Q!==null&&G!==null){var me=Q[1];if(X7(G,me))return Q[0]}return P.memoizedState=[v,G],v}function li(v,S){var P=V0(),G=S===void 0?null:S,Q=v();return P.memoizedState=[Q,G],Q}function ii(v,S){var P=LS(),G=S===void 0?null:S,Q=P.memoizedState;if(Q!==null&&G!==null){var me=Q[1];if(X7(G,me))return Q[0]}var De=v();return P.memoizedState=[De,G],De}function wi(v){var S=V0();return S.memoizedState=v,v}function oi(v){var S=LS(),P=Pg,G=P.memoizedState;return ui(S,G,v)}function Gt(v){var S=LS();if(Pg===null)return S.memoizedState=v,v;var P=Pg.memoizedState;return ui(S,P,v)}function ui(v,S,P){var G=!y0(SD);if(G){if(!Jn(P,S)){var Q=af();Gc.lanes=Jo(Gc.lanes,Q),er(Q),v.baseState=!0}return S}else return v.baseState&&(v.baseState=!1,Sf()),v.memoizedState=P,P}function $i(v,S,P){var G=gm();Tc(Kk(G,TS)),v(!0);var Q=t2.transition;t2.transition={};var me=t2.transition;t2.transition._updatedFibers=new Set;try{v(!1),S()}finally{if(Tc(G),t2.transition=Q,Q===null&&me._updatedFibers){var De=me._updatedFibers.size;De>10&&l("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."),me._updatedFibers.clear()}}}function In(){var v=r2(!1),S=v[0],P=v[1],G=$i.bind(null,P),Q=V0();return Q.memoizedState=G,[S,G]}function Kt(){var v=rG(),S=v[0],P=LS(),G=P.memoizedState;return[S,G]}function ki(){var v=Kz(),S=v[0],P=LS(),G=P.memoizedState;return[S,G]}var sa=!1;function $a(){return sa}function Mr(){var v=V0(),S=DD(),P=S.identifierPrefix,G;if(mf()){var Q=Yfe();G=":"+P+"R"+Q;var me=n2++;me>0&&(G+="H"+me.toString(32)),G+=":"}else{var De=Tee++;G=":"+P+"r"+De.toString(32)+":"}return v.memoizedState=G,G}function mn(){var v=LS(),S=v.memoizedState;return S}function Ir(v,S,P){typeof arguments[3]=="function"&&d("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");var G=Y0(v),Q={lane:G,action:P,hasEagerState:!1,eagerState:null,next:null};if(Xn(v))mi(S,Q);else{var me=DR(v,S,Q,G);if(me!==null){var De=Af();mp(me,v,G,De),wn(me,S,G)}}wa(v,G)}function fn(v,S,P){typeof arguments[3]=="function"&&d("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");var G=Y0(v),Q={lane:G,action:P,hasEagerState:!1,eagerState:null,next:null};if(Xn(v))mi(S,Q);else{var me=v.alternate;if(v.lanes===En&&(me===null||me.lanes===En)){var De=S.lastRenderedReducer;if(De!==null){var We;We=gr.current,gr.current=sc;try{var rt=S.lastRenderedState,_t=De(rt,P);if(Q.hasEagerState=!0,Q.eagerState=_t,Jn(_t,rt)){ove(v,S,Q,G);return}}catch{}finally{gr.current=We}}}var Ut=DR(v,S,Q,G);if(Ut!==null){var Di=Af();mp(Ut,v,G,Di),wn(Ut,S,G)}}wa(v,G)}function Xn(v){var S=v.alternate;return v===Gc||S!==null&&S===Gc}function mi(v,S){i2=jz=!0;var P=v.pending;P===null?S.next=S:(S.next=P.next,P.next=S),v.pending=S}function wn(v,S,P){if(vI(P)){var G=S.lanes;G=yI(G,v.pendingLanes);var Q=Jo(G,P);S.lanes=Q,fv(v,Q)}}function wa(v,S,P){b_(v,S)}var lr={readContext:lp,useCallback:Cv,useContext:Cv,useEffect:Cv,useImperativeHandle:Cv,useInsertionEffect:Cv,useLayoutEffect:Cv,useMemo:Cv,useReducer:Cv,useRef:Cv,useState:Cv,useDebugValue:Cv,useDeferredValue:Cv,useTransition:Cv,useMutableSource:Cv,useSyncExternalStore:Cv,useId:Cv,unstable_isNewReconciler:te},ka=null,Ba=null,Qr=null,la=null,mr=null,sc=null,Rs=null;{var Vd=function(){d("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().")},xr=function(){d("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks")};ka={readContext:function(v){return lp(v)},useCallback:function(v,S){return Dn="useCallback",wc(),FR(S),Ct(v,S)},useContext:function(v){return Dn="useContext",wc(),lp(v)},useEffect:function(v,S){return Dn="useEffect",wc(),FR(S),Qz(v,S)},useImperativeHandle:function(v,S,P){return Dn="useImperativeHandle",wc(),FR(P),Ue(v,S,P)},useInsertionEffect:function(v,S){return Dn="useInsertionEffect",wc(),FR(S),V(v,S)},useLayoutEffect:function(v,S){return Dn="useLayoutEffect",wc(),FR(S),ie(v,S)},useMemo:function(v,S){Dn="useMemo",wc(),FR(S);var P=gr.current;gr.current=mr;try{return li(v,S)}finally{gr.current=P}},useReducer:function(v,S,P){Dn="useReducer",wc();var G=gr.current;gr.current=mr;try{return qz(v,S,P)}finally{gr.current=G}},useRef:function(v){return Dn="useRef",wc(),oG(v)},useState:function(v){Dn="useState",wc();var S=gr.current;gr.current=mr;try{return r2(v)}finally{gr.current=S}},useDebugValue:function(v,S){return Dn="useDebugValue",wc(),void 0},useDeferredValue:function(v){return Dn="useDeferredValue",wc(),wi(v)},useTransition:function(){return Dn="useTransition",wc(),In()},useMutableSource:function(v,S,P){return Dn="useMutableSource",wc(),void 0},useSyncExternalStore:function(v,S,P){return Dn="useSyncExternalStore",wc(),iG(v,S,P)},useId:function(){return Dn="useId",wc(),Mr()},unstable_isNewReconciler:te},Ba={readContext:function(v){return lp(v)},useCallback:function(v,S){return Dn="useCallback",xa(),Ct(v,S)},useContext:function(v){return Dn="useContext",xa(),lp(v)},useEffect:function(v,S){return Dn="useEffect",xa(),Qz(v,S)},useImperativeHandle:function(v,S,P){return Dn="useImperativeHandle",xa(),Ue(v,S,P)},useInsertionEffect:function(v,S){return Dn="useInsertionEffect",xa(),V(v,S)},useLayoutEffect:function(v,S){return Dn="useLayoutEffect",xa(),ie(v,S)},useMemo:function(v,S){Dn="useMemo",xa();var P=gr.current;gr.current=mr;try{return li(v,S)}finally{gr.current=P}},useReducer:function(v,S,P){Dn="useReducer",xa();var G=gr.current;gr.current=mr;try{return qz(v,S,P)}finally{gr.current=G}},useRef:function(v){return Dn="useRef",xa(),oG(v)},useState:function(v){Dn="useState",xa();var S=gr.current;gr.current=mr;try{return r2(v)}finally{gr.current=S}},useDebugValue:function(v,S){return Dn="useDebugValue",xa(),void 0},useDeferredValue:function(v){return Dn="useDeferredValue",xa(),wi(v)},useTransition:function(){return Dn="useTransition",xa(),In()},useMutableSource:function(v,S,P){return Dn="useMutableSource",xa(),void 0},useSyncExternalStore:function(v,S,P){return Dn="useSyncExternalStore",xa(),iG(v,S,P)},useId:function(){return Dn="useId",xa(),Mr()},unstable_isNewReconciler:te},Qr={readContext:function(v){return lp(v)},useCallback:function(v,S){return Dn="useCallback",xa(),zt(v,S)},useContext:function(v){return Dn="useContext",xa(),lp(v)},useEffect:function(v,S){return Dn="useEffect",xa(),M(v,S)},useImperativeHandle:function(v,S,P){return Dn="useImperativeHandle",xa(),et(v,S,P)},useInsertionEffect:function(v,S){return Dn="useInsertionEffect",xa(),Y(v,S)},useLayoutEffect:function(v,S){return Dn="useLayoutEffect",xa(),ye(v,S)},useMemo:function(v,S){Dn="useMemo",xa();var P=gr.current;gr.current=sc;try{return ii(v,S)}finally{gr.current=P}},useReducer:function(v,S,P){Dn="useReducer",xa();var G=gr.current;gr.current=sc;try{return tG(v,S,P)}finally{gr.current=G}},useRef:function(v){return Dn="useRef",xa(),Jz()},useState:function(v){Dn="useState",xa();var S=gr.current;gr.current=sc;try{return rG(v)}finally{gr.current=S}},useDebugValue:function(v,S){return Dn="useDebugValue",xa(),lt()},useDeferredValue:function(v){return Dn="useDeferredValue",xa(),oi(v)},useTransition:function(){return Dn="useTransition",xa(),Kt()},useMutableSource:function(v,S,P){return Dn="useMutableSource",xa(),void 0},useSyncExternalStore:function(v,S,P){return Dn="useSyncExternalStore",xa(),Z1(v,S)},useId:function(){return Dn="useId",xa(),mn()},unstable_isNewReconciler:te},la={readContext:function(v){return lp(v)},useCallback:function(v,S){return Dn="useCallback",xa(),zt(v,S)},useContext:function(v){return Dn="useContext",xa(),lp(v)},useEffect:function(v,S){return Dn="useEffect",xa(),M(v,S)},useImperativeHandle:function(v,S,P){return Dn="useImperativeHandle",xa(),et(v,S,P)},useInsertionEffect:function(v,S){return Dn="useInsertionEffect",xa(),Y(v,S)},useLayoutEffect:function(v,S){return Dn="useLayoutEffect",xa(),ye(v,S)},useMemo:function(v,S){Dn="useMemo",xa();var P=gr.current;gr.current=Rs;try{return ii(v,S)}finally{gr.current=P}},useReducer:function(v,S,P){Dn="useReducer",xa();var G=gr.current;gr.current=Rs;try{return Wz(v,S,P)}finally{gr.current=G}},useRef:function(v){return Dn="useRef",xa(),Jz()},useState:function(v){Dn="useState",xa();var S=gr.current;gr.current=Rs;try{return Kz(v)}finally{gr.current=S}},useDebugValue:function(v,S){return Dn="useDebugValue",xa(),lt()},useDeferredValue:function(v){return Dn="useDeferredValue",xa(),Gt(v)},useTransition:function(){return Dn="useTransition",xa(),ki()},useMutableSource:function(v,S,P){return Dn="useMutableSource",xa(),void 0},useSyncExternalStore:function(v,S,P){return Dn="useSyncExternalStore",xa(),Z1(v,S)},useId:function(){return Dn="useId",xa(),mn()},unstable_isNewReconciler:te},mr={readContext:function(v){return Vd(),lp(v)},useCallback:function(v,S){return Dn="useCallback",xr(),wc(),Ct(v,S)},useContext:function(v){return Dn="useContext",xr(),wc(),lp(v)},useEffect:function(v,S){return Dn="useEffect",xr(),wc(),Qz(v,S)},useImperativeHandle:function(v,S,P){return Dn="useImperativeHandle",xr(),wc(),Ue(v,S,P)},useInsertionEffect:function(v,S){return Dn="useInsertionEffect",xr(),wc(),V(v,S)},useLayoutEffect:function(v,S){return Dn="useLayoutEffect",xr(),wc(),ie(v,S)},useMemo:function(v,S){Dn="useMemo",xr(),wc();var P=gr.current;gr.current=mr;try{return li(v,S)}finally{gr.current=P}},useReducer:function(v,S,P){Dn="useReducer",xr(),wc();var G=gr.current;gr.current=mr;try{return qz(v,S,P)}finally{gr.current=G}},useRef:function(v){return Dn="useRef",xr(),wc(),oG(v)},useState:function(v){Dn="useState",xr(),wc();var S=gr.current;gr.current=mr;try{return r2(v)}finally{gr.current=S}},useDebugValue:function(v,S){return Dn="useDebugValue",xr(),wc(),void 0},useDeferredValue:function(v){return Dn="useDeferredValue",xr(),wc(),wi(v)},useTransition:function(){return Dn="useTransition",xr(),wc(),In()},useMutableSource:function(v,S,P){return Dn="useMutableSource",xr(),wc(),void 0},useSyncExternalStore:function(v,S,P){return Dn="useSyncExternalStore",xr(),wc(),iG(v,S,P)},useId:function(){return Dn="useId",xr(),wc(),Mr()},unstable_isNewReconciler:te},sc={readContext:function(v){return Vd(),lp(v)},useCallback:function(v,S){return Dn="useCallback",xr(),xa(),zt(v,S)},useContext:function(v){return Dn="useContext",xr(),xa(),lp(v)},useEffect:function(v,S){return Dn="useEffect",xr(),xa(),M(v,S)},useImperativeHandle:function(v,S,P){return Dn="useImperativeHandle",xr(),xa(),et(v,S,P)},useInsertionEffect:function(v,S){return Dn="useInsertionEffect",xr(),xa(),Y(v,S)},useLayoutEffect:function(v,S){return Dn="useLayoutEffect",xr(),xa(),ye(v,S)},useMemo:function(v,S){Dn="useMemo",xr(),xa();var P=gr.current;gr.current=sc;try{return ii(v,S)}finally{gr.current=P}},useReducer:function(v,S,P){Dn="useReducer",xr(),xa();var G=gr.current;gr.current=sc;try{return tG(v,S,P)}finally{gr.current=G}},useRef:function(v){return Dn="useRef",xr(),xa(),Jz()},useState:function(v){Dn="useState",xr(),xa();var S=gr.current;gr.current=sc;try{return rG(v)}finally{gr.current=S}},useDebugValue:function(v,S){return Dn="useDebugValue",xr(),xa(),lt()},useDeferredValue:function(v){return Dn="useDeferredValue",xr(),xa(),oi(v)},useTransition:function(){return Dn="useTransition",xr(),xa(),Kt()},useMutableSource:function(v,S,P){return Dn="useMutableSource",xr(),xa(),void 0},useSyncExternalStore:function(v,S,P){return Dn="useSyncExternalStore",xr(),xa(),Z1(v,S)},useId:function(){return Dn="useId",xr(),xa(),mn()},unstable_isNewReconciler:te},Rs={readContext:function(v){return Vd(),lp(v)},useCallback:function(v,S){return Dn="useCallback",xr(),xa(),zt(v,S)},useContext:function(v){return Dn="useContext",xr(),xa(),lp(v)},useEffect:function(v,S){return Dn="useEffect",xr(),xa(),M(v,S)},useImperativeHandle:function(v,S,P){return Dn="useImperativeHandle",xr(),xa(),et(v,S,P)},useInsertionEffect:function(v,S){return Dn="useInsertionEffect",xr(),xa(),Y(v,S)},useLayoutEffect:function(v,S){return Dn="useLayoutEffect",xr(),xa(),ye(v,S)},useMemo:function(v,S){Dn="useMemo",xr(),xa();var P=gr.current;gr.current=sc;try{return ii(v,S)}finally{gr.current=P}},useReducer:function(v,S,P){Dn="useReducer",xr(),xa();var G=gr.current;gr.current=sc;try{return Wz(v,S,P)}finally{gr.current=G}},useRef:function(v){return Dn="useRef",xr(),xa(),Jz()},useState:function(v){Dn="useState",xr(),xa();var S=gr.current;gr.current=sc;try{return Kz(v)}finally{gr.current=S}},useDebugValue:function(v,S){return Dn="useDebugValue",xr(),xa(),lt()},useDeferredValue:function(v){return Dn="useDeferredValue",xr(),xa(),Gt(v)},useTransition:function(){return Dn="useTransition",xr(),xa(),ki()},useMutableSource:function(v,S,P){return Dn="useMutableSource",xr(),xa(),void 0},useSyncExternalStore:function(v,S,P){return Dn="useSyncExternalStore",xr(),xa(),Z1(v,S)},useId:function(){return Dn="useId",xr(),xa(),mn()},unstable_isNewReconciler:te}}var Ad=e.unstable_now,OS=0,Ch=-1,Sn=-1,Ha=-1,cr=!1,ba=!1;function Pr(){return cr}function No(){ba=!0}function Eo(){cr=!1,ba=!1}function Cl(){cr=ba,ba=!1}function sd(){return OS}function xh(){OS=Ad()}function Cm(v){Sn=Ad(),v.actualStartTime<0&&(v.actualStartTime=Ad())}function W_(v){Sn=-1}function NS(v,S){if(Sn>=0){var P=Ad()-Sn;v.actualDuration+=P,S&&(v.selfBaseDuration=P),Sn=-1}}function Zp(v){if(Ch>=0){var S=Ad()-Ch;Ch=-1;for(var P=v.return;P!==null;){switch(P.tag){case y:var G=P.stateNode;G.effectDuration+=S;return;case B:var Q=P.stateNode;Q.effectDuration+=S;return}P=P.return}}}function iC(v){if(Ha>=0){var S=Ad()-Ha;Ha=-1;for(var P=v.return;P!==null;){switch(P.tag){case y:var G=P.stateNode;G!==null&&(G.passiveEffectDuration+=S);return;case B:var Q=P.stateNode;Q!==null&&(Q.passiveEffectDuration+=S);return}P=P.return}}}function _m(){Ch=Ad()}function Em(){Ha=Ad()}function nC(v){for(var S=v.child;S;)v.actualDuration+=S.actualDuration,S=S.sibling}function cp(v,S){if(v&&v.defaultProps){var P=Za({},S),G=v.defaultProps;for(var Q in G)P[Q]===void 0&&(P[Q]=G[Q]);return P}return S}var vf={},aC,Ni,ta,Ta,Er,Ro,Ms,Dr,ms,zi,hn;{aC=new Set,Ni=new Set,ta=new Set,Ta=new Set,Dr=new Set,Er=new Set,ms=new Set,zi=new Set,hn=new Set;var Un=new Set;Ms=function(v,S){if(!(v===null||typeof v=="function")){var P=S+"_"+v;Un.has(P)||(Un.add(P),d("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.",S,v))}},Ro=function(v,S){if(S===void 0){var P=ol(v)||"Component";Er.has(P)||(Er.add(P),d("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.",P))}},Object.defineProperty(vf,"_processChildContext",{enumerable:!1,value:function(){throw new Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).")}}),Object.freeze(vf)}function Fa(v,S,P,G){var Q=v.memoizedState,me=P(G,Q);{if(v.mode&Sc){Cd(!0);try{me=P(G,Q)}finally{Cd(!1)}}Ro(S,me)}var De=me==null?Q:Za({},Q,me);if(v.memoizedState=De,v.lanes===En){var We=v.updateQueue;We.baseState=De}}var rr={isMounted:m_,enqueueSetState:function(v,S,P){var G=ov(v),Q=Af(),me=Y0(G),De=ew(Q,me);De.payload=S,P!=null&&(Ms(P,"setState"),De.callback=P);var We=LR(G,De,me);We!==null&&(mp(We,G,me,Q),Uz(We,G,me)),b_(G,me)},enqueueReplaceState:function(v,S,P){var G=ov(v),Q=Af(),me=Y0(G),De=ew(Q,me);De.tag=Nz,De.payload=S,P!=null&&(Ms(P,"replaceState"),De.callback=P);var We=LR(G,De,me);We!==null&&(mp(We,G,me,Q),Uz(We,G,me)),b_(G,me)},enqueueForceUpdate:function(v,S){var P=ov(v),G=Af(),Q=Y0(P),me=ew(G,Q);me.tag=xz,S!=null&&(Ms(S,"forceUpdate"),me.callback=S);var De=LR(P,me,Q);De!==null&&(mp(De,P,Q,G),Uz(De,P,Q)),d0(P,Q)}};function ro(v,S,P,G,Q,me,De){var We=v.stateNode;if(typeof We.shouldComponentUpdate=="function"){var rt=We.shouldComponentUpdate(G,me,De);{if(v.mode&Sc){Cd(!0);try{rt=We.shouldComponentUpdate(G,me,De)}finally{Cd(!1)}}rt===void 0&&d("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.",ol(S)||"Component")}return rt}return S.prototype&&S.prototype.isPureReactComponent?!Cr(P,G)||!Cr(Q,me):!0}function hi(v,S,P){var G=v.stateNode;{var Q=ol(S)||"Component",me=G.render;me||(S.prototype&&typeof S.prototype.render=="function"?d("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?",Q):d("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.",Q)),G.getInitialState&&!G.getInitialState.isReactClassApproved&&!G.state&&d("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?",Q),G.getDefaultProps&&!G.getDefaultProps.isReactClassApproved&&d("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.",Q),G.propTypes&&d("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.",Q),G.contextType&&d("contextType was defined as an instance property on %s. Use a static property to define contextType instead.",Q),S.childContextTypes&&!hn.has(S)&&(v.mode&Sc)===Jr&&(hn.add(S),d(`%s uses the legacy childContextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() instead

.Learn more about this warning here: https://reactjs.org/link/legacy-context`,Q)),S.contextTypes&&!hn.has(S)&&(v.mode&Sc)===Jr&&(hn.add(S),d(`%s uses the legacy contextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() with static contextType instead.

Learn more about this warning here: https://reactjs.org/link/legacy-context`,Q)),G.contextTypes&&d("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.",Q),S.contextType&&S.contextTypes&&!ms.has(S)&&(ms.add(S),d("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.",Q)),typeof G.componentShouldUpdate=="function"&&d("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.",Q),S.prototype&&S.prototype.isPureReactComponent&&typeof G.shouldComponentUpdate<"u"&&d("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.",ol(S)||"A pure component"),typeof G.componentDidUnmount=="function"&&d("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?",Q),typeof G.componentDidReceiveProps=="function"&&d("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().",Q),typeof G.componentWillRecieveProps=="function"&&d("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?",Q),typeof G.UNSAFE_componentWillRecieveProps=="function"&&d("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?",Q);var De=G.props!==P;G.props!==void 0&&De&&d("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.",Q,Q),G.defaultProps&&d("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.",Q,Q),typeof G.getSnapshotBeforeUpdate=="function"&&typeof G.componentDidUpdate!="function"&&!ta.has(S)&&(ta.add(S),d("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.",ol(S))),typeof G.getDerivedStateFromProps=="function"&&d("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.",Q),typeof G.getDerivedStateFromError=="function"&&d("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.",Q),typeof S.getSnapshotBeforeUpdate=="function"&&d("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.",Q);var We=G.state;We&&(typeof We!="object"||Ko(We))&&d("%s.state: must be set to an object or null",Q),typeof G.getChildContext=="function"&&typeof S.childContextTypes!="object"&&d("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().",Q)}}function _h(v,S){S.updater=rr,v.stateNode=S,Cb(S,v),S._reactInternalInstance=vf}function dp(v,S,P){var G=!1,Q=Tv,me=Tv,De=S.contextType;if("contextType"in S){var We=De===null||De!==void 0&&De.$$typeof===ci&&De._context===void 0;if(!We&&!zi.has(S)){zi.add(S);var rt="";De===void 0?rt=" However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file.":typeof De!="object"?rt=" However, it is set to a "+typeof De+".":De.$$typeof===Yl?rt=" Did you accidentally pass the Context.Provider instead?":De._context!==void 0?rt=" Did you accidentally pass the Context.Consumer instead?":rt=" However, it is set to an object with keys {"+Object.keys(De).join(", ")+"}.",d("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s",ol(S)||"Component",rt)}}if(typeof De=="object"&&De!==null)me=lp(De);else{Q=L1(v,S,!0);var _t=S.contextTypes;G=_t!=null,me=G?cD(v,Q):Tv}var Ut=new S(P,me);if(v.mode&Sc){Cd(!0);try{Ut=new S(P,me)}finally{Cd(!1)}}var Di=v.memoizedState=Ut.state!==null&&Ut.state!==void 0?Ut.state:null;_h(v,Ut);{if(typeof S.getDerivedStateFromProps=="function"&&Di===null){var Ri=ol(S)||"Component";Ni.has(Ri)||(Ni.add(Ri),d("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.",Ri,Ut.state===null?"null":"undefined",Ri))}if(typeof S.getDerivedStateFromProps=="function"||typeof Ut.getSnapshotBeforeUpdate=="function"){var Xi=null,tn=null,Cn=null;if(typeof Ut.componentWillMount=="function"&&Ut.componentWillMount.__suppressDeprecationWarning!==!0?Xi="componentWillMount":typeof Ut.UNSAFE_componentWillMount=="function"&&(Xi="UNSAFE_componentWillMount"),typeof Ut.componentWillReceiveProps=="function"&&Ut.componentWillReceiveProps.__suppressDeprecationWarning!==!0?tn="componentWillReceiveProps":typeof Ut.UNSAFE_componentWillReceiveProps=="function"&&(tn="UNSAFE_componentWillReceiveProps"),typeof Ut.componentWillUpdate=="function"&&Ut.componentWillUpdate.__suppressDeprecationWarning!==!0?Cn="componentWillUpdate":typeof Ut.UNSAFE_componentWillUpdate=="function"&&(Cn="UNSAFE_componentWillUpdate"),Xi!==null||tn!==null||Cn!==null){var Ja=ol(S)||"Component",po=typeof S.getDerivedStateFromProps=="function"?"getDerivedStateFromProps()":"getSnapshotBeforeUpdate()";Ta.has(Ja)||(Ta.add(Ja),d(`Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`,Ja,po,Xi!==null?`
  `+Xi:"",tn!==null?`
  `+tn:"",Cn!==null?`
  `+Cn:""))}}}return G&&VX(v,Q,me),Ut}function yf(v,S){var P=S.state;typeof S.componentWillMount=="function"&&S.componentWillMount(),typeof S.UNSAFE_componentWillMount=="function"&&S.UNSAFE_componentWillMount(),P!==S.state&&(d("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.",Do(v)||"Component"),rr.enqueueReplaceState(S,S.state,null))}function Lg(v,S,P,G){var Q=S.state;if(typeof S.componentWillReceiveProps=="function"&&S.componentWillReceiveProps(P,G),typeof S.UNSAFE_componentWillReceiveProps=="function"&&S.UNSAFE_componentWillReceiveProps(P,G),S.state!==Q){{var me=Do(v)||"Component";aC.has(me)||(aC.add(me),d("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.",me))}rr.enqueueReplaceState(S,S.state,null)}}function xb(v,S,P,G){hi(v,S,P);var Q=v.stateNode;Q.props=P,Q.state=v.memoizedState,Q.refs={},Fz(v);var me=S.contextType;if(typeof me=="object"&&me!==null)Q.context=lp(me);else{var De=L1(v,S,!0);Q.context=cD(v,De)}{if(Q.state===P){var We=ol(S)||"Component";Dr.has(We)||(Dr.add(We),d("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.",We))}v.mode&Sc&&G_.recordLegacyContextWarning(v,Q),G_.recordUnsafeLifecycleWarnings(v,Q)}Q.state=v.memoizedState;var rt=S.getDerivedStateFromProps;if(typeof rt=="function"&&(Fa(v,S,rt,P),Q.state=v.memoizedState),typeof S.getDerivedStateFromProps!="function"&&typeof Q.getSnapshotBeforeUpdate!="function"&&(typeof Q.UNSAFE_componentWillMount=="function"||typeof Q.componentWillMount=="function")&&(yf(v,Q),Vz(v,P,Q,G),Q.state=v.memoizedState),typeof Q.componentDidMount=="function"){var _t=Kr;_t|=Lp,(v.mode&Hl)!==Jr&&(_t|=ry),v.flags|=_t}}function _v(v,S,P,G){var Q=v.stateNode,me=v.memoizedProps;Q.props=me;var De=Q.context,We=S.contextType,rt=Tv;if(typeof We=="object"&&We!==null)rt=lp(We);else{var _t=L1(v,S,!0);rt=cD(v,_t)}var Ut=S.getDerivedStateFromProps,Di=typeof Ut=="function"||typeof Q.getSnapshotBeforeUpdate=="function";!Di&&(typeof Q.UNSAFE_componentWillReceiveProps=="function"||typeof Q.componentWillReceiveProps=="function")&&(me!==P||De!==rt)&&Lg(v,Q,P,rt),gee();var Ri=v.memoizedState,Xi=Q.state=Ri;if(Vz(v,P,Q,G),Xi=v.memoizedState,me===P&&Ri===Xi&&!_z()&&!$z()){if(typeof Q.componentDidMount=="function"){var tn=Kr;tn|=Lp,(v.mode&Hl)!==Jr&&(tn|=ry),v.flags|=tn}return!1}typeof Ut=="function"&&(Fa(v,S,Ut,P),Xi=v.memoizedState);var Cn=$z()||ro(v,S,me,P,Ri,Xi,rt);if(Cn){if(!Di&&(typeof Q.UNSAFE_componentWillMount=="function"||typeof Q.componentWillMount=="function")&&(typeof Q.componentWillMount=="function"&&Q.componentWillMount(),typeof Q.UNSAFE_componentWillMount=="function"&&Q.UNSAFE_componentWillMount()),typeof Q.componentDidMount=="function"){var Ja=Kr;Ja|=Lp,(v.mode&Hl)!==Jr&&(Ja|=ry),v.flags|=Ja}}else{if(typeof Q.componentDidMount=="function"){var po=Kr;po|=Lp,(v.mode&Hl)!==Jr&&(po|=ry),v.flags|=po}v.memoizedProps=P,v.memoizedState=Xi}return Q.props=P,Q.state=Xi,Q.context=rt,Cn}function tw(v,S,P,G,Q){var me=S.stateNode;j7(v,S);var De=S.memoizedProps,We=S.type===S.elementType?De:cp(S.type,De);me.props=We;var rt=S.pendingProps,_t=me.context,Ut=P.contextType,Di=Tv;if(typeof Ut=="object"&&Ut!==null)Di=lp(Ut);else{var Ri=L1(S,P,!0);Di=cD(S,Ri)}var Xi=P.getDerivedStateFromProps,tn=typeof Xi=="function"||typeof me.getSnapshotBeforeUpdate=="function";!tn&&(typeof me.UNSAFE_componentWillReceiveProps=="function"||typeof me.componentWillReceiveProps=="function")&&(De!==rt||_t!==Di)&&Lg(S,me,G,Di),gee();var Cn=S.memoizedState,Ja=me.state=Cn;if(Vz(S,G,me,Q),Ja=S.memoizedState,De===rt&&Cn===Ja&&!_z()&&!$z())return typeof me.componentDidUpdate=="function"&&(De!==v.memoizedProps||Cn!==v.memoizedState)&&(S.flags|=Kr),typeof me.getSnapshotBeforeUpdate=="function"&&(De!==v.memoizedProps||Cn!==v.memoizedState)&&(S.flags|=iu),!1;typeof Xi=="function"&&(Fa(S,P,Xi,G),Ja=S.memoizedState);var po=$z()||ro(S,P,We,G,Cn,Ja,Di)||Se;return po?(!tn&&(typeof me.UNSAFE_componentWillUpdate=="function"||typeof me.componentWillUpdate=="function")&&(typeof me.componentWillUpdate=="function"&&me.componentWillUpdate(G,Ja,Di),typeof me.UNSAFE_componentWillUpdate=="function"&&me.UNSAFE_componentWillUpdate(G,Ja,Di)),typeof me.componentDidUpdate=="function"&&(S.flags|=Kr),typeof me.getSnapshotBeforeUpdate=="function"&&(S.flags|=iu)):(typeof me.componentDidUpdate=="function"&&(De!==v.memoizedProps||Cn!==v.memoizedState)&&(S.flags|=Kr),typeof me.getSnapshotBeforeUpdate=="function"&&(De!==v.memoizedProps||Cn!==v.memoizedState)&&(S.flags|=iu),S.memoizedProps=G,S.memoizedState=Ja),me.props=G,me.state=Ja,me.context=Di,po}function kn(v,S){return{value:v,source:S,stack:iS(S),digest:null}}function o2(v,S,P){return{value:v,source:null,stack:P??null,digest:S??null}}function xS(v,S){return!0}function eN(v,S){try{var P=xS(v,S);if(P===!1)return;var G=S.value,Q=S.source,me=S.stack,De=me!==null?me:"";if(G!=null&&G._suppressLogging){if(v.tag===g)return;console.error(G)}var We=Q?Do(Q):null,rt=We?"The above error occurred in the <"+We+"> component:":"The above error occurred in one of your React components:",_t;if(v.tag===y)_t=`Consider adding an error boundary to your tree to customize error handling behavior.
Visit https://reactjs.org/link/error-boundaries to learn more about error boundaries.`;else{var Ut=Do(v)||"Anonymous";_t="React will try to recreate this component tree from scratch "+("using the error boundary you provided, "+Ut+".")}var Di=rt+`
`+De+`

`+(""+_t);console.error(Di)}catch(Ri){setTimeout(function(){throw Ri})}}var tN=typeof WeakMap=="function"?WeakMap:Map;function wy(v,S,P){var G=ew(bc,P);G.tag=H7,G.payload={element:null};var Q=S.value;return G.callback=function(){nte(Q),eN(v,S)},G}function Qu(v,S,P){var G=ew(bc,P);G.tag=H7;var Q=v.type.getDerivedStateFromError;if(typeof Q=="function"){var me=S.value;G.payload=function(){return Q(me)},G.callback=function(){ste(v),eN(v,S)}}var De=v.stateNode;return De!==null&&typeof De.componentDidCatch=="function"&&(G.callback=function(){ste(v),eN(v,S),typeof Q!="function"&&gw(this);var rt=S.value,_t=S.stack;this.componentDidCatch(rt,{componentStack:_t!==null?_t:""}),typeof Q!="function"&&(pm(v.lanes,ao)||d("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.",Do(v)||"Unknown"))}),G}function Zz(v,S,P){var G=v.pingCache,Q;if(G===null?(G=v.pingCache=new tN,Q=new Set,G.set(S,Q)):(Q=G.get(S),Q===void 0&&(Q=new Set,G.set(S,Q))),!Q.has(P)){Q.add(P);var me=fp.bind(null,v,S,P);Bp&&X_(v,P),S.then(me,me)}}function sG(v,S,P,G){var Q=v.updateQueue;if(Q===null){var me=new Set;me.add(P),v.updateQueue=me}else Q.add(P)}function s2(v,S){var P=v.tag;if((v.mode&ps)===Jr&&(P===p||P===x||P===H)){var G=v.alternate;G?(v.updateQueue=G.updateQueue,v.memoizedState=G.memoizedState,v.lanes=G.lanes):(v.updateQueue=null,v.memoizedState=null)}}function l2(v){var S=v;do{if(S.tag===L&&dve(S))return S;S=S.return}while(S!==null);return null}function $0(v,S,P,G,Q){if((v.mode&ps)===Jr){if(v===S)v.flags|=Dh;else{if(v.flags|=ra,P.flags|=bg,P.flags&=-52805,P.tag===g){var me=P.alternate;if(me===null)P.tag=J;else{var De=ew(bc,ao);De.tag=xz,LR(P,De,ao)}}P.lanes=Jo(P.lanes,ao)}return v}return v.flags|=Dh,v.lanes=Q,v}function lG(v,S,P,G,Q){if(P.flags|=$l,Bp&&X_(v,Q),G!==null&&typeof G=="object"&&typeof G.then=="function"){var me=G;s2(P),mf()&&P.mode&ps&&JX();var De=l2(S);if(De!==null){De.flags&=-257,$0(De,S,P,v,Q),De.mode&ps&&Zz(v,me,Q),sG(De,v,me);return}else{if(!fI(Q)){Zz(v,me,Q),LD();return}var We=new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition.");G=We}}else if(mf()&&P.mode&ps){JX();var rt=l2(S);if(rt!==null){(rt.flags&Dh)===Ia&&(rt.flags|=np),$0(rt,S,P,v,Q),Iz(kn(G,P));return}}G=kn(G,P),ete(G);var _t=S;do{switch(_t.tag){case y:{var Ut=G;_t.flags|=Dh;var Di=A_(Q);_t.lanes=Jo(_t.lanes,Di);var Ri=wy(_t,Ut,Di);zz(_t,Ri);return}case g:var Xi=G,tn=_t.type,Cn=_t.stateNode;if((_t.flags&ra)===Ia&&(typeof tn.getDerivedStateFromError=="function"||Cn!==null&&typeof Cn.componentDidCatch=="function"&&!Pu(Cn))){_t.flags|=Dh;var Ja=A_(Q);_t.lanes=Jo(_t.lanes,Ja);var po=Qu(_t,Xi,Ja);zz(_t,po);return}break}_t=_t.return}while(_t!==null)}function cG(){return null}var K_=i.ReactCurrentOwner,BS=!1,Hs,rC,fi,xo,J_,Og,c2,CD,H0;Hs={},rC={},fi={},xo={},J_={},Og=!1,c2={},CD={},H0={};function Bh(v,S,P,G){v===null?S.child=see(S,null,P,G):S.child=z1(S,v.child,P,G)}function Xz(v,S,P,G){S.child=z1(S,v.child,null,G),S.child=z1(S,null,P,G)}function iN(v,S,P,G,Q){if(S.type!==S.elementType){var me=P.propTypes;me&&Yp(me,G,"prop",ol(P))}var De=P.render,We=S.ref,rt,_t;PR(S,Q),Up(S);{if(K_.current=S,Go(!0),rt=bD(v,S,De,G,We,Q),_t=Q1(),S.mode&Sc){Cd(!0);try{rt=bD(v,S,De,G,We,Q),_t=Q1()}finally{Cd(!1)}}Go(!1)}return Eg(),v!==null&&!BS?(eG(v,S,Q),oC(v,S,Q)):(mf()&&_t&&H_(S),S.flags|=Ym,Bh(v,S,rt,Q),S.child)}function d2(v,S,P,G,Q){if(v===null){var me=P.type;if(TN(me)&&P.compare===null&&P.defaultProps===void 0){var De=me;return De=Z0(me),S.tag=H,S.type=De,j0(S,me),_D(v,S,De,G,Q)}{var We=me.propTypes;if(We&&Yp(We,G,"prop",ol(me)),P.defaultProps!==void 0){var rt=ol(me)||"Unknown";H0[rt]||(d("%s: Support for defaultProps will be removed from memo components in a future major release. Use JavaScript default parameters instead.",rt),H0[rt]=!0)}}var _t=IV(P.type,null,G,S,S.mode,Q);return _t.ref=S.ref,_t.return=S,S.child=_t,_t}{var Ut=P.type,Di=Ut.propTypes;Di&&Yp(Di,G,"prop",ol(Ut))}var Ri=v.child,Xi=AD(v,Q);if(!Xi){var tn=Ri.memoizedProps,Cn=P.compare;if(Cn=Cn!==null?Cn:Cr,Cn(tn,G)&&v.ref===S.ref)return oC(v,S,Q)}S.flags|=Ym;var Ja=fw(Ri,G);return Ja.ref=S.ref,Ja.return=S,S.child=Ja,Ja}function _D(v,S,P,G,Q){if(S.type!==S.elementType){var me=S.elementType;if(me.$$typeof===qa){var De=me,We=De._payload,rt=De._init;try{me=rt(We)}catch{me=null}var _t=me&&me.propTypes;_t&&Yp(_t,G,"prop",ol(me))}}if(v!==null){var Ut=v.memoizedProps;if(Cr(Ut,G)&&v.ref===S.ref&&S.type===v.type)if(BS=!1,S.pendingProps=G=Ut,AD(v,Q))(v.flags&bg)!==Ia&&(BS=!0);else return S.lanes=v.lanes,oC(v,S,Q)}return u2(v,S,P,G,Q)}function eV(v,S,P){var G=S.pendingProps,Q=G.children,me=v!==null?v.memoizedState:null;if(G.mode==="hidden"||ce)if((S.mode&ps)===Jr){var De={baseLanes:En,cachePool:null,transitions:null};S.memoizedState=De,SV(S,P)}else if(pm(P,Ag)){var Di={baseLanes:En,cachePool:null,transitions:null};S.memoizedState=Di;var Ri=me!==null?me.baseLanes:P;SV(S,Ri)}else{var We=null,rt;if(me!==null){var _t=me.baseLanes;rt=Jo(_t,P)}else rt=P;S.lanes=S.childLanes=Ag;var Ut={baseLanes:rt,cachePool:We,transitions:null};return S.memoizedState=Ut,S.updateQueue=null,SV(S,rt),null}else{var Xi;me!==null?(Xi=Jo(me.baseLanes,P),S.memoizedState=null):Xi=P,SV(S,Xi)}return Bh(v,S,Q,P),S.child}function tV(v,S,P){var G=S.pendingProps;return Bh(v,S,G,P),S.child}function iV(v,S,P){var G=S.pendingProps.children;return Bh(v,S,G,P),S.child}function nn(v,S,P){{S.flags|=Kr;{var G=S.stateNode;G.effectDuration=0,G.passiveEffectDuration=0}}var Q=S.pendingProps,me=Q.children;return Bh(v,S,me,P),S.child}function ky(v,S){var P=S.ref;(v===null&&P!==null||v!==null&&v.ref!==P)&&(S.flags|=kl,S.flags|=hS)}function u2(v,S,P,G,Q){if(S.type!==S.elementType){var me=P.propTypes;me&&Yp(me,G,"prop",ol(P))}var De;{var We=L1(S,P,!0);De=cD(S,We)}var rt,_t;PR(S,Q),Up(S);{if(K_.current=S,Go(!0),rt=bD(v,S,P,G,De,Q),_t=Q1(),S.mode&Sc){Cd(!0);try{rt=bD(v,S,P,G,De,Q),_t=Q1()}finally{Cd(!1)}}Go(!1)}return Eg(),v!==null&&!BS?(eG(v,S,Q),oC(v,S,Q)):(mf()&&_t&&H_(S),S.flags|=Ym,Bh(v,S,rt,Q),S.child)}function nV(v,S,P,G,Q){{switch(Uve(S)){case!1:{var me=S.stateNode,De=S.type,We=new De(S.memoizedProps,me.context),rt=We.state;me.updater.enqueueSetState(me,rt,null);break}case!0:{S.flags|=ra,S.flags|=Dh;var _t=new Error("Simulated error coming from DevTools"),Ut=A_(Q);S.lanes=Jo(S.lanes,Ut);var Di=Qu(S,kn(_t,S),Ut);zz(S,Di);break}}if(S.type!==S.elementType){var Ri=P.propTypes;Ri&&Yp(Ri,G,"prop",ol(P))}}var Xi;$_(P)?(Xi=!0,O1(S)):Xi=!1,PR(S,Q);var tn=S.stateNode,Cn;tn===null?(hp(v,S),dp(S,P,G),xb(S,P,G,Q),Cn=!0):v===null?Cn=_v(S,P,G,Q):Cn=tw(v,S,P,G,Q);var Ja=nN(v,S,P,Cn,Xi,Q);{var po=S.stateNode;Cn&&po.props!==G&&(Og||d("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.",Do(S)||"a component"),Og=!0)}return Ja}function nN(v,S,P,G,Q,me){ky(v,S);var De=(S.flags&ra)!==Ia;if(!G&&!De)return Q&&wR(S,P,!1),oC(v,S,me);var We=S.stateNode;K_.current=S;var rt;if(De&&typeof P.getDerivedStateFromError!="function")rt=null,W_();else{Up(S);{if(Go(!0),rt=We.render(),S.mode&Sc){Cd(!0);try{We.render()}finally{Cd(!1)}}Go(!1)}Eg()}return S.flags|=Ym,v!==null&&De?Xz(v,S,rt,me):Bh(v,S,rt,me),S.memoizedState=We.state,Q&&wR(S,P,!0),S.child}function ld(v){var S=v.stateNode;S.pendingContext?_7(v,S.pendingContext,S.pendingContext!==S.context):S.context&&_7(v,S.context,!1),G7(v,S.containerInfo)}function h2(v,S,P){if(ld(S),v===null)throw new Error("Should have a current fiber. This is a bug in React.");var G=S.pendingProps,Q=S.memoizedState,me=Q.element;j7(v,S),Vz(S,G,null,P);var De=S.memoizedState;S.stateNode;var We=De.element;if(Q.isDehydrated){var rt={element:We,isDehydrated:!1,cache:De.cache,pendingSuspenseBoundaries:De.pendingSuspenseBoundaries,transitions:De.transitions},_t=S.updateQueue;if(_t.baseState=rt,S.memoizedState=rt,S.flags&np){var Ut=kn(new Error("There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering."),S);return aV(v,S,We,P,Ut)}else if(We!==me){var Di=kn(new Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."),S);return aV(v,S,We,P,Di)}else{YX(S);var Ri=see(S,null,We,P);S.child=Ri;for(var Xi=Ri;Xi;)Xi.flags=Xi.flags&-3|ap,Xi=Xi.sibling}}else{if(pD(),We===me)return oC(v,S,P);Bh(v,S,We,P)}return S.child}function aV(v,S,P,G,Q){return pD(),Iz(Q),S.flags|=np,Bh(v,S,P,G),S.child}function rV(v,S,P){vee(S),v===null&&L7(S);var G=S.type,Q=S.pendingProps,me=v!==null?v.memoizedProps:null,De=Q.children,We=aD(G,Q);return We?De=null:me!==null&&aD(G,me)&&(S.flags|=Qm),ky(v,S),Bh(v,S,De,P),S.child}function oV(v,S){return v===null&&L7(S),null}function aN(v,S,P,G){hp(v,S);var Q=S.pendingProps,me=P,De=me._payload,We=me._init,rt=We(De);S.type=rt;var _t=S.tag=Nve(rt),Ut=cp(rt,Q),Di;switch(_t){case p:return j0(S,rt),S.type=rt=Z0(rt),Di=u2(null,S,rt,Ut,G),Di;case g:return S.type=rt=_V(rt),Di=nV(null,S,rt,Ut,G),Di;case x:return S.type=rt=Po(rt),Di=iN(null,S,rt,Ut,G),Di;case z:{if(S.type!==S.elementType){var Ri=rt.propTypes;Ri&&Yp(Ri,Ut,"prop",ol(rt))}return Di=d2(null,S,rt,cp(rt.type,Ut),G),Di}}var Xi="";throw rt!==null&&typeof rt=="object"&&rt.$$typeof===qa&&(Xi=" Did you wrap a component in React.lazy() more than once?"),new Error("Element type is invalid. Received a promise that resolves to: "+rt+". "+("Lazy element type must resolve to a class or function."+Xi))}function dG(v,S,P,G,Q){hp(v,S),S.tag=g;var me;return $_(P)?(me=!0,O1(S)):me=!1,PR(S,Q),dp(S,P,G),xb(S,P,G,Q),nN(null,S,P,!0,me,Q)}function rN(v,S,P,G){hp(v,S);var Q=S.pendingProps,me;{var De=L1(S,P,!1);me=cD(S,De)}PR(S,G);var We,rt;Up(S);{if(P.prototype&&typeof P.prototype.render=="function"){var _t=ol(P)||"Unknown";Hs[_t]||(d("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.",_t,_t),Hs[_t]=!0)}S.mode&Sc&&G_.recordLegacyContextWarning(S,null),Go(!0),K_.current=S,We=bD(null,S,P,Q,me,G),rt=Q1(),Go(!1)}if(Eg(),S.flags|=Ym,typeof We=="object"&&We!==null&&typeof We.render=="function"&&We.$$typeof===void 0){var Ut=ol(P)||"Unknown";rC[Ut]||(d("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.",Ut,Ut,Ut),rC[Ut]=!0)}if(typeof We=="object"&&We!==null&&typeof We.render=="function"&&We.$$typeof===void 0){{var Di=ol(P)||"Unknown";rC[Di]||(d("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.",Di,Di,Di),rC[Di]=!0)}S.tag=g,S.memoizedState=null,S.updateQueue=null;var Ri=!1;return $_(P)?(Ri=!0,O1(S)):Ri=!1,S.memoizedState=We.state!==null&&We.state!==void 0?We.state:null,Fz(S),_h(S,We),xb(S,P,Q,G),nN(null,S,P,!0,Ri,G)}else{if(S.tag=p,S.mode&Sc){Cd(!0);try{We=bD(null,S,P,Q,me,G),rt=Q1()}finally{Cd(!1)}}return mf()&&rt&&H_(S),Bh(null,S,We,G),j0(S,P),S.child}}function j0(v,S){{if(S&&S.childContextTypes&&d("%s(...): childContextTypes cannot be defined on a function component.",S.displayName||S.name||"Component"),v.ref!==null){var P="",G=Od();G&&(P+=`

Check the render method of \``+G+"`.");var Q=G||"",me=v._debugSource;me&&(Q=me.fileName+":"+me.lineNumber),J_[Q]||(J_[Q]=!0,d("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s",P))}if(S.defaultProps!==void 0){var De=ol(S)||"Unknown";H0[De]||(d("%s: Support for defaultProps will be removed from function components in a future major release. Use JavaScript default parameters instead.",De),H0[De]=!0)}if(typeof S.getDerivedStateFromProps=="function"){var We=ol(S)||"Unknown";xo[We]||(d("%s: Function components do not support getDerivedStateFromProps.",We),xo[We]=!0)}if(typeof S.contextType=="object"&&S.contextType!==null){var rt=ol(S)||"Unknown";fi[rt]||(d("%s: Function components do not support contextType.",rt),fi[rt]=!0)}}}var Qs={dehydrated:null,treeContext:null,retryLane:Vs};function wu(v){return{baseLanes:v,cachePool:cG(),transitions:null}}function UR(v,S){var P=null;return{baseLanes:Jo(v.baseLanes,S),cachePool:P,transitions:v.transitions}}function sV(v,S,P,G){if(S!==null){var Q=S.memoizedState;if(Q===null)return!1}return W7(v,e2)}function uG(v,S){return I_(v.childLanes,S)}function up(v,S,P){var G=S.pendingProps;zve(S)&&(S.flags|=ra);var Q=eC.current,me=!1,De=(S.flags&ra)!==Ia;if(De||sV(Q,v)?(me=!0,S.flags&=-129):(v===null||v.memoizedState!==null)&&(Q=K7(Q,bee)),Q=NR(Q),xR(S,Q),v===null){L7(S);var We=S.memoizedState;if(We!==null){var rt=We.dehydrated;if(rt!==null)return g2(S,rt)}var _t=G.children,Ut=G.fallback;if(me){var Di=ED(S,_t,Ut,P),Ri=S.child;return Ri.memoizedState=wu(P),S.memoizedState=Qs,Di}else return oN(S,_t)}else{var Xi=v.memoizedState;if(Xi!==null){var tn=Xi.dehydrated;if(tn!==null)return cV(v,S,De,G,tn,Xi,P)}if(me){var Cn=G.fallback,Ja=G.children,po=lV(v,S,Ja,Cn,P),Gr=S.child,Dl=v.child.memoizedState;return Gr.memoizedState=Dl===null?wu(P):UR(Dl,P),Gr.childLanes=uG(v,P),S.memoizedState=Qs,po}else{var hl=G.children,qi=hG(v,S,hl,P);return S.memoizedState=null,qi}}}function oN(v,S,P){var G=v.mode,Q={mode:"visible",children:S},me=ul(Q,G);return me.return=v,v.child=me,me}function ED(v,S,P,G){var Q=v.mode,me=v.child,De={mode:"hidden",children:S},We,rt;return(Q&ps)===Jr&&me!==null?(We=me,We.childLanes=En,We.pendingProps=De,v.mode&nr&&(We.actualDuration=0,We.actualStartTime=-1,We.selfBaseDuration=0,We.treeBaseDuration=0),rt=vw(P,Q,G,null)):(We=ul(De,Q),rt=vw(P,Q,G,null)),We.return=v,rt.return=v,We.sibling=rt,v.child=We,rt}function ul(v,S,P){return $n(v,S,En,null)}function G0(v,S){return fw(v,S)}function hG(v,S,P,G){var Q=v.child,me=Q.sibling,De=G0(Q,{mode:"visible",children:P});if((S.mode&ps)===Jr&&(De.lanes=G),De.return=S,De.sibling=null,me!==null){var We=S.deletions;We===null?(S.deletions=[me],S.flags|=Mh):We.push(me)}return S.child=De,De}function lV(v,S,P,G,Q){var me=S.mode,De=v.child,We=De.sibling,rt={mode:"hidden",children:P},_t;if((me&ps)===Jr&&S.child!==De){var Ut=S.child;_t=Ut,_t.childLanes=En,_t.pendingProps=rt,S.mode&nr&&(_t.actualDuration=0,_t.actualStartTime=-1,_t.selfBaseDuration=De.selfBaseDuration,_t.treeBaseDuration=De.treeBaseDuration),S.deletions=null}else _t=G0(De,rt),_t.subtreeFlags=De.subtreeFlags&vc;var Di;return We!==null?Di=fw(We,G):(Di=vw(G,me,Q,null),Di.flags|=Nd),Di.return=S,_t.return=S,_t.sibling=Di,S.child=_t,Di}function sN(v,S,P,G){G!==null&&Iz(G),z1(S,v.child,null,P);var Q=S.pendingProps,me=Q.children,De=oN(S,me);return De.flags|=Nd,S.memoizedState=null,De}function p2(v,S,P,G,Q){var me=S.mode,De={mode:"visible",children:P},We=ul(De,me),rt=vw(G,me,Q,null);return rt.flags|=Nd,We.return=S,rt.return=S,We.sibling=rt,S.child=We,(S.mode&ps)!==Jr&&z1(S,v.child,null,Q),rt}function g2(v,S,P){return(v.mode&ps)===Jr?(d("Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components."),v.lanes=ao):I1(S)?v.lanes=Ys:v.lanes=Ag,null}function cV(v,S,P,G,Q,me,De){if(P)if(S.flags&np){S.flags&=-257;var qi=o2(new Error("There was an error while hydrating this Suspense boundary. Switched to client rendering."));return sN(v,S,De,qi)}else{if(S.memoizedState!==null)return S.child=v.child,S.flags|=ra,null;var bn=G.children,Wi=G.fallback,ca=p2(v,S,bn,Wi,De),fr=S.child;return fr.memoizedState=wu(De),S.memoizedState=Qs,ca}else{if(KX(),(S.mode&ps)===Jr)return sN(v,S,De,null);if(I1(Q)){var We,rt,_t;{var Ut=xF(Q);We=Ut.digest,rt=Ut.message,_t=Ut.stack}var Di;rt?Di=new Error(rt):Di=new Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.");var Ri=o2(Di,We,_t);return sN(v,S,De,Ri)}var Xi=pm(De,v.childLanes);if(BS||Xi){var tn=DD();if(tn!==null){var Cn=SI(tn,De);if(Cn!==Vs&&Cn!==me.retryLane){me.retryLane=Cn;var Ja=bc;Qp(v,Cn),mp(tn,v,Cn,Ja)}}LD();var po=o2(new Error("This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition."));return sN(v,S,De,po)}else if(lD(Q)){S.flags|=ra,S.child=v.child;var Gr=Dve.bind(null,v);return BF(Q,Gr),null}else{Zfe(S,Q,me.treeContext);var Dl=G.children,hl=oN(S,Dl);return hl.flags|=ap,hl}}}function dV(v,S,P){v.lanes=Jo(v.lanes,S);var G=v.alternate;G!==null&&(G.lanes=Jo(G.lanes,S)),V7(v.return,S,P)}function uV(v,S,P){for(var G=S;G!==null;){if(G.tag===L){var Q=G.memoizedState;Q!==null&&dV(G,P,v)}else if(G.tag===re)dV(G,P,v);else if(G.child!==null){G.child.return=G,G=G.child;continue}if(G===v)return;for(;G.sibling===null;){if(G.return===null||G.return===v)return;G=G.return}G.sibling.return=G.return,G=G.sibling}}function pG(v){for(var S=v,P=null;S!==null;){var G=S.alternate;G!==null&&J1(G)===null&&(P=S),S=S.sibling}return P}function q0(v){if(v!==void 0&&v!=="forwards"&&v!=="backwards"&&v!=="together"&&!c2[v])if(c2[v]=!0,typeof v=="string")switch(v.toLowerCase()){case"together":case"forwards":case"backwards":{d('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.',v,v.toLowerCase());break}case"forward":case"backward":{d('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.',v,v.toLowerCase());break}default:d('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?',v);break}else d('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?',v)}function iw(v,S){v!==void 0&&!CD[v]&&(v!=="collapsed"&&v!=="hidden"?(CD[v]=!0,d('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?',v)):S!=="forwards"&&S!=="backwards"&&(CD[v]=!0,d('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?',v)))}function lN(v,S){{var P=Ko(v),G=!P&&typeof za(v)=="function";if(P||G){var Q=P?"array":"iterable";return d("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>",Q,S,Q),!1}}return!0}function gG(v,S){if((S==="forwards"||S==="backwards")&&v!==void 0&&v!==null&&v!==!1)if(Ko(v)){for(var P=0;P<v.length;P++)if(!lN(v[P],P))return}else{var G=za(v);if(typeof G=="function"){var Q=G.call(v);if(Q)for(var me=Q.next(),De=0;!me.done;me=Q.next()){if(!lN(me.value,De))return;De++}}else d('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?',S)}}function cN(v,S,P,G,Q){var me=v.memoizedState;me===null?v.memoizedState={isBackwards:S,rendering:null,renderingStartTime:0,last:G,tail:P,tailMode:Q}:(me.isBackwards=S,me.rendering=null,me.renderingStartTime=0,me.last=G,me.tail=P,me.tailMode=Q)}function Bt(v,S,P){var G=S.pendingProps,Q=G.revealOrder,me=G.tail,De=G.children;q0(Q),iw(me,Q),gG(De,Q),Bh(v,S,De,P);var We=eC.current,rt=W7(We,e2);if(rt)We=W1(We,e2),S.flags|=ra;else{var _t=v!==null&&(v.flags&ra)!==Ia;_t&&uV(S,S.child,P),We=NR(We)}if(xR(S,We),(S.mode&ps)===Jr)S.memoizedState=null;else switch(Q){case"forwards":{var Ut=pG(S.child),Di;Ut===null?(Di=S.child,S.child=null):(Di=Ut.sibling,Ut.sibling=null),cN(S,!1,Di,Ut,me);break}case"backwards":{var Ri=null,Xi=S.child;for(S.child=null;Xi!==null;){var tn=Xi.alternate;if(tn!==null&&J1(tn)===null){S.child=Xi;break}var Cn=Xi.sibling;Xi.sibling=Ri,Ri=Xi,Xi=Cn}cN(S,!0,Ri,null,me);break}case"together":{cN(S,!1,null,null,void 0);break}default:S.memoizedState=null}return S.child}function Pi(v,S,P){G7(S,S.stateNode.containerInfo);var G=S.pendingProps;return v===null?S.child=z1(S,null,G,P):Bh(v,S,G,P),S.child}var zn=!1;function Br(v,S,P){var G=S.type,Q=G._context,me=S.pendingProps,De=S.memoizedProps,We=me.value;{"value"in me||zn||(zn=!0,d("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?"));var rt=S.type.propTypes;rt&&Yp(rt,me,"prop","Context.Provider")}if(dee(S,Q,We),De!==null){var _t=De.value;if(Jn(_t,We)){if(De.children===me.children&&!_z())return oC(v,S,P)}else uee(S,Q,P)}var Ut=me.children;return Bh(v,S,Ut,P),S.child}var ku=!1;function Ev(v,S,P){var G=S.type;G._context===void 0?G!==G.Consumer&&(ku||(ku=!0,d("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))):G=G._context;var Q=S.pendingProps,me=Q.children;typeof me!="function"&&d("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."),PR(S,P);var De=lp(G);Up(S);var We;return K_.current=S,Go(!0),We=me(De),Go(!1),Eg(),S.flags|=Ym,Bh(v,S,We,P),S.child}function Sf(){BS=!0}function hp(v,S){(S.mode&ps)===Jr&&v!==null&&(v.alternate=null,S.alternate=null,S.flags|=Nd)}function oC(v,S,P){return v!==null&&(S.dependencies=v.dependencies),W_(),er(S.lanes),pm(P,S.childLanes)?(Nb(v,S),S.child):null}function nw(v,S,P){{var G=S.return;if(G===null)throw new Error("Cannot swap the root fiber.");if(v.alternate=null,S.alternate=null,P.index=S.index,P.sibling=S.sibling,P.return=S.return,P.ref=S.ref,S===G.child)G.child=P;else{var Q=G.child;if(Q===null)throw new Error("Expected parent to have a child.");for(;Q.sibling!==S;)if(Q=Q.sibling,Q===null)throw new Error("Expected to find the previous sibling.");Q.sibling=P}var me=G.deletions;return me===null?(G.deletions=[v],G.flags|=Mh):me.push(v),P.flags|=Nd,P}}function AD(v,S){var P=v.lanes;return!!pm(P,S)}function hV(v,S,P){switch(S.tag){case y:ld(S),S.stateNode,pD();break;case C:vee(S);break;case g:{var G=S.type;$_(G)&&O1(S);break}case T:G7(S,S.stateNode.containerInfo);break;case F:{var Q=S.memoizedProps.value,me=S.type._context;dee(S,me,Q);break}case B:{var De=pm(P,S.childLanes);De&&(S.flags|=Kr);{var We=S.stateNode;We.effectDuration=0,We.passiveEffectDuration=0}}break;case L:{var rt=S.memoizedState;if(rt!==null){if(rt.dehydrated!==null)return xR(S,NR(eC.current)),S.flags|=ra,null;var _t=S.child,Ut=_t.childLanes;if(pm(P,Ut))return up(v,S,P);xR(S,NR(eC.current));var Di=oC(v,S,P);return Di!==null?Di.sibling:null}else xR(S,NR(eC.current));break}case re:{var Ri=(v.flags&ra)!==Ia,Xi=pm(P,S.childLanes);if(Ri){if(Xi)return Bt(v,S,P);S.flags|=ra}var tn=S.memoizedState;if(tn!==null&&(tn.rendering=null,tn.tail=null,tn.lastEffect=null),xR(S,eC.current),Xi)break;return null}case le:case he:return S.lanes=En,eV(v,S,P)}return oC(v,S,P)}function dN(v,S,P){if(S._debugNeedsRemount&&v!==null)return nw(v,S,IV(S.type,S.key,S.pendingProps,S._debugOwner||null,S.mode,S.lanes));if(v!==null){var G=v.memoizedProps,Q=S.pendingProps;if(G!==Q||_z()||S.type!==v.type)BS=!0;else{var me=AD(v,P);if(!me&&(S.flags&ra)===Ia)return BS=!1,hV(v,S,P);(v.flags&bg)!==Ia?BS=!0:BS=!1}}else if(BS=!1,mf()&&Kfe(S)){var De=S.index,We=Jfe();GX(S,We,De)}switch(S.lanes=En,S.tag){case f:return rN(v,S,S.type,P);case j:{var rt=S.elementType;return aN(v,S,rt,P)}case p:{var _t=S.type,Ut=S.pendingProps,Di=S.elementType===_t?Ut:cp(_t,Ut);return u2(v,S,_t,Di,P)}case g:{var Ri=S.type,Xi=S.pendingProps,tn=S.elementType===Ri?Xi:cp(Ri,Xi);return nV(v,S,Ri,tn,P)}case y:return h2(v,S,P);case C:return rV(v,S,P);case E:return oV(v,S);case L:return up(v,S,P);case T:return Pi(v,S,P);case x:{var Cn=S.type,Ja=S.pendingProps,po=S.elementType===Cn?Ja:cp(Cn,Ja);return iN(v,S,Cn,po,P)}case I:return tV(v,S,P);case w:return iV(v,S,P);case B:return nn(v,S,P);case F:return Br(v,S,P);case D:return Ev(v,S,P);case z:{var Gr=S.type,Dl=S.pendingProps,hl=cp(Gr,Dl);if(S.type!==S.elementType){var qi=Gr.propTypes;qi&&Yp(qi,hl,"prop",ol(Gr))}return hl=cp(Gr.type,hl),d2(v,S,Gr,hl,P)}case H:return _D(v,S,S.type,S.pendingProps,P);case J:{var bn=S.type,Wi=S.pendingProps,ca=S.elementType===bn?Wi:cp(bn,Wi);return dG(v,S,bn,ca,P)}case re:return Bt(v,S,P);case ne:break;case le:return eV(v,S,P)}throw new Error("Unknown unit of work tag ("+S.tag+"). This error is likely caused by a bug in React. Please file an issue.")}function Y_(v){v.flags|=Kr}function ID(v){v.flags|=kl,v.flags|=hS}var Ree,mG,fG,Mee;Ree=function(v,S,P,G){for(var Q=S.child;Q!==null;){if(Q.tag===C||Q.tag===E)T1(v,Q.stateNode);else if(Q.tag!==T){if(Q.child!==null){Q.child.return=Q,Q=Q.child;continue}}if(Q===S)return;for(;Q.sibling===null;){if(Q.return===null||Q.return===S)return;Q=Q.return}Q.sibling.return=Q.return,Q=Q.sibling}},mG=function(v,S){},fG=function(v,S,P,G,Q){var me=v.memoizedProps;if(me!==G){var De=S.stateNode,We=q7(),rt=ER(De,P,me,G,Q,We);S.updateQueue=rt,rt&&Y_(S)}},Mee=function(v,S,P,G){P!==G&&Y_(S)};function m2(v,S){if(!mf())switch(v.tailMode){case"hidden":{for(var P=v.tail,G=null;P!==null;)P.alternate!==null&&(G=P),P=P.sibling;G===null?v.tail=null:G.sibling=null;break}case"collapsed":{for(var Q=v.tail,me=null;Q!==null;)Q.alternate!==null&&(me=Q),Q=Q.sibling;me===null?!S&&v.tail!==null?v.tail.sibling=null:v.tail=null:me.sibling=null;break}}}function bf(v){var S=v.alternate!==null&&v.alternate.child===v.child,P=En,G=Ia;if(S){if((v.mode&nr)!==Jr){for(var rt=v.selfBaseDuration,_t=v.child;_t!==null;)P=Jo(P,Jo(_t.lanes,_t.childLanes)),G|=_t.subtreeFlags&vc,G|=_t.flags&vc,rt+=_t.treeBaseDuration,_t=_t.sibling;v.treeBaseDuration=rt}else for(var Ut=v.child;Ut!==null;)P=Jo(P,Jo(Ut.lanes,Ut.childLanes)),G|=Ut.subtreeFlags&vc,G|=Ut.flags&vc,Ut.return=v,Ut=Ut.sibling;v.subtreeFlags|=G}else{if((v.mode&nr)!==Jr){for(var Q=v.actualDuration,me=v.selfBaseDuration,De=v.child;De!==null;)P=Jo(P,Jo(De.lanes,De.childLanes)),G|=De.subtreeFlags,G|=De.flags,Q+=De.actualDuration,me+=De.treeBaseDuration,De=De.sibling;v.actualDuration=Q,v.treeBaseDuration=me}else for(var We=v.child;We!==null;)P=Jo(P,Jo(We.lanes,We.childLanes)),G|=We.subtreeFlags,G|=We.flags,We.return=v,We=We.sibling;v.subtreeFlags|=G}return v.childLanes=P,S}function Pee(v,S,P){if(eve()&&(S.mode&ps)!==Jr&&(S.flags&ra)===Ia)return iee(S),pD(),S.flags|=np|$l|Dh,!1;var G=jF(S);if(P!==null&&P.dehydrated!==null)if(v===null){if(!G)throw new Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");if(Xfe(S),bf(S),(S.mode&nr)!==Jr){var Q=P!==null;if(Q){var me=S.child;me!==null&&(S.treeBaseDuration-=me.treeBaseDuration)}}return!1}else{if(pD(),(S.flags&ra)===Ia&&(S.memoizedState=null),S.flags|=Kr,bf(S),(S.mode&nr)!==Jr){var De=P!==null;if(De){var We=S.child;We!==null&&(S.treeBaseDuration-=We.treeBaseDuration)}}return!1}else return nee(),!0}function Dee(v,S,P){var G=S.pendingProps;switch(w7(S),S.tag){case f:case j:case H:case p:case x:case I:case w:case B:case D:case z:return bf(S),null;case g:{var Q=S.type;return $_(Q)&&HF(S),bf(S),null}case y:{var me=S.stateNode;if(q1(S),C7(S),Y7(),me.pendingContext&&(me.context=me.pendingContext,me.pendingContext=null),v===null||v.child===null){var De=jF(S);if(De)Y_(S);else if(v!==null){var We=v.memoizedState;(!We.isDehydrated||(S.flags&np)!==Ia)&&(S.flags|=iu,nee())}}return mG(v,S),bf(S),null}case C:{Hz(S);var rt=fee(),_t=S.type;if(v!==null&&S.stateNode!=null)fG(v,S,_t,G,rt),v.ref!==S.ref&&ID(S);else{if(!G){if(S.stateNode===null)throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");return bf(S),null}var Ut=q7(),Di=jF(S);if(Di)MR(S,rt,Ut)&&Y_(S);else{var Ri=_R(_t,G,rt,Ut,S);Ree(Ri,S,!1,!1),S.stateNode=Ri,PF(Ri,_t,G,rt)&&Y_(S)}S.ref!==null&&ID(S)}return bf(S),null}case E:{var Xi=G;if(v&&S.stateNode!=null){var tn=v.memoizedProps;Mee(v,S,tn,Xi)}else{if(typeof Xi!="string"&&S.stateNode===null)throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");var Cn=fee(),Ja=q7(),po=jF(S);po?eee(S)&&Y_(S):S.stateNode=rD(Xi,Cn,Ja,S)}return bf(S),null}case L:{K1(S);var Gr=S.memoizedState;if(v===null||v.memoizedState!==null&&v.memoizedState.dehydrated!==null){var Dl=Pee(v,S,Gr);if(!Dl)return S.flags&Dh?S:null}if((S.flags&ra)!==Ia)return S.lanes=P,(S.mode&nr)!==Jr&&nC(S),S;var hl=Gr!==null,qi=v!==null&&v.memoizedState!==null;if(hl!==qi&&hl){var bn=S.child;if(bn.flags|=Dc,(S.mode&ps)!==Jr){var Wi=v===null&&(S.memoizedProps.unstable_avoidThisFallback!==!0||!0);Wi||W7(eC.current,bee)?Ml():LD()}}var ca=S.updateQueue;if(ca!==null&&(S.flags|=Kr),bf(S),(S.mode&nr)!==Jr&&hl){var fr=S.child;fr!==null&&(S.treeBaseDuration-=fr.treeBaseDuration)}return null}case T:return q1(S),mG(v,S),v===null&&fe(S.stateNode.containerInfo),bf(S),null;case F:var or=S.type._context;return z7(or,S),bf(S),null;case J:{var Bo=S.type;return $_(Bo)&&HF(S),bf(S),null}case re:{K1(S);var rs=S.memoizedState;if(rs===null)return bf(S),null;var Bc=(S.flags&ra)!==Ia,cc=rs.rendering;if(cc===null)if(Bc)m2(rs,!1);else{var vp=tte()&&(v===null||(v.flags&ra)===Ia);if(!vp)for(var dc=S.child;dc!==null;){var zh=J1(dc);if(zh!==null){Bc=!0,S.flags|=ra,m2(rs,!1);var Iv=zh.updateQueue;return Iv!==null&&(S.updateQueue=Iv,S.flags|=Kr),S.subtreeFlags=Ia,Dz(S,P),xR(S,W1(eC.current,e2)),S.child}dc=dc.sibling}rs.tail!==null&&Ic()>Wee()&&(S.flags|=ra,Bc=!0,m2(rs,!1),S.lanes=UT)}else{if(!Bc){var If=J1(cc);if(If!==null){S.flags|=ra,Bc=!0;var $b=If.updateQueue;if($b!==null&&(S.updateQueue=$b,S.flags|=Kr),m2(rs,!0),rs.tail===null&&rs.tailMode==="hidden"&&!cc.alternate&&!mf())return bf(S),null}else Ic()*2-rs.renderingStartTime>Wee()&&P!==Ag&&(S.flags|=ra,Bc=!0,m2(rs,!1),S.lanes=UT)}if(rs.isBackwards)cc.sibling=S.child,S.child=cc;else{var Py=rs.last;Py!==null?Py.sibling=cc:S.child=cc,rs.last=cc}}if(rs.tail!==null){var Dy=rs.tail;rs.rendering=Dy,rs.tail=Dy.sibling,rs.renderingStartTime=Ic(),Dy.sibling=null;var wv=eC.current;return Bc?wv=W1(wv,e2):wv=NR(wv),xR(S,wv),Dy}return bf(S),null}case ne:break;case le:case he:{yN(S);var yw=S.memoizedState,EN=yw!==null;if(v!==null){var F2=v.memoizedState,eA=F2!==null;eA!==EN&&(S.flags|=Dc)}return!EN||(S.mode&ps)===Jr?bf(S):pm(Z_,Ag)&&(bf(S),S.subtreeFlags&(Nd|Kr)&&(S.flags|=Dc)),null}case Me:return null;case Le:return null}throw new Error("Unknown unit of work tag ("+S.tag+"). This error is likely caused by a bug in React. Please file an issue.")}function sC(v,S,P){switch(w7(S),S.tag){case g:{var G=S.type;$_(G)&&HF(S);var Q=S.flags;return Q&Dh?(S.flags=Q&-65537|ra,(S.mode&nr)!==Jr&&nC(S),S):null}case y:{S.stateNode,q1(S),C7(S),Y7();var me=S.flags;return(me&Dh)!==Ia&&(me&ra)===Ia?(S.flags=me&-65537|ra,S):null}case C:return Hz(S),null;case L:{K1(S);var De=S.memoizedState;if(De!==null&&De.dehydrated!==null){if(S.alternate===null)throw new Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");pD()}var We=S.flags;return We&Dh?(S.flags=We&-65537|ra,(S.mode&nr)!==Jr&&nC(S),S):null}case re:return K1(S),null;case T:return q1(S),null;case F:var rt=S.type._context;return z7(rt,S),null;case le:case he:return yN(S),null;case Me:return null;default:return null}}function vG(v,S,P){switch(w7(S),S.tag){case g:{var G=S.type.childContextTypes;G!=null&&HF(S);break}case y:{S.stateNode,q1(S),C7(S),Y7();break}case C:{Hz(S);break}case T:q1(S);break;case L:K1(S);break;case re:K1(S);break;case F:var Q=S.type._context;z7(Q,S);break;case le:case he:yN(S);break}}var Lee=null;Lee=new Set;var f2=!1,Tf=!1,tc=typeof WeakSet=="function"?WeakSet:Set,wr=null,wD=null,aw=null;function Oee(v){ph(null,function(){throw v}),sI()}var Nee=function(v,S){if(S.props=v.memoizedProps,S.state=v.memoizedState,v.mode&nr)try{_m(),S.componentWillUnmount()}finally{Zp(v)}else S.componentWillUnmount()};function xee(v,S){try{zR(Mg,v)}catch(P){Fi(v,S,P)}}function yG(v,S,P){try{Nee(v,P)}catch(G){Fi(v,S,G)}}function hve(v,S,P){try{P.componentDidMount()}catch(G){Fi(v,S,G)}}function Bee(v,S){try{SG(v)}catch(P){Fi(v,S,P)}}function rw(v,S){var P=v.ref;if(P!==null)if(typeof P=="function"){var G;try{if(Be&&qe&&v.mode&nr)try{_m(),G=P(null)}finally{Zp(v)}else G=P(null)}catch(Q){Fi(v,S,Q)}typeof G=="function"&&d("Unexpected return value from a callback ref in %s. A callback ref should not return a function.",Do(v))}else P.current=null}function v2(v,S,P){try{P()}catch(G){Fi(v,S,G)}}var Fee=!1;function pve(v,S){jI(v.containerInfo),wr=S,gve();var P=Fee;return Fee=!1,P}function gve(){for(;wr!==null;){var v=wr,S=v.child;(v.subtreeFlags&sv)!==Ia&&S!==null?(S.return=v,wr=S):mve()}}function mve(){for(;wr!==null;){var v=wr;oc(v);try{fve(v)}catch(P){Fi(v,v.return,P)}yo();var S=v.sibling;if(S!==null){S.return=v.return,wr=S;return}wr=v.return}}function fve(v){var S=v.alternate,P=v.flags;if((P&iu)!==Ia){switch(oc(v),v.tag){case p:case x:case H:break;case g:{if(S!==null){var G=S.memoizedProps,Q=S.memoizedState,me=v.stateNode;v.type===v.elementType&&!Og&&(me.props!==v.memoizedProps&&d("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",Do(v)||"instance"),me.state!==v.memoizedState&&d("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",Do(v)||"instance"));var De=me.getSnapshotBeforeUpdate(v.elementType===v.type?G:cp(v.type,G),Q);{var We=Lee;De===void 0&&!We.has(v.type)&&(We.add(v.type),d("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.",Do(v)))}me.__reactInternalSnapshotBeforeUpdate=De}break}case y:{{var rt=v.stateNode;bv(rt.containerInfo)}break}case C:case E:case T:case J:break;default:throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.")}yo()}}function Bb(v,S,P){var G=S.updateQueue,Q=G!==null?G.lastEffect:null;if(Q!==null){var me=Q.next,De=me;do{if((De.tag&v)===v){var We=De.destroy;De.destroy=void 0,We!==void 0&&((v&ff)!==DS?fS(S):(v&Mg)!==DS&&LT(S),(v&z0)!==DS&&mw(!0),v2(S,P,We),(v&z0)!==DS&&mw(!1),(v&ff)!==DS?hv():(v&Mg)!==DS&&dI())}De=De.next}while(De!==me)}}function zR(v,S){var P=S.updateQueue,G=P!==null?P.lastEffect:null;if(G!==null){var Q=G.next,me=Q;do{if((me.tag&v)===v){(v&ff)!==DS?BP(S):(v&Mg)!==DS&&v_(S);var De=me.create;(v&z0)!==DS&&mw(!0),me.destroy=De(),(v&z0)!==DS&&mw(!1),(v&ff)!==DS?lI():(v&Mg)!==DS&&cI();{var We=me.destroy;if(We!==void 0&&typeof We!="function"){var rt=void 0;(me.tag&Mg)!==Ia?rt="useLayoutEffect":(me.tag&z0)!==Ia?rt="useInsertionEffect":rt="useEffect";var _t=void 0;We===null?_t=" You returned null. If your effect does not require clean up, return undefined (or nothing).":typeof We.then=="function"?_t=`

It looks like you wrote `+rt+`(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:

`+rt+`(() => {
  async function fetchData() {
    // You can await here
    const response = await MyAPI.getData(someId);
    // ...
  }
  fetchData();
}, [someId]); // Or [] if effect doesn't need props or state

Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching`:_t=" You returned: "+We,d("%s must not return anything besides a function, which is used for clean-up.%s",rt,_t)}}}me=me.next}while(me!==Q)}}function vve(v,S){if((S.flags&Kr)!==Ia)switch(S.tag){case B:{var P=S.stateNode.passiveEffectDuration,G=S.memoizedProps,Q=G.id,me=G.onPostCommit,De=sd(),We=S.alternate===null?"mount":"update";Pr()&&(We="nested-update"),typeof me=="function"&&me(Q,We,P,De);var rt=S.return;e:for(;rt!==null;){switch(rt.tag){case y:var _t=rt.stateNode;_t.passiveEffectDuration+=P;break e;case B:var Ut=rt.stateNode;Ut.passiveEffectDuration+=P;break e}rt=rt.return}break}}}function jr(v,S,P,G){if((P.flags&_b)!==Ia)switch(P.tag){case p:case x:case H:{if(!Tf)if(P.mode&nr)try{_m(),zR(Mg|Nh,P)}finally{Zp(P)}else zR(Mg|Nh,P);break}case g:{var Q=P.stateNode;if(P.flags&Kr&&!Tf)if(S===null)if(P.type===P.elementType&&!Og&&(Q.props!==P.memoizedProps&&d("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",Do(P)||"instance"),Q.state!==P.memoizedState&&d("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",Do(P)||"instance")),P.mode&nr)try{_m(),Q.componentDidMount()}finally{Zp(P)}else Q.componentDidMount();else{var me=P.elementType===P.type?S.memoizedProps:cp(P.type,S.memoizedProps),De=S.memoizedState;if(P.type===P.elementType&&!Og&&(Q.props!==P.memoizedProps&&d("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",Do(P)||"instance"),Q.state!==P.memoizedState&&d("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",Do(P)||"instance")),P.mode&nr)try{_m(),Q.componentDidUpdate(me,De,Q.__reactInternalSnapshotBeforeUpdate)}finally{Zp(P)}else Q.componentDidUpdate(me,De,Q.__reactInternalSnapshotBeforeUpdate)}var We=P.updateQueue;We!==null&&(P.type===P.elementType&&!Og&&(Q.props!==P.memoizedProps&&d("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",Do(P)||"instance"),Q.state!==P.memoizedState&&d("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",Do(P)||"instance")),mee(P,We,Q));break}case y:{var rt=P.updateQueue;if(rt!==null){var _t=null;if(P.child!==null)switch(P.child.tag){case C:_t=P.child.stateNode;break;case g:_t=P.child.stateNode;break}mee(P,rt,_t)}break}case C:{var Ut=P.stateNode;if(S===null&&P.flags&Kr){var Di=P.type,Ri=P.memoizedProps;DF(Ut,Di,Ri)}break}case E:break;case T:break;case B:{{var Xi=P.memoizedProps,tn=Xi.onCommit,Cn=Xi.onRender,Ja=P.stateNode.effectDuration,po=sd(),Gr=S===null?"mount":"update";Pr()&&(Gr="nested-update"),typeof Cn=="function"&&Cn(P.memoizedProps.id,Gr,P.actualDuration,P.treeBaseDuration,P.actualStartTime,po);{typeof tn=="function"&&tn(P.memoizedProps.id,Gr,Ja,po),Mve(P);var Dl=P.return;e:for(;Dl!==null;){switch(Dl.tag){case y:var hl=Dl.stateNode;hl.effectDuration+=Ja;break e;case B:var qi=Dl.stateNode;qi.effectDuration+=Ja;break e}Dl=Dl.return}}}break}case L:{fs(v,P);break}case re:case J:case ne:case le:case he:case Le:break;default:throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.")}Tf||P.flags&kl&&SG(P)}function Uee(v){switch(v.tag){case p:case x:case H:{if(v.mode&nr)try{_m(),xee(v,v.return)}finally{Zp(v)}else xee(v,v.return);break}case g:{var S=v.stateNode;typeof S.componentDidMount=="function"&&hve(v,v.return,S),Bee(v,v.return);break}case C:{Bee(v,v.return);break}}}function zee(v,S){for(var P=null,G=v;;){if(G.tag===C){if(P===null){P=G;try{var Q=G.stateNode;S?E1(Q):GI(G.stateNode,G.memoizedProps)}catch(De){Fi(v,v.return,De)}}}else if(G.tag===E){if(P===null)try{var me=G.stateNode;S?ZT(me):fz(me,G.memoizedProps)}catch(De){Fi(v,v.return,De)}}else if(!((G.tag===le||G.tag===he)&&G.memoizedState!==null&&G!==v)){if(G.child!==null){G.child.return=G,G=G.child;continue}}if(G===v)return;for(;G.sibling===null;){if(G.return===null||G.return===v)return;P===G&&(P=null),G=G.return}P===G&&(P=null),G.sibling.return=G.return,G=G.sibling}}function SG(v){var S=v.ref;if(S!==null){var P=v.stateNode,G;switch(v.tag){case C:G=P;break;default:G=P}if(typeof S=="function"){var Q;if(v.mode&nr)try{_m(),Q=S(G)}finally{Zp(v)}else Q=S(G);typeof Q=="function"&&d("Unexpected return value from a callback ref in %s. A callback ref should not return a function.",Do(v))}else S.hasOwnProperty("current")||d("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().",Do(v)),S.current=G}}function ke(v){var S=v.alternate;S!==null&&(S.return=null),v.return=null}function Ng(v){var S=v.alternate;S!==null&&(v.alternate=null,Ng(S));{if(v.child=null,v.deletions=null,v.sibling=null,v.tag===C){var P=v.stateNode;P!==null&&Pn(P)}v.stateNode=null,v._debugOwner=null,v.return=null,v.dependencies=null,v.memoizedProps=null,v.memoizedState=null,v.pendingProps=null,v.stateNode=null,v.updateQueue=null}}function bG(v){for(var S=v.return;S!==null;){if(ow(S))return S;S=S.return}throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.")}function ow(v){return v.tag===C||v.tag===y||v.tag===T}function xg(v){var S=v;e:for(;;){for(;S.sibling===null;){if(S.return===null||ow(S.return))return null;S=S.return}for(S.sibling.return=S.return,S=S.sibling;S.tag!==C&&S.tag!==E&&S.tag!==Z;){if(S.flags&Nd||S.child===null||S.tag===T)continue e;S.child.return=S,S=S.child}if(!(S.flags&Nd))return S.stateNode}}function TG(v){var S=bG(v);switch(S.tag){case C:{var P=S.stateNode;S.flags&Qm&&(oD(P),S.flags&=-33);var G=xg(v);VR(v,G,P);break}case y:case T:{var Q=S.stateNode.containerInfo,me=xg(v);uN(v,me,Q);break}default:throw new Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.")}}function uN(v,S,P){var G=v.tag,Q=G===C||G===E;if(Q){var me=v.stateNode;S?LF(P,me,S):pz(P,me)}else if(G!==T){var De=v.child;if(De!==null){uN(De,S,P);for(var We=De.sibling;We!==null;)uN(We,S,P),We=We.sibling}}}function VR(v,S,P){var G=v.tag,Q=G===C||G===E;if(Q){var me=v.stateNode;S?uf(P,me,S):m7(P,me)}else if(G!==T){var De=v.child;if(De!==null){VR(De,S,P);for(var We=De.sibling;We!==null;)VR(We,S,P),We=We.sibling}}}var Cf=null,FS=!1;function yve(v,S,P){{var G=S;e:for(;G!==null;){switch(G.tag){case C:{Cf=G.stateNode,FS=!1;break e}case y:{Cf=G.stateNode.containerInfo,FS=!0;break e}case T:{Cf=G.stateNode.containerInfo,FS=!0;break e}}G=G.return}if(Cf===null)throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");kD(v,S,P),Cf=null,FS=!1}ke(P)}function Am(v,S,P){for(var G=P.child;G!==null;)kD(v,S,G),G=G.sibling}function kD(v,S,P){switch(DT(P),P.tag){case C:Tf||rw(P,S);case E:{{var G=Cf,Q=FS;Cf=null,Am(v,S,P),Cf=G,FS=Q,Cf!==null&&(FS?mz(Cf,P.stateNode):gz(Cf,P.stateNode))}return}case Z:{Cf!==null&&(FS?OF(Cf,P.stateNode):sD(Cf,P.stateNode));return}case T:{{var me=Cf,De=FS;Cf=P.stateNode.containerInfo,FS=!0,Am(v,S,P),Cf=me,FS=De}return}case p:case x:case z:case H:{if(!Tf){var We=P.updateQueue;if(We!==null){var rt=We.lastEffect;if(rt!==null){var _t=rt.next,Ut=_t;do{var Di=Ut,Ri=Di.destroy,Xi=Di.tag;Ri!==void 0&&((Xi&z0)!==DS?v2(P,S,Ri):(Xi&Mg)!==DS&&(LT(P),P.mode&nr?(_m(),v2(P,S,Ri),Zp(P)):v2(P,S,Ri),dI())),Ut=Ut.next}while(Ut!==_t)}}}Am(v,S,P);return}case g:{if(!Tf){rw(P,S);var tn=P.stateNode;typeof tn.componentWillUnmount=="function"&&yG(P,S,tn)}Am(v,S,P);return}case ne:{Am(v,S,P);return}case le:{if(P.mode&ps){var Cn=Tf;Tf=Cn||P.memoizedState!==null,Am(v,S,P),Tf=Cn}else Am(v,S,P);break}default:{Am(v,S,P);return}}}function Xp(v){v.memoizedState}function fs(v,S){var P=S.memoizedState;if(P===null){var G=S.alternate;if(G!==null){var Q=G.memoizedState;if(Q!==null){var me=Q.dehydrated;me!==null&&Sz(me)}}}}function _l(v){var S=v.updateQueue;if(S!==null){v.updateQueue=null;var P=v.stateNode;P===null&&(P=v.stateNode=new tc),S.forEach(function(G){var Q=zb.bind(null,v,G);if(!P.has(G)){if(P.add(G),Bp)if(wD!==null&&aw!==null)X_(aw,wD);else throw Error("Expected finished root and lanes to be set. This is a bug in React.");G.then(Q,Q)}})}}function sw(v,S,P){wD=P,aw=v,oc(S),Vee(S,v),oc(S),wD=null,aw=null}function xc(v,S,P){var G=S.deletions;if(G!==null)for(var Q=0;Q<G.length;Q++){var me=G[Q];try{yve(v,S,me)}catch(rt){Fi(me,S,rt)}}var De=ub();if(S.subtreeFlags&lv)for(var We=S.child;We!==null;)oc(We),Vee(We,v),We=We.sibling;oc(De)}function Vee(v,S,P){var G=v.alternate,Q=v.flags;switch(v.tag){case p:case x:case z:case H:{if(xc(S,v),W0(v),Q&Kr){try{Bb(z0|Nh,v,v.return),zR(z0|Nh,v)}catch(Bo){Fi(v,v.return,Bo)}if(v.mode&nr){try{_m(),Bb(Mg|Nh,v,v.return)}catch(Bo){Fi(v,v.return,Bo)}Zp(v)}else try{Bb(Mg|Nh,v,v.return)}catch(Bo){Fi(v,v.return,Bo)}}return}case g:{xc(S,v),W0(v),Q&kl&&G!==null&&rw(G,G.return);return}case C:{xc(S,v),W0(v),Q&kl&&G!==null&&rw(G,G.return);{if(v.flags&Qm){var me=v.stateNode;try{oD(me)}catch(Bo){Fi(v,v.return,Bo)}}if(Q&Kr){var De=v.stateNode;if(De!=null){var We=v.memoizedProps,rt=G!==null?G.memoizedProps:We,_t=v.type,Ut=v.updateQueue;if(v.updateQueue=null,Ut!==null)try{hz(De,Ut,_t,rt,We,v)}catch(Bo){Fi(v,v.return,Bo)}}}}return}case E:{if(xc(S,v),W0(v),Q&Kr){if(v.stateNode===null)throw new Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");var Di=v.stateNode,Ri=v.memoizedProps,Xi=G!==null?G.memoizedProps:Ri;try{g7(Di,Xi,Ri)}catch(Bo){Fi(v,v.return,Bo)}}return}case y:{if(xc(S,v),W0(v),Q&Kr&&G!==null){var tn=G.memoizedState;if(tn.isDehydrated)try{yz(S.containerInfo)}catch(Bo){Fi(v,v.return,Bo)}}return}case T:{xc(S,v),W0(v);return}case L:{xc(S,v),W0(v);var Cn=v.child;if(Cn.flags&Dc){var Ja=Cn.stateNode,po=Cn.memoizedState,Gr=po!==null;if(Ja.isHidden=Gr,Gr){var Dl=Cn.alternate!==null&&Cn.alternate.memoizedState!==null;Dl||bV()}}if(Q&Kr){try{Xp(v)}catch(Bo){Fi(v,v.return,Bo)}_l(v)}return}case le:{var hl=G!==null&&G.memoizedState!==null;if(v.mode&ps){var qi=Tf;Tf=qi||hl,xc(S,v),Tf=qi}else xc(S,v);if(W0(v),Q&Dc){var bn=v.stateNode,Wi=v.memoizedState,ca=Wi!==null,fr=v;if(bn.isHidden=ca,ca&&!hl&&(fr.mode&ps)!==Jr){wr=fr;for(var or=fr.child;or!==null;)wr=or,_G(or),or=or.sibling}zee(fr,ca)}return}case re:{xc(S,v),W0(v),Q&Kr&&_l(v);return}case ne:return;default:{xc(S,v),W0(v);return}}}function W0(v){var S=v.flags;if(S&Nd){try{TG(v)}catch(P){Fi(v,v.return,P)}v.flags&=-3}S&ap&&(v.flags&=-4097)}function $ee(v,S,P){wD=P,aw=S,wr=v,CG(v,S,P),wD=null,aw=null}function CG(v,S,P){for(var G=(v.mode&ps)!==Jr;wr!==null;){var Q=wr,me=Q.child;if(Q.tag===le&&G){var De=Q.memoizedState!==null,We=De||f2;if(We){pV(v,S,P);continue}else{var rt=Q.alternate,_t=rt!==null&&rt.memoizedState!==null,Ut=_t||Tf,Di=f2,Ri=Tf;f2=We,Tf=Ut,Tf&&!Ri&&(wr=Q,y2(Q));for(var Xi=me;Xi!==null;)wr=Xi,CG(Xi,S,P),Xi=Xi.sibling;wr=Q,f2=Di,Tf=Ri,pV(v,S,P);continue}}(Q.subtreeFlags&_b)!==Ia&&me!==null?(me.return=Q,wr=me):pV(v,S,P)}}function pV(v,S,P){for(;wr!==null;){var G=wr;if((G.flags&_b)!==Ia){var Q=G.alternate;oc(G);try{jr(S,Q,G,P)}catch(De){Fi(G,G.return,De)}yo()}if(G===v){wr=null;return}var me=G.sibling;if(me!==null){me.return=G.return,wr=me;return}wr=G.return}}function _G(v){for(;wr!==null;){var S=wr,P=S.child;switch(S.tag){case p:case x:case z:case H:{if(S.mode&nr)try{_m(),Bb(Mg,S,S.return)}finally{Zp(S)}else Bb(Mg,S,S.return);break}case g:{rw(S,S.return);var G=S.stateNode;typeof G.componentWillUnmount=="function"&&yG(S,S.return,G);break}case C:{rw(S,S.return);break}case le:{var Q=S.memoizedState!==null;if(Q){lw(v);continue}break}}P!==null?(P.return=S,wr=P):lw(v)}}function lw(v){for(;wr!==null;){var S=wr;if(S===v){wr=null;return}var P=S.sibling;if(P!==null){P.return=S.return,wr=P;return}wr=S.return}}function y2(v){for(;wr!==null;){var S=wr,P=S.child;if(S.tag===le){var G=S.memoizedState!==null;if(G){S2(v);continue}}P!==null?(P.return=S,wr=P):S2(v)}}function S2(v){for(;wr!==null;){var S=wr;oc(S);try{Uee(S)}catch(G){Fi(S,S.return,G)}if(yo(),S===v){wr=null;return}var P=S.sibling;if(P!==null){P.return=S.return,wr=P;return}wr=S.return}}function Sve(v,S,P,G){wr=S,bve(S,v,P,G)}function bve(v,S,P,G){for(;wr!==null;){var Q=wr,me=Q.child;(Q.subtreeFlags&rp)!==Ia&&me!==null?(me.return=Q,wr=me):oa(v,S,P,G)}}function oa(v,S,P,G){for(;wr!==null;){var Q=wr;if((Q.flags&Ph)!==Ia){oc(Q);try{Q_(S,Q,P,G)}catch(De){Fi(Q,Q.return,De)}yo()}if(Q===v){wr=null;return}var me=Q.sibling;if(me!==null){me.return=Q.return,wr=me;return}wr=Q.return}}function Q_(v,S,P,G){switch(S.tag){case p:case x:case H:{if(S.mode&nr){Em();try{zR(ff|Nh,S)}finally{iC(S)}}else zR(ff|Nh,S);break}}}function K0(v){wr=v,Mo()}function Mo(){for(;wr!==null;){var v=wr,S=v.child;if((wr.flags&Mh)!==Ia){var P=v.deletions;if(P!==null){for(var G=0;G<P.length;G++){var Q=P[G];wr=Q,Hee(Q,v)}{var me=v.alternate;if(me!==null){var De=me.child;if(De!==null){me.child=null;do{var We=De.sibling;De.sibling=null,De=We}while(De!==null)}}}wr=v}}(v.subtreeFlags&rp)!==Ia&&S!==null?(S.return=v,wr=S):hN()}}function hN(){for(;wr!==null;){var v=wr;(v.flags&Ph)!==Ia&&(oc(v),_f(v),yo());var S=v.sibling;if(S!==null){S.return=v.return,wr=S;return}wr=v.return}}function _f(v){switch(v.tag){case p:case x:case H:{v.mode&nr?(Em(),Bb(ff|Nh,v,v.return),iC(v)):Bb(ff|Nh,v,v.return);break}}}function Hee(v,S){for(;wr!==null;){var P=wr;oc(P),Cve(P,S),yo();var G=P.child;G!==null?(G.return=P,wr=G):Tve(v)}}function Tve(v){for(;wr!==null;){var S=wr,P=S.sibling,G=S.return;if(Ng(S),S===v){wr=null;return}if(P!==null){P.return=G,wr=P;return}wr=G}}function Cve(v,S){switch(v.tag){case p:case x:case H:{v.mode&nr?(Em(),Bb(ff,v,S),iC(v)):Bb(ff,v,S);break}}}function pp(v){switch(v.tag){case p:case x:case H:{try{zR(Mg|Nh,v)}catch(P){Fi(v,v.return,P)}break}case g:{var S=v.stateNode;try{S.componentDidMount()}catch(P){Fi(v,v.return,P)}break}}}function _ve(v){switch(v.tag){case p:case x:case H:{try{zR(ff|Nh,v)}catch(S){Fi(v,v.return,S)}break}}}function Fb(v){switch(v.tag){case p:case x:case H:{try{Bb(Mg|Nh,v,v.return)}catch(P){Fi(v,v.return,P)}break}case g:{var S=v.stateNode;typeof S.componentWillUnmount=="function"&&yG(v,v.return,S);break}}}function gV(v){switch(v.tag){case p:case x:case H:try{Bb(ff|Nh,v,v.return)}catch(S){Fi(v,v.return,S)}}}if(typeof Symbol=="function"&&Symbol.for){var _a=Symbol.for;_a("selector.component"),_a("selector.has_pseudo_class"),_a("selector.role"),_a("selector.test_id"),_a("selector.text")}var Fh=[];function Eve(){Fh.forEach(function(v){return v()})}var pN=i.ReactCurrentActQueue;function jee(v){{var S=typeof IS_REACT_ACT_ENVIRONMENT<"u"?IS_REACT_ACT_ENVIRONMENT:void 0,P=typeof jest<"u";return P&&S!==!1}}function EG(){{var v=typeof IS_REACT_ACT_ENVIRONMENT<"u"?IS_REACT_ACT_ENVIRONMENT:void 0;return!v&&pN.current!==null&&d("The current testing environment is not configured to support act(...)"),v}}var AG=Math.ceil,IG=i.ReactCurrentDispatcher,gN=i.ReactCurrentOwner,cd=i.ReactCurrentBatchConfig,lC=i.ReactCurrentActQueue,Uh=0,mV=1,gp=2,yl=4,J0=0,RD=1,$R=2,b2=3,MD=4,Gee=5,wG=6,Rl=Uh,Av=null,Ru=null,eg=En,Z_=En,T2=IR(En),Bg=J0,C2=null,_2=En,mN=En,E2=En,fN=null,Ry=null,fV=0,kG=500,qee=1/0,Ave=500,cw=null;function A2(){qee=Ic()+Ave}function Wee(){return qee}var vV=!1,RG=null,vN=null,Ub=!1,HR=null,cC=En,yV=[],MG=null,Kee=50,PD=0,PG=null,DG=!1,I2=!1,Ive=50,dw=0,w2=null,k2=bc,Ef=En,$d=!1;function DD(){return Av}function Af(){return(Rl&(gp|yl))!==Uh?Ic():(k2!==bc||(k2=Ic()),k2)}function Y0(v){var S=v.mode;if((S&ps)===Jr)return ao;if((Rl&gp)!==Uh&&eg!==En)return A_(eg);var P=tve()!==O7;if(P){if(cd.transition!==null){var G=cd.transition;G._updatedFibers||(G._updatedFibers=new Set),G._updatedFibers.add(v)}return Ef===Vs&&(Ef=af()),Ef}var Q=gm();if(Q!==Vs)return Q;var me=dz();return me}function LG(v){var S=v.mode;return(S&ps)===Jr?ao:Gk()}function mp(v,S,P,G){Lve(),$d&&d("useInsertionEffect must not schedule updates."),DG&&(I2=!0),bS(v,P,G),(Rl&gp)!==En&&v===Av?xn(S):(Bp&&Au(v,S,P),D2(S),v===Av&&((Rl&gp)===Uh&&(mN=Jo(mN,P)),Bg===MD&&uw(v,eg)),Fg(v,G),P===ao&&Rl===Uh&&(S.mode&ps)===Jr&&!lC.isBatchingLegacy&&(A2(),jX()))}function OG(v,S,P){var G=v.current;G.lanes=S,bS(v,S,P),Fg(v,P)}function va(v){return(Rl&gp)!==Uh}function Fg(v,S){var P=v.callbackNode;mI(v,S);var G=E_(v,v===Av?eg:En);if(G===En){P!==null&&VG(P),v.callbackNode=null,v.callbackPriority=Vs;return}var Q=rf(G),me=v.callbackPriority;if(me===Q&&!(lC.current!==null&&P!==bN)){P==null&&me!==ao&&d("Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.");return}P!=null&&VG(P);var De;if(Q===ao)v.tag===du?(lC.isBatchingLegacy!==null&&(lC.didScheduleLegacyUpdate=!0),I7(Yee.bind(null,v))):A7(Yee.bind(null,v)),lC.current!==null?lC.current.push(kR):uz(function(){(Rl&(gp|yl))===Uh&&kR()}),De=null;else{var We;switch(w_(G)){case mh:We=ru;break;case TS:We=cv;break;case of:We=Zm;break;case Vp:We=_g;break;default:We=Zm;break}De=eE(We,uu.bind(null,v))}v.callbackPriority=Q,v.callbackNode=De}function uu(v,S){if(Eo(),k2=bc,Ef=En,(Rl&(gp|yl))!==Uh)throw new Error("Should not already be working.");var P=v.callbackNode,G=pw();if(G&&v.callbackNode!==P)return null;var Q=E_(v,v===Av?eg:En);if(Q===En)return null;var me=!S0(v,Q)&&!YO(v,Q)&&!S,De=me?Rve(v,Q):OD(v,Q);if(De!==J0){if(De===$R){var We=f0(v);We!==En&&(Q=We,De=Xa(v,We))}if(De===RD){var rt=C2;throw Mu(v,En),uw(v,Q),Fg(v,Ic()),rt}if(De===wG)uw(v,Q);else{var _t=!S0(v,Q),Ut=v.current.alternate;if(_t&&!NG(Ut)){if(De=OD(v,Q),De===$R){var Di=f0(v);Di!==En&&(Q=Di,De=Xa(v,Di))}if(De===RD){var Ri=C2;throw Mu(v,En),uw(v,Q),Fg(v,Ic()),Ri}}v.finishedWork=Ut,v.finishedLanes=Q,Jee(v,De,Q)}}return Fg(v,Ic()),v.callbackNode===P?uu.bind(null,v):null}function Xa(v,S){var P=fN;if(TI(v)){var G=Mu(v,S);G.flags|=np,q(v.containerInfo)}var Q=OD(v,S);if(Q!==$R){var me=Ry;Ry=P,me!==null&&R2(me)}return Q}function R2(v){Ry===null?Ry=v:Ry.push.apply(Ry,v)}function Jee(v,S,P){switch(S){case J0:case RD:throw new Error("Root did not complete. This is a bug in React.");case $R:{jR(v,Ry,cw);break}case b2:{if(uw(v,P),$T(P)&&!ND()){var G=fV+kG-Ic();if(G>10){var Q=E_(v,En);if(Q!==En)break;var me=v.suspendedLanes;if(!zp(me,P)){Af(),gy(v,me);break}v.timeoutHandle=C1(jR.bind(null,v,Ry,cw),G);break}}jR(v,Ry,cw);break}case MD:{if(uw(v,P),jk(P))break;if(!ND()){var De=mv(v,P),We=De,rt=Ic()-We,_t=Vn(rt)-rt;if(_t>10){v.timeoutHandle=C1(jR.bind(null,v,Ry,cw),_t);break}}jR(v,Ry,cw);break}case Gee:{jR(v,Ry,cw);break}default:throw new Error("Unknown root exit status.")}}function NG(v){for(var S=v;;){if(S.flags&Hc){var P=S.updateQueue;if(P!==null){var G=P.stores;if(G!==null)for(var Q=0;Q<G.length;Q++){var me=G[Q],De=me.getSnapshot,We=me.value;try{if(!Jn(De(),We))return!1}catch{return!1}}}}var rt=S.child;if(S.subtreeFlags&Hc&&rt!==null){rt.return=S,S=rt;continue}if(S===v)return!0;for(;S.sibling===null;){if(S.return===null||S.return===v)return!0;S=S.return}S.sibling.return=S.return,S=S.sibling}return!0}function uw(v,S){S=I_(S,E2),S=I_(S,mN),qk(v,S)}function Yee(v){if(Cl(),(Rl&(gp|yl))!==Uh)throw new Error("Should not already be working.");pw();var S=E_(v,En);if(!pm(S,ao))return Fg(v,Ic()),null;var P=OD(v,S);if(v.tag!==du&&P===$R){var G=f0(v);G!==En&&(S=G,P=Xa(v,G))}if(P===RD){var Q=C2;throw Mu(v,En),uw(v,S),Fg(v,Ic()),Q}if(P===wG)throw new Error("Root did not complete. This is a bug in React.");var me=v.current.alternate;return v.finishedWork=me,v.finishedLanes=S,jR(v,Ry,cw),Fg(v,Ic()),null}function wve(v,S){S!==En&&(fv(v,Jo(S,ao)),Fg(v,Ic()),(Rl&(gp|yl))===Uh&&(A2(),kR()))}function xG(v,S){var P=Rl;Rl|=mV;try{return v(S)}finally{Rl=P,Rl===Uh&&!lC.isBatchingLegacy&&(A2(),jX())}}function kve(v,S,P,G,Q){var me=gm(),De=cd.transition;try{return cd.transition=null,Tc(mh),v(S,P,G,Q)}finally{Tc(me),cd.transition=De,Rl===Uh&&A2()}}function hw(v){HR!==null&&HR.tag===du&&(Rl&(gp|yl))===Uh&&pw();var S=Rl;Rl|=mV;var P=cd.transition,G=gm();try{return cd.transition=null,Tc(mh),v?v():void 0}finally{Tc(G),cd.transition=P,Rl=S,(Rl&(gp|yl))===Uh&&kR()}}function Qee(){return(Rl&(gp|yl))!==Uh}function SV(v,S){Tm(T2,Z_,v),Z_=Jo(Z_,S)}function yN(v){Z_=T2.current,bm(T2,v)}function Mu(v,S){v.finishedWork=null,v.finishedLanes=En;var P=v.timeoutHandle;if(P!==AR&&(v.timeoutHandle=AR,h7(P)),Ru!==null)for(var G=Ru.return;G!==null;){var Q=G.alternate;vG(Q,G),G=G.return}Av=v;var me=fw(v.current,null);return Ru=me,eg=Z_=S,Bg=J0,C2=null,_2=En,mN=En,E2=En,fN=null,Ry=null,rve(),G_.discardPendingWarnings(),me}function Zee(v,S){do{var P=Ru;try{if(Oz(),Eee(),yo(),gN.current=null,P===null||P.return===null){Bg=RD,C2=S,Ru=null;return}if(Be&&P.mode&nr&&NS(P,!0),Te)if(Eg(),S!==null&&typeof S=="object"&&typeof S.then=="function"){var G=S;dy(P,G,eg)}else c0(P,S,eg);lG(v,P.return,P,S,eg),TV(P)}catch(Q){S=Q,Ru===P&&P!==null?(P=P.return,Ru=P):P=Ru;continue}return}while(!0)}function Xee(){var v=IG.current;return IG.current=lr,v===null?lr:v}function BG(v){IG.current=v}function bV(){fV=Ic()}function er(v){_2=Jo(v,_2)}function Ml(){Bg===J0&&(Bg=b2)}function LD(){(Bg===J0||Bg===b2||Bg===$R)&&(Bg=MD),Av!==null&&(v0(_2)||v0(mN))&&uw(Av,eg)}function ete(v){Bg!==MD&&(Bg=$R),fN===null?fN=[v]:fN.push(v)}function tte(){return Bg===J0}function OD(v,S){var P=Rl;Rl|=gp;var G=Xee();if(Av!==v||eg!==S){if(Bp){var Q=v.memoizedUpdaters;Q.size>0&&(X_(v,eg),Q.clear()),FP(v,S)}cw=T0(),Mu(v,S)}S_(S);do try{ite();break}catch(me){Zee(v,me)}while(!0);if(Oz(),Rl=P,BG(G),Ru!==null)throw new Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");return Hk(),Av=null,eg=En,Bg}function ite(){for(;Ru!==null;)FG(Ru)}function Rve(v,S){var P=Rl;Rl|=gp;var G=Xee();if(Av!==v||eg!==S){if(Bp){var Q=v.memoizedUpdaters;Q.size>0&&(X_(v,eg),Q.clear()),FP(v,S)}cw=T0(),A2(),Mu(v,S)}S_(S);do try{Ug();break}catch(me){Zee(v,me)}while(!0);return Oz(),BG(G),Rl=P,Ru!==null?($k(),J0):(Hk(),Av=null,eg=En,Bg)}function Ug(){for(;Ru!==null&&!l0();)FG(Ru)}function FG(v){var S=v.alternate;oc(v);var P;(v.mode&nr)!==Jr?(Cm(v),P=zG(S,v,Z_),NS(v,!0)):P=zG(S,v,Z_),yo(),v.memoizedProps=v.pendingProps,P===null?TV(v):Ru=P,gN.current=null}function TV(v){var S=v;do{var P=S.alternate,G=S.return;if((S.flags&$l)===Ia){oc(S);var Q=void 0;if((S.mode&nr)===Jr?Q=Dee(P,S,Z_):(Cm(S),Q=Dee(P,S,Z_),NS(S,!1)),yo(),Q!==null){Ru=Q;return}}else{var me=sC(P,S);if(me!==null){me.flags&=ay,Ru=me;return}if((S.mode&nr)!==Jr){NS(S,!1);for(var De=S.actualDuration,We=S.child;We!==null;)De+=We.actualDuration,We=We.sibling;S.actualDuration=De}if(G!==null)G.flags|=$l,G.subtreeFlags=Ia,G.deletions=null;else{Bg=wG,Ru=null;return}}var rt=S.sibling;if(rt!==null){Ru=rt;return}S=G,Ru=S}while(S!==null);Bg===J0&&(Bg=Gee)}function jR(v,S,P){var G=gm(),Q=cd.transition;try{cd.transition=null,Tc(mh),Zr(v,S,P,G)}finally{cd.transition=Q,Tc(G)}return null}function Zr(v,S,P,G){do pw();while(HR!==null);if(UG(),(Rl&(gp|yl))!==Uh)throw new Error("Should not already be working.");var Q=v.finishedWork,me=v.finishedLanes;if(zk(me),Q===null)return Vk(),null;if(me===En&&d("root.finishedLanes should not be empty during a commit. This is a bug in React."),v.finishedWork=null,v.finishedLanes=En,Q===v.current)throw new Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");v.callbackNode=null,v.callbackPriority=Vs;var De=Jo(Q.lanes,Q.childLanes);Wk(v,De),v===Av&&(Av=null,Ru=null,eg=En),((Q.subtreeFlags&rp)!==Ia||(Q.flags&rp)!==Ia)&&(Ub||(Ub=!0,MG=P,eE(Zm,function(){return pw(),null})));var We=(Q.subtreeFlags&(sv|lv|_b|rp))!==Ia,rt=(Q.flags&(sv|lv|_b|rp))!==Ia;if(We||rt){var _t=cd.transition;cd.transition=null;var Ut=gm();Tc(mh);var Di=Rl;Rl|=yl,gN.current=null,pve(v,Q),xh(),sw(v,Q,me),df(v.containerInfo),v.current=Q,vS(me),$ee(Q,v,me),y_(),pS(),Rl=Di,Tc(Ut),cd.transition=_t}else v.current=Q,xh();var Ri=Ub;if(Ub?(Ub=!1,HR=v,cC=me):(dw=0,w2=null),De=v.pendingLanes,De===En&&(vN=null),Ri||ate(v.current,!1),uv(Q.stateNode,G),Bp&&v.memoizedUpdaters.clear(),Eve(),Fg(v,Ic()),S!==null)for(var Xi=v.onRecoverableError,tn=0;tn<S.length;tn++){var Cn=S[tn],Ja=Cn.stack,po=Cn.digest;Xi(Cn.value,{componentStack:Ja,digest:po})}if(vV){vV=!1;var Gr=RG;throw RG=null,Gr}return pm(cC,ao)&&v.tag!==du&&pw(),De=v.pendingLanes,pm(De,ao)?(No(),v===PG?PD++:(PD=0,PG=v)):PD=0,kR(),Vk(),null}function pw(){if(HR!==null){var v=w_(cC),S=C0(of,v),P=cd.transition,G=gm();try{return cd.transition=null,Tc(S),Pve()}finally{Tc(G),cd.transition=P}}return!1}function Mve(v){yV.push(v),Ub||(Ub=!0,eE(Zm,function(){return pw(),null}))}function Pve(){if(HR===null)return!1;var v=MG;MG=null;var S=HR,P=cC;if(HR=null,cC=En,(Rl&(gp|yl))!==Uh)throw new Error("Cannot flush passive effects while already rendering.");DG=!0,I2=!1,yS(P);var G=Rl;Rl|=yl,K0(S.current),Sve(S,S.current,P,v);{var Q=yV;yV=[];for(var me=0;me<Q.length;me++){var De=Q[me];vve(S,De)}}uI(),ate(S.current,!0),Rl=G,kR(),I2?S===w2?dw++:(dw=0,w2=S):dw=0,DG=!1,I2=!1,Ab(S);{var We=S.current.stateNode;We.effectDuration=0,We.passiveEffectDuration=0}return!0}function Pu(v){return vN!==null&&vN.has(v)}function gw(v){vN===null?vN=new Set([v]):vN.add(v)}function M2(v){vV||(vV=!0,RG=v)}var nte=M2;function CV(v,S,P){var G=kn(P,S),Q=wy(v,G,ao),me=LR(v,Q,ao),De=Af();me!==null&&(bS(me,ao,De),Fg(me,De))}function Fi(v,S,P){if(Oee(P),mw(!1),v.tag===y){CV(v,v,P);return}var G=null;for(G=S;G!==null;){if(G.tag===y){CV(G,v,P);return}else if(G.tag===g){var Q=G.type,me=G.stateNode;if(typeof Q.getDerivedStateFromError=="function"||typeof me.componentDidCatch=="function"&&!Pu(me)){var De=kn(P,v),We=Qu(G,De,ao),rt=LR(G,We,ao),_t=Af();rt!==null&&(bS(rt,ao,_t),Fg(rt,_t));return}}G=G.return}d(`Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.

Error message:

%s`,P)}function fp(v,S,P){var G=v.pingCache;G!==null&&G.delete(S);var Q=Af();gy(v,P),rte(v),Av===v&&zp(eg,P)&&(Bg===MD||Bg===b2&&$T(eg)&&Ic()-fV<kG?Mu(v,En):E2=Jo(E2,P)),Fg(v,Q)}function ge(v,S){S===Vs&&(S=LG(v));var P=Af(),G=Qp(v,S);G!==null&&(bS(G,S,P),Fg(G,P))}function Dve(v){var S=v.memoizedState,P=Vs;S!==null&&(P=S.retryLane),ge(v,P)}function zb(v,S){var P=Vs,G;switch(v.tag){case L:G=v.stateNode;var Q=v.memoizedState;Q!==null&&(P=Q.retryLane);break;case re:G=v.stateNode;break;default:throw new Error("Pinged unknown suspense boundary type. This is probably a bug in React.")}G!==null&&G.delete(S),ge(v,P)}function Vn(v){return v<120?120:v<480?480:v<1080?1080:v<1920?1920:v<3e3?3e3:v<4320?4320:AG(v/1960)*1960}function Lve(){if(PD>Kee)throw PD=0,PG=null,new Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");dw>Ive&&(dw=0,w2=null,d("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."))}function UG(){G_.flushLegacyContextWarning(),G_.flushPendingUnsafeLifecycleWarnings()}function ate(v,S){oc(v),P2(v,ry,Fb),S&&P2(v,Hu,gV),P2(v,ry,pp),S&&P2(v,Hu,_ve),yo()}function P2(v,S,P){for(var G=v,Q=null;G!==null;){var me=G.subtreeFlags&S;G!==Q&&G.child!==null&&me!==Ia?G=G.child:((G.flags&S)!==Ia&&P(G),G.sibling!==null?G=G.sibling:G=Q=G.return)}}var SN=null;function tr(v){{if((Rl&gp)!==Uh||!(v.mode&ps))return;var S=v.tag;if(S!==f&&S!==y&&S!==g&&S!==p&&S!==x&&S!==z&&S!==H)return;var P=Do(v)||"ReactComponent";if(SN!==null){if(SN.has(P))return;SN.add(P)}else SN=new Set([P]);var G=zu;try{oc(v),d("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.")}finally{G?oc(v):yo()}}}var zG;{var My=null;zG=function(v,S,P){var G=mte(My,S);try{return dN(v,S,P)}catch(me){if(k7()||me!==null&&typeof me=="object"&&typeof me.then=="function")throw me;if(Oz(),Eee(),vG(v,S),mte(S,G),S.mode&nr&&Cm(S),ph(null,dN,null,v,S,P),Tb()){var Q=sI();typeof Q=="object"&&Q!==null&&Q._suppressLogging&&typeof me=="object"&&me!==null&&!me._suppressLogging&&(me._suppressLogging=!0)}throw me}}}var Zs=!1,lc;lc=new Set;function xn(v){if(jm&&!$a())switch(v.tag){case p:case x:case H:{var S=Ru&&Do(Ru)||"Unknown",P=S;if(!lc.has(P)){lc.add(P);var G=Do(v)||"Unknown";d("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render",G,S,S)}break}case g:{Zs||(d("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."),Zs=!0);break}}}function X_(v,S){if(Bp){var P=v.memoizedUpdaters;P.forEach(function(G){Au(v,G,S)})}}var bN={};function eE(v,S){{var P=lC.current;return P!==null?(P.push(S),bN):Cg(v,S)}}function VG(v){if(v!==bN)return ly(v)}function ND(){return lC.current!==null}function D2(v){{if(v.mode&ps){if(!EG())return}else if(!jee()||Rl!==Uh||v.tag!==p&&v.tag!==x&&v.tag!==H)return;if(lC.current===null){var S=zu;try{oc(v),d(`An update to %s inside a test was not wrapped in act(...).

When testing, code that causes React state updates should be wrapped into act(...):

act(() => {
  /* fire events that update state */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`,Do(v))}finally{S?oc(v):yo()}}}}function rte(v){v.tag!==du&&EG()&&lC.current===null&&d(`A suspended resource finished loading inside a test, but the event was not wrapped in act(...).

When testing, code that resolves suspended data should be wrapped into act(...):

act(() => {
  /* finish loading suspended data */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`)}function mw(v){$d=v}var dC=null,Q0=null,Lr=function(v){dC=v};function Z0(v){{if(dC===null)return v;var S=dC(v);return S===void 0?v:S.current}}function _V(v){return Z0(v)}function Po(v){{if(dC===null)return v;var S=dC(v);if(S===void 0){if(v!=null&&typeof v.render=="function"){var P=Z0(v.render);if(v.render!==P){var G={$$typeof:Ai,render:P};return v.displayName!==void 0&&(G.displayName=v.displayName),G}}return v}return S.current}}function ote(v,S){{if(dC===null)return!1;var P=v.elementType,G=S.type,Q=!1,me=typeof G=="object"&&G!==null?G.$$typeof:null;switch(v.tag){case g:{typeof G=="function"&&(Q=!0);break}case p:{(typeof G=="function"||me===qa)&&(Q=!0);break}case x:{(me===Ai||me===qa)&&(Q=!0);break}case z:case H:{(me===Pa||me===qa)&&(Q=!0);break}default:return!1}if(Q){var De=dC(P);if(De!==void 0&&De===dC(G))return!0}return!1}}function ste(v){{if(dC===null||typeof WeakSet!="function")return;Q0===null&&(Q0=new WeakSet),Q0.add(v)}}var lte=function(v,S){{if(dC===null)return;var P=S.staleFamilies,G=S.updatedFamilies;pw(),hw(function(){$G(v.current,G,P)})}},cte=function(v,S){{if(v.context!==Tv)return;pw(),hw(function(){O2(S,v,null,null)})}};function $G(v,S,P){{var G=v.alternate,Q=v.child,me=v.sibling,De=v.tag,We=v.type,rt=null;switch(De){case p:case H:case g:rt=We;break;case x:rt=We.render;break}if(dC===null)throw new Error("Expected resolveFamily to be set during hot reload.");var _t=!1,Ut=!1;if(rt!==null){var Di=dC(rt);Di!==void 0&&(P.has(Di)?Ut=!0:S.has(Di)&&(De===g?Ut=!0:_t=!0))}if(Q0!==null&&(Q0.has(v)||G!==null&&Q0.has(G))&&(Ut=!0),Ut&&(v._debugNeedsRemount=!0),Ut||_t){var Ri=Qp(v,ao);Ri!==null&&mp(Ri,v,ao,bc)}Q!==null&&!Ut&&$G(Q,S,P),me!==null&&$G(me,S,P)}}var EV=function(v,S){{var P=new Set,G=new Set(S.map(function(Q){return Q.current}));return Pl(v.current,G,P),P}};function Pl(v,S,P){{var G=v.child,Q=v.sibling,me=v.tag,De=v.type,We=null;switch(me){case p:case H:case g:We=De;break;case x:We=De.render;break}var rt=!1;We!==null&&S.has(We)&&(rt=!0),rt?HG(v,P):G!==null&&Pl(G,S,P),Q!==null&&Pl(Q,S,P)}}function HG(v,S){{var P=dte(v,S);if(P)return;for(var G=v;;){switch(G.tag){case C:S.add(G.stateNode);return;case T:S.add(G.stateNode.containerInfo);return;case y:S.add(G.stateNode.containerInfo);return}if(G.return===null)throw new Error("Expected to reach root first.");G=G.return}}}function dte(v,S){for(var P=v,G=!1;;){if(P.tag===C)G=!0,S.add(P.stateNode);else if(P.child!==null){P.child.return=P,P=P.child;continue}if(P===v)return G;for(;P.sibling===null;){if(P.return===null||P.return===v)return G;P=P.return}P.sibling.return=P.return,P=P.sibling}return!1}var jG;{jG=!1;try{var ute=Object.preventExtensions({})}catch{jG=!0}}function Ove(v,S,P,G){this.tag=v,this.key=P,this.elementType=null,this.type=null,this.stateNode=null,this.return=null,this.child=null,this.sibling=null,this.index=0,this.ref=null,this.pendingProps=S,this.memoizedProps=null,this.updateQueue=null,this.memoizedState=null,this.dependencies=null,this.mode=G,this.flags=Ia,this.subtreeFlags=Ia,this.deletions=null,this.lanes=En,this.childLanes=En,this.alternate=null,this.actualDuration=Number.NaN,this.actualStartTime=Number.NaN,this.selfBaseDuration=Number.NaN,this.treeBaseDuration=Number.NaN,this.actualDuration=0,this.actualStartTime=-1,this.selfBaseDuration=0,this.treeBaseDuration=0,this._debugSource=null,this._debugOwner=null,this._debugNeedsRemount=!1,this._debugHookTypes=null,!jG&&typeof Object.preventExtensions=="function"&&Object.preventExtensions(this)}var Vb=function(v,S,P,G){return new Ove(v,S,P,G)};function AV(v){var S=v.prototype;return!!(S&&S.isReactComponent)}function TN(v){return typeof v=="function"&&!AV(v)&&v.defaultProps===void 0}function Nve(v){if(typeof v=="function")return AV(v)?g:p;if(v!=null){var S=v.$$typeof;if(S===Ai)return x;if(S===Pa)return z}return f}function fw(v,S){var P=v.alternate;P===null?(P=Vb(v.tag,S,v.key,v.mode),P.elementType=v.elementType,P.type=v.type,P.stateNode=v.stateNode,P._debugSource=v._debugSource,P._debugOwner=v._debugOwner,P._debugHookTypes=v._debugHookTypes,P.alternate=v,v.alternate=P):(P.pendingProps=S,P.type=v.type,P.flags=Ia,P.subtreeFlags=Ia,P.deletions=null,P.actualDuration=0,P.actualStartTime=-1),P.flags=v.flags&vc,P.childLanes=v.childLanes,P.lanes=v.lanes,P.child=v.child,P.memoizedProps=v.memoizedProps,P.memoizedState=v.memoizedState,P.updateQueue=v.updateQueue;var G=v.dependencies;switch(P.dependencies=G===null?null:{lanes:G.lanes,firstContext:G.firstContext},P.sibling=v.sibling,P.index=v.index,P.ref=v.ref,P.selfBaseDuration=v.selfBaseDuration,P.treeBaseDuration=v.treeBaseDuration,P._debugNeedsRemount=v._debugNeedsRemount,P.tag){case f:case p:case H:P.type=Z0(v.type);break;case g:P.type=_V(v.type);break;case x:P.type=Po(v.type);break}return P}function xve(v,S){v.flags&=vc|Nd;var P=v.alternate;if(P===null)v.childLanes=En,v.lanes=S,v.child=null,v.subtreeFlags=Ia,v.memoizedProps=null,v.memoizedState=null,v.updateQueue=null,v.dependencies=null,v.stateNode=null,v.selfBaseDuration=0,v.treeBaseDuration=0;else{v.childLanes=P.childLanes,v.lanes=P.lanes,v.child=P.child,v.subtreeFlags=Ia,v.deletions=null,v.memoizedProps=P.memoizedProps,v.memoizedState=P.memoizedState,v.updateQueue=P.updateQueue,v.type=P.type;var G=P.dependencies;v.dependencies=G===null?null:{lanes:G.lanes,firstContext:G.firstContext},v.selfBaseDuration=P.selfBaseDuration,v.treeBaseDuration=P.treeBaseDuration}return v}function hte(v,S,P){var G;return v===Ez?(G=ps,S===!0&&(G|=Sc,G|=Hl)):G=Jr,Bp&&(G|=nr),Vb(y,null,null,G)}function IV(v,S,P,G,Q,me){var De=f,We=v;if(typeof v=="function")AV(v)?(De=g,We=_V(We)):We=Z0(We);else if(typeof v=="string")De=C;else e:switch(v){case $r:return vw(P.children,Q,me,S);case Zd:De=w,Q|=Sc,(Q&ps)!==Jr&&(Q|=Hl);break;case rc:return pte(P,Q,me,S);case pn:return X0(P,Q,me,S);case Bn:return Ft(P,Q,me,S);case aa:return $n(P,Q,me,S);case ti:case kr:case on:case Fn:case Sa:default:{if(typeof v=="object"&&v!==null)switch(v.$$typeof){case Yl:De=F;break e;case ci:De=D;break e;case Ai:De=x,We=Po(We);break e;case Pa:De=z;break e;case qa:De=j,We=null;break e}var rt="";{(v===void 0||typeof v=="object"&&v!==null&&Object.keys(v).length===0)&&(rt+=" You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");var _t=G?Do(G):null;_t&&(rt+=`

Check the render method of \``+_t+"`.")}throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) "+("but got: "+(v==null?v:typeof v)+"."+rt))}}var Ut=Vb(De,P,S,Q);return Ut.elementType=v,Ut.type=We,Ut.lanes=me,Ut._debugOwner=G,Ut}function L2(v,S,P){var G=null;G=v._owner;var Q=v.type,me=v.key,De=v.props,We=IV(Q,me,De,G,S,P);return We._debugSource=v._source,We._debugOwner=v._owner,We}function vw(v,S,P,G){var Q=Vb(I,v,G,S);return Q.lanes=P,Q}function pte(v,S,P,G){typeof v.id!="string"&&d('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.',typeof v.id);var Q=Vb(B,v,G,S|nr);return Q.elementType=rc,Q.lanes=P,Q.stateNode={effectDuration:0,passiveEffectDuration:0},Q}function X0(v,S,P,G){var Q=Vb(L,v,G,S);return Q.elementType=pn,Q.lanes=P,Q}function Ft(v,S,P,G){var Q=Vb(re,v,G,S);return Q.elementType=Bn,Q.lanes=P,Q}function $n(v,S,P,G){var Q=Vb(le,v,G,S);Q.elementType=aa,Q.lanes=P;var me={isHidden:!1};return Q.stateNode=me,Q}function ei(v,S,P){var G=Vb(E,v,null,S);return G.lanes=P,G}function gte(){var v=Vb(C,null,null,Jr);return v.elementType="DELETED",v}function Xr(v){var S=Vb(Z,null,null,Jr);return S.stateNode=v,S}function GG(v,S,P){var G=v.children!==null?v.children:[],Q=Vb(T,G,v.key,S);return Q.lanes=P,Q.stateNode={containerInfo:v.containerInfo,pendingChildren:null,implementation:v.implementation},Q}function mte(v,S){return v===null&&(v=Vb(f,null,null,Jr)),v.tag=S.tag,v.key=S.key,v.elementType=S.elementType,v.type=S.type,v.stateNode=S.stateNode,v.return=S.return,v.child=S.child,v.sibling=S.sibling,v.index=S.index,v.ref=S.ref,v.pendingProps=S.pendingProps,v.memoizedProps=S.memoizedProps,v.updateQueue=S.updateQueue,v.memoizedState=S.memoizedState,v.dependencies=S.dependencies,v.mode=S.mode,v.flags=S.flags,v.subtreeFlags=S.subtreeFlags,v.deletions=S.deletions,v.lanes=S.lanes,v.childLanes=S.childLanes,v.alternate=S.alternate,v.actualDuration=S.actualDuration,v.actualStartTime=S.actualStartTime,v.selfBaseDuration=S.selfBaseDuration,v.treeBaseDuration=S.treeBaseDuration,v._debugSource=S._debugSource,v._debugOwner=S._debugOwner,v._debugNeedsRemount=S._debugNeedsRemount,v._debugHookTypes=S._debugHookTypes,v}function fte(v,S,P,G,Q){this.tag=S,this.containerInfo=v,this.pendingChildren=null,this.current=null,this.pingCache=null,this.finishedWork=null,this.timeoutHandle=AR,this.context=null,this.pendingContext=null,this.callbackNode=null,this.callbackPriority=Vs,this.eventTimes=Yr(En),this.expirationTimes=Yr(bc),this.pendingLanes=En,this.suspendedLanes=En,this.pingedLanes=En,this.expiredLanes=En,this.mutableReadLanes=En,this.finishedLanes=En,this.entangledLanes=En,this.entanglements=Yr(En),this.identifierPrefix=G,this.onRecoverableError=Q,this.mutableSourceEagerHydrationData=null,this.effectDuration=0,this.passiveEffectDuration=0;{this.memoizedUpdaters=new Set;for(var me=this.pendingUpdatersLaneMap=[],De=0;De<_d;De++)me.push(new Set)}switch(S){case Ez:this._debugRootType=P?"hydrateRoot()":"createRoot()";break;case du:this._debugRootType=P?"hydrate()":"render()";break}}function qG(v,S,P,G,Q,me,De,We,rt,_t){var Ut=new fte(v,S,P,We,rt),Di=hte(S,me);Ut.current=Di,Di.stateNode=Ut;{var Ri={element:G,isDehydrated:P,cache:null,transitions:null,pendingSuspenseBoundaries:null};Di.memoizedState=Ri}return Fz(Di),Ut}var WG="18.3.1";function Bve(v,S,P){var G=arguments.length>3&&arguments[3]!==void 0?arguments[3]:null;return ot(G),{$$typeof:Us,key:G==null?null:""+G,children:v,containerInfo:S,implementation:P}}var wV,GR;wV=!1,GR={};function KG(v){if(!v)return Tv;var S=ov(v),P=HX(S);if(S.tag===g){var G=S.type;if($_(G))return $X(S,G,P)}return P}function CN(v,S){{var P=ov(v);if(P===void 0){if(typeof v.render=="function")throw new Error("Unable to find node on an unmounted component.");var G=Object.keys(v).join(",");throw new Error("Argument appears to not be a ReactComponent. Keys: "+G)}var Q=ju(P);if(Q===null)return null;if(Q.mode&Sc){var me=Do(P)||"Component";if(!GR[me]){GR[me]=!0;var De=zu;try{oc(Q),P.mode&Sc?d("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node",S,S,me):d("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node",S,S,me)}finally{De?oc(De):yo()}}}return Q.stateNode}}function vte(v,S,P,G,Q,me,De,We){var rt=!1,_t=null;return qG(v,S,rt,_t,P,G,Q,me,De)}function JG(v,S,P,G,Q,me,De,We,rt,_t){var Ut=!0,Di=qG(P,G,Ut,v,Q,me,De,We,rt);Di.context=KG(null);var Ri=Di.current,Xi=Af(),tn=Y0(Ri),Cn=ew(Xi,tn);return Cn.callback=S??null,LR(Ri,Cn,tn),OG(Di,tn,Xi),Di}function O2(v,S,P,G){mS(S,v);var Q=S.current,me=Af(),De=Y0(Q);nd(De);var We=KG(P);S.context===null?S.context=We:S.pendingContext=We,jm&&zu!==null&&!wV&&(wV=!0,d(`Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.

Check the render method of %s.`,Do(zu)||"Unknown"));var rt=ew(me,De);rt.payload={element:v},G=G===void 0?null:G,G!==null&&(typeof G!="function"&&d("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.",G),rt.callback=G);var _t=LR(Q,rt,De);return _t!==null&&(mp(_t,Q,De,me),Uz(_t,Q,De)),De}function _N(v){var S=v.current;if(!S.child)return null;switch(S.child.tag){case C:return S.child.stateNode;default:return S.child.stateNode}}function YG(v){switch(v.tag){case y:{var S=v.stateNode;if(TI(S)){var P=VT(S);wve(S,P)}break}case L:{hw(function(){var Q=Qp(v,ao);if(Q!==null){var me=Af();mp(Q,v,ao,me)}});var G=ao;N2(v,G);break}}}function yte(v,S){var P=v.memoizedState;P!==null&&P.dehydrated!==null&&(P.retryLane=kb(P.retryLane,S))}function N2(v,S){yte(v,S);var P=v.alternate;P&&yte(P,S)}function Fve(v){if(v.tag===L){var S=g0,P=Qp(v,S);if(P!==null){var G=Af();mp(P,v,S,G)}N2(v,S)}}function Ste(v){if(v.tag===L){var S=Y0(v),P=Qp(v,S);if(P!==null){var G=Af();mp(P,v,S,G)}N2(v,S)}}function bte(v){var S=Ac(v);return S===null?null:S.stateNode}var kV=function(v){return null};function Uve(v){return kV(v)}var RV=function(v){return!1};function zve(v){return RV(v)}var Tte=null,Cte=null,_te=null,Ete=null,Ate=null,Ite=null,wte=null,kte=null,Rte=null;{var Mte=function(v,S,P){var G=S[P],Q=Ko(v)?v.slice():Za({},v);return P+1===S.length?(Ko(Q)?Q.splice(G,1):delete Q[G],Q):(Q[G]=Mte(v[G],S,P+1),Q)},Pte=function(v,S){return Mte(v,S,0)},Dte=function(v,S,P,G){var Q=S[G],me=Ko(v)?v.slice():Za({},v);if(G+1===S.length){var De=P[G];me[De]=me[Q],Ko(me)?me.splice(Q,1):delete me[Q]}else me[Q]=Dte(v[Q],S,P,G+1);return me},Lte=function(v,S,P){if(S.length!==P.length){l("copyWithRename() expects paths of the same length");return}else for(var G=0;G<P.length-1;G++)if(S[G]!==P[G]){l("copyWithRename() expects paths to be the same except for the deepest key");return}return Dte(v,S,P,0)},Ote=function(v,S,P,G){if(P>=S.length)return G;var Q=S[P],me=Ko(v)?v.slice():Za({},v);return me[Q]=Ote(v[Q],S,P+1,G),me},US=function(v,S,P){return Ote(v,S,0,P)},MV=function(v,S){for(var P=v.memoizedState;P!==null&&S>0;)P=P.next,S--;return P};Tte=function(v,S,P,G){var Q=MV(v,S);if(Q!==null){var me=US(Q.memoizedState,P,G);Q.memoizedState=me,Q.baseState=me,v.memoizedProps=Za({},v.memoizedProps);var De=Qp(v,ao);De!==null&&mp(De,v,ao,bc)}},Cte=function(v,S,P){var G=MV(v,S);if(G!==null){var Q=Pte(G.memoizedState,P);G.memoizedState=Q,G.baseState=Q,v.memoizedProps=Za({},v.memoizedProps);var me=Qp(v,ao);me!==null&&mp(me,v,ao,bc)}},_te=function(v,S,P,G){var Q=MV(v,S);if(Q!==null){var me=Lte(Q.memoizedState,P,G);Q.memoizedState=me,Q.baseState=me,v.memoizedProps=Za({},v.memoizedProps);var De=Qp(v,ao);De!==null&&mp(De,v,ao,bc)}},Ete=function(v,S,P){v.pendingProps=US(v.memoizedProps,S,P),v.alternate&&(v.alternate.pendingProps=v.pendingProps);var G=Qp(v,ao);G!==null&&mp(G,v,ao,bc)},Ate=function(v,S){v.pendingProps=Pte(v.memoizedProps,S),v.alternate&&(v.alternate.pendingProps=v.pendingProps);var P=Qp(v,ao);P!==null&&mp(P,v,ao,bc)},Ite=function(v,S,P){v.pendingProps=Lte(v.memoizedProps,S,P),v.alternate&&(v.alternate.pendingProps=v.pendingProps);var G=Qp(v,ao);G!==null&&mp(G,v,ao,bc)},wte=function(v){var S=Qp(v,ao);S!==null&&mp(S,v,ao,bc)},kte=function(v){kV=v},Rte=function(v){RV=v}}function Vve(v){var S=ju(v);return S===null?null:S.stateNode}function Nte(v){return null}function $ve(){return zu}function xte(v){var S=v.findFiberByHostInstance,P=i.ReactCurrentDispatcher;return cy({bundleType:v.bundleType,version:v.version,rendererPackageName:v.rendererPackageName,rendererConfig:v.rendererConfig,overrideHookState:Tte,overrideHookStateDeletePath:Cte,overrideHookStateRenamePath:_te,overrideProps:Ete,overridePropsDeletePath:Ate,overridePropsRenamePath:Ite,setErrorHandler:kte,setSuspenseHandler:Rte,scheduleUpdate:wte,currentDispatcherRef:P,findHostInstanceByFiber:Vve,findFiberByHostInstance:S||Nte,findHostInstancesForRefresh:EV,scheduleRefresh:lte,scheduleRoot:cte,setRefreshHandler:Lr,getCurrentFiber:$ve,reconcilerVersion:WG})}var QG=typeof reportError=="function"?reportError:function(v){console.error(v)};function PV(v){this._internalRoot=v}DV.prototype.render=PV.prototype.render=function(v){var S=this._internalRoot;if(S===null)throw new Error("Cannot update an unmounted root.");{typeof arguments[1]=="function"?d("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect()."):LV(arguments[1])?d("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root."):typeof arguments[1]<"u"&&d("You passed a second argument to root.render(...) but it only accepts one argument.");var P=S.containerInfo;if(P.nodeType!==$u){var G=bte(S.current);G&&G.parentNode!==P&&d("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.")}}O2(v,S,null,null)},DV.prototype.unmount=PV.prototype.unmount=function(){typeof arguments[0]=="function"&&d("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");var v=this._internalRoot;if(v!==null){this._internalRoot=null;var S=v.containerInfo;Qee()&&d("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition."),hw(function(){O2(null,v,null,null)}),_r(S)}};function Hve(v,S){if(!LV(v))throw new Error("createRoot(...): Target container is not a DOM element.");Bte(v);var P=!1,G=!1,Q="",me=QG;S!=null&&(S.hydrate?l("hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead."):typeof S=="object"&&S!==null&&S.$$typeof===al&&d(`You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:

  let root = createRoot(domContainer);
  root.render(<App />);`),S.unstable_strictMode===!0&&(P=!0),S.identifierPrefix!==void 0&&(Q=S.identifierPrefix),S.onRecoverableError!==void 0&&(me=S.onRecoverableError),S.transitionCallbacks!==void 0&&S.transitionCallbacks);var De=vte(v,Ez,null,P,G,Q,me);Wa(De.current,v);var We=v.nodeType===$u?v.parentNode:v;return Sv(We),new PV(De)}function DV(v){this._internalRoot=v}function jve(v){v&&jp(v)}DV.prototype.unstable_scheduleHydration=jve;function Gve(v,S,P){if(!LV(v))throw new Error("hydrateRoot(...): Target container is not a DOM element.");Bte(v),S===void 0&&d("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");var G=P??null,Q=P!=null&&P.hydratedSources||null,me=!1,De=!1,We="",rt=QG;P!=null&&(P.unstable_strictMode===!0&&(me=!0),P.identifierPrefix!==void 0&&(We=P.identifierPrefix),P.onRecoverableError!==void 0&&(rt=P.onRecoverableError));var _t=JG(S,null,v,Ez,G,me,De,We,rt);if(Wa(_t.current,v),Sv(v),Q)for(var Ut=0;Ut<Q.length;Ut++){var Di=Q[Ut];uve(_t,Di)}return new DV(_t)}function LV(v){return!!(v&&(v.nodeType===am||v.nodeType===vb||v.nodeType===kP))}function x2(v){return!!(v&&(v.nodeType===am||v.nodeType===vb||v.nodeType===kP||v.nodeType===$u&&v.nodeValue===" react-mount-point-unstable "))}function Bte(v){v.nodeType===am&&v.tagName&&v.tagName.toUpperCase()==="BODY"&&d("createRoot(): Creating roots directly with document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try using a container element created for your app."),bo(v)&&(v._reactRootContainer?d("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported."):d("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it."))}var qve=i.ReactCurrentOwner,Fte;Fte=function(v){if(v._reactRootContainer&&v.nodeType!==$u){var S=bte(v._reactRootContainer.current);S&&S.parentNode!==v&&d("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.")}var P=!!v._reactRootContainer,G=ZG(v),Q=!!(G&&Oo(G));Q&&!P&&d("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render."),v.nodeType===am&&v.tagName&&v.tagName.toUpperCase()==="BODY"&&d("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.")};function ZG(v){return v?v.nodeType===vb?v.documentElement:v.firstChild:null}function Ute(){}function Wve(v,S,P,G,Q){if(Q){if(typeof G=="function"){var me=G;G=function(){var Ri=_N(De);me.call(Ri)}}var De=JG(S,G,v,du,null,!1,!1,"",Ute);v._reactRootContainer=De,Wa(De.current,v);var We=v.nodeType===$u?v.parentNode:v;return Sv(We),hw(),De}else{for(var rt;rt=v.lastChild;)v.removeChild(rt);if(typeof G=="function"){var _t=G;G=function(){var Ri=_N(Ut);_t.call(Ri)}}var Ut=vte(v,du,null,!1,!1,"",Ute);v._reactRootContainer=Ut,Wa(Ut.current,v);var Di=v.nodeType===$u?v.parentNode:v;return Sv(Di),hw(function(){O2(S,Ut,P,G)}),Ut}}function Kve(v,S){v!==null&&typeof v!="function"&&d("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.",S,v)}function B2(v,S,P,G,Q){Fte(P),Kve(Q===void 0?null:Q,"render");var me=P._reactRootContainer,De;if(!me)De=Wve(P,S,v,Q,G);else{if(De=me,typeof Q=="function"){var We=Q;Q=function(){var rt=_N(De);We.call(rt)}}O2(S,De,v,Q)}return _N(De)}var xD=!1;function Jve(v){{xD||(xD=!0,d("findDOMNode is deprecated and will be removed in the next major release. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node"));var S=qve.current;if(S!==null&&S.stateNode!==null){var P=S.stateNode._warnedAboutRefsInRender;P||d("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.",ol(S.type)||"A component"),S.stateNode._warnedAboutRefsInRender=!0}}return v==null?null:v.nodeType===am?v:CN(v,"findDOMNode")}function XG(v,S,P){if(d("ReactDOM.hydrate is no longer supported in React 18. Use hydrateRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"),!x2(S))throw new Error("Target container is not a DOM element.");{var G=bo(S)&&S._reactRootContainer===void 0;G&&d("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call hydrateRoot(container, element)?")}return B2(null,v,S,!0,P)}function Yve(v,S,P){if(d("ReactDOM.render is no longer supported in React 18. Use createRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"),!x2(S))throw new Error("Target container is not a DOM element.");{var G=bo(S)&&S._reactRootContainer===void 0;G&&d("You are calling ReactDOM.render() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.render(element)?")}return B2(null,v,S,!1,P)}function Qve(v,S,P,G){if(d("ReactDOM.unstable_renderSubtreeIntoContainer() is no longer supported in React 18. Consider using a portal instead. Until you switch to the createRoot API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"),!x2(P))throw new Error("Target container is not a DOM element.");if(v==null||!SF(v))throw new Error("parentComponent must be a valid React Component");return B2(v,S,P,!1,G)}var zte=!1;function Zve(v){if(zte||(zte=!0,d("unmountComponentAtNode is deprecated and will be removed in the next major release. Switch to the createRoot API. Learn more: https://reactjs.org/link/switch-to-createroot")),!x2(v))throw new Error("unmountComponentAtNode(...): Target container is not a DOM element.");{var S=bo(v)&&v._reactRootContainer===void 0;S&&d("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.unmount()?")}if(v._reactRootContainer){{var P=ZG(v),G=P&&!Oo(P);G&&d("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.")}return hw(function(){B2(null,null,v,!1,function(){v._reactRootContainer=null,_r(v)})}),!0}else{{var Q=ZG(v),me=!!(Q&&Oo(Q)),De=v.nodeType===am&&x2(v.parentNode)&&!!v.parentNode._reactRootContainer;me&&d("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s",De?"You may have accidentally passed in a React root node instead of its container.":"Instead, have the parent component update its state and rerender in order to remove this component.")}return!1}}Oh(YG),sf(Fve),QO(Ste),k_(gm),R_($p),(typeof Map!="function"||Map.prototype==null||typeof Map.prototype.forEach!="function"||typeof Set!="function"||Set.prototype==null||typeof Set.prototype.clear!="function"||typeof Set.prototype.forEach!="function")&&d("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"),Eu(vR),s0(xG,kve,hw);function Xve(v,S){var P=arguments.length>2&&arguments[2]!==void 0?arguments[2]:null;if(!LV(S))throw new Error("Target container is not a DOM element.");return Bve(v,S,null,P)}function eye(v,S,P,G){return Qve(v,S,P,G)}var e9={usingClientEntryPoint:!1,Events:[Oo,ec,dl,ty,h_,xG]};function tye(v,S){return e9.usingClientEntryPoint||d('You are importing createRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'),Hve(v,S)}function iye(v,S,P){return e9.usingClientEntryPoint||d('You are importing hydrateRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'),Gve(v,S,P)}function nye(v){return Qee()&&d("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task."),hw(v)}var aye=xte({findFiberByHostInstance:Qo,bundleType:1,version:WG,rendererPackageName:"react-dom"});if(!aye&&vt&&window.top===window.self&&(navigator.userAgent.indexOf("Chrome")>-1&&navigator.userAgent.indexOf("Edge")===-1||navigator.userAgent.indexOf("Firefox")>-1)){var Vte=window.location.protocol;/^(https?|file):$/.test(Vte)&&console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools"+(Vte==="file:"?`
You might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq`:""),"font-weight:bold")}aT.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=e9,aT.createPortal=Xve,aT.createRoot=tye,aT.findDOMNode=Jve,aT.flushSync=nye,aT.hydrate=XG,aT.hydrateRoot=iye,aT.render=Yve,aT.unmountComponentAtNode=Zve,aT.unstable_batchedUpdates=xG,aT.unstable_renderSubtreeIntoContainer=eye,aT.version=WG,typeof __REACT_DEVTOOLS_GLOBAL_HOOK__<"u"&&typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop=="function"&&__REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error)}()),aT}var zCe;function VCe(){if(zCe)return Aq.exports;zCe=1;function t(){if(!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__>"u"||typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE!="function")){if(process.env.NODE_ENV!=="production")throw new Error("^_^");try{__REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(t)}catch(e){console.error(e)}}}return process.env.NODE_ENV==="production"?(t(),Aq.exports=VQe()):Aq.exports=$Qe(),Aq.exports}var $Ce;function HQe(){if($Ce)return OU;$Ce=1;var t=VCe();if(process.env.NODE_ENV==="production")OU.createRoot=t.createRoot,OU.hydrateRoot=t.hydrateRoot;else{var e=t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;OU.createRoot=function(i,r){e.usingClientEntryPoint=!0;try{return t.createRoot(i,r)}finally{e.usingClientEntryPoint=!1}},OU.hydrateRoot=function(i,r,o){e.usingClientEntryPoint=!0;try{return t.hydrateRoot(i,r,o)}finally{e.usingClientEntryPoint=!1}}}return OU}var jQe=HQe(),GQe=Object.defineProperty,qQe=(t,e,i)=>e in t?GQe(t,e,{enumerable:!0,configurable:!0,writable:!0,value:i}):t[e]=i,wq=(t,e,i)=>qQe(t,typeof e!="symbol"?e+"":e,i);const WQe={stringify:t=>t?"true":"false",parse:t=>/^[ty1-9]/i.test(t)},KQe={stringify:t=>t.name,parse:(t,e,i)=>{const r=(()=>{if(typeof window<"u"&&t in window)return window[t];if(typeof global<"u"&&t in global)return global[t]})();return typeof r=="function"?r.bind(i):void 0}},JQe={stringify:t=>JSON.stringify(t),parse:t=>JSON.parse(t)},YQe={stringify:t=>`${t}`,parse:t=>parseFloat(t)},QQe={stringify:t=>t,parse:t=>t},Dae={string:QQe,number:YQe,boolean:WQe,function:KQe,json:JQe};function ZQe(t){return t.replace(/([a-z0-9])([A-Z])/g,(e,i,r)=>`${i}-${r.toLowerCase()}`)}const kq=Symbol.for("r2wc.render"),Rq=Symbol.for("r2wc.connected"),JN=Symbol.for("r2wc.context"),yM=Symbol.for("r2wc.props");function XQe(t,e,i){var r,o,l;e.props||(e.props=t.propTypes?Object.keys(t.propTypes):[]),e.events||(e.events=[]);const d=Array.isArray(e.props)?e.props.slice():Object.keys(e.props),h=Array.isArray(e.events)?e.events.slice():Object.keys(e.events),p={},g={},f={},y={};for(const C of d){p[C]=Array.isArray(e.props)?"string":e.props[C];const E=ZQe(C);f[C]=E,y[E]=C}for(const C of h)g[C]=Array.isArray(e.events)?{}:e.events[C];class T extends HTMLElement{constructor(){super(),wq(this,l,!0),wq(this,o),wq(this,r,{}),wq(this,"container"),e.shadow?this.container=this.attachShadow({mode:e.shadow}):this.container=this,this[yM].container=this.container;for(const E of d){const I=f[E],w=this.getAttribute(I),D=p[E],F=D?Dae[D]:null;F!=null&&F.parse&&w&&(this[yM][E]=F.parse(w,I,this))}for(const E of h)this[yM][E]=I=>{const w=E.replace(/^on/,"").toLowerCase();this.dispatchEvent(new CustomEvent(w,{detail:I,...g[E]}))}}static get observedAttributes(){return Object.keys(y)}connectedCallback(){this[Rq]=!0,this[kq]()}disconnectedCallback(){this[Rq]=!1,this[JN]&&i.unmount(this[JN]),delete this[JN]}attributeChangedCallback(E,I,w){const D=y[E],F=p[D],x=F?Dae[F]:null;D in p&&x!=null&&x.parse&&w&&(this[yM][D]=x.parse(w,E,this),this[kq]())}[(l=Rq,o=JN,r=yM,kq)](){this[Rq]&&(this[JN]?i.update(this[JN],this[yM]):this[JN]=i.mount(this.container,t,this[yM]))}}for(const C of d){const E=f[C],I=p[C];Object.defineProperty(T.prototype,C,{enumerable:!0,configurable:!0,get(){return this[yM][C]},set(w){this[yM][C]=w;const D=I?Dae[I]:null;if(D!=null&&D.stringify){const F=D.stringify(w,E,this);this.getAttribute(E)!==F&&this.setAttribute(E,F)}else this[kq]()}})}return T}function eZe(t,e,i){const r=jQe.createRoot(t),o=U.createElement(e,i);return r.render(o),{root:r,ReactComponent:e}}function tZe({root:t,ReactComponent:e},i){const r=U.createElement(e,i);t.render(r)}function iZe({root:t}){t.unmount()}function nZe(t,e={}){return XQe(t,e,{mount:eZe,update:tZe,unmount:iZe})}var Mq={exports:{}},N$={};/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */var HCe;function aZe(){if(HCe)return N$;HCe=1;var t=fM(),e=Symbol.for("react.element"),i=Symbol.for("react.fragment"),r=Object.prototype.hasOwnProperty,o=t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,l={key:!0,ref:!0,__self:!0,__source:!0};function d(h,p,g){var f,y={},T=null,C=null;g!==void 0&&(T=""+g),p.key!==void 0&&(T=""+p.key),p.ref!==void 0&&(C=p.ref);for(f in p)r.call(p,f)&&!l.hasOwnProperty(f)&&(y[f]=p[f]);if(h&&h.defaultProps)for(f in p=h.defaultProps,p)y[f]===void 0&&(y[f]=p[f]);return{$$typeof:e,type:h,key:T,ref:C,props:y,_owner:o.current}}return N$.Fragment=i,N$.jsx=d,N$.jsxs=d,N$}var x$={};/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */var jCe;function rZe(){return jCe||(jCe=1,process.env.NODE_ENV!=="production"&&function(){var t=fM(),e=Symbol.for("react.element"),i=Symbol.for("react.portal"),r=Symbol.for("react.fragment"),o=Symbol.for("react.strict_mode"),l=Symbol.for("react.profiler"),d=Symbol.for("react.provider"),h=Symbol.for("react.context"),p=Symbol.for("react.forward_ref"),g=Symbol.for("react.suspense"),f=Symbol.for("react.suspense_list"),y=Symbol.for("react.memo"),T=Symbol.for("react.lazy"),C=Symbol.for("react.offscreen"),E=Symbol.iterator,I="@@iterator";function w(ci){if(ci===null||typeof ci!="object")return null;var Ai=E&&ci[E]||ci[I];return typeof Ai=="function"?Ai:null}var D=t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;function F(ci){{for(var Ai=arguments.length,pn=new Array(Ai>1?Ai-1:0),Bn=1;Bn<Ai;Bn++)pn[Bn-1]=arguments[Bn];x("error",ci,pn)}}function x(ci,Ai,pn){{var Bn=D.ReactDebugCurrentFrame,Pa=Bn.getStackAddendum();Pa!==""&&(Ai+="%s",pn=pn.concat([Pa]));var qa=pn.map(function(kr){return String(kr)});qa.unshift("Warning: "+Ai),Function.prototype.apply.call(console[ci],console,qa)}}var B=!1,L=!1,z=!1,H=!1,j=!1,J;J=Symbol.for("react.module.reference");function Z(ci){return!!(typeof ci=="string"||typeof ci=="function"||ci===r||ci===l||j||ci===o||ci===g||ci===f||H||ci===C||B||L||z||typeof ci=="object"&&ci!==null&&(ci.$$typeof===T||ci.$$typeof===y||ci.$$typeof===d||ci.$$typeof===h||ci.$$typeof===p||ci.$$typeof===J||ci.getModuleId!==void 0))}function re(ci,Ai,pn){var Bn=ci.displayName;if(Bn)return Bn;var Pa=Ai.displayName||Ai.name||"";return Pa!==""?pn+"("+Pa+")":pn}function ne(ci){return ci.displayName||"Context"}function le(ci){if(ci==null)return null;if(typeof ci.tag=="number"&&F("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."),typeof ci=="function")return ci.displayName||ci.name||null;if(typeof ci=="string")return ci;switch(ci){case r:return"Fragment";case i:return"Portal";case l:return"Profiler";case o:return"StrictMode";case g:return"Suspense";case f:return"SuspenseList"}if(typeof ci=="object")switch(ci.$$typeof){case h:var Ai=ci;return ne(Ai)+".Consumer";case d:var pn=ci;return ne(pn._context)+".Provider";case p:return re(ci,ci.render,"ForwardRef");case y:var Bn=ci.displayName||null;return Bn!==null?Bn:le(ci.type)||"Memo";case T:{var Pa=ci,qa=Pa._payload,kr=Pa._init;try{return le(kr(qa))}catch{return null}}}return null}var he=Object.assign,Me=0,Le,pe,te,Se,ce,X,ve;function Te(){}Te.__reactDisabledLog=!0;function Be(){{if(Me===0){Le=console.log,pe=console.info,te=console.warn,Se=console.error,ce=console.group,X=console.groupCollapsed,ve=console.groupEnd;var ci={configurable:!0,enumerable:!0,value:Te,writable:!0};Object.defineProperties(console,{info:ci,log:ci,warn:ci,error:ci,group:ci,groupCollapsed:ci,groupEnd:ci})}Me++}}function qe(){{if(Me--,Me===0){var ci={configurable:!0,enumerable:!0,writable:!0};Object.defineProperties(console,{log:he({},ci,{value:Le}),info:he({},ci,{value:pe}),warn:he({},ci,{value:te}),error:he({},ci,{value:Se}),group:he({},ci,{value:ce}),groupCollapsed:he({},ci,{value:X}),groupEnd:he({},ci,{value:ve})})}Me<0&&F("disabledDepth fell below zero. This is a bug in React. Please file an issue.")}}var Ge=D.ReactCurrentDispatcher,tt;function ct(ci,Ai,pn){{if(tt===void 0)try{throw Error()}catch(Pa){var Bn=Pa.stack.trim().match(/\n( *(at )?)/);tt=Bn&&Bn[1]||""}return`
`+tt+ci}}var Mt=!1,ht;{var vt=typeof WeakMap=="function"?WeakMap:Map;ht=new vt}function Pt(ci,Ai){if(!ci||Mt)return"";{var pn=ht.get(ci);if(pn!==void 0)return pn}var Bn;Mt=!0;var Pa=Error.prepareStackTrace;Error.prepareStackTrace=void 0;var qa;qa=Ge.current,Ge.current=null,Be();try{if(Ai){var kr=function(){throw Error()};if(Object.defineProperty(kr.prototype,"props",{set:function(){throw Error()}}),typeof Reflect=="object"&&Reflect.construct){try{Reflect.construct(kr,[])}catch(za){Bn=za}Reflect.construct(ci,[],kr)}else{try{kr.call()}catch(za){Bn=za}ci.call(kr.prototype)}}else{try{throw Error()}catch(za){Bn=za}ci()}}catch(za){if(za&&Bn&&typeof za.stack=="string"){for(var Sa=za.stack.split(`
`),aa=Bn.stack.split(`
`),ti=Sa.length-1,on=aa.length-1;ti>=1&&on>=0&&Sa[ti]!==aa[on];)on--;for(;ti>=1&&on>=0;ti--,on--)if(Sa[ti]!==aa[on]){if(ti!==1||on!==1)do if(ti--,on--,on<0||Sa[ti]!==aa[on]){var Fn=`
`+Sa[ti].replace(" at new "," at ");return ci.displayName&&Fn.includes("<anonymous>")&&(Fn=Fn.replace("<anonymous>",ci.displayName)),typeof ci=="function"&&ht.set(ci,Fn),Fn}while(ti>=1&&on>=0);break}}}finally{Mt=!1,Ge.current=qa,qe(),Error.prepareStackTrace=Pa}var Or=ci?ci.displayName||ci.name:"",Co=Or?ct(Or):"";return typeof ci=="function"&&ht.set(ci,Co),Co}function ni(ci,Ai,pn){return Pt(ci,!1)}function Zt(ci){var Ai=ci.prototype;return!!(Ai&&Ai.isReactComponent)}function it(ci,Ai,pn){if(ci==null)return"";if(typeof ci=="function")return Pt(ci,Zt(ci));if(typeof ci=="string")return ct(ci);switch(ci){case g:return ct("Suspense");case f:return ct("SuspenseList")}if(typeof ci=="object")switch(ci.$$typeof){case p:return ni(ci.render);case y:return it(ci.type,Ai,pn);case T:{var Bn=ci,Pa=Bn._payload,qa=Bn._init;try{return it(qa(Pa),Ai,pn)}catch{}}}return""}var Ke=Object.prototype.hasOwnProperty,ot={},Ht=D.ReactDebugCurrentFrame;function jt(ci){if(ci){var Ai=ci._owner,pn=it(ci.type,ci._source,Ai?Ai.type:null);Ht.setExtraStackFrame(pn)}else Ht.setExtraStackFrame(null)}function Nt(ci,Ai,pn,Bn,Pa){{var qa=Function.call.bind(Ke);for(var kr in ci)if(qa(ci,kr)){var Sa=void 0;try{if(typeof ci[kr]!="function"){var aa=Error((Bn||"React class")+": "+pn+" type `"+kr+"` is invalid; it must be a function, usually from the `prop-types` package, but received `"+typeof ci[kr]+"`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");throw aa.name="Invariant Violation",aa}Sa=ci[kr](Ai,kr,Bn,pn,null,"SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED")}catch(ti){Sa=ti}Sa&&!(Sa instanceof Error)&&(jt(Pa),F("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).",Bn||"React class",pn,kr,typeof Sa),jt(null)),Sa instanceof Error&&!(Sa.message in ot)&&(ot[Sa.message]=!0,jt(Pa),F("Failed %s type: %s",pn,Sa.message),jt(null))}}}var Vt=Array.isArray;function $t(ci){return Vt(ci)}function dt(ci){{var Ai=typeof Symbol=="function"&&Symbol.toStringTag,pn=Ai&&ci[Symbol.toStringTag]||ci.constructor.name||"Object";return pn}}function yt(ci){try{return kt(ci),!1}catch{return!0}}function kt(ci){return""+ci}function je(ci){if(yt(ci))return F("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.",dt(ci)),kt(ci)}var Ae=D.ReactCurrentOwner,xe={key:!0,ref:!0,__self:!0,__source:!0},gt,Ye;function Fe(ci){if(Ke.call(ci,"ref")){var Ai=Object.getOwnPropertyDescriptor(ci,"ref").get;if(Ai&&Ai.isReactWarning)return!1}return ci.ref!==void 0}function St(ci){if(Ke.call(ci,"key")){var Ai=Object.getOwnPropertyDescriptor(ci,"key").get;if(Ai&&Ai.isReactWarning)return!1}return ci.key!==void 0}function Wt(ci,Ai){typeof ci.ref=="string"&&Ae.current}function Ii(ci,Ai){{var pn=function(){gt||(gt=!0,F("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)",Ai))};pn.isReactWarning=!0,Object.defineProperty(ci,"key",{get:pn,configurable:!0})}}function en(ci,Ai){{var pn=function(){Ye||(Ye=!0,F("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)",Ai))};pn.isReactWarning=!0,Object.defineProperty(ci,"ref",{get:pn,configurable:!0})}}var sn=function(ci,Ai,pn,Bn,Pa,qa,kr){var Sa={$$typeof:e,type:ci,key:Ai,ref:pn,props:kr,_owner:qa};return Sa._store={},Object.defineProperty(Sa._store,"validated",{configurable:!1,enumerable:!1,writable:!0,value:!1}),Object.defineProperty(Sa,"_self",{configurable:!1,enumerable:!1,writable:!1,value:Bn}),Object.defineProperty(Sa,"_source",{configurable:!1,enumerable:!1,writable:!1,value:Pa}),Object.freeze&&(Object.freeze(Sa.props),Object.freeze(Sa)),Sa};function Qi(ci,Ai,pn,Bn,Pa){{var qa,kr={},Sa=null,aa=null;pn!==void 0&&(je(pn),Sa=""+pn),St(Ai)&&(je(Ai.key),Sa=""+Ai.key),Fe(Ai)&&(aa=Ai.ref,Wt(Ai,Pa));for(qa in Ai)Ke.call(Ai,qa)&&!xe.hasOwnProperty(qa)&&(kr[qa]=Ai[qa]);if(ci&&ci.defaultProps){var ti=ci.defaultProps;for(qa in ti)kr[qa]===void 0&&(kr[qa]=ti[qa])}if(Sa||aa){var on=typeof ci=="function"?ci.displayName||ci.name||"Unknown":ci;Sa&&Ii(kr,on),aa&&en(kr,on)}return sn(ci,Sa,aa,Pa,Bn,Ae.current,kr)}}var qt=D.ReactCurrentOwner,ri=D.ReactDebugCurrentFrame;function Ti(ci){if(ci){var Ai=ci._owner,pn=it(ci.type,ci._source,Ai?Ai.type:null);ri.setExtraStackFrame(pn)}else ri.setExtraStackFrame(null)}var rn;rn=!1;function Hn(ci){return typeof ci=="object"&&ci!==null&&ci.$$typeof===e}function ha(){{if(qt.current){var ci=le(qt.current.type);if(ci)return`

Check the render method of \``+ci+"`."}return""}}function hr(ci){return""}var yn={};function pr(ci){{var Ai=ha();if(!Ai){var pn=typeof ci=="string"?ci:ci.displayName||ci.name;pn&&(Ai=`

Check the top-level render call using <`+pn+">.")}return Ai}}function Ho(ci,Ai){{if(!ci._store||ci._store.validated||ci.key!=null)return;ci._store.validated=!0;var pn=pr(Ai);if(yn[pn])return;yn[pn]=!0;var Bn="";ci&&ci._owner&&ci._owner!==qt.current&&(Bn=" It was passed a child from "+le(ci._owner.type)+"."),Ti(ci),F('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.',pn,Bn),Ti(null)}}function Rr(ci,Ai){{if(typeof ci!="object")return;if($t(ci))for(var pn=0;pn<ci.length;pn++){var Bn=ci[pn];Hn(Bn)&&Ho(Bn,Ai)}else if(Hn(ci))ci._store&&(ci._store.validated=!0);else if(ci){var Pa=w(ci);if(typeof Pa=="function"&&Pa!==ci.entries)for(var qa=Pa.call(ci),kr;!(kr=qa.next()).done;)Hn(kr.value)&&Ho(kr.value,Ai)}}}function La(ci){{var Ai=ci.type;if(Ai==null||typeof Ai=="string")return;var pn;if(typeof Ai=="function")pn=Ai.propTypes;else if(typeof Ai=="object"&&(Ai.$$typeof===p||Ai.$$typeof===y))pn=Ai.propTypes;else return;if(pn){var Bn=le(Ai);Nt(pn,ci.props,"prop",Bn,ci)}else if(Ai.PropTypes!==void 0&&!rn){rn=!0;var Pa=le(Ai);F("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?",Pa||"Unknown")}typeof Ai.getDefaultProps=="function"&&!Ai.getDefaultProps.isReactClassApproved&&F("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.")}}function us(ci){{for(var Ai=Object.keys(ci.props),pn=0;pn<Ai.length;pn++){var Bn=Ai[pn];if(Bn!=="children"&&Bn!=="key"){Ti(ci),F("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.",Bn),Ti(null);break}}ci.ref!==null&&(Ti(ci),F("Invalid attribute `ref` supplied to `React.Fragment`."),Ti(null))}}var al={};function Us(ci,Ai,pn,Bn,Pa,qa){{var kr=Z(ci);if(!kr){var Sa="";(ci===void 0||typeof ci=="object"&&ci!==null&&Object.keys(ci).length===0)&&(Sa+=" You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");var aa=hr();aa?Sa+=aa:Sa+=ha();var ti;ci===null?ti="null":$t(ci)?ti="array":ci!==void 0&&ci.$$typeof===e?(ti="<"+(le(ci.type)||"Unknown")+" />",Sa=" Did you accidentally export a JSX literal instead of a component?"):ti=typeof ci,F("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s",ti,Sa)}var on=Qi(ci,Ai,pn,Pa,qa);if(on==null)return on;if(kr){var Fn=Ai.children;if(Fn!==void 0)if(Bn)if($t(Fn)){for(var Or=0;Or<Fn.length;Or++)Rr(Fn[Or],ci);Object.freeze&&Object.freeze(Fn)}else F("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");else Rr(Fn,ci)}if(Ke.call(Ai,"key")){var Co=le(ci),za=Object.keys(Ai).filter(function(Uu){return Uu!=="key"}),Za=za.length>0?"{key: someKey, "+za.join(": ..., ")+": ...}":"{key: someKey}";if(!al[Co+Za]){var ns=za.length>0?"{"+za.join(": ..., ")+": ...}":"{}";F(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,Za,Co,ns,Co),al[Co+Za]=!0}}return ci===r?us(on):La(on),on}}function $r(ci,Ai,pn){return Us(ci,Ai,pn,!0)}function Zd(ci,Ai,pn){return Us(ci,Ai,pn,!1)}var rc=Zd,Yl=$r;x$.Fragment=r,x$.jsx=rc,x$.jsxs=Yl}()),x$}var GCe;function oZe(){return GCe||(GCe=1,process.env.NODE_ENV==="production"?Mq.exports=aZe():Mq.exports=rZe()),Mq.exports}var Da=oZe();const sZe=LU({__proto__:null,default:cL(Da)},[Da]);var Lae=function(t,e){return Lae=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(i,r){i.__proto__=r}||function(i,r){for(var o in r)Object.prototype.hasOwnProperty.call(r,o)&&(i[o]=r[o])},Lae(t,e)};function mu(t,e){if(typeof e!="function"&&e!==null)throw new TypeError("Class extends value "+String(e)+" is not a constructor or null");Lae(t,e);function i(){this.constructor=t}t.prototype=e===null?Object.create(e):(i.prototype=e.prototype,new i)}var Rt=function(){return Rt=Object.assign||function(e){for(var i,r=1,o=arguments.length;r<o;r++){i=arguments[r];for(var l in i)Object.prototype.hasOwnProperty.call(i,l)&&(e[l]=i[l])}return e},Rt.apply(this,arguments)};function Mm(t,e){var i={};for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&e.indexOf(r)<0&&(i[r]=t[r]);if(t!=null&&typeof Object.getOwnPropertySymbols=="function")for(var o=0,r=Object.getOwnPropertySymbols(t);o<r.length;o++)e.indexOf(r[o])<0&&Object.prototype.propertyIsEnumerable.call(t,r[o])&&(i[r[o]]=t[r[o]]);return i}function B$(t,e,i,r){var o=arguments.length,l=o<3?e:r===null?r=Object.getOwnPropertyDescriptor(e,i):r,d;if(typeof Reflect=="object"&&typeof Reflect.decorate=="function")l=Reflect.decorate(t,e,i,r);else for(var h=t.length-1;h>=0;h--)(d=t[h])&&(l=(o<3?d(l):o>3?d(e,i,l):d(e,i))||l);return o>3&&l&&Object.defineProperty(e,i,l),l}function qCe(t){var e=typeof Symbol=="function"&&Symbol.iterator,i=e&&t[e],r=0;if(i)return i.call(t);if(t&&typeof t.length=="number")return{next:function(){return t&&r>=t.length&&(t=void 0),{value:t&&t[r++],done:!t}}};throw new TypeError(e?"Object is not iterable.":"Symbol.iterator is not defined.")}function Gd(t,e,i){if(i||arguments.length===2)for(var r=0,o=e.length,l;r<o;r++)(l||!(r in e))&&(l||(l=Array.prototype.slice.call(e,0,r)),l[r]=e[r]);return t.concat(l||Array.prototype.slice.call(e))}function Uc(t){return this instanceof Uc?(this.v=t,this):new Uc(t)}function dL(t,e,i){if(!Symbol.asyncIterator)throw new TypeError("Symbol.asyncIterator is not defined.");var r=i.apply(t,e||[]),o,l=[];return o=Object.create((typeof AsyncIterator=="function"?AsyncIterator:Object).prototype),h("next"),h("throw"),h("return",d),o[Symbol.asyncIterator]=function(){return this},o;function d(C){return function(E){return Promise.resolve(E).then(C,y)}}function h(C,E){r[C]&&(o[C]=function(I){return new Promise(function(w,D){l.push([C,I,w,D])>1||p(C,I)})},E&&(o[C]=E(o[C])))}function p(C,E){try{g(r[C](E))}catch(I){T(l[0][3],I)}}function g(C){C.value instanceof Uc?Promise.resolve(C.value.v).then(f,y):T(l[0][2],C)}function f(C){p("next",C)}function y(C){p("throw",C)}function T(C,E){C(E),l.shift(),l.length&&p(l[0][0],l[0][1])}}function Pq(t){var e,i;return e={},r("next"),r("throw",function(o){throw o}),r("return"),e[Symbol.iterator]=function(){return this},e;function r(o,l){e[o]=t[o]?function(d){return(i=!i)?{value:Uc(t[o](d)),done:!1}:l?l(d):d}:l}}function uL(t){if(!Symbol.asyncIterator)throw new TypeError("Symbol.asyncIterator is not defined.");var e=t[Symbol.asyncIterator],i;return e?e.call(t):(t=typeof qCe=="function"?qCe(t):t[Symbol.iterator](),i={},r("next"),r("throw"),r("return"),i[Symbol.asyncIterator]=function(){return this},i);function r(l){i[l]=t[l]&&function(d){return new Promise(function(h,p){d=t[l](d),o(h,p,d.done,d.value)})}}function o(l,d,h,p){Promise.resolve(p).then(function(g){l({value:g,done:h})},d)}}typeof SuppressedError=="function"&&SuppressedError;var WCe={},Dq=void 0;try{Dq=window}catch{}function Oae(t,e){if(typeof Dq<"u"){var i=Dq.__packages__=Dq.__packages__||{};if(!i[t]||!WCe[t]){WCe[t]=e;var r=i[t]=i[t]||[];r.push(e)}}}Oae("@fluentui/set-version","6.0.0");var Nae="__global__",KCe="__shadow_dom_stylesheet__",JCe={stylesheetKey:Nae,inShadow:!1,window:void 0,__isShadowConfig__:!0},lZe=function(t,e,i){return{stylesheetKey:t,inShadow:e,window:i,__isShadowConfig__:!0}},F$=function(t){return t&&cZe(t)?t.__isShadowConfig__===!0:!1};function cZe(t){return t!==null&&typeof t=="object"&&!Array.isArray(t)}function YCe(t){for(var e=[],i=1;i<arguments.length;i++)e[i-1]=arguments[i];var r=[],o=[],l=t;function d(h){for(var p=0,g=h;p<g.length;p++){var f=g[p];if(f&&!F$(f))if(typeof f=="string")if(f.indexOf(" ")>=0)d(f.split(" "));else{var y=l.argsFromClassName(f);y?d(y):r.indexOf(f)===-1&&r.push(f)}else Array.isArray(f)?d(f):typeof f=="object"&&o.push(f)}}return d(e),{classes:r,objects:o}}function QCe(t){NU!==t&&(NU=t)}function ZCe(){return NU===void 0&&(NU=typeof document<"u"&&!!document.documentElement&&document.documentElement.getAttribute("dir")==="rtl"),NU}var NU;NU=ZCe();function Lq(){return{rtl:ZCe(),shadowConfig:JCe}}var U$={none:0,insertNode:1,appendChild:2},XCe="__stylesheet__",dZe=typeof navigator<"u"&&/rv:11.0/.test(navigator.userAgent),hL={};try{hL=window||{}}catch{}var xU,yC=function(){function t(e,i){var r,o,l,d,h,p;this._rules=[],this._preservedRules=[],this._counter=0,this._keyToClassName={},this._onInsertRuleCallbacks=[],this._onResetCallbacks=[],this._classNameToArgs={},this._config=Rt({injectionMode:typeof document>"u"?U$.none:U$.insertNode,defaultPrefix:"css",namespace:void 0,cspSettings:void 0},e),this._classNameToArgs=(r=i?.classNameToArgs)!==null&&r!==void 0?r:this._classNameToArgs,this._counter=(o=i?.counter)!==null&&o!==void 0?o:this._counter,this._keyToClassName=(d=(l=this._config.classNameCache)!==null&&l!==void 0?l:i?.keyToClassName)!==null&&d!==void 0?d:this._keyToClassName,this._preservedRules=(h=i?.preservedRules)!==null&&h!==void 0?h:this._preservedRules,this._rules=(p=i?.rules)!==null&&p!==void 0?p:this._rules}return t.getInstance=function(e){if(xU=hL[XCe],hL[KCe])return hL[KCe].getInstance(e);if(!xU||xU._lastStyleElement&&xU._lastStyleElement.ownerDocument!==document){var i=hL?.FabricConfig||{},r=new t(i.mergeStyles,i.serializedStylesheet);xU=r,hL[XCe]=r}return xU},t.prototype.serialize=function(){return JSON.stringify({classNameToArgs:this._classNameToArgs,counter:this._counter,keyToClassName:this._keyToClassName,preservedRules:this._preservedRules,rules:this._rules})},t.prototype.setConfig=function(e){this._config=Rt(Rt({},this._config),e)},t.prototype.onReset=function(e){var i=this;return this._onResetCallbacks.push(e),function(){i._onResetCallbacks=i._onResetCallbacks.filter(function(r){return r!==e})}},t.prototype.onInsertRule=function(e){var i=this;return this._onInsertRuleCallbacks.push(e),function(){i._onInsertRuleCallbacks=i._onInsertRuleCallbacks.filter(function(r){return r!==e})}},t.prototype.getClassName=function(e){var i=this._config.namespace,r=e||this._config.defaultPrefix;return"".concat(i?i+"-":"").concat(r,"-").concat(this._counter++)},t.prototype.cacheClassName=function(e,i,r,o){this._keyToClassName[this._getCacheKey(i)]=e,this._classNameToArgs[e]={args:r,rules:o}},t.prototype.classNameFromKey=function(e){return this._keyToClassName[this._getCacheKey(e)]},t.prototype.getClassNameCache=function(){return this._keyToClassName},t.prototype.argsFromClassName=function(e){var i=this._classNameToArgs[e];return i&&i.args},t.prototype.insertedRulesFromClassName=function(e){var i=this._classNameToArgs[e];return i&&i.rules},t.prototype.insertRule=function(e,i,r){r===void 0&&(r=Nae);var o=this._config.injectionMode,l=o!==U$.none?this._getStyleElement():void 0;if(i&&this._preservedRules.push(e),l)switch(o){case U$.insertNode:this._insertRuleIntoSheet(l.sheet,e);break;case U$.appendChild:l.appendChild(document.createTextNode(e));break}else this._rules.push(e);this._config.onInsertRule&&this._config.onInsertRule(e),this._onInsertRuleCallbacks.forEach(function(d){return d({key:r,sheet:l?l.sheet:void 0,rule:e})})},t.prototype.getRules=function(e){return(e?this._preservedRules.join(""):"")+this._rules.join("")},t.prototype.reset=function(){this._rules=[],this._counter=0,this._classNameToArgs={},this._keyToClassName={},this._onResetCallbacks.forEach(function(e){return e()})},t.prototype.resetKeys=function(){this._keyToClassName={}},t.prototype._createStyleElement=function(){var e,i=((e=this._config.window)===null||e===void 0?void 0:e.document)||document,r=i.head,o=i.createElement("style"),l=null;o.setAttribute("data-merge-styles","true");var d=this._config.cspSettings;if(d&&d.nonce&&o.setAttribute("nonce",d.nonce),this._lastStyleElement)l=this._lastStyleElement.nextElementSibling;else{var h=this._findPlaceholderStyleTag();h?l=h.nextElementSibling:l=r.childNodes[0]}return r.insertBefore(o,r.contains(l)?l:null),this._lastStyleElement=o,o},t.prototype._insertRuleIntoSheet=function(e,i){if(!e)return!1;try{return e.insertRule(i,e.cssRules.length),!0}catch{}return!1},t.prototype._getCacheKey=function(e){return e},t.prototype._getStyleElement=function(){var e=this;if(!this._styleElement&&(this._styleElement=this._createStyleElement(),!dZe)){var i=this._config.window||window;i.requestAnimationFrame(function(){e._styleElement=void 0})}return this._styleElement},t.prototype._findPlaceholderStyleTag=function(){var e=document.head;return e?e.querySelector("style[data-merge-styles]"):null},t}(),e_e={};function uZe(t,e){var i=t[e];i.charAt(0)!=="-"&&(t[e]=e_e[i]=e_e[i]||i.replace(/([A-Z])/g,"-$1").toLowerCase())}var Oq;function hZe(){var t;if(!Oq){var e=typeof document<"u"?document:void 0,i=typeof navigator<"u"?navigator:void 0,r=(t=i?.userAgent)===null||t===void 0?void 0:t.toLowerCase();e?Oq={isWebkit:!!(e&&"WebkitAppearance"in e.documentElement.style),isMoz:!!(r&&r.indexOf("firefox")>-1),isOpera:!!(r&&r.indexOf("opera")>-1),isMs:!!(i&&(/rv:11.0/i.test(i.userAgent)||/Edge\/\d./i.test(navigator.userAgent)))}:Oq={isWebkit:!0,isMoz:!0,isOpera:!0,isMs:!0}}return Oq}var t_e={"user-select":1};function pZe(t,e){var i=hZe(),r=t[e];if(t_e[r]){var o=t[e+1];t_e[r]&&(i.isWebkit&&t.push("-webkit-"+r,o),i.isMoz&&t.push("-moz-"+r,o),i.isMs&&t.push("-ms-"+r,o),i.isOpera&&t.push("-o-"+r,o))}}var gZe=["column-count","font-weight","flex","flex-grow","flex-shrink","fill-opacity","opacity","order","z-index","zoom"];function mZe(t,e){var i=t[e],r=t[e+1];if(typeof r=="number"){var o=gZe.indexOf(i)>-1,l=i.indexOf("--")>-1,d=o||l?"":"px";t[e+1]="".concat(r).concat(d)}}var Nq,pL="left",gL="right",fZe="@noflip",i_e=(Nq={},Nq[pL]=gL,Nq[gL]=pL,Nq),n_e={"w-resize":"e-resize","sw-resize":"se-resize","nw-resize":"ne-resize"};function vZe(t,e,i){if(t.rtl){var r=e[i];if(!r)return;var o=e[i+1];if(typeof o=="string"&&o.indexOf(fZe)>=0)e[i+1]=o.replace(/\s*(?:\/\*\s*)?\@noflip\b(?:\s*\*\/)?\s*?/g,"");else if(r.indexOf(pL)>=0)e[i]=r.replace(pL,gL);else if(r.indexOf(gL)>=0)e[i]=r.replace(gL,pL);else if(String(o).indexOf(pL)>=0)e[i+1]=o.replace(pL,gL);else if(String(o).indexOf(gL)>=0)e[i+1]=o.replace(gL,pL);else if(i_e[r])e[i]=i_e[r];else if(n_e[o])e[i+1]=n_e[o];else switch(r){case"margin":case"padding":e[i+1]=SZe(o);break;case"box-shadow":e[i+1]=yZe(o,0);break}}}function yZe(t,e){var i=t.split(" "),r=parseInt(i[e],10);return i[0]=i[0].replace(String(r),String(r*-1)),i.join(" ")}function SZe(t){if(typeof t=="string"){var e=t.split(" ");if(e.length===4)return"".concat(e[0]," ").concat(e[3]," ").concat(e[2]," ").concat(e[1])}return t}function bZe(t){for(var e=[],i=0,r=0,o=0;o<t.length;o++)switch(t[o]){case"(":r++;break;case")":r&&r--;break;case"	":case" ":r||(o>i&&e.push(t.substring(i,o)),i=o+1);break}return i<t.length&&e.push(t.substring(i)),e}var TZe="displayName";function CZe(t){var e=t&&t["&"];return e?e.displayName:void 0}var a_e=/\:global\((.+?)\)/g;function _Ze(t){if(!a_e.test(t))return t;for(var e=[],i=/\:global\((.+?)\)/g,r=null;r=i.exec(t);)r[1].indexOf(",")>-1&&e.push([r.index,r.index+r[0].length,r[1].split(",").map(function(o){return":global(".concat(o.trim(),")")}).join(", ")]);return e.reverse().reduce(function(o,l){var d=l[0],h=l[1],p=l[2],g=o.slice(0,d),f=o.slice(h);return g+p+f},t)}function EZe(t){return t.indexOf(":global(")>=0||t.indexOf(":")===0}function r_e(t,e){return t.indexOf(":global(")>=0?t.replace(a_e,"$1"):t.indexOf(":host(")===0?t:t.indexOf(":")===0?e+t:t.indexOf("&")<0?e+" "+t:t}function o_e(t,e,i,r,o){e===void 0&&(e={__order:[]}),i.indexOf("@")===0?(i=i+"{"+t,BU([r],e,i,o)):i.indexOf(",")>-1?_Ze(i).split(",").map(function(l){return l.trim()}).forEach(function(l){return BU([r],e,r_e(l,t),o)}):BU([r],e,r_e(i,t),o)}function BU(t,e,i,r){e===void 0&&(e={__order:[]}),i===void 0&&(i="&");var o=e[i];o||(o={},e[i]=o,e.__order.push(i));for(var l=0,d=t;l<d.length;l++){var h=d[l];if(typeof h=="string"){var p=r.argsFromClassName(h);p&&BU(p,e,i,r)}else if(Array.isArray(h))BU(h,e,i,r);else for(var g in h)if(h.hasOwnProperty(g)){var f=h[g];if(g==="selectors"){var y=h.selectors;for(var T in y)y.hasOwnProperty(T)&&o_e(i,e,T,y[T],r)}else typeof f=="object"||EZe(g)?f!=null&&o_e(i,e,g,f,r):f!==void 0&&(g==="margin"||g==="padding"?AZe(o,g,f):o[g]=f)}}return e}function AZe(t,e,i){var r=typeof i=="string"?bZe(i):[i];r.length===0&&r.push(i),r[r.length-1]==="!important"&&(r=r.slice(0,-1).map(function(o){return o+" !important"})),t[e+"Top"]=r[0],t[e+"Right"]=r[1]||r[0],t[e+"Bottom"]=r[2]||r[0],t[e+"Left"]=r[3]||r[1]||r[0]}function IZe(t,e){for(var i=[t.rtl?"rtl":"ltr"],r=!1,o=0,l=e.__order;o<l.length;o++){var d=l[o];i.push(d);var h=e[d];for(var p in h)h.hasOwnProperty(p)&&h[p]!==void 0&&(r=!0,i.push(p,h[p]))}return r?i.join(""):void 0}function s_e(t,e){return e<=0?"":e===1?t:t+s_e(t,e-1)}function xae(t,e){if(!e)return"";var i=[];for(var r in e)e.hasOwnProperty(r)&&r!==TZe&&e[r]!==void 0&&i.push(r,e[r]);for(var o=0;o<i.length;o+=2)uZe(i,o),mZe(i,o),vZe(t,i,o),pZe(i,o);for(var o=1;o<i.length;o+=4)i.splice(o,1,":",i[o],";");return i.join("")}function l_e(t){for(var e,i=[],r=1;r<arguments.length;r++)i[r-1]=arguments[r];var o=(e=t.stylesheet)!==null&&e!==void 0?e:yC.getInstance(t.shadowConfig),l=BU(i,void 0,void 0,o),d=IZe(t,l);if(d){var h={className:o.classNameFromKey(d),key:d,args:i};if(!h.className){h.className=o.getClassName(CZe(l));for(var p=[],g=0,f=l.__order;g<f.length;g++){var y=f[g];p.push(y,xae(t,l[y]))}h.rulesToInsert=p}return h}}function c_e(t,e,i,r){e===void 0&&(e=1);var o=r??yC.getInstance(i),l=t.className,d=t.key,h=t.args,p=t.rulesToInsert;if(p){for(var g=0;g<p.length;g+=2){var f=p[g+1];if(f){var y=p[g];y=y.replace(/&/g,s_e(".".concat(t.className),e));var T="".concat(y,"{").concat(f,"}").concat(y.indexOf("@")===0?"}":"");o.insertRule(T)}}o.cacheClassName(l,d,h,p)}}function wZe(t){for(var e=[],i=1;i<arguments.length;i++)e[i-1]=arguments[i];var r=l_e.apply(void 0,Gd([t],e,!1));return r?(c_e(r,t.specificityMultiplier,t.shadowConfig,t.stylesheet),r.className):""}function It(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];return d_e(t,Lq())}function d_e(t,e){var i=t instanceof Array?t:[t],r=e||{},o=F$(i[0]);o&&(r.shadowConfig=i[0]),r.stylesheet=yC.getInstance(r.shadowConfig);var l=YCe(r.stylesheet,i),d=l.classes,h=l.objects;return h.length&&d.push(wZe(r,h)),d.join(" ")}function Ds(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];if(t&&t.length===1&&t[0]&&!t[0].subComponentStyles&&!F$(t[0]))return t[0];for(var i={},r={},o=0,l=t;o<l.length;o++){var d=l[o];if(d&&!F$(d)){for(var h in d)if(d.hasOwnProperty(h)){if(h==="subComponentStyles"&&d.subComponentStyles!==void 0){var p=d.subComponentStyles;for(var g in p)p.hasOwnProperty(g)&&(r.hasOwnProperty(g)?r[g].push(p[g]):r[g]=[p[g]]);continue}var f=i[h],y=d[h];f===void 0?i[h]=y:i[h]=Gd(Gd([],Array.isArray(f)?f:[f],!0),Array.isArray(y)?y:[y],!0)}}}if(Object.keys(r).length>0){i.subComponentStyles={};var T=i.subComponentStyles,C=function(E){if(r.hasOwnProperty(E)){var I=r[E];T[E]=function(w){return Ds.apply(void 0,I.map(function(D){return typeof D=="function"?D(w):D}))}}};for(var g in r)C(g)}return i}function Rw(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];return Bae(t,Lq())}function Bae(t,e){var i={subComponentStyles:{}},r=void 0,o;F$(t[0])?(r=t[0],o=t[1]):o=t[0],r??(r=e?.shadowConfig);var l=Rt(Rt({},e),{shadowConfig:r});if(!o&&t.length<=1)return{subComponentStyles:{}};var d=yC.getInstance(r);l.stylesheet=d;var h=Ds.apply(void 0,t),p=[];for(var g in h)if(h.hasOwnProperty(g)){if(g==="subComponentStyles"){i.subComponentStyles=h.subComponentStyles||{};continue}else if(g==="__shadowConfig__")continue;var f=h[g],y=YCe(d,f),T=y.classes,C=y.objects;if(C?.length){var E=l_e(l||{},{displayName:g},C);E&&(p.push(E),i[g]=T.concat([E.className]).join(" "))}else i[g]=T.join(" ")}for(var I=0,w=p;I<w.length;I++){var E=w[I];E&&c_e(E,e?.specificityMultiplier,r)}return i}function u_e(t){for(var e=[],i=1;i<arguments.length;i++)e[i-1]=arguments[i];for(var r=[],o=0,l=e;o<l.length;o++){var d=l[o];d&&r.push(typeof d=="function"?d(t):d)}return r.length===1?r[0]:r.length?Ds.apply(void 0,r):{}}function Fae(t){var e=yC.getInstance(),i=xae(Lq(),t),r=e.classNameFromKey(i);if(!r){var o=e.getClassName();e.insertRule("@font-face{".concat(i,"}"),!0),e.cacheClassName(o,i,[],["font-face",i])}}function Pm(t){var e=yC.getInstance(),i=[];for(var r in t)t.hasOwnProperty(r)&&i.push(r,"{",xae(Lq(),t[r]),"}");var o=i.join(""),l=e.classNameFromKey(o);if(l)return l;var d=e.getClassName();return e.insertRule("@keyframes ".concat(d,"{").concat(o,"}"),!0),e.cacheClassName(d,o,[],["keyframes",o]),d}function kZe(t){var e={},i=function(o){if(t.hasOwnProperty(o)){var l;Object.defineProperty(e,o,{get:function(){return l===void 0&&(l=It(t[o]).toString()),l},enumerable:!0,configurable:!0})}};for(var r in t)i(r);return e}function Uae(){return typeof window<"u"&&!!(window.document&&window.document.createElement)}var zae=void 0;try{zae=window}catch{}function Wc(t){if(!(!Uae()||typeof zae>"u")){var e=t;return e&&e.ownerDocument&&e.ownerDocument.defaultView?e.ownerDocument.defaultView:zae}}var YN=function(){function t(e,i){this._timeoutIds=null,this._immediateIds=null,this._intervalIds=null,this._animationFrameIds=null,this._isDisposed=!1,this._parent=e||null,this._onErrorHandler=i,this._noop=function(){}}return t.prototype.dispose=function(){var e;if(this._isDisposed=!0,this._parent=null,this._timeoutIds){for(e in this._timeoutIds)this._timeoutIds.hasOwnProperty(e)&&this.clearTimeout(parseInt(e,10));this._timeoutIds=null}if(this._immediateIds){for(e in this._immediateIds)this._immediateIds.hasOwnProperty(e)&&this.clearImmediate(parseInt(e,10));this._immediateIds=null}if(this._intervalIds){for(e in this._intervalIds)this._intervalIds.hasOwnProperty(e)&&this.clearInterval(parseInt(e,10));this._intervalIds=null}if(this._animationFrameIds){for(e in this._animationFrameIds)this._animationFrameIds.hasOwnProperty(e)&&this.cancelAnimationFrame(parseInt(e,10));this._animationFrameIds=null}},t.prototype.setTimeout=function(e,i){var r=this,o=0;return this._isDisposed||(this._timeoutIds||(this._timeoutIds={}),o=setTimeout(function(){try{r._timeoutIds&&delete r._timeoutIds[o],e.apply(r._parent)}catch(l){r._logError(l)}},i),this._timeoutIds[o]=!0),o},t.prototype.clearTimeout=function(e){this._timeoutIds&&this._timeoutIds[e]&&(clearTimeout(e),delete this._timeoutIds[e])},t.prototype.setImmediate=function(e,i){var r=this,o=0,l=Wc(i);if(!this._isDisposed){this._immediateIds||(this._immediateIds={});var d=function(){try{r._immediateIds&&delete r._immediateIds[o],e.apply(r._parent)}catch(h){r._logError(h)}};o=l.setTimeout(d,0),this._immediateIds[o]=!0}return o},t.prototype.clearImmediate=function(e,i){var r=Wc(i);this._immediateIds&&this._immediateIds[e]&&(r.clearTimeout(e),delete this._immediateIds[e])},t.prototype.setInterval=function(e,i){var r=this,o=0;return this._isDisposed||(this._intervalIds||(this._intervalIds={}),o=setInterval(function(){try{e.apply(r._parent)}catch(l){r._logError(l)}},i),this._intervalIds[o]=!0),o},t.prototype.clearInterval=function(e){this._intervalIds&&this._intervalIds[e]&&(clearInterval(e),delete this._intervalIds[e])},t.prototype.throttle=function(e,i,r){var o=this;if(this._isDisposed)return this._noop;var l=i||0,d=!0,h=!0,p=0,g,f,y=null;r&&typeof r.leading=="boolean"&&(d=r.leading),r&&typeof r.trailing=="boolean"&&(h=r.trailing);var T=function(E){var I=Date.now(),w=I-p,D=d?l-w:l;return w>=l&&(!E||d)?(p=I,y&&(o.clearTimeout(y),y=null),g=e.apply(o._parent,f)):y===null&&h&&(y=o.setTimeout(T,D)),g},C=function(){for(var E=[],I=0;I<arguments.length;I++)E[I]=arguments[I];return f=E,T(!0)};return C},t.prototype.debounce=function(e,i,r){var o=this;if(this._isDisposed){var l=function(){};return l.cancel=function(){},l.flush=function(){return null},l.pending=function(){return!1},l}var d=i||0,h=!1,p=!0,g=null,f=0,y=Date.now(),T,C,E=null;r&&typeof r.leading=="boolean"&&(h=r.leading),r&&typeof r.trailing=="boolean"&&(p=r.trailing),r&&typeof r.maxWait=="number"&&!isNaN(r.maxWait)&&(g=r.maxWait);var I=function(z){E&&(o.clearTimeout(E),E=null),y=z},w=function(z){I(z),T=e.apply(o._parent,C)},D=function(z){var H=Date.now(),j=!1;z&&(h&&H-f>=d&&(j=!0),f=H);var J=H-f,Z=d-J,re=H-y,ne=!1;return g!==null&&(re>=g&&E?ne=!0:Z=Math.min(Z,g-re)),J>=d||ne||j?w(H):(E===null||!z)&&p&&(E=o.setTimeout(D,Z)),T},F=function(){return!!E},x=function(){F()&&I(Date.now())},B=function(){return F()&&w(Date.now()),T},L=function(){for(var z=[],H=0;H<arguments.length;H++)z[H]=arguments[H];return C=z,D(!0)};return L.cancel=x,L.flush=B,L.pending=F,L},t.prototype.requestAnimationFrame=function(e,i){var r=this,o=0,l=Wc(i);if(!this._isDisposed){this._animationFrameIds||(this._animationFrameIds={});var d=function(){try{r._animationFrameIds&&delete r._animationFrameIds[o],e.apply(r._parent)}catch(h){r._logError(h)}};o=l.requestAnimationFrame?l.requestAnimationFrame(d):l.setTimeout(d,0),this._animationFrameIds[o]=!0}return o},t.prototype.cancelAnimationFrame=function(e,i){var r=Wc(i);this._animationFrameIds&&this._animationFrameIds[e]&&(r.cancelAnimationFrame?r.cancelAnimationFrame(e):r.clearTimeout(e),delete this._animationFrameIds[e])},t.prototype._logError=function(e){this._onErrorHandler&&this._onErrorHandler(e)},t}();function RZe(t){return t&&!!t._virtual}function MZe(t){var e;return t&&RZe(t)&&(e=t._virtual.parent),e}function Mw(t,e){var i,r;if(e===void 0&&(e=!0),!t)return null;var o=e&&MZe(t);return o||(typeof t.assignedElements!="function"&&(!((i=t.assignedSlot)===null||i===void 0)&&i.parentNode)?t.assignedSlot:((r=t.parentNode)===null||r===void 0?void 0:r.nodeType)===11?t.parentNode.host:t.parentNode)}function xy(t,e,i){i===void 0&&(i=!0);var r=!1;if(t&&e)if(i)if(t===e)r=!0;else for(r=!1;e;){var o=Mw(e);if(o===t){r=!0;break}e=o}else t.contains&&(r=t.contains(e));return r}function Vae(t,e,i){return i??(i=document),!t||t===i.body||t instanceof Document?null:e(t)?t:Vae(Mw(t),e)}function PZe(t,e,i){var r=Vae(t,function(o){return o.hasAttribute(e)},i);return r&&r.getAttribute(e)}var xq=function(t){for(var e=t.activeElement;e?.shadowRoot;)e=e.shadowRoot.activeElement;return e},h_e=function(t){var e=t.target;return e&&e.shadowRoot&&(e=t.composedPath()[0]),e},$ae="data-portal-element";function DZe(t){t.setAttribute($ae,"true")}function Hae(t,e,i){var r,o=Vae(t,function(l){var d;return e===l||!!(!((d=l.hasAttribute)===null||d===void 0)&&d.call(l,$ae))},i);return o!==null&&!!(!((r=o.hasAttribute)===null||r===void 0)&&r.call(o,$ae))}function LZe(t,e){var i=t,r=e;i._virtual||(i._virtual={children:[]});var o=i._virtual.parent;if(o&&o!==e){var l=o._virtual.children.indexOf(i);l>-1&&o._virtual.children.splice(l,1)}i._virtual.parent=r||void 0,r&&(r._virtual||(r._virtual={children:[]}),r._virtual.children.push(i))}function Gg(t){if(!(!Uae()||typeof document>"u")){var e=t;return e&&e.ownerDocument?e.ownerDocument:document}}var OZe="data-is-focusable",NZe="data-is-visible",xZe="data-focuszone-id",BZe="data-is-sub-focuszone";function p_e(t,e,i,r){return By(t,e,!0,!1,!1,i,void 0,void 0,void 0,r)}function g_e(t,e,i,r){return jS(t,e,!0,!1,!0,i,void 0,void 0,r)}function FZe(t,e,i,r,o){return By(t,e,r,!1,!1,i,!1,!0,void 0,o)}function UZe(t,e,i,r,o){return jS(t,e,r,!1,!0,i,!1,!0,o)}function zZe(t,e,i){var r=By(t,t,!0,!1,!1,!0,void 0,void 0,e,i);return r?(v_e(r),!0):!1}function jS(t,e,i,r,o,l,d,h,p){var g;if(!e||!d&&e===t)return null;var f=Bq(e);if(o&&f&&(l||!(SM(e)||jae(e)))){var y=e.lastElementChild||p&&((g=e.shadowRoot)===null||g===void 0?void 0:g.lastElementChild),T=jS(t,y,!0,!0,!0,l,d,h,p);if(T){if(h&&Pw(T,!0,p)||!h)return T;var C=jS(t,T.previousElementSibling,!0,!0,!0,l,d,h,p);if(C)return C;for(var E=T.parentElement;E&&E!==e;){var I=jS(t,E.previousElementSibling,!0,!0,!0,l,d,h,p);if(I)return I;E=E.parentElement}}}if(i&&f&&Pw(e,h,p))return e;var w=jS(t,e.previousElementSibling,!0,!0,!0,l,d,h,p);return w||(r?null:jS(t,e.parentElement,!0,!1,!1,l,d,h,p))}function By(t,e,i,r,o,l,d,h,p,g){var f;if(!e||e===t&&o&&!d)return null;var y=p?m_e:Bq,T=y(e);if(i&&T&&Pw(e,h,g))return e;if(!o&&T&&(l||!(SM(e)||jae(e)))){var C=e.firstElementChild||g&&((f=e.shadowRoot)===null||f===void 0?void 0:f.firstElementChild),E=By(t,C,!0,!0,!1,l,d,h,p,g);if(E)return E}if(e===t)return null;var I=By(t,e.nextElementSibling,!0,!0,!1,l,d,h,p,g);return I||(r?null:By(t,e.parentElement,!1,!1,!0,l,d,h,p,g))}function Bq(t){if(!t||!t.getAttribute)return!1;var e=t.getAttribute(NZe);return e!=null?e==="true":t.offsetHeight!==0||t.offsetParent!==null||t.isVisible===!0}function m_e(t,e){var i=e??Wc();return!!t&&Bq(t)&&!t.hidden&&i.getComputedStyle(t).visibility!=="hidden"}function Pw(t,e,i){if(i===void 0&&(i=!0),!t||t.disabled)return!1;var r=0,o=null;t&&t.getAttribute&&(o=t.getAttribute("tabIndex"),o&&(r=parseInt(o,10)));var l=t.getAttribute?t.getAttribute(OZe):null,d=o!==null&&r>=0,h=i&&t.shadowRoot?!!t.shadowRoot.delegatesFocus:!1,p=!!t&&l!=="false"&&(t.tagName==="A"||t.tagName==="BUTTON"||t.tagName==="INPUT"||t.tagName==="TEXTAREA"||t.tagName==="SELECT"||l==="true"||d||h);return e?r!==-1&&p:p}function SM(t){return!!(t&&t.getAttribute&&t.getAttribute(xZe))}function jae(t){return!!(t&&t.getAttribute&&t.getAttribute(BZe)==="true")}function VZe(t){var e=Gg(t),i=e&&e.activeElement;return!!(i&&xy(t,i))}function f_e(t,e,i){var r=Gg();return PZe(t,e,r)!=="true"}var Fq=void 0;function v_e(t){if(t){var e=Wc(t);e&&(Fq!==void 0&&e.cancelAnimationFrame(Fq),Fq=e.requestAnimationFrame(function(){t&&t.focus(),Fq=void 0}))}}function $Ze(t,e){for(var i=t,r=0,o=e;r<o.length;r++){var l=o[r],d=i.children[Math.min(l,i.children.length-1)];if(!d)break;i=d}return i=Pw(i)&&Bq(i)?i:By(t,i,!0)||jS(t,i),i}function HZe(t,e){for(var i=[];e&&t&&e!==t;){var r=Mw(e,!0);if(r===null)return[];i.unshift(Array.prototype.indexOf.call(r.children,e)),e=r}return i}function hE(t,e,i,r){return t.addEventListener(e,i,r),function(){return t.removeEventListener(e,i,r)}}function Gae(t,e){if(!t||!e)return!t&&!e;for(var i in t)if(t.hasOwnProperty(i)&&(!e.hasOwnProperty(i)||e[i]!==t[i]))return!1;for(var i in e)if(e.hasOwnProperty(i)&&!t.hasOwnProperty(i))return!1;return!0}function mL(t){for(var e=[],i=1;i<arguments.length;i++)e[i-1]=arguments[i];return jZe.apply(this,[null,t].concat(e))}function jZe(t,e){for(var i=[],r=2;r<arguments.length;r++)i[r-2]=arguments[r];e=e||{};for(var o=0,l=i;o<l.length;o++){var d=l[o];if(d)for(var h in d)d.hasOwnProperty(h)&&(!t||t(h))&&(e[h]=d[h])}return e}function GZe(t,e){var i={};for(var r in t)e.indexOf(r)===-1&&t.hasOwnProperty(r)&&(i[r]=t[r]);return i}var pE=function(){function t(e){this._id=t._uniqueId++,this._parent=e,this._eventRecords=[]}return t.raise=function(e,i,r,o,l){var d,h=l??Gg();if(t._isElement(e)){if(typeof h<"u"&&h.createEvent){var p=h.createEvent("HTMLEvents");p.initEvent(i,o||!1,!0),mL(p,r),d=e.dispatchEvent(p)}else if(typeof h<"u"&&h.createEventObject){var g=h.createEventObject(r);e.fireEvent("on"+i,g)}}else for(;e&&d!==!1;){var f=e.__events__,y=f?f[i]:null;if(y){for(var T in y)if(y.hasOwnProperty(T))for(var C=y[T],E=0;d!==!1&&E<C.length;E++){var I=C[E];I.objectCallback&&(d=I.objectCallback.call(I.parent,r))}}e=o?e.parent:null}return d},t.isObserved=function(e,i){var r=e&&e.__events__;return!!r&&!!r[i]},t.isDeclared=function(e,i){var r=e&&e.__declaredEvents;return!!r&&!!r[i]},t.stopPropagation=function(e){e.stopPropagation?e.stopPropagation():e.cancelBubble=!0},t._isElement=function(e){return!!e&&(!!e.addEventListener||typeof HTMLElement<"u"&&e instanceof HTMLElement)},t.prototype.dispose=function(){this._isDisposed||(this._isDisposed=!0,this.off(),this._parent=null)},t.prototype.onAll=function(e,i,r){for(var o in i)i.hasOwnProperty(o)&&this.on(e,o,i[o],r)},t.prototype.on=function(e,i,r,o){var l=this;if(i.indexOf(",")>-1)for(var d=i.split(/[ ,]+/),h=0;h<d.length;h++)this.on(e,d[h],r,o);else{var p=this._parent,g={target:e,eventName:i,parent:p,callback:r,options:o},d=e.__events__=e.__events__||{};if(d[i]=d[i]||{count:0},d[i][this._id]=d[i][this._id]||[],d[i][this._id].push(g),d[i].count++,t._isElement(e)){var f=function(){for(var C=[],E=0;E<arguments.length;E++)C[E]=arguments[E];if(!l._isDisposed){var I;try{if(I=r.apply(p,C),I===!1&&C[0]){var w=C[0];w.preventDefault&&w.preventDefault(),w.stopPropagation&&w.stopPropagation(),w.cancelBubble=!0}}catch{}return I}};g.elementCallback=f,e.addEventListener?e.addEventListener(i,f,o):e.attachEvent&&e.attachEvent("on"+i,f)}else{var y=function(){for(var C=[],E=0;E<arguments.length;E++)C[E]=arguments[E];if(!l._isDisposed)return r.apply(p,C)};g.objectCallback=y}this._eventRecords.push(g)}},t.prototype.off=function(e,i,r,o){for(var l=0;l<this._eventRecords.length;l++){var d=this._eventRecords[l];if((!e||e===d.target)&&(!i||i===d.eventName)&&(!r||r===d.callback)&&(typeof o!="boolean"||o===d.options)){var h=d.target.__events__,p=h[d.eventName],g=p?p[this._id]:null;g&&(g.length===1||!r?(p.count-=g.length,delete h[d.eventName][this._id]):(p.count--,g.splice(g.indexOf(d),1)),p.count||delete h[d.eventName]),d.elementCallback&&(d.target.removeEventListener?d.target.removeEventListener(d.eventName,d.elementCallback,d.options):d.target.detachEvent&&d.target.detachEvent("on"+d.eventName,d.elementCallback)),this._eventRecords.splice(l--,1)}}},t.prototype.raise=function(e,i,r){return t.raise(this._parent,e,i,r)},t.prototype.declare=function(e){var i=this._parent.__declaredEvents=this._parent.__declaredEvents||{};if(typeof e=="string")i[e]=!0;else for(var r=0;r<e.length;r++)i[e[r]]=!0},t._uniqueId=0,t}(),qae,z$=0,y_e=It({overflow:"hidden !important"}),S_e="data-is-scrollable",Wae=function(t,e){var i=Wc(t);if(!(!t||!i)){var r=0,o=null,l=i.getComputedStyle(t),d=function(p){p.targetTouches.length===1&&(r=p.targetTouches[0].clientY)},h=function(p){if(p.targetTouches.length===1&&(p.stopPropagation(),!!o)){var g=p.targetTouches[0].clientY-r,f=T_e(p.target);f&&o!==f&&(o=f,l=i.getComputedStyle(o));var y=o.scrollTop,T=l?.flexDirection==="column-reverse";y===0&&(T?g<0:g>0)&&p.preventDefault(),o.scrollHeight-Math.abs(Math.ceil(y))<=o.clientHeight&&(T?g>0:g<0)&&p.preventDefault()}};e.on(t,"touchstart",d,{passive:!1}),e.on(t,"touchmove",h,{passive:!1}),o=t}},Kae=function(t,e){if(t){var i=function(r){r.stopPropagation()};e.on(t,"touchmove",i,{passive:!1})}},b_e=function(t){t.preventDefault()};function qZe(){var t=Gg();t&&t.body&&!z$&&(t.body.classList.add(y_e),t.body.addEventListener("touchmove",b_e,{passive:!1,capture:!1})),z$++}function WZe(){if(z$>0){var t=Gg();t&&t.body&&z$===1&&(t.body.classList.remove(y_e),t.body.removeEventListener("touchmove",b_e)),z$--}}function KZe(t){if(qae===void 0){var e=Gg(),i=e.createElement("div");i.style.setProperty("width","100px"),i.style.setProperty("height","100px"),i.style.setProperty("overflow","scroll"),i.style.setProperty("position","absolute"),i.style.setProperty("top","-9999px"),e.body.appendChild(i),qae=i.offsetWidth-i.clientWidth,e.body.removeChild(i)}return qae}function T_e(t){for(var e=t,i=Gg(t);e&&e!==i.body;){if(e.getAttribute(S_e)==="true")return e;e=e.parentElement}for(e=t;e&&e!==i.body;){if(e.getAttribute(S_e)!=="false"){var r=getComputedStyle(e),o=r?r.getPropertyValue("overflow-y"):"";if(o&&(o==="scroll"||o==="auto"))return e}e=e.parentElement}return(!e||e===i.body)&&(e=Wc(t)),e}function SC(t){console&&console.warn&&console.warn(t)}function Jae(t,e,i,r,o){if(o===!0&&process.env.NODE_ENV!=="production")for(var l=0,d=i;l<d.length;l++){var h=d[l];h in e||SC("".concat(t," property '").concat(h,"' is required when '").concat(r,"' is used.'"))}}function Uq(t,e,i){if(process.env.NODE_ENV!=="production"){for(var r in i)if(e&&e[r]!==void 0){var o=i[r];o&&e[o]!==void 0&&SC("".concat(t," property '").concat(r,"' is mutually exclusive with '").concat(i[r],"'. ")+"Use one or the other.")}}}function fL(t,e,i){if(process.env.NODE_ENV!=="production"){for(var r in i)if(e&&r in e){var o="".concat(t," property '").concat(r,"' was used but has been deprecated."),l=i[r];l&&(o+=" Use '".concat(l,"' instead.")),SC(o)}}}(function(t){mu(e,t);function e(i,r){var o=t.call(this,i,r)||this;return JZe(o,e.prototype,["componentDidMount","shouldComponentUpdate","getSnapshotBeforeUpdate","render","componentDidUpdate","componentWillUnmount"]),o}return e.prototype.componentDidUpdate=function(i,r){this._updateComponentRef(i,this.props)},e.prototype.componentDidMount=function(){this._setComponentRef(this.props.componentRef,this)},e.prototype.componentWillUnmount=function(){if(this._setComponentRef(this.props.componentRef,null),this.__disposables){for(var i=0,r=this._disposables.length;i<r;i++){var o=this.__disposables[i];o.dispose&&o.dispose()}this.__disposables=null}},Object.defineProperty(e.prototype,"className",{get:function(){if(!this.__className){var i=/function (.{1,})\(/,r=i.exec(this.constructor.toString());this.__className=r&&r.length>1?r[1]:""}return this.__className},enumerable:!1,configurable:!0}),Object.defineProperty(e.prototype,"_disposables",{get:function(){return this.__disposables||(this.__disposables=[]),this.__disposables},enumerable:!1,configurable:!0}),Object.defineProperty(e.prototype,"_async",{get:function(){return this.__async||(this.__async=new YN(this),this._disposables.push(this.__async)),this.__async},enumerable:!1,configurable:!0}),Object.defineProperty(e.prototype,"_events",{get:function(){return this.__events||(this.__events=new pE(this),this._disposables.push(this.__events)),this.__events},enumerable:!1,configurable:!0}),e.prototype._resolveRef=function(i){var r=this;return this.__resolves||(this.__resolves={}),this.__resolves[i]||(this.__resolves[i]=function(o){return r[i]=o}),this.__resolves[i]},e.prototype._updateComponentRef=function(i,r){r===void 0&&(r={}),i&&r&&i.componentRef!==r.componentRef&&(this._setComponentRef(i.componentRef,null),this._setComponentRef(r.componentRef,this))},e.prototype._warnDeprecations=function(i){fL(this.className,this.props,i)},e.prototype._warnMutuallyExclusive=function(i){Uq(this.className,this.props,i)},e.prototype._warnConditionallyRequiredProps=function(i,r,o){Jae(this.className,this.props,i,r,o)},e.prototype._setComponentRef=function(i,r){!this._skipComponentRefResolution&&i&&(typeof i=="function"&&i(r),typeof i=="object"&&(i.current=r))},e})($.Component);function JZe(t,e,i){for(var r=0,o=i.length;r<o;r++)YZe(t,e,i[r])}function YZe(t,e,i){var r=t[i],o=e[i];(r||o)&&(t[i]=function(){for(var l=[],d=0;d<arguments.length;d++)l[d]=arguments[d];var h;return o&&(h=o.apply(this,l)),r!==o&&(h=r.apply(this,l)),h})}function QN(){return null}var Yae=function(t){mu(e,t);function e(i){var r=t.call(this,i)||this;return r.state={isRendered:Wc()===void 0},r}return e.prototype.componentDidMount=function(){var i=this,r=this.props.delay;this._timeoutId=window.setTimeout(function(){i.setState({isRendered:!0})},r)},e.prototype.componentWillUnmount=function(){this._timeoutId&&clearTimeout(this._timeoutId)},e.prototype.render=function(){return this.state.isRendered?$.Children.only(this.props.children):null},e.defaultProps={delay:0},e}($.Component),Qae="__globalSettings__",Zae="__callbacks__",QZe=0,C_e=function(){function t(){}return t.getValue=function(e,i){var r=Xae();return r[e]===void 0&&(r[e]=typeof i=="function"?i():i),r[e]},t.setValue=function(e,i){var r=Xae(),o=r[Zae],l=r[e];if(i!==l){r[e]=i;var d={oldValue:l,value:i,key:e};for(var h in o)o.hasOwnProperty(h)&&o[h](d)}return i},t.addChangeListener=function(e){var i=e.__id__,r=__e();i||(i=e.__id__=String(QZe++)),r[i]=e},t.removeChangeListener=function(e){var i=__e();delete i[e.__id__]},t}();function Xae(){var t,e=Wc(),i=e||{};return i[Qae]||(i[Qae]=(t={},t[Zae]={},t)),i[Qae]}function __e(){var t=Xae();return t[Zae]}var fa={tab:9,enter:13,alt:18,escape:27,space:32,pageUp:33,pageDown:34,end:35,home:36,left:37,up:38,right:39,down:40},gE=function(){function t(e,i,r,o){e===void 0&&(e=0),i===void 0&&(i=0),r===void 0&&(r=0),o===void 0&&(o=0),this.top=r,this.bottom=o,this.left=e,this.right=i}return Object.defineProperty(t.prototype,"width",{get:function(){return this.right-this.left},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"height",{get:function(){return this.bottom-this.top},enumerable:!1,configurable:!0}),t.prototype.equals=function(e){return parseFloat(this.top.toFixed(4))===parseFloat(e.top.toFixed(4))&&parseFloat(this.bottom.toFixed(4))===parseFloat(e.bottom.toFixed(4))&&parseFloat(this.left.toFixed(4))===parseFloat(e.left.toFixed(4))&&parseFloat(this.right.toFixed(4))===parseFloat(e.right.toFixed(4))},t}();function ZZe(t){for(var e=[],i=1;i<arguments.length;i++)e[i-1]=arguments[i];return e.length<2?e[0]:function(){for(var r=[],o=0;o<arguments.length;o++)r[o]=arguments[o];e.forEach(function(l){return l&&l.apply(t,r)})}}function FU(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];var i=t.filter(function(r){return r}).join(" ").trim();return i===""?void 0:i}function XZe(t,e,i){i===void 0&&(i=0);for(var r=-1,o=i;t&&o<t.length;o++)if(e(t[o],o)){r=o;break}return r}function eXe(t,e,i){var r=t.slice();return r.splice(e,0,i),r}function tXe(t,e){if(t.length!==e.length)return!1;for(var i=0;i<t.length;i++)if(t[i]!==e[i])return!1;return!0}function E_e(t){var e=null;try{var i=Wc();e=i?i.sessionStorage.getItem(t):null}catch{}return e}function iXe(t,e){var i;try{(i=Wc())===null||i===void 0||i.sessionStorage.setItem(t,e)}catch{}}var A_e="isRTL",bM;function Of(t){if(t===void 0&&(t={}),t.rtl!==void 0)return t.rtl;if(bM===void 0){var e=E_e(A_e);e!==null&&(bM=e==="1",nXe(bM));var i=Gg();bM===void 0&&i&&(bM=(i.body&&i.body.getAttribute("dir")||i.documentElement.getAttribute("dir"))==="rtl",QCe(bM))}return!!bM}function nXe(t,e){e===void 0&&(e=!1);var i=Gg();i&&i.documentElement.setAttribute("dir",t?"rtl":"ltr"),e&&iXe(A_e,t?"1":"0"),bM=t,QCe(bM)}var aXe=50,rXe=5,zq=0,ere=yC.getInstance();ere&&ere.onReset&&ere.onReset(function(){return zq++});var Vq="__retval__";function fu(t){t===void 0&&(t={});var e=new Map,i=0,r=0,o=zq,l=function(d,h){var p;if(h===void 0&&(h={}),t.useStaticStyles&&typeof d=="function"&&d.__noStyleOverride__)return d(h);r++;var g=d?d.__shadowConfig__:void 0,f=g&&g.window?g.window:"__default__";e.has(f)||e.set(f,new Map);var y=e.get(f),T=h.theme,C=T&&T.rtl!==void 0?T.rtl:Of(),E=t.disableCaching;if(o!==zq&&(o=zq,e.set(f,new Map),y=e.get(f),i=0),t.disableCaching||(y=I_e(e.get(f),d),y=I_e(y,h)),(E||!y[Vq])&&(d===void 0?y[Vq]={}:y[Vq]=Bae([typeof d=="function"?d(h):d],{shadowConfig:d.__shadowConfig__,rtl:!!C,specificityMultiplier:t.useStaticStyles?rXe:void 0}),E||i++),i>(t.cacheSize||aXe)){var I=Wc();!((p=I?.FabricConfig)===null||p===void 0)&&p.enableClassNameCacheFullWarning&&(console.warn("Styles are being recalculated too frequently. Cache miss rate is ".concat(i,"/").concat(r,".")),console.trace()),e.get(f).clear(),i=0,t.disableCaching=!0}return y[Vq]};return l}function tre(t,e){return e=oXe(e),t.has(e)||t.set(e,new Map),t.get(e)}function I_e(t,e){if(typeof e=="function"){var i=e.__cachedInputs__;if(i)for(var r=0,o=e.__cachedInputs__;r<o.length;r++){var l=o[r];t=tre(t,l)}else t=tre(t,e)}else if(typeof e=="object")for(var d in e)e.hasOwnProperty(d)&&(t=tre(t,e[d]));return t}function oXe(t){switch(t){case void 0:return"__undefined__";case null:return"__null__";default:return t}}var w_e=!1,$q=0,sXe={empty:!0},ire={},V$=typeof WeakMap>"u"?null:WeakMap;function lXe(){$q++}function ql(t,e,i){if(e===void 0&&(e=100),i===void 0&&(i=!1),!V$)return t;if(!w_e){var r=yC.getInstance();r&&r.onReset&&yC.getInstance().onReset(lXe),w_e=!0}var o,l=0,d=$q;return function(){for(var p=[],g=0;g<arguments.length;g++)p[g]=arguments[g];var f=o;(o===void 0||d!==$q||e>0&&l>e)&&(o=k_e(),l=0,d=$q),f=o;for(var y=0;y<p.length;y++){var T=cXe(p[y]);f.map.has(T)||f.map.set(T,k_e()),f=f.map.get(T)}return f.hasOwnProperty("value")||(f.value=t.apply(void 0,p),l++),i&&(f.value===null||f.value===void 0)&&(f.value=t.apply(void 0,p)),f.value}}function UU(t){if(!V$)return t;var e=new V$;function i(r){if(!r||typeof r!="function"&&typeof r!="object")return t(r);if(e.has(r))return e.get(r);var o=t(r);return e.set(r,o),o}return i}function cXe(t){if(t){if(typeof t=="object"||typeof t=="function")return t;ire[t]||(ire[t]={val:t})}else return sXe;return ire[t]}function k_e(){return{map:V$?new V$:null}}function dXe(t){var e=t,i=UU(function(r){if(t===r)throw new Error("Attempted to compose a component with itself.");var o=r,l=UU(function(h){var p=function(g){return $.createElement(o,Rt({},g,{defaultRender:h}))};return p}),d=function(h){var p=h.defaultRender;return $.createElement(e,Rt({},h,{defaultRender:p?l(p):o}))};return d});return i}var uXe=UU(dXe);function mE(t,e){return uXe(t)(e)}function nre(t,e){return t[e]!==void 0&&t[e]!==null}function wh(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];for(var i=[],r=0,o=t;r<o.length;r++){var l=o[r];if(l)if(typeof l=="string")i.push(l);else if(l.hasOwnProperty("toString")&&typeof l.toString=="function")i.push(l.toString());else for(var d in l)l[d]&&i.push(d)}return i.join(" ")}var hXe="customizations",pXe={settings:{},scopedSettings:{},inCustomizerContext:!1},vL=C_e.getValue(hXe,{settings:{},scopedSettings:{},inCustomizerContext:!1}),Hq=[],fE=function(){function t(){}return t.reset=function(){vL.settings={},vL.scopedSettings={}},t.applySettings=function(e){vL.settings=Rt(Rt({},vL.settings),e),t._raiseChange()},t.applyScopedSettings=function(e,i){vL.scopedSettings[e]=Rt(Rt({},vL.scopedSettings[e]),i),t._raiseChange()},t.getSettings=function(e,i,r){r===void 0&&(r=pXe);for(var o={},l=i&&r.scopedSettings[i]||{},d=i&&vL.scopedSettings[i]||{},h=0,p=e;h<p.length;h++){var g=p[h];o[g]=l[g]||r.settings[g]||d[g]||vL.settings[g]}return o},t.applyBatchedUpdates=function(e,i){t._suppressUpdates=!0;try{e()}catch{}t._suppressUpdates=!1,i||t._raiseChange()},t.observe=function(e){Hq.push(e)},t.unobserve=function(e){Hq=Hq.filter(function(i){return i!==e})},t._raiseChange=function(){t._suppressUpdates||Hq.forEach(function(e){return e()})},t}(),zU=$.createContext({customizations:{inCustomizerContext:!1,settings:{},scopedSettings:{}}});function gXe(t,e){t===void 0&&(t={});var i=R_e(e)?e:fXe(e);return i(t)}function mXe(t,e){t===void 0&&(t={});var i=R_e(e)?e:vXe(e);return i(t)}function R_e(t){return typeof t=="function"}function fXe(t){return function(e){return t?Rt(Rt({},e),t):e}}function vXe(t){return t===void 0&&(t={}),function(e){var i=Rt({},e);for(var r in t)t.hasOwnProperty(r)&&(i[r]=Rt(Rt({},e[r]),t[r]));return i}}function yXe(t,e){var i=(e||{}).customizations,r=i===void 0?{settings:{},scopedSettings:{}}:i;return{customizations:{settings:gXe(r.settings,t.settings),scopedSettings:mXe(r.scopedSettings,t.scopedSettings),inCustomizerContext:!0}}}var M_e=function(t){mu(e,t);function e(){var i=t!==null&&t.apply(this,arguments)||this;return i._onCustomizationChange=function(){return i.forceUpdate()},i}return e.prototype.componentDidMount=function(){fE.observe(this._onCustomizationChange)},e.prototype.componentWillUnmount=function(){fE.unobserve(this._onCustomizationChange)},e.prototype.render=function(){var i=this,r=this.props.contextTransform;return $.createElement(zU.Consumer,null,function(o){var l=yXe(i.props,o);return r&&(l=r(l)),$.createElement(zU.Provider,{value:l},i.props.children)})},e}($.Component);function SXe(t,e){for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i]);return e}var are=function(){return!1},bXe=function(){return JCe},TXe=function(){return new Map},rre=function(){},CXe=function(){return{stylesheets:new Map,useAdoptedStylesheetEx:are,useAdoptedStylesheet:are,useShadowConfig:bXe,useMergeStylesShadowRootContext:rre,useHasMergeStylesShadowRootContext:are,useMergeStylesRootStylesheets:TXe,useWindow:rre,useStyled:rre}},_Xe=$.createContext(CXe()),P_e=function(){var t=$.useContext(_Xe);return{useAdoptedStylesheet:t.useAdoptedStylesheet,useAdoptedStylesheetEx:t.useAdoptedStylesheetEx,useShadowConfig:t.useShadowConfig,useMergeStylesShadowRootContext:t.useMergeStylesShadowRootContext,useHasMergeStylesShadowRootContext:t.useHasMergeStylesShadowRootContext,useMergeStylesRootStylesheets:t.useMergeStylesRootStylesheets,useWindow:t.useWindow,useStyled:t.useStyled}},D_e=$.createContext(void 0),EXe=function(){return!!L_e()},L_e=function(){return $.useContext(D_e)},AXe=function(t){var e=t.stylesheetKey,i=t.children,r=P_e(),o=r.useAdoptedStylesheetEx,l=r.useMergeStylesRootStylesheets,d=r.useWindow,h=L_e(),p=l(),g=d();return o(Nae,h,p,g),o(e,h,p,g),i(!!h)},ZN=$.createContext({window:typeof window=="object"?window:void 0}),VU=function(){return $.useContext(ZN).window},O_e=function(){var t;return(t=$.useContext(ZN).window)===null||t===void 0?void 0:t.document},IXe=ql(lZe),wXe=ql(function(t,e,i){var r,o=(r=e??t)!==null&&r!==void 0?r:{};return o.__shadowConfig__=i,o});function $$(t,e,i){return function(o){var l,d=(l=function(h){mu(p,h);function p(g){var f=h.call(this,g)||this;return f._styleCache={},f._onSettingChanged=f._onSettingChanged.bind(f),f}return p.prototype.componentDidMount=function(){fE.observe(this._onSettingChanged)},p.prototype.componentWillUnmount=function(){fE.unobserve(this._onSettingChanged)},p.prototype.render=function(){var g=this;return $.createElement(AXe,{stylesheetKey:t},function(f){return $.createElement(zU.Consumer,null,function(y){var T,C=fE.getSettings(e,t,y.customizations),E=(T=g.context.window)!==null&&T!==void 0?T:Wc(),I=IXe(t,f,E),w=g.props;if(C.styles&&typeof C.styles=="function"&&(C.styles=C.styles(Rt(Rt({},C),w))),C.styles){if(g._styleCache.default!==C.styles||g._styleCache.component!==w.styles){var D=Ds(C.styles,w.styles);D.__shadowConfig__=I,g._styleCache.default=C.styles,g._styleCache.component=w.styles,g._styleCache.merged=D}return $.createElement(o,Rt({},C,w,{styles:g._styleCache.merged}))}var F=wXe(C.styles,w.styles,I);return $.createElement(o,Rt({},C,w,{styles:F}))})})},p.prototype._onSettingChanged=function(){this.forceUpdate()},p}($.Component),l.displayName="Customized"+t,l.contextType=ZN,l);return SXe(o,d)}}function N_e(t,e){var i=kXe(),r=$.useContext(zU).customizations,o=r.inCustomizerContext;return $.useEffect(function(){return o||fE.observe(i),function(){o||fE.unobserve(i)}},[o]),fE.getSettings(t,e,r)}function kXe(){var t=$.useState(0),e=t[1];return function(){return e(function(i){return++i})}}function x_e(t,e){for(var i in e)e.hasOwnProperty(i)&&(t[i]=ZZe(t,t[i],e[i]))}var jq="__currentId__",RXe="id__",Gq=Wc()||{};Gq[jq]===void 0&&(Gq[jq]=0);var B_e=!1;function bp(t){if(!B_e){var e=yC.getInstance();e&&e.onReset&&e.onReset(MXe),B_e=!0}var i=Gq[jq]++;return(t===void 0?RXe:t)+i}function MXe(t){t===void 0&&(t=0),Gq[jq]=t}var Tp=function(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];for(var i={},r=0,o=t;r<o.length;r++)for(var l=o[r],d=Array.isArray(l)?l:Object.keys(l),h=0,p=d;h<p.length;h++){var g=p[h];i[g]=1}return i},PXe=Tp(["onCopy","onCut","onPaste","onCompositionEnd","onCompositionStart","onCompositionUpdate","onFocus","onFocusCapture","onBlur","onBlurCapture","onChange","onInput","onSubmit","onLoad","onError","onKeyDown","onKeyDownCapture","onKeyPress","onKeyUp","onAbort","onCanPlay","onCanPlayThrough","onDurationChange","onEmptied","onEncrypted","onEnded","onLoadedData","onLoadedMetadata","onLoadStart","onPause","onPlay","onPlaying","onProgress","onRateChange","onSeeked","onSeeking","onStalled","onSuspend","onTimeUpdate","onVolumeChange","onWaiting","onClick","onClickCapture","onContextMenu","onDoubleClick","onDrag","onDragEnd","onDragEnter","onDragExit","onDragLeave","onDragOver","onDragStart","onDrop","onMouseDown","onMouseDownCapture","onMouseEnter","onMouseLeave","onMouseMove","onMouseOut","onMouseOver","onMouseUp","onMouseUpCapture","onSelect","onTouchCancel","onTouchEnd","onTouchMove","onTouchStart","onScroll","onWheel","onPointerCancel","onPointerDown","onPointerEnter","onPointerLeave","onPointerMove","onPointerOut","onPointerOver","onPointerUp","onGotPointerCapture","onLostPointerCapture"]),DXe=Tp(["accessKey","children","className","contentEditable","dir","draggable","hidden","htmlFor","id","lang","ref","role","style","tabIndex","title","translate","spellCheck","name"]),Lu=Tp(DXe,PXe),LXe=Tp(Lu,["form"]),F_e=Tp(Lu,["height","loop","muted","preload","src","width"]),OXe=Tp(F_e,["poster"]),NXe=Tp(Lu,["start"]),xXe=Tp(Lu,["value"]),ore=Tp(Lu,["download","href","hrefLang","media","rel","target","type"]),yL=Tp(Lu,["autoFocus","disabled","form","formAction","formEncType","formMethod","formNoValidate","formTarget","type","value"]),sre=Tp(yL,["accept","alt","autoCapitalize","autoComplete","checked","dirname","form","height","inputMode","list","max","maxLength","min","minLength","multiple","pattern","placeholder","readOnly","required","src","step","size","type","value","width"]),U_e=Tp(yL,["autoCapitalize","cols","dirname","form","maxLength","minLength","placeholder","readOnly","required","rows","wrap"]),BXe=Tp(yL,["form","multiple","required"]),FXe=Tp(Lu,["selected","value"]),UXe=Tp(Lu,["cellPadding","cellSpacing"]),zXe=Lu,VXe=Tp(Lu,["rowSpan","scope"]),$Xe=Tp(Lu,["colSpan","headers","rowSpan","scope"]),HXe=Tp(Lu,["span"]),jXe=Tp(Lu,["span"]),GXe=Tp(Lu,["acceptCharset","action","encType","encType","method","noValidate","target"]),qXe=Tp(Lu,["allow","allowFullScreen","allowPaymentRequest","allowTransparency","csp","height","importance","referrerPolicy","sandbox","src","srcDoc","width"]),z_e=Tp(Lu,["alt","crossOrigin","height","src","srcSet","useMap","width"]),Nf=Lu;function Wl(t,e,i){for(var r=Array.isArray(e),o={},l=Object.keys(t),d=0,h=l;d<h.length;d++){var p=h[d],g=!r&&e[p]||r&&e.indexOf(p)>=0||p.indexOf("data-")===0||p.indexOf("aria-")===0;g&&(!i||i?.indexOf(p)===-1)&&(o[p]=t[p])}return o}var WXe={label:LXe,audio:F_e,video:OXe,ol:NXe,li:xXe,a:ore,button:yL,input:sre,textarea:U_e,select:BXe,option:FXe,table:UXe,tr:zXe,th:VXe,td:$Xe,colGroup:HXe,col:jXe,form:GXe,iframe:qXe,img:z_e};function KXe(t,e,i){var r=t&&WXe[t]||Lu;return Wl(e,r,i)}function Dw(t){x_e(t,{componentDidMount:JXe,componentDidUpdate:YXe,componentWillUnmount:QXe})}function JXe(){qq(this.props.componentRef,this)}function YXe(t){t.componentRef!==this.props.componentRef&&(qq(t.componentRef,null),qq(this.props.componentRef,this))}function QXe(){qq(this.props.componentRef,null)}function qq(t,e){t&&(typeof t=="object"?t.current=e:typeof t=="function"&&t(e))}var cA,ZXe=(cA={},cA[fa.up]=1,cA[fa.down]=1,cA[fa.left]=1,cA[fa.right]=1,cA[fa.home]=1,cA[fa.end]=1,cA[fa.tab]=1,cA[fa.pageUp]=1,cA[fa.pageDown]=1,cA);function V_e(t){return!!ZXe[t]}var ys="ms-Fabric--isFocusVisible",$_e="ms-Fabric--isFocusHidden";function H_e(t,e){t&&(t.classList.add(e?ys:$_e),t.classList.remove(e?$_e:ys))}function XN(t,e,i){var r;i?i.forEach(function(o){return H_e(o.current,t)}):H_e((r=Wc(e))===null||r===void 0?void 0:r.document.body,t)}var j_e=new WeakMap,G_e=new WeakMap;function q_e(t,e){var i,r=j_e.get(t);return r?i=r+e:i=1,j_e.set(t,i),i}function XXe(t){var e=G_e.get(t);if(e)return e;var i=function(d){return K_e(d,t.registeredProviders)},r=function(d){return J_e(d,t.registeredProviders)},o=function(d){return Y_e(d,t.registeredProviders)},l=function(d){return Q_e(d,t.registeredProviders)};return e={onMouseDown:i,onPointerDown:r,onKeyDown:o,onKeyUp:l},G_e.set(t,e),e}var H$=$.createContext(void 0);function j$(t){var e=$.useContext(H$);$.useEffect(function(){var i,r,o,l,d=Wc(t?.current);if(!(!d||((i=d.FabricConfig)===null||i===void 0?void 0:i.disableFocusRects)===!0)){var h=d,p,g,f,y;if(!((r=e?.providerRef)===null||r===void 0)&&r.current&&(!((l=(o=e?.providerRef)===null||o===void 0?void 0:o.current)===null||l===void 0)&&l.addEventListener)){h=e.providerRef.current;var T=XXe(e);p=T.onMouseDown,g=T.onPointerDown,f=T.onKeyDown,y=T.onKeyUp}else p=K_e,g=J_e,f=Y_e,y=Q_e;var C=q_e(h,1);return C<=1&&(h.addEventListener("mousedown",p,!0),h.addEventListener("pointerdown",g,!0),h.addEventListener("keydown",f,!0),h.addEventListener("keyup",y,!0)),function(){var E;!d||((E=d.FabricConfig)===null||E===void 0?void 0:E.disableFocusRects)===!0||(C=q_e(h,-1),C===0&&(h.removeEventListener("mousedown",p,!0),h.removeEventListener("pointerdown",g,!0),h.removeEventListener("keydown",f,!0),h.removeEventListener("keyup",y,!0)))}}},[e,t])}var W_e=function(t){return j$(t.rootRef),null};function K_e(t,e){XN(!1,t.target,e)}function J_e(t,e){t.pointerType!=="mouse"&&XN(!1,t.target,e)}function Y_e(t,e){V_e(t.which)&&XN(!0,t.target,e)}function Q_e(t,e){V_e(t.which)&&XN(!0,t.target,e)}var lre=function(t){var e=t.providerRef,i=t.layerRoot,r=$.useState([])[0],o=$.useContext(H$),l=o!==void 0&&!i,d=$.useMemo(function(){return l?void 0:{providerRef:e,registeredProviders:r,registerProvider:function(h){r.push(h),o?.registerProvider(h)},unregisterProvider:function(h){o?.unregisterProvider(h);var p=r.indexOf(h);p>=0&&r.splice(p,1)}}},[e,r,o,l]);return $.useEffect(function(){if(d)return d.registerProvider(d.providerRef),function(){return d.unregisterProvider(d.providerRef)}},[d]),d?$.createElement(H$.Provider,{value:d},t.children):$.createElement($.Fragment,null,t.children)},eet=/[\(\[\{\<][^\)\]\}\>]*[\)\]\}\>]/g,tet=/[\0-\u001F\!-/:-@\[-`\{-\u00BF\u0250-\u036F\uD800-\uFFFF]/g,iet=/^\d+[\d\s]*(:?ext|x|)\s*\d+$/i,net=/\s+/g,aet=/[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\u1100-\u11FF\u3130-\u318F\uA960-\uA97F\uAC00-\uD7AF\uD7B0-\uD7FF\u3040-\u309F\u30A0-\u30FF\u3400-\u4DBF\u4E00-\u9FFF\uF900-\uFAFF]|[\uD840-\uD869][\uDC00-\uDED6]/;function ret(t,e){var i="",r=t.split(" ");return r.length===2?(i+=r[0].charAt(0).toUpperCase(),i+=r[1].charAt(0).toUpperCase()):r.length===3?(i+=r[0].charAt(0).toUpperCase(),i+=r[2].charAt(0).toUpperCase()):r.length!==0&&(i+=r[0].charAt(0).toUpperCase()),e&&i.length>1?i.charAt(1)+i.charAt(0):i}function oet(t){return t=t.replace(eet,""),t=t.replace(tet,""),t=t.replace(net," "),t=t.trim(),t}function set(t,e,i){return!t||(t=oet(t),aet.test(t)||!i&&iet.test(t))?"":ret(t,e)}function cet(t){var e=null;try{var i=Wc();e=i?i.localStorage.getItem(t):null}catch{}return e}var ex,Z_e="language";function det(t){if(t===void 0&&(t="sessionStorage"),ex===void 0){var e=Gg(),i=t==="localStorage"?cet(Z_e):t==="sessionStorage"?E_e(Z_e):void 0;i&&(ex=i),ex===void 0&&e&&(ex=e.documentElement.getAttribute("lang")),ex===void 0&&(ex="en")}return ex}function $U(t){for(var e=[],i=1;i<arguments.length;i++)e[i-1]=arguments[i];for(var r=0,o=e;r<o.length;r++){var l=o[r];X_e(t||{},l)}return t}function X_e(t,e,i){i===void 0&&(i=[]),i.push(e);for(var r in e)if(e.hasOwnProperty(r)&&r!=="__proto__"&&r!=="constructor"&&r!=="prototype"){var o=e[r];if(typeof o=="object"&&o!==null&&!Array.isArray(o)){var l=i.indexOf(o)>-1;t[r]=l?o:X_e(t[r]||{},o,i)}else t[r]=o}return i.pop(),t}var Wq=function(){return!window||!window.navigator||!window.navigator.userAgent?!1:/iPad|iPhone|iPod/i.test(window.navigator.userAgent)},uet=["TEMPLATE","STYLE","SCRIPT"];function eEe(t){var e=Gg(t);if(!e)return function(){};for(var i=[];t!==e.body&&t.parentElement;){for(var r=0,o=t.parentElement.children;r<o.length;r++){var l=o[r],d=l.getAttribute("aria-hidden");l!==t&&d?.toLowerCase()!=="true"&&uet.indexOf(l.tagName)===-1&&i.push([l,d])}t=t.parentElement}return i.forEach(function(h){var p=h[0];p.setAttribute("aria-hidden","true")}),function(){het(i),i=[]}}function het(t){t.forEach(function(e){var i=e[0],r=e[1];r?i.setAttribute("aria-hidden",r):i.removeAttribute("aria-hidden")})}var cre;function dre(t){var e;if(typeof cre>"u"||t){var i=Wc(),r=(e=i?.navigator)===null||e===void 0?void 0:e.userAgent;cre=!!r&&r.indexOf("Macintosh")!==-1}return!!cre}function pet(t){return t.clientWidth<t.scrollWidth}function get(t){return t.clientHeight<t.scrollHeight}function met(t){return pet(t)||get(t)}function fet(t){var e=UU(function(i){var r=UU(function(o){return function(l){return i(l,o)}});return function(o,l){return t(o,l?r(l):i)}});return e}var vet=UU(fet);function yet(t,e){return vet(t)(e)}var bet=function(t){var e;return function(i){e||(e=new Set,x_e(t,{componentWillUnmount:function(){e.forEach(function(o){return cancelAnimationFrame(o)})}}));var r=requestAnimationFrame(function(){e.delete(r),i()});e.add(r)}},Tet=/[\{\}]/g,Cet=/\{\d+\}/g;function _et(t){for(var e=[],i=1;i<arguments.length;i++)e[i-1]=arguments[i];var r=e;function o(l){var d=r[l.replace(Tet,"")];return d==null&&(d=""),d}return t.replace(Cet,o)}var Eet=["theme","styles"];function vu(t,e,i,r,o){r=r||{scope:"",fields:void 0};var l=r.scope,d=r.fields,h=d===void 0?Eet:d,p=$.forwardRef(function(f,y){var T=$.useRef(),C=N_e(h,l),E=C.styles;C.dir;var I=Mm(C,["styles","dir"]),w=i?i(f):void 0,D=P_e().useStyled,F=T.current&&T.current.__cachedInputs__||[],x=f.styles;if(!T.current||E!==F[1]||x!==F[2]){var B=function(L){return u_e(L,e,E,x)};B.__cachedInputs__=[e,E,x],B.__noStyleOverride__=!E&&!x,T.current=B}return T.current.__shadowConfig__=D(l),$.createElement(t,Rt({ref:y},I,w,f,{styles:T.current}))});p.displayName="Styled".concat(t.displayName||t.name);var g=o?$.memo(p):p;return p.displayName&&(g.displayName=p.displayName),g}var tx;process.env.NODE_ENV!=="production"&&(tx={valueOnChange:{},valueDefaultValue:{},controlledToUncontrolled:{},uncontrolledToControlled:{}});function tEe(t){if(process.env.NODE_ENV!=="production"){var e=t.componentId,i=t.componentName,r=t.defaultValueProp,o=t.props,l=t.oldProps,d=t.onChangeProp,h=t.readOnlyProp,p=t.valueProp,g=l?nre(l,p):void 0,f=nre(o,p);if(f){var y=!!o[d],T=!!(h&&o[h]);!(y||T)&&!tx.valueOnChange[e]&&(tx.valueOnChange[e]=!0,SC("Warning: You provided a '".concat(String(p),"' prop to a ").concat(String(i)," without an '").concat(String(d),"' handler. ")+"This will render a read-only field. If the field should be mutable use '".concat(String(r),"'. ")+"Otherwise, set '".concat(String(d),"'").concat(h?" or '".concat(String(h),"'"):"",".")));var C=o[r];C!=null&&!tx.valueDefaultValue[e]&&(tx.valueDefaultValue[e]=!0,SC("Warning: You provided both '".concat(String(p),"' and '").concat(String(r),"' to a ").concat(i,". ")+"Form fields must be either controlled or uncontrolled (specify either the '".concat(String(p),"' prop, ")+"or the '".concat(String(r),"' prop, but not both). Decide between using a controlled or uncontrolled ")+"".concat(i," and remove one of these props. More info: https://fb.me/react-controlled-components")))}if(l&&f!==g){var E=g?"a controlled":"an uncontrolled",I=g?"uncontrolled":"controlled",w=g?tx.controlledToUncontrolled:tx.uncontrolledToControlled;w[e]||(w[e]=!0,SC("Warning: A component is changing ".concat(E," ").concat(i," to be ").concat(I,". ")+"".concat(i,"s should not switch from controlled to uncontrolled (or vice versa). ")+"Decide between using controlled or uncontrolled for the lifetime of the component. More info: https://fb.me/react-controlled-components"))}}}var Aet=function(){var t,e=Wc();return!((t=e?.navigator)===null||t===void 0)&&t.userAgent?e.navigator.userAgent.indexOf("rv:11.0")>-1:!1};function Lw(t,e){for(var i=Rt({},e),r=0,o=Object.keys(t);r<o.length;r++){var l=o[r];i[l]===void 0&&(i[l]=t[l])}return i}var Iet=function(t){return function(e){for(var i=0,r=t.refs;i<r.length;i++){var o=r[i];typeof o=="function"?o(e):o&&(o.current=e)}}},iEe=function(t){var e={refs:[]};return function(){for(var i=[],r=0;r<arguments.length;r++)i[r]=arguments[r];return(!e.resolver||!tXe(e.refs,i))&&(e.resolver=Iet(e)),e.refs=i,e.resolver}},ix=Uae()?$.useLayoutEffect:$.useEffect,wet="icons",bC=C_e.getValue(wet,{__options:{disableWarnings:!1,warnOnMissingIcons:!0},__remapped:{}}),ure=yC.getInstance();ure&&ure.onReset&&ure.onReset(function(){for(var t in bC)bC.hasOwnProperty(t)&&bC[t].subset&&(bC[t].subset.className=void 0)});var Kq=function(t){return t.toLowerCase()};function qg(t,e){var i=Rt(Rt({},t),{isRegistered:!1,className:void 0}),r=t.icons;e=e?Rt(Rt({},bC.__options),e):bC.__options;for(var o in r)if(r.hasOwnProperty(o)){var l=r[o],d=Kq(o);bC[d]?Ret(o):bC[d]={code:l,subset:i}}}function nx(t,e){bC.__remapped[Kq(t)]=Kq(e)}function ket(t){var e=void 0,i=bC.__options;if(t=t?Kq(t):"",t=bC.__remapped[t]||t,t)if(e=bC[t],e){var r=e.subset;r&&r.fontFace&&(r.isRegistered||(Fae(r.fontFace),r.isRegistered=!0),r.className||(r.className=It(r.style,{fontFamily:r.fontFace.fontFamily,fontWeight:r.fontFace.fontWeight||"normal",fontStyle:r.fontFace.fontStyle||"normal"})))}else!i.disableWarnings&&i.warnOnMissingIcons&&SC('The icon "'.concat(t,'" was used but not registered. See https://github.com/microsoft/fluentui/wiki/Using-icons for more information.'));return e}var G$=[],hre=void 0;function Ret(t){var e=bC.__options,i=2e3,r=10;e.disableWarnings||(G$.push(t),hre===void 0&&(hre=setTimeout(function(){SC(`Some icons were re-registered. Applications should only call registerIcons for any given icon once. Redefining what an icon is may have unintended consequences. Duplicates include: 
`+G$.slice(0,r).join(", ")+(G$.length>r?" (+ ".concat(G$.length-r," more)"):"")),hre=void 0,G$=[]},i)))}function Met(t,e,i,r,o){o===void 0&&(o=!1);var l=Rt({primaryButtonBorder:"transparent",errorText:r?"#F1707B":"#a4262c",messageText:r?"#F3F2F1":"#323130",messageLink:r?"#6CB8F6":"#005A9E",messageLinkHovered:r?"#82C7FF":"#004578",infoIcon:r?"#C8C6C4":"#605e5c",errorIcon:r?"#F1707B":"#A80000",blockingIcon:r?"#442726":"#FDE7E9",warningIcon:r?"#C8C6C4":"#797775",severeWarningIcon:r?"#FCE100":"#D83B01",successIcon:r?"#92C353":"#107C10",infoBackground:r?"#323130":"#f3f2f1",errorBackground:r?"#442726":"#FDE7E9",blockingBackground:r?"#442726":"#FDE7E9",warningBackground:r?"#433519":"#FFF4CE",severeWarningBackground:r?"#4F2A0F":"#FED9CC",successBackground:r?"#393D1B":"#DFF6DD",warningHighlight:r?"#fff100":"#ffb900",successText:r?"#92c353":"#107C10"},i),d=nEe(t,e,l,r);return Pet(d,o)}function nEe(t,e,i,r,o){var l={},d=t||{},h=d.white,p=d.black,g=d.themePrimary,f=d.themeDark,y=d.themeDarker,T=d.themeDarkAlt,C=d.themeLighter,E=d.neutralLight,I=d.neutralLighter,w=d.neutralDark,D=d.neutralQuaternary,F=d.neutralQuaternaryAlt,x=d.neutralPrimary,B=d.neutralSecondary,L=d.neutralSecondaryAlt,z=d.neutralTertiary,H=d.neutralTertiaryAlt,j=d.neutralLighterAlt,J=d.accent;return h&&(l.bodyBackground=h,l.bodyFrameBackground=h,l.accentButtonText=h,l.buttonBackground=h,l.primaryButtonText=h,l.primaryButtonTextHovered=h,l.primaryButtonTextPressed=h,l.inputBackground=h,l.inputForegroundChecked=h,l.listBackground=h,l.menuBackground=h,l.cardStandoutBackground=h),p&&(l.bodyTextChecked=p,l.buttonTextCheckedHovered=p),g&&(l.link=g,l.primaryButtonBackground=g,l.inputBackgroundChecked=g,l.inputIcon=g,l.inputFocusBorderAlt=g,l.menuIcon=g,l.menuHeader=g,l.accentButtonBackground=g),f&&(l.primaryButtonBackgroundPressed=f,l.inputBackgroundCheckedHovered=f,l.inputIconHovered=f),y&&(l.linkHovered=y),T&&(l.primaryButtonBackgroundHovered=T),C&&(l.inputPlaceholderBackgroundChecked=C),E&&(l.bodyBackgroundChecked=E,l.bodyFrameDivider=E,l.bodyDivider=E,l.variantBorder=E,l.buttonBackgroundCheckedHovered=E,l.buttonBackgroundPressed=E,l.listItemBackgroundChecked=E,l.listHeaderBackgroundPressed=E,l.menuItemBackgroundPressed=E,l.menuItemBackgroundChecked=E),I&&(l.bodyBackgroundHovered=I,l.buttonBackgroundHovered=I,l.buttonBackgroundDisabled=I,l.buttonBorderDisabled=I,l.primaryButtonBackgroundDisabled=I,l.disabledBackground=I,l.listItemBackgroundHovered=I,l.listHeaderBackgroundHovered=I,l.menuItemBackgroundHovered=I),D&&(l.primaryButtonTextDisabled=D,l.disabledSubtext=D),F&&(l.listItemBackgroundCheckedHovered=F),z&&(l.disabledBodyText=z,l.variantBorderHovered=i?.variantBorderHovered||z,l.buttonTextDisabled=z,l.inputIconDisabled=z,l.disabledText=z),x&&(l.bodyText=x,l.actionLink=x,l.buttonText=x,l.inputBorderHovered=x,l.inputText=x,l.listText=x,l.menuItemText=x),j&&(l.bodyStandoutBackground=j,l.defaultStateBackground=j),w&&(l.actionLinkHovered=w,l.buttonTextHovered=w,l.buttonTextChecked=w,l.buttonTextPressed=w,l.inputTextHovered=w,l.menuItemTextHovered=w),B&&(l.bodySubtext=B,l.focusBorder=B,l.inputBorder=B,l.smallInputBorder=B,l.inputPlaceholderText=B),L&&(l.buttonBorder=L),H&&(l.disabledBodySubtext=H,l.disabledBorder=H,l.buttonBackgroundChecked=H,l.menuDivider=H),J&&(l.accentButtonBackground=J),e?.elevation4&&(l.cardShadow=e.elevation4),!r&&e?.elevation8?l.cardShadowHovered=e.elevation8:l.variantBorderHovered&&(l.cardShadowHovered="0 0 1px "+l.variantBorderHovered),l=Rt(Rt({},l),i),l}function Pet(t,e){var i="";return e===!0&&(i=" /* @deprecated */"),t.listTextColor=t.listText+i,t.menuItemBackgroundChecked+=i,t.warningHighlight+=i,t.warningText=t.messageText+i,t.successText+=i,t}function q$(t,e){var i,r,o;e===void 0&&(e={});var l=$U({},t,e,{semanticColors:nEe(e.palette,e.effects,e.semanticColors,e.isInverted===void 0?t.isInverted:e.isInverted)});if(!((i=e.palette)===null||i===void 0)&&i.themePrimary&&!(!((r=e.palette)===null||r===void 0)&&r.accent)&&(l.palette.accent=e.palette.themePrimary),e.defaultFontStyle)for(var d=0,h=Object.keys(l.fonts);d<h.length;d++){var p=h[d];l.fonts[p]=$U(l.fonts[p],e.defaultFontStyle,(o=e?.fonts)===null||o===void 0?void 0:o[p])}return l}var TM={themeDarker:"#004578",themeDark:"#005a9e",themeDarkAlt:"#106ebe",themePrimary:"#0078d4",themeSecondary:"#2b88d8",themeTertiary:"#71afe5",themeLight:"#c7e0f4",themeLighter:"#deecf9",themeLighterAlt:"#eff6fc",black:"#000000",blackTranslucent40:"rgba(0,0,0,.4)",neutralDark:"#201f1e",neutralPrimary:"#323130",neutralPrimaryAlt:"#3b3a39",neutralSecondary:"#605e5c",neutralSecondaryAlt:"#8a8886",neutralTertiary:"#a19f9d",neutralTertiaryAlt:"#c8c6c4",neutralQuaternary:"#d2d0ce",neutralQuaternaryAlt:"#e1dfdd",neutralLight:"#edebe9",neutralLighter:"#f3f2f1",neutralLighterAlt:"#faf9f8",accent:"#0078d4",white:"#ffffff",whiteTranslucent40:"rgba(255,255,255,.4)",yellowDark:"#d29200",yellow:"#ffb900",yellowLight:"#fff100",orange:"#d83b01",orangeLight:"#ea4300",orangeLighter:"#ff8c00",redDark:"#a4262c",red:"#e81123",magentaDark:"#5c005c",magenta:"#b4009e",magentaLight:"#e3008c",purpleDark:"#32145a",purple:"#5c2d91",purpleLight:"#b4a0ff",blueDark:"#002050",blueMid:"#00188f",blue:"#0078d4",blueLight:"#00bcf2",tealDark:"#004b50",teal:"#008272",tealLight:"#00b294",greenDark:"#004b1c",green:"#107c10",greenLight:"#bad80a"},HU;(function(t){t.depth0="0 0 0 0 transparent",t.depth4="0 1.6px 3.6px 0 rgba(0, 0, 0, 0.132), 0 0.3px 0.9px 0 rgba(0, 0, 0, 0.108)",t.depth8="0 3.2px 7.2px 0 rgba(0, 0, 0, 0.132), 0 0.6px 1.8px 0 rgba(0, 0, 0, 0.108)",t.depth16="0 6.4px 14.4px 0 rgba(0, 0, 0, 0.132), 0 1.2px 3.6px 0 rgba(0, 0, 0, 0.108)",t.depth64="0 25.6px 57.6px 0 rgba(0, 0, 0, 0.22), 0 4.8px 14.4px 0 rgba(0, 0, 0, 0.18)"})(HU||(HU={}));var aEe={elevation4:HU.depth4,elevation8:HU.depth8,elevation16:HU.depth16,elevation64:HU.depth64,roundedCorner2:"2px",roundedCorner4:"4px",roundedCorner6:"6px"},Det={s2:"4px",s1:"8px",m:"16px",l1:"20px",l2:"32px"},Ou="cubic-bezier(.1,.9,.2,1)",TC="cubic-bezier(.1,.25,.75,.9)",Jq="0.167s",pre="0.267s",Rd="0.367s",rEe="0.467s",xf=Pm({from:{opacity:0},to:{opacity:1}}),Bf=Pm({from:{opacity:1},to:{opacity:0,visibility:"hidden"}}),Let=bL(-10),Oet=bL(-20),Net=bL(-40),xet=bL(-400),Bet=bL(10),Fet=bL(20),Uet=bL(40),zet=bL(400),Vet=Yq(10),$et=Yq(20),Het=Yq(-10),jet=Yq(-20),Get=TL(10),qet=TL(20),Wet=TL(40),Ket=TL(400),Jet=TL(-10),Yet=TL(-20),Qet=TL(-40),Zet=TL(-400),Xet=Qq(-10),ett=Qq(-20),ttt=Qq(10),itt=Qq(20),ntt=Pm({from:{transform:"scale3d(.98,.98,1)"},to:{transform:"scale3d(1,1,1)"}}),att=Pm({from:{transform:"scale3d(1,1,1)"},to:{transform:"scale3d(.98,.98,1)"}}),rtt=Pm({from:{transform:"scale3d(1.03,1.03,1)"},to:{transform:"scale3d(1,1,1)"}}),ott=Pm({from:{transform:"scale3d(1,1,1)"},to:{transform:"scale3d(1.03,1.03,1)"}}),stt=Pm({from:{transform:"rotateZ(0deg)"},to:{transform:"rotateZ(90deg)"}}),ltt=Pm({from:{transform:"rotateZ(0deg)"},to:{transform:"rotateZ(-90deg)"}}),SL={easeFunction2:TC,durationValue2:pre,durationValue3:Rd},gre={slideRightIn10:xl("".concat(xf,",").concat(Let),Rd,Ou),slideRightIn20:xl("".concat(xf,",").concat(Oet),Rd,Ou),slideRightIn40:xl("".concat(xf,",").concat(Net),Rd,Ou),slideRightIn400:xl("".concat(xf,",").concat(xet),Rd,Ou),slideLeftIn10:xl("".concat(xf,",").concat(Bet),Rd,Ou),slideLeftIn20:xl("".concat(xf,",").concat(Fet),Rd,Ou),slideLeftIn40:xl("".concat(xf,",").concat(Uet),Rd,Ou),slideLeftIn400:xl("".concat(xf,",").concat(zet),Rd,Ou),slideUpIn10:xl("".concat(xf,",").concat(Vet),Rd,Ou),slideUpIn20:xl("".concat(xf,",").concat($et),Rd,Ou),slideDownIn10:xl("".concat(xf,",").concat(Het),Rd,Ou),slideDownIn20:xl("".concat(xf,",").concat(jet),Rd,Ou),slideRightOut10:xl("".concat(Bf,",").concat(Get),Rd,Ou),slideRightOut20:xl("".concat(Bf,",").concat(qet),Rd,Ou),slideRightOut40:xl("".concat(Bf,",").concat(Wet),Rd,Ou),slideRightOut400:xl("".concat(Bf,",").concat(Ket),Rd,Ou),slideLeftOut10:xl("".concat(Bf,",").concat(Jet),Rd,Ou),slideLeftOut20:xl("".concat(Bf,",").concat(Yet),Rd,Ou),slideLeftOut40:xl("".concat(Bf,",").concat(Qet),Rd,Ou),slideLeftOut400:xl("".concat(Bf,",").concat(Zet),Rd,Ou),slideUpOut10:xl("".concat(Bf,",").concat(Xet),Rd,Ou),slideUpOut20:xl("".concat(Bf,",").concat(ett),Rd,Ou),slideDownOut10:xl("".concat(Bf,",").concat(ttt),Rd,Ou),slideDownOut20:xl("".concat(Bf,",").concat(itt),Rd,Ou),scaleUpIn100:xl("".concat(xf,",").concat(ntt),Rd,Ou),scaleDownIn100:xl("".concat(xf,",").concat(rtt),Rd,Ou),scaleUpOut103:xl("".concat(Bf,",").concat(ott),Jq,TC),scaleDownOut98:xl("".concat(Bf,",").concat(att),Jq,TC),fadeIn100:xl(xf,Jq,TC),fadeIn200:xl(xf,pre,TC),fadeIn400:xl(xf,Rd,TC),fadeIn500:xl(xf,rEe,TC),fadeOut100:xl(Bf,Jq,TC),fadeOut200:xl(Bf,pre,TC),fadeOut400:xl(Bf,Rd,TC),fadeOut500:xl(Bf,rEe,TC),rotate90deg:xl(stt,"0.1s",TC),rotateN90deg:xl(ltt,"0.1s",TC)};function xl(t,e,i){return{animationName:t,animationDuration:e,animationTimingFunction:i,animationFillMode:"both"}}function bL(t){return Pm({from:{transform:"translate3d(".concat(t,"px,0,0)"),pointerEvents:"none"},to:{transform:"translate3d(0,0,0)",pointerEvents:"auto"}})}function Yq(t){return Pm({from:{transform:"translate3d(0,".concat(t,"px,0)"),pointerEvents:"none"},to:{transform:"translate3d(0,0,0)",pointerEvents:"auto"}})}function TL(t){return Pm({from:{transform:"translate3d(0,0,0)"},to:{transform:"translate3d(".concat(t,"px,0,0)")}})}function Qq(t){return Pm({from:{transform:"translate3d(0,0,0)"},to:{transform:"translate3d(0,".concat(t,"px,0)")}})}var Vh;(function(t){t.Arabic="Segoe UI Web (Arabic)",t.Cyrillic="Segoe UI Web (Cyrillic)",t.EastEuropean="Segoe UI Web (East European)",t.Greek="Segoe UI Web (Greek)",t.Hebrew="Segoe UI Web (Hebrew)",t.Thai="Leelawadee UI Web",t.Vietnamese="Segoe UI Web (Vietnamese)",t.WestEuropean="Segoe UI Web (West European)",t.Selawik="Selawik Web",t.Armenian="Segoe UI Web (Armenian)",t.Georgian="Segoe UI Web (Georgian)"})(Vh||(Vh={}));var Md;(function(t){t.Arabic="'".concat(Vh.Arabic,"'"),t.ChineseSimplified="'Microsoft Yahei UI', Verdana, Simsun",t.ChineseTraditional="'Microsoft Jhenghei UI', Pmingliu",t.Cyrillic="'".concat(Vh.Cyrillic,"'"),t.EastEuropean="'".concat(Vh.EastEuropean,"'"),t.Greek="'".concat(Vh.Greek,"'"),t.Hebrew="'".concat(Vh.Hebrew,"'"),t.Hindi="'Nirmala UI'",t.Japanese="'Yu Gothic UI', 'Meiryo UI', Meiryo, 'MS Pgothic', Osaka",t.Korean="'Malgun Gothic', Gulim",t.Selawik="'".concat(Vh.Selawik,"'"),t.Thai="'Leelawadee UI Web', 'Kmer UI'",t.Vietnamese="'".concat(Vh.Vietnamese,"'"),t.WestEuropean="'".concat(Vh.WestEuropean,"'"),t.Armenian="'".concat(Vh.Armenian,"'"),t.Georgian="'".concat(Vh.Georgian,"'")})(Md||(Md={}));var GS;(function(t){t.size10="10px",t.size12="12px",t.size14="14px",t.size16="16px",t.size18="18px",t.size20="20px",t.size24="24px",t.size28="28px",t.size32="32px",t.size42="42px",t.size68="68px",t.mini="10px",t.xSmall="10px",t.small="12px",t.smallPlus="12px",t.medium="14px",t.mediumPlus="16px",t.icon="16px",t.large="18px",t.xLarge="20px",t.xLargePlus="24px",t.xxLarge="28px",t.xxLargePlus="32px",t.superLarge="42px",t.mega="68px"})(GS||(GS={}));var xs;(function(t){t.light=100,t.semilight=300,t.regular=400,t.semibold=600,t.bold=700})(xs||(xs={}));var CC;(function(t){t.xSmall="10px",t.small="12px",t.medium="16px",t.large="20px"})(CC||(CC={}));var ctt="'Segoe UI', -apple-system, BlinkMacSystemFont, 'Roboto', 'Helvetica Neue', sans-serif",dtt="'Segoe UI', '".concat(Vh.WestEuropean,"'"),mre={ar:Md.Arabic,bg:Md.Cyrillic,cs:Md.EastEuropean,el:Md.Greek,et:Md.EastEuropean,he:Md.Hebrew,hi:Md.Hindi,hr:Md.EastEuropean,hu:Md.EastEuropean,ja:Md.Japanese,kk:Md.EastEuropean,ko:Md.Korean,lt:Md.EastEuropean,lv:Md.EastEuropean,pl:Md.EastEuropean,ru:Md.Cyrillic,sk:Md.EastEuropean,"sr-latn":Md.EastEuropean,th:Md.Thai,tr:Md.EastEuropean,uk:Md.Cyrillic,vi:Md.Vietnamese,"zh-hans":Md.ChineseSimplified,"zh-hant":Md.ChineseTraditional,hy:Md.Armenian,ka:Md.Georgian};function utt(t){return"".concat(t,", ").concat(ctt)}function htt(t){for(var e in mre)if(mre.hasOwnProperty(e)&&t&&e.indexOf(t)===0)return mre[e];return dtt}function _C(t,e,i){return{fontFamily:i,MozOsxFontSmoothing:"grayscale",WebkitFontSmoothing:"antialiased",fontSize:t,fontWeight:e}}function ptt(t){var e=htt(t),i=utt(e),r={tiny:_C(GS.mini,xs.regular,i),xSmall:_C(GS.xSmall,xs.regular,i),small:_C(GS.small,xs.regular,i),smallPlus:_C(GS.smallPlus,xs.regular,i),medium:_C(GS.medium,xs.regular,i),mediumPlus:_C(GS.mediumPlus,xs.regular,i),large:_C(GS.large,xs.regular,i),xLarge:_C(GS.xLarge,xs.semibold,i),xLargePlus:_C(GS.xLargePlus,xs.semibold,i),xxLarge:_C(GS.xxLarge,xs.semibold,i),xxLargePlus:_C(GS.xxLargePlus,xs.semibold,i),superLarge:_C(GS.superLarge,xs.semibold,i),mega:_C(GS.mega,xs.semibold,i)};return r}var gtt="https://res-1.cdn.office.net/files/fabric-cdn-prod_20230815.002/assets",mtt=ptt(det());function ax(t,e,i,r){t="'".concat(t,"'");var o=r!==void 0?"local('".concat(r,"'),"):"";Fae({fontFamily:t,src:o+"url('".concat(e,".woff2') format('woff2'),")+"url('".concat(e,".woff') format('woff')"),fontWeight:i,fontStyle:"normal",fontDisplay:"swap"})}function dA(t,e,i,r,o){r===void 0&&(r="segoeui");var l="".concat(t,"/").concat(i,"/").concat(r);ax(e,l+"-light",xs.light,o&&o+" Light"),ax(e,l+"-semilight",xs.semilight,o&&o+" SemiLight"),ax(e,l+"-regular",xs.regular,o),ax(e,l+"-semibold",xs.semibold,o&&o+" SemiBold"),ax(e,l+"-bold",xs.bold,o&&o+" Bold")}function ftt(t){if(t){var e="".concat(t,"/fonts");dA(e,Vh.Thai,"leelawadeeui-thai","leelawadeeui"),dA(e,Vh.Arabic,"segoeui-arabic"),dA(e,Vh.Cyrillic,"segoeui-cyrillic"),dA(e,Vh.EastEuropean,"segoeui-easteuropean"),dA(e,Vh.Greek,"segoeui-greek"),dA(e,Vh.Hebrew,"segoeui-hebrew"),dA(e,Vh.Vietnamese,"segoeui-vietnamese"),dA(e,Vh.WestEuropean,"segoeui-westeuropean","segoeui","Segoe UI"),dA(e,Md.Selawik,"selawik","selawik"),dA(e,Vh.Armenian,"segoeui-armenian"),dA(e,Vh.Georgian,"segoeui-georgian"),ax("Leelawadee UI Web","".concat(e,"/leelawadeeui-thai/leelawadeeui-semilight"),xs.light),ax("Leelawadee UI Web","".concat(e,"/leelawadeeui-thai/leelawadeeui-bold"),xs.semibold)}}function vtt(){var t,e,i=(t=Wc())===null||t===void 0?void 0:t.FabricConfig;return(e=i?.fontBaseUrl)!==null&&e!==void 0?e:gtt}ftt(vtt());function rx(t,e){t===void 0&&(t={}),e===void 0&&(e=!1);var i=!!t.isInverted,r={palette:TM,effects:aEe,fonts:mtt,spacing:Det,isInverted:i,disableGlobalClassNames:!1,semanticColors:Met(TM,aEe,void 0,i,e),rtl:void 0};return q$(r,t)}var Rn="@media screen and (-ms-high-contrast: active), screen and (forced-colors: active)",oEe="@media screen and (-ms-high-contrast: black-on-white), screen and (forced-colors: active) and (prefers-color-scheme: light)",jU=480,sEe=640,ytt=1024,fre=1366,Stt=jU-1,lEe=sEe-1,btt=768;function Zq(t,e){var i=" and (min-width: ".concat(t,"px)"),r=typeof e=="number"?" and (max-width: ".concat(e,"px)"):"";return"@media only screen".concat(i).concat(r)}function uc(){return{forcedColorAdjust:"none",MsHighContrastAdjust:"none"}}var ox;(function(t){t.Nav=1,t.ScrollablePane=1,t.FocusStyle=1,t.Coachmark=1e3,t.Layer=1e6,t.KeytipLayer=1000001})(ox||(ox={}));function vE(t,e,i,r,o,l,d,h){return typeof e=="number"||!e?cEe(t,{inset:e,position:i,highContrastStyle:r,borderColor:o,outlineColor:l,isFocusedOnly:d,borderRadius:h}):cEe(t,e)}function cEe(t,e){var i,r;e===void 0&&(e={});var o=e.borderRadius,l=e.inset,d=l===void 0?0:l,h=e.width,p=h===void 0?1:h,g=e.position,f=g===void 0?"relative":g,y=e.highContrastStyle,T=e.borderColor,C=T===void 0?t.palette.white:T,E=e.outlineColor,I=E===void 0?t.palette.neutralSecondary:E,w=e.isFocusedOnly,D=w===void 0?!0:w,F=e.pointerEvents;return{outline:"transparent",position:f,selectors:(i={"::-moz-focus-inner":{border:"0"}},i[".".concat(ys," &").concat(D?":focus":"",":after, :host(.").concat(ys,") &").concat(D?":focus":"",":after")]={content:'""',position:"absolute",pointerEvents:F,left:d+1,top:d+1,bottom:d+1,right:d+1,border:"".concat(p,"px solid ").concat(C),outline:"".concat(p,"px solid ").concat(I),zIndex:ox.FocusStyle,borderRadius:o,selectors:(r={},r[Rn]=y,r)},i)}}function Ttt(){return{selectors:{"&::-moz-focus-inner":{border:0},"&":{outline:"transparent"}}}}var dEe=function(t,e,i,r){var o,l,d;i===void 0&&(i="border"),r===void 0&&(r=-1);var h=i==="borderBottom";return{borderColor:t,selectors:{":after":(o={pointerEvents:"none",content:"''",position:"absolute",left:h?0:r,top:r,bottom:r,right:h?0:r},o[i]="2px solid ".concat(t),o.borderRadius=e,o.width=i==="borderBottom"?"100%":void 0,o.selectors=(l={},l[Rn]=(d={},d[i==="border"?"borderColor":"borderBottomColor"]="Highlight",d),l),o)}}},W$={position:"absolute",width:1,height:1,margin:-1,padding:0,border:0,overflow:"hidden",whiteSpace:"nowrap"},Ctt=ql(function(t,e){var i=yC.getInstance();return e?Object.keys(t).reduce(function(r,o){return r[o]=i.getClassName(t[o]),r},{}):t});function eh(t,e,i){return Ctt(t,e.disableGlobalClassNames)}var GU=function(){return GU=Object.assign||function(t){for(var e,i=1,r=arguments.length;i<r;i++){e=arguments[i];for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o])}return t},GU.apply(this,arguments)},K$=typeof window>"u"?global:window,uEe=K$&&K$.CSPSettings&&K$.CSPSettings.nonce,uA=_tt();function _tt(){var t=K$.__themeState__||{theme:void 0,lastStyleElement:void 0,registeredStyles:[]};return t.runState||(t=GU(GU({},t),{perf:{count:0,duration:0},runState:{flushTimer:0,mode:0,buffer:[]}})),t.registeredThemableStyles||(t=GU(GU({},t),{registeredThemableStyles:[]})),K$.__themeState__=t,t}function Ett(t,e){uA.loadStyles?uA.loadStyles(hEe(t).styleString,t):Rtt(t)}function Att(t){uA.theme=t,ktt()}function Itt(t){wtt(uA.registeredThemableStyles),uA.registeredThemableStyles=[]}function wtt(t){t.forEach(function(e){var i=e&&e.styleElement;i&&i.parentElement&&i.parentElement.removeChild(i)})}function ktt(){if(uA.theme){for(var t=[],e=0,i=uA.registeredThemableStyles;e<i.length;e++){var r=i[e];t.push(r.themableStyle)}t.length>0&&(Itt(),Ett([].concat.apply([],t)))}}function hEe(t){var e=uA.theme,i=!1,r=(t||[]).map(function(o){var l=o.theme;if(l){i=!0;var d=e?e[l]:void 0,h=o.defaultValue||"inherit";return e&&!d&&console&&!(l in e)&&typeof DEBUG<"u"&&DEBUG&&console.warn('Theming value not provided for "'.concat(l,'". Falling back to "').concat(h,'".')),d||h}else return o.rawString});return{styleString:r.join(""),themable:i}}function Rtt(t){if(!(typeof document>"u")){var e=document.getElementsByTagName("head")[0],i=document.createElement("style"),r=hEe(t),o=r.styleString,l=r.themable;i.setAttribute("data-load-themed-styles","true"),uEe&&i.setAttribute("nonce",uEe),i.appendChild(document.createTextNode(o)),uA.perf.count++,e.appendChild(i);var d=document.createEvent("HTMLEvents");d.initEvent("styleinsert",!0,!1),d.args={newStyle:i},document.dispatchEvent(d);var h={styleElement:i,themableStyle:t};l?uA.registeredThemableStyles.push(h):uA.registeredStyles.push(h)}}var yE=rx({}),Mtt=[],vre="theme";function pEe(){var t,e,i,r=Wc();!((e=r?.FabricConfig)===null||e===void 0)&&e.legacyTheme?Ptt(r.FabricConfig.legacyTheme):fE.getSettings([vre]).theme||(!((i=r?.FabricConfig)===null||i===void 0)&&i.theme&&(yE=rx(r.FabricConfig.theme)),fE.applySettings((t={},t[vre]=yE,t)))}pEe();function gEe(t){return t===void 0&&(t=!1),t===!0&&(yE=rx({},t)),yE}function Ptt(t,e){var i;return e===void 0&&(e=!1),yE=rx(t,e),Att(Rt(Rt(Rt(Rt({},yE.palette),yE.semanticColors),yE.effects),Dtt(yE))),fE.applySettings((i={},i[vre]=yE,i)),Mtt.forEach(function(r){try{r(yE)}catch{}}),yE}function Dtt(t){for(var e={},i=0,r=Object.keys(t.fonts);i<r.length;i++)for(var o=r[i],l=t.fonts[o],d=0,h=Object.keys(l);d<h.length;d++){var p=h[d],g=o+p.charAt(0).toUpperCase()+p.slice(1),f=l[p];p==="fontSize"&&typeof f=="number"&&(f=f+"px"),e[g]=f}return e}var sx={boxShadow:"none",margin:0,padding:0,boxSizing:"border-box"},J$={overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"};function mEe(t){return{selectors:{"::placeholder":t,":-ms-input-placeholder":t,"::-ms-input-placeholder":t}}}var EC=kZe(gre),Ltt="https://res.cdn.office.net/files/fabric-cdn-prod_20250411.001";Oae("@fluentui/style-utilities","8.12.0"),pEe();var hd={topLeftEdge:0,topCenter:1,topRightEdge:2,topAutoEdge:3,bottomLeftEdge:4,bottomCenter:5,bottomRightEdge:6,bottomAutoEdge:7,leftTopEdge:8,leftCenter:9,leftBottomEdge:10,rightTopEdge:11,rightCenter:12,rightBottomEdge:13},so;(function(t){t[t.top=1]="top",t[t.bottom=-1]="bottom",t[t.left=2]="left",t[t.right=-2]="right"})(so||(so={}));var fEe;(function(t){t[t.top=0]="top",t[t.bottom=1]="bottom",t[t.start=2]="start",t[t.end=3]="end"})(fEe||(fEe={}));var Fy;function rT(t,e,i){return{targetEdge:t,alignmentEdge:e,isAuto:i}}var vEe=(Fy={},Fy[hd.topLeftEdge]=rT(so.top,so.left),Fy[hd.topCenter]=rT(so.top),Fy[hd.topRightEdge]=rT(so.top,so.right),Fy[hd.topAutoEdge]=rT(so.top,void 0,!0),Fy[hd.bottomLeftEdge]=rT(so.bottom,so.left),Fy[hd.bottomCenter]=rT(so.bottom),Fy[hd.bottomRightEdge]=rT(so.bottom,so.right),Fy[hd.bottomAutoEdge]=rT(so.bottom,void 0,!0),Fy[hd.leftTopEdge]=rT(so.left,so.top),Fy[hd.leftCenter]=rT(so.left),Fy[hd.leftBottomEdge]=rT(so.left,so.bottom),Fy[hd.rightTopEdge]=rT(so.right,so.top),Fy[hd.rightCenter]=rT(so.right),Fy[hd.rightBottomEdge]=rT(so.right,so.bottom),Fy);function yre(t,e){return!(t.top<e.top||t.bottom>e.bottom||t.left<e.left||t.right>e.right)}function Xq(t,e){var i=[];return t.top<e.top&&i.push(so.top),t.bottom>e.bottom&&i.push(so.bottom),t.left<e.left&&i.push(so.left),t.right>e.right&&i.push(so.right),i}function Uy(t,e){return t[so[e]]}function yEe(t,e,i){return t[so[e]]=i,t}function Y$(t,e){var i=WU(e);return(Uy(t,i.positiveEdge)+Uy(t,i.negativeEdge))/2}function eW(t,e){return t>0?e:e*-1}function Sre(t,e){return eW(t,Uy(e,t))}function Ow(t,e,i){var r=Uy(t,i)-Uy(e,i);return eW(i,r)}function qU(t,e,i,r){r===void 0&&(r=!0);var o=Uy(t,e)-i,l=yEe(t,e,i);return r&&(l=yEe(t,e*-1,Uy(t,e*-1)-o)),l}function Q$(t,e,i,r){return r===void 0&&(r=0),qU(t,i,Uy(e,i)+eW(i,r))}function Ott(t,e,i,r){r===void 0&&(r=0);var o=i*-1,l=eW(o,r);return qU(t,i*-1,Uy(e,i)+l)}function tW(t,e,i){var r=Sre(i,t);return r>Sre(i,e)}function Ntt(t,e){for(var i=Xq(t,e),r=0,o=0,l=i;o<l.length;o++){var d=l[o];r+=Math.pow(Ow(t,e,d),2)}return r}function xtt(t,e,i,r){return r===void 0&&(r=200),i!==so.bottom&&i!==so.top?!1:Ow(t,e,i)>=r}function Btt(t,e,i,r,o,l,d){o===void 0&&(o=!1),d===void 0&&(d=0);var h=[so.left,so.right,so.bottom,so.top];Of()&&(h[0]*=-1,h[1]*=-1);for(var p=t,g=r.targetEdge,f=r.alignmentEdge,y,T=g,C=f,E=0;E<4;E++){if(tW(p,i,g))return{elementRectangle:p,targetEdge:g,alignmentEdge:f};if(o&&xtt(e,i,g,l)){switch(g){case so.bottom:p.bottom=i.bottom;break;case so.top:p.top=i.top;break}return{elementRectangle:p,targetEdge:g,alignmentEdge:f,forcedInBounds:!0}}else{var I=Ntt(p,i);(!y||I<y)&&(y=I,T=g,C=f),h.splice(h.indexOf(g),1),h.length>0&&(h.indexOf(g*-1)>-1?g=g*-1:(f=g,g=h.slice(-1)[0]),p=iW(t,e,{targetEdge:g,alignmentEdge:f},d))}}return p=iW(t,e,{targetEdge:T,alignmentEdge:C},d),{elementRectangle:p,targetEdge:T,alignmentEdge:C}}function Ftt(t,e,i,r){var o=t.alignmentEdge,l=t.targetEdge,d=t.elementRectangle,h=o*-1,p=iW(d,e,{targetEdge:l,alignmentEdge:h},i,r);return{elementRectangle:p,targetEdge:l,alignmentEdge:h}}function Utt(t,e,i,r,o,l,d,h,p){o===void 0&&(o=!1),d===void 0&&(d=0);var g=r.alignmentEdge,f=r.alignTargetEdge,y={elementRectangle:t,targetEdge:r.targetEdge,alignmentEdge:g};!h&&!p&&(y=Btt(t,e,i,r,o,l,d));var T=Xq(y.elementRectangle,i),C=h?-y.targetEdge:void 0;if(T.length>0)if(f)if(y.alignmentEdge&&T.indexOf(y.alignmentEdge*-1)>-1){var E=Ftt(y,e,d,p);if(yre(E.elementRectangle,i))return E;y=bre(Xq(E.elementRectangle,i),y,i,C)}else y=bre(T,y,i,C);else y=bre(T,y,i,C);return y}function bre(t,e,i,r){for(var o=0,l=t;o<l.length;o++){var d=l[o],h=void 0;if(r&&r===d*-1)h=qU(e.elementRectangle,d,Uy(i,d),!1),e.forcedInBounds=!0;else{h=Q$(e.elementRectangle,i,d);var p=tW(h,i,d*-1);p||(h=qU(h,d*-1,Uy(i,d*-1),!1),e.forcedInBounds=!0)}e.elementRectangle=h}return e}function SEe(t,e,i){var r=WU(e).positiveEdge,o=Y$(t,e),l=o-Uy(t,r);return qU(t,r,i-l)}function iW(t,e,i,r,o){r===void 0&&(r=0);var l=new gE(t.left,t.right,t.top,t.bottom),d=i.alignmentEdge,h=i.targetEdge,p=o?h:h*-1;if(l=o?Q$(l,e,h,r):Ott(l,e,h,r),d)l=Q$(l,e,d);else{var g=Y$(e,h);l=SEe(l,p,g)}return l}function WU(t){return t===so.top||t===so.bottom?{positiveEdge:so.left,negativeEdge:so.right}:{positiveEdge:so.top,negativeEdge:so.bottom}}function bEe(t,e,i){return i&&Math.abs(Ow(t,i,e))>Math.abs(Ow(t,i,e*-1))?e*-1:e}function ztt(t,e,i){return i!==void 0&&Uy(t,e)===Uy(i,e)}function Vtt(t,e,i,r,o,l,d,h){var p={},g=nW(e),f=l?i:i*-1,y=o||WU(i).positiveEdge;return(!d||ztt(t,iit(y),r))&&(y=bEe(t,y,r)),p[so[f]]=Ow(t,g,f),p[so[y]]=Ow(t,g,y),h&&(p[so[f*-1]]=Ow(t,g,f*-1),p[so[y*-1]]=Ow(t,g,y*-1)),p}function $tt(t){return Math.sqrt(t*t*2)}function Htt(t,e,i){if(t===void 0&&(t=hd.bottomAutoEdge),i)return{alignmentEdge:i.alignmentEdge,isAuto:i.isAuto,targetEdge:i.targetEdge};var r=Rt({},vEe[t]);return Of()?(r.alignmentEdge&&r.alignmentEdge%2===0&&(r.alignmentEdge=r.alignmentEdge*-1),e!==void 0?vEe[e]:r):r}function jtt(t,e,i,r,o){return t.isAuto&&(t.alignmentEdge=TEe(t.targetEdge,e,i)),t.alignTargetEdge=o,t}function TEe(t,e,i){var r=Y$(e,t),o=Y$(i,t),l=WU(t),d=l.positiveEdge,h=l.negativeEdge;return r<=o?d:h}function Gtt(t,e,i,r,o,l,d,h,p){l===void 0&&(l=!1);var g=iW(t,e,r,o,p);return yre(g,i)?{elementRectangle:g,targetEdge:r.targetEdge,alignmentEdge:r.alignmentEdge}:Utt(g,e,i,r,l,d,o,h,p)}function qtt(t,e,i){var r=t.targetEdge*-1,o=new gE(0,t.elementRectangle.width,0,t.elementRectangle.height),l={},d=bEe(t.elementRectangle,t.alignmentEdge?t.alignmentEdge:WU(r).positiveEdge,i),h=Ow(t.elementRectangle,t.targetRectangle,r),p=h>Math.abs(Uy(e,r));return l[so[r]]=Uy(e,r),l[so[d]]=Ow(e,o,d),{elementPosition:Rt({},l),closestEdge:TEe(t.targetEdge,e,o),targetEdge:r,hideBeak:!p}}function Wtt(t,e){var i=e.targetRectangle,r=WU(e.targetEdge),o=r.positiveEdge,l=r.negativeEdge,d=Y$(i,e.targetEdge),h=new gE(t/2,e.elementRectangle.width-t/2,t/2,e.elementRectangle.height-t/2),p=new gE(0,t,0,t);return p=qU(p,e.targetEdge*-1,-t/2),p=SEe(p,e.targetEdge*-1,d-Sre(o,e.elementRectangle)),tW(p,h,o)?tW(p,h,l)||(p=Q$(p,h,l)):p=Q$(p,h,o),p}function nW(t){var e=t.getBoundingClientRect();return new gE(e.left,e.right,e.top,e.bottom)}function Ktt(t){return new gE(t.left,t.right,t.top,t.bottom)}function Jtt(t,e){var i;if(e){if(e.preventDefault){var r=e;i=new gE(r.clientX,r.clientX,r.clientY,r.clientY)}else if(e.getBoundingClientRect)i=nW(e);else{var o=e,l=o.left||o.x,d=o.top||o.y,h=o.right||l,p=o.bottom||d;i=new gE(l,h,d,p)}if(!yre(i,t))for(var g=Xq(i,t),f=0,y=g;f<y.length;f++){var T=y[f];i[so[T]]=t[so[T]]}}else i=new gE(0,0,0,0);return i}function Ytt(t,e,i,r,o,l){o===void 0&&(o=!1);var d=t.gapSpace?t.gapSpace:0,h=Jtt(i,t.target),p=jtt(Htt(t.directionalHint,t.directionalHintForRTL,r),h,i,t.coverTarget,t.alignTargetEdge),g=Gtt(nW(e),h,i,p,d,o,l,t.directionalHintFixed,t.coverTarget);return Rt(Rt({},g),{targetRectangle:h})}function Qtt(t,e,i,r,o){var l=Vtt(t.elementRectangle,e,t.targetEdge,i,t.alignmentEdge,r,o,t.forcedInBounds);return{elementPosition:l,targetEdge:t.targetEdge,alignmentEdge:t.alignmentEdge}}function CEe(t,e,i){return e===void 0&&(e=0),i===void 0&&(i=0),$tt(t?e:0)/2+i}function _Ee(t,e,i,r,o,l,d,h){o===void 0&&(o=!1);var p=h??Wc(),g=t.isBeakVisible&&t.beakWidth||0,f=CEe(t.isBeakVisible,t.beakWidth,t.gapSpace),y=t;y.gapSpace=f;var T=t.bounds?Ktt(t.bounds):new gE(0,p.innerWidth-KZe(),0,p.innerHeight),C=Ytt(y,i,T,r,o,l),E=Wtt(g,C),I=qtt(C,E,T);return Rt(Rt({},Qtt(C,e,T,t.coverTarget,d)),{beakPosition:I})}function Ztt(t,e,i,r,o){var l=o??Wc();return _Ee(t,e,i,r,!1,void 0,!0,l)}function Xtt(t){var e,i,r,o,l=t,d=t,h=t,p,g=(e=h.left)!==null&&e!==void 0?e:h.x,f=(i=h.top)!==null&&i!==void 0?i:h.y,y=(r=h.right)!==null&&r!==void 0?r:g,T=(o=h.bottom)!==null&&o!==void 0?o:f;return l.stopPropagation?p=new gE(l.clientX,l.clientX,l.clientY,l.clientY):g!==void 0&&f!==void 0?p=new gE(g,y,f,T):p=nW(d),p}function eit(t,e,i,r,o,l,d){return _Ee(t,e,i,r,o,l,void 0,d)}function tit(t,e,i,r,o){return Ztt(t,e,i,r,o)}function iit(t){return t*-1}function nit(t,e){var i=void 0;if(e.getWindowSegments&&(i=e.getWindowSegments()),i===void 0||i.length<=1)return{top:0,left:0,right:e.innerWidth,bottom:e.innerHeight,width:e.innerWidth,height:e.innerHeight};var r=0,o=0;if(t!==null&&t.getBoundingClientRect){var l=t.getBoundingClientRect();r=(l.left+l.right)/2,o=(l.top+l.bottom)/2}else t!==null&&(r=t.left||t.x,o=t.top||t.y);for(var d={top:0,left:0,right:0,bottom:0,width:0,height:0},h=0,p=i;h<p.length;h++){var g=p[h];r&&g.left<=r&&g.right>=r&&o&&g.top<=o&&g.bottom>=o&&(d={top:g.top,left:g.left,right:g.right,bottom:g.bottom,width:g.width,height:g.height})}return d}function ait(t,e){return nit(t,e)}function rit(t,e,i){return CEe(t,e,i)}function oit(t){return Xtt(t)}function KU(){var t=$.useRef();return t.current||(t.current=new YN),$.useEffect(function(){return function(){var e;(e=t.current)===null||e===void 0||e.dispose(),t.current=void 0}},[]),t.current}function oT(t){var e=$.useRef();return e.current===void 0&&(e.current={value:typeof t=="function"?t():t}),e.current.value}function Tre(t){var e=$.useState(t),i=e[0],r=e[1],o=oT(function(){return function(){r(!0)}}),l=oT(function(){return function(){r(!1)}}),d=oT(function(){return function(){r(function(h){return!h})}});return[i,{setTrue:o,setFalse:l,toggle:d}]}function Z$(t,e,i){var r=$.useState(e),o=r[0],l=r[1],d=oT(t!==void 0),h=d?t:o,p=$.useRef(h),g=$.useRef(i);$.useEffect(function(){p.current=h,g.current=i});var f=oT(function(){return function(y,T){var C=typeof y=="function"?y(p.current):y;g.current&&g.current(T,C),d||l(C)}});return[h,f]}function Cre(t){var e=$.useRef(function(){throw new Error("Cannot call an event handler while rendering")});return ix(function(){e.current=t},[t]),oT(function(){return function(){for(var i=[],r=0;r<arguments.length;r++)i[r]=arguments[r];var o=e.current;return o.apply(void 0,i)}})}function yu(t,e){var i=$.useRef(e);return i.current||(i.current=bp(t)),i.current}function Ff(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];var i=$.useCallback(function(r){i.current=r;for(var o=0,l=t;o<l.length;o++){var d=l[o];typeof d=="function"?d(r):d&&(d.current=r)}},Gd([],t,!0));return i}function X$(t,e,i,r){var o=$.useRef(i);o.current=i,$.useEffect(function(){var l=t&&"current"in t?t.current:t;if(!(!l||!l.addEventListener)){var d=hE(l,e,function(h){return o.current(h)},r);return d}},[t,e,r])}function JU(t){var e=$.useRef();return $.useEffect(function(){e.current=t}),e.current}function EEe(t,e){e===void 0&&(e=null);var i=function(){var o=function(l){r.ref.current!==l&&(r.cleanup&&(r.cleanup(),r.cleanup=void 0),r.ref.current=l,l!==null&&(r.cleanup=r.callback(l)))};return o.current=e,o},r=$.useRef({ref:i(),callback:t}).current;return r.callback=t,r.ref}var AEe=function(){var t=oT({});return $.useEffect(function(){return function(){for(var e=0,i=Object.keys(t);e<i.length;e++){var r=i[e];clearTimeout(r)}}},[t]),oT({setTimeout:function(e,i){var r=setTimeout(e,i);return t[r]=1,r},clearTimeout:function(e){delete t[e],clearTimeout(e)}})};function IEe(t,e){var i,r,o,l=$.useRef(),d=$.useRef(null),h=VU();if(!t||t!==l.current||typeof t=="string"){var p=e?.current;if(t)if(typeof t=="string")if(!((i=p?.getRootNode())===null||i===void 0)&&i.host)d.current=(o=(r=p?.getRootNode())===null||r===void 0?void 0:r.querySelector(t))!==null&&o!==void 0?o:null;else{var g=Gg(p);d.current=g?g.querySelector(t):null}else"stopPropagation"in t||"getBoundingClientRect"in t?d.current=t:"current"in t?d.current=t.current:d.current=t;l.current=t}return[d,h]}var aW=function(t){var e=$.useRef(t);e.current=t,$.useEffect(function(){return function(){var i;(i=e.current)===null||i===void 0||i.call(e)}},[])},sit=0;function CM(t){if(process.env.NODE_ENV!=="production"){var e=t.name,i=t.props,r=t.other,o=r===void 0?[]:r,l=t.conditionallyRequired,d=t.deprecations,h=t.mutuallyExclusive,p=t.controlledUsage,g=$.useRef(!1),f=oT(function(){return"useWarnings_".concat(sit++)}),y=JU(i);if(!g.current){g.current=!0;for(var T=0,C=o;T<C.length;T++){var E=C[T];SC(E)}if(l)for(var I=0,w=l;I<w.length;I++){var D=w[I];Jae(e,i,D.requiredProps,D.conditionalPropName,D.condition)}d&&fL(e,i,d),h&&Uq(e,i,h)}p&&tEe(Rt(Rt({},p),{componentId:f,props:i,componentName:e,oldProps:y}))}}function lit(t,e){var i=KU(),r=$.useState(!1),o=r[0],l=r[1];return $.useEffect(function(){return i.requestAnimationFrame(function(){var d;if(!(t.style&&t.style.overflowY)){var h=!1;if(e&&e.current&&(!((d=e.current)===null||d===void 0)&&d.firstElementChild)){var p=e.current.clientHeight,g=e.current.firstElementChild.clientHeight;p>0&&g>p&&(h=g-p>1)}o!==h&&l(h)}}),function(){return i.dispose()}}),o}function cit(t){var e=t.originalElement,i=t.containsFocus;e&&i&&e!==Wc()&&setTimeout(function(){var r;(r=e.focus)===null||r===void 0||r.call(e)},0)}function dit(t,e){var i=t.onRestoreFocus,r=i===void 0?cit:i,o=$.useRef(),l=$.useRef(!1);$.useEffect(function(){return o.current=Gg().activeElement,VZe(e.current)&&(l.current=!0),function(){var d;r?.({originalElement:o.current,containsFocus:l.current,documentContainsFocus:((d=Gg())===null||d===void 0?void 0:d.hasFocus())||!1}),o.current=void 0}},[]),X$(e,"focus",$.useCallback(function(){l.current=!0},[]),!0),X$(e,"blur",$.useCallback(function(d){e.current&&d.relatedTarget&&!e.current.contains(d.relatedTarget)&&(l.current=!1)},[]),!0)}function uit(t,e){var i=String(t["aria-modal"]).toLowerCase()==="true"&&t.enableAriaHiddenSiblings;$.useEffect(function(){if(i&&e.current){var r=eEe(e.current);return r}},[e,i])}var eH=$.forwardRef(function(t,e){var i=Lw({shouldRestoreFocus:!0,enableAriaHiddenSiblings:!0},t),r=$.useRef(),o=Ff(r,e);uit(i,r),dit(i,r);var l=i.role,d=i.className,h=i.ariaLabel,p=i.ariaLabelledBy,g=i.ariaDescribedBy,f=i.style,y=i.children,T=i.onDismiss,C=lit(i,r),E=$.useCallback(function(w){switch(w.which){case fa.escape:T&&(T(w),w.preventDefault(),w.stopPropagation());break}},[T]),I=VU();return X$(I,"keydown",E),$.createElement("div",Rt({ref:o},Wl(i,Nf),{className:d,role:l,"aria-label":h,"aria-labelledby":p,"aria-describedby":g,onKeyDown:E,style:Rt({overflowY:C?"scroll":void 0,outline:"none"},f)}),y)});eH.displayName="Popup";var wEe=function(){var t;return(t=VU())!==null&&t!==void 0?t:typeof window<"u"?window:void 0},CL=function(t){var e,i;return(i=(e=t?.window)===null||e===void 0?void 0:e.document)!==null&&i!==void 0?i:typeof document<"u"?document:void 0},kEe=function(t){var e;return(e=t?.window)!==null&&e!==void 0?e:typeof window<"u"?window:void 0},YU,hit="CalloutContentBase",pit=(YU={},YU[so.top]=EC.slideUpIn10,YU[so.bottom]=EC.slideDownIn10,YU[so.left]=EC.slideLeftIn10,YU[so.right]=EC.slideRightIn10,YU),REe={top:0,left:0},git={opacity:0,filter:"opacity(0)",pointerEvents:"none"},mit=["role","aria-roledescription"],MEe={preventDismissOnLostFocus:!1,preventDismissOnScroll:!1,preventDismissOnResize:!1,isBeakVisible:!0,beakWidth:16,gapSpace:0,minPagePadding:8,directionalHint:hd.bottomAutoEdge},fit=fu({disableCaching:!0});function vit(t,e,i){var r=t.bounds,o=t.minPagePadding,l=o===void 0?MEe.minPagePadding:o,d=t.target,h=$.useState(!1),p=h[0],g=h[1],f=$.useRef(),y=$.useCallback(function(){if(!f.current||p){var C=typeof r=="function"?i?r(d,i):void 0:r;!C&&i&&(C=ait(e.current,i),C={top:C.top+l,left:C.left+l,right:C.right-l,bottom:C.bottom-l,width:C.width-l*2,height:C.height-l*2}),f.current=C,p&&g(!1)}return f.current},[r,l,d,e,i,p]),T=KU();return X$(i,"resize",T.debounce(function(){g(!0)},500,{leading:!0})),y}function yit(t,e,i,r){var o,l=t.calloutMaxHeight,d=t.finalHeight,h=t.directionalHint,p=t.directionalHintFixed,g=t.hidden,f=t.gapSpace,y=t.beakWidth,T=t.isBeakVisible,C=t.coverTarget,E=$.useState(),I=E[0],w=E[1],D=(o=r?.elementPosition)!==null&&o!==void 0?o:{},F=D.top,x=D.bottom,B=i?.current?oit(i.current):void 0;return $.useEffect(function(){var L,z=(L=e())!==null&&L!==void 0?L:{},H=z.top,j=z.bottom,J;r?.targetEdge===so.top&&B?.top&&!C&&(j=B.top-rit(T,y,f)),typeof F=="number"&&j?J=j-F:typeof x=="number"&&typeof H=="number"&&j&&(J=j-H-x),!l&&!g||l&&J&&l>J?w(J):w(l||void 0)},[x,l,d,h,p,e,g,r,F,f,y,T,B,C]),I}function Sit(t,e,i,r,o,l){var d=$.useState(),h=d[0],p=d[1],g=$.useRef(0),f=$.useRef(),y=KU(),T=t.hidden,C=t.target,E=t.finalHeight,I=t.calloutMaxHeight,w=t.onPositioned,D=t.directionalHint,F=t.hideOverflow,x=t.preferScrollResizePositioning,B=wEe(),L=$.useRef(),z;L.current!==l.current&&(L.current=l.current,z=l.current?B?.getComputedStyle(l.current):void 0);var H=z?.overflowY;return $.useEffect(function(){if(T)p(void 0),g.current=0;else{var j=y.requestAnimationFrame(function(){var J,Z;if(e.current&&i){var re=Rt(Rt({},t),{target:r.current,bounds:o()}),ne=i.cloneNode(!0);ne.style.maxHeight=I?"".concat(I):"",ne.style.visibility="hidden",(J=i.parentElement)===null||J===void 0||J.appendChild(ne);var le=f.current===C?h:void 0,he=F||H==="clip"||H==="hidden",Me=x&&!he,Le=E?tit(re,e.current,ne,le,B):eit(re,e.current,ne,le,Me,void 0,B);(Z=i.parentElement)===null||Z===void 0||Z.removeChild(ne),!h&&Le||h&&Le&&!_it(h,Le)&&g.current<5?(g.current++,p(Le)):g.current>0&&(g.current=0,w?.(h))}},i);return f.current=C,function(){y.cancelAnimationFrame(j),f.current=void 0}}},[T,D,y,i,I,e,r,E,o,w,h,t,C,F,x,H,B]),h}function bit(t,e,i){var r=t.hidden,o=t.setInitialFocus,l=KU(),d=!!e;$.useEffect(function(){if(!r&&o&&d&&i){var h=l.requestAnimationFrame(function(){return zZe(i)},i);return function(){return l.cancelAnimationFrame(h)}}},[r,d,l,i,o])}function Tit(t,e,i,r,o){var l=t.hidden,d=t.onDismiss,h=t.preventDismissOnScroll,p=t.preventDismissOnResize,g=t.preventDismissOnLostFocus,f=t.dismissOnTargetClick,y=t.shouldDismissOnWindowFocus,T=t.preventDismissOnEvent,C=$.useRef(!1),E=KU(),I=oT([function(){C.current=!0},function(){C.current=!1}]),w=!!e;return $.useEffect(function(){var D=function(H){w&&!h&&B(H)},F=function(H){!p&&!(T&&T(H))&&d?.(H)},x=function(H){g||B(H)},B=function(H){var j=H.composedPath?H.composedPath():[],J=j.length>0?j[0]:H.target,Z=i.current&&!xy(i.current,J);if(Z&&C.current){C.current=!1;return}if(!r.current&&Z||H.target!==o&&Z&&(!r.current||"stopPropagation"in r.current||f||J!==r.current&&!xy(r.current,J))){if(T&&T(H))return;d?.(H)}},L=function(H){y&&(T&&!T(H)||!T&&!g)&&!o?.document.hasFocus()&&H.relatedTarget===null&&d?.(H)},z=new Promise(function(H){E.setTimeout(function(){if(!l&&o){var j=[hE(o,"scroll",D,!0),hE(o,"resize",F,!0),hE(o.document.documentElement,"focus",x,!0),hE(o.document.documentElement,"click",x,!0),hE(o,"blur",L,!0)];H(function(){j.forEach(function(J){return J()})})}},0)});return function(){z.then(function(H){return H()})}},[l,E,i,r,o,d,y,f,g,p,h,w,T]),I}var PEe=$.memo($.forwardRef(function(t,e){var i=Lw(MEe,t),r=i.styles,o=i.style,l=i.ariaLabel,d=i.ariaDescribedBy,h=i.ariaLabelledBy,p=i.className,g=i.isBeakVisible,f=i.children,y=i.beakWidth,T=i.calloutWidth,C=i.calloutMaxWidth,E=i.calloutMinWidth,I=i.doNotLayer,w=i.finalHeight,D=i.hideOverflow,F=D===void 0?!!w:D,x=i.backgroundColor,B=i.calloutMaxHeight,L=i.onScroll,z=i.shouldRestoreFocus,H=z===void 0?!0:z,j=i.target,J=i.hidden,Z=i.onLayerMounted,re=i.popupProps,ne=$.useRef(null),le=$.useRef(null),he=Ff(le,re?.ref),Me=$.useState(null),Le=Me[0],pe=Me[1],te=$.useCallback(function(Ke){pe(Ke)},[]),Se=Ff(ne,e),ce=IEe(i.target,{current:Le}),X=ce[0],ve=ce[1],Te=vit(i,X,ve),Be=Sit(i,ne,Le,X,Te,he),qe=yit(i,Te,X,Be),Ge=Tit(i,Be,ne,X,ve),tt=Ge[0],ct=Ge[1],Mt=Be?.elementPosition.top&&Be?.elementPosition.bottom,ht=Rt(Rt({},Be?.elementPosition),{maxHeight:qe});if(Mt&&(ht.bottom=void 0),bit(i,Be,Le),$.useEffect(function(){J||Z?.()},[J]),!ve)return null;var vt=F,Pt=g&&!!j,ni=fit(r,{theme:i.theme,className:p,overflowYHidden:vt,calloutWidth:T,positions:Be,beakWidth:y,backgroundColor:x,calloutMaxWidth:C,calloutMinWidth:E,doNotLayer:I}),Zt=Rt(Rt({maxHeight:B||"100%"},o),vt&&{overflowY:"hidden"}),it=i.hidden?{visibility:"hidden"}:void 0;return $.createElement("div",{ref:Se,className:ni.container,style:it},$.createElement("div",Rt({},Wl(i,Nf,mit),{className:wh(ni.root,Be&&Be.targetEdge&&pit[Be.targetEdge]),style:Be?Rt({},ht):git,tabIndex:-1,ref:te}),Pt&&$.createElement("div",{className:ni.beak,style:Cit(Be)}),Pt&&$.createElement("div",{className:ni.beakCurtain}),$.createElement(eH,Rt({role:i.role,"aria-roledescription":i["aria-roledescription"],ariaDescribedBy:d,ariaLabel:l,ariaLabelledBy:h,className:ni.calloutMain,onDismiss:i.onDismiss,onMouseDown:tt,onMouseUp:ct,onRestoreFocus:i.onRestoreFocus,onScroll:L,shouldRestoreFocus:H,style:Zt},re,{ref:he}),f)))}),function(t,e){return!e.shouldUpdateWhenHidden&&t.hidden&&e.hidden?!0:Gae(t,e)});function Cit(t){var e,i,r=Rt(Rt({},(e=t?.beakPosition)===null||e===void 0?void 0:e.elementPosition),{display:!((i=t?.beakPosition)===null||i===void 0)&&i.hideBeak?"none":void 0});return!r.top&&!r.bottom&&!r.left&&!r.right&&(r.left=REe.left,r.top=REe.top),r}function _it(t,e){return DEe(t.elementPosition,e.elementPosition)&&DEe(t.beakPosition.elementPosition,e.beakPosition.elementPosition)}function DEe(t,e){for(var i in e)if(e.hasOwnProperty(i)){var r=t[i],o=e[i];if(r!==void 0&&o!==void 0){if(r.toFixed(2)!==o.toFixed(2))return!1}else return!1}return!0}PEe.displayName=hit;function Eit(t){return{height:t,width:t}}var Ait={container:"ms-Callout-container",root:"ms-Callout",beak:"ms-Callout-beak",beakCurtain:"ms-Callout-beakCurtain",calloutMain:"ms-Callout-main"},Iit=function(t){var e,i=t.theme,r=t.className,o=t.overflowYHidden,l=t.calloutWidth,d=t.beakWidth,h=t.backgroundColor,p=t.calloutMaxWidth,g=t.calloutMinWidth,f=t.doNotLayer,y=eh(Ait,i),T=i.semanticColors,C=i.effects;return{container:[y.container,{position:"relative"}],root:[y.root,i.fonts.medium,{position:"absolute",display:"flex",zIndex:f?ox.Layer:void 0,boxSizing:"border-box",borderRadius:C.roundedCorner2,boxShadow:C.elevation16,selectors:(e={},e[Rn]={borderWidth:1,borderStyle:"solid",borderColor:"WindowText"},e)},Ttt(),r,!!l&&{width:l},!!p&&{maxWidth:p},!!g&&{minWidth:g}],beak:[y.beak,{position:"absolute",backgroundColor:T.menuBackground,boxShadow:"inherit",border:"inherit",boxSizing:"border-box",transform:"rotate(45deg)"},Eit(d),h&&{backgroundColor:h}],beakCurtain:[y.beakCurtain,{position:"absolute",top:0,right:0,bottom:0,left:0,backgroundColor:T.menuBackground,borderRadius:C.roundedCorner2}],calloutMain:[y.calloutMain,{backgroundColor:T.menuBackground,overflowX:"hidden",overflowY:"auto",position:"relative",width:"100%",borderRadius:C.roundedCorner2},o&&{overflowY:"hidden"},h&&{backgroundColor:h}]}},wit=vu(PEe,Iit,void 0,{scope:"CalloutContent"}),LEe=$.createContext(void 0),kit=function(){return function(){}};LEe.Provider;function Rit(){var t;return(t=$.useContext(LEe))!==null&&t!==void 0?t:kit}var _re=VCe();const rW=cL(_re);var Mit=fu(),Pit=ql(function(t,e){return rx(Rt(Rt({},t),{rtl:e}))}),Dit=function(t){var e=t.theme,i=t.dir,r=Of(e)?"rtl":"ltr",o=Of()?"rtl":"ltr",l=i||r;return{rootDir:l!==r||l!==o?l:i,needsTheme:l!==r}},OEe=$.forwardRef(function(t,e){var i=t.className,r=t.theme,o=t.applyTheme,l=t.applyThemeToBody,d=t.styles,h=Mit(d,{theme:r,applyTheme:o,className:i}),p=$.useRef(null);return Oit(l,h,p),$.createElement($.Fragment,null,Lit(t,h,p,e))});OEe.displayName="FabricBase";function Lit(t,e,i,r){var o=e.root,l=t.as,d=l===void 0?"div":l,h=t.dir,p=t.theme,g=Wl(t,Nf,["dir"]),f=Dit(t),y=f.rootDir,T=f.needsTheme,C=$.createElement(lre,{providerRef:i},$.createElement(d,Rt({dir:y},g,{className:o,ref:Ff(i,r)})));return T&&(C=$.createElement(M_e,{settings:{theme:Pit(p,h==="rtl")}},C)),C}function Oit(t,e,i){var r=e.bodyThemed;return $.useEffect(function(){if(t){var o=Gg(i.current);if(o)return o.body.classList.add(r),function(){o.body.classList.remove(r)}}},[r,t,i]),i}var Ere={fontFamily:"inherit"},Nit={root:"ms-Fabric",bodyThemed:"ms-Fabric-bodyThemed"},xit=function(t){var e=t.applyTheme,i=t.className,r=t.preventBlanketFontInheritance,o=t.theme,l=eh(Nit,o);return{root:[l.root,o.fonts.medium,{color:o.palette.neutralPrimary},!r&&{"& button":Ere,"& input":Ere,"& textarea":Ere},e&&{color:o.semanticColors.bodyText,backgroundColor:o.semanticColors.bodyBackground},i],bodyThemed:[{backgroundColor:o.semanticColors.bodyBackground}]}},Bit=vu(OEe,xit,void 0,{scope:"Fabric"}),lx={},cx={},NEe="fluent-default-layer-host",Fit="#".concat(NEe);function Uit(t,e){lx[t]||(lx[t]=[]),lx[t].push(e);var i=cx[t];if(i)for(var r=0,o=i;r<o.length;r++){var l=o[r];l.notifyLayersChanged()}}function zit(t,e){var i=lx[t];if(i){var r=i.indexOf(e);r>=0&&(i.splice(r,1),i.length===0&&delete lx[t])}var o=cx[t];if(o)for(var l=0,d=o;l<d.length;l++){var h=d[l];h.notifyLayersChanged()}}function Vit(t){var e=cx[t];return e&&e[0]||void 0}function $it(t,e){var i=cx[t]||(cx[t]=[]);i.unshift(e)}function Hit(t,e){var i=cx[t];if(i){var r=i.indexOf(e);r>=0&&i.splice(r,1),i.length===0&&delete cx[t]}}function jit(t,e){e===void 0&&(e=null);var i=t.createElement("div");return i.setAttribute("id",NEe),i.style.cssText="position:fixed;z-index:1000000",e?e.appendChild(i):t?.body.appendChild(i),i}function xEe(t){lx[t]&&lx[t].forEach(function(e){return e()})}function Git(){return Fit}var qit=fu(),Wit=function(t){return t?.current?t.current.classList.contains(ys):!1},BEe=$.forwardRef(function(t,e){var i=Rit(),r=$.useRef(null),o=Ff(r,e),l=$.useRef(),d=$.useRef(null),h=$.useContext(H$),p=$.useState(!1),g=p[0],f=p[1],y=$.useCallback(function(he){var Me=Wit(h?.providerRef);he&&Me&&he.classList.add(ys)},[h]),T=t.children,C=t.className,E=t.eventBubblingEnabled,I=t.fabricProps,w=t.hostId,D=t.insertFirst,F=t.onLayerDidMount,x=F===void 0?function(){}:F,B=t.onLayerMounted,L=B===void 0?function(){}:B,z=t.onLayerWillUnmount,H=t.styles,j=t.theme,J=Ff(d,I?.ref,y),Z=qit(H,{theme:j,className:C,isNotHost:!w}),re=function(he,Me){var Le,pe;Me===void 0&&(Me=null);var te=Me??he;if(w){var Se=Vit(w);return Se?(Le=Se.rootRef.current)!==null&&Le!==void 0?Le:null:(pe=te.getElementById(w))!==null&&pe!==void 0?pe:null}else{var ce=Git(),X=ce?te.querySelector(ce):null;return X||(X=jit(he,Me)),X}},ne=function(){z?.();var he=l.current;l.current=void 0,he&&he.parentNode&&he.parentNode.removeChild(he)},le=function(){var he,Me,Le,pe,te=Gg(r.current),Se=!((Me=(he=r.current)===null||he===void 0?void 0:he.getRootNode())===null||Me===void 0)&&Me.host?(Le=r?.current)===null||Le===void 0?void 0:Le.getRootNode():void 0;if(!(!te||!te&&!Se)){var ce=re(te,Se);if(ce){ce.__tabsterElementFlags||(ce.__tabsterElementFlags={}),ce.__tabsterElementFlags.noDirectAriaHidden=!0,ne();var X=((pe=ce.ownerDocument)!==null&&pe!==void 0?pe:te).createElement("div");X.className=Z.root,DZe(X),LZe(X,r.current),D?ce.insertBefore(X,ce.firstChild):ce.appendChild(X),l.current=X,f(!0)}}};return ix(function(){le(),w&&Uit(w,le);var he=l.current?i(l.current):void 0;return function(){he&&he(),ne(),w&&zit(w,le)}},[w]),$.useEffect(function(){l.current&&g&&(L?.(),x?.(),f(!1))},[g,L,x]),Yit(t),$.createElement("span",{className:"ms-layer",ref:o},l.current&&_re.createPortal($.createElement(lre,{layerRoot:!0,providerRef:J},$.createElement(Bit,Rt({},!E&&Jit(),I,{className:wh(Z.content,I?.className),ref:J}),T)),l.current))});BEe.displayName="LayerBase";var oW,Kit=function(t){t.eventPhase===Event.BUBBLING_PHASE&&t.type!=="mouseenter"&&t.type!=="mouseleave"&&t.type!=="touchstart"&&t.type!=="touchend"&&t.stopPropagation()};function Jit(){return oW||(oW={},["onClick","onContextMenu","onDoubleClick","onDrag","onDragEnd","onDragEnter","onDragExit","onDragLeave","onDragOver","onDragStart","onDrop","onMouseDown","onMouseEnter","onMouseLeave","onMouseMove","onMouseOver","onMouseOut","onMouseUp","onTouchMove","onTouchStart","onTouchCancel","onTouchEnd","onKeyDown","onKeyPress","onKeyUp","onFocus","onBlur","onChange","onInput","onInvalid","onSubmit"].forEach(function(t){return oW[t]=Kit})),oW}function Yit(t){process.env.NODE_ENV!=="production"&&CM({name:"Layer",props:t,deprecations:{onLayerMounted:"onLayerDidMount"}})}var Qit={root:"ms-Layer",rootNoHost:"ms-Layer--fixed",content:"ms-Layer-content"},Zit=function(t){var e=t.className,i=t.isNotHost,r=t.theme,o=eh(Qit,r);return{root:[o.root,r.fonts.medium,i&&[o.rootNoHost,{position:"fixed",zIndex:ox.Layer,top:0,left:0,bottom:0,right:0,visibility:"hidden"}],e],content:[o.content,{visibility:"visible"}]}},QU=vu(BEe,Zit,void 0,{scope:"Layer",fields:["hostId","theme","styles"]}),tH=function(t){var e=t.className,i=$.useState(function(){return bp()})[0],r=t.id,o=r===void 0?i:r,l=$.useRef({hostId:o,rootRef:$.useRef(null),notifyLayersChanged:function(){}});return $.useImperativeHandle(t.componentRef,function(){return l.current}),$.useEffect(function(){$it(o,l.current),xEe(o)},[]),aW(function(){Hit(o,l.current),xEe(o)}),$.createElement("div",Rt({},t,{className:wh("ms-LayerHost",e),ref:l.current.rootRef}))},ZU=$.forwardRef(function(t,e){var i=t.layerProps,r=t.doNotLayer,o=Mm(t,["layerProps","doNotLayer"]),l=$.createElement(wit,Rt({},o,{doNotLayer:r,ref:e}));return r?l:$.createElement(QU,Rt({},i),l)});ZU.displayName="Callout";var Xit="FocusTrapZone",ent={disabled:!1,disableFirstFocus:!1,forceFocusInsideTrap:!0,isClickableOutsideFocusTrap:!1,"data-tabster":'{"uncontrolled": {"completely": true}}'},tnt=function(t,e,i){$.useImperativeHandle(t,function(){return{get previouslyFocusedElement(){return e},focus:i}},[i,e])},Nw=$.forwardRef(function(t,e){var i,r=$.useRef(null),o=$.useRef(null),l=$.useRef(null),d=Ff(r,e),h=O_e(),p=wEe(),g=EXe(),f=(i=JU(!1))!==null&&i!==void 0?i:!0,y=Lw(ent,t),T=oT({hasFocus:!1,focusStackId:yu("ftz-",y.id)}),C=y.children,E=y.componentRef,I=y.disabled,w=y.disableFirstFocus,D=y.forceFocusInsideTrap,F=y.focusPreviouslyFocusedInnerElement,x=y.firstFocusableSelector,B=y.firstFocusableTarget,L=y.disableRestoreFocus,z=L===void 0?y.ignoreExternalFocusing:L,H=y.isClickableOutsideFocusTrap,j=y.enableAriaHiddenSiblings,J={"aria-hidden":!0,style:{pointerEvents:"none",position:"fixed"},tabIndex:I?-1:0,"data-is-visible":!0,"data-is-focus-trap-zone-bumper":!0},Z=$.useCallback(function(pe){pe!==o.current&&pe!==l.current&&v_e(pe)},[]),re=Cre(function(){if(r.current){var pe=T.previouslyFocusedElementInTrapZone;if(F&&pe&&xy(r.current,pe)){Z(pe);return}var te=null;if(typeof B=="string")te=r.current.querySelector(B);else if(B)te=B(r.current);else if(x){var Se=typeof x=="string"?x:x();te=r.current.querySelector("."+Se)}te||(te=By(r.current,r.current.firstChild,!1,!1,!1,!0,void 0,void 0,void 0,g)),te&&Z(te)}}),ne=function(pe){if(!(I||!r.current)){var te=pe===T.hasFocus?UZe(r.current,l.current,!0,!1,g):FZe(r.current,o.current,!0,!1,g);te&&(te===o.current||te===l.current?re():te.focus())}},le=function(pe){var te;(te=y.onBlurCapture)===null||te===void 0||te.call(y,pe);var Se=pe.relatedTarget;pe.relatedTarget===null&&(Se=xq(h)),xy(r.current,Se)||(T.hasFocus=!1)},he=function(pe){var te;(te=y.onFocusCapture)===null||te===void 0||te.call(y,pe),pe.target===o.current?ne(!0):pe.target===l.current&&ne(!1),T.hasFocus=!0,pe.target!==pe.currentTarget&&!(pe.target===o.current||pe.target===l.current)&&(T.previouslyFocusedElementInTrapZone=h_e(pe.nativeEvent))},Me=Cre(function(pe){if(Nw.focusStack=Nw.focusStack.filter(function(Se){return T.focusStackId!==Se}),!!h){var te=h.activeElement;!z&&typeof pe?.focus=="function"&&(xy(r.current,te)||te===h.body||te.shadowRoot)&&Z(pe)}}),Le=Cre(function(pe){if(!I&&T.focusStackId===Nw.focusStack.slice(-1)[0]){var te=h_e(pe);te&&!xy(r.current,te)&&(h&&xq(h)===h.body?setTimeout(function(){h&&xq(h)===h.body&&(re(),T.hasFocus=!0)},0):(re(),T.hasFocus=!0),pe.preventDefault(),pe.stopPropagation())}});return $.useEffect(function(){var pe=[];return D&&pe.push(hE(p,"focus",Le,!0)),H||pe.push(hE(p,"click",Le,!0)),function(){pe.forEach(function(te){return te()})}},[D,H,p]),$.useEffect(function(){if(!(I||!f&&!D||!r.current)){Nw.focusStack.push(T.focusStackId);var pe=y.elementToFocusOnDismiss||xq(h);return!w&&!xy(r.current,pe)&&re(),function(){return Me(pe)}}},[D,I]),$.useEffect(function(){if(!I&&j){var pe=eEe(r.current);return pe}},[I,j,r]),aW(function(){delete T.previouslyFocusedElementInTrapZone}),tnt(E,T.previouslyFocusedElementInTrapZone,re),$.createElement("div",Rt({"aria-labelledby":y.ariaLabelledBy},Wl(y,Nf),{ref:d,onFocusCapture:he,onBlurCapture:le}),$.createElement("div",Rt({},J,{ref:o})),C,$.createElement("div",Rt({},J,{ref:l})))});Nw.displayName=Xit,Nw.focusStack=[];var int=fu(),nnt=function(t){mu(e,t);function e(){var i=t!==null&&t.apply(this,arguments)||this;return i._onRenderContent=function(r){return typeof r.content=="string"?$.createElement("p",{className:i._classNames.subText},r.content):$.createElement("div",{className:i._classNames.subText},r.content)},i}return e.prototype.render=function(){var i=this.props,r=i.className,o=i.calloutProps,l=i.directionalHint,d=i.directionalHintForRTL,h=i.styles,p=i.id,g=i.maxWidth,f=i.onRenderContent,y=f===void 0?this._onRenderContent:f,T=i.targetElement,C=i.theme;return this._classNames=int(h,{theme:C,className:r||o&&o.className,beakWidth:o&&o.isBeakVisible?o.beakWidth:0,gapSpace:o&&o.gapSpace,maxWidth:g}),$.createElement(ZU,Rt({target:T,directionalHint:l,directionalHintForRTL:d},o,Wl(this.props,Nf,["id"]),{className:this._classNames.root}),$.createElement("div",{className:this._classNames.content,id:p,onFocus:this.props.onFocus,onMouseEnter:this.props.onMouseEnter,onMouseLeave:this.props.onMouseLeave},y(this.props,this._onRenderContent)))},e.defaultProps={directionalHint:hd.topCenter,maxWidth:"364px",calloutProps:{isBeakVisible:!0,beakWidth:16,gapSpace:0,setInitialFocus:!0,doNotLayer:!1}},e}($.Component),ant=function(t){var e=t.className,i=t.beakWidth,r=i===void 0?16:i,o=t.gapSpace,l=o===void 0?0:o,d=t.maxWidth,h=t.theme,p=h.semanticColors,g=h.fonts,f=h.effects,y=-(Math.sqrt(r*r/2)+l)+1/window.devicePixelRatio;return{root:["ms-Tooltip",h.fonts.medium,EC.fadeIn200,{background:p.menuBackground,boxShadow:f.elevation8,padding:"8px",maxWidth:d,selectors:{":after":{content:"''",position:"absolute",bottom:y,left:y,right:y,top:y,zIndex:0}}},e],content:["ms-Tooltip-content",g.small,{position:"relative",zIndex:1,color:p.menuItemText,wordWrap:"break-word",overflowWrap:"break-word",overflow:"hidden"}],subText:["ms-Tooltip-subtext",{fontSize:"inherit",fontWeight:"inherit",color:"inherit",margin:0}]}},rnt=vu(nnt,ant,void 0,{scope:"Tooltip"}),XU;(function(t){t[t.zero=0]="zero",t[t.medium=1]="medium",t[t.long=2]="long"})(XU||(XU={}));var e5;(function(t){t[t.Parent=0]="Parent",t[t.Self=1]="Self"})(e5||(e5={}));var ont=fu(),snt=function(t){mu(e,t);function e(i){var r=t.call(this,i)||this;return r._tooltipHost=$.createRef(),r._defaultTooltipId=bp("tooltip"),r.show=function(){r._toggleTooltip(!0)},r.dismiss=function(){r._hideTooltip()},r._getTargetElement=function(){if(r._tooltipHost.current){var o=r.props.overflowMode;if(o!==void 0)switch(o){case e5.Parent:return r._tooltipHost.current.parentElement;case e5.Self:return r._tooltipHost.current}return r._tooltipHost.current}},r._onTooltipFocus=function(o){if(r._ignoreNextFocusEvent){r._ignoreNextFocusEvent=!1;return}r._onTooltipMouseEnter(o)},r._onTooltipContentFocus=function(o){e._currentVisibleTooltip&&e._currentVisibleTooltip!==r&&e._currentVisibleTooltip.dismiss(),e._currentVisibleTooltip=r,r._clearDismissTimer(),r._clearOpenTimer()},r._onTooltipBlur=function(o){var l;r._ignoreNextFocusEvent=((l=CL(r.context))===null||l===void 0?void 0:l.activeElement)===o.target,r._dismissTimerId=r._async.setTimeout(function(){r._hideTooltip()},0)},r._onTooltipMouseEnter=function(o){var l=r.props,d=l.overflowMode,h=l.delay,p=CL(r.context);if(e._currentVisibleTooltip&&e._currentVisibleTooltip!==r&&e._currentVisibleTooltip.dismiss(),e._currentVisibleTooltip=r,d!==void 0){var g=r._getTargetElement();if(g&&!met(g))return}if(!(o.target&&Hae(o.target,r._getTargetElement(),p)))if(r._clearDismissTimer(),r._clearOpenTimer(),h!==XU.zero){var f=r._getDelayTime(h);r._openTimerId=r._async.setTimeout(function(){r._toggleTooltip(!0)},f)}else r._toggleTooltip(!0)},r._onTooltipMouseLeave=function(o){var l=r.props.closeDelay;r._clearDismissTimer(),r._clearOpenTimer(),l?r._dismissTimerId=r._async.setTimeout(function(){r._toggleTooltip(!1)},l):r._toggleTooltip(!1),e._currentVisibleTooltip===r&&(e._currentVisibleTooltip=void 0)},r._onTooltipKeyDown=function(o){(o.which===fa.escape||o.ctrlKey)&&r.state.isTooltipVisible&&(r._hideTooltip(),o.stopPropagation())},r._clearDismissTimer=function(){r._async.clearTimeout(r._dismissTimerId)},r._clearOpenTimer=function(){r._async.clearTimeout(r._openTimerId)},r._hideTooltip=function(){r._clearOpenTimer(),r._clearDismissTimer(),r._toggleTooltip(!1)},r._toggleTooltip=function(o){r.state.isTooltipVisible!==o&&r.setState({isTooltipVisible:o},function(){return r.props.onTooltipToggle&&r.props.onTooltipToggle(o)})},r._getDelayTime=function(o){switch(o){case XU.medium:return 300;case XU.long:return 500;default:return 0}},Dw(r),r.state={isAriaPlaceholderRendered:!1,isTooltipVisible:!1},r}return e.prototype.render=function(){var i=this.props,r=i.calloutProps,o=i.children,l=i.content,d=i.directionalHint,h=i.directionalHintForRTL,p=i.hostClassName,g=i.id,f=i.setAriaDescribedBy,y=f===void 0?!0:f,T=i.tooltipProps,C=i.styles,E=i.theme;this._classNames=ont(C,{theme:E,className:p});var I=this.state.isTooltipVisible,w=g||this._defaultTooltipId,D=Rt(Rt({id:"".concat(w,"--tooltip"),content:l,targetElement:this._getTargetElement(),directionalHint:d,directionalHintForRTL:h,calloutProps:mL({},r,{onDismiss:this._hideTooltip,onFocus:this._onTooltipContentFocus,onMouseEnter:this._onTooltipMouseEnter,onMouseLeave:this._onTooltipMouseLeave}),onMouseEnter:this._onTooltipMouseEnter,onMouseLeave:this._onTooltipMouseLeave},Wl(this.props,Nf,["id"])),T),F=T?.onRenderContent?T.onRenderContent(D,function(L){return L?.content?$.createElement($.Fragment,null,L.content):null}):l,x=I&&!!F,B=y&&I&&F?w:void 0;return $.createElement("div",{className:this._classNames.root,ref:this._tooltipHost,onFocusCapture:this._onTooltipFocus,onBlurCapture:this._onTooltipBlur,onMouseEnter:this._onTooltipMouseEnter,onMouseLeave:this._onTooltipMouseLeave,onKeyDown:this._onTooltipKeyDown,role:"none","aria-describedby":B},o,x&&$.createElement(rnt,Rt({},D)),$.createElement("div",{hidden:!0,id:w,style:W$},F))},e.prototype.componentDidMount=function(){this._async=new YN(this)},e.prototype.componentWillUnmount=function(){e._currentVisibleTooltip&&e._currentVisibleTooltip===this&&(e._currentVisibleTooltip=void 0),this._async.dispose()},e.defaultProps={delay:XU.medium},e.contextType=ZN,e}($.Component),lnt={root:"ms-TooltipHost",ariaPlaceholder:"ms-TooltipHost-aria-placeholder"},cnt=function(t){var e=t.className,i=t.theme,r=eh(lnt,i);return{root:[r.root,{display:"inline"},e]}},AC=vu(snt,cnt,void 0,{scope:"TooltipHost"}),sW;(function(t){t[t.default=0]="default",t[t.image=1]="image",t[t.Default=1e5]="Default",t[t.Image=100001]="Image"})(sW||(sW={}));var qS;(function(t){t[t.center=0]="center",t[t.contain=1]="contain",t[t.cover=2]="cover",t[t.none=3]="none",t[t.centerCover=4]="centerCover",t[t.centerContain=5]="centerContain"})(qS||(qS={}));var iH;(function(t){t[t.landscape=0]="landscape",t[t.portrait=1]="portrait"})(iH||(iH={}));var Dm;(function(t){t[t.notLoaded=0]="notLoaded",t[t.loaded=1]="loaded",t[t.error=2]="error",t[t.errorLoaded=3]="errorLoaded"})(Dm||(Dm={}));var dnt=fu(),unt=/\.svg$/i,hnt="fabricImage";function pnt(t,e){var i=t.onLoadingStateChange,r=t.onLoad,o=t.onError,l=t.src,d=$.useState(Dm.notLoaded),h=d[0],p=d[1];ix(function(){p(Dm.notLoaded)},[l]),$.useEffect(function(){if(h===Dm.notLoaded){var y=e.current?l&&e.current.naturalWidth>0&&e.current.naturalHeight>0||e.current.complete&&unt.test(l):!1;y&&p(Dm.loaded)}}),$.useEffect(function(){i?.(h)},[h]);var g=$.useCallback(function(y){r?.(y),l&&p(Dm.loaded)},[l,r]),f=$.useCallback(function(y){o?.(y),p(Dm.error)},[o]);return[h,g,f]}var FEe=$.forwardRef(function(t,e){var i=$.useRef(),r=$.useRef(),o=pnt(t,r),l=o[0],d=o[1],h=o[2],p=Wl(t,z_e,["width","height"]),g=t.src,f=t.alt,y=t.width,T=t.height,C=t.shouldFadeIn,E=C===void 0?!0:C,I=t.shouldStartVisible,w=t.className,D=t.imageFit,F=t.role,x=t.maximizeFrame,B=t.styles,L=t.theme,z=t.loading,H=gnt(t,l,r,i),j=dnt(B,{theme:L,className:w,width:y,height:T,maximizeFrame:x,shouldFadeIn:E,shouldStartVisible:I,isLoaded:l===Dm.loaded||l===Dm.notLoaded&&t.shouldStartVisible,isLandscape:H===iH.landscape,isCenter:D===qS.center,isCenterContain:D===qS.centerContain,isCenterCover:D===qS.centerCover,isContain:D===qS.contain,isCover:D===qS.cover,isNone:D===qS.none,isError:l===Dm.error,isNotImageFit:D===void 0});return $.createElement("div",{className:j.root,style:{width:y,height:T},ref:i},$.createElement("img",Rt({},p,{onLoad:d,onError:h,key:hnt+t.src||"",className:j.image,ref:Ff(r,e),src:g,alt:f,role:F,loading:z})))});FEe.displayName="ImageBase";function gnt(t,e,i,r){var o=$.useRef(e),l=$.useRef();return(l===void 0||o.current===Dm.notLoaded&&e===Dm.loaded)&&(l.current=mnt(t,e,i,r)),o.current=e,l.current}function mnt(t,e,i,r){var o=t.imageFit,l=t.width,d=t.height;if(t.coverStyle!==void 0)return t.coverStyle;if(e===Dm.loaded&&(o===qS.cover||o===qS.contain||o===qS.centerContain||o===qS.centerCover)&&i.current&&r.current){var h=void 0;typeof l=="number"&&typeof d=="number"&&o!==qS.centerContain&&o!==qS.centerCover?h=l/d:h=r.current.clientWidth/r.current.clientHeight;var p=i.current.naturalWidth/i.current.naturalHeight;if(p>h)return iH.landscape}return iH.portrait}var fnt={root:"ms-Image",rootMaximizeFrame:"ms-Image--maximizeFrame",image:"ms-Image-image",imageCenter:"ms-Image-image--center",imageContain:"ms-Image-image--contain",imageCover:"ms-Image-image--cover",imageCenterContain:"ms-Image-image--centerContain",imageCenterCover:"ms-Image-image--centerCover",imageNone:"ms-Image-image--none",imageLandscape:"ms-Image-image--landscape",imagePortrait:"ms-Image-image--portrait"},vnt=function(t){var e=t.className,i=t.width,r=t.height,o=t.maximizeFrame,l=t.isLoaded,d=t.shouldFadeIn,h=t.shouldStartVisible,p=t.isLandscape,g=t.isCenter,f=t.isContain,y=t.isCover,T=t.isCenterContain,C=t.isCenterCover,E=t.isNone,I=t.isError,w=t.isNotImageFit,D=t.theme,F=eh(fnt,D),x={position:"absolute",left:"50% /* @noflip */",top:"50%",transform:"translate(-50%,-50%)"},B=Wc(),L=B!==void 0&&B.navigator.msMaxTouchPoints===void 0,z=f&&p||y&&!p?{width:"100%",height:"auto"}:{width:"auto",height:"100%"};return{root:[F.root,D.fonts.medium,{overflow:"hidden"},o&&[F.rootMaximizeFrame,{height:"100%",width:"100%"}],l&&d&&!h&&EC.fadeIn400,(g||f||y||T||C)&&{position:"relative"},e],image:[F.image,{display:"block",opacity:0},l&&["is-loaded",{opacity:1}],g&&[F.imageCenter,x],f&&[F.imageContain,L&&{width:"100%",height:"100%",objectFit:"contain"},!L&&z,!L&&x],y&&[F.imageCover,L&&{width:"100%",height:"100%",objectFit:"cover"},!L&&z,!L&&x],T&&[F.imageCenterContain,p&&{maxWidth:"100%"},!p&&{maxHeight:"100%"},x],C&&[F.imageCenterCover,p&&{maxHeight:"100%"},!p&&{maxWidth:"100%"},x],E&&[F.imageNone,{width:"auto",height:"auto"}],w&&[!!i&&!r&&{height:"auto",width:"100%"},!i&&!!r&&{height:"100%",width:"auto"},!!i&&!!r&&{height:"100%",width:"100%"}],p&&F.imageLandscape,!p&&F.imagePortrait,!l&&"is-notLoaded",d&&"is-fadeIn",I&&"is-error"]}},nH=vu(FEe,vnt,void 0,{scope:"Image"},!0);nH.displayName="Image";var dx=Rw({root:{display:"inline-block",textDecoration:"inherit"},placeholder:["ms-Icon-placeHolder",{width:"1em"}],image:["ms-Icon-imageContainer",{overflow:"hidden"}]}),UEe="ms-Icon",ynt=function(t){var e=t.className,i=t.iconClassName,r=t.isPlaceholder,o=t.isImage,l=t.styles;return{root:[r&&dx.placeholder,dx.root,o&&dx.image,i,e,l&&l.root,l&&l.imageContainer]}},zEe=ql(function(t){var e=ket(t)||{subset:{},code:void 0},i=e.code,r=e.subset;return i?{children:i,iconClassName:r.className,fontFamily:r.fontFace&&r.fontFace.fontFamily,mergeImageProps:r.mergeImageProps}:null},void 0,!0),_M=function(t){var e=t.iconName,i=t.className,r=t.style,o=r===void 0?{}:r,l=zEe(e)||{},d=l.iconClassName,h=l.children,p=l.fontFamily,g=l.mergeImageProps,f=Wl(t,Lu),y=t["aria-label"]||t.title,T=t["aria-label"]||t["aria-labelledby"]||t.title?{role:g?void 0:"img"}:{"aria-hidden":!0},C=h;return g&&typeof h=="object"&&typeof h.props=="object"&&y&&(C=$.cloneElement(h,{alt:y})),$.createElement("i",Rt({"data-icon-name":e},T,f,g?{title:void 0,"aria-label":void 0}:{},{className:wh(UEe,dx.root,d,!e&&dx.placeholder,i),style:Rt({fontFamily:p},o)}),C)};ql(function(t,e,i){return _M({iconName:t,className:e,"aria-label":i})});var Snt=fu({cacheSize:100}),bnt=function(t){mu(e,t);function e(i){var r=t.call(this,i)||this;return r._onImageLoadingStateChange=function(o){r.props.imageProps&&r.props.imageProps.onLoadingStateChange&&r.props.imageProps.onLoadingStateChange(o),o===Dm.error&&r.setState({imageLoadError:!0})},r.state={imageLoadError:!1},r}return e.prototype.render=function(){var i=this.props,r=i.children,o=i.className,l=i.styles,d=i.iconName,h=i.imageErrorAs,p=i.theme,g=typeof d=="string"&&d.length===0,f=!!this.props.imageProps||this.props.iconType===sW.image||this.props.iconType===sW.Image,y=zEe(d)||{},T=y.iconClassName,C=y.children,E=y.mergeImageProps,I=Snt(l,{theme:p,className:o,iconClassName:T,isImage:f,isPlaceholder:g}),w=f?"span":"i",D=Wl(this.props,Lu,["aria-label"]),F=this.state.imageLoadError,x=Rt(Rt({},this.props.imageProps),{onLoadingStateChange:this._onImageLoadingStateChange}),B=F&&h||nH,L=this.props["aria-label"]||this.props.ariaLabel,z=x.alt||L||this.props.title,H=!!(z||this.props["aria-labelledby"]||x["aria-label"]||x["aria-labelledby"]),j=H?{role:f||E?void 0:"img","aria-label":f||E?void 0:z}:{"aria-hidden":!0},J=C;return E&&C&&typeof C=="object"&&z&&(J=$.cloneElement(C,{alt:z})),$.createElement(w,Rt({"data-icon-name":d},j,D,E?{title:void 0,"aria-label":void 0}:{},{className:I.root}),f?$.createElement(B,Rt({},x)):r||J)},e}($.Component),Fr=vu(bnt,ynt,void 0,{scope:"Icon"},!0);Fr.displayName="Icon";var Tnt=function(t){var e=t.className,i=t.imageProps,r=Wl(t,Lu,["aria-label","aria-labelledby","title","aria-describedby"]),o=i.alt||t["aria-label"],l=o||t["aria-labelledby"]||t.title||i["aria-label"]||i["aria-labelledby"]||i.title,d={"aria-labelledby":t["aria-labelledby"],"aria-describedby":t["aria-describedby"],title:t.title},h=l?{}:{"aria-hidden":!0};return $.createElement("div",Rt({},h,r,{className:wh(UEe,dx.root,dx.image,e)}),$.createElement(nH,Rt({},d,i,{alt:l?o:""})))},Io;(function(t){t[t.tiny=0]="tiny",t[t.extraExtraSmall=1]="extraExtraSmall",t[t.extraSmall=2]="extraSmall",t[t.small=3]="small",t[t.regular=4]="regular",t[t.large=5]="large",t[t.extraLarge=6]="extraLarge",t[t.size8=17]="size8",t[t.size10=9]="size10",t[t.size16=8]="size16",t[t.size24=10]="size24",t[t.size28=7]="size28",t[t.size32=11]="size32",t[t.size40=12]="size40",t[t.size48=13]="size48",t[t.size56=16]="size56",t[t.size72=14]="size72",t[t.size100=15]="size100",t[t.size120=18]="size120"})(Io||(Io={}));var IC;(function(t){t[t.none=0]="none",t[t.offline=1]="offline",t[t.online=2]="online",t[t.away=3]="away",t[t.dnd=4]="dnd",t[t.blocked=5]="blocked",t[t.busy=6]="busy"})(IC||(IC={}));var ls;(function(t){t[t.lightBlue=0]="lightBlue",t[t.blue=1]="blue",t[t.darkBlue=2]="darkBlue",t[t.teal=3]="teal",t[t.lightGreen=4]="lightGreen",t[t.green=5]="green",t[t.darkGreen=6]="darkGreen",t[t.lightPink=7]="lightPink",t[t.pink=8]="pink",t[t.magenta=9]="magenta",t[t.purple=10]="purple",t[t.black=11]="black",t[t.orange=12]="orange",t[t.red=13]="red",t[t.darkRed=14]="darkRed",t[t.transparent=15]="transparent",t[t.violet=16]="violet",t[t.lightRed=17]="lightRed",t[t.gold=18]="gold",t[t.burgundy=19]="burgundy",t[t.warmGray=20]="warmGray",t[t.coolGray=21]="coolGray",t[t.gray=22]="gray",t[t.cyan=23]="cyan",t[t.rust=24]="rust"})(ls||(ls={}));var ng,qd;(function(t){t.size8="20px",t.size10="20px",t.size16="16px",t.size24="24px",t.size28="28px",t.size32="32px",t.size40="40px",t.size48="48px",t.size56="56px",t.size72="72px",t.size100="100px",t.size120="120px"})(qd||(qd={}));var Dv;(function(t){t.size6="6px",t.size8="8px",t.size12="12px",t.size16="16px",t.size20="20px",t.size28="28px",t.size32="32px",t.border="2px"})(Dv||(Dv={}));var lW=function(t){return{isSize8:t===Io.size8,isSize10:t===Io.size10||t===Io.tiny,isSize16:t===Io.size16,isSize24:t===Io.size24||t===Io.extraExtraSmall,isSize28:t===Io.size28||t===Io.extraSmall,isSize32:t===Io.size32,isSize40:t===Io.size40||t===Io.small,isSize48:t===Io.size48||t===Io.regular,isSize56:t===Io.size56,isSize72:t===Io.size72||t===Io.large,isSize100:t===Io.size100||t===Io.extraLarge,isSize120:t===Io.size120}},VEe=(ng={},ng[Io.tiny]=10,ng[Io.extraExtraSmall]=24,ng[Io.extraSmall]=28,ng[Io.small]=40,ng[Io.regular]=48,ng[Io.large]=72,ng[Io.extraLarge]=100,ng[Io.size8]=8,ng[Io.size10]=10,ng[Io.size16]=16,ng[Io.size24]=24,ng[Io.size28]=28,ng[Io.size32]=32,ng[Io.size40]=40,ng[Io.size48]=48,ng[Io.size56]=56,ng[Io.size72]=72,ng[Io.size100]=100,ng[Io.size120]=120,ng),$Ee=function(t){return{isAvailable:t===IC.online,isAway:t===IC.away,isBlocked:t===IC.blocked,isBusy:t===IC.busy,isDoNotDisturb:t===IC.dnd,isOffline:t===IC.offline}},HEe=6,jEe=3,GEe=40,qEe=20,Cnt=fu({cacheSize:100}),WEe=$.forwardRef(function(t,e){var i=t.coinSize,r=t.isOutOfOffice,o=t.styles,l=t.presence,d=t.theme,h=t.presenceTitle,p=t.presenceColors,g=$.useRef(null),f=Ff(e,g),y=lW(t.size),T=!(y.isSize8||y.isSize10||y.isSize16||y.isSize24||y.isSize28||y.isSize32)&&(i?i>32:!0),C=i?i/jEe<GEe?i/jEe+"px":GEe+"px":"",E=i?i/HEe<qEe?i/HEe+"px":qEe+"px":"",I=i?{fontSize:E,lineHeight:C}:void 0,w=i?{width:C,height:C}:void 0,D=Cnt(o,{theme:d,presence:l,size:t.size,isOutOfOffice:r,presenceColors:p});return l===IC.none?null:$.createElement("div",{role:"presentation",className:D.presence,style:w,title:h,ref:f},T&&$.createElement(Fr,{className:D.presenceIcon,iconName:_nt(t.presence,t.isOutOfOffice),style:I}))});WEe.displayName="PersonaPresenceBase";function _nt(t,e){if(t){var i="SkypeArrow";switch(IC[t]){case"online":return"SkypeCheck";case"away":return e?i:"SkypeClock";case"dnd":return"SkypeMinus";case"offline":return e?i:""}return""}}var Ent={presence:"ms-Persona-presence",presenceIcon:"ms-Persona-presenceIcon"},Ant=function(t){var e,i,r,o,l,d,h=t.theme,p=t.presenceColors,g=h.semanticColors,f=h.fonts,y=eh(Ent,h),T=lW(t.size),C=$Ee(t.presence),E=p&&p.available||"#6BB700",I=p&&p.away||"#FFAA44",w=p&&p.busy||"#C43148",D=p&&p.dnd||"#C50F1F",F=p&&p.offline||"#8A8886",x=p&&p.oof||"#B4009E",B=p&&p.background||g.bodyBackground,L=C.isOffline||t.isOutOfOffice&&(C.isAvailable||C.isBusy||C.isAway||C.isDoNotDisturb),z="1px",H="2px",j=T.isSize72||T.isSize100?H:z;return{presence:[y.presence,Rt(Rt({position:"absolute",height:Dv.size12,width:Dv.size12,borderRadius:"50%",top:"auto",right:"-2px",bottom:"-2px",border:"2px solid ".concat(B),textAlign:"center",boxSizing:"content-box",backgroundClip:"border-box"},uc()),{selectors:(e={},e[Rn]={borderColor:"Window",backgroundColor:"WindowText"},e)}),(T.isSize8||T.isSize10)&&{right:"auto",top:"7px",left:0,border:0,selectors:(i={},i[Rn]={top:"9px",border:"1px solid WindowText"},i)},(T.isSize8||T.isSize10||T.isSize24||T.isSize28||T.isSize32)&&n5(Dv.size8),(T.isSize40||T.isSize48)&&n5(Dv.size12),T.isSize16&&{height:Dv.size6,width:Dv.size6,borderWidth:"1.5px"},T.isSize56&&n5(Dv.size16),T.isSize72&&n5(Dv.size20),T.isSize100&&n5(Dv.size28),T.isSize120&&n5(Dv.size32),C.isAvailable&&{backgroundColor:E,selectors:(r={},r[Rn]=aH("Highlight"),r)},C.isAway&&aH(I),C.isBlocked&&[{selectors:(o={":after":T.isSize40||T.isSize48||T.isSize72||T.isSize100?{content:'""',width:"100%",height:j,backgroundColor:w,transform:"translateY(-50%) rotate(-45deg)",position:"absolute",top:"50%",left:0}:void 0},o[Rn]={selectors:{":after":{width:"calc(100% - 4px)",left:"2px",backgroundColor:"Window"}}},o)}],C.isBusy&&aH(w),C.isDoNotDisturb&&aH(D),C.isOffline&&aH(F),(L||C.isBlocked)&&[{backgroundColor:B,selectors:(l={":before":{content:'""',width:"100%",height:"100%",position:"absolute",top:0,left:0,border:"".concat(j," solid ").concat(w),borderRadius:"50%",boxSizing:"border-box"}},l[Rn]={backgroundColor:"WindowText",selectors:{":before":{width:"calc(100% - 2px)",height:"calc(100% - 2px)",top:"1px",left:"1px",borderColor:"Window"}}},l)}],L&&C.isAvailable&&i5(j,E),L&&C.isBusy&&i5(j,w),L&&C.isAway&&i5(j,x),L&&C.isDoNotDisturb&&i5(j,D),L&&C.isOffline&&i5(j,F),L&&C.isOffline&&t.isOutOfOffice&&i5(j,x)],presenceIcon:[y.presenceIcon,{color:B,fontSize:"6px",lineHeight:Dv.size12,verticalAlign:"top",selectors:(d={},d[Rn]={color:"Window"},d)},T.isSize56&&{fontSize:"8px",lineHeight:Dv.size16},T.isSize72&&{fontSize:f.small.fontSize,lineHeight:Dv.size20},T.isSize100&&{fontSize:f.medium.fontSize,lineHeight:Dv.size28},T.isSize120&&{fontSize:f.medium.fontSize,lineHeight:Dv.size32},C.isAway&&{position:"relative",left:L?void 0:"1px"},L&&C.isAvailable&&t5(E),L&&C.isBusy&&t5(w),L&&C.isAway&&t5(x),L&&C.isDoNotDisturb&&t5(D),L&&C.isOffline&&t5(F),L&&C.isOffline&&t.isOutOfOffice&&t5(x)]}};function t5(t){return{color:t,borderColor:t}}function i5(t,e){return{selectors:{":before":{border:"".concat(t," solid ").concat(e)}}}}function n5(t){return{height:t,width:t}}function aH(t){return{backgroundColor:t}}var KEe=vu(WEe,Ant,void 0,{scope:"PersonaPresence"}),JEe=[ls.lightBlue,ls.blue,ls.darkBlue,ls.teal,ls.green,ls.darkGreen,ls.lightPink,ls.pink,ls.magenta,ls.purple,ls.orange,ls.lightRed,ls.darkRed,ls.violet,ls.gold,ls.burgundy,ls.warmGray,ls.cyan,ls.rust,ls.coolGray],Int=JEe.length;function wnt(t){var e=ls.blue;if(!t)return e;for(var i=0,r=t.length-1;r>=0;r--){var o=t.charCodeAt(r),l=r%8;i^=(o<<l)+(o>>8-l)}return e=JEe[i%Int],e}function knt(t){switch(t){case ls.lightBlue:return"#4F6BED";case ls.blue:return"#0078D4";case ls.darkBlue:return"#004E8C";case ls.teal:return"#038387";case ls.lightGreen:case ls.green:return"#498205";case ls.darkGreen:return"#0B6A0B";case ls.lightPink:return"#C239B3";case ls.pink:return"#E3008C";case ls.magenta:return"#881798";case ls.purple:return"#5C2E91";case ls.orange:return"#CA5010";case ls.red:return"#EE1111";case ls.lightRed:return"#D13438";case ls.darkRed:return"#A4262C";case ls.transparent:return"transparent";case ls.violet:return"#8764B8";case ls.gold:return"#986F0B";case ls.burgundy:return"#750B1C";case ls.warmGray:return"#7A7574";case ls.cyan:return"#005B70";case ls.rust:return"#8E562E";case ls.coolGray:return"#69797E";case ls.black:return"#1D1D1D";case ls.gray:return"#393939"}}function Rnt(t){var e=t.primaryText,i=t.text,r=t.initialsColor,o;return typeof r=="string"?o=r:(r=r!==void 0?r:wnt(i||e),o=knt(r)),o}var YEe=fu({cacheSize:100}),Mnt=ql(function(t,e,i,r,o,l){return It(t,!l&&{backgroundColor:Rnt({text:r,initialsColor:e,primaryText:o}),color:i})}),QEe={size:Io.size48,presence:IC.none,imageAlt:""};function Pnt(t){process.env.NODE_ENV!=="production"&&CM({name:"PersonaCoin",props:t,deprecations:{primaryText:"text"}})}function Dnt(t){var e=t.onPhotoLoadingStateChange,i=t.imageUrl,r=$.useState(Dm.notLoaded),o=r[0],l=r[1];$.useEffect(function(){l(Dm.notLoaded)},[i]);var d=function(h){l(h),e?.(h)};return[o,d]}var ZEe=$.forwardRef(function(t,e){var i=Lw(QEe,t);Pnt(i);var r=Dnt(i),o=r[0],l=r[1],d=Lnt(l),h=i.className,p=i.coinProps,g=i.showUnknownPersonaCoin,f=i.coinSize,y=i.styles,T=i.imageUrl,C=i.initialsColor,E=i.initialsTextColor,I=i.isOutOfOffice,w=i.onRenderCoin,D=w===void 0?d:w,F=i.onRenderPersonaCoin,x=F===void 0?D:F,B=i.onRenderInitials,L=B===void 0?XEe:B,z=i.presence,H=i.presenceTitle,j=i.presenceColors,J=i.primaryText,Z=i.showInitialsUntilImageLoads,re=i.text,ne=i.theme,le=i.size,he=Wl(i,Nf),Me=Wl(p||{},Nf),Le=f?{width:f,height:f}:void 0,pe=g,te={coinSize:f,isOutOfOffice:I,presence:z,presenceTitle:H,presenceColors:j,size:le,theme:ne},Se=YEe(y,{theme:ne,className:p&&p.className?p.className:h,size:le,coinSize:f,showUnknownPersonaCoin:g}),ce=!!(o!==Dm.loaded&&(Z&&T||!T||o===Dm.error||pe));return $.createElement("div",Rt({role:"presentation"},he,{className:Se.coin,ref:e}),le!==Io.size8&&le!==Io.size10&&le!==Io.tiny?$.createElement("div",Rt({role:"presentation"},Me,{className:Se.imageArea,style:Le}),ce&&$.createElement("div",{className:Mnt(Se.initials,C,E,re,J,g),style:Le,"aria-hidden":"true"},L(i,XEe)),!pe&&x(i,d),$.createElement(KEe,Rt({},te))):i.presence?$.createElement(KEe,Rt({},te)):$.createElement(Fr,{iconName:"Contact",className:Se.size10WithoutPresenceIcon}),i.children)});ZEe.displayName="PersonaCoinBase";var Lnt=function(t){return function(e){var i=e.coinSize,r=e.styles,o=e.imageUrl,l=e.imageAlt,d=e.imageShouldFadeIn,h=e.imageShouldStartVisible,p=e.theme,g=e.showUnknownPersonaCoin,f=e.size,y=f===void 0?QEe.size:f;if(!o)return null;var T=YEe(r,{theme:p,size:y,showUnknownPersonaCoin:g}),C=i||VEe[y];return $.createElement(nH,{className:T.image,imageFit:qS.cover,src:o,width:C,height:C,alt:l,shouldFadeIn:d,shouldStartVisible:h,onLoadingStateChange:t})}},XEe=function(t){var e=t.imageInitials,i=t.allowPhoneInitials,r=t.showUnknownPersonaCoin,o=t.text,l=t.primaryText,d=t.theme;if(r)return $.createElement(Fr,{iconName:"Help"});var h=Of(d);return e=e||set(o||l||"",h,i),e!==""?$.createElement("span",null,e):$.createElement(Fr,{iconName:"Contact"})},Ont={coin:"ms-Persona-coin",imageArea:"ms-Persona-imageArea",image:"ms-Persona-image",initials:"ms-Persona-initials",size8:"ms-Persona--size8",size10:"ms-Persona--size10",size16:"ms-Persona--size16",size24:"ms-Persona--size24",size28:"ms-Persona--size28",size32:"ms-Persona--size32",size40:"ms-Persona--size40",size48:"ms-Persona--size48",size56:"ms-Persona--size56",size72:"ms-Persona--size72",size100:"ms-Persona--size100",size120:"ms-Persona--size120"},Nnt=function(t){var e,i=t.className,r=t.theme,o=t.coinSize,l=r.palette,d=r.fonts,h=lW(t.size),p=eh(Ont,r),g="rgb(234, 234, 234)",f="rgb(168, 0, 0)",y=o||t.size&&VEe[t.size]||48;return{coin:[p.coin,d.medium,h.isSize8&&p.size8,h.isSize10&&p.size10,h.isSize16&&p.size16,h.isSize24&&p.size24,h.isSize28&&p.size28,h.isSize32&&p.size32,h.isSize40&&p.size40,h.isSize48&&p.size48,h.isSize56&&p.size56,h.isSize72&&p.size72,h.isSize100&&p.size100,h.isSize120&&p.size120,i],size10WithoutPresenceIcon:{fontSize:d.xSmall.fontSize,position:"absolute",top:"5px",right:"auto",left:0},imageArea:[p.imageArea,{position:"relative",textAlign:"center",flex:"0 0 auto",height:y,width:y},y<=10&&{overflow:"visible",background:"transparent",height:0,width:0}],image:[p.image,{marginRight:"10px",position:"absolute",top:0,left:0,width:"100%",height:"100%",border:0,borderRadius:"50%",perspective:"1px"},y<=10&&{overflow:"visible",background:"transparent",height:0,width:0},y>10&&{height:y,width:y}],initials:[p.initials,{borderRadius:"50%",color:t.showUnknownPersonaCoin?f:l.white,fontSize:d.large.fontSize,fontWeight:xs.semibold,lineHeight:y===48?46:y,height:y,selectors:(e={},e[Rn]=Rt(Rt({border:"1px solid WindowText"},uc()),{color:"WindowText",boxSizing:"border-box",backgroundColor:"Window !important"}),e.i={fontWeight:xs.semibold},e)},t.showUnknownPersonaCoin&&{backgroundColor:g},y<32&&{fontSize:d.xSmall.fontSize},y>=32&&y<40&&{fontSize:d.medium.fontSize},y>=40&&y<56&&{fontSize:d.mediumPlus.fontSize},y>=56&&y<72&&{fontSize:d.xLarge.fontSize},y>=72&&y<100&&{fontSize:d.xxLarge.fontSize},y>=100&&{fontSize:d.superLarge.fontSize}]}},xnt=vu(ZEe,Nnt,void 0,{scope:"PersonaCoin"}),Bnt=fu(),Fnt={size:Io.size48,presence:IC.none,imageAlt:"",showOverflowTooltip:!0};function Unt(t){process.env.NODE_ENV!=="production"&&CM({name:"Persona",props:t,deprecations:{primaryText:"text"}})}var e0e=$.forwardRef(function(t,e){var i=Lw(Fnt,t);Unt(i);var r=$.useRef(null),o=Ff(e,r),l=function(){return i.text||i.primaryText||""},d=function(Ke,ot,Ht){var jt=ot&&ot(i,Ht);return jt?$.createElement("div",{dir:"auto",className:Ke},jt):void 0},h=function(Ke,ot){return ot===void 0&&(ot=!0),Ke?ot?function(){return $.createElement(AC,{content:Ke,overflowMode:e5.Parent,directionalHint:hd.topLeftEdge},Ke)}:function(){return $.createElement($.Fragment,null,Ke)}:void 0},p=function(Ke){return $.createElement(xnt,Rt({},Ke))},g=h(l(),i.showOverflowTooltip),f=h(i.secondaryText,i.showOverflowTooltip),y=h(i.tertiaryText,i.showOverflowTooltip),T=h(i.optionalText,i.showOverflowTooltip),C=i.hidePersonaDetails,E=i.onRenderOptionalText,I=E===void 0?T:E,w=i.onRenderPrimaryText,D=w===void 0?g:w,F=i.onRenderSecondaryText,x=F===void 0?f:F,B=i.onRenderTertiaryText,L=B===void 0?y:B,z=i.onRenderPersonaCoin,H=z===void 0?p:z,j=i.size,J=i.allowPhoneInitials,Z=i.className,re=i.coinProps,ne=i.showUnknownPersonaCoin,le=i.coinSize,he=i.styles,Me=i.imageAlt,Le=i.imageInitials,pe=i.imageShouldFadeIn,te=i.imageShouldStartVisible,Se=i.imageUrl,ce=i.initialsColor,X=i.initialsTextColor,ve=i.isOutOfOffice,Te=i.onPhotoLoadingStateChange,Be=i.onRenderCoin,qe=i.onRenderInitials,Ge=i.presence,tt=i.presenceTitle,ct=i.presenceColors,Mt=i.showInitialsUntilImageLoads,ht=i.showSecondaryText,vt=i.theme,Pt=Rt({allowPhoneInitials:J,showUnknownPersonaCoin:ne,coinSize:le,imageAlt:Me,imageInitials:Le,imageShouldFadeIn:pe,imageShouldStartVisible:te,imageUrl:Se,initialsColor:ce,initialsTextColor:X,onPhotoLoadingStateChange:Te,onRenderCoin:Be,onRenderInitials:qe,presence:Ge,presenceTitle:tt,showInitialsUntilImageLoads:Mt,size:j,text:l(),isOutOfOffice:ve,presenceColors:ct},re),ni=Bnt(he,{theme:vt,className:Z,showSecondaryText:ht,presence:Ge,size:j}),Zt=Wl(i,Nf),it=$.createElement("div",{className:ni.details},d(ni.primaryText,D,g),d(ni.secondaryText,x,f),d(ni.tertiaryText,L,y),d(ni.optionalText,I,T),i.children);return $.createElement("div",Rt({},Zt,{ref:o,className:ni.root,style:le?{height:le,minWidth:le}:void 0}),H(Pt,H),(!C||j===Io.size8||j===Io.size10||j===Io.tiny)&&it)});e0e.displayName="PersonaBase";var znt={root:"ms-Persona",size8:"ms-Persona--size8",size10:"ms-Persona--size10",size16:"ms-Persona--size16",size24:"ms-Persona--size24",size28:"ms-Persona--size28",size32:"ms-Persona--size32",size40:"ms-Persona--size40",size48:"ms-Persona--size48",size56:"ms-Persona--size56",size72:"ms-Persona--size72",size100:"ms-Persona--size100",size120:"ms-Persona--size120",available:"ms-Persona--online",away:"ms-Persona--away",blocked:"ms-Persona--blocked",busy:"ms-Persona--busy",doNotDisturb:"ms-Persona--donotdisturb",offline:"ms-Persona--offline",details:"ms-Persona-details",primaryText:"ms-Persona-primaryText",secondaryText:"ms-Persona-secondaryText",tertiaryText:"ms-Persona-tertiaryText",optionalText:"ms-Persona-optionalText",textContent:"ms-Persona-textContent"},Vnt=function(t){var e=t.className,i=t.showSecondaryText,r=t.theme,o=r.semanticColors,l=r.fonts,d=eh(znt,r),h=lW(t.size),p=$Ee(t.presence),g="16px",f={color:o.bodySubtext,fontWeight:xs.regular,fontSize:l.small.fontSize};return{root:[d.root,r.fonts.medium,sx,{color:o.bodyText,position:"relative",height:qd.size48,minWidth:qd.size48,display:"flex",alignItems:"center",selectors:{".contextualHost":{display:"none"}}},h.isSize8&&[d.size8,{height:qd.size8,minWidth:qd.size8}],h.isSize10&&[d.size10,{height:qd.size10,minWidth:qd.size10}],h.isSize16&&[d.size16,{height:qd.size16,minWidth:qd.size16}],h.isSize24&&[d.size24,{height:qd.size24,minWidth:qd.size24}],h.isSize24&&i&&{height:"36px"},h.isSize28&&[d.size28,{height:qd.size28,minWidth:qd.size28}],h.isSize28&&i&&{height:"32px"},h.isSize32&&[d.size32,{height:qd.size32,minWidth:qd.size32}],h.isSize40&&[d.size40,{height:qd.size40,minWidth:qd.size40}],h.isSize48&&d.size48,h.isSize56&&[d.size56,{height:qd.size56,minWidth:qd.size56}],h.isSize72&&[d.size72,{height:qd.size72,minWidth:qd.size72}],h.isSize100&&[d.size100,{height:qd.size100,minWidth:qd.size100}],h.isSize120&&[d.size120,{height:qd.size120,minWidth:qd.size120}],p.isAvailable&&d.available,p.isAway&&d.away,p.isBlocked&&d.blocked,p.isBusy&&d.busy,p.isDoNotDisturb&&d.doNotDisturb,p.isOffline&&d.offline,e],details:[d.details,{padding:"0 24px 0 16px",minWidth:0,width:"100%",textAlign:"left",display:"flex",flexDirection:"column",justifyContent:"space-around"},(h.isSize8||h.isSize10)&&{paddingLeft:17},(h.isSize24||h.isSize28||h.isSize32)&&{padding:"0 8px"},(h.isSize40||h.isSize48)&&{padding:"0 12px"}],primaryText:[d.primaryText,J$,{color:o.bodyText,fontWeight:xs.regular,fontSize:l.medium.fontSize,selectors:{":hover":{color:o.inputTextHovered}}},i&&{height:g,lineHeight:g,overflowX:"hidden"},(h.isSize8||h.isSize10)&&{fontSize:l.small.fontSize,lineHeight:qd.size8},h.isSize16&&{lineHeight:qd.size28},(h.isSize24||h.isSize28||h.isSize32||h.isSize40||h.isSize48)&&i&&{height:18},(h.isSize56||h.isSize72||h.isSize100||h.isSize120)&&{fontSize:l.xLarge.fontSize},(h.isSize56||h.isSize72||h.isSize100||h.isSize120)&&i&&{height:22}],secondaryText:[d.secondaryText,J$,f,(h.isSize8||h.isSize10||h.isSize16||h.isSize24||h.isSize28||h.isSize32)&&{display:"none"},i&&{display:"block",height:g,lineHeight:g,overflowX:"hidden"},h.isSize24&&i&&{height:18},(h.isSize56||h.isSize72||h.isSize100||h.isSize120)&&{fontSize:l.medium.fontSize},(h.isSize56||h.isSize72||h.isSize100||h.isSize120)&&i&&{height:18}],tertiaryText:[d.tertiaryText,J$,f,{display:"none",fontSize:l.medium.fontSize},(h.isSize72||h.isSize100||h.isSize120)&&{display:"block"}],optionalText:[d.optionalText,J$,f,{display:"none",fontSize:l.medium.fontSize},(h.isSize100||h.isSize120)&&{display:"block"}],textContent:[d.textContent,J$]}},ux=vu(e0e,Vnt,void 0,{scope:"Persona"}),Are={all:1,inputOnly:2},Lm;(function(t){t[t.vertical=0]="vertical",t[t.horizontal=1]="horizontal",t[t.bidirectional=2]="bidirectional",t[t.domOrder=3]="domOrder"})(Lm||(Lm={}));var cW="data-is-focusable",$nt="data-disable-click-on-enter",Ire="data-focuszone-id",xw="tabindex",wre="data-no-vertical-wrap",kre="data-no-horizontal-wrap",Rre=999999999,rH=-999999999,Mre,Hnt="ms-FocusZone";function jnt(t,e){var i;typeof MouseEvent=="function"?i=new MouseEvent("click",{ctrlKey:e?.ctrlKey,metaKey:e?.metaKey,shiftKey:e?.shiftKey,altKey:e?.altKey,bubbles:e?.bubbles,cancelable:e?.cancelable}):(i=document.createEvent("MouseEvents"),i.initMouseEvent("click",e?e.bubbles:!1,e?e.cancelable:!1,window,0,0,0,0,0,e?e.ctrlKey:!1,e?e.altKey:!1,e?e.shiftKey:!1,e?e.metaKey:!1,0,null)),t.dispatchEvent(i)}function Gnt(){return Mre||(Mre=It({selectors:{":focus":{outline:"none"}}},Hnt)),Mre}var oH={},dW=new Set,qnt=["text","number","password","email","tel","url","search","textarea"],EM=!1,hA=function(t){mu(e,t);function e(i){var r,o,l,d,h=t.call(this,i)||this;h._root=$.createRef(),h._mergedRef=iEe(),h._onFocus=function(g){if(!h._portalContainsElement(g.target)){var f=h.props,y=f.onActiveElementChanged,T=f.doNotAllowFocusEventToPropagate,C=f.stopFocusPropagation,E=f.onFocusNotification,I=f.onFocus,w=f.shouldFocusInnerElementWhenReceivedFocus,D=f.defaultTabbableElement,F=h._isImmediateDescendantOfZone(g.target),x;if(F)x=g.target;else for(var B=g.target;B&&B!==h._root.current;){if(Pw(B,void 0,h._inShadowRoot)&&h._isImmediateDescendantOfZone(B)){x=B;break}B=Mw(B,EM)}if(w&&g.target===h._root.current){var L=D&&typeof D=="function"&&h._root.current&&D(h._root.current);L&&Pw(L,void 0,h._inShadowRoot)?(x=L,L.focus()):(h.focus(!0),h._activeElement&&(x=null))}var z=!h._activeElement;x&&x!==h._activeElement&&((F||z)&&h._setFocusAlignment(x,!0,!0),h._activeElement=x,z&&h._updateTabIndexes()),y&&y(h._activeElement,g),(C||T)&&g.stopPropagation(),I?I(g):E&&E()}},h._onBlur=function(){h._setParkedFocus(!1)},h._onMouseDown=function(g){if(!h._portalContainsElement(g.target)){var f=h.props.disabled;if(!f){for(var y=g.target,T=[];y&&y!==h._root.current;)T.push(y),y=Mw(y,EM);for(;T.length&&(y=T.pop(),y&&Pw(y,void 0,h._inShadowRoot)&&h._setActiveElement(y,!0),!SM(y)););}}},h._onKeyDown=function(g,f){if(!h._portalContainsElement(g.target)){var y=h.props,T=y.direction,C=y.disabled,E=y.isInnerZoneKeystroke,I=y.pagingSupportDisabled,w=y.shouldEnterInnerZone;if(!C&&(h.props.onKeyDown&&h.props.onKeyDown(g),!g.isDefaultPrevented()&&!(h._getDocument().activeElement===h._root.current&&h._isInnerZone))){if((w&&w(g)||E&&E(g))&&h._isImmediateDescendantOfZone(g.target)){var D=h._getFirstInnerZone();if(D){if(!D.focus(!0))return}else if(jae(g.target)){if(!h.focusElement(By(g.target,g.target.firstChild,!0)))return}else return}else{if(g.altKey)return;switch(g.which){case fa.space:if(h._shouldRaiseClicksOnSpace&&h._tryInvokeClickForFocusable(g.target,g))break;return;case fa.left:if(T!==Lm.vertical&&(h._preventDefaultWhenHandled(g),h._moveFocusLeft(f)))break;return;case fa.right:if(T!==Lm.vertical&&(h._preventDefaultWhenHandled(g),h._moveFocusRight(f)))break;return;case fa.up:if(T!==Lm.horizontal&&(h._preventDefaultWhenHandled(g),h._moveFocusUp()))break;return;case fa.down:if(T!==Lm.horizontal&&(h._preventDefaultWhenHandled(g),h._moveFocusDown()))break;return;case fa.pageDown:if(!I&&h._moveFocusPaging(!0))break;return;case fa.pageUp:if(!I&&h._moveFocusPaging(!1))break;return;case fa.tab:if(h.props.allowTabKey||h.props.handleTabKey===Are.all||h.props.handleTabKey===Are.inputOnly&&h._isElementInput(g.target)){var F=!1;if(h._processingTabKey=!0,T===Lm.vertical||!h._shouldWrapFocus(h._activeElement,kre))F=g.shiftKey?h._moveFocusUp():h._moveFocusDown();else{var x=Of(f)?!g.shiftKey:g.shiftKey;F=x?h._moveFocusLeft(f):h._moveFocusRight(f)}if(h._processingTabKey=!1,F)break;h.props.shouldResetActiveElementWhenTabFromZone&&(h._activeElement=null)}return;case fa.home:if(h._isContentEditableElement(g.target)||h._isElementInput(g.target)&&!h._shouldInputLoseFocus(g.target,!1))return!1;var B=h._root.current&&h._root.current.firstChild;if(h._root.current&&B&&h.focusElement(By(h._root.current,B,!0)))break;return;case fa.end:if(h._isContentEditableElement(g.target)||h._isElementInput(g.target)&&!h._shouldInputLoseFocus(g.target,!0))return!1;var L=h._root.current&&h._root.current.lastChild;if(h._root.current&&h.focusElement(jS(h._root.current,L,!0,!0,!0)))break;return;case fa.enter:if(h._shouldRaiseClicksOnEnter&&h._tryInvokeClickForFocusable(g.target,g))break;return;default:return}}g.preventDefault(),g.stopPropagation()}}},h._getHorizontalDistanceFromCenter=function(g,f,y){var T=h._focusAlignment.left||h._focusAlignment.x||0,C=Math.floor(y.top),E=Math.floor(f.bottom),I=Math.floor(y.bottom),w=Math.floor(f.top),D=g&&C>E,F=!g&&I<w;return D||F?T>=y.left&&T<=y.left+y.width?0:Math.abs(y.left+y.width/2-T):h._shouldWrapFocus(h._activeElement,wre)?Rre:rH},Dw(h),process.env.NODE_ENV!=="production"&&fL("FocusZone",i,{rootProps:void 0,allowTabKey:"handleTabKey",elementType:"as",ariaDescribedBy:"aria-describedby",ariaLabelledBy:"aria-labelledby"}),h._id=bp("FocusZone"),h._focusAlignment={left:0,top:0},h._processingTabKey=!1;var p=(o=(r=i.shouldRaiseClicks)!==null&&r!==void 0?r:e.defaultProps.shouldRaiseClicks)!==null&&o!==void 0?o:!0;return h._shouldRaiseClicksOnEnter=(l=i.shouldRaiseClicksOnEnter)!==null&&l!==void 0?l:p,h._shouldRaiseClicksOnSpace=(d=i.shouldRaiseClicksOnSpace)!==null&&d!==void 0?d:p,h}return e.getOuterZones=function(){return dW.size},e._onKeyDownCapture=function(i){i.which===fa.tab&&dW.forEach(function(r){return r._updateTabIndexes()})},e.prototype.componentDidMount=function(){var i,r=this._root.current;if(this._inShadowRoot=!!(!((i=this.context)===null||i===void 0)&&i.shadowRoot),oH[this._id]=this,r){for(var o=Mw(r,EM);o&&o!==this._getDocument().body&&o.nodeType===1;){if(SM(o)){this._isInnerZone=!0;break}o=Mw(o,EM)}this._isInnerZone||(dW.add(this),this._root.current&&this._root.current.addEventListener("keydown",e._onKeyDownCapture,!0)),this._root.current&&this._root.current.addEventListener("blur",this._onBlur,!0),this._updateTabIndexes(),this.props.defaultTabbableElement&&typeof this.props.defaultTabbableElement=="string"?this._activeElement=this._getDocument().querySelector(this.props.defaultTabbableElement):this.props.defaultActiveElement&&(this._activeElement=this._getDocument().querySelector(this.props.defaultActiveElement)),this.props.shouldFocusOnMount&&this.focus()}},e.prototype.componentDidUpdate=function(){var i,r=this._root.current,o=this._getDocument();if(this._inShadowRoot=!!(!((i=this.context)===null||i===void 0)&&i.shadowRoot),(this._activeElement&&!xy(this._root.current,this._activeElement,EM)||this._defaultFocusElement&&!xy(this._root.current,this._defaultFocusElement,EM))&&(this._activeElement=null,this._defaultFocusElement=null,this._updateTabIndexes()),!this.props.preventFocusRestoration&&o&&this._lastIndexPath&&(o.activeElement===o.body||o.activeElement===null||o.activeElement===r)){var l=$Ze(r,this._lastIndexPath);l?(this._setActiveElement(l,!0),l.focus(),this._setParkedFocus(!1)):this._setParkedFocus(!0)}},e.prototype.componentWillUnmount=function(){delete oH[this._id],this._isInnerZone||(dW.delete(this),this._root.current&&this._root.current.removeEventListener("keydown",e._onKeyDownCapture,!0)),this._root.current&&this._root.current.removeEventListener("blur",this._onBlur,!0),this._activeElement=null,this._defaultFocusElement=null},e.prototype.render=function(){var i=this,r=this.props,o=r.as,l=r.elementType,d=r.rootProps,h=r.ariaDescribedBy,p=r.ariaLabelledBy,g=r.className,f=Wl(this.props,Lu),y=o||l||"div";this._evaluateFocusBeforeRender();var T=gEe();return $.createElement(y,Rt({"aria-labelledby":p,"aria-describedby":h},f,d,{className:wh(Gnt(),g),ref:this._mergedRef(this.props.elementRef,this._root),"data-focuszone-id":this._id,onKeyDown:function(C){return i._onKeyDown(C,T)},onFocus:this._onFocus,onMouseDownCapture:this._onMouseDown}),this.props.children)},e.prototype.focus=function(i,r){if(i===void 0&&(i=!1),r===void 0&&(r=!1),this._root.current)if(!i&&this._root.current.getAttribute(cW)==="true"&&this._isInnerZone){var o=this._getOwnerZone(this._root.current);if(o!==this._root.current){var l=oH[o.getAttribute(Ire)];return!!l&&l.focusElement(this._root.current)}return!1}else{if(!i&&this._activeElement&&xy(this._root.current,this._activeElement)&&Pw(this._activeElement,void 0,this._inShadowRoot)&&(!r||m_e(this._activeElement)))return this._activeElement.focus(),!0;var d=this._root.current.firstChild;return this.focusElement(By(this._root.current,d,!0,void 0,void 0,void 0,void 0,void 0,r))}return!1},e.prototype.focusLast=function(){if(this._root.current){var i=this._root.current&&this._root.current.lastChild;return this.focusElement(jS(this._root.current,i,!0,!0,!0))}return!1},e.prototype.focusElement=function(i,r){var o=this.props,l=o.onBeforeFocus,d=o.shouldReceiveFocus;return d&&!d(i)||l&&!l(i)?!1:i?(this._setActiveElement(i,r),this._activeElement&&this._activeElement.focus(),!0):!1},e.prototype.setFocusAlignment=function(i){this._focusAlignment=i},Object.defineProperty(e.prototype,"defaultFocusElement",{get:function(){return this._defaultFocusElement},enumerable:!1,configurable:!0}),Object.defineProperty(e.prototype,"activeElement",{get:function(){return this._activeElement},enumerable:!1,configurable:!0}),e.prototype._evaluateFocusBeforeRender=function(){var i=this._root.current,r=this._getDocument();if(r){var o=r.activeElement;if(o!==i){var l=xy(i,o,!1);this._lastIndexPath=l?HZe(i,o):void 0}}},e.prototype._setParkedFocus=function(i){var r=this._root.current;r&&this._isParked!==i&&(this._isParked=i,i?(this.props.allowFocusRoot||(this._parkedTabIndex=r.getAttribute("tabindex"),r.setAttribute("tabindex","-1")),r.focus()):this.props.allowFocusRoot||(this._parkedTabIndex?(r.setAttribute("tabindex",this._parkedTabIndex),this._parkedTabIndex=void 0):r.removeAttribute("tabindex")))},e.prototype._setActiveElement=function(i,r){var o=this._activeElement;this._activeElement=i,o&&(SM(o)&&this._updateTabIndexes(o),o.tabIndex=-1),this._activeElement&&((!this._focusAlignment||r)&&this._setFocusAlignment(i,!0,!0),this._activeElement.tabIndex=0)},e.prototype._preventDefaultWhenHandled=function(i){this.props.preventDefaultWhenHandled&&i.preventDefault()},e.prototype._tryInvokeClickForFocusable=function(i,r){var o=i;if(o===this._root.current)return!1;do{if(o.tagName==="BUTTON"||o.tagName==="A"||o.tagName==="INPUT"||o.tagName==="TEXTAREA"||o.tagName==="SUMMARY")return!1;if(this._isImmediateDescendantOfZone(o)&&o.getAttribute(cW)==="true"&&o.getAttribute($nt)!=="true")return jnt(o,r),!0;o=Mw(o,EM)}while(o!==this._root.current);return!1},e.prototype._getFirstInnerZone=function(i){if(i=i||this._activeElement||this._root.current,!i)return null;if(SM(i))return oH[i.getAttribute(Ire)];for(var r=i.firstElementChild;r;){if(SM(r))return oH[r.getAttribute(Ire)];var o=this._getFirstInnerZone(r);if(o)return o;r=r.nextElementSibling}return null},e.prototype._moveFocus=function(i,r,o,l){l===void 0&&(l=!0);var d=this._activeElement,h=-1,p=void 0,g=!1,f=this.props.direction===Lm.bidirectional;if(!d||!this._root.current||this._isElementInput(d)&&!this._shouldInputLoseFocus(d,i))return!1;var y=f?d.getBoundingClientRect():null;do if(d=i?By(this._root.current,d):jS(this._root.current,d),f){if(d){var T=d.getBoundingClientRect(),C=r(y,T);if(C===-1&&h===-1){p=d;break}if(C>-1&&(h===-1||C<h)&&(h=C,p=d),h>=0&&C<0)break}}else{p=d;break}while(d);if(p&&p!==this._activeElement)g=!0,this.focusElement(p);else if(this.props.isCircularNavigation&&l)return i?this.focusElement(By(this._root.current,this._root.current.firstElementChild,!0)):this.focusElement(jS(this._root.current,this._root.current.lastElementChild,!0,!0,!0));return g},e.prototype._moveFocusDown=function(){var i=this,r=-1,o=this._focusAlignment.left||this._focusAlignment.x||0;return this._moveFocus(!0,function(l,d){var h=-1,p=Math.floor(d.top),g=Math.floor(l.bottom);return p<g?i._shouldWrapFocus(i._activeElement,wre)?Rre:rH:((r===-1&&p>=g||p===r)&&(r=p,o>=d.left&&o<=d.left+d.width?h=0:h=Math.abs(d.left+d.width/2-o)),h)})?(this._setFocusAlignment(this._activeElement,!1,!0),!0):!1},e.prototype._moveFocusUp=function(){var i=this,r=-1,o=this._focusAlignment.left||this._focusAlignment.x||0;return this._moveFocus(!1,function(l,d){var h=-1,p=Math.floor(d.bottom),g=Math.floor(d.top),f=Math.floor(l.top);return p>f?i._shouldWrapFocus(i._activeElement,wre)?Rre:rH:((r===-1&&p<=f||g===r)&&(r=g,o>=d.left&&o<=d.left+d.width?h=0:h=Math.abs(d.left+d.width/2-o)),h)})?(this._setFocusAlignment(this._activeElement,!1,!0),!0):!1},e.prototype._moveFocusLeft=function(i){var r=this,o=this._shouldWrapFocus(this._activeElement,kre);return this._moveFocus(Of(i),function(l,d){var h=-1,p;return Of(i)?p=parseFloat(d.top.toFixed(3))<parseFloat(l.bottom.toFixed(3)):p=parseFloat(d.bottom.toFixed(3))>parseFloat(l.top.toFixed(3)),p&&d.right<=l.right&&r.props.direction!==Lm.vertical?h=l.right-d.right:o||(h=rH),h},void 0,o)?(this._setFocusAlignment(this._activeElement,!0,!1),!0):!1},e.prototype._moveFocusRight=function(i){var r=this,o=this._shouldWrapFocus(this._activeElement,kre);return this._moveFocus(!Of(i),function(l,d){var h=-1,p;return Of(i)?p=parseFloat(d.bottom.toFixed(3))>parseFloat(l.top.toFixed(3)):p=parseFloat(d.top.toFixed(3))<parseFloat(l.bottom.toFixed(3)),p&&d.left>=l.left&&r.props.direction!==Lm.vertical?h=d.left-l.left:o||(h=rH),h},void 0,o)?(this._setFocusAlignment(this._activeElement,!0,!1),!0):!1},e.prototype._moveFocusPaging=function(i,r){r===void 0&&(r=!0);var o=this._activeElement;if(!o||!this._root.current||this._isElementInput(o)&&!this._shouldInputLoseFocus(o,i))return!1;var l=T_e(o);if(!l)return!1;var d=-1,h=void 0,p=-1,g=-1,f=l.clientHeight,y=o.getBoundingClientRect();do if(o=i?By(this._root.current,o):jS(this._root.current,o),o){var T=o.getBoundingClientRect(),C=Math.floor(T.top),E=Math.floor(y.bottom),I=Math.floor(T.bottom),w=Math.floor(y.top),D=this._getHorizontalDistanceFromCenter(i,y,T),F=i&&C>E+f,x=!i&&I<w-f;if(F||x)break;D>-1&&(i&&C>p?(p=C,d=D,h=o):!i&&I<g?(g=I,d=D,h=o):(d===-1||D<=d)&&(d=D,h=o))}while(o);var B=!1;if(h&&h!==this._activeElement)B=!0,this.focusElement(h),this._setFocusAlignment(h,!1,!0);else if(this.props.isCircularNavigation&&r)return i?this.focusElement(By(this._root.current,this._root.current.firstElementChild,!0)):this.focusElement(jS(this._root.current,this._root.current.lastElementChild,!0,!0,!0));return B},e.prototype._setFocusAlignment=function(i,r,o){if(this.props.direction===Lm.bidirectional&&(!this._focusAlignment||r||o)){var l=i.getBoundingClientRect(),d=l.left+l.width/2,h=l.top+l.height/2;this._focusAlignment||(this._focusAlignment={left:d,top:h}),r&&(this._focusAlignment.left=d),o&&(this._focusAlignment.top=h)}},e.prototype._isImmediateDescendantOfZone=function(i){return this._getOwnerZone(i)===this._root.current},e.prototype._getOwnerZone=function(i){for(var r=Mw(i,EM);r&&r!==this._root.current&&r!==this._getDocument().body;){if(SM(r))return r;r=Mw(r,EM)}return r},e.prototype._updateTabIndexes=function(i){!this._activeElement&&this.props.defaultTabbableElement&&typeof this.props.defaultTabbableElement=="function"&&(this._activeElement=this.props.defaultTabbableElement(this._root.current)),!i&&this._root.current&&(this._defaultFocusElement=null,i=this._root.current,this._activeElement&&!xy(i,this._activeElement)&&(this._activeElement=null)),this._activeElement&&!Pw(this._activeElement,void 0,this._inShadowRoot)&&(this._activeElement=null);for(var r=i&&i.children,o=0;r&&o<r.length;o++){var l=r[o];SM(l)?l.getAttribute(cW)==="true"&&(!this._isInnerZone&&(!this._activeElement&&!this._defaultFocusElement||this._activeElement===l)?(this._defaultFocusElement=l,l.getAttribute(xw)!=="0"&&l.setAttribute(xw,"0")):l.getAttribute(xw)!=="-1"&&l.setAttribute(xw,"-1")):(l.getAttribute&&l.getAttribute(cW)==="false"&&l.setAttribute(xw,"-1"),Pw(l,void 0,this._inShadowRoot)?this.props.disabled?l.setAttribute(xw,"-1"):!this._isInnerZone&&(!this._activeElement&&!this._defaultFocusElement||this._activeElement===l)?(this._defaultFocusElement=l,l.getAttribute(xw)!=="0"&&l.setAttribute(xw,"0")):l.getAttribute(xw)!=="-1"&&l.setAttribute(xw,"-1"):l.tagName==="svg"&&l.getAttribute("focusable")!=="false"&&l.setAttribute("focusable","false")),this._updateTabIndexes(l)}},e.prototype._isContentEditableElement=function(i){return i&&i.getAttribute("contenteditable")==="true"},e.prototype._isElementInput=function(i){return!!(i&&i.tagName&&(i.tagName.toLowerCase()==="input"||i.tagName.toLowerCase()==="textarea"))},e.prototype._shouldInputLoseFocus=function(i,r){if(!this._processingTabKey&&i&&i.type&&qnt.indexOf(i.type.toLowerCase())>-1){var o=i.selectionStart,l=i.selectionEnd,d=o!==l,h=i.value,p=i.readOnly;if(d||o>0&&!r&&!p||o!==h.length&&r&&!p||this.props.handleTabKey&&!(this.props.shouldInputLoseFocusOnArrowKey&&this.props.shouldInputLoseFocusOnArrowKey(i)))return!1}return!0},e.prototype._shouldWrapFocus=function(i,r){return this.props.checkForNoWrap?f_e(i,r):!0},e.prototype._portalContainsElement=function(i){return i&&!!this._root.current&&Hae(i,this._root.current)},e.prototype._getDocument=function(){return Gg(this._root.current)},e.contextType=D_e,e.defaultProps={isCircularNavigation:!1,direction:Lm.bidirectional,shouldRaiseClicks:!0,"data-tabster":'{"uncontrolled": {}}'},e}($.Component),Wnt=fu(),Knt=function(t,e){var i=t.as,r=t.className,o=t.disabled,l=t.href,d=t.onClick,h=t.styles,p=t.theme,g=t.underline,f=$.useRef(null),y=Ff(f,e);Jnt(t,f),j$(f);var T=Wnt(h,{className:r,isButton:!l,isDisabled:o,isUnderlined:g,theme:p}),C=function(F){o?F.preventDefault():d&&d(F)},E=i||(l?"a":"button"),I={},w={root:E},D={root:Rt(Rt({},Ynt(E,t)),{"aria-disabled":o,className:T.root,onClick:C,ref:y})};return{state:I,slots:w,slotProps:D}},Jnt=function(t,e){$.useImperativeHandle(t.componentRef,function(){return{focus:function(){e.current&&e.current.focus()}}},[e])},Ynt=function(t,e){e.as;var i=e.disabled,r=e.target,o=e.href;e.theme,e.getStyles,e.styles,e.componentRef,e.underline;var l=Mm(e,["as","disabled","target","href","theme","getStyles","styles","componentRef","underline"]);return typeof t=="string"?t==="a"?Rt({target:r,href:i?void 0:o},l):t==="button"?Rt({type:"button",disabled:i},l):Rt(Rt({},l),{disabled:i}):Rt({target:r,href:o,disabled:i},l)},t0e=$.forwardRef(function(t,e){var i=Knt(t,e),r=i.slots,o=i.slotProps;return $.createElement(r.root,Rt({},o.root))});t0e.displayName="LinkBase";var Qnt={root:"ms-Link"},Znt=function(t){var e,i,r,o,l,d,h,p=t.className,g=t.isButton,f=t.isDisabled,y=t.isUnderlined,T=t.theme,C=T.semanticColors,E=C.link,I=C.linkHovered,w=C.disabledText,D=C.focusBorder,F=eh(Qnt,T);return{root:[F.root,T.fonts.medium,{color:E,outline:"none",fontSize:"inherit",fontWeight:"inherit",textDecoration:y?"underline":"none",selectors:(e={},e[".".concat(ys," &:focus, :host(.").concat(ys,") &:focus")]={boxShadow:"0 0 0 1px ".concat(D," inset"),outline:"1px auto ".concat(D),selectors:(i={},i[Rn]={outline:"1px solid WindowText"},i)},e[Rn]={borderBottom:"none"},e)},g&&{background:"none",backgroundColor:"transparent",border:"none",cursor:"pointer",display:"inline",margin:0,overflow:"inherit",padding:0,textAlign:"left",textOverflow:"inherit",userSelect:"text",borderBottom:"1px solid transparent",selectors:(r={},r[Rn]={color:"LinkText",forcedColorAdjust:"none"},r)},!g&&{selectors:(o={},o[Rn]={MsHighContrastAdjust:"auto",forcedColorAdjust:"auto"},o)},f&&["is-disabled",{color:w,cursor:"default"},{selectors:(l={"&:link, &:visited":{pointerEvents:"none"}},l[Rn]={color:"GrayText"},l)}],!f&&{selectors:{"&:active, &:hover, &:active:hover":{color:I,textDecoration:"underline",selectors:(d={},d[Rn]={color:"LinkText"},d)},"&:focus":{color:E,selectors:(h={},h[Rn]={color:"LinkText"},h)}}},F.root,p]}},uW=vu(t0e,Znt,void 0,{scope:"Link"}),Cp;(function(t){t[t.Normal=0]="Normal",t[t.Divider=1]="Divider",t[t.Header=2]="Header",t[t.Section=3]="Section"})(Cp||(Cp={}));function a5(t){return t.canCheck?!!(t.isChecked||t.checked):typeof t.isChecked=="boolean"?t.isChecked:typeof t.checked=="boolean"?t.checked:null}function AM(t){return!!(t.subMenuProps||t.items)}function Bw(t){return!!(t.isDisabled||t.disabled)}function i0e(t){var e=a5(t),i=e!==null;return i?"menuitemcheckbox":"menuitem"}var n0e=function(t){var e=t.item,i=t.classNames,r=e.iconProps;return $.createElement(Fr,Rt({},r,{className:i.icon}))},Xnt=function(t){var e=t.item,i=t.hasIcons;return i?e.onRenderIcon?e.onRenderIcon(t,n0e):n0e(t):null},eat=function(t){var e=t.onCheckmarkClick,i=t.item,r=t.classNames,o=a5(i);if(e){var l=function(d){return e(i,d)};return $.createElement(Fr,{iconName:i.canCheck!==!1&&o?"CheckMark":"",className:r.checkmarkIcon,onClick:l})}return null},tat=function(t){var e=t.item,i=t.classNames;return e.text||e.name?$.createElement("span",{className:i.label},e.text||e.name):null},iat=function(t){var e=t.item,i=t.classNames;return e.secondaryText?$.createElement("span",{className:i.secondaryText},e.secondaryText):null},nat=function(t){var e=t.item,i=t.classNames,r=t.theme;return AM(e)?$.createElement(Fr,Rt({iconName:Of(r)?"ChevronLeft":"ChevronRight"},e.submenuIconProps,{className:i.subMenuIcon})):null},aat=function(t){mu(e,t);function e(i){var r=t.call(this,i)||this;return r.openSubMenu=function(){var o=r.props,l=o.item,d=o.openSubMenu,h=o.getSubmenuTarget;if(h){var p=h();AM(l)&&d&&p&&d(l,p)}},r.dismissSubMenu=function(){var o=r.props,l=o.item,d=o.dismissSubMenu;AM(l)&&d&&d()},r.dismissMenu=function(o){var l=r.props.dismissMenu;l&&l(void 0,o)},Dw(r),r}return e.prototype.render=function(){var i=this.props,r=i.item,o=i.classNames,l=r.onRenderContent||this._renderLayout;return $.createElement("div",{className:r.split?o.linkContentMenu:o.linkContent},l(this.props,{renderCheckMarkIcon:eat,renderItemIcon:Xnt,renderItemName:tat,renderSecondaryText:iat,renderSubMenuIcon:nat}))},e.prototype._renderLayout=function(i,r){return $.createElement($.Fragment,null,r.renderCheckMarkIcon(i),r.renderItemIcon(i),r.renderItemName(i),r.renderSecondaryText(i),r.renderSubMenuIcon(i))},e}($.Component),rat=ql(function(t){return Rw({wrapper:{display:"inline-flex",height:"100%",alignItems:"center"},divider:{width:1,height:"100%",backgroundColor:t.palette.neutralTertiaryAlt}})}),_L=36,a0e=Zq(0,lEe),oat=ql(function(t){var e,i,r,o,l,d=t.semanticColors,h=t.fonts,p=t.palette,g=d.menuItemBackgroundHovered,f=d.menuItemTextHovered,y=d.menuItemBackgroundPressed,T=d.bodyDivider,C={item:[h.medium,{color:d.bodyText,position:"relative",boxSizing:"border-box"}],divider:{display:"block",height:"1px",backgroundColor:T,position:"relative"},root:[vE(t),h.medium,{color:d.bodyText,backgroundColor:"transparent",border:"none",width:"100%",height:_L,lineHeight:_L,display:"block",cursor:"pointer",padding:"0px 8px 0 4px",textAlign:"left"}],rootDisabled:{color:d.disabledBodyText,cursor:"default",pointerEvents:"none",selectors:(e={},e[Rn]={color:"GrayText",opacity:1},e)},rootHovered:{backgroundColor:g,color:f,selectors:{".ms-ContextualMenu-icon":{color:p.themeDarkAlt},".ms-ContextualMenu-submenuIcon":{color:p.neutralPrimary}}},rootFocused:{backgroundColor:p.white},rootChecked:{selectors:{".ms-ContextualMenu-checkmarkIcon":{color:p.neutralPrimary}}},rootPressed:{backgroundColor:y,selectors:{".ms-ContextualMenu-icon":{color:p.themeDark},".ms-ContextualMenu-submenuIcon":{color:p.neutralPrimary}}},rootExpanded:{backgroundColor:y,color:d.bodyTextChecked,selectors:(i={".ms-ContextualMenu-submenuIcon":(r={},r[Rn]={color:"inherit"},r)},i[Rn]=Rt({},uc()),i)},linkContent:{whiteSpace:"nowrap",height:"inherit",display:"flex",alignItems:"center",maxWidth:"100%"},anchorLink:{padding:"0px 8px 0 4px",textRendering:"auto",color:"inherit",letterSpacing:"normal",wordSpacing:"normal",textTransform:"none",textIndent:"0px",textShadow:"none",textDecoration:"none",boxSizing:"border-box"},label:{margin:"0 4px",verticalAlign:"middle",display:"inline-block",flexGrow:"1",textOverflow:"ellipsis",whiteSpace:"nowrap",overflow:"hidden"},secondaryText:{color:t.palette.neutralSecondary,paddingLeft:"20px",textAlign:"right"},icon:{display:"inline-block",minHeight:"1px",maxHeight:_L,fontSize:CC.medium,width:CC.medium,margin:"0 4px",verticalAlign:"middle",flexShrink:"0",selectors:(o={},o[a0e]={fontSize:CC.large,width:CC.large},o)},iconColor:{color:d.menuIcon},iconDisabled:{color:d.disabledBodyText},checkmarkIcon:{color:d.bodySubtext},subMenuIcon:{height:_L,lineHeight:_L,color:p.neutralSecondary,textAlign:"center",display:"inline-block",verticalAlign:"middle",flexShrink:"0",fontSize:CC.small,selectors:(l={":hover":{color:p.neutralPrimary},":active":{color:p.neutralPrimary}},l[a0e]={fontSize:CC.medium},l)},splitButtonFlexContainer:[vE(t),{display:"flex",height:_L,flexWrap:"nowrap",justifyContent:"center",alignItems:"flex-start"}]};return Ds(C)}),r0e="28px",sat=Zq(0,lEe),lat=ql(function(t){var e;return Rw(rat(t),{wrapper:{position:"absolute",right:28,selectors:(e={},e[sat]={right:32},e)},divider:{height:16,width:1}})}),cat={item:"ms-ContextualMenu-item",divider:"ms-ContextualMenu-divider",root:"ms-ContextualMenu-link",isChecked:"is-checked",isExpanded:"is-expanded",isDisabled:"is-disabled",linkContent:"ms-ContextualMenu-linkContent",linkContentMenu:"ms-ContextualMenu-linkContent",icon:"ms-ContextualMenu-icon",iconColor:"ms-ContextualMenu-iconColor",checkmarkIcon:"ms-ContextualMenu-checkmarkIcon",subMenuIcon:"ms-ContextualMenu-submenuIcon",label:"ms-ContextualMenu-itemText",secondaryText:"ms-ContextualMenu-secondaryText",splitMenu:"ms-ContextualMenu-splitMenu",screenReaderText:"ms-ContextualMenu-screenReaderText"},dat=ql(function(t,e,i,r,o,l,d,h,p,g,f,y){var T,C,E,I,w=oat(t),D=eh(cat,t);return Rw({item:[D.item,w.item,d],divider:[D.divider,w.divider,h],root:[D.root,w.root,r&&[D.isChecked,w.rootChecked],o&&w.anchorLink,i&&[D.isExpanded,w.rootExpanded],e&&[D.isDisabled,w.rootDisabled],!e&&!i&&[{selectors:(T={":hover":w.rootHovered,":active":w.rootPressed},T[".".concat(ys," &:focus, .").concat(ys," &:focus:hover, :host(.").concat(ys,") &:focus, :host(.").concat(ys,") &:focus:hover")]=w.rootFocused,T[".".concat(ys," &:hover, :host(.").concat(ys,") &:hover")]={background:"inherit;"},T)}],y],splitPrimary:[w.root,{width:"calc(100% - ".concat(r0e,")")},r&&["is-checked",w.rootChecked],(e||f)&&["is-disabled",w.rootDisabled],!(e||f)&&!r&&[{selectors:(C={":hover":w.rootHovered},C[":hover ~ .".concat(D.splitMenu)]=w.rootHovered,C[":active"]=w.rootPressed,C[".".concat(ys," &:focus, .").concat(ys," &:focus:hover, :host(.").concat(ys,") &:focus, :host(.").concat(ys,") &:focus:hover")]=w.rootFocused,C[".".concat(ys," &:hover, :host(.").concat(ys,") &:hover")]={background:"inherit;"},C)}]],splitMenu:[D.splitMenu,w.root,{flexBasis:"0",padding:"0 8px",minWidth:r0e},i&&["is-expanded",w.rootExpanded],e&&["is-disabled",w.rootDisabled],!e&&!i&&[{selectors:(E={":hover":w.rootHovered,":active":w.rootPressed},E[".".concat(ys," &:focus, .").concat(ys," &:focus:hover, :host(.").concat(ys,") &:focus, :host(.").concat(ys,") &:focus:hover")]=w.rootFocused,E[".".concat(ys," &:hover, :host(.").concat(ys,") &:hover")]={background:"inherit;"},E)}]],anchorLink:w.anchorLink,linkContent:[D.linkContent,w.linkContent],linkContentMenu:[D.linkContentMenu,w.linkContent,{justifyContent:"center"}],icon:[D.icon,l&&w.iconColor,w.icon,p,e&&[D.isDisabled,w.iconDisabled]],iconColor:w.iconColor,checkmarkIcon:[D.checkmarkIcon,l&&w.checkmarkIcon,w.icon,p],subMenuIcon:[D.subMenuIcon,w.subMenuIcon,g,i&&{color:t.palette.neutralPrimary},e&&[w.iconDisabled]],label:[D.label,w.label],secondaryText:[D.secondaryText,w.secondaryText],splitContainer:[w.splitButtonFlexContainer,!e&&!r&&[{selectors:(I={},I[".".concat(ys," &:focus, .").concat(ys," &:focus:hover, :host(.").concat(ys,") &:focus, :host(.").concat(ys,") &:focus:hover")]=w.rootFocused,I)}]],screenReaderText:[D.screenReaderText,w.screenReaderText,W$,{visibility:"hidden"}]})}),o0e=function(t){var e=t.theme,i=t.disabled,r=t.expanded,o=t.checked,l=t.isAnchorLink,d=t.knownIcon,h=t.itemClassName,p=t.dividerClassName,g=t.iconClassName,f=t.subMenuClassName,y=t.primaryDisabled,T=t.className;return dat(e,i,r,o,l,d,h,p,g,f,y,T)},sH=vu(aat,o0e,void 0,{scope:"ContextualMenuItem"}),Pre=function(t){mu(e,t);function e(i){var r=t.call(this,i)||this;return r._onItemMouseEnter=function(o){var l=r.props,d=l.item,h=l.onItemMouseEnter;h&&h(d,o,o.currentTarget)},r._onItemClick=function(o){var l=r.props,d=l.item,h=l.onItemClickBase;h&&h(d,o,o.currentTarget)},r._onItemMouseLeave=function(o){var l=r.props,d=l.item,h=l.onItemMouseLeave;h&&h(d,o)},r._onItemKeyDown=function(o){var l=r.props,d=l.item,h=l.onItemKeyDown;h&&h(d,o)},r._onItemMouseMove=function(o){var l=r.props,d=l.item,h=l.onItemMouseMove;h&&h(d,o,o.currentTarget)},r._getSubmenuTarget=function(){},Dw(r),r}return e.prototype.shouldComponentUpdate=function(i){return!Gae(i,this.props)},e}($.Component),uat="ktp",s0e="-",hat="data-ktp-target",pat="data-ktp-execute-target",gat="ktp-layer-id",Fw;(function(t){t.KEYTIP_ADDED="keytipAdded",t.KEYTIP_REMOVED="keytipRemoved",t.KEYTIP_UPDATED="keytipUpdated",t.PERSISTED_KEYTIP_ADDED="persistedKeytipAdded",t.PERSISTED_KEYTIP_REMOVED="persistedKeytipRemoved",t.PERSISTED_KEYTIP_EXECUTE="persistedKeytipExecute",t.ENTER_KEYTIP_MODE="enterKeytipMode",t.EXIT_KEYTIP_MODE="exitKeytipMode"})(Fw||(Fw={}));var mat=function(){function t(){this.keytips={},this.persistedKeytips={},this.sequenceMapping={},this.inKeytipMode=!1,this.shouldEnterKeytipMode=!0,this.delayUpdatingKeytipChange=!1}return t.getInstance=function(){return this._instance},t.prototype.init=function(e){this.delayUpdatingKeytipChange=e},t.prototype.register=function(e,i){i===void 0&&(i=!1);var r=e;i||(r=this.addParentOverflow(e),this.sequenceMapping[r.keySequences.toString()]=r);var o=this._getUniqueKtp(r);if(i?this.persistedKeytips[o.uniqueID]=o:this.keytips[o.uniqueID]=o,this.inKeytipMode||!this.delayUpdatingKeytipChange){var l=i?Fw.PERSISTED_KEYTIP_ADDED:Fw.KEYTIP_ADDED;pE.raise(this,l,{keytip:r,uniqueID:o.uniqueID})}return o.uniqueID},t.prototype.update=function(e,i){var r=this.addParentOverflow(e),o=this._getUniqueKtp(r,i),l=this.keytips[i];l&&(o.keytip.visible=l.keytip.visible,this.keytips[i]=o,delete this.sequenceMapping[l.keytip.keySequences.toString()],this.sequenceMapping[o.keytip.keySequences.toString()]=o.keytip,(this.inKeytipMode||!this.delayUpdatingKeytipChange)&&pE.raise(this,Fw.KEYTIP_UPDATED,{keytip:o.keytip,uniqueID:o.uniqueID}))},t.prototype.unregister=function(e,i,r){r===void 0&&(r=!1),r?delete this.persistedKeytips[i]:delete this.keytips[i],!r&&delete this.sequenceMapping[e.keySequences.toString()];var o=r?Fw.PERSISTED_KEYTIP_REMOVED:Fw.KEYTIP_REMOVED;(this.inKeytipMode||!this.delayUpdatingKeytipChange)&&pE.raise(this,o,{keytip:e,uniqueID:i})},t.prototype.enterKeytipMode=function(){pE.raise(this,Fw.ENTER_KEYTIP_MODE)},t.prototype.exitKeytipMode=function(){pE.raise(this,Fw.EXIT_KEYTIP_MODE)},t.prototype.getKeytips=function(){var e=this;return Object.keys(this.keytips).map(function(i){return e.keytips[i].keytip})},t.prototype.addParentOverflow=function(e){var i=Gd([],e.keySequences,!0);if(i.pop(),i.length!==0){var r=this.sequenceMapping[i.toString()];if(r&&r.overflowSetSequence)return Rt(Rt({},e),{overflowSetSequence:r.overflowSetSequence})}return e},t.prototype.menuExecute=function(e,i){pE.raise(this,Fw.PERSISTED_KEYTIP_EXECUTE,{overflowButtonSequences:e,keytipSequences:i})},t.prototype._getUniqueKtp=function(e,i){return i===void 0&&(i=bp()),{keytip:Rt({},e),uniqueID:i}},t._instance=new t,t}();function l0e(t){return t.reduce(function(e,i){return e+s0e+i.split("").join(s0e)},uat)}function fat(t,e){var i=e.length,r=Gd([],e,!0).pop(),o=Gd([],t,!0);return eXe(o,i-1,r)}function vat(t){var e=" "+gat;return t.length?e+" "+l0e(t):e}function yat(t){var e=$.useRef(),i=t.keytipProps?Rt({disabled:t.disabled},t.keytipProps):void 0,r=oT(mat.getInstance()),o=JU(t);ix(function(){e.current&&i&&(o?.keytipProps!==t.keytipProps||o?.disabled!==t.disabled)&&r.update(i,e.current)}),ix(function(){return i&&(e.current=r.register(i)),function(){i&&r.unregister(i,e.current)}},[]);var l={ariaDescribedBy:t.ariaDescribedBy,keytipId:void 0};return i&&(l=Sat(r,i,t.ariaDescribedBy)),l}function Sat(t,e,i){var r=t.addParentOverflow(e),o=FU(i,vat(r.keySequences)),l=Gd([],r.keySequences,!0);r.overflowSetSequence&&(l=fat(l,r.overflowSetSequence));var d=l0e(l);return{ariaDescribedBy:o,keytipId:d}}var lH=function(t){var e,i=t.children,r=Mm(t,["children"]),o=yat(r),l=o.keytipId,d=o.ariaDescribedBy;return i((e={},e[hat]=l,e[pat]=l,e["aria-describedby"]=d,e))},bat=function(t){mu(e,t);function e(){var i=t!==null&&t.apply(this,arguments)||this;return i._anchor=$.createRef(),i._getMemoizedMenuButtonKeytipProps=ql(function(r){return Rt(Rt({},r),{hasMenu:!0})}),i._getSubmenuTarget=function(){return i._anchor.current?i._anchor.current:void 0},i._onItemClick=function(r){var o=i.props,l=o.item,d=o.onItemClick;d&&d(l,r)},i._renderAriaDescription=function(r,o){return r?$.createElement("span",{id:i._ariaDescriptionId,className:o},r):null},i}return e.prototype.render=function(){var i=this,r=this.props,o=r.item,l=r.classNames,d=r.index,h=r.focusableElementIndex,p=r.totalItemCount,g=r.hasCheckmarks,f=r.hasIcons,y=r.expandedMenuItemKey,T=r.onItemClick,C=r.openSubMenu,E=r.dismissSubMenu,I=r.dismissMenu,w=sH;this.props.item.contextualMenuItemAs&&(w=mE(this.props.item.contextualMenuItemAs,w)),this.props.contextualMenuItemAs&&(w=mE(this.props.contextualMenuItemAs,w));var D=o.rel;o.target&&o.target.toLowerCase()==="_blank"&&(D=D||"nofollow noopener noreferrer");var F=AM(o),x=Wl(o,ore),B=Bw(o),L=o.itemProps,z=o.ariaDescription,H=o.keytipProps;H&&F&&(H=this._getMemoizedMenuButtonKeytipProps(H)),z&&(this._ariaDescriptionId=bp());var j=FU(o.ariaDescribedBy,z?this._ariaDescriptionId:void 0,x["aria-describedby"]),J={"aria-describedby":j};return $.createElement("div",null,$.createElement(lH,{keytipProps:o.keytipProps,ariaDescribedBy:j,disabled:B},function(Z){return $.createElement("a",Rt({},J,x,Z,{ref:i._anchor,href:o.href,target:o.target,rel:D,className:l.root,role:"menuitem","aria-haspopup":F||void 0,"aria-expanded":F?o.key===y:void 0,"aria-posinset":h+1,"aria-setsize":p,"aria-disabled":Bw(o),style:o.style,onClick:i._onItemClick,onMouseEnter:i._onItemMouseEnter,onMouseLeave:i._onItemMouseLeave,onMouseMove:i._onItemMouseMove,onKeyDown:F?i._onItemKeyDown:void 0}),$.createElement(w,Rt({componentRef:o.componentRef,item:o,classNames:l,index:d,onCheckmarkClick:g&&T?T:void 0,hasIcons:f,openSubMenu:C,dismissSubMenu:E,dismissMenu:I,getSubmenuTarget:i._getSubmenuTarget},L)),i._renderAriaDescription(z,l.screenReaderText))}))},e}(Pre),Tat=function(t){mu(e,t);function e(){var i=t!==null&&t.apply(this,arguments)||this;return i._btn=$.createRef(),i._getMemoizedMenuButtonKeytipProps=ql(function(r){return Rt(Rt({},r),{hasMenu:!0})}),i._renderAriaDescription=function(r,o){return r?$.createElement("span",{id:i._ariaDescriptionId,className:o},r):null},i._getSubmenuTarget=function(){return i._btn.current?i._btn.current:void 0},i}return e.prototype.render=function(){var i=this,r=this.props,o=r.item,l=r.classNames,d=r.index,h=r.focusableElementIndex,p=r.totalItemCount,g=r.hasCheckmarks,f=r.hasIcons,y=r.contextualMenuItemAs,T=r.expandedMenuItemKey,C=r.onItemMouseDown,E=r.onItemClick,I=r.openSubMenu,w=r.dismissSubMenu,D=r.dismissMenu,F=sH;o.contextualMenuItemAs&&(F=mE(o.contextualMenuItemAs,F)),y&&(F=mE(y,F));var x=a5(o),B=x!==null,L=i0e(o),z=AM(o),H=o.itemProps,j=o.ariaLabel,J=o.ariaDescription,Z=Wl(o,yL);delete Z.disabled;var re=o.role||L;J&&(this._ariaDescriptionId=bp());var ne=FU(o.ariaDescribedBy,J?this._ariaDescriptionId:void 0,Z["aria-describedby"]),le={className:l.root,onClick:this._onItemClick,onKeyDown:z?this._onItemKeyDown:void 0,onMouseEnter:this._onItemMouseEnter,onMouseLeave:this._onItemMouseLeave,onMouseDown:function(Me){return C?C(o,Me):void 0},onMouseMove:this._onItemMouseMove,href:o.href,title:o.title,"aria-label":j,"aria-describedby":ne,"aria-haspopup":z||void 0,"aria-expanded":z?o.key===T:void 0,"aria-posinset":h+1,"aria-setsize":p,"aria-disabled":Bw(o),"aria-checked":(re==="menuitemcheckbox"||re==="menuitemradio")&&B?!!x:void 0,"aria-selected":re==="menuitem"&&B?!!x:void 0,role:re,style:o.style},he=o.keytipProps;return he&&z&&(he=this._getMemoizedMenuButtonKeytipProps(he)),$.createElement(lH,{keytipProps:he,ariaDescribedBy:ne,disabled:Bw(o)},function(Me){return $.createElement("button",Rt({ref:i._btn},Z,le,Me),$.createElement(F,Rt({componentRef:o.componentRef,item:o,classNames:l,index:d,onCheckmarkClick:g&&E?E:void 0,hasIcons:f,openSubMenu:I,dismissSubMenu:w,dismissMenu:D,getSubmenuTarget:i._getSubmenuTarget},H)),i._renderAriaDescription(J,l.screenReaderText))})},e}(Pre),Cat=function(t){var e=t.theme,i=t.getClassNames,r=t.className;if(!e)throw new Error("Theme is undefined or null.");if(i){var o=i(e);return{wrapper:[o.wrapper],divider:[o.divider]}}return{wrapper:[{display:"inline-flex",height:"100%",alignItems:"center"},r],divider:[{width:1,height:"100%",backgroundColor:e.palette.neutralTertiaryAlt}]}},_at=fu(),c0e=$.forwardRef(function(t,e){var i=t.styles,r=t.theme,o=t.getClassNames,l=t.className,d=_at(i,{theme:r,getClassNames:o,className:l});return $.createElement("span",{className:d.wrapper,ref:e},$.createElement("span",{className:d.divider}))});c0e.displayName="VerticalDividerBase";var Eat=vu(c0e,Cat,void 0,{scope:"VerticalDivider"}),Aat=500,Iat=function(t){mu(e,t);function e(i){var r=t.call(this,i)||this;return r._getMemoizedMenuButtonKeytipProps=ql(function(o){return Rt(Rt({},o),{hasMenu:!0})}),r._onItemKeyDown=function(o){var l=r.props,d=l.item,h=l.onItemKeyDown;o.which===fa.enter?(r._executeItemClick(o),o.preventDefault(),o.stopPropagation()):h&&h(d,o)},r._getSubmenuTarget=function(){return r._splitButton},r._renderAriaDescription=function(o,l){return o?$.createElement("span",{id:r._ariaDescriptionId,className:l},o):null},r._onItemMouseEnterPrimary=function(o){var l=r.props,d=l.item,h=l.onItemMouseEnter;h&&h(Rt(Rt({},d),{subMenuProps:void 0,items:void 0}),o,r._splitButton)},r._onItemMouseEnterIcon=function(o){var l=r.props,d=l.item,h=l.onItemMouseEnter;h&&h(d,o,r._splitButton)},r._onItemMouseMovePrimary=function(o){var l=r.props,d=l.item,h=l.onItemMouseMove;h&&h(Rt(Rt({},d),{subMenuProps:void 0,items:void 0}),o,r._splitButton)},r._onItemMouseMoveIcon=function(o){var l=r.props,d=l.item,h=l.onItemMouseMove;h&&h(d,o,r._splitButton)},r._onIconItemClick=function(o){var l=r.props,d=l.item,h=l.onItemClickBase;h&&h(d,o,r._splitButton?r._splitButton:o.currentTarget)},r._executeItemClick=function(o){var l=r.props,d=l.item,h=l.executeItemClick,p=l.onItemClick;if(!(d.disabled||d.isDisabled)){if(r._processingTouch&&!d.canCheck&&p)return p(d,o);h&&h(d,o)}},r._onTouchStart=function(o){r._splitButton&&!("onpointerdown"in r._splitButton)&&r._handleTouchAndPointerEvent(o)},r._onPointerDown=function(o){o.pointerType==="touch"&&(r._handleTouchAndPointerEvent(o),o.preventDefault(),o.stopImmediatePropagation())},r._async=new YN(r),r._events=new pE(r),r._dismissLabelId=bp(),r}return e.prototype.componentDidMount=function(){this._splitButton&&"onpointerdown"in this._splitButton&&this._events.on(this._splitButton,"pointerdown",this._onPointerDown,!0)},e.prototype.componentWillUnmount=function(){this._async.dispose(),this._events.dispose()},e.prototype.render=function(){var i=this,r,o=this.props,l=o.item,d=o.classNames,h=o.index,p=o.focusableElementIndex,g=o.totalItemCount,f=o.hasCheckmarks,y=o.hasIcons,T=o.onItemMouseLeave,C=o.expandedMenuItemKey,E=AM(l),I=l.keytipProps;I&&(I=this._getMemoizedMenuButtonKeytipProps(I));var w=l.ariaDescription;w&&(this._ariaDescriptionId=bp());var D=(r=a5(l))!==null&&r!==void 0?r:void 0;return $.createElement(lH,{keytipProps:I,disabled:Bw(l)},function(F){return $.createElement("div",{"data-ktp-target":F["data-ktp-target"],ref:function(x){return i._splitButton=x},role:i0e(l),"aria-label":l.ariaLabel,className:d.splitContainer,"aria-disabled":Bw(l),"aria-expanded":E?l.key===C:void 0,"aria-haspopup":!0,"aria-describedby":FU(l.ariaDescribedBy,w?i._ariaDescriptionId:void 0,F["aria-describedby"]),"aria-checked":D,"aria-posinset":p+1,"aria-setsize":g,onMouseEnter:i._onItemMouseEnterPrimary,onMouseLeave:T?T.bind(i,Rt(Rt({},l),{subMenuProps:null,items:null})):void 0,onMouseMove:i._onItemMouseMovePrimary,onKeyDown:i._onItemKeyDown,onClick:i._executeItemClick,onTouchStart:i._onTouchStart,tabIndex:0,"data-is-focusable":!0,"aria-roledescription":l["aria-roledescription"]},i._renderSplitPrimaryButton(l,d,h,f,y),i._renderSplitDivider(l),i._renderSplitIconButton(l,d,h,F),i._renderAriaDescription(w,d.screenReaderText))})},e.prototype._renderSplitPrimaryButton=function(i,r,o,l,d){var h=this.props,p=h.contextualMenuItemAs,g=p===void 0?sH:p,f=h.onItemClick,y={key:i.key,disabled:Bw(i)||i.primaryDisabled,name:i.name,text:i.text||i.name,secondaryText:i.secondaryText,className:r.splitPrimary,canCheck:i.canCheck,isChecked:i.isChecked,checked:i.checked,iconProps:i.iconProps,id:this._dismissLabelId,onClick:i.onClick,onRenderIcon:i.onRenderIcon,data:i.data,"data-is-focusable":!1},T=i.itemProps;return $.createElement("button",Rt({},Wl(y,yL)),$.createElement(g,Rt({"data-is-focusable":!1,item:y,classNames:r,index:o,onCheckmarkClick:l&&f?f:void 0,hasIcons:d},T)))},e.prototype._renderSplitDivider=function(i){var r=i.getSplitButtonVerticalDividerClassNames||lat;return $.createElement(Eat,{getClassNames:r})},e.prototype._renderSplitIconButton=function(i,r,o,l){var d=this.props,h=d.onItemMouseLeave,p=d.onItemMouseDown,g=d.openSubMenu,f=d.dismissSubMenu,y=d.dismissMenu,T=sH;this.props.item.contextualMenuItemAs&&(T=mE(this.props.item.contextualMenuItemAs,T)),this.props.contextualMenuItemAs&&(T=mE(this.props.contextualMenuItemAs,T));var C={onClick:this._onIconItemClick,disabled:Bw(i),className:r.splitMenu,subMenuProps:i.subMenuProps,submenuIconProps:i.submenuIconProps,split:!0,key:i.key,"aria-labelledby":this._dismissLabelId},E=Rt(Rt({},Wl(C,yL)),{onMouseEnter:this._onItemMouseEnterIcon,onMouseLeave:h?h.bind(this,i):void 0,onMouseDown:function(w){return p?p(i,w):void 0},onMouseMove:this._onItemMouseMoveIcon,"data-is-focusable":!1,"data-ktp-execute-target":l["data-ktp-execute-target"],"aria-haspopup":!0}),I=i.itemProps;return $.createElement("button",Rt({},E),$.createElement(T,Rt({componentRef:i.componentRef,item:C,classNames:r,index:o,hasIcons:!1,openSubMenu:g,dismissSubMenu:f,dismissMenu:y,getSubmenuTarget:this._getSubmenuTarget},I)))},e.prototype._handleTouchAndPointerEvent=function(i){var r=this,o=this.props.onTap;o&&o(i),this._lastTouchTimeoutId&&(this._async.clearTimeout(this._lastTouchTimeoutId),this._lastTouchTimeoutId=void 0),this._processingTouch=!0,this._lastTouchTimeoutId=this._async.setTimeout(function(){r._processingTouch=!1,r._lastTouchTimeoutId=void 0},Aat)},e}(Pre),EL;(function(t){t[t.small=0]="small",t[t.medium=1]="medium",t[t.large=2]="large",t[t.xLarge=3]="xLarge",t[t.xxLarge=4]="xxLarge",t[t.xxxLarge=5]="xxxLarge",t[t.unknown=999]="unknown"})(EL||(EL={}));var wat=[479,639,1023,1365,1919,99999999],d0e;function u0e(){var t;return(t=d0e)!==null&&t!==void 0?t:EL.large}function kat(t){try{return t.document.documentElement.clientWidth}catch{return t.innerWidth}}function Rat(t){var e=EL.small;if(t){try{for(;kat(t)>wat[e];)e++}catch{e=u0e()}d0e=e}else throw new Error("Content was rendered in a server environment without providing a default responsive mode. Call setResponsiveMode to define what the responsive mode is.");return e}var hW=function(t,e){var i=$.useState(u0e()),r=i[0],o=i[1],l=$.useCallback(function(){var h=Rat(Wc(t.current));r!==h&&o(h)},[t,r]),d=VU();return X$(d,"resize",l),$.useEffect(function(){e===void 0&&l()},[e]),e??r},Mat=$.createContext({}),Pat=fu(),Dat=fu(),Lat={items:[],shouldFocusOnMount:!0,gapSpace:0,directionalHint:hd.bottomAutoEdge,beakWidth:16};function h0e(t){for(var e=0,i=0,r=t;i<r.length;i++){var o=r[i];if(o.itemType!==Cp.Divider&&o.itemType!==Cp.Header){var l=o.customOnRenderListLength?o.customOnRenderListLength:1;e+=l}}return e}function p0e(t,e){var i=e?.target,r=t.subMenuProps?t.subMenuProps.items:t.items;if(r){for(var o=[],l=0,d=r;l<d.length;l++){var h=d[l];if(h.preferMenuTargetAsEventTarget){var p=h.onClick,g=Mm(h,["onClick"]);o.push(Rt(Rt({},g),{onClick:S0e(p,i)}))}else o.push(h)}return o}}function Oat(t){return t.some(function(e){return!!(e.canCheck||e.sectionProps&&e.sectionProps.items.some(function(i){return i.canCheck===!0}))})}var g0e=250,Dre="ContextualMenu",Nat=ql(function(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];return function(i){return u_e.apply(void 0,Gd([i,o0e],t,!1))}});function xat(t,e){var i=t.hidden,r=i===void 0?!1:i,o=t.onMenuDismissed,l=t.onMenuOpened,d=JU(r),h=$.useRef(l),p=$.useRef(o),g=$.useRef(t);h.current=l,p.current=o,g.current=t,$.useEffect(function(){var f,y;r&&d===!1?(f=p.current)===null||f===void 0||f.call(p,g.current):!r&&d!==!1&&((y=h.current)===null||y===void 0||y.call(h,g.current))},[r,d]),$.useEffect(function(){return function(){var f;return(f=p.current)===null||f===void 0?void 0:f.call(p,g.current)}},[])}function Bat(t,e){var i=t.hidden,r=t.items,o=t.theme,l=t.className,d=t.id,h=t.target,p=$.useState(),g=p[0],f=p[1],y=$.useState(),T=y[0],C=y[1],E=$.useState(),I=E[0],w=E[1],D=yu(Dre,d),F=$.useCallback(function(){w(void 0),f(void 0),C(void 0)},[]),x=$.useCallback(function(z,H,j){var J=z.key;g!==J&&(H.focus(),w(j),f(J),C(H))},[g]);$.useEffect(function(){i&&F()},[i,F]);var B=$at(e,F),L=function(){var z=y0e(g,r),H=null;if(z&&(H={items:p0e(z,{target:h}),target:T,onDismiss:B,isSubMenu:!0,id:D,shouldFocusOnMount:!0,shouldFocusOnContainer:I,directionalHint:Of(o)?hd.leftTopEdge:hd.rightTopEdge,className:l,gapSpace:0,isBeakVisible:!1},z.subMenuProps&&mL(H,z.subMenuProps),z.preferMenuTargetAsEventTarget)){var j=z.onItemClick;H.onItemClick=S0e(j,h)}return H};return[g,x,L,B]}function Fat(t){var e=t.delayUpdateFocusOnHover,i=t.hidden,r=$.useRef(!e),o=$.useRef(!1);$.useEffect(function(){r.current=!e,o.current=i?!1:!e&&o.current},[e,i]);var l=$.useCallback(function(){e&&(r.current=!1)},[e]);return[r,o,l]}function Uat(t,e,i){var r=t.hidden,o=t.onRestoreFocus,l=$.useRef(),d=$.useCallback(function(h){var p,g;o?o(h):h?.documentContainsFocus&&((g=(p=l.current)===null||p===void 0?void 0:p.focus)===null||g===void 0||g.call(p))},[o]);return ix(function(){var h,p;if(r)l.current&&(d({originalElement:l.current,containsFocus:!0,documentContainsFocus:((p=Gg())===null||p===void 0?void 0:p.hasFocus())||!1}),l.current=void 0);else{var g=e?.document.activeElement;!(!((h=i.current)===null||h===void 0)&&h.contains(g))&&g.tagName!=="BODY"&&(l.current=g)}},[r,e?.document.activeElement,d,i]),[d]}function zat(t,e,i,r){var o=t.theme,l=t.isSubMenu,d=t.focusZoneProps,h=d===void 0?{}:d,p=h.checkForNoWrap,g=h.direction,f=g===void 0?Lm.vertical:g,y=$.useRef(),T=function(B,L,z){var H=!1;return L(B)&&(e(B,z),B.preventDefault(),B.stopPropagation(),H=!0),H},C=function(B){var L=Of(o)?fa.right:fa.left;return B.which!==L||!l?!1:!!(f===Lm.vertical||p&&!f_e(B.target,"data-no-horizontal-wrap"))},E=function(B){return B.which===fa.escape||C(B)||B.which===fa.up&&(B.altKey||B.metaKey)},I=function(B){y.current=f0e(B);var L=B.which===fa.escape&&(dre()||Wq());return T(B,E,L)},w=function(B){var L=y.current&&f0e(B);return y.current=!1,!!L&&!(Wq()||dre())},D=function(B){return T(B,w,!0)},F=function(B){var L=I(B);if(!(L||!i.current)){var z=!!(B.altKey||B.metaKey),H=B.which===fa.up,j=B.which===fa.down;if(!z&&(H||j)){var J=H?g_e(i.current,i.current.lastChild,!0):p_e(i.current,i.current.firstChild,!0);J&&(J.focus(),B.preventDefault(),B.stopPropagation())}}},x=function(B,L){var z=Of(o)?fa.left:fa.right;!B.disabled&&(L.which===z||L.which===fa.enter||L.which===fa.down&&(L.altKey||L.metaKey))&&(r(B,L.currentTarget),L.preventDefault())};return[I,D,F,x]}function Vat(t){var e=$.useRef(!0),i=$.useRef(),r=function(){!e.current&&i.current!==void 0?(t.clearTimeout(i.current),i.current=void 0):e.current=!1,i.current=t.setTimeout(function(){e.current=!0},g0e)};return[r,e]}function $at(t,e){var i=$.useRef(!1);$.useEffect(function(){return i.current=!0,function(){i.current=!1}},[]);var r=function(o,l){l?t(o,l):i.current&&e()};return r}function Hat(t,e){var i=t.subMenuHoverDelay,r=i===void 0?g0e:i,o=$.useRef(void 0),l=function(){o.current!==void 0&&(e.clearTimeout(o.current),o.current=void 0)},d=function(h){o.current=e.setTimeout(function(){h(),l()},r)};return[l,d,o]}function jat(t,e,i,r,o,l,d,h,p,g,f,y,T){var C=t.target,E=function(H,j,J){o.current&&(l.current=!0),!w()&&F(H,j,J)},I=function(H,j,J){var Z=j.currentTarget;if(o.current)l.current=!0;else return;!e.current||i.current!==void 0||Z===r?.document.activeElement||F(H,j,J)},w=function(){return!e.current||!l.current},D=function(H,j){var J;if(!w()&&(g(),d===void 0))if(h.current.setActive)try{h.current.setActive()}catch{}else(J=h.current)===null||J===void 0||J.focus()},F=function(H,j,J){var Z=J||j.currentTarget;H.key!==d&&(g(),d===void 0&&Z.focus(),AM(H)?(j.stopPropagation(),p(function(){Z.focus(),f(H,Z,!0)})):p(function(){y(j),Z.focus()}))},x=function(H,j){B(H,j,j.currentTarget)},B=function(H,j,J){var Z=p0e(H,{target:C});if(g(),!AM(H)&&(!Z||!Z.length))z(H,j);else if(H.key!==d){var re=typeof t.shouldFocusOnContainer=="boolean"?t.shouldFocusOnContainer:j.nativeEvent.pointerType==="mouse";f(H,J,re)}j.stopPropagation(),j.preventDefault()},L=function(H,j){z(H,j),j.stopPropagation()},z=function(H,j){if(!(H.disabled||H.isDisabled)){H.preferMenuTargetAsEventTarget&&b0e(j,C);var J=!1;H.onClick?J=!!H.onClick(j,H):t.onItemClick&&(J=!!t.onItemClick(j,H)),(J||!j.defaultPrevented)&&T(j,!0)}};return[E,I,D,x,L,z,B]}var m0e=$.memo($.forwardRef(function(t,e){var i,r=Lw(Lat,t);r.ref;var o=Mm(r,["ref"]),l=$.useRef(null),d=KU(),h=yu(Dre,o.id);CM({name:Dre,props:o,deprecations:{getMenuClassNames:"styles"}});var p=function(Ai,pn){var Bn;return(Bn=o.onDismiss)===null||Bn===void 0?void 0:Bn.call(o,Ai,pn)},g=IEe(o.target,l),f=g[0],y=g[1],T=Uat(o,y,l)[0],C=Bat(o,p),E=C[0],I=C[1],w=C[2],D=C[3],F=Fat(o),x=F[0],B=F[1],L=F[2],z=Vat(d),H=z[0],j=z[1],J=Hat(o,d),Z=J[0],re=J[1],ne=J[2],le=hW(l,o.responsiveMode);xat(o);var he=zat(o,p,l,I),Me=he[0],Le=he[1],pe=he[2],te=he[3],Se=jat(o,j,ne,y,x,B,E,l,re,Z,I,D,p),ce=Se[0],X=Se[1],ve=Se[2],Te=Se[3],Be=Se[4],qe=Se[5],Ge=Se[6],tt=function(Ai,pn,Bn){var Pa=0,qa=Ai.items,kr=Ai.totalItemCount,Sa=Ai.hasCheckmarks,aa=Ai.hasIcons;return $.createElement("ul",{className:pn.list,onKeyDown:Me,onKeyUp:Le,role:"presentation"},qa.map(function(ti,on){var Fn=Mt(ti,on,Pa,kr,Sa,aa,pn);if(ti.itemType!==Cp.Divider&&ti.itemType!==Cp.Header){var Or=ti.customOnRenderListLength?ti.customOnRenderListLength:1;Pa+=Or}return Fn}))},ct=function(Ai,pn){var Bn=o.focusZoneAs,Pa=Bn===void 0?hA:Bn;return $.createElement(Pa,Rt({},pn),Ai)},Mt=function(Ai,pn,Bn,Pa,qa,kr,Sa){var aa,ti=[],on=Ai.iconProps||{iconName:"None"},Fn=Ai.getItemClassNames,Or=Ai.itemProps,Co=Or?Or.styles:void 0,za=Ai.itemType===Cp.Divider?Ai.className:void 0,Za=Ai.submenuIconProps?Ai.submenuIconProps.className:"",ns;if(Fn)ns=Fn(o.theme,Bw(Ai),E===Ai.key,!!a5(Ai),!!Ai.href,on.iconName!=="None",Ai.className,za,on.className,Za,Ai.primaryDisabled);else{var Uu={theme:o.theme,disabled:Bw(Ai),expanded:E===Ai.key,checked:!!a5(Ai),isAnchorLink:!!Ai.href,knownIcon:on.iconName!=="None",itemClassName:Ai.className,dividerClassName:za,iconClassName:on.className,subMenuClassName:Za,primaryDisabled:Ai.primaryDisabled};ns=Dat(Nat((aa=Sa.subComponentStyles)===null||aa===void 0?void 0:aa.menuItem,Co),Uu)}switch((Ai.text==="-"||Ai.name==="-")&&(Ai.itemType=Cp.Divider),Ai.itemType){case Cp.Divider:ti.push(ni(pn,ns));break;case Cp.Header:ti.push(ni(pn,ns));var ml=it(Ai,ns,Sa,pn,qa,kr);ti.push(Pt(ml,Ai.key||pn,ns,Ai.title));break;case Cp.Section:ti.push(vt(Ai,ns,Sa,pn,qa,kr));break;default:var Cu=function(){return Zt(Ai,ns,pn,Bn,Pa,qa,kr)},Xd=o.onRenderContextualMenuItem?o.onRenderContextualMenuItem(Ai,Cu):Cu();ti.push(Pt(Xd,Ai.key||pn,ns,Ai.title));break}return $.createElement($.Fragment,{key:Ai.key},ti)},ht=function(Ai,pn){var Bn=Ai.index,Pa=Ai.focusableElementIndex,qa=Ai.totalItemCount,kr=Ai.hasCheckmarks,Sa=Ai.hasIcons;return Mt(Ai,Bn,Pa,qa,kr,Sa,pn)},vt=function(Ai,pn,Bn,Pa,qa,kr){var Sa=Ai.sectionProps;if(Sa){var aa,ti;if(Sa.title){var on=void 0,Fn="";if(typeof Sa.title=="string"){var Or=h+Sa.title.replace(/\s/g,"");on={key:"section-".concat(Sa.title,"-title"),itemType:Cp.Header,text:Sa.title,id:Or},Fn=Or}else{var Co=Sa.title.id||h+Sa.title.key.replace(/\s/g,"");on=Rt(Rt({},Sa.title),{id:Co}),Fn=Co}on&&(ti={role:"group","aria-labelledby":Fn},aa=it(on,pn,Bn,Pa,qa,kr))}if(Sa.items&&Sa.items.length>0){var za=0;return $.createElement("li",{role:"presentation",key:Sa.key||Ai.key||"section-".concat(Pa)},$.createElement("div",Rt({},ti),$.createElement("ul",{className:Bn.list,role:"presentation"},Sa.topDivider&&ni(Pa,pn,!0,!0),aa&&Pt(aa,Ai.key||Pa,pn,Ai.title),Sa.items.map(function(Za,ns){var Uu=Mt(Za,ns,za,h0e(Sa.items),qa,kr,Bn);if(Za.itemType!==Cp.Divider&&Za.itemType!==Cp.Header){var ml=Za.customOnRenderListLength?Za.customOnRenderListLength:1;za+=ml}return Uu}),Sa.bottomDivider&&ni(Pa,pn,!1,!0))))}}},Pt=function(Ai,pn,Bn,Pa){return $.createElement("li",{role:"presentation",title:Pa,key:pn,className:Bn.item},Ai)},ni=function(Ai,pn,Bn,Pa){return Pa||Ai>0?$.createElement("li",{role:"separator",key:"separator-"+Ai+(Bn===void 0?"":Bn?"-top":"-bottom"),className:pn.divider,"aria-hidden":"true"}):null},Zt=function(Ai,pn,Bn,Pa,qa,kr,Sa){if(Ai.onRender)return Ai.onRender(Rt({"aria-posinset":Pa+1,"aria-setsize":qa},Ai),p);var aa=o.contextualMenuItemAs,ti={item:Ai,classNames:pn,index:Bn,focusableElementIndex:Pa,totalItemCount:qa,hasCheckmarks:kr,hasIcons:Sa,contextualMenuItemAs:aa,onItemMouseEnter:ce,onItemMouseLeave:ve,onItemMouseMove:X,onItemMouseDown:Gat,executeItemClick:qe,onItemKeyDown:te,expandedMenuItemKey:E,openSubMenu:I,dismissSubMenu:D,dismissMenu:p};if(Ai.href){var on=bat;return Ai.contextualMenuItemWrapperAs&&(on=mE(Ai.contextualMenuItemWrapperAs,on)),$.createElement(on,Rt({},ti,{onItemClick:Be}))}if(Ai.split&&AM(Ai)){var Fn=Iat;return Ai.contextualMenuItemWrapperAs&&(Fn=mE(Ai.contextualMenuItemWrapperAs,Fn)),$.createElement(Fn,Rt({},ti,{onItemClick:Te,onItemClickBase:Ge,onTap:Z}))}var Or=Tat;return Ai.contextualMenuItemWrapperAs&&(Or=mE(Ai.contextualMenuItemWrapperAs,Or)),$.createElement(Or,Rt({},ti,{onItemClick:Te,onItemClickBase:Ge}))},it=function(Ai,pn,Bn,Pa,qa,kr){var Sa=sH;Ai.contextualMenuItemAs&&(Sa=mE(Ai.contextualMenuItemAs,Sa)),o.contextualMenuItemAs&&(Sa=mE(o.contextualMenuItemAs,Sa));var aa=Ai.itemProps,ti=Ai.id,on=aa&&Wl(aa,Nf);return $.createElement("div",Rt({id:ti,className:Bn.header},on,{style:Ai.style}),$.createElement(Sa,Rt({item:Ai,classNames:pn,index:Pa,onCheckmarkClick:qa?Te:void 0,hasIcons:kr},aa)))},Ke=o.isBeakVisible,ot=o.items,Ht=o.labelElementId,jt=o.id,Nt=o.className,Vt=o.beakWidth,$t=o.directionalHint,dt=o.directionalHintForRTL,yt=o.alignTargetEdge,kt=o.gapSpace,je=o.coverTarget,Ae=o.ariaLabel,xe=o.doNotLayer,gt=o.target,Ye=o.bounds,Fe=o.useTargetWidth,St=o.useTargetAsMinWidth,Wt=o.directionalHintFixed,Ii=o.shouldFocusOnMount,en=o.shouldFocusOnContainer,sn=o.title,Qi=o.styles,qt=o.theme,ri=o.calloutProps,Ti=o.onRenderSubMenu,rn=Ti===void 0?v0e:Ti,Hn=o.onRenderMenuList,ha=Hn===void 0?function(Ai,pn){return tt(Ai,pr)}:Hn,hr=o.focusZoneProps,yn=o.getMenuClassNames,pr=yn?yn(qt,Nt):Pat(Qi,{theme:qt,className:Nt}),Ho=Rr(ot);function Rr(Ai){for(var pn=0,Bn=Ai;pn<Bn.length;pn++){var Pa=Bn[pn];if(Pa.iconProps||Pa.itemType===Cp.Section&&Pa.sectionProps&&Rr(Pa.sectionProps.items))return!0}return!1}var La=Rt(Rt({direction:Lm.vertical,handleTabKey:Are.all,isCircularNavigation:!0,"data-tabster":'{"uncontrolled": {}, "focusable": { "excludeFromMover": true }}'},hr),{className:wh(pr.root,(i=o.focusZoneProps)===null||i===void 0?void 0:i.className)}),us=Oat(ot),al=E&&o.hidden!==!0?w():null;Ke=Ke===void 0?le<=EL.medium:Ke;var Us,$r=f.current;if((Fe||St)&&$r&&$r.offsetWidth){var Zd=$r.getBoundingClientRect(),rc=Zd.width-2;Fe?Us={width:rc}:St&&(Us={minWidth:rc})}if(ot&&ot.length>0){var Yl=h0e(ot),ci=pr.subComponentStyles?pr.subComponentStyles.callout:void 0;return $.createElement(Mat.Consumer,null,function(Ai){return $.createElement(ZU,Rt({styles:ci,onRestoreFocus:T},ri,{target:gt||Ai.target,isBeakVisible:Ke,beakWidth:Vt,directionalHint:$t,directionalHintForRTL:dt,gapSpace:kt,coverTarget:je,doNotLayer:xe,className:wh("ms-ContextualMenu-Callout",ri&&ri.className),setInitialFocus:Ii,onDismiss:o.onDismiss||Ai.onDismiss,onScroll:H,bounds:Ye,directionalHintFixed:Wt,alignTargetEdge:yt,hidden:o.hidden||Ai.hidden,ref:e}),$.createElement("div",{style:Us,ref:l,id:jt,className:pr.container,tabIndex:en?0:-1,onKeyDown:pe,onKeyUp:Le,onFocusCapture:L,"aria-label":Ae,"aria-labelledby":Ht,role:"menu"},sn&&$.createElement("div",{className:pr.title}," ",sn," "),ot&&ot.length?ct(ha({ariaLabel:Ae,items:ot,totalItemCount:Yl,hasCheckmarks:us,hasIcons:Ho,defaultMenuItemRenderer:function(pn){return ht(pn,pr)},labelElementId:Ht},function(pn,Bn){return tt(pn,pr)}),La):null,al&&rn(al,v0e)),$.createElement(W_e,null))})}else return null}),function(t,e){return!e.shouldUpdateWhenHidden&&t.hidden&&e.hidden?!0:Gae(t,e)});m0e.displayName="ContextualMenuBase";function f0e(t){return t.which===fa.alt||t.key==="Meta"}function Gat(t,e){var i;(i=t.onMouseDown)===null||i===void 0||i.call(t,t,e)}function v0e(t,e){throw Error("ContextualMenuBase: onRenderSubMenu callback is null or undefined. Please ensure to set `onRenderSubMenu` property either manually or with `styled` helper.")}function y0e(t,e){for(var i=0,r=e;i<r.length;i++){var o=r[i];if(o.itemType===Cp.Section&&o.sectionProps){var l=y0e(t,o.sectionProps.items);if(l)return l}else if(o.key&&o.key===t)return o}}function S0e(t,e){return t&&function(i,r){return b0e(i,e),t(i,r)}}function b0e(t,e){t&&e&&(t.persist(),e instanceof Event?t.target=e.target:e instanceof Element&&(t.target=e))}var qat={root:"ms-ContextualMenu",container:"ms-ContextualMenu-container",list:"ms-ContextualMenu-list",header:"ms-ContextualMenu-header",title:"ms-ContextualMenu-title",isopen:"is-open"},Wat=function(t){var e=t.className,i=t.theme,r=eh(qat,i),o=i.fonts,l=i.semanticColors,d=i.effects;return{root:[i.fonts.medium,r.root,r.isopen,{backgroundColor:l.menuBackground,minWidth:"180px"},e],container:[r.container,{selectors:{":focus":{outline:0}}}],list:[r.list,r.isopen,{listStyleType:"none",margin:"0",padding:"0"}],header:[r.header,o.small,{fontWeight:xs.semibold,color:l.menuHeader,background:"none",backgroundColor:"transparent",border:"none",height:_L,lineHeight:_L,cursor:"default",padding:"0px 6px",userSelect:"none",textAlign:"left"}],title:[r.title,{fontSize:o.mediumPlus.fontSize,paddingRight:"14px",paddingLeft:"14px",paddingBottom:"5px",paddingTop:"5px",backgroundColor:l.menuItemBackgroundPressed}],subComponentStyles:{callout:{root:{boxShadow:d.elevation8}},menuItem:{}}}};function T0e(t){return $.createElement(C0e,Rt({},t))}var C0e=vu(m0e,Wat,function(t){return{onRenderSubMenu:t.onRenderSubMenu?yet(t.onRenderSubMenu,T0e):T0e}},{scope:"ContextualMenu"}),hx=C0e;hx.displayName="ContextualMenu";var WS={msButton:"ms-Button",msButtonHasMenu:"ms-Button--hasMenu",msButtonIcon:"ms-Button-icon",msButtonMenuIcon:"ms-Button-menuIcon",msButtonLabel:"ms-Button-label",msButtonDescription:"ms-Button-description",msButtonScreenReaderText:"ms-Button-screenReaderText",msButtonFlexContainer:"ms-Button-flexContainer",msButtonTextContainer:"ms-Button-textContainer"},Kat=ql(function(t,e,i,r,o,l,d,h,p,g,f){var y,T,C=eh(WS,t||{}),E=g&&!f;return Rw(e.__shadowConfig__,{root:[C.msButton,e.root,r,p&&["is-checked",e.rootChecked],E&&["is-expanded",e.rootExpanded,(y={},y[":hover .".concat(C.msButtonIcon)]=e.iconExpandedHovered,y[":hover .".concat(C.msButtonMenuIcon)]=e.menuIconExpandedHovered||e.rootExpandedHovered,y[":hover"]=e.rootExpandedHovered,y)],h&&[WS.msButtonHasMenu,e.rootHasMenu],d&&["is-disabled",e.rootDisabled],!d&&!E&&!p&&(T={":hover":e.rootHovered},T[":hover .".concat(C.msButtonLabel)]=e.labelHovered,T[":hover .".concat(C.msButtonIcon)]=e.iconHovered,T[":hover .".concat(C.msButtonDescription)]=e.descriptionHovered,T[":hover .".concat(C.msButtonMenuIcon)]=e.menuIconHovered,T[":focus"]=e.rootFocused,T[":active"]=e.rootPressed,T[":active .".concat(C.msButtonIcon)]=e.iconPressed,T[":active .".concat(C.msButtonDescription)]=e.descriptionPressed,T[":active .".concat(C.msButtonMenuIcon)]=e.menuIconPressed,T),d&&p&&[e.rootCheckedDisabled],!d&&p&&{":hover":e.rootCheckedHovered,":active":e.rootCheckedPressed},i],flexContainer:[C.msButtonFlexContainer,e.flexContainer],textContainer:[C.msButtonTextContainer,e.textContainer],icon:[C.msButtonIcon,o,e.icon,E&&e.iconExpanded,p&&e.iconChecked,d&&e.iconDisabled],label:[C.msButtonLabel,e.label,p&&e.labelChecked,d&&e.labelDisabled],menuIcon:[C.msButtonMenuIcon,l,e.menuIcon,p&&e.menuIconChecked,d&&!f&&e.menuIconDisabled,!d&&!E&&!p&&{":hover":e.menuIconHovered,":active":e.menuIconPressed},E&&["is-expanded",e.menuIconExpanded]],description:[C.msButtonDescription,e.description,p&&e.descriptionChecked,d&&e.descriptionDisabled],screenReaderText:[C.msButtonScreenReaderText,e.screenReaderText]})}),Jat={msSplitButtonDivider:"ms-SplitButton-divider"},Yat=ql(function(t,e,i,r,o){return{root:It(t.splitButtonMenuButton,i&&[t.splitButtonMenuButtonExpanded],e&&[t.splitButtonMenuButtonDisabled],r&&!e&&[t.splitButtonMenuButtonChecked],o&&!e&&[{":focus":t.splitButtonMenuFocused}]),splitButtonContainer:It(t.splitButtonContainer,!e&&r&&[t.splitButtonContainerChecked,{":hover":t.splitButtonContainerCheckedHovered}],!e&&!r&&[{":hover":t.splitButtonContainerHovered,":focus":t.splitButtonContainerFocused}],e&&t.splitButtonContainerDisabled),icon:It(t.splitButtonMenuIcon,e&&t.splitButtonMenuIconDisabled,!e&&o&&t.splitButtonMenuIcon),flexContainer:It(t.splitButtonFlexContainer),divider:It(Jat.msSplitButtonDivider,t.splitButtonDivider,(o||e)&&t.splitButtonDividerDisabled)}}),Qat=500,_0e="BaseButton",pW=function(t){mu(e,t);function e(i){var r=t.call(this,i)||this;return r._buttonElement=$.createRef(),r._splitButtonContainer=$.createRef(),r._mergedRef=iEe(),r._renderedVisibleMenu=!1,r._getMemoizedMenuButtonKeytipProps=ql(function(o){return Rt(Rt({},o),{hasMenu:!0})}),r._onRenderIcon=function(o,l){var d=r.props.iconProps;if(d&&(d.iconName!==void 0||d.imageProps)){var h=d.className,p=d.imageProps,g=Mm(d,["className","imageProps"]);if(d.styles)return $.createElement(Fr,Rt({className:wh(r._classNames.icon,h),imageProps:p},g));if(d.iconName)return $.createElement(_M,Rt({className:wh(r._classNames.icon,h)},g));if(p)return $.createElement(Tnt,Rt({className:wh(r._classNames.icon,h),imageProps:p},g))}return null},r._onRenderTextContents=function(){var o=r.props,l=o.text,d=o.children,h=o.secondaryText,p=h===void 0?r.props.description:h,g=o.onRenderText,f=g===void 0?r._onRenderText:g,y=o.onRenderDescription,T=y===void 0?r._onRenderDescription:y;return l||typeof d=="string"||p?$.createElement("span",{className:r._classNames.textContainer},f(r.props,r._onRenderText),T(r.props,r._onRenderDescription)):[f(r.props,r._onRenderText),T(r.props,r._onRenderDescription)]},r._onRenderText=function(){var o=r.props.text,l=r.props.children;return o===void 0&&typeof l=="string"&&(o=l),r._hasText()?$.createElement("span",{key:r._labelId,className:r._classNames.label,id:r._labelId},o):null},r._onRenderChildren=function(){var o=r.props.children;return typeof o=="string"?null:o},r._onRenderDescription=function(o){var l=o.secondaryText,d=l===void 0?r.props.description:l;return d?$.createElement("span",{key:r._descriptionId,className:r._classNames.description,id:r._descriptionId},d):null},r._onRenderAriaDescription=function(){var o=r.props.ariaDescription;return o?$.createElement("span",{className:r._classNames.screenReaderText,id:r._ariaDescriptionId},o):null},r._onRenderMenuIcon=function(o){var l=r.props.menuIconProps;return $.createElement(_M,Rt({iconName:"ChevronDown"},l,{className:r._classNames.menuIcon}))},r._onRenderMenu=function(o){var l=r.props.menuAs?mE(r.props.menuAs,hx):hx;return $.createElement(l,Rt({},o))},r._onDismissMenu=function(o){var l=r.props.menuProps;l&&l.onDismiss&&l.onDismiss(o),(!o||!o.defaultPrevented)&&r._dismissMenu()},r._dismissMenu=function(){r._menuShouldFocusOnMount=void 0,r._menuShouldFocusOnContainer=void 0,r.setState({menuHidden:!0})},r._openMenu=function(o,l){l===void 0&&(l=!0),r.props.menuProps&&(r._menuShouldFocusOnContainer=o,r._menuShouldFocusOnMount=l,r._renderedVisibleMenu=!0,r.setState({menuHidden:!1}))},r._onToggleMenu=function(o){var l=!0;r.props.menuProps&&r.props.menuProps.shouldFocusOnMount===!1&&(l=!1),r.state.menuHidden?r._openMenu(o,l):r._dismissMenu()},r._onSplitContainerFocusCapture=function(o){var l=r._splitButtonContainer.current;!l||o.target&&Hae(o.target,l)||l.focus()},r._onSplitButtonPrimaryClick=function(o){r.state.menuHidden||r._dismissMenu();var l=r._processingTouch&&!r.props.toggle;!l&&r.props.onClick?r.props.onClick(o):l&&r._onMenuClick(o)},r._onKeyDown=function(o){r.props.disabled&&(o.which===fa.enter||o.which===fa.space)?(o.preventDefault(),o.stopPropagation()):r.props.disabled||(r.props.menuProps?r._onMenuKeyDown(o):r.props.onKeyDown!==void 0&&r.props.onKeyDown(o))},r._onKeyUp=function(o){!r.props.disabled&&r.props.onKeyUp!==void 0&&r.props.onKeyUp(o)},r._onKeyPress=function(o){!r.props.disabled&&r.props.onKeyPress!==void 0&&r.props.onKeyPress(o)},r._onMouseUp=function(o){!r.props.disabled&&r.props.onMouseUp!==void 0&&r.props.onMouseUp(o)},r._onMouseDown=function(o){!r.props.disabled&&r.props.onMouseDown!==void 0&&r.props.onMouseDown(o)},r._onClick=function(o){r.props.disabled||(r.props.menuProps?r._onMenuClick(o):r.props.onClick!==void 0&&r.props.onClick(o))},r._onSplitButtonContainerKeyDown=function(o){o.which===fa.enter||o.which===fa.space?r._buttonElement.current&&(r._buttonElement.current.click(),o.preventDefault(),o.stopPropagation()):r._onMenuKeyDown(o)},r._onMenuKeyDown=function(o){var l;if(!r.props.disabled){r.props.onKeyDown&&r.props.onKeyDown(o);var d=o.which===fa.up,h=o.which===fa.down;if(!o.defaultPrevented&&r._isValidMenuOpenKey(o)){var p=r.props.onMenuClick;p&&p(o,r.props),r._onToggleMenu(!1),o.preventDefault(),o.stopPropagation()}if((o.which===fa.enter||o.which===fa.space)&&XN(!0,o.target,(l=r.context)===null||l===void 0?void 0:l.registeredProviders),!(o.altKey||o.metaKey)&&(d||h)&&!r.state.menuHidden&&r.props.menuProps){var g=r._menuShouldFocusOnMount!==void 0?r._menuShouldFocusOnMount:r.props.menuProps.shouldFocusOnMount;g||(o.preventDefault(),o.stopPropagation(),r._menuShouldFocusOnMount=!0,r.forceUpdate())}}},r._onTouchStart=function(){r._isSplitButton&&r._splitButtonContainer.current&&!("onpointerdown"in r._splitButtonContainer.current)&&r._handleTouchAndPointerEvent()},r._onMenuClick=function(o){var l=r.props,d=l.onMenuClick,h=l.menuProps;d&&d(o,r.props);var p=typeof h?.shouldFocusOnContainer=="boolean"?h.shouldFocusOnContainer:o.nativeEvent.pointerType==="mouse";o.defaultPrevented||(r._onToggleMenu(p),o.preventDefault(),o.stopPropagation())},Dw(r),r._async=new YN(r),r._events=new pE(r),Jae(_0e,i,["menuProps","onClick"],"split",r.props.split),fL(_0e,i,{rootProps:void 0,description:"secondaryText",toggled:"checked"}),r._labelId=bp(),r._descriptionId=bp(),r._ariaDescriptionId=bp(),r.state={menuHidden:!0},r}return Object.defineProperty(e.prototype,"_isSplitButton",{get:function(){return!!this.props.menuProps&&!!this.props.onClick&&this.props.split===!0},enumerable:!1,configurable:!0}),e.prototype.render=function(){var i,r=this.props,o=r.ariaDescription,l=r.ariaLabel,d=r.ariaHidden,h=r.className,p=r.disabled,g=r.allowDisabledFocus,f=r.primaryDisabled,y=r.secondaryText,T=y===void 0?this.props.description:y,C=r.href,E=r.iconProps,I=r.menuIconProps,w=r.styles,D=r.checked,F=r.variantClassName,x=r.theme,B=r.toggle,L=r.getClassNames,z=r.role,H=this.state.menuHidden,j=p||f;this._classNames=L?L(x,h,F,E&&E.className,I&&I.className,j,D,!H,!!this.props.menuProps,this.props.split,!!g):Kat(x,w,h,F,E&&E.className,I&&I.className,j,!!this.props.menuProps,D,!H,this.props.split);var J=this,Z=J._ariaDescriptionId,re=J._labelId,ne=J._descriptionId,le=!j&&!!C,he=le?"a":"button",Me=Wl(mL(le?{}:{type:"button"},this.props.rootProps,this.props),le?ore:yL,["disabled"]),Le=l||Me["aria-label"],pe=void 0;o?pe=Z:T&&this.props.onRenderDescription!==QN?pe=ne:Me["aria-describedby"]&&(pe=Me["aria-describedby"]);var te=void 0;Me["aria-labelledby"]?te=Me["aria-labelledby"]:pe&&!Le&&(te=this._hasText()?re:void 0);var Se=!(this.props["data-is-focusable"]===!1||p&&!g||this._isSplitButton),ce=z==="menuitemcheckbox"||z==="checkbox",X=ce||B===!0?!!D:void 0,ve=mL(Me,(i={className:this._classNames.root,ref:this._mergedRef(this.props.elementRef,this._buttonElement),disabled:j&&!g,onKeyDown:this._onKeyDown,onKeyPress:this._onKeyPress,onKeyUp:this._onKeyUp,onMouseDown:this._onMouseDown,onMouseUp:this._onMouseUp,onClick:this._onClick,"aria-label":Le,"aria-labelledby":te,"aria-describedby":pe,"aria-disabled":j,"data-is-focusable":Se},i[ce?"aria-checked":"aria-pressed"]=X,i));if(d&&(ve["aria-hidden"]=!0),this._isSplitButton)return this._onRenderSplitButtonContent(he,ve);if(this.props.menuProps){var Te=this.props.menuProps.id,Be=Te===void 0?"".concat(this._labelId,"-menu"):Te;mL(ve,{"aria-expanded":!H,"aria-controls":H?null:Be,"aria-haspopup":!0})}return this._onRenderContent(he,ve)},e.prototype.componentDidMount=function(){this._isSplitButton&&this._splitButtonContainer.current&&("onpointerdown"in this._splitButtonContainer.current&&this._events.on(this._splitButtonContainer.current,"pointerdown",this._onPointerDown,!0),"onpointerup"in this._splitButtonContainer.current&&this.props.onPointerUp&&this._events.on(this._splitButtonContainer.current,"pointerup",this.props.onPointerUp,!0))},e.prototype.componentDidUpdate=function(i,r){this.props.onAfterMenuDismiss&&!r.menuHidden&&this.state.menuHidden&&this.props.onAfterMenuDismiss()},e.prototype.componentWillUnmount=function(){this._async.dispose(),this._events.dispose()},e.prototype.focus=function(){var i,r;this._isSplitButton&&this._splitButtonContainer.current?(XN(!0,void 0,(i=this.context)===null||i===void 0?void 0:i.registeredProviders),this._splitButtonContainer.current.focus()):this._buttonElement.current&&(XN(!0,void 0,(r=this.context)===null||r===void 0?void 0:r.registeredProviders),this._buttonElement.current.focus())},e.prototype.dismissMenu=function(){this._dismissMenu()},e.prototype.openMenu=function(i,r){this._openMenu(i,r)},e.prototype._onRenderContent=function(i,r){var o=this,l=this.props,d=i,h=l.menuIconProps,p=l.menuProps,g=l.onRenderIcon,f=g===void 0?this._onRenderIcon:g,y=l.onRenderAriaDescription,T=y===void 0?this._onRenderAriaDescription:y,C=l.onRenderChildren,E=C===void 0?this._onRenderChildren:C,I=l.onRenderMenu,w=I===void 0?this._onRenderMenu:I,D=l.onRenderMenuIcon,F=D===void 0?this._onRenderMenuIcon:D,x=l.disabled,B=l.keytipProps;B&&p&&(B=this._getMemoizedMenuButtonKeytipProps(B));var L=function(H){return $.createElement(d,Rt({},r,H),$.createElement("span",{className:o._classNames.flexContainer,"data-automationid":"splitbuttonprimary"},f(l,o._onRenderIcon),o._onRenderTextContents(),T(l,o._onRenderAriaDescription),E(l,o._onRenderChildren),!o._isSplitButton&&(p||h||o.props.onRenderMenuIcon)&&F(o.props,o._onRenderMenuIcon),p&&!p.doNotLayer&&o._shouldRenderMenu()&&w(o._getMenuProps(p),o._onRenderMenu)))},z=B?$.createElement(lH,{keytipProps:this._isSplitButton?void 0:B,ariaDescribedBy:r["aria-describedby"],disabled:x},function(H){return L(H)}):L();return p&&p.doNotLayer?$.createElement($.Fragment,null,z,this._shouldRenderMenu()&&w(this._getMenuProps(p),this._onRenderMenu)):$.createElement($.Fragment,null,z,$.createElement(W_e,null))},e.prototype._shouldRenderMenu=function(){var i=this.state.menuHidden,r=this.props,o=r.persistMenu,l=r.renderPersistedMenuHiddenOnMount;if(i){if(o&&(this._renderedVisibleMenu||l))return!0}else return!0;return!1},e.prototype._hasText=function(){return this.props.text!==null&&(this.props.text!==void 0||typeof this.props.children=="string")},e.prototype._getMenuProps=function(i){var r=this.props.persistMenu,o=this.state.menuHidden;return!i.ariaLabel&&!i.labelElementId&&this._hasText()&&(i=Rt(Rt({},i),{labelElementId:this._labelId})),Rt(Rt({id:this._labelId+"-menu",directionalHint:hd.bottomLeftEdge},i),{shouldFocusOnContainer:this._menuShouldFocusOnContainer,shouldFocusOnMount:this._menuShouldFocusOnMount,hidden:r?o:void 0,className:wh("ms-BaseButton-menuhost",i.className),target:this._isSplitButton?this._splitButtonContainer.current:this._buttonElement.current,onDismiss:this._onDismissMenu})},e.prototype._onRenderSplitButtonContent=function(i,r){var o=this,l=this.props,d=l.styles,h=d===void 0?{}:d,p=l.disabled,g=l.allowDisabledFocus,f=l.checked,y=l.getSplitButtonClassNames,T=l.primaryDisabled,C=l.menuProps,E=l.toggle,I=l.role,w=l.primaryActionButtonProps,D=this.props.keytipProps,F=this.state.menuHidden,x=y?y(!!p,!F,!!f,!!g):h&&Yat(h,!!p,!F,!!f,!!T);mL(r,{onClick:void 0,onPointerDown:void 0,onPointerUp:void 0,tabIndex:-1,"data-is-focusable":!1}),D&&C&&(D=this._getMemoizedMenuButtonKeytipProps(D));var B=Wl(r,[],["disabled"]);w&&mL(r,w);var L=function(z){return $.createElement("div",Rt({},B,{"data-ktp-target":z?z["data-ktp-target"]:void 0,role:I||"button","aria-disabled":p,"aria-haspopup":!0,"aria-expanded":!F,"aria-pressed":E?!!f:void 0,"aria-describedby":FU(r["aria-describedby"],z?z["aria-describedby"]:void 0),className:x&&x.splitButtonContainer,onKeyDown:o._onSplitButtonContainerKeyDown,onTouchStart:o._onTouchStart,ref:o._splitButtonContainer,"data-is-focusable":!0,onClick:!p&&!T?o._onSplitButtonPrimaryClick:void 0,tabIndex:!p&&!T||g?0:void 0,"aria-roledescription":r["aria-roledescription"],onFocusCapture:o._onSplitContainerFocusCapture}),$.createElement("span",{style:{display:"flex",width:"100%"}},o._onRenderContent(i,r),o._onRenderSplitButtonMenuButton(x,z),o._onRenderSplitButtonDivider(x)))};return D?$.createElement(lH,{keytipProps:D,disabled:p},function(z){return L(z)}):L()},e.prototype._onRenderSplitButtonDivider=function(i){if(i&&i.divider){var r=function(o){o.stopPropagation()};return $.createElement("span",{className:i.divider,"aria-hidden":!0,onClick:r})}return null},e.prototype._onRenderSplitButtonMenuButton=function(i,r){var o=this.props,l=o.allowDisabledFocus,d=o.checked,h=o.disabled,p=o.splitButtonMenuProps,g=o.splitButtonAriaLabel,f=o.primaryDisabled,y=this.state.menuHidden,T=this.props.menuIconProps;T===void 0&&(T={iconName:"ChevronDown"});var C=Rt(Rt({},p),{styles:i,checked:d,disabled:h,allowDisabledFocus:l,onClick:this._onMenuClick,menuProps:void 0,iconProps:Rt(Rt({},T),{className:this._classNames.menuIcon}),ariaLabel:g,"aria-haspopup":!0,"aria-expanded":!y,"data-is-focusable":!1});return $.createElement(e,Rt({},C,{"data-ktp-execute-target":r&&r["data-ktp-execute-target"],onMouseDown:this._onMouseDown,tabIndex:f&&!l?0:-1}))},e.prototype._onPointerDown=function(i){var r=this.props.onPointerDown;r&&r(i),i.pointerType==="touch"&&(this._handleTouchAndPointerEvent(),i.preventDefault(),i.stopImmediatePropagation())},e.prototype._handleTouchAndPointerEvent=function(){var i=this;this._lastTouchTimeoutId!==void 0&&(this._async.clearTimeout(this._lastTouchTimeoutId),this._lastTouchTimeoutId=void 0),this._processingTouch=!0,this._lastTouchTimeoutId=this._async.setTimeout(function(){i._processingTouch=!1,i._lastTouchTimeoutId=void 0,i.state.menuHidden&&i.focus()},Qat)},e.prototype._isValidMenuOpenKey=function(i){return this.props.menuTriggerKeyCode?i.which===this.props.menuTriggerKeyCode:this.props.menuProps?i.which===fa.down&&(i.altKey||i.metaKey):!1},e.defaultProps={baseClassName:"ms-Button",styles:{},split:!1},e.contextType=H$,e}($.Component),E0e={outline:0},A0e=function(t){return{fontSize:t,margin:"0 4px",height:"16px",lineHeight:"16px",textAlign:"center",flexShrink:0}},gW=ql(function(t){var e,i,r=t.semanticColors,o=t.effects,l=t.fonts,d=r.buttonBorder,h=r.disabledBackground,p=r.disabledText,g={left:-2,top:-2,bottom:-2,right:-2,outlineColor:"ButtonText"};return{root:[vE(t,{inset:1,highContrastStyle:g,borderColor:"transparent"}),t.fonts.medium,{border:"1px solid "+d,borderRadius:o.roundedCorner2,boxSizing:"border-box",cursor:"pointer",display:"inline-flex",alignItems:"center",justifyContent:"center",padding:"0 16px",textDecoration:"none",textAlign:"center",userSelect:"none",":active > span":{position:"relative",left:0,top:0}}],rootDisabled:[vE(t,{inset:1,highContrastStyle:g,borderColor:"transparent"}),{backgroundColor:h,borderColor:h,color:p,cursor:"default",":hover":E0e,":focus":E0e}],iconDisabled:(e={color:p},e[Rn]={color:"GrayText"},e),menuIconDisabled:(i={color:p},i[Rn]={color:"GrayText"},i),flexContainer:{display:"flex",height:"100%",flexWrap:"nowrap",justifyContent:"center",alignItems:"center"},description:{display:"block"},textContainer:{flexGrow:1,display:"block"},icon:A0e(l.mediumPlus.fontSize),menuIcon:A0e(l.small.fontSize),label:{margin:"0 4px",lineHeight:"100%",display:"block"},screenReaderText:W$}}),Lre=ql(function(t,e){var i,r,o,l,d,h,p,g,f,y,T,C,E,I,w,D,F,x=t.effects,B=t.palette,L=t.semanticColors,z={left:-2,top:-2,bottom:-2,right:-2,border:"none"},H={position:"absolute",width:1,right:31,top:8,bottom:8},j={splitButtonContainer:[vE(t,{highContrastStyle:z,inset:2,pointerEvents:"none"}),{display:"inline-flex",".ms-Button--default":{borderTopRightRadius:"0",borderBottomRightRadius:"0",borderRight:"none",flexGrow:"1"},".ms-Button--primary":(i={borderTopRightRadius:"0",borderBottomRightRadius:"0",border:"none",flexGrow:"1",":hover":{border:"none"},":active":{border:"none"}},i[Rn]=Rt(Rt({color:"WindowText",backgroundColor:"Window",border:"1px solid WindowText",borderRightWidth:"0"},uc()),{":hover":{backgroundColor:"Highlight",border:"1px solid Highlight",borderRightWidth:"0",color:"HighlightText"},":active":{border:"1px solid Highlight"}}),i),".ms-Button--default + .ms-Button":(r={},r[Rn]={border:"1px solid WindowText",borderLeftWidth:"0",":hover":{backgroundColor:"HighlightText",borderColor:"Highlight",color:"Highlight",".ms-Button-menuIcon":Rt({backgroundColor:"HighlightText",color:"Highlight"},uc())}},r),'.ms-Button--default + .ms-Button[aria-expanded="true"]':(o={},o[Rn]={backgroundColor:"HighlightText",borderColor:"Highlight",color:"Highlight",".ms-Button-menuIcon":Rt({backgroundColor:"HighlightText",color:"Highlight"},uc())},o),".ms-Button--primary + .ms-Button":(l={border:"none"},l[Rn]={border:"1px solid WindowText",borderLeftWidth:"0",":hover":{borderLeftWidth:"0",backgroundColor:"Highlight",borderColor:"Highlight",color:"HighlightText",".ms-Button-menuIcon":Rt(Rt({},uc()),{color:"HighlightText"})}},l),'.ms-Button--primary + .ms-Button[aria-expanded="true"]':(d={},d[Rn]=Rt(Rt({backgroundColor:"Highlight",borderColor:"Highlight",color:"HighlightText"},uc()),{".ms-Button-menuIcon":{color:"HighlightText"}}),d),".ms-Button.is-disabled":(h={},h[Rn]={color:"GrayText",borderColor:"GrayText",backgroundColor:"Window"},h)}],splitButtonContainerHovered:{".ms-Button--default.is-disabled":(p={backgroundColor:L.buttonBackgroundDisabled,color:L.buttonTextDisabled},p[Rn]={color:"GrayText",borderColor:"GrayText",backgroundColor:"Window"},p),".ms-Button--primary.is-disabled":(g={backgroundColor:L.primaryButtonBackgroundDisabled,color:L.primaryButtonTextDisabled},g[Rn]={color:"GrayText",borderColor:"GrayText",backgroundColor:"Window"},g)},splitButtonContainerChecked:{".ms-Button--primary":(f={},f[Rn]=Rt({color:"Window",backgroundColor:"WindowText"},uc()),f)},splitButtonContainerCheckedHovered:{".ms-Button--primary":(y={},y[Rn]=Rt({color:"Window",backgroundColor:"WindowText"},uc()),y)},splitButtonContainerFocused:{outline:"none!important"},splitButtonMenuButton:(T={padding:6,height:"auto",boxSizing:"border-box",borderRadius:0,borderTopRightRadius:x.roundedCorner2,borderBottomRightRadius:x.roundedCorner2,border:"1px solid ".concat(B.neutralSecondaryAlt),borderLeft:"none",outline:"transparent",userSelect:"none",display:"inline-block",textDecoration:"none",textAlign:"center",cursor:"pointer",verticalAlign:"top",width:32,marginLeft:-1,marginTop:0,marginRight:0,marginBottom:0},T[Rn]={".ms-Button-menuIcon":{color:"WindowText"}},T),splitButtonDivider:Rt(Rt({},H),(C={},C[Rn]={backgroundColor:"WindowText"},C)),splitButtonDividerDisabled:Rt(Rt({},H),(E={},E[Rn]={backgroundColor:"GrayText"},E)),splitButtonMenuButtonDisabled:(I={pointerEvents:"none",border:"none",":hover":{cursor:"default"},".ms-Button--primary":(w={},w[Rn]={color:"GrayText",borderColor:"GrayText",backgroundColor:"Window"},w),".ms-Button-menuIcon":(D={},D[Rn]={color:"GrayText"},D)},I[Rn]={color:"GrayText",border:"1px solid GrayText",backgroundColor:"Window"},I),splitButtonFlexContainer:{display:"flex",height:"100%",flexWrap:"nowrap",justifyContent:"center",alignItems:"center"},splitButtonContainerDisabled:(F={outline:"none",border:"none"},F[Rn]=Rt({color:"GrayText",borderColor:"GrayText",backgroundColor:"Window"},uc()),F),splitButtonMenuFocused:Rt({},vE(t,{highContrastStyle:z,inset:2}))};return Ds(j,e)}),I0e=function(){return{position:"absolute",width:1,right:31,top:8,bottom:8}};function Zat(t){var e,i,r,o,l,d=t.semanticColors,h=t.palette,p=d.buttonBackground,g=d.buttonBackgroundPressed,f=d.buttonBackgroundHovered,y=d.buttonBackgroundDisabled,T=d.buttonText,C=d.buttonTextHovered,E=d.buttonTextDisabled,I=d.buttonTextChecked,w=d.buttonTextCheckedHovered;return{root:{backgroundColor:p,color:T},rootHovered:(e={backgroundColor:f,color:C},e[Rn]={borderColor:"Highlight",color:"Highlight"},e),rootPressed:{backgroundColor:g,color:I},rootExpanded:{backgroundColor:g,color:I},rootChecked:{backgroundColor:g,color:I},rootCheckedHovered:{backgroundColor:g,color:w},rootDisabled:(i={color:E,backgroundColor:y},i[Rn]={color:"GrayText",borderColor:"GrayText",backgroundColor:"Window"},i),splitButtonContainer:(r={},r[Rn]={border:"none"},r),splitButtonMenuButton:{color:h.white,backgroundColor:"transparent",":hover":(o={backgroundColor:h.neutralLight},o[Rn]={color:"Highlight"},o)},splitButtonMenuButtonDisabled:{backgroundColor:d.buttonBackgroundDisabled,":hover":{backgroundColor:d.buttonBackgroundDisabled}},splitButtonDivider:Rt(Rt({},I0e()),(l={backgroundColor:h.neutralTertiaryAlt},l[Rn]={backgroundColor:"WindowText"},l)),splitButtonDividerDisabled:{backgroundColor:t.palette.neutralTertiaryAlt},splitButtonMenuButtonChecked:{backgroundColor:h.neutralQuaternaryAlt,":hover":{backgroundColor:h.neutralQuaternaryAlt}},splitButtonMenuButtonExpanded:{backgroundColor:h.neutralQuaternaryAlt,":hover":{backgroundColor:h.neutralQuaternaryAlt}},splitButtonMenuIcon:{color:d.buttonText},splitButtonMenuIconDisabled:{color:d.buttonTextDisabled}}}function Xat(t){var e,i,r,o,l,d,h,p,g,f=t.palette,y=t.semanticColors;return{root:(e={backgroundColor:y.primaryButtonBackground,border:"1px solid ".concat(y.primaryButtonBackground),color:y.primaryButtonText},e[Rn]=Rt({color:"Window",backgroundColor:"WindowText",borderColor:"WindowText"},uc()),e[".".concat(ys," &:focus, :host(.").concat(ys,") &:focus")]={":after":{border:"none",outlineColor:f.white}},e),rootHovered:(i={backgroundColor:y.primaryButtonBackgroundHovered,border:"1px solid ".concat(y.primaryButtonBackgroundHovered),color:y.primaryButtonTextHovered},i[Rn]={color:"Window",backgroundColor:"Highlight",borderColor:"Highlight"},i),rootPressed:(r={backgroundColor:y.primaryButtonBackgroundPressed,border:"1px solid ".concat(y.primaryButtonBackgroundPressed),color:y.primaryButtonTextPressed},r[Rn]=Rt({color:"Window",backgroundColor:"WindowText",borderColor:"WindowText"},uc()),r),rootExpanded:{backgroundColor:y.primaryButtonBackgroundPressed,color:y.primaryButtonTextPressed},rootChecked:{backgroundColor:y.primaryButtonBackgroundPressed,color:y.primaryButtonTextPressed},rootCheckedHovered:{backgroundColor:y.primaryButtonBackgroundPressed,color:y.primaryButtonTextPressed},rootDisabled:(o={color:y.primaryButtonTextDisabled,backgroundColor:y.primaryButtonBackgroundDisabled},o[Rn]={color:"GrayText",borderColor:"GrayText",backgroundColor:"Window"},o),splitButtonContainer:(l={},l[Rn]={border:"none"},l),splitButtonDivider:Rt(Rt({},I0e()),(d={backgroundColor:f.white},d[Rn]={backgroundColor:"Window"},d)),splitButtonMenuButton:(h={backgroundColor:y.primaryButtonBackground,color:y.primaryButtonText},h[Rn]={backgroundColor:"Canvas"},h[":hover"]=(p={backgroundColor:y.primaryButtonBackgroundHovered},p[Rn]={color:"Highlight"},p),h),splitButtonMenuButtonDisabled:{backgroundColor:y.primaryButtonBackgroundDisabled,":hover":{backgroundColor:y.primaryButtonBackgroundDisabled}},splitButtonMenuButtonChecked:{backgroundColor:y.primaryButtonBackgroundPressed,":hover":{backgroundColor:y.primaryButtonBackgroundPressed}},splitButtonMenuButtonExpanded:{backgroundColor:y.primaryButtonBackgroundPressed,":hover":{backgroundColor:y.primaryButtonBackgroundPressed}},splitButtonMenuIcon:{color:y.primaryButtonText},splitButtonMenuIconDisabled:(g={color:f.neutralTertiary},g[Rn]={color:"GrayText"},g)}}var ert="32px",trt="80px",irt=ql(function(t,e,i){var r=gW(t),o=Lre(t),l={root:{minWidth:trt,minHeight:ert},label:{fontWeight:xs.semibold}};return Ds(r,l,i?Xat(t):Zat(t),o,e)}),th=function(t){mu(e,t);function e(){return t!==null&&t.apply(this,arguments)||this}return e.prototype.render=function(){var i=this.props,r=i.primary,o=r===void 0?!1:r,l=i.styles,d=i.theme;return $.createElement(pW,Rt({},this.props,{variantClassName:o?"ms-Button--primary":"ms-Button--default",styles:irt(d,l,o),onRenderDescription:QN}))},e=B$([$$("DefaultButton",["theme","styles"])],e),e}($.Component),nrt="40px",art="0 4px",rrt=ql(function(t,e){var i,r,o,l=gW(t),d={root:(i={padding:art,height:nrt,color:t.palette.neutralPrimary,backgroundColor:"transparent",border:"1px solid transparent"},i[Rn]={borderColor:"Window"},i),rootHovered:(r={color:t.palette.themePrimary},r[Rn]={color:"Highlight"},r),iconHovered:{color:t.palette.themePrimary},rootPressed:{color:t.palette.black},rootExpanded:{color:t.palette.themePrimary},iconPressed:{color:t.palette.themeDarker},rootDisabled:(o={color:t.palette.neutralTertiary,backgroundColor:"transparent",borderColor:"transparent"},o[Rn]={color:"GrayText"},o),rootChecked:{color:t.palette.black},iconChecked:{color:t.palette.themeDarker},flexContainer:{justifyContent:"flex-start"},icon:{color:t.palette.themeDarkAlt},iconDisabled:{color:"inherit"},menuIcon:{color:t.palette.neutralSecondary},textContainer:{flexGrow:0}};return Ds(l,d,e)}),ort=function(t){mu(e,t);function e(){return t!==null&&t.apply(this,arguments)||this}return e.prototype.render=function(){var i=this.props,r=i.styles,o=i.theme;return $.createElement(pW,Rt({},this.props,{variantClassName:"ms-Button--action ms-Button--command",styles:rrt(o,r),onRenderDescription:QN}))},e=B$([$$("ActionButton",["theme","styles"])],e),e}($.Component),srt=ql(function(t,e){var i,r=gW(t),o=Lre(t),l=t.palette,d=t.semanticColors,h={root:{padding:"0 4px",width:"32px",height:"32px",backgroundColor:"transparent",border:"none",color:d.link},rootHovered:(i={color:l.themeDarkAlt,backgroundColor:l.neutralLighter},i[Rn]={borderColor:"Highlight",color:"Highlight"},i),rootHasMenu:{width:"auto"},rootPressed:{color:l.themeDark,backgroundColor:l.neutralLight},rootExpanded:{color:l.themeDark,backgroundColor:l.neutralLight},rootChecked:{color:l.themeDark,backgroundColor:l.neutralLight},rootCheckedHovered:{color:l.themeDark,backgroundColor:l.neutralQuaternaryAlt},rootDisabled:{color:l.neutralTertiaryAlt}};return Ds(r,h,o,e)}),zy=function(t){mu(e,t);function e(){return t!==null&&t.apply(this,arguments)||this}return e.prototype.render=function(){var i=this.props,r=i.styles,o=i.theme;return $.createElement(pW,Rt({},this.props,{variantClassName:"ms-Button--icon",styles:srt(o,r),onRenderText:QN,onRenderDescription:QN}))},e=B$([$$("IconButton",["theme","styles"])],e),e}($.Component),SE=function(t){mu(e,t);function e(){return t!==null&&t.apply(this,arguments)||this}return e.prototype.render=function(){return $.createElement(th,Rt({},this.props,{primary:!0,onRenderDescription:QN}))},e=B$([$$("PrimaryButton",["theme","styles"])],e),e}($.Component),lrt=ql(function(t,e,i,r){var o,l,d,h,p,g,f,y,T,C,E,I,w,D=gW(t),F=Lre(t),x=t.palette,B=t.semanticColors,L={left:4,top:4,bottom:4,right:4,border:"none"},z={root:[vE(t,{inset:2,highContrastStyle:L,borderColor:"transparent"}),t.fonts.medium,(o={minWidth:"40px",backgroundColor:x.white,color:x.neutralPrimary,padding:"0 4px",border:"none",borderRadius:0},o[Rn]={border:"none"},o)],rootHovered:(l={backgroundColor:x.neutralLighter,color:x.neutralDark},l[Rn]={color:"Highlight"},l[".".concat(WS.msButtonIcon)]={color:x.themeDarkAlt},l[".".concat(WS.msButtonMenuIcon)]={color:x.neutralPrimary},l),rootPressed:(d={backgroundColor:x.neutralLight,color:x.neutralDark},d[".".concat(WS.msButtonIcon)]={color:x.themeDark},d[".".concat(WS.msButtonMenuIcon)]={color:x.neutralPrimary},d),rootChecked:(h={backgroundColor:x.neutralLight,color:x.neutralDark},h[".".concat(WS.msButtonIcon)]={color:x.themeDark},h[".".concat(WS.msButtonMenuIcon)]={color:x.neutralPrimary},h),rootCheckedHovered:(p={backgroundColor:x.neutralQuaternaryAlt},p[".".concat(WS.msButtonIcon)]={color:x.themeDark},p[".".concat(WS.msButtonMenuIcon)]={color:x.neutralPrimary},p),rootExpanded:(g={backgroundColor:x.neutralLight,color:x.neutralDark},g[".".concat(WS.msButtonIcon)]={color:x.themeDark},g[".".concat(WS.msButtonMenuIcon)]={color:x.neutralPrimary},g),rootExpandedHovered:{backgroundColor:x.neutralQuaternaryAlt},rootDisabled:(f={backgroundColor:x.white},f[".".concat(WS.msButtonIcon)]=(y={color:B.disabledBodySubtext},y[Rn]=Rt({color:"GrayText"},uc()),y),f[Rn]=Rt({color:"GrayText",backgroundColor:"Window"},uc()),f),splitButtonContainer:(T={height:"100%"},T[Rn]={border:"none"},T),splitButtonDividerDisabled:(C={},C[Rn]={backgroundColor:"Window"},C),splitButtonDivider:{backgroundColor:x.neutralTertiaryAlt},splitButtonMenuButton:{backgroundColor:x.white,border:"none",borderTopRightRadius:"0",borderBottomRightRadius:"0",color:x.neutralSecondary,":hover":(E={backgroundColor:x.neutralLighter,color:x.neutralDark},E[Rn]={color:"Highlight"},E[".".concat(WS.msButtonIcon)]={color:x.neutralPrimary},E),":active":(I={backgroundColor:x.neutralLight},I[".".concat(WS.msButtonIcon)]={color:x.neutralPrimary},I)},splitButtonMenuButtonDisabled:(w={backgroundColor:x.white},w[Rn]=Rt({color:"GrayText",border:"none",backgroundColor:"Window"},uc()),w),splitButtonMenuButtonChecked:{backgroundColor:x.neutralLight,color:x.neutralDark,":hover":{backgroundColor:x.neutralQuaternaryAlt}},splitButtonMenuButtonExpanded:{backgroundColor:x.neutralLight,color:x.black,":hover":{backgroundColor:x.neutralQuaternaryAlt}},splitButtonMenuIcon:{color:x.neutralPrimary},splitButtonMenuIconDisabled:{color:x.neutralTertiary},label:{fontWeight:"normal"},icon:{color:x.themePrimary},menuIcon:{color:x.neutralSecondary}};return Ds(D,F,z,e)}),crt=function(t){mu(e,t);function e(){return t!==null&&t.apply(this,arguments)||this}return e.prototype.render=function(){var i=this.props,r=i.styles,o=i.theme;return $.createElement(pW,Rt({},this.props,{variantClassName:"ms-Button--commandBar",styles:lrt(o,r),onRenderDescription:QN}))},e=B$([$$("CommandBarButton",["theme","styles"])],e),e}($.Component),Ore=ort,drt=fu(),w0e=$.forwardRef(function(t,e){var i=t.disabled,r=t.required,o=t.inputProps,l=t.name,d=t.ariaLabel,h=t.ariaLabelledBy,p=t.ariaDescribedBy,g=t.ariaPositionInSet,f=t.ariaSetSize,y=t.title,T=t.checkmarkIconProps,C=t.styles,E=t.theme,I=t.className,w=t.boxSide,D=w===void 0?"start":w,F=yu("checkbox-",t.id),x=$.useRef(null),B=Ff(x,e),L=$.useRef(null),z=Z$(t.checked,t.defaultChecked,t.onChange),H=z[0],j=z[1],J=Z$(t.indeterminate,t.defaultIndeterminate),Z=J[0],re=J[1];j$(x),urt(t);var ne=drt(C,{theme:E,className:I,disabled:i,indeterminate:Z,checked:H,reversed:D!=="start",isUsingCustomLabelRender:!!t.onRenderLabel}),le=$.useCallback(function(Se){Z?(j(!!H,Se),re(!1)):j(!H,Se)},[j,re,Z,H]),he=$.useCallback(function(Se){return Se&&Se.label?$.createElement("span",{className:ne.text,title:Se.title},Se.label):null},[ne.text]),Me=$.useCallback(function(Se){if(L.current){var ce=!!Se;L.current.indeterminate=ce,re(ce)}},[re]);hrt(t,H,Z,Me,L),$.useEffect(function(){return Me(Z)},[Me,Z]);var Le=t.onRenderLabel||he,pe=Z?"mixed":void 0,te=Rt(Rt({className:ne.input,type:"checkbox"},o),{checked:!!H,disabled:i,required:r,name:l,id:F,title:y,onChange:le,"aria-disabled":i,"aria-label":d,"aria-labelledby":h,"aria-describedby":p,"aria-posinset":g,"aria-setsize":f,"aria-checked":pe});return $.createElement("div",{className:ne.root,title:y,ref:B},$.createElement("input",Rt({},te,{ref:L,title:y,"data-ktp-execute-target":!0})),$.createElement("label",{className:ne.label,htmlFor:F},$.createElement("div",{className:ne.checkbox,"data-ktp-target":!0},$.createElement(Fr,Rt({iconName:"CheckMark"},T,{className:ne.checkmark}))),Le(t,he)))});w0e.displayName="CheckboxBase";function urt(t){process.env.NODE_ENV!=="production"&&CM({name:"Checkbox",props:t,mutuallyExclusive:{checked:"defaultChecked",indeterminate:"defaultIndeterminate"}})}function hrt(t,e,i,r,o){$.useImperativeHandle(t.componentRef,function(){return{get checked(){return!!e},get indeterminate(){return!!i},set indeterminate(l){r(l)},focus:function(){o.current&&o.current.focus()}}},[o,e,i,r])}var prt={root:"ms-Checkbox",label:"ms-Checkbox-label",checkbox:"ms-Checkbox-checkbox",checkmark:"ms-Checkbox-checkmark",text:"ms-Checkbox-text"},k0e="20px",R0e="200ms",M0e="cubic-bezier(.4, 0, .23, 1)",grt=function(t){var e,i,r,o,l,d,h,p,g,f,y,T,C,E,I,w,D,F,x=t.className,B=t.theme,L=t.reversed,z=t.checked,H=t.disabled,j=t.isUsingCustomLabelRender,J=t.indeterminate,Z=B.semanticColors,re=B.effects,ne=B.palette,le=B.fonts,he=eh(prt,B),Me=Z.inputForegroundChecked,Le=ne.neutralSecondary,pe=ne.neutralPrimary,te=Z.inputBackgroundChecked,Se=Z.inputBackgroundChecked,ce=Z.disabledBodySubtext,X=Z.inputBorderHovered,ve=Z.inputBackgroundCheckedHovered,Te=Z.inputBackgroundChecked,Be=Z.inputBackgroundCheckedHovered,qe=Z.inputBackgroundCheckedHovered,Ge=Z.inputTextHovered,tt=Z.disabledBodySubtext,ct=Z.bodyText,Mt=Z.disabledText,ht=[(e={content:'""',borderRadius:re.roundedCorner2,position:"absolute",width:10,height:10,top:4,left:4,boxSizing:"border-box",borderWidth:5,borderStyle:"solid",borderColor:H?ce:te,transitionProperty:"border-width, border, border-color",transitionDuration:R0e,transitionTimingFunction:M0e},e[Rn]={borderColor:"WindowText"},e)];return{root:[he.root,{position:"relative",display:"flex"},L&&"reversed",z&&"is-checked",!H&&"is-enabled",H&&"is-disabled",!H&&[!z&&(i={},i[":hover .".concat(he.checkbox)]=(r={borderColor:X},r[Rn]={borderColor:"Highlight"},r),i[":focus .".concat(he.checkbox)]={borderColor:X},i[":hover .".concat(he.checkmark)]=(o={color:Le,opacity:"1"},o[Rn]={color:"Highlight"},o),i),z&&!J&&(l={},l[":hover .".concat(he.checkbox)]={background:Be,borderColor:qe},l[":focus .".concat(he.checkbox)]={background:Be,borderColor:qe},l[Rn]=(d={},d[":hover .".concat(he.checkbox)]={background:"Highlight",borderColor:"Highlight"},d[":focus .".concat(he.checkbox)]={background:"Highlight"},d[":focus:hover .".concat(he.checkbox)]={background:"Highlight"},d[":focus:hover .".concat(he.checkmark)]={color:"Window"},d[":hover .".concat(he.checkmark)]={color:"Window"},d),l),J&&(h={},h[":hover .".concat(he.checkbox,", :hover .").concat(he.checkbox,":after")]=(p={borderColor:ve},p[Rn]={borderColor:"WindowText"},p),h[":focus .".concat(he.checkbox)]={borderColor:ve},h[":hover .".concat(he.checkmark)]={opacity:"0"},h),(g={},g[":hover .".concat(he.text,", :focus .").concat(he.text)]=(f={color:Ge},f[Rn]={color:H?"GrayText":"WindowText"},f),g)],x],input:(y={position:"absolute",background:"none",opacity:0},y[".".concat(ys," &:focus + label::before, :host(.").concat(ys,") &:focus + label::before")]=(T={outline:"1px solid "+B.palette.neutralSecondary,outlineOffset:"2px"},T[Rn]={outline:"1px solid WindowText"},T),y),label:[he.label,B.fonts.medium,{display:"flex",alignItems:j?"center":"flex-start",cursor:H?"default":"pointer",position:"relative",userSelect:"none"},L&&{flexDirection:"row-reverse",justifyContent:"flex-end"},{"&::before":{position:"absolute",left:0,right:0,top:0,bottom:0,content:'""',pointerEvents:"none"}}],checkbox:[he.checkbox,(C={position:"relative",display:"flex",flexShrink:0,alignItems:"center",justifyContent:"center",height:k0e,width:k0e,border:"1px solid ".concat(pe),borderRadius:re.roundedCorner2,boxSizing:"border-box",transitionProperty:"background, border, border-color",transitionDuration:R0e,transitionTimingFunction:M0e,overflow:"hidden",":after":J?ht:null},C[Rn]=Rt({borderColor:"WindowText"},uc()),C),J&&{borderColor:te},L?{marginLeft:4}:{marginRight:4},!H&&!J&&z&&(E={background:Te,borderColor:Se},E[Rn]={background:"Highlight",borderColor:"Highlight"},E),H&&(I={borderColor:ce},I[Rn]={borderColor:"GrayText"},I),z&&H&&(w={background:tt,borderColor:ce},w[Rn]={background:"Window"},w)],checkmark:[he.checkmark,(D={opacity:z&&!J?"1":"0",color:Me},D[Rn]=Rt({color:H?"GrayText":"Window"},uc()),D)],text:[he.text,(F={color:H?Mt:ct,fontSize:le.medium.fontSize,lineHeight:"20px"},F[Rn]=Rt({color:H?"GrayText":"WindowText"},uc()),F),L?{marginRight:4}:{marginLeft:4}]}},Nre=vu(w0e,grt,void 0,{scope:"Checkbox"}),mrt=fu({cacheSize:100}),frt=function(t){mu(e,t);function e(){return t!==null&&t.apply(this,arguments)||this}return e.prototype.render=function(){var i=this.props,r=i.as,o=r===void 0?"label":r,l=i.children,d=i.className,h=i.disabled,p=i.styles,g=i.required,f=i.theme,y=mrt(p,{className:d,disabled:h,required:g,theme:f});return $.createElement(o,Rt({},Wl(this.props,Nf),{className:y.root}),l)},e}($.Component),vrt=function(t){var e,i=t.theme,r=t.className,o=t.disabled,l=t.required,d=i.semanticColors,h=xs.semibold,p=d.bodyText,g=d.disabledBodyText,f=d.errorText;return{root:["ms-Label",i.fonts.medium,{fontWeight:h,color:p,boxSizing:"border-box",boxShadow:"none",margin:0,display:"block",padding:"5px 0",wordWrap:"break-word",overflowWrap:"break-word"},o&&{color:g,selectors:(e={},e[Rn]=Rt({color:"GrayText"},uc()),e)},l&&{selectors:{"::after":{content:"' *'",color:f,paddingRight:12}}},r]}},px=vu(frt,vrt,void 0,{scope:"Label"}),yrt=fu(),Srt="",AL="TextField",brt="RedEye",Trt="Hide",Crt=function(t){mu(e,t);function e(i){var r=t.call(this,i)||this;r._textElement=$.createRef(),r._onFocus=function(d){r.props.onFocus&&r.props.onFocus(d),r.setState({isFocused:!0},function(){r.props.validateOnFocusIn&&r._validate(r.value)})},r._onBlur=function(d){r.props.onBlur&&r.props.onBlur(d),r.setState({isFocused:!1},function(){r.props.validateOnFocusOut&&r._validate(r.value)})},r._onRenderLabel=function(d){var h=d.label,p=d.required,g=r._classNames.subComponentStyles?r._classNames.subComponentStyles.label:void 0;return h?$.createElement(px,{required:p,htmlFor:r._id,styles:g,disabled:d.disabled,id:r._labelId},d.label):null},r._onRenderDescription=function(d){return d.description?$.createElement("span",{className:r._classNames.description},d.description):null},r._onRevealButtonClick=function(d){r.setState(function(h){return{isRevealingPassword:!h.isRevealingPassword}})},r._onInputChange=function(d){var h,p,g=d.target,f=g.value,y=xre(r.props,r.state)||"";if(f===void 0||f===r._lastChangeValue||f===y){r._lastChangeValue=void 0;return}r._lastChangeValue=f,(p=(h=r.props).onChange)===null||p===void 0||p.call(h,d,f),r._isControlled||r.setState({uncontrolledValue:f})},Dw(r),r._async=new YN(r),process.env.NODE_ENV!=="production"&&Uq(AL,i,{errorMessage:"onGetErrorMessage"}),r._fallbackId=bp(AL),r._descriptionId=bp(AL+"Description"),r._labelId=bp(AL+"Label"),r._prefixId=bp(AL+"Prefix"),r._suffixId=bp(AL+"Suffix"),r._warnControlledUsage();var o=i.defaultValue,l=o===void 0?Srt:o;return typeof l=="number"&&(l=String(l)),r.state={uncontrolledValue:r._isControlled?void 0:l,isFocused:!1,errorMessage:""},r._delayedValidate=r._async.debounce(r._validate,r.props.deferredValidationTime),r._lastValidation=0,r}return Object.defineProperty(e.prototype,"value",{get:function(){return xre(this.props,this.state)},enumerable:!1,configurable:!0}),e.prototype.componentDidMount=function(){this._adjustInputHeight(),this.props.validateOnLoad&&this._validate(this.value)},e.prototype.componentWillUnmount=function(){this._async.dispose()},e.prototype.getSnapshotBeforeUpdate=function(i,r){return{selection:[this.selectionStart,this.selectionEnd]}},e.prototype.componentDidUpdate=function(i,r,o){var l=this.props,d=(o||{}).selection,h=d===void 0?[null,null]:d,p=h[0],g=h[1];!!i.multiline!=!!l.multiline&&r.isFocused&&(this.focus(),p!==null&&g!==null&&p>=0&&g>=0&&this.setSelectionRange(p,g)),i.value!==l.value&&(this._lastChangeValue=void 0);var f=xre(i,r),y=this.value;f!==y&&(this._warnControlledUsage(i),this.state.errorMessage&&!l.errorMessage&&this.setState({errorMessage:""}),this._adjustInputHeight(),P0e(l)&&this._delayedValidate(y))},e.prototype.render=function(){var i=this.props,r=i.borderless,o=i.className,l=i.disabled,d=i.invalid,h=i.iconProps,p=i.inputClassName,g=i.label,f=i.multiline,y=i.required,T=i.underlined,C=i.prefix,E=i.resizable,I=i.suffix,w=i.theme,D=i.styles,F=i.autoAdjustHeight,x=i.canRevealPassword,B=i.revealPasswordAriaLabel,L=i.type,z=i.onRenderPrefix,H=z===void 0?this._onRenderPrefix:z,j=i.onRenderSuffix,J=j===void 0?this._onRenderSuffix:j,Z=i.onRenderLabel,re=Z===void 0?this._onRenderLabel:Z,ne=i.onRenderDescription,le=ne===void 0?this._onRenderDescription:ne,he=this.state,Me=he.isFocused,Le=he.isRevealingPassword,pe=this._errorMessage,te=typeof d=="boolean"?d:!!pe,Se=!!x&&L==="password"&&_rt(),ce=this._classNames=yrt(D,{theme:w,className:o,disabled:l,focused:Me,required:y,multiline:f,hasLabel:!!g,hasErrorMessage:te,borderless:r,resizable:E,hasIcon:!!h,underlined:T,inputClassName:p,autoAdjustHeight:F,hasRevealButton:Se});return $.createElement("div",{ref:this.props.elementRef,className:ce.root},$.createElement("div",{className:ce.wrapper},re(this.props,this._onRenderLabel),$.createElement("div",{className:ce.fieldGroup},(C!==void 0||this.props.onRenderPrefix)&&$.createElement("div",{className:ce.prefix,id:this._prefixId},H(this.props,this._onRenderPrefix)),f?this._renderTextArea():this._renderInput(),h&&$.createElement(Fr,Rt({className:ce.icon},h)),Se&&$.createElement("button",{"aria-label":B,className:ce.revealButton,onClick:this._onRevealButtonClick,"aria-pressed":!!Le,type:"button"},$.createElement("span",{className:ce.revealSpan},$.createElement(Fr,{className:ce.revealIcon,iconName:Le?Trt:brt}))),(I!==void 0||this.props.onRenderSuffix)&&$.createElement("div",{className:ce.suffix,id:this._suffixId},J(this.props,this._onRenderSuffix)))),this._isDescriptionAvailable&&$.createElement("span",{id:this._descriptionId},le(this.props,this._onRenderDescription),pe&&$.createElement("div",{role:"alert"},$.createElement(Yae,null,this._renderErrorMessage()))))},e.prototype.focus=function(){this._textElement.current&&this._textElement.current.focus()},e.prototype.blur=function(){this._textElement.current&&this._textElement.current.blur()},e.prototype.select=function(){this._textElement.current&&this._textElement.current.select()},e.prototype.setSelectionStart=function(i){this._textElement.current&&(this._textElement.current.selectionStart=i)},e.prototype.setSelectionEnd=function(i){this._textElement.current&&(this._textElement.current.selectionEnd=i)},Object.defineProperty(e.prototype,"selectionStart",{get:function(){return this._textElement.current?this._textElement.current.selectionStart:-1},enumerable:!1,configurable:!0}),Object.defineProperty(e.prototype,"selectionEnd",{get:function(){return this._textElement.current?this._textElement.current.selectionEnd:-1},enumerable:!1,configurable:!0}),e.prototype.setSelectionRange=function(i,r){this._textElement.current&&this._textElement.current.setSelectionRange(i,r)},e.prototype._warnControlledUsage=function(i){tEe({componentId:this._id,componentName:AL,props:this.props,oldProps:i,valueProp:"value",defaultValueProp:"defaultValue",onChangeProp:"onChange",readOnlyProp:"readOnly"}),this.props.value===null&&!this._hasWarnedNullValue&&(this._hasWarnedNullValue=!0,SC("Warning: 'value' prop on '".concat(AL,"' should not be null. Consider using an ")+"empty string to clear the component or undefined to indicate an uncontrolled component."))},Object.defineProperty(e.prototype,"_id",{get:function(){return this.props.id||this._fallbackId},enumerable:!1,configurable:!0}),Object.defineProperty(e.prototype,"_isControlled",{get:function(){return nre(this.props,"value")},enumerable:!1,configurable:!0}),e.prototype._onRenderPrefix=function(i){var r=i.prefix;return $.createElement("span",{style:{paddingBottom:"1px"}},r)},e.prototype._onRenderSuffix=function(i){var r=i.suffix;return $.createElement("span",{style:{paddingBottom:"1px"}},r)},Object.defineProperty(e.prototype,"_errorMessage",{get:function(){var i=this.props.errorMessage,r=i===void 0?this.state.errorMessage:i;return r||""},enumerable:!1,configurable:!0}),e.prototype._renderErrorMessage=function(){var i=this._errorMessage;return i?typeof i=="string"?$.createElement("p",{className:this._classNames.errorMessage},$.createElement("span",{"data-automation-id":"error-message"},i)):$.createElement("div",{className:this._classNames.errorMessage,"data-automation-id":"error-message"},i):null},Object.defineProperty(e.prototype,"_isDescriptionAvailable",{get:function(){var i=this.props;return!!(i.onRenderDescription||i.description||this._errorMessage)},enumerable:!1,configurable:!0}),e.prototype._renderTextArea=function(){var i=this.props.invalid,r=i===void 0?!!this._errorMessage:i,o=Wl(this.props,U_e,["defaultValue"]),l=this.props["aria-labelledby"]||(this.props.label?this._labelId:void 0);return $.createElement("textarea",Rt({id:this._id},o,{ref:this._textElement,value:this.value||"",onInput:this._onInputChange,onChange:this._onInputChange,className:this._classNames.field,"aria-labelledby":l,"aria-describedby":this._isDescriptionAvailable?this._descriptionId:this.props["aria-describedby"],"aria-invalid":r,"aria-label":this.props.ariaLabel,readOnly:this.props.readOnly,onFocus:this._onFocus,onBlur:this._onBlur}))},e.prototype._renderInput=function(){var i=this.props,r=i.ariaLabel,o=i.invalid,l=o===void 0?!!this._errorMessage:o,d=i.onRenderPrefix,h=i.onRenderSuffix,p=i.prefix,g=i.suffix,f=i.type,y=f===void 0?"text":f,T=i.label,C=[];T&&C.push(this._labelId),(p!==void 0||d)&&C.push(this._prefixId),(g!==void 0||h)&&C.push(this._suffixId);var E=Rt(Rt({type:this.state.isRevealingPassword?"text":y,id:this._id},Wl(this.props,sre,["defaultValue","type"])),{"aria-labelledby":this.props["aria-labelledby"]||(C.length>0?C.join(" "):void 0),ref:this._textElement,value:this.value||"",onInput:this._onInputChange,onChange:this._onInputChange,className:this._classNames.field,"aria-label":r,"aria-describedby":this._isDescriptionAvailable?this._descriptionId:this.props["aria-describedby"],"aria-invalid":l,onFocus:this._onFocus,onBlur:this._onBlur}),I=function(D){return $.createElement("input",Rt({},D))},w=this.props.onRenderInput||I;return w(E,I)},e.prototype._validate=function(i){var r=this;if(!(this._latestValidateValue===i&&P0e(this.props))){this._latestValidateValue=i;var o=this.props.onGetErrorMessage,l=o&&o(i||"");if(l!==void 0)if(typeof l=="string"||!("then"in l))this.setState({errorMessage:l}),this._notifyAfterValidate(i,l);else{var d=++this._lastValidation;l.then(function(h){d===r._lastValidation&&r.setState({errorMessage:h}),r._notifyAfterValidate(i,h)})}else this._notifyAfterValidate(i,"")}},e.prototype._notifyAfterValidate=function(i,r){i===this.value&&this.props.onNotifyValidationResult&&this.props.onNotifyValidationResult(r,i)},e.prototype._adjustInputHeight=function(){var i,r;if(this._textElement.current&&this.props.autoAdjustHeight&&this.props.multiline){var o=(r=(i=this.props.scrollContainerRef)===null||i===void 0?void 0:i.current)===null||r===void 0?void 0:r.scrollTop,l=this._textElement.current;l.style.height="",l.style.height=l.scrollHeight+"px",o&&(this.props.scrollContainerRef.current.scrollTop=o)}},e.defaultProps={resizable:!0,deferredValidationTime:200,validateOnLoad:!0},e}($.Component);function xre(t,e){var i=t.value,r=i===void 0?e.uncontrolledValue:i;return typeof r=="number"?String(r):r}function P0e(t){return!(t.validateOnFocusIn||t.validateOnFocusOut)}var mW;function _rt(){if(typeof mW!="boolean"){var t=Wc();if(t?.navigator){var e=/Edg/.test(t.navigator.userAgent||"");mW=!(Aet()||e)}else mW=!0}return mW}var Ert={root:"ms-TextField",description:"ms-TextField-description",errorMessage:"ms-TextField-errorMessage",field:"ms-TextField-field",fieldGroup:"ms-TextField-fieldGroup",prefix:"ms-TextField-prefix",suffix:"ms-TextField-suffix",wrapper:"ms-TextField-wrapper",revealButton:"ms-TextField-reveal",multiline:"ms-TextField--multiline",borderless:"ms-TextField--borderless",underlined:"ms-TextField--underlined",unresizable:"ms-TextField--unresizable",required:"is-required",disabled:"is-disabled",active:"is-active"};function Art(t){var e=t.underlined,i=t.disabled,r=t.focused,o=t.theme,l=o.palette,d=o.fonts;return function(){var h;return{root:[e&&i&&{color:l.neutralTertiary},e&&{fontSize:d.medium.fontSize,marginRight:8,paddingLeft:12,paddingRight:0,lineHeight:"22px",height:32},e&&r&&{selectors:(h={},h[Rn]={height:31},h)}]}}}function Irt(t){var e,i,r,o,l,d,h,p,g,f,y,T,C=t.theme,E=t.className,I=t.disabled,w=t.focused,D=t.required,F=t.multiline,x=t.hasLabel,B=t.borderless,L=t.underlined,z=t.hasIcon,H=t.resizable,j=t.hasErrorMessage,J=t.inputClassName,Z=t.autoAdjustHeight,re=t.hasRevealButton,ne=C.semanticColors,le=C.effects,he=C.fonts,Me=eh(Ert,C),Le={background:ne.disabledBackground,color:I?ne.disabledText:ne.inputPlaceholderText,display:"flex",alignItems:"center",padding:"0 10px",lineHeight:1,whiteSpace:"nowrap",flexShrink:0,selectors:(e={},e[Rn]={background:"Window",color:I?"GrayText":"WindowText"},e)},pe=[{color:ne.inputPlaceholderText,opacity:1,selectors:(i={},i[Rn]={color:"GrayText"},i)}],te={color:ne.disabledText,selectors:(r={},r[Rn]={color:"GrayText"},r)};return{root:[Me.root,he.medium,D&&Me.required,I&&Me.disabled,w&&Me.active,F&&Me.multiline,B&&Me.borderless,L&&Me.underlined,sx,{position:"relative"},E],wrapper:[Me.wrapper,L&&[{display:"flex",borderBottom:"1px solid ".concat(j?ne.errorText:ne.inputBorder),width:"100%"},I&&{borderBottomColor:ne.disabledBackground,selectors:(o={},o[Rn]=Rt({borderColor:"GrayText"},uc()),o)},!I&&{selectors:{":hover":{borderBottomColor:j?ne.errorText:ne.inputBorderHovered,selectors:(l={},l[Rn]=Rt({borderBottomColor:"Highlight"},uc()),l)}}},w&&[{position:"relative"},dEe(j?ne.errorText:ne.inputFocusBorderAlt,0,"borderBottom")]]],fieldGroup:[Me.fieldGroup,sx,{border:"1px solid ".concat(ne.inputBorder),borderRadius:le.roundedCorner2,background:ne.inputBackground,cursor:"text",height:32,display:"flex",flexDirection:"row",alignItems:"stretch",position:"relative"},F&&{minHeight:"60px",height:"auto",display:"flex"},!w&&!I&&{selectors:{":hover":{borderColor:ne.inputBorderHovered,selectors:(d={},d[Rn]=Rt({borderColor:"Highlight"},uc()),d)}}},w&&!L&&dEe(j?ne.errorText:ne.inputFocusBorderAlt,le.roundedCorner2),I&&{borderColor:ne.disabledBackground,selectors:(h={},h[Rn]=Rt({borderColor:"GrayText"},uc()),h),cursor:"default"},B&&{border:"none"},B&&w&&{border:"none",selectors:{":after":{border:"none"}}},L&&{flex:"1 1 0px",border:"none",textAlign:"left"},L&&I&&{backgroundColor:"transparent"},j&&!L&&{borderColor:ne.errorText,selectors:{"&:hover":{borderColor:ne.errorText}}},!x&&D&&{selectors:(p={":before":{content:"'*'",color:ne.errorText,position:"absolute",top:-5,right:-10}},p[Rn]={selectors:{":before":{color:"WindowText",right:-14}}},p)}],field:[he.medium,Me.field,sx,{borderRadius:0,border:"none",background:"none",backgroundColor:"transparent",color:ne.inputText,padding:"0 8px",width:"100%",minWidth:0,textOverflow:"ellipsis",outline:0,selectors:(g={"&:active, &:focus, &:hover":{outline:0},"::-ms-clear":{display:"none"}},g[Rn]={background:"Window",color:I?"GrayText":"WindowText"},g)},mEe(pe),F&&!H&&[Me.unresizable,{resize:"none"}],F&&{minHeight:"inherit",lineHeight:17,flexGrow:1,paddingTop:6,paddingBottom:6,overflow:"auto",width:"100%"},F&&Z&&{overflow:"hidden"},z&&!re&&{paddingRight:24},F&&z&&{paddingRight:40},I&&[{backgroundColor:ne.disabledBackground,color:ne.disabledText,borderColor:ne.disabledBackground},mEe(te)],L&&{textAlign:"left"},w&&!B&&{selectors:(f={},f[Rn]={paddingLeft:11,paddingRight:11},f)},w&&F&&!B&&{selectors:(y={},y[Rn]={paddingTop:4},y)},J],icon:[F&&{paddingRight:24,alignItems:"flex-end"},{pointerEvents:"none",position:"absolute",bottom:6,right:8,top:"auto",fontSize:CC.medium,lineHeight:18},I&&{color:ne.disabledText}],description:[Me.description,{color:ne.bodySubtext,fontSize:he.xSmall.fontSize}],errorMessage:[Me.errorMessage,EC.slideDownIn20,he.small,{color:ne.errorText,margin:0,paddingTop:5,display:"flex",alignItems:"center"}],prefix:[Me.prefix,Le],suffix:[Me.suffix,Le],revealButton:[Me.revealButton,"ms-Button","ms-Button--icon",vE(C,{inset:1}),{height:30,width:32,border:"none",padding:"0px 4px",backgroundColor:"transparent",color:ne.link,selectors:{":hover":{outline:0,color:ne.primaryButtonBackgroundHovered,backgroundColor:ne.buttonBackgroundHovered,selectors:(T={},T[Rn]={borderColor:"Highlight",color:"Highlight"},T)},":focus":{outline:0}}},z&&{marginRight:28}],revealSpan:{display:"flex",height:"100%",alignItems:"center"},revealIcon:{margin:"0px 4px",pointerEvents:"none",bottom:6,right:8,top:"auto",fontSize:CC.medium,lineHeight:18},subComponentStyles:{label:Art(t)}}}var Bre=vu(Crt,Irt,void 0,{scope:"TextField"});function D0e(t,e){for(var i=[],r=0,o=e;r<o.length;r++){var l=o[r],d=t[l];d&&i.push(d)}return i}var Uw;(function(t){t[t.Normal=0]="Normal",t[t.Divider=1]="Divider",t[t.Header=2]="Header",t[t.SelectAll=3]="SelectAll"})(Uw||(Uw={}));var bE;(function(t){t[t.xSmall=0]="xSmall",t[t.small=1]="small",t[t.medium=2]="medium",t[t.large=3]="large"})(bE||(bE={}));var Fre;(function(t){t[t.normal=0]="normal",t[t.large=1]="large"})(Fre||(Fre={}));var wrt=fu(),krt=function(t){mu(e,t);function e(){return t!==null&&t.apply(this,arguments)||this}return e.prototype.render=function(){var i=this.props,r=i.type,o=i.size,l=i.ariaLabel,d=i.ariaLive,h=i.styles,p=i.label,g=i.theme,f=i.className,y=i.labelPosition,T=l,C=Wl(this.props,Nf,["size"]),E=o;E===void 0&&r!==void 0&&(E=r===Fre.large?bE.large:bE.medium);var I=wrt(h,{theme:g,size:E,className:f,labelPosition:y});return $.createElement("div",Rt({},C,{className:I.root}),$.createElement("div",{className:I.circle}),p&&$.createElement("div",{className:I.label},p),T&&$.createElement("div",{role:"status","aria-live":d},$.createElement(Yae,null,$.createElement("div",{className:I.screenReaderText},T))))},e.defaultProps={size:bE.medium,ariaLive:"polite",labelPosition:"bottom"},e}($.Component),Rrt={root:"ms-Spinner",circle:"ms-Spinner-circle",label:"ms-Spinner-label"},Mrt=ql(function(){return Pm({"0%":{transform:"rotate(0deg)"},"100%":{transform:"rotate(360deg)"}})}),Prt=function(t){var e,i=t.theme,r=t.size,o=t.className,l=t.labelPosition,d=i.palette,h=eh(Rrt,i);return{root:[h.root,{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"},l==="top"&&{flexDirection:"column-reverse"},l==="right"&&{flexDirection:"row"},l==="left"&&{flexDirection:"row-reverse"},o],circle:[h.circle,{boxSizing:"border-box",borderRadius:"50%",borderWidth:"1.5px",borderStyle:"solid",borderTopColor:d.themePrimary,borderRightColor:d.themeLight,borderBottomColor:d.themeLight,borderLeftColor:d.themeLight,animationName:Mrt(),animationDuration:"1.3s",animationIterationCount:"infinite",animationTimingFunction:"cubic-bezier(.53,.21,.29,.67)",selectors:(e={},e[Rn]=Rt({borderTopColor:"Highlight"},uc()),e)},r===bE.xSmall&&["ms-Spinner--xSmall",{width:12,height:12}],r===bE.small&&["ms-Spinner--small",{width:16,height:16}],r===bE.medium&&["ms-Spinner--medium",{width:20,height:20}],r===bE.large&&["ms-Spinner--large",{width:28,height:28}]],label:[h.label,i.fonts.small,{color:d.themePrimary,margin:"8px 0 0",textAlign:"center"},l==="top"&&{margin:"0 0 8px"},l==="right"&&{margin:"0 0 0 8px"},l==="left"&&{margin:"0 8px 0 0"}],screenReaderText:W$}},gx=vu(krt,Prt,void 0,{scope:"Spinner"}),L0e=SL.durationValue2,Drt={root:"ms-Modal",main:"ms-Dialog-main",scrollableContent:"ms-Modal-scrollableContent",isOpen:"is-open",layer:"ms-Modal-Layer"},Lrt=function(t){var e,i=t.className,r=t.containerClassName,o=t.scrollableContentClassName,l=t.isOpen,d=t.isVisible,h=t.hasBeenOpened,p=t.modalRectangleTop,g=t.theme,f=t.topOffsetFixed,y=t.isModeless,T=t.layerClassName,C=t.isDefaultDragHandle,E=t.windowInnerHeight,I=g.palette,w=g.effects,D=g.fonts,F=eh(Drt,g);return{root:[F.root,D.medium,{backgroundColor:"transparent",position:"fixed",height:"100%",width:"100%",display:"flex",alignItems:"center",justifyContent:"center",opacity:0,pointerEvents:"none",transition:"opacity ".concat(L0e)},f&&typeof p=="number"&&h&&{alignItems:"flex-start"},l&&F.isOpen,d&&{opacity:1},d&&!y&&{pointerEvents:"auto"},i],main:[F.main,{boxShadow:w.elevation64,borderRadius:w.roundedCorner2,backgroundColor:I.white,boxSizing:"border-box",position:"relative",textAlign:"left",outline:"3px solid transparent",maxHeight:"calc(100% - 32px)",maxWidth:"calc(100% - 32px)",minHeight:"176px",minWidth:"288px",overflowY:"auto",zIndex:y?ox.Layer:void 0},y&&{pointerEvents:"auto"},f&&typeof p=="number"&&h&&{top:p},C&&{cursor:"move"},r],scrollableContent:[F.scrollableContent,{overflowY:"auto",flexGrow:1,maxHeight:"100vh",selectors:(e={},e["@supports (-webkit-overflow-scrolling: touch)"]={maxHeight:E},e)},o],layer:y&&[T,F.layer,{pointerEvents:"none"}],keyboardMoveIconContainer:{position:"absolute",display:"flex",justifyContent:"center",width:"100%",padding:"3px 0px"},keyboardMoveIcon:{fontSize:D.xLargePlus.fontSize,width:"24px"}}},Ort=fu(),Nrt=function(t){mu(e,t);function e(i){var r=t.call(this,i)||this;Dw(r);var o=r.props.allowTouchBodyScroll,l=o===void 0?!1:o;return r._allowTouchBodyScroll=l,r}return e.prototype.componentDidMount=function(){!this._allowTouchBodyScroll&&qZe()},e.prototype.componentWillUnmount=function(){!this._allowTouchBodyScroll&&WZe()},e.prototype.render=function(){var i=this.props,r=i.isDarkThemed,o=i.className,l=i.theme,d=i.styles,h=Wl(this.props,Nf),p=Ort(d,{theme:l,className:o,isDark:r});return $.createElement("div",Rt({},h,{className:p.root}))},e}($.Component),xrt={root:"ms-Overlay",rootDark:"ms-Overlay--dark"},Brt=function(t){var e,i=t.className,r=t.theme,o=t.isNone,l=t.isDark,d=r.palette,h=eh(xrt,r);return{root:[h.root,r.fonts.medium,{backgroundColor:d.whiteTranslucent40,top:0,right:0,bottom:0,left:0,position:"absolute",selectors:(e={},e[Rn]={border:"1px solid WindowText",opacity:0},e)},o&&{visibility:"hidden"},l&&[h.rootDark,{backgroundColor:d.blackTranslucent40}],i]}},Ure=vu(Nrt,Brt,void 0,{scope:"Overlay"}),Frt=ql(function(t,e){return{root:It(t,e&&{touchAction:"none",selectors:{"& *":{userSelect:"none"}}})}}),cH={touch:{start:"touchstart",move:"touchmove",stop:"touchend"},mouse:{start:"mousedown",move:"mousemove",stop:"mouseup"}},Urt=function(t){mu(e,t);function e(i){var r=t.call(this,i)||this;return r._currentEventType=cH.mouse,r._events=[],r._onMouseDown=function(o){var l=$.Children.only(r.props.children).props.onMouseDown;return l&&l(o),r._currentEventType=cH.mouse,r._onDragStart(o)},r._onMouseUp=function(o){var l=$.Children.only(r.props.children).props.onMouseUp;return l&&l(o),r._currentEventType=cH.mouse,r._onDragStop(o)},r._onTouchStart=function(o){var l=$.Children.only(r.props.children).props.onTouchStart;return l&&l(o),r._currentEventType=cH.touch,r._onDragStart(o)},r._onTouchEnd=function(o){var l=$.Children.only(r.props.children).props.onTouchEnd;l&&l(o),r._currentEventType=cH.touch,r._onDragStop(o)},r._onDragStart=function(o){if(typeof o.button=="number"&&o.button!==0)return!1;if(!(r.props.handleSelector&&!r._matchesSelector(o.target,r.props.handleSelector)||r.props.preventDragSelector&&r._matchesSelector(o.target,r.props.preventDragSelector))){r._touchId=r._getTouchId(o);var l=r._getControlPosition(o);if(l!==void 0){var d=r._createDragDataFromPosition(l);r.props.onStart&&r.props.onStart(o,d),r.setState({isDragging:!0,lastPosition:l});var h=CL(r.context);r._events=[hE(h.body,r._currentEventType.move,r._onDrag,!0),hE(h.body,r._currentEventType.stop,r._onDragStop,!0)]}}},r._onDrag=function(o){o.type==="touchmove"&&o.preventDefault();var l=r._getControlPosition(o);if(l){var d=r._createUpdatedDragData(r._createDragDataFromPosition(l)),h=d.position;r.props.onDragChange&&r.props.onDragChange(o,d),r.setState({position:h,lastPosition:l})}},r._onDragStop=function(o){if(r.state.isDragging){var l=r._getControlPosition(o);if(l){var d=r._createDragDataFromPosition(l);r.setState({isDragging:!1,lastPosition:void 0}),r.props.onStop&&r.props.onStop(o,d),r.props.position&&r.setState({position:r.props.position}),r._events.forEach(function(h){return h()})}}},r.state={isDragging:!1,position:r.props.position||{x:0,y:0},lastPosition:void 0},r}return e.prototype.componentDidUpdate=function(i){this.props.position&&(!i.position||this.props.position!==i.position)&&this.setState({position:this.props.position})},e.prototype.componentWillUnmount=function(){this._events.forEach(function(i){return i()})},e.prototype.render=function(){var i=$.Children.only(this.props.children),r=i.props,o=this.props.position,l=this.state,d=l.position,h=l.isDragging,p=d.x,g=d.y;return o&&!h&&(p=o.x,g=o.y),$.cloneElement(i,{style:Rt(Rt({},r.style),{transform:"translate(".concat(p,"px, ").concat(g,"px)")}),className:Frt(r.className,this.state.isDragging).root,onMouseDown:this._onMouseDown,onMouseUp:this._onMouseUp,onTouchStart:this._onTouchStart,onTouchEnd:this._onTouchEnd})},e.prototype._getControlPosition=function(i){var r=this._getActiveTouch(i);if(!(this._touchId!==void 0&&!r)){var o=r||i;return{x:o.clientX,y:o.clientY}}},e.prototype._getActiveTouch=function(i){return i.targetTouches&&this._findTouchInTouchList(i.targetTouches)||i.changedTouches&&this._findTouchInTouchList(i.changedTouches)},e.prototype._getTouchId=function(i){var r=i.targetTouches&&i.targetTouches[0]||i.changedTouches&&i.changedTouches[0];if(r)return r.identifier},e.prototype._matchesSelector=function(i,r){var o;if(!i||i===((o=CL(this.context))===null||o===void 0?void 0:o.body))return!1;var l=i.matches||i.webkitMatchesSelector||i.msMatchesSelector;return l?l.call(i,r)||this._matchesSelector(i.parentElement,r):!1},e.prototype._findTouchInTouchList=function(i){if(this._touchId!==void 0){for(var r=0;r<i.length;r++)if(i[r].identifier===this._touchId)return i[r]}},e.prototype._createDragDataFromPosition=function(i){var r=this.state.lastPosition;return r===void 0?{delta:{x:0,y:0},lastPosition:i,position:i}:{delta:{x:i.x-r.x,y:i.y-r.y},lastPosition:r,position:i}},e.prototype._createUpdatedDragData=function(i){var r=this.state.position;return{position:{x:r.x+i.delta.x,y:r.y+i.delta.y},delta:i.delta,lastPosition:r}},e.contextType=ZN,e}($.Component),r5={x:0,y:0},zrt={isOpen:!1,isDarkOverlay:!0,className:"",containerClassName:"",enableAriaHiddenSiblings:!0},Vrt=fu(),$rt=function(t){var e=10;return t.shiftKey?t.ctrlKey||(e=50):t.ctrlKey&&(e=1),e},Hrt=function(t,e){$.useImperativeHandle(t.componentRef,function(){return{focus:function(){e.current&&e.current.focus()}}},[e])},O0e=$.forwardRef(function(t,e){var i,r,o,l,d,h=Lw(zrt,t),p=h.allowTouchBodyScroll,g=h.className,f=h.children,y=h.containerClassName,T=h.scrollableContentClassName,C=h.elementToFocusOnDismiss,E=h.firstFocusableSelector,I=h.focusTrapZoneProps,w=h.forceFocusInsideTrap,D=h.disableRestoreFocus,F=D===void 0?h.ignoreExternalFocusing:D,x=h.isBlocking,B=h.isAlert,L=h.isClickableOutsideFocusTrap,z=h.isDarkOverlay,H=h.onDismiss,j=h.layerProps,J=h.overlay,Z=h.isOpen,re=h.titleAriaId,ne=h.styles,le=h.subtitleAriaId,he=h.theme,Me=h.topOffsetFixed,Le=h.responsiveMode,pe=h.onLayerDidMount,te=h.isModeless,Se=h.dragOptions,ce=h.onDismissed,X=h.enableAriaHiddenSiblings,ve=h.popupProps,Te=$.useRef(null),Be=$.useRef(null),qe=Ff(Be,I?.componentRef),Ge=$.useRef(null),tt=Ff(Te,e),ct=hW(tt),Mt=yu("ModalFocusTrapZone",I?.id),ht=VU(),vt=AEe(),Pt=vt.setTimeout,ni=vt.clearTimeout,Zt=$.useState(Z),it=Zt[0],Ke=Zt[1],ot=$.useState(Z),Ht=ot[0],jt=ot[1],Nt=$.useState(r5),Vt=Nt[0],$t=Nt[1],dt=$.useState(),yt=dt[0],kt=dt[1],je=Tre(!1),Ae=je[0],xe=je[1],gt=xe.toggle,Ye=xe.setFalse,Fe=oT(function(){return{onModalCloseTimer:0,allowTouchBodyScroll:p,scrollableContent:null,lastSetCoordinates:r5,events:new pE({})}}),St=(Se||{}).keepInBounds,Wt=B??(x&&!te),Ii=j===void 0?"":j.className,en=Vrt(ne,{theme:he,className:g,containerClassName:y,scrollableContentClassName:T,isOpen:Z,isVisible:Ht,hasBeenOpened:Fe.hasBeenOpened,modalRectangleTop:yt,topOffsetFixed:Me,isModeless:te,layerClassName:Ii,windowInnerHeight:ht?.innerHeight,isDefaultDragHandle:Se&&!Se.dragHandleSelector}),sn=Rt(Rt({eventBubblingEnabled:!1},j),{onLayerDidMount:j&&j.onLayerDidMount?j.onLayerDidMount:pe,insertFirst:j?.insertFirst||te,className:en.layer}),Qi=$.useCallback(function(Rr){Rr?Fe.allowTouchBodyScroll?Kae(Rr,Fe.events):Wae(Rr,Fe.events):Fe.events.off(Fe.scrollableContent),Fe.scrollableContent=Rr},[Fe]),qt=function(){var Rr=Ge.current,La=Rr?.getBoundingClientRect();La&&(Me&&kt(La.top),St&&(Fe.minPosition={x:-La.left,y:-La.top},Fe.maxPosition={x:La.left,y:La.top}))},ri=$.useCallback(function(Rr,La){var us=Fe.minPosition,al=Fe.maxPosition;return St&&us&&al&&(La=Math.max(us[Rr],La),La=Math.min(al[Rr],La)),La},[St,Fe]),Ti=function(){var Rr;Fe.lastSetCoordinates=r5,Ye(),Fe.isInKeyboardMoveMode=!1,Ke(!1),$t(r5),(Rr=Fe.disposeOnKeyUp)===null||Rr===void 0||Rr.call(Fe),ce?.()},rn=$.useCallback(function(){Ye(),Fe.isInKeyboardMoveMode=!1},[Fe,Ye]),Hn=$.useCallback(function(Rr,La){$t(function(us){return{x:ri("x",us.x+La.delta.x),y:ri("y",us.y+La.delta.y)}})},[ri]),ha=$.useCallback(function(){Be.current&&Be.current.focus()},[]),hr=function(){var Rr=function(La){if(La.altKey&&La.ctrlKey&&La.keyCode===fa.space){La.preventDefault(),La.stopPropagation();return}var us=La.altKey||La.keyCode===fa.escape;if(Ae&&us&&Ye(),Fe.isInKeyboardMoveMode&&(La.keyCode===fa.escape||La.keyCode===fa.enter)&&(Fe.isInKeyboardMoveMode=!1,La.preventDefault(),La.stopPropagation()),Fe.isInKeyboardMoveMode){var al=!0,Us=$rt(La);switch(La.keyCode){case fa.escape:$t(Fe.lastSetCoordinates);case fa.enter:{Fe.lastSetCoordinates=r5;break}case fa.up:{$t(function($r){return{x:$r.x,y:ri("y",$r.y-Us)}});break}case fa.down:{$t(function($r){return{x:$r.x,y:ri("y",$r.y+Us)}});break}case fa.left:{$t(function($r){return{x:ri("x",$r.x-Us),y:$r.y}});break}case fa.right:{$t(function($r){return{x:ri("x",$r.x+Us),y:$r.y}});break}default:al=!1}al&&(La.preventDefault(),La.stopPropagation())}};Fe.lastSetCoordinates=Vt,Ye(),Fe.isInKeyboardMoveMode=!0,Fe.events.on(ht,"keydown",Rr,!0),Fe.disposeOnKeyDown=function(){Fe.events.off(ht,"keydown",Rr,!0),Fe.disposeOnKeyDown=void 0}},yn=function(Rr){var La,us;(La=I?.onBlur)===null||La===void 0||La.call(I,Rr),Fe.lastSetCoordinates=r5,Fe.isInKeyboardMoveMode=!1,(us=Fe.disposeOnKeyDown)===null||us===void 0||us.call(Fe)},pr=function(){var Rr=function(La){La.altKey&&La.ctrlKey&&La.keyCode===fa.space&&xy(Fe.scrollableContent,La.target)&&(gt(),La.preventDefault(),La.stopPropagation())};Fe.disposeOnKeyUp||(Fe.events.on(ht,"keyup",Rr,!0),Fe.disposeOnKeyUp=function(){Fe.events.off(ht,"keyup",Rr,!0),Fe.disposeOnKeyUp=void 0})};$.useEffect(function(){ni(Fe.onModalCloseTimer),Z&&(requestAnimationFrame(function(){return Pt(qt,0)}),Ke(!0),Se&&pr(),Fe.hasBeenOpened=!0,jt(!0)),!Z&&it&&(Fe.onModalCloseTimer=Pt(Ti,parseFloat(L0e)*1e3),jt(!1))},[it,Z]),aW(function(){Fe.events.dispose(),Fe.onModalCloseTimer&&(ni(Fe.onModalCloseTimer),Fe.onModalCloseTimer=0)}),Hrt(h,Be),jrt(h);var Ho=$.createElement(Nw,Rt({},I,{id:Mt,ref:Ge,componentRef:qe,className:wh(en.main,I?.className),elementToFocusOnDismiss:(i=I?.elementToFocusOnDismiss)!==null&&i!==void 0?i:C,isClickableOutsideFocusTrap:(r=I?.isClickableOutsideFocusTrap)!==null&&r!==void 0?r:te||L||!x,disableRestoreFocus:(o=I?.disableRestoreFocus)!==null&&o!==void 0?o:F,forceFocusInsideTrap:((l=I?.forceFocusInsideTrap)!==null&&l!==void 0?l:w)&&!te,firstFocusableSelector:I?.firstFocusableSelector||E,focusPreviouslyFocusedInnerElement:(d=I?.focusPreviouslyFocusedInnerElement)!==null&&d!==void 0?d:!0,onBlur:Fe.isInKeyboardMoveMode?yn:void 0}),Se&&Fe.isInKeyboardMoveMode&&$.createElement("div",{className:en.keyboardMoveIconContainer},Se.keyboardMoveIconProps?$.createElement(Fr,Rt({},Se.keyboardMoveIconProps)):$.createElement(Fr,{iconName:"move",className:en.keyboardMoveIcon})),$.createElement("div",{ref:Qi,className:en.scrollableContent,"data-is-scrollable":!0},Se&&Ae&&$.createElement(Se.menu,{items:[{key:"move",text:Se.moveMenuItemText,onClick:hr},{key:"close",text:Se.closeMenuItemText,onClick:Ti}],onDismiss:Ye,alignTargetEdge:!0,coverTarget:!0,directionalHint:hd.topLeftEdge,directionalHintFixed:!0,shouldFocusOnMount:!0,target:Fe.scrollableContent}),f));return it&&ct>=(Le||EL.small)&&$.createElement(QU,Rt({ref:tt},sn),$.createElement(eH,Rt({role:Wt?"alertdialog":"dialog",ariaLabelledBy:re,ariaDescribedBy:le,onDismiss:H,shouldRestoreFocus:!F,enableAriaHiddenSiblings:X,"aria-modal":!te},ve),$.createElement("div",{className:en.root,role:te?void 0:"document"},!te&&$.createElement(Ure,Rt({"aria-hidden":!0,isDarkThemed:z,onClick:x?void 0:H,allowTouchBodyScroll:p},J)),Se?$.createElement(Urt,{handleSelector:Se.dragHandleSelector||"#".concat(Mt),preventDragSelector:"button",onStart:rn,onDragChange:Hn,onStop:ha,position:Vt},Ho):Ho)))||null});O0e.displayName="Modal";function jrt(t){process.env.NODE_ENV!=="production"&&CM({name:"Modal",props:t,deprecations:{onLayerDidMount:"layerProps.onLayerDidMount"}})}var o5=vu(O0e,Lrt,void 0,{scope:"Modal",fields:["theme","styles","enableAriaHiddenSiblings"]});o5.displayName="Modal";var Grt=function(){function t(){this._size=0}return t.prototype.updateOptions=function(e){for(var i=[],r=[],o=0,l=0;l<e.length;l++){var d=e[l],h=d.itemType,p=d.hidden;h===Uw.Divider||h===Uw.Header?(i.push(l),r.push(l)):p?r.push(l):o++}this._size=o,this._displayOnlyOptionsCache=i,this._notSelectableOptionsCache=r,this._cachedOptions=Gd([],e,!0)},Object.defineProperty(t.prototype,"optionSetSize",{get:function(){return this._size},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"cachedOptions",{get:function(){return this._cachedOptions},enumerable:!1,configurable:!0}),t.prototype.positionInSet=function(e){if(e!==void 0){for(var i=0;e>this._notSelectableOptionsCache[i];)i++;if(this._displayOnlyOptionsCache[i]===e)throw new Error("Unexpected: Option at index ".concat(e," is not a selectable element."));if(this._notSelectableOptionsCache[i]!==e)return e-i+1}},t}(),Om;(function(t){t[t.smallFluid=0]="smallFluid",t[t.smallFixedFar=1]="smallFixedFar",t[t.smallFixedNear=2]="smallFixedNear",t[t.medium=3]="medium",t[t.large=4]="large",t[t.largeFixed=5]="largeFixed",t[t.extraLarge=6]="extraLarge",t[t.custom=7]="custom",t[t.customNear=8]="customNear"})(Om||(Om={}));var qrt=fu(),Wrt="Panel",$h;(function(t){t[t.closed=0]="closed",t[t.animatingOpen=1]="animatingOpen",t[t.open=2]="open",t[t.animatingClosed=3]="animatingClosed"})($h||($h={}));var Krt=function(t){mu(e,t);function e(i){var r=t.call(this,i)||this;r._panel=$.createRef(),r._animationCallback=null,r._hasCustomNavigation=!!(r.props.onRenderNavigation||r.props.onRenderNavigationContent),r.dismiss=function(d){r.props.onDismiss&&r.isActive&&r.props.onDismiss(d),(!d||d&&!d.defaultPrevented)&&r.close()},r._allowScrollOnPanel=function(d){var h;r._resizeObserver=r._createResizeObserver(function(p){p.length>0&&p[0].target===d&&r._updateFooterPosition()}),d?((h=r._resizeObserver)===null||h===void 0||h.observe(d),r._allowTouchBodyScroll?Kae(d,r._events):Wae(d,r._events)):r._events.off(r._scrollableContent),r._scrollableContent=d},r._onRenderNavigation=function(d){if(!r.props.onRenderNavigationContent&&!r.props.onRenderNavigation&&!r.props.hasCloseButton)return null;var h=r.props.onRenderNavigationContent,p=h===void 0?r._onRenderNavigationContent:h;return $.createElement("div",{className:r._classNames.navigation},p(d,r._onRenderNavigationContent))},r._onRenderNavigationContent=function(d){var h,p=d.closeButtonAriaLabel,g=d.hasCloseButton,f=d.onRenderHeader,y=f===void 0?r._onRenderHeader:f;if(g){var T=(h=r._classNames.subComponentStyles)===null||h===void 0?void 0:h.closeButton();return $.createElement($.Fragment,null,!r._hasCustomNavigation&&y(r.props,r._onRenderHeader,r._headerTextId),$.createElement(zy,{styles:T,className:r._classNames.closeButton,onClick:r._onPanelClick,ariaLabel:p,title:p,"data-is-visible":!0,iconProps:{iconName:"Cancel"}}))}return null},r._onRenderHeader=function(d,h,p){var g=d.headerText,f=d.headerTextProps,y=f===void 0?{}:f;return g?$.createElement("div",{className:r._classNames.header},$.createElement("div",Rt({id:p,role:"heading","aria-level":1},y,{className:wh(r._classNames.headerText,y.className)}),g)):null},r._onRenderBody=function(d){return $.createElement("div",{className:r._classNames.content},d.children)},r._onRenderFooter=function(d){var h=r.props.onRenderFooterContent,p=h===void 0?null:h;return p?$.createElement("div",{className:r._classNames.footer},$.createElement("div",{className:r._classNames.footerInner},p())):null},r._animateTo=function(d){d===$h.open&&r.props.onOpen&&r.props.onOpen(),r._animationCallback=r._async.setTimeout(function(){r.setState({visibility:d}),r._onTransitionComplete(d)},200)},r._clearExistingAnimationTimer=function(){r._animationCallback!==null&&r._async.clearTimeout(r._animationCallback)},r._onPanelClick=function(d){r.dismiss(d)},r._onTransitionComplete=function(d){r._updateFooterPosition(),d===$h.open&&r.props.onOpened&&r.props.onOpened(),d===$h.closed&&r.props.onDismissed&&r.props.onDismissed()};var o=r.props.allowTouchBodyScroll,l=o===void 0?!1:o;return r._allowTouchBodyScroll=l,Dw(r),fL(Wrt,i,{ignoreExternalFocusing:"focusTrapZoneProps",forceFocusInsideTrap:"focusTrapZoneProps",firstFocusableSelector:"focusTrapZoneProps"}),r.state={isFooterSticky:!1,visibility:$h.closed,id:bp("Panel")},r}return e.getDerivedStateFromProps=function(i,r){return i.isOpen===void 0?null:i.isOpen&&(r.visibility===$h.closed||r.visibility===$h.animatingClosed)?{visibility:$h.animatingOpen}:!i.isOpen&&(r.visibility===$h.open||r.visibility===$h.animatingOpen)?{visibility:$h.animatingClosed}:null},e.prototype.componentDidMount=function(){this._async=new YN(this),this._events=new pE(this);var i=kEe(this.context),r=CL(this.context);this._events.on(i,"resize",this._updateFooterPosition),this._shouldListenForOuterClick(this.props)&&this._events.on(r?.body,"mousedown",this._dismissOnOuterClick,!0),this.props.isOpen&&this.setState({visibility:$h.animatingOpen})},e.prototype.componentDidUpdate=function(i,r){var o=this._shouldListenForOuterClick(this.props),l=this._shouldListenForOuterClick(i);this.state.visibility!==r.visibility&&(this._clearExistingAnimationTimer(),this.state.visibility===$h.animatingOpen?this._animateTo($h.open):this.state.visibility===$h.animatingClosed&&this._animateTo($h.closed));var d=CL(this.context);o&&!l?this._events.on(d?.body,"mousedown",this._dismissOnOuterClick,!0):!o&&l&&this._events.off(d?.body,"mousedown",this._dismissOnOuterClick,!0)},e.prototype.componentWillUnmount=function(){var i;this._async.dispose(),this._events.dispose(),(i=this._resizeObserver)===null||i===void 0||i.disconnect()},e.prototype.render=function(){var i=this.props,r=i.className,o=r===void 0?"":r,l=i.elementToFocusOnDismiss,d=i.firstFocusableSelector,h=i.focusTrapZoneProps,p=i.forceFocusInsideTrap,g=i.hasCloseButton,f=i.headerText,y=i.headerClassName,T=y===void 0?"":y,C=i.ignoreExternalFocusing,E=i.isBlocking,I=i.isFooterAtBottom,w=i.isLightDismiss,D=i.isHiddenOnDismiss,F=i.layerProps,x=i.overlayProps,B=i.popupProps,L=i.type,z=i.styles,H=i.theme,j=i.customWidth,J=i.onLightDismissClick,Z=J===void 0?this._onPanelClick:J,re=i.onRenderNavigation,ne=re===void 0?this._onRenderNavigation:re,le=i.onRenderHeader,he=le===void 0?this._onRenderHeader:le,Me=i.onRenderBody,Le=Me===void 0?this._onRenderBody:Me,pe=i.onRenderFooter,te=pe===void 0?this._onRenderFooter:pe,Se=this.state,ce=Se.isFooterSticky,X=Se.visibility,ve=Se.id,Te=L===Om.smallFixedNear||L===Om.customNear,Be=Of(H),qe=Be?Te:!Te,Ge=L===Om.custom||L===Om.customNear?{width:j}:{},tt=Wl(this.props,Nf),ct=this.isActive,Mt=X===$h.animatingClosed||X===$h.animatingOpen;if(this._headerTextId=f&&ve+"-headerText",!ct&&!Mt&&!D)return null;this._classNames=qrt(z,{theme:H,className:o,focusTrapZoneClassName:h?h.className:void 0,hasCloseButton:g,headerClassName:T,isAnimating:Mt,isFooterSticky:ce,isFooterAtBottom:I,isOnRightSide:qe,isOpen:ct,isHiddenOnDismiss:D,type:L,hasCustomNavigation:this._hasCustomNavigation});var ht=this,vt=ht._classNames,Pt=ht._allowTouchBodyScroll,ni;return E&&ct&&(ni=$.createElement(Ure,Rt({className:vt.overlay,isDarkThemed:!1,onClick:w?Z:void 0,allowTouchBodyScroll:Pt},x))),$.createElement(QU,Rt({},F),$.createElement(eH,Rt({role:"dialog","aria-modal":E?"true":void 0,ariaLabelledBy:this._headerTextId?this._headerTextId:void 0,onDismiss:this.dismiss,className:vt.hiddenPanel,enableAriaHiddenSiblings:!!ct},B),$.createElement("div",Rt({"aria-hidden":!ct&&Mt},tt,{ref:this._panel,className:vt.root}),ni,$.createElement(Nw,Rt({ignoreExternalFocusing:C,forceFocusInsideTrap:!E||D&&!ct?!1:p,firstFocusableSelector:d,isClickableOutsideFocusTrap:!0},h,{className:vt.main,style:Ge,elementToFocusOnDismiss:l}),$.createElement("div",{className:vt.contentInner},$.createElement("div",{ref:this._allowScrollOnPanel,className:vt.scrollableContent,"data-is-scrollable":!0},$.createElement("div",{className:vt.commands,"data-is-visible":!0},ne(this.props,this._onRenderNavigation)),(this._hasCustomNavigation||!g)&&he(this.props,this._onRenderHeader,this._headerTextId),Le(this.props,this._onRenderBody),te(this.props,this._onRenderFooter)))))))},e.prototype.open=function(){this.props.isOpen===void 0&&(this.isActive||this.setState({visibility:$h.animatingOpen}))},e.prototype.close=function(){this.props.isOpen===void 0&&this.isActive&&this.setState({visibility:$h.animatingClosed})},Object.defineProperty(e.prototype,"isActive",{get:function(){return this.state.visibility===$h.open||this.state.visibility===$h.animatingOpen},enumerable:!1,configurable:!0}),e.prototype._createResizeObserver=function(i){var r,o=CL(this.context),l=null;return!((r=o?.defaultView)===null||r===void 0)&&r.ResizeObserver&&(l=new o.defaultView.ResizeObserver(i)),l},e.prototype._shouldListenForOuterClick=function(i){return!!i.isBlocking&&!!i.isOpen},e.prototype._updateFooterPosition=function(){var i=this._scrollableContent;if(i){var r=i.clientHeight,o=i.scrollHeight;this.setState({isFooterSticky:r<o})}},e.prototype._dismissOnOuterClick=function(i){var r=this._panel.current;this.isActive&&r&&!i.defaultPrevented&&(xy(r,i.target)||(this.props.onOuterClick?this.props.onOuterClick(i):this.dismiss(i)))},e.defaultProps={isHiddenOnDismiss:!1,isOpen:void 0,isBlocking:!0,hasCloseButton:!0,type:Om.smallFixedFar},e.contextType=ZN,e}($.Component),zre,fW,vW,Vre,$re,Jrt={root:"ms-Panel",main:"ms-Panel-main",commands:"ms-Panel-commands",contentInner:"ms-Panel-contentInner",scrollableContent:"ms-Panel-scrollableContent",navigation:"ms-Panel-navigation",closeButton:"ms-Panel-closeButton ms-PanelAction-close",header:"ms-Panel-header",headerText:"ms-Panel-headerText",content:"ms-Panel-content",footer:"ms-Panel-footer",footerInner:"ms-Panel-footerInner",isOpen:"is-open",hasCloseButton:"ms-Panel--hasCloseButton",smallFluid:"ms-Panel--smFluid",smallFixedNear:"ms-Panel--smLeft",smallFixedFar:"ms-Panel--sm",medium:"ms-Panel--md",large:"ms-Panel--lg",largeFixed:"ms-Panel--fixed",extraLarge:"ms-Panel--xl",custom:"ms-Panel--custom",customNear:"ms-Panel--customLeft"},mx={full:"100%",auto:"auto",xs:272,sm:340,md1:592,md2:644,lg:940},IM={auto:"auto",none:0,md:48,lg:428,xl:176},dH=(zre={},zre["@media (min-width: ".concat(jU,"px)")]={width:mx.sm},zre),yW=(fW={},fW["@media (min-width: ".concat(sEe,"px)")]={width:mx.md1},fW["@media (min-width: ".concat(ytt,"px)")]={width:mx.md2},fW),Hre=(vW={},vW["@media (min-width: ".concat(btt,"px)")]={left:IM.md,width:mx.auto},vW["@media (min-width: ".concat(fre,"px)")]={left:IM.lg},vW),Yrt=(Vre={},Vre["@media (min-width: ".concat(fre,"px)")]={left:IM.auto,width:mx.lg},Vre),Qrt=($re={},$re["@media (min-width: ".concat(fre,"px)")]={left:IM.xl},$re),Zrt=function(t){var e;switch(t){case Om.smallFixedFar:e=Rt({},dH);break;case Om.medium:e=Rt(Rt({},dH),yW);break;case Om.large:e=Rt(Rt(Rt({},dH),yW),Hre);break;case Om.largeFixed:e=Rt(Rt(Rt(Rt({},dH),yW),Hre),Yrt);break;case Om.extraLarge:e=Rt(Rt(Rt(Rt({},dH),yW),Hre),Qrt);break}return e},Xrt="44px",jre={paddingLeft:"24px",paddingRight:"24px"},eot=function(t){var e,i,r,o,l=t.className,d=t.focusTrapZoneClassName,h=t.hasCloseButton,p=t.headerClassName,g=t.isAnimating,f=t.isFooterSticky,y=t.isFooterAtBottom,T=t.isOnRightSide,C=t.isOpen,E=t.isHiddenOnDismiss,I=t.hasCustomNavigation,w=t.theme,D=t.type,F=D===void 0?Om.smallFixedFar:D,x=w.effects,B=w.fonts,L=w.semanticColors,z=eh(Jrt,w),H=F===Om.custom||F===Om.customNear;return{root:[z.root,w.fonts.medium,C&&z.isOpen,h&&z.hasCloseButton,{pointerEvents:"none",position:"absolute",top:0,left:0,right:0,bottom:0},H&&T&&z.custom,H&&!T&&z.customNear,l],overlay:[{pointerEvents:"auto",cursor:"pointer"},C&&g&&EC.fadeIn100,!C&&g&&EC.fadeOut100],hiddenPanel:[!C&&!g&&E&&{visibility:"hidden"}],main:[z.main,{backgroundColor:L.bodyBackground,boxShadow:x.elevation64,pointerEvents:"auto",position:"absolute",display:"flex",flexDirection:"column",overflowX:"hidden",overflowY:"auto",WebkitOverflowScrolling:"touch",bottom:0,top:0,left:IM.auto,right:IM.none,width:mx.full,selectors:Rt((e={},e[Rn]={borderLeft:"3px solid ".concat(L.variantBorder),borderRight:"3px solid ".concat(L.variantBorder)},e),Zrt(F))},F===Om.smallFluid&&{left:IM.none},F===Om.smallFixedNear&&{left:IM.none,right:IM.auto,width:mx.xs},F===Om.customNear&&{right:"auto",left:0},H&&{maxWidth:"100vw"},C&&g&&!T&&EC.slideRightIn40,C&&g&&T&&EC.slideLeftIn40,!C&&g&&!T&&EC.slideLeftOut40,!C&&g&&T&&EC.slideRightOut40,d],commands:[z.commands,{backgroundColor:L.bodyBackground,paddingTop:18,selectors:(i={},i["@media (min-height: ".concat(jU,"px)")]={position:"sticky",top:0,zIndex:1},i)},I&&{paddingTop:"inherit"}],navigation:[z.navigation,{display:"flex",justifyContent:"flex-end"},I&&{height:Xrt}],contentInner:[z.contentInner,{display:"flex",flexDirection:"column",flexGrow:1,overflowY:"hidden"}],header:[z.header,jre,{alignSelf:"flex-start"},h&&!I&&{flexGrow:1},I&&{flexShrink:0}],headerText:[z.headerText,B.xLarge,{color:L.bodyText,lineHeight:"27px",overflowWrap:"break-word",wordWrap:"break-word",wordBreak:"break-word",hyphens:"auto"},p],scrollableContent:[z.scrollableContent,{overflowY:"auto"},y&&{flexGrow:1,display:"inherit",flexDirection:"inherit"}],content:[z.content,jre,{paddingBottom:20},y&&{selectors:(r={},r["@media (min-height: ".concat(jU,"px)")]={flexGrow:1},r)}],footer:[z.footer,{flexShrink:0,borderTop:"1px solid transparent",transition:"opacity ".concat(SL.durationValue3," ").concat(SL.easeFunction2),selectors:(o={},o["@media (min-height: ".concat(jU,"px)")]={position:"sticky",bottom:0},o)},f&&{backgroundColor:L.bodyBackground,borderTopColor:L.variantBorder}],footerInner:[z.footerInner,jre,{paddingBottom:16,paddingTop:16}],subComponentStyles:{closeButton:{root:[z.closeButton,{marginRight:14,color:w.palette.neutralSecondary,fontSize:CC.large},I&&{marginRight:0,height:"auto",width:"44px"}],rootHovered:{color:w.palette.neutralPrimary}}}}},N0e=vu(Krt,eot,void 0,{scope:"Panel"}),x0e="Dropdown",tot=fu(),iot={options:[]};function not(t){var e=t.defaultSelectedKeys,i=t.selectedKeys,r=t.defaultSelectedKey,o=t.selectedKey,l=t.options,d=t.multiSelect,h=JU(l),p=$.useState([]),g=p[0],f=p[1],y,T=l!==h;d?T&&e!==void 0?y=e:y=i:T&&r!==void 0?y=r:y=o;var C=JU(y);return $.useEffect(function(){var E=function(){if(y===void 0){if(d)return I();var D=w(null);return D!==-1?[D]:[]}else if(!Array.isArray(y)){var D=w(y);return D!==-1?[D]:[]}for(var F=[],x=0,B=y;x<B.length;x++){var L=B[x],D=w(L);D!==-1&&F.push(D)}return F},I=function(){return l.map(function(D,F){return D.selected?F:-1}).filter(function(D){return D!==-1})},w=function(D){return XZe(l,function(F){return D!=null?F.key===D:!!F.selected||!!F.isSelected})};(y!==void 0||!h)&&(y!==C||T)&&f(E())},[T,d,h,C,l,y]),[g,f]}var B0e=$.forwardRef(function(t,e){var i=Lw(iot,t),r=$.useRef(null),o=Ff(e,r),l=hW(r,i.responsiveMode),d=not(i),h=d[0],p=d[1];return $.createElement(aot,Rt({},i,{responsiveMode:l,hoisted:{rootRef:o,selectedIndices:h,setSelectedIndices:p}}))});B0e.displayName="DropdownBase";var aot=function(t){mu(e,t);function e(i){var r=t.call(this,i)||this;r._host=$.createRef(),r._focusZone=$.createRef(),r._dropDown=$.createRef(),r._scrollIdleDelay=250,r._sizePosCache=new Grt,r._requestAnimationFrame=bet(r),r.dismissMenu=function(){var T=r.state.isOpen;T&&r.setState({isOpen:!1})},r._onChange=function(T,C,E,I,w){var D=r.props,F=D.onChange,x=D.onChanged;if(F||x){var B=w?Rt(Rt({},C[E]),{selected:!I}):C[E];F&&F(Rt(Rt({},T),{target:r._dropDown.current}),B,E),x&&x(B,E)}},r._getPlaceholder=function(){return r.props.placeholder||r.props.placeHolder},r._getTitle=function(T,C){var E=r.props.multiSelectDelimiter,I=E===void 0?", ":E;return T.map(function(w){return w.text}).join(I)},r._onRenderTitle=function(T){return $.createElement($.Fragment,null,r._getTitle(T))},r._onRenderPlaceholder=function(T){return r._getPlaceholder()?$.createElement($.Fragment,null,r._getPlaceholder()):null},r._onRenderContainer=function(T){var C=T.calloutProps,E=T.panelProps,I=r.props,w=I.responsiveMode,D=I.dropdownWidth,F=w<=EL.medium,x={firstFocusableTarget:"#".concat(r._listId,"1")},B=r._classNames.subComponentStyles?r._classNames.subComponentStyles.panel:void 0,L=void 0,z=void 0;return D==="auto"?z=r._dropDown.current?r._dropDown.current.clientWidth:0:L=D||(r._dropDown.current?r._dropDown.current.clientWidth:0),F?$.createElement(N0e,Rt({closeButtonAriaLabel:"Close",focusTrapZoneProps:x,hasCloseButton:!0,isOpen:!0,isLightDismiss:!0,onDismiss:r._onDismiss,styles:B},E),r._renderFocusableList(T)):$.createElement(ZU,Rt({isBeakVisible:!1,gapSpace:0,doNotLayer:!1,directionalHintFixed:!1,directionalHint:hd.bottomLeftEdge,calloutWidth:L,calloutMinWidth:z},C,{className:r._classNames.callout,target:r._dropDown.current,onDismiss:r._onDismiss,onScroll:r._onScroll,onPositioned:r._onPositioned}),r._renderFocusableList(T))},r._onRenderCaretDown=function(T){return $.createElement(Fr,{className:r._classNames.caretDown,iconName:"ChevronDown","aria-hidden":!0})},r._onRenderList=function(T){var C=T.onRenderItem,E=C===void 0?r._onRenderItem:C,I={items:[]},w=[],D=function(){var x=I.id?[$.createElement("div",{role:"group",key:I.id,"aria-labelledby":I.id},I.items)]:I.items;w=Gd(Gd([],w,!0),x,!0),I={items:[]}},F=function(x,B){switch(x.itemType){case Uw.Header:I.items.length>0&&D();var L=r._id+x.key;I.items.push(E(Rt(Rt({id:L},x),{index:B}),r._onRenderItem)),I.id=L;break;case Uw.Divider:B>0&&I.items.push(E(Rt(Rt({},x),{index:B}),r._onRenderItem)),I.items.length>0&&D();break;default:I.items.push(E(Rt(Rt({},x),{index:B}),r._onRenderItem))}};return T.options.forEach(function(x,B){F(x,B)}),I.items.length>0&&D(),$.createElement($.Fragment,null,w)},r._onRenderItem=function(T){switch(T.itemType){case Uw.Divider:return r._renderSeparator(T);case Uw.Header:return r._renderHeader(T);default:return r._renderOption(T)}},r._renderOption=function(T){var C,E=r.props,I=E.onRenderOption,w=I===void 0?r._onRenderOption:I,D=E.hoisted.selectedIndices,F=D===void 0?[]:D,x=T.index!==void 0&&F?F.indexOf(T.index)>-1:!1,B=T.hidden?r._classNames.dropdownItemHidden:x&&T.disabled===!0?r._classNames.dropdownItemSelectedAndDisabled:x?r._classNames.dropdownItemSelected:T.disabled===!0?r._classNames.dropdownItemDisabled:r._classNames.dropdownItem,L=T.title,z=r._listId+T.index,H=(C=T.id)!==null&&C!==void 0?C:z+"-label",j=r._classNames.subComponentStyles?r._classNames.subComponentStyles.multiSelectItem:void 0;return r.props.multiSelect?$.createElement(Nre,{id:z,key:T.key,disabled:T.disabled,onChange:r._onItemClick(T),inputProps:Rt({"aria-selected":x,onMouseEnter:r._onItemMouseEnter.bind(r,T),onMouseLeave:r._onMouseItemLeave.bind(r,T),onMouseMove:r._onItemMouseMove.bind(r,T),role:"option"},{"data-index":T.index,"data-is-focusable":!(T.disabled||T.hidden)}),label:T.text,title:L,onRenderLabel:r._onRenderItemLabel.bind(r,Rt(Rt({},T),{id:H})),className:wh(B,"is-multi-select"),checked:x,styles:j,ariaPositionInSet:T.hidden?void 0:r._sizePosCache.positionInSet(T.index),ariaSetSize:T.hidden?void 0:r._sizePosCache.optionSetSize,ariaLabel:T.ariaLabel,ariaLabelledBy:T.ariaLabel?void 0:H}):$.createElement(Ore,{id:z,key:T.key,"data-index":T.index,"data-is-focusable":!T.disabled,disabled:T.disabled,className:B,onClick:r._onItemClick(T),onMouseEnter:r._onItemMouseEnter.bind(r,T),onMouseLeave:r._onMouseItemLeave.bind(r,T),onMouseMove:r._onItemMouseMove.bind(r,T),role:"option","aria-selected":x?"true":"false",ariaLabel:T.ariaLabel,title:L,"aria-posinset":r._sizePosCache.positionInSet(T.index),"aria-setsize":r._sizePosCache.optionSetSize},w(T,r._onRenderOption))},r._onRenderOption=function(T){return $.createElement("span",{className:r._classNames.dropdownOptionText},T.text)},r._onRenderMultiselectOption=function(T){return $.createElement("span",{id:T.id,"aria-hidden":"true",className:r._classNames.dropdownOptionText},T.text)},r._onRenderItemLabel=function(T){var C=r.props.onRenderOption,E=C===void 0?r._onRenderMultiselectOption:C;return E(T,r._onRenderMultiselectOption)},r._onPositioned=function(T){r._focusZone.current&&r._requestAnimationFrame(function(){var C=r.props.hoisted.selectedIndices;if(r._focusZone.current)if(!r._hasBeenPositioned&&C&&C[0]&&!r.props.options[C[0]].disabled){var E=Gg().getElementById("".concat(r._id,"-list").concat(C[0]));E&&r._focusZone.current.focusElement(E),r._hasBeenPositioned=!0}else r._focusZone.current.focus()}),(!r.state.calloutRenderEdge||r.state.calloutRenderEdge!==T.targetEdge)&&r.setState({calloutRenderEdge:T.targetEdge})},r._onItemClick=function(T){return function(C){T.disabled||(r.setSelectedIndex(C,T.index),r.props.multiSelect||r.setState({isOpen:!1}))}},r._onScroll=function(){var T=kEe(r.context);!r._isScrollIdle&&r._scrollIdleTimeoutId!==void 0?(T.clearTimeout(r._scrollIdleTimeoutId),r._scrollIdleTimeoutId=void 0):r._isScrollIdle=!1,r._scrollIdleTimeoutId=T.setTimeout(function(){r._isScrollIdle=!0},r._scrollIdleDelay)},r._onMouseItemLeave=function(T,C){if(!r._shouldIgnoreMouseEvent()&&r._host.current)if(r._host.current.setActive)try{r._host.current.setActive()}catch{}else r._host.current.focus()},r._onDismiss=function(){r.setState({isOpen:!1})},r._onDropdownBlur=function(T){var C=r._isDisabled();C||r.state.isOpen||(r.setState({hasFocus:!1}),r.props.onBlur&&r.props.onBlur(T))},r._onDropdownKeyDown=function(T){var C=r._isDisabled();if(!C&&(r._lastKeyDownWasAltOrMeta=r._isAltOrMeta(T),!(r.props.onKeyDown&&(r.props.onKeyDown(T),T.defaultPrevented)))){var E,I=r.props.hoisted.selectedIndices.length?r.props.hoisted.selectedIndices[0]:-1,w=T.altKey||T.metaKey,D=r.state.isOpen;switch(T.which){case fa.enter:r.setState({isOpen:!D});break;case fa.escape:if(!D)return;r.setState({isOpen:!1});break;case fa.up:if(w){if(D){r.setState({isOpen:!1});break}return}r.props.multiSelect?r.setState({isOpen:!0}):r._isDisabled()||(E=r._moveIndex(T,-1,I-1,I));break;case fa.down:w&&(T.stopPropagation(),T.preventDefault()),w&&!D||r.props.multiSelect?r.setState({isOpen:!0}):r._isDisabled()||(E=r._moveIndex(T,1,I+1,I));break;case fa.home:r.props.multiSelect||(E=r._moveIndex(T,1,0,I));break;case fa.end:r.props.multiSelect||(E=r._moveIndex(T,-1,r.props.options.length-1,I));break;case fa.space:break;default:return}E!==I&&(T.stopPropagation(),T.preventDefault())}},r._onDropdownKeyUp=function(T){var C=r._isDisabled();if(!C){var E=r._shouldHandleKeyUp(T),I=r.state.isOpen;if(!(r.props.onKeyUp&&(r.props.onKeyUp(T),T.defaultPrevented))){switch(T.which){case fa.space:r.setState({isOpen:!I});break;default:E&&I&&r.setState({isOpen:!1});return}T.stopPropagation(),T.preventDefault()}}},r._onZoneKeyDown=function(T){var C,E,I;r._lastKeyDownWasAltOrMeta=r._isAltOrMeta(T);var w=T.altKey||T.metaKey;switch(T.which){case fa.up:w?r.setState({isOpen:!1}):r._host.current&&(I=g_e(r._host.current,r._host.current.lastChild,!0));break;case fa.home:case fa.end:case fa.pageUp:case fa.pageDown:break;case fa.down:!w&&r._host.current&&(I=p_e(r._host.current,r._host.current.firstChild,!0));break;case fa.escape:r.setState({isOpen:!1});break;case fa.tab:r.setState({isOpen:!1});var D=Gg();D&&(T.shiftKey?(C=jS(D.body,r._dropDown.current,!1,!1,!0,!0))===null||C===void 0||C.focus():(E=By(D.body,r._dropDown.current,!1,!1,!0,!0))===null||E===void 0||E.focus());break;default:return}I&&I.focus(),T.stopPropagation(),T.preventDefault()},r._onZoneKeyUp=function(T){var C=r._shouldHandleKeyUp(T);C&&r.state.isOpen&&(r.setState({isOpen:!1}),T.preventDefault())},r._onDropdownClick=function(T){if(!(r.props.onClick&&(r.props.onClick(T),T.defaultPrevented))){var C=r.state.isOpen,E=r._isDisabled();!E&&!r._shouldOpenOnFocus()&&r.setState({isOpen:!C}),r._isFocusedByClick=!1}},r._onDropdownMouseDown=function(){r._isFocusedByClick=!0},r._onFocus=function(T){var C=r._isDisabled();if(!C){r.props.onFocus&&r.props.onFocus(T);var E={hasFocus:!0};r._shouldOpenOnFocus()&&(E.isOpen=!0),r.setState(E)}},r._isDisabled=function(){var T=r.props.disabled,C=r.props.isDisabled;return T===void 0&&(T=C),T},r._onRenderLabel=function(T){var C=T.label,E=T.required,I=T.disabled,w=r._classNames.subComponentStyles?r._classNames.subComponentStyles.label:void 0;return C?$.createElement(px,{className:r._classNames.label,id:r._labelId,required:E,styles:w,disabled:I},C):null},Dw(r);var o=i.multiSelect,l=i.selectedKey,d=i.selectedKeys,h=i.defaultSelectedKey,p=i.defaultSelectedKeys,g=i.options;if(process.env.NODE_ENV!=="production")if(fL(x0e,i,{isDisabled:"disabled",onChanged:"onChange",placeHolder:"placeholder",onRenderPlaceHolder:"onRenderPlaceholder"}),Uq(x0e,i,{defaultSelectedKey:"selectedKey",defaultSelectedKeys:"selectedKeys",selectedKeys:"selectedKey"}),o){var f=function(T){return SC("Dropdown property '".concat(T,"' cannot be used when 'multiSelect' is true. Use '").concat(T,"s' instead."))};l!==void 0&&f("selectedKey"),h!==void 0&&f("defaultSelectedKey")}else{var y=function(T){return SC("Dropdown property '".concat(T,"s' cannot be used when 'multiSelect' is false/unset. Use '").concat(T,"' instead."))};d!==void 0&&y("selectedKey"),p!==void 0&&y("defaultSelectedKey")}return r._id=i.id||bp("Dropdown"),r._labelId=r._id+"-label",r._listId=r._id+"-list",r._optionId=r._id+"-option",r._isScrollIdle=!0,r._hasBeenPositioned=!1,r._sizePosCache.updateOptions(g),r.state={isOpen:!1,hasFocus:!1,calloutRenderEdge:void 0},r}return Object.defineProperty(e.prototype,"selectedOptions",{get:function(){var i=this.props,r=i.options,o=i.hoisted.selectedIndices;return D0e(r,o)},enumerable:!1,configurable:!0}),e.prototype.componentWillUnmount=function(){clearTimeout(this._scrollIdleTimeoutId)},e.prototype.componentDidUpdate=function(i,r){r.isOpen===!0&&this.state.isOpen===!1&&(this._gotMouseMove=!1,this._hasBeenPositioned=!1,this.props.onDismiss&&this.props.onDismiss())},e.prototype.render=function(){var i=this._id,r=this.props,o=r.className,l=r.label,d=r.options,h=r.ariaLabel,p=r.required,g=r.errorMessage,f=r.styles,y=r.theme,T=r.panelProps,C=r.calloutProps,E=r.onRenderTitle,I=E===void 0?this._getTitle:E,w=r.onRenderContainer,D=w===void 0?this._onRenderContainer:w,F=r.onRenderCaretDown,x=F===void 0?this._onRenderCaretDown:F,B=r.onRenderLabel,L=B===void 0?this._onRenderLabel:B,z=r.onRenderItem,H=z===void 0?this._onRenderItem:z,j=r.hoisted.selectedIndices,J=this.state,Z=J.isOpen,re=J.calloutRenderEdge,ne=J.hasFocus,le=r.onRenderPlaceholder||r.onRenderPlaceHolder||this._getPlaceholder;d!==this._sizePosCache.cachedOptions&&this._sizePosCache.updateOptions(d);var he=D0e(d,j),Me=Wl(r,Nf),Le=this._isDisabled(),pe=i+"-errorMessage";this._classNames=tot(f,{theme:y,className:o,hasError:!!(g&&g.length>0),hasLabel:!!l,isOpen:Z,required:p,disabled:Le,isRenderingPlaceholder:!he.length,panelClassName:T?T.className:void 0,calloutClassName:C?C.className:void 0,calloutRenderEdge:re});var te=!!g&&g.length>0;return $.createElement("div",{className:this._classNames.root,ref:this.props.hoisted.rootRef,"aria-owns":Z?this._listId:void 0},L(this.props,this._onRenderLabel),$.createElement("div",Rt({"data-is-focusable":!Le,"data-ktp-target":!0,ref:this._dropDown,id:i,tabIndex:Le?-1:0,role:"combobox","aria-haspopup":"listbox","aria-expanded":Z?"true":"false","aria-label":h,"aria-labelledby":l&&!h?FU(this._labelId,this._optionId):void 0,"aria-describedby":te?this._id+"-errorMessage":void 0,"aria-required":p,"aria-disabled":Le,"aria-invalid":te,"aria-controls":Z?this._listId:void 0},Me,{className:this._classNames.dropdown,onBlur:this._onDropdownBlur,onKeyDown:this._onDropdownKeyDown,onKeyUp:this._onDropdownKeyUp,onClick:this._onDropdownClick,onMouseDown:this._onDropdownMouseDown,onFocus:this._onFocus}),$.createElement("span",{id:this._optionId,className:this._classNames.title,"aria-live":ne?"polite":void 0,"aria-atomic":ne?!0:void 0},he.length?I(he,this._onRenderTitle):le(r,this._onRenderPlaceholder)),$.createElement("span",{className:this._classNames.caretDownWrapper},x(r,this._onRenderCaretDown))),Z&&D(Rt(Rt({},r),{onDismiss:this._onDismiss,onRenderItem:H}),this._onRenderContainer),te&&$.createElement("div",{role:"alert",id:pe,className:this._classNames.errorMessage},g))},e.prototype.focus=function(i){this._dropDown.current&&(this._dropDown.current.focus(),i&&this.setState({isOpen:!0}))},e.prototype.setSelectedIndex=function(i,r){var o=this.props,l=o.options,d=o.selectedKey,h=o.selectedKeys,p=o.multiSelect,g=o.notifyOnReselect,f=o.hoisted.selectedIndices,y=f===void 0?[]:f,T=y?y.indexOf(r)>-1:!1,C=[];if(r=Math.max(0,Math.min(l.length-1,r)),d!==void 0||h!==void 0){this._onChange(i,l,r,T,p);return}if(!(!p&&!g&&r===y[0])){if(p)if(C=y?this._copyArray(y):[],T){var E=C.indexOf(r);E>-1&&C.splice(E,1)}else C.push(r);else C=[r];i.persist(),this.props.hoisted.setSelectedIndices(C),this._onChange(i,l,r,T,p)}},e.prototype._copyArray=function(i){for(var r=[],o=0,l=i;o<l.length;o++){var d=l[o];r.push(d)}return r},e.prototype._moveIndex=function(i,r,o,l){var d=this.props.options;if(l===o||d.length===0)return l;o>=d.length?o=0:o<0&&(o=d.length-1);for(var h=0;d[o].itemType===Uw.Header||d[o].itemType===Uw.Divider||d[o].disabled;){if(h>=d.length)return l;o+r<0?o=d.length:o+r>=d.length&&(o=-1),o=o+r,h++}return this.setSelectedIndex(i,o),o},e.prototype._renderFocusableList=function(i){var r=i.onRenderList,o=r===void 0?this._onRenderList:r,l=i.label,d=i.ariaLabel,h=i.multiSelect;return $.createElement("div",{className:this._classNames.dropdownItemsWrapper,onKeyDown:this._onZoneKeyDown,onKeyUp:this._onZoneKeyUp,ref:this._host,tabIndex:0},$.createElement(hA,{ref:this._focusZone,direction:Lm.vertical,id:this._listId,className:this._classNames.dropdownItems,role:"listbox","aria-label":d,"aria-labelledby":l&&!d?this._labelId:void 0,"aria-multiselectable":h},o(i,this._onRenderList)))},e.prototype._renderSeparator=function(i){var r=i.index,o=i.key,l=i.hidden?this._classNames.dropdownDividerHidden:this._classNames.dropdownDivider;return r>0?$.createElement("div",{role:"presentation",key:o,className:l}):null},e.prototype._renderHeader=function(i){var r=this.props.onRenderOption,o=r===void 0?this._onRenderOption:r,l=i.key,d=i.id,h=i.hidden?this._classNames.dropdownItemHeaderHidden:this._classNames.dropdownItemHeader;return $.createElement("div",{id:d,key:l,className:h},o(i,this._onRenderOption))},e.prototype._onItemMouseEnter=function(i,r){if(!this._shouldIgnoreMouseEvent()){var o=r.currentTarget;o.focus()}},e.prototype._onItemMouseMove=function(i,r){var o=CL(this.context),l=r.currentTarget;this._gotMouseMove=!0,!(!this._isScrollIdle||o.activeElement===l)&&l.focus()},e.prototype._shouldIgnoreMouseEvent=function(){return!this._isScrollIdle||!this._gotMouseMove},e.prototype._isAltOrMeta=function(i){return i.which===fa.alt||i.key==="Meta"},e.prototype._shouldHandleKeyUp=function(i){var r=this._lastKeyDownWasAltOrMeta&&this._isAltOrMeta(i);return this._lastKeyDownWasAltOrMeta=!1,!!r&&!(dre()||Wq())},e.prototype._shouldOpenOnFocus=function(){var i=this.state.hasFocus,r=this.props.openOnKeyboardFocus;return!this._isFocusedByClick&&r===!0&&!i},e.defaultProps={options:[]},e.contextType=ZN,e}($.Component),Gre,SW,qre,Wre,Kre,rot={root:"ms-Dropdown-container",label:"ms-Dropdown-label",dropdown:"ms-Dropdown",title:"ms-Dropdown-title",caretDownWrapper:"ms-Dropdown-caretDownWrapper",caretDown:"ms-Dropdown-caretDown",callout:"ms-Dropdown-callout",panel:"ms-Dropdown-panel",dropdownItems:"ms-Dropdown-items",dropdownItem:"ms-Dropdown-item",dropdownDivider:"ms-Dropdown-divider",dropdownOptionText:"ms-Dropdown-optionText",dropdownItemHeader:"ms-Dropdown-header",titleIsPlaceHolder:"ms-Dropdown-titleIsPlaceHolder",titleHasError:"ms-Dropdown-title--hasError"},bW=32,Jre=36,oot=(Gre={},Gre["".concat(Rn,", ").concat(oEe.replace("@media ",""))]=Rt({},uc()),Gre),TW={selectors:Rt((SW={},SW[Rn]=(qre={backgroundColor:"Highlight",borderColor:"Highlight",color:"HighlightText"},qre[".".concat(ys," &:focus:after")]={borderColor:"HighlightText"},qre),SW[".ms-Checkbox-checkbox"]=(Wre={},Wre[Rn]={borderColor:"HighlightText"},Wre),SW),oot)},F0e={selectors:(Kre={},Kre[Rn]={borderColor:"Highlight"},Kre)},sot=Zq(0,jU),lot=function(t){var e,i,r,o,l,d,h,p,g,f,y,T,C=t.theme,E=t.hasError,I=t.hasLabel,w=t.className,D=t.isOpen,F=t.disabled,x=t.required,B=t.isRenderingPlaceholder,L=t.panelClassName,z=t.calloutClassName,H=t.calloutRenderEdge;if(!C)throw new Error("theme is undefined or null in base Dropdown getStyles function.");var j=eh(rot,C),J=C.palette,Z=C.semanticColors,re=C.effects,ne=C.fonts,le={color:Z.menuItemTextHovered},he={color:Z.menuItemText},Me={borderColor:Z.errorText},Le=[j.dropdownItem,{backgroundColor:"transparent",boxSizing:"border-box",cursor:"pointer",display:"flex",alignItems:"center",padding:"0 8px",width:"100%",minHeight:Jre,lineHeight:20,height:0,position:"relative",border:"1px solid transparent",borderRadius:0,wordWrap:"break-word",overflowWrap:"break-word",textAlign:"left",".ms-Button-flexContainer":{width:"100%"}}],pe=[j.dropdownItemHeader,Rt(Rt({},ne.medium),{fontWeight:xs.semibold,color:Z.menuHeader,background:"none",backgroundColor:"transparent",border:"none",height:Jre,lineHeight:Jre,cursor:"default",padding:"0 8px",userSelect:"none",textAlign:"left",selectors:(e={},e[Rn]=Rt({color:"GrayText"},uc()),e)})],te=Z.menuItemBackgroundPressed,Se=function(Be){var qe,Ge;return Be===void 0&&(Be=!1),{selectors:(qe={"&:hover":[{color:Z.menuItemTextHovered,backgroundColor:Be?te:Z.menuItemBackgroundHovered},TW],"&.is-multi-select:hover":[{backgroundColor:Be?te:"transparent"},TW],"&:active:hover":[{color:Z.menuItemTextHovered,backgroundColor:Be?Z.menuItemBackgroundHovered:Z.menuItemBackgroundPressed},TW]},qe[".".concat(ys," &:focus:after, :host(.").concat(ys,") &:focus:after")]=(Ge={left:0,top:0,bottom:0,right:0},Ge[Rn]={inset:"2px"},Ge),qe[Rn]={border:"none"},qe)}},ce=Gd(Gd([],Le,!0),[{backgroundColor:te,color:Z.menuItemTextHovered},Se(!0),TW],!1),X=Gd(Gd([],Le,!0),[{color:Z.disabledText,cursor:"default",selectors:(i={},i[Rn]={color:"GrayText",border:"none"},i)}],!1),ve=H===so.bottom?"".concat(re.roundedCorner2," ").concat(re.roundedCorner2," 0 0"):"0 0 ".concat(re.roundedCorner2," ").concat(re.roundedCorner2),Te=H===so.bottom?"0 0 ".concat(re.roundedCorner2," ").concat(re.roundedCorner2):"".concat(re.roundedCorner2," ").concat(re.roundedCorner2," 0 0");return{root:[j.root,w],label:j.label,dropdown:[j.dropdown,sx,ne.medium,{color:Z.menuItemText,borderColor:Z.focusBorder,position:"relative",outline:0,userSelect:"none",selectors:(r={},r["&:hover ."+j.title]=[!F&&le,{borderColor:D?J.neutralSecondary:J.neutralPrimary},F0e],r["&:focus ."+j.title]=[!F&&le,{selectors:(o={},o[Rn]={color:"Highlight"},o)}],r["&:focus:after"]=[{pointerEvents:"none",content:"''",position:"absolute",boxSizing:"border-box",top:"0px",left:"0px",width:"100%",height:"100%",border:F?"none":"2px solid ".concat(J.themePrimary),borderRadius:"2px",selectors:(l={},l[Rn]={color:"Highlight"},l)}],r["&:active ."+j.title]=[!F&&le,{borderColor:J.themePrimary},F0e],r["&:hover ."+j.caretDown]=!F&&he,r["&:focus ."+j.caretDown]=[!F&&he,{selectors:(d={},d[Rn]={color:"Highlight"},d)}],r["&:active ."+j.caretDown]=!F&&he,r["&:hover ."+j.titleIsPlaceHolder]=!F&&he,r["&:focus ."+j.titleIsPlaceHolder]=!F&&he,r["&:active ."+j.titleIsPlaceHolder]=!F&&he,r["&:hover ."+j.titleHasError]=Me,r["&:active ."+j.titleHasError]=Me,r)},D&&"is-open",F&&"is-disabled",x&&"is-required",x&&!I&&{selectors:(h={":before":{content:"'*'",color:Z.errorText,position:"absolute",top:-5,right:-10}},h[Rn]={selectors:{":after":{right:-14}}},h)}],title:[j.title,sx,{backgroundColor:Z.inputBackground,borderWidth:1,borderStyle:"solid",borderColor:Z.inputBorder,borderRadius:D?ve:re.roundedCorner2,cursor:"pointer",display:"block",height:bW,lineHeight:bW-2,padding:"0 28px 0 8px",position:"relative",overflow:"hidden",whiteSpace:"nowrap",textOverflow:"ellipsis"},B&&[j.titleIsPlaceHolder,{color:Z.inputPlaceholderText}],E&&[j.titleHasError,Me],F&&{backgroundColor:Z.disabledBackground,border:"none",color:Z.disabledText,cursor:"default",selectors:(p={},p[Rn]=Rt({border:"1px solid GrayText",color:"GrayText",backgroundColor:"Window"},uc()),p)}],caretDownWrapper:[j.caretDownWrapper,{height:bW,lineHeight:bW-2,paddingTop:1,position:"absolute",right:8,top:0},!F&&{cursor:"pointer"}],caretDown:[j.caretDown,{color:J.neutralSecondary,fontSize:ne.small.fontSize,pointerEvents:"none"},F&&{color:Z.disabledText,selectors:(g={},g[Rn]=Rt({color:"GrayText"},uc()),g)}],errorMessage:Rt(Rt({color:Z.errorText},C.fonts.small),{paddingTop:5}),callout:[j.callout,{boxShadow:re.elevation8,borderRadius:Te,selectors:(f={},f[".ms-Callout-main"]={borderRadius:Te},f)},z],dropdownItemsWrapper:{selectors:{"&:focus":{outline:0}}},dropdownItems:[j.dropdownItems,{display:"block"}],dropdownItem:Gd(Gd([],Le,!0),[Se()],!1),dropdownItemSelected:ce,dropdownItemDisabled:X,dropdownItemSelectedAndDisabled:[ce,X,{backgroundColor:"transparent"}],dropdownItemHidden:Gd(Gd([],Le,!0),[{display:"none"}],!1),dropdownDivider:[j.dropdownDivider,{height:1,backgroundColor:Z.bodyDivider}],dropdownDividerHidden:[j.dropdownDivider,{display:"none"}],dropdownOptionText:[j.dropdownOptionText,{overflow:"hidden",whiteSpace:"nowrap",textOverflow:"ellipsis",minWidth:0,maxWidth:"100%",wordWrap:"break-word",overflowWrap:"break-word",margin:"1px"}],dropdownItemHeader:pe,dropdownItemHeaderHidden:Gd(Gd([],pe,!0),[{display:"none"}],!1),subComponentStyles:{label:{root:{display:"inline-block"}},multiSelectItem:{root:{padding:0},label:{alignSelf:"stretch",padding:"0 8px",width:"100%"},input:{selectors:(y={},y[".".concat(ys," &:focus + label::before, :host(.").concat(ys,") &:focus + label::before")]={outlineOffset:"0px"},y)}},panel:{root:[L],main:{selectors:(T={},T[sot]={width:272},T)},contentInner:{padding:"0 0 20px"}}}}},s5=vu(B0e,lot,void 0,{scope:"Dropdown"});s5.displayName="Dropdown";function cot(t,e){t===void 0&&(t="");var i={style:{MozOsxFontSmoothing:"grayscale",WebkitFontSmoothing:"antialiased",fontStyle:"normal",fontWeight:"normal",speak:"none"},fontFace:{fontFamily:'"FabricMDL2Icons"',src:"url('".concat(t,"fabric-icons-a13498cf.woff') format('woff')")},icons:{GlobalNavButton:"",ChevronDown:"",ChevronUp:"",Edit:"",Add:"",Cancel:"",More:"",Settings:"",Mail:"",Filter:"",Search:"",Share:"",BlockedSite:"",FavoriteStar:"",FavoriteStarFill:"",CheckMark:"",Delete:"",ChevronLeft:"",ChevronRight:"",Calendar:"",Megaphone:"",Undo:"",Flag:"",Page:"",Pinned:"",View:"",Clear:"",Download:"",Upload:"",Folder:"",Sort:"",AlignRight:"",AlignLeft:"",Tag:"",AddFriend:"",Info:"",SortLines:"",List:"",CircleRing:"",Heart:"",HeartFill:"",Tiles:"",Embed:"",Glimmer:"",Ascending:"",Descending:"",SortUp:"",SortDown:"",SyncToPC:"",LargeGrid:"",SkypeCheck:"",SkypeClock:"",SkypeMinus:"",ClearFilter:"",Flow:"",StatusCircleCheckmark:"",MoreVertical:""}};qg(i,e)}function dot(t,e){t===void 0&&(t="");var i={style:{MozOsxFontSmoothing:"grayscale",WebkitFontSmoothing:"antialiased",fontStyle:"normal",fontWeight:"normal",speak:"none"},fontFace:{fontFamily:'"FabricMDL2Icons-0"',src:"url('".concat(t,"fabric-icons-0-467ee27f.woff') format('woff')")},icons:{PageLink:"",CommentSolid:"",ChangeEntitlements:"",Installation:"",WebAppBuilderModule:"",WebAppBuilderFragment:"",WebAppBuilderSlot:"",BullseyeTargetEdit:"",WebAppBuilderFragmentCreate:"",PageData:"",PageHeaderEdit:"",ProductList:"",UnpublishContent:"",DependencyAdd:"",DependencyRemove:"",EntitlementPolicy:"",EntitlementRedemption:"",SchoolDataSyncLogo:"",PinSolid12:"",PinSolidOff12:"",AddLink:"",SharepointAppIcon16:"",DataflowsLink:"",TimePicker:"",UserWarning:"",ComplianceAudit:"",InternetSharing:"",Brightness:"",MapPin:"",Airplane:"",Tablet:"",QuickNote:"",Video:"",People:"",Phone:"",Pin:"",Shop:"",Stop:"",Link:"",AllApps:"",Zoom:"",ZoomOut:"",Microphone:"",Camera:"",Attach:"",Send:"",FavoriteList:"",PageSolid:"",Forward:"",Back:"",Refresh:"",Lock:"",ReportHacked:"",EMI:"",MiniLink:"",Blocked:"",ReadingMode:"",Favicon:"",Remove:"",Checkbox:"",CheckboxComposite:"",CheckboxFill:"",CheckboxIndeterminate:"",CheckboxCompositeReversed:"",BackToWindow:"",FullScreen:"",Print:"",Up:"",Down:"",OEM:"",Save:"",ReturnKey:"",Cloud:"",Flashlight:"",CommandPrompt:"",Sad:"",RealEstate:"",SIPMove:"",EraseTool:"",GripperTool:"",Dialpad:"",PageLeft:"",PageRight:"",MultiSelect:"",KeyboardClassic:"",Play:"",Pause:"",InkingTool:"",Emoji2:"",GripperBarHorizontal:"",System:"",Personalize:"",SearchAndApps:"",Globe:"",EaseOfAccess:"",ContactInfo:"",Unpin:"",Contact:"",Memo:"",IncomingCall:""}};qg(i,e)}function uot(t,e){t===void 0&&(t="");var i={style:{MozOsxFontSmoothing:"grayscale",WebkitFontSmoothing:"antialiased",fontStyle:"normal",fontWeight:"normal",speak:"none"},fontFace:{fontFamily:'"FabricMDL2Icons-1"',src:"url('".concat(t,"fabric-icons-1-4d521695.woff') format('woff')")},icons:{Paste:"",WindowsLogo:"",Error:"",GripperBarVertical:"",Unlock:"",Slideshow:"",Trim:"",AutoEnhanceOn:"",AutoEnhanceOff:"",Color:"",SaveAs:"",Light:"",Filters:"",AspectRatio:"",Contrast:"",Redo:"",Crop:"",PhotoCollection:"",Album:"",Rotate:"",PanoIndicator:"",Translate:"",RedEye:"",ViewOriginal:"",ThumbnailView:"",Package:"",Telemarketer:"",Warning:"",Financial:"",Education:"",ShoppingCart:"",Train:"",Move:"",TouchPointer:"",Merge:"",TurnRight:"",Ferry:"",Highlight:"",PowerButton:"",Tab:"",Admin:"",TVMonitor:"",Speakers:"",Game:"",HorizontalTabKey:"",UnstackSelected:"",StackIndicator:"",Nav2DMapView:"",StreetsideSplitMinimize:"",Car:"",Bus:"",EatDrink:"",SeeDo:"",LocationCircle:"",Home:"",SwitcherStartEnd:"",ParkingLocation:"",IncidentTriangle:"",Touch:"",MapDirections:"",CaretHollow:"",CaretSolid:"",History:"",Location:"",MapLayers:"",SearchNearby:"",Work:"",Recent:"",Hotel:"",Bank:"",LocationDot:"",Dictionary:"",ChromeBack:"",FolderOpen:"",PinnedFill:"",RevToggleKey:"",USB:"",Previous:"",Next:"",Sync:"",Help:"",Emoji:"",MailForward:"",ClosePane:"",OpenPane:"",PreviewLink:"",ZoomIn:"",Bookmarks:"",Document:"",ProtectedDocument:"",OpenInNewWindow:"",MailFill:"",ViewAll:"",Switch:"",Rename:"",Go:"",Remote:"",SelectAll:"",Orientation:"",Import:""}};qg(i,e)}function hot(t,e){t===void 0&&(t="");var i={style:{MozOsxFontSmoothing:"grayscale",WebkitFontSmoothing:"antialiased",fontStyle:"normal",fontWeight:"normal",speak:"none"},fontFace:{fontFamily:'"FabricMDL2Icons-2"',src:"url('".concat(t,"fabric-icons-2-63c99abf.woff') format('woff')")},icons:{Picture:"",ChromeClose:"",ShowResults:"",Message:"",CalendarDay:"",CalendarWeek:"",MailReplyAll:"",Read:"",Cut:"",PaymentCard:"",Copy:"",Important:"",MailReply:"",GotoToday:"",Font:"",FontColor:"",FolderFill:"",Permissions:"",DisableUpdates:"",Unfavorite:"",Italic:"",Underline:"",Bold:"",MoveToFolder:"",Dislike:"",Like:"",AlignCenter:"",OpenFile:"",ClearSelection:"",FontDecrease:"",FontIncrease:"",FontSize:"",CellPhone:"",RepeatOne:"",RepeatAll:"",Calculator:"",Library:"",PostUpdate:"",NewFolder:"",CalendarReply:"",UnsyncFolder:"",SyncFolder:"",BlockContact:"",Accept:"",BulletedList:"",Preview:"",News:"",Chat:"",Group:"",World:"",Comment:"",DockLeft:"",DockRight:"",Repair:"",Accounts:"",Street:"",RadioBullet:"",Stopwatch:"",Clock:"",WorldClock:"",AlarmClock:"",Photo:"",ActionCenter:"",Hospital:"",Timer:"",FullCircleMask:"",LocationFill:"",ChromeMinimize:"",ChromeRestore:"",Annotation:"",Fingerprint:"",Handwriting:"",ChromeFullScreen:"",Completed:"",Label:"",FlickDown:"",FlickUp:"",FlickLeft:"",FlickRight:"",MiniExpand:"",MiniContract:"",Streaming:"",MusicInCollection:"",OneDriveLogo:"",CompassNW:"",Code:"",LightningBolt:"",CalculatorMultiply:"",CalculatorAddition:"",CalculatorSubtract:"",CalculatorPercentage:"",CalculatorEqualTo:"",PrintfaxPrinterFile:"",StorageOptical:"",Communications:"",Headset:"",Health:"",Webcam2:"",FrontCamera:"",ChevronUpSmall:""}};qg(i,e)}function pot(t,e){t===void 0&&(t="");var i={style:{MozOsxFontSmoothing:"grayscale",WebkitFontSmoothing:"antialiased",fontStyle:"normal",fontWeight:"normal",speak:"none"},fontFace:{fontFamily:'"FabricMDL2Icons-3"',src:"url('".concat(t,"fabric-icons-3-089e217a.woff') format('woff')")},icons:{ChevronDownSmall:"",ChevronLeftSmall:"",ChevronRightSmall:"",ChevronUpMed:"",ChevronDownMed:"",ChevronLeftMed:"",ChevronRightMed:"",Devices2:"",PC1:"",PresenceChickletVideo:"",Reply:"",HalfAlpha:"",ConstructionCone:"",DoubleChevronLeftMed:"",Volume0:"",Volume1:"",Volume2:"",Volume3:"",Chart:"",Robot:"",Manufacturing:"",LockSolid:"",FitPage:"",FitWidth:"",BidiLtr:"",BidiRtl:"",RightDoubleQuote:"",Sunny:"",CloudWeather:"",Cloudy:"",PartlyCloudyDay:"",PartlyCloudyNight:"",ClearNight:"",RainShowersDay:"",Rain:"",Thunderstorms:"",RainSnow:"",Snow:"",BlowingSnow:"",Frigid:"",Fog:"",Squalls:"",Duststorm:"",Unknown:"",Precipitation:"",Ribbon:"",AreaChart:"",Assign:"",FlowChart:"",CheckList:"",Diagnostic:"",Generate:"",LineChart:"",Equalizer:"",BarChartHorizontal:"",BarChartVertical:"",Freezing:"",FunnelChart:"",Processing:"",Quantity:"",ReportDocument:"",StackColumnChart:"",SnowShowerDay:"",HailDay:"",WorkFlow:"",HourGlass:"",StoreLogoMed20:"",TimeSheet:"",TriangleSolid:"",UpgradeAnalysis:"",VideoSolid:"",RainShowersNight:"",SnowShowerNight:"",Teamwork:"",HailNight:"",PeopleAdd:"",Glasses:"",DateTime2:"",Shield:"",Header1:"",PageAdd:"",NumberedList:"",PowerBILogo:"",Info2:"",MusicInCollectionFill:"",Asterisk:"",ErrorBadge:"",CircleFill:"",Record2:"",AllAppsMirrored:"",BookmarksMirrored:"",BulletedListMirrored:"",CaretHollowMirrored:"",CaretSolidMirrored:"",ChromeBackMirrored:"",ClearSelectionMirrored:"",ClosePaneMirrored:"",DockLeftMirrored:"",DoubleChevronLeftMedMirrored:"",GoMirrored:""}};qg(i,e)}function got(t,e){t===void 0&&(t="");var i={style:{MozOsxFontSmoothing:"grayscale",WebkitFontSmoothing:"antialiased",fontStyle:"normal",fontWeight:"normal",speak:"none"},fontFace:{fontFamily:'"FabricMDL2Icons-4"',src:"url('".concat(t,"fabric-icons-4-a656cc0a.woff') format('woff')")},icons:{HelpMirrored:"",ImportMirrored:"",ImportAllMirrored:"",ListMirrored:"",MailForwardMirrored:"",MailReplyMirrored:"",MailReplyAllMirrored:"",MiniContractMirrored:"",MiniExpandMirrored:"",OpenPaneMirrored:"",ParkingLocationMirrored:"",SendMirrored:"",ShowResultsMirrored:"",ThumbnailViewMirrored:"",Media:"",Devices3:"",Focus:"",VideoLightOff:"",Lightbulb:"",StatusTriangle:"",VolumeDisabled:"",Puzzle:"",EmojiNeutral:"",EmojiDisappointed:"",HomeSolid:"",Ringer:"",PDF:"",HeartBroken:"",StoreLogo16:"",MultiSelectMirrored:"",Broom:"",AddToShoppingList:"",Cocktails:"",Wines:"",Articles:"",Cycling:"",DietPlanNotebook:"",Pill:"",ExerciseTracker:"",HandsFree:"",Medical:"",Running:"",Weights:"",Trackers:"",AddNotes:"",AllCurrency:"",BarChart4:"",CirclePlus:"",Coffee:"",Cotton:"",Market:"",Money:"",PieDouble:"",PieSingle:"",RemoveFilter:"",Savings:"",Sell:"",StockDown:"",StockUp:"",Lamp:"",Source:"",MSNVideos:"",Cricket:"",Golf:"",Baseball:"",Soccer:"",MoreSports:"",AutoRacing:"",CollegeHoops:"",CollegeFootball:"",ProFootball:"",ProHockey:"",Rugby:"",SubstitutionsIn:"",Tennis:"",Arrivals:"",Design:"",Website:"",Drop:"",HistoricalWeather:"",SkiResorts:"",Snowflake:"",BusSolid:"",FerrySolid:"",AirplaneSolid:"",TrainSolid:"",Ticket:"",WifiWarning4:"",Devices4:"",AzureLogo:"",BingLogo:"",MSNLogo:"",OutlookLogoInverse:"",OfficeLogo:"",SkypeLogo:"",Door:"",EditMirrored:"",GiftCard:"",DoubleBookmark:"",StatusErrorFull:""}};qg(i,e)}function mot(t,e){t===void 0&&(t="");var i={style:{MozOsxFontSmoothing:"grayscale",WebkitFontSmoothing:"antialiased",fontStyle:"normal",fontWeight:"normal",speak:"none"},fontFace:{fontFamily:'"FabricMDL2Icons-5"',src:"url('".concat(t,"fabric-icons-5-f95ba260.woff') format('woff')")},icons:{Certificate:"",FastForward:"",Rewind:"",Photo2:"",OpenSource:"",Movers:"",CloudDownload:"",Family:"",WindDirection:"",Bug:"",SiteScan:"",BrowserScreenShot:"",F12DevTools:"",CSS:"",JS:"",DeliveryTruck:"",ReminderPerson:"",ReminderGroup:"",ReminderTime:"",TabletMode:"",Umbrella:"",NetworkTower:"",CityNext:"",CityNext2:"",Section:"",OneNoteLogoInverse:"",ToggleFilled:"",ToggleBorder:"",SliderThumb:"",ToggleThumb:"",Documentation:"",Badge:"",Giftbox:"",VisualStudioLogo:"",HomeGroup:"",ExcelLogoInverse:"",WordLogoInverse:"",PowerPointLogoInverse:"",Cafe:"",SpeedHigh:"",Commitments:"",ThisPC:"",MusicNote:"",MicOff:"",PlaybackRate1x:"",EdgeLogo:"",CompletedSolid:"",AlbumRemove:"",MessageFill:"",TabletSelected:"",MobileSelected:"",LaptopSelected:"",TVMonitorSelected:"",DeveloperTools:"",Shapes:"",InsertTextBox:"",LowerBrightness:"",WebComponents:"",OfflineStorage:"",DOM:"",CloudUpload:"",ScrollUpDown:"",DateTime:"",Event:"",Cake:"",Org:"",PartyLeader:"",DRM:"",CloudAdd:"",AppIconDefault:"",Photo2Add:"",Photo2Remove:"",Calories:"",POI:"",AddTo:"",RadioBtnOff:"",RadioBtnOn:"",ExploreContent:"",Product:"",ProgressLoopInner:"",ProgressLoopOuter:"",Blocked2:"",FangBody:"",Toolbox:"",PageHeader:"",ChatInviteFriend:"",Brush:"",Shirt:"",Crown:"",Diamond:"",ScaleUp:"",QRCode:"",Feedback:"",SharepointLogoInverse:"",YammerLogo:"",Hide:"",Uneditable:"",ReturnToSession:"",OpenFolderHorizontal:"",CalendarMirrored:""}};qg(i,e)}function fot(t,e){t===void 0&&(t="");var i={style:{MozOsxFontSmoothing:"grayscale",WebkitFontSmoothing:"antialiased",fontStyle:"normal",fontWeight:"normal",speak:"none"},fontFace:{fontFamily:'"FabricMDL2Icons-6"',src:"url('".concat(t,"fabric-icons-6-ef6fd590.woff') format('woff')")},icons:{SwayLogoInverse:"",OutOfOffice:"",Trophy:"",ReopenPages:"",EmojiTabSymbols:"",AADLogo:"",AccessLogo:"",AdminALogoInverse32:"",AdminCLogoInverse32:"",AdminDLogoInverse32:"",AdminELogoInverse32:"",AdminLLogoInverse32:"",AdminMLogoInverse32:"",AdminOLogoInverse32:"",AdminPLogoInverse32:"",AdminSLogoInverse32:"",AdminYLogoInverse32:"",DelveLogoInverse:"",ExchangeLogoInverse:"",LyncLogo:"",OfficeVideoLogoInverse:"",SocialListeningLogo:"",VisioLogoInverse:"",Balloons:"",Cat:"",MailAlert:"",MailCheck:"",MailLowImportance:"",MailPause:"",MailRepeat:"",SecurityGroup:"",Table:"",VoicemailForward:"",VoicemailReply:"",Waffle:"",RemoveEvent:"",EventInfo:"",ForwardEvent:"",WipePhone:"",AddOnlineMeeting:"",JoinOnlineMeeting:"",RemoveLink:"",PeopleBlock:"",PeopleRepeat:"",PeopleAlert:"",PeoplePause:"",TransferCall:"",AddPhone:"",UnknownCall:"",NoteReply:"",NoteForward:"",NotePinned:"",RemoveOccurrence:"",Timeline:"",EditNote:"",CircleHalfFull:"",Room:"",Unsubscribe:"",Subscribe:"",HardDrive:"",RecurringTask:"",TaskManager:"",TaskManagerMirrored:"",Combine:"",Split:"",DoubleChevronUp:"",DoubleChevronLeft:"",DoubleChevronRight:"",TextBox:"",TextField:"",NumberField:"",Dropdown:"",PenWorkspace:"",BookingsLogo:"",ClassNotebookLogoInverse:"",DelveAnalyticsLogo:"",DocsLogoInverse:"",Dynamics365Logo:"",DynamicSMBLogo:"",OfficeAssistantLogo:"",OfficeStoreLogo:"",OneNoteEduLogoInverse:"",PlannerLogo:"",PowerApps:"",Suitcase:"",ProjectLogoInverse:"",CaretLeft8:"",CaretRight8:"",CaretUp8:"",CaretDown8:"",CaretLeftSolid8:"",CaretRightSolid8:"",CaretUpSolid8:"",CaretDownSolid8:"",ClearFormatting:"",Superscript:"",Subscript:"",Strikethrough:"",Export:"",ExportMirrored:""}};qg(i,e)}function vot(t,e){t===void 0&&(t="");var i={style:{MozOsxFontSmoothing:"grayscale",WebkitFontSmoothing:"antialiased",fontStyle:"normal",fontWeight:"normal",speak:"none"},fontFace:{fontFamily:'"FabricMDL2Icons-7"',src:"url('".concat(t,"fabric-icons-7-2b97bb99.woff') format('woff')")},icons:{SingleBookmark:"",SingleBookmarkSolid:"",DoubleChevronDown:"",FollowUser:"",ReplyAll:"",WorkforceManagement:"",RecruitmentManagement:"",Questionnaire:"",ManagerSelfService:"",ProductionFloorManagement:"",ProductRelease:"",ProductVariant:"",ReplyMirrored:"",ReplyAllMirrored:"",Medal:"",AddGroup:"",QuestionnaireMirrored:"",CloudImportExport:"",TemporaryUser:"",CaretSolid16:"",GroupedDescending:"",GroupedAscending:"",AwayStatus:"",MyMoviesTV:"",GenericScan:"",AustralianRules:"",WifiEthernet:"",TrackersMirrored:"",DateTimeMirrored:"",StopSolid:"",DoubleChevronUp12:"",DoubleChevronDown12:"",DoubleChevronLeft12:"",DoubleChevronRight12:"",CalendarAgenda:"",ConnectVirtualMachine:"",AddEvent:"",AssetLibrary:"",DataConnectionLibrary:"",DocLibrary:"",FormLibrary:"",FormLibraryMirrored:"",ReportLibrary:"",ReportLibraryMirrored:"",ContactCard:"",CustomList:"",CustomListMirrored:"",IssueTracking:"",IssueTrackingMirrored:"",PictureLibrary:"",OfficeAddinsLogo:"",OfflineOneDriveParachute:"",OfflineOneDriveParachuteDisabled:"",TriangleSolidUp12:"",TriangleSolidDown12:"",TriangleSolidLeft12:"",TriangleSolidRight12:"",TriangleUp12:"",TriangleDown12:"",TriangleLeft12:"",TriangleRight12:"",ArrowUpRight8:"",ArrowDownRight8:"",DocumentSet:"",GoToDashboard:"",DelveAnalytics:"",ArrowUpRightMirrored8:"",ArrowDownRightMirrored8:"",CompanyDirectory:"",OpenEnrollment:"",CompanyDirectoryMirrored:"",OneDriveAdd:"",ProfileSearch:"",Header2:"",Header3:"",Header4:"",RingerSolid:"",Eyedropper:"",MarketDown:"",CalendarWorkWeek:"",SidePanel:"",GlobeFavorite:"",CaretTopLeftSolid8:"",CaretTopRightSolid8:"",ViewAll2:"",DocumentReply:"",PlayerSettings:"",ReceiptForward:"",ReceiptReply:"",ReceiptCheck:"",Fax:"",RecurringEvent:"",ReplyAlt:"",ReplyAllAlt:"",EditStyle:"",EditMail:"",Lifesaver:"",LifesaverLock:"",InboxCheck:"",FolderSearch:""}};qg(i,e)}function yot(t,e){t===void 0&&(t="");var i={style:{MozOsxFontSmoothing:"grayscale",WebkitFontSmoothing:"antialiased",fontStyle:"normal",fontWeight:"normal",speak:"none"},fontFace:{fontFamily:'"FabricMDL2Icons-8"',src:"url('".concat(t,"fabric-icons-8-6fdf1528.woff') format('woff')")},icons:{CollapseMenu:"",ExpandMenu:"",Boards:"",SunAdd:"",SunQuestionMark:"",LandscapeOrientation:"",DocumentSearch:"",PublicCalendar:"",PublicContactCard:"",PublicEmail:"",PublicFolder:"",WordDocument:"",PowerPointDocument:"",ExcelDocument:"",GroupedList:"",ClassroomLogo:"",Sections:"",EditPhoto:"",Starburst:"",ShareiOS:"",AirTickets:"",PencilReply:"",Tiles2:"",SkypeCircleCheck:"",SkypeCircleClock:"",SkypeCircleMinus:"",SkypeMessage:"",ClosedCaption:"",ATPLogo:"",OfficeFormsLogoInverse:"",RecycleBin:"",EmptyRecycleBin:"",Hide2:"",Breadcrumb:"",BirthdayCake:"",TimeEntry:"",CRMProcesses:"",PageEdit:"",PageArrowRight:"",PageRemove:"",Database:"",DataManagementSettings:"",CRMServices:"",EditContact:"",ConnectContacts:"",AppIconDefaultAdd:"",AppIconDefaultList:"",ActivateOrders:"",DeactivateOrders:"",ProductCatalog:"",ScatterChart:"",AccountActivity:"",DocumentManagement:"",CRMReport:"",KnowledgeArticle:"",Relationship:"",HomeVerify:"",ZipFolder:"",SurveyQuestions:"",TextDocument:"",TextDocumentShared:"",PageCheckedOut:"",PageShared:"",SaveAndClose:"",Script:"",Archive:"",ActivityFeed:"",Compare:"",EventDate:"",ArrowUpRight:"",CaretRight:"",SetAction:"",ChatBot:"",CaretSolidLeft:"",CaretSolidDown:"",CaretSolidRight:"",CaretSolidUp:"",PowerAppsLogo:"",PowerApps2Logo:"",SearchIssue:"",SearchIssueMirrored:"",FabricAssetLibrary:"",FabricDataConnectionLibrary:"",FabricDocLibrary:"",FabricFormLibrary:"",FabricFormLibraryMirrored:"",FabricReportLibrary:"",FabricReportLibraryMirrored:"",FabricPublicFolder:"",FabricFolderSearch:"",FabricMovetoFolder:"",FabricUnsyncFolder:"",FabricSyncFolder:"",FabricOpenFolderHorizontal:"",FabricFolder:"",FabricFolderFill:"",FabricNewFolder:"",FabricPictureLibrary:"",PhotoVideoMedia:"",AddFavorite:""}};qg(i,e)}function Sot(t,e){t===void 0&&(t="");var i={style:{MozOsxFontSmoothing:"grayscale",WebkitFontSmoothing:"antialiased",fontStyle:"normal",fontWeight:"normal",speak:"none"},fontFace:{fontFamily:'"FabricMDL2Icons-9"',src:"url('".concat(t,"fabric-icons-9-c6162b42.woff') format('woff')")},icons:{AddFavoriteFill:"",BufferTimeBefore:"",BufferTimeAfter:"",BufferTimeBoth:"",PublishContent:"",ClipboardList:"",ClipboardListMirrored:"",CannedChat:"",SkypeForBusinessLogo:"",TabCenter:"",PageCheckedin:"",PageList:"",ReadOutLoud:"",CaretBottomLeftSolid8:"",CaretBottomRightSolid8:"",FolderHorizontal:"",MicrosoftStaffhubLogo:"",GiftboxOpen:"",StatusCircleOuter:"",StatusCircleInner:"",StatusCircleRing:"",StatusTriangleOuter:"",StatusTriangleInner:"",StatusTriangleExclamation:"",StatusCircleExclamation:"",StatusCircleErrorX:"",StatusCircleInfo:"",StatusCircleBlock:"",StatusCircleBlock2:"",StatusCircleQuestionMark:"",StatusCircleSync:"",Toll:"",ExploreContentSingle:"",CollapseContent:"",CollapseContentSingle:"",InfoSolid:"",GroupList:"",ProgressRingDots:"",CaloriesAdd:"",BranchFork:"",MuteChat:"",AddHome:"",AddWork:"",MobileReport:"",ScaleVolume:"",HardDriveGroup:"",FastMode:"",ToggleLeft:"",ToggleRight:"",TriangleShape:"",RectangleShape:"",CubeShape:"",Trophy2:"",BucketColor:"",BucketColorFill:"",Taskboard:"",SingleColumn:"",DoubleColumn:"",TripleColumn:"",ColumnLeftTwoThirds:"",ColumnRightTwoThirds:"",AccessLogoFill:"",AnalyticsLogo:"",AnalyticsQuery:"",NewAnalyticsQuery:"",AnalyticsReport:"",WordLogo:"",WordLogoFill:"",ExcelLogo:"",ExcelLogoFill:"",OneNoteLogo:"",OneNoteLogoFill:"",OutlookLogo:"",OutlookLogoFill:"",PowerPointLogo:"",PowerPointLogoFill:"",PublisherLogo:"",PublisherLogoFill:"",ScheduleEventAction:"",FlameSolid:"",ServerProcesses:"",Server:"",SaveAll:"",LinkedInLogo:"",Decimals:"",SidePanelMirrored:"",ProtectRestrict:"",Blog:"",UnknownMirrored:"",PublicContactCardMirrored:"",GridViewSmall:"",GridViewMedium:"",GridViewLarge:"",Step:"",StepInsert:"",StepShared:"",StepSharedAdd:"",StepSharedInsert:"",ViewDashboard:"",ViewList:""}};qg(i,e)}function bot(t,e){t===void 0&&(t="");var i={style:{MozOsxFontSmoothing:"grayscale",WebkitFontSmoothing:"antialiased",fontStyle:"normal",fontWeight:"normal",speak:"none"},fontFace:{fontFamily:'"FabricMDL2Icons-10"',src:"url('".concat(t,"fabric-icons-10-c4ded8e4.woff') format('woff')")},icons:{ViewListGroup:"",ViewListTree:"",TriggerAuto:"",TriggerUser:"",PivotChart:"",StackedBarChart:"",StackedLineChart:"",BuildQueue:"",BuildQueueNew:"",UserFollowed:"",ContactLink:"",Stack:"",Bullseye:"",VennDiagram:"",FiveTileGrid:"",FocalPoint:"",Insert:"",RingerRemove:"",TeamsLogoInverse:"",TeamsLogo:"",TeamsLogoFill:"",SkypeForBusinessLogoFill:"",SharepointLogo:"",SharepointLogoFill:"",DelveLogo:"",DelveLogoFill:"",OfficeVideoLogo:"",OfficeVideoLogoFill:"",ExchangeLogo:"",ExchangeLogoFill:"",Signin:"",DocumentApproval:"",CloneToDesktop:"",InstallToDrive:"",Blur:"",Build:"",ProcessMetaTask:"",BranchFork2:"",BranchLocked:"",BranchCommit:"",BranchCompare:"",BranchMerge:"",BranchPullRequest:"",BranchSearch:"",BranchShelveset:"",RawSource:"",MergeDuplicate:"",RowsGroup:"",RowsChild:"",Deploy:"",Redeploy:"",ServerEnviroment:"",VisioDiagram:"",HighlightMappedShapes:"",TextCallout:"",IconSetsFlag:"",VisioLogo:"",VisioLogoFill:"",VisioDocument:"",TimelineProgress:"",TimelineDelivery:"",Backlog:"",TeamFavorite:"",TaskGroup:"",TaskGroupMirrored:"",ScopeTemplate:"",AssessmentGroupTemplate:"",NewTeamProject:"",CommentAdd:"",CommentNext:"",CommentPrevious:"",ShopServer:"",LocaleLanguage:"",QueryList:"",UserSync:"",UserPause:"",StreamingOff:"",ArrowTallUpLeft:"",ArrowTallUpRight:"",ArrowTallDownLeft:"",ArrowTallDownRight:"",FieldEmpty:"",FieldFilled:"",FieldChanged:"",FieldNotChanged:"",RingerOff:"",PlayResume:"",BulletedList2:"",BulletedList2Mirrored:"",ImageCrosshair:"",GitGraph:"",Repo:"",RepoSolid:"",FolderQuery:"",FolderList:"",FolderListMirrored:"",LocationOutline:"",POISolid:"",CalculatorNotEqualTo:"",BoxSubtractSolid:""}};qg(i,e)}function Tot(t,e){t===void 0&&(t="");var i={style:{MozOsxFontSmoothing:"grayscale",WebkitFontSmoothing:"antialiased",fontStyle:"normal",fontWeight:"normal",speak:"none"},fontFace:{fontFamily:'"FabricMDL2Icons-11"',src:"url('".concat(t,"fabric-icons-11-2a8393d6.woff') format('woff')")},icons:{BoxAdditionSolid:"",BoxMultiplySolid:"",BoxPlaySolid:"",BoxCheckmarkSolid:"",CirclePauseSolid:"",CirclePause:"",MSNVideosSolid:"",CircleStopSolid:"",CircleStop:"",NavigateBack:"",NavigateBackMirrored:"",NavigateForward:"",NavigateForwardMirrored:"",UnknownSolid:"",UnknownMirroredSolid:"",CircleAddition:"",CircleAdditionSolid:"",FilePDB:"",FileTemplate:"",FileSQL:"",FileJAVA:"",FileASPX:"",FileCSS:"",FileSass:"",FileLess:"",FileHTML:"",JavaScriptLanguage:"",CSharpLanguage:"",CSharp:"",VisualBasicLanguage:"",VB:"",CPlusPlusLanguage:"",CPlusPlus:"",FSharpLanguage:"",FSharp:"",TypeScriptLanguage:"",PythonLanguage:"",PY:"",CoffeeScript:"",MarkDownLanguage:"",FullWidth:"",FullWidthEdit:"",Plug:"",PlugSolid:"",PlugConnected:"",PlugDisconnected:"",UnlockSolid:"",Variable:"",Parameter:"",CommentUrgent:"",Storyboard:"",DiffInline:"",DiffSideBySide:"",ImageDiff:"",ImagePixel:"",FileBug:"",FileCode:"",FileComment:"",BusinessHoursSign:"",FileImage:"",FileSymlink:"",AutoFillTemplate:"",WorkItem:"",WorkItemBug:"",LogRemove:"",ColumnOptions:"",Packages:"",BuildIssue:"",AssessmentGroup:"",VariableGroup:"",FullHistory:"",Wheelchair:"",SingleColumnEdit:"",DoubleColumnEdit:"",TripleColumnEdit:"",ColumnLeftTwoThirdsEdit:"",ColumnRightTwoThirdsEdit:"",StreamLogo:"",PassiveAuthentication:"",AlertSolid:"",MegaphoneSolid:"",TaskSolid:"",ConfigurationSolid:"",BugSolid:"",CrownSolid:"",Trophy2Solid:"",QuickNoteSolid:"",ConstructionConeSolid:"",PageListSolid:"",PageListMirroredSolid:"",StarburstSolid:"",ReadingModeSolid:"",SadSolid:"",HealthSolid:"",ShieldSolid:"",GiftBoxSolid:"",ShoppingCartSolid:"",MailSolid:"",ChatSolid:"",RibbonSolid:""}};qg(i,e)}function Cot(t,e){t===void 0&&(t="");var i={style:{MozOsxFontSmoothing:"grayscale",WebkitFontSmoothing:"antialiased",fontStyle:"normal",fontWeight:"normal",speak:"none"},fontFace:{fontFamily:'"FabricMDL2Icons-12"',src:"url('".concat(t,"fabric-icons-12-7e945a1e.woff') format('woff')")},icons:{FinancialSolid:"",FinancialMirroredSolid:"",HeadsetSolid:"",PermissionsSolid:"",ParkingSolid:"",ParkingMirroredSolid:"",DiamondSolid:"",AsteriskSolid:"",OfflineStorageSolid:"",BankSolid:"",DecisionSolid:"",Parachute:"",ParachuteSolid:"",FiltersSolid:"",ColorSolid:"",ReviewSolid:"",ReviewRequestSolid:"",ReviewRequestMirroredSolid:"",ReviewResponseSolid:"",FeedbackRequestSolid:"",FeedbackRequestMirroredSolid:"",FeedbackResponseSolid:"",WorkItemBar:"",WorkItemBarSolid:"",Separator:"",NavigateExternalInline:"",PlanView:"",TimelineMatrixView:"",EngineeringGroup:"",ProjectCollection:"",CaretBottomRightCenter8:"",CaretBottomLeftCenter8:"",CaretTopRightCenter8:"",CaretTopLeftCenter8:"",DonutChart:"",ChevronUnfold10:"",ChevronFold10:"",DoubleChevronDown8:"",DoubleChevronUp8:"",DoubleChevronLeft8:"",DoubleChevronRight8:"",ChevronDownEnd6:"",ChevronUpEnd6:"",ChevronLeftEnd6:"",ChevronRightEnd6:"",ContextMenu:"",AzureAPIManagement:"",AzureServiceEndpoint:"",VSTSLogo:"",VSTSAltLogo1:"",VSTSAltLogo2:"",FileTypeSolution:"",WordLogoInverse16:"",WordLogo16:"",WordLogoFill16:"",PowerPointLogoInverse16:"",PowerPointLogo16:"",PowerPointLogoFill16:"",ExcelLogoInverse16:"",ExcelLogo16:"",ExcelLogoFill16:"",OneNoteLogoInverse16:"",OneNoteLogo16:"",OneNoteLogoFill16:"",OutlookLogoInverse16:"",OutlookLogo16:"",OutlookLogoFill16:"",PublisherLogoInverse16:"",PublisherLogo16:"",PublisherLogoFill16:"",VisioLogoInverse16:"",VisioLogo16:"",VisioLogoFill16:"",TestBeaker:"",TestBeakerSolid:"",TestExploreSolid:"",TestAutoSolid:"",TestUserSolid:"",TestImpactSolid:"",TestPlan:"",TestStep:"",TestParameter:"",TestSuite:"",TestCase:"",Sprint:"",SignOut:"",TriggerApproval:"",Rocket:"",AzureKeyVault:"",Onboarding:"",Transition:"",LikeSolid:"",DislikeSolid:"",CRMCustomerInsightsApp:"",EditCreate:"",PlayReverseResume:"",PlayReverse:"",SearchData:"",UnSetColor:"",DeclineCall:""}};qg(i,e)}function _ot(t,e){t===void 0&&(t="");var i={style:{MozOsxFontSmoothing:"grayscale",WebkitFontSmoothing:"antialiased",fontStyle:"normal",fontWeight:"normal",speak:"none"},fontFace:{fontFamily:'"FabricMDL2Icons-13"',src:"url('".concat(t,"fabric-icons-13-c3989a02.woff') format('woff')")},icons:{RectangularClipping:"",TeamsLogo16:"",TeamsLogoFill16:"",Spacer:"",SkypeLogo16:"",SkypeForBusinessLogo16:"",SkypeForBusinessLogoFill16:"",FilterSolid:"",MailUndelivered:"",MailTentative:"",MailTentativeMirrored:"",MailReminder:"",ReceiptUndelivered:"",ReceiptTentative:"",ReceiptTentativeMirrored:"",Inbox:"",IRMReply:"",IRMReplyMirrored:"",IRMForward:"",IRMForwardMirrored:"",VoicemailIRM:"",EventAccepted:"",EventTentative:"",EventTentativeMirrored:"",EventDeclined:"",IDBadge:"",BackgroundColor:"",OfficeFormsLogoInverse16:"",OfficeFormsLogo:"",OfficeFormsLogoFill:"",OfficeFormsLogo16:"",OfficeFormsLogoFill16:"",OfficeFormsLogoInverse24:"",OfficeFormsLogo24:"",OfficeFormsLogoFill24:"",PageLock:"",NotExecuted:"",NotImpactedSolid:"",FieldReadOnly:"",FieldRequired:"",BacklogBoard:"",ExternalBuild:"",ExternalTFVC:"",ExternalXAML:"",IssueSolid:"",DefectSolid:"",LadybugSolid:"",NugetLogo:"",TFVCLogo:"",ProjectLogo32:"",ProjectLogoFill32:"",ProjectLogo16:"",ProjectLogoFill16:"",SwayLogo32:"",SwayLogoFill32:"",SwayLogo16:"",SwayLogoFill16:"",ClassNotebookLogo32:"",ClassNotebookLogoFill32:"",ClassNotebookLogo16:"",ClassNotebookLogoFill16:"",ClassNotebookLogoInverse32:"",ClassNotebookLogoInverse16:"",StaffNotebookLogo32:"",StaffNotebookLogoFill32:"",StaffNotebookLogo16:"",StaffNotebookLogoFill16:"",StaffNotebookLogoInverted32:"",StaffNotebookLogoInverted16:"",KaizalaLogo:"",TaskLogo:"",ProtectionCenterLogo32:"",GallatinLogo:"",Globe2:"",Guitar:"",Breakfast:"",Brunch:"",BeerMug:"",Vacation:"",Teeth:"",Taxi:"",Chopsticks:"",SyncOccurence:"",UnsyncOccurence:"",GIF:"",PrimaryCalendar:"",SearchCalendar:"",VideoOff:"",MicrosoftFlowLogo:"",BusinessCenterLogo:"",ToDoLogoBottom:"",ToDoLogoTop:"",EditSolid12:"",EditSolidMirrored12:"",UneditableSolid12:"",UneditableSolidMirrored12:"",UneditableMirrored:"",AdminALogo32:"",AdminALogoFill32:"",ToDoLogoInverse:""}};qg(i,e)}function Eot(t,e){t===void 0&&(t="");var i={style:{MozOsxFontSmoothing:"grayscale",WebkitFontSmoothing:"antialiased",fontStyle:"normal",fontWeight:"normal",speak:"none"},fontFace:{fontFamily:'"FabricMDL2Icons-14"',src:"url('".concat(t,"fabric-icons-14-5cf58db8.woff') format('woff')")},icons:{Snooze:"",WaffleOffice365:"",ImageSearch:"",NewsSearch:"",VideoSearch:"",R:"",FontColorA:"",FontColorSwatch:"",LightWeight:"",NormalWeight:"",SemiboldWeight:"",GroupObject:"",UngroupObject:"",AlignHorizontalLeft:"",AlignHorizontalCenter:"",AlignHorizontalRight:"",AlignVerticalTop:"",AlignVerticalCenter:"",AlignVerticalBottom:"",HorizontalDistributeCenter:"",VerticalDistributeCenter:"",Ellipse:"",Line:"",Octagon:"",Hexagon:"",Pentagon:"",RightTriangle:"",HalfCircle:"",QuarterCircle:"",ThreeQuarterCircle:"","6PointStar":"","12PointStar":"",ArrangeBringToFront:"",ArrangeSendToBack:"",ArrangeSendBackward:"",ArrangeBringForward:"",BorderDash:"",BorderDot:"",LineStyle:"",LineThickness:"",WindowEdit:"",HintText:"",MediaAdd:"",AnchorLock:"",AutoHeight:"",ChartSeries:"",ChartXAngle:"",ChartYAngle:"",Combobox:"",LineSpacing:"",Padding:"",PaddingTop:"",PaddingBottom:"",PaddingLeft:"",PaddingRight:"",NavigationFlipper:"",AlignJustify:"",TextOverflow:"",VisualsFolder:"",VisualsStore:"",PictureCenter:"",PictureFill:"",PicturePosition:"",PictureStretch:"",PictureTile:"",Slider:"",SliderHandleSize:"",DefaultRatio:"",NumberSequence:"",GUID:"",ReportAdd:"",DashboardAdd:"",MapPinSolid:"",WebPublish:"",PieSingleSolid:"",BlockedSolid:"",DrillDown:"",DrillDownSolid:"",DrillExpand:"",DrillShow:"",SpecialEvent:"",OneDriveFolder16:"",FunctionalManagerDashboard:"",BIDashboard:"",CodeEdit:"",RenewalCurrent:"",RenewalFuture:"",SplitObject:"",BulkUpload:"",DownloadDocument:"",GreetingCard:"",Flower:"",WaitlistConfirm:"",WaitlistConfirmMirrored:"",LaptopSecure:"",DragObject:"",EntryView:"",EntryDecline:"",ContactCardSettings:"",ContactCardSettingsMirrored:""}};qg(i,e)}function Aot(t,e){t===void 0&&(t="");var i={style:{MozOsxFontSmoothing:"grayscale",WebkitFontSmoothing:"antialiased",fontStyle:"normal",fontWeight:"normal",speak:"none"},fontFace:{fontFamily:'"FabricMDL2Icons-15"',src:"url('".concat(t,"fabric-icons-15-3807251b.woff') format('woff')")},icons:{CalendarSettings:"",CalendarSettingsMirrored:"",HardDriveLock:"",HardDriveUnlock:"",AccountManagement:"",ReportWarning:"",TransitionPop:"",TransitionPush:"",TransitionEffect:"",LookupEntities:"",ExploreData:"",AddBookmark:"",SearchBookmark:"",DrillThrough:"",MasterDatabase:"",CertifiedDatabase:"",MaximumValue:"",MinimumValue:"",VisualStudioIDELogo32:"",PasteAsText:"",PasteAsCode:"",BrowserTab:"",BrowserTabScreenshot:"",DesktopScreenshot:"",FileYML:"",ClipboardSolid:"",FabricUserFolder:"",FabricNetworkFolder:"",BullseyeTarget:"",AnalyticsView:"",Video360Generic:"",Untag:"",Leave:"",Trending12:"",Blocked12:"",Warning12:"",CheckedOutByOther12:"",CheckedOutByYou12:"",CircleShapeSolid:"",SquareShapeSolid:"",TriangleShapeSolid:"",DropShapeSolid:"",RectangleShapeSolid:"",ZoomToFit:"",InsertColumnsLeft:"",InsertColumnsRight:"",InsertRowsAbove:"",InsertRowsBelow:"",DeleteColumns:"",DeleteRows:"",DeleteRowsMirrored:"",DeleteTable:"",AccountBrowser:"",VersionControlPush:"",StackedColumnChart2:"",TripleColumnWide:"",QuadColumn:"",WhiteBoardApp16:"",WhiteBoardApp32:"",PinnedSolid:"",InsertSignatureLine:"",ArrangeByFrom:"",Phishing:"",CreateMailRule:"",PublishCourse:"",DictionaryRemove:"",UserRemove:"",UserEvent:"",Encryption:"",PasswordField:"",OpenInNewTab:"",Hide3:"",VerifiedBrandSolid:"",MarkAsProtected:"",AuthenticatorApp:"",WebTemplate:"",DefenderTVM:"",MedalSolid:"",D365TalentLearn:"",D365TalentInsight:"",D365TalentHRCore:"",BacklogList:"",ButtonControl:"",TableGroup:"",MountainClimbing:"",TagUnknown:"",TagUnknownMirror:"",TagUnknown12:"",TagUnknown12Mirror:"",Link12:"",Presentation:"",Presentation12:"",Lock12:"",BuildDefinition:"",ReleaseDefinition:"",SaveTemplate:"",UserGauge:"",BlockedSiteSolid12:"",TagSolid:"",OfficeChat:""}};qg(i,e)}function Iot(t,e){t===void 0&&(t="");var i={style:{MozOsxFontSmoothing:"grayscale",WebkitFontSmoothing:"antialiased",fontStyle:"normal",fontWeight:"normal",speak:"none"},fontFace:{fontFamily:'"FabricMDL2Icons-16"',src:"url('".concat(t,"fabric-icons-16-9cf93f3b.woff') format('woff')")},icons:{OfficeChatSolid:"",MailSchedule:"",WarningSolid:"",Blocked2Solid:"",SkypeCircleArrow:"",SkypeArrow:"",SyncStatus:"",SyncStatusSolid:"",ProjectDocument:"",ToDoLogoOutline:"",VisioOnlineLogoFill32:"",VisioOnlineLogo32:"",VisioOnlineLogoCloud32:"",VisioDiagramSync:"",Event12:"",EventDateMissed12:"",UserOptional:"",ResponsesMenu:"",DoubleDownArrow:"",DistributeDown:"",BookmarkReport:"",FilterSettings:"",GripperDotsVertical:"",MailAttached:"",AddIn:"",LinkedDatabase:"",TableLink:"",PromotedDatabase:"",BarChartVerticalFilter:"",BarChartVerticalFilterSolid:"",MicOff2:"",MicrosoftTranslatorLogo:"",ShowTimeAs:"",FileRequest:"",WorkItemAlert:"",PowerBILogo16:"",PowerBILogoBackplate16:"",BulletedListText:"",BulletedListBullet:"",BulletedListTextMirrored:"",BulletedListBulletMirrored:"",NumberedListText:"",NumberedListNumber:"",NumberedListTextMirrored:"",NumberedListNumberMirrored:"",RemoveLinkChain:"",RemoveLinkX:"",FabricTextHighlight:"",ClearFormattingA:"",ClearFormattingEraser:"",Photo2Fill:"",IncreaseIndentText:"",IncreaseIndentArrow:"",DecreaseIndentText:"",DecreaseIndentArrow:"",IncreaseIndentTextMirrored:"",IncreaseIndentArrowMirrored:"",DecreaseIndentTextMirrored:"",DecreaseIndentArrowMirrored:"",CheckListText:"",CheckListCheck:"",CheckListTextMirrored:"",CheckListCheckMirrored:"",NumberSymbol:"",Coupon:"",VerifiedBrand:"",ReleaseGate:"",ReleaseGateCheck:"",ReleaseGateError:"",M365InvoicingLogo:"",RemoveFromShoppingList:"",ShieldAlert:"",FabricTextHighlightComposite:"",Dataflows:"",GenericScanFilled:"",DiagnosticDataBarTooltip:"",SaveToMobile:"",Orientation2:"",ScreenCast:"",ShowGrid:"",SnapToGrid:"",ContactList:"",NewMail:"",EyeShadow:"",FabricFolderConfirm:"",InformationBarriers:"",CommentActive:"",ColumnVerticalSectionEdit:"",WavingHand:"",ShakeDevice:"",SmartGlassRemote:"",Rotate90Clockwise:"",Rotate90CounterClockwise:"",CampaignTemplate:"",ChartTemplate:"",PageListFilter:"",SecondaryNav:"",ColumnVerticalSection:"",SkypeCircleSlash:"",SkypeSlash:""}};qg(i,e)}function wot(t,e){t===void 0&&(t="");var i={style:{MozOsxFontSmoothing:"grayscale",WebkitFontSmoothing:"antialiased",fontStyle:"normal",fontWeight:"normal",speak:"none"},fontFace:{fontFamily:'"FabricMDL2Icons-17"',src:"url('".concat(t,"fabric-icons-17-0c4ed701.woff') format('woff')")},icons:{CustomizeToolbar:"",DuplicateRow:"",RemoveFromTrash:"",MailOptions:"",Childof:"",Footer:"",Header:"",BarChartVerticalFill:"",StackedColumnChart2Fill:"",PlainText:"",AccessibiltyChecker:"",DatabaseSync:"",ReservationOrders:"",TabOneColumn:"",TabTwoColumn:"",TabThreeColumn:"",BulletedTreeList:"",MicrosoftTranslatorLogoGreen:"",MicrosoftTranslatorLogoBlue:"",InternalInvestigation:"",AddReaction:"",ContactHeart:"",VisuallyImpaired:"",EventToDoLogo:"",Variable2:"",ModelingView:"",DisconnectVirtualMachine:"",ReportLock:"",Uneditable2:"",Uneditable2Mirrored:"",BarChartVerticalEdit:"",GlobalNavButtonActive:"",PollResults:"",Rerun:"",QandA:"",QandAMirror:"",BookAnswers:"",AlertSettings:"",TrimStart:"",TrimEnd:"",TableComputed:"",DecreaseIndentLegacy:"",IncreaseIndentLegacy:"",SizeLegacy:""}};qg(i,e)}var kot=function(){nx("trash","delete"),nx("onedrive","onedrivelogo"),nx("alertsolid12","eventdatemissed12"),nx("sixpointstar","6pointstar"),nx("twelvepointstar","12pointstar"),nx("toggleon","toggleleft"),nx("toggleoff","toggleright")};Oae("@fluentui/font-icons-mdl2","8.6.0");var Rot="".concat(Ltt,"/assets/icons/"),l5=Wc();function Mot(t,e){var i,r;t===void 0&&(t=((i=l5?.FabricConfig)===null||i===void 0?void 0:i.iconBaseUrl)||((r=l5?.FabricConfig)===null||r===void 0?void 0:r.fontBaseUrl)||Rot),[cot,dot,uot,hot,pot,got,mot,fot,vot,yot,Sot,bot,Tot,Cot,_ot,Eot,Aot,Iot,wot].forEach(function(o){return o(t,e)}),kot()}var qo;(function(t){t[t.info=0]="info",t[t.error=1]="error",t[t.blocked=2]="blocked",t[t.severeWarning=3]="severeWarning",t[t.success=4]="success",t[t.warning=5]="warning"})(qo||(qo={}));var IL,Pot=(IL={},IL[qo.info]="Info",IL[qo.warning]="Info",IL[qo.error]="ErrorBadge",IL[qo.blocked]="Blocked2",IL[qo.severeWarning]="Warning",IL[qo.success]="Completed",IL),Dot="MessageBar",Lot=fu(),Oot=function(t){switch(t){case qo.blocked:case qo.error:case qo.severeWarning:return"assertive"}return"polite"},Not=function(t){switch(t){case qo.blocked:case qo.error:case qo.severeWarning:return"alert"}return"status"},U0e=$.forwardRef(function(t,e){var i=Tre(!1),r=i[0],o=i[1].toggle,l=yu("MessageBar"),d=t.actions,h=t.className,p=t.children,g=t.overflowButtonAriaLabel,f=t.dismissIconProps,y=t.styles,T=t.theme,C=t.messageBarType,E=C===void 0?qo.info:C,I=t.onDismiss,w=I===void 0?void 0:I,D=t.isMultiline,F=D===void 0?!0:D,x=t.truncated,B=t.dismissButtonAriaLabel,L=t.messageBarIconProps,z=t.role,H=t.delayedRender,j=H===void 0?!0:H,J=t.expandButtonProps,Z=t.onExpandButtonToggled,re=Z===void 0?void 0:Z,ne=t.showExpandButton,le=$.useCallback(function(){o(),re&&re(!r)},[r,re,o]),he=Wl(t,Lu,["className","role"]),Me=Lot(y,{theme:T,messageBarType:E||qo.info,onDismiss:w!==void 0,actions:d!==void 0,truncated:x,isMultiline:F,expandSingleLine:r,className:h}),Le={iconName:r?"DoubleChevronUp":"DoubleChevronDown"},pe=d||w?{"aria-describedby":l,role:"region"}:{},te=d?$.createElement("div",{className:Me.actions},d):null,Se=w?$.createElement(zy,{disabled:!1,className:Me.dismissal,onClick:w,iconProps:f||{iconName:"Clear"},title:B,ariaLabel:B}):null;return $.createElement("div",Rt({ref:e,className:Me.root},pe),$.createElement("div",{className:Me.content},$.createElement("div",{className:Me.iconContainer,"aria-hidden":!0},L?$.createElement(Fr,Rt({},L,{className:wh(Me.icon,L.className)})):$.createElement(Fr,{iconName:Pot[E],className:Me.icon})),$.createElement("div",{className:Me.text,id:l,role:z||Not(E),"aria-live":Oot(E)},$.createElement("span",Rt({className:Me.innerText},he),j?$.createElement(Yae,null,$.createElement("span",null,p)):$.createElement("span",null,p))),(ne||!F&&!te&&x)&&$.createElement("div",{className:Me.expandSingleLine},$.createElement(zy,Rt({disabled:!1,className:Me.expand,onClick:le,iconProps:Le,ariaLabel:g,"aria-expanded":r},J))),!F&&te,!F&&Se&&$.createElement("div",{className:Me.dismissSingleLine},Se),F&&Se),F&&te)});U0e.displayName=Dot;var wL,kL,RL,ML,xot={root:"ms-MessageBar",error:"ms-MessageBar--error",blocked:"ms-MessageBar--blocked",severeWarning:"ms-MessageBar--severeWarning",success:"ms-MessageBar--success",warning:"ms-MessageBar--warning",multiline:"ms-MessageBar-multiline",singleline:"ms-MessageBar-singleline",dismissalSingleLine:"ms-MessageBar-dismissalSingleLine",expandingSingleLine:"ms-MessageBar-expandingSingleLine",content:"ms-MessageBar-content",iconContainer:"ms-MessageBar-icon",text:"ms-MessageBar-text",innerText:"ms-MessageBar-innerText",dismissSingleLine:"ms-MessageBar-dismissSingleLine",expandSingleLine:"ms-MessageBar-expandSingleLine",dismissal:"ms-MessageBar-dismissal",expand:"ms-MessageBar-expand",actions:"ms-MessageBar-actions",actionsSingleline:"ms-MessageBar-actionsSingleLine"},Bot=(wL={},wL[qo.error]="errorBackground",wL[qo.blocked]="errorBackground",wL[qo.success]="successBackground",wL[qo.warning]="warningBackground",wL[qo.severeWarning]="severeWarningBackground",wL[qo.info]="infoBackground",wL),Fot=(kL={},kL[qo.error]="errorIcon",kL[qo.blocked]="errorIcon",kL[qo.success]="successIcon",kL[qo.warning]="warningIcon",kL[qo.severeWarning]="severeWarningIcon",kL[qo.info]="infoIcon",kL),Uot=(RL={},RL[qo.error]="#ff0000",RL[qo.blocked]="#ff0000",RL[qo.success]="#bad80a",RL[qo.warning]="#fff100",RL[qo.severeWarning]="#ff0000",RL[qo.info]="WindowText",RL),zot=(ML={},ML[qo.error]="#e81123",ML[qo.blocked]="#e81123",ML[qo.success]="#107c10",ML[qo.warning]="#966400",ML[qo.severeWarning]="#d83b01",ML[qo.info]="WindowText",ML),Vot=function(t){var e,i,r,o,l,d,h,p,g,f,y,T=t.theme,C=t.className,E=t.onDismiss,I=t.truncated,w=t.isMultiline,D=t.expandSingleLine,F=t.messageBarType,x=F===void 0?qo.info:F,B=T.semanticColors,L=T.fonts,z=Zq(0,Stt),H=eh(xot,T),j={fontSize:CC.xSmall,height:10,lineHeight:"10px",color:B.messageText,selectors:(e={},e[Rn]=Rt(Rt({},uc()),{color:"WindowText"}),e)},J=[vE(T,{inset:1,highContrastStyle:{outlineOffset:"-6px",outline:"1px solid Highlight"},borderColor:"transparent"}),{flexShrink:0,width:32,height:32,padding:"8px 12px",selectors:{"& .ms-Button-icon":j,":hover":{backgroundColor:"transparent"},":active":{backgroundColor:"transparent"}}}];return{root:[H.root,L.medium,x===qo.error&&H.error,x===qo.blocked&&H.blocked,x===qo.severeWarning&&H.severeWarning,x===qo.success&&H.success,x===qo.warning&&H.warning,w?H.multiline:H.singleline,!w&&E&&H.dismissalSingleLine,!w&&I&&H.expandingSingleLine,{background:B[Bot[x]],boxSizing:"border-box",color:B.messageText,minHeight:32,width:"100%",display:"flex",wordBreak:"break-word",selectors:(i={".ms-Link":{color:B.messageLink,selectors:{":hover":{color:B.messageLinkHovered}}}},i[Rn]=Rt(Rt({},uc()),{background:"transparent",border:"1px solid ".concat(Uot[x]),color:"WindowText"}),i[oEe]={border:"1px solid ".concat(zot[x])},i)},w&&{flexDirection:"column"},C],content:[H.content,(r={display:"flex",width:"100%",lineHeight:"normal"},r[z]={display:"grid",gridTemplateColumns:"auto 1fr auto",gridTemplateRows:"1fr auto",gridTemplateAreas:`
            "icon text close"
            "action action action"
          `},r)],iconContainer:[H.iconContainer,(o={fontSize:CC.medium,minWidth:16,minHeight:16,display:"flex",flexShrink:0,margin:"8px 0 8px 12px"},o[z]={gridArea:"icon"},o)],icon:{color:B[Fot[x]],selectors:(l={},l[Rn]=Rt(Rt({},uc()),{color:"WindowText"}),l)},text:[H.text,Rt(Rt({minWidth:0,display:"flex",flexGrow:1,margin:8},L.small),(d={},d[z]={gridArea:"text"},d.selectors=(h={},h[Rn]=Rt({},uc()),h),d)),!E&&{marginRight:12}],innerText:[H.innerText,{lineHeight:16,selectors:{"& span a:last-child":{paddingLeft:4}}},I&&{overflow:"visible",whiteSpace:"pre-wrap"},!w&&{overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"},!w&&!I&&{selectors:(p={},p[z]={overflow:"visible",whiteSpace:"pre-wrap"},p)},D&&{overflow:"visible",whiteSpace:"pre-wrap"}],dismissSingleLine:[H.dismissSingleLine,(g={},g[z]={gridArea:"close"},g)],expandSingleLine:H.expandSingleLine,dismissal:[H.dismissal,J],expand:[H.expand,J],actions:[w?H.actions:H.actionsSingleline,(f={display:"flex",flexGrow:0,flexShrink:0,flexBasis:"auto",flexDirection:"row-reverse",alignItems:"center",margin:"0 12px 0 8px",forcedColorAdjust:"auto",MsHighContrastAdjust:"auto"},f[z]={gridArea:"action",marginRight:8,marginBottom:8},f.selectors={"& button:nth-child(n+2)":(y={marginLeft:8},y[z]={marginBottom:0},y)},f),w&&{marginBottom:8},E&&!w&&{marginRight:0}]}},CW=vu(U0e,Vot,void 0,{scope:"MessageBar"}),$ot=function(t,e){if(typeof ResizeObserver<"u"){var i=new ResizeObserver(e);return Array.isArray(t)?t.forEach(function(d){return i.observe(d)}):i.observe(t),function(){return i.disconnect()}}else{var r=function(){return e(void 0)},o=Wc(Array.isArray(t)?t[0]:t);if(!o)return function(){};var l=o.requestAnimationFrame(r);return o.addEventListener("resize",r,!1),function(){o.cancelAnimationFrame(l),o.removeEventListener("resize",r,!1)}}},Hot=function(t){var e=t.onOverflowItemsChanged,i=t.rtl,r=t.pinnedIndex,o=$.useRef(),l=$.useRef(),d=EEe(function(p){var g=$ot(p,function(f){l.current=f?f[0].contentRect.width:p.clientWidth,o.current&&o.current()});return function(){g(),l.current=void 0}}),h=EEe(function(p){return d(p.parentElement),function(){return d(null)}});return ix(function(){var p=d.current,g=h.current;if(!(!p||!g)){for(var f=[],y=0;y<p.children.length;y++){var T=p.children[y];T instanceof HTMLElement&&T!==g&&f.push(T)}var C=[],E=0;o.current=function(){var B=l.current;if(B!==void 0){for(var L=f.length-1;L>=0;L--){if(C[L]===void 0){var z=i?B-f[L].offsetLeft:f[L].offsetLeft+f[L].offsetWidth;L+1<f.length&&L+1===r&&(E=C[L+1]-z),L===f.length-2&&(E+=g.offsetWidth),C[L]=z+E}if(B>C[L]){w(L+1);return}}w(0)}};var I=f.length,w=function(B){I!==B&&(I=B,e(B,f.map(function(L,z){return{ele:L,isOverflowing:z>=B&&z!==r}})))},D=void 0;if(l.current!==void 0){var F=Wc(p);if(F){var x=F.requestAnimationFrame(o.current);D=function(){return F.cancelAnimationFrame(x)}}}return function(){D&&D(),w(f.length),o.current=void 0}}}),{menuButtonRef:h}},jot="PivotItem",z0e=function(t){mu(e,t);function e(i){var r=t.call(this,i)||this;return Dw(r),fL(jot,i,{linkText:"headerText"}),r}return e.prototype.render=function(){return $.createElement("div",Rt({},Wl(this.props,Nf)),this.props.children)},e}($.Component),Got=fu(),qot="Pivot",Wot=function(t,e,i,r){return t.getTabId?t.getTabId(i,r):e+"-Tab".concat(r)},V0e=function(t,e){var i={links:[],keyToIndexMapping:{},keyToTabIdMapping:{}};return $.Children.forEach($.Children.toArray(t.children),function(r,o){if($0e(r)){var l=r.props,d=l.linkText,h=Mm(l,["linkText"]),p=r.props.itemKey||o.toString();i.links.push(Rt(Rt({headerText:d},h),{itemKey:p})),i.keyToIndexMapping[p]=o,i.keyToTabIdMapping[p]=Wot(t,e,p,o)}else r&&SC("The children of a Pivot component must be of type PivotItem to be rendered.")}),i},$0e=function(t){var e;return $.isValidElement(t)&&((e=t.type)===null||e===void 0?void 0:e.name)===z0e.name},H0e=$.forwardRef(function(t,e){var i=$.useRef(null),r=$.useRef(null),o=yu("Pivot"),l=Z$(t.selectedKey,t.defaultSelectedKey),d=l[0],h=l[1],p=t.componentRef,g=t.theme,f=t.linkSize,y=t.linkFormat,T=t.overflowBehavior,C=t.overflowAriaLabel,E=t.focusZoneProps,I=t.overflowButtonAs,w,D={"aria-label":t["aria-label"],"aria-labelledby":t["aria-labelledby"]},F=Wl(t,Nf,["aria-label","aria-labelledby"]),x=V0e(t,o);$.useImperativeHandle(p,function(){return{focus:function(){var te;(te=i.current)===null||te===void 0||te.focus()}}});var B=function(te){if(!te)return null;var Se=te.itemCount,ce=te.itemIcon,X=te.headerText;return $.createElement("span",{className:w.linkContent},ce!==void 0&&$.createElement("span",{className:w.icon},$.createElement(Fr,{iconName:ce})),X!==void 0&&$.createElement("span",{className:w.text}," ",te.headerText),Se!==void 0&&$.createElement("span",{className:w.count}," (",Se,")"))},L=function(te,Se,ce,X){var ve=Se.itemKey,Te=Se.headerButtonProps,Be=Se.onRenderItemLink,qe=te.keyToTabIdMapping[ve],Ge,tt=ce===ve;Be?Ge=Be(Se,B):Ge=B(Se);var ct=Se.headerText||"";ct+=Se.itemCount?" ("+Se.itemCount+")":"",ct+=Se.itemIcon?" xx":"";var Mt=Se.role&&Se.role!=="tab"?{role:Se.role}:{role:"tab","aria-selected":tt};return $.createElement(Ore,Rt({},Te,Mt,{id:qe,key:ve,className:wh(X,tt&&w.linkIsSelected),onClick:function(ht){return z(ve,ht)},onKeyDown:function(ht){return H(ve,ht)},"aria-label":Se.ariaLabel,name:Se.headerText,keytipProps:Se.keytipProps,"data-content":ct}),Ge)},z=function(te,Se){Se.preventDefault(),j(te,Se)},H=function(te,Se){Se.which===fa.enter&&(Se.preventDefault(),j(te))},j=function(te,Se){var ce;if(h(te),x=V0e(t,o),t.onLinkClick&&x.keyToIndexMapping[te]>=0){var X=x.keyToIndexMapping[te],ve=$.Children.toArray(t.children)[X];$0e(ve)&&t.onLinkClick(ve,Se)}(ce=r.current)===null||ce===void 0||ce.dismissMenu()},J=function(te,Se){if(t.headersOnly||!te)return null;var ce=x.keyToIndexMapping[te],X=x.keyToTabIdMapping[te];return $.createElement("div",{role:"tabpanel",hidden:!Se,key:te,"aria-hidden":!Se,"aria-labelledby":X,className:w.itemContainer},$.Children.toArray(t.children)[ce])},Z=function(te){return te===null||te!==void 0&&x.keyToIndexMapping[te]!==void 0},re=function(){if(Z(d))return d;if(x.links.length)return x.links[0].itemKey};w=Got(t.styles,{theme:g,linkSize:f,linkFormat:y});var ne=re(),le=ne?x.keyToIndexMapping[ne]:0,he=x.links.map(function(te){return L(x,te,ne,w.link)}),Me=$.useMemo(function(){return{items:[],alignTargetEdge:!0,directionalHint:hd.bottomRightEdge}},[]),Le=Hot({onOverflowItemsChanged:function(te,Se){Se.forEach(function(ce){var X=ce.ele,ve=ce.isOverflowing;return X.dataset.isOverflowing="".concat(ve)}),Me.items=x.links.slice(te).filter(function(ce){return ce.itemKey!==ne}).map(function(ce,X){return ce.role="menuitem",{key:ce.itemKey||"".concat(te+X),onRender:function(){return L(x,ce,ne,w.linkInMenu)}}})},rtl:Of(g),pinnedIndex:le}).menuButtonRef,pe=I||Ore;return $.createElement("div",Rt({ref:e},F),$.createElement(hA,Rt({componentRef:i,role:"tablist"},D,{direction:Lm.horizontal},E,{className:wh(w.root,E?.className)}),he,T==="menu"&&$.createElement(pe,{className:wh(w.link,w.overflowMenuButton),elementRef:Le,componentRef:r,menuProps:Me,menuIconProps:{iconName:"More",style:{color:"inherit"}},ariaLabel:C,role:"tab"})),ne&&x.links.map(function(te){return(te.alwaysRender===!0||ne===te.itemKey)&&J(te.itemKey,ne===te.itemKey)}))});H0e.displayName=qot;var Kot={count:"ms-Pivot-count",icon:"ms-Pivot-icon",linkIsSelected:"is-selected",link:"ms-Pivot-link",linkContent:"ms-Pivot-linkContent",root:"ms-Pivot",rootIsLarge:"ms-Pivot--large",rootIsTabs:"ms-Pivot--tabs",text:"ms-Pivot-text",linkInMenu:"ms-Pivot-linkInMenu",overflowMenuButton:"ms-Pivot-overflowMenuButton"},j0e=function(t,e,i){var r,o,l;i===void 0&&(i=!1);var d=t.linkSize,h=t.linkFormat,p=t.theme,g=p.semanticColors,f=p.fonts,y=d==="large",T=h==="tabs";return[f.medium,{color:g.actionLink,padding:"0 8px",position:"relative",backgroundColor:"transparent",border:0,borderRadius:0,selectors:{":hover":{backgroundColor:g.buttonBackgroundHovered,color:g.buttonTextHovered,cursor:"pointer"},":active":{backgroundColor:g.buttonBackgroundPressed,color:g.buttonTextHovered},":focus":{outline:"none"}}},!i&&[{display:"inline-block",lineHeight:44,height:44,marginRight:8,textAlign:"center",selectors:(r={},r[".".concat(ys," &:focus, :host(.").concat(ys,") &:focus")]={outline:"1px solid ".concat(g.focusBorder)},r[".".concat(ys," &:focus:after, :host(.").concat(ys,") &:focus:after")]={content:"attr(data-content)",position:"relative",border:0},r[":before"]={backgroundColor:"transparent",bottom:0,content:'""',height:2,left:8,position:"absolute",right:8,transition:"left ".concat(SL.durationValue2," ").concat(SL.easeFunction2,`,
                        right `).concat(SL.durationValue2," ").concat(SL.easeFunction2)},r[":after"]={color:"transparent",content:"attr(data-content)",display:"block",fontWeight:xs.bold,height:1,overflow:"hidden",visibility:"hidden"},r)},y&&{fontSize:f.large.fontSize},T&&[{marginRight:0,height:44,lineHeight:44,backgroundColor:g.buttonBackground,padding:"0 10px",verticalAlign:"top",selectors:(o={":focus":{outlineOffset:"-2px"}},o[".".concat(ys," &:focus::before, :host(.").concat(ys,") &:focus::before")]={height:"auto",background:"transparent",transition:"none"},o["&:hover, &:focus"]={color:g.buttonTextCheckedHovered},o["&:active, &:hover"]={color:g.primaryButtonText,backgroundColor:g.primaryButtonBackground},o["&.".concat(e.linkIsSelected)]={backgroundColor:g.primaryButtonBackground,color:g.primaryButtonText,fontWeight:xs.regular,selectors:(l={":before":{backgroundColor:"transparent",transition:"none",position:"absolute",top:0,left:0,right:0,bottom:0,content:'""',height:0},":hover":{backgroundColor:g.primaryButtonBackgroundHovered,color:g.primaryButtonText},":active":{backgroundColor:g.primaryButtonBackgroundPressed,color:g.primaryButtonText}},l[Rn]=Rt({fontWeight:xs.semibold,color:"HighlightText",background:"Highlight"},uc()),l)},o[".".concat(ys," &.").concat(e.linkIsSelected,":focus, :host(.").concat(ys,") &.").concat(e.linkIsSelected,":focus")]={outlineColor:g.primaryButtonText},o)}]]]},Jot=function(t){var e,i,r,o,l=t.className,d=t.linkSize,h=t.linkFormat,p=t.theme,g=p.semanticColors,f=p.fonts,y=eh(Kot,p),T=d==="large",C=h==="tabs";return{root:[y.root,f.medium,sx,{position:"relative",color:g.link,whiteSpace:"nowrap"},T&&y.rootIsLarge,C&&y.rootIsTabs,l],itemContainer:{selectors:{"&[hidden]":{display:"none"}}},link:Gd(Gd([y.link],j0e(t,y),!0),[(e={},e["&[data-is-overflowing='true']"]={display:"none"},e)],!1),overflowMenuButton:[y.overflowMenuButton,(i={visibility:"hidden",position:"absolute",right:0},i[".".concat(y.link,"[data-is-overflowing='true'] ~ &")]={visibility:"visible",position:"relative"},i)],linkInMenu:Gd(Gd([y.linkInMenu],j0e(t,y,!0),!0),[{justifyContent:"start",height:36,lineHeight:36,width:"100%"}],!1),linkIsSelected:[y.link,y.linkIsSelected,{fontWeight:xs.semibold,selectors:(r={":before":{backgroundColor:g.inputBackgroundChecked,selectors:(o={},o[Rn]={backgroundColor:"Highlight"},o)},":hover::before":{left:0,right:0}},r[Rn]={color:"Highlight"},r)}],linkContent:[y.linkContent,{flex:"0 1 100%",selectors:{"& > * ":{marginLeft:4},"& > *:first-child":{marginLeft:0}}}],text:[y.text,{display:"inline-block",verticalAlign:"top"}],count:[y.count,{display:"inline-block",verticalAlign:"top"}],icon:y.icon}},Yot=vu(H0e,Jot,void 0,{scope:"Pivot"}),Qot={root:"ms-RatingStar-root",rootIsSmall:"ms-RatingStar-root--small",rootIsLarge:"ms-RatingStar-root--large",ratingStar:"ms-RatingStar-container",ratingStarBack:"ms-RatingStar-back",ratingStarFront:"ms-RatingStar-front",ratingButton:"ms-Rating-button",ratingStarIsSmall:"ms-Rating--small",ratingStartIsLarge:"ms-Rating--large",labelText:"ms-Rating-labelText",ratingFocusZone:"ms-Rating-focuszone"};function uH(t,e){var i;return{color:t,selectors:(i={},i[Rn]={color:e},i)}}function Zot(t){var e=t.disabled,i=t.readOnly,r=t.theme,o=r.semanticColors,l=r.palette,d=eh(Qot,r),h=16,p=20,g=8,f=2,y=l.neutralSecondary,T=l.themePrimary,C=l.themeDark,E=l.neutralPrimary,I=o.disabledBodySubtext;return{root:[d.root,r.fonts.medium,!e&&!i&&{selectors:{"&:hover":{selectors:{".ms-RatingStar-back":uH(E,"Highlight")}}}}],rootIsSmall:[d.rootIsSmall,{height:h+g*2+"px"}],rootIsLarge:[d.rootIsLarge,{height:p+g*2+"px"}],ratingStar:[d.ratingStar,{display:"inline-block",position:"relative",height:"inherit"}],ratingStarBack:[d.ratingStarBack,{color:y,width:"100%"},e&&uH(I,"GrayText")],ratingStarFront:[d.ratingStarFront,{position:"absolute",height:"100 %",left:"0",top:"0",textAlign:"center",verticalAlign:"middle",overflow:"hidden"},uH(E,"Highlight")],ratingButton:[vE(r),d.ratingButton,{backgroundColor:"transparent",padding:"".concat(g,"px ").concat(f,"px"),boxSizing:"content-box",margin:"0px",border:"none",cursor:"pointer",selectors:{"&:disabled":{cursor:"default"},"&[disabled]":{cursor:"default"}}},!e&&!i&&{selectors:{"&:hover ~ .ms-Rating-button":{selectors:{".ms-RatingStar-back":uH(y,"WindowText"),".ms-RatingStar-front":uH(y,"WindowText")}},"&:hover":{selectors:{".ms-RatingStar-back":{color:T},".ms-RatingStar-front":{color:C}}}}},e&&{cursor:"default"}],ratingStarIsSmall:[d.ratingStarIsSmall,{fontSize:h+"px",lineHeight:h+"px",height:h+"px"}],ratingStarIsLarge:[d.ratingStartIsLarge,{fontSize:p+"px",lineHeight:p+"px",height:p+"px"}],labelText:[d.labelText,W$],ratingFocusZone:[vE(r),d.ratingFocusZone,{display:"inline-block"}]}}var hH;(function(t){t[t.Small=0]="Small",t[t.Large=1]="Large"})(hH||(hH={}));var Xot=fu(),est=function(t){return $.createElement("div",{className:t.classNames.ratingStar},$.createElement(Fr,{className:t.classNames.ratingStarBack,iconName:t.fillPercentage===0||t.fillPercentage===100?t.icon:t.unselectedIcon}),!t.disabled&&$.createElement(Fr,{className:t.classNames.ratingStarFront,iconName:t.icon,style:{width:t.fillPercentage+"%"}}))},tst=function(t,e){$.useImperativeHandle(t,function(){return{rating:e}},[e])},ist=function(t){process.env.NODE_ENV!=="production"&&CM({name:"Rating",props:t,controlledUsage:{valueProp:"rating",defaultValueProp:"defaultRating",onChangeProp:"onChange",readOnlyProp:"readOnly"}})},nst=function(t,e,i){return Math.min(Math.max(t??e,e),i)},ast=function(t,e){var i=Math.ceil(e),r=100;return t===e?r=100:t===i?r=100*(e%1):t>i&&(r=0),r},G0e=function(t,e){return"".concat(t,"-star-").concat(e-1)},q0e=$.forwardRef(function(t,e){var i=yu("Rating"),r=yu("RatingLabel"),o=t.ariaLabel,l=t.ariaLabelFormat,d=t.disabled,h=t.getAriaLabel,p=t.styles,g=t.min,f=g===void 0?t.allowZeroStars?0:1:g,y=t.max,T=y===void 0?5:y,C=t.readOnly,E=t.size,I=t.theme,w=t.icon,D=w===void 0?"FavoriteStarFill":w,F=t.unselectedIcon,x=F===void 0?"FavoriteStar":F,B=t.onRenderStar,L=Math.max(f,0),z=Z$(t.rating,t.defaultRating,t.onChange),H=z[0],j=z[1],J=nst(H,L,T);ist(t),tst(t.componentRef,J);var Z=$.useRef(null),re=Ff(Z,e);j$(Z);for(var ne=Wl(t,Nf),le=Xot(p,{disabled:d,readOnly:C,theme:I}),he=h?.(J,T),Me=o||he,Le=[],pe=function(X,ve){return ve?ve(X):$.createElement(est,Rt({},X))},te=function(X){var ve=ast(X,J),Te=function(qe){(H===void 0||Math.ceil(H)!==X)&&j(X,qe)},Be=function(qe){var Ge=qe.which,tt=X;switch(Ge){case fa.right:case fa.down:tt=Math.min(T,tt+1);break;case fa.left:case fa.up:tt=Math.max(1,tt-1);break;case fa.home:case fa.pageUp:tt=1;break;case fa.end:case fa.pageDown:tt=T;break}tt!==X&&(H===void 0||Math.ceil(H)!==tt)&&j(tt,qe)};Le.push($.createElement("button",Rt({className:wh(le.ratingButton,E===hH.Large?le.ratingStarIsLarge:le.ratingStarIsSmall),id:G0e(i,X),key:X},X===Math.ceil(J)&&{"data-is-current":!0},{onKeyDown:Be,onClick:Te,disabled:!!(d||C),role:"radio","aria-hidden":C?"true":void 0,type:"button","aria-checked":X===Math.ceil(J)}),$.createElement("span",{id:"".concat(r,"-").concat(X),className:le.labelText},_et(l||"",X,T)),pe({fillPercentage:ve,disabled:d,classNames:le,icon:ve>0?D:x,starNum:X,unselectedIcon:x},B)))},Se=1;Se<=T;Se++)te(Se);var ce=E===hH.Large?le.rootIsLarge:le.rootIsSmall;return $.createElement("div",Rt({ref:re,className:wh("ms-Rating-star",le.root,ce),"aria-label":C?void 0:Me,id:i,role:C?void 0:"radiogroup"},ne),$.createElement(hA,Rt({direction:Lm.bidirectional,className:wh(le.ratingFocusZone,ce),defaultActiveElement:"#"+G0e(i,Math.ceil(J))},C&&{allowFocusRoot:!0,disabled:!0,role:"textbox","aria-label":he,"aria-readonly":!0,"data-is-focusable":!0,tabIndex:0}),Le))});q0e.displayName="RatingBase";var rst=vu(q0e,Zot,void 0,{scope:"Rating"}),Yre=Rt;function pH(t,e){for(var i=[],r=2;r<arguments.length;r++)i[r-2]=arguments[r];var o=t;return o.isSlot?(i=$.Children.toArray(i),i.length===0?o(e):o(Rt(Rt({},e),{children:i}))):$.createElement.apply(vM,Gd([t,e],i,!1))}function W0e(t,e){e===void 0&&(e={});var i=e.defaultProp,r=i===void 0?"children":i,o=function(l,d,h,p,g){if($.isValidElement(d))return d;var f=sst(r,d),y=lst(p,g,l,f);if(h){if(h.component){var T=h.component;return $.createElement(T,Rt({},y))}if(h.render)return h.render(y,t)}return $.createElement(t,Rt({},y))};return o}var ost=ql(function(t){return W0e(t)});function Qre(t,e){var i={},r=t,o=function(d){if(e.hasOwnProperty(d)){var h=function(p){for(var g=[],f=1;f<arguments.length;f++)g[f-1]=arguments[f];if(g.length>0)throw new Error("Any module using getSlots must use withSlots. Please see withSlots javadoc for more info.");return cst(e[d],p,r[d],r.slots&&r.slots[d],r._defaultStyles&&r._defaultStyles[d],r.theme)};h.isSlot=!0,i[d]=h}};for(var l in e)o(l);return i}function sst(t,e){var i,r;return typeof e=="string"||typeof e=="number"||typeof e=="boolean"?r=(i={},i[t]=e,i):r=e,r}function lst(t,e){for(var i=[],r=2;r<arguments.length;r++)i[r-2]=arguments[r];for(var o={},l=[],d=0,h=i;d<h.length;d++){var p=h[d];l.push(p&&p.className),Yre(o,p)}return o.className=d_e([t,l],{rtl:Of(e)}),o}function cst(t,e,i,r,o,l){return t.create!==void 0?t.create(e,i,r,o):ost(t)(e,i,r,o,l)}function Zre(t,e){e===void 0&&(e={});var i=e.factoryOptions,r=i===void 0?{}:i,o=r.defaultProp,l=function(d){var h=ust(e.displayName,$.useContext(zU),e.fields),p=e.state;p&&(d=Rt(Rt({},d),p(d)));var g=d.theme||h.theme,f=K0e(d,g,e.tokens,h.tokens,d.tokens),y=dst(d,g,f,e.styles,h.styles,d.styles),T=Rt(Rt({},d),{styles:y,tokens:f,_defaultStyles:y,theme:g});return t(T)};return l.displayName=e.displayName||t.name,o&&(l.create=W0e(l,{defaultProp:o})),Yre(l,e.statics),l}function dst(t,e,i){for(var r=[],o=3;o<arguments.length;o++)r[o-3]=arguments[o];return Ds.apply(void 0,r.map(function(l){return typeof l=="function"?l(t,e,i):l}))}function K0e(t,e){for(var i=[],r=2;r<arguments.length;r++)i[r-2]=arguments[r];for(var o={},l=0,d=i;l<d.length;l++){var h=d[l];h&&(h=typeof h=="function"?h(t,e):h,Array.isArray(h)&&(h=K0e.apply(void 0,Gd([t,e],h,!1))),Yre(o,h))}return o}function ust(t,e,i){var r=["theme","styles","tokens"];return fE.getSettings(i||r,t,e.customizations)}var J0e={root:"ms-StackItem"},hst={start:"flex-start",end:"flex-end"},pst=function(t,e,i){var r=t.grow,o=t.shrink,l=t.disableShrink,d=t.align,h=t.verticalFill,p=t.order,g=t.className,f=t.basis,y=f===void 0?"auto":f,T=eh(J0e,e);return{root:[e.fonts.medium,T.root,{flexBasis:y,margin:i.margin,padding:i.padding,height:h?"100%":"auto",width:"auto"},r&&{flexGrow:r===!0?1:r},(l||!r&&!o)&&{flexShrink:0},o&&!l&&{flexShrink:1},d&&{alignSelf:hst[d]||d},p&&{order:p},g]}},gst=function(t){var e=t.children,i=Wl(t,Lu);if(e==null)return null;var r=Qre(t,{root:"div"});return pH(r.root,Rt({},i),e)},Y0e=Zre(gst,{displayName:"StackItem",styles:pst}),c5=function(t,e){return e.spacing.hasOwnProperty(t)?e.spacing[t]:t},Xre=function(t){var e=parseFloat(t),i=isNaN(e)?0:e,r=isNaN(e)?"":e.toString(),o=t.substring(r.toString().length);return{value:i,unit:o||"px"}},mst=function(t,e){if(t===void 0||t==="")return{rowGap:{value:0,unit:"px"},columnGap:{value:0,unit:"px"}};if(typeof t=="number")return{rowGap:{value:t,unit:"px"},columnGap:{value:t,unit:"px"}};var i=t.split(" ");if(i.length>2)return{rowGap:{value:0,unit:"px"},columnGap:{value:0,unit:"px"}};if(i.length===2)return{rowGap:Xre(c5(i[0],e)),columnGap:Xre(c5(i[1],e))};var r=Xre(c5(t,e));return{rowGap:r,columnGap:r}},Q0e=function(t,e){if(t===void 0||typeof t=="number"||t==="")return t;var i=t.split(" ");return i.length<2?c5(t,e):i.reduce(function(r,o){return c5(r,e)+" "+c5(o,e)})},d5={start:"flex-start",end:"flex-end"},eoe={root:"ms-Stack",inner:"ms-Stack-inner",child:"ms-Stack-child"},fst=function(t,e,i){var r,o,l,d,h,p,g,f,y,T,C,E,I,w=t.className,D=t.disableShrink,F=t.enableScopedSelectors,x=t.grow,B=t.horizontal,L=t.horizontalAlign,z=t.reversed,H=t.verticalAlign,j=t.verticalFill,J=t.wrap,Z=eh(eoe,e),re=i&&i.childrenGap?i.childrenGap:t.gap,ne=i&&i.maxHeight?i.maxHeight:t.maxHeight,le=i&&i.maxWidth?i.maxWidth:t.maxWidth,he=i&&i.padding?i.padding:t.padding,Me=mst(re,e),Le=Me.rowGap,pe=Me.columnGap,te="".concat(-.5*pe.value).concat(pe.unit),Se="".concat(-.5*Le.value).concat(Le.unit),ce={textOverflow:"ellipsis"},X="> "+(F?"."+eoe.child:"*"),ve=(r={},r["".concat(X,":not(.").concat(J0e.root,")")]={flexShrink:0},r);return J?{root:[Z.root,{flexWrap:"wrap",maxWidth:le,maxHeight:ne,width:"auto",overflow:"visible",height:"100%"},L&&(o={},o[B?"justifyContent":"alignItems"]=d5[L]||L,o),H&&(l={},l[B?"alignItems":"justifyContent"]=d5[H]||H,l),w,{display:"flex"},B&&{height:j?"100%":"auto"}],inner:[Z.inner,(d={display:"flex",flexWrap:"wrap",marginLeft:te,marginRight:te,marginTop:Se,marginBottom:Se,overflow:"visible",boxSizing:"border-box",padding:Q0e(he,e),width:pe.value===0?"100%":"calc(100% + ".concat(pe.value).concat(pe.unit,")"),maxWidth:"100vw"},d[X]=Rt({margin:"".concat(.5*Le.value).concat(Le.unit," ").concat(.5*pe.value).concat(pe.unit)},ce),d),D&&ve,L&&(h={},h[B?"justifyContent":"alignItems"]=d5[L]||L,h),H&&(p={},p[B?"alignItems":"justifyContent"]=d5[H]||H,p),B&&(g={flexDirection:z?"row-reverse":"row",height:Le.value===0?"100%":"calc(100% + ".concat(Le.value).concat(Le.unit,")")},g[X]={maxWidth:pe.value===0?"100%":"calc(100% - ".concat(pe.value).concat(pe.unit,")")},g),!B&&(f={flexDirection:z?"column-reverse":"column",height:"calc(100% + ".concat(Le.value).concat(Le.unit,")")},f[X]={maxHeight:Le.value===0?"100%":"calc(100% - ".concat(Le.value).concat(Le.unit,")")},f)]}:{root:[Z.root,(y={display:"flex",flexDirection:B?z?"row-reverse":"row":z?"column-reverse":"column",flexWrap:"nowrap",width:"auto",height:j?"100%":"auto",maxWidth:le,maxHeight:ne,padding:Q0e(he,e),boxSizing:"border-box"},y[X]=ce,y),D&&ve,x&&{flexGrow:x===!0?1:x},L&&(T={},T[B?"justifyContent":"alignItems"]=d5[L]||L,T),H&&(C={},C[B?"alignItems":"justifyContent"]=d5[H]||H,C),B&&pe.value>0&&(E={},E[z?"".concat(X,":not(:last-child)"):"".concat(X,":not(:first-child)")]={marginLeft:"".concat(pe.value).concat(pe.unit)},E),!B&&Le.value>0&&(I={},I[z?"".concat(X,":not(:last-child)"):"".concat(X,":not(:first-child)")]={marginTop:"".concat(Le.value).concat(Le.unit)},I),w]}},vst=function(t){var e=t.as,i=e===void 0?"div":e,r=t.disableShrink,o=r===void 0?!1:r,l=t.doNotRenderFalsyValues,d=l===void 0?!1:l,h=t.enableScopedSelectors,p=h===void 0?!1:h,g=t.wrap,f=Mm(t,["as","disableShrink","doNotRenderFalsyValues","enableScopedSelectors","wrap"]);fL("Stack",t,{gap:"tokens.childrenGap",maxHeight:"tokens.maxHeight",maxWidth:"tokens.maxWidth",padding:"tokens.padding"});var y=yu("stack-inner"),T=Z0e(t.children,{disableShrink:o,enableScopedSelectors:p,doNotRenderFalsyValues:d}),C=Wl(f,Lu),E=Qre(t,{root:i,inner:"div"});return g?pH(E.root,Rt({},C),pH(E.inner,{key:y},T)):pH(E.root,Rt({},C),T)};function Z0e(t,e){var i=e.disableShrink,r=e.enableScopedSelectors,o=e.doNotRenderFalsyValues,l=$.Children.toArray(t);return l=$.Children.map(l,function(d){if(!d)return o?null:d;if(!$.isValidElement(d))return d;if(d.type===$.Fragment)return d.props.children?Z0e(d.props.children,{disableShrink:i,enableScopedSelectors:r,doNotRenderFalsyValues:o}):null;var h=d,p={};yst(d)&&(p={shrink:!i});var g=h.props.className;return $.cloneElement(h,Rt(Rt(Rt(Rt({},p),h.props),g&&{className:g}),r&&{className:wh(eoe.child,g)}))}),l}function yst(t){return!!t&&typeof t=="object"&&!!t.type&&t.type.displayName===Y0e.displayName}var Sst={Item:Y0e},Et=Zre(vst,{displayName:"Stack",styles:fst,statics:Sst}),bst=function(t){if(t.children==null)return null;t.block,t.className;var e=t.as,i=e===void 0?"span":e;t.variant,t.nowrap;var r=Mm(t,["block","className","as","variant","nowrap"]),o=Qre(t,{root:i});return pH(o.root,Rt({},Wl(r,Lu)))},Tst=function(t,e){var i=t.as,r=t.className,o=t.block,l=t.nowrap,d=t.variant,h=e.fonts,p=e.semanticColors,g=h[d||"medium"];return{root:[g,{color:g.color||p.bodyText,display:o?i==="td"?"table-cell":"block":"inline",mozOsxFontSmoothing:g.MozOsxFontSmoothing,webkitFontSmoothing:g.WebkitFontSmoothing},l&&{whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"},r]}},ja=Zre(bst,{displayName:"Text",styles:Tst}),Cst=fu(),toe="Toggle",X0e=$.forwardRef(function(t,e){var i=t.as,r=i===void 0?"div":i,o=t.ariaLabel,l=t.checked,d=t.className,h=t.defaultChecked,p=h===void 0?!1:h,g=t.disabled,f=t.inlineLabel,y=t.label,T=t.offAriaLabel,C=t.offText,E=t.onAriaLabel,I=t.onChange,w=t.onChanged,D=t.onClick,F=t.onText,x=t.role,B=t.styles,L=t.theme,z=Z$(l,p,$.useCallback(function(ce,X){I?.(ce,X),w?.(X)},[I,w])),H=z[0],j=z[1],J=Cst(B,{theme:L,className:d,disabled:g,checked:H,inlineLabel:f,onOffMissing:!F&&!C}),Z=H?E:T,re=yu(toe,t.id),ne="".concat(re,"-label"),le="".concat(re,"-stateText"),he=H?F:C,Me=Wl(t,sre,["defaultChecked"]),Le=void 0;!o&&!Z&&(y&&(Le=ne),he&&!Le&&(Le=le));var pe=$.useRef(null);j$(pe),_st(t,H,pe),process.env.NODE_ENV!=="production"&&CM({name:toe,props:t,deprecations:{offAriaLabel:void 0,onAriaLabel:"ariaLabel",onChanged:"onChange"},mutuallyExclusive:{checked:"defaultChecked"}});var te=function(ce){g||(j(!H,ce),D&&D(ce))},Se={root:{className:J.root,hidden:Me.hidden},label:{children:y,className:J.label,htmlFor:re,id:ne},container:{className:J.container},pill:Rt(Rt({},Me),{"aria-disabled":g,"aria-checked":H,"aria-label":o||Z,"aria-labelledby":Le,className:J.pill,"data-is-focusable":!0,"data-ktp-target":!0,disabled:g,id:re,onClick:te,ref:pe,role:x||"switch",type:"button"}),thumb:{className:J.thumb},stateText:{children:he,className:J.text,htmlFor:re,id:le}};return $.createElement(r,Rt({ref:e},Se.root),y&&$.createElement(px,Rt({},Se.label)),$.createElement("div",Rt({},Se.container),$.createElement("button",Rt({},Se.pill),$.createElement("span",Rt({},Se.thumb))),(H&&F||C)&&$.createElement(px,Rt({},Se.stateText))))});X0e.displayName=toe+"Base";var _st=function(t,e,i){$.useImperativeHandle(t.componentRef,function(){return{get checked(){return!!e},focus:function(){i.current&&i.current.focus()}}},[e,i])},Est=40,eAe=20,ioe=12,Ast=function(t){var e,i,r,o,l,d,h,p=t.theme,g=t.className,f=t.disabled,y=t.checked,T=t.inlineLabel,C=t.onOffMissing,E=p.semanticColors,I=p.palette,w=E.bodyBackground,D=E.inputBackgroundChecked,F=E.inputBackgroundCheckedHovered,x=I.neutralDark,B=E.disabledBodySubtext,L=E.smallInputBorder,z=E.inputForegroundChecked,H=E.disabledBodySubtext,j=E.disabledBackground,J=E.smallInputBorder,Z=E.inputBorderHovered,re=E.disabledBodySubtext,ne=E.disabledText;return{root:["ms-Toggle",y&&"is-checked",!f&&"is-enabled",f&&"is-disabled",p.fonts.medium,{marginBottom:"8px"},T&&{display:"flex",alignItems:"center"},g],label:["ms-Toggle-label",{display:"inline-block"},f&&{color:ne,selectors:(e={},e[Rn]={color:"GrayText"},e)},T&&!C&&{marginRight:16},C&&T&&{order:1,marginLeft:16},T&&{wordBreak:"break-word"}],container:["ms-Toggle-innerContainer",{display:"flex",position:"relative"}],pill:["ms-Toggle-background",vE(p,{inset:-3}),{fontSize:"20px",boxSizing:"border-box",width:Est,height:eAe,borderRadius:eAe/2,transition:"all 0.1s ease",border:"1px solid ".concat(J),background:w,cursor:"pointer",display:"flex",alignItems:"center",padding:"0 3px",overflow:"visible"},!f&&[!y&&{selectors:{":hover":[{borderColor:Z}],":hover .ms-Toggle-thumb":[{backgroundColor:x,selectors:(i={},i[Rn]={borderColor:"Highlight"},i)}]}},y&&[{background:D,borderColor:"transparent",justifyContent:"flex-end"},{selectors:(r={":hover":[{backgroundColor:F,borderColor:"transparent",selectors:(o={},o[Rn]={backgroundColor:"Highlight"},o)}]},r[Rn]=Rt({backgroundColor:"Highlight"},uc()),r)}]],f&&[{cursor:"default"},!y&&[{borderColor:re}],y&&[{backgroundColor:B,borderColor:"transparent",justifyContent:"flex-end"}]],!f&&{selectors:{"&:hover":{selectors:(l={},l[Rn]={borderColor:"Highlight"},l)}}}],thumb:["ms-Toggle-thumb",{display:"block",width:ioe,height:ioe,borderRadius:"50%",transition:"all 0.1s ease",backgroundColor:L,borderColor:"transparent",borderWidth:ioe/2,borderStyle:"solid",boxSizing:"border-box"},!f&&y&&[{backgroundColor:z,selectors:(d={},d[Rn]={backgroundColor:"Window",borderColor:"Window"},d)}],f&&[!y&&[{backgroundColor:H}],y&&[{backgroundColor:j}]]],text:["ms-Toggle-stateText",{selectors:{"&&":{padding:"0",margin:"0 8px",userSelect:"none",fontWeight:xs.regular}}},f&&{selectors:{"&&":{color:ne,selectors:(h={},h[Rn]={color:"GrayText"},h)}}}]}},tAe=vu(X0e,Ast,void 0,{scope:"Toggle"}),iAe=$.createContext(void 0);function Ist(){return N_e(["theme"]).theme}var hc=function(){var t=$.useContext(iAe),e=Ist();return t||e||rx({})},nAe=0,aAe={reset:function(){yC.getInstance().onReset(function(){return nAe++})},getId:function(){return nAe},renderStyles:function(t,e){return Bae(Array.isArray(t)?t:[t],e)},renderFontFace:function(t,e){return Fae(t)},renderKeyframes:function(t){return Pm(t)}},wst=function(t,e){var i,r,o,l=e[0],d=e[1],h=e[2];return(o=(r=(i=t.get(l))===null||i===void 0?void 0:i.get(d))===null||r===void 0?void 0:r.get(h))===null||o===void 0?void 0:o.classMap},kst=function(t,e,i){var r,o,l=e[0],d=e[1],h=e[2],p=(r=t.get(l))!==null&&r!==void 0?r:new Map;t.set(l,p);var g=(o=p.get(d))!==null&&o!==void 0?o:new Map;p.set(d,g),g.set(h,{classMap:i,refCount:0})};function Rst(t,e){var i,r,o=e[0],l=e[1],d=e[2],h=(r=(i=t.get(o))===null||i===void 0?void 0:i.get(l))===null||r===void 0?void 0:r.get(d);h&&h.refCount++}function Mst(t,e){var i,r,o,l,d,h,p,g,f=e[0],y=e[1],T=e[2],C=(r=(i=t.get(f))===null||i===void 0?void 0:i.get(y))===null||r===void 0?void 0:r.get(T);C&&(C.refCount--,C.refCount===0&&((l=(o=t.get(f))===null||o===void 0?void 0:o.get(y))===null||l===void 0||l.delete(T),((h=(d=t.get(f))===null||d===void 0?void 0:d.get(y))===null||h===void 0?void 0:h.size)===0&&((p=t.get(f))===null||p===void 0||p.delete(y),((g=t.get(f))===null||g===void 0?void 0:g.size)===0&&t.delete(f))))}function Pst(t){var e=new Map,i=new Set,r=function(o){var l=o.currentTarget,d=l.__id__;e.delete(d),l.removeEventListener("unload",r),i.delete(d)};return function(o){o===void 0&&(o={});var l=o.theme,d,h=VU();h&&(h.__id__=h.__id__||bp(),d=h.__id__,i.has(d)||(i.add(d),h.addEventListener("unload",r)));var p=hc();l=l||p;var g=aAe,f=g.getId(),y=[d,f,l],T=wst(e,y);if($.useEffect(function(){return Rst(e,[d,f,l]),function(){return Mst(e,[d,f,l])}},[d,f,l]),!T){var C=Dst(t)?t(l):t;T=aAe.renderStyles(C,{targetWindow:h,rtl:!!l.rtl}),kst(e,y,T)}return T}}function Dst(t){return typeof t=="function"}var Lst=Pst(function(t){var e=t.semanticColors,i=t.fonts;return{body:[{color:e.bodyText,background:e.bodyBackground,fontFamily:i.medium.fontFamily,fontWeight:i.medium.fontWeight,fontSize:i.medium.fontSize,MozOsxFontSmoothing:i.medium.MozOsxFontSmoothing,WebkitFontSmoothing:i.medium.WebkitFontSmoothing}]}});function Ost(t,e){var i,r=t.applyTo,o=r==="body",l=(i=O_e())===null||i===void 0?void 0:i.body;$.useEffect(function(){if(!(!o||!l)){for(var d=0,h=e;d<h.length;d++){var p=h[d];p&&l.classList.add(p)}return function(){if(!(!o||!l))for(var g=0,f=e;g<f.length;g++){var y=f[g];y&&l.classList.remove(y)}}}},[o,l,e])}function Nst(t){var e=Lst(t),i=t.className,r=t.applyTo;Ost(t,[e.root,e.body]),t.className=wh(i,e.root,r==="element"&&e.body)}var xst=function(t){var e=t.customizerContext,i=t.ref,r=t.theme,o=t.as||"div",l=typeof t.as=="string"?KXe(t.as,t):t.as===$.Fragment?{children:t.children}:GZe(t,["as"]);return $.createElement(iAe.Provider,{value:r},$.createElement(zU.Provider,{value:e},$.createElement(lre,{providerRef:i},$.createElement(o,Rt({},l)))))},rAe=new Map,Bst=function(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];for(var i=[],r=0,o=t;r<o.length;r++){var l=o[r];if(l){var d=l.id||rAe.get(l);d||(d=bp(""),rAe.set(l,d)),i.push(d)}}return i.join("-")},Fst=function(t){var e=t.theme,i=hc(),r=t.theme=$.useMemo(function(){var o=q$(i,e);return o.id=Bst(i,e),o},[i,e]);t.customizerContext=$.useMemo(function(){return{customizations:{inCustomizerContext:!0,settings:{theme:r},scopedSettings:r.components||{}}}},[r]),t.theme.rtl!==i.rtl&&(t.dir=t.theme.rtl?"rtl":"ltr")},Ust=function(t,e){var i=Lw(e,t);return Fst(i),{state:i,render:xst}},oAe=$.forwardRef(function(t,e){var i=Ff(e,$.useRef(null)),r=Ust(t,{ref:i,as:"div",applyTo:"element"}),o=r.render,l=r.state;return Nst(l),o(l)});oAe.displayName="ThemeProvider";function _W({children:t,style:e,className:i,role:r,title:o}){return U.createElement("div",{role:r,title:o,className:i,style:e},t)}function sAe(t,e){return`${t}__${e}`}function fx(t,e){return`${t}--${e}`}const vx="react-split",zst=fx(vx,"dragging"),Vst=fx(vx,"vertical"),$st=fx(vx,"horizontal"),lAe=fx(vx,"disabled"),Hst=sAe(vx,"pane"),EW=sAe(vx,"sash"),jst=fx(EW,"vertical"),Gst=fx(EW,"horizontal"),qst=fx(EW,"disabled");function gH(...t){const e=[];for(const i of t){if(!i)continue;const r=typeof i;if(r==="string"||r==="number"){e.push(`${i}`);continue}if(r==="object"){if(i.toString!==Object.prototype.toString){e.push(i.toString());continue}for(const o in i)Object.hasOwnProperty.call(i,o)&&i[o]&&e.push(o)}}return e.join(" ")}function noe(t,e,i=1/0){return typeof t>"u"?i:typeof t=="number"?t:t.endsWith("%")?e*(+t.replace("%","")/100):t.endsWith("px")?+t.replace("px",""):i}var Wst=function(t,e){var i={};for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&e.indexOf(r)<0&&(i[r]=t[r]);if(t!=null&&typeof Object.getOwnPropertySymbols=="function")for(var o=0,r=Object.getOwnPropertySymbols(t);o<r.length;o++)e.indexOf(r[o])<0&&Object.prototype.propertyIsEnumerable.call(t,r[o])&&(i[r[o]]=t[r[o]]);return i};function Kst(t){var{className:e,render:i,onDragStart:r,onDragging:o,onDragEnd:l}=t,d=Wst(t,["className","render","onDragStart","onDragging","onDragEnd"]);const h=$.useRef(null),[p,g]=$.useState(!1),[f,y]=$.useState(!1),T=function(E){o(E)},C=function(E){y(!1),l(E),window.removeEventListener("mousemove",T),window.removeEventListener("mouseup",C)};return U.createElement("div",Object.assign({role:"Resizer",className:gH(EW,e),onMouseEnter:()=>{h.current=setTimeout(()=>{g(!0)},150)},onMouseLeave:()=>{h.current&&(g(!1),clearTimeout(h.current))},onMouseDown:E=>{y(!0),r(E),window.addEventListener("mousemove",T),window.addEventListener("mouseup",C)}},d),i(f||p))}var Jst=function(t,e){var i={};for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&e.indexOf(r)<0&&(i[r]=t[r]);if(t!=null&&typeof Object.getOwnPropertySymbols=="function")for(var o=0,r=Object.getOwnPropertySymbols(t);o<r.length;o++)e.indexOf(r[o])<0&&Object.prototype.propertyIsEnumerable.call(t,r[o])&&(i[r[o]]=t[r[o]]);return i};function cAe(t){var{className:e,children:i,active:r,type:o}=t,l=Jst(t,["className","children","active","type"]);return U.createElement("div",Object.assign({className:gH("split-sash-content",r&&"split-sash-content-active",o&&`split-sash-content-${o}`,e)},l),i)}var Yst=function(t,e){var i={};for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&e.indexOf(r)<0&&(i[r]=t[r]);if(t!=null&&typeof Object.getOwnPropertySymbols=="function")for(var o=0,r=Object.getOwnPropertySymbols(t);o<r.length;o++)e.indexOf(r[o])<0&&Object.prototype.propertyIsEnumerable.call(t,r[o])&&(i[r[o]]=t[r[o]]);return i};const Qst=t=>{var e,{children:i,sizes:r,allowResize:o=!0,split:l="vertical",className:d,sashRender:h=(te,Se)=>U.createElement(cAe,{active:Se,type:"vscode"}),resizerSize:p=4,performanceMode:g=!1,onChange:f=()=>null,onDragStart:y=()=>null,onDragEnd:T=()=>null}=t,C=Yst(t,["children","sizes","allowResize","split","className","sashRender","resizerSize","performanceMode","onChange","onDragStart","onDragEnd"]);const E=$.useRef({x:0,y:0}),I=$.useRef(null),w=$.useRef({sizes:[],sashPosSizes:[]}),[D,F]=$.useState({}),[x,B]=$.useState(!1);$.useEffect(()=>{const te=new ResizeObserver(()=>{var Se,ce;F((ce=(Se=I?.current)===null||Se===void 0?void 0:Se.getBoundingClientRect())!==null&&ce!==void 0?ce:{})});return te.observe(I.current),()=>{te.disconnect()}},[]);const{sizeName:L,splitPos:z,splitAxis:H}=$.useMemo(()=>({sizeName:l==="vertical"?"width":"height",splitPos:l==="vertical"?"left":"top",splitAxis:l==="vertical"?"x":"y"}),[l]),j=(e=D[L])!==null&&e!==void 0?e:0,J=$.useMemo(()=>i.map(te=>{const Se=[0,1/0];if(te.type===_W){const{minSize:ce,maxSize:X}=te.props;Se[0]=noe(ce,j,0),Se[1]=noe(X,j)}return Se}),[i,j]),Z=$.useMemo(function(){let te=0,Se=0;const ce=i.map((X,ve)=>{const Te=noe(r[ve],j);return Te===1/0?te++:Se+=Te,Te});if(Se>j||!te&&Se<j){const X=(Se-j)/Se;return ce.map(ve=>ve===1/0?0:ve-ve*X)}if(te>0){const X=(j-Se)/te;return ce.map(ve=>ve===1/0?X:ve)}return ce},[...r,i.length,j]),re=$.useMemo(()=>Z.reduce((te,Se)=>[...te,te[te.length-1]+Se],[0]),[...Z]),ne=$.useCallback(function(te){var Se,ce;(ce=(Se=document?.body)===null||Se===void 0?void 0:Se.classList)===null||ce===void 0||ce.add(lAe),E.current={x:te.pageX,y:te.pageY},w.current={sizes:Z,sashPosSizes:re},B(!0),y(te)},[y,Z,re]),le=$.useCallback(function(te){var Se,ce;(ce=(Se=document?.body)===null||Se===void 0?void 0:Se.classList)===null||ce===void 0||ce.remove(lAe),E.current={x:te.pageX,y:te.pageY},w.current={sizes:Z,sashPosSizes:re},B(!1),T(te)},[T,Z,re]),he=$.useCallback(function(te,Se){let X={x:te.pageX,y:te.pageY}[H]-E.current[H];const ve=-Math.min(Z[Se]-J[Se][0],J[Se+1][1]-Z[Se+1]),Te=Math.min(Z[Se+1]-J[Se+1][0],J[Se][1]-Z[Se]);X<ve&&(X=ve),X>Te&&(X=Te);const Be=[...Z];Be[Se]+=X,Be[Se+1]-=X,f(Be)},[J,f]),Me=!(g&&x),Le=Me?Z:w.current.sizes,pe=Me?re:w.current.sashPosSizes;return U.createElement("div",Object.assign({className:gH(vx,l==="vertical"&&Vst,l==="horizontal"&&$st,x&&zst,d),ref:I},C),i.map((te,Se)=>{const ce=te.type===_W,X=ce?te.props:{};return U.createElement(_W,{key:Se,className:gH(Hst,X.className),style:Object.assign(Object.assign({},X.style),{[L]:Le[Se],[z]:pe[Se]})},ce?X.children:te)}),re.slice(1,-1).map((te,Se)=>U.createElement(Kst,{key:Se,className:gH(!o&&qst,l==="vertical"?jst:Gst),style:{[L]:p,[z]:te-p/2},render:h.bind(null,Se),onDragStart:ne,onDragging:ce=>he(ce,Se),onDragEnd:le})))};var dAe=typeof global=="object"&&global&&global.Object===Object&&global,Zst=typeof self=="object"&&self&&self.Object===Object&&self,zw=dAe||Zst||Function("return this")(),Vw=zw.Symbol,uAe=Object.prototype,Xst=uAe.hasOwnProperty,elt=uAe.toString,mH=Vw?Vw.toStringTag:void 0;function tlt(t){var e=Xst.call(t,mH),i=t[mH];try{t[mH]=void 0;var r=!0}catch{}var o=elt.call(t);return r&&(e?t[mH]=i:delete t[mH]),o}var ilt=Object.prototype,nlt=ilt.toString;function alt(t){return nlt.call(t)}var rlt="[object Null]",olt="[object Undefined]",hAe=Vw?Vw.toStringTag:void 0;function yx(t){return t==null?t===void 0?olt:rlt:hAe&&hAe in Object(t)?tlt(t):alt(t)}function Sx(t){return t!=null&&typeof t=="object"}var slt="[object Symbol]";function u5(t){return typeof t=="symbol"||Sx(t)&&yx(t)==slt}function AW(t,e){for(var i=-1,r=t==null?0:t.length,o=Array(r);++i<r;)o[i]=e(t[i],i,t);return o}var pA=Array.isArray,pAe=Vw?Vw.prototype:void 0,gAe=pAe?pAe.toString:void 0;function mAe(t){if(typeof t=="string")return t;if(pA(t))return AW(t,mAe)+"";if(u5(t))return gAe?gAe.call(t):"";var e=t+"";return e=="0"&&1/t==-1/0?"-0":e}var llt=/\s/;function clt(t){for(var e=t.length;e--&&llt.test(t.charAt(e)););return e}var dlt=/^\s+/;function ult(t){return t&&t.slice(0,clt(t)+1).replace(dlt,"")}function PL(t){var e=typeof t;return t!=null&&(e=="object"||e=="function")}var fAe=NaN,hlt=/^[-+]0x[0-9a-f]+$/i,plt=/^0b[01]+$/i,glt=/^0o[0-7]+$/i,mlt=parseInt;function vAe(t){if(typeof t=="number")return t;if(u5(t))return fAe;if(PL(t)){var e=typeof t.valueOf=="function"?t.valueOf():t;t=PL(e)?e+"":e}if(typeof t!="string")return t===0?t:+t;t=ult(t);var i=plt.test(t);return i||glt.test(t)?mlt(t.slice(2),i?2:8):hlt.test(t)?fAe:+t}function IW(t){return t}var flt="[object AsyncFunction]",vlt="[object Function]",ylt="[object GeneratorFunction]",Slt="[object Proxy]";function wW(t){if(!PL(t))return!1;var e=yx(t);return e==vlt||e==ylt||e==flt||e==Slt}var aoe=zw["__core-js_shared__"],yAe=function(){var t=/[^.]+$/.exec(aoe&&aoe.keys&&aoe.keys.IE_PROTO||"");return t?"Symbol(src)_1."+t:""}();function blt(t){return!!yAe&&yAe in t}var Tlt=Function.prototype,Clt=Tlt.toString;function bx(t){if(t!=null){try{return Clt.call(t)}catch{}try{return t+""}catch{}}return""}var _lt=/[\\^$.*+?()[\]{}|]/g,Elt=/^\[object .+?Constructor\]$/,Alt=Function.prototype,Ilt=Object.prototype,wlt=Alt.toString,klt=Ilt.hasOwnProperty,Rlt=RegExp("^"+wlt.call(klt).replace(_lt,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$");function Mlt(t){if(!PL(t)||blt(t))return!1;var e=wW(t)?Rlt:Elt;return e.test(bx(t))}function Plt(t,e){return t?.[e]}function Tx(t,e){var i=Plt(t,e);return Mlt(i)?i:void 0}var roe=Tx(zw,"WeakMap");function Dlt(t,e,i){switch(i.length){case 0:return t.call(e);case 1:return t.call(e,i[0]);case 2:return t.call(e,i[0],i[1]);case 3:return t.call(e,i[0],i[1],i[2])}return t.apply(e,i)}function Llt(){}var Olt=800,Nlt=16,xlt=Date.now;function Blt(t){var e=0,i=0;return function(){var r=xlt(),o=Nlt-(r-i);if(i=r,o>0){if(++e>=Olt)return arguments[0]}else e=0;return t.apply(void 0,arguments)}}function Flt(t){return function(){return t}}var SAe=function(){try{var t=Tx(Object,"defineProperty");return t({},"",{}),t}catch{}}(),Ult=SAe?function(t,e){return SAe(t,"toString",{configurable:!0,enumerable:!1,value:Flt(e),writable:!0})}:IW,zlt=Blt(Ult);function Vlt(t,e,i,r){for(var o=t.length,l=i+-1;++l<o;)if(e(t[l],l,t))return l;return-1}function $lt(t){return t!==t}function Hlt(t,e,i){for(var r=i-1,o=t.length;++r<o;)if(t[r]===e)return r;return-1}function jlt(t,e,i){return e===e?Hlt(t,e,i):Vlt(t,$lt,i)}function Glt(t,e){var i=t==null?0:t.length;return!!i&&jlt(t,e,0)>-1}var qlt=9007199254740991,Wlt=/^(?:0|[1-9]\d*)$/;function ooe(t,e){var i=typeof t;return e=e??qlt,!!e&&(i=="number"||i!="symbol"&&Wlt.test(t))&&t>-1&&t%1==0&&t<e}function soe(t,e){return t===e||t!==t&&e!==e}var bAe=Math.max;function Klt(t,e,i){return e=bAe(e===void 0?t.length-1:e,0),function(){for(var r=arguments,o=-1,l=bAe(r.length-e,0),d=Array(l);++o<l;)d[o]=r[e+o];o=-1;for(var h=Array(e+1);++o<e;)h[o]=r[o];return h[e]=i(d),Dlt(t,this,h)}}function Jlt(t,e){return zlt(Klt(t,e,IW),t+"")}var Ylt=9007199254740991;function loe(t){return typeof t=="number"&&t>-1&&t%1==0&&t<=Ylt}function kW(t){return t!=null&&loe(t.length)&&!wW(t)}function TAe(t,e,i){if(!PL(i))return!1;var r=typeof e;return(r=="number"?kW(i)&&ooe(e,i.length):r=="string"&&e in i)?soe(i[e],t):!1}var Qlt=Object.prototype;function Zlt(t){var e=t&&t.constructor,i=typeof e=="function"&&e.prototype||Qlt;return t===i}function Xlt(t,e){for(var i=-1,r=Array(t);++i<t;)r[i]=e(i);return r}var ect="[object Arguments]";function CAe(t){return Sx(t)&&yx(t)==ect}var _Ae=Object.prototype,tct=_Ae.hasOwnProperty,ict=_Ae.propertyIsEnumerable,coe=CAe(function(){return arguments}())?CAe:function(t){return Sx(t)&&tct.call(t,"callee")&&!ict.call(t,"callee")};function nct(){return!1}var EAe=typeof iT=="object"&&iT&&!iT.nodeType&&iT,AAe=EAe&&typeof module=="object"&&module&&!module.nodeType&&module,act=AAe&&AAe.exports===EAe,IAe=act?zw.Buffer:void 0,rct=IAe?IAe.isBuffer:void 0,doe=rct||nct,oct="[object Arguments]",sct="[object Array]",lct="[object Boolean]",cct="[object Date]",dct="[object Error]",uct="[object Function]",hct="[object Map]",pct="[object Number]",gct="[object Object]",mct="[object RegExp]",fct="[object Set]",vct="[object String]",yct="[object WeakMap]",Sct="[object ArrayBuffer]",bct="[object DataView]",Tct="[object Float32Array]",Cct="[object Float64Array]",_ct="[object Int8Array]",Ect="[object Int16Array]",Act="[object Int32Array]",Ict="[object Uint8Array]",wct="[object Uint8ClampedArray]",kct="[object Uint16Array]",Rct="[object Uint32Array]",ih={};ih[Tct]=ih[Cct]=ih[_ct]=ih[Ect]=ih[Act]=ih[Ict]=ih[wct]=ih[kct]=ih[Rct]=!0,ih[oct]=ih[sct]=ih[Sct]=ih[lct]=ih[bct]=ih[cct]=ih[dct]=ih[uct]=ih[hct]=ih[pct]=ih[gct]=ih[mct]=ih[fct]=ih[vct]=ih[yct]=!1;function Mct(t){return Sx(t)&&loe(t.length)&&!!ih[yx(t)]}function wAe(t){return function(e){return t(e)}}var kAe=typeof iT=="object"&&iT&&!iT.nodeType&&iT,fH=kAe&&typeof module=="object"&&module&&!module.nodeType&&module,Pct=fH&&fH.exports===kAe,uoe=Pct&&dAe.process,RAe=function(){try{var t=fH&&fH.require&&fH.require("util").types;return t||uoe&&uoe.binding&&uoe.binding("util")}catch{}}(),MAe=RAe&&RAe.isTypedArray,PAe=MAe?wAe(MAe):Mct,Dct=Object.prototype,Lct=Dct.hasOwnProperty;function Oct(t,e){var i=pA(t),r=!i&&coe(t),o=!i&&!r&&doe(t),l=!i&&!r&&!o&&PAe(t),d=i||r||o||l,h=d?Xlt(t.length,String):[],p=h.length;for(var g in t)Lct.call(t,g)&&!(d&&(g=="length"||o&&(g=="offset"||g=="parent")||l&&(g=="buffer"||g=="byteLength"||g=="byteOffset")||ooe(g,p)))&&h.push(g);return h}function Nct(t,e){return function(i){return t(e(i))}}var xct=Nct(Object.keys,Object),Bct=Object.prototype,Fct=Bct.hasOwnProperty;function Uct(t){if(!Zlt(t))return xct(t);var e=[];for(var i in Object(t))Fct.call(t,i)&&i!="constructor"&&e.push(i);return e}function hoe(t){return kW(t)?Oct(t):Uct(t)}var zct=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,Vct=/^\w*$/;function poe(t,e){if(pA(t))return!1;var i=typeof t;return i=="number"||i=="symbol"||i=="boolean"||t==null||u5(t)?!0:Vct.test(t)||!zct.test(t)||e!=null&&t in Object(e)}var vH=Tx(Object,"create");function $ct(){this.__data__=vH?vH(null):{},this.size=0}function Hct(t){var e=this.has(t)&&delete this.__data__[t];return this.size-=e?1:0,e}var jct="__lodash_hash_undefined__",Gct=Object.prototype,qct=Gct.hasOwnProperty;function Wct(t){var e=this.__data__;if(vH){var i=e[t];return i===jct?void 0:i}return qct.call(e,t)?e[t]:void 0}var Kct=Object.prototype,Jct=Kct.hasOwnProperty;function Yct(t){var e=this.__data__;return vH?e[t]!==void 0:Jct.call(e,t)}var Qct="__lodash_hash_undefined__";function Zct(t,e){var i=this.__data__;return this.size+=this.has(t)?0:1,i[t]=vH&&e===void 0?Qct:e,this}function Cx(t){var e=-1,i=t==null?0:t.length;for(this.clear();++e<i;){var r=t[e];this.set(r[0],r[1])}}Cx.prototype.clear=$ct,Cx.prototype.delete=Hct,Cx.prototype.get=Wct,Cx.prototype.has=Yct,Cx.prototype.set=Zct;function Xct(){this.__data__=[],this.size=0}function RW(t,e){for(var i=t.length;i--;)if(soe(t[i][0],e))return i;return-1}var edt=Array.prototype,tdt=edt.splice;function idt(t){var e=this.__data__,i=RW(e,t);if(i<0)return!1;var r=e.length-1;return i==r?e.pop():tdt.call(e,i,1),--this.size,!0}function ndt(t){var e=this.__data__,i=RW(e,t);return i<0?void 0:e[i][1]}function adt(t){return RW(this.__data__,t)>-1}function rdt(t,e){var i=this.__data__,r=RW(i,t);return r<0?(++this.size,i.push([t,e])):i[r][1]=e,this}function wM(t){var e=-1,i=t==null?0:t.length;for(this.clear();++e<i;){var r=t[e];this.set(r[0],r[1])}}wM.prototype.clear=Xct,wM.prototype.delete=idt,wM.prototype.get=ndt,wM.prototype.has=adt,wM.prototype.set=rdt;var yH=Tx(zw,"Map");function odt(){this.size=0,this.__data__={hash:new Cx,map:new(yH||wM),string:new Cx}}function sdt(t){var e=typeof t;return e=="string"||e=="number"||e=="symbol"||e=="boolean"?t!=="__proto__":t===null}function MW(t,e){var i=t.__data__;return sdt(e)?i[typeof e=="string"?"string":"hash"]:i.map}function ldt(t){var e=MW(this,t).delete(t);return this.size-=e?1:0,e}function cdt(t){return MW(this,t).get(t)}function ddt(t){return MW(this,t).has(t)}function udt(t,e){var i=MW(this,t),r=i.size;return i.set(t,e),this.size+=i.size==r?0:1,this}function kM(t){var e=-1,i=t==null?0:t.length;for(this.clear();++e<i;){var r=t[e];this.set(r[0],r[1])}}kM.prototype.clear=odt,kM.prototype.delete=ldt,kM.prototype.get=cdt,kM.prototype.has=ddt,kM.prototype.set=udt;var hdt="Expected a function";function goe(t,e){if(typeof t!="function"||e!=null&&typeof e!="function")throw new TypeError(hdt);var i=function(){var r=arguments,o=e?e.apply(this,r):r[0],l=i.cache;if(l.has(o))return l.get(o);var d=t.apply(this,r);return i.cache=l.set(o,d)||l,d};return i.cache=new(goe.Cache||kM),i}goe.Cache=kM;var pdt=500;function gdt(t){var e=goe(t,function(r){return i.size===pdt&&i.clear(),r}),i=e.cache;return e}var mdt=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,fdt=/\\(\\)?/g,vdt=gdt(function(t){var e=[];return t.charCodeAt(0)===46&&e.push(""),t.replace(mdt,function(i,r,o,l){e.push(o?l.replace(fdt,"$1"):r||i)}),e});function moe(t){return t==null?"":mAe(t)}function DAe(t,e){return pA(t)?t:poe(t,e)?[t]:vdt(moe(t))}function PW(t){if(typeof t=="string"||u5(t))return t;var e=t+"";return e=="0"&&1/t==-1/0?"-0":e}function foe(t,e){e=DAe(e,t);for(var i=0,r=e.length;t!=null&&i<r;)t=t[PW(e[i++])];return i&&i==r?t:void 0}function ydt(t,e,i){var r=t==null?void 0:foe(t,e);return r===void 0?i:r}function LAe(t,e){for(var i=-1,r=e.length,o=t.length;++i<r;)t[o+i]=e[i];return t}var OAe=Vw?Vw.isConcatSpreadable:void 0;function Sdt(t){return pA(t)||coe(t)||!!(OAe&&t&&t[OAe])}function bdt(t,e,i,r,o){var l=-1,d=t.length;for(i||(i=Sdt),o||(o=[]);++l<d;){var h=t[l];i(h)?LAe(o,h):o[o.length]=h}return o}function Tdt(t,e,i,r){for(var o=-1,l=t==null?0:t.length;++o<l;)i=e(i,t[o],o,t);return i}function Cdt(t){return function(e){return t?.[e]}}var _dt={À:"A",Á:"A",Â:"A",Ã:"A",Ä:"A",Å:"A",à:"a",á:"a",â:"a",ã:"a",ä:"a",å:"a",Ç:"C",ç:"c",Ð:"D",ð:"d",È:"E",É:"E",Ê:"E",Ë:"E",è:"e",é:"e",ê:"e",ë:"e",Ì:"I",Í:"I",Î:"I",Ï:"I",ì:"i",í:"i",î:"i",ï:"i",Ñ:"N",ñ:"n",Ò:"O",Ó:"O",Ô:"O",Õ:"O",Ö:"O",Ø:"O",ò:"o",ó:"o",ô:"o",õ:"o",ö:"o",ø:"o",Ù:"U",Ú:"U",Û:"U",Ü:"U",ù:"u",ú:"u",û:"u",ü:"u",Ý:"Y",ý:"y",ÿ:"y",Æ:"Ae",æ:"ae",Þ:"Th",þ:"th",ß:"ss",Ā:"A",Ă:"A",Ą:"A",ā:"a",ă:"a",ą:"a",Ć:"C",Ĉ:"C",Ċ:"C",Č:"C",ć:"c",ĉ:"c",ċ:"c",č:"c",Ď:"D",Đ:"D",ď:"d",đ:"d",Ē:"E",Ĕ:"E",Ė:"E",Ę:"E",Ě:"E",ē:"e",ĕ:"e",ė:"e",ę:"e",ě:"e",Ĝ:"G",Ğ:"G",Ġ:"G",Ģ:"G",ĝ:"g",ğ:"g",ġ:"g",ģ:"g",Ĥ:"H",Ħ:"H",ĥ:"h",ħ:"h",Ĩ:"I",Ī:"I",Ĭ:"I",Į:"I",İ:"I",ĩ:"i",ī:"i",ĭ:"i",į:"i",ı:"i",Ĵ:"J",ĵ:"j",Ķ:"K",ķ:"k",ĸ:"k",Ĺ:"L",Ļ:"L",Ľ:"L",Ŀ:"L",Ł:"L",ĺ:"l",ļ:"l",ľ:"l",ŀ:"l",ł:"l",Ń:"N",Ņ:"N",Ň:"N",Ŋ:"N",ń:"n",ņ:"n",ň:"n",ŋ:"n",Ō:"O",Ŏ:"O",Ő:"O",ō:"o",ŏ:"o",ő:"o",Ŕ:"R",Ŗ:"R",Ř:"R",ŕ:"r",ŗ:"r",ř:"r",Ś:"S",Ŝ:"S",Ş:"S",Š:"S",ś:"s",ŝ:"s",ş:"s",š:"s",Ţ:"T",Ť:"T",Ŧ:"T",ţ:"t",ť:"t",ŧ:"t",Ũ:"U",Ū:"U",Ŭ:"U",Ů:"U",Ű:"U",Ų:"U",ũ:"u",ū:"u",ŭ:"u",ů:"u",ű:"u",ų:"u",Ŵ:"W",ŵ:"w",Ŷ:"Y",ŷ:"y",Ÿ:"Y",Ź:"Z",Ż:"Z",Ž:"Z",ź:"z",ż:"z",ž:"z",Ĳ:"IJ",ĳ:"ij",Œ:"Oe",œ:"oe",ŉ:"'n",ſ:"s"},Edt=Cdt(_dt),Adt=/[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,Idt="\\u0300-\\u036f",wdt="\\ufe20-\\ufe2f",kdt="\\u20d0-\\u20ff",Rdt=Idt+wdt+kdt,Mdt="["+Rdt+"]",Pdt=RegExp(Mdt,"g");function Ddt(t){return t=moe(t),t&&t.replace(Adt,Edt).replace(Pdt,"")}var Ldt=/[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;function Odt(t){return t.match(Ldt)||[]}var Ndt=/[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;function xdt(t){return Ndt.test(t)}var NAe="\\ud800-\\udfff",Bdt="\\u0300-\\u036f",Fdt="\\ufe20-\\ufe2f",Udt="\\u20d0-\\u20ff",zdt=Bdt+Fdt+Udt,xAe="\\u2700-\\u27bf",BAe="a-z\\xdf-\\xf6\\xf8-\\xff",Vdt="\\xac\\xb1\\xd7\\xf7",$dt="\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf",Hdt="\\u2000-\\u206f",jdt=" \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",FAe="A-Z\\xc0-\\xd6\\xd8-\\xde",Gdt="\\ufe0e\\ufe0f",UAe=Vdt+$dt+Hdt+jdt,zAe="['’]",VAe="["+UAe+"]",qdt="["+zdt+"]",$Ae="\\d+",Wdt="["+xAe+"]",HAe="["+BAe+"]",jAe="[^"+NAe+UAe+$Ae+xAe+BAe+FAe+"]",Kdt="\\ud83c[\\udffb-\\udfff]",Jdt="(?:"+qdt+"|"+Kdt+")",Ydt="[^"+NAe+"]",GAe="(?:\\ud83c[\\udde6-\\uddff]){2}",qAe="[\\ud800-\\udbff][\\udc00-\\udfff]",h5="["+FAe+"]",Qdt="\\u200d",WAe="(?:"+HAe+"|"+jAe+")",Zdt="(?:"+h5+"|"+jAe+")",KAe="(?:"+zAe+"(?:d|ll|m|re|s|t|ve))?",JAe="(?:"+zAe+"(?:D|LL|M|RE|S|T|VE))?",YAe=Jdt+"?",QAe="["+Gdt+"]?",Xdt="(?:"+Qdt+"(?:"+[Ydt,GAe,qAe].join("|")+")"+QAe+YAe+")*",eut="\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])",tut="\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])",iut=QAe+YAe+Xdt,nut="(?:"+[Wdt,GAe,qAe].join("|")+")"+iut,aut=RegExp([h5+"?"+HAe+"+"+KAe+"(?="+[VAe,h5,"$"].join("|")+")",Zdt+"+"+JAe+"(?="+[VAe,h5+WAe,"$"].join("|")+")",h5+"?"+WAe+"+"+KAe,h5+"+"+JAe,tut,eut,$Ae,nut].join("|"),"g");function rut(t){return t.match(aut)||[]}function out(t,e,i){return t=moe(t),e=e,e===void 0?xdt(t)?rut(t):Odt(t):t.match(e)||[]}var sut="['’]",lut=RegExp(sut,"g");function cut(t){return function(e){return Tdt(out(Ddt(e).replace(lut,"")),t,"")}}function dut(){this.__data__=new wM,this.size=0}function uut(t){var e=this.__data__,i=e.delete(t);return this.size=e.size,i}function hut(t){return this.__data__.get(t)}function put(t){return this.__data__.has(t)}var gut=200;function mut(t,e){var i=this.__data__;if(i instanceof wM){var r=i.__data__;if(!yH||r.length<gut-1)return r.push([t,e]),this.size=++i.size,this;i=this.__data__=new kM(r)}return i.set(t,e),this.size=i.size,this}function RM(t){var e=this.__data__=new wM(t);this.size=e.size}RM.prototype.clear=dut,RM.prototype.delete=uut,RM.prototype.get=hut,RM.prototype.has=put,RM.prototype.set=mut;function fut(t,e){for(var i=-1,r=t==null?0:t.length,o=0,l=[];++i<r;){var d=t[i];e(d,i,t)&&(l[o++]=d)}return l}function vut(){return[]}var yut=Object.prototype,Sut=yut.propertyIsEnumerable,ZAe=Object.getOwnPropertySymbols,but=ZAe?function(t){return t==null?[]:(t=Object(t),fut(ZAe(t),function(e){return Sut.call(t,e)}))}:vut;function Tut(t,e,i){var r=e(t);return pA(t)?r:LAe(r,i(t))}function XAe(t){return Tut(t,hoe,but)}var voe=Tx(zw,"DataView"),yoe=Tx(zw,"Promise"),p5=Tx(zw,"Set"),eIe="[object Map]",Cut="[object Object]",tIe="[object Promise]",iIe="[object Set]",nIe="[object WeakMap]",aIe="[object DataView]",_ut=bx(voe),Eut=bx(yH),Aut=bx(yoe),Iut=bx(p5),wut=bx(roe),DL=yx;(voe&&DL(new voe(new ArrayBuffer(1)))!=aIe||yH&&DL(new yH)!=eIe||yoe&&DL(yoe.resolve())!=tIe||p5&&DL(new p5)!=iIe||roe&&DL(new roe)!=nIe)&&(DL=function(t){var e=yx(t),i=e==Cut?t.constructor:void 0,r=i?bx(i):"";if(r)switch(r){case _ut:return aIe;case Eut:return eIe;case Aut:return tIe;case Iut:return iIe;case wut:return nIe}return e});var rIe=zw.Uint8Array,kut="__lodash_hash_undefined__";function Rut(t){return this.__data__.set(t,kut),this}function Mut(t){return this.__data__.has(t)}function SH(t){var e=-1,i=t==null?0:t.length;for(this.__data__=new kM;++e<i;)this.add(t[e])}SH.prototype.add=SH.prototype.push=Rut,SH.prototype.has=Mut;function Put(t,e){for(var i=-1,r=t==null?0:t.length;++i<r;)if(e(t[i],i,t))return!0;return!1}function oIe(t,e){return t.has(e)}var Dut=1,Lut=2;function sIe(t,e,i,r,o,l){var d=i&Dut,h=t.length,p=e.length;if(h!=p&&!(d&&p>h))return!1;var g=l.get(t),f=l.get(e);if(g&&f)return g==e&&f==t;var y=-1,T=!0,C=i&Lut?new SH:void 0;for(l.set(t,e),l.set(e,t);++y<h;){var E=t[y],I=e[y];if(r)var w=d?r(I,E,y,e,t,l):r(E,I,y,t,e,l);if(w!==void 0){if(w)continue;T=!1;break}if(C){if(!Put(e,function(D,F){if(!oIe(C,F)&&(E===D||o(E,D,i,r,l)))return C.push(F)})){T=!1;break}}else if(!(E===I||o(E,I,i,r,l))){T=!1;break}}return l.delete(t),l.delete(e),T}function Out(t){var e=-1,i=Array(t.size);return t.forEach(function(r,o){i[++e]=[o,r]}),i}function Soe(t){var e=-1,i=Array(t.size);return t.forEach(function(r){i[++e]=r}),i}var Nut=1,xut=2,But="[object Boolean]",Fut="[object Date]",Uut="[object Error]",zut="[object Map]",Vut="[object Number]",$ut="[object RegExp]",Hut="[object Set]",jut="[object String]",Gut="[object Symbol]",qut="[object ArrayBuffer]",Wut="[object DataView]",lIe=Vw?Vw.prototype:void 0,boe=lIe?lIe.valueOf:void 0;function Kut(t,e,i,r,o,l,d){switch(i){case Wut:if(t.byteLength!=e.byteLength||t.byteOffset!=e.byteOffset)return!1;t=t.buffer,e=e.buffer;case qut:return!(t.byteLength!=e.byteLength||!l(new rIe(t),new rIe(e)));case But:case Fut:case Vut:return soe(+t,+e);case Uut:return t.name==e.name&&t.message==e.message;case $ut:case jut:return t==e+"";case zut:var h=Out;case Hut:var p=r&Nut;if(h||(h=Soe),t.size!=e.size&&!p)return!1;var g=d.get(t);if(g)return g==e;r|=xut,d.set(t,e);var f=sIe(h(t),h(e),r,o,l,d);return d.delete(t),f;case Gut:if(boe)return boe.call(t)==boe.call(e)}return!1}var Jut=1,Yut=Object.prototype,Qut=Yut.hasOwnProperty;function Zut(t,e,i,r,o,l){var d=i&Jut,h=XAe(t),p=h.length,g=XAe(e),f=g.length;if(p!=f&&!d)return!1;for(var y=p;y--;){var T=h[y];if(!(d?T in e:Qut.call(e,T)))return!1}var C=l.get(t),E=l.get(e);if(C&&E)return C==e&&E==t;var I=!0;l.set(t,e),l.set(e,t);for(var w=d;++y<p;){T=h[y];var D=t[T],F=e[T];if(r)var x=d?r(F,D,T,e,t,l):r(D,F,T,t,e,l);if(!(x===void 0?D===F||o(D,F,i,r,l):x)){I=!1;break}w||(w=T=="constructor")}if(I&&!w){var B=t.constructor,L=e.constructor;B!=L&&"constructor"in t&&"constructor"in e&&!(typeof B=="function"&&B instanceof B&&typeof L=="function"&&L instanceof L)&&(I=!1)}return l.delete(t),l.delete(e),I}var Xut=1,cIe="[object Arguments]",dIe="[object Array]",DW="[object Object]",eht=Object.prototype,uIe=eht.hasOwnProperty;function tht(t,e,i,r,o,l){var d=pA(t),h=pA(e),p=d?dIe:DL(t),g=h?dIe:DL(e);p=p==cIe?DW:p,g=g==cIe?DW:g;var f=p==DW,y=g==DW,T=p==g;if(T&&doe(t)){if(!doe(e))return!1;d=!0,f=!1}if(T&&!f)return l||(l=new RM),d||PAe(t)?sIe(t,e,i,r,o,l):Kut(t,e,p,i,r,o,l);if(!(i&Xut)){var C=f&&uIe.call(t,"__wrapped__"),E=y&&uIe.call(e,"__wrapped__");if(C||E){var I=C?t.value():t,w=E?e.value():e;return l||(l=new RM),o(I,w,i,r,l)}}return T?(l||(l=new RM),Zut(t,e,i,r,o,l)):!1}function Toe(t,e,i,r,o){return t===e?!0:t==null||e==null||!Sx(t)&&!Sx(e)?t!==t&&e!==e:tht(t,e,i,r,Toe,o)}var iht=1,nht=2;function aht(t,e,i,r){var o=i.length,l=o;if(t==null)return!l;for(t=Object(t);o--;){var d=i[o];if(d[2]?d[1]!==t[d[0]]:!(d[0]in t))return!1}for(;++o<l;){d=i[o];var h=d[0],p=t[h],g=d[1];if(d[2]){if(p===void 0&&!(h in t))return!1}else{var f=new RM,y;if(!(y===void 0?Toe(g,p,iht|nht,r,f):y))return!1}}return!0}function hIe(t){return t===t&&!PL(t)}function rht(t){for(var e=hoe(t),i=e.length;i--;){var r=e[i],o=t[r];e[i]=[r,o,hIe(o)]}return e}function pIe(t,e){return function(i){return i==null?!1:i[t]===e&&(e!==void 0||t in Object(i))}}function oht(t){var e=rht(t);return e.length==1&&e[0][2]?pIe(e[0][0],e[0][1]):function(i){return i===t||aht(i,t,e)}}function sht(t,e){return t!=null&&e in Object(t)}function lht(t,e,i){e=DAe(e,t);for(var r=-1,o=e.length,l=!1;++r<o;){var d=PW(e[r]);if(!(l=t!=null&&i(t,d)))break;t=t[d]}return l||++r!=o?l:(o=t==null?0:t.length,!!o&&loe(o)&&ooe(d,o)&&(pA(t)||coe(t)))}function cht(t,e){return t!=null&&lht(t,e,sht)}var dht=1,uht=2;function hht(t,e){return poe(t)&&hIe(e)?pIe(PW(t),e):function(i){var r=ydt(i,t);return r===void 0&&r===e?cht(i,t):Toe(e,r,dht|uht)}}function pht(t){return function(e){return e?.[t]}}function ght(t){return function(e){return foe(e,t)}}function mht(t){return poe(t)?pht(PW(t)):ght(t)}function gIe(t){return typeof t=="function"?t:t==null?IW:typeof t=="object"?pA(t)?hht(t[0],t[1]):oht(t):mht(t)}function fht(t){return function(e,i,r){for(var o=-1,l=Object(e),d=r(e),h=d.length;h--;){var p=d[++o];if(i(l[p],p,l)===!1)break}return e}}var vht=fht();function yht(t,e){return t&&vht(t,e,hoe)}function Sht(t,e){return function(i,r){if(i==null)return i;if(!kW(i))return t(i,r);for(var o=i.length,l=-1,d=Object(i);++l<o&&r(d[l],l,d)!==!1;);return i}}var bht=Sht(yht),Coe=function(){return zw.Date.now()},Tht="Expected a function",Cht=Math.max,_ht=Math.min;function Eht(t,e,i){var r,o,l,d,h,p,g=0,f=!1,y=!1,T=!0;if(typeof t!="function")throw new TypeError(Tht);e=vAe(e)||0,PL(i)&&(f=!!i.leading,y="maxWait"in i,l=y?Cht(vAe(i.maxWait)||0,e):l,T="trailing"in i?!!i.trailing:T);function C(z){var H=r,j=o;return r=o=void 0,g=z,d=t.apply(j,H),d}function E(z){return g=z,h=setTimeout(D,e),f?C(z):d}function I(z){var H=z-p,j=z-g,J=e-H;return y?_ht(J,l-j):J}function w(z){var H=z-p,j=z-g;return p===void 0||H>=e||H<0||y&&j>=l}function D(){var z=Coe();if(w(z))return F(z);h=setTimeout(D,I(z))}function F(z){return h=void 0,T&&r?C(z):(r=o=void 0,d)}function x(){h!==void 0&&clearTimeout(h),g=0,r=p=o=h=void 0}function B(){return h===void 0?d:F(Coe())}function L(){var z=Coe(),H=w(z);if(r=arguments,o=this,p=z,H){if(h===void 0)return E(p);if(y)return clearTimeout(h),h=setTimeout(D,e),C(p)}return h===void 0&&(h=setTimeout(D,e)),d}return L.cancel=x,L.flush=B,L}function Aht(t,e){var i=-1,r=kW(t)?Array(t.length):[];return bht(t,function(o,l,d){r[++i]=e(o,l,d)}),r}var Iht="[object Number]";function mIe(t){return typeof t=="number"||Sx(t)&&yx(t)==Iht}function wht(t,e){var i=t.length;for(t.sort(e);i--;)t[i]=t[i].value;return t}function kht(t,e){if(t!==e){var i=t!==void 0,r=t===null,o=t===t,l=u5(t),d=e!==void 0,h=e===null,p=e===e,g=u5(e);if(!h&&!g&&!l&&t>e||l&&d&&p&&!h&&!g||r&&d&&p||!i&&p||!o)return 1;if(!r&&!l&&!g&&t<e||g&&i&&o&&!r&&!l||h&&i&&o||!d&&o||!p)return-1}return 0}function Rht(t,e,i){for(var r=-1,o=t.criteria,l=e.criteria,d=o.length,h=i.length;++r<d;){var p=kht(o[r],l[r]);if(p){if(r>=h)return p;var g=i[r];return p*(g=="desc"?-1:1)}}return t.index-e.index}function Mht(t,e,i){e.length?e=AW(e,function(l){return pA(l)?function(d){return foe(d,l.length===1?l[0]:l)}:l}):e=[IW];var r=-1;e=AW(e,wAe(gIe));var o=Aht(t,function(l,d,h){var p=AW(e,function(g){return g(l)});return{criteria:p,index:++r,value:l}});return wht(o,function(l,d){return Rht(l,d,i)})}var Pht=cut(function(t,e,i){return t+(i?"_":"")+e.toLowerCase()}),fIe=Jlt(function(t,e){if(t==null)return[];var i=e.length;return i>1&&TAe(t,e[0],e[1])?e=[]:i>2&&TAe(e[0],e[1],e[2])&&(e=[e[0]]),Mht(t,bdt(e),[])}),Dht="Expected a function";function Lht(t,e,i){var r=!0,o=!0;if(typeof t!="function")throw new TypeError(Dht);return PL(i)&&(r="leading"in i?!!i.leading:r,o="trailing"in i?!!i.trailing:o),Eht(t,e,{leading:r,maxWait:e,trailing:o})}var Oht=1/0,Nht=p5&&1/Soe(new p5([,-0]))[1]==Oht?function(t){return new p5(t)}:Llt,xht=200;function Bht(t,e,i){var r=-1,o=Glt,l=t.length,d=!0,h=[],p=h;if(l>=xht){var g=e?null:Nht(t);if(g)return Soe(g);d=!1,o=oIe,p=new SH}else p=e?[]:h;e:for(;++r<l;){var f=t[r],y=e?e(f):f;if(f=f!==0?f:0,d&&y===y){for(var T=p.length;T--;)if(p[T]===y)continue e;e&&p.push(y),h.push(f)}else o(p,y,i)||(p!==h&&p.push(y),h.push(f))}return h}function Fht(t,e){return t&&t.length?Bht(t,gIe(e)):[]}let Vy=class{eventListeners=new Map;static unsubscribe(e){for(const i of e)wW(i)&&i()}addEventListener(e,i){if(!wW(i))throw new Error("Cannot subscribe to an event without a handler function");const r=this.eventListeners.get(e)||[];return r.push(i),this.eventListeners.set(e,r),()=>this.removeEventListener(e,i)}removeEventListener(e,i){if(this.eventListeners.has(e)){const o=(this.eventListeners.get(e)||[]).filter(l=>l!==i);this.eventListeners.set(e,o)}}emit(e,i){(this.eventListeners.get(e)||[]).forEach(o=>setTimeout(()=>o(i)))}};function vIe(t,e,i){return t.addEventListener(e,i),()=>{t&&t.removeEventListener(e,i)}}function _oe(t){const[e,i]=$.useState(!1);return $.useEffect(()=>{if(!t)return;const r=[t.display.on("full-screen-change",()=>i(t?.display.isFullScreen))];return i(t?.display.isFullScreen),()=>Vy.unsubscribe(r)},[e,t]),e}function Uht({services:t,dividerDirection:e,paneConfigs:i}){const[r,o]=$.useState([]),l=_oe(t);$.useEffect(()=>{o([])},[l]),$.useEffect(()=>{const h=i.map((f,y)=>{const T=r[y];if(!mIe(T))return mIe(f.maxSizePx)?f.maxSizePx:"auto";const C=f.minSizePx??0;if(T<C)return C;const E=f.maxSizePx??Number.POSITIVE_INFINITY;return T>E?E:T}),p=h.findIndex((f,y)=>f!==r[y]);if(p===-1)return;const g=h.map((f,y)=>y===p?f:"auto");o(g)},[i,r]);const d=i.map(h=>Da.jsx(_W,{minSize:h.minSizePx,maxSize:h.maxSizePx,children:h.component},h.key));return Da.jsx(Qst,{className:"split-pane",split:e,sizes:r,onChange:o,sashRender:(h,p)=>Da.jsx(cAe,{className:`line-wrapper ${p?"active":"inactive"}`,children:[Da.jsx("span",{className:`line ${e}`},"line")]}),children:d})}const zht=["Top","Right","Bottom","Left"];function bH(t,e,...i){const[r,o=r,l=r,d=o]=i,h=[r,o,l,d],p={};for(let g=0;g<h.length;g+=1)if(h[g]||h[g]===0){const f=t+zht[g]+e;p[f]=h[g]}return p}function Eoe(...t){return bH("border","Width",...t)}function Aoe(...t){return bH("border","Style",...t)}function Ioe(...t){return bH("border","Color",...t)}const Vht=["none","hidden","dotted","dashed","solid","double","groove","ridge","inset","outset"];function TH(t){return Vht.includes(t)}function $ht(...t){return TH(t[0])?Object.assign({},Aoe(t[0]),t[1]&&Eoe(t[1]),t[2]&&Ioe(t[2])):Object.assign({},Eoe(t[0]),t[1]&&Aoe(t[1]),t[2]&&Ioe(t[2]))}function Hht(...t){return TH(t[0])?Object.assign({borderLeftStyle:t[0]},t[1]&&{borderLeftWidth:t[1]},t[2]&&{borderLeftColor:t[2]}):Object.assign({borderLeftWidth:t[0]},t[1]&&{borderLeftStyle:t[1]},t[2]&&{borderLeftColor:t[2]})}function jht(...t){return TH(t[0])?Object.assign({borderBottomStyle:t[0]},t[1]&&{borderBottomWidth:t[1]},t[2]&&{borderBottomColor:t[2]}):Object.assign({borderBottomWidth:t[0]},t[1]&&{borderBottomStyle:t[1]},t[2]&&{borderBottomColor:t[2]})}function Ght(...t){return TH(t[0])?Object.assign({borderRightStyle:t[0]},t[1]&&{borderRightWidth:t[1]},t[2]&&{borderRightColor:t[2]}):Object.assign({borderRightWidth:t[0]},t[1]&&{borderRightStyle:t[1]},t[2]&&{borderRightColor:t[2]})}function qht(...t){return TH(t[0])?Object.assign({borderTopStyle:t[0]},t[1]&&{borderTopWidth:t[1]},t[2]&&{borderTopColor:t[2]}):Object.assign({borderTopWidth:t[0]},t[1]&&{borderTopStyle:t[1]},t[2]&&{borderTopColor:t[2]})}function Wht(t,e=t,i=t,r=e){return{borderBottomRightRadius:i,borderBottomLeftRadius:r,borderTopRightRadius:e,borderTopLeftRadius:t}}const Kht=t=>typeof t=="string"&&/(\d+(\w+|%))/.test(t),LW=t=>typeof t=="number"&&!Number.isNaN(t),Jht=t=>t==="initial",yIe=t=>t==="auto",Yht=t=>t==="none",Qht=["content","fit-content","max-content","min-content"],woe=t=>Qht.some(e=>t===e)||Kht(t);function Zht(...t){const e=t.length===1,i=t.length===2,r=t.length===3;if(e){const[o]=t;if(Jht(o))return{flexGrow:0,flexShrink:1,flexBasis:"auto"};if(yIe(o))return{flexGrow:1,flexShrink:1,flexBasis:"auto"};if(Yht(o))return{flexGrow:0,flexShrink:0,flexBasis:"auto"};if(LW(o))return{flexGrow:o,flexShrink:1,flexBasis:0};if(woe(o))return{flexGrow:1,flexShrink:1,flexBasis:o}}if(i){const[o,l]=t;if(LW(l))return{flexGrow:o,flexShrink:l,flexBasis:0};if(woe(l))return{flexGrow:o,flexShrink:1,flexBasis:l}}if(r){const[o,l,d]=t;if(LW(o)&&LW(l)&&(yIe(d)||woe(d)))return{flexGrow:o,flexShrink:l,flexBasis:d}}return process.env.NODE_ENV!=="production"&&console.error("The value passed to shorthands.flex did not match any flex property specs. The CSS styles were not generated. Please, check the flex documentation."),{}}function Xht(t,e=t){return{columnGap:t,rowGap:e}}const ept=/var\(.*\)/gi;function tpt(t){return t===void 0||typeof t=="number"||typeof t=="string"&&!ept.test(t)}const ipt=/^[a-zA-Z0-9\-_\\#;]+$/,npt=/^-moz-initial$|^auto$|^initial$|^inherit$|^revert$|^unset$|^span \d+$|^\d.*/;function koe(t){return t!==void 0&&typeof t=="string"&&ipt.test(t)&&!npt.test(t)}function apt(...t){if(t.some(l=>!tpt(l)))return process.env.NODE_ENV!=="production"&&console.error("The value passed to shorthands.gridArea() did not match any gridArea property specs. The CSS styles were not generated. Please, check the gridArea documentation.",["The value passed to shorthands.gridArea() did not match any gridArea property specs. ",`The CSS styles were not generated.
`,"Please, check the `grid-area` documentation:\n","- https://developer.mozilla.org/docs/Web/CSS/grid-area","- https://griffel.js.org/react/api/shorthands#shorthandsgridarea"].join("")),{};const e=t[0]!==void 0?t[0]:"auto",i=t[1]!==void 0?t[1]:koe(e)?e:"auto",r=t[2]!==void 0?t[2]:koe(e)?e:"auto",o=t[3]!==void 0?t[3]:koe(i)?i:"auto";return{gridRowStart:e,gridColumnStart:i,gridRowEnd:r,gridColumnEnd:o}}function rpt(...t){return bH("margin","",...t)}function opt(t,e=t){return{marginBlockStart:t,marginBlockEnd:e}}function spt(t,e=t){return{marginInlineStart:t,marginInlineEnd:e}}function lpt(...t){return bH("padding","",...t)}function cpt(t,e=t){return{paddingBlockStart:t,paddingBlockEnd:e}}function dpt(t,e=t){return{paddingInlineStart:t,paddingInlineEnd:e}}function upt(t,e=t){return{overflowX:t,overflowY:e}}function hpt(...t){const[e,i=e,r=e,o=i]=t;return{top:e,right:i,bottom:r,left:o}}function ppt(t,e,i){return Object.assign({outlineWidth:t},e&&{outlineStyle:e},i&&{outlineColor:i})}function gpt(...t){return fpt(t)?{transitionDelay:t[0],transitionDuration:t[0],transitionProperty:t[0],transitionTimingFunction:t[0]}:vpt(t).reduce((i,[r,o="0s",l="0s",d="ease"],h)=>(h===0?(i.transitionProperty=r,i.transitionDuration=o,i.transitionDelay=l,i.transitionTimingFunction=d):(i.transitionProperty+=`, ${r}`,i.transitionDuration+=`, ${o}`,i.transitionDelay+=`, ${l}`,i.transitionTimingFunction+=`, ${d}`),i),{})}const mpt=["-moz-initial","inherit","initial","revert","unset"];function fpt(t){return t.length===1&&mpt.includes(t[0])}function vpt(t){return t.length===1&&Array.isArray(t[0])?t[0]:[t]}function ypt(t,...e){if(e.length===0)return bpt(t)?{textDecorationStyle:t}:{textDecorationLine:t};const[i,r,o]=e;return Object.assign({textDecorationLine:t},i&&{textDecorationStyle:i},r&&{textDecorationColor:r},o&&{textDecorationThickness:o})}const Spt=["dashed","dotted","double","solid","wavy"];function bpt(t){return Spt.includes(t)}const Roe=typeof window>"u"?global:window,Moe="@griffel/";function SIe(t,e){return Roe[Symbol.for(Moe+t)]||(Roe[Symbol.for(Moe+t)]=e),Roe[Symbol.for(Moe+t)]}const OW=SIe("DEBUG_RESET_CLASSES",{}),CH=SIe("DEFINITION_LOOKUP_TABLE",{}),_H="data-make-styles-bucket",Tpt="data-priority",Poe="f",Cpt="r",EH=7,$w="___",bIe="_",TIe=process.env.NODE_ENV==="production"?$w.length+EH:$w.length+EH+bIe.length+EH,_pt=0,CIe=1,Ept={all:1,borderColor:1,borderStyle:1,borderWidth:1,borderBlock:1,borderBlockEnd:1,borderBlockStart:1,borderInline:1,borderInlineEnd:1,borderInlineStart:1},Doe="DO_NOT_USE_DIRECTLY: @griffel/reset-value";function _x(t){for(var e=0,i,r=0,o=t.length;o>=4;++r,o-=4)i=t.charCodeAt(r)&255|(t.charCodeAt(++r)&255)<<8|(t.charCodeAt(++r)&255)<<16|(t.charCodeAt(++r)&255)<<24,i=(i&65535)*1540483477+((i>>>16)*59797<<16),i^=i>>>24,e=(i&65535)*1540483477+((i>>>16)*59797<<16)^(e&65535)*1540483477+((e>>>16)*59797<<16);switch(o){case 3:e^=(t.charCodeAt(r+2)&255)<<16;case 2:e^=(t.charCodeAt(r+1)&255)<<8;case 1:e^=t.charCodeAt(r)&255,e=(e&65535)*1540483477+((e>>>16)*59797<<16)}return e^=e>>>13,e=(e&65535)*1540483477+((e>>>16)*59797<<16),((e^e>>>15)>>>0).toString(36)}function Loe(t){const e=t.length;if(e===EH)return t;for(let i=e;i<EH;i++)t+="0";return t}function _Ie(t,e,i=[]){return process.env.NODE_ENV==="production"?$w+Loe(_x(t+e)):$w+Loe(_x(t+e))+bIe+Loe(_x(i.join("")))}function EIe(t,e){let i="",r="";for(const o in t){const l=t[o];if(l===0){r+=o+" ";continue}const d=Array.isArray(l),h=e==="rtl"?(d?l[1]:l)+" ":(d?l[0]:l)+" ";i+=h,r+=h}return[i.slice(0,-1),r.slice(0,-1)]}function NW(t,e){const i={};for(const r in t){const[o,l]=EIe(t[r],e);if(l===""){i[r]="";continue}const d=_Ie(l,e),h=d+(o===""?"":" "+o);CH[d]=[t[r],e],i[r]=h}return i}const xW={};function ea(){let t=null,e="",i="";const r=new Array(arguments.length);let o="";for(let T=0;T<arguments.length;T++){const C=arguments[T];if(typeof C=="string"&&C!==""){const E=C.indexOf($w);if(E===-1)process.env.NODE_ENV!=="production"&&C.split(" ").forEach(I=>{I.startsWith(Cpt)&&OW[I]&&(o?console.error(`mergeClasses(): a passed string contains multiple classes produced by makeResetStyles (${C} & ${e}, this will lead to non-deterministic behavior. Learn more:https://griffel.js.org/react/api/make-reset-styles#limitations
Source string: ${C}`):o=I)}),e+=C+" ";else{const I=C.substr(E,TIe);E>0&&(e+=C.slice(0,E)),i+=I,r[T]=I}process.env.NODE_ENV!=="production"&&C.indexOf($w,E+1)!==-1&&console.error(`mergeClasses(): a passed string contains multiple identifiers of atomic classes (classes that start with "${$w}"), it's possible that passed classes were concatenated in a wrong way. Source string: ${C}`)}}if(i==="")return e.slice(0,-1);const l=xW[i];if(l!==void 0)return e+l;const d=[];for(let T=0;T<arguments.length;T++){const C=r[T];if(C){const E=CH[C];E?(d.push(E[_pt]),process.env.NODE_ENV!=="production"&&t!==null&&t!==E[CIe]&&console.error(`mergeClasses(): a passed string contains an identifier (${C}) that has different direction (dir="${E[1]?"rtl":"ltr"}") setting than other classes. This is not supported. Source string: ${arguments[T]}`),t=E[CIe]):process.env.NODE_ENV!=="production"&&console.error(`mergeClasses(): a passed string contains an identifier (${C}) that does not match any entry in cache. Source string: ${arguments[T]}`)}}const h=Object.assign.apply(Object,[{}].concat(d)),[p,g]=EIe(h,t),f=_Ie(g,t,r),y=f+" "+p;return xW[i]=y,CH[f]=[h,t],e+y}const AIe={},IIe=new Set,Ex={getChildrenSequences:t=>{const e=Object.keys(xW).find(i=>xW[i].startsWith(t));return e?e.split($w).filter(i=>i.length).map(i=>$w+i):[]},addCSSRule:t=>{IIe.add(t)},addSequenceDetails:(t,e)=>{Object.entries(t).forEach(([i,r])=>{AIe[r.substring(0,TIe)]={slotName:i,sourceURL:e}})},getCSSRules:()=>Array.from(IIe),getSequenceDetails:t=>AIe[t]};function wIe(t,e){return Array.isArray(t)?e==="rtl"?t[1]:t[0]:t||""}function Apt(t,e,i,r){const o=t[0],l=t[1];return Object.entries(o).map(([d,h])=>{const p=wIe(h,l);let g;if(i&&e){const f=i.find(({className:y})=>y===p);!f&&e[0][d]?g=wIe(e[0][d],e[1]):f&&e[0][d]?g=(r?r.filter(({debugClassNames:T})=>T.filter(({className:C})=>C===p).length>0).length>0:!1)?f.className:f.overriddenBy:(!f&&!e[0][d]||f&&!e[0][d])&&(g=void 0)}return{className:p,overriddenBy:g}})}function kIe(t,e){const i=CH[t];if(i===void 0)return;const r=e?CH[e.sequenceHash]:void 0,o=Apt(i,r,e?.debugClassNames,e?.children),l={sequenceHash:t,direction:i[1],children:[],debugClassNames:o};return Ex.getChildrenSequences(l.sequenceHash).reverse().forEach(h=>{const p=kIe(h,l);p&&l.children.push(p)}),l.children.length||(l.rules={},l.debugClassNames.forEach(({className:h})=>{const p=Ex.getSequenceDetails(t);p&&(l.slot=p.slotName,l.sourceURL=p.sourceURL);const g=Ex.getCSSRules().find(f=>f.includes(h));l.rules[h]=g})),l}function Ipt(t){if(OW[t]===void 0)return;const r={sequenceHash:t,direction:"ltr",children:[],debugClassNames:[{className:t}]};r.rules={},r.slot="makeResetStyles()";const[{className:o}]=r.debugClassNames,l=Ex.getCSSRules().filter(d=>d.includes(`.${o}`));return r.rules[o]=l.join(""),r}function wpt(t,e){const i=t?kIe(t):void 0,r=e?Ipt(e):void 0;return!i&&!r?void 0:i?r?{sequenceHash:i.sequenceHash+r.sequenceHash,direction:i.direction,children:[i,r],debugClassNames:[...i.debugClassNames,...r.debugClassNames]}:i:r}function kpt(t){const e=t.defaultView;if(!e||e.__GRIFFEL_DEVTOOLS__)return;const i={getInfo:r=>{let o,l;for(const d of r.classList)d.startsWith($w)&&(o=d),OW[d]&&(l=d);return wpt(o,l)}};Object.defineProperty(e,"__GRIFFEL_DEVTOOLS__",{configurable:!1,enumerable:!1,get(){return i}})}const g5=(()=>{var t;try{return!!(typeof window<"u"&&(!((t=window.sessionStorage)===null||t===void 0)&&t.getItem("__GRIFFEL_DEVTOOLS__")))}catch{return!1}})();function Rpt(t){if(!Array.isArray(t))return[t];if(process.env.NODE_ENV!=="production"&&t.length>2)throw new Error("CSS Bucket contains an entry with greater than 2 items, please report this to https://github.com/microsoft/griffel/issues");return t}function Mpt(t,e,i,r){const o=[];if(r[_H]=e,r[Tpt]=String(i),t)for(const d in r)t.setAttribute(d,r[d]);function l(d){return t?.sheet?t.sheet.insertRule(d,t.sheet.cssRules.length):o.push(d)}return{elementAttributes:r,insertRule:l,element:t,bucketName:e,cssRules(){return t?.sheet?Array.from(t.sheet.cssRules).map(d=>d.cssText):o}}}const RIe=["r","d","l","v","w","f","i","h","a","s","k","t","m","c"].reduce((t,e,i)=>(t[e]=i,t),{});function Ppt(t,e,i){return(t==="m"?t+e:t)+i}function Dpt(t,e,i,r,o={}){var l,d;const h=t==="m",p=(l=o.m)!==null&&l!==void 0?l:"0",g=(d=o.p)!==null&&d!==void 0?d:0,f=Ppt(t,p,g);if(!r.stylesheets[f]){const y=e&&e.createElement("style"),T=Mpt(y,t,g,Object.assign({},r.styleElementAttributes,h&&{media:p}));r.stylesheets[f]=T,e?.head&&y&&e.head.insertBefore(y,Opt(e,i,t,r,o))}return r.stylesheets[f]}function Lpt(t,e,i){var r,o;const l=e+((r=i.m)!==null&&r!==void 0?r:""),d=t.getAttribute(_H)+((o=t.media)!==null&&o!==void 0?o:"");return l===d}function Opt(t,e,i,r,o={}){var l,d;const h=RIe[i],p=(l=o.m)!==null&&l!==void 0?l:"",g=(d=o.p)!==null&&d!==void 0?d:0;let f=I=>h-RIe[I.getAttribute(_H)],y=t.head.querySelectorAll(`[${_H}]`);if(i==="m"){const I=t.head.querySelectorAll(`[${_H}="${i}"]`);I.length&&(y=I,f=w=>r.compareMediaQueries(p,w.media))}const T=I=>Lpt(I,i,o)?g-Number(I.getAttribute("data-priority")):f(I),C=y.length;let E=C-1;for(;E>=0;){const I=y.item(E);if(T(I)>0)return I.nextSibling;E--}return C>0?y.item(0):e?e.nextSibling:null}const Npt=["-moz-placeholder","-moz-focus-inner","-moz-focusring","-ms-input-placeholder","-moz-read-write","-moz-read-only"].join("|"),xpt=new RegExp(`:(${Npt})`);function MIe(t,e){try{t.insertRule(e)}catch(i){process.env.NODE_ENV!=="production"&&!xpt.test(e)&&console.error(`There was a problem inserting the following rule: "${e}"`,i)}}let Bpt=0;const Fpt=(t,e)=>t<e?-1:t>e?1:0;function Upt(t=typeof document>"u"?void 0:document,e={}){const{classNameHashSalt:i,unstable_filterCSSRule:r,insertionPoint:o,styleElementAttributes:l,compareMediaQueries:d=Fpt}=e,h={classNameHashSalt:i,insertionCache:{},stylesheets:{},styleElementAttributes:Object.freeze(l),compareMediaQueries:d,id:`d${Bpt++}`,insertCSSRules(p){for(const g in p){const f=p[g];for(let y=0,T=f.length;y<T;y++){const[C,E]=Rpt(f[y]),I=Dpt(g,t,o||null,h,E);h.insertionCache[C]||(h.insertionCache[C]=g,process.env.NODE_ENV!=="production"&&g5&&Ex.addCSSRule(C),r?r(C)&&MIe(I,C):MIe(I,C))}}}};return t&&process.env.NODE_ENV!=="production"&&g5&&kpt(t),h}const Ooe="<unknown>";function zpt(t){return jpt(t)||Wpt(t)||Jpt(t)}const Vpt=/^\s*at (.*?) ?\(((?:file|https?|blob|chrome-extension|native|eval|webpack|<anonymous>|\/|[a-z]:\\|\\\\).*?)?\)?\s*$/i,$pt=/^\s*at ()((?:file|https?|blob|chrome-extension|native|eval|webpack|<anonymous>|\/|[a-z]:\\|\\\\).*?)\s*$/i,Hpt=/\((\S*)\)/;function jpt(t){const e=Vpt.exec(t)||$pt.exec(t);if(!e)return null;let i=e[2];const r=i&&i.indexOf("native")===0,o=i&&i.indexOf("eval")===0,l=Hpt.exec(i);return o&&l!=null&&(i=l[1]),{loc:r?null:e[2],name:e[1]||Ooe}}const Gpt=/^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|\[native).*?|[^@]*bundle)\s*$/i,qpt=/(\S+) line (\d+)(?: > eval line \d+)* > eval/i;function Wpt(t){const e=Gpt.exec(t);if(!e)return null;let i=e[3];const r=i&&i.indexOf(" > eval")>-1,o=qpt.exec(i);return r&&o!=null&&(i=o[1]),{loc:e[3],name:e[1]||Ooe}}const Kpt=/^\s*(?:([^@]*)(?:\((.*?)\))?@)?(\S.*?)\s*$/i;function Jpt(t){const e=Kpt.exec(t);return e?{loc:e[3],name:e[1]||Ooe}:null}function PIe(){const t=String(new Error().stack).split(`
`),e=Ypt(t);if(e===void 0)return;const i=zpt(e);return i?.loc}function Ypt(t){for(let e=t.length-1;e>=0;--e)if(t[e].includes("at getSourceURLfromError"))return t[e+3]}const Noe=()=>{const t={};return function(i,r){t[i.id]===void 0&&(i.insertCSSRules(r),t[i.id]=!0)}};function DIe(t){return t.reduce(function(e,i){var r=i[0],o=i[1];return e[r]=o,e[o]=r,e},{})}function Qpt(t){return typeof t=="boolean"}function Zpt(t){return typeof t=="function"}function AH(t){return typeof t=="number"}function Xpt(t){return t===null||typeof t>"u"}function egt(t){return t&&typeof t=="object"}function tgt(t){return typeof t=="string"}function BW(t,e){return t.indexOf(e)!==-1}function igt(t){return parseFloat(t)===0?t:t[0]==="-"?t.slice(1):"-"+t}function FW(t,e,i,r){return e+igt(i)+r}function ngt(t){var e=t.indexOf(".");if(e===-1)t=100-parseFloat(t)+"%";else{var i=t.length-e-2;t=100-parseFloat(t),t=t.toFixed(i)+"%"}return t}function LIe(t){return t.replace(/ +/g," ").split(" ").map(function(e){return e.trim()}).filter(Boolean).reduce(function(e,i){var r=e.list,o=e.state,l=(i.match(/\(/g)||[]).length,d=(i.match(/\)/g)||[]).length;return o.parensDepth>0?r[r.length-1]=r[r.length-1]+" "+i:r.push(i),o.parensDepth+=l-d,{list:r,state:o}},{list:[],state:{parensDepth:0}}).list}function OIe(t){var e=LIe(t);if(e.length<=3||e.length>4)return t;var i=e[0],r=e[1],o=e[2],l=e[3];return[i,l,o,r].join(" ")}function agt(t){return!Qpt(t)&&!Xpt(t)}function rgt(t){for(var e=[],i=0,r=0,o=!1;r<t.length;)!o&&t[r]===","?(e.push(t.substring(i,r).trim()),r++,i=r):t[r]==="("?(o=!0,r++):(t[r]===")"&&(o=!1),r++);return i!=r&&e.push(t.substring(i,r+1)),e}var ia={padding:function(e){var i=e.value;return AH(i)?i:OIe(i)},textShadow:function(e){var i=e.value,r=rgt(i).map(function(o){return o.replace(/(^|\s)(-*)([.|\d]+)/,function(l,d,h,p){if(p==="0")return l;var g=h===""?"-":"";return""+d+g+p})});return r.join(",")},borderColor:function(e){var i=e.value;return OIe(i)},borderRadius:function(e){var i=e.value;if(AH(i))return i;if(BW(i,"/")){var r=i.split("/"),o=r[0],l=r[1],d=ia.borderRadius({value:o.trim()}),h=ia.borderRadius({value:l.trim()});return d+" / "+h}var p=LIe(i);switch(p.length){case 2:return p.reverse().join(" ");case 4:{var g=p[0],f=p[1],y=p[2],T=p[3];return[f,g,T,y].join(" ")}default:return i}},background:function(e){var i=e.value,r=e.valuesToConvert,o=e.isRtl,l=e.bgImgDirectionRegex,d=e.bgPosDirectionRegex;if(AH(i))return i;var h=i.replace(/(url\(.*?\))|(rgba?\(.*?\))|(hsl\(.*?\))|(#[a-fA-F0-9]+)|((^| )(\D)+( |$))/g,"").trim();return i=i.replace(h,ia.backgroundPosition({value:h,valuesToConvert:r,isRtl:o,bgPosDirectionRegex:d})),ia.backgroundImage({value:i,valuesToConvert:r,bgImgDirectionRegex:l})},backgroundImage:function(e){var i=e.value,r=e.valuesToConvert,o=e.bgImgDirectionRegex;return!BW(i,"url(")&&!BW(i,"linear-gradient(")?i:i.replace(o,function(l,d,h){return l.replace(h,r[h])})},backgroundPosition:function(e){var i=e.value,r=e.valuesToConvert,o=e.isRtl,l=e.bgPosDirectionRegex;return i.replace(o?/^((-|\d|\.)+%)/:null,function(d,h){return ngt(h)}).replace(l,function(d){return r[d]})},backgroundPositionX:function(e){var i=e.value,r=e.valuesToConvert,o=e.isRtl,l=e.bgPosDirectionRegex;return AH(i)?i:ia.backgroundPosition({value:i,valuesToConvert:r,isRtl:o,bgPosDirectionRegex:l})},transition:function(e){var i=e.value,r=e.propertiesToConvert;return i.split(/,\s*/g).map(function(o){var l=o.split(" ");return l[0]=r[l[0]]||l[0],l.join(" ")}).join(", ")},transitionProperty:function(e){var i=e.value,r=e.propertiesToConvert;return i.split(/,\s*/g).map(function(o){return r[o]||o}).join(", ")},transform:function(e){var i=e.value,r="[^\\u0020-\\u007e]",o="(?:(?:(?:\\[0-9a-f]{1,6})(?:\\r\\n|\\s)?)|\\\\[^\\r\\n\\f0-9a-f])",l="((?:-?"+("(?:[0-9]*\\.[0-9]+|[0-9]+)(?:\\s*(?:em|ex|px|cm|mm|in|pt|pc|deg|rad|grad|ms|s|hz|khz|%)|"+("-?"+("(?:[_a-z]|"+r+"|"+o+")")+("(?:[_a-z0-9-]|"+r+"|"+o+")")+"*")+")?")+")|(?:inherit|auto))",d=new RegExp("(translateX\\s*\\(\\s*)"+l+"(\\s*\\))","gi"),h=new RegExp("(translate\\s*\\(\\s*)"+l+"((?:\\s*,\\s*"+l+"){0,1}\\s*\\))","gi"),p=new RegExp("(translate3d\\s*\\(\\s*)"+l+"((?:\\s*,\\s*"+l+"){0,2}\\s*\\))","gi"),g=new RegExp("(rotate[ZY]?\\s*\\(\\s*)"+l+"(\\s*\\))","gi");return i.replace(d,FW).replace(h,FW).replace(p,FW).replace(g,FW)}};ia.objectPosition=ia.backgroundPosition,ia.margin=ia.padding,ia.borderWidth=ia.padding,ia.boxShadow=ia.textShadow,ia.webkitBoxShadow=ia.boxShadow,ia.mozBoxShadow=ia.boxShadow,ia.WebkitBoxShadow=ia.boxShadow,ia.MozBoxShadow=ia.boxShadow,ia.borderStyle=ia.borderColor,ia.webkitTransform=ia.transform,ia.mozTransform=ia.transform,ia.WebkitTransform=ia.transform,ia.MozTransform=ia.transform,ia.transformOrigin=ia.backgroundPosition,ia.webkitTransformOrigin=ia.transformOrigin,ia.mozTransformOrigin=ia.transformOrigin,ia.WebkitTransformOrigin=ia.transformOrigin,ia.MozTransformOrigin=ia.transformOrigin,ia.webkitTransition=ia.transition,ia.mozTransition=ia.transition,ia.WebkitTransition=ia.transition,ia.MozTransition=ia.transition,ia.webkitTransitionProperty=ia.transitionProperty,ia.mozTransitionProperty=ia.transitionProperty,ia.WebkitTransitionProperty=ia.transitionProperty,ia.MozTransitionProperty=ia.transitionProperty,ia["text-shadow"]=ia.textShadow,ia["border-color"]=ia.borderColor,ia["border-radius"]=ia.borderRadius,ia["background-image"]=ia.backgroundImage,ia["background-position"]=ia.backgroundPosition,ia["background-position-x"]=ia.backgroundPositionX,ia["object-position"]=ia.objectPosition,ia["border-width"]=ia.padding,ia["box-shadow"]=ia.textShadow,ia["-webkit-box-shadow"]=ia.textShadow,ia["-moz-box-shadow"]=ia.textShadow,ia["border-style"]=ia.borderColor,ia["-webkit-transform"]=ia.transform,ia["-moz-transform"]=ia.transform,ia["transform-origin"]=ia.transformOrigin,ia["-webkit-transform-origin"]=ia.transformOrigin,ia["-moz-transform-origin"]=ia.transformOrigin,ia["-webkit-transition"]=ia.transition,ia["-moz-transition"]=ia.transition,ia["transition-property"]=ia.transitionProperty,ia["-webkit-transition-property"]=ia.transitionProperty,ia["-moz-transition-property"]=ia.transitionProperty;var NIe=DIe([["paddingLeft","paddingRight"],["marginLeft","marginRight"],["left","right"],["borderLeft","borderRight"],["borderLeftColor","borderRightColor"],["borderLeftStyle","borderRightStyle"],["borderLeftWidth","borderRightWidth"],["borderTopLeftRadius","borderTopRightRadius"],["borderBottomLeftRadius","borderBottomRightRadius"],["padding-left","padding-right"],["margin-left","margin-right"],["border-left","border-right"],["border-left-color","border-right-color"],["border-left-style","border-right-style"],["border-left-width","border-right-width"],["border-top-left-radius","border-top-right-radius"],["border-bottom-left-radius","border-bottom-right-radius"]]),ogt=["content"],xIe=DIe([["ltr","rtl"],["left","right"],["w-resize","e-resize"],["sw-resize","se-resize"],["nw-resize","ne-resize"]]),sgt=new RegExp("(^|\\W|_)((ltr)|(rtl)|(left)|(right))(\\W|_|$)","g"),lgt=new RegExp("(left)|(right)");function BIe(t){return Object.keys(t).reduce(function(e,i){var r=t[i];if(tgt(r)&&(r=r.trim()),BW(ogt,i))return e[i]=r,e;var o=xoe(i,r),l=o.key,d=o.value;return e[l]=d,e},Array.isArray(t)?[]:{})}function xoe(t,e){var i=/\/\*\s?@noflip\s?\*\//.test(e),r=i?t:cgt(t),o=i?e:dgt(r,e);return{key:r,value:o}}function cgt(t){return NIe[t]||t}function dgt(t,e){if(!agt(e))return e;if(egt(e))return BIe(e);var i=AH(e),r=Zpt(e),o=i||r?e:e.replace(/ !important.*?$/,""),l=!i&&o.length!==e.length,d=ia[t],h;return d?h=d({value:o,valuesToConvert:xIe,propertiesToConvert:NIe,isRtl:!0,bgImgDirectionRegex:sgt,bgPosDirectionRegex:lgt}):h=xIe[o]||o,l?h+" !important":h}const ugt=/[A-Z]/g,hgt=/^ms-/,Boe={};function pgt(t){return"-"+t.toLowerCase()}function m5(t){if(Object.prototype.hasOwnProperty.call(Boe,t))return Boe[t];if(t.substr(0,2)==="--")return t;const e=t.replace(ugt,pgt);return Boe[t]=hgt.test(e)?"-"+e:e}function FIe(t){return t.charAt(0)==="&"?t.slice(1):t}var IH="-moz-",gA="-webkit-",UIe="comm",UW="rule",Foe="decl",ggt="@media",mgt="@import",fgt="@supports",vgt="@namespace",ygt="@keyframes",zIe="@layer",VIe=Math.abs,zW=String.fromCharCode,Sgt=Object.assign;function bgt(t,e){return $y(t,0)^45?(((e<<2^$y(t,0))<<2^$y(t,1))<<2^$y(t,2))<<2^$y(t,3):0}function $Ie(t){return t.trim()}function HIe(t,e){return(t=e.exec(t))?t[0]:t}function sT(t,e,i){return t.replace(e,i)}function jIe(t,e,i){return t.indexOf(e,i)}function $y(t,e){return t.charCodeAt(e)|0}function f5(t,e,i){return t.slice(e,i)}function mA(t){return t.length}function GIe(t){return t.length}function Ax(t,e){return e.push(t),t}function Tgt(t,e){return t.map(e).join("")}var VW=1,v5=1,qIe=0,wC=0,Hh=0,y5="";function $W(t,e,i,r,o,l,d,h){return{value:t,root:e,parent:i,type:r,props:o,children:l,line:VW,column:v5,length:d,return:"",siblings:h}}function Uoe(t,e){return Sgt($W("",null,null,"",null,null,0,t.siblings),t,{length:-t.length},e)}function Cgt(){return Hh}function _gt(){return Hh=wC>0?$y(y5,--wC):0,v5--,Hh===10&&(v5=1,VW--),Hh}function TE(){return Hh=wC<qIe?$y(y5,wC++):0,v5++,Hh===10&&(v5=1,VW++),Hh}function LL(){return $y(y5,wC)}function HW(){return wC}function jW(t,e){return f5(y5,t,e)}function S5(t){switch(t){case 0:case 9:case 10:case 13:case 32:return 5;case 33:case 43:case 44:case 47:case 62:case 64:case 126:case 59:case 123:case 125:return 4;case 58:return 3;case 34:case 39:case 40:case 91:return 2;case 41:case 93:return 1}return 0}function WIe(t){return VW=v5=1,qIe=mA(y5=t),wC=0,[]}function KIe(t){return y5="",t}function GW(t){return $Ie(jW(wC-1,zoe(t===91?t+2:t===40?t+1:t)))}function Egt(t){return KIe(Igt(WIe(t)))}function Agt(t){for(;(Hh=LL())&&Hh<33;)TE();return S5(t)>2||S5(Hh)>3?"":" "}function Igt(t){for(;TE();)switch(S5(Hh)){case 0:Ax(JIe(wC-1),t);break;case 2:Ax(GW(Hh),t);break;default:Ax(zW(Hh),t)}return t}function wgt(t,e){for(;--e&&TE()&&!(Hh<48||Hh>102||Hh>57&&Hh<65||Hh>70&&Hh<97););return jW(t,HW()+(e<6&&LL()==32&&TE()==32))}function zoe(t){for(;TE();)switch(Hh){case t:return wC;case 34:case 39:t!==34&&t!==39&&zoe(Hh);break;case 40:t===41&&zoe(t);break;case 92:TE();break}return wC}function kgt(t,e){for(;TE()&&t+Hh!==57;)if(t+Hh===84&&LL()===47)break;return"/*"+jW(e,wC-1)+"*"+zW(t===47?t:TE())}function JIe(t){for(;!S5(LL());)TE();return jW(t,wC)}function YIe(t){return KIe(qW("",null,null,null,[""],t=WIe(t),0,[0],t))}function qW(t,e,i,r,o,l,d,h,p){for(var g=0,f=0,y=d,T=0,C=0,E=0,I=1,w=1,D=1,F=0,x="",B=o,L=l,z=r,H=x;w;)switch(E=F,F=TE()){case 40:if(E!=108&&$y(H,y-1)==58){jIe(H+=sT(GW(F),"&","&\f"),"&\f",VIe(g?h[g-1]:0))!=-1&&(D=-1);break}case 34:case 39:case 91:H+=GW(F);break;case 9:case 10:case 13:case 32:H+=Agt(E);break;case 92:H+=wgt(HW()-1,7);continue;case 47:switch(LL()){case 42:case 47:Ax(Rgt(kgt(TE(),HW()),e,i,p),p),(S5(E||1)==5||S5(LL()||1)==5)&&mA(H)&&f5(H,-1,void 0)!==" "&&(H+=" ");break;default:H+="/"}break;case 123*I:h[g++]=mA(H)*D;case 125*I:case 59:case 0:switch(F){case 0:case 125:w=0;case 59+f:D==-1&&(H=sT(H,/\f/g,"")),C>0&&(mA(H)-y||I===0&&E===47)&&Ax(C>32?ZIe(H+";",r,i,y-1,p):ZIe(sT(H," ","")+";",r,i,y-2,p),p);break;case 59:H+=";";default:if(Ax(z=QIe(H,e,i,g,f,o,h,x,B=[],L=[],y,l),l),F===123)if(f===0)qW(H,e,z,z,B,l,y,h,L);else{switch(T){case 99:if($y(H,3)===110)break;case 108:if($y(H,2)===97)break;default:f=0;case 100:case 109:case 115:}f?qW(t,z,z,r&&Ax(QIe(t,z,z,0,0,o,h,x,o,B=[],y,L),L),o,L,y,h,r?B:L):qW(H,z,z,z,[""],L,0,h,L)}}g=f=C=0,I=D=1,x=H="",y=d;break;case 58:y=1+mA(H),C=E;default:if(I<1){if(F==123)--I;else if(F==125&&I++==0&&_gt()==125)continue}switch(H+=zW(F),F*I){case 38:D=f>0?1:(H+="\f",-1);break;case 44:h[g++]=(mA(H)-1)*D,D=1;break;case 64:LL()===45&&(H+=GW(TE())),T=LL(),f=y=mA(x=H+=JIe(HW())),F++;break;case 45:E===45&&mA(H)==2&&(I=0)}}return l}function QIe(t,e,i,r,o,l,d,h,p,g,f,y){for(var T=o-1,C=o===0?l:[""],E=GIe(C),I=0,w=0,D=0;I<r;++I)for(var F=0,x=f5(t,T+1,T=VIe(w=d[I])),B=t;F<E;++F)(B=$Ie(w>0?C[F]+" "+x:sT(x,/&\f/g,C[F])))&&(p[D++]=B);return $W(t,e,i,o===0?UW:h,p,g,f,y)}function Rgt(t,e,i,r){return $W(t,e,i,UIe,zW(Cgt()),f5(t,2,-2),0,r)}function ZIe(t,e,i,r,o){return $W(t,e,i,Foe,f5(t,0,r),f5(t,r+1,-1),r,o)}function b5(t,e){for(var i="",r=0;r<t.length;r++)i+=e(t[r],r,t,e)||"";return i}function XIe(t,e,i,r){switch(t.type){case zIe:if(t.children.length)break;case mgt:case vgt:case Foe:return t.return=t.return||t.value;case UIe:return"";case ygt:return t.return=t.value+"{"+b5(t.children,r)+"}";case UW:if(!mA(t.value=t.props.join(",")))return""}return mA(i=b5(t.children,r))?t.return=t.value+"{"+i+"}":""}function ewe(t){var e=GIe(t);return function(i,r,o,l){for(var d="",h=0;h<e;h++)d+=t[h](i,r,o,l)||"";return d}}function twe(t){return function(e){e.root||(e=e.return)&&t(e)}}const Mgt=t=>{switch(t.type){case UW:if(typeof t.props=="string"){if(process.env.NODE_ENV!=="production")throw new Error(`"element.props" has type "string" (${JSON.stringify(t.props,null,2)}), it's not expected. Please report a bug if it happens.`);return}t.props=t.props.map(e=>e.indexOf(":global(")===-1?e:Egt(e).reduce((i,r,o,l)=>{if(r==="")return i;if(r===":"&&l[o+1]==="global"){const d=l[o+2].slice(1,-1)+" ";return i.unshift(d),l[o+1]="",l[o+2]="",i}return i.push(r),i},[]).join(""))}};function iwe(t,e,i){switch(bgt(t,e)){case 5103:return gA+"print-"+t+t;case 3191:case 6645:case 3005:case 6391:case 5879:case 5623:case 6135:case 4599:case 4855:return gA+t+t;case 4215:if($y(t,9)===102||$y(t,e+1)===116)return gA+t+t;break;case 4789:return IH+t+t;case 5349:case 4246:case 6968:return gA+t+IH+t+t;case 6187:if(!HIe(t,/grab/))return sT(sT(sT(t,/(zoom-|grab)/,gA+"$1"),/(image-set)/,gA+"$1"),t,"")+t;case 5495:case 3959:return sT(t,/(image-set\([^]*)/,gA+"$1$`$1");case 4095:case 3583:case 4068:case 2532:return sT(t,/(.+)-inline(.+)/,gA+"$1$2")+t;case 8116:case 7059:case 5753:case 5535:case 5445:case 5701:case 4933:case 4677:case 5533:case 5789:case 5021:case 4765:if(mA(t)-1-e>6)switch($y(t,e+1)){case 102:if($y(t,e+3)===108)return sT(t,/(.+:)(.+)-([^]+)/,"$1"+gA+"$2-$3$1"+IH+($y(t,e+3)==108?"$3":"$2-$3"))+t;case 115:return~jIe(t,"stretch")?iwe(sT(t,"stretch","fill-available"),e)+t:t}break}return t}function nwe(t,e,i,r){if(t.length>-1&&!t.return)switch(t.type){case Foe:t.return=iwe(t.value,t.length);return;case UW:if(t.length)return Tgt(t.props,function(o){switch(HIe(o,/(::plac\w+|:read-\w+)/)){case":read-only":case":read-write":return b5([Uoe(t,{props:[sT(o,/:(read-\w+)/,":"+IH+"$1")]})],r);case"::placeholder":return b5([Uoe(t,{props:[sT(o,/:(plac\w+)/,":"+gA+"input-$1")]}),Uoe(t,{props:[sT(o,/:(plac\w+)/,":"+IH+"$1")]})],r)}return""})}}function Pgt(t){switch(t.type){case"@container":case ggt:case fgt:case zIe:return!0}return!1}const Dgt=t=>{Pgt(t)&&Array.isArray(t.children)&&t.children.sort((e,i)=>e.props[0]>i.props[0]?1:-1)};function Lgt(t,e){const i=[];return b5(YIe(t),ewe([Mgt,Dgt,nwe,XIe,twe(r=>i.push(r))])),i}const Ogt=/,( *[^ &])/g;function Ngt(t){return"&"+FIe(t.replace(Ogt,",&$1"))}function awe(t,e,i){let r=e;return i.length>0&&(r=i.reduceRight((o,l)=>`${Ngt(l)} { ${o} }`,e)),`${t}{${r}}`}function rwe(t,e){const{className:i,selectors:r,property:o,rtlClassName:l,rtlProperty:d,rtlValue:h,value:p}=t,{container:g,layer:f,media:y,supports:T}=e,C=`.${i}`,E=Array.isArray(p)?`${p.map(w=>`${m5(o)}: ${w}`).join(";")};`:`${m5(o)}: ${p};`;let I=awe(C,E,r);if(d&&l){const w=`.${l}`,D=Array.isArray(h)?`${h.map(F=>`${m5(d)}: ${F}`).join(";")};`:`${m5(d)}: ${h};`;I+=awe(w,D,r)}return y&&(I=`@media ${y} { ${I} }`),f&&(I=`@layer ${f} { ${I} }`),T&&(I=`@supports ${T} { ${I} }`),g&&(I=`@container ${g} { ${I} }`),Lgt(I)}function xgt(t){let e="";for(const i in t){const r=t[i];if(typeof r=="string"||typeof r=="number"){e+=m5(i)+":"+r+";";continue}if(Array.isArray(r))for(const o of r)e+=m5(i)+":"+o+";"}return e}function owe(t){let e="";for(const i in t)e+=`${i}{${xgt(t[i])}}`;return e}function swe(t,e){const i=`@keyframes ${t} {${e}}`,r=[];return b5(YIe(i),ewe([XIe,nwe,twe(o=>r.push(o))])),r}const Bgt={animation:[-1,["animationDelay","animationDirection","animationDuration","animationFillMode","animationIterationCount","animationName","animationPlayState","animationTimeline","animationTimingFunction"]],animationRange:[-1,["animationRangeEnd","animationRangeStart"]],background:[-2,["backgroundAttachment","backgroundClip","backgroundColor","backgroundImage","backgroundOrigin","backgroundPosition","backgroundPositionX","backgroundPositionY","backgroundRepeat","backgroundSize"]],backgroundPosition:[-1,["backgroundPositionX","backgroundPositionY"]],border:[-2,["borderBottom","borderBottomColor","borderBottomStyle","borderBottomWidth","borderLeft","borderLeftColor","borderLeftStyle","borderLeftWidth","borderRight","borderRightColor","borderRightStyle","borderRightWidth","borderTop","borderTopColor","borderTopStyle","borderTopWidth"]],borderBottom:[-1,["borderBottomColor","borderBottomStyle","borderBottomWidth"]],borderImage:[-1,["borderImageOutset","borderImageRepeat","borderImageSlice","borderImageSource","borderImageWidth"]],borderLeft:[-1,["borderLeftColor","borderLeftStyle","borderLeftWidth"]],borderRadius:[-1,["borderBottomLeftRadius","borderBottomRightRadius","borderTopLeftRadius","borderTopRightRadius"]],borderRight:[-1,["borderRightColor","borderRightStyle","borderRightWidth"]],borderTop:[-1,["borderTopColor","borderTopStyle","borderTopWidth"]],caret:[-1,["caretColor","caretShape"]],columnRule:[-1,["columnRuleColor","columnRuleStyle","columnRuleWidth"]],columns:[-1,["columnCount","columnWidth"]],containIntrinsicSize:[-1,["containIntrinsicHeight","containIntrinsicWidth"]],container:[-1,["containerName","containerType"]],flex:[-1,["flexBasis","flexGrow","flexShrink"]],flexFlow:[-1,["flexDirection","flexWrap"]],font:[-1,["fontFamily","fontSize","fontStretch","fontStyle","fontVariant","fontWeight","lineHeight"]],gap:[-1,["columnGap","rowGap"]],grid:[-1,["columnGap","gridAutoColumns","gridAutoFlow","gridAutoRows","gridColumnGap","gridRowGap","gridTemplateAreas","gridTemplateColumns","gridTemplateRows","rowGap"]],gridArea:[-1,["gridColumnEnd","gridColumnStart","gridRowEnd","gridRowStart"]],gridColumn:[-1,["gridColumnEnd","gridColumnStart"]],gridRow:[-1,["gridRowEnd","gridRowStart"]],gridTemplate:[-1,["gridTemplateAreas","gridTemplateColumns","gridTemplateRows"]],inset:[-1,["bottom","left","right","top"]],insetBlock:[-1,["insetBlockEnd","insetBlockStart"]],insetInline:[-1,["insetInlineEnd","insetInlineStart"]],listStyle:[-1,["listStyleImage","listStylePosition","listStyleType"]],margin:[-1,["marginBottom","marginLeft","marginRight","marginTop"]],marginBlock:[-1,["marginBlockEnd","marginBlockStart"]],marginInline:[-1,["marginInlineEnd","marginInlineStart"]],mask:[-1,["maskClip","maskComposite","maskImage","maskMode","maskOrigin","maskPosition","maskRepeat","maskSize"]],maskBorder:[-1,["maskBorderMode","maskBorderOutset","maskBorderRepeat","maskBorderSlice","maskBorderSource","maskBorderWidth"]],offset:[-1,["offsetAnchor","offsetDistance","offsetPath","offsetPosition","offsetRotate"]],outline:[-1,["outlineColor","outlineStyle","outlineWidth"]],overflow:[-1,["overflowX","overflowY"]],overscrollBehavior:[-1,["overscrollBehaviorX","overscrollBehaviorY"]],padding:[-1,["paddingBottom","paddingLeft","paddingRight","paddingTop"]],paddingBlock:[-1,["paddingBlockEnd","paddingBlockStart"]],paddingInline:[-1,["paddingInlineEnd","paddingInlineStart"]],placeContent:[-1,["alignContent","justifyContent"]],placeItems:[-1,["alignItems","justifyItems"]],placeSelf:[-1,["alignSelf","justifySelf"]],scrollMargin:[-1,["scrollMarginBottom","scrollMarginLeft","scrollMarginRight","scrollMarginTop"]],scrollMarginBlock:[-1,["scrollMarginBlockEnd","scrollMarginBlockStart"]],scrollMarginInline:[-1,["scrollMarginInlineEnd","scrollMarginInlineStart"]],scrollPadding:[-1,["scrollPaddingBottom","scrollPaddingLeft","scrollPaddingRight","scrollPaddingTop"]],scrollPaddingBlock:[-1,["scrollPaddingBlockEnd","scrollPaddingBlockStart"]],scrollPaddingInline:[-1,["scrollPaddingInlineEnd","scrollPaddingInlineStart"]],scrollTimeline:[-1,["scrollTimelineAxis","scrollTimelineName"]],textDecoration:[-1,["textDecorationColor","textDecorationLine","textDecorationStyle","textDecorationThickness"]],textEmphasis:[-1,["textEmphasisColor","textEmphasisStyle"]],transition:[-1,["transitionBehavior","transitionDelay","transitionDuration","transitionProperty","transitionTimingFunction"]],viewTimeline:[-1,["viewTimelineAxis","viewTimelineName"]]};function lwe(t,e){return t.length===0?e:`${t} and ${e}`}function Fgt(t){return t.substr(0,6)==="@media"}function Ugt(t){return t.substr(0,6)==="@layer"}const zgt=/^(:|\[|>|&)/;function Vgt(t){return zgt.test(t)}function $gt(t){return t.substr(0,9)==="@supports"}function Hgt(t){return t.substring(0,10)==="@container"}function jgt(t){return t!=null&&typeof t=="object"&&Array.isArray(t)===!1}const cwe={"us-w":"w","us-v":"i",nk:"l",si:"v",cu:"f",ve:"h",ti:"a"};function dwe(t,e){if(e.media)return"m";if(e.layer||e.supports)return"t";if(e.container)return"c";if(t.length>0){const i=t[0].trim();if(i.charCodeAt(0)===58)return cwe[i.slice(4,8)]||cwe[i.slice(3,5)]||"d"}return"d"}function WW(t,e){return t&&e+t}function uwe(t){return WW(t.container,"c")+WW(t.media,"m")+WW(t.layer,"l")+WW(t.supports,"s")}function Voe(t,e,i){const r=t+uwe(i)+e,o=_x(r),l=o.charCodeAt(0);return l>=48&&l<=57?String.fromCharCode(l+17)+o.slice(1):o}function KW({property:t,selector:e,salt:i,value:r},o){return Poe+_x(i+e+uwe(o)+t+r.trim())}function Ggt(t){return t===Doe}function $oe(t){return t.replace(/>\s+/g,">")}function hwe(...t){process.env.NODE_ENV!=="production"&&typeof document<"u"&&console.error(...t)}function qgt(t,e){hwe((()=>{const r=JSON.stringify(e,null,2),o=["@griffel/react: A rule was not resolved to CSS properly. Please check your `makeStyles` or `makeResetStyles` calls for following:"," ".repeat(2)+"makeStyles({"," ".repeat(4)+"[slot]: {"," ".repeat(6)+`"${t}": ${r.split(`
`).map((l,d)=>" ".repeat(d===0?0:6)+l).join(`
`)}`," ".repeat(4)+"}"," ".repeat(2)+"})",""];return t.indexOf("&")===-1?(o.push("It looks that you're are using a nested selector, but it is missing an ampersand placeholder where the generated class name should be injected."),o.push(`Try to update a property to include it i.e "${t}" => "&${t}".`)):(o.push(""),o.push("If it's not obvious what triggers a problem, please report an issue at https://github.com/microsoft/griffel/issues")),o.join(`
`)})())}function Wgt(t,e){hwe([`@griffel/react: You are using unsupported shorthand CSS property "${t}". Please check your "makeStyles" calls, there *should not* be following:`," ".repeat(2)+"makeStyles({"," ".repeat(4)+`[slot]: { ${t}: "${e}" }`," ".repeat(2)+"})","","Learn why CSS shorthands are not supported: https://aka.ms/griffel-css-shorthands"].join(`
`))}function pwe(t){return Bgt[t]}function gwe(t){var e;return(e=t?.[0])!==null&&e!==void 0?e:0}function Hoe(t,e,i,r){t[e]=r?[i,r]:i}function mwe(t,e){return e.length>0?[t,Object.fromEntries(e)]:t}function joe(t,e,i,r,o,l){var d;const h=[];l!==0&&h.push(["p",l]),e==="m"&&o&&h.push(["m",o]),(d=t[e])!==null&&d!==void 0||(t[e]=[]),i&&t[e].push(mwe(i,h)),r&&t[e].push(mwe(r,h))}function MM(t,e="",i=[],r={container:"",layer:"",media:"",supports:""},o={},l={},d){for(const h in t){if(Ept.hasOwnProperty(h)){Wgt(h,t[h]);continue}const p=t[h];if(p!=null){if(Ggt(p)){const g=$oe(i.join("")),f=Voe(g,h,r);Hoe(o,f,0,void 0);continue}if(typeof p=="string"||typeof p=="number"){const g=$oe(i.join("")),f=pwe(h);if(f){const B=f[1],L=Object.fromEntries(B.map(z=>[z,Doe]));MM(L,e,i,r,o,l)}const y=Voe(g,h,r),T=KW({value:p.toString(),salt:e,selector:g,property:h},r),C=d&&{key:h,value:d}||xoe(h,p),E=C.key!==h||C.value!==p,I=E?KW({value:C.value.toString(),property:C.key,salt:e,selector:g},r):void 0,w=E?{rtlClassName:I,rtlProperty:C.key,rtlValue:C.value}:void 0,D=dwe(i,r),[F,x]=rwe(Object.assign({className:T,selectors:i,property:h,value:p},w),r);Hoe(o,y,T,I),joe(l,D,F,x,r.media,gwe(f))}else if(h==="animationName"){const g=Array.isArray(p)?p:[p],f=[],y=[];for(const T of g){const C=owe(T),E=owe(BIe(T)),I=Poe+_x(C);let w;const D=swe(I,C);let F=[];C===E?w=I:(w=Poe+_x(E),F=swe(w,E));for(let x=0;x<D.length;x++)joe(l,"k",D[x],F[x],r.media,0);f.push(I),y.push(w)}MM({animationName:f.join(", ")},e,i,r,o,l,y.join(", "))}else if(Array.isArray(p)){if(p.length===0){process.env.NODE_ENV!=="production"&&console.warn(`makeStyles(): An empty array was passed as input to "${h}", the property will be omitted in the styles.`);continue}const g=$oe(i.join("")),f=pwe(h);if(f){const L=f[1],z=Object.fromEntries(L.map(H=>[H,Doe]));MM(z,e,i,r,o,l)}const y=Voe(g,h,r),T=KW({value:p.map(L=>(L??"").toString()).join(";"),salt:e,selector:g,property:h},r),C=p.map(L=>xoe(h,L));if(!!C.some(L=>L.key!==C[0].key)){process.env.NODE_ENV!=="production"&&console.error("makeStyles(): mixing CSS fallback values which result in multiple CSS properties in RTL is not supported.");continue}const I=C[0].key!==h||C.some((L,z)=>L.value!==p[z]),w=I?KW({value:C.map(L=>{var z;return((z=L?.value)!==null&&z!==void 0?z:"").toString()}).join(";"),salt:e,property:C[0].key,selector:g},r):void 0,D=I?{rtlClassName:w,rtlProperty:C[0].key,rtlValue:C.map(L=>L.value)}:void 0,F=dwe(i,r),[x,B]=rwe(Object.assign({className:T,selectors:i,property:h,value:p},D),r);Hoe(o,y,T,w),joe(l,F,x,B,r.media,gwe(f))}else if(jgt(p))if(Vgt(h))MM(p,e,i.concat(FIe(h)),r,o,l);else if(Fgt(h)){const g=lwe(r.media,h.slice(6).trim());MM(p,e,i,Object.assign({},r,{media:g}),o,l)}else if(Ugt(h)){const g=(r.layer?`${r.layer}.`:"")+h.slice(6).trim();MM(p,e,i,Object.assign({},r,{layer:g}),o,l)}else if($gt(h)){const g=lwe(r.supports,h.slice(9).trim());MM(p,e,i,Object.assign({},r,{supports:g}),o,l)}else if(Hgt(h)){const g=h.slice(10).trim();MM(p,e,i,Object.assign({},r,{container:g}),o,l)}else qgt(h,p)}}return[o,l]}function Kgt(t,e=""){const i={},r={};for(const o in t){const l=t[o],[d,h]=MM(l,e);i[o]=d,Object.keys(h).forEach(p=>{r[p]=(r[p]||[]).concat(h[p])})}return[i,r]}function Jgt(t,e=Noe){const i=e();let r=null,o=null,l=null,d=null,h;process.env.NODE_ENV!=="production"&&g5&&(h=PIe());let p;function g(f){const{dir:y,renderer:T}=f;r===null&&([r,o]=Kgt(t,T.classNameHashSalt),process.env.NODE_ENV!=="production"&&T.classNameHashSalt&&(p!==T.classNameHashSalt&&console.error(["@griffel/core:",`

`,'A provided renderer has different "classNameHashSalt".',"This is not supported and WILL cause issues with classnames generation.",'Ensure that all renderers created with "createDOMRenderer()" have the same "classNameHashSalt".'].join(" ")),p=T.classNameHashSalt));const C=y==="ltr";C?l===null&&(l=NW(r,y)):d===null&&(d=NW(r,y)),i(T,o);const E=C?l:d;return process.env.NODE_ENV!=="production"&&g5&&Ex.addSequenceDetails(E,h),E}return g}function fwe(t,e,i=Noe){const r=i();let o=null,l=null,d;process.env.NODE_ENV!=="production"&&g5&&(d=PIe());function h(p){const{dir:g,renderer:f}=p,y=g==="ltr";y?o===null&&(o=NW(t,g)):l===null&&(l=NW(t,g)),r(f,e);const T=y?o:l;return process.env.NODE_ENV!=="production"&&g5&&Ex.addSequenceDetails(T,d),T}return h}function Ygt(t,e,i,r=Noe){const o=r();function l(d){const{dir:h,renderer:p}=d,g=h==="ltr"?t:e||t;return o(p,Array.isArray(i)?{r:i}:i),process.env.NODE_ENV!=="production"&&(OW[g]=1),g}return l}const Wo={border:$ht,borderLeft:Hht,borderBottom:jht,borderRight:Ght,borderTop:qht,borderColor:Ioe,borderStyle:Aoe,borderRadius:Wht,borderWidth:Eoe,flex:Zht,gap:Xht,gridArea:apt,margin:rpt,marginBlock:opt,marginInline:spt,padding:lpt,paddingBlock:cpt,paddingInline:dpt,overflow:upt,inset:hpt,outline:ppt,transition:gpt,textDecoration:ypt};function Qgt(){return typeof window<"u"&&!!(window.document&&window.document.createElement)}const vwe=vM.useInsertionEffect?vM.useInsertionEffect:void 0,Goe=()=>{const t={};return function(i,r){if(vwe&&Qgt()){vwe(()=>{i.insertCSSRules(r)},[i,r]);return}t[i.id]===void 0&&(i.insertCSSRules(r),t[i.id]=!0)}},Zgt=$.createContext(Upt());function wH(){return $.useContext(Zgt)}const ywe=$.createContext("ltr"),Swe=({children:t,dir:e})=>$.createElement(ywe.Provider,{value:e},t);function qoe(){return $.useContext(ywe)}function Xgt(){try{const t=$.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher.current;return t==null?!1:(t.useContext({}),!0)}catch{return!1}}function Lv(t){const e=Jgt(t,Goe);if(process.env.NODE_ENV!=="production"&&Xgt())throw new Error(["makeStyles(): this function cannot be called in component's scope.","All makeStyles() calls should be top level i.e. in a root scope of a file."].join(" "));return function(){const r=qoe(),o=wH();return e({dir:r,renderer:o})}}function uo(t,e){const i=fwe(t,e,Goe);return function(){const o=qoe(),l=wH();return i({dir:o,renderer:l})}}function pd(t,e,i){const r=Ygt(t,e,i,Goe);return function(){const l=qoe(),d=wH();return r({dir:l,renderer:d})}}function emt(t,e){if(e){const i=Object.keys(e).reduce((r,o)=>`${r}--${o}: ${e[o]}; `,"");return`${t} { ${i} }`}return`${t} {}`}const bwe=Symbol.for("fui.slotRenderFunction"),T5=Symbol.for("fui.slotElementType"),Twe=Symbol.for("fui.slotClassNameProp");function Bl(t,e){const{defaultProps:i,elementType:r}=e,o=Cwe(t),l={...i,...o,[T5]:r,[Twe]:o?.className};return o&&typeof o.children=="function"&&(l[bwe]=o.children,l.children=i?.children),l}function Ss(t,e){if(!(t===null||t===void 0&&!e.renderByDefault))return Bl(t,e)}function Cwe(t){return typeof t=="string"||typeof t=="number"||Array.isArray(t)||$.isValidElement(t)?{children:t}:(t&&typeof t!="object"&&process.env.NODE_ENV!=="production"&&console.error(`@fluentui/react-utilities [slot.${Cwe.name}]:
A slot got an invalid value "${t}" (${typeof t}).
A valid value for a slot is a slot shorthand or slot properties object.
Slot shorthands can be strings, numbers, arrays or JSX elements`),t)}function kH(t){return!!t?.hasOwnProperty(T5)}function Pd(t){if(process.env.NODE_ENV!=="production"){const e=t;for(const i of Object.keys(e.components)){const r=e[i];if(r!==void 0)if(!kH(r))e[i]=Bl(r,{elementType:e.components[i]}),console.warn(`@fluentui/react-utilities [${Pd.name}]:
"state.${i}" is not a slot!
Be sure to create slots properly by using "slot.always" or "slot.optional".`);else{const{[T5]:o}=r;o!==e.components[i]&&(r[T5]=e.components[i],console.warn(`@fluentui/react-utilities [${Pd.name}]:
"state.${i}" element type differs from "state.components.${i}",
${o} !== ${e.components[i]}.
Be sure to create slots properly by using "slot.always" or "slot.optional" with the correct elementType.`))}}}}const Nu=(...t)=>{const e={};for(const i of t){const r=Array.isArray(i)?i:Object.keys(i);for(const o of r)e[o]=1}return e},tmt=Nu(["onAuxClick","onAnimationEnd","onAnimationStart","onCopy","onCut","onPaste","onCompositionEnd","onCompositionStart","onCompositionUpdate","onFocus","onFocusCapture","onBlur","onBlurCapture","onChange","onInput","onSubmit","onLoad","onError","onKeyDown","onKeyDownCapture","onKeyPress","onKeyUp","onAbort","onCanPlay","onCanPlayThrough","onDurationChange","onEmptied","onEncrypted","onEnded","onLoadedData","onLoadedMetadata","onLoadStart","onPause","onPlay","onPlaying","onProgress","onRateChange","onSeeked","onSeeking","onStalled","onSuspend","onTimeUpdate","onVolumeChange","onWaiting","onClick","onClickCapture","onContextMenu","onDoubleClick","onDrag","onDragEnd","onDragEnter","onDragExit","onDragLeave","onDragOver","onDragStart","onDrop","onMouseDown","onMouseDownCapture","onMouseEnter","onMouseLeave","onMouseMove","onMouseOut","onMouseOver","onMouseUp","onMouseUpCapture","onSelect","onTouchCancel","onTouchEnd","onTouchMove","onTouchStart","onScroll","onWheel","onPointerCancel","onPointerDown","onPointerEnter","onPointerLeave","onPointerMove","onPointerOut","onPointerOver","onPointerUp","onGotPointerCapture","onLostPointerCapture"]),imt=Nu(["accessKey","children","className","contentEditable","dir","draggable","hidden","htmlFor","id","lang","ref","role","style","tabIndex","title","translate","spellCheck","name"]),nmt=Nu(["itemID","itemProp","itemRef","itemScope","itemType"]),Wg=Nu(imt,tmt,nmt),amt=Nu(Wg,["form"]),_we=Nu(Wg,["height","loop","muted","preload","src","width"]),rmt=Nu(_we,["poster"]),omt=Nu(Wg,["start"]),smt=Nu(Wg,["value"]),lmt=Nu(Wg,["download","href","hrefLang","media","rel","target","type"]),cmt=Nu(Wg,["dateTime"]),JW=Nu(Wg,["autoFocus","disabled","form","formAction","formEncType","formMethod","formNoValidate","formTarget","type","value"]),dmt=Nu(JW,["accept","alt","autoCorrect","autoCapitalize","autoComplete","checked","dirname","form","height","inputMode","list","max","maxLength","min","minLength","multiple","pattern","placeholder","readOnly","required","src","step","size","type","value","width"]),umt=Nu(JW,["autoCapitalize","cols","dirname","form","maxLength","placeholder","readOnly","required","rows","wrap"]),hmt=Nu(JW,["form","multiple","required"]),pmt=Nu(Wg,["selected","value"]),gmt=Nu(Wg,["cellPadding","cellSpacing"]),mmt=Wg,fmt=Nu(Wg,["colSpan","rowSpan","scope"]),vmt=Nu(Wg,["colSpan","headers","rowSpan","scope"]),ymt=Nu(Wg,["span"]),Smt=Nu(Wg,["span"]),bmt=Nu(Wg,["disabled","form"]),Tmt=Nu(Wg,["acceptCharset","action","encType","encType","method","noValidate","target"]),Cmt=Nu(Wg,["allow","allowFullScreen","allowPaymentRequest","allowTransparency","csp","height","importance","referrerPolicy","sandbox","src","srcDoc","width"]),_mt=Nu(Wg,["alt","crossOrigin","height","src","srcSet","useMap","width"]),Emt=Nu(Wg,["open","onCancel","onClose"]);function Amt(t,e,i){const r=Array.isArray(e),o={},l=Object.keys(t);for(const d of l)(!r&&e[d]||r&&e.indexOf(d)>=0||d.indexOf("data-")===0||d.indexOf("aria-")===0)&&(!i||i?.indexOf(d)===-1)&&(o[d]=t[d]);return o}const Imt={label:amt,audio:_we,video:rmt,ol:omt,li:smt,a:lmt,button:JW,input:dmt,textarea:umt,select:hmt,option:pmt,table:gmt,tr:mmt,th:fmt,td:vmt,colGroup:ymt,col:Smt,fieldset:bmt,form:Tmt,iframe:Cmt,img:_mt,time:cmt,dialog:Emt};function Ewe(t,e,i){const r=t&&Imt[t]||Wg;return r.as=1,Amt(e,r,i)}const RH=({primarySlotTagName:t,props:e,excludedPropNames:i})=>({root:{style:e.style,className:e.className},primary:Ewe(t,e,[...i||[],"style","className"])}),_p=(t,e,i)=>{var r;return Ewe((r=e.as)!==null&&r!==void 0?r:t,e,i)};function wmt(t,e){const i={};for(const r in t)e.indexOf(r)===-1&&t.hasOwnProperty(r)&&(i[r]=t[r]);return i}function Awe(t,e){const i=$.useRef(void 0),r=$.useCallback((l,d)=>(i.current!==void 0&&e(i.current),i.current=t(l,d),i.current),[e,t]),o=$.useCallback(()=>{i.current!==void 0&&(e(i.current),i.current=void 0)},[e]);return $.useEffect(()=>o,[o]),[r,o]}const Iwe=$.createContext(void 0),kmt=Iwe.Provider,wwe=$.createContext(void 0),Rmt="",Mmt=wwe.Provider;function Pmt(){var t;return(t=$.useContext(wwe))!==null&&t!==void 0?t:Rmt}const Dmt=$.createContext(void 0).Provider,kwe=$.createContext(void 0),Lmt={targetDocument:typeof document=="object"?document:void 0,dir:"ltr"},Omt=kwe.Provider;function Ov(){var t;return(t=$.useContext(kwe))!==null&&t!==void 0?t:Lmt}const Rwe=$.createContext(void 0),Nmt=Rwe.Provider;function Mwe(){var t;return(t=$.useContext(Rwe))!==null&&t!==void 0?t:{}}const Woe=$.createContext(void 0),xmt=()=>{},Bmt=Woe.Provider,kh=t=>{var e,i;return(i=(e=$.useContext(Woe))===null||e===void 0?void 0:e[t])!==null&&i!==void 0?i:xmt},Pwe=$.createContext(void 0);Pwe.Provider;function Fmt(){return $.useContext(Pwe)}const Dwe=$.createContext(void 0);Dwe.Provider;function Umt(){var t;return(t=$.useContext(Dwe))!==null&&t!==void 0?t:{announce:()=>{}}}const zmt=t=>(t(0),0),Vmt=t=>t;function $mt(){const{targetDocument:t}=Ov(),e=t?.defaultView,i=e?e.requestAnimationFrame:zmt,r=e?e.cancelAnimationFrame:Vmt;return Awe(i,r)}function Hmt(t){return typeof t=="function"}const OL=t=>{"use no memo";process.env.NODE_ENV!=="production"&&t.state!==void 0&&t.defaultState!==void 0&&console.error(`@fluentui/react-utilities [useControllableState]:
A component must be either controlled or uncontrolled (specify either the state or the defaultState, but not both).
Decide between using a controlled or uncontrolled component and remove one of this props.
More info: https://reactjs.org/link/controlled-components
${new Error().stack}`);const[e,i]=$.useState(()=>t.defaultState===void 0?t.initialState:jmt(t.defaultState)?t.defaultState():t.defaultState),r=$.useRef(t.state);$.useEffect(()=>{r.current=t.state},[t.state]);const o=$.useCallback(l=>{Hmt(l)&&l(r.current)},[]);return Gmt(t.state)?[t.state,o]:[e,i]};function jmt(t){return typeof t=="function"}const Gmt=t=>{"use no memo";const[e]=$.useState(()=>t!==void 0);return process.env.NODE_ENV!=="production"&&$.useEffect(()=>{if(e!==(t!==void 0)){const i=new Error;console.error(`@fluentui/react-utilities [useControllableState]:
A component is changing ${e?"a controlled value to be uncontrolled":"an uncontrolled value to be controlled"}. This is likely caused by the value changing from ${e?"defined to an undefined":"undefined to a defined"} value, which should not happen.
Decide between using a controlled or uncontrolled input element for the lifetime of the component.
More info: https://reactjs.org/link/controlled-components
${i.stack}`)}},[e,t]),e};function Koe(){return typeof window<"u"&&!!(window.document&&window.document.createElement)}const qmt={current:0},Wmt=$.createContext(void 0);function Kmt(){var t;return(t=$.useContext(Wmt))!==null&&t!==void 0?t:qmt}const fA=Koe()?$.useLayoutEffect:$.useEffect,Fl=t=>{const e=$.useRef(()=>{throw new Error("Cannot call an event handler while rendering")});return fA(()=>{e.current=t},[t]),$.useCallback((...i)=>{const r=e.current;return r(...i)},[e])};function Jmt(){const t=$.useRef(!0);return t.current?(t.current=!1,!0):t.current}const Lwe=$.createContext(void 0);Lwe.Provider;function Ymt(){return $.useContext(Lwe)||""}function NL(t="fui-",e){"use no memo";const i=Kmt(),r=Ymt(),o=vM.useId;if(o){const l=o(),d=$.useMemo(()=>l.replace(/:/g,""),[l]);return e||`${r}${t}${d}`}return $.useMemo(()=>e||`${r}${t}${++i.current}`,[r,t,e,i])}function kC(...t){"use no memo";const e=$.useCallback(i=>{e.current=i;for(const r of t)typeof r=="function"?r(i):r&&(r.current=i)},[...t]);return e}const Owe=(t,e)=>!!t?.contains(e),Qmt=t=>{const{targetDocument:e}=Ov(),i=e?.defaultView,{refs:r,callback:o,element:l,disabled:d,disabledFocusOnIframe:h,contains:p=Owe}=t,g=$.useRef(void 0);Xmt({element:l,disabled:h||d,callback:o,refs:r,contains:p});const f=$.useRef(!1),y=Fl(C=>{if(f.current){f.current=!1;return}const E=C.composedPath()[0];r.every(w=>!p(w.current||null,E))&&!d&&o(C)}),T=Fl(C=>{f.current=r.some(E=>p(E.current||null,C.target))});$.useEffect(()=>{if(d)return;let C=Zmt(i);const E=I=>{if(I===C){C=void 0;return}y(I)};return l?.addEventListener("click",E,!0),l?.addEventListener("touchstart",E,!0),l?.addEventListener("contextmenu",E,!0),l?.addEventListener("mousedown",T,!0),g.current=i?.setTimeout(()=>{C=void 0},1),()=>{l?.removeEventListener("click",E,!0),l?.removeEventListener("touchstart",E,!0),l?.removeEventListener("contextmenu",E,!0),l?.removeEventListener("mousedown",T,!0),i?.clearTimeout(g.current),C=void 0}},[y,l,d,T,i])},Zmt=t=>{if(t){var e,i;if(typeof t.window=="object"&&t.window===t)return t.event;var r;return(r=(i=t.ownerDocument)===null||i===void 0||(e=i.defaultView)===null||e===void 0?void 0:e.event)!==null&&r!==void 0?r:void 0}},Joe="fuiframefocus",Xmt=t=>{const{disabled:e,element:i,callback:r,contains:o=Owe,pollDuration:l=1e3,refs:d}=t,h=$.useRef(),p=Fl(g=>{d.every(y=>!o(y.current||null,g.target))&&!e&&r(g)});$.useEffect(()=>{if(!e)return i?.addEventListener(Joe,p,!0),()=>{i?.removeEventListener(Joe,p,!0)}},[i,e,p]),$.useEffect(()=>{var g;if(!e)return h.current=i==null||(g=i.defaultView)===null||g===void 0?void 0:g.setInterval(()=>{const f=i?.activeElement;if(f?.tagName==="IFRAME"||f?.tagName==="WEBVIEW"){const y=new CustomEvent(Joe,{bubbles:!0});f.dispatchEvent(y)}},l),()=>{var f;i==null||(f=i.defaultView)===null||f===void 0||f.clearTimeout(h.current)}},[i,e,l])},eft=t=>{const{refs:e,callback:i,element:r,disabled:o,contains:l}=t,d=Fl(h=>{const p=l||((y,T)=>!!y?.contains(T)),g=h.composedPath()[0];e.every(y=>!p(y.current||null,g))&&!o&&i(h)});$.useEffect(()=>{if(!o)return r?.addEventListener("wheel",d),r?.addEventListener("touchmove",d),()=>{r?.removeEventListener("wheel",d),r?.removeEventListener("touchmove",d)}},[d,r,o])},tft=t=>{const e=$.useRef(null);return $.useEffect(()=>{e.current=t},[t]),e.current},ift=t=>-1,nft=t=>{};function Yoe(){const{targetDocument:t}=Ov(),e=t?.defaultView,i=e?e.setTimeout:ift,r=e?e.clearTimeout:nft;return Awe(i,r)}function vA(t,e){return(...i)=>{t?.(...i),e?.(...i)}}function yA(t,e){var i;const r=t;var o;return!!(!(r==null||(i=r.ownerDocument)===null||i===void 0)&&i.defaultView&&r instanceof r.ownerDocument.defaultView[(o=void 0)!==null&&o!==void 0?o:"HTMLElement"])}function Nwe(t){return!!t.type.isFluentTriggerComponent}function aft(t,e){return typeof t=="function"?t(e):t?xwe(t,e):t||null}function xwe(t,e){if(!$.isValidElement(t)||t.type===$.Fragment)throw new Error("A trigger element must be a single element for this component. Please ensure that you're not using React Fragments.");if(Nwe(t)){const i=xwe(t.props.children,e);return $.cloneElement(t,void 0,i)}else return $.cloneElement(t,e)}function Bwe(t){return $.isValidElement(t)?Nwe(t)?Bwe(t.props.children):t:null}function rft(t){return t&&!!t._virtual}function oft(t){return rft(t)&&t._virtual.parent||null}function Fwe(t,e={}){if(!t)return null;if(!e.skipVirtual){const r=oft(t);if(r)return r}const i=t.parentNode;return i&&i.nodeType===Node.DOCUMENT_FRAGMENT_NODE?i.host:i}function Qoe(t,e){if(!t||!e)return!1;if(t===e)return!0;{const i=new WeakSet;for(;e;){const r=Fwe(e,{skipVirtual:i.has(e)});if(i.add(e),r===t)return!0;e=r}}return!1}function Uwe(t,e){if(!t)return;const i=t;i._virtual||(i._virtual={}),i._virtual.parent=e}function zwe(t,e){return{...e,[T5]:t}}var YW={exports:{}},Wd={};/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */var Vwe;function sft(){if(Vwe)return Wd;Vwe=1;var t=60103,e=60106,i=60107,r=60108,o=60114,l=60109,d=60110,h=60112,p=60113,g=60120,f=60115,y=60116,T=60121,C=60122,E=60117,I=60129,w=60131;if(typeof Symbol=="function"&&Symbol.for){var D=Symbol.for;t=D("react.element"),e=D("react.portal"),i=D("react.fragment"),r=D("react.strict_mode"),o=D("react.profiler"),l=D("react.provider"),d=D("react.context"),h=D("react.forward_ref"),p=D("react.suspense"),g=D("react.suspense_list"),f=D("react.memo"),y=D("react.lazy"),T=D("react.block"),C=D("react.server.block"),E=D("react.fundamental"),I=D("react.debug_trace_mode"),w=D("react.legacy_hidden")}function F(le){if(typeof le=="object"&&le!==null){var he=le.$$typeof;switch(he){case t:switch(le=le.type,le){case i:case o:case r:case p:case g:return le;default:switch(le=le&&le.$$typeof,le){case d:case h:case y:case f:case l:return le;default:return he}}case e:return he}}}var x=l,B=t,L=h,z=i,H=y,j=f,J=e,Z=o,re=r,ne=p;return Wd.ContextConsumer=d,Wd.ContextProvider=x,Wd.Element=B,Wd.ForwardRef=L,Wd.Fragment=z,Wd.Lazy=H,Wd.Memo=j,Wd.Portal=J,Wd.Profiler=Z,Wd.StrictMode=re,Wd.Suspense=ne,Wd.isAsyncMode=function(){return!1},Wd.isConcurrentMode=function(){return!1},Wd.isContextConsumer=function(le){return F(le)===d},Wd.isContextProvider=function(le){return F(le)===l},Wd.isElement=function(le){return typeof le=="object"&&le!==null&&le.$$typeof===t},Wd.isForwardRef=function(le){return F(le)===h},Wd.isFragment=function(le){return F(le)===i},Wd.isLazy=function(le){return F(le)===y},Wd.isMemo=function(le){return F(le)===f},Wd.isPortal=function(le){return F(le)===e},Wd.isProfiler=function(le){return F(le)===o},Wd.isStrictMode=function(le){return F(le)===r},Wd.isSuspense=function(le){return F(le)===p},Wd.isValidElementType=function(le){return typeof le=="string"||typeof le=="function"||le===i||le===o||le===I||le===r||le===p||le===g||le===w||typeof le=="object"&&le!==null&&(le.$$typeof===y||le.$$typeof===f||le.$$typeof===l||le.$$typeof===d||le.$$typeof===h||le.$$typeof===E||le.$$typeof===T||le[0]===C)},Wd.typeOf=F,Wd}var Kd={};/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */var $we;function lft(){return $we||($we=1,process.env.NODE_ENV!=="production"&&function(){var t=60103,e=60106,i=60107,r=60108,o=60114,l=60109,d=60110,h=60112,p=60113,g=60120,f=60115,y=60116,T=60121,C=60122,E=60117,I=60129,w=60131;if(typeof Symbol=="function"&&Symbol.for){var D=Symbol.for;t=D("react.element"),e=D("react.portal"),i=D("react.fragment"),r=D("react.strict_mode"),o=D("react.profiler"),l=D("react.provider"),d=D("react.context"),h=D("react.forward_ref"),p=D("react.suspense"),g=D("react.suspense_list"),f=D("react.memo"),y=D("react.lazy"),T=D("react.block"),C=D("react.server.block"),E=D("react.fundamental"),D("react.scope"),D("react.opaque.id"),I=D("react.debug_trace_mode"),D("react.offscreen"),w=D("react.legacy_hidden")}var F=!1;function x(vt){return!!(typeof vt=="string"||typeof vt=="function"||vt===i||vt===o||vt===I||vt===r||vt===p||vt===g||vt===w||F||typeof vt=="object"&&vt!==null&&(vt.$$typeof===y||vt.$$typeof===f||vt.$$typeof===l||vt.$$typeof===d||vt.$$typeof===h||vt.$$typeof===E||vt.$$typeof===T||vt[0]===C))}function B(vt){if(typeof vt=="object"&&vt!==null){var Pt=vt.$$typeof;switch(Pt){case t:var ni=vt.type;switch(ni){case i:case o:case r:case p:case g:return ni;default:var Zt=ni&&ni.$$typeof;switch(Zt){case d:case h:case y:case f:case l:return Zt;default:return Pt}}case e:return Pt}}}var L=d,z=l,H=t,j=h,J=i,Z=y,re=f,ne=e,le=o,he=r,Me=p,Le=!1,pe=!1;function te(vt){return Le||(Le=!0,console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")),!1}function Se(vt){return pe||(pe=!0,console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")),!1}function ce(vt){return B(vt)===d}function X(vt){return B(vt)===l}function ve(vt){return typeof vt=="object"&&vt!==null&&vt.$$typeof===t}function Te(vt){return B(vt)===h}function Be(vt){return B(vt)===i}function qe(vt){return B(vt)===y}function Ge(vt){return B(vt)===f}function tt(vt){return B(vt)===e}function ct(vt){return B(vt)===o}function Mt(vt){return B(vt)===r}function ht(vt){return B(vt)===p}Kd.ContextConsumer=L,Kd.ContextProvider=z,Kd.Element=H,Kd.ForwardRef=j,Kd.Fragment=J,Kd.Lazy=Z,Kd.Memo=re,Kd.Portal=ne,Kd.Profiler=le,Kd.StrictMode=he,Kd.Suspense=Me,Kd.isAsyncMode=te,Kd.isConcurrentMode=Se,Kd.isContextConsumer=ce,Kd.isContextProvider=X,Kd.isElement=ve,Kd.isForwardRef=Te,Kd.isFragment=Be,Kd.isLazy=qe,Kd.isMemo=Ge,Kd.isPortal=tt,Kd.isProfiler=ct,Kd.isStrictMode=Mt,Kd.isSuspense=ht,Kd.isValidElementType=x,Kd.typeOf=B}()),Kd}var Hwe;function cft(){return Hwe||(Hwe=1,process.env.NODE_ENV==="production"?YW.exports=sft():YW.exports=lft()),YW.exports}var dft=cft();function uft(t){process.env.NODE_ENV==="development"&&typeof t=="object"&&!dft.isValidElementType(t)&&console.error(`@fluentui/react-jsx-runtime:
Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: ${t}.

If this happened in a slot of Fluent UI component, you might be facing package resolution issues.
Please make sure you don't have multiple versions of "@fluentui/react-utilities" installed in your dependencies or sub-dependencies.
You can check this by searching up for matching entries in a lockfile produced by your package manager (yarn.lock, pnpm-lock.yaml or package-lock.json).`)}function jwe(t,e){return function(r,o,l,d,h){return kH(o)?e(zwe(r,o),null,l,d,h):kH(r)?e(r,o,l,d,h):(uft(r),t(r,o,l,d,h))}}function Zoe(t){const{as:e,[Twe]:i,[T5]:r,[bwe]:o,...l}=t,d=l,h=typeof r=="string"?e??r:r;return typeof h!="string"&&e&&(d.as=e),{elementType:h,props:d,renderFunction:o}}const Ix=sZe,hft=(t,e,i)=>{const{elementType:r,renderFunction:o,props:l}=Zoe(t),d={...l,...e};return o?Ix.jsx($.Fragment,{children:o(r,d)},i):Ix.jsx(r,d,i)},pft=(t,e,i)=>{const{elementType:r,renderFunction:o,props:l}=Zoe(t),d={...l,...e};return o?Ix.jsx($.Fragment,{children:o(r,{...d,children:Ix.jsxs($.Fragment,{children:d.children},void 0)})},i):Ix.jsxs(r,d,i)},yr=jwe(Ix.jsx,hft),Uf=jwe(Ix.jsxs,pft),Xoe=$.createContext(void 0),gft={},mft=Xoe.Provider,fft=()=>$.useContext(Xoe)?$.useContext(Xoe):gft,vft=(t,e)=>(Pd(t),yr(Omt,{value:e.provider,children:yr(kmt,{value:e.theme,children:yr(Mmt,{value:e.themeClassName,children:yr(Bmt,{value:e.customStyleHooks_unstable,children:yr(Dmt,{value:e.tooltip,children:yr(Swe,{dir:e.textDirection,children:yr(mft,{value:e.iconDirection,children:yr(Nmt,{value:e.overrides_unstable,children:Uf(t.root,{children:[Koe()?null:yr("style",{dangerouslySetInnerHTML:{__html:t.serverStyleProps.cssRule},...t.serverStyleProps.attributes}),t.root.children]})})})})})})})})}));var yft=typeof WeakRef<"u",Gwe=class{constructor(t){yft&&typeof t=="object"?this._weakRef=new WeakRef(t):this._instance=t}deref(){var t,e;let i;return this._weakRef?(i=(t=this._weakRef)==null?void 0:t.deref(),i||delete this._weakRef):(i=this._instance,(e=i?.isDisposed)!=null&&e.call(i)&&delete this._instance),i}},SA="keyborg:focusin",MH="keyborg:focusout";function Sft(t){const e=t.HTMLElement,i=e.prototype.focus;let r=!1;return e.prototype.focus=function(){r=!0},t.document.createElement("button").focus(),e.prototype.focus=i,r}var ese=!1;function PM(t){const e=t.focus;e.__keyborgNativeFocus?e.__keyborgNativeFocus.call(t):t.focus()}function bft(t){const e=t;ese||(ese=Sft(e));const i=e.HTMLElement.prototype.focus;if(i.__keyborgNativeFocus)return;e.HTMLElement.prototype.focus=p;const r=new Set,o=f=>{const y=f.target;if(!y)return;const T=new CustomEvent(MH,{cancelable:!0,bubbles:!0,composed:!0,detail:{originalEvent:f}});y.dispatchEvent(T)},l=f=>{const y=f.target;if(!y)return;let T=f.composedPath()[0];const C=new Set;for(;T;)T.nodeType===Node.DOCUMENT_FRAGMENT_NODE?(C.add(T),T=T.host):T=T.parentNode;for(const E of r){const I=E.deref();(!I||!C.has(I))&&(r.delete(E),I&&(I.removeEventListener("focusin",l,!0),I.removeEventListener("focusout",o,!0)))}d(y,f.relatedTarget||void 0)},d=(f,y,T)=>{var C;const E=f.shadowRoot;if(E){for(const D of r)if(D.deref()===E)return;E.addEventListener("focusin",l,!0),E.addEventListener("focusout",o,!0),r.add(new Gwe(E));return}const I={relatedTarget:y,originalEvent:T},w=new CustomEvent(SA,{cancelable:!0,bubbles:!0,composed:!0,detail:I});w.details=I,(ese||h.lastFocusedProgrammatically)&&(I.isFocusedProgrammatically=f===((C=h.lastFocusedProgrammatically)==null?void 0:C.deref()),h.lastFocusedProgrammatically=void 0),f.dispatchEvent(w)},h=e.__keyborgData={focusInHandler:l,focusOutHandler:o,shadowTargets:r};e.document.addEventListener("focusin",e.__keyborgData.focusInHandler,!0),e.document.addEventListener("focusout",e.__keyborgData.focusOutHandler,!0);function p(){const f=e.__keyborgData;return f&&(f.lastFocusedProgrammatically=new Gwe(this)),i.apply(this,arguments)}let g=e.document.activeElement;for(;g&&g.shadowRoot;)d(g),g=g.shadowRoot.activeElement;p.__keyborgNativeFocus=i}function Tft(t){const e=t,i=e.HTMLElement.prototype,r=i.focus.__keyborgNativeFocus,o=e.__keyborgData;if(o){e.document.removeEventListener("focusin",o.focusInHandler,!0),e.document.removeEventListener("focusout",o.focusOutHandler,!0);for(const l of o.shadowTargets){const d=l.deref();d&&(d.removeEventListener("focusin",o.focusInHandler,!0),d.removeEventListener("focusout",o.focusOutHandler,!0))}o.shadowTargets.clear(),delete e.__keyborgData}r&&(i.focus=r)}var Cft=500,qwe=0,_ft=class{constructor(t,e){this._isNavigatingWithKeyboard_DO_NOT_USE=!1,this._onFocusIn=r=>{if(this._isMouseOrTouchUsedTimer||this.isNavigatingWithKeyboard)return;const o=r.detail;o.relatedTarget&&(o.isFocusedProgrammatically||o.isFocusedProgrammatically===void 0||(this.isNavigatingWithKeyboard=!0))},this._onMouseDown=r=>{r.buttons===0||r.clientX===0&&r.clientY===0&&r.screenX===0&&r.screenY===0||this._onMouseOrTouch()},this._onMouseOrTouch=()=>{const r=this._win;r&&(this._isMouseOrTouchUsedTimer&&r.clearTimeout(this._isMouseOrTouchUsedTimer),this._isMouseOrTouchUsedTimer=r.setTimeout(()=>{delete this._isMouseOrTouchUsedTimer},1e3)),this.isNavigatingWithKeyboard=!1},this._onKeyDown=r=>{this.isNavigatingWithKeyboard?this._shouldDismissKeyboardNavigation(r)&&this._scheduleDismiss():this._shouldTriggerKeyboardNavigation(r)&&(this.isNavigatingWithKeyboard=!0)},this.id="c"+ ++qwe,this._win=t;const i=t.document;if(e){const r=e.triggerKeys,o=e.dismissKeys;r?.length&&(this._triggerKeys=new Set(r)),o?.length&&(this._dismissKeys=new Set(o))}i.addEventListener(SA,this._onFocusIn,!0),i.addEventListener("mousedown",this._onMouseDown,!0),t.addEventListener("keydown",this._onKeyDown,!0),i.addEventListener("touchstart",this._onMouseOrTouch,!0),i.addEventListener("touchend",this._onMouseOrTouch,!0),i.addEventListener("touchcancel",this._onMouseOrTouch,!0),bft(t)}get isNavigatingWithKeyboard(){return this._isNavigatingWithKeyboard_DO_NOT_USE}set isNavigatingWithKeyboard(t){this._isNavigatingWithKeyboard_DO_NOT_USE!==t&&(this._isNavigatingWithKeyboard_DO_NOT_USE=t,this.update())}dispose(){const t=this._win;if(t){this._isMouseOrTouchUsedTimer&&(t.clearTimeout(this._isMouseOrTouchUsedTimer),this._isMouseOrTouchUsedTimer=void 0),this._dismissTimer&&(t.clearTimeout(this._dismissTimer),this._dismissTimer=void 0),Tft(t);const e=t.document;e.removeEventListener(SA,this._onFocusIn,!0),e.removeEventListener("mousedown",this._onMouseDown,!0),t.removeEventListener("keydown",this._onKeyDown,!0),e.removeEventListener("touchstart",this._onMouseOrTouch,!0),e.removeEventListener("touchend",this._onMouseOrTouch,!0),e.removeEventListener("touchcancel",this._onMouseOrTouch,!0),delete this._win}}isDisposed(){return!!this._win}update(){var t,e;const i=(e=(t=this._win)==null?void 0:t.__keyborg)==null?void 0:e.refs;if(i)for(const r of Object.keys(i))tse.update(i[r],this.isNavigatingWithKeyboard)}_shouldTriggerKeyboardNavigation(t){var e;if(t.key==="Tab")return!0;const i=(e=this._win)==null?void 0:e.document.activeElement,r=!this._triggerKeys||this._triggerKeys.has(t.keyCode),o=i&&(i.tagName==="INPUT"||i.tagName==="TEXTAREA"||i.isContentEditable);return r&&!o}_shouldDismissKeyboardNavigation(t){var e;return(e=this._dismissKeys)==null?void 0:e.has(t.keyCode)}_scheduleDismiss(){const t=this._win;if(t){this._dismissTimer&&(t.clearTimeout(this._dismissTimer),this._dismissTimer=void 0);const e=t.document.activeElement;this._dismissTimer=t.setTimeout(()=>{this._dismissTimer=void 0;const i=t.document.activeElement;e&&i&&e===i&&(this.isNavigatingWithKeyboard=!1)},Cft)}}},tse=class yQe{constructor(e,i){this._cb=[],this._id="k"+ ++qwe,this._win=e;const r=e.__keyborg;r?(this._core=r.core,r.refs[this._id]=this):(this._core=new _ft(e,i),e.__keyborg={core:this._core,refs:{[this._id]:this}})}static create(e,i){return new yQe(e,i)}static dispose(e){e.dispose()}static update(e,i){e._cb.forEach(r=>r(i))}dispose(){var e;const i=(e=this._win)==null?void 0:e.__keyborg;i?.refs[this._id]?(delete i.refs[this._id],Object.keys(i.refs).length===0&&(i.core.dispose(),delete this._win.__keyborg)):process.env.NODE_ENV!=="production"&&console.error(`Keyborg instance ${this._id} is being disposed incorrectly.`),this._cb=[],delete this._core,delete this._win}isNavigatingWithKeyboard(){var e;return!!((e=this._core)!=null&&e.isNavigatingWithKeyboard)}subscribe(e){this._cb.push(e)}unsubscribe(e){const i=this._cb.indexOf(e);i>=0&&this._cb.splice(i,1)}setVal(e){this._core&&(this._core.isNavigatingWithKeyboard=e)}};function ise(t,e){return tse.create(t,e)}function nse(t){tse.dispose(t)}/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 *//*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */const DM="data-tabster",Wwe="data-tabster-dummy",Kwe=["a[href]","button:not([disabled])","input:not([disabled])","select:not([disabled])","textarea:not([disabled])","*[tabindex]","*[contenteditable]","details > summary","audio[controls]","video[controls]"].join(", "),LM={EscapeGroupper:1,Restorer:2,Deloser:3},xL={Invisible:0,PartiallyVisible:1,Visible:2},PH={Source:0,Target:1},bA={Both:0,Vertical:1,Horizontal:2,Grid:3,GridLinear:4},ag={ArrowUp:1,ArrowDown:2,ArrowLeft:3,ArrowRight:4,PageUp:5,PageDown:6,Home:7,End:8},QW={Unlimited:0,Limited:1,LimitedTrapFocus:2},Jwe={Enter:1},Eft={Outside:2};/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */function KS(t,e){var i;return(i=t.storageEntry(e))===null||i===void 0?void 0:i.tabster}function Ywe(t,e,i){var r,o;const l=i||t._noop?void 0:e.getAttribute(DM);let d=t.storageEntry(e),h;if(l)if(l!==((r=d?.attr)===null||r===void 0?void 0:r.string))try{const y=JSON.parse(l);if(typeof y!="object")throw new Error(`Value is not a JSON object, got '${l}'.`);h={string:l,object:y}}catch(y){process.env.NODE_ENV==="development"&&console.error(`data-tabster attribute error: ${y}`,e)}else return;else if(!d)return;d||(d=t.storageEntry(e,!0)),d.tabster||(d.tabster={});const p=d.tabster||{},g=((o=d.attr)===null||o===void 0?void 0:o.object)||{},f=h?.object||{};for(const y of Object.keys(g))if(!f[y]){if(y==="root"){const T=p[y];T&&t.root.onRoot(T,!0)}switch(y){case"deloser":case"root":case"groupper":case"modalizer":case"restorer":case"mover":const T=p[y];T&&(T.dispose(),delete p[y]);break;case"observed":delete p[y],t.observedElement&&t.observedElement.onObservedElementUpdate(e);break;case"focusable":case"outline":case"uncontrolled":case"sys":delete p[y];break}}for(const y of Object.keys(f)){const T=f.sys;switch(y){case"deloser":p.deloser?p.deloser.setProps(f.deloser):t.deloser?p.deloser=t.deloser.createDeloser(e,f.deloser):process.env.NODE_ENV==="development"&&console.error("Deloser API used before initialization, please call `getDeloser()`");break;case"root":p.root?p.root.setProps(f.root):p.root=t.root.createRoot(e,f.root,T),t.root.onRoot(p.root);break;case"modalizer":p.modalizer?p.modalizer.setProps(f.modalizer):t.modalizer?p.modalizer=t.modalizer.createModalizer(e,f.modalizer,T):process.env.NODE_ENV==="development"&&console.error("Modalizer API used before initialization, please call `getModalizer()`");break;case"restorer":p.restorer?p.restorer.setProps(f.restorer):t.restorer?f.restorer&&(p.restorer=t.restorer.createRestorer(e,f.restorer)):process.env.NODE_ENV==="development"&&console.error("Restorer API used before initialization, please call `getRestorer()`");break;case"focusable":p.focusable=f.focusable;break;case"groupper":p.groupper?p.groupper.setProps(f.groupper):t.groupper?p.groupper=t.groupper.createGroupper(e,f.groupper,T):process.env.NODE_ENV==="development"&&console.error("Groupper API used before initialization, please call `getGroupper()`");break;case"mover":p.mover?p.mover.setProps(f.mover):t.mover?p.mover=t.mover.createMover(e,f.mover,T):process.env.NODE_ENV==="development"&&console.error("Mover API used before initialization, please call `getMover()`");break;case"observed":t.observedElement?(p.observed=f.observed,t.observedElement.onObservedElementUpdate(e)):process.env.NODE_ENV==="development"&&console.error("ObservedElement API used before initialization, please call `getObservedElement()`");break;case"uncontrolled":p.uncontrolled=f.uncontrolled;break;case"outline":t.outline?p.outline=f.outline:process.env.NODE_ENV==="development"&&console.error("Outline API used before initialization, please call `getOutline()`");break;case"sys":p.sys=f.sys;break;default:console.error(`Unknown key '${y}' in data-tabster attribute value.`)}}h?d.attr=h:(Object.keys(p).length===0&&(delete d.tabster,delete d.attr),t.storageEntry(e,!1))}/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */const Aft="tabster:focusin",Ift="tabster:focusout",ase="tabster:movefocus",wft="tabster:mover:state",Qwe="tabster:mover:movefocus",Zwe="tabster:mover:memorized-element",Xwe="tabster:groupper:movefocus",rse="tabster:restorer:restore-focus",kft="tabster:root:focus",Rft="tabster:root:blur",Mft=typeof CustomEvent<"u"?CustomEvent:function(){};class wx extends Mft{constructor(e,i){super(e,{bubbles:!0,cancelable:!0,composed:!0,detail:i}),this.details=i}}class Pft extends wx{constructor(e){super(Aft,e)}}class Dft extends wx{constructor(e){super(Ift,e)}}class BL extends wx{constructor(e){super(ase,e)}}class eke extends wx{constructor(e){super(wft,e)}}class tke extends wx{constructor(){super(rse)}}class Lft extends wx{constructor(e){super(kft,e)}}class Oft extends wx{constructor(e){super(Rft,e)}}/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */const ma={createMutationObserver:t=>new MutationObserver(t),createTreeWalker:(t,e,i,r)=>t.createTreeWalker(e,i,r),getParentNode:t=>t?t.parentNode:null,getParentElement:t=>t?t.parentElement:null,nodeContains:(t,e)=>!!(e&&t?.contains(e)),getActiveElement:t=>t.activeElement,querySelector:(t,e)=>t.querySelector(e),querySelectorAll:(t,e)=>Array.prototype.slice.call(t.querySelectorAll(e),0),getElementById:(t,e)=>t.getElementById(e),getFirstChild:t=>t?.firstChild||null,getLastChild:t=>t?.lastChild||null,getNextSibling:t=>t?.nextSibling||null,getPreviousSibling:t=>t?.previousSibling||null,getFirstElementChild:t=>t?.firstElementChild||null,getLastElementChild:t=>t?.lastElementChild||null,getNextElementSibling:t=>t?.nextElementSibling||null,getPreviousElementSibling:t=>t?.previousElementSibling||null,appendChild:(t,e)=>t.appendChild(e),insertBefore:(t,e,i)=>t.insertBefore(e,i),getSelection:t=>{var e;return((e=t.ownerDocument)===null||e===void 0?void 0:e.getSelection())||null},getElementsByName:(t,e)=>t.ownerDocument.getElementsByName(e)};function Nft(t){for(const e of Object.keys(t))ma[e]=t[e]}/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */let ose;const ike=typeof DOMRect<"u"?DOMRect:class{constructor(t,e,i,r){this.left=t||0,this.top=e||0,this.right=(t||0)+(i||0),this.bottom=(e||0)+(r||0)}};let xft=0;try{document.createTreeWalker(document,NodeFilter.SHOW_ELEMENT),ose=!1}catch{ose=!0}const sse=100;function OM(t){const e=t();let i=e.__tabsterInstanceContext;return i||(i={elementByUId:{},basics:{Promise:e.Promise||void 0,WeakRef:e.WeakRef||void 0},containerBoundingRectCache:{},lastContainerBoundingRectCacheId:0,fakeWeakRefs:[],fakeWeakRefsStarted:!1},e.__tabsterInstanceContext=i),i}function Bft(t){const e=t.__tabsterInstanceContext;e&&(e.elementByUId={},delete e.WeakRef,e.containerBoundingRectCache={},e.containerBoundingRectCacheTimer&&t.clearTimeout(e.containerBoundingRectCacheTimer),e.fakeWeakRefsTimer&&t.clearTimeout(e.fakeWeakRefsTimer),e.fakeWeakRefs=[],delete t.__tabsterInstanceContext)}function Fft(t){const e=t.__tabsterInstanceContext;return new(e?.basics.WeakMap||WeakMap)}function Uft(t){return!!t.querySelector(Kwe)}class nke{constructor(e){this._target=e}deref(){return this._target}static cleanup(e,i){return e._target?i||!cse(e._target.ownerDocument,e._target)?(delete e._target,!0):!1:!0}}class TA{constructor(e,i,r){const o=OM(e);let l;o.WeakRef?l=new o.WeakRef(i):(l=new nke(i),o.fakeWeakRefs.push(l)),this._ref=l,this._data=r}get(){const e=this._ref;let i;return e&&(i=e.deref(),i||delete this._ref),i}getData(){return this._data}}function ake(t,e){const i=OM(t);i.fakeWeakRefs=i.fakeWeakRefs.filter(r=>!nke.cleanup(r,e))}function rke(t){const e=OM(t);e.fakeWeakRefsStarted||(e.fakeWeakRefsStarted=!0,e.WeakRef=Gft(e)),e.fakeWeakRefsTimer||(e.fakeWeakRefsTimer=t().setTimeout(()=>{e.fakeWeakRefsTimer=void 0,ake(t),rke(t)},2*60*1e3))}function zft(t){const e=OM(t);e.fakeWeakRefsStarted=!1,e.fakeWeakRefsTimer&&(t().clearTimeout(e.fakeWeakRefsTimer),e.fakeWeakRefsTimer=void 0,e.fakeWeakRefs=[])}function lse(t,e,i){if(e.nodeType!==Node.ELEMENT_NODE)return;const r=ose?i:{acceptNode:i};return ma.createTreeWalker(t,e,NodeFilter.SHOW_ELEMENT,r,!1)}function oke(t,e){let i=e.__tabsterCacheId;const r=OM(t),o=i?r.containerBoundingRectCache[i]:void 0;if(o)return o.rect;const l=e.ownerDocument&&e.ownerDocument.documentElement;if(!l)return new ike;let d=0,h=0,p=l.clientWidth,g=l.clientHeight;if(e!==l){const y=e.getBoundingClientRect();d=Math.max(d,y.left),h=Math.max(h,y.top),p=Math.min(p,y.right),g=Math.min(g,y.bottom)}const f=new ike(d<p?d:-1,h<g?h:-1,d<p?p-d:0,h<g?g-h:0);return i||(i="r-"+ ++r.lastContainerBoundingRectCacheId,e.__tabsterCacheId=i),r.containerBoundingRectCache[i]={rect:f,element:e},r.containerBoundingRectCacheTimer||(r.containerBoundingRectCacheTimer=window.setTimeout(()=>{r.containerBoundingRectCacheTimer=void 0;for(const y of Object.keys(r.containerBoundingRectCache))delete r.containerBoundingRectCache[y].element.__tabsterCacheId;r.containerBoundingRectCache={}},50)),f}function ske(t,e,i){const r=lke(e);if(!r)return!1;const o=oke(t,r),l=e.getBoundingClientRect(),d=l.height*(1-i),h=Math.max(0,o.top-l.top),p=Math.max(0,l.bottom-o.bottom),g=h+p;return g===0||g<=d}function Vft(t,e,i){const r=lke(e);if(r){const o=oke(t,r),l=e.getBoundingClientRect();i?r.scrollTop+=l.top-o.top:r.scrollTop+=l.bottom-o.bottom}}function lke(t){const e=t.ownerDocument;if(e){for(let i=ma.getParentElement(t);i;i=ma.getParentElement(i))if(i.scrollWidth>i.clientWidth||i.scrollHeight>i.clientHeight)return i;return e.documentElement}return null}function $ft(t){t.__shouldIgnoreFocus=!0}function cke(t){return!!t.__shouldIgnoreFocus}function Hft(t){const e=new Uint32Array(4);if(t.crypto&&t.crypto.getRandomValues)t.crypto.getRandomValues(e);else if(t.msCrypto&&t.msCrypto.getRandomValues)t.msCrypto.getRandomValues(e);else for(let r=0;r<e.length;r++)e[r]=4294967295*Math.random();const i=[];for(let r=0;r<e.length;r++)i.push(e[r].toString(36));return i.push("|"),i.push((++xft).toString(36)),i.push("|"),i.push(Date.now().toString(36)),i.join("")}function ZW(t,e){const i=OM(t);let r=e.__tabsterElementUID;return r||(r=e.__tabsterElementUID=Hft(t())),!i.elementByUId[r]&&cse(e.ownerDocument,e)&&(i.elementByUId[r]=new TA(t,e)),r}function dke(t,e){const i=OM(t);for(const r of Object.keys(i.elementByUId)){const o=i.elementByUId[r],l=o&&o.get();l&&e&&!ma.nodeContains(e,l)||delete i.elementByUId[r]}}function cse(t,e){return ma.nodeContains(t?.body,e)}function uke(t,e){const i=t.matches||t.matchesSelector||t.msMatchesSelector||t.webkitMatchesSelector;return i&&i.call(t,e)}function jft(t){const e=OM(t);if(e.basics.Promise)return e.basics.Promise;throw new Error("No Promise defined.")}function Gft(t){return t.basics.WeakRef}let qft=0;class XW{constructor(e,i,r){const o=e.getWindow;this._tabster=e,this._element=new TA(o,i),this._props={...r},this.id="i"+ ++qft}getElement(){return this._element.get()}getProps(){return this._props}setProps(e){this._props={...e}}}class eK{constructor(e,i,r,o,l){var d;this._focusIn=f=>{if(this._fixedTarget){const T=this._fixedTarget.get();T&&PM(T);return}const y=this.input;if(this.onFocusIn&&y){const T=f.relatedTarget;this.onFocusIn(this,this._isBackward(!0,y,T),T)}},this._focusOut=f=>{if(this._fixedTarget)return;this.useDefaultAction=!1;const y=this.input;if(this.onFocusOut&&y){const T=f.relatedTarget;this.onFocusOut(this,this._isBackward(!1,y,T),T)}};const h=e(),p=h.document.createElement("i");p.tabIndex=0,p.setAttribute("role","none"),p.setAttribute(Wwe,""),p.setAttribute("aria-hidden","true");const g=p.style;g.position="fixed",g.width=g.height="1px",g.opacity="0.001",g.zIndex="-1",g.setProperty("content-visibility","hidden"),$ft(p),this.input=p,this.isFirst=r.isFirst,this.isOutside=i,this._isPhantom=(d=r.isPhantom)!==null&&d!==void 0?d:!1,this._fixedTarget=l,p.addEventListener("focusin",this._focusIn),p.addEventListener("focusout",this._focusOut),p.__tabsterDummyContainer=o,this._isPhantom&&(this._disposeTimer=h.setTimeout(()=>{delete this._disposeTimer,this.dispose()},0),this._clearDisposeTimeout=()=>{this._disposeTimer&&(h.clearTimeout(this._disposeTimer),delete this._disposeTimer),delete this._clearDisposeTimeout})}dispose(){var e;this._clearDisposeTimeout&&this._clearDisposeTimeout();const i=this.input;i&&(delete this._fixedTarget,delete this.onFocusIn,delete this.onFocusOut,delete this.input,i.removeEventListener("focusin",this._focusIn),i.removeEventListener("focusout",this._focusOut),delete i.__tabsterDummyContainer,(e=ma.getParentNode(i))===null||e===void 0||e.removeChild(i))}setTopLeft(e,i){var r;const o=(r=this.input)===null||r===void 0?void 0:r.style;o&&(o.top=`${e}px`,o.left=`${i}px`)}_isBackward(e,i,r){return e&&!r?!this.isFirst:!!(r&&i.compareDocumentPosition(r)&Node.DOCUMENT_POSITION_FOLLOWING)}}const dse={Root:1,Mover:3,Groupper:4};class DH{constructor(e,i,r,o,l,d){this._element=i,this._instance=new Kft(e,i,this,r,o,l,d)}_setHandlers(e,i){this._onFocusIn=e,this._onFocusOut=i}moveOut(e){var i;(i=this._instance)===null||i===void 0||i.moveOut(e)}moveOutWithDefaultAction(e,i){var r;(r=this._instance)===null||r===void 0||r.moveOutWithDefaultAction(e,i)}getHandler(e){return e?this._onFocusIn:this._onFocusOut}setTabbable(e){var i;(i=this._instance)===null||i===void 0||i.setTabbable(this,e)}dispose(){this._instance&&(this._instance.dispose(this),delete this._instance),delete this._onFocusIn,delete this._onFocusOut}static moveWithPhantomDummy(e,i,r,o,l){const h=new eK(e.getWindow,!0,{isPhantom:!0,isFirst:!0}).input;if(h){let p,g;if(i.tagName==="BODY")p=i,g=r&&o||!r&&!o?ma.getFirstElementChild(i):null;else{r&&(!o||o&&!e.focusable.isFocusable(i,!1,!0,!0))?(p=i,g=o?i.firstElementChild:null):(p=ma.getParentElement(i),g=r&&o||!r&&!o?i:ma.getNextElementSibling(i));let f,y;do f=r&&o||!r&&!o?ma.getPreviousElementSibling(g):g,y=LH(f),y===i?g=r&&o||!r&&!o?f:ma.getNextElementSibling(f):y=null;while(y)}p?.dispatchEvent(new BL({by:"root",owner:p,next:null,relatedEvent:l}))&&(ma.insertBefore(p,h,g),PM(h))}}static addPhantomDummyWithTarget(e,i,r,o){const d=new eK(e.getWindow,!0,{isPhantom:!0,isFirst:!0},void 0,new TA(e.getWindow,o)).input;if(d){let h,p;Uft(i)&&!r?(h=i,p=ma.getFirstElementChild(i)):(h=ma.getParentElement(i),p=r?i:ma.getNextElementSibling(i)),h&&ma.insertBefore(h,d,p)}}}function FL(t,e){var i;const r={1:"Root",2:"Modalizer",3:"Mover",4:"Groupper"};(i=t.input)===null||i===void 0||i.setAttribute(Wwe,[`isFirst=${t.isFirst}`,`isOutside=${t.isOutside}`,...e.map(o=>`(${r[o.priority]}, tabbable=${o.tabbable})`)].join(", "))}class Wft{constructor(e){this._updateQueue=new Set,this._lastUpdateQueueTime=0,this._changedParents=new WeakSet,this._dummyElements=[],this._dummyCallbacks=new WeakMap,this._domChanged=i=>{var r;this._changedParents.has(i)||(this._changedParents.add(i),!this._updateDummyInputsTimer&&(this._updateDummyInputsTimer=(r=this._win)===null||r===void 0?void 0:r.call(this).setTimeout(()=>{delete this._updateDummyInputsTimer;for(const o of this._dummyElements){const l=o.get();if(l){const d=this._dummyCallbacks.get(l);if(d){const h=ma.getParentNode(l);(!h||this._changedParents.has(h))&&d()}}}this._changedParents=new WeakSet},sse)))},this._win=e}add(e,i){!this._dummyCallbacks.has(e)&&this._win&&(this._dummyElements.push(new TA(this._win,e)),this._dummyCallbacks.set(e,i),this.domChanged=this._domChanged)}remove(e){this._dummyElements=this._dummyElements.filter(i=>{const r=i.get();return r&&r!==e}),this._dummyCallbacks.delete(e),this._dummyElements.length===0&&delete this.domChanged}dispose(){var e;const i=(e=this._win)===null||e===void 0?void 0:e.call(this);this._updateTimer&&(i?.clearTimeout(this._updateTimer),delete this._updateTimer),this._updateDummyInputsTimer&&(i?.clearTimeout(this._updateDummyInputsTimer),delete this._updateDummyInputsTimer),this._changedParents=new WeakSet,this._dummyCallbacks=new WeakMap,this._dummyElements=[],this._updateQueue.clear(),delete this.domChanged,delete this._win}updatePositions(e){this._win&&(this._updateQueue.add(e),this._lastUpdateQueueTime=Date.now(),this._scheduledUpdatePositions())}_scheduledUpdatePositions(){var e;this._updateTimer||(this._updateTimer=(e=this._win)===null||e===void 0?void 0:e.call(this).setTimeout(()=>{if(delete this._updateTimer,this._lastUpdateQueueTime+sse<=Date.now()){const i=new Map,r=[];for(const o of this._updateQueue)r.push(o(i));this._updateQueue.clear();for(const o of r)o();i.clear()}else this._scheduledUpdatePositions()},sse))}}class Kft{constructor(e,i,r,o,l,d,h){this._wrappers=[],this._isOutside=!1,this._transformElements=new Set,this._onFocusIn=(C,E,I)=>{this._onFocus(!0,C,E,I)},this._onFocusOut=(C,E,I)=>{this._onFocus(!1,C,E,I)},this.moveOut=C=>{var E;const I=this._firstDummy,w=this._lastDummy;if(I&&w){this._ensurePosition();const D=I.input,F=w.input,x=(E=this._element)===null||E===void 0?void 0:E.get();if(D&&F&&x){let B;C?(D.tabIndex=0,B=D):(F.tabIndex=0,B=F),B&&PM(B)}}},this.moveOutWithDefaultAction=(C,E)=>{var I;const w=this._firstDummy,D=this._lastDummy;if(w&&D){this._ensurePosition();const F=w.input,x=D.input,B=(I=this._element)===null||I===void 0?void 0:I.get();if(F&&x&&B){let L;C?!w.isOutside&&this._tabster.focusable.isFocusable(B,!0,!0,!0)?L=B:(w.useDefaultAction=!0,F.tabIndex=0,L=F):(D.useDefaultAction=!0,x.tabIndex=0,L=x),L&&B.dispatchEvent(new BL({by:"root",owner:B,next:null,relatedEvent:E}))&&PM(L)}}},this.setTabbable=(C,E)=>{var I,w;for(const F of this._wrappers)if(F.manager===C){F.tabbable=E;break}const D=this._getCurrent();if(D){const F=D.tabbable?0:-1;let x=(I=this._firstDummy)===null||I===void 0?void 0:I.input;x&&(x.tabIndex=F),x=(w=this._lastDummy)===null||w===void 0?void 0:w.input,x&&(x.tabIndex=F)}process.env.NODE_ENV==="development"&&(this._firstDummy&&FL(this._firstDummy,this._wrappers),this._lastDummy&&FL(this._lastDummy,this._wrappers))},this._addDummyInputs=()=>{this._addTimer||(this._addTimer=this._getWindow().setTimeout(()=>{delete this._addTimer,this._ensurePosition(),process.env.NODE_ENV==="development"&&(this._firstDummy&&FL(this._firstDummy,this._wrappers),this._lastDummy&&FL(this._lastDummy,this._wrappers)),this._addTransformOffsets()},0))},this._addTransformOffsets=()=>{this._tabster._dummyObserver.updatePositions(this._computeTransformOffsets)},this._computeTransformOffsets=C=>{var E,I;const w=((E=this._firstDummy)===null||E===void 0?void 0:E.input)||((I=this._lastDummy)===null||I===void 0?void 0:I.input),D=this._transformElements,F=new Set;let x=0,B=0;const L=this._getWindow();for(let z=w;z&&z.nodeType===Node.ELEMENT_NODE;z=ma.getParentElement(z)){let H=C.get(z);if(H===void 0){const j=L.getComputedStyle(z).transform;j&&j!=="none"&&(H={scrollTop:z.scrollTop,scrollLeft:z.scrollLeft}),C.set(z,H||null)}H&&(F.add(z),D.has(z)||z.addEventListener("scroll",this._addTransformOffsets),x+=H.scrollTop,B+=H.scrollLeft)}for(const z of D)F.has(z)||z.removeEventListener("scroll",this._addTransformOffsets);return this._transformElements=F,()=>{var z,H;(z=this._firstDummy)===null||z===void 0||z.setTopLeft(x,B),(H=this._lastDummy)===null||H===void 0||H.setTopLeft(x,B)}};const p=i.get();if(!p)throw new Error("No element");this._tabster=e,this._getWindow=e.getWindow,this._callForDefaultAction=h;const g=p.__tabsterDummy;if((g||this)._wrappers.push({manager:r,priority:o,tabbable:!0}),g)return process.env.NODE_ENV==="development"&&(this._firstDummy&&FL(this._firstDummy,g._wrappers),this._lastDummy&&FL(this._lastDummy,g._wrappers)),g;p.__tabsterDummy=this;const f=l?.dummyInputsPosition,y=p.tagName;this._isOutside=f?f===Eft.Outside:(d||y==="UL"||y==="OL"||y==="TABLE")&&!(y==="LI"||y==="TD"||y==="TH"),this._firstDummy=new eK(this._getWindow,this._isOutside,{isFirst:!0},i),this._lastDummy=new eK(this._getWindow,this._isOutside,{isFirst:!1},i);const T=this._firstDummy.input;T&&e._dummyObserver.add(T,this._addDummyInputs),this._firstDummy.onFocusIn=this._onFocusIn,this._firstDummy.onFocusOut=this._onFocusOut,this._lastDummy.onFocusIn=this._onFocusIn,this._lastDummy.onFocusOut=this._onFocusOut,this._element=i,this._addDummyInputs()}dispose(e,i){var r,o,l,d;const h=this._wrappers=this._wrappers.filter(p=>p.manager!==e&&!i);if(process.env.NODE_ENV==="development"&&(this._firstDummy&&FL(this._firstDummy,h),this._lastDummy&&FL(this._lastDummy,h)),h.length===0){delete((r=this._element)===null||r===void 0?void 0:r.get()).__tabsterDummy;for(const f of this._transformElements)f.removeEventListener("scroll",this._addTransformOffsets);this._transformElements.clear();const p=this._getWindow();this._addTimer&&(p.clearTimeout(this._addTimer),delete this._addTimer);const g=(o=this._firstDummy)===null||o===void 0?void 0:o.input;g&&this._tabster._dummyObserver.remove(g),(l=this._firstDummy)===null||l===void 0||l.dispose(),(d=this._lastDummy)===null||d===void 0||d.dispose()}}_onFocus(e,i,r,o){var l;const d=this._getCurrent();d&&(!i.useDefaultAction||this._callForDefaultAction)&&((l=d.manager.getHandler(e))===null||l===void 0||l(i,r,o))}_getCurrent(){return this._wrappers.sort((e,i)=>e.tabbable!==i.tabbable?e.tabbable?-1:1:e.priority-i.priority),this._wrappers[0]}_ensurePosition(){var e,i,r;const o=(e=this._element)===null||e===void 0?void 0:e.get(),l=(i=this._firstDummy)===null||i===void 0?void 0:i.input,d=(r=this._lastDummy)===null||r===void 0?void 0:r.input;if(!(!o||!l||!d))if(this._isOutside){const h=ma.getParentNode(o);if(h){const p=ma.getNextSibling(o);p!==d&&ma.insertBefore(h,d,p),ma.getPreviousElementSibling(o)!==l&&ma.insertBefore(h,l,o)}}else{ma.getLastElementChild(o)!==d&&ma.appendChild(o,d);const h=ma.getFirstElementChild(o);h&&h!==l&&h.parentNode&&ma.insertBefore(h.parentNode,l,h)}}}function hke(t){let e=null;for(let i=ma.getLastElementChild(t);i;i=ma.getLastElementChild(i))e=i;return e||void 0}function Jft(t,e){let i=t,r=null;for(;i&&!r;)r=e?ma.getPreviousElementSibling(i):ma.getNextElementSibling(i),i=ma.getParentElement(i);return r||void 0}function Yft(t){var e,i;const r=t.ownerDocument,o=(e=r.defaultView)===null||e===void 0?void 0:e.getComputedStyle(t);return t.offsetParent===null&&r.body!==t&&o?.position!=="fixed"||o?.visibility==="hidden"||o?.position==="fixed"&&(o.display==="none"||((i=t.parentElement)===null||i===void 0?void 0:i.offsetParent)===null&&r.body!==t.parentElement)}function use(t){return t.tagName==="INPUT"&&!!t.name&&t.type==="radio"}function Qft(t){if(!use(t))return;const e=t.name;let i=Array.from(ma.getElementsByName(t,e)),r;return i=i.filter(o=>use(o)?(o.checked&&(r=o),!0):!1),{name:e,buttons:new Set(i),checked:r}}function LH(t){var e;return((e=t?.__tabsterDummyContainer)===null||e===void 0?void 0:e.get())||null}/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */function hse(t,e){const i=JSON.stringify(t);return e===!0?i:{[DM]:i}}function Zft(t,e){for(const i of Object.keys(e)){const r=e[i];r?t[i]=r:delete t[i]}}function Xft(t,e,i){let r;{const o=t.getAttribute(DM);if(o)try{r=JSON.parse(o)}catch(l){process.env.NODE_ENV==="development"&&console.error(`data-tabster attribute error: ${l}`,t)}}r||(r={}),Zft(r,e),Object.keys(r).length>0?t.setAttribute(DM,hse(r,!0)):t.removeAttribute(DM)}/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */function pke(t,e,i){if(process.env.NODE_ENV==="development"){const r=t.get();r&&(e?r.style.removeProperty("--tabster-root"):r.style.setProperty("--tabster-root",i+","))}}class gke extends DH{constructor(e,i,r,o){super(e,i,dse.Root,o,void 0,!0),this._onDummyInputFocus=l=>{var d;if(l.useDefaultAction)this._setFocused(!1);else{this._tabster.keyboardNavigation.setNavigatingWithKeyboard(!0);const h=this._element.get();if(h){this._setFocused(!0);const p=this._tabster.focusedElement.getFirstOrLastTabbable(l.isFirst,{container:h,ignoreAccessibility:!0});if(p){PM(p);return}}(d=l.input)===null||d===void 0||d.blur()}},this._setHandlers(this._onDummyInputFocus),this._tabster=e,this._setFocused=r}}let evt=class extends XW{constructor(e,i,r,o,l){super(e,i,o),this._isFocused=!1,this._setFocused=g=>{var f;if(this._setFocusedTimer&&(this._tabster.getWindow().clearTimeout(this._setFocusedTimer),delete this._setFocusedTimer),this._isFocused===g)return;const y=this._element.get();y&&(g?(this._isFocused=!0,(f=this._dummyManager)===null||f===void 0||f.setTabbable(!1),y.dispatchEvent(new Lft({element:y}))):this._setFocusedTimer=this._tabster.getWindow().setTimeout(()=>{var T;delete this._setFocusedTimer,this._isFocused=!1,(T=this._dummyManager)===null||T===void 0||T.setTabbable(!0),y.dispatchEvent(new Oft({element:y}))},0))},this._onFocusIn=g=>{const f=this._tabster.getParent,y=this._element.get();let T=g.composedPath()[0];do{if(T===y){this._setFocused(!0);return}T=T&&f(T)}while(T)},this._onFocusOut=()=>{this._setFocused(!1)},this._onDispose=r;const d=e.getWindow;this.uid=ZW(d,i),this._sys=l,(e.controlTab||e.rootDummyInputs)&&this.addDummyInputs();const p=d().document;p.addEventListener(SA,this._onFocusIn),p.addEventListener(MH,this._onFocusOut),this._add()}addDummyInputs(){this._dummyManager||(this._dummyManager=new gke(this._tabster,this._element,this._setFocused,this._sys))}dispose(){var e;this._onDispose(this);const i=this._tabster.getWindow(),r=i.document;r.removeEventListener(SA,this._onFocusIn),r.removeEventListener(MH,this._onFocusOut),this._setFocusedTimer&&(i.clearTimeout(this._setFocusedTimer),delete this._setFocusedTimer),(e=this._dummyManager)===null||e===void 0||e.dispose(),this._remove()}moveOutWithDefaultAction(e,i){const r=this._dummyManager;if(r)r.moveOutWithDefaultAction(e,i);else{const o=this.getElement();o&&gke.moveWithPhantomDummy(this._tabster,o,!0,e,i)}}_add(){process.env.NODE_ENV==="development"&&pke(this._element,!1,this.uid)}_remove(){process.env.NODE_ENV==="development"&&pke(this._element,!0)}};class Nm{constructor(e,i){this._autoRootWaiting=!1,this._roots={},this._forceDummy=!1,this.rootById={},this._autoRootCreate=()=>{var r;const o=this._win().document,l=o.body;if(l){this._autoRootUnwait(o);const d=this._autoRoot;if(d)return Xft(l,{root:d}),Ywe(this._tabster,l),(r=KS(this._tabster,l))===null||r===void 0?void 0:r.root}else this._autoRootWaiting||(this._autoRootWaiting=!0,o.addEventListener("readystatechange",this._autoRootCreate))},this._onRootDispose=r=>{delete this._roots[r.id]},this._tabster=e,this._win=e.getWindow,this._autoRoot=i,e.queueInit(()=>{this._autoRoot&&this._autoRootCreate()})}_autoRootUnwait(e){e.removeEventListener("readystatechange",this._autoRootCreate),this._autoRootWaiting=!1}dispose(){const e=this._win();this._autoRootUnwait(e.document),delete this._autoRoot,Object.keys(this._roots).forEach(i=>{this._roots[i]&&(this._roots[i].dispose(),delete this._roots[i])}),this.rootById={}}createRoot(e,i,r){process.env.NODE_ENV;const o=new evt(this._tabster,e,this._onRootDispose,i,r);return this._roots[o.id]=o,this._forceDummy&&o.addDummyInputs(),o}addDummyInputs(){this._forceDummy=!0;const e=this._roots;for(const i of Object.keys(e))e[i].addDummyInputs()}static getRootByUId(e,i){const r=e().__tabsterInstance;return r&&r.root.rootById[i]}static getTabsterContext(e,i,r){r===void 0&&(r={});var o,l,d,h;if(!i.ownerDocument)return;const{checkRtl:p,referenceElement:g}=r,f=e.getParent;e.drainInitQueue();let y,T,C,E,I=!1,w,D,F,x,B=g||i;const L={};for(;B&&(!y||p);){const H=KS(e,B);if(p&&F===void 0){const ne=B.dir;ne&&(F=ne.toLowerCase()==="rtl")}if(!H){B=f(B);continue}const j=B.tagName;(H.uncontrolled||j==="IFRAME"||j==="WEBVIEW")&&e.focusable.isVisible(B)&&(x=B),!E&&(!((o=H.focusable)===null||o===void 0)&&o.excludeFromMover)&&!C&&(I=!0);const J=H.modalizer,Z=H.groupper,re=H.mover;!T&&J&&(T=J),!C&&Z&&(!T||J)&&(T?(!Z.isActive()&&Z.getProps().tabbability&&T.userId!==((l=e.modalizer)===null||l===void 0?void 0:l.activeId)&&(T=void 0,C=Z),D=Z):C=Z),!E&&re&&(!T||J)&&(!Z||B!==i)&&B.contains(i)&&(E=re,w=!!C&&C!==Z),H.root&&(y=H.root),!((d=H.focusable)===null||d===void 0)&&d.ignoreKeydown&&Object.assign(L,H.focusable.ignoreKeydown),B=f(B)}if(!y){const H=e.root;H._autoRoot&&!((h=i.ownerDocument)===null||h===void 0)&&h.body&&(y=H._autoRootCreate())}return C&&!E&&(w=!0),process.env.NODE_ENV==="development"&&!y&&(T||C||E)&&console.error("Tabster Root is required for Mover, Groupper and Modalizer to work."),y?{root:y,modalizer:T,groupper:C,mover:E,groupperBeforeMover:w,modalizerInGroupper:D,rtl:p?!!F:void 0,uncontrolled:x,excludedFromMover:I,ignoreKeydown:H=>!!L[H.key]}:void 0}static getRoot(e,i){var r;const o=e.getParent;for(let l=i;l;l=o(l)){const d=(r=KS(e,l))===null||r===void 0?void 0:r.root;if(d)return d}}onRoot(e,i){i?delete this.rootById[e.uid]:this.rootById[e.uid]=e}}/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */class mke{constructor(){this._callbacks=[]}dispose(){this._callbacks=[],delete this._val}subscribe(e){const i=this._callbacks;i.indexOf(e)<0&&i.push(e)}subscribeFirst(e){const i=this._callbacks,r=i.indexOf(e);r>=0&&i.splice(r,1),i.unshift(e)}unsubscribe(e){const i=this._callbacks.indexOf(e);i>=0&&this._callbacks.splice(i,1)}setVal(e,i){this._val!==e&&(this._val=e,this._callCallbacks(e,i))}getVal(){return this._val}trigger(e,i){this._callCallbacks(e,i)}_callCallbacks(e,i){this._callbacks.forEach(r=>r(e,i))}}/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */class tvt{constructor(e){this._tabster=e}dispose(){}getProps(e){const i=KS(this._tabster,e);return i&&i.focusable||{}}isFocusable(e,i,r,o){return uke(e,Kwe)&&(i||e.tabIndex!==-1)?(r||this.isVisible(e))&&(o||this.isAccessible(e)):!1}isVisible(e){if(!e.ownerDocument||e.nodeType!==Node.ELEMENT_NODE||Yft(e))return!1;const i=e.ownerDocument.body.getBoundingClientRect();return!(i.width===0&&i.height===0)}isAccessible(e){var i;for(let r=e;r;r=ma.getParentElement(r)){const o=KS(this._tabster,r);if(this._isHidden(r)||!((i=o?.focusable)===null||i===void 0?void 0:i.ignoreAriaDisabled)&&this._isDisabled(r))return!1}return!0}_isDisabled(e){return e.hasAttribute("disabled")}_isHidden(e){var i;const r=e.getAttribute("aria-hidden");return!!(r&&r.toLowerCase()==="true"&&!(!((i=this._tabster.modalizer)===null||i===void 0)&&i.isAugmented(e)))}findFirst(e,i){return this.findElement({...e},i)}findLast(e,i){return this.findElement({isBackward:!0,...e},i)}findNext(e,i){return this.findElement({...e},i)}findPrev(e,i){return this.findElement({...e,isBackward:!0},i)}findDefault(e,i){return this.findElement({...e,acceptCondition:r=>this.isFocusable(r,e.includeProgrammaticallyFocusable)&&!!this.getProps(r).isDefault},i)||null}findAll(e){return this._findElements(!0,e)||[]}findElement(e,i){const r=this._findElements(!1,e,i);return r&&r[0]}_findElements(e,i,r){var o,l,d;const{container:h,currentElement:p=null,includeProgrammaticallyFocusable:g,useActiveModalizer:f,ignoreAccessibility:y,modalizerId:T,isBackward:C,onElement:E}=i;r||(r={});const I=[];let{acceptCondition:w}=i;const D=!!w;if(!h)return null;w||(w=L=>this.isFocusable(L,g,!1,y));const F={container:h,modalizerUserId:T===void 0&&f?(o=this._tabster.modalizer)===null||o===void 0?void 0:o.activeId:T||((d=(l=Nm.getTabsterContext(this._tabster,h))===null||l===void 0?void 0:l.modalizer)===null||d===void 0?void 0:d.userId),from:p||h,isBackward:C,isFindAll:e,acceptCondition:w,hasCustomCondition:D,includeProgrammaticallyFocusable:g,ignoreAccessibility:y,cachedGrouppers:{},cachedRadioGroups:{}},x=lse(h.ownerDocument,h,L=>this._acceptElement(L,F));if(!x)return null;const B=L=>{var z,H;const j=(z=F.foundElement)!==null&&z!==void 0?z:F.foundBackward;return j&&I.push(j),e?j&&(F.found=!1,delete F.foundElement,delete F.foundBackward,delete F.fromCtx,F.from=j,E&&!E(j))?!1:!!(j||L):(j&&r&&(r.uncontrolled=(H=Nm.getTabsterContext(this._tabster,j))===null||H===void 0?void 0:H.uncontrolled),!!(L&&!j))};if(p||(r.outOfDOMOrder=!0),p&&ma.nodeContains(h,p))x.currentNode=p;else if(C){const L=hke(h);if(!L)return null;if(this._acceptElement(L,F)===NodeFilter.FILTER_ACCEPT&&!B(!0))return F.skippedFocusable&&(r.outOfDOMOrder=!0),I;x.currentNode=L}do C?x.previousNode():x.nextNode();while(B());return F.skippedFocusable&&(r.outOfDOMOrder=!0),I.length?I:null}_acceptElement(e,i){var r,o,l;if(i.found)return NodeFilter.FILTER_ACCEPT;const d=i.foundBackward;if(d&&(e===d||!ma.nodeContains(d,e)))return i.found=!0,i.foundElement=d,NodeFilter.FILTER_ACCEPT;const h=i.container;if(e===h)return NodeFilter.FILTER_SKIP;if(!ma.nodeContains(h,e)||LH(e)||ma.nodeContains(i.rejectElementsFrom,e))return NodeFilter.FILTER_REJECT;const p=i.currentCtx=Nm.getTabsterContext(this._tabster,e);if(!p)return NodeFilter.FILTER_SKIP;if(cke(e))return this.isFocusable(e,void 0,!0,!0)&&(i.skippedFocusable=!0),NodeFilter.FILTER_SKIP;if(!i.hasCustomCondition&&(e.tagName==="IFRAME"||e.tagName==="WEBVIEW"))return this.isVisible(e)&&((r=p.modalizer)===null||r===void 0?void 0:r.userId)===((o=this._tabster.modalizer)===null||o===void 0?void 0:o.activeId)?(i.found=!0,i.rejectElementsFrom=i.foundElement=e,NodeFilter.FILTER_ACCEPT):NodeFilter.FILTER_REJECT;if(!i.ignoreAccessibility&&!this.isAccessible(e))return this.isFocusable(e,!1,!0,!0)&&(i.skippedFocusable=!0),NodeFilter.FILTER_REJECT;let g,f=i.fromCtx;f||(f=i.fromCtx=Nm.getTabsterContext(this._tabster,i.from));const y=f?.mover;let T=p.groupper,C=p.mover;if(g=(l=this._tabster.modalizer)===null||l===void 0?void 0:l.acceptElement(e,i),g!==void 0&&(i.skippedFocusable=!0),g===void 0&&(T||C||y)){const E=T?.getElement(),I=y?.getElement();let w=C?.getElement();if(w&&ma.nodeContains(I,w)&&ma.nodeContains(h,I)&&(!E||!C||ma.nodeContains(I,E))&&(C=y,w=I),E){if(E===h||!ma.nodeContains(h,E))T=void 0;else if(!ma.nodeContains(E,e))return NodeFilter.FILTER_REJECT}if(w){if(!ma.nodeContains(h,w))C=void 0;else if(!ma.nodeContains(w,e))return NodeFilter.FILTER_REJECT}T&&C&&(w&&E&&!ma.nodeContains(E,w)?C=void 0:T=void 0),T&&(g=T.acceptElement(e,i)),C&&(g=C.acceptElement(e,i))}if(g===void 0&&(g=i.acceptCondition(e)?NodeFilter.FILTER_ACCEPT:NodeFilter.FILTER_SKIP,g===NodeFilter.FILTER_SKIP&&this.isFocusable(e,!1,!0,!0)&&(i.skippedFocusable=!0)),g===NodeFilter.FILTER_ACCEPT&&!i.found){if(!i.isFindAll&&use(e)&&!e.checked){const E=e.name;let I=i.cachedRadioGroups[E];if(I||(I=Qft(e),I&&(i.cachedRadioGroups[E]=I)),I?.checked&&I.checked!==e)return NodeFilter.FILTER_SKIP}i.isBackward?(i.foundBackward=e,g=NodeFilter.FILTER_SKIP):(i.found=!0,i.foundElement=e)}return g}}/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */const rg={Tab:"Tab",Enter:"Enter",Escape:"Escape",PageUp:"PageUp",PageDown:"PageDown",End:"End",Home:"Home",ArrowLeft:"ArrowLeft",ArrowUp:"ArrowUp",ArrowRight:"ArrowRight",ArrowDown:"ArrowDown"};/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */function ivt(t,e){var i;const r=t.getParent;let o=e;do{const l=(i=KS(t,o))===null||i===void 0?void 0:i.uncontrolled;if(l&&t.uncontrolled.isUncontrolledCompletely(o,!!l.completely))return o;o=r(o)}while(o)}const fke={[LM.Restorer]:0,[LM.Deloser]:1,[LM.EscapeGroupper]:2};class og extends mke{constructor(e,i){super(),this._init=()=>{const r=this._win(),o=r.document;o.addEventListener(SA,this._onFocusIn,!0),o.addEventListener(MH,this._onFocusOut,!0),r.addEventListener("keydown",this._onKeyDown,!0);const l=ma.getActiveElement(o);l&&l!==o.body&&this._setFocusedElement(l),this.subscribe(this._onChanged)},this._onFocusIn=r=>{const o=r.composedPath()[0];o&&this._setFocusedElement(o,r.detail.relatedTarget,r.detail.isFocusedProgrammatically)},this._onFocusOut=r=>{var o;this._setFocusedElement(void 0,(o=r.detail)===null||o===void 0?void 0:o.originalEvent.relatedTarget)},this._validateFocusedElement=r=>{},this._onKeyDown=r=>{if(r.key!==rg.Tab||r.ctrlKey)return;const o=this.getVal();if(!o||!o.ownerDocument||o.contentEditable==="true")return;const l=this._tabster,d=l.controlTab,h=Nm.getTabsterContext(l,o);if(!h||h.ignoreKeydown(r))return;const p=r.shiftKey,g=og.findNextTabbable(l,h,void 0,o,void 0,p,!0),f=h.root.getElement();if(!f)return;const y=g?.element,T=ivt(l,o);if(y){const C=g.uncontrolled;if(h.uncontrolled||ma.nodeContains(C,o)){if(!g.outOfDOMOrder&&C===h.uncontrolled||T&&!ma.nodeContains(T,y))return;DH.addPhantomDummyWithTarget(l,o,p,y);return}if(C&&l.focusable.isVisible(C)||y.tagName==="IFRAME"&&l.focusable.isVisible(y)){f.dispatchEvent(new BL({by:"root",owner:f,next:y,relatedEvent:r}))&&DH.moveWithPhantomDummy(l,C??y,!1,p,r);return}(d||g?.outOfDOMOrder)&&f.dispatchEvent(new BL({by:"root",owner:f,next:y,relatedEvent:r}))&&(r.preventDefault(),r.stopImmediatePropagation(),PM(y))}else!T&&f.dispatchEvent(new BL({by:"root",owner:f,next:null,relatedEvent:r}))&&h.root.moveOutWithDefaultAction(p,r)},this._onChanged=(r,o)=>{var l,d;if(r)r.dispatchEvent(new Pft(o));else{const h=(l=this._lastVal)===null||l===void 0?void 0:l.get();if(h){const p={...o},g=Nm.getTabsterContext(this._tabster,h),f=(d=g?.modalizer)===null||d===void 0?void 0:d.userId;f&&(p.modalizerId=f),h.dispatchEvent(new Dft(p))}}},this._tabster=e,this._win=i,e.queueInit(this._init)}dispose(){super.dispose();const e=this._win(),i=e.document;i.removeEventListener(SA,this._onFocusIn,!0),i.removeEventListener(MH,this._onFocusOut,!0),e.removeEventListener("keydown",this._onKeyDown,!0),this.unsubscribe(this._onChanged);const r=this._asyncFocus;r&&(e.clearTimeout(r.timeout),delete this._asyncFocus),delete og._lastResetElement,delete this._nextVal,delete this._lastVal}static forgetMemorized(e,i){var r,o;let l=og._lastResetElement,d=l&&l.get();d&&ma.nodeContains(i,d)&&delete og._lastResetElement,d=(o=(r=e._nextVal)===null||r===void 0?void 0:r.element)===null||o===void 0?void 0:o.get(),d&&ma.nodeContains(i,d)&&delete e._nextVal,l=e._lastVal,d=l&&l.get(),d&&ma.nodeContains(i,d)&&delete e._lastVal}getFocusedElement(){return this.getVal()}getLastFocusedElement(){var e;let i=(e=this._lastVal)===null||e===void 0?void 0:e.get();return(!i||i&&!cse(i.ownerDocument,i))&&(this._lastVal=i=void 0),i}focus(e,i,r,o){return this._tabster.focusable.isFocusable(e,i,!1,r)?(e.focus({preventScroll:o}),!0):!1}focusDefault(e){const i=this._tabster.focusable.findDefault({container:e});return i?(this._tabster.focusedElement.focus(i),!0):!1}getFirstOrLastTabbable(e,i){var r;const{container:o,ignoreAccessibility:l}=i;let d;if(o){const h=Nm.getTabsterContext(this._tabster,o);h&&(d=(r=og.findNextTabbable(this._tabster,h,o,void 0,void 0,!e,l))===null||r===void 0?void 0:r.element)}return d&&!ma.nodeContains(o,d)&&(d=void 0),d||void 0}_focusFirstOrLast(e,i){const r=this.getFirstOrLastTabbable(e,i);return r?(this.focus(r,!1,!0),!0):!1}focusFirst(e){return this._focusFirstOrLast(!0,e)}focusLast(e){return this._focusFirstOrLast(!1,e)}resetFocus(e){if(!this._tabster.focusable.isVisible(e))return!1;if(this._tabster.focusable.isFocusable(e,!0,!0,!0))this.focus(e);else{const i=e.getAttribute("tabindex"),r=e.getAttribute("aria-hidden");e.tabIndex=-1,e.setAttribute("aria-hidden","true"),og._lastResetElement=new TA(this._win,e),this.focus(e,!0,!0),this._setOrRemoveAttribute(e,"tabindex",i),this._setOrRemoveAttribute(e,"aria-hidden",r)}return!0}requestAsyncFocus(e,i,r){const o=this._tabster.getWindow(),l=this._asyncFocus;if(l){if(fke[e]>fke[l.source])return;o.clearTimeout(l.timeout)}this._asyncFocus={source:e,callback:i,timeout:o.setTimeout(()=>{this._asyncFocus=void 0,i()},r)}}cancelAsyncFocus(e){const i=this._asyncFocus;i?.source===e&&(this._tabster.getWindow().clearTimeout(i.timeout),this._asyncFocus=void 0)}_setOrRemoveAttribute(e,i,r){r===null?e.removeAttribute(i):e.setAttribute(i,r)}_setFocusedElement(e,i,r){var o,l;if(this._tabster._noop)return;const d={relatedTarget:i};if(e){const p=(o=og._lastResetElement)===null||o===void 0?void 0:o.get();if(og._lastResetElement=void 0,p===e||cke(e))return;d.isFocusedProgrammatically=r;const g=Nm.getTabsterContext(this._tabster,e),f=(l=g?.modalizer)===null||l===void 0?void 0:l.userId;f&&(d.modalizerId=f)}const h=this._nextVal={element:e?new TA(this._win,e):void 0,detail:d};e&&e!==this._val&&this._validateFocusedElement(e),this._nextVal===h&&this.setVal(e,d),this._nextVal=void 0}setVal(e,i){super.setVal(e,i),e&&(this._lastVal=new TA(this._win,e))}static findNextTabbable(e,i,r,o,l,d,h){const p=r||i.root.getElement();if(!p)return null;let g=null;const f=og._isTabbingTimer,y=e.getWindow();f&&y.clearTimeout(f),og.isTabbing=!0,og._isTabbingTimer=y.setTimeout(()=>{delete og._isTabbingTimer,og.isTabbing=!1},0);const T=i.modalizer,C=i.groupper,E=i.mover,I=w=>{if(g=w.findNextTabbable(o,l,d,h),o&&!g?.element){const D=w!==T&&ma.getParentElement(w.getElement());if(D){const F=Nm.getTabsterContext(e,o,{referenceElement:D});if(F){const x=w.getElement(),B=d?x:x&&hke(x)||x;B&&(g=og.findNextTabbable(e,F,r,B,D,d,h),g&&(g.outOfDOMOrder=!0))}}}};if(C&&E)I(i.groupperBeforeMover?C:E);else if(C)I(C);else if(E)I(E);else if(T)I(T);else{const w={container:p,currentElement:o,referenceElement:l,ignoreAccessibility:h,useActiveModalizer:!0},D={};g={element:e.focusable[d?"findPrev":"findNext"](w,D),outOfDOMOrder:D.outOfDOMOrder,uncontrolled:D.uncontrolled}}return g}}og.isTabbing=!1;/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */class nvt extends DH{constructor(e,i,r,o){super(r,e,dse.Groupper,o,!0),this._setHandlers((l,d,h)=>{var p,g;const f=e.get(),y=l.input;if(f&&y){const T=Nm.getTabsterContext(r,y);if(T){let C;C=(p=i.findNextTabbable(h||void 0,void 0,d,!0))===null||p===void 0?void 0:p.element,C||(C=(g=og.findNextTabbable(r,T,void 0,l.isOutside?y:Jft(f,!d),void 0,d,!0))===null||g===void 0?void 0:g.element),C&&PM(C)}}})}}class avt extends XW{constructor(e,i,r,o,l){super(e,i,o),this._shouldTabInside=!1,this.makeTabbable(!1),this._onDispose=r,e.controlTab||(this.dummyManager=new nvt(this._element,this,e,l))}dispose(){var e;this._onDispose(this);const i=this._element.get();(e=this.dummyManager)===null||e===void 0||e.dispose(),delete this.dummyManager,i&&process.env.NODE_ENV==="development"&&vke(this._element,!0),delete this._first}findNextTabbable(e,i,r,o){const l=this.getElement();if(!l)return null;const d=LH(e)===l;if(!this._shouldTabInside&&e&&ma.nodeContains(l,e)&&!d)return{element:void 0,outOfDOMOrder:!0};const h=this.getFirst(!0);if(!e||!ma.nodeContains(l,e)||d)return{element:h,outOfDOMOrder:!0};const p=this._tabster;let g=null,f=!1,y;if(this._shouldTabInside&&h){const T={container:l,currentElement:e,referenceElement:i,ignoreAccessibility:o,useActiveModalizer:!0},C={};g=p.focusable[r?"findPrev":"findNext"](T,C),f=!!C.outOfDOMOrder,!g&&this._props.tabbability===QW.LimitedTrapFocus&&(g=p.focusable[r?"findLast":"findFirst"]({container:l,ignoreAccessibility:o,useActiveModalizer:!0},C),f=!0),y=C.uncontrolled}return{element:g,uncontrolled:y,outOfDOMOrder:f}}makeTabbable(e){this._shouldTabInside=e||!this._props.tabbability,process.env.NODE_ENV==="development"&&vke(this._element,!this._shouldTabInside)}isActive(e){var i;const r=this.getElement()||null;let o=!0;for(let d=ma.getParentElement(r);d;d=ma.getParentElement(d)){const h=(i=KS(this._tabster,d))===null||i===void 0?void 0:i.groupper;h&&(h._shouldTabInside||(o=!1))}let l=o?this._props.tabbability?this._shouldTabInside:!1:void 0;if(l&&e){const d=this._tabster.focusedElement.getFocusedElement();d&&(l=d!==this.getFirst(!0))}return l}getFirst(e){var i;const r=this.getElement();let o;if(r){if(e&&this._tabster.focusable.isFocusable(r))return r;o=(i=this._first)===null||i===void 0?void 0:i.get(),o||(o=this._tabster.focusable.findFirst({container:r,useActiveModalizer:!0})||void 0,o&&this.setFirst(o))}return o}setFirst(e){e?this._first=new TA(this._tabster.getWindow,e):delete this._first}acceptElement(e,i){const r=i.cachedGrouppers,o=ma.getParentElement(this.getElement()),l=o&&Nm.getTabsterContext(this._tabster,o),d=l?.groupper,h=l?.groupperBeforeMover?d:void 0;let p;const g=T=>{let C=r[T.id],E;return C?E=C.isActive:(E=this.isActive(!0),C=r[T.id]={isActive:E}),E};if(h&&(p=h.getElement(),!g(h)&&p&&i.container!==p&&ma.nodeContains(i.container,p)))return i.skippedFocusable=!0,NodeFilter.FILTER_REJECT;const f=g(this),y=this.getElement();if(y&&f!==!0){if(y===e&&d&&(p||(p=d.getElement()),p&&!g(d)&&ma.nodeContains(i.container,p)&&p!==i.container)||y!==e&&ma.nodeContains(y,e))return i.skippedFocusable=!0,NodeFilter.FILTER_REJECT;const T=r[this.id];let C;if("first"in T?C=T.first:C=T.first=this.getFirst(!0),C&&i.acceptCondition(C))return i.rejectElementsFrom=y,i.skippedFocusable=!0,C!==i.from?(i.found=!0,i.foundElement=C,NodeFilter.FILTER_ACCEPT):NodeFilter.FILTER_REJECT}}}class rvt{constructor(e,i){this._current={},this._grouppers={},this._init=()=>{const r=this._win();this._tabster.focusedElement.subscribeFirst(this._onFocus);const o=r.document,l=ma.getActiveElement(o);l&&this._onFocus(l),o.addEventListener("mousedown",this._onMouseDown,!0),r.addEventListener("keydown",this._onKeyDown,!0),r.addEventListener(Xwe,this._onMoveFocus)},this._onGroupperDispose=r=>{delete this._grouppers[r.id]},this._onFocus=r=>{r&&this._updateCurrent(r)},this._onMouseDown=r=>{let o=r.target;for(;o&&!this._tabster.focusable.isFocusable(o);)o=this._tabster.getParent(o);o&&this._updateCurrent(o)},this._onKeyDown=r=>{if(r.key!==rg.Enter&&r.key!==rg.Escape||r.ctrlKey||r.altKey||r.shiftKey||r.metaKey)return;const o=this._tabster.focusedElement.getFocusedElement();o&&this.handleKeyPress(o,r)},this._onMoveFocus=r=>{var o;const l=r.composedPath()[0],d=(o=r.detail)===null||o===void 0?void 0:o.action;l&&d!==void 0&&!r.defaultPrevented&&(d===Jwe.Enter?this._enterGroupper(l):this._escapeGroupper(l),r.stopImmediatePropagation())},this._tabster=e,this._win=i,e.queueInit(this._init)}dispose(){const e=this._win();this._tabster.focusedElement.cancelAsyncFocus(LM.EscapeGroupper),this._current={},this._updateTimer&&(e.clearTimeout(this._updateTimer),delete this._updateTimer),this._tabster.focusedElement.unsubscribe(this._onFocus),e.document.removeEventListener("mousedown",this._onMouseDown,!0),e.removeEventListener("keydown",this._onKeyDown,!0),e.removeEventListener(Xwe,this._onMoveFocus),Object.keys(this._grouppers).forEach(i=>{this._grouppers[i]&&(this._grouppers[i].dispose(),delete this._grouppers[i])})}createGroupper(e,i,r){process.env.NODE_ENV;const o=this._tabster,l=new avt(o,e,this._onGroupperDispose,i,r);this._grouppers[l.id]=l;const d=o.focusedElement.getFocusedElement();return d&&ma.nodeContains(e,d)&&!this._updateTimer&&(this._updateTimer=this._win().setTimeout(()=>{delete this._updateTimer,d===o.focusedElement.getFocusedElement()&&this._updateCurrent(d)},0)),l}forgetCurrentGrouppers(){this._current={}}_updateCurrent(e){var i;this._updateTimer&&(this._win().clearTimeout(this._updateTimer),delete this._updateTimer);const r=this._tabster,o={};for(let l=r.getParent(e);l;l=r.getParent(l)){const d=(i=KS(r,l))===null||i===void 0?void 0:i.groupper;if(d){o[d.id]=!0,this._current[d.id]=d;const h=d.isActive()||e!==l&&(!d.getProps().delegated||d.getFirst(!1)!==e);d.makeTabbable(h)}}for(const l of Object.keys(this._current)){const d=this._current[l];d.id in o||(d.makeTabbable(!1),d.setFirst(void 0),delete this._current[l])}}_enterGroupper(e,i){const r=this._tabster,o=Nm.getTabsterContext(r,e),l=o?.groupper||o?.modalizerInGroupper,d=l?.getElement();if(l&&d&&(e===d||l.getProps().delegated&&e===l.getFirst(!1))){const h=r.focusable.findNext({container:d,currentElement:e,useActiveModalizer:!0});if(h&&(!i||i&&d.dispatchEvent(new BL({by:"groupper",owner:d,next:h,relatedEvent:i}))))return i&&(i.preventDefault(),i.stopImmediatePropagation()),h.focus(),h}return null}_escapeGroupper(e,i,r){const o=this._tabster,l=Nm.getTabsterContext(o,e);let d=l?.groupper||l?.modalizerInGroupper;const h=d?.getElement();if(d&&h&&ma.nodeContains(h,e)){let p;if(e!==h||r)p=d.getFirst(!0);else{const g=ma.getParentElement(h),f=g?Nm.getTabsterContext(o,g):void 0;d=f?.groupper,p=d?.getFirst(!0)}if(p&&(!i||i&&h.dispatchEvent(new BL({by:"groupper",owner:h,next:p,relatedEvent:i}))))return d&&d.makeTabbable(!1),p.focus(),p}return null}moveFocus(e,i){return i===Jwe.Enter?this._enterGroupper(e):this._escapeGroupper(e)}handleKeyPress(e,i,r){const o=this._tabster,l=Nm.getTabsterContext(o,e);if(l&&(l?.groupper||l?.modalizerInGroupper)){if(o.focusedElement.cancelAsyncFocus(LM.EscapeGroupper),l.ignoreKeydown(i))return;if(i.key===rg.Enter)this._enterGroupper(e,i);else if(i.key===rg.Escape){const d=o.focusedElement.getFocusedElement();o.focusedElement.requestAsyncFocus(LM.EscapeGroupper,()=>{d!==o.focusedElement.getFocusedElement()&&(r&&!d||!r)||this._escapeGroupper(e,i,r)},0)}}}}function vke(t,e){if(process.env.NODE_ENV==="development"){const i=t.get();i&&(e?i.style.removeProperty("--tabster-groupper"):i.style.setProperty("--tabster-groupper","unlimited"))}}/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */class ovt extends mke{constructor(e){super(),this._onChange=i=>{this.setVal(i,void 0)},this._keyborg=ise(e()),this._keyborg.subscribe(this._onChange)}dispose(){super.dispose(),this._keyborg&&(this._keyborg.unsubscribe(this._onChange),nse(this._keyborg),delete this._keyborg)}setNavigatingWithKeyboard(e){var i;(i=this._keyborg)===null||i===void 0||i.setVal(e)}isNavigatingWithKeyboard(){var e;return!!(!((e=this._keyborg)===null||e===void 0)&&e.isNavigatingWithKeyboard())}}/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */const svt=["input","textarea","*[contenteditable]"].join(", ");class lvt extends DH{constructor(e,i,r,o){super(i,e,dse.Mover,o),this._onFocusDummyInput=l=>{var d,h;const p=this._element.get(),g=l.input;if(p&&g){const f=Nm.getTabsterContext(this._tabster,p);let y;f&&(y=(d=og.findNextTabbable(this._tabster,f,void 0,g,void 0,!l.isFirst,!0))===null||d===void 0?void 0:d.element);const T=(h=this._getMemorized())===null||h===void 0?void 0:h.get();T&&this._tabster.focusable.isFocusable(T)&&(y=T),y&&PM(y)}},this._tabster=i,this._getMemorized=r,this._setHandlers(this._onFocusDummyInput)}}const pse=1,yke=2,Ske=3;class cvt extends XW{constructor(e,i,r,o,l){var d;super(e,i,o),this._visible={},this._onIntersection=p=>{for(const g of p){const f=g.target,y=ZW(this._win,f);let T,C=this._fullyVisible;if(g.intersectionRatio>=.25?(T=g.intersectionRatio>=.75?xL.Visible:xL.PartiallyVisible,T===xL.Visible&&(C=y)):T=xL.Invisible,this._visible[y]!==T){T===void 0?(delete this._visible[y],C===y&&delete this._fullyVisible):(this._visible[y]=T,this._fullyVisible=C);const E=this.getState(f);E&&f.dispatchEvent(new eke(E))}}},this._win=e.getWindow,this.visibilityTolerance=(d=o.visibilityTolerance)!==null&&d!==void 0?d:.8,(this._props.trackState||this._props.visibilityAware)&&(this._intersectionObserver=new IntersectionObserver(this._onIntersection,{threshold:[0,.25,.5,.75,1]}),this._observeState()),this._onDispose=r;const h=()=>o.memorizeCurrent?this._current:void 0;e.controlTab||(this.dummyManager=new lvt(this._element,e,h,l))}dispose(){var e;this._onDispose(this),this._intersectionObserver&&(this._intersectionObserver.disconnect(),delete this._intersectionObserver),delete this._current,delete this._fullyVisible,delete this._allElements,delete this._updateQueue,this._unobserve&&(this._unobserve(),delete this._unobserve);const i=this._win();this._setCurrentTimer&&(i.clearTimeout(this._setCurrentTimer),delete this._setCurrentTimer),this._updateTimer&&(i.clearTimeout(this._updateTimer),delete this._updateTimer),(e=this.dummyManager)===null||e===void 0||e.dispose(),delete this.dummyManager}setCurrent(e){e?this._current=new TA(this._win,e):this._current=void 0,(this._props.trackState||this._props.visibilityAware)&&!this._setCurrentTimer&&(this._setCurrentTimer=this._win().setTimeout(()=>{var i;delete this._setCurrentTimer;const r=[];this._current!==this._prevCurrent&&(r.push(this._current),r.push(this._prevCurrent),this._prevCurrent=this._current);for(const o of r){const l=o?.get();if(l&&((i=this._allElements)===null||i===void 0?void 0:i.get(l))===this){const d=this._props;if(l&&(d.visibilityAware!==void 0||d.trackState)){const h=this.getState(l);h&&l.dispatchEvent(new eke(h))}}}}))}getCurrent(){var e;return((e=this._current)===null||e===void 0?void 0:e.get())||null}findNextTabbable(e,i,r,o){const l=this.getElement(),d=l&&LH(e)===l;if(!l)return null;let h=null,p=!1,g;if(this._props.tabbable||d||e&&!ma.nodeContains(l,e)){const f={currentElement:e,referenceElement:i,container:l,ignoreAccessibility:o,useActiveModalizer:!0},y={};h=this._tabster.focusable[r?"findPrev":"findNext"](f,y),p=!!y.outOfDOMOrder,g=y.uncontrolled}return{element:h,uncontrolled:g,outOfDOMOrder:p}}acceptElement(e,i){var r,o;if(!og.isTabbing)return!((r=i.currentCtx)===null||r===void 0)&&r.excludedFromMover?NodeFilter.FILTER_REJECT:void 0;const{memorizeCurrent:l,visibilityAware:d,hasDefault:h=!0}=this._props,p=this.getElement();if(p&&(l||d||h)&&(!ma.nodeContains(p,i.from)||LH(i.from)===p)){let g;if(l){const f=(o=this._current)===null||o===void 0?void 0:o.get();f&&i.acceptCondition(f)&&(g=f)}if(!g&&h&&(g=this._tabster.focusable.findDefault({container:p,useActiveModalizer:!0})),!g&&d&&(g=this._tabster.focusable.findElement({container:p,useActiveModalizer:!0,isBackward:i.isBackward,acceptCondition:f=>{var y;const T=ZW(this._win,f),C=this._visible[T];return p!==f&&!!(!((y=this._allElements)===null||y===void 0)&&y.get(f))&&i.acceptCondition(f)&&(C===xL.Visible||C===xL.PartiallyVisible&&(d===xL.PartiallyVisible||!this._fullyVisible))}})),g)return i.found=!0,i.foundElement=g,i.rejectElementsFrom=p,i.skippedFocusable=!0,NodeFilter.FILTER_ACCEPT}}_observeState(){const e=this.getElement();if(this._unobserve||!e||typeof MutationObserver>"u")return;const i=this._win(),r=this._allElements=new WeakMap,o=this._tabster.focusable;let l=this._updateQueue=[];const d=ma.createMutationObserver(C=>{for(const E of C){const I=E.target,w=E.removedNodes,D=E.addedNodes;if(E.type==="attributes")E.attributeName==="tabindex"&&l.push({element:I,type:yke});else{for(let F=0;F<w.length;F++)l.push({element:w[F],type:Ske});for(let F=0;F<D.length;F++)l.push({element:D[F],type:pse})}}y()}),h=(C,E)=>{var I,w;const D=r.get(C);D&&E&&((I=this._intersectionObserver)===null||I===void 0||I.unobserve(C),r.delete(C)),!D&&!E&&(r.set(C,this),(w=this._intersectionObserver)===null||w===void 0||w.observe(C))},p=C=>{const E=o.isFocusable(C);r.get(C)?E||h(C,!0):E&&h(C)},g=C=>{const{mover:E}=T(C);if(E&&E!==this)if(E.getElement()===C&&o.isFocusable(C))h(C);else return;const I=lse(i.document,C,w=>{const{mover:D,groupper:F}=T(w);if(D&&D!==this)return NodeFilter.FILTER_REJECT;const x=F?.getFirst(!0);return F&&F.getElement()!==w&&x&&x!==w?NodeFilter.FILTER_REJECT:(o.isFocusable(w)&&h(w),NodeFilter.FILTER_SKIP)});if(I)for(I.currentNode=C;I.nextNode(););},f=C=>{r.get(C)&&h(C,!0);for(let I=ma.getFirstElementChild(C);I;I=ma.getNextElementSibling(I))f(I)},y=()=>{!this._updateTimer&&l.length&&(this._updateTimer=i.setTimeout(()=>{delete this._updateTimer;for(const{element:C,type:E}of l)switch(E){case yke:p(C);break;case pse:g(C);break;case Ske:f(C);break}l=this._updateQueue=[]},0))},T=C=>{const E={};for(let I=C;I;I=ma.getParentElement(I)){const w=KS(this._tabster,I);if(w&&(w.groupper&&!E.groupper&&(E.groupper=w.groupper),w.mover)){E.mover=w.mover;break}}return E};l.push({element:e,type:pse}),y(),d.observe(e,{childList:!0,subtree:!0,attributes:!0,attributeFilter:["tabindex"]}),this._unobserve=()=>{d.disconnect()}}getState(e){const i=ZW(this._win,e);if(i in this._visible){const r=this._visible[i]||xL.Invisible;return{isCurrent:this._current?this._current.get()===e:void 0,visibility:r}}}}function dvt(t,e,i,r,o,l,d,h){const p=i<o?o-i:d<t?t-d:0,g=r<l?l-r:h<e?e-h:0;return p===0?g:g===0?p:Math.sqrt(p*p+g*g)}class uvt{constructor(e,i){this._init=()=>{const r=this._win();r.addEventListener("keydown",this._onKeyDown,!0),r.addEventListener(Qwe,this._onMoveFocus),r.addEventListener(Zwe,this._onMemorizedElement),this._tabster.focusedElement.subscribe(this._onFocus)},this._onMoverDispose=r=>{delete this._movers[r.id]},this._onFocus=r=>{var o;let l=r,d=r;for(let h=ma.getParentElement(r);h;h=ma.getParentElement(h)){const p=(o=KS(this._tabster,h))===null||o===void 0?void 0:o.mover;p&&(p.setCurrent(d),l=void 0),!l&&this._tabster.focusable.isFocusable(h)&&(l=d=h)}},this._onKeyDown=async r=>{var o;if(this._ignoredInputTimer&&(this._win().clearTimeout(this._ignoredInputTimer),delete this._ignoredInputTimer),(o=this._ignoredInputResolve)===null||o===void 0||o.call(this,!1),r.ctrlKey||r.altKey||r.shiftKey||r.metaKey)return;const l=r.key;let d;if(l===rg.ArrowDown?d=ag.ArrowDown:l===rg.ArrowRight?d=ag.ArrowRight:l===rg.ArrowUp?d=ag.ArrowUp:l===rg.ArrowLeft?d=ag.ArrowLeft:l===rg.PageDown?d=ag.PageDown:l===rg.PageUp?d=ag.PageUp:l===rg.Home?d=ag.Home:l===rg.End&&(d=ag.End),!d)return;const h=this._tabster.focusedElement.getFocusedElement();!h||await this._isIgnoredInput(h,l)||this._moveFocus(h,d,r)},this._onMoveFocus=r=>{var o;const l=r.composedPath()[0],d=(o=r.detail)===null||o===void 0?void 0:o.key;l&&d!==void 0&&!r.defaultPrevented&&(this._moveFocus(l,d),r.stopImmediatePropagation())},this._onMemorizedElement=r=>{var o;const l=r.composedPath()[0];let d=(o=r.detail)===null||o===void 0?void 0:o.memorizedElement;if(l){const h=Nm.getTabsterContext(this._tabster,l),p=h?.mover;p&&(d&&!ma.nodeContains(p.getElement(),d)&&(d=void 0),p.setCurrent(d),r.stopImmediatePropagation())}},this._tabster=e,this._win=i,this._movers={},e.queueInit(this._init)}dispose(){var e;const i=this._win();this._tabster.focusedElement.unsubscribe(this._onFocus),(e=this._ignoredInputResolve)===null||e===void 0||e.call(this,!1),this._ignoredInputTimer&&(i.clearTimeout(this._ignoredInputTimer),delete this._ignoredInputTimer),i.removeEventListener("keydown",this._onKeyDown,!0),i.removeEventListener(Qwe,this._onMoveFocus),i.removeEventListener(Zwe,this._onMemorizedElement),Object.keys(this._movers).forEach(r=>{this._movers[r]&&(this._movers[r].dispose(),delete this._movers[r])})}createMover(e,i,r){process.env.NODE_ENV;const o=new cvt(this._tabster,e,this._onMoverDispose,i,r);return this._movers[o.id]=o,o}moveFocus(e,i){return this._moveFocus(e,i)}_moveFocus(e,i,r){var o,l;const d=this._tabster,h=Nm.getTabsterContext(d,e,{checkRtl:!0});if(!h||!h.mover||h.excludedFromMover||r&&h.ignoreKeydown(r))return null;const p=h.mover,g=p.getElement();if(h.groupperBeforeMover){const j=h.groupper;if(j&&!j.isActive(!0)){for(let J=ma.getParentElement(j.getElement());J&&J!==g;J=ma.getParentElement(J))if(!((l=(o=KS(d,J))===null||o===void 0?void 0:o.groupper)===null||l===void 0)&&l.isActive(!0))return null}else return null}if(!g)return null;const f=d.focusable,y=p.getProps(),T=y.direction||bA.Both,C=T===bA.Both,E=C||T===bA.Vertical,I=C||T===bA.Horizontal,w=T===bA.GridLinear,D=w||T===bA.Grid,F=y.cyclic;let x,B,L,z=0,H=0;if(D&&(L=e.getBoundingClientRect(),z=Math.ceil(L.left),H=Math.floor(L.right)),h.rtl&&(i===ag.ArrowRight?i=ag.ArrowLeft:i===ag.ArrowLeft&&(i=ag.ArrowRight)),i===ag.ArrowDown&&E||i===ag.ArrowRight&&(I||D))if(x=f.findNext({currentElement:e,container:g,useActiveModalizer:!0}),x&&D){const j=Math.ceil(x.getBoundingClientRect().left);!w&&H>j&&(x=void 0)}else!x&&F&&(x=f.findFirst({container:g,useActiveModalizer:!0}));else if(i===ag.ArrowUp&&E||i===ag.ArrowLeft&&(I||D))if(x=f.findPrev({currentElement:e,container:g,useActiveModalizer:!0}),x&&D){const j=Math.floor(x.getBoundingClientRect().right);!w&&j>z&&(x=void 0)}else!x&&F&&(x=f.findLast({container:g,useActiveModalizer:!0}));else if(i===ag.Home)D?f.findElement({container:g,currentElement:e,useActiveModalizer:!0,isBackward:!0,acceptCondition:j=>{var J;if(!f.isFocusable(j))return!1;const Z=Math.ceil((J=j.getBoundingClientRect().left)!==null&&J!==void 0?J:0);return j!==e&&z<=Z?!0:(x=j,!1)}}):x=f.findFirst({container:g,useActiveModalizer:!0});else if(i===ag.End)D?f.findElement({container:g,currentElement:e,useActiveModalizer:!0,acceptCondition:j=>{var J;if(!f.isFocusable(j))return!1;const Z=Math.ceil((J=j.getBoundingClientRect().left)!==null&&J!==void 0?J:0);return j!==e&&z>=Z?!0:(x=j,!1)}}):x=f.findLast({container:g,useActiveModalizer:!0});else if(i===ag.PageUp){if(f.findElement({currentElement:e,container:g,useActiveModalizer:!0,isBackward:!0,acceptCondition:j=>f.isFocusable(j)?ske(this._win,j,p.visibilityTolerance)?(x=j,!1):!0:!1}),D&&x){const j=Math.ceil(x.getBoundingClientRect().left);f.findElement({currentElement:x,container:g,useActiveModalizer:!0,acceptCondition:J=>{if(!f.isFocusable(J))return!1;const Z=Math.ceil(J.getBoundingClientRect().left);return z<Z||j>=Z?!0:(x=J,!1)}})}B=!1}else if(i===ag.PageDown){if(f.findElement({currentElement:e,container:g,useActiveModalizer:!0,acceptCondition:j=>f.isFocusable(j)?ske(this._win,j,p.visibilityTolerance)?(x=j,!1):!0:!1}),D&&x){const j=Math.ceil(x.getBoundingClientRect().left);f.findElement({currentElement:x,container:g,useActiveModalizer:!0,isBackward:!0,acceptCondition:J=>{if(!f.isFocusable(J))return!1;const Z=Math.ceil(J.getBoundingClientRect().left);return z>Z||j<=Z?!0:(x=J,!1)}})}B=!0}else if(D){const j=i===ag.ArrowUp,J=z,Z=Math.ceil(L.top),re=H,ne=Math.floor(L.bottom);let le,he,Me=0;f.findAll({container:g,currentElement:e,isBackward:j,onElement:Le=>{const pe=Le.getBoundingClientRect(),te=Math.ceil(pe.left),Se=Math.ceil(pe.top),ce=Math.floor(pe.right),X=Math.floor(pe.bottom);if(j&&Z<X||!j&&ne>Se)return!0;const ve=Math.ceil(Math.min(re,ce))-Math.floor(Math.max(J,te)),Te=Math.ceil(Math.min(re-J,ce-te));if(ve>0&&Te>=ve){const Be=ve/Te;Be>Me&&(le=Le,Me=Be)}else if(Me===0){const Be=dvt(J,Z,re,ne,te,Se,ce,X);(he===void 0||Be<he)&&(he=Be,le=Le)}else if(Me>0)return!1;return!0}}),x=le}return x&&(!r||r&&g.dispatchEvent(new BL({by:"mover",owner:g,next:x,relatedEvent:r})))?(B!==void 0&&Vft(this._win,x,B),r&&(r.preventDefault(),r.stopImmediatePropagation()),PM(x),x):null}async _isIgnoredInput(e,i){if(e.getAttribute("aria-expanded")==="true"&&e.hasAttribute("aria-activedescendant"))return!0;if(uke(e,svt)){let r=0,o=0,l=0,d;if(e.tagName==="INPUT"||e.tagName==="TEXTAREA"){const h=e.type;if(l=(e.value||"").length,h==="email"||h==="number"){if(l){const g=ma.getSelection(e);if(g){const f=g.toString().length,y=i===rg.ArrowLeft||i===rg.ArrowUp;if(g.modify("extend",y?"backward":"forward","character"),f!==g.toString().length)return g.modify("extend",y?"forward":"backward","character"),!0;l=0}}}else{const g=e.selectionStart;if(g===null)return h==="hidden";r=g||0,o=e.selectionEnd||0}}else e.contentEditable==="true"&&(d=new(jft(this._win))(h=>{this._ignoredInputResolve=C=>{delete this._ignoredInputResolve,h(C)};const p=this._win();this._ignoredInputTimer&&p.clearTimeout(this._ignoredInputTimer);const{anchorNode:g,focusNode:f,anchorOffset:y,focusOffset:T}=ma.getSelection(e)||{};this._ignoredInputTimer=p.setTimeout(()=>{var C,E,I;delete this._ignoredInputTimer;const{anchorNode:w,focusNode:D,anchorOffset:F,focusOffset:x}=ma.getSelection(e)||{};if(w!==g||D!==f||F!==y||x!==T){(C=this._ignoredInputResolve)===null||C===void 0||C.call(this,!1);return}if(r=F||0,o=x||0,l=((E=e.textContent)===null||E===void 0?void 0:E.length)||0,w&&D&&ma.nodeContains(e,w)&&ma.nodeContains(e,D)&&w!==e){let B=!1;const L=z=>{if(z===w)B=!0;else if(z===D)return!0;const H=z.textContent;if(H&&!ma.getFirstChild(z)){const J=H.length;B?D!==w&&(o+=J):(r+=J,o+=J)}let j=!1;for(let J=ma.getFirstChild(z);J&&!j;J=J.nextSibling)j=L(J);return j};L(e)}(I=this._ignoredInputResolve)===null||I===void 0||I.call(this,!0)},0)}));if(d&&!await d||r!==o||r>0&&(i===rg.ArrowLeft||i===rg.ArrowUp||i===rg.Home)||r<l&&(i===rg.ArrowRight||i===rg.ArrowDown||i===rg.End))return!0}return!1}}/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */function hvt(t,e,i,r){if(typeof MutationObserver>"u")return()=>{};const o=e.getWindow;let l;const d=f=>{var y,T,C,E,I;const w=new Set;for(const D of f){const F=D.target,x=D.removedNodes,B=D.addedNodes;if(D.type==="attributes")D.attributeName===DM&&(w.has(F)||i(e,F));else{for(let L=0;L<x.length;L++){const z=x[L];w.add(z),h(z,!0),(T=(y=e._dummyObserver).domChanged)===null||T===void 0||T.call(y,F)}for(let L=0;L<B.length;L++)h(B[L]),(E=(C=e._dummyObserver).domChanged)===null||E===void 0||E.call(C,F)}}w.clear(),(I=e.modalizer)===null||I===void 0||I.hiddenUpdate()};function h(f,y){l||(l=OM(o).elementByUId),p(f,y);const T=lse(t,f,C=>p(C,y));if(T)for(;T.nextNode(););}function p(f,y){var T;if(!f.getAttribute)return NodeFilter.FILTER_SKIP;const C=f.__tabsterElementUID;return C&&l&&(y?delete l[C]:(T=l[C])!==null&&T!==void 0||(l[C]=new TA(o,f))),(KS(e,f)||f.hasAttribute(DM))&&i(e,f,y),NodeFilter.FILTER_SKIP}const g=ma.createMutationObserver(d);return r&&h(o().document.body),g.observe(t,{childList:!0,subtree:!0,attributes:!0,attributeFilter:[DM]}),()=>{g.disconnect()}}/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */class pvt{constructor(e){this._isUncontrolledCompletely=e}isUncontrolledCompletely(e,i){var r;const o=(r=this._isUncontrolledCompletely)===null||r===void 0?void 0:r.call(this,e,i);return o===void 0?i:o}}/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */class gvt extends XW{constructor(e,i,r){var o;if(super(e,i,r),this._hasFocus=!1,this._onFocusOut=l=>{var d;const h=(d=this._element)===null||d===void 0?void 0:d.get();h&&l.relatedTarget===null&&h.dispatchEvent(new tke),h&&!ma.nodeContains(h,l.relatedTarget)&&(this._hasFocus=!1)},this._onFocusIn=()=>{this._hasFocus=!0},this._props.type===PH.Source){const l=(o=this._element)===null||o===void 0?void 0:o.get();l?.addEventListener("focusout",this._onFocusOut),l?.addEventListener("focusin",this._onFocusIn),this._hasFocus=ma.nodeContains(l,l&&ma.getActiveElement(l.ownerDocument))}}dispose(){var e;if(this._props.type===PH.Source){const i=(e=this._element)===null||e===void 0?void 0:e.get();i?.removeEventListener("focusout",this._onFocusOut),i?.removeEventListener("focusin",this._onFocusIn),this._hasFocus&&this._tabster.getWindow().document.body.dispatchEvent(new tke)}}}class tK{constructor(e){this._stack=[],this._getWindow=e}push(e){var i;((i=this._stack[this._stack.length-1])===null||i===void 0?void 0:i.get())!==e&&(this._stack.length>tK.DEPTH&&this._stack.shift(),this._stack.push(new TA(this._getWindow,e)))}pop(e){e===void 0&&(e=()=>!0);var i;const r=this._getWindow().document;for(let o=this._stack.length-1;o>=0;o--){const l=(i=this._stack.pop())===null||i===void 0?void 0:i.get();if(l&&ma.nodeContains(r.body,ma.getParentElement(l))&&e(l))return l}}}tK.DEPTH=10;class mvt{constructor(e){this._onRestoreFocus=i=>{var r,o;this._focusedElementState.cancelAsyncFocus(LM.Restorer);const l=i.composedPath()[0];if(l){const d=(o=(r=KS(this._tabster,l))===null||r===void 0?void 0:r.restorer)===null||o===void 0?void 0:o.getProps().id;this._focusedElementState.requestAsyncFocus(LM.Restorer,()=>this._restoreFocus(l,d),0)}},this._onFocusIn=i=>{var r;if(!i)return;const o=KS(this._tabster,i);((r=o?.restorer)===null||r===void 0?void 0:r.getProps().type)===PH.Target&&this._history.push(i)},this._restoreFocus=(i,r)=>{var o;const l=this._getWindow().document;if(ma.getActiveElement(l)!==l.body||!this._keyboardNavState.isNavigatingWithKeyboard()&&ma.nodeContains(l.body,i))return;const d=h=>{var p,g;const f=(g=(p=KS(this._tabster,h))===null||p===void 0?void 0:p.restorer)===null||g===void 0?void 0:g.getProps();return f?f.id:null};(o=this._history.pop(h=>r===d(h)))===null||o===void 0||o.focus()},this._tabster=e,this._getWindow=e.getWindow,this._getWindow().addEventListener(rse,this._onRestoreFocus),this._history=new tK(this._getWindow),this._keyboardNavState=e.keyboardNavigation,this._focusedElementState=e.focusedElement,this._focusedElementState.subscribe(this._onFocusIn)}dispose(){const e=this._getWindow();this._focusedElementState.unsubscribe(this._onFocusIn),this._focusedElementState.cancelAsyncFocus(LM.Restorer),e.removeEventListener(rse,this._onRestoreFocus)}createRestorer(e,i){const r=new gvt(this._tabster,e,i);return i.type===PH.Target&&ma.getActiveElement(e.ownerDocument)===e&&this._history.push(e),r}}/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */class fvt{constructor(e){this.keyboardNavigation=e.keyboardNavigation,this.focusedElement=e.focusedElement,this.focusable=e.focusable,this.root=e.root,this.uncontrolled=e.uncontrolled,this.core=e}}class vvt{constructor(e,i){var r,o;this._forgetMemorizedElements=[],this._wrappers=new Set,this._initQueue=[],this._version="8.5.4",this._noop=!1,this.getWindow=()=>{if(!this._win)throw new Error("Using disposed Tabster.");return this._win},this._storage=Fft(e),this._win=e;const l=this.getWindow;i?.DOMAPI&&Nft({...i.DOMAPI}),this.keyboardNavigation=new ovt(l),this.focusedElement=new og(this,l),this.focusable=new tvt(this),this.root=new Nm(this,i?.autoRoot),this.uncontrolled=new pvt(i?.checkUncontrolledCompletely||i?.checkUncontrolledTrappingFocus),this.controlTab=(r=i?.controlTab)!==null&&r!==void 0?r:!0,this.rootDummyInputs=!!i?.rootDummyInputs,this._dummyObserver=new Wft(l),this.getParent=(o=i?.getParent)!==null&&o!==void 0?o:ma.getParentNode,this.internal={stopObserver:()=>{this._unobserve&&(this._unobserve(),delete this._unobserve)},resumeObserver:d=>{if(!this._unobserve){const h=l().document;this._unobserve=hvt(h,this,Ywe,d)}}},rke(l),this.queueInit(()=>{this.internal.resumeObserver(!0)})}_mergeProps(e){var i;e&&(this.getParent=(i=e.getParent)!==null&&i!==void 0?i:this.getParent)}createTabster(e,i){const r=new fvt(this);return e||this._wrappers.add(r),this._mergeProps(i),r}disposeTabster(e,i){i?this._wrappers.clear():this._wrappers.delete(e),this._wrappers.size===0&&this.dispose()}dispose(){var e,i,r,o,l,d,h,p;this.internal.stopObserver();const g=this._win;g?.clearTimeout(this._initTimer),delete this._initTimer,this._initQueue=[],this._forgetMemorizedElements=[],g&&this._forgetMemorizedTimer&&(g.clearTimeout(this._forgetMemorizedTimer),delete this._forgetMemorizedTimer),(e=this.outline)===null||e===void 0||e.dispose(),(i=this.crossOrigin)===null||i===void 0||i.dispose(),(r=this.deloser)===null||r===void 0||r.dispose(),(o=this.groupper)===null||o===void 0||o.dispose(),(l=this.mover)===null||l===void 0||l.dispose(),(d=this.modalizer)===null||d===void 0||d.dispose(),(h=this.observedElement)===null||h===void 0||h.dispose(),(p=this.restorer)===null||p===void 0||p.dispose(),this.keyboardNavigation.dispose(),this.focusable.dispose(),this.focusedElement.dispose(),this.root.dispose(),this._dummyObserver.dispose(),zft(this.getWindow),dke(this.getWindow),this._storage=new WeakMap,this._wrappers.clear(),g&&(Bft(g),delete g.__tabsterInstance,delete this._win)}storageEntry(e,i){const r=this._storage;let o=r.get(e);return o?i===!1&&Object.keys(o).length===0&&r.delete(e):i===!0&&(o={},r.set(e,o)),o}forceCleanup(){this._win&&(this._forgetMemorizedElements.push(this._win.document.body),!this._forgetMemorizedTimer&&(this._forgetMemorizedTimer=this._win.setTimeout(()=>{delete this._forgetMemorizedTimer;for(let e=this._forgetMemorizedElements.shift();e;e=this._forgetMemorizedElements.shift())dke(this.getWindow,e),og.forgetMemorized(this.focusedElement,e)},0),ake(this.getWindow,!0)))}queueInit(e){var i;this._win&&(this._initQueue.push(e),this._initTimer||(this._initTimer=(i=this._win)===null||i===void 0?void 0:i.setTimeout(()=>{delete this._initTimer,this.drainInitQueue()},0)))}drainInitQueue(){if(!this._win)return;const e=this._initQueue;this._initQueue=[],e.forEach(i=>i())}}function yvt(t,e){let i=_vt(t);return i?i.createTabster(!1,e):(i=new vvt(t,e),t.__tabsterInstance=i,i.createTabster())}function Svt(t){const e=t.core;return e.groupper||(e.groupper=new rvt(e,e.getWindow)),e.groupper}function bvt(t){const e=t.core;return e.mover||(e.mover=new uvt(e,e.getWindow)),e.mover}function Tvt(t){const e=t.core;return e.restorer||(e.restorer=new mvt(e)),e.restorer}function Cvt(t,e){t.core.disposeTabster(t,e)}function _vt(t){return t.__tabsterInstance}const Evt=t=>t;function Avt(t){const e=t?.defaultView||void 0,i=e?.__tabsterShadowDOMAPI;if(e)return yvt(e,{autoRoot:{},controlTab:!1,getParent:Fwe,checkUncontrolledTrappingFocus:r=>{var o;return!!(!((o=r.firstElementChild)===null||o===void 0)&&o.hasAttribute("data-is-focus-trap-zone-bumper"))},DOMAPI:i})}function OH(t=Evt){const{targetDocument:e}=Ov(),i=$.useRef(null);if(fA(()=>{const r=Avt(e);if(r)return i.current=t(r),()=>{Cvt(r),i.current=null}},[e,t]),process.env.NODE_ENV!=="production"){const r=tft(t);if(r!==null&&r!==t)throw new Error(["@fluentui/react-tabster: ","The factory function passed to useTabster has changed. This should not ever happen."].join(`
`))}return i}const gse=t=>{OH();const e=hse(t,!0);return $.useMemo(()=>({[DM]:e}),[e])},NH=(t={})=>{const{circular:e,axis:i,memorizeCurrent:r=!0,tabbable:o,ignoreDefaultKeydown:l,unstable_hasDefault:d}=t;return OH(bvt),gse({mover:{cyclic:!!e,direction:Ivt(i??"vertical"),memorizeCurrent:r,tabbable:o,hasDefault:d},...l&&{focusable:{ignoreKeydown:l}}})};function Ivt(t){switch(t){case"horizontal":return bA.Horizontal;case"grid":return bA.Grid;case"grid-linear":return bA.GridLinear;case"both":return bA.Both;case"vertical":default:return bA.Vertical}}const mse=t=>(OH(Svt),gse({groupper:{tabbability:wvt(t?.tabBehavior)},focusable:{ignoreKeydown:t?.ignoreDefaultKeydown}})),wvt=t=>{switch(t){case"unlimited":return QW.Unlimited;case"limited":return QW.Limited;case"limited-trap-focus":return QW.LimitedTrapFocus;default:return}},iK=()=>{const t=OH(),{targetDocument:e}=Ov(),i=$.useCallback((h,p)=>{var g;return((g=t.current)===null||g===void 0?void 0:g.focusable.findAll({container:h,acceptCondition:p}))||[]},[t]),r=$.useCallback(h=>{var p;return(p=t.current)===null||p===void 0?void 0:p.focusable.findFirst({container:h})},[t]),o=$.useCallback(h=>{var p;return(p=t.current)===null||p===void 0?void 0:p.focusable.findLast({container:h})},[t]),l=$.useCallback((h,p={})=>{if(!t.current||!e)return null;const{container:g=e.body}=p;return t.current.focusable.findNext({currentElement:h,container:g})},[t,e]),d=$.useCallback((h,p={})=>{if(!t.current||!e)return null;const{container:g=e.body}=p;return t.current.focusable.findPrev({currentElement:h,container:g})},[t,e]);return{findAllFocusable:i,findFirstFocusable:r,findLastFocusable:o,findNextFocusable:l,findPrevFocusable:d}},fse="data-fui-focus-visible",vse="data-fui-focus-within",C5={style:{},selector:"focus",customizeSelector:t=>t};function kvt(t,e){if(bke(t))return()=>{};const i={current:void 0},r=ise(e);function o(p){r.isNavigatingWithKeyboard()&&yA(p)&&(i.current=p,p.setAttribute(fse,""))}function l(){i.current&&(i.current.removeAttribute(fse),i.current=void 0)}r.subscribe(p=>{p||l()});const d=p=>{l();const g=p.composedPath()[0];o(g)},h=p=>{(!p.relatedTarget||yA(p.relatedTarget)&&!t.contains(p.relatedTarget))&&l()};return t.addEventListener(SA,d),t.addEventListener("focusout",h),t.focusVisible=!0,t.contains(e.document.activeElement)&&o(e.document.activeElement),()=>{l(),t.removeEventListener(SA,d),t.removeEventListener("focusout",h),delete t.focusVisible,nse(r)}}function bke(t){return t?t.focusVisible?!0:bke(t?.parentElement):!1}function Tke(t={}){const e=Ov(),i=$.useRef(null);var r;const o=(r=t.targetDocument)!==null&&r!==void 0?r:e.targetDocument;return $.useEffect(()=>{if(o?.defaultView&&i.current)return kvt(i.current,o.defaultView)},[i,o]),i}function Rvt(t,e){const i=ise(e);i.subscribe(l=>{l||Cke(t)});const r=l=>{i.isNavigatingWithKeyboard()&&_ke(l.target)&&Mvt(t)},o=l=>{(!l.relatedTarget||_ke(l.relatedTarget)&&!t.contains(l.relatedTarget))&&Cke(t)};return t.addEventListener(SA,r),t.addEventListener("focusout",o),()=>{t.removeEventListener(SA,r),t.removeEventListener("focusout",o),nse(i)}}function Mvt(t){t.setAttribute(vse,"")}function Cke(t){t.removeAttribute(vse)}function _ke(t){return t?!!(t&&typeof t=="object"&&"classList"in t&&"contains"in t):!1}function yse(){const{targetDocument:t}=Ov(),e=$.useRef(null);return $.useEffect(()=>{if(t?.defaultView&&e.current)return Rvt(e.current,t.defaultView)},[e,t]),e}function Pvt(){return OH(Tvt),hse({restorer:{type:PH.Source}})}function Dvt(t,{selector:e=C5.selector,customizeSelector:i=C5.customizeSelector}=C5){return{[i(Lvt(e))]:t}}function Lvt(t){switch(t){case"focus":return`&[${fse}]`;case"focus-within":return`&[${vse}]:focus-within`}}const On={2:"#050505",4:"#0a0a0a",6:"#0f0f0f",8:"#141414",10:"#1a1a1a",12:"#1f1f1f",14:"#242424",16:"#292929",18:"#2e2e2e",20:"#333333",22:"#383838",24:"#3d3d3d",26:"#424242",30:"#4d4d4d",32:"#525252",34:"#575757",36:"#5c5c5c",38:"#616161",40:"#666666",42:"#6b6b6b",44:"#707070",46:"#757575",60:"#999999",68:"#adadad",70:"#b3b3b3",74:"#bdbdbd",78:"#c7c7c7",82:"#d1d1d1",84:"#d6d6d6",86:"#dbdbdb",88:"#e0e0e0",90:"#e6e6e6",92:"#ebebeb",94:"#f0f0f0",96:"#f5f5f5",98:"#fafafa"},Hy={5:"rgba(255, 255, 255, 0.05)",10:"rgba(255, 255, 255, 0.1)",20:"rgba(255, 255, 255, 0.2)",40:"rgba(255, 255, 255, 0.4)",50:"rgba(255, 255, 255, 0.5)",60:"rgba(255, 255, 255, 0.6)",70:"rgba(255, 255, 255, 0.7)",80:"rgba(255, 255, 255, 0.8)"},CE={5:"rgba(0, 0, 0, 0.05)",10:"rgba(0, 0, 0, 0.1)",20:"rgba(0, 0, 0, 0.2)",30:"rgba(0, 0, 0, 0.3)",40:"rgba(0, 0, 0, 0.4)",50:"rgba(0, 0, 0, 0.5)"},Ovt={50:"rgba(26, 26, 26, 0.5)"},Nvt={70:"rgba(31, 31, 31, 0.7)"},Eke={50:"rgba(36, 36, 36, 0.5)",80:"rgba(36, 36, 36, 0.8)"},Bs="#ffffff",nK="#000000",xvt={shade50:"#130204",shade40:"#230308",shade30:"#420610",shade20:"#590815",shade10:"#690a19",primary:"#750b1c",tint10:"#861b2c",tint20:"#962f3f",tint30:"#ac4f5e",tint40:"#d69ca5",tint50:"#e9c7cd",tint60:"#f9f0f2"},Ake={shade50:"#200205",shade40:"#3b0509",shade30:"#6e0811",shade20:"#960b18",shade10:"#b10e1c",primary:"#c50f1f",tint10:"#cc2635",tint20:"#d33f4c",tint30:"#dc626d",tint40:"#eeacb2",tint50:"#f6d1d5",tint60:"#fdf3f4"},Bvt={shade50:"#210809",shade40:"#3f1011",shade30:"#751d1f",shade20:"#9f282b",shade10:"#bc2f32",primary:"#d13438",tint10:"#d7494c",tint20:"#dc5e62",tint30:"#e37d80",tint40:"#f1bbbc",tint50:"#f8dadb",tint60:"#fdf6f6"},Fvt={shade50:"#230900",shade40:"#411200",shade30:"#7a2101",shade20:"#a62d01",shade10:"#c43501",primary:"#da3b01",tint10:"#de501c",tint20:"#e36537",tint30:"#e9835e",tint40:"#f4bfab",tint50:"#f9dcd1",tint60:"#fdf6f3"},Uvt={shade50:"#200d03",shade40:"#3d1805",shade30:"#712d09",shade20:"#9a3d0c",shade10:"#b6480e",primary:"#ca5010",tint10:"#d06228",tint20:"#d77440",tint30:"#df8e64",tint40:"#efc4ad",tint50:"#f7dfd2",tint60:"#fdf7f4"},zvt={shade50:"#271002",shade40:"#4a1e04",shade30:"#8a3707",shade20:"#bc4b09",shade10:"#de590b",primary:"#f7630c",tint10:"#f87528",tint20:"#f98845",tint30:"#faa06b",tint40:"#fdcfb4",tint50:"#fee5d7",tint60:"#fff9f5"},Vvt={shade50:"#291600",shade40:"#4d2a00",shade30:"#8f4e00",shade20:"#c26a00",shade10:"#e67e00",primary:"#ff8c00",tint10:"#ff9a1f",tint20:"#ffa83d",tint30:"#ffba66",tint40:"#ffddb3",tint50:"#ffedd6",tint60:"#fffaf5"},$vt={shade50:"#251a00",shade40:"#463100",shade30:"#835b00",shade20:"#b27c00",shade10:"#d39300",primary:"#eaa300",tint10:"#edad1c",tint20:"#efb839",tint30:"#f2c661",tint40:"#f9e2ae",tint50:"#fcefd3",tint60:"#fefbf4"},Hvt={shade50:"#282400",shade40:"#4c4400",shade30:"#817400",shade20:"#c0ad00",shade10:"#e4cc00",primary:"#fde300",tint10:"#fde61e",tint20:"#fdea3d",tint30:"#feee66",tint40:"#fef7b2",tint50:"#fffad6",tint60:"#fffef5"},jvt={shade50:"#1f1900",shade40:"#3a2f00",shade30:"#6c5700",shade20:"#937700",shade10:"#ae8c00",primary:"#c19c00",tint10:"#c8a718",tint20:"#d0b232",tint30:"#dac157",tint40:"#ecdfa5",tint50:"#f5eece",tint60:"#fdfbf2"},Gvt={shade50:"#181202",shade40:"#2e2103",shade30:"#553e06",shade20:"#745408",shade10:"#89640a",primary:"#986f0b",tint10:"#a47d1e",tint20:"#b18c34",tint30:"#c1a256",tint40:"#e0cea2",tint50:"#efe4cb",tint60:"#fbf8f2"},qvt={shade50:"#170e07",shade40:"#2b1a0e",shade30:"#50301a",shade20:"#6c4123",shade10:"#804d29",primary:"#8e562e",tint10:"#9c663f",tint20:"#a97652",tint30:"#bb8f6f",tint40:"#ddc3b0",tint50:"#edded3",tint60:"#faf7f4"},Wvt={shade50:"#0c1501",shade40:"#162702",shade30:"#294903",shade20:"#376304",shade10:"#427505",primary:"#498205",tint10:"#599116",tint20:"#6ba02b",tint30:"#85b44c",tint40:"#bdd99b",tint50:"#dbebc7",tint60:"#f6faf0"},Kvt={shade50:"#002111",shade40:"#003d20",shade30:"#00723b",shade20:"#009b51",shade10:"#00b85f",primary:"#00cc6a",tint10:"#19d279",tint20:"#34d889",tint30:"#5ae0a0",tint40:"#a8f0cd",tint50:"#cff7e4",tint60:"#f3fdf8"},Jvt={shade50:"#031a02",shade40:"#063004",shade30:"#0b5a08",shade20:"#0e7a0b",shade10:"#11910d",primary:"#13a10e",tint10:"#27ac22",tint20:"#3db838",tint30:"#5ec75a",tint40:"#a7e3a5",tint50:"#cef0cd",tint60:"#f2fbf2"},Ike={shade50:"#031403",shade40:"#052505",shade30:"#094509",shade20:"#0c5e0c",shade10:"#0e700e",primary:"#107c10",tint10:"#218c21",tint20:"#359b35",tint30:"#54b054",tint40:"#9fd89f",tint50:"#c9eac9",tint60:"#f1faf1"},Yvt={shade50:"#021102",shade40:"#032003",shade30:"#063b06",shade20:"#085108",shade10:"#0a5f0a",primary:"#0b6a0b",tint10:"#1a7c1a",tint20:"#2d8e2d",tint30:"#4da64d",tint40:"#9ad29a",tint50:"#c6e7c6",tint60:"#f0f9f0"},Qvt={shade50:"#001d1f",shade40:"#00373a",shade30:"#00666d",shade20:"#008b94",shade10:"#00a5af",primary:"#00b7c3",tint10:"#18bfca",tint20:"#32c8d1",tint30:"#58d3db",tint40:"#a6e9ed",tint50:"#cef3f5",tint60:"#f2fcfd"},Zvt={shade50:"#001516",shade40:"#012728",shade30:"#02494c",shade20:"#026467",shade10:"#037679",primary:"#038387",tint10:"#159195",tint20:"#2aa0a4",tint30:"#4cb4b7",tint40:"#9bd9db",tint50:"#c7ebec",tint60:"#f0fafa"},Xvt={shade50:"#000f12",shade40:"#001b22",shade30:"#00333f",shade20:"#004555",shade10:"#005265",primary:"#005b70",tint10:"#0f6c81",tint20:"#237d92",tint30:"#4496a9",tint40:"#94c8d4",tint50:"#c3e1e8",tint60:"#eff7f9"},eyt={shade50:"#001322",shade40:"#002440",shade30:"#004377",shade20:"#005ba1",shade10:"#006cbf",primary:"#0078d4",tint10:"#1a86d9",tint20:"#3595de",tint30:"#5caae5",tint40:"#a9d3f2",tint50:"#d0e7f8",tint60:"#f3f9fd"},tyt={shade50:"#000c16",shade40:"#00172a",shade30:"#002c4e",shade20:"#003b6a",shade10:"#00467e",primary:"#004e8c",tint10:"#125e9a",tint20:"#286fa8",tint30:"#4a89ba",tint40:"#9abfdc",tint50:"#c7dced",tint60:"#f0f6fa"},iyt={shade50:"#0d1126",shade40:"#182047",shade30:"#2c3c85",shade20:"#3c51b4",shade10:"#4760d5",primary:"#4f6bed",tint10:"#637cef",tint20:"#778df1",tint30:"#93a4f4",tint40:"#c8d1fa",tint50:"#e1e6fc",tint60:"#f7f9fe"},nyt={shade50:"#00061d",shade40:"#000c36",shade30:"#001665",shade20:"#001e89",shade10:"#0023a2",primary:"#0027b4",tint10:"#173bbd",tint20:"#3050c6",tint30:"#546fd2",tint40:"#a3b2e8",tint50:"#ccd5f3",tint60:"#f2f4fc"},ayt={shade50:"#120f25",shade40:"#221d46",shade30:"#3f3682",shade20:"#5649b0",shade10:"#6656d1",primary:"#7160e8",tint10:"#8172eb",tint20:"#9184ee",tint30:"#a79cf1",tint40:"#d2ccf8",tint50:"#e7e4fb",tint60:"#f9f8fe"},ryt={shade50:"#0f0717",shade40:"#1c0e2b",shade30:"#341a51",shade20:"#46236e",shade10:"#532982",primary:"#5c2e91",tint10:"#6b3f9e",tint20:"#7c52ab",tint30:"#9470bd",tint40:"#c6b1de",tint50:"#e0d3ed",tint60:"#f7f4fb"},oyt={shade50:"#160418",shade40:"#29072e",shade30:"#4c0d55",shade20:"#671174",shade10:"#7a1589",primary:"#881798",tint10:"#952aa4",tint20:"#a33fb1",tint30:"#b55fc1",tint40:"#d9a7e0",tint50:"#eaceef",tint60:"#faf2fb"},syt={shade50:"#1f091d",shade40:"#3a1136",shade30:"#6d2064",shade20:"#932b88",shade10:"#af33a1",primary:"#c239b3",tint10:"#c94cbc",tint20:"#d161c4",tint30:"#da7ed0",tint40:"#edbbe7",tint50:"#f5daf2",tint60:"#fdf5fc"},lyt={shade50:"#1c0b1f",shade40:"#35153a",shade30:"#63276d",shade20:"#863593",shade10:"#9f3faf",primary:"#b146c2",tint10:"#ba58c9",tint20:"#c36bd1",tint30:"#cf87da",tint40:"#e6bfed",tint50:"#f2dcf5",tint60:"#fcf6fd"},cyt={shade50:"#24091b",shade40:"#441232",shade30:"#80215d",shade20:"#ad2d7e",shade10:"#cd3595",primary:"#e43ba6",tint10:"#e750b0",tint20:"#ea66ba",tint30:"#ef85c8",tint40:"#f7c0e3",tint50:"#fbddf0",tint60:"#fef6fb"},dyt={shade50:"#1f0013",shade40:"#390024",shade30:"#6b0043",shade20:"#91005a",shade10:"#ac006b",primary:"#bf0077",tint10:"#c71885",tint20:"#ce3293",tint30:"#d957a8",tint40:"#eca5d1",tint50:"#f5cee6",tint60:"#fcf2f9"},uyt={shade50:"#13000c",shade40:"#240017",shade30:"#43002b",shade20:"#5a003b",shade10:"#6b0045",primary:"#77004d",tint10:"#87105d",tint20:"#98246f",tint30:"#ad4589",tint40:"#d696c0",tint50:"#e9c4dc",tint60:"#faf0f6"},hyt={shade50:"#141313",shade40:"#252323",shade30:"#444241",shade20:"#5d5958",shade10:"#6e6968",primary:"#7a7574",tint10:"#8a8584",tint20:"#9a9594",tint30:"#afabaa",tint40:"#d7d4d4",tint50:"#eae8e8",tint60:"#faf9f9"},pyt={shade50:"#0f0e0e",shade40:"#1c1b1a",shade30:"#343231",shade20:"#474443",shade10:"#54514f",primary:"#5d5a58",tint10:"#706d6b",tint20:"#84817e",tint30:"#9e9b99",tint40:"#cecccb",tint50:"#e5e4e3",tint60:"#f8f8f8"},gyt={shade50:"#111314",shade40:"#1f2426",shade30:"#3b4447",shade20:"#505c60",shade10:"#5f6d71",primary:"#69797e",tint10:"#79898d",tint20:"#89989d",tint30:"#a0adb2",tint40:"#cdd6d8",tint50:"#e4e9ea",tint60:"#f8f9fa"},myt={shade50:"#090a0b",shade40:"#111315",shade30:"#202427",shade20:"#2b3135",shade10:"#333a3f",primary:"#394146",tint10:"#4d565c",tint20:"#626c72",tint30:"#808a90",tint40:"#bcc3c7",tint50:"#dbdfe1",tint60:"#f6f7f8"},Kc={red:Bvt,green:Ike,darkOrange:Fvt,yellow:Hvt,berry:syt,lightGreen:Jvt,marigold:$vt},UL={darkRed:xvt,cranberry:Ake,pumpkin:Uvt,peach:Vvt,gold:jvt,brass:Gvt,brown:qvt,forest:Wvt,seafoam:Kvt,darkGreen:Yvt,lightTeal:Qvt,teal:Zvt,steel:Xvt,blue:eyt,royalBlue:tyt,cornflower:iyt,navy:nyt,lavender:ayt,purple:ryt,grape:oyt,lilac:lyt,pink:cyt,magenta:dyt,plum:uyt,beige:hyt,mink:pyt,platinum:gyt,anchor:myt},zc={cranberry:Ake,green:Ike,orange:zvt},wke=["red","green","darkOrange","yellow","berry","lightGreen","marigold"],kke=["darkRed","cranberry","pumpkin","peach","gold","brass","brown","forest","seafoam","darkGreen","lightTeal","teal","steel","blue","royalBlue","cornflower","navy","lavender","purple","grape","lilac","pink","magenta","plum","beige","mink","platinum","anchor"],lT={success:"green",warning:"orange",danger:"cranberry"},xH=wke.reduce((t,e)=>{const i=e.slice(0,1).toUpperCase()+e.slice(1),r={[`colorPalette${i}Background1`]:Kc[e].tint60,[`colorPalette${i}Background2`]:Kc[e].tint40,[`colorPalette${i}Background3`]:Kc[e].primary,[`colorPalette${i}Foreground1`]:Kc[e].shade10,[`colorPalette${i}Foreground2`]:Kc[e].shade30,[`colorPalette${i}Foreground3`]:Kc[e].primary,[`colorPalette${i}BorderActive`]:Kc[e].primary,[`colorPalette${i}Border1`]:Kc[e].tint40,[`colorPalette${i}Border2`]:Kc[e].primary};return Object.assign(t,r)},{});xH.colorPaletteYellowForeground1=Kc.yellow.shade30,xH.colorPaletteRedForegroundInverted=Kc.red.tint20,xH.colorPaletteGreenForegroundInverted=Kc.green.tint20,xH.colorPaletteYellowForegroundInverted=Kc.yellow.tint40;const fyt=kke.reduce((t,e)=>{const i=e.slice(0,1).toUpperCase()+e.slice(1),r={[`colorPalette${i}Background2`]:UL[e].tint40,[`colorPalette${i}Foreground2`]:UL[e].shade30,[`colorPalette${i}BorderActive`]:UL[e].primary};return Object.assign(t,r)},{}),vyt={...xH,...fyt},_5=Object.entries(lT).reduce((t,[e,i])=>{const r=e.slice(0,1).toUpperCase()+e.slice(1),o={[`colorStatus${r}Background1`]:zc[i].tint60,[`colorStatus${r}Background2`]:zc[i].tint40,[`colorStatus${r}Background3`]:zc[i].primary,[`colorStatus${r}Foreground1`]:zc[i].shade10,[`colorStatus${r}Foreground2`]:zc[i].shade30,[`colorStatus${r}Foreground3`]:zc[i].primary,[`colorStatus${r}ForegroundInverted`]:zc[i].tint30,[`colorStatus${r}BorderActive`]:zc[i].primary,[`colorStatus${r}Border1`]:zc[i].tint40,[`colorStatus${r}Border2`]:zc[i].primary};return Object.assign(t,o)},{});_5.colorStatusDangerBackground3Hover=zc[lT.danger].shade10,_5.colorStatusDangerBackground3Pressed=zc[lT.danger].shade20,_5.colorStatusWarningForeground1=zc[lT.warning].shade20,_5.colorStatusWarningForeground3=zc[lT.warning].shade20,_5.colorStatusWarningBorder2=zc[lT.warning].shade20;const yyt=t=>({colorNeutralForeground1:On[14],colorNeutralForeground1Hover:On[14],colorNeutralForeground1Pressed:On[14],colorNeutralForeground1Selected:On[14],colorNeutralForeground2:On[26],colorNeutralForeground2Hover:On[14],colorNeutralForeground2Pressed:On[14],colorNeutralForeground2Selected:On[14],colorNeutralForeground2BrandHover:t[80],colorNeutralForeground2BrandPressed:t[70],colorNeutralForeground2BrandSelected:t[80],colorNeutralForeground3:On[38],colorNeutralForeground3Hover:On[26],colorNeutralForeground3Pressed:On[26],colorNeutralForeground3Selected:On[26],colorNeutralForeground3BrandHover:t[80],colorNeutralForeground3BrandPressed:t[70],colorNeutralForeground3BrandSelected:t[80],colorNeutralForeground4:On[44],colorNeutralForegroundDisabled:On[74],colorNeutralForegroundInvertedDisabled:Hy[40],colorBrandForegroundLink:t[70],colorBrandForegroundLinkHover:t[60],colorBrandForegroundLinkPressed:t[40],colorBrandForegroundLinkSelected:t[70],colorNeutralForeground2Link:On[26],colorNeutralForeground2LinkHover:On[14],colorNeutralForeground2LinkPressed:On[14],colorNeutralForeground2LinkSelected:On[14],colorCompoundBrandForeground1:t[80],colorCompoundBrandForeground1Hover:t[70],colorCompoundBrandForeground1Pressed:t[60],colorBrandForeground1:t[80],colorBrandForeground2:t[70],colorBrandForeground2Hover:t[60],colorBrandForeground2Pressed:t[30],colorNeutralForeground1Static:On[14],colorNeutralForegroundStaticInverted:Bs,colorNeutralForegroundInverted:Bs,colorNeutralForegroundInvertedHover:Bs,colorNeutralForegroundInvertedPressed:Bs,colorNeutralForegroundInvertedSelected:Bs,colorNeutralForegroundInverted2:Bs,colorNeutralForegroundOnBrand:Bs,colorNeutralForegroundInvertedLink:Bs,colorNeutralForegroundInvertedLinkHover:Bs,colorNeutralForegroundInvertedLinkPressed:Bs,colorNeutralForegroundInvertedLinkSelected:Bs,colorBrandForegroundInverted:t[100],colorBrandForegroundInvertedHover:t[110],colorBrandForegroundInvertedPressed:t[100],colorBrandForegroundOnLight:t[80],colorBrandForegroundOnLightHover:t[70],colorBrandForegroundOnLightPressed:t[50],colorBrandForegroundOnLightSelected:t[60],colorNeutralBackground1:Bs,colorNeutralBackground1Hover:On[96],colorNeutralBackground1Pressed:On[88],colorNeutralBackground1Selected:On[92],colorNeutralBackground2:On[98],colorNeutralBackground2Hover:On[94],colorNeutralBackground2Pressed:On[86],colorNeutralBackground2Selected:On[90],colorNeutralBackground3:On[96],colorNeutralBackground3Hover:On[92],colorNeutralBackground3Pressed:On[84],colorNeutralBackground3Selected:On[88],colorNeutralBackground4:On[94],colorNeutralBackground4Hover:On[98],colorNeutralBackground4Pressed:On[96],colorNeutralBackground4Selected:Bs,colorNeutralBackground5:On[92],colorNeutralBackground5Hover:On[96],colorNeutralBackground5Pressed:On[94],colorNeutralBackground5Selected:On[98],colorNeutralBackground6:On[90],colorNeutralBackgroundInverted:On[16],colorNeutralBackgroundStatic:On[20],colorNeutralBackgroundAlpha:Hy[50],colorNeutralBackgroundAlpha2:Hy[80],colorSubtleBackground:"transparent",colorSubtleBackgroundHover:On[96],colorSubtleBackgroundPressed:On[88],colorSubtleBackgroundSelected:On[92],colorSubtleBackgroundLightAlphaHover:Hy[70],colorSubtleBackgroundLightAlphaPressed:Hy[50],colorSubtleBackgroundLightAlphaSelected:"transparent",colorSubtleBackgroundInverted:"transparent",colorSubtleBackgroundInvertedHover:CE[10],colorSubtleBackgroundInvertedPressed:CE[30],colorSubtleBackgroundInvertedSelected:CE[20],colorTransparentBackground:"transparent",colorTransparentBackgroundHover:"transparent",colorTransparentBackgroundPressed:"transparent",colorTransparentBackgroundSelected:"transparent",colorNeutralBackgroundDisabled:On[94],colorNeutralBackgroundInvertedDisabled:Hy[10],colorNeutralStencil1:On[90],colorNeutralStencil2:On[98],colorNeutralStencil1Alpha:CE[10],colorNeutralStencil2Alpha:CE[5],colorBackgroundOverlay:CE[40],colorScrollbarOverlay:CE[50],colorBrandBackground:t[80],colorBrandBackgroundHover:t[70],colorBrandBackgroundPressed:t[40],colorBrandBackgroundSelected:t[60],colorCompoundBrandBackground:t[80],colorCompoundBrandBackgroundHover:t[70],colorCompoundBrandBackgroundPressed:t[60],colorBrandBackgroundStatic:t[80],colorBrandBackground2:t[160],colorBrandBackground2Hover:t[150],colorBrandBackground2Pressed:t[130],colorBrandBackground3Static:t[60],colorBrandBackground4Static:t[40],colorBrandBackgroundInverted:Bs,colorBrandBackgroundInvertedHover:t[160],colorBrandBackgroundInvertedPressed:t[140],colorBrandBackgroundInvertedSelected:t[150],colorNeutralCardBackground:On[98],colorNeutralCardBackgroundHover:Bs,colorNeutralCardBackgroundPressed:On[96],colorNeutralCardBackgroundSelected:On[92],colorNeutralCardBackgroundDisabled:On[94],colorNeutralStrokeAccessible:On[38],colorNeutralStrokeAccessibleHover:On[34],colorNeutralStrokeAccessiblePressed:On[30],colorNeutralStrokeAccessibleSelected:t[80],colorNeutralStroke1:On[82],colorNeutralStroke1Hover:On[78],colorNeutralStroke1Pressed:On[70],colorNeutralStroke1Selected:On[74],colorNeutralStroke2:On[88],colorNeutralStroke3:On[94],colorNeutralStrokeSubtle:On[88],colorNeutralStrokeOnBrand:Bs,colorNeutralStrokeOnBrand2:Bs,colorNeutralStrokeOnBrand2Hover:Bs,colorNeutralStrokeOnBrand2Pressed:Bs,colorNeutralStrokeOnBrand2Selected:Bs,colorBrandStroke1:t[80],colorBrandStroke2:t[140],colorBrandStroke2Hover:t[120],colorBrandStroke2Pressed:t[80],colorBrandStroke2Contrast:t[140],colorCompoundBrandStroke:t[80],colorCompoundBrandStrokeHover:t[70],colorCompoundBrandStrokePressed:t[60],colorNeutralStrokeDisabled:On[88],colorNeutralStrokeInvertedDisabled:Hy[40],colorTransparentStroke:"transparent",colorTransparentStrokeInteractive:"transparent",colorTransparentStrokeDisabled:"transparent",colorNeutralStrokeAlpha:CE[5],colorNeutralStrokeAlpha2:Hy[20],colorStrokeFocus1:Bs,colorStrokeFocus2:nK,colorNeutralShadowAmbient:"rgba(0,0,0,0.12)",colorNeutralShadowKey:"rgba(0,0,0,0.14)",colorNeutralShadowAmbientLighter:"rgba(0,0,0,0.06)",colorNeutralShadowKeyLighter:"rgba(0,0,0,0.07)",colorNeutralShadowAmbientDarker:"rgba(0,0,0,0.20)",colorNeutralShadowKeyDarker:"rgba(0,0,0,0.24)",colorBrandShadowAmbient:"rgba(0,0,0,0.30)",colorBrandShadowKey:"rgba(0,0,0,0.25)"}),Rke={borderRadiusNone:"0",borderRadiusSmall:"2px",borderRadiusMedium:"4px",borderRadiusLarge:"6px",borderRadiusXLarge:"8px",borderRadiusCircular:"10000px"},Mke={curveAccelerateMax:"cubic-bezier(0.9,0.1,1,0.2)",curveAccelerateMid:"cubic-bezier(1,0,1,1)",curveAccelerateMin:"cubic-bezier(0.8,0,0.78,1)",curveDecelerateMax:"cubic-bezier(0.1,0.9,0.2,1)",curveDecelerateMid:"cubic-bezier(0,0,0,1)",curveDecelerateMin:"cubic-bezier(0.33,0,0.1,1)",curveEasyEaseMax:"cubic-bezier(0.8,0,0.2,1)",curveEasyEase:"cubic-bezier(0.33,0,0.67,1)",curveLinear:"cubic-bezier(0,0,1,1)"},Pke={durationUltraFast:"50ms",durationFaster:"100ms",durationFast:"150ms",durationNormal:"200ms",durationGentle:"250ms",durationSlow:"300ms",durationSlower:"400ms",durationUltraSlow:"500ms"},Dke={fontSizeBase100:"10px",fontSizeBase200:"12px",fontSizeBase300:"14px",fontSizeBase400:"16px",fontSizeBase500:"20px",fontSizeBase600:"24px",fontSizeHero700:"28px",fontSizeHero800:"32px",fontSizeHero900:"40px",fontSizeHero1000:"68px"},Lke={lineHeightBase100:"14px",lineHeightBase200:"16px",lineHeightBase300:"20px",lineHeightBase400:"22px",lineHeightBase500:"28px",lineHeightBase600:"32px",lineHeightHero700:"36px",lineHeightHero800:"40px",lineHeightHero900:"52px",lineHeightHero1000:"92px"},Oke={fontWeightRegular:400,fontWeightMedium:500,fontWeightSemibold:600,fontWeightBold:700},Nke={fontFamilyBase:"'Segoe UI', 'Segoe UI Web (West European)', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue', sans-serif",fontFamilyMonospace:"Consolas, 'Courier New', Courier, monospace",fontFamilyNumeric:"Bahnschrift, 'Segoe UI', 'Segoe UI Web (West European)', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue', sans-serif"},Ep={none:"0",xxs:"2px",xs:"4px",sNudge:"6px",s:"8px",mNudge:"10px",m:"12px",l:"16px",xl:"20px",xxl:"24px",xxxl:"32px"},xke={spacingHorizontalNone:Ep.none,spacingHorizontalXXS:Ep.xxs,spacingHorizontalXS:Ep.xs,spacingHorizontalSNudge:Ep.sNudge,spacingHorizontalS:Ep.s,spacingHorizontalMNudge:Ep.mNudge,spacingHorizontalM:Ep.m,spacingHorizontalL:Ep.l,spacingHorizontalXL:Ep.xl,spacingHorizontalXXL:Ep.xxl,spacingHorizontalXXXL:Ep.xxxl},Bke={spacingVerticalNone:Ep.none,spacingVerticalXXS:Ep.xxs,spacingVerticalXS:Ep.xs,spacingVerticalSNudge:Ep.sNudge,spacingVerticalS:Ep.s,spacingVerticalMNudge:Ep.mNudge,spacingVerticalM:Ep.m,spacingVerticalL:Ep.l,spacingVerticalXL:Ep.xl,spacingVerticalXXL:Ep.xxl,spacingVerticalXXXL:Ep.xxxl},Fke={strokeWidthThin:"1px",strokeWidthThick:"2px",strokeWidthThicker:"3px",strokeWidthThickest:"4px"},cs={colorNeutralForeground1:"var(--colorNeutralForeground1)",colorNeutralForeground2:"var(--colorNeutralForeground2)",colorNeutralForeground3:"var(--colorNeutralForeground3)",colorNeutralForegroundDisabled:"var(--colorNeutralForegroundDisabled)",colorBrandForegroundLink:"var(--colorBrandForegroundLink)",colorBrandForegroundLinkHover:"var(--colorBrandForegroundLinkHover)",colorBrandForeground1:"var(--colorBrandForeground1)",colorNeutralBackground1:"var(--colorNeutralBackground1)",colorNeutralBackground1Selected:"var(--colorNeutralBackground1Selected)",colorNeutralBackground2:"var(--colorNeutralBackground2)",colorNeutralBackground3:"var(--colorNeutralBackground3)",colorBrandBackground2:"var(--colorBrandBackground2)",colorBrandBackgroundInverted:"var(--colorBrandBackgroundInverted)",colorNeutralStrokeAccessible:"var(--colorNeutralStrokeAccessible)",colorNeutralStroke1Selected:"var(--colorNeutralStroke1Selected)",colorCompoundBrandStroke:"var(--colorCompoundBrandStroke)",colorStrokeFocus2:"var(--colorStrokeFocus2)",colorPaletteRedForeground3:"var(--colorPaletteRedForeground3)",colorPaletteDarkOrangeBorderActive:"var(--colorPaletteDarkOrangeBorderActive)",colorPaletteDarkOrangeForeground3:"var(--colorPaletteDarkOrangeForeground3)",colorPaletteMarigoldBackground1:"var(--colorPaletteMarigoldBackground1)",colorStatusWarningBackground3:"var(--colorStatusWarningBackground3)",borderRadiusMedium:"var(--borderRadiusMedium)",fontFamilyBase:"var(--fontFamilyBase)",fontSizeBase300:"var(--fontSizeBase300)",fontWeightRegular:"var(--fontWeightRegular)",fontWeightSemibold:"var(--fontWeightSemibold)",lineHeightBase100:"var(--lineHeightBase100)",lineHeightBase300:"var(--lineHeightBase300)",shadow4:"var(--shadow4)"};function aK(t,e,i=""){return{[`shadow2${i}`]:`0 0 2px ${t}, 0 1px 2px ${e}`,[`shadow4${i}`]:`0 0 2px ${t}, 0 2px 4px ${e}`,[`shadow8${i}`]:`0 0 2px ${t}, 0 4px 8px ${e}`,[`shadow16${i}`]:`0 0 2px ${t}, 0 8px 16px ${e}`,[`shadow28${i}`]:`0 0 8px ${t}, 0 14px 28px ${e}`,[`shadow64${i}`]:`0 0 8px ${t}, 0 32px 64px ${e}`}}const Syt=t=>{const e=yyt(t);return{...Rke,...Dke,...Lke,...Nke,...Oke,...Fke,...xke,...Bke,...Pke,...Mke,...e,...vyt,..._5,...aK(e.colorNeutralShadowAmbient,e.colorNeutralShadowKey),...aK(e.colorBrandShadowAmbient,e.colorBrandShadowKey,"Brand")}},Uke={10:"#061724",20:"#082338",30:"#0a2e4a",40:"#0c3b5e",50:"#0e4775",60:"#0f548c",70:"#115ea3",80:"#0f6cbd",90:"#2886de",100:"#479ef5",110:"#62abf5",120:"#77b7f7",130:"#96c6fa",140:"#b4d6fa",150:"#cfe4fa",160:"#ebf3fc"},Hw=wke.reduce((t,e)=>{const i=e.slice(0,1).toUpperCase()+e.slice(1),r={[`colorPalette${i}Background1`]:Kc[e].shade40,[`colorPalette${i}Background2`]:Kc[e].shade30,[`colorPalette${i}Background3`]:Kc[e].primary,[`colorPalette${i}Foreground1`]:Kc[e].tint30,[`colorPalette${i}Foreground2`]:Kc[e].tint40,[`colorPalette${i}Foreground3`]:Kc[e].tint20,[`colorPalette${i}BorderActive`]:Kc[e].tint30,[`colorPalette${i}Border1`]:Kc[e].primary,[`colorPalette${i}Border2`]:Kc[e].tint20};return Object.assign(t,r)},{});Hw.colorPaletteRedForeground3=Kc.red.tint30,Hw.colorPaletteRedBorder2=Kc.red.tint30,Hw.colorPaletteGreenForeground3=Kc.green.tint40,Hw.colorPaletteGreenBorder2=Kc.green.tint40,Hw.colorPaletteDarkOrangeForeground3=Kc.darkOrange.tint30,Hw.colorPaletteDarkOrangeBorder2=Kc.darkOrange.tint30,Hw.colorPaletteRedForegroundInverted=Kc.red.primary,Hw.colorPaletteGreenForegroundInverted=Kc.green.primary,Hw.colorPaletteYellowForegroundInverted=Kc.yellow.shade30;const Sse=kke.reduce((t,e)=>{const i=e.slice(0,1).toUpperCase()+e.slice(1),r={[`colorPalette${i}Background2`]:UL[e].shade30,[`colorPalette${i}Foreground2`]:UL[e].tint40,[`colorPalette${i}BorderActive`]:UL[e].tint30};return Object.assign(t,r)},{});Sse.colorPaletteDarkRedBackground2=UL.darkRed.shade20,Sse.colorPalettePlumBackground2=UL.plum.shade20;const byt={...Hw,...Sse},zL=Object.entries(lT).reduce((t,[e,i])=>{const r=e.slice(0,1).toUpperCase()+e.slice(1),o={[`colorStatus${r}Background1`]:zc[i].shade40,[`colorStatus${r}Background2`]:zc[i].shade30,[`colorStatus${r}Background3`]:zc[i].primary,[`colorStatus${r}Foreground1`]:zc[i].tint30,[`colorStatus${r}Foreground2`]:zc[i].tint40,[`colorStatus${r}Foreground3`]:zc[i].tint20,[`colorStatus${r}BorderActive`]:zc[i].tint30,[`colorStatus${r}ForegroundInverted`]:zc[i].shade10,[`colorStatus${r}Border1`]:zc[i].primary,[`colorStatus${r}Border2`]:zc[i].tint20};return Object.assign(t,o)},{});zL.colorStatusDangerBackground3Hover=zc[lT.danger].shade10,zL.colorStatusDangerBackground3Pressed=zc[lT.danger].shade20,zL.colorStatusDangerForeground3=zc[lT.danger].tint40,zL.colorStatusDangerBorder2=zc[lT.danger].tint30,zL.colorStatusSuccessForeground3=zc[lT.success].tint40,zL.colorStatusSuccessBorder2=zc[lT.success].tint40,zL.colorStatusWarningForegroundInverted=zc[lT.warning].shade20;const zke=Syt(Uke),Tyt=t=>({colorNeutralForeground1:Bs,colorNeutralForeground1Hover:Bs,colorNeutralForeground1Pressed:Bs,colorNeutralForeground1Selected:Bs,colorNeutralForeground2:On[84],colorNeutralForeground2Hover:Bs,colorNeutralForeground2Pressed:Bs,colorNeutralForeground2Selected:Bs,colorNeutralForeground2BrandHover:t[100],colorNeutralForeground2BrandPressed:t[90],colorNeutralForeground2BrandSelected:t[100],colorNeutralForeground3:On[68],colorNeutralForeground3Hover:On[84],colorNeutralForeground3Pressed:On[84],colorNeutralForeground3Selected:On[84],colorNeutralForeground3BrandHover:t[100],colorNeutralForeground3BrandPressed:t[90],colorNeutralForeground3BrandSelected:t[100],colorNeutralForeground4:On[60],colorNeutralForegroundDisabled:On[36],colorNeutralForegroundInvertedDisabled:Hy[40],colorBrandForegroundLink:t[100],colorBrandForegroundLinkHover:t[110],colorBrandForegroundLinkPressed:t[90],colorBrandForegroundLinkSelected:t[100],colorNeutralForeground2Link:On[84],colorNeutralForeground2LinkHover:Bs,colorNeutralForeground2LinkPressed:Bs,colorNeutralForeground2LinkSelected:Bs,colorCompoundBrandForeground1:t[100],colorCompoundBrandForeground1Hover:t[110],colorCompoundBrandForeground1Pressed:t[90],colorBrandForeground1:t[100],colorBrandForeground2:t[110],colorBrandForeground2Hover:t[130],colorBrandForeground2Pressed:t[160],colorNeutralForeground1Static:On[14],colorNeutralForegroundStaticInverted:Bs,colorNeutralForegroundInverted:On[14],colorNeutralForegroundInvertedHover:On[14],colorNeutralForegroundInvertedPressed:On[14],colorNeutralForegroundInvertedSelected:On[14],colorNeutralForegroundInverted2:On[14],colorNeutralForegroundOnBrand:Bs,colorNeutralForegroundInvertedLink:Bs,colorNeutralForegroundInvertedLinkHover:Bs,colorNeutralForegroundInvertedLinkPressed:Bs,colorNeutralForegroundInvertedLinkSelected:Bs,colorBrandForegroundInverted:t[80],colorBrandForegroundInvertedHover:t[70],colorBrandForegroundInvertedPressed:t[60],colorBrandForegroundOnLight:t[80],colorBrandForegroundOnLightHover:t[70],colorBrandForegroundOnLightPressed:t[50],colorBrandForegroundOnLightSelected:t[60],colorNeutralBackground1:On[16],colorNeutralBackground1Hover:On[24],colorNeutralBackground1Pressed:On[12],colorNeutralBackground1Selected:On[22],colorNeutralBackground2:On[12],colorNeutralBackground2Hover:On[20],colorNeutralBackground2Pressed:On[8],colorNeutralBackground2Selected:On[18],colorNeutralBackground3:On[8],colorNeutralBackground3Hover:On[16],colorNeutralBackground3Pressed:On[4],colorNeutralBackground3Selected:On[14],colorNeutralBackground4:On[4],colorNeutralBackground4Hover:On[12],colorNeutralBackground4Pressed:nK,colorNeutralBackground4Selected:On[10],colorNeutralBackground5:nK,colorNeutralBackground5Hover:On[8],colorNeutralBackground5Pressed:On[2],colorNeutralBackground5Selected:On[6],colorNeutralBackground6:On[20],colorNeutralBackgroundInverted:Bs,colorNeutralBackgroundStatic:On[24],colorNeutralBackgroundAlpha:Ovt[50],colorNeutralBackgroundAlpha2:Nvt[70],colorSubtleBackground:"transparent",colorSubtleBackgroundHover:On[22],colorSubtleBackgroundPressed:On[18],colorSubtleBackgroundSelected:On[20],colorSubtleBackgroundLightAlphaHover:Eke[80],colorSubtleBackgroundLightAlphaPressed:Eke[50],colorSubtleBackgroundLightAlphaSelected:"transparent",colorSubtleBackgroundInverted:"transparent",colorSubtleBackgroundInvertedHover:CE[10],colorSubtleBackgroundInvertedPressed:CE[30],colorSubtleBackgroundInvertedSelected:CE[20],colorTransparentBackground:"transparent",colorTransparentBackgroundHover:"transparent",colorTransparentBackgroundPressed:"transparent",colorTransparentBackgroundSelected:"transparent",colorNeutralBackgroundDisabled:On[8],colorNeutralBackgroundInvertedDisabled:Hy[10],colorNeutralStencil1:On[34],colorNeutralStencil2:On[20],colorNeutralStencil1Alpha:Hy[10],colorNeutralStencil2Alpha:Hy[5],colorBackgroundOverlay:CE[50],colorScrollbarOverlay:Hy[60],colorBrandBackground:t[70],colorBrandBackgroundHover:t[80],colorBrandBackgroundPressed:t[40],colorBrandBackgroundSelected:t[60],colorCompoundBrandBackground:t[100],colorCompoundBrandBackgroundHover:t[110],colorCompoundBrandBackgroundPressed:t[90],colorBrandBackgroundStatic:t[80],colorBrandBackground2:t[20],colorBrandBackground2Hover:t[40],colorBrandBackground2Pressed:t[10],colorBrandBackground3Static:t[60],colorBrandBackground4Static:t[40],colorBrandBackgroundInverted:Bs,colorBrandBackgroundInvertedHover:t[160],colorBrandBackgroundInvertedPressed:t[140],colorBrandBackgroundInvertedSelected:t[150],colorNeutralCardBackground:On[20],colorNeutralCardBackgroundHover:On[24],colorNeutralCardBackgroundPressed:On[18],colorNeutralCardBackgroundSelected:On[22],colorNeutralCardBackgroundDisabled:On[8],colorNeutralStrokeAccessible:On[68],colorNeutralStrokeAccessibleHover:On[74],colorNeutralStrokeAccessiblePressed:On[70],colorNeutralStrokeAccessibleSelected:t[100],colorNeutralStroke1:On[40],colorNeutralStroke1Hover:On[46],colorNeutralStroke1Pressed:On[42],colorNeutralStroke1Selected:On[44],colorNeutralStroke2:On[32],colorNeutralStroke3:On[24],colorNeutralStrokeSubtle:On[4],colorNeutralStrokeOnBrand:On[16],colorNeutralStrokeOnBrand2:Bs,colorNeutralStrokeOnBrand2Hover:Bs,colorNeutralStrokeOnBrand2Pressed:Bs,colorNeutralStrokeOnBrand2Selected:Bs,colorBrandStroke1:t[100],colorBrandStroke2:t[50],colorBrandStroke2Hover:t[50],colorBrandStroke2Pressed:t[30],colorBrandStroke2Contrast:t[50],colorCompoundBrandStroke:t[100],colorCompoundBrandStrokeHover:t[110],colorCompoundBrandStrokePressed:t[90],colorNeutralStrokeDisabled:On[26],colorNeutralStrokeInvertedDisabled:Hy[40],colorTransparentStroke:"transparent",colorTransparentStrokeInteractive:"transparent",colorTransparentStrokeDisabled:"transparent",colorNeutralStrokeAlpha:Hy[10],colorNeutralStrokeAlpha2:Hy[20],colorStrokeFocus1:nK,colorStrokeFocus2:Bs,colorNeutralShadowAmbient:"rgba(0,0,0,0.24)",colorNeutralShadowKey:"rgba(0,0,0,0.28)",colorNeutralShadowAmbientLighter:"rgba(0,0,0,0.12)",colorNeutralShadowKeyLighter:"rgba(0,0,0,0.14)",colorNeutralShadowAmbientDarker:"rgba(0,0,0,0.40)",colorNeutralShadowKeyDarker:"rgba(0,0,0,0.48)",colorBrandShadowAmbient:"rgba(0,0,0,0.30)",colorBrandShadowKey:"rgba(0,0,0,0.25)"}),Cyt=(t=>{const e=Tyt(t);return{...Rke,...Dke,...Lke,...Nke,...Oke,...Fke,...xke,...Bke,...Pke,...Mke,...e,...byt,...zL,...aK(e.colorNeutralShadowAmbient,e.colorNeutralShadowKey),...aK(e.colorBrandShadowAmbient,e.colorBrandShadowKey,"Brand")}})(Uke);function rK({outlineWidth:t,outlineOffset:e},i){const r=e?.[i]||e;return e?`calc(0px - ${t} - ${r})`:`calc(${t} * -1)`}const _yt=t=>{const{outlineRadius:e,outlineColor:i,outlineWidth:r}=t;return{...Wo.borderColor("transparent"),"@media (forced-colors: active)":{"::after":{...Wo.borderColor("Highlight")}},"::after":{content:'""',position:"absolute",pointerEvents:"none",zIndex:1,border:`${r} solid ${i}`,borderRadius:e,top:rK(t,"top"),right:rK(t,"right"),bottom:rK(t,"bottom"),left:rK(t,"left")}}},Eyt=({enableOutline:t=!1,selector:e=C5.selector,customizeSelector:i,style:r=C5.style}=C5)=>({":focus":{outlineStyle:t?void 0:"none"},":focus-visible":{outlineStyle:t?void 0:"none"},...Dvt(_yt({outlineColor:cs.colorStrokeFocus2,outlineRadius:cs.borderRadiusMedium,outlineWidth:"2px",...r}),{selector:e,customizeSelector:i})}),bse={root:"fui-FluentProvider"},Ayt=fwe({root:{sj55zd:"f19n0e5",De3pzq:"fxugw4r",fsow6f:["f1o700av","fes3tcz"],Bahqtrf:"fk6fouc",Be2twd7:"fkhj508",Bhrd7zp:"figsok6",Bg96gwp:"f1i3iumi"}},{d:[".f19n0e5{color:var(--colorNeutralForeground1);}",".fxugw4r{background-color:var(--colorNeutralBackground1);}",".f1o700av{text-align:left;}",".fes3tcz{text-align:right;}",".fk6fouc{font-family:var(--fontFamilyBase);}",".fkhj508{font-size:var(--fontSizeBase300);}",".figsok6{font-weight:var(--fontWeightRegular);}",".f1i3iumi{line-height:var(--lineHeightBase300);}"]}),Iyt=t=>{"use no memo";const e=wH(),i=Ayt({dir:t.dir,renderer:e});return t.root.className=ea(bse.root,t.themeClassName,i.root,t.root.className),t},wyt=vM.useInsertionEffect?vM.useInsertionEffect:fA,kyt=(t,e)=>{if(!t?.head)return;const i=t.createElement("style");return Object.keys(e).forEach(r=>{i.setAttribute(r,e[r])}),t.head.appendChild(i),i},Ryt=(t,e)=>{const i=t.sheet;i?(i.cssRules.length>0&&i.deleteRule(0),i.insertRule(e,0)):process.env.NODE_ENV!=="production"&&console.error("FluentProvider: No sheet available on styleTag, styles will not be inserted into DOM.")},Myt=t=>{"use no memo";const{targetDocument:e,theme:i,rendererAttributes:r}=t,o=$.useRef(),l=NL(bse.root),d=r,h=$.useMemo(()=>emt(`.${l}`,i),[i,l]);return process.env.NODE_ENV!=="production"&&$.useMemo(()=>{if(e){const p=`.${bse.root}.${l}`,g=e.querySelectorAll(p),y=e.querySelector(`${p} > style[id="${l}"]`)!==null?1:0;g.length>y&&console.error(["@fluentui/react-provider: There are conflicting ids in your DOM.","Please make sure that you configured your application properly.",`
`,`
`,"Configuration guide: https://aka.ms/fluentui-conflicting-ids"].join(" "))}},[]),Pyt(e,l),wyt(()=>{const p=e?.getElementById(l);return p?o.current=p:(o.current=kyt(e,{...d,id:l}),o.current&&Ryt(o.current,h)),()=>{var g;(g=o.current)===null||g===void 0||g.remove()}},[l,e,h,d]),{styleTagId:l,rule:h}};function Pyt(t,e){$.useState(()=>{if(!t)return;const i=t.getElementById(e);i&&t.head.append(i)})}const Dyt={},Lyt={},Oyt=(t,e)=>{"use no memo";const i=Ov(),r=Nyt(),o=Mwe(),l=$.useContext(Woe)||Dyt,{applyStylesToPortals:d=!0,customStyleHooks_unstable:h,dir:p=i.dir,targetDocument:g=i.targetDocument,theme:f,overrides_unstable:y={}}=t,T=Tse(r,f),C=Tse(o,y),E=Tse(l,h),I=wH();var w;const{styleTagId:D,rule:F}=Myt({theme:T,targetDocument:g,rendererAttributes:(w=I.styleElementAttributes)!==null&&w!==void 0?w:Lyt});return process.env.NODE_ENV!=="production"&&$.useEffect(()=>{T===void 0&&console.warn(['@fluentui/react-provider: FluentProvider does not have your "theme" defined.',"Make sure that your top-level FluentProvider has set a `theme` prop or you're setting the theme in your child FluentProvider."].join(" "))},[]),{applyStylesToPortals:d,customStyleHooks_unstable:E,dir:p,targetDocument:g,theme:T,overrides_unstable:C,themeClassName:D,components:{root:"div"},root:Bl(_p("div",{...t,dir:p,ref:kC(e,Tke({targetDocument:g}))}),{elementType:"div"}),serverStyleProps:{cssRule:F,attributes:{...I.styleElementAttributes,id:D}}}};function Tse(t,e){return t&&e?{...t,...e}:t||e}function Nyt(){return $.useContext(Iwe)}function xyt(t){const{applyStylesToPortals:e,customStyleHooks_unstable:i,dir:r,root:o,targetDocument:l,theme:d,themeClassName:h,overrides_unstable:p}=t,g=$.useMemo(()=>({dir:r,targetDocument:l}),[r,l]),[f]=$.useState(()=>({})),y=$.useMemo(()=>({textDirection:r}),[r]);return{customStyleHooks_unstable:i,overrides_unstable:p,provider:g,textDirection:r,iconDirection:y,tooltip:f,theme:d,themeClassName:e?o.className:h}}const E5=$.forwardRef((t,e)=>{const i=Oyt(t,e);Iyt(i);const r=xyt(i);return vft(i,r)});E5.displayName="FluentProvider";var oK={exports:{}},Cse={};/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */var Vke;function Byt(){return Vke||(Vke=1,function(t){function e(te,Se){var ce=te.length;te.push(Se);e:for(;0<ce;){var X=ce-1>>>1,ve=te[X];if(0<o(ve,Se))te[X]=Se,te[ce]=ve,ce=X;else break e}}function i(te){return te.length===0?null:te[0]}function r(te){if(te.length===0)return null;var Se=te[0],ce=te.pop();if(ce!==Se){te[0]=ce;e:for(var X=0,ve=te.length,Te=ve>>>1;X<Te;){var Be=2*(X+1)-1,qe=te[Be],Ge=Be+1,tt=te[Ge];if(0>o(qe,ce))Ge<ve&&0>o(tt,qe)?(te[X]=tt,te[Ge]=ce,X=Ge):(te[X]=qe,te[Be]=ce,X=Be);else if(Ge<ve&&0>o(tt,ce))te[X]=tt,te[Ge]=ce,X=Ge;else break e}}return Se}function o(te,Se){var ce=te.sortIndex-Se.sortIndex;return ce!==0?ce:te.id-Se.id}if(typeof performance=="object"&&typeof performance.now=="function"){var l=performance;t.unstable_now=function(){return l.now()}}else{var d=Date,h=d.now();t.unstable_now=function(){return d.now()-h}}var p=[],g=[],f=1,y=null,T=3,C=!1,E=!1,I=!1,w=typeof setTimeout=="function"?setTimeout:null,D=typeof clearTimeout=="function"?clearTimeout:null,F=typeof setImmediate<"u"?setImmediate:null;typeof navigator<"u"&&navigator.scheduling!==void 0&&navigator.scheduling.isInputPending!==void 0&&navigator.scheduling.isInputPending.bind(navigator.scheduling);function x(te){for(var Se=i(g);Se!==null;){if(Se.callback===null)r(g);else if(Se.startTime<=te)r(g),Se.sortIndex=Se.expirationTime,e(p,Se);else break;Se=i(g)}}function B(te){if(I=!1,x(te),!E)if(i(p)!==null)E=!0,Le(L);else{var Se=i(g);Se!==null&&pe(B,Se.startTime-te)}}function L(te,Se){E=!1,I&&(I=!1,D(j),j=-1),C=!0;var ce=T;try{for(x(Se),y=i(p);y!==null&&(!(y.expirationTime>Se)||te&&!re());){var X=y.callback;if(typeof X=="function"){y.callback=null,T=y.priorityLevel;var ve=X(y.expirationTime<=Se);Se=t.unstable_now(),typeof ve=="function"?y.callback=ve:y===i(p)&&r(p),x(Se)}else r(p);y=i(p)}if(y!==null)var Te=!0;else{var Be=i(g);Be!==null&&pe(B,Be.startTime-Se),Te=!1}return Te}finally{y=null,T=ce,C=!1}}var z=!1,H=null,j=-1,J=5,Z=-1;function re(){return!(t.unstable_now()-Z<J)}function ne(){if(H!==null){var te=t.unstable_now();Z=te;var Se=!0;try{Se=H(!0,te)}finally{Se?le():(z=!1,H=null)}}else z=!1}var le;if(typeof F=="function")le=function(){F(ne)};else if(typeof MessageChannel<"u"){var he=new MessageChannel,Me=he.port2;he.port1.onmessage=ne,le=function(){Me.postMessage(null)}}else le=function(){w(ne,0)};function Le(te){H=te,z||(z=!0,le())}function pe(te,Se){j=w(function(){te(t.unstable_now())},Se)}t.unstable_IdlePriority=5,t.unstable_ImmediatePriority=1,t.unstable_LowPriority=4,t.unstable_NormalPriority=3,t.unstable_Profiling=null,t.unstable_UserBlockingPriority=2,t.unstable_cancelCallback=function(te){te.callback=null},t.unstable_continueExecution=function(){E||C||(E=!0,Le(L))},t.unstable_forceFrameRate=function(te){0>te||125<te?console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"):J=0<te?Math.floor(1e3/te):5},t.unstable_getCurrentPriorityLevel=function(){return T},t.unstable_getFirstCallbackNode=function(){return i(p)},t.unstable_next=function(te){switch(T){case 1:case 2:case 3:var Se=3;break;default:Se=T}var ce=T;T=Se;try{return te()}finally{T=ce}},t.unstable_pauseExecution=function(){},t.unstable_requestPaint=function(){},t.unstable_runWithPriority=function(te,Se){switch(te){case 1:case 2:case 3:case 4:case 5:break;default:te=3}var ce=T;T=te;try{return Se()}finally{T=ce}},t.unstable_scheduleCallback=function(te,Se,ce){var X=t.unstable_now();switch(typeof ce=="object"&&ce!==null?(ce=ce.delay,ce=typeof ce=="number"&&0<ce?X+ce:X):ce=X,te){case 1:var ve=-1;break;case 2:ve=250;break;case 5:ve=1073741823;break;case 4:ve=1e4;break;default:ve=5e3}return ve=ce+ve,te={id:f++,callback:Se,priorityLevel:te,startTime:ce,expirationTime:ve,sortIndex:-1},ce>X?(te.sortIndex=ce,e(g,te),i(p)===null&&te===i(g)&&(I?(D(j),j=-1):I=!0,pe(B,ce-X))):(te.sortIndex=ve,e(p,te),E||C||(E=!0,Le(L))),te},t.unstable_shouldYield=re,t.unstable_wrapCallback=function(te){var Se=T;return function(){var ce=T;T=Se;try{return te.apply(this,arguments)}finally{T=ce}}}}(Cse)),Cse}var _se={};/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */var $ke;function Fyt(){return $ke||($ke=1,function(t){process.env.NODE_ENV!=="production"&&function(){typeof __REACT_DEVTOOLS_GLOBAL_HOOK__<"u"&&typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart=="function"&&__REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error);var e=!1,i=5;function r(Ye,Fe){var St=Ye.length;Ye.push(Fe),d(Ye,Fe,St)}function o(Ye){return Ye.length===0?null:Ye[0]}function l(Ye){if(Ye.length===0)return null;var Fe=Ye[0],St=Ye.pop();return St!==Fe&&(Ye[0]=St,h(Ye,St,0)),Fe}function d(Ye,Fe,St){for(var Wt=St;Wt>0;){var Ii=Wt-1>>>1,en=Ye[Ii];if(p(en,Fe)>0)Ye[Ii]=Fe,Ye[Wt]=en,Wt=Ii;else return}}function h(Ye,Fe,St){for(var Wt=St,Ii=Ye.length,en=Ii>>>1;Wt<en;){var sn=(Wt+1)*2-1,Qi=Ye[sn],qt=sn+1,ri=Ye[qt];if(p(Qi,Fe)<0)qt<Ii&&p(ri,Qi)<0?(Ye[Wt]=ri,Ye[qt]=Fe,Wt=qt):(Ye[Wt]=Qi,Ye[sn]=Fe,Wt=sn);else if(qt<Ii&&p(ri,Fe)<0)Ye[Wt]=ri,Ye[qt]=Fe,Wt=qt;else return}}function p(Ye,Fe){var St=Ye.sortIndex-Fe.sortIndex;return St!==0?St:Ye.id-Fe.id}var g=1,f=2,y=3,T=4,C=5;function E(Ye,Fe){}var I=typeof performance=="object"&&typeof performance.now=="function";if(I){var w=performance;t.unstable_now=function(){return w.now()}}else{var D=Date,F=D.now();t.unstable_now=function(){return D.now()-F}}var x=1073741823,B=-1,L=250,z=5e3,H=1e4,j=x,J=[],Z=[],re=1,ne=null,le=y,he=!1,Me=!1,Le=!1,pe=typeof setTimeout=="function"?setTimeout:null,te=typeof clearTimeout=="function"?clearTimeout:null,Se=typeof setImmediate<"u"?setImmediate:null;typeof navigator<"u"&&navigator.scheduling!==void 0&&navigator.scheduling.isInputPending!==void 0&&navigator.scheduling.isInputPending.bind(navigator.scheduling);function ce(Ye){for(var Fe=o(Z);Fe!==null;){if(Fe.callback===null)l(Z);else if(Fe.startTime<=Ye)l(Z),Fe.sortIndex=Fe.expirationTime,r(J,Fe);else return;Fe=o(Z)}}function X(Ye){if(Le=!1,ce(Ye),!Me)if(o(J)!==null)Me=!0,kt(ve);else{var Fe=o(Z);Fe!==null&&je(X,Fe.startTime-Ye)}}function ve(Ye,Fe){Me=!1,Le&&(Le=!1,Ae()),he=!0;var St=le;try{var Wt;if(!e)return Te(Ye,Fe)}finally{ne=null,le=St,he=!1}}function Te(Ye,Fe){var St=Fe;for(ce(St),ne=o(J);ne!==null&&!(ne.expirationTime>St&&(!Ye||Ht()));){var Wt=ne.callback;if(typeof Wt=="function"){ne.callback=null,le=ne.priorityLevel;var Ii=ne.expirationTime<=St,en=Wt(Ii);St=t.unstable_now(),typeof en=="function"?ne.callback=en:ne===o(J)&&l(J),ce(St)}else l(J);ne=o(J)}if(ne!==null)return!0;var sn=o(Z);return sn!==null&&je(X,sn.startTime-St),!1}function Be(Ye,Fe){switch(Ye){case g:case f:case y:case T:case C:break;default:Ye=y}var St=le;le=Ye;try{return Fe()}finally{le=St}}function qe(Ye){var Fe;switch(le){case g:case f:case y:Fe=y;break;default:Fe=le;break}var St=le;le=Fe;try{return Ye()}finally{le=St}}function Ge(Ye){var Fe=le;return function(){var St=le;le=Fe;try{return Ye.apply(this,arguments)}finally{le=St}}}function tt(Ye,Fe,St){var Wt=t.unstable_now(),Ii;if(typeof St=="object"&&St!==null){var en=St.delay;typeof en=="number"&&en>0?Ii=Wt+en:Ii=Wt}else Ii=Wt;var sn;switch(Ye){case g:sn=B;break;case f:sn=L;break;case C:sn=j;break;case T:sn=H;break;case y:default:sn=z;break}var Qi=Ii+sn,qt={id:re++,callback:Fe,priorityLevel:Ye,startTime:Ii,expirationTime:Qi,sortIndex:-1};return Ii>Wt?(qt.sortIndex=Ii,r(Z,qt),o(J)===null&&qt===o(Z)&&(Le?Ae():Le=!0,je(X,Ii-Wt))):(qt.sortIndex=Qi,r(J,qt),!Me&&!he&&(Me=!0,kt(ve))),qt}function ct(){}function Mt(){!Me&&!he&&(Me=!0,kt(ve))}function ht(){return o(J)}function vt(Ye){Ye.callback=null}function Pt(){return le}var ni=!1,Zt=null,it=-1,Ke=i,ot=-1;function Ht(){var Ye=t.unstable_now()-ot;return!(Ye<Ke)}function jt(){}function Nt(Ye){if(Ye<0||Ye>125){console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");return}Ye>0?Ke=Math.floor(1e3/Ye):Ke=i}var Vt=function(){if(Zt!==null){var Ye=t.unstable_now();ot=Ye;var Fe=!0,St=!0;try{St=Zt(Fe,Ye)}finally{St?$t():(ni=!1,Zt=null)}}else ni=!1},$t;if(typeof Se=="function")$t=function(){Se(Vt)};else if(typeof MessageChannel<"u"){var dt=new MessageChannel,yt=dt.port2;dt.port1.onmessage=Vt,$t=function(){yt.postMessage(null)}}else $t=function(){pe(Vt,0)};function kt(Ye){Zt=Ye,ni||(ni=!0,$t())}function je(Ye,Fe){it=pe(function(){Ye(t.unstable_now())},Fe)}function Ae(){te(it),it=-1}var xe=jt,gt=null;t.unstable_IdlePriority=C,t.unstable_ImmediatePriority=g,t.unstable_LowPriority=T,t.unstable_NormalPriority=y,t.unstable_Profiling=gt,t.unstable_UserBlockingPriority=f,t.unstable_cancelCallback=vt,t.unstable_continueExecution=Mt,t.unstable_forceFrameRate=Nt,t.unstable_getCurrentPriorityLevel=Pt,t.unstable_getFirstCallbackNode=ht,t.unstable_next=qe,t.unstable_pauseExecution=ct,t.unstable_requestPaint=xe,t.unstable_runWithPriority=Be,t.unstable_scheduleCallback=tt,t.unstable_shouldYield=Ht,t.unstable_wrapCallback=Ge,typeof __REACT_DEVTOOLS_GLOBAL_HOOK__<"u"&&typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop=="function"&&__REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error)}()}(_se)),_se}var Hke;function Uyt(){return Hke||(Hke=1,process.env.NODE_ENV==="production"?oK.exports=Byt():oK.exports=Fyt()),oK.exports}var jke=Uyt();const zyt=t=>{const e=i=>{const r=$.useRef(i.value),o=$.useRef(0),l=$.useRef();return l.current||(l.current={value:r,version:o,listeners:[]}),fA(()=>{r.current=i.value,o.current+=1,jke.unstable_runWithPriority(jke.unstable_NormalPriority,()=>{l.current.listeners.forEach(d=>{d([o.current,i.value])})})},[i.value]),$.createElement(t,{value:l.current},i.children)};return process.env.NODE_ENV!=="production"&&(e.displayName="ContextSelector.Provider"),e},BH=t=>{const e=$.createContext({value:{current:t},version:{current:-1},listeners:[]});return e.Provider=zyt(e.Provider),delete e.Consumer,e},sK=(t,e)=>{const i=$.useContext(t),{value:{current:r},version:{current:o},listeners:l}=i,d=e(r),[h,p]=$.useState([r,d]),g=y=>{p(T=>{if(!y)return[r,d];if(y[0]<=o)return Object.is(T[1],d)?T:[r,d];try{if(Object.is(T[0],y[1]))return T;const C=e(y[1]);return Object.is(T[1],C)?T:[y[1],C]}catch{}return[T[0],T[1]]})};Object.is(h[1],d)||g(void 0);const f=Fl(g);return fA(()=>(l.push(f),()=>{const y=l.indexOf(f);l.splice(y,1)}),[f,l]),h[1]};function Gke(t){const e=$.useContext(t);return e.version?e.version.current!==-1:!1}const FH="Enter",UH=" ",Vyt="Tab",$yt="ArrowDown",qke="ArrowLeft",Wke="ArrowRight",Kke="Escape";function Ese(t,e){const{disabled:i,disabledFocusable:r=!1,["aria-disabled"]:o,onClick:l,onKeyDown:d,onKeyUp:h,...p}=e??{},g=typeof o=="string"?o==="true":o,f=i||r||g,y=Fl(E=>{f?(E.preventDefault(),E.stopPropagation()):l?.(E)}),T=Fl(E=>{if(d?.(E),E.isDefaultPrevented())return;const I=E.key;if(f&&(I===FH||I===UH)){E.preventDefault(),E.stopPropagation();return}if(I===UH){E.preventDefault();return}else I===FH&&(E.preventDefault(),E.currentTarget.click())}),C=Fl(E=>{if(h?.(E),E.isDefaultPrevented())return;const I=E.key;if(f&&(I===FH||I===UH)){E.preventDefault(),E.stopPropagation();return}I===UH&&(E.preventDefault(),E.currentTarget.click())});if(t==="button"||t===void 0)return{...p,disabled:i&&!r,"aria-disabled":r?!0:g,onClick:r?void 0:y,onKeyUp:r?void 0:h,onKeyDown:r?void 0:d};{const E=!!p.href;let I=E?void 0:"button";!I&&f&&(I="link");const w={role:I,tabIndex:r||!E&&!i?0:void 0,...p,onClick:y,onKeyUp:C,onKeyDown:T,"aria-disabled":f};return t==="a"&&f&&(w.href=void 0),w}}const Hyt=uo({root:{mc9l5x:"f1w7gpdv",Bg96gwp:"fez10in",ycbfsm:"fg4l7m0"},rtl:{Bz10aip:"f13rod7r"}},{d:[".f1w7gpdv{display:inline;}",".fez10in{line-height:0;}",".f13rod7r{-webkit-transform:scaleX(-1);-moz-transform:scaleX(-1);-ms-transform:scaleX(-1);transform:scaleX(-1);}"],t:["@media (forced-colors: active){.fg4l7m0{forced-color-adjust:auto;}}"]}),jyt=(t,e)=>{const{title:i,primaryFill:r="currentColor",...o}=t,l={...o,title:void 0,fill:r},d=Hyt(),h=fft();return l.className=ea(d.root,e?.flipInRtl&&h?.textDirection==="rtl"&&d.rtl,l.className),i&&(l["aria-label"]=i),!l["aria-label"]&&!l["aria-labelledby"]?l["aria-hidden"]=!0:l.role="img",l},Mn=(t,e,i,r)=>{const o=e==="1em"?"20":e,l=$.forwardRef((d,h)=>{const p={...jyt(d,{flipInRtl:r?.flipInRtl}),ref:h,width:e,height:e,viewBox:`0 0 ${o} ${o}`,xmlns:"http://www.w3.org/2000/svg"};return $.createElement("svg",p,...i.map(g=>$.createElement("path",{d:g,fill:p.fill})))});return l.displayName=t,l},Gyt=Mn("AlertUrgentFilled","1em",["M2.47 12.25a5.16 5.16 0 0 1 9.42-4.2l1.22 2.75 1.67 1.62c.38.37.27 1-.22 1.22l-9.73 4.33a.75.75 0 0 1-1.05-.65L3.68 15l-1.21-2.75Zm6.36 5.09a1.49 1.49 0 0 0 2.68-1.2l-2.68 1.2Zm3.26-12.61a.5.5 0 0 1 .69-.14 6.17 6.17 0 0 1 2.91 4.91.5.5 0 1 1-1 0c0-.13 0-.26-.02-.39a5.17 5.17 0 0 0-2.45-3.69.5.5 0 0 1-.13-.7Zm.49-2.49a.5.5 0 0 1 .68-.16c2.46 1.5 4.58 3.8 4.74 7.9a.5.5 0 0 1-1 .04c-.14-3.68-2-5.7-4.26-7.09a.5.5 0 0 1-.16-.69Z"]),qyt=Mn("BoardFilled","1em",["M9.5 3v4H3V6a3 3 0 0 1 3-3h3.5Zm1 0v9H17V6a3 3 0 0 0-3-3h-3.5ZM17 13h-6.5v4H14a3 3 0 0 0 3-3v-1Zm-7.5 4V8H3v6a3 3 0 0 0 3 3h3.5Z"]),Wyt=Mn("BoardRegular","1em",["M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm3-2a2 2 0 0 0-2 2v1.06L9.5 7V4H6Zm4.5 0v8H16V6a2 2 0 0 0-2-2h-3.5Zm5.5 9h-5.5v3H14a2 2 0 0 0 2-2v-1Zm-6.5 3V8L4 8.06V14c0 1.1.9 2 2 2h3.5Z"]),Kyt=Mn("ChatFilled","1em",["M10 2a8 8 0 1 1-3.61 15.14l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a7.95 7.95 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8Zm.5 9H7.41a.5.5 0 0 0 0 1H10.59a.5.5 0 0 0 0-1h-.09Zm2-3H7.41a.5.5 0 0 0 0 1h5.18a.5.5 0 0 0 0-1h-.09Z"]),Jyt=Mn("ChatRegular","1em",["M10 2a8 8 0 1 1-3.61 15.14l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a7.95 7.95 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8Zm0 1a7 7 0 0 0-6.1 10.42.5.5 0 0 1 .06.28l-.02.1-.75 3.01 3.02-.75a.5.5 0 0 1 .19-.01l.09.02.09.04A7 7 0 1 0 10 3Zm.5 8a.5.5 0 0 1 .09 1H7.5a.5.5 0 0 1-.09-1h3.09Zm2-3a.5.5 0 0 1 .09 1H7.5a.5.5 0 0 1-.09-1h5.09Z"]),Yyt=Mn("CheckmarkCircleFilled","1em",["M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16Zm3.36 5.65a.5.5 0 0 0-.64-.06l-.07.06L9 11.3 7.35 9.65l-.07-.06a.5.5 0 0 0-.7.7l.07.07 2 2 .07.06c.17.11.4.11.56 0l.07-.06 4-4 .07-.08a.5.5 0 0 0-.06-.63Z"]),Qyt=Mn("ChevronLeftFilled","1em",["M12.27 15.8a.75.75 0 0 1-1.06-.03l-5-5.25a.75.75 0 0 1 0-1.04l5-5.25a.75.75 0 1 1 1.08 1.04L7.8 10l4.5 4.73c.29.3.28.78-.02 1.06Z"]),Zyt=Mn("ChevronLeftRegular","1em",["M12.35 15.85a.5.5 0 0 1-.7 0L6.16 10.4a.55.55 0 0 1 0-.78l5.49-5.46a.5.5 0 1 1 .7.7L7.2 10l5.16 5.15c.2.2.2.5 0 .7Z"]),Xyt=Mn("ChevronRightFilled","1em",["M7.73 4.2a.75.75 0 0 1 1.06.03l5 5.25c.28.3.28.75 0 1.04l-5 5.25a.75.75 0 1 1-1.08-1.04L12.2 10l-4.5-4.73a.75.75 0 0 1 .02-1.06Z"]),eSt=Mn("ChevronRightRegular","1em",["M7.65 4.15c.2-.2.5-.2.7 0l5.49 5.46c.21.22.21.57 0 .78l-5.49 5.46a.5.5 0 0 1-.7-.7L12.8 10 7.65 4.85a.5.5 0 0 1 0-.7Z"]),Jke=Mn("CircleFilled","1em",["M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16Z"]),tSt=Mn("DismissRegular","1em",["m4.09 4.22.06-.07a.5.5 0 0 1 .63-.06l.07.06L10 9.29l5.15-5.14a.5.5 0 0 1 .63-.06l.07.06c.18.17.2.44.06.63l-.06.07L10.71 10l5.14 5.15c.18.17.2.44.06.63l-.06.07a.5.5 0 0 1-.63.06l-.07-.06L10 10.71l-5.15 5.14a.5.5 0 0 1-.63.06l-.07-.06a.5.5 0 0 1-.06-.63l.06-.07L9.29 10 4.15 4.85a.5.5 0 0 1-.06-.63l.06-.07-.06.07Z"]),iSt=Mn("DismissCircleFilled","1em",["M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16ZM7.8 7.11a.5.5 0 0 0-.63.06l-.06.07a.5.5 0 0 0 .06.64L9.3 10l-2.12 2.12-.06.07a.5.5 0 0 0 .06.64l.07.06c.2.13.47.11.64-.06L10 10.7l2.12 2.12.07.06c.2.13.46.11.64-.06l.06-.07a.5.5 0 0 0-.06-.64L10.7 10l2.12-2.12.06-.07a.5.5 0 0 0-.06-.64l-.07-.06a.5.5 0 0 0-.64.06L10 9.3 7.88 7.17l-.07-.06Z"]),nSt=Mn("ImportantFilled","1em",["M10 2a3 3 0 0 0-3 3c0 2.23.79 5.2 1.22 6.69.24.79.97 1.31 1.78 1.31s1.54-.52 1.78-1.31C12.2 10.2 13 7.25 13 5a3 3 0 0 0-3-3Zm0 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"]),aSt=Mn("InfoFilled","1em",["M18 10a8 8 0 1 0-16 0 8 8 0 0 0 16 0ZM9.5 8.91a.5.5 0 0 1 1 0V13.6a.5.5 0 0 1-1 0V8.9Zm-.25-2.16a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0Z"]),rSt=Mn("MentionFilled","1em",["M10 1.75c4.56 0 8.25 3.7 8.25 8.25 0 2.83-1.22 4.75-3.25 4.75-1.2 0-2.12-.68-2.67-1.82a3.5 3.5 0 0 1-2.83 1.32c-2.3 0-3.75-1.82-3.75-4.25 0-2.46 1.41-4.25 3.75-4.25.9 0 1.66.26 2.25.72a.75.75 0 0 1 1.49-.08l.01.11V10c0 2.1.73 3.25 1.75 3.25s1.75-1.15 1.75-3.25a6.75 6.75 0 1 0-4.45 6.35.75.75 0 0 1 .5 1.4A8.23 8.23 0 0 1 1.76 10c0-4.56 3.7-8.25 8.25-8.25Zm-.5 5.5C8.08 7.25 7.25 8.3 7.25 10c0 1.67.87 2.75 2.25 2.75s2.25-1.08 2.25-2.75c0-1.7-.83-2.75-2.25-2.75Z"]),oSt=Mn("PeopleFilled","1em",["M6.75 10a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5Zm5.69 5.14c.53.22 1.2.36 2.06.36 4 0 4-3 4-3 0-.83-.67-1.5-1.5-1.5h-4.63c.4.48.63 1.09.63 1.75v.36a2.94 2.94 0 0 1-.02.25 4.62 4.62 0 0 1-.54 1.78ZM17 7.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0ZM1.5 13c0-1.1.9-2 2-2H10a2 2 0 0 1 2 2s0 4-5.25 4-5.25-4-5.25-4Zm11.5.1v.07Z"]),sSt=Mn("PollHorizontalFilled","1em",["M18 10a2 2 0 0 0-2-2H4a2 2 0 1 0 0 4h12a2 2 0 0 0 2-2Zm-8-6a2 2 0 0 0-2-2H4a2 2 0 1 0 0 4h4a2 2 0 0 0 2-2Zm4 12a2 2 0 0 0-2-2H4a2 2 0 1 0 0 4h8a2 2 0 0 0 2-2Z"]),lSt=Mn("PollHorizontalRegular","1em",["M16 8a2 2 0 1 1 0 4H4a2 2 0 1 1 0-4h12Zm1 2a1 1 0 0 0-1-1H4a1 1 0 0 0 0 2h12a1 1 0 0 0 1-1ZM8 2a2 2 0 1 1 0 4H4a2 2 0 1 1 0-4h4Zm1 2a1 1 0 0 0-1-1H4a1 1 0 0 0 0 2h4a1 1 0 0 0 1-1Zm5 12a2 2 0 0 0-2-2H4a2 2 0 1 0 0 4h8a2 2 0 0 0 2-2Zm-2-1a1 1 0 1 1 0 2H4a1 1 0 1 1 0-2h8Z"]),cSt=Mn("WarningFilled","1em",["M8.68 2.79a1.5 1.5 0 0 1 2.64 0l6.5 12A1.5 1.5 0 0 1 16.5 17h-13a1.5 1.5 0 0 1-1.32-2.21l6.5-12ZM10.5 7.5a.5.5 0 0 0-1 0v4a.5.5 0 0 0 1 0v-4Zm.25 6.25a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Z"]),dSt=Mn("ArrowClockwise16Regular","16",["M3 8a5 5 0 0 1 9-3h-2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-1 0v1.53A5.99 5.99 0 0 0 2 8a6 6 0 0 0 11.98.54.5.5 0 0 0-1-.08A5 5 0 0 1 3 8Z"]),uSt=Mn("Backspace20Regular","20",["M9.15 7.15c.2-.2.5-.2.7 0L12 9.29l2.15-2.14a.5.5 0 0 1 .7.7L12.71 10l2.14 2.15a.5.5 0 0 1-.7.7L12 10.71l-2.15 2.14a.5.5 0 0 1-.7-.7L11.29 10 9.15 7.85a.5.5 0 0 1 0-.7ZM6.59 4.66A2.5 2.5 0 0 1 8.29 4h7.21A2.5 2.5 0 0 1 18 6.5v7a2.5 2.5 0 0 1-2.5 2.5H8.28a2.5 2.5 0 0 1-1.7-.66l-3.78-3.5a2.5 2.5 0 0 1 0-3.68l3.79-3.5Zm1.7.34c-.38 0-.75.14-1.03.4L3.48 8.9a1.5 1.5 0 0 0 0 2.2l3.78 3.5c.28.26.65.4 1.02.4h7.22c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5H8.28Z"]),hSt=Mn("BoardSplit20Regular","20",["M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm1 4v4c0 1.1.9 2 2 2h5v-6H4Zm7-1V4H6a2 2 0 0 0-2 2v3h7Zm1 7h2a2 2 0 0 0 2-2v-1h-4v3Zm4-9V6a2 2 0 0 0-2-2h-2v3h4Zm0 1h-4v4h4V8Z"]),pSt=Mn("Call20Filled","20",["M6.99 2.07A2 2 0 0 1 9.3 3l.08.15.66 1.47a2.5 2.5 0 0 1-.44 2.72l-.13.13-1.05.98c-.19.17-.04.86.64 2.04.6 1.06 1.1 1.56 1.35 1.58h.1l2.05-.64a1.5 1.5 0 0 1 1.56.45l.1.11 1.35 1.88a2 2 0 0 1-.13 2.5l-.12.12-.54.52a3.5 3.5 0 0 1-3.72.7c-1.93-.78-3.69-2.56-5.29-5.33S3.52 7.2 3.82 5.14a3.5 3.5 0 0 1 2.26-2.8l.19-.06.72-.21Z"]),gSt=Mn("Call20Regular","20",["m6.99 2.07-.72.21a3.5 3.5 0 0 0-2.45 2.86c-.3 2.06.36 4.48 1.96 7.25 1.6 2.77 3.36 4.55 5.3 5.33a3.5 3.5 0 0 0 3.7-.7l.55-.52a2 2 0 0 0 .25-2.62L14.22 12a1.5 1.5 0 0 0-1.65-.56l-2.05.63-.06.01c-.22.04-.74-.45-1.4-1.58-.67-1.18-.82-1.87-.63-2.04l1.05-.98a2.5 2.5 0 0 0 .57-2.85l-.66-1.47a2 2 0 0 0-2.4-1.1Zm1.49 1.5.66 1.47a1.5 1.5 0 0 1-.35 1.71l-1.04.98c-.67.63-.45 1.71.45 3.27.85 1.47 1.62 2.19 2.45 2.06l.12-.02 2.09-.64a.5.5 0 0 1 .55.19l1.36 1.88a1 1 0 0 1-.13 1.3l-.54.52a2.5 2.5 0 0 1-2.65.5c-1.7-.68-3.3-2.3-4.8-4.9-1.5-2.59-2.1-4.8-1.84-6.61a2.5 2.5 0 0 1 1.75-2.04l.72-.22a1 1 0 0 1 1.2.55Z"]),Ase=Mn("CallEnd20Filled","20",["m17.96 10.94-.16.83c-.15.78-.87 1.3-1.7 1.22l-1.63-.16c-.72-.07-1.25-.59-1.47-1.33-.3-1-.5-1.75-.5-1.75a6.63 6.63 0 0 0-5 0s-.2.75-.5 1.75c-.2.67-.5 1.26-1.2 1.33l-1.63.16c-.81.08-1.6-.43-1.82-1.2l-.25-.84c-.25-.82-.03-1.7.58-2.28C4.1 7.3 6.67 6.51 9.99 6.5c3.33 0 5.6.78 7.16 2.16.66.58.97 1.46.8 2.28Z"]),mSt=Mn("CallMissed20Filled","20",["m17.8 7.77.16-.83c.16-.82-.15-1.7-.8-2.28-1.57-1.38-3.84-2.16-7.17-2.16-3.32 0-5.89.79-7.31 2.17-.6.59-.83 1.46-.58 2.28l.25.83A1.74 1.74 0 0 0 4.17 9l1.63-.16c.7-.07 1-.66 1.2-1.33.3-1 .5-1.75.5-1.75a6.63 6.63 0 0 1 5 0s.2.75.5 1.75c.22.74.75 1.26 1.47 1.33l1.63.16c.83.08 1.55-.44 1.7-1.22ZM9.5 11.5c.28 0 .5.22.5.5v1.5h1a.5.5 0 1 1 0 1H9.5A.5.5 0 0 1 9 14v-2c0-.28.22-.5.5-.5Zm-4 2a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM10 10a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Z"]),fSt=Mn("CallPause20Filled","20",["M3.55 2.44a4.1 4.1 0 0 1 2.99-.32c.5.12.94.45 1.2.9l.9 1.57a2.5 2.5 0 0 1-.84 3.36l-.79.5c-.32.2-.44.52-.37.77.27.9.86 1.9 1.52 2.58.19.2.54.25.9.05l.43-.26a2.5 2.5 0 0 1 3.44.94l.8 1.44c.27.47.31 1.03.12 1.53a3.9 3.9 0 0 1-1.96 2.22c-.9.41-1.94.4-2.88-.24-1.5-1-3.3-2.68-4.94-5.48a13.27 13.27 0 0 1-2.03-7.06 2.87 2.87 0 0 1 1.51-2.5ZM13 2.5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0v-6Zm3 0a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0v-6Z"]),vSt=Mn("CallPause20Regular","20",["M3.55 2.44a4.1 4.1 0 0 1 2.99-.32c.5.12.94.45 1.2.9l.97 1.7a2.5 2.5 0 0 1-.67 3.24l-.6.45c-.28.22-.4.52-.34.77.18.82.59 1.57 1.15 2.13.17.16.47.22.8.1l.66-.26a2.5 2.5 0 0 1 3.07 1.11l.95 1.7c.27.48.31 1.04.12 1.54a3.9 3.9 0 0 1-1.96 2.22c-.9.41-1.94.4-2.88-.24-1.5-1-3.3-2.68-4.94-5.48a13.27 13.27 0 0 1-2.03-7.06 2.87 2.87 0 0 1 1.51-2.5Zm.49.87c-.59.33-.98.89-1 1.66-.04 1.61.33 3.85 1.9 6.53a15.3 15.3 0 0 0 4.62 5.15 1.9 1.9 0 0 0 1.91.16 2.91 2.91 0 0 0 1.45-1.65.84.84 0 0 0-.06-.7l-.95-1.7a1.5 1.5 0 0 0-1.85-.68l-.66.26c-.58.22-1.33.2-1.85-.32A5.32 5.32 0 0 1 6.13 9.4c-.17-.72.2-1.4.71-1.78l.6-.46c.6-.45.78-1.29.4-1.94l-.97-1.7a.93.93 0 0 0-.58-.43 3.1 3.1 0 0 0-2.25.22ZM13 2.5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0v-6Zm3 0a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0v-6Z"]),ySt=Mn("CameraSwitch24Regular","24",["M21.25 7.5c.38 0 .7.28.74.65l.01.1v8.5a3.25 3.25 0 0 1-3.07 3.24l-.18.01H6.06l.72.72c.27.27.3.68.07.98l-.07.08a.75.75 0 0 1-.98.07l-.08-.07-2-2-.06-.07-.01-.01.07.08a.75.75 0 0 1 0-1.06l2-2a.75.75 0 0 1 1.13.98l-.07.08-.72.72h12.69c.92 0 1.67-.7 1.74-1.6l.01-.15v-8.5c0-.41.34-.75.75-.75ZM18.2 2.15l.08.07 2 2 .07.08-.07-.08a.75.75 0 0 1 0 1.06l-2 2a.75.75 0 0 1-1.13-.98l.07-.08.72-.72H5.25c-.92 0-1.67.7-1.74 1.6l-.01.15v8.5a.75.75 0 0 1-1.5.1v-8.6a3.25 3.25 0 0 1 3.07-3.24L5.25 4h12.69l-.72-.72a.75.75 0 0 1-.07-.98l.07-.08a.75.75 0 0 1 .98-.07ZM12 8a4 4 0 1 1 0 8 4 4 0 0 1 0-8Zm0 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z"]),SSt=Mn("Chat20Filled","20",["M10 2a8 8 0 1 1-3.61 15.14l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a7.95 7.95 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8Zm.5 9H7.41a.5.5 0 0 0 0 1H10.59a.5.5 0 0 0 0-1h-.09Zm2-3H7.41a.5.5 0 0 0 0 1h5.18a.5.5 0 0 0 0-1h-.09Z"]),bSt=Mn("Chat20Regular","20",["M10 2a8 8 0 1 1-3.61 15.14l-.12-.07-3.65.92a.5.5 0 0 1-.62-.45v-.08l.01-.08.92-3.64-.07-.12a7.95 7.95 0 0 1-.83-2.9l-.02-.37L2 10a8 8 0 0 1 8-8Zm0 1a7 7 0 0 0-6.1 10.42.5.5 0 0 1 .06.28l-.02.1-.75 3.01 3.02-.75a.5.5 0 0 1 .19-.01l.09.02.09.04A7 7 0 1 0 10 3Zm.5 8a.5.5 0 0 1 .09 1H7.5a.5.5 0 0 1-.09-1h3.09Zm2-3a.5.5 0 0 1 .09 1H7.5a.5.5 0 0 1-.09-1h5.09Z"]),TSt=Mn("Checkmark12Filled","12",["M9.76 3.2c.3.29.32.76.04 1.06l-4.25 4.5a.75.75 0 0 1-1.08.02L2.22 6.53a.75.75 0 0 1 1.06-1.06l1.7 1.7L8.7 3.24a.75.75 0 0 1 1.06-.04Z"]),CSt=Mn("Checkmark16Filled","16",["M14.05 3.49c.28.3.27.77-.04 1.06l-7.93 7.47A.85.85 0 0 1 4.9 12L2.22 9.28a.75.75 0 1 1 1.06-1.06l2.24 2.27 7.47-7.04a.75.75 0 0 1 1.06.04Z"]),_St=Mn("Checkmark20Regular","20",["M3.37 10.17a.5.5 0 0 0-.74.66l4 4.5c.19.22.52.23.72.02l10.5-10.5a.5.5 0 0 0-.7-.7L7.02 14.27l-3.65-4.1Z"]),ESt=Mn("CheckmarkCircle12Filled","12",["M1 6a5 5 0 1 1 10 0A5 5 0 0 1 1 6Zm7.35-.9a.5.5 0 1 0-.7-.7L5.5 6.54 4.35 5.4a.5.5 0 1 0-.7.7l1.5 1.5c.2.2.5.2.7 0l2.5-2.5Z"]),Yke=Mn("CheckmarkCircle16Regular","16",["M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8Zm6-7a7 7 0 1 0 0 14A7 7 0 0 0 8 1Zm2.85 5.85a.5.5 0 0 0-.7-.7l-2.9 2.9-1.4-1.4a.5.5 0 1 0-.7.7L6.9 10.1c.2.2.5.2.7 0l3.25-3.25Z"]),Qke=Mn("ChevronLeft20Regular","20",["M12.35 15.85a.5.5 0 0 1-.7 0L6.16 10.4a.55.55 0 0 1 0-.78l5.49-5.46a.5.5 0 1 1 .7.7L7.2 10l5.16 5.15c.2.2.2.5 0 .7Z"]),Zke=Mn("ChevronRight20Regular","20",["M7.65 4.15c.2-.2.5-.2.7 0l5.49 5.46c.21.22.21.57 0 .78l-5.49 5.46a.5.5 0 0 1-.7-.7L12.8 10 7.65 4.85a.5.5 0 0 1 0-.7Z"]),Xke=Mn("Circle16Regular","16",["M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12Zm0-1A5 5 0 1 1 8 3a5 5 0 0 1 0 10Z"]),ASt=Mn("Circle20Regular","20",["M10 3a7 7 0 1 0 0 14 7 7 0 0 0 0-14Zm-8 7a8 8 0 1 1 16 0 8 8 0 0 1-16 0Z"]),ISt=Mn("Clock16Regular","16",["M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8Zm6-7a7 7 0 1 0 0 14A7 7 0 0 0 8 1Zm0 3.5a.5.5 0 0 0-1 0v4c0 .28.22.5.5.5h3a.5.5 0 0 0 0-1H8V4.5Z"]),wSt=Mn("Clock20Filled","20",["M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16Zm-.5 3a.5.5 0 0 0-.5.5v5.09a.5.5 0 0 0 .5.41h3.09a.5.5 0 0 0-.09-1H10V5.41A.5.5 0 0 0 9.5 5Z"]),kSt=Mn("ClosedCaption20Regular","20",["M6.4 7.24c.82-.41 1.8-.24 2.45.4a.5.5 0 0 1-.7.71 1.12 1.12 0 0 0-1.3-.22C6.44 8.34 6 8.9 6 10s.44 1.66.85 1.87c.43.21.95.13 1.3-.22a.5.5 0 0 1 .7.7c-.65.65-1.63.82-2.45.41C5.56 12.34 5 11.39 5 10c0-1.39.56-2.34 1.4-2.76Zm7.95.4a2.12 2.12 0 0 0-2.45-.4c-.84.42-1.4 1.37-1.4 2.76 0 1.39.56 2.34 1.4 2.76.82.41 1.8.24 2.45-.4a.5.5 0 0 0-.7-.71c-.35.35-.87.43-1.3.22-.41-.21-.85-.76-.85-1.87s.44-1.66.85-1.87c.43-.21.95-.13 1.3.22a.5.5 0 0 0 .7-.7ZM2 7a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7Zm3-2a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H5Z"]),RSt=Mn("ClosedCaptionOff20Regular","20",["M2.85 2.15a.5.5 0 1 0-.7.7l1.48 1.48A3 3 0 0 0 2 7v6a3 3 0 0 0 3 3h10l.28-.01 1.87 1.86a.5.5 0 0 0 .7-.7l-1.48-1.48-.76-.77-2.93-2.93-1.06-1.05L10.5 9.8 8.94 8.23 7.77 7.06 4.72 4.01 2.85 2.15ZM14.3 15H5a2 2 0 0 1-2-2V7a2 2 0 0 1 1.39-1.9l2.1 2.1-.09.04C5.56 7.66 5 8.61 5 10c0 1.39.56 2.34 1.4 2.76.82.41 1.8.24 2.45-.4a.5.5 0 1 0-.7-.71c-.35.35-.87.43-1.3.22C6.44 11.66 6 11.1 6 10s.44-1.66.85-1.87c.15-.07.3-.1.46-.11L14.3 15Zm2.9.06-.72-.7A2 2 0 0 0 17 13V7a2 2 0 0 0-2-2H7.12l-1-1H15a3 3 0 0 1 3 3v6c0 .8-.31 1.52-.82 2.06Zm-5.65-5.64-.81-.81c.24-.65.65-1.11 1.17-1.37.82-.41 1.8-.24 2.45.4a.5.5 0 0 1-.7.71 1.12 1.12 0 0 0-1.3-.22c-.33.17-.68.56-.8 1.3Z"]),MSt=Mn("ConferenceRoom16Regular","16",["M10 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0ZM7.6 2a.5.5 0 0 0-.6.49v11a.5.5 0 0 0 .6.49l5-1a.5.5 0 0 0 .4-.5V3.5a.5.5 0 0 0-.4-.49l-5-1ZM8 12.89V3.1l4 .8v8.18l-4 .8Zm-2 .1v-1H4V4h2V3H3.5a.5.5 0 0 0-.5.5v9c0 .27.22.5.5.5H6Z"]),PSt=Mn("ContentView20Regular","20",["M5 7a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7Zm9 0H6v2h8V7Zm-2 4a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-2Zm0 1h2v1h-2v-1Zm-7-.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Zm.5 1.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4ZM3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm3-2a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H6Z"]),DSt=Mn("Delete20Regular","20",["M8.5 4h3a1.5 1.5 0 0 0-3 0Zm-1 0a2.5 2.5 0 0 1 5 0h5a.5.5 0 0 1 0 1h-1.05l-1.2 10.34A3 3 0 0 1 12.27 18H7.73a3 3 0 0 1-2.98-2.66L3.55 5H2.5a.5.5 0 0 1 0-1h5ZM5.74 15.23A2 2 0 0 0 7.73 17h4.54a2 2 0 0 0 1.99-1.77L15.44 5H4.56l1.18 10.23ZM8.5 7.5c.28 0 .5.22.5.5v6a.5.5 0 0 1-1 0V8c0-.28.22-.5.5-.5ZM12 8a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V8Z"]),Ise=Mn("Dialpad20Regular","20",["M6 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm1 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm3-7a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm1 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-1 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm1 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm3-11a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm1 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-1 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"]),LSt=Mn("Dismiss16Regular","16",["m2.59 2.72.06-.07a.5.5 0 0 1 .63-.06l.07.06L8 7.29l4.65-4.64a.5.5 0 0 1 .7.7L8.71 8l4.64 4.65c.18.17.2.44.06.63l-.06.07a.5.5 0 0 1-.63.06l-.07-.06L8 8.71l-4.65 4.64a.5.5 0 0 1-.7-.7L7.29 8 2.65 3.35a.5.5 0 0 1-.06-.63l.06-.07-.06.07Z"]),OSt=Mn("Dismiss20Regular","20",["m4.09 4.22.06-.07a.5.5 0 0 1 .63-.06l.07.06L10 9.29l5.15-5.14a.5.5 0 0 1 .63-.06l.07.06c.18.17.2.44.06.63l-.06.07L10.71 10l5.14 5.15c.18.17.2.44.06.63l-.06.07a.5.5 0 0 1-.63.06l-.07-.06L10 10.71l-5.15 5.14a.5.5 0 0 1-.63.06l-.07-.06a.5.5 0 0 1-.06-.63l.06-.07L9.29 10 4.15 4.85a.5.5 0 0 1-.06-.63l.06-.07-.06.07Z"]),eRe=Mn("DoorArrowLeft16Regular","16",["M4.75 1C3.78 1 3 1.78 3 2.75v10.5c0 .97.78 1.75 1.75 1.75h2.5a5.5 5.5 0 0 1-.65-1H4.75a.75.75 0 0 1-.75-.75V2.75c0-.41.34-.75.75-.75h6.5c.41 0 .75.34.75.75v3.27c.34.03.68.1 1 .19V2.75C13 1.78 12.22 1 11.25 1h-6.5ZM7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm9 3.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-6.85-.35a.5.5 0 0 0-.15.35.5.5 0 0 0 .15.35l2 2a.5.5 0 0 0 .7-.7L10.71 12h2.79a.5.5 0 0 0 0-1h-2.8l1.15-1.15a.5.5 0 0 0-.7-.7l-2 2Z"]),wse=Mn("DoorArrowRight16Regular","16",["M4.75 1C3.78 1 3 1.78 3 2.75v10.5c0 .97.78 1.75 1.75 1.75h2.5a5.5 5.5 0 0 1-.65-1H4.75a.75.75 0 0 1-.75-.75V2.75c0-.41.34-.75.75-.75h6.5c.41 0 .75.34.75.75v3.27c.34.03.68.1 1 .19V2.75C13 1.78 12.22 1 11.25 1h-6.5ZM7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm4.5 8a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm.35-2.15a.5.5 0 0 1-.7-.7L12.29 12H9.5a.5.5 0 0 1 0-1h2.8l-1.15-1.15a.5.5 0 0 1 .7-.7l2 2a.5.5 0 0 1 .15.35.5.5 0 0 1-.14.35l-2 2Z"]),NSt=Mn("Edit20Regular","20",["M17.18 2.93a2.97 2.97 0 0 0-4.26-.06l-9.37 9.38c-.33.33-.56.74-.66 1.2l-.88 3.94a.5.5 0 0 0 .6.6l3.93-.87c.46-.1.9-.34 1.23-.68l9.36-9.36a2.97 2.97 0 0 0 .05-4.15Zm-3.55.65a1.97 1.97 0 1 1 2.8 2.8l-.68.66-2.8-2.79.68-.67Zm-1.38 1.38 2.8 2.8-7.99 7.97c-.2.2-.46.35-.74.41l-3.16.7.7-3.18c.07-.27.2-.51.4-.7l8-8Z"]),xSt=Mn("Emoji20Regular","20",["M18 10a8 8 0 1 0-16 0 8 8 0 0 0 16 0ZM3 10a7 7 0 1 1 14 0 7 7 0 0 1-14 0Zm10.5-1.5a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm-5 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm-1.61 4.01a.5.5 0 1 0-.78.63 5 5 0 0 0 7.78 0 .5.5 0 1 0-.78-.63 4 4 0 0 1-6.22 0Z"]),BSt=Mn("ErrorCircle12Filled","12",["M6 11A5 5 0 1 0 6 1a5 5 0 0 0 0 10Zm-.75-2.75a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0Zm.26-4.84a.5.5 0 0 1 .98 0l.01.09v2.59a.5.5 0 0 1-1 0V3.41Z"]),FSt=Mn("ErrorCircle16Regular","16",["M8 2a6 6 0 1 1 0 12A6 6 0 0 1 8 2Zm0 1a5 5 0 1 0 0 10A5 5 0 0 0 8 3Zm0 7a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Zm0-5.5a.5.5 0 0 1 .5.41V8.5a.5.5 0 0 1-1 .09V5c0-.28.22-.5.5-.5Z"]),USt=Mn("Eye16Filled","16",["M2.98 8.62a.5.5 0 0 1-.6.36c-.44-.11-.36-.6-.36-.6l.01-.07.05-.14A6.7 6.7 0 0 1 3.2 6.19C4.1 5.08 5.6 4 8 4s3.9 1.09 4.8 2.18a6.7 6.7 0 0 1 1.18 2.17v.02a.5.5 0 0 1-.96.26L13 8.6a3.05 3.05 0 0 0-.2-.52 5.7 5.7 0 0 0-.78-1.26A4.96 4.96 0 0 0 8 5c-2.04 0-3.29.91-4.03 1.82A5.7 5.7 0 0 0 3 8.6v.02Zm2.52.88a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0Z"]),zSt=Mn("Eye16Regular","16",["M2.98 8.62a.5.5 0 0 1-.6.36c-.44-.11-.36-.6-.36-.6l.01-.07.05-.14A6.7 6.7 0 0 1 3.2 6.19C4.1 5.08 5.6 4 8 4s3.9 1.09 4.8 2.18a6.7 6.7 0 0 1 1.18 2.17v.02a.5.5 0 0 1-.96.26L13 8.6a3.05 3.05 0 0 0-.2-.52 5.7 5.7 0 0 0-.78-1.26A4.96 4.96 0 0 0 8 5c-2.04 0-3.29.91-4.03 1.82A5.7 5.7 0 0 0 3 8.6v.02ZM8 7a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5ZM6.5 9.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z"]),VSt=Mn("Flag16Filled","16",["M4 10h9a.5.5 0 0 0 .4-.8L11.12 6l2.3-3.2A.5.5 0 0 0 13 2H3.5a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 1 0V10Z"]),$St=Mn("Grid20Regular","20",["M7.5 11c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 0 1 2 16.5v-4c0-.83.67-1.5 1.5-1.5h4Zm9 0c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-4a1.5 1.5 0 0 1-1.5-1.5v-4c0-.83.67-1.5 1.5-1.5h4Zm-9 1h-4a.5.5 0 0 0-.5.5v4c0 .28.22.5.5.5h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5Zm9 0h-4a.5.5 0 0 0-.5.5v4c0 .28.22.5.5.5h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5Zm-9-10C8.33 2 9 2.67 9 3.5v4C9 8.33 8.33 9 7.5 9h-4A1.5 1.5 0 0 1 2 7.5v-4C2 2.67 2.67 2 3.5 2h4Zm9 0c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 0 1 11 7.5v-4c0-.83.67-1.5 1.5-1.5h4Zm-9 1h-4a.5.5 0 0 0-.5.5v4c0 .28.22.5.5.5h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5Zm9 0h-4a.5.5 0 0 0-.5.5v4c0 .28.22.5.5.5h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5Z"]),tRe=Mn("HandRight20Regular","20",["M4 12.02c0 1.06.2 2.1.6 3.08l.6 1.42c.22.55.64 1.01 1.17 1.29.27.14.56.21.86.21h2.55c.77 0 1.49-.41 1.87-1.08.5-.87 1.02-1.7 1.72-2.43l1.32-1.39c.44-.46.97-.84 1.49-1.23l.59-.45a.6.6 0 0 0 .23-.47c0-.75-.54-1.57-1.22-1.79a3.34 3.34 0 0 0-2.78.29V4.5a1.5 1.5 0 0 0-2.05-1.4 1.5 1.5 0 0 0-2.9 0A1.5 1.5 0 0 0 6 4.5v.09A1.5 1.5 0 0 0 4 6v6.02ZM8 4.5v4a.5.5 0 0 0 1 0v-5a.5.5 0 0 1 1 0v5a.5.5 0 0 0 1 0v-4a.5.5 0 0 1 1 0v6a.5.5 0 0 0 .85.37h.01c.22-.22.44-.44.72-.58.7-.35 2.22-.57 2.4.5l-.53.4c-.52.4-1.04.78-1.48 1.24l-1.33 1.38c-.75.79-1.31 1.7-1.85 2.63-.21.36-.6.58-1.01.58H7.23a.87.87 0 0 1-.4-.1 1.55 1.55 0 0 1-.71-.78l-.59-1.42a7.09 7.09 0 0 1-.53-2.7V6a.5.5 0 0 1 1 0v3.5a.5.5 0 0 0 1 0v-5a.5.5 0 0 1 1 0Z"]),iRe=Mn("HandRightOff20Regular","20",["M4 6c0-.36.13-.7.34-.95l-2.2-2.2a.5.5 0 1 1 .71-.7l15 15a.5.5 0 0 1-.7.7l-3.57-3.56-.21.22c-.7.72-1.22 1.56-1.72 2.43a2.16 2.16 0 0 1-1.87 1.08H7.23c-.3 0-.6-.07-.86-.21a2.55 2.55 0 0 1-1.18-1.3l-.58-1.41c-.4-.98-.61-2.02-.61-3.08V6Zm8.87 7.58L7 7.7V9.5a.5.5 0 0 1-1 0V6.7l-.94-.93A.5.5 0 0 0 5 6v6.02c0 .93.18 1.84.53 2.7l.59 1.42c.14.34.4.61.71.78.13.07.27.1.4.1h2.55c.42 0 .8-.22 1-.58.55-.94 1.11-1.84 1.86-2.63l.23-.23ZM10 3.5v4.38l.9.9a.5.5 0 0 0 .1-.28v-4a.5.5 0 0 1 1 0v5.38l.92.92c.2-.2.4-.38.66-.51.7-.35 2.22-.57 2.4.5l-.53.4c-.4.3-.81.61-1.18.95l.7.71c.38-.34.8-.65 1.2-.96l.6-.45a.6.6 0 0 0 .23-.47c0-.75-.54-1.57-1.22-1.79a3.34 3.34 0 0 0-2.78.29V4.5a1.5 1.5 0 0 0-2.05-1.4 1.5 1.5 0 0 0-2.9 0 1.5 1.5 0 0 0-1.96.87l.91.9V4.5a.5.5 0 0 1 1 0v1.38l1 1V3.5a.5.5 0 0 1 1 0Z"]),kx=Mn("Info20Filled","20",["M18 10a8 8 0 1 0-16 0 8 8 0 0 0 16 0ZM9.5 8.91a.5.5 0 0 1 1 0V13.6a.5.5 0 0 1-1 0V8.9Zm-.25-2.16a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0Z"]),HSt=Mn("Mic16Filled","16",["M8 2a2.5 2.5 0 0 0-2.5 2.5V8a2.5 2.5 0 0 0 5 0V4.5A2.5 2.5 0 0 0 8 2ZM4 7.5c.28 0 .5.22.5.5a3.5 3.5 0 1 0 7 0 .5.5 0 0 1 1 0 4.5 4.5 0 0 1-4 4.47v1.03a.5.5 0 0 1-1 0v-1.03A4.5 4.5 0 0 1 3.5 8c0-.28.22-.5.5-.5Z"]),lK=Mn("Mic20Filled","20",["M5.5 10a.5.5 0 0 0-1 0 5.5 5.5 0 0 0 5 5.48v2.02a.5.5 0 0 0 1 0v-2.02c2.8-.26 5-2.61 5-5.48a.5.5 0 0 0-1 0 4.5 4.5 0 1 1-9 0Zm7.5 0a3 3 0 0 1-6 0V5a3 3 0 0 1 6 0v5Z"]),kse=Mn("Mic20Regular","20",["M10 13a3 3 0 0 0 3-3V5a3 3 0 1 0-6 0v5a3 3 0 0 0 3 3Zm0-1a2 2 0 0 1-2-2V5a2 2 0 1 1 4 0v5a2 2 0 0 1-2 2ZM5 9.5c.28 0 .5.22.5.5a4.5 4.5 0 1 0 9 0 .5.5 0 0 1 1 0 5.5 5.5 0 0 1-5 5.48v2.02a.5.5 0 0 1-1 0v-2.02a5.5 5.5 0 0 1-5-5.48c0-.28.22-.5.5-.5Z"]),jSt=Mn("MicOff16Filled","16",["m10.8 11.52 3.35 3.33a.5.5 0 0 0 .7-.7l-13-13a.5.5 0 1 0-.7.7L5.5 6.21V8a2.5 2.5 0 0 0 3.88 2.09l.72.71A3.5 3.5 0 0 1 4.5 8a.5.5 0 1 0-1 0 4.5 4.5 0 0 0 4 4.47v1.03a.5.5 0 1 0 1 0v-1.03c.87-.1 1.66-.44 2.3-.95Zm1.26-1.58-.76-.76c.13-.37.2-.77.2-1.18a.5.5 0 0 1 1 0c0 .7-.16 1.35-.44 1.94Zm-1.58-1.59-4.8-4.79a2.5 2.5 0 0 1 4.82.94V8c0 .12 0 .24-.02.35Z"]),nRe=Mn("MicOff16Regular","16",["m10.8 11.52 3.35 3.33a.5.5 0 0 0 .7-.7l-13-13a.5.5 0 1 0-.7.7L5.5 6.21V8a2.5 2.5 0 0 0 3.88 2.09l.72.71A3.5 3.5 0 0 1 4.5 8a.5.5 0 1 0-1 0 4.5 4.5 0 0 0 4 4.47v1.03a.5.5 0 1 0 1 0v-1.03c.87-.1 1.66-.44 2.3-.95ZM8.66 9.35A1.5 1.5 0 0 1 6.5 8v-.8l2.15 2.15Zm.85-1.97V4.5a1.5 1.5 0 0 0-3-.12l-.82-.82a2.5 2.5 0 0 1 4.82.94V8c0 .12 0 .24-.02.35l-.98-.97Zm2.56 2.56-.76-.76c.13-.37.2-.77.2-1.18a.5.5 0 0 1 1 0c0 .7-.16 1.35-.44 1.94Z"]),Rse=Mn("MicOff20Filled","20",["M13 10a3 3 0 0 1-.1.78L7 4.88A3 3 0 0 1 13 5v5ZM7 7.7V10a3 3 0 0 0 4.74 2.45l1.07 1.07A4.5 4.5 0 0 1 5.5 10a.5.5 0 0 0-1.01 0 5.5 5.5 0 0 0 5 5.48v2.02a.5.5 0 0 0 1 0v-2.02a5.48 5.48 0 0 0 3.02-1.25l3.63 3.62a.5.5 0 0 0 .7-.7l-15-15a.5.5 0 1 0-.7.7L7 7.71Zm7.8 4.98c.45-.8.7-1.7.7-2.68a.5.5 0 0 0-1 0c0 .7-.16 1.35-.44 1.94l.74.74Z"]),aRe=Mn("MicOff20Regular","20",["M12 5v4.88l.9.9A3 3 0 0 0 13 10V5a3 3 0 0 0-6-.12l1 1V5a2 2 0 1 1 4 0ZM7 7.7 2.15 2.86a.5.5 0 1 1 .7-.7l15 15a.5.5 0 0 1-.7.7l-3.63-3.62a5.48 5.48 0 0 1-3.02 1.25v2.02a.5.5 0 0 1-1 0v-2.02a5.5 5.5 0 0 1-5-5.48.5.5 0 0 1 1 0 4.5 4.5 0 0 0 7.3 3.52l-1.06-1.07A3 3 0 0 1 7 10V7.7Zm4.02 4.02L8 8.71V10a2 2 0 0 0 3.02 1.72Zm3.78.96-.74-.74c.28-.59.44-1.25.44-1.94a.5.5 0 0 1 1 0c0 .97-.25 1.89-.7 2.68Z"]),cK=Mn("MicProhibited16Filled","16",["M4 4.5a2.5 2.5 0 0 1 5 0v.7a5.5 5.5 0 0 0-3.98 4.82A2.5 2.5 0 0 1 4 8V4.5Zm1.04 6.68A3.5 3.5 0 0 1 3 8a.5.5 0 0 0-1 0 4.5 4.5 0 0 0 3.32 4.34 5.47 5.47 0 0 1-.28-1.16ZM6 10.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0Zm2.4 2.8 4.9-4.9a3.5 3.5 0 0 1-4.9 4.9Zm-.7-.7a3.5 3.5 0 0 1 4.9-4.9l-4.9 4.9Z"]),rRe=Mn("MicProhibited20Filled","20",["M9.2 13A5.51 5.51 0 0 1 12 9.6V5a3 3 0 1 0-6 0v5a3 3 0 0 0 3.2 3Zm.3 4.5v-.7c-.32-.7-.5-1.48-.5-2.3A4.5 4.5 0 0 1 4.5 10a.5.5 0 0 0-1 0 5.5 5.5 0 0 0 5 5.48v2.02a.5.5 0 0 0 1 0Zm5 1.5a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9Zm0-8a3.5 3.5 0 0 0-2.8 5.6l4.9-4.9a3.48 3.48 0 0 0-2.1-.7Zm-2.1 6.3a3.5 3.5 0 0 0 4.9-4.9l-4.9 4.9Z"]),dK=Mn("MoreHorizontal20Filled","20",["M6.75 10a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Zm5 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0ZM15 11.75a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Z"]),GSt=Mn("MoreHorizontal20Regular","20",["M6.25 10a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Zm5 0a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0ZM15 11.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"]),qSt=Mn("Open20Regular","20",["M6 4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2v-2.5a.5.5 0 0 1 1 0V14a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h2.5a.5.5 0 0 1 0 1H6Zm5-.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5v5a.5.5 0 0 1-1 0V4.7l-4.15 4.15a.5.5 0 0 1-.7-.7L15.29 4H11.5a.5.5 0 0 1-.5-.5Z"]),WSt=Mn("People20Filled","20",["M6.75 10a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5Zm5.69 5.14c.53.22 1.2.36 2.06.36 4 0 4-3 4-3 0-.83-.67-1.5-1.5-1.5h-4.63c.4.48.63 1.09.63 1.75v.36a2.94 2.94 0 0 1-.02.25 4.62 4.62 0 0 1-.54 1.78ZM17 7.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0ZM1.5 13c0-1.1.9-2 2-2H10a2 2 0 0 1 2 2s0 4-5.25 4-5.25-4-5.25-4Zm11.5.1v.07Z"]),Mse=Mn("People20Regular","20",["M4.5 6.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0ZM6.75 3.5a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5Zm5.69 11.65c.53.21 1.21.35 2.06.35 1.88 0 2.92-.67 3.47-1.43a2.92 2.92 0 0 0 .53-1.5v-.07c0-.83-.67-1.5-1.5-1.5h-4.63c.24.29.42.63.53 1H17c.28 0 .5.22.5.5v.1l-.04.22c-.04.18-.13.42-.3.66-.33.46-1.04 1.02-2.66 1.02-.73 0-1.28-.11-1.69-.28-.08.28-.2.6-.37.93ZM1.5 13c0-1.1.9-2 2-2H10a2 2 0 0 1 2 2V13.08a1.43 1.43 0 0 1-.01.18 3.95 3.95 0 0 1-.67 1.8C10.62 16.09 9.26 17 6.75 17c-2.51 0-3.87-.92-4.57-1.93a3.95 3.95 0 0 1-.68-1.99V13Zm1 .06v.1l.06.33c.07.27.2.64.45 1C3.49 15.2 4.5 16 6.75 16s3.26-.8 3.74-1.5a2.95 2.95 0 0 0 .5-1.42l.01-.02V13a1 1 0 0 0-1-1H3.5a1 1 0 0 0-1 1v.06ZM13 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM14.5 5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z"]),KSt=Mn("PersonAdd20Regular","20",["M9 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8ZM6 6a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm-2 5a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9.14 9.14 0 0 0 9 18c.41 0 .82-.02 1.21-.06A5.5 5.5 0 0 1 9.6 17 12 12 0 0 1 9 17a8.16 8.16 0 0 1-4.33-1.05A3.36 3.36 0 0 1 3 13a1 1 0 0 1 1-1h5.6c.18-.36.4-.7.66-1H4Zm10.5 8a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm0-7c.28 0 .5.22.5.5V14h1.5a.5.5 0 0 1 0 1H15v1.5a.5.5 0 0 1-1 0V15h-1.5a.5.5 0 0 1 0-1H14v-1.5c0-.28.22-.5.5-.5Z"]),oRe=Mn("PersonCall20Regular","20",["M10 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8ZM7 6a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm-2 5a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9.14 9.14 0 0 0 10 18c.36 0 .71-.01 1.06-.04a2.2 2.2 0 0 1 0-1c-.34.02-.7.04-1.06.04a8.16 8.16 0 0 1-4.33-1.05A3.36 3.36 0 0 1 4 13a1 1 0 0 1 1-1h9.52c0-.26.03-.52.13-.77l.08-.23H5.01Zm10.58.58.29-.75a1.32 1.32 0 0 1 1.74-.73l.39.17c.47.2.86.57.94 1.06.46 2.73-1.9 6.6-4.63 7.59a1.6 1.6 0 0 1-1.44-.25l-.35-.23c-.6-.41-.7-1.24-.2-1.79l.54-.6c.26-.3.66-.42 1.04-.33l1.22.29c.97-.6 1.5-1.46 1.56-2.56l-.88-.86a.94.94 0 0 1-.22-1Z"]),JSt=Mn("PersonDelete20Filled","20",["M5 6a4 4 0 1 1 8 0 4 4 0 0 1-8 0Zm-3 7a2 2 0 0 1 2-2h6.26a5.48 5.48 0 0 0-.05 6.94c-.4.04-.8.06-1.21.06a9.14 9.14 0 0 1-4.87-1.2A4.35 4.35 0 0 1 2 13Zm17 1.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.65-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15 1.14-1.15Z"]),YSt=Mn("PersonDelete20Regular","20",["M5 6a4 4 0 1 1 8 0 4 4 0 0 1-8 0Zm4-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6ZM2 13a2 2 0 0 1 2-2h6.26c-.26.3-.48.64-.66 1H4a1 1 0 0 0-1 1c0 1.3.62 2.28 1.67 2.95A8.16 8.16 0 0 0 9 17l.6-.01c.17.34.37.66.61.95-.4.04-.8.06-1.21.06a9.14 9.14 0 0 1-4.87-1.2A4.35 4.35 0 0 1 2 13Zm17 1.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.65-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15 1.14-1.15Z"]),QSt=Mn("PersonSquare20Regular","20",["M10 5a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm2.5 5h-5c-.83 0-1.5.67-1.5 1.5 0 1.12.46 2.01 1.21 2.61.74.6 1.74.89 2.79.89s2.05-.29 2.79-.89c.75-.6 1.21-1.5 1.21-2.61 0-.83-.67-1.5-1.5-1.5ZM6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6ZM4 6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6Z"]),ZSt=Mn("PersonVoice20Regular","20",["M17.13 1.06a.5.5 0 0 1 .68.2 9.96 9.96 0 0 1 0 9.48.5.5 0 1 1-.88-.48 8.96 8.96 0 0 0 0-8.52.5.5 0 0 1 .2-.68Zm-2.32 1.97a.5.5 0 0 1 .65.27 6.98 6.98 0 0 1 0 5.4.5.5 0 1 1-.92-.39 5.98 5.98 0 0 0 0-4.62.5.5 0 0 1 .27-.66ZM5 6a4 4 0 1 1 8 0 4 4 0 0 1-8 0Zm4-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6ZM2 13a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2c0 1.7-.83 2.97-2.13 3.8A9.14 9.14 0 0 1 9 18a9.14 9.14 0 0 1-4.87-1.2A4.35 4.35 0 0 1 2 13Zm2-1a1 1 0 0 0-1 1c0 1.3.62 2.28 1.67 2.95A8.16 8.16 0 0 0 9 17c1.74 0 3.26-.36 4.33-1.05A3.36 3.36 0 0 0 15 13a1 1 0 0 0-1-1H4Z"]),XSt=Mn("Pin16Filled","16",["M10.06 2.45a1.5 1.5 0 0 0-2.39.35L5.65 6.59l-2.8.94a.5.5 0 0 0-.2.82l2.14 2.15-2.64 2.65L2 14l.85-.15 2.65-2.64 2.15 2.14a.5.5 0 0 0 .82-.2l.94-2.8 3.78-2.03a1.5 1.5 0 0 0 .35-2.38l-3.48-3.5Z"]),ebt=Mn("Pin20Filled","20",["M13.33 2.62a2 2 0 0 0-3.2.52L8.38 6.6a1.5 1.5 0 0 1-.78.72L4 8.75a1 1 0 0 0-.33 1.64l2.61 2.6L3 16.3v.7h.7L7 13.72l2.61 2.6a1 1 0 0 0 1.64-.33l1.43-3.59c.14-.34.4-.62.72-.78l3.46-1.73a2 2 0 0 0 .52-3.2l-4.05-4.06Z"]),tbt=Mn("Pin20Regular","20",["M10.12 3.14a2 2 0 0 1 3.2-.52l4.06 4.05a2 2 0 0 1-.52 3.2l-3.46 1.74a1.5 1.5 0 0 0-.72.78L11.25 16a1 1 0 0 1-1.64.33L7 13.7 3.7 17H3v-.7L6.3 13l-2.62-2.61a1 1 0 0 1 .34-1.64L7.6 7.32c.34-.14.62-.4.78-.72l1.73-3.46Zm2.5.18a1 1 0 0 0-1.6.26L9.29 7.04a2.5 2.5 0 0 1-1.31 1.2L4.39 9.69l5.93 5.93 1.43-3.59a2.5 2.5 0 0 1 1.2-1.3l3.46-1.74a1 1 0 0 0 .26-1.6l-4.05-4.06Z"]),ibt=Mn("PinOff20Regular","20",["M2.85 2.15a.5.5 0 1 0-.7.7L6.9 7.6 4.02 8.75a1 1 0 0 0-.34 1.64L6.3 13 3 16.3v.7h.7L7 13.7l2.61 2.62a1 1 0 0 0 1.64-.34l1.15-2.88 4.75 4.75a.5.5 0 0 0 .7-.7l-15-15Zm8.78 10.18-1.31 3.28-5.93-5.93 3.28-1.3 3.96 3.95Zm1.33-1.62-.08.04.74.75 3.24-1.62a2 2 0 0 0 .52-3.2l-4.05-4.06a2 2 0 0 0-3.2.52L8.5 6.38l.75.74.04-.08 1.73-3.45a1 1 0 0 1 1.6-.26l4.05 4.05a1 1 0 0 1-.26 1.6l-3.45 1.73Z"]),nbt=Mn("Play20Regular","20",["M17.22 8.69a1.5 1.5 0 0 1 0 2.62l-10 5.5A1.5 1.5 0 0 1 5 15.5v-11A1.5 1.5 0 0 1 7.22 3.2l10 5.5Zm-.48 1.75a.5.5 0 0 0 0-.88l-10-5.5A.5.5 0 0 0 6 4.5v11c0 .38.4.62.74.44l10-5.5Z"]),abt=Mn("Record16Regular","16",["M8 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1ZM2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8Z"]),rbt=Mn("ScaleFill20Regular","20",["M6 6.5a.5.5 0 0 1 .14-.35A.5.5 0 0 1 6.5 6h2a.5.5 0 0 1 0 1h-.8l1.15 1.15a.5.5 0 1 1-.7.7L7 7.71v.79a.5.5 0 0 1-1 0v-2Zm.04 7.2a.5.5 0 0 1-.04-.2v-2a.5.5 0 0 1 1 0v.8l1.15-1.15a.5.5 0 0 1 .7.7L7.71 13h.79a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.46-.3Zm7.65-7.66a.5.5 0 0 1 .3.46v2a.5.5 0 0 1-.99 0v-.8l-1.15 1.15a.5.5 0 0 1-.7-.7L12.29 7h-.79a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .2.04Zm.16 7.82a.5.5 0 0 1-.35.14h-2a.5.5 0 0 1 0-1h.8l-1.15-1.15a.5.5 0 0 1 .7-.7L13 12.29v-.79a.5.5 0 0 1 1 0v2a.5.5 0 0 1-.14.35ZM3 5c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Zm2-1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H5Z"]),obt=Mn("ScaleFit20Regular","20",["M6.88 7.92a.5.5 0 0 1-.05.7l-1 .88H8.5a.5.5 0 0 1 0 1H5.83l1 .87a.5.5 0 1 1-.66.76l-2-1.75a.5.5 0 0 1 0-.76l2-1.75a.5.5 0 0 1 .7.05Zm7.29 2.58-1 .87a.5.5 0 0 0 .66.76l2-1.75a.5.5 0 0 0 0-.76l-2-1.75a.5.5 0 0 0-.66.76l1 .87H11.5a.5.5 0 0 0 0 1h2.67ZM2 6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6Zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H4Z"]),sbt=Mn("Send20Filled","20",["M2.72 2.05a.5.5 0 0 0-.7.58l1.5 5.62c.05.19.2.33.4.36l6.85 1.14c.28.05.28.45 0 .5l-6.85 1.14a.5.5 0 0 0-.4.36l-1.5 5.62a.5.5 0 0 0 .7.58l15-7.5a.5.5 0 0 0 0-.9l-15-7.5Z"],{flipInRtl:!0}),lbt=Mn("Send20Regular","20",["M2.18 2.11a.5.5 0 0 1 .54-.06l15 7.5a.5.5 0 0 1 0 .9l-15 7.5a.5.5 0 0 1-.7-.58L3.98 10 2.02 2.63a.5.5 0 0 1 .16-.52Zm2.7 8.39-1.61 6.06L16.38 10 3.27 3.44 4.88 9.5h6.62a.5.5 0 1 1 0 1H4.88Z"],{flipInRtl:!0}),cbt=Mn("Settings20Filled","20",["M1.91 7.38A8.5 8.5 0 0 1 3.7 4.3a.5.5 0 0 1 .54-.13l1.92.68a1 1 0 0 0 1.32-.76l.36-2a.5.5 0 0 1 .4-.4 8.53 8.53 0 0 1 3.55 0c.2.04.35.2.38.4l.37 2a1 1 0 0 0 1.32.76l1.92-.68a.5.5 0 0 1 .54.13 8.5 8.5 0 0 1 1.78 3.08c.06.2 0 .4-.15.54l-1.56 1.32a1 1 0 0 0 0 1.52l1.56 1.32a.5.5 0 0 1 .15.54 8.5 8.5 0 0 1-1.78 3.08.5.5 0 0 1-.54.13l-1.92-.68a1 1 0 0 0-1.32.76l-.37 2a.5.5 0 0 1-.38.4 8.53 8.53 0 0 1-3.56 0 .5.5 0 0 1-.39-.4l-.36-2a1 1 0 0 0-1.32-.76l-1.92.68a.5.5 0 0 1-.54-.13 8.5 8.5 0 0 1-1.78-3.08.5.5 0 0 1 .15-.54l1.56-1.32a1 1 0 0 0 0-1.52L2.06 7.92a.5.5 0 0 1-.15-.54ZM8 10a2 2 0 1 0 4 0 2 2 0 0 0-4 0Z"]),dbt=Mn("Settings20Regular","20",["M1.91 7.38A8.5 8.5 0 0 1 3.7 4.3a.5.5 0 0 1 .54-.13l1.92.68a1 1 0 0 0 1.32-.76l.36-2a.5.5 0 0 1 .4-.4 8.53 8.53 0 0 1 3.55 0c.2.04.35.2.38.4l.37 2a1 1 0 0 0 1.32.76l1.92-.68a.5.5 0 0 1 .54.13 8.5 8.5 0 0 1 1.78 3.08c.06.2 0 .4-.15.54l-1.56 1.32a1 1 0 0 0 0 1.52l1.56 1.32a.5.5 0 0 1 .15.54 8.5 8.5 0 0 1-1.78 3.08.5.5 0 0 1-.54.13l-1.92-.68a1 1 0 0 0-1.32.76l-.37 2a.5.5 0 0 1-.38.4 8.53 8.53 0 0 1-3.56 0 .5.5 0 0 1-.39-.4l-.36-2a1 1 0 0 0-1.32-.76l-1.92.68a.5.5 0 0 1-.54-.13 8.5 8.5 0 0 1-1.78-3.08.5.5 0 0 1 .15-.54l1.56-1.32a1 1 0 0 0 0-1.52L2.06 7.92a.5.5 0 0 1-.15-.54Zm1.06 0 1.3 1.1a2 2 0 0 1 0 3.04l-1.3 1.1c.3.79.72 1.51 1.25 2.16l1.6-.58a2 2 0 0 1 2.63 1.53l.3 1.67a7.56 7.56 0 0 0 2.5 0l.3-1.67a2 2 0 0 1 2.64-1.53l1.6.58a7.5 7.5 0 0 0 1.24-2.16l-1.3-1.1a2 2 0 0 1 0-3.04l1.3-1.1a7.5 7.5 0 0 0-1.25-2.16l-1.6.58a2 2 0 0 1-2.63-1.53l-.3-1.67a7.55 7.55 0 0 0-2.5 0l-.3 1.67A2 2 0 0 1 5.81 5.8l-1.6-.58a7.5 7.5 0 0 0-1.24 2.16ZM7.5 10a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0Zm1 0a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Z"]),sRe=Mn("ShareScreenStart20Filled","20",["M4 4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H4Zm6 10a.5.5 0 0 1-.5-.5V7.7L7.85 9.36a.5.5 0 1 1-.7-.7l2.5-2.5c.2-.2.5-.2.7 0l2.5 2.5a.5.5 0 0 1-.7.7L10.5 7.71v5.79a.5.5 0 0 1-.5.5Z"]),ubt=Mn("ShareScreenStop20Filled","20",["M4.5 4A2.5 2.5 0 0 0 2 6.5v7A2.5 2.5 0 0 0 4.5 16h11a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 15.5 4h-11Zm2.65 3.15c.2-.2.5-.2.7 0L10 9.29l2.15-2.14a.5.5 0 0 1 .7.7L10.71 10l2.14 2.15a.5.5 0 0 1-.7.7L10 10.71l-2.15 2.14a.5.5 0 0 1-.7-.7L9.29 10 7.15 7.85a.5.5 0 0 1 0-.7Z"]),lRe=Mn("Speaker220Filled","20",["M12 3a1 1 0 0 0-1.68-.73l-3.87 3.6A.5.5 0 0 1 6.1 6H3.5C2.67 6 2 6.67 2 7.5v5c0 .83.67 1.5 1.5 1.5h2.6a.5.5 0 0 1 .35.13l3.87 3.6a1 1 0 0 0 1.68-.74V3.01Zm3.25 1.63a.5.5 0 0 1 .71.04 8 8 0 0 1 0 10.66.5.5 0 1 1-.75-.66 7 7 0 0 0 0-9.34.5.5 0 0 1 .04-.7Zm-1.17 8.3a.5.5 0 0 1-.19-.68 4.5 4.5 0 0 0 0-4.5.5.5 0 1 1 .87-.5 5.5 5.5 0 0 1 0 5.5.5.5 0 0 1-.68.18Z"]),Pse=Mn("Speaker220Regular","20",["M12 3a1 1 0 0 0-1.68-.73l-3.88 3.6A.5.5 0 0 1 6.1 6H3.5C2.67 6 2 6.67 2 7.5v5c0 .83.67 1.5 1.5 1.5h2.6a.5.5 0 0 1 .34.13l3.88 3.6a1 1 0 0 0 1.68-.74V3.01ZM7.12 6.6 11 3v14l-3.88-3.6A1.5 1.5 0 0 0 6.1 13H3.5a.5.5 0 0 1-.5-.5v-5c0-.28.22-.5.5-.5h2.6c.38 0 .75-.14 1.02-.4Zm8.14-1.97a.5.5 0 0 1 .7.04 8 8 0 0 1 0 10.66.5.5 0 0 1-.74-.66 7 7 0 0 0 0-9.34.5.5 0 0 1 .04-.7Zm-1.18 8.3a.5.5 0 0 1-.18-.68 4.5 4.5 0 0 0 0-4.5.5.5 0 1 1 .86-.5 5.5 5.5 0 0 1 0 5.5.5.5 0 0 1-.68.18Z"]),hbt=Mn("SpeakerMute16Filled","16",["M9 2.5a.5.5 0 0 0-.85-.36L5.22 5H3.5C2.67 5 2 5.66 2 6.5v3c0 .82.67 1.5 1.5 1.5h1.72l2.93 2.87A.5.5 0 0 0 9 13.5v-11Zm1.15 3.65c.2-.2.5-.2.7 0L12 7.29l1.15-1.14a.5.5 0 1 1 .7.7L12.71 8l1.14 1.15a.5.5 0 1 1-.7.7L12 8.71l-1.15 1.14a.5.5 0 0 1-.7-.7L11.29 8l-1.14-1.15a.5.5 0 0 1 0-.7Z"]),pbt=Mn("Square12Filled","12",["M2 4c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4Z"]),gbt=Mn("Square16Filled","16",["M2 4.5A2.5 2.5 0 0 1 4.5 2h7A2.5 2.5 0 0 1 14 4.5v7a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 11.5v-7Z"]),mbt=Mn("Star28Filled","28",["M12.7 3.9a1.45 1.45 0 0 1 2.6 0L18 9.37l6.01.87a1.45 1.45 0 0 1 .8 2.48l-4.35 4.24 1.03 6a1.45 1.45 0 0 1-2.1 1.52L14 21.64l-5.38 2.83a1.45 1.45 0 0 1-2.1-1.52l1.02-6-4.35-4.24c-.86-.84-.39-2.3.8-2.48l6.02-.87 2.7-5.45Z"]),fbt=Mn("Star28Regular","28",["M12.7 3.9a1.45 1.45 0 0 1 2.6 0L18 9.37l6.01.87a1.45 1.45 0 0 1 .8 2.48l-4.35 4.24 1.03 6a1.45 1.45 0 0 1-2.1 1.52L14 21.64l-5.38 2.83a1.45 1.45 0 0 1-2.1-1.52l1.02-6-4.35-4.24c-.86-.84-.39-2.3.8-2.48l6.02-.87 2.7-5.45Zm1.3.76-2.66 5.39c-.2.43-.62.72-1.09.8l-5.94.85 4.3 4.2c.34.33.5.8.42 1.28L8 23.1l5.32-2.8c.42-.22.92-.22 1.35 0l5.31 2.8-1.01-5.92c-.08-.47.07-.95.41-1.28l4.3-4.2-5.94-.86a1.45 1.45 0 0 1-1.1-.8L14 4.67Z"]),vbt=Mn("Table20Regular","20",["M17 5.5A2.5 2.5 0 0 0 14.5 3h-9A2.5 2.5 0 0 0 3 5.5v9A2.5 2.5 0 0 0 5.5 17h9a2.5 2.5 0 0 0 2.5-2.5v-9Zm-13 9V13h3v3H5.36A1.5 1.5 0 0 1 4 14.5Zm8-1.5v3H8v-3h4Zm2.5 3H13v-3h3V14.64A1.5 1.5 0 0 1 14.5 16ZM12 8v4H8V8h4Zm1 0h3v4h-3V8Zm-1-4v3H8V4h4Zm1 0H14.64A1.5 1.5 0 0 1 16 5.5V7h-3V4ZM7 4v3H4V5.36A1.5 1.5 0 0 1 5.5 4H7Zm0 4v4H4V8h3Z"]),ybt=Mn("TableSimple20Regular","20",["M3 5.5A2.5 2.5 0 0 1 5.5 3h9A2.5 2.5 0 0 1 17 5.5v9a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 3 14.5v-9Zm1 5v4c0 .83.67 1.5 1.5 1.5h4v-5.5H4Zm5.5-1V4h-4C4.67 4 4 4.67 4 5.5v4h5.5Zm1 1V16h4c.83 0 1.5-.67 1.5-1.5v-4h-5.5Zm5.5-1v-4c0-.83-.67-1.5-1.5-1.5h-4v5.5H16Z"]),Sbt=Mn("Translate20Regular","20",["M4.08 4.22c.7-.21 1.7-.34 2.84 0 1.01.3 1.56.9 1.83 1.56.26.63.26 1.27.26 1.67v5.05a.5.5 0 0 1-1 0v-.53c-.31.19-.67.38-1.05.55-.78.34-1.74.6-2.64.42a2.97 2.97 0 0 1-2.25-2.09c-.29-.97-.08-2.1.8-2.84a4.57 4.57 0 0 1 3.21-1c.71.03 1.38.17 1.93.32 0-.37-.03-.79-.18-1.17-.16-.4-.48-.77-1.19-.98a4.04 4.04 0 0 0-3.15.37h-.01a.5.5 0 0 1-.57-.82h.01l.02-.02a2.45 2.45 0 0 1 .3-.17c.2-.1.48-.22.84-.32ZM6.04 8a3.58 3.58 0 0 0-2.52.77 1.66 1.66 0 0 0-.5 1.79c.2.66.73 1.23 1.5 1.39.6.12 1.33-.04 2.04-.35.58-.26 1.1-.6 1.45-.85V8.37a8.27 8.27 0 0 0-1.97-.36Zm8.43-1.34a.5.5 0 0 0-.94-.34c-.18.5-.37 1.22-.47 1.65-.5.03-1 .03-1.53 0a.5.5 0 1 0-.06 1c.47.02.92.03 1.36 0-.11.58-.2 1.1-.25 1.56a4.71 4.71 0 0 0-2.3 2.3c-.44 1.02-.4 2.17.25 2.85.43.46 1.06.53 1.64.4.42-.1.86-.31 1.28-.61l.08.2a.5.5 0 0 0 .93-.36 8.18 8.18 0 0 0-.23-.53 6.7 6.7 0 0 0 1.68-3.6c.77.26 1.28.8 1.5 1.38.38 1.04-.04 2.55-2.11 3.47a.5.5 0 1 0 .4.92c2.43-1.08 3.26-3.07 2.64-4.73A3.37 3.37 0 0 0 16 10.17V10a.5.5 0 1 0-1 0v.02c-.43-.01-.88.03-1.36.13l.23-1.25a21.3 21.3 0 0 0 2.24-.41.5.5 0 0 0-.22-.98c-.62.15-1.2.27-1.77.35.1-.38.23-.85.35-1.2Zm-3.27 6.57c.23-.52.64-1.06 1.3-1.5-.01.63.04 1.16.13 1.61.1.48.24.87.38 1.2-.38.3-.75.49-1.06.56-.39.09-.6 0-.69-.1-.27-.3-.4-.97-.06-1.77Zm3.73-2.22a5.83 5.83 0 0 1-1.15 2.76l-.17-.62a7.2 7.2 0 0 1-.09-1.94l.13-.04c.46-.12.89-.17 1.28-.16Z"]),bbt=Mn("Video16Filled","16",["M1 5.5A2.5 2.5 0 0 1 3.5 3h4A2.5 2.5 0 0 1 10 5.5v5A2.5 2.5 0 0 1 7.5 13h-4A2.5 2.5 0 0 1 1 10.5v-5Zm12.04 6.28L10.9 10.3l.02-.28V5.98c0-.1 0-.19-.02-.28l2.14-1.48c.82-.57 1.96.02 1.96 1.03v5.5c0 1-1.14 1.6-1.96 1.03Z"]),zH=Mn("Video20Filled","20",["M2 7a3 3 0 0 1 3-3h5a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7Zm14.04 7.78L14 13.37V6.63l2.04-1.4c.83-.58 1.96.01 1.96 1.02v7.5c0 1-1.13 1.6-1.96 1.03Z"]),cRe=Mn("Video20Regular","20",["M5 4a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h5a3 3 0 0 0 3-3v-.32l3.04 2.1c.83.57 1.96-.03 1.96-1.03v-7.5c0-1-1.13-1.6-1.96-1.03L13 7.32V7a3 3 0 0 0-3-3H5Zm8 4.54 3.6-2.5c.17-.1.4.01.4.21v7.5c0 .2-.23.32-.4.2L13 11.46V8.54ZM3 7c0-1.1.9-2 2-2h5a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7Z"]),Tbt=Mn("VideoBackgroundEffect20Filled","20",["M6.2 4 2 8.2V6.8L4.8 4h1.4Zm7 0-1.46 1.46a3.48 3.48 0 0 0-1.02-.39L11.79 4h1.42Zm-1.08 3.17a2.51 2.51 0 0 0-2.34-1.16 2.5 2.5 0 1 0 2.34 1.16Zm.72-.72c.2.29.37.6.48.94L16.69 4 16.5 4h-1.2l-2.46 2.45ZM7.5 12c-.08 0-.15 0-.22.02A1.5 1.5 0 0 0 6 13.5V16h8v-2.5a1.5 1.5 0 0 0-1.5-1.5h-5Zm5-1c.22 0 .43.03.63.08L18 6.2V5.5c0-.2-.04-.4-.12-.59l-4.5 4.5a3.5 3.5 0 0 1-.93 1.59h.05Zm1.9.88c.23.27.4.58.5.93L18 9.7V8.29l-3.6 3.6ZM15 16v-1.2l3-3v1.4L15.2 16H15Zm-10-.3v-1.4l-1.7 1.69.2.01h1.2l.3-.3Zm1.57-6.48c.08.36.21.7.4 1.02L2.11 15.1A1.5 1.5 0 0 1 2 14.5v-.7l4.57-4.58ZM9.71 4 2 11.7v-1.4L8.3 4h1.4Z"]),dRe=Mn("VideoBackgroundEffect20Regular","20",["M6.2 4 2 8.2V6.8L4.8 4h1.4ZM3.5 16H5v-1.7l-1.7 1.69.2.01Zm11.7 0H15v-1.2l3-3v1.4L15.2 16ZM18 9.7l-3.1 3.1a2.5 2.5 0 0 0-.5-.92L18 8.3v1.42ZM12.5 12a1.5 1.5 0 0 1 1.5 1.5V16h-1v-2.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5V16H6v-2.5c0-.08 0-.15.02-.22A1.5 1.5 0 0 1 7.5 12h5Zm-2.78-1.02a2.49 2.49 0 0 1-2.21-2.7 2.5 2.5 0 1 1 2.21 2.7ZM10 10a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm-7.88 5.09 4.84-4.85a3.48 3.48 0 0 1-.39-1.02L2 13.79v.71c0 .2.04.4.12.59Zm9.62-9.63a3.48 3.48 0 0 0-1.02-.39L11.79 4h1.42l-1.47 1.46Zm1.58 1.93a3.49 3.49 0 0 0-.48-.94L15.29 4h1.21l.2.01-3.38 3.38ZM12.45 11c.44-.43.76-.98.93-1.59l4.5-4.5c.08.18.12.38.12.59v.7l-4.87 4.88a2.5 2.5 0 0 0-.63-.08h-.05ZM2 11.7 9.7 4H8.3L2 10.3v1.4Z"]),Dse=Mn("VideoOff20Filled","20",["M2.85 2.15a.5.5 0 1 0-.7.7l1.48 1.48A3 3 0 0 0 2 7v6a3 3 0 0 0 3 3h5a3 3 0 0 0 2.93-2.36l4.22 4.21a.5.5 0 0 0 .7-.7l-15-15ZM14 11.88l3.08 3.07c.5-.14.92-.6.92-1.2v-7.5c0-1-1.13-1.6-1.96-1.03L14 6.63v5.25ZM6.12 4 13 10.88V7a3 3 0 0 0-3-3H6.12Z"]),Cbt=Mn("VideoPerson20Filled","20",["M12.5 8.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0ZM2 5.5C2 4.67 2.67 4 3.5 4h13c.83 0 1.5.67 1.5 1.5v9c0 .83-.67 1.5-1.5 1.5h-13A1.5 1.5 0 0 1 2 14.5v-9ZM14 15h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-13a.5.5 0 0 0-.5.5v9c0 .28.22.5.5.5H6v-1.5c0-.83.67-1.5 1.5-1.5h5c.83 0 1.5.67 1.5 1.5V15Z"]),Lse=Mn("VideoPersonStar20Filled","20",["M2 5.5C2 4.67 2.67 4 3.5 4h13c.83 0 1.5.67 1.5 1.5v4.76a5.5 5.5 0 0 0-1-.66V5.5a.5.5 0 0 0-.5-.5h-13a.5.5 0 0 0-.5.5v9c0 .28.22.5.5.5H6v-1.5c0-.83.67-1.5 1.5-1.5h2.1a5.48 5.48 0 0 0-.4 4H3.5A1.5 1.5 0 0 1 2 14.5v-9Zm10.5 3c0 .34-.07.66-.19.95-.8.35-1.5.88-2.04 1.54L10 11a2.5 2.5 0 1 1 2.5-2.5Zm6.5 6a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4.02-2.64a.5.5 0 0 0-.96 0l-.47 1.53H12c-.48 0-.69.65-.3.95l1.26.94-.48 1.53c-.15.49.38.89.77.59l1.25-.95 1.25.95c.4.3.92-.1.77-.59l-.48-1.53 1.25-.94c.4-.3.2-.95-.3-.95h-1.54l-.47-1.53Z"]),Ose=Mn("VideoPersonStarOff20Filled","20",["M2.85 2.15a.5.5 0 1 0-.7.7L3.3 4.01C2.57 4.11 2 4.74 2 5.5v9c0 .83.67 1.5 1.5 1.5h5.7a5.5 5.5 0 0 1 .4-4H7.5c-.83 0-1.5.67-1.5 1.5V15H3.5a.5.5 0 0 1-.5-.5v-9c0-.28.22-.5.5-.5h.8l3.22 3.22-.02.28a2.5 2.5 0 0 0 2.77 2.49v-.01l.71.71a4.5 4.5 0 0 0 6.37 6.29.5.5 0 0 0 .5-.83l-15-15ZM16.5 17.2c-.13.27-.47.4-.75.2l-1.25-.95-1.25.95c-.4.3-.92-.1-.77-.59l.48-1.53-1.25-.94c-.4-.3-.2-.95.3-.95h.68l3.8 3.81ZM8.57 6.45l3.25 3.25c.16-.1.32-.17.5-.25A2.5 2.5 0 0 0 10 6c-.53 0-1.02.17-1.43.45Zm3.99 3.99 1.45 1.45.01-.03a.5.5 0 0 1 .96 0l.45 1.45.08.08H17c.48 0 .68.65.3.95l-.48.36 1.74 1.74a4.5 4.5 0 0 0-6-6ZM6.12 4l1 1h9.38c.28 0 .5.22.5.5v4.1c.36.18.7.4 1 .66V5.5c0-.83-.67-1.5-1.5-1.5H6.12Z"]),A5=Mn("VideoProhibited16Filled","16",["M1 5a2.5 2.5 0 0 1 2.5-2.5h5A2.5 2.5 0 0 1 11 5v1.02a5.5 5.5 0 0 0-4.63 7.48H3.5A2.5 2.5 0 0 1 1 11V5Zm11 1.02c1.13.1 2.17.55 3 1.24V4.5a.5.5 0 0 0-.82-.39L12 5.9v.13ZM7 11.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0Zm1 0a3.5 3.5 0 0 1 5.6-2.8l-4.9 4.9a3.48 3.48 0 0 1-.7-2.1Zm3.5 3.5c-.79 0-1.51-.26-2.1-.7l4.9-4.9a3.5 3.5 0 0 1-2.8 5.6Z"]),uRe=Mn("VideoProhibited20Filled","20",["M13 6.5A2.5 2.5 0 0 0 10.5 4h-6A2.5 2.5 0 0 0 2 6.5v7A2.5 2.5 0 0 0 4.5 16h4.7A5.5 5.5 0 0 1 13 9.2V6.5Zm5-.3v4.06a5.48 5.48 0 0 0-4-1.24V7.93l2.77-2.31a.75.75 0 0 1 1.23.57Zm-8 8.3a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0Zm1 0a3.5 3.5 0 0 1 5.6-2.8l-4.9 4.9a3.48 3.48 0 0 1-.7-2.1Zm3.5 3.5c-.79 0-1.51-.26-2.1-.7l4.9-4.9a3.5 3.5 0 0 1-2.8 5.6Z"]),_bt=Mn("Warning12Filled","12",["M5.21 1.46a.9.9 0 0 1 1.58 0l4.09 7.17a.92.92 0 0 1-.79 1.37H1.91a.92.92 0 0 1-.79-1.37l4.1-7.17ZM5.5 4.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-1 0ZM6 6.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z"]),Ebt=Mn("Warning16Filled","16",["M9.1 2.64a1.25 1.25 0 0 0-2.19 0l-4.75 8.5c-.47.83.13 1.86 1.09 1.86h9.5c.96 0 1.56-1.03 1.1-1.86l-4.76-8.5Zm-.35 7.61a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM7.5 8V5.5a.5.5 0 0 1 1 0V8a.5.5 0 0 1-1 0Z"]),hRe=Mn("WifiWarning20Filled","20",["M16.73 7.56c.4.4.78.87 1.11 1.35a.75.75 0 0 1-1.23.85 7.97 7.97 0 0 0-13.14 0 .75.75 0 1 1-1.23-.86 9.47 9.47 0 0 1 14.5-1.34ZM5.48 9.46a6.44 6.44 0 0 1 8.65-.43c-.52.1-1 .4-1.31.9a4.94 4.94 0 0 0-7.2 1.84.75.75 0 0 1-1.33-.67c.3-.61.7-1.16 1.19-1.65Zm4.3 6.51 1.08-2.15a1.24 1.24 0 1 0-1.08 2.15Zm1.7-3.4.68-1.35a4.13 4.13 0 0 0-5.9 1.9.75.75 0 0 0 1.37.6c.13-.32.32-.6.54-.82.9-.9 2.3-1.01 3.31-.33Zm2.12-2.02-3.5 7A1 1 0 0 0 11 19h7a1 1 0 0 0 .9-1.45l-3.5-7a1 1 0 0 0-1.8 0ZM15 12.5v3a.5.5 0 1 1-1 0v-3a.5.5 0 1 1 1 0Zm-.5 5.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Z"]),Abt=Mn("WindowHeaderHorizontal20Regular","20",["M5.5 3A2.5 2.5 0 0 0 3 5.5v9A2.5 2.5 0 0 0 5.5 17h9a2.5 2.5 0 0 0 2.5-2.5v-9A2.5 2.5 0 0 0 14.5 3h-9ZM4 14.5V7h12v7.5c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 14.5Z"]),Ibt="fui-Icon-filled",wbt="fui-Icon-regular",kbt=uo({root:{mc9l5x:"fjseox"},visible:{mc9l5x:"f1w7gpdv"}},{d:[".fjseox{display:none;}",".f1w7gpdv{display:inline;}"]}),Nse=(t,e)=>{const i=r=>{const{className:o,filled:l,...d}=r,h=kbt();return $.createElement($.Fragment,null,$.createElement(t,Object.assign({},d,{className:ea(h.root,l&&h.visible,Ibt,o)})),$.createElement(e,Object.assign({},d,{className:ea(h.root,!l&&h.visible,wbt,o)})))};return i.displayName="CompoundIcon",i};function Rbt(t){const e=t.clientX,i=t.clientY,r=e+1,o=i+1;function l(){return{left:e,top:i,right:r,bottom:o,x:e,y:i,height:1,width:1}}return{getBoundingClientRect:l}}const pRe="data-popper-is-intersecting",gRe="data-popper-escaped",mRe="data-popper-reference-hidden",Mbt="data-popper-placement",xse="fui-positioningend",Pbt=["top","right","bottom","left"],Rx=Math.min,_E=Math.max,uK=Math.round,jw=t=>({x:t,y:t}),Dbt={left:"right",right:"left",bottom:"top",top:"bottom"},Lbt={start:"end",end:"start"};function Bse(t,e,i){return _E(t,Rx(e,i))}function NM(t,e){return typeof t=="function"?t(e):t}function xM(t){return t.split("-")[0]}function I5(t){return t.split("-")[1]}function Fse(t){return t==="x"?"y":"x"}function Use(t){return t==="y"?"height":"width"}function VL(t){return["top","bottom"].includes(xM(t))?"y":"x"}function zse(t){return Fse(VL(t))}function Obt(t,e,i){i===void 0&&(i=!1);const r=I5(t),o=zse(t),l=Use(o);let d=o==="x"?r===(i?"end":"start")?"right":"left":r==="start"?"bottom":"top";return e.reference[l]>e.floating[l]&&(d=hK(d)),[d,hK(d)]}function Nbt(t){const e=hK(t);return[Vse(t),e,Vse(e)]}function Vse(t){return t.replace(/start|end/g,e=>Lbt[e])}function xbt(t,e,i){const r=["left","right"],o=["right","left"],l=["top","bottom"],d=["bottom","top"];switch(t){case"top":case"bottom":return i?e?o:r:e?r:o;case"left":case"right":return e?l:d;default:return[]}}function Bbt(t,e,i,r){const o=I5(t);let l=xbt(xM(t),i==="start",r);return o&&(l=l.map(d=>d+"-"+o),e&&(l=l.concat(l.map(Vse)))),l}function hK(t){return t.replace(/left|right|bottom|top/g,e=>Dbt[e])}function Fbt(t){return{top:0,right:0,bottom:0,left:0,...t}}function fRe(t){return typeof t!="number"?Fbt(t):{top:t,right:t,bottom:t,left:t}}function pK(t){const{x:e,y:i,width:r,height:o}=t;return{width:r,height:o,top:i,left:e,right:e+r,bottom:i+o,x:e,y:i}}function vRe(t,e,i){let{reference:r,floating:o}=t;const l=VL(e),d=zse(e),h=Use(d),p=xM(e),g=l==="y",f=r.x+r.width/2-o.width/2,y=r.y+r.height/2-o.height/2,T=r[h]/2-o[h]/2;let C;switch(p){case"top":C={x:f,y:r.y-o.height};break;case"bottom":C={x:f,y:r.y+r.height};break;case"right":C={x:r.x+r.width,y};break;case"left":C={x:r.x-o.width,y};break;default:C={x:r.x,y:r.y}}switch(I5(e)){case"start":C[d]-=T*(i&&g?-1:1);break;case"end":C[d]+=T*(i&&g?-1:1);break}return C}const Ubt=async(t,e,i)=>{const{placement:r="bottom",strategy:o="absolute",middleware:l=[],platform:d}=i,h=l.filter(Boolean),p=await(d.isRTL==null?void 0:d.isRTL(e));let g=await d.getElementRects({reference:t,floating:e,strategy:o}),{x:f,y}=vRe(g,r,p),T=r,C={},E=0;for(let I=0;I<h.length;I++){const{name:w,fn:D}=h[I],{x:F,y:x,data:B,reset:L}=await D({x:f,y,initialPlacement:r,placement:T,strategy:o,middlewareData:C,rects:g,platform:d,elements:{reference:t,floating:e}});f=F??f,y=x??y,C={...C,[w]:{...C[w],...B}},L&&E<=50&&(E++,typeof L=="object"&&(L.placement&&(T=L.placement),L.rects&&(g=L.rects===!0?await d.getElementRects({reference:t,floating:e,strategy:o}):L.rects),{x:f,y}=vRe(g,T,p)),I=-1)}return{x:f,y,placement:T,strategy:o,middlewareData:C}};async function w5(t,e){var i;e===void 0&&(e={});const{x:r,y:o,platform:l,rects:d,elements:h,strategy:p}=t,{boundary:g="clippingAncestors",rootBoundary:f="viewport",elementContext:y="floating",altBoundary:T=!1,padding:C=0}=NM(e,t),E=fRe(C),w=h[T?y==="floating"?"reference":"floating":y],D=pK(await l.getClippingRect({element:(i=await(l.isElement==null?void 0:l.isElement(w)))==null||i?w:w.contextElement||await(l.getDocumentElement==null?void 0:l.getDocumentElement(h.floating)),boundary:g,rootBoundary:f,strategy:p})),F=y==="floating"?{x:r,y:o,width:d.floating.width,height:d.floating.height}:d.reference,x=await(l.getOffsetParent==null?void 0:l.getOffsetParent(h.floating)),B=await(l.isElement==null?void 0:l.isElement(x))?await(l.getScale==null?void 0:l.getScale(x))||{x:1,y:1}:{x:1,y:1},L=pK(l.convertOffsetParentRelativeRectToViewportRelativeRect?await l.convertOffsetParentRelativeRectToViewportRelativeRect({elements:h,rect:F,offsetParent:x,strategy:p}):F);return{top:(D.top-L.top+E.top)/B.y,bottom:(L.bottom-D.bottom+E.bottom)/B.y,left:(D.left-L.left+E.left)/B.x,right:(L.right-D.right+E.right)/B.x}}const zbt=t=>({name:"arrow",options:t,async fn(e){const{x:i,y:r,placement:o,rects:l,platform:d,elements:h,middlewareData:p}=e,{element:g,padding:f=0}=NM(t,e)||{};if(g==null)return{};const y=fRe(f),T={x:i,y:r},C=zse(o),E=Use(C),I=await d.getDimensions(g),w=C==="y",D=w?"top":"left",F=w?"bottom":"right",x=w?"clientHeight":"clientWidth",B=l.reference[E]+l.reference[C]-T[C]-l.floating[E],L=T[C]-l.reference[C],z=await(d.getOffsetParent==null?void 0:d.getOffsetParent(g));let H=z?z[x]:0;(!H||!await(d.isElement==null?void 0:d.isElement(z)))&&(H=h.floating[x]||l.floating[E]);const j=B/2-L/2,J=H/2-I[E]/2-1,Z=Rx(y[D],J),re=Rx(y[F],J),ne=Z,le=H-I[E]-re,he=H/2-I[E]/2+j,Me=Bse(ne,he,le),Le=!p.arrow&&I5(o)!=null&&he!==Me&&l.reference[E]/2-(he<ne?Z:re)-I[E]/2<0,pe=Le?he<ne?he-ne:he-le:0;return{[C]:T[C]+pe,data:{[C]:Me,centerOffset:he-Me-pe,...Le&&{alignmentOffset:pe}},reset:Le}}}),Vbt=function(t){return t===void 0&&(t={}),{name:"flip",options:t,async fn(e){var i,r;const{placement:o,middlewareData:l,rects:d,initialPlacement:h,platform:p,elements:g}=e,{mainAxis:f=!0,crossAxis:y=!0,fallbackPlacements:T,fallbackStrategy:C="bestFit",fallbackAxisSideDirection:E="none",flipAlignment:I=!0,...w}=NM(t,e);if((i=l.arrow)!=null&&i.alignmentOffset)return{};const D=xM(o),F=VL(h),x=xM(h)===h,B=await(p.isRTL==null?void 0:p.isRTL(g.floating)),L=T||(x||!I?[hK(h)]:Nbt(h)),z=E!=="none";!T&&z&&L.push(...Bbt(h,I,E,B));const H=[h,...L],j=await w5(e,w),J=[];let Z=((r=l.flip)==null?void 0:r.overflows)||[];if(f&&J.push(j[D]),y){const he=Obt(o,d,B);J.push(j[he[0]],j[he[1]])}if(Z=[...Z,{placement:o,overflows:J}],!J.every(he=>he<=0)){var re,ne;const he=(((re=l.flip)==null?void 0:re.index)||0)+1,Me=H[he];if(Me)return{data:{index:he,overflows:Z},reset:{placement:Me}};let Le=(ne=Z.filter(pe=>pe.overflows[0]<=0).sort((pe,te)=>pe.overflows[1]-te.overflows[1])[0])==null?void 0:ne.placement;if(!Le)switch(C){case"bestFit":{var le;const pe=(le=Z.filter(te=>{if(z){const Se=VL(te.placement);return Se===F||Se==="y"}return!0}).map(te=>[te.placement,te.overflows.filter(Se=>Se>0).reduce((Se,ce)=>Se+ce,0)]).sort((te,Se)=>te[1]-Se[1])[0])==null?void 0:le[0];pe&&(Le=pe);break}case"initialPlacement":Le=h;break}if(o!==Le)return{reset:{placement:Le}}}return{}}}};function yRe(t,e){return{top:t.top-e.height,right:t.right-e.width,bottom:t.bottom-e.height,left:t.left-e.width}}function SRe(t){return Pbt.some(e=>t[e]>=0)}const $bt=function(t){return t===void 0&&(t={}),{name:"hide",options:t,async fn(e){const{rects:i}=e,{strategy:r="referenceHidden",...o}=NM(t,e);switch(r){case"referenceHidden":{const l=await w5(e,{...o,elementContext:"reference"}),d=yRe(l,i.reference);return{data:{referenceHiddenOffsets:d,referenceHidden:SRe(d)}}}case"escaped":{const l=await w5(e,{...o,altBoundary:!0}),d=yRe(l,i.floating);return{data:{escapedOffsets:d,escaped:SRe(d)}}}default:return{}}}}};async function Hbt(t,e){const{placement:i,platform:r,elements:o}=t,l=await(r.isRTL==null?void 0:r.isRTL(o.floating)),d=xM(i),h=I5(i),p=VL(i)==="y",g=["left","top"].includes(d)?-1:1,f=l&&p?-1:1,y=NM(e,t);let{mainAxis:T,crossAxis:C,alignmentAxis:E}=typeof y=="number"?{mainAxis:y,crossAxis:0,alignmentAxis:null}:{mainAxis:y.mainAxis||0,crossAxis:y.crossAxis||0,alignmentAxis:y.alignmentAxis};return h&&typeof E=="number"&&(C=h==="end"?E*-1:E),p?{x:C*f,y:T*g}:{x:T*g,y:C*f}}const jbt=function(t){return t===void 0&&(t=0),{name:"offset",options:t,async fn(e){var i,r;const{x:o,y:l,placement:d,middlewareData:h}=e,p=await Hbt(e,t);return d===((i=h.offset)==null?void 0:i.placement)&&(r=h.arrow)!=null&&r.alignmentOffset?{}:{x:o+p.x,y:l+p.y,data:{...p,placement:d}}}}},Gbt=function(t){return t===void 0&&(t={}),{name:"shift",options:t,async fn(e){const{x:i,y:r,placement:o}=e,{mainAxis:l=!0,crossAxis:d=!1,limiter:h={fn:w=>{let{x:D,y:F}=w;return{x:D,y:F}}},...p}=NM(t,e),g={x:i,y:r},f=await w5(e,p),y=VL(xM(o)),T=Fse(y);let C=g[T],E=g[y];if(l){const w=T==="y"?"top":"left",D=T==="y"?"bottom":"right",F=C+f[w],x=C-f[D];C=Bse(F,C,x)}if(d){const w=y==="y"?"top":"left",D=y==="y"?"bottom":"right",F=E+f[w],x=E-f[D];E=Bse(F,E,x)}const I=h.fn({...e,[T]:C,[y]:E});return{...I,data:{x:I.x-i,y:I.y-r,enabled:{[T]:l,[y]:d}}}}}},qbt=function(t){return t===void 0&&(t={}),{options:t,fn(e){const{x:i,y:r,placement:o,rects:l,middlewareData:d}=e,{offset:h=0,mainAxis:p=!0,crossAxis:g=!0}=NM(t,e),f={x:i,y:r},y=VL(o),T=Fse(y);let C=f[T],E=f[y];const I=NM(h,e),w=typeof I=="number"?{mainAxis:I,crossAxis:0}:{mainAxis:0,crossAxis:0,...I};if(p){const x=T==="y"?"height":"width",B=l.reference[T]-l.floating[x]+w.mainAxis,L=l.reference[T]+l.reference[x]-w.mainAxis;C<B?C=B:C>L&&(C=L)}if(g){var D,F;const x=T==="y"?"width":"height",B=["top","left"].includes(xM(o)),L=l.reference[y]-l.floating[x]+(B&&((D=d.offset)==null?void 0:D[y])||0)+(B?0:w.crossAxis),z=l.reference[y]+l.reference[x]+(B?0:((F=d.offset)==null?void 0:F[y])||0)-(B?w.crossAxis:0);E<L?E=L:E>z&&(E=z)}return{[T]:C,[y]:E}}}},Wbt=function(t){return t===void 0&&(t={}),{name:"size",options:t,async fn(e){var i,r;const{placement:o,rects:l,platform:d,elements:h}=e,{apply:p=()=>{},...g}=NM(t,e),f=await w5(e,g),y=xM(o),T=I5(o),C=VL(o)==="y",{width:E,height:I}=l.floating;let w,D;y==="top"||y==="bottom"?(w=y,D=T===(await(d.isRTL==null?void 0:d.isRTL(h.floating))?"start":"end")?"left":"right"):(D=y,w=T==="end"?"top":"bottom");const F=I-f.top-f.bottom,x=E-f.left-f.right,B=Rx(I-f[w],F),L=Rx(E-f[D],x),z=!e.middlewareData.shift;let H=B,j=L;if((i=e.middlewareData.shift)!=null&&i.enabled.x&&(j=x),(r=e.middlewareData.shift)!=null&&r.enabled.y&&(H=F),z&&!T){const Z=_E(f.left,0),re=_E(f.right,0),ne=_E(f.top,0),le=_E(f.bottom,0);C?j=E-2*(Z!==0||re!==0?Z+re:_E(f.left,f.right)):H=I-2*(ne!==0||le!==0?ne+le:_E(f.top,f.bottom))}await p({...e,availableWidth:j,availableHeight:H});const J=await d.getDimensions(h.floating);return E!==J.width||I!==J.height?{reset:{rects:!0}}:{}}}};function gK(){return typeof window<"u"}function k5(t){return bRe(t)?(t.nodeName||"").toLowerCase():"#document"}function RC(t){var e;return(t==null||(e=t.ownerDocument)==null?void 0:e.defaultView)||window}function BM(t){var e;return(e=(bRe(t)?t.ownerDocument:t.document)||window.document)==null?void 0:e.documentElement}function bRe(t){return gK()?t instanceof Node||t instanceof RC(t).Node:!1}function CA(t){return gK()?t instanceof Element||t instanceof RC(t).Element:!1}function Gw(t){return gK()?t instanceof HTMLElement||t instanceof RC(t).HTMLElement:!1}function TRe(t){return!gK()||typeof ShadowRoot>"u"?!1:t instanceof ShadowRoot||t instanceof RC(t).ShadowRoot}function VH(t){const{overflow:e,overflowX:i,overflowY:r,display:o}=_A(t);return/auto|scroll|overlay|hidden|clip/.test(e+r+i)&&!["inline","contents"].includes(o)}function Kbt(t){return["table","td","th"].includes(k5(t))}function mK(t){return[":popover-open",":modal"].some(e=>{try{return t.matches(e)}catch{return!1}})}function $se(t){const e=Hse(),i=CA(t)?_A(t):t;return["transform","translate","scale","rotate","perspective"].some(r=>i[r]?i[r]!=="none":!1)||(i.containerType?i.containerType!=="normal":!1)||!e&&(i.backdropFilter?i.backdropFilter!=="none":!1)||!e&&(i.filter?i.filter!=="none":!1)||["transform","translate","scale","rotate","perspective","filter"].some(r=>(i.willChange||"").includes(r))||["paint","layout","strict","content"].some(r=>(i.contain||"").includes(r))}function Jbt(t){let e=$L(t);for(;Gw(e)&&!R5(e);){if($se(e))return e;if(mK(e))return null;e=$L(e)}return null}function Hse(){return typeof CSS>"u"||!CSS.supports?!1:CSS.supports("-webkit-backdrop-filter","none")}function R5(t){return["html","body","#document"].includes(k5(t))}function _A(t){return RC(t).getComputedStyle(t)}function fK(t){return CA(t)?{scrollLeft:t.scrollLeft,scrollTop:t.scrollTop}:{scrollLeft:t.scrollX,scrollTop:t.scrollY}}function $L(t){if(k5(t)==="html")return t;const e=t.assignedSlot||t.parentNode||TRe(t)&&t.host||BM(t);return TRe(e)?e.host:e}function CRe(t){const e=$L(t);return R5(e)?t.ownerDocument?t.ownerDocument.body:t.body:Gw(e)&&VH(e)?e:CRe(e)}function _Re(t,e,i){var r;e===void 0&&(e=[]);const o=CRe(t),l=o===((r=t.ownerDocument)==null?void 0:r.body),d=RC(o);return l?(jse(d),e.concat(d,d.visualViewport||[],VH(o)?o:[],[])):e.concat(o,_Re(o,[]))}function jse(t){return t.parent&&Object.getPrototypeOf(t.parent)?t.frameElement:null}function ERe(t){const e=_A(t);let i=parseFloat(e.width)||0,r=parseFloat(e.height)||0;const o=Gw(t),l=o?t.offsetWidth:i,d=o?t.offsetHeight:r,h=uK(i)!==l||uK(r)!==d;return h&&(i=l,r=d),{width:i,height:r,$:h}}function ARe(t){return CA(t)?t:t.contextElement}function M5(t){const e=ARe(t);if(!Gw(e))return jw(1);const i=e.getBoundingClientRect(),{width:r,height:o,$:l}=ERe(e);let d=(l?uK(i.width):i.width)/r,h=(l?uK(i.height):i.height)/o;return(!d||!Number.isFinite(d))&&(d=1),(!h||!Number.isFinite(h))&&(h=1),{x:d,y:h}}const Ybt=jw(0);function IRe(t){const e=RC(t);return!Hse()||!e.visualViewport?Ybt:{x:e.visualViewport.offsetLeft,y:e.visualViewport.offsetTop}}function Qbt(t,e,i){return e===void 0&&(e=!1),!i||e&&i!==RC(t)?!1:e}function $H(t,e,i,r){e===void 0&&(e=!1),i===void 0&&(i=!1);const o=t.getBoundingClientRect(),l=ARe(t);let d=jw(1);e&&(r?CA(r)&&(d=M5(r)):d=M5(t));const h=Qbt(l,i,r)?IRe(l):jw(0);let p=(o.left+h.x)/d.x,g=(o.top+h.y)/d.y,f=o.width/d.x,y=o.height/d.y;if(l){const T=RC(l),C=r&&CA(r)?RC(r):r;let E=T,I=jse(E);for(;I&&r&&C!==E;){const w=M5(I),D=I.getBoundingClientRect(),F=_A(I),x=D.left+(I.clientLeft+parseFloat(F.paddingLeft))*w.x,B=D.top+(I.clientTop+parseFloat(F.paddingTop))*w.y;p*=w.x,g*=w.y,f*=w.x,y*=w.y,p+=x,g+=B,E=RC(I),I=jse(E)}}return pK({width:f,height:y,x:p,y:g})}function Gse(t,e){const i=fK(t).scrollLeft;return e?e.left+i:$H(BM(t)).left+i}function wRe(t,e,i){i===void 0&&(i=!1);const r=t.getBoundingClientRect(),o=r.left+e.scrollLeft-(i?0:Gse(t,r)),l=r.top+e.scrollTop;return{x:o,y:l}}function Zbt(t){let{elements:e,rect:i,offsetParent:r,strategy:o}=t;const l=o==="fixed",d=BM(r),h=e?mK(e.floating):!1;if(r===d||h&&l)return i;let p={scrollLeft:0,scrollTop:0},g=jw(1);const f=jw(0),y=Gw(r);if((y||!y&&!l)&&((k5(r)!=="body"||VH(d))&&(p=fK(r)),Gw(r))){const C=$H(r);g=M5(r),f.x=C.x+r.clientLeft,f.y=C.y+r.clientTop}const T=d&&!y&&!l?wRe(d,p,!0):jw(0);return{width:i.width*g.x,height:i.height*g.y,x:i.x*g.x-p.scrollLeft*g.x+f.x+T.x,y:i.y*g.y-p.scrollTop*g.y+f.y+T.y}}function Xbt(t){return Array.from(t.getClientRects())}function eTt(t){const e=BM(t),i=fK(t),r=t.ownerDocument.body,o=_E(e.scrollWidth,e.clientWidth,r.scrollWidth,r.clientWidth),l=_E(e.scrollHeight,e.clientHeight,r.scrollHeight,r.clientHeight);let d=-i.scrollLeft+Gse(t);const h=-i.scrollTop;return _A(r).direction==="rtl"&&(d+=_E(e.clientWidth,r.clientWidth)-o),{width:o,height:l,x:d,y:h}}function tTt(t,e){const i=RC(t),r=BM(t),o=i.visualViewport;let l=r.clientWidth,d=r.clientHeight,h=0,p=0;if(o){l=o.width,d=o.height;const g=Hse();(!g||g&&e==="fixed")&&(h=o.offsetLeft,p=o.offsetTop)}return{width:l,height:d,x:h,y:p}}function iTt(t,e){const i=$H(t,!0,e==="fixed"),r=i.top+t.clientTop,o=i.left+t.clientLeft,l=Gw(t)?M5(t):jw(1),d=t.clientWidth*l.x,h=t.clientHeight*l.y,p=o*l.x,g=r*l.y;return{width:d,height:h,x:p,y:g}}function kRe(t,e,i){let r;if(e==="viewport")r=tTt(t,i);else if(e==="document")r=eTt(BM(t));else if(CA(e))r=iTt(e,i);else{const o=IRe(t);r={x:e.x-o.x,y:e.y-o.y,width:e.width,height:e.height}}return pK(r)}function RRe(t,e){const i=$L(t);return i===e||!CA(i)||R5(i)?!1:_A(i).position==="fixed"||RRe(i,e)}function nTt(t,e){const i=e.get(t);if(i)return i;let r=_Re(t,[]).filter(h=>CA(h)&&k5(h)!=="body"),o=null;const l=_A(t).position==="fixed";let d=l?$L(t):t;for(;CA(d)&&!R5(d);){const h=_A(d),p=$se(d);!p&&h.position==="fixed"&&(o=null),(l?!p&&!o:!p&&h.position==="static"&&!!o&&["absolute","fixed"].includes(o.position)||VH(d)&&!p&&RRe(t,d))?r=r.filter(f=>f!==d):o=h,d=$L(d)}return e.set(t,r),r}function aTt(t){let{element:e,boundary:i,rootBoundary:r,strategy:o}=t;const d=[...i==="clippingAncestors"?mK(e)?[]:nTt(e,this._c):[].concat(i),r],h=d[0],p=d.reduce((g,f)=>{const y=kRe(e,f,o);return g.top=_E(y.top,g.top),g.right=Rx(y.right,g.right),g.bottom=Rx(y.bottom,g.bottom),g.left=_E(y.left,g.left),g},kRe(e,h,o));return{width:p.right-p.left,height:p.bottom-p.top,x:p.left,y:p.top}}function rTt(t){const{width:e,height:i}=ERe(t);return{width:e,height:i}}function oTt(t,e,i){const r=Gw(e),o=BM(e),l=i==="fixed",d=$H(t,!0,l,e);let h={scrollLeft:0,scrollTop:0};const p=jw(0);if(r||!r&&!l)if((k5(e)!=="body"||VH(o))&&(h=fK(e)),r){const T=$H(e,!0,l,e);p.x=T.x+e.clientLeft,p.y=T.y+e.clientTop}else o&&(p.x=Gse(o));const g=o&&!r&&!l?wRe(o,h):jw(0),f=d.left+h.scrollLeft-p.x-g.x,y=d.top+h.scrollTop-p.y-g.y;return{x:f,y,width:d.width,height:d.height}}function qse(t){return _A(t).position==="static"}function MRe(t,e){if(!Gw(t)||_A(t).position==="fixed")return null;if(e)return e(t);let i=t.offsetParent;return BM(t)===i&&(i=i.ownerDocument.body),i}function PRe(t,e){const i=RC(t);if(mK(t))return i;if(!Gw(t)){let o=$L(t);for(;o&&!R5(o);){if(CA(o)&&!qse(o))return o;o=$L(o)}return i}let r=MRe(t,e);for(;r&&Kbt(r)&&qse(r);)r=MRe(r,e);return r&&R5(r)&&qse(r)&&!$se(r)?i:r||Jbt(t)||i}const sTt=async function(t){const e=this.getOffsetParent||PRe,i=this.getDimensions,r=await i(t.floating);return{reference:oTt(t.reference,await e(t.floating),t.strategy),floating:{x:0,y:0,width:r.width,height:r.height}}};function lTt(t){return _A(t).direction==="rtl"}const cTt={convertOffsetParentRelativeRectToViewportRelativeRect:Zbt,getDocumentElement:BM,getClippingRect:aTt,getOffsetParent:PRe,getElementRects:sTt,getClientRects:Xbt,getDimensions:rTt,getScale:M5,isElement:CA,isRTL:lTt},dTt=w5,uTt=jbt,hTt=Gbt,pTt=Vbt,gTt=Wbt,DRe=$bt,mTt=zbt,LRe=qbt,fTt=(t,e,i)=>{const r=new Map,o={platform:cTt,...i},l={...o.platform,_c:r};return Ubt(t,e,{...o,platform:l})};function ORe(t){const e=t.split("-");return{side:e[0],alignment:e[1]}}const vTt=t=>t.nodeName==="HTML"?t:t.parentNode||t.host,yTt=t=>{var e;if(t.nodeType!==1)return{};const i=(e=t.ownerDocument)===null||e===void 0?void 0:e.defaultView;return i?i.getComputedStyle(t,null):{}},vK=t=>{const e=t&&vTt(t);if(!e)return document.body;switch(e.nodeName){case"HTML":case"BODY":return e.ownerDocument.body;case"#document":return e.body}const{overflow:i,overflowX:r,overflowY:o}=yTt(e);return/(auto|scroll|overlay)/.test(i+o+r)?e:vK(e)},STt=t=>{var e;const i=vK(t);return i?i!==((e=i.ownerDocument)===null||e===void 0?void 0:e.body):!1};function Wse(t,e){if(e==="window")return t?.ownerDocument.documentElement;if(e==="clippingParents")return"clippingAncestors";if(e==="scrollParent"){let i=vK(t);return i.nodeName==="BODY"&&(i=t?.ownerDocument.documentElement),i}return e}var NRe;(function(t){t[t.FunctionComponent=0]="FunctionComponent",t[t.ClassComponent=1]="ClassComponent",t[t.IndeterminateComponent=2]="IndeterminateComponent",t[t.HostRoot=3]="HostRoot",t[t.HostPortal=4]="HostPortal",t[t.HostComponent=5]="HostComponent",t[t.HostText=6]="HostText",t[t.Fragment=7]="Fragment",t[t.Mode=8]="Mode",t[t.ContextConsumer=9]="ContextConsumer",t[t.ContextProvider=10]="ContextProvider",t[t.ForwardRef=11]="ForwardRef",t[t.Profiler=12]="Profiler",t[t.SuspenseComponent=13]="SuspenseComponent",t[t.MemoComponent=14]="MemoComponent",t[t.SimpleMemoComponent=15]="SimpleMemoComponent",t[t.LazyComponent=16]="LazyComponent",t[t.IncompleteClassComponent=17]="IncompleteClassComponent",t[t.DehydratedFragment=18]="DehydratedFragment",t[t.SuspenseListComponent=19]="SuspenseListComponent",t[t.FundamentalComponent=20]="FundamentalComponent",t[t.ScopeComponent=21]="ScopeComponent"})(NRe||(NRe={}));function bTt(t){if(!t)return null;for(const e in t)if(e.indexOf("__reactInternalInstance$")===0||e.indexOf("__reactFiber$")===0)return t[e];throw new Error("getReactFiber(): Failed to find a React Fiber on a node")}function xRe(t,e){if(typeof t=="number")return t;const{start:i,end:r,...o}=t,l=o,d=e?"end":"start",h=e?"start":"end";return t[d]&&(l.left=t[d]),t[h]&&(l.right=t[h]),l}const TTt=t=>({above:"top",below:"bottom",before:t?"right":"left",after:t?"left":"right"}),CTt=()=>({start:"start",end:"end",top:"start",bottom:"end",center:void 0}),_Tt=(t,e)=>{const i=t==="above"||t==="below",r=e==="top"||e==="bottom";return i&&r||!i&&!r},BRe=(t,e,i)=>{const r=_Tt(e,t)?"center":t,o=e&&TTt(i)[e],l=r&&CTt()[r];return o&&l?`${o}-${l}`:o},ETt=()=>({top:"above",bottom:"below",right:"after",left:"before"}),ATt=t=>t==="above"||t==="below"?{start:"start",end:"end"}:{start:"top",end:"bottom"},Kse=t=>{const{side:e,alignment:i}=ORe(t),r=ETt()[e],o=i&&ATt(r)[i];return{position:r,alignment:o}},ITt={above:{position:"above",align:"center"},"above-start":{position:"above",align:"start"},"above-end":{position:"above",align:"end"},below:{position:"below",align:"center"},"below-start":{position:"below",align:"start"},"below-end":{position:"below",align:"end"},before:{position:"before",align:"center"},"before-top":{position:"before",align:"top"},"before-bottom":{position:"before",align:"bottom"},after:{position:"after",align:"center"},"after-top":{position:"after",align:"top"},"after-bottom":{position:"after",align:"bottom"}};function FRe(t){return t==null?{}:typeof t=="string"?ITt[t]:t}function Jse(t,e,i){const r=$.useRef(!0),[o]=$.useState(()=>({value:t,callback:e,facade:{get current(){return o.value},set current(l){const d=o.value;d!==l&&(o.value=l,o.callback(l,d))}}}));return fA(()=>{r.current=!1},[]),o.callback=e,o.facade}function wTt(t){let e;return()=>(e||(e=new Promise(i=>{Promise.resolve().then(()=>{e=void 0,i(t())})})),e)}function kTt(t){if(t.nodeName==="BUTTON"||t.nodeName==="INPUT"||t.nodeName==="SELECT"||t.nodeName==="TEXTAREA"){var i;return!!(!((i=bTt(t))===null||i===void 0)&&i.pendingProps.autoFocus)}return!1}function RTt(t){return kTt(t)?NodeFilter.FILTER_ACCEPT:NodeFilter.FILTER_SKIP}function MTt(t){const{arrow:e,middlewareData:i}=t;if(!i.arrow||!e)return;const{x:r,y:o}=i.arrow;Object.assign(e.style,{left:r!=null?`${r}px`:"",top:o!=null?`${o}px`:""})}function PTt(t){var e,i,r;const{container:o,placement:l,middlewareData:d,strategy:h,lowPPI:p,coordinates:g,useTransform:f=!0}=t;if(!o)return;o.setAttribute(Mbt,l),o.removeAttribute(pRe),d.intersectionObserver.intersecting&&o.setAttribute(pRe,""),o.removeAttribute(gRe),!((e=d.hide)===null||e===void 0)&&e.escaped&&o.setAttribute(gRe,""),o.removeAttribute(mRe),!((i=d.hide)===null||i===void 0)&&i.referenceHidden&&o.setAttribute(mRe,"");const y=((r=o.ownerDocument.defaultView)===null||r===void 0?void 0:r.devicePixelRatio)||1,T=Math.round(g.x*y)/y,C=Math.round(g.y*y)/y;if(Object.assign(o.style,{position:h}),f){Object.assign(o.style,{transform:p?`translate(${T}px, ${C}px)`:`translate3d(${T}px, ${C}px, 0)`});return}Object.assign(o.style,{left:`${T}px`,top:`${C}px`})}const DTt=t=>{switch(t){case"always":case!0:return{applyMaxWidth:!0,applyMaxHeight:!0};case"width-always":case"width":return{applyMaxWidth:!0,applyMaxHeight:!1};case"height-always":case"height":return{applyMaxWidth:!1,applyMaxHeight:!0};default:return!1}};function LTt(){return{name:"coverTarget",fn:t=>{const{placement:e,rects:i,x:r,y:o}=t,l=ORe(e).side,d={x:r,y:o};switch(l){case"bottom":d.y-=i.reference.height;break;case"top":d.y+=i.reference.height;break;case"left":d.x+=i.reference.width;break;case"right":d.x-=i.reference.width;break}return d}}}function OTt(t){const{hasScrollableElement:e,flipBoundary:i,container:r,fallbackPositions:o=[],isRtl:l}=t,d=o.reduce((h,p)=>{const{position:g,align:f}=FRe(p),y=BRe(f,g,l);return y&&h.push(y),h},[]);return pTt({...e&&{boundary:"clippingAncestors"},...i&&{altBoundary:!0,boundary:Wse(r,i)},fallbackStrategy:"bestFit",...d.length&&{fallbackPlacements:d}})}function NTt(){return{name:"intersectionObserver",fn:async t=>{const e=t.rects.floating,i=await dTt(t,{altBoundary:!0}),r=i.top<e.height&&i.top>0,o=i.bottom<e.height&&i.bottom>0;return{data:{intersecting:r||o}}}}}const xTt=t=>({name:"resetMaxSize",fn({middlewareData:e,elements:i}){var r;if(!((r=e.resetMaxSize)===null||r===void 0)&&r.maxSizeAlreadyReset)return{};const{applyMaxWidth:o,applyMaxHeight:l}=t;return o&&(i.floating.style.removeProperty("box-sizing"),i.floating.style.removeProperty("max-width"),i.floating.style.removeProperty("width")),l&&(i.floating.style.removeProperty("box-sizing"),i.floating.style.removeProperty("max-height"),i.floating.style.removeProperty("height")),{data:{maxSizeAlreadyReset:!0},reset:{rects:!0}}}});function BTt(t,e){const{container:i,overflowBoundary:r,overflowBoundaryPadding:o,isRtl:l}=e;return gTt({...o&&{padding:xRe(o,l)},...r&&{altBoundary:!0,boundary:Wse(i,r)},apply({availableHeight:d,availableWidth:h,elements:p,rects:g}){const f=(C,E,I)=>{if(C&&(p.floating.style.setProperty("box-sizing","border-box"),p.floating.style.setProperty(`max-${E}`,`${I}px`),g.floating[E]>I)){p.floating.style.setProperty(E,`${I}px`);const w=E==="width"?"x":"y";p.floating.style.getPropertyValue(`overflow-${w}`)||p.floating.style.setProperty(`overflow-${w}`,"auto")}},{applyMaxWidth:y,applyMaxHeight:T}=t;f(y,"width",h),f(T,"height",d)}})}function FTt(t){return!t||typeof t=="number"||typeof t=="object"?t:({rects:{floating:e,reference:i},placement:r})=>{const{position:o,alignment:l}=Kse(r);return t({positionedRect:e,targetRect:i,position:o,alignment:l})}}function UTt(t){const e=FTt(t);return uTt(e)}function zTt(t){const{hasScrollableElement:e,shiftToCoverTarget:i,disableTether:r,overflowBoundary:o,container:l,overflowBoundaryPadding:d,isRtl:h}=t;return hTt({...e&&{boundary:"clippingAncestors"},...i&&{crossAxis:!0,limiter:LRe({crossAxis:!0,mainAxis:!1})},...r&&{crossAxis:r==="all",limiter:LRe({crossAxis:r!=="all",mainAxis:!1})},...d&&{padding:xRe(d,h)},...o&&{altBoundary:!0,boundary:Wse(l,o)}})}const URe="--fui-match-target-size";function VTt(){return{name:"matchTargetSize",fn:async t=>{const{rects:{reference:e,floating:i},elements:{floating:r},middlewareData:{matchTargetSize:{matchTargetSizeAttempt:o=!1}={}}}=t;if(e.width===i.width||o)return{};const{width:l}=e;return r.style.setProperty(URe,`${l}px`),r.style.width||(r.style.width=`var(${URe})`),{data:{matchTargetSizeAttempt:!0},reset:{rects:!0}}}}}function yK(t){const e=[];let i=t;for(;i;){const r=vK(i);if(t.ownerDocument.body===r){e.push(r);break}if(r.nodeName==="BODY"&&r!==t.ownerDocument.body){process.env.NODE_ENV!=="production"&&console.error("@fluentui/react-positioning: You are comparing two different documents! This is an unexpected error, please report this as a bug to the Fluent UI team ");break}e.push(r),i=r}return e}function $Tt(t,e){return process.env.NODE_ENV==="test"&&(t.ResizeObserver=class{observe(){}unobserve(){}disconnect(){}}),new t.ResizeObserver(e)}function HTt(t){let e=!1;const{container:i,target:r,arrow:o,strategy:l,middleware:d,placement:h,useTransform:p=!0,disableUpdateOnResize:g=!1}=t,f=i.ownerDocument.defaultView;if(!r||!i||!f)return{updatePosition:()=>{},dispose:()=>{}};const y=g?null:$Tt(f,D=>{D.every(x=>x.contentRect.width>0&&x.contentRect.height>0)&&I()});let T=!0;const C=new Set;Object.assign(i.style,{position:"fixed",left:0,top:0,margin:0});const E=()=>{e||(T&&(yK(i).forEach(D=>C.add(D)),yA(r)&&yK(r).forEach(D=>C.add(D)),C.forEach(D=>{D.addEventListener("scroll",I,{passive:!0})}),y?.observe(i),yA(r)&&y?.observe(r),T=!1),Object.assign(i.style,{position:l}),fTt(r,i,{placement:h,middleware:d,strategy:l}).then(({x:D,y:F,middlewareData:x,placement:B})=>{e||(MTt({arrow:o,middlewareData:x}),PTt({container:i,middlewareData:x,placement:B,coordinates:{x:D,y:F},lowPPI:(f?.devicePixelRatio||1)<=1,strategy:l,useTransform:p}),i.dispatchEvent(new CustomEvent(xse)))}).catch(D=>{process.env.NODE_ENV==="development"&&console.error("[usePositioning]: Failed to calculate position",D)}))},I=wTt(()=>E()),w=()=>{e=!0,f&&(f.removeEventListener("scroll",I),f.removeEventListener("resize",I)),C.forEach(D=>{D.removeEventListener("scroll",I)}),C.clear(),y?.disconnect()};return f&&(f.addEventListener("scroll",I,{passive:!0}),f.addEventListener("resize",I)),I(),{updatePosition:I,dispose:w}}const Yse="__FUIDT_CONTROLLER__",SK="__FUIDT_ELEMENT_METADATA__",jTt="__FUIDT_HTML_ELEMENT_REFERENCE__",zRe="__FUIDT_SERIALIZED_DATA_CHANGE__";function VRe(t,e){var i,r;const o=t;return!!(!(o==null||(i=o.ownerDocument)==null)&&i.defaultView&&o instanceof o.ownerDocument.defaultView[(r=void 0)!=null?r:"HTMLElement"])}const $Re=t=>!!(VRe(t)&&SK in t&&t.parentElement!==null),GTt=t=>{let e=null;const i=new MutationObserver(o=>{if(e)for(const l of o)l.type==="childList"&&Array.from(l.removedNodes).includes(e)&&r.withdraw()}),r={get selectedElement(){return e},select:o=>($Re(o)&&(e=o,i.observe(o.parentElement,{childList:!0,subtree:!1})),e&&o&&e[SK].references.has(o)||r.withdraw(),e),withdraw:()=>{e=null,i.disconnect(),t.postMessage(zRe)}};return r},qTt=t=>{let{defaultView:e}=t;e&&(e[Yse]||(e[Yse]=GTt(e)))},WTt=t=>{var e,i;return qTt(t),(e=(i=t.defaultView)==null?void 0:i[Yse])!=null?e:null},KTt=(t,e)=>JSON.parse(JSON.stringify(t,(r,o)=>VRe(o)?e.add(o):typeof o=="object"&&o&&Object.getPrototypeOf(o)!==Object.prototype&&Object.getPrototypeOf(o)!==Array.prototype?"toString"in o?o.toString():void 0:o));let JTt=0;const YTt=()=>jTt+":"+JTt++,QTt=()=>{const t=new Map,e=new WeakMap;return{add:r=>{if(e.has(r))return e.get(r);const o=YTt();return t.set(o,r),e.set(r,o),o},get:r=>{const o=t.get(r);if(o&&e.has(o))return o},has:r=>e.has(r)}},ZTt=function(t,e){return t===void 0&&(t=document),e===void 0&&(e=XTt),{name:"@floating-ui/devtools",fn:i=>{const{[SK]:r}=$Re(i.elements.floating)?i.elements.floating:Object.assign(i.elements.floating,{[SK]:{references:QTt(),serializedData:[]}}),o=KTt(e(i),r.references);r.serializedData.unshift(o);const l=WTt(t);if(r.serializedData.length>1&&i.elements.floating===l?.selectedElement){var d;(d=t.defaultView)==null||d.postMessage(zRe)}return{}}}},XTt=t=>({...t,type:"FloatingUIMiddleware"}),eCt=t=>e=>{const{elements:{floating:i,reference:r}}=e,o=new Set;yA(r)&&yK(r).forEach(h=>o.add(h)),yK(i).forEach(h=>o.add(h));const l=Array.isArray(t.flipBoundary)?t.flipBoundary:yA(t.flipBoundary)?[t.flipBoundary]:[],d=Array.isArray(t.overflowBoundary)?t.overflowBoundary:yA(t.overflowBoundary)?[t.overflowBoundary]:[];return{type:"FluentUIMiddleware",middlewareState:e,options:t,initialPlacement:Kse(e.initialPlacement),placement:Kse(e.placement),flipBoundaries:l,overflowBoundaries:d,scrollParents:Array.from(o)}};function tCt(t){"use no memo";const e=$.useRef(null),i=$.useRef(null),r=$.useRef(null),o=$.useRef(null),l=$.useRef(null),{enabled:d=!0}=t,h=iCt(t),p=$.useCallback(()=>{e.current&&e.current.dispose(),e.current=null;var E;const I=(E=r.current)!==null&&E!==void 0?E:i.current;d&&Koe()&&I&&o.current&&(e.current=HTt({container:o.current,target:I,arrow:l.current,...h(o.current,l.current)}))},[d,h]),g=Fl(E=>{r.current=E,p()});$.useImperativeHandle(t.positioningRef,()=>({updatePosition:()=>{var E;return(E=e.current)===null||E===void 0?void 0:E.updatePosition()},setTarget:E=>{if(t.target&&process.env.NODE_ENV!=="production"){const I=new Error;console.warn("Imperative setTarget should not be used at the same time as target option"),console.warn(I.stack)}g(E)}}),[t.target,g]),fA(()=>{var E;g((E=t.target)!==null&&E!==void 0?E:null)},[t.target,g]),fA(()=>{p()},[p]),process.env.NODE_ENV!=="production"&&$.useEffect(()=>{if(o.current){var E;const I=o.current,w=(E=I.ownerDocument)===null||E===void 0?void 0:E.createTreeWalker(I,NodeFilter.SHOW_ELEMENT,{acceptNode:RTt});for(;w.nextNode();){const D=w.currentNode;console.warn("<Popper>:",D),console.warn(['<Popper>: ^ this node contains "autoFocus" prop on a React element. This can break the initial',"positioning of an element and cause a window jump effect. This issue occurs because React polyfills",'"autoFocus" behavior to solve inconsistencies between different browsers:',"https://github.com/facebook/react/issues/11851#issuecomment-351787078",`
`,'However, ".focus()" in this case occurs before any other React effects will be executed',"(React.useEffect(), componentDidMount(), etc.) and we can not prevent this behavior. If you really",'want to use "autoFocus" please add "position: fixed" to styles of the element that is wrapped by','"Popper".',`In general, it's not recommended to use "autoFocus" as it may break accessibility aspects:`,"https://github.com/jsx-eslint/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-autofocus.md",`
`,'We suggest to use the "trapFocus" prop on Fluent components or a catch "ref" and then use','"ref.current.focus" in React.useEffect():',"https://reactjs.org/docs/refs-and-the-dom.html#adding-a-ref-to-a-dom-element"].join(" "))}}},[]);const f=Jse(null,E=>{i.current!==E&&(i.current=E,p())}),y=Fl(()=>{var E;return(E=t.onPositioningEnd)===null||E===void 0?void 0:E.call(t)}),T=Jse(null,E=>{if(o.current!==E){var I;(I=o.current)===null||I===void 0||I.removeEventListener(xse,y),E?.addEventListener(xse,y),o.current=E,p()}}),C=Jse(null,E=>{l.current!==E&&(l.current=E,p())});return{targetRef:f,containerRef:T,arrowRef:C}}function iCt(t){"use no memo";const{align:e,arrowPadding:i,autoSize:r,coverTarget:o,flipBoundary:l,offset:d,overflowBoundary:h,pinned:p,position:g,unstable_disableTether:f,positionFixed:y,strategy:T,overflowBoundaryPadding:C,fallbackPositions:E,useTransform:I,matchTargetSize:w,disableUpdateOnResize:D=!1,shiftToCoverTarget:F}=t,{dir:x,targetDocument:B}=Ov(),L=x==="rtl",z=T??y?"fixed":"absolute",H=DTt(r);return $.useCallback((j,J)=>{const Z=STt(j),re=[H&&xTt(H),w&&VTt(),d&&UTt(d),o&&LTt(),!p&&OTt({container:j,flipBoundary:l,hasScrollableElement:Z,isRtl:L,fallbackPositions:E}),zTt({container:j,hasScrollableElement:Z,overflowBoundary:h,disableTether:f,overflowBoundaryPadding:C,isRtl:L,shiftToCoverTarget:F}),H&&BTt(H,{container:j,overflowBoundary:h,overflowBoundaryPadding:C,isRtl:L}),NTt(),J&&mTt({element:J,padding:i}),DRe({strategy:"referenceHidden"}),DRe({strategy:"escaped"}),process.env.NODE_ENV!=="production"&&B&&ZTt(B,eCt(t))].filter(Boolean);return{placement:BRe(e,g,L),middleware:re,strategy:z,useTransform:I,disableUpdateOnResize:D}},[e,i,H,o,f,l,L,d,h,p,g,z,C,E,I,w,B,D])}const nCt=t=>{const[e,i]=$.useState(t);return[e,o=>{if(o==null){i(void 0);return}let l;o instanceof MouseEvent?l=o:l=o.nativeEvent,!(l instanceof MouseEvent)&&process.env.NODE_ENV!=="production"&&console.error("usePositioningMouseTarget should only be used with MouseEvent");const d=Rbt(l);i(d)}]},HRe=BH(void 0),aCt={open:!1,setOpen:()=>null,toggleOpen:()=>null,triggerRef:{current:null},contentRef:{current:null},arrowRef:{current:null},openOnContext:!1,openOnHover:!1,size:"medium",trapFocus:!1,inline:!1};HRe.Provider;const jRe=t=>sK(HRe,(e=aCt)=>t(e));function rCt(t){return yA(t)?{element:t}:typeof t=="object"?t===null?{element:null}:t:{}}var Qse=()=>{try{return vM["".concat("__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE")].A.getOwner()}catch{}try{return vM["".concat("__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")].ReactCurrentOwner.current}catch{process.env.NODE_ENV!=="production"&&console.error("use-disposable: failed to get current fiber, please report this bug to maintainers")}},GRe=Symbol.for("react.strict_mode"),oCt=()=>{if(process.env.NODE_ENV==="production")return!1;const t=$.useRef(void 0),e=$.useMemo(()=>Number($.version.split(".")[0]),[$.version]);if(isNaN(e)||e<18)return!1;if(t.current===void 0){let i=Qse();for(;i&&i.return;)i=i.return,(i.type===GRe||i.elementType===GRe)&&(t.current=!0)}return!!t.current},qRe=new WeakSet;function sCt(t,e){const i=Qse();$.useEffect(()=>{if(!qRe.has(i)){qRe.add(i),t();return}return t()},e)}var WRe=new WeakSet;function lCt(t,e){return $.useMemo(()=>{const i=Qse();return WRe.has(i)?t():(WRe.add(i),null)},e)}function cCt(t,e){var i;const r=oCt()&&process.env.NODE_ENV!=="production",o=r?lCt:$.useMemo,l=r?sCt:$.useEffect,[d,h]=(i=o(()=>t(),e))!=null?i:[null,()=>null];return l(()=>h,e),d}const dCt=uo({root:{qhf8xq:"f1euv43f",Bhzewxz:"f15twtuk",oyh7mz:["f1vgc2s3","f1e31b4d"],j35jbq:["f1e31b4d","f1vgc2s3"],Bj3rh1h:"f494woh"}},{d:[".f1euv43f{position:absolute;}",".f15twtuk{top:0;}",".f1vgc2s3{left:0;}",".f1e31b4d{right:0;}",".f494woh{z-index:1000000;}"]}),KRe=vM.useInsertionEffect,uCt=t=>{"use no memo";const{targetDocument:e,dir:i}=Ov(),r=Fmt(),o=Tke(),l=dCt(),d=Pmt(),h=ea(d,l.root,t.className),p=r??e?.body,g=cCt(()=>{if(p===void 0||t.disabled)return[null,()=>null];const f=p.ownerDocument.createElement("div");return p.appendChild(f),[f,()=>f.remove()]},[p]);return KRe?KRe(()=>{if(!g)return;const f=h.split(" ").filter(Boolean);return g.classList.add(...f),g.setAttribute("dir",i),g.setAttribute("data-portal-node","true"),o.current=g,()=>{g.classList.remove(...f),g.removeAttribute("dir")}},[h,i,g,o]):$.useMemo(()=>{g&&(g.className=h,g.setAttribute("dir",i),g.setAttribute("data-portal-node","true"),o.current=g)},[h,i,g,o]),g},hCt=t=>{const{element:e,className:i}=rCt(t.mountNode),r=$.useRef(null),o=uCt({disabled:!!e,className:i}),l=e??o,d={children:t.children,mountNode:l,virtualParentRootRef:r};return $.useEffect(()=>{if(!l)return;const h=r.current,p=l.contains(h);if(h&&!p)return Uwe(l,h),()=>{Uwe(l,void 0)}},[r,l]),d},pCt=t=>$.createElement("span",{hidden:!0,ref:t.virtualParentRootRef},t.mountNode&&_re.createPortal(t.children,t.mountNode)),JRe=t=>{const e=hCt(t);return pCt(e)};JRe.displayName="Portal";const YRe=t=>{Pd(t);const{iconOnly:e,iconPosition:i}=t;return Uf(t.root,{children:[i!=="after"&&t.icon&&yr(t.icon,{}),!e&&t.root.children,i==="after"&&t.icon&&yr(t.icon,{})]})},QRe=$.createContext(void 0),gCt={},ZRe=QRe.Provider,mCt=()=>{var t;return(t=$.useContext(QRe))!==null&&t!==void 0?t:gCt},XRe=(t,e)=>{const{size:i}=mCt(),{appearance:r="secondary",as:o="button",disabled:l=!1,disabledFocusable:d=!1,icon:h,iconPosition:p="before",shape:g="rounded",size:f=i??"medium"}=t,y=Ss(h,{elementType:"span"});return{appearance:r,disabled:l,disabledFocusable:d,iconPosition:p,shape:g,size:f,iconOnly:!!(y?.children&&!t.children),components:{root:"button",icon:"span"},root:Bl(_p(o,Ese(t.as,t)),{elementType:"button",defaultProps:{ref:e,type:o==="button"?"button":void 0}}),icon:y}},eMe={root:"fui-Button",icon:"fui-Button__icon"},fCt=pd("r1alrhcs",null,{r:[".r1alrhcs{align-items:center;box-sizing:border-box;display:inline-flex;justify-content:center;text-decoration-line:none;vertical-align:middle;margin:0;overflow:hidden;background-color:var(--colorNeutralBackground1);color:var(--colorNeutralForeground1);border:var(--strokeWidthThin) solid var(--colorNeutralStroke1);font-family:var(--fontFamilyBase);outline-style:none;padding:5px var(--spacingHorizontalM);min-width:96px;border-radius:var(--borderRadiusMedium);font-size:var(--fontSizeBase300);font-weight:var(--fontWeightSemibold);line-height:var(--lineHeightBase300);transition-duration:var(--durationFaster);transition-property:background,border,color;transition-timing-function:var(--curveEasyEase);}",".r1alrhcs:hover{background-color:var(--colorNeutralBackground1Hover);border-color:var(--colorNeutralStroke1Hover);color:var(--colorNeutralForeground1Hover);cursor:pointer;}",".r1alrhcs:hover:active{background-color:var(--colorNeutralBackground1Pressed);border-color:var(--colorNeutralStroke1Pressed);color:var(--colorNeutralForeground1Pressed);outline-style:none;}",".r1alrhcs[data-fui-focus-visible]{border-color:var(--colorStrokeFocus2);border-radius:var(--borderRadiusMedium);border-width:1px;outline:var(--strokeWidthThick) solid var(--colorTransparentStroke);box-shadow:0 0 0 var(--strokeWidthThin) var(--colorStrokeFocus2) inset;z-index:1;}"],s:["@media screen and (prefers-reduced-motion: reduce){.r1alrhcs{transition-duration:0.01ms;}}","@media (forced-colors: active){.r1alrhcs:focus{border-color:ButtonText;}.r1alrhcs:hover{background-color:HighlightText;border-color:Highlight;color:Highlight;forced-color-adjust:none;}.r1alrhcs:hover:active{background-color:HighlightText;border-color:Highlight;color:Highlight;forced-color-adjust:none;}}","@supports (-moz-appearance:button){.r1alrhcs[data-fui-focus-visible]{box-shadow:0 0 0 calc(var(--strokeWidthThin) + 0.25px) var(--colorStrokeFocus2) inset;}}"]}),vCt=pd("rywnvv2",null,[".rywnvv2{align-items:center;display:inline-flex;justify-content:center;font-size:20px;height:20px;width:20px;--fui-Button__icon--spacing:var(--spacingHorizontalSNudge);}"]),yCt=uo({outline:{De3pzq:"f1c21dwh",Jwef8y:"fjxutwb",iro3zm:"fwiml72"},primary:{De3pzq:"ffp7eso",g2u3we:"f1p3nwhy",h3c5rm:["f11589ue","f1pdflbu"],B9xav0g:"f1q5o8ev",zhjwy3:["f1pdflbu","f11589ue"],sj55zd:"f1phragk",Jwef8y:"f15wkkf3",Bgoe8wy:"f1s2uweq",Bwzppfd:["fr80ssc","fecsdlb"],oetu4i:"f1ukrpxl",gg5e9n:["fecsdlb","fr80ssc"],Bi91k9c:"f1rq72xc",iro3zm:"fnp9lpt",b661bw:"f1h0usnq",Bk6r4ia:["fs4ktlq","fx2bmrt"],B9zn80p:"f16h9ulv",Bpld233:["fx2bmrt","fs4ktlq"],B2d53fq:"f1d6v5y2",Bsw6fvg:"f1rirnrt",Bjwas2f:"f1uu00uk",Bn1d65q:["fkvaka8","f9a0qzu"],Bxeuatn:"f1ux7til",n51gp8:["f9a0qzu","fkvaka8"],Bbusuzp:"f1lkg8j3",ycbfsm:"fkc42ay",Bqrx1nm:"fq7113v",pgvf35:"ff1wgvm",Bh7lczh:["fiob0tu","f1x4h75k"],dpv3f4:"f1j6scgf",Bpnjhaq:["f1x4h75k","fiob0tu"],ze5xyy:"f4xjyn1",g2kj27:"fbgcvur",Bf756sw:"f1ks1yx8",Bow2dr7:["f1o6qegi","fmxjhhp"],Bvhedfk:"fcnxywj",Gye4lf:["fmxjhhp","f1o6qegi"],pc6evw:"f9ddjv3"},secondary:{},subtle:{De3pzq:"fhovq9v",g2u3we:"f1p3nwhy",h3c5rm:["f11589ue","f1pdflbu"],B9xav0g:"f1q5o8ev",zhjwy3:["f1pdflbu","f11589ue"],sj55zd:"fkfq4zb",Jwef8y:"f1t94bn6",Bgoe8wy:"f1s2uweq",Bwzppfd:["fr80ssc","fecsdlb"],oetu4i:"f1ukrpxl",gg5e9n:["fecsdlb","fr80ssc"],Bi91k9c:"fnwyq0v",Bk3fhr4:"ft1hn21",Bmfj8id:"fuxngvv",Bbdnnc7:"fy5bs14",iro3zm:"fsv2rcd",b661bw:"f1h0usnq",Bk6r4ia:["fs4ktlq","fx2bmrt"],B9zn80p:"f16h9ulv",Bpld233:["fx2bmrt","fs4ktlq"],B2d53fq:"f1omzyqd",em6i61:"f1dfjoow",vm6p8p:"f1j98vj9",x3br3k:"fj8yq94",ze5xyy:"f4xjyn1",Bx3q9su:"f1et0tmh",pc6evw:"f9ddjv3",xd2cci:"f1wi8ngl"},transparent:{De3pzq:"f1c21dwh",g2u3we:"f1p3nwhy",h3c5rm:["f11589ue","f1pdflbu"],B9xav0g:"f1q5o8ev",zhjwy3:["f1pdflbu","f11589ue"],sj55zd:"fkfq4zb",Jwef8y:"fjxutwb",Bgoe8wy:"f1s2uweq",Bwzppfd:["fr80ssc","fecsdlb"],oetu4i:"f1ukrpxl",gg5e9n:["fecsdlb","fr80ssc"],Bi91k9c:"f139oj5f",Bk3fhr4:"ft1hn21",Bmfj8id:"fuxngvv",iro3zm:"fwiml72",b661bw:"f1h0usnq",Bk6r4ia:["fs4ktlq","fx2bmrt"],B9zn80p:"f16h9ulv",Bpld233:["fx2bmrt","fs4ktlq"],B2d53fq:"f1fg1p5m",em6i61:"f1dfjoow",vm6p8p:"f1j98vj9",Bqrx1nm:"f1tme0vf",ze5xyy:"f4xjyn1",g2kj27:"f18onu3q",pc6evw:"f9ddjv3"},circular:{Beyfa6y:0,Bbmb7ep:0,Btl43ni:0,B7oj6ja:0,Dimara:"f44lkw9"},rounded:{},square:{Beyfa6y:0,Bbmb7ep:0,Btl43ni:0,B7oj6ja:0,Dimara:"f1fabniw"},small:{Bf4jedk:"fh7ncta",Byoj8tv:0,uwmqm3:0,z189sj:0,z8tnut:0,B0ocmuz:"fneth5b",Beyfa6y:0,Bbmb7ep:0,Btl43ni:0,B7oj6ja:0,Dimara:"ft85np5",Be2twd7:"fy9rknc",Bhrd7zp:"figsok6",Bg96gwp:"fwrc4pm"},smallWithIcon:{Byoj8tv:"f1brlhvm",z8tnut:"f1sl3k7w"},medium:{},large:{Bf4jedk:"f14es27b",Byoj8tv:0,uwmqm3:0,z189sj:0,z8tnut:0,B0ocmuz:"f4db1ww",Beyfa6y:0,Bbmb7ep:0,Btl43ni:0,B7oj6ja:0,Dimara:"ft85np5",Be2twd7:"fod5ikn",Bhrd7zp:"fl43uef",Bg96gwp:"faaz57k"},largeWithIcon:{Byoj8tv:"fy7v416",z8tnut:"f1a1bwwz"}},{d:[".f1c21dwh{background-color:var(--colorTransparentBackground);}",".ffp7eso{background-color:var(--colorBrandBackground);}",".f1p3nwhy{border-top-color:transparent;}",".f11589ue{border-right-color:transparent;}",".f1pdflbu{border-left-color:transparent;}",".f1q5o8ev{border-bottom-color:transparent;}",".f1phragk{color:var(--colorNeutralForegroundOnBrand);}",".fhovq9v{background-color:var(--colorSubtleBackground);}",".fkfq4zb{color:var(--colorNeutralForeground2);}",[".f44lkw9{border-radius:var(--borderRadiusCircular);}",{p:-1}],[".f1fabniw{border-radius:var(--borderRadiusNone);}",{p:-1}],".fh7ncta{min-width:64px;}",[".fneth5b{padding:3px var(--spacingHorizontalS);}",{p:-1}],[".ft85np5{border-radius:var(--borderRadiusMedium);}",{p:-1}],".fy9rknc{font-size:var(--fontSizeBase200);}",".figsok6{font-weight:var(--fontWeightRegular);}",".fwrc4pm{line-height:var(--lineHeightBase200);}",".f1brlhvm{padding-bottom:1px;}",".f1sl3k7w{padding-top:1px;}",".f14es27b{min-width:96px;}",[".f4db1ww{padding:8px var(--spacingHorizontalL);}",{p:-1}],[".ft85np5{border-radius:var(--borderRadiusMedium);}",{p:-1}],".fod5ikn{font-size:var(--fontSizeBase400);}",".fl43uef{font-weight:var(--fontWeightSemibold);}",".faaz57k{line-height:var(--lineHeightBase400);}",".fy7v416{padding-bottom:7px;}",".f1a1bwwz{padding-top:7px;}"],h:[".fjxutwb:hover{background-color:var(--colorTransparentBackgroundHover);}",".fwiml72:hover:active{background-color:var(--colorTransparentBackgroundPressed);}",".f15wkkf3:hover{background-color:var(--colorBrandBackgroundHover);}",".f1s2uweq:hover{border-top-color:transparent;}",".fr80ssc:hover{border-right-color:transparent;}",".fecsdlb:hover{border-left-color:transparent;}",".f1ukrpxl:hover{border-bottom-color:transparent;}",".f1rq72xc:hover{color:var(--colorNeutralForegroundOnBrand);}",".fnp9lpt:hover:active{background-color:var(--colorBrandBackgroundPressed);}",".f1h0usnq:hover:active{border-top-color:transparent;}",".fs4ktlq:hover:active{border-right-color:transparent;}",".fx2bmrt:hover:active{border-left-color:transparent;}",".f16h9ulv:hover:active{border-bottom-color:transparent;}",".f1d6v5y2:hover:active{color:var(--colorNeutralForegroundOnBrand);}",".f1t94bn6:hover{background-color:var(--colorSubtleBackgroundHover);}",".fnwyq0v:hover{color:var(--colorNeutralForeground2Hover);}",".ft1hn21:hover .fui-Icon-filled{display:inline;}",".fuxngvv:hover .fui-Icon-regular{display:none;}",".fy5bs14:hover .fui-Button__icon{color:var(--colorNeutralForeground2BrandHover);}",".fsv2rcd:hover:active{background-color:var(--colorSubtleBackgroundPressed);}",".f1omzyqd:hover:active{color:var(--colorNeutralForeground2Pressed);}",".f1dfjoow:hover:active .fui-Icon-filled{display:inline;}",".f1j98vj9:hover:active .fui-Icon-regular{display:none;}",".fj8yq94:hover:active .fui-Button__icon{color:var(--colorNeutralForeground2BrandPressed);}",".f139oj5f:hover{color:var(--colorNeutralForeground2BrandHover);}",".f1fg1p5m:hover:active{color:var(--colorNeutralForeground2BrandPressed);}"],m:[["@media (forced-colors: active){.f1rirnrt{background-color:Highlight;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f1uu00uk{border-top-color:HighlightText;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f9a0qzu{border-left-color:HighlightText;}.fkvaka8{border-right-color:HighlightText;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f1ux7til{border-bottom-color:HighlightText;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f1lkg8j3{color:HighlightText;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.fkc42ay{forced-color-adjust:none;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.fq7113v:hover{background-color:HighlightText;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.ff1wgvm:hover{border-top-color:Highlight;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f1x4h75k:hover{border-left-color:Highlight;}.fiob0tu:hover{border-right-color:Highlight;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f1j6scgf:hover{border-bottom-color:Highlight;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f4xjyn1:hover{color:Highlight;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.fbgcvur:hover:active{background-color:HighlightText;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f1ks1yx8:hover:active{border-top-color:Highlight;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f1o6qegi:hover:active{border-right-color:Highlight;}.fmxjhhp:hover:active{border-left-color:Highlight;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.fcnxywj:hover:active{border-bottom-color:Highlight;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f9ddjv3:hover:active{color:Highlight;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f1et0tmh:hover .fui-Button__icon{color:Highlight;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f1wi8ngl:hover:active .fui-Button__icon{color:Highlight;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f1tme0vf:hover{background-color:var(--colorTransparentBackground);}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f18onu3q:hover:active{background-color:var(--colorTransparentBackground);}}",{m:"(forced-colors: active)"}]]}),SCt=uo({base:{De3pzq:"f1bg9a2p",g2u3we:"f1jj8ep1",h3c5rm:["f15xbau","fy0fskl"],B9xav0g:"f4ikngz",zhjwy3:["fy0fskl","f15xbau"],sj55zd:"f1s2aq7o",Bceei9c:"fdrzuqr",Bfinmwp:"f15x8b5r",Jwef8y:"f1falr9n",Bgoe8wy:"f12mpcsy",Bwzppfd:["f1gwvigk","f18rmfxp"],oetu4i:"f1jnshp0",gg5e9n:["f18rmfxp","f1gwvigk"],Bi91k9c:"fvgxktp",eoavqd:"fphbwmw",Bk3fhr4:"f19vpps7",Bmfj8id:"fv5swzo",Bbdnnc7:"f1al02dq",iro3zm:"f1t6o4dc",b661bw:"f10ztigi",Bk6r4ia:["f1ft5sdu","f1gzf82w"],B9zn80p:"f12zbtn2",Bpld233:["f1gzf82w","f1ft5sdu"],B2d53fq:"fcvwxyo",c3iz72:"f8w4c43",em6i61:"f1ol4fw6",vm6p8p:"f1q1lw4e",x3br3k:"f1dwjv2g"},highContrast:{Bsw6fvg:"f4lkoma",Bjwas2f:"fg455y9",Bn1d65q:["f1rvyvqg","f14g86mu"],Bxeuatn:"f1cwzwz",n51gp8:["f14g86mu","f1rvyvqg"],Bbusuzp:"f1dcs8yz",Bm2fdqk:"fuigjrg",G867l3:"fjwq6ea",gdbnj:["f1lr3nhc","f1mbxvi6"],mxns5l:"fn5gmvv",o3nasb:["f1mbxvi6","f1lr3nhc"],Bqrx1nm:"f1vmkb5g",pgvf35:"f53ppgq",Bh7lczh:["f1663y11","f80fkiy"],dpv3f4:"f18v5270",Bpnjhaq:["f80fkiy","f1663y11"],ze5xyy:"f1kc2mi9",Bx3q9su:"f4dhi0o",g2kj27:"f1y0svfh",Bf756sw:"fihuait",Bow2dr7:["fnxhupq","fyd6l6x"],Bvhedfk:"fx507ft",Gye4lf:["fyd6l6x","fnxhupq"],pc6evw:"fb3rf2x",xd2cci:"fequ9m0"},outline:{De3pzq:"f1c21dwh",Jwef8y:"f9ql6rf",iro3zm:"f3h1zc4"},primary:{g2u3we:"f1p3nwhy",h3c5rm:["f11589ue","f1pdflbu"],B9xav0g:"f1q5o8ev",zhjwy3:["f1pdflbu","f11589ue"],Bgoe8wy:"f1s2uweq",Bwzppfd:["fr80ssc","fecsdlb"],oetu4i:"f1ukrpxl",gg5e9n:["fecsdlb","fr80ssc"],b661bw:"f1h0usnq",Bk6r4ia:["fs4ktlq","fx2bmrt"],B9zn80p:"f16h9ulv",Bpld233:["fx2bmrt","fs4ktlq"]},secondary:{},subtle:{De3pzq:"f1c21dwh",g2u3we:"f1p3nwhy",h3c5rm:["f11589ue","f1pdflbu"],B9xav0g:"f1q5o8ev",zhjwy3:["f1pdflbu","f11589ue"],Jwef8y:"f9ql6rf",Bgoe8wy:"f1s2uweq",Bwzppfd:["fr80ssc","fecsdlb"],oetu4i:"f1ukrpxl",gg5e9n:["fecsdlb","fr80ssc"],iro3zm:"f3h1zc4",b661bw:"f1h0usnq",Bk6r4ia:["fs4ktlq","fx2bmrt"],B9zn80p:"f16h9ulv",Bpld233:["fx2bmrt","fs4ktlq"]},transparent:{De3pzq:"f1c21dwh",g2u3we:"f1p3nwhy",h3c5rm:["f11589ue","f1pdflbu"],B9xav0g:"f1q5o8ev",zhjwy3:["f1pdflbu","f11589ue"],Jwef8y:"f9ql6rf",Bgoe8wy:"f1s2uweq",Bwzppfd:["fr80ssc","fecsdlb"],oetu4i:"f1ukrpxl",gg5e9n:["fecsdlb","fr80ssc"],iro3zm:"f3h1zc4",b661bw:"f1h0usnq",Bk6r4ia:["fs4ktlq","fx2bmrt"],B9zn80p:"f16h9ulv",Bpld233:["fx2bmrt","fs4ktlq"]}},{d:[".f1bg9a2p{background-color:var(--colorNeutralBackgroundDisabled);}",".f1jj8ep1{border-top-color:var(--colorNeutralStrokeDisabled);}",".f15xbau{border-right-color:var(--colorNeutralStrokeDisabled);}",".fy0fskl{border-left-color:var(--colorNeutralStrokeDisabled);}",".f4ikngz{border-bottom-color:var(--colorNeutralStrokeDisabled);}",".f1s2aq7o{color:var(--colorNeutralForegroundDisabled);}",".fdrzuqr{cursor:not-allowed;}",".f15x8b5r .fui-Button__icon{color:var(--colorNeutralForegroundDisabled);}",".f1c21dwh{background-color:var(--colorTransparentBackground);}",".f1p3nwhy{border-top-color:transparent;}",".f11589ue{border-right-color:transparent;}",".f1pdflbu{border-left-color:transparent;}",".f1q5o8ev{border-bottom-color:transparent;}"],h:[".f1falr9n:hover{background-color:var(--colorNeutralBackgroundDisabled);}",".f12mpcsy:hover{border-top-color:var(--colorNeutralStrokeDisabled);}",".f1gwvigk:hover{border-right-color:var(--colorNeutralStrokeDisabled);}",".f18rmfxp:hover{border-left-color:var(--colorNeutralStrokeDisabled);}",".f1jnshp0:hover{border-bottom-color:var(--colorNeutralStrokeDisabled);}",".fvgxktp:hover{color:var(--colorNeutralForegroundDisabled);}",".fphbwmw:hover{cursor:not-allowed;}",".f19vpps7:hover .fui-Icon-filled{display:none;}",".fv5swzo:hover .fui-Icon-regular{display:inline;}",".f1al02dq:hover .fui-Button__icon{color:var(--colorNeutralForegroundDisabled);}",".f1t6o4dc:hover:active{background-color:var(--colorNeutralBackgroundDisabled);}",".f10ztigi:hover:active{border-top-color:var(--colorNeutralStrokeDisabled);}",".f1ft5sdu:hover:active{border-right-color:var(--colorNeutralStrokeDisabled);}",".f1gzf82w:hover:active{border-left-color:var(--colorNeutralStrokeDisabled);}",".f12zbtn2:hover:active{border-bottom-color:var(--colorNeutralStrokeDisabled);}",".fcvwxyo:hover:active{color:var(--colorNeutralForegroundDisabled);}",".f8w4c43:hover:active{cursor:not-allowed;}",".f1ol4fw6:hover:active .fui-Icon-filled{display:none;}",".f1q1lw4e:hover:active .fui-Icon-regular{display:inline;}",".f1dwjv2g:hover:active .fui-Button__icon{color:var(--colorNeutralForegroundDisabled);}",".f9ql6rf:hover{background-color:var(--colorTransparentBackground);}",".f3h1zc4:hover:active{background-color:var(--colorTransparentBackground);}",".f1s2uweq:hover{border-top-color:transparent;}",".fr80ssc:hover{border-right-color:transparent;}",".fecsdlb:hover{border-left-color:transparent;}",".f1ukrpxl:hover{border-bottom-color:transparent;}",".f1h0usnq:hover:active{border-top-color:transparent;}",".fs4ktlq:hover:active{border-right-color:transparent;}",".fx2bmrt:hover:active{border-left-color:transparent;}",".f16h9ulv:hover:active{border-bottom-color:transparent;}"],m:[["@media (forced-colors: active){.f4lkoma{background-color:ButtonFace;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.fg455y9{border-top-color:GrayText;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f14g86mu{border-left-color:GrayText;}.f1rvyvqg{border-right-color:GrayText;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f1cwzwz{border-bottom-color:GrayText;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f1dcs8yz{color:GrayText;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.fuigjrg .fui-Button__icon{color:GrayText;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.fjwq6ea:focus{border-top-color:GrayText;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f1lr3nhc:focus{border-right-color:GrayText;}.f1mbxvi6:focus{border-left-color:GrayText;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.fn5gmvv:focus{border-bottom-color:GrayText;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f1vmkb5g:hover{background-color:ButtonFace;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f53ppgq:hover{border-top-color:GrayText;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f1663y11:hover{border-right-color:GrayText;}.f80fkiy:hover{border-left-color:GrayText;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f18v5270:hover{border-bottom-color:GrayText;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f1kc2mi9:hover{color:GrayText;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f4dhi0o:hover .fui-Button__icon{color:GrayText;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f1y0svfh:hover:active{background-color:ButtonFace;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.fihuait:hover:active{border-top-color:GrayText;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.fnxhupq:hover:active{border-right-color:GrayText;}.fyd6l6x:hover:active{border-left-color:GrayText;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.fx507ft:hover:active{border-bottom-color:GrayText;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.fb3rf2x:hover:active{color:GrayText;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.fequ9m0:hover:active .fui-Button__icon{color:GrayText;}}",{m:"(forced-colors: active)"}]]}),bCt=uo({circular:{Bw81rd7:0,kdpuga:0,dm238s:0,B6xbmo0:0,B3whbx2:"f1062rbf"},rounded:{},square:{Bw81rd7:0,kdpuga:0,dm238s:0,B6xbmo0:0,B3whbx2:"fj0ryk1"},primary:{B8q5s1w:"f17t0x8g",Bci5o5g:["f194v5ow","fk7jm04"],n8qw10:"f1qgg65p",Bdrgwmp:["fk7jm04","f194v5ow"],j6ew2k:["fhgccpy","fjo7pq6"],he4mth:"f32wu9k",Byr4aka:"fu5nqqq",lks7q5:["f13prjl2","f1nl83rv"],Bnan3qt:"f1czftr5",k1dn9:["f1nl83rv","f13prjl2"],Boium3a:["f12k37oa","fdnykm2"],tm8e47:"fr96u23"},small:{Bw81rd7:0,kdpuga:0,dm238s:0,B6xbmo0:0,B3whbx2:"fazmxh"},medium:{},large:{Bw81rd7:0,kdpuga:0,dm238s:0,B6xbmo0:0,B3whbx2:"f1b6alqh"}},{d:[[".f1062rbf[data-fui-focus-visible]{border-radius:var(--borderRadiusCircular);}",{p:-1}],[".fj0ryk1[data-fui-focus-visible]{border-radius:var(--borderRadiusNone);}",{p:-1}],".f17t0x8g[data-fui-focus-visible]{border-top-color:var(--colorStrokeFocus2);}",".f194v5ow[data-fui-focus-visible]{border-right-color:var(--colorStrokeFocus2);}",".fk7jm04[data-fui-focus-visible]{border-left-color:var(--colorStrokeFocus2);}",".f1qgg65p[data-fui-focus-visible]{border-bottom-color:var(--colorStrokeFocus2);}",".fhgccpy[data-fui-focus-visible]{box-shadow:var(--shadow2),0 0 0 var(--strokeWidthThin) var(--colorStrokeFocus2) inset,0 0 0 var(--strokeWidthThick) var(--colorNeutralForegroundOnBrand) inset;}",".fjo7pq6[data-fui-focus-visible]{box-shadow:var(--shadow2),0 0 0 var(--strokeWidthThin) var(--colorStrokeFocus2) inset,0 0 0 var(--strokeWidthThick) var(--colorNeutralForegroundOnBrand) inset;}",".f32wu9k[data-fui-focus-visible]:hover{box-shadow:var(--shadow2),0 0 0 var(--strokeWidthThin) var(--colorStrokeFocus2) inset;}",".fu5nqqq[data-fui-focus-visible]:hover{border-top-color:var(--colorStrokeFocus2);}",".f13prjl2[data-fui-focus-visible]:hover{border-right-color:var(--colorStrokeFocus2);}",".f1nl83rv[data-fui-focus-visible]:hover{border-left-color:var(--colorStrokeFocus2);}",".f1czftr5[data-fui-focus-visible]:hover{border-bottom-color:var(--colorStrokeFocus2);}",[".fazmxh[data-fui-focus-visible]{border-radius:var(--borderRadiusSmall);}",{p:-1}],[".f1b6alqh[data-fui-focus-visible]{border-radius:var(--borderRadiusLarge);}",{p:-1}]],t:["@supports (-moz-appearance:button){.f12k37oa[data-fui-focus-visible]{box-shadow:var(--shadow2),0 0 0 calc(var(--strokeWidthThin) + 0.25px) var(--colorStrokeFocus2) inset,0 0 0 var(--strokeWidthThick) var(--colorNeutralForegroundOnBrand) inset;}.fdnykm2[data-fui-focus-visible]{box-shadow:var(--shadow2),0 0 0 calc(var(--strokeWidthThin) + 0.25px) var(--colorStrokeFocus2) inset,0 0 0 var(--strokeWidthThick) var(--colorNeutralForegroundOnBrand) inset;}}","@supports (-moz-appearance:button){.fr96u23[data-fui-focus-visible]:hover{box-shadow:var(--shadow2),0 0 0 calc(var(--strokeWidthThin) + 0.25px) var(--colorStrokeFocus2) inset;}}"]}),TCt=uo({small:{Byoj8tv:0,uwmqm3:0,z189sj:0,z8tnut:0,B0ocmuz:"fu97m5z",Bf4jedk:"f17fgpbq",B2u0y6b:"f1jt17bm"},medium:{Byoj8tv:0,uwmqm3:0,z189sj:0,z8tnut:0,B0ocmuz:"f18ktai2",Bf4jedk:"fwbmr0d",B2u0y6b:"f44c6la"},large:{Byoj8tv:0,uwmqm3:0,z189sj:0,z8tnut:0,B0ocmuz:"f1hbd1aw",Bf4jedk:"f12clzc2",B2u0y6b:"fjy1crr"}},{d:[[".fu97m5z{padding:1px;}",{p:-1}],".f17fgpbq{min-width:24px;}",".f1jt17bm{max-width:24px;}",[".f18ktai2{padding:5px;}",{p:-1}],".fwbmr0d{min-width:32px;}",".f44c6la{max-width:32px;}",[".f1hbd1aw{padding:7px;}",{p:-1}],".f12clzc2{min-width:40px;}",".fjy1crr{max-width:40px;}"]}),CCt=uo({small:{Be2twd7:"fe5j1ua",Bqenvij:"fjamq6b",a9b677:"f64fuq3",Bqrlyyl:"fbaiahx"},medium:{},large:{Be2twd7:"f1rt2boy",Bqenvij:"frvgh55",a9b677:"fq4mcun",Bqrlyyl:"f1exjqw5"},before:{t21cq0:["f1nizpg2","f1a695kz"]},after:{Frg6f3:["f1a695kz","f1nizpg2"]}},{d:[".fe5j1ua{font-size:20px;}",".fjamq6b{height:20px;}",".f64fuq3{width:20px;}",".fbaiahx{--fui-Button__icon--spacing:var(--spacingHorizontalXS);}",".f1rt2boy{font-size:24px;}",".frvgh55{height:24px;}",".fq4mcun{width:24px;}",".f1exjqw5{--fui-Button__icon--spacing:var(--spacingHorizontalSNudge);}",".f1nizpg2{margin-right:var(--fui-Button__icon--spacing);}",".f1a695kz{margin-left:var(--fui-Button__icon--spacing);}"]}),tMe=t=>{"use no memo";const e=fCt(),i=vCt(),r=yCt(),o=SCt(),l=bCt(),d=TCt(),h=CCt(),{appearance:p,disabled:g,disabledFocusable:f,icon:y,iconOnly:T,iconPosition:C,shape:E,size:I}=t;return t.root.className=ea(eMe.root,e,p&&r[p],r[I],y&&I==="small"&&r.smallWithIcon,y&&I==="large"&&r.largeWithIcon,r[E],(g||f)&&o.base,(g||f)&&o.highContrast,p&&(g||f)&&o[p],p==="primary"&&l.primary,l[I],l[E],T&&d[I],t.root.className),t.icon&&(t.icon.className=ea(eMe.icon,i,!!t.root.children&&h[C],h[I],t.icon.className)),t},P5=$.forwardRef((t,e)=>{const i=XRe(t,e);return tMe(i),kh("useButtonStyles_unstable")(i),YRe(i)});P5.displayName="Button";const iMe=$.createContext(void 0),_Ct=iMe.Provider,nMe=()=>$.useContext(iMe),ECt=t=>{var e,i,r,o;const{generatedControlId:l,orientation:d,required:h,size:p,validationState:g}=t,f=(e=t.label)===null||e===void 0?void 0:e.htmlFor,y=(i=t.label)===null||i===void 0?void 0:i.id,T=(r=t.validationMessage)===null||r===void 0?void 0:r.id,C=(o=t.hint)===null||o===void 0?void 0:o.id;return{field:$.useMemo(()=>({generatedControlId:l,hintId:C,labelFor:f,labelId:y,orientation:d,required:h,size:p,validationMessageId:T,validationState:g}),[l,C,f,y,d,h,p,T,g])}};function Zse(t,e){return aMe(nMe(),t,e)}function aMe(t,e,i){if(!t)return e;e={...e};const{generatedControlId:r,hintId:o,labelFor:l,labelId:d,required:h,validationMessageId:p,validationState:g}=t;if(r){var f,y;(y=(f=e).id)!==null&&y!==void 0||(f.id=r)}if(d&&(!i?.supportsLabelFor||l!==e.id)){var T,C,E;(E=(T=e)[C="aria-labelledby"])!==null&&E!==void 0||(T[C]=d)}if((p||o)&&(e["aria-describedby"]=[p,o,e?.["aria-describedby"]].filter(Boolean).join(" ")),g==="error"){var I,w,D;(D=(I=e)[w="aria-invalid"])!==null&&D!==void 0||(I[w]=!0)}if(h)if(i?.supportsRequired){var F,x;(x=(F=e).required)!==null&&x!==void 0||(F.required=!0)}else{var B,L,z;(z=(B=e)[L="aria-required"])!==null&&z!==void 0||(B[L]=!0)}if(i?.supportsSize){var H,j;(j=(H=e).size)!==null&&j!==void 0||(H.size=t.size)}return e}const ACt=(t,e)=>{Pd(t);let{children:i}=t;return typeof i=="function"&&(i=i(aMe(e.field)||{})),yr(_Ct,{value:e?.field,children:Uf(t.root,{children:[t.label&&yr(t.label,{}),i,t.validationMessage&&Uf(t.validationMessage,{children:[t.validationMessageIcon&&yr(t.validationMessageIcon,{}),t.validationMessage.children]}),t.hint&&yr(t.hint,{})]})})},ICt=(t,e)=>{const{disabled:i=!1,required:r=!1,weight:o="regular",size:l="medium"}=t;return{disabled:i,required:Ss(r===!0?"*":r||void 0,{defaultProps:{"aria-hidden":"true"},elementType:"span"}),weight:o,size:l,components:{root:"label",required:"span"},root:Bl(_p("label",{ref:e,...t}),{elementType:"label"})}},wCt=t=>(Pd(t),Uf(t.root,{children:[t.root.children,t.required&&yr(t.required,{})]})),rMe={root:"fui-Label",required:"fui-Label__required"},kCt=uo({root:{Bahqtrf:"fk6fouc",sj55zd:"f19n0e5"},disabled:{sj55zd:"f1s2aq7o",Bbusuzp:"f1dcs8yz"},required:{sj55zd:"f1whyuy6",uwmqm3:["fruq291","f7x41pl"]},small:{Be2twd7:"fy9rknc",Bg96gwp:"fwrc4pm"},medium:{Be2twd7:"fkhj508",Bg96gwp:"f1i3iumi"},large:{Be2twd7:"fod5ikn",Bg96gwp:"faaz57k",Bhrd7zp:"fl43uef"},semibold:{Bhrd7zp:"fl43uef"}},{d:[".fk6fouc{font-family:var(--fontFamilyBase);}",".f19n0e5{color:var(--colorNeutralForeground1);}",".f1s2aq7o{color:var(--colorNeutralForegroundDisabled);}",".f1whyuy6{color:var(--colorPaletteRedForeground3);}",".fruq291{padding-left:var(--spacingHorizontalXS);}",".f7x41pl{padding-right:var(--spacingHorizontalXS);}",".fy9rknc{font-size:var(--fontSizeBase200);}",".fwrc4pm{line-height:var(--lineHeightBase200);}",".fkhj508{font-size:var(--fontSizeBase300);}",".f1i3iumi{line-height:var(--lineHeightBase300);}",".fod5ikn{font-size:var(--fontSizeBase400);}",".faaz57k{line-height:var(--lineHeightBase400);}",".fl43uef{font-weight:var(--fontWeightSemibold);}"],m:[["@media (forced-colors: active){.f1dcs8yz{color:GrayText;}}",{m:"(forced-colors: active)"}]]}),RCt=t=>{"use no memo";const e=kCt();return t.root.className=ea(rMe.root,e.root,t.disabled&&e.disabled,e[t.size],t.weight==="semibold"&&e.semibold,t.root.className),t.required&&(t.required.className=ea(rMe.required,e.required,t.disabled&&e.disabled,t.required.className)),t},FM=$.forwardRef((t,e)=>{const i=ICt(t,e);return RCt(i),kh("useLabelStyles_unstable")(i),wCt(i)});FM.displayName="Label";const MCt={error:$.createElement(BSt,null),warning:$.createElement(_bt,null),success:$.createElement(ESt,null),none:void 0},PCt=(t,e)=>{const{children:i,orientation:r="vertical",required:o=!1,validationState:l=t.validationMessage?"error":"none",size:d="medium"}=t,h=NL("field-"),p=h+"__control",g=Bl(_p("div",{...t,ref:e},["children"]),{elementType:"div"}),f=Ss(t.label,{defaultProps:{htmlFor:p,id:h+"__label",required:o,size:d},elementType:FM}),y=Ss(t.validationMessage,{defaultProps:{id:h+"__validationMessage",role:l==="error"||l==="warning"?"alert":void 0},elementType:"div"}),T=Ss(t.hint,{defaultProps:{id:h+"__hint"},elementType:"div"}),C=MCt[l],E=Ss(t.validationMessageIcon,{renderByDefault:!!C,defaultProps:{children:C},elementType:"span"});return{children:i,generatedControlId:p,orientation:r,required:o,size:d,validationState:l,components:{root:"div",label:FM,validationMessage:"div",validationMessageIcon:"span",hint:"div"},root:g,label:f,validationMessageIcon:E,validationMessage:y,hint:T}},HH={root:"fui-Field",label:"fui-Field__label",validationMessage:"fui-Field__validationMessage",validationMessageIcon:"fui-Field__validationMessageIcon",hint:"fui-Field__hint"},DCt=uo({base:{mc9l5x:"f13qh94s"},horizontal:{Budl1dq:"f2wwaib",wkccdc:"f1645dqt"},horizontalNoLabel:{uwmqm3:["f15jqgz8","fggqkej"],Budl1dq:"f1c2z91y"}},{d:[".f13qh94s{display:grid;}",".f2wwaib{grid-template-columns:33% 1fr;}",".f1645dqt{grid-template-rows:auto auto auto 1fr;}",".f15jqgz8{padding-left:33%;}",".fggqkej{padding-right:33%;}",".f1c2z91y{grid-template-columns:1fr;}"]}),LCt=uo({vertical:{z8tnut:"fclwglc",Byoj8tv:"fywfov9",jrapky:"fyacil5"},verticalLarge:{z8tnut:"f1sl3k7w",Byoj8tv:"f1brlhvm",jrapky:"f8l5zjj"},horizontal:{z8tnut:"fp2oml8",Byoj8tv:"f1tdddsa",t21cq0:["fkujibs","f199hnxi"],Ijaq50:"f16hsg94",nk6f5a:"f1nzqi2z"},horizontalSmall:{z8tnut:"f1ywm7hm",Byoj8tv:"f14wxoun"},horizontalLarge:{z8tnut:"f1hqyr95",Byoj8tv:"fm4hlj0"}},{d:[".fclwglc{padding-top:var(--spacingVerticalXXS);}",".fywfov9{padding-bottom:var(--spacingVerticalXXS);}",".fyacil5{margin-bottom:var(--spacingVerticalXXS);}",".f1sl3k7w{padding-top:1px;}",".f1brlhvm{padding-bottom:1px;}",".f8l5zjj{margin-bottom:var(--spacingVerticalXS);}",".fp2oml8{padding-top:var(--spacingVerticalSNudge);}",".f1tdddsa{padding-bottom:var(--spacingVerticalSNudge);}",".fkujibs{margin-right:var(--spacingHorizontalM);}",".f199hnxi{margin-left:var(--spacingHorizontalM);}",".f16hsg94{grid-row-start:1;}",".f1nzqi2z{grid-row-end:-1;}",".f1ywm7hm{padding-top:var(--spacingVerticalXS);}",".f14wxoun{padding-bottom:var(--spacingVerticalXS);}",".f1hqyr95{padding-top:9px;}",".fm4hlj0{padding-bottom:9px;}"]}),OCt=pd("r5c4z9l",null,[".r5c4z9l{margin-top:var(--spacingVerticalXXS);color:var(--colorNeutralForeground3);font-family:var(--fontFamilyBase);font-size:var(--fontSizeBase200);font-weight:var(--fontWeightRegular);line-height:var(--lineHeightBase200);}"]),NCt=uo({error:{sj55zd:"f1hcrxcs"},withIcon:{uwmqm3:["frawy03","fg4c52"]}},{d:[".f1hcrxcs{color:var(--colorPaletteRedForeground1);}",".frawy03{padding-left:calc(12px + var(--spacingHorizontalXS));}",".fg4c52{padding-right:calc(12px + var(--spacingHorizontalXS));}"]}),xCt=pd("ra7h1uk","r1rh6bd7",[".ra7h1uk{display:inline-block;font-size:12px;margin-left:calc(-12px - var(--spacingHorizontalXS));margin-right:var(--spacingHorizontalXS);line-height:0;vertical-align:-1px;}",".r1rh6bd7{display:inline-block;font-size:12px;margin-right:calc(-12px - var(--spacingHorizontalXS));margin-left:var(--spacingHorizontalXS);line-height:0;vertical-align:-1px;}"]),BCt=uo({error:{sj55zd:"f1hcrxcs"},warning:{sj55zd:"f1k5f75o"},success:{sj55zd:"ffmvakt"}},{d:[".f1hcrxcs{color:var(--colorPaletteRedForeground1);}",".f1k5f75o{color:var(--colorPaletteDarkOrangeForeground1);}",".ffmvakt{color:var(--colorPaletteGreenForeground1);}"]}),FCt=t=>{"use no memo";const{validationState:e,size:i}=t,r=t.orientation==="horizontal",o=DCt();t.root.className=ea(HH.root,o.base,r&&o.horizontal,r&&!t.label&&o.horizontalNoLabel,t.root.className);const l=LCt();t.label&&(t.label.className=ea(HH.label,r&&l.horizontal,r&&i==="small"&&l.horizontalSmall,r&&i==="large"&&l.horizontalLarge,!r&&l.vertical,!r&&i==="large"&&l.verticalLarge,t.label.className));const d=xCt(),h=BCt();t.validationMessageIcon&&(t.validationMessageIcon.className=ea(HH.validationMessageIcon,d,e!=="none"&&h[e],t.validationMessageIcon.className));const p=OCt(),g=NCt();return t.validationMessage&&(t.validationMessage.className=ea(HH.validationMessage,p,e==="error"&&g.error,!!t.validationMessageIcon&&g.withIcon,t.validationMessage.className)),t.hint&&(t.hint.className=ea(HH.hint,p,t.hint.className)),t},jH=$.forwardRef((t,e)=>{const i=PCt(t,e);FCt(i),kh("useFieldStyles_unstable")(i);const r=ECt(i);return ACt(i,r)});jH.displayName="Field";const UCt=(t,e)=>{"use no memo";t=Zse(t,{supportsLabelFor:!0,supportsRequired:!0});const{disabled:i=!1,required:r,shape:o="square",size:l="medium",labelPosition:d="after",onChange:h}=t,[p,g]=OL({defaultState:t.defaultChecked,state:t.checked,initialState:!1}),f=RH({props:t,primarySlotTagName:"input",excludedPropNames:["checked","defaultChecked","size","onChange"]}),y=p==="mixed",T=NL("checkbox-",f.primary.id);let C;y?o==="circular"?C=$.createElement(Jke,null):C=l==="large"?$.createElement(gbt,null):$.createElement(pbt,null):p&&(C=l==="large"?$.createElement(CSt,null):$.createElement(TSt,null));const E={shape:o,checked:p,disabled:i,size:l,labelPosition:d,components:{root:"span",input:"input",indicator:"div",label:FM},root:Bl(t.root,{defaultProps:{ref:yse(),...f.root},elementType:"span"}),input:Bl(t.input,{defaultProps:{type:"checkbox",id:T,ref:e,checked:p===!0,...f.primary},elementType:"input"}),label:Ss(t.label,{defaultProps:{htmlFor:T,disabled:i,required:r,size:"medium"},elementType:FM}),indicator:Ss(t.indicator,{renderByDefault:!0,defaultProps:{"aria-hidden":!0,children:C},elementType:"div"})};E.input.onChange=Fl(w=>{const D=w.currentTarget.indeterminate?"mixed":w.currentTarget.checked;h?.(w,{checked:D}),g(D)});const I=kC(E.input.ref);return E.input.ref=I,fA(()=>{I.current&&(I.current.indeterminate=y)},[I,y]),E},zCt=t=>(Pd(t),Uf(t.root,{children:[yr(t.input,{}),t.labelPosition==="before"&&t.label&&yr(t.label,{}),t.indicator&&yr(t.indicator,{}),t.labelPosition==="after"&&t.label&&yr(t.label,{})]})),bK={root:"fui-Checkbox",label:"fui-Checkbox__label",input:"fui-Checkbox__input",indicator:"fui-Checkbox__indicator"},VCt=pd("r1q22k1j","r18ze4k2",{r:[".r1q22k1j{position:relative;display:inline-flex;cursor:pointer;vertical-align:middle;color:var(--colorNeutralForeground3);}",".r1q22k1j:focus{outline-style:none;}",".r1q22k1j:focus-visible{outline-style:none;}",".r1q22k1j[data-fui-focus-within]:focus-within{border-top-color:transparent;border-right-color:transparent;border-bottom-color:transparent;border-left-color:transparent;}",'.r1q22k1j[data-fui-focus-within]:focus-within::after{content:"";position:absolute;pointer-events:none;z-index:1;border:2px solid var(--colorStrokeFocus2);border-radius:var(--borderRadiusMedium);top:calc(2px * -1);right:calc(2px * -1);bottom:calc(2px * -1);left:calc(2px * -1);}',".r18ze4k2{position:relative;display:inline-flex;cursor:pointer;vertical-align:middle;color:var(--colorNeutralForeground3);}",".r18ze4k2:focus{outline-style:none;}",".r18ze4k2:focus-visible{outline-style:none;}",".r18ze4k2[data-fui-focus-within]:focus-within{border-top-color:transparent;border-left-color:transparent;border-bottom-color:transparent;border-right-color:transparent;}",'.r18ze4k2[data-fui-focus-within]:focus-within::after{content:"";position:absolute;pointer-events:none;z-index:1;border:2px solid var(--colorStrokeFocus2);border-radius:var(--borderRadiusMedium);top:calc(2px * -1);left:calc(2px * -1);bottom:calc(2px * -1);right:calc(2px * -1);}'],s:["@media (forced-colors: active){.r1q22k1j[data-fui-focus-within]:focus-within::after{border-top-color:Highlight;border-right-color:Highlight;border-bottom-color:Highlight;border-left-color:Highlight;}}","@media (forced-colors: active){.r18ze4k2[data-fui-focus-within]:focus-within::after{border-top-color:Highlight;border-left-color:Highlight;border-bottom-color:Highlight;border-right-color:Highlight;}}"]}),$Ct=uo({unchecked:{Bi91k9c:"f3p8bqa",pv5h1i:"fium13f",lj723h:"f1r2dosr",Hnthvo:"f1729es6"},checked:{sj55zd:"f19n0e5",wkncrt:"f35ds98",zxk7z7:"f12mnkne",Hmsnfy:"fei9a8h",e6czan:"fix56y3",pv5h1i:"f1bcv2js",qbydtz:"f7dr4go",Hnthvo:"f1r5cpua"},mixed:{sj55zd:"f19n0e5",Hmsnfy:"f1l27tf0",zxk7z7:"fcilktj",pv5h1i:"f1lphd54",Bunfa6h:"f1obkvq7",Hnthvo:"f2gmbuh",B15ykmv:"f1oy4fa1"},disabled:{Bceei9c:"f158kwzp",sj55zd:"f1s2aq7o",Hmsnfy:"f1w7mfl5",zxk7z7:"fcoafq6",Bbusuzp:"f1dcs8yz",mrqfp9:"fxb3eh3"}},{h:[".f3p8bqa:hover{color:var(--colorNeutralForeground2);}",".fium13f:hover{--fui-Checkbox__indicator--borderColor:var(--colorNeutralStrokeAccessibleHover);}",".fix56y3:hover{--fui-Checkbox__indicator--backgroundColor:var(--colorCompoundBrandBackgroundHover);}",".f1bcv2js:hover{--fui-Checkbox__indicator--borderColor:var(--colorCompoundBrandBackgroundHover);}",".f1lphd54:hover{--fui-Checkbox__indicator--borderColor:var(--colorCompoundBrandStrokeHover);}",".f1obkvq7:hover{--fui-Checkbox__indicator--color:var(--colorCompoundBrandForeground1Hover);}"],a:[".f1r2dosr:active{color:var(--colorNeutralForeground1);}",".f1729es6:active{--fui-Checkbox__indicator--borderColor:var(--colorNeutralStrokeAccessiblePressed);}",".f7dr4go:active{--fui-Checkbox__indicator--backgroundColor:var(--colorCompoundBrandBackgroundPressed);}",".f1r5cpua:active{--fui-Checkbox__indicator--borderColor:var(--colorCompoundBrandBackgroundPressed);}",".f2gmbuh:active{--fui-Checkbox__indicator--borderColor:var(--colorCompoundBrandStrokePressed);}",".f1oy4fa1:active{--fui-Checkbox__indicator--color:var(--colorCompoundBrandForeground1Pressed);}"],d:[".f19n0e5{color:var(--colorNeutralForeground1);}",".f35ds98{--fui-Checkbox__indicator--backgroundColor:var(--colorCompoundBrandBackground);}",".f12mnkne{--fui-Checkbox__indicator--color:var(--colorNeutralForegroundInverted);}",".fei9a8h{--fui-Checkbox__indicator--borderColor:var(--colorCompoundBrandBackground);}",".f1l27tf0{--fui-Checkbox__indicator--borderColor:var(--colorCompoundBrandStroke);}",".fcilktj{--fui-Checkbox__indicator--color:var(--colorCompoundBrandForeground1);}",".f158kwzp{cursor:default;}",".f1s2aq7o{color:var(--colorNeutralForegroundDisabled);}",".f1w7mfl5{--fui-Checkbox__indicator--borderColor:var(--colorNeutralStrokeDisabled);}",".fcoafq6{--fui-Checkbox__indicator--color:var(--colorNeutralForegroundDisabled);}"],m:[["@media (forced-colors: active){.f1dcs8yz{color:GrayText;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.fxb3eh3{--fui-Checkbox__indicator--color:GrayText;}}",{m:"(forced-colors: active)"}]]}),HCt=pd("ruo9svu",null,[".ruo9svu{box-sizing:border-box;cursor:inherit;height:100%;margin:0;opacity:0;position:absolute;top:0;width:calc(16px + 2 * var(--spacingHorizontalS));}"]),jCt=uo({before:{j35jbq:["f1e31b4d","f1vgc2s3"]},after:{oyh7mz:["f1vgc2s3","f1e31b4d"]},large:{a9b677:"f1mq5jt6"}},{d:[".f1e31b4d{right:0;}",".f1vgc2s3{left:0;}",".f1mq5jt6{width:calc(20px + 2 * var(--spacingHorizontalS));}"]}),GCt=pd("rl7ci6d",null,[".rl7ci6d{align-self:flex-start;box-sizing:border-box;flex-shrink:0;display:flex;align-items:center;justify-content:center;overflow:hidden;color:var(--fui-Checkbox__indicator--color);background-color:var(--fui-Checkbox__indicator--backgroundColor);border-color:var(--fui-Checkbox__indicator--borderColor, var(--colorNeutralStrokeAccessible));border-style:solid;border-width:var(--strokeWidthThin);border-radius:var(--borderRadiusSmall);margin:var(--spacingVerticalS) var(--spacingHorizontalS);fill:currentColor;pointer-events:none;font-size:12px;height:16px;width:16px;}"]),qCt=uo({large:{Be2twd7:"f4ybsrx",Bqenvij:"fjamq6b",a9b677:"f64fuq3"},circular:{Beyfa6y:0,Bbmb7ep:0,Btl43ni:0,B7oj6ja:0,Dimara:"f44lkw9"}},{d:[".f4ybsrx{font-size:16px;}",".fjamq6b{height:20px;}",".f64fuq3{width:20px;}",[".f44lkw9{border-radius:var(--borderRadiusCircular);}",{p:-1}]]}),WCt=uo({base:{qb2dma:"f7nlbp4",sj55zd:"f1ym3bx4",Bceei9c:"fpo1scq",Byoj8tv:0,uwmqm3:0,z189sj:0,z8tnut:0,B0ocmuz:"f1f5q0n8"},before:{z189sj:["f7x41pl","fruq291"]},after:{uwmqm3:["fruq291","f7x41pl"]},medium:{B6of3ja:"fjzwpt6",jrapky:"fh6j2fo"},large:{B6of3ja:"f1xlvstr",jrapky:"f49ad5g"}},{d:[".f7nlbp4{align-self:center;}",".f1ym3bx4{color:inherit;}",".fpo1scq{cursor:inherit;}",[".f1f5q0n8{padding:var(--spacingVerticalS) var(--spacingHorizontalS);}",{p:-1}],".f7x41pl{padding-right:var(--spacingHorizontalXS);}",".fruq291{padding-left:var(--spacingHorizontalXS);}",".fjzwpt6{margin-top:calc((16px - var(--lineHeightBase300)) / 2);}",".fh6j2fo{margin-bottom:calc((16px - var(--lineHeightBase300)) / 2);}",".f1xlvstr{margin-top:calc((20px - var(--lineHeightBase300)) / 2);}",".f49ad5g{margin-bottom:calc((20px - var(--lineHeightBase300)) / 2);}"]}),KCt=t=>{"use no memo";const{checked:e,disabled:i,labelPosition:r,shape:o,size:l}=t,d=VCt(),h=$Ct();t.root.className=ea(bK.root,d,i?h.disabled:e==="mixed"?h.mixed:e?h.checked:h.unchecked,t.root.className);const p=HCt(),g=jCt();t.input.className=ea(bK.input,p,l==="large"&&g.large,g[r],t.input.className);const f=GCt(),y=qCt();t.indicator&&(t.indicator.className=ea(bK.indicator,f,l==="large"&&y.large,o==="circular"&&y.circular,t.indicator.className));const T=WCt();return t.label&&(t.label.className=ea(bK.label,T.base,T[l],T[r],t.label.className)),t},oMe=$.forwardRef((t,e)=>{const i=UCt(t,e);return KCt(i),kh("useCheckboxStyles_unstable")(i),zCt(i)});oMe.displayName="Checkbox";const JCt=(t,e)=>{t=Zse(t,{supportsLabelFor:!0,supportsRequired:!0,supportsSize:!0});const i=Mwe();var r;const{size:o="medium",appearance:l=(r=i.inputDefaultAppearance)!==null&&r!==void 0?r:"outline",onChange:d}=t;process.env.NODE_ENV!=="production"&&(l==="filled-darker-shadow"||l==="filled-lighter-shadow")&&console.error("The 'filled-darker-shadow' and 'filled-lighter-shadow' appearances are deprecated and will be removed in the future.");const[h,p]=OL({state:t.value,defaultState:t.defaultValue,initialState:""}),g=RH({props:t,primarySlotTagName:"input",excludedPropNames:["size","onChange","value","defaultValue"]}),f={size:o,appearance:l,components:{root:"span",input:"input",contentBefore:"span",contentAfter:"span"},input:Bl(t.input,{defaultProps:{type:"text",ref:e,...g.primary},elementType:"input"}),contentAfter:Ss(t.contentAfter,{elementType:"span"}),contentBefore:Ss(t.contentBefore,{elementType:"span"}),root:Bl(t.root,{defaultProps:g.root,elementType:"span"})};return f.input.value=h,f.input.onChange=Fl(y=>{const T=y.target.value;d?.(y,{value:T}),p(T)}),f},YCt=t=>(Pd(t),Uf(t.root,{children:[t.contentBefore&&yr(t.contentBefore,{}),yr(t.input,{}),t.contentAfter&&yr(t.contentAfter,{})]})),TK={root:"fui-Input",input:"fui-Input__input",contentBefore:"fui-Input__contentBefore",contentAfter:"fui-Input__contentAfter"},QCt=pd("r1oeeo9n","r9sxh5",{r:[".r1oeeo9n{display:inline-flex;align-items:center;flex-wrap:nowrap;gap:var(--spacingHorizontalXXS);border-radius:var(--borderRadiusMedium);position:relative;box-sizing:border-box;vertical-align:middle;min-height:32px;font-family:var(--fontFamilyBase);font-size:var(--fontSizeBase300);font-weight:var(--fontWeightRegular);line-height:var(--lineHeightBase300);background-color:var(--colorNeutralBackground1);border:1px solid var(--colorNeutralStroke1);border-bottom-color:var(--colorNeutralStrokeAccessible);}",'.r1oeeo9n::after{box-sizing:border-box;content:"";position:absolute;left:-1px;bottom:-1px;right:-1px;height:max(2px, var(--borderRadiusMedium));border-bottom-left-radius:var(--borderRadiusMedium);border-bottom-right-radius:var(--borderRadiusMedium);border-bottom:2px solid var(--colorCompoundBrandStroke);clip-path:inset(calc(100% - 2px) 0 0 0);transform:scaleX(0);transition-property:transform;transition-duration:var(--durationUltraFast);transition-delay:var(--curveAccelerateMid);}',".r1oeeo9n:focus-within::after{transform:scaleX(1);transition-property:transform;transition-duration:var(--durationNormal);transition-delay:var(--curveDecelerateMid);}",".r1oeeo9n:focus-within:active::after{border-bottom-color:var(--colorCompoundBrandStrokePressed);}",".r1oeeo9n:focus-within{outline:2px solid transparent;}",".r9sxh5{display:inline-flex;align-items:center;flex-wrap:nowrap;gap:var(--spacingHorizontalXXS);border-radius:var(--borderRadiusMedium);position:relative;box-sizing:border-box;vertical-align:middle;min-height:32px;font-family:var(--fontFamilyBase);font-size:var(--fontSizeBase300);font-weight:var(--fontWeightRegular);line-height:var(--lineHeightBase300);background-color:var(--colorNeutralBackground1);border:1px solid var(--colorNeutralStroke1);border-bottom-color:var(--colorNeutralStrokeAccessible);}",'.r9sxh5::after{box-sizing:border-box;content:"";position:absolute;right:-1px;bottom:-1px;left:-1px;height:max(2px, var(--borderRadiusMedium));border-bottom-right-radius:var(--borderRadiusMedium);border-bottom-left-radius:var(--borderRadiusMedium);border-bottom:2px solid var(--colorCompoundBrandStroke);clip-path:inset(calc(100% - 2px) 0 0 0);transform:scaleX(0);transition-property:transform;transition-duration:var(--durationUltraFast);transition-delay:var(--curveAccelerateMid);}',".r9sxh5:focus-within::after{transform:scaleX(1);transition-property:transform;transition-duration:var(--durationNormal);transition-delay:var(--curveDecelerateMid);}",".r9sxh5:focus-within:active::after{border-bottom-color:var(--colorCompoundBrandStrokePressed);}",".r9sxh5:focus-within{outline:2px solid transparent;}"],s:["@media screen and (prefers-reduced-motion: reduce){.r1oeeo9n::after{transition-duration:0.01ms;transition-delay:0.01ms;}}","@media screen and (prefers-reduced-motion: reduce){.r1oeeo9n:focus-within::after{transition-duration:0.01ms;transition-delay:0.01ms;}}","@media screen and (prefers-reduced-motion: reduce){.r9sxh5::after{transition-duration:0.01ms;transition-delay:0.01ms;}}","@media screen and (prefers-reduced-motion: reduce){.r9sxh5:focus-within::after{transition-duration:0.01ms;transition-delay:0.01ms;}}"]}),ZCt=uo({small:{sshi5w:"f1pha7fy",Bahqtrf:"fk6fouc",Be2twd7:"fy9rknc",Bhrd7zp:"figsok6",Bg96gwp:"fwrc4pm"},medium:{},large:{sshi5w:"f1w5jphr",Bahqtrf:"fk6fouc",Be2twd7:"fod5ikn",Bhrd7zp:"figsok6",Bg96gwp:"faaz57k",i8kkvl:0,Belr9w4:0,rmohyg:"f1eyhf9v"},outline:{},outlineInteractive:{Bgoe8wy:"fvcxoqz",Bwzppfd:["f1ub3y4t","f1m52nbi"],oetu4i:"f1l4zc64",gg5e9n:["f1m52nbi","f1ub3y4t"],Drbcw7:"f8vnjqi",udz0bu:["fz1etlk","f1hc16gm"],Be8ivqh:"f1klwx88",ofdepl:["f1hc16gm","fz1etlk"]},underline:{De3pzq:"f1c21dwh",Beyfa6y:0,Bbmb7ep:0,Btl43ni:0,B7oj6ja:0,Dimara:"fokr779",icvyot:"f1ern45e",vrafjx:["f1n71otn","f1deefiw"],wvpqe5:["f1deefiw","f1n71otn"],Eqx8gd:["f1n6gb5g","f15yvnhg"],B1piin3:["f15yvnhg","f1n6gb5g"]},underlineInteractive:{oetu4i:"f1l4zc64",Be8ivqh:"f1klwx88",d9w3h3:0,B3778ie:0,B4j8arr:0,Bl18szs:0,Blrzh8d:"f2ale1x"},filled:{g2u3we:"fghlq4f",h3c5rm:["f1gn591s","fjscplz"],B9xav0g:"fb073pr",zhjwy3:["fjscplz","f1gn591s"]},filledInteractive:{q7v0qe:"ftmjh5b",kmh5ft:["f17blpuu","fsrcdbj"],nagaa4:"f1tpwn32",B1yhkcb:["fsrcdbj","f17blpuu"]},invalid:{tvckwq:"fs4k3qj",gk2u95:["fcee079","fmyw78r"],hhx65j:"f1fgmyf4",Bxowmz0:["fmyw78r","fcee079"]},"filled-darker":{De3pzq:"f16xq7d1"},"filled-lighter":{De3pzq:"fxugw4r"},"filled-darker-shadow":{De3pzq:"f16xq7d1",E5pizo:"fyed02w"},"filled-lighter-shadow":{De3pzq:"fxugw4r",E5pizo:"fyed02w"},disabled:{Bceei9c:"fdrzuqr",De3pzq:"f1c21dwh",g2u3we:"f1jj8ep1",h3c5rm:["f15xbau","fy0fskl"],B9xav0g:"f4ikngz",zhjwy3:["fy0fskl","f15xbau"],Bjwas2f:"fg455y9",Bn1d65q:["f1rvyvqg","f14g86mu"],Bxeuatn:"f1cwzwz",n51gp8:["f14g86mu","f1rvyvqg"],Bsft5z2:"fhr9occ",Bduesf4:"f99w1ws"},smallWithContentBefore:{uwmqm3:["fk8j09s","fdw0yi8"]},smallWithContentAfter:{z189sj:["fdw0yi8","fk8j09s"]},mediumWithContentBefore:{uwmqm3:["f1ng84yb","f11gcy0p"]},mediumWithContentAfter:{z189sj:["f11gcy0p","f1ng84yb"]},largeWithContentBefore:{uwmqm3:["f1uw59to","fw5db7e"]},largeWithContentAfter:{z189sj:["fw5db7e","f1uw59to"]}},{d:[".f1pha7fy{min-height:24px;}",".fk6fouc{font-family:var(--fontFamilyBase);}",".fy9rknc{font-size:var(--fontSizeBase200);}",".figsok6{font-weight:var(--fontWeightRegular);}",".fwrc4pm{line-height:var(--lineHeightBase200);}",".f1w5jphr{min-height:40px;}",".fod5ikn{font-size:var(--fontSizeBase400);}",".faaz57k{line-height:var(--lineHeightBase400);}",[".f1eyhf9v{gap:var(--spacingHorizontalSNudge);}",{p:-1}],".f1c21dwh{background-color:var(--colorTransparentBackground);}",[".fokr779{border-radius:0;}",{p:-1}],".f1ern45e{border-top-style:none;}",".f1n71otn{border-right-style:none;}",".f1deefiw{border-left-style:none;}",".f1n6gb5g::after{left:0;}",".f15yvnhg::after{right:0;}",[".f2ale1x::after{border-radius:0;}",{p:-1}],".fghlq4f{border-top-color:var(--colorTransparentStroke);}",".f1gn591s{border-right-color:var(--colorTransparentStroke);}",".fjscplz{border-left-color:var(--colorTransparentStroke);}",".fb073pr{border-bottom-color:var(--colorTransparentStroke);}",".fs4k3qj:not(:focus-within),.fs4k3qj:hover:not(:focus-within){border-top-color:var(--colorPaletteRedBorder2);}",".fcee079:not(:focus-within),.fcee079:hover:not(:focus-within){border-right-color:var(--colorPaletteRedBorder2);}",".fmyw78r:not(:focus-within),.fmyw78r:hover:not(:focus-within){border-left-color:var(--colorPaletteRedBorder2);}",".f1fgmyf4:not(:focus-within),.f1fgmyf4:hover:not(:focus-within){border-bottom-color:var(--colorPaletteRedBorder2);}",".f16xq7d1{background-color:var(--colorNeutralBackground3);}",".fxugw4r{background-color:var(--colorNeutralBackground1);}",".fyed02w{box-shadow:var(--shadow2);}",".fdrzuqr{cursor:not-allowed;}",".f1jj8ep1{border-top-color:var(--colorNeutralStrokeDisabled);}",".f15xbau{border-right-color:var(--colorNeutralStrokeDisabled);}",".fy0fskl{border-left-color:var(--colorNeutralStrokeDisabled);}",".f4ikngz{border-bottom-color:var(--colorNeutralStrokeDisabled);}",".fhr9occ::after{content:unset;}",".fk8j09s{padding-left:var(--spacingHorizontalSNudge);}",".fdw0yi8{padding-right:var(--spacingHorizontalSNudge);}",".f1ng84yb{padding-left:var(--spacingHorizontalMNudge);}",".f11gcy0p{padding-right:var(--spacingHorizontalMNudge);}",".f1uw59to{padding-left:var(--spacingHorizontalM);}",".fw5db7e{padding-right:var(--spacingHorizontalM);}"],h:[".fvcxoqz:hover{border-top-color:var(--colorNeutralStroke1Hover);}",".f1ub3y4t:hover{border-right-color:var(--colorNeutralStroke1Hover);}",".f1m52nbi:hover{border-left-color:var(--colorNeutralStroke1Hover);}",".f1l4zc64:hover{border-bottom-color:var(--colorNeutralStrokeAccessibleHover);}",".ftmjh5b:hover,.ftmjh5b:focus-within{border-top-color:var(--colorTransparentStrokeInteractive);}",".f17blpuu:hover,.f17blpuu:focus-within{border-right-color:var(--colorTransparentStrokeInteractive);}",".fsrcdbj:hover,.fsrcdbj:focus-within{border-left-color:var(--colorTransparentStrokeInteractive);}",".f1tpwn32:hover,.f1tpwn32:focus-within{border-bottom-color:var(--colorTransparentStrokeInteractive);}"],a:[".f8vnjqi:active,.f8vnjqi:focus-within{border-top-color:var(--colorNeutralStroke1Pressed);}",".fz1etlk:active,.fz1etlk:focus-within{border-right-color:var(--colorNeutralStroke1Pressed);}",".f1hc16gm:active,.f1hc16gm:focus-within{border-left-color:var(--colorNeutralStroke1Pressed);}",".f1klwx88:active,.f1klwx88:focus-within{border-bottom-color:var(--colorNeutralStrokeAccessiblePressed);}"],m:[["@media (forced-colors: active){.fg455y9{border-top-color:GrayText;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f14g86mu{border-left-color:GrayText;}.f1rvyvqg{border-right-color:GrayText;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f1cwzwz{border-bottom-color:GrayText;}}",{m:"(forced-colors: active)"}]],w:[".f99w1ws:focus-within{outline-style:none;}"]}),XCt=pd("r12stul0",null,[".r12stul0{align-self:stretch;box-sizing:border-box;flex-grow:1;min-width:0;border-style:none;padding:0 var(--spacingHorizontalM);color:var(--colorNeutralForeground1);background-color:transparent;outline-style:none;font-family:inherit;font-size:inherit;font-weight:inherit;line-height:inherit;}",".r12stul0::-webkit-input-placeholder{color:var(--colorNeutralForeground4);opacity:1;}",".r12stul0::-moz-placeholder{color:var(--colorNeutralForeground4);opacity:1;}",".r12stul0::placeholder{color:var(--colorNeutralForeground4);opacity:1;}"]),e_t=uo({small:{uwmqm3:["f1f5gg8d","f1vdfbxk"],z189sj:["f1vdfbxk","f1f5gg8d"]},medium:{},large:{uwmqm3:["fnphzt9","flt1dlf"],z189sj:["flt1dlf","fnphzt9"]},smallWithContentBefore:{uwmqm3:["fgiv446","ffczdla"]},smallWithContentAfter:{z189sj:["ffczdla","fgiv446"]},mediumWithContentBefore:{uwmqm3:["fgiv446","ffczdla"]},mediumWithContentAfter:{z189sj:["ffczdla","fgiv446"]},largeWithContentBefore:{uwmqm3:["fk8j09s","fdw0yi8"]},largeWithContentAfter:{z189sj:["fdw0yi8","fk8j09s"]},disabled:{sj55zd:"f1s2aq7o",De3pzq:"f1c21dwh",Bceei9c:"fdrzuqr",yvdlaj:"fahhnxm"}},{d:[".f1f5gg8d{padding-left:var(--spacingHorizontalS);}",".f1vdfbxk{padding-right:var(--spacingHorizontalS);}",".fnphzt9{padding-left:calc(var(--spacingHorizontalM) + var(--spacingHorizontalSNudge));}",".flt1dlf{padding-right:calc(var(--spacingHorizontalM) + var(--spacingHorizontalSNudge));}",".fgiv446{padding-left:var(--spacingHorizontalXXS);}",".ffczdla{padding-right:var(--spacingHorizontalXXS);}",".fk8j09s{padding-left:var(--spacingHorizontalSNudge);}",".fdw0yi8{padding-right:var(--spacingHorizontalSNudge);}",".f1s2aq7o{color:var(--colorNeutralForegroundDisabled);}",".f1c21dwh{background-color:var(--colorTransparentBackground);}",".fdrzuqr{cursor:not-allowed;}",".fahhnxm::-webkit-input-placeholder{color:var(--colorNeutralForegroundDisabled);}",".fahhnxm::-moz-placeholder{color:var(--colorNeutralForegroundDisabled);}"]}),t_t=pd("r1572tok",null,[".r1572tok{box-sizing:border-box;color:var(--colorNeutralForeground3);display:flex;}",".r1572tok>svg{font-size:20px;}"]),i_t=uo({disabled:{sj55zd:"f1s2aq7o"},small:{Duoase:"f3qv9w"},medium:{},large:{Duoase:"f16u2scb"}},{d:[".f1s2aq7o{color:var(--colorNeutralForegroundDisabled);}",".f3qv9w>svg{font-size:16px;}",".f16u2scb>svg{font-size:24px;}"]}),n_t=t=>{"use no memo";const{size:e,appearance:i}=t,r=t.input.disabled,o=`${t.input["aria-invalid"]}`=="true",l=i.startsWith("filled"),d=ZCt(),h=e_t(),p=i_t();t.root.className=ea(TK.root,QCt(),d[e],t.contentBefore&&d[`${e}WithContentBefore`],t.contentAfter&&d[`${e}WithContentAfter`],d[i],!r&&i==="outline"&&d.outlineInteractive,!r&&i==="underline"&&d.underlineInteractive,!r&&l&&d.filledInteractive,l&&d.filled,!r&&o&&d.invalid,r&&d.disabled,t.root.className),t.input.className=ea(TK.input,XCt(),h[e],t.contentBefore&&h[`${e}WithContentBefore`],t.contentAfter&&h[`${e}WithContentAfter`],r&&h.disabled,t.input.className);const g=[t_t(),r&&p.disabled,p[e]];return t.contentBefore&&(t.contentBefore.className=ea(TK.contentBefore,...g,t.contentBefore.className)),t.contentAfter&&(t.contentAfter.className=ea(TK.contentAfter,...g,t.contentAfter.className)),t},CK=$.forwardRef((t,e)=>{const i=JCt(t,e);return n_t(i),kh("useInputStyles_unstable")(i),YCt(i)});CK.displayName="Input";const a_t=$.createContext(void 0).Provider,Xse=BH(void 0),r_t={open:!1,setOpen:()=>!1,checkedValues:{},onCheckedValueChange:()=>null,isSubmenu:!1,triggerRef:{current:null},menuPopoverRef:{current:null},mountNode:null,triggerId:"",openOnContext:!1,openOnHover:!1,hasIcons:!1,hasCheckmarks:!1,inline:!1,persistOnItemClick:!1},o_t=Xse.Provider,jh=t=>sK(Xse,(e=r_t)=>t(e)),sMe=$.createContext(void 0),s_t=!1,l_t=sMe.Provider,c_t=()=>{var t;return(t=$.useContext(sMe))!==null&&t!==void 0?t:s_t},ele=BH(void 0),d_t={checkedValues:{},setFocusByFirstCharacter:()=>null,toggleCheckbox:()=>null,selectRadio:()=>null,hasIcons:!1,hasCheckmarks:!1},u_t=ele.Provider,tle=t=>sK(ele,(e=d_t)=>t(e)),GH="fuimenuenter",h_t=t=>{const{refs:e,callback:i,element:r,disabled:o}=t,l=Fl(d=>{const h=e[0],p=d.target;var g;!Qoe((g=h.current)!==null&&g!==void 0?g:null,p)&&!o&&i(d)});$.useEffect(()=>{if(r!=null)return o||r.addEventListener(GH,l),()=>{r.removeEventListener(GH,l)}},[l,r,o])},p_t=(t,e)=>{t.dispatchEvent(new CustomEvent(GH,{bubbles:!0,detail:{nativeEvent:e}}))};function ile(){const t=jh(i=>i.isSubmenu),e=Gke(ele);return t||e}const g_t=["after","after-bottom","before-top","before","before-bottom","above"],m_t=t=>{const e=ile(),{hoverDelay:i=500,inline:r=!1,hasCheckmarks:o=!1,hasIcons:l=!1,closeOnScroll:d=!1,openOnContext:h=!1,persistOnItemClick:p=!1,openOnHover:g=e,defaultCheckedValues:f,mountNode:y=null}=t,T=NL("menu"),[C,E]=nCt(),I={position:e?"after":"below",align:e?"top":"start",target:t.openOnContext?C:void 0,fallbackPositions:e?g_t:void 0,...FRe(t.positioning)},w=$.Children.toArray(t.children);process.env.NODE_ENV!=="production"&&(w.length===0&&console.warn("Menu must contain at least one child"),w.length>2&&console.warn("Menu must contain at most two children"));let D,F;w.length===2?(D=w[0],F=w[1]):w.length===1&&(F=w[0]);const{targetRef:x,containerRef:B}=tCt(I),[L,z]=v_t({hoverDelay:i,isSubmenu:e,setContextTarget:E,closeOnScroll:d,menuPopoverRef:B,triggerRef:x,open:t.open,defaultOpen:t.defaultOpen,onOpenChange:t.onOpenChange,openOnContext:h}),[H,j]=f_t({checkedValues:t.checkedValues,defaultCheckedValues:f,onCheckedValueChange:t.onCheckedValueChange});return{inline:r,hoverDelay:i,triggerId:T,isSubmenu:e,openOnHover:g,contextTarget:C,setContextTarget:E,hasCheckmarks:o,hasIcons:l,closeOnScroll:d,menuTrigger:D,menuPopover:F,mountNode:y,triggerRef:x,menuPopoverRef:B,components:{},openOnContext:h,open:L,setOpen:z,checkedValues:H,onCheckedValueChange:j,persistOnItemClick:p}},f_t=t=>{const[e,i]=OL({state:t.checkedValues,defaultState:t.defaultCheckedValues,initialState:{}}),r=Fl((o,{name:l,checkedItems:d})=>{var h;(h=t.onCheckedValueChange)===null||h===void 0||h.call(t,o,{name:l,checkedItems:d}),i(p=>({...p,[l]:d}))});return[e,r]},v_t=t=>{"use no memo";const{targetDocument:e}=Ov(),i=jh(I=>I.setOpen),r=Fl((I,w)=>{var D;return(D=t.onOpenChange)===null||D===void 0?void 0:D.call(t,I,w)}),o=$.useRef(!1),[l,d]=OL({state:t.open,defaultState:t.defaultOpen,initialState:!1}),h=Fl((I,w)=>{const D=I instanceof CustomEvent&&I.type===GH?I.detail.nativeEvent:I;r?.(D,{...w}),w.open&&I.type==="contextmenu"&&t.setContextTarget(I),w.open||t.setContextTarget(void 0),w.bubble&&i(I,{...w}),d(w.open)}),[p,g]=Yoe(),f=Fl((I,w)=>{if(g(),!(I instanceof Event)&&I.persist&&I.persist(),I.type==="mouseleave"||I.type==="mouseenter"||I.type==="mousemove"||I.type===GH){var D;!((D=t.triggerRef.current)===null||D===void 0)&&D.contains(I.target)&&(o.current=I.type==="mouseenter"||I.type==="mousemove"),p(()=>h(I,w),t.hoverDelay)}else h(I,w)});Qmt({contains:Qoe,disabled:!l,element:e,refs:[t.menuPopoverRef,!t.openOnContext&&t.triggerRef].filter(Boolean),callback:I=>f(I,{open:!1,type:"clickOutside",event:I})});const y=t.openOnContext||t.closeOnScroll;eft({contains:Qoe,element:e,callback:I=>f(I,{open:!1,type:"scrollOutside",event:I}),refs:[t.menuPopoverRef,!t.openOnContext&&t.triggerRef].filter(Boolean),disabled:!l||!y}),h_t({element:e,callback:I=>{o.current||f(I,{open:!1,type:"menuMouseEnter",event:I})},disabled:!l,refs:[t.menuPopoverRef]});const{findFirstFocusable:T}=iK(),C=$.useCallback(()=>{const I=T(t.menuPopoverRef.current);I?.focus()},[T,t.menuPopoverRef]),E=Jmt();return $.useEffect(()=>{if(l)C();else if(!E&&e?.activeElement===e?.body){var I;(I=t.triggerRef.current)===null||I===void 0||I.focus()}},[t.triggerRef,t.isSubmenu,l,C,e,t.menuPopoverRef]),[l,f]};function y_t(t){const{checkedValues:e,hasCheckmarks:i,hasIcons:r,inline:o,isSubmenu:l,menuPopoverRef:d,mountNode:h,onCheckedValueChange:p,open:g,openOnContext:f,openOnHover:y,persistOnItemClick:T,setOpen:C,triggerId:E,triggerRef:I}=t;return{menu:{checkedValues:e,hasCheckmarks:i,hasIcons:r,inline:o,isSubmenu:l,menuPopoverRef:d,mountNode:h,onCheckedValueChange:p,open:g,openOnContext:f,openOnHover:y,persistOnItemClick:T,setOpen:C,triggerId:E,triggerRef:I}}}const S_t=(t,e)=>$.createElement(o_t,{value:e.menu},t.menuTrigger,t.open&&t.menuPopover),lMe=t=>{const e=m_t(t),i=y_t(e);return S_t(e,i)};lMe.displayName="Menu";const b_t=(t,e)=>{"use no memo";const i=tle(o=>o.setFocusByFirstCharacter),{onKeyDown:r}=t.root;return t.root.onKeyDown=o=>{var l;r?.(o),!(((l=o.key)===null||l===void 0?void 0:l.length)>1)&&e.current&&i?.(o,e.current)},t},cMe=$.createContext(void 0),dMe={setMultiline:()=>null};cMe.Provider;const uMe=()=>{var t;return(t=$.useContext(cMe))!==null&&t!==void 0?t:dMe},hMe=()=>uMe()!==dMe,T_t=Nse(Xyt,eSt),C_t=Nse(Qyt,Zyt),__t=(t,e)=>{const i=c_t(),r=jh(I=>I.persistOnItemClick),{as:o="div",disabled:l=!1,hasSubmenu:d=i,persistOnClick:h=r}=t,{hasIcons:p,hasCheckmarks:g}=A_t({hasSubmenu:d}),f=jh(I=>I.setOpen);E_t({multiline:!!t.subText,hasSubmenu:d});const{dir:y}=Ov(),T=$.useRef(null),C=$.useRef(!1),E={hasSubmenu:d,disabled:l,persistOnClick:h,components:{root:"div",icon:"span",checkmark:"span",submenuIndicator:"span",content:"span",secondaryContent:"span",subText:"span"},root:Bl(_p(o,Ese(o,{role:"menuitem",...t,disabled:!1,disabledFocusable:l,ref:kC(e,T),onKeyDown:Fl(I=>{var w;(w=t.onKeyDown)===null||w===void 0||w.call(t,I),!I.isDefaultPrevented()&&(I.key===UH||I.key===FH)&&(C.current=!0)}),onMouseMove:Fl(I=>{var w;if(I.currentTarget.ownerDocument.activeElement!==I.currentTarget){var D;(D=T.current)===null||D===void 0||D.focus()}(w=t.onMouseMove)===null||w===void 0||w.call(t,I)}),onClick:Fl(I=>{var w;!d&&!h&&(f(I,{open:!1,keyboard:C.current,bubble:!0,type:"menuItemClick",event:I}),C.current=!1),(w=t.onClick)===null||w===void 0||w.call(t,I)})})),{elementType:"div"}),icon:Ss(t.icon,{renderByDefault:p,elementType:"span"}),checkmark:Ss(t.checkmark,{renderByDefault:g,elementType:"span"}),submenuIndicator:Ss(t.submenuIndicator,{renderByDefault:d,defaultProps:{children:y==="ltr"?$.createElement(T_t,null):$.createElement(C_t,null)},elementType:"span"}),content:Ss(t.content,{renderByDefault:!!t.children,defaultProps:{children:t.children},elementType:"span"}),secondaryContent:Ss(t.secondaryContent,{elementType:"span"}),subText:Ss(t.subText,{elementType:"span"})};return b_t(E,T),E},E_t=t=>{const{hasSubmenu:e,multiline:i}=t,r=hMe()&&e,{setMultiline:o}=uMe();fA(()=>{r||o(i)},[o,i,r])},A_t=t=>{const{hasSubmenu:e}=t,i=tle(l=>l.hasIcons),r=tle(l=>l.hasCheckmarks),o=hMe()&&e;return{hasIcons:i&&!o,hasCheckmarks:r&&!o}},I_t=t=>(Pd(t),Uf(t.root,{children:[t.checkmark&&yr(t.checkmark,{}),t.icon&&yr(t.icon,{}),t.content&&Uf(t.content,{children:[t.content.children,t.subText&&yr(t.subText,{})]}),t.secondaryContent&&yr(t.secondaryContent,{}),t.submenuIndicator&&yr(t.submenuIndicator,{})]})),w_t=uo({root:{a9b677:"fjw5fx7",Bqenvij:"fd461yt",Bcdw1i0:"fd7fpy0",Bnnss6s:"fi64zpg"},rootChecked:{Bcdw1i0:"f1022m68",Bnnss6s:"fi64zpg"}},{d:[".fjw5fx7{width:16px;}",".fd461yt{height:16px;}",".fd7fpy0{visibility:hidden;}",".fi64zpg{flex-shrink:0;}",".f1022m68{visibility:visible;}"]}),k_t=t=>{"use no memo";const e=w_t();t.checkmark&&(t.checkmark.className=ea(e.root,t.checked&&e.rootChecked,t.checkmark.className))},Mx={root:"fui-MenuItem",icon:"fui-MenuItem__icon",checkmark:"fui-MenuItem__checkmark",submenuIndicator:"fui-MenuItem__submenuIndicator",content:"fui-MenuItem__content",secondaryContent:"fui-MenuItem__secondaryContent",subText:"fui-MenuItem__subText"},R_t=pd("rfoezjv","r8lt3v0",{r:[".rfoezjv{border-radius:var(--borderRadiusMedium);position:relative;color:var(--colorNeutralForeground2);background-color:var(--colorNeutralBackground1);padding-right:var(--spacingVerticalSNudge);padding-left:var(--spacingVerticalSNudge);padding-top:var(--spacingVerticalSNudge);padding-bottom:var(--spacingVerticalSNudge);box-sizing:border-box;max-width:290px;min-height:32px;flex-shrink:0;display:flex;align-items:start;font-size:var(--fontSizeBase300);cursor:pointer;gap:4px;-webkit-user-select:none;-moz-user-select:none;user-select:none;}",".rfoezjv:hover{background-color:var(--colorNeutralBackground1Hover);color:var(--colorNeutralForeground2Hover);}",".rfoezjv:hover .fui-Icon-filled{display:inline;}",".rfoezjv:hover .fui-Icon-regular{display:none;}",".rfoezjv:hover .fui-MenuItem__icon{color:var(--colorNeutralForeground2BrandSelected);}",".rfoezjv:hover .fui-MenuItem__subText{color:var(--colorNeutralForeground3Hover);}",".rfoezjv:hover:active{background-color:var(--colorNeutralBackground1Pressed);color:var(--colorNeutralForeground2Pressed);}",".rfoezjv:hover:active .fui-MenuItem__subText{color:var(--colorNeutralForeground3Pressed);}",".rfoezjv:focus{outline-style:none;}",".rfoezjv:focus-visible{outline-style:none;}",".rfoezjv[data-fui-focus-visible]{border-top-color:transparent;border-right-color:transparent;border-bottom-color:transparent;border-left-color:transparent;}",'.rfoezjv[data-fui-focus-visible]::after{content:"";position:absolute;pointer-events:none;z-index:1;border:2px solid var(--colorStrokeFocus2);border-radius:var(--borderRadiusMedium);top:calc(2px * -1);right:calc(2px * -1);bottom:calc(2px * -1);left:calc(2px * -1);}',".r8lt3v0{border-radius:var(--borderRadiusMedium);position:relative;color:var(--colorNeutralForeground2);background-color:var(--colorNeutralBackground1);padding-left:var(--spacingVerticalSNudge);padding-right:var(--spacingVerticalSNudge);padding-top:var(--spacingVerticalSNudge);padding-bottom:var(--spacingVerticalSNudge);box-sizing:border-box;max-width:290px;min-height:32px;flex-shrink:0;display:flex;align-items:start;font-size:var(--fontSizeBase300);cursor:pointer;gap:4px;-webkit-user-select:none;-moz-user-select:none;user-select:none;}",".r8lt3v0:hover{background-color:var(--colorNeutralBackground1Hover);color:var(--colorNeutralForeground2Hover);}",".r8lt3v0:hover .fui-Icon-filled{display:inline;}",".r8lt3v0:hover .fui-Icon-regular{display:none;}",".r8lt3v0:hover .fui-MenuItem__icon{color:var(--colorNeutralForeground2BrandSelected);}",".r8lt3v0:hover .fui-MenuItem__subText{color:var(--colorNeutralForeground3Hover);}",".r8lt3v0:hover:active{background-color:var(--colorNeutralBackground1Pressed);color:var(--colorNeutralForeground2Pressed);}",".r8lt3v0:hover:active .fui-MenuItem__subText{color:var(--colorNeutralForeground3Pressed);}",".r8lt3v0:focus{outline-style:none;}",".r8lt3v0:focus-visible{outline-style:none;}",".r8lt3v0[data-fui-focus-visible]{border-top-color:transparent;border-left-color:transparent;border-bottom-color:transparent;border-right-color:transparent;}",'.r8lt3v0[data-fui-focus-visible]::after{content:"";position:absolute;pointer-events:none;z-index:1;border:2px solid var(--colorStrokeFocus2);border-radius:var(--borderRadiusMedium);top:calc(2px * -1);left:calc(2px * -1);bottom:calc(2px * -1);right:calc(2px * -1);}'],s:['@media (forced-colors: active){.rfoezjv:hover{background-color:Canvas;border-color:Highlight;color:Highlight;}.rfoezjv:focus{outline-style:none;}.rfoezjv:focus-visible{outline-style:none;}.rfoezjv[data-fui-focus-visible]{border-top-color:transparent;border-right-color:transparent;border-bottom-color:transparent;border-left-color:transparent;}@media (forced-colors: active){.rfoezjv[data-fui-focus-visible]::after{border-top-color:Highlight;border-right-color:Highlight;border-bottom-color:Highlight;border-left-color:Highlight;}}.rfoezjv[data-fui-focus-visible]::after{content:"";position:absolute;pointer-events:none;z-index:1;border:2px solid Highlight;border-radius:var(--borderRadiusMedium);top:calc(2px * -1);right:calc(2px * -1);bottom:calc(2px * -1);left:calc(2px * -1);}}',"@media (forced-colors: active){.rfoezjv[data-fui-focus-visible]::after{border-top-color:Highlight;border-right-color:Highlight;border-bottom-color:Highlight;border-left-color:Highlight;}}",'@media (forced-colors: active){.r8lt3v0:hover{background-color:Canvas;border-color:Highlight;color:Highlight;}.r8lt3v0:focus{outline-style:none;}.r8lt3v0:focus-visible{outline-style:none;}.r8lt3v0[data-fui-focus-visible]{border-top-color:transparent;border-left-color:transparent;border-bottom-color:transparent;border-right-color:transparent;}@media (forced-colors: active){.r8lt3v0[data-fui-focus-visible]::after{border-top-color:Highlight;border-left-color:Highlight;border-bottom-color:Highlight;border-right-color:Highlight;}}.r8lt3v0[data-fui-focus-visible]::after{content:"";position:absolute;pointer-events:none;z-index:1;border:2px solid Highlight;border-radius:var(--borderRadiusMedium);top:calc(2px * -1);left:calc(2px * -1);bottom:calc(2px * -1);right:calc(2px * -1);}}',"@media (forced-colors: active){.r8lt3v0[data-fui-focus-visible]::after{border-top-color:Highlight;border-left-color:Highlight;border-bottom-color:Highlight;border-right-color:Highlight;}}"]}),M_t=pd("r1ls86vo","rpbc5dr",[".r1ls86vo{padding-left:2px;padding-right:2px;background-color:transparent;flex-grow:1;}",".rpbc5dr{padding-right:2px;padding-left:2px;background-color:transparent;flex-grow:1;}"]),P_t=pd("r12mwwux","r1ewgu5j",[".r12mwwux{padding-left:2px;padding-right:2px;font-family:var(--fontFamilyBase);font-size:var(--fontSizeBase200);font-weight:var(--fontWeightRegular);line-height:var(--lineHeightBase300);color:var(--colorNeutralForeground3);}",".r12mwwux:hover{color:var(--colorNeutralForeground3Hover);}",".r12mwwux:focus{color:var(--colorNeutralForeground3Hover);}",".r1ewgu5j{padding-right:2px;padding-left:2px;font-family:var(--fontFamilyBase);font-size:var(--fontSizeBase200);font-weight:var(--fontWeightRegular);line-height:var(--lineHeightBase300);color:var(--colorNeutralForeground3);}",".r1ewgu5j:hover{color:var(--colorNeutralForeground3Hover);}",".r1ewgu5j:focus{color:var(--colorNeutralForeground3Hover);}"]),D_t=pd("ro9koqv",null,[".ro9koqv{width:20px;height:20px;font-size:20px;line-height:0;align-items:center;display:inline-flex;justify-content:center;flex-shrink:0;}"]),L_t=pd("r9c34qo",null,[".r9c34qo{width:20px;height:20px;font-size:20px;line-height:0;align-items:center;display:inline-flex;justify-content:center;}"]),O_t=pd("rk2ppru",null,[".rk2ppru{font-family:var(--fontFamilyBase);font-size:var(--fontSizeBase100);font-weight:var(--fontWeightRegular);line-height:var(--lineHeightBase100);color:var(--colorNeutralForeground3);}"]),N_t=uo({checkmark:{B6of3ja:"fmnzpld"},splitItemMain:{Bh6795r:"fqerorx"},splitItemTrigger:{Btl43ni:["f1ozlkrg","f10ostut"],Beyfa6y:["f1deotkl","f1krrbdw"],uwmqm3:["f1cnd47f","fhxju0i"],Ftih45:"f1wl9k8s",Ccq8qp:"f1yn80uh",Baz25je:"f68mna0",cmx5o7:"f1p5zmk"},disabled:{sj55zd:"f1s2aq7o",Bi91k9c:"fvgxktp",Jwef8y:"f1ijtazh",eoavqd:"fphbwmw",Bk3fhr4:"f19vpps7",Bmfj8id:"fv5swzo",Bg7n49j:"f1q1x1ba",B2d53fq:"fcvwxyo",iro3zm:"f1to34ca",t0hwav:"ft33916",Bbusuzp:"f1dcs8yz",ze5xyy:"f1kc2mi9",Bqrx1nm:"fkavljg",Bctn1xl:"fk56vqo",h5esng:"ff3wi9b",Bh6z0a4:"f1ikwg0d",Bh953qp:"f10l1t5h"}},{d:[".fmnzpld{margin-top:2px;}",".fqerorx{flex-grow:1;}",".f1ozlkrg{border-top-left-radius:0;}",".f10ostut{border-top-right-radius:0;}",".f1deotkl{border-bottom-left-radius:0;}",".f1krrbdw{border-bottom-right-radius:0;}",".f1cnd47f{padding-left:0;}",".fhxju0i{padding-right:0;}",'.f1wl9k8s::before{content:"";}',".f1yn80uh::before{width:var(--strokeWidthThin);}",".f68mna0::before{height:24px;}",".f1p5zmk::before{background-color:var(--colorNeutralStroke1);}",".f1s2aq7o{color:var(--colorNeutralForegroundDisabled);}"],h:[".fvgxktp:hover{color:var(--colorNeutralForegroundDisabled);}",".f1ijtazh:hover{background-color:var(--colorNeutralBackground1);}",".fphbwmw:hover{cursor:not-allowed;}",".f19vpps7:hover .fui-Icon-filled{display:none;}",".fv5swzo:hover .fui-Icon-regular{display:inline;}",".f1q1x1ba:hover .fui-MenuItem__icon{color:var(--colorNeutralForegroundDisabled);}",".fcvwxyo:hover:active{color:var(--colorNeutralForegroundDisabled);}",".f1to34ca:hover:active{background-color:var(--colorNeutralBackground1);}"],f:[".ft33916:focus{color:var(--colorNeutralForegroundDisabled);}"],m:[["@media (forced-colors: active){.f1dcs8yz{color:GrayText;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f1kc2mi9:hover{color:GrayText;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.fkavljg:hover{background-color:Canvas;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.fk56vqo:hover .fui-MenuItem__icon{color:GrayText;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.ff3wi9b:hover .fui-MenuItem__icon{background-color:Canvas;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f1ikwg0d:focus{color:GrayText;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f10l1t5h:focus{background-color:Canvas;}}",{m:"(forced-colors: active)"}]]}),x_t=uo({content:{mc9l5x:"f22iagw",Beiy3e4:"f1vx9l62"},secondaryContent:{qb2dma:"f7nlbp4"},submenuIndicator:{qb2dma:"f7nlbp4"}},{d:[".f22iagw{display:flex;}",".f1vx9l62{flex-direction:column;}",".f7nlbp4{align-self:center;}"]}),B_t=t=>{"use no memo";const e=N_t(),i=R_t(),r=M_t(),o=P_t(),l=D_t(),d=L_t(),h=x_t(),p=O_t(),g=!!t.subText;return t.root.className=ea(Mx.root,i,t.disabled&&e.disabled,t.root.className),t.content&&(t.content.className=ea(Mx.content,r,t.content.className,g&&h.content)),t.checkmark&&(t.checkmark.className=ea(Mx.checkmark,e.checkmark,t.checkmark.className)),t.secondaryContent&&(t.secondaryContent.className=ea(Mx.secondaryContent,!t.disabled&&o,t.secondaryContent.className,g&&h.secondaryContent)),t.icon&&(t.icon.className=ea(Mx.icon,l,t.icon.className)),t.submenuIndicator&&(t.submenuIndicator.className=ea(Mx.submenuIndicator,d,t.submenuIndicator.className,g&&h.submenuIndicator)),t.subText&&(t.subText.className=ea(Mx.subText,t.subText.className,p)),k_t(t),t},pMe=$.forwardRef((t,e)=>{const i=__t(t,e);return B_t(i),kh("useMenuItemStyles_unstable")(i),I_t(i)});pMe.displayName="MenuItem";const F_t=(t,e)=>{const{findAllFocusable:i}=iK(),{targetDocument:r}=Ov(),o=U_t(),l=Gke(Xse),d=NH({circular:!0});z_t(t,o,l)&&console.warn("You are using both MenuList and Menu props, we recommend you to use Menu props when available");const h=$.useRef(null);$.useEffect(()=>{const w=h.current;if(l&&r&&w){const D=F=>{const x=F.detail.next;x&&w.contains(r.activeElement)&&!w.contains(x)&&F.preventDefault()};return r.addEventListener(ase,D),()=>{r.removeEventListener(ase,D)}}},[h,r,l]);const p=$.useCallback((w,D)=>{const F=["menuitem","menuitemcheckbox","menuitemradio"];if(!h.current)return;const x=i(h.current,J=>J.hasAttribute("role")&&F.indexOf(J.getAttribute("role"))!==-1);let B=x.indexOf(D)+1;B===x.length&&(B=0);const L=x.map(J=>{var Z;return(Z=J.textContent)===null||Z===void 0?void 0:Z.charAt(0).toLowerCase()}),z=w.key.toLowerCase(),H=(J,Z)=>{for(let re=J;re<L.length;re++)if(z===L[re])return re;return-1};let j=H(B);j===-1&&(j=H(0)),j>-1&&x[j].focus()},[i]);var g;const[f,y]=OL({state:(g=t.checkedValues)!==null&&g!==void 0?g:l?o.checkedValues:void 0,defaultState:t.defaultCheckedValues,initialState:{}});var T;const C=(T=t.onCheckedValueChange)!==null&&T!==void 0?T:l?o.onCheckedValueChange:void 0,E=Fl((w,D,F,x)=>{const L=[...f?.[D]||[]];x?L.splice(L.indexOf(F),1):L.push(F),C?.(w,{name:D,checkedItems:L}),y(z=>({...z,[D]:L}))}),I=Fl((w,D,F)=>{const x=[F];y(B=>({...B,[D]:x})),C?.(w,{name:D,checkedItems:x})});return{components:{root:"div"},root:Bl(_p("div",{ref:kC(e,h),role:"menu","aria-labelledby":o.triggerId,...d,...t}),{elementType:"div"}),hasIcons:o.hasIcons||!1,hasCheckmarks:o.hasCheckmarks||!1,checkedValues:f,hasMenuContext:l,setFocusByFirstCharacter:p,selectRadio:I,toggleCheckbox:E}},U_t=()=>{const t=jh(l=>l.checkedValues),e=jh(l=>l.onCheckedValueChange),i=jh(l=>l.triggerId),r=jh(l=>l.hasIcons),o=jh(l=>l.hasCheckmarks);return{checkedValues:t,onCheckedValueChange:e,triggerId:i,hasIcons:r,hasCheckmarks:o}},z_t=(t,e,i)=>{let r=!1;for(const o in e)t[o]&&(r=!0);return i&&r},V_t=(t,e)=>(Pd(t),yr(u_t,{value:e.menuList,children:yr(t.root,{})}));function $_t(t){const{checkedValues:e,hasCheckmarks:i,hasIcons:r,selectRadio:o,setFocusByFirstCharacter:l,toggleCheckbox:d}=t;return{menuList:{checkedValues:e,hasCheckmarks:i,hasIcons:r,selectRadio:o,setFocusByFirstCharacter:l,toggleCheckbox:d}}}const H_t={root:"fui-MenuList"},j_t=uo({root:{mc9l5x:"f22iagw",Beiy3e4:"f1vx9l62",i8kkvl:0,Belr9w4:0,rmohyg:"f1t6b6ee"},hasMenuContext:{Bqenvij:"f1l02sjl"}},{d:[".f22iagw{display:flex;}",".f1vx9l62{flex-direction:column;}",[".f1t6b6ee{gap:2px;}",{p:-1}],".f1l02sjl{height:100%;}"]}),G_t=t=>{"use no memo";const e=j_t();return t.root.className=ea(H_t.root,e.root,t.hasMenuContext&&e.hasMenuContext,t.root.className),t},gMe=$.forwardRef((t,e)=>{const i=F_t(t,e),r=$_t(i);return G_t(i),kh("useMenuListStyles_unstable")(i),V_t(i,r)});gMe.displayName="MenuList";const q_t=(t,e)=>{"use no memo";const i=jh(L=>L.menuPopoverRef),r=jh(L=>L.setOpen),o=jh(L=>L.open),l=jh(L=>L.openOnHover),d=jh(L=>L.triggerRef),h=ile(),p=$.useRef(!0),g=Pvt(),[f,y]=Yoe(),{dir:T}=Ov(),C=T==="ltr"?qke:Wke,E=$.useCallback(L=>{L&&L.addEventListener("mouseover",z=>{p.current&&(p.current=!1,p_t(i.current,z),f(()=>p.current=!0,250))})},[i,f]);$.useEffect(()=>{},[y]);var I;const w=(I=jh(L=>L.inline))!==null&&I!==void 0?I:!1,D=jh(L=>L.mountNode),F=Bl(_p("div",{role:"presentation",...g,...t,ref:kC(e,i,E)}),{elementType:"div"}),{onMouseEnter:x,onKeyDown:B}=F;return F.onMouseEnter=Fl(L=>{(l||h)&&r(L,{open:!0,keyboard:!1,type:"menuPopoverMouseEnter",event:L}),x?.(L)}),F.onKeyDown=Fl(L=>{const z=L.key;if(z===Kke||h&&z===C){var H;o&&(!((H=i.current)===null||H===void 0)&&H.contains(L.target))&&!L.isDefaultPrevented()&&(r(L,{open:!1,keyboard:!0,type:"menuPopoverKeyDown",event:L}),L.preventDefault())}if(z===Vyt&&(r(L,{open:!1,keyboard:!0,type:"menuPopoverKeyDown",event:L}),!h)){var j;(j=d.current)===null||j===void 0||j.focus()}B?.(L)}),{inline:w,mountNode:D,components:{root:"div"},root:F}},W_t={root:"fui-MenuPopover"},K_t=uo({root:{Beyfa6y:0,Bbmb7ep:0,Btl43ni:0,B7oj6ja:0,Dimara:"ft85np5",De3pzq:"fxugw4r",sj55zd:"f19n0e5",B7ck84d:"f1ewtqcl",Bf4jedk:"fl8fusi",B2u0y6b:"f1kaai3v",B68tc82:"f1p9o1ba",a9b677:"f1ahpp82",E5pizo:"f1hg901r",Byoj8tv:0,uwmqm3:0,z189sj:0,z8tnut:0,B0ocmuz:"fd3pd8h",Bgfg5da:0,B9xav0g:0,oivjwe:0,Bn0qgzm:0,B4g9neb:0,zhjwy3:0,wvpqe5:0,ibv6hh:0,u1mtju:0,h3c5rm:0,vrafjx:0,Bekrc4i:0,i8vvqc:0,g2u3we:0,icvyot:0,B4j52fo:0,irswps:"f9ggezi",Bahqtrf:"fk6fouc",Be2twd7:"fkhj508",Bhrd7zp:"figsok6",Bg96gwp:"f1i3iumi",B93otf3:"f18k4bn6",vin17d:"fo1kyvf",Ezkn3b:"fetxo7e",nyiy2g:"f8x1vz1",swvrvq:"f8g0anz",Bkovbt3:"fezwn9i",hgjdhn:"fz5efge",fsy9dk:"f1ydixl4",B3ogreh:"f8dgqj5",jv49x5:"fnyfnr8",Bk7o48c:"fgw77r4",Bv12yb3:"f1noc5he",z0t1cu:"fi19xcv",Bks05zx:"f1mxk9aa",Bvtglag:"ffzg62k"}},{d:[[".ft85np5{border-radius:var(--borderRadiusMedium);}",{p:-1}],".fxugw4r{background-color:var(--colorNeutralBackground1);}",".f19n0e5{color:var(--colorNeutralForeground1);}",".f1ewtqcl{box-sizing:border-box;}",".fl8fusi{min-width:138px;}",".f1kaai3v{max-width:300px;}",".f1p9o1ba{overflow-x:hidden;}",".f1ahpp82{width:max-content;}",".f1hg901r{box-shadow:var(--shadow16);}",[".fd3pd8h{padding:4px;}",{p:-1}],[".f9ggezi{border:1px solid var(--colorTransparentStroke);}",{p:-2}],".fk6fouc{font-family:var(--fontFamilyBase);}",".fkhj508{font-size:var(--fontSizeBase300);}",".figsok6{font-weight:var(--fontWeightRegular);}",".f1i3iumi{line-height:var(--lineHeightBase300);}",".f18k4bn6{animation-composition:accumulate;}",".fo1kyvf{animation-duration:var(--durationSlower);}",".fetxo7e{animation-timing-function:var(--curveDecelerateMid);}",".f8x1vz1{--fui-positioning-slide-distance-x:0px;}",".f8g0anz{--fui-positioning-slide-distance-y:10px;}",".fezwn9i[data-popper-placement^=right]{--fui-positioning-slide-distance-x:-10px;}",".fz5efge[data-popper-placement^=right]{--fui-positioning-slide-distance-y:0px;}",".f1ydixl4[data-popper-placement^=bottom]{--fui-positioning-slide-distance-x:0px;}",".f8dgqj5[data-popper-placement^=bottom]{--fui-positioning-slide-distance-y:-10px;}",".fnyfnr8[data-popper-placement^=left]{--fui-positioning-slide-distance-x:10px;}",".fgw77r4[data-popper-placement^=left]{--fui-positioning-slide-distance-y:0px;}",".f1noc5he{animation-name:f1m0q9mo,f79suad;}"],k:["@keyframes f1m0q9mo{from{opacity:-1;}to{opacity:0;}}","@keyframes f79suad{from{transform:translate(var(--fui-positioning-slide-distance-x), var(--fui-positioning-slide-distance-y));}}"],m:[["@media (prefers-reduced-motion){.fi19xcv[data-popper-placement]{animation-duration:1ms;}}",{m:"(prefers-reduced-motion)"}],["@media (prefers-reduced-motion){.f1mxk9aa[data-popper-placement]{animation-name:f1m0q9mo;}}",{m:"(prefers-reduced-motion)"}]],t:["@supports not (animation-composition: accumulate){.ffzg62k[data-popper-placement]{animation-name:f1m0q9mo;}}"]}),J_t=t=>{"use no memo";const e=K_t();return t.root.className=ea(W_t.root,e.root,t.root.className),t},Y_t=t=>(Pd(t),t.inline?yr(t.root,{}):yr(JRe,{mountNode:t.mountNode,children:yr(t.root,{})})),mMe=$.forwardRef((t,e)=>{const i=q_t(t,e);return J_t(i),kh("useMenuPopoverStyles_unstable")(i),Y_t(i)});mMe.displayName="MenuPopover";const Q_t=t=>{const{children:e,disableButtonEnhancement:i=!1}=t,r=jh(re=>re.triggerRef),o=jh(re=>re.menuPopoverRef),l=jh(re=>re.setOpen),d=jh(re=>re.open),h=jh(re=>re.triggerId),p=jh(re=>re.openOnHover),g=jh(re=>re.openOnContext),f=ile(),{findFirstFocusable:y}=iK(),T=$.useCallback(()=>{const re=y(o.current);re?.focus()},[y,o]),C=$.useRef(!1),E=$.useRef(!1),{dir:I}=Ov(),w=I==="ltr"?Wke:qke,D=Bwe(e),F=re=>{D5(re)||re.isDefaultPrevented()||g&&(re.preventDefault(),l(re,{open:!0,keyboard:!1,type:"menuTriggerContextMenu",event:re}))},x=re=>{D5(re)||g||(l(re,{open:!d,keyboard:C.current,type:"menuTriggerClick",event:re}),C.current=!1)},B=re=>{if(D5(re))return;const ne=re.key;!g&&(f&&ne===w||!f&&ne===$yt)&&l(re,{open:!0,keyboard:!0,type:"menuTriggerKeyDown",event:re}),ne===Kke&&!f&&l(re,{open:!1,keyboard:!0,type:"menuTriggerKeyDown",event:re}),d&&ne===w&&f&&T()},L=re=>{D5(re)||p&&E.current&&l(re,{open:!0,keyboard:!1,type:"menuTriggerMouseEnter",event:re})},z=re=>{D5(re)||p&&!E.current&&(l(re,{open:!0,keyboard:!1,type:"menuTriggerMouseMove",event:re}),E.current=!0)},H=re=>{D5(re)||p&&l(re,{open:!1,keyboard:!1,type:"menuTriggerMouseLeave",event:re})},j={id:h,...D?.props,ref:kC(r,D?.ref),onMouseEnter:Fl(vA(D?.props.onMouseEnter,L)),onMouseLeave:Fl(vA(D?.props.onMouseLeave,H)),onContextMenu:Fl(vA(D?.props.onContextMenu,F)),onMouseMove:Fl(vA(D?.props.onMouseMove,z))},J={"aria-haspopup":"menu","aria-expanded":!d&&!f?void 0:d,...j,onClick:Fl(vA(D?.props.onClick,x)),onKeyDown:Fl(vA(D?.props.onKeyDown,B))},Z=Ese(D?.type==="button"||D?.type==="a"?D.type:"div",J);return{isSubmenu:f,children:aft(e,g?j:i?J:Z)}},D5=t=>{const e=i=>i.hasAttribute("disabled")||i.hasAttribute("aria-disabled")&&i.getAttribute("aria-disabled")==="true";return yA(t.target)&&e(t.target)?!0:yA(t.currentTarget)&&e(t.currentTarget)},Z_t=t=>$.createElement(l_t,{value:t.isSubmenu},t.children),nle=t=>{const e=Q_t(t);return Z_t(e)};nle.displayName="MenuTrigger",nle.isFluentTriggerComponent=!0;const fMe=$.createContext(void 0),X_t={};fMe.Provider;const eEt=()=>{var t;return(t=$.useContext(fMe))!==null&&t!==void 0?t:X_t},tEt=(t,e)=>{const{size:i}=eEt(),{appearance:r="primary",labelPosition:o="after",size:l=i??"medium",delay:d=0}=t,h=NL("spinner"),{role:p="progressbar",...g}=t,f=Bl(_p("div",{ref:e,role:p,...g},["size"]),{elementType:"div"}),[y,T]=$.useState(!1),[C,E]=Yoe();$.useEffect(()=>{if(!(d<=0))return C(()=>{T(!0)},d),()=>{E()}},[C,E,d]);const I=Ss(t.label,{defaultProps:{id:h},renderByDefault:!1,elementType:FM}),w=Ss(t.spinner,{renderByDefault:!0,elementType:"span"});return I&&f&&!f["aria-labelledby"]&&(f["aria-labelledby"]=I.id),{appearance:r,delay:d,labelPosition:o,size:l,shouldRenderSpinner:!d||y,components:{root:"div",spinner:"span",spinnerTail:"span",label:FM},root:f,spinner:w,spinnerTail:Bl(t.spinnerTail,{elementType:"span"}),label:I}},iEt=t=>{Pd(t);const{labelPosition:e,shouldRenderSpinner:i}=t;return Uf(t.root,{children:[t.label&&i&&(e==="above"||e==="before")&&yr(t.label,{}),t.spinner&&i&&yr(t.spinner,{children:t.spinnerTail&&yr(t.spinnerTail,{})}),t.label&&i&&(e==="below"||e==="after")&&yr(t.label,{})]})},_K={root:"fui-Spinner",spinner:"fui-Spinner__spinner",spinnerTail:"fui-Spinner__spinnerTail",label:"fui-Spinner__label"},nEt=pd("r82apo5",null,[".r82apo5{display:flex;align-items:center;justify-content:center;line-height:0;gap:8px;overflow:hidden;}"]),aEt=uo({vertical:{Beiy3e4:"f1vx9l62"}},{d:[".f1vx9l62{flex-direction:column;}"]}),rEt=pd("rvgcg50","r15nd2jo",{r:[".rvgcg50{position:relative;flex-shrink:0;-webkit-mask-image:radial-gradient(closest-side, transparent calc(100% - var(--fui-Spinner--strokeWidth) - 1px), white calc(100% - var(--fui-Spinner--strokeWidth)) calc(100% - 1px), transparent 100%);mask-image:radial-gradient(closest-side, transparent calc(100% - var(--fui-Spinner--strokeWidth) - 1px), white calc(100% - var(--fui-Spinner--strokeWidth)) calc(100% - 1px), transparent 100%);background-color:var(--colorBrandStroke2Contrast);color:var(--colorBrandStroke1);animation-duration:1.5s;animation-iteration-count:infinite;animation-timing-function:linear;animation-name:rb7n1on;}","@keyframes rb7n1on{0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}}",".r15nd2jo{position:relative;flex-shrink:0;-webkit-mask-image:radial-gradient(closest-side, transparent calc(100% - var(--fui-Spinner--strokeWidth) - 1px), white calc(100% - var(--fui-Spinner--strokeWidth)) calc(100% - 1px), transparent 100%);mask-image:radial-gradient(closest-side, transparent calc(100% - var(--fui-Spinner--strokeWidth) - 1px), white calc(100% - var(--fui-Spinner--strokeWidth)) calc(100% - 1px), transparent 100%);background-color:var(--colorBrandStroke2Contrast);color:var(--colorBrandStroke1);animation-duration:1.5s;animation-iteration-count:infinite;animation-timing-function:linear;animation-name:r1gx3jof;}","@keyframes r1gx3jof{0%{transform:rotate(0deg);}100%{transform:rotate(-360deg);}}"],s:["@media screen and (forced-colors: active){.rvgcg50{background-color:HighlightText;color:Highlight;forced-color-adjust:none;}}","@media screen and (prefers-reduced-motion: reduce){.rvgcg50{animation-duration:1.8s;}}","@media screen and (forced-colors: active){.r15nd2jo{background-color:HighlightText;color:Highlight;forced-color-adjust:none;}}","@media screen and (prefers-reduced-motion: reduce){.r15nd2jo{animation-duration:1.8s;}}"]}),oEt=pd("rxov3xa","r1o544mv",{r:[".rxov3xa{position:absolute;display:block;width:100%;height:100%;-webkit-mask-image:conic-gradient(transparent 105deg, white 105deg);mask-image:conic-gradient(transparent 105deg, white 105deg);animation-duration:1.5s;animation-iteration-count:infinite;animation-timing-function:var(--curveEasyEase);animation-name:r15mim6k;}",'.rxov3xa::before,.rxov3xa::after{content:"";position:absolute;display:block;width:100%;height:100%;animation:inherit;background-image:conic-gradient(currentcolor 135deg, transparent 135deg);}',"@keyframes r15mim6k{0%{transform:rotate(-135deg);}50%{transform:rotate(0deg);}100%{transform:rotate(225deg);}}",".rxov3xa::before{animation-name:r18vhmn8;}","@keyframes r18vhmn8{0%{transform:rotate(0deg);}50%{transform:rotate(105deg);}100%{transform:rotate(0deg);}}",".rxov3xa::after{animation-name:rkgrvoi;}","@keyframes rkgrvoi{0%{transform:rotate(0deg);}50%{transform:rotate(225deg);}100%{transform:rotate(0deg);}}",".r1o544mv{position:absolute;display:block;width:100%;height:100%;-webkit-mask-image:conic-gradient(transparent 105deg, white 105deg);mask-image:conic-gradient(transparent 105deg, white 105deg);animation-duration:1.5s;animation-iteration-count:infinite;animation-timing-function:var(--curveEasyEase);animation-name:r109gmi5;}",'.r1o544mv::before,.r1o544mv::after{content:"";position:absolute;display:block;width:100%;height:100%;animation:inherit;background-image:conic-gradient(currentcolor 135deg, transparent 135deg);}',"@keyframes r109gmi5{0%{transform:rotate(135deg);}50%{transform:rotate(0deg);}100%{transform:rotate(-225deg);}}",".r1o544mv::before{animation-name:r17whflh;}","@keyframes r17whflh{0%{transform:rotate(0deg);}50%{transform:rotate(-105deg);}100%{transform:rotate(0deg);}}",".r1o544mv::after{animation-name:re4odhl;}","@keyframes re4odhl{0%{transform:rotate(0deg);}50%{transform:rotate(-225deg);}100%{transform:rotate(0deg);}}"],s:["@media screen and (prefers-reduced-motion: reduce){.rxov3xa{animation-iteration-count:0;background-image:conic-gradient(transparent 120deg, currentcolor 360deg);}.rxov3xa::before,.rxov3xa::after{content:none;}}","@media screen and (prefers-reduced-motion: reduce){.r1o544mv{animation-iteration-count:0;background-image:conic-gradient(transparent 120deg, currentcolor 360deg);}.r1o544mv::before,.r1o544mv::after{content:none;}}"]}),sEt=uo({inverted:{De3pzq:"fr407j0",sj55zd:"f1f7voed"},rtlTail:{btxmck:"f179dep3",gb5jj2:"fbz9ihp",Br2kee7:"f1wkkxo7"},"extra-tiny":{Bqenvij:"fd461yt",a9b677:"fjw5fx7",qmp6fs:"f1v3ph3m"},tiny:{Bqenvij:"fjamq6b",a9b677:"f64fuq3",qmp6fs:"f1v3ph3m"},"extra-small":{Bqenvij:"frvgh55",a9b677:"fq4mcun",qmp6fs:"f1v3ph3m"},small:{Bqenvij:"fxldao9",a9b677:"f1w9dchk",qmp6fs:"f1v3ph3m"},medium:{Bqenvij:"f1d2rq10",a9b677:"f1szoe96",qmp6fs:"fb52u90"},large:{Bqenvij:"f8ljn23",a9b677:"fpdz1er",qmp6fs:"fb52u90"},"extra-large":{Bqenvij:"fbhnoac",a9b677:"feqmc2u",qmp6fs:"fb52u90"},huge:{Bqenvij:"f1ft4266",a9b677:"fksc0bp",qmp6fs:"fa3u9ii"}},{d:[".fr407j0{background-color:var(--colorNeutralStrokeAlpha2);}",".f1f7voed{color:var(--colorNeutralStrokeOnBrand2);}",".f179dep3{-webkit-mask-image:conic-gradient(white 255deg, transparent 255deg);mask-image:conic-gradient(white 255deg, transparent 255deg);}",".fbz9ihp::before,.fbz9ihp::after{background-image:conic-gradient(transparent 225deg, currentcolor 225deg);}",".fd461yt{height:16px;}",".fjw5fx7{width:16px;}",".f1v3ph3m{--fui-Spinner--strokeWidth:var(--strokeWidthThick);}",".fjamq6b{height:20px;}",".f64fuq3{width:20px;}",".frvgh55{height:24px;}",".fq4mcun{width:24px;}",".fxldao9{height:28px;}",".f1w9dchk{width:28px;}",".f1d2rq10{height:32px;}",".f1szoe96{width:32px;}",".fb52u90{--fui-Spinner--strokeWidth:var(--strokeWidthThicker);}",".f8ljn23{height:36px;}",".fpdz1er{width:36px;}",".fbhnoac{height:40px;}",".feqmc2u{width:40px;}",".f1ft4266{height:44px;}",".fksc0bp{width:44px;}",".fa3u9ii{--fui-Spinner--strokeWidth:var(--strokeWidthThickest);}"],m:[["@media screen and (prefers-reduced-motion: reduce){.f1wkkxo7{background-image:conic-gradient(currentcolor 0deg, transparent 240deg);}}",{m:"screen and (prefers-reduced-motion: reduce)"}]]}),lEt=uo({inverted:{sj55zd:"fonrgv7"},"extra-tiny":{Bahqtrf:"fk6fouc",Be2twd7:"fkhj508",Bhrd7zp:"figsok6",Bg96gwp:"f1i3iumi"},tiny:{Bahqtrf:"fk6fouc",Be2twd7:"fkhj508",Bhrd7zp:"figsok6",Bg96gwp:"f1i3iumi"},"extra-small":{Bahqtrf:"fk6fouc",Be2twd7:"fkhj508",Bhrd7zp:"figsok6",Bg96gwp:"f1i3iumi"},small:{Bahqtrf:"fk6fouc",Be2twd7:"fkhj508",Bhrd7zp:"figsok6",Bg96gwp:"f1i3iumi"},medium:{Bahqtrf:"fk6fouc",Be2twd7:"fod5ikn",Bhrd7zp:"fl43uef",Bg96gwp:"faaz57k"},large:{Bahqtrf:"fk6fouc",Be2twd7:"fod5ikn",Bhrd7zp:"fl43uef",Bg96gwp:"faaz57k"},"extra-large":{Bahqtrf:"fk6fouc",Be2twd7:"fod5ikn",Bhrd7zp:"fl43uef",Bg96gwp:"faaz57k"},huge:{Bahqtrf:"fk6fouc",Be2twd7:"f1pp30po",Bhrd7zp:"fl43uef",Bg96gwp:"f106mvju"}},{d:[".fonrgv7{color:var(--colorNeutralForegroundStaticInverted);}",".fk6fouc{font-family:var(--fontFamilyBase);}",".fkhj508{font-size:var(--fontSizeBase300);}",".figsok6{font-weight:var(--fontWeightRegular);}",".f1i3iumi{line-height:var(--lineHeightBase300);}",".fod5ikn{font-size:var(--fontSizeBase400);}",".fl43uef{font-weight:var(--fontWeightSemibold);}",".faaz57k{line-height:var(--lineHeightBase400);}",".f1pp30po{font-size:var(--fontSizeBase500);}",".f106mvju{line-height:var(--lineHeightBase500);}"]}),cEt=t=>{"use no memo";const{labelPosition:e,size:i,appearance:r}=t,{dir:o}=Ov(),l=nEt(),d=aEt(),h=rEt(),p=sEt(),g=oEt(),f=lEt();return t.root.className=ea(_K.root,l,(e==="above"||e==="below")&&d.vertical,t.root.className),t.spinner&&(t.spinner.className=ea(_K.spinner,h,p[i],r==="inverted"&&p.inverted,t.spinner.className)),t.spinnerTail&&(t.spinnerTail.className=ea(_K.spinnerTail,g,o==="rtl"&&p.rtlTail,t.spinnerTail.className)),t.label&&(t.label.className=ea(_K.label,f[i],r==="inverted"&&f.inverted,t.label.className)),t},vMe=$.forwardRef((t,e)=>{const i=tEt(t,e);return cEt(i),kh("useSpinnerStyles_unstable")(i),iEt(i)});vMe.displayName="Spinner";const dEt=(t,e)=>{t=Zse(t,{supportsLabelFor:!0,supportsRequired:!0});const{checked:i,defaultChecked:r,disabled:o,labelPosition:l="after",onChange:d,required:h}=t,p=RH({props:t,primarySlotTagName:"input",excludedPropNames:["checked","defaultChecked","onChange"]}),g=NL("switch-",p.primary.id),f=Bl(t.root,{defaultProps:{ref:yse(),...p.root},elementType:"div"}),y=Bl(t.indicator,{defaultProps:{"aria-hidden":!0,children:$.createElement(Jke,null)},elementType:"div"}),T=Bl(t.input,{defaultProps:{checked:i,defaultChecked:r,id:g,ref:e,role:"switch",type:"checkbox",...p.primary},elementType:"input"});T.onChange=vA(T.onChange,E=>d?.(E,{checked:E.currentTarget.checked}));const C=Ss(t.label,{defaultProps:{disabled:o,htmlFor:g,required:h,size:"medium"},elementType:FM});return{labelPosition:l,components:{root:"div",indicator:"div",input:"input",label:FM},root:f,indicator:y,input:T,label:C}},uEt=t=>{Pd(t);const{labelPosition:e}=t;return Uf(t.root,{children:[yr(t.input,{}),e!=="after"&&t.label&&yr(t.label,{}),yr(t.indicator,{}),e==="after"&&t.label&&yr(t.label,{})]})},EK={root:"fui-Switch",indicator:"fui-Switch__indicator",input:"fui-Switch__input",label:"fui-Switch__label"},hEt=pd("r2i81i2","rofhmb8",{r:[".r2i81i2{align-items:flex-start;box-sizing:border-box;display:inline-flex;position:relative;}",".r2i81i2:focus{outline-style:none;}",".r2i81i2:focus-visible{outline-style:none;}",".r2i81i2[data-fui-focus-within]:focus-within{border-top-color:transparent;border-right-color:transparent;border-bottom-color:transparent;border-left-color:transparent;}",'.r2i81i2[data-fui-focus-within]:focus-within::after{content:"";position:absolute;pointer-events:none;z-index:1;border:2px solid var(--colorStrokeFocus2);border-radius:var(--borderRadiusMedium);top:calc(2px * -1);right:calc(2px * -1);bottom:calc(2px * -1);left:calc(2px * -1);}',".rofhmb8{align-items:flex-start;box-sizing:border-box;display:inline-flex;position:relative;}",".rofhmb8:focus{outline-style:none;}",".rofhmb8:focus-visible{outline-style:none;}",".rofhmb8[data-fui-focus-within]:focus-within{border-top-color:transparent;border-left-color:transparent;border-bottom-color:transparent;border-right-color:transparent;}",'.rofhmb8[data-fui-focus-within]:focus-within::after{content:"";position:absolute;pointer-events:none;z-index:1;border:2px solid var(--colorStrokeFocus2);border-radius:var(--borderRadiusMedium);top:calc(2px * -1);left:calc(2px * -1);bottom:calc(2px * -1);right:calc(2px * -1);}'],s:["@media (forced-colors: active){.r2i81i2[data-fui-focus-within]:focus-within::after{border-top-color:Highlight;border-right-color:Highlight;border-bottom-color:Highlight;border-left-color:Highlight;}}","@media (forced-colors: active){.rofhmb8[data-fui-focus-within]:focus-within::after{border-top-color:Highlight;border-left-color:Highlight;border-bottom-color:Highlight;border-right-color:Highlight;}}"]}),pEt=uo({vertical:{Beiy3e4:"f1vx9l62"}},{d:[".f1vx9l62{flex-direction:column;}"]}),gEt=pd("r1c3hft5",null,{r:[".r1c3hft5{border-radius:var(--borderRadiusCircular);border:1px solid;line-height:0;box-sizing:border-box;fill:currentColor;flex-shrink:0;font-size:18px;height:20px;margin:var(--spacingVerticalS) var(--spacingHorizontalS);pointer-events:none;transition-duration:var(--durationNormal);transition-timing-function:var(--curveEasyEase);transition-property:background,border,color;width:40px;}",".r1c3hft5>*{transition-duration:var(--durationNormal);transition-timing-function:var(--curveEasyEase);transition-property:transform;}"],s:["@media screen and (prefers-reduced-motion: reduce){.r1c3hft5{transition-duration:0.01ms;}}","@media (forced-colors: active){.r1c3hft5{color:CanvasText;}.r1c3hft5>i{forced-color-adjust:none;}}","@media screen and (prefers-reduced-motion: reduce){.r1c3hft5>*{transition-duration:0.01ms;}}"]}),mEt=uo({labelAbove:{B6of3ja:"f1hu3pq6"}},{d:[".f1hu3pq6{margin-top:0;}"]}),fEt=pd("rsji9ng","r15xih98",{r:[".rsji9ng{box-sizing:border-box;cursor:pointer;height:100%;margin:0;opacity:0;position:absolute;width:calc(40px + 2 * var(--spacingHorizontalS));}",".rsji9ng:checked~.fui-Switch__indicator>*{transform:translateX(20px);}",".rsji9ng:disabled{cursor:default;}",".rsji9ng:disabled~.fui-Switch__indicator{color:var(--colorNeutralForegroundDisabled);}",".rsji9ng:disabled~.fui-Switch__label{cursor:default;color:var(--colorNeutralForegroundDisabled);}",".rsji9ng:enabled:not(:checked)~.fui-Switch__indicator{color:var(--colorNeutralStrokeAccessible);border-color:var(--colorNeutralStrokeAccessible);}",".rsji9ng:enabled:not(:checked)~.fui-Switch__label{color:var(--colorNeutralForeground1);}",".rsji9ng:enabled:not(:checked):hover~.fui-Switch__indicator{color:var(--colorNeutralStrokeAccessibleHover);border-color:var(--colorNeutralStrokeAccessibleHover);}",".rsji9ng:enabled:not(:checked):hover:active~.fui-Switch__indicator{color:var(--colorNeutralStrokeAccessiblePressed);border-color:var(--colorNeutralStrokeAccessiblePressed);}",".rsji9ng:enabled:checked~.fui-Switch__indicator{background-color:var(--colorCompoundBrandBackground);color:var(--colorNeutralForegroundInverted);border-color:var(--colorTransparentStroke);}",".rsji9ng:enabled:checked:hover~.fui-Switch__indicator{background-color:var(--colorCompoundBrandBackgroundHover);border-color:var(--colorTransparentStrokeInteractive);}",".rsji9ng:enabled:checked:hover:active~.fui-Switch__indicator{background-color:var(--colorCompoundBrandBackgroundPressed);border-color:var(--colorTransparentStrokeInteractive);}",".rsji9ng:disabled:not(:checked)~.fui-Switch__indicator{border-color:var(--colorNeutralStrokeDisabled);}",".rsji9ng:disabled:checked~.fui-Switch__indicator{background-color:var(--colorNeutralBackgroundDisabled);border-color:var(--colorTransparentStrokeDisabled);}",".r15xih98{box-sizing:border-box;cursor:pointer;height:100%;margin:0;opacity:0;position:absolute;width:calc(40px + 2 * var(--spacingHorizontalS));}",".r15xih98:checked~.fui-Switch__indicator>*{transform:translateX(-20px);}",".r15xih98:disabled{cursor:default;}",".r15xih98:disabled~.fui-Switch__indicator{color:var(--colorNeutralForegroundDisabled);}",".r15xih98:disabled~.fui-Switch__label{cursor:default;color:var(--colorNeutralForegroundDisabled);}",".r15xih98:enabled:not(:checked)~.fui-Switch__indicator{color:var(--colorNeutralStrokeAccessible);border-color:var(--colorNeutralStrokeAccessible);}",".r15xih98:enabled:not(:checked)~.fui-Switch__label{color:var(--colorNeutralForeground1);}",".r15xih98:enabled:not(:checked):hover~.fui-Switch__indicator{color:var(--colorNeutralStrokeAccessibleHover);border-color:var(--colorNeutralStrokeAccessibleHover);}",".r15xih98:enabled:not(:checked):hover:active~.fui-Switch__indicator{color:var(--colorNeutralStrokeAccessiblePressed);border-color:var(--colorNeutralStrokeAccessiblePressed);}",".r15xih98:enabled:checked~.fui-Switch__indicator{background-color:var(--colorCompoundBrandBackground);color:var(--colorNeutralForegroundInverted);border-color:var(--colorTransparentStroke);}",".r15xih98:enabled:checked:hover~.fui-Switch__indicator{background-color:var(--colorCompoundBrandBackgroundHover);border-color:var(--colorTransparentStrokeInteractive);}",".r15xih98:enabled:checked:hover:active~.fui-Switch__indicator{background-color:var(--colorCompoundBrandBackgroundPressed);border-color:var(--colorTransparentStrokeInteractive);}",".r15xih98:disabled:not(:checked)~.fui-Switch__indicator{border-color:var(--colorNeutralStrokeDisabled);}",".r15xih98:disabled:checked~.fui-Switch__indicator{background-color:var(--colorNeutralBackgroundDisabled);border-color:var(--colorTransparentStrokeDisabled);}"],s:["@media (forced-colors: active){.rsji9ng:disabled~.fui-Switch__indicator{color:GrayText;border-color:GrayText;}.rsji9ng:disabled~.fui-Switch__label{color:GrayText;}.rsji9ng:hover{color:CanvasText;}.rsji9ng:hover:active{color:CanvasText;}.rsji9ng:enabled:checked:hover~.fui-Switch__indicator{background-color:Highlight;color:Canvas;}.rsji9ng:enabled:checked:hover:active~.fui-Switch__indicator{background-color:Highlight;color:Canvas;}.rsji9ng:enabled:checked~.fui-Switch__indicator{background-color:Highlight;color:Canvas;}}","@media (forced-colors: active){.r15xih98:disabled~.fui-Switch__indicator{color:GrayText;border-color:GrayText;}.r15xih98:disabled~.fui-Switch__label{color:GrayText;}.r15xih98:hover{color:CanvasText;}.r15xih98:hover:active{color:CanvasText;}.r15xih98:enabled:checked:hover~.fui-Switch__indicator{background-color:Highlight;color:Canvas;}.r15xih98:enabled:checked:hover:active~.fui-Switch__indicator{background-color:Highlight;color:Canvas;}.r15xih98:enabled:checked~.fui-Switch__indicator{background-color:Highlight;color:Canvas;}}"]}),vEt=uo({before:{j35jbq:["f1e31b4d","f1vgc2s3"],Bhzewxz:"f15twtuk"},after:{oyh7mz:["f1vgc2s3","f1e31b4d"],Bhzewxz:"f15twtuk"},above:{B5kzvoi:"f1yab3r1",Bqenvij:"f1aar7gd",a9b677:"fly5x3f"}},{d:[".f1e31b4d{right:0;}",".f1vgc2s3{left:0;}",".f15twtuk{top:0;}",".f1yab3r1{bottom:0;}",".f1aar7gd{height:calc(20px + var(--spacingVerticalS));}",".fly5x3f{width:100%;}"]}),yEt=uo({base:{Bceei9c:"f1k6fduh",jrapky:"f49ad5g",B6of3ja:"f1xlvstr",Byoj8tv:0,uwmqm3:0,z189sj:0,z8tnut:0,B0ocmuz:"f1f5q0n8"},above:{z8tnut:"f1ywm7hm",Byoj8tv:"f14wxoun",a9b677:"fly5x3f"},after:{uwmqm3:["fruq291","f7x41pl"]},before:{z189sj:["f7x41pl","fruq291"]}},{d:[".f1k6fduh{cursor:pointer;}",".f49ad5g{margin-bottom:calc((20px - var(--lineHeightBase300)) / 2);}",".f1xlvstr{margin-top:calc((20px - var(--lineHeightBase300)) / 2);}",[".f1f5q0n8{padding:var(--spacingVerticalS) var(--spacingHorizontalS);}",{p:-1}],".f1ywm7hm{padding-top:var(--spacingVerticalXS);}",".f14wxoun{padding-bottom:var(--spacingVerticalXS);}",".fly5x3f{width:100%;}",".fruq291{padding-left:var(--spacingHorizontalXS);}",".f7x41pl{padding-right:var(--spacingHorizontalXS);}"]}),SEt=t=>{"use no memo";const e=hEt(),i=pEt(),r=gEt(),o=mEt(),l=fEt(),d=vEt(),h=yEt(),{label:p,labelPosition:g}=t;return t.root.className=ea(EK.root,e,g==="above"&&i.vertical,t.root.className),t.indicator.className=ea(EK.indicator,r,p&&g==="above"&&o.labelAbove,t.indicator.className),t.input.className=ea(EK.input,l,p&&d[g],t.input.className),t.label&&(t.label.className=ea(EK.label,h.base,h[g],t.label.className)),t},yMe=$.forwardRef((t,e)=>{const i=dEt(t,e);return SEt(i),kh("useSwitchStyles_unstable")(i),uEt(i)});yMe.displayName="Switch";const bEt={appearance:"transparent",reserveSelectedTabSpace:!0,selectTabOnFocus:!1,disabled:!1,selectedValue:void 0,onRegister:()=>{},onUnregister:()=>{},onSelect:()=>{},getRegisteredTabs:()=>({registeredTabs:{}}),size:"medium",vertical:!1},SMe=BH(void 0),TEt=SMe.Provider,EA=t=>sK(SMe,(e=bEt)=>t(e)),CEt=(t,e)=>{const{content:i,disabled:r=!1,icon:o,onClick:l,onFocus:d,value:h}=t,p=EA(ne=>ne.appearance),g=EA(ne=>ne.reserveSelectedTabSpace),f=EA(ne=>ne.selectTabOnFocus),y=EA(ne=>ne.disabled),T=EA(ne=>ne.selectedValue===h),C=EA(ne=>ne.onRegister),E=EA(ne=>ne.onUnregister),I=EA(ne=>ne.onSelect),w=EA(ne=>ne.size),D=EA(ne=>!!ne.vertical),F=y||r,x=$.useRef(null),B=ne=>I(ne,{value:h}),L=Fl(vA(l,B)),z=Fl(vA(d,B)),H=gse({focusable:{isDefault:T}});$.useEffect(()=>(C({value:h,ref:x}),()=>{E({value:h,ref:x})}),[C,E,x,h]);const j=Ss(o,{elementType:"span"}),J=Bl(i,{defaultProps:{children:t.children},elementType:"span"}),Z=i&&typeof i=="object"?wmt(i,["ref"]):i,re=!!(j?.children&&!J.children);return{components:{root:"button",icon:"span",content:"span",contentReservedSpace:"span"},root:Bl(_p("button",{ref:kC(e,x),role:"tab",type:"button","aria-selected":F?void 0:`${T}`,...H,...t,disabled:F,onClick:L,onFocus:f?z:d}),{elementType:"button"}),icon:j,iconOnly:re,content:J,contentReservedSpace:Ss(Z,{renderByDefault:!T&&!re&&g,defaultProps:{children:t.children},elementType:"span"}),appearance:p,disabled:F,selected:T,size:w,value:h,vertical:D}},_Et=t=>(Pd(t),Uf(t.root,{children:[t.icon&&yr(t.icon,{}),!t.iconOnly&&yr(t.content,{}),t.contentReservedSpace&&yr(t.contentReservedSpace,{})]})),bMe={offsetVar:"--fui-Tab__indicator--offset",scaleVar:"--fui-Tab__indicator--scale"},EEt=uo({base:{B68tc82:0,Bmxbyg5:0,Bpg54ce:"f1gl81tg"},animated:{Ba2ppi3:"fhwpy7i",F2fol1:"f6zz20j",B1dyfl9:"f1ai4sc1",B0vmy72:"f9qxlq5",u9bimw:"f1aql376"},horizontal:{sjv3b2:["fug4aj8","f1i5xzg7"],b1kco5:"f1q7ujh"},vertical:{sjv3b2:"f1hqboyk",b1kco5:"f1dxupa6"}},{d:[[".f1gl81tg{overflow:visible;}",{p:-1}],".fhwpy7i::after{transition-property:transform;}",".f6zz20j::after{transition-duration:var(--durationSlow);}",".f1ai4sc1::after{transition-timing-function:var(--curveDecelerateMax);}",".fug4aj8::after{transform-origin:left;}",".f1i5xzg7::after{transform-origin:right;}",".f1q7ujh::after{transform:translateX(var(--fui-Tab__indicator--offset)) scaleX(var(--fui-Tab__indicator--scale));}",".f1hqboyk::after{transform-origin:top;}",".f1dxupa6::after{transform:translateY(var(--fui-Tab__indicator--offset)) scaleY(var(--fui-Tab__indicator--scale));}"],m:[["@media (prefers-reduced-motion: reduce){.f9qxlq5::after{transition-property:none;}}",{m:"(prefers-reduced-motion: reduce)"}],["@media (prefers-reduced-motion: reduce){.f1aql376::after{transition-duration:0.01ms;}}",{m:"(prefers-reduced-motion: reduce)"}]]}),AEt=t=>{if(t){var e;const i=((e=t.parentElement)===null||e===void 0?void 0:e.getBoundingClientRect())||{x:0,y:0},r=t.getBoundingClientRect();return{x:r.x-i.x,y:r.y-i.y,width:r.width,height:r.height}}},TMe=(t,e)=>{var i;const r=ale(e)?(i=t[JSON.stringify(e)])===null||i===void 0?void 0:i.ref.current:void 0;return r?AEt(r):void 0},ale=t=>t!=null,IEt=t=>{const{disabled:e,selected:i,vertical:r}=t,o=EEt(),[l,d]=$.useState(),[h,p]=$.useState({offset:0,scale:1}),g=EA(C=>C.getRegisteredTabs),[f]=$mt();if(i){const{previousSelectedValue:C,selectedValue:E,registeredTabs:I}=g();if(ale(C)&&l!==C){const w=TMe(I,C),D=TMe(I,E);if(D&&w){const F=r?w.y-D.y:w.x-D.x,x=r?w.height/D.height:w.width/D.width;p({offset:F,scale:x}),d(C),f(()=>p({offset:0,scale:1}))}}}else ale(l)&&d(void 0);if(e)return t;const y=h.offset===0&&h.scale===1;t.root.className=ea(t.root.className,i&&o.base,i&&y&&o.animated,i&&(r?o.vertical:o.horizontal));const T={[bMe.offsetVar]:`${h.offset}px`,[bMe.scaleVar]:`${h.scale}`};return t.root.style={...T,...t.root.style},t},rle={root:"fui-Tab",icon:"fui-Tab__icon",content:"fui-Tab__content"},wEt={content:"fui-Tab__content--reserved-space"},CMe=uo({root:{Bt984gj:"f122n59",mc9l5x:"f13qh94s",Bnnss6s:"fi64zpg",Bxotwcr:"f1u07yai",Budl1dq:"frn2hmy",wkccdc:"f1olsevy",oeaueh:"f1s6fcnf",qhf8xq:"f10pi13n"},button:{Bt984gj:"f122n59",Bgfg5da:0,B9xav0g:0,oivjwe:0,Bn0qgzm:0,B4g9neb:0,zhjwy3:0,wvpqe5:0,ibv6hh:0,u1mtju:0,h3c5rm:0,vrafjx:0,Bekrc4i:0,i8vvqc:0,g2u3we:0,icvyot:0,B4j52fo:0,irswps:"f3bhgqh",Beyfa6y:0,Bbmb7ep:0,Btl43ni:0,B7oj6ja:0,Dimara:"ft85np5",Bceei9c:"f1k6fduh",mc9l5x:"f13qh94s",Bnnss6s:"fi64zpg",Bxotwcr:"f1u07yai",Budl1dq:"frn2hmy",wkccdc:"f1olsevy",Bahqtrf:"fk6fouc",Bg96gwp:"f1i3iumi",oeaueh:"f1s6fcnf",qhf8xq:"f10pi13n",B68tc82:0,Bmxbyg5:0,Bpg54ce:"f1a3p1vp",B9bfxx9:"f1cxpek8"},horizontal:{Brf1p80:"f4d9j23"},vertical:{Brf1p80:"f1s9ku6b"},smallHorizontal:{i8kkvl:"f14mj54c",Byoj8tv:0,uwmqm3:0,z189sj:0,z8tnut:0,B0ocmuz:"f1wmopi4"},smallVertical:{i8kkvl:"f14mj54c",Byoj8tv:0,uwmqm3:0,z189sj:0,z8tnut:0,B0ocmuz:"f12or63q"},mediumHorizontal:{i8kkvl:"f1rjii52",Byoj8tv:0,uwmqm3:0,z189sj:0,z8tnut:0,B0ocmuz:"f1w08f2p"},mediumVertical:{i8kkvl:"f1rjii52",Byoj8tv:0,uwmqm3:0,z189sj:0,z8tnut:0,B0ocmuz:"fymxs25"},largeHorizontal:{i8kkvl:"f1rjii52",Byoj8tv:0,uwmqm3:0,z189sj:0,z8tnut:0,B0ocmuz:"f1ssfvub"},largeVertical:{i8kkvl:"f1rjii52",Byoj8tv:0,uwmqm3:0,z189sj:0,z8tnut:0,B0ocmuz:"fwkd1rq"},transparent:{De3pzq:"f1c21dwh",B95qlz1:"f9rvdkv",B7xitij:"f1051ucx",Bptxc3x:"fmmjozx",Bwqhzpy:"fqhzt5g",iyk698:"f7l5cgy",cl4aha:"fpkze5g",B0q3jbp:"f1iywnoi",Be9ayug:"f9n45c4"},subtle:{De3pzq:"fhovq9v",B95qlz1:"f1bifk9c",B7xitij:"fo6hitd",Bptxc3x:"fmmjozx",Bwqhzpy:"fqhzt5g",iyk698:"f7l5cgy",cl4aha:"fpkze5g",B0q3jbp:"f1iywnoi",Be9ayug:"f9n45c4"},disabledCursor:{Bceei9c:"fdrzuqr"},disabled:{De3pzq:"f1c21dwh",Bptxc3x:"fato7r6",cl4aha:"fao1bnu"},selected:{Bptxc3x:"f1cadz5z",Bwqhzpy:"fwhdxxj",iyk698:"fintccb",cl4aha:"ffplhdr",B0q3jbp:"fjo17wb",Be9ayug:"f148789c"}},{d:[".f122n59{align-items:center;}",".f13qh94s{display:grid;}",".fi64zpg{flex-shrink:0;}",".f1u07yai{grid-auto-flow:column;}",".frn2hmy{grid-template-columns:auto;}",".f1olsevy{grid-template-rows:auto;}",".f1s6fcnf{outline-style:none;}",".f10pi13n{position:relative;}",[".f3bhgqh{border:none;}",{p:-2}],[".ft85np5{border-radius:var(--borderRadiusMedium);}",{p:-1}],".f1k6fduh{cursor:pointer;}",".fk6fouc{font-family:var(--fontFamilyBase);}",".f1i3iumi{line-height:var(--lineHeightBase300);}",[".f1a3p1vp{overflow:hidden;}",{p:-1}],".f1cxpek8{text-transform:none;}",".f4d9j23{justify-content:center;}",".f1s9ku6b{justify-content:start;}",".f14mj54c{column-gap:var(--spacingHorizontalXXS);}",[".f1wmopi4{padding:var(--spacingVerticalSNudge) var(--spacingHorizontalSNudge);}",{p:-1}],[".f12or63q{padding:var(--spacingVerticalXXS) var(--spacingHorizontalSNudge);}",{p:-1}],".f1rjii52{column-gap:var(--spacingHorizontalSNudge);}",[".f1w08f2p{padding:var(--spacingVerticalM) var(--spacingHorizontalMNudge);}",{p:-1}],[".fymxs25{padding:var(--spacingVerticalSNudge) var(--spacingHorizontalMNudge);}",{p:-1}],[".f1ssfvub{padding:var(--spacingVerticalL) var(--spacingHorizontalMNudge);}",{p:-1}],[".fwkd1rq{padding:var(--spacingVerticalS) var(--spacingHorizontalMNudge);}",{p:-1}],".f1c21dwh{background-color:var(--colorTransparentBackground);}",".f9rvdkv:enabled:hover{background-color:var(--colorTransparentBackgroundHover);}",".f1051ucx:enabled:active{background-color:var(--colorTransparentBackgroundPressed);}",".fmmjozx .fui-Tab__icon{color:var(--colorNeutralForeground2);}",".fqhzt5g:enabled:hover .fui-Tab__icon{color:var(--colorNeutralForeground2Hover);}",".f7l5cgy:enabled:active .fui-Tab__icon{color:var(--colorNeutralForeground2Pressed);}",".fpkze5g .fui-Tab__content{color:var(--colorNeutralForeground2);}",".f1iywnoi:enabled:hover .fui-Tab__content{color:var(--colorNeutralForeground2Hover);}",".f9n45c4:enabled:active .fui-Tab__content{color:var(--colorNeutralForeground2Pressed);}",".fhovq9v{background-color:var(--colorSubtleBackground);}",".f1bifk9c:enabled:hover{background-color:var(--colorSubtleBackgroundHover);}",".fo6hitd:enabled:active{background-color:var(--colorSubtleBackgroundPressed);}",".fdrzuqr{cursor:not-allowed;}",".fato7r6 .fui-Tab__icon{color:var(--colorNeutralForegroundDisabled);}",".fao1bnu .fui-Tab__content{color:var(--colorNeutralForegroundDisabled);}",".f1cadz5z .fui-Tab__icon{color:var(--colorCompoundBrandForeground1);}",".fwhdxxj:enabled:hover .fui-Tab__icon{color:var(--colorCompoundBrandForeground1Hover);}",".fintccb:enabled:active .fui-Tab__icon{color:var(--colorCompoundBrandForeground1Pressed);}",".ffplhdr .fui-Tab__content{color:var(--colorNeutralForeground1);}",".fjo17wb:enabled:hover .fui-Tab__content{color:var(--colorNeutralForeground1Hover);}",".f148789c:enabled:active .fui-Tab__content{color:var(--colorNeutralForeground1Pressed);}"]}),kEt=uo({base:{Beyfa6y:0,Bbmb7ep:0,Btl43ni:0,B7oj6ja:0,Dimara:"f44lkw9",Bptxc3x:"ftorr8m",cl4aha:"f16lqpmv"},medium:{Dbcxam:0,rjzwhg:0,Bblux5w:"f1lj1ynd"},subtle:{De3pzq:"fhovq9v",Bgfg5da:0,B9xav0g:0,oivjwe:0,Bn0qgzm:0,B4g9neb:0,zhjwy3:0,wvpqe5:0,ibv6hh:0,u1mtju:0,h3c5rm:0,vrafjx:0,Bekrc4i:0,i8vvqc:0,g2u3we:0,icvyot:0,B4j52fo:0,irswps:"fqeaewv",sj55zd:"fkfq4zb",B95qlz1:"f1bifk9c",Eo63ln:0,r9osk6:0,Itrz8y:0,zeg6vx:0,l65xgk:0,Bw4olcx:0,Folb0i:0,I2h8y4:0,Bgxgoyi:0,Bvlkotb:0,Fwyncl:0,Byh5edv:0,Becqvjq:0,uumbiq:0,B73q3dg:0,Bblwbaf:0,B0ezav:"ft57sj0",r4wkhp:"f1fcoy83",B7xitij:"fo6hitd",d3wsvi:0,Hdqn7s:0,zu5y1p:0,owqphb:0,g9c53k:0,Btmu08z:0,Bthxvy6:0,gluvuq:0,tb88gp:0,wns6jk:0,kdfdk4:0,Bbw008l:0,Bayi1ib:0,B1kkfu3:0,J1oqyp:0,kem6az:0,goa3yj:"fhn220o",p743kt:"f15qf7sh"},subtleSelected:{De3pzq:"f16xkysk",Bgfg5da:0,B9xav0g:0,oivjwe:0,Bn0qgzm:0,B4g9neb:0,zhjwy3:0,wvpqe5:0,ibv6hh:0,u1mtju:0,h3c5rm:0,vrafjx:0,Bekrc4i:0,i8vvqc:0,g2u3we:0,icvyot:0,B4j52fo:0,irswps:"f1c2pc3t",sj55zd:"faj9fo0",B95qlz1:"fsm7zmf",Eo63ln:0,r9osk6:0,Itrz8y:0,zeg6vx:0,l65xgk:0,Bw4olcx:0,Folb0i:0,I2h8y4:0,Bgxgoyi:0,Bvlkotb:0,Fwyncl:0,Byh5edv:0,Becqvjq:0,uumbiq:0,B73q3dg:0,Bblwbaf:0,B0ezav:"f1wo0sfq",r4wkhp:"f1afuynh",B7xitij:"f94ddyl",d3wsvi:0,Hdqn7s:0,zu5y1p:0,owqphb:0,g9c53k:0,Btmu08z:0,Bthxvy6:0,gluvuq:0,tb88gp:0,wns6jk:0,kdfdk4:0,Bbw008l:0,Bayi1ib:0,B1kkfu3:0,J1oqyp:0,kem6az:0,goa3yj:"fmle6oo",p743kt:"f1d3itm4"},subtleDisabled:{De3pzq:"fhovq9v",sj55zd:"f1s2aq7o",Bgfg5da:0,B9xav0g:0,oivjwe:0,Bn0qgzm:0,B4g9neb:0,zhjwy3:0,wvpqe5:0,ibv6hh:0,u1mtju:0,h3c5rm:0,vrafjx:0,Bekrc4i:0,i8vvqc:0,g2u3we:0,icvyot:0,B4j52fo:0,irswps:"fqeaewv"},subtleDisabledSelected:{De3pzq:"f1bg9a2p",Bgfg5da:0,B9xav0g:0,oivjwe:0,Bn0qgzm:0,B4g9neb:0,zhjwy3:0,wvpqe5:0,ibv6hh:0,u1mtju:0,h3c5rm:0,vrafjx:0,Bekrc4i:0,i8vvqc:0,g2u3we:0,icvyot:0,B4j52fo:0,irswps:"fegtqic",sj55zd:"f1s2aq7o"},filled:{De3pzq:"f16xq7d1",sj55zd:"fkfq4zb",B95qlz1:"fwwxidx",r4wkhp:"f1fcoy83",B7xitij:"f14i52sd",p743kt:"f15qf7sh",Bw5j0gk:"f159yq2d",Baikq8m:"ful0ncq",B2ndh17:"f2rulcp",w0x64w:"f19p5z4e",Bdzpij4:"fo1bcu3"},filledSelected:{De3pzq:"ffp7eso",sj55zd:"f1phragk",B95qlz1:"f1lm9dni",r4wkhp:"f1mn5ei1",B7xitij:"f1g6ncd0",p743kt:"fl71aob",bml8oc:"f13s88zn",qew46a:"f16zjd40",B84x17g:"f1mr3uue",Jetwu1:"f196ywdt"},filledDisabled:{De3pzq:"f1bg9a2p",Bgfg5da:0,B9xav0g:0,oivjwe:0,Bn0qgzm:0,B4g9neb:0,zhjwy3:0,wvpqe5:0,ibv6hh:0,u1mtju:0,h3c5rm:0,vrafjx:0,Bekrc4i:0,i8vvqc:0,g2u3we:0,icvyot:0,B4j52fo:0,irswps:"fqeaewv",sj55zd:"f1s2aq7o"},filledDisabledSelected:{De3pzq:"f1bg9a2p",Bgfg5da:0,B9xav0g:0,oivjwe:0,Bn0qgzm:0,B4g9neb:0,zhjwy3:0,wvpqe5:0,ibv6hh:0,u1mtju:0,h3c5rm:0,vrafjx:0,Bekrc4i:0,i8vvqc:0,g2u3we:0,icvyot:0,B4j52fo:0,irswps:"fegtqic",sj55zd:"f1s2aq7o"}},{d:[[".f44lkw9{border-radius:var(--borderRadiusCircular);}",{p:-1}],".ftorr8m .fui-Tab__icon{color:inherit;}",".f16lqpmv .fui-Tab__content{color:inherit;}",[".f1lj1ynd{padding-block:var(--spacingVerticalSNudge);}",{p:-1}],".fhovq9v{background-color:var(--colorSubtleBackground);}",[".fqeaewv{border:solid var(--strokeWidthThin) transparent;}",{p:-2}],".fkfq4zb{color:var(--colorNeutralForeground2);}",".f1bifk9c:enabled:hover{background-color:var(--colorSubtleBackgroundHover);}",[".ft57sj0:enabled:hover{border:solid var(--strokeWidthThin) var(--colorNeutralStroke1Hover);}",{p:-2}],".f1fcoy83:enabled:hover{color:var(--colorNeutralForeground2Hover);}",".fo6hitd:enabled:active{background-color:var(--colorSubtleBackgroundPressed);}",[".fhn220o:enabled:active{border:solid var(--strokeWidthThin) var(--colorNeutralStroke1Pressed);}",{p:-2}],".f15qf7sh:enabled:active{color:var(--colorNeutralForeground2Pressed);}",".f16xkysk{background-color:var(--colorBrandBackground2);}",[".f1c2pc3t{border:solid var(--strokeWidthThin) var(--colorCompoundBrandStroke);}",{p:-2}],".faj9fo0{color:var(--colorBrandForeground2);}",".fsm7zmf:enabled:hover{background-color:var(--colorBrandBackground2Hover);}",[".f1wo0sfq:enabled:hover{border:solid var(--strokeWidthThin) var(--colorCompoundBrandStrokeHover);}",{p:-2}],".f1afuynh:enabled:hover{color:var(--colorBrandForeground2Hover);}",".f94ddyl:enabled:active{background-color:var(--colorBrandBackground2Pressed);}",[".fmle6oo:enabled:active{border:solid var(--strokeWidthThin) var(--colorCompoundBrandStrokePressed);}",{p:-2}],".f1d3itm4:enabled:active{color:var(--colorBrandForeground2Pressed);}",".f1s2aq7o{color:var(--colorNeutralForegroundDisabled);}",[".fqeaewv{border:solid var(--strokeWidthThin) transparent;}",{p:-2}],".f1bg9a2p{background-color:var(--colorNeutralBackgroundDisabled);}",[".fegtqic{border:solid var(--strokeWidthThin) var(--colorNeutralStrokeDisabled);}",{p:-2}],".f16xq7d1{background-color:var(--colorNeutralBackground3);}",".fwwxidx:enabled:hover{background-color:var(--colorNeutralBackground3Hover);}",".f14i52sd:enabled:active{background-color:var(--colorNeutralBackground3Pressed);}",".ffp7eso{background-color:var(--colorBrandBackground);}",".f1phragk{color:var(--colorNeutralForegroundOnBrand);}",".f1lm9dni:enabled:hover{background-color:var(--colorBrandBackgroundHover);}",".f1mn5ei1:enabled:hover{color:var(--colorNeutralForegroundOnBrand);}",".f1g6ncd0:enabled:active{background-color:var(--colorBrandBackgroundPressed);}",".fl71aob:enabled:active{color:var(--colorNeutralForegroundOnBrand);}",[".fqeaewv{border:solid var(--strokeWidthThin) transparent;}",{p:-2}],[".fegtqic{border:solid var(--strokeWidthThin) var(--colorNeutralStrokeDisabled);}",{p:-2}]],m:[["@media (forced-colors: active){.f159yq2d:enabled:hover{background-color:Highlight;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.ful0ncq:enabled:hover{forced-color-adjust:none;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f2rulcp:enabled:hover .fui-Tab__content{color:HighlightText;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f19p5z4e:enabled:hover .fui-Icon-filled{color:HighlightText;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.fo1bcu3:enabled:hover .fui-Icon-regular{color:HighlightText;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f13s88zn:enabled{background-color:ButtonText;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f16zjd40:enabled .fui-Tab__content{color:ButtonFace;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f1mr3uue:enabled .fui-Tab__content{forced-color-adjust:none;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f196ywdt:enabled .fui-Tab__icon{color:ButtonFace;}}",{m:"(forced-colors: active)"}]]}),REt=uo({base:{B8q5s1w:"f8hki3x",Bci5o5g:["f1d2448m","ffh67wi"],n8qw10:"f1bjia2o",Bdrgwmp:["ffh67wi","f1d2448m"],Bn4voq9:"f1p7hgxw",Bfpq7zp:"f1way5bb",g9k6zt:"f9znhxp",j6ew2k:["fqa318h","fqa318h"],Bhxq17a:"f1vjpng2"},circular:{B8q5s1w:"f8hki3x",Bci5o5g:["f1d2448m","ffh67wi"],n8qw10:"f1bjia2o",Bdrgwmp:["ffh67wi","f1d2448m"],Bn4voq9:"f1p7hgxw",Bfpq7zp:"f1way5bb",g9k6zt:"f9znhxp",j6ew2k:["fzgyhws","fqxug60"],Bhxq17a:"f1vjpng2"}},{d:[".f8hki3x[data-fui-focus-visible]{border-top-color:transparent;}",".f1d2448m[data-fui-focus-visible]{border-right-color:transparent;}",".ffh67wi[data-fui-focus-visible]{border-left-color:transparent;}",".f1bjia2o[data-fui-focus-visible]{border-bottom-color:transparent;}",".f1p7hgxw[data-fui-focus-visible]{outline-width:var(--strokeWidthThick);}",".f1way5bb[data-fui-focus-visible]{outline-color:transparent;}",".f9znhxp[data-fui-focus-visible]{outline-style:solid;}",".fqa318h[data-fui-focus-visible]{box-shadow:var(--shadow4),0 0 0 var(--strokeWidthThick) var(--colorStrokeFocus2);}",".f1vjpng2[data-fui-focus-visible]{z-index:1;}",".fzgyhws[data-fui-focus-visible]{box-shadow:var(--shadow4),0 0 0 var(--strokeWidthThick) var(--colorStrokeFocus2),0 0 0 var(--strokeWidthThin) var(--colorNeutralStrokeOnBrand) inset;}",".fqxug60[data-fui-focus-visible]{box-shadow:var(--shadow4),0 0 0 var(--strokeWidthThick) var(--colorStrokeFocus2),0 0 0 var(--strokeWidthThin) var(--colorNeutralStrokeOnBrand) inset;}"]}),MEt=uo({base:{az7l2e:"fhw179n",vqofr:0,Bv4n3vi:0,Bgqb9hq:0,B0uxbk8:0,Bf3jju6:"fg9j5n4",amg5m6:"f1kmhr4c",zkfqfm:"fl1ydde",Bkydozb:"f1y7maxz",Bka2azo:0,vzq8l0:0,csmgbd:0,Br4ovkg:0,aelrif:"fceyvr4",y36c18:"f16cxu0",B1ctymy:"f1nwgacf",Bgvrrv0:"f15ovonk",ddr6p5:"fvje46l"},disabled:{az7l2e:"f1ut20fw",Bkydozb:"fhrzcfn",Bgvrrv0:"f1v15rkt",ddr6p5:"f3nwrnk"},smallHorizontal:{lawp4y:"fchca7p",Baz25je:"f1r53b5e",Fbdkly:["f1s6rxz5","fo35v8s"],mdwyqc:["fo35v8s","f1s6rxz5"]},smallVertical:{lawp4y:"fze4zud",Fbdkly:["f1fzr1x6","f1f351id"],Bciustq:"fdp32p8",Ccq8qp:"f1aij3q"},mediumHorizontal:{lawp4y:"fchca7p",Baz25je:"f1s2r9ax",Fbdkly:["f1o0nnkk","fxb7rol"],mdwyqc:["fxb7rol","f1o0nnkk"]},mediumVertical:{lawp4y:"f17jracn",Fbdkly:["f1fzr1x6","f1f351id"],Bciustq:"f117lcb2",Ccq8qp:"f1aij3q"},largeHorizontal:{lawp4y:"fchca7p",Baz25je:"f1s2r9ax",Fbdkly:["f1o0nnkk","fxb7rol"],mdwyqc:["fxb7rol","f1o0nnkk"]},largeVertical:{lawp4y:"fel9d3z",Fbdkly:["f1fzr1x6","f1f351id"],Bciustq:"f6vqlre",Ccq8qp:"f1aij3q"}},{h:[".fhw179n:hover::before{background-color:var(--colorNeutralStroke1Hover);}",[".fg9j5n4:hover::before{border-radius:var(--borderRadiusCircular);}",{p:-1}],'.f1kmhr4c:hover::before{content:"";}',".fl1ydde:hover::before{position:absolute;}",".f1ut20fw:hover::before{background-color:var(--colorTransparentStroke);}"],a:[".f1y7maxz:active::before{background-color:var(--colorNeutralStroke1Pressed);}",[".fceyvr4:active::before{border-radius:var(--borderRadiusCircular);}",{p:-1}],'.f16cxu0:active::before{content:"";}',".f1nwgacf:active::before{position:absolute;}",".fhrzcfn:active::before{background-color:var(--colorTransparentStroke);}"],m:[["@media (forced-colors: active){.f15ovonk:hover::before{background-color:Highlight;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.fvje46l:active::before{background-color:Highlight;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f1v15rkt:hover::before{background-color:transparent;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f3nwrnk:active::before{background-color:transparent;}}",{m:"(forced-colors: active)"}]],d:[".fchca7p::before{bottom:0;}",".f1r53b5e::before{height:var(--strokeWidthThick);}",".f1s6rxz5::before{left:var(--spacingHorizontalSNudge);}",".fo35v8s::before{right:var(--spacingHorizontalSNudge);}",".fze4zud::before{bottom:var(--spacingVerticalXS);}",".f1fzr1x6::before{left:0;}",".f1f351id::before{right:0;}",".fdp32p8::before{top:var(--spacingVerticalXS);}",".f1aij3q::before{width:var(--strokeWidthThicker);}",".f1s2r9ax::before{height:var(--strokeWidthThicker);}",".f1o0nnkk::before{left:var(--spacingHorizontalM);}",".fxb7rol::before{right:var(--spacingHorizontalM);}",".f17jracn::before{bottom:var(--spacingVerticalS);}",".f117lcb2::before{top:var(--spacingVerticalS);}",".fel9d3z::before{bottom:var(--spacingVerticalMNudge);}",".f6vqlre::before{top:var(--spacingVerticalMNudge);}"]}),PEt=uo({base:{Bjyk6c5:"f1rp0jgh",d9w3h3:0,B3778ie:0,B4j8arr:0,Bl18szs:0,Blrzh8d:"f3b9emi",Bsft5z2:"f13zj6fq",E3zdtr:"f1mdlcz9"},selected:{Bjyk6c5:"f1ksivud",Bej4dhw:"f1476jrx",B7wqxwa:"f18q216b",f7digc:"fy7ktjt",Bvuzv5k:"f1033yux",k4sdgo:"fkh9b8o"},disabled:{Bjyk6c5:"f13lkzet"},smallHorizontal:{By385i5:"fo72kxq",Dlnsje:"f9bb2ob",Eqx8gd:["f1q70ajw","f18rbzdx"],B1piin3:["f18rbzdx","f1q70ajw"]},smallVertical:{By385i5:"fqbue9b",Eqx8gd:["f1n6gb5g","f15yvnhg"],bn5sak:"fk1klkt",a2br6o:"f1o25lip"},mediumHorizontal:{By385i5:"fo72kxq",Dlnsje:"f1vx7lu8",Eqx8gd:["fna7m5n","f1oxpfwv"],B1piin3:["f1oxpfwv","fna7m5n"]},mediumVertical:{By385i5:"fipylg0",Eqx8gd:["f1n6gb5g","f15yvnhg"],bn5sak:"fqchiol",a2br6o:"f1o25lip"},largeHorizontal:{By385i5:"fo72kxq",Dlnsje:"f1vx7lu8",Eqx8gd:["fna7m5n","f1oxpfwv"],B1piin3:["f1oxpfwv","fna7m5n"]},largeVertical:{By385i5:"f1w7dm5g",Eqx8gd:["f1n6gb5g","f15yvnhg"],bn5sak:"f1p6em4m",a2br6o:"f1o25lip"}},{d:[".f1rp0jgh::after{background-color:var(--colorTransparentStroke);}",[".f3b9emi::after{border-radius:var(--borderRadiusCircular);}",{p:-1}],'.f13zj6fq::after{content:"";}',".f1mdlcz9::after{position:absolute;}",".f1ksivud::after{background-color:var(--colorCompoundBrandStroke);}",".f1476jrx:enabled:hover::after{background-color:var(--colorCompoundBrandStrokeHover);}",".f18q216b:enabled:active::after{background-color:var(--colorCompoundBrandStrokePressed);}",".f13lkzet::after{background-color:var(--colorNeutralForegroundDisabled);}",".fo72kxq::after{bottom:0;}",".f9bb2ob::after{height:var(--strokeWidthThick);}",".f1q70ajw::after{left:var(--spacingHorizontalSNudge);}",".f18rbzdx::after{right:var(--spacingHorizontalSNudge);}",".fqbue9b::after{bottom:var(--spacingVerticalXS);}",".f1n6gb5g::after{left:0;}",".f15yvnhg::after{right:0;}",".fk1klkt::after{top:var(--spacingVerticalXS);}",".f1o25lip::after{width:var(--strokeWidthThicker);}",".f1vx7lu8::after{height:var(--strokeWidthThicker);}",".fna7m5n::after{left:var(--spacingHorizontalM);}",".f1oxpfwv::after{right:var(--spacingHorizontalM);}",".fipylg0::after{bottom:var(--spacingVerticalS);}",".fqchiol::after{top:var(--spacingVerticalS);}",".f1w7dm5g::after{bottom:var(--spacingVerticalMNudge);}",".f1p6em4m::after{top:var(--spacingVerticalMNudge);}"],m:[["@media (forced-colors: active){.fy7ktjt::after{background-color:ButtonText;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f1033yux:enabled:hover::after{background-color:ButtonText;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.fkh9b8o:enabled:active::after{background-color:ButtonText;}}",{m:"(forced-colors: active)"}]]}),DEt=uo({base:{Br312pm:"fwpfdsa",Ijaq50:"f16hsg94",Bt984gj:"f122n59",mc9l5x:"ftuwxu6",Brf1p80:"f4d9j23",B68tc82:0,Bmxbyg5:0,Bpg54ce:"f1a3p1vp",D0sxk3:"f16u1re",t6yez3:"f8bsbmo"},small:{Be2twd7:"fe5j1ua",Bqenvij:"fjamq6b",a9b677:"f64fuq3"},medium:{Be2twd7:"fe5j1ua",Bqenvij:"fjamq6b",a9b677:"f64fuq3"},large:{Be2twd7:"f1rt2boy",Bqenvij:"frvgh55",a9b677:"fq4mcun"},selected:{D0sxk3:"fxoiby5",t6yez3:"f15q0o9g"}},{d:[".fwpfdsa{grid-column-start:1;}",".f16hsg94{grid-row-start:1;}",".f122n59{align-items:center;}",".ftuwxu6{display:inline-flex;}",".f4d9j23{justify-content:center;}",[".f1a3p1vp{overflow:hidden;}",{p:-1}],".f16u1re .fui-Icon-filled{display:none;}",".f8bsbmo .fui-Icon-regular{display:inline;}",".fe5j1ua{font-size:20px;}",".fjamq6b{height:20px;}",".f64fuq3{width:20px;}",".f1rt2boy{font-size:24px;}",".frvgh55{height:24px;}",".fq4mcun{width:24px;}",".fxoiby5 .fui-Icon-filled{display:inline;}",".f15q0o9g .fui-Icon-regular{display:none;}"]}),LEt=uo({base:{Bahqtrf:"fk6fouc",Be2twd7:"fkhj508",Bhrd7zp:"figsok6",Bg96gwp:"f1i3iumi",B68tc82:0,Bmxbyg5:0,Bpg54ce:"f1a3p1vp",Byoj8tv:0,uwmqm3:0,z189sj:0,z8tnut:0,B0ocmuz:"f1bwptpd"},selected:{Bahqtrf:"fk6fouc",Be2twd7:"fkhj508",Bhrd7zp:"fl43uef",Bg96gwp:"f1i3iumi"},large:{Bahqtrf:"fk6fouc",Be2twd7:"fod5ikn",Bhrd7zp:"figsok6",Bg96gwp:"faaz57k"},largeSelected:{Bahqtrf:"fk6fouc",Be2twd7:"fod5ikn",Bhrd7zp:"fl43uef",Bg96gwp:"faaz57k"},noIconBefore:{Br312pm:"fwpfdsa",Ijaq50:"f16hsg94"},iconBefore:{Br312pm:"fd46tj4",Ijaq50:"f16hsg94"},placeholder:{Bcdw1i0:"fd7fpy0"}},{d:[".fk6fouc{font-family:var(--fontFamilyBase);}",".fkhj508{font-size:var(--fontSizeBase300);}",".figsok6{font-weight:var(--fontWeightRegular);}",".f1i3iumi{line-height:var(--lineHeightBase300);}",[".f1a3p1vp{overflow:hidden;}",{p:-1}],[".f1bwptpd{padding:var(--spacingVerticalNone) var(--spacingHorizontalXXS);}",{p:-1}],".fl43uef{font-weight:var(--fontWeightSemibold);}",".fod5ikn{font-size:var(--fontSizeBase400);}",".faaz57k{line-height:var(--lineHeightBase400);}",".fwpfdsa{grid-column-start:1;}",".f16hsg94{grid-row-start:1;}",".fd46tj4{grid-column-start:2;}",".fd7fpy0{visibility:hidden;}"]}),OEt=t=>{"use no memo";return NEt(t),xEt(t,t.root),BEt(t),t},NEt=t=>{"use no memo";const e=CMe(),i=MEt(),r=PEt(),{appearance:o,disabled:l,selected:d,size:h,vertical:p}=t,g=[rle.root,e.root];return o!=="subtle-circular"&&o!=="filled-circular"&&g.push(i.base,h==="small"&&(p?i.smallVertical:i.smallHorizontal),h==="medium"&&(p?i.mediumVertical:i.mediumHorizontal),h==="large"&&(p?i.largeVertical:i.largeHorizontal),l&&i.disabled,d&&r.base,d&&!l&&r.selected,d&&h==="small"&&(p?r.smallVertical:r.smallHorizontal),d&&h==="medium"&&(p?r.mediumVertical:r.mediumHorizontal),d&&h==="large"&&(p?r.largeVertical:r.largeHorizontal),d&&l&&r.disabled),t.root.className=ea(...g,t.root.className),IEt(t),t},xEt=(t,e)=>{"use no memo";const i=CMe(),r=REt(),o=kEt(),{appearance:l,disabled:d,selected:h,size:p,vertical:g}=t,f=l==="subtle-circular",y=l==="filled-circular",T=f||y,C=[o.base,r.circular,p==="medium"&&o.medium,f&&o.subtle,h&&f&&o.subtleSelected,d&&f&&o.subtleDisabled,h&&d&&f&&o.subtleDisabledSelected,y&&o.filled,h&&y&&o.filledSelected,d&&y&&o.filledDisabled,h&&d&&y&&o.filledDisabledSelected],E=[r.base,!d&&l==="subtle"&&i.subtle,!d&&l==="transparent"&&i.transparent,!d&&h&&i.selected,d&&i.disabled];return e.className=ea(i.button,g?i.vertical:i.horizontal,p==="small"&&(g?i.smallVertical:i.smallHorizontal),p==="medium"&&(g?i.mediumVertical:i.mediumHorizontal),p==="large"&&(g?i.largeVertical:i.largeHorizontal),...T?C:E,d&&i.disabledCursor,e.className),t},BEt=t=>{"use no memo";const e=DEt(),i=LEt(),{selected:r,size:o}=t;return t.icon&&(t.icon.className=ea(rle.icon,e.base,e[o],r&&e.selected,t.icon.className)),t.contentReservedSpace&&(t.contentReservedSpace.className=ea(wEt.content,i.base,o==="large"?i.largeSelected:i.selected,t.icon?i.iconBefore:i.noIconBefore,i.placeholder,t.content.className),t.contentReservedSpaceClassName=t.contentReservedSpace.className),t.content.className=ea(rle.content,i.base,o==="large"&&i.large,r&&(o==="large"?i.largeSelected:i.selected),t.icon?i.iconBefore:i.noIconBefore,t.content.className),t},_Me=$.forwardRef((t,e)=>{const i=CEt(t,e);return OEt(i),kh("useTabStyles_unstable")(i),_Et(i)});_Me.displayName="Tab";const FEt=(t,e)=>{const{appearance:i="transparent",reserveSelectedTabSpace:r=!0,disabled:o=!1,onTabSelect:l,selectTabOnFocus:d=!1,size:h="medium",vertical:p=!1}=t,g=$.useRef(null),f=NH({circular:!0,axis:p?"vertical":"horizontal",memorizeCurrent:!1,unstable_hasDefault:!0}),[y,T]=OL({state:t.selectedValue,defaultState:t.defaultSelectedValue,initialState:void 0}),C=$.useRef(void 0),E=$.useRef(void 0);$.useEffect(()=>{E.current=C.current,C.current=y},[y]);const I=Fl((B,L)=>{T(L.value),l?.(B,L)}),w=$.useRef({}),D=Fl(B=>{const L=JSON.stringify(B.value);!L&&process.env.NODE_ENV!=="production"&&console.error([`[@fluentui/react-tabs] The value "${B.value}" cannot be serialized to JSON string.`,"Tab component requires serializable values.","Please provide a primitive value (string, number, boolean),","or a plain object/array that doesn't contain functions, symbols, or circular references."].join(" ")),w.current[L]=B}),F=Fl(B=>{delete w.current[JSON.stringify(B.value)]}),x=$.useCallback(()=>({selectedValue:C.current,previousSelectedValue:E.current,registeredTabs:w.current}),[]);return{components:{root:"div"},root:Bl(_p("div",{ref:kC(e,g),role:"tablist","aria-orientation":p?"vertical":"horizontal",...f,...t}),{elementType:"div"}),appearance:i,reserveSelectedTabSpace:r,disabled:o,selectTabOnFocus:d,selectedValue:y,size:h,vertical:p,onRegister:D,onUnregister:F,onSelect:I,getRegisteredTabs:x}},UEt=(t,e)=>(Pd(t),yr(t.root,{children:yr(TEt,{value:e.tabList,children:t.root.children})})),zEt={root:"fui-TabList"},VEt=uo({root:{mc9l5x:"f22iagw",Beiy3e4:"f1063pyq",Bnnss6s:"fi64zpg",Eh141a:"flvyvdh",qhf8xq:"f10pi13n"},horizontal:{Bt984gj:"f1q9h2pe",Beiy3e4:"f1063pyq"},vertical:{Bt984gj:"f1q9h2pe",Beiy3e4:"f1vx9l62"},roundedSmall:{i8kkvl:0,Belr9w4:0,rmohyg:"f1eyhf9v"},rounded:{i8kkvl:0,Belr9w4:0,rmohyg:"faqewft"}},{d:[".f22iagw{display:flex;}",".f1063pyq{flex-direction:row;}",".fi64zpg{flex-shrink:0;}",".flvyvdh{flex-wrap:nowrap;}",".f10pi13n{position:relative;}",".f1q9h2pe{align-items:stretch;}",".f1vx9l62{flex-direction:column;}",[".f1eyhf9v{gap:var(--spacingHorizontalSNudge);}",{p:-1}],[".faqewft{gap:var(--spacingHorizontalS);}",{p:-1}]]}),$Et=t=>{"use no memo";const{appearance:e,vertical:i,size:r}=t,o=VEt(),l=e==="subtle-circular"||e==="filled-circular";return t.root.className=ea(zEt.root,o.root,i?o.vertical:o.horizontal,l&&(r==="small"?o.roundedSmall:o.rounded),t.root.className),t};function HEt(t){const{appearance:e,reserveSelectedTabSpace:i,disabled:r,selectTabOnFocus:o,selectedValue:l,onRegister:d,onUnregister:h,onSelect:p,getRegisteredTabs:g,size:f,vertical:y}=t;return{tabList:{appearance:e,reserveSelectedTabSpace:i,disabled:r,selectTabOnFocus:o,selectedValue:l,onSelect:p,onRegister:d,onUnregister:h,getRegisteredTabs:g,size:f,vertical:y}}}const EMe=$.forwardRef((t,e)=>{const i=FEt(t,e),r=HEt(i);return $Et(i),kh("useTabListStyles_unstable")(i),UEt(i,r)});EMe.displayName="TabList";const AMe=(t,e)=>{const{wrap:i,truncate:r,block:o,italic:l,underline:d,strikethrough:h,size:p,font:g,weight:f,align:y}=t;return{align:y??"start",block:o??!1,font:g??"base",italic:l??!1,size:p??300,strikethrough:h??!1,truncate:r??!1,underline:d??!1,weight:f??"regular",wrap:i??!0,components:{root:"span"},root:Bl(_p("span",{ref:e,...t}),{elementType:"span"})}},IMe=t=>(Pd(t),yr(t.root,{})),jEt={root:"fui-Text"},GEt=uo({root:{Bahqtrf:"fk6fouc",Be2twd7:"fkhj508",Bg96gwp:"f1i3iumi",Bhrd7zp:"figsok6",fsow6f:"fpgzoln",mc9l5x:"f1w7gpdv",Huce71:"f6juhto",B68tc82:0,Bmxbyg5:0,Bpg54ce:"f1gl81tg",ygn44y:"f2jf649"},nowrap:{Huce71:"fz5stix",B68tc82:0,Bmxbyg5:0,Bpg54ce:"f1a3p1vp"},truncate:{ygn44y:"f1cmbuwj"},block:{mc9l5x:"ftgm304"},italic:{B80ckks:"f1j4dglz"},underline:{w71qe1:"f13mvf36"},strikethrough:{w71qe1:"fv5q2k7"},strikethroughUnderline:{w71qe1:"f1drk4o6"},base100:{Be2twd7:"f13mqy1h",Bg96gwp:"fcpl73t"},base200:{Be2twd7:"fy9rknc",Bg96gwp:"fwrc4pm"},base400:{Be2twd7:"fod5ikn",Bg96gwp:"faaz57k"},base500:{Be2twd7:"f1pp30po",Bg96gwp:"f106mvju"},base600:{Be2twd7:"f1x0m3f5",Bg96gwp:"fb86gi6"},hero700:{Be2twd7:"fojgt09",Bg96gwp:"fcen8rp"},hero800:{Be2twd7:"fccw675",Bg96gwp:"f1ebx5kk"},hero900:{Be2twd7:"f15afnhw",Bg96gwp:"fr3w3wp"},hero1000:{Be2twd7:"fpyltcb",Bg96gwp:"f1ivgwrt"},monospace:{Bahqtrf:"f1fedwem"},numeric:{Bahqtrf:"f1uq0ln5"},weightMedium:{Bhrd7zp:"fdj6btp"},weightSemibold:{Bhrd7zp:"fl43uef"},weightBold:{Bhrd7zp:"flh3ekv"},alignCenter:{fsow6f:"f17mccla"},alignEnd:{fsow6f:"f12ymhq5"},alignJustify:{fsow6f:"f1j59e10"}},{d:[".fk6fouc{font-family:var(--fontFamilyBase);}",".fkhj508{font-size:var(--fontSizeBase300);}",".f1i3iumi{line-height:var(--lineHeightBase300);}",".figsok6{font-weight:var(--fontWeightRegular);}",".fpgzoln{text-align:start;}",".f1w7gpdv{display:inline;}",".f6juhto{white-space:normal;}",[".f1gl81tg{overflow:visible;}",{p:-1}],".f2jf649{text-overflow:clip;}",".fz5stix{white-space:nowrap;}",[".f1a3p1vp{overflow:hidden;}",{p:-1}],".f1cmbuwj{text-overflow:ellipsis;}",".ftgm304{display:block;}",".f1j4dglz{font-style:italic;}",".f13mvf36{text-decoration-line:underline;}",".fv5q2k7{text-decoration-line:line-through;}",".f1drk4o6{text-decoration-line:line-through underline;}",".f13mqy1h{font-size:var(--fontSizeBase100);}",".fcpl73t{line-height:var(--lineHeightBase100);}",".fy9rknc{font-size:var(--fontSizeBase200);}",".fwrc4pm{line-height:var(--lineHeightBase200);}",".fod5ikn{font-size:var(--fontSizeBase400);}",".faaz57k{line-height:var(--lineHeightBase400);}",".f1pp30po{font-size:var(--fontSizeBase500);}",".f106mvju{line-height:var(--lineHeightBase500);}",".f1x0m3f5{font-size:var(--fontSizeBase600);}",".fb86gi6{line-height:var(--lineHeightBase600);}",".fojgt09{font-size:var(--fontSizeHero700);}",".fcen8rp{line-height:var(--lineHeightHero700);}",".fccw675{font-size:var(--fontSizeHero800);}",".f1ebx5kk{line-height:var(--lineHeightHero800);}",".f15afnhw{font-size:var(--fontSizeHero900);}",".fr3w3wp{line-height:var(--lineHeightHero900);}",".fpyltcb{font-size:var(--fontSizeHero1000);}",".f1ivgwrt{line-height:var(--lineHeightHero1000);}",".f1fedwem{font-family:var(--fontFamilyMonospace);}",".f1uq0ln5{font-family:var(--fontFamilyNumeric);}",".fdj6btp{font-weight:var(--fontWeightMedium);}",".fl43uef{font-weight:var(--fontWeightSemibold);}",".flh3ekv{font-weight:var(--fontWeightBold);}",".f17mccla{text-align:center;}",".f12ymhq5{text-align:end;}",".f1j59e10{text-align:justify;}"]}),wMe=t=>{"use no memo";const e=GEt();return t.root.className=ea(jEt.root,e.root,t.wrap===!1&&e.nowrap,t.truncate&&e.truncate,t.block&&e.block,t.italic&&e.italic,t.underline&&e.underline,t.strikethrough&&e.strikethrough,t.underline&&t.strikethrough&&e.strikethroughUnderline,t.size===100&&e.base100,t.size===200&&e.base200,t.size===400&&e.base400,t.size===500&&e.base500,t.size===600&&e.base600,t.size===700&&e.hero700,t.size===800&&e.hero800,t.size===900&&e.hero900,t.size===1e3&&e.hero1000,t.font==="monospace"&&e.monospace,t.font==="numeric"&&e.numeric,t.weight==="medium"&&e.weightMedium,t.weight==="semibold"&&e.weightSemibold,t.weight==="bold"&&e.weightBold,t.align==="center"&&e.alignCenter,t.align==="end"&&e.alignEnd,t.align==="justify"&&e.alignJustify,t.root.className),t},ole=$.forwardRef((t,e)=>{const i=AMe(t,e);return wMe(i),kh("useTextStyles_unstable")(i),IMe(i)});ole.displayName="Text";function kMe(t){const{useStyles:e,className:i,displayName:r}=t,o=$.forwardRef((l,d)=>{"use no memo";const h=e(),p=AMe(l,d);return wMe(p),p.root.className=ea(i,p.root.className,h.root,l.className),IMe(p)});return o.displayName=r,o}const qEt=kMe({useStyles:uo({root:{Bahqtrf:"fk6fouc",Be2twd7:"fy9rknc",Bhrd7zp:"figsok6",Bg96gwp:"fwrc4pm"}},{d:[".fk6fouc{font-family:var(--fontFamilyBase);}",".fy9rknc{font-size:var(--fontSizeBase200);}",".figsok6{font-weight:var(--fontWeightRegular);}",".fwrc4pm{line-height:var(--lineHeightBase200);}"]}),className:{root:"fui-Caption1"}.root,displayName:"Caption1"}),WEt=kMe({useStyles:uo({root:{Bahqtrf:"fk6fouc",Be2twd7:"fod5ikn",Bhrd7zp:"fl43uef",Bg96gwp:"faaz57k"}},{d:[".fk6fouc{font-family:var(--fontFamilyBase);}",".fod5ikn{font-size:var(--fontSizeBase400);}",".fl43uef{font-weight:var(--fontWeightSemibold);}",".faaz57k{line-height:var(--lineHeightBase400);}"]}),className:{root:"fui-Subtitle2"}.root,displayName:"Subtitle2"}),KEt=t=>{const e=t<=0?1:t;return process.env.NODE_ENV!=="production"&&t<=0&&console.error(`The prop 'max' must be greater than 0. Received max: ${t}`),e},JEt=(t,e)=>{if(t===void 0)return t;const i=t<0?0:t>e?e:t;return process.env.NODE_ENV!=="production"&&(t<0&&console.error(`The prop 'value' must be greater than or equal to zero. Received value: ${t}`),t>e&&console.error(`The prop 'value' must be less than or equal to 'max'. Received value: ${t}, max: ${e}`)),i},YEt=(t,e)=>{const i=nMe(),r=i?.validationState,{color:o=r==="error"||r==="warning"||r==="success"?r:"brand",shape:l="rounded",thickness:d="medium"}=t;var h;const p=KEt((h=t.max)!==null&&h!==void 0?h:1),g=JEt(t.value,p),f=Bl(_p("div",{ref:e,role:"progressbar","aria-valuemin":g!==void 0?0:void 0,"aria-valuemax":g!==void 0?p:void 0,"aria-valuenow":g,"aria-labelledby":i?.labelId,...t}),{elementType:"div"});i&&(i.validationMessageId||i.hintId)&&(f["aria-describedby"]=[i?.validationMessageId,i?.hintId,f["aria-describedby"]].filter(Boolean).join(" "));const y=Bl(t.bar,{elementType:"div"});return{color:o,max:p,shape:l,thickness:d,value:g,components:{root:"div",bar:"div"},root:f,bar:y}},QEt=t=>(Pd(t),yr(t.root,{children:t.bar&&yr(t.bar,{})})),RMe={root:"fui-ProgressBar",bar:"fui-ProgressBar__bar"},ZEt=.01,XEt=uo({root:{mc9l5x:"ftgm304",De3pzq:"f18f03hv",a9b677:"fly5x3f",B68tc82:0,Bmxbyg5:0,Bpg54ce:"f1a3p1vp",Bpep1pd:"fu42dvn"},rounded:{Beyfa6y:0,Bbmb7ep:0,Btl43ni:0,B7oj6ja:0,Dimara:"ft85np5"},square:{Beyfa6y:0,Bbmb7ep:0,Btl43ni:0,B7oj6ja:0,Dimara:"f1fabniw"},medium:{Bqenvij:"f4t8t6x"},large:{Bqenvij:"f6ywr7j"}},{d:[".ftgm304{display:block;}",".f18f03hv{background-color:var(--colorNeutralBackground6);}",".fly5x3f{width:100%;}",[".f1a3p1vp{overflow:hidden;}",{p:-1}],[".ft85np5{border-radius:var(--borderRadiusMedium);}",{p:-1}],[".f1fabniw{border-radius:var(--borderRadiusNone);}",{p:-1}],".f4t8t6x{height:2px;}",".f6ywr7j{height:4px;}"],m:[["@media screen and (forced-colors: active){.fu42dvn{background-color:CanvasText;}}",{m:"screen and (forced-colors: active)"}]]}),e0t=uo({base:{Bpep1pd:"f1neahkh",Beyfa6y:0,Bbmb7ep:0,Btl43ni:0,B7oj6ja:0,Dimara:"f12b9xdw",Bqenvij:"f1l02sjl"},nonZeroDeterminate:{Bmy1vo4:"fjt6zfz",B3o57yi:"f1wofebd",Bkqvd7p:"fv71qf3"},indeterminate:{B2u0y6b:"fa0wk36",qhf8xq:"f10pi13n",Bcmaq0h:["fpo0yib","f1u5hf6c"],Bv12yb3:["fwd2bol","f14gig94"],vin17d:"f1a27w2r",Ezkn3b:"f452v7t",w3vfg9:"f1cpbl36",Gqtpxc:"f4akx1t",B3vm3ge:"f18p5put"},brand:{De3pzq:"ftywsgz"},error:{De3pzq:"fdl5y0r"},warning:{De3pzq:"f1s438gw"},success:{De3pzq:"flxk52p"}},{m:[["@media screen and (forced-colors: active){.f1neahkh{background-color:Highlight;}}",{m:"screen and (forced-colors: active)"}],["@media screen and (prefers-reduced-motion: reduce){.f4akx1t{animation-duration:0.01ms;}}",{m:"screen and (prefers-reduced-motion: reduce)"}],["@media screen and (prefers-reduced-motion: reduce){.f18p5put{animation-iteration-count:1;}}",{m:"screen and (prefers-reduced-motion: reduce)"}]],d:[[".f12b9xdw{border-radius:inherit;}",{p:-1}],".f1l02sjl{height:100%;}",".fjt6zfz{transition-property:width;}",".f1wofebd{transition-duration:0.3s;}",".fv71qf3{transition-timing-function:ease;}",".fa0wk36{max-width:33%;}",".f10pi13n{position:relative;}",`.fpo0yib{background-image:linear-gradient(
      to right,
      var(--colorNeutralBackground6) 0%,
      var(--colorTransparentBackground) 50%,
      var(--colorNeutralBackground6) 100%
    );}`,`.f1u5hf6c{background-image:linear-gradient(
      to left,
      var(--colorNeutralBackground6) 0%,
      var(--colorTransparentBackground) 50%,
      var(--colorNeutralBackground6) 100%
    );}`,".fwd2bol{animation-name:f1keuaan;}",".f14gig94{animation-name:f10x8f8u;}",".f1a27w2r{animation-duration:3s;}",".f452v7t{animation-timing-function:linear;}",".f1cpbl36{animation-iteration-count:infinite;}",".ftywsgz{background-color:var(--colorCompoundBrandBackground);}",".fdl5y0r{background-color:var(--colorPaletteRedBackground3);}",".f1s438gw{background-color:var(--colorPaletteDarkOrangeBackground3);}",".flxk52p{background-color:var(--colorPaletteGreenBackground3);}"],k:["@keyframes f1keuaan{0%{left:-33%;}100%{left:100%;}}","@keyframes f10x8f8u{0%{right:-33%;}100%{right:100%;}}"]}),t0t=t=>{"use no memo";const{color:e,max:i,shape:r,thickness:o,value:l}=t,d=XEt(),h=e0t();return t.root.className=ea(RMe.root,d.root,d[r],d[o],t.root.className),t.bar&&(t.bar.className=ea(RMe.bar,h.base,h.brand,l===void 0&&h.indeterminate,l!==void 0&&l>ZEt&&h.nonZeroDeterminate,e&&l!==void 0&&h[e],t.bar.className)),t.bar&&l!==void 0&&(t.bar.style={width:Math.min(100,Math.max(0,l/i*100))+"%",...t.bar.style}),t},sle=$.forwardRef((t,e)=>{const i=YEt(t,e);return t0t(i),kh("useProgressBarStyles_unstable")(i),QEt(i)});sle.displayName="ProgressBar";const i0t=(t,e)=>{const{size:i="medium",vertical:r=!1}=t,o=NH({circular:!0,axis:"both"}),l={size:i,vertical:r,components:{root:"div"},root:Bl(_p("div",{role:"toolbar",ref:e,...r&&{"aria-orientation":"vertical"},...o,...t}),{elementType:"div"})},[d,h]=n0t({checkedValues:t.checkedValues,defaultCheckedValues:t.defaultCheckedValues,onCheckedValueChange:t.onCheckedValueChange}),p=Fl((f,y,T,C)=>{if(y&&T){const I=[...d?.[y]||[]];C?I.splice(I.indexOf(T),1):I.push(T),h?.(f,{name:y,checkedItems:I})}}),g=Fl((f,y,T,C)=>{y&&T&&h?.(f,{name:y,checkedItems:[T]})});return{...l,handleToggleButton:p,handleRadio:g,checkedValues:d??{}}},n0t=t=>{const[e,i]=OL({state:t.checkedValues,defaultState:t.defaultCheckedValues,initialState:{}}),{onCheckedValueChange:r}=t,o=Fl((l,{name:d,checkedItems:h})=>{r&&r(l,{name:d,checkedItems:h}),i(p=>p?{...p,[d]:h}:{[d]:h})});return[e,o]},a0t=BH(void 0),r0t=(t,e)=>(Pd(t),yr(a0t.Provider,{value:e.toolbar,children:yr(t.root,{children:t.root.children})})),o0t={root:"fui-Toolbar"},s0t=uo({root:{mc9l5x:"f22iagw",Bt984gj:"f122n59",Byoj8tv:0,uwmqm3:0,z189sj:0,z8tnut:0,B0ocmuz:"f1yqiaad"},vertical:{Beiy3e4:"f1vx9l62",a9b677:"f1acs6jw"},small:{Byoj8tv:0,uwmqm3:0,z189sj:0,z8tnut:0,B0ocmuz:"fvz760z"},medium:{Byoj8tv:0,uwmqm3:0,z189sj:0,z8tnut:0,B0ocmuz:"f1yqiaad"},large:{Byoj8tv:0,uwmqm3:0,z189sj:0,z8tnut:0,B0ocmuz:"f1ms6bdn"}},{d:[".f22iagw{display:flex;}",".f122n59{align-items:center;}",[".f1yqiaad{padding:4px 8px;}",{p:-1}],".f1vx9l62{flex-direction:column;}",".f1acs6jw{width:fit-content;}",[".fvz760z{padding:0px 4px;}",{p:-1}],[".f1yqiaad{padding:4px 8px;}",{p:-1}],[".f1ms6bdn{padding:4px 20px;}",{p:-1}]]}),l0t=t=>{"use no memo";const e=s0t(),{vertical:i,size:r}=t;return t.root.className=ea(o0t.root,e.root,i&&e.vertical,r==="small"&&!i&&e.small,r==="medium"&&!i&&e.medium,r==="large"&&!i&&e.large,t.root.className),t};function c0t(t){const{size:e,handleToggleButton:i,vertical:r,checkedValues:o,handleRadio:l}=t;return{toolbar:{size:e,vertical:r,handleToggleButton:i,handleRadio:l,checkedValues:o}}}const MMe=$.forwardRef((t,e)=>{const i=i0t(t,e),r=c0t(i);return l0t(i),kh("useToolbarStyles_unstable")(i),r0t(i,r)});MMe.displayName="Toolbar";const d0t=uo({vertical:{Beiy3e4:"f1vx9l62"},verticalIcon:{Be2twd7:"f1rt2boy",jrapky:0,Frg6f3:0,t21cq0:0,B6of3ja:0,B74szlk:"f1s184ao"}},{d:[".f1vx9l62{flex-direction:column;}",".f1rt2boy{font-size:24px;}",[".f1s184ao{margin:0;}",{p:-1}]]}),u0t=t=>{"use no memo";tMe(t);const e=d0t();t.root.className=ea(t.root.className,t.vertical&&e.vertical),t.icon&&(t.icon.className=ea(t.icon.className,t.vertical&&e.verticalIcon))},h0t=(t,e)=>{const{vertical:i=!1,...r}=t,o=XRe({appearance:"subtle",...r,size:"medium"},e);return{vertical:i,...o}},lle=$.forwardRef((t,e)=>{const i=h0t(t,e);return u0t(i),kh("useToolbarButtonStyles_unstable")(i),YRe(i)});lle.displayName="ToolbarButton";const p0t=(t,{referenceLabel:e,referenceId:i},r)=>{const{checkbox:o={},onSelectionChange:l,floatingAction:d,onClick:h,onKeyDown:p}=t,{findAllFocusable:g}=iK(),f=$.useRef(null),[y,T]=OL({state:t.selected,defaultState:t.defaultSelected,initialState:!1}),C=[t.selected,t.defaultSelected,l].some(z=>typeof z<"u"),[E,I]=$.useState(!1),w=$.useCallback(z=>{if(!r.current)return!1;const H=g(r.current),j=z.target,J=H.some(re=>re.contains(j)),Z=f?.current===j;return J&&!Z},[r,g]),D=$.useCallback(z=>{if(w(z))return;const H=!y;T(H),l&&l(z,{selected:H})},[l,y,T,w]),F=$.useCallback(z=>{[FH].includes(z.key)&&(z.preventDefault(),D(z))},[D]),x=$.useMemo(()=>{if(!C||d)return;const z={};return i?z["aria-labelledby"]=i:e&&(z["aria-label"]=e),Ss(o,{defaultProps:{ref:f,type:"checkbox",checked:y,onChange:H=>D(H),onFocus:()=>I(!0),onBlur:()=>I(!1),...z},elementType:"input"})},[o,d,y,C,D,i,e]),B=$.useMemo(()=>{if(d)return Ss(d,{defaultProps:{ref:f},elementType:"div"})},[d]),L=$.useMemo(()=>C?{onClick:vA(h,D),onKeyDown:vA(p,F)}:null,[C,D,h,p,F]);return{selected:y,selectable:C,selectFocused:E,selectableCardProps:L,checkboxSlot:x,floatingActionSlot:B}},PMe=$.createContext(void 0),cle={selectableA11yProps:{referenceId:void 0,setReferenceId(){},referenceLabel:void 0,setReferenceLabel(){}}},g0t=PMe.Provider,m0t=()=>{var t;return(t=$.useContext(PMe))!==null&&t!==void 0?t:cle},f0t={off:void 0,"no-tab":"limited-trap-focus","tab-exit":"limited","tab-only":"unlimited"},v0t=({focusMode:t,...e})=>{const i=["onClick","onDoubleClick","onMouseUp","onMouseDown","onPointerUp","onPointerDown","onTouchStart","onTouchEnd","onDragStart","onDragEnd"].some(d=>e[d]),r=t??(i?"no-tab":"off"),l={...mse({tabBehavior:f0t[r]}),tabIndex:0};return{interactive:i,focusAttributes:r==="off"?null:l}},y0t=(t,e)=>{const{appearance:i="filled",orientation:r="vertical",size:o="medium"}=t,[l,d]=$.useState(cle.selectableA11yProps.referenceId),[h,p]=$.useState(cle.selectableA11yProps.referenceId),g=yse(),{selectable:f,selected:y,selectableCardProps:T,selectFocused:C,checkboxSlot:E,floatingActionSlot:I}=p0t(t,{referenceId:l,referenceLabel:h},g),w=kC(g,e),{interactive:D,focusAttributes:F}=v0t(t);return{appearance:i,orientation:r,size:o,interactive:D,selectable:f,selectFocused:C,selected:y,selectableA11yProps:{setReferenceId:d,referenceId:l,referenceLabel:h,setReferenceLabel:p},components:{root:"div",floatingAction:"div",checkbox:"input"},root:Bl(_p("div",{ref:w,role:"group",...f?null:F,...t,...T}),{elementType:"div"}),floatingAction:I,checkbox:E}},S0t=(t,e)=>(Pd(t),yr(t.root,{children:Uf(g0t,{value:e,children:[t.checkbox?yr(t.checkbox,{}):null,t.floatingAction?yr(t.floatingAction,{}):null,t.root.children]})})),DMe={root:"fui-CardHeader",image:"fui-CardHeader__image",header:"fui-CardHeader__header",description:"fui-CardHeader__description",action:"fui-CardHeader__action"},b0t=uo({root:{Bkc6ea2:"fkufhic",Bt984gj:"f122n59"},image:{mc9l5x:"ftuwxu6",t21cq0:["fql5097","f6yss9k"]},header:{mc9l5x:"f22iagw"},description:{mc9l5x:"f22iagw"},action:{Frg6f3:["f6yss9k","fql5097"],B7frvx2:"f1ndzpm5",B06c7xf:["f1fkeggc","f1u45u6i"],B8uq84v:"f16eyofs",snkdo8:["f1u45u6i","f1fkeggc"],Bpf22ct:"f1wkmkig",apjfyd:"f18alut9"}},{d:[".fkufhic{--fui-CardHeader--gap:12px;}",".f122n59{align-items:center;}",".ftuwxu6{display:inline-flex;}",".fql5097{margin-right:var(--fui-CardHeader--gap);}",".f6yss9k{margin-left:var(--fui-CardHeader--gap);}",".f22iagw{display:flex;}"],m:[["@media (forced-colors: active){.f1ndzpm5 .fui-Button,.f1ndzpm5 .fui-Link{border-top-color:currentColor;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f1fkeggc .fui-Button,.f1fkeggc .fui-Link{border-right-color:currentColor;}.f1u45u6i .fui-Button,.f1u45u6i .fui-Link{border-left-color:currentColor;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f16eyofs .fui-Button,.f16eyofs .fui-Link{border-bottom-color:currentColor;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f1wkmkig .fui-Button,.f1wkmkig .fui-Link{color:currentColor;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f18alut9 .fui-Button,.f18alut9 .fui-Link{outline-color:currentColor;}}",{m:"(forced-colors: active)"}]]}),T0t=uo({root:{mc9l5x:"f13qh94s",t4k1zu:"f8a668j"},image:{Br312pm:"fwpfdsa",Ijaq50:"fldnz9j"},header:{Br312pm:"fd46tj4",Ijaq50:"f16hsg94"},description:{Br312pm:"fd46tj4",Ijaq50:"faunodf"},action:{Br312pm:"fis13di",Ijaq50:"fldnz9j"}},{d:[".f13qh94s{display:grid;}",".f8a668j{grid-auto-columns:min-content 1fr min-content;}",".fwpfdsa{grid-column-start:1;}",".fldnz9j{grid-row-start:span 2;}",".fd46tj4{grid-column-start:2;}",".f16hsg94{grid-row-start:1;}",".faunodf{grid-row-start:2;}",".fis13di{grid-column-start:3;}"]}),C0t=uo({root:{mc9l5x:"f22iagw"},header:{Bh6795r:"fqerorx"},image:{},description:{},action:{}},{d:[".f22iagw{display:flex;}",".fqerorx{flex-grow:1;}"]}),_0t=t=>{"use no memo";const e=b0t(),i=T0t(),r=C0t(),o=t.description?i:r,l=d=>{var h;return ea(DMe[d],e[d],o[d],(h=t[d])===null||h===void 0?void 0:h.className)};return t.root.className=l("root"),t.image&&(t.image.className=l("image")),t.header&&(t.header.className=l("header")),t.description&&(t.description.className=l("description")),t.action&&(t.action.className=l("action")),t},LMe={root:"fui-CardFooter",action:"fui-CardFooter__action"},E0t=uo({root:{mc9l5x:"f22iagw",Beiy3e4:"f1063pyq",i8kkvl:0,Belr9w4:0,rmohyg:"fsbu5mz"},action:{Frg6f3:["fcgxt0o","f1ujusj6"],B7frvx2:"f1ndzpm5",B06c7xf:["f1fkeggc","f1u45u6i"],B8uq84v:"f16eyofs",snkdo8:["f1u45u6i","f1fkeggc"],Bpf22ct:"f1wkmkig",apjfyd:"f18alut9"}},{d:[".f22iagw{display:flex;}",".f1063pyq{flex-direction:row;}",[".fsbu5mz{gap:12px;}",{p:-1}],".fcgxt0o{margin-left:auto;}",".f1ujusj6{margin-right:auto;}"],m:[["@media (forced-colors: active){.f1ndzpm5 .fui-Button,.f1ndzpm5 .fui-Link{border-top-color:currentColor;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f1fkeggc .fui-Button,.f1fkeggc .fui-Link{border-right-color:currentColor;}.f1u45u6i .fui-Button,.f1u45u6i .fui-Link{border-left-color:currentColor;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f16eyofs .fui-Button,.f16eyofs .fui-Link{border-bottom-color:currentColor;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f1wkmkig .fui-Button,.f1wkmkig .fui-Link{color:currentColor;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f18alut9 .fui-Button,.f18alut9 .fui-Link{outline-color:currentColor;}}",{m:"(forced-colors: active)"}]]}),A0t=t=>{"use no memo";const e=E0t();return t.root.className=ea(LMe.root,e.root,t.root.className),t.action&&(t.action.className=ea(LMe.action,e.action,t.action.className)),t},dle={root:"fui-Card",floatingAction:"fui-Card__floatingAction",checkbox:"fui-Card__checkbox"},I0t=pd("rfxo2k2","rgle7w9",[".rfxo2k2{overflow:hidden;border-radius:var(--fui-Card--border-radius);padding:var(--fui-Card--size);gap:var(--fui-Card--size);display:flex;position:relative;box-sizing:border-box;color:var(--colorNeutralForeground1);}",'.rfxo2k2::after{position:absolute;top:0;left:0;right:0;bottom:0;content:"";pointer-events:none;border-top-style:solid;border-right-style:solid;border-bottom-style:solid;border-left-style:solid;border-top-width:var(--strokeWidthThin);border-right-width:var(--strokeWidthThin);border-bottom-width:var(--strokeWidthThin);border-left-width:var(--strokeWidthThin);border-radius:var(--fui-Card--border-radius);}',".rfxo2k2>.fui-CardHeader,.rfxo2k2>.fui-CardFooter{flex-shrink:0;}",".rgle7w9{overflow:hidden;border-radius:var(--fui-Card--border-radius);padding:var(--fui-Card--size);gap:var(--fui-Card--size);display:flex;position:relative;box-sizing:border-box;color:var(--colorNeutralForeground1);}",'.rgle7w9::after{position:absolute;top:0;right:0;left:0;bottom:0;content:"";pointer-events:none;border-top-style:solid;border-left-style:solid;border-bottom-style:solid;border-right-style:solid;border-top-width:var(--strokeWidthThin);border-left-width:var(--strokeWidthThin);border-bottom-width:var(--strokeWidthThin);border-right-width:var(--strokeWidthThin);border-radius:var(--fui-Card--border-radius);}',".rgle7w9>.fui-CardHeader,.rgle7w9>.fui-CardFooter{flex-shrink:0;}"]),w0t=uo({focused:{Brovlpu:"ftqa4ok",B486eqv:"f2hkw1w",B8q5s1w:"f8hki3x",Bci5o5g:["f1d2448m","ffh67wi"],n8qw10:"f1bjia2o",Bdrgwmp:["ffh67wi","f1d2448m"],Bb7d1vk:"f226i61",zhwhgb:["f13kzufm","fsx75g8"],dhy2o1:"flujwa2",Gfyso:["fsx75g8","f13kzufm"],Bm4h7ae:"f15bsgw9",B7ys5i9:"f14e48fq",Busjfv9:"f18yb2kv",Bhk32uz:"fd6o370",f6g5ot:0,Boxcth7:0,Bhdgwq3:0,hgwjuy:0,Bshpdp8:0,Bsom6fd:0,Blkhhs4:0,Bonggc9:0,Ddfuxk:0,i03rao:0,kclons:0,clg4pj:0,Bpqj9nj:0,B6dhp37:0,Bf4ptjt:0,Bqtpl0w:0,i4rwgc:"fpqizxz",Dah5zi:0,B1tsrr9:0,qqdqy8:0,Bkh64rk:0,e3fwne:"fnd8nzh",J0r882:"f15fr7a0",Bule8hv:["fwsq40z","fy0y4wt"],Bjwuhne:"f34ld9f",Ghsupd:["fy0y4wt","fwsq40z"]},selectableFocused:{Brovlpu:"ftqa4ok",B486eqv:"f2hkw1w",Bssx7fj:"f1b1k54r",uh7if5:["f4ne723","fqqcjud"],clntm0:"fh7aioi",Dlk2r6:["fqqcjud","f4ne723"],Bm3wd5j:"f1k55ka9",Bbrhkcr:["fgclinu","f16pcs8n"],f1oku:"fycbxed",aywvf2:["f16pcs8n","fgclinu"],B2j2mmj:"ffht0p2",wigs8:"f1p0ul1q",pbfy6t:"f1c901ms",B0v4ure:"f1alokd7",Byrf0fs:0,Bsiemmq:0,Bwckmig:0,skfxo0:0,Iidy0u:0,B98u21t:0,Bvwlmkc:0,jo1ztg:0,Ba1iezr:0,Blmvk6g:0,B24cy0v:0,Bil7v7r:0,Br3gin4:0,nr063g:0,ghq09:0,Bbgo44z:0,Bseh09z:"f1i978nd",az1dzo:0,Ba3ybja:0,B6352mv:0,vppk2z:0,Biaj6j7:"f1nh8hsq",B2pnrqr:"f1amxum7",B29w5g4:["f1cec8w7","f554mv0"],Bhhzhcn:"f1sj6kbr",Bec0n69:["f554mv0","f1cec8w7"]},orientationHorizontal:{Beiy3e4:"f1063pyq",Bt984gj:"f122n59",Binpb3b:"ftrw7vg",qrt8p2:"f18opajm",k6ws3r:["f13002it","fqo182t"],Btcwela:["f18yna97","f1kd6wh7"],Fer9m8:"f4i4759"},orientationVertical:{Beiy3e4:"f1vx9l62",B5nvv7i:["f14k419y","f1fgo9fz"],Baxg94k:["f1fgo9fz","f14k419y"],tn21ii:"fvqmfsm",B0ud6bj:"f3am6yf",Bgdo4j:"f1r5wgso"},sizeSmall:{B7balbw:"f1pi9uxy",B1h88n7:"f1h1zgly"},sizeMedium:{B7balbw:"frsmuga",B1h88n7:"fuldkky"},sizeLarge:{B7balbw:"f1qua4xo",B1h88n7:"fimkt6v"},interactive:{rhjd8f:"f1epqm3e"},filled:{De3pzq:"fxugw4r",E5pizo:"f1whvlc6",B0n5ga8:"f16gxe2i",s924m2:["fpgykix","fzybk4o"],B1q35kw:"f1osi826",Gp14am:["fzybk4o","fpgykix"]},filledInteractive:{Bceei9c:"f1k6fduh",De3pzq:"fxugw4r",E5pizo:"f1whvlc6",B0n5ga8:"f16gxe2i",s924m2:["fpgykix","fzybk4o"],B1q35kw:"f1osi826",Gp14am:["fzybk4o","fpgykix"],Bi91k9c:"feu1g3u",Jwef8y:"f1knas48",Bvxd0ez:"f1m145df",ecr2s2:"fb40n2d"},filledInteractiveSelected:{De3pzq:"f1nfm20t",B0n5ga8:"f16eln5f",s924m2:["fa2okxs","fg4zq3l"],B1q35kw:"ff6932p",Gp14am:["fg4zq3l","fa2okxs"],Bi91k9c:"fx9teim",Jwef8y:"f1kz6goq"},filledAlternative:{De3pzq:"f1dmdbja",E5pizo:"f1whvlc6",B0n5ga8:"f16gxe2i",s924m2:["fpgykix","fzybk4o"],B1q35kw:"f1osi826",Gp14am:["fzybk4o","fpgykix"]},filledAlternativeInteractive:{Bceei9c:"f1k6fduh",De3pzq:"f1dmdbja",E5pizo:"f1whvlc6",B0n5ga8:"f16gxe2i",s924m2:["fpgykix","fzybk4o"],B1q35kw:"f1osi826",Gp14am:["fzybk4o","fpgykix"],Bi91k9c:"fnwyq0v",Jwef8y:"f1uvynv3",Bvxd0ez:"f1m145df",ecr2s2:"f1yhgkbh"},filledAlternativeInteractiveSelected:{De3pzq:"fjxa0vh",B0n5ga8:"f16eln5f",s924m2:["fa2okxs","fg4zq3l"],B1q35kw:"ff6932p",Gp14am:["fg4zq3l","fa2okxs"],Bi91k9c:"f1luvkty",Jwef8y:"fehi0vp"},outline:{De3pzq:"f1c21dwh",E5pizo:"f1couhl3",B0n5ga8:"ft83z1f",s924m2:["f1g4150c","f192dr6e"],B1q35kw:"f1qnawh6",Gp14am:["f192dr6e","f1g4150c"]},outlineInteractive:{Bceei9c:"f1k6fduh",De3pzq:"f1c21dwh",E5pizo:"f1couhl3",B0n5ga8:"ft83z1f",s924m2:["f1g4150c","f192dr6e"],B1q35kw:"f1qnawh6",Gp14am:["f192dr6e","f1g4150c"],Bi91k9c:"feu1g3u",Jwef8y:"fjxutwb",Be0v6ae:"f1llr77y",B5kxglz:["fzk0khw","fjj8tog"],B3pwyw6:"fb1u8ub",Bymgtzf:["fjj8tog","fzk0khw"],ecr2s2:"fophhak",dmfk:"f1uohb70",B4ofi8:["f1jm7v1n","f1bus3rq"],jgq6uv:"f1fbu7rr",Baxewws:["f1bus3rq","f1jm7v1n"]},outlineInteractiveSelected:{De3pzq:"f1q9pm1r",B0n5ga8:"f16eln5f",s924m2:["fa2okxs","fg4zq3l"],B1q35kw:"ff6932p",Gp14am:["fg4zq3l","fa2okxs"],Bi91k9c:"fx9teim",Jwef8y:"fg59vm4"},subtle:{De3pzq:"fhovq9v",E5pizo:"f1couhl3",B0n5ga8:"f16gxe2i",s924m2:["fpgykix","fzybk4o"],B1q35kw:"f1osi826",Gp14am:["fzybk4o","fpgykix"]},subtleInteractive:{Bceei9c:"f1k6fduh",De3pzq:"fhovq9v",E5pizo:"f1couhl3",B0n5ga8:"f16gxe2i",s924m2:["fpgykix","fzybk4o"],B1q35kw:"f1osi826",Gp14am:["fzybk4o","fpgykix"],Bi91k9c:"feu1g3u",Jwef8y:"f1t94bn6",ecr2s2:"f1wfn5kd"},subtleInteractiveSelected:{De3pzq:"fq5gl1p",B0n5ga8:"f16eln5f",s924m2:["fa2okxs","fg4zq3l"],B1q35kw:"ff6932p",Gp14am:["fg4zq3l","fa2okxs"],Bi91k9c:"fx9teim",Jwef8y:"f1uqaxdt"},highContrastSelected:{ycbfsm:"fkc42ay",Bsw6fvg:"f1rirnrt",Bbusuzp:"f1lkg8j3",xgfqdd:"f1nkj0oa",Bmmdzwq:"fey3rwa",zkpvhj:["f5jhx11","fff9uym"],B20bydw:"fm7n0jy",Bwwwggl:["fff9uym","f5jhx11"]},highContrastInteractive:{h1vhog:"fpfvv3l",kslmdy:"f1oamsm6",Baaf6ca:"f1il21bs",x9zz3d:"fnn5dk0",Bmmdzwq:"fey3rwa",zkpvhj:["f5jhx11","fff9uym"],B20bydw:"fm7n0jy",Bwwwggl:["fff9uym","f5jhx11"]},select:{qhf8xq:"f1euv43f",Bhzewxz:"fqclxi7",j35jbq:["fiv86kb","f36uhnt"],Bj3rh1h:"f19g0ac"},hiddenCheckbox:{B68tc82:0,Bmxbyg5:0,Bpg54ce:"f1a3p1vp",a9b677:"frkrog8",Bqenvij:"f1mpe4l3",qhf8xq:"f1euv43f",Bh84pgu:"fmf1zke",Bgl5zvf:"f1wch0ki",Huce71:"fz5stix"}},{f:[".ftqa4ok:focus{outline-style:none;}"],i:[".f2hkw1w:focus-visible{outline-style:none;}"],d:[".f8hki3x[data-fui-focus-visible]{border-top-color:transparent;}",".f1d2448m[data-fui-focus-visible]{border-right-color:transparent;}",".ffh67wi[data-fui-focus-visible]{border-left-color:transparent;}",".f1bjia2o[data-fui-focus-visible]{border-bottom-color:transparent;}",'.f15bsgw9[data-fui-focus-visible]::after{content:"";}',".f14e48fq[data-fui-focus-visible]::after{position:absolute;}",".f18yb2kv[data-fui-focus-visible]::after{pointer-events:none;}",".fd6o370[data-fui-focus-visible]::after{z-index:1;}",[".fpqizxz[data-fui-focus-visible]::after{border:var(--strokeWidthThick) solid var(--colorStrokeFocus2);}",{p:-2}],[".fnd8nzh[data-fui-focus-visible]::after{border-radius:var(--fui-Card--border-radius);}",{p:-1}],".f15fr7a0[data-fui-focus-visible]::after{top:calc(0px - var(--strokeWidthThick) - -2px);}",".fwsq40z[data-fui-focus-visible]::after{right:calc(0px - var(--strokeWidthThick) - -2px);}",".fy0y4wt[data-fui-focus-visible]::after{left:calc(0px - var(--strokeWidthThick) - -2px);}",".f34ld9f[data-fui-focus-visible]::after{bottom:calc(0px - var(--strokeWidthThick) - -2px);}",".f1b1k54r[data-fui-focus-within]:focus-within{border-top-color:transparent;}",".f4ne723[data-fui-focus-within]:focus-within{border-right-color:transparent;}",".fqqcjud[data-fui-focus-within]:focus-within{border-left-color:transparent;}",".fh7aioi[data-fui-focus-within]:focus-within{border-bottom-color:transparent;}",'.ffht0p2[data-fui-focus-within]:focus-within::after{content:"";}',".f1p0ul1q[data-fui-focus-within]:focus-within::after{position:absolute;}",".f1c901ms[data-fui-focus-within]:focus-within::after{pointer-events:none;}",".f1alokd7[data-fui-focus-within]:focus-within::after{z-index:1;}",[".f1i978nd[data-fui-focus-within]:focus-within::after{border:var(--strokeWidthThick) solid var(--colorStrokeFocus2);}",{p:-2}],[".f1nh8hsq[data-fui-focus-within]:focus-within::after{border-radius:var(--fui-Card--border-radius);}",{p:-1}],".f1amxum7[data-fui-focus-within]:focus-within::after{top:calc(0px - var(--strokeWidthThick) - -2px);}",".f1cec8w7[data-fui-focus-within]:focus-within::after{right:calc(0px - var(--strokeWidthThick) - -2px);}",".f554mv0[data-fui-focus-within]:focus-within::after{left:calc(0px - var(--strokeWidthThick) - -2px);}",".f1sj6kbr[data-fui-focus-within]:focus-within::after{bottom:calc(0px - var(--strokeWidthThick) - -2px);}",".f1063pyq{flex-direction:row;}",".f122n59{align-items:center;}",".ftrw7vg>.fui-CardPreview{margin-top:calc(var(--fui-Card--size) * -1);}",".f18opajm>.fui-CardPreview{margin-bottom:calc(var(--fui-Card--size) * -1);}",'.f13002it>:not([aria-hidden="true"]).fui-CardPreview:first-of-type{margin-left:calc(var(--fui-Card--size) * -1);}','.fqo182t>:not([aria-hidden="true"]).fui-CardPreview:first-of-type{margin-right:calc(var(--fui-Card--size) * -1);}','.f18yna97>:not([aria-hidden="true"]).fui-CardPreview:last-of-type{margin-right:calc(var(--fui-Card--size) * -1);}','.f1kd6wh7>:not([aria-hidden="true"]).fui-CardPreview:last-of-type{margin-left:calc(var(--fui-Card--size) * -1);}',".f4i4759>.fui-CardHeader:last-of-type,.f4i4759>.fui-CardFooter:last-of-type{flex-grow:1;}",".f1vx9l62{flex-direction:column;}",".f14k419y>.fui-CardPreview{margin-left:calc(var(--fui-Card--size) * -1);}",".f1fgo9fz>.fui-CardPreview{margin-right:calc(var(--fui-Card--size) * -1);}",'.fvqmfsm>:not([aria-hidden="true"]).fui-CardPreview:first-of-type{margin-top:calc(var(--fui-Card--size) * -1);}',".f3am6yf>.fui-Card__floatingAction+.fui-CardPreview{margin-top:calc(var(--fui-Card--size) * -1);}",'.f1r5wgso>:not([aria-hidden="true"]).fui-CardPreview:last-of-type{margin-bottom:calc(var(--fui-Card--size) * -1);}',".f1pi9uxy{--fui-Card--size:8px;}",".f1h1zgly{--fui-Card--border-radius:var(--borderRadiusSmall);}",".frsmuga{--fui-Card--size:12px;}",".fuldkky{--fui-Card--border-radius:var(--borderRadiusMedium);}",".f1qua4xo{--fui-Card--size:16px;}",".fimkt6v{--fui-Card--border-radius:var(--borderRadiusLarge);}",".f1epqm3e .fui-Text{color:currentColor;}",".fxugw4r{background-color:var(--colorNeutralBackground1);}",".f1whvlc6{box-shadow:var(--shadow4);}",".f16gxe2i::after{border-top-color:var(--colorTransparentStroke);}",".fpgykix::after{border-right-color:var(--colorTransparentStroke);}",".fzybk4o::after{border-left-color:var(--colorTransparentStroke);}",".f1osi826::after{border-bottom-color:var(--colorTransparentStroke);}",".f1k6fduh{cursor:pointer;}",".f1nfm20t{background-color:var(--colorNeutralBackground1Selected);}",".f16eln5f::after{border-top-color:var(--colorNeutralStroke1Selected);}",".fa2okxs::after{border-right-color:var(--colorNeutralStroke1Selected);}",".fg4zq3l::after{border-left-color:var(--colorNeutralStroke1Selected);}",".ff6932p::after{border-bottom-color:var(--colorNeutralStroke1Selected);}",".f1dmdbja{background-color:var(--colorNeutralBackground2);}",".fjxa0vh{background-color:var(--colorNeutralBackground2Selected);}",".f1c21dwh{background-color:var(--colorTransparentBackground);}",".f1couhl3{box-shadow:none;}",".ft83z1f::after{border-top-color:var(--colorNeutralStroke1);}",".f1g4150c::after{border-right-color:var(--colorNeutralStroke1);}",".f192dr6e::after{border-left-color:var(--colorNeutralStroke1);}",".f1qnawh6::after{border-bottom-color:var(--colorNeutralStroke1);}",".f1q9pm1r{background-color:var(--colorTransparentBackgroundSelected);}",".fhovq9v{background-color:var(--colorSubtleBackground);}",".fq5gl1p{background-color:var(--colorSubtleBackgroundSelected);}",".f1euv43f{position:absolute;}",".fqclxi7{top:4px;}",".fiv86kb{right:4px;}",".f36uhnt{left:4px;}",".f19g0ac{z-index:1;}",[".f1a3p1vp{overflow:hidden;}",{p:-1}],".frkrog8{width:1px;}",".f1mpe4l3{height:1px;}",".fmf1zke{clip:rect(0 0 0 0);}",".f1wch0ki{clip-path:inset(50%);}",".fz5stix{white-space:nowrap;}"],m:[["@media (forced-colors: active){.f226i61[data-fui-focus-visible]::after{border-top-color:Highlight;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f13kzufm[data-fui-focus-visible]::after{border-right-color:Highlight;}.fsx75g8[data-fui-focus-visible]::after{border-left-color:Highlight;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.flujwa2[data-fui-focus-visible]::after{border-bottom-color:Highlight;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f1k55ka9[data-fui-focus-within]:focus-within::after{border-top-color:Highlight;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f16pcs8n[data-fui-focus-within]:focus-within::after{border-left-color:Highlight;}.fgclinu[data-fui-focus-within]:focus-within::after{border-right-color:Highlight;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.fycbxed[data-fui-focus-within]:focus-within::after{border-bottom-color:Highlight;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.fkc42ay{forced-color-adjust:none;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f1rirnrt{background-color:Highlight;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f1lkg8j3{color:HighlightText;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f1nkj0oa .fui-CardPreview,.f1nkj0oa .fui-CardFooter{forced-color-adjust:auto;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.fey3rwa::after{border-top-color:Highlight;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f5jhx11::after{border-right-color:Highlight;}.fff9uym::after{border-left-color:Highlight;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.fm7n0jy::after{border-bottom-color:Highlight;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.fpfvv3l:hover,.fpfvv3l :active{forced-color-adjust:none;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f1oamsm6:hover,.f1oamsm6 :active{background-color:Highlight;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.f1il21bs:hover,.f1il21bs :active{color:HighlightText;}}",{m:"(forced-colors: active)"}],["@media (forced-colors: active){.fnn5dk0:hover .fui-CardPreview,.fnn5dk0 :active .fui-CardPreview,.fnn5dk0:hover .fui-CardFooter,.fnn5dk0 :active .fui-CardFooter{forced-color-adjust:auto;}}",{m:"(forced-colors: active)"}]],h:[".feu1g3u:hover{color:var(--colorNeutralForeground1Hover);}",".f1knas48:hover{background-color:var(--colorNeutralBackground1Hover);}",".f1m145df:hover{box-shadow:var(--shadow8);}",".fx9teim:hover{color:var(--colorNeutralForeground1Selected);}",".f1kz6goq:hover{background-color:var(--colorNeutralBackground1Selected);}",".fnwyq0v:hover{color:var(--colorNeutralForeground2Hover);}",".f1uvynv3:hover{background-color:var(--colorNeutralBackground2Hover);}",".f1luvkty:hover{color:var(--colorNeutralForeground2Selected);}",".fehi0vp:hover{background-color:var(--colorNeutralBackground2Selected);}",".fjxutwb:hover{background-color:var(--colorTransparentBackgroundHover);}",".f1llr77y:hover::after{border-top-color:var(--colorNeutralStroke1Hover);}",".fzk0khw:hover::after{border-right-color:var(--colorNeutralStroke1Hover);}",".fjj8tog:hover::after{border-left-color:var(--colorNeutralStroke1Hover);}",".fb1u8ub:hover::after{border-bottom-color:var(--colorNeutralStroke1Hover);}",".fg59vm4:hover{background-color:var(--colorTransparentBackgroundSelected);}",".f1t94bn6:hover{background-color:var(--colorSubtleBackgroundHover);}",".f1uqaxdt:hover{background-color:var(--colorSubtleBackgroundSelected);}"],a:[".fb40n2d:active{background-color:var(--colorNeutralBackground1Pressed);}",".f1yhgkbh:active{background-color:var(--colorNeutralBackground2Pressed);}",".fophhak:active{background-color:var(--colorTransparentBackgroundPressed);}",".f1uohb70:active::after{border-top-color:var(--colorNeutralStroke1Pressed);}",".f1jm7v1n:active::after{border-right-color:var(--colorNeutralStroke1Pressed);}",".f1bus3rq:active::after{border-left-color:var(--colorNeutralStroke1Pressed);}",".f1fbu7rr:active::after{border-bottom-color:var(--colorNeutralStroke1Pressed);}",".f1wfn5kd:active{background-color:var(--colorSubtleBackgroundPressed);}"]}),k0t=t=>{"use no memo";const e=I0t(),i=w0t(),r={horizontal:i.orientationHorizontal,vertical:i.orientationVertical},o={small:i.sizeSmall,medium:i.sizeMedium,large:i.sizeLarge},l={filled:i.filled,"filled-alternative":i.filledAlternative,outline:i.outline,subtle:i.subtle},d={filled:i.filledInteractiveSelected,"filled-alternative":i.filledAlternativeInteractiveSelected,outline:i.outlineInteractiveSelected,subtle:i.subtleInteractiveSelected},h={filled:i.filledInteractive,"filled-alternative":i.filledAlternativeInteractive,outline:i.outlineInteractive,subtle:i.subtleInteractive},p=t.interactive||t.selectable,g=$.useMemo(()=>t.selectable?t.selectFocused?i.selectableFocused:"":i.focused,[t.selectFocused,t.selectable,i.focused,i.selectableFocused]);return t.root.className=ea(dle.root,e,r[t.orientation],o[t.size],l[t.appearance],p&&i.interactive,p&&h[t.appearance],t.selected&&d[t.appearance],g,p&&i.highContrastInteractive,t.selected&&i.highContrastSelected,t.root.className),t.floatingAction&&(t.floatingAction.className=ea(dle.floatingAction,i.select,t.floatingAction.className)),t.checkbox&&(t.checkbox.className=ea(dle.checkbox,i.hiddenCheckbox,t.checkbox.className)),t};function R0t({selectableA11yProps:t}){return{selectableA11yProps:t}}const ule=$.forwardRef((t,e)=>{const i=y0t(t,e),r=R0t(i);return k0t(i),kh("useCardStyles_unstable")(i),S0t(i,r)});ule.displayName="Card";const M0t=(t,e)=>{const{action:i}=t;return{components:{root:"div",action:"div"},root:Bl(_p("div",{ref:e,...t}),{elementType:"div"}),action:Ss(i,{elementType:"div"})}},P0t=t=>(Pd(t),Uf(t.root,{children:[t.root.children,t.action&&yr(t.action,{})]})),OMe=$.forwardRef((t,e)=>{const i=M0t(t,e);return A0t(i),kh("useCardFooterStyles_unstable")(i),P0t(i)});OMe.displayName="CardFooter";function D0t(t){function e(i){return $.isValidElement(i)&&!!i.props.id}return $.Children.toArray(t).find(e)}function L0t(t,e,i){return t||(e?.props.id?e.props.id:i)}const O0t=(t,e)=>{const{image:i,header:r,description:o,action:l}=t,{selectableA11yProps:{referenceId:d,setReferenceId:h}}=m0t(),p=$.useRef(null),g=$.useRef(!1),f=NL(DMe.header,d),y=Ss(r,{renderByDefault:!0,defaultProps:{ref:p,id:g.current?void 0:d},elementType:"div"});return $.useEffect(()=>{var T;const C=g.current||(T=p.current)===null||T===void 0?void 0:T.id,E=D0t(y?.children);g.current=!!E,h(L0t(C,E,f))},[f,r,y,h]),{components:{root:"div",image:"div",header:"div",description:"div",action:"div"},root:Bl(_p("div",{ref:e,...t}),{elementType:"div"}),image:Ss(i,{elementType:"div"}),header:y,description:Ss(o,{elementType:"div"}),action:Ss(l,{elementType:"div"})}},N0t=t=>(Pd(t),Uf(t.root,{children:[t.image&&yr(t.image,{}),t.header&&yr(t.header,{}),t.description&&yr(t.description,{}),t.action&&yr(t.action,{})]})),NMe=$.forwardRef((t,e)=>{const i=O0t(t,e);return _0t(i),kh("useCardHeaderStyles_unstable")(i),N0t(i)});NMe.displayName="CardHeader";function x0t(t){switch(t){case"info":return $.createElement(aSt,null);case"warning":return $.createElement(cSt,null);case"error":return $.createElement(iSt,null);case"success":return $.createElement(Yyt,null);default:return null}}function B0t(t=!1){const{targetDocument:e}=Ov(),i=$.useReducer(()=>({}),{})[1],r=$.useRef(!1),o=$.useRef(null),l=$.useRef(-1),d=$.useCallback(p=>{var g,f;process.env.NODE_ENV!=="production"&&p.length>1&&console.error(["useMessageBarReflow: Resize observer should only have one entry. ","If multiple entries are observed, the first entry will be used.","This is a bug, please report it to the Fluent UI team."].join(" "));const y=p[0];var T;const C=(T=y==null||(f=y.borderBoxSize)===null||f===void 0||(g=f[0])===null||g===void 0?void 0:g.inlineSize)!==null&&T!==void 0?T:y?.target.getBoundingClientRect().width;if(C===void 0||!y)return;const{target:E}=y;if(!yA(E))return;let I;if(r.current)l.current<C&&(I=!1);else{const w=E.scrollWidth;C<w&&(I=!0)}l.current=C,typeof I<"u"&&r.current!==I&&(r.current=I,i())},[i]),h=$.useCallback(p=>{var g;if(!t||!p||!e?.defaultView)return;(g=o.current)===null||g===void 0||g.disconnect();const f=e.defaultView,y=new f.ResizeObserver(d);o.current=y,y.observe(p,{box:"border-box"})},[e,d,t]);return $.useEffect(()=>()=>{var p;(p=o.current)===null||p===void 0||p.disconnect()},[]),{ref:h,reflowing:r.current}}const xMe=$.createContext(void 0),F0t={className:"",nodeRef:$.createRef()},U0t=xMe.Provider,z0t=()=>{var t;return(t=$.useContext(xMe))!==null&&t!==void 0?t:F0t},V0t=(t,e)=>{const{layout:i="auto",intent:r="info",politeness:o,shape:l="rounded"}=t,d=o??r==="info"?"polite":"assertive",h=i==="auto",{ref:p,reflowing:g}=B0t(h),f=h?g?"multiline":"singleline":i,{className:y,nodeRef:T}=z0t(),C=$.useRef(null),E=$.useRef(null),{announce:I}=Umt(),w=NL();return $.useEffect(()=>{var D,F;const x=(D=E.current)===null||D===void 0?void 0:D.textContent,B=(F=C.current)===null||F===void 0?void 0:F.textContent,L=[x,B].filter(Boolean).join(",");I(L,{polite:d==="polite",alert:d==="assertive"})},[E,C,I,d]),{components:{root:"div",icon:"div",bottomReflowSpacer:"div"},root:Bl(_p("div",{ref:kC(e,p,T),role:"group","aria-labelledby":w,...t}),{elementType:"div"}),icon:Ss(t.icon,{renderByDefault:!0,elementType:"div",defaultProps:{children:x0t(r)}}),bottomReflowSpacer:Ss(t.bottomReflowSpacer,{renderByDefault:f==="multiline",elementType:"div"}),layout:f,intent:r,transitionClassName:y,actionsRef:C,bodyRef:E,titleId:w,shape:l}},BMe=$.createContext(void 0),$0t={titleId:"",layout:"singleline",actionsRef:$.createRef(),bodyRef:$.createRef()},H0t=BMe.Provider,hle=()=>{var t;return(t=$.useContext(BMe))!==null&&t!==void 0?t:$0t},j0t=(t,e)=>(Pd(t),yr(H0t,{value:e.messageBar,children:Uf(t.root,{children:[t.icon&&yr(t.icon,{}),t.root.children,t.bottomReflowSpacer&&yr(t.bottomReflowSpacer,{})]})})),ple={root:"fui-MessageBar",icon:"fui-MessageBar__icon",bottomReflowSpacer:"fui-MessageBar__bottomReflowSpacer"},G0t=pd("r2oyxsj","r1wuyrhw",['.r2oyxsj{white-space:nowrap;display:grid;grid-template-columns:auto 1fr auto auto;grid-template-rows:1fr;grid-template-areas:"icon body secondaryActions actions";padding-left:var(--spacingHorizontalM);border:var(--strokeWidthThin) solid var(--colorNeutralStroke1);border-radius:var(--borderRadiusMedium);align-items:center;min-height:36px;box-sizing:border-box;background-color:var(--colorNeutralBackground3);}','.r1wuyrhw{white-space:nowrap;display:grid;grid-template-columns:auto 1fr auto auto;grid-template-rows:1fr;grid-template-areas:"icon body secondaryActions actions";padding-right:var(--spacingHorizontalM);border:var(--strokeWidthThin) solid var(--colorNeutralStroke1);border-radius:var(--borderRadiusMedium);align-items:center;min-height:36px;box-sizing:border-box;background-color:var(--colorNeutralBackground3);}']),q0t=pd("r1df1z33","rivnfjc",[".r1df1z33{grid-area:icon;font-size:var(--fontSizeBase500);margin-right:var(--spacingHorizontalS);color:var(--colorNeutralForeground3);display:flex;align-items:center;}",".rivnfjc{grid-area:icon;font-size:var(--fontSizeBase500);margin-left:var(--spacingHorizontalS);color:var(--colorNeutralForeground3);display:flex;align-items:center;}"]),W0t=pd("r1vx593n",null,[".r1vx593n{margin-bottom:var(--spacingVerticalS);grid-area:secondaryActions;}"]),K0t=uo({rootMultiline:{Huce71:"f6juhto",Bt984gj:"f1s2louj",z8tnut:"f1ngh7ph",Budl1dq:"f17g0uqy",zoa1oz:"f1w7oly7"},secondaryActionsMultiline:{Brf1p80:"f1e8xxv9",B6of3ja:"f1gaxbfw",jrapky:"fqcjy3b",t21cq0:["fibjyge","f9yszdx"]},square:{Beyfa6y:0,Bbmb7ep:0,Btl43ni:0,B7oj6ja:0,Dimara:"fokr779"}},{d:[".f6juhto{white-space:normal;}",".f1s2louj{align-items:start;}",".f1ngh7ph{padding-top:var(--spacingVerticalMNudge);}",".f17g0uqy{grid-template-columns:auto 1fr auto;}",'.f1w7oly7{grid-template-areas:"icon body actions" "secondaryActions secondaryActions secondaryActions";}',".f1e8xxv9{justify-content:end;}",".f1gaxbfw{margin-top:var(--spacingVerticalMNudge);}",".fqcjy3b{margin-bottom:var(--spacingVerticalS);}",".fibjyge{margin-right:0px;}",".f9yszdx{margin-left:0px;}",[".fokr779{border-radius:0;}",{p:-1}]]}),J0t=uo({info:{},error:{sj55zd:"f1ca9wz"},warning:{sj55zd:"f14a4cve"},success:{sj55zd:"f36rra6"}},{d:[".f1ca9wz{color:var(--colorStatusDangerForeground1);}",".f14a4cve{color:var(--colorStatusWarningForeground3);}",".f36rra6{color:var(--colorStatusSuccessForeground1);}"]}),Y0t=uo({info:{},error:{De3pzq:"f1eon7jj",g2u3we:"f1f8dvr7",h3c5rm:["f1g1ijmo","f1nxacbt"],B9xav0g:"fo25q1j",zhjwy3:["f1nxacbt","f1g1ijmo"]},warning:{De3pzq:"f13ftzij",g2u3we:"frd1ypx",h3c5rm:["f1gyjrma","f18qd5xz"],B9xav0g:"fqyqtrt",zhjwy3:["f18qd5xz","f1gyjrma"]},success:{De3pzq:"f64thcm",g2u3we:"f1b4u7v",h3c5rm:["f1nyd2b1","f70v3om"],B9xav0g:"fk173vo",zhjwy3:["f70v3om","f1nyd2b1"]}},{d:[".f1eon7jj{background-color:var(--colorStatusDangerBackground1);}",".f1f8dvr7{border-top-color:var(--colorStatusDangerBorder1);}",".f1g1ijmo{border-right-color:var(--colorStatusDangerBorder1);}",".f1nxacbt{border-left-color:var(--colorStatusDangerBorder1);}",".fo25q1j{border-bottom-color:var(--colorStatusDangerBorder1);}",".f13ftzij{background-color:var(--colorStatusWarningBackground1);}",".frd1ypx{border-top-color:var(--colorStatusWarningBorder1);}",".f1gyjrma{border-right-color:var(--colorStatusWarningBorder1);}",".f18qd5xz{border-left-color:var(--colorStatusWarningBorder1);}",".fqyqtrt{border-bottom-color:var(--colorStatusWarningBorder1);}",".f64thcm{background-color:var(--colorStatusSuccessBackground1);}",".f1b4u7v{border-top-color:var(--colorStatusSuccessBorder1);}",".f1nyd2b1{border-right-color:var(--colorStatusSuccessBorder1);}",".f70v3om{border-left-color:var(--colorStatusSuccessBorder1);}",".fk173vo{border-bottom-color:var(--colorStatusSuccessBorder1);}"]}),Q0t=t=>{"use no memo";const e=G0t(),i=q0t(),r=J0t(),o=Y0t(),l=W0t(),d=K0t();return t.root.className=ea(ple.root,e,t.layout==="multiline"&&d.rootMultiline,t.shape==="square"&&d.square,o[t.intent],t.transitionClassName,t.root.className),t.icon&&(t.icon.className=ea(ple.icon,i,r[t.intent],t.icon.className)),t.bottomReflowSpacer&&(t.bottomReflowSpacer.className=ea(ple.bottomReflowSpacer,l)),t};function Z0t(t){const{layout:e,actionsRef:i,bodyRef:r,titleId:o}=t;return{messageBar:$.useMemo(()=>({layout:e,actionsRef:i,bodyRef:r,titleId:o}),[e,i,r,o])}}const FMe=$.forwardRef((t,e)=>{const i=V0t(t,e);return Q0t(i),kh("useMessageBarStyles_unstable")(i),j0t(i,Z0t(i))});FMe.displayName="MessageBar";const X0t=(t,e)=>{const{titleId:i}=hle();return{components:{root:"span"},root:Bl(_p("span",{ref:e,id:i,...t}),{elementType:"span"})}},eAt=t=>(Pd(t),yr(t.root,{})),tAt={root:"fui-MessageBarTitle"},iAt=pd("r168xkm9",null,[".r168xkm9{font-family:var(--fontFamilyBase);font-size:var(--fontSizeBase300);font-weight:var(--fontWeightSemibold);line-height:var(--lineHeightBase300);}",'.r168xkm9::after{content:" ";}']),nAt=t=>{"use no memo";const e=iAt();return t.root.className=ea(tAt.root,e,t.root.className),t},UMe=$.forwardRef((t,e)=>{const i=X0t(t,e);return nAt(i),kh("useMessageBarTitleStyles_unstable")(i),eAt(i)});UMe.displayName="MessageBarTitle";const aAt=(t,e)=>{const{layout:i="singleline",actionsRef:r}=hle();return{components:{root:"div",containerAction:"div"},containerAction:Ss(t.containerAction,{renderByDefault:!1,elementType:"div"}),root:Bl(_p("div",{ref:kC(e,r),...t}),{elementType:"div"}),layout:i,hasActions:!!t.children}},rAt=(t,e)=>(Pd(t),t.layout==="multiline"?Uf(ZRe,{value:e.button,children:[t.containerAction&&yr(t.containerAction,{}),yr(t.root,{})]}):Uf(ZRe,{value:e.button,children:[yr(t.root,{}),t.containerAction&&yr(t.containerAction,{})]})),zMe={root:"fui-MessageBarActions",containerAction:"fui-MessageBarActions__containerAction"},oAt=pd("r1t4x98y","r15utzv5",[".r1t4x98y{grid-area:secondaryActions;display:flex;column-gap:var(--spacingHorizontalM);padding-right:var(--spacingHorizontalM);}",".r15utzv5{grid-area:secondaryActions;display:flex;column-gap:var(--spacingHorizontalM);padding-left:var(--spacingHorizontalM);}"]),sAt=pd("rgzw8nq","r13ur29z",[".rgzw8nq{grid-area:actions;padding-right:var(--spacingHorizontalM);}",".r13ur29z{grid-area:actions;padding-left:var(--spacingHorizontalM);}"]),lAt=uo({root:{Brf1p80:"f1e8xxv9",B6of3ja:"f1gaxbfw",jrapky:"fqcjy3b",t21cq0:["fibjyge","f9yszdx"],z189sj:["f1p3vkop","f8cewkv"]},noActions:{mc9l5x:"fjseox"}},{d:[".f1e8xxv9{justify-content:end;}",".f1gaxbfw{margin-top:var(--spacingVerticalMNudge);}",".fqcjy3b{margin-bottom:var(--spacingVerticalS);}",".fibjyge{margin-right:0px;}",".f9yszdx{margin-left:0px;}",".f1p3vkop{padding-right:var(--spacingVerticalM);}",".f8cewkv{padding-left:var(--spacingVerticalM);}",".fjseox{display:none;}"]}),cAt=t=>{"use no memo";const e=oAt(),i=sAt(),r=lAt();return t.root.className=ea(zMe.root,e,t.layout==="multiline"&&r.root,!t.hasActions&&r.noActions,t.root.className),t.containerAction&&(t.containerAction.className=ea(zMe.containerAction,i,t.containerAction.className)),t};function dAt(){return{button:$.useMemo(()=>({size:"small"}),[])}}const VMe=$.forwardRef((t,e)=>{const i=aAt(t,e);return cAt(i),kh("useMessageBarActionsStyles_unstable")(i),rAt(i,dAt())});VMe.displayName="MessageBarActions";const uAt=(t,e)=>{const{bodyRef:i}=hle();return{components:{root:"div"},root:Bl(_p("div",{ref:kC(e,i),...t}),{elementType:"div"})}},hAt=(t,e)=>(Pd(t),yr(a_t,{value:e.link,children:yr(t.root,{})})),pAt={root:"fui-MessageBarBody"},gAt=pd("rtatq2b","re2rary",[".rtatq2b{font-family:var(--fontFamilyBase);font-size:var(--fontSizeBase300);font-weight:var(--fontWeightRegular);line-height:var(--lineHeightBase300);grid-area:body;padding-right:var(--spacingHorizontalM);}",".re2rary{font-family:var(--fontFamilyBase);font-size:var(--fontSizeBase300);font-weight:var(--fontWeightRegular);line-height:var(--lineHeightBase300);grid-area:body;padding-left:var(--spacingHorizontalM);}"]),mAt=t=>{"use no memo";const e=gAt();return t.root.className=ea(pAt.root,e,t.root.className),t};function fAt(t){return{link:$.useMemo(()=>({inline:!0}),[])}}const $Me=$.forwardRef((t,e)=>{const i=uAt(t,e),r=fAt();return mAt(i),kh("useMessageBarBodyStyles_unstable")(i),hAt(i,r)});$Me.displayName="MessageBarBody";const vAt=(t,e)=>{process.env.NODE_ENV!=="production"&&$.Children.forEach(t.children,l=>{if(!$.isValidElement(l)||l.type===$.Fragment)throw new Error("MessageBarGroup: children must be valid MessageBar components. Please ensure you're not using fragments. ")});var i;const r=$.Children.map((i=t.children)!==null&&i!==void 0?i:[],l=>$.isValidElement(l)&&l.type!==$.Fragment?l:null).filter(Boolean);var o;return{components:{root:"div"},root:Bl(_p("div",{ref:e,...t}),{elementType:"div"}),children:r,animate:(o=t.animate)!==null&&o!==void 0?o:"exit-only",enterStyles:"",exitStyles:""}};function gle(){return gle=Object.assign?Object.assign.bind():function(t){for(var e=1;e<arguments.length;e++){var i=arguments[e];for(var r in i)({}).hasOwnProperty.call(i,r)&&(t[r]=i[r])}return t},gle.apply(null,arguments)}function HMe(t,e){if(t==null)return{};var i={};for(var r in t)if({}.hasOwnProperty.call(t,r)){if(e.indexOf(r)!==-1)continue;i[r]=t[r]}return i}function mle(t,e){return mle=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(i,r){return i.__proto__=r,i},mle(t,e)}function jMe(t,e){t.prototype=Object.create(e.prototype),t.prototype.constructor=t,mle(t,e)}var AK={exports:{}},IK={exports:{}},gd={};/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */var GMe;function yAt(){if(GMe)return gd;GMe=1;var t=typeof Symbol=="function"&&Symbol.for,e=t?Symbol.for("react.element"):60103,i=t?Symbol.for("react.portal"):60106,r=t?Symbol.for("react.fragment"):60107,o=t?Symbol.for("react.strict_mode"):60108,l=t?Symbol.for("react.profiler"):60114,d=t?Symbol.for("react.provider"):60109,h=t?Symbol.for("react.context"):60110,p=t?Symbol.for("react.async_mode"):60111,g=t?Symbol.for("react.concurrent_mode"):60111,f=t?Symbol.for("react.forward_ref"):60112,y=t?Symbol.for("react.suspense"):60113,T=t?Symbol.for("react.suspense_list"):60120,C=t?Symbol.for("react.memo"):60115,E=t?Symbol.for("react.lazy"):60116,I=t?Symbol.for("react.block"):60121,w=t?Symbol.for("react.fundamental"):60117,D=t?Symbol.for("react.responder"):60118,F=t?Symbol.for("react.scope"):60119;function x(L){if(typeof L=="object"&&L!==null){var z=L.$$typeof;switch(z){case e:switch(L=L.type,L){case p:case g:case r:case l:case o:case y:return L;default:switch(L=L&&L.$$typeof,L){case h:case f:case E:case C:case d:return L;default:return z}}case i:return z}}}function B(L){return x(L)===g}return gd.AsyncMode=p,gd.ConcurrentMode=g,gd.ContextConsumer=h,gd.ContextProvider=d,gd.Element=e,gd.ForwardRef=f,gd.Fragment=r,gd.Lazy=E,gd.Memo=C,gd.Portal=i,gd.Profiler=l,gd.StrictMode=o,gd.Suspense=y,gd.isAsyncMode=function(L){return B(L)||x(L)===p},gd.isConcurrentMode=B,gd.isContextConsumer=function(L){return x(L)===h},gd.isContextProvider=function(L){return x(L)===d},gd.isElement=function(L){return typeof L=="object"&&L!==null&&L.$$typeof===e},gd.isForwardRef=function(L){return x(L)===f},gd.isFragment=function(L){return x(L)===r},gd.isLazy=function(L){return x(L)===E},gd.isMemo=function(L){return x(L)===C},gd.isPortal=function(L){return x(L)===i},gd.isProfiler=function(L){return x(L)===l},gd.isStrictMode=function(L){return x(L)===o},gd.isSuspense=function(L){return x(L)===y},gd.isValidElementType=function(L){return typeof L=="string"||typeof L=="function"||L===r||L===g||L===l||L===o||L===y||L===T||typeof L=="object"&&L!==null&&(L.$$typeof===E||L.$$typeof===C||L.$$typeof===d||L.$$typeof===h||L.$$typeof===f||L.$$typeof===w||L.$$typeof===D||L.$$typeof===F||L.$$typeof===I)},gd.typeOf=x,gd}var md={};/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */var qMe;function SAt(){return qMe||(qMe=1,process.env.NODE_ENV!=="production"&&function(){var t=typeof Symbol=="function"&&Symbol.for,e=t?Symbol.for("react.element"):60103,i=t?Symbol.for("react.portal"):60106,r=t?Symbol.for("react.fragment"):60107,o=t?Symbol.for("react.strict_mode"):60108,l=t?Symbol.for("react.profiler"):60114,d=t?Symbol.for("react.provider"):60109,h=t?Symbol.for("react.context"):60110,p=t?Symbol.for("react.async_mode"):60111,g=t?Symbol.for("react.concurrent_mode"):60111,f=t?Symbol.for("react.forward_ref"):60112,y=t?Symbol.for("react.suspense"):60113,T=t?Symbol.for("react.suspense_list"):60120,C=t?Symbol.for("react.memo"):60115,E=t?Symbol.for("react.lazy"):60116,I=t?Symbol.for("react.block"):60121,w=t?Symbol.for("react.fundamental"):60117,D=t?Symbol.for("react.responder"):60118,F=t?Symbol.for("react.scope"):60119;function x(Pt){return typeof Pt=="string"||typeof Pt=="function"||Pt===r||Pt===g||Pt===l||Pt===o||Pt===y||Pt===T||typeof Pt=="object"&&Pt!==null&&(Pt.$$typeof===E||Pt.$$typeof===C||Pt.$$typeof===d||Pt.$$typeof===h||Pt.$$typeof===f||Pt.$$typeof===w||Pt.$$typeof===D||Pt.$$typeof===F||Pt.$$typeof===I)}function B(Pt){if(typeof Pt=="object"&&Pt!==null){var ni=Pt.$$typeof;switch(ni){case e:var Zt=Pt.type;switch(Zt){case p:case g:case r:case l:case o:case y:return Zt;default:var it=Zt&&Zt.$$typeof;switch(it){case h:case f:case E:case C:case d:return it;default:return ni}}case i:return ni}}}var L=p,z=g,H=h,j=d,J=e,Z=f,re=r,ne=E,le=C,he=i,Me=l,Le=o,pe=y,te=!1;function Se(Pt){return te||(te=!0,console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")),ce(Pt)||B(Pt)===p}function ce(Pt){return B(Pt)===g}function X(Pt){return B(Pt)===h}function ve(Pt){return B(Pt)===d}function Te(Pt){return typeof Pt=="object"&&Pt!==null&&Pt.$$typeof===e}function Be(Pt){return B(Pt)===f}function qe(Pt){return B(Pt)===r}function Ge(Pt){return B(Pt)===E}function tt(Pt){return B(Pt)===C}function ct(Pt){return B(Pt)===i}function Mt(Pt){return B(Pt)===l}function ht(Pt){return B(Pt)===o}function vt(Pt){return B(Pt)===y}md.AsyncMode=L,md.ConcurrentMode=z,md.ContextConsumer=H,md.ContextProvider=j,md.Element=J,md.ForwardRef=Z,md.Fragment=re,md.Lazy=ne,md.Memo=le,md.Portal=he,md.Profiler=Me,md.StrictMode=Le,md.Suspense=pe,md.isAsyncMode=Se,md.isConcurrentMode=ce,md.isContextConsumer=X,md.isContextProvider=ve,md.isElement=Te,md.isForwardRef=Be,md.isFragment=qe,md.isLazy=Ge,md.isMemo=tt,md.isPortal=ct,md.isProfiler=Mt,md.isStrictMode=ht,md.isSuspense=vt,md.isValidElementType=x,md.typeOf=B}()),md}var WMe;function KMe(){return WMe||(WMe=1,process.env.NODE_ENV==="production"?IK.exports=yAt():IK.exports=SAt()),IK.exports}/*
object-assign
(c) Sindre Sorhus
@license MIT
*/var fle,JMe;function bAt(){if(JMe)return fle;JMe=1;var t=Object.getOwnPropertySymbols,e=Object.prototype.hasOwnProperty,i=Object.prototype.propertyIsEnumerable;function r(l){if(l==null)throw new TypeError("Object.assign cannot be called with null or undefined");return Object(l)}function o(){try{if(!Object.assign)return!1;var l=new String("abc");if(l[5]="de",Object.getOwnPropertyNames(l)[0]==="5")return!1;for(var d={},h=0;h<10;h++)d["_"+String.fromCharCode(h)]=h;var p=Object.getOwnPropertyNames(d).map(function(f){return d[f]});if(p.join("")!=="0123456789")return!1;var g={};return"abcdefghijklmnopqrst".split("").forEach(function(f){g[f]=f}),Object.keys(Object.assign({},g)).join("")==="abcdefghijklmnopqrst"}catch{return!1}}return fle=o()?Object.assign:function(l,d){for(var h,p=r(l),g,f=1;f<arguments.length;f++){h=Object(arguments[f]);for(var y in h)e.call(h,y)&&(p[y]=h[y]);if(t){g=t(h);for(var T=0;T<g.length;T++)i.call(h,g[T])&&(p[g[T]]=h[g[T]])}}return p},fle}var vle,YMe;function yle(){if(YMe)return vle;YMe=1;var t="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";return vle=t,vle}var Sle,QMe;function ZMe(){return QMe||(QMe=1,Sle=Function.call.bind(Object.prototype.hasOwnProperty)),Sle}var ble,XMe;function TAt(){if(XMe)return ble;XMe=1;var t=function(){};if(process.env.NODE_ENV!=="production"){var e=yle(),i={},r=ZMe();t=function(l){var d="Warning: "+l;typeof console<"u"&&console.error(d);try{throw new Error(d)}catch{}}}function o(l,d,h,p,g){if(process.env.NODE_ENV!=="production"){for(var f in l)if(r(l,f)){var y;try{if(typeof l[f]!="function"){var T=Error((p||"React class")+": "+h+" type `"+f+"` is invalid; it must be a function, usually from the `prop-types` package, but received `"+typeof l[f]+"`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");throw T.name="Invariant Violation",T}y=l[f](d,f,p,h,null,e)}catch(E){y=E}if(y&&!(y instanceof Error)&&t((p||"React class")+": type specification of "+h+" `"+f+"` is invalid; the type checker function must return `null` or an `Error` but returned a "+typeof y+". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."),y instanceof Error&&!(y.message in i)){i[y.message]=!0;var C=g?g():"";t("Failed "+h+" type: "+y.message+(C??""))}}}}return o.resetWarningCache=function(){process.env.NODE_ENV!=="production"&&(i={})},ble=o,ble}var Tle,ePe;function CAt(){if(ePe)return Tle;ePe=1;var t=KMe(),e=bAt(),i=yle(),r=ZMe(),o=TAt(),l=function(){};process.env.NODE_ENV!=="production"&&(l=function(h){var p="Warning: "+h;typeof console<"u"&&console.error(p);try{throw new Error(p)}catch{}});function d(){return null}return Tle=function(h,p){var g=typeof Symbol=="function"&&Symbol.iterator,f="@@iterator";function y(ce){var X=ce&&(g&&ce[g]||ce[f]);if(typeof X=="function")return X}var T="<<anonymous>>",C={array:D("array"),bigint:D("bigint"),bool:D("boolean"),func:D("function"),number:D("number"),object:D("object"),string:D("string"),symbol:D("symbol"),any:F(),arrayOf:x,element:B(),elementType:L(),instanceOf:z,node:Z(),objectOf:j,oneOf:H,oneOfType:J,shape:ne,exact:le};function E(ce,X){return ce===X?ce!==0||1/ce===1/X:ce!==ce&&X!==X}function I(ce,X){this.message=ce,this.data=X&&typeof X=="object"?X:{},this.stack=""}I.prototype=Error.prototype;function w(ce){if(process.env.NODE_ENV!=="production")var X={},ve=0;function Te(qe,Ge,tt,ct,Mt,ht,vt){if(ct=ct||T,ht=ht||tt,vt!==i){if(p){var Pt=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");throw Pt.name="Invariant Violation",Pt}else if(process.env.NODE_ENV!=="production"&&typeof console<"u"){var ni=ct+":"+tt;!X[ni]&&ve<3&&(l("You are manually calling a React.PropTypes validation function for the `"+ht+"` prop on `"+ct+"`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."),X[ni]=!0,ve++)}}return Ge[tt]==null?qe?Ge[tt]===null?new I("The "+Mt+" `"+ht+"` is marked as required "+("in `"+ct+"`, but its value is `null`.")):new I("The "+Mt+" `"+ht+"` is marked as required in "+("`"+ct+"`, but its value is `undefined`.")):null:ce(Ge,tt,ct,Mt,ht)}var Be=Te.bind(null,!1);return Be.isRequired=Te.bind(null,!0),Be}function D(ce){function X(ve,Te,Be,qe,Ge,tt){var ct=ve[Te],Mt=Le(ct);if(Mt!==ce){var ht=pe(ct);return new I("Invalid "+qe+" `"+Ge+"` of type "+("`"+ht+"` supplied to `"+Be+"`, expected ")+("`"+ce+"`."),{expectedType:ce})}return null}return w(X)}function F(){return w(d)}function x(ce){function X(ve,Te,Be,qe,Ge){if(typeof ce!="function")return new I("Property `"+Ge+"` of component `"+Be+"` has invalid PropType notation inside arrayOf.");var tt=ve[Te];if(!Array.isArray(tt)){var ct=Le(tt);return new I("Invalid "+qe+" `"+Ge+"` of type "+("`"+ct+"` supplied to `"+Be+"`, expected an array."))}for(var Mt=0;Mt<tt.length;Mt++){var ht=ce(tt,Mt,Be,qe,Ge+"["+Mt+"]",i);if(ht instanceof Error)return ht}return null}return w(X)}function B(){function ce(X,ve,Te,Be,qe){var Ge=X[ve];if(!h(Ge)){var tt=Le(Ge);return new I("Invalid "+Be+" `"+qe+"` of type "+("`"+tt+"` supplied to `"+Te+"`, expected a single ReactElement."))}return null}return w(ce)}function L(){function ce(X,ve,Te,Be,qe){var Ge=X[ve];if(!t.isValidElementType(Ge)){var tt=Le(Ge);return new I("Invalid "+Be+" `"+qe+"` of type "+("`"+tt+"` supplied to `"+Te+"`, expected a single ReactElement type."))}return null}return w(ce)}function z(ce){function X(ve,Te,Be,qe,Ge){if(!(ve[Te]instanceof ce)){var tt=ce.name||T,ct=Se(ve[Te]);return new I("Invalid "+qe+" `"+Ge+"` of type "+("`"+ct+"` supplied to `"+Be+"`, expected ")+("instance of `"+tt+"`."))}return null}return w(X)}function H(ce){if(!Array.isArray(ce))return process.env.NODE_ENV!=="production"&&(arguments.length>1?l("Invalid arguments supplied to oneOf, expected an array, got "+arguments.length+" arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."):l("Invalid argument supplied to oneOf, expected an array.")),d;function X(ve,Te,Be,qe,Ge){for(var tt=ve[Te],ct=0;ct<ce.length;ct++)if(E(tt,ce[ct]))return null;var Mt=JSON.stringify(ce,function(vt,Pt){var ni=pe(Pt);return ni==="symbol"?String(Pt):Pt});return new I("Invalid "+qe+" `"+Ge+"` of value `"+String(tt)+"` "+("supplied to `"+Be+"`, expected one of "+Mt+"."))}return w(X)}function j(ce){function X(ve,Te,Be,qe,Ge){if(typeof ce!="function")return new I("Property `"+Ge+"` of component `"+Be+"` has invalid PropType notation inside objectOf.");var tt=ve[Te],ct=Le(tt);if(ct!=="object")return new I("Invalid "+qe+" `"+Ge+"` of type "+("`"+ct+"` supplied to `"+Be+"`, expected an object."));for(var Mt in tt)if(r(tt,Mt)){var ht=ce(tt,Mt,Be,qe,Ge+"."+Mt,i);if(ht instanceof Error)return ht}return null}return w(X)}function J(ce){if(!Array.isArray(ce))return process.env.NODE_ENV!=="production"&&l("Invalid argument supplied to oneOfType, expected an instance of array."),d;for(var X=0;X<ce.length;X++){var ve=ce[X];if(typeof ve!="function")return l("Invalid argument supplied to oneOfType. Expected an array of check functions, but received "+te(ve)+" at index "+X+"."),d}function Te(Be,qe,Ge,tt,ct){for(var Mt=[],ht=0;ht<ce.length;ht++){var vt=ce[ht],Pt=vt(Be,qe,Ge,tt,ct,i);if(Pt==null)return null;Pt.data&&r(Pt.data,"expectedType")&&Mt.push(Pt.data.expectedType)}var ni=Mt.length>0?", expected one of type ["+Mt.join(", ")+"]":"";return new I("Invalid "+tt+" `"+ct+"` supplied to "+("`"+Ge+"`"+ni+"."))}return w(Te)}function Z(){function ce(X,ve,Te,Be,qe){return he(X[ve])?null:new I("Invalid "+Be+" `"+qe+"` supplied to "+("`"+Te+"`, expected a ReactNode."))}return w(ce)}function re(ce,X,ve,Te,Be){return new I((ce||"React class")+": "+X+" type `"+ve+"."+Te+"` is invalid; it must be a function, usually from the `prop-types` package, but received `"+Be+"`.")}function ne(ce){function X(ve,Te,Be,qe,Ge){var tt=ve[Te],ct=Le(tt);if(ct!=="object")return new I("Invalid "+qe+" `"+Ge+"` of type `"+ct+"` "+("supplied to `"+Be+"`, expected `object`."));for(var Mt in ce){var ht=ce[Mt];if(typeof ht!="function")return re(Be,qe,Ge,Mt,pe(ht));var vt=ht(tt,Mt,Be,qe,Ge+"."+Mt,i);if(vt)return vt}return null}return w(X)}function le(ce){function X(ve,Te,Be,qe,Ge){var tt=ve[Te],ct=Le(tt);if(ct!=="object")return new I("Invalid "+qe+" `"+Ge+"` of type `"+ct+"` "+("supplied to `"+Be+"`, expected `object`."));var Mt=e({},ve[Te],ce);for(var ht in Mt){var vt=ce[ht];if(r(ce,ht)&&typeof vt!="function")return re(Be,qe,Ge,ht,pe(vt));if(!vt)return new I("Invalid "+qe+" `"+Ge+"` key `"+ht+"` supplied to `"+Be+"`.\nBad object: "+JSON.stringify(ve[Te],null,"  ")+`
Valid keys: `+JSON.stringify(Object.keys(ce),null,"  "));var Pt=vt(tt,ht,Be,qe,Ge+"."+ht,i);if(Pt)return Pt}return null}return w(X)}function he(ce){switch(typeof ce){case"number":case"string":case"undefined":return!0;case"boolean":return!ce;case"object":if(Array.isArray(ce))return ce.every(he);if(ce===null||h(ce))return!0;var X=y(ce);if(X){var ve=X.call(ce),Te;if(X!==ce.entries){for(;!(Te=ve.next()).done;)if(!he(Te.value))return!1}else for(;!(Te=ve.next()).done;){var Be=Te.value;if(Be&&!he(Be[1]))return!1}}else return!1;return!0;default:return!1}}function Me(ce,X){return ce==="symbol"?!0:X?X["@@toStringTag"]==="Symbol"||typeof Symbol=="function"&&X instanceof Symbol:!1}function Le(ce){var X=typeof ce;return Array.isArray(ce)?"array":ce instanceof RegExp?"object":Me(X,ce)?"symbol":X}function pe(ce){if(typeof ce>"u"||ce===null)return""+ce;var X=Le(ce);if(X==="object"){if(ce instanceof Date)return"date";if(ce instanceof RegExp)return"regexp"}return X}function te(ce){var X=pe(ce);switch(X){case"array":case"object":return"an "+X;case"boolean":case"date":case"regexp":return"a "+X;default:return X}}function Se(ce){return!ce.constructor||!ce.constructor.name?T:ce.constructor.name}return C.checkPropTypes=o,C.resetWarningCache=o.resetWarningCache,C.PropTypes=C,C},Tle}var Cle,tPe;function _At(){if(tPe)return Cle;tPe=1;var t=yle();function e(){}function i(){}return i.resetWarningCache=e,Cle=function(){function r(d,h,p,g,f,y){if(y!==t){var T=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw T.name="Invariant Violation",T}}r.isRequired=r;function o(){return r}var l={array:r,bigint:r,bool:r,func:r,number:r,object:r,string:r,symbol:r,any:r,arrayOf:o,element:r,elementType:r,instanceOf:o,node:r,objectOf:o,oneOf:o,oneOfType:o,shape:o,exact:o,checkPropTypes:i,resetWarningCache:e};return l.PropTypes=l,l},Cle}var iPe;function EAt(){if(iPe)return AK.exports;if(iPe=1,process.env.NODE_ENV!=="production"){var t=KMe(),e=!0;AK.exports=CAt()(t.isElement,e)}else AK.exports=_At()();return AK.exports}var AAt=EAt();const Fs=cL(AAt),nPe={disabled:!1};var IAt=process.env.NODE_ENV!=="production"?Fs.oneOfType([Fs.number,Fs.shape({enter:Fs.number,exit:Fs.number,appear:Fs.number}).isRequired]):null;process.env.NODE_ENV!=="production"&&Fs.oneOfType([Fs.string,Fs.shape({enter:Fs.string,exit:Fs.string,active:Fs.string}),Fs.shape({enter:Fs.string,enterDone:Fs.string,enterActive:Fs.string,exit:Fs.string,exitDone:Fs.string,exitActive:Fs.string})]);const wK=U.createContext(null);var wAt=function(e){return e.scrollTop},qH="unmounted",Px="exited",Dx="entering",L5="entered",_le="exiting",UM=function(t){jMe(e,t);function e(r,o){var l;l=t.call(this,r,o)||this;var d=o,h=d&&!d.isMounting?r.enter:r.appear,p;return l.appearStatus=null,r.in?h?(p=Px,l.appearStatus=Dx):p=L5:r.unmountOnExit||r.mountOnEnter?p=qH:p=Px,l.state={status:p},l.nextCallback=null,l}e.getDerivedStateFromProps=function(o,l){var d=o.in;return d&&l.status===qH?{status:Px}:null};var i=e.prototype;return i.componentDidMount=function(){this.updateStatus(!0,this.appearStatus)},i.componentDidUpdate=function(o){var l=null;if(o!==this.props){var d=this.state.status;this.props.in?d!==Dx&&d!==L5&&(l=Dx):(d===Dx||d===L5)&&(l=_le)}this.updateStatus(!1,l)},i.componentWillUnmount=function(){this.cancelNextCallback()},i.getTimeouts=function(){var o=this.props.timeout,l,d,h;return l=d=h=o,o!=null&&typeof o!="number"&&(l=o.exit,d=o.enter,h=o.appear!==void 0?o.appear:d),{exit:l,enter:d,appear:h}},i.updateStatus=function(o,l){if(o===void 0&&(o=!1),l!==null)if(this.cancelNextCallback(),l===Dx){if(this.props.unmountOnExit||this.props.mountOnEnter){var d=this.props.nodeRef?this.props.nodeRef.current:rW.findDOMNode(this);d&&wAt(d)}this.performEnter(o)}else this.performExit();else this.props.unmountOnExit&&this.state.status===Px&&this.setState({status:qH})},i.performEnter=function(o){var l=this,d=this.props.enter,h=this.context?this.context.isMounting:o,p=this.props.nodeRef?[h]:[rW.findDOMNode(this),h],g=p[0],f=p[1],y=this.getTimeouts(),T=h?y.appear:y.enter;if(!o&&!d||nPe.disabled){this.safeSetState({status:L5},function(){l.props.onEntered(g)});return}this.props.onEnter(g,f),this.safeSetState({status:Dx},function(){l.props.onEntering(g,f),l.onTransitionEnd(T,function(){l.safeSetState({status:L5},function(){l.props.onEntered(g,f)})})})},i.performExit=function(){var o=this,l=this.props.exit,d=this.getTimeouts(),h=this.props.nodeRef?void 0:rW.findDOMNode(this);if(!l||nPe.disabled){this.safeSetState({status:Px},function(){o.props.onExited(h)});return}this.props.onExit(h),this.safeSetState({status:_le},function(){o.props.onExiting(h),o.onTransitionEnd(d.exit,function(){o.safeSetState({status:Px},function(){o.props.onExited(h)})})})},i.cancelNextCallback=function(){this.nextCallback!==null&&(this.nextCallback.cancel(),this.nextCallback=null)},i.safeSetState=function(o,l){l=this.setNextCallback(l),this.setState(o,l)},i.setNextCallback=function(o){var l=this,d=!0;return this.nextCallback=function(h){d&&(d=!1,l.nextCallback=null,o(h))},this.nextCallback.cancel=function(){d=!1},this.nextCallback},i.onTransitionEnd=function(o,l){this.setNextCallback(l);var d=this.props.nodeRef?this.props.nodeRef.current:rW.findDOMNode(this),h=o==null&&!this.props.addEndListener;if(!d||h){setTimeout(this.nextCallback,0);return}if(this.props.addEndListener){var p=this.props.nodeRef?[this.nextCallback]:[d,this.nextCallback],g=p[0],f=p[1];this.props.addEndListener(g,f)}o!=null&&setTimeout(this.nextCallback,o)},i.render=function(){var o=this.state.status;if(o===qH)return null;var l=this.props,d=l.children;l.in,l.mountOnEnter,l.unmountOnExit,l.appear,l.enter,l.exit,l.timeout,l.addEndListener,l.onEnter,l.onEntering,l.onEntered,l.onExit,l.onExiting,l.onExited,l.nodeRef;var h=HMe(l,["children","in","mountOnEnter","unmountOnExit","appear","enter","exit","timeout","addEndListener","onEnter","onEntering","onEntered","onExit","onExiting","onExited","nodeRef"]);return U.createElement(wK.Provider,{value:null},typeof d=="function"?d(o,h):U.cloneElement(U.Children.only(d),h))},e}(U.Component);UM.contextType=wK,UM.propTypes=process.env.NODE_ENV!=="production"?{nodeRef:Fs.shape({current:typeof Element>"u"?Fs.any:function(t,e,i,r,o,l){var d=t[e];return Fs.instanceOf(d&&"ownerDocument"in d?d.ownerDocument.defaultView.Element:Element)(t,e,i,r,o,l)}}),children:Fs.oneOfType([Fs.func.isRequired,Fs.element.isRequired]).isRequired,in:Fs.bool,mountOnEnter:Fs.bool,unmountOnExit:Fs.bool,appear:Fs.bool,enter:Fs.bool,exit:Fs.bool,timeout:function(e){var i=IAt;e.addEndListener||(i=i.isRequired);for(var r=arguments.length,o=new Array(r>1?r-1:0),l=1;l<r;l++)o[l-1]=arguments[l];return i.apply(void 0,[e].concat(o))},addEndListener:Fs.func,onEnter:Fs.func,onEntering:Fs.func,onEntered:Fs.func,onExit:Fs.func,onExiting:Fs.func,onExited:Fs.func}:{};function O5(){}UM.defaultProps={in:!1,mountOnEnter:!1,unmountOnExit:!1,appear:!1,enter:!0,exit:!0,onEnter:O5,onEntering:O5,onEntered:O5,onExit:O5,onExiting:O5,onExited:O5},UM.UNMOUNTED=qH,UM.EXITED=Px,UM.ENTERING=Dx,UM.ENTERED=L5,UM.EXITING=_le;function kAt(t){if(t===void 0)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function Ele(t,e){var i=function(l){return e&&$.isValidElement(l)?e(l):l},r=Object.create(null);return t&&$.Children.map(t,function(o){return o}).forEach(function(o){r[o.key]=i(o)}),r}function RAt(t,e){t=t||{},e=e||{};function i(f){return f in e?e[f]:t[f]}var r=Object.create(null),o=[];for(var l in t)l in e?o.length&&(r[l]=o,o=[]):o.push(l);var d,h={};for(var p in e){if(r[p])for(d=0;d<r[p].length;d++){var g=r[p][d];h[r[p][d]]=i(g)}h[p]=i(p)}for(d=0;d<o.length;d++)h[o[d]]=i(o[d]);return h}function Lx(t,e,i){return i[e]!=null?i[e]:t.props[e]}function MAt(t,e){return Ele(t.children,function(i){return $.cloneElement(i,{onExited:e.bind(null,i),in:!0,appear:Lx(i,"appear",t),enter:Lx(i,"enter",t),exit:Lx(i,"exit",t)})})}function PAt(t,e,i){var r=Ele(t.children),o=RAt(e,r);return Object.keys(o).forEach(function(l){var d=o[l];if($.isValidElement(d)){var h=l in e,p=l in r,g=e[l],f=$.isValidElement(g)&&!g.props.in;p&&(!h||f)?o[l]=$.cloneElement(d,{onExited:i.bind(null,d),in:!0,exit:Lx(d,"exit",t),enter:Lx(d,"enter",t)}):!p&&h&&!f?o[l]=$.cloneElement(d,{in:!1}):p&&h&&$.isValidElement(g)&&(o[l]=$.cloneElement(d,{onExited:i.bind(null,d),in:g.props.in,exit:Lx(d,"exit",t),enter:Lx(d,"enter",t)}))}}),o}var DAt=Object.values||function(t){return Object.keys(t).map(function(e){return t[e]})},LAt={component:"div",childFactory:function(e){return e}},Ale=function(t){jMe(e,t);function e(r,o){var l;l=t.call(this,r,o)||this;var d=l.handleExited.bind(kAt(l));return l.state={contextValue:{isMounting:!0},handleExited:d,firstRender:!0},l}var i=e.prototype;return i.componentDidMount=function(){this.mounted=!0,this.setState({contextValue:{isMounting:!1}})},i.componentWillUnmount=function(){this.mounted=!1},e.getDerivedStateFromProps=function(o,l){var d=l.children,h=l.handleExited,p=l.firstRender;return{children:p?MAt(o,h):PAt(o,d,h),firstRender:!1}},i.handleExited=function(o,l){var d=Ele(this.props.children);o.key in d||(o.props.onExited&&o.props.onExited(l),this.mounted&&this.setState(function(h){var p=gle({},h.children);return delete p[o.key],{children:p}}))},i.render=function(){var o=this.props,l=o.component,d=o.childFactory,h=HMe(o,["component","childFactory"]),p=this.state.contextValue,g=DAt(this.state.children).map(d);return delete h.appear,delete h.enter,delete h.exit,l===null?U.createElement(wK.Provider,{value:p},g):U.createElement(wK.Provider,{value:p},U.createElement(l,h,g))},e}(U.Component);Ale.propTypes=process.env.NODE_ENV!=="production"?{component:Fs.any,children:Fs.node,appear:Fs.bool,enter:Fs.bool,exit:Fs.bool,childFactory:Fs.func}:{},Ale.defaultProps=LAt;const OAt=(t,e,i,r)=>{switch(t){case"entering":case"entered":return r==="both"?e:"";case"exiting":case"exited":return i;default:return""}},NAt=({children:t,enterClassName:e,exitClassName:i,animate:r,...o})=>{const l=$.useRef(null);return $.createElement(UM,{timeout:250,nodeRef:l,...o},d=>$.createElement(xAt,{animate:r,enterClassName:e,exitClassName:i,nodeRef:l,state:d},t))},xAt=({children:t,state:e,enterClassName:i,exitClassName:r,animate:o,nodeRef:l})=>{const d=OAt(e,i,r,o),h=$.useMemo(()=>({className:d,nodeRef:l}),[d,l]);return $.createElement(U0t,{value:h},t)},BAt=t=>(Pd(t),yr(t.root,{children:yr(Ale,{component:null,children:t.children.map(e=>yr(NAt,{animate:t.animate,enterClassName:t.enterStyles,exitClassName:t.exitStyles,children:e},e.key))})})),FAt={root:"fui-MessageBarGroup"},UAt=uo({base:{Bf5fcs:"f4cll0y",vin17d:"fy8si0b"},enter:{Bv12yb3:"f1dg9w1v"},exit:{Bv12yb3:"fu80iee"}},{d:[".f4cll0y{animation-fill-mode:forwards;}",".fy8si0b{animation-duration:var(--durationNormal);}",".f1dg9w1v{animation-name:fngeioi;}",".fu80iee{animation-name:fk0lfw7;}"],k:["@keyframes fngeioi{from{opacity:0;transform:translateY(-100%);}to{opacity:1;transform:translateY(0);}}","@keyframes fk0lfw7{from{opacity:1;}to{opacity:0;}}"]}),zAt=t=>{"use no memo";const e=UAt();return t.root.className=ea(FAt.root,t.root.className),t.enterStyles=ea(e.base,e.enter),t.exitStyles=ea(e.base,e.exit),t},aPe=$.forwardRef((t,e)=>{const i=vAt(t,e);return zAt(i),kh("useMessageBarGroupStyles_unstable")(i),BAt(i)});aPe.displayName="MessageBarGroup";const VAt={Board:{regular:Wyt,filled:qyt},Chat:{regular:Jyt,filled:Kyt},Poll:{regular:lSt,filled:sSt}};function $At(t,e=!1){const i=rPe(t,"regular");let r=i;if(e){const o=rPe(t,"filled");r=Nse(o,i)}return r}function rPe(t,e){const i=VAt[t]?.[e];if(!i)throw new Error(`Unsupported icon name: ${t}`);return i}function oPe(){const[t,e]=$.useState(!1);return $.useEffect(()=>{const i=()=>document.body.classList.contains("dark-mode"),r=new MutationObserver(o=>{o.forEach(l=>{l.type==="attributes"&&l.attributeName==="class"&&e(i())})});return r.observe(document.body,{attributes:!0,attributeFilter:["class"]}),e(i()),()=>r.disconnect()},[]),t}function kK(){const t=oPe();return $.useMemo(()=>t?Cyt:zke,[t])}function HAt({tabs:t,selectedTabId:e,onSelectedTabChange:i}){const r=kK(),o=$.useMemo(()=>Object.values(t)[0]?.id,[t]),[l,d]=$.useState(),h=$.useMemo(()=>l??e??o,[o,l,e]);return $.useEffect(()=>{i?.(h)},[h,i]),Da.jsxs(E5,{className:"tabbed-panel",theme:r,children:[Da.jsx(jAt,{tabs:t,selectedValue:h,setSelectedValue:d}),Da.jsx(Da.Fragment,{children:t[h]?.children})]})}function jAt({tabs:t,selectedValue:e,setSelectedValue:i}){const r=Object.values(t);return r.length<=1?null:Da.jsx(EMe,{selectedValue:e,onTabSelect:(o,l)=>i(l.value),children:r.map(o=>Da.jsx(GAt,{id:o.id,name:o.name,iconName:o.iconName},o.id))})}function GAt({id:t,name:e,iconName:i}){const r=$.useMemo(()=>$At(i,!0),[i]);return Da.jsx(_Me,{id:t,icon:Da.jsx(r,{}),value:t,children:e})}const qAt=(t,e,i)=>t.length===e.length&&t.every((r,o)=>i(e[o],r)),WH=(t,e=Object.is)=>{let i=new Map,r=new Map;return o=>{const d=o((h,...p)=>{const g=i.get(h);if(g){const[y,T]=g;if(qAt(y,p,e))return r.set(h,[p,T]),T}const f=t(h,...p);return r.set(h,[p,f]),f});return i=r,r=new Map,d}};class KH extends Error{}KH.prototype.name="InvalidTokenError";function WAt(t){return decodeURIComponent(atob(t).replace(/(.)/g,(e,i)=>{let r=i.charCodeAt(0).toString(16).toUpperCase();return r.length<2&&(r="0"+r),"%"+r}))}function KAt(t){let e=t.replace(/-/g,"+").replace(/_/g,"/");switch(e.length%4){case 0:break;case 2:e+="==";break;case 3:e+="=";break;default:throw new Error("base64 string is not of the correct length")}try{return WAt(e)}catch{return atob(e)}}function JAt(t,e){if(typeof t!="string")throw new KH("Invalid token specified: must be a string");e||(e={});const i=e.header===!0?0:1,r=t.split(".")[i];if(typeof r!="string")throw new KH(`Invalid token specified: missing part #${i+1}`);let o;try{o=KAt(r)}catch(l){throw new KH(`Invalid token specified: invalid base64 for part #${i+1} (${l.message})`)}try{return JSON.parse(o)}catch(l){throw new KH(`Invalid token specified: invalid json for part #${i+1} (${l.message})`)}}const Ile=t=>{const{exp:e}=JAt(t);return{token:t,expiresOnTimestamp:e*1e3}},sPe={token:"",expiresOnTimestamp:-10},YAt=(t=>t*1e3*60)(10),QAt=.5;class ZAt{constructor(e){this.expiringSoonIntervalInMs=YAt,this.refreshAfterLifetimePercentage=QAt,this.activeTokenFetching=null,this.activeTokenUpdating=null,this.disposed=!1;const{tokenRefresher:i,token:r,refreshProactively:o}=e;this.refresh=i,this.currentToken=r?Ile(r):sPe,this.refreshProactively=o??!1,this.refreshProactively&&this.scheduleRefresh()}async getToken(e){return this.isTokenExpiringSoon(this.currentToken)?(this.isTokenValid(this.currentToken)||await this.updateTokenAndReschedule(e?.abortSignal),this.currentToken):this.currentToken}dispose(){this.disposed=!0,this.activeTokenFetching=null,this.activeTokenUpdating=null,this.currentToken=sPe,this.activeTimeout&&clearTimeout(this.activeTimeout)}async updateTokenAndReschedule(e){if(this.activeTokenUpdating)return this.activeTokenUpdating;this.activeTokenUpdating=this.refreshTokenAndReschedule(e);try{await this.activeTokenUpdating}finally{this.activeTokenUpdating=null}}async refreshTokenAndReschedule(e){const i=await this.refreshToken(e);if(!this.isTokenValid(i))throw new Error("The token returned from the tokenRefresher is expired.");this.currentToken=i,this.refreshProactively&&this.scheduleRefresh()}async refreshToken(e){try{return this.activeTokenFetching||(this.activeTokenFetching=this.refresh(e)),Ile(await this.activeTokenFetching)}finally{this.activeTokenFetching=null}}scheduleRefresh(){if(this.disposed)return;this.activeTimeout&&clearTimeout(this.activeTimeout);const e=this.currentToken.expiresOnTimestamp-Date.now();let i=null;this.isTokenExpiringSoon(this.currentToken)?i=e*this.refreshAfterLifetimePercentage:i=e-this.expiringSoonIntervalInMs,this.activeTimeout=setTimeout(()=>this.updateTokenAndReschedule(),i)}isTokenValid(e){return e&&Date.now()<e.expiresOnTimestamp}isTokenExpiringSoon(e){return!e||Date.now()>=e.expiresOnTimestamp-this.expiringSoonIntervalInMs}}class XAt{constructor(e){this.token=e}async getToken(){return this.token}dispose(){}}class eIt{constructor(e){this.disposed=!1,typeof e=="string"?this.tokenCredential=new XAt(Ile(e)):this.tokenCredential=new ZAt(e)}async getToken(e){this.throwIfDisposed();const i=await this.tokenCredential.getToken(e);return this.throwIfDisposed(),i}dispose(){this.disposed=!0,this.tokenCredential.dispose()}throwIfDisposed(){if(this.disposed)throw new Error("User credential is disposed")}}class RK extends Error{constructor(e){super(e),this.name="AbortError"}}function lPe(t,e){const{cleanupBeforeAbort:i,abortSignal:r,abortErrorMsg:o}=e??{};return new Promise((l,d)=>{function h(){d(new RK(o??"The operation was aborted."))}function p(){r?.removeEventListener("abort",g)}function g(){i?.(),p(),h()}if(r?.aborted)return h();try{t(f=>{p(),l(f)},f=>{p(),d(f)})}catch(f){d(f)}r?.addEventListener("abort",g)})}function cPe(t,e){return t=Math.ceil(t),e=Math.floor(e),Math.floor(Math.random()*(e-t+1))+t}const tIt="The delay was aborted.";function iIt(t,e){let i;const{abortSignal:r,abortErrorMsg:o}=e??{};return lPe(l=>{i=setTimeout(l,t)},{cleanupBeforeAbort:()=>clearTimeout(i),abortSignal:r,abortErrorMsg:o??tIt})}function dPe(t,e){const i=e.retryDelayInMs*Math.pow(2,t),r=Math.min(e.maxRetryDelayInMs,i);return{retryAfterInMs:r/2+cPe(0,r/2)}}async function nIt(t,e){var i,r;const o=new AbortController;function l(){o.abort()}(i=e?.abortSignal)===null||i===void 0||i.addEventListener("abort",l);try{return await Promise.race(t.map(d=>d({abortSignal:o.signal})))}finally{o.abort(),(r=e?.abortSignal)===null||r===void 0||r.removeEventListener("abort",l)}}function wle(t){return typeof t=="object"&&t!==null&&!Array.isArray(t)&&!(t instanceof RegExp)&&!(t instanceof Date)}function MK(t){if(wle(t)){const e=typeof t.name=="string",i=typeof t.message=="string";return e&&i}return!1}function JH(t){if(MK(t))return t.message;{let e;try{typeof t=="object"&&t?e=JSON.stringify(t):e=String(t)}catch{e="[unable to stringify input]"}return`Unknown error ${e}`}}function kle(t,e){switch(e){case"utf-8":return rIt(t);case"base64":return uPe(t);case"base64url":return aIt(t);case"hex":return oIt(t)}}function AA(t,e){switch(e){case"utf-8":return sIt(t);case"base64":return hPe(t);case"base64url":return lIt(t);case"hex":return cIt(t)}}function uPe(t){return btoa([...t].map(e=>String.fromCharCode(e)).join(""))}function aIt(t){return uPe(t).replace(/\+/g,"-").replace(/\//g,"_").replace(/=/g,"")}function rIt(t){return new TextDecoder().decode(t)}function oIt(t){return[...t].map(e=>e.toString(16).padStart(2,"0")).join("")}function sIt(t){return new TextEncoder().encode(t)}function hPe(t){return new Uint8Array([...atob(t)].map(e=>e.charCodeAt(0)))}function lIt(t){const e=t.replace(/-/g,"+").replace(/_/g,"/");return hPe(e)}const pPe=new Set("0123456789abcdefABCDEF");function cIt(t){const e=new Uint8Array(t.length/2);for(let i=0;i<t.length/2;++i){const r=t[2*i],o=t[2*i+1];if(!pPe.has(r)||!pPe.has(o))return e.slice(0,i);e[i]=parseInt(`${r}${o}`,16)}return e}let PK;function gPe(){if(PK)return PK;if(!self.crypto||!self.crypto.subtle)throw new Error("Your browser environment does not support cryptography functions.");return PK=self.crypto.subtle,PK}async function dIt(t,e,i){const r=gPe(),o=AA(t,"base64"),l=AA(e,"utf-8"),d=await r.importKey("raw",o,{name:"HMAC",hash:{name:"SHA-256"}},!1,["sign"]),h=await r.sign({name:"HMAC",hash:{name:"SHA-256"}},d,l);return kle(new Uint8Array(h),i)}async function uIt(t,e){const i=AA(t,"utf-8"),r=await gPe().digest({name:"SHA-256"},i);return kle(new Uint8Array(r),e)}function Rle(t){return typeof t<"u"&&t!==null}function hIt(t,e){if(!Rle(t)||typeof t!="object")return!1;for(const i of e)if(!mPe(t,i))return!1;return!0}function mPe(t,e){return Rle(t)&&typeof t=="object"&&e in t}function pIt(){let t="";for(let e=0;e<32;e++){const i=Math.floor(Math.random()*16);e===12?t+="4":e===16?t+=i&3|8:t+=i.toString(16),(e===7||e===11||e===15||e===19)&&(t+="-")}return t}var Mle;const gIt=typeof((Mle=globalThis?.crypto)===null||Mle===void 0?void 0:Mle.randomUUID)=="function"?globalThis.crypto.randomUUID.bind(globalThis.crypto):pIt;function Ple(){return gIt()}var Dle,Lle,Ole,Nle;const mIt=typeof window<"u"&&typeof window.document<"u",fIt=typeof self=="object"&&typeof self?.importScripts=="function"&&(((Dle=self.constructor)===null||Dle===void 0?void 0:Dle.name)==="DedicatedWorkerGlobalScope"||((Lle=self.constructor)===null||Lle===void 0?void 0:Lle.name)==="ServiceWorkerGlobalScope"||((Ole=self.constructor)===null||Ole===void 0?void 0:Ole.name)==="SharedWorkerGlobalScope"),fPe=typeof Deno<"u"&&typeof Deno.version<"u"&&typeof Deno.version.deno<"u",vPe=typeof Bun<"u"&&typeof Bun.version<"u",Ox=typeof globalThis.process<"u"&&!!globalThis.process.version&&!!(!((Nle=globalThis.process.versions)===null||Nle===void 0)&&Nle.node),vIt=Ox,yIt=Ox&&!vPe&&!fPe,SIt=typeof navigator<"u"&&navigator?.product==="ReactNative",bIt=Object.freeze(Object.defineProperty({__proto__:null,calculateRetryDelay:dPe,cancelablePromiseRace:nIt,computeSha256Hash:uIt,computeSha256Hmac:dIt,createAbortablePromise:lPe,delay:iIt,getErrorMessage:JH,getRandomIntegerInclusive:cPe,isBrowser:mIt,isBun:vPe,isDefined:Rle,isDeno:fPe,isError:MK,isNode:vIt,isNodeLike:Ox,isNodeRuntime:yIt,isObject:wle,isObjectWithProperties:hIt,isReactNative:SIt,isWebWorker:fIt,objectHasProperty:mPe,randomUUID:Ple,stringToUint8Array:AA,uint8ArrayToString:kle},Symbol.toStringTag,{value:"Module"})),yPe=new Set(["Deserialize","Serialize","Retry","Sign"]);class DK{constructor(e){var i;this._policies=[],this._policies=(i=e?.slice(0))!==null&&i!==void 0?i:[],this._orderedPolicies=void 0}addPolicy(e,i={}){if(i.phase&&i.afterPhase)throw new Error("Policies inside a phase cannot specify afterPhase.");if(i.phase&&!yPe.has(i.phase))throw new Error(`Invalid phase name: ${i.phase}`);if(i.afterPhase&&!yPe.has(i.afterPhase))throw new Error(`Invalid afterPhase name: ${i.afterPhase}`);this._policies.push({policy:e,options:i}),this._orderedPolicies=void 0}removePolicy(e){const i=[];return this._policies=this._policies.filter(r=>e.name&&r.policy.name===e.name||e.phase&&r.options.phase===e.phase?(i.push(r.policy),!1):!0),this._orderedPolicies=void 0,i}sendRequest(e,i){return this.getOrderedPolicies().reduceRight((l,d)=>h=>d.sendRequest(h,l),l=>e.sendRequest(l))(i)}getOrderedPolicies(){return this._orderedPolicies||(this._orderedPolicies=this.orderPolicies()),this._orderedPolicies}clone(){return new DK(this._policies)}static create(){return new DK}orderPolicies(){const e=[],i=new Map;function r(E){return{name:E,policies:new Set,hasRun:!1,hasAfterPolicies:!1}}const o=r("Serialize"),l=r("None"),d=r("Deserialize"),h=r("Retry"),p=r("Sign"),g=[o,l,d,h,p];function f(E){return E==="Retry"?h:E==="Serialize"?o:E==="Deserialize"?d:E==="Sign"?p:l}for(const E of this._policies){const I=E.policy,w=E.options,D=I.name;if(i.has(D))throw new Error("Duplicate policy names not allowed in pipeline");const F={policy:I,dependsOn:new Set,dependants:new Set};w.afterPhase&&(F.afterPhase=f(w.afterPhase),F.afterPhase.hasAfterPolicies=!0),i.set(D,F),f(w.phase).policies.add(F)}for(const E of this._policies){const{policy:I,options:w}=E,D=I.name,F=i.get(D);if(!F)throw new Error(`Missing node for policy ${D}`);if(w.afterPolicies)for(const x of w.afterPolicies){const B=i.get(x);B&&(F.dependsOn.add(B),B.dependants.add(F))}if(w.beforePolicies)for(const x of w.beforePolicies){const B=i.get(x);B&&(B.dependsOn.add(F),F.dependants.add(B))}}function y(E){E.hasRun=!0;for(const I of E.policies)if(!(I.afterPhase&&(!I.afterPhase.hasRun||I.afterPhase.policies.size))&&I.dependsOn.size===0){e.push(I.policy);for(const w of I.dependants)w.dependsOn.delete(I);i.delete(I.policy.name),E.policies.delete(I)}}function T(){for(const E of g){if(y(E),E.policies.size>0&&E!==l){l.hasRun||y(l);return}E.hasAfterPolicies&&y(l)}}let C=0;for(;i.size>0;){C++;const E=e.length;if(T(),e.length<=E&&C>1)throw new Error("Cannot satisfy policy dependencies due to requirements cycle.")}return e}}function SPe(){return DK.create()}function TIt(...t){if(t.length>0){const e=String(t[0]);e.includes(":error")?console.error(...t):e.includes(":warning")?console.warn(...t):e.includes(":info")?console.info(...t):e.includes(":verbose")?console.debug(...t):console.debug(...t)}}const bPe=typeof process<"u"&&process.env&&process.env.DEBUG||void 0;let TPe,xle=[],Ble=[];const LK=[];bPe&&Fle(bPe);const N5=Object.assign(t=>CPe(t),{enable:Fle,enabled:Ule,disable:CIt,log:TIt});function Fle(t){TPe=t,xle=[],Ble=[];const e=/\*/g,i=t.split(",").map(r=>r.trim().replace(e,".*?"));for(const r of i)r.startsWith("-")?Ble.push(new RegExp(`^${r.substr(1)}$`)):xle.push(new RegExp(`^${r}$`));for(const r of LK)r.enabled=Ule(r.namespace)}function Ule(t){if(t.endsWith("*"))return!0;for(const e of Ble)if(e.test(t))return!1;for(const e of xle)if(e.test(t))return!0;return!1}function CIt(){const t=TPe||"";return Fle(""),t}function CPe(t){const e=Object.assign(i,{enabled:Ule(t),destroy:_It,log:N5.log,namespace:t,extend:EIt});function i(...r){e.enabled&&(r.length>0&&(r[0]=`${t} ${r[0]}`),e.log(...r))}return LK.push(e),e}function _It(){const t=LK.indexOf(this);return t>=0?(LK.splice(t,1),!0):!1}function EIt(t){const e=CPe(`${this.namespace}:${t}`);return e.log=this.log,e}const _Pe=new Set,OK=typeof process<"u"&&process.env&&process.env.AZURE_LOG_LEVEL||void 0;let NK;const xK=N5("azure");xK.log=(...t)=>{N5.log(...t)};const zle=["verbose","info","warning","error"];OK&&(wPe(OK)?AIt(OK):console.error(`AZURE_LOG_LEVEL set to unknown log level '${OK}'; logging is not enabled. Acceptable values: ${zle.join(", ")}.`));function AIt(t){if(t&&!wPe(t))throw new Error(`Unknown log level '${t}'. Acceptable values: ${zle.join(",")}`);NK=t;const e=[];for(const i of _Pe)IPe(i)&&e.push(i.namespace);N5.enable(e.join(","))}function Vle(){return NK}const EPe={verbose:400,info:300,warning:200,error:100};function zf(t){const e=xK.extend(t);return APe(xK,e),{error:BK(e,"error"),warning:BK(e,"warning"),info:BK(e,"info"),verbose:BK(e,"verbose")}}function APe(t,e){e.log=(...i)=>{t.log(...i)}}function BK(t,e){const i=Object.assign(t.extend(e),{level:e});if(APe(t,i),IPe(i)){const r=N5.disable();N5.enable(r+","+i.namespace)}return _Pe.add(i),i}function IPe(t){return!!(NK&&EPe[t.level]<=EPe[NK])}function wPe(t){return zle.includes(t)}const Nx=zf("core-rest-pipeline"),$le="REDACTED",IIt=["x-ms-client-request-id","x-ms-return-client-request-id","x-ms-useragent","x-ms-correlation-request-id","x-ms-request-id","client-request-id","ms-cv","return-client-request-id","traceparent","Access-Control-Allow-Credentials","Access-Control-Allow-Headers","Access-Control-Allow-Methods","Access-Control-Allow-Origin","Access-Control-Expose-Headers","Access-Control-Max-Age","Access-Control-Request-Headers","Access-Control-Request-Method","Origin","Accept","Accept-Encoding","Cache-Control","Connection","Content-Length","Content-Type","Date","ETag","Expires","If-Match","If-Modified-Since","If-None-Match","If-Unmodified-Since","Last-Modified","Pragma","Request-Id","Retry-After","Server","Transfer-Encoding","User-Agent","WWW-Authenticate"],wIt=["api-version"];class Hle{constructor({additionalAllowedHeaderNames:e=[],additionalAllowedQueryParameters:i=[]}={}){e=IIt.concat(e),i=wIt.concat(i),this.allowedHeaderNames=new Set(e.map(r=>r.toLowerCase())),this.allowedQueryParameters=new Set(i.map(r=>r.toLowerCase()))}sanitize(e){const i=new Set;return JSON.stringify(e,(r,o)=>{if(o instanceof Error)return Object.assign(Object.assign({},o),{name:o.name,message:o.message});if(r==="headers")return this.sanitizeHeaders(o);if(r==="url")return this.sanitizeUrl(o);if(r==="query")return this.sanitizeQuery(o);if(r==="body")return;if(r==="response")return;if(r==="operationSpec")return;if(Array.isArray(o)||wle(o)){if(i.has(o))return"[Circular]";i.add(o)}return o},2)}sanitizeUrl(e){if(typeof e!="string"||e===null||e==="")return e;const i=new URL(e);if(!i.search)return e;for(const[r]of i.searchParams)this.allowedQueryParameters.has(r.toLowerCase())||i.searchParams.set(r,$le);return i.toString()}sanitizeHeaders(e){const i={};for(const r of Object.keys(e))this.allowedHeaderNames.has(r.toLowerCase())?i[r]=e[r]:i[r]=$le;return i}sanitizeQuery(e){if(typeof e!="object"||e===null)return e;const i={};for(const r of Object.keys(e))this.allowedQueryParameters.has(r.toLowerCase())?i[r]=e[r]:i[r]=$le;return i}}const kPe="logPolicy";function RPe(t={}){var e;const i=(e=t.logger)!==null&&e!==void 0?e:Nx.info,r=new Hle({additionalAllowedHeaderNames:t.additionalAllowedHeaderNames,additionalAllowedQueryParameters:t.additionalAllowedQueryParameters});return{name:kPe,async sendRequest(o,l){if(!i.enabled)return l(o);i(`Request: ${r.sanitize(o)}`);const d=await l(o);return i(`Response status code: ${d.status}`),i(`Headers: ${r.sanitize(d.headers)}`),d}}}const MPe="redirectPolicy",PPe=["GET","HEAD"];function DPe(t={}){const{maxRetries:e=20}=t;return{name:MPe,async sendRequest(i,r){const o=await r(i);return LPe(r,o,e)}}}async function LPe(t,e,i,r=0){const{request:o,status:l,headers:d}=e,h=d.get("location");if(h&&(l===300||l===301&&PPe.includes(o.method)||l===302&&PPe.includes(o.method)||l===303&&o.method==="POST"||l===307)&&r<i){const p=new URL(h,o.url);o.url=p.toString(),l===303&&(o.method="GET",o.headers.delete("Content-Length"),delete o.body),o.headers.delete("Authorization");const g=await t(o);return LPe(t,g,i,r+1)}return e}function kIt(){return"x-ms-useragent"}function RIt(t){const e=[{name:"Firefox",regex:/Firefox\/([\d.]+)/},{name:"Safari",regex:/Version\/([\d.]+).*Safari/}];for(const i of e){const r=t.match(i.regex);if(r)return{brand:i.name,version:r[1]}}}function MIt(t){const e=["Google Chrome","Microsoft Edge","Opera","Brave","Chromium"];for(const i of e){const r=t.find(o=>o.brand===i);if(r)return r}}async function PIt(t){const e=globalThis.navigator;let i="unknown";if(e?.userAgentData){const r=await e.userAgentData.getHighEntropyValues(["architecture","platformVersion"]);i=`${r.architecture}-${r.platform}-${r.platformVersion}`;const o=MIt(e.userAgentData.brands);o&&t.set(o.brand,o.version)}else if(e?.platform){i=e.platform;const r=RIt(e.userAgent);r&&t.set(r.brand,r.version)}else typeof globalThis.EdgeRuntime=="string"&&t.set("EdgeRuntime",globalThis.EdgeRuntime);t.set("OS",i)}const OPe="1.19.1",x5=3;function DIt(t){const e=[];for(const[i,r]of t){const o=r?`${i}/${r}`:i;e.push(o)}return e.join(" ")}function LIt(){return kIt()}async function NPe(t){const e=new Map;e.set("core-rest-pipeline",OPe),await PIt(e);const i=DIt(e);return t?`${t} ${i}`:i}const xPe=LIt(),BPe="userAgentPolicy";function FPe(t={}){const e=NPe(t.userAgentPrefix);return{name:BPe,async sendRequest(i,r){return i.headers.has(xPe)||i.headers.set(xPe,await e),r(i)}}}function jle(t){return!!(t&&typeof t.pipe=="function")}function Gle(t){return!!(t&&typeof t.getReader=="function"&&typeof t.tee=="function")}function OIt(t){return typeof t.stream=="function"}const UPe={arrayBuffer:()=>{throw new Error("Not implemented")},bytes:()=>{throw new Error("Not implemented")},slice:()=>{throw new Error("Not implemented")},text:()=>{throw new Error("Not implemented")}},FK=Symbol("rawContent");function NIt(t){return typeof t[FK]=="function"}function xIt(t){return NIt(t)?t[FK]():t.stream()}function BIt(t,e,i={}){var r,o,l,d;return Object.assign(Object.assign({},UPe),{type:(r=i.type)!==null&&r!==void 0?r:"",lastModified:(o=i.lastModified)!==null&&o!==void 0?o:new Date().getTime(),webkitRelativePath:(l=i.webkitRelativePath)!==null&&l!==void 0?l:"",size:(d=i.size)!==null&&d!==void 0?d:-1,name:e,stream:()=>{const h=t();if(jle(h))throw new Error("Not supported: a Node stream was provided as input to createFileFromStream.");return h},[FK]:t})}function FIt(t,e,i={}){var r,o,l;return Ox?Object.assign(Object.assign({},UPe),{type:(r=i.type)!==null&&r!==void 0?r:"",lastModified:(o=i.lastModified)!==null&&o!==void 0?o:new Date().getTime(),webkitRelativePath:(l=i.webkitRelativePath)!==null&&l!==void 0?l:"",size:t.byteLength,name:e,arrayBuffer:async()=>t.buffer,stream:()=>new Blob([t]).stream(),[FK]:()=>t}):new File([t],e,i)}function UIt(t){return new Response(t).blob()}async function zPe(t){if(t instanceof Blob||t instanceof Uint8Array)return t;if(Gle(t))return UIt(t);const e=xIt(t);if(jle(e))throw new Error("Encountered unexpected type. In the browser, `concat` supports Web ReadableStream, Blob, Uint8Array, and files created using `createFile` only.");return zPe(e)}async function zIt(t){const e=[];for(const i of t)e.push(await zPe(typeof i=="function"?i():i));return new Blob(e)}function VIt(){return`----AzSDKFormBoundary${Ple()}`}function $It(t){let e="";for(const[i,r]of t)e+=`${i}: ${r}\r
`;return e}function HIt(t){return t instanceof Uint8Array?t.byteLength:OIt(t)?t.size===-1?void 0:t.size:void 0}function jIt(t){let e=0;for(const i of t){const r=HIt(i);if(r===void 0)return;e+=r}return e}async function GIt(t,e,i){const r=[AA(`--${i}`,"utf-8"),...e.flatMap(l=>[AA(`\r
`,"utf-8"),AA($It(l.headers),"utf-8"),AA(`\r
`,"utf-8"),l.body,AA(`\r
--${i}`,"utf-8")]),AA(`--\r
\r
`,"utf-8")],o=jIt(r);o&&t.headers.set("Content-Length",o),t.body=await zIt(r)}const qle="multipartPolicy",qIt=70,WIt=new Set("abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'()+,-./:=?");function KIt(t){if(t.length>qIt)throw new Error(`Multipart boundary "${t}" exceeds maximum length of 70 characters`);if(Array.from(t).some(e=>!WIt.has(e)))throw new Error(`Multipart boundary "${t}" contains invalid characters`)}function VPe(){return{name:qle,async sendRequest(t,e){var i;if(!t.multipartBody)return e(t);if(t.body)throw new Error("multipartBody and regular body cannot be set at the same time");let r=t.multipartBody.boundary;const o=(i=t.headers.get("Content-Type"))!==null&&i!==void 0?i:"multipart/mixed",l=o.match(/^(multipart\/[^ ;]+)(?:; *boundary=(.+))?$/);if(!l)throw new Error(`Got multipart request body, but content-type header was not multipart: ${o}`);const[,d,h]=l;if(h&&r&&h!==r)throw new Error(`Multipart boundary was specified as ${h} in the header, but got ${r} in the request body`);return r??(r=h),r?KIt(r):r=VIt(),t.headers.set("Content-Type",`${d}; boundary=${r}`),await GIt(t,t.multipartBody.parts,r),t.multipartBody=void 0,e(t)}}}const JIt="decompressResponsePolicy";function $Pe(){throw new Error("decompressResponsePolicy is not supported in browser environment")}const YIt="The operation was aborted.";function HPe(t,e,i){return new Promise((r,o)=>{let l,d;const h=()=>o(new RK(i?.abortErrorMsg?i?.abortErrorMsg:YIt)),p=()=>{i?.abortSignal&&d&&i.abortSignal.removeEventListener("abort",d)};if(d=()=>(l&&clearTimeout(l),p(),h()),i?.abortSignal&&i.abortSignal.aborted)return h();l=setTimeout(()=>{p(),r(e)},t),i?.abortSignal&&i.abortSignal.addEventListener("abort",d)})}function QIt(t,e){const i=t.headers.get(e);if(!i)return;const r=Number(i);if(!Number.isNaN(r))return r}const Wle="Retry-After",ZIt=["retry-after-ms","x-ms-retry-after-ms",Wle];function jPe(t){if(t&&[429,503].includes(t.status))try{for(const o of ZIt){const l=QIt(t,o);if(l===0||l)return l*(o===Wle?1e3:1)}const e=t.headers.get(Wle);if(!e)return;const r=Date.parse(e)-Date.now();return Number.isFinite(r)?Math.max(0,r):void 0}catch{return}}function XIt(t){return Number.isFinite(jPe(t))}function GPe(){return{name:"throttlingRetryStrategy",retry({response:t}){const e=jPe(t);return Number.isFinite(e)?{retryAfterInMs:e}:{skipStrategy:!0}}}}const ewt=1e3,twt=1e3*64;function Kle(t={}){var e,i;const r=(e=t.retryDelayInMs)!==null&&e!==void 0?e:ewt,o=(i=t.maxRetryDelayInMs)!==null&&i!==void 0?i:twt;return{name:"exponentialRetryStrategy",retry({retryCount:l,response:d,responseError:h}){const p=nwt(h),g=p&&t.ignoreSystemErrors,f=iwt(d),y=f&&t.ignoreHttpStatusCodes;return d&&(XIt(d)||!f)||y||g?{skipStrategy:!0}:h&&!p&&!f?{errorToThrow:h}:dPe(l,{retryDelayInMs:r,maxRetryDelayInMs:o})}}}function iwt(t){return!!(t&&t.status!==void 0&&(t.status>=500||t.status===408)&&t.status!==501&&t.status!==505)}function nwt(t){return t?t.code==="ETIMEDOUT"||t.code==="ESOCKETTIMEDOUT"||t.code==="ECONNREFUSED"||t.code==="ECONNRESET"||t.code==="ENOENT"||t.code==="ENOTFOUND":!1}const qPe=zf("core-rest-pipeline retryPolicy"),awt="retryPolicy";function YH(t,e={maxRetries:x5}){const i=e.logger||qPe;return{name:awt,async sendRequest(r,o){var l,d;let h,p,g=-1;e:for(;;){g+=1,h=void 0,p=void 0;try{i.info(`Retry ${g}: Attempting to send request`,r.requestId),h=await o(r),i.info(`Retry ${g}: Received a response from request`,r.requestId)}catch(f){if(i.error(`Retry ${g}: Received an error from request`,r.requestId),p=f,!f||p.name!=="RestError")throw f;h=p.response}if(!((l=r.abortSignal)===null||l===void 0)&&l.aborted)throw i.error(`Retry ${g}: Request aborted.`),new RK;if(g>=((d=e.maxRetries)!==null&&d!==void 0?d:x5)){if(i.info(`Retry ${g}: Maximum retries reached. Returning the last received response, or throwing the last received error.`),p)throw p;if(h)return h;throw new Error("Maximum retries reached with no response or error to throw")}i.info(`Retry ${g}: Processing ${t.length} retry strategies.`);t:for(const f of t){const y=f.logger||qPe;y.info(`Retry ${g}: Processing retry strategy ${f.name}.`);const T=f.retry({retryCount:g,response:h,responseError:p});if(T.skipStrategy){y.info(`Retry ${g}: Skipped.`);continue t}const{errorToThrow:C,retryAfterInMs:E,redirectTo:I}=T;if(C)throw y.error(`Retry ${g}: Retry strategy ${f.name} throws error:`,C),C;if(E||E===0){y.info(`Retry ${g}: Retry strategy ${f.name} retries after ${E}`),await HPe(E,void 0,{abortSignal:r.abortSignal});continue e}if(I){y.info(`Retry ${g}: Retry strategy ${f.name} redirects to ${I}`),r.url=I;continue e}}if(p)throw i.info("None of the retry strategies could work with the received error. Throwing it."),p;if(h)return i.info("None of the retry strategies could work with the received response. Returning it."),h}}}}const rwt="defaultRetryPolicy";function WPe(t={}){var e;return{name:rwt,sendRequest:YH([GPe(),Kle(t)],{maxRetries:(e=t.maxRetries)!==null&&e!==void 0?e:x5}).sendRequest}}function UK(t){return t.toLowerCase()}function*owt(t){for(const e of t.values())yield[e.name,e.value]}class swt{constructor(e){if(this._headersMap=new Map,e)for(const i of Object.keys(e))this.set(i,e[i])}set(e,i){this._headersMap.set(UK(e),{name:e,value:String(i).trim()})}get(e){var i;return(i=this._headersMap.get(UK(e)))===null||i===void 0?void 0:i.value}has(e){return this._headersMap.has(UK(e))}delete(e){this._headersMap.delete(UK(e))}toJSON(e={}){const i={};if(e.preserveCase)for(const r of this._headersMap.values())i[r.name]=r.value;else for(const[r,o]of this._headersMap)i[r]=o.value;return i}toString(){return JSON.stringify(this.toJSON({preserveCase:!0}))}[Symbol.iterator](){return owt(this._headersMap)}}function QH(t){return new swt(t)}const KPe="formDataPolicy";function lwt(t){var e;const i={};for(const[r,o]of t.entries())(e=i[r])!==null&&e!==void 0||(i[r]=[]),i[r].push(o);return i}function JPe(){return{name:KPe,async sendRequest(t,e){if(Ox&&typeof FormData<"u"&&t.body instanceof FormData&&(t.formData=lwt(t.body),t.body=void 0),t.formData){const i=t.headers.get("Content-Type");i&&i.indexOf("application/x-www-form-urlencoded")!==-1?t.body=cwt(t.formData):await dwt(t.formData,t),t.formData=void 0}return e(t)}}}function cwt(t){const e=new URLSearchParams;for(const[i,r]of Object.entries(t))if(Array.isArray(r))for(const o of r)e.append(i,o.toString());else e.append(i,r.toString());return e.toString()}async function dwt(t,e){const i=e.headers.get("Content-Type");if(i&&!i.startsWith("multipart/form-data"))return;e.headers.set("Content-Type",i??"multipart/form-data");const r=[];for(const[o,l]of Object.entries(t))for(const d of Array.isArray(l)?l:[l])if(typeof d=="string")r.push({headers:QH({"Content-Disposition":`form-data; name="${o}"`}),body:AA(d,"utf-8")});else{if(d==null||typeof d!="object")throw new Error(`Unexpected value for key ${o}: ${d}. Value should be serialized to string first.`);{const h=d.name||"blob",p=QH();p.set("Content-Disposition",`form-data; name="${o}"; filename="${h}"`),p.set("Content-Type",d.type||"application/octet-stream"),r.push({headers:p,body:d})}}e.multipartBody={parts:r}}const uwt="proxyPolicy",YPe="proxyPolicy is not supported in browser environment";function hwt(){throw new Error(YPe)}function QPe(){throw new Error(YPe)}const ZPe="setClientRequestIdPolicy";function XPe(t="x-ms-client-request-id"){return{name:ZPe,async sendRequest(e,i){return e.headers.has(t)||e.headers.set(t,e.requestId),i(e)}}}const eDe="agentPolicy";function tDe(t){return{name:eDe,sendRequest:async(e,i)=>(e.agent||(e.agent=t),i(e))}}const iDe="tlsPolicy";function nDe(t){return{name:iDe,sendRequest:async(e,i)=>(e.tlsSettings||(e.tlsSettings=t),i(e))}}const ZH={span:Symbol.for("@azure/core-tracing span"),namespace:Symbol.for("@azure/core-tracing namespace")};function pwt(t={}){let e=new XH(t.parentContext);return t.span&&(e=e.setValue(ZH.span,t.span)),t.namespace&&(e=e.setValue(ZH.namespace,t.namespace)),e}class XH{constructor(e){this._contextMap=e instanceof XH?new Map(e._contextMap):new Map}setValue(e,i){const r=new XH(this);return r._contextMap.set(e,i),r}getValue(e){return this._contextMap.get(e)}deleteValue(e){const i=new XH(this);return i._contextMap.delete(e),i}}const Jle={instrumenterImplementation:void 0};function gwt(){return{end:()=>{},isRecording:()=>!1,recordException:()=>{},setAttribute:()=>{},setStatus:()=>{},addEvent:()=>{}}}function mwt(){return{createRequestHeaders:()=>({}),parseTraceparentHeader:()=>{},startSpan:(t,e)=>({span:gwt(),tracingContext:pwt({parentContext:e.tracingContext})}),withContext(t,e,...i){return e(...i)}}}function zK(){return Jle.instrumenterImplementation||(Jle.instrumenterImplementation=mwt()),Jle.instrumenterImplementation}function aDe(t){const{namespace:e,packageName:i,packageVersion:r}=t;function o(g,f,y){var T;const C=zK().startSpan(g,Object.assign(Object.assign({},y),{packageName:i,packageVersion:r,tracingContext:(T=f?.tracingOptions)===null||T===void 0?void 0:T.tracingContext}));let E=C.tracingContext;const I=C.span;E.getValue(ZH.namespace)||(E=E.setValue(ZH.namespace,e)),I.setAttribute("az.namespace",E.getValue(ZH.namespace));const w=Object.assign({},f,{tracingOptions:Object.assign(Object.assign({},f?.tracingOptions),{tracingContext:E})});return{span:I,updatedOptions:w}}async function l(g,f,y,T){const{span:C,updatedOptions:E}=o(g,f,T);try{const I=await d(E.tracingOptions.tracingContext,()=>Promise.resolve(y(E,C)));return C.setStatus({status:"success"}),I}catch(I){throw C.setStatus({status:"error",error:I}),I}finally{C.end()}}function d(g,f,...y){return zK().withContext(g,f,...y)}function h(g){return zK().parseTraceparentHeader(g)}function p(g){return zK().createRequestHeaders(g)}return{startSpan:o,withSpan:l,withContext:d,parseTraceparentHeader:h,createRequestHeaders:p}}const fwt={},vwt=new Hle;class EE extends Error{constructor(e,i={}){super(e),this.name="RestError",this.code=i.code,this.statusCode=i.statusCode,Object.defineProperty(this,"request",{value:i.request,enumerable:!1}),Object.defineProperty(this,"response",{value:i.response,enumerable:!1}),Object.setPrototypeOf(this,EE.prototype)}[fwt](){return`RestError: ${this.message} 
 ${vwt.sanitize(Object.assign(Object.assign({},this),{request:this.request,response:this.response}))}`}}EE.REQUEST_SEND_ERROR="REQUEST_SEND_ERROR",EE.PARSE_ERROR="PARSE_ERROR";function Yle(t){return t instanceof EE?!0:MK(t)&&t.name==="RestError"}const rDe="tracingPolicy";function oDe(t={}){const e=NPe(t.userAgentPrefix),i=new Hle({additionalAllowedQueryParameters:t.additionalAllowedQueryParameters}),r=ywt();return{name:rDe,async sendRequest(o,l){var d;if(!r)return l(o);const h=await e,p={"http.url":i.sanitizeUrl(o.url),"http.method":o.method,"http.user_agent":h,requestId:o.requestId};h&&(p["http.user_agent"]=h);const{span:g,tracingContext:f}=(d=Swt(r,o,p))!==null&&d!==void 0?d:{};if(!g||!f)return l(o);try{const y=await r.withContext(f,l,o);return Twt(g,y),y}catch(y){throw bwt(g,y),y}}}}function ywt(){try{return aDe({namespace:"",packageName:"@azure/core-rest-pipeline",packageVersion:OPe})}catch(t){Nx.warning(`Error when creating the TracingClient: ${JH(t)}`);return}}function Swt(t,e,i){try{const{span:r,updatedOptions:o}=t.startSpan(`HTTP ${e.method}`,{tracingOptions:e.tracingOptions},{spanKind:"client",spanAttributes:i});if(!r.isRecording()){r.end();return}const l=t.createRequestHeaders(o.tracingOptions.tracingContext);for(const[d,h]of Object.entries(l))e.headers.set(d,h);return{span:r,tracingContext:o.tracingOptions.tracingContext}}catch(r){Nx.warning(`Skipping creating a tracing span due to an error: ${JH(r)}`);return}}function bwt(t,e){try{t.setStatus({status:"error",error:MK(e)?e:void 0}),Yle(e)&&e.statusCode&&t.setAttribute("http.status_code",e.statusCode),t.end()}catch(i){Nx.warning(`Skipping tracing span processing due to an error: ${JH(i)}`)}}function Twt(t,e){try{t.setAttribute("http.status_code",e.status);const i=e.headers.get("x-ms-request-id");i&&t.setAttribute("serviceRequestId",i),e.status>=400&&t.setStatus({status:"error"}),t.end()}catch(i){Nx.warning(`Skipping tracing span processing due to an error: ${JH(i)}`)}}function sDe(t){var e;const i=SPe();return Ox&&(t.agent&&i.addPolicy(tDe(t.agent)),t.tlsOptions&&i.addPolicy(nDe(t.tlsOptions)),i.addPolicy(QPe(t.proxyOptions)),i.addPolicy($Pe())),i.addPolicy(JPe(),{beforePolicies:[qle]}),i.addPolicy(FPe(t.userAgentOptions)),i.addPolicy(XPe((e=t.telemetryOptions)===null||e===void 0?void 0:e.clientRequestIdHeaderName)),i.addPolicy(VPe(),{afterPhase:"Deserialize"}),i.addPolicy(WPe(t.retryOptions),{phase:"Retry"}),i.addPolicy(oDe(Object.assign(Object.assign({},t.userAgentOptions),t.loggingOptions)),{afterPhase:"Retry"}),Ox&&i.addPolicy(DPe(t.redirectOptions),{afterPhase:"Retry"}),i.addPolicy(RPe(t.loggingOptions),{afterPhase:"Sign"}),i}function Cwt(t){return(typeof Blob=="function"||typeof Blob=="object")&&t instanceof Blob}class _wt{async sendRequest(e){if(new URL(e.url).protocol!=="https:"&&!e.allowInsecureConnection)throw new Error(`Cannot connect to ${e.url} while allowInsecureConnection is false.`);if(e.proxySettings)throw new Error("HTTP proxy is not supported in browser environment");try{return await Ewt(e)}catch(o){throw wwt(o,e)}}}async function Ewt(t){const{abortController:e,abortControllerCleanup:i}=Iwt(t);try{const r=kwt(t.headers),{streaming:o,body:l}=Mwt(t),d=Object.assign(Object.assign({body:l,method:t.method,headers:r,signal:e.signal},"credentials"in Request.prototype?{credentials:t.withCredentials?"include":"same-origin"}:{}),"cache"in Request.prototype?{cache:"no-store"}:{});o&&(d.duplex="half");const h=await fetch(t.url,d);return Cwt(t.body)&&t.onUploadProgress&&t.onUploadProgress({loadedBytes:t.body.size}),Awt(h,t,i)}catch(r){throw i?.(),r}}async function Awt(t,e,i){var r,o;const l=Rwt(t),d={request:e,headers:l,status:t.status},h=Gle(t.body)?lDe(t.body,{onProgress:e.onDownloadProgress,onEnd:i}):t.body;if(!((r=e.streamResponseStatusCodes)===null||r===void 0)&&r.has(Number.POSITIVE_INFINITY)||!((o=e.streamResponseStatusCodes)===null||o===void 0)&&o.has(d.status))if(e.enableBrowserStreams)d.browserStreamBody=h??void 0;else{const p=new Response(h);d.blobBody=p.blob(),i?.()}else{const p=new Response(h);d.bodyAsText=await p.text(),i?.()}return d}function Iwt(t){const e=new AbortController;let i,r;if(t.abortSignal){if(t.abortSignal.aborted)throw new RK("The operation was aborted. Request has already been canceled.");r=o=>{o.type==="abort"&&e.abort()},t.abortSignal.addEventListener("abort",r),i=()=>{var o;r&&((o=t.abortSignal)===null||o===void 0||o.removeEventListener("abort",r))}}return t.timeout>0&&setTimeout(()=>{e.abort()},t.timeout),{abortController:e,abortControllerCleanup:i}}function wwt(t,e){var i;return t&&t?.name==="AbortError"?t:new EE(`Error sending request: ${t.message}`,{code:(i=t?.code)!==null&&i!==void 0?i:EE.REQUEST_SEND_ERROR,request:e})}function kwt(t){const e=new Headers;for(const[i,r]of t)e.append(i,r);return e}function Rwt(t){const e=QH();for(const[i,r]of t.headers)e.set(i,r);return e}function Mwt(t){const e=typeof t.body=="function"?t.body():t.body;if(jle(e))throw new Error("Node streams are not supported in browser environment.");return Gle(e)?{streaming:!0,body:lDe(e,{onProgress:t.onUploadProgress})}:{streaming:!1,body:e}}function lDe(t,e={}){let i=0;const{onProgress:r,onEnd:o}=e;if(Dwt(t))return t.pipeThrough(new TransformStream({transform(l,d){if(l===null){d.terminate();return}d.enqueue(l),i+=l.length,r&&r({loadedBytes:i})},flush(){o?.()}}));{const l=t.getReader();return new ReadableStream({async pull(d){var h;const{done:p,value:g}=await l.read();if(p||!g){o?.(),d.close(),l.releaseLock();return}i+=(h=g?.length)!==null&&h!==void 0?h:0,d.enqueue(g),r&&r({loadedBytes:i})},cancel(d){return o?.(),l.cancel(d)}})}}function Pwt(){return new _wt}function Dwt(t){return t.pipeThrough!==void 0&&self.TransformStream!==void 0}function cDe(){return Pwt()}class Lwt{constructor(e){var i,r,o,l,d,h,p;this.url=e.url,this.body=e.body,this.headers=(i=e.headers)!==null&&i!==void 0?i:QH(),this.method=(r=e.method)!==null&&r!==void 0?r:"GET",this.timeout=(o=e.timeout)!==null&&o!==void 0?o:0,this.multipartBody=e.multipartBody,this.formData=e.formData,this.disableKeepAlive=(l=e.disableKeepAlive)!==null&&l!==void 0?l:!1,this.proxySettings=e.proxySettings,this.streamResponseStatusCodes=e.streamResponseStatusCodes,this.withCredentials=(d=e.withCredentials)!==null&&d!==void 0?d:!1,this.abortSignal=e.abortSignal,this.tracingOptions=e.tracingOptions,this.onUploadProgress=e.onUploadProgress,this.onDownloadProgress=e.onDownloadProgress,this.requestId=e.requestId||Ple(),this.allowInsecureConnection=(h=e.allowInsecureConnection)!==null&&h!==void 0?h:!1,this.enableBrowserStreams=(p=e.enableBrowserStreams)!==null&&p!==void 0?p:!1,this.agent=e.agent,this.tlsSettings=e.tlsSettings}}function dDe(t){return new Lwt(t)}const Owt="exponentialRetryPolicy";function Nwt(t={}){var e;return YH([Kle(Object.assign(Object.assign({},t),{ignoreSystemErrors:!0}))],{maxRetries:(e=t.maxRetries)!==null&&e!==void 0?e:x5})}const uDe="systemErrorRetryPolicy";function xwt(t={}){var e;return{name:uDe,sendRequest:YH([Kle(Object.assign(Object.assign({},t),{ignoreHttpStatusCodes:!0}))],{maxRetries:(e=t.maxRetries)!==null&&e!==void 0?e:x5}).sendRequest}}const hDe="throttlingRetryPolicy";function Bwt(t={}){var e;return{name:hDe,sendRequest:YH([GPe()],{maxRetries:(e=t.maxRetries)!==null&&e!==void 0?e:x5}).sendRequest}}const Fwt={forcedRefreshWindowInMs:1e3,retryIntervalInMs:3e3,refreshWindowInMs:1e3*60*2};async function Uwt(t,e,i){async function r(){if(Date.now()<i)try{return await t()}catch{return null}else{const l=await t();if(l===null)throw new Error("Failed to refresh access token.");return l}}let o=await r();for(;o===null;)await HPe(e),o=await r();return o}function pDe(t,e){let i=null,r=null,o;const l=Object.assign(Object.assign({},Fwt),e),d={get isRefreshing(){return i!==null},get shouldRefresh(){var p;return d.isRefreshing?!1:r?.refreshAfterTimestamp&&r.refreshAfterTimestamp<Date.now()?!0:((p=r?.expiresOnTimestamp)!==null&&p!==void 0?p:0)-l.refreshWindowInMs<Date.now()},get mustRefresh(){return r===null||r.expiresOnTimestamp-l.forcedRefreshWindowInMs<Date.now()}};function h(p,g){var f;return d.isRefreshing||(i=Uwt(()=>t.getToken(p,g),l.retryIntervalInMs,(f=r?.expiresOnTimestamp)!==null&&f!==void 0?f:Date.now()).then(T=>(i=null,r=T,o=g.tenantId,r)).catch(T=>{throw i=null,r=null,o=void 0,T})),i}return async(p,g)=>{const f=!!g.claims,y=o!==g.tenantId;return f&&(r=null),y||f||d.mustRefresh?h(p,g):(d.shouldRefresh&&h(p,g),r)}}const gDe="bearerTokenAuthenticationPolicy";async function VK(t,e){try{return[await e(t),void 0]}catch(i){if(Yle(i)&&i.response)return[i.response,i];throw i}}async function zwt(t){const{scopes:e,getAccessToken:i,request:r}=t,o={abortSignal:r.abortSignal,tracingOptions:r.tracingOptions,enableCae:!0},l=await i(e,o);l&&t.request.headers.set("Authorization",`Bearer ${l.token}`)}function mDe(t){return t.status===401&&t.headers.has("WWW-Authenticate")}async function fDe(t,e){var i;const{scopes:r}=t,o=await t.getAccessToken(r,{enableCae:!0,claims:e});return o?(t.request.headers.set("Authorization",`${(i=o.tokenType)!==null&&i!==void 0?i:"Bearer"} ${o.token}`),!0):!1}function Qle(t){var e,i,r;const{credential:o,scopes:l,challengeCallbacks:d}=t,h=t.logger||Nx,p={authorizeRequest:(i=(e=d?.authorizeRequest)===null||e===void 0?void 0:e.bind(d))!==null&&i!==void 0?i:zwt,authorizeRequestOnChallenge:(r=d?.authorizeRequestOnChallenge)===null||r===void 0?void 0:r.bind(d)},g=o?pDe(o):()=>Promise.resolve(null);return{name:gDe,async sendRequest(f,y){if(!f.url.toLowerCase().startsWith("https://"))throw new Error("Bearer token authentication is not permitted for non-TLS protected (non-https) URLs.");await p.authorizeRequest({scopes:Array.isArray(l)?l:[l],request:f,getAccessToken:g,logger:h});let T,C,E;if([T,C]=await VK(f,y),mDe(T)){let I=vDe(T.headers.get("WWW-Authenticate"));if(I){let w;try{w=atob(I)}catch{return h.warning(`The WWW-Authenticate header contains "claims" that cannot be parsed. Unable to perform the Continuous Access Evaluation authentication flow. Unparsable claims: ${I}`),T}E=await fDe({scopes:Array.isArray(l)?l:[l],response:T,request:f,getAccessToken:g,logger:h},w),E&&([T,C]=await VK(f,y))}else if(p.authorizeRequestOnChallenge&&(E=await p.authorizeRequestOnChallenge({scopes:Array.isArray(l)?l:[l],request:f,response:T,getAccessToken:g,logger:h}),E&&([T,C]=await VK(f,y)),mDe(T)&&(I=vDe(T.headers.get("WWW-Authenticate")),I))){let w;try{w=atob(I)}catch{return h.warning(`The WWW-Authenticate header contains "claims" that cannot be parsed. Unable to perform the Continuous Access Evaluation authentication flow. Unparsable claims: ${I}`),T}E=await fDe({scopes:Array.isArray(l)?l:[l],response:T,request:f,getAccessToken:g,logger:h},w),E&&([T,C]=await VK(f,y))}}if(C)throw C;return T}}}function Vwt(t){const e=/(\w+)\s+((?:\w+=(?:"[^"]*"|[^,]*),?\s*)+)/g,i=/(\w+)="([^"]*)"/g,r=[];let o;for(;(o=e.exec(t))!==null;){const l=o[1],d=o[2],h={};let p;for(;(p=i.exec(d))!==null;)h[p[1]]=p[2];r.push({scheme:l,params:h})}return r}function vDe(t){var e;return t?(e=Vwt(t).find(r=>r.scheme==="Bearer"&&r.params.claims&&r.params.error==="insufficient_claims"))===null||e===void 0?void 0:e.params.claims:void 0}const yDe="ndJsonPolicy";function $wt(){return{name:yDe,async sendRequest(t,e){if(typeof t.body=="string"&&t.body.startsWith("[")){const i=JSON.parse(t.body);Array.isArray(i)&&(t.body=i.map(r=>JSON.stringify(r)+`
`).join(""))}return e(t)}}}const Zle="auxiliaryAuthenticationHeaderPolicy",SDe="x-ms-authorization-auxiliary";async function Hwt(t){var e,i;const{scopes:r,getAccessToken:o,request:l}=t,d={abortSignal:l.abortSignal,tracingOptions:l.tracingOptions};return(i=(e=await o(r,d))===null||e===void 0?void 0:e.token)!==null&&i!==void 0?i:""}function jwt(t){const{credentials:e,scopes:i}=t,r=t.logger||Nx,o=new WeakMap;return{name:Zle,async sendRequest(l,d){if(!l.url.toLowerCase().startsWith("https://"))throw new Error("Bearer token authentication for auxiliary header is not permitted for non-TLS protected (non-https) URLs.");if(!e||e.length===0)return r.info(`${Zle} header will not be set due to empty credentials.`),d(l);const h=[];for(const g of e){let f=o.get(g);f||(f=pDe(g),o.set(g,f)),h.push(Hwt({scopes:Array.isArray(i)?i:[i],request:l,getAccessToken:f}))}const p=(await Promise.all(h)).filter(g=>!!g);return p.length===0?(r.warning(`None of the auxiliary tokens are valid. ${SDe} header will not be set.`),d(l)):(l.headers.set(SDe,p.map(g=>`Bearer ${g}`).join(", ")),d(l))}}}const Gwt=Object.freeze(Object.defineProperty({__proto__:null,RestError:EE,agentPolicy:tDe,agentPolicyName:eDe,auxiliaryAuthenticationHeaderPolicy:jwt,auxiliaryAuthenticationHeaderPolicyName:Zle,bearerTokenAuthenticationPolicy:Qle,bearerTokenAuthenticationPolicyName:gDe,createDefaultHttpClient:cDe,createEmptyPipeline:SPe,createFile:FIt,createFileFromStream:BIt,createHttpHeaders:QH,createPipelineFromOptions:sDe,createPipelineRequest:dDe,decompressResponsePolicy:$Pe,decompressResponsePolicyName:JIt,defaultRetryPolicy:WPe,exponentialRetryPolicy:Nwt,exponentialRetryPolicyName:Owt,formDataPolicy:JPe,formDataPolicyName:KPe,getDefaultProxySettings:hwt,isRestError:Yle,logPolicy:RPe,logPolicyName:kPe,multipartPolicy:VPe,multipartPolicyName:qle,ndJsonPolicy:$wt,ndJsonPolicyName:yDe,proxyPolicy:QPe,proxyPolicyName:uwt,redirectPolicy:DPe,redirectPolicyName:MPe,retryPolicy:YH,setClientRequestIdPolicy:XPe,setClientRequestIdPolicyName:ZPe,systemErrorRetryPolicy:xwt,systemErrorRetryPolicyName:uDe,throttlingRetryPolicy:Bwt,throttlingRetryPolicyName:hDe,tlsPolicy:nDe,tlsPolicyName:iDe,tracingPolicy:oDe,tracingPolicyName:rDe,userAgentPolicy:FPe,userAgentPolicyName:BPe},Symbol.toStringTag,{value:"Module"})),qw=t=>typeof t.communicationUserId=="string",Vf=t=>typeof t.phoneNumber=="string",HL=t=>typeof t.microsoftTeamsUserId=="string",xx=t=>typeof t.teamsAppId=="string",bDe=t=>typeof t.id=="string",Ap=t=>qw(t)?Object.assign(Object.assign({},t),{kind:"communicationUser"}):Vf(t)?Object.assign(Object.assign({},t),{kind:"phoneNumber"}):HL(t)?Object.assign(Object.assign({},t),{kind:"microsoftTeamsUser"}):xx(t)?Object.assign(Object.assign({},t),{kind:"microsoftTeamsApp"}):Object.assign(Object.assign({},t),{kind:"unknown"}),Bx=t=>{const e=Ap(t);switch(e.kind){case"communicationUser":return e.communicationUserId;case"microsoftTeamsUser":{const{microsoftTeamsUserId:i,rawId:r,cloud:o,isAnonymous:l}=e;if(r)return r;if(l)return`8:teamsvisitor:${i}`;switch(o){case"dod":return`8:dod:${i}`;case"gcch":return`8:gcch:${i}`;case"public":return`8:orgid:${i}`}return`8:orgid:${i}`}case"microsoftTeamsApp":{const{teamsAppId:i,rawId:r,cloud:o}=e;if(r)return r;switch(o){case"dod":return`28:dod:${i}`;case"gcch":return`28:gcch:${i}`}return`28:orgid:${i}`}case"phoneNumber":{const{phoneNumber:i,rawId:r}=e;return r||`4:${i}`}case"unknown":return e.id}},Xle=(t,e)=>({kind:"microsoftTeamsApp",teamsAppId:t,cloud:e}),ece=(t,e,i)=>({kind:"microsoftTeamsUser",microsoftTeamsUserId:t,isAnonymous:i,cloud:e}),qwt=t=>{if(t.startsWith("4:"))return{kind:"phoneNumber",phoneNumber:`${t.substring(2)}`};const e=t.split(":");if(e.length!==3)return{kind:"unknown",id:t};const i=`${e[0]}:${e[1]}:`,r=e[2];switch(i){case"8:teamsvisitor:":return{kind:"microsoftTeamsUser",microsoftTeamsUserId:r,isAnonymous:!0};case"8:orgid:":return ece(r,"public",!1);case"8:dod:":return ece(r,"dod",!1);case"8:gcch:":return ece(r,"gcch",!1);case"8:acs:":case"8:spool:":case"8:dod-acs:":case"8:gcch-acs:":return{kind:"communicationUser",communicationUserId:t};case"28:orgid:":return Xle(r,"public");case"28:gcch:":return Xle(r,"gcch");case"28:dod:":return Xle(r,"dod")}return{kind:"unknown",id:t}},IA=(t,e)=>{const i=Object.keys(t)[0],r=t[i];if(e in r)return r[e];throw new Error(`Property ${e} is required for identifier of type ${i}.`)},Wwt=t=>{const e=[];if(t.communicationUser!==void 0&&e.push("communicationUser"),t.microsoftTeamsUser!==void 0&&e.push("microsoftTeamsUser"),t.microsoftTeamsApp!==void 0&&e.push("microsoftTeamsApp"),t.phoneNumber!==void 0&&e.push("phoneNumber"),e.length>1)throw new Error(`Only one of the properties in ${JSON.stringify(e)} should be present.`)},TDe=t=>{var e,i,r,o,l,d;const h=Ap(t);switch(h.kind){case"communicationUser":return{rawId:Bx(h),communicationUser:{id:h.communicationUserId}};case"phoneNumber":return{rawId:(e=h.rawId)!==null&&e!==void 0?e:Bx(h),phoneNumber:{value:h.phoneNumber}};case"microsoftTeamsUser":return{rawId:(i=h.rawId)!==null&&i!==void 0?i:Bx(h),microsoftTeamsUser:{userId:h.microsoftTeamsUserId,isAnonymous:(r=h.isAnonymous)!==null&&r!==void 0?r:!1,cloud:(o=h.cloud)!==null&&o!==void 0?o:"public"}};case"microsoftTeamsApp":return{rawId:(l=h.rawId)!==null&&l!==void 0?l:Bx(h),microsoftTeamsApp:{appId:h.teamsAppId,cloud:(d=h.cloud)!==null&&d!==void 0?d:"public"}};case"unknown":return{rawId:h.id};default:throw new Error(`Can't serialize an identifier with kind ${h.kind}`)}},Kwt=t=>t.communicationUser?"communicationUser":t.phoneNumber?"phoneNumber":t.microsoftTeamsUser?"microsoftTeamsUser":t.microsoftTeamsApp?"microsoftTeamsApp":"unknown",ej=t=>{var e;Wwt(t);const{communicationUser:i,microsoftTeamsUser:r,microsoftTeamsApp:o,phoneNumber:l}=t,d=(e=t.kind)!==null&&e!==void 0?e:Kwt(t);return d==="communicationUser"&&i?{kind:"communicationUser",communicationUserId:IA({communicationUser:i},"id")}:d==="phoneNumber"&&l?{kind:"phoneNumber",phoneNumber:IA({phoneNumber:l},"value"),rawId:IA({phoneNumber:t},"rawId")}:d==="microsoftTeamsUser"&&r?{kind:"microsoftTeamsUser",microsoftTeamsUserId:IA({microsoftTeamsUser:r},"userId"),isAnonymous:IA({microsoftTeamsUser:r},"isAnonymous"),cloud:IA({microsoftTeamsUser:r},"cloud"),rawId:IA({microsoftTeamsUser:t},"rawId")}:d==="microsoftTeamsApp"&&o?{kind:"microsoftTeamsApp",teamsAppId:IA({microsoftTeamsApp:o},"appId"),cloud:IA({microsoftTeamsApp:o},"cloud"),rawId:IA({microsoftTeamsApp:t},"rawId")}:{kind:"unknown",id:IA({unknown:t},"rawId")}},Ga=t=>Bx(t),tj=t=>{const e=t.indexOf("+")===0?"4:"+t:t;return qwt(e)},JS=t=>typeof t=="string"?tj(t):t,CDe=t=>qw(t)||Vf(t)||HL(t)||bDe(t),Jwt=t=>{if(!t)return!1;const e=JS(t);return HL(e)};var tce,_De;function Ywt(){return _De||(_De=1,tce="1.25.0"),tce}var Qwt=Ywt();const Zwt=cL(Qwt),Xwt=t=>{const e=t.search(/alpha/);return e>=0?t.substring(0,e+5):t},ekt=t=>{switch(t){case"Call":return 1;case"Chat":return 2;case"CallWithChat":return 3;case"StatefulComponents":return 4;default:return 0}},$K=t=>{const i=ekt(t);return Xwt(`acr1${i}0/${Zwt}`)},Jd=(t,e)=>{if(!t)return"";if(!e)return t;const i=/{(\w+)}/g;return t.replace(i,(r,o)=>{const l=e[o];return l===void 0?`{${o}}`:l})},HK=(t,e=tkt(),i)=>{try{return JSON.stringify(t,e,i)}catch(r){console.error(r);return}},tkt=()=>{const t=new Set;return function(i,r){return typeof r!="object"?r:t.has(r)?"Visited-Ref":(t.add(r),r)}},cT=t=>t*ADe(),EDe=t=>t/ADe(),ADe=()=>{let t=parseFloat(getComputedStyle(document.documentElement).fontSize);return Number.isNaN(t)&&(t=16),t},YS=t=>t.type==="resize"||t.type==="scroll";function Fx(t){return Object.keys(t)}const _n=t=>`${t/16}rem`,$f=(t,e)=>{t[e.level](HK(e))};var jK="NOT_FOUND";function ikt(t){var e;return{get:function(r){return e&&t(e.key,r)?e.value:jK},put:function(r,o){e={key:r,value:o}},getEntries:function(){return e?[e]:[]},clear:function(){e=void 0}}}function nkt(t,e){var i=[];function r(h){var p=i.findIndex(function(f){return e(h,f.key)});if(p>-1){var g=i[p];return p>0&&(i.splice(p,1),i.unshift(g)),g.value}return jK}function o(h,p){r(h)===jK&&(i.unshift({key:h,value:p}),i.length>t&&i.pop())}function l(){return i}function d(){i=[]}return{get:r,put:o,getEntries:l,clear:d}}var akt=function(e,i){return e===i};function rkt(t){return function(i,r){if(i===null||r===null||i.length!==r.length)return!1;for(var o=i.length,l=0;l<o;l++)if(!t(i[l],r[l]))return!1;return!0}}function okt(t,e){var i=typeof e=="object"?e:{equalityCheck:e},r=i.equalityCheck,o=r===void 0?akt:r,l=i.maxSize,d=l===void 0?1:l,h=i.resultEqualityCheck,p=rkt(o),g=d===1?ikt(p):nkt(d,p);function f(){var y=g.get(arguments);if(y===jK){if(y=t.apply(null,arguments),h){var T=g.getEntries(),C=T.find(function(E){return h(E.value,y)});C&&(y=C.value)}g.put(arguments,y)}return y}return f.clearCache=function(){return g.clear()},f}function skt(t){var e=Array.isArray(t[0])?t[0]:t;if(!e.every(function(r){return typeof r=="function"})){var i=e.map(function(r){return typeof r=="function"?"function "+(r.name||"unnamed")+"()":typeof r}).join(", ");throw new Error("createSelector expects all input-selectors to be functions, but received the following types: ["+i+"]")}return e}function lkt(t){for(var e=arguments.length,i=new Array(e>1?e-1:0),r=1;r<e;r++)i[r-1]=arguments[r];var o=function(){for(var d=arguments.length,h=new Array(d),p=0;p<d;p++)h[p]=arguments[p];var g=0,f,y={memoizeOptions:void 0},T=h.pop();if(typeof T=="object"&&(y=T,T=h.pop()),typeof T!="function")throw new Error("createSelector expects an output function after the inputs, but received: ["+typeof T+"]");var C=y,E=C.memoizeOptions,I=E===void 0?i:E,w=Array.isArray(I)?I:[I],D=skt(h),F=t.apply(void 0,[function(){return g++,T.apply(null,arguments)}].concat(w)),x=t(function(){for(var L=[],z=D.length,H=0;H<z;H++)L.push(D[H].apply(null,arguments));return f=F.apply(null,L),f});return Object.assign(x,{resultFunc:T,memoizedResultFunc:F,dependencies:D,lastResult:function(){return f},recomputations:function(){return g},resetRecomputations:function(){return g=0}}),x};return o}var Xs=lkt(okt);const B5=t=>t.deviceManager,ij=(t,e)=>{var i;return(i=t.calls[e.callId])===null||i===void 0?void 0:i.role},IDe=(t,e)=>{var i,r;return(r=(i=t.calls[e.callId])===null||i===void 0?void 0:i.hideAttendeeNames)!==null&&r!==void 0?r:!1},nj=(t,e)=>{var i,r;return(r=(i=t.calls[e.callId])===null||i===void 0?void 0:i.capabilitiesFeature)===null||r===void 0?void 0:r.capabilities},ckt=(t,e)=>!!t.calls[e.callId],dkt=(t,e)=>{var i;return(i=t.calls[e.callId])===null||i===void 0?void 0:i.dominantSpeakers},wDe=(t,e)=>{var i;return(i=t.calls[e.callId])===null||i===void 0?void 0:i.remoteParticipants},ice=(t,e)=>{var i,r;return(r=(i=t.calls[e.callId])===null||i===void 0?void 0:i.raiseHand)===null||r===void 0?void 0:r.localParticipantRaisedHand},kDe=(t,e)=>{var i;return(i=t.calls[e.callId])===null||i===void 0?void 0:i.spotlight},nce=(t,e)=>{var i;return(i=t.calls[e.callId])===null||i===void 0?void 0:i.localParticipantReaction},ace=(t,e)=>{var i;return(i=t.calls[e.callId])===null||i===void 0?void 0:i.isScreenSharingOn},rce=(t,e)=>{var i;return(i=t.calls[e.callId])===null||i===void 0?void 0:i.isMuted},ukt=(t,e)=>{var i;return(i=t.calls[e.callId])===null||i===void 0?void 0:i.optimalVideoCount.maxRemoteVideoStreams},RDe=(t,e)=>{var i;return(i=t.calls[e.callId])===null||i===void 0?void 0:i.localVideoStreams},hkt=(t,e)=>{var i;return(i=t.calls[e.callId])===null||i===void 0?void 0:i.screenShareRemoteParticipant},oce=t=>{var e;return(e=t.callAgent)===null||e===void 0?void 0:e.displayName},sce=t=>Ga(t.userId),MDe=t=>t.latestErrors,pkt=t=>t.latestNotifications,PDe=(t,e)=>{var i;return(i=t.calls[e.callId])===null||i===void 0?void 0:i.diagnostics},Ux=(t,e)=>{var i;return(i=t.calls[e.callId])===null||i===void 0?void 0:i.state},DDe=t=>t.environmentInfo,gkt=(t,e)=>{},mkt=(t,e)=>{var i;return(i=t.calls[e.callId])===null||i===void 0?void 0:i.captionsFeature.captions},lce=(t,e)=>{var i;return(i=t.calls[e.callId])===null||i===void 0?void 0:i.captionsFeature.isCaptionsFeatureActive},fkt=(t,e)=>{var i;return(i=t.calls[e.callId])===null||i===void 0?void 0:i.captionsFeature.startCaptionsInProgress},LDe=(t,e)=>{var i,r;return((i=t.calls[e.callId])===null||i===void 0?void 0:i.captionsFeature.currentCaptionLanguage)===""?"en":(r=t.calls[e.callId])===null||r===void 0?void 0:r.captionsFeature.currentCaptionLanguage},ODe=(t,e)=>{var i;return(i=t.calls[e.callId])===null||i===void 0?void 0:i.captionsFeature.currentSpokenLanguage},vkt=(t,e)=>{var i;return(i=t.calls[e.callId])===null||i===void 0?void 0:i.captionsFeature.supportedCaptionLanguages},ykt=(t,e)=>{var i;return(i=t.calls[e.callId])===null||i===void 0?void 0:i.captionsFeature.supportedSpokenLanguages},Skt=(t,e)=>{var i,r;return(r=(i=t.calls[e.callId])===null||i===void 0?void 0:i.meetingConference)===null||r===void 0?void 0:r.conferencePhones},bkt=t=>Object.values(t.incomingCalls),Tkt=t=>Object.values(t.incomingCallsEnded),Ckt=(t,e)=>{var i,r;return(r=(i=t.calls[e.callId])===null||i===void 0?void 0:i.breakoutRooms)===null||r===void 0?void 0:r.assignedBreakoutRoom};var NDe,fo=typeof globalThis<"u"?globalThis:typeof window<"u"?window:typeof global<"u"?global:typeof self<"u"?self:{};function _kt(t){return t&&t.__esModule&&Object.prototype.hasOwnProperty.call(t,"default")?t.default:t}function bs(t,e,i){return t(i={path:e,exports:{},require:function(r,o){return Ekt(r,o??i.path)}},i.exports),i.exports}function xDe(t){if(t.__esModule)return t;var e=Object.defineProperty({},"__esModule",{value:!0});return Object.keys(t).forEach(function(i){var r=Object.getOwnPropertyDescriptor(t,i);Object.defineProperty(e,i,r.get?r:{enumerable:!0,get:function(){return t[i]}})}),e}function Ekt(){throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs")}/*! *****************************************************************************
	Copyright (C) Microsoft. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0

	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.

	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */(function(t){(function(e){var i=typeof fo=="object"?fo:typeof self=="object"?self:typeof this=="object"?this:Function("return this;")(),r=o(t);function o(l,d){return function(h,p){typeof l[h]!="function"&&Object.defineProperty(l,h,{configurable:!0,writable:!0,value:p}),d&&d(h,p)}}i.Reflect===void 0?i.Reflect=t:r=o(i.Reflect,r),e(r)})(function(e){var i=Object.prototype.hasOwnProperty,r=typeof Symbol=="function",o=r&&Symbol.toPrimitive!==void 0?Symbol.toPrimitive:"@@toPrimitive",l=r&&Symbol.iterator!==void 0?Symbol.iterator:"@@iterator",d=typeof Object.create=="function",h={__proto__:[]}instanceof Array,p=!d&&!h,g={create:d?function(){return $t(Object.create(null))}:h?function(){return $t({__proto__:null})}:function(){return $t({})},has:p?function(dt,yt){return i.call(dt,yt)}:function(dt,yt){return yt in dt},get:p?function(dt,yt){return i.call(dt,yt)?dt[yt]:void 0}:function(dt,yt){return dt[yt]}},f=Object.getPrototypeOf(Function),y=typeof process=="object"&&process.env&&process.env.REFLECT_METADATA_USE_MAP_POLYFILL==="true",T=y||typeof Map!="function"||typeof Map.prototype.entries!="function"?jt():Map,C=y||typeof Set!="function"||typeof Set.prototype.entries!="function"?Nt():Set,E=new(y||typeof WeakMap!="function"?Vt():WeakMap);function I(dt,yt,kt,je){if(ce(kt)){if(!Mt(dt))throw new TypeError;if(!vt(yt))throw new TypeError;return J(dt,yt)}if(!Mt(dt))throw new TypeError;if(!Te(yt))throw new TypeError;if(!Te(je)&&!ce(je)&&!X(je))throw new TypeError;return X(je)&&(je=void 0),Z(dt,yt,kt=ct(kt),je)}function w(dt,yt){function kt(je,Ae){if(!Te(je))throw new TypeError;if(!ce(Ae)&&!Pt(Ae))throw new TypeError;Le(dt,yt,je,Ae)}return kt}function D(dt,yt,kt,je){if(!Te(kt))throw new TypeError;return ce(je)||(je=ct(je)),Le(dt,yt,kt,je)}function F(dt,yt,kt){if(!Te(yt))throw new TypeError;return ce(kt)||(kt=ct(kt)),ne(dt,yt,kt)}function x(dt,yt,kt){if(!Te(yt))throw new TypeError;return ce(kt)||(kt=ct(kt)),le(dt,yt,kt)}function B(dt,yt,kt){if(!Te(yt))throw new TypeError;return ce(kt)||(kt=ct(kt)),he(dt,yt,kt)}function L(dt,yt,kt){if(!Te(yt))throw new TypeError;return ce(kt)||(kt=ct(kt)),Me(dt,yt,kt)}function z(dt,yt){if(!Te(dt))throw new TypeError;return ce(yt)||(yt=ct(yt)),pe(dt,yt)}function H(dt,yt){if(!Te(dt))throw new TypeError;return ce(yt)||(yt=ct(yt)),te(dt,yt)}function j(dt,yt,kt){if(!Te(yt))throw new TypeError;ce(kt)||(kt=ct(kt));var je=re(yt,kt,!1);if(ce(je)||!je.delete(dt))return!1;if(je.size>0)return!0;var Ae=E.get(yt);return Ae.delete(kt),Ae.size>0||E.delete(yt),!0}function J(dt,yt){for(var kt=dt.length-1;kt>=0;--kt){var je=(0,dt[kt])(yt);if(!ce(je)&&!X(je)){if(!vt(je))throw new TypeError;yt=je}}return yt}function Z(dt,yt,kt,je){for(var Ae=dt.length-1;Ae>=0;--Ae){var xe=(0,dt[Ae])(yt,kt,je);if(!ce(xe)&&!X(xe)){if(!Te(xe))throw new TypeError;je=xe}}return je}function re(dt,yt,kt){var je=E.get(dt);if(ce(je)){if(!kt)return;je=new T,E.set(dt,je)}var Ae=je.get(yt);if(ce(Ae)){if(!kt)return;Ae=new T,je.set(yt,Ae)}return Ae}function ne(dt,yt,kt){if(le(dt,yt,kt))return!0;var je=Ht(yt);return!X(je)&&ne(dt,je,kt)}function le(dt,yt,kt){var je=re(yt,kt,!1);return!ce(je)&&Ge(je.has(dt))}function he(dt,yt,kt){if(le(dt,yt,kt))return Me(dt,yt,kt);var je=Ht(yt);return X(je)?void 0:he(dt,je,kt)}function Me(dt,yt,kt){var je=re(yt,kt,!1);if(!ce(je))return je.get(dt)}function Le(dt,yt,kt,je){re(kt,je,!0).set(dt,yt)}function pe(dt,yt){var kt=te(dt,yt),je=Ht(dt);if(je===null)return kt;var Ae=pe(je,yt);if(Ae.length<=0)return kt;if(kt.length<=0)return Ae;for(var xe=new C,gt=[],Ye=0,Fe=kt;Ye<Fe.length;Ye++){var St=Fe[Ye];xe.has(St)||(xe.add(St),gt.push(St))}for(var Wt=0,Ii=Ae;Wt<Ii.length;Wt++)St=Ii[Wt],xe.has(St)||(xe.add(St),gt.push(St));return gt}function te(dt,yt){var kt=[],je=re(dt,yt,!1);if(ce(je))return kt;for(var Ae=Zt(je.keys()),xe=0;;){var gt=Ke(Ae);if(!gt)return kt.length=xe,kt;var Ye=it(gt);try{kt[xe]=Ye}catch(Fe){try{ot(Ae)}finally{throw Fe}}xe++}}function Se(dt){if(dt===null)return 1;switch(typeof dt){case"undefined":return 0;case"boolean":return 2;case"string":return 3;case"symbol":return 4;case"number":return 5;case"object":return dt===null?1:6;default:return 6}}function ce(dt){return dt===void 0}function X(dt){return dt===null}function ve(dt){return typeof dt=="symbol"}function Te(dt){return typeof dt=="object"?dt!==null:typeof dt=="function"}function Be(dt,yt){switch(Se(dt)){case 0:case 1:case 2:case 3:case 4:case 5:return dt}var kt="string",je=ni(dt,o);if(je!==void 0){var Ae=je.call(dt,kt);if(Te(Ae))throw new TypeError;return Ae}return qe(dt)}function qe(dt,yt){var kt,je;{var Ae=dt.toString;if(ht(Ae)&&!Te(je=Ae.call(dt))||ht(kt=dt.valueOf)&&!Te(je=kt.call(dt)))return je}throw new TypeError}function Ge(dt){return!!dt}function tt(dt){return""+dt}function ct(dt){var yt=Be(dt);return ve(yt)?yt:tt(yt)}function Mt(dt){return Array.isArray?Array.isArray(dt):dt instanceof Object?dt instanceof Array:Object.prototype.toString.call(dt)==="[object Array]"}function ht(dt){return typeof dt=="function"}function vt(dt){return typeof dt=="function"}function Pt(dt){switch(Se(dt)){case 3:case 4:return!0;default:return!1}}function ni(dt,yt){var kt=dt[yt];if(kt!=null){if(!ht(kt))throw new TypeError;return kt}}function Zt(dt){var yt=ni(dt,l);if(!ht(yt))throw new TypeError;var kt=yt.call(dt);if(!Te(kt))throw new TypeError;return kt}function it(dt){return dt.value}function Ke(dt){var yt=dt.next();return!yt.done&&yt}function ot(dt){var yt=dt.return;yt&&yt.call(dt)}function Ht(dt){var yt=Object.getPrototypeOf(dt);if(typeof dt!="function"||dt===f||yt!==f)return yt;var kt=dt.prototype,je=kt&&Object.getPrototypeOf(kt);if(je==null||je===Object.prototype)return yt;var Ae=je.constructor;return typeof Ae!="function"||Ae===dt?yt:Ae}function jt(){var dt={},yt=[],kt=function(){function gt(Ye,Fe,St){this._index=0,this._keys=Ye,this._values=Fe,this._selector=St}return gt.prototype["@@iterator"]=function(){return this},gt.prototype[l]=function(){return this},gt.prototype.next=function(){var Ye=this._index;if(Ye>=0&&Ye<this._keys.length){var Fe=this._selector(this._keys[Ye],this._values[Ye]);return Ye+1>=this._keys.length?(this._index=-1,this._keys=yt,this._values=yt):this._index++,{value:Fe,done:!1}}return{value:void 0,done:!0}},gt.prototype.throw=function(Ye){throw this._index>=0&&(this._index=-1,this._keys=yt,this._values=yt),Ye},gt.prototype.return=function(Ye){return this._index>=0&&(this._index=-1,this._keys=yt,this._values=yt),{value:Ye,done:!0}},gt}();return function(){function gt(){this._keys=[],this._values=[],this._cacheKey=dt,this._cacheIndex=-2}return Object.defineProperty(gt.prototype,"size",{get:function(){return this._keys.length},enumerable:!0,configurable:!0}),gt.prototype.has=function(Ye){return this._find(Ye,!1)>=0},gt.prototype.get=function(Ye){var Fe=this._find(Ye,!1);return Fe>=0?this._values[Fe]:void 0},gt.prototype.set=function(Ye,Fe){var St=this._find(Ye,!0);return this._values[St]=Fe,this},gt.prototype.delete=function(Ye){var Fe=this._find(Ye,!1);if(Fe>=0){for(var St=this._keys.length,Wt=Fe+1;Wt<St;Wt++)this._keys[Wt-1]=this._keys[Wt],this._values[Wt-1]=this._values[Wt];return this._keys.length--,this._values.length--,Ye===this._cacheKey&&(this._cacheKey=dt,this._cacheIndex=-2),!0}return!1},gt.prototype.clear=function(){this._keys.length=0,this._values.length=0,this._cacheKey=dt,this._cacheIndex=-2},gt.prototype.keys=function(){return new kt(this._keys,this._values,je)},gt.prototype.values=function(){return new kt(this._keys,this._values,Ae)},gt.prototype.entries=function(){return new kt(this._keys,this._values,xe)},gt.prototype["@@iterator"]=function(){return this.entries()},gt.prototype[l]=function(){return this.entries()},gt.prototype._find=function(Ye,Fe){return this._cacheKey!==Ye&&(this._cacheIndex=this._keys.indexOf(this._cacheKey=Ye)),this._cacheIndex<0&&Fe&&(this._cacheIndex=this._keys.length,this._keys.push(Ye),this._values.push(void 0)),this._cacheIndex},gt}();function je(gt,Ye){return gt}function Ae(gt,Ye){return Ye}function xe(gt,Ye){return[gt,Ye]}}function Nt(){return function(){function dt(){this._map=new T}return Object.defineProperty(dt.prototype,"size",{get:function(){return this._map.size},enumerable:!0,configurable:!0}),dt.prototype.has=function(yt){return this._map.has(yt)},dt.prototype.add=function(yt){return this._map.set(yt,yt),this},dt.prototype.delete=function(yt){return this._map.delete(yt)},dt.prototype.clear=function(){this._map.clear()},dt.prototype.keys=function(){return this._map.keys()},dt.prototype.values=function(){return this._map.values()},dt.prototype.entries=function(){return this._map.entries()},dt.prototype["@@iterator"]=function(){return this.keys()},dt.prototype[l]=function(){return this.keys()},dt}()}function Vt(){var dt=16,yt=g.create(),kt=je();return function(){function Fe(){this._key=je()}return Fe.prototype.has=function(St){var Wt=Ae(St,!1);return Wt!==void 0&&g.has(Wt,this._key)},Fe.prototype.get=function(St){var Wt=Ae(St,!1);return Wt!==void 0?g.get(Wt,this._key):void 0},Fe.prototype.set=function(St,Wt){return Ae(St,!0)[this._key]=Wt,this},Fe.prototype.delete=function(St){var Wt=Ae(St,!1);return Wt!==void 0&&delete Wt[this._key]},Fe.prototype.clear=function(){this._key=je()},Fe}();function je(){var Fe;do Fe="@@WeakMap@@"+Ye();while(g.has(yt,Fe));return yt[Fe]=!0,Fe}function Ae(Fe,St){if(!i.call(Fe,kt)){if(!St)return;Object.defineProperty(Fe,kt,{value:g.create()})}return Fe[kt]}function xe(Fe,St){for(var Wt=0;Wt<St;++Wt)Fe[Wt]=255*Math.random()|0;return Fe}function gt(Fe){return typeof Uint8Array=="function"?typeof crypto<"u"?crypto.getRandomValues(new Uint8Array(Fe)):typeof msCrypto<"u"?msCrypto.getRandomValues(new Uint8Array(Fe)):xe(new Uint8Array(Fe),Fe):xe(new Array(Fe),Fe)}function Ye(){var Fe=gt(dt);Fe[6]=79&Fe[6]|64,Fe[8]=191&Fe[8]|128;for(var St="",Wt=0;Wt<dt;++Wt){var Ii=Fe[Wt];Wt!==4&&Wt!==6&&Wt!==8||(St+="-"),Ii<16&&(St+="0"),St+=Ii.toString(16).toLowerCase()}return St}}function $t(dt){return dt.__=void 0,delete dt.__,dt}e("decorate",I),e("metadata",w),e("defineMetadata",D),e("hasMetadata",F),e("hasOwnMetadata",x),e("getMetadata",B),e("getOwnMetadata",L),e("getMetadataKeys",z),e("getOwnMetadataKeys",H),e("deleteMetadata",j)})})(NDe||(NDe={}));const Akt=8;function fd(){const t="abcdef0123456789",e=t.length;let i="";for(let r=0;r<Akt;r++)i+=t.charAt(Math.floor(Math.random()*e));return i}var aj={BAD_REQUEST:400,REQUEST_TIMEOUT:408,PRECONDITION_FAILED:412,UNPROCESSABLE_ENTITY:422,INTERNAL_ERROR:500};const we={CALL_AGENT_RTC:{INCOMING_CALL_HANDLING_INVALID_NOTIFICATION_PAYLOAD:{message:"Failed to handle incoming call notification. Invalid payload in the notification",code:400,subCode:3080,resultCategories:["UnexpectedServerError"]},INCOMING_CALL_HANDLING_FAILED_TO_EXTRACT_PAYLOAD:{message:"Failed to handle incoming call notification. Failed to extract payload from notification",code:400,subCode:3081,resultCategories:["UnexpectedClientError"]},INCOMING_CALL_HANDLING_CALL_ALREADY_HANDLED:{message:"Failed to handle incoming call notification. Notification ignored as this exact call is already ongoing",code:400,subCode:3082,resultCategories:["ExpectedError"]},INCOMING_CALL_HANDLING_IGNORING_DUPLICATE_NOTIFICATION:{message:"Failed to handle incoming call notification. Ignored duplicated notification for this call as it was already handled",code:400,subCode:3083,resultCategories:["ExpectedError"]},INCOMING_CALL_HANDLING_FAILED_TO_HANDLE_NOTIFICATION_FOR_GROUPID_CALL:{message:"Failed to handle incoming call notification. Failed to create call based on notification payload",code:400,subCode:3084,resultCategories:["UnexpectedClientError"]},INCOMING_CALL_HANDLING_BAD_NOTIFICATION_PAYLOAD:{message:"Failed to handle incoming call notification. The payload is improperly formatted and cannot be processed",code:400,subCode:3085,resultCategories:["UnexpectedClientError"]},INCOMING_CALL_HANDLING_CALL_SETUP_SUCCEEDED:{message:"Failed to handle incoming call notification. Notification handling succeeded and incoming call will ring",code:400,subCode:3086,resultCategories:["Success"]},INCOMING_CALL_HANDLING_CALL_SETUP_FAILED:{message:"Failed to handle incoming call notification. Failed to setup incoming call",code:400,subCode:3087,resultCategories:["UnexpectedClientError"]},INCOMING_CALL_HANDLING_BAD_NOTIFICATION_EVENT_TYPE:{message:"Failed to handle incoming call notification. Notification type is not a supported.",code:400,subCode:3088,resultCategories:["UnexpectedClientError"]},INCOMING_CALL_HANDLING_CALL_ALREADY_EXISTS:{message:"Failed to handle incoming call notification. Client already exists and in progress",code:400,subCode:3089,resultCategories:["ExpectedError"]},INCOMING_CALL_HANDLING_CALL_FAILED_CANNOT_CONNECT:{message:"Failed to handle incoming call notification. Couldn't complete setup due to network issues",code:400,subCode:3090,resultCategories:["UnexpectedClientError"]},INCOMING_CALL_HANDLING_CALL_FAILED_NO_SIGNALING:{message:"Failed to handle incoming call notification. Client couldn't start call signaling",code:400,subCode:3091,resultCategories:["UnexpectedClientError"]},INCOMING_CALL_HANDLING_CALL_FAILED_CONFLICT:{message:"Failed to handle incoming call notification. There is already an active call with the same caller",code:400,subCode:3092,resultCategories:["UnexpectedClientError"]},INCOMING_CALL_HANDLING_CALL_FAILED_PUSH_IGNORED:{message:"Failed to handle incoming call notification. The notification was ignored",code:400,subCode:3093,resultCategories:["UnexpectedClientError"]},INCOMING_CALL_HANDLING_CALL_FAILED_ANSWERED_ELSEWHERE:{message:"Failed to handle incoming call notification. The call was already answered elsewhere before this endpoint could process this notification",code:400,subCode:3094,resultCategories:["ExpectedError"]},INCOMING_CALL_HANDLING_CALL_FAILED_CALL_ALREADY_ENDED:{message:"Failed to handle incoming call notification. The call was either canceled by caller or timed out",code:400,subCode:3095,resultCategories:["ExpectedError"]},INCOMING_CALL_HANDLING_CALL_SETUP_IN_PROGRESS:{message:"Failed to handle incoming call notification. The call notification was processed successfully and another event will be raised when the notification processing completes with result code",code:400,subCode:3096,resultCategories:["ExpectedError"]}},CALL_CLIENT:{INIT_CALL_CLIENT:{message:"Failed to initialize CallClient. Please try again, if issue persists, gather browser console logs, and contact Azure Communication Services support.",code:500,subCode:4e4,resultCategories:["UnexpectedClientError"]},CREATE_CALL_AGENT:{message:"Failed to create CallAgent. Please try again, if issue persists, gather browser console logs, and contact Azure Communication Services support.",code:409,subCode:40001,resultCategories:["UnexpectedClientError"]},CREATE_TEAMS_CALL_AGENT:{message:"Failed to create TeamsCallAgent. Please try again, if issue persists, gather browser console logs, and contact Azure Communication Services support.",code:409,subCode:40002,resultCategories:["UnexpectedClientError"]},RELAY_INFO:{message:"Failed to create a URL object with the ICE server URL provided.",code:400,subCode:40003,resultCategories:["ExpectedError"]},RELAY_UNRECOGNIZED_SCHEMA:{message:"The ICE server url must contain 'turn', 'turns', or 'stun'.",code:400,subCode:40004,resultCategories:["ExpectedError"]},PROXY_SHORT_URL:{message:"Failed setup proxy, the url is too short",code:400,subCode:40005,resultCategories:["ExpectedError"]},PROXY_PROTOCOL:{message:"Failed setup proxy, the protocol is not https or http",code:400,subCode:40006,resultCategories:["ExpectedError"]},SETUP_PROXY:{message:"Failed to create a URL object with the proxy URL provided.",code:400,subCode:40007,resultCategories:["ExpectedError"]},ONE_CALL_AGENT_PER_CALL_CLIENT:{message:"CallClient instance can support only one CallAgent or TeamsCallAgent create new CallClient instance to create new CallAgent or TeamsCallAgent",code:400,subCode:40008,resultCategories:["ExpectedError"]},EMERGENCY_CODE_TOO_LONG:{message:"EmergencyCountryCode is invalid, max length is 10",code:400,subCode:40009,resultCategories:["ExpectedError"]}},CALL_STACK:{BAD_PROTOCOL:{message:"ACS Web Calling SDK must be used through https, file:, or localhost",code:400,subCode:40100,resultCategories:["ExpectedError"]},BASE_STACK_INIT_TIMEOUT:{message:"Failed to create CallAgent, timeout during initialization of the calling base stack. Please try again, if issue persists, gather browser console logs, .HAR file, and contact Azure Communication Services support.",code:408,subCode:40101,resultCategories:["UnexpectedClientError"]},BASE_STACK_INIT_FAILED:{message:"Failed to create CallAgent, failure during initialization of the calling base stack. Please try again, if issue persists, gather browser console logs, .HAR file, and contact Azure Communication Services support.",code:500,subCode:40102,resultCategories:["UnexpectedClientError"]},USER_STACK_NO_BASE_STACK:{message:"Failed to create CallAgent, failure to initialize calling user stack because calling base stack failed to create. Please try again, if issue persists, gather browser console logs, .HAR file, and contact Azure Communication Services support.",code:500,subCode:40103,resultCategories:["UnexpectedClientError"]},USER_STACK_INIT_TIMEOUT:{message:"Failed to create CallAgent, timeout during initialization of the calling user stack. Please try again, if issue persists, gather browser console logs, .HAR file, and contact Azure Communication Services support.",code:408,subCode:40104,resultCategories:["UnexpectedClientError"]},USER_STACK_INIT_FAILED:{message:"Failed to create CallAgent, failure during initialization of the calling user stack. Please try again, if issue persists, gather browser console logs, .HAR file, and contact Azure Communication Services support.",code:500,subCode:40105,resultCategories:["UnexpectedClientError"]},PARSE_CONFIG:{message:"Failed to set configurations for the calling stack. Please try again, if issue persists, gather browser console logs, .HAR file, and contact Azure Communication Services support.",code:500,subCode:40106,resultCategories:["UnexpectedClientError"]},SET_STACK_CONFIG:{message:"Failed to set user configurations for calling stack. Please try again, if issue persists, gather browser console logs, .HAR file, and contact Azure Communication Services support.",code:500,subCode:40107,resultCategories:["UnexpectedClientError"]},GET_DM:{message:"Failed to get device manager due to internal call stack undefined. Please try again, if issue persists, gather browser console logs, .HAR file, and contact Azure Communication Services support.",code:500,subCode:40108,resultCategories:["UnexpectedClientError"]},SET_STACK_PARAMS:{message:"Failed to set configuration parameters for the calling stack. Please try again, if issue persists, gather browser console logs, .HAR file, and contact Azure Communication Services support.",code:500,subCode:40109,resultCategories:["UnexpectedClientError"]},FOUND_UNDEFINED_CONFIGS:{message:"Fetched undefined configurations for the calling stack. Please try again, if issue persists, gather browser console logs, .HAR file, and contact Azure Communication Services support.",code:500,subCode:40110,resultCategories:["UnexpectedClientError"]},SIGNALING_SERVICE_CREATE_FAIL:{message:"Failed to connect to Azure Communication Services infrastructure. Please try again and check the browser's network requests. If the requests keep failing, gather browser console logs, .HAR file, and contact Azure Communication Services support.",code:500,subCode:40111,resultCategories:["UnexpectedClientError"]},SIGNALING_INIT_FAIL:{message:"Failed to initialize connection to Azure Communication Services infrastructure. Please try again and check the browser's network requests. If the requests keep failing, gather browser console logs, .HAR file, and contact Azure Communication Services support.",code:500,subCode:40112,resultCategories:["UnexpectedClientError"]},SIGNALING_SERVICE_ALREADY_INITIALIZED:{message:"Already connected to Azure Communication Services infrastructure. Please try again, if issue persists, gather browser console logs, .HAR file, and contact Azure Communication Services support.",code:500,subCode:40113,resultCategories:["ExpectedError"]},SIGNALING_SERVICE_CREATE_TIMEOUT:{message:"Failed to connect to Azure Communication Services infrastructure, timeout during initialization. Please try again and check the browser's network requests. If the requests keep failing, gather browser console logs, .HAR file, and contact Azure Communication Services support.",code:408,subCode:40114,resultCategories:["UnexpectedClientError"]},SIGNALING_UNINITIALIZED:{message:"Failed to create CallAgent, unable to initialize connection to Azure Communication Services infrastructure. Please try again and check the browser's network requests. If the requests keep failing, gather browser console logs, .HAR file, and contact Azure Communication Services support.",code:412,subCode:40115,resultCategories:["UnexpectedClientError"]},USER_STACK_MEDIA_INIT_FAILED:{message:"Failed to create CallAgent, media failure during initialization of the calling user stack. Please try again, if issue persists, gather browser console logs, .HAR file, and contact Azure Communication Services support.",code:500,subCode:40116,resultCategories:["UnexpectedClientError"]},USER_STACK_SIGNALING_INIT_FAILED:{message:"Failed to create CallAgent, signaling failure during initialization of the calling user stack. Please try again, if issue persists, gather browser console logs, .HAR file, and contact Azure Communication Services support.",code:500,subCode:40117,resultCategories:["UnexpectedClientError"]},USER_STACK_INTERNAL_INIT_FAILED:{message:"Failed to create CallAgent, internal stack failure during initialization of the calling user stack. Please try again, if issue persists, gather browser console logs, .HAR file, and contact Azure Communication Services support.",code:500,subCode:40118,resultCategories:["UnexpectedClientError"]},USER_STACK_MEDIA_INIT_FAILED_PLATFORM_NOT_SUPPORTED:{message:"Media stack is not supported on this platform",code:400,subCode:40119,resultCategories:["UnexpectedClientError"]},FETCH_CONFIG:{message:"Failed to fetch configurations for the calling stack",code:500,subCode:40120,resultCategories:["UnexpectedClientError"]}},CALL_AGENT:{PROXY_CUSTOM_TURN_FORBIDDEN:{message:"Using proxy or custom TURN for calls involving Teams is disabled",code:403,subCode:40200,resultCategories:["ExpectedError"]},PARSE_ACCESSTOKEN:{message:"Failed to parse AccessToken",code:500,subCode:40201,resultCategories:["UnexpectedClientError"]},CANT_CALL_YOURSELF:{message:"Call to yourself is not supported.",code:400,subCode:40202,resultCategories:["ExpectedError"]},ACS_ALREADY_DISPOSED:{message:"Call Agent is already disposed",code:409,subCode:40203,resultCategories:["ExpectedError"]},CTE_ALREADY_DISPOSED:{message:"Teams Call Agent is already disposed",code:409,subCode:40204,resultCategories:["ExpectedError"]},EVENT_SUBSCRIBE:{message:"Not able to subscribe to CallAgent event, unknown event name.",code:422,subCode:40205,resultCategories:["ExpectedError"]},EVENT_UNSUBSCRIBE:{message:"Not able to unsubscribe from CallAgent event, unknown event name.",code:422,subCode:40206,resultCategories:["ExpectedError"]},MESH_DEVICETYPE_V2:{message:"Device type must be msft-acs-mesh-deviceType-v2 to join immersive call",code:400,subCode:40207,resultCategories:["ExpectedError"]},STACK_NOT_INIT:{message:"Failed to start or join call, call stack did not initialize",code:500,subCode:40208,resultCategories:["UnexpectedClientError"]},INVALID_JOIN_LOCATOR:{message:"Invalid join locator specified.",code:400,subCode:40209,resultCategories:["ExpectedError"]},INVALID_MEETING_LINK:{message:"The provided Teams meeting link is invalid.",code:400,subCode:40210,resultCategories:["ExpectedError"]},GROUPCALL_THREADID:{message:"Starting a group call must include thread ID in StartTeamsGroupCallOptions.",code:400,subCode:40212,resultCategories:["ExpectedError"]},ONE_TO_ONE_THREADID:{message:"Starting a one to one with thread ID is invalid.",code:400,subCode:40213,resultCategories:["ExpectedError"]},CTE_DISPLAY_NAME:{message:"Display name is not allowed to be set for Teams users.",code:400,subCode:40214,resultCategories:["ExpectedError"]},DISPLAY_NAME_TOO_LONG:{message:"Display name is too long.",code:400,subCode:40215,resultCategories:["ExpectedError"]},INIT_FAIL:{message:"Failed to create CallAgent. Please try again, if issue persists, gather browser console logs and contact Azure Communication Services support.",code:500,subCode:40216,resultCategories:["UnexpectedClientError"]},GET_TOKEN_BEFORE_INIT:{message:"Attempted to get AccessToken before initialization",code:422,subCode:40217,resultCategories:["UnexpectedClientError"]},INVALID_PUSH_NOTIFICATION_DATA:{message:"Invalid push notification data provided. No 'incomingCallContext' key found in the PushNotificationData.",code:400,subCode:40218,resultCategories:["ExpectedError"]},PUSH_NOTIFICATION_FAIL:{message:"Failed to handle push notification",code:500,subCode:40219,resultCategories:["UnexpectedClientError"]},INCOMING_PUSH_NOTIFICATION_PAYLOAD_TOO_MANY_KEYS:{message:"Incoming Call push notification payload provided has too many keys. Only 'incomingCallContext' key is expected in the PushNotificationData.",code:400,subCode:40220,resultCategories:["ExpectedError"]},INCOMING_PUSH_NOTIFICATION_INVALID_PAYLOAD_NO_CONTEXT_PROVIDED:{message:"Invalid push notification data provided. No 'incomingCallContext' key found in the PushNotificatitonData.",code:400,subCode:40221,resultCategories:["ExpectedError"]},INCOMING_PUSH_NOTIFICATION_INVALID_PAYLOAD:{message:"The decoded 'incomingCallContext' data is invalid.",code:400,subCode:40222,resultCategories:["ExpectedError"]},INCOMING_PUSH_NOTIFICATION_ALREADY_PROCESSED:{message:"Incoming Call is already being processed",code:400,subCode:40223,resultCategories:["ExpectedError"]},INCOMING_PUSH_NOTIFICATION_FAILED_TO_PROCESS:{message:"Failed to handle Incoming Call push notification",code:500,subCode:40224,resultCategories:["UnexpectedClientError"]},INCOMING_PUSH_NOTIFICATION_CALL_MISSED:{message:"Missed call",code:400,subCode:40225,resultCategories:["ExpectedError"]},USERIDS_MUST_BE_OBJECTS:{message:"AssertIsObject failed. : userIds must be object",code:400,subCode:40226,resultCategories:["ExpectedError"]},USERIDS_CANNOT_BE_NULL:{message:"AssertNotNull failed. : userIds cannot be null",code:400,subCode:40227,resultCategories:["ExpectedError"]},ACS_CALLAGENT_ALREADY_EXSISTS:{message:"Failed to create CallAgent, an instance of CallAgent associated with this identity already exists. Please dispose the existing CallAgent, or create a new one with a different identity.",code:409,subCode:40228,resultCategories:["ExpectedError"]},ACS_CALLAGENT_TOKEN_ONLY:{message:"CallAgent must be created only with ACS token",code:403,subCode:40229,resultCategories:["ExpectedError"]},TEAMS_CALLAGENT_ALREADY_EXSISTS:{message:"Failed to create TeamsCallAgent, an instance of TeamsCallAgent associated with this identity already exists. Please dispose the existing TeamsCallAgent before creating a new one.",code:409,subCode:40230,resultCategories:["ExpectedError"]},TEAMS_CALLAGENT_TOKEN_ONLY:{message:"TeamsCallAgent must be created only with Teams token",code:403,subCode:40231,resultCategories:["ExpectedError"]},FAILED_TO_GET_TOKEN:{message:"Failed to get token",code:409,subCode:40232,resultCategories:["UnexpectedClientError"]},REFRESHED_TOKEN_INVALID_USERID:{message:"Refreshed AccessToken User Id doesnt match initial User Id.",code:400,subCode:40233,resultCategories:["ExpectedError"]},REFRESHED_TOKEN_RETRIES:{message:"Access token is expired and failed to fetch a valid one after retries.",code:400,subCode:40234,resultCategories:["ExpectedError"]},ACCESSTOKEN_EXPIRED:{message:"AccessToken expired",code:401,subCode:40235,resultCategories:["ExpectedError"]},UNSUPPORTED_TARGET_TYPE:{message:"Unsupported target participant type in ACS-Teams call",code:400,subCode:40236,resultCategories:["ExpectedError"]},UNSUPPORTED_TFL_MEETING_JOIN:{message:"Joining a Teams for life meeting is not supported",code:400,subCode:40238,resultCategories:["ExpectedError"]},SET_DEVICE_TYPE_NOT_ALLOWED:{message:"setDeviceType is not allowed",code:500,subCode:40239,resultCategories:["UnexpectedClientError"]}},DEVICE_MANAGER:{GET_MEDIA_STREAM_TRACK:{message:"Failed to get raw device stream track",code:500,subCode:40600,resultCategories:["UnexpectedClientError"]},GET_MEDIA_STREAM_DEVICE_UNAVAILABLE:{message:"Failed to get raw device stream track, make sure there is available device",code:412,subCode:40601,resultCategories:["UnexpectedClientError"]},GET_DM:{message:"Failed to get device manager.",code:500,subCode:40602,resultCategories:["UnexpectedClientError"]},EVENT_SUBSCRIBE:{message:"Not able to subscribe to DeviceManager event, unknown event name.",code:422,subCode:40603,resultCategories:["ExpectedError"]},EVENT_UNSUBSCRIBE:{message:"Not able to unsubscribe from DeviceManager event, unknown event name.",code:422,subCode:40604,resultCategories:["ExpectedError"]},ACCESS_DM:{message:"Unable to access device manager",code:500,subCode:40605,resultCategories:["UnexpectedClientError"]},SPEAKER_ENUMERATION_UNSUPPORTED:{message:"Failed to enumerate speakers, it is not supported to enumerate/select speakers on Android Chrome, iOS Safari, nor MacOS Safari.",code:405,subCode:40606,resultCategories:["ExpectedError"]},SELECT_MICROPHONE_TIMEOUT:{message:"Microphone selection timed out.",code:408,subCode:40607,resultCategories:["UnexpectedClientError"]},SELECT_MICROPHONE_FAIL:{message:"There was an issue with selecting the microphone",code:500,subCode:40608,resultCategories:["UnexpectedClientError"]},SELECT_SPEAKER_TIMEOUT:{message:"Speaker selection timed out.",code:408,subCode:40609,resultCategories:["UnexpectedClientError"]},SELECT_SPEAKER_FAIL:{message:"There was an issue with selecting the speaker",code:500,subCode:40610,resultCategories:["UnexpectedClientError"]},SPEAKER_SELECTION_UNSUPPORTED:{message:"This device does not support speaker selection.",code:405,subCode:40611,resultCategories:["ExpectedError"]},ONE_PERMISSION_ATLEAST:{message:"At least one permission must be requested",code:400,subCode:40612,resultCategories:["ExpectedError"]},PERMISSION_NOT_GRANTED_OR_FAILED:{message:"Failed to obtain permission to use microphone and/or camera, it was denied or it failed. Please ensure to allow the permissions in the browser's setttings and in the OS setttings.",code:400,subCode:40613,resultCategories:["ExpectedError"]},ADP_FAIL:{message:"Failed to ask for device permissions Please ensure to allow the permissions in the browser's setttings and in the OS setttings and try again. If issue persists, gather browser console logs and contact Azure Communication Services support.",code:500,subCode:40614,resultCategories:["UnexpectedClientError"]},INVALID_DEVICE:{message:"Invalid AudioDeviceInfo object passed in. Ensure it has an Id.",code:400,subCode:40615,resultCategories:["ExpectedError"]},DEVICE_NOT_SELECTABLE:{message:"The device is not selectable",code:400,subCode:40616,resultCategories:["ExpectedError"]},DEVICE_ENUMERATING_FAIL:{message:"Failed to enumerate device.",code:500,subCode:40617,resultCategories:["UnexpectedClientError"]}},CALL:{OPERATION_NOT_ALLOWED_DURING_EMERGENCY_CALL:{message:"Attempted invalid operation during Emergency Call.",code:500,subCode:41e3,resultCategories:["ExpectedError"]},OPERATION_FAILED:{message:"{0} failed",code:500,subCode:41001,resultCategories:["UnexpectedClientError"]},REMOTE_AUDIO_GET_MEDIA_STREAM_UNDEFINED:{message:"Unable to get remote audio stream, getMediaStream returned undefined",code:500,subCode:41002,resultCategories:["UnexpectedClientError"]},REMOTE_AUDIO_GET_MEDIA_STREAM_RETURNED_ERROR:{message:"Unable to get remote audio stream, getMediaStream returned error",code:500,subCode:41003,resultCategories:["UnexpectedClientError"]},REMOTE_AUDIO_GET_MEDIA_STREAM_DISABLED:{message:"Getting raw audio media stream is currently disabled by Azure Communication Services.",code:409,subCode:41004,resultCategories:["ExpectedError"]},ACCEPT_INCOMING_CALL:{message:"Failed to accept the Incoming Call",code:500,subCode:41005,resultCategories:["UnexpectedClientError"]},ACCEPT_NOT_RINGING:{message:"Failed to accept the incoming call, it is not in the Ringing state. Subcscribe to CallAgent's 'incomingCall' event to accept the incoming call.",code:400,subCode:41006,resultCategories:["ExpectedError"]},REJECT_NOT_RINGING:{message:"Failed to reject the incoming call, it is not in the Ringing state. Subcscribe to CallAgent's 'incomingCall' event to reject the incoming call.",code:400,subCode:41007,resultCategories:["ExpectedError"]},LOCAL_AUDIO_GET_MEDIA_STREAM:{message:"Failed to get raw stream from local audio stream",code:500,subCode:41008,resultCategories:["UnexpectedClientError"]},LOCAL_AUDIO_SET_MEDIA_STREAM:{message:"Failed to set raw input audio stream",code:500,subCode:41009,resultCategories:["UnexpectedClientError"]},LOCAL_AUDIO_UNSET_MEDIA_STREAM:{message:"Failed to unset raw input audio stream",code:500,subCode:41010,resultCategories:["UnexpectedClientError"]},LOCAL_AUDIO_UNDEFINED_STACK:{message:"Failed to process audio because the calling stack is undefined. Please collect browser console logs and contact Azure Communication Services support.",code:500,subCode:41011,resultCategories:["UnexpectedClientError"]},REMOVE_LOCAL_VIDEO_ON_BAD_UFD:{message:"Removing local video stream due to video fail UFD being raised before call connected. Please ensure to allow video permissions in the browser's setttings and in the OS setttings, and ensure the camera device is not being used by another process.",code:409,subCode:41012,resultCategories:["UnexpectedClientError"]},STOP_AUDIO_ON_BAD_UFD:{message:"Failed to stop audio on microphone device not functioning or capture mute event {0} with value {1}",code:400,subCode:41013,resultCategories:["UnexpectedClientError"]},INSTANTIATE_CALL:{message:"Failed to instantiate the Call",code:500,subCode:41014,resultCategories:["UnexpectedClientError"]},MIC_MUTE:{message:"Failed to mute microphone. Please try again, if the issue persists, gather browser console logs and contact Azure Communication Services support.",code:500,subCode:41015,resultCategories:["UnexpectedClientError"]},MIC_UNMUTE:{message:"Failed to unmute microphone. Please try again, if the issue persists, gather browser console logs and contact Azure Communication Services support.",code:400,subCode:41016,resultCategories:["UnexpectedClientError"]},MIC_UNMUTE_AND_STARTAUDIO:{message:"Failed to recover the microphone audio after bad microphone UFD recovered. Please try again, if the issue persists, gather browser console logs and contact Azure Communication Services support.",code:410,subCode:41017,resultCategories:["UnexpectedClientError"]},MUTE_ALL_PARTICIPANTS_DISABLED:{message:"Mute other participants is currently disabled by ACS service.",code:403,subCode:41018,resultCategories:["ExpectedError"]},MUTE_ALL_PARTICIPANTS:{message:"Failed to mute all remote participants",code:500,subCode:41019,resultCategories:["UnexpectedClientError"]},MUTE_INCOMING_AUDIO:{message:"Failed to mute incoming audio",code:500,subCode:41020,resultCategories:["UnexpectedClientError"]},UNMUTE_INCOMING_AUDIO:{message:"Failed to unmute incoming audio",code:500,subCode:41021,resultCategories:["UnexpectedClientError"]},DTMF_TONE:{message:"Failed to send DTMF tone",code:400,subCode:41022,resultCategories:["UnexpectedClientError"]},INVALID_DTMF_TONE:{message:"Invalid value passed to DtfmTone",code:422,subCode:41023,resultCategories:["ExpectedError"]},START_AUDIO_BEFORE_VIDEO:{message:"Failed to start audio before starting video",code:500,subCode:41024,resultCategories:["UnexpectedClientError"]},STREAM_NULL:{message:"Failed to start video, LocalVideoStream instance is invalid or empty. Please pass in a LocalVideoStream instance.",code:400,subCode:41025,resultCategories:["ExpectedError"]},STREAM_IS_NOT_LVS:{message:"Failed to start video, localVideoStream is not an instance of LocalVideoStream",code:400,subCode:41026,resultCategories:["ExpectedError"]},VIDEO_ALREADY_ON:{message:"Failed to start video, video is already started.",code:400,subCode:41027,resultCategories:["ExpectedError"]},VIDEO_SET_MEDIA_STREAM:{message:"Failed to set media stream",code:500,subCode:41028,resultCategories:["UnexpectedClientError"]},START_VIDEO:{message:"Failed to start video",code:500,subCode:41029,resultCategories:["UnexpectedClientError"]},VIDEO_ALREADY_OFF:{message:"Failed to stop video, video is already stopped.",code:400,subCode:41030,resultCategories:["ExpectedError"]},VIDEO_UNDEFINED_STACK:{message:"Failed to start video because the calling stack is undefined. Please gether browser console logs, .HAR files, and contact Aure Communication Services support.",code:500,subCode:41031,resultCategories:["UnexpectedClientError"]},STOP_WRONG_STREAM:{message:"Failed to stop video, invalid argument. LocalVideoStream used as an input is currently not being sent.",code:400,subCode:41032,resultCategories:["ExpectedError"]},HOLD_CALL:{message:"Failed to hold the call. Please try again, if the issue persists, gather browser console logs and contact Azure Communication Services support.",code:500,subCode:41033,resultCategories:["UnexpectedClientError"]},RESUME_CALL:{message:"Failed to resume the call.Please try again, if the issue persists, gather browser console logs and contact Azure Communication Services support.",code:500,subCode:41034,resultCategories:["UnexpectedClientError"]},SS_ALREADY_ON:{message:"Failed to start screen share, screen share is already started.",code:400,subCode:41035,resultCategories:["ExpectedError"]},SS_RAW_STREAM_IS_NOT_LVS:{message:"Failed to start raw screen sharing, localVideoStream is not an instance of LocalVideoStream",code:400,subCode:41036,resultCategories:["ExpectedError"]},SS_RAW_STREAM_UNDEFINED:{message:"Unable to get media stream from local video stream for raw media screen sharing. Please try again, if the issue persists, gather browser console logs and contact Azure Communication Services support.",code:500,subCode:41037,resultCategories:["UnexpectedClientError"]},SS_RAW_STREAM_SET:{message:"Failed to set raw media stream for screen sharing. Please try again, if the issue persists, gather browser console logs and contact Azure Communication Services support.",code:422,subCode:41038,resultCategories:["UnexpectedClientError"]},SS_RAW_STREAM_GET:{message:"Failed to get raw screen sharing stream. Please try again, if the issue persists, gather browser console logs and contact Azure Communication Services support.",code:422,subCode:41039,resultCategories:["UnexpectedClientError"]},START_SS:{message:"Failed to start screen sharing",code:500,subCode:41040,resultCategories:["UnexpectedClientError"]},SS_ALREADY_OFF:{message:"Failed to stop screen share, screen share is already stopped.",code:400,subCode:41041,resultCategories:["ExpectedError"]},EVENT_SUBSCRIBE:{message:"Not able to subscribe to Call event, unknown event name.",code:422,subCode:41042,resultCategories:["ExpectedError"]},EVENT_UNSUBSCRIBE:{message:"Not able to unsubscribe from Call event, unknown event name.",code:422,subCode:41043,resultCategories:["ExpectedError"]},ONLY_SINGLE_VIDEO_STREAM:{message:"Only single LocalVideoStream is supported currently",code:400,subCode:41044,resultCategories:["ExpectedError"]},NOT_INSTANCE_OF_LVS:{message:"Stream is not an instance of LocalVideoStream",code:400,subCode:41045,resultCategories:["ExpectedError"]},ONLY_SINGLE_AUDIO_STREAM:{message:"Only single LocalAudioStream is supported currently",code:400,subCode:41046,resultCategories:["ExpectedError"]},NOT_INSTANCE_OF_LAS:{message:"Stream is not an instance of LocalAudioStream",code:400,subCode:41047,resultCategories:["ExpectedError"]},VIDEO_FAILED_TO_START:{message:"Failed to start video during call setup process. Please ensure to allow video permissions in the browser's setttings and in the OS setttings, and ensure the camera device is not being used by another process.",code:410,subCode:41048,resultCategories:["UnexpectedClientError"]},AUDIO_FAILED_TO_START:{message:"Failed to start audio during call setup process. Please try again, if the issue persists, gather browser console logs and contact Azure Communication Services support.",code:400,subCode:41049,resultCategories:["UnexpectedClientError"]},LARGE_MEETING_FORCE_ISAVAILABLE:{message:"Failed to force isAvailable flag to false during large meeting",code:500,subCode:41050,resultCategories:["UnexpectedClientError"]},LARGE_MEETING_DISPOSE_VIEW:{message:"Failed to dispose view in large meeting",code:500,subCode:41051,resultCategories:["UnexpectedClientError"]},ADD_UNKNOWN:{message:"Not able to add unkown participant.",code:400,subCode:41052,resultCategories:["ExpectedError"]},PARTICIPANT_ALREADY_IN_CALL:{message:"Participant is already in the call.",code:400,subCode:41053,resultCategories:["ExpectedError"]},PARTICIPANT_NOT_IN_CALL:{message:"Failed to remove the specified participant. The participant is not in the call.",code:400,subCode:41054,resultCategories:["ExpectedError"]},CTE_ADDPARTICIPANT_NO_THREAD_ID:{message:"Add participant failed: thread ID is missing in options.",code:400,subCode:41055,resultCategories:["ExpectedError"]},CTE_VOICE_NOT_ENABLED:{message:"Failed to start or join to the call, Teams Enterprise voice policy is not enabled for this Azure Communication Services resource. Follow the tutorial online to enable it.",code:412,subCode:41056,resultCategories:["ExpectedError"]},SERVER_CALL_ID:{message:"Failed to get server call Id",code:500,subCode:41057,resultCategories:["UnexpectedClientError"]},VOLUME_TRACK:{message:"Failed to get the MediaStream to initialize the Volume indicator. Please try again, if the issue persists, gather browser console logs and contact Azure Communication Services support.",code:500,subCode:41058,resultCategories:["UnexpectedClientError"]},VOLUME_INIT:{message:"Failed to setup volume calcualtor using AudioContext, please retry getVolumeindicator on a working audio stream with exponential backoff",code:500,subCode:41059,resultCategories:["UnexpectedClientError"]},VOLUME_EVENT_SUBSCRIBE:{message:"Not able to subscribe to Volume Indicator event, unknown event name.",code:400,subCode:41060,resultCategories:["ExpectedError"]},VOLUME_EVENT_UNSUBSCRIBE:{message:"Not able to unsubscribe from Volume Indicator event, unknown event name.",code:400,subCode:41061,resultCategories:["ExpectedError"]},VOLUME_GET:{message:"Failed to setup volume calculator, please retry after exponential backoff",code:500,subCode:41062,resultCategories:["UnexpectedClientError"]},GET_SERVER_CALL_ID:{message:"Failed to get serverCallId, serverCallId is empty",code:404,subCode:41063,resultCategories:["UnexpectedClientError"]},MEDIA_CONSTRAINTS_DISABLED:{message:"Setting call constraint is currently disabled by ACS service.",code:409,subCode:41064,resultCategories:["ExpectedError"]},SET_CONSTRAINTS_START_OR_ACCEPT:{message:"Error setting call constraints at call setup. Please try again, if the issue persists, gather browser console logs and contact Azure Communication Services support.",code:500,subCode:41065,resultCategories:["UnexpectedClientError"]},SET_CONSTRAINTS_MID_CALL:{message:"Error setting call constraints during mid-call",code:500,subCode:41066,resultCategories:["UnexpectedClientError"]},SET_CONSTRAINTS:{message:"Error settting video constraints during call settup or mid-call. Please try again, if the issue persists, gather browser console logs and contact Azure Communication Services support.",code:500,subCode:41067,resultCategories:["UnexpectedClientError"]},ACCEPT_VIDEO_CONSTRAINTS:{message:"Error setting video constraints during call accept",code:500,subCode:41068,resultCategories:["UnexpectedClientError"]},CALLSTART_VIDEO_CONSTRAINTS:{message:"Error setting video constraints during call start",code:500,subCode:41069,resultCategories:["UnexpectedClientError"]},SET_VIDEO_CONSTRAINTS:{message:"Failed to set call constraints during mid call",code:500,subCode:41070,resultCategories:["UnexpectedClientError"]},START_SS_CALL_NOT_CONNECTED:{message:"Failed to start screen share, call is not in Connected state. Subscribe to the Call's 'statteChanged' event to know when the call is connected.",code:412,subCode:41071,resultCategories:["ExpectedError"]},STOP_SS_CALL_NOT_CONNECTED:{message:"Failed to stop screen sharing. Call must be in connected state",code:412,subCode:41072,resultCategories:["ExpectedError"]},ACCESS_RAW_MEDIA_STREAM_DISABLED:{message:"Failed to get or set custom MediaStream, this functionality is currently disabled by Azure Communication Services.",code:412,subCode:41073,resultCategories:["ExpectedError"]},ACCESS_RAW_MEDIA_STREAM_UNDEFINED_FUNC:{message:"The raw media stream function is currently not available",code:500,subCode:41074,resultCategories:["UnexpectedClientError"]},SS_RAW_STREAM_LVS_IS_NOT_RAW_MEDIA:{message:"Failed to start raw screen sharing, localVideoStream doesn't contain a raw media stream",code:400,subCode:41075,resultCategories:["ExpectedError"]},START_AUDIO_STREAM_FAILED:{message:"Failed to start audio stream.",code:400,subCode:41076,resultCategories:["UnexpectedClientError"]},STOP_VIDEO_FAILED:{message:"Failed to stop video.",code:500,subCode:41077,resultCategories:["UnexpectedClientError"]},START_AUDIO_LAS_NOT_RAW_MEDIA:{message:"Failed to start raw audio, localAudioStream doesn't contain a raw media stream. To start raw audio, the LocalAudioStream passed in, must be constructed with a MediaStream object.",code:400,subCode:41083,resultCategories:["ExpectedError"]},STOP_AUDIO_LAS_NOT_RAW_MEDIA:{message:"Failed to stop raw audio, localAudioStream doesn't contain a raw media stream. To stop raw audio, the current LocalAudioStream in the call must have a MediaStream as the source.",code:400,subCode:41084,resultCategories:["ExpectedError"]},TEAMS_INVALID_THREAD_ID:{message:"Thread ID is invalid.",code:400,subCode:41085,resultCategories:["ExpectedError"]},MUTE_ALL_PARTICIPANTS_PSTN_UNSUPPORTED:{message:"Failed to mute ineligible PSTN remote participants.",code:405,subCode:41086,resultCategories:["ExpectedError"]},MUTE_ALL_PARTICIPANTS_CALL_NOT_CONNECTED:{message:"Failed to mute all remote participants. Call must be in connected state",code:412,subCode:41087,resultCategories:["ExpectedError"]},STOP_AUDIO_STREAM_CALL_NOT_CONNECTED:{message:"Failed to stop audio stream. Call must be in connected state",code:412,subCode:41088,resultCategories:["ExpectedError"]},ADD_PARTICIPANT_CALL_NOT_CONNECTED:{message:"Failed to add participant. Call must be in connected state",code:412,subCode:41089,resultCategories:["ExpectedError"]},REMOVE_PARTICIPANT_CALL_NOT_CONNECTED:{message:"Failed to remove participant. Call must be in connected state",code:412,subCode:41090,resultCategories:["ExpectedError"]},STOP_AUDIO_STREAM_FAILED:{message:"Failed to stop audio stream.",code:400,subCode:41091,resultCategories:["UnexpectedClientError"]},MUTE_ALL_PARTICIPANTS_NONCONNECTED_UNSUPPORTED:{message:"Failed to mute remote participants that are not in connected state.",code:405,subCode:41092,resultCategories:["ExpectedError"]},MUTE_ALL_PARTICIPANTS_1_TO_1_UNSUPPORTED:{message:"Failed to mute remote participants as mute others in 1-1 calls are unsupported.",code:405,subCode:41093,resultCategories:["ExpectedError"]},IP_AUDIO_NOT_ALLOWED:{message:"Failed to mute/unmute as VOIP Audio is not allowed in this call.",code:403,subCode:41104,resultCategories:["ExpectedError"]},IP_VIDEO_NOT_ALLOWED:{message:"Failed to start/stop video as VOIP Video is not allowed in this call.",code:403,subCode:41105,resultCategories:["ExpectedError"]},MIC_DISABLED:{message:"Failed to unmute as mic is disabled in this call.",code:403,subCode:41106,resultCategories:["ExpectedError"]},CAMERA_DISABLED:{message:"Failed to start video as camera is disabled in this call.",code:403,subCode:41107,resultCategories:["ExpectedError"]},UNMUTE_CONSENT_RESTRICTED:{message:"Unmute operation not allowed for participants that have not provided consent for recording or transcription as explicit consent is enabled.",code:400,subCode:41108,resultCategories:["ExpectedError"]},VIDEOSTART_CONSENT_RESTRICTED:{message:"Video start operation not allowed for participants that have not provided consent for recording or transcription as explicit consent is enabled.",code:400,subCode:41109,resultCategories:["ExpectedError"]},SCREENSHARE_CONSENT_RESTRICTED:{message:"Screen Share operation not allowed for participants that have not provided consent for recording or transcription as explicit consent is enabled.",code:400,subCode:41110,resultCategories:["ExpectedError"]},CONSENT_NOT_SUPPORTED_1TO1:{message:"Bad request. Explicit consent is not supported for 1:1 calls.",code:400,subCode:41111,resultCategories:["ExpectedError"]},FAILED_TO_SET_CONSENT:{message:"Failed to set user consent publish state. Please try again, if the issue persists, gather browser console logs and contact Azure Communication Services support.",code:500,subCode:41112,resultCategories:["UnexpectedServerError"]},CONSENT_ALREADY_SET_OR_NOT_REQUIRED:{message:"Bad request. Consent for recording or transcription is either already provided or it is not required for the call.",code:400,subCode:41113,resultCategories:["ExpectedError"]}},LOBBY:{EVENT_SUBSCRIBE:{message:"Not able to subscribe to Lobby event, unknown event name.",code:422,subCode:41800,resultCategories:["ExpectedError"]},EVENT_UNSUBSCRIBE:{message:"Not able to unsubscribe from Lobby event, unknown event name.",code:422,subCode:41801,resultCategories:["ExpectedError"]},CONV_UNSUPPORTED:{message:"Current conversation type doesn't support lobby admit and reject",code:400,subCode:41802,resultCategories:["ExpectedError"]},ALREADY_IN_MEETING:{message:"Participant is already in the meeting.",code:400,subCode:41803,resultCategories:["ExpectedError"]},NOT_IN_LOBBY:{message:"Participant is not in the lobby.",code:400,subCode:41804,resultCategories:["ExpectedError"]},UNAUTHORIZED_ADMIT_REJECT:{message:"only Organizer, Co-organizer or Presenter can admit/reject participants from lobby",code:403,subCode:41805,resultCategories:["ExpectedError"]}},CTE_MID_TIER_POLICY_SERVICE:{TEAMS_USER_ID_NOT_PROVIDED:{message:"Failed to fetch Teams user policies and settings cannot proceed, because teams user Id was not found in the AccessToken.",code:400,subCode:41900,resultCategories:["ExpectedError"]},FETCH_POLICY:{message:"Error Fetching Teams user policy from ACS MiddleTier Service",code:500,subCode:41901,resultCategories:["UnexpectedServerError"]},DERIVE_EMERGENCY_POLICY:{message:"Unable to derive emergency policy from ACS MiddleTier Service response",code:500,subCode:41902,resultCategories:["UnexpectedServerError"]},TEAMSUSER_CALLINGPOLICY_FETCHING_FAILED:{message:"Unable to fetch Teams calling policy from ACS MiddleTier Service response. Please try again, if the issue persists, gather browser console logs, .HAR file, and contact Azure Communication Services support.",code:500,subCode:41903,resultCategories:["UnexpectedServerError"]},TEAMSUSER_MEETINGPOLICY_FETCHING_FAILED:{message:"Unable to fetch Teams meeting policy from ACS MiddleTier Service response. Please try again, if the issue persists, gather browser console logs, .HAR file, and contact Azure Communication Services support.",code:500,subCode:41904,resultCategories:["UnexpectedServerError"]},TEAMSUSER_FEATURETYPE_TEAMSPROMGMT_FETCHING_FAILED:{message:"Unable to fetch feature types from ACS MiddleTier Service response. Please try again, if the issue persists, gather browser console logs, .HAR file, and contact Azure Communication Services support.",code:500,subCode:41905,resultCategories:["UnexpectedServerError"]},CREATETHREAD_FAILED:{message:"Unable to create thread for the Teams User groupcall from ACS MiddleTier Service response",code:500,subCode:41906,resultCategories:["UnexpectedServerError"]},ADD_PARTICIPANTS_TO_THREAD_FAILED:{message:"Unable to add particpant for the thread for Teams groupcall from ACS MiddleTier Service",code:500,subCode:41907,resultCategories:["UnexpectedServerError"]}},REMOTE_PARTICIPANT:{MUTE_PARTICIPANT_DISABLED:{message:"Mute other participants is disabled by ACS service.",code:403,subCode:42e3,resultCategories:["ExpectedError"]},MUTE_PARTICIPANT_FAILED:{message:"Failed to mute specific participant",code:500,subCode:42001,resultCategories:["UnexpectedClientError"]},EVENT_SUBSCRIBE:{message:"Not able to subscribe to RemoteParticipant event, unknown event name.",code:422,subCode:42002,resultCategories:["ExpectedError"]},EVENT_UNSUBSCRIBE:{message:"Not able to unsubscribe from RemoteParticipant event, unknown event name.",code:422,subCode:42003,resultCategories:["ExpectedError"]},MUTE_PARTICIPANT_PSTN_UNSUPPORTED:{message:"The scenario to soft mute a PSTN participant is not supported.",code:405,subCode:42004,resultCategories:["ExpectedError"]},MUTE_PARTICIPANT_NONCONNECTED_UNSUPPORTED:{message:"The scenario to soft mute a participant who is not connected is not supported.",code:405,subCode:42005,resultCategories:["ExpectedError"]},MUTE_PARTICIPANT_1_TO_1_UNSUPPORTED:{message:"The scenario to soft mute a participant is a 1-1 call is not supported.",code:405,subCode:42006,resultCategories:["ExpectedError"]}},LOCAL_VIDEO_STREAM:{SOURCE_UNAVAILABLE:{message:"Failed to start video, video device is being used by another process/application. Stop your camera from being used in the other process/application and try again.",code:412,subCode:43e3,resultCategories:["ExpectedError"]},PERMISSION_DENIED:{message:"Failed to start video, permission was not granted to use selected video device. Ensure video device permissions are allowed in the browser's settings and in the system's setttings.",code:403,subCode:43001,resultCategories:["ExpectedError"]},UNKNOWN:{message:"Failed to start video, unknown error. Please try again. If the issue persists, contact Azure Communication Services support.",code:500,subCode:43002,resultCategories:["UnexpectedClientError"]},WRONG_STREAM_TYPE:{message:"Failed to create local video stream, source was not of type VideoDeviceInfo or MediaStream",code:400,subCode:43003,resultCategories:["ExpectedError"]},SWITCH_SOURCE_WRONG_TYPE:{message:"Failed to switch video device, invalid input. Input must be of a VideoDeviceInfo type.",code:400,subCode:43004,resultCategories:["ExpectedError"]},SWITCH_SAME_SOURCE:{message:"Failed to switch video device, unable to switch to the same video device, it's already selected.",code:400,subCode:43005,resultCategories:["ExpectedError"]},CANT_GET_DEVICE_TYPE:{message:"Unable to get device type",code:500,subCode:43006,resultCategories:["UnexpectedClientError"]},VIDEO_GET_MEDIA_STREAM:{message:"Failed to get raw video stream. Please try again, if the issue persists, gather browser console logs and contact Azure Communication Services support.",code:500,subCode:43007,resultCategories:["UnexpectedClientError"]},SET_MEDIA_STREAM_WRONG_TYPE:{message:"Failed to set media stream source is not MediaStream",code:400,subCode:43008,resultCategories:["ExpectedError"]},SET_MEDIA_STREAM_UNDEFINED_FUNC:{message:"Failed to set raw video stream. Found undefined function. Gather browser console logs and contact Azure Communication Services support.",code:500,subCode:43009,resultCategories:["UnexpectedClientError"]},SET_MEDIA_STREAM:{message:"Failed to set raw video stream. Please try again, if the issue persists, gather browser console logs and contact Azure Communication Services support.",code:500,subCode:43010,resultCategories:["UnexpectedClientError"]},EVENT_SUBSCRIBE:{message:"Not able to subscribe to LocalVideoStream event, unknown event name.",code:422,subCode:43011,resultCategories:["ExpectedError"]},EVENT_UNSUBSCRIBE:{message:"Not able to unsubscribe from LocalVideoStream event, unknown event name.",code:422,subCode:43012,resultCategories:["ExpectedError"]},DEVICES_NOT_FOUND:{message:"Failed to start video, no video devices found. Ensure video devices are plugged in and enabled in the system settings.",code:412,subCode:43013,resultCategories:["ExpectedError"]},MEDIA_STREAM_REQUEST_ERROR:{message:"Failed to start video, error requesting media stream. Please try again, if issue persists, contact Azure Communication Services support.",code:412,subCode:43014,resultCategories:["UnexpectedClientError"]},MEDIA_STREAM_REQUEST_TIMEDOUT:{message:"Failed to start video, media stream request timed out. PLease allow permission on the browser's prompt to access the camera and try again.",code:412,subCode:43015,resultCategories:["ExpectedError"]},PERMISSION_DENIED_BY_SYSTEM:{message:"Failed to start video, permissions denied by system. Ensure video device permissions are allowed in the browser's settings and in the system's setttings.",code:412,subCode:43016,resultCategories:["ExpectedError"]},UNSUPPORTED_STREAM:{message:"Failed to start video, unsupported stream. Please try again, if issue persists, contact Azure Communication Services support.",code:412,subCode:43017,resultCategories:["UnexpectedClientError"]},CONSTRAINT_NOT_SATISFIED:{message:"Failed to start video, failed to set constraints. Please try again, if issue persists, contact Azure Communication Services support.",code:412,subCode:43018,resultCategories:["UnexpectedClientError"]},NO_DEVICE_SELECTED:{message:"Failed to start video, no device selected. Please ensure to pass a LocalVideoStream constructed with a VideoDeviceInfo and try again. If issue persists, contact Azure Communication Services support.",code:412,subCode:43019,resultCategories:["UnexpectedClientError"]},CALL_NOT_FOUND:{message:"Start video is cancelled because call has ended.",code:412,subCode:43021,resultCategories:["ExpectedError"]}},REMOTE_VIDEO_STREAM:{EVENT_SUBSCRIBE:{message:"Not able to subscribe to RemoteVideoStream event, unknown event name.",code:422,subCode:43100,resultCategories:["ExpectedError"]},EVENT_UNSUBSCRIBE:{message:"Not able to unsubscribe from RemoteVideoStream event, unknown event name.",code:422,subCode:43101,resultCategories:["ExpectedError"]},GET_RAW_MEDIA_STREAM:{message:"Not able to get media stream",code:500,subCode:43102,resultCategories:["UnexpectedClientError"]},RAWMEDIA_LVS_NOT_AVAILABLE:{message:"The remote video stream is currently not available, subscribe to the stream's isAvailable property to get notified when it is ready to get the raw media stream.",code:400,subCode:43103,resultCategories:["ExpectedError"]},SUBSCRIBE_MEDIA_STREAM_TIMEOUT:{message:"Failed to subscribe to media stream, timeout",code:408,subCode:43104,resultCategories:["UnexpectedClientError"]},GET_TRACK:{message:"Failed to get media stream",code:500,subCode:43105,resultCategories:["UnexpectedClientError"]},TRACK_UNMUTED_TIMEOUT:{message:"Failed to subscribe to media stream, muted",code:408,subCode:43106,resultCategories:["UnexpectedClientError"]},GET_MEDIA_STREAM:{message:"Failed to get raw media stream",code:500,subCode:43107,resultCategories:["UnexpectedClientError"]}},VIEW:{ISAVAILABLE_FALSE:{message:"Failed to render video stream, this stream is not available. Subscribe to the stream's isAvailable property to get notified when the remote participant has their video on and the stream is available for rendering.",code:412,subCode:43200,resultCategories:["ExpectedError"]},START_ALREADY_DISPOSED:{message:"Failed to start stream, already disposed",code:405,subCode:43201,resultCategories:["ExpectedError"]},STREAM_BECAME_UNAVAILABLE:{message:"Failed to render video stream, this stream is not longer available. Remote participant turned their video off.",code:404,subCode:43202,resultCategories:["ExpectedError"]},TIMEOUT:{message:"Failed to render video stream, rendering timed out while waiting for video frames. Please try again, if issue persists, contact Azure Communication Services support.",code:408,subCode:43203,resultCategories:["UnexpectedClientError"]},SUBSCRIBE:{message:"Failed to render video stream, failed to subscribe to video on the Azure Communication Services infrastructure. Please try again, if issue persists, contact Azure Communication Services support.",code:500,subCode:43204,resultCategories:["UnexpectedClientError"]},START:{message:"Failed to start stream, internal error",code:500,subCode:43205,resultCategories:["UnexpectedClientError"]},SCALING_MODE:{message:"Failed to updateScalingMode, failed to update",code:500,subCode:43206,resultCategories:["UnexpectedClientError"]},LARGE_MEETING_VIEW_DISPOSED:{message:"Failed to start stream, disposing stream because participant is not a dominant speaker in the large meeting",code:405,subCode:43207,resultCategories:["ExpectedError"]},REMOTE_VIDEO_STREAM_DISPOSED:{message:"Failed to start stream, disposing stream because remote video stream is disposing",code:405,subCode:43208,resultCategories:["ExpectedError"]},APP_VIEW_DISPOSED:{message:"Failed to render video stream, VideoStreamRenderer was disposed during initialization process.",code:405,subCode:43209,resultCategories:["ExpectedError"]},RENDERER_DISPOSE_ALREADY_DISPOSED:{message:"Failed to dispose VideoStreamRenderer, it is already disposed.",code:400,subCode:43210,resultCategories:["ExpectedError"]},REMOTE_RENDERER_DISPOSE_FAIL:{message:"Failed to dispose remote renderer",code:500,subCode:43211,resultCategories:["UnexpectedClientError"]},VIEW_WRONG_STREAM_TYPE:{message:"Failed to create VideoStreamRendererView, videoStream must be either LocalVideoStream or RemoteVideoStream type",code:400,subCode:43212,resultCategories:["ExpectedError"]},VIEW_ALREADY_DISPOSED:{message:"Failed to dispose, VideoStreamRendererView is disposed",code:400,subCode:43213,resultCategories:["ExpectedError"]},RENDER_FAIL_STREAM_DISPOSED:{message:"Failed to render, stream disposed",code:400,subCode:43214,resultCategories:["ExpectedError"]},SCALING_MODE_DISPOSED:{message:"Failed to updateScalingMode, VideoStreamRendererView is disposed",code:400,subCode:43215,resultCategories:["ExpectedError"]},SCALING_MODE_WRONG_VAL:{message:"Failed to updateScalingMode, wrong scalingMode value",code:400,subCode:43216,resultCategories:["ExpectedError"]},DISPOSE_FAIL:{message:"Failed to dispose view",code:500,subCode:43217,resultCategories:["UnexpectedClientError"]},RENDERER_WRONG_STREAM_TYPE:{message:"Failed to create VideoStreamRenderer, videoStream must be either LocalVideoStream or RemoteVideoStreamCommon type",code:400,subCode:43218,resultCategories:["ExpectedError"]},RENDERER_DISPOSED:{message:"Failed to create view, VideoStreamRenderer is disposed",code:400,subCode:43219,resultCategories:["ExpectedError"]},MAX_NUM_OF_VIEWS_REACHED:{message:"Failed to create view, maximum number of active RemoteVideoStream views has been reached. You can dispose of a previous one in order to create new one.",code:400,subCode:43220,resultCategories:["ExpectedError"]},CREATE_VIEW_FAILED:{message:"Failed to create view",code:500,subCode:43221,resultCategories:["UnexpectedClientError"]},RENDERER_ALREADY_DISPOSED:{message:"Failed to dispose, VideoStreamRendererView is already disposed",code:400,subCode:43222,resultCategories:["ExpectedError"]},UNKNOWN_STREAM_TYPE:{message:"Unknown stream type",code:400,subCode:43223,resultCategories:["ExpectedError"]},LOCAL_RENDERER_DISPOSE_FAIL:{message:"Failed to dispose local renderer",code:500,subCode:43224,resultCategories:["UnexpectedClientError"]},WATERMARK_ATTACH_FAIL:{message:"Meeting has watermark enabled, but failed to generate and attach watermark. Please try again. If the issue persists, gather browser console logs and contact Azure Communication Services support.",code:500,subCode:43225,resultCategories:["UnexpectedClientError"]},WATERMARK_UNEXPECTED_VALUES:{message:"Unknown watermark settings from server. Please check meeting organizer settings for watermark. If the issue persists, gather browser logs and contact Azure Communication Services support.",code:500,subCode:43226,resultCategories:["UnexpectedClientError"]},NO_WATERMARK_CAPABILITY_RECEIVED:{message:"Missing watermark capability from server. Please try again. If the issue persists, gather browser console logs and contact Azure Communication Services support.",code:500,subCode:43227,resultCategories:["UnexpectedServerError"]}},LOCAL_AUDIO_STREAM:{WRONG_STREAM_TYPE:{message:"Failed to create local audio stream, source is not of type AudioDeviceInfo or MediaStream",code:400,subCode:43600,resultCategories:["ExpectedError"]},SOURCE_WRONG_TYPE:{message:"Failed to create local audio stream, source is not a microphone",code:400,subCode:43601,resultCategories:["ExpectedError"]},GET_MEDIA_STREAM:{message:"Failed to get media stream source is not AudioDeviceInfo or MediaStream",code:500,subCode:43602,resultCategories:["UnexpectedClientError"]},SET_MEDIA_STREAM_WRONG_TYPE:{message:"Failed to switch stream on local audio, source is not of type MediaStream",code:400,subCode:43603,resultCategories:["ExpectedError"]},SWITCH_SOURCE_WRONG_TYPE:{message:"Failed to create local audio stream, source is not a microphone",code:400,subCode:43604,resultCategories:["ExpectedError"]},EVENT_SUBSCRIBE:{message:"Not able to subscribe to LocalAudioStream event, unknown event name.",code:422,subCode:43605,resultCategories:["ExpectedError"]},EVENT_UNSUBSCRIBE:{message:"Not able to unsubscribe from LocalAudioStream event, unknown event name.",code:422,subCode:43606,resultCategories:["ExpectedError"]},SWITCH_SAME_SOURCE:{message:"Failed to switch audio device, unable to switch to the same audio device, it's already selected.",code:400,subCode:43607,resultCategories:["ExpectedError"]},UNKNOWN:{message:"Failed to start audio, unknown error. Please try again. If the issue persists, gather browser console logs and contact Azure Communication Services support.",code:500,subCode:43608,resultCategories:["UnexpectedClientError"]}},REMOTE_AUDIO_STREAM:{},IDENTIFIER:{PARSE_PHONENUMBER:{message:"Unable to parse PhoneNumberIdentifier object",code:422,subCode:44e3,resultCategories:["ExpectedError"]},PARSE_MSFT_TEAMS_USER:{message:"Unable to parse MicrosoftTeamsUserIdentifier object",code:422,subCode:44001,resultCategories:["ExpectedError"]},PARSE_MSFT_TEAMS_APP:{message:"Unable to parse MicrosoftTeamsAppIdentifier object",code:422,subCode:44002,resultCategories:["ExpectedError"]},PARSE_IDENTIFIER:{message:"Unable to parse Identifier object, please check the syntax",code:422,subCode:44003,resultCategories:["ExpectedError"]},INVALID_COMM_USER:{message:"Invalid CommunicationUser identifier specified",code:422,subCode:44004,resultCategories:["ExpectedError"]},INVALID_MSFT_TEAMS_USER_RAWID:{message:"Invalid MicrosoftTeamsUser rawId specified",code:422,subCode:44005,resultCategories:["ExpectedError"]},INVALID_MSFT_TEAMS_USER_USERID:{message:"Invalid MicrosoftTeamsUser microsoftTeamsUserId specified",code:422,subCode:44006,resultCategories:["ExpectedError"]},INVALID_MSFT_TEAMS_APP_RAWID:{message:"Invalid MicrosoftTeamsApp rawId specified",code:422,subCode:44007,resultCategories:["ExpectedError"]},INVALID_MSFT_TEAMS_APP_APPID:{message:"Invalid MicrosoftTeamsApp teamsAppId specified",code:422,subCode:44008,resultCategories:["ExpectedError"]},INVALID_UNKNOWN_IDENTIFIER:{message:"Invalid identifier specified, please specify an id",code:422,subCode:44009,resultCategories:["ExpectedError"]},PARSE_INVALID_IDENTIFIER:{message:"Unable to parse Identifier object",code:422,subCode:44010,resultCategories:["ExpectedError"]},INVALID_IDENTIFIER_ARRAY:{message:"AssertIsArrayOfIdentifiers failed. : userIds must be array of CommunicationIdentifier",code:422,subCode:44011,resultCategories:["ExpectedError"]},NO_CLOUD_PREFIX_FOUND:{message:"No cloud prefix found in identity",code:409,subCode:44012,resultCategories:["ExpectedError"]}},INTERNAL:{ECS_CONFIG_EMPTY:{message:"Config is empty",code:500,subCode:44100,resultCategories:["UnexpectedServerError"]},ECS_CONFIG_MISSING_ACS:{message:"Missing ACS config key",code:500,subCode:44101,resultCategories:["UnexpectedServerError"]},ECS_CONFIG_MERGING_ERROR:{message:"Error while merging config",code:500,subCode:44102,resultCategories:["UnexpectedClientError"]},TELEMETRY_FAILED_TO_INITIALIZE_INVALID_CLOUD_TYPE:{message:"Failed to initialize telemetry",code:500,subCode:44103,resultCategories:["UnexpectedClientError"]},TELEMETRY_FAILED_TO_INITIALIZE_ALREADY_INITIALIZED:{message:"Failed to initialize telemetry",code:500,subCode:44104,resultCategories:["UnexpectedClientError"]},TELEMETRY_FAILED_TO_INITIALIZE:{message:"Failed to create and initialize telemetry logger for tenant. Please try again, if the issue persists, gather browser console logs and contact Azure Communication Services support.",code:500,subCode:44105,resultCategories:["UnexpectedClientError"]},TELEMETRY_FAILED_TO_FLUSH:{message:"Failed to flush telemetry",code:500,subCode:44106,resultCategories:["UnexpectedClientError"]},TELEMETRY_LOGGER_INIT_FAIL:{message:"Failed to initialize telemetry logger",code:500,subCode:44107,resultCategories:["UnexpectedClientError"]},NO_TOKEN_PROVIDED:{message:"No CommunicationTokenCredential provided",code:401,subCode:44108,resultCategories:["ExpectedError"]},EMPTY_TOKEN:{message:"AccessToken is empty",code:401,subCode:44109,resultCategories:["ExpectedError"]},GET_TOKEN:{message:"Failed to get AccessToken",code:401,subCode:44110,resultCategories:["UnexpectedClientError"]},TOKEN_PAYLOAD_UNDEFINED:{message:"Invalid token",code:401,subCode:44111,resultCategories:["ExpectedError"]},TOKEN_UNDEFINED:{message:"Failed to parse AccessToken",code:401,subCode:44112,resultCategories:["ExpectedError"]},INVALID_TOKEN_SCOPE:{message:"AccessToken does not contain 'voip' or 'voip.join' scope",code:401,subCode:44113,resultCategories:["ExpectedError"]},INVALID_TOKEN_SCOPE_FORMAT:{message:"Wrong AccessToken scope format. Scope is expected to be a string that contains 'voip'",code:401,subCode:44114,resultCategories:["ExpectedError"]},RESOURCE_NOT_FOUND_IN_TOKEN:{message:"AccessToken does not contain ACS resource Id",code:401,subCode:44115,resultCategories:["ExpectedError"]},USERID_NOT_FOUND_IN_TOKEN:{message:"AccessToken does not contain ACS user Id",code:401,subCode:44116,resultCategories:["ExpectedError"]},PARSE_TOKEN_FAIL:{message:"Failed to parse AccessToken",code:401,subCode:44117,resultCategories:["UnexpectedClientError"]},OPERATION_TIMEDOUT:{message:"Operation timed out",code:408,subCode:44118,resultCategories:["UnexpectedClientError"]}},RAW_MEDIA:{},FEATURES:{AUDIO_EFFECTS:{SET_ECHO_CANCELLATION:{message:"Error while trying to start or stop echo cancellation. Please try again, if the issue persists, gather browser console logs and contact Azure Communication Services support.",code:500,subCode:45e3,resultCategories:["UnexpectedClientError"]},SET_NOISE_SUPPRESSION:{message:"Error while trying to start or stop noise suppression. Please try again, if the issue persists, gather browser console logs and contact Azure Communication Services support.",code:500,subCode:45001,resultCategories:["UnexpectedClientError"]},EVENT_SUBSCRIBE:{message:"Not able to subscribe to AudioEffects event, unknown event name.",code:400,subCode:45002,resultCategories:["ExpectedError"]},EVENT_UNSUBSCRIBE:{message:"Not able to unsubscribe from AudioEffects event, unknown event name.",code:400,subCode:45003,resultCategories:["ExpectedError"]},DISABLED:{message:"Setting audio effects is currently disabled by Azure Communication Services.",code:403,subCode:45004,resultCategories:["ExpectedError"]},START_DISPOSED:{message:"Audio effects feature is disposed. Create a new AudioEffects feature instance.",code:400,subCode:45005,resultCategories:["ExpectedError"]},SOURCE_UNSUPPORTED:{message:"Current source is not supported",code:415,subCode:45006,resultCategories:["ExpectedError"]},START_DEVICE_MANAGER:{message:"Failed to get device manager to start effects.",code:500,subCode:45007,resultCategories:["UnexpectedClientError"]},STOP_DISPOSED:{message:"Audio effects feature is disposed. Create a new AudioEffects feature instance.",code:400,subCode:45008,resultCategories:["ExpectedError"]},STOP_DEVICE_MANAGER:{message:"Failed to get device manager to stop effects.",code:500,subCode:45009,resultCategories:["UnexpectedClientError"]},FAILED_TO_GET_DM:{message:"Internal error - DM missing",code:500,subCode:45010,resultCategories:["UnexpectedClientError"]},PROVIDER_UNAVAILABLE:{message:"EffectProvider not available",code:500,subCode:45011,resultCategories:["UnexpectedClientError"]},AEC_PROVIDER_MISSING:{message:"Internal error - stack aec provider missing",code:500,subCode:45012,resultCategories:["UnexpectedClientError"]},INVALID_EFFECT:{message:"Invalid effect provided",code:400,subCode:45013,resultCategories:["ExpectedError"]},INVALID_EFFECT_ECHO:{message:"Invalid or no echo cancellation effect provided",code:400,subCode:45014,resultCategories:["ExpectedError"]},INVALID_EFFECT_NOISE_SUPP:{message:"Invalid or no noise suppression effect provided",code:400,subCode:45015,resultCategories:["ExpectedError"]},UNSUPPORTED_EFFECT:{message:"Unsupported effect specified. Please specify a supported audio effect.",code:415,subCode:45016,resultCategories:["ExpectedError"]},SUPPORT_CHECK_FAILED:{message:"Error while checking support",code:501,subCode:45017,resultCategories:["UnexpectedClientError"]},INVALID_EFFECT_GAINCONTROL:{message:"Invalid or no auto gain control effect provided",code:400,subCode:45018,resultCategories:["ExpectedError"]},SET_AUTO_GAIN_CONTROL:{message:"Error while trying to start or stop auto gain control. Please try again, if the issue persists, gather browser console logs and contact Azure Communication Services support.",code:500,subCode:45019,resultCategories:["UnexpectedClientError"]},AUDIO_FLAGS:{message:"Error setting browser audio processing flags",code:500,subCode:45020,resultCategories:["UnexpectedClientError"]},START_FAILED:{message:"Error starting audio effects.",code:500,subCode:45021,resultCategories:["UnexpectedClientError"]},STOP_FAILED:{message:"Error stopping audio effects.",code:500,subCode:45022,resultCategories:["UnexpectedClientError"]},DISPOSE_FAILED:{message:"Error disposing audio effects feature.",code:500,subCode:45023,resultCategories:["UnexpectedClientError"]}},AUDIO_ZONES:{},CALL_SURVEY:{INVALID_SURVEY:{message:"Invalid call survey. Please submit a survey options.",code:400,subCode:45100,resultCategories:["ExpectedError"]},SUBMIT_TIMEOUT:{message:"Failed to submit survery, timedout. Please try again, if issue persists, gather browser console logs and contact Azure Communication Services support.",code:408,subCode:45101,resultCategories:["UnexpectedClientError"]}},CAPABILITIES:{},CAPTIONS:{INITIALIZE:{message:"Failed to initialize Captions.",code:500,subCode:45200,resultCategories:["UnexpectedClientError"]},DISABLED:{message:"Captions feature is currently disabled by Azure Communication services.",code:412,subCode:45201,resultCategories:["ExpectedError"]},SPOKEN_LANG_UNSUPPORTED:{message:"Spoken language requested is not supported.",code:400,subCode:45202,resultCategories:["ExpectedError"]},MEETING_POLICY_DISABLED:{message:"Captions feature is disabled in meeting policy.",code:403,subCode:45203,resultCategories:["ExpectedError"]},CALLING_POLICY_DISABLED:{message:"Captions feature is disabled in calling policy.",code:403,subCode:45204,resultCategories:["ExpectedError"]},START_FAILED:{message:"Could not start captions.",code:500,subCode:45205,resultCategories:["UnexpectedClientError"]},UPDATE_LANGUAGE_NOT_STARTED:{message:"Cannot update spoken language as captions has not started.",code:400,subCode:45206,resultCategories:["ExpectedError"]},SPOKEN_LANG_DISABLED:{message:"Set spoken language is currently disabled by Azure Communication Services.",code:412,subCode:45207,resultCategories:["ExpectedError"]},UPDATE_LANGUAGE_GET_TOKEN:{message:"Unable to update spoken language. Failed to get token.",code:401,subCode:45208,resultCategories:["UnexpectedClientError"]},UPDATE_LANGUAGE_FAILED:{message:"Unable to update spoken language.",code:500,subCode:45209,resultCategories:["UnexpectedClientError"]},UPDATE_CAPTIONS_NOT_STARTED:{message:"Cannot update caption language as captions has not started.",code:400,subCode:45210,resultCategories:["ExpectedError"]},CAPTIONS_LANG_DISABLED:{message:"Set caption language is currently disabled by Azure Communication Services.",code:412,subCode:45211,resultCategories:["ExpectedError"]},CAPTIONS_LANG_TEAMS_LICENSE:{message:"Set caption language failed. Teams premium license is needed to use this feature.",code:401,subCode:45212,resultCategories:["ExpectedError"]},CAPTIONS_LANG_UNSUPPORTED:{message:"Caption language requested is not supported.",code:400,subCode:45213,resultCategories:["ExpectedError"]},UPDATE_CAPTIONS_GET_TOKEN:{message:"Null token",code:401,subCode:45214,resultCategories:["ExpectedError"]},UPDATE_CAPTIONS_FAILED:{message:"Unable to update caption language.",code:500,subCode:45215,resultCategories:["UnexpectedClientError"]},CTE_POLICY_FETCH_FAIL:{message:"Failed to fetch policy for Teams Captions.",code:500,subCode:45216,resultCategories:["UnexpectedClientError"]},ALREADY_ACTIVE:{message:"Captions already active",code:400,subCode:45217,resultCategories:["ExpectedError"]},STOP_NOT_ACTIVE:{message:"Captions feature is not active.",code:400,subCode:45218,resultCategories:["ExpectedError"]},ALREADY_STARTING:{message:"Operation in progress",code:400,subCode:45219,resultCategories:["ExpectedError"]},SPOKEN_LANGUAGE_ALREADY_SET:{message:"Spoken language already set",code:400,subCode:45220,resultCategories:["ExpectedError"]},UPDATE_CAPTIONS_NOT_ACTIVE:{message:"Unable to update caption language as Captions is not active.",code:400,subCode:45221,resultCategories:["ExpectedError"]},CAPTIONS_LANG_ALREADY_SET:{message:"Caption language already set.",code:400,subCode:45222,resultCategories:["ExpectedError"]},UPDATE_ENDPOINT_METADATA:{message:"Failed to update endpoint metadata",code:500,subCode:45225,resultCategories:["UnexpectedClientError"]},START_FAILED_CALL_NOT_CONNECTED:{message:"Cannot start captions as call state is not connected.",code:400,subCode:45226,resultCategories:["ExpectedError"]},START_FAILED_CALL_ENDPOINTS_NOT_AVAILABLE:{message:"Cannot start captions as call endpoints are not available.",code:400,subCode:45227,resultCategories:["ExpectedError"]}},COMPOSED_STREAM:{},DATA_CHANNEL:{DISPOSED:{message:"DataChannel has been disposed",code:500,subCode:45300,resultCategories:["UnexpectedClientError"]},SENDER_NOT_READY:{message:"Sender is not ready",code:500,subCode:45301,resultCategories:["UnexpectedClientError"]},NO_AVAILABLE_CHANNEL_ID:{message:"No available channel id",code:500,subCode:45302,resultCategories:["UnexpectedClientError"]},INVALID_CHANNEL_ID:{message:"Invalid channel id {0}",code:400,subCode:45303,resultCategories:["ExpectedError"]},INVALID_BITRATE_IN_KBPS:{message:"Invalid bitrateInKbps",code:400,subCode:45304,resultCategories:["ExpectedError"]},INVALID_PARTICIPANTS:{message:"Invalid participants",code:400,subCode:45305,resultCategories:["ExpectedError"]},TOO_MANY_PARTICIPANTS:{message:"Too many participants",code:400,subCode:45306,resultCategories:["ExpectedError"]},NO_VALID_PARTICIPANT:{message:"No valid participant",code:400,subCode:45307,resultCategories:["ExpectedError"]},MSG_DATA_EMPTY:{message:"Message data is empty",code:400,subCode:45308,resultCategories:["ExpectedError"]},MSG_DATA_TOO_LARGE:{message:"The size of message data is too large",code:400,subCode:45309,resultCategories:["ExpectedError"]},INVALID_MSG_LENGTH:{message:"Invalid message length",code:500,subCode:45310,resultCategories:["UnexpectedClientError"]},BUFFER_FULL:{message:"The buffer is full. Please wait and try again",code:500,subCode:45311,resultCategories:["UnexpectedClientError"]},SENDER_CLOSED:{message:"The sender has been closed",code:400,subCode:45312,resultCategories:["ExpectedError"]},NO_AVAILABLE_RELIABLE_CHANNEL:{message:"Currently there is no available reliable channel",code:500,subCode:45313,resultCategories:["UnexpectedClientError"]},NO_AVAILABLE_UNRELIABLE_CHANNEL:{message:"Currently there is no available unreliable channel",code:500,subCode:45314,resultCategories:["UnexpectedClientError"]},CHANNEL_ALREADY_ALLOCATED:{message:"Unable allocate the channel because a channel with the same channelId has already been allocated",code:500,subCode:45315,resultCategories:["UnexpectedClientError"]},INVALID_BITRATE:{message:"Invalid bitrate",code:400,subCode:45316,resultCategories:["ExpectedError"]},TRAFFIC_LIMITED:{message:"Traffic is limited",code:400,subCode:45317,resultCategories:["ExpectedError"]},SEND_FAIL:{message:"Failed to send message.",code:500,subCode:45318,resultCategories:["UnexpectedClientError"]},EVENT_SUBSCRIBE:{message:"Not able to subscribe to DataChannel event, unknown event name.",code:422,subCode:45319,resultCategories:["ExpectedError"]},WRONG_ARGUMENT_TYPE:{message:"Wrong argument type specified.",code:400,subCode:45320,resultCategories:["ExpectedError"]},WRONG_ARGUMENT_VALUE:{message:"Wrong value specified.",code:400,subCode:45321,resultCategories:["ExpectedError"]},CANT_FIND_CHANNEL_ID:{message:"Cannot find the channelId specified.",code:400,subCode:45322,resultCategories:["ExpectedError"]},FAILED_TO_CREATE_SENDER:{message:"Failed to create the sender.",code:500,subCode:45323,resultCategories:["UnexpectedClientError"]},INVALID_INTERNAL_CHANNEL_ID:{message:"Invalid internal channel id {0} ({1})",code:400,subCode:45324,resultCategories:["ExpectedError"]}},DEBUG_INFO:{},DIAGNOSTICS:{INCORRECT_VALUETYPE_MAPPED:{message:"Mapped to an incorrect value type. Please gather browser console logs and contact Azure Communication Services support.",code:500,subCode:45400,resultCategories:["UnexpectedClientError"]},EVENT_SUBSCRIBE:{message:"Not able to subscribe to UserFacingDiagnostics event, unknown event name.",code:422,subCode:45401,resultCategories:["ExpectedError"]},EVENT_UNSUBSCRIBE:{message:"Not able to unsubscribe from UserFacingDiagnostics event, unknown event name.",code:422,subCode:45402,resultCategories:["ExpectedError"]},INCORRECT_VALUE_MAPPED:{message:"Failed to map diagnostic quality level. Please gather browser console logs and contact Azure Communication Services support.",code:500,subCode:45403,resultCategories:["UnexpectedClientError"]}},DOMINANT_SPEAKER:{},LIVE_STREAM:{EVENT_SUBSCRIBE:{message:"Not able to subscribe to LiveStream event, unknown event name.",code:422,subCode:45500,resultCategories:["ExpectedError"]},EVENT_UNSUBSCRIBE:{message:"Not able to unsubscribefrom LiveStream event, unknown event name.",code:422,subCode:45501,resultCategories:["ExpectedError"]},INVALID_AGGREGATION_INTERVAL_RANGE:{message:"Invalid aggregationInterval value range.",code:400,subCode:45502,resultCategories:["ExpectedError"]},INVALID_DATAPOINTS_AGGREGATION_RANGE:{message:"invalid dataPointsPerAggregation value range.",code:400,subCode:45503,resultCategories:["ExpectedError"]},DISPOSED:{message:"MediaStatsCallFeature has been disposed.",code:400,subCode:45504,resultCategories:["ExpectedError"]}},MEDIA_STATS:{INVALID_AGGREGATION_INTERVAL_RANGE:{message:"Invalid aggregationInterval value range.",code:400,subCode:45550,resultCategories:["ExpectedError"]},INVALID_DATAPOINTS_AGGREGATION_RANGE:{message:"invalid dataPointsPerAggregation value range.",code:400,subCode:45551,resultCategories:["ExpectedError"]},DISPOSED:{message:"MediaStatsCallFeature has been disposed.",code:400,subCode:45552,resultCategories:["ExpectedError"]}},OPTIMAL_VIDEO_COUNT:{EVENT_SUBSCRIBE:{message:"Not able to subscribe to OptimalVideoCount event, unknown event name.",code:422,subCode:45600,resultCategories:["ExpectedError"]},EVENT_UNSUBSCRIBE:{message:"Not able to unsubscribe from OptimalVideoCount event, unknown event name.",code:422,subCode:45601,resultCategories:["ExpectedError"]}},PPTLIVE:{},PRECALL_DIAGNOSTICS:{SET_DEVICE_FAIL:{message:"Failed to set default microphone or speaker with error",code:412,subCode:45700,resultCategories:["UnexpectedClientError"]},GET_DIAGNOSTICS_INFO:{message:"Unable to return call diagnostic information.",code:500,subCode:45701,resultCategories:["UnexpectedClientError"]},VIDEO_STREAM_TIMEOUT:{message:"Timeout in checking media stream status",code:500,subCode:45702,resultCategories:["UnexpectedClientError"]},GET_CALL_AGENT:{message:"Failed to get existing call agent or create a new one",code:500,subCode:45703,resultCategories:["UnexpectedClientError"]},CONNECT_FAIL:{message:"Test call failed to connect",code:500,subCode:45704,resultCategories:["UnexpectedClientError"]},RENDER_VIDEO:{message:"Call failed to render video.",code:500,subCode:45705,resultCategories:["UnexpectedClientError"]},HANGUP_FAIL:{message:"Test call failed hang up the call",code:500,subCode:45706,resultCategories:["UnexpectedClientError"]},VIDEO_MEDIASTATS:{message:"Failed to get video call media stats",code:500,subCode:45707,resultCategories:["UnexpectedClientError"]},CALL_CONNECT_TIMEOUT:{message:"Call timed out to connect. Please try again, if the issue persists, gather browser console logs and contact Azure Communication Services support.",code:408,subCode:45708,resultCategories:["UnexpectedClientError"]}},RAISE_HAND:{INITIALIZE:{message:"Could not initialize raise hand feature.",code:500,subCode:45750,resultCategories:["UnexpectedClientError"]},RAISE_HAND_PUBLISH_STATE:{message:"Could not change a participant state.",code:500,subCode:45751,resultCategories:["UnexpectedServerError"]},RAISE_HAND_FAIL:{message:"Could not change a participant state.",code:500,subCode:45752,resultCategories:["UnexpectedServerError"]},LOWER_HAND_FAIL:{message:"Could not change a participant state.",code:500,subCode:45753,resultCategories:["UnexpectedServerError"]},LOWER_REMOTEPARTICIPANTS_HANDS_FAIL:{message:"Could not change a participant state.",code:500,subCode:45754,resultCategories:["UnexpectedServerError"]},LOWER_ALL_HANDS_FAIL:{message:"Could not change a participant state.",code:500,subCode:45755,resultCategories:["UnexpectedServerError"]},NOT_SUPPORTED_1TO1:{message:"Raise hand is not supported for 1:1 direct calling",code:400,subCode:45758,resultCategories:["ExpectedError"]}},REACTION:{CALL_NOT_CONNECTED:{message:"Call is not connected yet to send reaction",code:400,subCode:45800,resultCategories:["ExpectedError"]},NOT_SUPPORTED_1TO1_CTE:{message:"Reaction send is not supported for 1:1 direct calling with teams identity",code:400,subCode:45801,resultCategories:["ExpectedError"]},EVENT_SUBSCRIBE_FAIL_POLICY:{message:"Unable to register listener due to meeting policy",code:403,subCode:45802,resultCategories:["ExpectedError"]},EVENT_UNSUBSCRIBE_FAIL_POLICY:{message:"Unable to deregister listener due to meeting policy",code:403,subCode:45803,resultCategories:["ExpectedError"]},SEND_FAIL_POLICY:{message:"Unable to send reaction due to meeting policy",code:403,subCode:45804,resultCategories:["ExpectedError"]},STATE_SERVICE_CONNECT_FAIL:{message:"Could not create state service proxy web-socket connection",code:500,subCode:45805,resultCategories:["UnexpectedServerError"]},MAP_CREATE_FAIL:{message:"Could not create sync map to exchange reaction",code:500,subCode:45806,resultCategories:["UnexpectedServerError"]},NOT_INIT_YET:{message:"Unable to handle send reaction",code:400,subCode:45807,resultCategories:["ExpectedError"]},SEND_REACTION_FAIL:{message:"Unable to handle send reaction",code:500,subCode:45808,resultCategories:["UnexpectedClientError"]},RECEIVE_REACTION_FAIL:{message:"Unable to parse reaction",code:500,subCode:45809,resultCategories:["UnexpectedClientError"]},EVENT_SUBSCRIBE:{message:"Not able to subscribe to Reation event, unknown event name.",code:422,subCode:45810,resultCategories:["ExpectedError"]},EVENT_UNSUBSCRIBE:{message:"Not able to unsubscribe from Reaction event, unknown event name.",code:422,subCode:45811,resultCategories:["ExpectedError"]}},RECORDING:{EVENT_SUBSCRIBE:{message:"Not able to subscribe to Recording event, unknown event name.",code:422,subCode:45850,resultCategories:["ExpectedError"]},EVENT_UNSUBSCRIBE:{message:"Not able to unsubscribe from Recording event, unknown event name.",code:422,subCode:45851,resultCategories:["ExpectedError"]},RECORDING_CONSENT_FAILURE:{message:"Failed to set consent publish state for recording. Please try again, if the issue persists, gather browser console logs and contact Azure Communication Services support.",code:500,subCode:45853,resultCategories:["UnexpectedServerError"]}},SPOTLIGHT:{ALREADY_SPOTLIGHTED:{message:"Bad request. All participants are already spotlighted",code:400,subCode:45900,resultCategories:["ExpectedError"]},START_SPOTLIGHT_FAILED:{message:"Internal Error. Start spotlight for participants failed",code:500,subCode:45901,resultCategories:["UnexpectedServerError"]},SPOTLIGHT_LIGHT_MAX_REACHED:{message:"Failed to start spotlight. Reached the maximum number of participants that can be Spotlighted.",code:400,subCode:45902,resultCategories:["ExpectedError"]},UNSUPPORTED_ROLE_TYPE:{message:"Failed to spotlight. User does not have a Presenter or Organizer role.",code:403,subCode:45903,resultCategories:["ExpectedError"]},NOT_SUPPORTED_1TO1:{message:"Spotlight is not supported for 1:1 direct calling",code:400,subCode:45906,resultCategories:["ExpectedError"]}},TEAMS_MEETING_AUDIO_CONFERENCING:{ONLY_AVAILABLE_IN_MEETINGS:{message:"Teams meeting audio conferencing feature is only available in meetings",code:400,subCode:45950,resultCategories:["ExpectedError"]},DISABLED:{message:"The Teams meeting audio conferencing details feature is disabled by ACS service.",code:405,subCode:45951,resultCategories:["ExpectedError"]},UNAVAILABLE_BEFORE_JOINING:{message:"Teams meeting audio conferencing details are not available before joining the Teams meeting",code:400,subCode:45952,resultCategories:["ExpectedError"]},UNVAILABLE_IN_LOBBY:{message:"Teams meeting audio conferencing details are not available in Lobby",code:400,subCode:45953,resultCategories:["ExpectedError"]},DETAILS_NOT_CONFIGURED:{message:"Teams meeting audio conferencing details is not configured",code:400,subCode:45954,resultCategories:["UnexpectedClientError"]},GET_DETAILS_FAILED:{message:"Error retrieving Teams meeting audio conferencing details",code:500,subCode:45955,resultCategories:["UnexpectedServerError"]}},TRANSCRIPTION:{TRANSCRIPTION_CONSENT_FAILURE:{message:"Failed to set consent publish state for transcription. Please try again, if the issue persists, gather browser console logs and contact Azure Communication Services support.",code:500,subCode:46001,resultCategories:["UnexpectedServerError"]}},TRANSFER:{TRANSFER_TO_TARGET_FAILED:{message:"Transfer to target failed",code:500,subCode:46050,resultCategories:["UnexpectedClientError"]},UNSUPPORTED_CALL_TYPE:{message:"Transfer is not supported in this call.",code:400,subCode:46051,resultCategories:["ExpectedError"]},TARGET_NOT_RECOGNIZED:{message:"Transfer target is not recognized.",code:400,subCode:46052,resultCategories:["ExpectedError"]},INVALID_TARGET_TYPE:{message:"Invalid target participant type detected.",code:400,subCode:46053,resultCategories:["ExpectedError"]}},UNMIXED_AUDIO:{UNAVAILABLE:{message:"UnmixedAudio is not available.",code:500,subCode:46100,resultCategories:["UnexpectedClientError"]},PENDING_OPERATION:{message:"The operation cannot be done because there is a pending operation",code:400,subCode:46101,resultCategories:["ExpectedError"]},UNSUPPORTED_OPERATION:{message:"The operation is not supported in peer-to-peer call",code:400,subCode:46102,resultCategories:["ExpectedError"]},ENABLED:{message:"Unmixed audio has been enabled",code:400,subCode:46103,resultCategories:["ExpectedError"]},DISABLED:{message:"Unmixed audio has been disabled",code:400,subCode:46104,resultCategories:["ExpectedError"]},DISPOSED:{message:"Unmixed audio has been disposed",code:400,subCode:46105,resultCategories:["ExpectedError"]},EVENT_SUBSCIBE_UNSUBSCRIBE:{message:"Not able to subscribe or unsubscibe to UnmixedAudio event, unknown event name.",code:422,subCode:46106,resultCategories:["ExpectedError"]},WRONG_ARGUMENT_TYPE:{message:"Wrong argument type specified.",code:400,subCode:46107,resultCategories:["ExpectedError"]},WRONG_ARGUMENT_VALUE:{message:"Wrong value specified.",code:400,subCode:46108,resultCategories:["ExpectedError"]},INVALID_STATE:{message:"Invalid state.",code:400,subCode:46109,resultCategories:["ExpectedError"]},UNKNOWN_ERROR:{message:"Unknown error",code:500,subCode:46110,resultCategories:["UnexpectedClientError"]},FAILED_TO_ENABLE:{message:"Failed to enable unmixed audio: AudioContext={0}, UnmixedAudio={1}",code:500,subCode:46111,resultCategories:["UnexpectedClientError"]},FAILED_TO_DISABLE:{message:"Failed to disable unmixed audio: AudioContext={0}, UnmixedAudio={1}",code:500,subCode:46112,resultCategories:["UnexpectedClientError"]},FAILED_TO_INITIALIZE:{message:"Failed to initialize unmixed audio.",code:500,subCode:46113,resultCategories:["UnexpectedClientError"]}},VIDEO_EFFECTS:{DISABLED:{message:"Video effects feature is currently disabled by Azure Communication Services.",code:403,subCode:46150,resultCategories:["ExpectedError"]},START_DISPOSED:{message:"VideoEffects feature is disposed. Create a new VideoEffects Feature instance.",code:400,subCode:46151,resultCategories:["ExpectedError"]},UNSUPPORTED_SOURCE:{message:"Current source is unsupported to use effects",code:415,subCode:46152,resultCategories:["ExpectedError"]},START_DEVICE_MANAGER:{message:"Failed to get device manager to start effects.",code:500,subCode:46153,resultCategories:["UnexpectedClientError"]},PROVIDER_UNAVAILABLE:{message:"EffectProvider not available",code:500,subCode:46154,resultCategories:["UnexpectedClientError"]},WEBCV_PROVIDER_FAILED:{message:"Failed to get WebCV provider.",code:500,subCode:46155,resultCategories:["UnexpectedClientError"]},UNSUPPORTED_EFFECT:{message:"Effect is not supported.",code:501,subCode:46156,resultCategories:["ExpectedError"]},STOP_DISPOSED:{message:"VideoEffects feature is disposed. Create a new VideoEffects Feature instance.",code:400,subCode:46157,resultCategories:["ExpectedError"]},STOP_DEVICE_MANAGER:{message:"Failed to get device manager to stop effects.",code:500,subCode:46158,resultCategories:["UnexpectedClientError"]},INVALID_EFFECT:{message:"Invalid effect provided",code:400,subCode:46159,resultCategories:["ExpectedError"]},EVENT_SUBSCRIBE:{message:"Not able to subscribe to event {event}, unknown event name",code:400,subCode:46160,resultCategories:["ExpectedError"]},EVENT_UNSUBSCRIBE:{message:"Not able to unsubscribe event {event}, unknown event name",code:400,subCode:46161,resultCategories:["ExpectedError"]},EFFECT_PROVIDER_TIMEOUT:{message:"Timed promise; rejected.",code:408,subCode:46162,resultCategories:["UnexpectedClientError"]},SUPPORT_CHECK_FAILED:{message:"Error while checking support",code:501,subCode:46163,resultCategories:["UnexpectedClientError"]},START_FAILED:{message:"Error starting video effects",code:500,subCode:46164,resultCategories:["UnexpectedClientError"]},STOP_FAILED:{message:"Error stopping video effects",code:500,subCode:46165,resultCategories:["UnexpectedClientError"]},DISPOSE_FAILED:{message:"Error disposing video effects feature",code:500,subCode:46166,resultCategories:["UnexpectedClientError"]},EFFECT_CONFIG_UPDATE_CALLBACK_FAILED:{message:"Effect config update callback had errors",code:500,subCode:46169,resultCategories:["UnexpectedClientError"]}},LOCAL_RECORDING:{ONLY_AVAILABLE_IN_MEETINGS:{message:"Local Recording feature is only available in meetings",code:400,subCode:46200,resultCategories:["ExpectedError"]},DISABLED:{message:"Local Recording feature is currently disabled by Azure Communication Service.",code:405,subCode:46201,resultCategories:["ExpectedError"]},EVENT_SUBSCRIBE:{message:"Not able to subscribe to LocalRecording event, unknown event name.",code:422,subCode:46202,resultCategories:["ExpectedError"]},EVENT_UNSUBSCRIBE:{message:"Not able to unsubscribe from LocalRecording event, unknown event name.",code:422,subCode:46203,resultCategories:["ExpectedError"]}},BREAKOUT_ROOMS:{ONLY_AVAILABLE_IN_MEETINGS:{message:"Breakout Rooms feature is only available in Teams meetings.",code:400,subCode:46250,resultCategories:["ExpectedError"]},DISABLED:{message:"Breakout Rooms feature is currently disabled by Azure Communication Services.",code:405,subCode:46251,resultCategories:["ExpectedError"]},EVENT_SUBSCRIBE:{message:"Not able to subscribe to Breakout Rooms event, unknown event name.",code:422,subCode:46252,resultCategories:["ExpectedError"]},EVENT_UNSUBSCRIBE:{message:"Not able to unsubscribe from Breakout Rooms event, unknown event name.",code:422,subCode:46253,resultCategories:["ExpectedError"]},JOIN_FAILED:{message:"Not able to join Breakout Room due to an unexpected error. Please try again, if the issue persists, gather browser console logs and contact Azure Communication Services support.",code:500,subCode:46254,resultCategories:["UnexpectedServerError"]},MAINMEETING_HOLD_FAILED:{message:"Not able to join Breakout Room as Main meeting hold is failed. Please try again, by calling join() method. If the issue persists, gather browser console logs and contact Azure Communication Services support.",code:500,subCode:46255,resultCategories:["UnexpectedServerError"]},JOIN_FAILED_ROOM_CLOSED:{message:"Not able to join Breakout Room as the room is closed. Please check the state of the Breakout Room before calling join.",code:412,subCode:46256,resultCategories:["ExpectedError"]},MAINMEETING_RESUME_FAILED:{message:"Not able to join back to the Main meeting as the resume failed.Please gather browser console logs and contact Azure Communication Services support.",code:412,subCode:46257,resultCategories:["UnexpectedServerError"]},BREAKOUT_ROOMS_UPDATEFAILED:{message:"Error while trying to update the Breakoutroom details. Please gather browser console logs and contact Azure Communication Services support.",code:412,subCode:46258,resultCategories:["UnexpectedClientError"]},BREAKOUT_ROOM_HANGUP_FAILED:{message:"Could not hang up the Breakout room call. Please gather browser console logs and contact Azure Communication Services support.",code:500,subCode:46259,resultCategories:["UnexpectedServerError"]},BREAKOUT_ROOM_URL_DOESNOT_EXIST:{message:"Cannot join Breakout Room as the url is null or empty.Can join BreakoutRoom only when assigned.",code:412,subCode:46260,resultCategories:["UnexpectedClientError"]},RETURN_TO_MAINMEETING_FAILED:{message:"Not able to join the main meeting. Please try again by calling the ReturnToMainMeeting() method. If the issue persists, gather browser console logs and contact Azure Communication Services support.",code:412,subCode:46261,resultCategories:["UnexpectedClientError"]},ALREADY_IN_MAINMEETING:{message:"Already in the main meeting. Please call this method only when the participant is in breakoutroom and removed from the main meeting.",code:412,subCode:46262,resultCategories:["ExpectedError"]},HANGUP_EXISTING_BREAKOUT_ROOM_FAILED:{message:"Existing breakout room call hangup failed. Try to call hangup() method again to hangup the call. Call join() method to join the breakout room again.",code:412,subCode:46263,resultCategories:["UnexpectedClientError"]}},TOGETHER_MODE:{ADD_TOGETHER_MODE_BOT_FAILED:{message:"Unable to add together mode bot. Please collect browser console logs and contact Azure Communication Services support.",code:500,subCode:46300,resultCategories:["UnexpectedServerError"]},PUBLISH_TOGETHER_MODE_STATE_FAILED:{message:"Internal Error. Publish together mode state failed. Please collect browser console logs and contact Azure Communication Services support.",code:500,subCode:46301,resultCategories:["UnexpectedServerError"]},SEAT_MAP_CALCULATION_FAILED:{message:"Seat coordinates calculation failed. Please collect browser console logs and contact Azure Communication Services support.",code:500,subCode:46302,resultCategories:["UnexpectedClientError"]},UNSUPPORTED_ROLE_TYPE:{message:"Start together mode failed. User does not have a Presenter, Co-Organizer or Organizer.",code:403,subCode:46303,resultCategories:["ExpectedError"]},UNSUPPORTED_CONVERSATION_TYPE:{message:"Start together mode failed. Together mode can only be started in group call or meeting scenarios.",code:403,subCode:46304,resultCategories:["ExpectedError"]},REQUEST_INITIAL_SEAT_MAPPING_FAILED:{message:"Unable to get initial seating coordinates. Please collect browser console logs and contact Azure Communication Services support.",code:500,subCode:46305,resultCategories:["UnexpectedClientError"]},UNSUPPORTED_USER_KIND:{message:"Start Together Mode failed. Only M365 users can start together mode.",code:403,subCode:46306,resultCategories:["ExpectedError"]}},CALLKIT:{},ONE_PHONE_SYSTEM:{CUSTOM_CONTEXT_NOT_SUPPORTED:{message:"Specifying custom context is not supported when OnBehalfOfOptions is specified.",code:412,subCode:46400,resultCategories:["ExpectedError"]}},SHAREDLINE_APPEARANCE:{DISABLED:{message:"Shared line appearance is currently disabled by Azure Communication Services.",code:405,subCode:46450,resultCategories:["ExpectedError"]},DISABLED_BY_CALLING_POLICY:{message:"Shared line appearance is disabled by Teams calling policy. Assign TeamsCalling policy with Allow delegation to true to enabled Sharedline appearance.",code:405,subCode:46451,resultCategories:["ExpectedError"]}},MEDIA_ACCESS:{MEDIA_ACCESS_UPDATE_FAILED:{message:"Internal error while updating the audio /video access.",code:500,subCode:46500,resultCategories:["UnexpectedServerError"]},INITIALIZE_FAILED:{message:"Could not initialize media access feature.",code:500,subCode:46501,resultCategories:["UnexpectedClientError"]},UNSUPPORTED_ROLE:{message:"Change media access failed. User does not have a Organizer, Co-Organizer or Presenter role.",code:403,subCode:46502,resultCategories:["ExpectedError"]},UNSUPPORTED_CONVERSATION_TYPE:{message:"Change media access failed. Change media access can only be done in meeting/group call scenarios.",code:403,subCode:46503,resultCategories:["ExpectedError"]},ROLE_RESTRICTED:{message:"Change media access failed. Only able to change media access for attendees.",code:403,subCode:46504,resultCategories:["ExpectedError"]},CALL_NOT_CONNECTED:{message:"Failed to change media access. Call must be in connected state",code:412,subCode:46505,resultCategories:["ExpectedError"]},INVALID_MEETING_CAPABILITY_ATTENDEE_RESTRICTIONS:{message:"Change audio video access failed. Meeting capability attendee restrictions is empty",code:500,subCode:46506,resultCategories:["UnexpectedClientError"]},FEATURE_DISABLED:{message:"Feature is disabled.",code:412,subCode:46507,resultCategories:["ExpectedError"]},INVALID_PARTICIPANTS_LIST:{message:"Invalid participants list, cannot be an empty array or contain null or undefined values.",code:400,subCode:46508,resultCategories:["ExpectedError"]},UNSUPPORTED_CONVERSATION_TYPE_FOR_FORBID_PERMIT_OTHERS_MEDIA_ACCESS:{message:"Attempt to change meeting media access failed. This action is only supported in Teams meetings.",code:403,subCode:46509,resultCategories:["ExpectedError"]}},REAL_TIME_TEXT:{INITIALIZE_FAILED:{message:"Failed to initialize RealTimeTextFeature",code:500,subCode:46550,resultCategories:["UnexpectedClientError"]},START_REAL_TIME_TEXT_FAILED:{message:"Failed to start RealTimeTextFeature",code:500,subCode:46551,resultCategories:["UnexpectedClientError"]},MESSAGE_LENGTH_EXCEEDS_MAX_INPUT_LENGTH:{message:"Message length exceeds max allowed input length",code:400,subCode:46552,resultCategories:["ExpectedError"]},SEND_REAL_TIME_TEXT_MESSAGE_FAILED:{message:"Failed to send a RealTimeText message",code:500,subCode:46553,resultCategories:["UnexpectedClientError"]},SEND_DATA_CHANNEL_MESSAGE_FAILED:{message:"Failed to send data channel message",code:500,subCode:46554,resultCategories:["UnexpectedClientError"]},REAL_TIME_TEXT_MESSAGE_PARSE_FAILED:{message:"Failed to parse RealTimeText message",code:500,subCode:46555,resultCategories:["UnexpectedClientError"]},REAL_TIME_TEXT_MESSAGE_CONTAINS_NO_SPEAKER:{message:"Real Time Text message contains no speaker",code:500,subCode:46556,resultCategories:["UnexpectedClientError"]},REAL_TIME_TEXT_MESSAGE_HANDLER_FAILED:{message:"Failed to handle RealTimeText Message",code:500,subCode:46557,resultCategories:["UnexpectedClientError"]},REAL_TIME_TEXT_MESSAGE_ENTRY_UPDATE_FAILED:{message:"Failed to update RealTimeText message entry",code:500,subCode:46558,resultCategories:["UnexpectedClientError"]},REAL_TIME_TEXT_TEAMS_DISABLED:{message:"Real Time Text feature is currently disabled by Azure Communication services for Teams Calls",code:412,subCode:46559,resultCategories:["ExpectedError"]}},VDI3:{INVALID_CDN_URL:{message:"The remote stack is unavailable due to invalid CDN path",code:400,subCode:46600,resultCategories:["UnexpectedClientError"]},METHOD_UNAVAILABLE:{message:"This method is unavailable when VDI remoting is enabled",code:405,subCode:46601,resultCategories:["ExpectedError"]},PROPERTY_UNAVAILABLE:{message:"This property is unavailable when VDI remoting is enabled",code:405,subCode:46602,resultCategories:["ExpectedError"]},METHOD_MISSING:{message:"This method is missing",code:405,subCode:46603,resultCategories:["UnexpectedClientError"]},CALL_INITIALIZING:{message:"The call object is initializing",code:400,subCode:46604,resultCategories:["ExpectedError"]},REMOTE_STACK_TERMINATED:{message:"The remote stack has been terminated. Please re-initialize the CallClient",code:500,subCode:46605,resultCategories:["UnexpectedClientError"]}}}},GK={0:{0:{public:!0,code:0,subCode:0,message:"Call ended successfully by local participant.",resultCategories:["Success"]},4097:{public:!0,code:0,subCode:4097,message:"Call ended for all users by the meeting organizer.",resultCategories:["Success"]},4521:{public:!0,code:0,subCode:4521,message:"Call ended because user disconnected from the call abruptly, this may be a result of a user closing the application that hosted the call, eg a user terminated application, closed browser of browser tab without proper hang-up.",resultCategories:["ExpectedError"]},5e3:{public:!0,code:0,subCode:5e3,message:"Call ended for this participant as it was removed from the conversation by another participant.",resultCategories:["Success"]},5003:{public:!0,code:0,subCode:5003,message:"Call ended successfully, as all callee endpoints declined the call.",resultCategories:["Success"]},5010:{code:0,subCode:5010,message:"This conversation has ended as only one participant was remaining in the conversation.",resultCategories:["Success"]},5013:{code:0,subCode:5013,message:"This conversation has ended as no one else has joined the group call.",resultCategories:["Success"]},5014:{code:0,subCode:5014,message:"",resultCategories:["Success"]},5300:{public:!0,code:0,subCode:5300,message:"Call ended for this participant as it was removed from the conversation by another participant.",resultCategories:["Success"]},5854:{code:0,subCode:5854,message:"Removed from the Teams meeting lobby by another participant.",resultCategories:["Success"]},5855:{code:0,subCode:5855,message:"Removed from Teams meeting lobby due to inactivity timeout.",resultCategories:["Success"]},7e3:{public:!0,code:0,subCode:7e3,message:"Call was ended by Azure Communication Service Call Automation API or a server bot.",resultCategories:["Success"]},7015:{code:0,subCode:7015,message:"Call ended by service because transfer completed successfully.",resultCategories:["Success"]},54e4:{public:!0,code:0,subCode:54e4,message:"Call ended successfully by local PSTN caller.",resultCategories:["Success"]},56e4:{public:!0,code:0,subCode:56e4,message:"Call ended successfully by remote PSTN participant.",resultCategories:["Success"]}},400:{580040:{code:400,subCode:580040,message:"Error from CreateUsageRequest: User is not entitled to call this destination.",resultCategories:["ExpectedError"]}},401:{10009:{public:!0,code:401,subCode:10009,message:"Unauthenticated identity. Ensure that your Communication Services token is valid and not expired.",resultCategories:["UnexpectedClientError"]}},403:{830:{code:403,subCode:830,message:"Only Communication Services user is allowed to join the Rooms meeting.",resultCategories:["ExpectedError"]},5829:{code:403,subCode:5829,message:"The join isn't allowed for the Rooms meeting beyond end time or prior to start time of the meeting.",resultCategories:["ExpectedError"]},510403:{public:!0,code:403,subCode:510403,message:"Call ended, as it has been marked as a spam and got blocked.",resultCategories:["ExpectedError"]},560403:{code:403,subCode:560403,message:"Call was forbidden, cancelled or rejected",resultCategories:["UnexpectedClientError"]}},404:{404:{code:404,subCode:404,message:"Call failed, unable to start or join to a call with given Id, call does not exist. Please check if provided id is correct, and if the call did not end already and try again.",resultCategories:["UnexpectedClientError"]},4500:{code:404,subCode:4500,message:"Call failed, unable to start or join to a call with given Id, call does not exist. Please check if provided id is correct, and if the call did not end already and try again.",resultCategories:["ExpectedError"]},560404:{code:404,subCode:560404,message:"Phone number not found.",resultCategories:["ExpectedError"]}},408:{4506:{public:!0,code:408,subCode:4506,message:"Call timed out. Check if the callee received and accepted the call.",resultCategories:["UnexpectedClientError"]},10056:{public:!0,code:408,subCode:10056,message:"Call setup failed due to timeout and lack of response from the participant attempting to join meeting or start a 1:1 or 1:n call. This may be caused by the participant leaving abruptly by closing the browser/application, losing network connectivity, or other reasons. Please ensure the participant did not leave abruptly and has a stable network connection.",resultCategories:["UnexpectedClientError"]},10057:{public:!0,code:408,subCode:10057,message:"Call setup failed due to timeout and lack of response from the participant accepting incoming 1:1 or 1:n call or meeting join request. This may be caused by the participant leaving abruptly by closing the browser/application, losing network connectivity, or other reasons. Please ensure the participant did not leave abruptly and has a stable network connection.",resultCategories:["ExpectedError"]},10325:{code:408,subCode:10325,message:"",resultCategories:["UnexpectedClientError"]},500001:{code:408,subCode:500001,message:"Gateway (SBC) failover timer expired.",resultCategories:["ExpectedError"]},560408:{code:408,subCode:560408,message:"The called party did not respond.",resultCategories:["ExpectedError"]}},410:{3100:{public:!0,code:410,subCode:3100,message:"Call setup failed due to unexpected network problem on the client, please check client's network and retry.",resultCategories:["UnexpectedClientError"]},3101:{public:!0,code:410,subCode:3101,message:"Call dropped due to unexpected network problem on the client, check the client's network and retry.",resultCategories:["UnexpectedClientError"]},3111:{public:!0,code:410,subCode:3111,message:"Call setup failed, unable to process media offer while connecting the call.",resultCategories:["UnexpectedClientError"]},3112:{public:!0,code:410,subCode:3112,message:"Call setup failed due to network configuration problem on the client side, please check client's network configuration, and retry.",resultCategories:["ExpectedError"]},301004:{public:!0,code:410,subCode:301004,message:"Participant was removed from the call by the Azure Communication Services infrastructure due to inability to establish media connectivity with Azure Communication Services infrastructure during call setup. Check user's network configuration, including local network, firewalls, VPNs configuration and try again.",resultCategories:["UnexpectedClientError"]},301005:{public:!0,code:410,subCode:301005,message:"Participant was removed from the call by the Azure Communication Services infrastructure due to loss of media connectivity with Azure Communication Services infrastructure, this usually happens if participant leaves the call abruptly or looses network connectivity. If participant wants to continue the call, it should reconnect.",resultCategories:["UnexpectedClientError"]}},429:{5029:{code:429,subCode:5029,message:"",resultCategories:["ExpectedError"]},10110:{code:429,subCode:10110,message:"This call has exceeded the maximum call lifetime.",resultCategories:["ExpectedError"]}},430:{10315:{code:430,subCode:10315,message:"Unable to deliver message to client application. Please ensure the client application is successfully sending netwwork requests to Azure Communication Services.",resultCategories:["ExpectedError"]},10317:{code:430,subCode:10317,message:"Unable to deliver message to client application. Please ensure the client application is successfully sending netwwork requests to Azure Communication Services.",resultCategories:["ExpectedError"]}},480:{10037:{public:!0,code:480,subCode:10037,message:"Target user did not have any endpoints registered with ACS. Please ensure that target user has at least one active endpoint and it is online.",resultCategories:["ExpectedError"]},10076:{public:!0,code:480,subCode:10076,message:"Target user was registered but it wasn't online at the time of the call. Ensure that target user has at least one active endpoint and it's online.",resultCategories:["ExpectedError"]},10077:{public:!0,code:480,subCode:10077,message:"Target user was registered with ACS and/or for push notifications, but it wasn't online at the time of the call. Ensure that target user has at least one active endpoint and it's online.",resultCategories:["ExpectedError"]},10078:{public:!0,code:480,subCode:10078,message:"Remote client endpoint not registered or not reachable. Ensure the remote client endpoint is successfully sending network requests to Azure Communication Services.",resultCategories:["ExpectedError"]},560480:{code:480,subCode:560480,message:"No answer from callee. Please double check why the callee did not answer the call. Retry the call later in case that the callee was temporary unavailable.",resultCategories:["ExpectedError"]}},484:{560484:{code:484,subCode:560484,message:"Incomplete/Invalid callee address.",resultCategories:["ExpectedError"]}},486:{560486:{public:!0,code:486,subCode:560486,message:"Call ended because remote PSTN participant was busy. The number called was already in a call or having technical issues.",resultCategories:["Success"]}},487:{0:{public:!0,code:487,subCode:0,message:"Call ended successfully as caller canceled the call.",resultCategories:["Success"]},4501:{code:487,subCode:4501,message:"Call canceled, locally declined, ended due to an endpoint mismatch issue, or failed to generate media offer.",resultCategories:["Success"]},10003:{public:!0,code:487,subCode:10003,message:"Call was cancelled for this user endpoint as it was was accepted elsewhere, by another endpoint.",resultCategories:["Success"]},10004:{public:!0,code:487,subCode:10004,message:"Call was cancelled on timeout, as target user did not accept or reject it on time. Ensure that user saw the notification and/or application can handle it automatically and try to initiate that call again.",resultCategories:["ExpectedError"]},10024:{public:!0,code:487,subCode:10024,message:"Call ended successfully as it was declined by all callee endpoints.",resultCategories:["Success"]},540200:{code:487,subCode:540200,message:"Call canceled, locally declined, ended due to an endpoint mismatch issue, or failed to generate media offer.",resultCategories:["Success"]},540487:{public:!0,code:487,subCode:540487,message:"Call ended successfully as caller canceled the call.",resultCategories:["Success"]},560487:{code:487,subCode:560487,message:"Call cancelled by originator.",resultCategories:["Success"]}},490:{4502:{public:!0,code:490,subCode:4502,message:"Call failed due to network connectivity problems, browser failed to complete the network HTTP request.",resultCategories:["UnexpectedClientError"]}},495:{4507:{public:!0,code:495,subCode:4507,message:"Call ended as application didn't provide a valid Azure Communication Services token.",resultCategories:["UnexpectedClientError"]}},496:{7:{public:!0,code:496,subCode:7,message:"Call ended as client lost network connection abruptly, and despite retrying multiple times it wasn't able to connect.",resultCategories:["ExpectedError"]}},500:{10045:{code:500,subCode:10045,message:"Azure Communication Services infrastructure error. Please gather browser console logs, .HAR file, and contact Azure Communication Services support.",resultCategories:["UnexpectedClientError"]}},503:{560503:{code:503,subCode:560503,message:"Unexpected server error",resultCategories:["UnexpectedServerError"]}},603:{0:{public:!0,code:603,subCode:0,message:"Call ended successfully as it was declined from callee.",resultCategories:["Success"]}}},Ikt=aj.BAD_REQUEST,BDe=aj.REQUEST_TIMEOUT,FDe=aj.PRECONDITION_FAILED,qK=aj.UNPROCESSABLE_ENTITY,jL=aj.INTERNAL_ERROR,WK="19:preview-",wkt={Date:!0,RegExp:!0,String:!0,Number:!0},UDe=3e3,rj=Symbol("INTERNAL_TELEMETRY_ERROR_MESSAGE_SYMBOL");var zDe;class Oe extends Error{constructor(e){if(super(),this._code=0,this._subCode=0,this._resultCategories=[],this[zDe]="",this.name="CallingCommunicationError",e.originalError instanceof Oe)return this._code=e.originalError.code,this._subCode=e.originalError.subCode,this._resultCategories=e.originalError.resultCategories,this.message=e.originalError.message,this.stack=e.originalError.stack,void(this[rj]=e.originalError[rj]);e.defaultErrorMessageArgs?this.message=e.defaultError.message.replace(/{(\d+)}/g,function(i,r){return e.defaultErrorMessageArgs&&e.defaultErrorMessageArgs[r]!==void 0?e.defaultErrorMessageArgs[r]:i}):this.message=e.defaultError.message,this._code=e.defaultError.code,this._subCode=e.defaultError.subCode,this._resultCategories=e.defaultError.resultCategories,e.originalError instanceof Error&&(this.stack=e.originalError.stack,this[rj]=e.originalError.message)}get code(){return this._code}get subCode(){return this._subCode}get resultCategories(){return this._resultCategories}}zDe=rj;const VDe=Symbol("loggerKeySymbol");var zx,GL,KK;function sg(t){return $De(t||"",!1)}function to(t){return $De(t||"",!0)}(function(t){t.CallAgent="CallAgent",t.TeamsCallAgent="TeamsCallAgent"})(zx||(zx={})),function(t){t.Call="Call",t.TeamsCall="TeamsCall"}(GL||(GL={})),function(t){t.IncomingCall="IncomingCall",t.TeamsIncomingCall="TeamsIncomingCall"}(KK||(KK={}));const qL=t=>(e,i,r)=>{const o=r.value;return r.value=function(...l){if(this.kind===GL.TeamsCall&&this.isEmergencyCallInProgress())throw new Oe({defaultError:we.CALL.OPERATION_NOT_ALLOWED_DURING_EMERGENCY_CALL,defaultErrorMessageArgs:[t]});return o.apply(this,l)},r},$De=(t,e)=>e?(i,r,o)=>{const l=o.value;return o.value=async function(...d){let h;const p=+new Date;JK(this,t,"started");try{h=await l.apply(this,d),JK(this,t,"succeeded",p)}catch(g){const f=new Oe({defaultError:we.CALL.OPERATION_FAILED,defaultErrorMessageArgs:[t],originalError:g});throw HDe(this,t,g,p),f}return h},o}:(i,r,o)=>{const l=o.value;return o.value=function(...d){let h;const p=+new Date;JK(this,t,"started");try{h=l.apply(this,d),JK(this,t,"succeeded",p)}catch(g){const f=new Oe({defaultError:we.CALL.OPERATION_FAILED,defaultErrorMessageArgs:[t],originalError:g});throw HDe(this,t,g,p),f}return h},o};function JK(t,e,i,r){const o=jDe(t);if(o){const l=r?`in ${(+new Date-r)/1e3}s`:"";o.info(`op:${e}, ${i} ${l}`)}}function HDe(t,e,i,r){const o=jDe(t);try{if(o){const l=r?`in ${(+new Date-r)/1e3}s`:"";o.error(`op:${e} failed, message=${i.message}, code=${i.code}${i.subCode?`, subCode=${i.subCode}`:""} ${l}`),i&&o.error(`op:${e} failed, message=${i.message}, code=${i.code}, subCode=${i.subCode}, resultCategories=${i.resultCategories}, time elapsed=${l}`)}}catch{}}function jDe(t){try{const e=Reflect.getMetadata(VDe,t);if(e)return t[e]}catch{}}var kkt="function",YK="object",QK="undefined",oj="prototype",cce=Object,Rkt=cce[oj];/*! https://github.com/nevware21/ts-utils v0.11.8 */function zM(t,e){return t||e}function QS(t,e){return t[e]}var dce,MC=void 0,xm=null,uce="",ZK="function",sj="object",VM="prototype",hce="__proto__",Vx="undefined",XK="constructor",pce="Symbol",Mkt="_polyfill",$x="length",eJ="name",Nv="call",tJ="toString",AE=zM(Object),gce=QS(AE,VM),GDe=zM(String),Hx=QS(GDe,VM),Pkt=zM(Math),qDe=zM(Array),WDe=QS(qDe,VM),$M=QS(WDe,"slice");function xv(t,e){try{return{v:t.apply(this,e)}}catch(i){return{e:i}}}function Dkt(t,e){var i=xv(t);return i.e?e:i.v}function iJ(t){return function(e){return typeof e===t}}function KDe(t){var e="[object "+t+"]";return function(i){return!(!i||Lkt(i)!==e)}}function Lkt(t){return gce[tJ].call(t)}function vd(t){return typeof t===Vx||t===Vx}function Okt(t){return!nJ(t)}function pc(t){return t===xm||vd(t)}function Nkt(t){return t===xm||!nJ(t)}function nJ(t){return!!t||t!==MC}function xkt(t){return!dce&&(dce=["string","number","boolean",Vx,"symbol","bigint"]),!(t===sj||dce.indexOf(t)===-1)}var Bm=iJ("string"),Ul=iJ(ZK);function jx(t){return!(!t&&pc(t))&&!!t&&typeof t===sj}var ds=QS(qDe,"isArray"),Bkt=KDe("Date"),HM=iJ("number"),Gx=iJ("boolean"),Fkt=KDe("Error");function WL(t){return!!(t&&t.then&&Ul(t.then))}function JDe(t){return!(!t||Dkt(function(){return!(t&&0+t)},!t))}var aJ=QS(AE,"getOwnPropertyDescriptor");function IE(t,e){return!!t&&gce.hasOwnProperty[Nv](t,e)}var jM=zM(QS(AE,"hasOwn"),Ukt);function Ukt(t,e){return IE(t,e)||!!aJ(t,e)}function nc(t,e,i){if(t&&jx(t)){for(var r in t)if(jM(t,r)&&e[Nv](t,r,t[r])===-1)break}}var rJ={e:"enumerable",c:"configurable",v:"value",w:"writable",g:"get",s:"set"};function YDe(t){var e={};if(e[rJ.c]=!0,e[rJ.e]=!0,t.l){e.get=function(){return t.l.v};var i=aJ(t.l,"v");i&&i.set&&(e.set=function(r){t.l.v=r})}return nc(t,function(r,o){e[rJ[r]]=Okt(o)?e[rJ[r]]:o}),e}var wE=QS(AE,"defineProperty"),zkt=QS(AE,"defineProperties");function Jc(t,e,i){return wE(t,e,YDe(i))}function Vkt(t,e){var i={};return nc(e,function(r,o){i[r]=YDe(o)}),zkt(t,i)}function QDe(t,e,i,r,o){var l={};return nc(t,function(d,h){oJ(l,d,e?h:d),oJ(l,h,d)}),r?r(l):l}function oJ(t,e,i,r){wE(t,e,{value:i,enumerable:!0,writable:!1})}var kE=zM(GDe),$kt="[object Error]";function Ws(t,e){var i=uce,r=gce[tJ][Nv](t);r===$kt&&(t={stack:kE(t.stack),message:kE(t.message),name:kE(t.name)});try{i=((i=JSON.stringify(t,xm,e?typeof e=="number"?e:4:MC))?i.replace(/"(\w+)"\s*:\s{0,1}/g,"$1: "):xm)||kE(t)}catch(o){i=" - "+Ws(o,e)}return r+": "+i}function wA(t){throw new Error(t)}function PC(t){throw new TypeError(t)}var ZDe=QS(AE,"freeze");function Hkt(t){return t}function jkt(t){return t[hce]||xm}var XDe=QS(AE,"assign"),Ww=QS(AE,"keys");function F5(t){return ZDe&&nc(t,function(e,i){(ds(i)||jx(i))&&F5(i)}),KL(t)}var KL=zM(ZDe,Hkt),mce=zM(QS(AE,"getPrototypeOf"),jkt);function Gkt(t){return QDe(t,1,0,KL)}function qkt(t){return QDe(t,0,0,KL)}function Wkt(t){var e={};return nc(t,function(i,r){oJ(e,i,r[1]),oJ(e,r[0],r[1])}),KL(e)}function Kkt(t){return Wkt(t)}var fce,eLe=qkt({asyncIterator:0,hasInstance:1,isConcatSpreadable:2,iterator:3,match:4,matchAll:5,replace:6,search:7,species:8,split:9,toPrimitive:10,toStringTag:11,unscopables:12}),tLe="__tsUtils$gblCfg";function iLe(){var t;return typeof globalThis!==Vx&&(t=globalThis),t||typeof self===Vx||(t=self),t||typeof window===Vx||(t=window),t||typeof global===Vx||(t=global),t}function nLe(){if(!fce){var t=xv(iLe).v||{};fce=t[tLe]=t[tLe]||{}}return fce}var sJ=lj;function lj(t,e,i){var r=e?e[t]:xm;return function(o){var l=(o?o[t]:xm)||r;if(l||i){var d=arguments;return(l||i).apply(o,l?$M[Nv](d,1):d)}PC('"'+kE(t)+'" not defined for '+Ws(o))}}function Jkt(t){return function(e){return e[t]}}var Ykt=QS(Pkt,"max"),aLe=sJ("slice",Hx),ZS=sJ("substring",Hx),kA=lj("substr",Hx,Qkt);function Qkt(t,e,i){return pc(t)&&PC("Invalid "+Ws(t)),i<0?uce:((e=e||0)<0&&(e=Ykt(e+t[$x],0)),vd(i)?aLe(t,e):aLe(t,e,e+i))}function lJ(t,e){return ZS(t,0,e)}var vce,cJ,Kg,rLe="_urid";function Zkt(){if(!vce){var t=nLe();vce=t.gblSym=t.gblSym||{k:{},s:{}}}return vce}function yce(t){var e={description:kE(t),toString:function(){return pce+"("+t+")"}};return e[Mkt]=!0,e}function Xkt(t){var e=Zkt();if(!jM(e.k,t)){var i=yce(t),r=Ww(e.s).length;i[rLe]=function(){return r+"_"+i[tJ]()},e.k[t]=i,e.s[i[rLe]()]=kE(t)}return e.k[t]}function eRt(t){var e;!cJ&&(cJ={});var i=eLe[t];return i&&(e=cJ[i]=cJ[i]||yce(pce+"."+i)),e}function JL(){Kg=nLe()}function tRt(t){var e={};return!Kg&&JL(),e.b=Kg.lzy,wE(e,"v",{configurable:!0,get:function(){var i=t();return Kg.lzy||wE(e,"v",{value:i}),e.b=Kg.lzy,i}}),e}function RE(t){return wE({toJSON:function(){return t}},"v",{value:t})}var cj,oLe="window";function dJ(t,e){var i;return function(){return!Kg&&JL(),i&&!Kg.lzy||(i=RE(xv(t,e).v)),i.v}}function YL(t){return!Kg&&JL(),cj&&t!==!1&&!Kg.lzy||(cj=RE(xv(iLe).v||xm)),cj.v}function Su(t,e){var i;if((i=cj&&e!==!1?cj.v:YL(e))&&i[t])return i[t];if(t===oLe)try{return window}catch{}return xm}function sLe(){return!!GM()}var GM=dJ(Su,["document"]);function iRt(){return!!QL()}var QL=dJ(Su,[oLe]);function nRt(){return!!Kw()}var dj,lLe,uJ,Kw=dJ(Su,["navigator"]),aRt=dJ(function(){return!!xv(function(){return process&&(process.versions||{}).node}).v});function hJ(){return dj=RE(xv(Su,[pce]).v)}function rRt(t){var e=(Kg.lzy?0:dj)||hJ();return e.v?e.v[t]:MC}function oRt(){return!!sRt()}function sRt(){return!Kg&&JL(),((Kg.lzy?0:dj)||hJ()).v}function pJ(t,e){var i=eLe[t];!Kg&&JL();var r=(Kg.lzy?0:dj)||hJ();return r.v?r.v[i||t]:eRt(t)}function Jw(t,e){!Kg&&JL();var i=(Kg.lzy?0:dj)||hJ();return i.v?i.v(t):yce(t)}function U5(t){return!Kg&&JL(),((lLe=(Kg.lzy?0:lLe)||RE(xv(rRt,["for"]).v)).v||Xkt)(t)}function Sce(t){return!!t&&Ul(t.next)}function cLe(t){return!Nkt(t)&&Ul(t[pJ(3)])}function bce(t,e,i){if(t&&(Sce(t)||(!uJ&&(uJ=RE(pJ(3))),t=t[uJ.v]?t[uJ.v]():xm),Sce(t))){var r=MC,o=MC;try{for(var l=0;!(o=t.next()).done&&e[Nv](i||t,o.value,l,t)!==-1;)l++}catch(d){r={e:d},t.throw&&(o=xm,t.throw(r))}finally{try{o&&!o.done&&t.return&&t.return(o)}finally{if(r)throw r.e}}}}function z5(t,e,i){return t.apply(e,i)}function ZL(t,e){return!vd(e)&&t&&(ds(e)?z5(t.push,t,e):Sce(e)||cLe(e)?bce(e,function(i){t.push(i)}):t.push(e)),t}function Qa(t,e,i){if(t)for(var r=t[$x]>>>0,o=0;o<r&&(!(o in t)||e[Nv](t,t[o],o,t)!==-1);o++);}var Bv=sJ("indexOf",WDe);function V5(t,e,i){return((t?t.slice:xm)||$M).apply(t,$M[Nv](arguments,1))}var Tce,XL=zM(QS(AE,"create"),lRt);function lRt(t){if(!t)return{};var e=typeof t;function i(){}return e!==sj&&e!==ZK&&PC("Prototype must be an Object or function: "+Ws(t)),i[VM]=t,new i}function dLe(t,e){var i=AE.setPrototypeOf||function(r,o){var l;!Tce&&(Tce=RE(((l={})[hce]=[],l instanceof Array))),Tce.v?r[hce]=o:nc(o,function(d,h){return r[d]=h})};return i(t,e)}function cRt(t,e,i){function r(){this[XK]=e,xv(Jc,[this,eJ,{v:t,c:!0,e:!1}])}return xv(Jc,[e,eJ,{v:t,c:!0,e:!1}]),(e=dLe(e,i))[VM]=i===xm?XL(i):(r[VM]=i[VM],new r),e}function uLe(t,e){e&&(t[eJ]=e)}function Cce(t,e,i){var r=Error,o=r[VM][eJ],l=Error.captureStackTrace;return cRt(t,function(){var d=this,h=arguments;try{xv(uLe,[r,t]);var p=z5(r,d,$M[Nv](h))||d;if(p!==d){var g=mce(d);g!==mce(p)&&dLe(p,g)}return l&&l(p,d[XK]),e&&e(p,h),p}finally{xv(uLe,[r,o])}},r)}function XS(){return(Date.now||dRt)()}function dRt(){return new Date().getTime()}function uRt(t){return function(i){return pc(i)&&PC("strTrim called ["+Ws(i)+"]"),i&&i.replace&&(i=i.replace(t,uce)),i}}var _ce,Ece,Ace,dT=lj("trim",Hx,uRt(/^\s+|(?=\s)\s+$/g));function Fv(t){if(!t||typeof t!==sj)return!1;Ace||(Ace=!iRt()||QL());var e=!1;if(t!==Ace){Ece||(_ce=Function[VM][tJ],Ece=_ce[Nv](AE));try{var i=mce(t);(e=!i)||(IE(i,XK)&&(i=i[XK]),e=!(!i||typeof i!==ZK||_ce[Nv](i)!==Ece))}catch{}}return e}function hRt(t){return t.value&&gLe(t),!0}var hLe=[fRt,gLe,yRt,vRt];function pRt(t,e,i,r){var o;return Qa(t,function(l){if(l.k===e)return o=l,-1}),o||(o={k:e,v:e},t.push(o),r(o)),o.v}function Ice(t,e,i,r){var o=i.handler,l=i.path?r?i.path.concat(r):i.path:[],d={handler:i.handler,src:i.src,path:l},h=typeof e,p=!1,g=e===xm;g||(e&&h===sj?p=Fv(e):g=xkt(h));var f={type:h,isPrim:g,isPlain:p,value:e,result:e,path:l,origin:i.src,copy:function(y,T){return Ice(t,y,T?d:i,T)},copyTo:function(y,T){return pLe(t,y,T,d)}};return f.isPrim?o&&o[Nv](i,f)?f.result:e:pRt(t,e,l,function(y){Jc(f,"result",{g:function(){return y.v},s:function(E){y.v=E}});for(var T=0,C=o;!(C||(T<hLe.length?hLe[T++]:hRt))[Nv](i,f);)C=xm})}function pLe(t,e,i,r){if(!pc(i))for(var o in i)e[o]=Ice(t,i[o],r,o);return e}function gRt(t,e,i){return pLe([],t,e,{handler:i,src:e,path:[]})}function mRt(t,e){return Ice([],t,{handler:e,src:t})}function fRt(t){var e=t.value;if(ds(e)){var i=t.result=[];return i.length=e.length,t.copyTo(i,e),!0}return!1}function vRt(t){var e=t.value;return!!Bkt(e)&&(t.result=new Date(e.getTime()),!0)}function yRt(t){return t.type===ZK}function gLe(t){var e=t.value;if(e&&t.isPlain){var i=t.result={};return t.copyTo(i,e),!0}return!1}function SRt(t,e){return Qa(e,function(i){gRt(t,i)}),t}function mLe(t,e,i,r,o,l,d){return SRt(mRt(t)||{},$M[Nv](arguments))}var wce,qM=Jkt($x);function bRt(){return!Kg&&JL(),wce&&!Kg.lzy||(wce=RE(xv(Su,["performance"]).v)),wce.v}function fLe(){var t=bRt();return t&&t.now?t.now():XS()}var TRt=lj("endsWith",Hx,CRt);function CRt(t,e,i){Bm(t)||PC("'"+Ws(t)+"' is not a string");var r=Bm(e)?e:kE(e),o=!vd(i)&&i<t[$x]?i:t[$x];return ZS(t,o-r[$x],o)===r}var $5=sJ("indexOf",Hx),vLe=lj("startsWith",Hx,_Rt);function _Rt(t,e,i){Bm(t)||PC("'"+Ws(t)+"' is not a string");var r=Bm(e)?e:kE(e),o=i>0?i:0;return ZS(t,o,o+r[$x])===r}var kce="ref",Rce="unref",Mce="hasRef",ERt="enabled";function ARt(t,e,i){var r,o=!0,l=t?e(xm):xm;function d(){return o=!1,l&&l[Rce]&&l[Rce](),r}function h(){l&&i(l),l=xm}function p(){return l=e(l),o||d(),r}function g(f){!f&&l&&h(),f&&!l&&p()}return(r={cancel:h,refresh:p})[Mce]=function(){return l&&l[Mce]?l[Mce]():o},r[kce]=function(){return o=!0,l&&l[kce]&&l[kce](),r},r[Rce]=d,{h:r=wE(r,ERt,{get:function(){return!!l},set:g}),dn:function(){l=xm}}}function Pce(t,e,i){var r=ds(e),o=r?e.length:0,l=(o>0?e[0]:r?MC:e)||setTimeout,d=(o>1?e[1]:MC)||clearTimeout,h=i[0];i[0]=function(){p.dn(),z5(h,MC,$M[Nv](arguments))};var p=ARt(t,function(g){if(g){if(g.refresh)return g.refresh(),g;z5(d,MC,[g])}return z5(l,MC,i)},function(g){z5(d,MC,[g])});return p.h}function Yw(t,e){return Pce(!0,MC,$M[Nv](arguments))}function IRt(t,e,i){return Pce(!0,t,$M[Nv](arguments,1))}function wRt(t,e){return Pce(!1,MC,$M[Nv](arguments))}(YL()||{}).Symbol,(YL()||{}).Reflect;var gJ,kRt="hasOwnProperty",Dce=function(t,e){return Dce=cce.setPrototypeOf||{__proto__:[]}instanceof Array&&function(i,r){i.__proto__=r}||function(i,r){for(var o in r)r[kRt](o)&&(i[o]=r[o])},Dce(t,e)};function uj(t,e){function i(){this.constructor=t}typeof e!==kkt&&e!==null&&PC("Class extends value "+String(e)+" is not a constructor or null"),Dce(t,e),t[oj]=e===null?XL(e):(i[oj]=e[oj],new i)}function yLe(t,e){for(var i=0,r=e.length,o=t.length;i<r;i++,o++)t[o]=e[i];return t}var mJ="constructor",WM="prototype",fJ="function",vJ="_dynInstFuncs",Lce="_isDynProxy",H5="_dynClass",RRt="_dynCls$",Oce="_dynInstChk",hj=Oce,SLe="_dfOpts",bLe="_unknown_",Nce="__proto__",yJ="_dyn"+Nce,TLe="__dynProto$Gbl",xce="_dynInstProto",SJ="useBaseInst",Bce="setInstFuncs",Fce=Object,pj=Fce.getPrototypeOf,CLe=Fce.getOwnPropertyNames,_Le=YL(),Uce=_Le[TLe]||(_Le[TLe]={o:(gJ={},gJ[Bce]=!0,gJ[SJ]=!0,gJ),n:1e3});function bJ(t){return t&&(t===Fce[WM]||t===Array[WM])}function zce(t){return bJ(t)||t===Function[WM]}function qx(t){var e;if(t){if(pj)return pj(t);var i=t[Nce]||t[WM]||(t[mJ]?t[mJ][WM]:null);e=t[yJ]||i,IE(t,yJ)||(delete t[xce],e=t[yJ]=t[xce]||t[yJ],t[xce]=i)}return e}function TJ(t,e){var i=[];if(CLe)i=CLe(t);else for(var r in t)typeof r=="string"&&IE(t,r)&&i.push(r);if(i&&i.length>0)for(var o=0;o<i.length;o++)e(i[o])}function Vce(t,e,i){return e!==mJ&&typeof t[e]===fJ&&(i||IE(t,e))&&e!==Nce&&e!==WM}function CJ(t){PC("DynamicProto: "+t)}function MRt(t){var e=XL(null);return TJ(t,function(i){!e[i]&&Vce(t,i,!1)&&(e[i]=t[i])}),e}function $ce(t,e){for(var i=t.length-1;i>=0;i--)if(t[i]===e)return!0;return!1}function PRt(t,e,i,r){function o(p,g,f){var y=g[f];if(y[Lce]&&r){var T=p[vJ]||{};T[hj]!==!1&&(y=(T[g[H5]]||{})[f]||y)}return function(){return y.apply(p,arguments)}}var l=XL(null);TJ(i,function(p){l[p]=o(e,i,p)});for(var d=qx(t),h=[];d&&!zce(d)&&!$ce(h,d);)TJ(d,function(p){!l[p]&&Vce(d,p,!pj)&&(l[p]=o(e,d,p))}),h.push(d),d=qx(d);return l}function DRt(t,e,i,r){var o=null;if(t&&IE(i,H5)){var l=t[vJ]||XL(null);if((o=(l[i[H5]]||XL(null))[e])||CJ("Missing ["+e+"] "+fJ),!o[Oce]&&l[hj]!==!1){for(var d=!IE(t,e),h=qx(t),p=[];d&&h&&!zce(h)&&!$ce(p,h);){var g=h[e];if(g){d=g===r;break}p.push(h),h=qx(h)}try{d&&(t[e]=o),o[Oce]=1}catch{l[hj]=!1}}}return o}function LRt(t,e,i){var r=e[t];return r===i&&(r=qx(e)[t]),typeof r!==fJ&&CJ("["+t+"] is not a "+fJ),r}function ORt(t,e,i,r,o){function l(p,g){var f=function(){return(DRt(this,g,p,f)||LRt(g,p,f)).apply(this,arguments)};return f[Lce]=1,f}if(!bJ(t)){var d=i[vJ]=i[vJ]||XL(null);if(!bJ(d)){var h=d[e]=d[e]||XL(null);d[hj]!==!1&&(d[hj]=!!o),bJ(h)||TJ(i,function(p){Vce(i,p,!1)&&i[p]!==r[p]&&(h[p]=i[p],delete i[p],(!IE(t,p)||t[p]&&!t[p][Lce])&&(t[p]=l(t,p)))})}}}function NRt(t,e){if(pj){for(var i=[],r=qx(e);r&&!zce(r)&&!$ce(i,r);){if(r===t)return!0;i.push(r),r=qx(r)}return!1}return!0}function Hce(t,e){return IE(t,WM)?t.name||e||bLe:((t||{})[mJ]||{}).name||e||bLe}function Yc(t,e,i,r){IE(t,WM)||CJ("theClass is an invalid class definition.");var o=t[WM];NRt(o,e)||CJ("["+Hce(t)+"] not in hierarchy of ["+Hce(e)+"]");var l=null;IE(o,H5)?l=o[H5]:(l=RRt+Hce(t,"_")+"$"+Uce.n,Uce.n++,o[H5]=l);var d=Yc[SLe],h=!!d[SJ];h&&r&&r[SJ]!==void 0&&(h=!!r[SJ]);var p=MRt(e);i(e,PRt(o,e,p,h));var g=!!pj&&!!d[Bce];g&&r&&(g=!!r[Bce]),ORt(o,l,e,p,g!==!1)}Yc[SLe]=Uce.o;var jce,eO=Gkt,Wx=eO({Unknown:0,NonRetryableStatus:1,InvalidEvent:2,SizeLimitExceeded:3,KillSwitch:4,QueueFull:5}),j5=(eO({Unknown:0,NonRetryableStatus:1,CleanStorage:2,MaxInStorageTimeExceeded:3}),eO({NONE:0,PENDING:3,INACTIVE:1,ACTIVE:2})),Gce="toLowerCase",_J="blkVal",el="length",EJ="rdOnly",AJ="notify",IJ="warnToConsole",gj="throwInternal",G5="setDf",tO="watch",lg="logger",wJ="apply",yd="push",mj="splice",ELe="hdlr",q5="cancel",fj="initialize",iO="identifier",kJ="removeNotificationListener",RJ="addNotificationListener",Qw="isInitialized",ALe="instrumentationKey",qce="INACTIVE",vj="value",MJ="getNotifyMgr",yj="getPlugin",Kx="name",Sj="iKey",W5="time",eb="processNext",ILe="getProcessTelContext",wLe="pollInternalLogs",K5="enabled",kLe="stopPollingInternalLogs",nO="unload",PJ="onComplete",RLe="version",MLe="loggingLevelConsole",Jx="createNew",KM="teardown",DJ="messageId",Yx="message",J5="isAsync",JM="diagLog",LJ="_doTeardown",bj="update",Zw="getNext",Tj="setNextPlugin",PLe="protocol",Wce="userAgent",OJ="split",Kce="nodeType",Qx="replace",xRt="logInternalMessage",YM="type",Jce="handler",Cj="status",DLe="getResponseHeader",LLe="getAllResponseHeaders",Yce="isChildEvt",Y5="data",Q5="getCtx",Xw="setCtx",Qce="complete",_j="urlString",OLe="sendPOST",Zce="headers",Z5="timeout",NLe="setRequestHeader",xLe="traceId",BLe="spanId",FLe="traceFlags";function BRt(t,e){jce||(jce=Cce("AggregationError",function(r,o){o[el]>1&&(r.errors=o[1])}));var i=t;throw Qa(e,function(r,o){i+=`
`.concat(o," > ").concat(Ws(r))}),new jce(i,e||[])}/*!
 * NevWare21 Solutions LLC - ts-async, 0.5.4
 * https://github.com/nevware21/ts-async
 * Copyright (c) NevWare21 Solutions LLC and contributors. All rights reserved.
 * Licensed under the MIT license.
 */var NJ="Promise",Xce="rejected";function DC(t,e){return Zx(t,function(i){return e?e({status:"fulfilled",rejected:!1,value:i}):i},function(i){return e?e({status:Xce,rejected:!0,reason:i}):i})}function Zx(t,e,i,r){var o=t;try{if(WL(t))(e||i)&&(o=t.then(e,i));else try{e&&(o=e(t))}catch(l){if(!i)throw l;o=i(l)}}finally{}return o}var xJ,ULe=["pending","resolving","resolved",Xce],zLe="dispatchEvent";function FRt(t){var e;return t&&t.createEvent&&(e=t.createEvent("Event")),!!e&&e.initEvent}function URt(t,e,i,r){var o=GM();!xJ&&(xJ=RE(!!xv(FRt,[o]).v));var l=xJ.v?o.createEvent("Event"):r?new Event(e):{};if(i&&i(l),xJ.v&&l.initEvent(e,!1,!0),l&&t[zLe])t[zLe](l);else{var d=t["on"+e];if(d)d(l);else{var h=Su("console");h&&(h.error||h.log)(e,Ws(l))}}}var ede,VLe="unhandledRejection",zRt=VLe.toLowerCase(),$Le=[],VRt=0,$Rt=10;function HLe(t){return Ul(t)?t.toString():Ws(t)}function HRt(t,e,i){var r,o,l=V5(arguments,3),d=0,h=!1,p=[],g=VRt++,f=!1,y=null;function T(B,L){try{return $Le.push(g),f=!0,y&&y.cancel(),y=null,t(function(z,H){p.push(function(){try{var j=d===2?B:L,J=vd(j)?r:Ul(j)?j(r):j;WL(J)?J.then(z,H):j?z(J):d===3?H(J):z(J)}catch(Z){H(Z)}}),h&&w()},l)}finally{$Le.pop()}}function C(B){return T(void 0,B)}function E(B){var L=B,z=B;return Ul(B)&&(L=function(H){return B&&B(),H},z=function(H){throw B&&B(),H}),T(L,z)}function I(){return ULe[d]}function w(){if(p.length>0){var B=p.slice();p=[],f=!0,y&&y.cancel(),y=null,e(B)}}function D(B,L){return function(z){if(d===L){if(B===2&&WL(z))return d=1,void z.then(D(2,1),D(3,1));d=B,h=!0,r=z,w(),f||B!==3||y||(y=Yw(F,$Rt))}}}function F(){if(!f)if(f=!0,aRt())process.emit(VLe,r,o);else{var B=QL()||YL();!ede&&(ede=RE(xv(Su,[NJ+"RejectionEvent"]).v)),URt(B,zRt,function(L){return Jc(L,"promise",{g:function(){return o}}),L.reason=r,L},!!ede.v)}}function x(){return"IPromise "+I()+(h?" - "+HLe(r):"")}return wE(o={then:T,catch:C,finally:E},"state",{get:I}),oRt()&&(o[pJ(11)]="IPromise"),o.toString=x,function(){Ul(i)||PC(NJ+": executor is not a function - "+HLe(i));var L=D(3,0);try{i.call(o,D(2,0),L)}catch(z){L(z)}}(),o}function jLe(t){return function(e){var i=V5(arguments,1);return t(function(r,o){try{var l=[],d=1;bce(e,function(h,p){h&&(d++,Zx(h,function(g){l[p]=g,--d==0&&r(l)},o))}),--d===0&&r(l)}catch(h){o(h)}},i)}}function jRt(t){return function(e){var i=V5(arguments,1);return WL(e)?e:t(function(r){r(e)},i)}}function GRt(t){return function(e){var i=V5(arguments,1);return t(function(r,o){o(e)},i)}}function qRt(t){return RE(function(e){var i=V5(arguments,1);return t(function(r,o){var l=[],d=1;function h(p,g){d++,DC(p,function(f){f.rejected?l[g]={status:Xce,reason:f.reason}:l[g]={status:"fulfilled",value:f.value},--d==0&&r(l)})}try{ds(e)?Qa(e,h):cLe(e)?bce(e,h):PC("Input is not an iterable"),--d===0&&r(l)}catch(p){o(p)}},i)})}function WRt(t){Qa(t,function(e){try{e()}catch{}})}function KRt(t){var e=HM(t)?t:0;return function(i){Yw(function(){WRt(i)},e)}}function Gh(t,e){return HRt(Gh,KRt(e),t,e)}var tde,ide,nde,JRt=jLe(Gh),YRt=jRt(Gh),QM=GRt(Gh);function QRt(t,e){!tde&&(tde=RE(xv(Su,[NJ]).v||null));var i=tde.v;if(!i)return Gh(t);Ul(t)||PC(NJ+": executor is not a function - "+Ws(t));var r=0;function o(){return ULe[r]}var l=new i(function(d,h){function p(f){r=2,d(f)}function g(f){r=3,h(f)}t(p,g)});return wE(l,"state",{get:o}),l}function ZM(t,e){return!ide&&(ide=RE(QRt)),ide.v.call(this,t,e)}var ZRt=jLe(ZM);function XRt(t,e){return!nde&&(nde=qRt(ZM)),nde.v(t,e)}var GLe,ade,Ej="reject",qLe="Rejected",eMt=0,rde={};function WLe(){}function BJ(t,e,i){!rde[t]&&(rde[t]=Cce(t));var r=XS();return new rde[t]("Task [".concat(e.id,"] ").concat(i||"","- ").concat(e.st?"Running":"Waiting",": ").concat(tMt(r,e.st||e.cr)))}function tMt(t,e){return(t-e||"0")+" ms"}function KLe(t,e){var i=XS()-e;Qa(t,function(r){(r&&!r.rj&&r.st&&r.st<i||!r.st&&r.cr&&r.cr<i)&&r&&r[Ej](r.rj||BJ("Aborted",r,"Stale "))})}function JLe(t,e){var i=Bv(t,e);i!==-1&&t.splice(i,1)}function iMt(t,e,i){ade=ade||{toString:function(){return"[[SchedulerState]]"}},wE(t,GLe=GLe||{toString:function(){return"[[SchedulerName]]"}},{get:e}),wE(t,ade,{get:i})}function ode(t,e){var i,r,o=[],l=[],d=6e5,h=d/10,p=0,g=(e?e+".":"")+eMt++;t=t||ZM;var f=function(){var w=qM(o)+qM(l)>0;d>0&&(r||(r=Yw(function(){KLe(o,d),KLe(l,d),r&&(r.enabled=qM(o)+qM(l)>0)},h)).unref(),r&&(r.enabled=w))},y=function(w,D,F){var x,B=g+"."+p++;D&&(B+="-("+D+")");var L=((x={id:B,cr:XS(),to:F})[Ej]=function(z){L.rj=z||BJ(qLe,L),L[Ej]=WLe},x);return L.p=i?C(L,i,w):t(T(L,w)),i=L,L.p},T=function(w,D){return w.st=XS(),o.push(w),f(),function(F,x){var B=function(H){w.rj=w.rj||H||BJ(qLe,w),w[Ej]=WLe,E(w),F=null,x&&x(H),x=null},L=w.id;if(w.rj)B(w.rj);else{w[Ej]=B;try{var z=D(L);w.to&&WL(z)&&(w.t=Yw(function(){B(BJ("Timeout",w))},w.to)),Zx(z,function(H){E(w);try{F&&F(H)}catch(j){x&&x(j)}x=null,F=null},B)}catch(H){B(H)}}}},C=function(w,D,F){return l.push(w),f(),t(function(x,B){DC(D.p,function(){JLe(l,w),T(w,F)(x,B)})})},E=function(w){JLe(o,w),w.t&&w.t.cancel(),w.t=null,i&&i===w&&(i=null,qM(o)+qM(l)===0&&(r&&r.cancel(),r=null))},I={idle:!0,queue:y,setStaleTimeout:function(w,D){r&&r.cancel(),r=null,d=w,h=D||w/10,f()}};return Jc(I,"idle",{g:function(){return qM(o)+qM(l)===0}}),iMt(I,function(){return g},function(){return{l:i,r:o,w:l}}),I}pJ(11);var ek=void 0,Qc="",Xx="channels",Fm="core",sde="createPerfMgr",lde="disabled",X5="extensionConfig",e3="extensions",tk="processTelemetry",FJ="priority",UJ="eventsSent",Aj="eventsDiscarded",zJ="eventsSendRequest",eB="perfEvent",cde="offlineEventsStored",dde="offlineBatchSent",ude="offlineBatchDrop",VJ="getPerfMgr",hde="domain",pde="path",nMt="Not dynamic - ",aMt=/-([a-z])/g,rMt=/([^\w\d_$])/g,oMt=/^(\d+[\w\d_$])/;function $J(t){return!pc(t)}function gde(t){var e=t;return e&&Bm(e)&&(e=(e=(e=e[Qx](aMt,function(i,r){return r.toUpperCase()}))[Qx](rMt,"_"))[Qx](oMt,function(i,r){return"_"+r})),e}function uT(t,e){return!(!t||!e)&&$5(t,e)!==-1}function mde(t){return t&&t.toISOString()||""}function YLe(t){return Fkt(t)?t[Kx]:Qc}function t3(t,e,i,r,o){var l=i;return t&&((l=t[e])===i||o&&!o(l)||r&&!r(i)||(l=i,t[e]=l)),l}function sMt(t,e,i){var r;return t?!(r=t[e])&&pc(r)&&(r=vd(i)?{}:i,t[e]=r):r=vd(i)?{}:i,r}function lMt(t,e){var i=null,r=null;return Ul(t)?i=t:r=t,function(){var o=arguments;if(i&&(r=i()),r)return r[e][wJ](r,o)}}function HJ(t,e,i,r,o){t&&e&&i&&o!==!1&&(t[e]=lMt(i,r))}function QLe(t,e,i,r){return t&&e&&jx(t)&&ds(i)&&Qa(i,function(o){Bm(o)&&HJ(t,o,e,o,r)}),t}function i3(t){return t&&XDe&&(t=cce(XDe({},t))),t}function n3(t){try{return t.responseText}catch{}return null}function cMt(t,e){return t?"XDomainRequest,Response:"+n3(t)||"":e}function ZLe(t,e){return t?"XMLHttpRequest,Status:"+t[Cj]+",Response:"+n3(t)||t.response||"":e}function XLe(t,e){return e&&(HM(e)?t=[e].concat(t):ds(e)&&(t=e.concat(t))),t}var dMt="Microsoft_ApplicationInsights_BypassAjaxInstrumentation",eOe="withCredentials",uMt="timeout";function hMt(t,e,i,r,o,l){function d(p,g,f){try{p[g]=f}catch{}}o===void 0&&(o=!1);var h=new XMLHttpRequest;return d(h,dMt,r),i&&d(h,eOe,i),h.open(t,e,!o),i&&d(h,eOe,i),!o&&l&&d(h,uMt,l),h}function pMt(t){var e={};return Bm(t)&&Qa(dT(t)[OJ](/[\r\n]+/),function(i){if(i){var r=i.indexOf(": ");if(r!==-1){var o=dT(i.substring(0,r))[Gce](),l=dT(i.substring(r+1));e[o]=l}else e[dT(i)]=1}}),e}function fde(t,e,i){if(!t[i]&&e&&e[DLe]){var r=e[DLe](i);r&&(t[i]=dT(r))}return t}var gMt="kill-duration",mMt="kill-duration-seconds",fMt="time-delta-millis";function jJ(t,e){var i={};return t[LLe]?i=pMt(t[LLe]()):e&&(i=fde(i,t,fMt),i=fde(i,t,gMt),i=fde(i,t,mMt)),i}var vMt="location",yMt="console",tOe="JSON",SMt="crypto",bMt="msCrypto",TMt="ReactNative",CMt="msie",_Mt="trident/",iOe="XMLHttpRequest",vde=null,nOe=null,Ij=null,yde=null;function aOe(t,e){var i=!1;if(t){try{if(!(i=e in t)){var r=t[oj];r&&(i=e in r)}}catch{}if(!i)try{i=!vd(new t()[e])}catch{}}return i}function GJ(t){return typeof location===YK&&location?location:Su(vMt)}function EMt(){return typeof console!==QK?console:Su(yMt)}function rOe(){return!!(typeof JSON===YK&&JSON||Su(tOe)!==null)}function AMt(){return rOe()?JSON||Su(tOe):null}function IMt(){return Su(SMt)}function wMt(){return Su(bMt)}function oOe(){var t=Kw();return!(!t||!t.product)&&t.product===TMt}function Sde(){var t=Kw();if(t&&(t[Wce]!==nOe||vde===null)){var e=((nOe=t[Wce])||Qc)[Gce]();vde=uT(e,CMt)||uT(e,_Mt)}return vde}function sOe(t){return yde!==null&&t!==!1||(yde=nRt()&&!!Kw().sendBeacon),yde}function lOe(t){var e=!1;try{e=!!Su("fetch");var i=Su("Request");e&&t&&i&&(e=aOe(i,"keepalive"))}catch{}return e}function kMt(){return Ij===null&&(Ij=typeof XDomainRequest!==QK)&&cOe()&&(Ij=Ij&&!aOe(Su(iOe),"withCredentials")),Ij}function cOe(){var t=!1;try{t=!!Su(iOe)}catch{}return t}var dOe=4294967296,tB=4294967295,uOe=123456789,hOe=987654321,pOe=!1,qJ=uOe,WJ=hOe;function RMt(t){t<0&&(t>>>=0),qJ=uOe+t&tB,WJ=hOe-t&tB,pOe=!0}function MMt(){try{var t=2147483647&XS();RMt((Math.random()*dOe^t)+t)}catch{}}function wj(t){var e=0,i=IMt()||wMt();return i&&i.getRandomValues&&(e=i.getRandomValues(new Uint32Array(1))[0]&tB),e===0&&Sde()&&(pOe||MMt(),e=PMt()&tB),e===0&&(e=Math.floor(dOe*Math.random()|0)),t||(e>>>=0),e}function PMt(t){var e=((WJ=36969*(65535&WJ)+(WJ>>16)&tB)<<16)+(65535&(qJ=18e3*(65535&qJ)+(qJ>>16)&tB))>>>0&tB;return e>>>=0,e}function bde(t){t===void 0&&(t=22);for(var e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",i=wj()>>>0,r=0,o=Qc;o[el]<t;)r++,o+=e.charAt(63&i),i>>>=6,r===5&&(i=(wj()<<2&4294967295|3&i)>>>0,r=0);return o}var gOe="3.3.2",DMt="."+bde(6),LMt=0;function mOe(t){return t[Kce]===1||t[Kce]===9||!+t[Kce]}function OMt(t,e){var i=e[t.id];if(!i){i={};try{mOe(e)&&Jc(e,t.id,{e:!1,v:i})}catch{}}return i}function a3(t,e){return e===void 0&&(e=!1),gde(t+LMt+++(e?"."+gOe:Qc)+DMt)}function fOe(t){var e={id:a3("_aiData-"+(t||Qc)+"."+gOe),accept:function(i){return mOe(i)},get:function(i,r,o,l){var d=i[e.id];return d?d[gde(r)]:(l&&((d=OMt(e,i))[gde(r)]=o),o)},kill:function(i,r){if(i&&i[r])try{delete i[r]}catch{}}};return e}function KJ(t){return t&&jx(t)&&(t.isVal||t.fb||jM(t,"v")||jM(t,"mrg")||jM(t,"ref")||t.set)}function vOe(t,e,i){var r,o=i.dfVal||nJ;if(e&&i.fb){var l=i.fb;ds(l)||(l=[l]);for(var d=0;d<l[el];d++){var h=l[d],p=e[h];if(o(p)?r=p:t&&(o(p=t.cfg[h])&&(r=p),t.set(t.cfg,kE(h),p)),o(r))break}}return!o(r)&&o(i.v)&&(r=i.v),r}function Tde(t,e,i){var r,o=i;return i&&KJ(i)&&(o=vOe(t,e,i)),o&&(KJ(o)&&(o=Tde(t,e,o)),ds(o)?(r=[])[el]=o[el]:Fv(o)&&(r={}),r&&(nc(o,function(l,d){d&&KJ(d)&&(d=Tde(t,e,d)),r[l]=d}),o=r)),o}function Cde(t,e,i,r){var o,l,d,h,p,g,f,y,T=r;KJ(T)?(o=T.isVal,l=T.set,g=T[EJ],f=T[_J],h=T.mrg,!(p=T.ref)&&vd(p)&&(p=!!h),d=vOe(t,e,T)):d=r,f&&t[_J](e,i);var C=!0,E=e[i];!E&&pc(E)||(y=E,C=!1,o&&y!==d&&!o(y)&&(y=d,C=!0),l&&(C=(y=l(y,d,e))===d)),C?y=d&&Tde(t,e,d):(Fv(y)||ds(d))&&h&&d&&(Fv(d)||ds(d))&&nc(d,function(I,w){Cde(t,y,I,w)}),t.set(e,i,y),p&&t.ref(e,i),g&&t[EJ](e,i)}var aO=U5("[[ai_dynCfg_1]]"),yOe=U5("[[ai_blkDynCfg_1]]"),NMt=U5("[[ai_frcDynCfg_1]]");function SOe(t){var e;return t&&(ds(t)?(e=[])[el]=t[el]:Fv(t)&&(e={}),e)?(nc(t,function(i,r){e[i]=SOe(r)}),e):t}function xMt(t){if(t){var e=t[aO]||t;if(e.cfg&&(e.cfg===t||e.cfg[aO]===e))return e}return null}function BMt(t){if(t&&(Fv(t)||ds(t)))try{t[yOe]=!0}catch{}return t}function _de(t,e,i){var r=!1;return i&&!t[e.blkVal]&&((r=i[NMt])||i[yOe]||(r=Fv(i)||ds(i))),r}function bOe(t){PC("InvalidAccess:"+t)}var FMt=["push","pop","shift","unshift","splice"],kj=function(t,e,i,r){t&&t[gj](3,108,"".concat(i," [").concat(e,"] failed - ")+Ws(r))};function UMt(t,e,i){ds(e)&&Qa(FMt,function(r){var o=e[r];e[r]=function(){for(var l=[],d=0;d<arguments.length;d++)l[d]=arguments[d];var h=o[wJ](this,l);return QJ(t,e,i,"Patching"),h}})}function JJ(t,e){var i=aJ(t,e);return i&&i.get}function zMt(t,e,i,r){var o={n:i,h:[],trk:function(g){g&&g.fn&&(Bv(o.h,g)===-1&&o.h[yd](g),t.trk(g,o))},clr:function(g){var f=Bv(o.h,g);f!==-1&&o.h[mj](f,1)}},l=!0,d=!1;function h(){l&&(d=d||_de(h,t,r),r&&!r[aO]&&d&&(r=QJ(t,r,i,"Converting")),l=!1);var g=t.act;return g&&o.trk(g),r}function p(g){if(r!==g){h[t.ro]&&!t.upd&&bOe("["+i+"] is read-only:"+Ws(e)),l&&(d=d||_de(h,t,r),l=!1);var f=d&&h[t.rf];if(d)if(f){nc(r,function(T){r[T]=g?g[T]:ek});try{nc(g,function(T,C){YJ(t,r,T,C)}),g=r}catch(T){kj((t.hdlr||{})[lg],i,"Assigning",T),d=!1}}else r&&r[aO]&&nc(r,function(T){var C=JJ(r,T);if(C){var E=C[t.prop];E&&E.chng()}});if(g!==r){var y=g&&_de(h,t,g);!f&&y&&(g=QJ(t,g,i,"Converting")),r=g,d=y}t.add(o)}}h[t.prop]={chng:function(){t.add(o)}},Jc(e,o.n,{g:h,s:p})}function YJ(t,e,i,r){if(e){var o=JJ(e,i);o&&o[t.prop]?e[i]=r:zMt(t,e,i,r)}return e}function Ede(t,e,i,r){if(e){var o=JJ(e,i),l=o&&!!o[t.prop],d=r&&r[0],h=r&&r[1],p=r&&r[2];if(!l){if(p)try{BMt(e)}catch(g){kj((t.hdlr||{})[lg],i,"Blocking",g)}try{YJ(t,e,i,e[i]),o=JJ(e,i)}catch(g){kj((t.hdlr||{})[lg],i,"State",g)}}d&&(o[t.rf]=d),h&&(o[t.ro]=h),p&&(o[t.blkVal]=!0)}return e}function QJ(t,e,i,r){try{nc(e,function(o,l){YJ(t,e,o,l)}),e[aO]||(wE(e,aO,{get:function(){return t[ELe]}}),UMt(t,e,i))}catch(o){kj((t.hdlr||{})[lg],i,r,o)}return e}var Rj="[[ai_",Mj="]]";function VMt(t){var e,i,r=Jw(Rj+"get"+t.uid+Mj),o=Jw(Rj+"ro"+t.uid+Mj),l=Jw(Rj+"rf"+t.uid+Mj),d=Jw(Rj+"blkVal"+t.uid+Mj),h=Jw(Rj+"dtl"+t.uid+Mj),p=null,g=null;function f(E,I){var w=i.act;try{i.act=E,E&&E[h]&&(Qa(E[h],function(F){F.clr(E)}),E[h]=[]),I({cfg:t.cfg,set:t.set.bind(t),setDf:t[G5].bind(t),ref:t.ref.bind(t),rdOnly:t[EJ].bind(t)})}catch(F){var D=t[lg];throw D&&D[gj](1,107,Ws(F)),F}finally{i.act=w||null}}function y(){if(p){var E=p;p=null,g&&g[q5](),g=null;var I=[];if(Qa(E,function(w){if(w&&(w[h]&&(Qa(w[h],function(D){D.clr(w)}),w[h]=null),w.fn))try{f(w,w.fn)}catch(D){I[yd](D)}}),p)try{y()}catch(w){I[yd](w)}I[el]>0&&BRt("Watcher error(s): ",I)}}function T(E){if(E&&E.h[el]>0){p||(p=[]),g||(g=Yw(function(){g=null,y()},0));for(var I=0;I<E.h[el];I++){var w=E.h[I];w&&Bv(p,w)===-1&&p[yd](w)}}}function C(E,I){if(E){var w=E[h]=E[h]||[];Bv(w,I)===-1&&w[yd](I)}}return(e={prop:r,ro:o,rf:l})[_J]=d,e[ELe]=t,e.add=T,e[AJ]=y,e.use=f,e.trk=C,i=e}function $Mt(t,e){var i={fn:e,rm:function(){i.fn=null,t=null,e=null}};return Jc(i,"toJSON",{v:function(){return"WatcherHandler"+(i.fn?"":"[X]")}}),t.use(i,e),i}function HMt(t,e,i){var r,o=xMt(e);if(o)return o;var l,d=a3("dyncfg",!0),h=e&&i!==!1?e:SOe(e);function p(){l[AJ]()}function g(D,F,x){try{D=YJ(l,D,F,x)}catch(B){kj(t,F,"Setting value",B)}return D[F]}function f(D){return $Mt(l,D)}function y(D,F){l.use(null,function(x){var B=l.upd;try{vd(F)||(l.upd=F),D(x)}finally{l.upd=B}})}function T(D,F){var x;return Ede(l,D,F,(x={},x[0]=!0,x))[F]}function C(D,F){var x;return Ede(l,D,F,(x={},x[1]=!0,x))[F]}function E(D,F){var x;return Ede(l,D,F,(x={},x[2]=!0,x))[F]}function I(D,F){return F&&nc(F,function(x,B){Cde(w,D,x,B)}),D}var w=((r={uid:null,cfg:h})[lg]=t,r[AJ]=p,r.set=g,r[G5]=I,r[tO]=f,r.ref=T,r[EJ]=C,r[_J]=E,r._block=y,r);return Jc(w,"uid",{c:!1,e:!1,w:!1,v:d}),QJ(l=VMt(w),h,"config","Creating"),w}function jMt(t,e){t?(t[IJ](e),t[gj](2,108,e)):bOe(e)}function ME(t,e,i,r){var o=HMt(i,t||{},r);return e&&o[G5](o.cfg,e),o}function jy(t,e,i){var r=t[aO]||t;return!r.cfg||r.cfg!==t&&r.cfg[aO]!==r?(jMt(i,nMt+Ws(t)),ME(t,null,i)[tO](e)):r[tO](e)}function Pj(t,e){if(t&&t[nO])return t[nO](e)}function TOe(t,e,i){var r;return i||(r=ZM(function(o){i=o})),t&&qM(t)>0?DC(Pj(t[0],e),function(){TOe(V5(t,1),e,i)}):i(),r}var GMt=500,COe="Microsoft_ApplicationInsights_BypassAjaxInstrumentation";function qMt(t){return{mrg:!0,v:t}}var ZJ,Dj,Ade=[UJ,Aj,zJ,eB],XJ=null;function WMt(t,e){return function(){var i=arguments,r=_Oe(e);if(r){var o=r.listener;o&&o[t]&&o[t][wJ](o,i)}}}function KMt(){var t=Su("Microsoft");return t&&(XJ=t.ApplicationInsights),XJ}function _Oe(t){var e=XJ;return e||t.disableDbgExt===!0||(e=XJ||KMt()),e?e.ChromeDbgExt:null}function JMt(t){if(!ZJ){ZJ={};for(var e=0;e<Ade[el];e++)ZJ[Ade[e]]=WMt(Ade[e],t)}return ZJ}var EOe="warnToConsole",YMt="AI (Internal): ",QMt="AI: ",ZMt="AITR_",XMt={loggingLevelConsole:0,loggingLevelTelemetry:1,maxMessageLimit:25,enableDebug:!1},ePt=((Dj={})[0]=null,Dj[1]="errorToConsole",Dj[2]=EOe,Dj[3]="debugToConsole",Dj);function AOe(t){return t?'"'+t[Qx](/\"/g,Qc)+'"':Qc}function Ide(t,e){var i=EMt();if(i){var r="log";i[t]&&(r=t),Ul(i[r])&&i[r](e)}}var wde=function(){function t(e,i,r,o){r===void 0&&(r=!1);var l=this;l[DJ]=e,l[Yx]=(r?QMt:YMt)+e;var d=Qc;rOe()&&(d=AMt().stringify(o));var h=(i?" message:"+AOe(i):Qc)+(o?" props:"+AOe(d):Qc);l[Yx]+=h}return t.dataType="MessageData",t}();function kde(t,e){return(t||{})[lg]||new eY(e)}var IOe,iB,eY=function(){function t(e){this.identifier="DiagnosticLogger",this.queue=[];var i,r,o,l,d,h=0,p={};Yc(t,this,function(g){function f(E,I){if(!T()){var w=!0,D=ZMt+I[DJ];if(p[D]?w=!1:p[D]=!0,w&&(E<=r&&(g.queue[yd](I),h++,C(E===1?"error":"warn",I)),h===o)){var F="Internal events throttle limit per PageView reached for this app.",x=new wde(23,F,!1);g.queue[yd](x),E===1?g.errorToConsole(F):g[IJ](F)}}}function y(E){return jy(ME(E,XMt,g).cfg,function(I){var w=I.cfg;i=w[MLe],r=w.loggingLevelTelemetry,o=w.maxMessageLimit,l=w.enableDebug})}function T(){return h>=o}function C(E,I){var w=_Oe(e||{});w&&w[JM]&&w[JM](E,I)}d=y(e||{}),g.consoleLoggingLevel=function(){return i},g[gj]=function(E,I,w,D,F){F===void 0&&(F=!1);var x=new wde(I,w,F,D);if(l)throw Ws(x);var B=ePt[E]||EOe;if(vd(x[Yx]))C("throw"+(E===1?"Critical":"Warning"),x);else{if(F){var L=+x[DJ];!p[L]&&i>=E&&(g[B](x[Yx]),p[L]=!0)}else i>=E&&g[B](x[Yx]);f(E,x)}},g.debugToConsole=function(E){Ide("debug",E),C("warning",E)},g[IJ]=function(E){Ide("warn",E),C("warning",E)},g.errorToConsole=function(E){Ide("error",E),C("error",E)},g.resetInternalMessageCount=function(){h=0,p={}},g[xRt]=f,g[nO]=function(E){d&&d.rm(),d=null}})}return t.__ieDyn=1,t}();function wOe(t){return t||new eY}function xu(t,e,i,r,o,l){l===void 0&&(l=!1),wOe(t)[gj](e,i,r,o,l)}function Lj(t,e){wOe(t)[IJ](e)}var ik,kOe="toGMTString",ROe="toUTCString",Rde="cookie",Mde="expires",MOe="isCookieUseDisabled",Pde="disableCookiesUsage",r3="_ckMgr",tY=null,Dde=null,POe=null,DOe={},iY={},tPt=((IOe={cookieCfg:qMt((iB={},iB[hde]={fb:"cookieDomain",dfVal:$J},iB.path={fb:"cookiePath",dfVal:$J},iB.enabled=ek,iB.ignoreCookies=ek,iB.blockedCookies=ek,iB)),cookieDomain:ek,cookiePath:ek})[Pde]=ek,IOe);function Lde(){!ik&&(ik=tRt(function(){return GM()}))}function iPt(t,e){var i=aY[r3]||iY[r3];return i||(i=aY[r3]=aY(t,e),iY[r3]=i),i}function nY(t){return!t||t.isEnabled()}function LOe(t,e){return!!(e&&t&&ds(t.ignoreCookies))&&Bv(t.ignoreCookies,e)!==-1}function nPt(t,e){return!!(e&&t&&ds(t.blockedCookies)&&Bv(t.blockedCookies,e)!==-1)||LOe(t,e)}function OOe(t,e){var i=e[K5];if(pc(i)){var r=void 0;vd(t[MOe])||(r=!t[MOe]),vd(t[Pde])||(r=!t[Pde]),i=r}return i}function NOe(t,e){var i;return t&&(i=t.getCookieMgr()),i||(i=iPt(e,(t||{})[lg])),i}function aY(t,e){var i,r,o,l,d,h,p,g,f;t=ME(t||iY,null,e).cfg,d=jy(t,function(T){T[G5](T.cfg,tPt),r=T.ref(T.cfg,"cookieCfg"),o=r[pde]||"/",l=r[hde],h=OOe(t,r)!==!1,p=r.getCookie||aPt,g=r.setCookie||zOe,f=r.delCookie||zOe},e);var y=((i={isEnabled:function(){var T=OOe(t,r)!==!1&&h&&xOe(e),C=iY[r3];return T&&C&&y!==C&&(T=nY(C)),T},setEnabled:function(T){h=T!==!1,r[K5]=T},set:function(T,C,E,I,w){var D=!1;if(nY(y)&&!nPt(r,T)){var F={},x=dT(C||Qc),B=$5(x,";");if(B!==-1&&(x=dT(lJ(C,B)),F=BOe(ZS(C,B+1))),t3(F,hde,I||l,JDe,vd),!pc(E)){var L=Sde();if(vd(F[Mde])){var z=XS()+1e3*E;if(z>0){var H=new Date;H.setTime(z),t3(F,Mde,FOe(H,L?kOe:ROe)||FOe(H,L?kOe:ROe)||Qc,JDe)}}L||t3(F,"max-age",Qc+E,null,vd)}var j=GJ();j&&j[PLe]==="https:"&&(t3(F,"secure",null,null,vd),Dde===null&&(Dde=!rPt((Kw()||{})[Wce])),Dde&&t3(F,"SameSite","None",null,vd)),t3(F,pde,w||o,null,vd),g(T,UOe(x,F)),D=!0}return D},get:function(T){var C=Qc;return nY(y)&&!LOe(r,T)&&(C=p(T)),C},del:function(T,C){var E=!1;return nY(y)&&(E=y.purge(T,C)),E},purge:function(T,C){var E,I=!1;if(xOe(e)){var w=((E={})[pde]=C||"/",E[Mde]="Thu, 01 Jan 1970 00:00:01 GMT",E);Sde()||(w["max-age"]="0"),f(T,UOe(Qc,w)),I=!0}return I}})[nO]=function(T){d&&d.rm(),d=null},i);return y[r3]=y,y}function xOe(t){if(tY===null){tY=!1,!ik&&Lde();try{var e=ik.v||{};tY=e[Rde]!==void 0}catch(i){xu(t,2,68,"Cannot access document.cookie - "+YLe(i),{exception:Ws(i)})}}return tY}function BOe(t){var e={};return t&&t[el]&&Qa(dT(t)[OJ](";"),function(i){if(i=dT(i||Qc)){var r=$5(i,"=");r===-1?e[i]=null:e[dT(lJ(i,r))]=dT(ZS(i,r+1))}}),e}function FOe(t,e){return Ul(t[e])?t[e]():null}function UOe(t,e){var i=t||Qc;return nc(e,function(r,o){i+="; "+r+(pc(o)?Qc:"="+o)}),i}function aPt(t){var e=Qc;if(!ik&&Lde(),ik.v){var i=ik.v[Rde]||Qc;POe!==i&&(DOe=BOe(i),POe=i),e=dT(DOe[t]||Qc)}return e}function zOe(t,e){!ik&&Lde(),ik.v&&(ik.v[Rde]=t+"="+e)}function rPt(t){return!!Bm(t)&&(!(!uT(t,"CPU iPhone OS 12")&&!uT(t,"iPad; CPU OS 12"))||!!(uT(t,"Macintosh; Intel Mac OS X 10_14")&&uT(t,"Version/")&&uT(t,"Safari"))||!(!uT(t,"Macintosh; Intel Mac OS X 10_14")||!TRt(t,"AppleWebKit/605.1.15 (KHTML, like Gecko)"))||!(!uT(t,"Chrome/5")&&!uT(t,"Chrome/6"))||!(!uT(t,"UnrealEngine")||uT(t,"Chrome"))||!(!uT(t,"UCBrowser/12")&&!uT(t,"UCBrowser/11")))}var oPt={perfEvtsSendAll:!1};function sPt(t){t.h=null;var e=t.cb;t.cb=[],Qa(e,function(i){xv(i.fn,[i.arg])})}function rO(t,e,i,r){Qa(t,function(o){o&&o[e]&&(i?(i.cb[yd]({fn:r,arg:o}),i.h=i.h||Yw(sPt,0,i)):xv(r,[o]))})}var lPt=function(){function t(e){var i,r;this.listeners=[];var o=[],l={h:null,cb:[]},d=ME(e,oPt);r=d[tO](function(h){i=!!h.cfg.perfEvtsSendAll}),Yc(t,this,function(h){Jc(h,"listeners",{g:function(){return o}}),h[RJ]=function(p){o[yd](p)},h[kJ]=function(p){for(var g=Bv(o,p);g>-1;)o[mj](g,1),g=Bv(o,p)},h[UJ]=function(p){rO(o,UJ,l,function(g){g[UJ](p)})},h[Aj]=function(p,g){rO(o,Aj,l,function(f){f[Aj](p,g)})},h[zJ]=function(p,g){rO(o,zJ,g?l:null,function(f){f[zJ](p,g)})},h[eB]=function(p){p&&(!i&&p[Yce]()||rO(o,eB,null,function(g){p[J5]?Yw(function(){return g[eB](p)},0):g[eB](p)}))},h[cde]=function(p){p&&p[el]&&rO(o,cde,l,function(g){g[cde](p)})},h[dde]=function(p){p&&p[Y5]&&rO(o,dde,l,function(g){g[dde](p)})},h[ude]=function(p,g){if(p>0){var f=g||0;rO(o,ude,l,function(y){y[ude](p,f)})}},h[nO]=function(p){var g,f=function(){r&&r.rm(),r=null,o=[],l.h&&l.h[q5](),l.h=null,l.cb=[]};if(rO(o,"unload",null,function(y){var T=y[nO](p);T&&(g||(g=[]),g[yd](T))}),g)return ZM(function(y){return DC(ZRt(g),function(){f(),y()})});f()}})}return t.__ieDyn=1,t}(),o3="ctx",Ode="ParentContextKey",Oj="ChildrenContextKey",cPt=null,rY=function(){function t(e,i,r){var o,l=this;l.start=XS(),l[Kx]=e,l[J5]=r,l[Yce]=function(){return!1},Ul(i)&&Jc(l,"payload",{g:function(){return!o&&Ul(i)&&(o=i(),i=null),o}}),l[Q5]=function(d){return d?d===t[Ode]||d===t[Oj]?l[d]:(l[o3]||{})[d]:null},l[Xw]=function(d,h){d&&(d===t[Ode]?(l[d]||(l[Yce]=function(){return!0}),l[d]=h):d===t[Oj]?l[d]=h:(l[o3]=l[o3]||{})[d]=h)},l[Qce]=function(){var d=0,h=l[Q5](t[Oj]);if(ds(h))for(var p=0;p<h[el];p++){var g=h[p];g&&(d+=g[W5])}l[W5]=XS()-l.start,l.exTime=l[W5]-d,l[Qce]=function(){}}}return t.ParentContextKey="parent",t.ChildrenContextKey="childEvts",t}(),dPt=function(){function t(e){this.ctx={},Yc(t,this,function(i){i.create=function(r,o,l){return new rY(r,o,l)},i.fire=function(r){r&&(r[Qce](),e&&Ul(e[eB])&&e[eB](r))},i[Xw]=function(r,o){r&&((i[o3]=i[o3]||{})[r]=o)},i[Q5]=function(r){return(i[o3]||{})[r]}})}return t.__ieDyn=1,t}(),Nde="CoreUtils.doPerf";function LC(t,e,i,r,o){if(t){var l=t;if(l[VJ]&&(l=l[VJ]()),l){var d=void 0,h=l[Q5](Nde);try{if(d=l.create(e(),r,o)){if(h&&d[Xw]&&(d[Xw](rY[Ode],h),h[Q5]&&h[Xw])){var p=h[Q5](rY[Oj]);p||(p=[],h[Xw](rY[Oj],p)),p[yd](d)}return l[Xw](Nde,d),i(d)}}catch(g){d&&d[Xw]&&d[Xw]("exception",g)}finally{d&&l.fire(d),l[Xw](Nde,h)}}}return i()}function uPt(){return cPt}function VOe(){var t=xde();return ZS(t,0,8)+"-"+ZS(t,8,12)+"-"+ZS(t,12,16)+"-"+ZS(t,16,20)+"-"+ZS(t,20)}function xde(){for(var t,e=["0","1","2","3","4","5","6","7","8","9","a","b","c","d","e","f"],i=Qc,r=0;r<4;r++)i+=e[15&(t=wj())]+e[t>>4&15]+e[t>>8&15]+e[t>>12&15]+e[t>>16&15]+e[t>>20&15]+e[t>>24&15]+e[t>>28&15];var o=e[8+(3&wj())|0];return kA(i,0,8)+kA(i,9,4)+"4"+kA(i,13,3)+o+kA(i,16,3)+kA(i,19,12)}var hPt="00000000000000000000000000000000",pPt="0000000000000000";function $Oe(t,e,i){return!(!t||t[el]!==e||t===i)&&!!t.match(/^[\da-f]*$/i)}function HOe(t){return $Oe(t,32,hPt)}function jOe(t){return $Oe(t,16,pPt)}var gPt=fOe("plugin");function nB(t){return gPt.get(t,"state",{},!0)}function GOe(t,e){for(var i,r=[],o=null,l=t[Zw]();l;){var d=l[yj]();if(d){o&&o[Tj]&&d[tk]&&o[Tj](d);var h=!!(i=nB(d))[Qw];d[Qw]&&(h=d[Qw]()),h||r[yd](d),o=d,l=l[Zw]()}}Qa(r,function(p){var g=t[Fm]();p[fj](t.getCfg(),g,e,t[Zw]()),i=nB(p),p[Fm]||i[Fm]||(i[Fm]=g),i[Qw]=!0,delete i[KM]})}function Bde(t){return t.sort(function(e,i){var r=0;if(i){var o=i[tk];e[tk]?r=o?e[FJ]-i[FJ]:1:o&&(r=-1)}else r=e?1:-1;return r})}function mPt(t){var e={};return{getName:function(){return e[Kx]},setName:function(i){e[Kx]=i},getTraceId:function(){return e[xLe]},setTraceId:function(i){HOe(i)&&(e[xLe]=i)},getSpanId:function(){return e[BLe]},setSpanId:function(i){jOe(i)&&(e[BLe]=i)},getTraceFlags:function(){return e[FLe]},setTraceFlags:function(i){e[FLe]=i}}}var qOe,fPt="TelemetryPluginChain",WOe="_hasRun",KOe="_getTelCtx",JOe=0;function vPt(t,e,i){for(;t;){if(t[yj]()===i)return t;t=t[Zw]()}return rB([i],e.config||{},e)}function Fde(t,e,i,r){var o=null,l=[];e||(e=ME({},null,i[lg])),r!==null&&(o=r?vPt(t,i,r):t);var d={_next:p,ctx:{core:function(){return i},diagLog:function(){return kde(i,e.cfg)},getCfg:function(){return e.cfg},getExtCfg:f,getConfig:y,hasNext:function(){return!!o},getNext:function(){return o},setNext:function(C){o=C},iterate:T,onComplete:h}};function h(C,E){for(var I=[],w=2;w<arguments.length;w++)I[w-2]=arguments[w];C&&l[yd]({func:C,self:vd(E)?d.ctx:E,args:I})}function p(){var C=o;if(o=C?C[Zw]():null,!C){var E=l;E&&E[el]>0&&(Qa(E,function(I){try{I.func.call(I.self,I.args)}catch(w){xu(i[lg],2,73,"Unexpected Exception during onComplete - "+Ws(w))}}),l=[])}return C}function g(C,E){var I=null,w=e.cfg;if(w&&C){var D=w[X5];!D&&E&&(D={}),w[X5]=D,(D=e.ref(w,X5))&&(!(I=D[C])&&E&&(I={}),D[C]=I,I=e.ref(D,C))}return I}function f(C,E){var I=g(C,!0);return E&&nc(E,function(w,D){if(pc(I[w])){var F=e.cfg[w];!F&&pc(F)||(I[w]=F)}Cde(e,I,w,D)}),e[G5](I,E)}function y(C,E,I){var w;I===void 0&&(I=!1);var D=g(C,!1),F=e.cfg;return!D||!D[E]&&pc(D[E])?!F[E]&&pc(F[E])||(w=F[E]):w=D[E],w||!pc(w)?w:I}function T(C){for(var E;E=d._next();){var I=E[yj]();I&&C(I)}}return d}function aB(t,e,i,r){var o=ME(e),l=Fde(t,o,i,r),d=l.ctx;function h(g){var f=l._next();return f&&f[tk](g,d),!f}function p(g,f){return g===void 0&&(g=null),ds(g)&&(g=rB(g,o.cfg,i,f)),aB(g||d[Zw](),o.cfg,i,f)}return d[eb]=h,d[Jx]=p,d}function oY(t,e,i){var r=ME(e.config),o=Fde(t,r,e,i),l=o.ctx;function d(p){var g=o._next();return g&&g[nO](l,p),!g}function h(p,g){return p===void 0&&(p=null),ds(p)&&(p=rB(p,r.cfg,e,g)),oY(p||l[Zw](),e,g)}return l[eb]=d,l[Jx]=h,l}function Ude(t,e,i){var r=ME(e.config),o=Fde(t,r,e,i).ctx;function l(h){return o.iterate(function(p){Ul(p[bj])&&p[bj](o,h)})}function d(h,p){return h===void 0&&(h=null),ds(h)&&(h=rB(h,r.cfg,e,p)),Ude(h||o[Zw](),e,p)}return o[eb]=l,o[Jx]=d,o}function rB(t,e,i,r){var o=null,l=!r;if(ds(t)&&t[el]>0){var d=null;Qa(t,function(h){if(l||r!==h||(l=!0),l&&h&&Ul(h[tk])){var p=yPt(h,e,i);o||(o=p),d&&d._setNext(p),d=p}})}return r&&!o?rB([r],e,i):o}function yPt(t,e,i){var r,o=null,l=Ul(t[tk]),d=Ul(t[Tj]),h={getPlugin:function(){return t},getNext:function(){return o},processTelemetry:f,unload:y,update:T,_id:r=t?t[iO]+"-"+t[FJ]+"-"+JOe++:"Unknown-0-"+JOe++,_setNext:function(C){o=C}};function p(){var C;return t&&Ul(t[KOe])&&(C=t[KOe]()),C||(C=aB(h,e,i)),C}function g(C,E,I,w,D){var F=!1,x=t?t[iO]:fPt,B=C[WOe];return B||(B=C[WOe]={}),C.setNext(o),t&&LC(C[Fm](),function(){return x+":"+I},function(){B[r]=!0;try{var L=o?o._id:Qc;L&&(B[L]=!1),F=E(C)}catch(H){var z=!o||B[o._id];z&&(F=!0),o&&z||xu(C[JM](),1,73,"Plugin ["+x+"] failed during "+I+" - "+Ws(H)+", run flags: "+Ws(B))}},w,D),F}function f(C,E){function I(w){if(!t||!l)return!1;var D=nB(t);return!D[KM]&&!D[lde]&&(d&&t[Tj](o),t[tk](C,w),!0)}g(E=E||p(),I,"processTelemetry",function(){return{item:C}},!C.sync)||E[eb](C)}function y(C,E){function I(){var w=!1;if(t){var D=nB(t),F=t[Fm]||D[Fm];!t||F&&F!==C.core()||D[KM]||(D[Fm]=null,D[KM]=!0,D[Qw]=!1,t[KM]&&t[KM](C,E)===!0&&(w=!0))}return w}g(C,I,"unload",function(){},E[J5])||C[eb](E)}function T(C,E){function I(){var w=!1;if(t){var D=nB(t),F=t[Fm]||D[Fm];!t||F&&F!==C.core()||D[KM]||t[bj]&&t[bj](C,E)===!0&&(w=!0)}return w}g(C,I,"update",function(){},!1)||C[eb](E)}return KL(h)}function YOe(){var t=[];function e(r){r&&t[yd](r)}function i(r,o){Qa(t,function(l){try{l(r,o)}catch(d){xu(r[JM](),2,73,"Unexpected error calling unload handler - "+Ws(d))}}),t=[]}return{add:e,run:i}}function QOe(){var t=[];function e(r){var o=t;t=[],Qa(o,function(l){try{(l.rm||l.remove).call(l)}catch(d){xu(r,2,73,"Unloading:"+Ws(d))}})}function i(r){r&&ZL(t,r)}return{run:e,add:i}}var oO="getPlugin",SPt=((qOe={})[X5]={isVal:$J,v:{}},qOe),zde=function(){function t(){var e,i,r,o,l,d=this;function h(f){f===void 0&&(f=null);var y=f;if(!y){var T=i||aB(null,{},d[Fm]);y=r&&r[oO]?T[Jx](null,r[oO]):T[Jx](null,r)}return y}function p(f,y,T){ME(f,SPt,kde(y)),!T&&y&&(T=y[ILe]()[Zw]());var C=r;r&&r[oO]&&(C=r[oO]()),d[Fm]=y,i=aB(T,f,y,C)}function g(){e=!1,d[Fm]=null,i=null,r=null,l=QOe(),o=YOe()}g(),Yc(t,d,function(f){f[fj]=function(y,T,C,E){p(y,T,E),e=!0},f[KM]=function(y,T){var C,E=f[Fm];if(E&&(!y||E===y[Fm]())){var I,w=!1,D=y||oY(null,E,r&&r[oO]?r[oO]():r),F=T||((C={reason:0})[J5]=!1,C);return f[LJ]&&f[LJ](D,F,x)===!0?I=!0:x(),I}function x(){w||(w=!0,o.run(D,T),l.run(D[JM]()),I===!0&&D[eb](F),g())}},f[bj]=function(y,T){var C=f[Fm];if(C&&(!y||C===y[Fm]())){var E,I=!1,w=y||Ude(null,C,r&&r[oO]?r[oO]():r),D=T||{reason:0};return f._doUpdate&&f._doUpdate(w,D,F)===!0?E=!0:F(),E}function F(){I||(I=!0,p(w.getCfg(),w.core(),w[Zw]()))}},HJ(f,"_addUnloadCb",function(){return o},"add"),HJ(f,"_addHook",function(){return l},"add"),Jc(f,"_unloadHooks",{g:function(){return l}})}),d[JM]=function(f){return h(f)[JM]()},d[Qw]=function(){return e},d.setInitialized=function(f){e=f},d[Tj]=function(f){r=f},d[eb]=function(f,y){y?y[eb](f):r&&Ul(r[tk])&&r[tk](f,null)},d._getTelCtx=h}return t.__ieDyn=1,t}();function bPt(t,e,i){var r={id:e,fn:i};return ZL(t,r),{remove:function(){Qa(t,function(o,l){if(o.id===r.id)return t[mj](l,1),-1})}}}function TPt(t,e,i){for(var r=!1,o=t[el],l=0;l<o;++l){var d=t[l];if(d)try{if(d.fn[wJ](null,[e])===!1){r=!0;break}}catch(h){xu(i,2,64,"Telemetry initializer failed: "+YLe(h),{exception:Ws(h)},!0)}}return!r}var oB,CPt=function(t){function e(){var i,r,o=t.call(this)||this;function l(){i=0,r=[]}return o.identifier="TelemetryInitializerPlugin",o.priority=199,l(),Yc(e,o,function(d,h){d.addTelemetryInitializer=function(p){return bPt(r,i++,p)},d[tk]=function(p,g){TPt(r,p,g?g[JM]():d[JM]())&&d[eb](p,g)},d[LJ]=function(){l()}}),o}return uj(e,t),e.__ieDyn=1,e}(zde),ZOe="Plugins must provide initialize method",_Pt="_notificationManager",XOe="SDK is still unloading...",EPt="SDK is not initialized",APt=100,IPt=5e4,Vde=F5(((oB={cookieCfg:{}})[e3]={rdOnly:!0,ref:!0,v:[]},oB[Xx]={rdOnly:!0,ref:!0,v:[]},oB[X5]={ref:!0,v:{}},oB[sde]=ek,oB.loggingLevelConsole=0,oB.diagnosticLogInterval=ek,oB));function wPt(t,e){return new dPt(e)}function kPt(t,e,i){var r,o=[],l=[],d={};return Qa(i,function(h){(pc(h)||pc(h[fj]))&&wA(ZOe);var p=h[FJ],g=h[iO];h&&p&&(pc(d[p])?d[p]=g:Lj(t,"Two extensions have same priority #"+p+" - "+d[p]+", "+g)),!p||p<e?o[yd](h):l[yd](h)}),(r={})[Fm]=o,r[Xx]=l,r}function e1e(t,e){var i=!1;return Qa(e,function(r){if(r===t)return i=!0,-1}),i}function $de(t,e,i,r){i&&nc(i,function(o,l){r&&Fv(l)&&Fv(e[o])&&$de(t,e[o],l,r),r&&Fv(l)&&Fv(e[o])?$de(t,e[o],l,r):t.set(e,o,l)})}function t1e(t,e){var i=null,r=-1;return Qa(t,function(o,l){if(o.w===e)return i=o,r=l,-1}),{i:r,l:i}}function RPt(t,e){var i=t1e(t,e).l;return i||(i={w:e,rm:function(){var r=t1e(t,e);r.i!==-1&&t[mj](r.i,1)}},t[yd](i)),i}function MPt(t,e,i){Qa(e,function(r){var o=jy(t,r.w,i);delete r.w,r.rm=function(){o.rm()}})}function PPt(t,e,i,r){return e.add(t[tO](function(o){var l=o.cfg.disableDbgExt;l===!0&&r&&(i[kJ](r),r=null),i&&!r&&l!==!0&&(r=JMt(o.cfg),i[RJ](r))})),r}function DPt(t){return Jc({rm:function(){t.rm()}},"toJSON",{v:function(){return"aicore::onCfgChange<"+JSON.stringify(t)+">"}})}var LPt=function(){function t(){var e,i,r,o,l,d,h,p,g,f,y,T,C,E,I,w,D,F,x,B,L,z,H,j,J,Z,re,ne,le,he,Me,Le;Yc(t,this,function(pe){function te(){le=!0,pc(L)?(Z=j5[qce],xu(r,1,112,"ikey can't be resolved from promises")):Z=j5.ACTIVE,Se()}function Se(){i&&(pe.releaseQueue(),pe[wLe]())}function ce(it){return he&&he[K5]||Le||(it||r&&r.queue[el]>0)&&(Me||(Me=!0,Zt(e[tO](function(Ke){var ot=Ke.cfg.diagnosticLogInterval;ot&&ot>0||(ot=1e4);var Ht=!1;he&&(Ht=he[K5],he[q5]()),(he=wRt(ct,ot)).unref(),he[K5]=Ht}))),he[K5]=!0),he}function X(){var it={};j=[];var Ke=function(ot){ot&&Qa(ot,function(Ht){if(Ht[iO]&&Ht[RLe]&&!it[Ht.identifier]){var jt=Ht[iO]+"="+Ht[RLe];j[yd](jt),it[Ht.identifier]=Ht}})};Ke(T),y&&Qa(y,function(ot){Ke(ot)}),Ke(f)}function ve(){i=!1,(e=ME({},Vde,pe[lg])).cfg[MLe]=1,Jc(pe,"config",{g:function(){return e.cfg},s:function(Ke){pe.updateCfg(Ke,!1)}}),Jc(pe,"pluginVersionStringArr",{g:function(){return j||X(),j}}),Jc(pe,"pluginVersionString",{g:function(){return J||(j||X(),J=j.join(";")),J||Qc}}),Jc(pe,"logger",{g:function(){return r||(r=new eY(e.cfg),e[lg]=r),r},s:function(Ke){e[lg]=Ke,r!==Ke&&(Pj(r,!1),r=Ke)}}),pe[lg]=new eY(e.cfg),H=[];var it=pe.config[e3]||[];it.splice(0,it[el]),ZL(it,H),E=new CPt,o=[],Pj(l,!1),l=null,d=null,h=null,Pj(p,!1),p=null,g=null,f=[],y=null,T=null,C=!1,I=null,w=a3("AIBaseCore",!0),D=YOe(),B=null,L=null,F=QOe(),z=[],J=null,j=null,Le=!1,he=null,Me=!1,Z=0,re=null,ne=null,le=!1}function Te(){var it=aB(Ge(),e.cfg,pe);return it[PJ](ce),it}function Be(it){var Ke=kPt(pe[lg],GMt,f);g=null,J=null,j=null,T=Bde(ZL(T=(y||[])[0]||[],Ke[Xx]));var ot=ZL(Bde(Ke[Fm]),T);H=KL(ot);var Ht=pe.config[e3]||[];Ht.splice(0,Ht[el]),ZL(Ht,H);var jt=Te();T&&T[el]>0&&GOe(jt[Jx](T),ot),GOe(jt,ot),it&&vt(it)}function qe(it){var Ke=null,ot=null,Ht=[];return Qa(H,function(jt){if(jt[iO]===it&&jt!==E)return ot=jt,-1;jt.getChannel&&Ht[yd](jt)}),!ot&&Ht[el]>0&&Qa(Ht,function(jt){if(!(ot=jt.getChannel(it)))return-1}),ot&&(Ke={plugin:ot,setEnabled:function(jt){nB(ot)[lde]=!jt},isEnabled:function(){var jt=nB(ot);return!jt[KM]&&!jt[lde]},remove:function(jt,Nt){var Vt;jt===void 0&&(jt=!0);var $t=[ot],dt=((Vt={reason:1})[J5]=jt,Vt);tt($t,dt,function(yt){yt&&Be({reason:32,removed:$t}),Nt&&Nt(yt)})}}),Ke}function Ge(){if(!g){var it=(H||[]).slice();Bv(it,E)===-1&&it[yd](E),g=rB(Bde(it),e.cfg,pe)}return g}function tt(it,Ke,ot){if(it&&it[el]>0){var Ht=oY(rB(it,e.cfg,pe),pe);Ht[PJ](function(){var jt=!1,Nt=[];Qa(f,function($t,dt){e1e($t,it)?jt=!0:Nt[yd]($t)}),f=Nt,J=null,j=null;var Vt=[];y&&(Qa(y,function($t,dt){var yt=[];Qa($t,function(kt){e1e(kt,it)?jt=!0:yt[yd](kt)}),Vt[yd](yt)}),y=Vt),ot&&ot(jt),ce()}),Ht[eb](Ke)}else ot(!1)}function ct(){if(r&&r.queue){var it=r.queue.slice(0);r.queue[el]=0,Qa(it,function(Ke){var ot,Ht=((ot={})[Kx]=I||"InternalMessageId: "+Ke[DJ],ot[Sj]=L,ot[W5]=mde(new Date),ot.baseType=wde.dataType,ot.baseData={message:Ke[Yx]},ot);pe.track(Ht)})}}function Mt(it,Ke,ot,Ht){var jt=1,Nt=!1,Vt=null;function $t(){jt--,Nt&&jt===0&&(Vt&&Vt[q5](),Vt=null,Ke&&Ke(Nt),Ke=null)}return Ht=Ht||5e3,T&&T[el]>0&&Te()[Jx](T).iterate(function(dt){if(dt.flush){jt++;var yt=!1;dt.flush(it,function(){yt=!0,$t()},ot)||yt||(it&&Vt==null?Vt=Yw(function(){Vt=null,$t()},Ht):$t())}}),Nt=!0,$t(),!0}function ht(){var it;Zt(e[tO](function(Ke){if(Ke.cfg.enablePerfMgr){var ot=Ke.cfg[sde];it!==ot&&(ot||(ot=wPt),sMt(Ke.cfg,sde,ot),it=ot,h=null),d||h||!Ul(ot)||(h=ot(pe,pe[MJ]()))}else h=null,it=null}))}function vt(it){var Ke=Ude(Ge(),pe);Ke[PJ](ce),pe._updateHook&&pe._updateHook(Ke,it)===!0||Ke[eb](it)}function Pt(it){var Ke=pe[lg];Ke?(xu(Ke,2,73,it),ce()):wA(it)}function ni(it){var Ke=pe[MJ]();Ke&&Ke[Aj]([it],2)}function Zt(it){F.add(it)}ve(),pe._getDbgPlgTargets=function(){return[H,o]},pe[Qw]=function(){return i},pe.activeStatus=function(){return Z},pe._setPendingStatus=function(){Z=3},pe[fj]=function(it,Ke,ot,Ht){C&&wA(XOe),pe[Qw]()&&wA("Core cannot be initialized more than once"),e=ME(it,Vde,ot||pe[lg],!1),it=e.cfg,Zt(e[tO](function(Vt){var $t=Vt.cfg;if(Z!==3){ne=$t.initInMemoMaxSize||APt;var dt=$t[ALe],yt=$t.endpointUrl;if(pc(dt)){L=null,Z=j5[qce];var kt="Please provide instrumentation key";i?(xu(r,1,100,kt),Se()):wA(kt)}else{var je=[];if(WL(dt)?(je[yd](dt),L=null):L=dt,WL(yt)?(je[yd](yt),re=null):re=yt,je[el]){le=!1,Z=3;var Ae=$J($t.initTimeOut)?$t.initTimeOut:IPt,xe=XRt(je);Yw(function(){le||te()},Ae),DC(xe,function(Ye){try{if(le)return;if(!Ye.rejected){var Fe=Ye[vj];if(Fe&&Fe[el]){var St=Fe[0];if(L=St&&St[vj],Fe[el]>1){var Wt=Fe[1];re=Wt&&Wt[vj]}}L&&(it[ALe]=L,it.endpointUrl=re)}te()}catch{le||te()}})}else te();var gt=Vt.ref(Vt.cfg,X5);nc(gt,function(Ye){Vt.ref(gt,Ye)})}}})),x=PPt(e,F,(l=Ht)&&pe[MJ](),x),ht(),pe[lg]=ot;var jt=it[e3];if((f=[])[yd].apply(f,yLe(yLe([],Ke,!1),jt)),y=it[Xx],Be(null),T&&T[el]!==0||wA("No "+Xx+" available"),y&&y[el]>1){var Nt=pe[yj]("TeeChannelController");Nt&&Nt.plugin||xu(r,1,28,"TeeChannel required")}MPt(it,z,r),z=null,i=!0,Z===j5.ACTIVE&&Se()},pe.getChannels=function(){var it=[];return T&&Qa(T,function(Ke){it[yd](Ke)}),KL(it)},pe.track=function(it){LC(pe[VJ](),function(){return"AppInsightsCore:track"},function(){it===null&&(ni(it),wA("Invalid telemetry item")),!it[Kx]&&pc(it[Kx])&&(ni(it),wA("telemetry name required")),it[Sj]=it[Sj]||L,it[W5]=it[W5]||mde(new Date),it.ver=it.ver||"4.0",!C&&pe[Qw]()&&Z===j5.ACTIVE?Te()[eb](it):Z!==j5[qce]&&o[el]<=ne&&o[yd](it)},function(){return{item:it}},!it.sync)},pe[ILe]=Te,pe[MJ]=function(){return l||(l=new lPt(e.cfg),pe[_Pt]=l),l},pe[RJ]=function(it){pe.getNotifyMgr()[RJ](it)},pe[kJ]=function(it){l&&l[kJ](it)},pe.getCookieMgr=function(){return p||(p=aY(e.cfg,pe[lg])),p},pe.setCookieMgr=function(it){p!==it&&(Pj(p,!1),p=it)},pe[VJ]=function(){return d||h||uPt()},pe.setPerfMgr=function(it){d=it},pe.eventCnt=function(){return o[el]},pe.releaseQueue=function(){if(i&&o[el]>0){var it=o;o=[],Z===2?Qa(it,function(Ke){Ke[Sj]=Ke[Sj]||L,Te()[eb](Ke)}):xu(r,2,20,"core init status is not active")}},pe[wLe]=function(it){return I=it||null,Le=!1,he&&he[q5](),ce(!0)},pe[kLe]=function(){Le=!0,he&&he[q5](),ct()},QLe(pe,function(){return E},["addTelemetryInitializer"]),pe[nO]=function(it,Ke,ot){var Ht;it===void 0&&(it=!0),i||wA(EPt),C&&wA(XOe);var jt,Nt=((Ht={reason:50})[J5]=it,Ht.flushComplete=!1,Ht);it&&!Ke&&(jt=ZM(function(dt){Ke=dt}));var Vt=oY(Ge(),pe);function $t(dt){Nt.flushComplete=dt,C=!0,D.run(Vt,Nt),pe[kLe](),Vt[eb](Nt)}return Vt[PJ](function(){F.run(pe[lg]),TOe([p,l,r],it,function(){ve(),Ke&&Ke(Nt)})},pe),ct(),Mt(it,$t,6,ot),jt},pe[yj]=qe,pe.addPlugin=function(it,Ke,ot,Ht){if(!it)return Ht&&Ht(!1),void Pt(ZOe);var jt=qe(it[iO]);if(jt&&!Ke)return Ht&&Ht(!1),void Pt("Plugin ["+it[iO]+"] is already loaded!");var Nt={reason:16};function Vt(dt){f[yd](it),Nt.added=[it],Be(Nt),Ht&&Ht(!0)}if(jt){var $t=[jt.plugin];tt($t,{reason:2,isAsync:!!ot},function(dt){dt?(Nt.removed=$t,Nt.reason|=32,Vt()):Ht&&Ht(!1)})}else Vt()},pe.updateCfg=function(it,Ke){var ot;if(Ke===void 0&&(Ke=!0),pe[Qw]()){ot={reason:1,cfg:e.cfg,oldCfg:mLe({},e.cfg),newConfig:mLe({},it),merge:Ke},it=ot.newConfig;var Ht=e.cfg;it[e3]=Ht[e3],it[Xx]=Ht[Xx]}e._block(function(jt){var Nt=jt.cfg;$de(jt,Nt,it,Ke),Ke||nc(Nt,function(Vt){jM(it,Vt)||jt.set(Nt,Vt,ek)}),jt[G5](Nt,Vde)},!0),e[AJ](),ot&&vt(ot)},pe.evtNamespace=function(){return w},pe.flush=Mt,pe.getTraceCtx=function(it){return B||(B=mPt()),B},pe.setTraceCtx=function(it){B=it||null},pe.addUnloadHook=Zt,HJ(pe,"addUnloadCb",function(){return D},"add"),pe.onCfgChange=function(it){return DPt(i?jy(e.cfg,it,pe[lg]):RPt(z,it))},pe.getWParam=function(){return sLe()||e.cfg.enableWParam?0:-1}})}return t.__ieDyn=1,t}(),nk="",i1e="&NoResponseBody=true",Hde="POST",OPt=function(){function t(){var e,i,r,o,l,d,h,p,g,f,y,T,C,E,I=0;Yc(t,this,function(w,D){var F=!0;function x(he,Me){H(Me,200,{},he)}function B(he,Me){xu(r,2,26,"Failed to send telemetry.",{message:he}),H(Me,400,{})}function L(he){B("No endpoint url is provided for the batch",he)}function z(he,Me){for(var Le,pe=0,te=null,Se=0;te==null&&Se<he[el];)pe=he[Se],g||pe!==1?pe!==2||!lOe(Me)||Me&&T?pe!==3||!sOe()||(Me?y:f)||(te=J):te=re:kMt()?te=ne:cOe()&&(te=Z),Se++;return te?((Le={_transport:pe,_isSync:Me})[OLe]=te,Le):null}function H(he,Me,Le,pe){try{he&&he(Me,Le,pe)}catch{}}function j(he,Me){var Le=Kw(),pe=he[_j];if(!pe)return L(Me),!0;pe=he[_j]+(C?i1e:nk);var te=he[Y5],Se=o?te:new Blob([te],{type:"text/plain;charset=UTF-8"});return Le.sendBeacon(pe,Se)}function J(he,Me,Le){var pe=he[Y5];try{if(pe)if(j(he,Me))x(nk,Me);else{var te=l&&l.beaconOnRetry;te&&Ul(te)?te(he,Me,j):(p&&p[OLe](he,Me,!0),xu(r,2,40,". Failed to send telemetry with Beacon API, retried with normal sender."))}}catch(Se){o&&Lj(r,"Failed to send telemetry using sendBeacon API. Ex:"+Ws(Se)),H(Me,o?0:400,{},nk)}}function Z(he,Me,Le){var pe,te,Se,ce=he[Zce]||{};!Le&&e&&(pe=ZM(function(Be,qe){te=Be,Se=qe})),o&&Le&&he.disableXhrSync&&(Le=!1);var X=he[_j];if(!X)return L(Me),void(te&&te(!1));var ve=hMt(Hde,X,F,!0,Le,he[Z5]);function Te(Be){var qe=l&&l.xhrOnComplete;if(qe&&Ul(qe))qe(Be,Me,he);else{var Ge=n3(Be);H(Me,Be[Cj],jJ(Be,o),Ge)}}return o||ve[NLe]("Content-type","application/json"),Qa(Ww(ce),function(Be){ve[NLe](Be,ce[Be])}),ve.onreadystatechange=function(){o||(Te(ve),ve.readyState===4&&te&&te(!0))},ve.onload=function(){o&&Te(ve)},ve.onerror=function(Be){H(Me,o?ve[Cj]:400,jJ(ve,o),o?nk:ZLe(ve)),Se&&Se(Be)},ve.ontimeout=function(){H(Me,o?ve[Cj]:500,jJ(ve,o),o?nk:ZLe(ve)),te&&te(!1)},ve.send(he[Y5]),pe}function re(he,Me,Le){var pe,te,Se,ce,X=he[_j],ve=he[Y5],Te=o?ve:new Blob([ve],{type:"application/json"}),Be=new Headers,qe=ve[el],Ge=!1,tt=!1,ct=he[Zce]||{},Mt=((pe={method:Hde,body:Te})[COe]=!0,pe);he.headers&&Ww(he.headers)[el]>0&&(Qa(Ww(ct),function(ni){Be.append(ni,ct[ni])}),Mt[Zce]=Be),h?Mt.credentials=h:F&&o&&(Mt.credentials="include"),Le&&(Mt.keepalive=!0,I+=qe,o?he._sendReason===2&&(Ge=!0,C&&(X+=i1e)):Ge=!0);var ht=new Request(X,Mt);try{ht[COe]=!0}catch{}if(!Le&&e&&(te=ZM(function(ni,Zt){Se=ni,ce=Zt})),!X)return L(Me),void(Se&&Se(!1));function vt(ni){H(Me,o?0:400,{},o?nk:ni)}function Pt(ni,Zt,it){var Ke=ni[Cj],ot=l.fetchOnComplete;ot&&Ul(ot)?ot(ni,Me,it||nk,Zt):H(Me,Ke,{},it||nk)}try{DC(fetch(o?X:ht,o?Mt:null),function(ni){if(Le&&(I-=qe,qe=0),!tt)if(tt=!0,ni.rejected)vt(ni.reason&&ni.reason[Yx]),ce&&ce(ni.reason);else{var Zt=ni[vj];try{o||Zt.ok?o&&!Zt.body?(Pt(Zt,null,nk),Se&&Se(!0)):DC(Zt.text(),function(it){Pt(Zt,he,it[vj]),Se&&Se(!0)}):(vt(Zt.statusText),Se&&Se(!1))}catch(it){vt(Ws(it)),ce&&ce(it)}}})}catch(ni){tt||(vt(Ws(ni)),ce&&ce(ni))}return Ge&&!tt&&(tt=!0,H(Me,200,{}),Se&&Se(!0)),o&&!tt&&he[Z5]>0&&E&&E.set(function(){tt||(tt=!0,H(Me,500,{}),Se&&Se(!0))},he[Z5]),te}function ne(he,Me,Le){var pe=QL(),te=new XDomainRequest,Se=he[Y5];te.onload=function(){var Be=n3(te),qe=l&&l.xdrOnComplete;qe&&Ul(qe)?qe(te,Me,he):H(Me,200,{},Be)},te.onerror=function(){H(Me,400,{},o?nk:cMt(te))},te.ontimeout=function(){H(Me,500,{})},te.onprogress=function(){};var ce=pe&&pe.location&&pe.location[PLe]||"",X=he[_j];if(X){if(!o&&X.lastIndexOf(ce,0)!==0){var ve="Cannot send XDomain request. The endpoint URL protocol doesn't match the hosting page protocol.";return xu(r,2,40,". "+ve),void B(ve,Me)}var Te=o?X:X[Qx](/^(https?:)/,"");te.open(Hde,Te),he[Z5]&&(te[Z5]=he[Z5]),te.send(Se),o&&Le?E&&E.set(function(){te.send(Se)},0):te.send(Se)}else L(Me)}function le(){I=0,i=!1,e=!1,r=null,o=null,l=null,d=null,h=null,p=null,g=!1,f=!1,y=!1,T=!1,C=!1,E=null}le(),w[fj]=function(he,Me){r=Me,i&&xu(r,1,28,"Sender is already initialized"),w.SetConfig(he),i=!0},w._getDbgPlgTargets=function(){return[i,o,d,e]},w.SetConfig=function(he){try{if(l=he.senderOnCompleteCallBack||{},d=!!he.disableCredentials,h=he.fetchCredentials,o=!!he.isOneDs,e=!!he.enableSendPromise,g=!!he.disableXhr,f=!!he.disableBeacon,y=!!he.disableBeaconSync,E=he.timeWrapper,C=!!he.addNoResponse,T=!!he.disableFetchKeepAlive,p={sendPOST:Z},o||(F=!1),d){var Me=GJ();Me&&Me.protocol&&Me.protocol[Gce]()==="file:"&&(F=!1)}return!0}catch{}return!1},w.getSyncFetchPayload=function(){return I},w.getSenderInst=function(he,Me){return he&&he[el]?z(he,Me):null},w.getFallbackInst=function(){return p},w[LJ]=function(he,Me){le()}})}return t.__ieDyn=1,t}(),n1e="on",a1e="attachEvent",r1e="addEventListener",o1e="detachEvent",s1e="removeEventListener",jde="events",Nj="visibilitychange",sY="pagehide",l1e="pageshow",c1e="unload",d1e="beforeunload",u1e=a3("aiEvtPageHide"),h1e=a3("aiEvtPageShow"),NPt=/\.[\.]+/g,xPt=/[\.]+$/,BPt=1,lY=fOe("events"),FPt=/^([^.]*)(?:\.(.+)|)/;function p1e(t){return t&&t[Qx]?t[Qx](/^[\s\.]+|(?=[\s\.])[\.\s]+$/g,Qc):t}function Gde(t,e){var i;if(e){var r=Qc;ds(e)?(r=Qc,Qa(e,function(l){(l=p1e(l))&&(l[0]!=="."&&(l="."+l),r+=l)})):r=p1e(e),r&&(r[0]!=="."&&(r="."+r),t=(t||Qc)+r)}var o=FPt.exec(t||Qc)||[];return(i={})[YM]=o[1],i.ns=(o[2]||Qc).replace(NPt,".").replace(xPt,Qc)[OJ](".").sort().join("."),i}function g1e(t,e,i){i===void 0&&(i=!0);var r=lY.get(t,jde,{},i),o=r[e];return o||(o=r[e]=[]),o}function m1e(t,e,i,r){t&&e&&e[YM]&&(t[s1e]?t[s1e](e[YM],i,r):t[o1e]&&t[o1e](n1e+e[YM],i))}function UPt(t,e,i,r){var o=!1;return t&&e&&e[YM]&&i&&(t[r1e]?(t[r1e](e[YM],i,r),o=!0):t[a1e]&&(t[a1e](n1e+e[YM],i),o=!0)),o}function f1e(t,e,i,r){for(var o=e[el];o--;){var l=e[o];l&&(i.ns&&i.ns!==l.evtName.ns||r&&!r(l)||(m1e(t,l.evtName,l[Jce],l.capture),e[mj](o,1)))}}function zPt(t,e,i){if(e[YM])f1e(t,g1e(t,e[YM]),e,i);else{var r=lY.get(t,jde,{});nc(r,function(o,l){f1e(t,l,e,i)}),Ww(r)[el]===0&&lY.kill(t,jde)}}function xj(t,e){return e?Gde("xx",ds(e)?[t].concat(e):[t,e]).ns[OJ]("."):t}function qde(t,e,i,r,o){var l;o===void 0&&(o=!1);var d=!1;if(t)try{var h=Gde(e,r);if((d=UPt(t,h,i,o))&&lY.accept(t)){var p=((l={guid:BPt++,evtName:h})[Jce]=i,l.capture=o,l);g1e(t,h.type)[yd](p)}}catch{}return d}function Wde(t,e,i,r,o){if(o===void 0&&(o=!1),t)try{var l=Gde(e,r),d=!1;zPt(t,l,function(h){return!((!l.ns||i)&&h[Jce]!==i)&&(d=!0,!0)}),d||m1e(t,l,i,o)}catch{}}function VPt(t,e,i){var r=!1,o=QL();o&&(r=qde(o,t,e,i),r=qde(o.body,t,e,i)||r);var l=GM();return l&&(r=qde(l,t,e,i)||r),r}function $Pt(t,e,i){var r=QL();r&&(Wde(r,t,e,i),Wde(r.body,t,e,i));var o=GM();o&&Wde(o,t,e,i)}function s3(t,e,i,r){var o=!1;return e&&t&&t[el]>0&&Qa(t,function(l){l&&(i&&Bv(i,l)!==-1||(o=VPt(l,e,r)||o))}),o}function HPt(t,e,i,r){var o=!1;return e&&t&&ds(t)&&!(o=s3(t,e,i,r))&&i&&i[el]>0&&(o=s3(t,e,null,r)),o}function Bj(t,e,i){t&&ds(t)&&Qa(t,function(r){r&&$Pt(r,e,i)})}function jPt(t,e,i){return HPt([d1e,c1e,sY],t,e,i)}function GPt(t,e){Bj([d1e,c1e,sY],t,e)}function v1e(t,e,i){function r(d){var h=GM();t&&h&&h.visibilityState==="hidden"&&t(d)}var o=xj(u1e,i),l=s3([sY],t,e,o);return e&&Bv(e,Nj)!==-1||(l=s3([Nj],r,e,o)||l),!l&&e&&(l=v1e(t,null,i)),l}function qPt(t,e){var i=xj(u1e,e);Bj([sY],t,i),Bj([Nj],null,i)}function y1e(t,e,i){function r(d){var h=GM();t&&h&&h.visibilityState==="visible"&&t(d)}var o=xj(h1e,i),l=s3([l1e],t,e,o);return!(l=s3([Nj],r,e,o)||l)&&e&&(l=y1e(t,null,i)),l}function WPt(t,e){var i=xj(h1e,e);Bj([l1e],t,i),Bj([Nj],null,i)}var sO,l3="",KPt="https://browser.events.data.microsoft.com/OneCollector/1.0/",S1e="version",Kde="properties",b1e="initialize",T1e="logger",JPt="indexOf",lO="timings",C1e="pollInternalLogs",PE="value",_1e="kind",Jde="length",Yde="processTelemetryStart",E1e="1DS-Web-JS-4.3.2",A1e=Rkt.hasOwnProperty,YPt=((sO={})[0]=0,sO[2]=6,sO[1]=1,sO[3]=7,sO[4098]=6,sO[4097]=1,sO[4099]=7,sO);function cO(t){return!(t===l3||pc(t))}function QPt(t){if(t){var e=$5(t,"-");if(e>-1)return lJ(t,e)}return l3}function ZPt(t){return!!(t&&HM(t)&&t>=1&&t<=4)}function XPt(t,e,i){if(!e&&!cO(e)||typeof t!="string")return null;var r=typeof e;if(r==="string"||r==="number"||r==="boolean"||ds(e))e={value:e};else if(r!=="object"||A1e.call(e,"value")){if(pc(e[PE])||e[PE]===l3||!Bm(e[PE])&&!HM(e[PE])&&!Gx(e[PE])&&!ds(e[PE]))return null}else e={value:i?JSON.stringify(e):e};if(ds(e[PE])&&!iDt(e[PE]))return null;if(!pc(e[_1e])){if(ds(e[PE])||!eDt(e[_1e]))return null;e[PE]=e[PE].toString()}return e}function I1e(t,e,i){var r=-1;if(!vd(t))if(e>0&&(e===32?r=8192:e<=13&&(r=e<<5)),tDt(i))r===-1&&(r=0),r|=i;else{var o=YPt[Zde(t)]||-1;r!==-1&&o!==-1?r|=o:o===6&&(r=o)}return r}function c3(t,e,i){var r;return i===void 0&&(i=!0),t&&(r=t.get(e),i&&r&&decodeURIComponent&&(r=decodeURIComponent(r))),r||l3}function w1e(t){t===void 0&&(t="D");var e=VOe();return t==="B"?e="{"+e+"}":t==="P"?e="("+e+")":t==="N"&&(e=e.replace(/-/g,l3)),e}function cY(t,e,i,r,o){var l={},d=!1,h=0,p=arguments[Jde],g=arguments;for(Gx(g[0])&&(d=g[0],h++);h<p;h++)nc(g[h],function(f,y){d&&y&&jx(y)?ds(y)?(l[f]=l[f]||[],Qa(y,function(T,C){T&&jx(T)?l[f][C]=cY(!0,l[f][C],T):l[f][C]=T})):l[f]=cY(!0,l[f],y):l[f]=y});return l}var ak=fLe;function eDt(t){return t===0||t>0&&t<=13||t===32}function tDt(t){return t>=0&&t<=9}function iDt(t){return t[Jde]>0}function Qde(t,e){var i=t;i[lO]=i[lO]||{},i[lO][Yde]=i[lO][Yde]||{},i[lO][Yde][e]=ak()}function Zde(t){var e=0;if(t!=null){var i=typeof t;i==="string"?e=1:i==="number"?e=2:i==="boolean"?e=3:i===YK&&(e=4,ds(t)?(e=4096,t[Jde]>0&&(e|=Zde(t[0]))):A1e.call(t,"value")&&(e=8192|Zde(t[PE])))}return e}function nDt(){return!!Su("chrome")}function Fj(t){return t>0}var aDt=F5({endpointUrl:KPt,propertyStorageOverride:{isVal:rDt}});function rDt(t){return!t||t.getProperty&&t.setProperty||wA("Invalid property storage override passed."),!0}var Xde,oDt=function(t){function e(){var i=t.call(this)||this;return Yc(e,i,function(r,o){r[b1e]=function(l,d,h,p){LC(r,function(){return"AppInsightsCore.initialize"},function(){try{o[b1e](ME(l,aDt,h||r[T1e],!1).cfg,d,h,p)}catch(y){var g=r[T1e],f=Ws(y);f[JPt]("channels")!==-1&&(f+=`
 - Channels must be provided through config.channels only!`),xu(g,1,514,"SDK Initialization Failed - no telemetry will be sent: "+f)}},function(){return{config:l,extensions:d,logger:h,notificationManager:p}})},r.track=function(l){LC(r,function(){return"AppInsightsCore.track"},function(){var d=l;if(d){d[lO]=d[lO]||{},d[lO].trackStart=ak(),ZPt(d.latency)||(d.latency=1);var h=d.ext=d.ext||{};h.sdk=h.sdk||{},h.sdk.ver=E1e;var p=d.baseData=d.baseData||{};p[Kde]=p[Kde]||{};var g=p[Kde];g[S1e]=g[S1e]||r.pluginVersionString||l3}o.track(d)},function(){return{item:l}},!l.sync)},r[C1e]=function(l){return o[C1e](l||"InternalLog")}}),i}return uj(e,t),e.__ieDyn=1,e}(LPt),Uj=(eO({NotSet:0,Pii_DistinguishedName:1,Pii_GenericData:2,Pii_IPV4Address:3,Pii_IPv6Address:4,Pii_MailSubject:5,Pii_PhoneNumber:6,Pii_QueryString:7,Pii_SipAddress:8,Pii_SmtpAddress:9,Pii_Identity:10,Pii_Uri:11,Pii_Fqdn:12,Pii_IPV4AddressLegacy:13,Pii_IPv6ScrubLastHextets:14,Pii_DropValue:15,CustomerContent_GenericContent:32}),eO({Normal:1,CostDeferred:2,RealTime:3,Immediate:4})),sDt=(eO({Unspecified:0,String:1,Int32:2,UInt32:3,Int64:4,UInt64:5,Double:6,Bool:7,Guid:8,DateTime:9}),eO({Normal:1,Critical:2}),eO({NONE:0,ERROR:1,WARNING:2,INFORMATION:3}),"toLowerCase"),dY="blkVal",OC="length",uY="rdOnly",eue="notify",k1e="warnToConsole",hY="throwInternal",pY="setDf",tue="watch",XM="logger",R1e="apply",rk="push",lDt="splice",M1e="hdlr",cDt="cancel",dDt="initialize",P1e="identifier",D1e="isInitialized",L1e="getPlugin",uDt="name",iue="time",eP="processNext",hDt="getProcessTelContext",O1e="unload",pDt="loggingLevelConsole",zj="createNew",sB="teardown",nue="messageId",Vj="message",aue="isAsync",lB="diagLog",N1e="_doTeardown",$j="update",cB="getNext",rue="setNextPlugin",x1e="userAgent",oue="nodeType",gY="replace",gDt="logInternalMessage",B1e="isChildEvt",Hj="getCtx",tP="setCtx",F1e="complete";function mDt(t,e){Xde||(Xde=Cce("AggregationError",function(r,o){o[OC]>1&&(r.errors=o[1])}));var i=t;throw Qa(e,function(r,o){i+=`
`.concat(o," > ").concat(Ws(r))}),new Xde(i,e||[])}var fDt=void 0,ok="",NC="core",vDt="disabled",mY="extensionConfig",d3="processTelemetry",yDt="priority",U1e="getPerfMgr",SDt="Not dynamic - ",bDt=/-([a-z])/g,TDt=/([^\w\d_$])/g,CDt=/^(\d+[\w\d_$])/;function _Dt(t){return!pc(t)}function sue(t){var e=t;return e&&Bm(e)&&(e=(e=(e=e[gY](bDt,function(i,r){return r.toUpperCase()}))[gY](TDt,"_"))[gY](CDt,function(i,r){return"_"+r})),e}function z1e(t,e){return!(!t||!e)&&$5(t,e)!==-1}function EDt(t){return t&&t.toISOString()||""}function ADt(t,e){var i=null,r=null;return Ul(t)?i=t:r=t,function(){var o=arguments;if(i&&(r=i()),r)return r[e][R1e](r,o)}}function V1e(t,e,i,r,o){t&&e&&i&&o!==!1&&(t[e]=ADt(i,r))}var IDt="console",$1e="JSON",wDt="crypto",kDt="msCrypto",RDt="msie",MDt="trident/",lue=null,H1e=null;function PDt(){return typeof console!==QK?console:Su(IDt)}function j1e(){return!!(typeof JSON===YK&&JSON||Su($1e)!==null)}function DDt(){return j1e()?JSON||Su($1e):null}function LDt(){return Su(wDt)}function ODt(){return Su(kDt)}function NDt(){var t=Kw();if(t&&(t[x1e]!==H1e||lue===null)){var e=((H1e=t[x1e])||ok)[sDt]();lue=z1e(e,RDt)||z1e(e,MDt)}return lue}var G1e=4294967296,dB=4294967295,q1e=123456789,W1e=987654321,K1e=!1,fY=q1e,vY=W1e;function xDt(t){t<0&&(t>>>=0),fY=q1e+t&dB,vY=W1e-t&dB,K1e=!0}function BDt(){try{var t=2147483647&XS();xDt((Math.random()*G1e^t)+t)}catch{}}function yY(t){var e=0,i=LDt()||ODt();return i&&i.getRandomValues&&(e=i.getRandomValues(new Uint32Array(1))[0]&dB),e===0&&NDt()&&(K1e||BDt(),e=FDt()&dB),e===0&&(e=Math.floor(G1e*Math.random()|0)),e>>>=0,e}function FDt(t){var e=((vY=36969*(65535&vY)+(vY>>16)&dB)<<16)+(65535&(fY=18e3*(65535&fY)+(fY>>16)&dB))>>>0&dB;return e>>>=0,e}function UDt(t){for(var e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",i=yY()>>>0,r=0,o=ok;o[OC]<t;)r++,o+=e.charAt(63&i),i>>>=6,r===5&&(i=(yY()<<2&4294967295|3&i)>>>0,r=0);return o}var J1e="3.3.1",zDt="."+UDt(6),VDt=0;function Y1e(t){return t[oue]===1||t[oue]===9||!+t[oue]}function $Dt(t,e){var i=e[t.id];if(!i){i={};try{Y1e(e)&&Jc(e,t.id,{e:!1,v:i})}catch{}}return i}function Q1e(t,e){return e===void 0&&(e=!1),sue(t+VDt+++(e?"."+J1e:ok)+zDt)}function HDt(t){var e={id:Q1e("_aiData-"+t+"."+J1e),accept:function(i){return Y1e(i)},get:function(i,r,o,l){var d=i[e.id];return d?d[sue(r)]:(l&&((d=$Dt(e,i))[sue(r)]=o),o)},kill:function(i,r){if(i&&i[r])try{delete i[r]}catch{}}};return e}function SY(t){return t&&jx(t)&&(t.isVal||t.fb||jM(t,"v")||jM(t,"mrg")||jM(t,"ref")||t.set)}function Z1e(t,e,i){var r,o=i.dfVal||nJ;if(e&&i.fb){var l=i.fb;ds(l)||(l=[l]);for(var d=0;d<l[OC];d++){var h=l[d],p=e[h];if(o(p)?r=p:t&&(o(p=t.cfg[h])&&(r=p),t.set(t.cfg,kE(h),p)),o(r))break}}return!o(r)&&o(i.v)&&(r=i.v),r}function cue(t,e,i){var r,o=i;return i&&SY(i)&&(o=Z1e(t,e,i)),o&&(SY(o)&&(o=cue(t,e,o)),ds(o)?(r=[])[OC]=o[OC]:Fv(o)&&(r={}),r&&(nc(o,function(l,d){d&&SY(d)&&(d=cue(t,e,d)),r[l]=d}),o=r)),o}function due(t,e,i,r){var o,l,d,h,p,g,f,y,T=r;SY(T)?(o=T.isVal,l=T.set,g=T[uY],f=T[dY],h=T.mrg,!(p=T.ref)&&vd(p)&&(p=!!h),d=Z1e(t,e,T)):d=r,f&&t[dY](e,i);var C=!0,E=e[i];!E&&pc(E)||(y=E,C=!1,o&&y!==d&&!o(y)&&(y=d,C=!0),l&&(C=(y=l(y,d,e))===d)),C?y=d&&cue(t,e,d):(Fv(y)||ds(d))&&h&&d&&(Fv(d)||ds(d))&&nc(d,function(I,w){due(t,y,I,w)}),t.set(e,i,y),p&&t.ref(e,i),g&&t[uY](e,i)}var dO=U5("[[ai_dynCfg_1]]"),X1e=U5("[[ai_blkDynCfg_1]]"),jDt=U5("[[ai_frcDynCfg_1]]");function eNe(t){var e;return t&&(ds(t)?(e=[])[OC]=t[OC]:Fv(t)&&(e={}),e)?(nc(t,function(i,r){e[i]=eNe(r)}),e):t}function GDt(t){if(t){var e=t[dO]||t;if(e.cfg&&(e.cfg===t||e.cfg[dO]===e))return e}return null}function qDt(t){if(t&&(Fv(t)||ds(t)))try{t[X1e]=!0}catch{}return t}function uue(t,e,i){var r=!1;return i&&!t[e.blkVal]&&((r=i[jDt])||i[X1e]||(r=Fv(i)||ds(i))),r}function tNe(t){PC("InvalidAccess:"+t)}var WDt=["push","pop","shift","unshift","splice"],jj=function(t,e,i,r){t&&t[hY](3,108,"".concat(i," [").concat(e,"] failed - ")+Ws(r))};function KDt(t,e,i){ds(e)&&Qa(WDt,function(r){var o=e[r];e[r]=function(){for(var l=[],d=0;d<arguments.length;d++)l[d]=arguments[d];var h=o[R1e](this,l);return CY(t,e,i,"Patching"),h}})}function bY(t,e){var i=aJ(t,e);return i&&i.get}function JDt(t,e,i,r){var o={n:i,h:[],trk:function(g){g&&g.fn&&(Bv(o.h,g)===-1&&o.h[rk](g),t.trk(g,o))},clr:function(g){var f=Bv(o.h,g);f!==-1&&o.h[lDt](f,1)}},l=!0,d=!1;function h(){l&&(d=d||uue(h,t,r),r&&!r[dO]&&d&&(r=CY(t,r,i,"Converting")),l=!1);var g=t.act;return g&&o.trk(g),r}function p(g){if(r!==g){h[t.ro]&&!t.upd&&tNe("["+i+"] is read-only:"+Ws(e)),l&&(d=d||uue(h,t,r),l=!1);var f=d&&h[t.rf];if(d)if(f){nc(r,function(T){r[T]=g?g[T]:fDt});try{nc(g,function(T,C){TY(t,r,T,C)}),g=r}catch(T){jj((t.hdlr||{})[XM],i,"Assigning",T),d=!1}}else r&&r[dO]&&nc(r,function(T){var C=bY(r,T);if(C){var E=C[t.prop];E&&E.chng()}});if(g!==r){var y=g&&uue(h,t,g);!f&&y&&(g=CY(t,g,i,"Converting")),r=g,d=y}t.add(o)}}h[t.prop]={chng:function(){t.add(o)}},Jc(e,o.n,{g:h,s:p})}function TY(t,e,i,r){if(e){var o=bY(e,i);o&&o[t.prop]?e[i]=r:JDt(t,e,i,r)}return e}function hue(t,e,i,r){if(e){var o=bY(e,i),l=o&&!!o[t.prop],d=r&&r[0],h=r&&r[1],p=r&&r[2];if(!l){if(p)try{qDt(e)}catch(g){jj((t.hdlr||{})[XM],i,"Blocking",g)}try{TY(t,e,i,e[i]),o=bY(e,i)}catch(g){jj((t.hdlr||{})[XM],i,"State",g)}}d&&(o[t.rf]=d),h&&(o[t.ro]=h),p&&(o[t.blkVal]=!0)}return e}function CY(t,e,i,r){try{nc(e,function(o,l){TY(t,e,o,l)}),e[dO]||(wE(e,dO,{get:function(){return t[M1e]}}),KDt(t,e,i))}catch(o){jj((t.hdlr||{})[XM],i,r,o)}return e}var Gj="[[ai_",qj="]]";function YDt(t){var e,i,r=Jw(Gj+"get"+t.uid+qj),o=Jw(Gj+"ro"+t.uid+qj),l=Jw(Gj+"rf"+t.uid+qj),d=Jw(Gj+"blkVal"+t.uid+qj),h=Jw(Gj+"dtl"+t.uid+qj),p=null,g=null;function f(E,I){var w=i.act;try{i.act=E,E&&E[h]&&(Qa(E[h],function(F){F.clr(E)}),E[h]=[]),I({cfg:t.cfg,set:t.set.bind(t),setDf:t[pY].bind(t),ref:t.ref.bind(t),rdOnly:t[uY].bind(t)})}catch(F){var D=t[XM];throw D&&D[hY](1,107,Ws(F)),F}finally{i.act=w||null}}function y(){if(p){var E=p;p=null,g&&g[cDt](),g=null;var I=[];if(Qa(E,function(w){if(w&&(w[h]&&(Qa(w[h],function(D){D.clr(w)}),w[h]=null),w.fn))try{f(w,w.fn)}catch(D){I[rk](D)}}),p)try{y()}catch(w){I[rk](w)}I[OC]>0&&mDt("Watcher error(s): ",I)}}function T(E){if(E&&E.h[OC]>0){p||(p=[]),g||(g=Yw(function(){g=null,y()},0));for(var I=0;I<E.h[OC];I++){var w=E.h[I];w&&Bv(p,w)===-1&&p[rk](w)}}}function C(E,I){if(E){var w=E[h]=E[h]||[];Bv(w,I)===-1&&w[rk](I)}}return(e={prop:r,ro:o,rf:l})[dY]=d,e[M1e]=t,e.add=T,e[eue]=y,e.use=f,e.trk=C,i=e}function QDt(t,e){var i={fn:e,rm:function(){i.fn=null,t=null,e=null}};return Jc(i,"toJSON",{v:function(){return"WatcherHandler"+(i.fn?"":"[X]")}}),t.use(i,e),i}function ZDt(t,e,i){var r,o=GDt(e);if(o)return o;var l,d=Q1e("dyncfg",!0),h=e&&i!==!1?e:eNe(e);function p(){l[eue]()}function g(D,F,x){try{D=TY(l,D,F,x)}catch(B){jj(t,F,"Setting value",B)}return D[F]}function f(D){return QDt(l,D)}function y(D,F){l.use(null,function(x){var B=l.upd;try{vd(F)||(l.upd=F),D(x)}finally{l.upd=B}})}function T(D,F){var x;return hue(l,D,F,(x={},x[0]=!0,x))[F]}function C(D,F){var x;return hue(l,D,F,(x={},x[1]=!0,x))[F]}function E(D,F){var x;return hue(l,D,F,(x={},x[2]=!0,x))[F]}function I(D,F){return F&&nc(F,function(x,B){due(w,D,x,B)}),D}var w=((r={uid:null,cfg:h})[XM]=t,r[eue]=p,r.set=g,r[pY]=I,r[tue]=f,r.ref=T,r[uY]=C,r[dY]=E,r._block=y,r);return Jc(w,"uid",{c:!1,e:!1,w:!1,v:d}),CY(l=YDt(w),h,"config","Creating"),w}function XDt(t,e){tNe(e)}function uB(t,e,i,r){var o=ZDt(i,t||{},r);return e&&o[pY](o.cfg,e),o}function _Y(t,e,i){var r=t[dO]||t;return!r.cfg||r.cfg!==t&&r.cfg[dO]!==r?(XDt(i,SDt+Ws(t)),uB(t,null,i)[tue](e)):r[tue](e)}var Wj,EY=null;function eLt(){var t=Su("Microsoft");return t&&(EY=t.ApplicationInsights),EY}function tLt(t){var e=EY;return e||t.disableDbgExt===!0||(e=EY||eLt()),e?e.ChromeDbgExt:null}var iNe="warnToConsole",iLt="AI (Internal): ",nLt="AI: ",aLt="AITR_",rLt={loggingLevelConsole:0,loggingLevelTelemetry:1,maxMessageLimit:25,enableDebug:!1},oLt=((Wj={})[0]=null,Wj[1]="errorToConsole",Wj[2]=iNe,Wj[3]="debugToConsole",Wj);function nNe(t){return t?'"'+t[gY](/\"/g,ok)+'"':ok}function pue(t,e){var i=PDt();if(i){var r="log";i[t]&&(r=t),Ul(i[r])&&i[r](e)}}var aNe=function(){function t(e,i,r,o){r===void 0&&(r=!1);var l=this;l[nue]=e,l[Vj]=(r?nLt:iLt)+e;var d=ok;j1e()&&(d=DDt().stringify(o));var h=(i?" message:"+nNe(i):ok)+(o?" props:"+nNe(d):ok);l[Vj]+=h}return t.dataType="MessageData",t}();function rNe(t,e){return(t||{})[XM]||new oNe(e)}var oNe=function(){function t(e){this.identifier="DiagnosticLogger",this.queue=[];var i,r,o,l,d,h=0,p={};Yc(t,this,function(g){function f(E,I){if(!T()){var w=!0,D=aLt+I[nue];if(p[D]?w=!1:p[D]=!0,w&&(E<=r&&(g.queue[rk](I),h++,C(E===1?"error":"warn",I)),h===o)){var F="Internal events throttle limit per PageView reached for this app.",x=new aNe(23,F,!1);g.queue[rk](x),E===1?g.errorToConsole(F):g[k1e](F)}}}function y(E){return _Y(uB(E,rLt,g).cfg,function(I){var w=I.cfg;i=w[pDt],r=w.loggingLevelTelemetry,o=w.maxMessageLimit,l=w.enableDebug})}function T(){return h>=o}function C(E,I){var w=tLt(e||{});w&&w[lB]&&w[lB](E,I)}d=y(e||{}),g.consoleLoggingLevel=function(){return i},g[hY]=function(E,I,w,D,F){F===void 0&&(F=!1);var x=new aNe(I,w,F,D);if(l)throw Ws(x);var B=oLt[E]||iNe;if(vd(x[Vj]))C("throw"+(E===1?"Critical":"Warning"),x);else{if(F){var L=+x[nue];!p[L]&&i>=E&&(g[B](x[Vj]),p[L]=!0)}else i>=E&&g[B](x[Vj]);f(E,x)}},g.debugToConsole=function(E){pue("debug",E),C("warning",E)},g[k1e]=function(E){pue("warn",E),C("warning",E)},g.errorToConsole=function(E){pue("error",E),C("error",E)},g.resetInternalMessageCount=function(){h=0,p={}},g[gDt]=f,g[O1e]=function(E){d&&d.rm(),d=null}})}return t.__ieDyn=1,t}();function sLt(t){return t||new oNe}function AY(t,e,i,r,o,l){l===void 0&&(l=!1),sLt(t)[hY](e,i,r,o,l)}var gue="ctx",mue="ParentContextKey",Kj="ChildrenContextKey",fue=function(){function t(e,i,r){var o,l=this;l.start=XS(),l[uDt]=e,l[aue]=r,l[B1e]=function(){return!1},Ul(i)&&Jc(l,"payload",{g:function(){return!o&&Ul(i)&&(o=i(),i=null),o}}),l[Hj]=function(d){return d?d===t[mue]||d===t[Kj]?l[d]:(l[gue]||{})[d]:null},l[tP]=function(d,h){d&&(d===t[mue]?(l[d]||(l[B1e]=function(){return!0}),l[d]=h):d===t[Kj]?l[d]=h:(l[gue]=l[gue]||{})[d]=h)},l[F1e]=function(){var d=0,h=l[Hj](t[Kj]);if(ds(h))for(var p=0;p<h[OC];p++){var g=h[p];g&&(d+=g[iue])}l[iue]=XS()-l.start,l.exTime=l[iue]-d,l[F1e]=function(){}}}return t.ParentContextKey="parent",t.ChildrenContextKey="childEvts",t}(),vue="CoreUtils.doPerf";function Jj(t,e,i,r,o){if(t){var l=t;if(l[U1e]&&(l=l[U1e]()),l){var d=void 0,h=l[Hj](vue);try{if(d=l.create(e(),r,o)){if(h&&d[tP]&&(d[tP](fue[mue],h),h[Hj]&&h[tP])){var p=h[Hj](fue[Kj]);p||(p=[],h[tP](fue[Kj],p)),p[rk](d)}return l[tP](vue,d),i(d)}}catch(g){d&&d[tP]&&d[tP]("exception",g)}finally{d&&l.fire(d),l[tP](vue,h)}}}return i()}function Yj(){var t=lLt();return ZS(t,0,8)+"-"+ZS(t,8,12)+"-"+ZS(t,12,16)+"-"+ZS(t,16,20)+"-"+ZS(t,20)}function lLt(){for(var t,e=["0","1","2","3","4","5","6","7","8","9","a","b","c","d","e","f"],i=ok,r=0;r<4;r++)i+=e[15&(t=yY())]+e[t>>4&15]+e[t>>8&15]+e[t>>12&15]+e[t>>16&15]+e[t>>20&15]+e[t>>24&15]+e[t>>28&15];var o=e[8+(3&yY())|0];return kA(i,0,8)+kA(i,9,4)+"4"+kA(i,13,3)+o+kA(i,16,3)+kA(i,19,12)}var cLt=HDt("plugin");function yue(t){return cLt.get(t,"state",{},!0)}var sNe,dLt="TelemetryPluginChain",lNe="_hasRun",cNe="_getTelCtx",dNe=0;function uLt(t,e,i){for(;t;){if(t[L1e]()===i)return t;t=t[cB]()}return Qj([i],e.config||{},e)}function Sue(t,e,i,r){var o=null,l=[];e||(e=uB({},null,i[XM])),r!==null&&(o=r?uLt(t,i,r):t);var d={_next:p,ctx:{core:function(){return i},diagLog:function(){return rNe(i,e.cfg)},getCfg:function(){return e.cfg},getExtCfg:f,getConfig:y,hasNext:function(){return!!o},getNext:function(){return o},setNext:function(C){o=C},iterate:T,onComplete:h}};function h(C,E){for(var I=[],w=2;w<arguments.length;w++)I[w-2]=arguments[w];C&&l[rk]({func:C,self:vd(E)?d.ctx:E,args:I})}function p(){var C=o;if(o=C?C[cB]():null,!C){var E=l;E&&E[OC]>0&&(Qa(E,function(I){try{I.func.call(I.self,I.args)}catch(w){AY(i[XM],2,73,"Unexpected Exception during onComplete - "+Ws(w))}}),l=[])}return C}function g(C,E){var I=null,w=e.cfg;if(w&&C){var D=w[mY];!D&&E&&(D={}),w[mY]=D,(D=e.ref(w,mY))&&(!(I=D[C])&&E&&(I={}),D[C]=I,I=e.ref(D,C))}return I}function f(C,E){var I=g(C,!0);return E&&nc(E,function(w,D){if(pc(I[w])){var F=e.cfg[w];!F&&pc(F)||(I[w]=F)}due(e,I,w,D)}),e[pY](I,E)}function y(C,E,I){var w;I===void 0&&(I=!1);var D=g(C,!1),F=e.cfg;return!D||!D[E]&&pc(D[E])?!F[E]&&pc(F[E])||(w=F[E]):w=D[E],w||!pc(w)?w:I}function T(C){for(var E;E=d._next();){var I=E[L1e]();I&&C(I)}}return d}function u3(t,e,i,r){var o=uB(e),l=Sue(t,o,i,r),d=l.ctx;function h(g){var f=l._next();return f&&f[d3](g,d),!f}function p(g,f){return g===void 0&&(g=null),ds(g)&&(g=Qj(g,o.cfg,i,f)),u3(g||d[cB](),o.cfg,i,f)}return d[eP]=h,d[zj]=p,d}function uNe(t,e,i){var r=uB(e.config),o=Sue(t,r,e,i),l=o.ctx;function d(p){var g=o._next();return g&&g[O1e](l,p),!g}function h(p,g){return p===void 0&&(p=null),ds(p)&&(p=Qj(p,r.cfg,e,g)),uNe(p||l[cB](),e,g)}return l[eP]=d,l[zj]=h,l}function hNe(t,e,i){var r=uB(e.config),o=Sue(t,r,e,i).ctx;function l(h){return o.iterate(function(p){Ul(p[$j])&&p[$j](o,h)})}function d(h,p){return h===void 0&&(h=null),ds(h)&&(h=Qj(h,r.cfg,e,p)),hNe(h||o[cB](),e,p)}return o[eP]=l,o[zj]=d,o}function Qj(t,e,i,r){var o=null,l=!r;if(ds(t)&&t[OC]>0){var d=null;Qa(t,function(h){if(l||r!==h||(l=!0),l&&h&&Ul(h[d3])){var p=hLt(h,e,i);o||(o=p),d&&d._setNext(p),d=p}})}return r&&!o?Qj([r],e,i):o}function hLt(t,e,i){var r,o=null,l=Ul(t[d3]),d=Ul(t[rue]),h={getPlugin:function(){return t},getNext:function(){return o},processTelemetry:f,unload:y,update:T,_id:r=t?t[P1e]+"-"+t[yDt]+"-"+dNe++:"Unknown-0-"+dNe++,_setNext:function(C){o=C}};function p(){var C;return t&&Ul(t[cNe])&&(C=t[cNe]()),C||(C=u3(h,e,i)),C}function g(C,E,I,w,D){var F=!1,x=t?t[P1e]:dLt,B=C[lNe];return B||(B=C[lNe]={}),C.setNext(o),t&&Jj(C[NC](),function(){return x+":"+I},function(){B[r]=!0;try{var L=o?o._id:ok;L&&(B[L]=!1),F=E(C)}catch(H){var z=!o||B[o._id];z&&(F=!0),o&&z||AY(C[lB](),1,73,"Plugin ["+x+"] failed during "+I+" - "+Ws(H)+", run flags: "+Ws(B))}},w,D),F}function f(C,E){function I(w){if(!t||!l)return!1;var D=yue(t);return!D[sB]&&!D[vDt]&&(d&&t[rue](o),t[d3](C,w),!0)}g(E=E||p(),I,"processTelemetry",function(){return{item:C}},!C.sync)||E[eP](C)}function y(C,E){function I(){var w=!1;if(t){var D=yue(t),F=t[NC]||D[NC];!t||F&&F!==C.core()||D[sB]||(D[NC]=null,D[sB]=!0,D[D1e]=!1,t[sB]&&t[sB](C,E)===!0&&(w=!0))}return w}g(C,I,"unload",function(){},E[aue])||C[eP](E)}function T(C,E){function I(){var w=!1;if(t){var D=yue(t),F=t[NC]||D[NC];!t||F&&F!==C.core()||D[sB]||t[$j]&&t[$j](C,E)===!0&&(w=!0)}return w}g(C,I,"update",function(){},!1)||C[eP](E)}return KL(h)}function pLt(){var t=[];function e(r){r&&t[rk](r)}function i(r,o){Qa(t,function(l){try{l(r,o)}catch(d){AY(r[lB](),2,73,"Unexpected error calling unload handler - "+Ws(d))}}),t=[]}return{add:e,run:i}}function gLt(){var t=[];function e(r){var o=t;t=[],Qa(o,function(l){try{(l.rm||l.remove).call(l)}catch(d){AY(r,2,73,"Unloading:"+Ws(d))}})}function i(r){r&&ZL(t,r)}return{run:e,add:i}}var hB,uO="getPlugin",mLt=((sNe={})[mY]={isVal:_Dt,v:{}},sNe),fLt=function(){function t(){var e,i,r,o,l,d=this;function h(f){f===void 0&&(f=null);var y=f;if(!y){var T=i||u3(null,{},d[NC]);y=r&&r[uO]?T[zj](null,r[uO]):T[zj](null,r)}return y}function p(f,y,T){uB(f,mLt,rNe(y)),!T&&y&&(T=y[hDt]()[cB]());var C=r;r&&r[uO]&&(C=r[uO]()),d[NC]=y,i=u3(T,f,y,C)}function g(){e=!1,d[NC]=null,i=null,r=null,l=gLt(),o=pLt()}g(),Yc(t,d,function(f){f[dDt]=function(y,T,C,E){p(y,T,E),e=!0},f[sB]=function(y,T){var C,E=f[NC];if(E&&(!y||E===y[NC]())){var I,w=!1,D=y||uNe(null,E,r&&r[uO]?r[uO]():r),F=T||((C={reason:0})[aue]=!1,C);return f[N1e]&&f[N1e](D,F,x)===!0?I=!0:x(),I}function x(){w||(w=!0,o.run(D,T),l.run(D[lB]()),I===!0&&D[eP](F),g())}},f[$j]=function(y,T){var C=f[NC];if(C&&(!y||C===y[NC]())){var E,I=!1,w=y||hNe(null,C,r&&r[uO]?r[uO]():r),D=T||{reason:0};return f._doUpdate&&f._doUpdate(w,D,F)===!0?E=!0:F(),E}function F(){I||(I=!0,p(w.getCfg(),w.core(),w[cB]()))}},V1e(f,"_addUnloadCb",function(){return o},"add"),V1e(f,"_addHook",function(){return l},"add"),Jc(f,"_unloadHooks",{g:function(){return l}})}),d[lB]=function(f){return h(f)[lB]()},d[D1e]=function(){return e},d.setInitialized=function(f){e=f},d[rue]=function(f){r=f},d[eP]=function(f,y){y?y[eP](f):r&&Ul(r[d3])&&r[d3](f,null)},d._getTelCtx=h}return t.__ieDyn=1,t}(),vLt="",Zj="timings",bue="processTelemetryStart";(hB={})[0]=0,hB[2]=6,hB[1]=1,hB[3]=7,hB[4098]=6,hB[4097]=1,hB[4099]=7;function pB(t){if(t){var e=$5(t,"-");if(e>-1)return lJ(t,e)}return vLt}var gB,yLt=fLe;function SLt(t,e){var i=t;i[Zj]=i[Zj]||{},i[Zj][bue]=i[Zj][bue]||{},i[Zj][bue][e]=yLt()}function pNe(t){return t>0}function IY(t){return HM(t)&&t>=1&&t<=2}(function(t){t[t.LocalStorage=1]="LocalStorage",t[t.SessionStorage=2]="SessionStorage",t[t.IndexedDb=3]="IndexedDb"})(gB||(gB={}));var bLt="readwrite",Tue="result",Xj="DBError: Unable to open database",gNe="Database is not open",TLt="DBError: Failed to Open Cursor",wY="DBError: Failed to delete the database",CLt="DBError: Database does not exist",_Lt="DBError: Database upgrade required",ELt="DBError: Feature not supported",mNe=["indexedDB"],ALt=Ul,ILt=Bm,wLt=0;function kLt(){var t=YL()||{},e=null;if(t)try{for(var i=0;i<mNe.length;i++)if((e=t[mNe[i]])&&ALt(e.open))return e}catch{e=null}return e||null}function iP(t,e){Su("QUnit")&&console&&console.log("  ["+EDt(new Date)+"]: IndexedDbHelper ["+t+"] "+e)}function xC(t,e,i){t&&t.warnToConsole("IndexedDbHelper ["+e+"] "+i)}function fNe(t,e,i,r){return function(o){i(new Error(e)),iP(t,"["+r+"] event rejected")}}var Cue=[];function e6(t,e){for(var i=null,r=0;r<Cue.length;r++)if((i=Cue[r]).name===t)return i;return i={name:t,sch:ode(Gh,"IndexedDbHelper["+t+"]"),dbHdl:[],add:function(o){i.dbHdl.push(o),iP(t,"- dbOpened (add) -- hdls ["+i.dbHdl.length+"]")},remove:function(o){for(var l=i.dbHdl,d=0;d<l.length;d++)if(l[d]===o){l.splice(d,1);break}iP(t,"- dbClosed (remove) -- hdls ["+i.dbHdl.length+"]")},isOpen:function(){return i.dbHdl.length>0},openHdl:function(){return i.dbHdl.length>0?i.dbHdl[0]:null}},Cue.push(i),i}var RLt=function(){function t(e){var i=wLt++,r=0;Yc(t,this,function(o){var l=kLt()||null;function d(f,y,T){var C=f.db,E=r++;iP(f.dbName,"["+i+":"+E+"] txn.open - "+y+" -- "+T);var I=C.transaction(y,bLt);return I.onabort=function(){xC(e,f.dbName,"["+i+":"+E+"] txn.onabort - "+y+" -- "+T+" -- "+Ws(I.error))},I.onerror=function(){xC(e,f.dbName,"["+i+":"+E+"] txn.onerror - "+y+" -- "+T)},I.oncomplete=function(){iP(f.dbName,"["+i+":"+E+"] txn.oncomplete - "+y+" -- "+T)},{db:f,store:I.objectStore(y),tx:I,tbl:y,openCursor:function(w,D){return p(f,y,w,D)},newTransaction:function(w){return h(f,y,w)}}}function h(f,y,T){if(!f||!f.db)return QM(new Error(gNe));try{var C=T(d(f,y,"openStore"));return WL(C)?C:YRt(C)}catch(E){return QM(E)}}function p(f,y,T,C){if(!f||!f.db)return QM(new Error(gNe));var E=null;return T&&ILt(T)?E=new MLt(T):T&&T.isMatch&&(E=T),Gh(function(I,w){var D=[],F=null,x=null;E&&E.keyRange&&(x=E.keyRange());var B=d(f,y,"openCursor");(F=x?B.store.openCursor(x):B.store.openCursor()).onerror=fNe(B.db.dbName,TLt,w,"openCursor"),F.onsuccess=function(L){var z=L.target[Tue];if(z){var H={store:B,cursor:z,continue:function(){z.continue()},done:function(){I(D)}},j=z.value;if(!E||E.isMatch(j))if(C)try{switch(C(H,j,D)){case 2:I(D);break;case 1:break;default:H.continue()}}catch(J){w(J)}else D.push(j),H.continue();else H.continue()}else I(D)}})}function g(f,y,T,C){return e6(f).sch.queue(T,y,C)}o.isAvailable=function(){return!!l},o.openDb=function(f,y,T,C){return g(f,"openDb",function(E){return Gh(function(I,w){var D=!1;function F(j,J,Z,re,ne){var le={db:J,dbName:f,dbVersion:y,ctx:null,isNew:re,txn:Z?Z.transaction:null};return ne||(le.openStore=function(he,Me){return h(le,he,Me)},le.openCursor=function(he,Me,Le){return p(le,he,Me,Le)}),le}function x(j,J){var Z=F(null,j,J,!0,!0);if(C)D=!0,DC(C(Z),function(re){if(re.rejected)try{J.transaction&&J.transaction.abort()}finally{w(re.reason)}else Z.txn||(Z.txn=J.transaction)});else try{J.transaction&&J.transaction.abort()}finally{w(new Error(_Lt))}}function B(j,J){var Z=e6(f);Z.add(j),j.onabort=function(le){xC(e,f,"onabort -- closing the Db"),Z.remove(j)},j.onerror=function(le){xC(e,f,"onerror -- closing the Db"),Z.remove(j)},j.onclose=function(le){xC(e,f,"onclose -- closing the Db"),Z.remove(j)},j.onversionchange=function(le){xC(e,f,"onversionchange -- force closing the Db"),j.close(),Z.remove(j)};var re=null,ne=null;Z.dbHdl.length>0&&(ne=Z.dbHdl[0]),re=F(Z,ne,J,D);try{Zx(T(re),I,w)}catch(le){w(le)}}var L=e6(f);if(l==null)w(new Error("No available storage factory"));else if(L.isOpen()){var z=F(L,L.openHdl(),null,!1);Zx(T(z),I,w)}else{var H=l.open(f,y);H.onblocked=function(j){xC(e,f,"Db Open Blocked event ["+E+"] - "+(H.error||"")),w(new Error(Xj))},H.onerror=function(j){xC(e,f,"Db Open Error event ["+E+"] - "+(H.error||"")),w(new Error(Xj))},H.onupgradeneeded=function(j){iP(f,"Db Open Create/Upgrade needed event ["+E+"]");try{var J=j.target[Tue];if(!J)return void w(new Error(Xj));x(J,H)}catch(Z){fNe(f,Xj,w,E)(Z)}},H.onsuccess=function(j){var J=j.target[Tue];J?B(J,H):w(new Error(Xj))}}})})},o.closeDb=function(f){g(f,"closeDb",function(y){var T=e6(f),C=T.dbHdl,E=C.length;if(E>0){for(var I=0;I<E;I++)C[I].close();T.dbHdl=[]}return 1}).catch(function(y){})},o.deleteDb=function(f){return l!=null&&g(f,"deleteDb",function(y){var T=e6(f),C=T.dbHdl,E=C.length;if(E>0){xC(e,f,"Db is open ["+E+"] force closing");for(var I=0;I<E;I++)C[I].close();T.dbHdl=[]}return Gh(function(w,D){setTimeout(function(){try{iP(f,"["+y+"] starting");var F=l.deleteDatabase(f);F.onerror=function(x){xC(e,f,"["+y+"] error!!"),D(new Error(wY))},F.onblocked=function(x){xC(e,f,"["+y+"] blocked!!"),D(new Error(wY))},F.onupgradeneeded=function(x){xC(e,f,"["+y+"] upgrade needed!!"),D(new Error(wY))},F.onsuccess=function(x){iP(f,"["+y+"] complete"),w(!0)},iP(f,"["+y+"] started")}catch(x){xC(e,f,"["+y+"] threw - "+x),D(new Error(wY+" - "+x))}},0)})})},o.getDbDetails=function(f){return g(f,"getDbDetails",function(y){return l!=null&&l.databases?Gh(function(T,C){l.databases().then(function(E){for(var I=0;I<E.length;I++)if(E[I].name===f)return void T(E[I]);C(new Error(CLt))},C)}):QM(new Error(ELt))},2e3)}})}return t.__ieDyn=1,t}(),MLt=function(){function t(e){var i=[],r=null;Yc(t,this,function(o){o.keyRange=function(){return r},o.parseQuery=function(l){if(i=[],l)for(var d=l.split(";"),h=0;h<d.length;h++){var p=d[h],g=p.indexOf("=");if(g!==-1){var f=p.substring(0,g),y=p.substring(g+1);f.indexOf("#")===0&&(f=f.substring(1),r||(r=IDBKeyRange.bound(y,y+"￿"))),o.startsWith(f,y)}}},o.startsWith=function(l,d){i.push({name:l,value:d,type:0})},o.contains=function(l,d){i.push({name:l,value:d,type:1})},o.isMatch=function(l){if(!i||i.length===0)return!0;if(!l)return!1;for(var d=0;d<i.length;d++){var h=i[d],p=l[h.name];if(p){if(h.type===0){if(p.indexOf(h.value)!==0)return!1}else if(h.type===1&&p.indexOf(h.value)===-1)return!1}}return!0},e&&o.parseQuery(e)})}return t.__ieDyn=1,t}(),PLt=10,DLt=1,LLt=6e5,_ue=6048e5,OLt="Unknown",NLt=-1,h3="DBError: Unable to add event",xLt="DBError: Unable to update iKey",BLt=1,nP="Evts",t6="iKey",FLt=IY;function p3(){return new Date().getTime()}function ULt(t,e){return function(i){return e(new Error(t))}}function zLt(t){t.objectStoreNames.contains(nP)||t.createObjectStore(nP,{keyPath:"key"}).createIndex("EvntId","key",{unique:!1}),t.objectStoreNames.contains(t6)||t.createObjectStore(t6,{keyPath:"iKey"}).createIndex("iKey","iKey",{unique:!0})}function vNe(t){return t.openStore(t6,function(e){return Gh(function(i,r){var o={iKey:t.ctx.iKey,tm:p3()},l=e.store.put(o);l.onsuccess=function(d){i(l.result.toString())},l.onerror=function(d){r(new Error(h3))},l.onerror=ULt(xLt,r)})})}function yNe(t){for(var e=[],i=2;i>=1;i--)for(var r=0;r<t.length;r++){var o=t[r];o&&o.evt.persistence===i&&e.push(o.evt)}return e}function VLt(t,e){for(var i=0;i<t.length;i++)if(e.tm<t[i].tm)return void t.splice(i,0,e);t.push(e)}function $Lt(t,e){for(var i=e.length,r=0;r<i;r++)if(t===e[r].id)return r;return-1}function HLt(t,e){var i=t.tm;return p3()-i>e}function kY(t){return function(e){return t.continue()}}function Eue(t){var e=t.cursor.delete();return e.onerror=kY(t),e.onsuccess=kY(t),1}function jLt(t,e){return t.openCursor(nP,e,function(i,r,o){return o.push(r),0})}function SNe(t,e,i){return t.openCursor(nP,e,function(r,o,l){return i(o)?(l.push(o),Eue(r)):0})}function GLt(t){return Gh(function(e,i){var r=!1;t.openCursor(t6,null,function(o,l,d){var h=l.tm;return p3()-h<_ue?0:(r=!0,2)}).then(function(){if(r){var o={};SNe(t,null,function(l){if(!l||!l.evt||!l.evt.iKey)return!0;var d=l.tm;return p3()-d>_ue||(o[l.evt.iKey]=1,!1)}).then(function(){var l=[];t.openCursor(t6,null,function(d,h,p){var g=h.tm;return p3()-g<_ue||o[h.iKey]?0:(l.push(h),Eue(d))}).then(function(){e(l)},i)},i)}else e([])},i)})}function qLt(t,e){return t.openCursor(nP,"#key="+t.ctx.iKeyPrefix(),function(i,r){var o=r.key;if(o.indexOf(t.ctx.iKeyPrefix())===0&&o.indexOf(t.ctx.evtKeyPrefix())===-1&&HLt(r,e)){r.key=t.ctx.evtKeyPrefix()+r.id;var l=i.store.store.put(r);return l.onerror=kY(i),l.onsuccess=function(d){try{Eue(i)}catch{i.continue()}},1}return 0})}function Aue(t,e){return Gh(function(i,r){GLt(t).then(function(){qLt(t,e).then(i,i)},r)})}function WLt(t,e){return Gh(function(i,r){var o=0,l=t.ctx.evtKeyPrefix();function d(){i(o)}function h(g,f){return Gh(function(y){var T=g.store.delete(f.key);T.onsuccess=function(C){o++,y()},T.onerror=function(C){y()}})}function p(g){g.length!==0?t.openStore(nP,function(f){for(var y=[],T=0;T<g.length;T++)y.push(h(f,g[T]));return JRt(y).then(d,d)}):d()}t.openCursor(nP,"#key="+l,function(g,f,y){return f.evt.persistence<=e&&f.key.indexOf(l)===0&&(VLt(y,f),y.length>PLt&&y.splice(y.length-1,1)),0}).then(p,function(){i(0)})})}var KLt=function(){function t(e,i){Yc(t,this,function(r){var o=null,l=null,d=OLt,h=null,p=null,g=null,f=NLt,y=0,T=LLt;function C(I){function w(F){return Gh(function(x,B){zLt(F.db),x()})}function D(F){return Gh(function(x,B){var L={iKey:d,storageId:h,iKeyPrefix:function(){return p},evtKeyPrefix:function(){return g}};F.ctx=L,Zx(vNe(F),function(){Zx(I(F),x,B)},B)})}return o.openDb(l,BLt,D,w)}function E(I,w,D){return Gh(function(F,x){function B(H,j){WLt(I,H).then(function(J){J>0&&(y-=J),j(J)},function(J){j(0)})}function L(H){F(w.evt)}function z(){I.openStore(nP,function(H){var j=H.store.put(w);j.onsuccess=function(J){D&&vNe(I).then(L,L),y++,F(w.evt)},j.onerror=function(J){function Z(re){re===0&&x(new Error(h3)),E(I,w,!1).then(function(ne){F(w.evt)},function(){x(new Error(h3))})}D?B(1,function(re){re>0?Z(re):w.evt.persistence>=2?B(2,function(ne){Z(ne)}):x(new Error(h3))}):x(new Error(h3))}})}f>0&&y>=f?B(1,function(H){H===0?w.evt.persistence>=2?B(2,function(j){z()}):x(new Error(h3)):z()}):z()})}r.id=e,r.initialize=function(I){var w=I.itemCtx.diagLog();if(!(o=new RLt(w)).isAvailable())return o=null,!1;var D=I.itemCtx.getCfg(),F=I.storageConfig;d=D.instrumentationKey||d,h=r.id||I.id||Yj(),g=(p=d+"::")+h+"::",T=F.accessThresholdInMs||T;var x=_Y(F,function(){f=F.maxStorageItems;var B=F.indexedDbName;l&&B!==l&&l&&DC(r.clear(),function(L){l=B,C(function(z){return z.isNew?[]:Aue(z,T)}).then(function(z){},function(z){w.warnToConsole("IndexedDbProvider failed to initialize - "+(z||"<unknown>")),o=null})}),l=B});return i&&i.add(x),C(function(B){return B.isNew?[]:Aue(B,T)}).then(function(B){},function(B){w.warnToConsole("IndexedDbProvider failed to initialize - "+(B||"<unknown>")),o=null}),!0},r._getDbgPlgTargets=function(){return[l]},r.supportsSyncRequests=function(){return!1},r.getAllEvents=function(){return o!=null&&o.isAvailable()?C(function(I){return Gh(function(w,D){jLt(I,"#key="+I.ctx.evtKeyPrefix()).then(function(F){y=F.length,w(yNe(F))},D)})}):[]},r.addEvent=function(I,w,D){return o!=null&&o.isAvailable()?(w.id=w.id||Yj(),FLt(w.persistence)||(w.persistence=1),C(function(F){var x=I||w.id,B={key:F.ctx.evtKeyPrefix()+x,id:x,evt:w,tm:p3(),v:DLt};return E(F,B,!0)})):w},r.removeEvents=function(I){if(o==null||!o.isAvailable())return[];var w=[];return Gh(function(D,F){C(function(x){return x.openCursor(nP,"#key="+x.ctx.iKey,function(B,L,z){if($Lt(L.id,I)!==-1){var H=B.cursor.delete();return H.onerror=kY(B),H.onsuccess=function(){w.push(L.evt),B.continue()},1}return 0})}).then(function(x){y-=w.length,D(w)},function(x){y-=w.length,D(w)})})},r.clear=function(){return o!=null&&o.isAvailable()?Gh(function(I,w){C(function(D){return SNe(D,"#key="+D.ctx.evtKeyPrefix(),function(F){return F.key.indexOf(D.ctx.evtKeyPrefix())===0})}).then(function(D){y=0,I(yNe(D))},w)}):[]},r.moveStaleEvents=function(){C(function(I){return Aue(I,T)})},r.teardown=function(){o&&o.closeDb(l)}})}return t.__ieDyn=1,t}(),bNe=10,TNe="3",CNe="Version",JLt="AWTEvents",YLt=5e6;function QLt(t,e){var i=!1;return e instanceof DOMException&&(e.code!==22&&e.name!=="QuotaExceededError"&&e.code!==1014&&e.name!=="NS_ERROR_DOM_QUOTA_REACHED"||t&&t.length!==0&&(i=!0)),i}function ZLt(t){var e=YL()||{},i=null;try{if(i=e[t]){var r="__storage_test__";i.setItem(r,r),i.removeItem(r)}}catch(o){QLt(i,o)||(i=null)}return i}function g3(t,e){if(t)for(var i=Ww(t),r=0;r<i.length;r++){var o=i[r];if(!e(t[o],o))break}}function XLt(t){var e=!0;return g3(t,function(i,r){return i&&(e=!1),e}),e}function eOt(t,e){for(var i=1,r=0,o=function(){var d=[],h=e[i];if(g3(h,function(g,f){return d.push(f),++r<bNe}),r>0){for(var p=0;p<d.length;p++)delete h[d[p]];return{value:!0}}i++};i<=t&&r<bNe;){var l=o();if(typeof l=="object")return l.value}return r>0}var tOt=IY,iOt=function(){function t(e,i,r){Yc(t,this,function(o){var l=null,d=JLt,h=null,p=TNe,g=null,f=null,y=YLt,T=6e5,C=null,E=null;function I(B,L){return{key:B,db:L}}function w(B,L){L===void 0&&(L=!0);var z=null;if(l){var H=l.getItem(B);if(H)try{z=JSON.parse(H)}catch{l.removeItem(B)}}return L&&!z&&(z={events:{1:{},2:{},3:{}},lastAccessTime:0}),I(B,z)}function D(B,L){L===void 0&&(L=!0);var z=!0,H=B.db;if(H){L&&(H.lastAccessTime=new Date().getTime());for(var j=1;j<=2;j++)if(!XLt(H.events[j])){z=!1;break}}try{if(z)l&&l.removeItem(B.key);else{var J=JSON.stringify(H);if(J.length>y)return!1;l&&l.setItem(B.key,J)}}catch{return!1}return!0}function F(B){var L=[],z=w(B,!1),H=z.db;if(H){var j=H.events;try{for(var J=1;J<=2;J++)g3(j[J],function(Z,re){return Z&&L.push(Z),!0})}catch{}l&&l.removeItem(z.key)}return L}function x(){if(l){for(var B=l.getItem(C),L=[],z=w(E),H=!1,j=0;j<l.length;j++){var J=l.key(j);if(J.indexOf(d)===0&&J!==C){if(B!==TNe){L.push(I(J,null));continue}var Z=w(J,!1),re=Z.db;if(re){if(new Date().getTime()-re.lastAccessTime>T){for(var ne=1,le=function(){var he=re.events[ne],Me=z.db.events[ne];g3(he,function(Le,pe){return(pB(Le.iKey)||Le.iKey)===f&&(Me[pe]=Le,delete he[pe]),!0}),ne++};ne<=2;)le();H=!0,L.push(Z)}}else L.push(I(J,null))}}for(j=0;j<L.length;j++)D(L[j],!1);H&&D(z),l.setItem(C,p)}}o.id=i,l=ZLt(e)||null,o._getDbgPlgTargets=function(){return[d,y]},o.initialize=function(B){if(!l)return!1;var L=B.storageConfig;h=o.id||B.id||Yj(),g=B.itemCtx.getCfg().instrumentationKey,f=pB(g)||g,T=L.accessThresholdInMs?L.accessThresholdInMs:T;var z=_Y(L,function(){y=L.maxStorageSizeInBytes;var H=L.storageKey;d&&H!==d&&DC(o.clear(),function(j){E=(d=H)+"."+h,C=d+CNe,x()})});return r&&r.add(z),d=L.storageKey,E=d+"."+h,C=d+CNe,x(),!0},o.supportsSyncRequests=function(){return!0},o.getAllEvents=function(){try{var B=[],L=w(E,!1).db;if(L)for(var z=L.events,H=2;H>=1;H--)g3(z[H],function(j){return j&&(pB(j.iKey)||j.iKey)===f&&B.push(j),!0});return B}catch(j){return QM(j)}},o.addEvent=function(B,L,z){try{var H=w(E);L.id=L.id||Yj(),tOt(L.persistence)||(L.persistence=1);for(var j=L.persistence,J=L.id,Z=H.db.events;;){if(Z[j][J]=L,D(H))return L;if(delete Z[j][J],!eOt(j,Z))return QM(new Error("Unable to free up event space"))}}catch(re){return QM(re)}},o.removeEvents=function(B){try{var L=w(E,!1),z=L.db;if(z){var H=z.events;try{for(var j=0;j<B.length;++j){var J=B[j];delete H[J.persistence][J.id]}if(D(L))return B}catch{}B=F(L.key)}return B}catch(Z){return QM(Z)}},o.clear=function(){try{var B=[],L=w(E,!1),z=L.db;if(z){for(var H=z.events,j=function(Z){var re=H[Z];g3(re,function(ne){return ne&&(pB(ne.iKey)||ne.iKey)===f&&(delete re[ne.id],B.push(ne)),!0})},J=2;J>=1;J--)j(J);D(L)}return B}catch(Z){return QM(Z)}},o.teardown=function(){try{var B=w(E,!1),L=B.db;L&&(L.lastAccessTime=0,D(B,!1))}catch{}},o.moveStaleEvents=function(){x()}})}return t.__ieDyn=1,t}(),nOt="4.3.1",aOt="LocalStorage",rOt=5,_Ne=IY,oOt=void 0,sOt="AppInsightEvents.1",lOt=F5({maxStorageSizeInBytes:{isVal:pNe,v:5e6},storageKey:"AWTEvents",minPersistenceLevel:{isVal:_Ne,v:1},providers:[gB.LocalStorage,gB.IndexedDb],indexedDbName:sOt,maxStorageItems:{isVal:pNe,v:oOt}}),cOt=function(t){function e(){var i=t.call(this)||this;return i.identifier=aOt,i.priority=1009,i.version=nOt,Yc(e,i,function(r,o){var l,d,h,p;function g(){l=!1,d=!1,h=null,p=[]}function f(B,L){h||(h=ode(Gh,"LocalStorage")),h.queue(function(z){return L(z)},B).catch(function(z){})}function y(B){Jj(r.core,function(){return"LocalStorageChannel:_sendStoredEventsToNextPlugin"},function(){f("sendToNext",function(L){return DC(B.provider.getAllEvents(),function(z){for(var H=z.value||[],j=0;j<H.length;j++)try{var J=H[j];(pB(J.iKey)||J.iKey)===B.tenantId&&r.processNext(J,B.coreRootCtx.createNew())}catch{}})})},function(){return{iKeyConfig:B}})}function T(B,L){Jj(r.core,function(){return"LocalStorageChannel:_removeEvents"},function(){f("removeEvents",function(z){var H=[];if(Qa(L,function(j){(pB(j.iKey)||j.iKey)===B.tenantId&&H.push(j)}),H.length>0)return DC(B.provider.removeEvents(H),function(j){})})},function(){return{iKeyConfig:B,events:L}})}function C(B,L){return!(L.sync||L.persistence<B.minPersistenceCacheLevel)}function E(B){var L=new KLt(void 0,r._unloadHooks);return L.initialize(B)||(L=null),L}function I(B,L){var z=new iOt(B,void 0,r._unloadHooks);return z.initialize(L)||(z=null),z}function w(B){for(var L=B.storageConfig.providers,z=null,H=0;!z&&H<L.length&&H<rOt;)switch(L[H++]){case gB.LocalStorage:z=I("localStorage",B);break;case gB.SessionStorage:z=I("sessionStorage",B);break;case gB.IndexedDb:z=E(B)}return z}function D(B,L){if(B.length!==L.length)return!1;var z=!0;return Qa(B,function(H,j){if(H!==L[j])return z=!1,-1}),z}function F(B,L,z,H){B&&(B.extensionConfig=B.extensionConfig||[]),!H&&L&&(H=L.getProcessTelContext().getNext());var j=null,J=r._getTelCtx().getNext();return J&&(j=J.getPlugin()),u3(H,B,L,j)}function x(B,L,z,H){var j=!1;if(Qa(p,function(Me){if(Me.iKey===B.instrumentationKey)return j=!0,-1}),!j){var J=null;r._addHook(_Y(B,function(Me){var Le=u3(null,Me.cfg,L);J=Le.getExtCfg(r.identifier,lOt);var pe=!1,te=null,Se=B.instrumentationKey;if(Qa(p,function(ve){if(ve.iKey===Se)return pe=!0,te=ve,-1}),pe&&te){var ce=J.providers,X=te.preProviders;D(ce,X)||DC(ne.clear(),function(ve){if(!ve.rejected)try{var Te=p.indexOf(te);Te!==-1&&p.splice(Te,1);var Be=w(te.providerContext);te.provider=Be,te.preProviders=ce.slice();var qe=te.preListener;qe&&L.removeNotificationListener(qe);var Ge={eventsSent:function(tt){T(te,tt)},eventsDiscarded:function(tt,ct){T(te,tt)}};te.preListener=Ge,p.push(te),L.addNotificationListener(Ge),y(te)}catch{}})}}));var Z=F(B,L,z,H),re={itemCtx:Z,storageConfig:J,id:r.id};if(!Bm(B.instrumentationKey))return;var ne=w(re),le={iKey:B.instrumentationKey,tenantId:pB(B.instrumentationKey)||B.instrumentationKey,minPersistenceCacheLevel:1,coreRootCtx:Z,providerContext:re,provider:ne,preProviders:J.providers.slice()};if(ne){_Ne(J.minPersistenceLevel||-1)&&(le.minPersistenceCacheLevel=J.minPersistenceLevel);var he={eventsSent:function(Me){T(le,Me)},eventsDiscarded:function(Me,Le){T(le,Me)}};le.preListener=he,p.push(le),L.addNotificationListener(he),y(le)}else p.push(le)}}g(),r.initialize=function(B,L,z,H){Jj(L,function(){return"LocalStorageChannel.initialize"},function(){l||(o.initialize(B,L,z),o.setInitialized(!1),l=!0,h=ode(Gh,"LocalStorage")),x(B,L,z,H)},function(){return{coreConfig:B,core:L,extensions:z,pluginChain:H}})},r.processTelemetry=function(B,L){var z=B;if(l&&!d){L=r._getTelCtx(L),SLt(B,r.identifier);var H=null;Qa(p,function(J){J.iKey===B.iKey&&(H=J)});var j=H?H.provider:null;if(z.sync||!j)return void r.processNext(z,L);z.id=z.id||Yj(),IY(z.persistence)||(z.persistence=1),C(H,z)&&f("processTelemetry",function(J){return j.addEvent(z.id,z,L)})}r.processNext(z,L)},r.pause=function(){d=!0},r.resume=function(){Jj(r.core,function(){return"LocalStorageChannel:resume"},function(){d=!1,Qa(p,function(B){B.provider&&y(B)})})},r._doTeardown=function(B,L){Qa(p,function(z){var H=z.provider;H&&H.teardown()}),g()},r.flush=function(B,L,z){},r._getDbgPlgTargets=function(){return[p]},r._sendStale=function(B){Qa(p,function(L){if(L&&L.iKey===B&&L.provider)return L.provider.moveStaleEvents(),y(L),-1})}}),i}return uj(e,t),e.__ieDyn=1,e}(fLt),RY="REAL_TIME",dOt="NEAR_REAL_TIME",uOt="BEST_EFFORT",hO="",Iue="drop",hOt="send",ENe="requeue",pOt="rspFail",gOt="oth",ANe="no-cache, no-store",wue="application/x-json-stream",MY="cache-control",i6="content-type",mOt="kill-tokens",fOt="kill-duration",vOt="time-delta-millis",kue="client-version",INe="client-id",Rue="time-delta-to-apply-millis",Mue="upload-time",Pue="apikey",Due="AuthMsaDeviceTicket",wNe="WebAuthToken",kNe="AuthXToken",yOt="NoResponseBody",PY="msfpc",RNe="trace",Lue="user",Oue="allowRequestSending",MNe="firstRequestSent",PNe="shouldAddClockSkewHeaders",DNe="getClockSkewHeaderValue",Nue="setClockSkew",zl="length",mB="concat",sk="iKey",Um="count",fB="events",tb="push",m3="split",DY="splice",xue="toLowerCase",f3="hdrs",Bue="useHdrs",n6="initialize",LNe="setTimeoutOverride",ONe="clearTimeoutOverride",SOt="payloadPreprocessor",NNe="overrideEndpointUrl",xNe="avoidOptions",bOt="disableEventTimings",TOt="stringifyObjects",Fue="enableCompoundKey",BNe="disableXhrSync",FNe="disableFetchKeepAlive",COt="addNoResponse",_Ot="excludeCsMetaData",UNe="useSendBeacon",zNe="fetchCredentials",VNe="alwaysUseXhrOverride",EOt="unloadTransports",$Ne="serializeOfflineEvt",HNe="getOfflineRequestDetails",Uue="createPayload",zue="createOneDSPayload",jNe="payloadBlob",lk="headers",a6="_thePayload",GNe="urlString",hT="batches",BC="sendType",Vue="addHeader",$ue="canSendRequest",LY="sendQueuedRequests",qNe="isCompletelyIdle",Hue="setUnloading",AOt="isTenantKilled",WNe="sendSynchronousBatch",jue="_transport",OY="getWParam",KNe="isBeacon",NY="timings",Gue="isTeardown",que="isSync",xY="data",IOt="timeout",Wue="_sendReason",JNe="setKillSwitchTenants",YNe="_backOffTransmission",BY="identifier",wOt="disableOptimizeObj",kOt="ignoreMc1Ms0CookieProcessing",QNe="eventsLimitInMem",ZNe="autoFlushEventsLimit",ROt="disableAutoBatchFlushLimit",MOt="overrideInstrumentationKey",POt="disableTelemetry",Kue="baseData",FY="sendAttempt",vB="latency",v3="sync";function XNe(t){var e=(t.ext||{}).intweb;return e&&cO(e[PY])?e[PY]:null}function exe(t){for(var e=null,i=0;e===null&&i<t[zl];i++)e=XNe(t[i]);return e}var r6=function(){function t(e,i){var r=i?[][mB](i):[],o=this,l=exe(r);o[sk]=function(){return e},o.Msfpc=function(){return l||hO},o[Um]=function(){return r[zl]},o[fB]=function(){return r},o.addEvent=function(d){return!!d&&(r[tb](d),l||(l=XNe(d)),!0)},o[m3]=function(d,h){var p;if(d<r[zl]){var g=r[zl]-d;pc(h)||(g=h<g?h:g),p=r[DY](d,g),l=exe(r)}return new t(e,p)}}return t.create=function(e,i){return new t(e,i)},t}(),DOt=function(){function t(){var e=!0,i=!0,r=!0,o="use-collector-delta",l=!1;Yc(t,this,function(d){d[Oue]=function(){return e},d[MNe]=function(){r&&(r=!1,l||(e=!1))},d[PNe]=function(){return i},d[DNe]=function(){return o},d[Nue]=function(h){l||(h?(o=h,i=!0,l=!0):i=!1,e=!0)}})}return t.__ieDyn=1,t}(),LOt=1e3,OOt=function(){function t(){var e={};function i(r){var o=[];return r&&Qa(r,function(l){o[tb](dT(l))}),o}Yc(t,this,function(r){r[JNe]=function(o,l){if(o&&l)try{var d=i(o[m3](","));if(l==="this-request-only")return d;for(var h=parseInt(l,10)*LOt,p=0;p<d[zl];++p)e[d[p]]=XS()+h}catch{return[]}return[]},r[AOt]=function(o){var l=e,d=dT(o);return l[d]!==void 0&&l[d]>XS()||(delete l[d],!1)}})}return t.__ieDyn=1,t}(),NOt=.8,xOt=1.2,txe=3e3,BOt=6e5;function FOt(t){return!(t>=300&&t<500&&t!=429||t==501||t==505)}function ixe(t){var e=0,i=txe*NOt,r=txe*xOt,o=Math.floor(Math.random()*(r-i))+i;return e=Math.pow(2,t)*o,Math.min(e,BOt)}var y3,UOt=20,zOt=3984588,nxe=65e3,axe=2e6,VOt=Math.min(axe,nxe),rxe="metadata",UY="f",$Ot=/\./,HOt=function(){function t(e,i,r,o,l,d){var h="data",p="baseData",g="ext",f=!!o,y=!0,T=i,C={},E=!!d,I=l||I1e;Yc(t,this,function(w){function D(x,B){var L=C[x];return L===void 0&&(x.length>=7&&(L=vLe(x,"ext.metadata")||vLe(x,"ext.web")),C[x]=L),L}function F(x,B,L,z,H,j,J){nc(x,function(Z,re){var ne=null;if(re||cO(re)){var le=L,he=Z,Me=H,Le=B;if(f&&!z&&$Ot.test(Z)){var pe=Z.split("."),te=pe.length;if(te>1){Me&&(Me=Me.slice());for(var Se=0;Se<te-1;Se++){var ce=pe[Se];Le=Le[ce]=Le[ce]||{},le+="."+ce,Me&&Me.push(ce)}he=pe[te-1]}}if(ne=!(z&&D(le))&&T&&T.handleField(le,he)?T.value(le,he,re,r):XPt(he,re,r)){var X=ne.value;if(Le[he]=X,j&&j(Me,he,ne),typeof X=="object"&&!ds(X)){var ve=Me;ve&&(ve=ve.slice()).push(he),F(re,X,le+"."+he,z,ve,j)}}}})}w.createPayload=function(x,B,L,z,H,j){return{apiKeys:[],payloadBlob:hO,overflow:null,sizeExceed:[],failedEvts:[],batches:[],numEvents:0,retryCnt:x,isTeardown:B,isSync:L,isBeacon:z,sendType:j,sendReason:H}},w.appendPayload=function(x,B,L){var z=x&&B&&!x.overflow;return z&&LC(e,function(){return"Serializer:appendPayload"},function(){for(var H=B.events(),j=x.payloadBlob,J=x.numEvents,Z=!1,re=[],ne=[],le=x.isBeacon,he=le?nxe:zOt,Me=le?VOt:axe,Le=0,pe=0;Le<H.length;){var te=H[Le];if(te){if(J>=L){x.overflow=B.split(Le);break}var Se=w.getEventBlob(te);if(Se&&Se.length<=Me){var ce=Se.length;if(j.length+ce>he){x.overflow=B.split(Le);break}j&&(j+=`
`),j+=Se,++pe>UOt&&(kA(j,0,1),pe=0),Z=!0,J++}else Se?re.push(te):ne.push(te),H.splice(Le,1),Le--}Le++}if(re.length>0&&x.sizeExceed.push(r6.create(B.iKey(),re)),ne.length>0&&x.failedEvts.push(r6.create(B.iKey(),ne)),Z){x.batches.push(B),x.payloadBlob=j,x.numEvents=J;var X=B.iKey();Bv(x.apiKeys,X)===-1&&x.apiKeys.push(X)}},function(){return{payload:x,theBatch:{iKey:B.iKey(),evts:B.events()},max:L}}),z},w.getEventBlob=function(x){try{return LC(e,function(){return"Serializer.getEventBlob"},function(){var B={};B.name=x.name,B.time=x.time,B.ver=x.ver,B.iKey="o:"+QPt(x.iKey);var L,z={};E||(L=function(Z,re,ne){jOt(I,z,Z,re,ne)});var H=x[g];H&&(B[g]=z,nc(H,function(Z,re){F(re,z[Z]={},"ext."+Z,!0,null,null,!0)}));var j=B[h]={};j.baseType=x.baseType;var J=j[p]={};return F(x.baseData,J,p,!1,[p],L,y),F(x.data,j,h,!1,[],L,y),JSON.stringify(B)},function(){return{item:x}})}catch{return null}}})}return t.__ieDyn=1,t}();function jOt(t,e,i,r,o){if(o&&e){var l=t(o.value,o.kind,o.propertyType);if(l>-1){var d=e[rxe];d||(d=e[rxe]={f:{}});var h=d[UY];if(h||(h=d[UY]={}),i)for(var p=0;p<i.length;p++){var g=i[p];h[g]||(h[g]={f:{}});var f=h[g][UY];f||(f=h[g][UY]={}),h=f}h=h[r]={},ds(o.value)?h.a={t:l}:h.t=l}}}function zY(t,e){return{set:function(i,r){for(var o=[],l=2;l<arguments.length;l++)o[l-2]=arguments[l];return IRt([t,e],i,r,o)}}}var Jue="sendAttempt",GOt="&"+yOt+"=true",qOt="?cors=true&"+i6[xue]()+"="+wue,WOt=((y3={})[1]=ENe,y3[100]=ENe,y3[200]="sent",y3[8004]=Iue,y3[8003]=Iue,y3),Yue={},Que={};function yB(t,e,i){Yue[t]=e,i!==!1&&(Que[e]=t)}function VY(t,e){var i=!1;if(t&&e){var r=Ww(t);if(r&&r[zl]>0)for(var o=e[xue](),l=0;l<r[zl];l++){var d=r[l];if(d&&IE(e,d)&&d[xue]()===o){i=!0;break}}}return i}function S3(t,e,i,r){e&&i&&i[zl]>0&&(r&&Yue[e]?(t[f3][Yue[e]]=i,t[Bue]=!0):t.url+="&"+e+"="+i)}function KOt(t,e,i){for(var r=0;r<t[zl];r++)if(t[r].name===e)return void(t[r].value=i);t[tb]({name:e,value:i})}function JOt(t,e){for(var i=0;i<t[zl];i++)if(t[i].name===e)return void t[DY](i,1)}yB(Due,Due,!1),yB(kue,kue),yB(INe,"Client-Id"),yB(Pue,Pue),yB(Rue,Rue),yB(Mue,Mue),yB(kNe,kNe);var YOt=function(){function t(e,i,r,o){var l,d,h,p,g,f,y,T,C,E,I,w,D,F,x,B,L,z,H,j,J,Z,re,ne,le,he,Me,Le,pe,te,Se,ce,X=!1;Yc(t,this,function(ve){tt();var Te=!0;function Be(Fe,St){try{return Se&&Se.getSenderInst(Fe,St)}catch{}return null}function qe(){try{return{enableSendPromise:!1,isOneDs:!0,disableCredentials:!Te,fetchCredentials:ce,disableXhr:!1,disableBeacon:!X,disableBeaconSync:!X,disableFetchKeepAlive:J,timeWrapper:pe,addNoResponse:re,senderOnCompleteCallBack:{xdrOnComplete:Ge,fetchOnComplete:ct,xhrOnComplete:Mt,beaconOnRetry:vt}}}catch{}return null}function Ge(Fe,St,Wt){var Ii=n3(Fe);ht(St,200,{},Ii),xe(Ii)}function tt(){var Fe;l=null,d=new OOt,h=!1,p=new DOt,X=!1,g=0,f=null,y=null,T=null,C=null,E=!0,I=[],w={},D=[],F=null,x=!1,B=null,L=!1,z=!1,H=Fe,j=Fe,J=Fe,Z=Fe,re=Fe,ne=[],le=Fe,he=Fe,Me=[],Le=!1,pe=zY(),te=!1,Se=null}function ct(Fe,St,Wt,Ii){var en=function(qt,ri,Ti){ht(St,qt,ri,Ti),xe(Ti)},sn={},Qi=Fe[lk];Qi&&Qi.forEach(function(qt,ri){sn[ri]=qt}),en(Fe.status,sn,Wt||hO)}function Mt(Fe,St,Wt){var Ii=n3(Fe);ht(St,Fe.status,jJ(Fe,!0),Ii),xe(Ii)}function ht(Fe,St,Wt,Ii){try{Fe(St,Wt,Ii)}catch(en){xu(y,2,518,Ws(en))}}function vt(Fe,St,Wt){var Ii=200,en=Fe[a6],sn=Fe[GNe]+(re?GOt:hO);try{var Qi=Kw();if(en){var qt=!!C.getPlugin("LocalStorage"),ri=[],Ti=[];Qa(en[hT],function(rn){if(ri&&rn&&rn[Um]()>0)for(var Hn=rn[fB](),ha=0;ha<Hn[zl];ha++){if(!Qi.sendBeacon(sn,F.getEventBlob(Hn[ha]))){ri[tb](rn[m3](ha));break}Ti[tb](rn[ha])}else ri[tb](rn[m3](0))}),Ti[zl]>0&&(en.sentEvts=Ti),qt||gt(ri,8003,en[BC],!0)}else Ii=0}catch(rn){Lj(y,"Failed to send telemetry using sendBeacon API. Ex:"+Ws(rn)),Ii=0}finally{ht(St,Ii,{},hO)}}function Pt(Fe){return Fe===2||Fe===3}function ni(Fe){return L&&Pt(Fe)&&(Fe=2),Fe}function Zt(){return!h&&g<i}function it(){var Fe=D;return D=[],Fe}function Ke(Fe,St,Wt){var Ii=!1;return Fe&&Fe[zl]>0&&!h&&T[St]&&F&&(Ii=St!==0||Zt()&&(Wt>0||p[Oue]())),Ii}function ot(Fe){var St={};return Fe&&Qa(Fe,function(Wt,Ii){St[Ii]={iKey:Wt[sk](),evts:Wt[fB]()}}),St}function Ht(Fe,St,Wt,Ii,en){if(Fe&&Fe[zl]!==0)if(h)gt(Fe,1,Ii);else{Ii=ni(Ii);try{var sn=Fe,Qi=Ii!==0;LC(C,function(){return"HttpManager:_sendBatches"},function(qt){qt&&(Fe=Fe.slice(0));for(var ri=[],Ti=null,rn=ak(),Hn=T[Ii]||(Qi?T[1]:T[0]),ha=Hn&&Hn[jue],hr=Z&&(L||Pt(Ii)||ha===3||Hn._isSync&&ha===2);Ke(Fe,Ii,St);){var yn=Fe.shift();yn&&yn[Um]()>0&&(d.isTenantKilled(yn[sk]())?ri[tb](yn):(Ti=Ti||F[Uue](St,Wt,Qi,hr,en,Ii),F.appendPayload(Ti,yn,e)?Ti.overflow!==null&&(Fe=[Ti.overflow][mB](Fe),Ti.overflow=null,Vt(Ti,rn,ak(),en),rn=ak(),Ti=null):(Vt(Ti,rn,ak(),en),rn=ak(),Fe=[yn][mB](Fe),Ti=null)))}Ti&&Vt(Ti,rn,ak(),en),Fe[zl]>0&&(D=Fe[mB](D)),gt(ri,8004,Ii)},function(){return{batches:ot(sn),retryCount:St,isTeardown:Wt,isSynchronous:Qi,sendReason:en,useSendBeacon:Pt(Ii),sendType:Ii}},!Qi)}catch(qt){xu(y,2,48,"Unexpected Exception sending batch: "+Ws(qt))}}}function jt(Fe,St){var Wt={url:l,hdrs:{},useHdrs:!1};St?(Wt[f3]=cY(Wt[f3],w),Wt.useHdrs=Ww(Wt.hdrs)[zl]>0):nc(w,function(qt,ri){Que[qt]?S3(Wt,Que[qt],ri,!1):(Wt[f3][qt]=ri,Wt[Bue]=!0)}),S3(Wt,INe,"NO_AUTH",St),S3(Wt,kue,E1e,St);var Ii=hO;Qa(Fe.apiKeys,function(qt){Ii[zl]>0&&(Ii+=","),Ii+=qt}),S3(Wt,Pue,Ii,St),S3(Wt,Mue,XS().toString(),St);var en=Ae(Fe);if(cO(en)&&(Wt.url+="&ext.intweb.msfpc="+en),p[PNe]()&&S3(Wt,Rue,p[DNe](),St),C[OY]){var sn=C[OY]();sn>=0&&(Wt.url+="&w="+sn)}for(var Qi=0;Qi<I[zl];Qi++)Wt.url+="&"+I[Qi].name+"="+I[Qi].value;return Wt}function Nt(Fe,St,Wt){Fe[St]=Fe[St]||{},Fe[St][f.identifier]=Wt}function Vt(Fe,St,Wt,Ii){if(Fe&&Fe.payloadBlob&&Fe.payloadBlob[zl]>0){var en=!!le,sn=T[Fe.sendType];!Pt(Fe[BC])&&Fe[KNe]&&Fe.sendReason===2&&(sn=T[2]||T[3]||sn);var Qi=z;(Fe.isBeacon||sn[jue]===3)&&(Qi=!1);var qt=jt(Fe,Qi);Qi=Qi||qt[Bue];var ri=ak();LC(C,function(){return"HttpManager:_doPayloadSend"},function(){for(var Ti=0;Ti<Fe.batches[zl];Ti++)for(var rn=Fe[hT][Ti][fB](),Hn=0;Hn<rn[zl];Hn++){var ha=rn[Hn];if(x){var hr=ha[NY]=ha[NY]||{};Nt(hr,"sendEventStart",ri),Nt(hr,"serializationStart",St),Nt(hr,"serializationCompleted",Wt)}ha[Jue]>0?ha[Jue]++:ha[Jue]=1}gt(Fe[hT],1e3+(Ii||0),Fe[BC],!0);var yn={data:Fe[jNe],urlString:qt.url,headers:qt[f3],_thePayload:Fe,_sendReason:Ii,timeout:H,disableXhrSync:j,disableFetchKeepAlive:J};Qi&&(VY(yn[lk],MY)||(yn[lk][MY]=ANe),VY(yn[lk],i6)||(yn[lk][i6]=wue));var pr=null;sn&&(pr=function(Ho){p[MNe]();var Rr=function(us,al){dt(us,al,Fe,Ii)},La=Fe[Gue]||Fe[que];try{sn.sendPOST(Ho,Rr,La),he&&he(yn,Ho,La,Fe[KNe])}catch(us){Lj(y,"Unexpected exception sending payload. Ex:"+Ws(us)),ht(Rr,0,{})}}),LC(C,function(){return"HttpManager:_doPayloadSend.sender"},function(){if(pr)if(Fe[BC]===0&&g++,en&&!Fe.isBeacon&&sn[jue]!==3){var Ho={data:yn[xY],urlString:yn[GNe],headers:cY({},yn[lk]),timeout:yn[IOt],disableXhrSync:yn[BNe],disableFetchKeepAlive:yn[FNe]},Rr=!1;LC(C,function(){return"HttpManager:_doPayloadSend.sendHook"},function(){try{le(Ho,function(La){Rr=!0,E||La[a6]||(La[a6]=La[a6]||yn[a6],La[Wue]=La[Wue]||yn[Wue]),pr(La)},Fe.isSync||Fe[Gue])}catch{Rr||pr(yn)}})}else pr(yn)})},function(){return{thePayload:Fe,serializationStart:St,serializationCompleted:Wt,sendReason:Ii}},Fe[que])}Fe.sizeExceed&&Fe.sizeExceed[zl]>0&&gt(Fe.sizeExceed,8003,Fe[BC]),Fe.failedEvts&&Fe.failedEvts[zl]>0&&gt(Fe.failedEvts,8002,Fe[BC])}function $t(Fe,St){x&&Qa(Fe,function(Wt){Nt(Wt[NY]=Wt[NY]||{},"sendEventCompleted",St)})}function dt(Fe,St,Wt,Ii){var en=9e3,sn=null,Qi=!1,qt=!1;try{var ri=!0;if(typeof Fe!==QK){if(St){p[Nue](St[vOt]);var Ti=St[fOt]||St["kill-duration-seconds"];Qa(d[JNe](St[mOt],Ti),function(Hn){Qa(Wt[hT],function(ha){if(ha[sk]()===Hn){sn=sn||[];var hr=ha[m3](0);Wt.numEvents-=hr[Um](),sn[tb](hr)}})})}if(Fe==200||Fe==204)return void(en=200);(!FOt(Fe)||Wt.numEvents<=0)&&(ri=!1),en=9e3+Fe%1e3}if(ri){en=100;var rn=Wt.retryCnt;Wt[BC]===0&&(rn<r?(Qi=!0,je(function(){Wt[BC]===0&&g--,Ht(Wt[hT],rn+1,Wt[Gue],L?2:Wt[BC],5)},L,ixe(rn))):(qt=!0,L&&(en=8001)))}}finally{Qi||(p[Nue](),yt(Wt,en,Ii,qt)),gt(sn,8004,Wt[BC])}}function yt(Fe,St,Wt,Ii){try{Ii&&f[YNe]();var en=Fe[hT];St===200&&(en=Fe.sentEvts||Fe[hT],Ii||Fe[que]||f._clearBackOff(),kt(en)),gt(en,St,Fe[BC],!0)}finally{Fe[BC]===0&&(g--,Wt!==5&&ve.sendQueuedRequests(Fe[BC],Wt))}}function kt(Fe){if(x){var St=ak();Qa(Fe,function(Wt){Wt&&Wt[Um]()>0&&$t(Wt[fB](),St)})}}function je(Fe,St,Wt){St?Fe():pe.set(Fe,Wt)}function Ae(Fe){for(var St=0;St<Fe.batches[zl];St++){var Wt=Fe[hT][St].Msfpc();if(Wt)return encodeURIComponent(Wt)}return hO}function xe(Fe){var St=Me;try{for(var Wt=0;Wt<St[zl];Wt++)try{St[Wt](Fe)}catch(en){xu(y,1,519,"Response handler failed: "+en)}if(Fe){var Ii=JSON.parse(Fe);cO(Ii.webResult)&&cO(Ii.webResult[PY])&&B.set("MSFPC",Ii.webResult[PY],31536e3)}}catch{}}function gt(Fe,St,Wt,Ii){if(Fe&&Fe[zl]>0&&o){var en=o[Ye(St)];if(en){var sn=Wt!==0;LC(C,function(){return"HttpManager:_sendBatchesNotification"},function(){je(function(){try{en.call(o,Fe,St,sn,Wt)}catch(Qi){xu(y,1,74,"send request notification failed: "+Qi)}},Ii||sn,0)},function(){return{batches:ot(Fe),reason:St,isSync:sn,sendSync:Ii,sendType:Wt}},!sn)}}}function Ye(Fe){var St=WOt[Fe];return cO(St)||(St=gOt,Fe>=9e3&&Fe<=9999?St=pOt:Fe>=8e3&&Fe<=8999?St=Iue:Fe>=1e3&&Fe<=1999&&(St=hOt)),St}ve[n6]=function(Fe,St,Wt){Le||(C=St,B=St.getCookieMgr(),y=(f=Wt).diagLog(),ZL(ne,jy(Fe,function(Ii){var en,sn=Ii.cfg,Qi=Ii.cfg.extensionConfig[Wt.identifier];pe=zY(Qi[LNe],Qi[ONe]),cO(sn.anonCookieName)?KOt(I,"anoncknm",sn.anonCookieName):JOt(I,"anoncknm"),le=Qi[SOt],he=Qi.payloadListener;var qt=Qi.httpXHROverride,ri=Qi[NNe]?Qi[NNe]:sn.endpointUrl;l=ri+qOt,z=!!vd(Qi[xNe])||!Qi[xNe],x=!Qi[bOt];var Ti=Qi.valueSanitizer,rn=Qi[TOt],Hn=!!sn[Fue];vd(Qi[Fue])||(Hn=!!Qi[Fue]),H=Qi.xhrTimeout,j=!!Qi[BNe],J=!!Qi[FNe],re=Qi[COt]!==!1,te=!!Qi[_Ot],St.getPlugin("LocalStorage")&&(J=!0),X=!oOe(),F=new HOt(C,Ti,rn,Hn,I1e,te),pc(Qi[UNe])||(X=!!Qi[UNe]),Qi[zNe]&&(ce=Qi[zNe]);var ha=qe();Se?Se.SetConfig(ha):(Se=new OPt)[n6](ha,y);var hr=qt,yn=Qi[VNe]?qt:null,pr=Qi[VNe]?qt:null,Ho=[3,2];if(!qt){E=!1;var Rr=[];oOe()?(Rr=[2,1],Ho=[2,1,3]):Rr=[1,2,3],(qt=Be(Rr=XLe(Rr,Qi.transports),!1))||Lj(y,"No available transport to send events"),hr=Be(Rr,!0)}yn||(yn=Be(Ho=XLe(Ho,Qi[EOt]),!0)),Z=!E&&(X&&sOe()||!J&&lOe(!0)),(en={})[0]=qt,en[1]=hr||Be([1,2,3],!0),en[2]=yn||hr||Be([1],!0),en[3]=pr||Be([2,3],!0)||hr||Be([1],!0),T=en})),Le=!0)},ve.addResponseHandler=function(Fe){return Me[tb](Fe),{rm:function(){var St=Me.indexOf(Fe);St>=0&&Me[DY](St,1)}}},ve[$Ne]=function(Fe){try{if(F)return F.getEventBlob(Fe)}catch{}return hO},ve[HNe]=function(){try{return jt(F&&F[Uue](0,!1,!1,!1,1,0),z)}catch{}return null},ve[zue]=function(Fe,St){try{var Wt=[];Qa(Fe,function(qt){St&&(qt=i3(qt));var ri=r6.create(qt[sk],[qt]);Wt[tb](ri)});for(var Ii=null;Wt[zl]>0&&F;){var en=Wt.shift();en&&en[Um]()>0&&(Ii=Ii||F[Uue](0,!1,!1,!1,1,0),F.appendPayload(Ii,en,e))}var sn=jt(Ii,z),Qi={data:Ii[jNe],urlString:sn.url,headers:sn[f3],timeout:H,disableXhrSync:j,disableFetchKeepAlive:J};return z&&(VY(Qi[lk],MY)||(Qi[lk][MY]=ANe),VY(Qi[lk],i6)||(Qi[lk][i6]=wue)),Qi}catch{}return null},ve._getDbgPlgTargets=function(){return[T[0],d,F,T,qe()]},ve[Vue]=function(Fe,St){w[Fe]=St},ve.removeHeader=function(Fe){delete w[Fe]},ve[$ue]=function(){return Zt()&&p[Oue]()},ve[LY]=function(Fe,St){vd(Fe)&&(Fe=0),L&&(Fe=ni(Fe),St=2),Ke(D,Fe,0)&&Ht(it(),0,!1,Fe,St||0)},ve[qNe]=function(){return!h&&g===0&&D[zl]===0},ve[Hue]=function(Fe){L=Fe},ve.addBatch=function(Fe){if(Fe&&Fe[Um]()>0){if(d.isTenantKilled(Fe[sk]()))return!1;D[tb](Fe)}return!0},ve.teardown=function(){D[zl]>0&&Ht(it(),0,!0,2,2),Qa(ne,function(Fe){Fe&&Fe.rm&&Fe.rm()}),ne=[]},ve.pause=function(){h=!0},ve.resume=function(){h=!1,ve[LY](0,4)},ve[WNe]=function(Fe,St,Wt){Fe&&Fe[Um]()>0&&(pc(St)&&(St=1),L&&(St=ni(St),Wt=2),Ht([Fe],0,!1,St,Wt||0))}})}return t.__ieDyn=1,t}(),QOt=.25,oxe=500,ZOt=20,sxe=6,lxe=2,XOt=4,cxe=2,e1t=1,Zue=1e4,SB="eventsDiscarded",dxe="",Jg=void 0,t1t=F5({eventsLimitInMem:{isVal:Fj,v:Zue},immediateEventLimit:{isVal:Fj,v:500},autoFlushEventsLimit:{isVal:Fj,v:0},disableAutoBatchFlushLimit:!1,httpXHROverride:{isVal:i1t,v:Jg},overrideInstrumentationKey:Jg,overrideEndpointUrl:Jg,disableTelemetry:!1,ignoreMc1Ms0CookieProcessing:!1,setTimeoutOverride:Jg,clearTimeoutOverride:Jg,payloadPreprocessor:Jg,payloadListener:Jg,disableEventTimings:Jg,valueSanitizer:Jg,stringifyObjects:Jg,enableCompoundKey:Jg,disableOptimizeObj:!1,fetchCredentials:Jg,transports:Jg,unloadTransports:Jg,useSendBeacon:Jg,disableFetchKeepAlive:Jg,avoidOptions:!1,xhrTimeout:Jg,disableXhrSync:Jg,alwaysUseXhrOverride:!1,maxEventRetryAttempts:{isVal:HM,v:sxe},maxUnloadEventRetryAttempts:{isVal:HM,v:lxe},addNoResponse:Jg,excludeCsMetaData:Jg});function i1t(t){return t&&t.sendPOST}var n1t=function(t){function e(){var i,r=t.call(this)||this;r.identifier="PostChannel",r.priority=1011,r.version="4.3.2";var o,l,d,h,p,g,f,y,T,C,E,I,w,D,F,x,B,L,z,H,j,J,Z,re,ne,le=!1,he=[],Me=!1,Le=0,pe=0,te={},Se=RY;return Yc(e,r,function(ce,X){function ve(){GPt(null,L),qPt(null,L),WPt(null,L)}function Te(qt){var ri=qt[OY];qt[OY]=function(){var Ti=0;return H&&(Ti|=2),Ti|ri.call(qt)}}function Be(qt){var ri=dxe;return qt&&qt[zl]&&Qa(qt,function(Ti){ri&&(ri+=`
`),ri+=Ti}),ri}function qe(qt){var ri=dxe;try{ct(qt),ri=y[$Ne](qt)}catch{}return ri}function Ge(qt){(qt||QL().event).type!=="beforeunload"&&(F=!0,y[Hue](F)),Ke(2,2)}function tt(qt){F=!1,y[Hue](F)}function ct(qt){qt.ext&&qt.ext[RNe]&&delete qt.ext[RNe],qt.ext&&qt.ext[Lue]&&qt.ext[Lue].id&&delete qt.ext[Lue].id,D&&(qt.ext=i3(qt.ext),qt[Kue]&&(qt[Kue]=i3(qt[Kue])),qt[xY]&&(qt[xY]=i3(qt[xY])))}function Mt(qt,ri){if(qt[FY]||(qt[FY]=0),qt[vB]||(qt[vB]=1),ct(qt),qt[v3]){if(g||Me)qt[vB]=3,qt[v3]=!1;else if(y)return D&&(qt=i3(qt)),void y[WNe](r6.create(qt[sk],[qt]),qt[v3]===!0?1:qt[v3],3)}var Ti=qt[vB],rn=pe,Hn=d;Ti===4&&(rn=Le,Hn=l);var ha=!1;if(rn<Hn)ha=!Nt(qt,ri);else{var hr=1,yn=ZOt;Ti===4&&(hr=4,yn=1),ha=!0,Vt(qt[sk],qt[vB],hr,yn)&&(ha=!Nt(qt,ri))}ha&&Ye(SB,[qt],Wx.QueueFull)}function ht(qt,ri,Ti){var rn=dt(qt,ri,Ti);return y[LY](ri,Ti),rn}function vt(){return pe>0}function Pt(){if(I>=0&&dt(I,0,w)&&y[LY](0,w),Le>0&&!p&&!Me){var qt=te[Se][2];qt>=0&&(p=Zt(function(){p=null,ht(4,0,1),Pt()},qt))}var ri=te[Se][1];!h&&!o&&ri>=0&&!Me&&(vt()?h=Zt(function(){h=null,ht(f===0?3:1,0,1),f++,f%=2,Pt()},ri):f=0)}function ni(){i=null,le=!1,he=[],o=null,Me=!1,Le=0,l=500,pe=0,d=Zue,te={},Se=RY,h=null,p=null,g=0,f=0,T={},C=0,Z=!1,E=0,I=-1,w=null,D=!0,F=!1,x=sxe,B=lxe,L=null,re=null,ne=!1,z=zY(),y=new YOt(oxe,cxe,e1t,{requeue:xe,send:St,sent:Wt,drop:Ii,rspFail:en,oth:sn}),Ae(),ot(),Qi()}function Zt(qt,ri){ri===0&&g&&(ri=1);var Ti=1e3;return g&&(Ti=ixe(g-1)),z.set(qt,ri*Ti)}function it(){return h!==null&&(h.cancel(),h=null,f=0,!0)}function Ke(qt,ri){it(),o&&(o.cancel(),o=null),Me||ht(1,qt,ri)}function ot(){T[4]={batches:[],iKeyMap:{}},T[3]={batches:[],iKeyMap:{}},T[2]={batches:[],iKeyMap:{}},T[1]={batches:[],iKeyMap:{}}}function Ht(qt,ri,Ti){var rn=T[ri];rn||(rn=T[ri=1]);var Hn=rn.iKeyMap[qt];return!Hn&&Ti&&(Hn=r6.create(qt),rn.batches[tb](Hn),rn.iKeyMap[qt]=Hn),Hn}function jt(qt,ri){y[$ue]()&&!g&&(C>0&&pe>C&&(ri=!0),ri&&o==null&&ce.flush(qt,function(){},20))}function Nt(qt,ri){D&&(qt=i3(qt));var Ti=qt[vB],rn=Ht(qt[sk],Ti,!0);return!!rn.addEvent(qt)&&(Ti!==4?(pe++,ri&&qt[FY]===0&&jt(!qt.sync,E>0&&rn[Um]()>=E)):Le++,!0)}function Vt(qt,ri,Ti,rn){for(;Ti<=ri;){var Hn=Ht(qt,ri,!0);if(Hn&&Hn[Um]()>0){var ha=Hn[m3](0,rn),hr=ha[Um]();if(hr>0)return Ti===4?Le-=hr:pe-=hr,Fe(SB,[ha],Wx.QueueFull),!0}Ti++}return $t(),!1}function $t(){for(var qt=0,ri=0,Ti=function(Hn){var ha=T[Hn];ha&&ha[hT]&&Qa(ha[hT],function(hr){Hn===4?qt+=hr[Um]():ri+=hr[Um]()})},rn=1;rn<=4;rn++)Ti(rn);pe=ri,Le=qt}function dt(qt,ri,Ti){var rn=!1,Hn=ri===0;return!Hn||y[$ue]()?LC(ce.core,function(){return"PostChannel._queueBatches"},function(){for(var ha=[],hr=4;hr>=qt;){var yn=T[hr];yn&&yn.batches&&yn.batches[zl]>0&&(Qa(yn[hT],function(pr){y.addBatch(pr)?rn=rn||pr&&pr[Um]()>0:ha=ha[mB](pr[fB]()),hr===4?Le-=pr[Um]():pe-=pr[Um]()}),yn[hT]=[],yn.iKeyMap={}),hr--}ha[zl]>0&&Ye(SB,ha,Wx.KillSwitch),rn&&I>=qt&&(I=-1,w=0)},function(){return{latency:qt,sendType:ri,sendReason:Ti}},!Hn):(I=I>=0?Math.min(I,qt):qt,w=Math.max(w,Ti)),rn}function yt(qt,ri){ht(1,0,ri),$t(),kt(function(){qt&&qt(),he[zl]>0?o=Zt(function(){o=null,yt(he.shift(),ri)},0):(o=null,Pt())})}function kt(qt){y[qNe]()?qt():o=Zt(function(){o=null,kt(qt)},QOt)}function je(){it(),Ae(),Se=RY,Pt()}function Ae(){(te={})[RY]=[2,1,0],te[dOt]=[6,3,0],te[uOt]=[18,9,0]}function xe(qt,ri){var Ti=[],rn=x;F&&(rn=B),Qa(qt,function(Hn){Hn&&Hn[Um]()>0&&Qa(Hn[fB](),function(ha){ha&&(ha[v3]&&(ha[vB]=4,ha[v3]=!1),ha[FY]<rn?(Qde(ha,ce[BY]),Mt(ha,!1)):Ti[tb](ha))})}),Ti[zl]>0&&Ye(SB,Ti,Wx.NonRetryableStatus),F&&Ke(2,2)}function gt(qt,ri){var Ti=J||{},rn=Ti[qt];if(rn)try{rn.apply(Ti,ri)}catch(Hn){xu(ce.diagLog(),1,74,qt+" notification failed: "+Hn)}}function Ye(qt,ri){for(var Ti=[],rn=2;rn<arguments.length;rn++)Ti[rn-2]=arguments[rn];ri&&ri[zl]>0&&gt(qt,[ri][mB](Ti))}function Fe(qt,ri){for(var Ti=[],rn=2;rn<arguments.length;rn++)Ti[rn-2]=arguments[rn];ri&&ri[zl]>0&&Qa(ri,function(Hn){Hn&&Hn[Um]()>0&&gt(qt,[Hn.events()][mB](Ti))})}function St(qt,ri,Ti){qt&&qt[zl]>0&&gt("eventsSendRequest",[ri>=1e3&&ri<=1999?ri-1e3:0,Ti!==!0])}function Wt(qt,ri){Fe("eventsSent",qt,ri),Pt()}function Ii(qt,ri){Fe(SB,qt,ri>=8e3&&ri<=8999?ri-8e3:Wx.Unknown)}function en(qt){Fe(SB,qt,Wx.NonRetryableStatus),Pt()}function sn(qt,ri){Fe(SB,qt,Wx.Unknown),Pt()}function Qi(){E=j?0:Math.max(oxe*(cxe+1),d/6)}ni(),ce._getDbgPlgTargets=function(){return[y,i]},ce[n6]=function(qt,ri,Ti){LC(ri,function(){return"PostChannel:initialize"},function(){X[n6](qt,ri,Ti),J=ri.getNotifyMgr();try{L=xj(a3(ce[BY]),ri.evtNamespace&&ri.evtNamespace()),ce._addHook(jy(qt,function(rn){var Hn=rn.cfg,ha=aB(null,Hn,ri);i=ha.getExtCfg(ce[BY],t1t),z=zY(i[LNe],i[ONe]),D=!i[wOt]&&nDt(),H=i[kOt],Te(ri),d=i[QNe],l=i.immediateEventLimit,C=i[ZNe],x=i.maxEventRetryAttempts,B=i.maxUnloadEventRetryAttempts,j=i[ROt],Qi(),re=i[MOt],ne=!!i[POt],Z&&ve();var hr=Hn.disablePageUnloadEvents||[];Z=jPt(Ge,hr,L),Z=v1e(Ge,hr,L)||Z,Z=y1e(tt,Hn.disablePageShowEvents,L)||Z})),y[n6](qt,ce.core,ce)}catch(rn){throw ce.setInitialized(!1),rn}},function(){return{theConfig:qt,core:ri,extensions:Ti}})},ce.processTelemetry=function(qt,ri){Qde(qt,ce[BY]),ri=ri||ce._getTelCtx(ri);var Ti=qt;ne||le||(re&&(Ti[sk]=re),Mt(Ti,!0),F?Ke(2,2):Pt()),ce.processNext(Ti,ri)},ce.getOfflineSupport=function(){try{var qt=y&&y[HNe]();if(y)return{getUrl:function(){return qt?qt.url:null},serialize:qe,batch:Be,shouldProcess:function(ri){return!ne},createPayload:function(ri){return null},createOneDSPayload:function(ri){if(y[zue])return y[zue](ri,D)}}}catch{}return null},ce._doTeardown=function(qt,ri){Ke(2,2),le=!0,y.teardown(),ve(),ni()},ce.setEventQueueLimits=function(qt,ri){i[QNe]=d=Fj(qt)?qt:Zue,i[ZNe]=C=Fj(ri)?ri:0,Qi();var Ti=pe>qt;if(!Ti&&E>0)for(var rn=1;!Ti&&rn<=3;rn++){var Hn=T[rn];Hn&&Hn[hT]&&Qa(Hn[hT],function(ha){ha&&ha[Um]()>=E&&(Ti=!0)})}jt(!0,Ti)},ce.pause=function(){it(),Me=!0,y.pause()},ce.resume=function(){Me=!1,y.resume(),Pt()},ce._loadTransmitProfiles=function(qt){je(),nc(qt,function(ri,Ti){var rn=Ti[zl];if(rn>=2){var Hn=rn>2?Ti[2]:0;if(Ti[DY](0,rn-2),Ti[1]<0&&(Ti[0]=-1),Ti[1]>0&&Ti[0]>0){var ha=Ti[0]/Ti[1];Ti[0]=Math.ceil(ha)*Ti[1]}Hn>=0&&Ti[1]>=0&&Hn>Ti[1]&&(Hn=Ti[1]),Ti[tb](Hn),te[ri]=Ti}})},ce.flush=function(qt,ri,Ti){var rn;if(qt===void 0&&(qt=!0),!Me)if(Ti=Ti||1,qt)ri||(rn=ZM(function(ha){ri=ha})),o==null?(it(),dt(1,0,Ti),o=Zt(function(){o=null,yt(ri,Ti)},0)):he[tb](ri);else{var Hn=it();ht(1,1,Ti),ri&&ri(),Hn&&Pt()}return rn},ce.setMsaAuthTicket=function(qt){y[Vue](Due,qt)},ce.setAuthPluginHeader=function(qt){y[Vue](wNe,qt)},ce.removeAuthPluginHeader=function(){y.removeHeader(wNe)},ce.hasEvents=vt,ce._setTransmitProfile=function(qt){Se!==qt&&te[qt]!==void 0&&(it(),Se=qt,Pt())},QLe(ce,function(){return y},["addResponseHandler"]),ce[YNe]=function(){g<XOt&&(g++,it(),Pt())},ce._clearBackOff=function(){g&&(g=0,it(),Pt())}}),r}return uj(e,t),e.__ieDyn=1,e}(zde),pT=Kkt,a1t="";function uxe(t){return{mrg:!0,v:t}}function bB(t){return{isVal:Bm,v:kE(a1t)}}var o6,hxe="locale",Xue="ver",r1t="browser",o1t="browserVer",s1t="popSample",l1t="eventFlags",ehe="name",c1t="serviceName",FC=pT({UserExt:[0,"user"],DeviceExt:[1,"device"],TraceExt:[2,"trace"],WebExt:[3,"web"],AppExt:[4,"app"],OSExt:[5,"os"],SdkExt:[6,"sdk"],IntWebExt:[7,"intweb"],UtcExt:[8,"utc"],LocExt:[9,"loc"],CloudExt:[10,"cloud"],DtExt:[11,"dt"]}),d1t=pT({id:[0,"id"],ver:[1,Xue],appName:[2,ehe],locale:[3,hxe],expId:[4,"expId"],env:[5,"env"]}),u1t=pT({domain:[0,"domain"],browser:[1,r1t],browserVer:[2,o1t],screenRes:[3,"screenRes"],userConsent:[4,"userConsent"],consentDetails:[5,"consentDetails"]}),h1t=pT({locale:[0,hxe],localId:[1,"localId"],id:[2,"id"]}),p1t=pT({osName:[0,ehe],ver:[1,Xue]}),g1t=pT({ver:[0,Xue],seq:[1,"seq"],installId:[2,"installId"],epoch:[3,"epoch"]}),m1t=pT({msfpc:[0,"msfpc"],anid:[1,"anid"],serviceName:[2,c1t]}),f1t=pT({popSample:[0,s1t],eventFlags:[1,l1t]}),v1t=pT({tz:[0,"tz"]}),y1t=pT({sessionId:[0,"sesId"]}),S1t=pT({localId:[0,"localId"],deviceClass:[1,"deviceClass"],make:[2,"make"],model:[3,"model"]}),b1t=pT({role:[0,"role"],roleInstance:[1,"roleInstance"],roleVer:[2,"roleVer"]}),T1t=pT({traceId:[0,"traceID"],traceName:[1,ehe],parentId:[2,"parentID"]}),C1t=pT({traceId:[0,"traceId"],spanId:[1,"spanId"],traceFlags:[2,"traceFlags"]});function pxe(){return o6===void 0&&(o6=!!mxe(0)),o6}function gxe(){return pxe()?mxe(0):null}function mxe(t){var e,i,r=null;try{var o=YL();if(!o)return null;i=new Date,(r=t===0?o.localStorage:o.sessionStorage)&&Ul(r.setItem)&&(r.setItem(i,i),e=r.getItem(i)!==i,r.removeItem(i),e&&(r=null))}catch{r=null}return r}function _1t(t,e,i){var r=gxe();if(r!==null)try{return r.setItem(e,i),!0}catch(o){o6=!1,xu(t,1,504,"Browser failed write to local storage. "+o)}return!1}function E1t(t,e){var i=gxe();if(i!==null)try{return i.getItem(e)}catch(r){o6=!1,xu(t,1,503,"Browser failed read of local storage. "+r)}return null}function A1t(){return this.getId()}function I1t(t){this.setId(t)}var fxe=function(){function t(){Yc(t,this,function(e){e.setId=function(i){e.customId=i},e.getId=function(){return Bm(e.customId)?e.customId:e.automaticId}})}return t._staticInit=void Jc(t.prototype,"id",{g:A1t,s:I1t}),t}(),vxe="ai_session",w1t=function(){function t(e,i,r){var o,l,d,h=kde(e),p=NOe(e);Yc(t,this,function(g){var f=jy(i,function(){d=i,g.config=d});function y(){var w=p.get(l());if(w&&Ul(w.split))T(w);else{var D=E1t(h,l());D&&T(D)}g.automaticSession.getId()||C()}function T(w){var D=g.automaticSession,F=w.split("|");F.length>0&&D.setId(F[0]);try{if(F.length>1){var x=+F[1];D.acquisitionDate=+new Date(x),D.acquisitionDate=D.acquisitionDate>0?D.acquisitionDate:0}if(F.length>2){var B=+F[2];D.renewalDate=+new Date(B),D.renewalDate=D.renewalDate>0?D.renewalDate:0}}catch(L){xu(h,1,510,"Error parsing ai_session cookie, session will be reset: "+L)}D.renewalDate===0&&xu(h,2,517,"AI session renewal date is 0, session will be reset.")}function C(){var w=g.automaticSession,D=new Date().getTime(),F=g.config.sessionAsGuid;!vd(F)&&F?Gx(F)?w.setId(w1e()):w.setId(w1e(F)):w.setId(bde(d.idLength||22)),w.acquisitionDate=D,w.renewalDate=D,E(w.getId(),w.acquisitionDate,w.renewalDate),pxe()||xu(h,2,505,"Browser does not support local storage. Session durations will be inaccurate.")}function E(w,D,F){var x=D+g.config.sessionExpirationMs,B=F+g.config.sessionRenewalMs,L=new Date,z=[w,D,F];x<B?L.setTime(x):L.setTime(B);var H=g.config.cookieDomain||null;p.set(l(),z.join("|")+";expires="+L.toUTCString(),null,H),o=new Date().getTime()}function I(w,D,F){_1t(h,l(),[w,D,F].join("|"))}r&&r.add(f),l=function(){return g.config.namePrefix?vxe+g.config.namePrefix:vxe},g.automaticSession=new fxe,g.update=function(){g.automaticSession.getId()||y();var w=g.automaticSession,D=g.config,F=new Date().getTime(),x=F-w.acquisitionDate>D.sessionExpirationMs,B=F-w.renewalDate>D.sessionRenewalMs;x||B?C():(!o||F-o>t.cookieUpdateInterval)&&(w.renewalDate=F,E(w.getId(),w.acquisitionDate,w.renewalDate))},g.backup=function(){var w=g.automaticSession;I(w.getId(),w.acquisitionDate,w.renewalDate)}})}return t.cookieUpdateInterval=6e4,t}(),the=["AX","EX","SF","CS","CF","CT","CU","DC","DF","H5","HL","WS","WP"];function yxe(t,e){e===void 0&&(e=the);var i=null;if(t)for(var r=t.split(","),o=0;o<r.length;o++)k1t(r[o],e)&&(i?i+=","+r[o]:i=r[o]);return i}function k1t(t,e){if(e===void 0&&(e=the),!t||t.length<4)return!1;for(var i=!1,r=256,o=t.substring(0,3).toString().toUpperCase(),l=0;l<e.length;l++)if(e[l]+":"===o&&t.length<=r){i=!0;break}return i}function R1t(){return this.getExpId()}var M1t=function(){function t(e,i,r){var o,l=null,d=the.slice(0),h="Treatments",p=null;Yc(t,this,function(g){if(I(e),sLe()){var f=GM().documentElement;f&&(g.locale=f.lang)}function y(w){var D,F={},x=GM();if(x){D=x&&x.querySelectorAll("meta");for(var B=0;B<D.length;B++){var L=D[B];L.name&&L.name.toLowerCase().indexOf(w)===0&&(F[L.name.replace(w,"")]=L.content)}}return F}function T(w){w!==l&&(l=yxe(w,d))}function C(){return T(c3(o,h)),l}function E(w){return T(w),l}function I(w){var D=jy(w,function(){o=i&&i.getCookieMgr(),p=w||{},g.env=p.env||y("awa-").env});r&&r.add(D)}g.getExpId=function(){return p.expId?E(p.expId):C()}})}return t.validateAppExpId=yxe,t._staticInit=void Jc(t.prototype,"expId",{g:R1t}),t}(),P1t=function(){function t(){}return t}(),D1t=function(){function t(){}return t}();function L1t(){return this.getMsfpc()}function O1t(){return this.getAnid()}var N1t=function(){function t(i,r,o){var l;Yc(t,this,function(d){function h(p){var g=jy(p,function(){l=r&&r.getCookieMgr();var f=p||{};f.serviceName&&(d.serviceName=f.serviceName)});o&&o.add(g)}h(i),d.getMsfpc=function(){return c3(l,"MSFPC")},d.getAnid=function(){return c3(l,"ANON").slice(0,34)}})}var e;return t._staticInit=(Jc(e=t.prototype,"msfpc",{g:L1t}),void Jc(e,"anid",{g:O1t})),t}(),x1t=function(){function t(){var e=new Date().getTimezoneOffset(),i=e%60,r=(e-i)/60,o="+";r>0&&(o="-"),r=Math.abs(r),i=Math.abs(i),this.tz=o+(r<10?"0"+r:r.toString())+":"+(i<10?"0"+i:i.toString())}return t}(),pO={WIN:/(windows|win32)/i,WINRT:/ arm;/i,WINPHONE:/windows\sphone\s\d+\.\d+/i,OSX:/(macintosh|mac os x)/i,IOS:/(ipad|iphone|ipod)(?=.*like mac os x)/i,LINUX:/(linux|joli|[kxln]?ubuntu|debian|[open]*suse|gentoo|arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk)/i,ANDROID:/android/i,CROS:/CrOS/i},Sxe={5.1:"XP","6.0":"Vista",6.1:"7",6.2:"8",6.3:"8.1","10.0":"10"},B1t="([\\d,.]+)",bxe="([\\d,_,.]+)",b3="Unknown",Txe=[{r:pO.WINPHONE,os:"Windows Phone"},{r:pO.WINRT,os:"Windows RT"},{r:pO.WIN,os:"Windows"},{r:pO.IOS,os:"iOS"},{r:pO.ANDROID,os:"Android"},{r:pO.LINUX,os:"Linux"},{r:pO.CROS,os:"Chrome OS"},{s:"x11",os:"Unix"},{s:"blackberry",os:"BlackBerry"},{s:"symbian",os:"Symbian"},{s:"nokia",os:"Nokia"},{r:pO.OSX,os:"Mac OS X"}];function F1t(t){for(var e=0;e<Txe.length;e++){var i=Txe[e];if(i.r&&t.match(i.r)||i.s&&t.indexOf(i.s)!==-1)return i.os}return b3}function U1t(t,e){return e==="Windows"?Cxe(t,"Windows NT"):e==="Android"?Cxe(t,e):e==="Mac OS X"?z1t(t):e==="iOS"?V1t(t):b3}function Cxe(t,e){var i=t.match(new RegExp(e+" "+B1t));return i?Sxe[i[1]]?Sxe[i[1]]:i[1]:b3}function z1t(t){var e=t.match(new RegExp("Mac OS X "+bxe));if(e){var i=e[1].replace(/_/g,".");if(i){var r=_xe(i);return r?i.split(r)[0]:i}}return b3}function V1t(t){var e=t.match(new RegExp("OS "+bxe));if(e){var i=e[1].replace(/_/g,".");if(i){var r=_xe(i);return r?i.split(r)[0]:i}}return b3}function _xe(t){return t.indexOf(".")>-1?".":t.indexOf("_")>-1?"_":null}var $1t=function(){function t(e,i){var r=this,o=null,l=null,d=null,h=null,p=function(C){d=C},g=function(C){h=C},f=function(){return d||o},y=function(){return h||l},T=jy(e,function(){if((e||{}).populateOperatingSystemInfo){var C=Kw()||{},E=e.userAgent||C.userAgent||"",I=(e.userAgentData||{}).platform||(C.userAgentData||{}).platform;if(E){var w=F1t(E.toLowerCase());o=w,l=U1t(E,w)}o&&o!==b3||!Bm(I)||(o=I)}});i&&i.add(T),Jc(r,"name",{s:p,g:f}),Jc(r,"ver",{s:g,g:y})}return t}(),ihe="MicrosoftApplicationsTelemetryDeviceId";function H1t(t,e,i,r){e?e.setProperty(i,r):t.set(i,r,31536e3)}function j1t(t,e,i){return e?e.getProperty(i)||"":c3(t,i)}var G1t=function(){function t(e,i,r){var o,l=0;Yc(t,this,function(d){d.seq=l,d.epoch=wj(!1).toString(),d.getSequenceId=function(){return++l};var h=jy(e,function(p){o=i&&i.getCookieMgr();var g=p.cfg.propertyStorageOverride;if(o.isEnabled()||g){var f=j1t(o,g,ihe);f||(f=VOe()),H1t(o,g,ihe,f),d.installId=f}else o.purge(ihe)});r&&r.add(h)})}return t.__ieDyn=1,t}(),q1t=function(){function t(e,i,r,o,l){var d=this;d.traceId=i||xde();var h=jy(e,function(){var p=e;if(p.enableDistributedTracing&&!r&&(r=xde().substring(0,16)),d.parentId=d.parentId||r,p.enableApplicationInsightsTrace&&!o){var g=GJ();g&&g.pathname&&(o=g.pathname)}d.name=d.name||o});l&&l.add(h)}return t}(),Exe="setLocalId";function W1t(){return this.getLocalId()}function K1t(t){this[Exe](t)}var J1t=function(){function t(e,i,r,o){var l,d,h;Yc(t,this,function(p){if(y(i),typeof navigator<"u"){var g=navigator;p.locale=g.userLanguage||g.language}function f(){if(!l.hashIdentifiers&&!l.dropIdentifiers){var T=c3(h,"MUID");T&&(d="t:"+T)}return d}function y(T){var C=jy(T,function(){if(h=r&&r.getCookieMgr(),l=T,d=null,h&&h.isEnabled()&&(f(),l.enableApplicationInsightsUser)){var E=c3(h,t.userCookieName);if(E){var I=E.split(t.cookieSeparator);I.length>0&&(p.id=I[0])}if(!p.id){p.id=bde(e&&!vd(e.idLength)?e.idLength:22);var w=mde(new Date);p.accountAcquisitionDate=w;var D=[p.id,w],F=l.cookieDomain?l.cookieDomain:void 0;h.set(t.userCookieName,D.join(t.cookieSeparator),31536e3,F)}}});o&&o.add(C)}p.getLocalId=function(){return d||f()},p[Exe]=function(T){d=T}})}return t.cookieSeparator="|",t.userCookieName="ai_user",t._staticInit=void Jc(t.prototype,"localId",{g:W1t,s:K1t}),t}(),Y1t=1048576,Q1t=2097152,Z1t=4194304,X1t=function(){function t(e,i){var r=this;r.popSample=100;var o=jy(e,function(){r.eventFlags=0,e.hashIdentifiers&&(r.eventFlags=r.eventFlags|Y1t),e.dropIdentifiers&&(r.eventFlags=r.eventFlags|Q1t),e.scrubIpOnly&&(r.eventFlags=r.eventFlags|Z1t)});i&&i.add(o)}return t}(),Axe=["Required","Analytics","SocialMedia","Advertising"],$Y="([\\d,.]+)",Ixe="Unknown",wxe="Edg/",kxe="EdgiOS/",nhe=[{ua:"OPR/",b:"Opera"},{ua:"PhantomJS",b:"PhantomJS"},{ua:"Edge",b:"Edge"},{ua:wxe,b:"Edge"},{ua:kxe,b:"Edge"},{ua:"Electron",b:"Electron"},{ua:"Chrome",b:"Chrome"},{ua:"Trident",b:"MSIE"},{ua:"MSIE ",b:"MSIE"},{ua:"Firefox",b:"Firefox"},{ua:"Safari",b:"Safari"},{ua:"SkypeShell",b:"SkypeShell"}],ahe=[{br:"Microsoft Edge",b:"Edge"},{br:"Google Chrome",b:"Chrome"},{br:"Opera",b:"Opera"}];function rhe(t,e){return e.indexOf(t)>-1}function eNt(t,e){for(var i=0;i<e.length;i++)if(t==e[i].brand)return e[i].version;return null}function tNt(t){if(t){for(var e=0;e<nhe.length;e++)if(rhe(nhe[e].ua,t))return nhe[e].b}return Ixe}function iNt(t,e){return e==="MSIE"?nNt(t):aNt(e,t)}function nNt(t){var e=t.match(new RegExp("MSIE "+$Y));if(e)return e[1];var i=t.match(new RegExp("rv:"+$Y));return i?i[1]:void 0}function aNt(t,e){t==="Safari"?t="Version":t==="Edge"&&(rhe(wxe,e)?t="Edg":rhe(kxe,e)&&(t="EdgiOS"));var i=e.match(new RegExp(t+"/"+$Y));return i||t==="Opera"&&(i=e.match(new RegExp("OPR/"+$Y)))?i[1]:Ixe}function rNt(){var t={h:0,w:0},e=QL();return e&&e.screen&&(t.h=screen.height,t.w=screen.width),t}function oNt(){return this.getUserConsent()}var sNt=function(){function t(e,i,r){NOe(i);var o=e||{},l=null,d=null,h=null,p=null,g=null,f=null,y=null;Yc(t,this,function(T){H(e);var C=GJ();if(C){var E=C.hostname;E&&(T.domain=C.protocol==="file:"?"local":E)}var I=rNt();function w(j,J){if(ds(J))try{for(var Z=0;Z<ahe.length;Z++){var re=eNt(ahe[Z].br,J);if(re)return g=ahe[Z].b,void(f=re)}}catch{}if(j){var ne=tNt(j);g=ne,f=iNt(j,ne)}}function D(j){h=j}function F(j){p=j}function x(){return h||g}function B(){return p||f}T.screenRes=I.w+"X"+I.h,T.getUserConsent=function(){return!1},T.getUserConsentDetails=function(){var j=null;try{var J=o.callback;if(J&&J.userConsentDetails){var Z=J.userConsentDetails();if(Z){j=o.disableConsentDetailsSanitize?Z:{};for(var re=0;re<Axe.length;re++){var ne=Axe[re];j[ne]=Z[ne]||!1}}}return y!==null&&((j=j||{}).GPC_DataSharingOptIn=!!y),j?JSON.stringify(j):null}catch{}};var L=function(){return y},z=function(j){y=Gx(j)?j:null,o.gpcDataSharingOptIn=y};function H(j){var J=jy(j,function(){if((o=j).populateBrowserInfo){var Z=o.userAgent,re=(o.userAgentData||{}).brands;if(Z!==l||re!==d){if(!Z||!re||re.length===0){var ne=Kw();ne&&(Z=Z||ne.userAgent||"",re=re||(ne.userAgentData||{}).brands)}w(Z,re),l=Z,d=re}}y=Gx(o.gpcDataSharingOptIn)?o.gpcDataSharingOptIn:null});r&&r.add(J)}Vkt(T,{userConsent:{g:T.getUserConsent},browser:{s:D,g:x},browserVer:{s:F,g:B},gpcDataSharingOptIn:{g:L,s:z}})})}return t._staticInit=void Jc(t.prototype,"userConsent",{g:oNt}),t}();function UC(t,e,i,r,o){var l=e.ext[FC[t]];if(l)try{nc(r,function(d,h){if(Bm(h)||HM(h)||Gx(h)){var p=l[i[d]];!o&&(p||Bm(p)||HM(p)||Gx(p))&&(h=p),l[i[d]]=h}})}catch{}return l}var HY,lNt=function(){function t(e,i,r,o){Yc(t,this,function(l){l.app=new M1t(i,r,o),l.cloud=new P1t,l.user=new J1t(e,i,r,o),l.os=new $1t(i,o),l.web=new sNt(i,r,o);var d=new G1t(e,r,o),h=new N1t(i,r,o),p=new X1t(i,o);l.loc=new x1t,l.device=new D1t;var g=new w1t(r,i,o);l.session=new fxe;var f=void 0,y=cNt(new q1t(i,f,f,f,o),E()),T=!(i||{}).eventContainExtFields;function C(){var I=l.session;if(I&&Bm(I.customId))return I.customId;g.update();var w=g.automaticSession;if(w){var D=w.getId();D&&Bm(D)&&(I.automaticId=D)}return I.automaticId}function E(){var I=y;return r&&r.getTraceCtx&&(I=r.getTraceCtx(!1)||y),I}l.getTraceCtx=function(){return y},l.getSessionId=C,l.applyApplicationContext=function(I){var w,D=l.app;UC(4,I,d1t,((w={})[0]=D.id,w[1]=D.ver,w[2]=D.name,w[3]=D.locale,w[4]=D.getExpId(),w[5]=D.env,w),T)},l.applyUserContext=function(I){var w,D=l.user;UC(0,I,h1t,((w={})[1]=D.getLocalId(),w[0]=D.locale,w[2]=D.id,w),T)},l.applyWebContext=function(I){var w,D=l.web;UC(3,I,u1t,((w={})[0]=D.domain,w[1]=D.browser,w[2]=D.browserVer,w[3]=D.screenRes,w[5]=D.getUserConsentDetails(),w[4]=!1,w),T)},l.applyOsContext=function(I){var w,D=l.os;UC(5,I,p1t,((w={})[0]=D.name,w[1]=D.ver,w),T)},l.applySdkContext=function(I){var w;UC(6,I,g1t,((w={})[2]=d.installId,w[1]=d.getSequenceId(),w[3]=d.epoch,w),T)},l.applyIntWebContext=function(I){var w;UC(7,I,m1t,((w={})[0]=h.getMsfpc(),w[1]=h.getAnid(),w[2]=h.serviceName,w),T)},l.applyUtcContext=function(I){var w,D=((w={})[0]=p.popSample,w);p.eventFlags>0&&(D[1]=p.eventFlags),UC(8,I,f1t,D,T)},l.applyLocContext=function(I){var w;UC(9,I,v1t,((w={})[0]=l.loc.tz,w),T)},l.applySessionContext=function(I){var w;UC(4,I,y1t,((w={})[0]=C(),w),T)},l.applyDeviceContext=function(I){var w,D=l.device;UC(1,I,S1t,((w={})[0]=D.localId,w[2]=D.make,w[3]=D.model,w[1]=D.deviceClass,w),T)},l.applyCloudContext=function(I){var w,D=l.cloud;UC(10,I,b1t,((w={})[0]=D.role,w[1]=D.roleInstance,w[2]=D.roleVer,w),T)},l.applyAITraceContext=function(I){var w;if(i.enableApplicationInsightsTrace){var D=E();D&&UC(2,I,T1t,((w={})[0]=D.getTraceId(),w[1]=D.getName(),w[2]=D.getSpanId(),w),!1)}},l.applyDistributedTraceContext=function(I){var w,D=E();if(D){var F=((w={})[0]=D.getTraceId(),w[1]=D.getSpanId(),w),x=D.getTraceFlags();pc(x)||(F[2]=x),UC(11,I,C1t,F,!1)}}})}return t.__ieDyn=1,t}();function cNt(t,e){var i=t||{};return{getName:function(){return i.name},setName:function(r){e&&e.setName(r),i.name=r},getTraceId:function(){return i.traceId},setTraceId:function(r){e&&e.setTraceId(r),HOe(r)&&(i.traceId=r)},getSpanId:function(){return i.parentId},setSpanId:function(r){e&&e.setSpanId(r),jOe(r)&&(i.parentId=r)},getTraceFlags:function(){return i.traceFlags},setTraceFlags:function(r){e&&e.setTraceFlags(r),i.traceFlags=r}}}var dNt=[FC[4],FC[0],FC[3],FC[5],FC[6],FC[7],FC[8],FC[9],FC[1],FC[2],FC[11],FC[10]],uNt=F5({populateBrowserInfo:!1,populateOperatingSystemInfo:!1,userAgent:bB(),userAgentData:uxe({brands:HY,mobile:HY,platform:HY}),userConsentCookieName:bB(),userConsented:!1,serviceName:bB(),env:bB(),expId:bB(),sessionRenewalMs:18e5,sessionExpirationMs:864e5,sessionAsGuid:null,cookieDomain:bB(),namePrefix:bB(),enableApplicationInsightsTrace:!1,enableApplicationInsightsUser:!1,hashIdentifiers:!1,dropIdentifiers:!1,scrubIpOnly:!1,callback:uxe({userConsentDetails:null}),gpcDataSharingOptIn:HY,idLength:22,enableDistributedTracing:!1,eventContainExtFields:!1}),hNt=function(t){function e(){var i,r,o,l=t.call(this)||this;return l.identifier="SystemPropertiesCollector",l.priority=3,l.version="4.3.2",Yc(e,l,function(d,h){function p(){i=null,r={}}function g(y){var T=d.identifier,C=d.core;d._addHook(jy(y,function(){var E=aB(null,y,C);o=E.getExtCfg(T,uNt)})),i=new lNt(y,o,C,d._unloadHooks),C&&C.setTraceCtx&&C.setTraceCtx(i.getTraceCtx())}function f(y,T){y&&nc(y,function(C,E){T[C]||(T[C]=E)})}p(),d.initialize=function(y,T,C){h.initialize(y,T,C),g(y)},d.processTelemetry=function(y,T){Qde(y,d.identifier),T=d._getTelCtx(T);var C=y.ext=y.ext?y.ext:{};y.data=y.data?y.data:{},Qa(dNt,function(E){C[E]=C[E]||{}}),i&&(i.applyUtcContext(y),i.applyApplicationContext(y),i.applyUserContext(y),i.applyWebContext(y),i.applyOsContext(y),i.applySdkContext(y),i.applyIntWebContext(y),i.applyLocContext(y),i.applySessionContext(y),i.applyDeviceContext(y),o.enableApplicationInsightsTrace&&i.applyAITraceContext(y),o.enableDistributedTracing&&i.applyDistributedTraceContext(y),i.applyCloudContext(y)),Qa(Ww(C),function(E){Ww(C[E]).length===0&&delete C[E]}),f(r,y.data),d.processNext(y,T)},d.getPropertiesContext=function(){return i},d.setProperty=function(y,T){r[y]=T},d._doTeardown=function(y,T){var C=(y||{}).core();if(C&&C.getTraceCtx&&i){var E=C.getTraceCtx(!1);E&&E===i.getTraceCtx()&&C.setTraceCtx(null)}p()},d._getDbgPlgTargets=function(){return[o]}}),l}return uj(e,t),e.__ieDyn=1,e}(zde);function ln(){return"xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g,t=>{const e=16*Math.random()|0;return(t==="x"?e:3&e|8).toString(16)})}const Rxe="Skype",ck={Public:"https://ic3.events.data.microsoft.com/OneCollector/1.0/",PublicEUDB:"https://eu-ic3.events.data.microsoft.com/OneCollector/1.0/",GccHigh:"https://tb.events.data.microsoft.com/OneCollector/1.0/",Dod:"https://pf.events.data.microsoft.com/OneCollector/1.0/",AirGap08:"https://collector.azure.eaglex.ic.gov/OneCollector/1.0/",AirGap09:"https://collector.azure.microsoft.scloud/OneCollector/1.0/",Enterprise:"https://teams.events.data.microsoft.com/OneCollector/1.0",EnterpriseEUDB:"https://eu-teams.events.data.microsoft.com/OneCollector/1.0"};var pl,zC;(function(t){t.Public="Public",t.GccHigh="GCCHigh",t.Dod="DoD",t.AirGap08="AirGap08",t.AirGap09="AirGap09"})(pl||(pl={})),function(t){t.OrgId="orgid",t.Acs="acs",t.Spool="spool",t.GccHigh="gcch",t.GccHighAcs="gcch-acs",t.Dod="dod",t.DodAcs="dod-acs",t.AirGap08="ag08",t.AirGap08Acs="ag08-acs",t.AirGap09="ag09",t.AirGap09Acs="ag09-acs"}(zC||(zC={}));const pNt={Public_EcsServer_Url:"https://ecs.communication.microsoft.com",GccHigh_EcsServer_Url:"https://config.ecs.gov.teams.microsoft.us",Dod_EcsServer_Url:"https://config.ecs.dod.teams.microsoft.us",AirGap08_EcsServer_Url:"https://config.ecs.teams.eaglex.ic.go",AirGap09_EcsServer_Url:"https://config.ecs.teams.microsoft.scloud",Enterprise_Ecs_ServerUrl:"https://config.teams.microsoft.com"},gNt={Public_ConversationServiceUrl:"https://api.flightproxy.skype.com/api/v2/cpconv",Public_TrouterServiceUrl:"https://go.trouter.communication.microsoft.com/v4/a",Public_RegistrarServiceUrl:"https://prod.registrar.skype.com/v3/registrations",Public_MdnTrapServiceUrl:"https://edge.skype.com/trap",Public_MdnTrapServiceTokenUrl:"https://edge.skype.com/trap/tokens",Public_MdnTrapRelaySkypeFqdns:"worldaz.tr.skype.com",Public_MdnTrapRelayTurnFqdns:"turn.azure.com",Public_MdnTrapRelayTurnUrl:"",GccHigh_ConversationServiceUrl:"https://api.cc.gov.teams.microsoft.us/conv/",GccHigh_TrouterServiceUrl:"https://go.trouter.gov.teams.microsoft.us/v4/a",GccHigh_RegistrarServiceUrl:"https://registrar.gov.teams.microsoft.us/v3/registrations",GccHigh_MdnTrapServiceUrl:"https://trap.gov.teams.microsoft.us",GccHigh_MdnTrapServiceTokenUrl:"https://trap.gov.teams.microsoft.us/tokens",GccHigh_MdnTrapRelaySkypeFqdns:"tr.gov.teams.microsoft.us",GccHigh_MdnTrapRelayTurnFqdns:"turn.gov.teams.microsoft.us",GccHigh_MdnTrapRelayTurnUrl:"https://turn.gov.teams.microsoft.us/relay",Dod_ConversationServiceUrl:"https://api.cc.dod.teams.microsoft.us/conv/",Dod_TrouterServiceUrl:"https://go.trouter.dod.teams.microsoft.us/v4/a",Dod_RegistrarServiceUrl:"https://registrar.dod.teams.microsoft.us/v3/registrations",Dod_MdnTrapServiceUrl:"https://trap.dod.teams.microsoft.us",Dod_MdnTrapServiceTokenUrl:"https://trap.dod.teams.microsoft.us/tokens",Dod_MdnTrapRelaySkypeFqdns:"tr.dod.teams.microsoft.us",Dod_MdnTrapRelayTurnFqdns:"turn.dod.teams.microsoft.us",Dod_MdnTrapRelayTurnUrl:"https://turn.dod.teams.microsoft.us/relay",AirGap08_ConversationServiceUrl:"https://api.cc.skype.com/conv/",AirGap08_TrouterServiceUrl:"https://go.trouter.teams.eaglex.ic.gov/v4/a",AirGap08_RegistrarServiceUrl:"https://api.registrar.teams.eaglex.ic.gov/v3/registrations",AirGap09_ConversationServiceUrl:"https://api.cc.skype.com/conv/",AirGap09_TrouterServiceUrl:"https://go.trouter.teams.microsoft.scloud/v4/a",AirGap09_RegistrarServiceUrl:"https://api.registrar.teams.microsoft.scloud/v3/registrations",Enterprise_ConversationServiceUrl:"https://api.flightproxy.teams.microsoft.com/api/v2/epconv",Enterprise_TrouterServiceUrl:"https://go.trouter.teams.microsoft.com/v4/a",Enterprise_RegistrarServiceUrl:"https://teams.microsoft.com/registrar/prod/v3/registrations",Enterprise_MdnTrapServiceUrl:"https://teams.microsoft.com/trap",Enterprise_MdnTrapServiceTokenUrl:"https://teams.microsoft.com/trap/tokens",Enterprise_MdnTrapRelaySkypeFqdns:"worldaz.relay.teams.microsoft.com",Enterprise_MdnTrapRelayTurnFqdns:"worldaz.relay.teams.microsoft.com",Enterprise_MdnTrapRelayTurnUrl:""};var Hf;(function(t){t.Public_ConversationServiceUrl_EUDB="https://api.flightproxy.skype.com/api/v2/cpconv",t.Public_TrouterServiceUrl_EUDB="https://go-eu.trouter.communication.microsoft.com/v4/a",t.Public_RegistrarServiceUrl_EUDB="https://emea.prod.registrar.skype.com/v3/registrations",t.Public_MdnTrapServiceUrl_EUDB="https://edge.skype.com/trap",t.Public_MdnTrapServiceTokenUrl_EUDB="https://edge.skype.com/trap/tokens",t.Public_MdnTrapRelaySkypeFqdns_EUDB="eu.relay.skype.com",t.Public_MdnTrapRelayTurnFqdns_EUDB="eu.relay.skype.com",t.Public_MdnTrapRelayTurnUrl_EUDB="",t.Enterprise_ConversationServiceUrl_EUDB="https://api.flightproxy.teams.microsoft.com/api/v2/epconv",t.Enterprise_TrouterServiceUrl_EUDB="https://go-eu.trouter.teams.microsoft.com/v4/a",t.Enterprise_RegistrarServiceUrl_EUDB="https://teams.microsoft.com/registrar/prod/v3/registrations",t.Enterprise_MdnTrapServiceUrl_EUDB="https://teams.microsoft.com/trap",t.Enterprise_MdnTrapServiceTokenUrl_EUDB="https://teams.microsoft.com/trap/tokens",t.Enterprise_MdnTrapRelaySkypeFqdns_EUDB="euaz.relay.teams.microsoft.com",t.Enterprise_MdnTrapRelayTurnFqdns_EUDB="euaz.relay.teams.microsoft.com",t.Enterprise_MdnTrapRelayTurnUrl_EUDB=""})(Hf||(Hf={}));const As={...gNt,...pNt},s6={baseServiceUrl:"https://global.mtgw.prod.communication.microsoft.com/",policyUrlSuffix:"acsmt/v1/useraggregatepolicysettings/",policyUrlSuffixV2:"acsmt/v2/useraggregatepolicysettings/",createThreadSuffix:"acsmt/v1/threads/",addParticipantSuffix:"acsmt/v1/addParticipantsToThread/"};var gT;(function(t){t.Consumer="consumer",t.Enterprise="enterprise"})(gT||(gT={}));const ohe=["europe","france","germany","norway","switzerland","sweden"],Mxe=["emea","fr","de","se"],Pxe=Array.from(new Set(ohe.concat(["qatar","uae","africa","uk"]))),Dxe=["asiapacific","india","japan","korea","australia"],Lxe=["unitedstates","brazil","canada"];var jY,dk;(function(t){t.EU="EU",t.RoW="RoW"})(jY||(jY={})),function(t){t.APAC="APAC",t.NOAM="NOAM",t.EMEA="EMEA",t.UNKNOWN=""}(dk||(dk={}));const mNt={AUDIO:{JITTER:{GOOD:30,AVERAGE:75},RTT:{GOOD:200,AVERAGE:350},PACKETS_LOSS_PERCENTAGE:{GOOD:3,AVERAGE:6}},VIDEO:{JITTER:{GOOD:20,AVERAGE:75},RTT:{GOOD:200,AVERAGE:350},PACKETS_LOSS_PERCENTAGE:{GOOD:3,AVERAGE:6}},BANDWIDTH:{GOOD:1500,AVERAGE:500},CALL:{DURATION_IN_SEC:30,GROUP_ID:ln(),AGGREGATION:{INTERVAL:1e3,DATAPOINTS:1},VIDEO_SIZE:{heigth:720,width:1280},MEDIASTREAM_TIMEOUT_IN_SEC:15,CONNECT_TIMEOUT_IN_SEC:10}};var RA;(function(t){t.AcsOrganizerRole="acsorganizer",t.AcsPresenterRole="acspresenter",t.AcsAttendeeRole="acsattendee",t.AcsConsumerRole="acsconsumer",t.AcsCollaboratorRole="acscollaborator",t.TeamsOrganizer="organizer",t.TeamsAttendee="attendee",t.TeamsPresenter="presenter",t.TeamsCoorganizer="coorganizer"})(RA||(RA={}));const fNt=["airpod","bluetooth","hands-free","stereo","wireless","citrix hdx","remote audio","vmware","built-in","integrated","internal","teams","high definition","facetime","macbook","smartaudio","front","rear","back","iphone","ipad","display","displayport","dp","hdmi","amd","nvidia","intel","analog","digital","dock","line( in| out)?","s/pdif","external","thunderbolt\\d*","usb","panoramic","desktop","capture","cable","cam","virtual","manycam","snap camera","obs","vb-audio","vaio","effect","sink","source","default","test"],vNt="28:9cd07db6-fab5-438c-8e34-44117fac7650",yNt="28:b102ccd8-1925-448b-90a7-b083aba25074";let SNt="3617";const T3=()=>SNt,bNt=2e3,TNt=5e4,CNt=3e4,Oxe=25e3,_Nt=6e3,ENt=5e3,ANt=1e3,INt=3,wNt="acs_broadcast_channel",kNt=5e3,RNt=500,MNt=!1,Nxe=500,PNt=512,DNt=0,LNt=.4,ONt=200,NNt=100,xNt=255,BNt=-127,FNt=6e3,UNt=2500,zNt=1500,VNt=5e3,$Nt=12,HNt=2e4,jNt=6e4,GY={WIDTH:0,HEIGHT:0},GNt=0,qNt=6e3,WNt=100,KNt=4,Wr="4cf9ed87f7dc4e148f77855cd1f2fdca-61fb83a7-6672-4264-806f-7aded29f9b49-7618",MA="53fdaa090eb946b5a1d6cbdeb4f2ef66-bcbf6380-2590-41cc-ae60-9e467cd51835-7413",gO="1cae5691997646c98b01d15beddae7a3-ce16e198-bc32-420f-ac64-42bb916111af-6865",JNt="5aea257f81424f5d8574e57a50974ead-d3a768ce-590c-4595-ab85-3dd046114290-6701",xxe="2efdf03d07594586a5977c404e185186-71b046c4-f48f-4ba7-96d3-2a74b54e1d46-7326",YNt="708a9eb9fe2646fe8f4c37b7eee2e3da-9b97485a-57b9-43a8-8177-07ca7a653a30-6706",QNt=7e3,ZNt=10,XNt=3,Bxe="28:8133db4c-c049-4346-9edd-273f164a9227",ext="28:b1902c3e-b9f7-4650-9b23-5772bd429747",Fxe="28:bdd75849-e0a6-4cce-8fc1-d7c0d4da43e5",Uxe="28:4b25d9f8-18f5-4d09-a582-cd0a28f63181",zxe="ACS-Public",txt="Teams-Public",she=["en-us"],ixt=["en"],nxt="en-us",axt=10,lhe="setLanguage",Vxe="mode",$xe="Transcription",rxt="RecordingAndTranscription",oxt="transcriptionModes",sxt="processingModes",Hxe=["closedCaptions"],lxt=["scheduledMeeting","adhocMeeting"],cxt=["28:f4693563-c70b-4e4d-bda6-01792aa21440","28:e32c9418-a835-4eb1-bfb9-733fa74dd6e8"],dxt=["28:5f2511f1-6da9-41d9-80d9-af7da23a2c27","28:accb0009-8d12-4cfe-969c-39b204e3ed0c"],uxt="tlePlayer",hxt=256,Gy="0.0",PA=!0,che=Symbol("global_telemetry_logger"),dhe=Symbol("global_call_client_index"),pxt=107,jxe="orgid",Gxe="dod",qxe="gcch",mO="8:",C3="28:",_3="4:",DA=":",qY="Unknown",gxt="ACSWeb",WY=mO+(jxe+DA),uhe=mO+(Gxe+DA),hhe=mO+(qxe+DA),phe=mO+("teamsvisitor"+DA),Wxe=mO+("acs"+DA),Kxe=mO+("spool"+DA),Jxe=mO+("dod-acs"+DA),Yxe=mO+("gcch-acs"+DA),KY=C3+(jxe+DA),ghe=C3+(qxe+DA),mhe=C3+(Gxe+DA),mxt={audioBitrate:{aggregation_needed:!1,raw_data_reduction:!0},videoBitrate:{aggregation_needed:!1,raw_data_reduction:!0},downloadBitrate:{aggregation_needed:!0,multiplier:8,integer:!0,calculation_method:"rate"},bufferLengthInMs:{aggregation_needed:!0},mediaDelayInMs:{aggregation_needed:!0,is_internal:!0},videoHeight:{aggregation_needed:!1,raw_data_reduction:!0},videoWidth:{aggregation_needed:!1,raw_data_reduction:!0},playerHeight:{aggregation_needed:!1,raw_data_reduction:!0,is_internal:!0},playerWidth:{aggregation_needed:!1,raw_data_reduction:!0,is_internal:!0},currentPlayPosition:{aggregation_needed:!1,raw_data_reduction:!0}};var zm,Dd;(function(t){t.GroupCall="joinGroupId",t.GroupChatCall="joinThreadId",t.TeamsCoordinates="joinMeetingCoordinates",t.TeamsMeetingId="joinMeetingId",t.TeamsMeetingLink="joinMeetingLink",t.RoomCall="joinRoom",t.Unknown="Unknown"})(zm||(zm={})),function(t){t.Organizer="Organizer",t.Coorganizer="Co-organizer",t.Attendee="Attendee",t.Presenter="Presenter",t.Consumer="Consumer",t.Collaborator="Collaborator",t.Unknown="Unknown"}(Dd||(Dd={}));const fxt={"msft-acs-room-deviceType":"room","msft-acs-3proom-deviceType":"3proom","msft-acs-mesh-deviceType":"mesh","msft-acs-mesh-deviceType-v2":"meshV2"};var aP,Bi;(function(t){t.onlyUsedProxy="onlyUsedProxy",t.onlyUsedNonMsftTurn="onlyUsedNonMsftTurn",t.usedProxyAndNonMsftTurn="usedProxyAndNonMsftTurn",t.noCustomProxyAndTurnUsed="noCustomProxyAndTurnUsed"})(aP||(aP={})),function(t){t.RoleRestricted="RoleRestricted",t.FeatureNotSupported="FeatureNotSupported",t.ClientRestricted="ClientRestricted",t.MeetingRestricted="MeetingRestricted",t.UserPolicyRestricted="UserPolicyRestricted",t.TeamsPremiumLicenseRestricted="TeamsPremiumLicenseRestricted",t.NotInitialized="NotInitialized",t.Capable="Capable",t.NotCapable="NotCapable",t.CapabilityNotApplicableForTheCallType="CapabilityNotApplicableForTheCallType",t.IpModeUserPolicyRestricted="IpModeUserPolicyRestricted",t.ExplicitConsentRequired="ExplicitConsentRequired"}(Bi||(Bi={}));const cg="roomsRoleBasedCapabilities",Ip="teamsRoleBasedCapabilities",vxt=/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,yxt=/(\:[0-9]{1,6})(?=$|\/|\?)/;var l6,JY;(function(t){t.TeamsProMgmt="TeamsProMgmt"})(l6||(l6={})),function(t){t.Disabled="Disabled",t.DisabledUserOverride="DisabledUserOverride"}(JY||(JY={}));const Qxe={Unknown:"Unknown",UsbCamera:"UsbCamera",CaptureAdapter:"CaptureAdapter",Virtual:"Virtual",ScreenSharing:"ScreenSharing"};var wp;function zr(t){const e=Ap(t);switch(e.kind){case wp.communicationUser:return e.communicationUserId;case wp.phoneNumber:if(e.rawId)return`${e.rawId}`;if(e.phoneNumber)return`${_3}${e.phoneNumber}`;throw new Oe({defaultError:we.IDENTIFIER.PARSE_PHONENUMBER});case wp.microsoftTeamsUser:if(e.rawId)return e.rawId;if(e.microsoftTeamsUserId){if(e.isAnonymous)return`${phe}${e.microsoftTeamsUserId}`;if(e.cloud==="public")return`${WY}${e.microsoftTeamsUserId}`;if(e.cloud==="dod")return`${uhe}${e.microsoftTeamsUserId}`;if(e.cloud==="gcch")return`${hhe}${e.microsoftTeamsUserId}`;if(!e.cloud)return`${WY}${e.microsoftTeamsUserId}`}throw new Oe({defaultError:we.IDENTIFIER.PARSE_MSFT_TEAMS_USER});case wp.microsoftTeamsApp:if(e.rawId)return e.rawId;if(e.teamsAppId){if(e.cloud==="public")return`${KY}${e.teamsAppId}`;if(e.cloud==="dod")return`${mhe}${e.teamsAppId}`;if(e.cloud==="gcch")return`${ghe}${e.teamsAppId}`;if(!e.cloud)return`${KY}${e.teamsAppId}`}throw new Oe({defaultError:we.IDENTIFIER.PARSE_MSFT_TEAMS_APP});case"unknown":return e.id;default:throw new Oe({defaultError:we.IDENTIFIER.PARSE_IDENTIFIER})}}function Sl(t){return t.startsWith(WY)?{kind:wp.microsoftTeamsUser,rawId:t,microsoftTeamsUserId:t.substring(8),isAnonymous:!1,cloud:"public"}:t.startsWith(uhe)?{kind:wp.microsoftTeamsUser,rawId:t,microsoftTeamsUserId:t.substring(6),isAnonymous:!1,cloud:"dod"}:t.startsWith(hhe)?{kind:wp.microsoftTeamsUser,rawId:t,microsoftTeamsUserId:t.substring(7),isAnonymous:!1,cloud:"gcch"}:t.startsWith(phe)?{kind:wp.microsoftTeamsUser,rawId:t,microsoftTeamsUserId:t.substring(15),isAnonymous:!0}:t.startsWith(_3)?{kind:wp.phoneNumber,rawId:t,phoneNumber:t.substring(2)}:t.startsWith(Wxe)||t.startsWith(Kxe)||t.startsWith(Yxe)||t.startsWith(Jxe)?{kind:wp.communicationUser,communicationUserId:t}:t.startsWith(KY)?{kind:wp.microsoftTeamsApp,rawId:t,teamsAppId:t.substring(9),cloud:"public"}:t.startsWith(ghe)?{kind:wp.microsoftTeamsApp,rawId:t,teamsAppId:t.substring(8),cloud:"gcch"}:t.startsWith(mhe)?{kind:wp.microsoftTeamsApp,rawId:t,teamsAppId:t.substring(7),cloud:"dod"}:{kind:wp.unknown,id:t}}function fO(t){return!!t.startsWith(C3)}function Sxt(t){return!(!t.startsWith(C3)||t.startsWith(KY)||t.startsWith(mhe)||t.startsWith(ghe))}function LA(t){const e=Ap(t);switch(e.kind){case wp.communicationUser:if(!(e.communicationUserId.startsWith(Wxe)||e.communicationUserId.startsWith(Kxe)||e.communicationUserId.startsWith(Yxe)||e.communicationUserId.startsWith(Jxe)))throw new Oe({defaultError:we.IDENTIFIER.INVALID_COMM_USER});return e;case"phoneNumber":return e;case wp.microsoftTeamsUser:if(e.rawId&&!e.rawId.startsWith(WY)&&!e.rawId.startsWith(uhe)&&!e.rawId.startsWith(hhe)&&!e.rawId.startsWith(phe))throw new Oe({defaultError:we.IDENTIFIER.INVALID_MSFT_TEAMS_USER_RAWID});if(!e.microsoftTeamsUserId)throw new Oe({defaultError:we.IDENTIFIER.INVALID_MSFT_TEAMS_USER_USERID});return e;case wp.microsoftTeamsApp:if(e.rawId&&!e.rawId.startsWith(C3))throw new Oe({defaultError:we.IDENTIFIER.INVALID_MSFT_TEAMS_APP_RAWID});if(!e.teamsAppId)throw new Oe({defaultError:we.IDENTIFIER.INVALID_MSFT_TEAMS_APP_APPID});return e;case wp.unknown:if(!e.id)throw new Oe({defaultError:we.IDENTIFIER.INVALID_UNKNOWN_IDENTIFIER});return e;default:throw new Oe({defaultError:we.IDENTIFIER.PARSE_INVALID_IDENTIFIER})}}function bxt(t){if(!(t instanceof Array))throw new Oe({defaultError:we.IDENTIFIER.INVALID_IDENTIFIER_ARRAY})}function Txt(t){const e=t.substring(0,t.indexOf(":"));if(!e)throw new Oe({defaultError:we.IDENTIFIER.NO_CLOUD_PREFIX_FOUND});switch(e){case zC.OrgId:case zC.Acs:case zC.Spool:return pl.Public;case zC.GccHigh:case zC.GccHighAcs:return pl.GccHigh;case zC.Dod:case zC.DodAcs:return pl.Dod;case zC.AirGap08:case zC.AirGap08Acs:return pl.AirGap08;case zC.AirGap09:case zC.AirGap09Acs:return pl.AirGap09;default:return pl.Public}}(function(t){t.communicationUser="communicationUser",t.microsoftTeamsUser="microsoftTeamsUser",t.microsoftTeamsApp="microsoftTeamsApp",t.phoneNumber="phoneNumber",t.unknown="unknown",t.group="group"})(wp||(wp={}));const Zxe="1.34.1.0_stable",Xxe="1.34.1";function E3(){const t="ACS_CLIENT_INTERNAL_SZK_VERSION".replace("Z","D");return Zxe===t?"1.0.0.0":Zxe}function uk(){const t="ACS_CLIENT_SZK_VERSION".replace("Z","D");return Xxe===t?"1.0.0.0":Xxe}var dn=bs(function(t,e){(function(){var i,r="4.17.21",o=200,l="Unsupported core-js use. Try https://npms.io/search?q=ponyfill.",d="Expected a function",h="Invalid `variable` option passed into `_.template`",p="__lodash_hash_undefined__",g=500,f="__lodash_placeholder__",y=1,T=2,C=4,E=1,I=2,w=1,D=2,F=4,x=8,B=16,L=32,z=64,H=128,j=256,J=512,Z=30,re="...",ne=800,le=16,he=1,Me=2,Le=3,pe=1/0,te=9007199254740991,Se=17976931348623157e292,ce=NaN,X=4294967295,ve=X-1,Te=X>>>1,Be=[["ary",H],["bind",w],["bindKey",D],["curry",x],["curryRight",B],["flip",J],["partial",L],["partialRight",z],["rearg",j]],qe="[object Arguments]",Ge="[object Array]",tt="[object AsyncFunction]",ct="[object Boolean]",Mt="[object Date]",ht="[object DOMException]",vt="[object Error]",Pt="[object Function]",ni="[object GeneratorFunction]",Zt="[object Map]",it="[object Number]",Ke="[object Null]",ot="[object Object]",Ht="[object Promise]",jt="[object Proxy]",Nt="[object RegExp]",Vt="[object Set]",$t="[object String]",dt="[object Symbol]",yt="[object Undefined]",kt="[object WeakMap]",je="[object WeakSet]",Ae="[object ArrayBuffer]",xe="[object DataView]",gt="[object Float32Array]",Ye="[object Float64Array]",Fe="[object Int8Array]",St="[object Int16Array]",Wt="[object Int32Array]",Ii="[object Uint8Array]",en="[object Uint8ClampedArray]",sn="[object Uint16Array]",Qi="[object Uint32Array]",qt=/\b__p \+= '';/g,ri=/\b(__p \+=) '' \+/g,Ti=/(__e\(.*?\)|\b__t\)) \+\n'';/g,rn=/&(?:amp|lt|gt|quot|#39);/g,Hn=/[&<>"']/g,ha=RegExp(rn.source),hr=RegExp(Hn.source),yn=/<%-([\s\S]+?)%>/g,pr=/<%([\s\S]+?)%>/g,Ho=/<%=([\s\S]+?)%>/g,Rr=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,La=/^\w*$/,us=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,al=/[\\^$.*+?()[\]{}|]/g,Us=RegExp(al.source),$r=/^\s+/,Zd=/\s/,rc=/\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,Yl=/\{\n\/\* \[wrapped with (.+)\] \*/,ci=/,? & /,Ai=/[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,pn=/[()=,{}\[\]\/\s]/,Bn=/\\(\\)?/g,Pa=/\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,qa=/\w*$/,kr=/^[-+]0x[0-9a-f]+$/i,Sa=/^0b[01]+$/i,aa=/^\[object .+?Constructor\]$/,ti=/^0o[0-7]+$/i,on=/^(?:0|[1-9]\d*)$/,Fn=/[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,Or=/($^)/,Co=/['\n\r\u2028\u2029\\]/g,za="\\ud800-\\udfff",Za="\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff",ns="\\u2700-\\u27bf",Uu="a-z\\xdf-\\xf6\\xf8-\\xff",ml="A-Z\\xc0-\\xd6\\xd8-\\xde",Cu="\\ufe0e\\ufe0f",Xd="\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",Il="['’]",Pp="["+za+"]",as="["+Xd+"]",td="["+Za+"]",YA="\\d+",bl="["+ns+"]",rl="["+Uu+"]",db="[^"+za+Xd+YA+ns+Uu+ml+"]",Dp="\\ud83c[\\udffb-\\udfff]",Zf="[^"+za+"]",im="(?:\\ud83c[\\udde6-\\uddff]){2}",Ld="[\\ud800-\\udbff][\\udc00-\\udfff]",Xo="["+ml+"]",Qh="\\u200d",jo="(?:"+rl+"|"+db+")",ZE="(?:"+Xo+"|"+db+")",Zh="(?:"+Il+"(?:d|ll|m|re|s|t|ve))?",Kv="(?:"+Il+"(?:D|LL|M|RE|S|T|VE))?",iS="(?:"+td+"|"+Dp+")?",fl="["+Cu+"]?",i_="\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])",ol="\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])",Xh=fl+iS+("(?:"+Qh+"(?:"+[Zf,im,Ld].join("|")+")"+fl+iS+")*"),ch="(?:"+[bl,im,Ld].join("|")+")"+Xh,Do="(?:"+[Zf+td+"?",td,im,Ld,Pp].join("|")+")",sl=RegExp(Il,"g"),zu=RegExp(td,"g"),jm=RegExp(Dp+"(?="+Dp+")|"+Do+Xh,"g"),Od=RegExp([Xo+"?"+rl+"+"+Zh+"(?="+[as,Xo,"$"].join("|")+")",ZE+"+"+Kv+"(?="+[as,Xo+jo,"$"].join("|")+")",Xo+"?"+jo+"+"+Zh,Xo+"+"+Kv,ol,i_,YA,ch].join("|"),"g"),nS=RegExp("["+Qh+za+Za+Cu+"]"),yo=/[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,oc=["Array","Buffer","DataView","Date","Error","Float32Array","Float64Array","Function","Int8Array","Int16Array","Int32Array","Map","Math","Object","Promise","RegExp","Set","String","Symbol","TypeError","Uint8Array","Uint8ClampedArray","Uint16Array","Uint32Array","WeakMap","_","clearTimeout","isFinite","parseInt","setTimeout"],ub=-1,Go={};Go[gt]=Go[Ye]=Go[Fe]=Go[St]=Go[Wt]=Go[Ii]=Go[en]=Go[sn]=Go[Qi]=!0,Go[qe]=Go[Ge]=Go[Ae]=Go[ct]=Go[xe]=Go[Mt]=Go[vt]=Go[Pt]=Go[Zt]=Go[it]=Go[ot]=Go[Nt]=Go[Vt]=Go[$t]=Go[kt]=!1;var So={};So[qe]=So[Ge]=So[Ae]=So[xe]=So[ct]=So[Mt]=So[gt]=So[Ye]=So[Fe]=So[St]=So[Wt]=So[Zt]=So[it]=So[ot]=So[Nt]=So[Vt]=So[$t]=So[dt]=So[Ii]=So[en]=So[sn]=So[Qi]=!0,So[vt]=So[Pt]=So[kt]=!1;var Xf={À:"A",Á:"A",Â:"A",Ã:"A",Ä:"A",Å:"A",à:"a",á:"a",â:"a",ã:"a",ä:"a",å:"a",Ç:"C",ç:"c",Ð:"D",ð:"d",È:"E",É:"E",Ê:"E",Ë:"E",è:"e",é:"e",ê:"e",ë:"e",Ì:"I",Í:"I",Î:"I",Ï:"I",ì:"i",í:"i",î:"i",ï:"i",Ñ:"N",ñ:"n",Ò:"O",Ó:"O",Ô:"O",Õ:"O",Ö:"O",Ø:"O",ò:"o",ó:"o",ô:"o",õ:"o",ö:"o",ø:"o",Ù:"U",Ú:"U",Û:"U",Ü:"U",ù:"u",ú:"u",û:"u",ü:"u",Ý:"Y",ý:"y",ÿ:"y",Æ:"Ae",æ:"ae",Þ:"Th",þ:"th",ß:"ss",Ā:"A",Ă:"A",Ą:"A",ā:"a",ă:"a",ą:"a",Ć:"C",Ĉ:"C",Ċ:"C",Č:"C",ć:"c",ĉ:"c",ċ:"c",č:"c",Ď:"D",Đ:"D",ď:"d",đ:"d",Ē:"E",Ĕ:"E",Ė:"E",Ę:"E",Ě:"E",ē:"e",ĕ:"e",ė:"e",ę:"e",ě:"e",Ĝ:"G",Ğ:"G",Ġ:"G",Ģ:"G",ĝ:"g",ğ:"g",ġ:"g",ģ:"g",Ĥ:"H",Ħ:"H",ĥ:"h",ħ:"h",Ĩ:"I",Ī:"I",Ĭ:"I",Į:"I",İ:"I",ĩ:"i",ī:"i",ĭ:"i",į:"i",ı:"i",Ĵ:"J",ĵ:"j",Ķ:"K",ķ:"k",ĸ:"k",Ĺ:"L",Ļ:"L",Ľ:"L",Ŀ:"L",Ł:"L",ĺ:"l",ļ:"l",ľ:"l",ŀ:"l",ł:"l",Ń:"N",Ņ:"N",Ň:"N",Ŋ:"N",ń:"n",ņ:"n",ň:"n",ŋ:"n",Ō:"O",Ŏ:"O",Ő:"O",ō:"o",ŏ:"o",ő:"o",Ŕ:"R",Ŗ:"R",Ř:"R",ŕ:"r",ŗ:"r",ř:"r",Ś:"S",Ŝ:"S",Ş:"S",Š:"S",ś:"s",ŝ:"s",ş:"s",š:"s",Ţ:"T",Ť:"T",Ŧ:"T",ţ:"t",ť:"t",ŧ:"t",Ũ:"U",Ū:"U",Ŭ:"U",Ů:"U",Ű:"U",Ų:"U",ũ:"u",ū:"u",ŭ:"u",ů:"u",ű:"u",ų:"u",Ŵ:"W",ŵ:"w",Ŷ:"Y",ŷ:"y",Ÿ:"Y",Ź:"Z",Ż:"Z",Ž:"Z",ź:"z",ż:"z",ž:"z",Ĳ:"IJ",ĳ:"ij",Œ:"Oe",œ:"oe",ŉ:"'n",ſ:"s"},zs={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"},mg={"&amp;":"&","&lt;":"<","&gt;":">","&quot;":'"',"&#39;":"'"},fg={"\\":"\\","'":"'","\n":"n","\r":"r","\u2028":"u2028","\u2029":"u2029"},hb=parseFloat,n_=parseInt,Lk=typeof fo=="object"&&fo&&fo.Object===Object&&fo,Gm=typeof self=="object"&&self&&self.Object===Object&&self,Os=Lk||Gm||Function("return this")(),dh=e&&!e.nodeType&&e,bd=dh&&t&&!t.nodeType&&t,pb=bd&&bd.exports===dh,bT=pb&&Lk.process,uh=function(){try{var Oi=bd&&bd.require&&bd.require("util").types;return Oi||bT&&bT.binding&&bT.binding("util")}catch{}}(),TT=uh&&uh.isArrayBuffer,a_=uh&&uh.isDate,gb=uh&&uh.isMap,qm=uh&&uh.isRegExp,st=uh&&uh.isSet,di=uh&&uh.isTypedArray;function Gi(Oi,gn,Tn){switch(Tn.length){case 0:return Oi.call(gn);case 1:return Oi.call(gn,Tn[0]);case 2:return Oi.call(gn,Tn[0],Tn[1]);case 3:return Oi.call(gn,Tn[0],Tn[1],Tn[2])}return Oi.apply(gn,Tn)}function un(Oi,gn,Tn,Aa){for(var ko=-1,vl=Oi==null?0:Oi.length;++ko<vl;){var tp=Oi[ko];gn(Aa,tp,Tn(tp),Oi)}return Aa}function jn(Oi,gn){for(var Tn=-1,Aa=Oi==null?0:Oi.length;++Tn<Aa&&gn(Oi[Tn],Tn,Oi)!==!1;);return Oi}function no(Oi,gn){for(var Tn=Oi==null?0:Oi.length;Tn--&&gn(Oi[Tn],Tn,Oi)!==!1;);return Oi}function Oa(Oi,gn){for(var Tn=-1,Aa=Oi==null?0:Oi.length;++Tn<Aa;)if(!gn(Oi[Tn],Tn,Oi))return!1;return!0}function Nr(Oi,gn){for(var Tn=-1,Aa=Oi==null?0:Oi.length,ko=0,vl=[];++Tn<Aa;){var tp=Oi[Tn];gn(tp,Tn,Oi)&&(vl[ko++]=tp)}return vl}function go(Oi,gn){return!!(Oi!=null&&Oi.length)&&nm(Oi,gn,0)>-1}function _s(Oi,gn,Tn){for(var Aa=-1,ko=Oi==null?0:Oi.length;++Aa<ko;)if(Tn(gn,Oi[Aa]))return!0;return!1}function _o(Oi,gn){for(var Tn=-1,Aa=Oi==null?0:Oi.length,ko=Array(Aa);++Tn<Aa;)ko[Tn]=gn(Oi[Tn],Tn,Oi);return ko}function Ks(Oi,gn){for(var Tn=-1,Aa=gn.length,ko=Oi.length;++Tn<Aa;)Oi[ko+Tn]=gn[Tn];return Oi}function Ko(Oi,gn,Tn,Aa){var ko=-1,vl=Oi==null?0:Oi.length;for(Aa&&vl&&(Tn=Oi[++ko]);++ko<vl;)Tn=gn(Tn,Oi[ko],ko,Oi);return Tn}function Ql(Oi,gn,Tn,Aa){var ko=Oi==null?0:Oi.length;for(Aa&&ko&&(Tn=Oi[--ko]);ko--;)Tn=gn(Tn,Oi[ko],ko,Oi);return Tn}function hs(Oi,gn){for(var Tn=-1,Aa=Oi==null?0:Oi.length;++Tn<Aa;)if(gn(Oi[Tn],Tn,Oi))return!0;return!1}var mb=e0("length");function QA(Oi){return Oi.split("")}function Jv(Oi){return Oi.match(Ai)||[]}function XE(Oi,gn,Tn){var Aa;return Tn(Oi,function(ko,vl,tp){if(gn(ko,vl,tp))return Aa=vl,!1}),Aa}function aS(Oi,gn,Tn,Aa){for(var ko=Oi.length,vl=Tn+(Aa?1:-1);Aa?vl--:++vl<ko;)if(gn(Oi[vl],vl,Oi))return vl;return-1}function nm(Oi,gn,Tn){return gn==gn?Va(Oi,gn,Tn):aS(Oi,Wm,Tn)}function Ok(Oi,gn,Tn,Aa){for(var ko=Tn-1,vl=Oi.length;++ko<vl;)if(Aa(Oi[ko],gn))return ko;return-1}function Wm(Oi){return Oi!=Oi}function r_(Oi,gn){var Tn=Oi==null?0:Oi.length;return Tn?Nk(Oi,gn)/Tn:ce}function e0(Oi){return function(gn){return gn==null?i:gn[Oi]}}function CT(Oi){return function(gn){return Oi==null?i:Oi[gn]}}function _T(Oi,gn,Tn,Aa,ko){return ko(Oi,function(vl,tp,eu){Tn=Aa?(Aa=!1,vl):gn(Tn,vl,tp,eu)}),Tn}function Vu(Oi,gn){var Tn=Oi.length;for(Oi.sort(gn);Tn--;)Oi[Tn]=Oi[Tn].value;return Oi}function Nk(Oi,gn){for(var Tn,Aa=-1,ko=Oi.length;++Aa<ko;){var vl=gn(Oi[Aa]);vl!==i&&(Tn=Tn===i?vl:Tn+vl)}return Tn}function hh(Oi,gn){for(var Tn=-1,Aa=Array(Oi);++Tn<Oi;)Aa[Tn]=gn(Tn);return Aa}function wP(Oi,gn){return _o(gn,function(Tn){return[Tn,Oi[Tn]]})}function ev(Oi){return Oi&&Oi.slice(0,ZA(Oi)+1).replace($r,"")}function vg(Oi){return function(gn){return Oi(gn)}}function fb(Oi,gn){return _o(gn,function(Tn){return Oi[Tn]})}function o_(Oi,gn){return Oi.has(gn)}function ET(Oi,gn){for(var Tn=-1,Aa=Oi.length;++Tn<Aa&&nm(gn,Oi[Tn],0)>-1;);return Tn}function Yv(Oi,gn){for(var Tn=Oi.length;Tn--&&nm(gn,Oi[Tn],0)>-1;);return Tn}function am(Oi,gn){for(var Tn=Oi.length,Aa=0;Tn--;)Oi[Tn]===gn&&++Aa;return Aa}var tv=CT(Xf),$u=CT(zs);function vb(Oi){return"\\"+fg[Oi]}function kP(Oi,gn){return Oi==null?i:Oi[gn]}function rm(Oi){return nS.test(Oi)}function yb(Oi){return yo.test(Oi)}function s_(Oi){for(var gn,Tn=[];!(gn=Oi.next()).done;)Tn.push(gn.value);return Tn}function t0(Oi){var gn=-1,Tn=Array(Oi.size);return Oi.forEach(function(Aa,ko){Tn[++gn]=[ko,Aa]}),Tn}function RP(Oi,gn){return function(Tn){return Oi(gn(Tn))}}function iv(Oi,gn){for(var Tn=-1,Aa=Oi.length,ko=0,vl=[];++Tn<Aa;){var tp=Oi[Tn];tp!==gn&&tp!==f||(Oi[Tn]=f,vl[ko++]=Tn)}return vl}function rS(Oi){var gn=-1,Tn=Array(Oi.size);return Oi.forEach(function(Aa){Tn[++gn]=Aa}),Tn}function oS(Oi){var gn=-1,Tn=Array(Oi.size);return Oi.forEach(function(Aa){Tn[++gn]=[Aa,Aa]}),Tn}function Va(Oi,gn,Tn){for(var Aa=Tn-1,ko=Oi.length;++Aa<ko;)if(Oi[Aa]===gn)return Aa;return-1}function om(Oi,gn,Tn){for(var Aa=Tn+1;Aa--;)if(Oi[Aa]===gn)return Aa;return Aa}function AT(Oi){return rm(Oi)?ep(Oi):mb(Oi)}function Qv(Oi){return rm(Oi)?l_(Oi):QA(Oi)}function ZA(Oi){for(var gn=Oi.length;gn--&&Zd.test(Oi.charAt(gn)););return gn}var MP=CT(mg);function ep(Oi){for(var gn=jm.lastIndex=0;jm.test(Oi);)++gn;return gn}function l_(Oi){return Oi.match(jm)||[]}function PP(Oi){return Oi.match(Od)||[]}var XA=function Oi(gn){var Tn,Aa=(gn=gn==null?Os:c_.defaults(Os.Object(),gn,c_.pick(Os,oc))).Array,ko=gn.Date,vl=gn.Error,tp=gn.Function,eu=gn.Math,Js=gn.Object,xk=gn.RegExp,WO=gn.String,tu=gn.TypeError,sS=Aa.prototype,DP=tp.prototype,Sb=Js.prototype,Zv=gn["__core-js_shared__"],IT=DP.toString,Vl=Sb.hasOwnProperty,i0=0,LP=(Tn=/[^.]+$/.exec(Zv&&Zv.keys&&Zv.keys.IE_PROTO||""))?"Symbol(src)_1."+Tn:"",bb=Sb.toString,Bk=IT.call(Js),eI=Os._,OP=xk("^"+IT.call(Vl).replace(al,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$"),n0=pb?gn.Buffer:i,Xv=gn.Symbol,Km=gn.Uint8Array,Td=n0?n0.allocUnsafe:i,a0=RP(Js.getPrototypeOf,Js),d_=Js.create,tI=Sb.propertyIsEnumerable,u_=sS.splice,NP=Xv?Xv.isConcatSpreadable:i,r0=Xv?Xv.iterator:i,ey=Xv?Xv.toStringTag:i,nv=function(){try{var O=gy(Js,"defineProperty");return O({},"",{}),O}catch{}}(),av=gn.clearTimeout!==Os.clearTimeout&&gn.clearTimeout,xP=ko&&ko.now!==Os.Date.now&&ko.now,lS=gn.setTimeout!==Os.setTimeout&&gn.setTimeout,Fk=eu.ceil,iI=eu.floor,_u=Js.getOwnPropertySymbols,Uk=n0?n0.isBuffer:i,wT=gn.isFinite,yg=sS.join,wl=RP(Js.keys,Js),id=eu.max,Eu=eu.min,ty=ko.now,KO=gn.parseInt,h_=eu.random,cS=sS.reverse,kT=gy(gn,"DataView"),Jm=gy(gn,"Map"),o0=gy(gn,"Promise"),dS=gy(gn,"Set"),s0=gy(gn,"WeakMap"),RT=gy(Js,"create"),uS=s0&&new s0,Sg={},p_=fy(kT),iy=fy(Jm),nI=fy(o0),aI=fy(dS),rI=fy(s0),MT=Xv?Xv.prototype:i,rv=MT?MT.valueOf:i,ny=MT?MT.toString:i;function Tt(O){if(cu(O)&&!Yo(O)&&!(O instanceof Lo)){if(O instanceof ph)return O;if(Vl.call(O,"__wrapped__"))return Hp(O)}return new ph(O)}var ip=function(){function O(){}return function(q){if(!Oc(q))return{};if(d_)return d_(q);O.prototype=q;var fe=new O;return O.prototype=i,fe}}();function PT(){}function ph(O,q){this.__wrapped__=O,this.__actions__=[],this.__chain__=!!q,this.__index__=0,this.__values__=i}function Lo(O){this.__wrapped__=O,this.__actions__=[],this.__dir__=1,this.__filtered__=!1,this.__iteratees__=[],this.__takeCount__=X,this.__views__=[]}function oI(){var O=new Lo(this.__wrapped__);return O.__actions__=Gu(this.__actions__),O.__dir__=this.__dir__,O.__filtered__=this.__filtered__,O.__iteratees__=Gu(this.__iteratees__),O.__takeCount__=this.__takeCount__,O.__views__=Gu(this.__views__),O}function Tb(){if(this.__filtered__){var O=new Lo(this);O.__dir__=-1,O.__filtered__=!0}else(O=this.clone()).__dir__*=-1;return O}function sI(){var O=this.__wrapped__.value(),q=this.__dir__,fe=Yo(O),$e=q<0,ut=fe?O.length:0,Dt=FP(0,ut,this.__views__),si=Dt.start,Ei=Dt.end,Ui=Ei-si,Nn=$e?Ei:si-1,Pn=this.__iteratees__,Yn=Pn.length,Wa=0,_r=Eu(Ui,this.__takeCount__);if(!fe||!$e&&ut==Ui&&_r==Ui)return uy(O,this.__actions__);var bo=[];e:for(;Ui--&&Wa<_r;){for(var Qo=-1,Oo=O[Nn+=q];++Qo<Yn;){var ec=Pn[Qo],dl=ec.iteratee,Jp=ec.type,Ay=dl(Oo);if(Jp==Me)Oo=Ay;else if(!Ay){if(Jp==he)continue e;break e}}bo[Wa++]=Oo}return bo}function ov(O){var q=-1,fe=O==null?0:O.length;for(this.clear();++q<fe;){var $e=O[q];this.set($e[0],$e[1])}}function SF(){this.__data__=RT?RT(null):{},this.size=0}function Cb(O){var q=this.has(O)&&delete this.__data__[O];return this.size-=q?1:0,q}function Ia(O){var q=this.__data__;if(RT){var fe=q[O];return fe===p?i:fe}return Vl.call(q,O)?q[O]:i}function Ym(O){var q=this.__data__;return RT?q[O]!==i:Vl.call(q,O)}function Nd(O,q){var fe=this.__data__;return this.size+=this.has(O)?0:1,fe[O]=RT&&q===i?p:q,this}function Kr(O){var q=-1,fe=O==null?0:O.length;for(this.clear();++q<fe;){var $e=O[q];this.set($e[0],$e[1])}}function Mh(){this.__data__=[],this.size=0}function Qm(O){var q=this.__data__,fe=yc(q,O);return!(fe<0)&&(fe==q.length-1?q.pop():u_.call(q,fe,1),--this.size,!0)}function fc(O){var q=this.__data__,fe=yc(q,O);return fe<0?i:q[fe][1]}function ra(O){return yc(this.__data__,O)>-1}function np(O,q){var fe=this.__data__,$e=yc(fe,O);return $e<0?(++this.size,fe.push([O,q])):fe[$e][1]=q,this}function kl(O){var q=-1,fe=O==null?0:O.length;for(this.clear();++q<fe;){var $e=O[q];this.set($e[0],$e[1])}}function iu(){this.size=0,this.__data__={hash:new ov,map:new(Jm||Kr),string:new ov}}function Ph(O){var q=bS(this,O).delete(O);return this.size-=q?1:0,q}function ap(O){return bS(this,O).get(O)}function Dc(O){return bS(this,O).has(O)}function Hc(O,q){var fe=bS(this,O),$e=fe.size;return fe.set(O,q),this.size+=fe.size==$e?0:1,this}function ay(O){var q=-1,fe=O==null?0:O.length;for(this.__data__=new kl;++q<fe;)this.add(O[q])}function $l(O){return this.__data__.set(O,p),this}function Dh(O){return this.__data__.has(O)}function bg(O){var q=this.__data__=new Kr(O);this.size=q.size}function Tg(){this.__data__=new Kr,this.size=0}function hS(O){var q=this.__data__,fe=q.delete(O);return this.size=q.size,fe}function Lp(O){return this.__data__.get(O)}function g_(O){return this.__data__.has(O)}function ry(O,q){var fe=this.__data__;if(fe instanceof Kr){var $e=fe.__data__;if(!Jm||$e.length<o-1)return $e.push([O,q]),this.size=++fe.size,this;fe=this.__data__=new kl($e)}return fe.set(O,q),this.size=fe.size,this}function Hu(O,q){var fe=Yo(O),$e=!fe&&B_(O),ut=!fe&&!$e&&F_(O),Dt=!fe&&!$e&&!ut&&L0(O),si=fe||$e||ut||Dt,Ei=si?hh(O.length,WO):[],Ui=Ei.length;for(var Nn in O)!q&&!Vl.call(O,Nn)||si&&(Nn=="length"||ut&&(Nn=="offset"||Nn=="parent")||Dt&&(Nn=="buffer"||Nn=="byteLength"||Nn=="byteOffset")||Tc(Nn,Ui))||Ei.push(Nn);return Ei}function sv(O){var q=O.length;return q?O[b_(0,q-1)]:i}function lv(O,q){return Ed(Gu(O),sy(q,0,O.length))}function _b(O){return Ed(Gu(O))}function rp(O,q,fe){(fe!==i&&!Cy(O[q],fe)||fe===i&&!(q in O))&&nu(O,q,fe)}function vc(O,q,fe){var $e=O[q];Vl.call(O,q)&&Cy($e,fe)&&(fe!==i||q in O)||nu(O,q,fe)}function yc(O,q){for(var fe=O.length;fe--;)if(Cy(O[fe][0],q))return fe;return-1}function sm(O,q,fe,$e){return Cg(O,function(ut,Dt,si){q($e,ut,fe(ut),si)}),$e}function Op(O,q){return O&&hm(q,Th(q),O)}function oy(O,q){return O&&hm(q,Rg(q),O)}function nu(O,q,fe){q=="__proto__"&&nv?nv(O,q,{configurable:!0,enumerable:!0,value:fe,writable:!0}):O[q]=fe}function m_(O,q){for(var fe=-1,$e=q.length,ut=Aa($e),Dt=O==null;++fe<$e;)ut[fe]=Dt?i:f1(O,q[fe]);return ut}function sy(O,q,fe){return O==O&&(fe!==i&&(O=O<=fe?O:fe),q!==i&&(O=O>=q?O:q)),O}function Np(O,q,fe,$e,ut,Dt){var si,Ei=q&y,Ui=q&T,Nn=q&C;if(fe&&(si=ut?fe(O,$e,ut,Dt):fe(O)),si!==i)return si;if(!Oc(O))return O;var Pn=Yo(O);if(Pn){if(si=TS(O),!Ei)return Gu(O,si)}else{var Yn=Au(O),Wa=Yn==Pt||Yn==ni;if(F_(O))return hI(O,Ei);if(Yn==ot||Yn==qe||Wa&&!ut){if(si=Ui||Wa?{}:of(O),!Ei)return Ui?g0(O,oy(si,O)):UT(O,Op(si,O))}else{if(!So[Yn])return ut?O:{};si=Vp(O,Yn,Ei)}}Dt||(Dt=new bg);var _r=Dt.get(O);if(_r)return _r;Dt.set(O,si),tz(O)?O.forEach(function(Qo){si.add(Np(Qo,q,fe,Qo,O,Dt))}):l1(O)&&O.forEach(function(Qo,Oo){si.set(Oo,Np(Qo,q,fe,Oo,O,Dt))});var bo=Pn?i:(Nn?Ui?I_:Jo:Ui?Rg:Th)(O);return jn(bo||O,function(Qo,Oo){bo&&(Qo=O[Oo=Qo]),vc(si,Oo,Np(Qo,q,fe,Oo,O,Dt))}),si}function ju(O){var q=Th(O);return function(fe){return xd(fe,O,q)}}function xd(O,q,fe){var $e=fe.length;if(O==null)return!$e;for(O=Js(O);$e--;){var ut=fe[$e],Dt=q[ut],si=O[ut];if(si===i&&!(ut in O)||!Dt(si))return!1}return!0}function Ac(O,q,fe){if(typeof O!="function")throw new tu(d);return Rb(function(){O.apply(i,fe)},q)}function au(O,q,fe,$e){var ut=-1,Dt=go,si=!0,Ei=O.length,Ui=[],Nn=q.length;if(!Ei)return Ui;fe&&(q=_o(q,vg(fe))),$e?(Dt=_s,si=!1):q.length>=o&&(Dt=o_,si=!1,q=new ay(q));e:for(;++ut<Ei;){var Pn=O[ut],Yn=fe==null?Pn:fe(Pn);if(Pn=$e||Pn!==0?Pn:0,si&&Yn==Yn){for(var Wa=Nn;Wa--;)if(q[Wa]===Yn)continue e;Ui.push(Pn)}else Dt(q,Yn,$e)||Ui.push(Pn)}return Ui}Tt.templateSettings={escape:yn,evaluate:pr,interpolate:Ho,variable:"",imports:{_:Tt}},Tt.prototype=PT.prototype,Tt.prototype.constructor=Tt,ph.prototype=ip(PT.prototype),ph.prototype.constructor=ph,Lo.prototype=ip(PT.prototype),Lo.prototype.constructor=Lo,ov.prototype.clear=SF,ov.prototype.delete=Cb,ov.prototype.get=Ia,ov.prototype.has=Ym,ov.prototype.set=Nd,Kr.prototype.clear=Mh,Kr.prototype.delete=Qm,Kr.prototype.get=fc,Kr.prototype.has=ra,Kr.prototype.set=np,kl.prototype.clear=iu,kl.prototype.delete=Ph,kl.prototype.get=ap,kl.prototype.has=Dc,kl.prototype.set=Hc,ay.prototype.add=ay.prototype.push=$l,ay.prototype.has=Dh,bg.prototype.clear=Tg,bg.prototype.delete=hS,bg.prototype.get=Lp,bg.prototype.has=g_,bg.prototype.set=ry;var Cg=wb(dv),ly=wb(_g,!0);function l0(O,q){var fe=!0;return Cg(O,function($e,ut,Dt){return fe=!!q($e,ut,Dt)}),fe}function pS(O,q,fe){for(var $e=-1,ut=O.length;++$e<ut;){var Dt=O[$e],si=q(Dt);if(si!=null&&(Ei===i?si==si&&!cf(si):fe(si,Ei)))var Ei=si,Ui=Dt}return Ui}function Ic(O,q,fe,$e){var ut=O.length;for((fe=Es(fe))<0&&(fe=-fe>ut?0:ut+fe),($e=$e===i||$e>ut?ut:Es($e))<0&&($e+=ut),$e=fe>$e?0:_F($e);fe<$e;)O[fe++]=q;return O}function Eb(O,q){var fe=[];return Cg(O,function($e,ut,Dt){q($e,ut,Dt)&&fe.push($e)}),fe}function ru(O,q,fe,$e,ut){var Dt=-1,si=O.length;for(fe||(fe=gm),ut||(ut=[]);++Dt<si;){var Ei=O[Dt];q>0&&fe(Ei)?q>1?ru(Ei,q-1,fe,$e,ut):Ks(ut,Ei):$e||(ut[ut.length]=Ei)}return ut}var cv=Ag(),Zm=Ag(!0);function dv(O,q){return O&&cv(O,q,Th)}function _g(O,q){return O&&Zm(O,q,Th)}function f_(O,q){return Nr(q,function(fe){return Lb(O[fe])})}function xp(O,q){for(var fe=0,$e=(q=nf(q,O)).length;O!=null&&fe<$e;)O=O[jc(q[fe++])];return fe&&fe==$e?O:i}function gS(O,q,fe){var $e=q(O);return Yo(O)?$e:Ks($e,fe(O))}function Ns(O){return O==null?O===i?yt:Ke:ey&&ey in Js(O)?Wk(O):QO(O)}function Na(O,q){return O>q}function lm(O,q){return O!=null&&Vl.call(O,q)}function Bp(O,q){return O!=null&&q in Js(O)}function cy(O,q,fe){return O>=Eu(q,fe)&&O<id(q,fe)}function mS(O,q,fe){for(var $e=fe?_s:go,ut=O[0].length,Dt=O.length,si=Dt,Ei=Aa(Dt),Ui=1/0,Nn=[];si--;){var Pn=O[si];si&&q&&(Pn=_o(Pn,vg(q))),Ui=Eu(Pn.length,Ui),Ei[si]=!fe&&(q||ut>=120&&Pn.length>=120)?new ay(si&&Pn):i}Pn=O[0];var Yn=-1,Wa=Ei[0];e:for(;++Yn<ut&&Nn.length<Ui;){var _r=Pn[Yn],bo=q?q(_r):_r;if(_r=fe||_r!==0?_r:0,!(Wa?o_(Wa,bo):$e(Nn,bo,fe))){for(si=Dt;--si;){var Qo=Ei[si];if(!(Qo?o_(Qo,bo):$e(O[si],bo,fe)))continue e}Wa&&Wa.push(bo),Nn.push(_r)}}return Nn}function uv(O,q,fe,$e){return dv(O,function(ut,Dt,si){q($e,fe(ut),Dt,si)}),$e}function Ab(O,q,fe){var $e=(O=k_(O,q=nf(q,O)))==null?O:O[jc(ym(q))];return $e==null?i:Gi($e,O,fe)}function DT(O){return cu(O)&&Ns(O)==qe}function Cd(O){return cu(O)&&Ns(O)==Ae}function cm(O){return cu(O)&&Ns(O)==Mt}function Fp(O,q,fe,$e,ut){return O===q||(O==null||q==null||!cu(O)&&!cu(q)?O!=O&&q!=q:zk(O,q,fe,$e,Fp,ut))}function zk(O,q,fe,$e,ut,Dt){var si=Yo(O),Ei=Yo(q),Ui=si?Ge:Au(O),Nn=Ei?Ge:Au(q),Pn=(Ui=Ui==qe?ot:Ui)==ot,Yn=(Nn=Nn==qe?ot:Nn)==ot,Wa=Ui==Nn;if(Wa&&F_(O)){if(!F_(q))return!1;si=!0,Pn=!1}if(Wa&&!Pn)return Dt||(Dt=new bg),si||L0(O)?ou(O,q,fe,$e,ut,Dt):qu(O,q,Ui,fe,$e,ut,Dt);if(!(fe&E)){var _r=Pn&&Vl.call(O,"__wrapped__"),bo=Yn&&Vl.call(q,"__wrapped__");if(_r||bo){var Qo=_r?O.value():O,Oo=bo?q.value():q;return Dt||(Dt=new bg),ut(Qo,Oo,fe,$e,Dt)}}return!!Wa&&(Dt||(Dt=new bg),pm(O,q,fe,$e,ut,Dt))}function Vk(O){return cu(O)&&Au(O)==Zt}function Up(O,q,fe,$e){var ut=fe.length,Dt=ut,si=!$e;if(O==null)return!Dt;for(O=Js(O);ut--;){var Ei=fe[ut];if(si&&Ei[2]?Ei[1]!==O[Ei[0]]:!(Ei[0]in O))return!1}for(;++ut<Dt;){var Ui=(Ei=fe[ut])[0],Nn=O[Ui],Pn=Ei[1];if(si&&Ei[2]){if(Nn===i&&!(Ui in O))return!1}else{var Yn=new bg;if($e)var Wa=$e(Nn,Pn,Ui,O,q,Yn);if(!(Wa===i?Fp(Pn,Nn,E|I,$e,Yn):Wa))return!1}}return!0}function Eg(O){return!(!Oc(O)||w_(O))&&(Lb(O)?OP:aa).test(fy(O))}function BP(O){return cu(O)&&Ns(O)==Nt}function lI(O){return cu(O)&&Au(O)==Vt}function fS(O){return cu(O)&&P0(O.length)&&!!Go[Ns(O)]}function hv(O){return typeof O=="function"?O:O==null?uf:typeof O=="object"?Yo(O)?dy(O[0],O[1]):c0(O):A1(O)}function v_(O){if(!vv(O))return wl(O);var q=[];for(var fe in Js(O))Vl.call(O,fe)&&fe!="constructor"&&q.push(fe);return q}function cI(O){if(!Oc(O))return CI(O);var q=vv(O),fe=[];for(var $e in O)($e!="constructor"||!q&&Vl.call(O,$e))&&fe.push($e);return fe}function LT(O,q){return O<q}function dI(O,q){var fe=-1,$e=kg(O)?Aa(O.length):[];return Cg(O,function(ut,Dt,si){$e[++fe]=q(ut,Dt,si)}),$e}function c0(O){var q=qk(O);return q.length==1&&q[0][2]?Jk(q[0][0],q[0][1]):function(fe){return fe===O||Up(fe,O,q)}}function dy(O,q){return Kk(O)&&Oh(q)?Jk(jc(O),q):function(fe){var $e=f1(fe,O);return $e===i&&$e===q?mR(fe,O):Fp(q,$e,E|I)}}function vS(O,q,fe,$e,ut){O!==q&&cv(q,function(Dt,si){if(ut||(ut=new bg),Oc(Dt))y_(O,q,si,fe,vS,$e,ut);else{var Ei=$e?$e(R_(O,si),Dt,si+"",O,q,ut):i;Ei===i&&(Ei=Dt),rp(O,si,Ei)}},Rg)}function y_(O,q,fe,$e,ut,Dt,si){var Ei=R_(O,fe),Ui=R_(q,fe),Nn=si.get(Ui);if(Nn)rp(O,fe,Nn);else{var Pn=Dt?Dt(Ei,Ui,fe+"",O,q,si):i,Yn=Pn===i;if(Yn){var Wa=Yo(Ui),_r=!Wa&&F_(Ui),bo=!Wa&&!_r&&L0(Ui);Pn=Ui,Wa||_r||bo?Yo(Ei)?Pn=Ei:Ku(Ei)?Pn=Gu(Ei):_r?(Yn=!1,Pn=hI(Ui,!0)):bo?(Yn=!1,Pn=C_(Ui,!0)):Pn=[]:kS(Ui)||B_(Ui)?(Pn=Ei,B_(Ei)?Pn=BI(Ei):Oc(Ei)&&!Lb(Ei)||(Pn=of(Ui))):Yn=!1}Yn&&(si.set(Ui,Pn),ut(Pn,Ui,$e,Dt,si),si.delete(Ui)),rp(O,fe,Pn)}}function yS(O,q){var fe=O.length;if(fe)return Tc(q+=q<0?fe:0,fe)?O[q]:i}function uI(O,q,fe){q=q.length?_o(q,function(Dt){return Yo(Dt)?function(si){return xp(si,Dt.length===1?Dt[0]:Dt)}:Dt}):[uf];var $e=-1;q=_o(q,vg(Yr()));var ut=dI(O,function(Dt,si,Ei){var Ui=_o(q,function(Nn){return Nn(Dt)});return{criteria:Ui,index:++$e,value:Dt}});return Vu(ut,function(Dt,si){return pv(Dt,si,fe)})}function S_(O,q){return $k(O,q,function(fe,$e){return mR(O,$e)})}function $k(O,q,fe){for(var $e=-1,ut=q.length,Dt={};++$e<ut;){var si=q[$e],Ei=xp(O,si);fe(Ei,si)&&Zl(Dt,nf(si,O),Ei)}return Dt}function Hk(O){return function(q){return xp(q,O)}}function nd(O,q,fe,$e){var ut=$e?Ok:nm,Dt=-1,si=q.length,Ei=O;for(O===q&&(q=Gu(q)),fe&&(Ei=_o(O,vg(fe)));++Dt<si;)for(var Ui=0,Nn=q[Dt],Pn=fe?fe(Nn):Nn;(Ui=ut(Ei,Pn,Ui,$e))>-1;)Ei!==O&&u_.call(Ei,Ui,1),u_.call(O,Ui,1);return O}function d0(O,q){for(var fe=O?q.length:0,$e=fe-1;fe--;){var ut=q[fe];if(fe==$e||ut!==Dt){var Dt=ut;Tc(ut)?u_.call(O,ut,1):um(O,ut)}}return O}function b_(O,q){return O+iI(h_()*(q-O+1))}function Jr(O,q,fe,$e){for(var ut=-1,Dt=id(Fk((q-O)/(fe||1)),0),si=Aa(Dt);Dt--;)si[$e?Dt:++ut]=O,O+=fe;return si}function ps(O,q){var fe="";if(!O||q<1||q>te)return fe;do q%2&&(fe+=O),(q=iI(q/2))&&(O+=O);while(q);return fe}function nr(O,q){return Ig(Yk(O,q,uf),O+"")}function Sc(O){return sv(vR(O))}function Hl(O,q){var fe=vR(O);return Ed(fe,sy(q,0,fe.length))}function Zl(O,q,fe,$e){if(!Oc(O))return O;for(var ut=-1,Dt=(q=nf(q,O)).length,si=Dt-1,Ei=O;Ei!=null&&++ut<Dt;){var Ui=jc(q[ut]),Nn=fe;if(Ui==="__proto__"||Ui==="constructor"||Ui==="prototype")return O;if(ut!=si){var Pn=Ei[Ui];(Nn=$e?$e(Pn,Ui,Ei):i)===i&&(Nn=Oc(Pn)?Pn:Tc(q[ut+1])?[]:{})}vc(Ei,Ui,Nn),Ei=Ei[Ui]}return O}var gh=uS?function(O,q){return uS.set(O,q),O}:uf,Xm=nv?function(O,q){return nv(O,"toString",{configurable:!0,enumerable:!1,value:oD(q),writable:!0})}:uf;function ll(O){return Ed(vR(O))}function _d(O,q,fe){var $e=-1,ut=O.length;q<0&&(q=-q>ut?0:ut+q),(fe=fe>ut?ut:fe)<0&&(fe+=ut),ut=q>fe?0:fe-q>>>0,q>>>=0;for(var Dt=Aa(ut);++$e<ut;)Dt[$e]=O[$e+q];return Dt}function En(O,q){var fe;return Cg(O,function($e,ut,Dt){return!(fe=q($e,ut,Dt))}),!!fe}function Vs(O,q,fe){var $e=0,ut=O==null?$e:O.length;if(typeof q=="number"&&q==q&&ut<=Te){for(;$e<ut;){var Dt=$e+ut>>>1,si=O[Dt];si!==null&&!cf(si)&&(fe?si<=q:si<q)?$e=Dt+1:ut=Dt}return ut}return ao(O,q,uf,fe)}function ao(O,q,fe,$e){var ut=0,Dt=O==null?0:O.length;if(Dt===0)return 0;for(var si=(q=fe(q))!=q,Ei=q===null,Ui=cf(q),Nn=q===i;ut<Dt;){var Pn=iI((ut+Dt)/2),Yn=fe(O[Pn]),Wa=Yn!==i,_r=Yn===null,bo=Yn==Yn,Qo=cf(Yn);if(si)var Oo=$e||bo;else Oo=Nn?bo&&($e||Wa):Ei?bo&&Wa&&($e||!_r):Ui?bo&&Wa&&!_r&&($e||!Qo):!_r&&!Qo&&($e?Yn<=q:Yn<q);Oo?ut=Pn+1:Dt=Pn}return Eu(Dt,ve)}function dm(O,q){for(var fe=-1,$e=O.length,ut=0,Dt=[];++fe<$e;){var si=O[fe],Ei=q?q(si):si;if(!fe||!Cy(Ei,Ui)){var Ui=Ei;Dt[ut++]=si===0?0:si}}return Dt}function op(O){return typeof O=="number"?O:cf(O)?ce:+O}function Ys(O){if(typeof O=="string")return O;if(Yo(O))return _o(O,Ys)+"";if(cf(O))return ny?ny.call(O):"";var q=O+"";return q=="0"&&1/O==-1/0?"-0":q}function Xl(O,q,fe){var $e=-1,ut=go,Dt=O.length,si=!0,Ei=[],Ui=Ei;if(fe)si=!1,ut=_s;else if(Dt>=o){var Nn=q?null:YO(O);if(Nn)return rS(Nn);si=!1,ut=o_,Ui=new ay}else Ui=q?[]:Ei;e:for(;++$e<Dt;){var Pn=O[$e],Yn=q?q(Pn):Pn;if(Pn=fe||Pn!==0?Pn:0,si&&Yn==Yn){for(var Wa=Ui.length;Wa--;)if(Ui[Wa]===Yn)continue e;q&&Ui.push(Yn),Ei.push(Pn)}else ut(Ui,Yn,fe)||(Ui!==Ei&&Ui.push(Yn),Ei.push(Pn))}return Ei}function um(O,q){return(O=k_(O,q=nf(q,O)))==null||delete O[jc(ym(q))]}function ef(O,q,fe,$e){return Zl(O,q,fe(xp(O,q)),$e)}function tf(O,q,fe,$e){for(var ut=O.length,Dt=$e?ut:-1;($e?Dt--:++Dt<ut)&&q(O[Dt],Dt,O););return fe?_d(O,$e?0:Dt,$e?Dt+1:ut):_d(O,$e?Dt+1:0,$e?ut:Dt)}function uy(O,q){var fe=O;return fe instanceof Lo&&(fe=fe.value()),Ko(q,function($e,ut){return ut.func.apply(ut.thisArg,Ks([$e],ut.args))},fe)}function OT(O,q,fe){var $e=O.length;if($e<2)return $e?Xl(O[0]):[];for(var ut=-1,Dt=Aa($e);++ut<$e;)for(var si=O[ut],Ei=-1;++Ei<$e;)Ei!=ut&&(Dt[ut]=au(Dt[ut]||si,O[Ei],q,fe));return Xl(ru(Dt,1),q,fe)}function T_(O,q,fe){for(var $e=-1,ut=O.length,Dt=q.length,si={};++$e<ut;){var Ei=$e<Dt?q[$e]:i;fe(si,O[$e],Ei)}return si}function NT(O){return Ku(O)?O:[]}function Ib(O){return typeof O=="function"?O:uf}function nf(O,q){return Yo(O)?O:Kk(O,q)?[O]:fh(jl(O))}var u0=nr;function hy(O,q,fe){var $e=O.length;return fe=fe===i?$e:fe,!q&&fe>=$e?O:_d(O,q,fe)}var xT=av||function(O){return Os.clearTimeout(O)};function hI(O,q){if(q)return O.slice();var fe=O.length,$e=Td?Td(fe):new O.constructor(fe);return O.copy($e),$e}function BT(O){var q=new O.constructor(O.byteLength);return new Km(q).set(new Km(O)),q}function FT(O,q){var fe=q?BT(O.buffer):O.buffer;return new O.constructor(fe,O.byteOffset,O.byteLength)}function h0(O){var q=new O.constructor(O.source,qa.exec(O));return q.lastIndex=O.lastIndex,q}function Lh(O){return rv?Js(rv.call(O)):{}}function C_(O,q){var fe=q?BT(O.buffer):O.buffer;return new O.constructor(fe,O.byteOffset,O.length)}function __(O,q){if(O!==q){var fe=O!==i,$e=O===null,ut=O==O,Dt=cf(O),si=q!==i,Ei=q===null,Ui=q==q,Nn=cf(q);if(!Ei&&!Nn&&!Dt&&O>q||Dt&&si&&Ui&&!Ei&&!Nn||$e&&si&&Ui||!fe&&Ui||!ut)return 1;if(!$e&&!Dt&&!Nn&&O<q||Nn&&fe&&ut&&!$e&&!Dt||Ei&&fe&&ut||!si&&ut||!Ui)return-1}return 0}function pv(O,q,fe){for(var $e=-1,ut=O.criteria,Dt=q.criteria,si=ut.length,Ei=fe.length;++$e<si;){var Ui=__(ut[$e],Dt[$e]);if(Ui)return $e>=Ei?Ui:Ui*(fe[$e]=="desc"?-1:1)}return O.index-q.index}function pI(O,q,fe,$e){for(var ut=-1,Dt=O.length,si=fe.length,Ei=-1,Ui=q.length,Nn=id(Dt-si,0),Pn=Aa(Ui+Nn),Yn=!$e;++Ei<Ui;)Pn[Ei]=q[Ei];for(;++ut<si;)(Yn||ut<Dt)&&(Pn[fe[ut]]=O[ut]);for(;Nn--;)Pn[Ei++]=O[ut++];return Pn}function p0(O,q,fe,$e){for(var ut=-1,Dt=O.length,si=-1,Ei=fe.length,Ui=-1,Nn=q.length,Pn=id(Dt-Ei,0),Yn=Aa(Pn+Nn),Wa=!$e;++ut<Pn;)Yn[ut]=O[ut];for(var _r=ut;++Ui<Nn;)Yn[_r+Ui]=q[Ui];for(;++si<Ei;)(Wa||ut<Dt)&&(Yn[_r+fe[si]]=O[ut++]);return Yn}function Gu(O,q){var fe=-1,$e=O.length;for(q||(q=Aa($e));++fe<$e;)q[fe]=O[fe];return q}function hm(O,q,fe,$e){var ut=!fe;fe||(fe={});for(var Dt=-1,si=q.length;++Dt<si;){var Ei=q[Dt],Ui=$e?$e(fe[Ei],O[Ei],Ei,fe,O):i;Ui===i&&(Ui=O[Ei]),ut?nu(fe,Ei,Ui):vc(fe,Ei,Ui)}return fe}function UT(O,q){return hm(O,fv(O),q)}function g0(O,q){return hm(O,SI(O),q)}function py(O,q){return function(fe,$e){var ut=Yo(fe)?un:sm,Dt=q?q():{};return ut(fe,O,Yr($e,2),Dt)}}function SS(O){return nr(function(q,fe){var $e=-1,ut=fe.length,Dt=ut>1?fe[ut-1]:i,si=ut>2?fe[2]:i;for(Dt=O.length>3&&typeof Dt=="function"?(ut--,Dt):i,si&&$p(fe[0],fe[1],si)&&(Dt=ut<3?i:Dt,ut=1),q=Js(q);++$e<ut;){var Ei=fe[$e];Ei&&O(q,Ei,$e,Dt)}return q})}function wb(O,q){return function(fe,$e){if(fe==null)return fe;if(!kg(fe))return O(fe,$e);for(var ut=fe.length,Dt=q?ut:-1,si=Js(fe);(q?Dt--:++Dt<ut)&&$e(si[Dt],Dt,si)!==!1;);return fe}}function Ag(O){return function(q,fe,$e){for(var ut=-1,Dt=Js(q),si=$e(q),Ei=si.length;Ei--;){var Ui=si[O?Ei:++ut];if(fe(Dt[Ui],Ui,Dt)===!1)break}return q}}function JO(O,q,fe){var $e=q&w,ut=zT(O);function Dt(){return(this&&this!==Os&&this instanceof Dt?ut:O).apply($e?fe:this,arguments)}return Dt}function bc(O){return function(q){var fe=rm(q=jl(q))?Qv(q):i,$e=fe?fe[0]:q.charAt(0),ut=fe?hy(fe,1).join(""):q.slice(1);return $e[O]()+ut}}function gv(O){return function(q){return Ko(_1(b1(q).replace(sl,"")),O,"")}}function zT(O){return function(){var q=arguments;switch(q.length){case 0:return new O;case 1:return new O(q[0]);case 2:return new O(q[0],q[1]);case 3:return new O(q[0],q[1],q[2]);case 4:return new O(q[0],q[1],q[2],q[3]);case 5:return new O(q[0],q[1],q[2],q[3],q[4]);case 6:return new O(q[0],q[1],q[2],q[3],q[4],q[5]);case 7:return new O(q[0],q[1],q[2],q[3],q[4],q[5],q[6])}var fe=ip(O.prototype),$e=O.apply(fe,q);return Oc($e)?$e:fe}}function gI(O,q,fe){var $e=zT(O);function ut(){for(var Dt=arguments.length,si=Aa(Dt),Ei=Dt,Ui=kb(ut);Ei--;)si[Ei]=arguments[Ei];var Nn=Dt<3&&si[0]!==Ui&&si[Dt-1]!==Ui?[]:iv(si,Ui);return(Dt-=Nn.length)<fe?jk(O,q,m0,ut.placeholder,i,si,Nn,i,i,fe-Dt):Gi(this&&this!==Os&&this instanceof ut?$e:O,this,si)}return ut}function E_(O){return function(q,fe,$e){var ut=Js(q);if(!kg(q)){var Dt=Yr(fe,3);q=Th(q),fe=function(Ei){return Dt(ut[Ei],Ei,ut)}}var si=O(q,fe,$e);return si>-1?ut[Dt?q[si]:si]:i}}function mv(O){return zp(function(q){var fe=q.length,$e=fe,ut=ph.prototype.thru;for(O&&q.reverse();$e--;){var Dt=q[$e];if(typeof Dt!="function")throw new tu(d);if(ut&&!si&&b0(Dt)=="wrapper")var si=new ph([],!0)}for($e=si?$e:fe;++$e<fe;){var Ei=b0(Dt=q[$e]),Ui=Ei=="wrapper"?yI(Dt):i;si=Ui&&Wu(Ui[0])&&Ui[1]==(H|x|L|j)&&!Ui[4].length&&Ui[9]==1?si[b0(Ui[0])].apply(si,Ui[3]):Dt.length==1&&Wu(Dt)?si[Ei]():si.thru(Dt)}return function(){var Nn=arguments,Pn=Nn[0];if(si&&Nn.length==1&&Yo(Pn))return si.plant(Pn).value();for(var Yn=0,Wa=fe?q[Yn].apply(this,Nn):Pn;++Yn<fe;)Wa=q[Yn].call(this,Wa);return Wa}})}function m0(O,q,fe,$e,ut,Dt,si,Ei,Ui,Nn){var Pn=q&H,Yn=q&w,Wa=q&D,_r=q&(x|B),bo=q&J,Qo=Wa?i:zT(O);function Oo(){for(var ec=arguments.length,dl=Aa(ec),Jp=ec;Jp--;)dl[Jp]=arguments[Jp];if(_r)var Ay=kb(Oo),V_=am(dl,Ay);if($e&&(dl=pI(dl,$e,ut,_r)),Dt&&(dl=p0(dl,Dt,si,_r)),ec-=V_,_r&&ec<Nn){var Ju=iv(dl,Ay);return jk(O,q,m0,Oo.placeholder,fe,dl,Ju,Ei,Ui,Nn-ec)}var hf=Yn?fe:this,Yp=Wa?hf[O]:O;return ec=dl.length,Ei?dl=_I(dl,Ei):bo&&ec>1&&dl.reverse(),Pn&&Ui<ec&&(dl.length=Ui),this&&this!==Os&&this instanceof Oo&&(Yp=Qo||zT(Yp)),Yp.apply(hf,dl)}return Oo}function mI(O,q){return function(fe,$e){return uv(fe,O,q($e),{})}}function VT(O,q){return function(fe,$e){var ut;if(fe===i&&$e===i)return q;if(fe!==i&&(ut=fe),$e!==i){if(ut===i)return $e;typeof fe=="string"||typeof $e=="string"?(fe=Ys(fe),$e=Ys($e)):(fe=op(fe),$e=op($e)),ut=O(fe,$e)}return ut}}function f0(O){return zp(function(q){return q=_o(q,vg(Yr())),nr(function(fe){var $e=this;return O(q,function(ut){return Gi(ut,$e,fe)})})})}function fI(O,q){var fe=(q=q===i?" ":Ys(q)).length;if(fe<2)return fe?ps(q,O):q;var $e=ps(q,Fk(O/AT(q)));return rm(q)?hy(Qv($e),0,O).join(""):$e.slice(0,O)}function v0(O,q,fe,$e){var ut=q&w,Dt=zT(O);function si(){for(var Ei=-1,Ui=arguments.length,Nn=-1,Pn=$e.length,Yn=Aa(Pn+Ui),Wa=this&&this!==Os&&this instanceof si?Dt:O;++Nn<Pn;)Yn[Nn]=$e[Nn];for(;Ui--;)Yn[Nn++]=arguments[++Ei];return Gi(Wa,ut?fe:this,Yn)}return si}function $T(O){return function(q,fe,$e){return $e&&typeof $e!="number"&&$p(q,fe,$e)&&(fe=$e=i),q=Sv(q),fe===i?(fe=q,q=0):fe=Sv(fe),Jr(q,fe,$e=$e===i?q<fe?1:-1:Sv($e),O)}}function y0(O){return function(q,fe){return typeof q=="string"&&typeof fe=="string"||(q=Sh(q),fe=Sh(fe)),O(q,fe)}}function jk(O,q,fe,$e,ut,Dt,si,Ei,Ui,Nn){var Pn=q&x;q|=Pn?L:z,(q&=~(Pn?z:L))&F||(q&=-4);var Yn=[O,q,ut,Pn?Dt:i,Pn?si:i,Pn?i:Dt,Pn?i:si,Ei,Ui,Nn],Wa=fe.apply(i,Yn);return Wu(O)&&_0(Wa,Yn),Wa.placeholder=$e,my(Wa,O,q)}function S0(O){var q=eu[O];return function(fe,$e){if(fe=Sh(fe),($e=$e==null?0:Eu(Es($e),292))&&wT(fe)){var ut=(jl(fe)+"e").split("e");return+((ut=(jl(q(ut[0]+"e"+(+ut[1]+$e)))+"e").split("e"))[0]+"e"+(+ut[1]-$e))}return q(fe)}}var YO=dS&&1/rS(new dS([,-0]))[1]==pe?function(O){return new dS(O)}:GI;function vI(O){return function(q){var fe=Au(q);return fe==Zt?t0(q):fe==Vt?oS(q):wP(q,O(q))}}function af(O,q,fe,$e,ut,Dt,si,Ei){var Ui=q&D;if(!Ui&&typeof O!="function")throw new tu(d);var Nn=$e?$e.length:0;if(Nn||(q&=-97,$e=ut=i),si=si===i?si:id(Es(si),0),Ei=Ei===i?Ei:Es(Ei),Nn-=ut?ut.length:0,q&z){var Pn=$e,Yn=ut;$e=ut=i}var Wa=Ui?i:yI(O),_r=[O,q,fe,$e,ut,Pn,Yn,Dt,si,Ei];if(Wa&&sf(_r,Wa),O=_r[0],q=_r[1],fe=_r[2],$e=_r[3],ut=_r[4],!(Ei=_r[9]=_r[9]===i?Ui?0:O.length:id(_r[9]-Nn,0))&&q&(x|B)&&(q&=-25),q&&q!=w)bo=q==x||q==B?gI(O,q,Ei):q!=L&&q!=(w|L)||ut.length?m0.apply(i,_r):v0(O,q,fe,$e);else var bo=JO(O,q,fe);return my((Wa?gh:_0)(bo,_r),O,q)}function Gk(O,q,fe,$e){return O===i||Cy(O,Sb[fe])&&!Vl.call($e,fe)?q:O}function rf(O,q,fe,$e,ut,Dt){return Oc(O)&&Oc(q)&&(Dt.set(q,O),vS(O,q,i,rf,Dt),Dt.delete(q)),O}function A_(O){return kS(O)?i:O}function ou(O,q,fe,$e,ut,Dt){var si=fe&E,Ei=O.length,Ui=q.length;if(Ei!=Ui&&!(si&&Ui>Ei))return!1;var Nn=Dt.get(O),Pn=Dt.get(q);if(Nn&&Pn)return Nn==q&&Pn==O;var Yn=-1,Wa=!0,_r=fe&I?new ay:i;for(Dt.set(O,q),Dt.set(q,O);++Yn<Ei;){var bo=O[Yn],Qo=q[Yn];if($e)var Oo=si?$e(Qo,bo,Yn,q,O,Dt):$e(bo,Qo,Yn,O,q,Dt);if(Oo!==i){if(Oo)continue;Wa=!1;break}if(_r){if(!hs(q,function(ec,dl){if(!o_(_r,dl)&&(bo===ec||ut(bo,ec,fe,$e,Dt)))return _r.push(dl)})){Wa=!1;break}}else if(bo!==Qo&&!ut(bo,Qo,fe,$e,Dt)){Wa=!1;break}}return Dt.delete(O),Dt.delete(q),Wa}function qu(O,q,fe,$e,ut,Dt,si){switch(fe){case xe:if(O.byteLength!=q.byteLength||O.byteOffset!=q.byteOffset)return!1;O=O.buffer,q=q.buffer;case Ae:return!(O.byteLength!=q.byteLength||!Dt(new Km(O),new Km(q)));case ct:case Mt:case it:return Cy(+O,+q);case vt:return O.name==q.name&&O.message==q.message;case Nt:case $t:return O==q+"";case Zt:var Ei=t0;case Vt:var Ui=$e&E;if(Ei||(Ei=rS),O.size!=q.size&&!Ui)return!1;var Nn=si.get(O);if(Nn)return Nn==q;$e|=I,si.set(O,q);var Pn=ou(Ei(O),Ei(q),$e,ut,Dt,si);return si.delete(O),Pn;case dt:if(rv)return rv.call(O)==rv.call(q)}return!1}function pm(O,q,fe,$e,ut,Dt){var si=fe&E,Ei=Jo(O),Ui=Ei.length;if(Ui!=Jo(q).length&&!si)return!1;for(var Nn=Ui;Nn--;){var Pn=Ei[Nn];if(!(si?Pn in q:Vl.call(q,Pn)))return!1}var Yn=Dt.get(O),Wa=Dt.get(q);if(Yn&&Wa)return Yn==q&&Wa==O;var _r=!0;Dt.set(O,q),Dt.set(q,O);for(var bo=si;++Nn<Ui;){var Qo=O[Pn=Ei[Nn]],Oo=q[Pn];if($e)var ec=si?$e(Oo,Qo,Pn,q,O,Dt):$e(Qo,Oo,Pn,O,q,Dt);if(!(ec===i?Qo===Oo||ut(Qo,Oo,fe,$e,Dt):ec)){_r=!1;break}bo||(bo=Pn=="constructor")}if(_r&&!bo){var dl=O.constructor,Jp=q.constructor;dl==Jp||!("constructor"in O)||!("constructor"in q)||typeof dl=="function"&&dl instanceof dl&&typeof Jp=="function"&&Jp instanceof Jp||(_r=!1)}return Dt.delete(O),Dt.delete(q),_r}function zp(O){return Ig(Yk(O,i,ad),O+"")}function Jo(O){return gS(O,Th,fv)}function I_(O){return gS(O,Rg,SI)}var yI=uS?function(O){return uS.get(O)}:GI;function b0(O){for(var q=O.name+"",fe=Sg[q],$e=Vl.call(Sg,q)?fe.length:0;$e--;){var ut=fe[$e],Dt=ut.func;if(Dt==null||Dt==O)return ut.name}return q}function kb(O){return(Vl.call(Tt,"placeholder")?Tt:O).placeholder}function Yr(){var O=Tt.iteratee||LF;return O=O===LF?hv:O,arguments.length?O(arguments[0],arguments[1]):O}function bS(O,q){var fe=O.__data__;return C0(q)?fe[typeof q=="string"?"string":"hash"]:fe.map}function qk(O){for(var q=Th(O),fe=q.length;fe--;){var $e=q[fe],ut=O[$e];q[fe]=[$e,ut,Oh(ut)]}return q}function gy(O,q){var fe=kP(O,q);return Eg(fe)?fe:i}function Wk(O){var q=Vl.call(O,ey),fe=O[ey];try{O[ey]=i;var $e=!0}catch{}var ut=bb.call(O);return $e&&(q?O[ey]=fe:delete O[ey]),ut}var fv=_u?function(O){return O==null?[]:(O=Js(O),Nr(_u(O),function(q){return tI.call(O,q)}))}:BF,SI=_u?function(O){for(var q=[];O;)Ks(q,fv(O)),O=a0(O);return q}:BF,Au=Ns;function FP(O,q,fe){for(var $e=-1,ut=fe.length;++$e<ut;){var Dt=fe[$e],si=Dt.size;switch(Dt.type){case"drop":O+=si;break;case"dropRight":q-=si;break;case"take":q=Eu(q,O+si);break;case"takeRight":O=id(O,q-si)}}return{start:O,end:q}}function T0(O){var q=O.match(Yl);return q?q[1].split(ci):[]}function mh(O,q,fe){for(var $e=-1,ut=(q=nf(q,O)).length,Dt=!1;++$e<ut;){var si=jc(q[$e]);if(!(Dt=O!=null&&fe(O,si)))break;O=O[si]}return Dt||++$e!=ut?Dt:!!(ut=O==null?0:O.length)&&P0(ut)&&Tc(si,ut)&&(Yo(O)||B_(O))}function TS(O){var q=O.length,fe=new O.constructor(q);return q&&typeof O[0]=="string"&&Vl.call(O,"index")&&(fe.index=O.index,fe.input=O.input),fe}function of(O){return typeof O.constructor!="function"||vv(O)?{}:ip(a0(O))}function Vp(O,q,fe){var $e=O.constructor;switch(q){case Ae:return BT(O);case ct:case Mt:return new $e(+O);case xe:return FT(O,fe);case gt:case Ye:case Fe:case St:case Wt:case Ii:case en:case sn:case Qi:return C_(O,fe);case Zt:return new $e;case it:case $t:return new $e(O);case Nt:return h0(O);case Vt:return new $e;case dt:return Lh(O)}}function bI(O,q){var fe=q.length;if(!fe)return O;var $e=fe-1;return q[$e]=(fe>1?"& ":"")+q[$e],q=q.join(fe>2?", ":" "),O.replace(rc,`{
/* [wrapped with `+q+`] */
`)}function gm(O){return Yo(O)||B_(O)||!!(NP&&O&&O[NP])}function Tc(O,q){var fe=typeof O;return!!(q=q??te)&&(fe=="number"||fe!="symbol"&&on.test(O))&&O>-1&&O%1==0&&O<q}function $p(O,q,fe){if(!Oc(fe))return!1;var $e=typeof q;return!!($e=="number"?kg(fe)&&Tc(q,fe.length):$e=="string"&&q in fe)&&Cy(fe[q],O)}function Kk(O,q){if(Yo(O))return!1;var fe=typeof O;return!(fe!="number"&&fe!="symbol"&&fe!="boolean"&&O!=null&&!cf(O))||La.test(O)||!Rr.test(O)||q!=null&&O in Js(q)}function C0(O){var q=typeof O;return q=="string"||q=="number"||q=="symbol"||q=="boolean"?O!=="__proto__":O===null}function Wu(O){var q=b0(O),fe=Tt[q];if(typeof fe!="function"||!(q in Lo.prototype))return!1;if(O===fe)return!0;var $e=yI(fe);return!!$e&&O===$e[0]}function w_(O){return!!LP&&LP in O}(kT&&Au(new kT(new ArrayBuffer(1)))!=xe||Jm&&Au(new Jm)!=Zt||o0&&Au(o0.resolve())!=Ht||dS&&Au(new dS)!=Vt||s0&&Au(new s0)!=kt)&&(Au=function(O){var q=Ns(O),fe=q==ot?O.constructor:i,$e=fe?fy(fe):"";if($e)switch($e){case p_:return xe;case iy:return Zt;case nI:return Ht;case aI:return Vt;case rI:return kt}return q});var TI=Zv?Lb:qI;function vv(O){var q=O&&O.constructor;return O===(typeof q=="function"&&q.prototype||Sb)}function Oh(O){return O==O&&!Oc(O)}function Jk(O,q){return function(fe){return fe!=null&&fe[O]===q&&(q!==i||O in Js(fe))}}function ar(O){var q=Zn(O,function($e){return fe.size===g&&fe.clear(),$e}),fe=q.cache;return q}function sf(O,q){var fe=O[1],$e=q[1],ut=fe|$e,Dt=ut<(w|D|H),si=$e==H&&fe==x||$e==H&&fe==j&&O[7].length<=q[8]||$e==(H|j)&&q[7].length<=q[8]&&fe==x;if(!Dt&&!si)return O;$e&w&&(O[2]=q[2],ut|=fe&w?0:F);var Ei=q[3];if(Ei){var Ui=O[3];O[3]=Ui?pI(Ui,Ei,q[4]):Ei,O[4]=Ui?iv(O[3],f):q[4]}return(Ei=q[5])&&(Ui=O[5],O[5]=Ui?p0(Ui,Ei,q[6]):Ei,O[6]=Ui?iv(O[5],f):q[6]),(Ei=q[7])&&(O[7]=Ei),$e&H&&(O[8]=O[8]==null?q[8]:Eu(O[8],q[8])),O[9]==null&&(O[9]=q[9]),O[0]=q[0],O[1]=ut,O}function CI(O){var q=[];if(O!=null)for(var fe in Js(O))q.push(fe);return q}function QO(O){return bb.call(O)}function Yk(O,q,fe){return q=id(q===i?O.length-1:q,0),function(){for(var $e=arguments,ut=-1,Dt=id($e.length-q,0),si=Aa(Dt);++ut<Dt;)si[ut]=$e[q+ut];ut=-1;for(var Ei=Aa(q+1);++ut<q;)Ei[ut]=$e[ut];return Ei[q]=fe(si),Gi(O,this,Ei)}}function k_(O,q){return q.length<2?O:xp(O,_d(q,0,-1))}function _I(O,q){for(var fe=O.length,$e=Eu(q.length,fe),ut=Gu(O);$e--;){var Dt=q[$e];O[$e]=Tc(Dt,fe)?ut[Dt]:i}return O}function R_(O,q){if((q!=="constructor"||typeof O[q]!="function")&&q!="__proto__")return O[q]}var _0=mm(gh),Rb=lS||function(O,q){return Os.setTimeout(O,q)},Ig=mm(Xm);function my(O,q,fe){var $e=q+"";return Ig(O,bI($e,E0(T0($e),fe)))}function mm(O){var q=0,fe=0;return function(){var $e=ty(),ut=le-($e-fe);if(fe=$e,ut>0){if(++q>=ne)return arguments[0]}else q=0;return O.apply(i,arguments)}}function Ed(O,q){var fe=-1,$e=O.length,ut=$e-1;for(q=q===i?$e:q;++fe<q;){var Dt=b_(fe,ut),si=O[Dt];O[Dt]=O[fe],O[fe]=si}return O.length=q,O}var fh=ar(function(O){var q=[];return O.charCodeAt(0)===46&&q.push(""),O.replace(us,function(fe,$e,ut,Dt){q.push(ut?Dt.replace(Bn,"$1"):$e||fe)}),q});function jc(O){if(typeof O=="string"||cf(O))return O;var q=O+"";return q=="0"&&1/O==-1/0?"-0":q}function fy(O){if(O!=null){try{return IT.call(O)}catch{}try{return O+""}catch{}}return""}function E0(O,q){return jn(Be,function(fe){var $e="_."+fe[0];q&fe[1]&&!go(O,$e)&&O.push($e)}),O.sort()}function Hp(O){if(O instanceof Lo)return O.clone();var q=new ph(O.__wrapped__,O.__chain__);return q.__actions__=Gu(O.__actions__),q.__index__=O.__index__,q.__values__=O.__values__,q}function UP(O,q,fe){q=(fe?$p(O,q,fe):q===i)?1:id(Es(q),0);var $e=O==null?0:O.length;if(!$e||q<1)return[];for(var ut=0,Dt=0,si=Aa(Fk($e/q));ut<$e;)si[Dt++]=_d(O,ut,ut+=q);return si}function fm(O){for(var q=-1,fe=O==null?0:O.length,$e=0,ut=[];++q<fe;){var Dt=O[q];Dt&&(ut[$e++]=Dt)}return ut}function bF(){var O=arguments.length;if(!O)return[];for(var q=Aa(O-1),fe=arguments[0],$e=O;$e--;)q[$e-1]=arguments[$e];return Ks(Yo(fe)?Gu(fe):[fe],ru(q,1))}var zP=nr(function(O,q){return Ku(O)?au(O,ru(q,1,Ku,!0)):[]}),jp=nr(function(O,q){var fe=ym(q);return Ku(fe)&&(fe=i),Ku(O)?au(O,ru(q,1,Ku,!0),Yr(fe,2)):[]}),Bd=nr(function(O,q){var fe=ym(q);return Ku(fe)&&(fe=i),Ku(O)?au(O,ru(q,1,Ku,!0),i,fe):[]});function M_(O,q,fe){var $e=O==null?0:O.length;return $e?_d(O,(q=fe||q===i?1:Es(q))<0?0:q,$e):[]}function ZO(O,q,fe){var $e=O==null?0:O.length;return $e?_d(O,0,(q=$e-(q=fe||q===i?1:Es(q)))<0?0:q):[]}function HT(O,q){return O&&O.length?tf(O,Yr(q,3),!0,!0):[]}function jT(O,q){return O&&O.length?tf(O,Yr(q,3),!0):[]}function Lc(O,q,fe,$e){var ut=O==null?0:O.length;return ut?(fe&&typeof fe!="number"&&$p(O,q,fe)&&(fe=0,$e=ut),Ic(O,q,fe,$e)):[]}function gs(O,q,fe){var $e=O==null?0:O.length;if(!$e)return-1;var ut=fe==null?0:Es(fe);return ut<0&&(ut=id($e+ut,0)),aS(O,Yr(q,3),ut)}function Fd(O,q,fe){var $e=O==null?0:O.length;if(!$e)return-1;var ut=$e-1;return fe!==i&&(ut=Es(fe),ut=fe<0?id($e+ut,0):Eu(ut,$e-1)),aS(O,Yr(q,3),ut,!0)}function ad(O){return O!=null&&O.length?ru(O,1):[]}function vh(O){return O!=null&&O.length?ru(O,pe):[]}function Gp(O,q){return O!=null&&O.length?ru(O,q=q===i?1:Es(q)):[]}function A0(O){for(var q=-1,fe=O==null?0:O.length,$e={};++q<fe;){var ut=O[q];$e[ut[0]]=ut[1]}return $e}function su(O){return O&&O.length?O[0]:i}function I0(O,q,fe){var $e=O==null?0:O.length;if(!$e)return-1;var ut=fe==null?0:Es(fe);return ut<0&&(ut=id($e+ut,0)),nm(O,q,ut)}function CS(O){return O!=null&&O.length?_d(O,0,-1):[]}var P_=nr(function(O){var q=_o(O,NT);return q.length&&q[0]===O[0]?mS(q):[]}),Qk=nr(function(O){var q=ym(O),fe=_o(O,NT);return q===ym(fe)?q=i:fe.pop(),fe.length&&fe[0]===O[0]?mS(fe,Yr(q,2)):[]}),EI=nr(function(O){var q=ym(O),fe=_o(O,NT);return(q=typeof q=="function"?q:i)&&fe.pop(),fe.length&&fe[0]===O[0]?mS(fe,i,q):[]});function vm(O,q){return O==null?"":yg.call(O,q)}function ym(O){var q=O==null?0:O.length;return q?O[q-1]:i}function w0(O,q,fe){var $e=O==null?0:O.length;if(!$e)return-1;var ut=$e;return fe!==i&&(ut=(ut=Es(fe))<0?id($e+ut,0):Eu(ut,$e-1)),q==q?om(O,q,ut):aS(O,Wm,ut,!0)}function Sm(O,q){return O&&O.length?yS(O,Es(q)):i}var GT=nr(_S);function _S(O,q){return O&&O.length&&q&&q.length?nd(O,q):O}function ES(O,q,fe){return O&&O.length&&q&&q.length?nd(O,q,Yr(fe,2)):O}function AI(O,q,fe){return O&&O.length&&q&&q.length?nd(O,q,i,fe):O}var wg=zp(function(O,q){var fe=O==null?0:O.length,$e=m_(O,q);return d0(O,_o(q,function(ut){return Tc(ut,fe)?+ut:ut}).sort(__)),$e});function AS(O,q){var fe=[];if(!O||!O.length)return fe;var $e=-1,ut=[],Dt=O.length;for(q=Yr(q,3);++$e<Dt;){var si=O[$e];q(si,$e,O)&&(fe.push(si),ut.push($e))}return d0(O,ut),fe}function vy(O){return O==null?O:cS.call(O)}function cl(O,q,fe){var $e=O==null?0:O.length;return $e?(fe&&typeof fe!="number"&&$p(O,q,fe)?(q=0,fe=$e):(q=q==null?0:Es(q),fe=fe===i?$e:Es(fe)),_d(O,q,fe)):[]}function Mb(O,q){return Vs(O,q)}function rd(O,q,fe){return ao(O,q,Yr(fe,2))}function Iu(O,q){var fe=O==null?0:O.length;if(fe){var $e=Vs(O,q);if($e<fe&&Cy(O[$e],q))return $e}return-1}function yy(O,q){return Vs(O,q,!0)}function sp(O,q,fe){return ao(O,q,Yr(fe,2),!0)}function qp(O,q){if(O!=null&&O.length){var fe=Vs(O,q,!0)-1;if(Cy(O[fe],q))return fe}return-1}function II(O){return O&&O.length?dm(O):[]}function D_(O,q){return O&&O.length?dm(O,Yr(q,2)):[]}function yv(O){var q=O==null?0:O.length;return q?_d(O,1,q):[]}function Zk(O,q,fe){return O&&O.length?_d(O,0,(q=fe||q===i?1:Es(q))<0?0:q):[]}function lf(O,q,fe){var $e=O==null?0:O.length;return $e?_d(O,(q=$e-(q=fe||q===i?1:Es(q)))<0?0:q,$e):[]}function Xk(O,q){return O&&O.length?tf(O,Yr(q,3),!1,!0):[]}function eR(O,q){return O&&O.length?tf(O,Yr(q,3)):[]}var IS=nr(function(O){return Xl(ru(O,1,Ku,!0))}),VP=nr(function(O){var q=ym(O);return Ku(q)&&(q=i),Xl(ru(O,1,Ku,!0),Yr(q,2))}),Sy=nr(function(O){var q=ym(O);return q=typeof q=="function"?q:i,Xl(ru(O,1,Ku,!0),i,q)});function XO(O){return O&&O.length?Xl(O):[]}function wI(O,q){return O&&O.length?Xl(O,Yr(q,2)):[]}function tR(O,q){return q=typeof q=="function"?q:i,O&&O.length?Xl(O,i,q):[]}function k0(O){if(!O||!O.length)return[];var q=0;return O=Nr(O,function(fe){if(Ku(fe))return q=id(fe.length,q),!0}),hh(q,function(fe){return _o(O,e0(fe))})}function $P(O,q){if(!O||!O.length)return[];var fe=k0(O);return q==null?fe:_o(fe,function($e){return Gi(q,i,$e)})}var HP=nr(function(O,q){return Ku(O)?au(O,q):[]}),kI=nr(function(O){return OT(Nr(O,Ku))}),jP=nr(function(O){var q=ym(O);return Ku(q)&&(q=i),OT(Nr(O,Ku),Yr(q,2))}),qT=nr(function(O){var q=ym(O);return q=typeof q=="function"?q:i,OT(Nr(O,Ku),i,q)}),e1=nr(k0);function L_(O,q){return T_(O||[],q||[],vc)}function t1(O,q){return T_(O||[],q||[],Zl)}var od=nr(function(O){var q=O.length,fe=q>1?O[q-1]:i;return fe=typeof fe=="function"?(O.pop(),fe):i,$P(O,fe)});function i1(O){var q=Tt(O);return q.__chain__=!0,q}function n1(O,q){return q(O),O}function iR(O,q){return q(O)}var Pb=zp(function(O){var q=O.length,fe=q?O[0]:0,$e=this.__wrapped__,ut=function(Dt){return m_(Dt,O)};return!(q>1||this.__actions__.length)&&$e instanceof Lo&&Tc(fe)?(($e=$e.slice(fe,+fe+(q?1:0))).__actions__.push({func:iR,args:[ut],thisArg:i}),new ph($e,this.__chain__).thru(function(Dt){return q&&!Dt.length&&Dt.push(i),Dt})):this.thru(ut)});function RI(){return i1(this)}function O_(){return new ph(this.value(),this.__chain__)}function GP(){this.__values__===i&&(this.__values__=xI(this.value()));var O=this.__index__>=this.__values__.length;return{done:O,value:O?i:this.__values__[this.__index__++]}}function Wp(){return this}function qP(O){for(var q,fe=this;fe instanceof PT;){var $e=Hp(fe);$e.__index__=0,$e.__values__=i,q?ut.__wrapped__=$e:q=$e;var ut=$e;fe=fe.__wrapped__}return ut.__wrapped__=O,q}function nR(){var O=this.__wrapped__;if(O instanceof Lo){var q=O;return this.__actions__.length&&(q=new Lo(this)),(q=q.reverse()).__actions__.push({func:iR,args:[vy],thisArg:i}),new ph(q,this.__chain__)}return this.thru(vy)}function Db(){return uy(this.__wrapped__,this.__actions__)}var N_=py(function(O,q,fe){Vl.call(O,fe)?++O[fe]:nu(O,fe,1)});function lu(O,q,fe){var $e=Yo(O)?Oa:l0;return fe&&$p(O,q,fe)&&(q=i),$e(O,Yr(q,3))}function WT(O,q){return(Yo(O)?Nr:Eb)(O,Yr(q,3))}var aR=E_(gs),R0=E_(Fd);function a1(O,q){return ru(PI(O,q),1)}function rR(O,q){return ru(PI(O,q),pe)}function r1(O,q,fe){return fe=fe===i?1:Es(fe),ru(PI(O,q),fe)}function MI(O,q){return(Yo(O)?jn:Cg)(O,Yr(q,3))}function oR(O,q){return(Yo(O)?no:ly)(O,Yr(q,3))}var sR=py(function(O,q,fe){Vl.call(O,fe)?O[fe].push(q):nu(O,fe,[q])});function wS(O,q,fe,$e){O=kg(O)?O:vR(O),fe=fe&&!$e?Es(fe):0;var ut=O.length;return fe<0&&(fe=id(ut+fe,0)),U_(O)?fe<=ut&&O.indexOf(q,fe)>-1:!!ut&&nm(O,q,fe)>-1}var lR=nr(function(O,q,fe){var $e=-1,ut=typeof q=="function",Dt=kg(O)?Aa(O.length):[];return Cg(O,function(si){Dt[++$e]=ut?Gi(q,si,fe):Ab(si,q,fe)}),Dt}),M0=py(function(O,q,fe){nu(O,fe,q)});function PI(O,q){return(Yo(O)?_o:dI)(O,Yr(q,3))}function KT(O,q,fe,$e){return O==null?[]:(Yo(q)||(q=q==null?[]:[q]),Yo(fe=$e?i:fe)||(fe=fe==null?[]:[fe]),uI(O,q,fe))}var WP=py(function(O,q,fe){O[fe?0:1].push(q)},function(){return[[],[]]});function DI(O,q,fe){var $e=Yo(O)?Ko:_T,ut=arguments.length<3;return $e(O,Yr(q,4),fe,ut,Cg)}function cR(O,q,fe){var $e=Yo(O)?Ql:_T,ut=arguments.length<3;return $e(O,Yr(q,4),fe,ut,ly)}function LI(O,q){return(Yo(O)?Nr:Eb)(O,Gn(Yr(q,3)))}function o1(O){return(Yo(O)?sv:Sc)(O)}function KP(O,q,fe){return q=(fe?$p(O,q,fe):q===i)?1:Es(q),(Yo(O)?lv:Hl)(O,q)}function by(O){return(Yo(O)?_b:ll)(O)}function dR(O){if(O==null)return 0;if(kg(O))return U_(O)?AT(O):O.length;var q=Au(O);return q==Zt||q==Vt?O.size:v_(O).length}function x_(O,q,fe){var $e=Yo(O)?hs:En;return fe&&$p(O,q,fe)&&(q=i),$e(O,Yr(q,3))}var JT=nr(function(O,q){if(O==null)return[];var fe=q.length;return fe>1&&$p(O,q[0],q[1])?q=[]:fe>2&&$p(q[0],q[1],q[2])&&(q=[q[0]]),uI(O,ru(q,1),[])}),Ty=xP||function(){return Os.Date.now()};function A(O,q){if(typeof q!="function")throw new tu(d);return O=Es(O),function(){if(--O<1)return q.apply(this,arguments)}}function R(O,q,fe){return q=fe?i:q,q=O&&q==null?O.length:q,af(O,H,i,i,i,i,q)}function K(O,q){var fe;if(typeof q!="function")throw new tu(d);return O=Es(O),function(){return--O>0&&(fe=q.apply(this,arguments)),O<=1&&(q=i),fe}}var ae=nr(function(O,q,fe){var $e=w;if(fe.length){var ut=iv(fe,kb(ae));$e|=L}return af(O,$e,q,fe,ut)}),Ce=nr(function(O,q,fe){var $e=w|D;if(fe.length){var ut=iv(fe,kb(Ce));$e|=L}return af(q,$e,O,fe,ut)});function Ve(O,q,fe){var $e=af(O,x,i,i,i,i,i,q=fe?i:q);return $e.placeholder=Ve.placeholder,$e}function mt(O,q,fe){var $e=af(O,B,i,i,i,i,i,q=fe?i:q);return $e.placeholder=mt.placeholder,$e}function Xt(O,q,fe){var $e,ut,Dt,si,Ei,Ui,Nn=0,Pn=!1,Yn=!1,Wa=!0;if(typeof O!="function")throw new tu(d);function _r(Ju){var hf=$e,Yp=ut;return $e=ut=i,Nn=Ju,si=O.apply(Yp,hf)}function bo(Ju){return Nn=Ju,Ei=Rb(ec,q),Pn?_r(Ju):si}function Qo(Ju){var hf=q-(Ju-Ui);return Yn?Eu(hf,Dt-(Ju-Nn)):hf}function Oo(Ju){var hf=Ju-Ui;return Ui===i||hf>=q||hf<0||Yn&&Ju-Nn>=Dt}function ec(){var Ju=Ty();if(Oo(Ju))return dl(Ju);Ei=Rb(ec,Qo(Ju))}function dl(Ju){return Ei=i,Wa&&$e?_r(Ju):($e=ut=i,si)}function Jp(){Ei!==i&&xT(Ei),Nn=0,$e=Ui=ut=Ei=i}function Ay(){return Ei===i?si:dl(Ty())}function V_(){var Ju=Ty(),hf=Oo(Ju);if($e=arguments,ut=this,Ui=Ju,hf){if(Ei===i)return bo(Ui);if(Yn)return xT(Ei),Ei=Rb(ec,q),_r(Ui)}return Ei===i&&(Ei=Rb(ec,q)),si}return q=Sh(q)||0,Oc(fe)&&(Pn=!!fe.leading,Dt=(Yn="maxWait"in fe)?id(Sh(fe.maxWait)||0,q):Dt,Wa="trailing"in fe?!!fe.trailing:Wa),V_.cancel=Jp,V_.flush=Ay,V_}var Si=nr(function(O,q){return Ac(O,1,q)}),Zi=nr(function(O,q,fe){return Ac(O,Sh(q)||0,fe)});function Kn(O){return af(O,J)}function Zn(O,q){if(typeof O!="function"||q!=null&&typeof q!="function")throw new tu(d);var fe=function(){var $e=arguments,ut=q?q.apply(this,$e):$e[0],Dt=fe.cache;if(Dt.has(ut))return Dt.get(ut);var si=O.apply(this,$e);return fe.cache=Dt.set(ut,si)||Dt,si};return fe.cache=new(Zn.Cache||kl),fe}function Gn(O){if(typeof O!="function")throw new tu(d);return function(){var q=arguments;switch(q.length){case 0:return!O.call(this);case 1:return!O.call(this,q[0]);case 2:return!O.call(this,q[0],q[1]);case 3:return!O.call(this,q[0],q[1],q[2])}return!O.apply(this,q)}}function Ka(O){return K(2,O)}Zn.Cache=kl;var br=u0(function(O,q){var fe=(q=q.length==1&&Yo(q[0])?_o(q[0],vg(Yr())):_o(ru(q,1),vg(Yr()))).length;return nr(function($e){for(var ut=-1,Dt=Eu($e.length,fe);++ut<Dt;)$e[ut]=q[ut].call(this,$e[ut]);return Gi(O,this,$e)})}),Tr=nr(function(O,q){var fe=iv(q,kb(Tr));return af(O,L,i,q,fe)}),Ud=nr(function(O,q){var fe=iv(q,kb(Ud));return af(O,z,i,q,fe)}),Vi=zp(function(O,q){return af(O,j,i,i,i,q)});function Mi(O,q){if(typeof O!="function")throw new tu(d);return nr(O,q=q===i?q:Es(q))}function Yi(O,q){if(typeof O!="function")throw new tu(d);return q=q==null?0:id(Es(q),0),nr(function(fe){var $e=fe[q],ut=hy(fe,0,q);return $e&&Ks(ut,$e),Gi(O,this,ut)})}function Jn(O,q,fe){var $e=!0,ut=!0;if(typeof O!="function")throw new tu(d);return Oc(fe)&&($e="leading"in fe?!!fe.leading:$e,ut="trailing"in fe?!!fe.trailing:ut),Xt(O,q,{leading:$e,maxWait:q,trailing:ut})}function Cr(O){return R(O,1)}function lo(O,q){return Tr(Ib(q),O)}function ho(){if(!arguments.length)return[];var O=arguments[0];return Yo(O)?O:[O]}function Hr(O){return Np(O,C)}function yh(O,q){return Np(O,C,q=typeof q=="function"?q:i)}function Tl(O){return Np(O,y|C)}function YT(O,q){return Np(O,y|C,q=typeof q=="function"?q:i)}function JP(O,q){return q==null||xd(O,q,Th(q))}function Cy(O,q){return O===q||O!=O&&q!=q}var J4=y0(Na),Y4=y0(function(O,q){return O>=q}),B_=DT(function(){return arguments}())?DT:function(O){return cu(O)&&Vl.call(O,"callee")&&!tI.call(O,"callee")},Yo=Aa.isArray,YP=TT?vg(TT):Cd;function kg(O){return O!=null&&P0(O.length)&&!Lb(O)}function Ku(O){return cu(O)&&kg(O)}function Q4(O){return O===!0||O===!1||cu(O)&&Ns(O)==ct}var F_=Uk||qI,Z4=a_?vg(a_):cm;function OI(O){return cu(O)&&O.nodeType===1&&!kS(O)}function TF(O){if(O==null)return!0;if(kg(O)&&(Yo(O)||typeof O=="string"||typeof O.splice=="function"||F_(O)||L0(O)||B_(O)))return!O.length;var q=Au(O);if(q==Zt||q==Vt)return!O.size;if(vv(O))return!v_(O).length;for(var fe in O)if(Vl.call(O,fe))return!1;return!0}function QP(O,q){return Fp(O,q)}function CF(O,q,fe){var $e=(fe=typeof fe=="function"?fe:i)?fe(O,q):i;return $e===i?Fp(O,q,i,fe):!!$e}function uR(O){if(!cu(O))return!1;var q=Ns(O);return q==vt||q==ht||typeof O.message=="string"&&typeof O.name=="string"&&!kS(O)}function i7(O){return typeof O=="number"&&wT(O)}function Lb(O){if(!Oc(O))return!1;var q=Ns(O);return q==Pt||q==ni||q==tt||q==jt}function s1(O){return typeof O=="number"&&O==Es(O)}function P0(O){return typeof O=="number"&&O>-1&&O%1==0&&O<=te}function Oc(O){var q=typeof O;return O!=null&&(q=="object"||q=="function")}function cu(O){return O!=null&&typeof O=="object"}var l1=gb?vg(gb):Vk;function c1(O,q){return O===q||Up(O,q,qk(q))}function hR(O,q,fe){return fe=typeof fe=="function"?fe:i,Up(O,q,qk(q),fe)}function d1(O){return D0(O)&&O!=+O}function u1(O){if(TI(O))throw new vl(l);return Eg(O)}function X4(O){return O===null}function ez(O){return O==null}function D0(O){return typeof O=="number"||cu(O)&&Ns(O)==it}function kS(O){if(!cu(O)||Ns(O)!=ot)return!1;var q=a0(O);if(q===null)return!0;var fe=Vl.call(q,"constructor")&&q.constructor;return typeof fe=="function"&&fe instanceof fe&&IT.call(fe)==Bk}var NI=qm?vg(qm):BP;function n7(O){return s1(O)&&O>=-9007199254740991&&O<=te}var tz=st?vg(st):lI;function U_(O){return typeof O=="string"||!Yo(O)&&cu(O)&&Ns(O)==$t}function cf(O){return typeof O=="symbol"||cu(O)&&Ns(O)==dt}var L0=di?vg(di):fS;function a7(O){return O===i}function z_(O){return cu(O)&&Au(O)==kt}function pR(O){return cu(O)&&Ns(O)==je}var zd=y0(LT),h1=y0(function(O,q){return O<=q});function xI(O){if(!O)return[];if(kg(O))return U_(O)?Qv(O):Gu(O);if(r0&&O[r0])return s_(O[r0]());var q=Au(O);return(q==Zt?t0:q==Vt?rS:vR)(O)}function Sv(O){return O?(O=Sh(O))===pe||O===-1/0?(O<0?-1:1)*Se:O==O?O:0:O===0?O:0}function Es(O){var q=Sv(O),fe=q%1;return q==q?fe?q-fe:q:0}function _F(O){return O?sy(Es(O),0,X):0}function Sh(O){if(typeof O=="number")return O;if(cf(O))return ce;if(Oc(O)){var q=typeof O.valueOf=="function"?O.valueOf():O;O=Oc(q)?q+"":q}if(typeof O!="string")return O===0?O:+O;O=ev(O);var fe=Sa.test(O);return fe||ti.test(O)?n_(O.slice(2),fe?2:8):kr.test(O)?ce:+O}function BI(O){return hm(O,Rg(O))}function RS(O){return O?sy(Es(O),-9007199254740991,te):O===0?O:0}function jl(O){return O==null?"":Ys(O)}var O0=SS(function(O,q){if(vv(q)||kg(q))hm(q,Th(q),O);else for(var fe in q)Vl.call(q,fe)&&vc(O,fe,q[fe])}),p1=SS(function(O,q){hm(q,Rg(q),O)}),gR=SS(function(O,q,fe,$e){hm(q,Rg(q),O,$e)}),iz=SS(function(O,q,fe,$e){hm(q,Th(q),O,$e)}),r7=zp(m_);function bh(O,q){var fe=ip(O);return q==null?fe:Op(fe,q)}var ZP=nr(function(O,q){O=Js(O);var fe=-1,$e=q.length,ut=$e>2?q[2]:i;for(ut&&$p(q[0],q[1],ut)&&($e=1);++fe<$e;)for(var Dt=q[fe],si=Rg(Dt),Ei=-1,Ui=si.length;++Ei<Ui;){var Nn=si[Ei],Pn=O[Nn];(Pn===i||Cy(Pn,Sb[Nn])&&!Vl.call(O,Nn))&&(O[Nn]=Dt[Nn])}return O}),g1=nr(function(O){return O.push(i,rf),Gi(rz,i,O)});function N0(O,q){return XE(O,Yr(q,3),dv)}function EF(O,q){return XE(O,Yr(q,3),_g)}function _y(O,q){return O==null?O:cv(O,Yr(q,3),Rg)}function x0(O,q){return O==null?O:Zm(O,Yr(q,3),Rg)}function FI(O,q){return O&&dv(O,Yr(q,3))}function MS(O,q){return O&&_g(O,Yr(q,3))}function m1(O){return O==null?[]:f_(O,Th(O))}function XP(O){return O==null?[]:f_(O,Rg(O))}function f1(O,q,fe){var $e=O==null?i:xp(O,q);return $e===i?fe:$e}function UI(O,q){return O!=null&&mh(O,q,lm)}function mR(O,q){return O!=null&&mh(O,q,Bp)}var nz=mI(function(O,q,fe){q!=null&&typeof q.toString!="function"&&(q=bb.call(q)),O[q]=fe},oD(uf)),eD=mI(function(O,q,fe){q!=null&&typeof q.toString!="function"&&(q=bb.call(q)),Vl.call(O,q)?O[q].push(fe):O[q]=[fe]},Yr),o7=nr(Ab);function Th(O){return kg(O)?Hu(O):v_(O)}function Rg(O){return kg(O)?Hu(O,!0):cI(O)}function az(O,q){var fe={};return q=Yr(q,3),dv(O,function($e,ut,Dt){nu(fe,q($e,ut,Dt),$e)}),fe}function s7(O,q){var fe={};return q=Yr(q,3),dv(O,function($e,ut,Dt){nu(fe,ut,q($e,ut,Dt))}),fe}var zI=SS(function(O,q,fe){vS(O,q,fe)}),rz=SS(function(O,q,fe,$e){vS(O,q,fe,$e)}),l7=zp(function(O,q){var fe={};if(O==null)return fe;var $e=!1;q=_o(q,function(Dt){return Dt=nf(Dt,O),$e||($e=Dt.length>1),Dt}),hm(O,I_(O),fe),$e&&(fe=Np(fe,y|T|C,A_));for(var ut=q.length;ut--;)um(fe,q[ut]);return fe});function B0(O,q){return oz(O,Gn(Yr(q)))}var AF=zp(function(O,q){return O==null?{}:S_(O,q)});function oz(O,q){if(O==null)return{};var fe=_o(I_(O),function($e){return[$e]});return q=Yr(q),$k(O,fe,function($e,ut){return q($e,ut[0])})}function sz(O,q,fe){var $e=-1,ut=(q=nf(q,O)).length;for(ut||(ut=1,O=i);++$e<ut;){var Dt=O==null?i:O[jc(q[$e])];Dt===i&&($e=ut,Dt=fe),O=Lb(Dt)?Dt.call(O):Dt}return O}function c7(O,q,fe){return O==null?O:Zl(O,q,fe)}function d7(O,q,fe,$e){return $e=typeof $e=="function"?$e:i,O==null?O:Zl(O,q,fe,$e)}var IF=vI(Th),v1=vI(Rg);function fR(O,q,fe){var $e=Yo(O),ut=$e||F_(O)||L0(O);if(q=Yr(q,4),fe==null){var Dt=O&&O.constructor;fe=ut?$e?new Dt:[]:Oc(O)&&Lb(Dt)?ip(a0(O)):{}}return(ut?jn:dv)(O,function(si,Ei,Ui){return q(fe,si,Ei,Ui)}),fe}function VI(O,q){return O==null||um(O,q)}function wF(O,q,fe){return O==null?O:ef(O,q,Ib(fe))}function kF(O,q,fe,$e){return $e=typeof $e=="function"?$e:i,O==null?O:ef(O,q,Ib(fe),$e)}function vR(O){return O==null?[]:fb(O,Th(O))}function $I(O){return O==null?[]:fb(O,Rg(O))}function yR(O,q,fe){return fe===i&&(fe=q,q=i),fe!==i&&(fe=(fe=Sh(fe))==fe?fe:0),q!==i&&(q=(q=Sh(q))==q?q:0),sy(Sh(O),q,fe)}function RF(O,q,fe){return q=Sv(q),fe===i?(fe=q,q=0):fe=Sv(fe),cy(O=Sh(O),q,fe)}function y1(O,q,fe){if(fe&&typeof fe!="boolean"&&$p(O,q,fe)&&(q=fe=i),fe===i&&(typeof q=="boolean"?(fe=q,q=i):typeof O=="boolean"&&(fe=O,O=i)),O===i&&q===i?(O=0,q=1):(O=Sv(O),q===i?(q=O,O=0):q=Sv(q)),O>q){var $e=O;O=q,q=$e}if(fe||O%1||q%1){var ut=h_();return Eu(O+ut*(q-O+hb("1e-"+((ut+"").length-1))),q)}return b_(O,q)}var MF=gv(function(O,q,fe){return q=q.toLowerCase(),O+(fe?S1(q):q)});function S1(O){return AR(jl(O).toLowerCase())}function b1(O){return(O=jl(O))&&O.replace(Fn,tv).replace(zu,"")}function lz(O,q,fe){O=jl(O),q=Ys(q);var $e=O.length,ut=fe=fe===i?$e:sy(Es(fe),0,$e);return(fe-=q.length)>=0&&O.slice(fe,ut)==q}function u7(O){return(O=jl(O))&&hr.test(O)?O.replace(Hn,$u):O}function tD(O){return(O=jl(O))&&Us.test(O)?O.replace(al,"\\$&"):O}var iD=gv(function(O,q,fe){return O+(fe?"-":"")+q.toLowerCase()}),SR=gv(function(O,q,fe){return O+(fe?" ":"")+q.toLowerCase()}),bR=bc("toLowerCase");function TR(O,q,fe){O=jl(O);var $e=(q=Es(q))?AT(O):0;if(!q||$e>=q)return O;var ut=(q-$e)/2;return fI(iI(ut),fe)+O+fI(Fk(ut),fe)}function CR(O,q,fe){O=jl(O);var $e=(q=Es(q))?AT(O):0;return q&&$e<q?O+fI(q-$e,fe):O}function cz(O,q,fe){O=jl(O);var $e=(q=Es(q))?AT(O):0;return q&&$e<q?fI(q-$e,fe)+O:O}function nD(O,q,fe){return fe||q==null?q=0:q&&(q=+q),KO(jl(O).replace($r,""),q||0)}function $s(O,q,fe){return q=(fe?$p(O,q,fe):q===i)?1:Es(q),ps(jl(O),q)}function HI(){var O=arguments,q=jl(O[0]);return O.length<3?q:q.replace(O[1],O[2])}var QT=gv(function(O,q,fe){return O+(fe?"_":"")+q.toLowerCase()});function Kp(O,q,fe){return fe&&typeof fe!="number"&&$p(O,q,fe)&&(q=fe=i),(fe=fe===i?X:fe>>>0)?(O=jl(O))&&(typeof q=="string"||q!=null&&!NI(q))&&!(q=Ys(q))&&rm(O)?hy(Qv(O),0,fe):O.split(q,fe):[]}var jI=gv(function(O,q,fe){return O+(fe?" ":"")+AR(q)});function df(O,q,fe){return O=jl(O),fe=fe==null?0:sy(Es(fe),0,O.length),q=Ys(q),O.slice(fe,fe+q.length)==q}function _R(O,q,fe){var $e=Tt.templateSettings;fe&&$p(O,q,fe)&&(q=i),O=jl(O),q=gR({},q,$e,Gk);var ut,Dt,si=gR({},q.imports,$e.imports,Gk),Ei=Th(si),Ui=fb(si,Ei),Nn=0,Pn=q.interpolate||Or,Yn="__p += '",Wa=xk((q.escape||Or).source+"|"+Pn.source+"|"+(Pn===Ho?Pa:Or).source+"|"+(q.evaluate||Or).source+"|$","g"),_r="//# sourceURL="+(Vl.call(q,"sourceURL")?(q.sourceURL+"").replace(/\s/g," "):"lodash.templateSources["+ ++ub+"]")+`
`;O.replace(Wa,function(Oo,ec,dl,Jp,Ay,V_){return dl||(dl=Jp),Yn+=O.slice(Nn,V_).replace(Co,vb),ec&&(ut=!0,Yn+=`' +
__e(`+ec+`) +
'`),Ay&&(Dt=!0,Yn+=`';
`+Ay+`;
__p += '`),dl&&(Yn+=`' +
((__t = (`+dl+`)) == null ? '' : __t) +
'`),Nn=V_+Oo.length,Oo}),Yn+=`';
`;var bo=Vl.call(q,"variable")&&q.variable;if(bo){if(pn.test(bo))throw new vl(h)}else Yn=`with (obj) {
`+Yn+`
}
`;Yn=(Dt?Yn.replace(qt,""):Yn).replace(ri,"$1").replace(Ti,"$1;"),Yn="function("+(bo||"obj")+`) {
`+(bo?"":`obj || (obj = {});
`)+"var __t, __p = ''"+(ut?", __e = _.escape":"")+(Dt?`, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
`:`;
`)+Yn+`return __p
}`;var Qo=uz(function(){return tp(Ei,_r+"return "+Yn).apply(i,Ui)});if(Qo.source=Yn,uR(Qo))throw Qo;return Qo}function T1(O){return jl(O).toLowerCase()}function PF(O){return jl(O).toUpperCase()}function ER(O,q,fe){if((O=jl(O))&&(fe||q===i))return ev(O);if(!O||!(q=Ys(q)))return O;var $e=Qv(O),ut=Qv(q);return hy($e,ET($e,ut),Yv($e,ut)+1).join("")}function aD(O,q,fe){if((O=jl(O))&&(fe||q===i))return O.slice(0,ZA(O)+1);if(!O||!(q=Ys(q)))return O;var $e=Qv(O);return hy($e,0,Yv($e,Qv(q))+1).join("")}function rD(O,q,fe){if((O=jl(O))&&(fe||q===i))return O.replace($r,"");if(!O||!(q=Ys(q)))return O;var $e=Qv(O);return hy($e,ET($e,Qv(q))).join("")}function dz(O,q){var fe=Z,$e=re;if(Oc(q)){var ut="separator"in q?q.separator:ut;fe="length"in q?Es(q.length):fe,$e="omission"in q?Ys(q.omission):$e}var Dt=(O=jl(O)).length;if(rm(O)){var si=Qv(O);Dt=si.length}if(fe>=Dt)return O;var Ei=fe-AT($e);if(Ei<1)return $e;var Ui=si?hy(si,0,Ei).join(""):O.slice(0,Ei);if(ut===i)return Ui+$e;if(si&&(Ei+=Ui.length-Ei),NI(ut)){if(O.slice(Ei).search(ut)){var Nn,Pn=Ui;for(ut.global||(ut=xk(ut.source,jl(qa.exec(ut))+"g")),ut.lastIndex=0;Nn=ut.exec(Pn);)var Yn=Nn.index;Ui=Ui.slice(0,Yn===i?Ei:Yn)}}else if(O.indexOf(Ys(ut),Ei)!=Ei){var Wa=Ui.lastIndexOf(ut);Wa>-1&&(Ui=Ui.slice(0,Wa))}return Ui+$e}function C1(O){return(O=jl(O))&&ha.test(O)?O.replace(rn,MP):O}var h7=gv(function(O,q,fe){return O+(fe?" ":"")+q.toUpperCase()}),AR=bc("toUpperCase");function _1(O,q,fe){return O=jl(O),(q=fe?i:q)===i?yb(O)?PP(O):Jv(O):O.match(q)||[]}var uz=nr(function(O,q){try{return Gi(O,i,q)}catch(fe){return uR(fe)?fe:new vl(fe)}}),p7=zp(function(O,q){return jn(q,function(fe){fe=jc(fe),nu(O,fe,ae(O[fe],O))}),O});function DF(O){var q=O==null?0:O.length,fe=Yr();return O=q?_o(O,function($e){if(typeof $e[1]!="function")throw new tu(d);return[fe($e[0]),$e[1]]}):[],nr(function($e){for(var ut=-1;++ut<q;){var Dt=O[ut];if(Gi(Dt[0],this,$e))return Gi(Dt[1],this,$e)}})}function hz(O){return ju(Np(O,y))}function oD(O){return function(){return O}}function g7(O,q){return O==null||O!=O?q:O}var m7=mv(),pz=mv(!0);function uf(O){return O}function LF(O){return hv(typeof O=="function"?O:Np(O,y))}function gz(O){return c0(Np(O,y))}function mz(O,q){return dy(O,Np(q,y))}var sD=nr(function(O,q){return function(fe){return Ab(fe,O,q)}}),OF=nr(function(O,q){return function(fe){return Ab(O,fe,q)}});function E1(O,q,fe){var $e=Th(q),ut=f_(q,$e);fe!=null||Oc(q)&&(ut.length||!$e.length)||(fe=q,q=O,O=this,ut=f_(q,Th(q)));var Dt=!(Oc(fe)&&"chain"in fe&&!fe.chain),si=Lb(O);return jn(ut,function(Ei){var Ui=q[Ei];O[Ei]=Ui,si&&(O.prototype[Ei]=function(){var Nn=this.__chain__;if(Dt||Nn){var Pn=O(this.__wrapped__);return(Pn.__actions__=Gu(this.__actions__)).push({func:Ui,args:arguments,thisArg:O}),Pn.__chain__=Nn,Pn}return Ui.apply(O,Ks([this.value()],arguments))})}),O}function ZT(){return Os._===this&&(Os._=eI),this}function GI(){}function fz(O){return O=Es(O),nr(function(q){return yS(q,O)})}var bv=f0(_o),Ey=f0(Oa),NF=f0(hs);function A1(O){return Kk(O)?e0(jc(O)):Hk(O)}function lD(O){return function(q){return O==null?i:xp(O,q)}}var I1=$T(),xF=$T(!0);function BF(){return[]}function qI(){return!1}function WI(){return{}}function w1(){return""}function vz(){return!0}function k1(O,q){if((O=Es(O))<1||O>te)return[];var fe=X,$e=Eu(O,X);q=Yr(q),O-=X;for(var ut=hh($e,q);++fe<O;)q(fe);return ut}function FF(O){return Yo(O)?_o(O,jc):cf(O)?[O]:Gu(fh(jl(O)))}function UF(O){var q=++i0;return jl(O)+q}var R1=VT(function(O,q){return O+q},0),f7=S0("ceil"),M1=VT(function(O,q){return O/q},1),yz=S0("floor");function Sz(O){return O&&O.length?pS(O,uf,Na):i}function P1(O,q){return O&&O.length?pS(O,Yr(q,2),Na):i}function v7(O){return r_(O,uf)}function y7(O,q){return r_(O,Yr(q,2))}function bz(O){return O&&O.length?pS(O,uf,LT):i}function Tz(O,q){return O&&O.length?pS(O,Yr(q,2),LT):i}var zF,S7=VT(function(O,q){return O*q},1),b7=S0("round"),VF=VT(function(O,q){return O-q},0);function D1(O){return O&&O.length?Nk(O,uf):0}function KI(O,q){return O&&O.length?Nk(O,Yr(q,2)):0}return Tt.after=A,Tt.ary=R,Tt.assign=O0,Tt.assignIn=p1,Tt.assignInWith=gR,Tt.assignWith=iz,Tt.at=r7,Tt.before=K,Tt.bind=ae,Tt.bindAll=p7,Tt.bindKey=Ce,Tt.castArray=ho,Tt.chain=i1,Tt.chunk=UP,Tt.compact=fm,Tt.concat=bF,Tt.cond=DF,Tt.conforms=hz,Tt.constant=oD,Tt.countBy=N_,Tt.create=bh,Tt.curry=Ve,Tt.curryRight=mt,Tt.debounce=Xt,Tt.defaults=ZP,Tt.defaultsDeep=g1,Tt.defer=Si,Tt.delay=Zi,Tt.difference=zP,Tt.differenceBy=jp,Tt.differenceWith=Bd,Tt.drop=M_,Tt.dropRight=ZO,Tt.dropRightWhile=HT,Tt.dropWhile=jT,Tt.fill=Lc,Tt.filter=WT,Tt.flatMap=a1,Tt.flatMapDeep=rR,Tt.flatMapDepth=r1,Tt.flatten=ad,Tt.flattenDeep=vh,Tt.flattenDepth=Gp,Tt.flip=Kn,Tt.flow=m7,Tt.flowRight=pz,Tt.fromPairs=A0,Tt.functions=m1,Tt.functionsIn=XP,Tt.groupBy=sR,Tt.initial=CS,Tt.intersection=P_,Tt.intersectionBy=Qk,Tt.intersectionWith=EI,Tt.invert=nz,Tt.invertBy=eD,Tt.invokeMap=lR,Tt.iteratee=LF,Tt.keyBy=M0,Tt.keys=Th,Tt.keysIn=Rg,Tt.map=PI,Tt.mapKeys=az,Tt.mapValues=s7,Tt.matches=gz,Tt.matchesProperty=mz,Tt.memoize=Zn,Tt.merge=zI,Tt.mergeWith=rz,Tt.method=sD,Tt.methodOf=OF,Tt.mixin=E1,Tt.negate=Gn,Tt.nthArg=fz,Tt.omit=l7,Tt.omitBy=B0,Tt.once=Ka,Tt.orderBy=KT,Tt.over=bv,Tt.overArgs=br,Tt.overEvery=Ey,Tt.overSome=NF,Tt.partial=Tr,Tt.partialRight=Ud,Tt.partition=WP,Tt.pick=AF,Tt.pickBy=oz,Tt.property=A1,Tt.propertyOf=lD,Tt.pull=GT,Tt.pullAll=_S,Tt.pullAllBy=ES,Tt.pullAllWith=AI,Tt.pullAt=wg,Tt.range=I1,Tt.rangeRight=xF,Tt.rearg=Vi,Tt.reject=LI,Tt.remove=AS,Tt.rest=Mi,Tt.reverse=vy,Tt.sampleSize=KP,Tt.set=c7,Tt.setWith=d7,Tt.shuffle=by,Tt.slice=cl,Tt.sortBy=JT,Tt.sortedUniq=II,Tt.sortedUniqBy=D_,Tt.split=Kp,Tt.spread=Yi,Tt.tail=yv,Tt.take=Zk,Tt.takeRight=lf,Tt.takeRightWhile=Xk,Tt.takeWhile=eR,Tt.tap=n1,Tt.throttle=Jn,Tt.thru=iR,Tt.toArray=xI,Tt.toPairs=IF,Tt.toPairsIn=v1,Tt.toPath=FF,Tt.toPlainObject=BI,Tt.transform=fR,Tt.unary=Cr,Tt.union=IS,Tt.unionBy=VP,Tt.unionWith=Sy,Tt.uniq=XO,Tt.uniqBy=wI,Tt.uniqWith=tR,Tt.unset=VI,Tt.unzip=k0,Tt.unzipWith=$P,Tt.update=wF,Tt.updateWith=kF,Tt.values=vR,Tt.valuesIn=$I,Tt.without=HP,Tt.words=_1,Tt.wrap=lo,Tt.xor=kI,Tt.xorBy=jP,Tt.xorWith=qT,Tt.zip=e1,Tt.zipObject=L_,Tt.zipObjectDeep=t1,Tt.zipWith=od,Tt.entries=IF,Tt.entriesIn=v1,Tt.extend=p1,Tt.extendWith=gR,E1(Tt,Tt),Tt.add=R1,Tt.attempt=uz,Tt.camelCase=MF,Tt.capitalize=S1,Tt.ceil=f7,Tt.clamp=yR,Tt.clone=Hr,Tt.cloneDeep=Tl,Tt.cloneDeepWith=YT,Tt.cloneWith=yh,Tt.conformsTo=JP,Tt.deburr=b1,Tt.defaultTo=g7,Tt.divide=M1,Tt.endsWith=lz,Tt.eq=Cy,Tt.escape=u7,Tt.escapeRegExp=tD,Tt.every=lu,Tt.find=aR,Tt.findIndex=gs,Tt.findKey=N0,Tt.findLast=R0,Tt.findLastIndex=Fd,Tt.findLastKey=EF,Tt.floor=yz,Tt.forEach=MI,Tt.forEachRight=oR,Tt.forIn=_y,Tt.forInRight=x0,Tt.forOwn=FI,Tt.forOwnRight=MS,Tt.get=f1,Tt.gt=J4,Tt.gte=Y4,Tt.has=UI,Tt.hasIn=mR,Tt.head=su,Tt.identity=uf,Tt.includes=wS,Tt.indexOf=I0,Tt.inRange=RF,Tt.invoke=o7,Tt.isArguments=B_,Tt.isArray=Yo,Tt.isArrayBuffer=YP,Tt.isArrayLike=kg,Tt.isArrayLikeObject=Ku,Tt.isBoolean=Q4,Tt.isBuffer=F_,Tt.isDate=Z4,Tt.isElement=OI,Tt.isEmpty=TF,Tt.isEqual=QP,Tt.isEqualWith=CF,Tt.isError=uR,Tt.isFinite=i7,Tt.isFunction=Lb,Tt.isInteger=s1,Tt.isLength=P0,Tt.isMap=l1,Tt.isMatch=c1,Tt.isMatchWith=hR,Tt.isNaN=d1,Tt.isNative=u1,Tt.isNil=ez,Tt.isNull=X4,Tt.isNumber=D0,Tt.isObject=Oc,Tt.isObjectLike=cu,Tt.isPlainObject=kS,Tt.isRegExp=NI,Tt.isSafeInteger=n7,Tt.isSet=tz,Tt.isString=U_,Tt.isSymbol=cf,Tt.isTypedArray=L0,Tt.isUndefined=a7,Tt.isWeakMap=z_,Tt.isWeakSet=pR,Tt.join=vm,Tt.kebabCase=iD,Tt.last=ym,Tt.lastIndexOf=w0,Tt.lowerCase=SR,Tt.lowerFirst=bR,Tt.lt=zd,Tt.lte=h1,Tt.max=Sz,Tt.maxBy=P1,Tt.mean=v7,Tt.meanBy=y7,Tt.min=bz,Tt.minBy=Tz,Tt.stubArray=BF,Tt.stubFalse=qI,Tt.stubObject=WI,Tt.stubString=w1,Tt.stubTrue=vz,Tt.multiply=S7,Tt.nth=Sm,Tt.noConflict=ZT,Tt.noop=GI,Tt.now=Ty,Tt.pad=TR,Tt.padEnd=CR,Tt.padStart=cz,Tt.parseInt=nD,Tt.random=y1,Tt.reduce=DI,Tt.reduceRight=cR,Tt.repeat=$s,Tt.replace=HI,Tt.result=sz,Tt.round=b7,Tt.runInContext=Oi,Tt.sample=o1,Tt.size=dR,Tt.snakeCase=QT,Tt.some=x_,Tt.sortedIndex=Mb,Tt.sortedIndexBy=rd,Tt.sortedIndexOf=Iu,Tt.sortedLastIndex=yy,Tt.sortedLastIndexBy=sp,Tt.sortedLastIndexOf=qp,Tt.startCase=jI,Tt.startsWith=df,Tt.subtract=VF,Tt.sum=D1,Tt.sumBy=KI,Tt.template=_R,Tt.times=k1,Tt.toFinite=Sv,Tt.toInteger=Es,Tt.toLength=_F,Tt.toLower=T1,Tt.toNumber=Sh,Tt.toSafeInteger=RS,Tt.toString=jl,Tt.toUpper=PF,Tt.trim=ER,Tt.trimEnd=aD,Tt.trimStart=rD,Tt.truncate=dz,Tt.unescape=C1,Tt.uniqueId=UF,Tt.upperCase=h7,Tt.upperFirst=AR,Tt.each=MI,Tt.eachRight=oR,Tt.first=su,E1(Tt,(zF={},dv(Tt,function(O,q){Vl.call(Tt.prototype,q)||(zF[q]=O)}),zF),{chain:!1}),Tt.VERSION=r,jn(["bind","bindKey","curry","curryRight","partial","partialRight"],function(O){Tt[O].placeholder=Tt}),jn(["drop","take"],function(O,q){Lo.prototype[O]=function(fe){fe=fe===i?1:id(Es(fe),0);var $e=this.__filtered__&&!q?new Lo(this):this.clone();return $e.__filtered__?$e.__takeCount__=Eu(fe,$e.__takeCount__):$e.__views__.push({size:Eu(fe,X),type:O+($e.__dir__<0?"Right":"")}),$e},Lo.prototype[O+"Right"]=function(fe){return this.reverse()[O](fe).reverse()}}),jn(["filter","map","takeWhile"],function(O,q){var fe=q+1,$e=fe==he||fe==Le;Lo.prototype[O]=function(ut){var Dt=this.clone();return Dt.__iteratees__.push({iteratee:Yr(ut,3),type:fe}),Dt.__filtered__=Dt.__filtered__||$e,Dt}}),jn(["head","last"],function(O,q){var fe="take"+(q?"Right":"");Lo.prototype[O]=function(){return this[fe](1).value()[0]}}),jn(["initial","tail"],function(O,q){var fe="drop"+(q?"":"Right");Lo.prototype[O]=function(){return this.__filtered__?new Lo(this):this[fe](1)}}),Lo.prototype.compact=function(){return this.filter(uf)},Lo.prototype.find=function(O){return this.filter(O).head()},Lo.prototype.findLast=function(O){return this.reverse().find(O)},Lo.prototype.invokeMap=nr(function(O,q){return typeof O=="function"?new Lo(this):this.map(function(fe){return Ab(fe,O,q)})}),Lo.prototype.reject=function(O){return this.filter(Gn(Yr(O)))},Lo.prototype.slice=function(O,q){O=Es(O);var fe=this;return fe.__filtered__&&(O>0||q<0)?new Lo(fe):(O<0?fe=fe.takeRight(-O):O&&(fe=fe.drop(O)),q!==i&&(fe=(q=Es(q))<0?fe.dropRight(-q):fe.take(q-O)),fe)},Lo.prototype.takeRightWhile=function(O){return this.reverse().takeWhile(O).reverse()},Lo.prototype.toArray=function(){return this.take(X)},dv(Lo.prototype,function(O,q){var fe=/^(?:filter|find|map|reject)|While$/.test(q),$e=/^(?:head|last)$/.test(q),ut=Tt[$e?"take"+(q=="last"?"Right":""):q],Dt=$e||/^find/.test(q);ut&&(Tt.prototype[q]=function(){var si=this.__wrapped__,Ei=$e?[1]:arguments,Ui=si instanceof Lo,Nn=Ei[0],Pn=Ui||Yo(si),Yn=function(ec){var dl=ut.apply(Tt,Ks([ec],Ei));return $e&&Wa?dl[0]:dl};Pn&&fe&&typeof Nn=="function"&&Nn.length!=1&&(Ui=Pn=!1);var Wa=this.__chain__,_r=!!this.__actions__.length,bo=Dt&&!Wa,Qo=Ui&&!_r;if(!Dt&&Pn){si=Qo?si:new Lo(this);var Oo=O.apply(si,Ei);return Oo.__actions__.push({func:iR,args:[Yn],thisArg:i}),new ph(Oo,Wa)}return bo&&Qo?O.apply(this,Ei):(Oo=this.thru(Yn),bo?$e?Oo.value()[0]:Oo.value():Oo)})}),jn(["pop","push","shift","sort","splice","unshift"],function(O){var q=sS[O],fe=/^(?:push|sort|unshift)$/.test(O)?"tap":"thru",$e=/^(?:pop|shift)$/.test(O);Tt.prototype[O]=function(){var ut=arguments;if($e&&!this.__chain__){var Dt=this.value();return q.apply(Yo(Dt)?Dt:[],ut)}return this[fe](function(si){return q.apply(Yo(si)?si:[],ut)})}}),dv(Lo.prototype,function(O,q){var fe=Tt[q];if(fe){var $e=fe.name+"";Vl.call(Sg,$e)||(Sg[$e]=[]),Sg[$e].push({name:q,func:fe})}}),Sg[m0(i,D).name]=[{name:"wrapper",func:i}],Lo.prototype.clone=oI,Lo.prototype.reverse=Tb,Lo.prototype.value=sI,Tt.prototype.at=Pb,Tt.prototype.chain=RI,Tt.prototype.commit=O_,Tt.prototype.next=GP,Tt.prototype.plant=qP,Tt.prototype.reverse=nR,Tt.prototype.toJSON=Tt.prototype.valueOf=Tt.prototype.value=Db,Tt.prototype.first=Tt.prototype.head,r0&&(Tt.prototype[r0]=Wp),Tt},c_=XA();bd?((bd.exports=c_)._=c_,dh._=c_):Os._=c_}).call(fo)});function Cxt(){return new Date().toISOString()}function _xt(t,e){if(Array.isArray(t))return e.slice()}function fhe(t){try{const e=typeof t=="string"?new URL(t):t;return`${e.protocol}//${e.host}${e.pathname}`}catch{return""}}function eBe(t){return Array.isArray(t)&&t.length!==0}function vO(t){return t==null||t===void 0}function Ext(t,e){return t!==void 0?t:e}function Axt(t){return!!t&&typeof t.then=="function"}function YY(t){try{return JSON.stringify(t,null,2)}catch{return`failed to stringify obj ${t}`}}function Ixt(t){return new RegExp(vxt).test(t)}function wxt(t,e){const l=/^(.+)@([^@]+)$/,d=t.match(l),h=d?.[2],p=d?.length===3?d[1]:t,g=p.length>e?`${p.substring(0,e)}***`:p;return h?`${g}@${h}`:g}const kxt=(t,e,i)=>{const r=document.documentElement.clientWidth/document.documentElement.clientHeight,o=Math.max(r,1),l=1/o,d=.001,h=.5,p=.5,g=4.5,f=11.5,y=.75,T=24,C=1,E=Math.min(t,e)*d*o;return{scaledFontSize:T*Math.max(y,E)*l,scaledBorderSize:C*Math.max(1,E)*l,scaledHorizontalGap:p*Math.max(h,Math.min(1,E)),scaledVerticalGap:Math.max(f*Math.min(1,E),g*o)}},Rxt=t=>{const e=tBe(90-t),i=1/Math.cos(tBe(t)),r=1/Math.cos(e),o=Math.tan(e);return(l,d)=>l<o*d?l*i:d*r},tBe=t=>t*(Math.PI/180),Mxt={"audio.send":{bitrate:{min:0,max:535500},packetsPerSecond:{min:0,max:200},packetsLostPerSecond:{min:0,max:200}},"audio.receive":{bitrate:{min:0,max:535500},packetsPerSecond:{min:0,max:200},packetsLostPerSecond:{min:0,max:200}},"video.send":{bitrate:{min:0,max:8e6},packetsPerSecond:{min:0,max:1e3},packetsLostPerSecond:{min:0,max:1e3},frameRateInput:{min:0,max:66},frameRateEncoded:{min:0,max:66},frameRateSent:{min:0,max:66}},"video.receive":{bitrate:{min:0,max:8e6},packetsPerSecond:{min:0,max:1e3},packetsLostPerSecond:{min:0,max:1e3},frameRateOutput:{min:0,max:66},frameRateDecoded:{min:0,max:66},frameRateReceived:{min:0,max:66}},"screenShare.send":{bitrate:{min:0,max:8e6},packetsPerSecond:{min:0,max:1e3},packetsLostPerSecond:{min:0,max:1e3},frameRateInput:{min:0,max:33},frameRateEncoded:{min:0,max:33},frameRateSent:{min:0,max:33}},"screenShare.receive":{bitrate:{min:0,max:8e6},packetsPerSecond:{min:0,max:1e3},packetsLostPerSecond:{min:0,max:1e3},frameRateOutput:{min:0,max:33},frameRateDecoded:{min:0,max:33},frameRateReceived:{min:0,max:33}}};var QY,yO,OA,Ar,ZY,vhe,A3,hk,TB,XY,CB,I3,iBe,yhe,w3,k3,VC,nBe,rP,To,eQ,mT,tQ;(function(t){t.Outgoing="Outgoing",t.Incoming="Incoming",t.TransferOutgoing="TransferOutgoing"})(QY||(QY={})),function(t){t.CreateCallAgent="CreateCallAgent",t.CreateTeamsCallAgent="CreateTeamsCallAgent",t.GetDeviceManager="GetDeviceManager",t.GetEnvironmentInfo="GetEnvironmentInfo",t.GetSDKVersion="GetSDKVersion",t.Feature="Feature"}(yO||(yO={})),function(t){t.StartCall="StartCall",t.Join="Join",t.HandlePushNotification="HandlePushNotification",t.Initialize="Initialize",t.Dispose="Dispose",t.CreateCall="CreateCall",t.Feature="Feature"}(OA||(OA={})),function(t){t.Call="Call",t.StartCall="StartCall",t.CallGroup="CallGroup",t.JoinGroup="JoinGroup",t.Accept="Accept",t.Reject="Reject",t.Mute="Mute",t.Unmute="Unmute",t.MuteAllRemoteParticipants="MuteAllRemoteParticipants",t.MuteIncomingAudio="MuteIncomingAudio",t.UnmuteIncomingAudio="UnmuteIncomingAudio",t.SendDtmf="SendDtmf",t.HangUp="HangUp",t.StartVideo="StartVideo",t.StartAudio="StartAudio",t.StopAudio="StopAudio",t.StopVideo="StopVideo",t.AddParticipant="AddParticipant",t.RemoveParticipant="RemoveParticipant",t.LobbyAdmitParticipant="LobbyAdmitParticipant",t.LobbyRejectParticipant="LobbyRejectParticipant",t.LobbyAdmitAll="LobbyAdmitAll",t.Hold="Hold",t.Resume="Resume",t.StartScreenShare="StartScreenShare",t.StopScreenShare="StopScreenShare",t.Transfer="Transfer",t.BindToCall="BindToCall",t.Feature="Feature",t.SetConstraints="SetConstraints"}(Ar||(Ar={})),function(t){t.Mute="Mute"}(ZY||(ZY={})),function(t){t.GetServerCallId="GetServerCallId"}(vhe||(vhe={})),function(t){t.CreateStackBase="CreateStackBase",t.GetDeviceManager="GetDeviceManager",t.InitializeStackForUser="InitializeStackForUser",t.InitializeEcsBase="InitializeEcsBase",t.InitializeEcsForUser="InitializeEcsForUser",t.Dispose="Dispose"}(A3||(A3={})),function(t){t.GetDeviceManager="GetDeviceManager",t.GetCameras="GetCameras",t.GetMicrophones="GetMicrophones",t.GetSpeakers="GetSpeakers",t.GetCamera="GetCamera",t.SelectCamera="SelectCamera",t.GetSelectedMicrophone="GetSelectedMicrophone",t.SelectMicrophone="SelectMicrophone",t.GetSelectedSpeaker="GetSelectedSpeaker",t.SelectSpeaker="SelectSpeaker",t.RenderPreviewVideo="RenderPreviewVideo",t.AskDevicePermission="AskDevicePermission"}(hk||(hk={})),function(t){t.Dispose="Dispose",t.UpdateScalingMode="UpdateScalingMode",t.Render="Render",t.RenderRemoteStream="RenderRemoteStream",t.RenderLocalStream="RenderLocalStream"}(TB||(TB={})),function(t){t.Dispose="Dispose",t.CreateView="CreateView"}(XY||(XY={})),function(t){t.SwitchSource="SwitchSource",t.Render="Render",t.GetMediaStream="GetMediaStream",t.SetMediaStream="SetMediaStream",t.SwitchVideo="SwitchVideo",t.Feature="Feature"}(CB||(CB={})),function(t){t.SwitchSource="SwitchSource",t.GetMediaStream="GetMediaStream",t.SetMediaStream="SetMediaStream",t.Feature="Feature"}(I3||(I3={})),function(t){t.SetScalingMode="SetScalingMode",t.Start="Start",t.Stop="Stop",t.SwitchDevice="SwitchDevice",t.Dispose="Dispose"}(iBe||(iBe={})),function(t){t.Render="Render",t.GetMediaStream="GetMediaStream"}(yhe||(yhe={})),function(t){t.Start="Start",t.Resume="Resume",t.Pause="Pause",t.SetScalingMode="SetScalingMode",t.Dispose="Dispose"}(w3||(w3={})),function(t){t.Start="Start",t.Resume="Resume",t.Pause="Pause",t.SetScalingMode="SetScalingMode",t.Dispose="Dispose",t.SetSourceObject="SetSourceObject"}(k3||(k3={})),function(t){t.SourceUnavailableError="SourceUnavailableError",t.permissionDeniedError="permissionDeniedError",t.PermissionDeniedError="PermissionDeniedError",t.DevicesNotFoundError="DevicesNotFoundError",t.MediaStreamRequestError="MediaStreamRequestError",t.PermissionsDeniedBySystem="PermissionsDeniedBySystem",t.UnknownFailureForVideoOperation="UnknownFailureForVideoOperation",t.noDeviceSelected="noDeviceSelected",t.NoDeviceSelected="NoDeviceSelected",t.MediaStreamRequestTimedout="MediaStreamRequestTimedout",t.UnsupportedStream="UnsupportedStream",t.ConstraintNotSatisfiedError="ConstraintNotSatisfiedError"}(VC||(VC={})),function(t){t.BrowserNotSupported="BrowserNotSupported",t.IncompatibleVersions="IncompatibleVersions"}(nBe||(nBe={})),function(t){t.JoinTeamMeeting="JoinTeamMeeting",t.JoinRoom="JoinRoom",t.JoinWithGroupId="JoinWithGroupId",t.PlaceCall="PlaceCall",t.AcceptCall="AcceptCall",t.TransferToParticipant="TransferToParticipant",t.TransferToCall="TransferToCall",t.CallQueue="CallQueue"}(rP||(rP={})),function(t){t.TeamsMeeting="TeamsMeeting",t.Rooms="Rooms",t.GroupIdCall="GroupIdCall",t.TwoParty="TwoParty",t.MultiParty="MultiParty"}(To||(To={})),function(t){t.Enabled="Enabled",t.UserOverride="UserOverride",t.Disabled="Disabled"}(eQ||(eQ={})),function(t){t.Standard="standard",t.MusicOnHold="musicOnHold"}(mT||(mT={})),function(t){t.Disabled="Disabled",t.EnabledOutgoingIncoming="EnabledOutgoingIncoming"}(tQ||(tQ={}));const iQ={telemetry:{callStatsFlushTimeout:_Nt,discardedTelemetryRetryTimeout:ENt,discardedEventsBufferMaxLength:ANt,discardedEventsMaxRetries:INt,telemetryFlushTimeout:bNt,asyncTelemetryFlush:!0,allowedEvents:[],blockedEvents:["acs_calling_feature_usage","acs_calling_call_client_init"],blockedKindOfEvents:[{name:"acs_calling_token_expiration_changed",kindOfEvents:["attempt","success"]}],blockedEventsByProperty:[{name:"",properties:[]}],limit:{outSideCall:{enabled:!1,deltaTimeInMs:15e3,includedEvents:[],excludedEvents:[]},rates:[]},telemetryBeforeUnload:!1,gzipTelemetryPayload:!0,localStorageEnable:!1,speakingWhileMutedThrottleInterval:18e4,mediaStatsConfig:{enabled:!0,throttleTelemetry:1,aggregationInterval:10,dataPointsPerAggregation:6,metricsProperties:{},dataToSend:{raw:!1,min:!0,max:!0,sum:!0,count:!0},enableNetworkInformation:!1,enableMemoryInformationV1:!1,enableMemoryInformationV2:!1,enableBatteryInformation:!1,enablePressureInformation:!1,enableAudioLeakInformation:!1,audioLeakThreshold:46e-5,enableVideoLeakInformation:!1,enableVideoMaxCapCallStats:!1,enableRenderCountCheck:!1},liveStreamStatsConfig:{enabled:!1,aggregationInterval:10,dataPointsPerAggregation:6,additionalStats:{},dataToSend:{raw:!1,min:!0,max:!0,sum:!0,count:!0}},reportSdkUaToService:!0,reportEnvToService:!0,sendNetworkChangedTelemetry:!1,deviceChangedEvents:{enabled:!0,piiSafeWordsMode:"merge",piiSafeWords:fNt},progressEvents:{enableOvcChangedEvent:!0},maxExistingReportedParticipants:25,sendNetworkInfo:!1,apiCauseIdHeader:"X-Microsoft-Skype-Message-ID"},ecsClient:{throttling:{triggerCount:5,triggerDuration:1e4,coolDownDuration:3e5,startingDelay:3e3,maxDelay:6e4,delayFactor:2}},mediaStats:{blockMetrics:{},transformMetrics:{},activeState:[3,10,9],fetchInterval:1,aggregationInterval:10,dataPointsPerAggregation:6,pollingMethod:"interval",timerThrottlingFilter:{enabled:!1,delayRatio:0,filterRange:Mxt}},liveStreamStats:{activeState:[3],fetchInterval:1,aggregationInterval:10,dataPointsPerAggregation:6,pollingMethod:"interval"},debugInfo:{broadcastChannelName:wNt,tabsBroadcastDelay:kNt,tabsUpdateDelay:RNt,enableLogDump:MNt,maxLogDumpLength:Nxe,includeList:[],excludeList:[]},volumeIndicator:{fftSize:PNt,minDecibels:BNt,maxDecibels:DNt,smoothingConstant:LNt,microphoneVolumeSampleIntervalMs:ONt,normalisedMaxVolume:NNt,maxAvailableVolume:xNt},telemetryEvents:{eventNameToPriority:{eventName:["acs_calling_call_stats"],priority:[Uj.Immediate]}},rendering:{remoteVideo:{createViewTimeout:FNt,maxRendererRetries:1,speedupCreateViewWithPlayEvent:!1,createViewUnsubscribeTimeout:UNt,debounceTimeout:zNt,createViewSendMediaStats:!0,createViewSendMediaStatsMaxLength:120,createViewSendMediaStatsInitialMaxLength:1,createViewFailureNetworkUfdCheckWindowInMs:2e3,forceCheckIfVideoWasAttachedToDom:!0,checkIfVideoAttachedToDom_poll:!0,checkIfVideoAttachedToDom_intervalTime:VNt,checkIfVideoAttachedToDom_intervalMaxTries:$Nt,checkIfVideoAttachedToDom_timeout:HNt,createViewSenderStatsDuration:jNt,registeredViewIdsMaxLength:GNt,getMediaStreamTimeout:qNt,largeMeeting:{handleVideoRendering:!0,participantCountThreshold:WNt,dominantSpeakersWithVideoOn_topCount:KNt},decrementOvcOnRemoteSsRendering:!1,decrementOvcValue:3}},captions:{acsBotMri:Bxe,teamsBotMri:Fxe,teamsGccBotMri:Uxe,clientInfo:zxe,availableLanguages:she,enabled:!0,dataChannelId:XNt,useCapabilities:!0,setBotMetadataWhenEmptyFix:!0,acs:{enabled:!0,botMri:Bxe,modeKey:Vxe,modeVal:$xe,modesKey:oxt,modesVal:Hxe,clientInfo:{ring:zxe},spokenLanguages:{enabled:!0,languages:she}},teams:{enabled:!0,legacyBotMri:ext,botMri:Fxe,gccBotMri:Uxe,modeKey:Vxe,modeVal:rxt,modesKey:sxt,modesVal:Hxe,clientInfo:{ring:txt},spokenLanguages:{enabled:!0,languages:she},captionLanguages:{enabled:!1,languages:ixt}}},audioEffects:{enableAudioEffects:!1,maxStringLengthForTelemetry:250},videoEffects:{enableVideoEffects:!1,imageTransparencyCheckTimeoutInMs:1e3,effectInitTimeThresholdInMs:2e4,fpsWarningThreshold:5,waitTimeToInitiateFpsChecksInMs:2e4,fpsCheckIntervalTimeInMs:3e3,maxStringLengthForTelemetry:250},calling:{enableMuteOthers:!0,enableSmePassFakeConversation:!1,doNotWaitForTrouter:!0,hangUpCallOnPageHide:!1,maxNumberOfTokenFetchRetries:10,deviceSelectionTimeoutInMs:3e3,deviceNotFunctioningMuted:!0,muteUnmuteOnMicrophoneNotFunctioning:!1,unmuteDelayForMicrophoneNotFunctioningInMs:0,preventStopAudio:!1,preventFakeMute:!1,osAutoRecoverAudio:!1,deviceCaptureMuteRecover:!1,allowMuteOnBadUfd:!0,preventStopVideo:!0,mediaMetricsDeviceEventsEnabled:!1,allowAccessRawMediaStream:!1,applyViewLimit:!0,deviceCaptureMutedVideo:!0,removeLvsCheckOnCallStartAndCallAccept:!1,removeLocalAudioStreamCheckOnCallStartAndCallAccept:!1,turnOffScreenShareBeforeHold:!0,allowMutePstnRemoteParticipant:!0,constraints:{enabled:!1,maxOutgoingResolution:0,maxOutgoingFrameRate:0,maxOutgoingVideoBitrate:0},sharedLineAppearance:{enabled:!1},supportLiveStreaming:!1,liveStreamingBotIds:cxt,composedStreamBotIds:dxt,teamsCallQualityFeedback:{enabled:!0,tenantId:gO},setDeviceType:!1,devicePermissions:{splitAskAudioVideo:!1,timeoutInBetween:0,getCurrentState:!0},applicationSettingsUrls:{Public_ConversationServiceUrl:As.Public_ConversationServiceUrl,Public_TrouterServiceUrl:As.Public_TrouterServiceUrl,Public_RegistrarServiceUrl:As.Public_RegistrarServiceUrl,Public_MdnTrapServiceUrl:As.Public_MdnTrapServiceUrl,Public_MdnTrapServiceTokenUrl:As.Public_MdnTrapServiceTokenUrl,Public_MdnTrapRelaySkypeFqdns:As.Public_MdnTrapRelaySkypeFqdns,Public_MdnTrapRelayTurnFqdns:As.Public_MdnTrapRelayTurnFqdns,Public_MdnTrapRelayTurnUrl:As.Public_MdnTrapRelayTurnUrl,GccHigh_ConversationServiceUrl:As.GccHigh_ConversationServiceUrl,GccHigh_TrouterServiceUrl:As.GccHigh_TrouterServiceUrl,GccHigh_RegistrarServiceUrl:As.GccHigh_RegistrarServiceUrl,GccHigh_MdnTrapServiceUrl:As.GccHigh_MdnTrapServiceUrl,GccHigh_MdnTrapServiceTokenUrl:As.GccHigh_MdnTrapServiceTokenUrl,GccHigh_MdnTrapRelaySkypeFqdns:As.GccHigh_MdnTrapRelaySkypeFqdns,GccHigh_MdnTrapRelayTurnFqdns:As.GccHigh_MdnTrapRelayTurnFqdns,GccHigh_MdnTrapRelayTurnUrl:As.GccHigh_MdnTrapRelayTurnUrl,Dod_ConversationServiceUrl:As.Dod_ConversationServiceUrl,Dod_TrouterServiceUrl:As.Dod_TrouterServiceUrl,Dod_RegistrarServiceUrl:As.Dod_RegistrarServiceUrl,Dod_MdnTrapServiceUrl:As.Dod_MdnTrapServiceUrl,Dod_MdnTrapServiceTokenUrl:As.Dod_MdnTrapServiceTokenUrl,Dod_MdnTrapRelaySkypeFqdns:As.Dod_MdnTrapRelaySkypeFqdns,Dod_MdnTrapRelayTurnFqdns:As.Dod_MdnTrapRelayTurnFqdns,Dod_MdnTrapRelayTurnUrl:As.Dod_MdnTrapRelayTurnUrl,AirGap08_ConversationServiceUrl:As.AirGap08_ConversationServiceUrl,AirGap08_TrouterServiceUrl:As.AirGap08_TrouterServiceUrl,AirGap08_RegistrarServiceUrl:As.AirGap08_RegistrarServiceUrl,AirGap09_ConversationServiceUrl:As.AirGap09_ConversationServiceUrl,AirGap09_TrouterServiceUrl:As.AirGap09_TrouterServiceUrl,AirGap09_RegistrarServiceUrl:As.AirGap09_RegistrarServiceUrl,Enterprise_ConversationServiceUrl:As.Enterprise_ConversationServiceUrl,Enterprise_TrouterServiceUrl:As.Enterprise_TrouterServiceUrl,Enterprise_RegistrarServiceUrl:As.Enterprise_RegistrarServiceUrl,Enterprise_MdnTrapServiceUrl:As.Enterprise_MdnTrapServiceUrl,Enterprise_MdnTrapServiceTokenUrl:As.Enterprise_MdnTrapServiceTokenUrl,Enterprise_MdnTrapRelaySkypeFqdns:As.Enterprise_MdnTrapRelaySkypeFqdns,Enterprise_MdnTrapRelayTurnFqdns:As.Enterprise_MdnTrapRelayTurnFqdns,Enterprise_MdnTrapRelayTurnUrl:As.Enterprise_MdnTrapRelayTurnUrl},applicationSettingsEudbUrls:{Public_ConversationServiceUrl_EUDB:Hf.Public_ConversationServiceUrl_EUDB,Public_TrouterServiceUrl_EUDB:Hf.Public_TrouterServiceUrl_EUDB,Public_RegistrarServiceUrl_EUDB:Hf.Public_RegistrarServiceUrl_EUDB,Public_MdnTrapServiceUrl_EUDB:Hf.Public_MdnTrapServiceUrl_EUDB,Public_MdnTrapServiceTokenUrl_EUDB:Hf.Public_MdnTrapServiceTokenUrl_EUDB,Public_MdnTrapRelaySkypeFqdns_EUDB:Hf.Public_MdnTrapRelaySkypeFqdns_EUDB,Public_MdnTrapRelayTurnFqdns_EUDB:Hf.Public_MdnTrapRelayTurnFqdns_EUDB,Public_MdnTrapRelayTurnUrl_EUDB:Hf.Public_MdnTrapRelayTurnUrl_EUDB,Enterprise_ConversationServiceUrl_EUDB:Hf.Enterprise_ConversationServiceUrl_EUDB,Enterprise_TrouterServiceUrl_EUDB:Hf.Enterprise_TrouterServiceUrl_EUDB,Enterprise_RegistrarServiceUrl_EUDB:Hf.Enterprise_RegistrarServiceUrl_EUDB,Enterprise_MdnTrapServiceUrl_EUDB:Hf.Enterprise_MdnTrapServiceUrl_EUDB,Enterprise_MdnTrapServiceTokenUrl_EUDB:Hf.Enterprise_MdnTrapServiceTokenUrl_EUDB,Enterprise_MdnTrapRelaySkypeFqdns_EUDB:Hf.Enterprise_MdnTrapRelaySkypeFqdns_EUDB,Enterprise_MdnTrapRelayTurnFqdns_EUDB:Hf.Enterprise_MdnTrapRelayTurnFqdns_EUDB,Enterprise_MdnTrapRelayTurnUrl_EUDB:Hf.Enterprise_MdnTrapRelayTurnUrl_EUDB},maxDisplayNameLength:256,callDiagnostics:mNt,eudb:{isEnabled:!0,countries:ohe,regions:Mxe,defaultDataLocationEurope:!1,EmeaTenants:Pxe,ApacTenants:Dxe,NoamTenants:Lxe,acsCompliantEvents:{},isRgnClaimEnabledForACS:!0,sendRegionToNgc:!0},tfl:{isEnabled:!1,hosts:["teams.live.com"]},remoteDiagnostic:{sourceEvents:["cameraStartTimedOut","speakingWhileMicrophoneIsMuted"],exposedEvents:["cameraStartFailed",""]},lobbyAdmitAndReject:{enabled:!0,supportedConversationTypes:["scheduledMeeting","adHocMeeting"]},localRecording:{enabled:!0,supportedConversationTypes:["scheduledMeeting","adHocMeeting"]},platformSupportValidation:!1,enableCustomTurnUsage:!1,allowProxyForTeamsCalls:!1,allowCustomTurnForTeamsCalls:!1,spotlight:{enabled:!0,maxSpotlightParticipants:7,supportedRoles:["presenter","organizer","coorganizer"],meetingTypes:["scheduledMeeting"]},teamsMeetingAudioConferencing:{enabled:!0,supportedConversationTypes:["scheduledMeeting","adHocMeeting"]},breakoutRooms:{enabled:!0,supportedConversationTypes:["scheduledMeeting"],autoMoveInMilliSeconds:3e3,hangUpCallDelayInMilliSeconds:5e3},explicitConsentFeatureEnabled:{enabled:!0},transfer:{autoAccept:!0},reaction:{enabled:!0,telemetryEventAggregationIntervalInSecond:3,enableStateServiceConsoleLogs:!0,StateServiceProxySettings:{batchedRequestsEnabled:!1,websocketAliveTimeAfterLoseFocusInMS:3e4,pingTimeoutInMs:2e4,pongTimeoutInMs:5e3,maxSessionRetries:2,offlineMessageCacheEnabled:!0,maxOfflineMessageCacheLength:64,maxOfflineMessageCacheTimeInMs:2e4,autoRoutingEnabled:!0}},pptlive:{enabled:!0,wdParams:{wdModernSlideShowInTeams:!0,wdPresenterViewInTeams:!1,wdForceModernSlideShowInTeams:!1,isMovePrivateViewingToPPTEnabled:!0},appSettings:{takeFocusOnBoot:!0,enableAdvanceOnClick:!1,enableAdvanceOnTap:!1},stateServiceProxySettings:{batchedRequestsEnabled:!1,maxRoundtripRaw:300,pingTimeoutInMs:15e3,pongTimeoutInMs:15e3,retryIntervalsInMs:[1e3,2e3,4e3],verbose:!1,websocketAliveTimeAfterLoseFocusInMS:3e4,autoRoutingEnabled:!0,useServiceGeneratedClientId:!0,offlineMessageCacheEnabled:!0,maxOfflineMessageCacheTimeInMs:2e4,maxOfflineMessageCacheLength:64,allowReconnectOnSendMessage:!0},enableStateServiceInPreviewerFeatures:'["Ink","Media","Nav","NavSync","PresUrl","PresUrlBoot"]',featureGates:'{"ModernSlideShowAllowListForFileType":"pptx;ppsx;potx;pptm;ppsm;pot;ppt;odp;pps"}'},togetherMode:{enable:!0,botId:vNt,gccBotId:yNt,dataChannelId:13,forceSeatMapRequest:!1,supportedConversationTypes:["scheduledMeeting","adHocMeeting","groupCall"],mainVideo:{scaledWidthRatio:.6,scaledHeightRatio:.8}},checkHiddenBotOnCallStart:!0,blacklistedBots:[],musicOnHoldEnabled:!0,customContext:{userToUser:{headerKey:"User-To-User"},xHeaders:{headerKeyPrefix:"X-MS-Custom-",headerKeyRegex:"^[a-zA-Z0-9.!%*_+~-]{1,64}$",headerValueRegex:"^[a-zA-Z0-9.!%*_+~=;-]{1,256}$",maxCount:5}},watermark:{watermarkEnabledForAcsUsers:!0,watermarkEnabledForCteUsers:!0,watermarkDefaultOpacity:30,watermarkDefaultPattern:"Tiled",enableAudioOnlyFallback:!0,watermarkMaxUsernameLength:17,watermarkEmptyDisplayNamePlaceholder:"UnknownUser"},mediaAccess:{enabled:!0,ipMediaPolicyEnabled:!0,supportedRoles:["presenter","organizer","coorganizer"],supportedConversationTypes:["scheduledMeeting","adHocMeeting","groupCall","huddleGroupCall","screenShareCall"],supportedConversationTypesForMuteAll:["scheduledMeeting","adHocMeeting"]},realTimeText:{autoCommitTimeout:300,autoSendInterval:3e3,dataChannelId:24,maxInputLength:2e3,teams:{enabled:!0}}},teamsMeetingShortUrlJoin:{validatePattern:!0,regexPattern:"\\/meet\\/[^\\/\\?]+(\\?p=[^\\/\\?]+)?$"},dataChannel:{maxReceiveBufferSize:2097152,receiveTimeoutInMs:12e4,maxSendBandwidth:5e5,maxBroadcastPacketRate:80,defaultBitrate:32e3,maxMessageSize:32768,enableBroadcastLimitOnReliableChannel:!1,dataIdConfigs:[]},unmixedAudio:{maxStreamSize:7,operationTimeoutInMs:1e4,skipProviderStateCheck:!1},vdi3:{enabled:!0,cdnBaseUrl:"https://res.public.onecdn.static.microsoft/ic3-1/pluginless/",cdnUrl:"",customTsVersion:"",loaderHtmlPath:"skype-calling-pluginless.loader.html",pluginlessJsPath:"skype-calling-pluginless.cdn.js",transportConnectionTimeoutInMs:3e4,remoteExecutionTimeoutInMs:3e4,chunkSize:7e5,customEcsConfig:""},roles:{acsOrganizer:RA.AcsOrganizerRole,acsPresenter:RA.AcsPresenterRole,acsAttendee:RA.AcsAttendeeRole,acsConsumer:RA.AcsConsumerRole,acsCollaborator:RA.AcsCollaboratorRole,teamsAttendee:RA.TeamsAttendee,teamsOrganizer:RA.TeamsOrganizer,teamsPresenter:RA.TeamsPresenter,teamsCoorganizer:RA.TeamsCoorganizer},roomsRoleBasedCapabilities:{presenter:SO(To.Rooms,"Presenter"),attendee:SO(To.Rooms,"Attendee"),consumer:SO(To.Rooms,"Consumer"),collaborator:SO(To.Rooms,"Collaborator")},teamsRoleBasedCapabilities:{organizer:SO(To.TeamsMeeting,"Organizer"),coorganizer:SO(To.TeamsMeeting,"Co-organizer"),presenter:SO(To.TeamsMeeting,"Presenter"),attendee:SO(To.TeamsMeeting,"Attendee")},environments:{android:{chrome:{minVersion:Gy,isSupportedOnSdkVersion:PA},edgeanaheim:{minVersion:Gy,isSupportedOnSdkVersion:PA}},ios:{safari:{minVersion:Gy,isSupportedOnSdkVersion:PA},chrome:{minVersion:Gy,isSupportedOnSdkVersion:!uk().includes("stable")},edgeanaheim:{minVersion:Gy,isSupportedOnSdkVersion:!uk().includes("stable")},applewebview:{minVersion:Gy,isSupportedOnSdkVersion:PA}},mac:{chrome:{minVersion:Gy,isSupportedOnSdkVersion:PA},safari:{minVersion:Gy,isSupportedOnSdkVersion:PA},edgeanaheim:{minVersion:Gy,isSupportedOnSdkVersion:PA},firefox:{minVersion:Gy,isSupportedOnSdkVersion:!uk().includes("stable")}},windows:{chrome:{minVersion:Gy,isSupportedOnSdkVersion:PA},chromium:{minVersion:Gy,isSupportedOnSdkVersion:PA},edgeanaheim:{minVersion:Gy,isSupportedOnSdkVersion:PA},firefox:{minVersion:Gy,isSupportedOnSdkVersion:!uk().includes("stable")}},linux:{chrome:{minVersion:Gy,isSupportedOnSdkVersion:PA},firefox:{minVersion:Gy,isSupportedOnSdkVersion:!uk().includes("stable")}}},MiddleTier:{enabled:!1,maxRetry:3,baseServiceUrl:s6.baseServiceUrl,policyUrlSuffix:s6.policyUrlSuffix,policyUrlSuffixV2:s6.policyUrlSuffixV2,userPolicySettingsApi:!1,serverManagedThreadIdApiConfiguration:{allowServerThreadCreation:!0,decoupleChatThreadFromCalls:!0,createThreadSuffix:s6.createThreadSuffix,addParticipantSuffix:s6.addParticipantSuffix}},PowerPointStateServiceUrl:{public:{amer:"https://usc.pptservicescast.officeapps.live.com",apac:"https://apac.pptservicescast.officeapps.live.com",emea:"https://emea.pptservicescast.officeapps.live.com",uk:"https://ukc.pptservicescast.officeapps.live.com",eu:"https://euc.pptservicescast.officeapps.live.com",in:"https://inc.pptservicescast.officeapps.live.com",au:"https://auc.pptservicescast.officeapps.live.com",ca:"https://canc.pptservicescast.officeapps.live.com",fr:"https://fr.pptservicescast.officeapps.live.com",jp:"https://jpc.pptservicescast.officeapps.live.com",ae:"https://ae.pptservicescast.officeapps.live.com",kr:"https://krc.pptservicescast.officeapps.live.com",sg:"https://sg.pptservicescast.officeapps.live.com",za:"https://za.pptservicescast.officeapps.live.com",de:"https://de.pptservicescast.officeapps.live.com",ch:"https://ch.pptservicescast.officeapps.live.com",no:"https://no.pptservicescast.officeapps.live.com",br:"https://pptservicescast.officeapps.live.com",se:"https://se.pptservicescast.officeapps.live.com",qa:"https://qa.pptservicescast.officeapps.live.com",gallatin:"https://pptservicescast.osi.microsoftonline.cn",pl:"https://pl.pptservicescast.officeapps.live.com",it:"https://euc.pptservicescast.officeapps.live.com",il:"https://pptservicescast.officeapps.live.com",mx:"https://pptservicescast.officeapps.live.com"},gcc:"https://pptservicescast.gcc.osi.office365.us",gcch:"https://pptservicescast.osi.office365.us",dod:"https://pptservicescast.osi.apps.mil",ag08:"https://pptservicescast.osi.eaglex.ic.gov",ag09:"https://pptservicescast.osi.microsoft.scloud"}};let aBe;function Pxt(t){if(!t)throw new Oe({defaultError:we.INTERNAL.ECS_CONFIG_EMPTY});if(!t.AcsCallingSDKWeb)throw new Oe({defaultError:we.INTERNAL.ECS_CONFIG_MISSING_ACS});try{const e=iQ.telemetry.deviceChangedEvents.piiSafeWords.slice();dn.mergeWith(iQ,t.AcsCallingSDKWeb,_xt);const i=iQ.telemetry.deviceChangedEvents;i.piiSafeWordsMode==="merge"&&(i.piiSafeWords=dn.union(e,i.piiSafeWords))}catch{throw new Oe({defaultError:we.INTERNAL.ECS_CONFIG_MERGING_ERROR})}}function wt(){return iQ}function Dxt(t){aBe=t}function nQ(){return aBe}function SO(t,e){const i={turnVideoOn:!0,unmuteMic:!0,shareScreen:!0,removeParticipant:!0,hangUpForEveryOne:!0,addCommunicationUser:!0,addTeamsUser:!0,addPhoneNumber:!0,manageLobby:!0,spotlightParticipant:!0,removeParticipantsSpotlight:!0,blurBackground:!0,startLiveMeetingCaptions:!0,startLiveCallingCaptions:!0,setCaptionLanguage:!0,raiseHand:!0,pstnDialOut:!0,muteOthers:!0,useReactions:!0,viewAttendeeNames:!0,startTogetherMode:!0,joinBreakoutRooms:!0,forbidOthersAudio:!0,forbidOthersVideo:!0};if(t==To.TeamsMeeting){if(e=="Co-organizer"||e=="Organizer")return{...i};if(e=="Presenter"){const r={...i};return r.hangUpForEveryOne=!1,r}if(e=="Attendee"){const r={...i};return r.removeParticipant=!1,r.manageLobby=!1,r.spotlightParticipant=!1,r.removeParticipantsSpotlight=!1,r.shareScreen=!1,r.muteOthers=!1,r.hangUpForEveryOne=!1,r.startTogetherMode=!1,r.joinBreakoutRooms=!0,r.forbidOthersAudio=!1,r.forbidOthersVideo=!1,r}}if(t==To.Rooms){const r={...i};if(r.removeParticipant=!1,r.hangUpForEveryOne=!1,r.addCommunicationUser=!1,r.addTeamsUser=!1,r.manageLobby=!1,r.spotlightParticipant=!1,r.removeParticipantsSpotlight=!1,r.blurBackground=!1,r.startLiveMeetingCaptions=!0,r.startLiveCallingCaptions=!0,r.setCaptionLanguage=!1,r.raiseHand=!1,r.startTogetherMode=!1,r.joinBreakoutRooms=!1,r.forbidOthersAudio=!1,r.forbidOthersVideo=!1,e=="Presenter")return{...r};if(e=="Collaborator"){const o={...r};return o.muteOthers=!1,o.addPhoneNumber=!1,o.pstnDialOut=!1,o}if(e=="Attendee"){const o={...r};return o.shareScreen=!1,o.muteOthers=!1,o.addPhoneNumber=!1,o.pstnDialOut=!1,o}if(e=="Consumer"){const o={...r};return o.turnVideoOn=!1,o.unmuteMic=!1,o.shareScreen=!1,o.muteOthers=!1,o.addPhoneNumber=!1,o.pstnDialOut=!1,o}}return i}const Lxt=["response","responseText","responseURL","status","state","statusText","timeout","withCredentials","stack","message","name","error","piiSafe","phase","code","participantId","phrase","subCode","reason"];function c6(t){switch(t){case"Crop":return 1;case"Fit":return 2;default:return 0}}function d6(t){return t.toString===Object.prototype.toString?JSON.stringify(t):t.toString()}function rBe(t,e){try{return typeof t=="string"?new Blob([t]).size:t.byteLength}catch(i){return e.error(i),0}}function Oxt(t,e){const i=Object.keys(t);for(let r of i)if(t[r]!==e[r])return!1;return!0}function oBe(t){let e={};return t.forEach((i,r)=>{e[r]=i}),Object.freeze(e)}function sBe(t,e="Timed promise; rejected."){let i,r,o,l=!0;const d=()=>{o=window.setTimeout(()=>{r(new Oe({defaultError:we.FEATURES.VIDEO_EFFECTS.EFFECT_PROVIDER_TIMEOUT}))},t)},h=()=>{window.clearTimeout(o)};let p=new Promise((g,f)=>{i=y=>{h(),l=!1,g(y)},r=y=>{h(),l=!1,f(y)}});return{timerStart:d,timerStop:h,deferredPromise:{promise:p,resolve:i,reject:r,isPending:()=>l,dispose:()=>{r("disposed")}}}}function lBe(t,e){if(t==null)throw new Oe({defaultError:e})}function cBe(t,e){if(typeof t!="object")throw new Oe({defaultError:e})}function dBe(t){let[,e]=t?.split(".");if(e===void 0)throw new Oe({defaultError:we.INTERNAL.TOKEN_PAYLOAD_UNDEFINED});return e=e.replace(/-/g,"+").replace(/_/g,"/"),JSON.parse(decodeURIComponent(escape(atob(e))))}function oP(t,e){throw e.error(`CallingCommunicationError: Message={${t.message},Code={${t.code}}, SubCode={${t.subCode}}, ResultCategories={${t.resultCategories}}`),new Oe({defaultError:t})}function nh(){}function Nxt(t,e){const i=xxt(t);return!!e&&!!i.find(r=>r===e)}function u6(t,e){return wt().calling.eudb.isEnabled&&Nxt(t,e||"")}function uBe(t){return wt().calling.eudb.isRgnClaimEnabledForACS||!!t&&t===gT.Enterprise||!1}function xxt(t){return uBe(t)?wt().calling.eudb.regions:wt().calling.eudb.countries}async function R3(t,e,i){let r;try{if(!t)throw new Oe({defaultError:we.INTERNAL.NO_TOKEN_PROVIDED});try{r=(await t.getToken(i))?.token}catch(o){throw new Oe(o.message==="The token returned from the tokenRefresher is expired."?{defaultError:we.CALL_AGENT.ACCESSTOKEN_EXPIRED}:{defaultError:we.INTERNAL.GET_TOKEN})}if(!r)throw new Oe({defaultError:we.INTERNAL.EMPTY_TOKEN})}catch(o){throw new Oe({defaultError:we.INTERNAL.GET_TOKEN,originalError:o})}try{let o=dBe(r);if(!o)throw new Oe({defaultError:we.INTERNAL.TOKEN_UNDEFINED});if(typeof o.acsScope!="string")throw new Oe({defaultError:we.INTERNAL.INVALID_TOKEN_SCOPE_FORMAT});if(!o.acsScope.split(",").find(C=>C==="voip"||C==="voip.join"))throw new Oe({defaultError:we.INTERNAL.INVALID_TOKEN_SCOPE});const l=o.resourceId,d=Sl(`8:${o.skypeid}`);if(!l&&d?.kind!=="microsoftTeamsUser")throw new Oe({defaultError:we.INTERNAL.RESOURCE_NOT_FOUND_IN_TOKEN});let h=o.skypeid;if(!h)throw new Oe({defaultError:we.INTERNAL.USERID_NOT_FOUND_IN_TOKEN});const p=Txt(h),g=!!o.tid,f=!!o.rgn,y=(g||e?o.rgn:o.resourceLocation)||"";let T=!1;return g&&(T=!!o.aad_pft),{jwtToken:r,acsResourceId:l,identityMri:h,cloudType:p,isCte:g,region:y,rgnClaimExists:f,exp:1e3*o.exp,aadpftClaimExists:T}}catch(o){throw new Oe({defaultError:we.INTERNAL.PARSE_TOKEN_FAIL,originalError:o})}}function Bxt(t,e,i){const r=`azsdk-js-communication-calling/${t}`;let o="";if(i?.diagnostics?.appName){let l=i?.diagnostics?.appName.trim().replace(/\s/g,"_");l.length>64&&(e.warn("appName is too long, max allowed length is 64 chars, appName was truncated to max length"),l=l.substr(0,64)),o+=l?`${l}/`:"default/"}else o+="default/";if(i?.diagnostics?.appVersion){let l=i?.diagnostics?.appVersion.trim().replace(/\s/g,"_");l.length>64&&(e.warn("appVersion is too long, max allowed length is 64 chars, appVersion was truncated to max length"),l=l.substr(0,64)),o+=l||"0.0.0"}else o+="0.0.0";if(o+=` ${r}`,i?.diagnostics?.tags&&Array.isArray(i?.diagnostics?.tags)&&i?.diagnostics?.tags.length>0){let l=i?.diagnostics?.tags.map(d=>d.trim().replace(/\s/g,"_")).filter(d=>!!d).join(";");l.length>128&&(e.warn("tags are too long, max allowed length is 128 chars, tags were truncated to max length"),l=l.substr(0,128)),l.length>0&&(o+=" ("+l+").")}return o}function Fxt(t){return t?t.groupId?zm.GroupCall:!t.threadId||t.organizerId||t.tenantId||t.messageId?t.threadId&&t.organizerId&&t.tenantId&&t.messageId?zm.TeamsCoordinates:t.meetingId?zm.TeamsMeetingId:t.meetingLink?zm.TeamsMeetingLink:t.roomId?zm.RoomCall:zm.Unknown:zm.GroupChatCall:zm.Unknown}function pk(t,e=!1){const i=r=>{try{return r.split(`
`)[0]}catch{return"invalid stack"}};if(t===void 0)return"void";if(t instanceof Error||t instanceof String||t instanceof Number||t instanceof Boolean)return t.toString();try{return t.stack&&(t.stack=i(t.stack)),(e?JSON.stringify(t):JSON.stringify(t,Lxt,4)).replace(/(\r\n\t|\n|\r\t|\s)/gm,"")}catch{return`failed to get error information:${t&&typeof t.toString=="function"&&t.toString()} ${t&&t.response&&JSON.stringify(t.response)}`}}function aQ(t,e){return e.info("permission state to boolean",t),t==="granted"}function hBe(t,e,i=[]){let r=[];try{const o=Array.isArray(t);for(const d in t){const h=t[d],p=o?+d:d;if(!(d in e)){r.push({type:"REMOVE",path:[p],oldValue:t[d]});continue}const g=e[d],f=typeof h=="object"&&typeof g=="object";if(h&&g&&f&&!wkt[Object.getPrototypeOf(h).constructor.name]&&!i.includes(h)){const y=hBe(h,g);r.push.apply(r,y.map(T=>(T.path.unshift(p),T)))}else h===g||f&&(isNaN(h)?h+""==g+"":+h==+g)||r.push({path:[p],type:"CHANGE",value:g,oldValue:h})}const l=Array.isArray(e);for(const d in e)d in t||r.push({type:"CREATE",path:[l?+d:d],value:e[d]})}catch{}return r}function pBe(t,e){const i={[t.roles.acsOrganizer.toLowerCase()]:Dd.Organizer,[t.roles.teamsOrganizer.toLowerCase()]:Dd.Organizer,[t.roles.acsPresenter.toLowerCase()]:Dd.Presenter,[t.roles.teamsPresenter.toLowerCase()]:Dd.Presenter,[t.roles.acsAttendee.toLowerCase()]:Dd.Attendee,[t.roles.teamsAttendee.toLowerCase()]:Dd.Attendee,[t.roles.acsConsumer.toLowerCase()]:Dd.Consumer,[t.roles.acsCollaborator.toLowerCase()]:Dd.Collaborator,[t.roles.teamsCoorganizer.toLowerCase()]:Dd.Coorganizer};return e&&i[e.toString().toLowerCase()]?i[e.toString().toLowerCase()]:Dd.Unknown}function Uxt(t,e){return e.meetingCapability==null&&t.meetingCapability!=null||e.capabilities==null&&t.capabilities!=null||!(dn.isEqual(e.capabilities,t.capabilities)&&dn.isEqual(e.meetingCapability,t.meetingCapability)&&dn.isEqual(e.recordingConsentDetails,t.recordingConsentDetails))}function zxt(t,e){return!(!t.capabilities||t.capabilities.allowVideo==null||e.capabilities?.allowVideo!=null&&e.capabilities.allowVideo==t.capabilities.allowVideo)||!(!t.meetingCapability||t.meetingCapability.allowIPVideo==null||e.meetingCapability?.allowIPVideo!=null&&e.meetingCapability.allowIPVideo==t.meetingCapability.allowIPVideo)||!(!t.meetingCapability||t.meetingCapability.attendeeRestrictions==null||e.meetingCapability?.attendeeRestrictions!=null&&e.meetingCapability.attendeeRestrictions==t.meetingCapability.attendeeRestrictions)||!(!t.meetingCapability||t.meetingCapability.allowPstnConferencing==null||e.meetingCapability?.allowPstnConferencing!=null&&e.meetingCapability.allowPstnConferencing==t.meetingCapability.allowPstnConferencing)||!(!t.meetingCapability||t.meetingCapability.allowTranslatedCaptions==null||e.meetingCapability?.allowTranslatedCaptions!=null&&e.meetingCapability?.allowTranslatedCaptions==t.meetingCapability.allowTranslatedCaptions)||!(!t.meetingCapability||t.meetingCapability.allowTranslatedTranscriptions==null||e.meetingCapability?.allowTranslatedTranscriptions!=null&&e.meetingCapability?.allowTranslatedTranscriptions==t.meetingCapability.allowTranslatedTranscriptions)||!(!t.meetingCapability||t.meetingCapability.allowRaiseHands==null||e.meetingCapability?.allowRaiseHands!=null&&e.meetingCapability?.allowRaiseHands==t.meetingCapability.allowRaiseHands)||!(!t.meetingCapability||t.meetingCapability.allowTeamsMeetingReactions==null||e.meetingCapability?.allowTeamsMeetingReactions!=null&&e.meetingCapability?.allowTeamsMeetingReactions==t.meetingCapability.allowTeamsMeetingReactions)||!(!t.meetingCapability||t.meetingCapability.presenterOption==null||e.meetingCapability?.presenterOption!=null&&e.meetingCapability?.presenterOption==t.meetingCapability.presenterOption)||!(!t.capabilities||t.capabilities.maskIdentitiesForRole==null||e.capabilities?.maskIdentitiesForRole!=null&&e.capabilities?.maskIdentitiesForRole==t.capabilities.maskIdentitiesForRole)||!(!t.recordingConsentDetails||t.recordingConsentDetails.consentActivelyRequired==null||e.recordingConsentDetails?.consentActivelyRequired!=null&&e.recordingConsentDetails.consentActivelyRequired==t.recordingConsentDetails.consentActivelyRequired)}function She(t){let e=1;return t.participantCounts&&t.participantCounts.totalParticipants>0&&(e=t.participantCounts.totalParticipants),t.participants&&(e-=t.participants.filter(i=>rQ(i)).length),e}function rQ(t){if(fO(t.id)){if(Sxt(t.id)||wt()?.calling?.blacklistedBots?.includes(t.id))return!0;if(t.endpoints?.endpointDetails&&t.endpoints?.endpointDetails.length>0)return t.endpoints?.endpointDetails[0].endpointMetadata?.__platform?.ui?.hidden}return!1}function _B(t,e,i,r,o){if(i||r&&r.kind==="microsoftTeamsUser"||o&&$xt(o)){const l=wt().calling.allowProxyForTeamsCalls,d=t.proxyInUse,h=wt().calling.allowCustomTurnForTeamsCalls,p=e.customRelayManagerInUse;if(d&&!l||p&&!h)return!1}return!0}function bhe(t,e){let i=e==zx.TeamsCallAgent?"communicationUser":"microsoftTeamsUser";return!!t.find(r=>Ap(r).kind===i)}function Vxt(t){return t.startsWith(WK)}function $xt(t){return!!(t.meetingId||t.meetingLink||t.messageId||t.organizerId||t.tenantId||t.threadId)}function Hxt(){return{1:{0:void 0,1:void 0,2:void 0,3:void 0},2:{0:void 0,1:void 0,2:void 0,3:void 0},3:{0:void 0,1:void 0,2:void 0,3:void 0},4:{0:void 0,1:void 0,2:void 0,3:void 0},5:{0:void 0,1:void 0,2:void 0,3:void 0},6:{0:void 0,1:void 0,2:void 0,3:void 0},7:{0:void 0,1:void 0,2:void 0,3:void 0},8:{0:void 0,1:void 0,2:void 0,3:void 0},9:{0:void 0,1:void 0,2:void 0,3:void 0},10:{0:void 0,1:void 0,2:void 0,3:void 0},11:{0:void 0,1:void 0,2:void 0,3:void 0},12:{0:void 0,1:void 0,2:void 0,3:void 0},13:{0:void 0,1:void 0,2:void 0,3:void 0},14:{0:void 0,1:void 0,2:void 0,3:void 0},15:{0:void 0,1:void 0,2:void 0,3:void 0},16:{0:void 0,1:void 0,2:void 0,3:void 0},17:{0:void 0,1:void 0,2:void 0,3:void 0},18:{0:void 0,1:void 0,2:void 0,3:void 0},19:{0:void 0,1:void 0,2:void 0,3:void 0},20:{0:void 0,1:void 0,2:void 0,3:void 0},21:{0:void 0,1:void 0,2:void 0,3:void 0},22:{0:void 0,1:void 0,2:void 0,3:void 0},23:{0:void 0,1:void 0,2:void 0,3:void 0},24:{0:void 0,1:void 0,2:void 0,3:void 0},25:{0:void 0,1:void 0,2:void 0,3:void 0},26:{0:void 0,1:void 0,2:void 0,3:void 0},27:{0:void 0,1:void 0,2:void 0,3:void 0},28:{0:void 0,1:void 0,2:void 0,3:void 0},29:{0:void 0,1:void 0,2:void 0,3:void 0},30:{0:void 0,1:void 0,2:void 0,3:void 0},31:{0:void 0,1:void 0,2:void 0,3:void 0},32:{0:void 0,1:void 0,2:void 0,3:void 0},33:{0:void 0,1:void 0,2:void 0,3:void 0},34:{0:void 0,1:void 0,2:void 0,3:void 0},35:{0:void 0,1:void 0,2:void 0,3:void 0},36:{0:void 0,1:void 0,2:void 0,3:void 0},37:{0:void 0,1:void 0,2:void 0,3:void 0},38:{0:void 0,1:void 0,2:void 0,3:void 0},39:{0:void 0,1:void 0,2:void 0,3:void 0},40:{0:void 0,1:void 0,2:void 0,3:void 0},41:{0:void 0,1:void 0,2:void 0,3:void 0},42:{0:void 0,1:void 0,2:void 0,3:void 0},43:{0:void 0,1:void 0,2:void 0,3:void 0},44:{0:void 0,1:void 0,2:void 0,3:void 0},45:{0:void 0,1:void 0,2:void 0,3:void 0},46:{0:void 0,1:void 0,2:void 0,3:void 0},47:{0:void 0,1:void 0,2:void 0,3:void 0},48:{0:void 0,1:void 0,2:void 0,3:void 0},49:{0:void 0,1:void 0,2:void 0,3:void 0},50:{0:void 0,1:void 0,2:void 0,3:void 0},51:{0:void 0,1:void 0,2:void 0,3:void 0},52:{0:void 0,1:void 0,2:void 0,3:void 0},53:{0:void 0,1:void 0,2:void 0,3:void 0},54:{0:void 0,1:void 0,2:void 0,3:void 0},55:{0:void 0,1:void 0,2:void 0,3:void 0},56:{0:void 0,1:void 0,2:void 0,3:void 0},57:{0:void 0,1:void 0,2:void 0,3:void 0},58:{0:void 0,1:void 0,2:void 0,3:void 0},59:{0:void 0,1:void 0,2:void 0,3:void 0},60:{0:void 0,1:void 0,2:void 0,3:void 0},61:{0:void 0,1:void 0,2:void 0,3:void 0},62:{0:void 0,1:void 0,2:void 0,3:void 0},63:{0:void 0,1:void 0,2:void 0,3:void 0},64:{0:void 0,1:void 0,2:void 0,3:void 0},65:{0:void 0,1:void 0,2:void 0,3:void 0},80:{0:void 0,1:void 0,2:void 0,3:void 0},66:{0:void 0,1:void 0,2:void 0,3:void 0},67:{0:void 0,1:void 0,2:void 0,3:void 0},68:{0:void 0,1:void 0,2:void 0,3:void 0},69:{0:void 0,1:void 0,2:void 0,3:void 0},70:{0:void 0,1:void 0,2:void 0,3:void 0},71:{0:void 0,1:void 0,2:void 0,3:void 0},72:{0:void 0,1:void 0,2:void 0,3:void 0},73:{0:void 0,1:void 0,2:void 0,3:void 0},74:{0:void 0,1:void 0,2:void 0,3:void 0},75:{0:void 0,1:void 0,2:void 0,3:void 0},76:{0:void 0,1:void 0,2:void 0,3:void 0},77:{0:void 0,1:void 0,2:void 0,3:void 0},78:{0:void 0,1:void 0,2:void 0,3:void 0},79:{0:void 0,1:void 0,2:void 0,3:void 0},81:{0:void 0,1:void 0,2:void 0,3:void 0}}}function h6(t){if(!t||!t.customContext)return;const e={},i={};if(t.customContext.userToUser&&(e[wt().calling.customContext.userToUser.headerKey]=t.customContext.userToUser),t.customContext.xHeaders&&!t.customContext.sipHeaders){const o=wt().calling.customContext.xHeaders.headerKeyPrefix,l=new RegExp(wt().calling.customContext.xHeaders.headerKeyRegex),d=new RegExp(wt().calling.customContext.xHeaders.headerValueRegex);t.customContext.xHeaders.forEach(h=>{const p=h.key.toLowerCase().startsWith(o.toLowerCase());h.key=p?`${o}${h.key.slice(o.length)}`:`${o}${h.key}`}),t.customContext.xHeaders.filter(h=>l.test(h.key)&&d.test(h.value)).slice(0,wt().calling.customContext.xHeaders.maxCount).forEach(h=>e[h.key]=h.value)}if(t.customContext.sipHeaders){const o=wt().calling.customContext.xHeaders.headerKeyPrefix,l=new RegExp(wt().calling.customContext.xHeaders.headerKeyRegex),d=new RegExp(wt().calling.customContext.xHeaders.headerValueRegex);t.customContext.sipHeaders.forEach(h=>{const p=h.key.toLowerCase().startsWith(o.toLowerCase());h.key=p?`${o}${h.key.slice(o.length)}`:`${o}${h.key}`}),t.customContext.sipHeaders.filter(h=>l.test(h.key)&&d.test(h.value)).slice(0,wt().calling.customContext.xHeaders.maxCount).forEach(h=>e[h.key]=h.value)}t.customContext.voipHeaders&&t.customContext.voipHeaders.forEach(o=>i[o.key]=o.value);const r={};return Object.keys(e).length>0&&(r.sipHeaders=e),Object.keys(i).length>0&&(r.voipHeaders=i),Object.keys(e).length>0||Object.keys(i).length>0?r:void 0}function gBe(t){return mBe(t.customHeaderContext)||mBe(t.clientTransferContext)}function mBe(t){if(!t)return;const e=t.sipHeaders||t.customContext?.sipHeaders,i=t.voipHeaders||t.customContext?.voipHeaders;if(!e&&!i)return;const r=wt().calling.customContext.userToUser.headerKey,o=wt().calling.customContext.xHeaders.headerKeyPrefix,l=e&&Object.entries(e).find(g=>g[0]?.toLowerCase()===r.toLowerCase()),d=e&&Object.entries(e).filter(g=>g[0]?.toLowerCase().startsWith(o?.toLowerCase())).map(g=>({key:g[0],value:g[1]})),h=i&&Object.entries(i).map(g=>({key:g[0],value:g[1]})),p={};return e&&l&&(p.userToUser=l[1]),d&&d.length>0&&(p.xHeaders=d,p.sipHeaders=d),h&&h.length>0&&(p.voipHeaders=h),p.userToUser===void 0&&p.xHeaders?.length===0&&p.sipHeaders?.length===0&&p.voipHeaders?.length===0?void 0:p}var Is=bs(function(t,e){var i=typeof Uint8Array<"u"&&typeof Uint16Array<"u"&&typeof Int32Array<"u";e.assign=function(l){for(var d=Array.prototype.slice.call(arguments,1);d.length;){var h=d.shift();if(h){if(typeof h!="object")throw new TypeError(h+"must be non-object");for(var p in h)h.hasOwnProperty(p)&&(l[p]=h[p])}}return l},e.shrinkBuf=function(l,d){return l.length===d?l:l.subarray?l.subarray(0,d):(l.length=d,l)};var r={arraySet:function(l,d,h,p,g){if(d.subarray&&l.subarray)l.set(d.subarray(h,h+p),g);else for(var f=0;f<p;f++)l[g+f]=d[h+f]},flattenChunks:function(l){var d,h,p,g,f,y;for(p=0,d=0,h=l.length;d<h;d++)p+=l[d].length;for(y=new Uint8Array(p),g=0,d=0,h=l.length;d<h;d++)f=l[d],y.set(f,g),g+=f.length;return y}},o={arraySet:function(l,d,h,p,g){for(var f=0;f<p;f++)l[g+f]=d[h+f]},flattenChunks:function(l){return[].concat.apply([],l)}};e.setTyped=function(l){l?(e.Buf8=Uint8Array,e.Buf16=Uint16Array,e.Buf32=Int32Array,e.assign(e,r)):(e.Buf8=Array,e.Buf16=Array,e.Buf32=Array,e.assign(e,o))},e.setTyped(i)}),jxt=4,fBe=0,vBe=1,Gxt=2;function M3(t){for(var e=t.length;--e>=0;)t[e]=0}var qxt=0,yBe=1,Wxt=2,Kxt=3,Jxt=258,The=29,p6=256,g6=p6+1+The,P3=30,Che=19,SBe=2*g6+1,EB=15,_he=16,Yxt=7,Ehe=256,bBe=16,TBe=17,CBe=18,Ahe=[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0],oQ=[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13],Qxt=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7],_Be=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15],Zxt=512,sP=new Array(2*(g6+2));M3(sP);var m6=new Array(2*P3);M3(m6);var f6=new Array(Zxt);M3(f6);var v6=new Array(Jxt-Kxt+1);M3(v6);var Ihe=new Array(The);M3(Ihe);var EBe,ABe,IBe,sQ=new Array(P3);function whe(t,e,i,r,o){this.static_tree=t,this.extra_bits=e,this.extra_base=i,this.elems=r,this.max_length=o,this.has_stree=t&&t.length}function khe(t,e){this.dyn_tree=t,this.max_code=0,this.stat_desc=e}function wBe(t){return t<256?f6[t]:f6[256+(t>>>7)]}function y6(t,e){t.pending_buf[t.pending++]=255&e,t.pending_buf[t.pending++]=e>>>8&255}function fT(t,e,i){t.bi_valid>_he-i?(t.bi_buf|=e<<t.bi_valid&65535,y6(t,t.bi_buf),t.bi_buf=e>>_he-t.bi_valid,t.bi_valid+=i-_he):(t.bi_buf|=e<<t.bi_valid&65535,t.bi_valid+=i)}function gk(t,e,i){fT(t,i[2*e],i[2*e+1])}function kBe(t,e){var i=0;do i|=1&t,t>>>=1,i<<=1;while(--e>0);return i>>>1}function Xxt(t){t.bi_valid===16?(y6(t,t.bi_buf),t.bi_buf=0,t.bi_valid=0):t.bi_valid>=8&&(t.pending_buf[t.pending++]=255&t.bi_buf,t.bi_buf>>=8,t.bi_valid-=8)}function eBt(t,e){var i,r,o,l,d,h,p=e.dyn_tree,g=e.max_code,f=e.stat_desc.static_tree,y=e.stat_desc.has_stree,T=e.stat_desc.extra_bits,C=e.stat_desc.extra_base,E=e.stat_desc.max_length,I=0;for(l=0;l<=EB;l++)t.bl_count[l]=0;for(p[2*t.heap[t.heap_max]+1]=0,i=t.heap_max+1;i<SBe;i++)(l=p[2*p[2*(r=t.heap[i])+1]+1]+1)>E&&(l=E,I++),p[2*r+1]=l,r>g||(t.bl_count[l]++,d=0,r>=C&&(d=T[r-C]),h=p[2*r],t.opt_len+=h*(l+d),y&&(t.static_len+=h*(f[2*r+1]+d)));if(I!==0){do{for(l=E-1;t.bl_count[l]===0;)l--;t.bl_count[l]--,t.bl_count[l+1]+=2,t.bl_count[E]--,I-=2}while(I>0);for(l=E;l!==0;l--)for(r=t.bl_count[l];r!==0;)(o=t.heap[--i])>g||(p[2*o+1]!==l&&(t.opt_len+=(l-p[2*o+1])*p[2*o],p[2*o+1]=l),r--)}}function RBe(t,e,i){var r,o,l=new Array(EB+1),d=0;for(r=1;r<=EB;r++)l[r]=d=d+i[r-1]<<1;for(o=0;o<=e;o++){var h=t[2*o+1];h!==0&&(t[2*o]=kBe(l[h]++,h))}}function tBt(){var t,e,i,r,o,l=new Array(EB+1);for(i=0,r=0;r<The-1;r++)for(Ihe[r]=i,t=0;t<1<<Ahe[r];t++)v6[i++]=r;for(v6[i-1]=r,o=0,r=0;r<16;r++)for(sQ[r]=o,t=0;t<1<<oQ[r];t++)f6[o++]=r;for(o>>=7;r<P3;r++)for(sQ[r]=o<<7,t=0;t<1<<oQ[r]-7;t++)f6[256+o++]=r;for(e=0;e<=EB;e++)l[e]=0;for(t=0;t<=143;)sP[2*t+1]=8,t++,l[8]++;for(;t<=255;)sP[2*t+1]=9,t++,l[9]++;for(;t<=279;)sP[2*t+1]=7,t++,l[7]++;for(;t<=287;)sP[2*t+1]=8,t++,l[8]++;for(RBe(sP,g6+1,l),t=0;t<P3;t++)m6[2*t+1]=5,m6[2*t]=kBe(t,5);EBe=new whe(sP,Ahe,p6+1,g6,EB),ABe=new whe(m6,oQ,0,P3,EB),IBe=new whe(new Array(0),Qxt,0,Che,Yxt)}function MBe(t){var e;for(e=0;e<g6;e++)t.dyn_ltree[2*e]=0;for(e=0;e<P3;e++)t.dyn_dtree[2*e]=0;for(e=0;e<Che;e++)t.bl_tree[2*e]=0;t.dyn_ltree[2*Ehe]=1,t.opt_len=t.static_len=0,t.last_lit=t.matches=0}function PBe(t){t.bi_valid>8?y6(t,t.bi_buf):t.bi_valid>0&&(t.pending_buf[t.pending++]=t.bi_buf),t.bi_buf=0,t.bi_valid=0}function iBt(t,e,i,r){PBe(t),y6(t,i),y6(t,~i),Is.arraySet(t.pending_buf,t.window,e,i,t.pending),t.pending+=i}function DBe(t,e,i,r){var o=2*e,l=2*i;return t[o]<t[l]||t[o]===t[l]&&r[e]<=r[i]}function Rhe(t,e,i){for(var r=t.heap[i],o=i<<1;o<=t.heap_len&&(o<t.heap_len&&DBe(e,t.heap[o+1],t.heap[o],t.depth)&&o++,!DBe(e,r,t.heap[o],t.depth));)t.heap[i]=t.heap[o],i=o,o<<=1;t.heap[i]=r}function LBe(t,e,i){var r,o,l,d,h=0;if(t.last_lit!==0)do r=t.pending_buf[t.d_buf+2*h]<<8|t.pending_buf[t.d_buf+2*h+1],o=t.pending_buf[t.l_buf+h],h++,r===0?gk(t,o,e):(gk(t,(l=v6[o])+p6+1,e),(d=Ahe[l])!==0&&fT(t,o-=Ihe[l],d),gk(t,l=wBe(--r),i),(d=oQ[l])!==0&&fT(t,r-=sQ[l],d));while(h<t.last_lit);gk(t,Ehe,e)}function Mhe(t,e){var i,r,o,l=e.dyn_tree,d=e.stat_desc.static_tree,h=e.stat_desc.has_stree,p=e.stat_desc.elems,g=-1;for(t.heap_len=0,t.heap_max=SBe,i=0;i<p;i++)l[2*i]!==0?(t.heap[++t.heap_len]=g=i,t.depth[i]=0):l[2*i+1]=0;for(;t.heap_len<2;)l[2*(o=t.heap[++t.heap_len]=g<2?++g:0)]=1,t.depth[o]=0,t.opt_len--,h&&(t.static_len-=d[2*o+1]);for(e.max_code=g,i=t.heap_len>>1;i>=1;i--)Rhe(t,l,i);o=p;do i=t.heap[1],t.heap[1]=t.heap[t.heap_len--],Rhe(t,l,1),r=t.heap[1],t.heap[--t.heap_max]=i,t.heap[--t.heap_max]=r,l[2*o]=l[2*i]+l[2*r],t.depth[o]=(t.depth[i]>=t.depth[r]?t.depth[i]:t.depth[r])+1,l[2*i+1]=l[2*r+1]=o,t.heap[1]=o++,Rhe(t,l,1);while(t.heap_len>=2);t.heap[--t.heap_max]=t.heap[1],eBt(t,e),RBe(l,g,t.bl_count)}function OBe(t,e,i){var r,o,l=-1,d=e[1],h=0,p=7,g=4;for(d===0&&(p=138,g=3),e[2*(i+1)+1]=65535,r=0;r<=i;r++)o=d,d=e[2*(r+1)+1],++h<p&&o===d||(h<g?t.bl_tree[2*o]+=h:o!==0?(o!==l&&t.bl_tree[2*o]++,t.bl_tree[2*bBe]++):h<=10?t.bl_tree[2*TBe]++:t.bl_tree[2*CBe]++,h=0,l=o,d===0?(p=138,g=3):o===d?(p=6,g=3):(p=7,g=4))}function NBe(t,e,i){var r,o,l=-1,d=e[1],h=0,p=7,g=4;for(d===0&&(p=138,g=3),r=0;r<=i;r++)if(o=d,d=e[2*(r+1)+1],!(++h<p&&o===d)){if(h<g)do gk(t,o,t.bl_tree);while(--h!=0);else o!==0?(o!==l&&(gk(t,o,t.bl_tree),h--),gk(t,bBe,t.bl_tree),fT(t,h-3,2)):h<=10?(gk(t,TBe,t.bl_tree),fT(t,h-3,3)):(gk(t,CBe,t.bl_tree),fT(t,h-11,7));h=0,l=o,d===0?(p=138,g=3):o===d?(p=6,g=3):(p=7,g=4)}}function nBt(t){var e;for(OBe(t,t.dyn_ltree,t.l_desc.max_code),OBe(t,t.dyn_dtree,t.d_desc.max_code),Mhe(t,t.bl_desc),e=Che-1;e>=3&&t.bl_tree[2*_Be[e]+1]===0;e--);return t.opt_len+=3*(e+1)+5+5+4,e}function aBt(t,e,i,r){var o;for(fT(t,e-257,5),fT(t,i-1,5),fT(t,r-4,4),o=0;o<r;o++)fT(t,t.bl_tree[2*_Be[o]+1],3);NBe(t,t.dyn_ltree,e-1),NBe(t,t.dyn_dtree,i-1)}function rBt(t){var e,i=4093624447;for(e=0;e<=31;e++,i>>>=1)if(1&i&&t.dyn_ltree[2*e]!==0)return fBe;if(t.dyn_ltree[18]!==0||t.dyn_ltree[20]!==0||t.dyn_ltree[26]!==0)return vBe;for(e=32;e<p6;e++)if(t.dyn_ltree[2*e]!==0)return vBe;return fBe}M3(sQ);var xBe=!1;function oBt(t){xBe||(tBt(),xBe=!0),t.l_desc=new khe(t.dyn_ltree,EBe),t.d_desc=new khe(t.dyn_dtree,ABe),t.bl_desc=new khe(t.bl_tree,IBe),t.bi_buf=0,t.bi_valid=0,MBe(t)}function BBe(t,e,i,r){fT(t,(qxt<<1)+(r?1:0),3),iBt(t,e,i)}function sBt(t){fT(t,yBe<<1,3),gk(t,Ehe,sP),Xxt(t)}function lBt(t,e,i,r){var o,l,d=0;t.level>0?(t.strm.data_type===Gxt&&(t.strm.data_type=rBt(t)),Mhe(t,t.l_desc),Mhe(t,t.d_desc),d=nBt(t),o=t.opt_len+3+7>>>3,(l=t.static_len+3+7>>>3)<=o&&(o=l)):o=l=i+5,i+4<=o&&e!==-1?BBe(t,e,i,r):t.strategy===jxt||l===o?(fT(t,(yBe<<1)+(r?1:0),3),LBe(t,sP,m6)):(fT(t,(Wxt<<1)+(r?1:0),3),aBt(t,t.l_desc.max_code+1,t.d_desc.max_code+1,d+1),LBe(t,t.dyn_ltree,t.dyn_dtree)),MBe(t),r&&PBe(t)}function cBt(t,e,i){return t.pending_buf[t.d_buf+2*t.last_lit]=e>>>8&255,t.pending_buf[t.d_buf+2*t.last_lit+1]=255&e,t.pending_buf[t.l_buf+t.last_lit]=255&i,t.last_lit++,e===0?t.dyn_ltree[2*i]++:(t.matches++,e--,t.dyn_ltree[2*(v6[i]+p6+1)]++,t.dyn_dtree[2*wBe(e)]++),t.last_lit===t.lit_bufsize-1}var DE={_tr_init:oBt,_tr_stored_block:BBe,_tr_flush_block:lBt,_tr_tally:cBt,_tr_align:sBt};function dBt(t,e,i,r){for(var o=65535&t,l=t>>>16&65535,d=0;i!==0;){i-=d=i>2e3?2e3:i;do l=l+(o=o+e[r++]|0)|0;while(--d);o%=65521,l%=65521}return o|l<<16}var S6=dBt;function uBt(){for(var t,e=[],i=0;i<256;i++){t=i;for(var r=0;r<8;r++)t=1&t?3988292384^t>>>1:t>>>1;e[i]=t}return e}var hBt=uBt();function pBt(t,e,i,r){var o=hBt,l=r+i;t^=-1;for(var d=r;d<l;d++)t=t>>>8^o[255&(t^e[d])];return~t}var D3,jf=pBt,lQ={2:"need dictionary",1:"stream end",0:"","-1":"file error","-2":"stream error","-3":"data error","-4":"insufficient memory","-5":"buffer error","-6":"incompatible version"},AB=0,gBt=1,mBt=3,bO=4,FBe=5,mk=0,UBe=1,LE=-2,fBt=-3,Phe=-5,vBt=-1,yBt=1,cQ=2,SBt=3,bBt=4,TBt=0,CBt=2,dQ=8,_Bt=9,EBt=15,ABt=8,Dhe=286,IBt=30,wBt=19,kBt=2*Dhe+1,RBt=15,gc=3,TO=258,NA=TO+gc+1,MBt=32,uQ=42,Lhe=69,hQ=73,pQ=91,gQ=103,IB=113,b6=666,Gf=1,T6=2,wB=3,L3=4,PBt=3;function CO(t,e){return t.msg=lQ[e],e}function zBe(t){return(t<<1)-(t>4?9:0)}function _O(t){for(var e=t.length;--e>=0;)t[e]=0}function EO(t){var e=t.state,i=e.pending;i>t.avail_out&&(i=t.avail_out),i!==0&&(Is.arraySet(t.output,e.pending_buf,e.pending_out,i,t.next_out),t.next_out+=i,e.pending_out+=i,t.total_out+=i,t.avail_out-=i,e.pending-=i,e.pending===0&&(e.pending_out=0))}function Uv(t,e){DE._tr_flush_block(t,t.block_start>=0?t.block_start:-1,t.strstart-t.block_start,e),t.block_start=t.strstart,EO(t.strm)}function Vc(t,e){t.pending_buf[t.pending++]=e}function C6(t,e){t.pending_buf[t.pending++]=e>>>8&255,t.pending_buf[t.pending++]=255&e}function DBt(t,e,i,r){var o=t.avail_in;return o>r&&(o=r),o===0?0:(t.avail_in-=o,Is.arraySet(e,t.input,t.next_in,o,i),t.state.wrap===1?t.adler=S6(t.adler,e,o,i):t.state.wrap===2&&(t.adler=jf(t.adler,e,o,i)),t.next_in+=o,t.total_in+=o,o)}function VBe(t,e){var i,r,o=t.max_chain_length,l=t.strstart,d=t.prev_length,h=t.nice_match,p=t.strstart>t.w_size-NA?t.strstart-(t.w_size-NA):0,g=t.window,f=t.w_mask,y=t.prev,T=t.strstart+TO,C=g[l+d-1],E=g[l+d];t.prev_length>=t.good_match&&(o>>=2),h>t.lookahead&&(h=t.lookahead);do if(g[(i=e)+d]===E&&g[i+d-1]===C&&g[i]===g[l]&&g[++i]===g[l+1]){l+=2,i++;do;while(g[++l]===g[++i]&&g[++l]===g[++i]&&g[++l]===g[++i]&&g[++l]===g[++i]&&g[++l]===g[++i]&&g[++l]===g[++i]&&g[++l]===g[++i]&&g[++l]===g[++i]&&l<T);if(r=TO-(T-l),l=T-TO,r>d){if(t.match_start=e,d=r,r>=h)break;C=g[l+d-1],E=g[l+d]}}while((e=y[e&f])>p&&--o!=0);return d<=t.lookahead?d:t.lookahead}function kB(t){var e,i,r,o,l,d=t.w_size;do{if(o=t.window_size-t.lookahead-t.strstart,t.strstart>=d+(d-NA)){Is.arraySet(t.window,t.window,d,d,0),t.match_start-=d,t.strstart-=d,t.block_start-=d,e=i=t.hash_size;do r=t.head[--e],t.head[e]=r>=d?r-d:0;while(--i);e=i=d;do r=t.prev[--e],t.prev[e]=r>=d?r-d:0;while(--i);o+=d}if(t.strm.avail_in===0)break;if(i=DBt(t.strm,t.window,t.strstart+t.lookahead,o),t.lookahead+=i,t.lookahead+t.insert>=gc)for(l=t.strstart-t.insert,t.ins_h=t.window[l],t.ins_h=(t.ins_h<<t.hash_shift^t.window[l+1])&t.hash_mask;t.insert&&(t.ins_h=(t.ins_h<<t.hash_shift^t.window[l+gc-1])&t.hash_mask,t.prev[l&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=l,l++,t.insert--,!(t.lookahead+t.insert<gc)););}while(t.lookahead<NA&&t.strm.avail_in!==0)}function LBt(t,e){var i=65535;for(i>t.pending_buf_size-5&&(i=t.pending_buf_size-5);;){if(t.lookahead<=1){if(kB(t),t.lookahead===0&&e===AB)return Gf;if(t.lookahead===0)break}t.strstart+=t.lookahead,t.lookahead=0;var r=t.block_start+i;if((t.strstart===0||t.strstart>=r)&&(t.lookahead=t.strstart-r,t.strstart=r,Uv(t,!1),t.strm.avail_out===0)||t.strstart-t.block_start>=t.w_size-NA&&(Uv(t,!1),t.strm.avail_out===0))return Gf}return t.insert=0,e===bO?(Uv(t,!0),t.strm.avail_out===0?wB:L3):(t.strstart>t.block_start&&(Uv(t,!1),t.strm.avail_out),Gf)}function Ohe(t,e){for(var i,r;;){if(t.lookahead<NA){if(kB(t),t.lookahead<NA&&e===AB)return Gf;if(t.lookahead===0)break}if(i=0,t.lookahead>=gc&&(t.ins_h=(t.ins_h<<t.hash_shift^t.window[t.strstart+gc-1])&t.hash_mask,i=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),i!==0&&t.strstart-i<=t.w_size-NA&&(t.match_length=VBe(t,i)),t.match_length>=gc)if(r=DE._tr_tally(t,t.strstart-t.match_start,t.match_length-gc),t.lookahead-=t.match_length,t.match_length<=t.max_lazy_match&&t.lookahead>=gc){t.match_length--;do t.strstart++,t.ins_h=(t.ins_h<<t.hash_shift^t.window[t.strstart+gc-1])&t.hash_mask,i=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart;while(--t.match_length!=0);t.strstart++}else t.strstart+=t.match_length,t.match_length=0,t.ins_h=t.window[t.strstart],t.ins_h=(t.ins_h<<t.hash_shift^t.window[t.strstart+1])&t.hash_mask;else r=DE._tr_tally(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++;if(r&&(Uv(t,!1),t.strm.avail_out===0))return Gf}return t.insert=t.strstart<gc-1?t.strstart:gc-1,e===bO?(Uv(t,!0),t.strm.avail_out===0?wB:L3):t.last_lit&&(Uv(t,!1),t.strm.avail_out===0)?Gf:T6}function O3(t,e){for(var i,r,o;;){if(t.lookahead<NA){if(kB(t),t.lookahead<NA&&e===AB)return Gf;if(t.lookahead===0)break}if(i=0,t.lookahead>=gc&&(t.ins_h=(t.ins_h<<t.hash_shift^t.window[t.strstart+gc-1])&t.hash_mask,i=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),t.prev_length=t.match_length,t.prev_match=t.match_start,t.match_length=gc-1,i!==0&&t.prev_length<t.max_lazy_match&&t.strstart-i<=t.w_size-NA&&(t.match_length=VBe(t,i),t.match_length<=5&&(t.strategy===yBt||t.match_length===gc&&t.strstart-t.match_start>4096)&&(t.match_length=gc-1)),t.prev_length>=gc&&t.match_length<=t.prev_length){o=t.strstart+t.lookahead-gc,r=DE._tr_tally(t,t.strstart-1-t.prev_match,t.prev_length-gc),t.lookahead-=t.prev_length-1,t.prev_length-=2;do++t.strstart<=o&&(t.ins_h=(t.ins_h<<t.hash_shift^t.window[t.strstart+gc-1])&t.hash_mask,i=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart);while(--t.prev_length!=0);if(t.match_available=0,t.match_length=gc-1,t.strstart++,r&&(Uv(t,!1),t.strm.avail_out===0))return Gf}else if(t.match_available){if((r=DE._tr_tally(t,0,t.window[t.strstart-1]))&&Uv(t,!1),t.strstart++,t.lookahead--,t.strm.avail_out===0)return Gf}else t.match_available=1,t.strstart++,t.lookahead--}return t.match_available&&(r=DE._tr_tally(t,0,t.window[t.strstart-1]),t.match_available=0),t.insert=t.strstart<gc-1?t.strstart:gc-1,e===bO?(Uv(t,!0),t.strm.avail_out===0?wB:L3):t.last_lit&&(Uv(t,!1),t.strm.avail_out===0)?Gf:T6}function OBt(t,e){for(var i,r,o,l,d=t.window;;){if(t.lookahead<=TO){if(kB(t),t.lookahead<=TO&&e===AB)return Gf;if(t.lookahead===0)break}if(t.match_length=0,t.lookahead>=gc&&t.strstart>0&&(r=d[o=t.strstart-1])===d[++o]&&r===d[++o]&&r===d[++o]){l=t.strstart+TO;do;while(r===d[++o]&&r===d[++o]&&r===d[++o]&&r===d[++o]&&r===d[++o]&&r===d[++o]&&r===d[++o]&&r===d[++o]&&o<l);t.match_length=TO-(l-o),t.match_length>t.lookahead&&(t.match_length=t.lookahead)}if(t.match_length>=gc?(i=DE._tr_tally(t,1,t.match_length-gc),t.lookahead-=t.match_length,t.strstart+=t.match_length,t.match_length=0):(i=DE._tr_tally(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++),i&&(Uv(t,!1),t.strm.avail_out===0))return Gf}return t.insert=0,e===bO?(Uv(t,!0),t.strm.avail_out===0?wB:L3):t.last_lit&&(Uv(t,!1),t.strm.avail_out===0)?Gf:T6}function NBt(t,e){for(var i;;){if(t.lookahead===0&&(kB(t),t.lookahead===0)){if(e===AB)return Gf;break}if(t.match_length=0,i=DE._tr_tally(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++,i&&(Uv(t,!1),t.strm.avail_out===0))return Gf}return t.insert=0,e===bO?(Uv(t,!0),t.strm.avail_out===0?wB:L3):t.last_lit&&(Uv(t,!1),t.strm.avail_out===0)?Gf:T6}function fk(t,e,i,r,o){this.good_length=t,this.max_lazy=e,this.nice_length=i,this.max_chain=r,this.func=o}function xBt(t){t.window_size=2*t.w_size,_O(t.head),t.max_lazy_match=D3[t.level].max_lazy,t.good_match=D3[t.level].good_length,t.nice_match=D3[t.level].nice_length,t.max_chain_length=D3[t.level].max_chain,t.strstart=0,t.block_start=0,t.lookahead=0,t.insert=0,t.match_length=t.prev_length=gc-1,t.match_available=0,t.ins_h=0}function BBt(){this.strm=null,this.status=0,this.pending_buf=null,this.pending_buf_size=0,this.pending_out=0,this.pending=0,this.wrap=0,this.gzhead=null,this.gzindex=0,this.method=dQ,this.last_flush=-1,this.w_size=0,this.w_bits=0,this.w_mask=0,this.window=null,this.window_size=0,this.prev=null,this.head=null,this.ins_h=0,this.hash_size=0,this.hash_bits=0,this.hash_mask=0,this.hash_shift=0,this.block_start=0,this.match_length=0,this.prev_match=0,this.match_available=0,this.strstart=0,this.match_start=0,this.lookahead=0,this.prev_length=0,this.max_chain_length=0,this.max_lazy_match=0,this.level=0,this.strategy=0,this.good_match=0,this.nice_match=0,this.dyn_ltree=new Is.Buf16(2*kBt),this.dyn_dtree=new Is.Buf16(2*(2*IBt+1)),this.bl_tree=new Is.Buf16(2*(2*wBt+1)),_O(this.dyn_ltree),_O(this.dyn_dtree),_O(this.bl_tree),this.l_desc=null,this.d_desc=null,this.bl_desc=null,this.bl_count=new Is.Buf16(RBt+1),this.heap=new Is.Buf16(2*Dhe+1),_O(this.heap),this.heap_len=0,this.heap_max=0,this.depth=new Is.Buf16(2*Dhe+1),_O(this.depth),this.l_buf=0,this.lit_bufsize=0,this.last_lit=0,this.d_buf=0,this.opt_len=0,this.static_len=0,this.matches=0,this.insert=0,this.bi_buf=0,this.bi_valid=0}function $Be(t){var e;return t&&t.state?(t.total_in=t.total_out=0,t.data_type=CBt,(e=t.state).pending=0,e.pending_out=0,e.wrap<0&&(e.wrap=-e.wrap),e.status=e.wrap?uQ:IB,t.adler=e.wrap===2?0:1,e.last_flush=AB,DE._tr_init(e),mk):CO(t,LE)}function HBe(t){var e=$Be(t);return e===mk&&xBt(t.state),e}function FBt(t,e){return t&&t.state?t.state.wrap!==2?LE:(t.state.gzhead=e,mk):LE}function jBe(t,e,i,r,o,l){if(!t)return LE;var d=1;if(e===vBt&&(e=6),r<0?(d=0,r=-r):r>15&&(d=2,r-=16),o<1||o>_Bt||i!==dQ||r<8||r>15||e<0||e>9||l<0||l>bBt)return CO(t,LE);r===8&&(r=9);var h=new BBt;return t.state=h,h.strm=t,h.wrap=d,h.gzhead=null,h.w_bits=r,h.w_size=1<<h.w_bits,h.w_mask=h.w_size-1,h.hash_bits=o+7,h.hash_size=1<<h.hash_bits,h.hash_mask=h.hash_size-1,h.hash_shift=~~((h.hash_bits+gc-1)/gc),h.window=new Is.Buf8(2*h.w_size),h.head=new Is.Buf16(h.hash_size),h.prev=new Is.Buf16(h.w_size),h.lit_bufsize=1<<o+6,h.pending_buf_size=4*h.lit_bufsize,h.pending_buf=new Is.Buf8(h.pending_buf_size),h.d_buf=h.lit_bufsize>>1,h.l_buf=3*h.lit_bufsize,h.level=e,h.strategy=l,h.method=i,HBe(t)}function UBt(t,e){return jBe(t,e,dQ,EBt,ABt,TBt)}function zBt(t,e){var i,r,o,l;if(!t||!t.state||e>FBe||e<0)return t?CO(t,LE):LE;if(r=t.state,!t.output||!t.input&&t.avail_in!==0||r.status===b6&&e!==bO)return CO(t,t.avail_out===0?Phe:LE);if(r.strm=t,i=r.last_flush,r.last_flush=e,r.status===uQ)if(r.wrap===2)t.adler=0,Vc(r,31),Vc(r,139),Vc(r,8),r.gzhead?(Vc(r,(r.gzhead.text?1:0)+(r.gzhead.hcrc?2:0)+(r.gzhead.extra?4:0)+(r.gzhead.name?8:0)+(r.gzhead.comment?16:0)),Vc(r,255&r.gzhead.time),Vc(r,r.gzhead.time>>8&255),Vc(r,r.gzhead.time>>16&255),Vc(r,r.gzhead.time>>24&255),Vc(r,r.level===9?2:r.strategy>=cQ||r.level<2?4:0),Vc(r,255&r.gzhead.os),r.gzhead.extra&&r.gzhead.extra.length&&(Vc(r,255&r.gzhead.extra.length),Vc(r,r.gzhead.extra.length>>8&255)),r.gzhead.hcrc&&(t.adler=jf(t.adler,r.pending_buf,r.pending,0)),r.gzindex=0,r.status=Lhe):(Vc(r,0),Vc(r,0),Vc(r,0),Vc(r,0),Vc(r,0),Vc(r,r.level===9?2:r.strategy>=cQ||r.level<2?4:0),Vc(r,PBt),r.status=IB);else{var d=dQ+(r.w_bits-8<<4)<<8;d|=(r.strategy>=cQ||r.level<2?0:r.level<6?1:r.level===6?2:3)<<6,r.strstart!==0&&(d|=MBt),d+=31-d%31,r.status=IB,C6(r,d),r.strstart!==0&&(C6(r,t.adler>>>16),C6(r,65535&t.adler)),t.adler=1}if(r.status===Lhe)if(r.gzhead.extra){for(o=r.pending;r.gzindex<(65535&r.gzhead.extra.length)&&(r.pending!==r.pending_buf_size||(r.gzhead.hcrc&&r.pending>o&&(t.adler=jf(t.adler,r.pending_buf,r.pending-o,o)),EO(t),o=r.pending,r.pending!==r.pending_buf_size));)Vc(r,255&r.gzhead.extra[r.gzindex]),r.gzindex++;r.gzhead.hcrc&&r.pending>o&&(t.adler=jf(t.adler,r.pending_buf,r.pending-o,o)),r.gzindex===r.gzhead.extra.length&&(r.gzindex=0,r.status=hQ)}else r.status=hQ;if(r.status===hQ)if(r.gzhead.name){o=r.pending;do{if(r.pending===r.pending_buf_size&&(r.gzhead.hcrc&&r.pending>o&&(t.adler=jf(t.adler,r.pending_buf,r.pending-o,o)),EO(t),o=r.pending,r.pending===r.pending_buf_size)){l=1;break}l=r.gzindex<r.gzhead.name.length?255&r.gzhead.name.charCodeAt(r.gzindex++):0,Vc(r,l)}while(l!==0);r.gzhead.hcrc&&r.pending>o&&(t.adler=jf(t.adler,r.pending_buf,r.pending-o,o)),l===0&&(r.gzindex=0,r.status=pQ)}else r.status=pQ;if(r.status===pQ)if(r.gzhead.comment){o=r.pending;do{if(r.pending===r.pending_buf_size&&(r.gzhead.hcrc&&r.pending>o&&(t.adler=jf(t.adler,r.pending_buf,r.pending-o,o)),EO(t),o=r.pending,r.pending===r.pending_buf_size)){l=1;break}l=r.gzindex<r.gzhead.comment.length?255&r.gzhead.comment.charCodeAt(r.gzindex++):0,Vc(r,l)}while(l!==0);r.gzhead.hcrc&&r.pending>o&&(t.adler=jf(t.adler,r.pending_buf,r.pending-o,o)),l===0&&(r.status=gQ)}else r.status=gQ;if(r.status===gQ&&(r.gzhead.hcrc?(r.pending+2>r.pending_buf_size&&EO(t),r.pending+2<=r.pending_buf_size&&(Vc(r,255&t.adler),Vc(r,t.adler>>8&255),t.adler=0,r.status=IB)):r.status=IB),r.pending!==0){if(EO(t),t.avail_out===0)return r.last_flush=-1,mk}else if(t.avail_in===0&&zBe(e)<=zBe(i)&&e!==bO)return CO(t,Phe);if(r.status===b6&&t.avail_in!==0)return CO(t,Phe);if(t.avail_in!==0||r.lookahead!==0||e!==AB&&r.status!==b6){var h=r.strategy===cQ?NBt(r,e):r.strategy===SBt?OBt(r,e):D3[r.level].func(r,e);if(h!==wB&&h!==L3||(r.status=b6),h===Gf||h===wB)return t.avail_out===0&&(r.last_flush=-1),mk;if(h===T6&&(e===gBt?DE._tr_align(r):e!==FBe&&(DE._tr_stored_block(r,0,0,!1),e===mBt&&(_O(r.head),r.lookahead===0&&(r.strstart=0,r.block_start=0,r.insert=0))),EO(t),t.avail_out===0))return r.last_flush=-1,mk}return e!==bO?mk:r.wrap<=0?UBe:(r.wrap===2?(Vc(r,255&t.adler),Vc(r,t.adler>>8&255),Vc(r,t.adler>>16&255),Vc(r,t.adler>>24&255),Vc(r,255&t.total_in),Vc(r,t.total_in>>8&255),Vc(r,t.total_in>>16&255),Vc(r,t.total_in>>24&255)):(C6(r,t.adler>>>16),C6(r,65535&t.adler)),EO(t),r.wrap>0&&(r.wrap=-r.wrap),r.pending!==0?mk:UBe)}function VBt(t){var e;return t&&t.state?(e=t.state.status)!==uQ&&e!==Lhe&&e!==hQ&&e!==pQ&&e!==gQ&&e!==IB&&e!==b6?CO(t,LE):(t.state=null,e===IB?CO(t,fBt):mk):LE}function $Bt(t,e){var i,r,o,l,d,h,p,g,f=e.length;if(!t||!t.state||(l=(i=t.state).wrap)===2||l===1&&i.status!==uQ||i.lookahead)return LE;for(l===1&&(t.adler=S6(t.adler,e,f,0)),i.wrap=0,f>=i.w_size&&(l===0&&(_O(i.head),i.strstart=0,i.block_start=0,i.insert=0),g=new Is.Buf8(i.w_size),Is.arraySet(g,e,f-i.w_size,i.w_size,0),e=g,f=i.w_size),d=t.avail_in,h=t.next_in,p=t.input,t.avail_in=f,t.next_in=0,t.input=e,kB(i);i.lookahead>=gc;){r=i.strstart,o=i.lookahead-(gc-1);do i.ins_h=(i.ins_h<<i.hash_shift^i.window[r+gc-1])&i.hash_mask,i.prev[r&i.w_mask]=i.head[i.ins_h],i.head[i.ins_h]=r,r++;while(--o);i.strstart=r,i.lookahead=gc-1,kB(i)}return i.strstart+=i.lookahead,i.block_start=i.strstart,i.insert=i.lookahead,i.lookahead=0,i.match_length=i.prev_length=gc-1,i.match_available=0,t.next_in=h,t.input=p,t.avail_in=d,i.wrap=l,mk}D3=[new fk(0,0,0,0,LBt),new fk(4,4,8,4,Ohe),new fk(4,5,16,8,Ohe),new fk(4,6,32,32,Ohe),new fk(4,4,16,16,O3),new fk(8,16,32,32,O3),new fk(8,16,128,128,O3),new fk(8,32,128,256,O3),new fk(32,128,258,1024,O3),new fk(32,258,258,4096,O3)];var _6={deflateInit:UBt,deflateInit2:jBe,deflateReset:HBe,deflateResetKeep:$Be,deflateSetHeader:FBt,deflate:zBt,deflateEnd:VBt,deflateSetDictionary:$Bt,deflateInfo:"pako deflate (from Nodeca project)"},GBe=!0,qBe=!0;try{String.fromCharCode.apply(null,[0])}catch{GBe=!1}try{String.fromCharCode.apply(null,new Uint8Array(1))}catch{qBe=!1}for(var E6=new Is.Buf8(256),AO=0;AO<256;AO++)E6[AO]=AO>=252?6:AO>=248?5:AO>=240?4:AO>=224?3:AO>=192?2:1;E6[254]=E6[254]=1;var HBt=function(t){var e,i,r,o,l,d=t.length,h=0;for(o=0;o<d;o++)(64512&(i=t.charCodeAt(o)))==55296&&o+1<d&&(64512&(r=t.charCodeAt(o+1)))==56320&&(i=65536+(i-55296<<10)+(r-56320),o++),h+=i<128?1:i<2048?2:i<65536?3:4;for(e=new Is.Buf8(h),l=0,o=0;l<h;o++)(64512&(i=t.charCodeAt(o)))==55296&&o+1<d&&(64512&(r=t.charCodeAt(o+1)))==56320&&(i=65536+(i-55296<<10)+(r-56320),o++),i<128?e[l++]=i:i<2048?(e[l++]=192|i>>>6,e[l++]=128|63&i):i<65536?(e[l++]=224|i>>>12,e[l++]=128|i>>>6&63,e[l++]=128|63&i):(e[l++]=240|i>>>18,e[l++]=128|i>>>12&63,e[l++]=128|i>>>6&63,e[l++]=128|63&i);return e};function WBe(t,e){if(e<65537&&(t.subarray&&qBe||!t.subarray&&GBe))return String.fromCharCode.apply(null,Is.shrinkBuf(t,e));for(var i="",r=0;r<e;r++)i+=String.fromCharCode(t[r]);return i}var jBt=function(t){for(var e=new Is.Buf8(t.length),i=0,r=e.length;i<r;i++)e[i]=t.charCodeAt(i);return e},GBt=function(t,e){var i,r,o,l,d=e||t.length,h=new Array(2*d);for(r=0,i=0;i<d;)if((o=t[i++])<128)h[r++]=o;else if((l=E6[o])>4)h[r++]=65533,i+=l-1;else{for(o&=l===2?31:l===3?15:7;l>1&&i<d;)o=o<<6|63&t[i++],l--;l>1?h[r++]=65533:o<65536?h[r++]=o:(o-=65536,h[r++]=55296|o>>10&1023,h[r++]=56320|1023&o)}return WBe(h,r)},RB={string2buf:HBt,buf2binstring:function(t){return WBe(t,t.length)},binstring2buf:jBt,buf2string:GBt,utf8border:function(t,e){var i;for((e=e||t.length)>t.length&&(e=t.length),i=e-1;i>=0&&(192&t[i])==128;)i--;return i<0||i===0?e:i+E6[t[i]]>e?i:e}};function qBt(){this.input=null,this.next_in=0,this.avail_in=0,this.total_in=0,this.output=null,this.next_out=0,this.avail_out=0,this.total_out=0,this.msg="",this.state=null,this.data_type=2,this.adler=0}var KBe=qBt,JBe=Object.prototype.toString,WBt=0,Nhe=4,N3=0,YBe=1,QBe=2,KBt=-1,JBt=0,YBt=8;function MB(t){if(!(this instanceof MB))return new MB(t);this.options=Is.assign({level:KBt,method:YBt,chunkSize:16384,windowBits:15,memLevel:8,strategy:JBt,to:""},t||{});var e=this.options;e.raw&&e.windowBits>0?e.windowBits=-e.windowBits:e.gzip&&e.windowBits>0&&e.windowBits<16&&(e.windowBits+=16),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new KBe,this.strm.avail_out=0;var i=_6.deflateInit2(this.strm,e.level,e.method,e.windowBits,e.memLevel,e.strategy);if(i!==N3)throw new Error(lQ[i]);if(e.header&&_6.deflateSetHeader(this.strm,e.header),e.dictionary){var r;if(r=typeof e.dictionary=="string"?RB.string2buf(e.dictionary):JBe.call(e.dictionary)==="[object ArrayBuffer]"?new Uint8Array(e.dictionary):e.dictionary,(i=_6.deflateSetDictionary(this.strm,r))!==N3)throw new Error(lQ[i]);this._dict_set=!0}}function xhe(t,e){var i=new MB(e);if(i.push(t,!0),i.err)throw i.msg;return i.result}function QBt(t,e){return(e=e||{}).raw=!0,xhe(t,e)}function ZBt(t,e){return(e=e||{}).gzip=!0,xhe(t,e)}MB.prototype.push=function(t,e){var i,r,o=this.strm,l=this.options.chunkSize;if(this.ended)return!1;r=e===~~e?e:e===!0?Nhe:WBt,typeof t=="string"?o.input=RB.string2buf(t):JBe.call(t)==="[object ArrayBuffer]"?o.input=new Uint8Array(t):o.input=t,o.next_in=0,o.avail_in=o.input.length;do{if(o.avail_out===0&&(o.output=new Is.Buf8(l),o.next_out=0,o.avail_out=l),(i=_6.deflate(o,r))!==YBe&&i!==N3)return this.onEnd(i),this.ended=!0,!1;o.avail_out!==0&&(o.avail_in!==0||r!==Nhe&&r!==QBe)||(this.options.to==="string"?this.onData(RB.buf2binstring(Is.shrinkBuf(o.output,o.next_out))):this.onData(Is.shrinkBuf(o.output,o.next_out)))}while((o.avail_in>0||o.avail_out===0)&&i!==YBe);return r===Nhe?(i=_6.deflateEnd(this.strm),this.onEnd(i),this.ended=!0,i===N3):r!==QBe||(this.onEnd(N3),o.avail_out=0,!0)},MB.prototype.onData=function(t){this.chunks.push(t)},MB.prototype.onEnd=function(t){t===N3&&(this.options.to==="string"?this.result=this.chunks.join(""):this.result=Is.flattenChunks(this.chunks)),this.chunks=[],this.err=t,this.msg=this.strm.msg};var XBt={Deflate:MB,deflate:xhe,deflateRaw:QBt,gzip:ZBt},mQ=30,eFt=12,tFt=function(e,i){var r,o,l,d,h,p,g,f,y,T,C,E,I,w,D,F,x,B,L,z,H,j,J,Z,re;r=e.state,o=e.next_in,Z=e.input,l=o+(e.avail_in-5),d=e.next_out,re=e.output,h=d-(i-e.avail_out),p=d+(e.avail_out-257),g=r.dmax,f=r.wsize,y=r.whave,T=r.wnext,C=r.window,E=r.hold,I=r.bits,w=r.lencode,D=r.distcode,F=(1<<r.lenbits)-1,x=(1<<r.distbits)-1;e:do{I<15&&(E+=Z[o++]<<I,I+=8,E+=Z[o++]<<I,I+=8),B=w[E&F];t:for(;;){if(E>>>=L=B>>>24,I-=L,(L=B>>>16&255)===0)re[d++]=65535&B;else{if(!(16&L)){if(64&L){if(32&L){r.mode=eFt;break e}e.msg="invalid literal/length code",r.mode=mQ;break e}B=w[(65535&B)+(E&(1<<L)-1)];continue t}for(z=65535&B,(L&=15)&&(I<L&&(E+=Z[o++]<<I,I+=8),z+=E&(1<<L)-1,E>>>=L,I-=L),I<15&&(E+=Z[o++]<<I,I+=8,E+=Z[o++]<<I,I+=8),B=D[E&x];;){if(E>>>=L=B>>>24,I-=L,16&(L=B>>>16&255)){if(H=65535&B,I<(L&=15)&&(E+=Z[o++]<<I,(I+=8)<L&&(E+=Z[o++]<<I,I+=8)),(H+=E&(1<<L)-1)>g){e.msg="invalid distance too far back",r.mode=mQ;break e}if(E>>>=L,I-=L,H>(L=d-h)){if((L=H-L)>y&&r.sane){e.msg="invalid distance too far back",r.mode=mQ;break e}if(j=0,J=C,T===0){if(j+=f-L,L<z){z-=L;do re[d++]=C[j++];while(--L);j=d-H,J=re}}else if(T<L){if(j+=f+T-L,(L-=T)<z){z-=L;do re[d++]=C[j++];while(--L);if(j=0,T<z){z-=L=T;do re[d++]=C[j++];while(--L);j=d-H,J=re}}}else if(j+=T-L,L<z){z-=L;do re[d++]=C[j++];while(--L);j=d-H,J=re}for(;z>2;)re[d++]=J[j++],re[d++]=J[j++],re[d++]=J[j++],z-=3;z&&(re[d++]=J[j++],z>1&&(re[d++]=J[j++]))}else{j=d-H;do re[d++]=re[j++],re[d++]=re[j++],re[d++]=re[j++],z-=3;while(z>2);z&&(re[d++]=re[j++],z>1&&(re[d++]=re[j++]))}break}if(64&L){e.msg="invalid distance code",r.mode=mQ;break e}B=D[(65535&B)+(E&(1<<L)-1)]}}break}}while(o<l&&d<p);o-=z=I>>3,E&=(1<<(I-=z<<3))-1,e.next_in=o,e.next_out=d,e.avail_in=o<l?l-o+5:5-(o-l),e.avail_out=d<p?p-d+257:257-(d-p),r.hold=E,r.bits=I},x3=15,ZBe=852,XBe=592,eFe=0,Bhe=1,tFe=2,iFt=[3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258,0,0],nFt=[16,16,16,16,16,16,16,16,17,17,17,17,18,18,18,18,19,19,19,19,20,20,20,20,21,21,21,21,16,72,78],aFt=[1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577,0,0],rFt=[16,16,16,16,17,17,18,18,19,19,20,20,21,21,22,22,23,23,24,24,25,25,26,26,27,27,28,28,29,29,64,64],A6=function(e,i,r,o,l,d,h,p){var g,f,y,T,C,E,I,w,D,F=p.bits,x=0,B=0,L=0,z=0,H=0,j=0,J=0,Z=0,re=0,ne=0,le=null,he=0,Me=new Is.Buf16(x3+1),Le=new Is.Buf16(x3+1),pe=null,te=0;for(x=0;x<=x3;x++)Me[x]=0;for(B=0;B<o;B++)Me[i[r+B]]++;for(H=F,z=x3;z>=1&&Me[z]===0;z--);if(H>z&&(H=z),z===0)return l[d++]=20971520,l[d++]=20971520,p.bits=1,0;for(L=1;L<z&&Me[L]===0;L++);for(H<L&&(H=L),Z=1,x=1;x<=x3;x++)if(Z<<=1,(Z-=Me[x])<0)return-1;if(Z>0&&(e===eFe||z!==1))return-1;for(Le[1]=0,x=1;x<x3;x++)Le[x+1]=Le[x]+Me[x];for(B=0;B<o;B++)i[r+B]!==0&&(h[Le[i[r+B]]++]=B);if(e===eFe?(le=pe=h,E=19):e===Bhe?(le=iFt,he-=257,pe=nFt,te-=257,E=256):(le=aFt,pe=rFt,E=-1),ne=0,B=0,x=L,C=d,j=H,J=0,y=-1,T=(re=1<<H)-1,e===Bhe&&re>ZBe||e===tFe&&re>XBe)return 1;for(;;){I=x-J,h[B]<E?(w=0,D=h[B]):h[B]>E?(w=pe[te+h[B]],D=le[he+h[B]]):(w=96,D=0),g=1<<x-J,L=f=1<<j;do l[C+(ne>>J)+(f-=g)]=I<<24|w<<16|D;while(f!==0);for(g=1<<x-1;ne&g;)g>>=1;if(g!==0?(ne&=g-1,ne+=g):ne=0,B++,--Me[x]==0){if(x===z)break;x=i[r+h[B]]}if(x>H&&(ne&T)!==y){for(J===0&&(J=H),C+=L,Z=1<<(j=x-J);j+J<z&&!((Z-=Me[j+J])<=0);)j++,Z<<=1;if(re+=1<<j,e===Bhe&&re>ZBe||e===tFe&&re>XBe)return 1;l[y=ne&T]=H<<24|j<<16|C-d}}return ne!==0&&(l[C+ne]=x-J<<24|64<<16),p.bits=H,0},oFt=0,iFe=1,nFe=2,aFe=4,sFt=5,fQ=6,PB=0,lFt=1,cFt=2,xA=-2,rFe=-3,oFe=-4,dFt=-5,sFe=8,lFe=1,cFe=2,dFe=3,uFe=4,hFe=5,pFe=6,gFe=7,mFe=8,fFe=9,vFe=10,vQ=11,lP=12,Fhe=13,yFe=14,Uhe=15,SFe=16,bFe=17,TFe=18,CFe=19,yQ=20,SQ=21,_Fe=22,EFe=23,AFe=24,IFe=25,wFe=26,zhe=27,kFe=28,RFe=29,Rh=30,MFe=31,uFt=852,hFt=592,pFt=15;function PFe(t){return(t>>>24&255)+(t>>>8&65280)+((65280&t)<<8)+((255&t)<<24)}function gFt(){this.mode=0,this.last=!1,this.wrap=0,this.havedict=!1,this.flags=0,this.dmax=0,this.check=0,this.total=0,this.head=null,this.wbits=0,this.wsize=0,this.whave=0,this.wnext=0,this.window=null,this.hold=0,this.bits=0,this.length=0,this.offset=0,this.extra=0,this.lencode=null,this.distcode=null,this.lenbits=0,this.distbits=0,this.ncode=0,this.nlen=0,this.ndist=0,this.have=0,this.next=null,this.lens=new Is.Buf16(320),this.work=new Is.Buf16(288),this.lendyn=null,this.distdyn=null,this.sane=0,this.back=0,this.was=0}function DFe(t){var e;return t&&t.state?(e=t.state,t.total_in=t.total_out=e.total=0,t.msg="",e.wrap&&(t.adler=1&e.wrap),e.mode=lFe,e.last=0,e.havedict=0,e.dmax=32768,e.head=null,e.hold=0,e.bits=0,e.lencode=e.lendyn=new Is.Buf32(uFt),e.distcode=e.distdyn=new Is.Buf32(hFt),e.sane=1,e.back=-1,PB):xA}function LFe(t){var e;return t&&t.state?((e=t.state).wsize=0,e.whave=0,e.wnext=0,DFe(t)):xA}function OFe(t,e){var i,r;return t&&t.state?(r=t.state,e<0?(i=0,e=-e):(i=1+(e>>4),e<48&&(e&=15)),e&&(e<8||e>15)?xA:(r.window!==null&&r.wbits!==e&&(r.window=null),r.wrap=i,r.wbits=e,LFe(t))):xA}function NFe(t,e){var i,r;return t?(r=new gFt,t.state=r,r.window=null,(i=OFe(t,e))!==PB&&(t.state=null),i):xA}function mFt(t){return NFe(t,pFt)}var Vhe,$he,xFe=!0;function fFt(t){if(xFe){var e;for(Vhe=new Is.Buf32(512),$he=new Is.Buf32(32),e=0;e<144;)t.lens[e++]=8;for(;e<256;)t.lens[e++]=9;for(;e<280;)t.lens[e++]=7;for(;e<288;)t.lens[e++]=8;for(A6(iFe,t.lens,0,288,Vhe,0,t.work,{bits:9}),e=0;e<32;)t.lens[e++]=5;A6(nFe,t.lens,0,32,$he,0,t.work,{bits:5}),xFe=!1}t.lencode=Vhe,t.lenbits=9,t.distcode=$he,t.distbits=5}function BFe(t,e,i,r){var o,l=t.state;return l.window===null&&(l.wsize=1<<l.wbits,l.wnext=0,l.whave=0,l.window=new Is.Buf8(l.wsize)),r>=l.wsize?(Is.arraySet(l.window,e,i-l.wsize,l.wsize,0),l.wnext=0,l.whave=l.wsize):((o=l.wsize-l.wnext)>r&&(o=r),Is.arraySet(l.window,e,i-r,o,l.wnext),(r-=o)?(Is.arraySet(l.window,e,i-r,r,0),l.wnext=r,l.whave=l.wsize):(l.wnext+=o,l.wnext===l.wsize&&(l.wnext=0),l.whave<l.wsize&&(l.whave+=o))),0}function vFt(t,e){var i,r,o,l,d,h,p,g,f,y,T,C,E,I,w,D,F,x,B,L,z,H,j,J,Z=0,re=new Is.Buf8(4),ne=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];if(!t||!t.state||!t.output||!t.input&&t.avail_in!==0)return xA;(i=t.state).mode===lP&&(i.mode=Fhe),d=t.next_out,o=t.output,p=t.avail_out,l=t.next_in,r=t.input,h=t.avail_in,g=i.hold,f=i.bits,y=h,T=p,H=PB;e:for(;;)switch(i.mode){case lFe:if(i.wrap===0){i.mode=Fhe;break}for(;f<16;){if(h===0)break e;h--,g+=r[l++]<<f,f+=8}if(2&i.wrap&&g===35615){i.check=0,re[0]=255&g,re[1]=g>>>8&255,i.check=jf(i.check,re,2,0),g=0,f=0,i.mode=cFe;break}if(i.flags=0,i.head&&(i.head.done=!1),!(1&i.wrap)||(((255&g)<<8)+(g>>8))%31){t.msg="incorrect header check",i.mode=Rh;break}if((15&g)!==sFe){t.msg="unknown compression method",i.mode=Rh;break}if(f-=4,z=8+(15&(g>>>=4)),i.wbits===0)i.wbits=z;else if(z>i.wbits){t.msg="invalid window size",i.mode=Rh;break}i.dmax=1<<z,t.adler=i.check=1,i.mode=512&g?vFe:lP,g=0,f=0;break;case cFe:for(;f<16;){if(h===0)break e;h--,g+=r[l++]<<f,f+=8}if(i.flags=g,(255&i.flags)!==sFe){t.msg="unknown compression method",i.mode=Rh;break}if(57344&i.flags){t.msg="unknown header flags set",i.mode=Rh;break}i.head&&(i.head.text=g>>8&1),512&i.flags&&(re[0]=255&g,re[1]=g>>>8&255,i.check=jf(i.check,re,2,0)),g=0,f=0,i.mode=dFe;case dFe:for(;f<32;){if(h===0)break e;h--,g+=r[l++]<<f,f+=8}i.head&&(i.head.time=g),512&i.flags&&(re[0]=255&g,re[1]=g>>>8&255,re[2]=g>>>16&255,re[3]=g>>>24&255,i.check=jf(i.check,re,4,0)),g=0,f=0,i.mode=uFe;case uFe:for(;f<16;){if(h===0)break e;h--,g+=r[l++]<<f,f+=8}i.head&&(i.head.xflags=255&g,i.head.os=g>>8),512&i.flags&&(re[0]=255&g,re[1]=g>>>8&255,i.check=jf(i.check,re,2,0)),g=0,f=0,i.mode=hFe;case hFe:if(1024&i.flags){for(;f<16;){if(h===0)break e;h--,g+=r[l++]<<f,f+=8}i.length=g,i.head&&(i.head.extra_len=g),512&i.flags&&(re[0]=255&g,re[1]=g>>>8&255,i.check=jf(i.check,re,2,0)),g=0,f=0}else i.head&&(i.head.extra=null);i.mode=pFe;case pFe:if(1024&i.flags&&((C=i.length)>h&&(C=h),C&&(i.head&&(z=i.head.extra_len-i.length,i.head.extra||(i.head.extra=new Array(i.head.extra_len)),Is.arraySet(i.head.extra,r,l,C,z)),512&i.flags&&(i.check=jf(i.check,r,C,l)),h-=C,l+=C,i.length-=C),i.length))break e;i.length=0,i.mode=gFe;case gFe:if(2048&i.flags){if(h===0)break e;C=0;do z=r[l+C++],i.head&&z&&i.length<65536&&(i.head.name+=String.fromCharCode(z));while(z&&C<h);if(512&i.flags&&(i.check=jf(i.check,r,C,l)),h-=C,l+=C,z)break e}else i.head&&(i.head.name=null);i.length=0,i.mode=mFe;case mFe:if(4096&i.flags){if(h===0)break e;C=0;do z=r[l+C++],i.head&&z&&i.length<65536&&(i.head.comment+=String.fromCharCode(z));while(z&&C<h);if(512&i.flags&&(i.check=jf(i.check,r,C,l)),h-=C,l+=C,z)break e}else i.head&&(i.head.comment=null);i.mode=fFe;case fFe:if(512&i.flags){for(;f<16;){if(h===0)break e;h--,g+=r[l++]<<f,f+=8}if(g!==(65535&i.check)){t.msg="header crc mismatch",i.mode=Rh;break}g=0,f=0}i.head&&(i.head.hcrc=i.flags>>9&1,i.head.done=!0),t.adler=i.check=0,i.mode=lP;break;case vFe:for(;f<32;){if(h===0)break e;h--,g+=r[l++]<<f,f+=8}t.adler=i.check=PFe(g),g=0,f=0,i.mode=vQ;case vQ:if(i.havedict===0)return t.next_out=d,t.avail_out=p,t.next_in=l,t.avail_in=h,i.hold=g,i.bits=f,cFt;t.adler=i.check=1,i.mode=lP;case lP:if(e===sFt||e===fQ)break e;case Fhe:if(i.last){g>>>=7&f,f-=7&f,i.mode=zhe;break}for(;f<3;){if(h===0)break e;h--,g+=r[l++]<<f,f+=8}switch(i.last=1&g,f-=1,3&(g>>>=1)){case 0:i.mode=yFe;break;case 1:if(fFt(i),i.mode=yQ,e===fQ){g>>>=2,f-=2;break e}break;case 2:i.mode=bFe;break;case 3:t.msg="invalid block type",i.mode=Rh}g>>>=2,f-=2;break;case yFe:for(g>>>=7&f,f-=7&f;f<32;){if(h===0)break e;h--,g+=r[l++]<<f,f+=8}if((65535&g)!=(g>>>16^65535)){t.msg="invalid stored block lengths",i.mode=Rh;break}if(i.length=65535&g,g=0,f=0,i.mode=Uhe,e===fQ)break e;case Uhe:i.mode=SFe;case SFe:if(C=i.length){if(C>h&&(C=h),C>p&&(C=p),C===0)break e;Is.arraySet(o,r,l,C,d),h-=C,l+=C,p-=C,d+=C,i.length-=C;break}i.mode=lP;break;case bFe:for(;f<14;){if(h===0)break e;h--,g+=r[l++]<<f,f+=8}if(i.nlen=257+(31&g),g>>>=5,f-=5,i.ndist=1+(31&g),g>>>=5,f-=5,i.ncode=4+(15&g),g>>>=4,f-=4,i.nlen>286||i.ndist>30){t.msg="too many length or distance symbols",i.mode=Rh;break}i.have=0,i.mode=TFe;case TFe:for(;i.have<i.ncode;){for(;f<3;){if(h===0)break e;h--,g+=r[l++]<<f,f+=8}i.lens[ne[i.have++]]=7&g,g>>>=3,f-=3}for(;i.have<19;)i.lens[ne[i.have++]]=0;if(i.lencode=i.lendyn,i.lenbits=7,j={bits:i.lenbits},H=A6(oFt,i.lens,0,19,i.lencode,0,i.work,j),i.lenbits=j.bits,H){t.msg="invalid code lengths set",i.mode=Rh;break}i.have=0,i.mode=CFe;case CFe:for(;i.have<i.nlen+i.ndist;){for(;D=(Z=i.lencode[g&(1<<i.lenbits)-1])>>>16&255,F=65535&Z,!((w=Z>>>24)<=f);){if(h===0)break e;h--,g+=r[l++]<<f,f+=8}if(F<16)g>>>=w,f-=w,i.lens[i.have++]=F;else{if(F===16){for(J=w+2;f<J;){if(h===0)break e;h--,g+=r[l++]<<f,f+=8}if(g>>>=w,f-=w,i.have===0){t.msg="invalid bit length repeat",i.mode=Rh;break}z=i.lens[i.have-1],C=3+(3&g),g>>>=2,f-=2}else if(F===17){for(J=w+3;f<J;){if(h===0)break e;h--,g+=r[l++]<<f,f+=8}f-=w,z=0,C=3+(7&(g>>>=w)),g>>>=3,f-=3}else{for(J=w+7;f<J;){if(h===0)break e;h--,g+=r[l++]<<f,f+=8}f-=w,z=0,C=11+(127&(g>>>=w)),g>>>=7,f-=7}if(i.have+C>i.nlen+i.ndist){t.msg="invalid bit length repeat",i.mode=Rh;break}for(;C--;)i.lens[i.have++]=z}}if(i.mode===Rh)break;if(i.lens[256]===0){t.msg="invalid code -- missing end-of-block",i.mode=Rh;break}if(i.lenbits=9,j={bits:i.lenbits},H=A6(iFe,i.lens,0,i.nlen,i.lencode,0,i.work,j),i.lenbits=j.bits,H){t.msg="invalid literal/lengths set",i.mode=Rh;break}if(i.distbits=6,i.distcode=i.distdyn,j={bits:i.distbits},H=A6(nFe,i.lens,i.nlen,i.ndist,i.distcode,0,i.work,j),i.distbits=j.bits,H){t.msg="invalid distances set",i.mode=Rh;break}if(i.mode=yQ,e===fQ)break e;case yQ:i.mode=SQ;case SQ:if(h>=6&&p>=258){t.next_out=d,t.avail_out=p,t.next_in=l,t.avail_in=h,i.hold=g,i.bits=f,tFt(t,T),d=t.next_out,o=t.output,p=t.avail_out,l=t.next_in,r=t.input,h=t.avail_in,g=i.hold,f=i.bits,i.mode===lP&&(i.back=-1);break}for(i.back=0;D=(Z=i.lencode[g&(1<<i.lenbits)-1])>>>16&255,F=65535&Z,!((w=Z>>>24)<=f);){if(h===0)break e;h--,g+=r[l++]<<f,f+=8}if(D&&!(240&D)){for(x=w,B=D,L=F;D=(Z=i.lencode[L+((g&(1<<x+B)-1)>>x)])>>>16&255,F=65535&Z,!(x+(w=Z>>>24)<=f);){if(h===0)break e;h--,g+=r[l++]<<f,f+=8}g>>>=x,f-=x,i.back+=x}if(g>>>=w,f-=w,i.back+=w,i.length=F,D===0){i.mode=wFe;break}if(32&D){i.back=-1,i.mode=lP;break}if(64&D){t.msg="invalid literal/length code",i.mode=Rh;break}i.extra=15&D,i.mode=_Fe;case _Fe:if(i.extra){for(J=i.extra;f<J;){if(h===0)break e;h--,g+=r[l++]<<f,f+=8}i.length+=g&(1<<i.extra)-1,g>>>=i.extra,f-=i.extra,i.back+=i.extra}i.was=i.length,i.mode=EFe;case EFe:for(;D=(Z=i.distcode[g&(1<<i.distbits)-1])>>>16&255,F=65535&Z,!((w=Z>>>24)<=f);){if(h===0)break e;h--,g+=r[l++]<<f,f+=8}if(!(240&D)){for(x=w,B=D,L=F;D=(Z=i.distcode[L+((g&(1<<x+B)-1)>>x)])>>>16&255,F=65535&Z,!(x+(w=Z>>>24)<=f);){if(h===0)break e;h--,g+=r[l++]<<f,f+=8}g>>>=x,f-=x,i.back+=x}if(g>>>=w,f-=w,i.back+=w,64&D){t.msg="invalid distance code",i.mode=Rh;break}i.offset=F,i.extra=15&D,i.mode=AFe;case AFe:if(i.extra){for(J=i.extra;f<J;){if(h===0)break e;h--,g+=r[l++]<<f,f+=8}i.offset+=g&(1<<i.extra)-1,g>>>=i.extra,f-=i.extra,i.back+=i.extra}if(i.offset>i.dmax){t.msg="invalid distance too far back",i.mode=Rh;break}i.mode=IFe;case IFe:if(p===0)break e;if(C=T-p,i.offset>C){if((C=i.offset-C)>i.whave&&i.sane){t.msg="invalid distance too far back",i.mode=Rh;break}C>i.wnext?(C-=i.wnext,E=i.wsize-C):E=i.wnext-C,C>i.length&&(C=i.length),I=i.window}else I=o,E=d-i.offset,C=i.length;C>p&&(C=p),p-=C,i.length-=C;do o[d++]=I[E++];while(--C);i.length===0&&(i.mode=SQ);break;case wFe:if(p===0)break e;o[d++]=i.length,p--,i.mode=SQ;break;case zhe:if(i.wrap){for(;f<32;){if(h===0)break e;h--,g|=r[l++]<<f,f+=8}if(T-=p,t.total_out+=T,i.total+=T,T&&(t.adler=i.check=i.flags?jf(i.check,o,T,d-T):S6(i.check,o,T,d-T)),T=p,(i.flags?g:PFe(g))!==i.check){t.msg="incorrect data check",i.mode=Rh;break}g=0,f=0}i.mode=kFe;case kFe:if(i.wrap&&i.flags){for(;f<32;){if(h===0)break e;h--,g+=r[l++]<<f,f+=8}if(g!==(4294967295&i.total)){t.msg="incorrect length check",i.mode=Rh;break}g=0,f=0}i.mode=RFe;case RFe:H=lFt;break e;case Rh:H=rFe;break e;case MFe:return oFe;default:return xA}return t.next_out=d,t.avail_out=p,t.next_in=l,t.avail_in=h,i.hold=g,i.bits=f,(i.wsize||T!==t.avail_out&&i.mode<Rh&&(i.mode<zhe||e!==aFe))&&BFe(t,t.output,t.next_out,T-t.avail_out),y-=t.avail_in,T-=t.avail_out,t.total_in+=y,t.total_out+=T,i.total+=T,i.wrap&&T&&(t.adler=i.check=i.flags?jf(i.check,o,T,t.next_out-T):S6(i.check,o,T,t.next_out-T)),t.data_type=i.bits+(i.last?64:0)+(i.mode===lP?128:0)+(i.mode===yQ||i.mode===Uhe?256:0),(y===0&&T===0||e===aFe)&&H===PB&&(H=dFt),H}function yFt(t){if(!t||!t.state)return xA;var e=t.state;return e.window&&(e.window=null),t.state=null,PB}function SFt(t,e){var i;return t&&t.state&&2&(i=t.state).wrap?(i.head=e,e.done=!1,PB):xA}function bFt(t,e){var i,r=e.length;return t&&t.state?(i=t.state).wrap!==0&&i.mode!==vQ?xA:i.mode===vQ&&S6(1,e,r,0)!==i.check?rFe:BFe(t,e,r,r)?(i.mode=MFe,oFe):(i.havedict=1,PB):xA}var I6={inflateReset:LFe,inflateReset2:OFe,inflateResetKeep:DFe,inflateInit:mFt,inflateInit2:NFe,inflate:vFt,inflateEnd:yFt,inflateGetHeader:SFt,inflateSetDictionary:bFt,inflateInfo:"pako inflate (from Nodeca project)"},dg={Z_NO_FLUSH:0,Z_PARTIAL_FLUSH:1,Z_SYNC_FLUSH:2,Z_FULL_FLUSH:3,Z_FINISH:4,Z_BLOCK:5,Z_TREES:6,Z_OK:0,Z_STREAM_END:1,Z_NEED_DICT:2,Z_ERRNO:-1,Z_STREAM_ERROR:-2,Z_DATA_ERROR:-3,Z_BUF_ERROR:-5,Z_NO_COMPRESSION:0,Z_BEST_SPEED:1,Z_BEST_COMPRESSION:9,Z_DEFAULT_COMPRESSION:-1,Z_FILTERED:1,Z_HUFFMAN_ONLY:2,Z_RLE:3,Z_FIXED:4,Z_DEFAULT_STRATEGY:0,Z_BINARY:0,Z_TEXT:1,Z_UNKNOWN:2,Z_DEFLATED:8};function TFt(){this.text=0,this.time=0,this.xflags=0,this.os=0,this.extra=null,this.extra_len=0,this.name="",this.comment="",this.hcrc=0,this.done=!1}var CFt=TFt,FFe=Object.prototype.toString;function DB(t){if(!(this instanceof DB))return new DB(t);this.options=Is.assign({chunkSize:16384,windowBits:0,to:""},t||{});var e=this.options;e.raw&&e.windowBits>=0&&e.windowBits<16&&(e.windowBits=-e.windowBits,e.windowBits===0&&(e.windowBits=-15)),!(e.windowBits>=0&&e.windowBits<16)||t&&t.windowBits||(e.windowBits+=32),e.windowBits>15&&e.windowBits<48&&(15&e.windowBits||(e.windowBits|=15)),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new KBe,this.strm.avail_out=0;var i=I6.inflateInit2(this.strm,e.windowBits);if(i!==dg.Z_OK)throw new Error(lQ[i]);this.header=new CFt,I6.inflateGetHeader(this.strm,this.header)}function Hhe(t,e){var i=new DB(e);if(i.push(t,!0),i.err)throw i.msg;return i.result}function _Ft(t,e){return(e=e||{}).raw=!0,Hhe(t,e)}DB.prototype.push=function(t,e){var i,r,o,l,d,h,p=this.strm,g=this.options.chunkSize,f=this.options.dictionary,y=!1;if(this.ended)return!1;r=e===~~e?e:e===!0?dg.Z_FINISH:dg.Z_NO_FLUSH,typeof t=="string"?p.input=RB.binstring2buf(t):FFe.call(t)==="[object ArrayBuffer]"?p.input=new Uint8Array(t):p.input=t,p.next_in=0,p.avail_in=p.input.length;do{if(p.avail_out===0&&(p.output=new Is.Buf8(g),p.next_out=0,p.avail_out=g),(i=I6.inflate(p,dg.Z_NO_FLUSH))===dg.Z_NEED_DICT&&f&&(h=typeof f=="string"?RB.string2buf(f):FFe.call(f)==="[object ArrayBuffer]"?new Uint8Array(f):f,i=I6.inflateSetDictionary(this.strm,h)),i===dg.Z_BUF_ERROR&&y===!0&&(i=dg.Z_OK,y=!1),i!==dg.Z_STREAM_END&&i!==dg.Z_OK)return this.onEnd(i),this.ended=!0,!1;p.next_out&&(p.avail_out!==0&&i!==dg.Z_STREAM_END&&(p.avail_in!==0||r!==dg.Z_FINISH&&r!==dg.Z_SYNC_FLUSH)||(this.options.to==="string"?(o=RB.utf8border(p.output,p.next_out),l=p.next_out-o,d=RB.buf2string(p.output,o),p.next_out=l,p.avail_out=g-l,l&&Is.arraySet(p.output,p.output,o,l,0),this.onData(d)):this.onData(Is.shrinkBuf(p.output,p.next_out)))),p.avail_in===0&&p.avail_out===0&&(y=!0)}while((p.avail_in>0||p.avail_out===0)&&i!==dg.Z_STREAM_END);return i===dg.Z_STREAM_END&&(r=dg.Z_FINISH),r===dg.Z_FINISH?(i=I6.inflateEnd(this.strm),this.onEnd(i),this.ended=!0,i===dg.Z_OK):r!==dg.Z_SYNC_FLUSH||(this.onEnd(dg.Z_OK),p.avail_out=0,!0)},DB.prototype.onData=function(t){this.chunks.push(t)},DB.prototype.onEnd=function(t){t===dg.Z_OK&&(this.options.to==="string"?this.result=this.chunks.join(""):this.result=Is.flattenChunks(this.chunks)),this.chunks=[],this.err=t,this.msg=this.strm.msg};var EFt={Inflate:DB,inflate:Hhe,inflateRaw:_Ft,ungzip:Hhe},UFe={};(0,Is.assign)(UFe,XBt,EFt,dg);var w6=UFe;function ug(){let t,e,i=!0;return{isPending:()=>i,promise:new Promise((r,o)=>{t=r,e=o}),resolve:r=>{i&&(t(r),i=!1)},reject:r=>{i&&(e(r),i=!1)},dispose:()=>{i&&(e("disposed"),i=!1)}}}function k6(t){return new Promise(e=>zFe(e,t))}function zFe(t,e){return globalThis.setTimeout(t,e)}function VFe(t){globalThis.clearTimeout(t)}function cP(t,e){const i=ug();let r;try{r=t()}catch(l){return Promise.reject(i.reject(l))}if(e<0)return r.finally(()=>{i.resolve(r)}),i.promise;const o=zFe(()=>{i.isPending()&&i.reject(new Oe({defaultError:we.INTERNAL.OPERATION_TIMEDOUT}))},e);return r.catch(l=>{VFe(o),i.isPending()&&i.reject(l)}).finally(()=>{VFe(o),i.isPending()&&i.resolve(r)}),i.promise}function AFt(t,e){var i=t.toString(),r=e.toString();return i>r?1:i<r?-1:0}var IFt=AFt;function wFt(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function $Fe(t,e){for(var i=0;i<e.length;i++){var r=e[i];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}function HFe(t,e,i){return e&&$Fe(t.prototype,e),i&&$Fe(t,i),t}function kFt(t,e,i){return e in t?Object.defineProperty(t,e,{value:i,enumerable:!0,configurable:!0,writable:!0}):t[e]=i,t}var RFt=function(){function t(){var e=(arguments.length>0&&arguments[0]!==void 0?arguments[0]:{}).comparator,i=e===void 0?IFt:e;wFt(this,t),kFt(this,"comparator",void 0),this.comparator=i}return HFe(t,null,[{key:"from",value:function(i,r){throw new Error("not implemented")}}]),HFe(t,[{key:"clear",value:function(){throw new Error("not implemented")}},{key:"toArray",value:function(){throw new Error("not implemented")}},{key:"push",value:function(i){throw new Error("not implemented")}},{key:"enqueue",value:function(i){return this.push(i)}},{key:"top",value:function(){throw new Error("not implemented")}},{key:"peek",value:function(){return this.top()}},{key:"pop",value:function(){throw new Error("not implemented")}},{key:"dequeue",value:function(){return this.pop()}},{key:"merge",value:function(i){throw new Error("not implemented")}},{key:"isEmpty",value:function(){throw new Error("not implemented")}},{key:"length",get:function(){throw new Error("not implemented")}}]),t}();function jhe(t){return jhe=typeof Symbol=="function"&&typeof Symbol.iterator=="symbol"?function(i){return typeof i}:function(i){return i&&typeof Symbol=="function"&&i.constructor===Symbol&&i!==Symbol.prototype?"symbol":typeof i},jhe(t)}function MFt(t){return LFt(t)||DFt(t)||PFt()}function PFt(){throw new TypeError("Invalid attempt to spread non-iterable instance")}function DFt(t){if(Symbol.iterator in Object(t)||Object.prototype.toString.call(t)==="[object Arguments]")return Array.from(t)}function LFt(t){if(Array.isArray(t)){for(var e=0,i=new Array(t.length);e<t.length;e++)i[e]=t[e];return i}}function OFt(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function jFe(t,e){for(var i=0;i<e.length;i++){var r=e[i];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}function NFt(t,e,i){return e&&jFe(t.prototype,e),i&&jFe(t,i),t}function xFt(t,e){return!e||jhe(e)!=="object"&&typeof e!="function"?GFe(t):e}function Ghe(t){return Ghe=Object.setPrototypeOf?Object.getPrototypeOf:function(i){return i.__proto__||Object.getPrototypeOf(i)},Ghe(t)}function GFe(t){if(t===void 0)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function BFt(t,e){if(typeof e!="function"&&e!==null)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&qhe(t,e)}function qhe(t,e){return qhe=Object.setPrototypeOf||function(r,o){return r.__proto__=o,r},qhe(t,e)}function FFt(t,e,i){return e in t?Object.defineProperty(t,e,{value:i,enumerable:!0,configurable:!0,writable:!0}):t[e]=i,t}function UFt(t,e,i){var r=2*e,o=2*e+1,l=e;return r<t.length&&i(t[l],t[r])<0&&(l=r),o<t.length&&i(t[l],t[o])<0&&(l=o),l}function Whe(t,e,i){var r=UFt(t,e,i);if(r!==e){var o=t[e];t[e]=t[r],t[r]=o,Whe(t,r,i)}}function qFe(t){for(var e=Math.floor(t.collection.length/2)-1;e>=0;--e)Whe(t.collection,e,t.comparator)}var vT,vi,Je,OE,hg,ts,vo,zFt=function(){function t(){var e,i;OFt(this,t);for(var r=arguments.length,o=new Array(r),l=0;l<r;l++)o[l]=arguments[l];return FFt(GFe(i=xFt(this,(e=Ghe(t)).call.apply(e,[this].concat(o)))),"collection",[]),i}return BFt(t,RFt),NFt(t,[{key:"clear",value:function(){this.collection.length=0}},{key:"toArray",value:function(){return MFt(this.collection).sort(this.comparator)}},{key:"top",value:function(){if(this.length===0)throw new Error("invalid operation: top() called for empty BinaryHeap");return this.collection[0]}},{key:"pop",value:function(){if(this.length===0)throw new Error("invalid operation: pop() called for empty BinaryHeap");var i=this.collection[0];return this.collection.length>1?(this.collection[0]=this.collection.pop(),Whe(this.collection,0,this.comparator)):this.collection.pop(),i}},{key:"push",value:function(i){this.collection.push(i);for(var r=this.collection,o=r.length-1,l=Math.floor(o/2);o>0&&this.comparator(r[l],r[o])<0;o=l,l=Math.floor(l/2)){var d=r[o];r[o]=r[l],r[l]=d}}},{key:"merge",value:function(i){this.collection=i instanceof t?this.collection.concat(i.collection):this.collection.concat(i.toArray()),qFe(this),i.clear()}},{key:"isEmpty",value:function(){return!this.collection.length}},{key:"length",get:function(){return this.collection.length}}],[{key:"from",value:function(i){var r=new t(arguments.length>1&&arguments[1]!==void 0?arguments[1]:{});return r.collection=Array.from(i),qFe(r),r}}]),t}(),VFt=zFt;class $Ft{constructor(e,i){this._tenantId=e,this.listeners=[],this._logger=i.createChild(`TelemetryLogger[${e}]`);const r=this._tenantId;i.log(`Notification Manager Notification Manager logger initialized for tenant ${r}`),this._discardedEventsBufferPQ=new VFt({comparator:(o,l)=>l.latency-o.latency})}addNotificationListener(e){this.listeners.find(i=>i===e)||this.listeners.push(e)}removeNotificationListener(e){this.listeners=this.listeners.filter(i=>i!==e)}eventsSent(e){const i=JSON.stringify(e);this._logger.log(`Notification Manager sent telemetry events ${i}`),this.listeners.forEach(r=>r.eventsSent&&r.eventsSent(e))}eventsDiscarded(e,i){this._logger.log(`Notification Manager discarded telemetry events ${JSON.stringify(e)}, reason ${i} adding to retry buffer`),e.forEach(o=>{o.latency=o.latency||Uj.Normal;const l=o;(l.sendAttempt||0)<=wt().telemetry.discardedEventsMaxRetries?this._discardedEventsBufferPQ.push(l):this._logger.log(`Notification Manager dropping event due to too many retries ${JSON.stringify(o)}`)});const r=wt().telemetry.discardedEventsBufferMaxLength;for(;this._discardedEventsBufferPQ.length>r;)this._logger.log(` dropping event from retry buffer ${this._discardedEventsBufferPQ.dequeue()} due to overflow`);this.listeners.forEach(o=>o.eventsDiscarded&&o.eventsDiscarded(e,i))}getDiscardedEvents(){const e=[],i=this._discardedEventsBufferPQ.length;for(let r=0;r<i;r++)e.push(this._discardedEventsBufferPQ.dequeue());return e}}class ib{constructor(e,i,r,o){this._sentEventsMap=new Map,this._telemetryLoggers=new Map,this._eventsBufferMap=new Map,this._initialized=!1,this.sdkDiagnosticInformation="",this._telemetryRateLimit=new Map,this._mediaEventsReportedForTheCall={},this._logger=e.createChild("TelemetryLogManager"),this.sdkDiagnosticInformation=i,this._sdkInternaVersion=E3(),this._acsProxy=r,this._acsCustomRelayManager=o,wt().telemetry.limit.rates.forEach(l=>{this._telemetryRateLimit.set(l.eventName,{windowStartTime:Date.now(),eventCount:0})})}getSentEventsMap(){return this._sentEventsMap}getTelemetryLoggers(){return this._telemetryLoggers}getEventsBufferMap(){return this._eventsBufferMap}isInitialized(){return this._initialized}getCloudType(){return this._caConfigBag?.cloudType}getAcsResourceId(){return this._caConfigBag?.acsResourceId}getClientId(){return this._caConfigBag?.clientId}initialize(e){if(!e.cloudType)throw this._logger.error("Failed to initialize telemetry loggers, invalid cloud type provided."),new Oe({defaultError:we.INTERNAL.TELEMETRY_FAILED_TO_INITIALIZE_INVALID_CLOUD_TYPE});if(this._initialized)throw this._logger.error("Failed to initialize telemetry loggers, telemetry log manager is already initialized."),new Oe({defaultError:we.INTERNAL.TELEMETRY_FAILED_TO_INITIALIZE_ALREADY_INITIALIZED});this._telemetryLoggers.forEach((i,r)=>{try{i.initialize(e),this._logger.log(`Initialized and flushed buffered telemetry logger for ${r}`)}catch{this._logger.warn(`Failed to initialize and flush buffered telemetry logger for ${r}`),this._telemetryLoggers.delete(r)}}),this._initialized=!0,this._caConfigBag=e,this._logger.log(`Telemetry log manager has been initialized for Call Client: ${this._caConfigBag.clientId}`)}clearTelemetryLoggers(){const e=this._telemetryLoggers.size;return this._telemetryLoggers=new Map,this._caConfigBag=void 0,this._initialized=!1,e}getMediaEventReportedPromise(e){if(!this._mediaEventsReportedForTheCall[e]){const i=ug();i.promise.catch(nh),this._mediaEventsReportedForTheCall[e]=i}return this._mediaEventsReportedForTheCall[e].promise}_reportMediaEventForTheCall(e){if(this._mediaEventsReportedForTheCall[e])this._mediaEventsReportedForTheCall[e].resolve();else{const i=ug();i.promise.catch(nh),i.resolve(),this._mediaEventsReportedForTheCall[e]=i}}_getEventDataWithoutPii(e){const i={};if(e.properties)for(const r of Object.keys(e.properties)){const o=e.properties[r];i[r]={value:o?.value??o,kind:o?.piiKind??0}}return i}sendEvent(e,i,r){try{const o=this._sentEventsMap.get(e.properties?.correlationId),l=o?.get(r)??0;if(r!==void 0&&l>0||r&&r!=="attempt"&&(o?.get("attempt")??0)===0)return;if(this._logger.debug(`sending event=${e.name}`),this.checkIfEventIsBlocked(e)||this.shouldLimitSendingTelemetry(e.name)||this.isRateLimitExceeded(e.name))return void this._logger.debug(`event=${e.name} is blocked`);if(this.checkIfEventPropertiesBlocked(e))return void this._logger.debug(`event=${e.name} properties are blocked`);const d={name:e.name,data:e.properties};d?.name in bQ&&(d.data=this._getEventDataWithoutPii(e)),d.data===void 0&&(d.data={}),d?.name===bQ.mdsc_webrtc_session&&this._reportMediaEventForTheCall(d?.data?.CorrelationId),typeof e.priority!==void 0?d.latency=e.priority:d.latency=Uj.Normal;const h=wt().telemetryEvents.eventNameToPriority.eventName.indexOf(e.name);h!==-1&&(d.latency=wt().telemetryEvents.eventNameToPriority.priority[h]),d.data.sdkVersion=this._sdkInternaVersion,d.data.platformId=T3();const p=`${T3()}/${this._sdkInternaVersion}`;d.data.uiVersion=p,d.data.ui_version=p,d.data.Platform_Uiversion=p,d.data.userAgent=`${this.sdkDiagnosticInformation} ${navigator.userAgent}`,d.data.clientTimestamp=+new Date,d.data.customProxyAndRelayUsage=this.getCustomProxyAndRelayTag();const g=e.tenant;let f=this._eventsBufferMap.get(g);f||(f=this._eventsBufferMap.set(g,[]).get(g));let y=this._telemetryLoggers.get(g);if(y||(y=new HFt(g,this._logger,f,this._acsProxy),this._telemetryLoggers.set(g,y),this._logger.log(`Created telemetry logger for ${g}`)),this._initialized){if(!y.isInitialized())try{y.initialize(this._caConfigBag),this._logger.log(`Created and initialized telemetry logger for ${g}`)}catch{throw this._telemetryLoggers.delete(g),f?.push(d),this._logger.error(`Failed to create and initialize telemetry logger for ${g}`),new Oe({defaultError:we.INTERNAL.TELEMETRY_FAILED_TO_INITIALIZE,defaultErrorMessageArgs:[g]})}i&&y.getAppInsightsCore()?.addNotificationListener(i),y.sendEvent(d);const T=e.properties?.correlationId;if(T!==void 0&&r!==void 0){const C=this._sentEventsMap.get(T)??new Map;C.set(r,(C.get(r)??0)+1),this._sentEventsMap.set(T,C)}}else f?.push(d)}catch{this._logger.warn(`Failed to send event ${e?.name}`)}}deleteEventMapByCorrelationId(e){this._sentEventsMap.delete(e)}async flushAllEvents(e){if(this._logger.debug(`flushing events: ${this._telemetryLoggers.size}`),wt().telemetry.telemetryFlushTimeout!==-1){const i=(o,l)=>{try{const d=ug();d.promise.catch(nh);const h=cP(async()=>(l===gO&&await this.getMediaEventReportedPromise(e),d.promise),wt().telemetry.telemetryFlushTimeout);return o.flushEvents(()=>{this._logger.debug("events flushed"),d.resolve()}),h.then(nh)}catch{throw new Oe({defaultError:we.INTERNAL.TELEMETRY_FAILED_TO_FLUSH})}},r=[];return this._telemetryLoggers.forEach((o,l)=>{r.push(i(o,l).catch(()=>{this._logger.warn("Failed to flush telemetry")}))}),Promise.all(r)}this._telemetryLoggers.forEach(i=>{try{i.flushEvents()}catch{this._logger.warn("Failed to flush telemetry")}})}checkIfEventIsBlocked(e){const i=e.name,r=e.properties?.kindOfEvent,o=wt().telemetry.blockedEvents,l=wt().telemetry.blockedKindOfEvents;return o.includes(i)||l.find(d=>d.name==i&&d.kindOfEvents.includes(r))!==void 0}checkIfEventPropertiesBlocked(e){try{const{name:i,properties:r}=e;return wt().telemetry.blockedEventsByProperty.some(({name:o,properties:l})=>o===i&&l?.find(d=>r?.[Object.keys(d)[0]]===d[Object.keys(d)[0]]))}catch(i){return this._logger.debug(`Failed to check if event properties are blocked: ${i}`),!1}}shouldLimitSendingTelemetry(e){return wt().telemetry.limit.outSideCall.enabled&&(wt().telemetry.limit.outSideCall.includedEvents.length===0||wt().telemetry.limit.outSideCall.includedEvents.includes(e))&&!wt().telemetry.limit.outSideCall.excludedEvents.includes(e)&&ib.callEndTimestamp!==Number.MAX_SAFE_INTEGER&&ib.callEndTimestamp+wt().telemetry.limit.outSideCall.deltaTimeInMs-Date.now()<0}isRateLimitExceeded(e){const i=wt().telemetry.limit.rates.find(o=>o.eventName===e);if(i===void 0)return!1;let r=this._telemetryRateLimit.get(e);if(r||(this._telemetryRateLimit.set(e,{windowStartTime:Date.now(),eventCount:0}),r=this._telemetryRateLimit.get(e)),r){const o=Date.now();if(o-r.windowStartTime>i.windowSizeInMs&&(r.windowStartTime=o,r.eventCount=0),r.eventCount++,r.eventCount>i.maxEventPerWindow)return this._logger.info(`Telemetry event ${e} is rate limited`),!0}return!1}getCustomProxyAndRelayTag(){const e=this._acsProxy?.proxyInUse??!1,i=this._acsCustomRelayManager?.hasRelayConfig??!1;return e&&i?aP.usedProxyAndNonMsftTurn:e?aP.onlyUsedProxy:i?aP.onlyUsedNonMsftTurn:aP.noCustomProxyAndTurnUsed}}ib.telemetryPayloadBytesOriginal=0,ib.telemetryPayloadBytesCompressed=0,ib.callEndTimestamp=0;class HFt{constructor(e,i,r,o){this._tenantId=e,this._eventsBuffer=r,this._initialized=!1,this._networkOnline=!0,this._telemetryRetryIntervalRunning=!1,this._logger=i.createChild(`TelemetryLogger[${e}]`),this._acsProxy=o,window.addEventListener("online",l=>{this._networkOnline=l.detail,this._networkOnline&&this._initialized&&!this._telemetryRetryIntervalRunning&&(this._logger.log("browser network back online starting telemetry send retry"),this.scheduleDiscardedTelemetryRetry())})}initialize(e){if(this._initialized)this._logger.warn(`Telemetry logger for tenant: ${this._tenantId}, already initialized`);else try{const i=new hNt;this._appInsightsCore=new oDt,this._postChannel=new n1t;const r={instrumentationKey:this._tenantId,extensions:[this._postChannel,i],disableCookiesUsage:!0},o={populateBrowserInfo:!0,populateOperatingSystemInfo:!0};r.extensionConfig===void 0&&(r.extensionConfig={}),r.extensionConfig[i.identifier]=o;const l={overrideEndpointUrl:this.getAriaCollectorUrl(e),payloadPreprocessor:wt().telemetry.gzipTelemetryPayload?(d,h)=>{this.gzipPayload(d,h)}:void 0};if(r.extensionConfig[this._postChannel.identifier]=l,Object.keys(wt().calling?.eudb?.acsCompliantEvents).length>0&&(Khe={...Khe,...wt().calling.eudb.acsCompliantEvents}),wt().telemetry.localStorageEnable){const d=new cOt;r.extensions?.push(d);const h={storageKey:"WebSdkTelemetry"};r.extensionConfig[d.identifier]=h}this._NotificationManager=new $Ft(this._tenantId,this._logger),this._appInsightsCore.initialize(r,[],void 0,this._NotificationManager),this._caConfigBag=e,this.scheduleDiscardedTelemetryRetry(),this._initialized=!0,this._eventsBuffer.forEach(d=>{this.sendEvent(d)}),this._eventsBuffer.splice(0,this._eventsBuffer.length)}catch{throw this._logger.error(`Failed to initialize telemetry logger for tenant: ${this._tenantId}`),new Oe({defaultError:we.INTERNAL.TELEMETRY_LOGGER_INIT_FAIL})}}getCloudType(){return this._caConfigBag?.cloudType}getAcsResourceId(){return this._caConfigBag?.acsResourceId}getClientId(){return this._caConfigBag?.clientId}isInitialized(){return this._initialized}getAppInsightsCore(){return this._appInsightsCore}sendEvent(e){this._initialized&&(e?.name in Khe&&this.appendEudbComplianceRegionToEvent(e),e?.data&&(e.data.clientId=this._caConfigBag?.clientId||"",e?.name?.indexOf("mdsc_webrtc")===0?e.data.metrics_AcsResourceId=this._caConfigBag?.acsResourceId||"":e.data.AcsResourceId=this._caConfigBag?.acsResourceId||"",e.data.cloudType=this._caConfigBag?.cloudType||"",e.data.identityType=this._caConfigBag?.identityType||""),this.sendAppInsightsCoreEvent(e))}scheduleDiscardedTelemetryRetry(){const e=wt().telemetry.discardedTelemetryRetryTimeout,i=setInterval(async()=>{this._networkOnline?(this._NotificationManager?.getDiscardedEvents().forEach(r=>{this.sendEvent(r)}),this._telemetryRetryIntervalRunning=!0):(this._logger.log("browser lost network access stopping telemetry send retry"),clearInterval(i),this._telemetryRetryIntervalRunning=!1)},e)}sendAppInsightsCoreEvent(e){this._appInsightsCore?.track(e)}flushEvents(e){if(this._initialized&&this._postChannel){const i=wt().telemetry.asyncTelemetryFlush;this._postChannel.flush(i,e)}}getAriaCollectorUrl(e){const i=u6(e.identityType,e.region);let r;if(e.identityType===gT.Enterprise)r=i?ck.EnterpriseEUDB:ck.Enterprise;else switch(e.cloudType){case pl.Public:r=i?ck.PublicEUDB:ck.Public;break;case pl.GccHigh:r=ck.GccHigh;break;case pl.Dod:r=ck.Dod;break;case pl.AirGap08:r=ck.AirGap08;break;case pl.AirGap09:r=ck.AirGap09;break;default:r=ck.Public}return this._acsProxy?this._acsProxy.proxyfyUrl(r):r}gzipPayload(e,i){try{ib.telemetryPayloadBytesOriginal+=rBe(e.data,this._logger),e.data=w6.gzip(e.data),e.urlString+="&content-encoding=gzip",ib.telemetryPayloadBytesCompressed+=rBe(e.data,this._logger)}catch(r){this._logger.warn("Failed to gzip with pako: ",r)}i(e)}getRegion(e){if(this._caConfigBag&&uBe(this._caConfigBag.identityType))switch(e){case"emea":case"de":return dk.EMEA;case"apac":return dk.APAC;case"noam":case"amer":return dk.NOAM;default:return this._logger.log(`Unable to map region \`${e}\`, to EudbTenantRegion`),dk.UNKNOWN}return e&&Pxe.includes(e)?dk.EMEA:e&&Dxe.includes(e)?dk.APAC:e&&Lxe.includes(e)?dk.NOAM:(this._logger.log(`Unable to map region \`${e}\`, to EudbTenantRegion`),dk.UNKNOWN)}appendEudbComplianceRegionToEvent(e){const i=this.getTenantComplianceRegion(),r=this.getRegion(this._caConfigBag?.region);if(e.data){const o={};o[jFt]=i,o[qFt]=r,e.data[GFt]=o}}getTenantComplianceRegion(){return this._caConfigBag&&u6(this._caConfigBag.identityType,this._caConfigBag.region)?jY.EU:jY.RoW}}(function(t){t.remote_view="remote_view",t.remote_stream="remote_stream",t.network_quality="network_quality",t.video_device_issue="video_device_issue",t.other_diagnostic="other_diagnostic",t.logger_event="logger_event",t.number_of_participants="number_of_participants",t.media_metrics_device_events="media_metrics_device_events",t.sdk_active_in_another_tab="sdk_active_in_another_tab",t.network_changed="network_changed",t.video_max_capabilities="video_max_capabilities"})(vT||(vT={})),function(t){t.acs_calling_call_attempt="acs_calling_call_attempt",t.acs_calling_call_connected="acs_calling_call_connected",t.acs_calling_call_failed="acs_calling_call_failed",t.acs_calling_call_accept_attempt="acs_calling_call_accept_attempt",t.acs_calling_call_accept_connected="acs_calling_call_accept_connected",t.acs_calling_call_accept_failed="acs_calling_call_accept_failed",t.acs_calling_call_reject_attempt="acs_calling_call_reject_attempt",t.acs_calling_call_reject_success="acs_calling_call_reject_success",t.acs_calling_call_reject_failed="acs_calling_call_reject_failed",t.acs_calling_call_hangup_attempt="acs_calling_call_hangup_attempt",t.acs_calling_call_hangup_success="acs_calling_call_hangup_success",t.acs_calling_call_hangup_failure="acs_calling_call_hangup_failure",t.acs_calling_call_progress="acs_calling_call_progress",t.acs_calling_stack_init="acs_calling_stack_init",t.acs_calling_get_device_manager="acs_calling_get_device_manager",t.acs_calling_config_fetched_attempt="acs_calling_config_fetched_attempt",t.acs_calling_config_fetched_success="acs_calling_config_fetched_success",t.acs_calling_config_fetched_failure="acs_calling_config_fetched_failure",t.acs_calling_signaling_init="acs_calling_signaling_init",t.acs_calling_call_agent="acs_calling_call_agent",t.acs_calling_call_agent_init_attempt="acs_calling_call_agent_init_attempt",t.acs_calling_call_agent_init_success="acs_calling_call_agent_init_success",t.acs_calling_call_agent_init_failure="acs_calling_call_agent_init_failure",t.acs_calling_create_view_attempt="acs_calling_create_view_attempt",t.acs_calling_create_view_success="acs_calling_create_view_success",t.acs_calling_create_view_failure="acs_calling_create_view_failure",t.acs_calling_dispose_view_attempt="acs_calling_dispose_view_attempt",t.acs_calling_dispose_view_success="acs_calling_dispose_view_success",t.acs_calling_dispose_view_failure="acs_calling_dispose_view_failure",t.acs_calling_start_video_attempt="acs_calling_start_video_attempt",t.acs_calling_start_video_success="acs_calling_start_video_success",t.acs_calling_start_video_failure="acs_calling_start_video_failure",t.acs_calling_stop_video_on_ufd_attempt="acs_calling_stop_video_on_ufd_attempt",t.acs_calling_stop_video_attempt="acs_calling_stop_video_attempt",t.acs_calling_stop_video_success="acs_calling_stop_video_success",t.acs_calling_stop_video_failure="acs_calling_stop_video_failure",t.acs_calling_call_hold_and_resume="acs_calling_call_hold_and_resume",t.acs_calling_start_screen_share="acs_calling_start_screen_share",t.acs_calling_stop_screen_share="acs_calling_stop_screen_share",t.acs_calling_audio_stream_volume="acs_calling_audio_stream_volume",t.acs_calling_call_stats="acs_calling_call_stats",t.acs_calling_call_stats_and_ufds="acs_calling_call_stats_and_ufds",t.acs_calling_participant_added_or_removed="acs_calling_participant_added_or_removed",t.acs_calling_adp_attempt="acs_calling_adp_attempt",t.acs_calling_adp_success="acs_calling_adp_success",t.acs_calling_adp_failure="acs_calling_adp_failure",t.acs_calling_client_operations="acs_calling_client_operations",t.acs_calling_device_permission_changed="acs_calling_device_permission_changed",t.acs_calling_local_audio_source_changed="acs_calling_local_audio_source_changed",t.acs_calling_start_audio_stream_track="acs_calling_start_audio_stream_track",t.acs_calling_stop_audio_stream_track="acs_calling_stop_audio_stream_track",t.acs_calling_get_remote_audio_stream_track="acs_calling_get_remote_audio_stream_track",t.acs_calling_get_raw_device_media_stream="acs_calling_get_raw_device_media_stream",t.acs_calling_media_stream="acs_calling_media_stream",t.acs_calling_page_hidden="acs_calling_page_hidden",t.acs_calling_orientation_changed="acs_calling_orientation_changed",t.acs_calling_token_expiration_changed="acs_calling_token_expiration_changed",t.acs_calling_token_expiration_changed_failure="acs_calling_token_expiration_changed_failure",t.acs_calling_token_has_no_data_location="acs_calling_token_has_no_data_location",t.acs_calling_mute_on_ufd_attempt="acs_calling_mute_on_ufd_attempt",t.acs_calling_mute_attempt="acs_calling_mute_attempt",t.acs_calling_mute_success="acs_calling_mute_success",t.acs_calling_mute_failure="acs_calling_mute_failure",t.acs_calling_unmute_attempt="acs_calling_unmute_attempt",t.acs_calling_unmute_success="acs_calling_unmute_success",t.acs_calling_unmute_failure="acs_calling_unmute_failure",t.acs_calling_start_audio_attempt="acs_calling_start_audio_attempt",t.acs_calling_start_audio_success="acs_calling_start_audio_success",t.acs_calling_start_audio_failure="acs_calling_start_audio_failure",t.acs_calling_unmute_speaker_attempt="acs_calling_unmute_speaker_attempt",t.acs_calling_unmute_speaker_success="acs_calling_unmute_speaker_success",t.acs_calling_unmute_speaker_failure="acs_calling_unmute_speaker_failure",t.acs_calling_stop_audio_attempt="acs_calling_stop_audio_attempt",t.acs_calling_stop_audio_success="acs_calling_stop_audio_success",t.acs_calling_stop_audio_failure="acs_calling_stop_audio_failure",t.acs_calling_prevent_stop_audio="acs_calling_prevent_stop_audio",t.acs_calling_captions="acs_calling_captions",t.acs_calling_mid_call_media_stats="acs_calling_mid_call_media_stats",t.acs_calling_mid_call_new_media_stats="acs_calling_mid_call_new_media_stats",t.acs_calling_mid_call_raw_media_stats="acs_calling_mid_call_raw_media_stats",t.acs_calling_datachannel="acs_calling_datachannel",t.acs_calling_datachannel_stats="acs_calling_datachannel_stats",t.acs_calling_unmixed_audio="acs_calling_unmixed_audio",t.acs_calling_livestream_stats="acs_calling_livestream_stats",t.acs_calling_livestream_raw_stats="acs_calling_livestream_raw_stats",t.acs_calling_survey="acs_calling_survey",t.mdsc_call_quality_feedback="mdsc_call_quality_feedback",t.acs_calling_switch_video_source_attempt="acs_calling_switch_video_source_attempt",t.acs_calling_switch_video_source_success="acs_calling_switch_video_source_success",t.acs_calling_switch_video_source_failure="acs_calling_switch_video_source_failure",t.acs_calling_diagnostics_attempt="acs_calling_diagnostics_attempt",t.acs_calling_diagnostics_result="acs_calling_diagnostics_result",t.acs_calling_feature_usage="acs_calling_feature_usage",t.acs_calling_middletier_gateway_fetch_policy="acs_calling_middletier_gateway_fetch_policy",t.acs_calling_middletier_gateway_emergency_content="acs_calling_middletier_gateway_emergency_content",t.acs_calling_middletier_gateway_fetch_user_policies_for_captions="acs_calling_middletier_gateway_fetch_user_policies_for_captions",t.acs_calling_middletier_gateway_api="acs_calling_middletier_gateway_api",t.acs_calling_call_client_init="acs_calling_call_client_init",t.acs_calling_tab_events="acs_calling_tab_events",t.acs_calling_lobby_events="acs_calling_lobby_events",t.acs_calling_handle_push_notification="acs_calling_handle_push_notification"}(vi||(vi={})),function(t){t.attempt="attempt",t.success="success",t.failure="failure",t.getter="getter",t.setter="setter",t.subscribe="subscribe",t.unsubscribe="unsubscribe",t.initialize="initialize",t.event="event"}(Je||(Je={})),function(t){t.lobbyAdmit="lobbyAdmit",t.lobbyAdmitAll="lobbyAdmitAll",t.lobbyReject="lobbyReject"}(OE||(OE={})),function(t){t.MuteMicrophone="MuteMicrophone",t.MuteAllRemoteParticipants="MuteAllRemoteParticipants",t.MuteSpecificParticipant="MuteSpecificParticipant",t.UnmuteMicrophone="UnmuteMicrophone",t.MuteIncomingAudio="MuteIncomingAudio",t.UnmuteIncomingAudio="UnmuteIncomingAudio"}(hg||(hg={})),function(t){t.Expected="expected",t.Unexpected="unexpected",t.Unknown="unknown"}(ts||(ts={})),function(t){t.CaptionsKindChanged="CaptionsKindChanged",t.FirstCaptionReceived="FirstCaptionReceived",t.FirstCaptionParsingError="FirstCaptionParsingError",t.InitializeCaptions="InitializeCaptions",t.LanguageChanged="LanguageChanged",t.SetSpokenLanguage="SetSpokenLanguage",t.SetCaptionLanguage="SetCaptionLanguage",t.SpokenLanguageChanged="SpokenLanguageChanged",t.StartCaptions="StartCaptions",t.StopCaptions="StopCaptions",t.UpdateEndpointMetadata="UpdateEndpointMetadata",t.UpdateIsActive="UpdateIsActive",t.StartDataChannel="StartDataChannel"}(vo||(vo={}));let Khe={...vi,skypecosi_concore_web_csa_conversation_callmodality:"skypecosi_concore_web_csa_conversation_callmodality",skypecosi_concore_web_pluginless_modality_session:"skypecosi_concore_web_pluginless_modality_session",skypecosi_concore_web_pluginless_call_session:"skypecosi_concore_web_pluginless_call_session",skypecosi_concore_web_csa_conversation_httprequest:"skypecosi_concore_web_csa_conversation_httprequest"};const jFt="tenantComplianceRegion",GFt="acsCompliancePayload",qFt="tenantRegion";var bQ,Zc,Ts,Sr,R6,vk,NE;(function(t){t.mdsc_webrtc_session="mdsc_webrtc_session",t.mdsc_webrtc_session_initial="mdsc_webrtc_session_initial"})(bQ||(bQ={})),function(t){t.AudioRaw="AudioRaw",t.VideoRaw="VideoRaw",t.ScreenSharingRaw="ScreenSharingRaw",t.VideoRawOrScreenSharingRaw="VideoRawOrScreenSharingRaw",t.Audio="Audio",t.Video="Video"}(Zc||(Zc={})),function(t){t.Local="Local",t.Remote="Remote"}(Ts||(Ts={})),function(t){t.getMediaStream="getMediaStream",t.setMediaStream="setMediaStream",t.startEffects="startEffects",t.stopEffects="stopEffects",t.effectConfigureUpdate="effectConfigureUpdate",t.isSupported="isSupported",t.subscribe="subscribe",t.fpsWarningThresholdReached="fpsWarningThresholdReached",t.timeForEffectsWarningReached="timeForEffectsWarningReached",t.effectsError="effectsError",t.switchSource="switchSource",t.render="render",t.watermark="watermark"}(Sr||(Sr={})),function(t){t.stun="stun",t.turn="turn",t.turns="turns"}(R6||(R6={})),function(t){t.tcp="tcp",t.tls="tls",t.udp="udp"}(vk||(vk={})),function(t){t.Public_App="Public_App",t.Internal_LargeMeetingVideoRendering="Internal_LargeMeetingVideoRendering",t.Internal_RemoteVideoStreamDisposed="Internal_RemoteVideoStreamDisposed"}(NE||(NE={}));var WFe,B3=typeof Reflect=="object"?Reflect:null,KFe=B3&&typeof B3.apply=="function"?B3.apply:function(e,i,r){return Function.prototype.apply.call(e,i,r)};function WFt(t){console&&console.warn&&console.warn(t)}WFe=B3&&typeof B3.ownKeys=="function"?B3.ownKeys:Object.getOwnPropertySymbols?function(e){return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e))}:function(e){return Object.getOwnPropertyNames(e)};var JFe=Number.isNaN||function(e){return e!=e};function Yd(){Yd.init.call(this)}var $c=Yd,KFt=ZFt;Yd.EventEmitter=Yd,Yd.prototype._events=void 0,Yd.prototype._eventsCount=0,Yd.prototype._maxListeners=void 0;var YFe=10;function TQ(t){if(typeof t!="function")throw new TypeError('The "listener" argument must be of type Function. Received type '+typeof t)}function QFe(t){return t._maxListeners===void 0?Yd.defaultMaxListeners:t._maxListeners}function ZFe(t,e,i,r){var o,l,d;if(TQ(i),(l=t._events)===void 0?(l=t._events=Object.create(null),t._eventsCount=0):(l.newListener!==void 0&&(t.emit("newListener",e,i.listener?i.listener:i),l=t._events),d=l[e]),d===void 0)d=l[e]=i,++t._eventsCount;else if(typeof d=="function"?d=l[e]=r?[i,d]:[d,i]:r?d.unshift(i):d.push(i),(o=QFe(t))>0&&d.length>o&&!d.warned){d.warned=!0;var h=new Error("Possible EventEmitter memory leak detected. "+d.length+" "+String(e)+" listeners added. Use emitter.setMaxListeners() to increase limit");h.name="MaxListenersExceededWarning",h.emitter=t,h.type=e,h.count=d.length,WFt(h)}return t}function JFt(){if(!this.fired)return this.target.removeListener(this.type,this.wrapFn),this.fired=!0,arguments.length===0?this.listener.call(this.target):this.listener.apply(this.target,arguments)}function XFe(t,e,i){var r={fired:!1,wrapFn:void 0,target:t,type:e,listener:i},o=JFt.bind(r);return o.listener=i,r.wrapFn=o,o}function e2e(t,e,i){var r=t._events;if(r===void 0)return[];var o=r[e];return o===void 0?[]:typeof o=="function"?i?[o.listener||o]:[o]:i?QFt(o):i2e(o,o.length)}function t2e(t){var e=this._events;if(e!==void 0){var i=e[t];if(typeof i=="function")return 1;if(i!==void 0)return i.length}return 0}function i2e(t,e){for(var i=new Array(e),r=0;r<e;++r)i[r]=t[r];return i}function YFt(t,e){for(;e+1<t.length;e++)t[e]=t[e+1];t.pop()}function QFt(t){for(var e=new Array(t.length),i=0;i<e.length;++i)e[i]=t[i].listener||t[i];return e}function ZFt(t,e){return new Promise(function(i,r){function o(){l!==void 0&&t.removeListener("error",l),i([].slice.call(arguments))}var l;e!=="error"&&(l=function(h){t.removeListener(e,o),r(h)},t.once("error",l)),t.once(e,o)})}Object.defineProperty(Yd,"defaultMaxListeners",{enumerable:!0,get:function(){return YFe},set:function(t){if(typeof t!="number"||t<0||JFe(t))throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received '+t+".");YFe=t}}),Yd.init=function(){this._events!==void 0&&this._events!==Object.getPrototypeOf(this)._events||(this._events=Object.create(null),this._eventsCount=0),this._maxListeners=this._maxListeners||void 0},Yd.prototype.setMaxListeners=function(e){if(typeof e!="number"||e<0||JFe(e))throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received '+e+".");return this._maxListeners=e,this},Yd.prototype.getMaxListeners=function(){return QFe(this)},Yd.prototype.emit=function(e){for(var i=[],r=1;r<arguments.length;r++)i.push(arguments[r]);var o=e==="error",l=this._events;if(l!==void 0)o=o&&l.error===void 0;else if(!o)return!1;if(o){var d;if(i.length>0&&(d=i[0]),d instanceof Error)throw d;var h=new Error("Unhandled error."+(d?" ("+d.message+")":""));throw h.context=d,h}var p=l[e];if(p===void 0)return!1;if(typeof p=="function")KFe(p,this,i);else{var g=p.length,f=i2e(p,g);for(r=0;r<g;++r)KFe(f[r],this,i)}return!0},Yd.prototype.addListener=function(e,i){return ZFe(this,e,i,!1)},Yd.prototype.on=Yd.prototype.addListener,Yd.prototype.prependListener=function(e,i){return ZFe(this,e,i,!0)},Yd.prototype.once=function(e,i){return TQ(i),this.on(e,XFe(this,e,i)),this},Yd.prototype.prependOnceListener=function(e,i){return TQ(i),this.prependListener(e,XFe(this,e,i)),this},Yd.prototype.removeListener=function(e,i){var r,o,l,d,h;if(TQ(i),(o=this._events)===void 0)return this;if((r=o[e])===void 0)return this;if(r===i||r.listener===i)--this._eventsCount==0?this._events=Object.create(null):(delete o[e],o.removeListener&&this.emit("removeListener",e,r.listener||i));else if(typeof r!="function"){for(l=-1,d=r.length-1;d>=0;d--)if(r[d]===i||r[d].listener===i){h=r[d].listener,l=d;break}if(l<0)return this;l===0?r.shift():YFt(r,l),r.length===1&&(o[e]=r[0]),o.removeListener!==void 0&&this.emit("removeListener",e,h||i)}return this},Yd.prototype.off=Yd.prototype.removeListener,Yd.prototype.removeAllListeners=function(e){var i,r,o;if((r=this._events)===void 0)return this;if(r.removeListener===void 0)return arguments.length===0?(this._events=Object.create(null),this._eventsCount=0):r[e]!==void 0&&(--this._eventsCount==0?this._events=Object.create(null):delete r[e]),this;if(arguments.length===0){var l,d=Object.keys(r);for(o=0;o<d.length;++o)(l=d[o])!=="removeListener"&&this.removeAllListeners(l);return this.removeAllListeners("removeListener"),this._events=Object.create(null),this._eventsCount=0,this}if(typeof(i=r[e])=="function")this.removeListener(e,i);else if(i!==void 0)for(o=i.length-1;o>=0;o--)this.removeListener(e,i[o]);return this},Yd.prototype.listeners=function(e){return e2e(this,e,!0)},Yd.prototype.rawListeners=function(e){return e2e(this,e,!1)},Yd.listenerCount=function(t,e){return typeof t.listenerCount=="function"?t.listenerCount(e):t2e.call(t,e)},Yd.prototype.listenerCount=t2e,Yd.prototype.eventNames=function(){return this._eventsCount>0?WFe(this._events):[]},$c.once=KFt;class XFt{constructor(e){this.disposed=!1,this.callAgent=e.callAgent,this.callClient=e.callClient,this.eventEmitter=new $c.EventEmitter}dispose(){this.disposed||(this.eventEmitter.removeAllListeners(),this.disposed=!0)}}class e2t{constructor(e){this.disposed=!1,this.callClient=e.callClient,this.eventEmitter=new $c.EventEmitter}dispose(){this.disposed||(this.eventEmitter.removeAllListeners(),this.disposed=!0)}}class t2t{constructor(e){this.disposed=!1,this.call=e.call,this.callAgent=e.callAgent,this.callInfo=e.callInfo,this.eventEmitter=new $c.EventEmitter}dispose(){this.disposed||(this.eventEmitter.removeAllListeners(),this.disposed=!0)}}class n2e{constructor(e){this._logger=e,this._queue=Promise.resolve()}add(e){this._queue||(this._queue=Promise.resolve());let i=e;const r=this._queue?.then(i);return r&&(this._queue=r?.catch(o=>{throw o instanceof Oe?(this._logger?.error(`Error from promiseQueue! ${JSON.stringify(o)}`),o):new Error(`Error from promiseQueue! ${JSON.stringify(o)}`)})),r}dispose(){this._queue=null}}const CQ=()=>(t,e,i)=>{const r=i.value;return i.value=function(...o){return this.serialQueue.add(r.bind(this,...o))},i};class i2t{constructor(e){this.disposed=!1,this.streamInstance=e.streamInstance,this.eventEmitter=new $c.EventEmitter,this.serialQueue=new n2e(this.streamInstance.logger)}}class n2t{constructor(e){this.disposed=!1,this.streamInstance=e.streamInstance,this.eventEmitter=new $c.EventEmitter,this.serialQueue=new n2e(this.streamInstance.logger)}}var IO,LB;(function(t){t[t.CallClientFeature=0]="CallClientFeature",t[t.CallAgentFeature=1]="CallAgentFeature",t[t.CallFeature=2]="CallFeature"})(IO||(IO={}));class Bu extends t2t{}class a2t extends XFt{}class Jhe extends e2t{}class a2e extends i2t{}class r2e extends n2t{}(function(t){t.Transfer="Transfer",t.StartCaptions="StartCaptions",t.StopCaptions="StopCaptions",t.SetSpokenLanguage="SetSpokenLanguage",t.SetCaptionLanguage="SetCaptionLanguage",t.getMediaStatsCollector="getMediaStatsCollector",t.disposeAllCollectors="disposeAllCollectors"})(LB||(LB={}));class M6{constructor(e,i,r){this._logger=e,this._featureCtorContext=i,this._featureInitContext=r,this._apiObjInstances=new Map}getApiObjectInstance(e){if(!this._apiObjInstances.has(e)){const i=new e(this._featureCtorContext);return(i instanceof Bu||i instanceof a2t||i instanceof Jhe||i instanceof a2e||i instanceof r2e)&&i.initialize(this._featureInitContext,this._logger),this._apiObjInstances.set(e,i),i}return this._apiObjInstances.get(e)}dispose(){for(const[,e]of this._apiObjInstances)e.dispose()}}const r2t={commandUrl:"",processingModes:{closedCaptions:{state:"Inactive"},realTimeTranscript:{state:"Inactive"}},spokenLanguage:""};var o2e,qy;(function(t){t.Acs="acs",t.Teams="teams",t.Unknown="unknown"})(o2e||(o2e={})),function(t){t.Captions="captions",t.TeamsCaptions="teams_captions"}(qy||(qy={}));class o2t{constructor(e){this._eventEmitter=e,this._dataChannelId=wt().captions.dataChannelId,this._isCaptionsBot=i=>i.id===this._captionsBotMri||i.id===this._captionsLegacyBotMri,this._getBotMetadata=i=>i?.endpoints?.endpointDetails[0]?.endpointMetadata??void 0,this._getBotDataMediaStreamSourceId=i=>{if(i?.endpoints?.endpointDetails[0]?.mediaStreams){let r=i?.endpoints?.endpointDetails[0]?.mediaStreams;if(r.length>0){for(let o in r)if(r[o].type==="data")return r[o].sourceId}}},this._isCaptionsEnabled=i=>i?.processingModes?.closedCaptions?.state==="Active",this._copyBotMetaData=i=>{const r=this._getBotMetadata(i)||r2t;return JSON.parse(JSON.stringify(r))}}dispose(){this._acsMetadata=void 0}}function Qd(t,e={activationEvent:"OnFeatureAccess"}){return{get callApiCtor(){return t},activationOptions:e,isCallFeature:!0}}function s2e(t,e={activationEvent:"OnFeatureAccess"}){return{get callClientApiCtor(){return t},activationOptions:e,isCallClientFeature:!0}}function l2e(t,e={activationEvent:"OnFeatureAccess"}){return{get videoStreamApiCtor(){return t},activationOptions:e,isVideoStreamFeature:!0}}function c2e(t,e={activationEvent:"OnFeatureAccess"}){return{get audioStreamApiCtor(){return t},activationOptions:e,isAudioStreamFeature:!0}}function s2t(t,e,i=100){return Math.round((t/e+Number.EPSILON)*i)/i}function Pc(t,e,i){try{const r={correlationId:t.correlationId||"",callId:t.callId,localParticipantId:t.localParticipantId,featureName:t.featureName,featureType:t.featureType,initializationType:t.initializationType,featureDetails:t.featureDetails,additionalDetails:t.additionalDetails||{},networkInfo:t.networkInfo||[]};e.sendEvent({name:vi.acs_calling_feature_usage,tenant:Wr,properties:r})}catch{i.debug(`Unable to send ${t.featureName} feature usage telemtery`)}}function Yhe(t,e,i){try{const r={featureName:t.featureName,featureType:t.featureType,initializationType:t.initializationType,featureDetails:t.featureDetails};e.sendEvent({name:vi.acs_calling_feature_usage,tenant:Wr,properties:r})}catch{i.debug(`Unable to send ${t.featureName} feature usage telemetry`)}}const l2t={0:"",1:"Success",2:"NoNgcEndpoint",3:"NetworkError",4:"MediaDroppedError",5:"BadRequest",6:"CallEstablishmentTimeout",7:"CallSetupError",8:"NoPermission",9:"Missed",10:"Declined",11:"Busy",12:"Cancelled",13:"Dropped",14:"PstnInsufficientFunds",15:"PstnSkypeoutAccountBlocked",16:"PstnCouldNotConnectToSkypeProxy",17:"PstnBlockedByUs",18:"PstnBlockedRegulatoryIndia",19:"PstnInvalidNumber",20:"PstnNumberForbidden",21:"PstnCallTerminated",22:"PstnNumberUnavailable",23:"PstnEmergencyCallDenied",24:"CallNotFound",25:"LocalError",26:"NotAcceptableHere",27:"CallForwarded",28:"CallForwardedToVoicemail",29:"SkypeTokenError",30:"CallAccepted",31:"LocalHttpStackError",32:"UnknownError",33:"PstnNoSubscriptionCover",34:"SessionNotFound",35:"SessionTimedOut",36:"PstnCreditExpired",37:"PstnCreditExpiredButEnough",38:"RetargetNotSupported",39:"EnterprisePstnInternalError",40:"EnterprisePstnUnavailable",41:"EnterprisePstnForbidden",42:"EnterprisePstnInvalidNumber",43:"EnterprisePstnMiscError",44:"Kicked",45:"NetworkRequestTimeoutError",46:"CallDoesNotExist",47:"MediaSetupFailure",48:"ServiceUnavailable",49:"SignalingError",50:"ConversationEstablishmentFailed",51:"TemporarilyUnavailable",52:"CannotConnectToNetworkError",53:"MediaRelayWhiteListingIssue",54:"NoSignalingFromPeer",55:"DeniedInLobby",56:"TimedOutInLobby",57:"CallFailedConflict",58:"DevicePermissionDenied",59:"ConfParticipantCountLimitReached",60:"ActionNotAllowed",61:"Abandoned",62:"ForbiddenDueToPolicy",63:"InsufficientCapabilitiesForCallee",64:"UserBlocked",65:"AccessDenied",66:"AnonymousJoinDisabledByPolicy",67:"NoLobbyForBroadcastJoin",68:"NotAllowedDueToInformationBarrier",69:"BroadcastLimitReached",70:"TeamParkPolicyDisabled",71:"B2bJoinDisabledByPolicy",72:"LocationBasedRoutingError",73:"ConfLobbyParticipantCountLimitReached",74:"DowngradeToStreamingClient",75:"CallRedirected",76:"CallIsEndToEndEncrypted",77:"Suspended"},d2e=t=>typeof t=="number"&&l2t[t]||"UnknownError",c2t={0:"",1:"AddingFailed",2:"NoResponse",3:"Declined",4:"NotReachable",5:"Blocked",6:"NotFriendOrAuthorized",7:"CallLimitReached",8:"CallNotFound",9:"NetworkError",10:"MediaDroppedError",11:"OtherError",12:"PstnInsufficientFunds",13:"PstnSkypeoutAccountBlocked",14:"PstnCouldNotConnectToSkypeProxy",15:"PstnBlockedByUs",16:"PstnBlockedRegulatoryIndia",17:"PstnInvalidNumber",18:"PstnNumberForbidden",19:"Busy",20:"PstnCallTerminated",21:"PstnNumberUnavailable",22:"PstnEmergencyCallDenied",23:"Cancelled",24:"Dropped",25:"PstnNoSubscriptionCover",26:"PstnCreditExpired",27:"PstnCreditExpiredButEnough",28:"EnterprisePstnInternalError",29:"EnterprisePstnUnavailable",30:"EnterprisePstnForbidden",31:"EnterprisePstnInvalidNumber",32:"EnterprisePstnMiscError",33:"Kicked",34:"NetworkRequestTimeoutError",35:"CallDoesNotExist",36:"MediaSetupFailure",37:"ServiceUnavailable",38:"SignalingError",39:"ConversationEstablishmentFailed",40:"TemporarilyUnavailable",41:"CannotConnectToNetworkError",42:"NoSignalingFromPeer",43:"ParticipantDoesNotExist",44:"DeniedInLobby",45:"TimedOutInLobby",46:"ConfParticipantCountLimitReached",47:"Abandoned",48:"ActionNotAllowed",49:"ForbiddenDueToPolicy",50:"InsufficientCapabilitiesForCallee",51:"AccessDenied",52:"NoPermission",53:"AnonymousJoinDisabledByPolicy",54:"NoLobbyForBroadcastJoin",55:"NotAllowedDueToInformationBarrier",56:"BroadcastLimitReached",57:"B2bJoinDisabledByPolicy",58:"LocationBasedRoutingError",59:"ConfLobbyParticipantCountLimitReached",60:"LobbyUserLeft"},u2e=t=>typeof t=="number"&&c2t[t]||"UnknownError",h2e={0:"None",1:"Incoming Call",2:"Connecting",3:"Connected",4:"LocalHold",5:"RemoteHold",10:"InLobby",9:"EarlyMedia",6:"Disconnecting",7:"Disconnected",8:"Unknown",11:"Unknown",12:"Unknown",13:"Unknown",14:"Unknown",15:"Unknown"},p2e={0:"None",1:"RealTime",2:"Streaming"};function d2t(t){switch(t){case"Num0":return 0;case"Num1":return 1;case"Num2":return 2;case"Num3":return 3;case"Num4":return 4;case"Num5":return 5;case"Num6":return 6;case"Num7":return 7;case"Num8":return 8;case"Num9":return 9;case"Star":return 10;case"Pound":return 11;case"A":return 12;case"B":return 13;case"C":return 14;case"D":return 15;case"Flash":return 16;default:throw new Oe({defaultError:we.CALL.INVALID_DTMF_TONE})}}function F3(t,e){let i=0,r=0,o=qY,l=[];return i=t.tsCall.callEndDiagnosticsInfo&&t.tsCall.callEndDiagnosticsInfo.callControllerCode||0,r=t.tsCall.callEndDiagnosticsInfo&&t.tsCall.callEndDiagnosticsInfo.callControllerSubCode||0,l=GK[i]?.[r]?.resultCategories||t.tsCall.callEndDiagnosticsInfo&&t.tsCall.callEndDiagnosticsInfo.resultCategories||["Success"],o=GK[i]?.[r]?.message||d2e(e||t.tsCall?.terminatedReason||0),t.logger.error(`Call end reason=${o}, code=${i}, subCode=${r}, resultCategories=${l.toString()}`),{callEndReason:{message:o,code:i,subCode:r,resultCategories:l},callingCommunicationError:new Oe({defaultError:{message:o,code:i,subCode:r,resultCategories:l}})}}function U3(t,e,i){let r=0,o=0,l=qY,d=[];if(e?.callEndDiagnosticsInfo)r=e.callEndDiagnosticsInfo&&e.callEndDiagnosticsInfo.callControllerCode||0,o=e.callEndDiagnosticsInfo&&e.callEndDiagnosticsInfo.callControllerSubCode||0,l=GK[r]?.[o]?.message||u2e(i||e.stateReason||0),d=GK[r]?.[o]?.resultCategories||e.callEndDiagnosticsInfo&&e.callEndDiagnosticsInfo.resultCategories||["Success"];else{const h=F3(t,i);r=h.callEndReason.code,o=h.callEndReason.subCode||0,d=h.callEndReason.resultCategories,l=h.callEndReason.message}return t.logger[r===0?"info":"error"](`Participant call end reason=${l}, code=${r}, subCode=${o}, resultCategories=${d.toString()}`),{callEndReason:{message:l,code:r,subCode:o,resultCategories:d},callingCommunicationError:new Oe({defaultError:{message:l,code:r,subCode:o,resultCategories:d}})}}function z3(t,e,i){let r;switch(e?.type?e.type:VC.UnknownFailureForVideoOperation){case VC.DevicesNotFoundError:r=new Oe({defaultError:we.LOCAL_VIDEO_STREAM.DEVICES_NOT_FOUND});break;case VC.MediaStreamRequestError:r=new Oe({defaultError:we.LOCAL_VIDEO_STREAM.MEDIA_STREAM_REQUEST_ERROR});break;case VC.MediaStreamRequestTimedout:r=new Oe({defaultError:we.LOCAL_VIDEO_STREAM.MEDIA_STREAM_REQUEST_TIMEDOUT});break;case VC.PermissionsDeniedBySystem:r=new Oe({defaultError:we.LOCAL_VIDEO_STREAM.PERMISSION_DENIED_BY_SYSTEM});break;case VC.UnsupportedStream:r=new Oe({defaultError:we.LOCAL_VIDEO_STREAM.UNSUPPORTED_STREAM});break;case VC.ConstraintNotSatisfiedError:r=new Oe({defaultError:we.LOCAL_VIDEO_STREAM.CONSTRAINT_NOT_SATISFIED});break;case VC.noDeviceSelected:r=new Oe({defaultError:we.LOCAL_VIDEO_STREAM.NO_DEVICE_SELECTED});break;case VC.SourceUnavailableError:r=new Oe({defaultError:we.LOCAL_VIDEO_STREAM.SOURCE_UNAVAILABLE});break;case VC.PermissionDeniedError:case VC.permissionDeniedError:r=new Oe({defaultError:we.LOCAL_VIDEO_STREAM.PERMISSION_DENIED});break;default:r=new Oe(i?{defaultError:we.CALL.STOP_VIDEO_FAILED}:{defaultError:we.LOCAL_VIDEO_STREAM.UNKNOWN})}return r}function u2t(t,e,i){const r=e?.code===void 0?500:e?._code,o=e?.subCode||e?._subCode||0;return new Oe({defaultError:{message:i+", reason: "+(e?.phrase||e?.message||"unknown error"),code:r,subCode:o,resultCategories:e?.resultCategories||[]}})}function nb(t,e){return new Oe({defaultError:{message:e.message,code:t?.response?.status||e.code,subCode:e.subCode,resultCategories:e.resultCategories},originalError:t})}function h2t(t,e){return new Oe({defaultError:{message:t?.response?.data?.operationFailure?.phrase||e.message,code:t?.response?.data?.operationFailure?.code||e.code,subCode:t?.response?.data?.operationFailure?.subCode||e.subCode,resultCategories:t?.response?.data?.operationFailure?.resultCategories||e.resultCategories},originalError:t})}function an(t){return{communicationServicesError:{message:t.message||"Unknown error",code:t.code===void 0?jL:t.code,subCode:t.subCode||0,resultCategories:t.resultCategories===void 0||t.resultCategories.length===0?["UnexpectedClientError"]:t.resultCategories,originalErrorMessage:t[rj]||""}}}function dP(t){return{callEndReason:{message:t.message,code:t.code===void 0?jL:t.code,subCode:t.subCode||0,resultCategories:t.resultCategories===void 0||t.resultCategories.length===0?["UnexpectedClientError"]:t.resultCategories}}}var _Q=function(t,e,i,r){var o,l=arguments.length,d=l<3?e:r===null?r=Object.getOwnPropertyDescriptor(e,i):r;if(typeof Reflect=="object"&&typeof Reflect.decorate=="function")d=Reflect.decorate(t,e,i,r);else for(var h=t.length-1;h>=0;h--)(o=t[h])&&(d=(l<3?o(d):l>3?o(e,i,d):o(e,i))||d);return l>3&&d&&Object.defineProperty(e,i,d),d},xE=function(t,e){if(typeof Reflect=="object"&&typeof Reflect.metadata=="function")return Reflect.metadata(t,e)};const p2t=Date.UTC(1900,0,1),g2t=3;class m2t extends Bu{constructor(e){super(e),this._impl=new P6(this.eventEmitter)}initialize(e,i){const r=ln();this._impl.initialize(e.tsCall,e.call,e.callAgent,e.callAgent.getHttpRequestHelper(),e.telemetryLogManager,i,this._telemetryStartTime,r),this._logger=i,this._telemetryStartTime=+Date.now(),this._telemetryLogManager=e.telemetryLogManager,this._call=e.call}get name(){return this._sendFeatureUsage("name",Je.getter),this._captionsTelemetryType.toString()}get _captionsTelemetryType(){return this._impl.kind==="TeamsCaptions"?qy.TeamsCaptions:qy.Captions}get captions(){return this._impl.captions}on(e,i){this.eventEmitter.on(e,i)}off(e,i){this.eventEmitter.off(e,i)}dispose(){this._sendFeatureUsage("dispose",Je.attempt),this.disposed?this._sendFeatureUsage("dispose",Je.failure):(this._impl.dispose(),super.dispose(),this._sendFeatureUsage("dispose",Je.success))}_sendFeatureUsage(e,i){Pc({callId:this._call.id,localParticipantId:this._call.tsCall.participantId,featureName:this._captionsTelemetryType,featureType:"Call",initializationType:"OnFeatureAccess",featureDetails:{name:e,step:i}},this._telemetryLogManager,this._logger)}}class g2e{constructor(e,i){this._eventEmitter=i,this._impl=e}async startCaptions(e){await this._impl.startCaptions(e)}async stopCaptions(){await this._impl.stopCaptions()}async setSpokenLanguage(e){await this._impl.setSpokenLanguage(e)}get supportedSpokenLanguages(){return this._impl.supportedSpokenLanguages}get isCaptionsFeatureActive(){return this._impl.isCaptionsFeatureActive}get activeSpokenLanguage(){return this._impl.activeSpokenLanguage}get kind(){return this._impl.kind}}class f2t extends g2e{constructor(e,i){super(e,i)}on(e,i){this._eventEmitter.on(e,i)}off(e,i){this._eventEmitter.off(e,i)}}class v2t extends g2e{constructor(e,i){super(e,i)}get supportedCaptionLanguages(){return this._impl.supportedCaptionLanguages}get activeCaptionLanguage(){return this._impl.activeCaptionLanguage}async setCaptionLanguage(e){await this._impl.setCaptionLanguage(e)}on(e,i){this._eventEmitter.on(e,i)}off(e,i){this._eventEmitter.off(e,i)}}class P6 extends o2t{constructor(e,i,r,o){super(e),this._botParticipantId="",this._isCteUser=!1,this._isCaptionsActive=!1,this._firstTimeActive=!1,this._ecsCaptionsEnabled=!1,this._ecsACSCaptionsEnabled=!1,this._ecsTeamsCaptionsEnabled=!1,this._ecsSpokenLanguagesEnabled=!1,this._ecsSpokenLanguages=[],this._ecsCaptionLanguagesEnabled=!1,this._ecsCaptionLanguages=[],this._ecsAmtPolicyUrlSuffix="",this._ecsCapabilitiesEnabled=!0,this._ecsSetBotMetadataWhenEmptyFixEnabled=!0,this._hasReportedCaptionParseFailure=!1,this._hasReceivedFirstCaption=!1,this._currentLanguage="",this._currentCaptionLanguage="",this._participantSequenceIdMap={},this.capabilityChangeHandler=l=>{l.newValue.startLiveMeetingCaptions&&(this._participantCapability.startLiveMeetingCaptions=this._call.getParticipantCapabilities().startLiveMeetingCaptions,this._logger.log(`participant capabilitity to startLiveMeetingCaptions feature is ${this._participantCapability}`)),l.newValue.startLiveCallingCaptions&&(this._participantCapability.startLiveCallingCaptions=this._call.getParticipantCapabilities().startLiveCallingCaptions,this._logger.log(`participant capabilitity to startLiveCallingCaptions feature is ${this._participantCapability}`)),l.newValue.setCaptionLanguage&&(this._participantCapability.setCaptionLanguage=this._call.getParticipantCapabilities().setCaptionLanguage,this._logger.log(`participant capabilitity to setCaptionLanguage feature is ${this._participantCapability}`))},this._addParticipantPromise=null,this._dataChannelHandler={onStarted:async(l,d)=>{},onStopped:async l=>{},onDataReceived:async(l,d,h)=>{let p;try{p=JSON.parse(d.toString())}catch{try{if(this._textDecoder===void 0)throw new Error("TextDecoder undefined.");p=JSON.parse(this._textDecoder.decode(d))}catch(f){return this._logger.error("Failed to parse Captions result",f),void(this._hasReportedCaptionParseFailure||(this._hasReportedCaptionParseFailure=!0,this._sendCaptionsEvent(vo.FirstCaptionParsingError,Je.failure,"",0,ts.Unexpected,"Could not decode data packet.")))}}if(p){let g=[];p.textTracks&&this._isCaptionInTextTracks(p)?g=p.textTracks:p.recognitionResults&&(g=p.recognitionResults),g.forEach(f=>{try{if(f.source.toLowerCase()!=="mt"&&f.source.toLowerCase()!=="ai")return;const[y,T]=f.id.split("/");let C=parseInt(T,10);if(this._participantSequenceIdMap[f.userId]&&this._botParticipantId==y&&this._participantSequenceIdMap[f.userId]>C)return;this._botParticipantId=y,this._participantSequenceIdMap[f.userId]=C;const E=this._tsCall.participants.find(w=>w.id===f.userId)?.displayName||(this._internalCallAgent.getUserMri()===f.userId?this._internalCallAgent?.displayName:void 0),I={resultType:f.isFinal?"Final":"Partial",captionText:f.text,spokenText:f.originalText??f.text,timestamp:new Date(new Date(f.timestampAudioSent/1e4).getTime()+p2t),speaker:{identifier:Sl(f.userId),displayName:E},spokenLanguage:f.spokenLanguage,captionLanguage:f.trackLanguage};if(this._currentLanguage!=f.spokenLanguage&&(this._currentLanguage=f.spokenLanguage,this._eventEmitter.emit("SpokenLanguageChanged")),!this.isCaptionsFeatureActive||this._mediaStreamSourceId!==h)return;this._hasReceivedFirstCaption||(this._hasReceivedFirstCaption=!0,this._sendCaptionsEvent(vo.FirstCaptionReceived,Je.success,"",0)),this._eventEmitter.emit("CaptionsReceived",I)}catch(y){this._logger.error("Failed to parse Captions result",y),this._hasReportedCaptionParseFailure||(this._hasReportedCaptionParseFailure=!0,this._sendCaptionsEvent(vo.FirstCaptionParsingError,Je.failure,"",0,ts.Unexpected,"Error thrown during incoming caption result mapping."))}})}}},this._isCaptionInTextTracks=l=>{let d=!1;return l.textTracks&&l.textTracks.forEach(h=>{h.source==="Mt"&&(d=!0)}),d},this._handleBotRemoved=l=>{this._acsMetadata&&this._isCaptionsBot(l)&&(this.isCaptionsFeatureActive&&(this._isCaptionsActive=!1,this._eventEmitter.emit("CaptionsActiveChanged")),this._acsMetadata=void 0,this._firstTimeActive=!1)},this._participantCapability={startLiveMeetingCaptions:{isPresent:!0,reason:"Capable"},startLiveCallingCaptions:{isPresent:!0,reason:"Capable"},setCaptionLanguage:{isPresent:!0,reason:"Capable"}},this._telemetryStartTime=Date.now()}get isCaptionsFeatureActive(){return!!this._acsMetadata&&this._isCaptionsEnabled(this._acsMetadata)&&this._isCaptionsActive}get supportedSpokenLanguages(){return this._ecsSpokenLanguages}get supportedCaptionLanguages(){return this._ecsCaptionLanguages}get captions(){return this._captions}get kind(){return this._name===qy.TeamsCaptions?"TeamsCaptions":"Captions"}get activeSpokenLanguage(){return this._currentLanguage}get activeCaptionLanguage(){return this._currentCaptionLanguage}get isTeamsConversationType(){return lxt.indexOf(this._tsCall.conversationType)>-1}get isTeamsUserInCall(){for(let e of this._tsCall.participants)if(Sl(e.id).kind==="microsoftTeamsUser")return!0;return!1}get isTeamsCallKind(){return this._call.kind===GL.TeamsCall}get isTeamsCaptionsBotInCall(){for(let e of this._tsCall.participants)if(this._tsCall.region==="gcc"&&e.id===wt().captions.teams.gccBotMri||this._tsCall.region!=="gcc"&&(e.id===wt().captions.teams.botMri||e.id===wt().captions.teams.legacyBotMri))return!0;return!1}async updateParticipantTranscriptionPrefsMetadata(e,i){let r;for(let l in this._tsCall.endpoints?.endpointDetails)if(this._tsCall.endpoints?.endpointDetails[l].participantId===this._tsCall.participantId){r=this._tsCall.endpoints?.endpointDetails[l];break}const o=r?.endpointMetadata??{transcriptionPrefs:{}};e?o.transcriptionPrefs?.closedCaptions?o.transcriptionPrefs.closedCaptions=e:o.transcriptionPrefs={closedCaptions:e}:o.transcriptionPrefs?.closedCaptions&&delete o.transcriptionPrefs.closedCaptions;try{await this._tsCall.updateEndpointMetadata(JSON.stringify(o))}catch{this._addParticipantPromise=null;const d=new Oe({defaultError:we.FEATURES.CAPTIONS.UPDATE_ENDPOINT_METADATA});throw this._sendCaptionsEvent(vo.UpdateEndpointMetadata,Je.failure,i,this._telemetryStartTime,ts.Unexpected,d.message,d.code,d.subCode,an(d)),this._sendFeatureUsage("updateEndpointMetadata",Je.failure),this._logger.warn(d.message),d}}initialize(e,i,r,o,l,d,h,p){this._logger=d.createChild(()=>`CaptionsFeature::Call(id='${e.callId}', state='${e.state}')`),this._tsCall=e,this._call=i,this._internalCallAgent=r,this._httpRequestHelper=o,this._telemetryLogManager=l,this._telemetryStartTime=h,this._isCteUser=r.isCteUser(),this._ecsCaptionsEnabled=wt().captions.enabled,this._ecsACSCaptionsEnabled=wt().captions.acs.enabled,this._ecsTeamsCaptionsEnabled=wt().captions.teams.enabled,this._ecsSetBotMetadataWhenEmptyFixEnabled=wt().captions.setBotMetadataWhenEmptyFix,this._name=this.isTeamsConversationType||this._isCteUser||this.isTeamsUserInCall||this.isTeamsCaptionsBotInCall||this.isTeamsCallKind?qy.TeamsCaptions:qy.Captions,this.updateCaptionsData(this._name),this._sendCaptionsEvent(vo.InitializeCaptions,Je.initialize,p,this._telemetryStartTime),this._initializationPromise=new Promise((g,f)=>{this._initializeAsync(p).then(y=>g()).catch(y=>f(y))})}async _initializeAsync(e){try{this._textDecoder=new TextDecoder,this._tsCall.on("callStateChanged",()=>{this._tsCall.state===3&&this._name===qy.TeamsCaptions&&this._tsCall.region==="gcc"&&(this._captionsBotMri=wt().captions.teams.gccBotMri)}),this._tsCall.on("participantAdded",async r=>{if(this._captions&&this._captions.kind==="Captions"&&Sl(r.id).kind==="microsoftTeamsUser"){if(this._captionsBotMri)try{await this._tsCall.removeParticipant(this._captionsBotMri),this._acsMetadata&&(this._acsMetadata=void 0)}catch(o){const l=new Oe({defaultError:{message:u2e(o),code:r.callEndDiagnosticsInfo?.callControllerCode||0,subCode:r.callEndDiagnosticsInfo?.callControllerSubCode||0,resultCategories:r.callEndDiagnosticsInfo?.resultCategories||["UnexpectedClientError"]},originalError:o});this._sendCaptionsEvent(vo.CaptionsKindChanged,Je.failure,e,this._telemetryStartTime,ts.Unexpected,l.message,l.code,l.subCode,an(l))}if(this.updateCaptionsData(qy.TeamsCaptions),this._ecsSetBotMetadataWhenEmptyFixEnabled){const o=this._tsCall.participants.find(l=>l.id===this._captionsBotMri);if(o){this._acsMetadata=this._copyBotMetaData(o),this._mediaStreamSourceId=o.getSourceIdForMediaType(3);try{await this._tsCall.startDataChannel(),await this._tsCall.dataChannelAdapter.addHandler(this._dataChannelId,this._dataChannelHandler)}catch{const d=new Oe({defaultError:we.FEATURES.CAPTIONS.ALREADY_ACTIVE});this._sendCaptionsEvent(vo.StartDataChannel,Je.failure,e,this._telemetryStartTime,ts.Expected,d.message,d.code,d.subCode,an(d)),this._sendFeatureUsage("startDataChannel",Je.failure)}}}this._isCaptionsActive&&(this._currentLanguage&&this._ecsSpokenLanguages.includes(this._currentLanguage)?await this._captions.startCaptions({spokenLanguage:this._currentLanguage}):await this._captions.startCaptions()),this._eventEmitter.emit("CaptionsKindChanged"),this._sendCaptionsEvent(vo.CaptionsKindChanged,Je.success,e,this._telemetryStartTime)}}),this._tsCall.on("participantAdded",async r=>{this._isCaptionsBot(r)&&(this._acsMetadata||(this._acsMetadata=this._copyBotMetaData(r),this._mediaStreamSourceId=this._getBotDataMediaStreamSourceId(r),await this._tsCall.startDataChannel(),await this._tsCall.dataChannelAdapter.addHandler(this._dataChannelId,this._dataChannelHandler)))}),this._tsCall.on("participantRemoved",async r=>{this._isCaptionsBot(r)&&this._handleBotRemoved(r)}),this._tsCall.on("participantUpdated",async r=>{this._getBotMetadata(r)&&this._isCaptionsBot(r)&&this._acsMetadata&&(this._acsMetadata=this._copyBotMetaData(r),this._mediaStreamSourceId=this._getBotDataMediaStreamSourceId(r),!this._firstTimeActive&&this.isCaptionsFeatureActive&&(this._firstTimeActive=!0,this._eventEmitter.emit("CaptionsActiveChanged")))});const i=this._tsCall.participants.find(r=>r.id===this._captionsBotMri||r.id===this._captionsLegacyBotMri);i&&(this._acsMetadata=this._copyBotMetaData(i),this._mediaStreamSourceId=i.getSourceIdForMediaType(3),await this._tsCall.startDataChannel(),await this._tsCall.dataChannelAdapter.addHandler(this._dataChannelId,this._dataChannelHandler))}catch{const r=new Oe({defaultError:we.FEATURES.CAPTIONS.INITIALIZE});throw this._sendCaptionsEvent(vo.InitializeCaptions,Je.failure,e,this._telemetryStartTime,ts.Unexpected,r.message,r.code,r.subCode,an(r)),this._logger.error(r.message),r}}updateCaptionsData(e){e===qy.Captions?(this._name=qy.Captions,this._captionsBotMri=wt().captions.acs.botMri,this._captionsLegacyBotMri=void 0,this._modeKey=wt().captions.acs.modeKey,this._modeVal=wt().captions.acs.modeVal,this._modesKey=wt().captions.acs.modesKey,this._modesVal=wt().captions.acs.modesVal,this._clientInfo=wt().captions.acs.clientInfo.ring,this._ecsACSCaptionsEnabled=wt().captions.acs.enabled,this._ecsSpokenLanguagesEnabled=wt().captions.acs.spokenLanguages.enabled,this._ecsSpokenLanguages=wt().captions.acs.spokenLanguages.languages,this._ecsCapabilitiesEnabled=wt().captions.useCapabilities,this._ecsSetBotMetadataWhenEmptyFixEnabled=wt().captions.setBotMetadataWhenEmptyFix,this._call.offParticipantCapabilitiesChanged("capabilitiesChanged",this.capabilityChangeHandler),this._logger.log("participant capabilities change event listener unregistered"),this._captions=new f2t(this,this._eventEmitter)):e===qy.TeamsCaptions&&(this._name=qy.TeamsCaptions,this._tsCall.region==="gcc"?this._captionsBotMri=wt().captions.teams.gccBotMri:this._captionsBotMri=wt().captions.teams.botMri,this._captionsLegacyBotMri=wt().captions.teams.legacyBotMri,this._modeKey=wt().captions.teams.modeKey,this._modeVal=wt().captions.teams.modeVal,this._modesKey=wt().captions.teams.modesKey,this._modesVal=wt().captions.teams.modesVal,this._clientInfo=wt().captions.teams.clientInfo.ring,this._ecsTeamsCaptionsEnabled=wt().captions.teams.enabled,this._ecsSpokenLanguagesEnabled=wt().captions.teams.spokenLanguages.enabled,this._ecsSpokenLanguages=wt().captions.teams.spokenLanguages.languages,this._ecsCaptionLanguagesEnabled=wt().captions.teams.captionLanguages.enabled,this._ecsCaptionLanguages=wt().captions.teams.captionLanguages.languages,this._ecsAmtPolicyUrlSuffix=wt().MiddleTier.policyUrlSuffixV2,this._ecsCapabilitiesEnabled=wt().captions.useCapabilities,this._ecsSetBotMetadataWhenEmptyFixEnabled=wt().captions.setBotMetadataWhenEmptyFix,this._participantCapability.startLiveMeetingCaptions=this._call.getParticipantCapabilities().startLiveMeetingCaptions,this._logger.log(`participant capabilitity to startLiveMeetingCaptions feature is ${this._participantCapability.startLiveMeetingCaptions}`),this._participantCapability.startLiveCallingCaptions=this._call.getParticipantCapabilities().startLiveCallingCaptions,this._logger.log(`participant capabilitity to startLiveCallingCaptions feature is ${this._participantCapability.startLiveCallingCaptions}`),this._participantCapability.setCaptionLanguage=this._call.getParticipantCapabilities().setCaptionLanguage,this._logger.log(`participant capabilitity to setCaptionLanguage feature is ${this._participantCapability.setCaptionLanguage}`),this._call.onParticipantCapabilitiesChanged("capabilitiesChanged",this.capabilityChangeHandler),this._logger.log("participant capabilities change event listener registered"),this._captions=new v2t(this,this._eventEmitter))}async startCaptions(e){this._telemetryStartTime=+Date.now();const i=ln(),r=e?.spokenLanguage||nxt;if(this._sendFeatureUsage("startCaptions",Je.attempt),this._sendCaptionsEvent(vo.StartCaptions,Je.attempt,i,0),this._addParticipantPromise){const o=new Oe({defaultError:we.FEATURES.CAPTIONS.ALREADY_STARTING});return this._sendCaptionsEvent(vo.StartCaptions,Je.failure,i,this._telemetryStartTime,ts.Expected,o.message,o.code,o.subCode,an(o)),void this._sendFeatureUsage("startCaptions",Je.failure)}if(await this._initializationPromise,!this._ecsCaptionsEnabled){const o=new Oe({defaultError:we.FEATURES.CAPTIONS.DISABLED});return this._sendCaptionsEvent(vo.StartCaptions,Je.failure,i,this._telemetryStartTime,ts.Expected,o.message,o.code,o.subCode,an(o)),this._sendFeatureUsage("startCaptions",Je.failure),void this._logger.error("Feature is not enabled.")}if(this._tsCall.state!==3){const o=new Oe({defaultError:we.FEATURES.CAPTIONS.START_FAILED_CALL_NOT_CONNECTED});return this._sendCaptionsEvent(vo.StartCaptions,Je.failure,i,this._telemetryStartTime,ts.Expected,o.message,o.code,o.subCode,an(o)),this._sendFeatureUsage("startCaptions",Je.failure),void this._logger.error("Captions unable to start as call state is not connected.")}if(!this._tsCall.endpoints){const o=new Oe({defaultError:we.FEATURES.CAPTIONS.START_FAILED_CALL_ENDPOINTS_NOT_AVAILABLE});return this._sendCaptionsEvent(vo.StartCaptions,Je.failure,i,this._telemetryStartTime,ts.Expected,o.message,o.code,o.subCode,an(o)),this._sendFeatureUsage("startCaptions",Je.failure),void this._logger.error("Captions unable to start as call endpoints are not available.")}if(!this._ecsSpokenLanguages.includes(r)){const o=new Oe({defaultError:we.FEATURES.CAPTIONS.SPOKEN_LANG_UNSUPPORTED});throw this._sendCaptionsEvent(vo.StartCaptions,Je.failure,i,this._telemetryStartTime,ts.Expected,o.message,o.code,o.subCode,an(o)),this._sendFeatureUsage("setSpokenLanguage",Je.failure),this._logger.error("Spoken language requested is not supported."),o}if(this._name===qy.Captions&&!this._ecsACSCaptionsEnabled){const o=new Oe({defaultError:we.FEATURES.CAPTIONS.DISABLED});return this._sendCaptionsEvent(vo.StartCaptions,Je.failure,i,this._telemetryStartTime,ts.Expected,o.message,o.code,o.subCode,an(o)),this._sendFeatureUsage("startCaptions",Je.failure),void this._logger.error("Captions Feature is not enabled.")}if(this._name===qy.TeamsCaptions){if(this._tsCall.region==="gcc"&&(this._captionsBotMri=wt().captions.teams.gccBotMri),!this._ecsTeamsCaptionsEnabled){const o=new Oe({defaultError:we.FEATURES.CAPTIONS.DISABLED});return this._sendCaptionsEvent(vo.StartCaptions,Je.failure,i,this._telemetryStartTime,ts.Expected,o.message,o.code,o.subCode,an(o)),this._sendFeatureUsage("startCaptions",Je.failure),void this._logger.error("Teams Captinons Feature is not enabled.")}if(this._ecsCapabilitiesEnabled){if(this._isCteUser){if(this._call.callInfo.context===To.TeamsMeeting||this.isTeamsConversationType){if(this._participantCapability){if(this.isTeamsConversationType){if(!this._participantCapability?.startLiveMeetingCaptions.isPresent){const o=new Oe({defaultError:we.FEATURES.CAPTIONS.MEETING_POLICY_DISABLED});throw this._sendCaptionsEvent(vo.StartCaptions,Je.failure,i,this._telemetryStartTime,ts.Expected,o.message,o.code,o.subCode,an(o)),this._sendFeatureUsage("startCaptions",Je.failure),this._logger.error(o.message),o}}else if(!this._participantCapability?.startLiveCallingCaptions.isPresent){const o=new Oe({defaultError:we.FEATURES.CAPTIONS.CALLING_POLICY_DISABLED});throw this._sendCaptionsEvent(vo.StartCaptions,Je.failure,i,this._telemetryStartTime,ts.Expected,o.message,o.code,o.subCode,an(o)),this._sendFeatureUsage("startCaptions",Je.failure),this._logger.error(o.message),o}}}else if(this._internalCallAgent.getUserPolicy()?.teamsCallingPolicy?.liveCaptionsEnabledTypeForCalling!=="DisabledUserOverride"){const l=new Oe({defaultError:we.FEATURES.CAPTIONS.CALLING_POLICY_DISABLED});throw this._sendCaptionsEvent(vo.StartCaptions,Je.failure,i,this._telemetryStartTime,ts.Expected,l.message,l.code,l.subCode,an(l)),this._sendFeatureUsage("startCaptions",Je.failure),this._logger.error(l.message),l}}}else if(this._mtPolicy=this._internalCallAgent.mtPolicyService,this._isCteUser){try{this._mtPolicy.initialize({localParticipant:this._internalCallAgent.getUserMri(),jwtTokenProvider:await this._internalCallAgent.tokenProvider,telemetryLogManager:this._telemetryLogManager}),await this._mtPolicy.fetchUserPoliciesFromAcsMiddleTier(this._tsCall.callId,this._call.callAgent.getUserMri(),{policyUrlSuffix:this._ecsAmtPolicyUrlSuffix,userPolicies:["TeamsCallingPolicy","TeamsMeetingPolicy"],userProperties:["FeatureTypes","PoliciesMetadata"]}),this._mtCaptionsPolicyResult=JSON.parse(this._mtPolicy.getTeamsUserCaptionsPoliciesData())}catch(o){const l=new Oe({defaultError:we.FEATURES.CAPTIONS.CTE_POLICY_FETCH_FAIL,originalError:o});this._sendCaptionsEvent(vo.StartCaptions,Je.failure,i,this._telemetryStartTime,ts.Unexpected,l.message,l.code,l.subCode,an(l)),this._logger.error("Unable to fetch policies")}if(this._mtCaptionsPolicyResult){if(this.isTeamsConversationType){if(!this._mtCaptionsPolicyResult?.isLiveCaptionsEnabledForMeeting){const o=new Oe({defaultError:we.FEATURES.CAPTIONS.MEETING_POLICY_DISABLED});throw this._sendCaptionsEvent(vo.StartCaptions,Je.failure,i,this._telemetryStartTime,ts.Expected,o.message,o.code,o.subCode,an(o)),this._sendFeatureUsage("startCaptions",Je.failure),this._logger.error(o.message),o}}else if(!this._mtCaptionsPolicyResult?.isLiveCaptionsEnabledForCalling){const o=new Oe({defaultError:we.FEATURES.CAPTIONS.CALLING_POLICY_DISABLED});throw this._sendCaptionsEvent(vo.StartCaptions,Je.failure,i,this._telemetryStartTime,ts.Expected,o.message,o.code,o.subCode,an(o)),this._sendFeatureUsage("startCaptions",Je.failure),this._logger.error(o.message),o}}}}if(this._ecsSetBotMetadataWhenEmptyFixEnabled){const o=this._tsCall.participants.find(l=>l.id===this._captionsBotMri||l.id===this._captionsLegacyBotMri);if(o&&!this._acsMetadata){this._acsMetadata=this._copyBotMetaData(o),this._mediaStreamSourceId=o.getSourceIdForMediaType(3);try{await this._tsCall.startDataChannel(),await this._tsCall.dataChannelAdapter.addHandler(this._dataChannelId,this._dataChannelHandler)}catch{const d=new Oe({defaultError:we.FEATURES.CAPTIONS.ALREADY_ACTIVE});this._sendCaptionsEvent(vo.StartDataChannel,Je.failure,i,this._telemetryStartTime,ts.Expected,d.message,d.code,d.subCode,an(d)),this._sendFeatureUsage("startDataChannel",Je.failure)}}}if(this._acsMetadata){if(this._isCaptionsEnabled(this._acsMetadata))if(this._isCaptionsActive){const o=new Oe({defaultError:we.FEATURES.CAPTIONS.ALREADY_ACTIVE});this._sendCaptionsEvent(vo.StartCaptions,Je.failure,i,this._telemetryStartTime,ts.Expected,o.message,o.code,o.subCode,an(o)),this._sendFeatureUsage("startCaptions",Je.failure)}else this._isCaptionsActive=!0,this._captions.kind==="Captions"&&await this.updateParticipantTranscriptionPrefsMetadata(!0,i),this._sendCaptionsEvent(vo.StartCaptions,Je.success,i,this._telemetryStartTime),this._sendFeatureUsage("startCaptions",Je.success),this._eventEmitter.emit("CaptionsActiveChanged");else if(this._captions.kind==="Captions")if(this._isCaptionsActive){const o=new Oe({defaultError:we.FEATURES.CAPTIONS.ALREADY_ACTIVE});this._sendCaptionsEvent(vo.StartCaptions,Je.failure,i,this._telemetryStartTime,ts.Expected,o.message,o.code,o.subCode,an(o)),this._sendFeatureUsage("startCaptions",Je.failure)}else this._isCaptionsActive=!0,await this.updateParticipantTranscriptionPrefsMetadata(!0,i),this._sendCaptionsEvent(vo.StartCaptions,Je.success,i,this._telemetryStartTime),this._sendFeatureUsage("startCaptions",Je.success),this._eventEmitter.emit("CaptionsActiveChanged")}else try{const o={participantInvitationData:{botData:{clientInfo:this._clientInfo,consumerType:"ACS",initiatorUserToken:this._name===qy.TeamsCaptions?"":await this._internalCallAgent.tokenProvider(),spokenLanguage:r,[this._modeKey]:this._modeVal,[this._modesKey]:this._modesVal}}};this._captions.kind==="Captions"&&await this.updateParticipantTranscriptionPrefsMetadata(!0,i),this._addParticipantPromise=this._tsCall.addParticipant(this._captionsBotMri,o),await this._addParticipantPromise,this._addParticipantPromise=null,this._currentLanguage!==r&&(this._currentLanguage=r,this._eventEmitter.emit("SpokenLanguageChanged")),this._isCaptionsActive=!0,this._sendCaptionsEvent(vo.StartCaptions,Je.success,i,this._telemetryStartTime),this._sendFeatureUsage("startCaptions",Je.success)}catch{this._addParticipantPromise=null;const l=new Oe({defaultError:we.FEATURES.CAPTIONS.START_FAILED});throw this._sendCaptionsEvent(vo.StartCaptions,Je.failure,i,this._telemetryStartTime,ts.Unexpected,l.message,l.code,l.subCode,an(l)),this._sendFeatureUsage("startCaptions",Je.failure),this._logger.error(l.message),l}}async stopCaptions(){this._telemetryStartTime=+Date.now();const e=ln();if(this._sendFeatureUsage("stopCaptions",Je.attempt),this._sendCaptionsEvent(vo.StopCaptions,Je.attempt,e,0),this.isCaptionsFeatureActive)this._captions.kind==="Captions"&&await this.updateParticipantTranscriptionPrefsMetadata(!1,e),this._isCaptionsActive=!1,this._sendCaptionsEvent(vo.StopCaptions,Je.success,e,this._telemetryStartTime),this._sendFeatureUsage("stopCaptions",Je.success),this._eventEmitter.emit("CaptionsActiveChanged");else{const i=new Oe({defaultError:we.FEATURES.CAPTIONS.STOP_NOT_ACTIVE});this._sendCaptionsEvent(vo.StopCaptions,Je.failure,e,this._telemetryStartTime,ts.Expected,i.message,i.code,i.subCode,an(i)),this._logger.warn(i.message)}this._isCaptionsActive=!1}async setSpokenLanguage(e){this._telemetryStartTime=+Date.now();const i=ln();if(this._sendFeatureUsage("setSpokenLanguage",Je.attempt),this._sendCaptionsEvent(vo.SetSpokenLanguage,Je.attempt,i,0),await this._initializationPromise,!this._acsMetadata?.commandUrl){const r=new Oe({defaultError:we.FEATURES.CAPTIONS.UPDATE_LANGUAGE_NOT_STARTED});throw this._sendCaptionsEvent(vo.SetSpokenLanguage,Je.failure,i,this._telemetryStartTime,ts.Expected,r.message,r.code,r.subCode,an(r)),this._sendFeatureUsage("setSpokenLanguage",Je.failure),this._logger.error(r.message),r}if(!this._isCaptionsActive){const r=new Oe({defaultError:we.FEATURES.CAPTIONS.UPDATE_LANGUAGE_NOT_STARTED});return this._sendCaptionsEvent(vo.SetSpokenLanguage,Je.failure,i,this._telemetryStartTime,ts.Expected,r.message,r.code,r.subCode,an(r)),this._sendFeatureUsage("setSpokenLanguage",Je.failure),void this._logger.warn(r.message)}if(!this._ecsSpokenLanguagesEnabled){const r=new Oe({defaultError:we.FEATURES.CAPTIONS.SPOKEN_LANG_DISABLED});return this._sendCaptionsEvent(vo.SetSpokenLanguage,Je.failure,i,this._telemetryStartTime,ts.Expected,r.message,r.code,r.subCode,an(r)),this._sendFeatureUsage("setSpokenLanguage",Je.failure),void this._logger.error(r.message)}if(e==this._currentLanguage){const r=new Oe({defaultError:we.FEATURES.CAPTIONS.SPOKEN_LANGUAGE_ALREADY_SET});return this._sendCaptionsEvent(vo.SetSpokenLanguage,Je.failure,i,this._telemetryStartTime,ts.Expected,r.message,r.code,r.subCode,an(r)),void this._sendFeatureUsage("setSpokenLanguage",Je.failure)}if(!this._ecsSpokenLanguages.includes(e)){const r=new Oe({defaultError:we.FEATURES.CAPTIONS.SPOKEN_LANG_UNSUPPORTED});throw this._sendCaptionsEvent(vo.SetSpokenLanguage,Je.failure,i,this._telemetryStartTime,ts.Expected,r.message,r.code,r.subCode,an(r)),this._sendFeatureUsage("setSpokenLanguage",Je.failure),this._logger.error(r.message),r}try{const r=await this._internalCallAgent.tokenProvider();if(!r){const o=new Oe({defaultError:we.FEATURES.CAPTIONS.UPDATE_LANGUAGE_GET_TOKEN});throw this._sendCaptionsEvent(vo.SetSpokenLanguage,Je.failure,i,this._telemetryStartTime,ts.Unexpected,o.message,o.code,o.subCode,an(o)),o}await this._sendSetLanguageRequest(e,"",r,this._acsMetadata.commandUrl),this._currentLanguage!==e&&(this._currentLanguage=e,this._eventEmitter.emit("SpokenLanguageChanged")),this._sendCaptionsEvent(vo.SetSpokenLanguage,Je.success,i,this._telemetryStartTime),this._sendFeatureUsage("setSpokenLanguage",Je.success)}catch(r){const o=new Oe({defaultError:we.FEATURES.CAPTIONS.UPDATE_LANGUAGE_FAILED,originalError:r});throw this._sendCaptionsEvent(vo.SetSpokenLanguage,Je.failure,i,this._telemetryStartTime,ts.Unexpected,o.message,o.code,o.subCode,an(o)),this._sendFeatureUsage("setSpokenLanguage",Je.failure),this._logger.error(o.message),o}}async setCaptionLanguage(e){this._telemetryStartTime=+Date.now();const i=ln();if(this._sendFeatureUsage("setCaptionLanguage",Je.attempt),this._sendCaptionsEvent(vo.SetCaptionLanguage,Je.attempt,i,0),await this._initializationPromise,!this._acsMetadata?.commandUrl){const r=new Oe({defaultError:we.FEATURES.CAPTIONS.UPDATE_CAPTIONS_NOT_STARTED});throw this._sendCaptionsEvent(vo.SetSpokenLanguage,Je.failure,i,this._telemetryStartTime,ts.Expected,r.message,r.code,r.subCode,an(r)),this._sendFeatureUsage("setCaptionLanguage",Je.failure),this._logger.error(r.message),r}if(!this._isCaptionsActive){const r=new Oe({defaultError:we.FEATURES.CAPTIONS.UPDATE_CAPTIONS_NOT_ACTIVE});return this._sendCaptionsEvent(vo.SetCaptionLanguage,Je.failure,i,this._telemetryStartTime,ts.Expected,r.message,r.code,r.subCode,an(r)),this._sendFeatureUsage("setCaptionLanguage",Je.failure),void this._logger.warn(r.message)}if(!this._ecsCaptionLanguagesEnabled){const r=new Oe({defaultError:we.FEATURES.CAPTIONS.CAPTIONS_LANG_DISABLED});return this._sendCaptionsEvent(vo.SetSpokenLanguage,Je.failure,i,this._telemetryStartTime,ts.Expected,r.message,r.code,r.subCode,an(r)),this._sendFeatureUsage("setCaptionLanguage",Je.failure),void this._logger.error(r.message)}if(this._isTranslatedCaptionsAllowed||this._tsCall.meetingDetails?.meetingCapability&&this._tsCall.meetingDetails.meetingCapability.allowTranslatedCaptions&&(this._isTranslatedCaptionsAllowed=this._tsCall.meetingDetails.meetingCapability.allowTranslatedCaptions),!this.isTeamsConversationType||!this._isTranslatedCaptionsAllowed){if(this._ecsCapabilitiesEnabled){if(this._call.callInfo.context!==To.TeamsMeeting){if(!this._internalCallAgent.getUserProperties()?.featureTypes?.includes(l6.TeamsProMgmt)){const o=new Oe({defaultError:we.FEATURES.CAPTIONS.CAPTIONS_LANG_TEAMS_LICENSE});throw this._sendCaptionsEvent(vo.SetSpokenLanguage,Je.failure,i,this._telemetryStartTime,ts.Expected,o.message,o.code,o.subCode,an(o)),this._sendFeatureUsage("setCaptionLanguage",Je.failure),this._logger.error(o.message),o}}else if(!this._participantCapability?.setCaptionLanguage.isPresent){const r=new Oe({defaultError:we.FEATURES.CAPTIONS.CAPTIONS_LANG_TEAMS_LICENSE});throw this._sendCaptionsEvent(vo.SetSpokenLanguage,Je.failure,i,this._telemetryStartTime,ts.Expected,r.message,r.code,r.subCode,an(r)),this._sendFeatureUsage("setCaptionLanguage",Je.failure),this._logger.error(r.message),r}}else if(!this._mtCaptionsPolicyResult?.isTeamsProMgmtSkuAvailable){const r=new Oe({defaultError:we.FEATURES.CAPTIONS.CAPTIONS_LANG_TEAMS_LICENSE});throw this._sendCaptionsEvent(vo.SetSpokenLanguage,Je.failure,i,this._telemetryStartTime,ts.Expected,r.message,r.code,r.subCode,an(r)),this._sendFeatureUsage("setCaptionLanguage",Je.failure),this._logger.error(r.message),r}}if(e==this._currentCaptionLanguage){const r=new Oe({defaultError:we.FEATURES.CAPTIONS.CAPTIONS_LANG_ALREADY_SET});return this._sendCaptionsEvent(vo.SetCaptionLanguage,Je.failure,i,this._telemetryStartTime,ts.Expected,r.message,r.code,r.subCode,an(r)),void this._sendFeatureUsage("setCaptionLanguage",Je.failure)}if(!this._ecsCaptionLanguages.includes(e)){const r=new Oe({defaultError:we.FEATURES.CAPTIONS.CAPTIONS_LANG_UNSUPPORTED});throw this._sendCaptionsEvent(vo.SetSpokenLanguage,Je.failure,i,this._telemetryStartTime,ts.Expected,r.message,r.code,r.subCode,an(r)),this._sendFeatureUsage("setCaptionLanguage",Je.failure),this._logger.error(r.message),r}try{const r=await this._internalCallAgent.tokenProvider();if(!r){const o=new Oe({defaultError:we.FEATURES.CAPTIONS.UPDATE_CAPTIONS_GET_TOKEN});throw this._sendCaptionsEvent(vo.SetSpokenLanguage,Je.failure,i,this._telemetryStartTime,ts.Unexpected,o.message,o.code,o.subCode,an(o)),o}await this._sendSetLanguageRequest("",e,r,this._acsMetadata.commandUrl),this._currentCaptionLanguage!==e&&(this._currentCaptionLanguage=e,this._eventEmitter.emit("CaptionLanguageChanged")),this._sendCaptionsEvent(vo.SetCaptionLanguage,Je.success,i,this._telemetryStartTime),this._sendFeatureUsage("setCaptionLanguage",Je.success)}catch(r){const o=new Oe({defaultError:we.FEATURES.CAPTIONS.UPDATE_CAPTIONS_FAILED,originalError:r});throw this._sendCaptionsEvent(vo.SetSpokenLanguage,Je.failure,i,this._telemetryStartTime,ts.Unexpected,o.message,o.code,o.subCode,an(o)),this._sendFeatureUsage("setCaptionLanguage",Je.failure),this._logger.error(o.message),o}}dispose(){this._acsMetadata=void 0,this._textDecoder=void 0}_sendCaptionsEvent(e,i,r,o,l,d,h,p,g){let f={eventName:vi.acs_calling_captions,callId:this._call.id,correlationId:r,isExpected:l??"",localParticipantId:this._call.tsCall.participantId,featureType:this._name,featureDetails:{step:e},kindOfEvent:i,timestampInfo:o?{deltaTimeInMs:+Date.now()-o}:"",additionalDetails:{failureReason:d,code:h,subCode:p,...g}};try{this._telemetryLogManager.sendEvent({name:vi.acs_calling_captions,tenant:Wr,properties:f})}catch{this._logger.debug(`Unable to send ${this._name} feature usage telemtery`)}}_sendFeatureUsage(e,i){Pc({callId:this._tsCall.callId,localParticipantId:this._tsCall.participantId,featureName:this._name,featureType:"Call",initializationType:"OnFeatureAccess",featureDetails:{name:e,step:i}},this._telemetryLogManager,this._logger)}async _sendSetLanguageRequest(e,i,r,o){const l=e?{type:lhe,spokenLanguage:e}:{type:lhe,subtitleLanguages:[i]},d={timestamp:new Date().toISOString(),participantMri:this._internalCallAgent.getUserMri(),participantLegId:this._tsCall.participantId,action:lhe,mode:$xe,actionParameters:l},h={headers:{"X-Microsoft-Skype-Chain-ID":this._tsCall.callId,Authorization:`Bearer ${r}`,"x-skypetoken":r},withCredentials:!0};return this._httpRequestHelper.sendRequestWithRetry("post",o,d,h,g2t)}}_Q([to(LB.StartCaptions),xE("design:type",Function),xE("design:paramtypes",[Object]),xE("design:returntype",Promise)],P6.prototype,"startCaptions",null),_Q([to(LB.StopCaptions),xE("design:type",Function),xE("design:paramtypes",[]),xE("design:returntype",Promise)],P6.prototype,"stopCaptions",null),_Q([to(LB.SetSpokenLanguage),xE("design:type",Function),xE("design:paramtypes",[String]),xE("design:returntype",Promise)],P6.prototype,"setSpokenLanguage",null),_Q([to(LB.SetCaptionLanguage),xE("design:type",Function),xE("design:paramtypes",[String]),xE("design:returntype",Promise)],P6.prototype,"setCaptionLanguage",null);class y2t extends Bu{constructor(e){super(e),this._impl=new S2t(this.eventEmitter),this._callInfo=e.callInfo}get name(){return"RaiseHand"}initialize(e,i){this._logger=i,this._telemetryLogManager=e.telemetryLogManager,this._tsCall=e.tsCall,this._impl.initialize(e.tsCall,e.callAgent,e.telemetryLogManager,i,this._callInfo)}async raiseHand(){return this._impl.raiseHand()}async lowerHand(){return this._impl.lowerHand()}async lowerHands(e){return this._impl.lowerHands(e)}lowerAllHands(){return this._impl.lowerAllHands()}getRaisedHands(){return this._sendFeatureUsage("getRaisedHands",Je.getter),this._impl.raisedHands}on(e,i){this._sendFeatureUsage(e,Je.subscribe),this.eventEmitter.on(e,i)}off(e,i){this._sendFeatureUsage(e,Je.unsubscribe),this.eventEmitter.off(e,i)}_sendFeatureUsage(e,i){Pc({callId:this._tsCall.callId,localParticipantId:this._tsCall.participantId,featureName:"RaiseHand",featureType:"Call",initializationType:"OnFeatureAccess",featureDetails:{name:e,step:i}},this._telemetryLogManager,this._logger)}dispose(){this.disposed||super.dispose()}}class S2t{constructor(e){this.typeRankComparator=(i,r)=>i.publishedState===void 0?-1:r.publishedState===void 0?1:i.publishedState.typeRank-r.publishedState.typeRank,this._eventEmitter=e,this._currentRaiseHandStates=new Map}initialize(e,i,r,o,l){this._logger=o.createChild(()=>`RaiseHandFeature::Call(id='${e.callId}')`),this._tsCall=e,this._callInfo=l,this._telemetryLogManager=r,this._internalCallAgent=i,this._sendFeatureUsage("initialize",Je.initialize);try{let d=h=>new Map(this.getPublishedState(h).sort(this.typeRankComparator).map(p=>[p.id,p]));this._tsCall.on("publishedStatesChanged",async h=>{let p=d(h),g=this._currentRaiseHandStates;this._currentRaiseHandStates=p,this._currentRaiseHandStates.forEach((f,y)=>{g.has(y)||this._eventEmitter.emit("raisedHandEvent",{identifier:Sl(y)})}),g.forEach((f,y)=>{this._currentRaiseHandStates.has(y)||this._eventEmitter.emit("loweredHandEvent",{identifier:Sl(y)})})}),this._tsCall.publishedStates&&(this._currentRaiseHandStates=d(this._tsCall.publishedStates)),this._sendFeatureUsage("initialize",Je.success)}catch(d){throw this._logger.error("Could not initialize raise hand feature.",d),this._sendFeatureUsage("initialize",Je.failure),new Oe({defaultError:we.FEATURES.RAISE_HAND.INITIALIZE,originalError:d})}}async raiseHand(){if(this._sendFeatureUsage("raiseHand",Je.attempt),this._callInfo.context===To.TwoParty)throw this._logger.warn("Raise hand not supported for 1:1 calls"),this._sendFeatureUsage("raiseHand",Je.failure),new Oe({defaultError:we.FEATURES.RAISE_HAND.NOT_SUPPORTED_1TO1});try{if(this.getLocalRaiseHandState()!==void 0)return void this._sendFeatureUsage("raiseHand",Je.failure);const e={level:"user",type:"raiseHands",content:"{}"};if(!await this._tsCall.publishState(e,fd()))throw new Oe({defaultError:we.FEATURES.RAISE_HAND.RAISE_HAND_PUBLISH_STATE});this._sendFeatureUsage("raiseHand",Je.success)}catch(e){throw this._logger.error("Could not change a participant state. Code: ",e?.response?.status),this._sendFeatureUsage("raiseHand",Je.failure),nb(e,we.FEATURES.RAISE_HAND.RAISE_HAND_FAIL)}}async lowerHand(){this._sendFeatureUsage("lowerHand",Je.attempt);try{const e=this.getLocalRaiseHandState();if(e===void 0)return void this._sendFeatureUsage("lowerHand",Je.failure);const i={stateIds:[e]};await this._tsCall.removeState(i,fd()),this._sendFeatureUsage("lowerHand",Je.success)}catch(e){throw this._logger.error("Could not change a participant state. Code: ",e?.response?.status),this._sendFeatureUsage("lowerHand",Je.failure),nb(e,we.FEATURES.RAISE_HAND.LOWER_HAND_FAIL)}}async lowerHands(e){this._sendFeatureUsage("lowerHands",Je.attempt);try{if(e.length===0)return void this._sendFeatureUsage("lowerHands",Je.failure);if(this._currentRaiseHandStates.size===0)return void this._sendFeatureUsage("lowerHands",Je.failure);const i=e.map(o=>zr(o)),r=this.findStateIdsForParticipantIds(i);await this._tsCall.removeState({stateIds:r},fd()),this._sendFeatureUsage("lowerHands",Je.success)}catch(i){throw this._logger.error("Could not change a participant state.",i),this._sendFeatureUsage("lowerHands",Je.failure),nb(i,we.FEATURES.RAISE_HAND.LOWER_REMOTEPARTICIPANTS_HANDS_FAIL)}}async lowerAllHands(){this._sendFeatureUsage("lowerAllHands",Je.attempt);try{await this._tsCall.removeStatesForEveryone({type:"raiseHands"},fd()),this._sendFeatureUsage("lowerAllHands",Je.success)}catch(e){throw this._logger.error("Could not change a participant state.",e),this._sendFeatureUsage("lowerAllHands",Je.failure),nb(e,we.FEATURES.RAISE_HAND.LOWER_ALL_HANDS_FAIL)}}get raisedHands(){return this._currentRaiseHandStates.size===0?[]:Array.from(this._currentRaiseHandStates.keys()).map((e,i)=>({identifier:Sl(e),order:i+1}))}getLocalRaiseHandState(){const e=this.findStateIdsForParticipantIds([this._internalCallAgent.getUserMri()]);if(e&&e.length>0)return e[0]}findStateIdsForParticipantIds(e){return e&&this._currentRaiseHandStates.size!==0?Array.from(this._currentRaiseHandStates.entries()).filter(i=>e.includes(i[0])).map(i=>i[1]?.publishedState?.stateId).filter(i=>!!i):[]}getPublishedState(e){return e.typeStates.filter(i=>i.type==="raiseHands").map(i=>i.participantStates).flat()}_sendFeatureUsage(e,i){Pc({callId:this._tsCall.callId,localParticipantId:this._tsCall.participantId,featureName:"RaiseHand",featureType:"Call",initializationType:"OnFeatureAccess",featureDetails:{name:e,step:i}},this._telemetryLogManager,this._logger)}}var Ls;(function(t){t.turnVideoOn="turnVideoOn",t.unmuteMic="unmuteMic",t.shareScreen="shareScreen",t.removeParticipant="removeParticipant",t.hangUpForEveryOne="hangUpForEveryOne",t.addCommunicationUser="addCommunicationUser",t.addTeamsUser="addTeamsUser",t.addPhoneNumber="addPhoneNumber",t.manageLobby="manageLobby",t.spotlightParticipant="spotlightParticipant",t.removeParticipantsSpotlight="removeParticipantsSpotlight",t.blurBackground="blurBackground",t.startLiveMeetingCaptions="startLiveMeetingCaptions",t.startLiveCallingCaptions="startLiveCallingCaptions",t.setCaptionLanguage="setCaptionLanguage",t.raiseHand="raiseHand",t.pstnDialOut="pstnDialOut",t.muteOthers="muteOthers",t.useReactions="useReactions",t.viewAttendeeNames="viewAttendeeNames",t.startTogetherMode="startTogetherMode",t.joinBreakoutRooms="joinBreakoutRooms",t.forbidOthersAudio="forbidOthersAudio",t.forbidOthersVideo="forbidOthersVideo"})(Ls||(Ls={}));class b2t{constructor(e){this._logger=e,this._ecsConfig=wt()}getResolvedCapabilitiesBasedOnRole(e,i){let r={...i},o=e.toLocaleLowerCase();return o!==Dd.Attendee.toLocaleLowerCase()&&o!==Dd.Presenter.toLocaleLowerCase()&&o!==Dd.Consumer.toLocaleLowerCase()&&o!==Dd.Collaborator.toLocaleLowerCase()||(this._ecsConfig[cg][o][Ls.turnVideoOn]?r.turnVideoOn={isPresent:this._ecsConfig[cg][o][Ls.turnVideoOn],reason:Bi.Capable}:r.turnVideoOn={isPresent:this._ecsConfig[cg][o][Ls.turnVideoOn],reason:Bi.RoleRestricted},this._ecsConfig[cg][o][Ls.unmuteMic]?r.unmuteMic={isPresent:this._ecsConfig[cg][o][Ls.unmuteMic],reason:Bi.Capable}:r.unmuteMic={isPresent:this._ecsConfig[cg][o][Ls.unmuteMic],reason:Bi.RoleRestricted},this._ecsConfig[cg][o][Ls.shareScreen]?r.shareScreen={isPresent:this._ecsConfig[cg][o][Ls.shareScreen],reason:Bi.Capable}:r.shareScreen={isPresent:this._ecsConfig[cg][o][Ls.shareScreen],reason:Bi.RoleRestricted},this._ecsConfig[cg][o][Ls.removeParticipant]?r.removeParticipant={isPresent:this._ecsConfig[cg][o][Ls.removeParticipant],reason:Bi.Capable}:r.removeParticipant={isPresent:this._ecsConfig[cg][o][Ls.removeParticipant],reason:Bi.RoleRestricted},this._ecsConfig[cg][o][Ls.muteOthers]?r.muteOthers={isPresent:this._ecsConfig[cg][o][Ls.muteOthers],reason:Bi.Capable}:r.muteOthers={isPresent:this._ecsConfig[cg][o][Ls.muteOthers],reason:Bi.RoleRestricted},this._ecsConfig[cg][o][Ls.pstnDialOut]?r.pstnDialOut={isPresent:this._ecsConfig[cg][o][Ls.pstnDialOut],reason:Bi.Capable}:r.pstnDialOut={isPresent:this._ecsConfig[cg][o][Ls.pstnDialOut],reason:Bi.RoleRestricted},this._ecsConfig[cg][o][Ls.addPhoneNumber]?r.addPhoneNumber={isPresent:this._ecsConfig[cg][o][Ls.addPhoneNumber],reason:Bi.Capable}:r.addPhoneNumber={isPresent:this._ecsConfig[cg][o][Ls.addPhoneNumber],reason:Bi.RoleRestricted}),r.removeParticipant={isPresent:!1,reason:Bi.CapabilityNotApplicableForTheCallType},r.hangUpForEveryOne={isPresent:!1,reason:Bi.CapabilityNotApplicableForTheCallType},r.addCommunicationUser={isPresent:!1,reason:Bi.CapabilityNotApplicableForTheCallType},r.addTeamsUser={isPresent:!1,reason:Bi.CapabilityNotApplicableForTheCallType},r.manageLobby={isPresent:!1,reason:Bi.CapabilityNotApplicableForTheCallType},r.spotlightParticipant={isPresent:!1,reason:Bi.CapabilityNotApplicableForTheCallType},r.removeParticipantsSpotlight={isPresent:!1,reason:Bi.CapabilityNotApplicableForTheCallType},r.blurBackground={isPresent:!1,reason:Bi.CapabilityNotApplicableForTheCallType},r.startLiveMeetingCaptions={isPresent:!0,reason:Bi.Capable},r.startLiveCallingCaptions={isPresent:!0,reason:Bi.Capable},r.setCaptionLanguage={isPresent:!1,reason:Bi.CapabilityNotApplicableForTheCallType},r.raiseHand={isPresent:!1,reason:Bi.CapabilityNotApplicableForTheCallType},r.useReactions={isPresent:!0,reason:Bi.Capable},r.viewAttendeeNames={isPresent:!0,reason:Bi.Capable},r.startTogetherMode={isPresent:!1,reason:Bi.CapabilityNotApplicableForTheCallType},r.joinBreakoutRooms={isPresent:!1,reason:Bi.CapabilityNotApplicableForTheCallType},r.forbidOthersAudio={isPresent:!1,reason:Bi.CapabilityNotApplicableForTheCallType},r.forbidOthersVideo={isPresent:!1,reason:Bi.CapabilityNotApplicableForTheCallType},this._logger.log(`Capabilities resolved to : ${JSON.stringify(r)} on role change to ${e}`),r}}const m2e="DisableAv",T2t="DisableVideo",C2t="DisableAudio",_2t="Attendee",f2e="attendee";class Qhe extends Bu{constructor(e){super(e),this.getLocalParticipantMediaAccess=()=>this._impl.getLocalParticipantMediaAccess(),this._impl=new E2t(this.eventEmitter)}get name(){return"MediaAccess"}initialize(e,i){this._logger=i,this._telemetryLogManager=e.telemetryLogManager,this._tsCall=e.tsCall,this._impl.initialize(e.tsCall,e.callAgent,e.call,e.telemetryLogManager,i)}getAllOthersMediaAccess(){return this._impl.getAllOthersMediaAccess()}getMeetingMediaAccess(){return this._impl.getMeetingMediaAccess()}async permitAudio(e){return this._impl.permitAudio(e)}async permitOthersAudio(){return this._impl.permitOthersAudio()}async forbidAudio(e){return this._impl.forbidAudio(e)}async forbidOthersAudio(){return this._impl.forbidOthersAudio()}async permitVideo(e){return this._impl.permitVideo(e)}async permitOthersVideo(){return this._impl.permitOthersVideo()}async forbidVideo(e){return this._impl.forbidVideo(e)}async forbidOthersVideo(){return this._impl.forbidOthersVideo()}on(e,i){if(this._sendFeatureUsage(e,Je.subscribe),e!=="mediaAccessChanged"&&e!=="meetingMediaAccessChanged"&&e!=="localParticipantMediaAccessChanged")throw new Oe({defaultError:we.CALL.EVENT_SUBSCRIBE,defaultErrorMessageArgs:[e]});this.eventEmitter.on(e,i)}off(e,i){if(this._sendFeatureUsage(e,Je.unsubscribe),e!=="mediaAccessChanged"&&e!=="meetingMediaAccessChanged"&&e!=="localParticipantMediaAccessChanged")throw new Oe({defaultError:we.CALL.EVENT_UNSUBSCRIBE,defaultErrorMessageArgs:[e]});this.eventEmitter.off(e,i)}_sendFeatureUsage(e,i){Pc({callId:this._tsCall.callId,localParticipantId:this._tsCall.participantId,featureName:"MediaAccess",featureType:"Call",initializationType:"OnFeatureAccess",featureDetails:{name:e,step:i}},this._telemetryLogManager,this._logger)}dispose(){this.disposed||super.dispose()}}class E2t{constructor(e){this._ecsTeamsMediaAccessEnabled=!1,this._remoteParticipantsMediaAccess=[],this.getAllOthersMediaAccess=()=>(this._remoteParticipantsMediaAccess=this._tsCall.participants.reduce((r,o)=>{const l=this._publishedStatesMediaAccessMap.get(o.id),d=o.advancedMeetingRole===f2e,h=Sl(o.id);return l&&d?r.push(l):!l&&d?r.push({participant:h,isAudioPermitted:!this.isMeetingCapabilityAudioRestricted(),isVideoPermitted:!this.isMeetingCapabilityVideoRestricted()}):r.push({participant:h,isAudioPermitted:!0,isVideoPermitted:!0}),r},[]),this._remoteParticipantsMediaAccess),this.getLocalParticipantMediaAccess=()=>{const r=this._internalCallAgent.getUserMri(),o=this._publishedStatesMediaAccessMap.get(r),l=this._call.role===_2t;if(o&&l)return o;const d=Sl(r);return!o&&l?{participant:d,isAudioPermitted:!this.isMeetingCapabilityAudioRestricted(),isVideoPermitted:!this.isMeetingCapabilityVideoRestricted()}:{participant:d,isAudioPermitted:!0,isVideoPermitted:!0}},this.isMeetingCapabilityAudioRestricted=()=>[m2e,C2t].includes(this._tsCall.meetingDetails?.meetingCapability?.attendeeRestrictions),this.isMeetingCapabilityVideoRestricted=()=>[m2e,T2t].includes(this._tsCall.meetingDetails?.meetingCapability?.attendeeRestrictions),this.getMediaAccessMap=r=>{if(dn.isEmpty(r?.typeStates))return new Map;const o=new Map;return r&&this.getPublishedState(r).forEach(l=>{l.participantStates.forEach(d=>{let h=o.get(d.id);h||(h={participantId:d.id},o.set(d.id,h)),["attendeeAudioRestricted","attendeeModalitiesUnrestricted"].includes(l.type)&&(h.isAudioPermitted=this.isAudioPermitted(l.type)),["attendeeVideoRestricted","attendeeVideoUnrestricted"].includes(l.type)&&(h.isVideoPermitted=this.isVideoPermitted(l.type))})}),o.forEach(l=>{l.isAudioPermitted===void 0&&(l.isAudioPermitted=!this.isMeetingCapabilityAudioRestricted()),l.isVideoPermitted===void 0&&(l.isVideoPermitted=!this.isMeetingCapabilityVideoRestricted())}),new Map(Array.from(o).map(([l,d])=>[l,{participant:Sl(l),isAudioPermitted:!!d?.isAudioPermitted,isVideoPermitted:!!d?.isVideoPermitted}]))},this.isAudioPermitted=r=>this.isMeetingCapabilityAudioRestricted()?r==="attendeeModalitiesUnrestricted":r!=="attendeeAudioRestricted",this.isVideoPermitted=r=>this.isMeetingCapabilityVideoRestricted()?r==="attendeeVideoUnrestricted":r!=="attendeeVideoRestricted",this.checkRemoteParticipantsMediaAccessAndEmitEvent=()=>{const r=this._remoteParticipantsMediaAccess;this._publishedStatesMediaAccessMap=this.getMediaAccessMap(this._tsCall.publishedStates),this.getAllOthersMediaAccess(),dn.isEqual(r,this._remoteParticipantsMediaAccess)||this._eventEmitter.emit("mediaAccessChanged",{mediaAccesses:this._remoteParticipantsMediaAccess})},this.checkLocalMediaAccessAndEmitEvent=()=>{const r=this.getLocalParticipantMediaAccess();dn.isEqual(this._localMediaAccess,r)||(this._localMediaAccess=r,this._eventEmitter.emit("localParticipantMediaAccessChanged",{mediaAccess:this._localMediaAccess}))},this.isUserRoleEligible=()=>this._tsCall.advancedMeetingRole&&this._supportedUserRoles.includes(this._tsCall.advancedMeetingRole),this.isSupportedConversationType=()=>this._supportedConversationTypes.includes(this._tsCall.conversationType);const i=wt().calling.mediaAccess;this._ecsTeamsMediaAccessEnabled=i.enabled,this._supportedUserRoles=i.supportedRoles,this._supportedConversationTypes=i.supportedConversationTypes,this._supportedConversationTypesForMuteAll=i.supportedConversationTypesForMuteAll,this._eventEmitter=e,this._publishedStatesMediaAccessMap=new Map,this._attendeeRestrictions="",this._localMediaAccess=void 0}initialize(e,i,r,o,l){this._logger=l.createChild(()=>`MediaAccessCallFeature::Call(id='${e.callId}')`),this._tsCall=e,this._call=r,this._telemetryLogManager=o,this._internalCallAgent=i,this._sendFeatureUsage("initialize",Je.initialize);try{if(!this._ecsTeamsMediaAccessEnabled)throw"feature not supported or call context is not teams meeting join";this._tsCall.on("publishedStatesChanged",async d=>{this._logger.info("publishedStatesChanged event received");const h=this._publishedStatesMediaAccessMap;this._publishedStatesMediaAccessMap=this.getMediaAccessMap(d),dn.isEqual(h,this._publishedStatesMediaAccessMap)||this._eventEmitter.emit("mediaAccessChanged",{mediaAccesses:this.getAllOthersMediaAccess()}),this.checkLocalMediaAccessAndEmitEvent()}),this._tsCall.changed(()=>{const d=this._tsCall.meetingDetails?.meetingCapability?.attendeeRestrictions;dn.isEqual(this._attendeeRestrictions,d)||(this._logger.info(`Attendee restrictions change from ${this._attendeeRestrictions} to ${d}`),this._attendeeRestrictions=d,this._eventEmitter.emit("meetingMediaAccessChanged",{meetingMediaAccess:this.getMeetingMediaAccess()}),this.checkRemoteParticipantsMediaAccessAndEmitEvent(),this.checkLocalMediaAccessAndEmitEvent())}),this._tsCall.on("participantCountsUpdated",d=>{this._logger.info("participantCountsUpdated changed event received, totalParticipants: ",d?.totalParticipants),this.checkRemoteParticipantsMediaAccessAndEmitEvent(),this.checkLocalMediaAccessAndEmitEvent()}),this._attendeeRestrictions=this._tsCall.meetingDetails?.meetingCapability?.attendeeRestrictions,this._publishedStatesMediaAccessMap=this.getMediaAccessMap(this._tsCall.publishedStates),this._localMediaAccess=this.getLocalParticipantMediaAccess(),this._sendFeatureUsage("initialize",Je.success)}catch(d){throw this._logger.error("Could not initialize media access feature.",d),this._sendFeatureUsage("initialize",Je.failure),new Oe({defaultError:we.FEATURES.MEDIA_ACCESS.INITIALIZE_FAILED,originalError:d})}}async permitAudio(e){const i=ln();this._sendFeatureUsage("permitAudio",Je.attempt,i),this.validateMediaAccessConditions("permitAudio",i,!1,!0,e.map(r=>zr(r)));try{const r=e.map(o=>zr(o));this.isMeetingCapabilityAudioRestricted()?await this.addModalityState(r,"attendeeModalitiesUnrestricted",i):await this.removeModalityState(r,"attendeeAudioRestricted",i),this._sendFeatureUsage("permitAudio",Je.success,i)}catch(r){throw this._logger.error(`Could not change a participant state. Code: ${r?.response?.status} correlationId: ${i}`),this._sendFeatureUsage("permitAudio",Je.failure),nb(r,we.FEATURES.MEDIA_ACCESS.MEDIA_ACCESS_UPDATE_FAILED)}}async forbidAudio(e){const i=ln();this._sendFeatureUsage("forbidAudio",Je.attempt,i),this.validateMediaAccessConditions("forbidAudio",i,!1,!0,e.map(r=>zr(r)));try{const r=e.map(o=>zr(o));this.isMeetingCapabilityAudioRestricted()?await this.removeModalityState(r,"attendeeModalitiesUnrestricted",i):await this.addModalityState(r,"attendeeAudioRestricted",i),this._sendFeatureUsage("forbidAudio",Je.success,i)}catch(r){throw this._logger.error(`Could not change a participant state. Code: ${r?.response?.status} correlationId: ${i}`),this._sendFeatureUsage("forbidAudio",Je.failure),nb(r,we.FEATURES.MEDIA_ACCESS.MEDIA_ACCESS_UPDATE_FAILED)}}async permitOthersAudio(){const e=ln();this._sendFeatureUsage("permitOthersAudio",Je.attempt,e),this.validateMediaAccessConditions("permitOthersAudio",e,!0);try{let i;i=this.isMeetingCapabilityVideoRestricted()?2:0,await this.updateAttendeeRestrictions(i,e),this._sendFeatureUsage("permitOthersAudio",Je.success,e)}catch(i){throw this._logger.error(`Could not change a participant state. Code: ${i?.response?.status} correlationId: ${e}`),this._sendFeatureUsage("permitOthersAudio",Je.failure),nb(i,we.FEATURES.MEDIA_ACCESS.MEDIA_ACCESS_UPDATE_FAILED)}}async forbidOthersAudio(){const e=ln();this._sendFeatureUsage("forbidOthersAudio",Je.attempt,e),this.validateMediaAccessConditions("forbidOthersAudio",e,!0);try{let i;i=this.isMeetingCapabilityVideoRestricted()?3:1,await this.updateAttendeeRestrictions(i,e),this._sendFeatureUsage("forbidOthersAudio",Je.success,e)}catch(i){throw this._logger.error(`Could not change a participant state. Code: ${i?.response?.status} correlationId: ${e}`),this._sendFeatureUsage("forbidOthersAudio",Je.failure),nb(i,we.FEATURES.MEDIA_ACCESS.MEDIA_ACCESS_UPDATE_FAILED)}}async permitVideo(e){const i=ln();this._sendFeatureUsage("permitVideo",Je.attempt,i),this.validateMediaAccessConditions("permitVideo",i,!1,!0,e.map(r=>zr(r)));try{const r=e.map(o=>zr(o));this.isMeetingCapabilityVideoRestricted()?await this.addModalityState(r,"attendeeVideoUnrestricted",i):await this.removeModalityState(r,"attendeeVideoRestricted",i),this._sendFeatureUsage("permitVideo",Je.success,i)}catch(r){throw this._logger.error(`Could not change a participant state. Code: ${r?.response?.status} correlationId: ${i}`),this._sendFeatureUsage("permitVideo",Je.failure),nb(r,we.FEATURES.MEDIA_ACCESS.MEDIA_ACCESS_UPDATE_FAILED)}}async forbidVideo(e){const i=ln();this._sendFeatureUsage("forbidVideo",Je.attempt,i),this.validateMediaAccessConditions("forbidVideo",i,!1,!0,e.map(r=>zr(r)));try{const r=e.map(o=>zr(o));this.isMeetingCapabilityVideoRestricted()?await this.removeModalityState(r,"attendeeVideoUnrestricted",i):await this.addModalityState(r,"attendeeVideoRestricted",i),this._sendFeatureUsage("forbidVideo",Je.success,i)}catch(r){throw this._logger.error(`Could not change a participant state. Code: ${r?.response?.status} correlationId: ${i}`),this._sendFeatureUsage("forbidVideo",Je.failure),nb(r,we.FEATURES.MEDIA_ACCESS.MEDIA_ACCESS_UPDATE_FAILED)}}async permitOthersVideo(){const e=ln();this._sendFeatureUsage("permitOthersVideo",Je.attempt,e),this.validateMediaAccessConditions("permitOthersVideo",e,!0);try{let i;i=this.isMeetingCapabilityAudioRestricted()?1:0,await this.updateAttendeeRestrictions(i,e),this._sendFeatureUsage("permitOthersVideo",Je.success,e)}catch(i){throw this._logger.error(`Could not change a participant state. Code: ${i?.response?.status} correlationId: ${e}`),this._sendFeatureUsage("permitOthersVideo",Je.failure),nb(i,we.FEATURES.MEDIA_ACCESS.MEDIA_ACCESS_UPDATE_FAILED)}}async forbidOthersVideo(){const e=ln();this._sendFeatureUsage("forbidOthersVideo",Je.attempt,e),this.validateMediaAccessConditions("forbidOthersVideo",e,!0);try{let i;i=this.isMeetingCapabilityAudioRestricted()?3:2,await this.updateAttendeeRestrictions(i,e),this._sendFeatureUsage("forbidOthersVideo",Je.success,e)}catch(i){throw this._logger.error(`Could not change a participant state. Code: ${i?.response?.status} correlationId: ${e}`),this._sendFeatureUsage("forbidOthersVideo",Je.failure),nb(i,we.FEATURES.MEDIA_ACCESS.MEDIA_ACCESS_UPDATE_FAILED)}}getMeetingMediaAccess(){return{isAudioPermitted:!this.isMeetingCapabilityAudioRestricted(),isVideoPermitted:!this.isMeetingCapabilityVideoRestricted()}}updateAttendeeRestrictions(e,i){const r={attendeeRestrictions:e};return this._tsCall.updateMeetingSettings(r,i).catch(o=>{this._logger.error(`updateAttendeeRestrictions: failed with correlationId: ${i}, error: ${JSON.stringify(o)}`)})}getPublishedState(e){return e.typeStates.filter(i=>["attendeeVideoRestricted","attendeeAudioRestricted","attendeeVideoUnrestricted","attendeeModalitiesUnrestricted"].includes(i.type))}addModalityState(e,i,r){return new Promise((o,l)=>{const d={type:i,level:"user",content:"{}",participantIds:e};this._tsCall.publishState(d,r).then(()=>{o()}).catch(h=>{const p=`addModalityState: failed with error: ${JSON.stringify({...h,correlationId:r,participantIds:e})}`;this._logger.error(p),l(p)})})}removeModalityState(e,i,r){const o=this._tsCall.publishedStates?this.getStateIdForParticipants(this._tsCall.publishedStates,e,i):[];if(dn.isEmpty(o)){const l=`removeModalityState: no valid stateIds found for participants: ${e}, publishStateType: ${i} correlationId: ${r}`;return this._logger.error(l),Promise.reject(l)}return new Promise((l,d)=>{const h={stateIds:o};this._tsCall.removeState(h,r).then(()=>{l()}).catch(p=>{const g=`removeModalityState: failed with error: ${JSON.stringify({...p,correlationId:r,stateIds:o})}`;this._logger.error(g),d(g)})})}getStateIdForParticipants(e,i,r){const o=[],l=e&&e.typeStates&&e.typeStates.find(d=>d.type===r);return dn.isEmpty(l?.participantStates)?(this._logger.error(`getStateIdForParticipants: no valid typeState or participantStates found for participants: ${i}`),o):(i.forEach(d=>{const h=l?.participantStates.find(p=>p&&p.id===d);dn.isEmpty(h)?this._logger.error(`getStateIdForParticipants: participant: ${d} not found.`):dn.isEmpty(h?.publishedState)?this._logger.error(`getStateIdForParticipants: no published state for participant: ${d}`):h?.publishedState&&o.push(h.publishedState.stateId)}),o)}validateMediaAccessConditions(e,i,r,o,l){let d;if(this._ecsTeamsMediaAccessEnabled)if(this.isUserRoleEligible())if(r||this.isSupportedConversationType())if(r&&!this._supportedConversationTypesForMuteAll.includes(this._tsCall.conversationType))this._logger.error(`Conversation type is not supported for media access all feature, conversation type: ${this._tsCall.conversationType}`),d=new Oe({defaultError:we.FEATURES.MEDIA_ACCESS.UNSUPPORTED_CONVERSATION_TYPE_FOR_FORBID_PERMIT_OTHERS_MEDIA_ACCESS,defaultErrorMessageArgs:["Conversation type: ",this._tsCall.conversationType]});else if(this._tsCall.state!==3)this._logger.error("Call state is not connected."),d=new Oe({defaultError:we.FEATURES.MEDIA_ACCESS.CALL_NOT_CONNECTED,defaultErrorMessageArgs:["call state: ",this._tsCall.state]});else if(dn.isEmpty(l))o&&dn.isEmpty(l)?(this._logger.error("Participants array is empty."),d=new Oe({defaultError:we.FEATURES.MEDIA_ACCESS.INVALID_PARTICIPANTS_LIST})):this._tsCall.meetingDetails?.meetingCapability?.attendeeRestrictions||(this._logger.error("Meeting capability attendee restrictions is empty."),d=new Oe({defaultError:we.FEATURES.MEDIA_ACCESS.INVALID_MEETING_CAPABILITY_ATTENDEE_RESTRICTIONS,defaultErrorMessageArgs:["Meeting capability attendeerestrictions is empty."]}));else{const h=this._tsCall.participants.find(p=>l?.includes(p.id)&&p.advancedMeetingRole!==f2e);h&&(this._logger.error(`Participant is not an attendee. id: ${h.id}`),d=new Oe({defaultError:we.FEATURES.MEDIA_ACCESS.ROLE_RESTRICTED,defaultErrorMessageArgs:["Participant role: ",h.advancedMeetingRole||""]}))}else this._logger.error(`Conversation type is not supported for media access feature, conversation type: ${this._tsCall.conversationType}`),d=new Oe({defaultError:we.FEATURES.MEDIA_ACCESS.UNSUPPORTED_CONVERSATION_TYPE,defaultErrorMessageArgs:["Conversation type: ",this._tsCall.conversationType]});else this._logger.error("User role is not eligible for media access feature."),d=new Oe({defaultError:we.FEATURES.MEDIA_ACCESS.UNSUPPORTED_ROLE,defaultErrorMessageArgs:["User role: ",this._tsCall.advancedMeetingRole||""]});else this._logger.error("Media access feature is not enabled."),d=new Oe({defaultError:we.FEATURES.MEDIA_ACCESS.FEATURE_DISABLED,defaultErrorMessageArgs:["Media access feature is not enabled."]});if(d)throw this._sendFeatureUsage(e,Je.failure,i),d}_sendFeatureUsage(e,i,r){Pc({correlationId:r,callId:this._tsCall.callId,localParticipantId:this._tsCall.participantId,featureName:"MediaAccess",featureType:"Call",initializationType:"OnFeatureAccess",featureDetails:{name:e,step:i}},this._telemetryLogManager,this._logger)}}class v2e{constructor(e,i){this._logger=e,this._ecsConfig=wt(),this._call=i}getResolvedCapabilitiesBasedOnRole(e,i){let r={...i},o=e.toLocaleLowerCase();return o!==Dd.Attendee.toLocaleLowerCase()&&o!==Dd.Presenter.toLocaleLowerCase()&&o!==Dd.Consumer.toLocaleLowerCase()&&o!==Dd.Organizer.toLocaleLowerCase()&&o!==Dd.Coorganizer.toLocaleLowerCase()||(o=o.replace("-",""),i.shareScreen.reason!=Bi.UserPolicyRestricted&&(this._ecsConfig[Ip][o][Ls.shareScreen]?r.shareScreen={isPresent:!0,reason:Bi.Capable}:r.shareScreen={isPresent:!1,reason:Bi.RoleRestricted}),this._ecsConfig[Ip][o][Ls.removeParticipant]?r.removeParticipant={isPresent:!0,reason:Bi.Capable}:r.removeParticipant={isPresent:!1,reason:Bi.RoleRestricted},this._ecsConfig[Ip][o][Ls.hangUpForEveryOne]?r.hangUpForEveryOne={isPresent:!0,reason:Bi.Capable}:r.hangUpForEveryOne={isPresent:!1,reason:Bi.RoleRestricted},this._ecsConfig[Ip][o][Ls.addCommunicationUser]?r.addCommunicationUser={isPresent:!0,reason:Bi.Capable}:r.addCommunicationUser={isPresent:!1,reason:Bi.RoleRestricted},this._ecsConfig[Ip][o][Ls.addTeamsUser]?r.addTeamsUser={isPresent:!0,reason:Bi.Capable}:r.addTeamsUser={isPresent:!1,reason:Bi.RoleRestricted},this._ecsConfig[Ip][o][Ls.addPhoneNumber]?r.addPhoneNumber={isPresent:!0,reason:Bi.Capable}:r.addPhoneNumber={isPresent:!1,reason:Bi.RoleRestricted},this._ecsConfig[Ip][o][Ls.manageLobby]?r.manageLobby={isPresent:!0,reason:Bi.Capable}:r.manageLobby={isPresent:!1,reason:Bi.RoleRestricted},this._ecsConfig[Ip][o][Ls.spotlightParticipant]?r.spotlightParticipant={isPresent:!0,reason:Bi.Capable}:r.spotlightParticipant={isPresent:!1,reason:Bi.RoleRestricted},this._ecsConfig[Ip][o][Ls.removeParticipantsSpotlight]?r.removeParticipantsSpotlight={isPresent:!0,reason:Bi.Capable}:r.removeParticipantsSpotlight={isPresent:!1,reason:Bi.RoleRestricted},i.blurBackground.reason!=Bi.UserPolicyRestricted&&(this._ecsConfig[Ip][o][Ls.blurBackground]?r.blurBackground={isPresent:!0,reason:Bi.Capable}:r.blurBackground={isPresent:!1,reason:Bi.RoleRestricted}),i.startLiveMeetingCaptions.reason!=Bi.UserPolicyRestricted&&(this._ecsConfig[Ip][o][Ls.startLiveMeetingCaptions]?r.startLiveMeetingCaptions={isPresent:!0,reason:Bi.Capable}:r.startLiveMeetingCaptions={isPresent:!1,reason:Bi.RoleRestricted}),i.startLiveCallingCaptions.reason!=Bi.UserPolicyRestricted&&(this._ecsConfig[Ip][o][Ls.startLiveCallingCaptions]?r.startLiveCallingCaptions={isPresent:!0,reason:Bi.Capable}:r.startLiveCallingCaptions={isPresent:!1,reason:Bi.RoleRestricted}),i.setCaptionLanguage.reason!=Bi.TeamsPremiumLicenseRestricted&&(this._ecsConfig[Ip][o][Ls.setCaptionLanguage]?r.setCaptionLanguage={isPresent:!0,reason:Bi.Capable}:r.setCaptionLanguage={isPresent:!1,reason:Bi.RoleRestricted}),i.raiseHand.reason!=Bi.MeetingRestricted&&(this._ecsConfig[Ip][o][Ls.raiseHand]?r.raiseHand={isPresent:!0,reason:Bi.Capable}:r.raiseHand={isPresent:!1,reason:Bi.RoleRestricted}),i.pstnDialOut.reason!=Bi.MeetingRestricted&&(this._ecsConfig[Ip][o][Ls.pstnDialOut]?r.pstnDialOut={isPresent:!0,reason:Bi.Capable}:r.pstnDialOut={isPresent:!1,reason:Bi.RoleRestricted}),i.muteOthers.reason!=Bi.MeetingRestricted&&(this._ecsConfig[Ip][o][Ls.muteOthers]?r.muteOthers={isPresent:!0,reason:Bi.Capable}:r.muteOthers={isPresent:!1,reason:Bi.RoleRestricted}),i.forbidOthersAudio.reason!=Bi.MeetingRestricted&&(this._ecsConfig[Ip][o][Ls.forbidOthersAudio]?r.forbidOthersAudio={isPresent:!0,reason:Bi.Capable}:r.forbidOthersAudio={isPresent:!1,reason:Bi.RoleRestricted}),i.forbidOthersVideo.reason!=Bi.MeetingRestricted&&(this._ecsConfig[Ip][o][Ls.forbidOthersVideo]?r.forbidOthersVideo={isPresent:!0,reason:Bi.Capable}:r.forbidOthersVideo={isPresent:!1,reason:Bi.RoleRestricted}),i.useReactions.reason!=Bi.MeetingRestricted&&(this._ecsConfig[Ip][o][Ls.useReactions]?r.useReactions={isPresent:!0,reason:Bi.Capable}:r.useReactions={isPresent:!1,reason:Bi.RoleRestricted}),i.viewAttendeeNames.reason!=Bi.MeetingRestricted&&(this._ecsConfig[Ip][o][Ls.viewAttendeeNames]?r.viewAttendeeNames={isPresent:!0,reason:Bi.Capable}:r.viewAttendeeNames={isPresent:!1,reason:Bi.RoleRestricted}),i.startTogetherMode.reason!=Bi.MeetingRestricted&&(this._ecsConfig[Ip][o][Ls.startTogetherMode]?r.startTogetherMode={isPresent:!0,reason:Bi.Capable}:r.startTogetherMode={isPresent:!1,reason:Bi.RoleRestricted}),i.joinBreakoutRooms.reason!=Bi.UserPolicyRestricted&&(this._ecsConfig[Ip][o][Ls.joinBreakoutRooms]?r.joinBreakoutRooms={isPresent:!0,reason:Bi.Capable}:r.joinBreakoutRooms={isPresent:!1,reason:Bi.RoleRestricted})),this.resolveMicVideoAndScreenShareCapabilities(r),this._logger.log(`Capabilities resolved to : ${JSON.stringify(r)} on role change to ${e}`),r}getResolvedCapabilitiesBasedOnMeetingCapabilities(e,i){let r={...i};return this.resolveMicVideoAndScreenShareCapabilities(r),e.allowRaiseHands!=null&&(e.allowRaiseHands?r.raiseHand={isPresent:!0,reason:Bi.Capable}:r.raiseHand={isPresent:!1,reason:Bi.MeetingRestricted}),e.allowPstnConferencing!=null&&(e.allowPstnConferencing?r.pstnDialOut={isPresent:!0,reason:Bi.Capable}:r.pstnDialOut={isPresent:!1,reason:Bi.MeetingRestricted}),e.allowTeamsMeetingReactions!=null&&(e.allowTeamsMeetingReactions?r.useReactions={isPresent:!0,reason:Bi.Capable}:r.useReactions={isPresent:!1,reason:Bi.MeetingRestricted}),e.maskIdentitiesForRole!=null&&(e.maskIdentitiesForRole?r.viewAttendeeNames={isPresent:!1,reason:Bi.MeetingRestricted}:r.viewAttendeeNames={isPresent:!0,reason:Bi.Capable}),e.allowTranslatedCaptions!=null&&(e.allowTranslatedCaptions?r.setCaptionLanguage={isPresent:!0,reason:Bi.Capable}:r.setCaptionLanguage={isPresent:!1,reason:Bi.TeamsPremiumLicenseRestricted}),this._logger.log(`Capabilities resolved to : ${JSON.stringify(r)} on meeting details change to ${e}`),r}getResolvedCapabilitiesBasedOnUserPolicy(e,i){let r={...i};return e.teamsMeetingPolicy?.screenSharingMode!=null&&(e.teamsMeetingPolicy?.screenSharingMode=="Disabled"?r.shareScreen={isPresent:!1,reason:Bi.UserPolicyRestricted}:r.shareScreen={isPresent:!0,reason:Bi.Capable}),e.teamsMeetingPolicy?.liveCaptionsEnabledType!=null&&(e.teamsMeetingPolicy?.liveCaptionsEnabledType=="Disabled"?r.startLiveMeetingCaptions={isPresent:!1,reason:Bi.UserPolicyRestricted}:r.startLiveMeetingCaptions={isPresent:!0,reason:Bi.Capable}),e.teamsCallingPolicy?.liveCaptionsEnabledTypeForCalling!=null&&(e.teamsCallingPolicy?.liveCaptionsEnabledTypeForCalling=="Disabled"?r.startLiveCallingCaptions={isPresent:!1,reason:Bi.UserPolicyRestricted}:r.startLiveCallingCaptions={isPresent:!0,reason:Bi.Capable}),e.teamsMeetingPolicy?.videoFiltersMode!=null&&(e.teamsMeetingPolicy?.videoFiltersMode=="NoFilters"?r.blurBackground={isPresent:!1,reason:Bi.UserPolicyRestricted}:r.blurBackground={isPresent:!0,reason:Bi.Capable}),e.teamsMeetingPolicy?.allowBreakoutRooms!=null&&(e.teamsMeetingPolicy?.allowBreakoutRooms?r.joinBreakoutRooms={isPresent:!0,reason:Bi.Capable}:r.joinBreakoutRooms={isPresent:!1,reason:Bi.UserPolicyRestricted}),e.teamsMeetingPolicy?.ipAudioMode!=null&&(e.teamsMeetingPolicy?.ipAudioMode==="Disabled"?r.unmuteMic={isPresent:!1,reason:Bi.IpModeUserPolicyRestricted}:r.unmuteMic={isPresent:!0,reason:Bi.Capable}),e.teamsMeetingPolicy?.ipVideoMode!=null&&(e.teamsMeetingPolicy?.ipVideoMode==="Disabled"?r.turnVideoOn={isPresent:!1,reason:Bi.IpModeUserPolicyRestricted}:r.turnVideoOn={isPresent:!0,reason:Bi.Capable}),this.resolveMicVideoAndScreenShareCapabilities(r),this._logger.log(`Capabilities resolved to : ${JSON.stringify(r)} on user policy update to ${e}`),r}getResolvedCapabilitiesBasedOnUserProperties(e,i){let r={...i};return this._logger.log(`Capabilities resolved to : ${JSON.stringify(r)} on user properties update to ${e}`),r}getResolvedCapabilitiesBasedOnCallPublishedStates(e){const i={...e};return this.resolveMicVideoAndScreenShareCapabilities(i),this._logger.log(`Capabilities resolved to : ${JSON.stringify(i)}`),i}resolveMicVideoAndScreenShareCapabilities(e){const i=e.unmuteMic.reason===Bi.IpModeUserPolicyRestricted,r=e.turnVideoOn.reason===Bi.IpModeUserPolicyRestricted;if(!i||!r){const o=this._call.feature(Qd(Qhe)).getLocalParticipantMediaAccess();i||(e.unmuteMic=o.isAudioPermitted?{isPresent:!0,reason:Bi.Capable}:{isPresent:!1,reason:Bi.MeetingRestricted}),r||(e.turnVideoOn=o.isVideoPermitted?{isPresent:!0,reason:Bi.Capable}:{isPresent:!1,reason:Bi.MeetingRestricted})}e.shareScreen.reason===Bi.Capable&&this._call.explicitConsentStateImp.areCoreCapabilitiesConsentRestricted()?e.shareScreen={isPresent:!1,reason:Bi.ExplicitConsentRequired}:e.shareScreen.reason!==Bi.ExplicitConsentRequired||this._call.explicitConsentStateImp.areCoreCapabilitiesConsentRestricted()||(e.shareScreen={isPresent:!0,reason:Bi.Capable}),e.unmuteMic.reason===Bi.Capable&&this._call.explicitConsentStateImp.areCoreCapabilitiesConsentRestricted()?e.unmuteMic={isPresent:!1,reason:Bi.ExplicitConsentRequired}:e.unmuteMic.reason!==Bi.ExplicitConsentRequired||this._call.explicitConsentStateImp.areCoreCapabilitiesConsentRestricted()||(e.unmuteMic={isPresent:!0,reason:Bi.Capable}),e.turnVideoOn.reason===Bi.Capable&&this._call.explicitConsentStateImp.areCoreCapabilitiesConsentRestricted()?e.turnVideoOn={isPresent:!1,reason:Bi.ExplicitConsentRequired}:e.turnVideoOn.reason!==Bi.ExplicitConsentRequired||this._call.explicitConsentStateImp.areCoreCapabilitiesConsentRestricted()||(e.turnVideoOn={isPresent:!0,reason:Bi.Capable})}}class y2e{constructor(e,i,r,o,l,d){this._meetingCapabilities={},this._eventEmitter=e,this._logger=i,this._callInfo=o,this._tsCall=d,this._call=r,this._callAgent=l,this._capabilities=this.initializeCapabilities(),(this._callInfo.context==To.Rooms||this._callInfo.context==To.TeamsMeeting)&&this.doInitialCapabilityResolutionBasedOnRole(),this._callInfo.context==To.TeamsMeeting&&this.doInitialCapabilityResolutionBasedOnUserPolicy(),this._callInfo.context==To.TeamsMeeting&&this.doInitialCapabilityResolutionBasedOnMeetingCapabilities(),this._callInfo.context==To.TeamsMeeting&&this.doInitialCapabilityResolutionBasedOnCallPublishedStates()}initializeCapabilities(){return this._logger.info("initializing capabilities"),this._callInfo.context!=To.Rooms&&this._callInfo.context!=To.TeamsMeeting?{turnVideoOn:{isPresent:!1,reason:Bi.FeatureNotSupported},unmuteMic:{isPresent:!1,reason:Bi.FeatureNotSupported},shareScreen:{isPresent:!1,reason:Bi.FeatureNotSupported},removeParticipant:{isPresent:!1,reason:Bi.FeatureNotSupported},hangUpForEveryOne:{isPresent:!1,reason:Bi.FeatureNotSupported},addCommunicationUser:{isPresent:!1,reason:Bi.FeatureNotSupported},addTeamsUser:{isPresent:!1,reason:Bi.FeatureNotSupported},addPhoneNumber:{isPresent:!1,reason:Bi.FeatureNotSupported},manageLobby:{isPresent:!1,reason:Bi.FeatureNotSupported},spotlightParticipant:{isPresent:!1,reason:Bi.FeatureNotSupported},removeParticipantsSpotlight:{isPresent:!1,reason:Bi.FeatureNotSupported},blurBackground:{isPresent:!1,reason:Bi.FeatureNotSupported},startLiveMeetingCaptions:{isPresent:!1,reason:Bi.FeatureNotSupported},startLiveCallingCaptions:{isPresent:!1,reason:Bi.FeatureNotSupported},setCaptionLanguage:{isPresent:!1,reason:Bi.FeatureNotSupported},raiseHand:{isPresent:!1,reason:Bi.FeatureNotSupported},pstnDialOut:{isPresent:!1,reason:Bi.FeatureNotSupported},muteOthers:{isPresent:!1,reason:Bi.FeatureNotSupported},useReactions:{isPresent:!1,reason:Bi.FeatureNotSupported},viewAttendeeNames:{isPresent:!1,reason:Bi.FeatureNotSupported},startTogetherMode:{isPresent:!1,reason:Bi.FeatureNotSupported},joinBreakoutRooms:{isPresent:!1,reason:Bi.FeatureNotSupported},forbidOthersAudio:{isPresent:!1,reason:Bi.FeatureNotSupported},forbidOthersVideo:{isPresent:!1,reason:Bi.FeatureNotSupported}}:{turnVideoOn:{isPresent:!1,reason:Bi.NotInitialized},unmuteMic:{isPresent:!1,reason:Bi.NotInitialized},shareScreen:{isPresent:!1,reason:Bi.NotInitialized},removeParticipant:{isPresent:!1,reason:Bi.NotInitialized},hangUpForEveryOne:{isPresent:!1,reason:Bi.NotInitialized},addCommunicationUser:{isPresent:!1,reason:Bi.NotInitialized},addTeamsUser:{isPresent:!1,reason:Bi.NotInitialized},addPhoneNumber:{isPresent:!1,reason:Bi.NotInitialized},manageLobby:{isPresent:!1,reason:Bi.NotInitialized},spotlightParticipant:{isPresent:!1,reason:Bi.NotInitialized},removeParticipantsSpotlight:{isPresent:!1,reason:Bi.NotInitialized},blurBackground:{isPresent:!1,reason:Bi.NotInitialized},startLiveMeetingCaptions:{isPresent:!1,reason:Bi.FeatureNotSupported},startLiveCallingCaptions:{isPresent:!1,reason:Bi.FeatureNotSupported},setCaptionLanguage:{isPresent:!1,reason:Bi.FeatureNotSupported},raiseHand:{isPresent:!1,reason:Bi.NotInitialized},pstnDialOut:{isPresent:!1,reason:Bi.NotInitialized},muteOthers:{isPresent:!1,reason:Bi.NotInitialized},useReactions:{isPresent:!1,reason:Bi.NotInitialized},joinBreakoutRooms:{isPresent:!1,reason:Bi.NotInitialized},viewAttendeeNames:{isPresent:!1,reason:Bi.NotInitialized},startTogetherMode:{isPresent:!1,reason:Bi.NotInitialized},forbidOthersAudio:{isPresent:!1,reason:Bi.NotInitialized},forbidOthersVideo:{isPresent:!1,reason:Bi.NotInitialized}}}doInitialCapabilityResolutionBasedOnRole(){this.resolveCapabilitiesBasedOnRole()}doInitialCapabilityResolutionBasedOnUserPolicy(){this.getCapabilityResolver()instanceof v2e&&this._callInfo.context!=To.Rooms&&this.resolveCapabilitiesBasedOnUserPolicy()}doInitialCapabilityResolutionBasedOnMeetingCapabilities(){this.resolveCapabilitiesBasedOnMeetingCapabilities()}doInitialCapabilityResolutionBasedOnCallPublishedStates(){this.resolveCapabilitiesBasedOnCallPublishedStates()}getCapabilityResolver(){return this._callInfo.context?.match(To.Rooms)?new b2t(this._logger):(this._callInfo.context?.match(To.TeamsMeeting),new v2e(this._logger,this._call))}getCapabilities(){return this._capabilities}resolveCapabilitiesBasedOnRole(){if(this._callInfo.context!=To.Rooms&&this._callInfo.context!=To.TeamsMeeting)return;let e=this._call.role;e==Dd.Unknown&&(e=this._callInfo.context==To.Rooms?Dd.Consumer:Dd.Attendee);let i=this.getCapabilityResolver();if(i){let r=JSON.parse(JSON.stringify(this._capabilities));if(this._capabilities=i.getResolvedCapabilitiesBasedOnRole(e,this._capabilities),!dn.isEqual(r,this._capabilities)){const o=this.getChangedCapabilitiesInfo(r,this._capabilities,"RoleChanged");this._logger.info(`Capabilities has changed based on role update to ${e}, emitting capabilities changed event with capabilitiesChangeInfo: ${JSON.stringify(o)}`),this._eventEmitter.emit("capabilitiesChanged",o)}}}resolveCapabilitiesBasedOnMeetingCapabilities(){if(this._callInfo.context!=To.TeamsMeeting)return;let e={};e={...this._tsCall.meetingDetails?.capabilities,...this._tsCall.meetingDetails?.meetingCapability,...this._tsCall.meetingDetails?.recordingConsentDetails},this._meetingCapabilities={...e};let i=this.getCapabilityResolver();if(i&&i){const r=JSON.parse(JSON.stringify(this._capabilities));if(this._capabilities=i.getResolvedCapabilitiesBasedOnMeetingCapabilities(e,this._capabilities),!dn.isEqual(r,this._capabilities)){const o=this.getChangedCapabilitiesInfo(r,this._capabilities,"MeetingOptionOrOrganizerPolicyChanged");this._logger.info(`Capabilities has changed due to meeting capabilities, emitting capabilities changed event with capabilitiesChangeInfo: ${JSON.stringify(o)}`),this._eventEmitter.emit("capabilitiesChanged",o)}}}resolveCapabilitiesBasedOnCallPublishedStates(){if(this._callInfo.context!==To.TeamsMeeting)return;const e=this.getCapabilityResolver();if(e&&e){const i=JSON.parse(JSON.stringify(this._capabilities));if(this._capabilities=e.getResolvedCapabilitiesBasedOnCallPublishedStates(this._capabilities),!dn.isEqual(i,this._capabilities)){const r=this.getChangedCapabilitiesInfo(i,this._capabilities,"MeetingOptionOrOrganizerPolicyChanged");this._logger.info(`Capabilities has changed due to call published states, emitting capabilities changed event with capabilitiesChangeInfo: ${JSON.stringify(r)}`),this._eventEmitter.emit("capabilitiesChanged",r)}}}resolveCapabilitiesBasedOnUserPolicy(){if(this._callInfo.context!=To.TeamsMeeting)return;let e=this._callAgent.getUserPolicy(),i=this.getCapabilityResolver();if(i&&i&&e){let r=JSON.parse(JSON.stringify(this._capabilities));if(this._capabilities=i.getResolvedCapabilitiesBasedOnUserPolicy(e,this._capabilities),!dn.isEqual(r,this._capabilities)){const o=this.getChangedCapabilitiesInfo(r,this._capabilities,"UserPolicyChanged");this._logger.info(`Capabilities has changed due to user policy, emitting capabilities changed event with capabilitiesChangeInfo: ${JSON.stringify(o)}`),this._eventEmitter.emit("capabilitiesChanged",o)}}}resolveCapabilitiesBasedOnUserProperties(){if(this._callInfo.context!=To.TeamsMeeting)return;let e=this._callAgent.getUserProperties(),i=this.getCapabilityResolver();if(i&&i&&e){let r=JSON.parse(JSON.stringify(this._capabilities));if(this._capabilities=i.getResolvedCapabilitiesBasedOnUserProperties(e,this._capabilities),!dn.isEqual(r,this._capabilities)){const o=this.getChangedCapabilitiesInfo(r,this._capabilities,"TeamsPremiumLicenseChanged");this._logger.info(`Capabilities has changed due to Teams Premium License, emitting capabilities changed event with capabilitiesChangeInfo: ${JSON.stringify(o)}`),this._eventEmitter.emit("capabilitiesChanged",o)}}}getMeetingsCapabilitiesInternal(){return this._meetingCapabilities}getChangedCapabilitiesInfo(e,i,r){let o={},l={};return Object.keys(e).forEach(d=>{e[d].isPresent!=i[d].isPresent&&(o[d]=e[d],l[d]=i[d])}),{oldValue:o,newValue:l,reason:r}}}class A2t extends Bu{constructor(e){super(e),this._callInfo=e.callInfo,this._impl=new I2t(this.eventEmitter)}get name(){return this._sendFeatureUsage("name",Je.getter),"Capabilities"}initialize(e,i){this._logger=i,this._telemetryLogManager=e.telemetryLogManager,this._tsCall=e.tsCall,this._impl.initialize(e.tsCall,e.callAgent,e.call,this._callInfo,e.telemetryLogManager,i),this._sendFeatureUsage("initialize",Je.initialize)}get capabilities(){return this._sendFeatureUsage("getCapabilities",Je.getter),this._impl.capabilities}on(e,i){this._sendFeatureUsage(e,Je.subscribe),this.eventEmitter.on(e,i)}off(e,i){this._sendFeatureUsage(e,Je.unsubscribe),this.eventEmitter.off(e,i)}_sendFeatureUsage(e,i){Pc({callId:this._tsCall.callId,localParticipantId:this._tsCall.participantId,featureName:"Capabilities",featureType:"Call",initializationType:"OnFeatureAccess",featureDetails:{name:e,step:i}},this._telemetryLogManager,this._logger)}dispose(){this.disposed||super.dispose()}}class I2t{constructor(e){this._eventEmitter=e}get capabilities(){return this._capabilityResolver.getCapabilities()}initialize(e,i,r,o,l,d){this._logger=d.createChild(()=>`CapabilitiesFeature::Call(id='${e.callId}')`),this._tsCall=e,this._call=r,this._callInfo=o,this._internalCallAgent=i,this._timeToInitialize=new Date,this._capabilityResolver=new y2e(this._eventEmitter,this._logger,this._call,this._callInfo,this._internalCallAgent,this._tsCall),this._call.on("roleChanged",()=>{this._capabilityResolver.resolveCapabilitiesBasedOnRole();let h=(new Date().getTime()-this._timeToInitialize.getTime())/1e3;this._logger.info("Time difference to initialize after role set is "+h)}),this._call.onMeetingCapabilitiesChanged("meetingCapabilitiesChanged",()=>{this._capabilityResolver.resolveCapabilitiesBasedOnMeetingCapabilities();let h=(new Date().getTime()-this._timeToInitialize.getTime())/1e3;this._logger.info("Time difference to initialize after meeting set up is"+h)}),this._call.feature(Qd(Qhe)).on("localParticipantMediaAccessChanged",()=>{this._capabilityResolver.resolveCapabilitiesBasedOnCallPublishedStates(),this._logger.info("Time when received localParticipantMediaAccessChanged event"+new Date().getTime())}),this._call.explicitConsentStateImp.onConsentRestrictionChanged("consentRestrictionChanged",()=>{this._capabilityResolver.resolveCapabilitiesBasedOnCallPublishedStates();let h=(new Date().getTime()-this._timeToInitialize.getTime())/1e3;this._logger.info("Time difference to initialize after published state change is"+h)})}}var uP,ah,w2t=function(t){var e=0;if(t.length==0)return e;for(var i=0;i<t.length;i++)e=(e<<5)-e+t.charCodeAt(i),e|=0;return e},k2t=function(t,e){var i="0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";e=e||62;var r,o=[],l="",d=t<0?"-":"";for(t=Math.abs(t);t>=e;)r=t%e,t=Math.floor(t/e),o.push(i[r]);t>0&&o.push(i[t]);for(var h=o.length-1;h>=0;h--)l+=o[h];return d+l},R2t=function(t){var e=typeof t;if(e==="string"||e==="number")return k2t(w2t(String(t)),61).replace("-","Z");throw new Error("Unexpected input type")};(function(t){t.ping="ping",t.pong="pong"})(uP||(uP={}));class M2t extends Jhe{constructor(e){super(e),this._impl=new P2t;try{uk().includes("stable")||(this._browserTabInfoImpl=new $C(this.eventEmitter))}catch{e.callClient.logger.error("Feature to detect multiple tabs is not supported on the current environment.")}}get name(){return this._sendFeatureUsage("name",Je.getter),"DebugInfo"}get lastLocalParticipantId(){return this._sendFeatureUsage("lastLocalParticipantId",Je.getter),this._impl.lastLocalParticipantId}get logs(){return this._impl.logDump}get localParticipantIdMap(){return this._impl.localParticipantIdMap}get incommingCallIdMap(){return this._impl.incommingCallIdMap}get lastCallId(){if(this._sendFeatureUsage("lastCallId",Je.getter),this.lastLocalParticipantId)return this._impl.localParticipantIdMap[this.lastLocalParticipantId].callIds.slice(-1)[0]}get diagnosticInformation(){return this._impl.diagnosticInformation}get sdkVersion(){return uk()}get acsResourceId(){return this._impl.AcsResourceId}get clientId(){return this._impl.clientId}dumpDebugInfoAsJSONString(){try{return JSON.stringify(this.toZip())}catch(e){return`JSON.stringify threw: ${e}`}}toZip(){return{clientId:this.clientId,lastLocalParticipantId:this.lastLocalParticipantId,localParticipantIdMap:this.localParticipantIdMap,incommingCallMap:this.incommingCallIdMap,AcsResourceId:this.acsResourceId,diagnosticInformation:this.diagnosticInformation,sdkVersion:this.sdkVersion,logs:this.logs}}dumpDebugInfo(){this._sendFeatureUsage("dumpDebugInfo",Je.attempt);try{const e=w6.deflate(this.dumpDebugInfoAsJSONString(),{to:"string"}),i=R2t(e);return this._sendFeatureUsage("dumpDebugInfo",Je.success),{dump:e,dumpId:`${ln()}-${i}`}}catch(e){const i=`failed to deflate, error: ${e}`;return this.logger.error(i),this._sendFeatureUsage("dumpDebugInfo",Je.failure),{dump:w6.deflate(i,{to:"string"}),dumpId:ln()}}}initialize(e,i){this._impl.initialize(e,i),this.logger=i,this._telemetryLogManager=e.telemetryLogManager,this._callClient=e.callClient,this._browserTabInfoImpl&&this._browserTabInfoImpl.initialize(e.callClient,i,e.telemetryLogManager),this._sendFeatureUsage("initialize",Je.initialize)}async getEnvironmentInfo(){return this._sendFeatureUsage("getEnvironmentInfo",Je.getter),await this._callClient.getEnvironmentInfoInternal()}get isAnotherCallClientActiveInSameTab(){return this._sendFeatureUsage("isAnotherCallClientActiveInSameTab",Je.getter),!!this._browserTabInfoImpl&&this._browserTabInfoImpl.isAnotherCallClientActiveInSameTab}get isCallClientActiveInAnotherTab(){return this._sendFeatureUsage("isCallClientActiveInAnotherTab",Je.getter),!!this._browserTabInfoImpl&&this._browserTabInfoImpl.isCallClientActiveInAnotherTab}on(e,i){e!=="isCallClientActiveInAnotherTabChanged"&&e!=="isAnotherCallClientActiveInSameTabChanged"&&this.logger.error(`Not able to subscribe to event ${e}, unknown event name`),this._sendFeatureUsage(e,Je.subscribe),this.eventEmitter.on(e,i)}off(e,i){e!=="isCallClientActiveInAnotherTabChanged"&&e!=="isAnotherCallClientActiveInSameTabChanged"&&this.logger.error(`Not able to unsubscribe to event ${e}, unknown event name`),this._sendFeatureUsage(e,Je.unsubscribe),this.eventEmitter.off(e,i)}_sendFeatureUsage(e,i){Yhe({featureName:"DebugInfo",featureType:"CallClient",initializationType:"OnExtendedObjectConstructor",featureDetails:{name:e,step:i}},this._telemetryLogManager,this.logger)}dispose(){this._sendFeatureUsage("dispose",Je.attempt),this.disposed?this._sendFeatureUsage("dispose",Je.failure):(this._impl.dispose(),super.dispose(),this._sendFeatureUsage("dispose",Je.success))}}class P2t{get diagnosticInformation(){return this._sdkDiagnosticInformation}get logDump(){return this._logger.log("Log dump requested"),this._logger.dumpAllLogs()}get AcsResourceId(){return this._callAgent?.getAcsResourceId()}get lastLocalParticipantId(){return this._lastLocalParticipantId}get localParticipantIdMap(){return this._localParticipantIdMap}get incommingCallIdMap(){return this._incommingCallIdMap}get clientId(){return this._callAgent?.getClientId()}constructor(){this._localParticipantIdMap={},this._incommingCallIdMap={}}initialize(e,i){this._logger=i,this._callAgent=e?.callClient?.callAgent,this._sdkDiagnosticInformation=e?.callClient.sdkDiagnosticInformation,this._logger.info("waiting for call agent to be created");const r=()=>{this._callAgent=e?.callClient.callAgent,this.subscribeToCallAgentEvents()};e?.callClient.on("callAgentCreated",r)}dispose(){}subscribeToCallAgentEvents(){try{this._callAgent?.on("callsUpdated",e=>{[...e.added,...e.removed].forEach(i=>{this.updateLocalParticipantIdMap(i),i.on("idChanged",()=>{this.updateLocalParticipantIdMap(i)})})}),this._callAgent?.on("incomingCall",e=>{let i=e.incomingCall;i.on("callEnded",r=>{try{this._incommingCallIdMap[i.id]=JSON.stringify(r.callEndReason)}catch{this._incommingCallIdMap[i.id]="callEnd reason unknown"}});try{this._incommingCallIdMap[i.id]=JSON.stringify(e.incomingCall.callerInfo.identifier?.kind)}catch{this._incommingCallIdMap[i.id]="identifier kind unknown"}})}catch{this._logger.info("failed to subscribe to call agent events, due to non initialized call agent")}}updateLocalParticipantIdMap(e){try{let i=this._localParticipantIdMap[e.tsCall.participantId]?.callIds.filter(h=>h!==e.tsCall.callId).concat([e.tsCall.callId])??[e.tsCall.callId],r=[],o=[],l=e.callEndReason?JSON.stringify(e.callEndReason):e.state,d=e.state;this._localParticipantIdMap[e.tsCall.participantId]?.callEndReasons?(this._localParticipantIdMap[e.tsCall.participantId].callEndReasons.slice(-1)[0]!==l?(this._localParticipantIdMap[e.tsCall.participantId].callEndReasons.push(l),r=this._localParticipantIdMap[e.tsCall.participantId].callEndReasons):r=this._localParticipantIdMap[e.tsCall.participantId].callEndReasons,this._localParticipantIdMap[e.tsCall.participantId].stateTransitions.slice(-1)[0]!==d?(this._localParticipantIdMap[e.tsCall.participantId].stateTransitions.push(d),o=this._localParticipantIdMap[e.tsCall.participantId].stateTransitions):o=this._localParticipantIdMap[e.tsCall.participantId].stateTransitions):(r=[l],o=[e.state]),this._localParticipantIdMap[e.tsCall.participantId]={callIds:i,callEndReasons:r,stateTransitions:o},this._logger.info(`localParticipantIdMap: ${JSON.stringify(this._localParticipantIdMap)}`),e.on("stateChanged",()=>{e.state==="Connected"&&(this._lastLocalParticipantId=e.tsCall.participantId,this._logger.info(`last patricipant id: ${this._lastLocalParticipantId}`)),this._localParticipantIdMap[e.tsCall.participantId].stateTransitions.slice(-1)[0]!==e.state&&this.localParticipantIdMap[e.tsCall.participantId].stateTransitions.push(e.state)})}catch(i){this._logger.error(`exception occured while updating localParticipantId map: ${i}`)}}}class $C{get isCallClientActiveInAnotherTab(){return this._isCallClientActiveInAnotherTab}get isAnotherCallClientActiveInSameTab(){return this._isAnotherCallClientActiveInSameTab}constructor(e){this._eventEmitter=e,this._tabGroupId=$C.tabId,this._isCallClientActiveInAnotherTab=!1,this._isAnotherCallClientActiveInSameTab=!1,this._areThereMultipleTabs=null,this._manyCallClientInSameTab=null,this._isTabFirstLoadFlag=!0,this._intervalId=void 0,this._timeoutId=void 0,this._channel=new BroadcastChannel(wt().debugInfo.broadcastChannelName)}initialize(e,i,r){this._callClient=e,this._logger=i,this._telemetryLogManager=r;const o=wt().debugInfo.tabsBroadcastDelay,l=wt().debugInfo.tabsUpdateDelay;this.tabsCheck(),this._channel.postMessage({action:uP.ping,tabId:$C.tabId,groupId:this._tabGroupId}),this._timeoutId=setTimeout(()=>{this._areThereMultipleTabs&&(this._isCallClientActiveInAnotherTab=this._areThereMultipleTabs),this._manyCallClientInSameTab&&(this._isAnotherCallClientActiveInSameTab=this._manyCallClientInSameTab),this.sendTabUpdateEvent(),this._isTabFirstLoadFlag=!1},10),this._intervalId=setInterval(()=>{this._areThereMultipleTabs=null,this._manyCallClientInSameTab=null,this._channel.postMessage({action:uP.ping,tabId:$C.tabId,groupId:this._tabGroupId}),setTimeout(()=>{this._areThereMultipleTabs===null&&(this._areThereMultipleTabs=!1),this._manyCallClientInSameTab===null&&(this._manyCallClientInSameTab=!1),this.tabsUpdate()},l)},o)}tabsCheck(){this._channel.addEventListener("message",e=>{e.data?.action!==uP.ping&&e.data?.action!==uP.pong||(e.data?.action===uP.ping&&($C.tabId===e.data.tabId?this._manyCallClientInSameTab=!0:$C.tabId!==e.data.tabId&&(this._areThereMultipleTabs=!0),this._channel.postMessage({action:uP.pong,tabId:$C.tabId,groupId:this._tabGroupId})),e.data?.action===uP.pong&&($C.tabId===e.data.tabId?this._manyCallClientInSameTab=!0:$C.tabId!==e.data.tabId&&(this._areThereMultipleTabs=!0),this._tabGroupId!==e.data.groupId&&(this._tabGroupId=e.data.groupId)),this.tabsUpdate())})}sendTabUpdateToCallEvent(){this._callClient.callAgent?._calls?.forEach(e=>e?.stats?.recordEvent({name:vT.sdk_active_in_another_tab,callId:e.id,localParticipantId:e.tsCall.participantId,data:{tabId:$C.tabId,tabGroupId:this._tabGroupId,isCallClientActiveInAnotherTab:this._isCallClientActiveInAnotherTab,isAnotherCallClientActiveInSameTab:this._isAnotherCallClientActiveInSameTab}}))}sendTabUpdateEvent(){const e={tabId:$C.tabId,tabGroupId:this._tabGroupId,isCallClientActiveInAnotherTab:this._isCallClientActiveInAnotherTab,isAnotherCallClientActiveInSameTab:this._isAnotherCallClientActiveInSameTab};this._telemetryLogManager.sendEvent({name:vi.acs_calling_tab_events,tenant:Wr,properties:e})}tabsUpdate(){this._isTabFirstLoadFlag||this._manyCallClientInSameTab===null||this._areThereMultipleTabs===null||this._isCallClientActiveInAnotherTab===this._areThereMultipleTabs&&this._isAnotherCallClientActiveInSameTab===this._manyCallClientInSameTab||(this._isAnotherCallClientActiveInSameTab!==this._manyCallClientInSameTab&&(this._logger.log(`isAnotherCallClientActiveInSameTab changed from ${this._isAnotherCallClientActiveInSameTab} to ${this._manyCallClientInSameTab}`),this._isAnotherCallClientActiveInSameTab=this._manyCallClientInSameTab,this._eventEmitter.emit("isAnotherCallClientActiveInSameTabChanged")),this._isCallClientActiveInAnotherTab!==this._areThereMultipleTabs&&(this._logger.log(`isCallClientActiveInAnotherTab changed from ${this._isCallClientActiveInAnotherTab} to ${this._areThereMultipleTabs}`),this._isCallClientActiveInAnotherTab=this._areThereMultipleTabs,this._eventEmitter.emit("isCallClientActiveInAnotherTabChanged")),this.sendTabUpdateEvent(),this.sendTabUpdateToCallEvent())}dispose(){this._channel.close(),this._timeoutId!==void 0&&clearTimeout(this._timeoutId),this._intervalId!==void 0&&clearInterval(this._intervalId)}}$C.tabId=ln(),function(t){t[t.Good=1]="Good",t[t.Poor=2]="Poor",t[t.Bad=3]="Bad"}(ah||(ah={}));const Zhe="networkReconnect",Xhe="networkReceiveQuality",epe="networkSendQuality",tpe="networkRelaysNotReachable",ipe="noNetwork",S2e="noSpeakerDevicesEnumerated",b2e="noMicrophoneDevicesEnumerated",T2e="microphoneNotFunctioning",npe="microphoneMuteUnexpectedly",C2e="cameraStoppedUnexpectedly",_2e="capturerStoppedUnexpectedly",E2e="speakingWhileMicrophoneIsMuted",A2e="cameraFreeze",ape="cameraStartFailed",I2e="capturerStartFailed",w2e="cameraStartTimedOut",k2e="screenshareRecordingDisabled",R2e="microphonePermissionDenied",M2e="cameraPermissionDenied";function P2e(t,e){return e=="serverConnection"?t?"Good":"Bad":typeof t=="boolean"?t?"Bad":"Good":ah[t]}class D2t extends Bu{constructor(e){super(e),this._impl=new L2t}get name(){return this._sendFeatureUsage("name",Je.getter),"Diagnostics"}get network(){return this._sendFeatureUsage("network",Je.getter),this._impl.network}get media(){return this._sendFeatureUsage("media",Je.getter),this._impl.media}get remote(){return this._sendFeatureUsage("remote",Je.getter),this._impl.remote}initialize(e,i){this._logger=i,this._telemetryLogManager=e.telemetryLogManager,this._call=e.call,this._impl.initialize(e,i),this._sendFeatureUsage("initialize",Je.initialize)}_sendFeatureUsage(e,i){Pc({callId:this._call.id,localParticipantId:this._call.tsCall.participantId,featureName:"Diagnostics",featureType:"Call",initializationType:"OnFeatureAccess",featureDetails:{name:e,step:i}},this._telemetryLogManager,this._logger)}dispose(){this._sendFeatureUsage("dispose",Je.attempt),this.disposed?this._sendFeatureUsage("dispose",Je.failure):(this._impl.dispose(),super.dispose(),this._sendFeatureUsage("dispose",Je.success))}}class L2t{get network(){return this._network===void 0&&(this._network=new O2t(this._internalApi,this._logger),this._network.bindToTsCallQualityChangedEvent()),this._network}get media(){return this._media===void 0&&(this._media=new N2t(this._internalApi,this._logger),this._media.bindToTsCallQualityChangedEvent()),this._media}get remote(){return this._remote===void 0&&(this._remote=new x2t(this._internalApi,this._logger),this._remote.bindToTsCallPublishedStatesChangedEvent()),this._remote}initialize(e,i){this._internalApi=e,this._logger=i}dispose(){}}class rpe{constructor(e,i,r){this._name=e,this.internalApi=i,this.logger=r,this._tsUfdUnknownValue=0,this.tsToAcsNetworkQualityEventTypeMap={5:Zhe,2:Xhe,1:epe,32:tpe,37:ipe},this.tsToAcsMediaQualityEventTypeMap={44:S2e,43:b2e,9:T2e,25:npe,27:E2e,45:A2e,33:ape,34:w2e,55:k2e,26:R2e,47:M2e},this.tsQualityToAcsQualityMap={1:ah.Good,2:ah.Poor,3:ah.Bad},this.tsQualityToAcsBooleanMap={3:!0,1:!1},this.eventEmitter=new $c.EventEmitter}bindToTsCallQualityChangedEvent(){this.internalApi.tsCall.on("callQualityChanged",e=>{try{let i;if(this._name==="NetworkDiagnostics"?i=this.mapTsNetworkQualityEventType(e.type):this._name==="MediaDiagnostics"&&(i=this.mapTsMediaQualityEventType(e.type,e.mediaType)),i){if(e.value===this._tsUfdUnknownValue)return;let r,o;if(this._name==="NetworkDiagnostics"){const{mappedQualityLevel:p,valueType:g}=this.mapTsNetworkQualityLevel(i,e.value);r=p,this.setLatestDiagnostic(i,{value:r,valueType:g})}else if(this._name==="MediaDiagnostics"){const{mappedQualityLevel:p,valueType:g}=this.mapTsMediaQualityLevel(i,e.value);r=p,this.setLatestDiagnostic(i,{value:r,valueType:g})}if(typeof r!="number"||r!==ah.Good&&r!==ah.Poor&&r!==ah.Bad){if(typeof r!="boolean")throw this.logger.error(`Incorrect valueType mapped for diagnostic='${i}', value='${r}'`),new Oe({defaultError:we.FEATURES.DIAGNOSTICS.INCORRECT_VALUETYPE_MAPPED});o="DiagnosticFlag"}else o="DiagnosticQuality";const l={diagnostic:i,value:r,valueType:o};this.logger.log(`Call diagnostic changed, diagnostic='${l.diagnostic}', value='${l.value}'`);const d=l.valueType==="DiagnosticFlag"&&l.value===!0,h=l.valueType==="DiagnosticQuality"&&(l.value===ah.Bad||l.value===ah.Poor);(d||h)&&this.logger.warn(`Call diagnostic error raised!, diagnostic='${l.diagnostic}', value='${l.value}', value type='${l.valueType}'`),this.sendDiagnosticEvent({name:"UserFacingDiagnostics",callId:this.internalApi.tsCall.callId,localParticipantId:this.internalApi.tsCall.participantId,remoteParticipantId:"",diagnostic:l.diagnostic,valueText:P2e(l.value),valueType:l.valueType,correlationId:""}),this.eventEmitter.emit("diagnosticChanged",l)}}catch(i){this.logger.error(`${i?.message})`)}})}mapTsNetworkQualityEventType(e){return this.tsToAcsNetworkQualityEventTypeMap[e]}mapTsNetworkQualityLevel(e,i){let r,o;switch(e){case Zhe:case Xhe:case epe:o="DiagnosticQuality",r=this.tsQualityToAcsQualityMap[i];break;case tpe:case ipe:o="DiagnosticFlag",r=this.tsQualityToAcsBooleanMap[i]}return{mappedQualityLevel:r,valueType:o}}mapTsMediaQualityEventType(e,i){const r=this.tsToAcsMediaQualityEventTypeMap[e];if(r===npe)switch(i){case 1:return C2e;case 2:return _2e}return r===ape&&i===2?I2e:r}mapTsMediaQualityLevel(e,i){let r,o;switch(e){case S2e:case b2e:case T2e:case npe:case E2e:case A2e:case ape:case w2e:case k2e:case R2e:case M2e:case C2e:case _2e:case I2e:o="DiagnosticFlag",r=this.tsQualityToAcsBooleanMap[i]}return{mappedQualityLevel:r,valueType:o}}sendDiagnosticEvent(e){this.internalApi.telemetryLogManager.sendEvent({name:vi.acs_calling_call_stats_and_ufds,tenant:Wr,properties:{name:e.name,callId:e.callId,localParticipantId:e.localParticipantId,remoteParticipantId:e.remoteParticipantId,diagnostic:e.diagnostic,valueText:e.valueText,valueType:e.valueType,correlationId:e.correlationId}})}}class O2t extends rpe{constructor(e,i){super("NetworkDiagnostics",e,i.createChild(()=>`[UserFacingDiagnosticsFeature:NetworkDiagnostics:Call(id='${e.tsCall.callId}', state='${e.tsCall.state}')]`)),this.latestNetworkDiagnostics=new Map}setLatestDiagnostic(e,i){this.latestNetworkDiagnostics.set(e,i)}on(e,i){if(e!=="diagnosticChanged")throw new Oe({defaultError:we.FEATURES.DIAGNOSTICS.EVENT_SUBSCRIBE,defaultErrorMessageArgs:[e]});this.eventEmitter.on(e,i)}off(e,i){if(e!=="diagnosticChanged")throw new Oe({defaultError:we.FEATURES.DIAGNOSTICS.EVENT_UNSUBSCRIBE,defaultErrorMessageArgs:[e]});this.eventEmitter.off(e,i)}getLatest(){try{return oBe(this.latestNetworkDiagnostics)}catch{return this.logger.error("Failed to get latest network diagnostics"),{}}}}class N2t extends rpe{constructor(e,i){super("MediaDiagnostics",e,i.createChild(()=>`[UserFacingDiagnosticsFeature:MediaDiagnostics:Call(id='${e.tsCall.callId}', state='${e.tsCall.state}')]`)),this.latestMediaDiagnostics=new Map}setLatestDiagnostic(e,i){this.latestMediaDiagnostics.set(e,i)}on(e,i){if(e!=="diagnosticChanged")throw new Oe({defaultError:we.FEATURES.DIAGNOSTICS.EVENT_SUBSCRIBE,defaultErrorMessageArgs:[e]});this.eventEmitter.on(e,i)}off(e,i){if(e!=="diagnosticChanged")throw new Oe({defaultError:we.FEATURES.DIAGNOSTICS.EVENT_UNSUBSCRIBE,defaultErrorMessageArgs:[e]});this.eventEmitter.off(e,i)}getLatest(){try{return oBe(this.latestMediaDiagnostics)}catch{return this.logger.error("Failed to get latest media diagnostics"),{}}}}class x2t extends rpe{constructor(e,i){super("RemoteDiagnostics",e,i.createChild(()=>`[UserFacingDiagnosticsFeature:RemoteDiagnosticsiagnostics:Call(id='${e.tsCall.callId}', state='${e.tsCall.state}')]`)),this._remoteDiagnosticCorrelationIdMap=new Map,this._isSendingRemoteDiagnostics=!1,this.tsQualityStringToEnumMap={NetworkSendQuality:1,NetworkRecvQuality:2,NetworkDelay:3,NetworkBandwidthLow:4,NetworkReconnect:5,NetworkPacketLoss:6,NetworkJitter:7,NetworkRateMatching:8,DeviceCaptureNotFunctioning:9,DeviceRenderNotFunctioning:10,DeviceRenderGlitches:11,DeviceLowSNR:12,DeviceLowSpeechLevel:13,DeviceClipping:14,DeviceEcho:15,DeviceNearEndToEchoRatio:16,DeviceHalfDuplexAec:17,DeviceMultipleEndpoints:18,DeviceHowling:19,DeviceRenderZeroVolume:20,DeviceRenderMute:21,NetworkSendCatastrophic:22,NetworkRecvCatastrophic:23,CpuInsufficient:24,DeviceCaptureMute:25,DeviceCaptureNotMuteButSilent:26,DeviceSpeakWhileMuted:27,VideoVbssRendered:28,NetworkEthernetInterfaceUsed:29,NetworkWlanInterfaceUsed:30,NetworkWwanInterfaceUsed:31,NetworkRelaysNotReachable:32,VideoCapturerDeviceStartFailed:33,VideoCapturerDeviceStartTimedOut:34,VideoCapturerDeviceStartFailureLackSystemRes:35,VideoCapturerDeviceStartFailureMFResConflict:36,NoNetwork:37,NetworkNotWorking:38,DeviceCaptureNotFunctioningDeviceInUse:39,DeviceRenderNotFunctioningDeviceInUse:40,DeviceCaptureNotFunctioningAudioSrvNotRunning:41,DeviceRenderNotFunctioningAudioSrvNotRunning:42,ZeroCaptureDevicesEnumerated:43,ZeroRenderDevicesEnumerated:44,VideoCaptureDeviceFreeze:45,AudioCapturePermissionDenied:46,VideoCapturePermissionDenied:47,VideoCaptureFreezeRecovered:48,DeviceRenderHowling:49,LowFarEndInput:50,ImageRenderingQuality:51,RemoteNetworkConnectivityIssue:52,PresentationAudioLoopbackDeviceState:53,AudioCaptureUltrasoundDetected:54,ScreenshareRecordingDisabled:55,MultichannelAudioBandwidth:56,MusicModeNotAvailable:57,MusicModeSupported:58,AudioCaptureMusicDetectedWithHighNS:59,AudioCaptureMusicDetectedWithLowNS:60,CameraLighting:61,DeviceCaptureVoiceActive:62,AudioLoopbackDeviceReady:63,NoRequiredVideoCodecs:64,SpatialAudioMUCHUnavailable:65,SpeechOverlapFailedInterruptionDetected:66,BackgroundSpeechSuppressed:67,BackgroundLoudSpeechSuppressed:68,ActiveSpeechDetected:69,DeviceCaptureNotFunctioningBluetoothMidCallFail:70,DeviceCaptureNotFunctioningWebcamMicMidCallFail:71,DeviceCaptureNotMuteButSilentDongle:72,DeviceRenderNotFunctioningBluetoothMidCallFail:73,ZeroCaptureDevicesEnumeratedRDP:74,ZeroRenderDevicesEnumeratedRDP:75,WrongCaptureDevicesUsedRDP:76,WrongRenderDevicesUsedRDP:77,NetworkStatusIndicator:78,LoopbackDeviceRenderNotFunctioning:79,AudioMixMUCHUnavailable:80,HighSystemMemoryUsage:81},this.tsMediaStringToEnumMap={Audio:0,Video:1,ScreenShare:2,Data:3},this.tsQualityLevelStringToEnumMap={Good:1,Poor:2,Bad:3,Unknown:0},this._latestRemoteDiagnostics={diagnostics:[]}}bindToTsCallPublishedStatesChangedEvent(){this.internalApi.tsCall.on("publishedStatesChanged",async e=>{const i=[],r=new Set;e.typeStates.forEach(o=>{const l=(h,p)=>{const g=this.getRemoteDiagnosticIndex(h);g>-1&&this._latestRemoteDiagnostics.diagnostics[g].value!==h.value?(h={...h,remoteParticipant:this._latestRemoteDiagnostics.diagnostics[g].remoteParticipant},this._latestRemoteDiagnostics.diagnostics[g]=h,i.push(h)):g!==-1||this.isGoodServerRemoteDiagnostic(h)||(h={...h,remoteParticipant:this.internalApi.call.remoteParticipants.find(f=>zr(f.identifier)===p)},this._latestRemoteDiagnostics.diagnostics.push(h),i.push(h))},d=(h,p)=>{const g=this.createClientRemoteDiagnostic(p.id,h);for(const f of g)l(f,p.id)};o.type==="serverMediaUfd"&&(this.logger.debug(`Remote diagnostics changed, typeState='${JSON.stringify(o)}'`),o.participantStates.forEach(h=>{try{if(h.id!==this.internalApi.callAgent.getUserMri()){const p=this.createServerRemoteDiagnostic(h.id,h.publishedState?.content);l(p,h.id),r.add(h.id)}}catch(p){this.logger.error(`Error processing remote diagnostic: ${JSON.stringify(h)}, error: ${p?.message}`)}})),o.type==="clientMediaUfd"&&(this.logger.debug(`Client remote diagnostics changed, typeState='${JSON.stringify(o)}'`),o.participantStates.forEach(h=>{try{if(h.id!==this.internalApi.callAgent.getUserMri()&&h.endpoints)for(const p of h.endpoints)d(p,h)}catch(p){this.logger.error(`Error processing client remote diagnostic: ${JSON.stringify(h)}, error: ${p?.message}`)}}))}),this.removeRemoteUserDiagnostics(r),i.length>0&&(this.sendRemoteDiagnosticsTelemetry(i),this.eventEmitter.emit("diagnosticChanged",{diagnostics:i}))}),this.internalApi.tsCall.on("participantCountsUpdated",()=>{this._isSendingRemoteDiagnostics&&this.enableSendingRemoteDiagnosticsBasedOnRemoteAcsUserCount()})}setLatestDiagnostic(e,i){}get isSendingDiagnosticsEnabled(){return this._isSendingRemoteDiagnostics}startSendingDiagnostics(){this._isSendingRemoteDiagnostics=!0,this.enableSendingRemoteDiagnosticsBasedOnRemoteAcsUserCount()}stopSendingDiagnostics(){this._isSendingRemoteDiagnostics=!1,this.internalApi.tsCall.enableRemoteUFDs?.(!1),this.logger.debug("Disabled client remote diagnostics")}getLatest(){return this._latestRemoteDiagnostics}on(e,i){if(e!=="diagnosticChanged")throw new Oe({defaultError:we.FEATURES.DIAGNOSTICS.EVENT_SUBSCRIBE,defaultErrorMessageArgs:[e]});this.eventEmitter.on(e,i)}off(e,i){if(e!=="diagnosticChanged")throw new Oe({defaultError:we.FEATURES.DIAGNOSTICS.EVENT_UNSUBSCRIBE,defaultErrorMessageArgs:[e]});this.eventEmitter.off(e,i)}enableSendingRemoteDiagnosticsBasedOnRemoteAcsUserCount(){const e=this.internalApi.call.remoteParticipants.filter(i=>i.identifier.kind==="communicationUser").length;e>0&&this._isSendingRemoteDiagnostics?(this.logger.debug(`Enabling remote client UFDs, totalRemoteAcsParticipants=${e}`),this.internalApi.tsCall.enableRemoteUFDs?.(!0)):e===0&&(this.logger.debug(`Disabling remote client UFDs, totalRemoteAcsParticipants=${e}`),this.internalApi.tsCall.enableRemoteUFDs?.(!1))}isGoodServerRemoteDiagnostic(e){return e.diagnostic==="serverConnection"&&e.value===!0}createServerRemoteDiagnostic(e,i){if(!i)throw new Error("Content is missing in remote diagnostic");return typeof i=="string"&&(i=JSON.parse(i)),{participantId:i.participantId,rawId:e,diagnostic:i.type,value:typeof i.value=="string"&&i.value.toLowerCase()==="good",valueType:"DiagnosticFlag"}}mergeOrIgnoreClientDiagnostics(e){const i=wt().calling.remoteDiagnostic.sourceEvents.indexOf(e);if(i>-1){const r=wt().calling.remoteDiagnostic.exposedEvents[i];return this.logger.debug(`Merging ${wt().calling.remoteDiagnostic.sourceEvents[i]} to ${r}`),r}return e}createClientRemoteDiagnostic(e,i){if(!i.publishedState.content)throw new Error("Content is missing in client remote diagnostic");const r=[],o=i.publishedState.content;for(const l of o){const d=l.type;let h=this.mapTsNetworkQualityEventType(this.tsQualityStringToEnumMap[d]);const p=l.value;let g;if(h)g=this.mapTsNetworkQualityLevel(h,this.tsQualityLevelStringToEnumMap[p]);else{const T=l.mediaType;h=this.mapTsMediaQualityEventType(this.tsQualityStringToEnumMap[d],this.tsMediaStringToEnumMap[T]),g=this.mapTsMediaQualityLevel(h,this.tsQualityLevelStringToEnumMap[p])}const f=this.mergeOrIgnoreClientDiagnostics(h);if(f==="")continue;f!==h&&(h=f);const y={participantId:i.id,rawId:e,diagnostic:h,value:g.mappedQualityLevel,valueType:g.valueType};r.push(y)}return r}getRemoteDiagnosticIndex(e){return this._latestRemoteDiagnostics.diagnostics.findIndex(i=>i.participantId===e.participantId&&i.diagnostic===e.diagnostic)}removeRemoteUserDiagnostics(e){this._latestRemoteDiagnostics.diagnostics=this._latestRemoteDiagnostics.diagnostics.filter(i=>{const r=e.has(i.rawId);return r||this._remoteDiagnosticCorrelationIdMap.forEach((o,l)=>{l.endsWith(`_${i.participantId}`)&&this._remoteDiagnosticCorrelationIdMap.delete(l)}),r})}sendRemoteDiagnosticsTelemetry(e){this.logger.debug(`Sending remote diagnostics telemetry, number of diagnostics=${e.length}`),e.forEach(i=>{const r=`${i.diagnostic}_${i.participantId}`;this._remoteDiagnosticCorrelationIdMap.has(r)||this._remoteDiagnosticCorrelationIdMap.set(r,ln()),this.sendDiagnosticEvent({name:"RemoteClientDiagnostics",callId:this.internalApi.tsCall.callId,localParticipantId:this.internalApi.tsCall.participantId,remoteParticipantId:i.participantId,diagnostic:i.diagnostic,valueText:P2e(i.value,i.diagnostic),valueType:i.valueType,correlationId:this._remoteDiagnosticCorrelationIdMap.get(r)??""}),(i.valueType==="DiagnosticFlag"&&i.value===!0||i.valueType==="DiagnosticQuality"&&i.value===ah.Good)&&this._remoteDiagnosticCorrelationIdMap.set(r,ln())})}}class B2t extends Bu{constructor(e){super(e),this._impl=new D2e(this.eventEmitter)}get name(){return this._sendFeatureUsage("name",Je.getter),"DominantSpeakers"}initialize(e,i){this._logger=i,this._telemetryLogManager=e.telemetryLogManager,this._call=e.call,this._impl.initialize(e.tsCall,e.callAgent,e.telemetryLogManager,i),this._sendFeatureUsage("initialize",Je.initialize)}get dominantSpeakers(){return this._sendFeatureUsage("dominantSpeakers",Je.getter),this._impl.dominantSpeakers}on(e,i){this._sendFeatureUsage("dominantSpeakersChanged",Je.subscribe),this.eventEmitter.on(e,i)}off(e,i){this._sendFeatureUsage("dominantSpeakersChanged",Je.unsubscribe),this.eventEmitter.off(e,i)}_sendFeatureUsage(e,i){Pc({callId:this._call.id,localParticipantId:this._call.tsCall.participantId,featureName:"DominantSpeakers",featureType:"Call",initializationType:"OnFeatureAccess",featureDetails:{name:e,step:i}},this._telemetryLogManager,this._logger)}dispose(){this._sendFeatureUsage("dispose",Je.attempt),this.disposed?this._sendFeatureUsage("dispose",Je.failure):(this._impl.dispose(),super.dispose(),this._sendFeatureUsage("dispose",Je.success))}}class D2e{constructor(e){this._eventEmitter=e,this.localDominantList=[]}initialize(e,i,r,o,l=!1){this._logger=o.createChild(()=>`DominantSpeakersFeature${l?"Internal":""}::Call(id='${e.callId}')`),this._tsCall=e,this.localDominantList=this._tsCall.dominantSpeakerInfo?.speakerList||[],this._tsCallChangedListener=this._tsCall.changed(()=>{let d=!1;if(this.localDominantList.length!=this._tsCall.dominantSpeakerInfo.speakerList.length)d=!0;else for(let h in this._tsCall.dominantSpeakerInfo.speakerList)if(this._tsCall.dominantSpeakerInfo.speakerList[h]!==this.localDominantList[h]){d=!0;break}d&&(this._logger.info("Dominant speakers list change detected"),this.localDominantList=this._tsCall.dominantSpeakerInfo.speakerList,this._eventEmitter.emit("dominantSpeakersChanged"))})}on(e,i){this._eventEmitter.on(e,i)}off(e,i){this._eventEmitter.off(e,i)}get dominantSpeakers(){let e=Array();return this._tsCall.dominantSpeakerInfo.speakerList.map(i=>{e.push(Sl(i))}),{speakersList:e,timestamp:this._tsCall.dominantSpeakerInfo.timestamp||new Date}}dispose(){this._eventEmitter.removeAllListeners(),this._tsCallChangedListener?.dispose()}}class qf extends $c.EventEmitter{constructor(e,i){super(),this._options={enableLogOn:!0,enableLogOff:!0,enableLogOnce:!0,enableLogEmit:!0},this._logger=e.createChild("CallingEventEmitter"),i&&(this._options=i)}on(e,i){return this._options.enableLogOn!==!1&&this._logger.info(`event:subscribe to ${e.toString()}`),super.on(e,i)}once(e,i){return this._options.enableLogOnce!==!1&&this._logger.info(`event:subscribe once to ${e.toString()}`),super.once(e,i)}off(e,i){return this._options.enableLogOff!==!1&&this._logger.info(`event:unsubscribed ${e.toString()}`),super.off(e,i)}emit(e,...i){try{return this._options.enableLogEmit!==!1&&this._logger.info(`event:emit ${e.toString()}`),super.emit(e,...i)}catch{return this._logger.warn(`Application threw an error while it handled the ${e.toString()} event`),!1}}}function L2e(){return{audio:{send:{},receive:{}},video:{send:{},receive:{}},screenShare:{send:{},receive:{}},dataChannel:{},transports:{},info:{}}}function O2e(t){let e=t.length>0?t[0]:0;return t.forEach(i=>{i>e&&(e=i)}),e}function N2e(t){let e=t.length>0?t[0]:0;return t.forEach(i=>{i<e&&(e=i)}),e}function EQ(t){let e=0,i=0;return t.forEach(r=>{const o=r-i,l=e+o;i=l-e-o,e=l}),e}const AQ=L2e;class x2e{constructor(e){this._metricsProperties=e,this._originalValues={},this._aggregateValues={},this._events=[],this._currentValues={}}addStats(e,i){const r=this._metricsProperties[e];if(r!==void 0&&r.skip!==!0){if(r.events){const o=r.output_key??e;i!==this._currentValues[o]&&(this._currentValues[o]=i,this._events.push({name:o,value:i,timestamp:Date.now()}))}else{let o=this._originalValues[e];o===void 0&&(o={raw:[],beginTime:Date.now()},this._originalValues[e]=o),o.raw.push(i)}return i}}aggregate(){for(const[e,i]of Object.entries(this._originalValues)){const r=this._metricsProperties[e],o=r.output_key??e;let l=this._aggregateValues[o];l===void 0&&(l={raw:[],timestamp:new Date(i.beginTime)},r.aggregable&&(l.aggregation={count:[],sum:[],max:[],min:[]}),this._aggregateValues[o]=l);const d=i.raw;let h=d;if(r.aggregable&&l.aggregation){const p=d.filter(g=>typeof g=="number"&&!isNaN(g));l.aggregation.count.push(p.length),l.aggregation.sum.push(EQ(p)),l.aggregation.max.push(O2e(p)),l.aggregation.min.push(N2e(p)),h=p}r.raw_data_reduction&&h.length>0&&(l.reduced=l.reduced||[],l.reduced.push(h[h.length-1])),h.forEach(p=>l.raw.push(p))}this._originalValues={}}popAggregates(){const e=this._aggregateValues;return this._aggregateValues={},e}popEvents(){const e=this._events;return this._events=[],e}}class F2t{constructor(e,i){if(this._aggregationInterval=0,this._dataPointsPerAggregation=0,this._disposed=!1,this._calculators=AQ(),this._isActive=!1,i.aggregationInterval<1)throw new Error("invalid aggregationInterval value range");if(i.dataPointsPerAggregation<1)throw new Error("invalid dataPointsPerAggregation value range");this._metricsProperties=i.metricsPropertics,this._logger=e.createChild("TelemetryCollector"),this._eventEmitter=new qf(this._logger,{enableLogEmit:!1}),this._callStateChanged=ug(),this._aggregationInterval=i.aggregationInterval,this._dataPointsPerAggregation=i.dataPointsPerAggregation,this._run()}on(e,i){this._eventEmitter.on(e,i)}off(e,i){this._eventEmitter.off(e,i)}dispose(){this._disposed||(this._disposed=!0,this._callStateChanged.resolve(!1),this._eventEmitter.removeAllListeners(),this._mediaStatsSource?.removeSink(this))}get source(){return this._mediaStatsSource}set source(e){this._mediaStatsSource=e}onReport(e){this._processMediaStatsReport(e)}onAdded(e){this._isActive!==e&&(this._isActive=e,this._callStateChanged.resolve(e))}onRemoved(){this.dispose()}pause(){this._isActive&&(this._isActive=!1,this._callStateChanged.resolve(!1))}resume(){this._isActive||(this._isActive=!0,this._callStateChanged.resolve(!0))}stop(){this.dispose()}_processMediaStatsReport(e){try{const i=[[e.audio.send,this._calculators.audio.send,this._metricsProperties.audio.send,"send"],[e.audio.receive,this._calculators.audio.receive,this._metricsProperties.audio.receive,"recv"],[e.video.send,this._calculators.video.send,this._metricsProperties.video.send,"send"],[e.video.receive,this._calculators.video.receive,this._metricsProperties.video.receive,"recv"],[e.screenShare.send,this._calculators.screenShare.send,this._metricsProperties.screenShare.send,"send"],[e.screenShare.receive,this._calculators.screenShare.receive,this._metricsProperties.screenShare.receive,"recv"],[e.dataChannel,this._calculators.dataChannel,this._metricsProperties.dataChannel,""],[e.transports,this._calculators.transports,this._metricsProperties.transports,""],[e.info,this._calculators.info,this._metricsProperties.info,""]];for(const[r,o,l,d]of i){const h=[],p=Object.keys(o);Object.keys(r).forEach(g=>{const f=r[g],y=f.id;h.push(y),o[y]===void 0&&(o[y]=new x2e(l));const T=(C,E)=>o[y].addStats(C,E);if(Object.keys(f).forEach(C=>T(C,f[C])),d=="send"||d=="recv"){const C=f.transportId;if(C!==void 0){const E=e.transports[C];E.rtt!==void 0&&T("pairRttInMs",E.rttInMs),E.availableIncomingBitrate!==void 0&&d=="recv"&&T("availableBitrate",E.availableIncomingBitrate),E.availableOutgoingBitrate!==void 0&&d=="send"&&T("availableBitrate",E.availableOutgoingBitrate)}}}),p.filter(g=>!h.includes(g)).forEach(g=>{delete o[g]})}}catch(i){this._logger.error(i)}}async _run(){let e=0;const i=()=>{if(e===0)return;const o={audio:{send:{},receive:{}},video:{send:{},receive:{}},screenShare:{send:{},receive:{}},dataChannel:{},transports:{},info:{}},l=[[o.audio.send,this._calculators.audio.send],[o.audio.receive,this._calculators.audio.receive],[o.video.send,this._calculators.video.send],[o.video.receive,this._calculators.video.receive],[o.screenShare.send,this._calculators.screenShare.send],[o.screenShare.receive,this._calculators.screenShare.receive],[o.dataChannel,this._calculators.dataChannel],[o.transports,this._calculators.transports],[o.info,this._calculators.info]];for(const[d,h]of l)for(const[p,g]of Object.entries(h))d[p]={id:p,...g.popAggregates(),events:g.popEvents()};this._eventEmitter.emit("data",o),e=0};let r=1e3*this._aggregationInterval;for(;!this._disposed;){const o=[this._calculators.audio.send,this._calculators.audio.receive,this._calculators.video.send,this._calculators.video.receive,this._calculators.screenShare.send,this._calculators.screenShare.receive,this._calculators.dataChannel,this._calculators.info];if(this._isActive){r>0&&await cP(()=>this._callStateChanged.promise,r).catch(h=>{});const l=Date.now();for(const h of o)for(const[,p]of Object.entries(h))p.aggregate();e++,e===this._dataPointsPerAggregation&&i();const d=Date.now();r=l+1e3*this._aggregationInterval-d}else i(),this._calculators=AQ(),await this._callStateChanged.promise.catch(l=>{}),r=1e3*this._aggregationInterval;this._callStateChanged.isPending()||(this._callStateChanged=ug())}i()}}function IQ(t){const e=[];return t.sort((i,r)=>i.id>r.id?1:i.id<r.id?-1:0),t.forEach(i=>{const r=/^([^.]+)\.?([^.]+)?$/.exec(i.id);if(r&&r[2]){i.id=dn.toString(r[2]);const o=dn.toString(r[1]);if(e.length>0&&e[e.length-1].id===o){const l=e[e.length-1].altLayouts??[];l.push(i),e[e.length-1].altLayouts=l}else e.push(i)}else e.push(i)}),e}class U2t{constructor(e,i){if(this._aggregationInterval=0,this._dataPointsPerAggregation=0,this._disposed=!1,this._calculators=AQ(),this._isActive=!1,i.aggregationInterval<1)throw new Oe({defaultError:we.FEATURES.MEDIA_STATS.INVALID_AGGREGATION_INTERVAL_RANGE});if(i.dataPointsPerAggregation<1)throw new Oe({defaultError:we.FEATURES.MEDIA_STATS.INVALID_DATAPOINTS_AGGREGATION_RANGE});this._metricsProperties=i.metricsPropertics,this._logger=e.createChild("MediaStatsCollector"),this._eventEmitter=new qf(this._logger,{enableLogEmit:!1}),this._callStateChanged=ug(),this._aggregationInterval=i.aggregationInterval,this._dataPointsPerAggregation=i.dataPointsPerAggregation,this._run()}on(e,i){this._eventEmitter.on(e,i)}off(e,i){this._eventEmitter.off(e,i)}dispose(){this._disposed||(this._disposed=!0,this._callStateChanged.resolve(!1),this._eventEmitter.removeAllListeners(),this._mediaStatsSource?.removeSink(this))}get source(){return this._mediaStatsSource}set source(e){this._mediaStatsSource=e}onReport(e){this._processMediaStatsReport(e)}onAdded(e){this._isActive!==e&&(this._isActive=e,this._callStateChanged.resolve(e))}onRemoved(){this.dispose()}pause(){this._isActive&&(this._isActive=!1,this._callStateChanged.resolve(!1))}resume(){this._isActive||(this._isActive=!0,this._callStateChanged.resolve(!0))}stop(){this.dispose()}_processMediaStatsReport(e){const i={audio:{send:[],receive:[]},video:{send:[],receive:[]},screenShare:{send:[],receive:[]},transports:[]};try{const r=[[e.audio.send,i.audio.send,this._calculators.audio.send,this._metricsProperties.audio.send],[e.audio.receive,i.audio.receive,this._calculators.audio.receive,this._metricsProperties.audio.receive],[e.video.send,i.video.send,this._calculators.video.send,this._metricsProperties.video.send],[e.video.receive,i.video.receive,this._calculators.video.receive,this._metricsProperties.video.receive],[e.screenShare.send,i.screenShare.send,this._calculators.screenShare.send,this._metricsProperties.screenShare.send],[e.screenShare.receive,i.screenShare.receive,this._calculators.screenShare.receive,this._metricsProperties.screenShare.receive],[e.transports,i.transports,this._calculators.transports,this._metricsProperties.transports]];let o=!1;for(const[l,d,h,p]of r){const g=[],f=Object.keys(h);Object.keys(l).forEach(y=>{const T=l[y];let C=T.id;T.groupId&&(C=`${T.groupId}.${C}`,o=!0);const E={id:C};g.push(C),h[C]===void 0&&(h[C]=new x2e(p)),Object.keys(T).forEach(I=>{const w=p[I];if(w&&w.skip!==!0){const D=h[C].addStats(I,T[I]),F=w.output_key??I;E[F]=D}}),d.push(E)}),f.filter(y=>!g.includes(y)).forEach(y=>{delete h[y]})}o&&(i.video.send=IQ(i.video.send),i.screenShare.send=IQ(i.screenShare.send))}catch(r){this._logger.error(r)}this._eventEmitter.emit("sampleReported",i)}async _run(){let e=0;const i=()=>{if(e===0)return;const o={audio:{send:[],receive:[]},video:{send:[],receive:[]},screenShare:{send:[],receive:[]},transports:[]};for(const[l,d]of Object.entries(this._calculators.audio.send))o.audio.send.push({id:l,...d.popAggregates()});for(const[l,d]of Object.entries(this._calculators.audio.receive))o.audio.receive.push({id:l,...d.popAggregates()});for(const[l,d]of Object.entries(this._calculators.video.send))o.video.send.push({id:l,...d.popAggregates()});for(const[l,d]of Object.entries(this._calculators.video.receive))o.video.receive.push({id:l,...d.popAggregates()});for(const[l,d]of Object.entries(this._calculators.screenShare.send))o.screenShare.send.push({id:l,...d.popAggregates()});for(const[l,d]of Object.entries(this._calculators.screenShare.receive))o.screenShare.receive.push({id:l,...d.popAggregates()});for(const[l,d]of Object.entries(this._calculators.transports))o.transports.push({id:l,...d.popAggregates()});o.video.send=IQ(o.video.send),o.screenShare.send=IQ(o.screenShare.send),this._eventEmitter.emit("summaryReported",o),e=0};let r=1e3*this._aggregationInterval;for(;!this._disposed;){const o=[this._calculators.audio.send,this._calculators.audio.receive,this._calculators.video.send,this._calculators.video.receive,this._calculators.screenShare.send,this._calculators.screenShare.receive,this._calculators.transports];if(this._isActive){r>0&&await cP(()=>this._callStateChanged.promise,r).catch(h=>{});const l=Date.now();for(const h of o)for(const[,p]of Object.entries(h))p.aggregate();e++,e===this._dataPointsPerAggregation&&i();const d=Date.now();r=l+1e3*this._aggregationInterval-d}else i(),this._calculators=AQ(),await this._callStateChanged.promise.catch(l=>{}),r=1e3*this._aggregationInterval;this._callStateChanged.isPending()||(this._callStateChanged=ug())}i()}}class B2e{constructor(){this._eventEmitter=new $c.EventEmitter,this._getCurrentTime=globalThis.performance&&typeof globalThis.performance.now=="function"?()=>globalThis.performance.now():()=>Date.now()}on(e,i){this._eventEmitter.on(e,i)}off(e,i){this._eventEmitter.off(e,i)}dispose(){this._eventEmitter.removeAllListeners()}}class z2t extends B2e{constructor(e){super(),this._intervalInMs=e,this._handle=0}start(){this._handle||(this._handle=globalThis.setInterval(()=>{this._eventEmitter.emit("tick")},this._intervalInMs))}stop(){this._handle&&(globalThis.clearInterval(this._handle),this._handle=0)}dispose(){this.stop(),super.dispose()}}class V2t extends B2e{constructor(e){super(),this._intervalInMs=e,this._callQueue=Promise.resolve(),this._state={isRunning:!1}}start(){if(this._state.isRunning)return;const e={isRunning:!0};this._state=e;const i=async()=>{for(;e.isRunning;){const r=this._getCurrentTime();this._eventEmitter.emit("tick");const o=this._getCurrentTime()-r;o<this._intervalInMs&&await k6(this._intervalInMs-o)}};this._callQueue=this._callQueue.then(()=>i()).catch(()=>{})}stop(){this._state.isRunning&&(this._state.isRunning=!1)}dispose(){this._state.isRunning=!1,super.dispose()}}class $2t{static createTicker(e,i){if(e==="interval")return new z2t(i);if(e==="timeout")return new V2t(i);throw new Error(`Invalid tickerType: ${e}`)}}class F2e{constructor(e,i,r,o,l){this._call=e,this._logger=i,this._dataEventRefCount=0,this._lastFetchTime=0,this._timerDelayRatio=0,this._pendingStats=!1,this._tsCall=this._call.tsCall,this._fetchInterval=r,this._eventEmitter=new qf(this._logger,{enableLogEmit:!1});const d=1e3*r;this._ticker=$2t.createTicker(o,d),this._ticker.on("tick",()=>{const p=Date.now();this._lastFetchTime>0&&(this._timerDelayRatio=(p-this._lastFetchTime)/d),this._lastFetchTime=p,this._dataEventRefCount>0&&this._pendingStats===!1&&(this._pendingStats=!0,this.getStats().then(g=>{g&&this._eventEmitter.emit("data",g)}).catch(g=>{this._logger.error(g)}).finally(()=>{this._pendingStats=!1}))});const h=()=>{l.includes(this._tsCall.state)?this._start():this._stop()};this._callStateChangedHandle=this._tsCall.on("callStateChanged",()=>{h()}),h()}dispose(){this._callStateChangedHandle.dispose(),this._ticker.dispose()}get fetchInterval(){return this._fetchInterval}get timerDelayRatio(){return this._timerDelayRatio}_start(){this._lastFetchTime=0,this._timerDelayRatio=0,this._ticker.start()}_stop(){this._ticker.stop()}on(e,i){this._dataEventRefCount++,this._eventEmitter.on(e,i)}off(e,i){this._dataEventRefCount--,this._eventEmitter.off(e,i)}}class H2t extends F2e{constructor(e,i,r){super(e,i.createChild("MediaStatsPoller"),r.mediaStats.fetchInterval,r.mediaStats.pollingMethod,r.mediaStats.activeState),this._memoryInformationV2PendingTask=!1,this._lastCap=new Map,this._lastCpuPressureLevel=-1,this._telemetryConfig=r.telemetry.mediaStatsConfig,this._endpointId=e.tsCall.endpointId}_recordSendMaxCapabilities(e,i){if(i)try{const r=JSON.parse(i);dn.each(r,o=>{const l=o.events,d=this._lastCap.get(e)??0,h=dn.filter(dn.flatten(l),p=>p?.eventType==="req"&&p?.timestamp>d);h.length>0&&this._lastCap.set(e,dn.last(h).timestamp),h.forEach(p=>{this._call.stats.recordEvent({name:vT.video_max_capabilities,callId:this._call.id,localParticipantId:this._tsCall.participantId,timestamp:p.timestamp,data:{streamType:e,eventType:p.eventType??"",capabilities:p.capabilities??{},isSimulcast:p.isSimulcast??!1}})})})}catch(r){this._logger.warn(`Failed to process max capabilities for streamType ${e}: ${r}`)}}async getStats(){const e=await this._tsCall.getMediaSessionStatsAsync?.();this._telemetryConfig.enableVideoMaxCapCallStats&&e?.extensions&&(this._recordSendMaxCapabilities("Video",e.extensions.Video_send_MaxCapabilities),this._recordSendMaxCapabilities("ScreenSharing",e.extensions.Sharing_send_MaxCapabilities));const i={report:e,delayRatio:this.timerDelayRatio};if((e?.video.send.length||e?.screenShare.send.length)&&this._call.tsCall.endpoints?.endpointDetails?.forEach(r=>{r.endpointId===this._endpointId&&r.mediaStreams?.forEach(o=>{o.type==="video"&&o.sourceId?i.videoStreamId=o.sourceId:o.type==="applicationsharing-video"&&o.sourceId&&(i.screenShareStreamId=o.sourceId)})}),this._telemetryConfig.enableRenderCountCheck&&(e?.video.recv.length||e?.screenShare.recv.length)&&(i.ovcInformation={renderCount:this._call.activeRemoteVideoStreamViews.size,optimalVideoCount:this._tsCall.optimalVideoCount??0,renderCountOverOvc:Math.max(this._call.activeRemoteVideoStreamViews.size-(this._tsCall.optimalVideoCount??0),0)}),this._telemetryConfig.enableNetworkInformation&&window.navigator.connection){const r=window.navigator.connection,o=dn.get(r,"downlink"),l=dn.get(r,"rtt");o===void 0&&l===void 0||(i.networkInformation={downlink:o,rtt:l})}if(this._telemetryConfig.enableMemoryInformationV1&&window.performance?.memory){const r=window.performance.memory,o=dn.get(r,"jsHeapSizeLimit"),l=dn.get(r,"totalJSHeapSize"),d=dn.get(r,"usedJSHeapSize");o===void 0&&l===void 0&&d===void 0||(i.memoryInformationV1={jsHeapSizeLimit:o,totalJSHeapSize:l,usedJSHeapSize:d})}if(this._telemetryConfig.enableMemoryInformationV2&&window.crossOriginIsolated&&window.performance?.measureUserAgentSpecificMemory&&(this._memoryInformationV2&&(i.memoryInformationV2={jsSize:this._memoryInformationV2.jsSize,sharedSize:this._memoryInformationV2.sharedSize,domSize:this._memoryInformationV2.domSize}),this._memoryInformationV2PendingTask||(this._memoryInformationV2PendingTask=!0,window.performance.measureUserAgentSpecificMemory.call(window.performance).then(r=>{let o,l,d;dn.get(r,"breakdown",[]).forEach(h=>{h.bytes>0&&(dn.indexOf(h.types,"DOM")>=0&&(d=d===void 0?h.bytes:d+h.bytes),dn.indexOf(h.types,"Shared")>=0&&(l=l===void 0?h.bytes:l+h.bytes),dn.indexOf(h.types,"JavaScript")>=0&&(o=o===void 0?h.bytes:o+h.bytes))}),this._memoryInformationV2={jsSize:o,sharedSize:l,domSize:d}}).catch(r=>{this._memoryInformationV2=void 0}).finally(()=>{this._memoryInformationV2PendingTask=!1}))),this._telemetryConfig.enableBatteryInformation&&navigator.getBattery)try{const r=await navigator.getBattery();r&&(i.batteryInformation={charging:r.charging,level:r.level})}catch{}if(this._telemetryConfig.enablePressureInformation&&window.PressureObserver){if(!this._pressureObserver)try{this._pressureObserver=new window.PressureObserver(r=>{const o=r[r.length-1];this._lastCpuPressureLevel=["nominal","fair","serious","critical"].indexOf(o.state)}),await this._pressureObserver.observe("cpu",{sampleInterval:1e3})}catch(r){this._logger.error(`Failed to observe cpu pressure ${r}`)}this._lastCpuPressureLevel!==-1&&(i.pressureInformation={cpuPressureLevel:this._lastCpuPressureLevel})}if(this._telemetryConfig.enableAudioLeakInformation)try{const r=this._tsCall.isMuted||this._tsCall.isServerMuted;i.callInformation?i.callInformation.audioLeak=0:i.callInformation={audioLeak:0},r&&e?.audio.send.length&&e.audio.send[0].audioLevel!==void 0&&e.audio.send[0].audioLevel>this._telemetryConfig.audioLeakThreshold&&(navigator.mediaDevices.isRemote&&!navigator.mediaDevices.tsCallingChannel?.createdRemoteObject||(i.callInformation.audioLeak=1))}catch{}if(this._telemetryConfig.enableVideoLeakInformation)try{i.callInformation?i.callInformation.videoLeak=0:i.callInformation={videoLeak:0},!this._tsCall.isVideoOn&&e?.video.send.length&&(i.callInformation.videoLeak=1)}catch{}return i}dispose(){try{this._pressureObserver&&(this._pressureObserver.disconnect(),this._pressureObserver=void 0)}catch(e){this._logger.error(`dispose error: ${e}`)}}}var yk;(function(t){t[t.Running=0]="Running",t[t.Paused=1]="Paused",t[t.Stopped=2]="Stopped"})(yk||(yk={}));class U2e{constructor(){this._sinks=[],this._transformers=[],this._state=yk.Running}_setTransformers(e){this._transformers=e.slice()}addSink(e){e.source=this,this._sinks.push(e),e.onAdded(this._state===yk.Running)}removeSink(e){e.source===this&&(dn.pull(this._sinks,e),e.source=void 0,e.onRemoved())}removeAllSinks(){const e=this._sinks;this._sinks=[],e.forEach(i=>{i.source=void 0,i.onRemoved()})}send(e){if(this._state!==yk.Running)return;let i=e;this._transformers.length&&(i=this._transformers.reduce((r,o)=>o.transform(r),e)),this._sinks.forEach(r=>r.onReport(i))}pause(){this._state===yk.Running&&(this._state=yk.Paused,this._sinks.forEach(e=>e.pause()))}resume(){this._state===yk.Paused&&(this._state=yk.Running,this._sinks.forEach(e=>e.resume()))}stop(){this._state!==yk.Stopped&&this._sinks.forEach(e=>e.stop())}}class j2t extends U2e{constructor(e){super(),this._setTransformers(e)}onReport(e){if(e.report===void 0)return;const i=L2e();i.metadata=i.metadata??{},i.metadata.delayRatio=e.delayRatio;const r=[],o={id:"0"};e.ovcInformation&&(o.renderCountOverOvc=e.ovcInformation.renderCountOverOvc,o.optimalVideoCount=e.ovcInformation.optimalVideoCount,o.renderCount=e.ovcInformation.renderCount),e.networkInformation&&(e.networkInformation.downlink!==void 0&&(o.networkInfoDownlink=e.networkInformation.downlink),e.networkInformation.rtt!==void 0&&(o.networkInfoRttInMs=e.networkInformation.rtt)),e.memoryInformationV1&&(e.memoryInformationV1.jsHeapSizeLimit!==void 0&&(o.jsHeapSizeLimit=e.memoryInformationV1.jsHeapSizeLimit),e.memoryInformationV1.totalJSHeapSize!==void 0&&(o.totalJSHeapSize=e.memoryInformationV1.totalJSHeapSize),e.memoryInformationV1.usedJSHeapSize!==void 0&&(o.usedJSHeapSize=e.memoryInformationV1.usedJSHeapSize)),e.memoryInformationV2&&(e.memoryInformationV2.jsSize!==void 0&&(o.jsSize=e.memoryInformationV2.jsSize),e.memoryInformationV2.sharedSize!==void 0&&(o.sharedSize=e.memoryInformationV2.sharedSize),e.memoryInformationV2.domSize!==void 0&&(o.domSize=e.memoryInformationV2.domSize)),e.batteryInformation&&(e.batteryInformation.charging!==void 0&&(o.batteryCharging=e.batteryInformation.charging?1:0),e.batteryInformation.level!==void 0&&(o.batteryLevel=e.batteryInformation.level)),e.pressureInformation&&e.pressureInformation.cpuPressureLevel!==void 0&&(o.cpuPressureLevel=e.pressureInformation.cpuPressureLevel),e.callInformation&&(e.callInformation.audioLeak!==void 0&&(o.audioLeak=e.callInformation.audioLeak),e.callInformation.videoLeak!==void 0&&(o.videoLeak=e.callInformation.videoLeak)),dn.keys(o).length>1&&r.push(o);const l=[[e.report.audio.send,i.audio.send],[e.report.audio.recv,i.audio.receive],[e.report.video.send,i.video.send],[e.report.video.recv,i.video.receive],[e.report.screenShare.send,i.screenShare.send],[e.report.screenShare.recv,i.screenShare.receive],[e.report.data,i.dataChannel],[e.report.transports,i.transports],[r,i.info]],d=h=>{const p={};return Object.entries(h).forEach(g=>{const f=g[0],y=g[1];f!=="altLayouts"&&y!=null&&(p[f]=y)}),p};l.forEach(h=>{const p=h[0];if(p!==void 0){const g=h[1],f=y=>{p===e.report?.video.send&&e.videoStreamId!==void 0?y.streamId=e.videoStreamId:p===e.report?.screenShare.send&&e.screenShareStreamId!==void 0&&(y.streamId=e.screenShareStreamId)};p.forEach(y=>{const T=dn.toString(y.id);g[T]=d(y),f(g[T]),y.altLayouts!==void 0&&y.altLayouts.forEach(C=>{const E=C.id,I=d(C);I.groupId=T,g[E]=I,f(g[E])})})}}),this.send(i)}}class G2t extends U2e{constructor(e){super(),this._setTransformers(e)}onAdded(e){}onRemoved(){}onReport(e){this.send(e)}get source(){return this._mediaStatsSource}set source(e){this._mediaStatsSource=e}}class q2t{constructor(e){this._tsCall=e,this._activeParticipantMris=new Set,this._sourceIdToParticipantInfo=new Map,this._listenerHandles=[],this._config=wt(),this._listenerHandles.push(this._tsCall.on("participantAdded",i=>{this._activeParticipantMris.add(i.id),this._updateMapping(i)})),this._listenerHandles.push(this._tsCall.on("participantUpdated",i=>{this._activeParticipantMris.has(i.id)&&this._updateMapping(i)})),this._listenerHandles.push(this._tsCall.on("participantRemoved",i=>{this._activeParticipantMris.delete(i.id),this._removeMapping(i)})),this._tsCall.participants?.forEach(i=>{this._activeParticipantMris.add(i.id),this._updateMapping(i)})}_updateMapping(e){const i=e.id,r=[],o=this._config.calling.composedStreamBotIds;e.endpoints?.endpointDetails?.forEach(l=>{l.mediaStreams?.forEach(d=>{r.push(d.sourceId),this._sourceIdToParticipantInfo.set(d.sourceId,{mri:i,participantId:l.participantId,isComposedStream:o.includes(i)})})})}_removeMapping(e){e.endpoints?.endpointDetails?.forEach(i=>{i.mediaStreams?.forEach(r=>{this._sourceIdToParticipantInfo.delete(r.sourceId)})})}findParticipantInfo(e){let i=this._sourceIdToParticipantInfo.get(e);if(i===void 0&&this.isP2P()&&this._tsCall.participants.length&&this._tsCall.participants[0].endpoints?.endpointDetails.length){const r=this._tsCall.participants[0],o=r.endpoints?.endpointDetails[0];i={mri:r.id,participantId:o?.participantId??"",isComposedStream:!1}}return i}isP2P(){return this._tsCall.callType===1}dispose(){this._activeParticipantMris.clear(),this._sourceIdToParticipantInfo.clear(),this._listenerHandles.forEach(e=>e.dispose())}}class W2t{constructor(e,i,r,o){this._tsCall=e,this._call=i,this._telemetryLogManager=r,this._config=o,this._participantMappingManager=new q2t(this._tsCall)}dispose(){this._participantMappingManager.dispose()}log(e){const i=this._config.telemetry.mediaStatsConfig;[{type:"audio",direction:"send",value:e.audio.send},{type:"audio",direction:"recv",value:e.audio.receive},{type:"video",direction:"send",value:e.video.send},{type:"video",direction:"recv",value:e.video.receive},{type:"screen",direction:"send",value:e.screenShare.send},{type:"screen",direction:"recv",value:e.screenShare.receive},{type:"data",direction:"",value:e.dataChannel},{type:"transport",direction:"",value:e.transports},{type:"info",direction:"",value:e.info}].forEach(r=>{const o=Object.values(r.value);o.forEach(l=>{const d={id:l.id},h={id:l.id};Object.keys(l).forEach(f=>{const y=f;if(f==="id")return;if(f==="events"){const E=l[y];return void(E.length>0&&(d.events=JSON.stringify(E)))}const T=l[y];if(i.dataToSend.raw){const E={};T?.timestamp&&(E.timestamp=T?.timestamp),i.dataToSend.raw&&(E.raw=T?.raw),h[y]=E}const C={};T.aggregation!==void 0?(T.timestamp&&(C.timestamp=T.timestamp),i.dataToSend.min&&(C.min=T.aggregation.min),i.dataToSend.max&&(C.max=T.aggregation.max),i.dataToSend.sum&&(C.sum=T.aggregation.sum),i.dataToSend.count&&(C.count=T.aggregation.count)):(T.timestamp&&(C.timestamp=T.timestamp),T.reduced?C.raw=T.reduced:T.raw&&(C.raw=T.raw)),d[y]=C});let p="",g="";if((r.type==="video"||r.type==="screen")&&r.direction==="recv"){const f=l;if(f.streamId!==void 0&&f.streamId.raw?.length){const y=f.streamId.raw[0],T=this._participantMappingManager.findParticipantInfo(y);p=T?.participantId??"",g=T?.isComposedStream?"ComposedVideoStream":"RemoteVideoStream"}}if(Object.keys(d).length>1){const f={mediaType:r.type,mediaDirection:r.direction,stats:d,callId:this._tsCall.callId,remoteParticipantId:p,localParticipantId:this._tsCall.participantId,videoStreamKind:g,streamCount:o.length,appliedFrameHeightMaxSentConstraint:this._call.mediaConstraintsManager.currentVideoConstraints?.send?.frameHeight?.max,appliedBitrateMaxSentConstraint:this._call.mediaConstraintsManager.currentVideoConstraints?.send?.bitrate?.max,appliedFrameRateMaxSentConstraint:this._call.mediaConstraintsManager.currentVideoConstraints?.send?.frameRate?.max,audioEffectsProcessorStats:this._call.audioEffectsProcessorStats??void 0};this._sendMidCallNewMediaStats(f)}if(i.dataToSend.raw&&Object.keys(h).length>1){const f={mediaType:r.type,mediaDirection:r.direction,stats:h,callId:this._tsCall.callId,remoteParticipantId:p,localParticipantId:this._tsCall.participantId,videoStreamKind:g,streamCount:o.length};this._sendMidCallRawMediaStats(f)}})})}_sendMidCallNewMediaStats(e){this._telemetryLogManager.sendEvent({name:vi.acs_calling_mid_call_new_media_stats,tenant:Wr,properties:e})}_sendMidCallRawMediaStats(e){this._telemetryLogManager.sendEvent({name:vi.acs_calling_mid_call_raw_media_stats,tenant:Wr,properties:e})}}function K2t(){return{transform:t=>dn.cloneDeep(t)}}function J2t(t){return{transform:e=>([[e.audio.send,t.audio.send],[e.audio.receive,t.audio.receive],[e.video.send,t.video.send],[e.video.receive,t.video.receive],[e.screenShare.send,t.screenShare.send],[e.screenShare.receive,t.screenShare.receive],[e.dataChannel,t.dataChannel],[e.transports,t.transports],[e.info,t.info]].forEach(i=>{const r=i[0],o=i[1];dn.forEach(o,(l,d)=>{l.disabled!==!0&&dn.forEach(r,h=>{let p=h[l.source];p!==void 0&&(l.multiplier!==void 0&&typeof p=="number"&&(p*=l.multiplier),l.integer&&(p=dn.toInteger(p)),h[d]=p)})})}),e)}}function Y2t(t){const e=["audio.send","audio.receive","video.send","video.receive","screenShare.send","screenShare.receive","dataChannel","transports","info"];return{transform:i=>(dn.forEach(e,r=>{const o=dn.get(i,r),l=dn.get(t,r,[]);dn.forEach(o,d=>{l.forEach(h=>{h!=="id"&&delete d[h]})})}),i)}}function Q2t(t,e){return{transform:i=>{const r=i.metadata?.delayRatio,o=t>0&&r!==void 0&&r>t;return dn.forEach(e,(l,d)=>{const h=dn.get(i,d);dn.forEach(h,p=>{dn.forEach(l,(g,f)=>{if(o)delete p[f];else{const y=p[f];(g.max!==void 0&&y>g.max||g.min!==void 0&&y<g.min||dn.isNaN(y))&&delete p[f]}})})}),i}}}const z2e={codecName:{},bitrate:{aggregable:!0},jitterInMs:{aggregable:!0},packets:{},packetsPerSecond:{aggregable:!0},packetsLost:{},packetsLostPerSecond:{aggregable:!0},rttInMs:{aggregable:!0},streamId:{},frameRateInput:{aggregable:!0},frameWidthInput:{aggregable:!0},frameHeightInput:{aggregable:!0},framesEncoded:{},frameRateEncoded:{aggregable:!0},framesSent:{},frameRateSent:{aggregable:!0},frameWidthSent:{aggregable:!0},frameHeightSent:{aggregable:!0},keyFramesEncoded:{},transportId:{}},V2e={codecName:{},bitrate:{aggregable:!0},jitterInMs:{aggregable:!0},packets:{},packetsPerSecond:{aggregable:!0},packetsLost:{},packetsLostPerSecond:{aggregable:!0},rttInMs:{aggregable:!0},streamId:{},jitterBufferDelayInMs:{aggregable:!0},frameRateDecoded:{aggregable:!0},frameRateReceived:{aggregable:!0},frameWidthReceived:{aggregable:!0},frameHeightReceived:{aggregable:!0},longestFreezeDurationInMs:{},totalFreezeDurationInMs:{},framesReceived:{},framesDropped:{},framesDecoded:{},keyFramesDecoded:{},transportId:{}},$2e={audio:{send:{codecName:{},bitrate:{aggregable:!0},jitterInMs:{aggregable:!0},packets:{},packetsPerSecond:{aggregable:!0},packetsLost:{},packetsLostPerSecond:{aggregable:!0},rttInMs:{aggregable:!0},audioInputLevel:{aggregable:!0},transportId:{}},receive:{codecName:{},bitrate:{aggregable:!0},jitterInMs:{aggregable:!0},packets:{},packetsPerSecond:{aggregable:!0},packetsLost:{},packetsLostPerSecond:{aggregable:!0},rttInMs:{aggregable:!0},jitterBufferDelayInMs:{aggregable:!0},audioOutputLevel:{aggregable:!0},healedRatio:{aggregable:!0},transportId:{}}},video:{send:z2e,receive:V2e},screenShare:{send:z2e,receive:V2e},dataChannel:{incomingBitrate:{aggregable:!0},outgoingBitrate:{aggregable:!0},messagesSentPerSecond:{aggregable:!0},messagesReceivedPerSecond:{aggregable:!0}},transports:{rttInMs:{aggregable:!0},availableIncomingBitrate:{aggregable:!0},availableOutgoingBitrate:{aggregable:!0}},info:{}},H2e={codecName:{raw_data_reduction:!0},packets:{raw_data_reduction:!0},packetsLost:{raw_data_reduction:!0},streamId:{raw_data_reduction:!0},framesEncoded:{raw_data_reduction:!0},framesSent:{raw_data_reduction:!0},keyFramesEncoded:{raw_data_reduction:!0},pairRttInMs:{aggregable:!0},availableBitrate:{aggregable:!0},transportId:{skip:!0},groupId:{raw_data_reduction:!0},fsOvershoot:{aggregable:!0},fpsOvershoot:{aggregable:!0},brOvershoot:{aggregable:!0}},j2e={codecName:{raw_data_reduction:!0},streamId:{raw_data_reduction:!0},packets:{raw_data_reduction:!0},packetsLost:{raw_data_reduction:!0},jitterBufferDelayInMs:{output_key:"jitterBufferInMs"},longestFreezeDurationInMs:{skip:!0},totalFreezeDurationInMs:{raw_data_reduction:!0},framesReceived:{raw_data_reduction:!0},framesDropped:{raw_data_reduction:!0},framesDecoded:{raw_data_reduction:!0},keyFramesDecoded:{raw_data_reduction:!0},pairRttInMs:{aggregable:!0},availableBitrate:{aggregable:!0},transportId:{skip:!0}},Z2t={audio:{send:{codecName:{raw_data_reduction:!0},packets:{raw_data_reduction:!0},packetsLost:{raw_data_reduction:!0},pairRttInMs:{aggregable:!0},availableBitrate:{aggregable:!0},transportId:{skip:!0}},receive:{codecName:{raw_data_reduction:!0},packets:{raw_data_reduction:!0},packetsLost:{raw_data_reduction:!0},jitterBufferDelayInMs:{output_key:"jitterBufferInMs"},pairRttInMs:{aggregable:!0},availableBitrate:{aggregable:!0},transportId:{skip:!0}}},video:{send:H2e,receive:j2e},screenShare:{send:H2e,receive:j2e},dataChannel:{state:{raw_data_reduction:!0},dataChannelIdentifier:{raw_data_reduction:!0},messagesSent:{raw_data_reduction:!0},bytesSent:{raw_data_reduction:!0},messagesReceived:{raw_data_reduction:!0},bytesReceived:{raw_data_reduction:!0}},transports:{candidateType:{events:!0},relayProtocol:{events:!0}},info:{networkInfoDownlink:{aggregable:!0},networkInfoRttInMs:{aggregable:!0},totalJSHeapSize:{aggregable:!0},usedJSHeapSize:{aggregable:!0},jsHeapSizeLimit:{aggregable:!0},jsSize:{aggregable:!0},sharedSize:{aggregable:!0},domSize:{aggregable:!0},batteryCharging:{aggregable:!0},batteryLevel:{aggregable:!0},cpuPressureLevel:{aggregable:!0},audioLeak:{aggregable:!0},videoLeak:{aggregable:!0},renderCountOverOvc:{aggregable:!0},optimalVideoCount:{aggregable:!0},renderCount:{aggregable:!0}}},wQ={multiplier:1e3,integer:!0,source:"jitter"},D6={multiplier:1e3,integer:!0,source:"rtt"},G2e={integer:!0,source:"jitterBufferMs"},q2e={jitterInMs:wQ,rttInMs:D6,fsOvershoot:{integer:!0,source:"isFsOvershooting"},fpsOvershoot:{integer:!0,source:"isFpsOvershooting"},brOvershoot:{integer:!0,source:"isBrOvershooting"}},W2e={jitterInMs:wQ,rttInMs:D6,jitterBufferDelayInMs:G2e,streamId:{source:"msi"},longestFreezeDurationInMs:{multiplier:1e3,integer:!0,source:"longestFreezeDuration"},totalFreezeDurationInMs:{multiplier:1e3,integer:!0,source:"totalFreezeDuration"}},X2t={audio:{send:{jitterInMs:wQ,rttInMs:D6,audioInputLevel:{multiplier:65536,integer:!0,source:"audioLevel"}},receive:{jitterInMs:wQ,rttInMs:D6,jitterBufferDelayInMs:G2e,audioOutputLevel:{multiplier:65536,integer:!0,source:"audioLevel"}}},video:{send:q2e,receive:W2e},screenShare:{send:q2e,receive:W2e},dataChannel:{incomingBitrate:{source:"recvBitrate"},outgoingBitrate:{source:"sendBitrate"}},transports:{rttInMs:D6},info:{networkInfoDownlink:{multiplier:1e3,integer:!0,source:"networkInfoDownlink"}}};class eUt{constructor(e,i,r,o){this._tsCall=e,this._call=i,this._logger=r,this._disposed=!1;const l=wt();this._config=l.mediaStats,this._statsPoller=new H2t(i,this._logger,l);const d=[J2t(dn.merge(dn.cloneDeep(X2t),this._config.transformMetrics))];this._config.timerThrottlingFilter.enabled&&d.push(Q2t(this._config.timerThrottlingFilter.delayRatio,this._config.timerThrottlingFilter.filterRange)),this._mediaStatsSourceNode=new j2t(d);const h=this._config.activeState;this._isCallActive=h.includes(this._tsCall.state),this._callStateChangedHandle=this._tsCall.on("callStateChanged",()=>{const f=h.includes(this._tsCall.state);this._isCallActive!==f&&(this._isCallActive=f,f?this._mediaStatsSourceNode.resume():this._mediaStatsSourceNode.pause())});const p=this._config.blockMetrics;if(Object.keys(p).length>0){const f=new G2t([K2t(),Y2t(p)]);this._mediaStatsSourceNode.addSink(f),this._collectorsSourceNode=f}else this._collectorsSourceNode=this._mediaStatsSourceNode;const g=l.telemetry.mediaStatsConfig;if(g.enabled){const f=new W2t(this._tsCall,this._call,o,l),y=dn.merge(dn.cloneDeep($2e),Z2t,g.metricsProperties),T=new F2t(this._logger,{aggregationInterval:g.aggregationInterval,dataPointsPerAggregation:g.dataPointsPerAggregation,metricsPropertics:y});T.on("data",C=>f.log(C)),this._mediaStatsSourceNode.addSink(T)}this._isCallActive?this._mediaStatsSourceNode.resume():this._mediaStatsSourceNode.pause(),this._dataEventListener=f=>{this._mediaStatsSourceNode.onReport(f)},this._statsPoller.on("data",this._dataEventListener)}createCollector(e){if(this._disposed)throw new Oe({defaultError:we.FEATURES.MEDIA_STATS.DISPOSED});const i=this._config,r=new U2t(this._logger,{aggregationInterval:e?.aggregationInterval??i.aggregationInterval,dataPointsPerAggregation:e?.dataPointsPerAggregation??i.dataPointsPerAggregation,metricsPropertics:$2e});return this._collectorsSourceNode.addSink(r),r}dispose(){this._disposed||(this._disposed=!0,this._statsPoller.off("data",this._dataEventListener),this._statsPoller.dispose(),this._mediaStatsSourceNode.stop(),this._callStateChangedHandle.dispose())}}class K2e extends Bu{constructor(e){super(e)}get name(){return this._sendFeatureUsage("name",Je.getter),"MediaStats"}createCollector(e){this._sendFeatureUsage("createCollector",Je.attempt);const i=this._statsManager.createCollector(e);return this._sendFeatureUsage("creaetCollector",Je.success),i}initialize(e,i){this._logger=i,this._telemetryLogManager=e.telemetryLogManager,this._call=e.call,this._statsManager=new eUt(e.tsCall,this._call,this._logger,this._telemetryLogManager),this._sendFeatureUsage("initialize",Je.initialize)}_sendFeatureUsage(e,i){Pc({callId:this._call.id,localParticipantId:this._call.tsCall.participantId,featureName:"MediaStats",featureType:"Call",initializationType:"OnExtendedObjectConstructor",featureDetails:{name:e,step:i}},this._telemetryLogManager,this._logger)}dispose(){this._sendFeatureUsage("dispose",Je.attempt),this.disposed?this._sendFeatureUsage("dispose",Je.failure):(this._statsManager.dispose(),super.dispose(),this._sendFeatureUsage("dispose",Je.success))}}var OB,NB;(function(t){t[t.None=0]="None",t[t.Started=1]="Started",t[t.Paused=2]="Paused",t[t.Ended=3]="Ended"})(OB||(OB={}));class tUt extends Bu{constructor(e){super(e),this._callInfo=e.callInfo,this._impl=new iUt(this.eventEmitter)}get name(){return this._sendFeatureUsage("name",Je.getter),"Recording"}initialize(e,i){this._logger=i,this._telemetryLogManager=e.telemetryLogManager,this._call=e.call,this._impl.initialize(e.tsCall,i,this._callInfo,this._call),this._sendFeatureUsage("initialize",Je.initialize)}get isRecordingActive(){return this._sendFeatureUsage("isRecordingActive",Je.getter),this._impl.isRecordingActive}get recordings(){return this._sendFeatureUsage("recordings",Je.getter),this._impl.recordings}on(e,i){if(e!=="isRecordingActiveChanged"&&e!=="recordingsUpdated")throw new Oe({defaultError:we.FEATURES.RECORDING.EVENT_SUBSCRIBE,defaultErrorMessageArgs:[e]});this._sendFeatureUsage(e,Je.subscribe),this.eventEmitter.on(e,i)}off(e,i){if(e!=="isRecordingActiveChanged"&&e!=="recordingsUpdated")throw new Oe({defaultError:we.FEATURES.RECORDING.EVENT_UNSUBSCRIBE,defaultErrorMessageArgs:[e]});this._sendFeatureUsage(e,Je.unsubscribe),this.eventEmitter.off(e,i)}get isTeamsConsentRequired(){return this._sendFeatureUsage("isTeamsConsentRequired",Je.getter),this._impl.isTeamsConsentRequired}grantTeamsConsent(){return this._sendFeatureUsage("ConsentForRecording",Je.attempt),this._impl.grantTeamsConsent().then(()=>{this._sendFeatureUsage("ConsentForRecording",Je.success)}).catch(e=>{throw this._sendFeatureUsage("ConsentForRecording",Je.failure,e),e})}dispose(){this._sendFeatureUsage("dispose",Je.attempt),this.disposed?this._sendFeatureUsage("dispose",Je.failure):(this._impl.dispose(),super.dispose(),this._sendFeatureUsage("dispose",Je.success))}_sendFeatureUsage(e,i,r){let o=r?an(r):void 0;Pc({callId:this._call.id,localParticipantId:this._call.tsCall.participantId,featureName:"Recording",featureType:"Call",initializationType:"OnFeatureAccess",featureDetails:{name:e,step:i},additionalDetails:o},this._telemetryLogManager,this._logger)}}class iUt{constructor(e){this._eventEmitter=e,this._recordingBots=new Map,this._recordingBotChangedSubs=new WeakMap,this._recordingInitiatorMap=new Map,this._isRecordingActive=!1,this.grantTeamsConsent=async()=>(this._logger.info("Attempting to set consent for recording"),this._call.explicitConsentStateImp.consent(this._callInfo).catch(i=>{throw this._logger.error("Consent failure to set publish state for user"),nb(i,we.FEATURES.RECORDING.RECORDING_CONSENT_FAILURE)})),this._updateIsCallRecorded=i=>this._isRecordingActive!==i&&(this._isRecordingActive=i,this._logger.info(`Updating isCallRecorded to ${i}`),!0),this._handleRecordingBotAdded=i=>{const r=()=>{let o,l=!1,d=!1;if(this._hasRecordingState(i)){if(this._recordingBots.has(i.id)){let h=this._getRecordingBotEndpoint(i);if(o=this._recordingBots.get(i.id),h&&o){o.endpoint=h;let p=h.userId?this._recordingInitiatorMap.get(h.userId):void 0;d=o.recordingInfo?.update(h,p)??!1}}else o=this._getRecordingBotInfo(i),o&&(this._logger.info("Adding recording bot"),this._recordingBots.set(i.id,o),l=!0);this._sendEvents(d?[o]:void 0,l?[o]:void 0,void 0,this._updateIsCallRecorded(this._isRecordingEnabled()))}};r(),this._recordingBotChangedSubs.set(i,i.changed(r))},this._handleRecordingBotRemoved=i=>{let r=this._recordingBots.get(i.id);this._recordingBots.delete(i.id),this._recordingBotChangedSubs.get(i)?.dispose(),this._recordingBotChangedSubs.delete(i),this._logger.info(`Updating recordingState to ${r?.endpoint?.state}`),r?.recordingInfo?.dispose(),this._sendEvents([r],void 0,[r],this._updateIsCallRecorded(this._isRecordingEnabled()))},this._sendEvents=(i,r,o,l)=>{i&&i.forEach(p=>p?.recordingInfo?.sendRecordingStateChanged());let d=!!r&&r.length>0,h=!!o&&o.length>0;(d||h)&&this._eventEmitter.emit("recordingsUpdated",{added:this._getRecordingInfos(r),removed:this._getRecordingInfos(o)}),l&&this._eventEmitter.emit("isRecordingActiveChanged")},this._hasRecordingState=i=>i?.endpoints?.endpointDetails?.some(r=>!!r?.endpointMetadata?.__platform?.recording?.compliance?.state||!!r?.endpointMetadata?.processingModes?.recording?.state)??!1,this._getRecordingInfos=i=>{if(i)return i.map(r=>r?.recordingInfo).filter(r=>!!r)},this._isRecordingEnabled=()=>{let i=!1;try{this._recordingBots.forEach(r=>{i||(i=r?.endpoint?.state==="Active")})}catch(r){this._logger.info("Unable to read recording state: ",r)}return i},this._getRecordingInfoImpl=i=>{if(i==null||i.state!=="Active"&&i.state!=="Inactive")return;let r;return i.userId!==void 0&&(r=this._recordingInitiatorMap.get(i.userId)),new nUt(i.state,this._eventEmitter,r)},this._getRecordingBotInfo=i=>{let r=this._getRecordingBotEndpoint(i);return r?{endpoint:r,recordingInfo:this._getRecordingInfoImpl(r)}:void 0},this._getRecordingBotEndpoint=i=>{let r=i.endpoints?.endpointDetails.map(o=>{let l=o?.endpointMetadata?.__platform?.recording?.compliance?.state,d=o?.endpointMetadata?.__platform?.recording?.compliance?.userId,h=o?.endpointMetadata?.processingModes?.recording?.state,p=o?.endpointMetadata?.processingModes?.recording?.userId;if(l||h)return{state:l??h,userId:d??p}}).filter(o=>o!=null);if(r&&r.length!=0)return r.length>1&&this._logger.log(`Unexpected: multiple recording endpoints: ${r?.map(o=>o?.state??"undefined").join(", ")}`),r[0]}}get isRecordingActive(){return this._isRecordingActive}get recordings(){return Array.from(this._recordingBots.values()).map(e=>e?.recordingInfo).filter(e=>!!e)}initialize(e,i,r,o){this._logger=i.createChild(()=>`RecordingFeature::Call(id='${e.callId}', state='${e.state}')`),this._callInfo=r,this._call=o,e.on("callStateChanged",async()=>{e.state===3&&this._initInitiatorMap(e)}),e.participants.forEach(l=>{fO(l.id)&&this._handleRecordingBotAdded(l)}),e.on("participantAdded",async l=>{fO(l.id)?this._handleRecordingBotAdded(l):l===void 0||this._recordingInitiatorMap.has(l.id)||this._recordingInitiatorMap.set(l.id,l.displayName)}),e.on("participantRemoved",async l=>{fO(l.id)?this._handleRecordingBotRemoved(l):l!==void 0&&this._recordingInitiatorMap.has(l.id)&&this._recordingInitiatorMap.delete(l.id)}),e.on("participantUpdated",async l=>{l!==void 0&&this._recordingInitiatorMap.has(l.id)&&this._recordingInitiatorMap.set(l.id,l.displayName)})}get isTeamsConsentRequired(){return this._call.explicitConsentStateImp.isConsentRequiredInCall()}dispose(){let e=this._updateIsCallRecorded(!1),i=Array.from(this._recordingBots.values());i.forEach(r=>r?.recordingInfo?.dispose()),this._sendEvents(void 0,void 0,i,e)}_initInitiatorMap(e){const{participants:i}=e;[...i].forEach(r=>{fO(r.id)||this._recordingInitiatorMap.set(r.id,r.displayName)})}}class nUt{constructor(e,i,r){this.state=this.getRecordingState(e),this._eventEmitter=i,this.displayName=r}on(e,i){this._eventEmitter.on(e,i)}off(e,i){this._eventEmitter.off(e,i)}update(e,i){if(e==null)return!1;let r=this.getRecordingState(e.state);return r!=this.state&&(this.state=r,i!==void 0&&(this.displayName=i),!0)}dispose(){this.state=OB.Ended}sendRecordingStateChanged(){this._eventEmitter.emit("recordingStateChanged")}getRecordingState(e){let i=OB.None;switch(e?.toLocaleLowerCase()){case"active":i=OB.Started;break;case"inactive":i=OB.Paused;break;default:i=OB.None}return i}}(function(t){t[t.None=0]="None",t[t.Started=1]="Started",t[t.Ended=2]="Ended"})(NB||(NB={}));const ope={ACTIVE:"active",INACTIVE:"inactive"};class aUt extends Bu{constructor(e){super(e),this._impl=new rUt(this.eventEmitter)}get name(){return this._sendFeatureUsage("name",Je.getter),"LocalRecording"}initialize(e,i){this._logger=i,this._telemetryLogManager=e.telemetryLogManager,this._call=e.call,this._impl.initialize(e.tsCall,e.telemetryLogManager,i),this._sendFeatureUsage("initialize",Je.initialize)}get isRecordingActive(){return this._sendFeatureUsage("isRecordingActive",Je.getter),this._impl.isRecordingActive}get recordings(){return this._sendFeatureUsage("recordings",Je.getter),this._impl.recordings}on(e,i){if(e!=="isLocalRecordingActiveChanged"&&e!=="localRecordingsUpdated")throw new Oe({defaultError:we.FEATURES.RECORDING.EVENT_SUBSCRIBE,defaultErrorMessageArgs:[e]});this._sendFeatureUsage(e,Je.subscribe),this.eventEmitter.on(e,i)}off(e,i){if(e!=="isLocalRecordingActiveChanged"&&e!=="localRecordingsUpdated")throw new Oe({defaultError:we.FEATURES.RECORDING.EVENT_UNSUBSCRIBE,defaultErrorMessageArgs:[e]});this._sendFeatureUsage(e,Je.unsubscribe),this.eventEmitter.off(e,i)}_sendFeatureUsage(e,i,r){let o=r?{code:r?.code||jL,subCode:r?.subCode||0,failureReason:r?.message||""}:void 0;Pc({callId:this._call.id,localParticipantId:this._call.tsCall.participantId,featureName:"LocalRecording",featureType:"Call",initializationType:"OnFeatureAccess",featureDetails:{name:e,step:i},additionalDetails:o},this._telemetryLogManager,this._logger)}dispose(){this._sendFeatureUsage("dispose",Je.attempt),this.disposed?this._sendFeatureUsage("dispose",Je.failure):(this._impl.dispose(),super.dispose(),this._sendFeatureUsage("dispose",Je.success))}}class rUt{constructor(e){this._eventEmitter=e,this._localRecordingInitiators=new Map,this._sendEvents=(i,r,o)=>{let l=!!i&&i.length>0,d=!!r&&r.length>0;(l||d)&&this._eventEmitter.emit("localRecordingsUpdated",{added:i,removed:r}),o&&this._eventEmitter.emit("isLocalRecordingActiveChanged")},this._isEnabled=wt().calling.localRecording.enabled,this._supportedConversationTypes=wt().calling.localRecording.supportedConversationTypes}get isRecordingActive(){return this._localRecordingInitiators.size>0}get recordings(){return Array.from(this._localRecordingInitiators.values())}initialize(e,i,r){if(this._logger=r.createChild(()=>`LocalRecordingFeature::Call(id='${e.callId}', state='${e.state}')`),!this._isEnabled){const o="Local Recording feature is is disabled",l=new Oe({defaultError:we.FEATURES.LOCAL_RECORDING.DISABLED});throw this._logger.error(o),l}e.on("callStateChanged",async()=>{if(e.state===3){if(!this._supportedConversationTypes.includes(e.conversationType)){const o="Local Recording feature is only available in meetings",l=new Oe({defaultError:we.FEATURES.LOCAL_RECORDING.ONLY_AVAILABLE_IN_MEETINGS});throw this._logger.error(o),l}this.initLocalRecordingStatus(e)}}),e.on("participantUpdated",o=>this._onParticipantUpdatedEvent(e,o,o.endpoints?.endpointDetails))}dispose(){let e=this._localRecordingInitiators.size>0,i=Array.from(this._localRecordingInitiators.values());i.forEach(r=>r?.dispose()),e&&(e=this._localRecordingInitiators.size==0),this._sendEvents(void 0,i,e)}hasOngoingLocalRecording(e){return e?.some(i=>(i.propertyBag?.localRecording?.value?.state||"")===ope.ACTIVE)||!1}initLocalRecordingStatus(e){const{participants:i}=e,r=[...i];this._localRecordingInitiators=new Map(r.filter(o=>this.hasOngoingLocalRecording(o.endpoints?.endpointDetails)).map(o=>[o.id,this._getLocalRecordingInfo(o)]))}_onParticipantUpdatedEvent(e,i,r){i?fO(i.id)||(this.hasOngoingLocalRecording(r)?this._tryAddLocalRecordingInitiator(e,i):this._tryRemoveLocalRecordingInitiator(e,i)):this._logger.error(`Empty participant, skip update event processing. CallId: ${e.callId}`)}_tryAddLocalRecordingInitiator(e,i){const{callId:r}=e;if(!this._localRecordingInitiators.has(i.id)){this._logger.info(`Add local recording participant: ${i.id}, callId: ${r}`);let o=this._getLocalRecordingInfo(i);this._localRecordingInitiators.set(i.id,o),this._sendEvents([o],void 0,this._localRecordingInitiators.size==1)}}_tryRemoveLocalRecordingInitiator(e,i){const{callId:r}=e;if(this._localRecordingInitiators.has(i.id)){this._logger.info(`Remove local recording participant: ${i.id}, callId: ${r}`);let o=this._localRecordingInitiators.get(i.id);o.update(ope.INACTIVE),this._localRecordingInitiators.delete(i.id),this._sendEvents(void 0,[o],this._localRecordingInitiators.size==0)}}_getLocalRecordingInfo(e){let i=e.displayName;return new oUt(ope.ACTIVE,i)}}class oUt{constructor(e,i){this.state=this.getRecordingState(e),this.displayName=i}update(e){let i=this.getRecordingState(e);return i!=this.state&&(this.state=i,!0)}dispose(){this.state=NB.Ended}getRecordingState(e){let i=NB.None;switch(e?.toLocaleLowerCase()){case"active":i=NB.Started;break;case"inactive":i=NB.Ended;break;default:i=NB.None}return i}}class sUt extends Bu{constructor(e){super(e),this._impl=new lUt(this.eventEmitter),this._callInfo=e.callInfo}get name(){return this._sendFeatureUsage("name",Je.getter),"Transcription"}initialize(e,i){this._logger=i,this._telemetryLogManager=e.telemetryLogManager,this._call=e.call,this._impl.initialize(e.tsCall,i,this._callInfo,this._call),this._sendFeatureUsage("initialize",Je.initialize)}get isTranscriptionActive(){return this._sendFeatureUsage("isTranscriptionActive",Je.getter),this._impl.isTranscriptionActive}get isTeamsConsentRequired(){return this._sendFeatureUsage("isTeamsConsentRequired",Je.getter),this._impl.isTeamsConsentRequired}grantTeamsConsent(){return this._sendFeatureUsage("ConsentForTranscription",Je.attempt),this._impl.grantTeamsConsent().then(()=>{this._sendFeatureUsage("ConsentForTranscription",Je.success)}).catch(e=>{throw this._sendFeatureUsage("ConsentForTranscription",Je.failure,e),e})}on(e,i){this._sendFeatureUsage("isTranscriptionActiveChanged",Je.subscribe),this.eventEmitter.on(e,i)}off(e,i){this._sendFeatureUsage("isTranscriptionActiveChanged",Je.unsubscribe),this.eventEmitter.off(e,i)}dispose(){this._sendFeatureUsage("dispose",Je.attempt),this.disposed?this._sendFeatureUsage("dispose",Je.failure):(this._impl.dispose(),super.dispose(),this._sendFeatureUsage("dispose",Je.success))}_sendFeatureUsage(e,i,r){let o=r?an(r):void 0;Pc({callId:this._call.id,localParticipantId:this._call.tsCall.participantId,featureName:"Transcription",featureType:"Call",initializationType:"OnFeatureAccess",featureDetails:{name:e,step:i},additionalDetails:o},this._telemetryLogManager,this._logger)}}class lUt{constructor(e){this._eventEmitter=e,this._botChangedSubs=new Map,this._isTranscriptionActive=!1,this.grantTeamsConsent=async()=>(this._logger.info("Attempting to set consent for transcription"),this._call.explicitConsentStateImp.consent(this._callInfo).catch(i=>{throw this._logger.error("Consent failure to set publish state for user"),nb(i,we.FEATURES.TRANSCRIPTION.TRANSCRIPTION_CONSENT_FAILURE)})),this._updateIsTranscriptionActive=i=>{this._isTranscriptionActive!==i&&(this._isTranscriptionActive=i,this._logger.info(`Updating isTranscriptionActive to ${i}`),this._eventEmitter.emit("isTranscriptionActiveChanged"))},this._isCallingApplication=i=>fO(i.id),this._handleBotRemoved=i=>{this._botChangedSubs.get(i)?.dispose(),this._botChangedSubs.delete(i),this._checkIfAbotIsTranscribing()},this._handleBotAdded=i=>{this._botChangedSubs.set(i,i.changed(this._checkIfAbotIsTranscribing)),this._checkIfAbotIsTranscribing()},this._checkIfAbotIsTranscribing=()=>{try{Array.from(this._botChangedSubs.keys()).find(i=>i.endpoints?.endpointDetails?.find(r=>r?.endpointMetadata?.processingModes?.realTimeTranscript?.state==="Active"))?this._updateIsTranscriptionActive(!0):this._updateIsTranscriptionActive(!1)}catch(i){this._logger.warn("Unable to read transcription state: ",i)}}}get isTranscriptionActive(){return this._isTranscriptionActive}initialize(e,i,r,o){this._logger=i.createChild(()=>`TranscriptionFeature::Call(id='${e.callId}', state='${e.state}')`),this._callInfo=r,this._call=o,e.on("participantAdded",l=>{this._isCallingApplication(l)&&this._handleBotAdded(l)}),e.participants.forEach(l=>{this._isCallingApplication(l)&&this._handleBotAdded(l)}),e.on("participantRemoved",l=>{this._isCallingApplication(l)&&this._handleBotRemoved(l)})}get isTeamsConsentRequired(){return this._call.explicitConsentStateImp.isConsentRequiredInCall()}dispose(){this._updateIsTranscriptionActive(!1),this._botChangedSubs.forEach((e,i)=>e.dispose()),this._botChangedSubs.clear()}}class spe{get state(){return this._state}get error(){return this._error}constructor(e,i,r=!0){return this._eventEmitter=new $c.EventEmitter,this._lastTsTransferState=0,this._getTransferEndReason=(o,l=0)=>{let d=l,h=0,p=o||"Unknown";this._tsCall&&(d=this._tsCall.transferDiagnosticsInfo&&this._tsCall.transferDiagnosticsInfo.callControllerCode||l,h=this._tsCall.transferDiagnosticsInfo&&this._tsCall.transferDiagnosticsInfo?.callControllerSubCode||0,p=d2e(this._tsCall.terminatedReason));const g={code:d,subCode:h};return this._logger[d===0?"info":"error"](`Transfer end reason=${p}, code=${d}, subCode=${h}`),g},this._state="None",this._logger=i.createChild(()=>"Transfer"),this._logger.log("created"),this._tsCall=e,r?e.state!==4?(this._logger.error("Transfer end reason= call must be on hold before transfer"),this._error={code:FDe},void this.setTransferState(4)):(this._lastTsTransferState=this._tsCall.transferState,this.setTransferState(this._tsCall.transferState),void this._tsCall.changed(()=>{this._tsCall.transferState!==this._lastTsTransferState&&(this._logger.log(`tsCall transfer state changed=${this._tsCall.transferState}`),this._lastTsTransferState=this._tsCall.transferState,this.setTransferState(this._tsCall.transferState))})):(this._logger.error("Transfer end reason= call was not found with this callId"),this._error={code:FDe},void this.setTransferState(4))}on(e,i){this._eventEmitter.on(e,i)}off(e,i){this._eventEmitter.off(e,i)}setTransferState(e){let i,r;const o={0:"None",1:"Transferring",2:"Transferring",3:"Transferred",4:"Failed"};o[e]?(i=o[e],i==="Failed"&&(r=this._getTransferEndReason(),this._error=r),this._logger.log(`Mapped ts transfer state:[${e}] to [${i}]`),this._setTransferState(i)):this._logger.warn(`unable to map tsCall state=[${e}] to transfer state`)}_setTransferState(e){e!==this._state&&(this._logger.log(`transfer state changed [${this._state}]=>[${this.state}]`),this._state=e,this._eventEmitter.emit("stateChanged"))}}class kQ{constructor(){this.CAUSE_ID_TO_NETWORK_INFO={}}static getInstance(){return this.instance||(this.instance=new kQ),this.instance}deleteNetworkInfo(e){delete this.CAUSE_ID_TO_NETWORK_INFO[e]}ifCauseIdExistsRemoveNetworkInfo(e){return this.CAUSE_ID_TO_NETWORK_INFO[e]&&this.CAUSE_ID_TO_NETWORK_INFO[e].length===0?!!this.getRemoveCauseIdToNetworkInfo(e):!!this.CAUSE_ID_TO_NETWORK_INFO[e]}getRemoveCauseIdToNetworkInfo(e){if(!wt().telemetry.sendNetworkInfo)return;const i=this.CAUSE_ID_TO_NETWORK_INFO[e];return i&&this.deleteNetworkInfo(e),i}setCauseIdToNetworkInfo(e,i){Object.keys(this.CAUSE_ID_TO_NETWORK_INFO).length>100&&(this.CAUSE_ID_TO_NETWORK_INFO={}),i?this.CAUSE_ID_TO_NETWORK_INFO[e]?this.CAUSE_ID_TO_NETWORK_INFO[e].push({url:i.url,statusCode:i.statusCode,start:i.start,end:i.end,deltaTimeInMs:i.deltaTimeInMs,causeId:i.causeId}):this.CAUSE_ID_TO_NETWORK_INFO[e]=[{url:i.url,statusCode:i.statusCode,start:i.start,end:i.end,deltaTimeInMs:i.deltaTimeInMs,causeId:i.causeId}]:this.CAUSE_ID_TO_NETWORK_INFO[e]=[]}}kQ.instance=null;const wo=kQ.getInstance();var cUt=function(t,e,i,r){var o,l=arguments.length,d=l<3?e:r===null?r=Object.getOwnPropertyDescriptor(e,i):r;if(typeof Reflect=="object"&&typeof Reflect.decorate=="function")d=Reflect.decorate(t,e,i,r);else for(var h=t.length-1;h>=0;h--)(o=t[h])&&(d=(l<3?o(d):l>3?o(e,i,d):o(e,i))||d);return l>3&&d&&Object.defineProperty(e,i,d),d},lpe=function(t,e){if(typeof Reflect=="object"&&typeof Reflect.metadata=="function")return Reflect.metadata(t,e)};class dUt extends Bu{constructor(e){super(e),this._impl=new J2e(this.eventEmitter)}get name(){return this._sendFeatureUsage("name",Je.getter),"Transfer"}transfer(e,i){return this._impl.transfer(e,i)}initialize(e,i){this._logger=i,this._telemetryLogManager=e.telemetryLogManager,this._call=e.call,this._impl.initialize(e.tsCall,e.callAgent,e.telemetryLogManager,i),this._sendFeatureUsage("initialize",Je.initialize)}on(e,i){this._sendFeatureUsage(e,Je.subscribe),this.eventEmitter.on(e,i)}off(e,i){this._sendFeatureUsage(e,Je.subscribe),this.eventEmitter.on(e,i)}_sendFeatureUsage(e,i){Pc({callId:this._call.id,localParticipantId:this._call.tsCall.participantId,featureName:"Transfer",featureType:"Call",initializationType:"OnFeatureAccess",featureDetails:{name:e,step:i}},this._telemetryLogManager,this._logger)}dispose(){this._sendFeatureUsage("dispose",Je.attempt),this.disposed?this._sendFeatureUsage("dispose",Je.failure):(this._impl.dispose(),super.dispose(),this._sendFeatureUsage("dispose",Je.success))}}class J2e{constructor(e){this._eventEmitter=e,this._autoAccept=wt().calling.transfer.autoAccept}initialize(e,i,r,o){this._logger=o.createChild(()=>`TransferFeature::Call(id='${e.callId}', state='${e.state}')`),this._telemetryLogManager=r,this._tsCall=e,this._callAgent=i,e.on("transferRequested",async l=>{try{const d=this.getTransferRequestPayload(l);if(this._autoAccept){const h=await d.accept();this._eventEmitter.emit("transferAccepted",{targetCall:h})}}catch(d){this._logger.error(`Failed to handle transferRequested event: ${d?.message??"unknown error"}`)}})}transfer(e,i){let r="safe";if(e.targetCallId?r="consultative":e.targetParticipantVoicemail&&(r="voicemail"),this._sendFeatureUsage(r,Je.attempt,i),!this.isTransferable(this._tsCall))throw this._sendFeatureUsage(r,Je.failure,i),new Oe({defaultError:we.FEATURES.TRANSFER.UNSUPPORTED_CALL_TYPE});const o=fd();wo.setCauseIdToNetworkInfo(o);try{let l;switch(r){case"safe":return l=this.transferToParticipant(e.targetParticipant,o,i),this._sendFeatureUsage(r,Je.success,i,wo.getRemoveCauseIdToNetworkInfo(o)),l;case"consultative":return l=this.transferToCall(e.targetCallId,o,i),this._sendFeatureUsage(r,Je.success,i,wo.getRemoveCauseIdToNetworkInfo(o)),l;case"voicemail":return l=this.transferToParticipantVoicemail(e.targetParticipantVoicemail,i),this._sendFeatureUsage(r,Je.success,i),l}}catch(l){if(this._sendFeatureUsage(r,Je.failure,i,wo.getRemoveCauseIdToNetworkInfo(o)),l instanceof Oe)throw l}throw this._sendFeatureUsage(r,Je.failure,i),new Oe({defaultError:we.FEATURES.TRANSFER.TARGET_NOT_RECOGNIZED})}getTransferRequestPayload(e){const i=Sl(e.transferContext.targetMri);if(i.kind==="communicationUser"||i.kind==="phoneNumber"||i.kind==="microsoftTeamsUser"||i.kind==="unknown"||i.kind==="microsoftTeamsApp"){let r=!1;return{accept:async()=>{let l;try{if(l=await this._callAgent.createTransferTargetCall(e.transferContext),r)return this._logger.info("Transfer accept was called when transfer action is already in progress."),l;r=!0;const d={threadId:"",messageId:void 0,transferContext:e.transferContext,mediaPeerType:0};l.startCallInternal(void 0,!1,void 0,d).catch(p=>{r=!1,e.onCompleted(7),this._logger.error("Transfer to target failed at call start")});const h=()=>{if(r)switch(l.state){case"Connected":r=!1,e.onCompleted(1),this._logger.info("Transfer Completed"),l.off("stateChanged",()=>{});break;case"Disconnected":r=!1,e.onCompleted(7),this._logger.info(`Transfer call disconnected. 
                                            code = ${l.callEndReason?.code} 
                                            subcode = ${l.callEndReason?.subCode} 
                                            message = ${l.callEndReason?.message} 
                                            result categories = ${l.callEndReason?.resultCategories}`),l.off("stateChanged",()=>{})}};return l.on("stateChanged",h),l}catch(d){throw r=!1,e.onCompleted(7),this._logger.error("Transfer to target failed at call create"),new Oe({defaultError:we.FEATURES.TRANSFER.TRANSFER_TO_TARGET_FAILED,originalError:d})}}}}throw new Oe({defaultError:we.FEATURES.TRANSFER.INVALID_TARGET_TYPE,defaultErrorMessageArgs:[i]})}isTransferable(e){return e.callType===1||e.participants.filter(i=>!fO(i.id)).length<=2}transferToParticipant(e,i,r){const o=zr(e);let l;return r&&(l={disableForwardingAndUnanswered:r.disableForwardingAndUnanswered,clientTransferContext:{customContext:h6(r)}}),this._tsCall.state===4&&this._tsCall.callSafeTransfer(o,i,l),new spe(this._tsCall,this._logger)}transferToCall(e,i,r){const o=this._callAgent.getCallByCallId(e);if(o&&!this.isTransferable(o))throw new Oe({defaultError:we.FEATURES.TRANSFER.UNSUPPORTED_CALL_TYPE});let l;return r&&(l={clientTransferContext:{customContext:h6(r)}}),o&&this._tsCall.state===4&&this._tsCall.callConsultativeTransfer(o,i,void 0,l),new spe(this._tsCall,this._logger,!!o)}transferToParticipantVoicemail(e,i){const r=zr(e);if(this._tsCall.state===4){const o={transferTargetMri:r};this._tsCall.transferCallToVoicemail(o)}return new spe(this._tsCall,this._logger)}_sendFeatureUsage(e,i,r,o){Pc({callId:this._tsCall.callId,localParticipantId:this._tsCall.participantId,featureName:"Transfer",featureType:"Call",initializationType:"OnFeatureAccess",featureDetails:{name:e,step:i},additionalDetails:{transferConstraint:{userToUserPresent:!!r?.customContext?.userToUser,xHeadersPresent:!!r?.customContext?.xHeaders&&r.customContext.xHeaders.length>0,type:e==="safe"?"participant":e==="consultative"?"call":"voicemail"}},networkInfo:o||[]},this._telemetryLogManager,this._logger)}dispose(){}}cUt([sg(LB.Transfer),lpe("design:type",Function),lpe("design:paramtypes",[Object,Object]),lpe("design:returntype",Object)],J2e.prototype,"transfer",null);class hP{constructor(e,i,r,o){this._name=e,this._id=i,this._deviceType=r,this._deviceManager=o}get name(){return this._name}setName(e){this._name=e}get id(){return this._id}setId(e){this._id=e}get deviceType(){return this._deviceType}setDeviceType(e){this._deviceType=e}get deviceManager(){return this._deviceManager}}function zv(t,e){Reflect.defineMetadata(VDe,e,t)}function Xc(t){if(this._capacity=Q2e(t),this._length=0,this._front=0,Y2e(t)){for(var e=t.length,i=0;i<e;++i)this[i]=t[i];this._length=e}}Xc.prototype.toArray=function(){for(var e=this._length,i=new Array(e),r=this._front,o=this._capacity,l=0;l<e;++l)i[l]=this[r+l&o-1];return i},Xc.prototype.push=function(e){var i=arguments.length,r=this._length;if(i>1){var o=this._capacity;if(r+i>o){for(var l=0;l<i;++l)this._checkCapacity(r+1),this[d=this._front+r&this._capacity-1]=arguments[l],r++,this._length=r;return r}for(var d=this._front,l=0;l<i;++l)this[d+r&o-1]=arguments[l],d++;return this._length=r+i,r+i}return i===0?r:(this._checkCapacity(r+1),this[l=this._front+r&this._capacity-1]=e,this._length=r+1,r+1)},Xc.prototype.pop=function(){var e=this._length;if(e!==0){var i=this._front+e-1&this._capacity-1,r=this[i];return this[i]=void 0,this._length=e-1,r}},Xc.prototype.shift=function(){var e=this._length;if(e!==0){var i=this._front,r=this[i];return this[i]=void 0,this._front=i+1&this._capacity-1,this._length=e-1,r}},Xc.prototype.unshift=function(e){var i=this._length,r=arguments.length;if(r>1){if(i+r>(l=this._capacity)){for(var o=r-1;o>=0;o--){this._checkCapacity(i+1);var l=this._capacity;this[h=(this._front-1&l-1^l)-l]=arguments[o],i++,this._length=i,this._front=h}return i}var d=this._front;for(o=r-1;o>=0;o--){var h;this[h=(d-1&l-1^l)-l]=arguments[o],d=h}return this._front=d,this._length=i+r,i+r}return r===0?i:(this._checkCapacity(i+1),l=this._capacity,this[o=(this._front-1&l-1^l)-l]=e,this._length=i+1,this._front=o,i+1)},Xc.prototype.peekBack=function(){var e=this._length;if(e!==0)return this[this._front+e-1&this._capacity-1]},Xc.prototype.peekFront=function(){if(this._length!==0)return this[this._front]},Xc.prototype.get=function(e){var i=e;if(i===(0|i)){var r=this._length;if(i<0&&(i+=r),!(i<0||i>=r))return this[this._front+i&this._capacity-1]}},Xc.prototype.isEmpty=function(){return this._length===0},Xc.prototype.clear=function(){for(var e=this._length,i=this._front,r=this._capacity,o=0;o<e;++o)this[i+o&r-1]=void 0;this._length=0,this._front=0},Xc.prototype.toString=function(){return this.toArray().toString()},Xc.prototype.valueOf=Xc.prototype.toString,Xc.prototype.removeFront=Xc.prototype.shift,Xc.prototype.removeBack=Xc.prototype.pop,Xc.prototype.insertFront=Xc.prototype.unshift,Xc.prototype.insertBack=Xc.prototype.push,Xc.prototype.enqueue=Xc.prototype.push,Xc.prototype.dequeue=Xc.prototype.shift,Xc.prototype.toJSON=Xc.prototype.toArray,Object.defineProperty(Xc.prototype,"length",{get:function(){return this._length},set:function(){throw new RangeError("")}}),Xc.prototype._checkCapacity=function(e){this._capacity<e&&this._resizeTo(Q2e(1.5*this._capacity+16))},Xc.prototype._resizeTo=function(e){var i=this._capacity;this._capacity=e;var r=this._front,o=this._length;r+o>i&&uUt(this,0,this,i,r+o&i-1)};var Y2e=Array.isArray;function uUt(t,e,i,r,o){for(var l=0;l<o;++l)i[l+r]=t[l+e],t[l+e]=void 0}function hUt(t){return t>>>=0,t-=1,t|=t>>1,t|=t>>2,t|=t>>4,t|=t>>8,(t|=t>>16)+1}function Q2e(t){if(typeof t!="number"){if(!Y2e(t))return 16;t=t.length}return hUt(Math.min(Math.max(16,t),1073741824))}var cpe=Xc;class rh{static overrideDefaultLogDump(){if(rh.logDump.isEmpty())rh.logDump=new cpe(wt()?.debugInfo?.maxLogDumpLength);else{let e=new cpe(wt()?.debugInfo?.maxLogDumpLength);for(;rh.logDump.length>0;){const i=rh.logDump.shift();i&&e.push(i)}rh.logDump=e}}constructor(e,i=[],r=rh.defaultLogRedirect){this._azureLogger=e,this._namespace=i,this._logRedirectCallback=r}createChild(e){return new rh(this._azureLogger,[...this._namespace,typeof e=="string"?()=>e:e])}createFnLogger(e,i,...r){return this.createChild(this.getPrefix(e,i)+r.join(""))}log(...e){const i=this.getMessage(e);this._azureLogger.verbose(i),this._logRedirectCallback(`log:${i}`)}debug(...e){const i=this.getMessage(e);this._azureLogger.verbose(i),this._logRedirectCallback(`debug:${i}`)}info(...e){const i=this.getMessage(e);this._azureLogger.info(i),this._logRedirectCallback(`info:${i}`)}warn(...e){const i=this.getMessage(e);this._azureLogger.warning(i),this._logRedirectCallback(`warn:${i}`)}error(...e){const i=this.getMessage(e);this._azureLogger.error(this.getMessage(e)),this._logRedirectCallback(`error::${i}`)}getMessage(...e){return`${Cxt()} ${this.getNamespace()} ${e.join(" ")}`}getNamespace(){return this._namespace.map(e=>e()).join(":")}getPrefix(e,i){let r="";return i&&(r+=i),e&&(r+=e),r}redirectLog(e){this._logRedirectCallback=i=>{rh.defaultLogRedirect(i),e(i)}}dumpAllLogs(){return[...rh.logDump.toArray()]}}rh.logDump=new cpe(Nxe),rh.defaultLogRedirect=t=>{if(wt()?.debugInfo?.enableLogDump){const e=()=>{rh.logDump.length>wt()?.debugInfo?.maxLogDumpLength&&rh.logDump.shift()};if(wt()?.debugInfo?.includeList.some(i=>dn.includes(t,i))||!wt()?.debugInfo?.excludeList.some(i=>dn.includes(t,i)))return rh.logDump.push(t),void e()}};var Vv,pUt=function(t,e,i,r){var o,l=arguments.length,d=l<3?e:r;if(typeof Reflect=="object"&&typeof Reflect.decorate=="function")d=Reflect.decorate(t,e,i,r);else for(var h=t.length-1;h>=0;h--)(o=t[h])&&(d=(l<3?o(d):l>3?o(e,i,d):o(e,i))||d);return l>3&&d&&Object.defineProperty(e,i,d),d},gUt=function(t,e){if(typeof Reflect=="object"&&typeof Reflect.metadata=="function")return Reflect.metadata(t,e)};class L6{constructor(e){this._telemetryLogManager=e}sendMediaStreamEvent(e){this._telemetryLogManager?.sendEvent({name:vi.acs_calling_media_stream,tenant:Wr,properties:{correlationId:e.correlationId,mediaType:e.mediaType,operation:e.operation,timestampInfo:e.timestampInfo,streamType:e.streamType||Ts.Local,additionalDetails:e.additionalDetails||"",kindOfEvent:e.kindOfEvent||"",callId:e.callId||"",localPaticipantId:e.localParticipantId||"",createViewResolvedOnPlayEvent:e.createViewResolvedOnPlayEvent||""}})}}pUt([zv,gUt("design:type",Object)],L6.prototype,"logger",void 0);class Z2e{constructor(e,i,r){this._logger=e,this._environmentInfo=i,this._isVdi3Enabled=r,this._videoEffectsEnabled=!1,this._audioEffectsEnabled=!1,this._videoEffectsSupported=!1,this._audioEffectsSupported=!1,this._config=wt(),this._mediaConfig=nQ(),this._videoEffectsEnabled=!(!this._mediaConfig?.enableVideoEffects||!this._config?.videoEffects?.enableVideoEffects),this._audioEffectsEnabled=!!this._config?.audioEffects?.enableAudioEffects,this._videoEffectsEnabled&&(this._videoEffectsSupported=this._mediaConfig?.webcv?.useWasmEffects?this._isWasmVideoEffectSupported():this._isWebgl2EffectSupported())}async videoEffectsSupported(){if(this._videoEffectsEnabled){const e=this._mediaConfig?.webcv?.useWasmEffects?this._isWasmVideoEffectSupported():this._isWebgl2EffectSupported();this._videoEffectsSupported=e&&this._isCurrentEnvironmentSDKSupported()}else this._logger.info("Video effects are disabled."),this._videoEffectsSupported=!1;return this._videoEffectsSupported}async audioEffectsSupported(e){return this._audioEffectsEnabled?this._audioEffectsSupported=this._isBrowserEffect(e)?this._isBrowserEffectSupported(e):await this._isWasmAudioEffectSupported():(this._logger.info("Audio effects are disabled."),this._audioEffectsSupported=!1),this._audioEffectsSupported}_isBrowserEffect(e){if(typeof e=="string")switch(e){case"BrowserEchoCancellation":case"BrowserNoiseSuppression":case"BrowserAutoGainControl":return!0;default:return!1}return!1}_isBrowserEffectSupported(e){if(this._isVdi3Enabled)return!0;const i=window.navigator?.mediaDevices?.getSupportedConstraints?.();if(i)switch(e){case"BrowserEchoCancellation":return!!i.echoCancellation;case"BrowserNoiseSuppression":return!!i.noiseSuppression;case"BrowserAutoGainControl":return!!i.autoGainControl;default:return!1}return!1}_isCurrentEnvironmentSDKSupported(){return!!(this._environmentInfo.isSupportedBrowser&&this._environmentInfo.isSupportedBrowserVersion&&this._environmentInfo.isSupportedEnvironment&&this._environmentInfo.isSupportedPlatform)}_isWasmVideoEffectSupported(){return this._mediaConfig?.webcv?.useWasmEffects?!!window.MediaStreamTrackProcessor||(this._logger.info("WASM effects disabled, insertable streams are not supported"),!1):(this._logger.info("WASM effects disabled by WebCV feature flag"),!1)}_isWebgl2EffectSupported(){return this._isCurrentRendererSupported()&&this._isWebGL2Supported()}_isCurrentRendererSupported(){const e=this._mediaConfig?.webcv?.webGLUnsupportedRenderers??[];let i=!1;try{const r=document.createElement("canvas").getContext("webgl"),o=r?.getExtension("WEBGL_debug_renderer_info"),l=o&&r?.getParameter(o.UNMASKED_RENDERER_WEBGL);return l&&!e.some(d=>d===l)?i=!0:this._logger.info(`Unsupported renderer: ${d6(l)}`),i}catch(r){return this._logger.warn(`Error trying to check compatibility: ${JSON.stringify(r)}`),!1}}_isWebGL2Supported(){try{const e=document.createElement("canvas").getContext("webgl2");if(!e)return this._logger.info("WebGL2 context is not supported"),!1;const i=e.getSupportedExtensions(),r=this._mediaConfig?.webcv?.webGLRequiredExtensions.filter(o=>!i?.includes(o));if(r.length>0)return this._logger.info(`Unsupported WebGL2 extensions: ${d6(r)}`),!1}catch(e){return this._logger.error(`isWebGL2Supported: ${d6(e)}`),!1}return!0}async _isWasmAudioEffectSupported(){return window.AudioWorkletNode?!!window.WebAssembly||(this._logger.info("WebAssembly is not supported"),!1):(this._logger.info("AudioWorkletNode is not supported"),!1)}}function X2e(t){if(typeof t=="object"){if("initializeMediaAgent"in t)return Vv.IPluginlessCallingStack;if("setConfiguration"in t)return Vv.ICallRegistry;if("joinCallWithoutCallModality"in t)return Vv.ICall;if("getSourceIdForMediaType"in t)return Vv.ICallParticipant;if("getDiagnosticData"in t&&"start"in t)return Vv.ICallParticipantStream;if("askDevicePermission"in t)return Vv.IDeviceManager}return Vv.None}function eUe(t){if(typeof t!="object"||t===Object.prototype)return!1;for(const[,e]of Object.entries(Object.getOwnPropertyDescriptors(t)))if(e.get!==void 0||e.value!==void 0&&typeof e.value=="function")return!0;return eUe(Object.getPrototypeOf(t))}(function(t){t[t.None=0]="None",t[t.IPluginlessCallingStack=1]="IPluginlessCallingStack",t[t.ICallRegistry=2]="ICallRegistry",t[t.ICall=3]="ICall",t[t.ICallParticipant=4]="ICallParticipant",t[t.ICallParticipantStream=5]="ICallParticipantStream",t[t.IDeviceManager=6]="IDeviceManager"})(Vv||(Vv={}));const xB=Symbol();function $v(t){return typeof t=="object"&&xB in t}var tUe=function(t,e,i,r){var o,l=arguments.length,d=l<3?e:r===null?r=Object.getOwnPropertyDescriptor(e,i):r;if(typeof Reflect=="object"&&typeof Reflect.decorate=="function")d=Reflect.decorate(t,e,i,r);else for(var h=t.length-1;h>=0;h--)(o=t[h])&&(d=(l<3?o(d):l>3?o(e,i,d):o(e,i))||d);return l>3&&d&&Object.defineProperty(e,i,d),d},V3=function(t,e){if(typeof Reflect=="object"&&typeof Reflect.metadata=="function")return Reflect.metadata(t,e)};const mUt=[{acsEffect:"Off",tsCallingEffect:0},{acsEffect:"BackgroundBlur",tsCallingEffect:1},{acsEffect:"BackgroundReplacement",tsCallingEffect:16}];class RQ extends a2e{constructor(){super(...arguments),this._effect=null,this._fpsWarningEventIntervalIds=[],this._fpsWarningEventTimeoutIds=[],this._tsCallingEffectCapability=0,this._tsCallingSupportedEffects=[{acsEffect:"Off",tsCallingEffect:0}],this._activeEffects=[],this._sourceStreamSubscription=null,this._stringForUnknownInput="UNKNOWN",this.configUpdatedCallback=async e=>{const i=ln(),r=this.getUsageDetailsForTelemetry("Configure method",e),o=+new Date;try{this.sendFeatureUsageTelemetry({eventName:vi.acs_calling_media_stream,correlationId:i,operation:Sr.effectConfigureUpdate,kindOfEvent:Je.attempt,additionalDetails:{usageDetails:r,effectsSdk:{videoEffects:{backgroundImageHasTransparentPixels:this.getBackgroundImageHasTransparentPixel()}}}});const l=this._internalDeviceManager.getTsDeviceManager();if(e==="BackgroundReplacement"){const d=(this._effect?._internalHandle?.effectConfig).backgroundImageUrl;d&&await l.setBackgroundImageAsync("",d),this.sendFeatureUsageTelemetry({eventName:vi.acs_calling_media_stream,correlationId:i,operation:Sr.effectConfigureUpdate,timestampInfo:{deltaTimeInMs:+new Date-o},kindOfEvent:Je.success,additionalDetails:{usageDetails:r,effectsSdk:{videoEffects:{backgroundImageHasTransparentPixels:this.getBackgroundImageHasTransparentPixel()}}}})}this._logger.info("effect config was updated")}catch(l){const d=new Oe({defaultError:we.FEATURES.VIDEO_EFFECTS.EFFECT_CONFIG_UPDATE_CALLBACK_FAILED,originalError:l});this._logger.error(d.message),this.sendFeatureUsageTelemetry({eventName:vi.acs_calling_media_stream,correlationId:i,operation:Sr.effectConfigureUpdate,timestampInfo:{deltaTimeInMs:+new Date-o},kindOfEvent:Je.failure,additionalDetails:{failureReason:d.message,code:d.code,...an(d),usageDetails:r}})}},this.processingErrorCallback=async e=>{const i=ln();this.eventEmitter.emit("effectsError",e);const r=this.getEffectNameForTelemetry(this._effect?.name),o=this.getUsageDetailsForTelemetry("Internal handle error",r);this.sendFeatureUsageTelemetry({eventName:vi.acs_calling_media_stream,correlationId:i,operation:Sr.effectsError,kindOfEvent:Je.failure,additionalDetails:{failureReason:e.message,code:e.code,...an(e),usageDetails:o}}),await this.stopEffects()},this.effectStatusChangedCallback=(e,i)=>{if(i.length>0){const r=this._effect?.name?[this._effect.name]:i;this.eventEmitter.emit("effectsStarted",r)}else{const r=this._effect?.name?[this._effect.name]:e;this.eventEmitter.emit("effectsStopped",r)}}}initialize(e,i){this._logger=i.createChild(" - VideoEffects:"),this._telemetryLogManager=e.telemetryLogManager,this.updateEffectStatusManager()}get name(){return"VideoEffects"}get activeEffects(){return this._effectsStatusManager?.getActiveEffects?.()??this._activeEffects}on(e,i){if(e!=="effectsStarted"&&e!=="effectsStopped"&&e!=="effectsError"&&e!=="fpsWarningThresholdReached"&&e!=="timeForEffectsWarningReached")throw new Oe({defaultError:we.FEATURES.VIDEO_EFFECTS.EVENT_SUBSCRIBE,defaultErrorMessageArgs:[e]});this.eventEmitter.on(e,i);const r=ln();this.sendFeatureUsageTelemetry({eventName:vi.acs_calling_media_stream,correlationId:r,operation:Sr.subscribe,additionalDetails:{usageDetails:`Subscribed to ${e}`}})}off(e,i){if(e!=="effectsStarted"&&e!=="effectsStopped"&&e!=="effectsError"&&e!=="fpsWarningThresholdReached"&&e!=="timeForEffectsWarningReached")throw new Oe({defaultError:we.FEATURES.VIDEO_EFFECTS.EVENT_UNSUBSCRIBE,defaultErrorMessageArgs:[e]});this.eventEmitter.off(e,i)}async isSupported(e){const i=ln(),r=+new Date,o=this.getEffectNameForTelemetry(e?.name),l=this.getUsageDetailsForTelemetry("",o);this.sendFeatureUsageTelemetry({eventName:vi.acs_calling_media_stream,correlationId:i,operation:Sr.isSupported,kindOfEvent:Je.attempt,additionalDetails:{usageDetails:l}});try{this._logger.info(`isSupported attempted with input ${this.getEffectNameForTelemetry(e?.name)}`);const d=this.getEffectInternalCast(e);if(this.disposed)throw new Oe({defaultError:we.FEATURES.VIDEO_EFFECTS.START_DISPOSED});if(!this.streamInstance.canStartEffects)throw new Oe({defaultError:we.FEATURES.VIDEO_EFFECTS.UNSUPPORTED_SOURCE});this._internalDeviceManager||(this._internalDeviceManager=this.streamInstance.source.deviceManager);const h=this._internalDeviceManager.getEnvironmentInfoInternal(),p=$v(this._internalDeviceManager.getTsDeviceManager());this._supportChecker||(this._supportChecker=new Z2e(this._logger,h,p));const g=await this._supportChecker.videoEffectsSupported();this._logger.info(`Support check for ${d.name} resulted in: ${g}`);const f=this.getUsageDetailsForTelemetry("",d.name);return this.sendFeatureUsageTelemetry({eventName:vi.acs_calling_media_stream,correlationId:i,operation:Sr.isSupported,timestampInfo:{deltaTimeInMs:+new Date-r},kindOfEvent:Je.success,additionalDetails:{usageDetails:f}}),this._logger.info("isSupported success"),g}catch(d){const h=new Oe({defaultError:we.FEATURES.VIDEO_EFFECTS.SUPPORT_CHECK_FAILED,originalError:d});this._logger.error(h.message);const p=this.getEffectNameForTelemetry(e?.name),g=this.getUsageDetailsForTelemetry("",p);throw this.sendFeatureUsageTelemetry({eventName:vi.acs_calling_media_stream,correlationId:i,operation:Sr.isSupported,timestampInfo:{deltaTimeInMs:+new Date-r},kindOfEvent:Je.failure,additionalDetails:{failureReason:h.message,code:h.code,...an(h),usageDetails:g}}),h}}async startEffects(e){const i=ln(),r=+new Date,o=this.getEffectNameForTelemetry(e?.name),l=this.getUsageDetailsForTelemetry("",o);this.sendFeatureUsageTelemetry({eventName:vi.acs_calling_media_stream,correlationId:i,operation:Sr.startEffects,kindOfEvent:Je.attempt,additionalDetails:{usageDetails:l}});try{if(this._logger.info(`startEffects attempted with input ${this.getEffectNameForTelemetry(e?.name)}`),!wt().videoEffects.enableVideoEffects)throw new Oe({defaultError:we.FEATURES.VIDEO_EFFECTS.DISABLED});if(this.disposed)throw new Oe({defaultError:we.FEATURES.VIDEO_EFFECTS.START_DISPOSED});if(!this.streamInstance.canStartEffects)throw new Oe({defaultError:we.FEATURES.VIDEO_EFFECTS.UNSUPPORTED_SOURCE});this._internalDeviceManager||(this._internalDeviceManager=this.streamInstance.source.deviceManager),this.updateEffectStatusManager(),this.subscribeToStreamInstanceEvents();const d=window.performance.now();if(this._effect=this.getEffectInternalCast(e),!await this.isSupported(e))throw new Oe({defaultError:we.FEATURES.VIDEO_EFFECTS.UNSUPPORTED_EFFECT});const h=this._internalDeviceManager.getTsDeviceManager();if(!h)throw new Oe({defaultError:we.FEATURES.VIDEO_EFFECTS.START_DEVICE_MANAGER});this.setConfigForEffects(),this.disposeEffectEventSubscriptions(),this.subscribeToEffectEvents();const p=await this._effect._internalHandle.getEffectProvider();if(!p)throw new Oe({defaultError:we.FEATURES.VIDEO_EFFECTS.PROVIDER_UNAVAILABLE});const g=await p.getVideoEffectProvider(),f=this.streamInstance.callStackWebCVProvider;if(!f)throw new Oe({defaultError:we.FEATURES.VIDEO_EFFECTS.WEBCV_PROVIDER_FAILED});f.videoEffectProviderDeferredPromise.resolve(g),this._tsCallingEffectCapability===0&&(this._tsCallingEffectCapability=await h?.getDeviceEffectsCapabilityAsync("")),this._tsCallingSupportedEffects=this.getTsCallingSupportedEffects();const y=this._tsCallingSupportedEffects.find(E=>E.acsEffect===this._effect?.name);if(!y)throw new Oe({defaultError:we.FEATURES.VIDEO_EFFECTS.UNSUPPORTED_EFFECT});await h?.setDeviceEffectsAsync("",y.tsCallingEffect),this._effectsStatusManager.setActiveEffects([this._effect.name]),this._logger.info(`Video effects started: ${this._effect.name}`);const T=window.performance.now();this.handleEffectsInitTimeEvent(d,T),this.handleFpsWarningEvent();const C=this.getUsageDetailsForTelemetry("",this._effect.name);this.sendFeatureUsageTelemetry({eventName:vi.acs_calling_media_stream,correlationId:i,operation:Sr.startEffects,timestampInfo:{deltaTimeInMs:+new Date-r},kindOfEvent:Je.success,additionalDetails:{usageDetails:C,effectsSdk:{videoEffects:{backgroundImageHasTransparentPixels:this.getBackgroundImageHasTransparentPixel()}}}}),this._logger.info("startEffects success")}catch(d){const h=new Oe({defaultError:we.FEATURES.VIDEO_EFFECTS.START_FAILED,originalError:d});this._logger?.error(h.message),this.eventEmitter.emit("effectsError",h),this.clearFpsCheckInterval();const p=this.getEffectNameForTelemetry(e?.name),g=this.getUsageDetailsForTelemetry("",p);this.sendFeatureUsageTelemetry({eventName:vi.acs_calling_media_stream,correlationId:i,operation:Sr.startEffects,timestampInfo:{deltaTimeInMs:+new Date-r},kindOfEvent:Je.failure,additionalDetails:{failureReason:h.message,code:h.code,...an(h),usageDetails:g,effectsSdk:{videoEffects:{backgroundImageHasTransparentPixels:this.getBackgroundImageHasTransparentPixel()}}}})}}async stopEffects(){const e=ln(),i=+new Date;this.sendFeatureUsageTelemetry({eventName:vi.acs_calling_media_stream,correlationId:e,operation:Sr.stopEffects,kindOfEvent:Je.attempt});try{if(this._logger.info("stopEffects attempted"),this.clearFpsCheckInterval(),this.disposed)throw new Oe({defaultError:we.FEATURES.VIDEO_EFFECTS.STOP_DISPOSED});this._internalDeviceManager||(this._internalDeviceManager=this.streamInstance.source.deviceManager);const r=this._internalDeviceManager.getTsDeviceManager();if(!r)throw new Oe({defaultError:we.FEATURES.VIDEO_EFFECTS.STOP_DEVICE_MANAGER});this.updateEffectStatusManager();const o=this._tsCallingSupportedEffects.find(d=>d.acsEffect==="Off");if(!o)throw new Oe({defaultError:we.FEATURES.VIDEO_EFFECTS.UNSUPPORTED_EFFECT});await r.setDeviceEffectsAsync("",o.tsCallingEffect),this._effectsStatusManager?.setActiveEffects([]),this.unsubscribeFromStreamInstanceEvents();const l=this.getEffectNameForTelemetry(this._effect?.name);this._logger.info(`Video effects stopped: ${l}`),this.sendFeatureUsageTelemetry({eventName:vi.acs_calling_media_stream,correlationId:e,operation:Sr.stopEffects,timestampInfo:{deltaTimeInMs:+new Date-i},kindOfEvent:Je.success}),this._logger.info("stopEffects success")}catch(r){const o=new Oe({defaultError:we.FEATURES.VIDEO_EFFECTS.STOP_FAILED,originalError:r});this._logger?.error(o.message),this.eventEmitter.emit("effectsError",o),this.sendFeatureUsageTelemetry({eventName:vi.acs_calling_media_stream,correlationId:e,operation:Sr.stopEffects,timestampInfo:{deltaTimeInMs:+new Date-i},kindOfEvent:Je.failure,additionalDetails:{failureReason:o.message,code:o.code,...an(o)}})}}async dispose(){try{if(this._logger.info("dispose attempted"),this.disposed)return void this._logger.info("VideoEffects feature already disposed");this._effect&&await this.stopEffects(),this.eventEmitter.removeAllListeners(),this.serialQueue.dispose(),this._effectsStatusManager?.off("statusChanged",this.effectStatusChangedCallback),this.unsubscribeFromStreamInstanceEvents(),this.disposed=!0,this._logger.info("VideoEffects feature disposed")}catch(e){const i=new Oe({defaultError:we.FEATURES.VIDEO_EFFECTS.DISPOSE_FAILED,originalError:e});this._logger?.error(i.message),this.eventEmitter.emit("effectsError",i)}}getEffectsSdkVersion(){let e=this._stringForUnknownInput;return this.activeEffects.length>0&&this._effect&&this._effect._internalHandle?.getVersion&&(e=this._effect._internalHandle?.getVersion()),this.truncateToMax(e)}getActiveEffectsForTelemetry(){return this.truncateToMax(JSON.stringify(this.activeEffects))}getEffectInternalCast(e){if(e?.name==="BackgroundBlur"&&this.isValidEffectInstance(e)||e?.name==="BackgroundReplacement"&&this.isValidEffectInstance(e))return e;throw new Oe({defaultError:we.FEATURES.VIDEO_EFFECTS.INVALID_EFFECT})}isValidEffectInstance(e){let i;return(e.name==="BackgroundBlur"&&e._internalHandle!==void 0||e.name==="BackgroundReplacement"&&e._internalHandle!==void 0)&&(i=e,this.hasValidInternalHandle(i._internalHandle))}hasValidInternalHandle(e){return e.effectConfig!==void 0&&e.getEffectProvider!==void 0&&e.dispose!==void 0&&e.getStats!==void 0&&e.setConfig!==void 0}getTsCallingSupportedEffects(){const e=[];return Object.values(mUt).forEach(i=>{(this._tsCallingEffectCapability&i.tsCallingEffect)===i.tsCallingEffect&&e.push(i)}),e}subscribeToEffectEvents(){this._effect&&this._internalDeviceManager?(this._effect._internalHandle.on("configUpdated",this.configUpdatedCallback),this._effect._internalHandle.on("processingError",this.processingErrorCallback)):this._logger.debug("No effect instance found.")}disposeEffectEventSubscriptions(){this._effect?(this._effect._internalHandle.off("configUpdated",this.configUpdatedCallback),this._effect._internalHandle.off("processingError",this.processingErrorCallback)):this._logger.debug("No effect instance found.")}subscribeToStreamInstanceEvents(){this._sourceStreamSubscription&&(this._logger.info("Already subscribed to videoSourceChanged, removing old sub"),this.streamInstance.off("videoSourceChanged",this._sourceStreamSubscription)),this._sourceStreamSubscription=async e=>{e.source&&e.source.mediaStreamType!=="Video"&&await this.stopEffects()},this.streamInstance.on("videoSourceChanged",this._sourceStreamSubscription)}unsubscribeFromStreamInstanceEvents(){this._sourceStreamSubscription?(this.streamInstance.off("videoSourceChanged",this._sourceStreamSubscription),this._sourceStreamSubscription=null):this._logger.info("No videoSourceChanged sub active")}handleEffectsInitTimeEvent(e,i){if(!this._effect)return void this._logger.debug("No effect active");const r=ln(),o=i-e,l=this._effect._internalHandle.effectConfig.effectInitTimeThresholdInMs;if(this._logger.info(`Time for effects to start: ${o}ms`),l&&o>l){this.eventEmitter.emit("timeForEffectsWarningReached",this._effect.name);const d=this.getUsageDetailsForTelemetry(`Threshold value: ${l}ms`,this._effect.name);this.sendFeatureUsageTelemetry({eventName:vi.acs_calling_media_stream,correlationId:r,operation:Sr.timeForEffectsWarningReached,additionalDetails:{usageDetails:d}})}}handleFpsWarningEvent(){if(!this._effect)return void this._logger.debug("No effect active");this.clearFpsCheckInterval();const e=wt(),i=ln(),r=e.videoEffects.waitTimeToInitiateFpsChecksInMs,o=e.videoEffects.fpsCheckIntervalTimeInMs;this._fpsWarningThresholdValue=this._effect._internalHandle.effectConfig.fpsWarningThreshold??e.videoEffects.fpsWarningThreshold;const l=()=>{const h=window.setInterval(()=>{const p=this._effect?._internalHandle.getStats(),g=p?.processor.fpsAvg;if(this._logger.info(`Effects avg fps check interval poll. Current Avg - ${g}`),g&&g<this._fpsWarningThresholdValue){this.eventEmitter.emit("fpsWarningThresholdReached",this._effect?.name),window.clearInterval(h),this._logger.info(`Effects fps warning threshold hit at ${g}fps`);const f=this.getUsageDetailsForTelemetry(`Fps reported: ${g}, Fps warning threshold value: ${this._fpsWarningThresholdValue}`,this._effect?.name);this.sendFeatureUsageTelemetry({eventName:vi.acs_calling_media_stream,correlationId:i,operation:Sr.fpsWarningThresholdReached,additionalDetails:{usageDetails:f}})}},o);this._fpsWarningEventIntervalIds.push(h)},d=window.setTimeout(l,r);this._fpsWarningEventTimeoutIds.push(d)}setConfigForEffects(){if(!this._effect)return void this._logger.debug("No effect active");const e=this._effect._internalHandle.configProvider.config.videoEffects??this._effect._internalHandle.configProvider.config,i=nQ(),r=wt();if(i?.enableVideoEffects&&r?.videoEffects?.enableVideoEffects&&(e.enableVideoEffects=i.enableVideoEffects&&r.videoEffects.enableVideoEffects),e.effectConfig={...e.effectConfig,effectInitTimeThresholdInMs:r.videoEffects.effectInitTimeThresholdInMs,fpsWarningThreshold:r.videoEffects.fpsWarningThreshold},i.webcv){const o=i.webcv;e.webcvConfig={...e.webcvConfig,...o}}this._effect._internalHandle.setConfig(e),this._logger.info(`Config for effects set: ${d6(e)}`)}sendFeatureUsageTelemetry(e){if(this._telemetryLogManager){e.additionalDetails={...e.additionalDetails,callState:this.streamInstance.getCall()?.state,activeEffects:JSON.stringify(this.activeEffects),effectsSdk:{...e.additionalDetails?.effectsSdk,version:this.getEffectsSdkVersion()}};try{const i={correlationId:e.correlationId,mediaType:Zc.VideoRaw,streamType:Ts.Local,operation:e.operation,timestampInfo:e.timestampInfo||{},kindOfEvent:e.kindOfEvent||"",additionalDetails:e.additionalDetails||"",callId:this.streamInstance.getCall()?.id||"",localParticipantId:this.streamInstance.getLocalParticipantId()||""};this._telemetryLogManager.sendEvent({name:e.eventName,tenant:Wr,properties:i})}catch{this._logger.debug(`Unable to send ${e.operation} telemetry`)}}else this._logger.debug("Telemetry error. Instance is undefined.")}getEffectNameForTelemetry(e){let i=this._stringForUnknownInput;return e?i=typeof e=="string"?e:JSON.stringify(e):this._effect?.name?i=this._effect.name:this._activeEffects?.[0]&&(i=JSON.stringify(this._activeEffects[0])),this.truncateToMax(i)}getUsageDetailsForTelemetry(e,i=""){return this.truncateToMax(`${i?`[${i}] `:""}${e}`)}clearFpsCheckInterval(){this._fpsWarningEventIntervalIds.forEach(e=>{window.clearInterval(e)}),this._fpsWarningEventTimeoutIds.forEach(e=>{window.clearTimeout(e)}),this._fpsWarningEventIntervalIds=[],this._fpsWarningEventTimeoutIds=[]}updateEffectStatusManager(){this.streamInstance.canStartEffects?(this._internalDeviceManager||(this._internalDeviceManager=this.streamInstance.source.deviceManager),this._effectsStatusManager||(this._effectsStatusManager=this._internalDeviceManager.callStackVideoEffectsStatusManager,this._effectsStatusManager.on("statusChanged",this.effectStatusChangedCallback)),this._activeEffects=this._effectsStatusManager.getActiveEffects()):this._logger.warn("Cannot update status manager, current source is not supported.")}truncateToMax(e){const i=wt().videoEffects.maxStringLengthForTelemetry;return e.length>i?(this._logger?.info("Truncating video effects info for telemetry"),e.substring(0,i-2)+".."):e}getBackgroundImageHasTransparentPixel(){try{if(this._effect?.name==="BackgroundReplacement"&&this._effect._internalHandle?.imageLoader?.loadedImageHasTransparentPixels!==void 0)return this._effect._internalHandle.imageLoader?.loadedImageHasTransparentPixels}catch{return null}return null}}tUe([CQ(),V3("design:type",Function),V3("design:paramtypes",[Object]),V3("design:returntype",Promise)],RQ.prototype,"startEffects",null),tUe([CQ(),V3("design:type",Function),V3("design:paramtypes",[]),V3("design:returntype",Promise)],RQ.prototype,"stopEffects",null);var iUe,O6=function(t,e,i,r){var o,l=arguments.length,d=l<3?e:r===null?r=Object.getOwnPropertyDescriptor(e,i):r;if(typeof Reflect=="object"&&typeof Reflect.decorate=="function")d=Reflect.decorate(t,e,i,r);else for(var h=t.length-1;h>=0;h--)(o=t[h])&&(d=(l<3?o(d):l>3?o(e,i,d):o(e,i))||d);return l>3&&d&&Object.defineProperty(e,i,d),d},HC=function(t,e){if(typeof Reflect=="object"&&typeof Reflect.metadata=="function")return Reflect.metadata(t,e)};class kp{constructor(e){if(this._disposed=!1,this._call=new Set,this._canStartEffects=!1,this.kind="LocalVideoStream",this._renderers=[],this._rawStreamCloneCache=new Set,this._disposeRenderer=r=>{this.logger.log("disposing renderer");try{r.dispose(),this.logger.log("renderer disposed")}catch{this.logger.log("failed to dispose renderer")}},!(e instanceof hP||e instanceof MediaStream))throw new Oe({defaultError:we.LOCAL_VIDEO_STREAM.WRONG_STREAM_TYPE});const i=zf("ACS-calling");this.logger=new rh(i,[()=>`LocalVideoStream:${e.id}`]),this.logger.info("created"),this._eventEmitter=new qf(this.logger),this.setSource(e,!0),this._localStreamTelemetryEventSender=new L6(this._telemetryLogManager)}on(e,i){if(e!=="videoSourceChanged")throw new Oe({defaultError:we.LOCAL_VIDEO_STREAM.EVENT_SUBSCRIBE,defaultErrorMessageArgs:[e]});this._eventEmitter.on(e,i)}off(e,i){if(e!=="videoSourceChanged")throw new Oe({defaultError:we.LOCAL_VIDEO_STREAM.EVENT_SUBSCRIBE,defaultErrorMessageArgs:[e]});this._eventEmitter.off(e,i)}get source(){return this._source}get mediaStreamType(){return this._mediaStreamType}get telemetryLogManager(){return this._telemetryLogManager}get callStackWebCVProvider(){return this.source?.deviceManager?.callStackWebCvProvider??null}get callStackEffectsStatusManager(){return this.source?.deviceManager?.callStackVideoEffectsStatusManager??null}get canStartEffects(){return this._canStartEffects}async switchSource(e){const i=this.logger.createFnLogger(CB.SwitchSource),r=+new Date,o=ln(),l={timestampInfo:{attemptTimestamp:r},correlationId:o,operation:Sr.switchSource,callId:this.getCall()?.id||"",localParticipantId:this.getLocalParticipantId()||"",kindOfEvent:Je.attempt,mediaType:Zc.Video,streamType:Ts.Local};if(this._localStreamTelemetryEventSender.sendMediaStreamEvent(l),!(e instanceof hP)){const d=new Oe({defaultError:we.LOCAL_VIDEO_STREAM.SWITCH_SOURCE_WRONG_TYPE}),h={correlationId:o,callId:this.getCall()?.id||"",localParticipantId:this.getLocalParticipantId()||"",operation:Sr.switchSource,additionalDetails:{failureReason:d.message,code:qK,...an(d)},timestampInfo:{deltaTimeInMs:+new Date-r},kindOfEvent:Je.failure,mediaType:Zc.Video,streamType:Ts.Local};throw this._localStreamTelemetryEventSender.sendMediaStreamEvent(h),d}if(this._source===e){const d=new Oe({defaultError:we.LOCAL_VIDEO_STREAM.SWITCH_SAME_SOURCE}),h={correlationId:o,callId:this.getCall()?.id||"",localParticipantId:this.getLocalParticipantId()||"",operation:Sr.switchSource,additionalDetails:{failureReason:d.message,code:d.code,...an(d)},timestampInfo:{deltaTimeInMs:+new Date-r},kindOfEvent:Je.failure,mediaType:Zc.Video,streamType:Ts.Local};throw this._localStreamTelemetryEventSender.sendMediaStreamEvent(h),d}try{this._mediaStreamType==="RawMedia"&&Array.from(this._call.values()).some(h=>h.localVideoStream===this)&&e.deviceManager.getTsDeviceManager().unsetRawMediaStream?.(1),e.deviceManager.getTsDeviceManager().selectDevices({camera:e.id}),this.setSource(e);const d={correlationId:o,callId:this.getCall()?.id||"",localParticipantId:this.getLocalParticipantId()||"",mediaType:Zc.Video,operation:Sr.switchSource,timestampInfo:{deltaTimeInMs:+new Date-r},streamType:Ts.Local,kindOfEvent:Je.success};this._localStreamTelemetryEventSender.sendMediaStreamEvent(d)}catch(d){const h=z3(i,d),p={correlationId:o,callId:this.getCall()?.id||"",localParticipantId:this.getLocalParticipantId()||"",operation:Sr.switchSource,additionalDetails:{failureReason:h.message,code:qK,...an(h)},timestampInfo:{deltaTimeInMs:+new Date-r},kindOfEvent:Je.failure,mediaType:Zc.Video,streamType:Ts.Local};throw this._localStreamTelemetryEventSender.sendMediaStreamEvent(p),h}}dispose(){this.logger.log("Disposing LocalVideoStream."),this._disposed?this.logger.log("already disposed"):(this.disposeRawStream(),this._renderers.forEach(e=>this._disposeRenderer(e)),this._renderers=[],this._extensibleApi?.dispose(),this._eventEmitter.removeAllListeners(),this._disposed=!0)}async getMediaStream(){const e=ln();let i=+new Date;const r={correlationId:e,callId:this.getCall()?.id||"",localParticipantId:this.getLocalParticipantId()||"",timestampInfo:{attemptTimestamp:i},operation:Sr.getMediaStream,kindOfEvent:Je.attempt,mediaType:Zc.VideoRaw,streamType:Ts.Local};if(this._localStreamTelemetryEventSender.sendMediaStreamEvent(r),this.subscribeToRawStreamChangedIfNeeded(),this._mediaStreamSource){const o={correlationId:e,callId:this.getCall()?.id||"",localParticipantId:this.getLocalParticipantId()||"",mediaType:Zc.VideoRaw,operation:Sr.getMediaStream,timestampInfo:{deltaTimeInMs:+new Date-i},streamType:Ts.Local,kindOfEvent:Je.success};this._localStreamTelemetryEventSender.sendMediaStreamEvent(o);const l=this._mediaStreamSource.clone();return this._cacheCloneStream(l),l}try{let o;if(this._source.deviceType==="ScreenSharing"?o=2:this._source.deviceType!=="UsbCamera"&&this._source.deviceType!=="CaptureAdapter"&&this._source.deviceType!=="Virtual"||(o=1),!o)throw new Oe({defaultError:we.LOCAL_VIDEO_STREAM.CANT_GET_DEVICE_TYPE});this._rawStream||(this._rawStream=this.source.deviceManager.getRawDeviceMediaStream(o));const l={correlationId:e,callId:this.getCall()?.id||"",localParticipantId:this.getLocalParticipantId()||"",mediaType:Zc.VideoRaw,operation:Sr.getMediaStream,timestampInfo:{deltaTimeInMs:+new Date-i},streamType:Ts.Local,kindOfEvent:Je.success};this._localStreamTelemetryEventSender.sendMediaStreamEvent(l);const d=(await this._rawStream?.getMediaStream()).clone();return this._cacheCloneStream(d),d}catch(o){let l;l=this._source.deviceType==="ScreenSharing"?new Oe({defaultError:we.CALL.SS_RAW_STREAM_GET,originalError:o}):new Oe({defaultError:we.LOCAL_VIDEO_STREAM.VIDEO_GET_MEDIA_STREAM,originalError:o});const d={timestampInfo:{deltaTimeInMs:+new Date-i},correlationId:e,callId:this.getCall()?.id||"",localParticipantId:this.getLocalParticipantId()||"",operation:Sr.getMediaStream,additionalDetails:{failureReason:l.message,code:l.code,...an(l)},kindOfEvent:Je.failure,mediaType:Zc.VideoRaw,streamType:Ts.Local};throw this._localStreamTelemetryEventSender.sendMediaStreamEvent(d),l}}async setMediaStream(e){const i=ln();let r,o=+new Date,l=!1,d=!1,h=Zc.VideoRawOrScreenSharingRaw;for(let g of this._call){const f=g;if(f.localScreenSharingStream===this||f.localVideoStream===this){r=f.deviceManager,d=!0,f.localVideoStream===this?(l=!0,h=Zc.VideoRaw):f.localScreenSharingStream===this&&(l=!1,h=Zc.ScreenSharingRaw);break}}const p={timestampInfo:{attemptTimestamp:o},correlationId:i,callId:this.getCall()?.id||"",localParticipantId:this.getLocalParticipantId()||"",operation:Sr.setMediaStream,kindOfEvent:Je.attempt,mediaType:h,streamType:Ts.Local};if(this._localStreamTelemetryEventSender.sendMediaStreamEvent(p),!(e instanceof MediaStream)){const g=new Oe({defaultError:we.LOCAL_VIDEO_STREAM.SET_MEDIA_STREAM_WRONG_TYPE}),f={timestampInfo:{deltaTimeInMs:+new Date-o},correlationId:i,callId:this.getCall()?.id||"",localParticipantId:this.getLocalParticipantId()||"",operation:Sr.setMediaStream,additionalDetails:{failureReason:g.message,code:g.code,...an(g)},kindOfEvent:Je.failure,mediaType:h,streamType:Ts.Local};throw this._localStreamTelemetryEventSender.sendMediaStreamEvent(f),g}if(this.setSource(e),wt()?.calling?.allowAccessRawMediaStream)try{if(d){const f=r?.getTsDeviceManager();if(!f?.setRawMediaStream)throw new Oe({defaultError:we.LOCAL_VIDEO_STREAM.SET_MEDIA_STREAM_UNDEFINED_FUNC});l?f.setRawMediaStream(e,1):f.setRawMediaStream(e,2)}this._renderers.forEach(f=>{f.setSourceObject(e)});const g={timestampInfo:{deltaTimeInMs:+new Date-o},correlationId:i,callId:this.getCall()?.id||"",localParticipantId:this.getLocalParticipantId()||"",operation:Sr.setMediaStream,kindOfEvent:Je.success,mediaType:h,streamType:Ts.Local};this._localStreamTelemetryEventSender.sendMediaStreamEvent(g)}catch(g){const f=new Oe({defaultError:we.LOCAL_VIDEO_STREAM.SET_MEDIA_STREAM,originalError:g}),y={correlationId:i,callId:this.getCall()?.id||"",localParticipantId:this.getLocalParticipantId()||"",operation:Sr.setMediaStream,additionalDetails:{failureReason:f.message,code:f.code,...an(f)},timestampInfo:{deltaTimeInMs:+new Date-o},kindOfEvent:Je.failure,mediaType:h,streamType:Ts.Local};throw this._localStreamTelemetryEventSender.sendMediaStreamEvent(y),f}}addCall(e){this._call.add(e)}removeCall(e){this._call.delete(e)}feature(e){return this._extensibleApi||(this._extensibleApi=new M6(this.logger,{streamInstance:this},{streamInstance:this,telemetryLogManager:this.telemetryLogManager})),this._extensibleApi.getApiObjectInstance(e.videoStreamApiCtor)}registerRenderer(e){this._renderers.push(e)}unregisterRenderer(e){const i=this._renderers.indexOf(e);i!==-1&&this._renderers.splice(i,1)}getStreamMetadata(){let e,i,r=this.getCall();this._source instanceof hP?(e=this.source.deviceManager,i=this.source.deviceType):this._mediaStreamSource instanceof MediaStream&&r&&(e=r.deviceManager);let o=-1;return r&&(this._mediaStreamType==="Video"||this.mediaStreamType==="RawMedia"&&r.localVideoStream===this?o=r.tsCall.mediaStreams[0][0]?.id||-1:(this._mediaStreamType==="ScreenSharing"||this.mediaStreamType==="RawMedia"&&r.localScreenSharingStream===this)&&(o=r.tsCall.mediaStreams[1][0]?.id||-1)),{source:"local",sourceId:o,streamType:this.mediaStreamType,deviceType:i||"",callId:r?.id||"",localParticipantId:r?.tsCall.participantId||"",deviceManagerPermissionState:e?JSON.stringify({cameraPermission:e.getVideoDevicePermission(),microphonePermission:e.getAudioDevicePermission()}):"",acsResourceId:e?.getAcsResourceId()||"",clientId:e?.getClientId()||""}}getLocalParticipantId(){let e="";const i=this.getCall();return i&&(e=i.tsCall.participantId),e}getCall(){for(const e of this._call)if(e.localVideoStreams.includes(this))return e}getEffectsCurrentStateRecord(){try{const e=this.feature(l2e(RQ)),i=e.getEffectsSdkVersion();return{activeEffects:e.getActiveEffectsForTelemetry(),effectsSdk:{version:i}}}catch(e){return void this.logger.warn(`Error while getting current effect state on LocalAudioStream for telemetry: ${e}`)}}setSource(e,i=!1){if(e instanceof hP)this._telemetryLogManager=e.deviceManager.telemetryLogManager,this._source=e,this._mediaStreamType=e.deviceType==="ScreenSharing"?"ScreenSharing":"Video",this._mediaStreamSource=void 0,this._rawStream=void 0,this._canStartEffects=!0;else{try{globalThis[dhe]===1&&(this._telemetryLogManager=globalThis[che])}catch{this.logger.error("Failed to retrive telemetry logger for localVideoStream")}this._source={name:"CustomMediaStream",id:ln(),deviceType:"Virtual"},this._mediaStreamSource=e,this._mediaStreamType="RawMedia",this._canStartEffects=!1}i||this._eventEmitter.emit("videoSourceChanged",{source:this})}subscribeToRawStreamChangedIfNeeded(){this._source instanceof hP&&!this._videoSourceChangedSub&&(this._videoSourceChangedSub=this._rawStream?.changed(()=>{this._eventEmitter.emit("videoSourceChanged",{source:this})}))}_cacheCloneStream(e){this._rawStreamCloneCache.add(e)}disposeRawStream(){this._rawStream&&this._rawStream.dispose();for(const e of Array.from(this._rawStreamCloneCache))e?.getTracks?.().forEach(i=>i.stop());this._rawStreamCloneCache.clear(),this._videoSourceChangedSub?.dispose(),this._videoSourceChangedSub=void 0}}O6([zv,HC("design:type",Object)],kp.prototype,"logger",void 0),O6([to(CB.SwitchSource),HC("design:type",Function),HC("design:paramtypes",[Object]),HC("design:returntype",Promise)],kp.prototype,"switchSource",null),O6([to(CB.GetMediaStream),HC("design:type",Function),HC("design:paramtypes",[]),HC("design:returntype",Promise)],kp.prototype,"getMediaStream",null),O6([to(CB.SetMediaStream),HC("design:type",Function),HC("design:paramtypes",[MediaStream]),HC("design:returntype",Promise)],kp.prototype,"setMediaStream",null),O6([sg(CB.Feature),HC("design:type",Function),HC("design:paramtypes",[Object]),HC("design:returntype",typeof(iUe=typeof TFeature<"u"&&TFeature)=="function"?iUe:Object)],kp.prototype,"feature",null);class pP{constructor(e,i,r,o,l){this._name=e,this._id=i,this._isSystemDefault=r,this._deviceType=o,this._deviceManager=l}get name(){return this._name}setName(e){this._name=e}get id(){return this._id}setId(e){this._id=e}get isSystemDefault(){return this._isSystemDefault}setIsSystemDefault(e){this._isSystemDefault=e}get deviceType(){return this._deviceType}setDeviceType(e){this._deviceType=e}get deviceManager(){return this._deviceManager}}var fUt=function(t,e,i,r){var o,l=arguments.length,d=l<3?e:r;if(typeof Reflect=="object"&&typeof Reflect.decorate=="function")d=Reflect.decorate(t,e,i,r);else for(var h=t.length-1;h>=0;h--)(o=t[h])&&(d=(l<3?o(d):l>3?o(e,i,d):o(e,i))||d);return l>3&&d&&Object.defineProperty(e,i,d),d},vUt=function(t,e){if(typeof Reflect=="object"&&typeof Reflect.metadata=="function")return Reflect.metadata(t,e)};class dpe{constructor(e,i,r,o,l){this._workQueue=Promise.resolve(),this.logger=e.createChild("volume indicator"),this._eventEmitter=new qf(this.logger,{enableLogEmit:!1}),this._isInitialized=!1,this._level=0,this._streamType=i,this._callId=o,this._localParticipantId=l,this._telemetryLogManager=r}get isInitialized(){return this._isInitialized}initialize(e){if(e===void 0)throw this.logger.error("failed to getMediaStreamTrack"),new Oe({defaultError:we.CALL.VOLUME_TRACK});const i=ln(),r=+new Date;try{this.sendVolumeEvent({eventName:vi.acs_calling_audio_stream_volume,correlationId:i,callId:this._callId||"",localParticipantId:this._localParticipantId||"",streamType:this._streamType,kindOfEvent:"attempt",timestampInfo:"",additionalDetails:""}),this.bindToAudioStreamVolume(e),this.sendVolumeEvent({eventName:vi.acs_calling_audio_stream_volume,correlationId:i,callId:this._callId||"",localParticipantId:this._localParticipantId||"",streamType:this._streamType,kindOfEvent:"success",timestampInfo:{deltaTimeInMs:+new Date-r},additionalDetails:""})}catch(o){const l=new Oe({defaultError:we.CALL.VOLUME_INIT,originalError:o});throw this.logger.error(l.message),this.sendVolumeEvent({eventName:vi.acs_calling_audio_stream_volume,correlationId:i,callId:this._callId||"",localParticipantId:this._localParticipantId||"",streamType:this._streamType,kindOfEvent:"failure",timestampInfo:{deltaTimeInMs:+new Date-r},additionalDetails:{failureReason:l.message,code:l.code,subCode:l.subCode,...an(l)}}),l}}bindToAudioStreamVolume(e){let[i,r]=this.setupVolumeCalculator(e);this._level=i();let o=setInterval(()=>{let l=i();l!==this._level&&(this._level=l,this._eventEmitter.emit("levelChanged"))},wt()?.volumeIndicator?.microphoneVolumeSampleIntervalMs);this._volumeCallBackInterval=o,this._audioContext=r}setupVolumeCalculator(e){const i=new MediaStream(e),r=new AudioContext,o=r.createMediaStreamSource(i),l=r.createAnalyser();o.connect(l),l.fftSize=wt().volumeIndicator.fftSize,l.minDecibels=wt().volumeIndicator.minDecibels,l.maxDecibels=wt().volumeIndicator.maxDecibels,l.smoothingTimeConstant=wt().volumeIndicator.smoothingConstant;const d=new Uint8Array(l.frequencyBinCount);return[()=>{try{l.getByteFrequencyData(d);let h=0;for(const g of d)h+=g;return h/d.length*wt().volumeIndicator.normalisedMaxVolume/wt().volumeIndicator.maxAvailableVolume}catch{return this.logger.error("error in calculating audio stream volume"),0}},r]}dispose(){this._isInitialized=!1,this._level=0,this._eventEmitter.removeAllListeners();try{this._audioContext?.close().catch(e=>{this.logger.error("unable to close AudioContext")})}catch{this.logger.error("unable to close MicrophoneAudioContext")}this._volumeCallBackInterval&&clearInterval(this._volumeCallBackInterval)}on(e,i){if(e!=="levelChanged")throw new Oe({defaultError:we.CALL.VOLUME_EVENT_SUBSCRIBE,defaultErrorMessageArgs:[e]});this._eventEmitter.on(e,i)}off(e,i){if(e!=="levelChanged")throw new Oe({defaultError:we.CALL.VOLUME_EVENT_UNSUBSCRIBE,defaultErrorMessageArgs:[e]});this._eventEmitter.off(e,i)}get level(){return this._level}getVolumeIndicator(e){const i=()=>{if(!this.isInitialized)try{this.initialize(e),this._isInitialized=!0}catch(o){const l=new Oe({defaultError:we.CALL.VOLUME_GET,originalError:o});throw this.logger.error(l.message),l}return this},r=this._workQueue.then(()=>i());return this._workQueue=r.then(nh,nh),r}sendVolumeEvent(e){try{this._telemetryLogManager?.sendEvent({name:e.eventName,tenant:Wr,properties:e})}catch{this.logger.debug("Unable to send screen share telemetry")}}}fUt([zv,vUt("design:type",Object)],dpe.prototype,"logger",void 0);class yUt{constructor(e,i,r){this._effectsStatusManager=e,this._logger=i,this._localAudioStream=r,this._currentActiveBrowserEffects={};const o=this._localAudioStream.source.deviceManager;this._isVdi3Enabled=$v(o.getTsDeviceManager()),this._updateCurrentActive()}async setBrowserAudioEffects(e,i,r){try{await this._updateCurrentActive(i);const o={autoGainControl:r.autoGainControl!==void 0?r.autoGainControl:this._currentActiveBrowserEffects.autoGainControl,echoCancellation:r.echoCancellation!==void 0?r.echoCancellation:this._currentActiveBrowserEffects.echoCancellation,noiseSuppression:r.noiseSuppression!==void 0?r.noiseSuppression:this._currentActiveBrowserEffects.noiseSuppression},l=this._calculateFlags(o);this._logger.info(`Setting browser audio processing flags to ${l}`),await e.setAudioProcessingFlags(l)}catch(o){throw new Oe({defaultError:we.FEATURES.AUDIO_EFFECTS.AUDIO_FLAGS,originalError:o})}}async _updateCurrentActive(e){try{const i=e??this._effectsStatusManager.getActiveEffects();if(!this._localAudioStream.canStartEffects)throw new Error("Cannot proceed to update current browser audio effects, most likely source is not supported for audio effects");const r=this._isVdi3Enabled?{autoGainControl:!0,noiseSuppression:!0,echoCancellation:!0}:await(async()=>{const h=await this._localAudioStream.getMediaStream(),p=h?.getAudioTracks()?.[0];if(!p)throw new Error("Could not get MediaStreamTrack from the LocalAudioStream");return p.getSettings()})();let o=!!r?.autoGainControl,l=!!r?.noiseSuppression,d=!!r?.echoCancellation;this._currentActiveBrowserEffects={},(i?.autoGainControl?.[0]==="BrowserAutoGainControl"||o)&&(this._currentActiveBrowserEffects.autoGainControl=!0),(i?.echoCancellation?.[0]==="BrowserEchoCancellation"||d)&&(this._currentActiveBrowserEffects.echoCancellation=!0),(i?.noiseSuppression?.[0]==="BrowserNoiseSuppression"||l)&&(this._currentActiveBrowserEffects.noiseSuppression=!0)}catch(i){throw new Oe({defaultError:we.FEATURES.AUDIO_EFFECTS.AUDIO_FLAGS,originalError:i})}}_calculateFlags(e){let i=0;return e.autoGainControl&&(i+=1),e.echoCancellation&&(i+=2),e.noiseSuppression&&(i+=4),i}}var nUe=function(t,e,i,r){var o,l=arguments.length,d=l<3?e:r===null?r=Object.getOwnPropertyDescriptor(e,i):r;if(typeof Reflect=="object"&&typeof Reflect.decorate=="function")d=Reflect.decorate(t,e,i,r);else for(var h=t.length-1;h>=0;h--)(o=t[h])&&(d=(l<3?o(d):l>3?o(e,i,d):o(e,i))||d);return l>3&&d&&Object.defineProperty(e,i,d),d},$3=function(t,e){if(typeof Reflect=="object"&&typeof Reflect.metadata=="function")return Reflect.metadata(t,e)};class MQ extends r2e{constructor(){super(...arguments),this._wasmVqeInitialized=!1,this._activeEffects={echoCancellation:[],noiseSuppression:[],autoGainControl:[]},this._currentEffects={},this._previousTsWasmEffectType=0,this._currentTsWasmEffectType=0,this._stringForUnknownInput="UNKNOWN",this._audioEffectsProcessorStats=null,this._sourceStreamSubscription=null,this.effectStatusChangedCallback=(e,i,r)=>{this._logger?.debug(`Effects status changed from ${JSON.stringify(e)} to ${JSON.stringify(i)} with operationType: ${r}`),r!=="start"&&r!=="initialize"||this.eventEmitter.emit("effectsStarted",i),r==="stop"&&this.eventEmitter.emit("effectsStopped",i)},this.configUpdatedCallback=async e=>{this._logger?.info("configUpdated callback, no-op.")},this.processingErrorCallback=async e=>{const i=ln();this._logger?.info("processingError callback"),this.eventEmitter.emit("effectsError",e);const r=this.getEffectsNameForTelemetry(this.activeEffects),o=this.getUsageDetailsForTelemetry("Internal handle error",r);this.sendFeatureUsageTelemetry({eventName:vi.acs_calling_media_stream,correlationId:i,operation:Sr.stopEffects,kindOfEvent:Je.failure,additionalDetails:{failureReason:e.message,...an(e),usageDetails:o}}),await this.stopEffects({echoCancellation:!0,noiseSuppression:!0})},this.subscribeToStatUpdates=async()=>{const e=this.getAnyActiveWasmEffect();if(!e)return;const i=await e._internalHandle.getEffectProvider(),r=await i?.getAudioEffectProvider();let o=null;r&&(this._audioEffectProviderSub=r?.on?.("onMetricsUpdated",()=>{try{o=r?.getStats&&r.getStats(),o&&(this._audioEffectsProcessorStats={activeAudioEffects:JSON.stringify(this.activeEffects),audioEffectsSpeechProcessingStats:{localAudioInputSpeechRMS_dBFS:o?.speechLevels?.nearEndInputRMS_dBFS,localAudioOutputSpeechRMS_dBFS:o?.speechLevels?.nearEndOutputRMS_dBFS,localAudioInputNoiseRMS_dBFS:o?.noiseLevels?.nearEndInputRMS_dBFS,localAudioOutputNoiseRMS_dBFS:o?.noiseLevels?.nearEndOutputRMS_dBFS,remoteAudioInputSpeechRMS_dBFS:o?.speechLevels?.farEndInputRMS_dBFS,remoteAudioOutputSpeechRMS_dBFS:o?.speechLevels?.farEndOutputRMS_dBFS},rawStats:JSON.stringify(o)}),this.eventEmitter.emit("effectsProcessorStatsUpdated",this._audioEffectsProcessorStats)}catch(l){this._logger?.warn(`Could not emit audio effect processor stat event: ${l}`)}}),this._logger?.info("Subscribed to audioEffectsProvider stat updates"))},this.unsubscribeFromStatUpdates=()=>{this.getAnyActiveWasmEffect()?this._logger?.info("There is a wasm audio effect still active, skipping stat unsubscribe"):this._audioEffectProviderSub?.dispose&&(this._audioEffectProviderSub.dispose(),this._audioEffectProviderSub=()=>{},this._audioEffectsProcessorStats=null,this._logger?.info("Unsubscribed from audioEffectsProvider stat updates"))}}initialize(e,i){this._logger=i.createChild(" - AudioEffects:"),this._telemetryLogManager=e.telemetryLogManager,this.updateAudioEffectsStatusManager()}get name(){return"AudioEffects"}get activeEffects(){return this._effectsStatusManager?.getActiveEffects?.()??this._activeEffects}on(e,i){if(e!=="effectsStarted"&&e!=="effectsStopped"&&e!=="effectsError"&&e!=="effectsProcessorStatsUpdated")throw new Oe({defaultError:we.FEATURES.AUDIO_EFFECTS.EVENT_SUBSCRIBE,defaultErrorMessageArgs:[e]});this.eventEmitter.on(e,i)}off(e,i){if(e!=="effectsStarted"&&e!=="effectsStopped"&&e!=="effectsError"&&e!=="effectsProcessorStatsUpdated")throw new Oe({defaultError:we.FEATURES.AUDIO_EFFECTS.EVENT_UNSUBSCRIBE,defaultErrorMessageArgs:[e]});this.eventEmitter.off(e,i)}async isSupported(e){const i=ln(),r=+new Date,o=this.getUsageDetailsForTelemetry("",this.getEffectsNameForTelemetry(e));this.sendFeatureUsageTelemetry({eventName:vi.acs_calling_media_stream,correlationId:i,operation:Sr.isSupported,kindOfEvent:Je.attempt,additionalDetails:{usageDetails:o}});try{if(this._logger?.info(`isSupported attempted with input ${e}`),this.disposed)throw new Oe({defaultError:we.FEATURES.AUDIO_EFFECTS.START_DISPOSED});if(!this.streamInstance.canStartEffects)throw new Oe({defaultError:we.FEATURES.AUDIO_EFFECTS.SOURCE_UNSUPPORTED});this._internalDeviceManager||(this._internalDeviceManager=this.streamInstance.source.deviceManager);const l=this._internalDeviceManager.getEnvironmentInfoInternal(),d=$v(this._internalDeviceManager.getTsDeviceManager());this._supportChecker||(this._supportChecker=new Z2e(this._logger,l,d));let h=!1;if(typeof e=="object"){const f=this.getEffectInternalCast(e);h=await this._supportChecker.audioEffectsSupported(f),this._logger?.info(`Support check for ${f.name} resulted in: ${h}`)}else typeof e=="string"&&(h=await this._supportChecker.audioEffectsSupported(e),this._logger?.info(`Support check for ${e} resulted in: ${h}`));const p=this.getEffectsNameForTelemetry(e),g=this.getUsageDetailsForTelemetry("",p);return this.sendFeatureUsageTelemetry({eventName:vi.acs_calling_media_stream,correlationId:i,operation:Sr.isSupported,timestampInfo:{deltaTimeInMs:+new Date-r},kindOfEvent:Je.success,additionalDetails:{usageDetails:g}}),this._logger?.info("isSupported success"),h}catch(l){const d=new Oe({defaultError:we.FEATURES.AUDIO_EFFECTS.SUPPORT_CHECK_FAILED,originalError:l});this._logger?.error(d.message);const h=this.getEffectsNameForTelemetry(e),p=this.getUsageDetailsForTelemetry("",h);throw this.sendFeatureUsageTelemetry({eventName:vi.acs_calling_media_stream,correlationId:i,operation:Sr.isSupported,timestampInfo:{deltaTimeInMs:+new Date-r},kindOfEvent:Je.failure,additionalDetails:{failureReason:d.message,code:d.code,...an(d),usageDetails:p}}),d}}async startEffects(e){const i=ln(),r=+new Date,o=this.getUsageDetailsForTelemetry("",JSON.stringify(this.getEffectsConfigForTelemetry(e)));this.sendFeatureUsageTelemetry({eventName:vi.acs_calling_media_stream,correlationId:i,operation:Sr.startEffects,kindOfEvent:Je.attempt,additionalDetails:{usageDetails:o}});try{if(this._logger?.info(`startEffects attempted with input ${JSON.stringify(this.getEffectsConfigForTelemetry(e))}`),!wt()?.audioEffects?.enableAudioEffects)throw new Oe({defaultError:we.FEATURES.AUDIO_EFFECTS.DISABLED});if(this.disposed)throw new Oe({defaultError:we.FEATURES.AUDIO_EFFECTS.START_DISPOSED});if(!this.streamInstance.canStartEffects)throw new Oe({defaultError:we.FEATURES.AUDIO_EFFECTS.SOURCE_UNSUPPORTED});this._internalDeviceManager||(this._internalDeviceManager=this.streamInstance.source.deviceManager);const d=this._internalDeviceManager.getTsDeviceManager();if(!d)throw new Oe({defaultError:we.FEATURES.AUDIO_EFFECTS.START_DEVICE_MANAGER});await this.updateAudioEffectsStatusManager(),this.subscribeToStreamInstanceEvents(),this.disposeEffectEventSubscriptions(),this.subscribeToEffectEvents();let h=this.activeEffects;e?.autoGainControl&&(h=await this.startStopAutoGainControl(d,h,!0,e.autoGainControl)),e?.echoCancellation&&(h=await this.startStopEchoCancellation(d,h,!0,e.echoCancellation)),e?.noiseSuppression&&(h=await this.startStopNoiseSuppression(d,h,!0,e.noiseSuppression)),this._currentTsWasmEffectType!==this._previousTsWasmEffectType&&(this._logger?.info(`Setting tsDeviceManager setAudioEffectsAsync API with ${this._currentTsWasmEffectType}`),await d.setAudioEffectsAsync("",this._currentTsWasmEffectType)),this._effectsStatusManager?.setActiveEffects(h,"start"),await this.subscribeToStatUpdates();const p=JSON.stringify(h),g=this.getUsageDetailsForTelemetry("",p);this.sendFeatureUsageTelemetry({eventName:vi.acs_calling_media_stream,correlationId:i,operation:Sr.startEffects,timestampInfo:{deltaTimeInMs:+new Date-r},kindOfEvent:Je.success,additionalDetails:{usageDetails:g}}),this._logger?.info("startEffects success")}catch(l){const d=new Oe({defaultError:we.FEATURES.AUDIO_EFFECTS.START_FAILED,originalError:l});this._logger?.error(d.message),this.eventEmitter.emit("effectsError",d);const h=JSON.stringify(this.getEffectsConfigForTelemetry(e)),p=this.getUsageDetailsForTelemetry("",h);this.sendFeatureUsageTelemetry({eventName:vi.acs_calling_media_stream,correlationId:i,operation:Sr.startEffects,timestampInfo:{deltaTimeInMs:+new Date-r},kindOfEvent:Je.failure,additionalDetails:{failureReason:d.message,code:d.code,...an(d),usageDetails:p}})}}async stopEffects(e){const i=ln(),r=+new Date,o=this.getUsageDetailsForTelemetry("",JSON.stringify(this.getEffectsConfigForTelemetry(e)));this.sendFeatureUsageTelemetry({eventName:vi.acs_calling_media_stream,correlationId:i,operation:Sr.stopEffects,kindOfEvent:Je.attempt,additionalDetails:{usageDetails:o}});try{if(this._logger?.info(`stopEffects attempted with input ${JSON.stringify(this.getEffectsConfigForTelemetry(e))}`),this.disposed)throw new Oe({defaultError:we.FEATURES.AUDIO_EFFECTS.STOP_DISPOSED});this._internalDeviceManager||(this._internalDeviceManager=this.streamInstance.source.deviceManager);const l=this._internalDeviceManager.getTsDeviceManager();if(!l)throw new Oe({defaultError:we.FEATURES.AUDIO_EFFECTS.STOP_DEVICE_MANAGER});await this.updateAudioEffectsStatusManager();let d=this.activeEffects;e?.autoGainControl&&(d=await this.startStopAutoGainControl(l,d,!1)),e?.echoCancellation&&(d=await this.startStopEchoCancellation(l,d,!1)),e?.noiseSuppression&&(d=await this.startStopNoiseSuppression(l,d,!1)),this._currentTsWasmEffectType!==this._previousTsWasmEffectType&&(this._logger?.info(`Setting tsDeviceManager setAudioEffectsAsync API with ${this._currentTsWasmEffectType}`),await l.setAudioEffectsAsync("",this._currentTsWasmEffectType)),this._effectsStatusManager?.setActiveEffects(d,"stop"),this.unsubscribeFromStatUpdates(),this.unsubscribeFromStreamInstanceEvents();const h=JSON.stringify(d),p=this.getUsageDetailsForTelemetry("",h);this.sendFeatureUsageTelemetry({eventName:vi.acs_calling_media_stream,correlationId:i,operation:Sr.stopEffects,timestampInfo:{deltaTimeInMs:+new Date-r},kindOfEvent:Je.success,additionalDetails:{usageDetails:p}}),this._logger?.info("stopEffects success")}catch(l){const d=new Oe({defaultError:we.FEATURES.AUDIO_EFFECTS.STOP_FAILED,originalError:l});this._logger?.error(d.message),this.eventEmitter.emit("effectsError",d);const h=JSON.stringify(this.getEffectsConfigForTelemetry(e)),p=this.getUsageDetailsForTelemetry("",h);this.sendFeatureUsageTelemetry({eventName:vi.acs_calling_media_stream,correlationId:i,operation:Sr.stopEffects,timestampInfo:{deltaTimeInMs:+new Date-r},kindOfEvent:Je.failure,additionalDetails:{failureReason:d.message,code:d.code,...an(d),usageDetails:p}})}}async dispose(){const e=async()=>{try{const i=this._internalDeviceManager?.getTsDeviceManager();if(i){let r=await this.startStopAutoGainControl(i,this._activeEffects,!1);r=await this.startStopEchoCancellation(i,r,!1),await this.startStopNoiseSuppression(i,r,!1)}}catch(i){this._logger?.info(`Error stopping effects before disposing: ${i.message}`)}};try{if(this._logger?.info("dispose attempt"),this.disposed)return void this._logger?.info("AudioEffects feature already disposed");await e(),this.unsubscribeFromStatUpdates(),this.unsubscribeFromStreamInstanceEvents(),this._currentEffects={},this._effectsStatusManager?.setActiveEffects({echoCancellation:[],noiseSuppression:[],autoGainControl:[]},"dispose"),this.eventEmitter.removeAllListeners(),this.serialQueue.dispose(),this._effectsStatusManager?.off("statusChanged",this.effectStatusChangedCallback),this.disposed=!0,this._logger?.info("AudioEffects feature disposed")}catch(i){const r=new Oe({defaultError:we.FEATURES.AUDIO_EFFECTS.DISPOSE_FAILED,originalError:i});this._logger?.error(r.message),this.eventEmitter.emit("effectsError",r)}}get audioEffectsProcessorStats(){return this._audioEffectsProcessorStats}getEffectsSdkVersion(){let e=this._stringForUnknownInput;const i=this.getAnyActiveWasmEffect();return i&&i._internalHandle?.getVersion&&(e=i._internalHandle.getVersion()),this.truncateToMax(e)}getActiveEffectsForTelemetry(){return this.truncateToMax(JSON.stringify(this.activeEffects))}async updateAudioEffectsStatusManager(){if(!this.streamInstance.canStartEffects)return void this._logger?.warn("Cannot update status manager, current source is not supported.");this._internalDeviceManager||(this._internalDeviceManager=this.streamInstance.source.deviceManager);const e=$v(this._internalDeviceManager.getTsDeviceManager());if(!this._effectsStatusManager)if(this._effectsStatusManager=this._internalDeviceManager.callStackAudioEffectsStatusManager,this._effectsStatusManager.on("statusChanged",this.effectStatusChangedCallback),this.streamInstance.canStartEffects){const i=e?{autoGainControl:!0,noiseSuppression:!0,echoCancellation:!0}:await(async()=>(await this.streamInstance.getMediaStream())?.getAudioTracks()?.[0]?.getSettings())();this._effectsStatusManager?.setActiveEffects({autoGainControl:i.autoGainControl?["BrowserAutoGainControl"]:[],echoCancellation:i.echoCancellation?["BrowserEchoCancellation"]:[],noiseSuppression:i.noiseSuppression?["BrowserNoiseSuppression"]:[]},"initialize")}else this._logger?.debug("Cannot process initial browser audio effects status, most likely LocalAudioStream source is not AudioDeviceInfo");this._activeEffects=this._effectsStatusManager.getActiveEffects(),this._browserAudioEffectsManager||(this._browserAudioEffectsManager=new yUt(this._effectsStatusManager,this._logger,this.streamInstance))}async initializeWasmVqeInStack(e){if(this._wasmVqeInitialized)return void this._logger?.info("WasmVqe initialized already");if(!this._internalDeviceManager)throw new Oe({defaultError:we.FEATURES.AUDIO_EFFECTS.FAILED_TO_GET_DM});const i=await e._internalHandle.getEffectProvider();if(!i)throw new Oe({defaultError:we.FEATURES.AUDIO_EFFECTS.PROVIDER_UNAVAILABLE});const r=await i.getAudioEffectProvider(),o=this.streamInstance.callStackWasmVqeProvider;if(!o)throw new Oe({defaultError:we.FEATURES.AUDIO_EFFECTS.AEC_PROVIDER_MISSING});o.providerValue=r,this._wasmVqeInitialized=!0}getEffectInternalCast(e){if(e?.name==="EchoCancellation"&&this.isValidEffectInstance(e)||e?.name==="DeepNoiseSuppression"&&this.isValidEffectInstance(e))return e;throw new Oe({defaultError:we.FEATURES.AUDIO_EFFECTS.INVALID_EFFECT})}isValidEffectInstance(e){let i;return(e.name==="EchoCancellation"&&e._internalHandle||!(e.name!=="DeepNoiseSuppression"||!e._internalHandle))&&(i=e,this.hasValidInternalHandle(i._internalHandle))}hasValidInternalHandle(e){return!!(e.getEffectProvider&&e.dispose&&e.setConfig&&e.handleProcessingError)}updateCurrentTsWasmAudioEffectType(e,i,r){const o=r??this._effectsStatusManager?.getActiveEffects();let l=!!o?.echoCancellation?.includes("EchoCancellation"),d=!!o?.noiseSuppression?.includes("DeepNoiseSuppression");switch(e){case"EchoCancellation":l=i;break;case"DeepNoiseSuppression":d=i}this._previousTsWasmEffectType=this._currentTsWasmEffectType,this._currentTsWasmEffectType=l&&d?16:l?4:d?2:0}subscribeToStreamInstanceEvents(){this._sourceStreamSubscription&&(this._logger?.info("Already subscribed to audioSourceChanged before, removing old sub"),this.streamInstance.off("audioSourceChanged",this._sourceStreamSubscription)),this._sourceStreamSubscription=async e=>{e.source&&e.source.mediaStreamType!=="Audio"&&await this.stopEffects({echoCancellation:!0,noiseSuppression:!0})},this.streamInstance.on("audioSourceChanged",this._sourceStreamSubscription)}unsubscribeFromStreamInstanceEvents(){this._sourceStreamSubscription?(this.streamInstance.off("audioSourceChanged",this._sourceStreamSubscription),this._sourceStreamSubscription=null):this._logger?.info("No audioSourceChanged sub active")}subscribeToEffectEvents(){typeof this._currentEffects.echoCancellation=="object"&&(this._currentEffects.echoCancellation?._internalHandle.on("configUpdated",this.configUpdatedCallback),this._currentEffects.echoCancellation?._internalHandle.on("processingError",this.processingErrorCallback)),typeof this._currentEffects.noiseSuppression=="object"&&(this._currentEffects.noiseSuppression?._internalHandle.on("configUpdated",this.configUpdatedCallback),this._currentEffects.noiseSuppression?._internalHandle.on("processingError",this.processingErrorCallback))}disposeEffectEventSubscriptions(){typeof this._currentEffects.echoCancellation=="object"&&(this._currentEffects.echoCancellation?._internalHandle.off("configUpdated",this.configUpdatedCallback),this._currentEffects.echoCancellation?._internalHandle.off("processingError",this.processingErrorCallback)),typeof this._currentEffects.noiseSuppression=="object"&&(this._currentEffects.noiseSuppression?._internalHandle.off("configUpdated",this.configUpdatedCallback),this._currentEffects.noiseSuppression?._internalHandle.off("processingError",this.processingErrorCallback))}setConfigForEffects(e){const i=e._internalHandle.configProvider.config.audioEffects,r=nQ(),o=wt();r?.wasmvqe?.enableVqe&&o?.audioEffects?.enableAudioEffects&&(i.enableAudioEffects=r?.wasmvqe?.enableVqe&&o.audioEffects.enableAudioEffects),e._internalHandle.setConfig(i),this._logger?.info(`Config for audio effects set: ${d6(i)}`)}async startStopAutoGainControl(e,i,r,o){try{if(r&&o){if(!await this.isSupported(o)){const l=this.getEffectsNameForTelemetry(o);throw new Oe({defaultError:we.FEATURES.AUDIO_EFFECTS.UNSUPPORTED_EFFECT,defaultErrorMessageArgs:[JSON.stringify(l)]})}if(o!=="BrowserAutoGainControl")throw new Oe({defaultError:we.FEATURES.AUDIO_EFFECTS.INVALID_EFFECT_GAINCONTROL});return await this._browserAudioEffectsManager?.setBrowserAudioEffects(e,i,{autoGainControl:!0}),this._logger?.info("Browser auto gain control started"),this._currentEffects.autoGainControl=o,i.autoGainControl=[o],i}switch(i?.autoGainControl?.[0]??""){case"":case"BrowserAutoGainControl":await this._browserAudioEffectsManager?.setBrowserAudioEffects(e,i,{autoGainControl:!1}),this._logger?.info("Browser auto gain control stopped")}return i.autoGainControl=[],this._currentEffects.autoGainControl=void 0,i}catch(l){throw new Oe({defaultError:we.FEATURES.AUDIO_EFFECTS.SET_AUTO_GAIN_CONTROL,defaultErrorMessageArgs:[r],originalError:l})}}async startStopEchoCancellation(e,i,r,o){try{if(r&&o){if(!await this.isSupported(o)){const l=this.getEffectsNameForTelemetry(o);throw new Oe({defaultError:we.FEATURES.AUDIO_EFFECTS.UNSUPPORTED_EFFECT,defaultErrorMessageArgs:[JSON.stringify(l)]})}if(typeof o=="string"&&o==="BrowserEchoCancellation")i.echoCancellation[0]==="EchoCancellation"&&(await this.initializeWasmVqeInStack(this._currentEffects.noiseSuppression),this.updateCurrentTsWasmAudioEffectType("EchoCancellation",!1,i),i.echoCancellation=[]),await this._browserAudioEffectsManager?.setBrowserAudioEffects(e,i,{echoCancellation:!0}),this._logger?.info("Browser echo cancellation started"),this._currentEffects.echoCancellation=o,i.echoCancellation=[o];else{if(typeof o!="object")throw new Oe({defaultError:we.FEATURES.AUDIO_EFFECTS.INVALID_EFFECT_ECHO});this._currentEffects.echoCancellation=this.getEffectInternalCast(o),this.setConfigForEffects(this._currentEffects.echoCancellation),await this.initializeWasmVqeInStack(this._currentEffects.echoCancellation),this.updateCurrentTsWasmAudioEffectType(this._currentEffects.echoCancellation.name,!0,i),i.echoCancellation=[this._currentEffects.echoCancellation.name]}return i}switch(i?.echoCancellation?.[0]??""){case"":case"BrowserEchoCancellation":await this._browserAudioEffectsManager?.setBrowserAudioEffects(e,i,{echoCancellation:!1}),this._logger?.info("Browser echo cancellation stopped");break;case"EchoCancellation":await this.initializeWasmVqeInStack(this._currentEffects.echoCancellation),this.updateCurrentTsWasmAudioEffectType("EchoCancellation",!1,i)}return i.echoCancellation=[],this._currentEffects.echoCancellation=void 0,i}catch(l){throw new Oe({defaultError:we.FEATURES.AUDIO_EFFECTS.SET_ECHO_CANCELLATION,defaultErrorMessageArgs:[r],originalError:l})}}async startStopNoiseSuppression(e,i,r,o){try{if(r&&o){if(!await this.isSupported(o)){const l=this.getEffectsNameForTelemetry(o);throw new Oe({defaultError:we.FEATURES.AUDIO_EFFECTS.UNSUPPORTED_EFFECT,defaultErrorMessageArgs:[JSON.stringify(l)]})}if(typeof o=="string"&&o==="BrowserNoiseSuppression")i.noiseSuppression[0]==="DeepNoiseSuppression"&&(await this.initializeWasmVqeInStack(this._currentEffects.noiseSuppression),this.updateCurrentTsWasmAudioEffectType("DeepNoiseSuppression",!1,i),i.noiseSuppression=[]),await this._browserAudioEffectsManager?.setBrowserAudioEffects(e,i,{noiseSuppression:!0}),this._logger?.info("Browser noise cancellation started"),i.noiseSuppression=[o],this._currentEffects.noiseSuppression=o;else{if(typeof o!="object")throw new Oe({defaultError:we.FEATURES.AUDIO_EFFECTS.INVALID_EFFECT_NOISE_SUPP});this._currentEffects.noiseSuppression=this.getEffectInternalCast(o),this.setConfigForEffects(this._currentEffects.noiseSuppression),await this.initializeWasmVqeInStack(this._currentEffects.noiseSuppression),this.updateCurrentTsWasmAudioEffectType(this._currentEffects.noiseSuppression.name,!0,i),i.noiseSuppression=[this._currentEffects.noiseSuppression.name]}return i}switch(i?.noiseSuppression?.[0]??""){case"":case"BrowserNoiseSuppression":await this._browserAudioEffectsManager?.setBrowserAudioEffects(e,i,{noiseSuppression:!1}),this._logger?.info("Browser noise suppression stopped");break;case"DeepNoiseSuppression":await this.initializeWasmVqeInStack(this._currentEffects.noiseSuppression),this.updateCurrentTsWasmAudioEffectType("DeepNoiseSuppression",!1,i)}return i.noiseSuppression=[],this._currentEffects.noiseSuppression=void 0,i}catch(l){throw new Oe({defaultError:we.FEATURES.AUDIO_EFFECTS.SET_NOISE_SUPPRESSION,defaultErrorMessageArgs:[r],originalError:l})}}sendFeatureUsageTelemetry(e){if(this._telemetryLogManager){e.additionalDetails={...e.additionalDetails,callState:this.streamInstance.getCall()?.state,activeEffects:JSON.stringify(this.activeEffects),effectsSdk:{version:this.getEffectsSdkVersion()}};try{const i={correlationId:e.correlationId,mediaType:Zc.AudioRaw,streamType:Ts.Local,operation:e.operation,timestampInfo:e.timestampInfo||{},kindOfEvent:e.kindOfEvent||"",additionalDetails:e.additionalDetails||"",callId:this.streamInstance.getCall()?.id||"",localParticipantId:this.streamInstance.getLocalParticipantId()||""};this._telemetryLogManager.sendEvent({name:e.eventName,tenant:Wr,properties:i})}catch{this._logger?.debug(`Unable to send ${e.operation} telemetry`)}}else this._logger?.debug("Telemetry error. Instance is undefined.")}getAnyActiveWasmEffect(){let e=null;for(const i of Object.values(this._currentEffects))i&&typeof i=="object"&&(e=i);return e}getEffectsConfigForTelemetry(e){let i=!1;typeof e?.autoGainControl!="boolean"&&typeof e?.echoCancellation!="boolean"&&typeof e?.noiseSuppression!="boolean"||(i=!0);let r={};return r=i?{autoGainControl:e?.autoGainControl&&typeof e?.autoGainControl=="boolean"?e?.autoGainControl:void 0,echoCancellation:e?.echoCancellation&&typeof e?.echoCancellation=="boolean"?e?.echoCancellation:void 0,noiseSuppression:e?.noiseSuppression&&typeof e?.noiseSuppression=="boolean"?e?.noiseSuppression:void 0}:{autoGainControl:this.getEffectsNameForTelemetry(e?.autoGainControl),echoCancellation:this.getEffectsNameForTelemetry(e?.echoCancellation),noiseSuppression:this.getEffectsNameForTelemetry(e?.noiseSuppression)},Object.keys(r).forEach(o=>{r[o]!==""&&r[o]!==void 0||delete r[o]}),r}getEffectsNameForTelemetry(e){return e?typeof e=="string"?this.truncateToMax(e):e?.name&&typeof e?.name=="string"?this.truncateToMax(e.name):(this._logger?.warn("Invalid effect object found"),this._stringForUnknownInput):""}getUsageDetailsForTelemetry(e,i){const r=`${i?`[${i}]`:""}:${e??""}`;return this.truncateToMax(r)}truncateToMax(e){const i=wt().audioEffects.maxStringLengthForTelemetry;return e.length>i?(this._logger?.info("Truncating audio effects info for telemetry"),e.substring(0,i-2)+".."):e}}nUe([CQ(),$3("design:type",Function),$3("design:paramtypes",[Object]),$3("design:returntype",Promise)],MQ.prototype,"startEffects",null),nUe([CQ(),$3("design:type",Function),$3("design:paramtypes",[Object]),$3("design:returntype",Promise)],MQ.prototype,"stopEffects",null);var aUe,jC,BE,N6=function(t,e,i,r){var o,l=arguments.length,d=l<3?e:r===null?r=Object.getOwnPropertyDescriptor(e,i):r;if(typeof Reflect=="object"&&typeof Reflect.decorate=="function")d=Reflect.decorate(t,e,i,r);else for(var h=t.length-1;h>=0;h--)(o=t[h])&&(d=(l<3?o(d):l>3?o(e,i,d):o(e,i))||d);return l>3&&d&&Object.defineProperty(e,i,d),d},GC=function(t,e){if(typeof Reflect=="object"&&typeof Reflect.metadata=="function")return Reflect.metadata(t,e)};class gP{constructor(e){this._calls=new Set,this.canStartEffects=!1;const i=zf("ACS-calling");if(this.logger=new rh(i,[()=>`LocalAudioStream for default device with source: ${!!e}`]),this._eventEmitter=new qf(this.logger),this._disposed=!1,!(e instanceof pP||e instanceof MediaStream))throw new Oe({defaultError:we.LOCAL_AUDIO_STREAM.WRONG_STREAM_TYPE});if(e instanceof pP&&e.deviceType!=="Microphone")throw new Oe({defaultError:we.LOCAL_AUDIO_STREAM.SOURCE_WRONG_TYPE});this.setSource(e,!0),this._localStreamTelemetryEventSender=new L6(this._telemetryLogManager),this._volumeIndicator=new dpe(this.logger,"LocalAudioStream",this._telemetryLogManager),this.logger.info("created")}on(e,i){if(e!=="audioSourceChanged")throw new Oe({defaultError:we.LOCAL_AUDIO_STREAM.EVENT_SUBSCRIBE,defaultErrorMessageArgs:[e]});this._eventEmitter.on(e,i)}off(e,i){if(e!=="audioSourceChanged")throw new Oe({defaultError:we.LOCAL_AUDIO_STREAM.EVENT_SUBSCRIBE,defaultErrorMessageArgs:[e]});this._eventEmitter.off(e,i)}feature(e){return this._extensibleApi||(this._extensibleApi=new M6(this.logger,{streamInstance:this},{streamInstance:this,telemetryLogManager:this.telemetryLogManager})),this._extensibleApi.getApiObjectInstance(e.audioStreamApiCtor)}get mediaStreamType(){return this._mediaStreamType}get source(){return this._source}get telemetryLogManager(){return this._telemetryLogManager}get callStackWasmVqeProvider(){return this.source?.deviceManager?.callStackWasmVqeProvider??null}get callStackEffectsStatusManager(){return this.source?.deviceManager?.callStackAudioEffectsStatusManager??null}addCall(e){this._calls.add(e)}removeCall(e){this._calls.delete(e)}getCall(){for(const e of this._calls)if(e.localAudioStreams.includes(this))return e}getLocalParticipantId(){let e="";const i=this.getCall();return i&&(e=i.tsCall.participantId),e}async getMediaStream(){const e=ln(),i=+new Date,r={timestampInfo:{attemptTimestamp:i},correlationId:e,operation:Sr.getMediaStream,kindOfEvent:Je.attempt,mediaType:Zc.AudioRaw,streamType:Ts.Local};if(this._localStreamTelemetryEventSender.sendMediaStreamEvent(r),this.subscribeToRawStreamChangedIfNeeded(),this._mediaStreamSource){const d={correlationId:e,mediaType:Zc.AudioRaw,operation:Sr.getMediaStream,timestampInfo:{deltaTimeInMs:+new Date-i},streamType:Ts.Local,kindOfEvent:Je.success};return this._localStreamTelemetryEventSender.sendMediaStreamEvent(d),this._mediaStreamSource}if(this._source instanceof pP)try{this._rawStream||(this._rawStream=this._source.deviceManager.getRawDeviceMediaStream(0));const d=await this._rawStream?.getMediaStream(),h={correlationId:e,mediaType:Zc.AudioRaw,operation:Sr.getMediaStream,timestampInfo:{deltaTimeInMs:+new Date-i},streamType:Ts.Local,kindOfEvent:Je.success};return this._localStreamTelemetryEventSender.sendMediaStreamEvent(h),d}catch(d){const h=new Oe({defaultError:we.LOCAL_AUDIO_STREAM.GET_MEDIA_STREAM,originalError:d}),p={correlationId:e,operation:Sr.getMediaStream,additionalDetails:{failureReason:h.message,code:h.code,...an(h)},timestampInfo:{deltaTimeInMs:+new Date-i},kindOfEvent:Je.failure,mediaType:Zc.AudioRaw,streamType:Ts.Local};throw this._localStreamTelemetryEventSender.sendMediaStreamEvent(p),h}const o=new Oe({defaultError:we.LOCAL_AUDIO_STREAM.GET_MEDIA_STREAM}),l={timestampInfo:{deltaTimeInMs:+new Date-i},correlationId:e,operation:Sr.getMediaStream,additionalDetails:{failureReason:o.message,code:qK,...an(o)},kindOfEvent:Je.failure,mediaType:Zc.AudioRaw,streamType:Ts.Local};throw this._localStreamTelemetryEventSender.sendMediaStreamEvent(l),o}async setMediaStream(e){const i=ln();let r=+new Date;const o={timestampInfo:{attemptTimestamp:r},correlationId:i,operation:Sr.setMediaStream,kindOfEvent:Je.attempt,mediaType:Zc.AudioRaw,streamType:Ts.Local};if(this._localStreamTelemetryEventSender.sendMediaStreamEvent(o),!(e instanceof MediaStream)){const d=new Oe({defaultError:we.LOCAL_AUDIO_STREAM.SET_MEDIA_STREAM_WRONG_TYPE}),h={timestampInfo:{deltaTimeInMs:+new Date-r},correlationId:i,operation:Sr.setMediaStream,additionalDetails:{failureReason:d.message,code:d.code,...an(d)},kindOfEvent:Je.failure,mediaType:Zc.AudioRaw,streamType:Ts.Local};throw this._localStreamTelemetryEventSender.sendMediaStreamEvent(h),d}this._mediaStreamSource=new MediaStream(e.getAudioTracks()),this.setSource(this._mediaStreamSource),this._volumeIndicator.dispose();const l={correlationId:i,mediaType:Zc.AudioRaw,operation:Sr.setMediaStream,timestampInfo:{deltaTimeInMs:+new Date-r},streamType:Ts.Local,kindOfEvent:Je.success};this._localStreamTelemetryEventSender.sendMediaStreamEvent(l)}async switchSource(e){const i=+new Date,r=ln(),o={timestampInfo:{attemptTimestamp:i},correlationId:r,operation:Sr.switchSource,kindOfEvent:Je.attempt,mediaType:Zc.Audio,streamType:Ts.Local};if(this._localStreamTelemetryEventSender.sendMediaStreamEvent(o),e instanceof pP&&e.deviceType!=="Microphone"){const l=new Oe({defaultError:we.LOCAL_AUDIO_STREAM.SWITCH_SOURCE_WRONG_TYPE}),d={timestampInfo:{deltaTimeInMs:+new Date-i},correlationId:r,operation:Sr.switchSource,additionalDetails:{failureReason:l.message,code:l.code,...an(l)},kindOfEvent:Je.failure,mediaType:Zc.Audio,streamType:Ts.Local};throw this._localStreamTelemetryEventSender.sendMediaStreamEvent(d),l}if(this._source===e){const l=new Oe({defaultError:we.LOCAL_AUDIO_STREAM.SWITCH_SAME_SOURCE}),d={timestampInfo:{deltaTimeInMs:+new Date-i},correlationId:r,operation:Sr.switchSource,additionalDetails:{failureReason:l.message,code:l.code,...an(l)},kindOfEvent:Je.failure,mediaType:Zc.Audio,streamType:Ts.Local};throw this._localStreamTelemetryEventSender.sendMediaStreamEvent(d),l}try{this._source.deviceManager.selectMicrophone(e),this.setSource(e),this._volumeIndicator.dispose();const l={correlationId:r,mediaType:Zc.Audio,operation:Sr.switchSource,timestampInfo:{deltaTimeInMs:+new Date-i},streamType:Ts.Local,kindOfEvent:Je.success};this._localStreamTelemetryEventSender.sendMediaStreamEvent(l)}catch(l){const d=new Oe({defaultError:we.LOCAL_AUDIO_STREAM.UNKNOWN,originalError:l}),h={timestampInfo:{deltaTimeInMs:+new Date-i},correlationId:r,operation:Sr.switchSource,additionalDetails:{failureReason:d.message,code:d.code,...an(d)},kindOfEvent:Je.failure,mediaType:Zc.Audio,streamType:Ts.Local};throw this._localStreamTelemetryEventSender.sendMediaStreamEvent(h),d}}dispose(){this.logger.log("LocalAudioStream disposing"),this._disposed?this.logger.log("Already disposed"):(this.disposeRawStream(),this._volumeIndicator.dispose(),this._extensibleApi?.dispose(),this._eventEmitter.removeAllListeners(),this._disposed=!0,this.logger.log("LocalAudioStream disposed"))}async getVolume(){return this._volumeIndicator.isInitialized?this._volumeIndicator:this._volumeIndicator.getVolumeIndicator(await this.getMediaStream())}subscribeToRawStreamChangedIfNeeded(){this._source instanceof pP&&!this._audioSourceChangedSub&&(this._audioSourceChangedSub=this._rawStream?.changed(()=>{this._volumeIndicator.dispose(),this._eventEmitter.emit("audioSourceChanged",{source:this})}))}disposeRawStream(){this._audioSourceChangedSub?.dispose(),this._rawStream?.dispose(),this._audioSourceChangedSub=void 0}getStreamMetadata(){const e=this.source.deviceManager;return{source:"local",streamType:this.mediaStreamType,deviceType:this.source.deviceType,deviceManagerPermissionState:JSON.stringify({cameraPermission:e.getVideoDevicePermission(),microphonePermission:e.getAudioDevicePermission()}),acsResourceId:e.getAcsResourceId()||"",clientId:e.getClientId()}}getEffectsCurrentStateRecord(){try{const e=this.feature(c2e(MQ)),i=e.getEffectsSdkVersion();return{activeEffects:e.getActiveEffectsForTelemetry(),effectsSdk:{version:i}}}catch(e){return void this.logger.warn(`Error while getting current effect state on LocalAudioStream for telemetry: ${e}`)}}setSource(e,i=!1){if(e instanceof pP)this._telemetryLogManager=e.deviceManager.telemetryLogManager,this._source=e,this._mediaStreamType="Audio",this._mediaStreamSource=void 0,this._rawStream=void 0,this.canStartEffects=!0;else{try{globalThis[dhe]===1&&(this._telemetryLogManager=globalThis[che])}catch{this.logger.error("Failed to retrive telemetry logger for localAudioStream")}this._source={name:"CustomMediaStream",id:ln(),deviceType:"Virtual",isSystemDefault:!1},this._mediaStreamSource=e,this._mediaStreamType="RawMedia",this.canStartEffects=!1}i||this._eventEmitter.emit("audioSourceChanged",{source:this})}}N6([zv,GC("design:type",Object)],gP.prototype,"logger",void 0),N6([sg(I3.Feature),GC("design:type",Function),GC("design:paramtypes",[Object]),GC("design:returntype",typeof(aUe=typeof TFeature<"u"&&TFeature)=="function"?aUe:Object)],gP.prototype,"feature",null),N6([to(I3.GetMediaStream),GC("design:type",Function),GC("design:paramtypes",[]),GC("design:returntype",Promise)],gP.prototype,"getMediaStream",null),N6([to(I3.SetMediaStream),GC("design:type",Function),GC("design:paramtypes",[MediaStream]),GC("design:returntype",Promise)],gP.prototype,"setMediaStream",null),N6([to(I3.SwitchSource),GC("design:type",Function),GC("design:paramtypes",[Object]),GC("design:returntype",Promise)],gP.prototype,"switchSource",null),function(t){t[t.JITTER=0]="JITTER",t[t.RTT=1]="RTT",t[t.PACKETS_LOSS=2]="PACKETS_LOSS",t[t.BIT_RATE=3]="BIT_RATE",t[t.BANDWIDTH=4]="BANDWIDTH"}(jC||(jC={})),function(t){t[t.AUDIO=0]="AUDIO",t[t.VIDEO=1]="VIDEO"}(BE||(BE={}));const BA="Unknown";var wO,tl;function SUt(t,e,i,r){const o=wt()?.rendering.remoteVideo.createViewSendMediaStatsMaxLength,l=wt()?.rendering.remoteVideo.createViewSendMediaStatsInitialMaxLength,d=["bitrate","packetsPerSecond","packetsLostPerSecond","jitterInMs","rttInMs","pairRttInMs","healedRatio","lossRate"],h=["bitrate","packetsPerSecond","packetsLostPerSecond","jitterInMs","rttInMs","pairRttInMs","frameRateDecoded","frameRateReceived","frameWidthReceived","frameHeightReceived","longestFreezeDurationInMs","totalFreezeDurationInMs","framesReceived","framesDropped","framesDecoded","keyFramesDecoded"],p=h;if(i.audio.receive.length>0){const g=i.audio.receive[0];t.audio=t.audio??{},e.audio=e.audio??{},d.forEach(f=>{const y=f;if(g[y]!==void 0&&t.audio){const T=g[y];t.audio[y]===void 0?t.audio[y]=[T]:(t.audio[y]?.length>=o&&t.audio[y]?.shift(),t.audio[y]?.push(T))}if(g[y]!==void 0&&e.audio){const T=g[y];e.audio[y]===void 0?e.audio[y]=[T]:e.audio[y]?.length<l&&e.audio[y]?.push(T)}})}if(i.video.receive.length>0){const g=i.video.receive.find(f=>f.streamId===r);g!==void 0&&(t.video=t.video??{},e.video=e.video??{},h.forEach(f=>{const y=f;if(g[y]!==void 0&&t.video){const T=g[y];t.video[y]===void 0?t.video[y]=[T]:(t.video[y]?.length>=o&&t.video[y]?.shift(),t.video[y]?.push(T))}if(g[y]!==void 0&&e.video){const T=g[y];e.video[y]===void 0?e.video[y]=[T]:e.video[y]?.length<l&&e.video[y]?.push(T)}}))}if(i.screenShare.receive.length>0){const g=i.screenShare.receive.find(f=>f.streamId===r);g!==void 0&&(t.screenShare=t.screenShare??{},e.screenShare=e.screenShare??{},p.forEach(f=>{const y=f;if(g[y]!==void 0&&t.screenShare){const T=g[y];t.screenShare[y]===void 0?t.screenShare[y]=[T]:(t.screenShare[y]?.length>=o&&t.screenShare[y]?.shift(),t.screenShare[y]?.push(T))}if(g[y]!==void 0&&e.screenShare){const T=g[y];e.screenShare[y]===void 0?e.screenShare[y]=[T]:e.screenShare[y]?.length<l&&e.screenShare[y]?.push(T)}}))}}function BB(t){return t?.count.length&&t?.count[0]?s2t(t.sum[0],t.count[0]):NaN}function kO(t){return t?.count.length&&t?.count[0]?t.sum[0]:NaN}(function(t){t.Supported="Supported",t.NotSupported="NotSupported",t.Unknown="Unknown"})(wO||(wO={})),function(t){t.CompleteTest="CompleteTest",t.StartTest="StartTest",t.DeviceAccess="DeviceAccess",t.DeviceEnumerations="DeviceEnumerations",t.InCallDiagnostics="InCallDiagnostics",t.BrowserSupport="BrowserSupport"}(tl||(tl={}));class bUt extends Jhe{constructor(e){super(e),this._impl=new TUt}initialize(e,i){const r=e.callClient;this._logger=i;const o={diagnostics:{tags:["diagnostics"]}},l=r.createInstance(o);this._telemetryLogManager=l.telemetryLogManager,this._impl.intialize(r,l,i,this._telemetryLogManager),this._sendFeatureUsage("initialize",Je.initialize)}get name(){return this._sendFeatureUsage("name",Je.getter),"PreCallDiagnostics"}startTest(e,i){return this._impl.startTest(e,i)}_sendFeatureUsage(e,i){Yhe({featureName:"PreCallDiagnostics",featureType:"CallClient",initializationType:"OnExtendedObjectConstructor",featureDetails:{name:e,step:i}},this._telemetryLogManager,this._logger)}dispose(){this._sendFeatureUsage("dispose",Je.attempt),this.disposed?this._sendFeatureUsage("dispose",Je.failure):(this._impl.dispose(),super.dispose(),this._sendFeatureUsage("dispose",Je.success))}}class TUt{constructor(){this._printableObjectAll=!0,this._completeTestInfo={name:"",succeeded:!0},this._diagnosticsTestRunIds=[],this._callMediaStatistics=ug(),this._inCallDiagnostics={connected:!1,diagnostics:{audio:{jitter:BA,packetLoss:BA,rtt:BA},video:{jitter:BA,packetLoss:BA,rtt:BA}},bandWidth:BA},this._diagnosticsMediaTelemetry={jitter:{audio:{inbound:0,outbound:0},video:{inbound:0,outbound:0}},rtt:{audio:0,video:0},packets:{audioSent:0,audioSentLost:0,audioReceived:0,audioReceivedLost:0,videoSent:0,videoSentLost:0,videoReceived:0,videoReceivedLost:0},bandWidth:0},this._isCreatingNewCallAgent=!1}intialize(e,i,r,o){this._internalCallClient=i,this._mainCallClient=e,this._logger=r,this._telemetryLogManager=o}async getDevices(e,i){let r=[];try{switch(i){case"Speaker":r=await e.getSpeakers();break;case"Microphone":r=await e.getMicrophones();break;default:r=await e.getCameras()}}catch{this._logger.warn("Failed to get speakers")}return r}async startTest(e,i){this._sendFeatureUsage("startTest",Je.attempt),this._currentTestRunId=ln(),this._diagnosticsTestRunIds.push(this._currentTestRunId),this.telemetryLogAttemptEvents({diagnosticsTestRunId:this._currentTestRunId,testAttemptDetails:{name:tl.CompleteTest}}),this.telemetryLogAttemptEvents({diagnosticsTestRunId:this._currentTestRunId,testAttemptDetails:{name:tl.StartTest}});try{this._internalDeviceManager=await this._internalCallClient.getDeviceManager();const r=this._internalCallClient.callAgent,o=await this._mainCallClient.getDeviceManager();await(await r?.tsStack?.getDeviceManagerAsync?.())?.selectDevicesAsync?.({speaker:o.selectedSpeaker?.id,microphone:o.selectedMicrophone?.id});const d=await this._internalCallClient.getDeviceManager(),h={mic:(await this.getDevices(d,"Microphone")).length,speaker:(await this.getDevices(d,"Speaker")).length};this.telemetryLogResultEvents({diagnosticsTestRunId:this._currentTestRunId,testResultDetails:this.updateTestInfo(tl.StartTest,!0,`Device selection successful. Result: ${pk(h,this._printableObjectAll)}`)})}catch(r){const o=new Oe({defaultError:we.FEATURES.PRECALL_DIAGNOSTICS.SET_DEVICE_FAIL,originalError:r});throw this.telemetryLogResultEvents({diagnosticsTestRunId:this._currentTestRunId,testResultDetails:this.updateTestInfo(tl.StartTest,!1,"Device selection failed."),additionalDetails:{...an(o)}}),this._logger.warn(r),this._sendFeatureUsage("startTest",Je.failure),o}try{return this.telemetryLogResultEvents({diagnosticsTestRunId:this._currentTestRunId,testResultDetails:this.updateTestInfo(tl.StartTest,!0,"StartTest succeeded")}),this._sendFeatureUsage("startTest",Je.success),i?{deviceAccess:i.deviceAccess?this.deviceAccess():void 0,deviceEnumeration:i.deviceEnumeration?this.deviceEnumeration():void 0,inCallDiagnostics:i.inCallDiagnostics?this.getInCallDiagnostics(e):void 0,browserSupport:i.browserSupport?this.getBrowserSupport():void 0,callMediaStatistics:i.callMediaStatistics?this.getcallMediaStatistics():void 0,id:this._currentTestRunId}:{deviceAccess:this.deviceAccess(),deviceEnumeration:this.deviceEnumeration(),inCallDiagnostics:this.getInCallDiagnostics(e),browserSupport:this.getBrowserSupport(),callMediaStatistics:this.getcallMediaStatistics(),id:this._currentTestRunId}}catch(r){const o=new Oe({defaultError:we.FEATURES.PRECALL_DIAGNOSTICS.GET_DIAGNOSTICS_INFO,originalError:r});throw this._logger.error(o.message),this.telemetryLogResultEvents({diagnosticsTestRunId:this._currentTestRunId,testResultDetails:this.updateTestInfo(tl.StartTest,!1,"StartTest failed."),additionalDetails:{...an(o)}}),this._sendFeatureUsage("startTest",Je.failure),o}}async getBrowserSupport(){let e;this.telemetryLogAttemptEvents({diagnosticsTestRunId:this._currentTestRunId,testAttemptDetails:{name:tl.BrowserSupport}});try{const i=await this._mainCallClient.getEnvironmentInfoInternal();e={browser:i.isSupportedBrowser?wO.Supported:wO.NotSupported,os:i.isSupportedPlatform?wO.Supported:wO.NotSupported},this.updateTestInfo(tl.BrowserSupport,!0),this.telemetryLogResultEvents({diagnosticsTestRunId:this._currentTestRunId,testResultDetails:{succeeded:!0,result:`Browser support successful. Result: ${pk(e,this._printableObjectAll)}`,name:tl.BrowserSupport}})}catch(i){e={browser:wO.Unknown,os:wO.Unknown},this.telemetryLogResultEvents({diagnosticsTestRunId:this._currentTestRunId,testResultDetails:this.updateTestInfo(tl.BrowserSupport,!1,`Browser support failed. Error: ${pk(i)}`)}),this._logger.error(`Browser support failed: ${i}`)}return new Promise(i=>i(e))}async renderHiddenVideoElement(e,i){let r,o=e.tsCall,l=o.mediaStreams;try{await new Promise((g,f)=>{r=o.changed(()=>{l[0]!==void 0&&l[0].length>0&&l[0][0].isAvailable&&(g(),r?.dispose(),this.updateTestInfo(tl.InCallDiagnostics,!0),this.telemetryLogResultEvents({diagnosticsTestRunId:this._currentTestRunId,testResultDetails:{succeeded:!0,result:"Call mediaStreams successful.",name:tl.InCallDiagnostics}}))}),setTimeout(()=>{this.telemetryLogResultEvents({diagnosticsTestRunId:this._currentTestRunId,testResultDetails:this.updateTestInfo(tl.InCallDiagnostics,!1,"Call mediaStreams failed. Error: Timeout")}),f(new Oe({defaultError:we.FEATURES.PRECALL_DIAGNOSTICS.VIDEO_STREAM_TIMEOUT}))},1e3*this._diagnosticsEcsConfig.CALL.MEDIASTREAM_TIMEOUT_IN_SEC)});let d=o.mediaStreams[0][0],h=document.getElementById("_hiddenSelfRemoteStream");h&&h.remove(),h=document.createElement("div"),h.id="_hiddenSelfRemoteStream",h.style.position="relative",h.style.height="0px",h.style.width="0px";const p=document.createElement("div");p.style.position="absolute",p.style.height=this._diagnosticsEcsConfig.CALL.VIDEO_SIZE.heigth+"px",p.style.width=this._diagnosticsEcsConfig.CALL.VIDEO_SIZE.width+"px",p.style.bottom="0px",p.style.left="-2000px",h.appendChild(p),document.getElementsByTagName("body")[0].appendChild(h),this.updateTestInfo(tl.InCallDiagnostics,!0),this.telemetryLogResultEvents({diagnosticsTestRunId:this._currentTestRunId,testResultDetails:{succeeded:!0,result:`Video element rendering successful. CallId: ${e.id}, localParticipantId: ${i}`,name:tl.InCallDiagnostics}}),await d.start(p)}catch(d){this.telemetryLogResultEvents({diagnosticsTestRunId:this._currentTestRunId,testResultDetails:this.updateTestInfo(tl.InCallDiagnostics,!1,`Call mediaStreams failed. Error: ${pk(d)}`)}),this._logger.warn("Failed to render hidden video element")}}sineWaveAudioStream(){const e=new window.AudioContext,i=e.createMediaStreamDestination(),r=e.createOscillator();r.type="sine",r.frequency.value=500,r.connect(i),r.start();const{stream:o}=i;return new gP(o)}async receiveAndPlayCallAudio(e,i){try{const r=new window.AudioContext,o=new MediaStream;r.createMediaStreamSource(o).connect(r.destination),this.updateTestInfo(tl.InCallDiagnostics,!0),this.telemetryLogResultEvents({diagnosticsTestRunId:this._currentTestRunId,testResultDetails:{succeeded:!0,result:`Call mediaStreams audio track succeeded. CallId: ${e.id}, localParticipantId: ${i}`,name:tl.InCallDiagnostics}})}catch(r){this.telemetryLogResultEvents({diagnosticsTestRunId:this._currentTestRunId,testResultDetails:this.updateTestInfo(tl.InCallDiagnostics,!1,`Call mediaStreams audio track failed. Error: ${pk(r)}`)}),this._logger.warn("Failed to send audio to call.")}}async getcallMediaStatistics(){return this._callMediaStatistics.promise}setEcsConfig(){this._diagnosticsEcsConfig=wt()?.calling?.callDiagnostics}async getInCallDiagnostics(e){this.telemetryLogAttemptEvents({diagnosticsTestRunId:this._currentTestRunId,testAttemptDetails:{name:tl.InCallDiagnostics}}),this.setEcsConfig();const i={groupId:this._diagnosticsEcsConfig.CALL.GROUP_ID},r=await this.getDevices(this._internalDeviceManager,"Camera");let o,l="";r.length!==0&&(o=[new kp(r[0])]);const d={videoOptions:{localVideoStreams:o},audioOptions:{muted:!1,localAudioStreams:[this.sineWaveAudioStream()]}};let h;try{h=await this._mainCallClient.callAgent?.getExistingCallAgentWithToken(e),h?this._internalCallClient.setCallAgent(h):(this._isCreatingNewCallAgent=!0,await this._internalCallClient.createCallAgent(e)),this.updateTestInfo(tl.InCallDiagnostics,!0),this.telemetryLogResultEvents({diagnosticsTestRunId:this._currentTestRunId,testResultDetails:{succeeded:!0,result:"Create CallAgent successful.",name:tl.InCallDiagnostics}})}catch(g){const f=new Oe({defaultError:we.FEATURES.PRECALL_DIAGNOSTICS.GET_CALL_AGENT,originalError:g});throw this.telemetryLogResultEvents({diagnosticsTestRunId:this._currentTestRunId,testResultDetails:this.updateTestInfo(tl.InCallDiagnostics,!1,f.message),additionalDetails:{...an(f)}}),this._logger.error(f.message),f}const p=this._internalCallClient.callAgent?.join(i,d);if(p){try{await this.waitCallConnected(p),l=p.tsCall.participantId,this.updateTestInfo(tl.InCallDiagnostics,!0),this.telemetryLogResultEvents({diagnosticsTestRunId:this._currentTestRunId,testResultDetails:{succeeded:!0,result:"Call connected successfully",name:tl.InCallDiagnostics}})}catch(f){const y=new Oe({defaultError:we.FEATURES.PRECALL_DIAGNOSTICS.CONNECT_FAIL,originalError:f});throw this.telemetryLogResultEvents({diagnosticsTestRunId:this._currentTestRunId,testResultDetails:this.updateTestInfo(tl.InCallDiagnostics,!1,y.message),additionalDetails:{...an(y)}}),this._logger.error(y.message),y}try{this.updateTestInfo(tl.InCallDiagnostics,!0),await this.renderHiddenVideoElement(p,l)}catch(f){const y=new Oe({defaultError:we.FEATURES.PRECALL_DIAGNOSTICS.RENDER_VIDEO,originalError:f});throw this.telemetryLogResultEvents({diagnosticsTestRunId:this._currentTestRunId,testResultDetails:this.updateTestInfo(tl.InCallDiagnostics,!1,y.message),additionalDetails:{...an(y)}}),y}this.receiveAndPlayCallAudio(p,l);const g=p.feature(Qd(K2e,{activationEvent:"OnExtendedObjectConstructor"}));this._callMediaStatistics.resolve(g),g.createCollector({aggregationInterval:this._diagnosticsEcsConfig.CALL.AGGREGATION.INTERVAL,dataPointsPerAggregation:this._diagnosticsEcsConfig.CALL.AGGREGATION.DATAPOINTS}).on("summaryReported",f=>this.gatherCallStatistics(f));try{await k6(1e3*this._diagnosticsEcsConfig.CALL.DURATION_IN_SEC),await p.hangUp({forEveryone:!0}),this.updateTestInfo(tl.InCallDiagnostics,!0),this.telemetryLogResultEvents({diagnosticsTestRunId:this._currentTestRunId,testResultDetails:{succeeded:!0,result:`Call hangup successful. Result: ${pk(this._inCallDiagnostics,this._printableObjectAll)}`,name:tl.InCallDiagnostics}})}catch(f){const y=new Oe({defaultError:we.FEATURES.PRECALL_DIAGNOSTICS.HANGUP_FAIL,originalError:f});throw this.telemetryLogResultEvents({diagnosticsTestRunId:this._currentTestRunId,testResultDetails:this.updateTestInfo(tl.InCallDiagnostics,!1,y.message),additionalDetails:{...an(y)}}),this._logger.error(y.message),y}this.dispose()}return this.telemetryLogResultEvents({diagnosticsTestRunId:this._currentTestRunId,testResultDetails:{succeeded:this._completeTestInfo.succeeded,result:this._completeTestInfo.result||"InCallDiagnostics succeeded.",name:tl.CompleteTest}}),this._inCallDiagnostics}async waitCallConnected(e){await new Promise(async(i,r)=>{e.on("stateChanged",()=>{e.state=="Connected"&&(this._inCallDiagnostics.connected=!0,i()),e.state=="Disconnected"&&r("Call disconnected")});const o=this._diagnosticsEcsConfig.CALL.CONNECT_TIMEOUT_IN_SEC;await k6(1e3*o),r(new Oe({defaultError:we.FEATURES.PRECALL_DIAGNOSTICS.CALL_CONNECT_TIMEOUT,defaultErrorMessageArgs:[o]}))})}qualityGrade(e,i,r){return e<=i?"Good":e>=r?"Bad":"Average"}bandwidthQualityGrade(e,i,r){return e>=i?"Good":e<=r?"Bad":"Average"}getQualityGradeForMetric(e,i,r){switch(e){case jC.JITTER:return r===BE.AUDIO?this.qualityGrade(i,this._diagnosticsEcsConfig.AUDIO.JITTER.GOOD,this._diagnosticsEcsConfig.AUDIO.JITTER.AVERAGE):this.qualityGrade(i,this._diagnosticsEcsConfig.VIDEO.JITTER.GOOD,this._diagnosticsEcsConfig.VIDEO.JITTER.AVERAGE);case jC.RTT:return r===BE.AUDIO?this.qualityGrade(i,this._diagnosticsEcsConfig.AUDIO.RTT.GOOD,this._diagnosticsEcsConfig.AUDIO.RTT.AVERAGE):this.qualityGrade(i,this._diagnosticsEcsConfig.VIDEO.RTT.GOOD,this._diagnosticsEcsConfig.VIDEO.RTT.AVERAGE);case jC.PACKETS_LOSS:return r===BE.AUDIO?this.qualityGrade(i,this._diagnosticsEcsConfig.AUDIO.PACKETS_LOSS_PERCENTAGE.GOOD,this._diagnosticsEcsConfig.AUDIO.PACKETS_LOSS_PERCENTAGE.AVERAGE):this.qualityGrade(i,this._diagnosticsEcsConfig.VIDEO.PACKETS_LOSS_PERCENTAGE.GOOD,this._diagnosticsEcsConfig.VIDEO.PACKETS_LOSS_PERCENTAGE.AVERAGE);case jC.BANDWIDTH:return this.bandwidthQualityGrade(i,this._diagnosticsEcsConfig.BANDWIDTH.GOOD,this._diagnosticsEcsConfig.BANDWIDTH.AVERAGE);default:return BA}}gatherCallStatistics(e){try{const i=e.audio.receive.length?e.audio.receive[0]:void 0,r=e.audio.send.length?e.audio.send[0]:void 0,o=e.video.receive.length?e.video.receive[0]:void 0,l=e.video.send.length?e.video.send[0]:void 0,d=e.transports.length?e.transports[0]:void 0;this._diagnosticsMediaTelemetry.jitter.audio.inbound=BB(i?.jitterInMs?.aggregation),this._diagnosticsMediaTelemetry.jitter.audio.outbound=BB(r?.jitterInMs?.aggregation);const h=Math.max(this._diagnosticsMediaTelemetry.jitter.audio?.inbound,this._diagnosticsMediaTelemetry.jitter.audio?.outbound);this._inCallDiagnostics.diagnostics.audio.jitter=this.getQualityGradeForMetric(jC.JITTER,h,BE.AUDIO),this._diagnosticsMediaTelemetry.rtt.audio=BB(r?.rttInMs?.aggregation),this._inCallDiagnostics.diagnostics.audio.rtt=this.getQualityGradeForMetric(jC.JITTER,this._diagnosticsMediaTelemetry.rtt.audio,BE.AUDIO),this._diagnosticsMediaTelemetry.packets.audioSent=kO(r?.packetsPerSecond?.aggregation),this._diagnosticsMediaTelemetry.packets.audioSentLost=kO(r?.packetsLostPerSecond?.aggregation),this._diagnosticsMediaTelemetry.packets.audioReceived=kO(i?.packetsPerSecond?.aggregation),this._diagnosticsMediaTelemetry.packets.audioReceivedLost=kO(i?.packetsLostPerSecond?.aggregation);const p=this._diagnosticsMediaTelemetry.packets.audioSent-this._diagnosticsMediaTelemetry.packets.audioSentLost,g=this._diagnosticsMediaTelemetry.packets.audioReceived-this._diagnosticsMediaTelemetry.packets.audioReceivedLost,f=Math.max(p,g)/this._diagnosticsMediaTelemetry.packets.audioSent*100;this._inCallDiagnostics.diagnostics.audio.packetLoss=this.getQualityGradeForMetric(jC.PACKETS_LOSS,f,BE.AUDIO),this._diagnosticsMediaTelemetry.jitter.video.inbound=BB(o?.jitterInMs?.aggregation),this._diagnosticsMediaTelemetry.jitter.video.outbound=BB(l?.jitterInMs?.aggregation);const y=Math.max(this._diagnosticsMediaTelemetry.jitter.video.inbound,this._diagnosticsMediaTelemetry.jitter.video.outbound);this._inCallDiagnostics.diagnostics.video.jitter=this.getQualityGradeForMetric(jC.JITTER,y,BE.VIDEO),this._diagnosticsMediaTelemetry.rtt.video=BB(l?.rttInMs?.aggregation),this._inCallDiagnostics.diagnostics.video.rtt=this.getQualityGradeForMetric(jC.RTT,this._diagnosticsMediaTelemetry.rtt.video,BE.VIDEO),this._diagnosticsMediaTelemetry.packets.videoSent=kO(l?.packetsPerSecond?.aggregation),this._diagnosticsMediaTelemetry.packets.videoSentLost=kO(l?.packetsLostPerSecond?.aggregation),this._diagnosticsMediaTelemetry.packets.videoReceived=kO(o?.packetsPerSecond?.aggregation),this._diagnosticsMediaTelemetry.packets.videoReceivedLost=kO(o?.packetsLostPerSecond?.aggregation);const T=this._diagnosticsMediaTelemetry.packets.videoSent-this._diagnosticsMediaTelemetry.packets.videoSentLost,C=this._diagnosticsMediaTelemetry.packets.videoReceived-this._diagnosticsMediaTelemetry.packets.videoReceivedLost,E=Math.max(T,C)/this._diagnosticsMediaTelemetry.packets.videoSent*100;this._inCallDiagnostics.diagnostics.video.packetLoss=this.getQualityGradeForMetric(jC.PACKETS_LOSS,E,BE.VIDEO),this._diagnosticsMediaTelemetry.bandWidth=BB(d?.availableOutgoingBitrate?.aggregation),this._inCallDiagnostics.bandWidth=this.getQualityGradeForMetric(jC.BANDWIDTH,this._diagnosticsMediaTelemetry.bandWidth,BE.AUDIO)}catch(i){const r=new Oe({defaultError:we.FEATURES.PRECALL_DIAGNOSTICS.VIDEO_MEDIASTATS,originalError:i});this._logger.error("Failed to get audio call media stats:",r.message),this._callMediaStatistics.reject(r)}}async deviceAccess(){this.telemetryLogAttemptEvents({diagnosticsTestRunId:this._currentTestRunId,testAttemptDetails:{name:tl.DeviceAccess}});const e=this._internalDeviceManager.askDevicePermission({audio:!0,video:!0});try{const i=await e;this.updateTestInfo(tl.DeviceAccess,!0),this.telemetryLogResultEvents({diagnosticsTestRunId:this._currentTestRunId,testResultDetails:{succeeded:!0,result:`Device Access successful. Result: ${pk(i,this._printableObjectAll)}`,name:tl.DeviceAccess}})}catch{this.telemetryLogResultEvents({diagnosticsTestRunId:this._currentTestRunId,testResultDetails:this.updateTestInfo(tl.DeviceAccess,!1,"Device Access failed.")})}return e}async deviceEnumeration(){const e={microphone:BA,camera:BA,speaker:BA};this.telemetryLogAttemptEvents({diagnosticsTestRunId:this._currentTestRunId,testAttemptDetails:{name:tl.DeviceEnumerations}});try{const i=(await this.getDevices(this._internalDeviceManager,"Microphone")).length!==0,r=(await this.getDevices(this._internalDeviceManager,"Camera")).length!==0,o=(await this.getDevices(this._internalDeviceManager,"Speaker")).length!==0;e.microphone=i?"Available":"NotAvailable",e.camera=r?"Available":"NotAvailable",e.speaker=o?"Available":"NotAvailable",this.updateTestInfo(tl.DeviceEnumerations,!0),this.telemetryLogResultEvents({diagnosticsTestRunId:this._currentTestRunId,testResultDetails:{succeeded:!0,result:`Device Enumeration successful. Result: ${pk(e,this._printableObjectAll)}`,name:tl.DeviceEnumerations}})}catch(i){this.telemetryLogResultEvents({diagnosticsTestRunId:this._currentTestRunId,testResultDetails:this.updateTestInfo(tl.DeviceEnumerations,!1,"Device Enumeration failed.")}),this._logger.error(`Couldn't find mic, camera, or speaker: ${i}`)}return e}telemetryLogAttemptEvents(e){this._telemetryLogManager.sendEvent({name:vi.acs_calling_diagnostics_attempt,tenant:Wr,properties:{name:e.testAttemptDetails.name,diagnosticsTestRunId:e.diagnosticsTestRunId}})}telemetryLogResultEvents(e){this._telemetryLogManager.sendEvent({name:vi.acs_calling_diagnostics_result,tenant:Wr,properties:{name:e.testResultDetails.name,diagnosticsTestRunId:e.diagnosticsTestRunId,succeeded:e.testResultDetails.succeeded,result:e.testResultDetails.result,additionalDetails:e.additionalDetails||{}}})}updateTestInfo(e,i,r){return this._completeTestInfo.succeeded&&(this._completeTestInfo={succeeded:i,name:e,result:r}),{succeeded:i,name:e,result:r||""}}_sendFeatureUsage(e,i){Yhe({featureName:"PreCallDiagnostics",featureType:"CallClient",initializationType:"OnExtendedObjectConstructor",featureDetails:{name:e,step:i}},this._telemetryLogManager,this._logger)}dispose(){this._isCreatingNewCallAgent&&this._internalCallClient.callAgent?.dispose()}}class rUe{constructor(e,i){this._debounce=void 0,this._updateFunction=e,this._timeout=i}debounce(){this._debounce?(clearTimeout(this._debounce),this._debounce=setTimeout(()=>{this._updateFunction(),this._debounce=void 0},this._timeout)):(this._updateFunction(),this._debounce=setTimeout(()=>{this._debounce=void 0},this._timeout))}flush(){this._debounce&&(clearTimeout(this._debounce),this._debounce=void 0,this._updateFunction())}}class FB{constructor(e,i,r,o,l,d){this._isReceiving=!1,this._mediaStreamType="Video",this._renderers=[],this._disposed=!1,this._size={height:0,width:0},this._setType=h=>{h.type===0?this._mediaStreamType="Video":h.type===1?this._mediaStreamType="ScreenSharing":h.type===2&&(this._mediaStreamType="LiveStream")},this._disposeRenderer=h=>{this.logger.log("disposing renderer");try{h.dispose(NE.Internal_RemoteVideoStreamDisposed),this.logger.log("renderer disposed")}catch{this.logger.log("failed to dispose renderer")}},this.tsStream=e,this._setType(this.tsStream),this.logger=i.createChild(()=>`Stream:{id=${this.tsStream.id}}:{type=${this._mediaStreamType}}`),this.telemetryLogManager=l,this.kind=d,this._eventEmitter=new qf(this.logger),this.call=r,this._tsParticipantId=o,this.sendRemoteVideoStreamTelemetry(),this._debounceSize=this.createDebounceSize(),this._debounceIsReceiving=new rUe(()=>{const h=this._renderers?.filter(p=>!!p?.isRendering).length>0;this._isReceiving!==h&&(this._isReceiving=h,this.logger.info(`isReceiving changed to ${this._isReceiving}`),this._eventEmitter.emit("isReceivingChanged"),this.sendRemoteVideoStreamTelemetry())},wt().rendering.remoteVideo.debounceTimeout),this._registeredViewIdsMaxLength=wt().rendering.remoteVideo.registeredViewIdsMaxLength,this.logger.info("created")}on(e,i){if(e!=="sizeChanged"&&e!=="isReceivingChanged")throw new Oe({defaultError:we.REMOTE_VIDEO_STREAM.EVENT_SUBSCRIBE,defaultErrorMessageArgs:[e]});this._eventEmitter.on(e,i)}off(e,i){if(e!=="sizeChanged"&&e!=="isReceivingChanged")throw new Oe({defaultError:we.REMOTE_VIDEO_STREAM.EVENT_UNSUBSCRIBE,defaultErrorMessageArgs:[e]});this._eventEmitter.off(e,i)}get id(){return this.tsStream.id}get isReceiving(){return this._isReceiving}get tsParticipantId(){return this._tsParticipantId}get remoteParticipantId(){return this.tsStream.participantId??""}get mediaStreamType(){return this._mediaStreamType}get size(){return{height:this._size.height,width:this._size.width}}updateSize(){this._debounceSize.debounce()}updateIsReceiving(){this._debounceIsReceiving.debounce()}flushIsReceiving(){this._debounceIsReceiving.flush()}registerRenderer(e){this._renderers.push(e),this.logger.info(`Renderer registered, view id: ${e.viewId}`)}unregisterRenderer(e){const i=this._renderers.indexOf(e);i!==-1&&(this._renderers.splice(i,1),this.logger.info(`Renderer un-registered, view id: ${e.viewId}`))}dispose(){this.logger.log("dispose"),this._disposed?this.logger.log("already disposed"):(this._disposed=!0,this._streamChangedHandler&&this._streamChangedHandler.dispose(),this._renderers.forEach(e=>this._disposeRenderer(e)),this._renderers=[],this._eventEmitter.removeAllListeners())}getRegisteredViewIds(){let e=this._renderers.map(i=>i.viewId);return this._registeredViewIdsMaxLength&&(e=e.slice(0,this._registeredViewIdsMaxLength)),e.join(", ")}sendRemoteVideoStreamTelemetry(){this.call.stats.recordEvent({name:vT.remote_stream,callId:this.call.id,localParticipantId:this.call.tsCall.participantId,data:{...this.getStreamMetadata()}})}createDebounceSize(){return new rUe(()=>{let e={height:0,width:0};this._renderers?.forEach(i=>{i?.isRendering&&i.size.height>e.height&&i.size.width>e.width&&(e.height=i.size.height,e.width=i.size.width)},wt().rendering.remoteVideo.debounceTimeout),this._size.height===e.height&&this._size.width===e.width||(this._size.height=e.height,this._size.width=e.width,this.logger.info(`stream size changed to { height: ${this._size.height}, width: ${this._size.width} }`),this._eventEmitter.emit("sizeChanged"),this.sendRemoteVideoStreamTelemetry())},wt().rendering.remoteVideo.debounceTimeout)}}class CUt{constructor(e){this._statsInfo=e,this._originalValues={},this._aggregateValues={}}isDiffMethod(e){return e=="diff"||e=="last2"||e==="rate"}addStats(e,i){const r=this._statsInfo[e];let o=this._originalValues[e];if(o===void 0&&(o={raw:[],calc:[],lastTime:Date.now(),beginTime:Date.now()},this._originalValues[e]=o),this.isDiffMethod(r.calculation_method)){o.raw.push(i);const l=Date.now(),d=o.lastTime;o.lastTime=l,o.raw.length>1?(i=o.raw[o.raw.length-1]-o.raw[o.raw.length-2],r.calculation_method==="rate"&&(i=i/(l-d)*1e3),r.multiplier!==void 0&&(i*=r.multiplier),r.integer===!0&&(i|=0),o.calc.push(i)):r.calculation_method==="rate"&&(i=0)}else r.multiplier!==void 0&&typeof i=="number"&&(i*=r.multiplier),r.integer===!0&&(i|=0),o.raw.push(i);return i}aggregate(){const e={};for(const[i,r]of Object.entries(this._originalValues)){const o=this._statsInfo[i];if(o===void 0||o.show===!1)continue;this.isDiffMethod(o.calculation_method)&&r.raw.length>0&&(e[i]={raw:[r.raw[r.raw.length-1]],calc:[],lastTime:r.lastTime,beginTime:0});let l=this._aggregateValues[i];l===void 0&&(l={raw:[],timestamp:new Date(r.beginTime)},o.aggregation_needed&&(l.aggregation={count:[],sum:[],max:[],min:[]}),this._aggregateValues[i]=l);const d=r.calc?.length?r.calc:r.raw;let h=d;if(o.aggregation_needed&&l.aggregation){const p=d.filter(g=>typeof g=="number"&&!isNaN(g));l.aggregation.count.push(p.length),l.aggregation.sum.push(EQ(p)),l.aggregation.max.push(O2e(p)),l.aggregation.min.push(N2e(p)),h=p}o.raw_data_reduction&&h.length>0&&(l.reduced=l.reduced||[],l.reduced.push(h[h.length-1])),h.forEach(p=>l.raw.push(p))}this._originalValues=e}popAggregates(){const e={};for(const[i,r]of Object.entries(this._aggregateValues))e[this._statsInfo[i].name??i]=r;return this._aggregateValues={},e}}class oUe{constructor(e,i,r){if(this._tsCall=e,this._aggregationInterval=0,this._dataPointsPerAggregation=0,this._disposed=!1,this._calculators=new Map,r.aggregationInterval<1)throw new Oe({defaultError:we.FEATURES.LIVE_STREAM.INVALID_AGGREGATION_INTERVAL_RANGE});if(r.dataPointsPerAggregation<1)throw new Oe({defaultError:we.FEATURES.LIVE_STREAM.INVALID_DATAPOINTS_AGGREGATION_RANGE});this._logger=i.createChild("LiveStreamStatsCollector"),this._eventEmitter=new qf(this._logger,{enableLogEmit:!1}),this._callStateChanged=ug(),this._statsPoller=r.statsPoller,this._statsInfo=r.statsInfo,this._aggregationInterval=r.aggregationInterval,this._dataPointsPerAggregation=r.dataPointsPerAggregation,this._isInternal=r.isInternal,this._dataEventListener=d=>{d!==void 0&&this._processData(d)},this._statsPoller.on("data",this._dataEventListener);const o=[3,10];let l=o.includes(this._tsCall.state);this._callStateChangedHandle=this._tsCall.on("callStateChanged",()=>{l!==o.includes(this._tsCall.state)&&(l=!l,this._callStateChanged.resolve(l))}),this._run()}on(e,i){this._eventEmitter.on(e,i)}off(e,i){this._eventEmitter.off(e,i)}dispose(){this._disposed||(this._disposed=!0,this._callStateChangedHandle.dispose(),this._callStateChanged.resolve(!1),this._statsPoller.off("data",this._dataEventListener),this._eventEmitter.emit("dispose"),this._eventEmitter.removeAllListeners())}_processData(e){const i={},r=Object.keys(e);r.length!==0&&(r.forEach(o=>{const l=e[o],d={};let h=this._calculators.get(o);h||(h=new CUt(this._statsInfo),this._calculators.set(o,h));for(const[p,g]of Object.entries(l)){const f=this._statsInfo[p];if(f&&f.show!==!1&&(this._isInternal||!f.is_internal)){const y=h.addStats(p,g);d[f.name??p]=y}}i[o]=d}),Object.keys(i).length>0&&this._eventEmitter.emit("sampleReported",i))}async _run(){let e=0;const i=d=>(Object.keys(d).forEach(h=>{d[h].reduced&&!this._isInternal&&delete d[h].reduced}),d),r=()=>{if(this._calculators.size===0||e===0)return;const d=[],h={};this._calculators.forEach((p,g)=>{const f=i(p.popAggregates());Object.keys(f).length===0?d.push(g):(f.reduced&&!this._isInternal&&delete f.reduced,h[g]=f)});try{this._eventEmitter.emit("summaryReported",h)}catch(p){this._logger.error(`summary event: ${p}`)}d.forEach(p=>{this._calculators.delete(p)}),e=0},o=[3,10];let l=1e3*this._aggregationInterval;for(;!this._disposed;){if(o.includes(this._tsCall.state)){l>0&&await cP(()=>this._callStateChanged.promise,l).catch(p=>{});const d=Date.now();this._calculators.size>0&&(this._calculators.forEach(p=>{p.aggregate()}),e++,e===this._dataPointsPerAggregation&&r());const h=Date.now();l=d+1e3*this._aggregationInterval-h}else r(),this._calculators.clear(),await this._callStateChanged.promise.catch(d=>{}),l=1e3*this._aggregationInterval;this._callStateChanged.isPending()||(this._callStateChanged=ug())}r()}}class _Ut extends F2e{constructor(e,i,r,o){super(e,i.createChild("LiveStreamStatsPoller"),r.liveStreamStats.fetchInterval,r.liveStreamStats.pollingMethod,r.liveStreamStats.activeState),this._liveStreams=o}async getStats(){const e={};return this._liveStreams.forEach((i,r)=>{try{const o=i.tsStream.getStats();if(o){const l=o.id.toString(),d={id:l};typeof o.player_downloadBitrate=="number"&&(d.videoBitrate=o.player_downloadBitrate),typeof o.player_audioDownloadBitrate=="number"&&(d.audioBitrate=o.player_audioDownloadBitrate),typeof o.player_totalDownloadedBytes=="number"&&(d.downloadBitrate=o.player_totalDownloadedBytes,d.totalDownloadBytes=o.player_totalDownloadedBytes),typeof o.player_videoBufferLength=="number"&&(d.bufferLengthInMs=Math.round(1e3*o.player_videoBufferLength)),o.player_mediaHeight!==void 0&&(d.videoHeight=o.player_mediaHeight),o.player_mediaWidth!==void 0&&(d.videoWidth=o.player_mediaWidth),o.player_playerHeight!==void 0&&(d.playerHeight=o.player_playerHeight),o.player_playerWidth!==void 0&&(d.playerWidth=o.player_playerWidth),typeof o.player_mediaDelay=="number"&&(d.mediaDelayInMs=Math.round(1e3*o.player_mediaDelay)),typeof o.player_currentPlayPosition=="number"&&(d.currentPlayPosition=Math.round(1e3*o.player_currentPlayPosition)/1e3),e[l]=d}}catch(o){this._logger.error(`fetch live stream stats failed: ${o}`)}}),Object.keys(e).length>0?e:void 0}}class EUt{constructor(e,i,r){this._tsCall=e,this._telemetryLogManager=i,this._config=r}log(e){Object.entries(e).forEach(([i,r])=>{const o={id:i},l={id:i};if(Object.entries(r).forEach(([d,h])=>{const p=d,g={};if(this._config.dataToSend.raw){const f={};h?.timestamp&&(f.timestamp=h.timestamp),h?.raw&&(f.raw=h?.raw),f.raw===void 0&&delete l[p],l[p]=f}h?.aggregation!==void 0?(h?.timestamp&&(g.timestamp=h?.timestamp),this._config.dataToSend.min&&(g.min=h?.aggregation.min),this._config.dataToSend.max&&(g.max=h?.aggregation.max),this._config.dataToSend.sum&&(g.sum=h?.aggregation.sum),this._config.dataToSend.count&&(g.count=h?.aggregation.count),h?.aggregation.sum&&h?.aggregation.count&&(g.average=EQ(h?.aggregation.sum)/EQ(h?.aggregation.count))):(h?.timestamp&&(g.timestamp=h.timestamp),h?.reduced?g.raw=h?.reduced:h?.raw!==void 0&&(g.raw=h?.raw)),o[p]=g}),Object.keys(o).length>1){const d={stats:o,callId:this._tsCall.callId||"",localParticipantId:this._tsCall.participantId||""};this._sendLiveStreamStatsEvent(d)}if(this._config.dataToSend.raw&&Object.keys(l).length>1){const d={stats:l,callId:this._tsCall.callId||"",localParticipantId:this._tsCall.participantId||""};this._sendLiveStreamRawStatsEvent(d)}})}_sendLiveStreamStatsEvent(e){this._telemetryLogManager.sendEvent({name:vi.acs_calling_livestream_stats,tenant:Wr,properties:e})}_sendLiveStreamRawStatsEvent(e){this._telemetryLogManager.sendEvent({name:vi.acs_calling_livestream_raw_stats,tenant:Wr,properties:e})}}class AUt{constructor(e,i,r,o){this._logger=i,this._collectors=[],this._disposed=!1,this._externalStatsInfo={};const l=wt(),d=l.telemetry.liveStreamStatsConfig;this._config=l.liveStreamStats,this._tsCall=e.tsCall,this._statsPoller=new _Ut(e,this._logger,l,o);const h={...mxt,...d.additionalStats};if(Object.entries(h).filter(([,p])=>!p.is_internal).forEach(([p,g])=>{this._externalStatsInfo[p]=g}),d.enabled){const p=new oUe(this._tsCall,this._logger,{statsPoller:this._statsPoller,aggregationInterval:d.aggregationInterval,dataPointsPerAggregation:d.dataPointsPerAggregation,statsInfo:h,isInternal:!0}),g=new EUt(this._tsCall,r,d);p.on("summaryReported",f=>{g.log(f)}),this._collectors.push(p)}}createStatsCollector(e){if(this._disposed)throw new Oe({defaultError:we.FEATURES.LIVE_STREAM.DISPOSED});const i=this._config,r=new oUe(this._tsCall,this._logger,{statsPoller:this._statsPoller,aggregationInterval:e?.aggregationInterval??i.aggregationInterval,dataPointsPerAggregation:e?.dataPointsPerAggregation??i.dataPointsPerAggregation,statsInfo:this._externalStatsInfo,isInternal:!1});return r.on("dispose",()=>{this._collectors=this._collectors.filter(o=>o!==r)}),this._collectors.push(r),r}dispose(){this._disposed||(this._disposed=!0,this._collectors.forEach(e=>{e.dispose()}))}}class upe{constructor(e,i){this._featureName=e,this._targetBotIds=i,this._streamIdToStreamMap=new Map}initialize(e,i,r,o,l){this._logger=l.createChild(()=>`${this._featureName}::Call(id='${e.callId}')`),this._telemetryLogManager=o,this._call=r,this._tsCall=e,this._callAgent=i,this.observeBotParticipantsAlreadyInCall(),this._tsCall.on("participantAdded",async d=>{this.observeBotParticipantJustJoinedCall(d)}),this._tsCall.on("participantRemoved",async d=>{this.removeStreamOfTheBotJustRemovedFromCall(d)})}disposeAllBotStreams(){this._streamIdToStreamMap.forEach(e=>e.dispose()),this._streamIdToStreamMap.clear()}updateBotIds(e){this._targetBotIds=e}observeBotParticipantsAlreadyInCall(){this._tsCall.participants.forEach(e=>{this.isExpectedBotParticipant(e)&&(this._logger.info(`${this._featureName} Bot already in the call`),this.observeBotParticipant(e))})}observeBotParticipantJustJoinedCall(e){this.isExpectedBotParticipant(e)&&(this._logger.info(`${this._featureName} Bot added`),this.observeBotParticipant(e))}removeStreamOfTheBotJustRemovedFromCall(e){if(this.isExpectedBotParticipant(e)){this._logger.info(`${this._featureName} Bot removed`);const i=[];this.removeAllStreams(e,i),this.checkVideoStreamAddedOrRemoved([],i)}}observeBotParticipant(e){e.changed(()=>{this._logger.info(`${this._featureName} Bot - changed event triggered. state: ${e.state}`),this._mapStreams(e)}),this._logger.info(`Composition Bot state: ${e.state}`),this._mapStreams(e)}_mapStreams(e){const i=[],r=[],o=l=>{if(e)if(eBe(e.streams&&e.streams[l])){let d=e.streams[l];this._logger.log(`Stream Type: ${l}`),d.forEach(h=>{if(h.id===void 0&&(h.id=-1),!this._streamIdToStreamMap.get(h.id)){const p=this.createConcreteVideoStream(h,e.id);this._logger.log(`${this._featureName} stream created, type==${p.mediaStreamType} id=${h.id}`),i.push(p)}}),this._streamIdToStreamMap.forEach(h=>{h.tsParticipantId!==e.id||d.some(p=>p.id===h.id)||r.push(h)})}else this.removeAllStreams(e,r)};this.getStreamTypes().forEach(l=>o(l)),this.checkVideoStreamAddedOrRemoved(i,r)}removeAllStreams(e,i){this._streamIdToStreamMap.forEach(r=>{r.tsParticipantId===e.id&&i.push(r)})}checkVideoStreamAddedOrRemoved(e,i){if(e.length>0||i.length>0){const r=l=>{this._streamIdToStreamMap.set(l.id,l)},o=l=>{const d=this._streamIdToStreamMap.get(l.id);d&&(this._logger.log(`stream removed, type==${d.mediaStreamType} id=${l.id}`),this._streamIdToStreamMap.delete(l.id),d.dispose())};e.forEach(r),i.forEach(o),this.emitVideoStreamsUpdatedEvent({added:e,removed:i})}}isExpectedBotParticipant(e){return this._targetBotIds.includes(e.id)}}class IUt extends Bu{constructor(e){super(e),this._impl=new wUt(this.eventEmitter,this.name)}get name(){return"LiveStream"}initialize(e,i){this._impl.initialize(e.tsCall,e.callAgent,e.call,e.telemetryLogManager,i)}dispose(){this._impl.dispose(),super.dispose()}get liveStreams(){return this._impl.liveStreams}get participantCount(){return this._impl.streamingClientCount}on(e,i){if(e!=="liveStreamsUpdated"&&e!=="participantCountChanged")throw new Oe({defaultError:we.FEATURES.LIVE_STREAM.EVENT_SUBSCRIBE,defaultErrorMessageArgs:[e]});this.eventEmitter.on(e,i)}off(e,i){if(e!=="liveStreamsUpdated"&&e!=="participantCount")throw new Oe({defaultError:we.FEATURES.LIVE_STREAM.EVENT_UNSUBSCRIBE,defaultErrorMessageArgs:[e]});this.eventEmitter.off(e,i)}createStatsCollector(e){return this._impl.createStatsCollector(e)}}class wUt extends upe{constructor(e,i){super(i,wt().calling.liveStreamingBotIds),this._eventEmitter=e}initialize(e,i,r,o,l){super.initialize(e,i,r,o,l),this._statsManager=new AUt(r,l,o,this._streamIdToStreamMap),this._tsCall.participantCounts&&this._tsCall.participantCounts.streamingClients!=null&&(this._participantCount=this._tsCall.participantCounts.streamingClients),this._tsCall.on("participantCountsUpdated",()=>{if(this._tsCall.participantCounts&&this._participantCount!==this._tsCall.participantCounts.streamingClients){const d=this._participantCount;this._participantCount=this._tsCall.participantCounts.streamingClients,this._logger.log(`tsCall participantCount changed from ${d} to ${this._participantCount}`),this._eventEmitter.emit("participantCountChanged")}})}dispose(){super.disposeAllBotStreams(),this._statsManager.dispose()}createStatsCollector(e){return this._statsManager.createStatsCollector(e)}get liveStreams(){return[...this._streamIdToStreamMap.values()].map(e=>e)}get streamingClientCount(){return this._participantCount??0}createConcreteVideoStream(e,i){return new kUt(e,this._logger,this._call,this._callAgent,i,this._telemetryLogManager)}getStreamTypes(){return[2]}emitVideoStreamsUpdatedEvent(e){return this._eventEmitter.emit("liveStreamsUpdated",e)}}class kUt extends FB{constructor(e,i,r,o,l,d){super(e,i,r,l,d,"LiveVideoStream")}getStreamMetadata(){return{callId:this.call?.id,streamType:this.mediaStreamType,localParticipantId:this.call.tsCall.participantId,remoteParticipantId:this.remoteParticipantId,sourceId:this.id,source:"remote",isReceiving:this._isReceiving,isStreaming:this.tsStream.isStreaming,viewIdsRegistered:this.getRegisteredViewIds(),height:this._size.height,width:this._size.width,isDisposed:this._disposed}}}class RUt extends Bu{constructor(e){super(e),this._impl=new MUt(this.eventEmitter,this.name)}get name(){return"ComposedStream"}initialize(e,i){this._impl.initialize(e.tsCall,e.callAgent,e.call,e.telemetryLogManager,i)}dispose(){this._impl.dispose(),super.dispose()}get composedStreams(){return this._impl.composedStreams}on(e,i){this.eventEmitter.on(e,i)}off(e,i){this.eventEmitter.off(e,i)}}class MUt extends upe{constructor(e,i){super(i,wt().calling.composedStreamBotIds),this._eventEmitter=e}initialize(e,i,r,o,l){super.initialize(e,i,r,o,l)}dispose(){super.disposeAllBotStreams()}get composedStreams(){return[...this._streamIdToStreamMap.values()].map(e=>e)}createConcreteVideoStream(e,i){return new PUt(e,this._logger,this._call,this._callAgent,i,this._telemetryLogManager)}getStreamTypes(){return[0]}emitVideoStreamsUpdatedEvent(e){return this._eventEmitter.emit("composedStreamsUpdated",e)}}class PUt extends FB{constructor(e,i,r,o,l,d){super(e,i,r,l,d,"ComposedVideoStream")}getStreamMetadata(){return{callId:this.call?.id,streamType:this.mediaStreamType,localParticipantId:this.call.tsCall.participantId,remoteParticipantId:this.remoteParticipantId,sourceId:this.id,source:"remote",isReceiving:this._isReceiving,isStreaming:this.tsStream.isStreaming,viewIdsRegistered:this.getRegisteredViewIds(),height:this._size.height,width:this._size.width,isDisposed:this._disposed}}}class sUe{constructor(e){this._tsCall=e,this._activeParticipantMris=new Set,this._participantMriToSourceId=new Map,this._sourceIdToParticipantMri=new Map,this._sourceIdToParticipantId=new Map,this._listenerHandles=[],this._eventEmitter=new $c.EventEmitter,this._listenerHandles.push(this._tsCall.on("participantAdded",i=>{this._activeParticipantMris.add(i.id),this._updateMapping(i),this._eventEmitter.emit("participantAdded",i.id)})),this._listenerHandles.push(this._tsCall.on("participantUpdated",i=>{this._activeParticipantMris.has(i.id)&&this._updateMapping(i)&&this._eventEmitter.emit("participantUpdated",i.id)})),this._listenerHandles.push(this._tsCall.on("participantRemoved",i=>{this._activeParticipantMris.delete(i.id),this._removeMapping(i),this._eventEmitter.emit("participantRemoved",i.id)})),this._tsCall.participants.forEach(i=>{this._activeParticipantMris.add(i.id),this._updateMapping(i)})}_updateMapping(e){const i=e.id,r=[];e.endpoints?.endpointDetails?.forEach(l=>{const d=l.mediaStreams?.find(h=>h.type==="data");d&&(r.push(d.sourceId),this._sourceIdToParticipantId.set(d.sourceId,l.participantId))});const o=this._participantMriToSourceId.get(i);return r.sort(),!dn.isEqual(r,o)&&(this._participantMriToSourceId.set(i,r),r.forEach(l=>{this._sourceIdToParticipantMri.set(l,i)}),!0)}_removeMapping(e){const i=e.id,r=this._participantMriToSourceId.get(i)||[];this._participantMriToSourceId.delete(i),r.forEach(o=>{this._sourceIdToParticipantMri.delete(o),this._sourceIdToParticipantId.delete(o)})}on(e,i){this._eventEmitter.on(e,i)}off(e,i){this._eventEmitter.off(e,i)}findParticipantMri(e){let i=this._sourceIdToParticipantMri.get(e);return i===void 0&&this.isP2P()&&this._tsCall.participants.length&&(i=this._tsCall.participants[0].id),i}findParticipantId(e){let i=this._sourceIdToParticipantId.get(e);return i===void 0&&this.isP2P()&&this._tsCall.participants.length&&this._tsCall.participants[0].endpoints?.endpointDetails.length&&(i=(this._tsCall.participants[0].endpoints?.endpointDetails[0]).participantId),i}findSourceIds(e){return this._participantMriToSourceId.get(e)??[]}isP2P(){return this._tsCall.callType===1}dispose(){this._activeParticipantMris.clear(),this._participantMriToSourceId.clear(),this._sourceIdToParticipantMri.clear(),this._sourceIdToParticipantId.clear(),this._listenerHandles.forEach(e=>e.dispose()),this._eventEmitter.removeAllListeners()}}const x6=2147483648,B6=65535,hpe=1024,ppe=255,lUe=8,cUe=64,dUe=4294967295,DUt="Normal",LUt="Durable",OUt=.4,NUt=.8;function uUe(t,e){return new Oe({defaultError:we.FEATURES.DATA_CHANNEL.EVENT_SUBSCRIBE,defaultErrorMessageArgs:[e,t]})}function F6(t,e){return new Oe({defaultError:we.FEATURES.DATA_CHANNEL.WRONG_ARGUMENT_TYPE,defaultErrorMessageArgs:[t,e]})}function hUe(t,e){return new Oe({defaultError:we.FEATURES.DATA_CHANNEL.WRONG_ARGUMENT_VALUE,defaultErrorMessageArgs:[t,e]})}function xUt(){return new Oe({defaultError:we.FEATURES.DATA_CHANNEL.DISPOSED})}function BUt(){return new Oe({defaultError:we.FEATURES.DATA_CHANNEL.SENDER_NOT_READY})}function pUe(){return new Oe({defaultError:we.FEATURES.DATA_CHANNEL.NO_AVAILABLE_CHANNEL_ID})}function FUt(t){return new Oe({defaultError:we.FEATURES.DATA_CHANNEL.INVALID_CHANNEL_ID,defaultErrorMessageArgs:[t]})}function UUt(t,e){return new Oe({defaultError:we.FEATURES.DATA_CHANNEL.INVALID_INTERNAL_CHANNEL_ID,defaultErrorMessageArgs:[e,t]})}function gUe(){return new Oe({defaultError:we.FEATURES.DATA_CHANNEL.TOO_MANY_PARTICIPANTS})}function zUt(){return new Oe({defaultError:we.FEATURES.DATA_CHANNEL.NO_VALID_PARTICIPANT})}function VUt(){return new Oe({defaultError:we.FEATURES.DATA_CHANNEL.MSG_DATA_EMPTY})}function $Ut(){return new Oe({defaultError:we.FEATURES.DATA_CHANNEL.MSG_DATA_TOO_LARGE})}function HUt(){return new Oe({defaultError:we.FEATURES.DATA_CHANNEL.INVALID_MSG_LENGTH})}function jUt(){return new Oe({defaultError:we.FEATURES.DATA_CHANNEL.BUFFER_FULL})}function GUt(){return new Oe({defaultError:we.FEATURES.DATA_CHANNEL.SENDER_CLOSED})}function qUt(){return new Oe({defaultError:we.FEATURES.DATA_CHANNEL.NO_AVAILABLE_RELIABLE_CHANNEL})}function mUe(){return new Oe({defaultError:we.FEATURES.DATA_CHANNEL.NO_AVAILABLE_UNRELIABLE_CHANNEL})}function WUt(){return new Oe({defaultError:we.FEATURES.DATA_CHANNEL.CHANNEL_ALREADY_ALLOCATED})}function KUt(t){return new Oe({defaultError:we.FEATURES.DATA_CHANNEL.CANT_FIND_CHANNEL_ID,defaultErrorMessageArgs:[t]})}function gpe(){return new Oe({defaultError:we.FEATURES.DATA_CHANNEL.TRAFFIC_LIMITED})}function H3(t){return t?.message??"Unknown"}function U6(t,e,i){const r=i.value;return i.value=function(...o){try{return r?.apply(this,o)}catch(l){throw this?._logger?.error(`${e}: ${H3(l)}`),l}},i}function JUt(t,e,i){const r=i.value;return i.value=async function(...o){try{return await r?.apply(this,o)}catch(l){throw this?._logger?.error(`${e}: ${H3(l)}`),l}},i}class FA{constructor(){this._firstByte=0,this._channelVersion=0,this._channelId=0,this._sequenceNumber=0}static parse(e){if(e.length<FA.headerLength)throw HUt();const i=new DataView(e.buffer),r=i.getUint8(0),o=i.getUint8(1),l=i.getUint16(2),d=i.getUint32(4),h=e.slice(FA.headerLength),p=new FA;return p._firstByte=r,p._channelVersion=o,p._channelId=l,p._sequenceNumber=d,p._data=h,p._serializedData=e,p}static create(e,i,r,o){const l=new FA,d=new Uint8Array(FA.headerLength+o.length),h=new DataView(d.buffer);return i&=255,e&=65535,r>>>=0,h.setUint8(0,0),h.setUint8(1,i),h.setUint16(2,e),h.setUint32(4,r),d.set(o,FA.headerLength),l._channelVersion=i,l._channelId=e,l._sequenceNumber=r,l._data=o,l._serializedData=d,l}get channelId(){return this._channelId}set channelId(e){this._channelId=e}get channelVersion(){return this._channelVersion}get sequenceNumber(){return this._sequenceNumber}get data(){return this._data}get serializedData(){return this._serializedData}isInternal(){return!!(128&this._firstByte)}isEmpty(){return this._data.length===0}}var UA;FA.headerLength=lUe,function(t){t[t.Initializing=0]="Initializing",t[t.Initialized=1]="Initialized",t[t.Started=2]="Started",t[t.Stopped=3]="Stopped",t[t.Destroyed=4]="Destroyed"}(UA||(UA={}));class z6{constructor(e,i){this._eventEmitter=new $c.EventEmitter,this._state=UA.Initializing,this._tsCall=e,this._dataId=i}async initialize(){const e={onStarted:async(i,r,o)=>{this._dataSendFunction=r,this._getStats=o,this._state=UA.Started,this._eventEmitter.emit("stateChanged",this._state)},onStopped:async i=>{this._dataSendFunction=void 0,this._getStats=void 0,this._state=UA.Stopped,this._eventEmitter.emit("stateChanged",this._state)},onDataReceived:async(i,r,o)=>{const l={sourceId:o,data:r};this._eventEmitter.emit("message",l)}};await this._tsCall.dataChannelAdapter?.addHandler(this._dataId,e),this._state<UA.Initialized&&(this._state=UA.Initialized)}on(e,i){this._eventEmitter.on(e,i)}off(e,i){this._eventEmitter.off(e,i)}send(e,i){return this._dataSendFunction?this._dataSendFunction(e,i):Promise.reject(BUt())}getStats(){return this._getStats?this._getStats():Promise.resolve({bufferSize:0,remainingBytes:0,remainingPackets:0})}get state(){return this._state}dispose(){if(this._state===UA.Destroyed)return;const e=this._state;this._state=UA.Destroyed,this._dataSendFunction=void 0,this._getStats=void 0,e!==UA.Initializing&&this._tsCall.dataChannelAdapter?.removeHandler(this._dataId).catch(nh),this._eventEmitter.emit("stateChanged",this._state),this._eventEmitter.removeAllListeners()}}class YUt{constructor(e,i,r){const o=e.dataId;this._logger=r.createChild(`DataChannelProcessor(${o})`),this._eventEmitter=new qf(this._logger,{enableLogOn:!1,enableLogOff:!1,enableLogOnce:!1,enableLogEmit:!1}),this._bufferFullErrorMessage=`dataId ${o} send queue is full`,this._dataChannelAdapter=new z6(i,o),this._dataChannelAdapter.on("message",l=>{try{const d=l.sourceId,h=FA.parse(l.data),p={sourceId:d,message:h};h.isInternal()?this._eventEmitter.emit("internalMessage",p):this._eventEmitter.emit("message",p)}catch(d){this._logger.error(`process message error: ${H3(d)}`)}})}async initialize(){await this._dataChannelAdapter.initialize()}async send(e){try{if(e.recipients===void 0)throw zUt();if(e.recipients.length>cUe)throw gUe();await this._dataChannelAdapter.send(e.data,e.recipients)}catch(i){throw i?.message===this._bufferFullErrorMessage?jUt():new Oe({defaultError:we.FEATURES.DATA_CHANNEL.SEND_FAIL,originalError:i})}}on(e,i){this._eventEmitter.on(e,i)}off(e,i){this._eventEmitter.off(e,i)}dispose(){this._eventEmitter.removeAllListeners(),this._dataChannelAdapter.dispose()}}class QUt{constructor(e){this._sourceIds=[],this._participantMappingManager=e,this._participantMapping=new Map,e.on("participantAdded",i=>{if(this._participantMapping.has(i)){const r=this._participantMappingManager.findSourceIds(i);this._participantMapping.set(i,r),this._updateSourceIds()}}),e.on("participantUpdated",i=>{if(this._participantMapping.has(i)){const r=this._participantMappingManager.findSourceIds(i);this._participantMapping.set(i,r),this._updateSourceIds()}}),e.on("participantRemoved",i=>{this._participantMapping.has(i)&&(this._participantMapping.set(i,[]),this._updateSourceIds())})}get sourceIds(){if(this._participantMappingManager.isP2P()||!(this._participantMapping.size>0)||this._sourceIds.length!==0)return this._sourceIds}setParticipants(e){const i=[];e.forEach(r=>{LA(r),i.push(zr(r))}),this._participantMapping.clear(),i.forEach(r=>{const o=this._participantMappingManager.findSourceIds(r);this._participantMapping.set(r,o)}),this._updateSourceIds()}_updateSourceIds(){this._sourceIds=Array.from(this._participantMapping.values()).flat()}}var RO,PQ=function(t,e,i,r){var o,l=arguments.length,d=l<3?e:r===null?r=Object.getOwnPropertyDescriptor(e,i):r;if(typeof Reflect=="object"&&typeof Reflect.decorate=="function")d=Reflect.decorate(t,e,i,r);else for(var h=t.length-1;h>=0;h--)(o=t[h])&&(d=(l<3?o(d):l>3?o(e,i,d):o(e,i))||d);return l>3&&d&&Object.defineProperty(e,i,d),d},FE=function(t,e){if(typeof Reflect=="object"&&typeof Reflect.metadata=="function")return Reflect.metadata(t,e)};(function(t){t[t.Open=0]="Open",t[t.Closed=1]="Closed",t[t.Destroyed=2]="Destroyed"})(RO||(RO={}));class V6{constructor(e,i,r,o,l,d){this._state=RO.Open;const h=wt().dataChannel;this._eventEmitter=new $c.EventEmitter,this._channelId=e,this._channelVersion=i,this._sequenceNumber=Math.floor(Math.random()*(dUe+1)),this._recipientsManager=new QUt(o),this._dataChannelMonitor=l,this._sendMessageFunction=r,this._maxMessageSize=h.maxMessageSize,this._logger=d.createChild(`DataChannelSender(${e},${i})`),this._logger.info("opened")}get channelId(){return this._channelId}get maxMessageSize(){return this._maxMessageSize}setParticipants(e){if(!Array.isArray(e))throw F6("participants","CommunicationIdentifier[]");if(e.length>cUe)throw gUe();this._recipientsManager.setParticipants(e),this._logger.info(`participant size: ${e.length}`)}async sendMessage(e){if(this._dataChannelMonitor.updateAttemptStats(e.length),!(e instanceof Uint8Array))throw F6("data","Uint8Array");if(this._state===RO.Closed)throw GUt();if(e.length===0)throw VUt();if(e.length>this._maxMessageSize)throw $Ut();const i=this._recipientsManager.sourceIds;await this._sendMessage(e,i),this._dataChannelMonitor.updateCommitStats(e.length)}close(){this._state<RO.Closed&&(this._sendMessage(new Uint8Array,[]).catch(nh),this._state=RO.Closed,this._eventEmitter.emit("close"),this._logger.info("closed"),this._dataChannelMonitor.close())}on(e,i){this._eventEmitter.on(e,i)}off(e,i){this._eventEmitter.off(e,i)}dispose(){this.close(),this._state!==RO.Destroyed&&(this._eventEmitter.removeAllListeners(),this._state=RO.Destroyed,this._logger.info("disposed"))}get channelVersion(){return this._channelVersion}get state(){return this._state}async _sendMessage(e,i){const r=FA.create(this._channelId,this._channelVersion,this._sequenceNumber,e);this._sequenceNumber=(this._sequenceNumber+1)%(dUe+1);const o={channelId:this._channelId,channelVersion:this._channelVersion,recipients:i,data:r.serializedData};await this._sendMessageFunction(o)}}PQ([U6,FE("design:type",Function),FE("design:paramtypes",[Array]),FE("design:returntype",void 0)],V6.prototype,"setParticipants",null),PQ([JUt,FE("design:type",Function),FE("design:paramtypes",[Uint8Array]),FE("design:returntype",Promise)],V6.prototype,"sendMessage",null),PQ([U6,FE("design:type",Function),FE("design:paramtypes",[]),FE("design:returntype",void 0)],V6.prototype,"close",null),PQ([U6,FE("design:type",Function),FE("design:paramtypes",[]),FE("design:returntype",void 0)],V6.prototype,"dispose",null);class ZUt{constructor(e){this.value=e,this.next=void 0}}class XUt{constructor(){this.length=0,this.front=void 0,this.rear=void 0}enqueue(e){const i=new ZUt(e);this.front?(this.rear.next=i,this.rear=i):(this.front=i,this.rear=i),this.length++}dequeue(){if(!this.front)return;const e=this.front;return this.front===this.rear?(this.front=void 0,this.rear=void 0):this.front=this.front.next,this.length--,e.value}peek(){return this.front?.value}size(){return this.length}back(){return this.rear?.value}isEmpty(){return length===0}clear(){this.front=void 0,this.rear=void 0,this.length=0}}var MO,fUe=function(t,e,i,r){var o,l=arguments.length,d=l<3?e:r===null?r=Object.getOwnPropertyDescriptor(e,i):r;if(typeof Reflect=="object"&&typeof Reflect.decorate=="function")d=Reflect.decorate(t,e,i,r);else for(var h=t.length-1;h>=0;h--)(o=t[h])&&(d=(l<3?o(d):l>3?o(e,i,d):o(e,i))||d);return l>3&&d&&Object.defineProperty(e,i,d),d},j3=function(t,e){if(typeof Reflect=="object"&&typeof Reflect.metadata=="function")return Reflect.metadata(t,e)};(function(t){t[t.Open=0]="Open",t[t.Closed=1]="Closed",t[t.Destroyed=2]="Destroyed"})(MO||(MO={}));class mpe{constructor(e,i,r,o,l,d){this._receiveBuffers=new XUt,this._remainingBytes=0,this._state=MO.Open,this._channelVersion=0;const h=wt().dataChannel;this._logger=d.createChild(`DataChannelReceiver(${e},${o},${r})`),this._eventEmitter=new qf(this._logger,{enableLogEmit:!1}),this._maxBufferSize=h.maxReceiveBufferSize,this._dataChannelMonitor=l,this._channelId=e,this._senderParticipantIdentifier=Sl(i),this._channelVersion=o,this._lastMessageTimestamp=Date.now(),this._logger.info("created.")}get channelId(){return this._channelId}get senderParticipantIdentifier(){return this._senderParticipantIdentifier}on(e,i){this._eventEmitter.on(e,i)}off(e,i){this._eventEmitter.off(e,i)}readMessage(){const e=this._receiveBuffers.dequeue();return e?.data&&(this._remainingBytes-=e.data.length),e}dispose(){this._state!==MO.Destroyed&&(this.close(),this._state=MO.Destroyed,this._receiveBuffers.clear(),this._eventEmitter.removeAllListeners())}close(){this._state===MO.Open&&(this._state=MO.Closed,this._eventEmitter.emit("close"),this._dataChannelMonitor.close())}get channelVersion(){return this._channelVersion}get lastMessageTimestamp(){return this._lastMessageTimestamp}get state(){return this._state}appendMessage(e){if(this._dataChannelMonitor.updateAttemptStats(e.data.length),this._state!==MO.Open)return;if(e.data.length===0)return void this.close();if(this._lastMessageTimestamp=Date.now(),this._remainingBytes+e.data.length>this._maxBufferSize)return;const i={sequenceNumber:e.sequenceNumber,data:e.data};this._receiveBuffers.enqueue(i),this._remainingBytes+=e.data.length,this._eventEmitter.emit("messageReady"),this._dataChannelMonitor.updateCommitStats(e.data.length)}}function e5t(t){const e=[];return t.bitrateInKbps!==void 0&&e.push(`bitrateInKbps=${t.bitrateInKbps}`),t.channelId!==void 0&&e.push(`channelId=${t.channelId}`),t.participants!==void 0&&e.push(`participants size=${t.participants.length}`),t.priority!==void 0&&e.push(`priority=${t.priority}`),t.reliability!==void 0&&e.push(`reliability=${t.reliability}`),e.join(",")}function t5t(t,e){if(t===e)return 0;if(e===-1)return 1;const i=t-e;return i>0?i<ppe/2?1:-1:-i>ppe/2?1:-1}function i5t(t){return t===ppe?0:t+1}fUe([U6,j3("design:type",Function),j3("design:paramtypes",[]),j3("design:returntype",Object)],mpe.prototype,"readMessage",null),fUe([U6,j3("design:type",Function),j3("design:paramtypes",[FA]),j3("design:returntype",void 0)],mpe.prototype,"appendMessage",null);class n5t{constructor(e,i,r){this._timeoutHandle=0;const o=wt().dataChannel;this._eventEmitter=new $c.EventEmitter,this._participantMappingManager=e,this._dataChannelMonitor=i,this._logger=r,this._receivers=new Map,this._lastestVersion=new Map,this._receiveTimeoutInMs=o.receiveTimeoutInMs}_checkTimeoutReceivers(){Array.from(this._receivers.keys()).forEach(e=>{const i=this._receivers.get(e);i!==void 0&&Date.now()-i.lastMessageTimestamp>=this._receiveTimeoutInMs&&i.close()}),this._receivers.size>0&&(this._timeoutHandle=window.setTimeout(()=>{this._timeoutHandle=0,this._checkTimeoutReceivers()},Math.ceil(this._receiveTimeoutInMs/2)))}appendMessage(e){const i=`${e.sourceId},${e.message.channelId}`,r=`${e.sourceId},${e.message.channelId},${e.message.channelVersion}`;let o=this._lastestVersion.get(i),l=this._receivers.get(r);const d=e.message;if(l===void 0){if(o!==void 0&&t5t(d.channelVersion,o)===-1||(this._lastestVersion.set(i,d.channelVersion),d.isEmpty())||this._eventEmitter.listenerCount("dataChannelReceiverCreated")===0)return;const h=this._participantMappingManager.findParticipantMri(e.sourceId)??"",p=this._participantMappingManager.findParticipantId(e.sourceId)??"",g=this._dataChannelMonitor.createReceiverMonitor(d.channelId,d.channelVersion,p);if(h==="")return void this._logger.info(`Unable to find corresponding sender mri, ignoring the message. channelId:${d.channelId}, sourceId:${e.sourceId}`);this._logger.info(`channelId:${d.channelId} message from ${p}, sourceId:${e.sourceId}, channelVersion:${d.channelVersion}`),l=new mpe(d.channelId,h,e.sourceId,d.channelVersion,g,this._logger),l.on("close",()=>{this._receivers.delete(r)}),this._receivers.set(r,l),this._eventEmitter.emit("dataChannelReceiverCreated",l),this._timeoutHandle===0&&this._checkTimeoutReceivers()}l.appendMessage(d),d.isEmpty()&&this._receivers.delete(r)}on(e,i){this._eventEmitter.on(e,i)}off(e,i){this._eventEmitter.off(e,i)}dispose(){window.clearTimeout(this._timeoutHandle),this._timeoutHandle=0,this._receivers.forEach((e,i)=>{e.dispose()}),this._lastestVersion.clear(),this._receivers.clear(),this._eventEmitter.removeAllListeners()}}const $6=B6-hpe+1;class fpe{constructor(e){this._channelIdsInUse=e}findAvailableChannelId(){if(this._channelIdsInUse.size>=$6)throw pUe();const e=()=>Math.floor(Math.random()*$6)+hpe;let i;for(;(i=e())&&this._channelIdsInUse.has(i););return i}}class vUe{constructor(e){this._availableChannelIds=[],this._channelIdsInUse=e,this._initArray()}findAvailableChannelId(){if(this._availableChannelIds.length===0){if(this._channelIdsInUse.size>=$6)throw pUe();this._initArray()}return this._availableChannelIds.pop()}_initArray(){const e=Array.from(this._channelIdsInUse,o=>o).sort();let i=0,r=0;for(;i<=B6&&r<e.length;)i<e[r]?(this._availableChannelIds.push(i),i++):(i>e[r]||i++,r++);for(;i<=B6;)this._availableChannelIds.push(i),i++;this._availableChannelIds=dn.shuffle(this._availableChannelIds)}}class a5t{constructor(){this._channelIdsInUse=new Set,this._highWaterMark=Math.ceil($6*NUt),this._lowWaterMark=Math.floor($6*OUt),this._strategy=new fpe(this._channelIdsInUse)}addChannelId(e){e>=hpe&&e<=B6&&(this._channelIdsInUse.add(e),this._channelIdsInUse.size>=this._highWaterMark&&this._strategy instanceof fpe&&(this._strategy=new vUe(this._channelIdsInUse)))}removeChannelId(e){this._channelIdsInUse.delete(e),this._channelIdsInUse.size<this._lowWaterMark&&this._strategy instanceof vUe&&(this._strategy=new fpe(this._channelIdsInUse))}findAvailableChannelId(){return this._strategy.findAvailableChannelId()}}class r5t{constructor(e){this._dataIds=[],this._channelIds=new Map,e.forEach(i=>{this._dataIds.push({dataId:i.dataId,bandwidth:i.bandwidth,allocatedBandwidth:0})})}allocate(e){const i=dn.maxBy(this._dataIds,r=>1-(r.allocatedBandwidth+e.bitrate)/r.bandwidth);if(i===void 0)throw qUt();return i.allocatedBandwidth+=e.bitrate,this._channelIds.set(e.channelId,{dataId:i.dataId,allocatedBandwidth:e.bitrate}),i.dataId}deallocate(e){const i=this._channelIds.get(e);if(i!==void 0){const r=this._dataIds.find(o=>o.dataId===i.dataId);r!==void 0&&(r.allocatedBandwidth-=i.allocatedBandwidth),this._channelIds.delete(e)}}getDataIds(e){const i=this._channelIds.get(e);return i!==void 0?[i.dataId]:[]}}function o5t(t){if(t.find(e=>!Number.isInteger(Math.log2(e))))return!1;for(let e=1;e<t.length;e++)if(t[e]!==2*t[e-1])return!1;return!0}class s5t{getDataIds(e){throw mUe()}getAllSum(){return 0}}class l5t{constructor(e){this._acsDataIdConfigs=[],this._bandwidthList=[],this._acsDataIdConfigs=e,e.forEach(i=>{this._bandwidthList.push(i.bandwidth/1e3)}),this._allSum=dn.sumBy(e,i=>i.bandwidth)}getDataIds(e){let i=[];const r=Math.ceil(e/1e3);if(r>=this._allSum)i=this._acsDataIdConfigs.map(o=>o.dataId);else{const o=this._bandwidthList[0]-1;let l=0;r&o&&(l=this._bandwidthList.findIndex(d=>!(d&r)),l!==-1&&(i.push(this._acsDataIdConfigs[l].dataId),l++));for(let d=l;d<this._bandwidthList.length;d++)this._bandwidthList[d]&r&&i.push(this._acsDataIdConfigs[d].dataId)}return i}getAllSum(){return this._allSum}}function c5t(t){const e=[[]];return t.forEach(i=>{const r=[];e.forEach(o=>{r.push([...o,i])}),e.push(...r)}),e}class d5t{constructor(e){this._bandwidthMap=new Map,this._bandwidthMap.set(0,[]),c5t(e).forEach(i=>{const r=dn.sumBy(i,l=>l.bandwidth),o=this._bandwidthMap.get(r);(o===void 0||i.length<o.length)&&this._bandwidthMap.set(r,i.map(l=>l.dataId))}),this._bandwidthList=Array.from(this._bandwidthMap.keys()).sort((i,r)=>i-r)}getDataIds(e){const i=dn.sortedIndex(this._bandwidthList,e),r=this._bandwidthList[i]??this._bandwidthList[this._bandwidthList.length-1];return this._bandwidthMap.get(r)||[]}getAllSum(){return dn.last(this._bandwidthList)||0}}class yUe{constructor(e){(e=dn.sortBy(e,i=>i.bandwidth)).length?o5t(e.map(i=>i.bandwidth/1e3))?this._dataIdSelectionStrategy=new l5t(e):this._dataIdSelectionStrategy=new d5t(e):this._dataIdSelectionStrategy=new s5t}getDataIds(e){return this._dataIdSelectionStrategy.getDataIds(e)}getAllSum(){return this._dataIdSelectionStrategy.getAllSum()}}class SUe{constructor(e){this._totalNormalPriorityBandwidth=0,this._totalHighPriorityBandwidth=0,this._configs=new Map,this._currentNormalPriorityDataIds=[],this._currentHighPriorityDataIds=[],this._normalPriorityTable=new yUe(e.filter(i=>i.priority==="normal")),this._highPriorityTable=new yUe(e.filter(i=>i.priority==="high"))}allocate(e){this._configs.set(e.channelId,e),e.priority==="Normal"?this._totalNormalPriorityBandwidth+=e.bitrate:e.priority==="High"&&(this._totalHighPriorityBandwidth+=e.bitrate),this._updateDataIds()}deallocate(e){const i=this._configs.get(e);i!==void 0&&(this._configs.delete(e),i.priority==="Normal"?this._totalNormalPriorityBandwidth-=i.bitrate:i.priority==="High"&&(this._totalHighPriorityBandwidth-=i.bitrate),this._updateDataIds())}getDataIds(e){const i=this._configs.get(e);if(i!==void 0){if(i.priority==="Normal")return this._currentNormalPriorityDataIds;if(i.priority==="High")return this._currentHighPriorityDataIds}return[]}_updateDataIds(){const e=this._highPriorityTable.getAllSum(),i=this._totalHighPriorityBandwidth-e;if(i>0){const r=this._totalNormalPriorityBandwidth+i;this._currentNormalPriorityDataIds=this._normalPriorityTable.getDataIds(r),this._currentHighPriorityDataIds=this._highPriorityTable.getDataIds(this._totalHighPriorityBandwidth).concat(this._currentNormalPriorityDataIds)}else this._currentNormalPriorityDataIds=this._normalPriorityTable.getDataIds(this._totalNormalPriorityBandwidth),this._currentHighPriorityDataIds=this._highPriorityTable.getDataIds(this._totalHighPriorityBandwidth)}}class u5t{constructor(e){const i=e.filter(l=>l.category==="reliable"),r=e.filter(l=>l.category==="unicast"),o=e.filter(l=>l.category==="broadcast");this._reliableDataIdManager=new r5t(i),this._unicastDataIdManager=new SUe(r),this._broadcastDataIdManager=new SUe(o),this._configs=new Map}allocate(e){let i=-1;if(this._configs.has(e.channelId))throw WUt();try{e.reliability==="Durable"?i=this._reliableDataIdManager.allocate(e):(this._unicastDataIdManager.allocate(e),this._broadcastDataIdManager.allocate(e)),this._configs.set(e.channelId,e)}catch(r){throw e.reliability==="Durable"?this._reliableDataIdManager.deallocate(e.channelId):(this._unicastDataIdManager.deallocate(e.channelId),this._broadcastDataIdManager.deallocate(e.channelId)),r}return i}deallocate(e){const i=this._configs.get(e);i!==void 0&&(i.reliability==="Durable"?this._reliableDataIdManager.deallocate(e):(this._unicastDataIdManager.deallocate(e),this._broadcastDataIdManager.deallocate(e)),this._configs.delete(e))}getDataIdToSend(e,i,r){const o=this._configs.get(e);if(o!==void 0)return o.reliability==="Durable"?this._reliableDataIdManager.getDataIds(e):r?this._broadcastDataIdManager.getDataIds(e):this._unicastDataIdManager.getDataIds(e);throw KUt(e)}}class bUe{constructor(e){this._attemptCount=0,this._attemptBytes=0,this._commitCount=0,this._commitBytes=0,this._dataChannelTelemetryLogger=e,this._openTime=new Date,this._closeTime=this._openTime}updateAttemptStats(e){this._attemptCount++,this._attemptBytes+=e}updateCommitStats(e){this._commitCount++,this._commitBytes+=e}close(){this._closeTime=new Date}}class h5t extends bUe{constructor(e,i,r,o){super(o),this._channelId=e,this._channelVersion=i,this._correlationId=r}close(){super.close();const e={direction:"send",channelId:this._channelId,channelVersion:this._channelVersion,openTime:this._openTime,closeTime:this._closeTime,attemptCount:this._attemptCount,attemptBytes:this._attemptBytes,commitCount:this._commitCount,commitBytes:this._commitBytes,correlationId:this._correlationId};this._dataChannelTelemetryLogger.sendStatsEvent(e)}}class p5t extends bUe{constructor(e,i,r,o){super(o),this._channelId=e,this._channelVersion=i,this._remoteParticipantId=r}close(){super.close();const e={direction:"recv",channelId:this._channelId,channelVersion:this._channelVersion,openTime:this._openTime,closeTime:this._closeTime,attemptCount:this._attemptCount,attemptBytes:this._attemptBytes,commitCount:this._commitCount,commitBytes:this._commitBytes,remoteParticipantId:this._remoteParticipantId};this._dataChannelTelemetryLogger.sendStatsEvent(e)}}class g5t{constructor(e){this._dataChannelTelemetryLogger=e}createSenderMonitor(e,i,r){return new h5t(e,i,r,this._dataChannelTelemetryLogger)}createReceiverMonitor(e,i,r){return new p5t(e,i,r,this._dataChannelTelemetryLogger)}}class m5t{constructor(e){this._timeBucket=0,this._maxPacketRate=0,this._packetCount=0,this._maxPacketRate=e}canSend(e){let i=Math.ceil(e/1200);const r=window.performance.now();return Math.floor(r/1e3)==this._timeBucket&&(i+=this._packetCount),i<=this._maxPacketRate}update(e){let i=Math.ceil(e/1200);const r=window.performance.now(),o=Math.floor(r/1e3);o!==this._timeBucket&&(this._timeBucket=o,this._packetCount=0),this._packetCount+=i}}class f5t{constructor(e){this._endTime=0,this._maxDataRate=0,this._maxDataRate=e/8}canSend(e){if(this._maxDataRate===0)return!0;const i=window.performance.now(),r=(this._endTime-i)/1e3;return!(r>0)||r+e/this._maxDataRate<=1}update(e){const i=window.performance.now(),r=this._maxDataRate?e/this._maxDataRate*1e3:0;this._endTime<i?this._endTime=i+r:this._endTime+=r}changeBitrate(e){this._maxDataRate=e/8}}class v5t{constructor(){this._totalBytes=0,this._lastUpdateTime=window.performance.now(),this._lastUpdateBytes=0,this._currentBitrate=0}getBitrate(){return this._currentBitrate}update(e){this._totalBytes+=e}calculateBitrate(){const e=window.performance.now();e-this._lastUpdateTime>0&&(this._currentBitrate=8*(this._totalBytes-this._lastUpdateBytes)/(e-this._lastUpdateTime)),this._lastUpdateTime=e,this._lastUpdateBytes=this._totalBytes}}class y5t{constructor(e,i){this._availableBytes=0,this._reducedBytes=0,this._lastUpdateTime=window.performance.now(),this._packetRateLimiter=new m5t(i),this._receiveBitrate=new v5t,this._bitrateTimer=window.setInterval(()=>{this._receiveBitrate.calculateBitrate();const r=window.performance.now(),o=(r-this._lastUpdateTime)/1e3;this._availableBytes=e/8*o,this._reducedBytes=.8*this._receiveBitrate.getBitrate()/8*o,this._lastUpdateTime=r},1e3)}canSend(e,i){return i?!!this._packetRateLimiter.canSend(e)&&this._availableBytes-this._reducedBytes>=e:this._availableBytes>=e}updateSendBytes(e,i){i&&this._packetRateLimiter.update(e),this._availableBytes-=e}updateReceiveBytes(e){this._receiveBitrate.update(e)}dispose(){window.clearInterval(this._bitrateTimer)}}var PO,bu;(function(t){t[t.Initializing=0]="Initializing",t[t.Initialized=1]="Initialized",t[t.Destroyed=2]="Destroyed"})(PO||(PO={}));class S5t{constructor(e,i,r){this._state=PO.Initializing,this._initializedDefer=ug();const o=wt();this._logger=i,this._tsCall=e,this._dataChannelTelemtryLogger=r,this._participantMappingManager=new sUe(e),this._dataChannelMonitor=new g5t(r),this._senders=new Map,this._receiversManager=new n5t(this._participantMappingManager,this._dataChannelMonitor,i),this._processors=new Map,this._channelVersions=new Map,this._randomChannelIdManager=new a5t,this._dataIds=new Map,o.dataChannel.dataIdConfigs.forEach(l=>{const d=this._dataIds.get(l.dataId)??[];d.push(l.raw?{dataId:l.dataId,raw:l.raw}:{dataId:l.dataId,raw:l.raw,bandwidth:l.bandwidth??0,priority:l.priority??"normal",category:l.category??"reliable"}),this._dataIds.set(l.dataId,d)}),this._rateLimiters=new Map,this._sendTrafficLimiter=new y5t(o.dataChannel.maxSendBandwidth,o.dataChannel.maxBroadcastPacketRate),this._enableBroadcastLimitOnReliableChannel=o.dataChannel.enableBroadcastLimitOnReliableChannel}async initialize(){const e=async d=>{const h=new YUt(d,this._tsCall,this._logger);return h.on("message",p=>{const g=p.message;d.raw?g.channelId=d.dataId+x6:this._sendTrafficLimiter.updateReceiveBytes(g.data.length);try{this._receiversManager.appendMessage(p)}catch(f){this._logger.error(`Failed to appendMessage on dataId ${d.dataId}: ${H3(f)}`)}}),await h.initialize(),h},i=[],r=new Map,o=Array.from(this._dataIds.keys());for(let d=0;d<o.length;d++){const h=o[d],p=this._dataIds.get(h)[0];try{const g=await e(p);r.set(h,g)}catch{i.push(h),this._dataIds.delete(h)}}const l=dn.flatten(Array.from(this._dataIds.values())).filter(d=>!d.raw);this._dataIdMappingManager=new u5t(l),this._state===PO.Initializing?(this._processors=r,l.forEach(d=>{this._rateLimiters.has(d.dataId)||this._rateLimiters.set(d.dataId,new f5t(d.bandwidth))}),i.length?this._dataChannelTelemtryLogger.sendCreateProcessorEvent({kindOfEvent:"failure",dataIds:i}):this._dataChannelTelemtryLogger.sendCreateProcessorEvent({kindOfEvent:"success",dataIds:o}),this._state=PO.Initialized,this._initializedDefer.resolve()):r.forEach(d=>{d.dispose()})}createSender(e,i){let r=e.channelId,o=!1;if(r>=x6){const y=r-x6;if(this._dataIds.get(y)?.[0].raw!==!0)throw UUt(y,r);o=!0}else{if(r<0||r>B6)throw FUt(r);r===0&&(r=this._randomChannelIdManager.findAvailableChannelId())}this._senders.get(r)?.close();const l=i5t(this._channelVersions.get(r)??-1);let d=r>=x6?r-x6:-1,h=!1;d===-1&&this._state===PO.Initialized&&(d=this._dataIdMappingManager.allocate({channelId:r,reliability:e.reliability,priority:e.priority,bitrate:1e3*e.bitrateInKbps}),h=!0);const p=async y=>{const T=y.data.length;if(d===-1&&!h){if(T===lUe)return;await this._initializedDefer.promise,h||(d=this._dataIdMappingManager.allocate({channelId:r,reliability:e.reliability,priority:e.priority,bitrate:1e3*e.bitrateInKbps}),h=!0)}const C=y.recipients?.length===0&&!this._participantMappingManager.isP2P();if(d!==-1)if(this._enableBroadcastLimitOnReliableChannel&&C&&!o){if(!this._sendTrafficLimiter.canSend(T,C))throw gpe();await this._processors.get(d)?.send(y),this._sendTrafficLimiter.updateSendBytes(T,C)}else await this._processors.get(d)?.send(y);else{const E=this._dataIdMappingManager.getDataIdToSend(r,T,C);try{const I=!this._sendTrafficLimiter.canSend(T,C);if(I&&e.priority!=="High")throw gpe();if(E.length===0)throw mUe();for(let w=0;w<E.length;w++)try{const D=E[w],F=this._dataIds.get(D)[0];if(I&&F.priority==="normal")continue;const x=this._rateLimiters.get(D);if(x?.canSend(T)??!0)return await this._processors.get(D)?.send(y),x?.update(T),void this._sendTrafficLimiter.updateSendBytes(T,C)}catch{}throw gpe()}catch(I){this._logger.error(`Failed to send channelId ${r} message: ${H3(I)}`)}}},g=this._dataChannelMonitor.createSenderMonitor(r,l,i),f=new V6(r,l,p,this._participantMappingManager,g,this._logger);return f.on("close",()=>{h&&this._dataIdMappingManager.deallocate(r),this._randomChannelIdManager.removeChannelId(r),this._senders.delete(r),setTimeout(()=>f.dispose(),0)}),e.participants!==void 0&&f.setParticipants(e.participants),this._senders.set(r,f),this._randomChannelIdManager.addChannelId(r),this._channelVersions.set(r,l),f}getDataStreamIdsFromParticipant(e){return this._participantMappingManager.findSourceIds(e.id)}on(e,i){e==="dataChannelReceiverCreated"&&this._receiversManager.on("dataChannelReceiverCreated",i)}off(e,i){e==="dataChannelReceiverCreated"&&this._receiversManager.off("dataChannelReceiverCreated",i)}dispose(){this._state!==PO.Destroyed&&(this._state=PO.Destroyed,this._initializedDefer.isPending()&&this._initializedDefer.reject(xUt()),this._senders.forEach(e=>{e.dispose()}),this._receiversManager.dispose(),this._processors.forEach(e=>{e.dispose()}),this._sendTrafficLimiter.dispose(),this._participantMappingManager.dispose())}}class b5t{constructor(e,i){this._tsCall=e,this._telemetryLogManager=i}sendStatsEvent(e){const i={callId:this._tsCall.callId,localParticipantId:this._tsCall.participantId,...e};this._telemetryLogManager.sendEvent({name:vi.acs_calling_datachannel_stats,tenant:Wr,properties:i})}sendCreateSenderEvent(e){const i={callId:this._tsCall.callId,localParticipantId:this._tsCall.participantId,operation:"createSender",...e};this._telemetryLogManager.sendEvent({name:vi.acs_calling_datachannel,tenant:Wr,properties:i})}sendCreateProcessorEvent(e){const i={callId:this._tsCall.callId,localParticipantId:this._tsCall.participantId,operation:"createProcessor",...e};this._telemetryLogManager.sendEvent({name:vi.acs_calling_datachannel,tenant:Wr,properties:i})}}class T5t extends Bu{constructor(e){super(e)}createDataChannelSender(e){const i=ln(),r=wt();try{if(e.bitrateInKbps!==void 0&&typeof e.bitrateInKbps!="number")throw F6("bitrateInKbps","number");if(e.channelId!==void 0&&typeof e.channelId!="number")throw F6("channelId","number");if(e.participants!==void 0&&!Array.isArray(e.participants))throw F6("participants","CommunicationIdentifier[]");if(e.priority!==void 0&&["High","Normal"].indexOf(e.priority)===-1)throw hUe("priority","High,Normal");if(e.reliability!==void 0&&["Durable","Lossy"].indexOf(e.reliability)===-1)throw hUe("reliability","Durable,Lossy");const o={bitrateInKbps:Math.ceil(e.bitrateInKbps??r.dataChannel.defaultBitrate/1e3),channelId:e.channelId??0,participants:e.participants??[],priority:e.priority??DUt,reliability:e.reliability??LUt};this._logger.info(`createDataChannelSender: ${e5t(e)}`),this._sendFeatureUsage("createDataChannelSender",Je.attempt),this._dataChannelTelemetryLogger.sendCreateSenderEvent({kindOfEvent:"attempt",correlationId:i,senderOptions:{channelId:e.channelId,bitrateInKbps:e.bitrateInKbps,participantsSize:e.participants?.length,priority:e.priority,reliability:e.reliability}});const l=this._dataChannelManager.createSender(o,i);return this._dataChannelTelemetryLogger.sendCreateSenderEvent({kindOfEvent:"success",correlationId:i,senderOptions:{channelId:l.channelId,bitrateInKbps:o.bitrateInKbps,participantsSize:o.participants?.length,priority:o.priority,reliability:o.reliability}}),this._logger.info(`The sender is created. channel id=${l.channelId}`),this._sendFeatureUsage("createDataChannelSender",Je.success),l}catch(o){const l=new Oe({defaultError:we.FEATURES.DATA_CHANNEL.FAILED_TO_CREATE_SENDER,originalError:o});throw this._logger.info(`Failed to create the sender: ${l.message}`),this._sendFeatureUsage("createDataChannelSender",Je.failure),this._dataChannelTelemetryLogger.sendCreateSenderEvent({kindOfEvent:"failure",correlationId:i,failureReason:l.message,additionalDetails:{...an(l)}}),l}}async createDataChannelAdapter(e){const i=new z6(this._tsCall,e);return await i.initialize(),i}initialize(e,i){this._tsCall=e.tsCall,this._logger=i.createChild("DataChannelCallFeature"),this._telemetryLogManager=e.telemetryLogManager,this._dataChannelTelemetryLogger=new b5t(this._tsCall,this._telemetryLogManager);const r=new S5t(this._tsCall,this._logger,this._dataChannelTelemetryLogger);this._dataChannelManager=r,this._dataChannelManager.initialize().then(()=>{this._sendFeatureUsage("initialize",Je.initialize)}).catch(o=>{this._logger.error(`initialize:${H3(o)}`)})}get name(){return this._sendFeatureUsage("name",Je.getter),"DataChannel"}dispose(){this.disposed||(this._dataChannelManager?.dispose(),super.dispose())}getDataStreamIdsFromParticipant(e){return e.tsRemoteParticipant?this._dataChannelManager.getDataStreamIdsFromParticipant(e.tsRemoteParticipant):[]}on(e,i){if(e!=="dataChannelReceiverCreated")throw uUe(e,"subscribe");this._sendFeatureUsage(e,Je.subscribe),e==="dataChannelReceiverCreated"&&this._dataChannelManager?.on("dataChannelReceiverCreated",i)}off(e,i){if(e!=="dataChannelReceiverCreated")throw uUe(e,"unsubscribe");this._sendFeatureUsage(e,Je.unsubscribe),e==="dataChannelReceiverCreated"&&this._dataChannelManager?.off("dataChannelReceiverCreated",i)}_sendFeatureUsage(e,i){Pc({callId:this._tsCall.callId,localParticipantId:this._tsCall.participantId,featureName:"DataChannel",featureType:"Call",initializationType:"OnFeatureAccess",featureDetails:{name:e,step:i}},this._telemetryLogManager,this._logger)}}class C5t extends Bu{constructor(e){super(e),this._impl=new _5t(this.eventEmitter),this._isSpotlightFeatureEnabled=wt().calling.spotlight.enabled,this._callInfo=e.callInfo}get name(){return"Spotlight"}initialize(e,i){this._logger=i,this._logger.info(`Spotlight feature enable flag: ${this._isSpotlightFeatureEnabled}`),this._isSpotlightFeatureEnabled?(this._telemetryLogManager=e.telemetryLogManager,this._tsCall=e.tsCall,this._impl.initialize(e.tsCall,e.callAgent,e.telemetryLogManager,i,this._callInfo)):this._logger.warn("Calls to spotlight APIs will perform no action or return default values where applicable")}async startSpotlight(e){this._isSpotlightFeatureEnabled&&this.validateIdentifierParam(e)&&await this._impl.startSpotlight(e)}async stopSpotlight(e){this._isSpotlightFeatureEnabled&&this.validateIdentifierParam(e)&&await this._impl.stopSpotlight(e)}async stopAllSpotlight(){this._isSpotlightFeatureEnabled&&await this._impl.stopAllSpotlight()}getSpotlightedParticipants(){return this._isSpotlightFeatureEnabled?(this._sendFeatureUsage("getSpotlightedParticipants",Je.getter),this._impl.spotlightedParticipants):[]}get maxParticipantsToSpotlight(){return this._isSpotlightFeatureEnabled?(this._sendFeatureUsage("maxSpotlightSupportedState",Je.getter),this._impl.maxSpotlightStateSupported):0}on(e,i){this._isSpotlightFeatureEnabled&&(this._sendFeatureUsage(e,Je.subscribe),this.eventEmitter.on(e,i))}off(e,i){this._isSpotlightFeatureEnabled&&(this._sendFeatureUsage(e,Je.unsubscribe),this.eventEmitter.off(e,i))}validateIdentifierParam(e=[]){try{return e.forEach(i=>LA(i)),!0}catch{return!1}}_sendFeatureUsage(e,i){Pc({callId:this._tsCall.callId,localParticipantId:this._tsCall.participantId,featureName:this.name,featureType:"Call",initializationType:"OnFeatureAccess",featureDetails:{name:e,step:i}},this._telemetryLogManager,this._logger)}dispose(){this.disposed||super.dispose()}}class _5t{constructor(e){this.typeRankComparator=(r,o)=>r.publishedState===void 0?-1:o.publishedState===void 0?1:r.publishedState.typeRank-o.publishedState.typeRank,this._eventEmitter=e,this._currentSpotlightStates=new Map;const i=wt().calling.spotlight;this._maxSpotlightStateSupported=i.maxSpotlightParticipants,this._supportedUserRoles=i.supportedRoles,this._meetingTypes=i.meetingTypes}initialize(e,i,r,o,l){this._logger=o.createChild(()=>`SpotlightFeature::Call(id='${e.callId}')`),this._tsCall=e,this._callInfo=l,this._telemetryLogManager=r,this._internalCallAgent=i;const d="initialize";this._sendFeatureUsage(d,Je.initialize);try{let h=p=>new Map(this.getPublishedState(p).sort(this.typeRankComparator).map((g,f)=>[g.id,{spotlightStateId:g.publishedState?.stateId,index:f+1}]));this._tsCall.on("publishedStatesChanged",async p=>{let g=h(p),f=[];g.forEach((T,C)=>{this._currentSpotlightStates.has(C)||f.push({identifier:Sl(C),order:T?.index})});let y=[];this._currentSpotlightStates.forEach((T,C)=>{g.has(C)||y.push({identifier:Sl(C)})}),this._currentSpotlightStates=g,(f.length||y.length)&&this._eventEmitter.emit("spotlightChanged",{added:f,removed:y})}),this._tsCall.publishedStates&&(this._currentSpotlightStates=h(this._tsCall.publishedStates)),this._sendFeatureUsage(d,Je.success)}catch(h){this.handleSpotlightFailure(d,h)}}async startSpotlight(e){const i="startSpotlight";try{this._sendFeatureUsage(i,Je.attempt);let r=this.getIdentifiersMri(e).filter(l=>!this._currentSpotlightStates.has(l));if(!r.length)throw new Oe({defaultError:we.FEATURES.SPOTLIGHT.ALREADY_SPOTLIGHTED});this.validateStartSpotlightConditions(r);const o={level:"user",type:"spotlight",content:"{}",participantIds:r};if(!await this._tsCall.publishState(o,fd()))throw new Oe({defaultError:we.FEATURES.SPOTLIGHT.START_SPOTLIGHT_FAILED});this._sendFeatureUsage(i,Je.success)}catch(r){this.handleSpotlightFailure(i,r)}}async stopSpotlight(e){const i="stopSpotlight";this._tsCall.publishedStates||this._logger.warn(`${i}: no participants is currently Spotlighted`);try{this._sendFeatureUsage(i,Je.attempt);let r=this.getIdentifiersMri(e);this.validateStopSpotlightConditions(r);const o=this.findStateIdsForParticipantIds(r);await this._tsCall.removeState({stateIds:o},fd()),this._sendFeatureUsage(i,Je.success)}catch(r){this.handleSpotlightFailure(i,r)}}async stopAllSpotlight(){const e="stopAllSpotlight";try{this._sendFeatureUsage(e,Je.attempt),this.validateStopSpotlightConditions([]),await this._tsCall.removeStatesForEveryone({type:"spotlight"},fd()),this._sendFeatureUsage(e,Je.success)}catch(i){this.handleSpotlightFailure(e,i)}}get spotlightedParticipants(){return this._tsCall.publishedStates?Array.from(this._currentSpotlightStates.keys()).map(e=>({identifier:Sl(e),order:this._currentSpotlightStates.get(e)?.index})):[]}get maxSpotlightStateSupported(){return this._maxSpotlightStateSupported}findStateIdsForParticipantIds(e){return e.length&&this._tsCall.publishedStates?e.map(i=>this._currentSpotlightStates.get(i)?.spotlightStateId||"").filter(i=>i.length):[]}getPublishedState(e){return e.typeStates.filter(i=>i.type==="spotlight").map(i=>i.participantStates).flat()}isUserRoleEligible(){const e=this._tsCall.advancedMeetingRole;return!!e&&!!this._supportedUserRoles.find(i=>i===e)}isRoleBasedConversationType(){const e=this._tsCall.conversationType;return!!e&&!!this._meetingTypes.find(i=>i===e)}getIdentifiersMri(e){return e&&e?.length?e.map(i=>zr(i)):[this._internalCallAgent.getUserMri()]}validateStartSpotlightConditions(e){const i="startSpotlight";if(this._callInfo.context===To.TwoParty)throw this._logger.warn("Spotlight not supported for 1:1 calls"),this._sendFeatureUsage(i,Je.failure),new Oe({defaultError:we.FEATURES.SPOTLIGHT.NOT_SUPPORTED_1TO1});if(this.spotlightedParticipants.length+e.length>this._maxSpotlightStateSupported)throw new Oe({defaultError:we.FEATURES.SPOTLIGHT.SPOTLIGHT_LIGHT_MAX_REACHED,defaultErrorMessageArgs:[this._maxSpotlightStateSupported]});if(this.isRoleBasedConversationType()&&!this.isUserRoleEligible())throw new Oe({defaultError:we.FEATURES.SPOTLIGHT.UNSUPPORTED_ROLE_TYPE,defaultErrorMessageArgs:["Start",this._tsCall.conversationType]})}validateStopSpotlightConditions(e){if(!(e.length===1&&e[0]===this._internalCallAgent.getUserMri())&&this.isRoleBasedConversationType()&&!this.isUserRoleEligible())throw new Oe({defaultError:we.FEATURES.SPOTLIGHT.UNSUPPORTED_ROLE_TYPE,defaultErrorMessageArgs:["Stop",this._tsCall.conversationType]})}handleSpotlightFailure(e,i){throw this._logger.error(JSON.stringify(i)),this._sendFeatureUsage(e,Je.failure,i),i}_sendFeatureUsage(e,i,r){let o=r?{code:r?.code||jL,subCode:r?.subCode||0,failureReason:r?.message||"",...an(r)}:void 0;Pc({callId:this._tsCall.callId,localParticipantId:this._tsCall.participantId,featureName:"Spotlight",featureType:"Call",initializationType:"OnFeatureAccess",featureDetails:{name:e,step:i},additionalDetails:o},this._telemetryLogManager,this._logger)}}class E5t extends Bu{constructor(e){super(e),this._impl=new il}initialize(e,i){this._impl.initialize(e.tsCall,e.callAgent,e.call,e.telemetryLogManager,i)}get name(){return"CallSurvey"}dispose(){super.dispose()}submitSurvey(e){return this._impl.submitSurvey(e)}}class il{initialize(e,i,r,o,l){this._tsCall=e,this._call=r,this._telemetryLogManager=o,this._logger=l,this.updateCallSurveyInfo();const d=()=>{this._tsCall?.state===7&&(this._logger.debug("Call disconnected. Releasing call and tsCall references."),this.updateCallSurveyInfo(),this._tsCall=void 0,this._call=void 0)};this._tsCall.on("callStateChanged",d)}async submitSurvey(e){const i=+new Date,r=ln();this.updateCallSurveyInfo(),this.sendEndOfCallEvent("attempt",r);const o=this.validateSurvey(e);if(o){const l=new Oe({defaultError:we.FEATURES.CALL_SURVEY.INVALID_SURVEY,defaultErrorMessageArgs:[o]});throw this.sendEndOfCallEvent("failure",r,i,{failureReason:o,code:Ikt,...an(l),isExpected:!0}),l}return new Promise((l,d)=>{const h=this.createCallSurveyInternal(e);this.registerNotificationEventListener(h,r,i,l,d),this.sendEndOfCallEvent("success",r,i,void 0,h)})}registerNotificationEventListener(e,i,r,o,l){const d={id:i,callId:e.callId,localParticipantId:e.localParticipantId,overallRating:e.overallRating,audioRating:e.audioRating,videoRating:e.videoRating,screenshareRating:e.screenshareRating};il.NOTIFICATION_LISTENER.eventsSent=h=>{h.find(p=>p.name===vi.acs_calling_survey&&p.data?.correlationId===i&&p.data?.kindOfEvent==="success")&&o(d)},il.NOTIFICATION_LISTENER.eventsDiscarded=(h,p)=>{if(h.find(g=>g.name===vi.acs_calling_survey&&g.data?.correlationId===i&&g.data?.kindOfEvent==="success")){const g=new Oe({defaultError:we.FEATURES.CALL_SURVEY.SUBMIT_TIMEOUT});this.sendEndOfCallEvent("failure",i,r,{failureReason:g.message,code:g.code,...an(g)}),l(g)}}}updateCallSurveyInfo(){const e=this.createCallSurveyInfo();e&&(this._callSurveyInfo=e)}createCallSurveyInfo(){return this._call&&this._tsCall?{callId:this._tsCall.callId,localParticipantId:this._tsCall.participantId,callMode:this._tsCall.callMode,isCteTeamsCall:this._call.isCteTeamsCall}:void this._logger.warn(`Call: ${this._call} or tsCall: ${this._tsCall} is not available to create call survey info.`)}sendEndOfCallEvent(e,i,r,o,l){try{const d={eventName:vi.acs_calling_survey,callId:this._callSurveyInfo?.callId,localParticipantId:this._callSurveyInfo?.localParticipantId,correlationId:i,kindOfEvent:e,timestampInfo:{deltaTimeInMs:0},additionalDetails:o};if(r){const h=+new Date;d.timestampInfo.deltaTimeInMs=h-r}e==="success"&&l?(d.overallRating=l.overallRating,d.audioRating=l.audioRating,d.videoRating=l.videoRating,d.screenshareRating=l.screenshareRating,this._telemetryLogManager.sendEvent({name:vi.acs_calling_survey,tenant:Wr,priority:Uj.Immediate,properties:d},il.NOTIFICATION_LISTENER),wt().calling.teamsCallQualityFeedback.enabled&&this._callSurveyInfo?.isCteTeamsCall&&this.acsCallSurveyToMediaCallQualityFeedback(l,i)):this._telemetryLogManager.sendEvent({name:d.eventName,tenant:Wr,properties:d})}catch{this._logger.debug("Unable to send call survey telemetry")}}acsCallSurveyToMediaCallQualityFeedback(e,i){const r=this.getFiveStarRating(e.overallRating);if(r===void 0)return void this._logger.info("Call survey has no valid overall rating. Skipping media call quality feedback.");const o=this.getAllCallIssues(e),l={acs_correlation_id:i,call_mos_score_questionary_id:105,clientType:"ACSWebSDK",call_id:e.callId,participant_id:e.localParticipantId,call_mos_score:r-1,call_mos_score_tracking_reason:"random",call_mos_score_problem_tokens:o,call_mos_score_never_expires:!1};this._callSurveyInfo?.callMode!==void 0&&(l.call_mode=this._callSurveyInfo.callMode),this._telemetryLogManager.sendEvent({name:vi.mdsc_call_quality_feedback,tenant:wt().calling.teamsCallQualityFeedback.tenantId,priority:Uj.Immediate,properties:l})}getAllCallIssues(e){const i=[];return e.overallRating?.issues?.forEach(r=>i.push(il.ACS_OVERALL_ISSUES_TO_TEAMS_CQF_PROBLEM_TOKEN_CODE[r])),e.audioRating?.issues?.forEach(r=>i.push(il.ACS_AUDIO_ISSUES_TO_TEAMS_CQF_PROBLEM_TOKEN_CODE[r])),e.videoRating?.issues?.forEach(r=>i.push(il.ACS_VIDEO_ISSUES_TO_TEAMS_CQF_PROBLEM_TOKEN_CODE[r])),e.screenshareRating?.issues?.forEach(r=>i.push(il.ACS_SCREENSHARE_ISSUES_TO_TEAMS_CQF_PROBLEM_TOKEN_CODE[r])),i.length>0?"checks="+i.join("%20"):""}getFiveStarRating(e){if(e?.scale){const i=e.score-e.scale.lowerBound+1,r=e.scale.upperBound-e.scale.lowerBound+1,o=Math.round(5*i/r);return o<1?1:o}return e?.score}createCallSurveyInternal(e){const i={callId:this._callSurveyInfo?.callId,localParticipantId:this._callSurveyInfo?.localParticipantId};return e&&(i.overallRating=e.overallRating,i.audioRating=e.audioRating,i.videoRating=e.videoRating,i.screenshareRating=e.screenshareRating),i}validateSurvey(e){let i="";return i=this.validateOverallRating(e.overallRating),i+=this.validateAudioRating(e.audioRating),i+=this.validateVideoRating(e.videoRating),i+=this.validateScreenshareRating(e.screenshareRating),i!==""||e.overallRating||e.audioRating||e.videoRating||e.screenshareRating||(i="At least one survey rating is required."),i===""&&(i=this.validateCallSurveyTypes(e)),i.trim()}validateOverallRating(e){if(!e)return"";let i="";return this.isValidFiveStarRating(e)?e.scale&&!this.isRatingValueMatchesRatingScale(e.score,e.scale)?i=this.ratingOutOfRangeMessage(il.OVERALL_RATING_SCORE,e):e.scale&&!this.isValidQualityThreshold(e.scale)?i=this.thresholdOutOfRangeMessage("overallRating.scale.lowScoreThreshold",e):e.scale&&!this.isValidRatingScale(e.scale)&&(i=this.ratingScaleOutOfRangeMessage("overallRating.scale",e)):i=this.defaultRatingScaleMessage(il.OVERALL_RATING_SCORE),i}validateAudioRating(e){if(!e)return"";let i="";return this.isValidFiveStarRating(e)?e.scale&&!this.isRatingValueMatchesRatingScale(e.score,e.scale)?i=this.ratingOutOfRangeMessage(il.AUDIO_RATING_SCORE,e):e.scale&&!this.isValidQualityThreshold(e.scale)?i=this.thresholdOutOfRangeMessage("audioRating.scale.lowScoreThreshold",e):e.scale&&!this.isValidRatingScale(e.scale)&&(i=this.ratingScaleOutOfRangeMessage("audioRating.scale",e)):i=this.defaultRatingScaleMessage(il.AUDIO_RATING_SCORE),i}validateVideoRating(e){if(!e)return"";let i="";return this.isValidFiveStarRating(e)?e.scale&&!this.isRatingValueMatchesRatingScale(e.score,e.scale)?i=this.ratingOutOfRangeMessage(il.VIDEO_RATING_SCORE,e):e.scale&&!this.isValidQualityThreshold(e.scale)?i=this.thresholdOutOfRangeMessage("videoRating.scale.lowScoreThreshold",e):e.scale&&!this.isValidRatingScale(e.scale)&&(i=this.ratingScaleOutOfRangeMessage("videoRating.scale",e)):i=this.defaultRatingScaleMessage(il.VIDEO_RATING_SCORE),i}validateScreenshareRating(e){if(!e)return"";let i="";return this.isValidFiveStarRating(e)?e.scale&&!this.isRatingValueMatchesRatingScale(e.score,e.scale)?i=this.ratingOutOfRangeMessage(il.SCREEN_SHARE_RATING_SCORE,e):e.scale&&!this.isValidQualityThreshold(e.scale)?i=this.thresholdOutOfRangeMessage("screenshareRating.scale.lowScoreThreshold",e):e.scale&&!this.isValidRatingScale(e.scale)&&(i=this.ratingScaleOutOfRangeMessage("screenshareRating.scale",e)):i=this.defaultRatingScaleMessage(il.SCREEN_SHARE_RATING_SCORE),i}validateCallSurveyTypes(e){let i="";return e.overallRating&&(i=this.valueShouldBeNumber(il.OVERALL_RATING_SCORE,e.overallRating.score),e.overallRating.issues&&(this.isArray(e.overallRating.issues)?e.overallRating.issues.some(r=>il.OVERALL_ISSUES[r]!==r)&&(i+="overallRating.issues array should be of type OverallIssue. "):i+="overallRating.issues should be of type Array<OverallIssue>. "),i+=this.ratingScaleShouldNotHaveUnexpectedProperties("overallRating.scale",e.overallRating.scale),i+=this.ratingShouldNotHaveUnexpectedProperties("overallRating",e.overallRating)),e.audioRating&&(i+=this.valueShouldBeNumber(il.AUDIO_RATING_SCORE,e.audioRating.score),e.audioRating.issues&&(this.isArray(e.audioRating.issues)?e.audioRating.issues.some(r=>il.AUDIO_ISSUES[r]!==r)&&(i+="audioRating.issues array should be of type AudioIssue. "):i+="audioRating.issues should be of type Array<AudioIssue>. "),i+=this.ratingScaleShouldNotHaveUnexpectedProperties("audioRating.scale",e.audioRating.scale),i+=this.ratingShouldNotHaveUnexpectedProperties("audioRating",e.audioRating)),e.videoRating&&(i+=this.valueShouldBeNumber(il.VIDEO_RATING_SCORE,e.videoRating.score),e.videoRating.issues&&(this.isArray(e.videoRating.issues)?e.videoRating.issues.some(r=>il.VIDEO_ISSUES[r]!==r)&&(i+="videoRating.issues array should be of type VideoIssue. "):i+="videoRating.issues should be of type Array<VideoIssue>. "),i+=this.ratingScaleShouldNotHaveUnexpectedProperties("videoRating.scale",e.videoRating.scale),i+=this.ratingShouldNotHaveUnexpectedProperties("videoRating",e.videoRating)),e.screenshareRating&&(i+=this.valueShouldBeNumber(il.SCREEN_SHARE_RATING_SCORE,e.screenshareRating.score),e.screenshareRating.issues&&(this.isArray(e.screenshareRating.issues)?e.screenshareRating.issues.some(r=>il.SCREENSHARE_ISSUES[r]!==r)&&(i+="screenshareRating.issues array should be of type ScreenshareIssue. "):i+="screenshareRating.issues should be of type Array<ScreenshareIssue>. "),i+=this.ratingScaleShouldNotHaveUnexpectedProperties("screenshareRating.scale",e.screenshareRating.scale),i+=this.ratingShouldNotHaveUnexpectedProperties("screenshareRating",e.screenshareRating)),i}isNumber(e){return e!==null&&typeof e=="number"}isArray(e){return e!==null&&Array.isArray(e)}isValidFiveStarRating(e){return e==null||e.scale!==void 0||e.score>=1&&e.score<=5}isRatingValueMatchesRatingScale(e,i){return e>=i.lowerBound&&e<=i.upperBound}isValidQualityThreshold(e){return e.lowScoreThreshold>=e.lowerBound&&e.lowScoreThreshold<=e.upperBound}isValidRatingScale(e){return e.lowerBound>=0&&e.upperBound<=100}valueShouldBeNumber(e,i){return this.isNumber(i)?"":`${e} should be of type number. `}ratingScaleShouldNotHaveUnexpectedProperties(e,i){let r="";if(!i)return r;for(const o in i)il.RATING_SCALE_KEYS[o]===void 0&&(r+=`${e} should not have ${o}. `);return r}ratingShouldNotHaveUnexpectedProperties(e,i){let r="";if(!i)return r;for(const o in i)il.CALL_RATING_KEYS[o]===void 0&&(r+=`${e} should not have ${o}. `);return r}defaultRatingScaleMessage(e){return`In default scale ${e} should be 1 to 5. `}ratingOutOfRangeMessage(e,i){return`${e}: ${i.score} should be between ${i.scale?.lowerBound} and ${i.scale?.upperBound}. `}thresholdOutOfRangeMessage(e,i){return`${e}: ${i.scale?.lowScoreThreshold} should be between ${i.scale?.lowerBound} and ${i.scale?.upperBound}. `}ratingScaleOutOfRangeMessage(e,i){return`${e} lowerBound: ${i.scale?.lowerBound} and upperBound: ${i.scale?.upperBound} should be between 0 and 100. `}}il.OVERALL_RATING_SCORE="overallRating.score",il.AUDIO_RATING_SCORE="audioRating.score",il.VIDEO_RATING_SCORE="videoRating.score",il.SCREEN_SHARE_RATING_SCORE="screenshareRating.score",il.NOTIFICATION_LISTENER={},il.OVERALL_ISSUES={CallCannotInvite:"CallCannotInvite",CallCannotJoin:"CallCannotJoin",CallEndedUnexpectedly:"CallEndedUnexpectedly",HadToRejoin:"HadToRejoin",OtherIssues:"OtherIssues"},il.AUDIO_ISSUES={AudioInterruption:"AudioInterruption",AudioNoise:"AudioNoise",AudioStoppedUnexpectedly:"AudioStoppedUnexpectedly",DistortedSpeech:"DistortedSpeech",Echo:"Echo",LowVolume:"LowVolume",NoLocalAudio:"NoLocalAudio",NoRemoteAudio:"NoRemoteAudio",OtherIssues:"OtherIssues"},il.VIDEO_ISSUES={AudioVideoOutOfSync:"AudioVideoOutOfSync",DarkVideoReceived:"DarkVideoReceived",Freezes:"Freezes",LowQuality:"LowQuality",NoVideoReceived:"NoVideoReceived",NoVideoSent:"NoVideoSent",OtherIssues:"OtherIssues",StoppedUnexpectedly:"StoppedUnexpectedly"},il.SCREENSHARE_ISSUES={CannotPresent:"CannotPresent",Freezes:"Freezes",LargeDelay:"LargeDelay",LowQuality:"LowQuality",NoContentLocal:"NoContentLocal",NoContentRemote:"NoContentRemote",OtherIssues:"OtherIssues",StoppedUnexpectedly:"StoppedUnexpectedly"},il.CALL_RATING_KEYS={score:"score",issues:"issues",scale:"scale"},il.RATING_SCALE_KEYS={lowerBound:"lowerBound",upperBound:"upperBound",lowScoreThreshold:"lowScoreThreshold"},il.ACS_OVERALL_ISSUES_TO_TEAMS_CQF_PROBLEM_TOKEN_CODE={CallCannotInvite:502,CallCannotJoin:501,CallEndedUnexpectedly:501,HadToRejoin:501,OtherIssues:501},il.ACS_AUDIO_ISSUES_TO_TEAMS_CQF_PROBLEM_TOKEN_CODE={AudioInterruption:108,AudioNoise:104,AudioStoppedUnexpectedly:106,DistortedSpeech:107,Echo:103,LowVolume:105,NoLocalAudio:101,NoRemoteAudio:102,OtherIssues:109},il.ACS_VIDEO_ISSUES_TO_TEAMS_CQF_PROBLEM_TOKEN_CODE={AudioVideoOutOfSync:207,DarkVideoReceived:206,Freezes:204,LowQuality:203,NoVideoReceived:201,NoVideoSent:202,OtherIssues:208,StoppedUnexpectedly:205},il.ACS_SCREENSHARE_ISSUES_TO_TEAMS_CQF_PROBLEM_TOKEN_CODE={CannotPresent:402,Freezes:405,LargeDelay:407,LowQuality:404,NoContentLocal:401,NoContentRemote:402,OtherIssues:408,StoppedUnexpectedly:406};class A5t extends Bu{constructor(e){super(e),this._impl=new I5t(this.eventEmitter,this.name)}get name(){return"AudioZones"}initialize(e,i){this._impl.initialize(e.tsCall,e.callAgent,e.call,e.telemetryLogManager,i)}updateAudioZone(e,i){return this._impl.updateAudioZone(e,i)}dispose(){this._impl.dispose(),super.dispose()}get meetingGroupDetails(){return this._impl.meetingGroupDetails}on(e,i){this.eventEmitter.on(e,i)}off(e,i){this.eventEmitter.off(e,i)}}class I5t{constructor(e,i){this._eventEmitter=e,this._featureName=i}initialize(e,i,r,o,l){this._logger=l.createChild(()=>`${this._featureName}::Call(id='${e.callId}')`),this._tsCall=e,this.updateMeetingGroupDetails(),this._tsCall.changed(()=>{this._logger.log("tsCall changed"),this.updateMeetingGroupDetails()})}updateAudioZone(e,i){const r=ln();return this._logger.log(`updateAudioZone toGroup=${e}, fromGroup=${i}, causeId=${r}`),this._tsCall.updateMeetingGroups(r,{scope:4,toGroup:e,fromGroup:i})}dispose(){this._meetingGroupDetails=void 0}get meetingGroupDetails(){return this._meetingGroupDetails}updateMeetingGroupDetails(){const e=this._tsCall.meetingDetails?.meetingGroups??void 0;dn.isEqual(e,this._meetingGroupDetails)||(this._meetingGroupDetails=e,this._eventEmitter.emit("meetingGroupDetailsChanged"))}}class w5t extends Bu{_sendOVCTelemetryEvent(e){if(!this._telemetryLogManager)return;const i={callId:this._call?.id||"",localParticipantId:this._tsCall?.participantId||"",featureName:"OptimalVideoCount",featureType:"Call",initializationType:"OnFeatureAccess",featureDetails:{step:e}};this._telemetryLogManager.sendEvent({name:vi.acs_calling_feature_usage,tenant:Wr,properties:i})}get optimalVideoCount(){return this._sendOVCTelemetryEvent(Je.getter),this._impl.optimalVideoCount}constructor(e){super(e),this.name="OptimalVideoCount",this._impl=new k5t(this.name,this.eventEmitter)}initialize(e,i){this._impl.initialize(e.tsCall,e.callAgent,e.call,e.telemetryLogManager,i),this._tsCall=e.tsCall,this._telemetryLogManager=e.telemetryLogManager,this._call=e.call}on(e,i){if(e!=="optimalVideoCountChanged")throw new Oe({defaultError:we.FEATURES.OPTIMAL_VIDEO_COUNT.EVENT_SUBSCRIBE,defaultErrorMessageArgs:[e]});this._sendOVCTelemetryEvent(Je.subscribe),this.eventEmitter.on(e,i)}off(e,i){if(e!=="optimalVideoCountChanged")throw new Oe({defaultError:we.FEATURES.OPTIMAL_VIDEO_COUNT.EVENT_UNSUBSCRIBE,defaultErrorMessageArgs:[e]});this._sendOVCTelemetryEvent(Je.unsubscribe),this.eventEmitter.off(e,i)}dispose(){super.dispose(),this._impl.dispose()}}class k5t{get optimalVideoCount(){return this._optimalVideoCount}constructor(e,i){this._featureName=e,this._eventEmitter=i,this._optimalVideoCount=1,this._isRenderingRemoteScreenShareChangedListener=()=>{}}initialize(e,i,r,o,l){this._tsCall=e,this._call=r,this._logger=l,this._logger?.createChild(()=>`${this._featureName}::Call(id='${this._tsCall?.callId}')`);const d=()=>{const h=wt()?.rendering.remoteVideo.decrementOvcOnRemoteSsRendering,p=wt()?.rendering.remoteVideo.decrementOvcValue;let g=(this._tsCall?.optimalVideoCount?this._tsCall.optimalVideoCount:1)-(h&&this._call?.isRenderingRemoteScreenShare?p:0);g<0&&(g=0),this._optimalVideoCount!==g&&(this._logger?.log(`tsCall optimalVideoCount changed from ${this._optimalVideoCount} to ${g}`),this._optimalVideoCount=g,this._eventEmitter.emit("optimalVideoCountChanged"))};this._tsCallChangedListener=this._tsCall.changed(()=>{d()}),this._isRenderingRemoteScreenShareChangedListener=()=>{d()},this._call.onIsRenderingRemoteScreenShareChanged("isRenderingRemoteScreenShareChanged",this._isRenderingRemoteScreenShareChangedListener),d()}dispose(){this._tsCallChangedListener?.dispose(),this._call?.offIsRenderingRemoteScreenShareChanged("isRenderingRemoteScreenShareChanged",this._isRenderingRemoteScreenShareChangedListener)}}function TUe(t,e){return new Oe({defaultError:we.FEATURES.UNMIXED_AUDIO.EVENT_SUBSCIBE_UNSUBSCRIBE,defaultErrorMessageArgs:[e,t]})}function CUe(){return new Oe({defaultError:we.FEATURES.UNMIXED_AUDIO.UNAVAILABLE})}function UB(t){return dn.isString(t)?t:t?.message??"Unknown"}function DQ(t){throw t instanceof Oe?t:new Oe({defaultError:we.FEATURES.UNMIXED_AUDIO.UNKNOWN_ERROR})}function _Ue(){return new Oe({defaultError:we.FEATURES.UNMIXED_AUDIO.PENDING_OPERATION})}function EUe(){return new Oe({defaultError:we.FEATURES.UNMIXED_AUDIO.UNSUPPORTED_OPERATION})}function R5t(){return new Oe({defaultError:we.FEATURES.UNMIXED_AUDIO.ENABLED})}function M5t(){return new Oe({defaultError:we.FEATURES.UNMIXED_AUDIO.DISABLED})}function P5t(){return new Oe({defaultError:we.FEATURES.UNMIXED_AUDIO.DISPOSED})}function LQ(t){return new Oe({defaultError:we.FEATURES.UNMIXED_AUDIO.INVALID_STATE,defaultErrorMessageArgs:[t]})}function AUe(t){return new Oe({defaultError:we.FEATURES.UNMIXED_AUDIO.FAILED_TO_INITIALIZE,originalError:t})}function D5t(t,e){return new Oe({defaultError:we.FEATURES.UNMIXED_AUDIO.FAILED_TO_ENABLE,defaultErrorMessageArgs:[e.audioContextState||"undefined",e.unmixedAudioState||"undefined"],originalError:t})}function L5t(t,e){return new Oe({defaultError:we.FEATURES.UNMIXED_AUDIO.FAILED_TO_DISABLE,defaultErrorMessageArgs:[e.audioContextState||"undefined",e.unmixedAudioState||"undefined"],originalError:t})}class O5t{constructor(e){this._tsCall=e,this._sourceIdMapping=new Map,this._participantIdMapping=new Map,this._listenerHandles=[],this._listenerHandles.push(this._tsCall.on("participantAdded",i=>{this._updateMapping(i)})),this._listenerHandles.push(this._tsCall.on("participantUpdated",i=>{this._updateMapping(i)})),this._listenerHandles.push(this._tsCall.on("participantRemoved",i=>{this._removeMapping(i)})),this._tsCall.participants.forEach(i=>{this._updateMapping(i)})}_updateMapping(e){e.endpoints?.endpointDetails?.forEach(i=>{const r=i.mediaStreams?.find(o=>o.type==="audio");if(r){const o={sourceId:r.sourceId,participantId:i.participantId,mri:e.id};this._sourceIdMapping.set(r.sourceId,o),this._participantIdMapping.set(i.participantId,o)}})}_removeMapping(e){e.endpoints?.endpointDetails?.forEach(i=>{const r=i.mediaStreams?.find(o=>o.type==="audio");r&&(this._sourceIdMapping.delete(r.sourceId),this._participantIdMapping.delete(i.participantId))})}findParticipantInfoBySourceId(e){return this._sourceIdMapping.get(e)}findParticipantInfoByParticipantId(e){return this._participantIdMapping.get(e)}dispose(){this._sourceIdMapping.clear(),this._participantIdMapping.clear(),this._listenerHandles.forEach(e=>e.dispose())}}class N5t{constructor(e,i){this._tsCall=e,this._telemetryLogManager=i}sendActionEvent(e){const i={callId:this._tsCall.callId,localParticipantId:this._tsCall.participantId,...e};this._telemetryLogManager.sendEvent({name:vi.acs_calling_unmixed_audio,tenant:Wr,properties:i})}}class vpe{constructor(e,i){this._unmixedAudioTelemetryLogger=e,this._action=i,this._correlationId=ln()}logAttempt(){this._unmixedAudioTelemetryLogger.sendActionEvent({action:this._action,kindOfEvent:"attempt",correlationId:this._correlationId})}logSuccess(){this._unmixedAudioTelemetryLogger.sendActionEvent({action:this._action,kindOfEvent:"success",correlationId:this._correlationId})}logFailure(e,i){this._unmixedAudioTelemetryLogger.sendActionEvent({action:this._action,kindOfEvent:"failure",correlationId:this._correlationId,failureReason:e.message,...i,additionalDetails:{...an(e)}})}}class x5t{constructor(e,i){this._waitTimeoutInMs=e,this._expectedState=i,this._result=ug(),this._wait=cP(()=>this._result.promise,this._waitTimeoutInMs)}updateState(e){this._result.isPending()&&(e===this._expectedState?this._result.resolve():this._result.reject(new Error(`Unexpected active state: ${e}`)))}get waitState(){return this._expectedState}async wait(){await this._wait}cancel(){this._result.isPending()&&this._result.reject(new Error("Operation cancelled"))}}class IUe{constructor(e,i){this._logger=e.createChild(`AudioContext:${i}`),this._eventEmitter=new $c.EventEmitter;const r=new AudioContext,o=()=>{this._logger.info(`The AudioContext:${i} state changed to ${r.state}`),this._eventEmitter.emit("stateChanged"),r.state==="closed"&&(r.removeEventListener("statechange",o),this._eventEmitter.removeAllListeners())};r.addEventListener("statechange",o),this._audioContext=r}async resume(e=0){if(this._audioContext.state==="closed")throw LQ(this._audioContext.state);if(this._audioContext.state==="running")return;const i=new x5t(e,!0);return this._audioContext.resume().then(()=>{i.updateState(!0),this._logger.info("resumed")}).catch(r=>{this._logger.info(`Failed to resume: ${UB(r)}`),i.updateState(!1)}),i.wait()}async close(){this._audioContext.state!=="closed"&&await this._audioContext.close().then(()=>{this._logger.info("closed")}).catch(e=>{this._logger.info(`Failed to close: ${UB(e)}`)})}get state(){return this._audioContext.state}get value(){return this._audioContext}on(e,i){this._eventEmitter.on(e,i)}off(e,i){this._eventEmitter.off(e,i)}}function ype(t){switch(t){case bu.Uninitialized:return"Uninitialized";case bu.Initializing:return"Initializing";case bu.Initialized:return"Initialized";case bu.Destroyed:return"Destroyed";case bu.Aborted:return"Aborted"}}(function(t){t[t.Uninitialized=0]="Uninitialized",t[t.Initializing=1]="Initializing",t[t.Initialized=2]="Initialized",t[t.Destroyed=3]="Destroyed",t[t.Aborted=4]="Aborted"})(bu||(bu={}));class B5t{constructor(e,i,r,o){this._state=bu.Uninitialized,this._listenerHandles=[],this._audioContextSeq=0,this._activeState=!1,this._pendingOperation=!1,this._initializedDefer=ug();try{this._tsCall=e,this._logger=i.createChild("UnmixedAudioManager"),this._eventEmitter=new qf(this._logger,{enableLogEmit:!1}),this._unmixedAudioTelemetryLogger=r,this._participantManager=new O5t(e),this._destinationStreamInfoMap=new Map,this._destinationStreamInfoList=new Array(o.maxStreamSize),this._sourceStreamInfoList=new Array(o.maxStreamSize),this._maxStreamSize=o.maxStreamSize,this._operationTimeoutInMs=o.operationTimeoutInMs,this._skipProviderStateCheck=o.skipProviderStateCheck}catch(l){throw this._state=bu.Aborted,i.info(`Failed to create UnmixedAudioManager: ${UB(l)}`),AUe(l)}}async initialize(){if(this._state!==bu.Uninitialized)throw LQ(ype(this._state));this._initializedDefer.isPending()||(this._initializedDefer=ug());const e=new vpe(this._unmixedAudioTelemetryLogger,"initialize");this._state=bu.Initializing;try{if(e.logAttempt(),!this._tsCall.getUnmixedAudioProvider||(this._tsUnmixedAudioProvider=this._tsUnmixedAudioProvider??await this._tsCall.getUnmixedAudioProvider(),!this._tsUnmixedAudioProvider))throw CUe();this._audioContext||(this._audioContext=new IUe(this._logger,this._audioContextSeq++),this._audioContext.on("stateChanged",()=>{this._updateActiveState()})),this._listenerHandles.length===0&&(this._listenerHandles.push(this._tsUnmixedAudioProvider.on("onStreamSourcesUpdated",i=>{this._state===bu.Initialized?this._onStreamSourcesUpdatedHandler(i):this._logger.error(`Cannot attach _onStreamSourcesUpdatedHandler listener - this._state:${this._state}`)})),this._listenerHandles.push(this._tsUnmixedAudioProvider.on("onActiveStateChanged",()=>{this._state===bu.Initialized?this._updateActiveState():this._logger.error(`Cannot attach _updateActiveState listener - this._state:${this._state}`)}))),e.logSuccess(),this._logger.info(`Initialized with maxStreamSize ${this._maxStreamSize}. The AudioContext state is ${this._getAudioContextState()}. tsUnmixedAudioProvider state is: [active: ${this._tsUnmixedAudioProvider.active} configured: ${this._tsUnmixedAudioProvider.configured}]`),this._state=bu.Initialized,this._initializedDefer.resolve(),this._updateActiveState()}catch(i){this._state=bu.Uninitialized;const r=UB(i);this._logger.error(`Failed to initialize: ${r}`);const o=AUe(i);e.logFailure(o),this._initializedDefer.reject(o)}return this._initializedDefer.promise}async enableUnmixedAudio(){const e=new vpe(this._unmixedAudioTelemetryLogger,"enable");try{if(![bu.Uninitialized,bu.Initializing,bu.Initialized].includes(this._state))throw LQ(ype(this._state));if(this._tsCall.callType===1)throw EUe();if(this._pendingOperation)throw _Ue();if(this.isUnmixedAudioEnabled&&(this._skipProviderStateCheck||this._getUnmixedAudioProviderState()==="active")&&this._getAudioContextState()==="running")throw R5t();this._pendingOperation=!0,e.logAttempt(),this._state===bu.Uninitialized?await this.initialize():this._state===bu.Initializing&&await this._initializedDefer.promise,this._audioContext!==void 0&&this._getAudioContextState()!=="closed"||(this._cleaupAudioNodes(),this._audioContext=new IUe(this._logger,this._audioContextSeq++),this._audioContext.on("stateChanged",()=>{this._updateActiveState()}));const i=[["resume AudioContext",this._getAudioContextState()==="running"?void 0:this._audioContext.resume(this._operationTimeoutInMs)],["enable spatial audio config",this.isUnmixedAudioEnabled?void 0:this._enableSpatialAudio(!0)]];await this._runTasks(i),this._pendingOperation=!1,e.logSuccess(),this._logger.info(`UnmixedAudio is enabled. The AudioContext state is ${this._getAudioContextState()}.`),this._updateActiveState()}catch(i){const r=this._getAudioContextState(),o=this._getUnmixedAudioProviderState(),l=UB(i);this._logger.error(`Failed to enable unmixed audio: ${l}. isEnabled=${this.isUnmixedAudioEnabled}, AudioContext=${r}, UnmixedAudio=${o}`);const d={audioContextState:r,unmixedAudioState:o},h=D5t(i,d);this._pendingOperation===!1&&DQ(h),e.logFailure(h,d),this._pendingOperation=!1,DQ(h)}}async disableUnmixedAudio(){const e=new vpe(this._unmixedAudioTelemetryLogger,"disable");try{if(![bu.Initializing,bu.Initialized].includes(this._state))throw LQ(ype(this._state));if(this._tsCall.callType===1)throw EUe();if(this._pendingOperation)throw _Ue();if(!this.isUnmixedAudioEnabled)throw M5t();this._pendingOperation=!0,e.logAttempt(),this._state===bu.Initializing&&await this._initializedDefer.promise;const i=[["disable spatial audio config",this._enableSpatialAudio(!1)]];await this._runTasks(i),this._pendingOperation=!1,e.logSuccess(),this._logger.info("UnmixedAudio is disabled")}catch(i){const r=this._getAudioContextState(),o=this._getUnmixedAudioProviderState(),l=UB(i);this._logger.info(`Failed to disable unmixed audio: ${l}. isEnabled=${this.isUnmixedAudioEnabled}, AudioContext=${r}, UnmixedAudio=${o}`);const d={audioContextState:r,unmixedAudioState:o},h=L5t(i,d);this._pendingOperation===!1&&DQ(h),e.logFailure(h,d),this._pendingOperation=!1,DQ(h)}}get isUnmixedAudioActive(){return this._state===bu.Initialized&&this._getUnmixedAudioProviderState()==="active"&&this._getAudioContextState()==="running"}get isUnmixedAudioEnabled(){return this._state===bu.Initialized&&(this._tsUnmixedAudioProvider?.configured??!1)}getAudioSourceIdsFromParticipantIds(e){return e.map(i=>this._participantManager.findParticipantInfoByParticipantId(i.participantId)?.sourceId).filter(i=>i!==void 0)}on(e,i){this._eventEmitter.on(e,i)}off(e,i){this._eventEmitter.off(e,i)}dispose(){this._state!==bu.Destroyed&&(this._state=bu.Destroyed,this._initializedDefer.isPending()&&this._initializedDefer.reject(P5t()),this._listenerHandles.forEach(e=>e.dispose()),this._cleaupAudioNodes(),this._participantManager.dispose(),this._audioContext?.close(),this._eventEmitter.removeAllListeners())}_getAudioContextState(){return this._audioContext?.state??"unavailable"}_getUnmixedAudioProviderState(){return this._tsUnmixedAudioProvider?this._tsUnmixedAudioProvider.active?"active":"inactive":"unavailable"}_cleaupAudioNodes(){this._sourceStreamInfoList.forEach((e,i)=>{const r=this._destinationStreamInfoList[i];e!==void 0&&r!==void 0&&e.audioNode.disconnect(r.audioNode),this._sourceStreamInfoList[i]=void 0,this._destinationStreamInfoList[i]=void 0}),this._destinationStreamInfoMap.clear()}_onStreamSourcesUpdatedHandler(e){const i=this._audioContext?.value;if(i===void 0||i.state!=="running")return void this._logger.warn(`Dropping onStreamSourcesUpdated event because audioContext.state is ${i?.state}`);const r=[];for(let o=0;o<this._maxStreamSize;o++){const l=o<e.length?e[o]:0,d=l?this._participantManager.findParticipantInfoBySourceId(l):void 0;let h=this._destinationStreamInfoList[o],p=this._sourceStreamInfoList[o];if(d===void 0)h!==void 0&&p!==void 0&&(p.audioNode.disconnect(h.audioNode),this._destinationStreamInfoList[o]=void 0);else{const g=this._tsUnmixedAudioProvider?.streams[o]??void 0;if(p!==void 0&&p.mediaStream!==g&&(h!==void 0&&p.audioNode.disconnect(h.audioNode),p=void 0,this._sourceStreamInfoList[o]=void 0),!g)continue;let f=!1;p!==void 0&&h!==void 0&&d.participantId!==h.participantId&&(p.audioNode.disconnect(h.audioNode),h=void 0,this._destinationStreamInfoList[o]=void 0),h===void 0&&(h=this._destinationStreamInfoMap.get(d.participantId),h===void 0&&(h={participantId:d.participantId,identifier:Sl(d.mri),audioNode:i.createMediaStreamDestination()},this._destinationStreamInfoMap.set(d.participantId,h)),this._destinationStreamInfoList[o]=h,f=!0),p===void 0&&(p={mediaStream:g,audioNode:i.createMediaStreamSource(g)},this._sourceStreamInfoList[o]=p,f=!0),f&&p.audioNode.connect(h.audioNode),r.push({id:d.sourceId,stream:h.audioNode.stream,participantId:d.participantId,identifier:h.identifier})}}this._eventEmitter.emit("participantSpeaking",{speakers:r})}async _enableSpatialAudio(e){await this._tsCall.setAudioMidcallConfigJson({enableSpatialAudio:e})}async _runTasks(e){let i;if((await Promise.allSettled(e.map(r=>r[1]))).forEach((r,o)=>{r.status==="rejected"&&(this._logger.info(`Failed to ${e[o][0]}: ${UB(r.reason)}}`),i=r)}),i!==void 0)throw i.reason}_updateActiveState(){const e=this.isUnmixedAudioActive;e!==this._activeState&&(this._activeState=e,this._eventEmitter.emit("activeStateChanged"))}}class F5t extends Bu{constructor(e){super(e)}initialize(e,i){const r=wt().unmixedAudio;this._tsCall=e.tsCall,this._logger=i.createChild("UnmixedAudioCallFeature"),this._telemetryLogManager=e.telemetryLogManager;const o=new N5t(this._tsCall,this._telemetryLogManager);this._unmixedAudioManager=new B5t(this._tsCall,this._logger,o,r),this._unmixedAudioManager.initialize().then(()=>{this._sendFeatureUsage("initialize",Je.initialize)}).catch(l=>{})}get name(){return this._sendFeatureUsage("name",Je.getter),"UnmixedAudio"}dispose(){this.disposed||(this._unmixedAudioManager.dispose(),super.dispose())}enableUnmixedAudio(){return this._unmixedAudioManager.enableUnmixedAudio()}disableUnmixedAudio(){return this._unmixedAudioManager.disableUnmixedAudio()}get isUnmixedAudioActive(){return this._unmixedAudioManager.isUnmixedAudioActive}get isUnmixedAudioEnabled(){return this._unmixedAudioManager.isUnmixedAudioEnabled}getAudioStreamIdsFromParticipant(e){return this._unmixedAudioManager.getAudioSourceIdsFromParticipantIds(e.endpointDetails)}on(e,i){if(e!=="participantSpeaking"&&e!=="activeStateChanged")throw TUe(e,"subscribe");this._sendFeatureUsage(e,Je.subscribe),this._unmixedAudioManager.on(e,i)}off(e,i){if(e!=="participantSpeaking"&&e!=="activeStateChanged")throw TUe(e,"unsubscribe");this._sendFeatureUsage(e,Je.unsubscribe),this._unmixedAudioManager.off(e,i)}_sendFeatureUsage(e,i){Pc({callId:this._tsCall.callId,localParticipantId:this._tsCall.participantId,featureName:"UnmixedAudio",featureType:"Call",initializationType:"OnFeatureAccess",featureDetails:{name:e,step:i}},this._telemetryLogManager,this._logger)}}class U5t extends Bu{constructor(e){super(e),this._impl=new z5t}get name(){return"TeamsMeetingAudioConferencing"}initialize(e,i){this._impl.initialize(e.tsCall,e.callAgent,e.telemetryLogManager,i)}async getTeamsMeetingAudioConferencingDetails(){return this._impl.getTeamsMeetingAudioConferencingDetails()}dispose(){this.disposed||super.dispose()}}class z5t{constructor(){this._isEnabled=wt().calling.teamsMeetingAudioConferencing.enabled,this._supportedConversationTypes=wt().calling.teamsMeetingAudioConferencing.supportedConversationTypes}initialize(e,i,r,o){this._logger=o.createChild(()=>`teamsMeetingAudioConferencing::Call(id='${e.callId}')`),this._tsCall=e,this._telemetryLogManager=r,this._internalCallAgent=i;const l="initialize";if(this.sendFeatureUsage(l,Je.initialize),!this.isSupportedConversationType()){const d=new Oe({defaultError:we.FEATURES.TEAMS_MEETING_AUDIO_CONFERENCING.ONLY_AVAILABLE_IN_MEETINGS});throw this._logger.error(d.message),this.sendFeatureUsage(l,Je.failure,d),d}this.sendFeatureUsage(l,Je.success)}getTeamsMeetingAudioConferencingDetails(){const e="getTeamsMeetingAudioConferencingDetails";if(this.sendFeatureUsage(e,Je.attempt),!this._isEnabled){const o=new Oe({defaultError:we.FEATURES.TEAMS_MEETING_AUDIO_CONFERENCING.DISABLED});return this._logger.error(o.message),this.sendFeatureUsage(e,Je.failure,o),Promise.reject(o)}if(!this.isSupportedConversationType()){const o=new Oe({defaultError:we.FEATURES.TEAMS_MEETING_AUDIO_CONFERENCING.ONLY_AVAILABLE_IN_MEETINGS});return this._logger.error(o.message),this.sendFeatureUsage(e,Je.failure,o),Promise.reject(o)}let i;if(this._tsCall.state!==3)return i=new Oe({defaultError:we.FEATURES.TEAMS_MEETING_AUDIO_CONFERENCING.UNAVAILABLE_BEFORE_JOINING}),this._tsCall.state===10&&(i=new Oe({defaultError:we.FEATURES.TEAMS_MEETING_AUDIO_CONFERENCING.UNVAILABLE_IN_LOBBY})),this.sendFeatureUsage(e,Je.failure,i),this._logger.error(i.message),Promise.reject(i);let r={phoneConferenceId:"",phoneNumbers:[]};try{const o=this._tsCall?.meetingDetails?.pstnDetails?.acpMcuInfo?.settings,l=this._tsCall?.meetingDetails?.pstnDetails?.meetingInvitePhoneNumbers;if(o||l){const d=o?.participantPasscode||"",h=l?.flatMap(p=>{const g=()=>{const f=p.isTollFree?void 0:Sl(_3+p.number),y=p.isTollFree?Sl(_3+p.number):void 0;return{cityName:p?.cityName,countryName:p?.countryName,tollPhoneNumber:f,tollFreePhoneNumber:y}};return p.number?g():[]})||[];if(h===null||h.length===0){const p={cityName:void 0,countryName:void 0,tollPhoneNumber:o?.tollNumber&&Sl(_3+o?.tollNumber),tollFreePhoneNumber:o?.tollFreeNumber&&Sl(_3+o?.tollFreeNumber)};h.push(p)}r={phoneConferenceId:d,phoneNumbers:h},this._logger.info("Teams meeting audio conferencing details was retrieved successfully")}return this.sendFeatureUsage(e,Je.success),Promise.resolve(r)}catch(o){const l=new Oe({defaultError:we.FEATURES.TEAMS_MEETING_AUDIO_CONFERENCING.GET_DETAILS_FAILED,originalError:o});throw this.sendFeatureUsage(e,Je.failure,l),l}}isSupportedConversationType(){const e=this._tsCall.conversationType;let i=this._supportedConversationTypes.find(r=>r===e);return this._logger.info(`TeamsMeetingAudioConferencingDetails::ConversationType = 
            ${e}. ConversationType is supported = ${i}`),i}sendFeatureUsage(e,i,r){let o=r?{code:r?.code||jL,subCode:r?.subCode||0,failureReason:r?.message||"",...an(r)}:void 0;Pc({callId:this._tsCall.callId,localParticipantId:this._tsCall.participantId,featureName:"TeamsMeetingAudioConferencing",featureType:"Call",initializationType:"OnFeatureAccess",featureDetails:{name:e,step:i},additionalDetails:o},this._telemetryLogManager,this._logger)}}var ws=bs(function(t,e){Object.defineProperty(e,"__esModule",{value:!0}),e.TraceLevel=void 0,function(i){i[i.Error=10]="Error",i[i.Warning=15]="Warning",i[i.Info=50]="Info"}(e.TraceLevel||(e.TraceLevel={}))}),ed=bs(function(t,e){Object.defineProperty(e,"__esModule",{value:!0}),e.MessageTrackingOption=e.ConnectionState=e.ServiceGeneratedClientIdName=e.SystemCommandsStateName=e.ConfigurationName=e.SystemSessionStateName=e.StateSubscriptionsName=void 0,e.StateSubscriptionsName="ConfigStateSubscriptions",e.SystemSessionStateName="systemSessionState",e.ConfigurationName="config",e.SystemCommandsStateName="systemCommands",e.ServiceGeneratedClientIdName="serviceGeneratedClientId",function(i){i[i.Disconnected=0]="Disconnected",i[i.Connected=1]="Connected",i[i.Connecting=2]="Connecting"}(e.ConnectionState||(e.ConnectionState={})),function(i){i[i.All=0]="All",i[i.Last=1]="Last",i[i.None=2]="None"}(e.MessageTrackingOption||(e.MessageTrackingOption={}))});function wUe(t,e){return function(){return t.apply(e,arguments)}}const{toString:V5t}=Object.prototype,{getPrototypeOf:Spe}=Object,OQ=(bpe=Object.create(null),t=>{const e=V5t.call(t);return bpe[e]||(bpe[e]=e.slice(8,-1).toLowerCase())});var bpe;const zA=t=>(t=t.toLowerCase(),e=>OQ(e)===t),NQ=t=>e=>typeof e===t,{isArray:G3}=Array,H6=NQ("undefined");function $5t(t){return t!==null&&!H6(t)&&t.constructor!==null&&!H6(t.constructor)&&qC(t.constructor.isBuffer)&&t.constructor.isBuffer(t)}const kUe=zA("ArrayBuffer");function H5t(t){let e;return e=typeof ArrayBuffer<"u"&&ArrayBuffer.isView?ArrayBuffer.isView(t):t&&t.buffer&&kUe(t.buffer),e}const j5t=NQ("string"),qC=NQ("function"),RUe=NQ("number"),xQ=t=>t!==null&&typeof t=="object",G5t=t=>t===!0||t===!1,BQ=t=>{if(OQ(t)!=="object")return!1;const e=Spe(t);return!(e!==null&&e!==Object.prototype&&Object.getPrototypeOf(e)!==null||Symbol.toStringTag in t||Symbol.iterator in t)},q5t=zA("Date"),W5t=zA("File"),K5t=zA("Blob"),J5t=zA("FileList"),Y5t=t=>xQ(t)&&qC(t.pipe),Q5t=t=>{let e;return t&&(typeof FormData=="function"&&t instanceof FormData||qC(t.append)&&((e=OQ(t))==="formdata"||e==="object"&&qC(t.toString)&&t.toString()==="[object FormData]"))},Z5t=zA("URLSearchParams"),[X5t,e3t,t3t,i3t]=["ReadableStream","Request","Response","Headers"].map(zA),n3t=t=>t.trim?t.trim():t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,"");function j6(t,e,{allOwnKeys:i=!1}={}){if(t==null)return;let r,o;if(typeof t!="object"&&(t=[t]),G3(t))for(r=0,o=t.length;r<o;r++)e.call(null,t[r],r,t);else{const l=i?Object.getOwnPropertyNames(t):Object.keys(t),d=l.length;let h;for(r=0;r<d;r++)h=l[r],e.call(null,t[h],h,t)}}function MUe(t,e){e=e.toLowerCase();const i=Object.keys(t);let r,o=i.length;for(;o-- >0;)if(r=i[o],e===r.toLowerCase())return r;return null}const zB=typeof globalThis<"u"?globalThis:typeof self<"u"?self:typeof window<"u"?window:global,PUe=t=>!H6(t)&&t!==zB;function Tpe(){const{caseless:t}=PUe(this)&&this||{},e={},i=(r,o)=>{const l=t&&MUe(e,o)||o;BQ(e[l])&&BQ(r)?e[l]=Tpe(e[l],r):BQ(r)?e[l]=Tpe({},r):G3(r)?e[l]=r.slice():e[l]=r};for(let r=0,o=arguments.length;r<o;r++)arguments[r]&&j6(arguments[r],i);return e}const a3t=(t,e,i,{allOwnKeys:r}={})=>(j6(e,(o,l)=>{i&&qC(o)?t[l]=wUe(o,i):t[l]=o},{allOwnKeys:r}),t),r3t=t=>(t.charCodeAt(0)===65279&&(t=t.slice(1)),t),o3t=(t,e,i,r)=>{t.prototype=Object.create(e.prototype,r),t.prototype.constructor=t,Object.defineProperty(t,"super",{value:e.prototype}),i&&Object.assign(t.prototype,i)},s3t=(t,e,i,r)=>{let o,l,d;const h={};if(e=e||{},t==null)return e;do{for(o=Object.getOwnPropertyNames(t),l=o.length;l-- >0;)d=o[l],r&&!r(d,t,e)||h[d]||(e[d]=t[d],h[d]=!0);t=i!==!1&&Spe(t)}while(t&&(!i||i(t,e))&&t!==Object.prototype);return e},l3t=(t,e,i)=>{t=String(t),(i===void 0||i>t.length)&&(i=t.length),i-=e.length;const r=t.indexOf(e,i);return r!==-1&&r===i},c3t=t=>{if(!t)return null;if(G3(t))return t;let e=t.length;if(!RUe(e))return null;const i=new Array(e);for(;e-- >0;)i[e]=t[e];return i},d3t=(Cpe=typeof Uint8Array<"u"&&Spe(Uint8Array),t=>Cpe&&t instanceof Cpe);var Cpe;const u3t=(t,e)=>{const i=(t&&t[Symbol.iterator]).call(t);let r;for(;(r=i.next())&&!r.done;){const o=r.value;e.call(t,o[0],o[1])}},h3t=(t,e)=>{let i;const r=[];for(;(i=t.exec(e))!==null;)r.push(i);return r},p3t=zA("HTMLFormElement"),g3t=t=>t.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g,function(i,r,o){return r.toUpperCase()+o}),DUe=(({hasOwnProperty:t})=>(e,i)=>t.call(e,i))(Object.prototype),m3t=zA("RegExp"),LUe=(t,e)=>{const i=Object.getOwnPropertyDescriptors(t),r={};j6(i,(o,l)=>{let d;(d=e(o,l,t))!==!1&&(r[l]=d||o)}),Object.defineProperties(t,r)},f3t=t=>{LUe(t,(e,i)=>{if(qC(t)&&["arguments","caller","callee"].indexOf(i)!==-1)return!1;const r=t[i];qC(r)&&(e.enumerable=!1,"writable"in e?e.writable=!1:e.set||(e.set=()=>{throw Error("Can not rewrite read-only method '"+i+"'")}))})},v3t=(t,e)=>{const i={},r=o=>{o.forEach(l=>{i[l]=!0})};return G3(t)?r(t):r(String(t).split(e)),i},y3t=()=>{},S3t=(t,e)=>t!=null&&Number.isFinite(t=+t)?t:e;function b3t(t){return!!(t&&qC(t.append)&&t[Symbol.toStringTag]==="FormData"&&t[Symbol.iterator])}const T3t=t=>{const e=new Array(10),i=(r,o)=>{if(xQ(r)){if(e.indexOf(r)>=0)return;if(!("toJSON"in r)){e[o]=r;const l=G3(r)?[]:{};return j6(r,(d,h)=>{const p=i(d,o+1);!H6(p)&&(l[h]=p)}),e[o]=void 0,l}}return r};return i(t,0)},C3t=zA("AsyncFunction"),_3t=t=>t&&(xQ(t)||qC(t))&&qC(t.then)&&qC(t.catch),OUe=(NUe=typeof setImmediate=="function",xUe=qC(zB.postMessage),NUe?setImmediate:xUe?(_pe=`axios@${Math.random()}`,FQ=[],zB.addEventListener("message",({source:t,data:e})=>{t===zB&&e===_pe&&FQ.length&&FQ.shift()()},!1),t=>{FQ.push(t),zB.postMessage(_pe,"*")}):t=>setTimeout(t));var NUe,xUe,_pe,FQ;const E3t=typeof queueMicrotask<"u"?queueMicrotask.bind(zB):typeof process<"u"&&process.nextTick||OUe;var vn={isArray:G3,isArrayBuffer:kUe,isBuffer:$5t,isFormData:Q5t,isArrayBufferView:H5t,isString:j5t,isNumber:RUe,isBoolean:G5t,isObject:xQ,isPlainObject:BQ,isReadableStream:X5t,isRequest:e3t,isResponse:t3t,isHeaders:i3t,isUndefined:H6,isDate:q5t,isFile:W5t,isBlob:K5t,isRegExp:m3t,isFunction:qC,isStream:Y5t,isURLSearchParams:Z5t,isTypedArray:d3t,isFileList:J5t,forEach:j6,merge:Tpe,extend:a3t,trim:n3t,stripBOM:r3t,inherits:o3t,toFlatObject:s3t,kindOf:OQ,kindOfTest:zA,endsWith:l3t,toArray:c3t,forEachEntry:u3t,matchAll:h3t,isHTMLForm:p3t,hasOwnProperty:DUe,hasOwnProp:DUe,reduceDescriptors:LUe,freezeMethods:f3t,toObjectSet:v3t,toCamelCase:g3t,noop:y3t,toFiniteNumber:S3t,findKey:MUe,global:zB,isContextDefined:PUe,isSpecCompliantForm:b3t,toJSONObject:T3t,isAsyncFn:C3t,isThenable:_3t,setImmediate:OUe,asap:E3t};function nl(t,e,i,r,o){Error.call(this),Error.captureStackTrace?Error.captureStackTrace(this,this.constructor):this.stack=new Error().stack,this.message=t,this.name="AxiosError",e&&(this.code=e),i&&(this.config=i),r&&(this.request=r),o&&(this.response=o,this.status=o.status?o.status:null)}vn.inherits(nl,Error,{toJSON:function(){return{message:this.message,name:this.name,description:this.description,number:this.number,fileName:this.fileName,lineNumber:this.lineNumber,columnNumber:this.columnNumber,stack:this.stack,config:vn.toJSONObject(this.config),code:this.code,status:this.status}}});const BUe=nl.prototype,FUe={};["ERR_BAD_OPTION_VALUE","ERR_BAD_OPTION","ECONNABORTED","ETIMEDOUT","ERR_NETWORK","ERR_FR_TOO_MANY_REDIRECTS","ERR_DEPRECATED","ERR_BAD_RESPONSE","ERR_BAD_REQUEST","ERR_CANCELED","ERR_NOT_SUPPORT","ERR_INVALID_URL"].forEach(t=>{FUe[t]={value:t}}),Object.defineProperties(nl,FUe),Object.defineProperty(BUe,"isAxiosError",{value:!0}),nl.from=(t,e,i,r,o,l)=>{const d=Object.create(BUe);return vn.toFlatObject(t,d,function(p){return p!==Error.prototype},h=>h!=="isAxiosError"),nl.call(d,t.message,e,i,r,o),d.cause=t,d.name=t.name,l&&Object.assign(d,l),d};var A3t=null;function Epe(t){return vn.isPlainObject(t)||vn.isArray(t)}function UUe(t){return vn.endsWith(t,"[]")?t.slice(0,-2):t}function zUe(t,e,i){return t?t.concat(e).map(function(o,l){return o=UUe(o),!i&&l?"["+o+"]":o}).join(i?".":""):e}function I3t(t){return vn.isArray(t)&&!t.some(Epe)}const w3t=vn.toFlatObject(vn,{},null,function(e){return/^is[A-Z]/.test(e)});function UQ(t,e,i){if(!vn.isObject(t))throw new TypeError("target must be an object");e=e||new FormData;const r=(i=vn.toFlatObject(i,{metaTokens:!0,dots:!1,indexes:!1},!1,function(E,I){return!vn.isUndefined(I[E])})).metaTokens,o=i.visitor||g,l=i.dots,d=i.indexes,h=(i.Blob||typeof Blob<"u"&&Blob)&&vn.isSpecCompliantForm(e);if(!vn.isFunction(o))throw new TypeError("visitor must be a function");function p(C){if(C===null)return"";if(vn.isDate(C))return C.toISOString();if(!h&&vn.isBlob(C))throw new nl("Blob is not supported. Use a Buffer instead.");return vn.isArrayBuffer(C)||vn.isTypedArray(C)?h&&typeof Blob=="function"?new Blob([C]):Buffer.from(C):C}function g(C,E,I){let w=C;if(C&&!I&&typeof C=="object"){if(vn.endsWith(E,"{}"))E=r?E:E.slice(0,-2),C=JSON.stringify(C);else if(vn.isArray(C)&&I3t(C)||(vn.isFileList(C)||vn.endsWith(E,"[]"))&&(w=vn.toArray(C)))return E=UUe(E),w.forEach(function(F,x){!vn.isUndefined(F)&&F!==null&&e.append(d===!0?zUe([E],x,l):d===null?E:E+"[]",p(F))}),!1}return!!Epe(C)||(e.append(zUe(I,E,l),p(C)),!1)}const f=[],y=Object.assign(w3t,{defaultVisitor:g,convertValue:p,isVisitable:Epe});function T(C,E){if(!vn.isUndefined(C)){if(f.indexOf(C)!==-1)throw Error("Circular reference detected in "+E.join("."));f.push(C),vn.forEach(C,function(w,D){(!(vn.isUndefined(w)||w===null)&&o.call(e,w,vn.isString(D)?D.trim():D,E,y))===!0&&T(w,E?E.concat(D):[D])}),f.pop()}}if(!vn.isObject(t))throw new TypeError("data must be an object");return T(t),e}function VUe(t){const e={"!":"%21","'":"%27","(":"%28",")":"%29","~":"%7E","%20":"+","%00":"\0"};return encodeURIComponent(t).replace(/[!'()~]|%20|%00/g,function(r){return e[r]})}function Ape(t,e){this._pairs=[],t&&UQ(t,this,e)}const $Ue=Ape.prototype;function k3t(t){return encodeURIComponent(t).replace(/%3A/gi,":").replace(/%24/g,"$").replace(/%2C/gi,",").replace(/%20/g,"+").replace(/%5B/gi,"[").replace(/%5D/gi,"]")}function HUe(t,e,i){if(!e)return t;const r=i&&i.encode||k3t;vn.isFunction(i)&&(i={serialize:i});const o=i&&i.serialize;let l;if(l=o?o(e,i):vn.isURLSearchParams(e)?e.toString():new Ape(e,i).toString(r),l){const d=t.indexOf("#");d!==-1&&(t=t.slice(0,d)),t+=(t.indexOf("?")===-1?"?":"&")+l}return t}$Ue.append=function(e,i){this._pairs.push([e,i])},$Ue.toString=function(e){const i=e?function(r){return e.call(this,r,VUe)}:VUe;return this._pairs.map(function(o){return i(o[0])+"="+i(o[1])},"").join("&")};class jUe{constructor(){this.handlers=[]}use(e,i,r){return this.handlers.push({fulfilled:e,rejected:i,synchronous:!!r&&r.synchronous,runWhen:r?r.runWhen:null}),this.handlers.length-1}eject(e){this.handlers[e]&&(this.handlers[e]=null)}clear(){this.handlers&&(this.handlers=[])}forEach(e){vn.forEach(this.handlers,function(r){r!==null&&e(r)})}}var GUe={silentJSONParsing:!0,forcedJSONParsing:!0,clarifyTimeoutError:!1},R3t={isBrowser:!0,classes:{URLSearchParams:typeof URLSearchParams<"u"?URLSearchParams:Ape,FormData:typeof FormData<"u"?FormData:null,Blob:typeof Blob<"u"?Blob:null},protocols:["http","https","file","blob","url","data"]};const Ipe=typeof window<"u"&&typeof document<"u",wpe=typeof navigator=="object"&&navigator||void 0,M3t=Ipe&&(!wpe||["ReactNative","NativeScript","NS"].indexOf(wpe.product)<0),P3t=typeof WorkerGlobalScope<"u"&&self instanceof WorkerGlobalScope&&typeof self.importScripts=="function",D3t=Ipe&&window.location.href||"http://localhost";var Wy={...Object.freeze({__proto__:null,hasBrowserEnv:Ipe,hasStandardBrowserWebWorkerEnv:P3t,hasStandardBrowserEnv:M3t,navigator:wpe,origin:D3t}),...R3t};function L3t(t,e){return UQ(t,new Wy.classes.URLSearchParams,Object.assign({visitor:function(i,r,o,l){return Wy.isNode&&vn.isBuffer(i)?(this.append(r,i.toString("base64")),!1):l.defaultVisitor.apply(this,arguments)}},e))}function O3t(t){return vn.matchAll(/\w+|\[(\w*)]/g,t).map(e=>e[0]==="[]"?"":e[1]||e[0])}function N3t(t){const e={},i=Object.keys(t);let r;const o=i.length;let l;for(r=0;r<o;r++)l=i[r],e[l]=t[l];return e}function qUe(t){function e(i,r,o,l){let d=i[l++];if(d==="__proto__")return!0;const h=Number.isFinite(+d),p=l>=i.length;return d=!d&&vn.isArray(o)?o.length:d,p?(vn.hasOwnProp(o,d)?o[d]=[o[d],r]:o[d]=r,!h):(o[d]&&vn.isObject(o[d])||(o[d]=[]),e(i,r,o[d],l)&&vn.isArray(o[d])&&(o[d]=N3t(o[d])),!h)}if(vn.isFormData(t)&&vn.isFunction(t.entries)){const i={};return vn.forEachEntry(t,(r,o)=>{e(O3t(r),o,i,0)}),i}return null}function x3t(t,e,i){if(vn.isString(t))try{return(e||JSON.parse)(t),vn.trim(t)}catch(r){if(r.name!=="SyntaxError")throw r}return(i||JSON.stringify)(t)}const G6={transitional:GUe,adapter:["xhr","http","fetch"],transformRequest:[function(e,i){const r=i.getContentType()||"",o=r.indexOf("application/json")>-1,l=vn.isObject(e);if(l&&vn.isHTMLForm(e)&&(e=new FormData(e)),vn.isFormData(e))return o?JSON.stringify(qUe(e)):e;if(vn.isArrayBuffer(e)||vn.isBuffer(e)||vn.isStream(e)||vn.isFile(e)||vn.isBlob(e)||vn.isReadableStream(e))return e;if(vn.isArrayBufferView(e))return e.buffer;if(vn.isURLSearchParams(e))return i.setContentType("application/x-www-form-urlencoded;charset=utf-8",!1),e.toString();let d;if(l){if(r.indexOf("application/x-www-form-urlencoded")>-1)return L3t(e,this.formSerializer).toString();if((d=vn.isFileList(e))||r.indexOf("multipart/form-data")>-1){const h=this.env&&this.env.FormData;return UQ(d?{"files[]":e}:e,h&&new h,this.formSerializer)}}return l||o?(i.setContentType("application/json",!1),x3t(e)):e}],transformResponse:[function(e){const i=this.transitional||G6.transitional,r=i&&i.forcedJSONParsing,o=this.responseType==="json";if(vn.isResponse(e)||vn.isReadableStream(e))return e;if(e&&vn.isString(e)&&(r&&!this.responseType||o)){const l=!(i&&i.silentJSONParsing)&&o;try{return JSON.parse(e)}catch(d){if(l)throw d.name==="SyntaxError"?nl.from(d,nl.ERR_BAD_RESPONSE,this,null,this.response):d}}return e}],timeout:0,xsrfCookieName:"XSRF-TOKEN",xsrfHeaderName:"X-XSRF-TOKEN",maxContentLength:-1,maxBodyLength:-1,env:{FormData:Wy.classes.FormData,Blob:Wy.classes.Blob},validateStatus:function(e){return e>=200&&e<300},headers:{common:{Accept:"application/json, text/plain, */*","Content-Type":void 0}}};vn.forEach(["delete","get","head","post","put","patch"],t=>{G6.headers[t]={}});const B3t=vn.toObjectSet(["age","authorization","content-length","content-type","etag","expires","from","host","if-modified-since","if-unmodified-since","last-modified","location","max-forwards","proxy-authorization","referer","retry-after","user-agent"]);var F3t=t=>{const e={};let i,r,o;return t&&t.split(`
`).forEach(function(d){o=d.indexOf(":"),i=d.substring(0,o).trim().toLowerCase(),r=d.substring(o+1).trim(),!i||e[i]&&B3t[i]||(i==="set-cookie"?e[i]?e[i].push(r):e[i]=[r]:e[i]=e[i]?e[i]+", "+r:r)}),e};const WUe=Symbol("internals");function q6(t){return t&&String(t).trim().toLowerCase()}function zQ(t){return t===!1||t==null?t:vn.isArray(t)?t.map(zQ):String(t)}function U3t(t){const e=Object.create(null),i=/([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;let r;for(;r=i.exec(t);)e[r[1]]=r[2];return e}const z3t=t=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(t.trim());function kpe(t,e,i,r,o){return vn.isFunction(r)?r.call(this,e,i):(o&&(e=i),vn.isString(e)?vn.isString(r)?e.indexOf(r)!==-1:vn.isRegExp(r)?r.test(e):void 0:void 0)}function V3t(t){return t.trim().toLowerCase().replace(/([a-z\d])(\w*)/g,(e,i,r)=>i.toUpperCase()+r)}function $3t(t,e){const i=vn.toCamelCase(" "+e);["get","set","has"].forEach(r=>{Object.defineProperty(t,r+i,{value:function(o,l,d){return this[r].call(this,e,o,l,d)},configurable:!0})})}class yT{constructor(e){e&&this.set(e)}set(e,i,r){const o=this;function l(h,p,g){const f=q6(p);if(!f)throw new Error("header name must be a non-empty string");const y=vn.findKey(o,f);(!y||o[y]===void 0||g===!0||g===void 0&&o[y]!==!1)&&(o[y||p]=zQ(h))}const d=(h,p)=>vn.forEach(h,(g,f)=>l(g,f,p));if(vn.isPlainObject(e)||e instanceof this.constructor)d(e,i);else if(vn.isString(e)&&(e=e.trim())&&!z3t(e))d(F3t(e),i);else if(vn.isHeaders(e))for(const[h,p]of e.entries())l(p,h,r);else e!=null&&l(i,e,r);return this}get(e,i){if(e=q6(e)){const r=vn.findKey(this,e);if(r){const o=this[r];if(!i)return o;if(i===!0)return U3t(o);if(vn.isFunction(i))return i.call(this,o,r);if(vn.isRegExp(i))return i.exec(o);throw new TypeError("parser must be boolean|regexp|function")}}}has(e,i){if(e=q6(e)){const r=vn.findKey(this,e);return!(!r||this[r]===void 0||i&&!kpe(this,this[r],r,i))}return!1}delete(e,i){const r=this;let o=!1;function l(d){if(d=q6(d)){const h=vn.findKey(r,d);!h||i&&!kpe(r,r[h],h,i)||(delete r[h],o=!0)}}return vn.isArray(e)?e.forEach(l):l(e),o}clear(e){const i=Object.keys(this);let r=i.length,o=!1;for(;r--;){const l=i[r];e&&!kpe(this,this[l],l,e,!0)||(delete this[l],o=!0)}return o}normalize(e){const i=this,r={};return vn.forEach(this,(o,l)=>{const d=vn.findKey(r,l);if(d)return i[d]=zQ(o),void delete i[l];const h=e?V3t(l):String(l).trim();h!==l&&delete i[l],i[h]=zQ(o),r[h]=!0}),this}concat(...e){return this.constructor.concat(this,...e)}toJSON(e){const i=Object.create(null);return vn.forEach(this,(r,o)=>{r!=null&&r!==!1&&(i[o]=e&&vn.isArray(r)?r.join(", "):r)}),i}[Symbol.iterator](){return Object.entries(this.toJSON())[Symbol.iterator]()}toString(){return Object.entries(this.toJSON()).map(([e,i])=>e+": "+i).join(`
`)}get[Symbol.toStringTag](){return"AxiosHeaders"}static from(e){return e instanceof this?e:new this(e)}static concat(e,...i){const r=new this(e);return i.forEach(o=>r.set(o)),r}static accessor(e){const i=(this[WUe]=this[WUe]={accessors:{}}).accessors,r=this.prototype;function o(l){const d=q6(l);i[d]||($3t(r,l),i[d]=!0)}return vn.isArray(e)?e.forEach(o):o(e),this}}function Rpe(t,e){const i=this||G6,r=e||i,o=yT.from(r.headers);let l=r.data;return vn.forEach(t,function(h){l=h.call(i,l,o.normalize(),e?e.status:void 0)}),o.normalize(),l}function KUe(t){return!(!t||!t.__CANCEL__)}function q3(t,e,i){nl.call(this,t??"canceled",nl.ERR_CANCELED,e,i),this.name="CanceledError"}function JUe(t,e,i){const r=i.config.validateStatus;i.status&&r&&!r(i.status)?e(new nl("Request failed with status code "+i.status,[nl.ERR_BAD_REQUEST,nl.ERR_BAD_RESPONSE][Math.floor(i.status/100)-4],i.config,i.request,i)):t(i)}function H3t(t){const e=/^([-+\w]{1,25})(:?\/\/|:)/.exec(t);return e&&e[1]||""}function j3t(t,e){t=t||10;const i=new Array(t),r=new Array(t);let o,l=0,d=0;return e=e!==void 0?e:1e3,function(p){const g=Date.now(),f=r[d];o||(o=g),i[l]=p,r[l]=g;let y=d,T=0;for(;y!==l;)T+=i[y++],y%=t;if(l=(l+1)%t,l===d&&(d=(d+1)%t),g-o<e)return;const C=f&&g-f;return C?Math.round(1e3*T/C):void 0}}function G3t(t,e){let i,r,o=0,l=1e3/e;const d=(h,p=Date.now())=>{o=p,i=null,r&&(clearTimeout(r),r=null),t.apply(null,h)};return[(...h)=>{const p=Date.now(),g=p-o;g>=l?d(h,p):(i=h,r||(r=setTimeout(()=>{r=null,d(i)},l-g)))},()=>i&&d(i)]}yT.accessor(["Content-Type","Content-Length","Accept","Accept-Encoding","User-Agent","Authorization"]),vn.reduceDescriptors(yT.prototype,({value:t},e)=>{let i=e[0].toUpperCase()+e.slice(1);return{get:()=>t,set(r){this[i]=r}}}),vn.freezeMethods(yT),vn.inherits(q3,nl,{__CANCEL__:!0});const VQ=(t,e,i=3)=>{let r=0;const o=j3t(50,250);return G3t(l=>{const d=l.loaded,h=l.lengthComputable?l.total:void 0,p=d-r,g=o(p);r=d,t({loaded:d,total:h,progress:h?d/h:void 0,bytes:p,rate:g||void 0,estimated:g&&h&&d<=h?(h-d)/g:void 0,event:l,lengthComputable:h!=null,[e?"download":"upload"]:!0})},i)},YUe=(t,e)=>{const i=t!=null;return[r=>e[0]({lengthComputable:i,total:t,loaded:r}),e[1]]},QUe=t=>(...e)=>vn.asap(()=>t(...e));var q3t=Wy.hasStandardBrowserEnv?((t,e)=>i=>(i=new URL(i,Wy.origin),t.protocol===i.protocol&&t.host===i.host&&(e||t.port===i.port)))(new URL(Wy.origin),Wy.navigator&&/(msie|trident)/i.test(Wy.navigator.userAgent)):()=>!0,W3t=Wy.hasStandardBrowserEnv?{write(t,e,i,r,o,l){const d=[t+"="+encodeURIComponent(e)];vn.isNumber(i)&&d.push("expires="+new Date(i).toGMTString()),vn.isString(r)&&d.push("path="+r),vn.isString(o)&&d.push("domain="+o),l===!0&&d.push("secure"),document.cookie=d.join("; ")},read(t){const e=document.cookie.match(new RegExp("(^|;\\s*)("+t+")=([^;]*)"));return e?decodeURIComponent(e[3]):null},remove(t){this.write(t,"",Date.now()-864e5)}}:{write(){},read:()=>null,remove(){}};function K3t(t){return/^([a-z][a-z\d+\-.]*:)?\/\//i.test(t)}function J3t(t,e){return e?t.replace(/\/?\/$/,"")+"/"+e.replace(/^\/+/,""):t}function ZUe(t,e,i){let r=!K3t(e);return t&&(r||i==0)?J3t(t,e):e}const XUe=t=>t instanceof yT?{...t}:t;function VB(t,e){e=e||{};const i={};function r(g,f,y,T){return vn.isPlainObject(g)&&vn.isPlainObject(f)?vn.merge.call({caseless:T},g,f):vn.isPlainObject(f)?vn.merge({},f):vn.isArray(f)?f.slice():f}function o(g,f,y,T){return vn.isUndefined(f)?vn.isUndefined(g)?void 0:r(void 0,g,y,T):r(g,f,y,T)}function l(g,f){if(!vn.isUndefined(f))return r(void 0,f)}function d(g,f){return vn.isUndefined(f)?vn.isUndefined(g)?void 0:r(void 0,g):r(void 0,f)}function h(g,f,y){return y in e?r(g,f):y in t?r(void 0,g):void 0}const p={url:l,method:l,data:l,baseURL:d,transformRequest:d,transformResponse:d,paramsSerializer:d,timeout:d,timeoutMessage:d,withCredentials:d,withXSRFToken:d,adapter:d,responseType:d,xsrfCookieName:d,xsrfHeaderName:d,onUploadProgress:d,onDownloadProgress:d,decompress:d,maxContentLength:d,maxBodyLength:d,beforeRedirect:d,transport:d,httpAgent:d,httpsAgent:d,cancelToken:d,socketPath:d,responseEncoding:d,validateStatus:h,headers:(g,f,y)=>o(XUe(g),XUe(f),y,!0)};return vn.forEach(Object.keys(Object.assign({},t,e)),function(f){const y=p[f]||o,T=y(t[f],e[f],f);vn.isUndefined(T)&&y!==h||(i[f]=T)}),i}var e5e=t=>{const e=VB({},t);let i,{data:r,withXSRFToken:o,xsrfHeaderName:l,xsrfCookieName:d,headers:h,auth:p}=e;if(e.headers=h=yT.from(h),e.url=HUe(ZUe(e.baseURL,e.url,e.allowAbsoluteUrls),t.params,t.paramsSerializer),p&&h.set("Authorization","Basic "+btoa((p.username||"")+":"+(p.password?unescape(encodeURIComponent(p.password)):""))),vn.isFormData(r)){if(Wy.hasStandardBrowserEnv||Wy.hasStandardBrowserWebWorkerEnv)h.setContentType(void 0);else if((i=h.getContentType())!==!1){const[g,...f]=i?i.split(";").map(y=>y.trim()).filter(Boolean):[];h.setContentType([g||"multipart/form-data",...f].join("; "))}}if(Wy.hasStandardBrowserEnv&&(o&&vn.isFunction(o)&&(o=o(e)),o||o!==!1&&q3t(e.url))){const g=l&&d&&W3t.read(d);g&&h.set(l,g)}return e},Y3t=typeof XMLHttpRequest<"u"&&function(t){return new Promise(function(i,r){const o=e5e(t);let l=o.data;const d=yT.from(o.headers).normalize();let h,p,g,f,y,{responseType:T,onUploadProgress:C,onDownloadProgress:E}=o;function I(){f&&f(),y&&y(),o.cancelToken&&o.cancelToken.unsubscribe(h),o.signal&&o.signal.removeEventListener("abort",h)}let w=new XMLHttpRequest;function D(){if(!w)return;const x=yT.from("getAllResponseHeaders"in w&&w.getAllResponseHeaders());JUe(function(L){i(L),I()},function(L){r(L),I()},{data:T&&T!=="text"&&T!=="json"?w.response:w.responseText,status:w.status,statusText:w.statusText,headers:x,config:t,request:w}),w=null}w.open(o.method.toUpperCase(),o.url,!0),w.timeout=o.timeout,"onloadend"in w?w.onloadend=D:w.onreadystatechange=function(){w&&w.readyState===4&&(w.status!==0||w.responseURL&&w.responseURL.indexOf("file:")===0)&&setTimeout(D)},w.onabort=function(){w&&(r(new nl("Request aborted",nl.ECONNABORTED,t,w)),w=null)},w.onerror=function(){r(new nl("Network Error",nl.ERR_NETWORK,t,w)),w=null},w.ontimeout=function(){let B=o.timeout?"timeout of "+o.timeout+"ms exceeded":"timeout exceeded";const L=o.transitional||GUe;o.timeoutErrorMessage&&(B=o.timeoutErrorMessage),r(new nl(B,L.clarifyTimeoutError?nl.ETIMEDOUT:nl.ECONNABORTED,t,w)),w=null},l===void 0&&d.setContentType(null),"setRequestHeader"in w&&vn.forEach(d.toJSON(),function(B,L){w.setRequestHeader(L,B)}),vn.isUndefined(o.withCredentials)||(w.withCredentials=!!o.withCredentials),T&&T!=="json"&&(w.responseType=o.responseType),E&&([g,y]=VQ(E,!0),w.addEventListener("progress",g)),C&&w.upload&&([p,f]=VQ(C),w.upload.addEventListener("progress",p),w.upload.addEventListener("loadend",f)),(o.cancelToken||o.signal)&&(h=x=>{w&&(r(!x||x.type?new q3(null,t,w):x),w.abort(),w=null)},o.cancelToken&&o.cancelToken.subscribe(h),o.signal&&(o.signal.aborted?h():o.signal.addEventListener("abort",h)));const F=H3t(o.url);F&&Wy.protocols.indexOf(F)===-1?r(new nl("Unsupported protocol "+F+":",nl.ERR_BAD_REQUEST,t)):w.send(l||null)})};const Q3t=(t,e)=>{const{length:i}=t=t?t.filter(Boolean):[];if(e||i){let r,o=new AbortController;const l=function(g){if(!r){r=!0,h();const f=g instanceof Error?g:this.reason;o.abort(f instanceof nl?f:new q3(f instanceof Error?f.message:f))}};let d=e&&setTimeout(()=>{d=null,l(new nl(`timeout ${e} of ms exceeded`,nl.ETIMEDOUT))},e);const h=()=>{t&&(d&&clearTimeout(d),d=null,t.forEach(g=>{g.unsubscribe?g.unsubscribe(l):g.removeEventListener("abort",l)}),t=null)};t.forEach(g=>g.addEventListener("abort",l));const{signal:p}=o;return p.unsubscribe=()=>vn.asap(h),p}},Z3t=function*(t,e){let i=t.byteLength;if(i<e)return void(yield t);let r,o=0;for(;o<i;)r=o+e,yield t.slice(o,r),o=r},X3t=async function*(t,e){for await(const i of e4t(t))yield*Z3t(i,e)},e4t=async function*(t){if(t[Symbol.asyncIterator])return void(yield*t);const e=t.getReader();try{for(;;){const{done:i,value:r}=await e.read();if(i)break;yield r}}finally{await e.cancel()}},t5e=(t,e,i,r)=>{const o=X3t(t,e);let l,d=0,h=p=>{l||(l=!0,r&&r(p))};return new ReadableStream({async pull(p){try{const{done:g,value:f}=await o.next();if(g)return h(),void p.close();let y=f.byteLength;if(i){let T=d+=y;i(T)}p.enqueue(new Uint8Array(f))}catch(g){throw h(g),g}},cancel:p=>(h(p),o.return())},{highWaterMark:2})},$Q=typeof fetch=="function"&&typeof Request=="function"&&typeof Response=="function",i5e=$Q&&typeof ReadableStream=="function",t4t=$Q&&(typeof TextEncoder=="function"?(n5e=new TextEncoder,t=>n5e.encode(t)):async t=>new Uint8Array(await new Response(t).arrayBuffer()));var n5e;const a5e=(t,...e)=>{try{return!!t(...e)}catch{return!1}},i4t=i5e&&a5e(()=>{let t=!1;const e=new Request(Wy.origin,{body:new ReadableStream,method:"POST",get duplex(){return t=!0,"half"}}).headers.has("Content-Type");return t&&!e}),r5e=65536,Mpe=i5e&&a5e(()=>vn.isReadableStream(new Response("").body)),HQ={stream:Mpe&&(t=>t.body)};var o5e;$Q&&(o5e=new Response,["text","arrayBuffer","blob","formData","stream"].forEach(t=>{!HQ[t]&&(HQ[t]=vn.isFunction(o5e[t])?e=>e[t]():(e,i)=>{throw new nl(`Response type '${t}' is not supported`,nl.ERR_NOT_SUPPORT,i)})}));const n4t=async t=>t==null?0:vn.isBlob(t)?t.size:vn.isSpecCompliantForm(t)?(await new Request(Wy.origin,{method:"POST",body:t}).arrayBuffer()).byteLength:vn.isArrayBufferView(t)||vn.isArrayBuffer(t)?t.byteLength:(vn.isURLSearchParams(t)&&(t+=""),vn.isString(t)?(await t4t(t)).byteLength:void 0),a4t=async(t,e)=>{const i=vn.toFiniteNumber(t.getContentLength());return i??n4t(e)};var r4t=$Q&&(async t=>{let{url:e,method:i,data:r,signal:o,cancelToken:l,timeout:d,onDownloadProgress:h,onUploadProgress:p,responseType:g,headers:f,withCredentials:y="same-origin",fetchOptions:T}=e5e(t);g=g?(g+"").toLowerCase():"text";let C,E=Q3t([o,l&&l.toAbortSignal()],d);const I=E&&E.unsubscribe&&(()=>{E.unsubscribe()});let w;try{if(p&&i4t&&i!=="get"&&i!=="head"&&(w=await a4t(f,r))!==0){let L,z=new Request(e,{method:"POST",body:r,duplex:"half"});if(vn.isFormData(r)&&(L=z.headers.get("content-type"))&&f.setContentType(L),z.body){const[H,j]=YUe(w,VQ(QUe(p)));r=t5e(z.body,r5e,H,j)}}vn.isString(y)||(y=y?"include":"omit");const D="credentials"in Request.prototype;C=new Request(e,{...T,signal:E,method:i.toUpperCase(),headers:f.normalize().toJSON(),body:r,duplex:"half",credentials:D?y:void 0});let F=await fetch(C);const x=Mpe&&(g==="stream"||g==="response");if(Mpe&&(h||x&&I)){const L={};["status","statusText","headers"].forEach(J=>{L[J]=F[J]});const z=vn.toFiniteNumber(F.headers.get("content-length")),[H,j]=h&&YUe(z,VQ(QUe(h),!0))||[];F=new Response(t5e(F.body,r5e,H,()=>{j&&j(),I&&I()}),L)}g=g||"text";let B=await HQ[vn.findKey(HQ,g)||"text"](F,t);return!x&&I&&I(),await new Promise((L,z)=>{JUe(L,z,{data:B,headers:yT.from(F.headers),status:F.status,statusText:F.statusText,config:t,request:C})})}catch(D){throw I&&I(),D&&D.name==="TypeError"&&/fetch/i.test(D.message)?Object.assign(new nl("Network Error",nl.ERR_NETWORK,t,C),{cause:D.cause||D}):nl.from(D,D&&D.code,t,C)}});const Ppe={http:A3t,xhr:Y3t,fetch:r4t};vn.forEach(Ppe,(t,e)=>{if(t){try{Object.defineProperty(t,"name",{value:e})}catch{}Object.defineProperty(t,"adapterName",{value:e})}});const s5e=t=>`- ${t}`,o4t=t=>vn.isFunction(t)||t===null||t===!1;var l5e={getAdapter:t=>{t=vn.isArray(t)?t:[t];const{length:e}=t;let i,r;const o={};for(let l=0;l<e;l++){let d;if(i=t[l],r=i,!o4t(i)&&(r=Ppe[(d=String(i)).toLowerCase()],r===void 0))throw new nl(`Unknown adapter '${d}'`);if(r)break;o[d||"#"+l]=r}if(!r){const l=Object.entries(o).map(([d,h])=>`adapter ${d} `+(h===!1?"is not supported by the environment":"is not available in the build"));throw new nl("There is no suitable adapter to dispatch the request "+(e?l.length>1?`since :
`+l.map(s5e).join(`
`):" "+s5e(l[0]):"as no adapter specified"),"ERR_NOT_SUPPORT")}return r},adapters:Ppe};function Dpe(t){if(t.cancelToken&&t.cancelToken.throwIfRequested(),t.signal&&t.signal.aborted)throw new q3(null,t)}function c5e(t){return Dpe(t),t.headers=yT.from(t.headers),t.data=Rpe.call(t,t.transformRequest),["post","put","patch"].indexOf(t.method)!==-1&&t.headers.setContentType("application/x-www-form-urlencoded",!1),l5e.getAdapter(t.adapter||G6.adapter)(t).then(function(i){return Dpe(t),i.data=Rpe.call(t,t.transformResponse,i),i.headers=yT.from(i.headers),i},function(i){return KUe(i)||(Dpe(t),i&&i.response&&(i.response.data=Rpe.call(t,t.transformResponse,i.response),i.response.headers=yT.from(i.response.headers))),Promise.reject(i)})}const d5e="1.8.4",jQ={};["object","boolean","number","function","string","symbol"].forEach((t,e)=>{jQ[t]=function(r){return typeof r===t||"a"+(e<1?"n ":" ")+t}});const u5e={};function s4t(t,e,i){if(typeof t!="object")throw new nl("options must be an object",nl.ERR_BAD_OPTION_VALUE);const r=Object.keys(t);let o=r.length;for(;o-- >0;){const l=r[o],d=e[l];if(d){const h=t[l],p=h===void 0||d(h,l,t);if(p!==!0)throw new nl("option "+l+" must be "+p,nl.ERR_BAD_OPTION_VALUE)}else if(i!==!0)throw new nl("Unknown option "+l,nl.ERR_BAD_OPTION)}}jQ.transitional=function(e,i,r){function o(l,d){return"[Axios v"+d5e+"] Transitional option '"+l+"'"+d+(r?". "+r:"")}return(l,d,h)=>{if(e===!1)throw new nl(o(d," has been removed"+(i?" in "+i:"")),nl.ERR_DEPRECATED);return i&&!u5e[d]&&(u5e[d]=!0,console.warn(o(d," has been deprecated since v"+i+" and will be removed in the near future"))),!e||e(l,d,h)}},jQ.spelling=function(e){return(i,r)=>(console.warn(`${r} is likely a misspelling of ${e}`),!0)};var GQ={assertOptions:s4t,validators:jQ};const Sk=GQ.validators;class $B{constructor(e){this.defaults=e,this.interceptors={request:new jUe,response:new jUe}}async request(e,i){try{return await this._request(e,i)}catch(r){if(r instanceof Error){let o={};Error.captureStackTrace?Error.captureStackTrace(o):o=new Error;const l=o.stack?o.stack.replace(/^.+\n/,""):"";try{r.stack?l&&!String(r.stack).endsWith(l.replace(/^.+\n.+\n/,""))&&(r.stack+=`
`+l):r.stack=l}catch{}}throw r}}_request(e,i){typeof e=="string"?(i=i||{}).url=e:i=e||{},i=VB(this.defaults,i);const{transitional:r,paramsSerializer:o,headers:l}=i;r!==void 0&&GQ.assertOptions(r,{silentJSONParsing:Sk.transitional(Sk.boolean),forcedJSONParsing:Sk.transitional(Sk.boolean),clarifyTimeoutError:Sk.transitional(Sk.boolean)},!1),o!=null&&(vn.isFunction(o)?i.paramsSerializer={serialize:o}:GQ.assertOptions(o,{encode:Sk.function,serialize:Sk.function},!0)),i.allowAbsoluteUrls!==void 0||(this.defaults.allowAbsoluteUrls!==void 0?i.allowAbsoluteUrls=this.defaults.allowAbsoluteUrls:i.allowAbsoluteUrls=!0),GQ.assertOptions(i,{baseUrl:Sk.spelling("baseURL"),withXsrfToken:Sk.spelling("withXSRFToken")},!0),i.method=(i.method||this.defaults.method||"get").toLowerCase();let d=l&&vn.merge(l.common,l[i.method]);l&&vn.forEach(["delete","get","head","post","put","patch","common"],E=>{delete l[E]}),i.headers=yT.concat(d,l);const h=[];let p=!0;this.interceptors.request.forEach(function(I){typeof I.runWhen=="function"&&I.runWhen(i)===!1||(p=p&&I.synchronous,h.unshift(I.fulfilled,I.rejected))});const g=[];let f;this.interceptors.response.forEach(function(I){g.push(I.fulfilled,I.rejected)});let y,T=0;if(!p){const E=[c5e.bind(this),void 0];for(E.unshift.apply(E,h),E.push.apply(E,g),y=E.length,f=Promise.resolve(i);T<y;)f=f.then(E[T++],E[T++]);return f}y=h.length;let C=i;for(T=0;T<y;){const E=h[T++],I=h[T++];try{C=E(C)}catch(w){I.call(this,w);break}}try{f=c5e.call(this,C)}catch(E){return Promise.reject(E)}for(T=0,y=g.length;T<y;)f=f.then(g[T++],g[T++]);return f}getUri(e){return HUe(ZUe((e=VB(this.defaults,e)).baseURL,e.url,e.allowAbsoluteUrls),e.params,e.paramsSerializer)}}vn.forEach(["delete","get","head","options"],function(e){$B.prototype[e]=function(i,r){return this.request(VB(r||{},{method:e,url:i,data:(r||{}).data}))}}),vn.forEach(["post","put","patch"],function(e){function i(r){return function(l,d,h){return this.request(VB(h||{},{method:e,headers:r?{"Content-Type":"multipart/form-data"}:{},url:l,data:d}))}}$B.prototype[e]=i(),$B.prototype[e+"Form"]=i(!0)});class Lpe{constructor(e){if(typeof e!="function")throw new TypeError("executor must be a function.");let i;this.promise=new Promise(function(l){i=l});const r=this;this.promise.then(o=>{if(!r._listeners)return;let l=r._listeners.length;for(;l-- >0;)r._listeners[l](o);r._listeners=null}),this.promise.then=o=>{let l;const d=new Promise(h=>{r.subscribe(h),l=h}).then(o);return d.cancel=function(){r.unsubscribe(l)},d},e(function(l,d,h){r.reason||(r.reason=new q3(l,d,h),i(r.reason))})}throwIfRequested(){if(this.reason)throw this.reason}subscribe(e){this.reason?e(this.reason):this._listeners?this._listeners.push(e):this._listeners=[e]}unsubscribe(e){if(!this._listeners)return;const i=this._listeners.indexOf(e);i!==-1&&this._listeners.splice(i,1)}toAbortSignal(){const e=new AbortController,i=r=>{e.abort(r)};return this.subscribe(i),e.signal.unsubscribe=()=>this.unsubscribe(i),e.signal}static source(){let e;return{token:new Lpe(function(r){e=r}),cancel:e}}}function l4t(t){return function(i){return t.apply(null,i)}}function c4t(t){return vn.isObject(t)&&t.isAxiosError===!0}const Ope={Continue:100,SwitchingProtocols:101,Processing:102,EarlyHints:103,Ok:200,Created:201,Accepted:202,NonAuthoritativeInformation:203,NoContent:204,ResetContent:205,PartialContent:206,MultiStatus:207,AlreadyReported:208,ImUsed:226,MultipleChoices:300,MovedPermanently:301,Found:302,SeeOther:303,NotModified:304,UseProxy:305,Unused:306,TemporaryRedirect:307,PermanentRedirect:308,BadRequest:400,Unauthorized:401,PaymentRequired:402,Forbidden:403,NotFound:404,MethodNotAllowed:405,NotAcceptable:406,ProxyAuthenticationRequired:407,RequestTimeout:408,Conflict:409,Gone:410,LengthRequired:411,PreconditionFailed:412,PayloadTooLarge:413,UriTooLong:414,UnsupportedMediaType:415,RangeNotSatisfiable:416,ExpectationFailed:417,ImATeapot:418,MisdirectedRequest:421,UnprocessableEntity:422,Locked:423,FailedDependency:424,TooEarly:425,UpgradeRequired:426,PreconditionRequired:428,TooManyRequests:429,RequestHeaderFieldsTooLarge:431,UnavailableForLegalReasons:451,InternalServerError:500,NotImplemented:501,BadGateway:502,ServiceUnavailable:503,GatewayTimeout:504,HttpVersionNotSupported:505,VariantAlsoNegotiates:506,InsufficientStorage:507,LoopDetected:508,NotExtended:510,NetworkAuthenticationRequired:511};function h5e(t){const e=new $B(t),i=wUe($B.prototype.request,e);return vn.extend(i,$B.prototype,e,{allOwnKeys:!0}),vn.extend(i,e,null,{allOwnKeys:!0}),i.create=function(o){return h5e(VB(t,o))},i}Object.entries(Ope).forEach(([t,e])=>{Ope[e]=t});const pg=h5e(G6);pg.Axios=$B,pg.CanceledError=q3,pg.CancelToken=Lpe,pg.isCancel=KUe,pg.VERSION=d5e,pg.toFormData=UQ,pg.AxiosError=nl,pg.Cancel=pg.CanceledError,pg.all=function(e){return Promise.all(e)},pg.spread=l4t,pg.isAxiosError=c4t,pg.mergeConfig=VB,pg.AxiosHeaders=yT,pg.formToJSON=t=>qUe(vn.isHTMLForm(t)?new FormData(t):t),pg.getAdapter=l5e.getAdapter,pg.HttpStatusCode=Ope,pg.default=pg;const{Axios:d4t,AxiosError:u4t,CanceledError:h4t,isCancel:p4t,CancelToken:g4t,VERSION:m4t,all:f4t,Cancel:v4t,isAxiosError:y4t,spread:S4t,toFormData:b4t,AxiosHeaders:T4t,HttpStatusCode:C4t,formToJSON:_4t,getAdapter:E4t,mergeConfig:A4t}=pg;for(var I4t=Object.freeze({__proto__:null,default:pg,Axios:d4t,AxiosError:u4t,CanceledError:h4t,isCancel:p4t,CancelToken:g4t,VERSION:m4t,all:f4t,Cancel:v4t,isAxiosError:y4t,spread:S4t,toFormData:b4t,AxiosHeaders:T4t,HttpStatusCode:C4t,formToJSON:_4t,getAdapter:E4t,mergeConfig:A4t}),p5e=bs(function(t){var e=typeof crypto<"u"&&crypto.getRandomValues&&crypto.getRandomValues.bind(crypto)||typeof msCrypto<"u"&&typeof window.msCrypto.getRandomValues=="function"&&msCrypto.getRandomValues.bind(msCrypto);if(e){var i=new Uint8Array(16);t.exports=function(){return e(i),i}}else{var r=new Array(16);t.exports=function(){for(var l,d=0;d<16;d++)3&d||(l=4294967296*Math.random()),r[d]=l>>>((3&d)<<3)&255;return r}}}),g5e=[],qQ=0;qQ<256;++qQ)g5e[qQ]=(qQ+256).toString(16).substr(1);function w4t(t,e){var i=e||0,r=g5e;return[r[t[i++]],r[t[i++]],r[t[i++]],r[t[i++]],"-",r[t[i++]],r[t[i++]],"-",r[t[i++]],r[t[i++]],"-",r[t[i++]],r[t[i++]],"-",r[t[i++]],r[t[i++]],r[t[i++]],r[t[i++]],r[t[i++]],r[t[i++]]].join("")}var m5e,Npe,f5e=w4t,xpe=0,Bpe=0;function k4t(t,e,i){var r=e&&i||0,o=e||[],l=(t=t||{}).node||m5e,d=t.clockseq!==void 0?t.clockseq:Npe;if(l==null||d==null){var h=p5e();l==null&&(l=m5e=[1|h[0],h[1],h[2],h[3],h[4],h[5]]),d==null&&(d=Npe=16383&(h[6]<<8|h[7]))}var p=t.msecs!==void 0?t.msecs:new Date().getTime(),g=t.nsecs!==void 0?t.nsecs:Bpe+1,f=p-xpe+(g-Bpe)/1e4;if(f<0&&t.clockseq===void 0&&(d=d+1&16383),(f<0||p>xpe)&&t.nsecs===void 0&&(g=0),g>=1e4)throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");xpe=p,Bpe=g,Npe=d;var y=(1e4*(268435455&(p+=122192928e5))+g)%4294967296;o[r++]=y>>>24&255,o[r++]=y>>>16&255,o[r++]=y>>>8&255,o[r++]=255&y;var T=p/4294967296*1e4&268435455;o[r++]=T>>>8&255,o[r++]=255&T,o[r++]=T>>>24&15|16,o[r++]=T>>>16&255,o[r++]=d>>>8|128,o[r++]=255&d;for(var C=0;C<6;++C)o[r+C]=l[C];return e||f5e(o)}var R4t=k4t;function M4t(t,e,i){var r=e&&i||0;typeof t=="string"&&(e=t==="binary"?new Array(16):null,t=null);var o=(t=t||{}).random||(t.rng||p5e)();if(o[6]=15&o[6]|64,o[8]=63&o[8]|128,e)for(var l=0;l<16;++l)e[r+l]=o[l];return e||f5e(o)}var v5e=M4t,Fpe=v5e;Fpe.v1=R4t,Fpe.v4=v5e;for(var UE=Fpe,VA=bs(function(t,e){var i=fo&&fo.__assign||function(){return i=Object.assign||function(d){for(var h,p=1,g=arguments.length;p<g;p++)for(var f in h=arguments[p])Object.prototype.hasOwnProperty.call(h,f)&&(d[f]=h[f]);return d},i.apply(this,arguments)};function r(d,h){if(h===void 0&&(h=!0),d==null)return"";if(typeof d=="string")return d;try{return JSON.stringify(d,l(o(h)))}catch{return"Stringifying error failed"}}Object.defineProperty(e,"__esModule",{value:!0}),e.errorToString=void 0,e.errorToString=r;var o=function(d){return d===void 0&&(d=!1),function(h,p){return p instanceof Error?i({name:p.name,message:p.message,stack:d?[]:(typeof p.stack=="string"?p.stack:"").split(`
`).map(function(g){return g.trim()}).filter(function(g){return!!g})},p):p}},l=function(d){var h=new WeakSet;return function(p,g){if(typeof g=="object"&&g!==null){if(h.has(g))return;h.add(g)}return d(p,g)}}}),P4t=bs(function(t,e){Object.defineProperty(e,"__esModule",{value:!0}),e.EvictingQueue=void 0;var i=function(){function r(o){this.maxSize=o,this._store=[]}return Object.defineProperty(r.prototype,"store",{get:function(){return this._store},enumerable:!1,configurable:!0}),Object.defineProperty(r.prototype,"size",{get:function(){return this._store.length},enumerable:!1,configurable:!0}),r.prototype.enqueue=function(o){this._store.length>=this.maxSize&&this._store.shift(),this._store.push(o)},r.prototype.dequeue=function(){return this._store.shift()},r.prototype.clear=function(){this._store=[]},r.prototype.forEach=function(o){this._store.forEach(o)},r}();e.EvictingQueue=i}),W6=bs(function(t,e){var i=fo&&fo.__awaiter||function(l,d,h,p){function g(f){return f instanceof h?f:new h(function(y){y(f)})}return new(h||(h=Promise))(function(f,y){function T(I){try{E(p.next(I))}catch(w){y(w)}}function C(I){try{E(p.throw(I))}catch(w){y(w)}}function E(I){I.done?f(I.value):g(I.value).then(T,C)}E((p=p.apply(l,d||[])).next())})},r=fo&&fo.__generator||function(l,d){var h,p,g,f,y={label:0,sent:function(){if(1&g[0])throw g[1];return g[1]},trys:[],ops:[]};return f={next:T(0),throw:T(1),return:T(2)},typeof Symbol=="function"&&(f[Symbol.iterator]=function(){return this}),f;function T(E){return function(I){return C([E,I])}}function C(E){if(h)throw new TypeError("Generator is already executing.");for(;f&&(f=0,E[0]&&(y=0)),y;)try{if(h=1,p&&(g=2&E[0]?p.return:E[0]?p.throw||((g=p.return)&&g.call(p),0):p.next)&&!(g=g.call(p,E[1])).done)return g;switch(p=0,g&&(E=[2&E[0],g.value]),E[0]){case 0:case 1:g=E;break;case 4:return y.label++,{value:E[1],done:!1};case 5:y.label++,p=E[1],E=[0];continue;case 7:E=y.ops.pop(),y.trys.pop();continue;default:if(g=y.trys,!((g=g.length>0&&g[g.length-1])||E[0]!==6&&E[0]!==2)){y=0;continue}if(E[0]===3&&(!g||E[1]>g[0]&&E[1]<g[3])){y.label=E[1];break}if(E[0]===6&&y.label<g[1]){y.label=g[1],g=E;break}if(g&&y.label<g[2]){y.label=g[2],y.ops.push(E);break}g[2]&&y.ops.pop(),y.trys.pop();continue}E=d.call(l,y)}catch(I){E=[6,I],p=0}finally{h=g=0}if(5&E[0])throw E[1];return{value:E[0]?E[1]:void 0,done:!0}}};Object.defineProperty(e,"__esModule",{value:!0}),e.SimpleSyncCell=void 0;var o=function(){function l(d,h,p,g,f){this.m_id=d,this.m_sender=h,this.m_shouldEmitEventForAllMessages=p,this.aggregation=f,this.m_events=new $c.EventEmitter,this.m_emitUnacknowledgedEventFor=g??ed.MessageTrackingOption.None}return l.prototype.on=function(d,h){return this.m_events.on(d,h),this},l.prototype.off=function(d,h){return this.m_events.off(d,h),this},l.prototype.removeAllListeners=function(d){return this.m_events.removeAllListeners(d),this},l.prototype.id=function(){return this.m_id},l.prototype.messageTrackingOption=function(){return this.m_emitUnacknowledgedEventFor},l.prototype.getAsync=function(){return i(this,void 0,void 0,function(){return r(this,function(d){return[2,this.m_value]})})},l.prototype.setAsync=function(d){return i(this,void 0,void 0,function(){var h;return r(this,function(p){return this.m_value=d,h={messageId:(0,UE.v4)(),senderId:this.m_sender.senderId(),objectId:this.m_id,type:"cell",operation:"set",value:JSON.stringify(this.m_value)},this.m_sender.sendStateMessage(h),[2]})})},l.prototype.delete=function(){this.m_value=void 0;var d={messageId:(0,UE.v4)(),senderId:this.m_sender.senderId(),objectId:this.m_id,type:"cell",operation:"delete",value:""};this.m_sender.sendStateMessage(d)},l.prototype.handleStateMessage=function(d){switch(d.operation){case"set":return void((JSON.stringify(this.m_value)!==d.value||this.m_shouldEmitEventForAllMessages)&&(this.m_value=JSON.parse(d.value),this.m_events.emit("valueChanged",this.m_value,d)));case"delete":return this.m_value=void 0,void this.m_events.emit("valueDeleted",this.m_value,d);default:return}},l.prototype.handleUnacknowledgedMessage=function(d){this.m_events.emit("valueUnacknowledged",d)},l.prototype.beginAggregatedStateUpdating=function(){var d;(d=this.aggregation)===null||d===void 0||d.beginAggregatedStateUpdating()},l.prototype.endAggregatedStateUpdating=function(){var d;(d=this.aggregation)===null||d===void 0||d.endAggregatedStateUpdating()},l}();e.SimpleSyncCell=o}),y5e=bs(function(t,e){function i(r){return r.operation==="delete"&&r.value==="prefix"}Object.defineProperty(e,"__esModule",{value:!0}),e.isPrefixDeleteMessage=void 0,e.isPrefixDeleteMessage=i}),S5e=bs(function(t,e){Object.defineProperty(e,"__esModule",{value:!0}),e.SimpleSyncMap=void 0;var i=function(){function r(o,l,d,h,p){this.m_id=o,this.m_sender=l,this.m_shouldEmitEventForAllMessages=d,this.aggregation=p,this.m_events=new $c.EventEmitter,this.m_map=new Map,this.m_emitUnacknowledgedEventFor=h??ed.MessageTrackingOption.None}return r.prototype.on=function(o,l){return this.m_events.on(o,l),this},r.prototype.off=function(o,l){return this.m_events.off(o,l),this},r.prototype.removeAllListeners=function(o){return this.m_events.removeAllListeners(o),this},r.prototype.id=function(){return this.m_id},r.prototype.messageTrackingOption=function(){return this.m_emitUnacknowledgedEventFor},r.prototype.get=function(o){return this.m_map.get(o)},r.prototype.set=function(o,l){this.m_map.set(o,l);var d={messageId:(0,UE.v4)(),senderId:this.m_sender.senderId(),objectId:this.m_id,type:"map",operation:"set",property:o,value:JSON.stringify(l)};this.m_sender.sendStateMessage(d)},r.prototype.delete=function(o){var l={messageId:(0,UE.v4)(),senderId:this.m_sender.senderId(),objectId:this.m_id,type:"map",operation:"delete",property:o,value:""};this.performLocalDelete(l),this.m_sender.sendStateMessage(l)},r.prototype.deleteWithPrefix=function(o){var l={messageId:(0,UE.v4)(),senderId:this.m_sender.senderId(),objectId:this.m_id,type:"map",operation:"delete",property:o,value:"prefix"};this.performLocalDelete(l),this.m_sender.sendStateMessage(l)},r.prototype.forEach=function(o){this.m_map.forEach(o)},r.prototype.handleStateMessage=function(o){switch(o.operation){case"set":return void this.handleSet(o);case"delete":return void this.handleDelete(o);default:return}},r.prototype.handleSet=function(o){if(!o.property)throw new Error("property is missing for a map.");(JSON.stringify(this.m_map.get(o.property))!==o.value||this.m_shouldEmitEventForAllMessages)&&(this.m_map.set(o.property,JSON.parse(o.value)),this.m_events.emit("valueChanged",o.property,o))},r.prototype.handleDelete=function(o){this.performLocalDelete(o),(0,y5e.isPrefixDeleteMessage)(o)?this.m_events.emit("valuesDeletedWithPrefix",o.property,o):this.m_events.emit("valueDeleted",o.property||"",o)},r.prototype.handleUnacknowledgedMessage=function(o){this.m_events.emit("valueUnacknowledged",o)},r.prototype.beginAggregatedStateUpdating=function(){var o;(o=this.aggregation)===null||o===void 0||o.beginAggregatedStateUpdating()},r.prototype.endAggregatedStateUpdating=function(){var o;(o=this.aggregation)===null||o===void 0||o.endAggregatedStateUpdating()},r.prototype.performLocalDelete=function(o){var l=this;if(o.property){var d=o.property;(0,y5e.isPrefixDeleteMessage)(o)?this.m_map.forEach(function(h,p){p.startsWith(d)&&l.m_map.delete(p)}):this.m_map.delete(o.property)}else this.m_map.clear()},r}();e.SimpleSyncMap=i}),W3=bs(function(t){typeof Object.create=="function"?t.exports=function(i,r){r&&(i.super_=r,i.prototype=Object.create(r.prototype,{constructor:{value:i,enumerable:!1,writable:!0,configurable:!0}}))}:t.exports=function(i,r){if(r){i.super_=r;var o=function(){};o.prototype=r.prototype,i.prototype=new o,i.prototype.constructor=i}}}),D4t=B4t,L4t=U4t,O4t=$4t,bk=[],zE=[],N4t=typeof Uint8Array<"u"?Uint8Array:Array,Upe="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",K3=0,x4t=Upe.length;K3<x4t;++K3)bk[K3]=Upe[K3],zE[Upe.charCodeAt(K3)]=K3;function b5e(t){var e=t.length;if(e%4>0)throw new Error("Invalid string. Length must be a multiple of 4");var i=t.indexOf("=");return i===-1&&(i=e),[i,i===e?0:4-i%4]}function B4t(t){var e=b5e(t),i=e[0],r=e[1];return 3*(i+r)/4-r}function F4t(t,e,i){return 3*(e+i)/4-i}function U4t(t){var e,i,r=b5e(t),o=r[0],l=r[1],d=new N4t(F4t(t,o,l)),h=0,p=l>0?o-4:o;for(i=0;i<p;i+=4)e=zE[t.charCodeAt(i)]<<18|zE[t.charCodeAt(i+1)]<<12|zE[t.charCodeAt(i+2)]<<6|zE[t.charCodeAt(i+3)],d[h++]=e>>16&255,d[h++]=e>>8&255,d[h++]=255&e;return l===2&&(e=zE[t.charCodeAt(i)]<<2|zE[t.charCodeAt(i+1)]>>4,d[h++]=255&e),l===1&&(e=zE[t.charCodeAt(i)]<<10|zE[t.charCodeAt(i+1)]<<4|zE[t.charCodeAt(i+2)]>>2,d[h++]=e>>8&255,d[h++]=255&e),d}function z4t(t){return bk[t>>18&63]+bk[t>>12&63]+bk[t>>6&63]+bk[63&t]}function V4t(t,e,i){for(var r,o=[],l=e;l<i;l+=3)r=(t[l]<<16&16711680)+(t[l+1]<<8&65280)+(255&t[l+2]),o.push(z4t(r));return o.join("")}function $4t(t){for(var e,i=t.length,r=i%3,o=[],l=16383,d=0,h=i-r;d<h;d+=l)o.push(V4t(t,d,d+l>h?h:d+l));return r===1?(e=t[i-1],o.push(bk[e>>2]+bk[e<<4&63]+"==")):r===2&&(e=(t[i-2]<<8)+t[i-1],o.push(bk[e>>10]+bk[e>>4&63]+bk[e<<2&63]+"=")),o.join("")}zE[45]=62,zE[95]=63;var zpe={byteLength:D4t,toByteArray:L4t,fromByteArray:O4t},H4t=function(t,e,i,r,o){var l,d,h=8*o-r-1,p=(1<<h)-1,g=p>>1,f=-7,y=i?o-1:0,T=i?-1:1,C=t[e+y];for(y+=T,l=C&(1<<-f)-1,C>>=-f,f+=h;f>0;l=256*l+t[e+y],y+=T,f-=8);for(d=l&(1<<-f)-1,l>>=-f,f+=r;f>0;d=256*d+t[e+y],y+=T,f-=8);if(l===0)l=1-g;else{if(l===p)return d?NaN:1/0*(C?-1:1);d+=Math.pow(2,r),l-=g}return(C?-1:1)*d*Math.pow(2,l-r)},j4t=function(t,e,i,r,o,l){var d,h,p,g=8*l-o-1,f=(1<<g)-1,y=f>>1,T=o===23?Math.pow(2,-24)-Math.pow(2,-77):0,C=r?0:l-1,E=r?1:-1,I=e<0||e===0&&1/e<0?1:0;for(e=Math.abs(e),isNaN(e)||e===1/0?(h=isNaN(e)?1:0,d=f):(d=Math.floor(Math.log(e)/Math.LN2),e*(p=Math.pow(2,-d))<1&&(d--,p*=2),(e+=d+y>=1?T/p:T*Math.pow(2,1-y))*p>=2&&(d++,p/=2),d+y>=f?(h=0,d=f):d+y>=1?(h=(e*p-1)*Math.pow(2,o),d+=y):(h=e*Math.pow(2,y-1)*Math.pow(2,o),d=0));o>=8;t[i+C]=255&h,C+=E,h/=256,o-=8);for(d=d<<o|h,g+=o;g>0;t[i+C]=255&d,C+=E,d/=256,g-=8);t[i+C-E]|=128*I},J3={read:H4t,write:j4t},K6=bs(function(t,e){const i=typeof Symbol=="function"&&typeof Symbol.for=="function"?Symbol.for("nodejs.util.inspect.custom"):null;e.Buffer=d,e.SlowBuffer=D,e.INSPECT_MAX_BYTES=50;const r=2147483647;function o(){try{const je=new Uint8Array(1),Ae={foo:function(){return 42}};return Object.setPrototypeOf(Ae,Uint8Array.prototype),Object.setPrototypeOf(je,Ae),je.foo()===42}catch{return!1}}function l(je){if(je>r)throw new RangeError('The value "'+je+'" is invalid for option "size"');const Ae=new Uint8Array(je);return Object.setPrototypeOf(Ae,d.prototype),Ae}function d(je,Ae,xe){if(typeof je=="number"){if(typeof Ae=="string")throw new TypeError('The "string" argument must be of type string. Received type number');return f(je)}return h(je,Ae,xe)}function h(je,Ae,xe){if(typeof je=="string")return y(je,Ae);if(ArrayBuffer.isView(je))return C(je);if(je==null)throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type "+typeof je);if(Vt(je,ArrayBuffer)||je&&Vt(je.buffer,ArrayBuffer)||typeof SharedArrayBuffer<"u"&&(Vt(je,SharedArrayBuffer)||je&&Vt(je.buffer,SharedArrayBuffer)))return E(je,Ae,xe);if(typeof je=="number")throw new TypeError('The "value" argument must not be of type number. Received type number');const gt=je.valueOf&&je.valueOf();if(gt!=null&&gt!==je)return d.from(gt,Ae,xe);const Ye=I(je);if(Ye)return Ye;if(typeof Symbol<"u"&&Symbol.toPrimitive!=null&&typeof je[Symbol.toPrimitive]=="function")return d.from(je[Symbol.toPrimitive]("string"),Ae,xe);throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type "+typeof je)}function p(je){if(typeof je!="number")throw new TypeError('"size" argument must be of type number');if(je<0)throw new RangeError('The value "'+je+'" is invalid for option "size"')}function g(je,Ae,xe){return p(je),je<=0?l(je):Ae!==void 0?typeof xe=="string"?l(je).fill(Ae,xe):l(je).fill(Ae):l(je)}function f(je){return p(je),l(je<0?0:0|w(je))}function y(je,Ae){if(typeof Ae=="string"&&Ae!==""||(Ae="utf8"),!d.isEncoding(Ae))throw new TypeError("Unknown encoding: "+Ae);const xe=0|F(je,Ae);let gt=l(xe);const Ye=gt.write(je,Ae);return Ye!==xe&&(gt=gt.slice(0,Ye)),gt}function T(je){const Ae=je.length<0?0:0|w(je.length),xe=l(Ae);for(let gt=0;gt<Ae;gt+=1)xe[gt]=255&je[gt];return xe}function C(je){if(Vt(je,Uint8Array)){const Ae=new Uint8Array(je);return E(Ae.buffer,Ae.byteOffset,Ae.byteLength)}return T(je)}function E(je,Ae,xe){if(Ae<0||je.byteLength<Ae)throw new RangeError('"offset" is outside of buffer bounds');if(je.byteLength<Ae+(xe||0))throw new RangeError('"length" is outside of buffer bounds');let gt;return gt=Ae===void 0&&xe===void 0?new Uint8Array(je):xe===void 0?new Uint8Array(je,Ae):new Uint8Array(je,Ae,xe),Object.setPrototypeOf(gt,d.prototype),gt}function I(je){if(d.isBuffer(je)){const Ae=0|w(je.length),xe=l(Ae);return xe.length===0||je.copy(xe,0,0,Ae),xe}return je.length!==void 0?typeof je.length!="number"||$t(je.length)?l(0):T(je):je.type==="Buffer"&&Array.isArray(je.data)?T(je.data):void 0}function w(je){if(je>=r)throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x"+r.toString(16)+" bytes");return 0|je}function D(je){return+je!=je&&(je=0),d.alloc(+je)}function F(je,Ae){if(d.isBuffer(je))return je.length;if(ArrayBuffer.isView(je)||Vt(je,ArrayBuffer))return je.byteLength;if(typeof je!="string")throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type '+typeof je);const xe=je.length,gt=arguments.length>2&&arguments[2]===!0;if(!gt&&xe===0)return 0;let Ye=!1;for(;;)switch(Ae){case"ascii":case"latin1":case"binary":return xe;case"utf8":case"utf-8":return Ke(je).length;case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return 2*xe;case"hex":return xe>>>1;case"base64":return jt(je).length;default:if(Ye)return gt?-1:Ke(je).length;Ae=(""+Ae).toLowerCase(),Ye=!0}}function x(je,Ae,xe){let gt=!1;if((Ae===void 0||Ae<0)&&(Ae=0),Ae>this.length||((xe===void 0||xe>this.length)&&(xe=this.length),xe<=0)||(xe>>>=0)<=(Ae>>>=0))return"";for(je||(je="utf8");;)switch(je){case"hex":return te(this,Ae,xe);case"utf8":case"utf-8":return le(this,Ae,xe);case"ascii":return Le(this,Ae,xe);case"latin1":case"binary":return pe(this,Ae,xe);case"base64":return ne(this,Ae,xe);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return Se(this,Ae,xe);default:if(gt)throw new TypeError("Unknown encoding: "+je);je=(je+"").toLowerCase(),gt=!0}}function B(je,Ae,xe){const gt=je[Ae];je[Ae]=je[xe],je[xe]=gt}function L(je,Ae,xe,gt,Ye){if(je.length===0)return-1;if(typeof xe=="string"?(gt=xe,xe=0):xe>2147483647?xe=2147483647:xe<-2147483648&&(xe=-2147483648),$t(xe=+xe)&&(xe=Ye?0:je.length-1),xe<0&&(xe=je.length+xe),xe>=je.length){if(Ye)return-1;xe=je.length-1}else if(xe<0){if(!Ye)return-1;xe=0}if(typeof Ae=="string"&&(Ae=d.from(Ae,gt)),d.isBuffer(Ae))return Ae.length===0?-1:z(je,Ae,xe,gt,Ye);if(typeof Ae=="number")return Ae&=255,typeof Uint8Array.prototype.indexOf=="function"?Ye?Uint8Array.prototype.indexOf.call(je,Ae,xe):Uint8Array.prototype.lastIndexOf.call(je,Ae,xe):z(je,[Ae],xe,gt,Ye);throw new TypeError("val must be string, number or Buffer")}function z(je,Ae,xe,gt,Ye){let Fe,St=1,Wt=je.length,Ii=Ae.length;if(gt!==void 0&&((gt=String(gt).toLowerCase())==="ucs2"||gt==="ucs-2"||gt==="utf16le"||gt==="utf-16le")){if(je.length<2||Ae.length<2)return-1;St=2,Wt/=2,Ii/=2,xe/=2}function en(sn,Qi){return St===1?sn[Qi]:sn.readUInt16BE(Qi*St)}if(Ye){let sn=-1;for(Fe=xe;Fe<Wt;Fe++)if(en(je,Fe)===en(Ae,sn===-1?0:Fe-sn)){if(sn===-1&&(sn=Fe),Fe-sn+1===Ii)return sn*St}else sn!==-1&&(Fe-=Fe-sn),sn=-1}else for(xe+Ii>Wt&&(xe=Wt-Ii),Fe=xe;Fe>=0;Fe--){let sn=!0;for(let Qi=0;Qi<Ii;Qi++)if(en(je,Fe+Qi)!==en(Ae,Qi)){sn=!1;break}if(sn)return Fe}return-1}function H(je,Ae,xe,gt){xe=Number(xe)||0;const Ye=je.length-xe;gt?(gt=Number(gt))>Ye&&(gt=Ye):gt=Ye;const Fe=Ae.length;let St;for(gt>Fe/2&&(gt=Fe/2),St=0;St<gt;++St){const Wt=parseInt(Ae.substr(2*St,2),16);if($t(Wt))return St;je[xe+St]=Wt}return St}function j(je,Ae,xe,gt){return Nt(Ke(Ae,je.length-xe),je,xe,gt)}function J(je,Ae,xe,gt){return Nt(ot(Ae),je,xe,gt)}function Z(je,Ae,xe,gt){return Nt(jt(Ae),je,xe,gt)}function re(je,Ae,xe,gt){return Nt(Ht(Ae,je.length-xe),je,xe,gt)}function ne(je,Ae,xe){return Ae===0&&xe===je.length?zpe.fromByteArray(je):zpe.fromByteArray(je.slice(Ae,xe))}function le(je,Ae,xe){xe=Math.min(je.length,xe);const gt=[];let Ye=Ae;for(;Ye<xe;){const Fe=je[Ye];let St=null,Wt=Fe>239?4:Fe>223?3:Fe>191?2:1;if(Ye+Wt<=xe){let Ii,en,sn,Qi;switch(Wt){case 1:Fe<128&&(St=Fe);break;case 2:Ii=je[Ye+1],(192&Ii)==128&&(Qi=(31&Fe)<<6|63&Ii,Qi>127&&(St=Qi));break;case 3:Ii=je[Ye+1],en=je[Ye+2],(192&Ii)==128&&(192&en)==128&&(Qi=(15&Fe)<<12|(63&Ii)<<6|63&en,Qi>2047&&(Qi<55296||Qi>57343)&&(St=Qi));break;case 4:Ii=je[Ye+1],en=je[Ye+2],sn=je[Ye+3],(192&Ii)==128&&(192&en)==128&&(192&sn)==128&&(Qi=(15&Fe)<<18|(63&Ii)<<12|(63&en)<<6|63&sn,Qi>65535&&Qi<1114112&&(St=Qi))}}St===null?(St=65533,Wt=1):St>65535&&(St-=65536,gt.push(St>>>10&1023|55296),St=56320|1023&St),gt.push(St),Ye+=Wt}return Me(gt)}e.kMaxLength=r,d.TYPED_ARRAY_SUPPORT=o(),d.TYPED_ARRAY_SUPPORT||typeof console>"u"||typeof console.error!="function"||console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."),Object.defineProperty(d.prototype,"parent",{enumerable:!0,get:function(){if(d.isBuffer(this))return this.buffer}}),Object.defineProperty(d.prototype,"offset",{enumerable:!0,get:function(){if(d.isBuffer(this))return this.byteOffset}}),d.poolSize=8192,d.from=function(je,Ae,xe){return h(je,Ae,xe)},Object.setPrototypeOf(d.prototype,Uint8Array.prototype),Object.setPrototypeOf(d,Uint8Array),d.alloc=function(je,Ae,xe){return g(je,Ae,xe)},d.allocUnsafe=function(je){return f(je)},d.allocUnsafeSlow=function(je){return f(je)},d.isBuffer=function(Ae){return Ae!=null&&Ae._isBuffer===!0&&Ae!==d.prototype},d.compare=function(Ae,xe){if(Vt(Ae,Uint8Array)&&(Ae=d.from(Ae,Ae.offset,Ae.byteLength)),Vt(xe,Uint8Array)&&(xe=d.from(xe,xe.offset,xe.byteLength)),!d.isBuffer(Ae)||!d.isBuffer(xe))throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');if(Ae===xe)return 0;let gt=Ae.length,Ye=xe.length;for(let Fe=0,St=Math.min(gt,Ye);Fe<St;++Fe)if(Ae[Fe]!==xe[Fe]){gt=Ae[Fe],Ye=xe[Fe];break}return gt<Ye?-1:Ye<gt?1:0},d.isEncoding=function(Ae){switch(String(Ae).toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"latin1":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return!0;default:return!1}},d.concat=function(Ae,xe){if(!Array.isArray(Ae))throw new TypeError('"list" argument must be an Array of Buffers');if(Ae.length===0)return d.alloc(0);let gt;if(xe===void 0)for(xe=0,gt=0;gt<Ae.length;++gt)xe+=Ae[gt].length;const Ye=d.allocUnsafe(xe);let Fe=0;for(gt=0;gt<Ae.length;++gt){let St=Ae[gt];if(Vt(St,Uint8Array))Fe+St.length>Ye.length?(d.isBuffer(St)||(St=d.from(St)),St.copy(Ye,Fe)):Uint8Array.prototype.set.call(Ye,St,Fe);else{if(!d.isBuffer(St))throw new TypeError('"list" argument must be an Array of Buffers');St.copy(Ye,Fe)}Fe+=St.length}return Ye},d.byteLength=F,d.prototype._isBuffer=!0,d.prototype.swap16=function(){const Ae=this.length;if(Ae%2!=0)throw new RangeError("Buffer size must be a multiple of 16-bits");for(let xe=0;xe<Ae;xe+=2)B(this,xe,xe+1);return this},d.prototype.swap32=function(){const Ae=this.length;if(Ae%4!=0)throw new RangeError("Buffer size must be a multiple of 32-bits");for(let xe=0;xe<Ae;xe+=4)B(this,xe,xe+3),B(this,xe+1,xe+2);return this},d.prototype.swap64=function(){const Ae=this.length;if(Ae%8!=0)throw new RangeError("Buffer size must be a multiple of 64-bits");for(let xe=0;xe<Ae;xe+=8)B(this,xe,xe+7),B(this,xe+1,xe+6),B(this,xe+2,xe+5),B(this,xe+3,xe+4);return this},d.prototype.toString=function(){const Ae=this.length;return Ae===0?"":arguments.length===0?le(this,0,Ae):x.apply(this,arguments)},d.prototype.toLocaleString=d.prototype.toString,d.prototype.equals=function(Ae){if(!d.isBuffer(Ae))throw new TypeError("Argument must be a Buffer");return this===Ae||d.compare(this,Ae)===0},d.prototype.inspect=function(){let Ae="";const xe=e.INSPECT_MAX_BYTES;return Ae=this.toString("hex",0,xe).replace(/(.{2})/g,"$1 ").trim(),this.length>xe&&(Ae+=" ... "),"<Buffer "+Ae+">"},i&&(d.prototype[i]=d.prototype.inspect),d.prototype.compare=function(Ae,xe,gt,Ye,Fe){if(Vt(Ae,Uint8Array)&&(Ae=d.from(Ae,Ae.offset,Ae.byteLength)),!d.isBuffer(Ae))throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type '+typeof Ae);if(xe===void 0&&(xe=0),gt===void 0&&(gt=Ae?Ae.length:0),Ye===void 0&&(Ye=0),Fe===void 0&&(Fe=this.length),xe<0||gt>Ae.length||Ye<0||Fe>this.length)throw new RangeError("out of range index");if(Ye>=Fe&&xe>=gt)return 0;if(Ye>=Fe)return-1;if(xe>=gt)return 1;if(this===Ae)return 0;let St=(Fe>>>=0)-(Ye>>>=0),Wt=(gt>>>=0)-(xe>>>=0);const Ii=Math.min(St,Wt),en=this.slice(Ye,Fe),sn=Ae.slice(xe,gt);for(let Qi=0;Qi<Ii;++Qi)if(en[Qi]!==sn[Qi]){St=en[Qi],Wt=sn[Qi];break}return St<Wt?-1:Wt<St?1:0},d.prototype.includes=function(Ae,xe,gt){return this.indexOf(Ae,xe,gt)!==-1},d.prototype.indexOf=function(Ae,xe,gt){return L(this,Ae,xe,gt,!0)},d.prototype.lastIndexOf=function(Ae,xe,gt){return L(this,Ae,xe,gt,!1)},d.prototype.write=function(Ae,xe,gt,Ye){if(xe===void 0)Ye="utf8",gt=this.length,xe=0;else if(gt===void 0&&typeof xe=="string")Ye=xe,gt=this.length,xe=0;else{if(!isFinite(xe))throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");xe>>>=0,isFinite(gt)?(gt>>>=0,Ye===void 0&&(Ye="utf8")):(Ye=gt,gt=void 0)}const Fe=this.length-xe;if((gt===void 0||gt>Fe)&&(gt=Fe),Ae.length>0&&(gt<0||xe<0)||xe>this.length)throw new RangeError("Attempt to write outside buffer bounds");Ye||(Ye="utf8");let St=!1;for(;;)switch(Ye){case"hex":return H(this,Ae,xe,gt);case"utf8":case"utf-8":return j(this,Ae,xe,gt);case"ascii":case"latin1":case"binary":return J(this,Ae,xe,gt);case"base64":return Z(this,Ae,xe,gt);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return re(this,Ae,xe,gt);default:if(St)throw new TypeError("Unknown encoding: "+Ye);Ye=(""+Ye).toLowerCase(),St=!0}},d.prototype.toJSON=function(){return{type:"Buffer",data:Array.prototype.slice.call(this._arr||this,0)}};const he=4096;function Me(je){const Ae=je.length;if(Ae<=he)return String.fromCharCode.apply(String,je);let xe="",gt=0;for(;gt<Ae;)xe+=String.fromCharCode.apply(String,je.slice(gt,gt+=he));return xe}function Le(je,Ae,xe){let gt="";xe=Math.min(je.length,xe);for(let Ye=Ae;Ye<xe;++Ye)gt+=String.fromCharCode(127&je[Ye]);return gt}function pe(je,Ae,xe){let gt="";xe=Math.min(je.length,xe);for(let Ye=Ae;Ye<xe;++Ye)gt+=String.fromCharCode(je[Ye]);return gt}function te(je,Ae,xe){const gt=je.length;(!Ae||Ae<0)&&(Ae=0),(!xe||xe<0||xe>gt)&&(xe=gt);let Ye="";for(let Fe=Ae;Fe<xe;++Fe)Ye+=dt[je[Fe]];return Ye}function Se(je,Ae,xe){const gt=je.slice(Ae,xe);let Ye="";for(let Fe=0;Fe<gt.length-1;Fe+=2)Ye+=String.fromCharCode(gt[Fe]+256*gt[Fe+1]);return Ye}function ce(je,Ae,xe){if(je%1!=0||je<0)throw new RangeError("offset is not uint");if(je+Ae>xe)throw new RangeError("Trying to access beyond buffer length")}function X(je,Ae,xe,gt,Ye,Fe){if(!d.isBuffer(je))throw new TypeError('"buffer" argument must be a Buffer instance');if(Ae>Ye||Ae<Fe)throw new RangeError('"value" argument is out of bounds');if(xe+gt>je.length)throw new RangeError("Index out of range")}function ve(je,Ae,xe,gt,Ye){vt(Ae,gt,Ye,je,xe,7);let Fe=Number(Ae&BigInt(4294967295));je[xe++]=Fe,Fe>>=8,je[xe++]=Fe,Fe>>=8,je[xe++]=Fe,Fe>>=8,je[xe++]=Fe;let St=Number(Ae>>BigInt(32)&BigInt(4294967295));return je[xe++]=St,St>>=8,je[xe++]=St,St>>=8,je[xe++]=St,St>>=8,je[xe++]=St,xe}function Te(je,Ae,xe,gt,Ye){vt(Ae,gt,Ye,je,xe,7);let Fe=Number(Ae&BigInt(4294967295));je[xe+7]=Fe,Fe>>=8,je[xe+6]=Fe,Fe>>=8,je[xe+5]=Fe,Fe>>=8,je[xe+4]=Fe;let St=Number(Ae>>BigInt(32)&BigInt(4294967295));return je[xe+3]=St,St>>=8,je[xe+2]=St,St>>=8,je[xe+1]=St,St>>=8,je[xe]=St,xe+8}function Be(je,Ae,xe,gt,Ye,Fe){if(xe+gt>je.length)throw new RangeError("Index out of range");if(xe<0)throw new RangeError("Index out of range")}function qe(je,Ae,xe,gt,Ye){return Ae=+Ae,xe>>>=0,Ye||Be(je,Ae,xe,4),J3.write(je,Ae,xe,gt,23,4),xe+4}function Ge(je,Ae,xe,gt,Ye){return Ae=+Ae,xe>>>=0,Ye||Be(je,Ae,xe,8),J3.write(je,Ae,xe,gt,52,8),xe+8}d.prototype.slice=function(Ae,xe){const gt=this.length;(Ae=~~Ae)<0?(Ae+=gt)<0&&(Ae=0):Ae>gt&&(Ae=gt),(xe=xe===void 0?gt:~~xe)<0?(xe+=gt)<0&&(xe=0):xe>gt&&(xe=gt),xe<Ae&&(xe=Ae);const Ye=this.subarray(Ae,xe);return Object.setPrototypeOf(Ye,d.prototype),Ye},d.prototype.readUintLE=d.prototype.readUIntLE=function(Ae,xe,gt){Ae>>>=0,xe>>>=0,gt||ce(Ae,xe,this.length);let Ye=this[Ae],Fe=1,St=0;for(;++St<xe&&(Fe*=256);)Ye+=this[Ae+St]*Fe;return Ye},d.prototype.readUintBE=d.prototype.readUIntBE=function(Ae,xe,gt){Ae>>>=0,xe>>>=0,gt||ce(Ae,xe,this.length);let Ye=this[Ae+--xe],Fe=1;for(;xe>0&&(Fe*=256);)Ye+=this[Ae+--xe]*Fe;return Ye},d.prototype.readUint8=d.prototype.readUInt8=function(Ae,xe){return Ae>>>=0,xe||ce(Ae,1,this.length),this[Ae]},d.prototype.readUint16LE=d.prototype.readUInt16LE=function(Ae,xe){return Ae>>>=0,xe||ce(Ae,2,this.length),this[Ae]|this[Ae+1]<<8},d.prototype.readUint16BE=d.prototype.readUInt16BE=function(Ae,xe){return Ae>>>=0,xe||ce(Ae,2,this.length),this[Ae]<<8|this[Ae+1]},d.prototype.readUint32LE=d.prototype.readUInt32LE=function(Ae,xe){return Ae>>>=0,xe||ce(Ae,4,this.length),(this[Ae]|this[Ae+1]<<8|this[Ae+2]<<16)+16777216*this[Ae+3]},d.prototype.readUint32BE=d.prototype.readUInt32BE=function(Ae,xe){return Ae>>>=0,xe||ce(Ae,4,this.length),16777216*this[Ae]+(this[Ae+1]<<16|this[Ae+2]<<8|this[Ae+3])},d.prototype.readBigUInt64LE=yt(function(Ae){Pt(Ae>>>=0,"offset");const xe=this[Ae],gt=this[Ae+7];xe!==void 0&&gt!==void 0||ni(Ae,this.length-8);const Ye=xe+256*this[++Ae]+65536*this[++Ae]+this[++Ae]*2**24,Fe=this[++Ae]+256*this[++Ae]+65536*this[++Ae]+gt*2**24;return BigInt(Ye)+(BigInt(Fe)<<BigInt(32))}),d.prototype.readBigUInt64BE=yt(function(Ae){Pt(Ae>>>=0,"offset");const xe=this[Ae],gt=this[Ae+7];xe!==void 0&&gt!==void 0||ni(Ae,this.length-8);const Ye=xe*2**24+65536*this[++Ae]+256*this[++Ae]+this[++Ae],Fe=this[++Ae]*2**24+65536*this[++Ae]+256*this[++Ae]+gt;return(BigInt(Ye)<<BigInt(32))+BigInt(Fe)}),d.prototype.readIntLE=function(Ae,xe,gt){Ae>>>=0,xe>>>=0,gt||ce(Ae,xe,this.length);let Ye=this[Ae],Fe=1,St=0;for(;++St<xe&&(Fe*=256);)Ye+=this[Ae+St]*Fe;return Fe*=128,Ye>=Fe&&(Ye-=Math.pow(2,8*xe)),Ye},d.prototype.readIntBE=function(Ae,xe,gt){Ae>>>=0,xe>>>=0,gt||ce(Ae,xe,this.length);let Ye=xe,Fe=1,St=this[Ae+--Ye];for(;Ye>0&&(Fe*=256);)St+=this[Ae+--Ye]*Fe;return Fe*=128,St>=Fe&&(St-=Math.pow(2,8*xe)),St},d.prototype.readInt8=function(Ae,xe){return Ae>>>=0,xe||ce(Ae,1,this.length),128&this[Ae]?-1*(255-this[Ae]+1):this[Ae]},d.prototype.readInt16LE=function(Ae,xe){Ae>>>=0,xe||ce(Ae,2,this.length);const gt=this[Ae]|this[Ae+1]<<8;return 32768&gt?4294901760|gt:gt},d.prototype.readInt16BE=function(Ae,xe){Ae>>>=0,xe||ce(Ae,2,this.length);const gt=this[Ae+1]|this[Ae]<<8;return 32768&gt?4294901760|gt:gt},d.prototype.readInt32LE=function(Ae,xe){return Ae>>>=0,xe||ce(Ae,4,this.length),this[Ae]|this[Ae+1]<<8|this[Ae+2]<<16|this[Ae+3]<<24},d.prototype.readInt32BE=function(Ae,xe){return Ae>>>=0,xe||ce(Ae,4,this.length),this[Ae]<<24|this[Ae+1]<<16|this[Ae+2]<<8|this[Ae+3]},d.prototype.readBigInt64LE=yt(function(Ae){Pt(Ae>>>=0,"offset");const xe=this[Ae],gt=this[Ae+7];xe!==void 0&&gt!==void 0||ni(Ae,this.length-8);const Ye=this[Ae+4]+256*this[Ae+5]+65536*this[Ae+6]+(gt<<24);return(BigInt(Ye)<<BigInt(32))+BigInt(xe+256*this[++Ae]+65536*this[++Ae]+this[++Ae]*2**24)}),d.prototype.readBigInt64BE=yt(function(Ae){Pt(Ae>>>=0,"offset");const xe=this[Ae],gt=this[Ae+7];xe!==void 0&&gt!==void 0||ni(Ae,this.length-8);const Ye=(xe<<24)+65536*this[++Ae]+256*this[++Ae]+this[++Ae];return(BigInt(Ye)<<BigInt(32))+BigInt(this[++Ae]*2**24+65536*this[++Ae]+256*this[++Ae]+gt)}),d.prototype.readFloatLE=function(Ae,xe){return Ae>>>=0,xe||ce(Ae,4,this.length),J3.read(this,Ae,!0,23,4)},d.prototype.readFloatBE=function(Ae,xe){return Ae>>>=0,xe||ce(Ae,4,this.length),J3.read(this,Ae,!1,23,4)},d.prototype.readDoubleLE=function(Ae,xe){return Ae>>>=0,xe||ce(Ae,8,this.length),J3.read(this,Ae,!0,52,8)},d.prototype.readDoubleBE=function(Ae,xe){return Ae>>>=0,xe||ce(Ae,8,this.length),J3.read(this,Ae,!1,52,8)},d.prototype.writeUintLE=d.prototype.writeUIntLE=function(Ae,xe,gt,Ye){Ae=+Ae,xe>>>=0,gt>>>=0,!Ye&&X(this,Ae,xe,gt,Math.pow(2,8*gt)-1,0);let Fe=1,St=0;for(this[xe]=255&Ae;++St<gt&&(Fe*=256);)this[xe+St]=Ae/Fe&255;return xe+gt},d.prototype.writeUintBE=d.prototype.writeUIntBE=function(Ae,xe,gt,Ye){Ae=+Ae,xe>>>=0,gt>>>=0,!Ye&&X(this,Ae,xe,gt,Math.pow(2,8*gt)-1,0);let Fe=gt-1,St=1;for(this[xe+Fe]=255&Ae;--Fe>=0&&(St*=256);)this[xe+Fe]=Ae/St&255;return xe+gt},d.prototype.writeUint8=d.prototype.writeUInt8=function(Ae,xe,gt){return Ae=+Ae,xe>>>=0,gt||X(this,Ae,xe,1,255,0),this[xe]=255&Ae,xe+1},d.prototype.writeUint16LE=d.prototype.writeUInt16LE=function(Ae,xe,gt){return Ae=+Ae,xe>>>=0,gt||X(this,Ae,xe,2,65535,0),this[xe]=255&Ae,this[xe+1]=Ae>>>8,xe+2},d.prototype.writeUint16BE=d.prototype.writeUInt16BE=function(Ae,xe,gt){return Ae=+Ae,xe>>>=0,gt||X(this,Ae,xe,2,65535,0),this[xe]=Ae>>>8,this[xe+1]=255&Ae,xe+2},d.prototype.writeUint32LE=d.prototype.writeUInt32LE=function(Ae,xe,gt){return Ae=+Ae,xe>>>=0,gt||X(this,Ae,xe,4,4294967295,0),this[xe+3]=Ae>>>24,this[xe+2]=Ae>>>16,this[xe+1]=Ae>>>8,this[xe]=255&Ae,xe+4},d.prototype.writeUint32BE=d.prototype.writeUInt32BE=function(Ae,xe,gt){return Ae=+Ae,xe>>>=0,gt||X(this,Ae,xe,4,4294967295,0),this[xe]=Ae>>>24,this[xe+1]=Ae>>>16,this[xe+2]=Ae>>>8,this[xe+3]=255&Ae,xe+4},d.prototype.writeBigUInt64LE=yt(function(Ae,xe=0){return ve(this,Ae,xe,BigInt(0),BigInt("0xffffffffffffffff"))}),d.prototype.writeBigUInt64BE=yt(function(Ae,xe=0){return Te(this,Ae,xe,BigInt(0),BigInt("0xffffffffffffffff"))}),d.prototype.writeIntLE=function(Ae,xe,gt,Ye){if(Ae=+Ae,xe>>>=0,!Ye){const Ii=Math.pow(2,8*gt-1);X(this,Ae,xe,gt,Ii-1,-Ii)}let Fe=0,St=1,Wt=0;for(this[xe]=255&Ae;++Fe<gt&&(St*=256);)Ae<0&&Wt===0&&this[xe+Fe-1]!==0&&(Wt=1),this[xe+Fe]=(Ae/St|0)-Wt&255;return xe+gt},d.prototype.writeIntBE=function(Ae,xe,gt,Ye){if(Ae=+Ae,xe>>>=0,!Ye){const Ii=Math.pow(2,8*gt-1);X(this,Ae,xe,gt,Ii-1,-Ii)}let Fe=gt-1,St=1,Wt=0;for(this[xe+Fe]=255&Ae;--Fe>=0&&(St*=256);)Ae<0&&Wt===0&&this[xe+Fe+1]!==0&&(Wt=1),this[xe+Fe]=(Ae/St|0)-Wt&255;return xe+gt},d.prototype.writeInt8=function(Ae,xe,gt){return Ae=+Ae,xe>>>=0,gt||X(this,Ae,xe,1,127,-128),Ae<0&&(Ae=255+Ae+1),this[xe]=255&Ae,xe+1},d.prototype.writeInt16LE=function(Ae,xe,gt){return Ae=+Ae,xe>>>=0,gt||X(this,Ae,xe,2,32767,-32768),this[xe]=255&Ae,this[xe+1]=Ae>>>8,xe+2},d.prototype.writeInt16BE=function(Ae,xe,gt){return Ae=+Ae,xe>>>=0,gt||X(this,Ae,xe,2,32767,-32768),this[xe]=Ae>>>8,this[xe+1]=255&Ae,xe+2},d.prototype.writeInt32LE=function(Ae,xe,gt){return Ae=+Ae,xe>>>=0,gt||X(this,Ae,xe,4,2147483647,-2147483648),this[xe]=255&Ae,this[xe+1]=Ae>>>8,this[xe+2]=Ae>>>16,this[xe+3]=Ae>>>24,xe+4},d.prototype.writeInt32BE=function(Ae,xe,gt){return Ae=+Ae,xe>>>=0,gt||X(this,Ae,xe,4,2147483647,-2147483648),Ae<0&&(Ae=4294967295+Ae+1),this[xe]=Ae>>>24,this[xe+1]=Ae>>>16,this[xe+2]=Ae>>>8,this[xe+3]=255&Ae,xe+4},d.prototype.writeBigInt64LE=yt(function(Ae,xe=0){return ve(this,Ae,xe,-BigInt("0x8000000000000000"),BigInt("0x7fffffffffffffff"))}),d.prototype.writeBigInt64BE=yt(function(Ae,xe=0){return Te(this,Ae,xe,-BigInt("0x8000000000000000"),BigInt("0x7fffffffffffffff"))}),d.prototype.writeFloatLE=function(Ae,xe,gt){return qe(this,Ae,xe,!0,gt)},d.prototype.writeFloatBE=function(Ae,xe,gt){return qe(this,Ae,xe,!1,gt)},d.prototype.writeDoubleLE=function(Ae,xe,gt){return Ge(this,Ae,xe,!0,gt)},d.prototype.writeDoubleBE=function(Ae,xe,gt){return Ge(this,Ae,xe,!1,gt)},d.prototype.copy=function(Ae,xe,gt,Ye){if(!d.isBuffer(Ae))throw new TypeError("argument should be a Buffer");if(gt||(gt=0),Ye||Ye===0||(Ye=this.length),xe>=Ae.length&&(xe=Ae.length),xe||(xe=0),Ye>0&&Ye<gt&&(Ye=gt),Ye===gt||Ae.length===0||this.length===0)return 0;if(xe<0)throw new RangeError("targetStart out of bounds");if(gt<0||gt>=this.length)throw new RangeError("Index out of range");if(Ye<0)throw new RangeError("sourceEnd out of bounds");Ye>this.length&&(Ye=this.length),Ae.length-xe<Ye-gt&&(Ye=Ae.length-xe+gt);const Fe=Ye-gt;return this===Ae&&typeof Uint8Array.prototype.copyWithin=="function"?this.copyWithin(xe,gt,Ye):Uint8Array.prototype.set.call(Ae,this.subarray(gt,Ye),xe),Fe},d.prototype.fill=function(Ae,xe,gt,Ye){if(typeof Ae=="string"){if(typeof xe=="string"?(Ye=xe,xe=0,gt=this.length):typeof gt=="string"&&(Ye=gt,gt=this.length),Ye!==void 0&&typeof Ye!="string")throw new TypeError("encoding must be a string");if(typeof Ye=="string"&&!d.isEncoding(Ye))throw new TypeError("Unknown encoding: "+Ye);if(Ae.length===1){const St=Ae.charCodeAt(0);(Ye==="utf8"&&St<128||Ye==="latin1")&&(Ae=St)}}else typeof Ae=="number"?Ae&=255:typeof Ae=="boolean"&&(Ae=Number(Ae));if(xe<0||this.length<xe||this.length<gt)throw new RangeError("Out of range index");if(gt<=xe)return this;let Fe;if(xe>>>=0,gt=gt===void 0?this.length:gt>>>0,Ae||(Ae=0),typeof Ae=="number")for(Fe=xe;Fe<gt;++Fe)this[Fe]=Ae;else{const St=d.isBuffer(Ae)?Ae:d.from(Ae,Ye),Wt=St.length;if(Wt===0)throw new TypeError('The value "'+Ae+'" is invalid for argument "value"');for(Fe=0;Fe<gt-xe;++Fe)this[Fe+xe]=St[Fe%Wt]}return this};const tt={};function ct(je,Ae,xe){tt[je]=class extends xe{constructor(){super(),Object.defineProperty(this,"message",{value:Ae.apply(this,arguments),writable:!0,configurable:!0}),this.name=`${this.name} [${je}]`,this.stack,delete this.name}get code(){return je}set code(gt){Object.defineProperty(this,"code",{configurable:!0,enumerable:!0,value:gt,writable:!0})}toString(){return`${this.name} [${je}]: ${this.message}`}}}function Mt(je){let Ae="",xe=je.length;const gt=je[0]==="-"?1:0;for(;xe>=gt+4;xe-=3)Ae=`_${je.slice(xe-3,xe)}${Ae}`;return`${je.slice(0,xe)}${Ae}`}function ht(je,Ae,xe){Pt(Ae,"offset"),je[Ae]!==void 0&&je[Ae+xe]!==void 0||ni(Ae,je.length-(xe+1))}function vt(je,Ae,xe,gt,Ye,Fe){if(je>xe||je<Ae){const St=typeof Ae=="bigint"?"n":"";let Wt;throw Wt=Ae===0||Ae===BigInt(0)?`>= 0${St} and < 2${St} ** ${8*(Fe+1)}${St}`:`>= -(2${St} ** ${8*(Fe+1)-1}${St}) and < 2 ** ${8*(Fe+1)-1}${St}`,new tt.ERR_OUT_OF_RANGE("value",Wt,je)}ht(gt,Ye,Fe)}function Pt(je,Ae){if(typeof je!="number")throw new tt.ERR_INVALID_ARG_TYPE(Ae,"number",je)}function ni(je,Ae,xe){throw Math.floor(je)!==je?(Pt(je,xe),new tt.ERR_OUT_OF_RANGE("offset","an integer",je)):Ae<0?new tt.ERR_BUFFER_OUT_OF_BOUNDS:new tt.ERR_OUT_OF_RANGE("offset",`>= 0 and <= ${Ae}`,je)}ct("ERR_BUFFER_OUT_OF_BOUNDS",function(je){return je?`${je} is outside of buffer bounds`:"Attempt to access memory outside buffer bounds"},RangeError),ct("ERR_INVALID_ARG_TYPE",function(je,Ae){return`The "${je}" argument must be of type number. Received type ${typeof Ae}`},TypeError),ct("ERR_OUT_OF_RANGE",function(je,Ae,xe){let gt=`The value of "${je}" is out of range.`,Ye=xe;return Number.isInteger(xe)&&Math.abs(xe)>2**32?Ye=Mt(String(xe)):typeof xe=="bigint"&&(Ye=String(xe),(xe>BigInt(2)**BigInt(32)||xe<-(BigInt(2)**BigInt(32)))&&(Ye=Mt(Ye)),Ye+="n"),gt+=` It must be ${Ae}. Received ${Ye}`,gt},RangeError);const Zt=/[^+/0-9A-Za-z-_]/g;function it(je){if((je=(je=je.split("=")[0]).trim().replace(Zt,"")).length<2)return"";for(;je.length%4!=0;)je+="=";return je}function Ke(je,Ae){let xe;Ae=Ae||1/0;const gt=je.length;let Ye=null;const Fe=[];for(let St=0;St<gt;++St){if(xe=je.charCodeAt(St),xe>55295&&xe<57344){if(!Ye){if(xe>56319){(Ae-=3)>-1&&Fe.push(239,191,189);continue}if(St+1===gt){(Ae-=3)>-1&&Fe.push(239,191,189);continue}Ye=xe;continue}if(xe<56320){(Ae-=3)>-1&&Fe.push(239,191,189),Ye=xe;continue}xe=65536+(Ye-55296<<10|xe-56320)}else Ye&&(Ae-=3)>-1&&Fe.push(239,191,189);if(Ye=null,xe<128){if((Ae-=1)<0)break;Fe.push(xe)}else if(xe<2048){if((Ae-=2)<0)break;Fe.push(xe>>6|192,63&xe|128)}else if(xe<65536){if((Ae-=3)<0)break;Fe.push(xe>>12|224,xe>>6&63|128,63&xe|128)}else{if(!(xe<1114112))throw new Error("Invalid code point");if((Ae-=4)<0)break;Fe.push(xe>>18|240,xe>>12&63|128,xe>>6&63|128,63&xe|128)}}return Fe}function ot(je){const Ae=[];for(let xe=0;xe<je.length;++xe)Ae.push(255&je.charCodeAt(xe));return Ae}function Ht(je,Ae){let xe,gt,Ye;const Fe=[];for(let St=0;St<je.length&&!((Ae-=2)<0);++St)xe=je.charCodeAt(St),gt=xe>>8,Ye=xe%256,Fe.push(Ye),Fe.push(gt);return Fe}function jt(je){return zpe.toByteArray(it(je))}function Nt(je,Ae,xe,gt){let Ye;for(Ye=0;Ye<gt&&!(Ye+xe>=Ae.length||Ye>=je.length);++Ye)Ae[Ye+xe]=je[Ye];return Ye}function Vt(je,Ae){return je instanceof Ae||je!=null&&je.constructor!=null&&je.constructor.name!=null&&je.constructor.name===Ae.name}function $t(je){return je!=je}const dt=function(){const je="0123456789abcdef",Ae=new Array(256);for(let xe=0;xe<16;++xe){const gt=16*xe;for(let Ye=0;Ye<16;++Ye)Ae[gt+Ye]=je[xe]+je[Ye]}return Ae}();function yt(je){return typeof BigInt>"u"?kt:je}function kt(){throw new Error("BigInt not supported")}}),HB=bs(function(t,e){/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */var i=K6.Buffer;function r(l,d){for(var h in l)d[h]=l[h]}function o(l,d,h){return i(l,d,h)}i.from&&i.alloc&&i.allocUnsafe&&i.allocUnsafeSlow?t.exports=K6:(r(K6,e),e.Buffer=o),o.prototype=Object.create(i.prototype),r(i,o),o.from=function(l,d,h){if(typeof l=="number")throw new TypeError("Argument must not be a number");return i(l,d,h)},o.alloc=function(l,d,h){if(typeof l!="number")throw new TypeError("Argument must be a number");var p=i(l);return d!==void 0?typeof h=="string"?p.fill(d,h):p.fill(d):p.fill(0),p},o.allocUnsafe=function(l){if(typeof l!="number")throw new TypeError("Argument must be a number");return i(l)},o.allocUnsafeSlow=function(l){if(typeof l!="number")throw new TypeError("Argument must be a number");return K6.SlowBuffer(l)}}),T5e=HB.Buffer;/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */function WQ(t,e){this._block=T5e.alloc(t),this._finalSize=e,this._blockSize=t,this._len=0}WQ.prototype.update=function(t,e){typeof t=="string"&&(e=e||"utf8",t=T5e.from(t,e));for(var i=this._block,r=this._blockSize,o=t.length,l=this._len,d=0;d<o;){for(var h=l%r,p=Math.min(o-d,r-h),g=0;g<p;g++)i[h+g]=t[d+g];d+=p,(l+=p)%r==0&&this._update(i)}return this._len+=o,this},WQ.prototype.digest=function(t){var e=this._len%this._blockSize;this._block[e]=128,this._block.fill(0,e+1),e>=this._finalSize&&(this._update(this._block),this._block.fill(0));var i=8*this._len;if(i<=4294967295)this._block.writeUInt32BE(i,this._blockSize-4);else{var r=(4294967295&i)>>>0,o=(i-r)/4294967296;this._block.writeUInt32BE(o,this._blockSize-8),this._block.writeUInt32BE(r,this._blockSize-4)}this._update(this._block);var l=this._hash();return t?l.toString(t):l},WQ.prototype._update=function(){throw new Error("_update must be implemented by subclass")};var Tk=WQ,G4t=HB.Buffer,q4t=[1518500249,1859775393,-1894007588,-899497514],W4t=new Array(80);function J6(){this.init(),this._w=W4t,Tk.call(this,64,56)}function K4t(t){return t<<5|t>>>27}function J4t(t){return t<<30|t>>>2}function Y4t(t,e,i,r){return t===0?e&i|~e&r:t===2?e&i|e&r|i&r:e^i^r}W3(J6,Tk),J6.prototype.init=function(){return this._a=1732584193,this._b=4023233417,this._c=2562383102,this._d=271733878,this._e=3285377520,this},J6.prototype._update=function(t){for(var e=this._w,i=0|this._a,r=0|this._b,o=0|this._c,l=0|this._d,d=0|this._e,h=0;h<16;++h)e[h]=t.readInt32BE(4*h);for(;h<80;++h)e[h]=e[h-3]^e[h-8]^e[h-14]^e[h-16];for(var p=0;p<80;++p){var g=~~(p/20),f=K4t(i)+Y4t(g,r,o,l)+d+e[p]+q4t[g]|0;d=l,l=o,o=J4t(r),r=i,i=f}this._a=i+this._a|0,this._b=r+this._b|0,this._c=o+this._c|0,this._d=l+this._d|0,this._e=d+this._e|0},J6.prototype._hash=function(){var t=G4t.allocUnsafe(20);return t.writeInt32BE(0|this._a,0),t.writeInt32BE(0|this._b,4),t.writeInt32BE(0|this._c,8),t.writeInt32BE(0|this._d,12),t.writeInt32BE(0|this._e,16),t};var Q4t=J6,Z4t=HB.Buffer,X4t=[1518500249,1859775393,-1894007588,-899497514],ezt=new Array(80);function Y6(){this.init(),this._w=ezt,Tk.call(this,64,56)}function tzt(t){return t<<1|t>>>31}function izt(t){return t<<5|t>>>27}function nzt(t){return t<<30|t>>>2}function azt(t,e,i,r){return t===0?e&i|~e&r:t===2?e&i|e&r|i&r:e^i^r}W3(Y6,Tk),Y6.prototype.init=function(){return this._a=1732584193,this._b=4023233417,this._c=2562383102,this._d=271733878,this._e=3285377520,this},Y6.prototype._update=function(t){for(var e=this._w,i=0|this._a,r=0|this._b,o=0|this._c,l=0|this._d,d=0|this._e,h=0;h<16;++h)e[h]=t.readInt32BE(4*h);for(;h<80;++h)e[h]=tzt(e[h-3]^e[h-8]^e[h-14]^e[h-16]);for(var p=0;p<80;++p){var g=~~(p/20),f=izt(i)+azt(g,r,o,l)+d+e[p]+X4t[g]|0;d=l,l=o,o=nzt(r),r=i,i=f}this._a=i+this._a|0,this._b=r+this._b|0,this._c=o+this._c|0,this._d=l+this._d|0,this._e=d+this._e|0},Y6.prototype._hash=function(){var t=Z4t.allocUnsafe(20);return t.writeInt32BE(0|this._a,0),t.writeInt32BE(0|this._b,4),t.writeInt32BE(0|this._c,8),t.writeInt32BE(0|this._d,12),t.writeInt32BE(0|this._e,16),t};var rzt=Y6,ozt=HB.Buffer,szt=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298],lzt=new Array(64);function Q6(){this.init(),this._w=lzt,Tk.call(this,64,56)}function czt(t,e,i){return i^t&(e^i)}function dzt(t,e,i){return t&e|i&(t|e)}function uzt(t){return(t>>>2|t<<30)^(t>>>13|t<<19)^(t>>>22|t<<10)}function hzt(t){return(t>>>6|t<<26)^(t>>>11|t<<21)^(t>>>25|t<<7)}function pzt(t){return(t>>>7|t<<25)^(t>>>18|t<<14)^t>>>3}function gzt(t){return(t>>>17|t<<15)^(t>>>19|t<<13)^t>>>10}W3(Q6,Tk),Q6.prototype.init=function(){return this._a=1779033703,this._b=3144134277,this._c=1013904242,this._d=2773480762,this._e=1359893119,this._f=2600822924,this._g=528734635,this._h=1541459225,this},Q6.prototype._update=function(t){for(var e=this._w,i=0|this._a,r=0|this._b,o=0|this._c,l=0|this._d,d=0|this._e,h=0|this._f,p=0|this._g,g=0|this._h,f=0;f<16;++f)e[f]=t.readInt32BE(4*f);for(;f<64;++f)e[f]=gzt(e[f-2])+e[f-7]+pzt(e[f-15])+e[f-16]|0;for(var y=0;y<64;++y){var T=g+hzt(d)+czt(d,h,p)+szt[y]+e[y]|0,C=uzt(i)+dzt(i,r,o)|0;g=p,p=h,h=d,d=l+T|0,l=o,o=r,r=i,i=T+C|0}this._a=i+this._a|0,this._b=r+this._b|0,this._c=o+this._c|0,this._d=l+this._d|0,this._e=d+this._e|0,this._f=h+this._f|0,this._g=p+this._g|0,this._h=g+this._h|0},Q6.prototype._hash=function(){var t=ozt.allocUnsafe(32);return t.writeInt32BE(this._a,0),t.writeInt32BE(this._b,4),t.writeInt32BE(this._c,8),t.writeInt32BE(this._d,12),t.writeInt32BE(this._e,16),t.writeInt32BE(this._f,20),t.writeInt32BE(this._g,24),t.writeInt32BE(this._h,28),t};var C5e=Q6,mzt=HB.Buffer,fzt=new Array(64);function KQ(){this.init(),this._w=fzt,Tk.call(this,64,56)}W3(KQ,C5e),KQ.prototype.init=function(){return this._a=3238371032,this._b=914150663,this._c=812702999,this._d=4144912697,this._e=4290775857,this._f=1750603025,this._g=1694076839,this._h=3204075428,this},KQ.prototype._hash=function(){var t=mzt.allocUnsafe(28);return t.writeInt32BE(this._a,0),t.writeInt32BE(this._b,4),t.writeInt32BE(this._c,8),t.writeInt32BE(this._d,12),t.writeInt32BE(this._e,16),t.writeInt32BE(this._f,20),t.writeInt32BE(this._g,24),t};var vzt=KQ,yzt=HB.Buffer,_5e=[1116352408,3609767458,1899447441,602891725,3049323471,3964484399,3921009573,2173295548,961987163,4081628472,1508970993,3053834265,2453635748,2937671579,2870763221,3664609560,3624381080,2734883394,310598401,1164996542,607225278,1323610764,1426881987,3590304994,1925078388,4068182383,2162078206,991336113,2614888103,633803317,3248222580,3479774868,3835390401,2666613458,4022224774,944711139,264347078,2341262773,604807628,2007800933,770255983,1495990901,1249150122,1856431235,1555081692,3175218132,1996064986,2198950837,2554220882,3999719339,2821834349,766784016,2952996808,2566594879,3210313671,3203337956,3336571891,1034457026,3584528711,2466948901,113926993,3758326383,338241895,168717936,666307205,1188179964,773529912,1546045734,1294757372,1522805485,1396182291,2643833823,1695183700,2343527390,1986661051,1014477480,2177026350,1206759142,2456956037,344077627,2730485921,1290863460,2820302411,3158454273,3259730800,3505952657,3345764771,106217008,3516065817,3606008344,3600352804,1432725776,4094571909,1467031594,275423344,851169720,430227734,3100823752,506948616,1363258195,659060556,3750685593,883997877,3785050280,958139571,3318307427,1322822218,3812723403,1537002063,2003034995,1747873779,3602036899,1955562222,1575990012,2024104815,1125592928,2227730452,2716904306,2361852424,442776044,2428436474,593698344,2756734187,3733110249,3204031479,2999351573,3329325298,3815920427,3391569614,3928383900,3515267271,566280711,3940187606,3454069534,4118630271,4000239992,116418474,1914138554,174292421,2731055270,289380356,3203993006,460393269,320620315,685471733,587496836,852142971,1086792851,1017036298,365543100,1126000580,2618297676,1288033470,3409855158,1501505948,4234509866,1607167915,987167468,1816402316,1246189591],Szt=new Array(160);function Z6(){this.init(),this._w=Szt,Tk.call(this,128,112)}function E5e(t,e,i){return i^t&(e^i)}function A5e(t,e,i){return t&e|i&(t|e)}function I5e(t,e){return(t>>>28|e<<4)^(e>>>2|t<<30)^(e>>>7|t<<25)}function w5e(t,e){return(t>>>14|e<<18)^(t>>>18|e<<14)^(e>>>9|t<<23)}function bzt(t,e){return(t>>>1|e<<31)^(t>>>8|e<<24)^t>>>7}function Tzt(t,e){return(t>>>1|e<<31)^(t>>>8|e<<24)^(t>>>7|e<<25)}function Czt(t,e){return(t>>>19|e<<13)^(e>>>29|t<<3)^t>>>6}function _zt(t,e){return(t>>>19|e<<13)^(e>>>29|t<<3)^(t>>>6|e<<26)}function Wf(t,e){return t>>>0<e>>>0?1:0}W3(Z6,Tk),Z6.prototype.init=function(){return this._ah=1779033703,this._bh=3144134277,this._ch=1013904242,this._dh=2773480762,this._eh=1359893119,this._fh=2600822924,this._gh=528734635,this._hh=1541459225,this._al=4089235720,this._bl=2227873595,this._cl=4271175723,this._dl=1595750129,this._el=2917565137,this._fl=725511199,this._gl=4215389547,this._hl=327033209,this},Z6.prototype._update=function(t){for(var e=this._w,i=0|this._ah,r=0|this._bh,o=0|this._ch,l=0|this._dh,d=0|this._eh,h=0|this._fh,p=0|this._gh,g=0|this._hh,f=0|this._al,y=0|this._bl,T=0|this._cl,C=0|this._dl,E=0|this._el,I=0|this._fl,w=0|this._gl,D=0|this._hl,F=0;F<32;F+=2)e[F]=t.readInt32BE(4*F),e[F+1]=t.readInt32BE(4*F+4);for(;F<160;F+=2){var x=e[F-30],B=e[F-30+1],L=bzt(x,B),z=Tzt(B,x),H=Czt(x=e[F-4],B=e[F-4+1]),j=_zt(B,x),J=e[F-14],Z=e[F-14+1],re=e[F-32],ne=e[F-32+1],le=z+Z|0,he=L+J+Wf(le,z)|0;he=(he=he+H+Wf(le=le+j|0,j)|0)+re+Wf(le=le+ne|0,ne)|0,e[F]=he,e[F+1]=le}for(var Me=0;Me<160;Me+=2){he=e[Me],le=e[Me+1];var Le=A5e(i,r,o),pe=A5e(f,y,T),te=I5e(i,f),Se=I5e(f,i),ce=w5e(d,E),X=w5e(E,d),ve=_5e[Me],Te=_5e[Me+1],Be=E5e(d,h,p),qe=E5e(E,I,w),Ge=D+X|0,tt=g+ce+Wf(Ge,D)|0;tt=(tt=(tt=tt+Be+Wf(Ge=Ge+qe|0,qe)|0)+ve+Wf(Ge=Ge+Te|0,Te)|0)+he+Wf(Ge=Ge+le|0,le)|0;var ct=Se+pe|0,Mt=te+Le+Wf(ct,Se)|0;g=p,D=w,p=h,w=I,h=d,I=E,d=l+tt+Wf(E=C+Ge|0,C)|0,l=o,C=T,o=r,T=y,r=i,y=f,i=tt+Mt+Wf(f=Ge+ct|0,Ge)|0}this._al=this._al+f|0,this._bl=this._bl+y|0,this._cl=this._cl+T|0,this._dl=this._dl+C|0,this._el=this._el+E|0,this._fl=this._fl+I|0,this._gl=this._gl+w|0,this._hl=this._hl+D|0,this._ah=this._ah+i+Wf(this._al,f)|0,this._bh=this._bh+r+Wf(this._bl,y)|0,this._ch=this._ch+o+Wf(this._cl,T)|0,this._dh=this._dh+l+Wf(this._dl,C)|0,this._eh=this._eh+d+Wf(this._el,E)|0,this._fh=this._fh+h+Wf(this._fl,I)|0,this._gh=this._gh+p+Wf(this._gl,w)|0,this._hh=this._hh+g+Wf(this._hl,D)|0},Z6.prototype._hash=function(){var t=yzt.allocUnsafe(64);function e(i,r,o){t.writeInt32BE(i,o),t.writeInt32BE(r,o+4)}return e(this._ah,this._al,0),e(this._bh,this._bl,8),e(this._ch,this._cl,16),e(this._dh,this._dl,24),e(this._eh,this._el,32),e(this._fh,this._fl,40),e(this._gh,this._gl,48),e(this._hh,this._hl,56),t};var k5e=Z6,Ezt=HB.Buffer,Azt=new Array(160);function JQ(){this.init(),this._w=Azt,Tk.call(this,128,112)}W3(JQ,k5e),JQ.prototype.init=function(){return this._ah=3418070365,this._bh=1654270250,this._ch=2438529370,this._dh=355462360,this._eh=1731405415,this._fh=2394180231,this._gh=3675008525,this._hh=1203062813,this._al=3238371032,this._bl=914150663,this._cl=812702999,this._dl=4144912697,this._el=4290775857,this._fl=1750603025,this._gl=1694076839,this._hl=3204075428,this},JQ.prototype._hash=function(){var t=Ezt.allocUnsafe(48);function e(i,r,o){t.writeInt32BE(i,o),t.writeInt32BE(r,o+4)}return e(this._ah,this._al,0),e(this._bh,this._bl,8),e(this._ch,this._cl,16),e(this._dh,this._dl,24),e(this._eh,this._el,32),e(this._fh,this._fl,40),t};var Izt=JQ,R5e=bs(function(t){var e=t.exports=function(r){r=r.toLowerCase();var o=e[r];if(!o)throw new Error(r+" is not supported (we accept pull requests)");return new o};e.sha=Q4t,e.sha1=rzt,e.sha224=vzt,e.sha256=C5e,e.sha384=Izt,e.sha512=k5e}),wzt=bs(function(t,e){Object.defineProperty(e,"__esModule",{value:!0}),e.SimpleServicePerformanceTelemetry=e.SimpleServiceTelemetry=void 0;var i=function(){function o(l,d,h){this.backendService="SimpleService",this.clientId=l,this.sessionId=this.calculateHash(d),this.wsReconnectCount=0,this.wsState=ed.ConnectionState[ed.ConnectionState.Disconnected],this.maxRoundtripRaw=h||0,this.roundtripTelemetry=new r,this.messageHandleTelemetry=new r,this.offlineCacheTelemetry={cachedCount:0,resentCount:0,expiredCount:0,rejectedCount:0},this.maxRoundtripRaw>0&&(this.roundtripRaw=[]),this.messagePendingAckCount=0,this.unacknowledgedMessagesCount=0,this.messageRequested={},this.messageReceived={},this.messageAcknowledged={}}return o.prototype.addRoundtripLatency=function(l){this.roundtripRaw&&this.roundtripRaw.length<this.maxRoundtripRaw&&this.roundtripRaw.push(l),this.roundtripTelemetry.addLatency(l)},o.prototype.addMessageHandleLatency=function(l){this.messageHandleTelemetry.addLatency(l)},o.prototype.incrementAcknowledgedCount=function(l){this.incrementMessageCount(this.messageAcknowledged,l)},o.prototype.incrementRequestedCount=function(l){this.incrementMessageCount(this.messageRequested,l)},o.prototype.incrementReceivedCount=function(l){this.incrementMessageCount(this.messageReceived,l)},o.prototype.incrementMessageCount=function(l,d){var h=l[d],p=h===void 0?1:h+1;l[d]=p},o.prototype.calculateHash=function(l){return l?"".concat(new R5e.sha256().update(l).digest("hex")):""},o}();e.SimpleServiceTelemetry=i;var r=function(){function o(){this.count=0,this.minValue=0,this.maxValue=0,this.avgValue=0}return o.prototype.addLatency=function(l){this.count+=1,this.avgValue=this.avgValue+(l-this.avgValue)/this.count,this.minValue=this.count>1?Math.min(l,this.minValue):l,this.maxValue=Math.max(this.maxValue,l)},o}();e.SimpleServicePerformanceTelemetry=r}),kzt=bs(function(t,e){var i=fo&&fo.__awaiter||function(l,d,h,p){function g(f){return f instanceof h?f:new h(function(y){y(f)})}return new(h||(h=Promise))(function(f,y){function T(I){try{E(p.next(I))}catch(w){y(w)}}function C(I){try{E(p.throw(I))}catch(w){y(w)}}function E(I){I.done?f(I.value):g(I.value).then(T,C)}E((p=p.apply(l,d||[])).next())})},r=fo&&fo.__generator||function(l,d){var h,p,g,f,y={label:0,sent:function(){if(1&g[0])throw g[1];return g[1]},trys:[],ops:[]};return f={next:T(0),throw:T(1),return:T(2)},typeof Symbol=="function"&&(f[Symbol.iterator]=function(){return this}),f;function T(E){return function(I){return C([E,I])}}function C(E){if(h)throw new TypeError("Generator is already executing.");for(;f&&(f=0,E[0]&&(y=0)),y;)try{if(h=1,p&&(g=2&E[0]?p.return:E[0]?p.throw||((g=p.return)&&g.call(p),0):p.next)&&!(g=g.call(p,E[1])).done)return g;switch(p=0,g&&(E=[2&E[0],g.value]),E[0]){case 0:case 1:g=E;break;case 4:return y.label++,{value:E[1],done:!1};case 5:y.label++,p=E[1],E=[0];continue;case 7:E=y.ops.pop(),y.trys.pop();continue;default:if(g=y.trys,!((g=g.length>0&&g[g.length-1])||E[0]!==6&&E[0]!==2)){y=0;continue}if(E[0]===3&&(!g||E[1]>g[0]&&E[1]<g[3])){y.label=E[1];break}if(E[0]===6&&y.label<g[1]){y.label=g[1],g=E;break}if(g&&y.label<g[2]){y.label=g[2],y.ops.push(E);break}g[2]&&y.ops.pop(),y.trys.pop();continue}E=d.call(l,y)}catch(I){E=[6,I],p=0}finally{h=g=0}if(5&E[0])throw E[1];return{value:E[0]?E[1]:void 0,done:!0}}};Object.defineProperty(e,"__esModule",{value:!0}),e.StateServiceWebSocketConnection=void 0;var o=function(){function l(d,h){var p=this;this.onopen=null,this.onclose=null,this.onerror=null,this.onmessage=null,this.onlog=null,this.ws=new WebSocket(d),this.settings=h,this.ws.onopen=function(g){return i(p,void 0,void 0,function(){return r(this,function(f){switch(f.label){case 0:return this.onopen&&this.onopen(g),[4,this.sendSetupMessages()];case 1:return f.sent(),[2]}})})},this.ws.onclose=function(g){p.onclose&&p.onclose(g)},this.ws.onerror=function(g){p.onerror&&p.onerror(g)},this.ws.onmessage=function(g){p.onmessage&&p.onmessage(g)}}return l.CreateAsync=function(d,h){return i(this,void 0,void 0,function(){return r(this,function(p){return[2,new l(d,h)]})})},Object.defineProperty(l.prototype,"name",{get:function(){return"WebSocket"},enumerable:!1,configurable:!0}),Object.defineProperty(l.prototype,"readyState",{get:function(){return this.ws.readyState},enumerable:!1,configurable:!0}),Object.defineProperty(l.prototype,"isOpen",{get:function(){return this.ws.readyState===WebSocket.OPEN},enumerable:!1,configurable:!0}),Object.defineProperty(l.prototype,"shouldSendPings",{get:function(){return!0},enumerable:!1,configurable:!0}),l.prototype.close=function(){this.ws.close()},l.prototype.send=function(d){this.ws.send(d)},l.prototype.sendSetupMessages=function(){return i(this,void 0,void 0,function(){var d,h,p,g,f,y,T=this;return r(this,function(C){switch(C.label){case 0:return(h=this.settings.getAuthTokenAsync)?[4,this.settings.getAuthTokenAsync()]:[3,2];case 1:h=C.sent(),C.label=2;case 2:return d=h,p=this.settings,g=p.metadata,f=p.subscriptions,y={authToken:d,metadata:g,subscriptions:f},this.settings.createSetupMessage(y).forEach(function(E){return T.send(E)}),[2]}})})},l}();e.StateServiceWebSocketConnection=o}),Rzt=xDe(I4t),Mzt=bs(function(t,e){var i=fo&&fo.__awaiter||function(f,y,T,C){function E(I){return I instanceof T?I:new T(function(w){w(I)})}return new(T||(T=Promise))(function(I,w){function D(B){try{x(C.next(B))}catch(L){w(L)}}function F(B){try{x(C.throw(B))}catch(L){w(L)}}function x(B){B.done?I(B.value):E(B.value).then(D,F)}x((C=C.apply(f,y||[])).next())})},r=fo&&fo.__generator||function(f,y){var T,C,E,I,w={label:0,sent:function(){if(1&E[0])throw E[1];return E[1]},trys:[],ops:[]};return I={next:D(0),throw:D(1),return:D(2)},typeof Symbol=="function"&&(I[Symbol.iterator]=function(){return this}),I;function D(x){return function(B){return F([x,B])}}function F(x){if(T)throw new TypeError("Generator is already executing.");for(;I&&(I=0,x[0]&&(w=0)),w;)try{if(T=1,C&&(E=2&x[0]?C.return:x[0]?C.throw||((E=C.return)&&E.call(C),0):C.next)&&!(E=E.call(C,x[1])).done)return E;switch(C=0,E&&(x=[2&x[0],E.value]),x[0]){case 0:case 1:E=x;break;case 4:return w.label++,{value:x[1],done:!1};case 5:w.label++,C=x[1],x=[0];continue;case 7:x=w.ops.pop(),w.trys.pop();continue;default:if(E=w.trys,!((E=E.length>0&&E[E.length-1])||x[0]!==6&&x[0]!==2)){w=0;continue}if(x[0]===3&&(!E||x[1]>E[0]&&x[1]<E[3])){w.label=x[1];break}if(x[0]===6&&w.label<E[1]){w.label=E[1],E=x;break}if(E&&w.label<E[2]){w.label=E[2],w.ops.push(x);break}E[2]&&w.ops.pop(),w.trys.pop();continue}x=y.call(f,w)}catch(B){x=[6,B],C=0}finally{T=E=0}if(5&x[0])throw x[1];return{value:x[0]?x[1]:void 0,done:!0}}},o=fo&&fo.__values||function(f){var y=typeof Symbol=="function"&&Symbol.iterator,T=y&&f[y],C=0;if(T)return T.call(f);if(f&&typeof f.length=="number")return{next:function(){return f&&C>=f.length&&(f=void 0),{value:f&&f[C++],done:!f}}};throw new TypeError(y?"Object is not iterable.":"Symbol.iterator is not defined.")},l=fo&&fo.__importDefault||function(f){return f&&f.__esModule?f:{default:f}};Object.defineProperty(e,"__esModule",{value:!0}),e.SimpleStateServiceProxy=void 0;var d=l(Rzt),h=[2e3,2e3,3e3,3e3,5e3],p=4321,g=function(){function f(y,T,C,E,I,w){var D;this.m_events=new $c.EventEmitter,this.m_clientId="",this.m_connectionState=ed.ConnectionState.Disconnected,this.m_handlers=new Map,this.m_connection=null,this.m_clientIds=new Set,this.m_initTimeoutDurationInMS=0,this.m_retryAttempts=0,this.m_sessionRetryAttempts=0,this.m_maxSessionRetries=0,this.m_outboundMessageInfo=new Map,this.m_initPromise={promise:null,resolve:null,reject:null},this.m_messageBuffer=[],this.m_batchWaitTimeMS=20,this.m_batchMessageTypeName="list",this.m_closeConnectionTimer=null,this.m_lastCloseCode=0,this.m_lastCloseReason="",this.m_offlineMessageCache=[],this.m_unacknowledgedMessages=new Map,this.m_sessionId=y,this.m_hashedSessionId=this.calculateHash(y),this.m_logger=E,this.m_connectionAliveTimeAfterLoseFocusInMS=I.websocketAliveTimeAfterLoseFocusInMS,this.m_useServiceGeneratedClientId=I.useServiceGeneratedClientId||!1,this.m_wsUrl="".concat(C,"?docId=").concat(this.m_sessionId,"&clientType=").concat(T),I.correlationId&&(this.m_wsUrl+="&cid=".concat(I.correlationId)),I.isAutomation&&(this.m_wsUrl+="&automation=true"),I.autoRoutingEnabled&&(this.m_wsUrl+="&routing=true"),this.m_useServiceGeneratedClientId||(this.m_clientId=I.customClientId||(0,UE.v4)(),this.m_wsUrl+="&clientId=".concat(this.m_clientId)),this.m_deltasBaseUrl=C.replace("wss://","https://").replace("ws://","http://"),this.setupSystemClientsCell(),this.setUpSystemCommandsCell(),this.setupServiceGeneratedClientIdCell(),this.m_useServiceGeneratedClientId&&(this.m_clientIdEvictingQueue=new P4t.EvictingQueue(20)),this.m_telemetry=new wzt.SimpleServiceTelemetry(this.m_clientId,this.m_sessionId,I.maxRoundtripRaw),this.m_verbose=I.verbose||!1,this.m_batchedRequestsEnabled=I.batchedRequestsEnabled,this.m_initTimeoutDurationInMS=I.initTimeoutDurationInMs||0,this.m_pingTimeoutInMs=I.pingTimeoutInMs,this.m_pongTimeoutInMs=I.pongTimeoutInMs,this.m_user=w,this.m_metadata=I.metadata,this.m_retryIntervalsInMs=I.retryIntervalsInMs||h,this.m_retryIntervalsInMs.sort(function(F,x){return F-x}),this.m_maxSessionRetries=I.maxSessionRetries,this.m_offlineMessageCacheEnabled=I.offlineMessageCacheEnabled,this.m_maxOfflineMessageCacheTimeInMs=I.maxOfflineMessageCacheTimeInMs,this.m_maxOfflineMessageCacheLength=I.maxOfflineMessageCacheLength,this.m_allowReconnectOnMessageSend=I.allowReconnectOnSendMessage||!1,this.m_unacknowledgedMaxTimeInMs=(D=I.unacknowledgeMessageTimeoutInMs)!==null&&D!==void 0?D:0,this.m_subscriptions=I.subscriptions,this.m_connectionSettings={getAuthTokenAsync:this.getAuthToken.bind(this),createSetupMessage:this.createSetupMessage.bind(this),metadata:this.m_metadata,subscriptions:this.m_subscriptions}}return Object.defineProperty(f.prototype,"lastCloseReason",{get:function(){return this.m_lastCloseReason},enumerable:!1,configurable:!0}),f.prototype.senderId=function(){return this.m_clientId},f.prototype.countOfOutboundMessagesNotRoundTrippedYet=function(){return this.m_outboundMessageInfo.size},f.prototype.canRetry=function(){return this.m_connectionState===ed.ConnectionState.Disconnected&&this.m_lastCloseCode!==p},f.prototype.getServiceTelemetry=function(){return this.m_telemetry.wsState=ed.ConnectionState[this.getConnectionState()],this.m_telemetry.messagePendingAckCount=this.m_outboundMessageInfo.size,this.m_telemetry},f.prototype.activeClientCount=function(){return this.m_clientIds.size},f.prototype.activeClientIds=function(){return this.m_clientIds},f.prototype.clientId=function(){return this.m_clientId},f.prototype.getConnectionState=function(){return this.m_connectionState},f.prototype.on=function(y,T){return this.m_events.on(y,T),this},f.prototype.connectAsync=function(){return i(this,void 0,void 0,function(){var y=this;return r(this,function(T){return this.m_initPromise.promise=new Promise(function(C,E){y.m_initPromise.resolve=C,y.m_initPromise.reject=E}),this.setConnectionState(ed.ConnectionState.Connecting),[2,new Promise(function(C,E){return i(y,void 0,void 0,function(){var I,w=this;return r(this,function(D){switch(D.label){case 0:return I=this,[4,kzt.StateServiceWebSocketConnection.CreateAsync(this.m_wsUrl,this.m_connectionSettings)];case 1:return I.m_connection=D.sent(),this.m_connection.onopen=function(){w.handleConnectionOpen(),w.startInitTimeoutTimerWithRetry(w.m_initTimeoutDurationInMS,w.m_initPromise.reject),C()},this.m_connection.onerror=function(F){var x;w.m_logger.sendTraceTag(590213388,ws.TraceLevel.Error,"SimpleStateServiceProxy::connect - ".concat((x=w.m_connection)===null||x===void 0?void 0:x.name," onerror. {hashedSessionId: ").concat(w.m_hashedSessionId,", ClientId: ").concat(w.m_clientId,", Error: ").concat(JSON.stringify(F),"}")),w.retryConnection(function(B){var L,z="failed to reconnect after ".concat((L=w.m_connection)===null||L===void 0?void 0:L.name," error: ").concat((0,VA.errorToString)(B));w.m_logger.sendTraceTag(579463185,ws.TraceLevel.Error,z),E(z)},!1,function(){return C()})},this.m_connection.onlog=function(F){var x;w.m_logger.sendTraceTag(556909603,F.detail.level,"SimpleStateServiceProxy::log - ".concat((x=w.m_connection)===null||x===void 0?void 0:x.name," {hashedSessionId: ").concat(w.m_hashedSessionId,", ClientId: ").concat(w.m_clientId,", Message: ").concat(F.detail.message,"}"))},this.m_connection.onclose=function(F){var x,B;w.m_logger.sendTraceTag(590213389,ws.TraceLevel.Error,"SimpleStateServiceProxy::connect - ".concat((x=w.m_connection)===null||x===void 0?void 0:x.name," onclose. {hashedSessionId: ").concat(w.m_hashedSessionId,", ClientId: ").concat(w.m_clientId,", Code: ").concat(F.code,", Reason: ").concat(F.reason,"}")),w.m_lastCloseCode=F.code,w.m_lastCloseReason=F.reason,F.code!==p?w.retryConnection(function(L){var z="failed to reconnect after service side disconnect: ".concat((0,VA.errorToString)(L));w.m_logger.sendTraceTag(579463186,ws.TraceLevel.Error,z),E(z)},!1,function(){return C()}):(w.setConnectionState(ed.ConnectionState.Disconnected),w.m_logger.sendTraceTag(588009741,ws.TraceLevel.Error,"SimpleStateServiceProxy::connect - ".concat((B=w.m_connection)===null||B===void 0?void 0:B.name," onclose. Not retryable close code. {hashedSessionId: ").concat(w.m_hashedSessionId,", ClientId: ").concat(w.m_clientId,"}")))},this.m_connection.onmessage=function(F){var x;try{w.handleConnectionMessage(F)}catch(B){w.m_logger.sendTraceTag(590213390,ws.TraceLevel.Error,"SimpleStateServiceProxy::onmessage - ".concat((x=w.m_connection)===null||x===void 0?void 0:x.name," error. {hashedSessionId: ").concat(w.m_hashedSessionId,", ClientId: ").concat(w.m_clientId,", Error: ").concat((0,VA.errorToString)(B),"}"))}},[2]}})})})]})})},f.prototype.close=function(){var y;this.m_logger.sendTraceTag(590213400,ws.TraceLevel.Info,"SimpleStateServiceProxy::close. {hashedSessionId: ".concat(this.m_hashedSessionId,", ClientId: ").concat(this.m_clientId,"}")),this.closeAndClearConnection(),this.m_retryTimer&&(clearTimeout(this.m_retryTimer),this.m_retryTimer=null),this.m_unacknowledgedMessages.clear(),this.clearPingPongTimer(),this.clearOfflineMessageCacheTimer(),this.clearInitTimeoutTimer(),this.clearUnacknowledgedTimer(),(y=this.m_clientIdEvictingQueue)===null||y===void 0||y.clear(),this.countOfOutboundMessagesNotRoundTrippedYet()!==0&&(this.m_events.emit("messageFailedToRoundTripOnClose",this.m_outboundMessageInfo.size),this.m_outboundMessageInfo.clear())},f.prototype.sendStateMessage=function(y){this.sendStateMessageImpl(y)},f.prototype.createMapAsync=function(y,T,C,E){return i(this,void 0,void 0,function(){var I;return r(this,function(w){return I=new S5e.SimpleSyncMap(y,this,T,C,E),this.m_handlers.set(y,I),[2,I]})})},f.prototype.getMapAsync=function(y){return i(this,void 0,void 0,function(){var T;return r(this,function(C){return(T=this.m_handlers.get(y))?[2,T]:[2,null]})})},f.prototype.waitMapAsync=function(y,T,C,E){return i(this,void 0,void 0,function(){var I;return r(this,function(w){switch(w.label){case 0:return[4,this.m_initPromise.promise];case 1:return w.sent(),[4,this.getMapAsync(y)];case 2:return(I=w.sent())?[3,4]:[4,this.createMapAsync(y,T,C,E)];case 3:I=w.sent(),w.label=4;case 4:return[2,I]}})})},f.prototype.createCellAsync=function(y,T,C,E){return i(this,void 0,void 0,function(){var I;return r(this,function(w){return I=new W6.SimpleSyncCell(y,this,T,C,E),this.m_handlers.set(y,I),[2,I]})})},f.prototype.getCellAsync=function(y){return i(this,void 0,void 0,function(){var T;return r(this,function(C){return(T=this.m_handlers.get(y))?[2,T]:[2,null]})})},f.prototype.waitCellAsync=function(y,T,C,E){return i(this,void 0,void 0,function(){var I;return r(this,function(w){switch(w.label){case 0:return this.m_logger.sendTraceTag(520161040,ws.TraceLevel.Info,"SimpleStateServiceProxy::waitCellAsync - awaiting initPromise ".concat(y)),[4,this.m_initPromise.promise];case 1:return w.sent(),this.m_logger.sendTraceTag(520161039,ws.TraceLevel.Info,"SimpleStateServiceProxy::waitCellAsync - getCellAsync ".concat(y)),[4,this.getCellAsync(y)];case 2:return(I=w.sent())?[3,4]:(this.m_logger.sendTraceTag(520161038,ws.TraceLevel.Info,"SimpleStateServiceProxy::waitCellAsync - createCellAsync ".concat(y)),[4,this.createCellAsync(y,T,C,E)]);case 3:I=w.sent(),w.label=4;case 4:return[2,I]}})})},f.prototype.onFocusChanged=function(y){var T=this;y?(window.clearTimeout(this.m_closeConnectionTimer),this.m_connection||(this.m_logger.sendTraceTag(590213392,ws.TraceLevel.Info,"SimpleStateServiceProxy::onFocusChanged - retryConnection due to getting focus again. {hashedSessionId: ".concat(this.m_hashedSessionId,", ClientId: ").concat(this.m_clientId,"}")),this.retryConnection(function(C){T.m_logger.sendTraceTag(579463187,ws.TraceLevel.Error,"failed to reconnect after regaining focus: ".concat((0,VA.errorToString)(C)))},!0))):this.m_closeConnectionTimer=window.setTimeout(function(){var C;T.m_connection&&(T.m_logger.sendTraceTag(590213391,ws.TraceLevel.Info,"SimpleStateServiceProxy::onFocusChanged - ".concat((C=T.m_connection)===null||C===void 0?void 0:C.name," close due to losing focus. {hashedSessionId: ").concat(T.m_hashedSessionId,", ClientId: ").concat(T.m_clientId,"}")),T.m_connection.onclose=function(){},T.m_connection.close(),T.m_connection=null)},this.m_connectionAliveTimeAfterLoseFocusInMS)},f.prototype.getHistoryAsync=function(y,T){return i(this,void 0,void 0,function(){var C,E;return r(this,function(I){switch(I.label){case 0:return(C=new URL(this.m_deltasBaseUrl)).searchParams.append("action","deltas"),C.searchParams.append("docId",this.m_sessionId),C.searchParams.append("cid",this.m_clientId),C.searchParams.append("objectId",y),T&&C.searchParams.append("property",T),[4,d.default.get(C.toString())];case 1:return(E=I.sent().data).forEach(function(w){return w.value=JSON.parse(w.value)}),[2,E]}})})},f.prototype.getHistoryWithPaginationAsync=function(y,T,C){return i(this,void 0,void 0,function(){var E,I;return r(this,function(w){switch(w.label){case 0:return(E=new URL(this.m_deltasBaseUrl)).searchParams.append("action","deltas"),E.searchParams.append("docId",this.m_sessionId),E.searchParams.append("cid",this.m_clientId),E.searchParams.append("objectId",y),E.searchParams.append("pagination","true"),C&&E.searchParams.append("cursor",C),T&&E.searchParams.append("property",T),[4,d.default.get(E.toString())];case 1:return(I=w.sent().data).messages.forEach(function(D){return D.value=JSON.parse(D.value)}),[2,I]}})})},f.prototype.setupSystemClientsCell=function(){var y=this;this.m_clientsCell=new W6.SimpleSyncCell("systemClients",this),this.m_handlers.set(this.m_clientsCell.id(),this.m_clientsCell),this.m_clientsCell.on("valueChanged",function(T){y.m_clientIds=new Set(T),y.m_events.emit("activeClientCountChanged")})},f.prototype.setUpSystemCommandsCell=function(){var y=this;this.m_systemCommandsCell=new W6.SimpleSyncCell(ed.SystemCommandsStateName,this),this.m_handlers.set(this.m_systemCommandsCell.id(),this.m_systemCommandsCell),this.m_systemCommandsCell.on("valueChanged",function(T){return i(y,void 0,void 0,function(){var C,E,I;return r(this,function(w){switch(w.label){case 0:return T==="refreshToken"?[3,1]:[3,6];case 1:if(!this.m_user||!this.m_user.getForceRefreshedTokenAsync)return[3,5];w.label=2;case 2:return w.trys.push([2,4,,5]),[4,this.m_user.getForceRefreshedTokenAsync()];case 3:return C=w.sent(),E={},C&&(E.authorization=C.token,E.authProvider=C.authProvider,E.mri=C.mri||"",E.huid=C.hashedUserEmail||""),this.sendConfigMessage(E),[3,5];case 4:return I=w.sent(),this.m_logger.sendTraceTag(574107847,ws.TraceLevel.Error,"Error getting force refreshed auth token: ".concat((0,VA.errorToString)(I))),[3,5];case 5:return[3,7];case 6:return this.m_logger.sendTraceTag(574107848,ws.TraceLevel.Error,"Unknown system command cell value: ".concat(T)),[3,7];case 7:return[2]}})})})},f.prototype.setupServiceGeneratedClientIdCell=function(){var y=this;this.m_serviceGeneratedClientIdCell=new W6.SimpleSyncCell(ed.ServiceGeneratedClientIdName,this),this.m_handlers.set(this.m_serviceGeneratedClientIdCell.id(),this.m_serviceGeneratedClientIdCell),this.m_serviceGeneratedClientIdCell.on("valueChanged",function(T){y.m_logger.sendTraceTag(520161037,ws.TraceLevel.Info,"SimpleStateServiceProxy::serviceGeneratedClientId changed to ".concat(T,"}")),y.setClientId(T,!0),y.processClientIdQueue(),y.m_useServiceGeneratedClientId&&(y.processOfflineMessageCache(!0),y.clearOfflineMessageCacheTimer())}),this.m_logger.sendTraceTag(509743689,ws.TraceLevel.Info,"SimpleStateServiceProxy::setupServiceGeneratedClientIdCell completed.")},f.prototype.handleConnectionOpen=function(){var y;this.m_logger.sendTraceTag(590213387,ws.TraceLevel.Info,"SimpleStateServiceProxy::connect - ".concat((y=this.m_connection)===null||y===void 0?void 0:y.name," onopen. {hashedSessionId: ").concat(this.m_hashedSessionId,", ClientId: ").concat(this.m_clientId,"}")),this.m_retryAttempts=0,this.setConnectionState(ed.ConnectionState.Connected),this.startPingTimer(),this.m_useServiceGeneratedClientId||(this.processOfflineMessageCache(!1),this.clearOfflineMessageCacheTimer())},f.prototype.setConnectionState=function(y){this.m_connectionState!==y&&(this.m_connectionState=y,y===ed.ConnectionState.Disconnected&&this.m_useServiceGeneratedClientId&&this.setClientId("",!1),this.m_events.emit("connectionStateChanged"))},f.prototype.setClientId=function(y,T){this.m_clientId!==y&&(this.m_clientId=y,T&&this.m_events.emit("clientIdChanged"))},f.prototype.processClientIdQueue=function(){var y=this;this.m_clientIdEvictingQueue&&this.m_clientIdEvictingQueue.forEach(function(T){T.senderId=y.m_clientId,y.sendConnectionMessage(T,!0)})},f.prototype.sendGetInitialSystemStateMessages=function(){try{var y={messageId:(0,UE.v4)(),senderId:this.senderId(),objectId:ed.SystemSessionStateName,type:"",operation:"get",value:""};this.sendStateMessage(y);var T={messageId:(0,UE.v4)(),senderId:this.senderId(),objectId:ed.ServiceGeneratedClientIdName,type:"",operation:"get",value:""};this.sendStateMessage(T),this.m_logger.sendTraceTag(509141838,ws.TraceLevel.Info,"SimpleStateServiceProxy::sendGetInitialSystemStateMessages - sent messages.")}catch(C){this.m_logger.sendTraceTag(509141837,ws.TraceLevel.Error,"SimpleStateServiceProxy::sendGetInitialSystemStateMessages - caught error ".concat(C))}},f.prototype.createSetupMessage=function(y){var T=y.authToken,C=y.metadata,E=y.subscriptions,I=[];if(T||C){var w={};T&&(w.authorization=T.token,w.authProvider=T.authProvider,w.mri=T.mri||"",w.huid=T.hashedUserEmail||""),C&&(w.metadata=JSON.stringify(C));var D={messageId:(0,UE.v4)(),senderId:this.senderId(),objectId:ed.ConfigurationName,type:"",operation:"",value:JSON.stringify(w)};I.push(JSON.stringify(D))}return E&&(D={messageId:(0,UE.v4)(),senderId:this.senderId(),objectId:ed.StateSubscriptionsName,type:"",operation:"",value:JSON.stringify(E)},I.push(JSON.stringify(D))),I},f.prototype.sendConfigMessage=function(y){var T={messageId:(0,UE.v4)(),senderId:this.senderId(),objectId:ed.ConfigurationName,type:"",operation:"",value:JSON.stringify(y)};this.sendStateMessage(T)},f.prototype.retryConnection=function(y,T,C){var E=this;if(this.clearPingPongTimer(),this.clearInitTimeoutTimer(),this.m_retryAttempts>=this.m_retryIntervalsInMs.length||this.m_sessionRetryAttempts>=this.m_maxSessionRetries)return this.setConnectionState(ed.ConnectionState.Disconnected),this.m_logger.sendTraceTag(590213393,ws.TraceLevel.Error,"SimpleStateServiceProxy::retryConnection reached max retry attempts. {hashedSessionId: ".concat(this.m_hashedSessionId,", ClientId: ").concat(this.m_clientId,"}")),void(y&&y(new Error("reached max retry attempts")));if(this.setConnectionState(ed.ConnectionState.Connecting),T||this.m_connection&&!this.m_retryTimer){var I=this.m_retryIntervalsInMs[this.m_retryAttempts];this.m_retryAttempts+=1,this.m_sessionRetryAttempts+=1,this.m_telemetry.wsReconnectCount+=1,this.closeAndClearConnection(),this.m_retryTimer=setTimeout(function(){return i(E,void 0,void 0,function(){var w;return r(this,function(D){switch(D.label){case 0:this.m_logger.sendTraceTag(590213395,ws.TraceLevel.Info,"SimpleStateServiceProxy::retryConnection. {hashedSessionId: ".concat(this.m_hashedSessionId,", ClientId: ").concat(this.m_clientId,"}")),this.m_retryTimer=null,D.label=1;case 1:return D.trys.push([1,3,,4]),[4,this.connectAsync()];case 2:return D.sent(),C&&C(),[3,4];case 3:return w=D.sent(),this.setConnectionState(ed.ConnectionState.Disconnected),this.m_logger.sendTraceTag(590213396,ws.TraceLevel.Error,"SimpleStateServiceProxy::retryConnection failed. {hashedSessionId: ".concat(this.m_hashedSessionId,", ClientId: ").concat(this.m_clientId,"}, ").concat((0,VA.errorToString)(w))),this.m_retryAttempts>=this.m_retryIntervalsInMs.length&&y(w),[3,4];case 4:return[2]}})})},I)}else this.m_logger.sendTraceTag(590213394,ws.TraceLevel.Info,"SimpleStateServiceProxy::retryConnection skipped. {hashedSessionId: ".concat(this.m_hashedSessionId,", ClientId: ").concat(this.m_clientId,", NullConnection: ").concat(this.m_connection===null,", NullRetryTimer: ").concat(this.m_retryTimer===null,"}"))},f.prototype.startPingTimer=function(){var y=this;this.m_connection&&this.m_connection.shouldSendPings&&(this.m_pingTimeoutInMs<=0||this.m_pongTimeoutInMs<=0||(this.clearPingPongTimer(),this.m_pingTimer=setTimeout(function(){return i(y,void 0,void 0,function(){return r(this,function(T){return this.sendPingMessage(),this.m_pingTimer=null,[2]})})},this.m_pingTimeoutInMs)))},f.prototype.sendPingMessage=function(){var y=this;this.m_connection&&(this.m_connection.isOpen?(this.m_verbose&&this.m_logger.sendTraceTag(559952470,ws.TraceLevel.Info,"SimpleStateServiceProxy::sendPingMessage. {hashedSessionId: ".concat(this.m_hashedSessionId,", ClientId: ").concat(this.m_clientId,", __ping__")),this.m_connection.send("__ping__"),this.clearPongTimer(),this.m_pongTimer=setTimeout(function(){return i(y,void 0,void 0,function(){var T=this;return r(this,function(C){return this.retryConnection(function(E){T.m_logger.sendTraceTag(579463188,ws.TraceLevel.Error,"failed to reconnect after missing ping: ".concat((0,VA.errorToString)(E)))},!1),this.m_pongTimer=null,[2]})})},this.m_pongTimeoutInMs)):(this.retryConnection(function(T){y.m_logger.sendTraceTag(579463189,ws.TraceLevel.Error,"failed to reconnect after closed connection: ".concat((0,VA.errorToString)(T)))},!1),this.clearPongTimer()))},f.prototype.clearPingPongTimer=function(){this.clearPingTimer(),this.clearPongTimer()},f.prototype.clearPingTimer=function(){this.m_pingTimer&&(clearTimeout(this.m_pingTimer),this.m_pingTimer=null)},f.prototype.clearPongTimer=function(){this.m_pongTimer&&(clearTimeout(this.m_pongTimer),this.m_pongTimer=null)},f.prototype.handleConnectionMessage=function(y){if(typeof y.data=="string"){if(this.startPingTimer(),y.data==="__pong__")return void(this.m_verbose&&this.m_logger.sendTraceTag(559952471,ws.TraceLevel.Info,"SimpleStateServiceProxy::handleConnectionMessage. {hashedSessionId: ".concat(this.m_hashedSessionId,", ClientId: ").concat(this.m_clientId,", __pong__")));var T=Date.now();try{var C=JSON.parse(y.data);Array.isArray(C)&&C.length>0?this.handleAggregatedStateMessages(C):this.handleStateMessage(C),this.m_telemetry.addMessageHandleLatency(Date.now()-T),C.objectId===ed.SystemSessionStateName?(this.m_logger.sendTraceTag(520161036,ws.TraceLevel.Info,"SimpleStateServiceProxy::handleConnectionMessage - systemSessionState - initPromise resolved."),this.m_initPromise.resolve(),this.clearInitTimeoutTimer()):C.objectId===ed.ServiceGeneratedClientIdName&&this.m_logger.sendTraceTag(509743688,ws.TraceLevel.Info,"SimpleStateServiceProxy::handleConnectionMessage - serviceGeneratedClientId received.")}catch(E){this.m_logger.sendTraceTag(578102302,ws.TraceLevel.Error,"handleConnectionMessage: ".concat((0,VA.errorToString)(E)))}}else this.m_logger.sendTraceTag(590213397,ws.TraceLevel.Error,"SimpleStateServiceProxy::handleConnectionMessage - Unknown data type. {hashedSessionId: ".concat(this.m_hashedSessionId,", ClientId: ").concat(this.m_clientId,", Type: ").concat(typeof y.data,"}"))},f.prototype.handleAggregatedStateMessages=function(y){var T,C,E=this;if(y&&y.length!==0){var I=y.map(function(B){return JSON.parse(B)}),w={};I.forEach(function(B){return w[B.objectId]=1+(w[B.objectId]||0)}),Object.keys(w).forEach(function(B){if(w[B]>1){var L=E.m_handlers.get(B);L&&L.beginAggregatedStateUpdating&&L.beginAggregatedStateUpdating()}});try{for(var D=o(I),F=D.next();!F.done;F=D.next()){var x=F.value;this.handleStateMessage(x)}}catch(B){T={error:B}}finally{try{F&&!F.done&&(C=D.return)&&C.call(D)}finally{if(T)throw T.error}}Object.keys(w).forEach(function(B){if(w[B]>1){var L=E.m_handlers.get(B);L&&L.endAggregatedStateUpdating&&L.endAggregatedStateUpdating()}})}},f.prototype.handleStateMessage=function(y){var T=this;if(this.m_verbose&&this.m_logger.sendTraceTag(590213398,ws.TraceLevel.Info,"SimpleStateServiceProxy::handleStateMessage. {hashedSessionId: ".concat(this.m_hashedSessionId,", ClientId: ").concat(this.m_clientId,", ObjectId: ").concat(y.objectId,", MessageId: ").concat(y.messageId,"}")),y.type==="list")JSON.parse(y.value).forEach(function(E){T.handleStateMessage(E)});else{if(this.m_user&&this.m_user.validateMessage&&!this.m_user.validateMessage(y))return void this.m_logger.sendTraceTag(588009742,ws.TraceLevel.Error,"SimpleStateServiceProxy::handleStateMessage rejected message: {hashedSessionId: ".concat(this.m_hashedSessionId,", ClientId: ").concat(this.m_clientId,", ObjectId: ").concat(y.objectId,", MessageId: ").concat(y.messageId,"}"));var C=this.getHandlerForMessage(y);if(y.senderId===this.senderId()&&(this.acknowledgeMessage(y,C),this.m_telemetry.incrementAcknowledgedCount(y.objectId)),this.measureMessageRoundTripLatency(y),this.m_telemetry.incrementReceivedCount(y.objectId),C)return void C.handleStateMessage(y)}},f.prototype.getAuthToken=function(){return i(this,void 0,void 0,function(){var y,T;return r(this,function(C){switch(C.label){case 0:if(!this.m_user||!this.m_user.getAuthTokenAsync)return[3,4];C.label=1;case 1:return C.trys.push([1,3,,4]),[4,this.m_user.getAuthTokenAsync()];case 2:return y=C.sent(),[3,4];case 3:return T=C.sent(),this.m_logger.sendTraceTag(578102469,ws.TraceLevel.Error,"Error getting auth token: ".concat((0,VA.errorToString)(T))),[3,4];case 4:return[2,y]}})})},f.prototype.getHandlerForMessage=function(y){var T=this.m_handlers.get(y.objectId);return T||(y.type==="cell"?T=new W6.SimpleSyncCell(y.objectId,this):y.type==="map"?T=new S5e.SimpleSyncMap(y.objectId,this):this.m_logger.sendTraceTag(559204164,ws.TraceLevel.Error,"SimpleStateServiceProxy::handleStateMessage - Unknown message type. {hashedSessionId: ".concat(this.m_hashedSessionId,", ClientId: ").concat(this.m_clientId,", Type: ").concat(y.type,"}")),T&&this.m_handlers.set(y.objectId,T),T)},f.prototype.sendStateMessageImpl=function(y){var T,C=this;if(this.m_verbose&&this.m_logger.sendTraceTag(590213403,ws.TraceLevel.Info,"SimpleStateServiceProxy::sendStateMessageImpl. {hashedSessionId: ".concat(this.m_hashedSessionId,", ClientId: ").concat(this.m_clientId,", ObjectId: ").concat(y.objectId,", MessageId: ").concat(y.messageId,"}")),y.objectId!==ed.StateSubscriptionsName&&y.objectId!==ed.ConfigurationName){if(this.m_outboundMessageInfo.set(y.messageId,Date.now()),this.m_telemetry.incrementRequestedCount(y.objectId),this.m_unacknowledgedMaxTimeInMs>0){var E=(T=this.getHandlerForMessage(y))===null||T===void 0?void 0:T.messageTrackingOption();if(E&&E!==ed.MessageTrackingOption.None){var I=this.getUnacknowledgedMessagesMapKey(y,E);this.m_unacknowledgedMessages.set(I,{message:y,timestamp:Date.now()}),this.startUnacknowledgeMessageTimer()}}if(this.m_useServiceGeneratedClientId&&this.m_clientIdEvictingQueue&&!this.m_clientId&&y.operation!=="get")return this.m_logger.sendTraceTag(508348254,ws.TraceLevel.Info,"SimpleStateServiceProxy::enqueueMessage ".concat(JSON.stringify(y))),void this.m_clientIdEvictingQueue.enqueue(y)}this.m_user&&this.m_user.patchMessage&&this.m_user.patchMessage(y),this.m_batchedRequestsEnabled?(this.m_messageBuffer.push(y),this.m_processBufferTimer||(this.m_processBufferTimer=setTimeout(function(){C.processMessageBuffer()},this.m_batchWaitTimeMS))):this.sendConnectionMessage(y,!0)},f.prototype.createListMessage=function(y){if(y.length!==0)return y.length===1?y[0]:{value:JSON.stringify(y),type:this.m_batchMessageTypeName,operation:"",messageId:(0,UE.v4)(),objectId:"batch",senderId:this.senderId()}},f.prototype.processMessageBuffer=function(){var y=this.m_messageBuffer.length,T=this.m_messageBuffer.splice(0,y),C=this.createListMessage(T);this.m_processBufferTimer&&clearTimeout(this.m_processBufferTimer),this.m_processBufferTimer=null,C&&this.sendConnectionMessage(C,!0)},f.prototype.processOfflineMessageCache=function(y){var T=this;this.m_offlineMessageCacheEnabled&&(this.m_offlineMessageCache.forEach(function(C){y&&(C.message.senderId=T.m_clientId),T.sendConnectionMessage(C.message,!1),T.m_telemetry.offlineCacheTelemetry.resentCount+=1}),this.m_offlineMessageCache=[])},f.prototype.purgeOfflineMessageCache=function(){var y=this;if(this.m_offlineMessageCacheEnabled&&this.m_maxOfflineMessageCacheTimeInMs){var T=Date.now(),C=this.m_offlineMessageCache.filter(function(E){return y.m_maxOfflineMessageCacheTimeInMs&&E.timestamp+y.m_maxOfflineMessageCacheTimeInMs>=T});this.m_telemetry.offlineCacheTelemetry.expiredCount+=this.m_offlineMessageCache.length-C.length,this.m_offlineMessageCache=C,this.m_offlineMessageCache.length===0&&this.clearOfflineMessageCacheTimer()}},f.prototype.clearOfflineMessageCacheTimer=function(){this.m_offlineMessageCacheEnabled&&this.m_offlineMessageCacheTimer&&(clearInterval(this.m_offlineMessageCacheTimer),this.m_offlineMessageCacheTimer=null)},f.prototype.getUnacknowledgedMessagesMapKey=function(y,T){return T===ed.MessageTrackingOption.None?"":T===ed.MessageTrackingOption.All?y.messageId:y.objectId},f.prototype.startUnacknowledgeMessageTimer=function(){var y=this;this.m_unacknowledgedMaxTimeInMs>0&&!this.m_unacknowledgedTimer&&(this.m_unacknowledgedTimer=setInterval(function(){y.notifyUnacknowledgedMessages(),y.m_unacknowledgedMessages.size<=0&&y.clearUnacknowledgedTimer()},this.m_unacknowledgedMaxTimeInMs/2))},f.prototype.acknowledgeMessage=function(y,T){if(y.senderId===this.senderId()&&T&&!(this.m_unacknowledgedMessages.size<=0)){var C=this.getUnacknowledgedMessagesMapKey(y,T.messageTrackingOption()),E=this.m_unacknowledgedMessages.get(C);E&&y.messageId===E.message.messageId&&this.m_unacknowledgedMessages.delete(C)}},f.prototype.notifyUnacknowledgedMessages=function(){var y=this,T=Date.now();this.m_unacknowledgedMessages.forEach(function(C,E){if(C.timestamp+y.m_unacknowledgedMaxTimeInMs<T){var I=y.getHandlerForMessage(C.message);I?.handleUnacknowledgedMessage(C.message),y.m_unacknowledgedMessages.delete(E),y.m_telemetry.unacknowledgedMessagesCount+=1}})},f.prototype.clearUnacknowledgedTimer=function(){this.m_unacknowledgedTimer&&(clearInterval(this.m_unacknowledgedTimer),this.m_unacknowledgedTimer=null)},f.prototype.startInitTimeoutTimerWithRetry=function(y,T){var C=this;this.startInitTimeoutTimer(y,function(){C.m_logger.sendTraceTag(509141836,ws.TraceLevel.Error,"SimpleStateServiceProxy::startInitTimeoutTimer - failed to init after ".concat(y," ms; requesting get messages and retrying")),C.sendGetInitialSystemStateMessages(),C.startInitTimeoutTimer(y,T)})},f.prototype.startInitTimeoutTimer=function(y,T){y>0&&(this.clearInitTimeoutTimer(),this.m_initTimeoutTimer=setTimeout(function(){T("Initialization timed out after ".concat(y," ms"))},y))},f.prototype.clearInitTimeoutTimer=function(){this.m_initTimeoutTimer&&clearTimeout(this.m_initTimeoutTimer)},f.prototype.sendConnectionMessage=function(y,T){var C,E,I=this;if(this.m_allowReconnectOnMessageSend&&this.m_connectionState===ed.ConnectionState.Disconnected&&(this.updateRetryAttempts(),this.retryConnection(function(w){I.m_logger.sendTraceTag(559428289,ws.TraceLevel.Error,"SimpleStateServiceProxy::sendConnectionMessage - failed to reconnect with error: ".concat((0,VA.errorToString)(w)," "))},!1)),this.m_offlineMessageCacheEnabled&&T){if(!this.m_connection||this.m_connectionState!==ed.ConnectionState.Connected)return!this.m_maxOfflineMessageCacheLength||this.m_offlineMessageCache.length>=this.m_maxOfflineMessageCacheLength?(this.m_telemetry.offlineCacheTelemetry.rejectedCount+=1,void this.m_logger.sendTraceTag(570807006,ws.TraceLevel.Error,"SimpleStateServiceProxy::sendConnectionMessage - Dropping message because offline cache is full. {hashedSessionId: ".concat(this.m_hashedSessionId,", ClientId: ").concat(this.m_clientId,", Status: ").concat((C=this.m_connection)===null||C===void 0?void 0:C.readyState,"}"))):(!this.m_offlineMessageCacheTimer&&this.m_maxOfflineMessageCacheTimeInMs&&(this.m_offlineMessageCacheTimer=setInterval(function(){I.purgeOfflineMessageCache()},this.m_maxOfflineMessageCacheTimeInMs/2)),this.m_offlineMessageCache.push({message:y,timestamp:Date.now()}),void(this.m_telemetry.offlineCacheTelemetry.cachedCount+=1))}else{if(!this.m_connection)return void this.m_logger.sendTraceTag(590213401,ws.TraceLevel.Error,"SimpleStateServiceProxy::sendConnectionMessage - connection is not set. {hashedSessionId: ".concat(this.m_hashedSessionId,", ClientId: ").concat(this.m_clientId,"}"));if(!this.m_connection.isOpen)return void this.m_logger.sendTraceTag(590213402,ws.TraceLevel.Error,"SimpleStateServiceProxy::sendConnectionMessage - ".concat(this.m_connection.name," status is not open. {hashedSessionId: ").concat(this.m_hashedSessionId,", ClientId: ").concat(this.m_clientId,", Status: ").concat(this.m_connection.readyState,"}"))}(E=this.m_connection)===null||E===void 0||E.send(JSON.stringify(y))},f.prototype.closeAndClearConnection=function(){if(this.m_connection){if(this.m_connection.onclose=function(){},this.m_connection.isOpen)this.m_connection.close();else{var y=this.m_connection;y.onopen=function(){return y.close()}}this.m_connection=null}},f.prototype.updateRetryAttempts=function(){this.m_retryAttempts>=this.m_retryIntervalsInMs.length&&(this.m_retryAttempts=0),this.m_sessionRetryAttempts>=this.m_maxSessionRetries&&(this.m_sessionRetryAttempts=0)},f.prototype.measureMessageRoundTripLatency=function(y){if(y.senderId===this.senderId())try{var T=this.m_outboundMessageInfo.get(y.messageId);if(T!==void 0){this.m_outboundMessageInfo.delete(y.messageId);var C=Date.now()-T;this.m_events.emit("messageRoundTripped",{clientId:this.m_clientId,sessionId:this.m_sessionId,messageId:y.messageId,objectId:y.objectId,operation:y.operation,latencyInMs:C}),this.m_telemetry.addRoundtripLatency(C)}else this.m_verbose&&this.m_logger.sendTraceTag(590213404,ws.TraceLevel.Info,"SimpleStateServiceProxy::measureMessageRoundTripLatency. Failed to find outbound message info for {hashedSessionId: ".concat(this.m_hashedSessionId,", ClientId: ").concat(this.m_clientId,", ObjectId: ").concat(y.objectId,", MessageId: ").concat(y.messageId,"}"))}catch(E){this.m_logger.sendTraceTag(590213405,ws.TraceLevel.Error,"SimpleStateServiceProxy::measureMessageRoundTripLatency - Exception thrown error. {hashedSessionId: ".concat(this.m_hashedSessionId,", ClientId: ").concat(this.m_clientId,", MessageId: ").concat(y.messageId,", Error: ").concat(E.message,"}"))}},f.prototype.calculateHash=function(y){return y?"".concat(new R5e.sha256().update(y).digest("hex")):""},f}();e.SimpleStateServiceProxy=g}),Pzt=bs(function(t,e){var i=fo&&fo.__awaiter||function(l,d,h,p){function g(f){return f instanceof h?f:new h(function(y){y(f)})}return new(h||(h=Promise))(function(f,y){function T(I){try{E(p.next(I))}catch(w){y(w)}}function C(I){try{E(p.throw(I))}catch(w){y(w)}}function E(I){I.done?f(I.value):g(I.value).then(T,C)}E((p=p.apply(l,d||[])).next())})},r=fo&&fo.__generator||function(l,d){var h,p,g,f,y={label:0,sent:function(){if(1&g[0])throw g[1];return g[1]},trys:[],ops:[]};return f={next:T(0),throw:T(1),return:T(2)},typeof Symbol=="function"&&(f[Symbol.iterator]=function(){return this}),f;function T(E){return function(I){return C([E,I])}}function C(E){if(h)throw new TypeError("Generator is already executing.");for(;f&&(f=0,E[0]&&(y=0)),y;)try{if(h=1,p&&(g=2&E[0]?p.return:E[0]?p.throw||((g=p.return)&&g.call(p),0):p.next)&&!(g=g.call(p,E[1])).done)return g;switch(p=0,g&&(E=[2&E[0],g.value]),E[0]){case 0:case 1:g=E;break;case 4:return y.label++,{value:E[1],done:!1};case 5:y.label++,p=E[1],E=[0];continue;case 7:E=y.ops.pop(),y.trys.pop();continue;default:if(g=y.trys,!((g=g.length>0&&g[g.length-1])||E[0]!==6&&E[0]!==2)){y=0;continue}if(E[0]===3&&(!g||E[1]>g[0]&&E[1]<g[3])){y.label=E[1];break}if(E[0]===6&&y.label<g[1]){y.label=g[1],g=E;break}if(g&&y.label<g[2]){y.label=g[2],y.ops.push(E);break}g[2]&&y.ops.pop(),y.trys.pop();continue}E=d.call(l,y)}catch(I){E=[6,I],p=0}finally{h=g=0}if(5&E[0])throw E[1];return{value:E[0]?E[1]:void 0,done:!0}}};function o(l,d,h,p,g,f){return i(this,void 0,void 0,function(){var y;return r(this,function(T){switch(T.label){case 0:return[4,(y=new Mzt.SimpleStateServiceProxy(l,d,h,p,g,f)).connectAsync()];case 1:return T.sent(),[2,y]}})})}Object.defineProperty(e,"__esModule",{value:!0}),e.createStateServiceProxyAsync=void 0,e.createStateServiceProxyAsync=o}),Vpe=bs(function(t,e){var i=fo&&fo.__createBinding||(Object.create?function(o,l,d,h){h===void 0&&(h=d);var p=Object.getOwnPropertyDescriptor(l,d);p&&!("get"in p?!l.__esModule:p.writable||p.configurable)||(p={enumerable:!0,get:function(){return l[d]}}),Object.defineProperty(o,h,p)}:function(o,l,d,h){h===void 0&&(h=d),o[h]=l[d]}),r=fo&&fo.__exportStar||function(o,l){for(var d in o)d==="default"||Object.prototype.hasOwnProperty.call(l,d)||i(l,o,d)};Object.defineProperty(e,"__esModule",{value:!0}),r(ws,e),r(ed,e),r(Pzt,e)});class Dzt{constructor(e){this.enableConsoleLog=wt().calling.reaction.enableStateServiceConsoleLogs,this._logger=e}sendTraceTag(e,i,r){this.enableConsoleLog&&this._logger.info(`Tag: ${e}, Leve: ${i}, Message: ${r}`)}}class Lzt extends Bu{constructor(e){super(e),this._impl=new Ozt(this.eventEmitter),this._isReactionFeatureEnabled=wt().calling.reaction.enabled,this._callInfo=e.callInfo}get name(){return"Reaction"}initialize(e,i){this._tsCall=e.tsCall,this._logger=i,this._telemetryLogManager=e.telemetryLogManager,this._logger.info(`Meeting Reaction feature enable flag: ${this._isReactionFeatureEnabled}`),this._isReactionFeatureEnabled&&e.tsCall.state===3?this._impl.initialize(e.tsCall,e.callAgent,e.call,e.telemetryLogManager,i,this._callInfo):e.tsCall.on("callStateChanged",()=>{this._isReactionFeatureEnabled&&e.tsCall.state===3?this._impl.initialize(e.tsCall,e.callAgent,e.call,e.telemetryLogManager,i,this._callInfo):this._logger.warn("Calls to reaction APIs will perform no action or return default values where applicable")})}async sendReaction(e){let i=ln();if(this._sendFeatureUsage("sendReaction",Je.attempt,void 0,i),this._tsCall.state!=3||this.callInfo.context===To.TwoParty){const r=new Oe({defaultError:this._tsCall.state!=3?we.FEATURES.REACTION.CALL_NOT_CONNECTED:we.FEATURES.REACTION.NOT_SUPPORTED_1TO1_CTE});throw this._sendFeatureUsage("sendReaction",Je.failure,r,i),r}await this._impl.sendReaction(e,i)}on(e,i){if(e!=="reaction")throw new Oe({defaultError:we.FEATURES.REACTION.EVENT_SUBSCRIBE,defaultErrorMessageArgs:[e]});if(!this._isReactionFeatureEnabled){const r=new Oe({defaultError:we.FEATURES.REACTION.EVENT_SUBSCRIBE_FAIL_POLICY});throw this._sendFeatureUsage("receiveReaction",Je.failure,r),r}this._sendFeatureUsage("receiveReaction",Je.subscribe),this._impl.on(e,i)}off(e,i){if(e!=="reaction")throw new Oe({defaultError:we.FEATURES.REACTION.EVENT_UNSUBSCRIBE,defaultErrorMessageArgs:[e]});if(!this._isReactionFeatureEnabled){const r=new Oe({defaultError:we.FEATURES.REACTION.EVENT_UNSUBSCRIBE_FAIL_POLICY});throw this._sendFeatureUsage("receiveReaction",Je.failure,r),r}this._sendFeatureUsage("receiveReaction",Je.unsubscribe),this._impl.off(e,i)}dispose(){this.disposed||(this._impl.dispose(),super.dispose())}_sendFeatureUsage(e,i,r,o){let l=r?{code:r?.code||jL,subCode:r?.subCode||0,failureReason:r?.message||"",...an(r)}:void 0;Pc({correlationId:o,callId:this._tsCall.callId,localParticipantId:this._tsCall.participantId,featureName:this.name,featureType:"Call",initializationType:"OnFeatureAccess",featureDetails:{name:e,step:i},additionalDetails:l},this._telemetryLogManager,this._logger)}}class Ozt{constructor(e){this._wsUrl="",this.name="Reaction",this.capabilityChangeHandler=i=>{i.newValue.useReactions&&(this._participantCapability=this._call.getParticipantCapabilities().useReactions,this._logger.log(`participant capabilitity to useReactions feature is ${this._participantCapability}`))},this._eventEmitter=e,this._participantCapability={isPresent:!0,reason:"Capable"},this._isReactionFeatureEnabled=wt().calling.reaction.enabled}initialize(e,i,r,o,l,d){this._proxy===void 0||this._proxy?.getConnectionState()===Vpe.ConnectionState.Disconnected?(this._logger=l.createChild(()=>`ReactionImplOverStateService::Call(id='${this._tsCall.callId}')`),this._internalCallAgent=i,this._tsCall=e,this._call=r,this._callInfo=d,this._docId=this._tsCall.callId,this._wsUrl=this.getEndpointUrl(),this._telemetryLogManager=o,this._sendAttempOrFailureFeatureUsage("initialize",Je.attempt),this.start()):l.info("State Service Proxy already has an active connection."),this._callInfo.context==To.TeamsMeeting&&(this._participantCapability=this._call.getParticipantCapabilities().useReactions,this._logger.log(`participant capabilitity to useReactions feature is ${this._participantCapability}`),this._call.onParticipantCapabilitiesChanged("capabilitiesChanged",this.capabilityChangeHandler),this._logger.log("participant capabilities change event listener registered"))}async start(){const e=wt().calling.reaction.StateServiceProxySettings,i=gxt,r={getAuthTokenAsync:this.getAuthToken.bind(this)};try{this._proxy=await Vpe.createStateServiceProxyAsync(this._docId,i,this._wsUrl,new Dzt(this._logger),e,r)}catch(o){return this._logger.error("Could not create state service proxy",o),void this._sendAttempOrFailureFeatureUsage("initialize",Je.failure,new Oe({defaultError:we.FEATURES.REACTION.STATE_SERVICE_CONNECT_FAIL,originalError:o}))}try{this._reactionsMap=await this._proxy.createMapAsync("reactions",!0)}catch(o){return this._logger.error("Could not create state service proxy reaction map",o),void this._sendAttempOrFailureFeatureUsage("initialize",Je.failure,new Oe({defaultError:we.FEATURES.REACTION.MAP_CREATE_FAIL,originalError:o}))}this._sendSuccessFeatureUsage("initialize",Je.success),this._reactionsMap?.on("valueChanged",this.onReactionsReceived.bind(this))}async getAuthToken(){const e={token:await this._internalCallAgent.tokenProvider(),authProvider:"SKYPE",mri:this._internalCallAgent.getUserMri()};return Promise.resolve(e)}async sendReaction(e,i){if(!this._isReactionFeatureEnabled||!this._participantCapability.isPresent){const r=new Oe({defaultError:we.FEATURES.REACTION.SEND_FAIL_POLICY});throw this._sendAttempOrFailureFeatureUsage("sendReaction",Je.failure,r,i),r}if(!this._reactionsMap){this._logger.error("Reaction Map has not yet been initialized.");const r=new Oe({defaultError:we.FEATURES.REACTION.NOT_INIT_YET});throw this._sendAttempOrFailureFeatureUsage("sendReaction",Je.failure,r,i),r}try{return this._reactionsMap?.set(this._internalCallAgent.getUserMri(),{name:e.reactionType}),void this._sendSuccessFeatureUsage("sendReaction",Je.success,i,e.reactionType)}catch(r){this._logger.error("Unable to send reaction",r);const o=new Oe({defaultError:we.FEATURES.REACTION.SEND_REACTION_FAIL,originalError:r});throw this._sendAttempOrFailureFeatureUsage("sendReaction",Je.failure,o,i),o}}on(e,i){this._eventEmitter.on(e,i)}off(e,i){this._eventEmitter.off(e,i)}async onReactionsReceived(e){if(this._tsCall.state===3&&this._participantCapability.isPresent){const i=ln();this._sendAttempOrFailureFeatureUsage("receiveReaction",Je.attempt,void 0,i);try{const r={reactionType:(await this._reactionsMap?.get(e)).name};this._eventEmitter.emit("reaction",{identifier:e,reactionMessage:r}),this._sendSuccessFeatureUsage("receiveReaction",Je.success,i,r.reactionType)}catch(r){this._logger.error("Unable to parse reaction",r);let o=new Oe({defaultError:we.FEATURES.REACTION.RECEIVE_REACTION_FAIL,originalError:r});this._sendAttempOrFailureFeatureUsage("receiveReaction",Je.failure,o,i)}}}dispose(){this._telemetryLogManager!==void 0&&(this._proxy?.getConnectionState()===Vpe.ConnectionState.Connected?(this._reactionsMap?.removeAllListeners("valueChanged"),this._proxy.close(),this._sendSuccessFeatureUsage("dispose",Je.success),this._call.offParticipantCapabilitiesChanged("capabilitiesChanged",this.capabilityChangeHandler)):this._sendSuccessFeatureUsage("dispose",Je.failure))}_sendAttempOrFailureFeatureUsage(e,i,r,o){let l=r?{code:r?.code||jL,subCode:r?.subCode||0,failureReason:r?.message||"",...an(r)}:void 0;Pc({correlationId:o,callId:this._tsCall.callId,localParticipantId:this._tsCall.participantId,featureName:this.name,featureType:"Call",initializationType:"OnFeatureAccess",featureDetails:{name:e,step:i},additionalDetails:l},this._telemetryLogManager,this._logger)}_sendSuccessFeatureUsage(e,i,r,o){let l;l=e==="initialize"||e=="dispose"?void 0:{reactionConstraint:{reactionType:o}},Pc({correlationId:r,callId:this._tsCall.callId,localParticipantId:this._tsCall.participantId,featureName:this.name,featureType:"Call",initializationType:"OnFeatureAccess",featureDetails:{name:e,step:i},additionalDetails:l},this._telemetryLogManager,this._logger)}getEndpointUrl(){const e=this._internalCallAgent._caConfigBag,i=e&&u6(e.identityType,e.region);var r=wt().PowerPointStateServiceUrl.public.amer;switch(e?.cloudType){case pl.Public:i&&(r=wt().PowerPointStateServiceUrl.public.eu);break;case pl.GccHigh:r=wt().PowerPointStateServiceUrl.gcch;break;case pl.AirGap08:r=wt().PowerPointStateServiceUrl.ag08;break;case pl.AirGap09:r=wt().PowerPointStateServiceUrl.ag09;break;case pl.Dod:r=wt().PowerPointStateServiceUrl.dod;break;default:r=wt().PowerPointStateServiceUrl.public.amer}return`wss://${new URL(r).hostname}/StateServiceHandler.ashx`}}class Nzt{get contentSharingSession(){return this._contentSharingSession}constructor(e){this._contentSharingSession=e}getFileDetails(){if(this.contentSharingSession)return JSON.parse(atob(this.contentSharingSession.contentSharingIdentity))}}const M5e="azure_communication_calling_pptLive";class xzt extends Bu{constructor(e){super(e),this._impl=new Bzt(this.eventEmitter)}on(e,i){this._sendFeatureUsage(e,Je.subscribe),this.eventEmitter.on(e,i)}off(e,i){this._sendFeatureUsage(e,Je.unsubscribe),this.eventEmitter.off(e,i)}get isActive(){return this._impl.isActive}get target(){return this._impl.target}get activePresenterId(){return this._impl.activePresenterId}get name(){return"PPTLive"}initialize(e,i){this._logger=i,this._telemetryLogManager=e.telemetryLogManager,this._tsCall=e.tsCall,this._impl.initialize(e.tsCall,e.callAgent,e.telemetryLogManager,i)}_sendFeatureUsage(e,i){Pc({callId:this._tsCall.callId,localParticipantId:this._tsCall.participantId,featureName:e,featureType:"Call",initializationType:"OnFeatureAccess",featureDetails:{name:e,step:i}},this._telemetryLogManager,this._logger)}dispose(){this.disposed||super.dispose()}}class Bzt{constructor(e){this._isActive=!1,this._isInitializingPPTLive=!1,this._updateIsActive=i=>this._isActive!==i&&(this._isActive=i,this._logger.info(`Updating isActive to ${i}`),!0),this._eventEmitter=e,this._target=document.createElement("div"),this._target.id=M5e,this._target.style.width="100%",this._target.style.height="100%"}initialize(e,i,r,o){this._logger=o.createChild(()=>`PPTLive::Call(id='${e.callId}')`),this._tsCall=e,this._internalCallAgent=i,this._telemetryLogManager=r,this._tsCall.on("contentSharingChanged",()=>{this._checkContentSharingSession(this._tsCall.contentSharingSessions)}),this._tsCall.on("callStateChanged",()=>{this._updatePPTLive(this._tsCall.state)})}get isActive(){return this._isActive}get target(){return this._target}get activePresenterId(){return this._activePresenterId}_checkContentSharingSession(e){if(this._contentSharing&&e.length===0)this._updateIsActive(!1),this._contentSharing=void 0,this._target.innerHTML="",this._isInitializingPPTLive=!1,this._eventEmitter.emit("isActiveChanged"),this._sendFeatureUsage("endedPPTLive",Je.success);else if(!this._contentSharing&&e.length!==0){if(!wt().calling.pptlive.enabled)return;this._contentSharing=new Nzt(e[0]),this._updatePPTLive(this._tsCall.state),this._sendFeatureUsage("startedPPTLive",Je.attempt,this._contentSharing?.contentSharingSession?.contentSharingGuid)}}async _updatePPTLive(e){this._fileDetails=this._contentSharing?.getFileDetails(),this._fileDetails&&this._fileDetails.type==="ppt"&&e===3&&await this._startPPTLive(this._target)}_updateActivePresenter(){this._tsCall.participants.forEach(e=>{const i=Sl(e.id);e.contentSharingRole===2&&(this._activePresenterId=i)})}_sendFeatureUsage(e,i,r){Pc({callId:this._tsCall.callId,localParticipantId:this._tsCall.participantId,featureName:"PPTLive",featureType:"Call",initializationType:"OnFeatureAccess",featureDetails:{name:e,step:i},additionalDetails:{pptLiveConstraint:{contentId:r}}},this._telemetryLogManager,this._logger)}_observeDivMount(){const e=new MutationObserver(async i=>{if(this._isActive&&!this._isInitializingPPTLive)for(const r of i)for(let o=0;o<r.addedNodes.length;o++){const l=r.addedNodes[o];if(l.nodeType===Node.ELEMENT_NODE&&l.matches(`#${M5e}`)){await this._startPPTLive(this._target),e.disconnect();break}}else e.disconnect()});e.observe(document.body,{childList:!0,subtree:!0})}_initViewerWithExperiment(e,i,r,o,l,d,h,p,g,f,y,T,C,E,I){const w={getAuthTokenAsync:!1,getForceRefreshedTokenAsync:!1},D=window.Microsoft,F=H=>{this._isInitializingPPTLive=!1,this._observeDivMount(),this._sendFeatureUsage("startedPPTLive",Je.success,this._contentSharing?.contentSharingSession?.contentSharingGuid)},x=H=>{this._isInitializingPPTLive=!1;var j="Category: "+H.Category+`
Message: `+H.Message+`
ExtraInfo: `+H.ExtraInfo;this._sendFeatureUsage("startedPPTLive",Je.failure,this._contentSharing?.contentSharingSession?.contentSharingGuid),this._logger.error(j)},B=wt().calling.pptlive,L={entryPoint:"null"},z={Container:e,SessionInformation:{DocumentClickTime:new Date,HostInitTime:new Date,UiLocale:T,DataLocale:T,IsPresenter:!1,WdParams:{wdModernSlideShowInTeams:B.wdParams.wdModernSlideShowInTeams,wdPresenterViewInTeams:B.wdParams.wdPresenterViewInTeams,wdForceModernSlideShowInTeams:B.wdParams.wdForceModernSlideShowInTeams,isMovePrivateViewingToPPTEnabled:B.wdParams.isMovePrivateViewingToPPTEnabled},PptFeatureGates:B.featureGates,ParticipantId:p,EnableStateServiceInPreviewerFeatures:JSON.parse(B.enableStateServiceInPreviewerFeatures),StateServiceSettings:{stateServiceProxySettings:B.stateServiceProxySettings,regionalEndpointUrl:this._getEndpointUrl(),authEnabled:!1,rosterCheckEnabled:!1,stateServiceUser:w},ContentId:C,EndpointId:h,CallId:E,HostName:"ACSWeb",HostSessionId:g},WopiPrecheckInfo:{FileName:o,FileGetUrl:d,FileSize:l,CustomFontCatalogUrl:I,BundleInfo:{MajorVersion:r,Url:f},CreateNewInfo:null},ApplicationCustomSettings:{TakeFocusOnBoot:B.appSettings.takeFocusOnBoot,EnableAdvanceOnClick:B.appSettings.enableAdvanceOnClick,EnableAdvanceOnTap:B.appSettings.enableAdvanceOnTap},Diagnostics:L,FnOnInitializeSuccess:F,FnOnInitializeFailure:x};y&&(z.ApplicationCustomSettings.EnableWacFallback=!1,z.ApplicationUrl=y),D.Office.PowerPoint.Bootstrap.Prefetch(),D.Office.PowerPoint.Bootstrap.InitializeWopiPending(z),this._updateActivePresenter(),this._updateIsActive(!0),this._eventEmitter.emit("isActiveChanged"),this._sendFeatureUsage("startedPPTLive",Je.initialize,this._contentSharing?.contentSharingSession?.contentSharingGuid)}async _startPPTLive(e){this._fileDetails?.bootstrapperUrl&&(this._isInitializingPPTLive=!0,e.innerHTML="",await this._loadDynamicModule(this._fileDetails.bootstrapperUrl).then(()=>{this._fileDetails&&this._initViewerWithExperiment(e,Number(this._contentSharing?.contentSharingSession?.contentSharingState),this._fileDetails.majorVersion,this._fileDetails.name,this._fileDetails.fileSize,this._fileDetails.fileGetUrl,this._tsCall.endpointId,this._tsCall.participantId,ln(),this._fileDetails.contentBundleUrl,this._fileDetails.wacUrl,navigator.language,this._fileDetails.id,this._tsCall.callId,this._fileDetails.customFontCatalogUrl)}).catch(()=>{this._sendFeatureUsage("startedPPTLive",Je.failure,this._contentSharing?.contentSharingSession?.contentSharingGuid)}))}_getEndpointUrl(){const e=this._internalCallAgent._caConfigBag,i=e&&u6(e.identityType,e.region);let r=wt().PowerPointStateServiceUrl.public.amer;switch(e?.cloudType){case pl.Public:i&&(r=wt().PowerPointStateServiceUrl.public.eu);break;case pl.GccHigh:r=wt().PowerPointStateServiceUrl.gcch;break;case pl.AirGap08:r=wt().PowerPointStateServiceUrl.ag08;break;case pl.AirGap09:r=wt().PowerPointStateServiceUrl.ag09;break;case pl.Dod:r=wt().PowerPointStateServiceUrl.dod;break;default:r=wt().PowerPointStateServiceUrl.public.amer}return r}async _loadDynamicModule(e){const i=document.querySelectorAll(`head > script[src="${e}"]`);return i.length>0&&i[0]?Promise.resolve():new Promise((r,o)=>{const l=document.createElement("script"),d=document.getElementsByTagName("head")[0];l.onload=()=>r(),l.onerror=h=>{d.removeChild(l),o(h)},l.src=e,d.appendChild(l)})}}const Fzt=1.778,YQ=255,X6=2,Uzt=1280,zzt=720;var e8;(function(t){t.sceneChanged="sceneChanged",t.seatingChanged="seatingChanged"})(e8||(e8={}));const Vzt=(t,e)=>{const i=new Map;return(JSON.parse($zt(t))?.seating).forEach(o=>{const l=o?.mri,d=Hzt({x:o?.x,y:o?.y,w:o?.w,h:o?.h},e);i.set(l,d)}),i},$zt=t=>{try{const e=w6.ungzip(K6.Buffer.from(t,"base64"));return new TextDecoder().decode(e)}catch(e){throw e}},Hzt=(t,e)=>{const{sceneX:i,sceneY:r,sceneWidth:o,sceneHeight:l}=jzt(e),d=Gzt(t.x,t.y,t.w,t.h,o,l),h=wt().calling.togetherMode.mainVideo.scaledHeightRatio,p=wt().calling.togetherMode.mainVideo.scaledWidthRatio;return{top:r+d.y+d.h*(1-h),left:i+d.x+d.w*(1-p)/X6,width:d.w*p,height:d.h*h}},jzt=t=>{const e=t.width,i=t.height,r=Fzt,o=Math.max(e-i*r,0)/X6,l=Math.max(i-e/r,0)/X6;return{sceneX:o,sceneY:l,sceneWidth:e-o*X6,sceneHeight:i-l*X6}},Gzt=(t,e,i,r,o,l)=>({x:t/YQ*o,y:e/YQ*l,w:i/YQ*o,h:r/YQ*l});class qzt extends Bu{constructor(e){super(e),this._impl=new Wzt(this.eventEmitter,this.name,wt().calling.togetherMode.botId)}get name(){return"TeamsMeetingTogetherMode"}initialize(e,i){this._impl.initialize(e.tsCall,e.callAgent,e.call,e.telemetryLogManager,i)}dispose(){this._impl.dispose(),super.dispose()}on(e,i){if(e!=="togetherModeStreamsUpdated"&&e!=="togetherModeSceneUpdated"&&e!=="togetherModeSeatingUpdated")throw new Oe({defaultError:we.CALL.EVENT_SUBSCRIBE,defaultErrorMessageArgs:[e]});this.eventEmitter.on(e,i)}off(e,i){if(e!=="togetherModeStreamsUpdated"&&e!=="togetherModeSceneUpdated"&&e!=="togetherModeSeatingUpdated")throw new Oe({defaultError:we.CALL.EVENT_SUBSCRIBE,defaultErrorMessageArgs:[e]});this.eventEmitter.on(e,i)}get togetherModeStream(){return this._impl.togetherModeStream}get togetherModeSeatingMap(){return this._impl.seatingCooridnates}set sceneSize(e){this._impl.sceneSize=e}get sceneSize(){return this._impl.sceneSize}async start(){await this._impl.start()}}class Wzt extends upe{constructor(e,i,r){super(i,[r]),this._eventEmitter=e,this._togetherModeBotId=r,this._lastSeatingMapData="",this._seatingCoordinates=new Map,this._dataChannelId=wt().calling.togetherMode.dataChannelId,this._supportedConversationTypes=wt().calling.togetherMode.supportedConversationTypes,this._lastdataChannelMessage={},this._botSceneSize={width:Uzt,height:zzt}}initialize(e,i,r,o,l){e.region==="gcc"&&this.updateTogethermodeBotId(wt().calling.togetherMode.gccBotId),super.initialize(e,i,r,o,l),e.on("callStateChanged",()=>{if(e.state===3){const d=this.isGccBotInCall();(e.region==="gcc"||d)&&(this.updateTogethermodeBotId(wt().calling.togetherMode.gccBotId),d&&this.observeBotParticipantsAlreadyInCall())}}),this._dataChannelAdapter=new z6(e,this._dataChannelId),this._dataChannelAdapter.on("message",d=>{this.handleDataChannelMessageReceived(d)}),this._dataChannelAdapter.on("stateChanged",d=>{this.handleDataChannelStateChanged(d)}),this._dataChannelAdapter.initialize(),this._sendFeatureUsage("initialize",Je.initialize)}dispose(){this._dataChannelAdapter?.off("message",()=>{}),this._dataChannelAdapter?.off("stateChanged",()=>{}),super.disposeAllBotStreams(),this._dataChannelAdapter?.dispose()}get togetherModeStream(){return[...this._streamIdToStreamMap.values()].map(e=>e)}get seatingCooridnates(){return this._seatingCoordinates}set sceneSize(e){this._botSceneSize=e;const i=this.decodeMessageData(this._lastdataChannelMessage?.data);this.updateSeatingCoordinatesAndEmitEvent(i?.payload,i?.eventType)}get sceneSize(){return this._botSceneSize}async start(){const e="start";try{this.validateCanStartTogetherMode()}catch(i){return this._sendFeatureUsage(e,Je.failure,i),void this._logger.error(`[${this._featureName}]: Validation failed. ${JSON.stringify(i)}`)}if(this.isTogetherModeBotInCall())this._logger.warn("Together mode is already active");else{this._sendFeatureUsage(e,Je.attempt),this._logger.info(`[${this._featureName}]: Adding together mode bot to call`);try{await this._tsCall.addParticipant(this._togetherModeBotId)}catch(r){const o=new Oe({defaultError:we.FEATURES.TOGETHER_MODE.ADD_TOGETHER_MODE_BOT_FAILED,originalError:r});throw this._sendFeatureUsage(e,Je.failure,o),o}const i={level:"user",type:"togetherMode",content:"{}",participantIds:[this._togetherModeBotId]};try{await this._tsCall.publishState(i,fd())}catch(r){const o=nb(r,we.FEATURES.TOGETHER_MODE.PUBLISH_TOGETHER_MODE_STATE_FAILED);throw this._sendFeatureUsage(e,Je.failure,o),o}this._sendFeatureUsage(e,Je.success)}}createConcreteVideoStream(e,i){return new Kzt(e,this._logger,this._call,i,this._telemetryLogManager)}getStreamTypes(){return[0]}emitVideoStreamsUpdatedEvent(e){return this._eventEmitter.emit("togetherModeStreamsUpdated",e)}handleDataChannelMessageReceived(e){if(!e?.data)return;const i="messageReceived";try{this._sendFeatureUsage(i,Je.attempt),this._lastdataChannelMessage=e;const r=this.decodeMessageData(e.data);if(!r?.payload?.seating)return this._logger.info("Received data does not contain seating information. Ignoring the event"),void this._sendFeatureUsage(i,Je.success);if(r.payload.seating===this._lastSeatingMapData)return this._logger.info("Seating map data is the same as the last received data. Ignoring the event"),void this._sendFeatureUsage(i,Je.success);this._lastSeatingMapData=r.payload.seating,this.updateSeatingCoordinatesAndEmitEvent(r.payload,r.eventType),this._sendFeatureUsage(i,Je.success)}catch(r){const o=new Oe({defaultError:we.FEATURES.TOGETHER_MODE.SEAT_MAP_CALCULATION_FAILED,originalError:r});this._sendFeatureUsage(i,Je.failure,o)}}decodeMessageData(e){return e?JSON.parse(new TextDecoder().decode(e)):null}updateSeatingCoordinatesAndEmitEvent(e,i){if(i===e8.sceneChanged||i===e8.seatingChanged){const r=i===e8.sceneChanged?"togetherModeSceneUpdated":"togetherModeSeatingUpdated";this._seatingCoordinates=Vzt(e?.seating,this._botSceneSize),wt().calling.togetherMode.forceSeatMapRequest&&this.requestSeatMap(),r==="togetherModeSceneUpdated"&&this._eventEmitter.emit("togetherModeSeatingUpdated",this._seatingCoordinates),this._eventEmitter.emit(r,this._seatingCoordinates)}}validateCanStartTogetherMode(){if(!this._callAgent.isCteUser())throw new Oe({defaultError:we.FEATURES.TOGETHER_MODE.UNSUPPORTED_USER_KIND});if(!this.isSupportedConversationType())throw new Oe({defaultError:we.FEATURES.TOGETHER_MODE.UNSUPPORTED_CONVERSATION_TYPE})}handleDataChannelStateChanged(e){e===UA.Started&&this.requestSeatMap()}requestSeatMap(){try{const e={eventType:"seatMapping",payload:{seqId:1}};this._dataChannelAdapter?.send(new TextEncoder().encode(JSON.stringify(e)))}catch(e){throw new Oe({defaultError:we.FEATURES.TOGETHER_MODE.REQUEST_INITIAL_SEAT_MAPPING_FAILED,originalError:e})}}updateTogethermodeBotId(e){this._togetherModeBotId=e,super.updateBotIds([e])}isGccBotInCall(){for(let e of this._tsCall.participants)if(e.id===wt().calling.togetherMode.gccBotId)return!0;return!1}isTogetherModeBotInCall(){for(let e of this._tsCall.participants)if(e.id===this._togetherModeBotId)return!0;return!1}isSupportedConversationType(){const e=this._tsCall.conversationType;return!!e&&!!this._supportedConversationTypes.find(i=>i===e)}_sendFeatureUsage(e,i,r){const o=r&&an(r);Pc({callId:this._tsCall.callId,localParticipantId:this._tsCall.participantId,featureName:"TogetherMode",featureType:"Call",initializationType:"OnFeatureAccess",featureDetails:{name:e,step:i},additionalDetails:o},this._telemetryLogManager,this._logger)}}class Kzt extends FB{constructor(e,i,r,o,l){super(e,i,r,o,l,"TogetherModeVideoStream"),this._isAvailable=!1;const d=()=>{this.setIsAvailable(this.tsStream.isAvailable)};this._streamChangedHandler=this.tsStream.changed(()=>{d()}),d()}on(e,i){this._eventEmitter.on(e,i)}off(e,i){this._eventEmitter.off(e,i)}setIsAvailable(e){e!==this._isAvailable&&(this._isAvailable=!!e,this.logger.log(`isAvailable changed to ${this._isAvailable}`),this._eventEmitter.emit("isAvailableChanged",this._isAvailable),super.sendRemoteVideoStreamTelemetry())}getStreamMetadata(){return{callId:this.call?.id,streamType:this.mediaStreamType,localParticipantId:this.call.tsCall.participantId,remoteParticipantId:this.remoteParticipantId,sourceId:this.id,source:"remote",isReceiving:this._isReceiving,isStreaming:this.tsStream.isStreaming,isAvailable:this._isAvailable,viewIdsRegistered:this.getRegisteredViewIds(),height:this._size.height,width:this._size.width,isDisposed:this._disposed}}get isAvailable(){return this._isAvailable}}class P5e{constructor(e,i,r,o,l,d,h,p){this._logger=o.createChild(()=>"BreakoutRooms"),this._logger.log("created"),this._tsCall=e,this._mainMeeting=r,this._callAgent=i,this._telemetryLogManager=d,this.state="closed",this._eventEmitter=l,this.threadId="",this._breakoutRoomsCallFeature=h,this._breakoutRoomsService=p,this._hangUpCallDelayInMilliSeconds=wt().calling.breakoutRooms.hangUpCallDelayInMilliSeconds}async join(){try{if(this.state!=="open")throw this._logger.error("Breakout room is not open."),new Oe({defaultError:we.FEATURES.BREAKOUT_ROOMS.JOIN_FAILED_ROOM_CLOSED,originalError:"Cannot join the breakout room as it is closed."});return await this.holdMainMeetingCall(),await this.joinBreakoutRoomCall()}catch(e){throw this._logger.error("Breakout Room join failed",e),this._sendFeatureUsage("BreakoutRoomJoinError",Je.failure),this._logger?.error(e),e}}async returnToMainMeeting(){try{return this.state=="open"&&(this._breakoutRoomsService.isMainMeetingRejoin=!0),this.call?.state==="Connected"&&this.handleBreakoutRoomCallHangUp(this.call),this._mainMeeting.isSubscribedCall&&this._mainMeeting.state=="None"&&(await this.hangUpSubscribedCall(),await k6(this._hangUpCallDelayInMilliSeconds)),this.isBreakoutRoomManager()?(this._logger?.info("Resuming main meeting."),await this.resumeMainMeeting()):await this.rejoinMainMeeting()}catch(e){throw this._logger.error("Rejoin main meeting failed.",e),this._sendFeatureUsage("RejoinMainMeetingError",Je.failure),new Oe({defaultError:we.FEATURES.BREAKOUT_ROOMS.RETURN_TO_MAINMEETING_FAILED,originalError:e})}}async hangUp(e){e!=null&&setTimeout(()=>{this.handleBreakoutRoomCallHangUp(e)},this._hangUpCallDelayInMilliSeconds)}async handleBreakoutRoomCallHangUp(e){e?.state==="Connected"&&await e?.hangUp().then(()=>{this._logger.info("Breakout room call hang up success.")}).catch(i=>{throw this._logger.error("Error in hanging up the breakout room call.",i),new Oe({defaultError:we.FEATURES.BREAKOUT_ROOMS.HANGUP_EXISTING_BREAKOUT_ROOM_FAILED,originalError:i})})}getBreakoutRoomCall(e){return this._callAgent.calls.find(i=>i.id==e)}async rejoinMainMeeting(){let e;if(!this._mainMeeting.isSubscribedCall&&this._mainMeeting.state==="Connected")throw this._logger?.error("Cannot return to  main meeting as the user is already in main meeting."),new Oe({defaultError:we.FEATURES.BREAKOUT_ROOMS.ALREADY_IN_MAINMEETING,originalError:"Cannot return to main meeting as the user is already in main meeting."});return this._logger?.info("Returning to main meeting."),this._breakoutRoomsService.mainMeetingjoinLink&&(e=this._callAgent.join({meetingLink:this._breakoutRoomsService.mainMeetingjoinLink}),this._logger.info("joined mainmeeting , callId :",e.id),this._sendFeatureUsage("RejoinMainMeetingSuccess",Je.success)),Promise.resolve(e)}async joinBreakoutRoomCall(){try{if(this.url==null)throw new Oe({defaultError:we.FEATURES.BREAKOUT_ROOMS.BREAKOUT_ROOM_URL_DOESNOT_EXIST,originalError:"Cannot join the breakout room as the BreakoutRoom is not created."});this.call=this._callAgent.join({meetingLink:this.url});const e={type:"join",data:this.call};this.emitBreakoutRoomsUpdated(e),this._logger.info("Joined breakout room. callId :",this.call.id),this._sendFeatureUsage("BreakoutRoomJoin",Je.success),this.call.on("stateChanged",()=>{switch(this.call?.state){case"Disconnected":this._logger.info("Breakout room is disconnected."),!this._breakoutRoomsService.isNewBreakoutRoomAssigned&&this.hangUpSubscribedCall(),this._breakoutRoomsService.breakoutRoomCallId=void 0,this._breakoutRoomsService.breakoutRoomsCallFeatureImpl?.dispose();break;case"Connected":!this._mainMeeting.isSubscribedCall&&this.hangUpMainMeeting(),this._previousBreakoutRoomId=this._breakoutRoomsService.breakoutRoomCallId,this._breakoutRoomsService.isNewBreakoutRoomAssigned&&this._previousBreakoutRoomId&&this.hangUp(this.getBreakoutRoomCall(this._previousBreakoutRoomId)),this._breakoutRoomsService.breakoutRoomCallId=this.call.id}})}catch(e){throw this._logger.error("Breakout room join failed",e),new Oe({defaultError:we.FEATURES.BREAKOUT_ROOMS.JOIN_FAILED,originalError:e})}return Promise.resolve(this.call)}emitBreakoutRoomsUpdated(e){!this._mainMeeting.isSubscribedCall&&this._eventEmitter.emit("breakoutRoomsUpdated",e),this._mainMeeting.isSubscribedCall&&this._eventEmitter.emit("breakoutRoomsUpdatedInternal",e)}async holdMainMeetingCall(){this._mainMeeting.isSubscribedCall||this._mainMeeting.state!="Connected"||this._mainMeeting.hold().catch(e=>{throw this._logger.error("Main meeting hold failed",e),new Oe({defaultError:we.FEATURES.BREAKOUT_ROOMS.MAINMEETING_HOLD_FAILED,originalError:e})})}async resumeMainMeeting(){try{if(this.isBreakoutRoomManager()&&(this._logger?.info("Resuming main meeting"),this._mainMeeting.state==="LocalHold"))return this._mainMeeting.resume().then(()=>{this._logger?.info("Main meeting is resumed"),this._sendFeatureUsage("MainMeetingResumeSuccess",Je.success);let e=this._callAgent.calls.find(i=>i.id==this._mainMeeting.id);if(e)return e;throw new Oe({defaultError:we.FEATURES.BREAKOUT_ROOMS.MAINMEETING_RESUME_FAILED,originalError:"Main meeting call not found."})}).catch(e=>{const i=new Oe({defaultError:we.FEATURES.BREAKOUT_ROOMS.MAINMEETING_RESUME_FAILED,originalError:e});throw this._logger?.error("Error in resuming main meeting",i),this._sendFeatureUsage("MainMeetingResumeError",Je.failure),i})}catch(e){throw e}throw new Oe({defaultError:we.FEATURES.BREAKOUT_ROOMS.MAINMEETING_RESUME_FAILED,originalError:"Main meeting resume failed."})}async hangUpSubscribedCall(){this._mainMeeting.isSubscribedCall&&(this._mainMeeting.on("stateChanged",async()=>{this._mainMeeting.state==="Disconnected"&&(this._breakoutRoomsService.isNewBreakoutRoomAssigned=!1,this._mainMeeting.dispose())}),this._mainMeeting.hangUp().then(()=>{this._breakoutRoomsService.isMainMeetingRejoin=!0,this._logger?.info("Subscribed call is disconnected"),this._sendFeatureUsage("SubscribedCallHangupSuccess",Je.success)}).catch(e=>{this._logger?.error("Not able to disconnect subscribed call",e),this._sendFeatureUsage("SubscribedCallHangupError",Je.failure)}))}async hangUpMainMeeting(){try{if(!this.isBreakoutRoomManager()){let e=this._callAgent.getCallByCallId(this._mainMeeting.id);const i=e&&JSON.parse(await e.getJoinBlob()),r=i?.conversationUrl;if(!r)throw new Oe({defaultError:we.CALL.GET_SERVER_CALL_ID});if(e){const o={meetingUrl:r,threadId:e.threadId,callId:e.callId,participantId:e.participantId,messageId:e.messageId};this._mainMeeting.on("stateChanged",async()=>{if(this._mainMeeting.state==="Disconnected")return this._mainMeeting.dispose(),await this.joinMainMeetingWithoutModalities(o)}),await this._mainMeeting.hangUp()}}}catch(e){this._sendFeatureUsage("MainMeetingHangupError",Je.failure),this._logger?.error("Error in hangingup main meeting ",e)}}isBreakoutRoomManager(){if(this._callAgent.isCteUser()){if(this._mainMeeting?.role==Dd.Organizer||this._mainMeeting?.role==Dd.Coorganizer)return!0;const e=this._callAgent.getUserMri(),i=this._tsCall.meetingDetails?.breakoutDetails?.mainMeetingProperties?.breakoutRoomManagers||this._tsCall.meetingDetails?.breakoutDetails?.breakoutRoomProperties?.breakoutRoomManagers;return i==null||i?.length==0?!1:!!i.find(r=>r.id===e)}return!1}async joinMainMeetingWithoutModalities(e){this._callAgent.subscribeCallWithoutModality(e).then(i=>{if(i.isSubscribedCall=!0,this._mainMeeting=i,i){let r=this._callAgent.getCallByCallId(i.id);r&&(this._breakoutRoomsCallFeature.initialize({tsCall:r,call:i,callAgent:this._callAgent,telemetryLogManager:this._telemetryLogManager},this._logger),this._breakoutRoomsCallFeature.on("breakoutRoomsUpdatedInternal",o=>{this._breakoutRoomsService.breakoutRoomsCallFeatureImpl?.emitBreakoutRoomsEvents(o)}))}this._logger?.info("Joined main meeting without modalities successfully"),this._sendFeatureUsage("SubscribedCallJoinSuccess",Je.success)}).catch(i=>{throw this._logger?.error("Error in joining the  main meeting without modalities",i),this._sendFeatureUsage("SubscribedCallJoinFailed",Je.failure),i})}_sendFeatureUsage(e,i,r){let o=r?an(r):void 0;Pc({callId:this._tsCall.callId,localParticipantId:this._tsCall.participantId,featureName:"BreakoutRooms",featureType:"Call",initializationType:"OnFeatureAccess",featureDetails:{name:e,step:i},additionalDetails:o},this._telemetryLogManager,this._logger)}}function D5e(t){const e=new URL(t),i=e.pathname.split("/"),r=decodeURIComponent(i[3]);return!!(e.searchParams.get("context")??void 0)&&!!r}function L5e(t,e){let i=!0;try{const r=new URL(t);if(wt().teamsMeetingShortUrlJoin.validatePattern){const o=new RegExp(wt().teamsMeetingShortUrlJoin.regexPattern);i=!!r.toString().trim().match(o)}}catch(r){e.error(`Teams Meeting url validation failed with error= ${JSON.stringify(r)}`),i=!1}return i}function O5e(t,e){return e.some(i=>t.includes(i.trim().toLocaleLowerCase()))}function $pe(t){try{const e=new URL(t),i=e.pathname.split("/"),r=decodeURIComponent(i[3]),o=i[4],l=JSON.parse(decodeURIComponent(e.search.replace("?context=",""))),d=l.Oid;return{threadId:r,messageId:o,organizerId:d,tenantId:l.Tid}}catch(e){throw new Oe({defaultError:we.CALL_AGENT.INVALID_MEETING_LINK,originalError:e})}}function Jzt(t){let e=btoa(t).replace(/=/g,"");e=e.replace(/\+/g,"-"),e=e.replace(/\//g,"_");for(const i of e)if(i.match(/[^A-Za-z0-9-_]/))throw new Oe({defaultError:we.CALL.SERVER_CALL_ID});return e}class Yzt{constructor(e,i,r,o,l,d,h,p){this._autoMoveInMs=wt().calling.breakoutRooms.autoMoveInMilliSeconds,this._eventEmitter=h,this._tsCall=e,this._currentCall=r,this._telemetryLogManager=o,this._callAgent=i,this._logger=l,this._breakoutRoomsCallFeature=d,this.breakoutRoomsService=p,this.breakoutRoom=new P5e(this._tsCall,this._callAgent,this._currentCall,this._logger,h,this._telemetryLogManager,this._breakoutRoomsCallFeature,this.breakoutRoomsService)}initialize(e){e.changed(()=>{this._logger.log("tsCall changed event with breakoutroom details"),this.updateBreakoutDetails()})}get breakoutRoomAssigned(){return this._breakoutRoomAssigned=this._breakoutRoomAssignedInternal,this._breakoutRoomAssigned}get breakoutRooms(){return this._breakoutRooms=this._breakoutRoomsInternal,this._breakoutRooms}get breakoutRoomSettings(){return this._breakoutRoomSettings=this._breakoutRoomSettingsInternal,this._breakoutRoomSettings}emitBreakoutRoomsEvents(e){this._eventEmitter.emit("breakoutRoomsUpdated",e)}updateBreakoutDetails(){try{if(this._tsCall.breakoutDetails?.mainMeetingProperties?.assignedBreakoutRooms&&this._tsCall.breakoutDetails?.mainMeetingProperties?.assignedBreakoutRooms.length>0){if(this.hasBreakoutRooomsAssigned(this._tsCall.breakoutDetails?.mainMeetingProperties?.assignedBreakoutRooms[0])||this.hasBreakoutRooomsAssignmentChanged(this._tsCall.breakoutDetails?.mainMeetingProperties?.assignedBreakoutRooms[0])){this._logger?.info("breakoutroom is assigned");const e=this._tsCall.breakoutDetails?.mainMeetingProperties?.assignedBreakoutRooms[0]??null;if(this._breakoutRoomAssignedInternal!=null&&(this._logger?.info("New breakout room is assigned"),this.breakoutRoomsService.isNewBreakoutRoomAssigned=this._breakoutRoomAssignedInternal?.url!=e?.meetingJoinUrl,this.breakoutRoomsService.isNewBreakoutRoomAssigned&&(this.breakoutRoomsService.breakoutRoomCallId=this._breakoutRoomAssignedInternal?.call?.id)),e){this._breakoutRoomAssignedInternal=this.updateAssignedBreakoutRoomDetails(e);const i={type:"assignedBreakoutRooms",data:this.breakoutRoomAssigned};this.emitBreakoutRoomsUpdated(i)}this.canJoinBreakoutRoom()&&this.joinBreakoutRoom(),this._currentCall.isSubscribedCall&&this._breakoutRoomAssignedInternal&&!this.breakoutRoomsService.isNewBreakoutRoomAssigned&&this.breakoutRoomsService.breakoutRoomCallId&&(this._breakoutRoomAssignedInternal.call=this._callAgent.calls.find(i=>i.id===this.breakoutRoomsService.breakoutRoomCallId),this.breakoutRoomsService.breakoutRoomCallId=void 0),this.breakoutRoomsService.isMainMeetingRejoin&&(this.breakoutRoomsService.isMainMeetingRejoin=!1)}this.hasBreakoutRoomsStateChanged(this._tsCall.breakoutDetails?.mainMeetingProperties?.assignedBreakoutRooms[0])&&(this._logger?.info("breakoutroom state changed"),this.handleBreakoutRoomStateChanged())}if(this._breakoutRoomAssignedInternal&&this._tsCall.breakoutDetails?.mainMeetingProperties?.assignedBreakoutRooms==null||this._tsCall.breakoutDetails?.mainMeetingProperties?.assignedBreakoutRooms?.length==0){this._breakoutRoomAssignedInternal=void 0;const e={type:"assignedBreakoutRooms",data:this.breakoutRoomAssigned};this.emitBreakoutRoomsUpdated(e)}if(this.hasAllBreakoutRoomsAvailable(this._tsCall.breakoutDetails?.mainMeetingProperties?.allBreakoutRooms)){this._logger?.info("all breakoutrooms available"),this.parseBreakoutRooms(this._tsCall.breakoutDetails?.mainMeetingProperties?.allBreakoutRooms);const e={type:"breakoutRooms",data:this.breakoutRooms};this._eventEmitter.emit("breakoutRoomsUpdated",e)}if(this._tsCall.meetingDetails?.breakoutDetails?.breakoutRoomProperties&&this.hasbreakoutRoomSettingsAvailable(this._tsCall.meetingDetails?.breakoutDetails?.breakoutRoomProperties)||this.hasbreakoutRoomSettingsUpdated(this._tsCall.meetingDetails?.breakoutDetails?.breakoutRoomProperties)){this._logger?.info("breakoutroom settings are available"),this.updateBreakoutRoomSettings(),this.breakoutRoomsService.breakoutRoomsCallFeatureImpl=this._breakoutRoomsCallFeature;const e={type:"breakoutRoomsSettings",data:this.breakoutRoomSettings};this._currentCall.isBreakoutRoomCall=!0,this._eventEmitter.emit("breakoutRoomsUpdated",e)}}catch(e){throw this._logger.error("Could not Update Breakout details.",e),this._sendFeatureUsage("UpdateBreakoutDetails",Je.failure),new Oe({defaultError:we.FEATURES.BREAKOUT_ROOMS.BREAKOUT_ROOMS_UPDATEFAILED,originalError:e})}}updateAssignedBreakoutRoomDetails(e){let i=this.breakoutRoom;return this.assignBreakoutRoomProperties(e,i),i}assignBreakoutRoomProperties(e,i){i.autoMoveParticipantToBreakoutRoom=e?.allowMoveParticipantsAutomatically,i.displayName=e?.name,i.url=e?.meetingJoinUrl,i.threadId=e?.meetingJoinUrl&&$pe(e?.meetingJoinUrl)?.threadId||"",i.state=e?.isOpen?"open":"closed"}emitBreakoutRoomsUpdated(e){!this._currentCall.isSubscribedCall&&this._eventEmitter.emit("breakoutRoomsUpdated",e),this._currentCall.isSubscribedCall&&this._eventEmitter.emit("breakoutRoomsUpdatedInternal",e)}canJoinBreakoutRoom(){return this._breakoutRoomAssignedInternal?.state=="open"&&this._breakoutRoomAssignedInternal?.autoMoveParticipantToBreakoutRoom&&(this._currentCall.isSubscribedCall&&this.breakoutRoomsService.isNewBreakoutRoomAssigned||!this._currentCall.isSubscribedCall&&!this.breakoutRoomsService.isMainMeetingRejoin)}async handleBreakoutRoomStateChanged(){if(this._breakoutRoomAssignedInternal&&this._breakoutRoomAssignedInternal?.state){this._breakoutRoomAssignedInternal.state=this._tsCall.breakoutDetails?.mainMeetingProperties?.assignedBreakoutRooms&&this._tsCall.breakoutDetails?.mainMeetingProperties?.assignedBreakoutRooms[0]?.isOpen?"open":"closed",this._logger?.info("breakoutroom state is changed to ",this._breakoutRoomAssignedInternal?.state);const e={type:"assignedBreakoutRooms",data:this.breakoutRoomAssigned};this.emitBreakoutRoomsUpdated(e),this._breakoutRoomAssignedInternal?.state==="open"&&this._breakoutRoomAssignedInternal?.autoMoveParticipantToBreakoutRoom?this.joinBreakoutRoom():this._breakoutRoomAssignedInternal?.state==="closed"&&(this.breakoutRoomsService.isMainMeetingRejoin=!1,await this._breakoutRoomAssignedInternal.hangUp(this._breakoutRoomAssignedInternal.call))}}joinBreakoutRoom(){try{this._logger?.info("joining breakout room call"),setTimeout(()=>{this._breakoutRoomAssignedInternal?.join().then(e=>{this._breakoutRoomAssignedInternal&&(this._breakoutRoomAssignedInternal.call=e),this._logger?.info("Breakout room call joined successfully")})},this._autoMoveInMs)}catch(e){throw this._logger?.error(e),e}}hasbreakoutRoomSettingsAvailable(e){return e!=null&&this._breakoutRoomSettingsInternal===void 0}hasbreakoutRoomSettingsUpdated(e){return e!=null&&this._breakoutRoomSettingsInternal==null||e?.roomEndTime!=this._breakoutRoomSettingsInternal?.roomEndTime||e?.additionalData?.allowJoinBackToMainMeeting!=this._breakoutRoomSettingsInternal?.disableReturnToMainMeeting}updateBreakoutRoomSettings(){this._breakoutRoomSettingsInternal={disableReturnToMainMeeting:this._tsCall.meetingDetails?.breakoutDetails?.additionalData?.allowJoinBackToMainMeeting.toLowerCase()!=="true"},this._tsCall.meetingDetails?.breakoutDetails?.breakoutRoomProperties?.roomEndTime&&(this._breakoutRoomSettingsInternal.roomEndTime=this._tsCall.meetingDetails?.breakoutDetails?.breakoutRoomProperties?.roomEndTime),this.breakoutRoomsService.mainMeetingjoinLink=this._tsCall.meetingDetails?.breakoutDetails?.breakoutRoomProperties?.mainMeetingJoinUrl}parseBreakoutRooms(e){this._breakoutRoomsInternal=e.map(i=>{let r=new P5e(this._tsCall,this._callAgent,this._currentCall,this._logger,this._eventEmitter,this._telemetryLogManager,this._breakoutRoomsCallFeature,this.breakoutRoomsService);return this.assignBreakoutRoomProperties(i,r),r.invitees=i.invitees.map(o=>Sl(o.id)),r})}hasAllBreakoutRoomsAvailable(e){return!!(e?.length>0&&this._breakoutRoomsInternal?.length==0||e?.length!=this._breakoutRooms?.length||this.hasAllBreakoutRoomsPropertiesChanged(e)||this._breakoutRoomsInternal&&this._breakoutRoomsInternal?.length>0&&e?.length==0)}hasAllBreakoutRoomsPropertiesChanged(e){return!!(e&&e.length>0&&this._breakoutRooms&&this._breakoutRooms.length>0)&&e.some(i=>{const r=this._breakoutRoomsInternal?.find(o=>i.displayName===o.displayName);return!r||i.isOpen!==(r.state==="open")})}hasBreakoutRooomsAssigned(e){return(this._breakoutRoomAssignedInternal?.url==null||this._breakoutRoomAssignedInternal?.url=="")&&e?.meetingJoinUrl!==void 0||this._breakoutRoomAssignedInternal?.displayName!=e?.name}hasBreakoutRooomsAssignmentChanged(e){return!!(this._breakoutRoomAssignedInternal?.url&&e&&e?.meetingJoinUrl!==void 0&&this._breakoutRoomAssignedInternal?.url!=e?.meetingJoinUrl||this._breakoutRoomAssignedInternal?.autoMoveParticipantToBreakoutRoom!=e?.allowMoveParticipantsAutomatically)}hasBreakoutRoomsStateChanged(e){return!(!this._breakoutRoomAssignedInternal||this.isBreakoutRoomOpen()==e.isOpen)}isBreakoutRoomOpen(){return this._breakoutRoomAssignedInternal?.state==="open"}_sendFeatureUsage(e,i,r){let o=r?an(r):void 0;Pc({callId:this._tsCall.callId,localParticipantId:this._tsCall.participantId,featureName:"BreakoutRooms",featureType:"Call",initializationType:"OnFeatureAccess",featureDetails:{name:e,step:i},additionalDetails:o},this._telemetryLogManager,this._logger)}}class jB{constructor(e){this._eventEmitter=e}emit(e,i){!e&&this._eventEmitter.emit("breakoutRoomsUpdated",i),e&&this._eventEmitter.emit("breakoutRoomsUpdatedInternal",i)}subscribe(e){this._eventEmitter.on("breakoutRoomsUpdatedInternal",e)}static getInstance(e){return jB.instance||(jB.instance=new jB(e)),jB.instance}dispose(){jB.instance=void 0}}class Qzt extends Bu{constructor(e){super(e),this._impl=new Zzt(this.eventEmitter,this),this.breakoutRoomsService=jB.getInstance(this.eventEmitter)}get name(){return"BreakoutRooms"}initialize(e,i){this._logger=i,this._telemetryLogManager=e.telemetryLogManager,this._tsCall=e.tsCall,this._impl.initialize(this._tsCall,e.callAgent,e.call,e.telemetryLogManager,i,this.breakoutRoomsService)}get assignedBreakoutRooms(){return this._impl.breakoutRoomAssigned}get breakoutRooms(){return this._impl.breakoutRooms}get breakoutRoomsSettings(){return this._impl.breakoutRoomSettings}emitBreakoutRoomsEvents(e){this._impl.emitBreakoutRoomsEvents(e)}on(e,i){this._sendFeatureUsage(e,Je.subscribe),this.eventEmitter.on(e,i)}off(e,i){this._sendFeatureUsage(e,Je.unsubscribe),this.eventEmitter.off(e,i)}_sendFeatureUsage(e,i){Pc({callId:this._tsCall.callId,localParticipantId:this._tsCall.participantId,featureName:"BreakoutRooms",featureType:"Call",initializationType:"OnFeatureAccess",featureDetails:{name:e,step:i}},this._telemetryLogManager,this._logger)}dispose(){this.disposed||super.dispose()}}class Zzt{constructor(e,i){this._isEnabled=wt().calling.breakoutRooms.enabled,this._supportedConversationTypes=wt().calling.breakoutRooms.supportedConversationTypes,this._eventEmitter=e,this._breakoutRoomsCallFeature=i}initialize(e,i,r,o,l,d){this._logger=l.createChild(()=>`BreakoutRoomsFeature::Call(id='${e.callId}')`),this._tsCall=e,this._internalCallAgent=i;const h="initialize";if(this._breakoutRoomsImpl=new Yzt(e,i,r,o,l,this._breakoutRoomsCallFeature,this._eventEmitter,d),this._breakoutRoomsImpl._sendFeatureUsage(h,Je.attempt),!this._isEnabled){const p="Breakoutrooms feature is is disabled",g=new Oe({defaultError:we.FEATURES.BREAKOUT_ROOMS.DISABLED});throw this._breakoutRoomsImpl._sendFeatureUsage(h,Je.failure,g),this._logger.error(p),g}if(this._tsCall.state===3&&!this._supportedConversationTypes.includes(e.conversationType)){const p="Breakout rooms feature is only available in meetings",g=new Oe({defaultError:we.FEATURES.BREAKOUT_ROOMS.ONLY_AVAILABLE_IN_MEETINGS});throw this._breakoutRoomsImpl._sendFeatureUsage(h,Je.failure,g),this._logger.error(p),g}this._breakoutRoomsImpl.initialize(this._tsCall),this._breakoutRoomsImpl._sendFeatureUsage(h,Je.success)}get breakoutRoomAssigned(){return this._breakoutRoomsImpl.breakoutRoomAssigned}get breakoutRooms(){return this._breakoutRoomsImpl.breakoutRooms}get breakoutRoomSettings(){return this._breakoutRoomsImpl.breakoutRoomSettings}emitBreakoutRoomsEvents(e){return this._breakoutRoomsImpl.emitBreakoutRoomsEvents(e)}}var Vm;(function(t){t.Initialize="initialize",t.Dispose="dispose",t.RealTimeTextReceived="realTimeTextReceived",t.SendRealTimeText="sendRealTimeText",t.StartDataChannel="startDataChannel",t.LockTimerToDataChannel="lockTimerToDataChannel",t.SendTimerToDataChannel="sendTimerToDataChannel",t.FinalizedSendRealTimeText="finalizedSendRealTimeText",t.RealTimeTextStarted="realTimeTextStarted"})(Vm||(Vm={}));class Xzt extends Bu{constructor(e){super(e),this._impl=new eVt(this.eventEmitter)}initialize(e,i){const r=ln();this._logger=i,this._telemetryLogManager=e.telemetryLogManager,this._call=e.call,this._sendFeatureUsage(Vm.Initialize,Je.initialize,r),this._impl.initialize(e.tsCall,e.call,e.callAgent,e.telemetryLogManager,i,r)}get name(){return"RealTimeText"}async sendRealTimeText(e,i){await this._impl.sendRealTimeText(e,i)}on(e,i){this.eventEmitter.on(e,i)}off(e,i){this.eventEmitter.off(e,i)}dispose(){this._sendFeatureUsage(Vm.Dispose,Je.attempt),this.disposed?this._sendFeatureUsage(Vm.Dispose,Je.failure):(this._impl.dispose(),super.dispose(),this._sendFeatureUsage(Vm.Dispose,Je.success))}_sendFeatureUsage(e,i,r){Pc({correlationId:r,callId:this._call.id,localParticipantId:this._call.tsCall.participantId,featureName:this.name,featureType:"Call",initializationType:"OnFeatureAccess",featureDetails:{name:e,step:i}},this._telemetryLogManager,this._logger)}}class eVt{constructor(e){this._eventEmitter=e,this._isEnterpriseUser=!1,this._ecsAutoSendInterval=0,this._ecsAutoCommitTimeout=0,this._ecsMaxInputLength=0,this._ecsDataChannelId=0,this._ecsTeamsEnabled=!1,this._dataChannelInitialized=!1,this._firstMessageReceivedOrSent=!1,this._entries=new Map,this.sequenceId=0,this._userMri="",this._nextMessage="",this._rttSendTimerToDataChannel=()=>{const i=ln();this._sendTimer=setTimeout(async()=>{this._sendFeatureUsage(Vm.SendTimerToDataChannel,Je.attempt,i),this._nextMessage.includes(`
`)&&this._lockTimer&&(clearTimeout(this._lockTimer),this._lockTimer=null),await this._purgeMessage(i,Vm.SendTimerToDataChannel)},this._ecsAutoCommitTimeout)},this._rttLockTimerToDataChannel=()=>{const i=ln();this._lockTimer&&(clearTimeout(this._lockTimer),this._lockTimer=null),this._lockTimer=setTimeout(async()=>{this._sendFeatureUsage(Vm.LockTimerToDataChannel,Je.attempt,i);let r=this._entries.get(this._userMri)?.text??"";(r.trim()!==""||this._entries.get(this._userMri)&&this._entries.get(this._userMri)?.resultType!=="Final")&&(this._nextMessage=r+`
`,await this._purgeMessage(i,Vm.LockTimerToDataChannel))},this._ecsAutoSendInterval)},this._dataChannelHandler=i=>{let r,{sourceId:o,data:l}=i;const d=ln();try{this._sendFeatureUsage(Vm.RealTimeTextReceived,Je.attempt,d),r=JSON.parse(l.toString())}catch{try{if(this._textDecoder===void 0)throw new Error("TextDecoder undefined.");r=JSON.parse(this._textDecoder.decode(l))}catch{throw this._logger.error("Failed to parse RealTimeText message"),new Oe({defaultError:we.FEATURES.REAL_TIME_TEXT.REAL_TIME_TEXT_MESSAGE_PARSE_FAILED})}try{if(r&&o){let p=r.s,g=this._participantMappingManager?.findParticipantMri(o);if(!g)throw new Oe({defaultError:we.FEATURES.REAL_TIME_TEXT.REAL_TIME_TEXT_MESSAGE_CONTAINS_NO_SPEAKER});this._updateEntries(g,p),this._sendFirstMessageReceivedOrSentTelemetry(),this._sendFeatureUsage(Vm.RealTimeTextReceived,Je.success,d)}}catch(p){const g=new Oe({originalError:p,defaultError:we.FEATURES.REAL_TIME_TEXT.REAL_TIME_TEXT_MESSAGE_HANDLER_FAILED});throw this._sendFeatureUsage(Vm.RealTimeTextReceived,Je.failure,d,g),g}}},this._updateEntries=(i,r)=>{try{let o,l=this._entries.get(i),{composedText:d,isFinal:h}=this._generateRealTimeTextMessage(r,l&&l.resultType!=="Final"?l.text:"");const p=new Date,g=h?"Final":"Partial";if(l)o={...l,sequenceId:l.resultType==="Final"?this.sequenceId++:l.sequenceId,text:d,updatedTimestamp:p,resultType:g};else{const f=this._tsCall.participants.find(y=>y.id===i)?.displayName||(this._internalCallAgent.getUserMri()===i?this._internalCallAgent?.displayName:void 0);o={sequenceId:this.sequenceId++,text:d,sender:{identifier:Sl(i),displayName:f,endpointDetails:[]},receivedTimestamp:p,updatedTimestamp:p,resultType:g,isLocal:this._internalCallAgent.getUserMri()===i}}this._entries.set(i,o),this._eventEmitter.emit("realTimeTextReceived",this._entries.get(i)),this._entries.get(i)?.resultType==="Final"&&this._entries.delete(i)}catch(o){throw new Oe({originalError:o,defaultError:we.FEATURES.REAL_TIME_TEXT.REAL_TIME_TEXT_MESSAGE_ENTRY_UPDATE_FAILED})}},this._generateRealTimeTextMessage=(i,r)=>{let o=r;for(const l of i)switch(l){case"\b":o=o.slice(0,-1);break;case`
`:return{composedText:o,isFinal:!0};default:o+=l}return{composedText:o,isFinal:!1}}}initialize(e,i,r,o,l,d){this._logger=l,this._tsCall=e,this._call=i,this._internalCallAgent=r,this._telemetryLogManager=o,this._isEnterpriseUser=r.isCteUser(),this._ecsAutoCommitTimeout=wt().calling.realTimeText.autoCommitTimeout,this._ecsAutoSendInterval=wt().calling.realTimeText.autoSendInterval,this._ecsMaxInputLength=wt().calling.realTimeText.maxInputLength,this._ecsDataChannelId=wt().calling.realTimeText.dataChannelId,this._ecsTeamsEnabled=wt().calling.realTimeText.teams.enabled;try{if(this._isEnterpriseUser&&!this._ecsTeamsEnabled){const h=new Oe({defaultError:we.FEATURES.REAL_TIME_TEXT.REAL_TIME_TEXT_TEAMS_DISABLED});throw this._sendFeatureUsage(Vm.Initialize,Je.failure,d,h),h}this._userMri=this._internalCallAgent.getUserMri(),this._rttDataChannelAdapter=new z6(e,this._ecsDataChannelId),this._participantMappingManager=new sUe(e),this._textDecoder=new TextDecoder,this._textEncoder=new TextEncoder,this.startDataChannel(d)}catch(h){const p=new Oe({originalError:h,defaultError:we.FEATURES.REAL_TIME_TEXT.INITIALIZE_FAILED});throw this._sendFeatureUsage(Vm.Initialize,Je.failure,d,p),p}}startDataChannel(e){try{this._rttDataChannelAdapter||(this._rttDataChannelAdapter=new z6(this._tsCall,this._ecsDataChannelId)),this._dataChannelInitialized||(this._rttDataChannelAdapter.initialize().then(()=>{this._dataChannelInitialized=!0}),this._rttDataChannelAdapter.off("message",this._dataChannelHandler),this._rttDataChannelAdapter.on("message",this._dataChannelHandler))}catch(i){const r=new Oe({originalError:i,defaultError:we.FEATURES.REAL_TIME_TEXT.START_REAL_TIME_TEXT_FAILED});throw this._sendFeatureUsage(Vm.StartDataChannel,Je.failure,e,r),r}}async sendRealTimeText(e,i){const r=ln();this.startDataChannel(r);let o=Vm.SendRealTimeText;i&&(o=Vm.FinalizedSendRealTimeText),this._sendFeatureUsage(o,Je.attempt,r);try{if(e===""&&(!this._entries.get(this._userMri)||this._entries.get(this._userMri)?.resultType==="Final")||!i&&e===this._entries.get(this._userMri)?.text)return;if(e.length>this._ecsMaxInputLength)throw new Oe({defaultError:we.FEATURES.REAL_TIME_TEXT.MESSAGE_LENGTH_EXCEEDS_MAX_INPUT_LENGTH});this._nextMessage=i?e+=`
`:e,i?(this._lockTimer&&(clearTimeout(this._lockTimer),this._lockTimer=null),this._sendTimer&&(clearTimeout(this._sendTimer),this._sendTimer=null),await this._purgeMessage(r,o)):(this._rttLockTimerToDataChannel(),this._sendTimer||this._rttSendTimerToDataChannel()),this._sendFeatureUsage(o,Je.success,r)}catch(l){const d=new Oe({originalError:l,defaultError:we.FEATURES.REAL_TIME_TEXT.SEND_REAL_TIME_TEXT_MESSAGE_FAILED});throw this._sendFeatureUsage(o,Je.failure,r,d),d}}async _purgeMessage(e,i){const r=tVt(this._entries.get(this._userMri)?.text??"",this._nextMessage);if(r!==""){if(this._textEncoder===void 0)throw new Error("TextEncoder undefined.");let o=this._textEncoder.encode(JSON.stringify({s:r}));this._updateEntries(this._internalCallAgent.getUserMri(),r);try{await this._rttDataChannelAdapter?.send(o),this._sendFirstMessageReceivedOrSentTelemetry()}catch{const d=new Oe({defaultError:we.FEATURES.REAL_TIME_TEXT.SEND_DATA_CHANNEL_MESSAGE_FAILED});throw this._sendFeatureUsage(i,Je.failure,e),d}this._nextMessage="",r.includes(`
`)?(this._lockTimer&&(clearTimeout(this._lockTimer),this._lockTimer=null),this._entries.delete(this._userMri)):this._rttLockTimerToDataChannel(),this._sendTimer&&(clearTimeout(this._sendTimer),this._sendTimer=null),this._sendFeatureUsage(i,Je.success,e)}}dispose(){this._textDecoder=void 0}_sendFeatureUsage(e,i,r,o){const l=o&&an(o);Pc({correlationId:r,callId:this._tsCall.callId,localParticipantId:this._tsCall.participantId,featureName:"RealTimeText",featureType:"Call",initializationType:"OnFeatureAccess",featureDetails:{name:e,step:i},additionalDetails:l},this._telemetryLogManager,this._logger)}_sendFirstMessageReceivedOrSentTelemetry(){this._firstMessageReceivedOrSent||(this._sendFeatureUsage(Vm.RealTimeTextStarted,Je.event),this._firstMessageReceivedOrSent=!0)}}const tVt=(t,e)=>{let i="";const r=Math.min(t?.length,e.length);let o=-1;for(let l=0;l<r;l++)t[l]!==e[l]&&o===-1&&(o=l),o!==-1&&(i+="\b");for(let l=r;l<t.length;l++)i+="\b";return i+=o===-1?e.substring(r):e.substring(o),i},Ma={Recording:Qd(tUt),Transfer:Qd(dUt),Transcription:Qd(sUt),Captions:Qd(m2t),RaiseHand:Qd(y2t),LocalRecording:Qd(aUt),Reaction:Qd(Lzt),Spotlight:Qd(C5t),PPTLive:Qd(xzt),BreakoutRooms:Qd(Qzt),Capabilities:Qd(A2t),DominantSpeakers:Qd(B2t),LiveStream:Qd(IUt),ComposedStream:Qd(RUt),CallSurvey:Qd(E5t),UserFacingDiagnostics:Qd(D2t),MediaStats:Qd(K2e,{activationEvent:"OnExtendedObjectConstructor"}),DebugInfo:s2e(M2t,{activationEvent:"OnExtendedObjectConstructor"}),PreCallDiagnostics:s2e(bUt),VideoEffects:l2e(RQ),AudioEffects:c2e(MQ),DataChannel:Qd(T5t),OptimalVideoCount:Qd(w5t),UnmixedAudio:Qd(F5t),AudioZones:Qd(A5t),TeamsMeetingAudioConferencing:Qd(U5t),TogetherMode:Qd(qzt),MediaAccess:Qd(Qhe),RealTimeText:Qd(Xzt)};function Hpe(t){switch(t){case IO.CallClientFeature:return Object.entries(Ma).filter(e=>e[1].isCallClientFeature===!0).map(e=>e[1]);case IO.CallAgentFeature:return Object.entries(Ma).filter(e=>e[1].isCallAgentFeature===!0).map(e=>e[1]);case IO.CallFeature:return Object.entries(Ma).filter(e=>e[1].isCallFeature===!0).map(e=>e[1])}}class iVt{constructor(e,i){this._eventBag=[],this.resetEventBag=()=>{this._eventBag=[]},this._logger=e.createChild("CallStats"),this._telemetryLogManager=i}recordEvent(e){try{if(wt()?.telemetry?.callStatsFlushTimeout<0||wt()?.telemetry?.blockedEvents?.indexOf(e.name)>-1)return;const i={timestamp:+new Date,...e};this._logger.debug(`CallStat recorded=${e.name}`),this._eventBag.push(i),this.scheduleTelemetryFlush()}catch{this._logger.debug("Failed to record call stats")}}flushEvents(){if(this._logger.debug(`CallStats sending telemetry, number of events=${this._eventBag.length}`),this._eventBag.length!==0)try{const e=this._eventBag.reduce((i,r)=>(i[r.localParticipantId]?i[r.localParticipantId].events.push({name:r.name,timestamp:r.timestamp,...r.data}):i[r.localParticipantId]={callId:r.callId,localParticipantId:r.localParticipantId,events:[{name:r.name,timestamp:r.timestamp,...r.data}]},i),{});Object.keys(e).forEach(i=>{this._telemetryLogManager.sendEvent({name:vi.acs_calling_call_stats,tenant:Wr,properties:{...e[i]}})}),this.resetEventBag()}catch{this._logger.debug("Failed to send call stats")}}scheduleTelemetryFlush(){this._callStatSendTimeout||(this._callStatSendTimeout=window.setTimeout(()=>{this.flushEvents(),this._callStatSendTimeout=void 0},wt().telemetry.callStatsFlushTimeout))}}function Y3(t,e){if(e==="Connected")return;let i;if(t==Ar.MuteAllRemoteParticipants)i=we.CALL.MUTE_ALL_PARTICIPANTS_CALL_NOT_CONNECTED;else if(t==Ar.StopAudio)i=we.CALL.STOP_AUDIO_STREAM_CALL_NOT_CONNECTED;else if(t==Ar.AddParticipant)i=we.CALL.ADD_PARTICIPANT_CALL_NOT_CONNECTED;else{if(t!=Ar.RemoveParticipant)return;i=we.CALL.REMOVE_PARTICIPANT_CALL_NOT_CONNECTED}throw new Oe({defaultError:i})}class nVt{constructor(e){this._volumeIndicator=e,this._eventEmitter=new $c}on(e,i){this._eventEmitter.on(e,i)}off(e,i){this._eventEmitter.off(e,i)}get level(){return this._volumeIndicator.level}async setSource(e){this._mediaStream!==e&&(this._mediaStream&&this._volumeIndicator.dispose(),e&&(this._mediaStream=e,await this._volumeIndicator.getVolumeIndicator(e),this._volumeIndicator.on("levelChanged",()=>{this._eventEmitter.emit("levelChanged")})))}dispose(){this._eventEmitter.removeAllListeners()}}var aVt=function(t,e,i,r){var o,l=arguments.length,d=l<3?e:r;if(typeof Reflect=="object"&&typeof Reflect.decorate=="function")d=Reflect.decorate(t,e,i,r);else for(var h=t.length-1;h>=0;h--)(o=t[h])&&(d=(l<3?o(d):l>3?o(e,i,d):o(e,i))||d);return l>3&&d&&Object.defineProperty(e,i,d),d},rVt=function(t,e){if(typeof Reflect=="object"&&typeof Reflect.metadata=="function")return Reflect.metadata(t,e)};class N5e{constructor(e,i,r,o){this._workQueue=Promise.resolve();const l=zf("ACS-calling");this.logger=new rh(l,[()=>"RemoteAudioStream for media stream"]),this._source=e,this._disposed=!1,this._volumeIndicator=new dpe(this.logger,"RemoteAudioStream",i,r,o),e.changed(async()=>{this._volumeProxy&&(this._workQueue=this._workQueue.then(async()=>{await this._volumeProxy?.setSource(await this._source.getMediaStream())}).catch(d=>{this.logger.log(`source changed but failed to update volume indicator: ${d?.message??"unknown error"}`)}))}),this.logger.info("created")}async getMediaStream(){return await this._source.getMediaStream()}get source(){return this._source}dispose(){this.logger.log("dispose"),this._disposed?this.logger.log("already disposed"):(this._volumeIndicator.dispose(),this._disposed=!0)}async getVolume(){if(!this._volumeProxy){const e=new nVt(this._volumeIndicator),i=this._workQueue.then(async()=>{await e.setSource(await this._source.getMediaStream())});this._workQueue=i.catch(nh),await i,this._volumeProxy=e}return this._volumeProxy}}aVt([zv,rVt("design:type",Object)],N5e.prototype,"logger",void 0);var x5e=bs(function(t,e){(function(i,r){var o="1.0.38",l="",d="?",h="function",p="undefined",g="object",f="string",y="major",T="model",C="name",E="type",I="vendor",w="version",D="architecture",F="console",x="mobile",B="tablet",L="smarttv",z="wearable",H="embedded",j=500,J="Amazon",Z="Apple",re="ASUS",ne="BlackBerry",le="Browser",he="Chrome",Me="Firefox",Le="Google",pe="Huawei",te="LG",Se="Microsoft",ce="Motorola",X="Opera",ve="Samsung",Te="Sharp",Be="Sony",qe="Xiaomi",Ge="Zebra",tt="Facebook",ct="Chromium OS",Mt="Mac OS",ht=function(dt,yt){var kt={};for(var je in dt)yt[je]&&yt[je].length%2==0?kt[je]=yt[je].concat(dt[je]):kt[je]=dt[je];return kt},vt=function(dt){for(var yt={},kt=0;kt<dt.length;kt++)yt[dt[kt].toUpperCase()]=dt[kt];return yt},Pt=function(dt,yt){return typeof dt===f&&ni(yt).indexOf(ni(dt))!==-1},ni=function(dt){return dt.toLowerCase()},Zt=function(dt){return typeof dt===f?dt.replace(/[^\d\.]/g,l).split(".")[0]:r},it=function(dt,yt){if(typeof dt===f)return dt=dt.replace(/^\s\s*/,l),typeof yt===p?dt:dt.substring(0,j)},Ke=function(dt,yt){for(var kt,je,Ae,xe,gt,Ye,Fe=0;Fe<yt.length&&!gt;){var St=yt[Fe],Wt=yt[Fe+1];for(kt=je=0;kt<St.length&&!gt&&St[kt];)if(gt=St[kt++].exec(dt))for(Ae=0;Ae<Wt.length;Ae++)Ye=gt[++je],typeof(xe=Wt[Ae])===g&&xe.length>0?xe.length===2?typeof xe[1]==h?this[xe[0]]=xe[1].call(this,Ye):this[xe[0]]=xe[1]:xe.length===3?typeof xe[1]!==h||xe[1].exec&&xe[1].test?this[xe[0]]=Ye?Ye.replace(xe[1],xe[2]):r:this[xe[0]]=Ye?xe[1].call(this,Ye,xe[2]):r:xe.length===4&&(this[xe[0]]=Ye?xe[3].call(this,Ye.replace(xe[1],xe[2])):r):this[xe]=Ye||r;Fe+=2}},ot=function(dt,yt){for(var kt in yt)if(typeof yt[kt]===g&&yt[kt].length>0){for(var je=0;je<yt[kt].length;je++)if(Pt(yt[kt][je],dt))return kt===d?r:kt}else if(Pt(yt[kt],dt))return kt===d?r:kt;return dt},Ht={ME:"4.90","NT 3.11":"NT3.51","NT 4.0":"NT4.0",2e3:"NT 5.0",XP:["NT 5.1","NT 5.2"],Vista:"NT 6.0",7:"NT 6.1",8:"NT 6.2",8.1:"NT 6.3",10:["NT 6.4","NT 10.0"],RT:"ARM"},jt={browser:[[/\b(?:crmo|crios)\/([\w\.]+)/i],[w,[C,"Chrome"]],[/edg(?:e|ios|a)?\/([\w\.]+)/i],[w,[C,"Edge"]],[/(opera mini)\/([-\w\.]+)/i,/(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,/(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i],[C,w],[/opios[\/ ]+([\w\.]+)/i],[w,[C,X+" Mini"]],[/\bop(?:rg)?x\/([\w\.]+)/i],[w,[C,X+" GX"]],[/\bopr\/([\w\.]+)/i],[w,[C,X]],[/\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i],[w,[C,"Baidu"]],[/(kindle)\/([\w\.]+)/i,/(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,/(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i,/(?:ms|\()(ie) ([\w\.]+)/i,/(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,/(heytap|ovi)browser\/([\d\.]+)/i,/(weibo)__([\d\.]+)/i],[C,w],[/\bddg\/([\w\.]+)/i],[w,[C,"DuckDuckGo"]],[/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i],[w,[C,"UC"+le]],[/microm.+\bqbcore\/([\w\.]+)/i,/\bqbcore\/([\w\.]+).+microm/i,/micromessenger\/([\w\.]+)/i],[w,[C,"WeChat"]],[/konqueror\/([\w\.]+)/i],[w,[C,"Konqueror"]],[/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i],[w,[C,"IE"]],[/ya(?:search)?browser\/([\w\.]+)/i],[w,[C,"Yandex"]],[/slbrowser\/([\w\.]+)/i],[w,[C,"Smart Lenovo "+le]],[/(avast|avg)\/([\w\.]+)/i],[[C,/(.+)/,"$1 Secure "+le],w],[/\bfocus\/([\w\.]+)/i],[w,[C,Me+" Focus"]],[/\bopt\/([\w\.]+)/i],[w,[C,X+" Touch"]],[/coc_coc\w+\/([\w\.]+)/i],[w,[C,"Coc Coc"]],[/dolfin\/([\w\.]+)/i],[w,[C,"Dolphin"]],[/coast\/([\w\.]+)/i],[w,[C,X+" Coast"]],[/miuibrowser\/([\w\.]+)/i],[w,[C,"MIUI "+le]],[/fxios\/([-\w\.]+)/i],[w,[C,Me]],[/\bqihu|(qi?ho?o?|360)browser/i],[[C,"360 "+le]],[/(oculus|sailfish|huawei|vivo)browser\/([\w\.]+)/i],[[C,/(.+)/,"$1 "+le],w],[/samsungbrowser\/([\w\.]+)/i],[w,[C,ve+" Internet"]],[/(comodo_dragon)\/([\w\.]+)/i],[[C,/_/g," "],w],[/metasr[\/ ]?([\d\.]+)/i],[w,[C,"Sogou Explorer"]],[/(sogou)mo\w+\/([\d\.]+)/i],[[C,"Sogou Mobile"],w],[/(electron)\/([\w\.]+) safari/i,/(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,/m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i],[C,w],[/(lbbrowser)/i,/\[(linkedin)app\]/i],[C],[/((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i],[[C,tt],w],[/(Klarna)\/([\w\.]+)/i,/(kakao(?:talk|story))[\/ ]([\w\.]+)/i,/(naver)\(.*?(\d+\.[\w\.]+).*\)/i,/safari (line)\/([\w\.]+)/i,/\b(line)\/([\w\.]+)\/iab/i,/(alipay)client\/([\w\.]+)/i,/(twitter)(?:and| f.+e\/([\w\.]+))/i,/(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i],[C,w],[/\bgsa\/([\w\.]+) .*safari\//i],[w,[C,"GSA"]],[/musical_ly(?:.+app_?version\/|_)([\w\.]+)/i],[w,[C,"TikTok"]],[/headlesschrome(?:\/([\w\.]+)| )/i],[w,[C,he+" Headless"]],[/ wv\).+(chrome)\/([\w\.]+)/i],[[C,he+" WebView"],w],[/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i],[w,[C,"Android "+le]],[/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i],[C,w],[/version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i],[w,[C,"Mobile Safari"]],[/version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i],[w,C],[/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i],[C,[w,ot,{"1.0":"/8",1.2:"/1",1.3:"/3","2.0":"/412","2.0.2":"/416","2.0.3":"/417","2.0.4":"/419","?":"/"}]],[/(webkit|khtml)\/([\w\.]+)/i],[C,w],[/(navigator|netscape\d?)\/([-\w\.]+)/i],[[C,"Netscape"],w],[/mobile vr; rv:([\w\.]+)\).+firefox/i],[w,[C,Me+" Reality"]],[/ekiohf.+(flow)\/([\w\.]+)/i,/(swiftfox)/i,/(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,/(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,/(firefox)\/([\w\.]+)/i,/(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,/(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,/(links) \(([\w\.]+)/i,/panasonic;(viera)/i],[C,w],[/(cobalt)\/([\w\.]+)/i],[C,[w,/master.|lts./,""]]],cpu:[[/(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i],[[D,"amd64"]],[/(ia32(?=;))/i],[[D,ni]],[/((?:i[346]|x)86)[;\)]/i],[[D,"ia32"]],[/\b(aarch64|arm(v?8e?l?|_?64))\b/i],[[D,"arm64"]],[/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i],[[D,"armhf"]],[/windows (ce|mobile); ppc;/i],[[D,"arm"]],[/((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i],[[D,/ower/,l,ni]],[/(sun4\w)[;\)]/i],[[D,"sparc"]],[/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i],[[D,ni]]],device:[[/\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i],[T,[I,ve],[E,B]],[/\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,/samsung[- ]([-\w]+)/i,/sec-(sgh\w+)/i],[T,[I,ve],[E,x]],[/(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i],[T,[I,Z],[E,x]],[/\((ipad);[-\w\),; ]+apple/i,/applecoremedia\/[\w\.]+ \((ipad)/i,/\b(ipad)\d\d?,\d\d?[;\]].+ios/i],[T,[I,Z],[E,B]],[/(macintosh);/i],[T,[I,Z]],[/\b(sh-?[altvz]?\d\d[a-ekm]?)/i],[T,[I,Te],[E,x]],[/\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i],[T,[I,pe],[E,B]],[/(?:huawei|honor)([-\w ]+)[;\)]/i,/\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i],[T,[I,pe],[E,x]],[/\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,/\b; (\w+) build\/hm\1/i,/\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,/\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,/oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,/\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i],[[T,/_/g," "],[I,qe],[E,x]],[/oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,/\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i],[[T,/_/g," "],[I,qe],[E,B]],[/; (\w+) bui.+ oppo/i,/\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i],[T,[I,"OPPO"],[E,x]],[/\b(opd2\d{3}a?) bui/i],[T,[I,"OPPO"],[E,B]],[/vivo (\w+)(?: bui|\))/i,/\b(v[12]\d{3}\w?[at])(?: bui|;)/i],[T,[I,"Vivo"],[E,x]],[/\b(rmx[1-3]\d{3})(?: bui|;|\))/i],[T,[I,"Realme"],[E,x]],[/\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,/\bmot(?:orola)?[- ](\w*)/i,/((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i],[T,[I,ce],[E,x]],[/\b(mz60\d|xoom[2 ]{0,2}) build\//i],[T,[I,ce],[E,B]],[/((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i],[T,[I,te],[E,B]],[/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,/\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,/\blg-?([\d\w]+) bui/i],[T,[I,te],[E,x]],[/(ideatab[-\w ]+)/i,/lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i],[T,[I,"Lenovo"],[E,B]],[/(?:maemo|nokia).*(n900|lumia \d+)/i,/nokia[-_ ]?([-\w\.]*)/i],[[T,/_/g," "],[I,"Nokia"],[E,x]],[/(pixel c)\b/i],[T,[I,Le],[E,B]],[/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i],[T,[I,Le],[E,x]],[/droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i],[T,[I,Be],[E,x]],[/sony tablet [ps]/i,/\b(?:sony)?sgp\w+(?: bui|\))/i],[[T,"Xperia Tablet"],[I,Be],[E,B]],[/ (kb2005|in20[12]5|be20[12][59])\b/i,/(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i],[T,[I,"OnePlus"],[E,x]],[/(alexa)webm/i,/(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,/(kf[a-z]+)( bui|\)).+silk\//i],[T,[I,J],[E,B]],[/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i],[[T,/(.+)/g,"Fire Phone $1"],[I,J],[E,x]],[/(playbook);[-\w\),; ]+(rim)/i],[T,I,[E,B]],[/\b((?:bb[a-f]|st[hv])100-\d)/i,/\(bb10; (\w+)/i],[T,[I,ne],[E,x]],[/(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i],[T,[I,re],[E,B]],[/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i],[T,[I,re],[E,x]],[/(nexus 9)/i],[T,[I,"HTC"],[E,B]],[/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,/(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,/(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i],[I,[T,/_/g," "],[E,x]],[/droid.+; ([ab][1-7]-?[0178a]\d\d?)/i],[T,[I,"Acer"],[E,B]],[/droid.+; (m[1-5] note) bui/i,/\bmz-([-\w]{2,})/i],[T,[I,"Meizu"],[E,x]],[/; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i],[T,[I,"Ulefone"],[E,x]],[/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,/(hp) ([\w ]+\w)/i,/(asus)-?(\w+)/i,/(microsoft); (lumia[\w ]+)/i,/(lenovo)[-_ ]?([-\w]+)/i,/(jolla)/i,/(oppo) ?([\w ]+) bui/i],[I,T,[E,x]],[/(kobo)\s(ereader|touch)/i,/(archos) (gamepad2?)/i,/(hp).+(touchpad(?!.+tablet)|tablet)/i,/(kindle)\/([\w\.]+)/i,/(nook)[\w ]+build\/(\w+)/i,/(dell) (strea[kpr\d ]*[\dko])/i,/(le[- ]+pan)[- ]+(\w{1,9}) bui/i,/(trinity)[- ]*(t\d{3}) bui/i,/(gigaset)[- ]+(q\w{1,9}) bui/i,/(vodafone) ([\w ]+)(?:\)| bui)/i],[I,T,[E,B]],[/(surface duo)/i],[T,[I,Se],[E,B]],[/droid [\d\.]+; (fp\du?)(?: b|\))/i],[T,[I,"Fairphone"],[E,x]],[/(u304aa)/i],[T,[I,"AT&T"],[E,x]],[/\bsie-(\w*)/i],[T,[I,"Siemens"],[E,x]],[/\b(rct\w+) b/i],[T,[I,"RCA"],[E,B]],[/\b(venue[\d ]{2,7}) b/i],[T,[I,"Dell"],[E,B]],[/\b(q(?:mv|ta)\w+) b/i],[T,[I,"Verizon"],[E,B]],[/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i],[T,[I,"Barnes & Noble"],[E,B]],[/\b(tm\d{3}\w+) b/i],[T,[I,"NuVision"],[E,B]],[/\b(k88) b/i],[T,[I,"ZTE"],[E,B]],[/\b(nx\d{3}j) b/i],[T,[I,"ZTE"],[E,x]],[/\b(gen\d{3}) b.+49h/i],[T,[I,"Swiss"],[E,x]],[/\b(zur\d{3}) b/i],[T,[I,"Swiss"],[E,B]],[/\b((zeki)?tb.*\b) b/i],[T,[I,"Zeki"],[E,B]],[/\b([yr]\d{2}) b/i,/\b(dragon[- ]+touch |dt)(\w{5}) b/i],[[I,"Dragon Touch"],T,[E,B]],[/\b(ns-?\w{0,9}) b/i],[T,[I,"Insignia"],[E,B]],[/\b((nxa|next)-?\w{0,9}) b/i],[T,[I,"NextBook"],[E,B]],[/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i],[[I,"Voice"],T,[E,x]],[/\b(lvtel\-)?(v1[12]) b/i],[[I,"LvTel"],T,[E,x]],[/\b(ph-1) /i],[T,[I,"Essential"],[E,x]],[/\b(v(100md|700na|7011|917g).*\b) b/i],[T,[I,"Envizen"],[E,B]],[/\b(trio[-\w\. ]+) b/i],[T,[I,"MachSpeed"],[E,B]],[/\btu_(1491) b/i],[T,[I,"Rotor"],[E,B]],[/(shield[\w ]+) b/i],[T,[I,"Nvidia"],[E,B]],[/(sprint) (\w+)/i],[I,T,[E,x]],[/(kin\.[onetw]{3})/i],[[T,/\./g," "],[I,Se],[E,x]],[/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i],[T,[I,Ge],[E,B]],[/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i],[T,[I,Ge],[E,x]],[/smart-tv.+(samsung)/i],[I,[E,L]],[/hbbtv.+maple;(\d+)/i],[[T,/^/,"SmartTV"],[I,ve],[E,L]],[/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i],[[I,te],[E,L]],[/(apple) ?tv/i],[I,[T,Z+" TV"],[E,L]],[/crkey/i],[[T,he+"cast"],[I,Le],[E,L]],[/droid.+aft(\w+)( bui|\))/i],[T,[I,J],[E,L]],[/\(dtv[\);].+(aquos)/i,/(aquos-tv[\w ]+)\)/i],[T,[I,Te],[E,L]],[/(bravia[\w ]+)( bui|\))/i],[T,[I,Be],[E,L]],[/(mitv-\w{5}) bui/i],[T,[I,qe],[E,L]],[/Hbbtv.*(technisat) (.*);/i],[I,T,[E,L]],[/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,/hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i],[[I,it],[T,it],[E,L]],[/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i],[[E,L]],[/(ouya)/i,/(nintendo) ([wids3utch]+)/i],[I,T,[E,F]],[/droid.+; (shield) bui/i],[T,[I,"Nvidia"],[E,F]],[/(playstation [345portablevi]+)/i],[T,[I,Be],[E,F]],[/\b(xbox(?: one)?(?!; xbox))[\); ]/i],[T,[I,Se],[E,F]],[/((pebble))app/i],[I,T,[E,z]],[/(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i],[T,[I,Z],[E,z]],[/droid.+; (glass) \d/i],[T,[I,Le],[E,z]],[/droid.+; (wt63?0{2,3})\)/i],[T,[I,Ge],[E,z]],[/(quest( \d| pro)?)/i],[T,[I,tt],[E,z]],[/(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i],[I,[E,H]],[/(aeobc)\b/i],[T,[I,J],[E,H]],[/droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i],[T,[E,x]],[/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i],[T,[E,B]],[/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i],[[E,B]],[/(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i],[[E,x]],[/(android[-\w\. ]{0,9});.+buil/i],[T,[I,"Generic"]]],engine:[[/windows.+ edge\/([\w\.]+)/i],[w,[C,"EdgeHTML"]],[/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i],[w,[C,"Blink"]],[/(presto)\/([\w\.]+)/i,/(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,/ekioh(flow)\/([\w\.]+)/i,/(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,/(icab)[\/ ]([23]\.[\d\.]+)/i,/\b(libweb)/i],[C,w],[/rv\:([\w\.]{1,9})\b.+(gecko)/i],[w,C]],os:[[/microsoft (windows) (vista|xp)/i],[C,w],[/(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i],[C,[w,ot,Ht]],[/windows nt 6\.2; (arm)/i,/windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,/(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i],[[w,ot,Ht],[C,"Windows"]],[/ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,/(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,/cfnetwork\/.+darwin/i],[[w,/_/g,"."],[C,"iOS"]],[/(mac os x) ?([\w\. ]*)/i,/(macintosh|mac_powerpc\b)(?!.+haiku)/i],[[C,Mt],[w,/_/g,"."]],[/droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i],[w,C],[/(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,/(blackberry)\w*\/([\w\.]*)/i,/(tizen|kaios)[\/ ]([\w\.]+)/i,/\((series40);/i],[C,w],[/\(bb(10);/i],[w,[C,ne]],[/(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i],[w,[C,"Symbian"]],[/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i],[w,[C,Me+" OS"]],[/web0s;.+rt(tv)/i,/\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i],[w,[C,"webOS"]],[/watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i],[w,[C,"watchOS"]],[/crkey\/([\d\.]+)/i],[w,[C,he+"cast"]],[/(cros) [\w]+(?:\)| ([\w\.]+)\b)/i],[[C,ct],w],[/panasonic;(viera)/i,/(netrange)mmh/i,/(nettv)\/(\d+\.[\w\.]+)/i,/(nintendo|playstation) ([wids345portablevuch]+)/i,/(xbox); +xbox ([^\);]+)/i,/\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,/(mint)[\/\(\) ]?(\w*)/i,/(mageia|vectorlinux)[; ]/i,/([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,/(hurd|linux) ?([\w\.]*)/i,/(gnu) ?([\w\.]*)/i,/\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,/(haiku) (\w+)/i],[C,w],[/(sunos) ?([\w\.\d]*)/i],[[C,"Solaris"],w],[/((?:open)?solaris)[-\/ ]?([\w\.]*)/i,/(aix) ((\d)(?=\.|\)| )[\w\.])*/i,/\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,/(unix) ?([\w\.]*)/i],[C,w]]},Nt=function(dt,yt){if(typeof dt===g&&(yt=dt,dt=r),!(this instanceof Nt))return new Nt(dt,yt).getResult();var kt=typeof i!==p&&i.navigator?i.navigator:r,je=dt||(kt&&kt.userAgent?kt.userAgent:l),Ae=kt&&kt.userAgentData?kt.userAgentData:r,xe=yt?ht(jt,yt):jt,gt=kt&&kt.userAgent==je;return this.getBrowser=function(){var Ye={};return Ye[C]=r,Ye[w]=r,Ke.call(Ye,je,xe.browser),Ye[y]=Zt(Ye[w]),gt&&kt&&kt.brave&&typeof kt.brave.isBrave==h&&(Ye[C]="Brave"),Ye},this.getCPU=function(){var Ye={};return Ye[D]=r,Ke.call(Ye,je,xe.cpu),Ye},this.getDevice=function(){var Ye={};return Ye[I]=r,Ye[T]=r,Ye[E]=r,Ke.call(Ye,je,xe.device),gt&&!Ye[E]&&Ae&&Ae.mobile&&(Ye[E]=x),gt&&Ye[T]=="Macintosh"&&kt&&typeof kt.standalone!==p&&kt.maxTouchPoints&&kt.maxTouchPoints>2&&(Ye[T]="iPad",Ye[E]=B),Ye},this.getEngine=function(){var Ye={};return Ye[C]=r,Ye[w]=r,Ke.call(Ye,je,xe.engine),Ye},this.getOS=function(){var Ye={};return Ye[C]=r,Ye[w]=r,Ke.call(Ye,je,xe.os),gt&&!Ye[C]&&Ae&&Ae.platform&&Ae.platform!="Unknown"&&(Ye[C]=Ae.platform.replace(/chrome os/i,ct).replace(/macos/i,Mt)),Ye},this.getResult=function(){return{ua:this.getUA(),browser:this.getBrowser(),engine:this.getEngine(),os:this.getOS(),device:this.getDevice(),cpu:this.getCPU()}},this.getUA=function(){return je},this.setUA=function(Ye){return je=typeof Ye===f&&Ye.length>j?it(Ye,j):Ye,this},this.setUA(je),this};Nt.VERSION=o,Nt.BROWSER=vt([C,w,y]),Nt.CPU=vt([D]),Nt.DEVICE=vt([T,I,E,F,x,L,B,z,H]),Nt.ENGINE=Nt.OS=vt([C,w]),t.exports&&(e=t.exports=Nt),e.UAParser=Nt;var Vt=typeof i!==p&&(i.jQuery||i.Zepto);if(Vt&&!Vt.ua){var $t=new Nt;Vt.ua=$t.getResult(),Vt.ua.get=function(){return $t.getUA()},Vt.ua.set=function(dt){$t.setUA(dt);var yt=$t.getResult();for(var kt in yt)Vt.ua[kt]=yt[kt]}}})(typeof window=="object"?window:fo)});const B5e=[{name:"edge",engine:"Edge",key:"Edge"},{name:"edgeanaheim",engine:"Chromium",key:"Edg"},{name:"chromium",engine:"Chromium",key:"Chromium"},{name:"opera",engine:"Chromium",key:"OPR"},{name:"yandexbrowser",engine:"Chromium",key:"YaBrowser"},{name:"electron",engine:"Chromium",key:"Electron"},{name:"chrome",engine:"Chromium",key:"Chrome"},{name:"firefox",engine:"Firefox",key:"Firefox"},{name:"safari",engine:"Safari",key:"Safari"},{name:"applewebview",engine:"Safari",key:"Mac OS X"},{name:"ie",engine:"MSIE",key:"Trident"}],QQ="0.0",F5e="unknown";function oVt(t){return/iPhone|iPad|iPod|Android|Mobi/i.test(t)?"Mobile":"Desktop"}function sVt(t){const e=!/like android/i.test(t),i=/android/i.test(t);return e&&i}let jpe=new x5e.UAParser;function GB(){return jpe||(jpe=new x5e.UAParser),jpe.getResult()}function U5e(){const t=GB().ua;return t.indexOf("Edge")!==-1?"edge":t.indexOf("Electron")!==-1?"electron":t.indexOf("Chrome")!==-1?"chrome":t.indexOf("Firefox")!==-1?"firefox":t.indexOf("Safari")!==-1?"safari":t.indexOf("Mac OS X")!==-1?"applewebview":t.indexOf("Trident")!==-1?"ie":"unknown"}function lVt(t,e){return t!=="edge"&&t!=="edgeanaheim"||((e.includes("Edg/")||e.includes("EdgA/")||e.includes("EdgiOS/"))&&(t="edgeanaheim"),e.includes("Edge/")&&(t="edge")),t}function cVt(t,e){const i=e.find(({key:o})=>t.includes(o));if(!i)return F5e;let r=i.name;return r=lVt(r,GB().ua),r}function dVt(t,e){return mP()==="ios"&&(e="Safari"),e}function uVt(t,e){const i=e.find(({name:o})=>o===t);if(!i)return F5e;let r=i.engine;return r=dVt(t,r),r}function hVt(){const t=GB();return t.browser.name==="WebKit"&&t.ua.indexOf("Mac OS X")!==-1?t.os.version??QQ:t.browser.version!==void 0?t.browser.version:QQ}function $A(){const t=GB(),e=t.ua,i=cVt(t.browser.name,B5e);return{name:i,engine:uVt(i,B5e),version:hVt(),formFactor:oVt(e)}}function mP(){const t=GB().ua;return/windows phone/i.test(t)?"windowsphone":/windows /i.test(t)?"windows":/macintosh/i.test(t)?"mac":/(ipod|iphone|ipad)/i.test(t)?"ios":sVt(t)?"android":/(web|hpw)[o0]s/i.test(t)?"webos":/tizen/i.test(t)?"tizen":/headlesschrome(?:\/([\w\.]+)| )/i.test(t)?"headlesschrome":/linux/i.test(t)?"linux":/CrOS/.test(t)?"chrome":"other"}function pVt(){const t=$A();return`${`os=${mP()};`} ${`osVer=${z5e()};`} ${`browser=${t.name};`} ${`browserVer=${t.version};`} ${`formFactor=${t.formFactor};`}`}function z5e(){const t=GB();return t.os.version!==void 0?t.os.version:QQ}function V5e(t){return/^\d+$/.test(t)}function gVt(t,e){t=t.replace(/,/g,".").trim(),e=e.replace(/,/g,".").trim();let i=t.split("."),r=e.split("."),o=0;try{if(!i.every(V5e)||!r.every(V5e))return-2;for(;i.length<r.length;)i.push("0");for(;r.length<i.length;)r.push("0");let d=i.map(Number),h=r.map(Number);for(var l=0;l<d.length;l++)if(d[l]!==h[l]){if(d[l]>h[l])return 1;if(d[l]<h[l])return-1}}catch(d){xK.log(`Error in browser check version support: ${d}`)}return o}function $5e(t){return!!(wt()?.environments).hasOwnProperty(t)}function mVt(t,e){let i=wt()?.environments;return!(!$5e(t)||!i[t].hasOwnProperty(e))&&i[t][e].isSupportedOnSdkVersion}function fVt(t,e){let i=wt()?.environments;return i.hasOwnProperty(t)&&i[t].hasOwnProperty(e)?i[t][e].minVersion:QQ}function H5e(){let t,e,i=!1;const r=GB(),o=mP(),l=$A().name,d=$A().version,h=$5e(o),p=mVt(o,l);return p&&gVt(d,fVt(o,l))>=0&&(i=!0),e={platform:r.os.name,browser:r.browser.name,browserVersion:r.browser.version},t={environment:e,isSupportedPlatform:h,isSupportedBrowser:p,isSupportedBrowserVersion:i,isSupportedEnvironment:h&&p&&i},t}var vVt=function(t,e,i,r){var o,l=arguments.length,d=l<3?e:r;if(typeof Reflect=="object"&&typeof Reflect.decorate=="function")d=Reflect.decorate(t,e,i,r);else for(var h=t.length-1;h>=0;h--)(o=t[h])&&(d=(l<3?o(d):l>3?o(e,i,d):o(e,i))||d);return l>3&&d&&Object.defineProperty(e,i,d),d},yVt=function(t,e){if(typeof Reflect=="object"&&typeof Reflect.metadata=="function")return Reflect.metadata(t,e)};class j5e{get currentVideoConstraints(){return this._currentVideoConstraints}constructor(e,i,r){this._tsCall=e,this._currentVideoConstraints={send:{frameHeight:{max:void 0},frameRate:{max:void 0},bitrate:{max:void 0}}},this._logger=i.createChild("MediaConstraintsManager"),this._telemetryLogManager=r}async setVideoConstraints(e,i,r,o){const l=this.getTelemetryPayload({video:e}),d=h=>{let p=h?{failureReason:h?h.message:void 0,code:h?h.code:void 0,...an(h)}:void 0;Pc({correlationId:r,callId:this._tsCall.callId,localParticipantId:this._tsCall.participantId,featureName:"SetConstraints",featureType:"Call",initializationType:"None",timestampInfo:{deltaTimeInMs:+new Date-o},featureDetails:{name:"setConstraints",step:h?Je.failure:Je.success,stage:i},additionalDetails:{constraints:this.getTelemetryPayload({video:this._currentVideoConstraints}),...p}},this._telemetryLogManager,this._logger)};try{if(Pc({correlationId:r,callId:this._tsCall.callId,localParticipantId:this._tsCall.participantId,featureName:"SetConstraints",featureType:"Call",initializationType:"None",timestampInfo:"",featureDetails:{name:"setConstraints",step:Je.attempt,stage:i},additionalDetails:{constraints:l}},this._telemetryLogManager,this._logger),!wt().calling.constraints.enabled)throw this._logger.error("Setting call constraints is disabled"),new Oe({defaultError:we.CALL.MEDIA_CONSTRAINTS_DISABLED});this._updateVideoConstraintsCache(e);const h={outgoingVideoLimit:{maxResolution:this._currentVideoConstraints.send?.frameHeight?.max,maxFramerate:this._currentVideoConstraints.send?.frameRate?.max,maxBitrate:this._currentVideoConstraints.send?.bitrate?.max}},p=this._tsCall.setCallConstraints?.(h);if(i!=="mid-call")p?.then(()=>{this._logger.info(`Successfully set call constraints at call ${i} - ${JSON.stringify(this._currentVideoConstraints)}`),d()}).catch(g=>{this._logger.error(`Error setting call constraints at call ${i}`);const f=new Oe({defaultError:we.CALL.SET_CONSTRAINTS_START_OR_ACCEPT,defaultErrorMessageArgs:[i],originalError:g});d(f)});else try{await p,this._logger.info(`Successfully set call constraints during ${i} - ${JSON.stringify(this._currentVideoConstraints)}`),d()}catch(g){throw new Oe({defaultError:we.CALL.SET_CONSTRAINTS_MID_CALL,originalError:g})}return this._currentVideoConstraints}catch(h){const p=new Oe({defaultError:we.CALL.SET_CONSTRAINTS,defaultErrorMessageArgs:[i],originalError:h});throw d(p),p}}getTelemetryPayload(e){return{video:{send:{frameHeight:{max:e.video?.send?.frameHeight?.max},frameRate:{max:e.video?.send?.frameRate?.max},bitrate:{max:e.video?.send?.bitrate?.max}}}}}_updateVideoConstraintsCache(e){const i=wt(),r=i.calling.constraints.maxOutgoingResolution,o=i.calling.constraints.maxOutgoingFrameRate,l=i.calling.constraints.maxOutgoingVideoBitrate,d=e?.send?.frameHeight?.max??this._currentVideoConstraints.send?.frameHeight?.max,h=e?.send?.frameRate?.max??this._currentVideoConstraints.send?.frameRate?.max,p=e?.send?.bitrate?.max??this._currentVideoConstraints.send?.bitrate?.max;this._currentVideoConstraints={send:{frameHeight:{max:this._getConstraintValue(r,"maxOutgoingResolution",d)},frameRate:{max:this._getConstraintValue(o,"maxOutgoingFrameRate",h)},bitrate:{max:this._getConstraintValue(l,"maxOutgoingBitrate",p)}}}}_getConstraintValue(e,i,r){return typeof r=="number"?r<1?void this._logger.info(`Received ${i} as 0 or less, removing ${i} constraint`):(e>0&&r>e&&(this._logger.info(`${i} value ${r} is larger than ${e}, resetting to ${e}`),r=e),r):void this._logger.warn(`Received invalid ${i} value, removing ${i} constraint`)}}vVt([zv,yVt("design:type",Object)],j5e.prototype,"_logger",void 0);var ZQ=function(t,e,i,r){var o,l=arguments.length,d=l<3?e:r===null?r=Object.getOwnPropertyDescriptor(e,i):r;if(typeof Reflect=="object"&&typeof Reflect.decorate=="function")d=Reflect.decorate(t,e,i,r);else for(var h=t.length-1;h>=0;h--)(o=t[h])&&(d=(l<3?o(d):l>3?o(e,i,d):o(e,i))||d);return l>3&&d&&Object.defineProperty(e,i,d),d},Ck=function(t,e){if(typeof Reflect=="object"&&typeof Reflect.metadata=="function")return Reflect.metadata(t,e)};class t8{constructor(e,i,r,o){this.logger=r.createChild("Lobby"),this._tsCall=e,this._eventEmitter=new qf(this.logger),this._participants=new Map,this._call=i,this._telemetryLogManager=o,this._lobbySupportedConversationTypes=wt().calling.lobbyAdmitAndReject.supportedConversationTypes,this._isLobbyEnabled=wt().calling.lobbyAdmitAndReject.enabled,this._hasExpectedError=!1,this._isLobbyEnabled&&(this.getInLobbyParticipants(i.remoteParticipants),this._remoteParticipantUpdatedListener=l=>{if(l.added.length!==0&&l.added.forEach(d=>{d.state==="InLobby"&&this.addLobbyParticipant(d),d.on("stateChanged",()=>{d.state==="InLobby"?this.addLobbyParticipant(d):d.state==="Connected"&&this.removeLobbyParticipant(d)})}),l.removed.length!==0){if(this._call.remoteParticipants.length===0)return void this.removeAllLobbyParticipants();l.removed.forEach(d=>{this.removeLobbyParticipant(d)})}},this._call.on("remoteParticipantsUpdated",this._remoteParticipantUpdatedListener))}on(e,i){if(e!=="lobbyParticipantsUpdated")throw new Oe({defaultError:we.LOBBY.EVENT_SUBSCRIBE,defaultErrorMessageArgs:[e]});this._eventEmitter.on(e,i)}off(e,i){if(e!=="lobbyParticipantsUpdated")throw new Oe({defaultError:we.LOBBY.EVENT_UNSUBSCRIBE,defaultErrorMessageArgs:[e]});this._eventEmitter.off(e,i)}async admit(e,i){if(!this._isLobbyEnabled)return void this.logger.warn("Lobby is not enabled");const r=ln(),o=+new Date;this._sendLobbyAdmitAndRejectUsage("Start admit participant",OE.lobbyAdmit,r,Je.attempt,void 0);try{LA(e),this.validateLobbyOperation(e),await this._tsCall.admitParticipant(zr(e));const l=+new Date;this._sendLobbyAdmitAndRejectUsage("Lobby participant admitted successfully",OE.lobbyAdmit,r,Je.success,l-o)}catch(l){let d=ts.Unexpected;this._hasExpectedError&&(d=ts.Expected,this._hasExpectedError=!1),this.handleLobbyAdmitAndRejectFailure("Failed to admit participant from lobby",l,r,o,OE.lobbyAdmit,d)}}async reject(e,i){if(!this._isLobbyEnabled)return void this.logger.warn("Lobby is not enabled");const r=ln(),o=+new Date;this._sendLobbyAdmitAndRejectUsage("Start reject participant",OE.lobbyReject,r,Je.attempt,void 0);try{LA(e),this.validateLobbyOperation(e),await this._tsCall.removeParticipant(zr(e));const l=+new Date;this._sendLobbyAdmitAndRejectUsage("Lobby participant rejected successfully",OE.lobbyReject,r,Je.success,l-o)}catch(l){let d=ts.Unexpected;this._hasExpectedError&&(d=ts.Expected,this._hasExpectedError=!1),this.handleLobbyAdmitAndRejectFailure("Failed to reject participant from lobby",l,r,o,OE.lobbyReject,d)}}async admitAll(e){const i=ln(),r=+new Date;let o,l=0,d=0;if(!this._isLobbyEnabled)return this.logger.warn("Lobby is not enabled"),{successCount:l,failureCount:d};this._sendLobbyAdmitAndRejectUsage("Start admit all participants",OE.lobbyAdmitAll,i,Je.attempt,void 0);try{this.validateLobbyOperation(),await this._tsCall.admit({scope:"all"},fd()).then(p=>{if(o=p,p.result){const g=JSON.parse(p.result);l=g.successCount,d=g.failureCount}});const h=+new Date;if(d!==0)return this._sendLobbyAdmitAndRejectUsage(`${l} participants are admitted successfully, ${d} participants admit failed. TransactionEnd: ${o}`,OE.lobbyAdmitAll,i,Je.success,h-r),{successCount:l,failureCount:d};this._sendLobbyAdmitAndRejectUsage("All participants are admitted successfully",OE.lobbyAdmitAll,i,Je.success,h-r)}catch(h){let p=ts.Unexpected;this._hasExpectedError&&(p=ts.Expected,this._hasExpectedError=!1),this.handleLobbyAdmitAndRejectFailure("Failed to admit all participants from lobby",h,i,r,OE.lobbyAdmitAll,p)}return{successCount:l,failureCount:d}}get participants(){return this._isLobbyEnabled?Array.from(this._participants.values()):(this.logger.warn("Lobby is not enabled"),[])}getInLobbyParticipants(e){e.forEach(i=>{if(i.state==="InLobby"){const r=zr(i.identifier);this._participants.set(r,i)}})}removeAllLobbyParticipants(){if(this._participants.size===0)return;const e=Array.from(this._participants.values());this._participants.clear(),this.logger.info("All participants are removed from lobby"),this._eventEmitter.emit("lobbyParticipantsUpdated",{added:[],removed:e})}removeLobbyParticipant(e){const i=zr(e.identifier);this._participants.has(i)&&(this.logger.info(`${Ap(e.identifier).kind} is removed from lobby`),this._participants.delete(i),this._eventEmitter.emit("lobbyParticipantsUpdated",{added:[],removed:[e]}))}addLobbyParticipant(e){const i=zr(e.identifier);this._participants.has(i)||(this.logger.info(`${Ap(e.identifier).kind} is added to lobby`),this._participants.set(i,e),this._eventEmitter.emit("lobbyParticipantsUpdated",{added:[e],removed:[]}))}validateLobbyOperation(e){const i=this._tsCall.conversationType?this._tsCall.conversationType:"oneToOneCall";if(this.logger.info("Current conversation type is: ",i),!this._lobbySupportedConversationTypes.find(r=>r===i))throw this._hasExpectedError=!0,new Oe({defaultError:we.LOBBY.CONV_UNSUPPORTED});if(e){let r=this._call.remoteParticipants.find(o=>zr(o.identifier)===zr(e));if(r&&r.state==="Connected")throw this._hasExpectedError=!0,new Oe({defaultError:we.LOBBY.ALREADY_IN_MEETING,defaultErrorMessageArgs:[Ap(e).kind]});if(r&&r.state!=="InLobby"||!r)throw this._hasExpectedError=!0,new Oe({defaultError:we.LOBBY.NOT_IN_LOBBY,defaultErrorMessageArgs:[Ap(e).kind]})}if(this._call.role!==Dd.Presenter&&this._call.role!==Dd.Organizer&&this._call.role!==Dd.Coorganizer)throw this._hasExpectedError=!0,new Oe({defaultError:we.LOBBY.UNAUTHORIZED_ADMIT_REJECT})}handleLobbyAdmitAndRejectFailure(e,i,r,o,l,d){const h=+new Date,p=u2t(this.logger,i,e);throw this._sendLobbyAdmitAndRejectUsage(p.message,l,r,Je.failure,h-o,d,i),p}_sendLobbyAdmitAndRejectUsage(e,i,r,o,l,d,h){o===Je.failure?this.logger.error(e):this.logger.info(e),this.sendLobbyAdmitAndRejectEvent({eventName:vi.acs_calling_lobby_events,callId:this._call.id,localParticipantId:this._tsCall.participantId,correlationId:r,kindOfEvent:o,operation:i,isExpected:d??"",timestampInfo:l?{deltaTimeInMs:l}:"",additionalDetails:h?{failureReason:h.message,code:h.code,subCode:h.subCode,...an(h)}:""})}sendLobbyAdmitAndRejectEvent(e){try{this._telemetryLogManager.sendEvent({name:e.eventName,tenant:Wr,properties:e})}catch{this.logger.debug("Unable to send lobby admit and reject telemetry")}}}function G5e(){const t=window.navigator.mediaDevices;if(t?.isRemote){const e=t?.MSRDC_MMR_Shim?.remoteObjectManager?.isConnected;if(e===!0)return"connected";if(e===!1)return"disconnected"}return""}function q5e(t){const e=window.navigator.mediaDevices,i={isMMREnabled:e?.isRemote??!1,isVdi3Enabled:t};return i.isMMREnabled&&(e?.mmrClientVersion&&(i.mmrClientVersion=e.mmrClientVersion),e?.mmrExtensionVersion&&(i.mmrExtensionVersion=e.mmrExtensionVersion),e?.mmrHostVersion&&(i.mmrHostVersion=e.mmrHostVersion),e?.activityId&&(i.mmrActivityId=e.activityId),e?.connectionId&&(i.mmrConnectionId=e.connectionId),i.mmrRdpState=G5e()),i}ZQ([zv,Ck("design:type",Object)],t8.prototype,"logger",void 0),ZQ([to(Ar.LobbyAdmitParticipant),Ck("design:type",Function),Ck("design:paramtypes",[Object,Object]),Ck("design:returntype",Promise)],t8.prototype,"admit",null),ZQ([to(Ar.LobbyRejectParticipant),Ck("design:type",Function),Ck("design:paramtypes",[Object,Object]),Ck("design:returntype",Promise)],t8.prototype,"reject",null),ZQ([to(Ar.LobbyAdmitAll),Ck("design:type",Function),Ck("design:paramtypes",[Object]),Ck("design:returntype",Promise)],t8.prototype,"admitAll",null);class W5e{constructor(e){this._lastState="",this._callback=r=>{const o=r?.detail?.state??"";o?o!==this._lastState&&(this._logger.info(`connection state is ${o}`),this._eventEmitter.emit("stateChange",o),this._lastState=o):this._logger.info("connection state is unknown")},this._logger=e.createChild("MmrRdpConnectionManager"),this._eventEmitter=new $c.EventEmitter;const i=window.navigator.mediaDevices;i?.isRemote&&(i?.addEventListener("rdpClientConnectionStateChanged",this._callback),this._logger.info("listener registered"))}on(e,i){this._eventEmitter.on(e,i)}off(e,i){this._eventEmitter.off(e,i)}get state(){return G5e()}dispose(){const e=window.navigator.mediaDevices;e?.isRemote&&(e?.removeEventListener("rdpClientConnectionStateChanged",this._callback),this._logger.info("event listener unregistered")),this._eventEmitter.removeAllListeners()}}var SVt=function(t,e,i,r){var o,l=arguments.length,d=l<3?e:r===null?r=Object.getOwnPropertyDescriptor(e,i):r;if(typeof Reflect=="object"&&typeof Reflect.decorate=="function")d=Reflect.decorate(t,e,i,r);else for(var h=t.length-1;h>=0;h--)(o=t[h])&&(d=(l<3?o(d):l>3?o(e,i,d):o(e,i))||d);return l>3&&d&&Object.defineProperty(e,i,d),d},Gpe=function(t,e){if(typeof Reflect=="object"&&typeof Reflect.metadata=="function")return Reflect.metadata(t,e)};class Q3 extends FB{constructor(e,i,r,o,l,d,h){const p=l.id;super(e,i,r,p,d,"RemoteVideoStream"),this._remoteParticipantIdentifier=h,this._isAvailable=!1,this.setIsAvailable=y=>{y!==this._isAvailable&&(this._isAvailable=!!y,this.logger.log(`isAvailable changed to ${this._isAvailable}`),this._eventEmitter.emit("isAvailableChanged",this._isAvailable),this.call.isHandlingLargeMeetingVideoRendering&&this.call.handleDominantSpeakersVideos(),super.sendRemoteVideoStreamTelemetry())};const g=()=>{if(this.mediaStreamType==="Video"&&r.isHandlingLargeMeetingVideoRendering){for(const y of r.getTopNDominantSpeakersWithVideoOn())if(this.tsStream.isAvailable&&zr(y.identifier)===zr(this._remoteParticipantIdentifier))return void this.setIsAvailable(!0);this.setIsAvailable(!1)}else l.state!==7?(l.state===3&&f.dispose(),this.setIsAvailable(this.tsStream.isAvailable)):this.setIsAvailable(!1)};this._streamChangedHandler=this.tsStream.changed(()=>{g()});const f=l.changed(()=>{g()});g()}on(e,i){if(e!=="isAvailableChanged"&&e!=="sizeChanged"&&e!=="isReceivingChanged")throw new Oe({defaultError:we.REMOTE_VIDEO_STREAM.EVENT_SUBSCRIBE,defaultErrorMessageArgs:[e]});this._eventEmitter.on(e,i)}off(e,i){if(e!=="isAvailableChanged"&&e!=="sizeChanged"&&e!=="isReceivingChanged")throw new Oe({defaultError:we.REMOTE_VIDEO_STREAM.EVENT_UNSUBSCRIBE,defaultErrorMessageArgs:[e]});this._eventEmitter.off(e,i)}get isAvailable(){return this._isAvailable}async getMediaStream(){const e=ln(),i=+new Date,r={correlationId:e,additionalDetails:{remoteStreamMetadata:this.getStreamMetadata(),mediaSourceId:this.tsStream.mediaSourceId},operation:Sr.getMediaStream,mediaType:this.getMediaType(),streamType:Ts.Remote,timestampInfo:{attemptTimestamp:i},kindOfEvent:Je.attempt,localParticipantId:this.call.tsCall.participantId,callId:this.call.id};this.sendMediaStreamEvent(r);try{if(!this.tsStream.getRawStream)throw new Oe({defaultError:we.REMOTE_VIDEO_STREAM.GET_RAW_MEDIA_STREAM});if(!this.tsStream.isAvailable)throw new Oe({defaultError:we.REMOTE_VIDEO_STREAM.RAWMEDIA_LVS_NOT_AVAILABLE});const o=this.tsStream.getRawStream(),l=new Promise(async(f,y)=>{const T=setTimeout(()=>{C.dispose(),y(new Oe({defaultError:we.REMOTE_VIDEO_STREAM.SUBSCRIBE_MEDIA_STREAM_TIMEOUT}))},wt().rendering.remoteVideo.getMediaStreamTimeout),C=o.changed(()=>{E()}),E=async()=>{try{const I=await o.getMediaStream();if(!I)return void this.logger.warn("MediaStream is not yet ready.");clearTimeout(T),C.dispose(),f(I)}catch(I){this.logger.warn(`MediaStream is not yet ready, error=${I?.message||"unknown"}`)}};E()}),d=await l,h=d.getVideoTracks()[0];if(!h)throw new Oe({defaultError:we.REMOTE_VIDEO_STREAM.GET_TRACK});await new Promise((f,y)=>{const T=()=>{h.removeEventListener("unmute",T,!1),f()};h.addEventListener("unmute",T,!1),h.muted?setTimeout(()=>{h.removeEventListener("unmute",T,!1),y(new Oe({defaultError:we.REMOTE_VIDEO_STREAM.TRACK_UNMUTED_TIMEOUT}))},wt().rendering.remoteVideo.getMediaStreamTimeout):T()});const g={correlationId:e,additionalDetails:{remoteStreamMetadata:this.getStreamMetadata(),mediaSourceId:this.tsStream.mediaSourceId},operation:Sr.getMediaStream,mediaType:this.getMediaType(),streamType:Ts.Remote,timestampInfo:{deltaTimeInMs:+new Date-i},kindOfEvent:Je.success,localParticipantId:this.call.tsCall.participantId,callId:this.call.id};return this.sendMediaStreamEvent(g),d}catch(o){const l={correlationId:e,operation:Sr.getMediaStream,mediaType:this.getMediaType(),streamType:Ts.Remote,additionalDetails:{failureReason:o?.message||"",code:o.code||jL,...an(o),remoteStreamMetadata:this.getStreamMetadata(),mediaSourceId:this.tsStream.mediaSourceId},timestampInfo:{deltaTimeInMs:+new Date-i},kindOfEvent:Je.failure,localParticipantId:this.call.tsCall.participantId,callId:this.call.id};throw this.sendMediaStreamEvent(l),new Oe({defaultError:we.REMOTE_VIDEO_STREAM.GET_MEDIA_STREAM,originalError:o})}}getStreamMetadata(){return{callId:this.call?.id,streamType:this.mediaStreamType,localParticipantId:this.call.tsCall.participantId,remoteParticipantId:this.remoteParticipantId,sourceId:this.id,source:"remote",rank:this.tsStream.rank,isAvailable:this.tsStream.isAvailable,acsIsAvailable:this._isAvailable,isReceiving:this._isReceiving,isStreaming:this.tsStream.isStreaming,viewIdsRegistered:this._renderers.map(e=>e.viewId).join(", "),height:this._size.height,width:this._size.width,isDisposed:this._disposed,optimalVideoCount:this.call?.tsCall.optimalVideoCount||1,currentNumberOfVideosRendered:this.call?.activeRemoteVideoStreamViews?.size||0}}dispose(){this.setIsAvailable(!1),super.dispose()}getMediaType(){return this.mediaStreamType==="ScreenSharing"?Zc.ScreenSharingRaw:Zc.VideoRaw}sendMediaStreamEvent(e){this.telemetryLogManager.sendEvent({name:vi.acs_calling_media_stream,tenant:Wr,properties:{timestampInfo:e.timestampInfo,correlationId:e.correlationId,additionalDetails:e.additionalDetails||"",kindOfEvent:e.kindOfEvent||"",mediaType:e.mediaType,streamType:e.streamType,operation:e.operation,localParticipantId:e.localParticipantId||"",callId:e.callId||""}})}}SVt([to(yhe.GetMediaStream),Gpe("design:type",Function),Gpe("design:paramtypes",[]),Gpe("design:returntype",Promise)],Q3.prototype,"getMediaStream",null);const io={14:"#242424",16:"#292929",20:"#333333",26:"#424242",30:"#4d4d4d",34:"#575757",38:"#616161",44:"#707070",70:"#b3b3b3",74:"#bdbdbd",78:"#c7c7c7",82:"#d1d1d1",84:"#d6d6d6",86:"#dbdbdb",88:"#e0e0e0",90:"#e6e6e6",92:"#ebebeb",94:"#f0f0f0",96:"#f5f5f5",98:"#fafafa"},DO={10:"rgba(255, 255, 255, 0.1)",20:"rgba(255, 255, 255, 0.2)",40:"rgba(255, 255, 255, 0.4)",50:"rgba(255, 255, 255, 0.5)",70:"rgba(255, 255, 255, 0.7)",80:"rgba(255, 255, 255, 0.8)"},LO={5:"rgba(0, 0, 0, 0.05)",10:"rgba(0, 0, 0, 0.1)",20:"rgba(0, 0, 0, 0.2)",30:"rgba(0, 0, 0, 0.3)",40:"rgba(0, 0, 0, 0.4)",50:"rgba(0, 0, 0, 0.5)"},gg="#ffffff",bVt="#000000",K5e={shade50:"#200205",shade40:"#3b0509",shade30:"#6e0811",shade20:"#960b18",shade10:"#b10e1c",primary:"#c50f1f",tint10:"#cc2635",tint20:"#d33f4c",tint30:"#dc626d",tint40:"#eeacb2",tint50:"#f6d1d5",tint60:"#fdf3f4"},J5e={shade50:"#031403",shade40:"#052505",shade30:"#094509",shade20:"#0c5e0c",shade10:"#0e700e",primary:"#107c10",tint10:"#218c21",tint20:"#359b35",tint30:"#54b054",tint40:"#9fd89f",tint50:"#c9eac9",tint60:"#f1faf1"},WC={red:{shade50:"#210809",shade40:"#3f1011",shade30:"#751d1f",shade20:"#9f282b",shade10:"#bc2f32",primary:"#d13438",tint10:"#d7494c",tint20:"#dc5e62",tint30:"#e37d80",tint40:"#f1bbbc",tint50:"#f8dadb",tint60:"#fdf6f6"},green:J5e,darkOrange:{shade50:"#230900",shade40:"#411200",shade30:"#7a2101",shade20:"#a62d01",shade10:"#c43501",primary:"#da3b01",tint10:"#de501c",tint20:"#e36537",tint30:"#e9835e",tint40:"#f4bfab",tint50:"#f9dcd1",tint60:"#fdf6f3"},yellow:{shade50:"#282400",shade40:"#4c4400",shade30:"#817400",shade20:"#c0ad00",shade10:"#e4cc00",primary:"#fde300",tint10:"#fde61e",tint20:"#fdea3d",tint30:"#feee66",tint40:"#fef7b2",tint50:"#fffad6",tint60:"#fffef5"},berry:{shade50:"#1f091d",shade40:"#3a1136",shade30:"#6d2064",shade20:"#932b88",shade10:"#af33a1",primary:"#c239b3",tint10:"#c94cbc",tint20:"#d161c4",tint30:"#da7ed0",tint40:"#edbbe7",tint50:"#f5daf2",tint60:"#fdf5fc"},lightGreen:{shade50:"#031a02",shade40:"#063004",shade30:"#0b5a08",shade20:"#0e7a0b",shade10:"#11910d",primary:"#13a10e",tint10:"#27ac22",tint20:"#3db838",tint30:"#5ec75a",tint40:"#a7e3a5",tint50:"#cef0cd",tint60:"#f2fbf2"},marigold:{shade50:"#251a00",shade40:"#463100",shade30:"#835b00",shade20:"#b27c00",shade10:"#d39300",primary:"#eaa300",tint10:"#edad1c",tint20:"#efb839",tint30:"#f2c661",tint40:"#f9e2ae",tint50:"#fcefd3",tint60:"#fefbf4"}},qpe={darkRed:{shade50:"#130204",shade40:"#230308",shade30:"#420610",shade20:"#590815",shade10:"#690a19",primary:"#750b1c",tint10:"#861b2c",tint20:"#962f3f",tint30:"#ac4f5e",tint40:"#d69ca5",tint50:"#e9c7cd",tint60:"#f9f0f2"},cranberry:K5e,pumpkin:{shade50:"#200d03",shade40:"#3d1805",shade30:"#712d09",shade20:"#9a3d0c",shade10:"#b6480e",primary:"#ca5010",tint10:"#d06228",tint20:"#d77440",tint30:"#df8e64",tint40:"#efc4ad",tint50:"#f7dfd2",tint60:"#fdf7f4"},peach:{shade50:"#291600",shade40:"#4d2a00",shade30:"#8f4e00",shade20:"#c26a00",shade10:"#e67e00",primary:"#ff8c00",tint10:"#ff9a1f",tint20:"#ffa83d",tint30:"#ffba66",tint40:"#ffddb3",tint50:"#ffedd6",tint60:"#fffaf5"},gold:{shade50:"#1f1900",shade40:"#3a2f00",shade30:"#6c5700",shade20:"#937700",shade10:"#ae8c00",primary:"#c19c00",tint10:"#c8a718",tint20:"#d0b232",tint30:"#dac157",tint40:"#ecdfa5",tint50:"#f5eece",tint60:"#fdfbf2"},brass:{shade50:"#181202",shade40:"#2e2103",shade30:"#553e06",shade20:"#745408",shade10:"#89640a",primary:"#986f0b",tint10:"#a47d1e",tint20:"#b18c34",tint30:"#c1a256",tint40:"#e0cea2",tint50:"#efe4cb",tint60:"#fbf8f2"},brown:{shade50:"#170e07",shade40:"#2b1a0e",shade30:"#50301a",shade20:"#6c4123",shade10:"#804d29",primary:"#8e562e",tint10:"#9c663f",tint20:"#a97652",tint30:"#bb8f6f",tint40:"#ddc3b0",tint50:"#edded3",tint60:"#faf7f4"},forest:{shade50:"#0c1501",shade40:"#162702",shade30:"#294903",shade20:"#376304",shade10:"#427505",primary:"#498205",tint10:"#599116",tint20:"#6ba02b",tint30:"#85b44c",tint40:"#bdd99b",tint50:"#dbebc7",tint60:"#f6faf0"},seafoam:{shade50:"#002111",shade40:"#003d20",shade30:"#00723b",shade20:"#009b51",shade10:"#00b85f",primary:"#00cc6a",tint10:"#19d279",tint20:"#34d889",tint30:"#5ae0a0",tint40:"#a8f0cd",tint50:"#cff7e4",tint60:"#f3fdf8"},darkGreen:{shade50:"#021102",shade40:"#032003",shade30:"#063b06",shade20:"#085108",shade10:"#0a5f0a",primary:"#0b6a0b",tint10:"#1a7c1a",tint20:"#2d8e2d",tint30:"#4da64d",tint40:"#9ad29a",tint50:"#c6e7c6",tint60:"#f0f9f0"},lightTeal:{shade50:"#001d1f",shade40:"#00373a",shade30:"#00666d",shade20:"#008b94",shade10:"#00a5af",primary:"#00b7c3",tint10:"#18bfca",tint20:"#32c8d1",tint30:"#58d3db",tint40:"#a6e9ed",tint50:"#cef3f5",tint60:"#f2fcfd"},teal:{shade50:"#001516",shade40:"#012728",shade30:"#02494c",shade20:"#026467",shade10:"#037679",primary:"#038387",tint10:"#159195",tint20:"#2aa0a4",tint30:"#4cb4b7",tint40:"#9bd9db",tint50:"#c7ebec",tint60:"#f0fafa"},steel:{shade50:"#000f12",shade40:"#001b22",shade30:"#00333f",shade20:"#004555",shade10:"#005265",primary:"#005b70",tint10:"#0f6c81",tint20:"#237d92",tint30:"#4496a9",tint40:"#94c8d4",tint50:"#c3e1e8",tint60:"#eff7f9"},blue:{shade50:"#001322",shade40:"#002440",shade30:"#004377",shade20:"#005ba1",shade10:"#006cbf",primary:"#0078d4",tint10:"#1a86d9",tint20:"#3595de",tint30:"#5caae5",tint40:"#a9d3f2",tint50:"#d0e7f8",tint60:"#f3f9fd"},royalBlue:{shade50:"#000c16",shade40:"#00172a",shade30:"#002c4e",shade20:"#003b6a",shade10:"#00467e",primary:"#004e8c",tint10:"#125e9a",tint20:"#286fa8",tint30:"#4a89ba",tint40:"#9abfdc",tint50:"#c7dced",tint60:"#f0f6fa"},cornflower:{shade50:"#0d1126",shade40:"#182047",shade30:"#2c3c85",shade20:"#3c51b4",shade10:"#4760d5",primary:"#4f6bed",tint10:"#637cef",tint20:"#778df1",tint30:"#93a4f4",tint40:"#c8d1fa",tint50:"#e1e6fc",tint60:"#f7f9fe"},navy:{shade50:"#00061d",shade40:"#000c36",shade30:"#001665",shade20:"#001e89",shade10:"#0023a2",primary:"#0027b4",tint10:"#173bbd",tint20:"#3050c6",tint30:"#546fd2",tint40:"#a3b2e8",tint50:"#ccd5f3",tint60:"#f2f4fc"},lavender:{shade50:"#120f25",shade40:"#221d46",shade30:"#3f3682",shade20:"#5649b0",shade10:"#6656d1",primary:"#7160e8",tint10:"#8172eb",tint20:"#9184ee",tint30:"#a79cf1",tint40:"#d2ccf8",tint50:"#e7e4fb",tint60:"#f9f8fe"},purple:{shade50:"#0f0717",shade40:"#1c0e2b",shade30:"#341a51",shade20:"#46236e",shade10:"#532982",primary:"#5c2e91",tint10:"#6b3f9e",tint20:"#7c52ab",tint30:"#9470bd",tint40:"#c6b1de",tint50:"#e0d3ed",tint60:"#f7f4fb"},grape:{shade50:"#160418",shade40:"#29072e",shade30:"#4c0d55",shade20:"#671174",shade10:"#7a1589",primary:"#881798",tint10:"#952aa4",tint20:"#a33fb1",tint30:"#b55fc1",tint40:"#d9a7e0",tint50:"#eaceef",tint60:"#faf2fb"},lilac:{shade50:"#1c0b1f",shade40:"#35153a",shade30:"#63276d",shade20:"#863593",shade10:"#9f3faf",primary:"#b146c2",tint10:"#ba58c9",tint20:"#c36bd1",tint30:"#cf87da",tint40:"#e6bfed",tint50:"#f2dcf5",tint60:"#fcf6fd"},pink:{shade50:"#24091b",shade40:"#441232",shade30:"#80215d",shade20:"#ad2d7e",shade10:"#cd3595",primary:"#e43ba6",tint10:"#e750b0",tint20:"#ea66ba",tint30:"#ef85c8",tint40:"#f7c0e3",tint50:"#fbddf0",tint60:"#fef6fb"},magenta:{shade50:"#1f0013",shade40:"#390024",shade30:"#6b0043",shade20:"#91005a",shade10:"#ac006b",primary:"#bf0077",tint10:"#c71885",tint20:"#ce3293",tint30:"#d957a8",tint40:"#eca5d1",tint50:"#f5cee6",tint60:"#fcf2f9"},plum:{shade50:"#13000c",shade40:"#240017",shade30:"#43002b",shade20:"#5a003b",shade10:"#6b0045",primary:"#77004d",tint10:"#87105d",tint20:"#98246f",tint30:"#ad4589",tint40:"#d696c0",tint50:"#e9c4dc",tint60:"#faf0f6"},beige:{shade50:"#141313",shade40:"#252323",shade30:"#444241",shade20:"#5d5958",shade10:"#6e6968",primary:"#7a7574",tint10:"#8a8584",tint20:"#9a9594",tint30:"#afabaa",tint40:"#d7d4d4",tint50:"#eae8e8",tint60:"#faf9f9"},mink:{shade50:"#0f0e0e",shade40:"#1c1b1a",shade30:"#343231",shade20:"#474443",shade10:"#54514f",primary:"#5d5a58",tint10:"#706d6b",tint20:"#84817e",tint30:"#9e9b99",tint40:"#cecccb",tint50:"#e5e4e3",tint60:"#f8f8f8"},platinum:{shade50:"#111314",shade40:"#1f2426",shade30:"#3b4447",shade20:"#505c60",shade10:"#5f6d71",primary:"#69797e",tint10:"#79898d",tint20:"#89989d",tint30:"#a0adb2",tint40:"#cdd6d8",tint50:"#e4e9ea",tint60:"#f8f9fa"},anchor:{shade50:"#090a0b",shade40:"#111315",shade30:"#202427",shade20:"#2b3135",shade10:"#333a3f",primary:"#394146",tint10:"#4d565c",tint20:"#626c72",tint30:"#808a90",tint40:"#bcc3c7",tint50:"#dbdfe1",tint60:"#f6f7f8"}},ab={cranberry:K5e,green:J5e,orange:{shade50:"#271002",shade40:"#4a1e04",shade30:"#8a3707",shade20:"#bc4b09",shade10:"#de590b",primary:"#f7630c",tint10:"#f87528",tint20:"#f98845",tint30:"#faa06b",tint40:"#fdcfb4",tint50:"#fee5d7",tint60:"#fff9f5"}},TVt=["darkRed","cranberry","pumpkin","peach","gold","brass","brown","forest","seafoam","darkGreen","lightTeal","teal","steel","blue","royalBlue","cornflower","navy","lavender","purple","grape","lilac","pink","magenta","plum","beige","mink","platinum","anchor"],Z3={success:"green",warning:"orange",danger:"cranberry"},i8=["red","green","darkOrange","yellow","berry","lightGreen","marigold"].reduce((t,e)=>{const i=e.slice(0,1).toUpperCase()+e.slice(1),r={[`colorPalette${i}Background1`]:WC[e].tint60,[`colorPalette${i}Background2`]:WC[e].tint40,[`colorPalette${i}Background3`]:WC[e].primary,[`colorPalette${i}Foreground1`]:WC[e].shade10,[`colorPalette${i}Foreground2`]:WC[e].shade30,[`colorPalette${i}Foreground3`]:WC[e].primary,[`colorPalette${i}BorderActive`]:WC[e].primary,[`colorPalette${i}Border1`]:WC[e].tint40,[`colorPalette${i}Border2`]:WC[e].primary};return Object.assign(t,r)},{});i8.colorPaletteYellowForeground1=WC.yellow.shade30,i8.colorPaletteRedForegroundInverted=WC.red.tint20,i8.colorPaletteGreenForegroundInverted=WC.green.tint20,i8.colorPaletteYellowForegroundInverted=WC.yellow.tint40;const CVt=TVt.reduce((t,e)=>{const i=e.slice(0,1).toUpperCase()+e.slice(1),r={[`colorPalette${i}Background2`]:qpe[e].tint40,[`colorPalette${i}Foreground2`]:qpe[e].shade30,[`colorPalette${i}BorderActive`]:qpe[e].primary};return Object.assign(t,r)},{}),_Vt={...i8,...CVt},X3=Object.entries(Z3).reduce((t,[e,i])=>{const r=e.slice(0,1).toUpperCase()+e.slice(1),o={[`colorStatus${r}Background1`]:ab[i].tint60,[`colorStatus${r}Background2`]:ab[i].tint40,[`colorStatus${r}Background3`]:ab[i].primary,[`colorStatus${r}Foreground1`]:ab[i].shade10,[`colorStatus${r}Foreground2`]:ab[i].shade30,[`colorStatus${r}Foreground3`]:ab[i].primary,[`colorStatus${r}ForegroundInverted`]:ab[i].tint30,[`colorStatus${r}BorderActive`]:ab[i].primary,[`colorStatus${r}Border1`]:ab[i].tint40,[`colorStatus${r}Border2`]:ab[i].primary};return Object.assign(t,o)},{});X3.colorStatusDangerBackground3Hover=ab[Z3.danger].shade10,X3.colorStatusDangerBackground3Pressed=ab[Z3.danger].shade20,X3.colorStatusWarningForeground1=ab[Z3.warning].shade20,X3.colorStatusWarningForeground3=ab[Z3.warning].shade20,X3.colorStatusWarningBorder2=ab[Z3.warning].shade20;const EVt=t=>({colorNeutralForeground1:io[14],colorNeutralForeground1Hover:io[14],colorNeutralForeground1Pressed:io[14],colorNeutralForeground1Selected:io[14],colorNeutralForeground2:io[26],colorNeutralForeground2Hover:io[14],colorNeutralForeground2Pressed:io[14],colorNeutralForeground2Selected:io[14],colorNeutralForeground2BrandHover:t[80],colorNeutralForeground2BrandPressed:t[70],colorNeutralForeground2BrandSelected:t[80],colorNeutralForeground3:io[38],colorNeutralForeground3Hover:io[26],colorNeutralForeground3Pressed:io[26],colorNeutralForeground3Selected:io[26],colorNeutralForeground3BrandHover:t[80],colorNeutralForeground3BrandPressed:t[70],colorNeutralForeground3BrandSelected:t[80],colorNeutralForeground4:io[44],colorNeutralForegroundDisabled:io[74],colorNeutralForegroundInvertedDisabled:DO[40],colorBrandForegroundLink:t[70],colorBrandForegroundLinkHover:t[60],colorBrandForegroundLinkPressed:t[40],colorBrandForegroundLinkSelected:t[70],colorNeutralForeground2Link:io[26],colorNeutralForeground2LinkHover:io[14],colorNeutralForeground2LinkPressed:io[14],colorNeutralForeground2LinkSelected:io[14],colorCompoundBrandForeground1:t[80],colorCompoundBrandForeground1Hover:t[70],colorCompoundBrandForeground1Pressed:t[60],colorBrandForeground1:t[80],colorBrandForeground2:t[70],colorBrandForeground2Hover:t[60],colorBrandForeground2Pressed:t[30],colorNeutralForeground1Static:io[14],colorNeutralForegroundStaticInverted:gg,colorNeutralForegroundInverted:gg,colorNeutralForegroundInvertedHover:gg,colorNeutralForegroundInvertedPressed:gg,colorNeutralForegroundInvertedSelected:gg,colorNeutralForegroundInverted2:gg,colorNeutralForegroundOnBrand:gg,colorNeutralForegroundInvertedLink:gg,colorNeutralForegroundInvertedLinkHover:gg,colorNeutralForegroundInvertedLinkPressed:gg,colorNeutralForegroundInvertedLinkSelected:gg,colorBrandForegroundInverted:t[100],colorBrandForegroundInvertedHover:t[110],colorBrandForegroundInvertedPressed:t[100],colorBrandForegroundOnLight:t[80],colorBrandForegroundOnLightHover:t[70],colorBrandForegroundOnLightPressed:t[50],colorBrandForegroundOnLightSelected:t[60],colorNeutralBackground1:gg,colorNeutralBackground1Hover:io[96],colorNeutralBackground1Pressed:io[88],colorNeutralBackground1Selected:io[92],colorNeutralBackground2:io[98],colorNeutralBackground2Hover:io[94],colorNeutralBackground2Pressed:io[86],colorNeutralBackground2Selected:io[90],colorNeutralBackground3:io[96],colorNeutralBackground3Hover:io[92],colorNeutralBackground3Pressed:io[84],colorNeutralBackground3Selected:io[88],colorNeutralBackground4:io[94],colorNeutralBackground4Hover:io[98],colorNeutralBackground4Pressed:io[96],colorNeutralBackground4Selected:gg,colorNeutralBackground5:io[92],colorNeutralBackground5Hover:io[96],colorNeutralBackground5Pressed:io[94],colorNeutralBackground5Selected:io[98],colorNeutralBackground6:io[90],colorNeutralBackgroundInverted:io[16],colorNeutralBackgroundStatic:io[20],colorNeutralBackgroundAlpha:DO[50],colorNeutralBackgroundAlpha2:DO[80],colorSubtleBackground:"transparent",colorSubtleBackgroundHover:io[96],colorSubtleBackgroundPressed:io[88],colorSubtleBackgroundSelected:io[92],colorSubtleBackgroundLightAlphaHover:DO[70],colorSubtleBackgroundLightAlphaPressed:DO[50],colorSubtleBackgroundLightAlphaSelected:"transparent",colorSubtleBackgroundInverted:"transparent",colorSubtleBackgroundInvertedHover:LO[10],colorSubtleBackgroundInvertedPressed:LO[30],colorSubtleBackgroundInvertedSelected:LO[20],colorTransparentBackground:"transparent",colorTransparentBackgroundHover:"transparent",colorTransparentBackgroundPressed:"transparent",colorTransparentBackgroundSelected:"transparent",colorNeutralBackgroundDisabled:io[94],colorNeutralBackgroundInvertedDisabled:DO[10],colorNeutralStencil1:io[90],colorNeutralStencil2:io[98],colorNeutralStencil1Alpha:LO[10],colorNeutralStencil2Alpha:LO[5],colorBackgroundOverlay:LO[40],colorScrollbarOverlay:LO[50],colorBrandBackground:t[80],colorBrandBackgroundHover:t[70],colorBrandBackgroundPressed:t[40],colorBrandBackgroundSelected:t[60],colorCompoundBrandBackground:t[80],colorCompoundBrandBackgroundHover:t[70],colorCompoundBrandBackgroundPressed:t[60],colorBrandBackgroundStatic:t[80],colorBrandBackground2:t[160],colorBrandBackground2Hover:t[150],colorBrandBackground2Pressed:t[130],colorBrandBackground3Static:t[60],colorBrandBackground4Static:t[40],colorBrandBackgroundInverted:gg,colorBrandBackgroundInvertedHover:t[160],colorBrandBackgroundInvertedPressed:t[140],colorBrandBackgroundInvertedSelected:t[150],colorNeutralCardBackground:io[98],colorNeutralCardBackgroundHover:gg,colorNeutralCardBackgroundPressed:io[96],colorNeutralCardBackgroundSelected:io[92],colorNeutralCardBackgroundDisabled:io[94],colorNeutralStrokeAccessible:io[38],colorNeutralStrokeAccessibleHover:io[34],colorNeutralStrokeAccessiblePressed:io[30],colorNeutralStrokeAccessibleSelected:t[80],colorNeutralStroke1:io[82],colorNeutralStroke1Hover:io[78],colorNeutralStroke1Pressed:io[70],colorNeutralStroke1Selected:io[74],colorNeutralStroke2:io[88],colorNeutralStroke3:io[94],colorNeutralStrokeSubtle:io[88],colorNeutralStrokeOnBrand:gg,colorNeutralStrokeOnBrand2:gg,colorNeutralStrokeOnBrand2Hover:gg,colorNeutralStrokeOnBrand2Pressed:gg,colorNeutralStrokeOnBrand2Selected:gg,colorBrandStroke1:t[80],colorBrandStroke2:t[140],colorBrandStroke2Hover:t[120],colorBrandStroke2Pressed:t[80],colorBrandStroke2Contrast:t[140],colorCompoundBrandStroke:t[80],colorCompoundBrandStrokeHover:t[70],colorCompoundBrandStrokePressed:t[60],colorNeutralStrokeDisabled:io[88],colorNeutralStrokeInvertedDisabled:DO[40],colorTransparentStroke:"transparent",colorTransparentStrokeInteractive:"transparent",colorTransparentStrokeDisabled:"transparent",colorNeutralStrokeAlpha:LO[5],colorNeutralStrokeAlpha2:DO[20],colorStrokeFocus1:gg,colorStrokeFocus2:bVt,colorNeutralShadowAmbient:"rgba(0,0,0,0.12)",colorNeutralShadowKey:"rgba(0,0,0,0.14)",colorNeutralShadowAmbientLighter:"rgba(0,0,0,0.06)",colorNeutralShadowKeyLighter:"rgba(0,0,0,0.07)",colorNeutralShadowAmbientDarker:"rgba(0,0,0,0.20)",colorNeutralShadowKeyDarker:"rgba(0,0,0,0.24)",colorBrandShadowAmbient:"rgba(0,0,0,0.30)",colorBrandShadowKey:"rgba(0,0,0,0.25)"}),AVt={borderRadiusNone:"0",borderRadiusSmall:"2px",borderRadiusMedium:"4px",borderRadiusLarge:"6px",borderRadiusXLarge:"8px",borderRadiusCircular:"10000px"},IVt={curveAccelerateMax:"cubic-bezier(0.9,0.1,1,0.2)",curveAccelerateMid:"cubic-bezier(1,0,1,1)",curveAccelerateMin:"cubic-bezier(0.8,0,0.78,1)",curveDecelerateMax:"cubic-bezier(0.1,0.9,0.2,1)",curveDecelerateMid:"cubic-bezier(0,0,0,1)",curveDecelerateMin:"cubic-bezier(0.33,0,0.1,1)",curveEasyEaseMax:"cubic-bezier(0.8,0,0.2,1)",curveEasyEase:"cubic-bezier(0.33,0,0.67,1)",curveLinear:"cubic-bezier(0,0,1,1)"},wVt={durationUltraFast:"50ms",durationFaster:"100ms",durationFast:"150ms",durationNormal:"200ms",durationGentle:"250ms",durationSlow:"300ms",durationSlower:"400ms",durationUltraSlow:"500ms"},kVt={fontSizeBase100:"10px",fontSizeBase200:"12px",fontSizeBase300:"14px",fontSizeBase400:"16px",fontSizeBase500:"20px",fontSizeBase600:"24px",fontSizeHero700:"28px",fontSizeHero800:"32px",fontSizeHero900:"40px",fontSizeHero1000:"68px"},RVt={lineHeightBase100:"14px",lineHeightBase200:"16px",lineHeightBase300:"20px",lineHeightBase400:"22px",lineHeightBase500:"28px",lineHeightBase600:"32px",lineHeightHero700:"36px",lineHeightHero800:"40px",lineHeightHero900:"52px",lineHeightHero1000:"92px"},MVt={fontWeightRegular:400,fontWeightMedium:500,fontWeightSemibold:600,fontWeightBold:700},PVt={fontFamilyBase:"'Segoe UI', 'Segoe UI Web (West European)', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue', sans-serif",fontFamilyMonospace:"Consolas, 'Courier New', Courier, monospace",fontFamilyNumeric:"Bahnschrift, 'Segoe UI', 'Segoe UI Web (West European)', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue', sans-serif"},Rp={none:"0",xxs:"2px",xs:"4px",sNudge:"6px",s:"8px",mNudge:"10px",m:"12px",l:"16px",xl:"20px",xxl:"24px",xxxl:"32px"},DVt={spacingHorizontalNone:Rp.none,spacingHorizontalXXS:Rp.xxs,spacingHorizontalXS:Rp.xs,spacingHorizontalSNudge:Rp.sNudge,spacingHorizontalS:Rp.s,spacingHorizontalMNudge:Rp.mNudge,spacingHorizontalM:Rp.m,spacingHorizontalL:Rp.l,spacingHorizontalXL:Rp.xl,spacingHorizontalXXL:Rp.xxl,spacingHorizontalXXXL:Rp.xxxl},LVt={spacingVerticalNone:Rp.none,spacingVerticalXXS:Rp.xxs,spacingVerticalXS:Rp.xs,spacingVerticalSNudge:Rp.sNudge,spacingVerticalS:Rp.s,spacingVerticalMNudge:Rp.mNudge,spacingVerticalM:Rp.m,spacingVerticalL:Rp.l,spacingVerticalXL:Rp.xl,spacingVerticalXXL:Rp.xxl,spacingVerticalXXXL:Rp.xxxl},OVt={strokeWidthThin:"1px",strokeWidthThick:"2px",strokeWidthThicker:"3px",strokeWidthThickest:"4px"};function Y5e(t,e,i=""){return{[`shadow2${i}`]:`0 0 2px ${t}, 0 1px 2px ${e}`,[`shadow4${i}`]:`0 0 2px ${t}, 0 2px 4px ${e}`,[`shadow8${i}`]:`0 0 2px ${t}, 0 4px 8px ${e}`,[`shadow16${i}`]:`0 0 2px ${t}, 0 8px 16px ${e}`,[`shadow28${i}`]:`0 0 8px ${t}, 0 14px 28px ${e}`,[`shadow64${i}`]:`0 0 8px ${t}, 0 32px 64px ${e}`}}const Q5e=(t=>{const e=EVt(t);return{...AVt,...kVt,...RVt,...PVt,...MVt,...OVt,...DVt,...LVt,...wVt,...IVt,...e,..._Vt,...X3,...Y5e(e.colorNeutralShadowAmbient,e.colorNeutralShadowKey),...Y5e(e.colorBrandShadowAmbient,e.colorBrandShadowKey,"Brand")}})({30:"#0a2e4a",40:"#0c3b5e",50:"#0e4775",60:"#0f548c",70:"#115ea3",80:"#0f6cbd",100:"#479ef5",110:"#62abf5",120:"#77b7f7",130:"#96c6fa",140:"#b4d6fa",150:"#cfe4fa",160:"#ebf3fc"});let NVt=1;class xVt{constructor(e,i,r,o,l){this._container=e,this._videoStream=i,this._viewId=r,this._streamTelemetryEventSender=l,this._watermarkCapability=null,this.WATERMARK_TEXT_COMMON_STYLES={fontFamily:Q5e.fontFamilyBase,fontWeight:"bold",stroke:"black",strokeOpacity:"0.1",fill:Q5e.colorNeutralStrokeOnBrand2},this.WATERMARK_CONTAINER_STYLES={position:"absolute",pointerEvents:"none",width:"100%",height:"100%",top:"0",left:"0"},this.TEXT_ROTATION=30,this.SHADOW_OPACITY_RATIO=3,this.RANGE_MAX=100,this.BORDER_SIZE=18,this.BORDER_SIZE_FRAC=1/this.BORDER_SIZE,this.SPACE_USE=.9,this.MAX_BORDER=2,this.SINGLE_PATTERN_FONT_SIZE_FACTOR=.07,this._svgContainerHidden="",this._svgWatermarkUseTextScale=0,this._svgWatermarkUseTextBorderSize=0,this._svgTextTiledScaledSize=0,this._svgTextTiledScaledStrokeWidth=0,this._svgFirstPatternWidth=0,this._svgFirstPatternHeight=0,this._svgSecondPatternWidth=0,this._svgSecondPatternHeight=0,this._svgSecondPatternOffsetX=0,this._svgSecondPatternOffsetY=0,this._computeTextDiagonal=Rxt(this.TEXT_ROTATION),this._isApple=!1,this._getScaledPatternDimensions=(p,g,f,y)=>({width:p*(f+1.1),height:g*(y+1.1)}),this._call=this._videoStream.call,this._logger=o.createChild("WatermarkOverlayProvider"+NVt++);const d=this._call.getMeetingCapabilitiesInternal();if(!d){this._logger.warn("No watermark capabilities found. Likely not received from service.");const p=new Oe({defaultError:we.VIEW.NO_WATERMARK_CAPABILITY_RECEIVED}),g=ln();return void this._streamTelemetryEventSender.sendMediaStreamEvent({correlationId:g,callId:this._call.id,timestampInfo:{attemptTimestamp:Date.now()},operation:Sr.watermark,kindOfEvent:Je.failure,mediaType:this._videoStream.mediaStreamType,streamType:Ts.Remote,additionalDetails:{failureReason:p.message,code:p.code,...an(p),watermark:{...this._getWatermarkUsageTelemetryPayload()}}})}this._watermarkCapability=d.waterMarkCapability;const h=this._call.deviceManager.getOSNameInternal();this._isApple=h==="ios"||h==="mac",this._resizeObserver=new ResizeObserver(p=>{for(const g of p)if(g.contentRect?.width>1){const f=g.contentRect.width,y=g.contentRect.height;this._updateWatermarkScalingValues(f,y)}}),this._resizeObserver.observe(this._container)}attach(){const e=ln(),i=Date.now();try{if(!this._watermarkCapability)return void this._logger.warn("No watermark capabilities found. No-op.");if(this._videoStream.mediaStreamType!=="Video"&&this._videoStream.mediaStreamType!=="ScreenSharing")throw new Error("Unsupported media type for watermark");this._watermarkIsReceivingSub=()=>{this._videoStream.isReceiving&&(this._generateWatermark(this._videoStream.mediaStreamType,e),this._updateWatermarkScalingValues(this._container.getBoundingClientRect().width,this._container.getBoundingClientRect().height))},this._videoStream.on("isReceivingChanged",this._watermarkIsReceivingSub)}catch(r){const o=new Oe({defaultError:we.VIEW.WATERMARK_ATTACH_FAIL,originalError:r});throw this._streamTelemetryEventSender.sendMediaStreamEvent({correlationId:e,callId:this._call.id,timestampInfo:{deltaTimeInMs:Date.now()-i},operation:Sr.watermark,kindOfEvent:Je.failure,mediaType:this._videoStream.mediaStreamType,streamType:Ts.Remote,additionalDetails:{failureReason:o.message,code:o.code,...an(o),watermark:{...this._getWatermarkUsageTelemetryPayload()}}}),o}}dispose(){this._resizeObserver&&this._resizeObserver.disconnect(),this._mutationObserver&&this._mutationObserver.disconnect(),this._audioOnlyCallback&&this._call.offWatermarkAudioOnlyFallbackTriggeredChanged("watermarkAudioOnlyFallbackTriggeredChanged",this._audioOnlyCallback),this._svgContainer&&(this._container.removeChild(this._svgContainer),this._svgContainer=void 0,this._svgContainerHidden=""),this._watermarkIsReceivingSub&&this._videoStream.off("isReceivingChanged",this._watermarkIsReceivingSub),this._logger.info(`watermark overlay provider disposed for viewid: ${this._viewId}`)}_updateWatermarkScalingValues(e,i){this._getSelectedWatermarkPattern()==="Single"?this._updateWatermarkUseTextScalingSingle(e,i):this._getSelectedWatermarkPattern()==="Tiled"&&this._updateWatermarkPatternScalingTiled(e,i)}_generateWatermark(e,i){const r=Date.now();try{if(!this._watermarkCapability)return void this._logger.warn("No watermark capabilities found. No-op.");if(this._call.watermarkAudioOnlyFallbackTriggered)return this._logger.warn("Watermark audio only fallback was triggered, disposing remote stream"),void this._videoStream.dispose();let o;if(e==="Video"&&this._watermarkCapability.enabledForVideo)o=this._watermarkCapability.videoSettings;else{if(e!=="ScreenSharing"||!this._watermarkCapability.enabledForVbss)return void this._logger.info(`No watermark operations to be done on viewId: ${this._viewId}`);o=this._watermarkCapability.vbssSettings}if(this._streamTelemetryEventSender.sendMediaStreamEvent({correlationId:i,callId:this._call.id,timestampInfo:{attemptTimestamp:r},operation:Sr.watermark,kindOfEvent:Je.attempt,mediaType:this._videoStream.mediaStreamType,streamType:Ts.Remote,additionalDetails:{watermark:{...this._getWatermarkUsageTelemetryPayload()}}}),!o||!o.opacity||!o.pattern||typeof o.opacity!="number"||typeof o.pattern!="string")throw this._logger.debug("Unexpected watermark settings"),new Oe({defaultError:we.VIEW.WATERMARK_UNEXPECTED_VALUES});const l=this._getClampedUsername();let d;if(o.pattern==="Single")d=this._generateSinglePatternWatermark(l,o);else{if(o.pattern!=="Tiled")throw this._logger.debug("Unexpected watermark pattern setting"),new Oe({defaultError:we.VIEW.WATERMARK_UNEXPECTED_VALUES});d=this._generateTiledPatternWatermark(l,o)}this._svgContainerHidden=d.outerHTML,this._container.appendChild(d),this._audioOnlyCallback=()=>{this._call.watermarkAudioOnlyFallbackTriggered&&(this._logger.debug("Watermark audio only fallback triggered by one of the renderers"),this._logger.debug(`Disposing remote stream with viewId ${this._viewId}`),this._videoStream.dispose(),this._streamTelemetryEventSender.sendMediaStreamEvent({correlationId:i,callId:this._call.id,timestampInfo:{attemptTimestamp:Date.now()},operation:Sr.watermark,kindOfEvent:Je.event,mediaType:this._videoStream.mediaStreamType,streamType:Ts.Remote,additionalDetails:{watermark:{...this._getWatermarkUsageTelemetryPayload()}}}))},this._call.onWatermarkAudioOnlyFallbackTriggeredChanged("watermarkAudioOnlyFallbackTriggeredChanged",this._audioOnlyCallback),this._mutationObserver=new MutationObserver(h=>{this._svgContainer?.outerHTML!==this._svgContainerHidden&&(this._logger.debug("watermark mutation detected, falling back to audio only!"),this._triggerAudioOnlyFallback(),this._streamTelemetryEventSender.sendMediaStreamEvent({correlationId:i,callId:this._call.id,timestampInfo:{attemptTimestamp:Date.now()},operation:Sr.watermark,kindOfEvent:Je.event,mediaType:this._videoStream.mediaStreamType,streamType:Ts.Remote,additionalDetails:{watermark:{...this._getWatermarkUsageTelemetryPayload(this._viewId)}}}))}),this._mutationObserver.observe(this._container,{attributes:!0,subtree:!0,childList:!0}),this._logger.info(`watermark attached for viewId: ${this._viewId}`),this._streamTelemetryEventSender.sendMediaStreamEvent({correlationId:i,callId:this._call.id,timestampInfo:{deltaTimeInMs:Date.now()-r},operation:Sr.watermark,kindOfEvent:Je.success,mediaType:this._videoStream.mediaStreamType,streamType:Ts.Remote,additionalDetails:{watermark:{...this._getWatermarkUsageTelemetryPayload()}}})}catch(o){const l=new Oe({defaultError:we.VIEW.WATERMARK_ATTACH_FAIL,originalError:o});throw this._triggerAudioOnlyFallback(),this._streamTelemetryEventSender.sendMediaStreamEvent({correlationId:i,callId:this._call.id,timestampInfo:{deltaTimeInMs:Date.now()-r},operation:Sr.watermark,kindOfEvent:Je.failure,mediaType:this._videoStream.mediaStreamType,streamType:Ts.Remote,additionalDetails:{failureReason:l.message,code:l.code,...an(l),watermark:{...this._getWatermarkUsageTelemetryPayload(this._viewId)}}}),l}}_triggerAudioOnlyFallback(){this._logger.debug(`audio only fallback triggered by viewId ${this._viewId}`),this._logger.debug(`Disposing remote stream with viewId ${this._viewId}`),this._videoStream.dispose(),this._call.setWatermarkAudioOnlyFallbackTriggered(!0)}_addStyleAttributesToSvgElement(e,i){for(const[r,o]of Object.entries(i))e.style[`${r}`]=o}_generateSinglePatternWatermark(e,i){const r=this._getWatermarkContainer(i);this._svgContainer=r;const o=i.opacity/this.RANGE_MAX,l=o/this.SHADOW_OPACITY_RATIO,d=ln(),h=`url(#${d})`,p=document.createElementNS("http://www.w3.org/2000/svg","defs"),g=this._getSvgFilter(d,l),f=document.createElementNS("http://www.w3.org/2000/svg","text");f.id=ln(),this._addStyleAttributesToSvgElement(f,this.WATERMARK_TEXT_COMMON_STYLES),f.setAttribute("filter",h),f.setAttribute("text-anchor","middle"),f.setAttribute("dominant-baseline","middle"),f.setAttribute("fill-opacity",`${o}`),f.style.transform="rotate(-30deg)";const y=document.createTextNode(e);f.appendChild(y),this._svgTextDefElement=f,p.appendChild(g),p.appendChild(f);const T=document.createElementNS("http://www.w3.org/2000/svg","use");return T.id=ln(),this._svgWatermarkUseTagSinglePattern=T,T.setAttribute("href",`#${this._svgTextDefElement.id}`),T.setAttribute("x","50%"),T.setAttribute("y","50%"),T.setAttribute("width","100%"),T.setAttribute("height","100%"),T.setAttribute("font-size",`${this._svgWatermarkUseTextScale}`),T.setAttribute("stroke-width",`${this._svgWatermarkUseTextBorderSize}`),r.appendChild(p),r.appendChild(T),this._updateWatermarkUseTextScalingSingle(this._container.getBoundingClientRect().width,this._container.getBoundingClientRect().height),r}_updateWatermarkUseTextScalingSingle(e,i){if(this._svgContainer&&this._svgWatermarkUseTagSinglePattern){const r=this._computeTextDiagonal(e,i);return this._svgWatermarkUseTextScale=this.SPACE_USE*r*this.SINGLE_PATTERN_FONT_SIZE_FACTOR,this._svgWatermarkUseTextBorderSize=Math.max(1,Math.min(this.MAX_BORDER,this._svgWatermarkUseTextScale*this.BORDER_SIZE_FRAC)),this._svgWatermarkUseTagSinglePattern.setAttribute("font-size",`${this._svgWatermarkUseTextScale}`),this._svgWatermarkUseTagSinglePattern.setAttribute("stroke-width",`${this._svgWatermarkUseTextBorderSize}`),void(this._svgContainerHidden=this._svgContainer.outerHTML)}this._logger.warn("svg watermark element missing, cannot update")}_updateWatermarkPatternScalingTiled(e,i){if(this._svgContainer&&this._svgTextDefElement&&this._svgFirstPattern&&this._svgSecondPattern){const r=kxt(e,i,this._isApple);this._svgTextTiledScaledSize=r.scaledFontSize,this._svgTextTiledScaledStrokeWidth=r.scaledBorderSize,this._svgTextDefElement.setAttribute("font-size",`${this._svgTextTiledScaledSize}`),this._svgTextDefElement.setAttribute("stroke-width",`${this._svgTextTiledScaledStrokeWidth}`);const o=this._svgTextDefElement.getBoundingClientRect().width,l=this._svgTextDefElement.getBoundingClientRect().height,{width:d,height:h}=this._getScaledPatternDimensions(o,l,r.scaledHorizontalGap,r.scaledVerticalGap),p=.5*d,g=.5*h;return this._svgFirstPatternWidth=d,this._svgFirstPatternHeight=h,this._svgSecondPatternWidth=d,this._svgSecondPatternHeight=h,this._svgSecondPatternOffsetX=p,this._svgSecondPatternOffsetY=g,this._svgFirstPattern.setAttribute("width",`${this._svgFirstPatternWidth}`),this._svgFirstPattern.setAttribute("height",`${this._svgFirstPatternHeight}`),this._svgSecondPattern.setAttribute("width",`${this._svgSecondPatternWidth}`),this._svgSecondPattern.setAttribute("height",`${this._svgSecondPatternHeight}`),this._svgSecondPattern.setAttribute("x",`${this._svgSecondPatternOffsetX}`),this._svgSecondPattern.setAttribute("y",`${this._svgSecondPatternOffsetY}`),void(this._svgContainerHidden=this._svgContainer.outerHTML)}this._logger.warn("svg watermark element missing, cannot update")}_generateTiledPatternWatermark(e,i){const r=this._getWatermarkContainer(i);this._svgContainer=r;const o=i.opacity/this.RANGE_MAX,l=o/this.SHADOW_OPACITY_RATIO,d=ln(),h=ln(),p=ln(),g=`url(#${d})`,f=document.createElementNS("http://www.w3.org/2000/svg","defs"),y=this._getSvgFilter(d,l),T=document.createElementNS("http://www.w3.org/2000/svg","text");this._svgTextDefElement=T,T.id=ln(),this._addStyleAttributesToSvgElement(T,this.WATERMARK_TEXT_COMMON_STYLES),T.setAttribute("filter",g),T.setAttribute("dominant-baseline","hanging"),T.setAttribute("fill-opacity",`${o}`),T.setAttribute("font-size",`${this._svgTextTiledScaledSize}`),T.setAttribute("stroke-width",`${this._svgTextTiledScaledStrokeWidth}`);const C=document.createTextNode(e);T.appendChild(C);const E=document.createElementNS("http://www.w3.org/2000/svg","pattern");this._svgFirstPattern=E,E.id=h,E.setAttribute("patternUnits","userSpaceOnUse"),E.setAttribute("patternTransform","rotate(-30)"),E.setAttribute("width",`${this._svgFirstPatternWidth}`),E.setAttribute("height",`${this._svgFirstPatternHeight}`);const I=document.createElementNS("http://www.w3.org/2000/svg","use");I.setAttribute("href",`#${this._svgTextDefElement.id}`),E.appendChild(I);const w=document.createElementNS("http://www.w3.org/2000/svg","pattern");this._svgSecondPattern=w,w.id=p,w.setAttribute("patternUnits","userSpaceOnUse"),w.setAttribute("patternTransform","rotate(-30)"),w.setAttribute("width",`${this._svgSecondPatternWidth}`),w.setAttribute("height",`${this._svgSecondPatternHeight}`),w.setAttribute("x",`${this._svgSecondPatternOffsetX}`),w.setAttribute("y",`${this._svgSecondPatternOffsetY}`);const D=I.cloneNode(!0);w.appendChild(D),f.appendChild(y),f.appendChild(T),f.appendChild(E),f.appendChild(w);const F=this._getRect(0,0,100,100,h),x=this._getRect(0,0,100,100,p);return r.appendChild(f),r.appendChild(F),r.appendChild(x),this._updateWatermarkPatternScalingTiled(this._container.getBoundingClientRect().width,this._container.getBoundingClientRect().height),r}_getWatermarkContainer(e){const i=document.createElementNS("http://www.w3.org/2000/svg","svg");return this._addStyleAttributesToSvgElement(i,this.WATERMARK_CONTAINER_STYLES),i.setAttribute("xmlns","http://www.w3.org/2000/svg"),i}_getSvgFilter(e,i){const r=document.createElementNS("http://www.w3.org/2000/svg","filter");r.id=e;const o=document.createElementNS("http://www.w3.org/2000/svg","feDropShadow");return o.setAttribute("dx","0.5"),o.setAttribute("dy","0.5"),o.setAttribute("stdDeviation","1"),o.setAttribute("flood-color","black"),o.setAttribute("flood-opacity",`${i}`),r.appendChild(o),r}_getRect(e,i,r,o,l){const d=document.createElementNS("http://www.w3.org/2000/svg","rect");return d.setAttribute("x",`${e}%`),d.setAttribute("y",`${i}%`),d.setAttribute("width",`${r}%`),d.setAttribute("height",`${o}%`),d.setAttribute("fill",`url(#${l})`),d}_getClampedUsername(){let e="";const i=this._call.callAgent,r=wt().calling.watermark,o=r.watermarkMaxUsernameLength,l=r.watermarkEmptyDisplayNamePlaceholder;if(i?.isCteUser()){let d=i.getUserProperties()?.sipUri;d&&typeof d=="string"&&(e=d.replace("sip:",""))}else e=i?.displayName??"",e||(e=l);return wxt(e,o)}_getSelectedWatermarkPattern(){return this._videoStream.mediaStreamType==="Video"&&this._watermarkCapability?.enabledForVideo&&this._watermarkCapability?.videoSettings?.pattern?this._watermarkCapability.videoSettings.pattern:this._videoStream.mediaStreamType==="ScreenSharing"&&this._watermarkCapability?.enabledForVbss&&this._watermarkCapability?.vbssSettings?.pattern?this._watermarkCapability.vbssSettings.pattern:""}_getWatermarkUsageTelemetryPayload(e=""){return{endpointSupportsWatermark:this._call.callAgent.isWatermarkSupported(),audioOnlyFallbackTriggered:this._call.watermarkAudioOnlyFallbackTriggered,audioOnlyFallbackTriggeredByViewId:e,watermarkUsage:{video:{enabled:this._watermarkCapability?.enabledForVideo,opacity:this._watermarkCapability?.videoSettings.opacity,pattern:this._watermarkCapability?.videoSettings.pattern},screenshare:{enabled:this._watermarkCapability?.enabledForVbss,opacity:this._watermarkCapability?.vbssSettings.opacity,pattern:this._watermarkCapability?.vbssSettings.pattern}},viewId:this._viewId}}}var Wpe=function(t,e,i,r){var o,l=arguments.length,d=l<3?e:r===null?r=Object.getOwnPropertyDescriptor(e,i):r;if(typeof Reflect=="object"&&typeof Reflect.decorate=="function")d=Reflect.decorate(t,e,i,r);else for(var h=t.length-1;h>=0;h--)(o=t[h])&&(d=(l<3?o(d):l>3?o(e,i,d):o(e,i))||d);return l>3&&d&&Object.defineProperty(e,i,d),d},qB=function(t,e){if(typeof Reflect=="object"&&typeof Reflect.metadata=="function")return Reflect.metadata(t,e)};let BVt=1;class XQ{get isRendering(){return this._isRendering}get scalingMode(){return this._scalingMode}get isMirrored(){return this._isMirrored}get target(){return this._target}get viewId(){return this._viewId}get isDisposed(){return this._disposed}get retryErrorEvents(){return this._retryErrorEvents}get size(){return{height:this._size.height,width:this._size.width}}constructor(e,i,r,o,l,d,h){this._target=e,this._viewId=i,this._videoStream=r,this._onDisposedCallback=l,this._createViewSteps=d,this._eventEmitter=new $c.EventEmitter,this._isRendering=!1,this._scalingMode="Stretch",this._isMirrored=!1,this._createViewResolvedOnPlayEvent=!1,this._hasRenderingEvent=!1,this._hasPlayEvent=!1,this._size={height:0,width:0},this._disposed=!1,this.resolveRenderingPendingPromise=(p=!1)=>{this._renderingDeferred?.isPending()&&(this._renderingDeferred.resolve(),p&&(this.logger.log(`video element play event was fired and promise was resolved and isRendering is: ${this._tsRenderer?.isRendering}`),this._createViewResolvedOnPlayEvent=!0)),p?this._hasPlayEvent||(this._hasPlayEvent=!0,this._createViewSteps.isPlayedTimestamp=Date.now(),this._createViewSteps.isPlayedTimeDeltaSinceAttemptMs=this._createViewSteps.attemptTimestamp===void 0?0:this._createViewSteps.isPlayedTimestamp-this._createViewSteps.attemptTimestamp):!this._hasRenderingEvent&&this._isRendering&&(this._hasRenderingEvent=!0,this._createViewSteps.isRenderedTimestamp=Date.now(),this._createViewSteps.isRenderedTimeDeltaSinceAttemptMs=this._createViewSteps.attemptTimestamp===void 0?0:this._createViewSteps.isRenderedTimestamp-this._createViewSteps.attemptTimestamp)},this._handleTsRendererChanged=p=>{if(this.logger.debug(`rendering state is ${this._isRendering}, changed to ${this._tsRenderer?.isRendering}`),this._tsRenderer)if(this._tsRenderer.isRendering!==this._isRendering&&(this._isRendering=this._tsRenderer.isRendering,this._videoStream.updateIsReceiving(),this._isRendering&&this.resolveRenderingPendingPromise(),p.log(`isRendering change to ${this._isRendering}`)),this._tsRenderer.isRendering){const g=this._tsRenderer.streamSize?.height||GY.HEIGHT,f=this._tsRenderer.streamSize?.width||GY.WIDTH;g===this._size.height&&f===this._size.width||this.setAndUpdateSize(),this.resolveRenderingPendingPromise()}else this._size.height=0,this._size.width=0,this._videoStream.updateSize();this.sendRendererTelemetry()},this.sendRendererTelemetry=()=>{if(this._tsRenderer)try{const p={isRendering:this._tsRenderer.isRendering,streamWidth:this._tsRenderer.streamSize.width,streamHeight:this._tsRenderer.streamSize.height,isVideoAttached:this._target.isConnected,rendererWidth:this._target?.offsetWidth,rendererHeight:this._target?.offsetHeight};if(this.previousStats){if(Oxt(this.previousStats,p))return}else this.previousStats=p;this.previousStats=p;const g=this._videoStream.getStreamMetadata(),{callId:f,localParticipantId:y,isDisposed:T,viewIdsRegistered:C,height:E,width:I,...w}=g,D={...p,...w,viewId:this._viewId,disposed:this._disposed};this._videoStream.call.stats.recordEvent({name:vT.remote_view,callId:f,localParticipantId:y,data:D})}catch{}},this._unsubscribeAvailabilityCallback=()=>{this._availableCallback&&(this._videoStream.kind==="RemoteVideoStream"&&this._videoStream?.off("isAvailableChanged",this._availableCallback),this._availableCallback=void 0)},this._disposeTsRendererChangedObservable=()=>{this._tsRendererChanged&&(this._tsRendererChanged.dispose(),this._tsRendererChanged=void 0)},this._attemptToDisposeTsRenderer=()=>{if(this._tsRenderer){this.logger.debug("disposing underlying remote renderer");try{this._tsRenderer?.dispose(),this._tsRenderer=void 0}catch(p){throw this.logger.warn(`underlying remote renderer dispose failed with ${p?.message} error`),new Oe({defaultError:we.VIEW.REMOTE_RENDERER_DISPOSE_FAIL})}}},this.logger=o.createChild("RemoteStreamRenderer"+BVt++),this.logger.log("created"),h?.scalingMode!==void 0&&(this._scalingMode=h.scalingMode),h?.isMirrored!==void 0&&(this._isMirrored=h.isMirrored),this._remoteStreamTelemetryEventSender=new L6(this._videoStream.telemetryLogManager),this._watermarkOverlayProvider=new xVt(this._target,this._videoStream,this._viewId,this.logger,this._remoteStreamTelemetryEventSender),this._watermarkOverlayProvider.attach(),this._retryErrorEvents=new Set([we.VIEW.TIMEOUT.subCode,we.VIEW.SUBSCRIBE.subCode])}async start(){const e=ln(),i=+new Date,r=this.logger.createFnLogger(w3.Start),o={timestampInfo:{attemptTimestamp:i},correlationId:e,operation:Sr.render,kindOfEvent:Je.attempt,mediaType:this._videoStream.mediaStreamType,streamType:Ts.Remote};if(this._remoteStreamTelemetryEventSender.sendMediaStreamEvent(o),this._disposed)throw this.logger.warn("already disposed"),new Oe({defaultError:we.VIEW.START_ALREADY_DISPOSED});this._createViewTimeout&&(clearTimeout(this._createViewTimeout),this._createViewTimeout=void 0);try{r.info(`scalingMode=${c6(this._scalingMode)}`),this._videoStream.registerRenderer(this),this._renderingDeferred=ug(),this._renderingDeferred.promise.catch(nh),this._videoStream.kind==="RemoteVideoStream"&&(this._availableCallback=()=>{this._videoStream.isAvailable||(r.warn("stream isAvailable changed to false, attempting to reject operation"),this._renderingDeferred?.isPending()&&!this._disposed&&this._renderingDeferred?.reject(new Oe({defaultError:we.VIEW.STREAM_BECAME_UNAVAILABLE})))},this._videoStream.on("isAvailableChanged",this._availableCallback)),this._createViewSteps.startSubscriptionTimestamp=Date.now(),this._createViewSteps.startSubscriptionTimeDeltaSinceAttemptMs=this._createViewSteps.attemptTimestamp===void 0?0:this._createViewSteps.startSubscriptionTimestamp-this._createViewSteps.attemptTimestamp,this._videoStream.tsStream.start(this._target,{scalingMode:c6(this._scalingMode),transparent:!1}).then(d=>{if(this._createViewSteps.rendererIsAvailableTimestamp=Date.now(),this._createViewSteps.rendererIsAvailableTimeDeltaSinceAttemptMs=this._createViewSteps.attemptTimestamp===void 0?0:this._createViewSteps.rendererIsAvailableTimestamp-this._createViewSteps.attemptTimestamp,this._isMirrored&&(this._target.style.transform="rotateY(180deg)",this._target.style.webkitTransform="rotateY(180deg)"),this._tsRenderer=d,this.logger.info("subscribed to video, waiting for the first frame"),this._disposed)throw this.logger.warn("already disposed, dispose underlying renderer"),this._attemptToDisposeTsRenderer(),new Oe({defaultError:we.VIEW.START_ALREADY_DISPOSED});if(this.logger.info(`current state of rendering is ${this._tsRenderer.isRendering}`),this.sendRendererTelemetry(),wt().rendering.remoteVideo.createViewTimeout!==-1&&(this._createViewTimeout=setTimeout(()=>{if(this._renderingDeferred?.isPending())try{this._renderingDeferred.reject(new Oe({defaultError:we.VIEW.TIMEOUT})),this._createViewTimeout&&(clearTimeout(this._createViewTimeout),this._createViewTimeout=void 0)}catch{}},wt().rendering.remoteVideo.createViewTimeout)),wt().rendering.remoteVideo.speedupCreateViewWithPlayEvent){const h=this._target&&this._target.children.length>0&&this._target.children[0];h?h.addEventListener("play",this.videoPlayEventListener.bind(this)):this.logger.warn("video element was not found while trying to listen to play event")}this._tsRendererChanged=this._tsRenderer.changed(()=>this._handleTsRendererChanged(r)),this._tsRenderer.isRendering&&(this._isRendering=!0,this._videoStream.updateIsReceiving(),this.setAndUpdateSize(),this.resolveRenderingPendingPromise())}).catch(d=>{if(this.logger.info("Failed to subscribe to video"),this._renderingDeferred?.isPending()){const h=new Oe({defaultError:we.VIEW.SUBSCRIBE,originalError:d});this._renderingDeferred.reject(h)}}),await this._renderingDeferred.promise,this._videoStream.flushIsReceiving(),this._unsubscribeAvailabilityCallback(),wt().rendering.remoteVideo.forceCheckIfVideoWasAttachedToDom&&this._checkIfVideoWasAttachedToDom();const l={timestampInfo:{deltaTimeInMs:+new Date-i},correlationId:e,operation:Sr.render,kindOfEvent:Je.success,mediaType:this._videoStream.mediaStreamType,streamType:Ts.Remote,createViewResolvedOnPlayEvent:this._createViewResolvedOnPlayEvent};return this._remoteStreamTelemetryEventSender.sendMediaStreamEvent(l),this}catch(l){this.logger.warn(`Failed to render, message=${l}`);try{this._retryErrorEvents.has(l?.subCode)||this.dispose()}catch(h){this.logger.warn(`dispose failed with ${h?.message} error`)}const d=new Oe({defaultError:we.VIEW.START,originalError:l});if(d.message!==we.VIEW.LARGE_MEETING_VIEW_DISPOSED.message&&d.message!==we.VIEW.REMOTE_VIDEO_STREAM_DISPOSED.message){const h={timestampInfo:{deltaTimeInMs:+new Date-i},correlationId:e,operation:Sr.render,additionalDetails:{failureReason:d.message,code:qK,...an(d)},kindOfEvent:Je.failure,mediaType:this._videoStream.mediaStreamType,streamType:Ts.Remote,createViewResolvedOnPlayEvent:this._createViewResolvedOnPlayEvent};this._remoteStreamTelemetryEventSender.sendMediaStreamEvent(h)}throw d}}videoPlayEventListener(){this.logger.log("video element play event was fired"),this.resolveRenderingPendingPromise(!0)}setAndUpdateSize(){try{this._size.width=this._tsRenderer?.streamSize.width||GY.WIDTH,this._size.height=this._tsRenderer?.streamSize.height||GY.HEIGHT,this._videoStream.updateSize()}catch(e){this.logger.error(`Failed to update video stream size with error ${e}`)}}async setScalingMode(e){if(!this._tsRenderer)throw new Oe({defaultError:we.VIEW.SCALING_MODE});await this._tsRenderer.setScalingMode(c6(e)),this._scalingMode=e}_clearTimeouts(){this._checkIfVideoWasAttachedToDomTimeout&&(clearTimeout(this._checkIfVideoWasAttachedToDomTimeout),this._checkIfVideoWasAttachedToDomTimeout=void 0),this._createViewTimeout&&(clearTimeout(this._createViewTimeout),this._createViewTimeout=void 0)}dispose(e=NE.Public_App){if(this._disposed)throw new Oe({defaultError:we.VIEW.RENDERER_DISPOSE_ALREADY_DISPOSED});if(this._disposed=!0,this._disposeTsRendererChangedObservable(),this._unsubscribeAvailabilityCallback(),this._attemptToDisposeTsRenderer(),this._renderingDeferred?.isPending()){let i;switch(e){case NE.Internal_LargeMeetingVideoRendering:i=we.VIEW.LARGE_MEETING_VIEW_DISPOSED;break;case NE.Internal_RemoteVideoStreamDisposed:i=we.VIEW.REMOTE_VIDEO_STREAM_DISPOSED;break;default:i=we.VIEW.APP_VIEW_DISPOSED}this._renderingDeferred.reject(new Oe({defaultError:i}))}if(this._target){const i=this._target.children&&this._target.children.length>0&&this._target.children[0];i&&i.removeEventListener("play",this.videoPlayEventListener),this._target.remove()}try{e!==NE.Public_App&&this._onDisposedCallback(e)}catch(i){this.logger.debug(`dispose callback failed with ${i?.message} error`)}this._watermarkOverlayProvider.dispose(),this._videoStream.unregisterRenderer(this),this._size.height=0,this._size.width=0,this._videoStream.updateSize(),this._isRendering=!1,this._videoStream.updateIsReceiving(),this._eventEmitter.removeAllListeners(),this._renderingDeferred=void 0,this._clearTimeouts()}_checkIfVideoWasAttachedToDom(){if(this._checkIfVideoWasAttachedToDomTimeout&&(clearTimeout(this._checkIfVideoWasAttachedToDomTimeout),this._checkIfVideoWasAttachedToDomTimeout=void 0),wt().rendering.remoteVideo.checkIfVideoAttachedToDom_poll){let e=wt().rendering.remoteVideo.checkIfVideoAttachedToDom_intervalMaxTries;const i=()=>{this._target.isConnected||e<=0?this.sendRendererTelemetry():(e--,e>=0&&(this._checkIfVideoWasAttachedToDomTimeout=setTimeout(()=>i(),wt().rendering.remoteVideo.checkIfVideoAttachedToDom_intervalTime)))};i()}else this._checkIfVideoWasAttachedToDomTimeout=setTimeout(()=>{this._target.isConnected&&this.sendRendererTelemetry()},wt().rendering.remoteVideo.checkIfVideoAttachedToDom_timeout)}}Wpe([zv,qB("design:type",Object)],XQ.prototype,"logger",void 0),Wpe([to(w3.Start),qB("design:type",Function),qB("design:paramtypes",[]),qB("design:returntype",Promise)],XQ.prototype,"start",null),Wpe([sg(w3.Dispose),qB("design:type",Function),qB("design:paramtypes",[String]),qB("design:returntype",void 0)],XQ.prototype,"dispose",null);var n8=function(t,e,i,r){var o,l=arguments.length,d=l<3?e:r===null?r=Object.getOwnPropertyDescriptor(e,i):r;if(typeof Reflect=="object"&&typeof Reflect.decorate=="function")d=Reflect.decorate(t,e,i,r);else for(var h=t.length-1;h>=0;h--)(o=t[h])&&(d=(l<3?o(d):l>3?o(e,i,d):o(e,i))||d);return l>3&&d&&Object.defineProperty(e,i,d),d},KC=function(t,e){if(typeof Reflect=="object"&&typeof Reflect.metadata=="function")return Reflect.metadata(t,e)};class e4{get isRendering(){return this._isRendering}get scalingMode(){return this._scalingMode}get isMirrored(){return this._isMirrored}get target(){return this._target}get isDisposed(){return this._disposed}constructor(e,i,r,o,l){this._target=e,this._videoStream=i,this._onDisposed=o,this._eventEmitter=new $c.EventEmitter,this._isRendering=!1,this._scalingMode="Stretch",this._isMirrored=!0,this._disposed=!1,this.logger=r.createChild("LocalStreamRenderer"),this.logger.log("created"),l?.scalingMode!==void 0&&(this._scalingMode=l.scalingMode),l?.isMirrored!==void 0?this._isMirrored=l.isMirrored:this._videoStream.mediaStreamType==="ScreenSharing"&&(this._isMirrored=!1),this._localStreamTelemetryEventSender=new L6(this._videoStream.telemetryLogManager)}on(e,i){this._eventEmitter.on(e,i)}off(e,i){this._eventEmitter.off(e,i)}async start(){const e=ln(),i=this.logger.createFnLogger(w3.Start),r=+new Date,o={timestampInfo:{attemptTimestamp:r},correlationId:e,operation:Sr.render,kindOfEvent:Je.attempt,mediaType:this._videoStream.mediaStreamType,streamType:Ts.Local};this._localStreamTelemetryEventSender.sendMediaStreamEvent(o);try{if(i.info("attempting to select new device as a source"),this._videoStream.source instanceof hP&&this._videoStream.mediaStreamType==="Video"){const d=this._videoStream.source.deviceManager.getTsDeviceManager();d.selectDevices({camera:this._videoStream.source.id}),i.info("device selected"),i.info("creating preview"),this._tsRenderer=await d.createPreview(this._target,{kind:"camera"},{scalingMode:c6(this._scalingMode),transparent:!1,ignoreMirroring:!1,disposeRendererWhenStreamisNotAvailable:()=>!0})}else{if(this._videoStream.mediaStreamType!=="RawMedia"&&this._videoStream.mediaStreamType!=="ScreenSharing")throw new Oe({defaultError:we.VIEW.UNKNOWN_STREAM_TYPE});{this._rawMediaOrSS_previewVideo=document.createElement("video"),this._rawMediaOrSS_previewVideo.style.width="100%",this._rawMediaOrSS_previewVideo.style.height="100%",this._rawMediaOrSS_previewVideo.style.objectFit="contain",this._rawMediaOrSS_previewVideo.setAttribute("playsinline","true"),this._rawMediaOrSS_previewVideo.disablePictureInPicture=!0,this._rawMediaOrSS_previewVideo.autoplay=!0;const d=await this._videoStream.getMediaStream(),h=new MediaStream(d.getVideoTracks());this._rawMediaOrSS_previewVideo.srcObject=h,this._rawMediaOrSS_previewVideo.play(),this._target.appendChild(this._rawMediaOrSS_previewVideo)}}this._isMirrored&&(this._target.style.transform="rotateY(180deg)",this._target.style.webkitTransform="rotateY(180deg)"),this._videoStream.registerRenderer(this);const l={timestampInfo:{deltaTimeInMs:+new Date-r},correlationId:e,operation:Sr.render,kindOfEvent:Je.success,mediaType:this._videoStream.mediaStreamType,streamType:Ts.Local};return this._localStreamTelemetryEventSender.sendMediaStreamEvent(l),this}catch(l){this.dispose();const d=z3(i,l),h={timestampInfo:{deltaTimeInMs:+new Date-r},correlationId:e,operation:Sr.render,additionalDetails:{failureReason:d.message,code:d.code,subCode:d.subCode,...an(d)},kindOfEvent:Je.failure,mediaType:this._videoStream.mediaStreamType,streamType:Ts.Local};throw this._localStreamTelemetryEventSender.sendMediaStreamEvent(h),d}}setScalingMode(e){if(this._tsRenderer)this._tsRenderer.setScalingMode(c6(e)),this._scalingMode=e;else{if(!this._rawMediaOrSS_previewVideo)throw new Oe({defaultError:we.VIEW.SCALING_MODE});switch(e){case"Stretch":this._rawMediaOrSS_previewVideo.style.objectFit="fill";break;case"Crop":this._rawMediaOrSS_previewVideo.style.objectFit="cover";break;default:this._rawMediaOrSS_previewVideo.style.objectFit="contain"}}}setSourceObject(e){this.disposeScreenSharingMediaStream();const i=this._target.querySelector("video");i&&(i.srcObject=e,i.play())}dispose(){if(!this._disposed){if(this._tsRenderer)try{this.logger.log("disposing underlying local renderer"),this._tsRenderer.dispose(),this._tsRenderer=void 0}catch(e){throw this.logger.warn(`underlying local renderer dispose failed with ${e?.message} error`),new Oe({defaultError:we.VIEW.LOCAL_RENDERER_DISPOSE_FAIL})}this.disposeScreenSharingMediaStream(),this._target.remove(),this._onDisposed&&this._onDisposed(this),this._eventEmitter.removeAllListeners(),this._disposed=!0}}disposeScreenSharingMediaStream(){if(this._videoStream.getCall()?.localScreenSharingStream){const e=this._target.querySelector("video"),i=e?.srcObject;i&&(i.getVideoTracks().forEach(r=>{r.stop()}),e.srcObject=null,this.logger.info("disposed of ScreenSharing MediaStream"))}}}n8([zv,KC("design:type",Object)],e4.prototype,"logger",void 0),n8([to(k3.Start),KC("design:type",Function),KC("design:paramtypes",[]),KC("design:returntype",Promise)],e4.prototype,"start",null),n8([sg(k3.SetScalingMode),KC("design:type",Function),KC("design:paramtypes",[String]),KC("design:returntype",void 0)],e4.prototype,"setScalingMode",null),n8([sg(k3.SetSourceObject),KC("design:type",Function),KC("design:paramtypes",[MediaStream]),KC("design:returntype",void 0)],e4.prototype,"setSourceObject",null),n8([sg(k3.Dispose),KC("design:type",Function),KC("design:paramtypes",[]),KC("design:returntype",void 0)],e4.prototype,"dispose",null);var eZ=function(t,e,i,r){var o,l=arguments.length,d=l<3?e:r===null?r=Object.getOwnPropertyDescriptor(e,i):r;if(typeof Reflect=="object"&&typeof Reflect.decorate=="function")d=Reflect.decorate(t,e,i,r);else for(var h=t.length-1;h>=0;h--)(o=t[h])&&(d=(l<3?o(d):l>3?o(e,i,d):o(e,i))||d);return l>3&&d&&Object.defineProperty(e,i,d),d},_k=function(t,e){if(typeof Reflect=="object"&&typeof Reflect.metadata=="function")return Reflect.metadata(t,e)};let FVt=1;class Ek{get scalingMode(){return this._streamRenderer.scalingMode}get isMirrored(){return this._streamRenderer.isMirrored}get disposed(){return this._disposed}constructor(e,i,r,o,l){if(this._videoStream=e,this._viewId=r,this._options=l,this._disposed=!1,this._isRetryErrorSubCode=d=>"retryErrorEvents"in this._streamRenderer&&this._streamRenderer.retryErrorEvents.has(d.subCode),this._deleteActiveRemoteVideoStreamView=(d,h)=>{if(d.call.activeRemoteVideoStreamViews?.has(d.id)){let p=d.call.activeRemoteVideoStreamViews?.get(d.id);p?.delete(h),p?.size==0&&d.call.activeRemoteVideoStreamViews?.delete(d.id)}},this.logger=i.createChild("VideoStreamRendererView"+FVt++),this.target=document.createElement("div"),this.target.style.width="100%",this.target.style.height="100%",this._videoStream instanceof FB)this._streamRenderer=new XQ(this.target,this._viewId,this._videoStream,this.logger,d=>{this._disposed?void 0:this.dispose(d)},o,this._options);else{if(!(this._videoStream instanceof kp))throw new Oe({defaultError:we.VIEW.VIEW_WRONG_STREAM_TYPE});this._streamRenderer=new e4(this.target,this._videoStream,this.logger,()=>this.dispose,this._options)}this._telemetryLogManager=this._videoStream.telemetryLogManager,this.logger.info("created")}async render(){const e=this.logger.createFnLogger(this._videoStream instanceof FB?TB.RenderRemoteStream:TB.RenderLocalStream);if(this._disposed)throw e.log("failed, stream disposed!"),new Oe({defaultError:we.VIEW.RENDER_FAIL_STREAM_DISPOSED});const i=wt().rendering.remoteVideo.maxRendererRetries;let r=1;const o=(d,h)=>d().catch(p=>{if(h>0&&this._isRetryErrorSubCode(p))return r+=1,o(d,h-1);throw this._streamRenderer.isDisposed||this._streamRenderer.dispose(),p}),l=()=>this._streamRenderer.start();try{await o(l,i-1)}catch(d){throw e.error(`Failed to render stream ${this._viewId} after ${r} retries.`),this._isRetryErrorSubCode(d)&&r>1&&(d.message+=`
Failed to render stream ${this._viewId} after ${r} retries.`),d}return r}async updateScalingMode(e){if(this._disposed)throw new Oe({defaultError:we.VIEW.SCALING_MODE_DISPOSED});if(e!=="Crop"&&e!=="Fit"&&e!=="Stretch")throw new Oe({defaultError:we.VIEW.SCALING_MODE_WRONG_VAL});try{await this._streamRenderer.setScalingMode(e)}catch(i){throw new Oe({defaultError:we.VIEW.SCALING_MODE,originalError:i})}}dispose(e=NE.Public_App){if(this._disposed)throw new Oe({defaultError:we.VIEW.VIEW_ALREADY_DISPOSED});this._disposed=!0;const i=+new Date,r=ln();try{e===NE.Public_App&&this.sendDisposeViewEvent({eventName:vi.acs_calling_dispose_view_attempt,correlationId:r,timestampInfo:{attemptTimestamp:i}}),this.logger.debug("attempt to dispose stream renderer"),this._streamRenderer.dispose(e),this.target?.remove(),this._videoStream instanceof Q3&&(this._deleteActiveRemoteVideoStreamView(this._videoStream,this._viewId),wt()?.rendering.remoteVideo.decrementOvcOnRemoteSsRendering&&this._videoStream.mediaStreamType==="ScreenSharing"&&(Ek.remoteScreenSharingViews.delete(this._viewId),Ek.remoteScreenSharingViews.size<=0&&this._videoStream.call.setIsRenderingRemoteScreenShare(!1)));const o=+new Date;e===NE.Public_App&&this.sendDisposeViewEvent({eventName:vi.acs_calling_dispose_view_success,correlationId:r,timestampInfo:{deltaTimeInMs:o-i}})}catch(o){const l=new Oe({defaultError:we.VIEW.DISPOSE_FAIL,originalError:o});if(e===NE.Public_App){const d=+new Date;this.sendDisposeViewEvent({eventName:vi.acs_calling_dispose_view_failure,correlationId:r,timestampInfo:{deltaTimeInMS:d-i}},l)}throw l}}sendDisposeViewEvent(e,i){try{let r,o;i&&(r=typeof i?.message=="string"?i?.message:"",o={...an(i)}),this._telemetryLogManager.sendEvent({name:e.eventName,tenant:Wr,properties:{...this._videoStream.getStreamMetadata(),viewId:this._viewId,correlationId:e.correlationId,timestampInfo:e.timestampInfo,failureReason:r,additionalDetails:o}})}catch{this.logger.debug("Unable to send telemtery")}}}Ek.remoteScreenSharingViews=new Map,eZ([zv,_k("design:type",Object)],Ek.prototype,"logger",void 0),eZ([to(TB.Render),_k("design:type",Function),_k("design:paramtypes",[]),_k("design:returntype",Promise)],Ek.prototype,"render",null),eZ([to(TB.UpdateScalingMode),_k("design:type",Function),_k("design:paramtypes",[String]),_k("design:returntype",Promise)],Ek.prototype,"updateScalingMode",null),eZ([sg(TB.Dispose),_k("design:type",Function),_k("design:paramtypes",[String]),_k("design:returntype",void 0)],Ek.prototype,"dispose",null);var is=bs(function(t,e){function i(o,l){var d=0;return o.replace(/%[dixs%]/g,function(h){var p=0;if(h[p++]!=="%")return"";var g=h[p++];return g==="%"?"%":g==="s"||g==="d"||g==="i"?l[d++]:g==="x"?l[d++].toString(16):h})}function r(o){for(var l=[],d=1;d<arguments.length;d++)l[d-1]=arguments[d];return i(o,l)}/*!
 *  AufLog.ts
 *  AUF
 *
 *  Created by Johan Blumenberg on 2016-12-29
 *  Copyright 2016 Microsoft. All rights reserved.
 *
 */Object.defineProperty(e,"__esModule",{value:!0}),function(o){o[o.Trace=10]="Trace",o[o.Debug6=16]="Debug6",o[o.Debug5=18]="Debug5",o[o.Debug4=20]="Debug4",o[o.Debug3=30]="Debug3",o[o.Debug2=40]="Debug2",o[o.Debug1=50]="Debug1",o[o.Warning=60]="Warning",o[o.Error=70]="Error",o[o.Fatal=80]="Fatal",o[o.MetaData=90]="MetaData"}(e.LogLevel||(e.LogLevel={})),function(o){o[o.UseDefault=0]="UseDefault",o[o.Compress=1]="Compress",o[o.Disabled=2]="Disabled"}(e.LogFileCompression||(e.LogFileCompression={})),function(o){o[o.Raw=0]="Raw",o[o.Base64=1]="Base64"}(e.LogFileEncoding||(e.LogFileEncoding={})),function(o){o[o.Unencrypted=0]="Unencrypted",o[o.Encrypted=1]="Encrypted"}(e.LogFileEncryption||(e.LogFileEncryption={})),function(o){o[o.PEM=0]="PEM",o[o.DER=1]="DER",o[o.BER=2]="BER"}(e.CertStoreFormat||(e.CertStoreFormat={})),function(o){o[o.InsertFront=8]="InsertFront"}(e.AppenderFlags||(e.AppenderFlags={})),e.vsprintf=i,e.sprintf=r}),Ky=bs(function(t,e){/*!
 *  LogFactory.ts
 *  AUF
 *
 *  Created by Johan Blumenberg on 2016-12-29
 *  Copyright 2016 Microsoft. All rights reserved.
 *
 */var i,r,o=fo&&fo.__extends||(i=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(C,E){C.__proto__=E}||function(C,E){for(var I in E)E.hasOwnProperty(I)&&(C[I]=E[I])},function(C,E){function I(){this.constructor=C}i(C,E),C.prototype=E===null?Object.create(E):(I.prototype=E.prototype,new I)});function l(C){if(C===null)return-1;for(var E=0,I=C.length-1;I>=0;I--)E=37*E+C.charCodeAt(I)|0;var w="__auf_literal:";for(I=w.length-1;I>=0;I--)E=37*E+w.charCodeAt(I)|0;return E}Object.defineProperty(e,"__esModule",{value:!0}),function(C){C[C.Unsafe=0]="Unsafe",C[C.Safe=1]="Safe",C[C.Inherited_Unsafe=2]="Inherited_Unsafe",C[C.Inherited_Safe=3]="Inherited_Safe",C[C.Blacklisted_Unsafe=4]="Blacklisted_Unsafe"}(r||(r={}));var d,h=function(){function C(E,I){this._level=is.LogLevel.Debug4,this._threshold=255,this._safe=r.Inherited_Unsafe,this._name=E,I&&(this._level=I.level(),this._safe=I.safe()?r.Inherited_Safe:r.Inherited_Unsafe,this._extendedInfo=I.extendedInfo())}return C.prototype.name=function(){return this._name},C.prototype.safe=function(){return this._safe===r.Safe||this._safe===r.Inherited_Safe},C.prototype.safety=function(){return this._safe},C.prototype.setSafety=function(E){this._safe=E},C.prototype.description=function(){return this._desc},C.prototype.setDescription=function(E){this._desc=E},C.prototype.level=function(){return this._level},C.prototype.setLevel=function(E){d.setLevel(this,E)},C.prototype._setLevel=function(E){this._level=E},C.prototype._setThreshold=function(E){this._threshold=E},C.prototype.isEnabled=function(E){return this._threshold<=E},C.prototype.setExtendedInfo=function(E){this._extendedInfo=E},C.prototype.extendedInfo=function(){return this._extendedInfo},C.prototype.trace=function(E){for(var I=[],w=1;w<arguments.length;w++)I[w-1]=arguments[w];d.log.apply(d,[this,is.LogLevel.Trace,l(E),E].concat(I))},C.prototype.debug6=function(E){for(var I=[],w=1;w<arguments.length;w++)I[w-1]=arguments[w];d.log.apply(d,[this,is.LogLevel.Debug6,l(E),E].concat(I))},C.prototype.debug5=function(E){for(var I=[],w=1;w<arguments.length;w++)I[w-1]=arguments[w];d.log.apply(d,[this,is.LogLevel.Debug5,l(E),E].concat(I))},C.prototype.debug4=function(E){for(var I=[],w=1;w<arguments.length;w++)I[w-1]=arguments[w];d.log.apply(d,[this,is.LogLevel.Debug4,l(E),E].concat(I))},C.prototype.debug3=function(E){for(var I=[],w=1;w<arguments.length;w++)I[w-1]=arguments[w];d.log.apply(d,[this,is.LogLevel.Debug3,l(E),E].concat(I))},C.prototype.debug2=function(E){for(var I=[],w=1;w<arguments.length;w++)I[w-1]=arguments[w];d.log.apply(d,[this,is.LogLevel.Debug2,l(E),E].concat(I))},C.prototype.debug1=function(E){for(var I=[],w=1;w<arguments.length;w++)I[w-1]=arguments[w];d.log.apply(d,[this,is.LogLevel.Debug1,l(E),E].concat(I))},C.prototype.warn=function(E){for(var I=[],w=1;w<arguments.length;w++)I[w-1]=arguments[w];d.log.apply(d,[this,is.LogLevel.Warning,l(E),E].concat(I))},C.prototype.error=function(E){for(var I=[],w=1;w<arguments.length;w++)I[w-1]=arguments[w];d.log.apply(d,[this,is.LogLevel.Error,l(E),E].concat(I))},C.prototype.fatal=function(E){for(var I=[],w=1;w<arguments.length;w++)I[w-1]=arguments[w];d.log.apply(d,[this,is.LogLevel.Fatal,l(E),E].concat(I))},C.prototype.meta=function(E){for(var I=[],w=1;w<arguments.length;w++)I[w-1]=arguments[w];d.log.apply(d,[this,is.LogLevel.MetaData,l(E),E].concat(I))},C}(),p=function(){function C(){}return C.instance=function(){return d},C.levelToString=function(E){return E<=is.LogLevel.Trace?"TRACE":E<=is.LogLevel.Debug6?"DEBUG6":E<=is.LogLevel.Debug5?"DEBUG5":E<=is.LogLevel.Debug4?"DEBUG4":E<=is.LogLevel.Debug3?"DEBUG3":E<=is.LogLevel.Debug2?"DEBUG2":E<=is.LogLevel.Debug1?"DEBUG1":E<=is.LogLevel.Warning?"WARN":E<=is.LogLevel.Error?"ERROR":E<=is.LogLevel.Fatal?"FATAL":(is.LogLevel.MetaData,"META")},C.levelFromString=function(E){return this._levelFromString[E]||parseInt(E,10)},C}();function g(C,E){for(var I=E.name();I.length>0;){if(C[I])return C[I];var w=I.lastIndexOf(".");I=w<0?"":I.substr(0,w)}return C[""]?C[""]:is.LogLevel.Debug4}function f(C,E){var I=255;return E.forEach(function(w){var D=255;w.appender.levels()?D=Math.min(D,g(w.appender.levels(),C)):w.appender.receiveAll()||(D=Math.min(D,C.level())),I=Math.min(I,D)}),I}function y(C,E,I){return!!C.appender.receiveAll()||(C.appender.levels()?I>=g(C.appender.levels(),E):I>=E.level())}p._levelFromString={TRACE:is.LogLevel.Trace,DEBUG6:is.LogLevel.Debug6,DEBUG5:is.LogLevel.Debug5,DEBUG4:is.LogLevel.Debug4,DEBUG3:is.LogLevel.Debug3,DEBUG2:is.LogLevel.Debug2,DEBUG1:is.LogLevel.Debug1,WARN:is.LogLevel.Warning,ERROR:is.LogLevel.Error,FATAL:is.LogLevel.Fatal,META:is.LogLevel.MetaData},e.LogFactory=p;var T=function(C){function E(){var I=C.call(this)||this;return I._nextId=0,I._appenders=[],I._components={},I._componentBlacklist=[],I._components[""]=new h("",null),I}return o(E,C),E.prototype.toHex=function(I){return(4294967296+I).toString(16).substr(-8)},E.prototype.addAppender=function(I,w){w===void 0&&(w=0);var D=this._nextId++;return w&is.AppenderFlags.InsertFront?this._appenders.unshift({appender:I,handle:D}):this._appenders.push({appender:I,handle:D}),this.recalcComponentThresholds(),D},E.prototype.removeAppender=function(I){for(var w=0;w<this._appenders.length;w++)if(this._appenders[w].handle===I){this._appenders.splice(w,1);break}this.recalcComponentThresholds()},E.prototype.log=function(I,w,D,F){for(var x=[],B=4;B<arguments.length;B++)x[B-4]=arguments[B];try{if(I.isEnabled(w)){var L={timestamp:new Date().getTime(),component:I,level:w};this._appenders.forEach(function(z){y(z,I,w)&&z.appender.log(L,D,F,x)})}}catch{}},E.prototype.parent=function(I){for(;;){var w=I.lastIndexOf(".");if(I=w>=0?I.substr(0,w):"",this._components[I])return this._components[I]}},E.prototype.children=function(I){var w=[];for(var D in this._components)this.parent(D).name()===I&&w.push(this._components[D]);return w},E.prototype.component=function(I){if(this._components[I])return this._components[I];var w=new h(I,this.parent(I));this._components[I]=w;var D=f(w,this._appenders);return w._setThreshold(D),w},E.prototype.rootComponent=function(){return this.component("")},E.prototype.setSafetyRecursive=function(I,w){var D=this;this.children(I).forEach(function(F){F.safety()!==r.Inherited_Safe&&F.safety()!==r.Inherited_Unsafe||(F.setSafety(w),D.setSafetyRecursive(F.name(),w))})},E.prototype.declareComponentSafe=function(I,w){var D=this.component(I);this._componentBlacklist.indexOf(D.name())!==-1?D.setSafety(r.Blacklisted_Unsafe):D.setSafety(w?r.Safe:r.Unsafe),this.setSafetyRecursive(I,w?r.Inherited_Safe:r.Inherited_Unsafe)},E.prototype.declareComponentDescription=function(I,w){this.component(I).setDescription(w)},E.prototype.setExtendedInfoRecursive=function(I,w){var D=this;this.children(I).forEach(function(F){F.extendedInfo()===void 0&&(F.setExtendedInfo(w),D.setExtendedInfoRecursive(F.name(),w))})},E.prototype.declareComponentExtendedInfo=function(I,w){var D=this.component(I);D.setExtendedInfo(w),this.setExtendedInfoRecursive(D.name(),w)},E.prototype.recalcComponentThresholds=function(){for(var I in this._components){var w=this._components[I],D=f(w,this._appenders);w._setThreshold(D)}},E.prototype.setLevel=function(I,w){if(I.name()==="")for(var D in this._components){(B=this._components[D])._setLevel(w);var F=f(B,this._appenders);B._setThreshold(F)}else{var x=I.name()+".";I._setLevel(w),F=f(I,this._appenders);for(var D in I._setThreshold(F),this._components){var B;if((B=this._components[D]).name().substr(0,x.length)===x){B._setLevel(w);var L=f(B,this._appenders);B._setThreshold(L)}}}},E.prototype.setComponentBlacklist=function(I){for(var w in this._componentBlacklist=I,this._components){var D=this._components[w];this._componentBlacklist.indexOf(D.name())!==-1&&D.setSafety(r.Blacklisted_Unsafe)}},E}(p);d=new T}),oh=bs(function(t,e){function i(D){var F=T();return D.then(function(x){F.resolve(x)},function(x){F.reject(x)}),F.promise().thenAsync(function(x){return x})}function r(D){return D!=null&&typeof D.then=="function"}function o(D){return D!=null&&typeof D.cancel=="function"}function l(D,F){if(!e.config.catchExceptions)return D();try{return D()}catch(x){return F(x)}}Object.defineProperty(e,"__esModule",{value:!0}),e.config={exceptionsToConsole:!0,catchExceptions:!0,traceEnabled:!1,exceptionHandler:void 0,unhandledErrorHandler:function(D){throw D}},e.fromThenable=i;var d,h=[],p=typeof setImmediate<"u";function g(D){h.push(D),h.length===1&&(p?setImmediate(f):setTimeout(f,0))}function f(){var D=h;h=[];for(var F=0;F<D.length;F++)D[F]()}function y(D){if(D.length===0)return C([]);var F,x=T(),B=D.length,L=Array(D.length);x.onCancel(function(H){D.forEach(function(j){o(j)&&d.SyncTask.cancelOtherInternal(j,H)})});var z=function(){--B==0&&(F!==void 0?x.reject(F):x.resolve(L))};return D.forEach(function(H,j){r(H)?H.then(function(J){L[j]=J,z()},function(J){F===void 0&&(F=J===void 0||J),z()}):(L[j]=H,z())}),x.promise()}function T(){return new d.SyncTask}function C(D){return new d.SyncTask().resolve(D).promise()}function E(D){return new d.SyncTask().reject(D).promise()}function I(D){var F=T(),x=!1;return F.onCancel(function(B){D.forEach(function(L){o(L)&&d.SyncTask.cancelOtherInternal(L,B)})}),D.forEach(function(B){r(B)?B.then(function(L){x||(x=!0,F.resolve(L))},function(L){x||(x=!0,F.reject(L))}):x||(x=!0,F.resolve(B))}),F.promise()}function w(D,F){var x=T(),B=setTimeout(function(){x.resolve({timedOut:!0})},F);return I([D.then(function(L){return clearTimeout(B),{timedOut:!1,result:L}}),x.promise()])}e.asyncCallback=g,function(D){var F=function(){function x(){this._completedSuccess=!1,this._completedFail=!1,this._traceEnabled=!1,this._cancelCallbacks=[],this._wasCanceled=!1,this._wasExplicitlyCanceled=!1,this._resolving=!1,this._storedCallbackSets=[],this._mustHandleError=!0}return x.prototype._addCallbackSet=function(B,L){var z=this,H=new x;return H.onCancel(function(j){B.wasCanceled=!0,B.cancelContext=j,z._cancelInternal(j)}),B.task=H,this._storedCallbackSets.push(B),L?this._mustHandleError=!1:H._mustHandleError=!1,this._resolving||(this._completedSuccess?this._resolveSuccesses():this._completedFail&&this._resolveFailures()),H.promise()},x.prototype.onCancel=function(B){return this._completedSuccess||this._completedFail||(this._wasCanceled?B(this._cancelContext):this._cancelCallbacks.push(B)),this},x.prototype.then=function(B,L){return this._addCallbackSet({successFunc:B,failFunc:L},!0)},x.prototype.thenAsync=function(B,L){return this._addCallbackSet({successFunc:B,failFunc:L,asyncCallback:!0},!0)},x.prototype.catch=function(B){return this._addCallbackSet({failFunc:B},!0)},x.prototype.always=function(B){return this._addCallbackSet({successFunc:B,failFunc:B},!0)},x.prototype.setTracingEnabled=function(B){return this._traceEnabled=B,this},x.prototype.finally=function(B){return this._addCallbackSet({successFunc:B,failFunc:B},!1),this},x.prototype.done=function(B){return this._addCallbackSet({successFunc:B},!1),this},x.prototype.fail=function(B){return this._addCallbackSet({failFunc:B},!1),this},x.prototype.resolve=function(B){return this._checkState(!0),this._completedSuccess=!0,this._storedResolution=B,this._cancelCallbacks=[],this._resolveSuccesses(),this},x.prototype.reject=function(B){return this._checkState(!1),this._completedFail=!0,this._storedErrResolution=B,this._cancelCallbacks=[],this._resolveFailures(),x._enforceErrorHandled(this),this},x.prototype._checkState=function(B){if(this._completedSuccess||this._completedFail){this._completeStack&&console.error(this._completeStack.message,this._completeStack.stack);var L="Failed to "+(B?"resolve":"reject")+": the task is already "+(this._completedSuccess?"resolved":"rejected");throw new Error(L)}(e.config.traceEnabled||this._traceEnabled)&&(this._completeStack=new Error("resolve"))},x._enforceErrorHandled=function(B){B._mustHandleError&&(x._rejectedTasks.push(B),x._enforceErrorHandledTimer||(x._enforceErrorHandledTimer=setTimeout(function(){x._enforceErrorHandledTimer=void 0;var L=x._rejectedTasks;x._rejectedTasks=[],L.forEach(function(z,H){z._mustHandleError&&e.config.unhandledErrorHandler(z._storedErrResolution)})},0)))},x.prototype.cancel=function(B){if(this._wasExplicitlyCanceled)throw new Error("Already Canceled");this._wasExplicitlyCanceled=!0,this._cancelInternal(B)},x.prototype._cancelInternal=function(B){var L=this;if(!this._wasCanceled){this._wasCanceled=!0,this._cancelContext=B;var z=this._cancelCallbacks;this._cancelCallbacks=[],z.length>0&&z.forEach(function(H){L._completedSuccess||L._completedFail||H(L._cancelContext)})}},x.cancelOtherInternal=function(B,L){var z=B;z._storedCallbackSets&&z._cancelInternal?z._cancelInternal(L):B.cancel(L)},x.prototype.promise=function(){return this},x.prototype._resolveSuccesses=function(){var B=this;for(this._resolving=!0;this._storedCallbackSets.length;){var L=this._storedCallbackSets;this._storedCallbackSets=[],L.forEach(function(z){z.asyncCallback?g(function(){return B._resolveSuccessCallback(z)}):B._resolveSuccessCallback(z)})}this._resolving=!1},x.prototype._resolveSuccessCallback=function(B){var L=this;B.successFunc?l(function(){var z=B.successFunc(L._storedResolution);o(z)&&(B.wasCanceled?x.cancelOtherInternal(z,B.cancelContext):B.task.onCancel(function(H){return x.cancelOtherInternal(z,H)})),r(z)?z.then(function(H){B.task.resolve(H)},function(H){B.task.reject(H)}):B.task.resolve(z)},function(z){L._handleException(z,"SyncTask caught exception in success block: "+z.toString()),B.task.reject(z)}):B.task.resolve(this._storedResolution)},x.prototype._resolveFailures=function(){var B=this;for(this._resolving=!0;this._storedCallbackSets.length;){var L=this._storedCallbackSets;this._storedCallbackSets=[],L.forEach(function(z){z.asyncCallback?g(function(){return B._resolveFailureCallback(z)}):B._resolveFailureCallback(z)})}this._resolving=!1},x.prototype._resolveFailureCallback=function(B){var L=this;B.failFunc?l(function(){var z=B.failFunc(L._storedErrResolution);o(z)&&(B.wasCanceled?x.cancelOtherInternal(z,B.cancelContext):B.task.onCancel(function(H){return x.cancelOtherInternal(z,H)})),r(z)?z.then(function(H){B.task.resolve(H)},function(H){B.task.reject(H)}):B.task.resolve(z)},function(z){L._handleException(z,"SyncTask caught exception in failure block: "+z.toString()),B.task.reject(z)}):B.task.reject(this._storedErrResolution)},x.prototype._handleException=function(B,L){e.config.exceptionsToConsole&&console.error(L),e.config.exceptionHandler&&e.config.exceptionHandler(B)},x.prototype.toEs6Promise=function(){var B=this;return new Promise(function(L,z){return B.then(L,z)})},x._rejectedTasks=[],x}();D.SyncTask=F}(d||(d={})),e.all=y,e.Defer=T,e.Resolved=C,e.Rejected=E,e.race=I,e.raceTimer=w}),a8=bs(function(t,e){/*!
 *  Appenders.ts
 *  AUF
 *
 *  Created by Johan Blumenberg on 2016-12-29
 *  Copyright 2016 Microsoft. All rights reserved.
 *
 */var i,r=fo&&fo.__extends||(i=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(F,x){F.__proto__=x}||function(F,x){for(var B in x)x.hasOwnProperty(B)&&(F[B]=x[B])},function(F,x){function B(){this.constructor=F}i(F,x),F.prototype=x===null?Object.create(x):(B.prototype=x.prototype,new B)});Object.defineProperty(e,"__esModule",{value:!0});var o,l=function(){function F(x){this._formatter=x||new p}return F.prototype.formatter=function(){return this._formatter},F.prototype.receiveAll=function(){return!1},F.prototype.levels=function(){return null},F}();function d(F){return(4294967296+F).toString(16).substr(-8)}function h(F,x){return(1e12+F).toString(10).substr(-2)}e.AbstractLogAppender=l,function(F){F[F.Timestamp=1]="Timestamp",F[F.Component=4]="Component",F[F.Level=8]="Level",F[F.FullDate=32]="FullDate",F[F.LogId=64]="LogId"}(o=e.SLF_Flags||(e.SLF_Flags={}));var p=function(){function F(x){x===void 0&&(x=4294967295),this._flags=x}return F.prototype.format=function(x,B,L,z){var H="";if(this._flags&o.FullDate)H+=new Date(x.timestamp).toISOString()+" ";else if(this._flags&o.Timestamp){var j=new Date(x.timestamp);H+=h(j.getHours())+":"+h(j.getMinutes())+":"+h(j.getSeconds())+"."+h(j.getMilliseconds())+" "}return this._flags&o.LogId&&(H+="[#"+d(B)+"-"+(x.component.safe()?"S":"u")+"] "),this._flags&o.Level&&(H+="["+Ky.LogFactory.levelToString(x.level)+"] "),this._flags&o.Component&&(H+="["+x.component.name()+"] "),L||L===""?H+is.vsprintf(L,z):H+d(B)+": "+z.join(" ")},F}();e.StandardLogFormatter=p;var g=console,f=console.log||function(){},y=console.info||f,T=console.warn||y,C=console.error||T,E=function(F){function x(){return F!==null&&F.apply(this,arguments)||this}return r(x,F),x.prototype.log=function(B,L,z,H){H=H.slice(0);var j=B.level<=is.LogLevel.Debug3?f:B.level<=is.LogLevel.Debug1?y:B.level<=is.LogLevel.Warning?T:C;if(L===-1){var J=this.formatter().format(B,L,"",[]);typeof H[0]=="string"&&(J+=H.shift()),j.apply(g,[J].concat(H))}else{for(var Z=void 0,re=[];Z=z.match(/\s*%@\s*$/);)z=z.substr(0,z.length-Z[0].length),re.unshift(H.pop());J=this.formatter().format(B,L,z,H),j.apply(g,[J].concat(re))}},x}(l);e.ConsoleAppender=E;var I=function(){function F(x){this._chained=x}return F.prototype.log=function(x,B,L,z){this._chained.log(x,B,L,z)},F.prototype.receiveAll=function(){return this._chained.receiveAll()},F.prototype.levels=function(){return this._chained.levels()},F}();e.ChainedLogAppender=I;var w=function(F){function x(B,L){var z=F.call(this,B)||this;return z._levels=L,z}return r(x,F),x.prototype.levels=function(){return this._levels},x}(I);function D(F,x){return new w(F,x)}e.wrapAppenderWithLogLevels=D}),UVt=bs(function(t,e){/*!
 *  RootToolsManager.ts
 *  AUF
 *
 *  Created by Johan Blumenberg on 2016-12-29
 *  Copyright 2016 Microsoft. All rights reserved.
 *
 */var i,r=fo&&fo.__extends||(i=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(H,j){H.__proto__=j}||function(H,j){for(var J in j)j.hasOwnProperty(J)&&(H[J]=j[J])},function(H,j){function J(){this.constructor=H}i(H,j),H.prototype=j===null?Object.create(j):(J.prototype=j.prototype,new J)});Object.defineProperty(e,"__esModule",{value:!0});var o=Ky.LogFactory.instance().component("RootToolsManager");Ky.LogFactory.instance().declareComponentSafe("RootToolsManager",!0);var l,d="638b8ba2bae14e07aa5d73ddb5d5e5c5-297b8412-5df3-4a83-83c4-7b76c6c5d3f0-7104";(function(H){H[H.InternalBuild=0]="InternalBuild",H[H.PublicBuild=1]="PublicBuild"})(l=e.BuildType||(e.BuildType={}));var h=l.InternalBuild;function p(H){var j=h;return h=H,j}function g(H){return(4294967296+H).toString(16).substr(-8)}function f(H,j){var J=[];for(var Z in H)J.push(j(Z,H[Z]));return J}function y(H,j,J){if(H==null)return j==null||j.length===0;if(j==null)return H==null||H.length===0;if(H.length===j.length){for(var Z=0;Z<H.length;Z++)if(!J(H[Z],j[Z]))return!1;return!0}return!1}function T(H,j){return H==null?j==null:j==null?H==null:H.arg===j.arg&&H.op===j.op&&H.value===j.value}function C(H,j){return H==null?j==null||j.logId===0:j==null?H==null||H.logId===0:H.logId===j.logId&&H.name===j.name&&y(H.matchers,j.matchers,T)}function E(H,j){return H==null?j==null:j==null?H==null:H.component===j.component&&H.parsedLevel===j.level}function I(H,j){return H==null?j==null:j==null?H==null:H.component===j.component&&H.level===j.level}function w(H){for(var j=[],J=0;J<H.length;J++)typeof H[J]=="string"||typeof H[J]=="number"?j.push(H[J]):j.push(JSON.stringify(H[J]));return j}e.setBuildType=p;var D=function(H){function j(J,Z,re){var ne=H.call(this)||this;return ne._unmetConditions=[],ne._rtMan=J,ne._triggerCallback=Z,ne._ecsConfig=re,ne.resetConditions(),ne}return r(j,H),j.prototype.config=function(){return this._ecsConfig},j.prototype.configEquals=function(J){return this._ecsConfig.includeUnsafe===J.includeUnsafe&&this._ecsConfig.mutualSubmissionType===J.mutualSubmissionType&&this._ecsConfig.name===J.name&&this._ecsConfig.reenableAfterTriggering===J.reenableAfterTriggering&&this._ecsConfig.experimentTarget===J.experimentTarget&&C(this._ecsConfig.resetCondition,J.resetCondition)&&y(this._ecsConfig.conditions,J.conditions,C)&&y(this._ecsConfig.filters,J.filters,I)},j.prototype.nativeConfigEquals=function(J){return this._ecsConfig.includeUnsafe===J.includeUnsafe&&this._ecsConfig.name===J.name&&this._ecsConfig.reenableAfterTriggering===J.reenableAfterTriggering&&C(this._ecsConfig.resetCondition,J.resetCondition)&&y(this._ecsConfig.conditions,J.conditions,C)&&y(this._ecsConfig.filters,J.filters,E)},j.prototype.needReset=function(J){return!this.configEquals(J)},j.prototype.resetConditions=function(){this._unmetConditions=[];for(var J=0;J<this._ecsConfig.conditions.length;J++)this._unmetConditions.push(J)},j.prototype.matcherMatches=function(J,Z){if(J.arg>=Z.length)return!1;var re=Z[J.arg],ne=typeof re=="string"?J.value:parseInt(J.value,10);return J.op==="="||J.op==="=="?re===ne:J.op==="!="?re!==ne:J.op==="<"?re<ne:J.op==="<="?re<=ne:J.op===">"?re>ne:J.op===">="?re>=ne:J.op.toUpperCase()==="CONTAINS"&&(""+re).indexOf(J.value)>=0},j.prototype.conditionMatches=function(J,Z,re){if(Z!==J.logId)return!1;if(J.matchers){for(var ne=0;ne<J.matchers.length;ne++)if(!this.matcherMatches(J.matchers[ne],re))return!1}return!0},j.prototype.log=function(J,Z,re,ne){if(this._unmetConditions.length!==0&&J.component!==o){var le=this._ecsConfig;le.resetCondition&&this.conditionMatches(le.resetCondition,Z,ne)&&(o.debug4("LogTrigger %s: resetCondition met",le.name),this.resetConditions());for(var he=0;he<this._unmetConditions.length;he++){var Me=this._unmetConditions[he];if(this.conditionMatches(le.conditions[Me],Z,ne)){o.debug4("LogTrigger %s: condition %s met",le.name,le.conditions[Me].name),this._unmetConditions.splice(he,1);break}}this._unmetConditions.length===0&&(o.debug1("LogTrigger %s has triggered, trying to send the log",le.name),this._triggerCallback.call(this._rtMan,le),le.reenableAfterTriggering&&this.resetConditions())}},j.prototype.receiveAll=function(){return!0},j}(a8.AbstractLogAppender),F=function(H){function j(J,Z,re){var ne=H.call(this)||this;return ne._circularBuffer=[],ne._circularBufferMaxSize=0,ne._onBufferOverflow=null,ne._circularBuffer=[],ne._circularBufferMaxSize=Z,ne._includeUnsafe=J,ne._onBufferOverflow=re||function(){return ne._circularBuffer.shift()},ne}return r(j,H),j.prototype.log=function(J,Z,re,ne){if((this._includeUnsafe||J.component.safe())&&!(this._circularBuffer.length>this._circularBufferMaxSize)){var le={md:J,logId:Z,messages:w(ne)};this._circularBuffer.push(le),this._circularBuffer.length>this._circularBufferMaxSize&&this._onBufferOverflow()}},j.prototype.visitReverseOrder=function(J){for(var Z=this._circularBuffer.length-1;Z>=0;Z--){var re=this._circularBuffer[Z];if(!J(re.md,re.logId,re.messages))return}},j.prototype.visitForwardOrder=function(J){for(var Z=0;Z<this._circularBuffer.length;Z++){var re=this._circularBuffer[Z];if(!J(re.md,re.logId,re.messages))return}},j.prototype.needReset=function(J,Z){return J!==this._includeUnsafe||Z!==this._circularBufferMaxSize},j.prototype.dumpLogBuffer=function(J,Z,re){var ne=this,le=new x(J.reverse),he=J.filter.map(function(Le){return{component:Le.component==="root"?"":Le.component,parsedLevel:Le.level}}),Me=re||{matchedLines:0,totalLines:0};return(J.reverse?this.visitReverseOrder:this.visitForwardOrder).apply(this,[function(Le,pe,te){return Me.totalLines++,ne.filterMatches(Le,pe,te,he)&&(Me.matchedLines++,le.log(Le.component,Le.timestamp,Le.level,pe,te)),!Z||le._data.length<Z}]),le.close(),le.data()},j.prototype.filterMatches=function(J,Z,re,ne){for(var le=0;le<ne.length;le++)if((ne[le].component===""||J.component.name()===ne[le].component||J.component.name().substr(0,ne[le].component.length)===ne[le].component&&J.component.name().charAt(ne[le].component.length)===".")&&J.level>=ne[le].parsedLevel)return!0;return!1},j.prototype.clear=function(){this._circularBuffer=[]},j.prototype.size=function(){return this._circularBuffer.length},j.prototype.empty=function(){return this.size()===0},j.prototype.capacity=function(){return this._circularBufferMaxSize},j}(a8.AbstractLogAppender);e.CircularBuffer=F;var x=function(){function H(j){this._reverse=j,this._first=!0,this._pending=[],this._components={},this._componentCount=0,this._lastts=0,this._base64chars="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",this._data="ULOG2! ",this._data+=j?'"':" ",this._data+=" "}return H.prototype._add8=function(j){if(this._pending.push(255&j),this._pending.length===3){var J=(this._pending[0]<<16)+(this._pending[1]<<8)+(this._pending[2]|0),Z=this._base64chars[J>>18&63]+this._base64chars[J>>12&63]+this._base64chars[J>>6&63]+this._base64chars[63&J];this._data+=Z,this._pending=[]}},H.prototype._add16=function(j){this._add8(j>>8&255),this._add8(255&j)},H.prototype._add32=function(j){this._add8(j>>24&255),this._add8(j>>16&255),this._add8(j>>8&255),this._add8(255&j)},H.prototype._add64=function(j){this._add32(j/4294967296|0),this._add32(0|j)},H.prototype._addS=function(j){for(var J=0;J<j.length;J++)this._add8(j.charCodeAt(J));this._add8(0)},H.prototype._close=function(){for(;this._pending.length;)this._add8(0)},H.prototype.log=function(j,J,Z,re,ne){var le=this._components[j.name()];le||(le=++this._componentCount,this._components[j.name()]=le,this._add8(2),this._add16(le),this._addS(j.name()),this._addS(""),this._addS(""),this._add8(j.safe()?1:0));var he=128;this._first&&(he|=2);var Me=J-this._lastts;this._lastts=J,Me>-128&&Me<128&&(he|=1),this._add8(he),1&he?this._add8(Me):this._add64(1e3*J),this._first&&(this._add32(1),this._add8(0),this._add16(0)),this._add16(le),this._add8(Z),this._add32(re),this._add8(ne.length);for(var Le=0;Le<ne.length;Le++)this._add8(8),this._addS(""+ne[Le]);this._first=!1},H.prototype.close=function(){this._add8(7),this._close()},H.prototype.data=function(){return this._data},H.prototype.empty=function(){return this._first},H}(),B=function(H){function j(J,Z,re,ne){var le=H.call(this)||this;return le._capacity=J,le._onBufferOverflow=Z,le._enableThrottling=re,le._maxVerbosityLevel=ne,le._outputFormatter=new x(!1),le._linesStored=0,le._throttling=!1,le._linesThrottled=0,le}return r(j,H),j.prototype.log=function(J,Z,re,ne){this._maxVerbosityLevel&&J.level<this._maxVerbosityLevel||(this._throttling?this._linesThrottled++:(this._linesStored++,this._outputFormatter.log(J.component,J.timestamp,J.level,Z,w(ne))),this._linesStored>this._capacity&&(this._enableThrottling?this._throttling||(this._throttling=!0):this._onBufferOverflow()))},j.prototype.dumpAndReset=function(){if(this._outputFormatter.empty())return"";this._linesThrottled>0&&this._outputFormatter.log(o,new Date().getTime(),is.LogLevel.Fatal,-1,["RooToolsManager: Log buffer overflow! "+this._linesThrottled+" lines thrown away"]),this._outputFormatter.close();var J=this._outputFormatter.data();return this.clearBuffer(),J},j.prototype.empty=function(){return this._outputFormatter.empty()},j.prototype.clearBuffer=function(){this._outputFormatter=new x(!1),this._linesStored=0,this._linesThrottled=0,this._throttling=!1},j.prototype.capacity=function(){return this._capacity},j.prototype.throttlingEnabled=function(){return this._enableThrottling},j.prototype.size=function(){return this._linesStored},j.prototype.maxVerbosityLevel=function(){return this._maxVerbosityLevel},j}(a8.AbstractLogAppender);function L(H){return H==="Native"||H==="JavaScript"||H==="Mixed"}e.DumperBuffer=B;var z=function(){function H(){this._maxUploadSize=0,this._jsToNativeBuffer=null,this._jsToNativeBufferHandle=null,this._jsToNativeFlushTimer=null,this._jsToNativeFlushInterval=0,this._triggers={},this._defaultBuffers=[{size:2097152,level:is.LogLevel.Debug4}],this._defaultKillswitch={blacklist:[],whitelist:[]},this._defaultBlacklists={component:[],logline:[]},this._localLogLevels={},this._defaultExperimentTarget="Mixed",this._BRBCallback=null}return H.prototype.setDelegate=function(j){this._glue=j,this.registerListeners()},H.prototype.isDelegateSet=function(){return this._glue!=null},H.prototype.setNativeFunctions=function(j){this._native&&this._native.log_config.removeLogTriggerListener(this),this._native=j,this._native&&this._native.log_config.addLogTriggerListener(this)},H.prototype.applyLogLevels=function(){var j={};for(var J in this._localLogLevels)j[J]=this._localLogLevels[J];j[""]=j.root||is.LogLevel.Debug4,delete j.root;var Z=f(j,function(re,ne){return{component:re,level:ne}});Z.sort(function(re,ne){return re.component.length-ne.component.length}),Z.forEach(function(re){return Ky.LogFactory.instance().component(re.component).setLevel(re.level)}),this._native&&this._native.log_config.setLogLevelConfig(Z)},H.prototype.setLocalLogLevelConfig=function(j){this._localLogLevels=j,this.applyLogLevels()},H.prototype.parseMatcher=function(j){return j==null||j.arg==null||j.op==null||j.value==null?null:{arg:j.arg,op:j.op,value:j.value}},H.prototype.parseCondition=function(j){if(j==null||j.logId==null||j.matchers&&!(j.matchers instanceof Array))return null;var J={name:j.name||g(j.logId),logId:j.logId,matchers:[]};if(j.matchers&&j.matchers.length)for(var Z=0,re=j.matchers;Z<re.length;Z++){var ne=re[Z],le=this.parseMatcher(ne);le&&J.matchers.push(le)}return J},H.prototype.parseFilter=function(j){return j==null||j.component==null||j.component.length===0?null:{component:j.component,level:j.level,parsedLevel:Ky.LogFactory.levelFromString(j.level)}},H.prototype.parseConfig=function(j,J,Z){if(j==null||!(j.conditions instanceof Array)||j.conditions.length==0||!(j.filters instanceof Array)||j.filters.length==0||j.resetCondition&&!this.parseCondition(j.resetCondition))return null;for(var re={name:j.name||J+"->"+Z,ecsNs:J,reenableAfterTriggering:j.reenableAfterTriggering||!1,mutualSubmissionType:j.mutualSubmissionType||"",includeUnsafe:h!==l.PublicBuild&&(j.includeUnsafe||!1),experimentTarget:L(j.experimentTarget)&&j.experimentTarget||this._defaultExperimentTarget,conditions:[],resetCondition:j.resetCondition==null?j.resetCondition:this.parseCondition(j.resetCondition),filters:[]},ne=0,le=j.conditions;ne<le.length;ne++){var he=le[ne],Me=this.parseCondition(he);Me&&re.conditions.push(Me)}for(var Le=0,pe=j.filters;Le<pe.length;Le++){var te=pe[Le],Se=this.parseFilter(te);Se&&re.filters.push(Se)}return re.conditions.length===0?null:re},H.prototype.isExperimentListed=function(j,J,Z,re){return!!j&&(!(!re||!j.some(function(ne){return ne.namespace==="*"}))||j.some(function(ne){return ne.namespace===J&&(ne.experiment===Z||ne.experiment=="*")}))},H.prototype.isExperimentAllowed=function(j,J,Z){return!this.isExperimentListed(j.blacklist,J,Z,!0)||this.isExperimentListed(j.whitelist,J,Z,!1)},H.prototype.findTrigger=function(j,J){for(var Z in j)if(j[Z].configEquals(J))return Z;return null},H.prototype.findTriggerByNativeConfig=function(j,J){for(var Z in j)if(j[Z].nativeConfigEquals(J))return Z;return null},H.prototype.OnEcsChange=function(){var j=this;function J(Z,re,ne){return re<Z.length?ne(Z[re]).then(function(){return J(Z,re+1,ne)}):oh.Resolved()}return this._glue==null?oh.Resolved():this._glue.fetchEcsConfig("SkypeRootTools","ULBaseline").then(function(Z){o.debug4("Reloading ULBaseline config - new config: %@",Z),Z||(o.warn("No ULBaseline config"),Z={}),j._maxUploadSize=Z.logUpload&&Z.logUpload.maxSize||1024;var re=[],ne=j._triggers;j._triggers={};var le=(Z.logUpload&&Z.logUpload.maxSize||1024)/100,he=Z.circularBuffer&&Z.circularBuffer.enabled,Me=Z.circularBuffer&&Z.circularBuffer.buffers||j._defaultBuffers,Le=Z.circularBuffer&&Z.circularBuffer.storeUnsafe;j._defaultExperimentTarget=L(Z.defaultExperimentTarget)&&Z.defaultExperimentTarget||"Mixed";var pe=Z.killswitch||j._defaultKillswitch,te=Z.blacklists||j._defaultBlacklists;te.component.length>0&&Ky.LogFactory.instance().setComponentBlacklist(te.component);var Se={};(Z.componentLevels||[]).forEach(function(ce){return Se[ce.component]=ce.level}),J(Z.configPaths||[],0,function(ce){return j._glue.fetchEcsConfig(ce.ns,ce.key).then(function(X){var ve=X instanceof Array?X:[X];o.debug4("Reloading ECS config for %s->%s - new config: %@",ce.ns,ce.key,ve);for(var Te=0,Be=ve;Te<Be.length;Te++){var qe=Be[Te];if(qe!=null){var Ge=j.parseConfig(qe,ce.ns,ce.key);if(Ge!=null)if(Ge.experimentTarget==="JavaScript"||Ge.experimentTarget==="Mixed")if(o.debug2("Parsed ECS config for %s->%s - %@",ce.ns,ce.key,Ge),j.isExperimentAllowed(pe,ce.ns,Ge.name)){o.debug2("Allowing %s->%s:%s according to killswitch",ce.ns,ce.key,Ge.name),he=!0;var tt=j.findTrigger(ne,Ge);tt!=null?(o.debug2("Triggers updated, keeping trigger %s",Ge.name),j._triggers[tt]=ne[tt],delete ne[tt]):re.push(Ge),Ge.filters&&Ge.filters.forEach(function(ct){return Se[ct.component]=Math.min(Se[ct.component]||255,ct.parsedLevel)}),Ge.includeUnsafe&&(Le=!0)}else o.debug2("Disallowing %s->%s according to killswitch",ce.ns,ce.key);else o.debug4("Skipping %s->%s, targeted for %s",ce.ns,ce.key,Ge);else o.error("Failed to parse ECS config for %s->%s",ce.ns,ce.key)}}})}).always(function(){for(var ce in j.applyLogLevels(),ne)o.debug2("Triggers updated, removing trigger %s",ne[ce].config().name),Ky.LogFactory.instance().removeAppender(+ce);if(re.forEach(function(qe){o.debug2("Triggers updated, adding trigger %s",qe.name);var Ge=new D(j,j._triggered,qe),tt=Ky.LogFactory.instance().addAppender(Ge);j._triggers[String(tt)]=Ge}),Se[""]=Se.root||is.LogLevel.Debug4,delete Se.root,!j._circularBuffer||he&&!j._circularBuffer.needReset(Le,le)?j._circularBuffer&&(Object.keys(ne).length>0||re.length>0?(o.debug2("Buffer updated, reapplying log levels, removing log levels wrapper"),Ky.LogFactory.instance().removeAppender(j._circularBufferHandle),j._circularBufferHandle=null):o.debug2("Buffer updated, no change")):(o.debug2("Buffer updated, removing existing buffer"),Ky.LogFactory.instance().removeAppender(j._circularBufferHandle),j._circularBuffer=null,j._circularBufferHandle=null),he&&(j._circularBuffer||(o.debug2("Buffer updated, adding new buffer (storeUnsafe=%d,maxSize=%s)",Le,le),j._circularBuffer=new F(Le,le)),j._circularBufferHandle==null&&(o.debug2("Creating log level wrapper"),j._circularBufferHandle=Ky.LogFactory.instance().addAppender(a8.wrapAppenderWithLogLevels(j._circularBuffer,Se),is.AppenderFlags.InsertFront))),j._native){var X=f(Se,function(qe,Ge){return{component:qe,level:Ge}});X.sort(function(qe,Ge){return qe.component.length-Ge.component.length}),j._native.log_config.setLogBufferConfig(he,{storeUnsafe:Le,buffers:Me},X);var ve=[];for(var Te in j._triggers){var Be=j._triggers[Te].config();ve.push({name:Be.name,ecsNs:Be.ecsNs,conditions:Be.conditions,resetCondition:Be.resetCondition,includeUnsafe:Be.includeUnsafe,reenableAfterTriggering:Be.reenableAfterTriggering,filters:Be.filters.map(function(qe){return{component:qe.component,level:qe.parsedLevel}}),dumpFile:!1,metadata:{}})}j._native.log_config.setLogTriggerConfig(ve,{})}})})},H.prototype._send=function(j,J){this._glue!=null&&(this._glue.sendTelemetry(d,{logTriggerName:j.name,logEcsNs:j.ecsNs,logdata:J}),o.debug4("LogSender::send, sent %d bytes",J.length))},H.prototype.triggered=function(j,J){},H.prototype.triggeredPartially=function(j,J,Z,re,ne){var le=this.findTriggerByNativeConfig(this._triggers,j);if(le){var he={level:J.level,component:Ky.LogFactory.instance().component(J.component),timestamp:J.timestamp};this._triggers[le].log(he,Z,re,ne)}},H.prototype.reset=function(j){var J=this.findTriggerByNativeConfig(this._triggers,j);J&&this._triggers[J].resetConditions()},H.prototype.dumpLogBuffer=function(j,J){if(this._circularBuffer){var Z={matchedLines:0,totalLines:0},re=this._circularBuffer.dumpLogBuffer(j,this._maxUploadSize,Z);if(o.debug4("dumpLogBuffer: dumped %d of %d lines, size of payload: %d",Z.matchedLines,Z.totalLines,re!=null?re.length:0),this._native){var ne=oh.Defer();return this._native.log_config.mergeAndDumpLogBuffer(re,j,J,function(le){return ne.resolve(le)}),ne.promise()}return oh.Resolved(re)}return o.warn("dumpLogBuffer: no log buffer enabled"),oh.Rejected()},H.prototype._triggered=function(j){var J=this,Z={compression:is.LogFileCompression.Compress,encoding:is.LogFileEncoding.Base64,encryption:is.LogFileEncryption.Encrypted,maxRotations:0,maxSize:this._maxUploadSize,reverse:!0},re={includeUnsafe:j.includeUnsafe,filter:j.filters.map(function(ne){return{component:ne.component,level:ne.parsedLevel}}),reverse:!0};this.dumpLogBuffer(re,Z).then(function(ne){return J._send(j,ne)})},H.prototype.sendBRBEvent=function(j,J){try{if(o.debug2("sendBRBEvent %s",JSON.stringify(j)),this._glue!=null&&typeof this._glue.sendLoggingEventToNative=="function"){var Z={eventType:"uploadBRB",mutualSubmissionType:"call",payload:j},re=J!==void 0?JSON.stringify({userIds:J}):"";this._glue.sendLoggingEventToNative(JSON.stringify(Z),re)}}catch(ne){o.error("sendBRBEvent %s: %s",ne.name,ne.message)}},H.prototype.setBRBCallback=function(j){o.debug2("setBRBCallback"),this._glue!=null?typeof this._glue.setNativeLoggingEventCallback=="function"?this._BRBCallback=j:o.warn("setBRBCallback: RootToolsManagerDelegate missing setNativeLoggingEventCallback method"):o.warn("setBRBCallback: RootToolsManagerDelegate is not set")},H.prototype.registerListeners=function(){var j=this;this._glue!=null&&typeof this._glue.setNativeLoggingEventCallback=="function"?this._glue.setNativeLoggingEventCallback(function(J,Z){return j.handleNativeLoggingEvent(J,Z)}):o.warn("registerListeners: RootToolsManagerDelegate missing setNativeLoggingEventCallback method")},H.prototype.handleNativeLoggingEvent=function(j,J){try{o.debug2("Native Log event message: %s aux: %s",j,J);var Z=JSON.parse(j);if(Z.eventType&&Z.eventType==="uploadBRB"){if(typeof this._BRBCallback!="function")return void o.warn("BRBCallback not set, ignoring native event");o.debug4("Sending BRB callback: %@",Z.payload),this._BRBCallback(Z.payload)}else Z.eventType&&Z.eventType==="jsLogFileConfiguration"&&this.handleLogFileConfigEvent(Z)}catch(re){o.error("handleNativeLoggingEvent %s: %s",re.name,re.message)}},H.prototype.handleLogFileConfigEvent=function(j){if(j.payload){var J=j.payload;if(J.enabled){if(J.chunkSize&&J.flushInterval){var Z={chunkSize:J.chunkSize,flushInterval:J.flushInterval,enableThrottling:J.enableThrottling,maxVerbosityLevel:J.maxVerbosityLevel};this.startJsToNativeLogging(Z)}}else this.flushDisableJsToNativeLogging()}},H.prototype.logExternalForDDL=function(j,J){try{if(o.debug2("logExternalForDDL %s %s",j,J),this._glue!=null&&typeof this._glue.sendLoggingEventToNative=="function"){var Z={eventType:"logInSClog",payload:{message:j,parameters:J}};this._glue.sendLoggingEventToNative(JSON.stringify(Z),"")}else o.warn("ignoring logExternalForDDL, delegate misconfigured")}catch(re){o.error("logExternalForDDL %s: %s",re.name,re.message)}},H.prototype.startJsToNativeLogging=function(j){var J=this,Z=j.chunkSize,re=j.flushInterval,ne=j.enableThrottling,le=this._getVerbosityLevelFromConfig(j.maxVerbosityLevel);if(this._jsToNativeBuffer){if(this._jsToNativeBuffer.capacity()===Z&&this._jsToNativeFlushInterval===re&&this._jsToNativeBuffer.throttlingEnabled()===ne&&this._jsToNativeBuffer.maxVerbosityLevel()===le)return void o.debug1("Same JS2Native settings received - doing nothing");o.debug1("Reapplying js to native settings"),this.flushDisableJsToNativeLogging()}this._jsToNativeBuffer=new B(Z,function(){J.onJsToNativeBufferReady(J._jsToNativeBuffer)},ne,le),this.setJsToNativeFlushTimeout(re),this._jsToNativeFlushInterval=re,this._jsToNativeBufferHandle=Ky.LogFactory.instance().addAppender(this._jsToNativeBuffer)},H.prototype._getVerbosityLevelFromConfig=function(j){return j?Ky.LogFactory.levelFromString(j):null},H.prototype.flushDisableJsToNativeLogging=function(){this._jsToNativeBuffer&&this.onJsToNativeBufferReady(this._jsToNativeBuffer),this.plainDisableJsToNativeLogging()},H.prototype.plainDisableJsToNativeLogging=function(){this.clearJsToNativeFlushTimeout(),this._jsToNativeBufferHandle&&(Ky.LogFactory.instance().removeAppender(this._jsToNativeBufferHandle),this._jsToNativeBufferHandle=0,this._jsToNativeBuffer=null,o.debug1("Disabling forwarding JS logs to native"))},H.prototype.onJsToNativeBufferReady=function(j){this._glue!=null&&typeof this._glue.sendLoggingEventToNative=="function"?(this.clearJsToNativeFlushTimeout(),this.dumpJsToNativeBuffer(j),this.setJsToNativeFlushTimeout(this._jsToNativeFlushInterval)):this.plainDisableJsToNativeLogging()},H.prototype.dumpJsToNativeBuffer=function(j){if(!j.empty()){var J=j.dumpAndReset(),Z={eventType:"writeLogData"};this._glue.sendLoggingEventToNative(JSON.stringify(Z),J)}},H.prototype.clearJsToNativeFlushTimeout=function(){this._jsToNativeFlushTimer&&(clearTimeout(this._jsToNativeFlushTimer),this._jsToNativeFlushTimer=null)},H.prototype.setJsToNativeFlushTimeout=function(j){var J=this;!this._jsToNativeFlushTimer&&j&&(this._jsToNativeFlushTimer=setTimeout(function(){J._jsToNativeFlushTimer=null,J.onJsToNativeBufferReady(J._jsToNativeBuffer)},j))},H.prototype.stopAsyncOperations=function(){this.flushDisableJsToNativeLogging()},H}();e.RootToolsManager=new z}),zVt=bs(function(t,e){/*!
 *  pii.ts
 *  AUF
 *
 *  Created by Johan Blumenberg on 2017-01-16
 *  Copyright 2017 Microsoft. All rights reserved.
 *
 */Object.defineProperty(e,"__esModule",{value:!0});var i=function(C){return C},r=!0,o=i,l={},d=0;function h(C){return l[C]="u"+ ++d}var p,g=/^([0-9][0-9]?):([^<>\*\{\}&'\"\/\\?^`|~\s]+)$/;(function(C){C[C.MSA=1]="MSA",C[C.S4B_Bridge=2]="S4B_Bridge",C[C.PSTN=4]="PSTN",C[C.SkypeId=8]="SkypeId",C[C.Thread=19]="Thread",C[C.LegacyShortCircuit=20]="LegacyShortCircuit",C[C.OneToOneTextMessage=21]="OneToOneTextMessage",C[C.GroupTextMessage=22]="GroupTextMessage",C[C.Bot=28]="Bot",C[C.InternalSkype=48]="InternalSkype"})(p||(p={}));var f=[p.Thread,p.InternalSkype];function y(C){r=C}function T(C){o=C||i}e.enableAnonymization=y,e.useTagger=T,function(C){function E(F){return r?F?l[F]||h(F):null:F}function I(F){var x=E(F);return o(x)}function w(F){var x,B=F.match(g);if(B){var L=Number(B[1]),z=B[2];x=f.indexOf(L)!=-1?F:L+":"+E(z)}else x=E(F);return o(x)}function D(F){var x;return x=r?typeof F=="number"?19229:typeof F=="string"?F.charAt(0)+"...":null:F,o(x)}C.UserName=I,C.Mri=w,C.Omit=D}(e.pii||(e.pii={}))}),Hv=bs(function(t,e){/*!
 *  index.ts
 *  AUF
 *
 *  Created by Johan Blumenberg on 2016-12-29
 *  Copyright 2016 Microsoft. All rights reserved.
 *
 */function i(r){for(var o in r)e.hasOwnProperty(o)||(e[o]=r[o])}Object.defineProperty(e,"__esModule",{value:!0}),i(is),i(Ky),i(UVt),i(a8),i(zVt)});function VVt(t,e,i,r){const o=["audioBitrate","videoBitrate","downloadBitrate","bufferLengthInMs","videoHeight","videoWidth","currentPlayPosition"],l=e[i.toString()];l!==void 0&&o.forEach(d=>{const h=d,p=d;if(l[h]!==void 0){const g=l[h];t[p]===void 0?t[p]=[g]:(t[p]?.length>=r&&t[p]?.shift(),t[p]?.push(g))}})}class $Vt{get createViewStats(){return this._createViewStats}get initialCreateViewStats(){return this._initialCreateViewStats}constructor(e,i,r,o,l){this._statsCollector=e,this._streamId=i,this._logger=r,this._call=o,this._attemptTimestamp=l,this._createViewFailureStats={},this._createViewStats={},this._initialCreateViewStats={},this._statsCollector.on("sampleReported",d=>{SUt(this.createViewStats,this.initialCreateViewStats,d,this._streamId)})}getCreateViewFailureStats(){try{let e=0,i=NaN;this.createViewStats.video?.framesDropped!==void 0&&this.initialCreateViewStats.video?.framesDropped!==void 0&&(e=this.createViewStats.video?.framesDropped.length,i=this.createViewStats.video?.framesDropped[e-1]-this.initialCreateViewStats.video?.framesDropped[0]);let r=NaN;this.createViewStats.video?.framesReceived!==void 0&&this.initialCreateViewStats.video?.framesReceived!==void 0&&(e=this.createViewStats.video.framesReceived.length,r=this.createViewStats.video.framesReceived[e-1]-this.initialCreateViewStats.video?.framesReceived[0]);let o=NaN;this.createViewStats.video?.framesDecoded!==void 0&&this.initialCreateViewStats.video?.framesDecoded!==void 0&&(e=this.createViewStats.video.framesDecoded.length,o=this.createViewStats.video.framesDecoded[e-1]-this.initialCreateViewStats.video?.framesDecoded[0]);let l=NaN;this.createViewStats.video?.keyFramesDecoded!==void 0&&this.initialCreateViewStats.video?.keyFramesDecoded!==void 0&&(e=this.createViewStats.video.keyFramesDecoded.length,l=this.createViewStats.video.keyFramesDecoded[e-1]-this.initialCreateViewStats.video?.keyFramesDecoded[0]);let d=0;!isNaN(i)&&r>0&&(d=Number((i/r*100).toFixed(7)));let h=!1;r>0&&o===0&&(h=!0);let p=!1;!isNaN(o)&&!isNaN(l)&&o>0&&o===l&&(p=!0);const g=[],f=this._call.networkQualityUfdEventDetails,y=wt().rendering.remoteVideo.createViewFailureNetworkUfdCheckWindowInMs;f.forEach(C=>{Math.abs(C.timestampInfo-this._attemptTimestamp)<=y&&g.push(C)});const T=r===0;this._createViewFailureStats.video={framesDroppedPercentage:d,framesReceivedButNothingDecoded:h,onlyKeyFramesDecoded:p,networkQualityEventsDuringAttempt:g,zeroFramesReceived:T}}catch{this._logger.debug("Error calculating create view failure stats!")}return this._createViewFailureStats}}class HVt{constructor(e,i){this._liveStreamStatsCollector=e,this._streamId=i,this._liveStreamStats={},this._initialLiveStreamStats={};const r=wt()?.rendering.remoteVideo.createViewSendMediaStatsMaxLength;this._liveStreamStatsCollector.on("sampleReported",o=>{VVt(this._liveStreamStats,o,this._streamId,r),dn.isEmpty(this._initialLiveStreamStats)&&(this._initialLiveStreamStats=this._liveStreamStats)})}get initialCreateViewLiveStreamStats(){return this._initialLiveStreamStats}get createViewLiveStreamStats(){return this._liveStreamStats}}var Kpe=function(t,e,i,r){var o,l=arguments.length,d=l<3?e:r===null?r=Object.getOwnPropertyDescriptor(e,i):r;if(typeof Reflect=="object"&&typeof Reflect.decorate=="function")d=Reflect.decorate(t,e,i,r);else for(var h=t.length-1;h>=0;h--)(o=t[h])&&(d=(l<3?o(d):l>3?o(e,i,d):o(e,i))||d);return l>3&&d&&Object.defineProperty(e,i,d),d},WB=function(t,e){if(typeof Reflect=="object"&&typeof Reflect.metadata=="function")return Reflect.metadata(t,e)};class KB{get _createViewStats(){return this._videoStream.kind!=="RemoteVideoStream"&&this._videoStream.kind!=="ComposedVideoStream"||!this._createViewTelemetryHelper?this._videoStream.kind==="LiveVideoStream"&&this._createViewLiveStreamTelemetryHelper?this._createViewLiveStreamTelemetryHelper.createViewLiveStreamStats:{}:this._createViewTelemetryHelper.createViewStats}constructor(e){if(this.size={height:0,width:0},this.views=new Map,this.disposed=!1,this._attemptToDisposeView=r=>{try{r?.dispose()}catch(o){this.logger.warn(o?.message||"Failed to dispose, unknown error")}},this._addActiveRemoteVideoStreamView=(r,o,l)=>{if(r.call.activeRemoteVideoStreamViews?.has(r.id)){let d=r.call.activeRemoteVideoStreamViews?.get(r.id);d&&d.set(o,l)}else{let d=new Map;d.set(o,l),r.call.activeRemoteVideoStreamViews?.set(r.id,d)}},!(e instanceof kp||e instanceof FB||e instanceof Q3))throw new Oe({defaultError:we.VIEW.RENDERER_WRONG_STREAM_TYPE});const i=zf("ACS");this._videoStream=e,this._telemetryLogManager=e.telemetryLogManager,this.logger=new rh(i,e instanceof kp?[()=>`VideoStreamRenderer:LocalVideoStream:${Hv.pii.Omit(e?.source?.id)}`]:[()=>`VideoStreamRenderer:${e.kind}:${e?.id}`]),this.logger.info("created")}async createView(e){if(this.disposed)throw new Oe({defaultError:we.VIEW.RENDERER_DISPOSED});const i={},r=+new Date,o=ln(),l=ln();let d,h;try{let p=1;if(i.attemptTimestamp=r,this.sendCreateViewEvent({eventName:vi.acs_calling_create_view_attempt,viewId:o,correlationId:l,timestampInfo:{attemptTimestamp:r},isMirrored:e?.isMirrored,scalingMode:e?.scalingMode,stepsInfo:i}),this._videoStream.kind==="RemoteVideoStream"&&!this._videoStream.isAvailable)throw new Oe({defaultError:we.VIEW.ISAVAILABLE_FALSE});const g=wt(),f=nQ();if(this._videoStream.kind==="RemoteVideoStream"&&this._videoStream.mediaStreamType!=="ScreenSharing"&&g?.calling.applyViewLimit&&f?.numVideoChannelsGvc){const T=f?.numVideoChannelsGvc,C=this._videoStream;if(!C.call.activeRemoteVideoStreamViews?.has(C.id)&&C.call.activeRemoteVideoStreamViews?.size>=T)throw new Oe({defaultError:we.VIEW.MAX_NUM_OF_VIEWS_REACHED,defaultErrorMessageArgs:[T]})}if(g?.rendering.remoteVideo.createViewSendMediaStats){if(this._videoStream.kind==="RemoteVideoStream"||this._videoStream.kind==="ComposedVideoStream"){const T=this._videoStream,C=T.call;h=T.call.feature(Ma.MediaStats).createCollector();const E=T.id;this._createViewTelemetryHelper=new $Vt(h,E,this.logger,C,r)}else if(this._videoStream.kind==="LiveVideoStream"){const T=this._videoStream;h=T.call.feature(Ma.LiveStream).createStatsCollector();const C=T.id;this._createViewLiveStreamTelemetryHelper=new HVt(h,C)}}d=new Ek(this._videoStream,this.logger,o,i,e),this.views.set(o,d),p=await d.render(),this._videoStream.kind==="RemoteVideoStream"&&this._videoStream.mediaStreamType!=="ScreenSharing"&&this._addActiveRemoteVideoStreamView(this._videoStream,o,d),this._videoStream.kind==="RemoteVideoStream"&&this._videoStream.mediaStreamType==="ScreenSharing"&&g?.rendering.remoteVideo.decrementOvcOnRemoteSsRendering&&(this._videoStream.call.setIsRenderingRemoteScreenShare(!0),Ek.remoteScreenSharingViews.set(o,d));const y=+new Date;return this.sendCreateViewEvent({eventName:vi.acs_calling_create_view_success,viewId:o,correlationId:l,timestampInfo:{deltaTimeInMs:y-r},additionalProperties:{isRetry:!!p&&p>1,attemptNumber:p},stepsInfo:i}),d}catch(p){const g=new Oe({defaultError:we.VIEW.CREATE_VIEW_FAILED,originalError:p});if(this.views.delete(o),this._attemptToDisposeView(d),g.message!==we.VIEW.LARGE_MEETING_VIEW_DISPOSED.message&&g.message!==we.VIEW.REMOTE_VIDEO_STREAM_DISPOSED.message){const f=Date.now();this.sendCreateViewEvent({eventName:vi.acs_calling_create_view_failure,viewId:o,correlationId:l,timestampInfo:{deltaTimeInMs:f-r},stepsInfo:i},g)}throw g}finally{h?.dispose()}}async sendCreateViewEvent(e,i){try{let r={},o={},l={};if(wt()?.rendering.remoteVideo.createViewSendMediaStats&&(e.eventName===vi.acs_calling_create_view_failure||e.eventName===vi.acs_calling_create_view_success)){if(this._videoStream.kind==="RemoteVideoStream"){const p=this._videoStream.call,g=await p.tsCall.getMediaSessionStatsAsync?.();r={isRetry:e.additionalProperties?.isRetry??!1,attemptNumber:e.additionalProperties?.attemptNumber??1,videoSubscriptionEvents:g?.extensions?.Video_SubscriptionEvents,screenSharingSubscriptionEvents:g?.extensions?.Sharing_SubscriptionEvents,videoSendMaxCapabilities:g?.extensions?.Video_send_MaxCapabilities,screenSharingSendMaxCapabilities:g?.extensions?.Sharing_send_MaxCapabilities,iceConnectedStateTime:g?.metrics?.IceConnectedStateTime,relayCandidate:g?.extensions?.RelayCandidate,videoRecvTimeToFirstFrame:g?.extensions?.Video_recv_TimeToFirstFrame,screenSharingRecvTimeToFirstFrame:g?.extensions?.Sharing_recv_TimeToFirstFrame,optimalVideoCount:p.tsCall.optimalVideoCount||1,currentNumberOfVideosRendered:p.activeRemoteVideoStreamViews?.size||0}}e.eventName===vi.acs_calling_create_view_failure&&(l=this._createViewTelemetryHelper?.getCreateViewFailureStats()??{},o=this._createViewStats)}r.visibilityState=document.visibilityState,e.isMirrored!==void 0&&(r.isMirrored=e.isMirrored),e.scalingMode!==void 0&&(r.scalingMode=e.scalingMode),e.eventName!==vi.acs_calling_create_view_failure&&e.eventName!==vi.acs_calling_create_view_success||this._videoStream.kind!=="RemoteVideoStream"&&this._videoStream.kind!=="ComposedVideoStream"||dn.forOwn(e.stepsInfo,(p,g)=>{p!==void 0&&(r[g]=p)});let d="",h={};i&&(d=typeof i?.message=="string"?i?.message:"",h={...an(i)}),this._telemetryLogManager.sendEvent({name:e.eventName,tenant:Wr,properties:{viewId:e.viewId,correlationId:e.correlationId,timestampInfo:e.timestampInfo,...this._videoStream.getStreamMetadata(),failureReason:d,additionalProperties:r,additionalDetails:h,stats:o,createViewFailureDebugStats:l,videoStreamKind:this._videoStream.kind}})}catch{this.logger.debug("Unable to send telemtery")}}dispose(){if(this.disposed)throw new Oe({defaultError:we.VIEW.RENDERER_ALREADY_DISPOSED});this.disposed=!0,this.views.forEach(this._attemptToDisposeView),this.views.clear()}}Kpe([zv,WB("design:type",Object)],KB.prototype,"logger",void 0),Kpe([to(XY.CreateView),WB("design:type",Function),WB("design:paramtypes",[Object]),WB("design:returntype",Promise)],KB.prototype,"createView",null),Kpe([sg(XY.Dispose),WB("design:type",Function),WB("design:paramtypes",[]),WB("design:returntype",void 0)],KB.prototype,"dispose",null);var Z5e=function(t,e,i,r){var o,l=arguments.length,d=l<3?e:r===null?r=Object.getOwnPropertyDescriptor(e,i):r;if(typeof Reflect=="object"&&typeof Reflect.decorate=="function")d=Reflect.decorate(t,e,i,r);else for(var h=t.length-1;h>=0;h--)(o=t[h])&&(d=(l<3?o(d):l>3?o(e,i,d):o(e,i))||d);return l>3&&d&&Object.defineProperty(e,i,d),d},tZ=function(t,e){if(typeof Reflect=="object"&&typeof Reflect.metadata=="function")return Reflect.metadata(t,e)};class Jpe{get identifier(){return this._identifier}get endpointDetails(){return this._tsParticipant?.endpoints?.endpointDetails.map(e=>({participantId:e.participantId,deviceType:e.deviceType,clientEndpointCapabilities:e.clientEndpointCapabilities,endpointMetadata:e.endpointMetadata}))||[]}get state(){return this._state}get videoStreams(){return[...this._mappedStreams.values()]}get isMuted(){return this._isMuted}get isSpeaking(){return this._isSpeaking}get callEndReason(){return this._callEndReason}get displayName(){return this._displayName}get role(){return this._role}constructor(e,i,r,o,l){this._mappedStreams=new Map,this._state="Idle",this._lastTsParticipantState=0,this._isMuted=!1,this._isSpeaking=!1,this._displayName="",this._role="Unknown",this.acsToTsStreamType=d=>d==="Video"?0:d==="ScreenSharing"?1:void 0,this._identifier=e,this.logger=i.createChild(()=>`RemoteParticipant{${this._identifier.kind}}`),this._telemetryLogManager=l,this._eventEmitter=new qf(this.logger),this._callAgent=o,this._call=r,this.logger.log("created"),this._renderers={Video:{renderingState:{}},ScreenSharing:{renderingState:{}}}}on(e,i){if(e!=="stateChanged"&&e!=="isMutedChanged"&&e!=="isSpeakingChanged"&&e!=="displayNameChanged"&&e!=="roleChanged"&&e!=="videoStreamsUpdated")throw new Oe({defaultError:we.REMOTE_PARTICIPANT.EVENT_SUBSCRIBE,defaultErrorMessageArgs:[e]});this._eventEmitter.on(e,i)}off(e,i){if(e!=="stateChanged"&&e!=="isMutedChanged"&&e!=="isSpeakingChanged"&&e!=="displayNameChanged"&&e!=="roleChanged"&&e!=="videoStreamsUpdated")throw new Oe({defaultError:we.REMOTE_PARTICIPANT.EVENT_UNSUBSCRIBE,defaultErrorMessageArgs:[e]});this._eventEmitter.off(e,i)}async mute(){const e=wt();if(!e.calling.enableMuteOthers)throw new Oe({defaultError:we.REMOTE_PARTICIPANT.MUTE_PARTICIPANT_DISABLED});if(!this._call.tsCall.conversationType&&this._call.callInfo.context===To.TwoParty)throw new Oe({defaultError:we.REMOTE_PARTICIPANT.MUTE_PARTICIPANT_1_TO_1_UNSUPPORTED});if(!["Connected","Hold"].some(l=>l===this._state))throw new Oe({defaultError:we.REMOTE_PARTICIPANT.MUTE_PARTICIPANT_NONCONNECTED_UNSUPPORTED});const i=this.logger.createFnLogger(ZY.Mute),r=+new Date,o=ln();if(this.sendAudioEvent({eventName:vi.acs_calling_mute_attempt,eventType:hg.MuteSpecificParticipant,timestampInfo:{attemptTimestamp:r},correlationId:o,step:"mid-call"}),!e.calling.allowMutePstnRemoteParticipant&&this._identifier.kind==="phoneNumber"){const l=+new Date,d=we.REMOTE_PARTICIPANT.MUTE_PARTICIPANT_PSTN_UNSUPPORTED;i.warn(d.message);const h=new Oe({defaultError:d});throw this.sendAudioEvent({eventName:vi.acs_calling_mute_failure,eventType:hg.MuteSpecificParticipant,timestampInfo:{deltaTimeInMs:l-r},correlationId:o,step:"mid-call"},h),h}try{i.info("remote mute specific"),this._tsParticipant!==void 0?await this._call.tsCall.muteParticipants(1,[this._tsParticipant]):i.warn("no participant to mute in attempt to mute specific remote participant"),i.info("remote mute specific success");const l=+new Date;this.sendAudioEvent({eventName:vi.acs_calling_mute_success,eventType:hg.MuteSpecificParticipant,timestampInfo:{deltaTimeInMs:l-r},correlationId:o,step:"mid-call"})}catch(l){const d=new Oe({defaultError:we.REMOTE_PARTICIPANT.MUTE_PARTICIPANT_FAILED,originalError:l});i.error(d.message);const h=+new Date;throw this.sendAudioEvent({eventName:vi.acs_calling_mute_failure,eventType:hg.MuteSpecificParticipant,timestampInfo:{deltaTimeInMs:h-r},correlationId:o,step:"mid-call"},d),d}}_dispose(){this.logger.log("dispose"),this._participantChangedHandler&&this._participantChangedHandler.dispose(),this._mappedStreams.forEach(e=>e.dispose()),this._eventEmitter.emit("stateChanged",this._state),this._eventEmitter.removeAllListeners(),this._disposeVideo(0),this._disposeVideo(1)}get tsRemoteParticipant(){return this._tsParticipant}get kind(){return"RemoteParticipant"}setCallEndReason(e){this._callEndReason=e}observeParticipant(e){this._tsParticipant||(this._tsParticipant=e,this._displayName=e.displayName,this._isMuted=e.isServerMuted,this._participantChangedHandler=this._tsParticipant.changed(()=>{if(this._tsParticipant&&this._tsParticipant.state!==this._lastTsParticipantState&&(this._lastTsParticipantState=this._tsParticipant.state,this._mapTsParticipantState(this._tsParticipant.state)),this._mapStreams(),this._tsParticipant&&this._tsParticipant.isServerMuted!==this._isMuted&&(this._isMuted=this._tsParticipant.isServerMuted,this._eventEmitter.emit("isMutedChanged")),this._tsParticipant&&this._tsParticipant.displayName&&this._tsParticipant.displayName!==this._displayName&&(this._displayName=e.displayName,this._eventEmitter.emit("displayNameChanged")),this._tsParticipant&&this._tsParticipant.advancedMeetingRole!==this._lastTsParticipantAdvancedRole&&(this._lastTsParticipantAdvancedRole=e.advancedMeetingRole,this._setParticipantRole(this._tsParticipant.advancedMeetingRole)),this._tsParticipant){const i=this._tsParticipant.voiceLevel!==0;i!==this._isSpeaking&&(this._isSpeaking=i,this._eventEmitter.emit("isSpeakingChanged"))}}),this._mapTsParticipantState(this._tsParticipant.state),this._mapStreams(),this._lastTsParticipantAdvancedRole=this._tsParticipant.advancedMeetingRole,this._setParticipantRole(this._tsParticipant.advancedMeetingRole),this._displayName||!xx(this._identifier)&&!HL(this._identifier)||this.getRemoteParticipantProperties().then(i=>{i?.displayName&&(this._displayName=i.displayName,this._eventEmitter.emit("displayNameChanged"))}).catch(i=>{this.logger.error(`Failed to get remote participant properties: ${i}`)}))}setParticipantState(e){e!==this._state&&(this.logger.log(`state changed ${this._state}=>${this.state}`),this._state=e,this._state=="Disconnected"?this._dispose():this._eventEmitter.emit("stateChanged",this._state))}async stopRenderingVideo(){this._disposeVideo(0)}async renderVideo(e,i){return typeof e=="function"?this._updateRenderingState(e,"Video",i):await this._renderStreamForParticipant(e,0,i)}async _updateRenderingState(e,i,r){if(typeof e=="function"){let o;const l=i==="Video"?0:1;this._tsParticipant&&(o=r?.stream?r.stream:new Q3(this._tsParticipant.streams[l][0],this.logger,this._call,this._callAgent,this._tsParticipant,this._telemetryLogManager,this._identifier),o.on("isReceivingChanged",()=>{this._renderers[i].renderingState.isFrozen=!o.isReceiving,e(this._renderers[i].renderingState)}),o.on("isAvailableChanged",async()=>{this._renderers[i].renderingState.isStreaming!==o?.isAvailable&&(this._renderers[i].renderingState.isStreaming=o.isAvailable,this._renderers[i].renderingState.isStreaming&&!this._renderers[i].renderer&&(this._renderers[i].renderer=this._renderers[i]?.renderer?this._renderers[i].renderer:new KB(o),this._renderers[i].view||(this._renderers[i].view=await this._renderers[i].renderer?.createView(r?.viewOptions)),this._renderers[i].renderingState.videoTarget=this._renderers[i].view?.target)),e(this._renderers[i].renderingState)}))}}async renderScreenShare(e,i){return typeof e=="function"?this._updateRenderingState(e,"ScreenSharing",i):this._renderStreamForParticipant(e,1,i)}async _renderStreamForParticipant(e,i,r){if(this._tsParticipant){const o=i===0?"Video":"ScreenSharing",l=r?.stream?r.stream:new Q3(this._tsParticipant.streams[i][0],this.logger,this._call,this._callAgent,this._tsParticipant,this._telemetryLogManager,this._identifier);return l.isAvailable&&(this._renderers[o].view=await this._appendVideo(e,i,l,r?.viewOptions)),l.on("isAvailableChanged",async()=>{l.isAvailable?this._renderers[o].view=await this._appendVideo(e,i,l,r?.viewOptions):this._renderers[o]?.view&&this._renderers[o].view?.target&&this._renderers[o].view?.target.parentNode?.removeChild(this._renderers[o].view?.target)}),Promise.resolve({stream:l,view:this._renderers[o]?.view})}return Promise.reject()}async _appendVideo(e,i,r,o){try{const l=i===0?"Video":"ScreenSharing";if(i===0&&(this._renderers[l]?.renderer||(this._renderers[l].renderer=this._renderers[l]?.renderer?this._renderers[l].renderer:new KB(r),this._renderers[l].view=await this._renderers[l].renderer?.createView(o)),this._renderers[l].view))return e.appendChild(this._renderers[l].view?.target||document.createElement("emptyNode")),Promise.resolve(this._renderers[l].view)}catch(l){return Promise.reject(l)}return Promise.reject()}async _disposeVideo(e){const i=e===0?"Video":"ScreenSharing";this._renderers[i].view?.dispose(),this._renderers[i].renderer?.dispose(),this._renderers[i]={renderingState:{}}}_setParticipantRole(e){let i=pBe(wt(),e);i==="Unknown"?this.logger.log(`tsParticipant advancedMeetingRole=${e} had no mapping`):this.logger.log(`mapped tsParticipant advancedMeetingRole=${e}=>${i}`),this._role!=i&&(this.logger.log(`role changed ${this._role}=>${e}`),this._role=i,this._eventEmitter.emit("roleChanged"))}_mapTsParticipantState(e){let i;const r={0:"Idle",1:"Connecting",2:"Ringing",3:"Connected",4:"Disconnected",5:"Hold",7:"InLobby",6:"EarlyMedia"};r[e]?(i=r[e],this.logger.log(`mapped tsParticipant ${e}=>${this._state}`),this.setParticipantState(i)):this.logger.log(`unable to map tsCall state=${e} to call state`)}_mapStreams(){const e=[],i=[],r=d=>{this._mappedStreams.set(d.id,d)},o=d=>{const h=this._mappedStreams.get(d.id);h&&(this.logger.log(`stream removed, type==${h.mediaStreamType} id=${d.id}`),this._mappedStreams.delete(d.id),h.dispose())},l=d=>{if(this._tsParticipant)if(this._tsParticipant.streams&&eBe(this._tsParticipant.streams[d])){let h=[];this._tsParticipant&&(h=this._tsParticipant.streams[d]),h.forEach(p=>{if(!this._mappedStreams.get(p.id)){const g=new Q3(p,this.logger,this._call,this._callAgent,this._tsParticipant,this._telemetryLogManager,this._identifier);this.logger.log(`stream created, type==${g.mediaStreamType} id=${p.id}`),e.push(g)}}),this._mappedStreams.forEach(p=>{this.acsToTsStreamType(p.mediaStreamType)===d&&(h.some(g=>g.id===p.id)||i.push(p))})}else this._mappedStreams.forEach(h=>{this.acsToTsStreamType(h.mediaStreamType)===d&&i.push(h)})};l(0),l(1),(e.length>0||i.length>0)&&(e.forEach(r),i.forEach(o),this._eventEmitter.emit("videoStreamsUpdated",{added:e,removed:i}))}sendAudioEvent(e,i){try{let r,o;i&&(r=i.message,o=an(i));const l={callId:this._call.id,timestampInfo:e.timestampInfo,correlationId:e.correlationId,step:e.step||"",failureReason:r||"",additionalDetails:{...o}};e.eventType!==void 0&&(l.eventType=e.eventType),this._telemetryLogManager.sendEvent({name:e.eventName,tenant:Wr,properties:l})}catch{this.logger.debug("Unable to send mute others audio telemetry")}}getRemoteParticipantProperties(){return new Promise(e=>{const i={policyUrlSuffix:wt().MiddleTier.policyUrlSuffixV2,userPolicies:["TeamsMeetingPolicy"],userProperties:["displayName"]};this._callAgent.mtPolicyService.requestUserPoliciesFromAcsMiddleTier(this._call.id,zr(this.identifier),i,this._callAgent.getUserMri()).then(r=>{e(r.userAggregatedPolicySettingData?.userProperties)})})}}Z5e([zv,tZ("design:type",Object)],Jpe.prototype,"logger",void 0),Z5e([to(ZY.Mute),tZ("design:type",Function),tZ("design:paramtypes",[]),tZ("design:returntype",Promise)],Jpe.prototype,"mute",null);class jVt{constructor(e){this._deviceManager=e,this._eventEmitter=new $c.EventEmitter,this._selectedDeviceListeners=new Map,this._selectedDevices=new Map,this._deviceInfoMapper=this._deviceManager.deviceInfoMapper;const i=l=>()=>{const d=this._selectedDevices.get(l),h=l==="Speaker"?this._deviceManager.selectedSpeaker:l==="Microphone"?this._deviceManager.selectedMicrophone:void 0,p=h===void 0?void 0:{id:this._deviceInfoMapper.getDeviceId(h.id),name:this._deviceInfoMapper.scrubDeviceLabel(h.name)};this._selectedDevices.set(l,p),this._eventEmitter.emit("selectedDeviceChanged",{selectedDeviceType:l,oldDevice:d,newDevice:p})},r=i("Speaker");this._selectedDeviceListeners.set("Speaker",r),this._deviceManager.on("selectedSpeakerChanged",r),r();const o=i("Microphone");this._selectedDeviceListeners.set("Microphone",o),this._deviceManager.on("selectedMicrophoneChanged",o),o()}on(e,i){this._eventEmitter.on(e,i)}off(e,i){this._eventEmitter.off(e,i)}selectedDevice(e){return this._selectedDevices.get(e)}dispose(){const e=this._selectedDeviceListeners.get("Speaker");e&&this._deviceManager.off("selectedSpeakerChanged",e);const i=this._selectedDeviceListeners.get("Microphone");i&&this._deviceManager.off("selectedMicrophoneChanged",i),this._eventEmitter.removeAllListeners()}}function VE(t,e,i,r){const o=r===zm.RoomCall||t.kind===GL.Call&&t.direction=="Incoming"&&!t.tsCall.groupId&&!!t.tsCall.meetingData?.meetingCode&&!t.tsCall.threadId,l=!o&&r===zm.TeamsMeetingLink||r===zm.TeamsMeetingId||r===zm.TeamsCoordinates||t.direction=="Incoming"&&!t.tsCall.groupId&&!!t.tsCall.meetingData&&!!t.tsCall.threadId,d={audio:"",video:""},h=t.localAudioStreams?.[0];h&&(d.audio=h.getEffectsCurrentStateRecord()??"");const p=t.localVideoStreams?.[0];return p&&(d.video=p.getEffectsCurrentStateRecord()??""),{timestampInfo:{attemptTimestamp:+new Date},correlationId:i,localParticipantId:t.tsCall.participantId||"",isAcsTeamsCall:t.isAcsTeamsCall,callId:t.tsCall.callId||"",callType:t.tsCall.callType||"",callDirection:t.direction,state:t.state==="Ringing"?"Ringing":h2e[t.tsCall.state],groupJoin:!!t.tsCall.groupId,roomJoin:o,meetingJoin:l,callEndDiagnosticsInfo:t.tsCall.callEndDiagnosticsInfo||{},isSupportedEnvironment:e?.runningEnvironmentInfo?.isSupportedEnvironment,effectsStateInfo:d,hostRegion:t.tsCall.region||"",diagnosticInfo:{...t.tsCall.callEndDiagnosticsInfo,telemetryPayloadBytesOriginal:ib.telemetryPayloadBytesOriginal,telemetryPayloadBytesCompressed:ib.telemetryPayloadBytesCompressed}}}function $E(t,e,i){try{i.step==="state-changed"&&i.newState==="Connecting"&&(ib.telemetryPayloadBytesOriginal=0,ib.telemetryPayloadBytesCompressed=0),t.sendEvent({name:vi.acs_calling_call_progress,tenant:Wr,properties:i})}catch{e.error(`Failed to send event: ${vi.acs_calling_call_progress} step: ${i.step}`)}}var GVt=function(t,e,i,r){var o,l=arguments.length,d=l<3?e:r===null?r=Object.getOwnPropertyDescriptor(e,i):r;if(typeof Reflect=="object"&&typeof Reflect.decorate=="function")d=Reflect.decorate(t,e,i,r);else for(var h=t.length-1;h>=0;h--)(o=t[h])&&(d=(l<3?o(d):l>3?o(e,i,d):o(e,i))||d);return l>3&&d&&Object.defineProperty(e,i,d),d},Ype=function(t,e){if(typeof Reflect=="object"&&typeof Reflect.metadata=="function")return Reflect.metadata(t,e)};class iZ{get threadId(){return this._threadId}get roomId(){return this._roomId}get groupId(){return this._groupId}get participantId(){return this._tsCall.participantId}get isPstnInterop(){return this._isPstnInterop}get isTeamsInterop(){return this._isTeamsInterop}get callScenario(){if(this._tsCall.callQueueInfo)return rP.CallQueue;if(this.transferorKind!=="unknown"){if(this._tsCall.incomingCallType==="transfer")return rP.TransferToParticipant;if(this._tsCall.incomingCallType==="replaces")return rP.TransferToCall}return this.direction==="Incoming"?"AcceptCall":this.direction==="Outgoing"&&this.context=="Rooms"?rP.JoinRoom:this.direction==="Outgoing"&&this.context=="TeamsMeeting"?rP.JoinTeamMeeting:this.direction==="Outgoing"&&this.context=="GroupIdCall"?rP.JoinWithGroupId:rP.PlaceCall}get context(){return this._tsCall.callType==1||this._currentCallContext==To.TwoParty?To.TwoParty:this._tsCall.groupId?To.GroupIdCall:this._tsCall.conversationType=="groupCall"||this._currentCallContext==To.MultiParty?To.MultiParty:this._config?.roomId||this._roomId||this._tsCall.meetingData?.meetingCode?.startsWith("994")||this._tsCall.meetingData?.meetingCode?.startsWith("995")||this._tsCall.meetingData?.meetingCode?.startsWith("996")?To.Rooms:this._tsCall.meetingData?.meetingUrl||this._tsCall.meetingData?.passcode||this._tsCall.conversationType=="scheduledMeeting"?To.TeamsMeeting:(this._tsCall.callType,To.MultiParty)}get transferorKind(){return this._tsCall.transferorMri?Sl(this._tsCall.transferorMri||"").kind:""}get direction(){return this._config?.isIncoming?QY.Incoming:QY.Outgoing}get initiatorKind(){return Sl(this._tsCall.callerMri?this._tsCall.callerMri:"").kind}get targetKind(){return this._tsCall.groupId?this._tsCall.groupId:this._config?.roomId?this._config.roomId:this._tsCall.meetingData?.meetingUrl||this._tsCall.meetingData?.meetingCode?"TeamsMeetingJoinLink":this._tsCall.transferorMri?"Transferee":this._tsCall.participants.length===1?Sl(this._tsCall.participants[0].id).kind:this._tsCall.participants.filter(e=>e.id!==this._tsCall.callerMri).map(e=>Sl(e.id).kind).toString()}constructor(e,i={}){this._tsCall=e,this._threadId=this._tsCall.threadId;const r=this._tsCall.groupId;this._groupId=!r||r.startsWith("19:")||r.startsWith("99:")?void 0:r,this._roomId=i?.config?.roomId,this._config=i.config,this._isPstnInterop=!1,this._isTeamsInterop=!1}setThreadId(e){this._threadId=e}initialize(e,i,r){this._logger=i,this._eventEmitter=e,this._threadId=this._tsCall.threadId,this._tsCallChangedListener=this._tsCall.changed(()=>this.threadIdChanged(this._tsCall)),this._p2pCallListener=this._tsCall.changed(()=>this.p2pCallHandler()),this._isPstnInterop=this.isPSTNUserInCall,this._isTeamsInterop=this.isTeamsUserInCall,this._participantUpdatedListener=this._tsCall.on("participantCountsUpdated",()=>{this.interoperabilityChangeHandler(),this.p2pCallEscalationHandler()})}async getServerCallId(){const e=JSON.parse(await this._tsCall.getJoinBlob()),i=e?.conversationUrl;if(!i)throw new Oe({defaultError:we.CALL.GET_SERVER_CALL_ID});return Jzt(i)}p2pCallHandler(){this._currentCallContext==null&&this._tsCall.callType==1&&(this._currentCallContext=To.TwoParty)}p2pCallEscalationHandler(){this._currentCallContext==To.TwoParty&&She(this._tsCall)>2&&(this._currentCallContext=To.MultiParty,this._eventEmitter.emit("callInfoChanged"),this._p2pCallListener?.dispose())}get isTeamsUserInCall(){if(!this._tsCall.participants)return!1;for(const e of this._tsCall.participants)if(Sl(e.id).kind==="microsoftTeamsUser")return!0;return!1}get isPSTNUserInCall(){if(!this._tsCall.participants)return!1;for(const e of this._tsCall.participants)if(Sl(e.id).kind==="phoneNumber")return!0;return!1}interoperabilityChangeHandler(){!this._isPstnInterop&&this.isPSTNUserInCall&&(this._isPstnInterop=!0,this._eventEmitter.emit("callInfoChanged")),!this._isTeamsInterop&&this.isTeamsUserInCall&&(this._isTeamsInterop=!0,this._eventEmitter.emit("callInfoChanged"))}threadIdChanged(e){this._tsCall.threadId!==this._threadId&&(this._logger.log(`threadId changed from ${this._threadId} to ${e?.threadId}`),this._threadId=this._tsCall.threadId,this._eventEmitter.emit("threadIdChanged"))}on(e,i){this._eventEmitter.on(e,i)}off(e,i){this._eventEmitter.off(e,i)}onCallInfoChanged(e,i){this._eventEmitter.on(e,i)}offCallInfoChanged(e,i){this._eventEmitter.off(e,i)}dispose(){this._tsCallChangedListener?.dispose(),this._eventEmitter.removeAllListeners(),this._p2pCallListener?.dispose(),this._participantUpdatedListener?.dispose()}}GVt([to(vhe.GetServerCallId),Ype("design:type",Function),Ype("design:paramtypes",[]),Ype("design:returntype",Promise)],iZ.prototype,"getServerCallId",null);class nZ{constructor(e,i,r,o){this._recordingConsentEnabled=!1,this._consentActivelyRequired=!1,this._localParticipantConsentPublishState=!1,this._isExplicitConsentEnabled=!1,this._isInitialized=!1,this._isExplicitConsentEnabled=wt().calling.explicitConsentFeatureEnabled.enabled,this.initialize(e,i,r,o)}dispose(){this._isInitialized=!1,this._recordingConsentEnabled=!1,this._consentActivelyRequired=!1,this._localParticipantConsentPublishState=!1,nZ.instance=null}isConsentRequiredInCall(){if(!this._isExplicitConsentEnabled)return!1;let e=this._recordingConsentEnabled&&!this._localParticipantConsentPublishState;return this._logger.info("ExplicitConsentCallStateManager: isConsentRequiredInCall: Recording Consent Enabled: "+this._recordingConsentEnabled+" Local Participant Consent Publish State: "+this._localParticipantConsentPublishState),this._logger.log("ExplicitConsentCallStateManager: isConsentRequiredInCall: "+e),e}async consent(e){if(this._isExplicitConsentEnabled){if(e.context===To.TwoParty)throw this._logger.warn("Consent for recording is not supported for 1:1 calls"),new Oe({defaultError:we.CALL.CONSENT_NOT_SUPPORTED_1TO1});if(!this.isConsentRequiredInCall())throw new Oe({defaultError:we.CALL.CONSENT_ALREADY_SET_OR_NOT_REQUIRED});try{const i={level:"user",type:"consentToRecording",content:"{}"};if(!await this._tsCall.publishState(i,fd()))throw this._logger.error("Consent failure to set publish state for user"),new Oe({defaultError:we.CALL.FAILED_TO_SET_CONSENT});this._logger.log("ExplicitConsentCallStateManager: Consent for the call provided successfully")}catch(i){throw this._logger.error("Consent failure to set publish state for user on service side"),i}}}areCoreCapabilitiesConsentRestricted(){if(!this._isExplicitConsentEnabled)return!1;let e=this._consentActivelyRequired&&!this._localParticipantConsentPublishState;return this._logger.info("ExplicitConsentCallStateManager: areCoreCapabilitiesConsentRestricted: Consent Actively Required: "+this._consentActivelyRequired+" Local Participant Consent Publish State: "+this._localParticipantConsentPublishState),this._logger.log("ExplicitConsentCallStateManager: areCoreCapabilitiesConsentRestricted: "+e),e}offConsentRestrictionChanged(e,i){if(e!=="consentRestrictionChanged")throw new Error("ExplicitConsentCallStateManager: OffConsentRestrictionChanged - Invalid event");this._logger.log("ExplicitConsentCallStateManager: Unsubscribing to consentRestrictionChanged event"),this._eventEmitter.off(e,i)}onConsentRestrictionChanged(e,i){if(e!=="consentRestrictionChanged")throw new Error("ExplicitConsentCallStateManager: onConsentRestrictionChanged - Invalid event");this._logger.log("ExplicitConsentCallStateManager: Subscribing to consentRestrictionChanged event"),this._eventEmitter.on(e,i)}initialize(e,i,r,o){this._isExplicitConsentEnabled&&(this._isInitialized||(this._logger=o.createChild(()=>`Explicit Consent::Call(id='${e.callId}', state='${e.state}')`),this._tsCall=e,this._callAgent=i,this._eventEmitter=r,e.changed(()=>{if(e.meetingDetails?.recordingConsentDetails?.explicitRecordingConsentEnabled===!0){this._recordingConsentEnabled=!0;const l=e.meetingDetails?.recordingConsentDetails?.consentActivelyRequired===!0;l!==this._consentActivelyRequired&&(this._consentActivelyRequired=l,this._eventEmitter.emit("consentRestrictionChanged"))}}),e.on("publishedStatesChanged",async l=>{this._localParticipantConsentPublishState=!1,this._handleConsentStateChange(l)}),this._isInitialized=!0))}_handleConsentStateChange(e){if(this._localParticipantConsentPublishState!==!0){const r=this._callAgent.getUserMri();var i=!1;e&&this._getPublishedState(e).forEach(o=>{o.participantStates.forEach(l=>{if(l.id===r)return this._logger.log("ExplicitConsentCallStateManager: Handle Consent State changes: Local participant has provided the consent"),void(i=!0)})}),this._localParticipantConsentPublishState=i,i&&this._eventEmitter.emit("consentRestrictionChanged")}}_getPublishedState(e){return e.typeStates.filter(i=>["consentToRecording"].includes(i.type))}}nZ.instance=null;var X5e,Kf=function(t,e,i,r){var o,l=arguments.length,d=l<3?e:r===null?r=Object.getOwnPropertyDescriptor(e,i):r;if(typeof Reflect=="object"&&typeof Reflect.decorate=="function")d=Reflect.decorate(t,e,i,r);else for(var h=t.length-1;h>=0;h--)(o=t[h])&&(d=(l<3?o(d):l>3?o(e,i,d):o(e,i))||d);return l>3&&d&&Object.defineProperty(e,i,d),d},zo=function(t,e){if(typeof Reflect=="object"&&typeof Reflect.metadata=="function")return Reflect.metadata(t,e)};class qVt{constructor(e){this._lastRecovered=new Date,this._shouldNotifyError=!0,this._shouldNotifyRecovery=!0,this._interval=0,this._interval=e}updateLastRecoveredTime(e){this._lastRecovered=new Date(e.getTime()+this._interval),this._shouldNotifyError=!0,this._shouldNotifyRecovery=!1}shouldNotifyError(e){const i=this._lastRecovered<e&&this._shouldNotifyError;return i&&(this._shouldNotifyError=!1,this._shouldNotifyRecovery=!0),i}shouldNotifyRecovery(e){const i=this._shouldNotifyRecovery;return i&&this.updateLastRecoveredTime(e),i}}class Yg{get id(){return this._id}get callerInfo(){return{identifier:this._callerIdentity,displayName:this._callerDisplayName}}get transferorInfo(){if(this._transferorIdentity)return{identifier:this._transferorIdentity,displayName:this._transferorDisplayName}}get state(){return this._state}get role(){return this._role}get callEndReason(){return this._callEndReason}get kind(){return this._kind}get direction(){return this._direction}get isMuted(){return this._isMuted}get isScreenSharingOn(){return this._isScreenSharingOn}get isLocalVideoStarted(){return this._isLocalVideoStarted}get localVideoStreams(){return this._localVideoStreams}get localAudioStreams(){return this._localAudioStreams}get isIncomingAudioMuted(){return this._isIncomingAudioMuted}get remoteParticipants(){return this._remoteParticipants}get totalParticipantCount(){return this._totalParticipantCount}get lobby(){return this._lobby}get isAcsTeamsCall(){return this._isAcsTeamsCall}get isIPAudioEnabled(){return this.callInfo.context===To.TwoParty||this._allowIPAudio}get isIPVideoEnabled(){return this.callInfo.context===To.TwoParty||this._allowIPVideo}get isCteTeamsCall(){return this._isCteTeamsCall}subscribeToGetRemoteAudioStream(){if(!this._rawAudioStreamChangedSubscription)try{const e=this.tsCall.getIncomingRawAudioStream(),i=async()=>{try{if(this._remoteAudioStreams.length===0){if(!await e.getMediaStream())throw new Oe({defaultError:we.CALL.REMOTE_AUDIO_GET_MEDIA_STREAM_UNDEFINED});this._remoteAudioStreams.push(new N5e(e,this._telemetryLogManager,this.id,this.tsCall.participantId)),this._eventEmitter.emit("remoteAudioStreamsUpdated",{added:this._remoteAudioStreams,removed:[]})}else if(await e.getMediaStream())this._eventEmitter.emit("remoteAudioStreamsUpdated",{added:[],removed:[]});else{const r=this._remoteAudioStreams[0];r.dispose(),this._remoteAudioStreams=[],this._eventEmitter.emit("remoteAudioStreamsUpdated",{added:[],removed:[r]})}}catch(r){throw new Oe({defaultError:we.CALL.REMOTE_AUDIO_GET_MEDIA_STREAM_RETURNED_ERROR,originalError:r})}};this._rawAudioStreamChangedSubscription=e.changed(()=>{this.logger.info(`Changed fired ${this.tsCall.state}, ${this.state}`),i().catch(nh)}),i().catch(()=>{this.logger.info("Failed to update remote audio stream collection, retrying on changed")})}catch{this.logger.info("Failed to get raw audio stream from the stack")}}get remoteAudioStreams(){if(!wt().calling.allowAccessRawMediaStream)throw new Oe({defaultError:we.CALL.REMOTE_AUDIO_GET_MEDIA_STREAM_DISABLED});return this._remoteAudioStreams}get deviceManager(){return this._callAgent.deviceManager}get mediaConstraintsManager(){return this._mediaConstraintsManager}get isHandlingLargeMeetingVideoRendering(){return this._isHandlingLargeMeetingVideoRendering}get callInfo(){return this._callInfo}get networkQualityUfdEventDetails(){return this._networkQualityUfdEventDetails}get acsProxy(){return this._callAgent.acsProxy}get acsCustomRelayManager(){return this._callAgent.acsCustomRelayManager}get audioEffectsProcessorStats(){return this._audioEffectsProcessorStats}get callAgent(){return this._callAgent}get iceServers(){return this._getIceServersCalledOnce||(this._getIceServersCalledOnce=!0,this._iceServers=this.tsCall.getMediaSessionStats()?.extensions?.IceServers),this._iceServers}get watermarkAudioOnlyFallbackTriggered(){return this._watermarkAudioOnlyFallbackTriggered}constructor(e,i,r,o,l,d){this._callAgent=i,this._isMuted=!1,this._isMuted_correlationIdCache=ln(),this._isIncomingAudioMuted=!1,this._isIncomingAudioMuted_correlationIdCache=ln(),this._isScreenSharingOn=!1,this._isLocalVideoStarted=!1,this._localVideoStreams=[],this._localAudioStreams=[],this._remoteAudioStreams=[],this._totalParticipantCount=1,this._isDeviceNotFunctioningMuted=!1,this.__attemptedToRecoverMicNotFunctioningBySDK=!1,this._isMicrophoneMuted=!1,this._disposed=!1,this._lastTsCallState=0,this._isSpeakerMuted=!1,this._callMode=0,this._role=qY,this._lastTsCallMeetingDetails={},this._isHandlingLargeMeetingVideoRendering=!1,this._joinContextDescription=zm.Unknown,this._remoteParticipantsChangedListeners=[],this._localRingingStateSet=!1,this._networkQualityUfdEventDetails=[],this._audioEffectsProcessorStats=null,this._getIceServersCalledOnce=!1,this._watermarkAudioOnlyFallbackTriggered=!1,this._transportStateTimestamp=new Map,this._setOrUpdateDeviceEventsTask=Promise.resolve(),this._isAcsTeamsCall=!1,this._isCteTeamsCall=this._callAgent.isCteUser(),this._mriToRemoteParticipantMap=new Map,this._remoteParticipants=[],this._state="None",this._transportState="None",this._allowIPAudio=!0,this._allowIPVideo=!0,this.localVideoStream=void 0,this.localScreenSharingStream=void 0,this.isRenderingRemoteScreenShare=!1,this._handleMuteChanges=()=>{const p=[To.Rooms,To.GroupIdCall,To.MultiParty,To.TeamsMeeting].some(f=>f===this._callInfo.context),g=this.tsCall.conversationType||p?!!(this.tsCall.isMuted||this.tsCall.state!==10&&this.tsCall.isServerMuted||this._isDeviceNotFunctioningMuted):!(!this.tsCall.isMuted&&!this._isDeviceNotFunctioningMuted);if(this._isMuted!=g){this.logger.info(`isMuted changed from ${this._isMuted} to ${g}`);const f=[];this.tsCall.isMuted&&f.push("isMicrophoneMuted"),this.tsCall.isServerMuted&&(f.push("isServerMuted"),[3,4,5].some(T=>T===this.tsCall.state)&&this._eventEmitter.emit("mutedByOthers"),this.explicitConsentStateImp.areCoreCapabilitiesConsentRestricted()&&this.handleConsentCapabilitiesChanges()),this._isDeviceNotFunctioningMuted&&f.push("isDeviceNotFunctioningMuted");let y="";f.length>=1&&(y=f.join(", ")),g&&(this._isMuted_correlationIdCache=ln()),$E(this._telemetryLogManager,this.logger,{...VE(this,this._callAgent,this._isMuted_correlationIdCache,this._joinContextDescription),step:"isMuted-changed",oldIsMuted:this._isMuted,newIsMuted:g,reason:y}),this._isMuted=g,this._eventEmitter.emit("isMutedChanged")}},this.audioSourceChanged=async p=>{this._telemetryLogManager.sendEvent({name:vi.acs_calling_local_audio_source_changed,tenant:Wr,properties:{callId:this.id,localParticipantId:this.tsCall.participantId,timestampInfo:+new Date,correlationId:ln(),localAudioStream:p.source?.source instanceof MediaStream?"MediaStream":"Device"}}),p.source instanceof pP?(this.localAudioStreams[0]&&this.localAudioStreams[0].mediaStreamType==="RawMedia"&&this.stopAudioInternal(!0),await(await this._callAgent.tsStack?.getDeviceManagerAsync?.())?.selectDevicesAsync?.({microphone:p.source.id})):await this.startAudioInternal(p.source,!0)},this._handleIncomingAudioMuteChanges=()=>{const p=this._isSpeakerMuted;this._isIncomingAudioMuted!=p&&(this.logger.info(`newIncomingAudioMuted changed from ${this._isIncomingAudioMuted} to ${p}`),p&&(this._isIncomingAudioMuted_correlationIdCache=ln()),$E(this._telemetryLogManager,this.logger,{...VE(this,this._callAgent,this._isIncomingAudioMuted_correlationIdCache,this._joinContextDescription),step:"isIncomingAudioMuted-changed",oldIsMuted:this._isIncomingAudioMuted,newIsMuted:p,reason:""}),this._isIncomingAudioMuted=p,this._eventEmitter.emit("isIncomingAudioMutedChanged"))},this._id=e.callId,this.tsCall=r,this._direction=e.isIncoming?"Incoming":"Outgoing",this._config=e,this.logger=this._callAgent.logger.createChild(()=>`Call:${this._id}:${this._state}`),this._telemetryLogManager=o,this.stats=new iVt(this.logger,this._telemetryLogManager),this._eventEmitter=new qf(this.logger),this.activeRemoteVideoStreamViews=new Map,this.isSubscribedCall=!1,this.isBreakoutRoomCall=!1,this._mediaMetricsDeviceEvents={},this._kind=l,this._optimalVideoCount=1,this._ufdsCorrelationIdCache=Hxt(),this._callInfo=new iZ(r,{config:e}),this._callInfo.initialize(this._eventEmitter,this.logger,this._telemetryLogManager),this._speakingWhileMutedManager=new qVt(wt().telemetry.speakingWhileMutedThrottleInterval),wt().calling.mediaMetricsDeviceEventsEnabled&&(async()=>{const p=await this._callAgent.tsStack?.getDeviceManagerAsync?.();p&&(this._dmDevicesChangedSub=p.on("devicesChanged",()=>{this._setOrUpdateDeviceEventsTask=this._setOrUpdateDeviceEventsTask.then(()=>this.setOrUpdateMediaMetricsDeviceEvents().catch(nh))}))})().catch(p=>{this.logger.error(`Failed to register devicesChanged event: ${p}`)}),this._extensibleApi=new M6(this.logger,{call:this,callAgent:this._callAgent,callInfo:this._callInfo},{tsCall:this.tsCall,callAgent:this._callAgent,call:this,telemetryLogManager:this._telemetryLogManager}),this.explicitConsentStateImp=new nZ(this.tsCall,i,this._eventEmitter,this.logger),this._capabilityResolver=new y2e(this._eventEmitter,this.logger,this,this._callInfo,i,r),this._lobby=new t8(this.tsCall,this,this.logger,this._telemetryLogManager);const h=Hpe(IO.CallFeature);for(const p of h)p.activationOptions.activationEvent==="OnExtendedObjectConstructor"&&this.feature(p);this._mmrRdpConnectionManager=new W5e(this.logger),wt().telemetry.sendNetworkChangedTelemetry&&this._sendNetworkChangedTelemetry(),wt().telemetry.deviceChangedEvents.enabled&&(this._selectedDeviceManager=new jVt(this.deviceManager),this._setupSelectedDeviceChangedTelemetry()),this._mediaConstraintsManager=new j5e(this.tsCall,this.logger,this._telemetryLogManager),this._isAcsTeamsCall=d??!1,this.feature(Ma.MediaAccess).on("localParticipantMediaAccessChanged",p=>{this.logger.info(`Call common, time when received localParticipantMediaAccessChanged event: ${new Date().getTime()}, isAudioPermitted=${p.mediaAccess.isAudioPermitted}, isVideoPermitted=${p.mediaAccess.isVideoPermitted}`),p.mediaAccess.isVideoPermitted===!1&&this.localVideoStream&&this.stopVideo(this.localVideoStream)}),this.explicitConsentStateImp.onConsentRestrictionChanged("consentRestrictionChanged",()=>{this.logger.info(`Call common, time when received explicitConsentStateChanged event:=
                ${this.explicitConsentStateImp.areCoreCapabilitiesConsentRestricted()}`),this.handleConsentCapabilitiesChanges()})}async accept(e={}){const i=e.audioOptions?.muted??!1,r=this.getLocalVideoStreamFromCallOptions(e),o=this.getLocalAudioStreamFromCallOptions(e),l=+new Date,d=ln(),h=this._callAgent.getEcsConfigIds(),p=gBe(this.tsCall),g=$v(this.tsCall),f={joinContextDescription:"",additionalProperties:{EmergencyCountryCode:this._callAgent._caConfigBag?.emergencyCountryCode||"",IsUserEmergencyCountryCode:this._callAgent._caConfigBag?.IsUserEmergencyCountryCode||!1,trouterState:this._callAgent.getTrouterState(),muted:i,withVideo:this.isIPVideoEnabled&&!!r,withAudio:this.isIPAudioEnabled&&o?.mediaStreamType?o?.mediaStreamType:"",...q5e(g),AcsCallingSDKWeb_ecsConfigId:h.AcsCallingSDKWeb,SkypeWebMedia_ecsConfigId:h.SkypeWebMedia,customContext:{userToUserPresent:!!p?.userToUser,xHeadersPresent:!!p?.xHeaders&&p.xHeaders.length>0}},additionalDetails:{}},y=(T,C,E)=>{const I=+new Date,w={...f};let D;if(C){const{callEndReason:F,callingCommunicationError:x}=F3(this,T);w.additionalDetails.callEndReason=F,D=x}else D=new Oe({defaultError:we.CALL.ACCEPT_INCOMING_CALL,originalError:T}),w.additionalDetails.communicationServicesError=an(D).communicationServicesError;if(this.sendCallStageEvent({eventName:vi.acs_calling_call_accept_failed,correlationId:d,timestampInfo:{deltaTimeInMs:I-l},additionalPayload:w},D,void 0,E?wo.getRemoveCauseIdToNetworkInfo(E):void 0),r){const F=+new Date;D=new Oe({defaultError:we.LOCAL_VIDEO_STREAM.CALL_NOT_FOUND}),this.logger.error(D.message),this.sendVideoEvent({correlationId:d,eventName:vi.acs_calling_start_video_failure,timestampInfo:{deltaTimeInMs:F-l},localVideoStream:r,step:"accept",isScreenSharingOnFlag:this._isScreenSharingOn},D),this.removeLocalVideoStream(r)}return o&&this.removeLocalAudioStream(o),D};try{if(e?.videoOptions?.constraints){const I=this._mediaConstraintsManager.getTelemetryPayload({video:e?.videoOptions?.constraints});f.additionalProperties.constraints=I}this.sendCallStageEvent({eventName:vi.acs_calling_call_accept_attempt,correlationId:d,timestampInfo:{attemptTimestamp:l},additionalPayload:f});const T={...f};if(r&&this.setLocalVideoStream(r),this.setLocalAudioStream(o),r&&this.sendVideoEvent({eventName:vi.acs_calling_start_video_attempt,timestampInfo:{attemptTimestamp:l},correlationId:d,step:"accept",isScreenSharingOnFlag:this._isScreenSharingOn}),this.tsCall.state!==1)throw new Oe({defaultError:we.CALL.ACCEPT_NOT_RINGING});try{if(e?.videoOptions?.constraints){const I=await this._mediaConstraintsManager.setVideoConstraints(e?.videoOptions?.constraints,"accept",d,l),w=this._mediaConstraintsManager.getTelemetryPayload({video:I});T.additionalProperties.constraints=w}}catch(I){const w=new Oe({defaultError:we.CALL.ACCEPT_VIDEO_CONSTRAINTS,originalError:I});this.logger.error(`${w.message}`)}const C={withVideo:!!r&&this.isIPVideoEnabled,muted:i};if(i&&(C.muteFlags=1),wt()?.calling?.enableCustomTurnUsage&&this.acsCustomRelayManager?.customRelayManagerInUse&&(C.mediaConfiguration={connectionType:"NoDirectConnection"}),o&&await this.startAudioInternal(o,!0).catch(I=>{this.logger.error(`Failed to start localAudioStream, message=${I?.message}`)}),r?.mediaStreamType==="RawMedia")try{await this._setRawStream(r,1)}catch(I){const w=+new Date,D=new Oe({defaultError:we.LOCAL_VIDEO_STREAM.VIDEO_GET_MEDIA_STREAM,originalError:I});this.sendVideoEvent({correlationId:d,eventName:vi.acs_calling_media_stream,timestampInfo:{deltaTimeInMs:w-l},localVideoStream:r,step:"accept",isScreenSharingOnFlag:this._isScreenSharingOn},D),this.removeLocalVideoStream(r)}const E=fd();return wo.setCauseIdToNetworkInfo(E),this.tsCall.accept(C,E).then(async()=>{const I=+new Date;r&&this.shallRemoveLvsAfterConnectedSuccessfully(r,"accept",d,I,l),o&&this.shallRemoveLasAfterConnectedSuccessfully(o,"accept",d,I,l),this.sendCallStageEvent({eventName:vi.acs_calling_call_accept_connected,correlationId:d,timestampInfo:{deltaTimeInMs:I-l},additionalPayload:T},void 0,void 0,wo.getRemoveCauseIdToNetworkInfo(E))}).catch(I=>{y(I,!0,E)}),this}catch(T){throw y(T,!1)}}async reject(){const e=+new Date,i=ln();this.sendCallStageEvent({eventName:vi.acs_calling_call_reject_attempt,correlationId:i,timestampInfo:{attemptTimestamp:e}});const r=this._callAgent.getEcsConfigIds(),o={additionalProperties:{EmergencyCountryCode:this._callAgent._caConfigBag?.emergencyCountryCode||"",IsUserEmergencyCountryCode:this._callAgent._caConfigBag?.IsUserEmergencyCountryCode||!1,trouterState:this._callAgent.getTrouterState(),AcsCallingSDKWeb_ecsConfigId:r.AcsCallingSDKWeb,SkypeWebMedia_ecsConfigId:r.SkypeWebMedia},additionalDetails:{}};if(this.tsCall.state!==1){const d=new Oe({defaultError:we.CALL.REJECT_NOT_RINGING});o.additionalDetails.communicationServicesError=an(d).communicationServicesError;const h=+new Date;throw this.sendCallStageEvent({eventName:vi.acs_calling_call_reject_failed,correlationId:i,timestampInfo:{deltaTimeInMs:h-e},additionalPayload:o},d),d}const l=fd();return wo.setCauseIdToNetworkInfo(l),this.tsCall.reject(l).then(()=>{const d=+new Date;this.sendCallStageEvent({eventName:vi.acs_calling_call_reject_success,correlationId:i,timestampInfo:{deltaTimeInMs:d-e}},void 0,void 0,wo.getRemoveCauseIdToNetworkInfo(l))}).catch(d=>{const h=+new Date,{callEndReason:p,callingCommunicationError:g}=F3(this,d);throw o.additionalDetails.callEndReason=p,this.sendCallStageEvent({eventName:vi.acs_calling_call_reject_failed,correlationId:i,timestampInfo:{deltaTimeInMs:h-e},additionalPayload:o},g,void 0,wo.getRemoveCauseIdToNetworkInfo(l)),g})}dispose(){this._disposed||(this._dmDevicesChangedSub&&this._dmDevicesChangedSub.dispose(),this._dmDevicesChangedSub=void 0,this._extensibleApi.dispose(),this._eventEmitter.removeAllListeners(),this._onlineListener&&window.removeEventListener("online",this._onlineListener),this._offlineListener&&window.removeEventListener("offline",this._offlineListener),this._trouterStateChangedListener&&this._callAgent.offTrouterStateChanged(this._trouterStateChangedListener),this._mmrRdpConnectionManager.dispose(),this._selectedDeviceManager?.dispose(),this.explicitConsentStateImp.dispose(),this._disposed=!0)}async startAudioInternal(e,i=!1){const r=ln(),o=+new Date,l=fd();wo.setCauseIdToNetworkInfo(l);try{if(this.isInternalApiCallWithoutRawMedia(e,i))return;this.sendRawMediaEvent({eventName:vi.acs_calling_start_audio_stream_track,callId:this.id,localParticipantId:this.tsCall.participantId,correlationId:r,kindOfEvent:Je.attempt,isInternal:i,timestampInfo:"",additionalDetails:""}),this.validateRawMedia(e,we.CALL.START_AUDIO_LAS_NOT_RAW_MEDIA),this._userProvidedLocalAudioStreamCache=e;const d=await this.createMediaStream(e),h=await this._callAgent.tsStack?.getDeviceManagerAsync?.();if(!wt()?.calling?.allowAccessRawMediaStream||!h?.setRawMediaStream)throw new Oe({defaultError:we.CALL.LOCAL_AUDIO_SET_MEDIA_STREAM});h?.setRawMediaStream(d,0),this.removeLocalAudioStream(this.localAudioStreams[0]),this.setLocalAudioStream(e);const p=+new Date;this.sendRawMediaEvent({eventName:vi.acs_calling_start_audio_stream_track,callId:this.id,localParticipantId:this.tsCall.participantId,correlationId:r,kindOfEvent:Je.success,isInternal:i,localAudioStream:this.localAudioStreams[0],timestampInfo:{deltaTimeInMs:p-o},additionalDetails:{networkInfo:wo.getRemoveCauseIdToNetworkInfo(l)}})}catch(d){const h=new Oe({defaultError:we.CALL.START_AUDIO_STREAM_FAILED,originalError:d});this.logger.error(`Failed to start raw media audio: ${h.message}`);const p=+new Date;throw this.sendRawMediaEvent({eventName:vi.acs_calling_start_audio_stream_track,callId:this.id,localParticipantId:this.tsCall.participantId,correlationId:r,isInternal:i,kindOfEvent:Je.failure,timestampInfo:{deltaTimeInMs:p-o},additionalDetails:{failureReason:h.message||"",code:h.code,subCode:h.subCode,...an(h),networkInfo:wo.getRemoveCauseIdToNetworkInfo(l)}}),h}}isInternalApiCallWithoutRawMedia(e,i){return!(e?.mediaStreamType==="RawMedia"||!i)&&(this.logger.info("startAudioInternal internal call: LocalAudioStream media type is raw media, skipping raw audio startAudioInternal"),!0)}validateRawMedia(e,i){if(e?.mediaStreamType!=="RawMedia")throw new Oe({defaultError:i})}async createMediaStream(e){let i;try{i=await e.getMediaStream()}catch(r){throw new Oe({defaultError:we.CALL.LOCAL_AUDIO_GET_MEDIA_STREAM,originalError:r})}return new MediaStream(i)}stopAudioInternal(e=!1){const i=ln(),r=+new Date,o=fd();wo.setCauseIdToNetworkInfo(o);try{const l=this._localAudioStreams[0];if(this.isInternalApiCallWithoutRawMedia(l,e))return;this.sendRawMediaEvent({eventName:vi.acs_calling_stop_audio_stream_track,callId:this.id,localParticipantId:this.tsCall.participantId,correlationId:i,kindOfEvent:Je.attempt,isInternal:e,timestampInfo:"",additionalDetails:""}),e||Y3(Ar.StopAudio,this.state),this.validateRawMedia(l,we.CALL.STOP_AUDIO_LAS_NOT_RAW_MEDIA);const d=this._callAgent.tsStack?.getDeviceManager();if(!wt()?.calling?.allowAccessRawMediaStream||!d?.unsetRawMediaStream)throw new Oe({defaultError:we.CALL.LOCAL_AUDIO_UNSET_MEDIA_STREAM});d.unsetRawMediaStream(0),this._userProvidedLocalAudioStreamCache=void 0,this.removeLocalAudioStream(this.localAudioStreams[0]),this.setLocalAudioStream();const h=+new Date;this.sendRawMediaEvent({eventName:vi.acs_calling_stop_audio_stream_track,callId:this.id,localParticipantId:this.tsCall.participantId,correlationId:i,kindOfEvent:Je.success,isInternal:e,localAudioStream:this.localAudioStreams[0],timestampInfo:{deltaTimeInMs:h-r},additionalDetails:{networkInfo:wo.getRemoveCauseIdToNetworkInfo(o)}})}catch(l){const d=new Oe({defaultError:we.CALL.STOP_AUDIO_STREAM_FAILED,originalError:l});this.logger.error(`Failed to stop raw media audio: ${d.message}`);const h=+new Date;throw this.sendRawMediaEvent({eventName:vi.acs_calling_stop_audio_stream_track,callId:this.id,localParticipantId:this.tsCall.participantId,correlationId:i,isInternal:e,kindOfEvent:Je.failure,timestampInfo:{deltaTimeInMs:h-r},additionalDetails:{failureReason:d.message||"",code:d.code,subCode:d.subCode,...an(d),networkInfo:wo.getRemoveCauseIdToNetworkInfo(o)}}),d}}bindTsCall(){const e=[];this.tsCall.callerMri!==void 0&&(this._callerIdentity=Sl(this.tsCall.callerMri),this._callerDisplayName=this.tsCall.participants.find(l=>l.id===this.tsCall.callerMri)?.displayName),this._lastTsCallState=this.tsCall.state,this.mapTsCallState(this.tsCall.state),this._setCallRole(this.tsCall.advancedMeetingRole),this.tsCall.callQueueInfo?(this._callerIdentity=Sl(this.tsCall.callQueueInfo.onBehalfOf.id),this._callerDisplayName=this.tsCall.callQueueInfo.onBehalfOf.displayName?this.tsCall.callQueueInfo.onBehalfOf.displayName:this.tsCall.participants.find(l=>l.id===this.tsCall.callQueueInfo?.details.id)?.displayName,this._transferorIdentity=Sl(this.tsCall.callQueueInfo.details.id),this._transferorDisplayName=this.tsCall.callQueueInfo.details.displayName?this.tsCall.callQueueInfo.details.displayName:this.tsCall.participants.find(l=>l.id===this.tsCall.callQueueInfo?.details.id)?.displayName):this.tsCall.transferorMri&&(this._transferorIdentity=Sl(this.tsCall.transferorMri),this._transferorDisplayName=this.tsCall.transferorDisplayName),this.updateCallMode(),e.push(this.tsCall.changed(()=>{this.tsCall.callId!==this._id&&(this.logger.log(`tsCall callId changed from ${this._id} to ${this.tsCall.callId}`),$E(this._telemetryLogManager,this.logger,{...VE(this,this._callAgent,ln(),this._joinContextDescription),step:"id-changed",isAcsTeamsCall:this.isAcsTeamsCall,oldCallId:this._id,newCallId:this.tsCall.callId}),this._id=this.tsCall.callId,this._eventEmitter.emit("idChanged")),this.tsCall.state!==this._lastTsCallState&&(this.logger.log(`tsCall state changed=${this.tsCall.state}`),this._lastTsCallState=this.tsCall.state,this.mapTsCallState(this.tsCall.state),this._handleMuteChanges()),this._isScreenSharingOn!==this.tsCall.isScreenSharingOn&&(this.logger.log(`tsCall isScreenSharingOn changed=${this.tsCall.isScreenSharingOn}`),this._isScreenSharingOn=this.tsCall.isScreenSharingOn,this._isScreenSharingOn||this.removeScreenSharingStream(),this._eventEmitter.emit("isScreenSharingOnChanged")),this._isMicrophoneMuted!==this.tsCall.isMuted&&(this.logger.log(`tsCall isMuted changed=${this.tsCall.isMuted}`),this._isMicrophoneMuted=this.tsCall.isMuted,this._handleMuteChanges()),this._isSpeakerMuted!==this.tsCall.isSpeakerMuted&&(this.logger.log(`tsCall _isSpeakerMuted changed=${this.tsCall.isSpeakerMuted}`),this._isSpeakerMuted=this.tsCall.isSpeakerMuted,this._handleIncomingAudioMuteChanges()),this.tsCall.advancedMeetingRole!==this._lastTsCallAdvancedMeetingRole&&(this.logger.log(`tsCall advancedMeetingRole changed=${this.tsCall.advancedMeetingRole}`),this._setCallRole(this.tsCall.advancedMeetingRole)),(this.tsCall.meetingData?.meetingUrl||this.tsCall.meetingData?.passcode||this.tsCall.conversationType=="scheduledMeeting")&&this.tsCall.meetingDetails&&Uxt(this.tsCall.meetingDetails,this._lastTsCallMeetingDetails)&&this._setMeetingCapabilities(this.tsCall.meetingDetails),this.updateCallMode(),this.optimalVideoCountChanged()})),e.push(this.tsCall.on("serverMutedChanged",()=>{this.logger.log(`tsCall isServerMuted changed=${this.tsCall.isServerMuted}`),this._handleMuteChanges()})),this._totalParticipantCount=She(this.tsCall),e.push(this.tsCall.on("participantCountsUpdated",()=>{const l=She(this.tsCall);if(this._totalParticipantCount!==l){const d=this._totalParticipantCount;this._totalParticipantCount=l,this.logger.log(`tsCall totalParticipantCount changed from ${d} to ${this._totalParticipantCount}`),wt().rendering.remoteVideo.largeMeeting.handleVideoRendering&&this._enableOrDisable_largeMeeting_videoRendering(),this._eventEmitter.emit("totalParticipantCountChanged");try{this.stats.recordEvent({name:vT.number_of_participants,callId:this.id,localParticipantId:this.tsCall.participantId,data:{totalParticipantCount:this._totalParticipantCount,participantCounts:this.tsCall.participantCounts||{},previousParticipantCount:d}})}catch{this.logger.error("failed to send participant count change telemetry")}}}));const i=(l,d)=>{if(l!==d){this.logger.log(`transportState changed from ${this._transportState} to ${d}`);const h=this._transportStateTimestamp.get("Connected")===void 0?this._connectedTimestamp:void 0;this._transportStateTimestamp.delete(d);const p=dn.omitBy({connectedTimetamp:h,transportConnectedTimestamp:this._transportStateTimestamp.get("Connected"),transportDisconnectedTimestamp:this._transportStateTimestamp.get("Disconnected"),transportFailedTimestamp:this._transportStateTimestamp.get("Failed")},dn.isUndefined),g=dn.merge(VE(this,this._callAgent,ln(),this._joinContextDescription),{timestampInfo:p});$E(this._telemetryLogManager,this.logger,{...g,step:"transportState-changed",oldState:l,newState:d}),this._transportStateTimestamp.set(d,Date.now()),this._transportState=d}};e.push(this.tsCall.on("transportConnected",()=>{i(this._transportState,"Connected")})),e.push(this.tsCall.on("transportDisconnected",()=>{i(this._transportState,"Disconnected")})),e.push(this.tsCall.on("transportFailed",()=>{i(this._transportState,"Failed")})),e.push(this.tsCall.on("callQualityChanged",async l=>{try{let d,h;if(l.type===5||l.type===32||l.type===2||l.type===1||l.type===37?(d=vT.network_quality,this._trackNetworkQualityUfdEventDetails(l.type)):l.type===44||l.type===43||l.type===9||l.type===25||l.type===45||l.type===33||l.type===34||l.type===55||l.type===26||l.type===47?d=vT.video_device_issue:l.type===27?(h=!0,d=vT.video_device_issue):d=vT.other_diagnostic,l.value===3||l.value===2){if(h&&!this._speakingWhileMutedManager.shouldNotifyError(new Date))return;this.logger.warn(`Ufd error raised!, ufd=${l.type}, value=${l.value}, kind=${d}`),d===vT.network_quality&&window.dispatchEvent(new CustomEvent("online",{detail:!1}))}else{if(h&&!this._speakingWhileMutedManager.shouldNotifyRecovery(new Date))return;this.logger.warn(`Ufd error recovered!, ufd=${l.type}, value=${l.value}, kind=${d}`),d===vT.network_quality&&window.dispatchEvent(new CustomEvent("online",{detail:!0}))}let p="";const g=this._ufdsCorrelationIdCache[l.type][l.mediaType];l.value==3||l.value==2?g?p=g:(p=ln(),this._ufdsCorrelationIdCache[l.type][l.mediaType]=p):(g&&(p=g),this._ufdsCorrelationIdCache[l.type][l.mediaType]=void 0);const f={type:l.type.toString(),level:l.value,mediaType:l.mediaType,correlationId:p};if(this.stats.recordEvent({name:d,callId:this.id,localParticipantId:this.tsCall.participantId,data:f}),this.shallStopVideo(l)){const y=+new Date,T=ln();this.logger.warn(`Attempting to stop video gracefully due to video ufd being raised.UFD: ${l.type}, value: ${l.value}, call direction: ${this._direction}`),this.sendAudioEvent({eventName:vi.acs_calling_stop_video_on_ufd_attempt,timestampInfo:{attemptTimestamp:y},correlationId:T,step:"mid-call"});try{this.localVideoStream&&this.stopVideo(this.localVideoStream)}catch{const E=`Failed to stop video on video device start failed or capture mute event ${l.type} with value ${l.value}`;this.logger.error(E)}}if(this.shallRemoveLocalVideoStreamOnBadUfd(l)){const y=new Oe({defaultError:we.CALL.REMOVE_LOCAL_VIDEO_ON_BAD_UFD,defaultErrorMessageArgs:[l.type,l.value,this._direction]});this.localVideoStream&&(this.sendVideoEvent({eventName:vi.acs_calling_start_video_failure,correlationId:ln(),timestampInfo:{attemptTimestamp:+new Date},step:"start",additionalDetails:{...an(y)},localVideoStream:this.localVideoStream,isScreenSharingOnFlag:this.isScreenSharingOn},y),this.removeLocalVideoStream(this.localVideoStream)),this.logger.error(y.message)}if(this.shallStopAudio(l)){const y=+new Date,T=ln();if(wt()?.calling?.allowMuteOnBadUfd&&!this.tsCall.isMuted){this.sendAudioEvent({eventName:vi.acs_calling_mute_on_ufd_attempt,timestampInfo:{attemptTimestamp:y},correlationId:T,step:"mid-call"});try{await this.mute()}catch{const I=`Failed to mute on microphone device not functioning or capture mute event ${l.type} with value ${l.value}`;this.logger.error(I)}}if(wt()?.calling?.preventStopAudio)return this.sendAudioEvent({eventName:vi.acs_calling_prevent_stop_audio,timestampInfo:{attemptTimestamp:y},correlationId:T,step:"mid-call"}),void(!wt()?.calling?.preventFakeMute&&this.markCallMuted());this.sendAudioEvent({eventName:vi.acs_calling_stop_audio_attempt,timestampInfo:{attemptTimestamp:y},correlationId:T,step:"mid-call"});try{await this.tsCall.stopAudio(),this.markCallMuted();const E=+new Date;this.sendAudioEvent({eventName:vi.acs_calling_stop_audio_success,timestampInfo:{deltaTimeInMs:E-y},correlationId:T,step:"mid-call"})}catch(E){const I=new Oe({defaultError:we.CALL.STOP_AUDIO_ON_BAD_UFD,defaultErrorMessageArgs:[l.type,l.value],originalError:E});this.logger.error(I.message);const w=+new Date;this.sendAudioEvent({eventName:vi.acs_calling_stop_audio_failure,timestampInfo:{deltaTimeInMs:w-y},correlationId:T,step:"mid-call"},I)}}this.muteUnmuteOnMicrophoneNotFunctioningUfd(l),this.audioDidAutoRecover(l)&&(this._isDeviceNotFunctioningMuted=!1,this._handleMuteChanges())}catch{this.logger.error("Failed to send ufd telemetry")}})),e.push(this.tsCall.on("participantAdded",async l=>{this.logger.debug("tsCall participant added");const d=[];l.endpoints?.endpointDetails.forEach(p=>d.push(p.participantId)),d.length===0&&d.push("remoteParticipantId unavailable");const h=Sl(l.id);if(this._isCteTeamsCall=this._isCteTeamsCall||h.kind==="microsoftTeamsUser",this.sendParticipantAddedOrRemovedEvent({remoteParticipantIds:d,participantAddedOrRemoved:"added",kindOfEvent:Je.event}),rQ(l))this.logger.info("Add participant: Handle hidden calling application");else{this._handleLocalRingingCallState(l);try{const p=this.getOrCreateRemoteParticipant(h,l);this._eventEmitter.emit("remoteParticipantsUpdated",{added:[p],removed:[]})}catch{this.logger.log("unable to map call participant to ACS user")}}})),this.logger.debug(`tsCall current participant count=${this.tsCall?.participants?.length}`);const r=l=>{const d=Sl(l.id);this._isCteTeamsCall=this._isCteTeamsCall||d.kind==="microsoftTeamsUser";const h=this.getOrCreateRemoteParticipant(d,l);this._handleLocalRingingCallState(l),h.on("displayNameChanged",()=>{this._callerIdentity&&zr(this._callerIdentity)===zr(h.identifier)&&(this._callerDisplayName=h.displayName,this._eventEmitter.emit("callerInfoChanged")),this._transferorIdentity&&zr(this._transferorIdentity)===zr(h.identifier)&&(this._transferorDisplayName=h.displayName,this._eventEmitter.emit("transferorInfoChanged"))})},o=[];this.tsCall.participants.forEach(l=>{wt().calling.checkHiddenBotOnCallStart&&rQ(l)||r(l);try{l.endpoints?.endpointDetails.forEach(d=>o.push(d.participantId))}catch{this.logger.error("Unable to get participantId from from remote participant")}});try{this.sendParticipantAddedOrRemovedEvent({remoteParticipantIds:o,participantAddedOrRemoved:"added",kindOfEvent:Je.initialize})}catch{this.logger.error("Unable to send participant added telemtery")}return e.push(this.tsCall.on("participantRemoved",async l=>{this.logger.debug("tsCall participant removed");const d=[];if(l.endpoints?.endpointDetails.forEach(p=>d.push(p.participantId)),d.length===0&&d.push("remoteParticipantId unavailable"),rQ(l))return this.logger.info("Remove participant: Ignore calling application"),void this.sendParticipantAddedOrRemovedEvent({remoteParticipantIds:d,participantAddedOrRemoved:"removed",kindOfEvent:Je.event});const h=l.id;if(h){const p=this._remoteParticipants.find(g=>zr(g.identifier)===h);if(p){const{callEndReason:g}=U3(this,l);p.setCallEndReason(g),this.deleteRemoteParticipant(p),this._eventEmitter.emit("remoteParticipantsUpdated",{added:[],removed:[p]}),this.sendParticipantAddedOrRemovedEvent({remoteParticipantIds:d,participantAddedOrRemoved:"removed",kindOfEvent:Je.event,additionalDetails:{...dP(g)}})}else this.logger.log("unable to find participant to remove")}})),e}_trackNetworkQualityUfdEventDetails(e){const i=+new Date;let r="";switch(e){case 5:r=Zhe;break;case 32:r=tpe;break;case 2:r=Xhe;break;case 1:r=epe;break;case 37:r=ipe}this._networkQualityUfdEventDetails.push({eventName:r,timestampInfo:i})}async muteUnmuteOnMicrophoneNotFunctioningUfd(e){try{const i=wt().calling;if(!i.muteUnmuteOnMicrophoneNotFunctioning||this._isMuted||e.type!==9||e.value!==3)return;this.__attemptedToRecoverMicNotFunctioningBySDK=!0,await this.mute(),i.unmuteDelayForMicrophoneNotFunctioningInMs>=0&&await k6(i.unmuteDelayForMicrophoneNotFunctioningInMs),await this.unmute()}catch(i){this.logger.info("Unable to perform mute and unmute to recover microphoneNotFunctioning",i)}finally{this.__attemptedToRecoverMicNotFunctioningBySDK=!1}}updateCallMode(){this.tsCall.callMode&&this._callMode!==this.tsCall.callMode&&(this.logger.log(`tsCall callMode changed from ${this._callMode} to ${this.tsCall.callMode}`),$E(this._telemetryLogManager,this.logger,{...VE(this,this._callAgent,ln(),this._joinContextDescription),step:"callMode-changed",oldState:p2e[this._callMode],newState:p2e[this.tsCall.callMode]}),this._callMode=this.tsCall.callMode)}async startCallInternal(e,i,r,o,l,d){const h=!!e?.audioOptions?.muted,p=this.getLocalVideoStreamFromCallOptions(e),g=this.getLocalAudioStreamFromCallOptions(e);let f;const y=l?.attemptTimestamp??+new Date,T=l?.correlationId??ln(),C=ln();this._joinContextDescription=Fxt(r);const E=this._callAgent.getEcsConfigIds(),I=this.tsCall.participants.length===1&&!this.tsCall.threadId&&!i,w=!!I||this._allowIPAudio,D=!!I||this._allowIPVideo,F=$v(this.tsCall),x={joinContextDescription:this._joinContextDescription,additionalProperties:{EmergencyCountryCode:this._callAgent._caConfigBag?.emergencyCountryCode||"",IsUserEmergencyCountryCode:this._callAgent._caConfigBag?.IsUserEmergencyCountryCode||!1,IsEmergencyCall:o?.isEmergency||!1,trouterState:this._callAgent.getTrouterState(),muted:h,withVideo:D&&!!p,withAudio:w&&g?.mediaStreamType?g.mediaStreamType:"",...q5e(F),AcsCallingSDKWeb_ecsConfigId:E.AcsCallingSDKWeb,SkypeWebMedia_ecsConfigId:E.SkypeWebMedia,customContext:{userToUserPresent:!!e?.customContext?.userToUser,xHeadersPresent:!!e?.customContext?.xHeaders&&e.customContext.xHeaders.length>0},firstPartyOptions:{isDeviceTypeEnabled:wt().calling.setDeviceType,deviceType:this._callAgent.getDeviceType(),isImmersiveMode:e?.firstPartyOptions?.isImmersiveMode,accessToImmersiveEvents:e?.firstPartyOptions?.accessToImmersiveEvents}},additionalDetails:{}};e?.videoOptions?.constraints&&(x.additionalProperties.constraints=this._mediaConstraintsManager.getTelemetryPayload({video:e?.videoOptions?.constraints})),o?.meetingInfo?.tenantId&&(this._teamsMeetingTenantId=o.meetingInfo.tenantId,x.additionalProperties.teamsMeetingTenantId=o.meetingInfo.tenantId),o?.threadId&&(this._teamsMeetingThreadId=o.threadId,x.additionalProperties.teamsMeetingThreadId=o.threadId),o?.onBehalfOf&&(x.additionalProperties.onBehalfOfProvided=!0,x.additionalProperties.onBehalfOfIdKind=Sl(o.onBehalfOf).kind);const B={...x},L={...x};this.sendCallStageEvent({eventName:vi.acs_calling_call_attempt,correlationId:T,timestampInfo:{attemptTimestamp:y},additionalPayload:x},void 0,void 0,void 0,"attempt");try{this._isMicrophoneMuted=h,e?.alternateCallerId&&(f=zr(e.alternateCallerId)),p&&this.setLocalVideoStream(p),this.setLocalAudioStream(g)}catch(H){d?.reject(H);const j=+new Date,J=new Oe({defaultError:we.CALL.INSTANTIATE_CALL,originalError:H});throw B.additionalDetails.communicationServicesError=an(J).communicationServicesError,this.sendCallStageEvent({eventName:vi.acs_calling_call_failed,correlationId:T,timestampInfo:{deltaTimeInMs:j-y},additionalPayload:B},J,void 0,void 0,"failure"),this.logger.error(J.message),J}const z=fd();wo.setCauseIdToNetworkInfo(z);try{const H={...o};!wt().calling.setDeviceType||this._callAgent.getDeviceType()!=="mesh"&&this._callAgent.getDeviceType()!=="meshV2"||(H.endpointMetadata=JSON.stringify({meshapp:!0})),F?(await this.tsCall.initAsync?.(H),d?.resolve()):this.tsCall.init(H),p&&this.sendVideoEvent({correlationId:C,eventName:vi.acs_calling_start_video_attempt,timestampInfo:{attemptTimestamp:y},localVideoStream:p,step:"start",isScreenSharingOnFlag:this._isScreenSharingOn});try{if(e?.videoOptions?.constraints){const Z=await this._mediaConstraintsManager.setVideoConstraints(e?.videoOptions?.constraints,"start",C,y),re=this._mediaConstraintsManager.getTelemetryPayload({video:Z});L.additionalProperties.constraints=re}}catch(Z){const re=new Oe({defaultError:we.CALL.CALLSTART_VIDEO_CONSTRAINTS,originalError:Z});this.logger.error(`${re.message}`)}const j=this.setClientEndpointCapabilities(e);if(wt()?.calling?.enableCustomTurnUsage&&this.acsCustomRelayManager?.customRelayManagerInUse&&(j.mediaConfiguration={connectionType:"NoDirectConnection"}),h&&(j.muteFlags=1),e?.firstPartyOptions?.disableAudioMixing&&(j.muteFlags===void 0?j.muteFlags=2:j.muteFlags|=2),e?.firstPartyOptions?.enableSpatialAudio!==void 0&&(j.mediaConfiguration=j.mediaConfiguration||{},j.mediaConfiguration.enableSpatialAudio=e.firstPartyOptions.enableSpatialAudio,this._callAgent.tsStack?await this._callAgent.tsStack.setMediaConfig({enableSpatialAudio:e.firstPartyOptions.enableSpatialAudio}):this.logger.error(`Could not set enableSpatialAudio to ${e.firstPartyOptions.enableSpatialAudio} since this._callAgent.tsStack is null`)),j.customHeaderContext=h6(e),g&&await this.startAudioInternal(g,!0).catch(Z=>{this.logger.error(`Failed to start localAudioStream, message=${Z?.message}`)}),p?.mediaStreamType==="RawMedia")try{await this._setRawStream(p,1)}catch(Z){const re=+new Date,ne=new Oe({defaultError:we.LOCAL_VIDEO_STREAM.VIDEO_GET_MEDIA_STREAM,originalError:Z});this.sendVideoEvent({correlationId:C,eventName:vi.acs_calling_media_stream,timestampInfo:{deltaTimeInMs:re-y},localVideoStream:p,step:"start",isScreenSharingOnFlag:this._isScreenSharingOn},ne),this.removeLocalVideoStream(p)}i?await this.tsCall.startWithMeetingData(z,{withVideo:!!p&&this.isIPVideoEnabled,muted:h,ringOthers:!0,alternateId:f,shouldResurrect:"resurrect",...j}):await this.tsCall.start({withVideo:!!p&&this.isIPVideoEnabled,muted:h,ringOthers:!0,alternateId:f,...j},z);const J=+new Date;this.sendCallStageEvent({eventName:vi.acs_calling_call_connected,correlationId:T,timestampInfo:{deltaTimeInMs:J-y},additionalPayload:L},void 0,void 0,wo.getRemoveCauseIdToNetworkInfo(z),"success"),g&&this.shallRemoveLasAfterConnectedSuccessfully(g,"start",T,J,y),p&&this.shallRemoveLvsAfterConnectedSuccessfully(p,"start",T,J,y),this._handleAudioEffectsOperations()}catch(H){d?.reject(H);const j=+new Date,{callEndReason:J,callingCommunicationError:Z}=F3(this,H);if(p){const re=new Oe({defaultError:we.LOCAL_VIDEO_STREAM.CALL_NOT_FOUND,originalError:H});this.sendVideoEvent({correlationId:C,eventName:vi.acs_calling_start_video_failure,timestampInfo:{deltaTimeInMs:j-y},localVideoStream:p,step:"start",isScreenSharingOnFlag:this._isScreenSharingOn},re),this.removeLocalVideoStream(p)}throw g&&this.removeLocalAudioStream(g),B.additionalDetails.callEndReason=dP(J).callEndReason,this.sendCallStageEvent({eventName:vi.acs_calling_call_failed,correlationId:T,timestampInfo:{deltaTimeInMs:j-y},additionalPayload:B},Z,void 0,wo.getRemoveCauseIdToNetworkInfo(z),"failure"),this.logger.error(`Failed to start the call, message=${J?.message}, code=${J?.code}, subCode=${J?.subCode}, resultCategories=${J?.resultCategories}`),Z}}getTopNDominantSpeakersWithVideoOn(){if(this._internalDominantSpeakersListener){const e=this._internalDominantSpeakersListener.dominantSpeakers.speakersList.map(i=>this._mriToRemoteParticipantMap.get(zr(i))).filter(i=>!!i).filter(i=>!!i.videoStreams.filter(r=>r.mediaStreamType==="Video").find(r=>r.tsStream.isAvailable));if(this.logger.info(`There are currently ${e.length} top-n dominant speakers with video on in the large meeting where topCount is ${wt().rendering.remoteVideo.largeMeeting.dominantSpeakersWithVideoOn_topCount}`),e.length<wt().rendering.remoteVideo.largeMeeting.dominantSpeakersWithVideoOn_topCount){const i=this._remoteParticipants.filter(r=>!!r.videoStreams.filter(o=>o.mediaStreamType==="Video").find(o=>o.tsStream.isAvailable)).filter(r=>!e.includes(r));i.sort((r,o)=>{const l=r.tsRemoteParticipant?.endpoints?.endpointDetails[0]?.mediaStreams?.filter(g=>g.type==="audio").map(g=>g.sourceId)??[],d=l.length>0?Math.min(...l):void 0,h=o.tsRemoteParticipant?.endpoints?.endpointDetails[0]?.mediaStreams?.filter(g=>g.type==="audio").map(g=>g.sourceId)??[],p=h.length>0?Math.min(...h):void 0;return d!==void 0&&p!=null?d-p:0});for(const r of i){if(e.length===wt().rendering.remoteVideo.largeMeeting.dominantSpeakersWithVideoOn_topCount)break;e.push(r)}}else e.splice(wt().rendering.remoteVideo.largeMeeting.dominantSpeakersWithVideoOn_topCount);return e}return[]}getParticipantCapabilities(){const e=this._capabilityResolver.getCapabilities();return this.logger.log(`participant capabilities are ${e}`),e}getMeetingCapabilitiesInternal(){const e=this._capabilityResolver.getMeetingsCapabilitiesInternal();return this.logger.info(`meeting capabilities are ${e}`),e}feature(e){return this._extensibleApi.getApiObjectInstance(e.callApiCtor)}async hangUp(e){const i=+new Date,r=ln(),o=fd();return wo.setCauseIdToNetworkInfo(o),this.sendCallStageEvent({eventName:vi.acs_calling_call_hangup_attempt,correlationId:r,timestampInfo:{attemptTimestamp:i}}),this.tsCall.stop(e?.forEveryone,o).then(()=>{const l=+new Date;this.sendCallStageEvent({eventName:vi.acs_calling_call_hangup_success,correlationId:r,timestampInfo:{deltaTimeInMs:l-i}},void 0,void 0,wo.getRemoveCauseIdToNetworkInfo(o))}).catch(l=>{const d=+new Date,{callEndReason:h,callingCommunicationError:p}=F3(this,l),g=this._callAgent.getEcsConfigIds(),f={additionalProperties:{EmergencyCountryCode:this._callAgent._caConfigBag?.emergencyCountryCode||"",IsUserEmergencyCountryCode:this._callAgent._caConfigBag?.IsUserEmergencyCountryCode||!1,trouterState:this._callAgent.getTrouterState(),AcsCallingSDKWeb_ecsConfigId:g.AcsCallingSDKWeb,SkypeWebMedia_ecsConfigId:g.SkypeWebMedia},additionalDetails:{...dP(h)}};throw this.sendCallStageEvent({eventName:vi.acs_calling_call_hangup_failure,correlationId:r,timestampInfo:{deltaTimeInMs:d-i},additionalPayload:f},p,void 0,wo.getRemoveCauseIdToNetworkInfo(o)),p})}async mute(){const e=this.logger.createFnLogger(Ar.Mute),i=+new Date,r=ln(),o=fd();wo.setCauseIdToNetworkInfo(o),this.sendAudioEvent({eventName:vi.acs_calling_mute_attempt,eventType:hg.MuteMicrophone,timestampInfo:{attemptTimestamp:i},correlationId:r,step:"mid-call",initiatedBySdk:this.__attemptedToRecoverMicNotFunctioningBySDK});try{e.info("mute"),await this.tsCall.mute(o),e.info("mute success");const l=+new Date;this.sendAudioEvent({eventName:vi.acs_calling_mute_success,eventType:hg.MuteMicrophone,timestampInfo:{deltaTimeInMs:l-i},correlationId:r,step:"mid-call",initiatedBySdk:this.__attemptedToRecoverMicNotFunctioningBySDK,networkInfo:wo.getRemoveCauseIdToNetworkInfo(o)})}catch(l){const d=new Oe({defaultError:we.CALL.MIC_MUTE,originalError:l});e.error("Failed to mute microphone");const h=+new Date;throw this.sendAudioEvent({eventName:vi.acs_calling_mute_failure,eventType:hg.MuteMicrophone,timestampInfo:{deltaTimeInMs:h-i},correlationId:r,step:"mid-call",initiatedBySdk:this.__attemptedToRecoverMicNotFunctioningBySDK,networkInfo:wo.getRemoveCauseIdToNetworkInfo(o)},d),d}}async unmute(){const e=this.logger.createFnLogger(Ar.Unmute),i=+new Date,r=ln();let o=!1;const l=fd();if(wo.setCauseIdToNetworkInfo(l),this.sendAudioEvent({eventName:vi.acs_calling_unmute_attempt,eventType:hg.UnmuteMicrophone,timestampInfo:{attemptTimestamp:i},correlationId:r,step:"mid-call",initiatedBySdk:this.__attemptedToRecoverMicNotFunctioningBySDK}),!this.isAudioPermitted()){const d="cannot unmute as microphone is disabled";throw e.error(d),new Oe({defaultError:we.CALL.MIC_DISABLED,originalError:d})}if(!this.isIPAudioEnabled){const d="cannot unmute as IP audio in Teams Meeting Policy is disabled";throw e.error(d),new Oe({defaultError:we.CALL.IP_AUDIO_NOT_ALLOWED,originalError:d})}if(this.explicitConsentStateImp.areCoreCapabilitiesConsentRestricted()){const d="cannot unmute as consent is required to be recorded or transcribed";throw e.error(d),new Oe({defaultError:we.CALL.UNMUTE_CONSENT_RESTRICTED,originalError:d})}try{e.info("unmute"),await this.tsCall.unmute(l),e.info("unmute success");const d=+new Date;this.sendAudioEvent({eventName:vi.acs_calling_unmute_success,eventType:hg.UnmuteMicrophone,timestampInfo:{deltaTimeInMs:d-i},correlationId:r,step:"mid-call",initiatedBySdk:this.__attemptedToRecoverMicNotFunctioningBySDK,networkInfo:wo.getRemoveCauseIdToNetworkInfo(l)});const h=+new Date;if(!wt()?.calling?.preventStopAudio&&this._isDeviceNotFunctioningMuted){this.sendAudioEvent({eventName:vi.acs_calling_start_audio_attempt,timestampInfo:{attemptTimestamp:h},correlationId:r,step:"mid-call",networkInfo:wo.getRemoveCauseIdToNetworkInfo(l)}),o=!0,e.info("start audio"),await this.tsCall.startAudio(),e.info("start audio success");const g=+new Date;this._isDeviceNotFunctioningMuted=!1,this._handleMuteChanges(),this.sendAudioEvent({eventName:vi.acs_calling_start_audio_success,timestampInfo:{deltaTimeInMs:g-h},correlationId:r,step:"mid-call",networkInfo:wo.getRemoveCauseIdToNetworkInfo(l)})}this.setLocalAudioStream()}catch(d){const h=o?we.CALL.MIC_UNMUTE_AND_STARTAUDIO:we.CALL.MIC_UNMUTE,p=new Oe({defaultError:h,originalError:d});e.error(h.message);const g=+new Date;throw this.sendAudioEvent({eventName:o?vi.acs_calling_start_audio_failure:vi.acs_calling_unmute_failure,eventType:o?void 0:hg.UnmuteMicrophone,timestampInfo:{deltaTimeInMs:g-i},correlationId:r,step:"mid-call",initiatedBySdk:this.__attemptedToRecoverMicNotFunctioningBySDK&&!o,networkInfo:wo.getRemoveCauseIdToNetworkInfo(l)},p),p}}async muteAllRemoteParticipants(){const e=wt();if(!e.calling.enableMuteOthers)throw new Oe({defaultError:we.CALL.MUTE_ALL_PARTICIPANTS_DISABLED});if(!this.tsCall.conversationType&&this._callInfo.context===To.TwoParty)throw new Oe({defaultError:we.CALL.MUTE_ALL_PARTICIPANTS_1_TO_1_UNSUPPORTED});const i=this.logger.createFnLogger(Ar.MuteAllRemoteParticipants),r=+new Date,o=ln();this.sendAudioEvent({eventName:vi.acs_calling_mute_attempt,eventType:hg.MuteAllRemoteParticipants,timestampInfo:{attemptTimestamp:r},correlationId:o,step:"mid-call"});try{i.info("mute all others"),Y3(Ar.MuteAllRemoteParticipants,this.state);const l=[];if(this._remoteParticipants.length!==0){let h=!1,p=!1,g="";if(this._remoteParticipants.map(f=>{const y=f.tsRemoteParticipant;e.calling.allowMutePstnRemoteParticipant||f.identifier.kind!=="phoneNumber"?[3,5].some(T=>T===y?.state)?y!==void 0&&(l.push(y),g+=zr(f.identifier)+", "):(i.warn("non-connected participants cannot be muted by others"),p=!0):(i.warn("PSTN participants cannot be muted by others"),h=!0)}),l.length!==0?(await this.tsCall.muteParticipants(1,l),i.info(`called mute function on the following participants: ${g}`)):i.error("all remote participants are not supported to be muted by others"),h)throw new Oe({defaultError:we.CALL.MUTE_ALL_PARTICIPANTS_PSTN_UNSUPPORTED});if(p)throw new Oe({defaultError:we.CALL.MUTE_ALL_PARTICIPANTS_NONCONNECTED_UNSUPPORTED})}else i.info("no participants to mute in attempt to mute all remote participants");i.info("mute all others success");const d=+new Date;this.sendAudioEvent({eventName:vi.acs_calling_mute_success,eventType:hg.MuteAllRemoteParticipants,timestampInfo:{deltaTimeInMs:d-r},correlationId:o,step:"mid-call"})}catch(l){const d=new Oe({defaultError:we.CALL.MUTE_ALL_PARTICIPANTS,originalError:l});i.error(d.message);const h=+new Date;throw this.sendAudioEvent({eventName:vi.acs_calling_mute_failure,eventType:hg.MuteAllRemoteParticipants,timestampInfo:{deltaTimeInMs:h-r},correlationId:o,step:"mid-call"},d),d}}async muteIncomingAudio(){const e=this.logger.createFnLogger(Ar.MuteIncomingAudio),i=+new Date,r=ln();this.sendAudioEvent({eventName:vi.acs_calling_mute_attempt,eventType:hg.MuteIncomingAudio,timestampInfo:{attemptTimestamp:i},correlationId:r,step:"mid-call"});try{await this.tsCall.muteSpeaker();const o=+new Date;this.sendAudioEvent({eventName:vi.acs_calling_mute_success,eventType:hg.MuteIncomingAudio,timestampInfo:{deltaTimeInMs:o-i},correlationId:r,step:"mid-call"})}catch(o){const l=new Oe({defaultError:we.CALL.MUTE_INCOMING_AUDIO,originalError:o});e.error(l.message);const d=+new Date;throw this.sendAudioEvent({eventName:vi.acs_calling_mute_failure,eventType:hg.MuteIncomingAudio,timestampInfo:{deltaTimeInMs:d-i},correlationId:r,step:"mid-call"},l),l}}async unmuteIncomingAudio(){const e=this.logger.createFnLogger(Ar.MuteIncomingAudio),i=+new Date,r=ln();this.sendAudioEvent({eventName:vi.acs_calling_unmute_attempt,eventType:hg.UnmuteIncomingAudio,timestampInfo:{attemptTimestamp:i},correlationId:r,step:"mid-call"});try{await this.tsCall.unmuteSpeaker();const o=+new Date;this.sendAudioEvent({eventName:vi.acs_calling_unmute_success,eventType:hg.UnmuteIncomingAudio,timestampInfo:{deltaTimeInMs:o-i},correlationId:r,step:"mid-call"})}catch(o){const l=new Oe({defaultError:we.CALL.UNMUTE_INCOMING_AUDIO,originalError:o});e.error(l.message);const d=+new Date;throw this.sendAudioEvent({eventName:vi.acs_calling_unmute_failure,eventType:hg.UnmuteIncomingAudio,timestampInfo:{deltaTimeInMs:d-i},correlationId:r,step:"mid-call"},l),l}}async sendDtmf(e){const i=d2t(e);return this.tsCall.sendDtmfTone(i).catch(r=>{throw this.logger.error("Failed to send DTMF tone"),new Oe({defaultError:we.CALL.DTMF_TONE})})}async startVideo(e){const i=this.logger.createFnLogger(Ar.StartVideo),r=+new Date,o=ln(),l=wt()?.calling?.preventStopAudio;if(this.sendVideoEvent({eventName:vi.acs_calling_start_video_attempt,timestampInfo:{attemptTimestamp:r},localVideoStream:e,correlationId:o,step:"mid-call",isScreenSharingOnFlag:this._isScreenSharingOn}),!this.isVideoPermitted()){const h="cannot start video as camera is disabled by the Presenter or Organizer of the meeting";throw i.error(h),new Oe({defaultError:we.CALL.CAMERA_DISABLED,originalError:h})}if(!this.isIPVideoEnabled){const h="cannot start video as IP video is not allowed";throw i.error(h),new Oe({defaultError:we.CALL.IP_VIDEO_NOT_ALLOWED,originalError:h})}if(this.explicitConsentStateImp.areCoreCapabilitiesConsentRestricted()){const h="cannot start video as consent is restricted";throw i.error(h),new Oe({defaultError:we.CALL.VIDEOSTART_CONSENT_RESTRICTED,originalError:h})}if(this._isDeviceNotFunctioningMuted&&!l){this.sendAudioEvent({eventName:vi.acs_calling_start_audio_attempt,timestampInfo:{attemptTimestamp:r},correlationId:o,step:"mid-call"});try{i.info("start audio before starting video"),await this.tsCall.startAudio(),i.info("start audio success before starting video");const h=+new Date;this._isDeviceNotFunctioningMuted=!1,this._handleMuteChanges(),this.sendAudioEvent({eventName:vi.acs_calling_start_audio_success,timestampInfo:{deltaTimeInMs:h-r},correlationId:o,step:"mid-call"})}catch(h){const p="Failed to start audio before starting video",g=new Oe({defaultError:we.CALL.START_AUDIO_BEFORE_VIDEO,originalError:h});i.error(p);const f=+new Date;throw this.sendAudioEvent({eventName:vi.acs_calling_start_audio_failure,timestampInfo:{deltaTimeInMs:f-r},correlationId:o,step:"mid-call"},g),g}}try{if(!e)throw new Oe({defaultError:we.CALL.STREAM_NULL});if(!(e instanceof kp))throw new Oe({defaultError:we.CALL.STREAM_IS_NOT_LVS});if(this.tsCall.isVideoOn)throw new Oe({defaultError:we.CALL.VIDEO_ALREADY_ON});e?.mediaStreamType==="RawMedia"&&await this._setRawStream(e,1),this.setLocalVideoStream(e)}catch(h){const p=new Oe({defaultError:we.CALL.START_VIDEO,originalError:h});throw this.sendVideoEvent({correlationId:o,eventName:vi.acs_calling_start_video_failure,timestampInfo:{attemptTimestamp:r},localVideoStream:e,step:"mid-call",isScreenSharingOnFlag:this._isScreenSharingOn},p),p}const d=fd();wo.setCauseIdToNetworkInfo(d);try{i.info("start video"),await this.tsCall.startVideo(void 0,d);const h=+new Date;this.sendVideoEvent({correlationId:o,eventName:vi.acs_calling_start_video_success,timestampInfo:{deltaTimeInMs:h-r},localVideoStream:e,step:"mid-call",isScreenSharingOnFlag:this._isScreenSharingOn,networkInfo:wo.getRemoveCauseIdToNetworkInfo(d)}),i.info("video started")}catch(h){const p=+new Date,g=z3(i,h);throw this.sendVideoEvent({correlationId:o,eventName:vi.acs_calling_start_video_failure,timestampInfo:{deltaTimeInMs:p-r},localVideoStream:e,step:"mid-call",isScreenSharingOnFlag:this._isScreenSharingOn,networkInfo:wo.getRemoveCauseIdToNetworkInfo(d)},g),this.removeLocalVideoStream(e),g}}async stopVideo(e){const i=this.logger.createFnLogger(Ar.StopVideo),r=+new Date,o=ln();this.sendVideoEvent({correlationId:o,eventName:vi.acs_calling_stop_video_attempt,timestampInfo:{attemptTimestamp:r},localVideoStream:e,step:"mid-call",isScreenSharingOnFlag:this._isScreenSharingOn});const l=this.tsCall.state===4||this.tsCall.state===5;if(!l&&!this.tsCall.isVideoOn||l&&!this.localVideoStream){const p=new Oe({defaultError:we.CALL.VIDEO_ALREADY_OFF});throw this.sendVideoEvent({correlationId:o,eventName:vi.acs_calling_stop_video_failure,timestampInfo:{attemptTimestamp:r},localVideoStream:e,step:"mid-call",isScreenSharingOnFlag:this._isScreenSharingOn},p),p}if(this.localVideoStream!==void 0&&this.localVideoStream!==e){const p=new Oe({defaultError:we.CALL.STOP_WRONG_STREAM});throw this.sendVideoEvent({correlationId:o,eventName:vi.acs_calling_stop_video_failure,timestampInfo:{attemptTimestamp:r},localVideoStream:e,step:"mid-call",isScreenSharingOnFlag:this._isScreenSharingOn},p),p}const d=()=>{try{if(wt().calling.allowAccessRawMediaStream&&e.mediaStreamType==="RawMedia"){const p=this._callAgent.tsStack?.getDeviceManager();p&&p.unsetRawMediaStream&&p.unsetRawMediaStream(1)}}catch(p){this.logger.info(`Unset raw video stream: ${p?.message??"Unkown error"}`)}},h=fd();wo.setCauseIdToNetworkInfo(h);try{i.info("stop video"),await this.tsCall.stopVideo(void 0,h),d();const p=+new Date;this.sendVideoEvent({correlationId:o,eventName:vi.acs_calling_stop_video_success,timestampInfo:{deltaTimeInMs:p-r},localVideoStream:e,step:"mid-call",isScreenSharingOnFlag:this._isScreenSharingOn,networkInfo:wo.getRemoveCauseIdToNetworkInfo(h)}),i.info("video stopped"),this.removeLocalVideoStream(e)}catch(p){d();const g=+new Date,f=z3(i,p,!0);throw this.sendVideoEvent({correlationId:o,eventName:vi.acs_calling_stop_video_failure,timestampInfo:{deltaTimeInMs:g-r},localVideoStream:e,step:"mid-call",isScreenSharingOnFlag:this._isScreenSharingOn,networkInfo:wo.getRemoveCauseIdToNetworkInfo(h)},f),f}}startAudio(e){return this.startAudioInternal(e)}stopAudio(){return this.stopAudioInternal()}async hold(){const e=+new Date,i=ln(),r=fd();wo.setCauseIdToNetworkInfo(r);try{this.sendCallOnHoldAndResumedEvent({eventName:vi.acs_calling_call_hold_and_resume,callId:this.id,localParticipantId:this.tsCall.participantId,correlationId:i,operation:Ar.Hold,kindOfEvent:Je.attempt,timestampInfo:{deltaTimeInMs:e},additionalDetails:{holdType:mT.Standard,isScreenSharingOnFlag:this.tsCall.isScreenSharingOn}}),wt().calling.turnOffScreenShareBeforeHold&&this.tsCall.isScreenSharingOn&&await this.tsCall.stopScreenSharing().then(()=>{this.logger.log("Successfully turned off screen sharing before hold")}).catch(()=>{this.logger.error("Failed to turn off screensharing before hold")}),await this.tsCall.hold(void 0,r),this.removeLocalAudioStream(this._localAudioStreams[0]);const o=+new Date;this.sendCallOnHoldAndResumedEvent({eventName:vi.acs_calling_call_hold_and_resume,callId:this.id,localParticipantId:this.tsCall.participantId,correlationId:i,operation:Ar.Hold,kindOfEvent:Je.success,timestampInfo:{deltaTimeInMs:o-e},additionalDetails:{holdType:mT.Standard,isScreenSharingOnFlag:this.tsCall.isScreenSharingOn},networkInfo:wo.getRemoveCauseIdToNetworkInfo(r)})}catch{const l=+new Date,d=new Oe({defaultError:we.CALL.HOLD_CALL});throw this.sendCallOnHoldAndResumedEvent({eventName:vi.acs_calling_call_hold_and_resume,callId:this.id,localParticipantId:this.tsCall.participantId,correlationId:i,operation:Ar.Hold,kindOfEvent:Je.failure,timestampInfo:{deltaTimeInMs:l-e},additionalDetails:{failureReason:d.message,code:d.code,subCode:d.subCode,holdType:mT.Standard,isScreenSharingOnFlag:this.tsCall.isScreenSharingOn,...an(d)},networkInfo:wo.getRemoveCauseIdToNetworkInfo(r)}),d}}async resume(){const e=+new Date,i=ln(),r=fd();wo.setCauseIdToNetworkInfo(r);try{this.sendCallOnHoldAndResumedEvent({eventName:vi.acs_calling_call_hold_and_resume,callId:this.id,localParticipantId:this.tsCall.participantId,correlationId:i,operation:Ar.Resume,kindOfEvent:Je.attempt,timestampInfo:{deltaTimeInMs:e},additionalDetails:{holdType:mT.Standard,isScreenSharingOnFlag:this.tsCall.isScreenSharingOn}}),await this.tsCall.unhold(void 0,r),this.setLocalAudioStream();const o=+new Date;this.sendCallOnHoldAndResumedEvent({eventName:vi.acs_calling_call_hold_and_resume,callId:this.id,localParticipantId:this.tsCall.participantId,correlationId:i,operation:Ar.Resume,kindOfEvent:Je.success,timestampInfo:{deltaTimeInMs:o-e},additionalDetails:{isScreenSharingOnFlag:this.tsCall.isScreenSharingOn,holdType:mT.Standard},networkInfo:wo.getRemoveCauseIdToNetworkInfo(r)})}catch{const l=+new Date,d=new Oe({defaultError:we.CALL.RESUME_CALL});throw this.sendCallOnHoldAndResumedEvent({eventName:vi.acs_calling_call_hold_and_resume,callId:this.id,localParticipantId:this.tsCall.participantId,correlationId:i,operation:Ar.Resume,kindOfEvent:Je.failure,timestampInfo:{deltaTimeInMs:l-e},additionalDetails:{failureReason:d.message,code:d.code,subCode:d.subCode,holdType:mT.Standard,isScreenSharingOnFlag:this.tsCall.isScreenSharingOn,...an(d)},networkInfo:wo.getRemoveCauseIdToNetworkInfo(r)}),d}}async startScreenSharing(e){const i=this.logger.createFnLogger(Ar.StartScreenShare),r=+new Date,o=ln();try{if(this.sendScreenShareEvent({eventName:vi.acs_calling_start_screen_share,callId:this.id,localParticipantId:this.tsCall.participantId,correlationId:o,kindOfEvent:Je.attempt,timestampInfo:"",additionalDetails:"",isVideoOn:this._isLocalVideoStarted,localVideoStream:e}),this.tsCall.state!==3)throw new Oe({defaultError:we.CALL.START_SS_CALL_NOT_CONNECTED});if(this.tsCall.isScreenSharingOn)throw new Oe({defaultError:we.CALL.SS_ALREADY_ON});if(this.explicitConsentStateImp.areCoreCapabilitiesConsentRestricted()){const l="screen sharing cannot be started as consent is required to be recorded or transcribed";throw i.error(l),new Oe({defaultError:we.CALL.SCREENSHARE_CONSENT_RESTRICTED,originalError:l})}if(e){if(!(e instanceof kp))throw new Oe({defaultError:we.CALL.SS_RAW_STREAM_IS_NOT_LVS});if(e.mediaStreamType!=="RawMedia")throw new Oe({defaultError:we.CALL.SS_RAW_STREAM_LVS_IS_NOT_RAW_MEDIA});await this._setRawStream(e,2),this.localScreenSharingStream=e}else this.localScreenSharingStream=new kp(new hP(Qxe.ScreenSharing,ln(),Qxe.ScreenSharing,this._callAgent.deviceManager))}catch(l){const d=+new Date;this.removeScreenSharingStream();const h=new Oe({defaultError:we.CALL.START_SS,originalError:l});throw this.sendScreenShareEvent({eventName:vi.acs_calling_start_screen_share,callId:this.id,localParticipantId:this.tsCall.participantId,correlationId:o,kindOfEvent:Je.failure,timestampInfo:{deltaTimeInMs:d-r},additionalDetails:{failureReason:h.message,code:h.code,subCode:h.subCode,...an(h)},isVideoOn:this._isLocalVideoStarted,localVideoStream:this.localScreenSharingStream}),h}return this.tsCall.startScreenSharing().then(()=>{const l=+new Date;this.localScreenSharingStream&&this._localVideoStreams.indexOf(this.localScreenSharingStream)===-1&&(this.localScreenSharingStream.addCall(this),this._localVideoStreams.push(this.localScreenSharingStream),this._eventEmitter.emit("localVideoStreamsUpdated",{added:[this.localScreenSharingStream],removed:[]})),this.sendScreenShareEvent({eventName:vi.acs_calling_start_screen_share,callId:this.id,localParticipantId:this.tsCall.participantId,correlationId:o,kindOfEvent:Je.success,timestampInfo:{deltaTimeInMs:l-r},additionalDetails:"",isVideoOn:this._isLocalVideoStarted,localVideoStream:this.localScreenSharingStream})}).catch(l=>{const d=+new Date;this.removeScreenSharingStream();const h=z3(i,l);throw this.sendScreenShareEvent({eventName:vi.acs_calling_start_screen_share,callId:this.id,localParticipantId:this.tsCall.participantId,correlationId:o,kindOfEvent:Je.failure,timestampInfo:{deltaTimeInMs:d-r},additionalDetails:{failureReason:h.message,code:h.code,subCode:h.subCode,...an(h)},isVideoOn:this._isLocalVideoStarted,localVideoStream:this.localScreenSharingStream}),h})}async stopScreenSharing(){const e=this.logger.createFnLogger(Ar.StopScreenShare),i=+new Date,r=ln();if(this.sendScreenShareEvent({eventName:vi.acs_calling_stop_screen_share,callId:this.id,localParticipantId:this.tsCall.participantId,correlationId:r,kindOfEvent:Je.attempt,timestampInfo:"",additionalDetails:"",isVideoOn:this._isLocalVideoStarted,localVideoStream:this.localScreenSharingStream}),this.tsCall.state!==3)throw new Oe({defaultError:we.CALL.STOP_SS_CALL_NOT_CONNECTED});if(!this.tsCall.isScreenSharingOn){const o=+new Date,l=new Oe({defaultError:we.CALL.SS_ALREADY_OFF});throw this.sendScreenShareEvent({eventName:vi.acs_calling_stop_screen_share,callId:this.id,localParticipantId:this.tsCall.participantId,correlationId:r,kindOfEvent:Je.failure,timestampInfo:{deltaTimeInMs:o-i},additionalDetails:{failureReason:l.message,code:l.code,subCode:l.subCode,...an(l)},isVideoOn:this._isLocalVideoStarted,localVideoStream:this.localScreenSharingStream}),l}return this.tsCall.stopScreenSharing().then(()=>{const o=+new Date,l=dn.cloneDeep(this.localScreenSharingStream);this.removeScreenSharingStream(),this.sendScreenShareEvent({eventName:vi.acs_calling_stop_screen_share,callId:this.id,localParticipantId:this.tsCall.participantId,correlationId:r,kindOfEvent:Je.success,timestampInfo:{deltaTimeInMs:o-i},additionalDetails:"",isVideoOn:this._isLocalVideoStarted,localVideoStream:l})}).catch(o=>{const l=+new Date,d=z3(e,o,!0),h=typeof d?.message=="string"?d?.message:void 0;throw this.sendScreenShareEvent({eventName:vi.acs_calling_stop_screen_share,callId:this.id,localParticipantId:this.tsCall.participantId,correlationId:r,kindOfEvent:Je.failure,timestampInfo:{deltaTimeInMs:l-i},additionalDetails:{failureReason:h||"",code:d.code,subCode:d.subCode,...an(d)},isVideoOn:this._isLocalVideoStarted,localVideoStream:this.localScreenSharingStream}),d})}async setConstraints(e){const i=+new Date,r=ln();try{const o=await this._mediaConstraintsManager.setVideoConstraints(e?.video,"mid-call",r,i);this.logger.info(`Video constraints set - ${JSON.stringify(o)}`)}catch(o){throw new Oe({defaultError:we.CALL.SET_VIDEO_CONSTRAINTS,originalError:o})}}on(e,i){if(e!=="stateChanged"&&e!=="idChanged"&&e!=="isMutedChanged"&&e!=="isIncomingAudioMutedChanged"&&e!=="isScreenSharingOnChanged"&&e!=="isLocalVideoStartedChanged"&&e!=="remoteParticipantsUpdated"&&e!=="localVideoStreamsUpdated"&&e!=="localAudioStreamsUpdated"&&e!=="remoteAudioStreamsUpdated"&&e!=="totalParticipantCountChanged"&&e!=="roleChanged"&&e!=="mutedByOthers"&&e!=="callerInfoChanged"&&e!=="transferorInfoChanged")throw new Oe({defaultError:we.CALL.EVENT_SUBSCRIBE,defaultErrorMessageArgs:[e]});this._eventEmitter.on(e,i)}off(e,i){if(e!=="stateChanged"&&e!=="idChanged"&&e!=="isMutedChanged"&&e!="isIncomingAudioMutedChanged"&&e!=="isScreenSharingOnChanged"&&e!=="isLocalVideoStartedChanged"&&e!=="remoteParticipantsUpdated"&&e!=="localVideoStreamsUpdated"&&e!=="localAudioStreamsUpdated"&&e!=="remoteAudioStreamsUpdated"&&e!=="totalParticipantCountChanged"&&e!=="roleChanged"&&e!=="mutedByOthers"&&e!=="callerInfoChanged"&&e!=="transferorInfoChanged")throw new Oe({defaultError:we.CALL.EVENT_UNSUBSCRIBE,defaultErrorMessageArgs:[e]});this._eventEmitter.off(e,i)}onMeetingCapabilitiesChanged(e,i){if(e!=="meetingCapabilitiesChanged")throw new Oe({defaultError:we.CALL.EVENT_SUBSCRIBE,defaultErrorMessageArgs:[e]});this._eventEmitter.on(e,i)}offMeetingCapabilitiesChanged(e,i){if(e!="meetingCapabilitiesChanged")throw new Oe({defaultError:we.CALL.EVENT_UNSUBSCRIBE,defaultErrorMessageArgs:[e]});this._eventEmitter.off(e,i)}onParticipantCapabilitiesChanged(e,i){this.logger.log("participant capabilities change event listener registered"),this._eventEmitter.on(e,i)}offParticipantCapabilitiesChanged(e,i){this.logger.log("participant capabilities change event listener unregistered"),this._eventEmitter.off(e,i)}setWatermarkAudioOnlyFallbackTriggered(e){this._watermarkAudioOnlyFallbackTriggered=e,this._eventEmitter.emit("watermarkAudioOnlyFallbackTriggeredChanged")}onWatermarkAudioOnlyFallbackTriggeredChanged(e,i){this.logger.log("watermark audio only fallback triggered listener registered"),this._eventEmitter.on(e,i)}offWatermarkAudioOnlyFallbackTriggeredChanged(e,i){this.logger.log("watermark audio only fallback triggered listener unregistered"),this._eventEmitter.off(e,i)}setIsRenderingRemoteScreenShare(e){this.isRenderingRemoteScreenShare!==e&&(this.isRenderingRemoteScreenShare=e,this._eventEmitter.emit("isRenderingRemoteScreenShareChanged"))}onIsRenderingRemoteScreenShareChanged(e,i){this._eventEmitter.on(e,i)}offIsRenderingRemoteScreenShareChanged(e,i){this._eventEmitter.off(e,i)}getOrCreateRemoteParticipant(e,i){let r=this._remoteParticipants.find(o=>zr(o.identifier)===zr(e));return r||(r=new Jpe(e,this.logger,this,this._callAgent,this._telemetryLogManager),this._remoteParticipants.push(r),this._mriToRemoteParticipantMap.set(zr(r.identifier),r)),i&&r.observeParticipant(i),r}deleteRemoteParticipant(e){let i=!0;return this._remoteParticipants.splice(this._remoteParticipants.indexOf(e),1).length!==1&&(this.logger.warn("Deleted remote participant array is not 1"),i=!1),this._mriToRemoteParticipantMap.delete(zr(e.identifier))||(this.logger.warn("Deleted remote participant was not found in mri-to-remoteparticipant map"),i=!1),i}sendCallOnHoldAndResumedEvent(e){try{this._telemetryLogManager.sendEvent({name:e.eventName,tenant:Wr,properties:e})}catch{this.logger.debug("Unable to send call hold or resume telemetry")}}sendVideoEvent(e,i){try{let r,o;try{r=e.localVideoStream?.getStreamMetadata()}catch{this.logger.error("Unable to get stream meta data on send video event")}i&&(o=typeof i?.message=="string"?i?.message:void 0,e.additionalDetails={...an(i)}),this._telemetryLogManager.sendEvent({name:e.eventName,tenant:Wr,properties:{...r,callId:this.id,localParticipantId:this.tsCall.participantId,timestampInfo:e.timestampInfo,correlationId:e.correlationId,step:e.step||"",failureReason:o||"",isScreenSharingOnFlag:e.isScreenSharingOnFlag,additionalDetails:e.additionalDetails||{},networkInfo:e.networkInfo||[]}})}catch{this.logger.debug("Unable to send video telemetry")}}sendScreenShareEvent(e){let i;try{i=e.localVideoStream?.getStreamMetadata()}catch{this.logger.error("Unable to get stream meta data on send video event")}try{this._telemetryLogManager.sendEvent({name:e.eventName,tenant:Wr,properties:{...i,callId:this.id,localParticipantId:this.tsCall.participantId,correlationId:e.correlationId,kindOfEvent:e.kindOfEvent,timestampInfo:e.timestampInfo,additionalDetails:e.additionalDetails,isVideoOn:e.isVideoOn}})}catch{this.logger.debug("Unable to send screen share telemetry")}}sendRawMediaEvent(e){const i={...e};i.localAudioStream=e.localAudioStream?.source instanceof MediaStream?"MediaStream":"Device";try{this._telemetryLogManager.sendEvent({name:e.eventName,tenant:Wr,properties:i})}catch{this.logger.debug("Unable to send raw media telemetry")}}sendAudioEvent(e,i){try{let r;i&&(r=typeof i?.message=="string"?i?.message:void 0,e.additionalDetails={...an(i)});const o={callId:this.id,localParticipantId:this.tsCall.participantId,timestampInfo:e.timestampInfo,correlationId:e.correlationId,step:e.step||"",failureReason:r||"",additionalDetails:e.additionalDetails||{},networkInfo:e.networkInfo||[]};e.eventType!==void 0&&(o.eventType=e.eventType),e.initiatedBySdk&&(o.initiatedBySdk=!0),this._telemetryLogManager.sendEvent({name:e.eventName,tenant:Wr,properties:o})}catch{this.logger.debug("Unable to send audio telemetry")}}sendCallStageEvent(e,i,r,o,l){try{let d,h="";i&&(d=this?.tsCall?.callEndDiagnosticsInfo||r||{},h=i.message);const p=this._joinContextDescription===zm.RoomCall||this.kind===GL.Call&&this._direction==="Incoming"&&!this.tsCall.groupId&&!!this.tsCall.meetingData?.meetingCode&&!this.tsCall.threadId,g=!p&&this._joinContextDescription===zm.TeamsMeetingLink||this._joinContextDescription===zm.TeamsMeetingId||this._joinContextDescription===zm.TeamsCoordinates||this._direction=="Incoming"&&!this.tsCall.groupId&&!!this.tsCall.meetingData&&!!this.tsCall.threadId,f={localParticipantId:this?.tsCall?.participantId||"",callId:this?.tsCall?.callId||"",callType:this?.tsCall?.callType||"",callDirection:this._direction,failureReason:h,callEndDiagnosticsInfo:d,calleeIdentityType:this.getParticipantIdentityType(),groupJoin:!!this?.tsCall?.groupId,roomJoin:p,meetingJoin:g,hostRegion:this?.tsCall?.region||"",correlationId:e.correlationId,timestampInfo:e.timestampInfo,...e.additionalPayload,networkInfo:o||[]};this._telemetryLogManager.sendEvent({name:e.eventName,tenant:Wr,properties:f},void 0,l)}catch{}}getParticipantIdentityType(){if(this.tsCall?.participants.length>1)return wp.group;if(this.tsCall?.participants.length===0)return wp.unknown;const e=this.tsCall?.participants[0];return Sl(e.id).kind}optimalVideoCountChanged(){const e=this._optimalVideoCount,i=this.tsCall.optimalVideoCount,r=wt().telemetry.progressEvents.enableOvcChangedEvent;if(i&&e!==i&&r)try{$E(this._telemetryLogManager,this.logger,{...VE(this,this._callAgent,ln(),this._joinContextDescription),step:"optimalVideoCount-changed",previousOptimalVideoCount:e,newOptimalVideoCount:i,currentNumberOfVideosRendered:this.activeRemoteVideoStreamViews?.size||0})}catch{this.logger.error("Failed to send optimal video count change telemetry")}finally{this._optimalVideoCount=this.tsCall.optimalVideoCount||1}}_sendNetworkChangedTelemetry(){try{const e=(i,r,o)=>{$E(this._telemetryLogManager,this.logger,{...VE(this,this._callAgent,ln(),this._joinContextDescription),step:"network-changed",trouterState:i,onLine:r,rdpState:o})};this._trouterStateChangedListener=i=>{e(i,navigator.onLine,this._mmrRdpConnectionManager.state)},this._callAgent.onTrouterStateChanged(this._trouterStateChangedListener),this._onlineListener=i=>{e(this._callAgent.getTrouterState(),!0,this._mmrRdpConnectionManager.state)},window.addEventListener("online",this._onlineListener),this._offlineListener=i=>{e(this._callAgent.getTrouterState(),!1,this._mmrRdpConnectionManager.state)},window.addEventListener("offline",this._offlineListener),this._mmrRdpConnectionManager.on("stateChange",i=>{e(this._callAgent.getTrouterState(),!1,i)}),e(this._callAgent.getTrouterState(),navigator.onLine,this._mmrRdpConnectionManager.state)}catch{this.logger.warn("Failed to subscribe to network changed")}}_setupSelectedDeviceChangedTelemetry(){try{const e=i=>{$E(this._telemetryLogManager,this.logger,{...VE(this,this._callAgent,ln(),this._joinContextDescription),step:"selectedDevice-changed",selectedDeviceType:i.selectedDeviceType,oldDevice:i.oldDevice,newDevice:i.newDevice})};if(this._selectedDeviceManager){this._selectedDeviceManager.on("selectedDeviceChanged",e);const i=this._selectedDeviceManager.selectedDevice("Speaker"),r=this._selectedDeviceManager.selectedDevice("Microphone");e({selectedDeviceType:"Speaker",oldDevice:void 0,newDevice:i}),e({selectedDeviceType:"Microphone",oldDevice:void 0,newDevice:r})}}catch{this.logger.warn("Failed to subscribe to selectedDevice changed")}}setLocalVideoStream(e){if(!this._callAgent.tsStack)throw new Oe({defaultError:we.CALL.VIDEO_UNDEFINED_STACK});if(!this.localVideoStream&&e&&!this._localVideoStreams.find(i=>i===e)){this.localVideoStream=e,this._localVideoStreams.push(this.localVideoStream),this.localVideoStream.mediaStreamType!=="RawMedia"&&this._callAgent.tsStack.getDeviceManager()?.selectDevices({camera:e.source.id}),this.localVideoStream.addCall(this);try{this._eventEmitter.emit("localVideoStreamsUpdated",{added:[this.localVideoStream],removed:[]})}catch{this.logger.warn("Application threw on emit localVideoStreamsUpdated added")}this.logger.log("isLocalVideoStarted changed=true"),this._isLocalVideoStarted=!0,this._eventEmitter.emit("isLocalVideoStartedChanged")}}removeLocalVideoStream(e){if(this.localVideoStream&&e===this.localVideoStream&&this.localVideoStreams.find(i=>i===this.localVideoStream)){if(this.logger.log("Attempting to remove local video stream"),this._localVideoStreams.splice(this._localVideoStreams.indexOf(this.localVideoStream),1).length===0)return void this.logger.warn("Stream not found, failed to remove stream from localVideoStreams collection");this.logger.log("Local video stream removed successfully"),this.localVideoStream.removeCall(this),this.localVideoStream.dispose();const i=this.localVideoStream;this.localVideoStream=void 0;try{this._eventEmitter.emit("localVideoStreamsUpdated",{added:[],removed:[i]})}catch{this.logger.warn("Application threw on emit localVideoStreamsUpdated removed")}this.logger.log("isLocalVideoStarted changed=false"),this._isLocalVideoStarted=!1,this._eventEmitter.emit("isLocalVideoStartedChanged")}}setLocalAudioStream(e){if(!this._callAgent.tsStack)throw new Oe({defaultError:we.CALL.LOCAL_AUDIO_UNDEFINED_STACK});if(e)e.on("audioSourceChanged",this.audioSourceChanged),this._localAudioStreams.push(e),e.addCall(this),this._eventEmitter.emit("localAudioStreamsUpdated",{added:[e],removed:[]});else if(this._localAudioStreams.length===0){if(this._userProvidedLocalAudioStreamCache)return(e=this._userProvidedLocalAudioStreamCache).on("audioSourceChanged",this.audioSourceChanged),this._localAudioStreams.push(e),e.addCall(this),void this._eventEmitter.emit("localAudioStreamsUpdated",{added:[e],removed:[]});const i=this.deviceManager?.selectedMicrophone;if(i){const r=new gP(i);r.on("audioSourceChanged",this.audioSourceChanged),this._localAudioStreams.push(r),r.addCall(this),this._eventEmitter.emit("localAudioStreamsUpdated",{added:[r],removed:[]})}else this.logger.warn("Could not get current selected microphone to update localAudioStreams collection")}else this.logger.warn("No localAudioStream provided and the collection is not empty, doing nothing")}removeLocalAudioStream(e){if(e){if(this.logger.log("Attempting to remove local audio stream"),e.off("audioSourceChanged",this.audioSourceChanged),e.dispose(),this._localAudioStreams.splice(this._localAudioStreams.indexOf(e),1).length===0)return void this.logger.warn("Stream not found, failed to remove stream from localAudioStreams collection");e.removeCall(this),this.logger.log("Local audio stream removed successfully"),this._eventEmitter.emit("localAudioStreamsUpdated",{added:[],removed:[e]})}}_handleAudioEffectsOperations(){try{const e=this._localAudioStreams?.[0];if(!e)return void this.logger.debug("No LocalAudioStream found in the call, cannot handle call audio effects operations");this._audioEffectsStatsListener=r=>{this._audioEffectsProcessorStats=r},e.feature(Ma.AudioEffects)?.on("effectsProcessorStatsUpdated",this._audioEffectsStatsListener)}catch(e){this.logger.warn(`Error handling audio effects operations during call start: ${e}`)}}isAudioPermitted(){return!!this.feature(Ma.MediaAccess)?.getLocalParticipantMediaAccess().isAudioPermitted}isVideoPermitted(){return!!this.feature(Ma.MediaAccess)?.getLocalParticipantMediaAccess().isVideoPermitted}removeScreenSharingStream(){if(this.localScreenSharingStream&&this.localVideoStreams.find(e=>e===this.localScreenSharingStream)){if(wt()?.calling?.allowAccessRawMediaStream&&this.localScreenSharingStream?.mediaStreamType==="RawMedia"){const r=this._callAgent.tsStack?.getDeviceManager();r?.unsetRawMediaStream&&r.unsetRawMediaStream(2)}this.localScreenSharingStream.dispose(),this.localScreenSharingStream.removeCall(this);const e=this._localVideoStreams.indexOf(this.localScreenSharingStream);this._localVideoStreams.splice(e,1);const i=this.localScreenSharingStream;this.localScreenSharingStream=void 0,this._isScreenSharingOn=!1,this._eventEmitter.emit("localVideoStreamsUpdated",{added:[],removed:[i]})}}mapTsCallState(e){const i=h2e[e];switch(i){case"Unknown":case void 0:this.logger.log(`Ignored tsCall state \`${e}\``);break;case"Disconnected":{this._callEndReason=F3(this).callEndReason,this._remoteParticipants.forEach(o=>{o.setCallEndReason(U3(this,o.tsRemoteParticipant).callEndReason),o.setParticipantState("Disconnected")});const r=this._remoteParticipants.map(o=>o);this._remoteParticipants=[],this._mriToRemoteParticipantMap.clear(),this._eventEmitter.emit("remoteParticipantsUpdated",{added:[],removed:r}),this.localVideoStream&&this.removeLocalVideoStream(this.localVideoStream),this.localAudioStreams[0]&&this.removeLocalAudioStream(this.localAudioStreams[0]),this._rawAudioStreamChangedSubscription?.dispose&&this._rawAudioStreamChangedSubscription.dispose(),wt().calling.allowAccessRawMediaStream&&this.remoteAudioStreams[0]&&this.removeRemoteAudioStream(this.remoteAudioStreams[0]),this._userProvidedLocalAudioStreamCache=void 0,this.logger.log(`Mapped tsCall state:${e} to ${i}`),this._setCallState(i),this._telemetryLogManager.flushAllEvents(this.id).then(()=>{this.logger.log("Telemetry flushed")}).catch(o=>{this.logger.warn("Failed to flush telemetry log manager events")});break}case"Connected":this.logger.log(`Mapped tsCall state:${e} to ${i}`),this._remoteParticipantsChangedListeners.forEach(r=>{r.dispose()}),this._setCallState(i),this._setOrUpdateDeviceEventsTask=this._setOrUpdateDeviceEventsTask.then(()=>this.setOrUpdateMediaMetricsDeviceEvents().catch(nh)),wt().calling.allowAccessRawMediaStream&&this.subscribeToGetRemoteAudioStream();break;case"Incoming Call":{this.logger.log(`state changed from ${this._state} to 'Incoming Call'`);const r=new iZ(this.tsCall,{config:this._config});$E(this._telemetryLogManager,this.logger,{...VE(this,this._callAgent,ln(),this._joinContextDescription),step:"state-changed",oldState:this._state,newState:"Incoming Call",callTypeInfo:{initiatorKind:r.initiatorKind,targetKind:r.targetKind,transferor:r.transferorKind,context:r.context,callScenario:r.callScenario,direction:r.direction},teamsMeetingTenantId:this._teamsMeetingTenantId||"",teamsMeetingThreadId:this._teamsMeetingThreadId||"",callDurationInSeconds:this.tsCall.callStartedAt?Math.floor((Date.now()-this.tsCall.callStartedAt?.getTime())/1e3):-1});break}default:this.logger.log(`Mapped tsCall state:${e} to ${i}`),this._setCallState(i)}}shallStopVideo(e){const i=wt()?.calling?.deviceNotFunctioningMuted,r=wt()?.calling?.deviceCaptureMutedVideo,o=wt()?.calling?.preventStopVideo,l=e.type===25&&e.value===3,d=l&&e.mediaType===1,h=e.type===33&&e.value===3,p=$A(),g=mP()==="ios"&&p.engine==="Safari",f=mP()==="android",y=this.tsCall.state===3;return o?y&&this.tsCall.isVideoOn&&h:i&&y&&this.tsCall.isVideoOn&&(h||g&&l||r&&f&&d)}shallRemoveLocalVideoStreamOnBadUfd(e){const i=this.tsCall.localMediaStreams.find(d=>d.mediaType===1),r=e.mediaType===1&&e.value===3&&e.type===25,o=this.tsCall.state==4||this.tsCall.state===5;if($A().formFactor==="Mobile"&&(r||document.visibilityState=="hidden")&&this.localVideoStream&&o&&!i||!wt()?.calling?.removeLvsCheckOnCallStartAndCallAccept)return!1;const l=this.tsCall.state===3;return e.mediaType===1&&e.value===3&&(e.type===33||e.type===25||e.type===34)&&!!this.localVideoStream&&!l&&!i}shallStopAudio(e){const i=wt()?.calling?.deviceNotFunctioningMuted,r=wt()?.calling?.osAutoRecoverAudio,o=e.type===25&&e.value===3&&e.mediaType===0,l=e.type===9&&e.value===3,d=$A(),h=mP()==="ios"&&d.engine==="Safari",p=this.tsCall.state===3;return r?i&&p&&l:i&&!this._isDeviceNotFunctioningMuted&&p&&(l||h&&o)}markCallMuted(){this._isDeviceNotFunctioningMuted=!0,this._handleMuteChanges()}audioDidAutoRecover(e){const i=wt()?.calling?.deviceCaptureMuteRecover&&!wt()?.calling?.preventFakeMute,r=e.type===25&&e.value===1&&e.mediaType===0,o=this.tsCall.state===3,l=$A(),d=mP()==="ios"&&l.engine==="Safari",h=e.type===9&&e.value===1;return i&&this._isDeviceNotFunctioningMuted&&o&&(h||d&&r)}sendParticipantAddedOrRemovedEvent(e){try{this._telemetryLogManager.sendEvent({name:vi.acs_calling_participant_added_or_removed,tenant:Wr,properties:{callId:this.id,remotePerticipantId:Array.isArray(e?.remoteParticipantIds)?e?.remoteParticipantIds.slice(0,wt().telemetry.maxExistingReportedParticipants):[],participantAddedOrRemoved:e.participantAddedOrRemoved,localParticipantId:this.tsCall.participantId,kindOfEvent:e.kindOfEvent,correlationId:e.correlationId||"",timestampInfo:e.timestampInfo||"",additionalDetails:e.additionalDetails||{},networkInfo:e.networkInfo||[]}})}catch{this.logger.debug("Unable to send participant added or removed telemtery")}}_handleLocalRingingCallState(e){this._state==="Connected"||this._direction!=="Outgoing"||this._localRingingStateSet||this._remoteParticipantsChangedListeners.push(e.changed(()=>{e.state!==2||this._state==="Connected"||this._localRingingStateSet||(this._setCallState("Ringing"),this._localRingingStateSet=!0,this._remoteParticipantsChangedListeners.forEach(i=>{i.dispose()}))}))}_setCallState(e){if(e!==this._state){const i=this._state,r=e,o=new iZ(this.tsCall,{config:this._config});this.logger.log(`state changed from ${i} to ${r}`),this._state=r,r==="Connected"&&(this._connectedTimestamp=Date.now()),this._eventEmitter.emit("stateChanged"),$E(this._telemetryLogManager,this.logger,{...VE(this,this._callAgent,ln(),this._joinContextDescription),step:"state-changed",oldState:i,newState:r,callTypeInfo:{initiatorKind:o.initiatorKind,targetKind:o.targetKind,transferor:o.transferorKind,context:o.context,callScenario:o.callScenario,direction:o.direction},teamsMeetingTenantId:this._teamsMeetingTenantId||"",teamsMeetingThreadId:this._teamsMeetingThreadId||"",callDurationInSeconds:this.tsCall.callStartedAt?Math.floor((Date.now()-this.tsCall.callStartedAt?.getTime())/1e3):-1,additionalDetails:this._state==="Disconnected"&&this._callEndReason?{...dP(this._callEndReason)}:void 0})}}_setCallRole(e){if(e!==this._lastTsCallAdvancedMeetingRole){const i=pBe(wt(),e);i===qY?this.logger.log(`tsParticipant advancedMeetingRole=${this._role} had no mapping`):this.logger.log(`mapped tsParticipant advancedMeetingRole=${e}=>${i}`),$E(this._telemetryLogManager,this.logger,{...VE(this,this._callAgent,ln(),this._joinContextDescription),step:"role-changed",oldAcsRole:this._role,newAcsRole:i,serviceRole:e||""}),this._role!=i&&(this.logger.log(`self-role changed ${this._role}=>${e}`),this._role=i,this._lastTsCallAdvancedMeetingRole=e,this._capabilityResolver.resolveCapabilitiesBasedOnRole(),this._eventEmitter.emit("roleChanged"))}}_setMeetingCapabilities(e){zxt(e,this._lastTsCallMeetingDetails)&&($E(this._telemetryLogManager,this.logger,{...VE(this,this._callAgent,ln(),this._joinContextDescription),step:"meetingCapabilities-changed",oldMeetingDetails:this._lastTsCallMeetingDetails,newMeetingDetails:e}),this.logger.log(`Core Meeting Capabilities has changed to: ${JSON.stringify(e)}`),this._capabilityResolver.resolveCapabilitiesBasedOnMeetingCapabilities(),this._eventEmitter.emit("meetingCapabilitiesChanged")),Object.assign(this._lastTsCallMeetingDetails,e)}removeRemoteAudioStream(e){if(e){if(this.logger.log("Attempting to remove remote audio stream"),this._remoteAudioStreams.splice(this._remoteAudioStreams.indexOf(e),1).length===0)return void this.logger.warn("Stream not found, failed to remove stream from remoteAudioStreams collection");this.logger.log("remote audio stream removed successfully"),this._eventEmitter.emit("remoteAudioStreamsUpdated",{added:[],removed:[e]})}}async setOrUpdateMediaMetricsDeviceEvents(){if(wt().calling.mediaMetricsDeviceEventsEnabled)try{const e=await this.tsCall.getMediaSessionStatsAsync?.();if(e?.metrics?.DeviceEvents!==void 0){const i=JSON.parse(e.metrics.DeviceEvents),r=hBe(this._mediaMetricsDeviceEvents||{},i);r.length>0&&(this._mediaMetricsDeviceEvents=i,this.stats.recordEvent({name:vT.media_metrics_device_events,callId:this.id,localParticipantId:this.tsCall.participantId,data:{metricsDeviceEvents:r||{},metricsDevicesChangeCount:i?.metrics_DevicesChangeCount||0,metricsDevicesCount:i?.metrics_DevicesCount||{}}}))}else this.logger.info("Failed to set media metrics device events telemetry: no valid events data")}catch{this.logger.error("Failed to set media metrics device events telemetry")}}setClientEndpointCapabilities(e){const i={};let r=0;return e?.firstPartyOptions?.isImmersiveMode&&(r|=32768),e?.firstPartyOptions?.accessToImmersiveEvents&&(r|=2097152),wt()?.calling?.supportLiveStreaming&&(r|=32),wt()?.calling.sharedLineAppearance.enabled&&(r|=128),this._allowBreakoutRoomJoin&&(r|=4098),r>0&&(i.clientEndpointCapabilities=r),i}getLocalVideoStreamFromCallOptions(e){let i;if(Array.isArray(e?.videoOptions?.localVideoStreams)){if(e?.videoOptions?.localVideoStreams.length!==1)throw new Oe({defaultError:we.CALL.ONLY_SINGLE_VIDEO_STREAM});if(i=e?.videoOptions?.localVideoStreams[0],!(i instanceof kp))throw new Oe({defaultError:we.CALL.NOT_INSTANCE_OF_LVS})}return i}getLocalAudioStreamFromCallOptions(e){let i;if(Array.isArray(e?.audioOptions?.localAudioStreams)){if(e?.audioOptions?.localAudioStreams.length!==1)throw new Oe({defaultError:we.CALL.ONLY_SINGLE_AUDIO_STREAM});if(i=e?.audioOptions?.localAudioStreams[0],!(i instanceof gP))throw new Oe({defaultError:we.CALL.NOT_INSTANCE_OF_LAS})}return i&&(this._userProvidedLocalAudioStreamCache=i),i}async _setRawStream(e,i){if(!wt().calling.allowAccessRawMediaStream)throw new Oe({defaultError:we.CALL.ACCESS_RAW_MEDIA_STREAM_DISABLED});const r=await this._callAgent.tsStack?.getDeviceManagerAsync?.();if(!r?.setRawMediaStream)throw new Oe({defaultError:we.CALL.ACCESS_RAW_MEDIA_STREAM_UNDEFINED_FUNC});try{const o=await e.getMediaStream();if(!o)throw new Oe({defaultError:we.CALL.SS_RAW_STREAM_UNDEFINED});r.setRawMediaStream(o,i)}catch(o){if(i===1)throw new Oe({defaultError:we.CALL.VIDEO_SET_MEDIA_STREAM,originalError:o});if(i===2)throw new Oe({defaultError:we.CALL.SS_RAW_STREAM_SET,originalError:o})}}shallRemoveLvsAfterConnectedSuccessfully(e,i,r,o,l){if(this.tsCall.localMediaStreams.find(d=>d.mediaType===1))this.sendVideoEvent({correlationId:r,eventName:vi.acs_calling_start_video_success,timestampInfo:{deltaTimeInMs:o-l},localVideoStream:e,step:i,isScreenSharingOnFlag:this._isScreenSharingOn});else{if(!wt()?.calling?.removeLvsCheckOnCallStartAndCallAccept)return;this.localVideoStream&&this.removeLocalVideoStream(this.localVideoStream);const d=+new Date,h=new Oe({defaultError:we.CALL.VIDEO_FAILED_TO_START,defaultErrorMessageArgs:[i]});this.logger.error(h.message),this.sendVideoEvent({correlationId:r,eventName:vi.acs_calling_start_video_failure,timestampInfo:{deltaTimeInMs:d-l},localVideoStream:e,step:i,isScreenSharingOnFlag:this._isScreenSharingOn},h)}}shallRemoveLasAfterConnectedSuccessfully(e,i,r,o,l){if(this.tsCall.localMediaStreams.find(d=>d.mediaType===0))this.sendRawMediaEvent({eventName:vi.acs_calling_start_audio_stream_track,callId:this.id,localParticipantId:this.tsCall.participantId,correlationId:r,kindOfEvent:Je.success,localAudioStream:e,timestampInfo:{deltaTimeInMs:o-l},additionalDetails:""});else{if(!wt().calling.removeLocalAudioStreamCheckOnCallStartAndCallAccept)return;this.removeLocalAudioStream(this.localAudioStreams[0]);const d=+new Date;this.logger.error(`Removing local audio stream because audio failed to start during call-${i} process.`);const h=new Oe({defaultError:we.CALL.AUDIO_FAILED_TO_START,defaultErrorMessageArgs:[i]});this.sendRawMediaEvent({eventName:vi.acs_calling_start_audio_stream_track,callId:this.id,localParticipantId:this.tsCall.participantId,correlationId:r,localAudioStream:e,kindOfEvent:Je.failure,timestampInfo:{deltaTimeInMs:d-l},additionalDetails:{failureReason:h.message||"",code:h.code,subCode:h.subCode,...an(h)}})}}_enableOrDisable_largeMeeting_videoRendering(){try{!this._isHandlingLargeMeetingVideoRendering&&this._totalParticipantCount-1>=wt().rendering.remoteVideo.largeMeeting.participantCountThreshold?(this._isHandlingLargeMeetingVideoRendering=!0,this._internalDominantSpeakersListener=new D2e(new qf(this.logger.createChild(()=>`DominanSpeakersFeatureInternal:: Call(id=${this.tsCall.callId})`))),this._internalDominantSpeakersListener.initialize(this.tsCall,this._callAgent,this._telemetryLogManager,this.logger,!0),this.logger.info("Initialized internal dominant speakers listener"),this._internalDominantSpeakersListener.on("dominantSpeakersChanged",()=>{this.handleDominantSpeakersVideos()}),this.handleDominantSpeakersVideos(),this.logger.info("Initialized large meeting video rendering handler")):this._isHandlingLargeMeetingVideoRendering&&(this._totalParticipantCount-1>=wt().rendering.remoteVideo.largeMeeting.participantCountThreshold?this.handleDominantSpeakersVideos():(this._isHandlingLargeMeetingVideoRendering=!1,this._internalDominantSpeakersListener?.dispose(),this._internalDominantSpeakersListener=void 0,this.logger.info("Disposed of internal dominant speakers listener"),this.remoteParticipants.forEach(e=>{e.videoStreams.forEach(i=>{i.setIsAvailable(i.tsStream.isAvailable)})}),this.logger.info("All remote streams isAvailable flags were reset"),this.logger.info("Disposed large meeting video rendering handler")))}catch(e){this.logger.error("Failed to handle large meeting video rendering",e)}}async handleConsentCapabilitiesChanges(){this.explicitConsentStateImp.areCoreCapabilitiesConsentRestricted()&&(this.isMuted||this.mute().then(()=>{this.logger.log("ExplicitConsentCallStateManager: Handle Capabilities changes: Mic is turned off :",this.isMuted)}).catch(e=>{this.logger.error("ExplicitConsentCallStateManager: Handle Capabilities changes: Error stopping mic",e)}),this.isLocalVideoStarted&&this.localVideoStream&&this.stopVideo(this.localVideoStream).then(()=>{this.logger.log("ExplicitConsentCallStateManager: Handle Capabilities changes: Video is turned off :",this.isLocalVideoStarted)}).catch(e=>{this.logger.error("ExplicitConsentCallStateManager: Handle Capabilities changes: Error stopping video",e)}),this.isScreenSharingOn&&this.stopScreenSharing().then(()=>{this.logger.log("ExplicitConsentCallStateManager: Handle Capabilities changes: Screenshare is turned off :",this.isScreenSharingOn)}).catch(e=>{this.logger.error("ExplicitConsentCallStateManager: Handle Capabilities changes: Error stopping screenshare",e)}))}handleDominantSpeakersVideos(){this.logger.info("Dominant speakers changed during large meeting");const e=this.getTopNDominantSpeakersWithVideoOn();this.logger.info(`There are currently ${e.length} top-n speakers with video on in the large meeting`),e.forEach(i=>{i.videoStreams.filter(r=>r.mediaStreamType==="Video").forEach(r=>{r.setIsAvailable(r.tsStream.isAvailable)})}),this._remoteParticipants.filter(i=>!e.includes(i)).forEach(i=>{i.videoStreams.filter(r=>r.mediaStreamType==="Video").forEach(r=>{try{r.setIsAvailable(!1)}catch(l){const d=new Oe({defaultError:we.CALL.LARGE_MEETING_FORCE_ISAVAILABLE,originalError:l});this.logger.warn(d.message)}const o=this.activeRemoteVideoStreamViews.get(r.id);o&&o.forEach(l=>{try{l.disposed||(l.dispose(NE.Internal_LargeMeetingVideoRendering),this.logger.info("Successfully disposed of view during large meeting"))}catch(d){const h=new Oe({defaultError:we.CALL.LARGE_MEETING_DISPOSE_VIEW,originalError:d});this.logger.warn(h.message)}})})})}}Kf([zv,zo("design:type",Object)],Yg.prototype,"logger",void 0),Kf([sg(Ar.BindToCall),zo("design:type",Function),zo("design:paramtypes",[]),zo("design:returntype",Array)],Yg.prototype,"bindTsCall",null),Kf([sg(Ar.Feature),zo("design:type",Function),zo("design:paramtypes",[Object]),zo("design:returntype",typeof(X5e=typeof TFeature<"u"&&TFeature)=="function"?X5e:Object)],Yg.prototype,"feature",null),Kf([to(Ar.HangUp),zo("design:type",Function),zo("design:paramtypes",[Object]),zo("design:returntype",Promise)],Yg.prototype,"hangUp",null),Kf([to(Ar.Mute),zo("design:type",Function),zo("design:paramtypes",[]),zo("design:returntype",Promise)],Yg.prototype,"mute",null),Kf([to(Ar.Unmute),zo("design:type",Function),zo("design:paramtypes",[]),zo("design:returntype",Promise)],Yg.prototype,"unmute",null),Kf([to(Ar.MuteAllRemoteParticipants),zo("design:type",Function),zo("design:paramtypes",[]),zo("design:returntype",Promise)],Yg.prototype,"muteAllRemoteParticipants",null),Kf([to(Ar.MuteIncomingAudio),zo("design:type",Function),zo("design:paramtypes",[]),zo("design:returntype",Promise)],Yg.prototype,"muteIncomingAudio",null),Kf([to(Ar.UnmuteIncomingAudio),zo("design:type",Function),zo("design:paramtypes",[]),zo("design:returntype",Promise)],Yg.prototype,"unmuteIncomingAudio",null),Kf([to(Ar.SendDtmf),zo("design:type",Function),zo("design:paramtypes",[String]),zo("design:returntype",Promise)],Yg.prototype,"sendDtmf",null),Kf([to(Ar.StartVideo),zo("design:type",Function),zo("design:paramtypes",[kp]),zo("design:returntype",Promise)],Yg.prototype,"startVideo",null),Kf([to(Ar.StopVideo),zo("design:type",Function),zo("design:paramtypes",[kp]),zo("design:returntype",Promise)],Yg.prototype,"stopVideo",null),Kf([to(Ar.StartAudio),zo("design:type",Function),zo("design:paramtypes",[gP]),zo("design:returntype",Promise)],Yg.prototype,"startAudio",null),Kf([qL(Ar.Hold),to(Ar.Hold),zo("design:type",Function),zo("design:paramtypes",[]),zo("design:returntype",Promise)],Yg.prototype,"hold",null),Kf([qL(Ar.Resume),to(Ar.Resume),zo("design:type",Function),zo("design:paramtypes",[]),zo("design:returntype",Promise)],Yg.prototype,"resume",null),Kf([to(Ar.StartScreenShare),zo("design:type",Function),zo("design:paramtypes",[kp]),zo("design:returntype",Promise)],Yg.prototype,"startScreenSharing",null),Kf([to(Ar.StopScreenShare),zo("design:type",Function),zo("design:paramtypes",[]),zo("design:returntype",Promise)],Yg.prototype,"stopScreenSharing",null),Kf([to(Ar.SetConstraints),zo("design:type",Function),zo("design:paramtypes",[Object]),zo("design:returntype",Promise)],Yg.prototype,"setConstraints",null);var e3e=function(t,e,i,r){var o,l=arguments.length,d=l<3?e:r===null?r=Object.getOwnPropertyDescriptor(e,i):r;if(typeof Reflect=="object"&&typeof Reflect.decorate=="function")d=Reflect.decorate(t,e,i,r);else for(var h=t.length-1;h>=0;h--)(o=t[h])&&(d=(l<3?o(d):l>3?o(e,i,d):o(e,i))||d);return l>3&&d&&Object.defineProperty(e,i,d),d},t4=function(t,e){if(typeof Reflect=="object"&&typeof Reflect.metadata=="function")return Reflect.metadata(t,e)};class i4 extends Yg{get info(){return this._info}constructor(e,i,r,o,l){super(e,i,r,o,GL.Call,l),this._info=this.callInfo,this._allowBreakoutRoomJoin=wt().calling.breakoutRooms.enabled}dispose(){super.dispose(),this._extensibleApi.dispose()}addParticipant(e,i){let r,o;const l=i,d=i,h=i,p=+new Date,g=ln();if(this.sendParticipantAddedOrRemovedEvent({kindOfEvent:Je.attempt,participantAddedOrRemoved:"add",correlationId:g,timestampInfo:{attemptTimestamp:p},additionalDetails:{customContext:{userToUserPresent:!!l?.customContext?.userToUser,xHeadersPresent:!!l?.customContext?.xHeaders&&l?.customContext.xHeaders.length>0}}}),this._callAgent.isCteUser())switch(this.validateThreadId(e,i),Ap(e).kind){case"communicationUser":o=l.threadId;break;case"microsoftTeamsUser":o=h.threadId;break;case"phoneNumber":o=d.threadId;break;default:{const E=new Oe({defaultError:we.CALL.ADD_UNKNOWN});throw this.sendParticipantAddedOrRemovedEvent({kindOfEvent:Je.failure,participantAddedOrRemoved:"add",correlationId:g,timestampInfo:{deltaTimeInMs:+new Date-p},additionalDetails:{code:E.code,failureReason:E.message,...an(E)}}),E}}let f;d?.alternateCallerId&&(LA(d.alternateCallerId),r=zr(d.alternateCallerId));try{if(Y3(Ar.AddParticipant,this.state),f=LA(e),!_B(this.acsProxy,this.acsCustomRelayManager,!1,f))throw new Oe({defaultError:we.CALL_AGENT.PROXY_CUSTOM_TURN_FORBIDDEN})}catch(E){throw this.sendParticipantAddedOrRemovedEvent({kindOfEvent:Je.failure,participantAddedOrRemoved:"add",correlationId:g,timestampInfo:{deltaTimeInMs:+new Date-p},additionalDetails:{code:E.code,failureReason:E.message,...an(E)}}),E}if(this._remoteParticipants.find(E=>zr(E.identifier)===zr(e))){const E=new Oe({defaultError:we.CALL.PARTICIPANT_ALREADY_IN_CALL,defaultErrorMessageArgs:[Ap(e).kind]});throw this.sendParticipantAddedOrRemovedEvent({kindOfEvent:Je.failure,participantAddedOrRemoved:"add",correlationId:g,timestampInfo:{deltaTimeInMs:+new Date-p},additionalDetails:{code:E.code,failureReason:E.message,...an(E)}}),E}const y=[...this.remoteParticipants.values()].map(E=>E.identifier);this._isAcsTeamsCall=bhe([...y,e],this._callAgent.kind),wt().calling.enableSmePassFakeConversation&&this._isAcsTeamsCall&&!o&&(o=this.tsCall.threadId||`${WK}${ln()}`);const T=fd();wo.setCauseIdToNetworkInfo(T);const C=this.getOrCreateRemoteParticipant(Sl(zr(e)));return this.tsCall.addParticipant(zr(e),{alternateId:r,threadId:o,customHeaderContext:h6(d)},T).then(()=>{this.sendParticipantAddedOrRemovedEvent({kindOfEvent:Je.success,participantAddedOrRemoved:"add",correlationId:g,timestampInfo:{deltaTimeInMs:+new Date-p},networkInfo:wo.getRemoveCauseIdToNetworkInfo(T)})}).catch(E=>{const{callEndReason:I}=U3(this,C.tsRemoteParticipant,E);C.callEndReason||C.setCallEndReason(I);const w=dP(I);this.sendParticipantAddedOrRemovedEvent({kindOfEvent:Je.failure,participantAddedOrRemoved:"add",correlationId:g,timestampInfo:{deltaTimeInMs:+new Date-p},additionalDetails:{code:w?.callEndReason.code,subCode:w?.callEndReason.subCode,failureReason:w?.callEndReason.message,...w},networkInfo:wo.getRemoveCauseIdToNetworkInfo(T)}),this._remoteParticipants.find(D=>zr(D.identifier)===zr(e))&&(this.deleteRemoteParticipant(C),this._eventEmitter.emit("remoteParticipantsUpdated",{added:[],removed:[C]}))}),C}async removeParticipant(e,i){const r=+new Date,o=ln();this.sendParticipantAddedOrRemovedEvent({kindOfEvent:Je.attempt,participantAddedOrRemoved:"remove",correlationId:o,timestampInfo:{attemptTimestamp:r}});try{Y3(Ar.RemoveParticipant,this.state),LA(e)}catch(h){const p=new Oe({defaultError:we.IDENTIFIER.PARSE_INVALID_IDENTIFIER,originalError:h});throw this.sendParticipantAddedOrRemovedEvent({kindOfEvent:Je.failure,participantAddedOrRemoved:"remove",correlationId:o,timestampInfo:{deltaTimeInMs:+new Date-r},additionalDetails:{code:h.code,failureReason:h.message,...an(p)}}),p}let l=this._remoteParticipants.find(h=>zr(h.identifier)===zr(e));if(!l){const h=new Oe({defaultError:we.CALL.PARTICIPANT_NOT_IN_CALL,defaultErrorMessageArgs:[Ap(e).kind]});throw this.sendParticipantAddedOrRemovedEvent({kindOfEvent:Je.failure,participantAddedOrRemoved:"remove",correlationId:o,timestampInfo:{deltaTimeInMs:r-+new Date},additionalDetails:{code:h.code,subCode:h.subCode,failureReason:h.message,...an(h)}}),h}const d=fd();wo.setCauseIdToNetworkInfo(d);try{await this.tsCall.removeParticipant(zr(e)),this.sendParticipantAddedOrRemovedEvent({kindOfEvent:Je.success,participantAddedOrRemoved:"remove",correlationId:o,timestampInfo:{deltaTimeInMs:r-+new Date},networkInfo:wo.getRemoveCauseIdToNetworkInfo(d)})}catch(h){const p=U3(this,l.tsRemoteParticipant,h).callEndReason;l.callEndReason||l.setCallEndReason(p);const g=dP(p);throw this.sendParticipantAddedOrRemovedEvent({kindOfEvent:Je.failure,participantAddedOrRemoved:"remove",correlationId:o,timestampInfo:{deltaTimeInMs:r-+new Date},additionalDetails:{code:g?.callEndReason.code,subCode:g?.callEndReason.subCode,failureReason:g?.callEndReason.message,...g},networkInfo:wo.getRemoveCauseIdToNetworkInfo(d)}),new Oe({defaultError:{message:p.message,code:p.code,subCode:p.subCode||0,resultCategories:p.resultCategories},originalError:h})}}validateThreadId(e,i){if(!i?.threadId)throw new Oe({defaultError:we.CALL.CTE_ADDPARTICIPANT_NO_THREAD_ID})}}e3e([sg(Ar.AddParticipant),t4("design:type",Function),t4("design:paramtypes",[Object,Object]),t4("design:returntype",Object)],i4.prototype,"addParticipant",null),e3e([to(Ar.RemoveParticipant),t4("design:type",Function),t4("design:paramtypes",[Object,Object]),t4("design:returntype",Promise)],i4.prototype,"removeParticipant",null);var WVt=function(t,e,i,r){var o,l=arguments.length,d=l<3?e:r===null?r=Object.getOwnPropertyDescriptor(e,i):r;if(typeof Reflect=="object"&&typeof Reflect.decorate=="function")d=Reflect.decorate(t,e,i,r);else for(var h=t.length-1;h>=0;h--)(o=t[h])&&(d=(l<3?o(d):l>3?o(e,i,d):o(e,i))||d);return l>3&&d&&Object.defineProperty(e,i,d),d},Qpe=function(t,e){if(typeof Reflect=="object"&&typeof Reflect.metadata=="function")return Reflect.metadata(t,e)};class Zpe{get kind(){return this._kind}get id(){return this._callCommon.id}get callerInfo(){return this._callCommon.callerInfo}get transferorInfo(){return this._callCommon.transferorInfo}get callEndReason(){return this._callCommon.callEndReason}get customContext(){return this._customContext}constructor(e,i){this._callCommon=e,this._eventEmitter=new $c.EventEmitter,this._kind=i,this._callConnected=this._callCommon.state==="Connected",this._customContext=gBe(this._callCommon.tsCall),this._callCommon.on("stateChanged",()=>{this._callCommon.state==="Connected"?this._callConnected=!0:this._callCommon.state!=="Disconnected"||this._callConnected||this._eventEmitter.emit("callEnded",{callEndReason:this._callCommon.callEndReason})}),this._callCommon.on("callerInfoChanged",()=>{this._eventEmitter.emit("callerInfoChanged")}),this._callCommon.on("transferorInfoChanged",()=>{this._eventEmitter.emit("transferorInfoChanged")})}on(e,i){this._eventEmitter.on(e,i)}off(e,i){this._eventEmitter.off(e,i)}reject(){return this._callCommon.reject()}}WVt([to(),Qpe("design:type",Function),Qpe("design:paramtypes",[]),Qpe("design:returntype",Promise)],Zpe.prototype,"reject",null);var KVt=function(t,e,i,r){var o,l=arguments.length,d=l<3?e:r===null?r=Object.getOwnPropertyDescriptor(e,i):r;if(typeof Reflect=="object"&&typeof Reflect.decorate=="function")d=Reflect.decorate(t,e,i,r);else for(var h=t.length-1;h>=0;h--)(o=t[h])&&(d=(l<3?o(d):l>3?o(e,i,d):o(e,i))||d);return l>3&&d&&Object.defineProperty(e,i,d),d},Xpe=function(t,e){if(typeof Reflect=="object"&&typeof Reflect.metadata=="function")return Reflect.metadata(t,e)};class t3e extends Zpe{get info(){return this._call.info}constructor(e){super(e,KK.IncomingCall),this._call=e}async accept(e){if(this.info?.initiatorKind==="microsoftTeamsUser"&&!_B(this._call.acsProxy,this._call.acsCustomRelayManager,!0))throw new Oe({defaultError:we.CALL_AGENT.PROXY_CUSTOM_TURN_FORBIDDEN});return await this._call.accept(e),this._call}}KVt([to(Ar.Accept),Xpe("design:type",Function),Xpe("design:paramtypes",[Object]),Xpe("design:returntype",Promise)],t3e.prototype,"accept",null);var i3e=function(e,i){return function(){return e.apply(i,arguments)}},ege=Object.prototype.toString,tge=function(t){return function(e){var i=ege.call(e);return t[i]||(t[i]=i.slice(8,-1).toLowerCase())}}(Object.create(null));function OO(t){return t=t.toLowerCase(),function(i){return tge(i)===t}}function aZ(t){return Array.isArray(t)}function ige(t){return t===void 0}function JVt(t){return t!==null&&!ige(t)&&t.constructor!==null&&!ige(t.constructor)&&typeof t.constructor.isBuffer=="function"&&t.constructor.isBuffer(t)}var n3e=OO("ArrayBuffer");function YVt(t){return typeof ArrayBuffer<"u"&&ArrayBuffer.isView?ArrayBuffer.isView(t):t&&t.buffer&&n3e(t.buffer)}function QVt(t){return typeof t=="string"}function a3e(t){return typeof t=="number"}function r3e(t){return t!==null&&typeof t=="object"}function rZ(t){if(tge(t)!=="object")return!1;var e=Object.getPrototypeOf(t);return e===null||e===Object.prototype}function ZVt(t){return t&&Object.keys(t).length===0&&Object.getPrototypeOf(t)===Object.prototype}var XVt=OO("Date"),e$t=OO("File"),t$t=OO("Blob"),i$t=OO("FileList");function nge(t){return ege.call(t)==="[object Function]"}function n$t(t){return r3e(t)&&nge(t.pipe)}function a$t(t){var e="[object FormData]";return t&&(typeof FormData=="function"&&t instanceof FormData||ege.call(t)===e||nge(t.toString)&&t.toString()===e)}var r$t=OO("URLSearchParams");function o$t(t){return t.trim?t.trim():t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,"")}function s$t(){var t;return(typeof navigator>"u"||(t=navigator.product)!=="ReactNative"&&t!=="NativeScript"&&t!=="NS")&&typeof window<"u"&&typeof document<"u"}function age(t,e){if(t!=null)if(typeof t!="object"&&(t=[t]),aZ(t))for(var i=0,r=t.length;i<r;i++)e.call(null,t[i],i,t);else for(var o in t)Object.prototype.hasOwnProperty.call(t,o)&&e.call(null,t[o],o,t)}function rge(){var t={};function e(o,l){rZ(t[l])&&rZ(o)?t[l]=rge(t[l],o):rZ(o)?t[l]=rge({},o):aZ(o)?t[l]=o.slice():t[l]=o}for(var i=0,r=arguments.length;i<r;i++)age(arguments[i],e);return t}function l$t(t,e,i){return age(e,function(o,l){t[l]=i&&typeof o=="function"?i3e(o,i):o}),t}function c$t(t){return t.charCodeAt(0)===65279&&(t=t.slice(1)),t}function d$t(t,e,i,r){t.prototype=Object.create(e.prototype,r),t.prototype.constructor=t,i&&Object.assign(t.prototype,i)}function u$t(t,e,i,r){var o,l,d,h={};if(e=e||{},t==null)return e;do{for(l=(o=Object.getOwnPropertyNames(t)).length;l-- >0;)d=o[l],r&&!r(d,t,e)||h[d]||(e[d]=t[d],h[d]=!0);t=i!==!1&&Object.getPrototypeOf(t)}while(t&&(!i||i(t,e))&&t!==Object.prototype);return e}function h$t(t,e,i){t=String(t),(i===void 0||i>t.length)&&(i=t.length),i-=e.length;var r=t.indexOf(e,i);return r!==-1&&r===i}function p$t(t){if(!t)return null;if(aZ(t))return t;var e=t.length;if(!a3e(e))return null;for(var i=new Array(e);e-- >0;)i[e]=t[e];return i}var g$t=function(t){return function(e){return t&&e instanceof t}}(typeof Uint8Array<"u"&&Object.getPrototypeOf(Uint8Array));function m$t(t,e){for(var i,r=(t&&t[Symbol.iterator]).call(t);(i=r.next())&&!i.done;){var o=i.value;e.call(t,o[0],o[1])}}function f$t(t,e){for(var i,r=[];(i=t.exec(e))!==null;)r.push(i);return r}var v$t=OO("HTMLFormElement"),y$t=function(e){return function(i,r){return e.call(i,r)}}(Object.prototype.hasOwnProperty),ua={isArray:aZ,isArrayBuffer:n3e,isBuffer:JVt,isFormData:a$t,isArrayBufferView:YVt,isString:QVt,isNumber:a3e,isObject:r3e,isPlainObject:rZ,isEmptyObject:ZVt,isUndefined:ige,isDate:XVt,isFile:e$t,isBlob:t$t,isFunction:nge,isStream:n$t,isURLSearchParams:r$t,isStandardBrowserEnv:s$t,forEach:age,merge:rge,extend:l$t,trim:o$t,stripBOM:c$t,inherits:d$t,toFlatObject:u$t,kindOf:tge,kindOfTest:OO,endsWith:h$t,toArray:p$t,isTypedArray:g$t,isFileList:i$t,forEachEntry:m$t,matchAll:f$t,isHTMLForm:v$t,hasOwnProperty:y$t};function n4(t,e,i,r,o){Error.call(this),Error.captureStackTrace?Error.captureStackTrace(this,this.constructor):this.stack=new Error().stack,this.message=t,this.name="AxiosError",e&&(this.code=e),i&&(this.config=i),r&&(this.request=r),o&&(this.response=o)}ua.inherits(n4,Error,{toJSON:function(){return{message:this.message,name:this.name,description:this.description,number:this.number,fileName:this.fileName,lineNumber:this.lineNumber,columnNumber:this.columnNumber,stack:this.stack,config:this.config,code:this.code,status:this.response&&this.response.status?this.response.status:null}}});var o3e=n4.prototype,s3e={};["ERR_BAD_OPTION_VALUE","ERR_BAD_OPTION","ECONNABORTED","ETIMEDOUT","ERR_NETWORK","ERR_FR_TOO_MANY_REDIRECTS","ERR_DEPRECATED","ERR_BAD_RESPONSE","ERR_BAD_REQUEST","ERR_CANCELED","ERR_NOT_SUPPORT","ERR_INVALID_URL"].forEach(function(t){s3e[t]={value:t}}),Object.defineProperties(n4,s3e),Object.defineProperty(o3e,"isAxiosError",{value:!0}),n4.from=function(t,e,i,r,o,l){var d=Object.create(o3e);return ua.toFlatObject(t,d,function(p){return p!==Error.prototype}),n4.call(d,t.message,e,i,r,o),d.cause=t,d.name=t.name,l&&Object.assign(d,l),d};var Tu=n4,S$t=typeof self=="object"?self.FormData:window.FormData;function oge(t){return ua.isPlainObject(t)||ua.isArray(t)}function l3e(t){return ua.endsWith(t,"[]")?t.slice(0,-2):t}function c3e(t,e,i){return t?t.concat(e).map(function(o,l){return o=l3e(o),!i&&l?"["+o+"]":o}).join(i?".":""):e}function b$t(t){return ua.isArray(t)&&!t.some(oge)}var T$t=ua.toFlatObject(ua,{},null,function(e){return/^is[A-Z]/.test(e)});function C$t(t){return t&&ua.isFunction(t.append)&&t[Symbol.toStringTag]==="FormData"&&t[Symbol.iterator]}function _$t(t,e,i){if(!ua.isObject(t))throw new TypeError("target must be an object");e=e||new(S$t||FormData);var r=(i=ua.toFlatObject(i,{metaTokens:!0,dots:!1,indexes:!1},!1,function(E,I){return!ua.isUndefined(I[E])})).metaTokens,o=i.visitor||g,l=i.dots,d=i.indexes,h=(i.Blob||typeof Blob<"u"&&Blob)&&C$t(e);if(!ua.isFunction(o))throw new TypeError("visitor must be a function");function p(C){if(C===null)return"";if(ua.isDate(C))return C.toISOString();if(!h&&ua.isBlob(C))throw new Tu("Blob is not supported. Use a Buffer instead.");return ua.isArrayBuffer(C)||ua.isTypedArray(C)?h&&typeof Blob=="function"?new Blob([C]):Buffer.from(C):C}function g(C,E,I){var w=C;if(C&&!I&&typeof C=="object"){if(ua.endsWith(E,"{}"))E=r?E:E.slice(0,-2),C=JSON.stringify(C);else if(ua.isArray(C)&&b$t(C)||ua.isFileList(C)||ua.endsWith(E,"[]")&&(w=ua.toArray(C)))return E=l3e(E),w.forEach(function(F,x){!ua.isUndefined(F)&&e.append(d===!0?c3e([E],x,l):d===null?E:E+"[]",p(F))}),!1}return!!oge(C)||(e.append(c3e(I,E,l),p(C)),!1)}var f=[],y=Object.assign(T$t,{defaultVisitor:g,convertValue:p,isVisitable:oge});function T(C,E){if(!ua.isUndefined(C)){if(f.indexOf(C)!==-1)throw Error("Circular reference detected in "+E.join("."));f.push(C),ua.forEach(C,function(w,D){(!ua.isUndefined(w)&&o.call(e,w,ua.isString(D)?D.trim():D,E,y))===!0&&T(w,E?E.concat(D):[D])}),f.pop()}}if(!ua.isObject(t))throw new TypeError("data must be an object");return T(t),e}var oZ=_$t;function d3e(t){var e={"!":"%21","'":"%27","(":"%28",")":"%29","~":"%7E","%20":"+","%00":"\0"};return encodeURIComponent(t).replace(/[!'\(\)~]|%20|%00/g,function(r){return e[r]})}function u3e(t,e){this._pairs=[],t&&oZ(t,this,e)}var h3e=u3e.prototype;h3e.append=function(e,i){this._pairs.push([e,i])},h3e.toString=function(e){var i=e?function(r){return e.call(this,r,d3e)}:d3e;return this._pairs.map(function(o){return i(o[0])+"="+i(o[1])},"").join("&")};var p3e=u3e;function E$t(t){return encodeURIComponent(t).replace(/%3A/gi,":").replace(/%24/g,"$").replace(/%2C/gi,",").replace(/%20/g,"+").replace(/%5B/gi,"[").replace(/%5D/gi,"]")}var g3e=function(e,i,r){if(!i)return e;var o=e.indexOf("#");o!==-1&&(e=e.slice(0,o));var l,d=r&&r.encode||E$t,h=r&&r.serialize;return(l=h?h(i,r):ua.isURLSearchParams(i)?i.toString():new p3e(i,r).toString(d))&&(e+=(e.indexOf("?")===-1?"?":"&")+l),e};function r8(){this.handlers=[]}r8.prototype.use=function(e,i,r){return this.handlers.push({fulfilled:e,rejected:i,synchronous:!!r&&r.synchronous,runWhen:r?r.runWhen:null}),this.handlers.length-1},r8.prototype.eject=function(e){this.handlers[e]&&(this.handlers[e]=null)},r8.prototype.clear=function(){this.handlers&&(this.handlers=[])},r8.prototype.forEach=function(e){ua.forEach(this.handlers,function(r){r!==null&&e(r)})};var m3e=r8,sZ=function(e,i){ua.forEach(e,function(o,l){l!==i&&l.toUpperCase()===i.toUpperCase()&&(e[i]=o,delete e[l])})},f3e={silentJSONParsing:!0,forcedJSONParsing:!0,clarifyTimeoutError:!1},lZ={classes:{URLSearchParams:typeof URLSearchParams<"u"?URLSearchParams:p3e,FormData,Blob},protocols:["http","https","file","blob","url","data"]},A$t=function(e,i){return oZ(e,new lZ.classes.URLSearchParams,Object.assign({visitor:function(r,o,l,d){return d.defaultVisitor.apply(this,arguments)}},i))};function I$t(t){return ua.matchAll(/\w+|\[(\w*)]/g,t).map(function(e){return e[0]==="[]"?"":e[1]||e[0]})}function w$t(t){var e,i,r={},o=Object.keys(t),l=o.length;for(e=0;e<l;e++)r[i=o[e]]=t[i];return r}function k$t(t){function e(r,o,l,d){var h=r[d++],p=Number.isFinite(+h),g=d>=r.length;return h=!h&&ua.isArray(l)?l.length:h,g?(ua.hasOwnProperty(l,h)?l[h]=[l[h],o]:l[h]=o,!p):(l[h]&&ua.isObject(l[h])||(l[h]=[]),e(r,o,l[h],d)&&ua.isArray(l[h])&&(l[h]=w$t(l[h])),!p)}if(ua.isFormData(t)&&ua.isFunction(t.entries)){var i={};return ua.forEachEntry(t,function(r,o){e(I$t(r),o,i,0)}),i}return null}var v3e=k$t,R$t=function(e,i,r){var o=r.config.validateStatus;r.status&&o&&!o(r.status)?i(new Tu("Request failed with status code "+r.status,[Tu.ERR_BAD_REQUEST,Tu.ERR_BAD_RESPONSE][Math.floor(r.status/100)-4],r.config,r.request,r)):e(r)},M$t=ua.isStandardBrowserEnv()?function(){return{write:function(i,r,o,l,d,h){var p=[];p.push(i+"="+encodeURIComponent(r)),ua.isNumber(o)&&p.push("expires="+new Date(o).toGMTString()),ua.isString(l)&&p.push("path="+l),ua.isString(d)&&p.push("domain="+d),h===!0&&p.push("secure"),document.cookie=p.join("; ")},read:function(i){var r=document.cookie.match(new RegExp("(^|;\\s*)("+i+")=([^;]*)"));return r?decodeURIComponent(r[3]):null},remove:function(i){this.write(i,"",Date.now()-864e5)}}}():{write:function(){},read:function(){return null},remove:function(){}},P$t=function(e){return/^([a-z][a-z\d+\-.]*:)?\/\//i.test(e)},D$t=function(e,i){return i?e.replace(/\/+$/,"")+"/"+i.replace(/^\/+/,""):e},y3e=function(e,i){return e&&!P$t(i)?D$t(e,i):i},L$t=["age","authorization","content-length","content-type","etag","expires","from","host","if-modified-since","if-unmodified-since","last-modified","location","max-forwards","proxy-authorization","referer","retry-after","user-agent"],O$t=function(e){var i,r,o,l={};return e&&ua.forEach(e.split(`
`),function(h){if(o=h.indexOf(":"),i=ua.trim(h.slice(0,o)).toLowerCase(),r=ua.trim(h.slice(o+1)),i){if(l[i]&&L$t.indexOf(i)>=0)return;l[i]=i==="set-cookie"?(l[i]?l[i]:[]).concat([r]):l[i]?l[i]+", "+r:r}}),l},N$t=ua.isStandardBrowserEnv()?function(){var e,i=/(msie|trident)/i.test(navigator.userAgent),r=document.createElement("a");function o(l){var d=l;return i&&(r.setAttribute("href",d),d=r.href),r.setAttribute("href",d),{href:r.href,protocol:r.protocol?r.protocol.replace(/:$/,""):"",host:r.host,search:r.search?r.search.replace(/^\?/,""):"",hash:r.hash?r.hash.replace(/^#/,""):"",hostname:r.hostname,port:r.port,pathname:r.pathname.charAt(0)==="/"?r.pathname:"/"+r.pathname}}return e=o(window.location.href),function(d){var h=ua.isString(d)?o(d):d;return h.protocol===e.protocol&&h.host===e.host}}():function(){return!0};function S3e(t,e,i){Tu.call(this,t??"canceled",Tu.ERR_CANCELED,e,i),this.name="CanceledError"}ua.inherits(S3e,Tu,{__CANCEL__:!0});var cZ=S3e,x$t=function(e){var i=/^([-+\w]{1,25})(:?\/\/|:)/.exec(e);return i&&i[1]||""},B$t=function(e){return new Promise(function(r,o){var l,d=e.data,h=e.headers,p=e.responseType,g=e.withXSRFToken;function f(){e.cancelToken&&e.cancelToken.unsubscribe(l),e.signal&&e.signal.removeEventListener("abort",l)}ua.isFormData(d)&&ua.isStandardBrowserEnv()&&delete h["Content-Type"];var y=new XMLHttpRequest;if(e.auth){var T=e.auth.username||"",C=e.auth.password?unescape(encodeURIComponent(e.auth.password)):"";h.Authorization="Basic "+btoa(T+":"+C)}var E=y3e(e.baseURL,e.url);function I(){if(y){var F="getAllResponseHeaders"in y?O$t(y.getAllResponseHeaders()):null,x={data:p&&p!=="text"&&p!=="json"?y.response:y.responseText,status:y.status,statusText:y.statusText,headers:F,config:e,request:y};R$t(function(L){r(L),f()},function(L){o(L),f()},x),y=null}}if(y.open(e.method.toUpperCase(),g3e(E,e.params,e.paramsSerializer),!0),y.timeout=e.timeout,"onloadend"in y?y.onloadend=I:y.onreadystatechange=function(){y&&y.readyState===4&&(y.status!==0||y.responseURL&&y.responseURL.indexOf("file:")===0)&&setTimeout(I)},y.onabort=function(){y&&(o(new Tu("Request aborted",Tu.ECONNABORTED,e,y)),y=null)},y.onerror=function(){o(new Tu("Network Error",Tu.ERR_NETWORK,e,y)),y=null},y.ontimeout=function(){var x=e.timeout?"timeout of "+e.timeout+"ms exceeded":"timeout exceeded",B=e.transitional||f3e;e.timeoutErrorMessage&&(x=e.timeoutErrorMessage),o(new Tu(x,B.clarifyTimeoutError?Tu.ETIMEDOUT:Tu.ECONNABORTED,e,y)),y=null},ua.isStandardBrowserEnv()&&(g&&ua.isFunction(g)&&(g=g(e)),g||g!==!1&&N$t(E))){var w=e.xsrfHeaderName&&e.xsrfCookieName&&M$t.read(e.xsrfCookieName);w&&(h[e.xsrfHeaderName]=w)}"setRequestHeader"in y&&ua.forEach(h,function(x,B){d===void 0&&B.toLowerCase()==="content-type"?delete h[B]:y.setRequestHeader(B,x)}),ua.isUndefined(e.withCredentials)||(y.withCredentials=!!e.withCredentials),p&&p!=="json"&&(y.responseType=e.responseType),typeof e.onDownloadProgress=="function"&&y.addEventListener("progress",e.onDownloadProgress),typeof e.onUploadProgress=="function"&&y.upload&&y.upload.addEventListener("progress",e.onUploadProgress),(e.cancelToken||e.signal)&&(l=function(F){y&&(o(!F||F.type?new cZ(null,e,y):F),y.abort(),y=null)},e.cancelToken&&e.cancelToken.subscribe(l),e.signal&&(e.signal.aborted?l():e.signal.addEventListener("abort",l))),d||d===!1||d===0||d===""||(d=null);var D=x$t(E);D&&lZ.protocols.indexOf(D)===-1?o(new Tu("Unsupported protocol "+D+":",Tu.ERR_BAD_REQUEST,e)):y.send(d)})},F$t={"Content-Type":"application/x-www-form-urlencoded"};function b3e(t,e){!ua.isUndefined(t)&&ua.isUndefined(t["Content-Type"])&&(t["Content-Type"]=e)}function U$t(){var t;return(typeof XMLHttpRequest<"u"||typeof process<"u"&&Object.prototype.toString.call(process)==="[object process]")&&(t=B$t),t}function z$t(t,e,i){if(ua.isString(t))try{return(e||JSON.parse)(t),ua.trim(t)}catch(r){if(r.name!=="SyntaxError")throw r}return(i||JSON.stringify)(t)}var dZ={transitional:f3e,adapter:U$t(),transformRequest:[function(e,i){sZ(i,"Accept"),sZ(i,"Content-Type");var r,o=i&&i["Content-Type"]||"",l=o.indexOf("application/json")>-1,d=ua.isObject(e);if(d&&ua.isHTMLForm(e)&&(e=new FormData(e)),ua.isFormData(e))return l?JSON.stringify(v3e(e)):e;if(ua.isArrayBuffer(e)||ua.isBuffer(e)||ua.isStream(e)||ua.isFile(e)||ua.isBlob(e))return e;if(ua.isArrayBufferView(e))return e.buffer;if(ua.isURLSearchParams(e))return b3e(i,"application/x-www-form-urlencoded;charset=utf-8"),e.toString();if(d){if(o.indexOf("application/x-www-form-urlencoded")!==-1)return A$t(e,this.formSerializer).toString();if((r=ua.isFileList(e))||o.indexOf("multipart/form-data")>-1){var h=this.env&&this.env.FormData;return oZ(r?{"files[]":e}:e,h&&new h,this.formSerializer)}}return d||l?(b3e(i,"application/json"),z$t(e)):e}],transformResponse:[function(e){var i=this.transitional||dZ.transitional,r=i&&i.forcedJSONParsing,o=this.responseType==="json";if(e&&ua.isString(e)&&(r&&!this.responseType||o)){var l=!(i&&i.silentJSONParsing)&&o;try{return JSON.parse(e)}catch(d){if(l)throw d.name==="SyntaxError"?Tu.from(d,Tu.ERR_BAD_RESPONSE,this,null,this.response):d}}return e}],timeout:0,xsrfCookieName:"XSRF-TOKEN",xsrfHeaderName:"X-XSRF-TOKEN",maxContentLength:-1,maxBodyLength:-1,env:{FormData:lZ.classes.FormData,Blob:lZ.classes.Blob},validateStatus:function(e){return e>=200&&e<300},headers:{common:{Accept:"application/json, text/plain, */*"}}};ua.forEach(["delete","get","head"],function(e){dZ.headers[e]={}}),ua.forEach(["post","put","patch"],function(e){dZ.headers[e]=ua.merge(F$t)});var sge=dZ,lge=function(e,i,r,o){var l=this||sge;return ua.forEach(o,function(h){e=h.call(l,e,i,r)}),e},T3e=function(e){return!(!e||!e.__CANCEL__)};function cge(t){if(t.cancelToken&&t.cancelToken.throwIfRequested(),t.signal&&t.signal.aborted)throw new cZ}var C3e=function(e){return cge(e),e.headers=e.headers||{},e.data=lge.call(e,e.data,e.headers,null,e.transformRequest),sZ(e.headers,"Accept"),sZ(e.headers,"Content-Type"),e.headers=ua.merge(e.headers.common||{},e.headers[e.method]||{},e.headers),ua.forEach(["delete","get","head","post","put","patch","common"],function(r){delete e.headers[r]}),(e.adapter||sge.adapter)(e).then(function(r){return cge(e),r.data=lge.call(e,r.data,r.headers,r.status,e.transformResponse),r},function(r){return T3e(r)||(cge(e),r&&r.response&&(r.response.data=lge.call(e,r.response.data,r.response.headers,r.response.status,e.transformResponse))),Promise.reject(r)})},o8=function(e,i){i=i||{};var r={};function o(f,y){return ua.isPlainObject(f)&&ua.isPlainObject(y)?ua.merge(f,y):ua.isEmptyObject(y)?ua.merge({},f):ua.isPlainObject(y)?ua.merge({},y):ua.isArray(y)?y.slice():y}function l(f){return ua.isUndefined(i[f])?ua.isUndefined(e[f])?void 0:o(void 0,e[f]):o(e[f],i[f])}function d(f){if(!ua.isUndefined(i[f]))return o(void 0,i[f])}function h(f){return ua.isUndefined(i[f])?ua.isUndefined(e[f])?void 0:o(void 0,e[f]):o(void 0,i[f])}function p(f){return f in i?o(e[f],i[f]):f in e?o(void 0,e[f]):void 0}var g={url:d,method:d,data:d,baseURL:h,transformRequest:h,transformResponse:h,paramsSerializer:h,timeout:h,timeoutMessage:h,withCredentials:h,withXSRFToken:h,adapter:h,responseType:h,xsrfCookieName:h,xsrfHeaderName:h,onUploadProgress:h,onDownloadProgress:h,decompress:h,maxContentLength:h,maxBodyLength:h,beforeRedirect:h,transport:h,httpAgent:h,httpsAgent:h,cancelToken:h,socketPath:h,responseEncoding:h,validateStatus:p};return ua.forEach(Object.keys(e).concat(Object.keys(i)),function(y){var T=g[y]||l,C=T(y);ua.isUndefined(C)&&T!==p||(r[y]=C)}),r},_3e={version:"0.28.1"},V$t=_3e.version,dge={};["object","boolean","number","function","string","symbol"].forEach(function(t,e){dge[t]=function(r){return typeof r===t||"a"+(e<1?"n ":" ")+t}});var E3e={};function $$t(t,e,i){if(typeof t!="object")throw new Tu("options must be an object",Tu.ERR_BAD_OPTION_VALUE);for(var r=Object.keys(t),o=r.length;o-- >0;){var l=r[o],d=e[l];if(d){var h=t[l],p=h===void 0||d(h,l,t);if(p!==!0)throw new Tu("option "+l+" must be "+p,Tu.ERR_BAD_OPTION_VALUE)}else if(i!==!0)throw new Tu("Unknown option "+l,Tu.ERR_BAD_OPTION)}}dge.transitional=function(e,i,r){function o(l,d){return"[Axios v"+V$t+"] Transitional option '"+l+"'"+d+(r?". "+r:"")}return function(l,d,h){if(e===!1)throw new Tu(o(d," has been removed"+(i?" in "+i:"")),Tu.ERR_DEPRECATED);return i&&!E3e[d]&&(E3e[d]=!0,console.warn(o(d," has been deprecated since v"+i+" and will be removed in the near future"))),!e||e(l,d,h)}};var uge={assertOptions:$$t,validators:dge},NO=uge.validators;function a4(t){this.defaults=t,this.interceptors={request:new m3e,response:new m3e}}a4.prototype.request=function(e,i){typeof e=="string"?(i=i||{}).url=e:i=e||{},(i=o8(this.defaults,i)).method?i.method=i.method.toLowerCase():this.defaults.method?i.method=this.defaults.method.toLowerCase():i.method="get";var r=i.transitional;r!==void 0&&uge.assertOptions(r,{silentJSONParsing:NO.transitional(NO.boolean),forcedJSONParsing:NO.transitional(NO.boolean),clarifyTimeoutError:NO.transitional(NO.boolean)},!1);var o=i.paramsSerializer;o!==void 0&&uge.assertOptions(o,{encode:NO.function,serialize:NO.function},!0),ua.isFunction(o)&&(i.paramsSerializer={serialize:o});var l=[],d=!0;this.interceptors.request.forEach(function(E){typeof E.runWhen=="function"&&E.runWhen(i)===!1||(d=d&&E.synchronous,l.unshift(E.fulfilled,E.rejected))});var h,p=[];if(this.interceptors.response.forEach(function(E){p.push(E.fulfilled,E.rejected)}),!d){var g=[C3e,void 0];for(Array.prototype.unshift.apply(g,l),g=g.concat(p),h=Promise.resolve(i);g.length;)h=h.then(g.shift(),g.shift());return h}for(var f=i;l.length;){var y=l.shift(),T=l.shift();try{f=y(f)}catch(C){T(C);break}}try{h=C3e(f)}catch(C){return Promise.reject(C)}for(;p.length;)h=h.then(p.shift(),p.shift());return h},a4.prototype.getUri=function(e){e=o8(this.defaults,e);var i=y3e(e.baseURL,e.url);return g3e(i,e.params,e.paramsSerializer)},ua.forEach(["delete","get","head","options"],function(e){a4.prototype[e]=function(i,r){return this.request(o8(r||{},{method:e,url:i,data:(r||{}).data}))}}),ua.forEach(["post","put","patch"],function(e){function i(r){return function(l,d,h){return this.request(o8(h||{},{method:e,headers:r?{"Content-Type":"multipart/form-data"}:{},url:l,data:d}))}}a4.prototype[e]=i(),a4.prototype[e+"Form"]=i(!0)});var uZ=a4;function r4(t){if(typeof t!="function")throw new TypeError("executor must be a function.");var e;this.promise=new Promise(function(o){e=o});var i=this;this.promise.then(function(r){if(i._listeners){for(var o=i._listeners.length;o-- >0;)i._listeners[o](r);i._listeners=null}}),this.promise.then=function(r){var o,l=new Promise(function(d){i.subscribe(d),o=d}).then(r);return l.cancel=function(){i.unsubscribe(o)},l},t(function(o,l,d){i.reason||(i.reason=new cZ(o,l,d),e(i.reason))})}r4.prototype.throwIfRequested=function(){if(this.reason)throw this.reason},r4.prototype.subscribe=function(e){this.reason?e(this.reason):this._listeners?this._listeners.push(e):this._listeners=[e]},r4.prototype.unsubscribe=function(e){if(this._listeners){var i=this._listeners.indexOf(e);i!==-1&&this._listeners.splice(i,1)}},r4.source=function(){var e;return{token:new r4(function(r){e=r}),cancel:e}};var H$t=r4,j$t=function(e){return function(r){return e.apply(null,r)}},G$t=function(e){return ua.isObject(e)&&e.isAxiosError===!0};function A3e(t){var e=new uZ(t),i=i3e(uZ.prototype.request,e);return ua.extend(i,uZ.prototype,e),ua.extend(i,e),i.create=function(o){return A3e(o8(t,o))},i}var rb=A3e(sge);rb.Axios=uZ,rb.CanceledError=cZ,rb.CancelToken=H$t,rb.isCancel=T3e,rb.VERSION=_3e.version,rb.toFormData=oZ,rb.AxiosError=Tu,rb.Cancel=rb.CanceledError,rb.all=function(e){return Promise.all(e)},rb.spread=j$t,rb.isAxiosError=G$t,rb.formToJSON=function(t){return v3e(ua.isHTMLForm(t)?new FormData(t):t)};var I3e=rb,q$t=rb;I3e.default=q$t;var JB=I3e;class W$t{constructor(e,i){this.logger=e,this.proxy=i}async sendRequestWithRetry(e,i,r,o,l,d=1,h){if(d>l)throw new Error("Max retry reached");o.timeout||(o.timeout=2e4),o.maxRedirects=0,this.proxy&&(i=this.proxy.proxyfyUrl(i));try{switch(e){case"post":default:return await JB.post(i,r,o);case"get":return await JB.get(i,o);case"put":return await JB.put(i,r,o);case"delete":return await JB.delete(i,o)}}catch(p){let g=p?.response?.status;this.logger.error(`Found error for request ${e} ${i} ${g||""}`);const f=d+1;if(f<=l){let y=i;if(p&&p.response){if(p.response.status===301||p.response.status===302||p.response.status===303||p.response.status===307||p.response.status===404)y=p.response.headers&&p.response.headers.location?p.response.headers.location:y;else if(p.response.status<500)throw p}return this.logger.error(`Retrying, attempt #${f} url=${y}`),await new Promise(T=>setTimeout(T,h)),this.sendRequestWithRetry(e,y,r,o,l,f,h)}throw p}}}const hZ={callNotification:"callNotification",conversationInvitation:"conversationInvitation",debugContent:"debugContent",groupContext:"groupContext"};class K$t{get callId(){return this._callId}get localParticipantId(){return this._localParticipantId}constructor(e,i,r){if(this._callId="",this._localParticipantId="",this._logger=r.createChild("IncomingCallPushNotificationHandler"),!e.incomingCallContext)throw new Oe({defaultError:we.CALL_AGENT.INCOMING_PUSH_NOTIFICATION_INVALID_PAYLOAD_NO_CONTEXT_PROVIDED});if(Object.keys(e).length>1)throw new Oe({defaultError:we.CALL_AGENT.INCOMING_PUSH_NOTIFICATION_PAYLOAD_TOO_MANY_KEYS});if(this._payload=e,this._incomingCallContext=this._payload.incomingCallContext,this._tsCallRegistry=i,this._gp=JSON.parse(w6.inflate(atob(this._incomingCallContext),{to:"string"})),!(this._gp.hasOwnProperty(hZ.callNotification)&&this._gp.hasOwnProperty(hZ.conversationInvitation)&&this._gp.hasOwnProperty(hZ.debugContent)&&this._gp.hasOwnProperty(hZ.groupContext)))throw this._logger.error(`Missing incoming call context data. Found: ${Object.keys(this._gp)}`),new Oe({defaultError:we.CALL_AGENT.INCOMING_PUSH_NOTIFICATION_INVALID_PAYLOAD});this._callId=this._gp.debugContent.callId,this._localParticipantId=this._gp.debugContent.participantId}async process(){try{if(this._tsCallRegistry.calls.some(o=>o.callId==this._callId))throw new Oe({defaultError:we.CALL_AGENT.INCOMING_PUSH_NOTIFICATION_ALREADY_PROCESSED});const e=ug(),i=o=>{const l=()=>{o.callId===this._callId&&o.participantId===this._localParticipantId&&o.state===1&&e.resolve()};this._tsCallStateSub=o.on("callStateChanged",l),l()};this._tsCallRegistrySub=this._tsCallRegistry.on("callAdded",i);const r={eventId:pxt,body:{gp:this._gp}};if(!this._tsCallRegistry.incomingCallMessageHandler.handleMessage(r))throw new Oe({defaultError:we.CALL_AGENT.INCOMING_PUSH_NOTIFICATION_FAILED_TO_PROCESS});setTimeout(()=>{e.isPending()&&e.reject(new Oe({defaultError:we.CALL_AGENT.INCOMING_PUSH_NOTIFICATION_CALL_MISSED}))},5e3),await e.promise}catch(e){throw e}finally{this._tsCallRegistrySub?.dispose(),this._tsCallStateSub?.dispose()}}}const s8=0,J$t=220004,Y$t=220005,Q$t=220006,Z$t=220007;class X$t{constructor(e){this._httpRequestHelper=e,this._isPolicyFetchApplicable=!1,this._policySettingData={},this._threadIdData={};const i=zf("ACS");this._logger=new rh(i)}initialize(e){this._localParticipant=e.localParticipant,this._jwtTokenProvider=e.jwtTokenProvider,this._telemetryLogManager=e.telemetryLogManager}userDialedNumber(e){this._userDialedPstnNumber=e,this._emergencyNumber=this._userDialedPstnNumber}async CreateChatThreadId(e,i){this._callId=e;const r=+new Date,o=i?.createThreadIdSuffix??wt().MiddleTier.serverManagedThreadIdApiConfiguration.createThreadSuffix;this.sendMiddleTierApiEvent({eventName:vi.acs_calling_middletier_gateway_api,suffix:o,kindOfEvent:Je.attempt});const l=await this.getAcsMiddletierServiceRequestHeaderForThreadApi(),d=new URL(o,wt().MiddleTier.baseServiceUrl);i?.participants.push({id:this._localParticipant});const h={Participants:i?.participants};try{const p=await this._httpRequestHelper.sendRequestWithRetry("post",d.toString(),h,{headers:l},wt().MiddleTier.maxRetry);return this._logger.info("Successfully created chat thread using ACS MiddleTier Service."),this._threadIdData=p?.data,this.sendMiddleTierApiEvent({eventName:vi.acs_calling_middletier_gateway_api,suffix:o,kindOfEvent:Je.success,timestampInfo:{deltaTimeInMs:new Date().getTime()-r},additionalDetails:{phrase:"Thread Id was successfully created from ACS MiddleTier Service",code:s8,subCode:Q$t}}),Promise.resolve(this._threadIdData.threadId)}catch{this._logger.error("Error creating thread Id from ACS MiddleTier Service");const g=new Oe({defaultError:we.CTE_MID_TIER_POLICY_SERVICE.CREATETHREAD_FAILED});throw this.sendMiddleTierApiEvent({eventName:vi.acs_calling_middletier_gateway_api,suffix:o,kindOfEvent:Je.failure,timestampInfo:{deltaTimeInMs:new Date().getTime()-r},additionalDetails:{failureReason:g.message,code:g.code,subCode:g.subCode,...an(g)}}),g}}async AddParticipantsToThread(e,i){this._callId=e;const r=+new Date,o=i?.addParticipantsSuffix??wt().MiddleTier.serverManagedThreadIdApiConfiguration.addParticipantSuffix;this.sendMiddleTierApiEvent({eventName:vi.acs_calling_middletier_gateway_api,suffix:o,kindOfEvent:Je.attempt});const l=await this.getAcsMiddletierServiceRequestHeaderForThreadApi(),d=new URL(o,wt().MiddleTier.baseServiceUrl),h={threadId:i?.threadId,Participants:i?.participants};try{const p=await this._httpRequestHelper.sendRequestWithRetry("post",d.toString(),h,{headers:l},wt().MiddleTier.maxRetry);this._logger.info("Call to add participants to chat thread using ACS MiddleTier Service");const g=p?.data;if(g!==null){if(!g.isSuccess)throw new Oe({defaultError:we.CTE_MID_TIER_POLICY_SERVICE.ADD_PARTICIPANTS_TO_THREAD_FAILED});g.multipleStatus.length>0&&g.multipleStatus[0].statusCode==735&&this._logger.info("Trying to add the same participant to the thread id")}return this.sendMiddleTierApiEvent({eventName:vi.acs_calling_middletier_gateway_api,suffix:o,kindOfEvent:Je.success,timestampInfo:{deltaTimeInMs:new Date().getTime()-r},additionalDetails:{phrase:"Successfully add participants from ACS MiddleTier Service",code:s8,subCode:Z$t}}),Promise.resolve(g.isSuccess)}catch{this._logger.error("Fail to add participant error from ACS MiddleTier Service");const g=new Oe({defaultError:we.CTE_MID_TIER_POLICY_SERVICE.ADD_PARTICIPANTS_TO_THREAD_FAILED});throw this.sendMiddleTierApiEvent({eventName:vi.acs_calling_middletier_gateway_api,suffix:o,kindOfEvent:Je.failure,timestampInfo:{deltaTimeInMs:new Date().getTime()-r},additionalDetails:{failureReason:g.message,code:g.code,subCode:g.subCode,...an(g)}}),g}}async fetchUserPoliciesFromAcsMiddleTier(e,i,r){this._policySettingData=await this.requestUserPoliciesFromAcsMiddleTier(e,i,r)}async requestUserPoliciesFromAcsMiddleTier(e,i,r,o){this._callId=e;const l=+new Date;if(this.sendMiddleTierPolicyEvent({eventName:vi.acs_calling_middletier_gateway_fetch_policy,kindOfEvent:Je.attempt},i),!i){const g=new Oe({defaultError:we.CTE_MID_TIER_POLICY_SERVICE.TEAMS_USER_ID_NOT_PROVIDED});throw this.sendMiddleTierPolicyEvent({eventName:vi.acs_calling_middletier_gateway_fetch_policy,kindOfEvent:Je.failure,timestampInfo:{deltaTimeInMs:new Date().getTime()-l},additionalDetails:{failureReason:g.message,code:g.code,subCode:g.subCode,...an(g)}}),g}let d,h={};r?(d=new URL(r.policyUrlSuffix,wt().MiddleTier.baseServiceUrl),h={id:i,userPolicies:r.userPolicies,userProperties:r.userProperties}):(d=new URL(wt().MiddleTier.policyUrlSuffix,wt().MiddleTier.baseServiceUrl),h={id:i});const p=await this.getAcsMiddletierServiceRequestHeaderForThreadApi(o);try{const g=await this._httpRequestHelper.sendRequestWithRetry("post",d.toString(),h,{headers:p},wt().MiddleTier.maxRetry);return this.sendMiddleTierPolicyEvent({eventName:vi.acs_calling_middletier_gateway_fetch_policy,kindOfEvent:Je.success,timestampInfo:{deltaTimeInMs:new Date().getTime()-l},additionalDetails:{phrase:"Teams user policy was fetched successfully from ACS MiddleTier Service",code:s8,subCode:J$t}},i),g?.data}catch(g){const f=h2t(g,we.CTE_MID_TIER_POLICY_SERVICE.FETCH_POLICY);throw this._logger.error(f.message),this.sendMiddleTierPolicyEvent({eventName:vi.acs_calling_middletier_gateway_fetch_policy,kindOfEvent:Je.failure,timestampInfo:{deltaTimeInMs:new Date().getTime()-l},additionalDetails:{failureReason:f.message,code:f.code,subCode:f.subCode,...an(f)}},i),f}}isEvEnabled(){return this._policySettingData?.userAggregatedPolicySettingData?.userProperties?.evEnabled||!1}isMoHEnabled(){const e=this._policySettingData?.userAggregatedPolicySettingData?.userPolicies?.teamsCallingPolicy,i=e?.musicOnHoldEnabledType;return this._logger.info("Checking Music on Hold Policy, Enabled Type is: "+i),i===(eQ.Enabled||eQ.UserOverride)}isBreakoutRoomsAllowed(){let i=this._policySettingData?.userAggregatedPolicySettingData?.userPolicies?.teamsMeetingPolicy?.allowBreakoutRooms;return this._logger.info("Allow Breakout rooms from Teams meeting policy is "+i),i==null&&(i=!0),i}isIPAudioAllowed(){if(!wt().calling.mediaAccess.ipMediaPolicyEnabled)return this._logger.info("Allow IP audio is true as feature flag ipAudioVideoPolicyEnabled is false"),!0;const e=this._policySettingData?.userAggregatedPolicySettingData?.userPolicies?.teamsMeetingPolicy,i=e?.ipAudioMode!==tQ.Disabled;return this._logger.info("Allow IP audio from Teams meeting policy is "+i),i}isIPVideoAllowed(){if(!wt().calling.mediaAccess.ipMediaPolicyEnabled)return this._logger.info("Allow IP video is true as feature flag ipAudioVideoPolicyEnabled is false"),!0;const e=this._policySettingData?.userAggregatedPolicySettingData?.userPolicies?.teamsMeetingPolicy,i=e?.ipVideoMode!==tQ.Disabled;return this._logger.info("Allow IP video from Teams meeting policy is "+i),i}getTeamsUserCaptionsPoliciesData(){const e=+new Date;let i="";this.sendMiddleTierPolicyEvent({eventName:vi.acs_calling_middletier_gateway_fetch_user_policies_for_captions,kindOfEvent:Je.attempt});const r=this._policySettingData.userAggregatedPolicySettingData,o=r?.userPolicies,l=r?.userProperties;if(!o?.teamsCallingPolicy){const d=new Oe({defaultError:we.CTE_MID_TIER_POLICY_SERVICE.TEAMSUSER_CALLINGPOLICY_FETCHING_FAILED});this.sendMiddleTierPolicyEvent({eventName:vi.acs_calling_middletier_gateway_fetch_user_policies_for_captions,kindOfEvent:Je.failure,timestampInfo:{deltaTimeInMs:new Date().getTime()-e},additionalDetails:{failureReason:d.message,code:d.code,subCode:d.subCode,...an(d)}})}if(!o?.teamsMeetingPolicy){const d=new Oe({defaultError:we.CTE_MID_TIER_POLICY_SERVICE.TEAMSUSER_MEETINGPOLICY_FETCHING_FAILED});this.sendMiddleTierPolicyEvent({eventName:vi.acs_calling_middletier_gateway_fetch_user_policies_for_captions,kindOfEvent:Je.failure,timestampInfo:{deltaTimeInMs:new Date().getTime()-e},additionalDetails:{failureReason:d.message,code:d.code,subCode:d.subCode,...an(d)}})}if(!l?.featureTypes){const d=new Oe({defaultError:we.CTE_MID_TIER_POLICY_SERVICE.TEAMSUSER_FEATURETYPE_TEAMSPROMGMT_FETCHING_FAILED});this.sendMiddleTierPolicyEvent({eventName:vi.acs_calling_middletier_gateway_fetch_user_policies_for_captions,kindOfEvent:Je.failure,timestampInfo:{deltaTimeInMs:new Date().getTime()-e},additionalDetails:{failureReason:d.message,code:d.code,subCode:d.subCode,...an(d)}})}return(o?.teamsCallingPolicy||o?.teamsMeetingPolicy||l?.featureTypes?.includes(l6.TeamsProMgmt))&&(i=JSON.stringify({isLiveCaptionsEnabledForCalling:o?.teamsCallingPolicy?.liveCaptionsEnabledTypeForCalling===JY.DisabledUserOverride,isLiveCaptionsEnabledForMeeting:o?.teamsMeetingPolicy?.liveCaptionsEnabledType===JY.DisabledUserOverride,isTeamsProMgmtSkuAvailable:l?.featureTypes?.includes(l6.TeamsProMgmt)??!1}),this.sendMiddleTierPolicyEvent({eventName:vi.acs_calling_middletier_gateway_fetch_user_policies_for_captions,kindOfEvent:Je.success,timestampInfo:{deltaTimeInMs:new Date().getTime()-e},additionalDetails:{phrase:"Fetching Captions policy from ACS MiddleTier Service response was successful",code:s8}}),this._logger.info(`Fetching user's captions policy content = ${i}`)),i}getEmergencyContent(){const e=+new Date;this.sendMiddleTierPolicyEvent({eventName:vi.acs_calling_middletier_gateway_emergency_content,kindOfEvent:Je.attempt});let i="";try{const r=this._policySettingData.userAggregatedPolicySettingData,o=r?.userPolicies;let l=!1,d="";if(o?.locationPolicy?.emergencyNumbers){const p=o.locationPolicy.emergencyNumbers||[];this.isPhoneNumberInLocationPolicy(p)&&(l=!0,i=JSON.stringify({enableSecurityMemberNotifications:this.isSecurityDeskEnabled(),callerLocation:r?.userProperties.region,locationPolicyTag:o?.locationPolicy?.policyDocument,teamsEmergencyCallingPolicyTag:o?.teamsEmergencyCallingPolicy?.policyDocument}),d="LocationPolicy")}if(!l&&o?.teamsEmergencyCallRoutingPolicy){const p=o?.teamsEmergencyCallRoutingPolicy?.emergencyNumbers||[];this.isPhoneNumberInTeamsEmergenencyRoutingPolicy(p)&&(l=!0,i=JSON.stringify({enableSecurityMemberNotifications:this.isSecurityDeskEnabled(),callerLocation:r?.userProperties.region,teamsEmergencyCallRoutingPolicyTag:o?.teamsEmergencyCallRoutingPolicy?.policyDocument,teamsEmergencyCallingPolicyTag:o?.teamsEmergencyCallingPolicy?.policyDocument}),d="TeamsEmergencyCallingRoutingPolicy")}const h=l?`Created Emergency policy using ${d}`:"This is NOT an emergency call";return this.sendMiddleTierPolicyEvent({eventName:vi.acs_calling_middletier_gateway_emergency_content,kindOfEvent:Je.success,timestampInfo:{deltaTimeInMs:new Date().getTime()-e},additionalDetails:{phrase:"Deriving Emergency policy from ACS MiddleTier Service response was successful",code:s8,subCode:Y$t}}),this._logger.info(`Deriving emergency policy message = ${h}. Emergency Content = ${i}`),i}catch(r){const o=new Oe({defaultError:we.CTE_MID_TIER_POLICY_SERVICE.DERIVE_EMERGENCY_POLICY,originalError:r});throw this.sendMiddleTierPolicyEvent({eventName:vi.acs_calling_middletier_gateway_emergency_content,kindOfEvent:Je.failure,timestampInfo:{deltaTimeInMs:new Date().getTime()-e},additionalDetails:{failureReason:o.message,code:o.code,subCode:o.subCode,...an(o)}}),o}}isFetchUserPoliciesAndSettingsApplicable(e,i){return vO(e)||vO(i)||(this._isPolicyFetchApplicable=this.verifyFetchUserPoliciesSettings(e,i)),this._isPolicyFetchApplicable}getEmergencyNumber(){return this._emergencyNumber}getUserDialedPstnNumber(){return this._userDialedPstnNumber}getUserPolicy(){return this._policySettingData.userAggregatedPolicySettingData?.userPolicies}getUserProperties(){return this._policySettingData.userAggregatedPolicySettingData?.userProperties}isPhoneNumberInLocationPolicy(e){if(!vO(e)){for(const i of e)if(i.dialString===this._userDialedPstnNumber||!vO(i.dialMask?.split(";").find(r=>r===this._userDialedPstnNumber)))return this._emergencyNumber=i.dialString,!0}return!1}isPhoneNumberInTeamsEmergenencyRoutingPolicy(e){if(!vO(e)){for(const i of e)if(i.emergencyDialString===this._userDialedPstnNumber||!vO(i.emergencyDialMask?.split(";").find(r=>r===this._userDialedPstnNumber)))return this._emergencyNumber=i.emergencyDialString,!0}return!1}verifyFetchUserPoliciesSettings(e,i){const r=wt().MiddleTier;return r.enabled?r.userPolicySettingsApi?e?Array.isArray(i)&&(i.length>1||!Vf(i[0]))?(this._logger.info("Target particpant (Callee) is not a PSTN Number"),!1):Array.isArray(i)||Vf(i)?(this._logger.info("Teams user is eligible to fetch policies and settings from MiddleTier Service "),!0):(this._logger.info("Target particpant (Callee) is not a PSTN Number"),!1):(this._logger.info("Originator (Caller) is not a Teams User"),!1):(this._logger.info("ACS MiddleTier Policy API is disabled"),r.userPolicySettingsApi):(this._logger.info("ACS MiddleTier service is disabled"),r.enabled)}isSecurityDeskEnabled(){const e=this._policySettingData.userAggregatedPolicySettingData?.userPolicies?.teamsEmergencyCallingPolicy;return!(vO(e?.notificationGroup)&&vO(e?.notificationDialOutNumber)||e?.notificationGroup?.trim().length==0&&e?.notificationDialOutNumber?.trim().length==0)}async getAcsMiddletierServiceRequestHeader(){return{"Content-Type":"application/json","X-Skypetoken":this._jwtTokenProvider?await this._jwtTokenProvider():"","Access-Control-Allow-Origin":"*","X-Microsoft-Skype-Chain-ID":this._callId}}async getAcsMiddletierServiceRequestHeaderForThreadApi(e){let i={};return i=await this.getAcsMiddletierServiceRequestHeader(),i.onbehalfOfUser=e??this._localParticipant,i}sendMiddleTierPolicyEvent(e,i){try{this.setDefaultEventData(e,i),this._telemetryLogManager?.sendEvent({name:e.eventName,tenant:Wr,properties:e})}catch{this._logger.debug("Unable to send AcsMiddleTierPolicyService telemetry")}}sendMiddleTierApiEvent(e){try{this.setDefaultEventData(e),this._telemetryLogManager?.sendEvent({name:e.eventName,tenant:Wr,properties:e})}catch{this._logger.debug("Unable to send MiddleTier Api telemetry")}}setDefaultEventData(e,i){e.callId=this._callId,e.localParticipantId=this._localParticipant,e.requestedParticipantMRI=i??this._localParticipant,e.timestampInfo=e.timestampInfo??"",e.additionalDetails=e.additionalDetails??""}}class eHt{constructor(e){this._logger=e}get gpu(){const e={};try{const i=document.createElement("canvas"),r=i.getContext("webgl")||i.getContext("experimental-webgl");if(r){const o=r.getExtension("WEBGL_debug_renderer_info");o?(e.vendor=r.getParameter(o.UNMASKED_VENDOR_WEBGL),e.renderer=r.getParameter(o.UNMASKED_RENDERER_WEBGL)):this._logger?.info("Unable to get GPU info: debug renderer info is not supported")}else this._logger?.info("Unable to get GPU info: WebGL is not supported")}catch(i){this._logger?.info(`Unable to get GPU info: ${i}`)}return e}get hardwareConcurrency(){return navigator.hardwareConcurrency}}var o4;(function(t){t.deviceSelection="deviceSelection",t.handleIncomingCall="handleIncomingCall"})(o4||(o4={}));var w3e,pZ=function(t,e,i,r){var o,l=arguments.length,d=l<3?e:r===null?r=Object.getOwnPropertyDescriptor(e,i):r;if(typeof Reflect=="object"&&typeof Reflect.decorate=="function")d=Reflect.decorate(t,e,i,r);else for(var h=t.length-1;h>=0;h--)(o=t[h])&&(d=(l<3?o(d):l>3?o(e,i,d):o(e,i))||d);return l>3&&d&&Object.defineProperty(e,i,d),d},Ak=function(t,e){if(typeof Reflect=="object"&&typeof Reflect.metadata=="function")return Reflect.metadata(t,e)};let tHt=1;class s4{get kind(){return this._kind}get connectionState(){return this._connectionState}constructor(e,i,r,o,l,d,h){this._callClient=e,this._pushHandlingDeltaTimeInMs=new Map,this._disposed=!1,this.tokenProvider=async g=>{const f=+new Date;let y;try{if(this.sendTokenChangedEvent({kindOfEvent:"attempt",timestampInfo:{attemptTimestamp:f},oldTokenExpiration:this._oldTokenExpiration}),!this._communicationTokenCredential)throw new Oe({defaultError:we.CALL_AGENT.GET_TOKEN_BEFORE_INIT});y=await R3(this._communicationTokenCredential,wt().calling.eudb.isRgnClaimEnabledForACS,{abortSignal:this._abortController.signal}),y.acsResourceId===this._parsedTokenCredential?.acsResourceId&&y.identityMri===this._parsedTokenCredential?.identityMri||oP(we.CALL_AGENT.REFRESHED_TOKEN_INVALID_USERID,this.logger),g?this._tokenFetchTries+=1:this._tokenFetchTries=0,this._tokenFetchTries>this._maxNmberOfRetries&&(this.updateConnectionState("invalidToken"),this._disposed||await this.dispose(),oP(we.CALL_AGENT.REFRESHED_TOKEN_RETRIES,this.logger));const T=+new Date;return this.sendTokenChangedEvent({kindOfEvent:"success",timestampInfo:{deltaTimeInMs:T-f},oldTokenExpiration:this._oldTokenExpiration,newTokenExpiration:y.exp,isTokenChanged:this._oldToken!==y.jwtToken}),this._oldToken=y.jwtToken,this._oldTokenExpiration=y.exp,y.jwtToken}catch(T){const C={kindOfEvent:"failure",timestampInfo:{deltaTimeInMs:+new Date-f},oldTokenExpiration:this._oldTokenExpiration};throw y&&(C.newTokenExpiration=y.exp,C.isTokenChanged=this._oldToken!==y.jwtToken,this._oldToken=y.jwtToken,this._oldTokenExpiration=y.exp),this.sendTokenChangedEvent(C,T),T}},this.sendTokenChangedEvent=(g,f)=>{try{let y={kindOfEvent:g.kindOfEvent,timestampInfo:g.timestampInfo,oldTokenExpiration:g.oldTokenExpiration};g.newTokenExpiration!==void 0&&(y.newTokenExpiration=g.newTokenExpiration),g.isTokenChanged!==void 0&&(y.isTokenChanged=g.isTokenChanged),f&&(y={...y,...an(f)}),this._telemetryLogManager.sendEvent({name:vi.acs_calling_token_expiration_changed,tenant:Wr,properties:y})}catch{this.logger.debug("Unable to send token change telemetry")}},this.pushHandlingStarted=g=>{const f=ln();this._pushHandlingDeltaTimeInMs.set(g,{correlationId:f,timestamp:+new Date}),this.logger.log("Incoming call state started",g),wo.setCauseIdToNetworkInfo(g),this.sendIncomingNotificationEvent({eventName:vi.acs_calling_client_operations,operation:o4.handleIncomingCall,networkInfo:[],kindOfEvent:"attempt",timestampInfo:{deltaTimeInMs:void 0},correlationId:f,additionalDetails:{},callId:"",participantId:""})},this.pushHandlingEnded=(g,f)=>{const y=f?.code!==void 0&&[0,200].includes(f?.code),T=w=>{if(y)return new Oe({defaultError:{code:w?.code??0,subCode:w?.subCode??0,message:"Success",resultCategories:["Success"]}});const D=[we.CALL_AGENT_RTC.INCOMING_CALL_HANDLING_INVALID_NOTIFICATION_PAYLOAD,we.CALL_AGENT_RTC.INCOMING_CALL_HANDLING_FAILED_TO_EXTRACT_PAYLOAD,we.CALL_AGENT_RTC.INCOMING_CALL_HANDLING_CALL_ALREADY_HANDLED,we.CALL_AGENT_RTC.INCOMING_CALL_HANDLING_IGNORING_DUPLICATE_NOTIFICATION,we.CALL_AGENT_RTC.INCOMING_CALL_HANDLING_FAILED_TO_HANDLE_NOTIFICATION_FOR_GROUPID_CALL,we.CALL_AGENT_RTC.INCOMING_CALL_HANDLING_BAD_NOTIFICATION_PAYLOAD,we.CALL_AGENT_RTC.INCOMING_CALL_HANDLING_CALL_SETUP_SUCCEEDED,we.CALL_AGENT_RTC.INCOMING_CALL_HANDLING_CALL_SETUP_FAILED,we.CALL_AGENT_RTC.INCOMING_CALL_HANDLING_BAD_NOTIFICATION_EVENT_TYPE,we.CALL_AGENT_RTC.INCOMING_CALL_HANDLING_CALL_ALREADY_EXISTS,we.CALL_AGENT_RTC.INCOMING_CALL_HANDLING_CALL_FAILED_CANNOT_CONNECT,we.CALL_AGENT_RTC.INCOMING_CALL_HANDLING_CALL_FAILED_NO_SIGNALING,we.CALL_AGENT_RTC.INCOMING_CALL_HANDLING_CALL_FAILED_CONFLICT,we.CALL_AGENT_RTC.INCOMING_CALL_HANDLING_CALL_FAILED_PUSH_IGNORED,we.CALL_AGENT_RTC.INCOMING_CALL_HANDLING_CALL_FAILED_ANSWERED_ELSEWHERE,we.CALL_AGENT_RTC.INCOMING_CALL_HANDLING_CALL_FAILED_CALL_ALREADY_ENDED,we.CALL_AGENT_RTC.INCOMING_CALL_HANDLING_CALL_SETUP_IN_PROGRESS],F=dn.find(D,x=>x.subCode===w?.subCode)??we.CALL_AGENT.INVALID_PUSH_NOTIFICATION_DATA;return new Oe({defaultError:F})};this.logger.log("Incoming call state ended",g,f);const C=wo.getRemoveCauseIdToNetworkInfo(g),E=this._pushHandlingDeltaTimeInMs.get(g)?.correlationId||"unknown",I=T(f);this.sendIncomingNotificationEvent({eventName:vi.acs_calling_client_operations,operation:o4.handleIncomingCall,networkInfo:C||[],kindOfEvent:y?"success":"failure",timestampInfo:{deltaTimeInMs:this._pushHandlingDeltaTimeInMs.has(g)?+new Date-this._pushHandlingDeltaTimeInMs.get(g)?.timestamp:void 0},correlationId:E,additionalDetails:{...an(I)},callId:f.callId||"",participantId:f.participantId||""}),this._pushHandlingDeltaTimeInMs.delete(g),this._eventEmitter.emit("handleIncomingCall",{callId:f.callId||"",participantId:f.participantId||"",...dP({code:I.code,subCode:I.subCode,message:I.message,resultCategories:I.resultCategories})})},this.logger=i.createChild("CallAgent"+tHt++),this._telemetryLogManager=o,this._kind=d,this._connectionState="Disconnected",this._eventEmitter=new qf(this.logger),this._internalEventEmitter=new $c.EventEmitter,this.clientId=r,this._abortController=new AbortController,this._maxDisplayNameLength=wt()?.calling?.maxDisplayNameLength||hxt,this._oldToken="",this._oldTokenExpiration=0,this._tokenFetchTries=0,this._maxNmberOfRetries=wt()?.calling?.maxNumberOfTokenFetchRetries||axt,this._callStack=l,this.acsProxy=this._callClient.acsProxy,this.acsCustomRelayManager=this._callClient.acsCustomRelayManager,this._httpRequestHelper=new W$t(this.logger,this.acsProxy),this.mtPolicyService=new X$t(this._httpRequestHelper),this._parsedTokenCredential={jwtToken:"",acsResourceId:void 0,identityMri:"",cloudType:pl.Public,isCte:!1,region:"",rgnClaimExists:!1,exp:0},this._caConfigBag={clientId:"",acsResourceId:this._parsedTokenCredential.acsResourceId,identityMri:this._parsedTokenCredential.identityMri,cloudType:this._parsedTokenCredential.cloudType,identityType:this._parsedTokenCredential.isCte?gT.Enterprise:gT.Consumer,region:this._parsedTokenCredential.region,emergencyCountryCode:void 0,IsUserEmergencyCountryCode:!1},this.deviceManager=h,this._extensibleApi=new M6(this.logger,{callClient:this._callClient,callAgent:this},{tsStack:this.tsStack,callAgent:this,telemetryLogManager:this._telemetryLogManager});const p=Hpe(IO.CallAgentFeature);for(const g of p)g.activationOptions.activationEvent==="OnExtendedObjectConstructor"&&this.feature(g);this._trouterStateChangeCallback=g=>{this.logger.log(`Callback Trouter state changed to ${g}`),this.updateConnectionState("trouterChanged")},this._registrarStateChangeCallback=g=>{this.logger.log(`Callback Registrar state changed to ${g}`),this.updateConnectionState("registrarChanged")}}getHttpRequestHelper(){return this._httpRequestHelper}getTrouterState(){return this._callStack?this._callStack.getTrouterState():"Unknown"}onTrouterStateChanged(e){return this._callStack.onTrouterStateChanged(e)}offTrouterStateChanged(e){return this._callStack.offTrouterStateChanged(e)}onDisposed(e){this._internalEventEmitter.on("disposed",e)}getAcsResourceId(){return this._parsedTokenCredential?.acsResourceId||""}getUserMri(){return`8:${this._parsedTokenCredential?.identityMri}`||""}getUserPolicy(){return this._userPolicies}getUserProperties(){return this._userProperties}async initialize(e,i){const r=+new Date,o=new eHt(this.logger),l={gpu:o.gpu,hardwareConcurrency:o.hardwareConcurrency};try{if(this.sendCallAgentInitializiedEvent(vi.acs_calling_call_agent_init_attempt,{attemptTimestamp:r},l),this._communicationTokenCredential=e,this._parsedTokenCredential=await R3(e,wt().calling.eudb.isRgnClaimEnabledForACS,{abortSignal:this._abortController.signal}),this._kind!==zx.TeamsCallAgent||this._parsedTokenCredential.isCte?this._kind===zx.CallAgent&&this._parsedTokenCredential.isCte&&oP(we.CALL_AGENT.ACS_CALLAGENT_TOKEN_ONLY,this.logger):oP(we.CALL_AGENT.TEAMS_CALLAGENT_TOKEN_ONLY,this.logger),i?.displayName){if(this._parsedTokenCredential.isCte)throw new Oe({defaultError:we.CALL_AGENT.CTE_DISPLAY_NAME});if(i?.displayName.length>this._maxDisplayNameLength)throw new Oe({defaultError:we.CALL_AGENT.DISPLAY_NAME_TOO_LONG})}if(this._parsedTokenCredential.cloudType===pl.Public&&(!this._parsedTokenCredential.region||this._parsedTokenCredential.region==="")){try{const h=+new Date-r;this._telemetryLogManager.sendEvent({name:vi.acs_calling_token_has_no_data_location,tenant:Wr,properties:{deltaTimeInMs:h}})}catch{this.logger.debug("Unable to send token has no data location assigned")}this._parsedTokenCredential.region=this._parsedTokenCredential.rgnClaimExists?Mxe[0]:ohe[0],this.logger.info("Used default data location because token has no data location assigned")}this._caConfigBag={clientId:this.clientId,acsResourceId:this._parsedTokenCredential.acsResourceId,identityMri:this._parsedTokenCredential.identityMri,cloudType:this._parsedTokenCredential.cloudType,identityType:this._parsedTokenCredential.isCte?gT.Enterprise:gT.Consumer,emergencyCountryCode:i?.emergencyCallOptions?.countryCode,region:this._parsedTokenCredential.region,IsUserEmergencyCountryCode:!!i?.emergencyCallOptions?.countryCode},this.addToCallAgentsMap(this._parsedTokenCredential),this._disposed=!1;try{this.runningEnvironmentInfo=await this._callClient.getEnvironmentInfoInternal()}catch{this.logger.debug("Unable to get the running environment info")}if(this.tsStack=await this._callStack.initializeStackForUser(this.tokenProvider,this._caConfigBag),this._parsedTokenCredential.rgnClaimExists)try{await this.updateParsedTokenCredentials(e)}catch(h){this.logger.debug(`Failed to update parsed token credentials. Error message = ${h?.message||""}`)}await this.setUserPoliciesOnAgentInitialization(),this.isCteUser()&&(i={...i,displayName:this._userProperties?.displayName??void 0}),this._telemetryLogManager.initialize(this._caConfigBag),this._tsCallRegistry=await this.initializeCallRegistry(this.tsStack,i),this.registerConnectionStateEventHandlers();const d=+new Date;this.sendCallAgentInitializiedEvent(vi.acs_calling_call_agent_init_success,{deltaTimeInMs:d-r},l)}catch(d){this._caConfigBag&&!this._telemetryLogManager.isInitialized()&&this._telemetryLogManager.initialize(this._caConfigBag);const h=new Oe({defaultError:we.CALL_AGENT.INIT_FAIL,originalError:d});this.removeFromCallAgentsMap(this._parsedTokenCredential);const p=+new Date;throw this.sendCallAgentInitializiedEvent(vi.acs_calling_call_agent_init_failure,{deltaTimeInMs:p-r},l,h),this._telemetryLogManager.clearTelemetryLoggers(),h}}async setUserPoliciesOnAgentInitialization(){this.mtPolicyService.initialize({localParticipant:this.getUserMri(),jwtTokenProvider:this.tokenProvider,telemetryLogManager:this._telemetryLogManager})}isCteUser(){return this._parsedTokenCredential?.isCte!==void 0&&this._parsedTokenCredential?.isCte}getClientId(){return this.clientId}getCallByCallId(e,i){return i?this._tsCallRegistry.getCall(e,i):this._tsCallRegistry.calls.filter(r=>r.callId===e)?.[0]}async createTransferTargetCall(e){const i=fd(),r=ln(),o=ln(),l=await this._tsCallRegistry.createCallAsync({callId:r,localParticipantId:o,causeId:i,type:"ThreadId",threadId:""}),d=this.createNewCall(r,l);return this.addToCallArray(d),this.handleCallState(d),l.addParticipant(e.targetMri).catch(()=>{this.logger.error("Failed to add participant for transer call")}),$v(l)?await Promise.all(d.bindTsCall()):d.bindTsCall(),this._eventEmitter.emit("callsUpdated",{added:[d],removed:[]}),d}async subscribeCallWithoutModality(e){const i=fd(),r=await this._tsCallRegistry.createCallAsync({callId:e.callId,localParticipantId:e.participantId,causeId:i,type:"ThreadId",threadId:e.threadId,messageId:e.messageId}),o=this.createNewCall(e.callId,r),l={conversationUrl:e.meetingUrl,conversationId:e.callId},d={};return this.addToCallArray(o),this.handleCallState(o),r.joinCallWithoutCallModality(l,d,i).then(()=>{this.logger.info("Successfully joined call without modalities")}).catch(h=>{throw this.logger.error("Error while joining call without modalities",h),new Oe({defaultError:we.CALL_AGENT.INVALID_JOIN_LOCATOR,originalError:h})}),$v(r)?await Promise.all(o.bindTsCall()):o.bindTsCall(),o}getEcsConfigIds(){return this._callStack.getEcsConfigIds()}feature(e){return this._extensibleApi.getApiObjectInstance(e.callAgentApiCtor)}async handlePushNotification(e){const i=ln(),r=+new Date;let o;try{if(this.sendHandlePushNotificationEvent({eventName:vi.acs_calling_handle_push_notification,correlationId:i,featureName:"handlePushNotification",operationName:"handleIncomingCallPushNotification",callId:"",localParticipantId:"",kindOfEvent:"attempt",timestampInfo:"",additionalDetails:""}),!e.incomingCallContext)throw new Oe({defaultError:we.CALL_AGENT.INVALID_PUSH_NOTIFICATION_DATA});o=new K$t(e,this._tsCallRegistry,this.logger),await o.process(),this.sendHandlePushNotificationEvent({eventName:vi.acs_calling_handle_push_notification,correlationId:i,featureName:"handlePushNotification",operationName:"handleIncomingCallPushNotification",callId:o.callId,localParticipantId:o.localParticipantId,kindOfEvent:"success",timestampInfo:{deltaTimeInMs:+new Date-r},additionalDetails:""})}catch(l){const d=new Oe({defaultError:we.CALL_AGENT.PUSH_NOTIFICATION_FAIL,originalError:l});throw this.sendHandlePushNotificationEvent({eventName:vi.acs_calling_handle_push_notification,correlationId:i,featureName:"handlePushNotification",operationName:"handleIncomingCallPushNotification",callId:o?.callId||"",localParticipantId:o?.localParticipantId||"",kindOfEvent:"failure",timestampInfo:{deltaTimeInMs:+new Date-r},additionalDetails:{failureReason:d.message,code:d.code,...an(d)}}),d}}getDeviceType(){const e=this._callClient?.firstPartyOptions?.acsDeviceType;return e?fxt[e]:"default"}isWatermarkSupported(){return this.isCteUser()?wt().calling.watermark.watermarkEnabledForCteUsers:wt().calling.watermark.watermarkEnabledForAcsUsers}trackCallEndTimeToStopTelemetry(e){e.length===0?ib.callEndTimestamp=Date.now():ib.callEndTimestamp=Number.MAX_SAFE_INTEGER}updateConnectionState(e){const i=this.getCallAgentConnectionState(),r=this.getTrouterState(),o=this._callStack?.isRegistered()?"Connected":"Disconnected",l=i==="Connected"?void 0:e=="invalidToken"?"invalidToken":"connectionIssue";if(this.sendCallAgentInfoEvent({eventName:vi.acs_calling_call_agent,additionalDetails:{step:"connectionState-changed",oldState:this._connectionState,newState:i,trouterState:r,registrarState:o,reason:l,connectionStateSource:e}}),i!==this._connectionState||l!==this._connectionStateReason){const d={oldValue:this._connectionState,newValue:i,reason:l};this._connectionState=i,this._connectionStateReason=l,this._eventEmitter.emit("connectionStateChanged",d)}}sendCallAgentInfoEvent(e){try{this._telemetryLogManager.sendEvent({name:e.eventName,tenant:Wr,properties:{...e.additionalDetails}})}catch(i){this.logger.debug("Failed to send connection state changed event",i)}}sendCallAgentInitializiedEvent(e,i,r,o){try{let l=typeof o?.message=="string"?o?.message:void 0;e!==vi.acs_calling_call_agent_init_failure&&(l=void 0);const d=o?an(o):void 0,h=this.getEcsConfigIds();this._telemetryLogManager.sendEvent({name:e,tenant:Wr,properties:{...i,isSupportedEnvironment:this.runningEnvironmentInfo?.isSupportedEnvironment,failureReason:l,additionalProperties:{AcsCallingSDKWeb_ecsConfigIds:h.AcsCallingSDKWeb,SkypeWebMedia_ecsConfigIds:h.SkypeWebMedia},additionalInformation:{trouterState:this.getTrouterState(),hardwareInfo:r},additionalDetails:{...d,firstPartyOptions:{isDeviceTypeEnabled:wt().calling.setDeviceType,deviceTypeRawStrlen:this._callClient?.firstPartyOptions?.acsDeviceType?.length,deviceType:this.getDeviceType()},aadPftClaimExists:this._parsedTokenCredential.aadpftClaimExists}}})}catch{this.logger.debug("Unable to send telemtery")}}sendHandlePushNotificationEvent(e){try{this._telemetryLogManager?.sendEvent({name:e.eventName,tenant:Wr,properties:e})}catch{this.logger.debug("Unable to send handle push notification telemetry")}}async initializeCallRegistry(e,i){const r=i?.displayName,o=await this.getCallRegistry(e,this._parsedTokenCredential,this.tokenProvider,r);return this.logger.info(`registry created for version number=${uk()}`),o}async getCallRegistry(e,i,r,o){const l={id:i.identityMri,displayName:o||"",tokenProvider:r},d=await e.createCallRegistry(l);await d.login(l);const h=wt()?.tsCalling?.accountConfiguration?.ring||void 0,p=i.isCte?gT.Enterprise:gT.Consumer,g=i.acsResourceId,f=i.region;let y={acsResourceId:g,clientType:p,ring:h};if(wt().calling.setDeviceType)y.deviceType=this.getDeviceType();else if(this._callClient.firstPartyOptions?.acsDeviceType)throw new Oe({defaultError:we.CALL_AGENT.SET_DEVICE_TYPE_NOT_ALLOWED});const T=wt().calling.eudb;return T.isEnabled&&T.sendRegionToNgc&&(T.isRgnClaimEnabledForACS||i.isCte)&&(y={...y,region:f}),wt()?.calling.supportLiveStreaming&&(y.clientSupportsUms=!0),y.clientSupportsWatermark=this.isWatermarkSupported(),await d.setConfiguration(y),d.on("callAdded",this.handleCallAdded),d.on("callRemoved",this.handleCallRemoved),d.on("pushHandlingStarted",this.pushHandlingStarted),d.on("pushHandlingEnded",this.pushHandlingEnded),o&&await d.updateDisplayName(o),d}async updateParsedTokenCredentials(e){this._parsedTokenCredential=await R3(e,wt().calling.eudb.isRgnClaimEnabledForACS,{abortSignal:this._abortController.signal}),this._caConfigBag.region=this._parsedTokenCredential.region}registerConnectionStateEventHandlers(){this._callStack.onRegisteredChanged(this._registrarStateChangeCallback),this.onTrouterStateChanged(this._trouterStateChangeCallback)}getCallAgentConnectionState(){return this._callStack?.isRegistered()&&this.getTrouterState()==="Connected"?"Connected":"Disconnected"}sendIncomingNotificationEvent(e){try{this._telemetryLogManager.sendEvent({name:e.eventName,tenant:Wr,properties:e})}catch{this.logger.debug("Unable to send incoming call notification telemetry")}}}pZ([zv,Ak("design:type",Object)],s4.prototype,"logger",void 0),pZ([to(OA.Initialize),Ak("design:type",Function),Ak("design:paramtypes",[Object,Object]),Ak("design:returntype",Promise)],s4.prototype,"initialize",null),pZ([sg(OA.Feature),Ak("design:type",Function),Ak("design:paramtypes",[Object]),Ak("design:returntype",typeof(w3e=typeof TFeature<"u"&&TFeature)=="function"?w3e:Object)],s4.prototype,"feature",null),pZ([to(OA.HandlePushNotification),Ak("design:type",Function),Ak("design:paramtypes",[Object]),Ak("design:returntype",Promise)],s4.prototype,"handlePushNotification",null);class iHt{constructor(e){this._call=e}setTarget(e){this._call=e}getTarget(){return this._call}startVideo(e){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}stopVideo(e){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}startScreenSharing(e){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}stopScreenSharing(e){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}setConstraints(e){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}}function l4(t){const e=new iHt(t);return new Proxy({},{get:(i,r)=>{let o,l;const d=e.getTarget();if(r in e)o=e[r],l=e;else{if(d===void 0)throw new Oe({defaultError:we.FEATURES.VDI3.CALL_INITIALIZING});if(!(r in d))return;o=d[r],l=d}return typeof o=="function"?function(...h){return o.apply(l,h)}:o},has:(i,r)=>{const o=e.getTarget();return r in e||o!==void 0&&r in o}})}var hge=function(t,e,i,r){var o,l=arguments.length,d=l<3?e:r===null?r=Object.getOwnPropertyDescriptor(e,i):r;if(typeof Reflect=="object"&&typeof Reflect.decorate=="function")d=Reflect.decorate(t,e,i,r);else for(var h=t.length-1;h>=0;h--)(o=t[h])&&(d=(l<3?o(d):l>3?o(e,i,d):o(e,i))||d);return l>3&&d&&Object.defineProperty(e,i,d),d},fP=function(t,e){if(typeof Reflect=="object"&&typeof Reflect.metadata=="function")return Reflect.metadata(t,e)};class JC extends s4{get calls(){return this._calls}constructor(e,i,r,o,l,d,h){super(e,i,o,l,r,zx.CallAgent,d),this._calls=[],this.handleCallRemoved=p=>{this.logger.info(`removing callId=${p.callId}`);const g=this._calls.find(f=>f.id===p.callId);if(g){if(g.isBreakoutRoomCall){const f=wt().calling.breakoutRooms.hangUpCallDelayInMilliSeconds;setTimeout(()=>{this.disposeCall(g)},f)}else this.disposeCall(g);this._eventEmitter.emit("callsUpdated",{added:[],removed:[g]}),this.logger.info("call removed")}},this.handleCallAdded=p=>{if(!this._calls.find(g=>g.id===p.callId)){const g=p.on("callStateChanged",async()=>{if(p.state===1){const f=$v(p),y=p.callId;g.dispose();let T=new i4({callId:y,isIncoming:!0},this,p,this._telemetryLogManager);f&&(T=l4(T));const C=new t3e(T);this.handleCallState(T),f?await Promise.all(T.bindTsCall()):T.bindTsCall(),this._eventEmitter.emit("incomingCall",{incomingCall:C})}})}},this.handleCallState=p=>{p.on("stateChanged",async()=>{try{p.state==="Disconnected"?this.tsStack?(await this._tsCallRegistry.deleteCallAsync?.(p.tsCall)||this.logger.info(`The call has been removed from registry, call id: ${p.id}`),p.stats.flushEvents(),this._telemetryLogManager.flushAllEvents(p.id).catch(()=>{this.logger.error("Failed to flush telemetry log manager events")})):this.logger.info("Unable to remove call from registry"):p.state==="Connecting"&&p.direction=="Incoming"&&(this.addToCallArray(p),this._eventEmitter.emit("callsUpdated",{added:[p],removed:[]}))}catch{this.logger.error("Failed to handle call state changed event")}})},this.displayName=h?.displayName}addToCallAgentsMap(e){JC.callAgents.get(e?.identityMri)&&oP(we.CALL_AGENT.ACS_CALLAGENT_ALREADY_EXSISTS,this.logger),JC.callAgents.set(e?.identityMri,this)}removeFromCallAgentsMap(e){e?.identityMri&&JC.callAgents.get(e?.identityMri)===this&&JC.callAgents.delete(e?.identityMri)}disposeCall(e){const i=this._calls.indexOf(e);i!==-1&&this._calls.splice(i,1),e.dispose(),this.trackCallEndTimeToStopTelemetry(this._calls)}async getExistingCallAgentWithToken(e){try{const i=await R3(e,wt().calling.eudb.isRgnClaimEnabledForACS);return JC.callAgents.get(i.identityMri)}catch(i){throw new Oe({defaultError:we.CALL_AGENT.PARSE_ACCESSTOKEN,originalError:i})}}createNewCall(e,i){const r=new i4({callId:e},this,i,this._telemetryLogManager);return $v(i)?l4(r):r}addToCallArray(e){this._calls.push(e),this.trackCallEndTimeToStopTelemetry(this._calls)}startCall(e,i){const r=ln(),o=+new Date,l={correlationId:r,timestampInfo:{attemptTimestamp:o}};this._telemetryLogManager.sendEvent({name:vi.acs_calling_call_attempt,tenant:Wr,properties:l},void 0,"attempt");try{if(this.assertCallUserIds(e),i?.alternateCallerId&&LA(i.alternateCallerId),e.find(h=>zr(h)===this.getUserMri()))throw new Oe({defaultError:we.CALL_AGENT.CANT_CALL_YOURSELF});let d=i?.audioOptions?.muted;return d===void 0&&(d=!1),this.logger.info(`startCall with video=${!!i?.videoOptions},muted=${d}`),this.createCall({participants:e,startCallOptions:i},{correlationId:r,attemptTimestamp:o})}catch(d){let h,p;throw d instanceof Oe&&(h=typeof d?.message=="string"?d?.message:void 0,p={...an(d)}),this._telemetryLogManager.sendEvent({name:vi.acs_calling_call_failed,tenant:Wr,properties:{correlationId:r,timestampInfo:{deltaTimeInMs:+new Date-o},failureReason:h||"",additionalDetails:p||{}}},void 0,"failure"),d}finally{this._telemetryLogManager.deleteEventMapByCorrelationId(r)}}join(e,i){if(!_B(this.acsProxy,this.acsCustomRelayManager,!1,void 0,e))throw new Oe({defaultError:we.CALL_AGENT.PROXY_CUSTOM_TURN_FORBIDDEN});this.assertCallContext(e);let r=i?.audioOptions?.muted;return r===void 0&&(r=!1),this.logger.info(`join with video=${!!i?.videoOptions},muted=${r}`),this.createCall({callContext:e,startCallOptions:i})}async dispose(){if(this._disposed)throw new Oe({defaultError:we.CALL_AGENT.ACS_ALREADY_DISPOSED});this._disposed=!0,this._abortController.abort(),this._extensibleApi.dispose(),this._parsedTokenCredential?.identityMri&&JC.callAgents.delete(this._parsedTokenCredential?.identityMri);try{const e=this._tokenFetchTries>this._maxNmberOfRetries;await this._callStack?.dispose(e)}catch{this.logger.error("Call Agent failed to dispose to Call Stack")}this.offTrouterStateChanged(this._trouterStateChangeCallback),this._callStack.offRegisteredChanged(this._registrarStateChangeCallback),delete this._callStack,this._telemetryLogManager.clearTelemetryLoggers(),this._eventEmitter.removeAllListeners(),this._internalEventEmitter.emit("disposed"),this._internalEventEmitter.removeAllListeners()}on(e,i){if(e!=="handleIncomingCall"&&e!=="incomingCall"&&e!=="callsUpdated"&&e!=="connectionStateChanged")throw new Oe({defaultError:we.CALL_AGENT.EVENT_SUBSCRIBE,defaultErrorMessageArgs:[e]});this._eventEmitter.on(e,i)}off(e,i){if(e!=="handleIncomingCall"&&e!=="incomingCall"&&e!=="callsUpdated"&&e!=="connectionStateChanged")throw new Oe({defaultError:we.CALL_AGENT.EVENT_UNSUBSCRIBE,defaultErrorMessageArgs:[e]});this._eventEmitter.off(e,i)}createCall(e,i){if(e?.startCallOptions?.firstPartyOptions?.isImmersiveMode&&this.getDeviceType()!=="meshV2")throw new Oe({defaultError:we.CALL_AGENT.MESH_DEVICETYPE_V2});if(!this.tsStack)throw new Oe({defaultError:we.CALL_AGENT.STACK_NOT_INIT});let r,o,l,d=e?.callContext?.threadId||e?.startCallOptions?.threadId,h=!1,p=e?.callContext?.groupId;const g=e?.callContext?.roomId,f=e?.callContext?.meetingLink,y=e?.callContext?.meetingId,T=e?.callContext?.passcode||"";if(p&&p.startsWith("19:")&&(d=p,p=""),f)if(D5e(f))o=$pe(f);else{if(!L5e(f,this.logger))throw new Oe({defaultError:we.CALL_AGENT.INVALID_MEETING_LINK});if(O5e(f.trim().toLocaleLowerCase(),wt().calling.tfl.hosts)&&!wt().calling.tfl.isEnabled)throw new Oe({defaultError:we.CALL_AGENT.UNSUPPORTED_TFL_MEETING_JOIN});h=!0}e?.callContext?.threadId&&e?.callContext?.organizerId&&e?.callContext?.tenantId&&(o={threadId:e?.callContext?.threadId,messageId:e?.callContext?.messageId?e?.callContext?.messageId.toString():"0",organizerId:e?.callContext?.organizerId,tenantId:e?.callContext?.tenantId}),o&&(l={meetingType:o.messageId==="0"?1:2,tenantId:o.tenantId,organizerId:o.organizerId,replyChainMessageId:o.messageId},d=o.threadId,r=o.messageId);const C=fd(),E=ln(),I=ln(),w={threadId:d||"",messageId:r||"",meetingInfo:l,mediaPeerType:2};let D=!1;if($v(this._tsCallRegistry)){const F=l4();return(async()=>{let x;p?x=await this._tsCallRegistry.createCallAsync({type:"GroupId",groupId:p,callId:E,localParticipantId:I,causeId:C}):y?x=await this._tsCallRegistry.createCallAsync({callId:E,localParticipantId:I,causeId:C,type:"MeetingData",meetingData:{meetingCode:y,passcode:T,threadId:d}}):g?x=await this._tsCallRegistry.createCallAsync({callId:E,localParticipantId:I,causeId:C,type:"MeetingData",meetingData:{meetingCode:g}}):h?x=await this._tsCallRegistry.createCallAsync({callId:E,localParticipantId:I,causeId:C,type:"MeetingData",meetingData:{meetingUrl:f}}):(D=!!e?.participants&&e.participants.length>=2&&bhe(e.participants,this.kind),wt().calling.enableSmePassFakeConversation&&!d&&D&&(d=`${WK}${ln()}`),x=await this._tsCallRegistry.createCallAsync({callId:E,localParticipantId:I,causeId:C,type:"ThreadId",threadId:d||"",messageId:r}));const B=new i4({callId:E,roomId:g},this,x,this._telemetryLogManager,D);F.setTarget(B),this.addToCallArray(F),this.handleCallState(F),e?.participants&&e?.participants.forEach(z=>{x.addParticipant(zr(z)).catch(()=>{this.logger.error("Failed to add participant during call start")})});const L=ug();B.startCallInternal(e?.startCallOptions,!!y||!!g,e?.callContext,w,i,L).catch(nh),await Promise.all(B.bindTsCall()),await L.promise,this._eventEmitter.emit("callsUpdated",{added:[F],removed:[]})})().catch(x=>{}),F}{let F,x=!1;p?F=this._tsCallRegistry.createCallWithGroupId(p,E,I,C):y?F=this._tsCallRegistry.createCallWithMeetingData({meetingCode:y,passcode:T,threadId:d},E,I,C):g?F=this._tsCallRegistry.createCallWithMeetingData({meetingCode:g},E,I,C):h?F=this._tsCallRegistry.createCallWithMeetingData({meetingUrl:f},E,I,C):(x=!!e?.participants&&e.participants.length>=2&&bhe(e.participants,this.kind),wt().calling.enableSmePassFakeConversation&&!d&&x&&(d=`${WK}${ln()}`),F=this._tsCallRegistry.createCall(d||"",E,I,r,C));const B=new i4({callId:E,roomId:g},this,F,this._telemetryLogManager,x);return this.addToCallArray(B),this.handleCallState(B),e?.participants&&e?.participants.forEach(L=>{F.addParticipant(zr(L)).catch(()=>{this.logger.error("Failed to add participant during call start")})}),B.startCallInternal(e?.startCallOptions,!!y||!!g,e?.callContext,w,i).catch(nh),B.bindTsCall(),this._eventEmitter.emit("callsUpdated",{added:[B],removed:[]}),B}}assertCallContext(e){if(!e||this.checkForAtLeastOneValidCallConfig(e)||this.checkIfMultiplesConfigsWereSpecified(e)||this.checkForInvalidTeamsMeetingCoordinates(e))throw new Oe({defaultError:we.CALL_AGENT.INVALID_JOIN_LOCATOR})}checkForAtLeastOneValidCallConfig(e){return!(e.threadId||e.meetingLink||e.groupId||e.meetingId||e.roomId)}checkIfMultiplesConfigsWereSpecified(e){return e.threadId&&e.groupId||e.groupId&&e.meetingLink}checkForInvalidTeamsMeetingCoordinates(e){return!e.threadId&&e.tenantId&&e.organizerId||e.threadId&&(e.organizerId&&!e.tenantId||!e.organizerId&&e.tenantId)}assertCallUserIds(e){cBe(e,we.CALL_AGENT.USERIDS_MUST_BE_OBJECTS),lBe(e,we.CALL_AGENT.USERIDS_CANNOT_BE_NULL),bxt(e),e.forEach(i=>{const r=LA(i);if(!_B(this.acsProxy,this.acsCustomRelayManager,!1,r))throw new Oe({defaultError:we.CALL_AGENT.PROXY_CUSTOM_TURN_FORBIDDEN})})}}JC.callAgents=new Map,hge([sg(OA.StartCall),fP("design:type",Function),fP("design:paramtypes",[Array,Object]),fP("design:returntype",Object)],JC.prototype,"startCall",null),hge([sg(OA.Join),fP("design:type",Function),fP("design:paramtypes",[Object,Object]),fP("design:returntype",Object)],JC.prototype,"join",null),hge([to(OA.Dispose),fP("design:type",Function),fP("design:paramtypes",[]),fP("design:returntype",Promise)],JC.prototype,"dispose",null);var vP=bs(function(t,e){var i=window;(function(r,o){t.exports=o(Hv,dn)})(0,(r,o)=>{var l={},d={exports:l},h=Object.create,p=Object.defineProperty,g=Object.getOwnPropertyDescriptor,f=Object.getOwnPropertyNames,y=Object.getPrototypeOf,T=Object.prototype.hasOwnProperty,C=(M,V)=>function(){return V||(0,M[f(M)[0]])((V={exports:{}}).exports,V),V.exports},E=(M,V)=>{for(var Y in V)p(M,Y,{get:V[Y],enumerable:!0})},I=(M,V,Y,ie)=>{if(V&&typeof V=="object"||typeof V=="function")for(let ye of f(V))T.call(M,ye)||ye===Y||p(M,ye,{get:()=>V[ye],enumerable:!(ie=g(V,ye))||ie.enumerable});return M},w=(M,V,Y)=>(Y=M!=null?h(y(M)):{},I(M&&M.__esModule?Y:p(Y,"default",{value:M,enumerable:!0}),M)),D=M=>I(p({},"__esModule",{value:!0}),M),F=C({"../node_modules/lodash.clonedeep/index.js"(M,V){var Y=200,ie="__lodash_hash_undefined__",ye=9007199254740991,_e="[object Arguments]",Ue="[object Array]",et="[object Boolean]",nt="[object Date]",lt="[object Error]",Ct="[object Function]",zt="[object GeneratorFunction]",li="[object Map]",ii="[object Number]",wi="[object Object]",oi="[object Promise]",Gt="[object RegExp]",ui="[object Set]",$i="[object String]",In="[object Symbol]",Kt="[object WeakMap]",ki="[object ArrayBuffer]",sa="[object DataView]",$a="[object Float32Array]",Mr="[object Float64Array]",mn="[object Int8Array]",Ir="[object Int16Array]",fn="[object Int32Array]",Xn="[object Uint8Array]",mi="[object Uint8ClampedArray]",wn="[object Uint16Array]",wa="[object Uint32Array]",lr=/[\\^$.*+?()[\]{}|]/g,ka=/\w*$/,Ba=/^\[object .+?Constructor\]$/,Qr=/^(?:0|[1-9]\d*)$/,la={};la[_e]=la[Ue]=la[ki]=la[sa]=la[et]=la[nt]=la[$a]=la[Mr]=la[mn]=la[Ir]=la[fn]=la[li]=la[ii]=la[wi]=la[Gt]=la[ui]=la[$i]=la[In]=la[Xn]=la[mi]=la[wn]=la[wa]=!0,la[lt]=la[Ct]=la[Kt]=!1;var mr=typeof i=="object"&&i&&i.Object===Object&&i,sc=typeof self=="object"&&self&&self.Object===Object&&self,Rs=mr||sc||Function("return this")(),Vd=typeof M=="object"&&M&&!M.nodeType&&M,xr=Vd&&typeof V=="object"&&V&&!V.nodeType&&V,Ad=xr&&xr.exports===Vd;function OS(Bt,Pi){return Bt.set(Pi[0],Pi[1]),Bt}function Ch(Bt,Pi){return Bt.add(Pi),Bt}function Sn(Bt,Pi){for(var zn=-1,Br=Bt?Bt.length:0;++zn<Br&&Pi(Bt[zn],zn,Bt)!==!1;);return Bt}function Ha(Bt,Pi){for(var zn=-1,Br=Pi.length,ku=Bt.length;++zn<Br;)Bt[ku+zn]=Pi[zn];return Bt}function cr(Bt,Pi,zn,Br){var ku=-1,Ev=Bt?Bt.length:0;for(Br;++ku<Ev;)zn=Pi(zn,Bt[ku],ku,Bt);return zn}function ba(Bt,Pi){for(var zn=-1,Br=Array(Bt);++zn<Bt;)Br[zn]=Pi(zn);return Br}function Pr(Bt,Pi){return Bt?.[Pi]}function No(Bt){var Pi=!1;if(Bt!=null&&typeof Bt.toString!="function")try{Pi=!!(Bt+"")}catch{}return Pi}function Eo(Bt){var Pi=-1,zn=Array(Bt.size);return Bt.forEach(function(Br,ku){zn[++Pi]=[ku,Br]}),zn}function Cl(Bt,Pi){return function(zn){return Bt(Pi(zn))}}function sd(Bt){var Pi=-1,zn=Array(Bt.size);return Bt.forEach(function(Br){zn[++Pi]=Br}),zn}var xh,Cm=Array.prototype,W_=Function.prototype,NS=Object.prototype,Zp=Rs["__core-js_shared__"],iC=(xh=/[^.]+$/.exec(Zp&&Zp.keys&&Zp.keys.IE_PROTO||""))?"Symbol(src)_1."+xh:"",_m=W_.toString,Em=NS.hasOwnProperty,nC=NS.toString,cp=RegExp("^"+_m.call(Em).replace(lr,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$"),vf=Ad?Rs.Buffer:void 0,aC=Rs.Symbol,Ni=Rs.Uint8Array,ta=Cl(Object.getPrototypeOf,Object),Ta=Object.create,Er=NS.propertyIsEnumerable,Ro=Cm.splice,Ms=Object.getOwnPropertySymbols,Dr=vf?vf.isBuffer:void 0,ms=Cl(Object.keys,Object),zi=j0(Rs,"DataView"),hn=j0(Rs,"Map"),Un=j0(Rs,"Promise"),Fa=j0(Rs,"Set"),rr=j0(Rs,"WeakMap"),ro=j0(Object,"create"),hi=G0(zi),_h=G0(hn),dp=G0(Un),yf=G0(Fa),Lg=G0(rr),xb=aC?aC.prototype:void 0,_v=xb?xb.valueOf:void 0;function tw(Bt){var Pi=-1,zn=Bt?Bt.length:0;for(this.clear();++Pi<zn;){var Br=Bt[Pi];this.set(Br[0],Br[1])}}function kn(){this.__data__=ro?ro(null):{}}function o2(Bt){return this.has(Bt)&&delete this.__data__[Bt]}function xS(Bt){var Pi=this.__data__;if(ro){var zn=Pi[Bt];return zn===ie?void 0:zn}return Em.call(Pi,Bt)?Pi[Bt]:void 0}function eN(Bt){var Pi=this.__data__;return ro?Pi[Bt]!==void 0:Em.call(Pi,Bt)}function tN(Bt,Pi){return this.__data__[Bt]=ro&&Pi===void 0?ie:Pi,this}function wy(Bt){var Pi=-1,zn=Bt?Bt.length:0;for(this.clear();++Pi<zn;){var Br=Bt[Pi];this.set(Br[0],Br[1])}}function Qu(){this.__data__=[]}function Zz(Bt){var Pi=this.__data__,zn=Bh(Pi,Bt);return!(zn<0)&&(zn==Pi.length-1?Pi.pop():Ro.call(Pi,zn,1),!0)}function sG(Bt){var Pi=this.__data__,zn=Bh(Pi,Bt);return zn<0?void 0:Pi[zn][1]}function s2(Bt){return Bh(this.__data__,Bt)>-1}function l2(Bt,Pi){var zn=this.__data__,Br=Bh(zn,Bt);return Br<0?zn.push([Bt,Pi]):zn[Br][1]=Pi,this}function $0(Bt){var Pi=-1,zn=Bt?Bt.length:0;for(this.clear();++Pi<zn;){var Br=Bt[Pi];this.set(Br[0],Br[1])}}function lG(){this.__data__={hash:new tw,map:new(hn||wy),string:new tw}}function cG(Bt){return rN(this,Bt).delete(Bt)}function K_(Bt){return rN(this,Bt).get(Bt)}function BS(Bt){return rN(this,Bt).has(Bt)}function Hs(Bt,Pi){return rN(this,Bt).set(Bt,Pi),this}function rC(Bt){this.__data__=new wy(Bt)}function fi(){this.__data__=new wy}function xo(Bt){return this.__data__.delete(Bt)}function J_(Bt){return this.__data__.get(Bt)}function Og(Bt){return this.__data__.has(Bt)}function c2(Bt,Pi){var zn=this.__data__;if(zn instanceof wy){var Br=zn.__data__;if(!hn||Br.length<Y-1)return Br.push([Bt,Pi]),this;zn=this.__data__=new $0(Br)}return zn.set(Bt,Pi),this}function CD(Bt,Pi){var zn=p2(Bt)||sN(Bt)?ba(Bt.length,String):[],Br=zn.length,ku=!!Br;for(var Ev in Bt)!Em.call(Bt,Ev)||ku&&(Ev=="length"||up(Ev,Br))||zn.push(Ev);return zn}function H0(Bt,Pi,zn){var Br=Bt[Pi];Em.call(Bt,Pi)&&lV(Br,zn)&&(zn!==void 0||Pi in Bt)||(Bt[Pi]=zn)}function Bh(Bt,Pi){for(var zn=Bt.length;zn--;)if(lV(Bt[zn][0],Pi))return zn;return-1}function Xz(Bt,Pi){return Bt&&oV(Pi,lN(Pi),Bt)}function iN(Bt,Pi,zn,Br,ku,Ev,Sf){var hp;if(Br&&(hp=Ev?Br(Bt,ku,Ev,Sf):Br(Bt)),hp!==void 0)return hp;if(!q0(Bt))return Bt;var oC=p2(Bt);if(oC){if(hp=UR(Bt),!Pi)return rV(Bt,hp)}else{var nw=wu(Bt),AD=nw==Ct||nw==zt;if(dV(Bt))return nn(Bt,Pi);if(nw==wi||nw==_e||AD&&!Ev){if(No(Bt))return Ev?Bt:{};if(hp=sV(AD?{}:Bt),!Pi)return aN(Bt,Xz(hp,Bt))}else{if(!la[nw])return Ev?Bt:{};hp=uG(Bt,nw,iN,Pi)}}Sf||(Sf=new rC);var hV=Sf.get(Bt);if(hV)return hV;if(Sf.set(Bt,hp),!oC)var dN=zn?dG(Bt):lN(Bt);return Sn(dN||Bt,function(Y_,ID){dN&&(Y_=Bt[ID=Y_]),H0(hp,ID,iN(Y_,Pi,zn,Br,ID,Bt,Sf))}),hp}function d2(Bt){return q0(Bt)?Ta(Bt):{}}function _D(Bt,Pi,zn){var Br=Pi(Bt);return p2(Bt)?Br:Ha(Br,zn(Bt))}function eV(Bt){return nC.call(Bt)}function tV(Bt){return!(!q0(Bt)||ED(Bt))&&(uV(Bt)||No(Bt)?cp:Ba).test(G0(Bt))}function iV(Bt){if(!ul(Bt))return ms(Bt);var Pi=[];for(var zn in Object(Bt))Em.call(Bt,zn)&&zn!="constructor"&&Pi.push(zn);return Pi}function nn(Bt,Pi){if(Pi)return Bt.slice();var zn=new Bt.constructor(Bt.length);return Bt.copy(zn),zn}function ky(Bt){var Pi=new Bt.constructor(Bt.byteLength);return new Ni(Pi).set(new Ni(Bt)),Pi}function u2(Bt,Pi){var zn=Pi?ky(Bt.buffer):Bt.buffer;return new Bt.constructor(zn,Bt.byteOffset,Bt.byteLength)}function nV(Bt,Pi,zn){return cr(Pi?zn(Eo(Bt),!0):Eo(Bt),OS,new Bt.constructor)}function nN(Bt){var Pi=new Bt.constructor(Bt.source,ka.exec(Bt));return Pi.lastIndex=Bt.lastIndex,Pi}function ld(Bt,Pi,zn){return cr(Pi?zn(sd(Bt),!0):sd(Bt),Ch,new Bt.constructor)}function h2(Bt){return _v?Object(_v.call(Bt)):{}}function aV(Bt,Pi){var zn=Pi?ky(Bt.buffer):Bt.buffer;return new Bt.constructor(zn,Bt.byteOffset,Bt.length)}function rV(Bt,Pi){var zn=-1,Br=Bt.length;for(Pi||(Pi=Array(Br));++zn<Br;)Pi[zn]=Bt[zn];return Pi}function oV(Bt,Pi,zn,Br){zn||(zn={});for(var ku=-1,Ev=Pi.length;++ku<Ev;){var Sf=Pi[ku],hp=void 0;H0(zn,Sf,hp===void 0?Bt[Sf]:hp)}return zn}function aN(Bt,Pi){return oV(Bt,Qs(Bt),Pi)}function dG(Bt){return _D(Bt,lN,Qs)}function rN(Bt,Pi){var zn=Bt.__data__;return oN(Pi)?zn[typeof Pi=="string"?"string":"hash"]:zn.map}function j0(Bt,Pi){var zn=Pr(Bt,Pi);return tV(zn)?zn:void 0}tw.prototype.clear=kn,tw.prototype.delete=o2,tw.prototype.get=xS,tw.prototype.has=eN,tw.prototype.set=tN,wy.prototype.clear=Qu,wy.prototype.delete=Zz,wy.prototype.get=sG,wy.prototype.has=s2,wy.prototype.set=l2,$0.prototype.clear=lG,$0.prototype.delete=cG,$0.prototype.get=K_,$0.prototype.has=BS,$0.prototype.set=Hs,rC.prototype.clear=fi,rC.prototype.delete=xo,rC.prototype.get=J_,rC.prototype.has=Og,rC.prototype.set=c2;var Qs=Ms?Cl(Ms,Object):gG,wu=eV;function UR(Bt){var Pi=Bt.length,zn=Bt.constructor(Pi);return Pi&&typeof Bt[0]=="string"&&Em.call(Bt,"index")&&(zn.index=Bt.index,zn.input=Bt.input),zn}function sV(Bt){return typeof Bt.constructor!="function"||ul(Bt)?{}:d2(ta(Bt))}function uG(Bt,Pi,zn,Br){var ku=Bt.constructor;switch(Pi){case ki:return ky(Bt);case et:case nt:return new ku(+Bt);case sa:return u2(Bt,Br);case $a:case Mr:case mn:case Ir:case fn:case Xn:case mi:case wn:case wa:return aV(Bt,Br);case li:return nV(Bt,Br,zn);case ii:case $i:return new ku(Bt);case Gt:return nN(Bt);case ui:return ld(Bt,Br,zn);case In:return h2(Bt)}}function up(Bt,Pi){return!!(Pi=Pi??ye)&&(typeof Bt=="number"||Qr.test(Bt))&&Bt>-1&&Bt%1==0&&Bt<Pi}function oN(Bt){var Pi=typeof Bt;return Pi=="string"||Pi=="number"||Pi=="symbol"||Pi=="boolean"?Bt!=="__proto__":Bt===null}function ED(Bt){return!!iC&&iC in Bt}function ul(Bt){var Pi=Bt&&Bt.constructor;return Bt===(typeof Pi=="function"&&Pi.prototype||NS)}function G0(Bt){if(Bt!=null){try{return _m.call(Bt)}catch{}try{return Bt+""}catch{}}return""}function hG(Bt){return iN(Bt,!0,!0)}function lV(Bt,Pi){return Bt===Pi||Bt!=Bt&&Pi!=Pi}function sN(Bt){return cV(Bt)&&Em.call(Bt,"callee")&&(!Er.call(Bt,"callee")||nC.call(Bt)==_e)}(zi&&wu(new zi(new ArrayBuffer(1)))!=sa||hn&&wu(new hn)!=li||Un&&wu(Un.resolve())!=oi||Fa&&wu(new Fa)!=ui||rr&&wu(new rr)!=Kt)&&(wu=function(Bt){var Pi=nC.call(Bt),zn=Pi==wi?Bt.constructor:void 0,Br=zn?G0(zn):void 0;if(Br)switch(Br){case hi:return sa;case _h:return li;case dp:return oi;case yf:return ui;case Lg:return Kt}return Pi});var p2=Array.isArray;function g2(Bt){return Bt!=null&&pG(Bt.length)&&!uV(Bt)}function cV(Bt){return iw(Bt)&&g2(Bt)}var dV=Dr||cN;function uV(Bt){var Pi=q0(Bt)?nC.call(Bt):"";return Pi==Ct||Pi==zt}function pG(Bt){return typeof Bt=="number"&&Bt>-1&&Bt%1==0&&Bt<=ye}function q0(Bt){var Pi=typeof Bt;return!!Bt&&(Pi=="object"||Pi=="function")}function iw(Bt){return!!Bt&&typeof Bt=="object"}function lN(Bt){return g2(Bt)?CD(Bt):iV(Bt)}function gG(){return[]}function cN(){return!1}V.exports=hG}}),x=C({"../skype-calling-pluginless/dist/skype-calling-pluginless.bundle.js"(M,V){var Y,ie,ye=window;Y=M,ie=(_e,Ue)=>{var et={},nt={exports:et},lt=Object.create,Ct=Object.defineProperty,zt=Object.getOwnPropertyDescriptor,li=Object.getOwnPropertyNames,ii=Object.getPrototypeOf,wi=Object.prototype.hasOwnProperty,oi=(n,a)=>function(){return a||(0,n[li(n)[0]])((a={exports:{}}).exports,a),a.exports},Gt=(n,a)=>{for(var s in a)Ct(n,s,{get:a[s],enumerable:!0})},ui=(n,a,s,c)=>{if(a&&typeof a=="object"||typeof a=="function")for(let u of li(a))wi.call(n,u)||u===s||Ct(n,u,{get:()=>a[u],enumerable:!(c=zt(a,u))||c.enumerable});return n},$i=(n,a,s)=>(s=n!=null?lt(ii(n)):{},ui(n&&n.__esModule?s:Ct(s,"default",{value:n,enumerable:!0}),n)),In=n=>ui(Ct({},"__esModule",{value:!0}),n),Kt=(n,a,s,c)=>{for(var u,m=zt(a,s),b=n.length-1;b>=0;b--)(u=n[b])&&(m=u(a,s,m)||m);return m&&Ct(a,s,m),m},ki=(n,a)=>(s,c)=>a(s,c,n),sa=oi({"../node_modules/axios/lib/helpers/bind.js"(n,a){a.exports=function(c,u){return function(){for(var b=new Array(arguments.length),_=0;_<b.length;_++)b[_]=arguments[_];return c.apply(u,b)}}}}),$a=oi({"../node_modules/axios/lib/utils.js"(n,a){var s=sa(),c=Object.prototype.toString;function u(Xe){return c.call(Xe)==="[object Array]"}function m(Xe){return Xe===void 0}function b(Xe){return Xe!==null&&!m(Xe)&&Xe.constructor!==null&&!m(Xe.constructor)&&typeof Xe.constructor.isBuffer=="function"&&Xe.constructor.isBuffer(Xe)}function _(Xe){return c.call(Xe)==="[object ArrayBuffer]"}function k(Xe){return typeof FormData<"u"&&Xe instanceof FormData}function N(Xe){return typeof ArrayBuffer<"u"&&ArrayBuffer.isView?ArrayBuffer.isView(Xe):Xe&&Xe.buffer&&Xe.buffer instanceof ArrayBuffer}function W(Xe){return typeof Xe=="string"}function ee(Xe){return typeof Xe=="number"}function oe(Xe){return Xe!==null&&typeof Xe=="object"}function de(Xe){return c.call(Xe)==="[object Date]"}function se(Xe){return c.call(Xe)==="[object File]"}function Re(Xe){return c.call(Xe)==="[object Blob]"}function ue(Xe){return c.call(Xe)==="[object Function]"}function Ne(Xe){return oe(Xe)&&ue(Xe.pipe)}function ze(Xe){return typeof URLSearchParams<"u"&&Xe instanceof URLSearchParams}function He(Xe){return Xe.replace(/^\s*/,"").replace(/\s*$/,"")}function be(){return(typeof navigator>"u"||navigator.product!=="ReactNative"&&navigator.product!=="NativeScript"&&navigator.product!=="NS")&&typeof window<"u"&&typeof document<"u"}function Ee(Xe,bt){if(Xe!=null)if(typeof Xe!="object"&&(Xe=[Xe]),u(Xe))for(var Ot=0,Yt=Xe.length;Ot<Yt;Ot++)bt.call(null,Xe[Ot],Ot,Xe);else for(var pt in Xe)Object.prototype.hasOwnProperty.call(Xe,pt)&&bt.call(null,Xe[pt],pt,Xe)}function Pe(){var Xe={};function bt(pt,Lt){typeof Xe[Lt]=="object"&&typeof pt=="object"?Xe[Lt]=Pe(Xe[Lt],pt):Xe[Lt]=pt}for(var Ot=0,Yt=arguments.length;Ot<Yt;Ot++)Ee(arguments[Ot],bt);return Xe}function Qe(){var Xe={};function bt(pt,Lt){typeof Xe[Lt]=="object"&&typeof pt=="object"?Xe[Lt]=Qe(Xe[Lt],pt):Xe[Lt]=typeof pt=="object"?Qe({},pt):pt}for(var Ot=0,Yt=arguments.length;Ot<Yt;Ot++)Ee(arguments[Ot],bt);return Xe}function Ze(Xe,bt,Ot){return Ee(bt,function(pt,Lt){Xe[Lt]=Ot&&typeof pt=="function"?s(pt,Ot):pt}),Xe}a.exports={isArray:u,isArrayBuffer:_,isBuffer:b,isFormData:k,isArrayBufferView:N,isString:W,isNumber:ee,isObject:oe,isUndefined:m,isDate:de,isFile:se,isBlob:Re,isFunction:ue,isStream:Ne,isURLSearchParams:ze,isStandardBrowserEnv:be,forEach:Ee,merge:Pe,deepMerge:Qe,extend:Ze,trim:He}}}),Mr=oi({"../node_modules/axios/lib/helpers/buildURL.js"(n,a){var s=$a();function c(u){return encodeURIComponent(u).replace(/%40/gi,"@").replace(/%3A/gi,":").replace(/%24/g,"$").replace(/%2C/gi,",").replace(/%20/g,"+").replace(/%5B/gi,"[").replace(/%5D/gi,"]")}a.exports=function(m,b,_){if(!b)return m;var k;if(_)k=_(b);else if(s.isURLSearchParams(b))k=b.toString();else{var N=[];s.forEach(b,function(oe,de){oe!=null&&(s.isArray(oe)?de+="[]":oe=[oe],s.forEach(oe,function(Re){s.isDate(Re)?Re=Re.toISOString():s.isObject(Re)&&(Re=JSON.stringify(Re)),N.push(c(de)+"="+c(Re))}))}),k=N.join("&")}if(k){var W=m.indexOf("#");W!==-1&&(m=m.slice(0,W)),m+=(m.indexOf("?")===-1?"?":"&")+k}return m}}}),mn=oi({"../node_modules/axios/lib/core/InterceptorManager.js"(n,a){var s=$a();function c(){this.handlers=[]}c.prototype.use=function(m,b){return this.handlers.push({fulfilled:m,rejected:b}),this.handlers.length-1},c.prototype.eject=function(m){this.handlers[m]&&(this.handlers[m]=null)},c.prototype.forEach=function(m){s.forEach(this.handlers,function(_){_!==null&&m(_)})},a.exports=c}}),Ir=oi({"../node_modules/axios/lib/core/transformData.js"(n,a){var s=$a();a.exports=function(u,m,b){return s.forEach(b,function(k){u=k(u,m)}),u}}}),fn=oi({"../node_modules/axios/lib/cancel/isCancel.js"(n,a){a.exports=function(c){return!(!c||!c.__CANCEL__)}}}),Xn=oi({"../node_modules/axios/lib/helpers/normalizeHeaderName.js"(n,a){var s=$a();a.exports=function(u,m){s.forEach(u,function(_,k){k!==m&&k.toUpperCase()===m.toUpperCase()&&(u[m]=_,delete u[k])})}}}),mi=oi({"../node_modules/axios/lib/core/enhanceError.js"(n,a){a.exports=function(c,u,m,b,_){return c.config=u,m&&(c.code=m),c.request=b,c.response=_,c.isAxiosError=!0,c.toJSON=function(){return{message:this.message,name:this.name,description:this.description,number:this.number,fileName:this.fileName,lineNumber:this.lineNumber,columnNumber:this.columnNumber,stack:this.stack,config:this.config,code:this.code}},c}}}),wn=oi({"../node_modules/axios/lib/core/createError.js"(n,a){var s=mi();a.exports=function(u,m,b,_,k){var N=new Error(u);return s(N,m,b,_,k)}}}),wa=oi({"../node_modules/axios/lib/core/settle.js"(n,a){var s=wn();a.exports=function(u,m,b){var _=b.config.validateStatus;!_||_(b.status)?u(b):m(s("Request failed with status code "+b.status,b.config,null,b.request,b))}}}),lr=oi({"../node_modules/axios/lib/helpers/isAbsoluteURL.js"(n,a){a.exports=function(c){return/^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(c)}}}),ka=oi({"../node_modules/axios/lib/helpers/combineURLs.js"(n,a){a.exports=function(c,u){return u?c.replace(/\/+$/,"")+"/"+u.replace(/^\/+/,""):c}}}),Ba=oi({"../node_modules/axios/lib/core/buildFullPath.js"(n,a){var s=lr(),c=ka();a.exports=function(m,b){return m&&!s(b)?c(m,b):b}}}),Qr=oi({"../node_modules/axios/lib/helpers/parseHeaders.js"(n,a){var s=$a(),c=["age","authorization","content-length","content-type","etag","expires","from","host","if-modified-since","if-unmodified-since","last-modified","location","max-forwards","proxy-authorization","referer","retry-after","user-agent"];a.exports=function(m){var b,_,k,N={};return m&&s.forEach(m.split(`
`),function(ee){if(k=ee.indexOf(":"),b=s.trim(ee.substr(0,k)).toLowerCase(),_=s.trim(ee.substr(k+1)),b){if(N[b]&&c.indexOf(b)>=0)return;N[b]=b==="set-cookie"?(N[b]?N[b]:[]).concat([_]):N[b]?N[b]+", "+_:_}}),N}}}),la=oi({"../node_modules/axios/lib/helpers/isValidXss.js"(n,a){a.exports=function(c){return/(\b)(on\w+)=|javascript|(<\s*)(\/*)script/gi.test(c)}}}),mr=oi({"../node_modules/axios/lib/helpers/isURLSameOrigin.js"(n,a){var s=$a(),c=la();a.exports=s.isStandardBrowserEnv()?function(){var m,b=/(msie|trident)/i.test(navigator.userAgent),_=document.createElement("a");function k(N){var W=N;if(c(N))throw new Error("URL contains XSS injection attempt");return b&&(_.setAttribute("href",W),W=_.href),_.setAttribute("href",W),{href:_.href,protocol:_.protocol?_.protocol.replace(/:$/,""):"",host:_.host,search:_.search?_.search.replace(/^\?/,""):"",hash:_.hash?_.hash.replace(/^#/,""):"",hostname:_.hostname,port:_.port,pathname:_.pathname.charAt(0)==="/"?_.pathname:"/"+_.pathname}}return m=k(window.location.href),function(W){var ee=s.isString(W)?k(W):W;return ee.protocol===m.protocol&&ee.host===m.host}}():function(){return function(){return!0}}()}}),sc=oi({"../node_modules/axios/lib/helpers/cookies.js"(n,a){var s=$a();a.exports=s.isStandardBrowserEnv()?function(){return{write:function(m,b,_,k,N,W){var ee=[];ee.push(m+"="+encodeURIComponent(b)),s.isNumber(_)&&ee.push("expires="+new Date(_).toGMTString()),s.isString(k)&&ee.push("path="+k),s.isString(N)&&ee.push("domain="+N),W===!0&&ee.push("secure"),document.cookie=ee.join("; ")},read:function(m){var b=document.cookie.match(new RegExp("(^|;\\s*)("+m+")=([^;]*)"));return b?decodeURIComponent(b[3]):null},remove:function(m){this.write(m,"",Date.now()-864e5)}}}():function(){return{write:function(){},read:function(){return null},remove:function(){}}}()}}),Rs=oi({"../node_modules/axios/lib/adapters/xhr.js"(n,a){var s=$a(),c=wa(),u=Mr(),m=Ba(),b=Qr(),_=mr(),k=wn();a.exports=function(W){return new Promise(function(oe,de){var se=W.data,Re=W.headers;s.isFormData(se)&&delete Re["Content-Type"];var ue=new XMLHttpRequest;if(W.auth){var Ne=W.auth.username||"",ze=W.auth.password||"";Re.Authorization="Basic "+btoa(Ne+":"+ze)}var He=m(W.baseURL,W.url);if(ue.open(W.method.toUpperCase(),u(He,W.params,W.paramsSerializer),!0),ue.timeout=W.timeout,ue.onreadystatechange=function(){if(ue&&ue.readyState===4&&(ue.status!==0||ue.responseURL&&ue.responseURL.indexOf("file:")===0)){var Qe="getAllResponseHeaders"in ue?b(ue.getAllResponseHeaders()):null,Ze={data:W.responseType&&W.responseType!=="text"?ue.response:ue.responseText,status:ue.status,statusText:ue.statusText,headers:Qe,config:W,request:ue};c(oe,de,Ze),ue=null}},ue.onabort=function(){ue&&(de(k("Request aborted",W,"ECONNABORTED",ue)),ue=null)},ue.onerror=function(){de(k("Network Error",W,null,ue)),ue=null},ue.ontimeout=function(){var Qe="timeout of "+W.timeout+"ms exceeded";W.timeoutErrorMessage&&(Qe=W.timeoutErrorMessage),de(k(Qe,W,"ECONNABORTED",ue)),ue=null},s.isStandardBrowserEnv()){var be=sc(),Ee=(W.withCredentials||_(He))&&W.xsrfCookieName?be.read(W.xsrfCookieName):void 0;Ee&&(Re[W.xsrfHeaderName]=Ee)}if("setRequestHeader"in ue&&s.forEach(Re,function(Qe,Ze){se===void 0&&Ze.toLowerCase()==="content-type"?delete Re[Ze]:ue.setRequestHeader(Ze,Qe)}),s.isUndefined(W.withCredentials)||(ue.withCredentials=!!W.withCredentials),W.responseType)try{ue.responseType=W.responseType}catch(Pe){if(W.responseType!=="json")throw Pe}typeof W.onDownloadProgress=="function"&&ue.addEventListener("progress",W.onDownloadProgress),typeof W.onUploadProgress=="function"&&ue.upload&&ue.upload.addEventListener("progress",W.onUploadProgress),W.cancelToken&&W.cancelToken.promise.then(function(Qe){ue&&(ue.abort(),de(Qe),ue=null)}),se===void 0&&(se=null),ue.send(se)})}}}),Vd=oi({"../node_modules/axios/lib/defaults.js"(n,a){var s=$a(),c=Xn(),u={"Content-Type":"application/x-www-form-urlencoded"};function m(k,N){!s.isUndefined(k)&&s.isUndefined(k["Content-Type"])&&(k["Content-Type"]=N)}function b(){var k;return(typeof XMLHttpRequest<"u"||typeof process<"u"&&Object.prototype.toString.call(process)==="[object process]")&&(k=Rs()),k}var _={adapter:b(),transformRequest:[function(N,W){return c(W,"Accept"),c(W,"Content-Type"),s.isFormData(N)||s.isArrayBuffer(N)||s.isBuffer(N)||s.isStream(N)||s.isFile(N)||s.isBlob(N)?N:s.isArrayBufferView(N)?N.buffer:s.isURLSearchParams(N)?(m(W,"application/x-www-form-urlencoded;charset=utf-8"),N.toString()):s.isObject(N)?(m(W,"application/json;charset=utf-8"),JSON.stringify(N)):N}],transformResponse:[function(N){if(typeof N=="string")try{N=JSON.parse(N)}catch{}return N}],timeout:0,xsrfCookieName:"XSRF-TOKEN",xsrfHeaderName:"X-XSRF-TOKEN",maxContentLength:-1,validateStatus:function(N){return N>=200&&N<300},headers:{common:{Accept:"application/json, text/plain, */*"}}};s.forEach(["delete","get","head"],function(N){_.headers[N]={}}),s.forEach(["post","put","patch"],function(N){_.headers[N]=s.merge(u)}),a.exports=_}}),xr=oi({"../node_modules/axios/lib/core/dispatchRequest.js"(n,a){var s=$a(),c=Ir(),u=fn(),m=Vd();function b(_){_.cancelToken&&_.cancelToken.throwIfRequested()}a.exports=function(k){return b(k),k.headers=k.headers||{},k.data=c(k.data,k.headers,k.transformRequest),k.headers=s.merge(k.headers.common||{},k.headers[k.method]||{},k.headers),s.forEach(["delete","get","head","post","put","patch","common"],function(W){delete k.headers[W]}),(k.adapter||m.adapter)(k).then(function(W){return b(k),W.data=c(W.data,W.headers,k.transformResponse),W},function(W){return u(W)||(b(k),W&&W.response&&(W.response.data=c(W.response.data,W.response.headers,k.transformResponse))),Promise.reject(W)})}}}),Ad=oi({"../node_modules/axios/lib/core/mergeConfig.js"(n,a){var s=$a();a.exports=function(u,m){m=m||{};var b={},_=["url","method","params","data"],k=["headers","auth","proxy"],N=["baseURL","url","transformRequest","transformResponse","paramsSerializer","timeout","withCredentials","adapter","responseType","xsrfCookieName","xsrfHeaderName","onUploadProgress","onDownloadProgress","maxContentLength","validateStatus","maxRedirects","httpAgent","httpsAgent","cancelToken","socketPath"];s.forEach(_,function(de){m[de]!==void 0&&(b[de]=m[de])}),s.forEach(k,function(de){s.isObject(m[de])?b[de]=s.deepMerge(u[de],m[de]):m[de]!==void 0?b[de]=m[de]:s.isObject(u[de])?b[de]=s.deepMerge(u[de]):u[de]!==void 0&&(b[de]=u[de])}),s.forEach(N,function(de){m[de]!==void 0?b[de]=m[de]:u[de]!==void 0&&(b[de]=u[de])});var W=_.concat(k).concat(N),ee=Object.keys(m).filter(function(de){return W.indexOf(de)===-1});return s.forEach(ee,function(de){m[de]!==void 0?b[de]=m[de]:u[de]!==void 0&&(b[de]=u[de])}),b}}}),OS=oi({"../node_modules/axios/lib/core/Axios.js"(n,a){var s=$a(),c=Mr(),u=mn(),m=xr(),b=Ad();function _(k){this.defaults=k,this.interceptors={request:new u,response:new u}}_.prototype.request=function(N){typeof N=="string"?(N=arguments[1]||{}).url=arguments[0]:N=N||{},(N=b(this.defaults,N)).method?N.method=N.method.toLowerCase():this.defaults.method?N.method=this.defaults.method.toLowerCase():N.method="get";var W=[m,void 0],ee=Promise.resolve(N);for(this.interceptors.request.forEach(function(de){W.unshift(de.fulfilled,de.rejected)}),this.interceptors.response.forEach(function(de){W.push(de.fulfilled,de.rejected)});W.length;)ee=ee.then(W.shift(),W.shift());return ee},_.prototype.getUri=function(N){return N=b(this.defaults,N),c(N.url,N.params,N.paramsSerializer).replace(/^\?/,"")},s.forEach(["delete","get","head","options"],function(N){_.prototype[N]=function(W,ee){return this.request(s.merge(ee||{},{method:N,url:W}))}}),s.forEach(["post","put","patch"],function(N){_.prototype[N]=function(W,ee,oe){return this.request(s.merge(oe||{},{method:N,url:W,data:ee}))}}),a.exports=_}}),Ch=oi({"../node_modules/axios/lib/cancel/Cancel.js"(n,a){function s(c){this.message=c}s.prototype.toString=function(){return"Cancel"+(this.message?": "+this.message:"")},s.prototype.__CANCEL__=!0,a.exports=s}}),Sn=oi({"../node_modules/axios/lib/cancel/CancelToken.js"(n,a){var s=Ch();function c(u){if(typeof u!="function")throw new TypeError("executor must be a function.");var m;this.promise=new Promise(function(k){m=k});var b=this;u(function(k){b.reason||(b.reason=new s(k),m(b.reason))})}c.prototype.throwIfRequested=function(){if(this.reason)throw this.reason},c.source=function(){var m;return{token:new c(function(_){m=_}),cancel:m}},a.exports=c}}),Ha=oi({"../node_modules/axios/lib/helpers/spread.js"(n,a){a.exports=function(c){return function(m){return c.apply(null,m)}}}}),cr=oi({"../node_modules/axios/lib/axios.js"(n,a){var s=$a(),c=sa(),u=OS(),m=Ad();function b(k){var N=new u(k),W=c(u.prototype.request,N);return s.extend(W,u.prototype,N),s.extend(W,N),W}var _=b(Vd());_.Axios=u,_.create=function(N){return b(m(_.defaults,N))},_.Cancel=Ch(),_.CancelToken=Sn(),_.isCancel=fn(),_.all=function(N){return Promise.all(N)},_.spread=Ha(),a.exports=_,a.exports.default=_}}),ba=oi({"../node_modules/axios/index.js"(n,a){a.exports=cr()}}),Pr=oi({"../node_modules/ua-parser-js/src/ua-parser.js"(n,a){(function(s,c){var u="1.0.38",m="",b="?",_="function",k="undefined",N="object",W="string",ee="major",oe="model",de="name",se="type",Re="vendor",ue="version",Ne="architecture",ze="console",He="mobile",be="tablet",Ee="smarttv",Pe="wearable",Qe="embedded",Ze=500,Xe="Amazon",bt="Apple",Ot="ASUS",Yt="BlackBerry",pt="Browser",Lt="Chrome",xt="Firefox",yi="Google",Li="Huawei",cn="LG",Ci="Microsoft",ji="Motorola",An="Opera",Ea="Samsung",Ln="Sharp",ga="Sony",vs="Xiaomi",ss="Zebra",Ya="Facebook",ir="Chromium OS",Ji="Mac OS",pa=function(es,qs){var qr={};for(var Ol in es)qs[Ol]&&qs[Ol].length%2==0?qr[Ol]=qs[Ol].concat(es[Ol]):qr[Ol]=es[Ol];return qr},Ca=function(es){for(var qs={},qr=0;qr<es.length;qr++)qs[es[qr].toUpperCase()]=es[qr];return qs},da=function(es,qs){return typeof es===W&&Wn(qs).indexOf(Wn(es))!==-1},Wn=function(es){return es.toLowerCase()},co=function(es){return typeof es===W?es.replace(/[^\d\.]/g,m).split(".")[0]:c},eo=function(es,qs){if(typeof es===W)return es=es.replace(/^\s\s*/,m),typeof qs===k?es:es.substring(0,Ze)},Uo=function(es,qs){for(var qr,Ol,Ih,mo,ig,pi,Qn=0;Qn<qs.length&&!ig;){var ft=qs[Qn],Hi=qs[Qn+1];for(qr=Ol=0;qr<ft.length&&!ig&&ft[qr];)if(ig=ft[qr++].exec(es))for(Ih=0;Ih<Hi.length;Ih++)pi=ig[++Ol],typeof(mo=Hi[Ih])===N&&mo.length>0?mo.length===2?typeof mo[1]==_?this[mo[0]]=mo[1].call(this,pi):this[mo[0]]=mo[1]:mo.length===3?typeof mo[1]!==_||mo[1].exec&&mo[1].test?this[mo[0]]=pi?pi.replace(mo[1],mo[2]):c:this[mo[0]]=pi?mo[1].call(this,pi,mo[2]):c:mo.length===4&&(this[mo[0]]=pi?mo[3].call(this,pi.replace(mo[1],mo[2])):c):this[mo]=pi||c;Qn+=2}},Zo=function(es,qs){for(var qr in qs)if(typeof qs[qr]===N&&qs[qr].length>0){for(var Ol=0;Ol<qs[qr].length;Ol++)if(da(qs[qr][Ol],es))return qr===b?c:qr}else if(da(qs[qr],es))return qr===b?c:qr;return es},oo={ME:"4.90","NT 3.11":"NT3.51","NT 4.0":"NT4.0",2e3:"NT 5.0",XP:["NT 5.1","NT 5.2"],Vista:"NT 6.0",7:"NT 6.1",8:"NT 6.2",8.1:"NT 6.3",10:["NT 6.4","NT 10.0"],RT:"ARM"},Xu={browser:[[/\b(?:crmo|crios)\/([\w\.]+)/i],[ue,[de,"Chrome"]],[/edg(?:e|ios|a)?\/([\w\.]+)/i],[ue,[de,"Edge"]],[/(opera mini)\/([-\w\.]+)/i,/(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,/(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i],[de,ue],[/opios[\/ ]+([\w\.]+)/i],[ue,[de,An+" Mini"]],[/\bop(?:rg)?x\/([\w\.]+)/i],[ue,[de,An+" GX"]],[/\bopr\/([\w\.]+)/i],[ue,[de,An]],[/\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i],[ue,[de,"Baidu"]],[/(kindle)\/([\w\.]+)/i,/(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,/(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i,/(?:ms|\()(ie) ([\w\.]+)/i,/(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,/(heytap|ovi)browser\/([\d\.]+)/i,/(weibo)__([\d\.]+)/i],[de,ue],[/\bddg\/([\w\.]+)/i],[ue,[de,"DuckDuckGo"]],[/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i],[ue,[de,"UC"+pt]],[/microm.+\bqbcore\/([\w\.]+)/i,/\bqbcore\/([\w\.]+).+microm/i,/micromessenger\/([\w\.]+)/i],[ue,[de,"WeChat"]],[/konqueror\/([\w\.]+)/i],[ue,[de,"Konqueror"]],[/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i],[ue,[de,"IE"]],[/ya(?:search)?browser\/([\w\.]+)/i],[ue,[de,"Yandex"]],[/slbrowser\/([\w\.]+)/i],[ue,[de,"Smart Lenovo "+pt]],[/(avast|avg)\/([\w\.]+)/i],[[de,/(.+)/,"$1 Secure "+pt],ue],[/\bfocus\/([\w\.]+)/i],[ue,[de,xt+" Focus"]],[/\bopt\/([\w\.]+)/i],[ue,[de,An+" Touch"]],[/coc_coc\w+\/([\w\.]+)/i],[ue,[de,"Coc Coc"]],[/dolfin\/([\w\.]+)/i],[ue,[de,"Dolphin"]],[/coast\/([\w\.]+)/i],[ue,[de,An+" Coast"]],[/miuibrowser\/([\w\.]+)/i],[ue,[de,"MIUI "+pt]],[/fxios\/([-\w\.]+)/i],[ue,[de,xt]],[/\bqihu|(qi?ho?o?|360)browser/i],[[de,"360 "+pt]],[/(oculus|sailfish|huawei|vivo)browser\/([\w\.]+)/i],[[de,/(.+)/,"$1 "+pt],ue],[/samsungbrowser\/([\w\.]+)/i],[ue,[de,Ea+" Internet"]],[/(comodo_dragon)\/([\w\.]+)/i],[[de,/_/g," "],ue],[/metasr[\/ ]?([\d\.]+)/i],[ue,[de,"Sogou Explorer"]],[/(sogou)mo\w+\/([\d\.]+)/i],[[de,"Sogou Mobile"],ue],[/(electron)\/([\w\.]+) safari/i,/(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,/m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i],[de,ue],[/(lbbrowser)/i,/\[(linkedin)app\]/i],[de],[/((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i],[[de,Ya],ue],[/(Klarna)\/([\w\.]+)/i,/(kakao(?:talk|story))[\/ ]([\w\.]+)/i,/(naver)\(.*?(\d+\.[\w\.]+).*\)/i,/safari (line)\/([\w\.]+)/i,/\b(line)\/([\w\.]+)\/iab/i,/(alipay)client\/([\w\.]+)/i,/(twitter)(?:and| f.+e\/([\w\.]+))/i,/(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i],[de,ue],[/\bgsa\/([\w\.]+) .*safari\//i],[ue,[de,"GSA"]],[/musical_ly(?:.+app_?version\/|_)([\w\.]+)/i],[ue,[de,"TikTok"]],[/headlesschrome(?:\/([\w\.]+)| )/i],[ue,[de,Lt+" Headless"]],[/ wv\).+(chrome)\/([\w\.]+)/i],[[de,Lt+" WebView"],ue],[/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i],[ue,[de,"Android "+pt]],[/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i],[de,ue],[/version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i],[ue,[de,"Mobile Safari"]],[/version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i],[ue,de],[/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i],[de,[ue,Zo,{"1.0":"/8",1.2:"/1",1.3:"/3","2.0":"/412","2.0.2":"/416","2.0.3":"/417","2.0.4":"/419","?":"/"}]],[/(webkit|khtml)\/([\w\.]+)/i],[de,ue],[/(navigator|netscape\d?)\/([-\w\.]+)/i],[[de,"Netscape"],ue],[/mobile vr; rv:([\w\.]+)\).+firefox/i],[ue,[de,xt+" Reality"]],[/ekiohf.+(flow)\/([\w\.]+)/i,/(swiftfox)/i,/(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,/(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,/(firefox)\/([\w\.]+)/i,/(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,/(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,/(links) \(([\w\.]+)/i,/panasonic;(viera)/i],[de,ue],[/(cobalt)\/([\w\.]+)/i],[de,[ue,/master.|lts./,""]]],cpu:[[/(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i],[[Ne,"amd64"]],[/(ia32(?=;))/i],[[Ne,Wn]],[/((?:i[346]|x)86)[;\)]/i],[[Ne,"ia32"]],[/\b(aarch64|arm(v?8e?l?|_?64))\b/i],[[Ne,"arm64"]],[/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i],[[Ne,"armhf"]],[/windows (ce|mobile); ppc;/i],[[Ne,"arm"]],[/((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i],[[Ne,/ower/,m,Wn]],[/(sun4\w)[;\)]/i],[[Ne,"sparc"]],[/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i],[[Ne,Wn]]],device:[[/\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i],[oe,[Re,Ea],[se,be]],[/\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,/samsung[- ]([-\w]+)/i,/sec-(sgh\w+)/i],[oe,[Re,Ea],[se,He]],[/(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i],[oe,[Re,bt],[se,He]],[/\((ipad);[-\w\),; ]+apple/i,/applecoremedia\/[\w\.]+ \((ipad)/i,/\b(ipad)\d\d?,\d\d?[;\]].+ios/i],[oe,[Re,bt],[se,be]],[/(macintosh);/i],[oe,[Re,bt]],[/\b(sh-?[altvz]?\d\d[a-ekm]?)/i],[oe,[Re,Ln],[se,He]],[/\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i],[oe,[Re,Li],[se,be]],[/(?:huawei|honor)([-\w ]+)[;\)]/i,/\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i],[oe,[Re,Li],[se,He]],[/\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,/\b; (\w+) build\/hm\1/i,/\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,/\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,/oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,/\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i],[[oe,/_/g," "],[Re,vs],[se,He]],[/oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,/\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i],[[oe,/_/g," "],[Re,vs],[se,be]],[/; (\w+) bui.+ oppo/i,/\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i],[oe,[Re,"OPPO"],[se,He]],[/\b(opd2\d{3}a?) bui/i],[oe,[Re,"OPPO"],[se,be]],[/vivo (\w+)(?: bui|\))/i,/\b(v[12]\d{3}\w?[at])(?: bui|;)/i],[oe,[Re,"Vivo"],[se,He]],[/\b(rmx[1-3]\d{3})(?: bui|;|\))/i],[oe,[Re,"Realme"],[se,He]],[/\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,/\bmot(?:orola)?[- ](\w*)/i,/((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i],[oe,[Re,ji],[se,He]],[/\b(mz60\d|xoom[2 ]{0,2}) build\//i],[oe,[Re,ji],[se,be]],[/((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i],[oe,[Re,cn],[se,be]],[/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,/\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,/\blg-?([\d\w]+) bui/i],[oe,[Re,cn],[se,He]],[/(ideatab[-\w ]+)/i,/lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i],[oe,[Re,"Lenovo"],[se,be]],[/(?:maemo|nokia).*(n900|lumia \d+)/i,/nokia[-_ ]?([-\w\.]*)/i],[[oe,/_/g," "],[Re,"Nokia"],[se,He]],[/(pixel c)\b/i],[oe,[Re,yi],[se,be]],[/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i],[oe,[Re,yi],[se,He]],[/droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i],[oe,[Re,ga],[se,He]],[/sony tablet [ps]/i,/\b(?:sony)?sgp\w+(?: bui|\))/i],[[oe,"Xperia Tablet"],[Re,ga],[se,be]],[/ (kb2005|in20[12]5|be20[12][59])\b/i,/(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i],[oe,[Re,"OnePlus"],[se,He]],[/(alexa)webm/i,/(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,/(kf[a-z]+)( bui|\)).+silk\//i],[oe,[Re,Xe],[se,be]],[/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i],[[oe,/(.+)/g,"Fire Phone $1"],[Re,Xe],[se,He]],[/(playbook);[-\w\),; ]+(rim)/i],[oe,Re,[se,be]],[/\b((?:bb[a-f]|st[hv])100-\d)/i,/\(bb10; (\w+)/i],[oe,[Re,Yt],[se,He]],[/(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i],[oe,[Re,Ot],[se,be]],[/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i],[oe,[Re,Ot],[se,He]],[/(nexus 9)/i],[oe,[Re,"HTC"],[se,be]],[/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,/(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,/(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i],[Re,[oe,/_/g," "],[se,He]],[/droid.+; ([ab][1-7]-?[0178a]\d\d?)/i],[oe,[Re,"Acer"],[se,be]],[/droid.+; (m[1-5] note) bui/i,/\bmz-([-\w]{2,})/i],[oe,[Re,"Meizu"],[se,He]],[/; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i],[oe,[Re,"Ulefone"],[se,He]],[/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,/(hp) ([\w ]+\w)/i,/(asus)-?(\w+)/i,/(microsoft); (lumia[\w ]+)/i,/(lenovo)[-_ ]?([-\w]+)/i,/(jolla)/i,/(oppo) ?([\w ]+) bui/i],[Re,oe,[se,He]],[/(kobo)\s(ereader|touch)/i,/(archos) (gamepad2?)/i,/(hp).+(touchpad(?!.+tablet)|tablet)/i,/(kindle)\/([\w\.]+)/i,/(nook)[\w ]+build\/(\w+)/i,/(dell) (strea[kpr\d ]*[\dko])/i,/(le[- ]+pan)[- ]+(\w{1,9}) bui/i,/(trinity)[- ]*(t\d{3}) bui/i,/(gigaset)[- ]+(q\w{1,9}) bui/i,/(vodafone) ([\w ]+)(?:\)| bui)/i],[Re,oe,[se,be]],[/(surface duo)/i],[oe,[Re,Ci],[se,be]],[/droid [\d\.]+; (fp\du?)(?: b|\))/i],[oe,[Re,"Fairphone"],[se,He]],[/(u304aa)/i],[oe,[Re,"AT&T"],[se,He]],[/\bsie-(\w*)/i],[oe,[Re,"Siemens"],[se,He]],[/\b(rct\w+) b/i],[oe,[Re,"RCA"],[se,be]],[/\b(venue[\d ]{2,7}) b/i],[oe,[Re,"Dell"],[se,be]],[/\b(q(?:mv|ta)\w+) b/i],[oe,[Re,"Verizon"],[se,be]],[/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i],[oe,[Re,"Barnes & Noble"],[se,be]],[/\b(tm\d{3}\w+) b/i],[oe,[Re,"NuVision"],[se,be]],[/\b(k88) b/i],[oe,[Re,"ZTE"],[se,be]],[/\b(nx\d{3}j) b/i],[oe,[Re,"ZTE"],[se,He]],[/\b(gen\d{3}) b.+49h/i],[oe,[Re,"Swiss"],[se,He]],[/\b(zur\d{3}) b/i],[oe,[Re,"Swiss"],[se,be]],[/\b((zeki)?tb.*\b) b/i],[oe,[Re,"Zeki"],[se,be]],[/\b([yr]\d{2}) b/i,/\b(dragon[- ]+touch |dt)(\w{5}) b/i],[[Re,"Dragon Touch"],oe,[se,be]],[/\b(ns-?\w{0,9}) b/i],[oe,[Re,"Insignia"],[se,be]],[/\b((nxa|next)-?\w{0,9}) b/i],[oe,[Re,"NextBook"],[se,be]],[/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i],[[Re,"Voice"],oe,[se,He]],[/\b(lvtel\-)?(v1[12]) b/i],[[Re,"LvTel"],oe,[se,He]],[/\b(ph-1) /i],[oe,[Re,"Essential"],[se,He]],[/\b(v(100md|700na|7011|917g).*\b) b/i],[oe,[Re,"Envizen"],[se,be]],[/\b(trio[-\w\. ]+) b/i],[oe,[Re,"MachSpeed"],[se,be]],[/\btu_(1491) b/i],[oe,[Re,"Rotor"],[se,be]],[/(shield[\w ]+) b/i],[oe,[Re,"Nvidia"],[se,be]],[/(sprint) (\w+)/i],[Re,oe,[se,He]],[/(kin\.[onetw]{3})/i],[[oe,/\./g," "],[Re,Ci],[se,He]],[/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i],[oe,[Re,ss],[se,be]],[/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i],[oe,[Re,ss],[se,He]],[/smart-tv.+(samsung)/i],[Re,[se,Ee]],[/hbbtv.+maple;(\d+)/i],[[oe,/^/,"SmartTV"],[Re,Ea],[se,Ee]],[/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i],[[Re,cn],[se,Ee]],[/(apple) ?tv/i],[Re,[oe,bt+" TV"],[se,Ee]],[/crkey/i],[[oe,Lt+"cast"],[Re,yi],[se,Ee]],[/droid.+aft(\w+)( bui|\))/i],[oe,[Re,Xe],[se,Ee]],[/\(dtv[\);].+(aquos)/i,/(aquos-tv[\w ]+)\)/i],[oe,[Re,Ln],[se,Ee]],[/(bravia[\w ]+)( bui|\))/i],[oe,[Re,ga],[se,Ee]],[/(mitv-\w{5}) bui/i],[oe,[Re,vs],[se,Ee]],[/Hbbtv.*(technisat) (.*);/i],[Re,oe,[se,Ee]],[/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,/hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i],[[Re,eo],[oe,eo],[se,Ee]],[/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i],[[se,Ee]],[/(ouya)/i,/(nintendo) ([wids3utch]+)/i],[Re,oe,[se,ze]],[/droid.+; (shield) bui/i],[oe,[Re,"Nvidia"],[se,ze]],[/(playstation [345portablevi]+)/i],[oe,[Re,ga],[se,ze]],[/\b(xbox(?: one)?(?!; xbox))[\); ]/i],[oe,[Re,Ci],[se,ze]],[/((pebble))app/i],[Re,oe,[se,Pe]],[/(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i],[oe,[Re,bt],[se,Pe]],[/droid.+; (glass) \d/i],[oe,[Re,yi],[se,Pe]],[/droid.+; (wt63?0{2,3})\)/i],[oe,[Re,ss],[se,Pe]],[/(quest( \d| pro)?)/i],[oe,[Re,Ya],[se,Pe]],[/(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i],[Re,[se,Qe]],[/(aeobc)\b/i],[oe,[Re,Xe],[se,Qe]],[/droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i],[oe,[se,He]],[/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i],[oe,[se,be]],[/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i],[[se,be]],[/(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i],[[se,He]],[/(android[-\w\. ]{0,9});.+buil/i],[oe,[Re,"Generic"]]],engine:[[/windows.+ edge\/([\w\.]+)/i],[ue,[de,"EdgeHTML"]],[/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i],[ue,[de,"Blink"]],[/(presto)\/([\w\.]+)/i,/(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,/ekioh(flow)\/([\w\.]+)/i,/(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,/(icab)[\/ ]([23]\.[\d\.]+)/i,/\b(libweb)/i],[de,ue],[/rv\:([\w\.]{1,9})\b.+(gecko)/i],[ue,de]],os:[[/microsoft (windows) (vista|xp)/i],[de,ue],[/(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i],[de,[ue,Zo,oo]],[/windows nt 6\.2; (arm)/i,/windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,/(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i],[[ue,Zo,oo],[de,"Windows"]],[/ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,/(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,/cfnetwork\/.+darwin/i],[[ue,/_/g,"."],[de,"iOS"]],[/(mac os x) ?([\w\. ]*)/i,/(macintosh|mac_powerpc\b)(?!.+haiku)/i],[[de,Ji],[ue,/_/g,"."]],[/droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i],[ue,de],[/(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,/(blackberry)\w*\/([\w\.]*)/i,/(tizen|kaios)[\/ ]([\w\.]+)/i,/\((series40);/i],[de,ue],[/\(bb(10);/i],[ue,[de,Yt]],[/(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i],[ue,[de,"Symbian"]],[/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i],[ue,[de,xt+" OS"]],[/web0s;.+rt(tv)/i,/\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i],[ue,[de,"webOS"]],[/watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i],[ue,[de,"watchOS"]],[/crkey\/([\d\.]+)/i],[ue,[de,Lt+"cast"]],[/(cros) [\w]+(?:\)| ([\w\.]+)\b)/i],[[de,ir],ue],[/panasonic;(viera)/i,/(netrange)mmh/i,/(nettv)\/(\d+\.[\w\.]+)/i,/(nintendo|playstation) ([wids345portablevuch]+)/i,/(xbox); +xbox ([^\);]+)/i,/\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,/(mint)[\/\(\) ]?(\w*)/i,/(mageia|vectorlinux)[; ]/i,/([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,/(hurd|linux) ?([\w\.]*)/i,/(gnu) ?([\w\.]*)/i,/\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,/(haiku) (\w+)/i],[de,ue],[/(sunos) ?([\w\.\d]*)/i],[[de,"Solaris"],ue],[/((?:open)?solaris)[-\/ ]?([\w\.]*)/i,/(aix) ((\d)(?=\.|\)| )[\w\.])*/i,/\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,/(unix) ?([\w\.]*)/i],[de,ue]]},kd=function(es,qs){if(typeof es===N&&(qs=es,es=c),!(this instanceof kd))return new kd(es,qs).getResult();var qr=typeof s!==k&&s.navigator?s.navigator:c,Ol=es||(qr&&qr.userAgent?qr.userAgent:m),Ih=qr&&qr.userAgentData?qr.userAgentData:c,mo=qs?pa(Xu,qs):Xu,ig=qr&&qr.userAgent==Ol;return this.getBrowser=function(){var pi={};return pi[de]=c,pi[ue]=c,Uo.call(pi,Ol,mo.browser),pi[ee]=co(pi[ue]),ig&&qr&&qr.brave&&typeof qr.brave.isBrave==_&&(pi[de]="Brave"),pi},this.getCPU=function(){var pi={};return pi[Ne]=c,Uo.call(pi,Ol,mo.cpu),pi},this.getDevice=function(){var pi={};return pi[Re]=c,pi[oe]=c,pi[se]=c,Uo.call(pi,Ol,mo.device),ig&&!pi[se]&&Ih&&Ih.mobile&&(pi[se]=He),ig&&pi[oe]=="Macintosh"&&qr&&typeof qr.standalone!==k&&qr.maxTouchPoints&&qr.maxTouchPoints>2&&(pi[oe]="iPad",pi[se]=be),pi},this.getEngine=function(){var pi={};return pi[de]=c,pi[ue]=c,Uo.call(pi,Ol,mo.engine),pi},this.getOS=function(){var pi={};return pi[de]=c,pi[ue]=c,Uo.call(pi,Ol,mo.os),ig&&!pi[de]&&Ih&&Ih.platform&&Ih.platform!="Unknown"&&(pi[de]=Ih.platform.replace(/chrome os/i,ir).replace(/macos/i,Ji)),pi},this.getResult=function(){return{ua:this.getUA(),browser:this.getBrowser(),engine:this.getEngine(),os:this.getOS(),device:this.getDevice(),cpu:this.getCPU()}},this.getUA=function(){return Ol},this.setUA=function(pi){return Ol=typeof pi===W&&pi.length>Ze?eo(pi,Ze):pi,this},this.setUA(Ol),this};kd.VERSION=u,kd.BROWSER=Ca([de,ue,ee]),kd.CPU=Ca([Ne]),kd.DEVICE=Ca([oe,Re,se,ze,He,Ee,be,Pe,Qe]),kd.ENGINE=kd.OS=Ca([de,ue]),typeof n!==k?(typeof a!==k&&a.exports&&(n=a.exports=kd),n.UAParser=kd):typeof s!==k&&(s.UAParser=kd);var jg=typeof s!==k&&(s.jQuery||s.Zepto);if(jg&&!jg.ua){var Ah=new kd;jg.ua=Ah.getResult(),jg.ua.get=function(){return Ah.getUA()},jg.ua.set=function(es){Ah.setUA(es);var qs=Ah.getResult();for(var qr in qs)jg.ua[qr]=qs[qr]}}})(typeof window=="object"?window:n)}}),No=oi({"../node_modules/@skype/hydra_player_sdk/hydra_player_sdk_bundle.js"(n,a){var s,c;s=n,c=function(){return u={103:function(b,_){Object.defineProperty(_,"__esModule",{value:!0}),_.defer=void 0,_.defer=function(){var k,N;return{promise:new Promise(function(W,ee){k=W,N=ee}),resolve:k,reject:N}}},457:function(b,_){Object.defineProperty(_,"__esModule",{value:!0}),_.iframeConfigDefault=void 0,_.iframeConfigDefault={scriptSrcDownload:!1,allowSameOrigin:!1}},1:function(b,_){Object.defineProperty(_,"__esModule",{value:!0}),_.liveStreamStatisticConfigDefault=void 0,_.liveStreamStatisticConfigDefault={maxUserInitiatedEventCount:100}},318:function(b,_){Object.defineProperty(_,"__esModule",{value:!0}),_.logSupportedCodecsConfigDefault=void 0,_.logSupportedCodecsConfigDefault={logSupportedCodecs:!1}},508:function(b,_){Object.defineProperty(_,"__esModule",{value:!0}),_.webRtcIceCandidateCollectorConfigDefault=void 0,_.webRtcIceCandidateCollectorConfigDefault={WebRtcIceCandidateCollectorDelayAfterCompleteMs:2500,WebRtcIceCandidateCollectorDelayAfterErrorMs:1e3,WebRtcIceCandidateCollectorMaxRetriesMs:5,WebRtcIceCandidateCollectorRetryDelayMs:100,WebRtcIceCandidateCollectorMaxCollectionTimeMs:6e4,WebRtcIceCandidateCollectorDisableCollection:!1}},10:function(b,_){Object.defineProperty(_,"__esModule",{value:!0}),_.default=function(){return"xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g,function(k){var N=16*Math.random()|0;return(k==="x"?N:3&N|8).toString(16)})}},171:function(b,_,k){var N=this&&this.__assign||function(){return N=Object.assign||function(be){for(var Ee,Pe=1,Qe=arguments.length;Pe<Qe;Pe++)for(var Ze in Ee=arguments[Pe])Object.prototype.hasOwnProperty.call(Ee,Ze)&&(be[Ze]=Ee[Ze]);return be},N.apply(this,arguments)},W=this&&this.__awaiter||function(be,Ee,Pe,Qe){return new(Pe||(Pe=Promise))(function(Ze,Xe){function bt(pt){try{Yt(Qe.next(pt))}catch(Lt){Xe(Lt)}}function Ot(pt){try{Yt(Qe.throw(pt))}catch(Lt){Xe(Lt)}}function Yt(pt){var Lt;pt.done?Ze(pt.value):(Lt=pt.value,Lt instanceof Pe?Lt:new Pe(function(xt){xt(Lt)})).then(bt,Ot)}Yt((Qe=Qe.apply(be,Ee||[])).next())})},ee=this&&this.__generator||function(be,Ee){var Pe,Qe,Ze,Xe,bt={label:0,sent:function(){if(1&Ze[0])throw Ze[1];return Ze[1]},trys:[],ops:[]};return Xe={next:Ot(0),throw:Ot(1),return:Ot(2)},typeof Symbol=="function"&&(Xe[Symbol.iterator]=function(){return this}),Xe;function Ot(Yt){return function(pt){return function(Lt){if(Pe)throw new TypeError("Generator is already executing.");for(;Xe&&(Xe=0,Lt[0]&&(bt=0)),bt;)try{if(Pe=1,Qe&&(Ze=2&Lt[0]?Qe.return:Lt[0]?Qe.throw||((Ze=Qe.return)&&Ze.call(Qe),0):Qe.next)&&!(Ze=Ze.call(Qe,Lt[1])).done)return Ze;switch(Qe=0,Ze&&(Lt=[2&Lt[0],Ze.value]),Lt[0]){case 0:case 1:Ze=Lt;break;case 4:return bt.label++,{value:Lt[1],done:!1};case 5:bt.label++,Qe=Lt[1],Lt=[0];continue;case 7:Lt=bt.ops.pop(),bt.trys.pop();continue;default:if(!((Ze=(Ze=bt.trys).length>0&&Ze[Ze.length-1])||Lt[0]!==6&&Lt[0]!==2)){bt=0;continue}if(Lt[0]===3&&(!Ze||Lt[1]>Ze[0]&&Lt[1]<Ze[3])){bt.label=Lt[1];break}if(Lt[0]===6&&bt.label<Ze[1]){bt.label=Ze[1],Ze=Lt;break}if(Ze&&bt.label<Ze[2]){bt.label=Ze[2],bt.ops.push(Lt);break}Ze[2]&&bt.ops.pop(),bt.trys.pop();continue}Lt=Ee.call(be,bt)}catch(xt){Lt=[6,xt],Qe=0}finally{Pe=Ze=0}if(5&Lt[0])throw Lt[1];return{value:Lt[0]?Lt[1]:void 0,done:!0}}([Yt,pt])}}},oe=this&&this.__spreadArray||function(be,Ee,Pe){if(Pe||arguments.length===2)for(var Qe,Ze=0,Xe=Ee.length;Ze<Xe;Ze++)!Qe&&Ze in Ee||(Qe||(Qe=Array.prototype.slice.call(Ee,0,Ze)),Qe[Ze]=Ee[Ze]);return be.concat(Qe||Array.prototype.slice.call(Ee))};Object.defineProperty(_,"__esModule",{value:!0}),_.LiveStreamStatistic=_.PlayerScenario=void 0;var de=k(346),se=k(963),Re=k(1),ue=k(534),Ne=k(318),ze=function(){function be(Ee,Pe,Qe){this.name=Ee,this.details=Pe,this.failReason=Qe,this.timeStamp=Date.now()}return be.prototype.getName=function(){return this.name},be.prototype.getFailReason=function(){return this.failReason},be.prototype.getDetails=function(){return this.details},be.prototype.getTimeStamp=function(){return this.timeStamp},be}();_.PlayerScenario=ze;var He=function(){function be(Ee,Pe,Qe,Ze){this.config=Ee,this.logFn=Pe,this.playerDiagnosticsLog=Qe,this.playerMetadata=Ze,this.playerEvents=[],this.playbackEvents=[],this.ecdnPluginEvents=[],this.experimentalEvents=[],this.userInitiatedSeekEvents=[],this.userInitiatedPlayEvents=[],this.userInitiatedPauseEvents=[],this.hydraInitResult=null,this.callSetupSucceeded=!1,this.callDropped=!1,this.latestErrorReason=void 0,this.clientNetworkType=void 0,this.supportedCodecs=void 0,this.maxPlayerPlaybackEventCount=Ee.maxPlayerPlaybackEventCount||5,this.maxPlayerDiagnosticsCount=Ee.maxPlayerDiagnosticsCount||5,this.maxPlayerMemoryTraceLogCount=Ee.maxPlayerMemoryTraceLogCount||100,this.maxPlayerExperimentalEvents=Ee.maxPlayerExperimentalEvents||100,this.maxUserInitiatedEventCount=ue.getECSSetting(this.config,"maxUserInitiatedEventCount",Re.liveStreamStatisticConfigDefault.maxUserInitiatedEventCount),this.config.debugLogging&&(this.playerDiagnosticsLog.memoryLog=[]),this.addNetworkTypeEventListener(),ue.getECSSetting(this.config,"logSupportedCodecs",Ne.logSupportedCodecsConfigDefault.logSupportedCodecs)&&this.populateSupportedCodecs()}return be.prototype.getPlayerDiagnosticSnapshot=function(){return this.currentPlayerDiagnosticSnapshot},be.prototype.setHydraInitResult=function(Ee){this.hydraInitResult=Ee},be.prototype.registerStatsUpdated=function(Ee){var Pe=this;this.currentPlayerDiagnosticSnapshot=Ee,Object.keys(this.playerDiagnosticsLog).forEach(function(Qe){var Ze,Xe=Qe,bt=(Ze=Pe.playerDiagnosticsLog[Qe])!==null&&Ze!==void 0?Ze:[];if(Array.isArray(bt)){bt.push(Ee[Xe]);var Ot=Xe==="memoryLog"&&bt.length>Pe.maxPlayerMemoryTraceLogCount,Yt=Xe!=="memoryLog"&&bt.length>Pe.maxPlayerDiagnosticsCount;(Ot||Yt)&&bt.splice(0,1)}else Pe.playerDiagnosticsLog[Qe]=Ee[Xe]})},be.prototype.registerEventLoadAttempt=function(Ee,Pe){this.registerScenario(Ee,Pe)},be.prototype.registerEventLoadFailed=function(Ee,Pe){this.completeScenario(Ee,Pe)},be.prototype.registerEventLoadSucceeded=function(Ee,Pe){this.completeScenario(Ee,void 0,Pe),Ee===se.PlayerScenarioType.LoadPlayer&&(this.callSetupSucceeded=!0)},be.prototype.registerSdnPluginLoadAttempt=function(Ee){this.registerScenario(se.PlayerScenarioType.SdnPluginLoad,Ee)},be.prototype.registerSdnPluginLoadFailed=function(Ee){this.completeScenario(se.PlayerScenarioType.SdnPluginLoad,Ee)},be.prototype.registerSdnPluginLoadSucceeded=function(Ee){this.completeScenario(se.PlayerScenarioType.SdnPluginLoad,void 0,Ee)},be.prototype.registerSdnPluginInitializeAttempt=function(Ee){this.registerScenario(se.PlayerScenarioType.SdnPluginInitialize,Ee)},be.prototype.registerSdnPluginInitializeFailed=function(Ee){this.completeScenario(se.PlayerScenarioType.SdnPluginInitialize,Ee)},be.prototype.registerSdnPluginInitializeSucceeded=function(Ee){this.completeScenario(se.PlayerScenarioType.SdnPluginInitialize,void 0,Ee)},be.prototype.registerSdnPluginSetSourceAttempt=function(Ee){this.registerScenario(se.PlayerScenarioType.SdnPluginSetSource,Ee)},be.prototype.registerSdnPluginSetSourceFailed=function(Ee){this.completeScenario(se.PlayerScenarioType.SdnPluginSetSource,Ee)},be.prototype.registerSdnPluginSetSourceSucceeded=function(Ee){this.completeScenario(se.PlayerScenarioType.SdnPluginSetSource,void 0,Ee)},be.prototype.registerStreamConnectionAttempt=function(Ee){this.registerScenario(se.PlayerScenarioType.StreamConnection,{streamUrl:Ee})},be.prototype.registerStreamConnectionSucceeded=function(Ee){this.completeScenario(se.PlayerScenarioType.StreamConnection,void 0,{result:ue.stringifyObject(Ee)})},be.prototype.registerStreamConnectionFailed=function(Ee,Pe){this.completeScenario(se.PlayerScenarioType.StreamConnection,Ee,{result:ue.stringifyObject(Pe)})},be.prototype.registerSetSourceAttempt=function(Ee,Pe,Qe){var Ze=Ee||"";Qe&&(Ze={src:Ee||"",isPrimary:ue.stringifyObject(Pe),reason:Qe}),this.registerScenario(se.PlayerScenarioType.SetSource,Ze)},be.prototype.registerSetSourceSucceeded=function(Ee,Pe,Qe,Ze,Xe){this.completeScenario(se.PlayerScenarioType.SetSource,void 0,{src:Ee,isPrimary:ue.stringifyObject(Pe),switchingDiagnostics:ue.stringifyObject(Qe),stepDuration:ue.stringifyObject(Ze),initialSeekToLiveEdge:ue.stringifyObject(Xe)})},be.prototype.registerSetSourceFailed=function(Ee,Pe,Qe,Ze,Xe){this.completeScenario(se.PlayerScenarioType.SetSource,Ee,{src:ue.stringifyObject(Pe),isPrimary:ue.stringifyObject(Qe),switchingDiagnostics:ue.stringifyObject(Ze),stepDuration:ue.stringifyObject(Xe)})},be.prototype.registerPlayerDestroyed=function(Ee){this.registerScenario(se.PlayerScenarioType.Destroyed,Ee),this.completeScenario(se.PlayerScenarioType.Destroyed)},be.prototype.registerPlaybackStateChanged=function(Ee,Pe){var Qe,Ze,Xe,bt,Ot,Yt;if(Ee!==de.HydraPlayerPlaybackState.CanPlayThrough||this.firstReadyStateTimestamp){if(Ee===de.HydraPlayerPlaybackState.Playing){if(this.firstPlayingState||(this.firstPlayingState={timestamp:Date.now()},Pe&&(Pe.edgeLatency&&(this.firstPlayingState.edgeLatency=Pe.edgeLatency),Pe.bufferLength&&(this.firstPlayingState.bufferLength=Pe.bufferLength))),this.userInitiatedSeekEvents.length>0){var pt=this.userInitiatedSeekEvents[this.userInitiatedSeekEvents.length-1];this.modifyTelemetryEventPayload(pt,{playingStatePosition:(Ze=(Qe=this.currentPlayerDiagnosticSnapshot)===null||Qe===void 0?void 0:Qe.currentPlayPosition)!==null&&Ze!==void 0?Ze:-1,playingStateTimestamp:Date.now()},!1)}if(this.userInitiatedPlayEvents.length>0){var Lt=this.userInitiatedPlayEvents[this.userInitiatedPlayEvents.length-1];this.modifyTelemetryEventPayload(Lt,{playingStatePosition:(bt=(Xe=this.currentPlayerDiagnosticSnapshot)===null||Xe===void 0?void 0:Xe.currentPlayPosition)!==null&&bt!==void 0?bt:-1,playingStateTimestamp:Date.now()},!1)}}else if(Ee===de.HydraPlayerPlaybackState.Pause&&this.userInitiatedPauseEvents.length>0){var xt=this.userInitiatedPauseEvents[this.userInitiatedPauseEvents.length-1];this.modifyTelemetryEventPayload(xt,{pauseStatePosition:(Yt=(Ot=this.currentPlayerDiagnosticSnapshot)===null||Ot===void 0?void 0:Ot.currentPlayPosition)!==null&&Yt!==void 0?Yt:-1,pauseStateTimestamp:Date.now()},!1)}}else this.firstReadyStateTimestamp=Date.now();this.registerPlaybackEvent(se.TelemetryEventType.StateChanged,Ee)},be.prototype.registerCapabilitiesUpdated=function(Ee){this.registerPlaybackEvent(se.TelemetryEventType.CapabilitiesUpdated,Ee)},be.prototype.registerHydraInputStateChanged=function(Ee,Pe){this.registerPlaybackEvent(se.TelemetryEventType.HydraInputStateChanged,Ee,Pe)},be.prototype.registerHydraOutputStateChanged=function(Ee,Pe){this.registerPlaybackEvent(se.TelemetryEventType.HydraOutputStateChanged,Ee,Pe)},be.prototype.registerPlaybackBuffering=function(Ee){this.registerPlaybackEvent(se.TelemetryEventType.Buffering,Ee)},be.prototype.registerSdnPluginEvent=function(Ee){var Pe=this.createTelemetryEvent(se.TelemetryEventType.EcdnPluginEvents,Ee);this.ecdnPluginEvents.push(Pe),this.ecdnPluginEvents.length>this.maxPlayerPlaybackEventCount&&this.ecdnPluginEvents.splice(0,1),this.logTelemetryEvent(Pe)},be.prototype.registerPlaybackError=function(Ee,Pe,Qe,Ze){this.registerPlaybackEvent(se.TelemetryEventType.Error,{errorType:Ee,details:Pe,errorSource:Qe,errorReason:Ze}),this.latestErrorReason=Ze},be.prototype.registerIgnoredPlaybackError=function(Ee){this.registerPlaybackEvent(se.TelemetryEventType.IgnoredError,Ee)},be.prototype.registerDownloadBitrateChanged=function(Ee){this.registerPlaybackEvent(se.TelemetryEventType.BitrateChangedDownload,Ee)},be.prototype.registerStreamOptionsConfigured=function(Ee,Pe){this.registerPlaybackEvent(se.TelemetryEventType.StreamOptionsConfigured,Ee,Pe)},be.prototype.registerPlaybackBitrateChanged=function(Ee){this.registerPlaybackEvent(se.TelemetryEventType.BitrateChangedPlayback,Ee)},be.prototype.registerVolumeChange=function(Ee){this.registerPlaybackEvent(se.TelemetryEventType.Volume,Ee)},be.prototype.getSnapshotReport=function(){var Ee,Pe,Qe=[this.getTotalLoadEvent(),this.getHydraLoadEvent()].concat(this.buildCompleteTelemetryEvent()),Ze=this.playbackEvents,Xe={};this.currentPlayerDiagnosticSnapshot&&(Xe=this.filterAndPrepareTelemetry());var bt=ue.getECSSetting(this.config,"logSupportedCodecs",Ne.logSupportedCodecsConfigDefault.logSupportedCodecs);return N(N(N(N(N(N(N(N(N(N(N(N(N(N(N(N({isFullReport:!1,configIds:this.config.configIds||"",eTag:this.config.eTag||""},this.getPlayerMetadataReport()),{isIframe:!0,isFullscreenButtonDisabled:!1,telemetryTickMs:(Pe=(Ee=this.currentPlayerDiagnosticSnapshot)===null||Ee===void 0?void 0:Ee.statsInterval)!==null&&Pe!==void 0?Pe:-1}),this.getHydraInitializationReport()),this.getPlayerInitializationReport(Qe)),this.getHydraInternalReport(Ze)),this.getPlaybackReport(Ze)),this.getBitrateReport(Ze)),this.getStreamConnectionReport(Qe)),this.getSdnReport(Qe)),this.getSetSourceReport(Qe)),this.getExperimentalEvents()),this.getUserInitiatedSeekEvents()),{networkType:this.getClientNetworkType()}),bt?{supportedCodecs:ue.stringifyObject(this.supportedCodecs)}:{}),{callSetupSucceeded:this.callSetupSucceeded,callDropped:this.callDropped}),Xe)},be.prototype.getReport=function(){var Ee,Pe,Qe,Ze,Xe=[this.getTotalLoadEvent(),this.getHydraLoadEvent()].concat(this.buildCompleteTelemetryEvent()),bt=this.playbackEvents,Ot=ue.getECSSetting(this.config,"logSupportedCodecs",Ne.logSupportedCodecsConfigDefault.logSupportedCodecs);return N(N(N(N(N(N(N(N(N(N(N(N(N(N(N(N(N({isFullReport:!0,configIds:this.config.configIds||"",eTag:this.config.eTag||""},this.getPlayerMetadataReport()),{isIframe:!0,isFullscreenButtonDisabled:!1,telemetryTickMs:(Pe=(Ee=this.currentPlayerDiagnosticSnapshot)===null||Ee===void 0?void 0:Ee.statsInterval)!==null&&Pe!==void 0?Pe:-1}),this.getHydraInitializationReport()),this.getPlayerInitializationReport(Xe)),this.getHydraInternalReport(bt)),this.getPlaybackReport(bt)),this.getBitrateReport(bt)),this.getStreamConnectionReport(Xe)),this.getSdnReport(Xe)),this.getSetSourceReport(Xe)),this.getExperimentalEvents()),this.getUserInitiatedSeekEvents()),{networkType:this.getClientNetworkType()}),Ot?{supportedCodecs:ue.stringifyObject(this.supportedCodecs)}:{}),{callSetupSucceeded:this.callSetupSucceeded,callDropped:this.callDropped}),this.getPlayerDiagnosticLog()),{eventId:((Qe=this.currentPlayerDiagnosticSnapshot)===null||Qe===void 0?void 0:Qe.eventId)||"",templateId:((Ze=this.currentPlayerDiagnosticSnapshot)===null||Ze===void 0?void 0:Ze.templateId)||""})},be.prototype.buildCompleteTelemetryEvent=function(){this.playerEvents.sort(function(xt,yi){return xt.getName()!==yi.getName()?Object.keys(se.PlayerScenarioType).indexOf(xt.getName())-Object.keys(se.PlayerScenarioType).indexOf(yi.getName()):xt.getTimeStamp()-yi.getTimeStamp()});for(var Ee,Pe,Qe,Ze,Xe,bt=[],Ot=0,Yt=this.playerEvents;Ot<Yt.length;Ot++){var pt=Yt[Ot],Lt=bt[bt.length-1];bt.length&&pt.getName()===Lt.name&&Lt.duration===0?bt[bt.length-1]=(Ee=Lt,Qe=(Pe=pt).getFailReason()?{failReason:Pe.getFailReason()}:{},Ze=Pe.getDetails()?{details:Pe.getDetails()}:{},Xe={name:Ee.name,startTime:Ee.startTime,duration:Pe.getTimeStamp()>Ee.startTime?Pe.getTimeStamp()-Ee.startTime:Ee.duration},N(N(N({},Xe),Qe),Ze)):bt.push({name:se.PlayerScenarioType[pt.getName()],startTime:pt.getTimeStamp(),duration:0})}return bt},be.prototype.getHydraLoadEvent=function(){var Ee,Pe,Qe,Ze={name:se.PlayerScenarioType.LoadHydra,startTime:((Ee=this.hydraInitResult)===null||Ee===void 0?void 0:Ee.initStartTime)||-1,duration:((Pe=this.hydraInitResult)===null||Pe===void 0?void 0:Pe.initDuration)||0};!((Qe=this.hydraInitResult)===null||Qe===void 0)&&Qe.errorMsg&&(Ze.failReason=this.hydraInitResult.errorMsg);var Xe=this.getHydraRuntimeDownloadDetails();return Xe&&(Ze.details=Xe),Ze},be.prototype.getHydraRuntimeDownloadDetails=function(){if(this.hydraInitResult){for(var Ee=[],Pe=0,Qe=this.hydraInitResult.runtimeDownloadResults;Pe<Qe.length;Pe++){var Ze=Qe[Pe],Xe={success:Ze.success,url:Ze.url,startTime:Ze.startTime,duration:Ze.duration,trackingReference:Ze.trackingReference,timeTakenToDownloadScript:Ze.timeTakenToDownloadScript};Ze.errorMsg&&(Xe.errorMsg=Ze.errorMsg),Ee.push(Xe)}return ue.stringifyObject(Ee)}return null},be.prototype.getTotalLoadEvent=function(){var Ee,Pe,Qe,Ze=this.getScenario(se.PlayerScenarioType.LoadPlayer),Xe=((Ee=this.hydraInitResult)===null||Ee===void 0?void 0:Ee.initDuration)||0,bt=Ze.length>0?Ze[Ze.length-1].getTimeStamp()-Ze[0].getTimeStamp():0,Ot=Ze.length>0?Ze[Ze.length-1].getFailReason():void 0,Yt={name:se.PlayerScenarioType.Load,startTime:((Pe=this.hydraInitResult)===null||Pe===void 0?void 0:Pe.initStartTime)||-1,duration:Xe+bt};return!((Qe=this.hydraInitResult)===null||Qe===void 0)&&Qe.errorMsg?Yt.failReason=this.hydraInitResult.errorMsg:Ot&&(Yt.failReason=Ot),Yt},be.prototype.getPlayerMetadataReport=function(){return{playerId:this.playerMetadata.playerId||"",traceId:this.playerMetadata.playerId?this.playerMetadata.playerId.replace(/-/g,""):"",hydraPlayerRuntimeVersion:this.playerMetadata.hydraPlayerRuntimeVersion||"",hydraPlayerSdkVersion:this.playerMetadata.hydraPlayerSdkVersion,player_playerType:this.playerMetadata.hydraPlayerType}},be.prototype.registerPlaybackEvent=function(Ee,Pe,Qe){var Ze=this.createTelemetryEvent(Ee,Pe,Qe);Ee===se.TelemetryEventType.Error&&Pe?.errorType!==de.HydraPlayerPlaybackErrorType.PlaybackRetried&&(Ze.fatal=!0,this.callDropped=!0),this.playbackEvents.push(Ze),this.playbackEvents.length>this.maxPlayerPlaybackEventCount&&this.playbackEvents.splice(0,1),this.logTelemetryEvent(Ze)},be.prototype.getPlayerDiagnosticLog=function(){var Ee=this;if(!this.currentPlayerDiagnosticSnapshot)return{};var Pe=this.currentPlayerDiagnosticSnapshot,Qe=this.playerDiagnosticsLog,Ze=N(N({},Pe),Qe),Xe={};return Object.keys(Ze).forEach(function(bt){Xe["player_".concat(bt)]=Ee.prepareForTelemetry(Ze[bt])}),Xe},be.prototype.getHydraInitializationReport=function(){var Ee,Pe,Qe,Ze;return{hydraInit_succeeded:((Ee=this.hydraInitResult)===null||Ee===void 0?void 0:Ee.initSucceeded)||!1,hydraInit_startTime:((Pe=this.hydraInitResult)===null||Pe===void 0?void 0:Pe.initStartTime)||-1,hydraInit_errorMessage:((Qe=this.hydraInitResult)===null||Qe===void 0?void 0:Qe.errorMsg)||"",hydraInit_duration:((Ze=this.hydraInitResult)===null||Ze===void 0?void 0:Ze.initDuration)||0}},be.prototype.getPlayerInitializationReport=function(Ee){var Pe,Qe=Ee.find(function(bt){return bt.name===se.PlayerScenarioType.Load}),Ze=this.playerEvents.find(function(bt){return bt.getName()===se.PlayerScenarioType.StreamConnection}),Xe={init_timeLoadToStreamConnectionEstablished:(Qe&&Ze?Ze.getTimeStamp()-Qe.startTime:-1)||-1,init_timeLoadToReady:(Qe&&this.firstReadyStateTimestamp?this.firstReadyStateTimestamp-Qe.startTime:-1)||-1,init_timeLoadToPlaying:(Qe&&(!((Pe=this.firstPlayingState)===null||Pe===void 0)&&Pe.timestamp)?this.firstPlayingState.timestamp-Qe.startTime:-1)||-1,init_allEvents:this.prepareForTelemetry(Ee)};return this.firstPlayingState&&(Xe.init_firstPlayingStateStatistics=this.prepareForTelemetry(this.firstPlayingState)),Xe},be.prototype.getHydraInternalReport=function(Ee){var Pe=Ee.filter(function(Ze){return Ze.eventType===se.TelemetryEventType.HydraInputStateChanged}),Qe=Ee.filter(function(Ze){return Ze.eventType===se.TelemetryEventType.HydraOutputStateChanged});return{hydra_inputStateChangeEvents:this.prepareForTelemetry(Pe),hydra_outputStateChangeEvents:this.prepareForTelemetry(Qe)}},be.prototype.getPlaybackReport=function(Ee){var Pe=Ee.filter(function(ga){return ga.eventType===se.TelemetryEventType.StateChanged}),Qe=Pe.find(function(ga){return ga.payload===de.HydraPlayerPlaybackState.CanPlayThrough}),Ze=Pe.find(function(ga){return ga.payload===de.HydraPlayerPlaybackState.Play}),Xe=Pe.find(function(ga){return ga.payload===de.HydraPlayerPlaybackState.Start}),bt=Pe.find(function(ga){return ga.payload===de.HydraPlayerPlaybackState.Playing}),Ot=Qe!=null&&Ze!=null?Ze.timestamp-Qe.timestamp:-1,Yt=Ze!=null&&Xe!=null?Xe.timestamp-Ze.timestamp:-1,pt=Xe!=null&&bt!=null?bt.timestamp-Xe.timestamp:-1,Lt=Pe.filter(function(ga){return ga.payload===de.HydraPlayerPlaybackState.Seeked}),xt=Pe.filter(function(ga){return ga.payload===de.HydraPlayerPlaybackState.Seeking}),yi=Pe.filter(function(ga){return ga.payload===de.HydraPlayerPlaybackState.Pause}),Li=Pe.filter(function(ga){return ga.payload===de.HydraPlayerPlaybackState.Waiting}),cn=[se.TelemetryEventType.BitrateChangedDownload,se.TelemetryEventType.BitrateChangedPlayback,se.TelemetryEventType.Error,se.TelemetryEventType.Mute,se.TelemetryEventType.StateChanged,se.TelemetryEventType.Volume,se.TelemetryEventType.StreamOptionsConfigured,se.TelemetryEventType.IgnoredError],Ci=Ee.filter(function(ga){return ga.eventType===se.TelemetryEventType.Error}),ji=Ee.filter(function(ga){return ga.eventType===se.TelemetryEventType.IgnoredError}),An=Ee.filter(function(ga){return ga.eventType===se.TelemetryEventType.Volume||ga.eventType===se.TelemetryEventType.Mute}),Ea=Ee.filter(function(ga){return ga.eventType===se.TelemetryEventType.StreamOptionsConfigured}),Ln=Ee.filter(function(ga){return!cn.includes(ga.eventType)});return{playback_timeReadyToPlay:Ot,playback_timePlayToStart:Yt,playback_timeStartToPlaying:pt,playback_bufferingEvents:this.prepareForTelemetry(Li),playback_errorEvents:this.prepareForTelemetry(Ci),playback_ignoredErrorEvents:this.prepareForTelemetry(ji),playback_pauseEvents:this.prepareForTelemetry(yi),playback_otherEvents:this.prepareForTelemetry(Ln),playback_seekedEvents:this.prepareForTelemetry(Lt),playback_seekingEvents:this.prepareForTelemetry(xt),playback_stateChangeEvents:this.prepareForTelemetry(Pe),playback_volumeEvents:this.prepareForTelemetry(An),playback_streamOptionsConfiguredEvents:this.prepareForTelemetry(Ea),playback_latestErrorReason:this.latestErrorReason||""}},be.prototype.getBitrateReport=function(Ee){var Pe,Qe,Ze,Xe,bt=Ee.filter(function(yi){return yi.eventType===se.TelemetryEventType.BitrateChangedDownload}),Ot=bt.sort(function(yi){return Number(yi.payload)}),Yt=bt.length>0?{bitrate_downloadChanges:this.prepareForTelemetry(bt),bitrate_downloadChangeCount:bt.length>0||-1,bitrate_downloadMin:((Pe=Ot[0])===null||Pe===void 0?void 0:Pe.payload)||-1,bitrate_downloadMax:((Qe=Ot[Ot.length-1])===null||Qe===void 0?void 0:Qe.payload)||-1}:{},pt=Ee.filter(function(yi){return yi.eventType===se.TelemetryEventType.BitrateChangedPlayback}),Lt=pt.sort(function(yi){return Number(yi.payload)}),xt=pt.length>0?{bitrate_playbackChanges:this.prepareForTelemetry(pt),bitrate_playbackChangeCount:pt.length>0||-1,bitrate_playbackMin:((Ze=Lt[0])===null||Ze===void 0?void 0:Ze.payload)||-1,bitrate_playbackMax:((Xe=Lt[Lt.length-1])===null||Xe===void 0?void 0:Xe.payload)||-1}:{};return N(N({},Yt),xt)},be.prototype.addNetworkTypeEventListener=function(){var Ee,Pe,Qe,Ze,Xe=this;!((Pe=(Ee=window.navigator)===null||Ee===void 0?void 0:Ee.connection)===null||Pe===void 0)&&Pe.type&&((Ze=(Qe=window.navigator)===null||Qe===void 0?void 0:Qe.connection)===null||Ze===void 0||Ze.addEventListener("change",function(){Xe.updateClientNetworkType()}))},be.prototype.updateClientNetworkType=function(){this.clientNetworkType=void 0,this.getClientNetworkType()},be.prototype.getClientNetworkType=function(){var Ee,Pe,Qe,Ze;if(this.clientNetworkType===void 0){var Xe="Unknown";if(!((Pe=(Ee=window.navigator)===null||Ee===void 0?void 0:Ee.connection)===null||Pe===void 0)&&Pe.type)switch((Ze=(Qe=window.navigator)===null||Qe===void 0?void 0:Qe.connection)===null||Ze===void 0?void 0:Ze.type){case"cellular":Xe="WWAN";break;case"ethernet":Xe="Wired";break;case"wifi":Xe="Wireless";break;default:Xe="Unknown"}this.clientNetworkType=Xe}return this.clientNetworkType},be.prototype.getCodecList=function(){return[{type:"file",video:{contentType:"video/mp4; codecs=hev1.1.6.L93",width:1920,height:1080,bitrate:1e4,framerate:60}},{type:"file",video:{contentType:"video/mp4; codecs=hev1.1.6.L90",width:1920,height:1080,bitrate:1e4,framerate:30}},{type:"file",video:{contentType:"video/mp4; codecs=hev1.1.6.L63",width:1280,height:720,bitrate:1e4,framerate:60}},{type:"file",video:{contentType:"video/mp4; codecs=hev1.1.6.L60",width:1280,height:720,bitrate:1e4,framerate:30}},{type:"file",video:{contentType:"video/mp4; codecs=hev1.1.6.L30",width:640,height:480,bitrate:1e4,framerate:30}},{type:"file",video:{contentType:"video/mp4; codecs=avc1.64002A",width:1920,height:1080,bitrate:1e4,framerate:60}},{type:"file",video:{contentType:"video/mp4; codecs=avc1.640028",width:1920,height:1080,bitrate:1e4,framerate:30}},{type:"file",video:{contentType:"video/mp4; codecs=avc1.640020",width:1280,height:720,bitrate:1e4,framerate:60}},{type:"file",video:{contentType:"video/mp4; codecs=avc1.64001E",width:1280,height:720,bitrate:1e4,framerate:30}},{type:"file",video:{contentType:"video/mp4; codecs=avc1.640015",width:640,height:480,bitrate:1e4,framerate:30}},{type:"file",video:{contentType:"video/webm; codecs=vp09.00.10.08",width:1920,height:1080,bitrate:5e6,framerate:30}},{type:"file",video:{contentType:"video/webm; codecs=vp8",width:1920,height:1080,bitrate:5e6,framerate:30}},{type:"file",video:{contentType:"video/ogg; codecs=theora, vorbis",width:640,height:480,bitrate:5e5,framerate:30}},{type:"file",video:{contentType:"video/mp4; codecs=av01.0.05M.08",width:1920,height:1080,bitrate:1e4,framerate:60}},{type:"file",video:{contentType:"video/mp4; codecs=av01.0.04M.08",width:1920,height:1080,bitrate:1e4,framerate:30}},{type:"file",video:{contentType:"video/mp4; codecs=av01.0.03M.08",width:1280,height:720,bitrate:1e4,framerate:60}},{type:"file",video:{contentType:"video/mp4; codecs=av01.0.03M.08",width:1280,height:720,bitrate:1e4,framerate:30}},{type:"file",video:{contentType:"video/mp4; codecs=av01.0.02M.08",width:640,height:480,bitrate:1e4,framerate:30}},{type:"file",audio:{contentType:"audio/webm; codecs=opus",channels:"2",bitrate:64e3,samplerate:48e3}},{type:"file",audio:{contentType:"audio/ogg; codecs=vorbis",channels:"2",bitrate:128e3,samplerate:44100}},{type:"file",audio:{contentType:"audio/mp4; codecs=mp4a.40.2",channels:"2",bitrate:128e3,samplerate:44100}},{type:"file",audio:{contentType:"audio/mp4; codecs=mp4a.40.5",channels:"2",bitrate:64e3,samplerate:48e3}},{type:"file",audio:{contentType:"audio/mpeg",channels:"2",bitrate:128e3,samplerate:44100}},{type:"file",audio:{contentType:"audio/flac",channels:"2",bitrate:32e4,samplerate:96e3}},{type:"file",audio:{contentType:"audio/mp4 codecs=ac-3",channels:"6",bitrate:64e4,samplerate:48e3}},{type:"file",audio:{contentType:"audio/mp4 codecs=ec-3",channels:"6",bitrate:64e4,samplerate:48e3}},{type:"file",audio:{contentType:"audio/wav; codecs=1",channels:"2",bitrate:1411200,samplerate:44100}}]},be.prototype.getAudioVideoCodecsSupported=function(Ee){return W(this,void 0,void 0,function(){var Pe,Qe,Ze=this;return ee(this,function(Xe){switch(Xe.label){case 0:return Pe=[],"mediaCapabilities"in navigator?(Qe=Ee.map(function(bt){return W(Ze,void 0,void 0,function(){var Ot,Yt;return ee(this,function(pt){switch(pt.label){case 0:Ot=bt,pt.label=1;case 1:return pt.trys.push([1,3,,4]),[4,navigator.mediaCapabilities.decodingInfo(Ot)];case 2:return(Yt=pt.sent()).supported&&(bt.video?Pe.push({codec:bt.video.contentType,supported:Yt.supported,smooth:Yt.smooth,powerEfficient:Yt.powerEfficient,resolution:bt.video.height,framerate:bt.video.framerate}):bt.audio&&Pe.push({codec:bt.audio.contentType,supported:Yt.supported,smooth:Yt.smooth,powerEfficient:Yt.powerEfficient})),[3,4];case 3:return pt.sent(),[3,4];case 4:return[2]}})})}),[4,Promise.allSettled(Qe)]):[3,2];case 1:Xe.sent(),Xe.label=2;case 2:return[2,Pe]}})})},be.prototype.populateSupportedCodecs=function(){var Ee=this;this.supportedCodecs===void 0&&this.getAudioVideoCodecsSupported(this.getCodecList()).then(function(Pe){Ee.supportedCodecs=Pe})},be.prototype.getSdnReport=function(Ee){var Pe,Qe=Ee.filter(function(Ot){return[se.PlayerScenarioType.SdnPluginLoad,se.PlayerScenarioType.SdnPluginInitialize,se.PlayerScenarioType.SdnPluginSetSource].includes(Ot.name)}),Ze=oe(oe([],Qe,!0),this.ecdnPluginEvents,!0),Xe=Qe.filter(function(Ot){return Ot.failReason!==void 0}),bt=Qe.filter(function(Ot){return Ot.name===se.PlayerScenarioType.SdnPluginLoad}).sort(function(Ot,Yt){return Yt.startTime-Ot.startTime})[0];return{sdn_loaded:!(bt==null||bt.failReason!==void 0),sdn_details:(Pe=bt?.details)!==null&&Pe!==void 0?Pe:"",sdn_error:Xe.length>0&&Xe[Xe.length-1].failReason||"",sdn_events:this.prepareForTelemetry(Ze)}},be.prototype.getStreamConnectionReport=function(Ee){var Pe=Ee.filter(function(Qe){return Qe.name===se.PlayerScenarioType.StreamConnection});return{stream_connection_events:this.prepareForTelemetry(Pe)}},be.prototype.getSetSourceReport=function(Ee){var Pe=Ee.filter(function(Qe){return Qe.name===se.PlayerScenarioType.SetSource});return{set_source_events:this.prepareForTelemetry(Pe)}},be.prototype.registerScenario=function(Ee,Pe){this.playerEvents.push(new ze(Ee,Pe))},be.prototype.completeScenario=function(Ee,Pe,Qe){this.playerEvents.push(new ze(Ee,Qe,Pe))},be.prototype.logTelemetryEvent=function(Ee){this.config.debugLogging&&(this.logFn("debug","PlayerTelemetryEvent: ".concat(JSON.stringify(Ee))),this.logFn("debug","PlayerDiagnosticData: ".concat(JSON.stringify(this.currentPlayerDiagnosticSnapshot))))},be.prototype.filterAndPrepareTelemetry=function(){var Ee=this,Pe=new Set;Pe.add("serviceLatencyCdg"),Pe.add("endToEndLatencyCdg"),Pe.add("videoEdgeLatencyCdg"),Pe.add("eventId"),Pe.add("templateId");var Qe={};return Object.keys(this.currentPlayerDiagnosticSnapshot).forEach(function(Ze){Pe.has(Ze)||(Qe["player_".concat(Ze)]=Ee.prepareForTelemetry(Ee.currentPlayerDiagnosticSnapshot[Ze]))}),Qe},be.prototype.prepareForTelemetry=function(Ee){return typeof Ee=="boolean"?Ee:typeof Ee=="string"||Ee===void 0?Ee||"":typeof Ee=="number"?Ee??-1:JSON.stringify(Ee)},be.prototype.getScenario=function(Ee){return this.playerEvents.filter(function(Pe){return Pe.getName()===Ee})},be.prototype.createTelemetryEvent=function(Ee,Pe,Qe){var Ze,Xe,bt={eventType:Ee,timestamp:Date.now(),currentPlayPosition:(Xe=(Ze=this.currentPlayerDiagnosticSnapshot)===null||Ze===void 0?void 0:Ze.currentPlayPosition)!==null&&Xe!==void 0?Xe:-1};return Pe!==void 0&&(bt.payload=this.prepareForTelemetry(Pe)),bt.message=Qe,bt},be.prototype.modifyTelemetryEventPayload=function(Ee,Pe,Qe){try{if(Ee.payload){var Ze=JSON.parse(Ee.payload);Ze=Qe?N(N({},Ze),Pe):N(N({},Pe),Ze),Ee.payload=this.prepareForTelemetry(Ze)}else Ee.payload=this.prepareForTelemetry(Pe)}catch(Xe){this.logFn("error","Failed to modify payload for event: ".concat(ue.stringifyObject(Ee),", error: ").concat(Xe))}},be.prototype.registerExperimentalEvent=function(Ee,Pe,Qe){var Ze=this.createTelemetryEvent(Ee,Pe,Qe);this.experimentalEvents.push(Ze),this.experimentalEvents.length>this.maxPlayerExperimentalEvents&&this.experimentalEvents.splice(0,1),this.logTelemetryEvent(Ze)},be.prototype.getExperimentalEvents=function(){return{playback_experimentalEvents:this.prepareForTelemetry(this.experimentalEvents)}},be.prototype.registerUserInitiatedSeek=function(Ee){var Pe,Qe,Ze={newCurrentPlayPosition:Ee,seekForward:((Qe=(Pe=this.currentPlayerDiagnosticSnapshot)===null||Pe===void 0?void 0:Pe.currentPlayPosition)!==null&&Qe!==void 0?Qe:-1)<Ee},Xe=this.createTelemetryEvent(se.TelemetryEventType.UserInitiatedSeek,Ze);this.userInitiatedSeekEvents.push(Xe),this.userInitiatedSeekEvents.length>this.maxUserInitiatedEventCount&&this.userInitiatedSeekEvents.splice(0,1)},be.prototype.registerUserInitiatedPlay=function(){var Ee=this.createTelemetryEvent(se.TelemetryEventType.UserInitiatedPlay);this.userInitiatedPlayEvents.push(Ee),this.userInitiatedPlayEvents.length>this.maxUserInitiatedEventCount&&this.userInitiatedPlayEvents.splice(0,1)},be.prototype.registerUserInitiatedPause=function(){var Ee=this.createTelemetryEvent(se.TelemetryEventType.UserInitiatedPause);this.userInitiatedPauseEvents.push(Ee),this.userInitiatedPauseEvents.length>this.maxUserInitiatedEventCount&&this.userInitiatedPauseEvents.splice(0,1)},be.prototype.getUserInitiatedSeekEvents=function(){return{playback_userInitiatedSeekEvents:this.prepareForTelemetry(this.userInitiatedSeekEvents),playback_userInitiatedPlayEvents:this.prepareForTelemetry(this.userInitiatedPlayEvents),playback_userInitiatedPauseEvents:this.prepareForTelemetry(this.userInitiatedPauseEvents)}},be.prototype.registerPlayBlocked=function(Ee){this.registerScenario(se.PlayerScenarioType.PlayAttemptBlocked,"Called video element play() but it failed with error: ".concat(Ee)),this.completeScenario(se.PlayerScenarioType.PlayAttemptBlocked)},be}();_.LiveStreamStatistic=He},42:function(b,_){Object.defineProperty(_,"__esModule",{value:!0}),_.Spinner=void 0;var k=function(){function N(W){this.container=W,this.spinnerId="hydra-player-spinner",this.firstSpinnerShowTimestamp=null,this.firstSpinnerHideTimestamp=null,this.spinnerInfoHistory=[],this.maxTimestampHistorySize=100;var ee=this.container.ownerDocument.getElementById(this.spinnerId);if(ee)return this.spinner=ee,void this.show();var oe=this.container.ownerDocument.createElement("style");oe.textContent=`
            .ml-player-spinner-container {
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                position: absolute;
                pointer-events: none;
            }
            .ml-player-spinner {
                width: 3.6rem;
                height: 3.6rem;
                display: block;
                overflow-clip-margin: content-box;
                overflow: hidden;
                animation: ml-player-spinner-outer-rotate 3s linear infinite;
            }
            .ml-player-spinner-dark-wheel {
                fill: none;
                r: 45%;
                cx: 50%;
                cy: 50%;
                stroke: rgb(68, 71, 145);
                stroke-width: 8px;
            }
            .ml-player-spinner-light-wheel {
                fill: none;
                r: 45%;
                cx: 50%;
                cy: 50%;
                stroke: rgb(127, 133, 245);
                stroke-width: 8px;
                stroke-dasharray: 283;
                stroke-dashoffset: 280;
                stroke-linecap: round;
                transform-origin: 50% 50%;
                animation: ml-player-spinner-inner-rotate 1.5s cubic-bezier(0.33, 0, 0.67, 1) infinite;
            }
            @keyframes ml-player-spinner-outer-rotate {
                0% {
                    transform: rotate(0deg);
                }
                100% {
                    transform: rotate(360deg);
                }
            }
            @keyframes ml-player-spinner-inner-rotate {
                0% {
                    stroke-dashoffset: 283;
                    transform: rotate(0deg);
                }
                25% {
                    stroke-dashoffset: 283;
                    transform: rotate(0deg);
                }
                50% {
                    stroke-dashoffset: 75;
                    transform: rotate(45deg);
                }
                75% {
                    stroke-dashoffset: 75;
                    transform: rotate(45deg);
                }
                100% {
                    stroke-dashoffset: 283;
                    transform: rotate(360deg);
                }
            }
        `,this.container.ownerDocument.head.appendChild(oe),this.container.style.position="relative";var de=this.container.ownerDocument.createElement("div");de.classList.add("ml-player-spinner-container"),this.container.appendChild(de),this.spinner=this.container.ownerDocument.createElementNS("http://www.w3.org/2000/svg","svg"),this.spinner.style.position="absolute",this.spinner.setAttribute("viewBox","0 0 100 100"),this.spinner.classList.add("ml-player-spinner"),this.spinner.id=this.spinnerId,de.appendChild(this.spinner);var se=this.container.ownerDocument.createElementNS("http://www.w3.org/2000/svg","circle");se.classList.add("ml-player-spinner-dark-wheel"),this.spinner.appendChild(se);var Re=this.container.ownerDocument.createElementNS("http://www.w3.org/2000/svg","circle");Re.classList.add("ml-player-spinner-light-wheel"),this.spinner.appendChild(Re),this.show()}return Object.defineProperty(N.prototype,"firstShowTimestamp",{get:function(){return this.firstSpinnerShowTimestamp},enumerable:!1,configurable:!0}),Object.defineProperty(N.prototype,"firstHideTimestamp",{get:function(){return this.firstSpinnerHideTimestamp},enumerable:!1,configurable:!0}),Object.defineProperty(N.prototype,"firstSpinnerDuration",{get:function(){return this.firstSpinnerShowTimestamp?this.firstSpinnerHideTimestamp?this.firstSpinnerHideTimestamp-this.firstSpinnerShowTimestamp:Date.now()-this.firstSpinnerShowTimestamp:null},enumerable:!1,configurable:!0}),Object.defineProperty(N.prototype,"visibilityHistory",{get:function(){if(this.spinnerInfoHistory.length>0){var W=this.spinnerInfoHistory[this.spinnerInfoHistory.length-1];W.hideTimestamp||(W.displayDuration=Date.now()-W.showTimestamp)}return this.spinnerInfoHistory},enumerable:!1,configurable:!0}),N.prototype.show=function(){var W=Date.now();this.firstSpinnerShowTimestamp||(this.firstSpinnerShowTimestamp=W),(this.spinnerInfoHistory.length===0||this.spinnerInfoHistory[this.spinnerInfoHistory.length-1].hideTimestamp)&&(this.spinnerInfoHistory.push({showTimestamp:W,displayDuration:0}),this.spinnerInfoHistory.length>this.maxTimestampHistorySize&&this.spinnerInfoHistory.splice(0,1)),this.spinner.style.display="block"},N.prototype.hide=function(){var W=Date.now();if(this.firstSpinnerHideTimestamp||(this.firstSpinnerHideTimestamp=W),this.spinnerInfoHistory.length>0){var ee=this.spinnerInfoHistory[this.spinnerInfoHistory.length-1];ee.hideTimestamp||(ee.hideTimestamp=W,ee.displayDuration=W-ee.showTimestamp)}this.spinner.style.display="none"},N.prototype.isVisible=function(){return this.spinner.style.display!=="none"},N}();_.Spinner=k},378:function(b,_){var k,N;Object.defineProperty(_,"__esModule",{value:!0}),_.MessageType=void 0,(N=k||(_.MessageType=k={})).Command="Command",N.CommandSuccessResult="CommandSuccessResult",N.CommandFailureResult="CommandFailureResult",N.PlayerEvent="PlayerEvent",N.InternalPlayerEvent="InternalPlayerEvent"},963:function(b,_){var k,N,W;Object.defineProperty(_,"__esModule",{value:!0}),_.PlayerScenarioType=_.TelemetryEventType=void 0,(W=k||(_.TelemetryEventType=k={})).BitrateChangedDownload="BitrateChangedDownload",W.StreamOptionsConfigured="StreamOptionsConfigured",W.BitrateChangedPlayback="BitrateChangedPlayback",W.CaptionsToggled="CaptionsToggled",W.Error="Error",W.IgnoredError="IgnoredError",W.FullscreenChanged="FullscreenChanged",W.Mute="Mute",W.PotentialMediaFreeze="PotentialMediaFreeze",W.StateChanged="StateChanged",W.HydraInputStateChanged="HydraInputStateChanged",W.HydraOutputStateChanged="HydraOutputStateChanged",W.Volume="Volume",W.Buffering="Buffering",W.Online="Online",W.Offline="Offline",W.NetworkChange="NetworkChange",W.HlsEvents="HlsEvents",W.EcdnPluginEvents="EcdnPluginEvents",W.UserInitiatedSeek="UserInitiatedSeek",W.UserInitiatedPlay="UserInitiatedPlay",W.UserInitiatedPause="UserInitiatedPause",W.CapabilitiesUpdated="CapabilitiesUpdated",function(ee){ee.LoadHydra="LoadHydra",ee.LoadHlsScript="LoadHlsScript",ee.LoadPlayer="LoadPlayer",ee.Load="Load",ee.LoadHlsAuthCookie="LoadHlsAuthCookie",ee.HlsManifestLoad="HlsManifestLoad",ee.HlsKeyLoad="HlsKeyLoad",ee.LoadHlsFirstFragment="LoadHlsFirstFragment",ee.SetSource="SetSource",ee.SdnPluginLoad="SdnPluginLoad",ee.ThaPluginLoad="ThaPluginLoad",ee.HydraPipelineInitialization="HydraPipelineInitialization",ee.Destroyed="Destroyed",ee.Setup="Setup",ee.StreamConnection="StreamConnection",ee.SdnPluginInitialize="SdnPluginInitialize",ee.SdnPluginSetSource="SdnPluginSetSource",ee.PlayAttemptBlocked="PlayAttemptBlocked"}(N||(_.PlayerScenarioType=N={}))},176:function(b,_){var k,N,W,ee,oe,de,se,Re;Object.defineProperty(_,"__esModule",{value:!0}),_.MobileInteractionType=_.HydraSupportedSDN=_.HydraPlayerDestroyedReason=_.HydraOutputState=_.HydraInputState=_.HydraPlayerPlaybackErrorSource=_.PlaybackMode=void 0,(Re=k||(_.PlaybackMode=k={})).Live="Live",Re.DVR="DVR",function(ue){ue.Stream="Stream",ue.HydraPipeline="HydraPipeline",ue.VideoPlayer="VideoPlayer"}(N||(_.HydraPlayerPlaybackErrorSource=N={})),function(ue){ue.Idle="Idle",ue.Started="Started",ue.BufferReceived="BufferReceived",ue.Ended="Ended",ue.Stopped="Stopped",ue.Destroyed="Destroyed"}(W||(_.HydraInputState=W={})),function(ue){ue.Idle="Idle",ue.Attached="Attached",ue.Starting="Starting",ue.Started="Started",ue.BufferReceived="BufferReceived",ue.BufferAppended="BufferAppended",ue.Stopped="Stopped",ue.Destroyed="Destroyed"}(ee||(_.HydraOutputState=ee={})),function(ue){ue.PlayerStopped="PlayerStopped",ue.PlaybackError="PlaybackError"}(oe||(_.HydraPlayerDestroyedReason=oe={})),function(ue){ue.Hive="hive",ue.Kollective="kollective",ue.Ramp="ramp",ue.Peer5="peer5",ue.Microsoft="microsoft"}(de||(_.HydraSupportedSDN=de={})),function(ue){ue[ue.DoublePress3Fingers=0]="DoublePress3Fingers"}(se||(_.MobileInteractionType=se={}))},346:function(b,_){var k,N,W,ee,oe,de,se,Re,ue;Object.defineProperty(_,"__esModule",{value:!0}),_.HttpFetchErrorReason=_.IframeMessages=_.HydraPlayerType=_.HydraPlayerPlaybackErrorType=_.HydraPlayerPlaybackState=_.HydraPlayerSetupErrorType=_.HydraStreamDeliveryPipeline=_.HydraStreamingEventType=void 0,(ue=k||(_.HydraStreamingEventType=k={})).TLE="TLE",ue.Overflow="Overflow",ue.TownHallBasic="TownHall_Basic",ue.TownHallPremium="TownHall_Premium",ue.TownHall="TownHall",function(Ne){Ne.AMS="AMS",Ne.HLS="MiddleLaneHttpLiveStreaming",Ne.Ums="MiddleLaneUltraLowLatency"}(N||(_.HydraStreamDeliveryPipeline=N={})),function(Ne){Ne.MultiplePlayerLoad="MultiplePlayerLoad",Ne.PlayerInitializationFailed="PlayerInitializationFailed",Ne.InvalidStream="InvalidStream",Ne.SetSourceFailed="SetSourceFailed"}(W||(_.HydraPlayerSetupErrorType=W={})),function(Ne){Ne.LoadStart="loadstart",Ne.LoadedData="loadeddata",Ne.LoadedMetadata="loadedmetadata",Ne.Start="start",Ne.CanPlayThrough="canplaythrough",Ne.Play="play",Ne.Playing="playing",Ne.Pause="pause",Ne.Waiting="waiting",Ne.Seeking="seeking",Ne.Seeked="seeked",Ne.Ended="ended",Ne.Error="error",Ne.Destroyed="destroyed",Ne.Initialized="initialized",Ne.Stalled="stalled",Ne.VolumeChange="volumechange",Ne.PlaybackBitrateChanged="playbackbitratechanged",Ne.DownloadBitrateChanged="downloadbitratechanged",Ne.TimeUpdate="timeupdate",Ne.DurationChange="durationchange",Ne.HlsKeyLoading="hlsKeyLoading",Ne.HlsKeyLoaded="hlsKeyLoaded",Ne.HlsKeyLoadedFailed="hlsKeyLoadedFailed",Ne.HlsManifestLoading="hlsManifestLoading",Ne.HlsManifestLoaded="hlsManifestLoaded",Ne.HlsManifestLoadedFailed="hlsManifestLoadedFailed",Ne.HlsFirstFragmentLoading="hlsFragLoading",Ne.HlsFirstFragmentBuffered="hlsFragBuffered",Ne.HlsFirstFragmentLoadFailed="hlsFirstFragmentLoadFailed",Ne.HlsFragmentChanged="hlsFragmentChanged",Ne.Online="online",Ne.Offline="offline",Ne.NetworkChange="networkChange"}(ee||(_.HydraPlayerPlaybackState=ee={})),function(Ne){Ne.UnsupportedPlatform="UnsupportedPlatform",Ne.NetworkError="NetworkError",Ne.PlaybackRetried="PlaybackRetried",Ne.PlaybackError="PlaybackError",Ne.Unknown="Unknown",Ne.MediaTimeout="MediaTimeout",Ne.NoMediaFlow="NoMediaFlow"}(oe||(_.HydraPlayerPlaybackErrorType=oe={})),function(Ne){Ne[Ne.Hls=1]="Hls",Ne[Ne.Ums=2]="Ums"}(de||(_.HydraPlayerType=de={})),function(Ne){Ne.RequestIceCandidates="RequestIceCandidates"}(se||(_.IframeMessages=se={})),function(Ne){Ne.Unknown="Unknown",Ne.ClientNetwork="ClientNetwork",Ne.ClientNetworkOrUnreachableServer="ClientNetworkOrUnreachableServer",Ne.ServerNetwork="ServerNetwork",Ne.ClientAuthIssue="ClientAuthIssue",Ne.ServerResourceNotFound="ServerResourceNotFound"}(Re||(_.HttpFetchErrorReason=Re={}))},534:function(b,_,k){var N=this&&this.__awaiter||function(Pe,Qe,Ze,Xe){return new(Ze||(Ze=Promise))(function(bt,Ot){function Yt(xt){try{Lt(Xe.next(xt))}catch(yi){Ot(yi)}}function pt(xt){try{Lt(Xe.throw(xt))}catch(yi){Ot(yi)}}function Lt(xt){var yi;xt.done?bt(xt.value):(yi=xt.value,yi instanceof Ze?yi:new Ze(function(Li){Li(yi)})).then(Yt,pt)}Lt((Xe=Xe.apply(Pe,Qe||[])).next())})},W=this&&this.__generator||function(Pe,Qe){var Ze,Xe,bt,Ot,Yt={label:0,sent:function(){if(1&bt[0])throw bt[1];return bt[1]},trys:[],ops:[]};return Ot={next:pt(0),throw:pt(1),return:pt(2)},typeof Symbol=="function"&&(Ot[Symbol.iterator]=function(){return this}),Ot;function pt(Lt){return function(xt){return function(yi){if(Ze)throw new TypeError("Generator is already executing.");for(;Ot&&(Ot=0,yi[0]&&(Yt=0)),Yt;)try{if(Ze=1,Xe&&(bt=2&yi[0]?Xe.return:yi[0]?Xe.throw||((bt=Xe.return)&&bt.call(Xe),0):Xe.next)&&!(bt=bt.call(Xe,yi[1])).done)return bt;switch(Xe=0,bt&&(yi=[2&yi[0],bt.value]),yi[0]){case 0:case 1:bt=yi;break;case 4:return Yt.label++,{value:yi[1],done:!1};case 5:Yt.label++,Xe=yi[1],yi=[0];continue;case 7:yi=Yt.ops.pop(),Yt.trys.pop();continue;default:if(!((bt=(bt=Yt.trys).length>0&&bt[bt.length-1])||yi[0]!==6&&yi[0]!==2)){Yt=0;continue}if(yi[0]===3&&(!bt||yi[1]>bt[0]&&yi[1]<bt[3])){Yt.label=yi[1];break}if(yi[0]===6&&Yt.label<bt[1]){Yt.label=bt[1],bt=yi;break}if(bt&&Yt.label<bt[2]){Yt.label=bt[2],Yt.ops.push(yi);break}bt[2]&&Yt.ops.pop(),Yt.trys.pop();continue}yi=Qe.call(Pe,Yt)}catch(Li){yi=[6,Li],Xe=0}finally{Ze=bt=0}if(5&yi[0])throw yi[1];return{value:yi[0]?yi[1]:void 0,done:!0}}([Lt,xt])}}};Object.defineProperty(_,"__esModule",{value:!0}),_.isPlaybackStoppingState=_.tryCallVideoElementPlay=_.sanitizeForFormatSpecifiers=_.addEvent=_.TimeRanges=_.NO_OP_BUFFERED=_.getHttpFetchErrorReason=_.createVideoPlayButton=_.createVideoElement=_.createVideoElementDiv=_.showPlayerControls=_.repeatUntilCancel=_.wait=_.stringifyError=_.stringifyObject=_.getRandomHexString=_.getPlayerSetting=_.getECSSetting=_.retry=_.createIFrame=_.getMajorFromVersion=void 0;var ee=k(346),oe=k(457);function de(Pe,Qe,Ze,Xe,bt,Ot,Yt){return N(this,void 0,void 0,function(){var pt,Lt,xt,yi,Li,cn=this;return W(this,function(Ci){switch(Ci.label){case 0:return pt=100,Lt=Date.now(),[4,Re(Ze,xt={trackingRef:"",timeTakenToDownloadScript:-1},bt,Ot,Yt).catch(function(ji){return N(cn,void 0,void 0,function(){var An;return W(this,function(Ea){switch(Ea.label){case 0:return An="Failed to get IFrame source: ".concat(ze(ji)),Xe.push({success:!1,url:Ze,startTime:Lt,duration:Date.now()-Lt,trackingReference:xt.trackingRef,timeTakenToDownloadScript:xt.timeTakenToDownloadScript,errorMsg:An}),Xe.length>pt&&Xe.shift(),[4,Promise.reject(new Error(An))];case 1:return[2,Ea.sent()]}})})})];case 1:return yi=Ci.sent(),Qe.srcdoc=yi,Li=new Promise(function(ji,An){Qe.onload=function(){Xe.push({success:!0,url:Ze,startTime:Lt,duration:Date.now()-Lt,trackingReference:xt.trackingRef,timeTakenToDownloadScript:xt.timeTakenToDownloadScript}),Xe.length>pt&&Xe.shift(),ji()},Qe.onerror=function(Ea){var Ln="Failed to load HydraPlayer IFrame: ".concat(ze(Ea));Xe.push({success:!1,url:Ze,startTime:Lt,duration:Date.now()-Lt,trackingReference:xt.trackingRef,timeTakenToDownloadScript:xt.timeTakenToDownloadScript,errorMsg:Ln}),Xe.length>pt&&Xe.shift(),An(new Error(Ln))}}),Pe.appendChild(Qe),[4,Li];case 2:return Ci.sent(),[2]}})})}function se(Pe){return N(this,arguments,void 0,function(Qe,Ze,Xe){var bt=this;return Ze===void 0&&(Ze=5),Xe===void 0&&(Xe=200),W(this,function(Ot){switch(Ot.label){case 0:return[4,Qe(Ze).catch(function(Yt){return N(bt,void 0,void 0,function(){var pt=this;return W(this,function(Lt){switch(Lt.label){case 0:return--Ze!=0?[3,2]:[4,Promise.reject(new Error("[retry] retries exhausted: ".concat(He(Yt))))];case 1:case 3:return[2,Lt.sent()];case 2:return[4,new Promise(function(xt){return setTimeout(function(){xt(se(Qe,Ze,Xe).catch(function(yi){return N(pt,void 0,void 0,function(){return W(this,function(Li){switch(Li.label){case 0:return[4,Promise.reject(new Error("".concat(He(Yt)).concat(", ",He(yi))))];case 1:return[2,Li.sent()]}})})}))},Xe)})]}})})})];case 1:return[2,Ot.sent()]}})})}function Re(Pe,Qe,Ze,Xe,bt){return N(this,void 0,void 0,function(){var Ot,Yt,pt,Lt=this;return W(this,function(xt){switch(xt.label){case 0:return Ot=Date.now(),Ze?(Yt='<script src="'.concat(Pe,'"><\/script')+">",[3,3]):[3,1];case 1:return[4,ue(Pe,Qe,Xe).catch(function(yi){return N(Lt,void 0,void 0,function(){return W(this,function(Li){switch(Li.label){case 0:return[4,Promise.reject(yi)];case 1:return[2,Li.sent()]}})})})];case 2:pt=xt.sent(),Yt=bt?'<script nonce="'.concat(bt,'">').concat(pt,"<\/script")+">":"<script>".concat(pt,"<\/script")+">",xt.label=3;case 3:return Qe.timeTakenToDownloadScript=Date.now()-Ot,[2,`
        <html class style='height: 100%; width: 100%; overflow: hidden'>
        <head></head>
        <body class style='height: 100%; width: 100%; margin: 0px'>
            `.concat(Yt,`
        </body>
        </html>
    `)]}})})}function ue(Pe,Qe,Ze){return N(this,void 0,void 0,function(){var Xe,bt,Ot,Yt=this;return W(this,function(pt){switch(pt.label){case 0:return Xe=function(Lt,xt){var yi,Li;return xt.includes("vz")?(Li=Lt.headers.get("uuid"))!==null&&Li!==void 0?Li:"":(yi=Lt.headers.get("X-Azure-Ref"))!==null&&yi!==void 0?yi:""},Ze?(bt=new AbortController,Ot=setTimeout(function(){bt.abort()},Ze),[4,fetch(Pe,{signal:bt.signal,cache:"no-cache"}).then(function(Lt){return N(Yt,void 0,void 0,function(){return W(this,function(xt){switch(xt.label){case 0:return clearTimeout(Ot),Lt.ok?[3,2]:[4,Promise.reject(new Error("".concat(Lt.status)))];case 1:return[2,xt.sent()];case 2:return Qe.trackingRef=Xe(Lt,Pe),[2,Lt]}})})}).then(function(Lt){return N(Yt,void 0,void 0,function(){var xt=this;return W(this,function(yi){switch(yi.label){case 0:return[4,Lt.text().then(function(Li){return N(xt,void 0,void 0,function(){return W(this,function(cn){switch(cn.label){case 0:return Li?[2,Li]:[3,1];case 1:return[4,Promise.reject(new Error("".concat(Lt.status,", script ").concat(Pe," contents are null")))];case 2:return[2,cn.sent()]}})})})];case 1:return[2,yi.sent()]}})})}).catch(function(Lt){return N(Yt,void 0,void 0,function(){return W(this,function(xt){throw clearTimeout(Ot),Lt})})})]):[3,2];case 1:case 3:return[2,pt.sent()];case 2:return[4,fetch(Pe,{cache:"no-cache"}).then(function(Lt){return N(Yt,void 0,void 0,function(){return W(this,function(xt){switch(xt.label){case 0:return Lt.ok?[3,2]:[4,Promise.reject(new Error("".concat(Lt.status)))];case 1:return[2,xt.sent()];case 2:return Qe.trackingRef=Xe(Lt,Pe),[2,Lt]}})})}).then(function(Lt){return N(Yt,void 0,void 0,function(){var xt=this;return W(this,function(yi){switch(yi.label){case 0:return[4,Lt.text().then(function(Li){return N(xt,void 0,void 0,function(){return W(this,function(cn){switch(cn.label){case 0:return Li?[2,Li]:[3,1];case 1:return[4,Promise.reject(new Error("".concat(Lt.status,", script ").concat(Pe," contents are null")))];case 2:return[2,cn.sent()]}})})})];case 1:return[2,yi.sent()]}})})})]}})})}function Ne(Pe,Qe,Ze){var Xe,bt=Ze,Ot=(Xe=Pe.ecsSettings)===null||Xe===void 0?void 0:Xe[Qe];return typeof Ot==typeof bt&&(bt=Ot),bt}function ze(Pe){try{if(!Pe)return"".concat(Pe);if(Pe instanceof Map)return Ze={},Pe.forEach(function(Xe,bt){Ze[bt.toString()]=Xe}),JSON.stringify(Ze);var Qe=Pe.toString();return Qe.endsWith("[object Object]")?JSON.stringify(Pe):Qe}catch{return""}var Ze}function He(Pe){return Pe instanceof Error?Pe.message:ze(Pe)}function be(Pe){return N(this,void 0,void 0,function(){return W(this,function(Qe){switch(Qe.label){case 0:return[4,new Promise(function(Ze){return setTimeout(Ze,Pe)})];case 1:return Qe.sent(),[2]}})})}function Ee(Pe){return Pe&&Pe.replace(/%[a-zA-Z]/g,"")}_.getMajorFromVersion=function(Pe){var Qe=Pe.match(/^(\d+)\.\d+\.\d+(-.*)?$/);return Qe?Qe[1]:null},_.createIFrame=function(Pe,Qe,Ze){return N(this,void 0,void 0,function(){var Xe,bt,Ot,Yt,pt,Lt,xt,yi,Li,cn,Ci=this;return W(this,function(ji){switch(ji.label){case 0:return Xe=Ne(Ze,"scriptSrcDownload",oe.iframeConfigDefault.scriptSrcDownload),bt=Ne(Ze,"allowSameOrigin",oe.iframeConfigDefault.allowSameOrigin),Ot=Ze.maxRetryCountForLoadingResources,Yt=Ze.disableSandbox,pt=Ze.hydraRuntimeFetchTimeout,Lt=[],(xt=Pe.ownerDocument.createElement("iframe")).id="player-iframe",Yt||(bt?(Li=xt.sandbox)===null||Li===void 0||Li.add("allow-scripts","allow-same-origin"):(cn=xt.sandbox)===null||cn===void 0||cn.add("allow-scripts")),xt.allowFullscreen=!0,xt.allow="camera; microphone; autoplay",xt.style.height="100%",xt.style.width="100%",xt.style.border="none",yi=function(An){return Qe[An%Qe.length]},[4,se(function(An){return N(Ci,void 0,void 0,function(){var Ea,Ln,ga;return W(this,function(vs){switch(vs.label){case 0:return Ea=yi(An),Ln=(ga=Ze.nonce)!==null&&ga!==void 0?ga:"",[4,de(Pe,xt,Ea,Lt,Xe,pt,Ln)];case 1:return vs.sent(),[2]}})})},Ot).then(function(){return{iframe:xt,initResult:{isSuccess:!0,runtimeDownloadResults:Lt}}}).catch(function(An){return N(Ci,void 0,void 0,function(){var Ea;return W(this,function(Ln){return Ea="Failed to load Hydra player runtime scripts, src: ",Qe.forEach(function(ga){return Ea=Ea.concat(ga,", ")}),Ea+="errors: ".concat(ze(An)),[2,{initResult:{isSuccess:!1,runtimeDownloadResults:Lt,errorMsg:Ea}}]})})})];case 1:return[2,ji.sent()]}})})},_.retry=se,_.getECSSetting=Ne,_.getPlayerSetting=function(Pe,Qe){var Ze;return((Ze=Pe.ecsSettings)===null||Ze===void 0?void 0:Ze[Qe])!==void 0?Pe.ecsSettings[Qe]:Pe[Qe]},_.getRandomHexString=function(Pe){return Array.from(Array(Pe)).map(function(){return Math.floor(16*Math.random()).toString(16)}).join("")},_.stringifyObject=ze,_.stringifyError=He,_.wait=be,_.repeatUntilCancel=function(Pe,Qe,Ze,Xe){var bt=!1,Ot=Xe||console.log,Yt=Ee(Pe);return Ot("RepeatUntilCancel starting task: ".concat(Yt)),N(this,void 0,void 0,function(){var pt,Lt,xt;return W(this,function(yi){switch(yi.label){case 0:return bt?[3,2]:(pt=new Date,Qe(),Lt=new Date().getTime()-pt.getTime(),(xt=Ze-Lt)<0&&(xt=Ze+xt%Ze,Ot("Skipping execution for ".concat(Yt,", last execution took: ").concat(Lt," ms, delayMs: ").concat(Ze),"warn")),[4,be(xt)]);case 1:return yi.sent(),[3,0];case 2:return[2]}})}),function(){Ot("RepeatUntilCancel stopping task: ".concat(Yt)),bt=!0}},_.showPlayerControls=function(Pe){return Pe.allowPlayerControls!==void 0?Pe.allowPlayerControls:Pe.streamingEventType===ee.HydraStreamingEventType.TLE},_.createVideoElementDiv=function(Pe,Qe,Ze){Ze("createVideoElementDiv started");var Xe=Qe.ownerDocument.createElement("div");return Xe.id=Pe,Xe.style.position="relative",Xe.style.width="100%",Xe.style.height="100%",Qe.appendChild(Xe),Ze("createVideoElementDiv done"),Xe},_.createVideoElement=function(Pe,Qe,Ze,Xe,bt){bt("createVideoElement started");var Ot=Qe.ownerDocument.createElement("video");Ot.controls=Xe,Ot.id=Pe,Ot.setAttribute("playsinline","");var Yt=Ze.videoLang;Yt&&(Ot.setAttribute("lang",Yt),bt("createVideoElement: language set to ".concat(Yt)));var pt=Ze.videoElementStyles;if(pt)for(var Lt=0;Lt<pt.length;Lt++)Ot.classList.add(pt[Lt]);return Ot.style.width="100%",Ot.style.height="100%",Ot.style.position="absolute",Ot.muted=Ze.muteVideo,Ot.addEventListener("contextmenu",function(xt){xt.preventDefault()}),["play","pause","stop","seekbackward","seekforward","seekto","previoustrack","nexttrack"].forEach(function(xt){try{navigator.mediaSession.setActionHandler(xt,function(){})}catch{}}),Qe.appendChild(Ot),bt("createVideoElement done"),Ot},_.createVideoPlayButton=function(Pe,Qe,Ze,Xe){Xe("createVideoPlayButton started");var bt=Qe.ownerDocument.createElement("style");bt.innerHTML=`
    .hydra-play-button {
        width: 70px;
        height: 70px;
        background-color: #373538;
        border: none;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .triangle {
        position: relative;
        background-color: white;
        text-align: left;
    }
    .triangle:before,
    .triangle:after {
        content: '';
        position: absolute;
        background-color: inherit;
    }
    .triangle,
    .triangle:before,
    .triangle:after {
        width: 1em;
        height: 1em;
        border-top-right-radius: 30%;
    }

    .triangle {
        transform: rotate(270deg) skewX(-30deg) scale(1, .866) translate(10%, -15%);
    }
    .triangle:before {
        transform: rotate(-135deg) skewX(-45deg) scale(1.414, .707) translate(0, -50%);
    }
    .triangle:after {
        transform: rotate(135deg) skewY(-45deg) scale(.707, 1.414) translate(50%);
    }
    `,Qe.ownerDocument.head.appendChild(bt);var Ot=Qe.ownerDocument.createElement("div");Ot.id=Pe,Ot.className="hydra-play-button";var Yt=document.createElement("div");return Yt.className="triangle",Ot.appendChild(Yt),Ze||(Ot.style.display="none"),Qe.appendChild(Ot),Xe("createVideoPlayButton done"),Ot},_.getHttpFetchErrorReason=function(Pe){return Pe===void 0?ee.HttpFetchErrorReason.Unknown:Pe===0?ee.HttpFetchErrorReason.ClientNetworkOrUnreachableServer:Pe===401?ee.HttpFetchErrorReason.ClientAuthIssue:Pe===404?ee.HttpFetchErrorReason.ServerResourceNotFound:Pe>=400&&Pe<=499?ee.HttpFetchErrorReason.ClientNetwork:Pe>=500&&Pe<=599?ee.HttpFetchErrorReason.ServerNetwork:ee.HttpFetchErrorReason.Unknown},_.NO_OP_BUFFERED={length:0,start:function(){return 0},end:function(){return 0}},_.TimeRanges={toString:function(Pe){for(var Qe="",Ze=Pe.length,Xe=0;Xe<Ze;Xe++)Qe+="[".concat(Pe.start(Xe).toFixed(3),"-").concat(Pe.end(Xe).toFixed(3),"]");return Qe},range:function(Pe){return Pe&&Pe.length!==0?[Pe.start(Pe.length-1),Pe.end(Pe.length-1)]:[0,0]},prevRange:function(Pe){if(Pe&&Pe.length===2)return[Pe.start(Pe.length-2),Pe.end(Pe.length-2)]}},_.addEvent=function(Pe,Qe){var Ze={};return Qe?.detail&&(Ze={detail:Qe.detail}),new CustomEvent(Pe,Ze)},_.sanitizeForFormatSpecifiers=Ee,_.tryCallVideoElementPlay=function(Pe){var Qe=Pe.play();return Qe!==void 0?Qe:new Promise(function(Ze){return Ze()})},_.isPlaybackStoppingState=function(Pe){return Pe===ee.HydraPlayerPlaybackState.Pause||Pe===ee.HydraPlayerPlaybackState.Ended||Pe===ee.HydraPlayerPlaybackState.Seeking||Pe===ee.HydraPlayerPlaybackState.Waiting||Pe===ee.HydraPlayerPlaybackState.Stalled||Pe===ee.HydraPlayerPlaybackState.Destroyed}},564:function(b,_){var k,N,W,ee,oe,de,se,Re,ue,Ne;Object.defineProperty(_,"__esModule",{value:!0}),_.UmsModality=_.HttpFetchErrorReason=_.IframeMessages=_.HydraPlayerType=_.HydraPlayerPlaybackErrorType=_.HydraPlayerPlaybackState=_.HydraPlayerSetupErrorType=_.HydraStreamDeliveryPipeline=_.HydraStreamingEventType=void 0,(Ne=k||(_.HydraStreamingEventType=k={})).TLE="TLE",Ne.Overflow="Overflow",Ne.TownHallBasic="TownHall_Basic",Ne.TownHallPremium="TownHall_Premium",Ne.TownHall="TownHall",function(ze){ze.AMS="AMS",ze.HLS="MiddleLaneHttpLiveStreaming",ze.Ums="MiddleLaneUltraLowLatency"}(N||(_.HydraStreamDeliveryPipeline=N={})),function(ze){ze.MultiplePlayerLoad="MultiplePlayerLoad",ze.PlayerInitializationFailed="PlayerInitializationFailed",ze.InvalidStream="InvalidStream",ze.SetSourceFailed="SetSourceFailed"}(W||(_.HydraPlayerSetupErrorType=W={})),function(ze){ze.LoadStart="loadstart",ze.LoadedData="loadeddata",ze.LoadedMetadata="loadedmetadata",ze.Start="start",ze.CanPlayThrough="canplaythrough",ze.Play="play",ze.Playing="playing",ze.Pause="pause",ze.Waiting="waiting",ze.Seeking="seeking",ze.Seeked="seeked",ze.Ended="ended",ze.Error="error",ze.Destroyed="destroyed",ze.Initialized="initialized",ze.Stalled="stalled",ze.VolumeChange="volumechange",ze.PlaybackBitrateChanged="playbackbitratechanged",ze.DownloadBitrateChanged="downloadbitratechanged",ze.TimeUpdate="timeupdate",ze.DurationChange="durationchange",ze.HlsKeyLoading="hlsKeyLoading",ze.HlsKeyLoaded="hlsKeyLoaded",ze.HlsKeyLoadedFailed="hlsKeyLoadedFailed",ze.HlsManifestLoading="hlsManifestLoading",ze.HlsManifestLoaded="hlsManifestLoaded",ze.HlsManifestLoadedFailed="hlsManifestLoadedFailed",ze.HlsFirstFragmentLoading="hlsFragLoading",ze.HlsFirstFragmentBuffered="hlsFragBuffered",ze.HlsFirstFragmentLoadFailed="hlsFirstFragmentLoadFailed",ze.HlsFragmentChanged="hlsFragmentChanged",ze.Online="online",ze.Offline="offline",ze.NetworkChange="networkChange"}(ee||(_.HydraPlayerPlaybackState=ee={})),function(ze){ze.UnsupportedPlatform="UnsupportedPlatform",ze.NetworkError="NetworkError",ze.PlaybackRetried="PlaybackRetried",ze.PlaybackError="PlaybackError",ze.Unknown="Unknown",ze.MediaTimeout="MediaTimeout",ze.NoMediaFlow="NoMediaFlow"}(oe||(_.HydraPlayerPlaybackErrorType=oe={})),function(ze){ze[ze.Hls=1]="Hls",ze[ze.Ums=2]="Ums"}(de||(_.HydraPlayerType=de={})),function(ze){ze.RequestIceCandidates="RequestIceCandidates"}(se||(_.IframeMessages=se={})),function(ze){ze.Unknown="Unknown",ze.ClientNetwork="ClientNetwork",ze.ClientNetworkOrUnreachableServer="ClientNetworkOrUnreachableServer",ze.ServerNetwork="ServerNetwork",ze.ClientAuthIssue="ClientAuthIssue",ze.ServerResourceNotFound="ServerResourceNotFound"}(Re||(_.HttpFetchErrorReason=Re={})),function(ze){ze.audio="Audio",ze.video="Video",ze.text="Text"}(ue||(_.UmsModality=ue={}))},521:function(b,_,k){var N=this&&this.__awaiter||function(Ee,Pe,Qe,Ze){return new(Qe||(Qe=Promise))(function(Xe,bt){function Ot(Lt){try{pt(Ze.next(Lt))}catch(xt){bt(xt)}}function Yt(Lt){try{pt(Ze.throw(Lt))}catch(xt){bt(xt)}}function pt(Lt){var xt;Lt.done?Xe(Lt.value):(xt=Lt.value,xt instanceof Qe?xt:new Qe(function(yi){yi(xt)})).then(Ot,Yt)}pt((Ze=Ze.apply(Ee,Pe||[])).next())})},W=this&&this.__generator||function(Ee,Pe){var Qe,Ze,Xe,bt,Ot={label:0,sent:function(){if(1&Xe[0])throw Xe[1];return Xe[1]},trys:[],ops:[]};return bt={next:Yt(0),throw:Yt(1),return:Yt(2)},typeof Symbol=="function"&&(bt[Symbol.iterator]=function(){return this}),bt;function Yt(pt){return function(Lt){return function(xt){if(Qe)throw new TypeError("Generator is already executing.");for(;bt&&(bt=0,xt[0]&&(Ot=0)),Ot;)try{if(Qe=1,Ze&&(Xe=2&xt[0]?Ze.return:xt[0]?Ze.throw||((Xe=Ze.return)&&Xe.call(Ze),0):Ze.next)&&!(Xe=Xe.call(Ze,xt[1])).done)return Xe;switch(Ze=0,Xe&&(xt=[2&xt[0],Xe.value]),xt[0]){case 0:case 1:Xe=xt;break;case 4:return Ot.label++,{value:xt[1],done:!1};case 5:Ot.label++,Ze=xt[1],xt=[0];continue;case 7:xt=Ot.ops.pop(),Ot.trys.pop();continue;default:if(!((Xe=(Xe=Ot.trys).length>0&&Xe[Xe.length-1])||xt[0]!==6&&xt[0]!==2)){Ot=0;continue}if(xt[0]===3&&(!Xe||xt[1]>Xe[0]&&xt[1]<Xe[3])){Ot.label=xt[1];break}if(xt[0]===6&&Ot.label<Xe[1]){Ot.label=Xe[1],Xe=xt;break}if(Xe&&Ot.label<Xe[2]){Ot.label=Xe[2],Ot.ops.push(xt);break}Xe[2]&&Ot.ops.pop(),Ot.trys.pop();continue}xt=Pe.call(Ee,Ot)}catch(yi){xt=[6,yi],Ze=0}finally{Qe=Xe=0}if(5&xt[0])throw xt[1];return{value:xt[0]?xt[1]:void 0,done:!0}}([pt,Lt])}}};Object.defineProperty(_,"__esModule",{value:!0}),_.HydraPlayer=_.getSdkVersion=void 0;var ee=k(346),oe=k(378),de=k(715),se=k(357),Re=k(534),ue=k(42),Ne=k(103),ze=k(282),He=k(10);_.getSdkVersion=function(){return"4.2521.1"};var be=function(){function Ee(Pe,Qe){this.playerSettings=Pe,this.eventHandler=Qe,this.spinner=null,this.telemetryReportHandler=null,this.playerRuntimeUrls=[],this.commandResultsMap=new Map,this.iframeCommunicationHandler=null,this.MAX_COMMAND_RESULTS_MAP_SIZE=1e4,this.playerInternalEventHandler=new de.HydraPlayerInternalEventHandler}return Ee.prototype.dispose=function(){var Pe;(Pe=this.telemetryReportHandler)===null||Pe===void 0||Pe.addDisposeTelemetry(),this.isIFrameCommunicationActive()&&this.callPlayerApi("disposeHydraPlayer")},Ee.prototype.release=function(){var Pe;(Pe=this.spinner)===null||Pe===void 0||Pe.hide(),this.contextWindow&&this.contextWindow.removeEventListener("message",this.onMessage.bind(this)),this.iframeCommunicationHandler&&this.iframeCommunicationHandler.dispose(),this.iframe&&this.container&&this.container.hasChildNodes()&&this.container.removeChild(this.iframe)},Ee.prototype.setup=function(Pe){return N(this,void 0,void 0,function(){var Qe,Ze,Xe,bt,Ot,Yt,pt,Lt;return W(this,function(xt){switch(xt.label){case 0:Qe=Date.now(),this.container=Pe,Ze=null,xt.label=1;case 1:return xt.trys.push([1,14,,15]),this.spinner=new ue.Spinner(this.container),this.playerInternalEventHandler.setSpinner(this.spinner),[4,this.initializeIFrame()];case 2:if(!(Ze=xt.sent()).isSuccess)return[3,12];Xe={initSucceeded:!0,initStartTime:Qe,initDuration:Date.now()-Qe,runtimeDownloadResults:Ze.runtimeDownloadResults||[]},xt.label=3;case 3:return xt.trys.push([3,5,,11]),[4,this.callPlayerApi("createHydraPlayer",this.playerSettings,Xe)];case 4:return xt.sent(),[3,11];case 5:return bt=xt.sent(),this.eventHandler.log("warn","Failed to create HydraPlayer: ".concat(bt)),this.playerSettings.playerType!==ee.HydraPlayerType.Hls?[3,7]:[4,this.callPlayerApi("createHlsHydraPlayer",this.playerSettings,Xe)];case 6:return xt.sent(),[3,10];case 7:return this.playerSettings.playerType!==ee.HydraPlayerType.Ums?[3,9]:[4,this.callPlayerApi("createUmsHydraPlayer",this.playerSettings,Xe)];case 8:return xt.sent(),[3,10];case 9:throw new Error("Cannot create Hydra player - Unknown player type");case 10:return[3,11];case 11:return this.onSetupCompleted(Xe),[2,!0];case 12:throw new Error(Ze.errorMsg);case 13:return[3,15];case 14:Ot=xt.sent(),Yt=(0,Re.stringifyObject)(Ot),this.eventHandler.log("error","Failed to setup HydraPlayer: ".concat(Yt)),pt={initSucceeded:!1,initStartTime:Qe,initDuration:Date.now()-Qe,runtimeDownloadResults:Ze?.runtimeDownloadResults||[],errorMsg:Yt};try{(Lt=this.spinner)===null||Lt===void 0||Lt.hide()}catch(yi){this.eventHandler.log("error","Failed to hide spinner: ".concat((0,Re.stringifyObject)(yi)))}return this.onSetupCompleted(pt),[2,!1];case 15:return[2]}})})},Ee.prototype.onSetupCompleted=function(Pe){this.telemetryReportHandler=new se.TelemetryReportHandler(this.playerSettings,this.eventHandler.log.bind(this.eventHandler),Pe,this.spinner),this.playerInternalEventHandler.setTelemetryReportHandler(this.telemetryReportHandler)},Ee.prototype.getFullTelemetryReport=function(){var Pe;return((Pe=this.telemetryReportHandler)===null||Pe===void 0?void 0:Pe.getFullTelemetryReport())||{}},Ee.prototype.getSnapshotTelemetryReport=function(){var Pe;return((Pe=this.telemetryReportHandler)===null||Pe===void 0?void 0:Pe.getSnapshotTelemetryReport())||{}},Ee.prototype.callPlayerApi=function(Pe){for(var Qe=[],Ze=1;Ze<arguments.length;Ze++)Qe[Ze-1]=arguments[Ze];return N(this,void 0,void 0,function(){var Xe,bt,Ot,Yt,pt;return W(this,function(Lt){switch(Lt.label){case 0:return this.iframe?[3,2]:[4,Promise.reject(new Error("Hydra IFrame not initialized yet"))];case 1:case 3:return[2,Lt.sent()];case 2:if(Xe=(0,He.default)(),bt={msgType:oe.MessageType.Command,id:Xe,name:Pe,args:Qe},!this.isIFrameCommunicationActive())throw new Error("IFrame MessageAPI communication not active");if(this.commandResultsMap.size>=this.MAX_COMMAND_RESULTS_MAP_SIZE)throw new Error("Too many Hydra player API commands in progress - skipping this player API call");return Ot=Ne.defer(),Yt={name:Pe,id:Xe},this.commandResultsMap.set(Yt,Ot),(pt=this.iframe.contentWindow)===null||pt===void 0||pt.postMessage(bt,"*"),[4,Ot.promise]}})})},Object.defineProperty(Ee.prototype,"contextWindow",{get:function(){var Pe;return(Pe=this.container)===null||Pe===void 0?void 0:Pe.ownerDocument.defaultView},enumerable:!1,configurable:!0}),Ee.prototype.isIFrameCommunicationActive=function(){var Pe;return!!(!((Pe=this.iframe)===null||Pe===void 0)&&Pe.contentWindow)&&!!this.contextWindow},Ee.prototype.getRuntimeUrls=function(Pe){if(!Array.isArray(this.playerSettings.playerRuntimeJsUrls)){var Qe=(0,Re.getMajorFromVersion)(Pe);return Qe&&this.playerSettings.playerRuntimeJsUrls[Qe]||[]}return this.playerSettings.playerRuntimeJsUrls},Ee.prototype.initializeIFrame=function(){return N(this,void 0,void 0,function(){var Pe;return W(this,function(Qe){switch(Qe.label){case 0:return this.playerSettings.hydraPlayerSdkVersion="4.2521.1",this.playerRuntimeUrls=this.getRuntimeUrls(this.playerSettings.hydraPlayerSdkVersion),this.playerRuntimeUrls.length!==0&&this.container?[4,(0,Re.createIFrame)(this.container,this.playerRuntimeUrls,this.playerSettings)]:[2,{isSuccess:!1,runtimeDownloadResults:[],errorMsg:`No compatible runtime URLs provided for HydraPlayer SDK version:
                    `.concat(this.playerSettings.hydraPlayerSdkVersion,`, URLs:
                    `).concat((0,Re.stringifyObject)(this.playerSettings.playerRuntimeJsUrls))}];case 1:return(Pe=Qe.sent()).initResult.isSuccess&&Pe.iframe&&(this.iframe=Pe.iframe,this.iframeCommunicationHandler=new ze.IframeCommunicationHandler(this.iframe,this.playerSettings,this.eventHandler.log),this.contextWindow.addEventListener("message",this.onMessage.bind(this))),[2,Pe.initResult]}})})},Ee.prototype.onMessage=function(Pe){switch(Pe.data.msgType){case oe.MessageType.PlayerEvent:this.processPlayerEvent(Pe.data);break;case oe.MessageType.InternalPlayerEvent:this.processInternalPlayerEvent(Pe.data);break;case oe.MessageType.CommandSuccessResult:this.processCommandSuccessResult(Pe.data);break;case oe.MessageType.CommandFailureResult:this.processCommandFailureResult(Pe.data)}},Ee.prototype.processCommandSuccessResult=function(Pe){var Qe=this;this.eventHandler.log("debug","HydraPlayer command succeeded for ".concat(Pe.name," - result: ").concat((0,Re.stringifyObject)(Pe.result))),this.getMapCommandResults(Pe).forEach(function(Ze){Ze[1].resolve(Pe.result),Qe.commandResultsMap.delete(Ze[0])})},Ee.prototype.processCommandFailureResult=function(Pe){var Qe=this;this.eventHandler.log("debug","HydraPlayer command failed for ".concat(Pe.name," - error: ").concat(Pe.error.message)),this.getMapCommandResults(Pe).forEach(function(Ze){Ze[1].reject(Pe.error),Qe.commandResultsMap.delete(Ze[0])})},Ee.prototype.getMapCommandResults=function(Pe){var Qe=Array.from(this.commandResultsMap.entries()),Ze=[];return Pe.id?Ze=Qe.filter(function(Xe){return Xe[0].id===Pe.id}):Pe.name&&(Ze=Qe.filter(function(Xe){return Xe[0].name===Pe.name})),Ze},Ee.prototype.processPlayerEvent=function(Pe){var Qe;(Qe=this.eventHandler[Pe.name])===null||Qe===void 0||Qe.apply(this.eventHandler,Pe.args)},Ee.prototype.processInternalPlayerEvent=function(Pe){this.playerInternalEventHandler&&this.playerInternalEventHandler[Pe.name].apply(this,Pe.args)},Ee}();_.HydraPlayer=be},282:function(b,_,k){Object.defineProperty(_,"__esModule",{value:!0}),_.IframeCommunicationHandler=void 0;var N=k(346),W=k(735),ee=function(){function oe(de,se,Re){var ue=this;this.iframe=de,this.playerSettings=se,this.logger=Re,this.setupMessageListener(),this.candidatesCollector=new W.WebRtcIceCandidateCollector(this.playerSettings),this.candidatesCollector.startCandidatesCollection().catch(function(Ne){ue.logger("warn","Failed to start collecting ICE candidates ".concat(Ne))})}return oe.prototype.setupMessageListener=function(){var de;(de=this.iframe.ownerDocument.defaultView)===null||de===void 0||de.addEventListener("message",this.processMessage.bind(this))},oe.prototype.postMessageToIframe=function(de){var se;(se=this.iframe.contentWindow)===null||se===void 0||se.postMessage(de,"*")},oe.prototype.dispose=function(){var de;(de=this.iframe.ownerDocument.defaultView)===null||de===void 0||de.removeEventListener("message",this.processMessage.bind(this)),this.candidatesCollector&&this.candidatesCollector.destroy()},oe.prototype.processMessage=function(de){var se=this;de.data===N.IframeMessages.RequestIceCandidates&&de.data.candidates===void 0&&this.candidatesCollector.getCandidates().then(function(Re){var ue=JSON.stringify(Re.map(function(Ne){return JSON.stringify(Ne)}));se.postMessageToIframe({topic:N.IframeMessages.RequestIceCandidates,candidates:ue})}).catch(function(){se.postMessageToIframe({topic:N.IframeMessages.RequestIceCandidates,candidates:[]})})},oe}();_.IframeCommunicationHandler=ee},260:function(b,_,k){var N=this&&this.__createBinding||(Object.create?function(ee,oe,de,se){se===void 0&&(se=de);var Re=Object.getOwnPropertyDescriptor(oe,de);Re&&!("get"in Re?!oe.__esModule:Re.writable||Re.configurable)||(Re={enumerable:!0,get:function(){return oe[de]}}),Object.defineProperty(ee,se,Re)}:function(ee,oe,de,se){se===void 0&&(se=de),ee[se]=oe[de]}),W=this&&this.__exportStar||function(ee,oe){for(var de in ee)de==="default"||Object.prototype.hasOwnProperty.call(oe,de)||N(oe,ee,de)};Object.defineProperty(_,"__esModule",{value:!0}),W(k(521),_),W(k(564),_)},715:function(b,_){Object.defineProperty(_,"__esModule",{value:!0}),_.HydraPlayerInternalEventHandler=void 0;var k=function(){function N(){this.spinner=null,this.telemetryReportHandler=null}return N.prototype.setSpinner=function(W){this.spinner=W},N.prototype.setTelemetryReportHandler=function(W){this.telemetryReportHandler=W},N.prototype.firstPlayerLoadAttemptDone=function(){var W;(W=this.spinner)===null||W===void 0||W.hide()},N.prototype.fullTelemetryReportUpdated=function(W){var ee;(ee=this.telemetryReportHandler)===null||ee===void 0||ee.setFullTelemetryReport(W)},N.prototype.snapshotTelemetryReportUpdated=function(W){var ee;(ee=this.telemetryReportHandler)===null||ee===void 0||ee.setSnapshotTelemetryReport(W)},N}();_.HydraPlayerInternalEventHandler=k},357:function(b,_,k){var N=this&&this.__assign||function(){return N=Object.assign||function(ue){for(var Ne,ze=1,He=arguments.length;ze<He;ze++)for(var be in Ne=arguments[ze])Object.prototype.hasOwnProperty.call(Ne,be)&&(ue[be]=Ne[be]);return ue},N.apply(this,arguments)};Object.defineProperty(_,"__esModule",{value:!0}),_.TelemetryReportHandler=void 0;var W=k(346),ee=k(176),oe=k(963),de=k(171),se=k(534),Re=function(){function ue(Ne,ze,He,be){var Ee=this;this.logFn=ze,this.spinner=be,this.initialLiveStreamStatistic=new de.LiveStreamStatistic(Ne,function(Pe,Qe){Ee.logFn(Pe,Qe)},{videoBufferLength:[],videoCachedLength:[],videoEdgeLatency:[],playerHeight:[],playerWidth:[],mediaHeight:[],mediaWidth:[],windowHeight:[],windowWidth:[],playbackRate:[],currentPlayPosition:[],statsInterval:[]},{hydraPlayerSdkVersion:Ne.hydraPlayerSdkVersion||"Unknown",hydraPlayerType:W.HydraPlayerType.Hls}),this.initialLiveStreamStatistic.setHydraInitResult(He),this.fullTelemetryReport=this.initialLiveStreamStatistic.getReport(),this.snapshotTelemetryReport=this.initialLiveStreamStatistic.getSnapshotReport()}return ue.prototype.getFullTelemetryReport=function(){return this.fullTelemetryReport},ue.prototype.getSnapshotTelemetryReport=function(){return this.snapshotTelemetryReport},ue.prototype.setFullTelemetryReport=function(Ne){var ze,He,be,Ee,Pe,Qe,Ze;this.fullTelemetryReport=N(N({},Ne),{init_spinnerShowTimestamp:(He=(ze=this.spinner)===null||ze===void 0?void 0:ze.firstShowTimestamp)!==null&&He!==void 0?He:-1,init_spinnerHideTimestamp:(Ee=(be=this.spinner)===null||be===void 0?void 0:be.firstHideTimestamp)!==null&&Ee!==void 0?Ee:-1,init_spinnerDuration:(Qe=(Pe=this.spinner)===null||Pe===void 0?void 0:Pe.firstSpinnerDuration)!==null&&Qe!==void 0?Qe:-1,init_spinnerVisible:((Ze=this.spinner)===null||Ze===void 0?void 0:Ze.isVisible())||!1})},ue.prototype.setSnapshotTelemetryReport=function(Ne){var ze,He,be,Ee,Pe,Qe,Ze;this.snapshotTelemetryReport=N(N({},Ne),{init_spinnerShowTimestamp:(He=(ze=this.spinner)===null||ze===void 0?void 0:ze.firstShowTimestamp)!==null&&He!==void 0?He:-1,init_spinnerHideTimestamp:(Ee=(be=this.spinner)===null||be===void 0?void 0:be.firstHideTimestamp)!==null&&Ee!==void 0?Ee:-1,init_spinnerDuration:(Qe=(Pe=this.spinner)===null||Pe===void 0?void 0:Pe.firstSpinnerDuration)!==null&&Qe!==void 0?Qe:-1,init_spinnerVisible:((Ze=this.spinner)===null||Ze===void 0?void 0:Ze.isVisible())||!1})},ue.prototype.addDisposeTelemetry=function(){var Ne=Date.now();this.updateInitEventsWithDisposeEvent(this.fullTelemetryReport,Ne,"full"),this.updateInitEventsWithDisposeEvent(this.snapshotTelemetryReport,Ne,"snapshot"),this.updateStateChangeEventsWithDisposeEvent(this.fullTelemetryReport,Ne,"full"),this.updateStateChangeEventsWithDisposeEvent(this.snapshotTelemetryReport,Ne,"snapshot")},ue.prototype.updateInitEventsWithDisposeEvent=function(Ne,ze,He){try{var be=Ne.init_allEvents,Ee=JSON.parse(be);Ee[Ee.length-1].name!==oe.PlayerScenarioType.Destroyed&&Ee.push({name:oe.PlayerScenarioType.Destroyed,startTime:ze,duration:0,details:ee.HydraPlayerDestroyedReason.PlayerStopped}),Ne.init_allEvents=(0,se.stringifyObject)(Ee)}catch{this.logFn("warn","Failed to add player destroyed information to init_allEvents telemetry field in ".concat(He," telemetry report."))}},ue.prototype.updateStateChangeEventsWithDisposeEvent=function(Ne,ze,He){try{var be=Ne.playback_stateChangeEvents,Ee=JSON.parse(be);Ee[Ee.length-1].name!==W.HydraPlayerPlaybackState.Destroyed&&Ee.push({eventType:oe.TelemetryEventType.StateChanged,timestamp:ze,currentPlayPosition:-1,payload:W.HydraPlayerPlaybackState.Destroyed}),Ne.playback_stateChangeEvents=(0,se.stringifyObject)(Ee)}catch{this.logFn("warn","Failed to add player destroyed information to playback_stateChangeEvents telemetry field in ".concat(He," telemetry report."))}},ue}();_.TelemetryReportHandler=Re},735:function(b,_,k){var N=this&&this.__awaiter||function(ue,Ne,ze,He){return new(ze||(ze=Promise))(function(be,Ee){function Pe(Xe){try{Ze(He.next(Xe))}catch(bt){Ee(bt)}}function Qe(Xe){try{Ze(He.throw(Xe))}catch(bt){Ee(bt)}}function Ze(Xe){var bt;Xe.done?be(Xe.value):(bt=Xe.value,bt instanceof ze?bt:new ze(function(Ot){Ot(bt)})).then(Pe,Qe)}Ze((He=He.apply(ue,Ne||[])).next())})},W=this&&this.__generator||function(ue,Ne){var ze,He,be,Ee,Pe={label:0,sent:function(){if(1&be[0])throw be[1];return be[1]},trys:[],ops:[]};return Ee={next:Qe(0),throw:Qe(1),return:Qe(2)},typeof Symbol=="function"&&(Ee[Symbol.iterator]=function(){return this}),Ee;function Qe(Ze){return function(Xe){return function(bt){if(ze)throw new TypeError("Generator is already executing.");for(;Ee&&(Ee=0,bt[0]&&(Pe=0)),Pe;)try{if(ze=1,He&&(be=2&bt[0]?He.return:bt[0]?He.throw||((be=He.return)&&be.call(He),0):He.next)&&!(be=be.call(He,bt[1])).done)return be;switch(He=0,be&&(bt=[2&bt[0],be.value]),bt[0]){case 0:case 1:be=bt;break;case 4:return Pe.label++,{value:bt[1],done:!1};case 5:Pe.label++,He=bt[1],bt=[0];continue;case 7:bt=Pe.ops.pop(),Pe.trys.pop();continue;default:if(!((be=(be=Pe.trys).length>0&&be[be.length-1])||bt[0]!==6&&bt[0]!==2)){Pe=0;continue}if(bt[0]===3&&(!be||bt[1]>be[0]&&bt[1]<be[3])){Pe.label=bt[1];break}if(bt[0]===6&&Pe.label<be[1]){Pe.label=be[1],be=bt;break}if(be&&Pe.label<be[2]){Pe.label=be[2],Pe.ops.push(bt);break}be[2]&&Pe.ops.pop(),Pe.trys.pop();continue}bt=Ne.call(ue,Pe)}catch(Ot){bt=[6,Ot],He=0}finally{ze=be=0}if(5&bt[0])throw bt[1];return{value:bt[0]?bt[1]:void 0,done:!0}}([Ze,Xe])}}},ee=this&&this.__spreadArray||function(ue,Ne,ze){if(ze||arguments.length===2)for(var He,be=0,Ee=Ne.length;be<Ee;be++)!He&&be in Ne||(He||(He=Array.prototype.slice.call(Ne,0,be)),He[be]=Ne[be]);return ue.concat(He||Array.prototype.slice.call(Ne))};Object.defineProperty(_,"__esModule",{value:!0}),_.WebRtcIceCandidateCollector=void 0;var oe=k(103),de=k(534),se=k(508),Re=function(){function ue(Ne){this.playerSettings=Ne,this.latestCandidates=[],this.newCandidates=[],this.peerConnection=null,this.timeoutId=void 0,this.candidatesCollectionDefer=null,this.delayAfterComplete=(0,de.getECSSetting)(this.playerSettings,"WebRtcIceCandidateCollectorDelayAfterCompleteMs",se.webRtcIceCandidateCollectorConfigDefault.WebRtcIceCandidateCollectorDelayAfterCompleteMs),this.delayAfterError=(0,de.getECSSetting)(this.playerSettings,"WebRtcIceCandidateCollectorDelayAfterErrorMs",se.webRtcIceCandidateCollectorConfigDefault.WebRtcIceCandidateCollectorDelayAfterErrorMs),this.maxRetries=(0,de.getECSSetting)(this.playerSettings,"WebRtcIceCandidateCollectorMaxRetriesMs",se.webRtcIceCandidateCollectorConfigDefault.WebRtcIceCandidateCollectorMaxRetriesMs),this.retryDelay=(0,de.getECSSetting)(this.playerSettings,"WebRtcIceCandidateCollectorRetryDelayMs",se.webRtcIceCandidateCollectorConfigDefault.WebRtcIceCandidateCollectorRetryDelayMs),this.maxCollectionTime=(0,de.getECSSetting)(this.playerSettings,"WebRtcIceCandidateCollectorMaxCollectionTimeMs",se.webRtcIceCandidateCollectorConfigDefault.WebRtcIceCandidateCollectorMaxCollectionTimeMs),this.disabledCollection=(0,de.getECSSetting)(this.playerSettings,"WebRtcIceCandidateCollectorDisableCollection",se.webRtcIceCandidateCollectorConfigDefault.WebRtcIceCandidateCollectorDisableCollection)}return ue.prototype.handleIceCandidate=function(Ne){Ne.candidate&&this.newCandidates.push(Ne.candidate)},ue.prototype.handleIceGatheringStateChange=function(){var Ne,ze;((Ne=this.peerConnection)===null||Ne===void 0?void 0:Ne.iceGatheringState)==="complete"&&(this.latestCandidates=ee([],this.newCandidates,!0),this.newCandidates=[],(ze=this.candidatesCollectionDefer)===null||ze===void 0||ze.resolve(),this.candidatesCollectionDefer=null,this.destroyConnection(),this.clearCollectionTimeout(),this.startCandidatesCollection(this.delayAfterComplete))},ue.prototype.setUpPeerConnection=function(){return N(this,void 0,void 0,function(){var Ne,ze,He,be;return W(this,function(Ee){switch(Ee.label){case 0:return Ee.trys.push([0,3,,4]),this.peerConnection=new RTCPeerConnection,this.peerConnection.createDataChannel("local-ip-hydra-player-ice-candidates"),this.peerConnection.addEventListener("icecandidate",this.handleIceCandidate.bind(this)),this.peerConnection.addEventListener("icegatheringstatechange",this.handleIceGatheringStateChange.bind(this)),[4,(He=this.peerConnection)===null||He===void 0?void 0:He.createOffer()];case 1:return Ne=Ee.sent(),[4,(be=this.peerConnection)===null||be===void 0?void 0:be.setLocalDescription(Ne)];case 2:return Ee.sent(),[3,4];case 3:throw ze=Ee.sent(),this.destroyConnection(),new Error("Failure starting collection: ".concat((0,de.stringifyError)(ze)));case 4:return[2]}})})},ue.prototype.destroyConnection=function(){this.peerConnection&&(this.peerConnection.removeEventListener("icecandidate",this.handleIceCandidate.bind(this)),this.peerConnection.removeEventListener("icegatheringstatechange",this.handleIceGatheringStateChange.bind(this)),this.peerConnection.close(),this.peerConnection=null)},ue.prototype.clearCollectionTimeout=function(){this.timeoutId!==void 0&&(clearTimeout(this.timeoutId),this.timeoutId=void 0)},ue.prototype.destroy=function(){this.disabledCollection=!0,this.destroyConnection(),this.clearCollectionTimeout(),this.candidatesCollectionDefer&&(this.candidatesCollectionDefer.reject(new Error("Collection aborted due to destroy")),this.candidatesCollectionDefer=null)},ue.prototype.startCandidatesCollection=function(){return N(this,arguments,void 0,function(Ne){var ze,He=this;return Ne===void 0&&(Ne=0),W(this,function(be){switch(be.label){case 0:return this.candidatesCollectionDefer||this.disabledCollection?[2]:Ne>0?[4,new Promise(function(Ee){return setTimeout(Ee,Ne)})]:[3,2];case 1:be.sent(),be.label=2;case 2:return this.candidatesCollectionDefer=(0,oe.defer)(),this.candidatesCollectionDefer.promise.catch(function(){}),ze=this.setUpPeerConnection.bind(this),[4,(0,de.retry)(ze,this.maxRetries,this.retryDelay).then(function(){He.timeoutId=setTimeout(function(){var Ee;(Ee=He.candidatesCollectionDefer)===null||Ee===void 0||Ee.reject(new Error("Collection timed out")),He.candidatesCollectionDefer=null,He.destroyConnection(),He.startCandidatesCollection(He.delayAfterError)},He.maxCollectionTime)}).catch(function(Ee){return N(He,void 0,void 0,function(){var Pe,Qe;return W(this,function(Ze){switch(Ze.label){case 0:return Pe="Failed to start collection ".concat((0,de.stringifyError)(Ee)),(Qe=this.candidatesCollectionDefer)===null||Qe===void 0||Qe.reject(new Error(Pe)),this.candidatesCollectionDefer=null,[4,Promise.reject(new Error(Pe))];case 1:return Ze.sent(),this.startCandidatesCollection(this.delayAfterError),[2]}})})})];case 3:return be.sent(),[2]}})})},ue.prototype.getCandidates=function(){return N(this,void 0,void 0,function(){return W(this,function(Ne){switch(Ne.label){case 0:return this.latestCandidates.length===0&&this.candidatesCollectionDefer?[4,this.candidatesCollectionDefer.promise]:[3,2];case 1:Ne.sent(),Ne.label=2;case 2:return[2,this.latestCandidates]}})})},ue}();_.WebRtcIceCandidateCollector=Re}},m={},function b(_){var k=m[_];if(k!==void 0)return k.exports;var N=m[_]={exports:{}};return u[_].call(N.exports,N,N.exports,b),N.exports}(260);var u,m},typeof n=="object"&&typeof a=="object"?a.exports=c():typeof n=="object"?n.hydra_player_sdk=c():s.hydra_player_sdk=c()}}),Eo=oi({"../node_modules/pako/lib/utils/common.js"(n){var a=typeof Uint8Array<"u"&&typeof Uint16Array<"u"&&typeof Int32Array<"u";function s(m,b){return Object.prototype.hasOwnProperty.call(m,b)}n.assign=function(m){for(var b=Array.prototype.slice.call(arguments,1);b.length;){var _=b.shift();if(_){if(typeof _!="object")throw new TypeError(_+"must be non-object");for(var k in _)s(_,k)&&(m[k]=_[k])}}return m},n.shrinkBuf=function(m,b){return m.length===b?m:m.subarray?m.subarray(0,b):(m.length=b,m)};var c={arraySet:function(m,b,_,k,N){if(b.subarray&&m.subarray)m.set(b.subarray(_,_+k),N);else for(var W=0;W<k;W++)m[N+W]=b[_+W]},flattenChunks:function(m){var b,_,k,N,W,ee;for(k=0,b=0,_=m.length;b<_;b++)k+=m[b].length;for(ee=new Uint8Array(k),N=0,b=0,_=m.length;b<_;b++)W=m[b],ee.set(W,N),N+=W.length;return ee}},u={arraySet:function(m,b,_,k,N){for(var W=0;W<k;W++)m[N+W]=b[_+W]},flattenChunks:function(m){return[].concat.apply([],m)}};n.setTyped=function(m){m?(n.Buf8=Uint8Array,n.Buf16=Uint16Array,n.Buf32=Int32Array,n.assign(n,c)):(n.Buf8=Array,n.Buf16=Array,n.Buf32=Array,n.assign(n,u))},n.setTyped(a)}}),Cl=oi({"../node_modules/pako/lib/zlib/trees.js"(n){var a=Eo(),s=4,c=0,u=1,m=2;function b(ft){for(var Hi=ft.length;--Hi>=0;)ft[Hi]=0}var _=0,k=1,N=2,W=3,ee=258,oe=29,de=256,se=de+1+oe,Re=30,ue=19,Ne=2*se+1,ze=15,He=16,be=7,Ee=256,Pe=16,Qe=17,Ze=18,Xe=[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0],bt=[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13],Ot=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7],Yt=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15],pt=512,Lt=new Array(2*(se+2));b(Lt);var xt=new Array(2*Re);b(xt);var yi=new Array(pt);b(yi);var Li=new Array(ee-W+1);b(Li);var cn=new Array(oe);b(cn);var Ci,ji,An,Ea=new Array(Re);function Ln(ft,Hi,Qt,xi,at){this.static_tree=ft,this.extra_bits=Hi,this.extra_base=Qt,this.elems=xi,this.max_length=at,this.has_stree=ft&&ft.length}function ga(ft,Hi){this.dyn_tree=ft,this.max_code=0,this.stat_desc=Hi}function vs(ft){return ft<256?yi[ft]:yi[256+(ft>>>7)]}function ss(ft,Hi){ft.pending_buf[ft.pending++]=255&Hi,ft.pending_buf[ft.pending++]=Hi>>>8&255}function Ya(ft,Hi,Qt){ft.bi_valid>He-Qt?(ft.bi_buf|=Hi<<ft.bi_valid&65535,ss(ft,ft.bi_buf),ft.bi_buf=Hi>>He-ft.bi_valid,ft.bi_valid+=Qt-He):(ft.bi_buf|=Hi<<ft.bi_valid&65535,ft.bi_valid+=Qt)}function ir(ft,Hi,Qt){Ya(ft,Qt[2*Hi],Qt[2*Hi+1])}function Ji(ft,Hi){var Qt=0;do Qt|=1&ft,ft>>>=1,Qt<<=1;while(--Hi>0);return Qt>>>1}function pa(ft){ft.bi_valid===16?(ss(ft,ft.bi_buf),ft.bi_buf=0,ft.bi_valid=0):ft.bi_valid>=8&&(ft.pending_buf[ft.pending++]=255&ft.bi_buf,ft.bi_buf>>=8,ft.bi_valid-=8)}function Ca(ft,Hi){var Qt,xi,at,Ki,bi,Ie,ai=Hi.dyn_tree,Jt=Hi.max_code,At=Hi.stat_desc.static_tree,gi=Hi.stat_desc.has_stree,_i=Hi.stat_desc.extra_bits,sr=Hi.stat_desc.extra_base,ya=Hi.stat_desc.max_length,dr=0;for(Ki=0;Ki<=ze;Ki++)ft.bl_count[Ki]=0;for(ai[2*ft.heap[ft.heap_max]+1]=0,Qt=ft.heap_max+1;Qt<Ne;Qt++)(Ki=ai[2*ai[2*(xi=ft.heap[Qt])+1]+1]+1)>ya&&(Ki=ya,dr++),ai[2*xi+1]=Ki,xi>Jt||(ft.bl_count[Ki]++,bi=0,xi>=sr&&(bi=_i[xi-sr]),Ie=ai[2*xi],ft.opt_len+=Ie*(Ki+bi),gi&&(ft.static_len+=Ie*(At[2*xi+1]+bi)));if(dr!==0){do{for(Ki=ya-1;ft.bl_count[Ki]===0;)Ki--;ft.bl_count[Ki]--,ft.bl_count[Ki+1]+=2,ft.bl_count[ya]--,dr-=2}while(dr>0);for(Ki=ya;Ki!==0;Ki--)for(xi=ft.bl_count[Ki];xi!==0;)(at=ft.heap[--Qt])>Jt||(ai[2*at+1]!==Ki&&(ft.opt_len+=(Ki-ai[2*at+1])*ai[2*at],ai[2*at+1]=Ki),xi--)}}function da(ft,Hi,Qt){var xi,at,Ki=new Array(ze+1),bi=0;for(xi=1;xi<=ze;xi++)Ki[xi]=bi=bi+Qt[xi-1]<<1;for(at=0;at<=Hi;at++){var Ie=ft[2*at+1];Ie!==0&&(ft[2*at]=Ji(Ki[Ie]++,Ie))}}function Wn(){var ft,Hi,Qt,xi,at,Ki=new Array(ze+1);for(Qt=0,xi=0;xi<oe-1;xi++)for(cn[xi]=Qt,ft=0;ft<1<<Xe[xi];ft++)Li[Qt++]=xi;for(Li[Qt-1]=xi,at=0,xi=0;xi<16;xi++)for(Ea[xi]=at,ft=0;ft<1<<bt[xi];ft++)yi[at++]=xi;for(at>>=7;xi<Re;xi++)for(Ea[xi]=at<<7,ft=0;ft<1<<bt[xi]-7;ft++)yi[256+at++]=xi;for(Hi=0;Hi<=ze;Hi++)Ki[Hi]=0;for(ft=0;ft<=143;)Lt[2*ft+1]=8,ft++,Ki[8]++;for(;ft<=255;)Lt[2*ft+1]=9,ft++,Ki[9]++;for(;ft<=279;)Lt[2*ft+1]=7,ft++,Ki[7]++;for(;ft<=287;)Lt[2*ft+1]=8,ft++,Ki[8]++;for(da(Lt,se+1,Ki),ft=0;ft<Re;ft++)xt[2*ft+1]=5,xt[2*ft]=Ji(ft,5);Ci=new Ln(Lt,Xe,de+1,se,ze),ji=new Ln(xt,bt,0,Re,ze),An=new Ln(new Array(0),Ot,0,ue,be)}function co(ft){var Hi;for(Hi=0;Hi<se;Hi++)ft.dyn_ltree[2*Hi]=0;for(Hi=0;Hi<Re;Hi++)ft.dyn_dtree[2*Hi]=0;for(Hi=0;Hi<ue;Hi++)ft.bl_tree[2*Hi]=0;ft.dyn_ltree[2*Ee]=1,ft.opt_len=ft.static_len=0,ft.last_lit=ft.matches=0}function eo(ft){ft.bi_valid>8?ss(ft,ft.bi_buf):ft.bi_valid>0&&(ft.pending_buf[ft.pending++]=ft.bi_buf),ft.bi_buf=0,ft.bi_valid=0}function Uo(ft,Hi,Qt,xi){eo(ft),ss(ft,Qt),ss(ft,~Qt),a.arraySet(ft.pending_buf,ft.window,Hi,Qt,ft.pending),ft.pending+=Qt}function Zo(ft,Hi,Qt,xi){var at=2*Hi,Ki=2*Qt;return ft[at]<ft[Ki]||ft[at]===ft[Ki]&&xi[Hi]<=xi[Qt]}function oo(ft,Hi,Qt){for(var xi=ft.heap[Qt],at=Qt<<1;at<=ft.heap_len&&(at<ft.heap_len&&Zo(Hi,ft.heap[at+1],ft.heap[at],ft.depth)&&at++,!Zo(Hi,xi,ft.heap[at],ft.depth));)ft.heap[Qt]=ft.heap[at],Qt=at,at<<=1;ft.heap[Qt]=xi}function Xu(ft,Hi,Qt){var xi,at,Ki,bi,Ie=0;if(ft.last_lit!==0)do xi=ft.pending_buf[ft.d_buf+2*Ie]<<8|ft.pending_buf[ft.d_buf+2*Ie+1],at=ft.pending_buf[ft.l_buf+Ie],Ie++,xi===0?ir(ft,at,Hi):(ir(ft,(Ki=Li[at])+de+1,Hi),(bi=Xe[Ki])!==0&&Ya(ft,at-=cn[Ki],bi),ir(ft,Ki=vs(--xi),Qt),(bi=bt[Ki])!==0&&Ya(ft,xi-=Ea[Ki],bi));while(Ie<ft.last_lit);ir(ft,Ee,Hi)}function kd(ft,Hi){var Qt,xi,at,Ki=Hi.dyn_tree,bi=Hi.stat_desc.static_tree,Ie=Hi.stat_desc.has_stree,ai=Hi.stat_desc.elems,Jt=-1;for(ft.heap_len=0,ft.heap_max=Ne,Qt=0;Qt<ai;Qt++)Ki[2*Qt]!==0?(ft.heap[++ft.heap_len]=Jt=Qt,ft.depth[Qt]=0):Ki[2*Qt+1]=0;for(;ft.heap_len<2;)Ki[2*(at=ft.heap[++ft.heap_len]=Jt<2?++Jt:0)]=1,ft.depth[at]=0,ft.opt_len--,Ie&&(ft.static_len-=bi[2*at+1]);for(Hi.max_code=Jt,Qt=ft.heap_len>>1;Qt>=1;Qt--)oo(ft,Ki,Qt);at=ai;do Qt=ft.heap[1],ft.heap[1]=ft.heap[ft.heap_len--],oo(ft,Ki,1),xi=ft.heap[1],ft.heap[--ft.heap_max]=Qt,ft.heap[--ft.heap_max]=xi,Ki[2*at]=Ki[2*Qt]+Ki[2*xi],ft.depth[at]=(ft.depth[Qt]>=ft.depth[xi]?ft.depth[Qt]:ft.depth[xi])+1,Ki[2*Qt+1]=Ki[2*xi+1]=at,ft.heap[1]=at++,oo(ft,Ki,1);while(ft.heap_len>=2);ft.heap[--ft.heap_max]=ft.heap[1],Ca(ft,Hi),da(Ki,Jt,ft.bl_count)}function jg(ft,Hi,Qt){var xi,at,Ki=-1,bi=Hi[1],Ie=0,ai=7,Jt=4;for(bi===0&&(ai=138,Jt=3),Hi[2*(Qt+1)+1]=65535,xi=0;xi<=Qt;xi++)at=bi,bi=Hi[2*(xi+1)+1],++Ie<ai&&at===bi||(Ie<Jt?ft.bl_tree[2*at]+=Ie:at!==0?(at!==Ki&&ft.bl_tree[2*at]++,ft.bl_tree[2*Pe]++):Ie<=10?ft.bl_tree[2*Qe]++:ft.bl_tree[2*Ze]++,Ie=0,Ki=at,bi===0?(ai=138,Jt=3):at===bi?(ai=6,Jt=3):(ai=7,Jt=4))}function Ah(ft,Hi,Qt){var xi,at,Ki=-1,bi=Hi[1],Ie=0,ai=7,Jt=4;for(bi===0&&(ai=138,Jt=3),xi=0;xi<=Qt;xi++)if(at=bi,bi=Hi[2*(xi+1)+1],!(++Ie<ai&&at===bi)){if(Ie<Jt)do ir(ft,at,ft.bl_tree);while(--Ie!=0);else at!==0?(at!==Ki&&(ir(ft,at,ft.bl_tree),Ie--),ir(ft,Pe,ft.bl_tree),Ya(ft,Ie-3,2)):Ie<=10?(ir(ft,Qe,ft.bl_tree),Ya(ft,Ie-3,3)):(ir(ft,Ze,ft.bl_tree),Ya(ft,Ie-11,7));Ie=0,Ki=at,bi===0?(ai=138,Jt=3):at===bi?(ai=6,Jt=3):(ai=7,Jt=4)}}function es(ft){var Hi;for(jg(ft,ft.dyn_ltree,ft.l_desc.max_code),jg(ft,ft.dyn_dtree,ft.d_desc.max_code),kd(ft,ft.bl_desc),Hi=ue-1;Hi>=3&&ft.bl_tree[2*Yt[Hi]+1]===0;Hi--);return ft.opt_len+=3*(Hi+1)+5+5+4,Hi}function qs(ft,Hi,Qt,xi){var at;for(Ya(ft,Hi-257,5),Ya(ft,Qt-1,5),Ya(ft,xi-4,4),at=0;at<xi;at++)Ya(ft,ft.bl_tree[2*Yt[at]+1],3);Ah(ft,ft.dyn_ltree,Hi-1),Ah(ft,ft.dyn_dtree,Qt-1)}function qr(ft){var Hi,Qt=4093624447;for(Hi=0;Hi<=31;Hi++,Qt>>>=1)if(1&Qt&&ft.dyn_ltree[2*Hi]!==0)return c;if(ft.dyn_ltree[18]!==0||ft.dyn_ltree[20]!==0||ft.dyn_ltree[26]!==0)return u;for(Hi=32;Hi<de;Hi++)if(ft.dyn_ltree[2*Hi]!==0)return u;return c}b(Ea);var Ol=!1;function Ih(ft){Ol||(Wn(),Ol=!0),ft.l_desc=new ga(ft.dyn_ltree,Ci),ft.d_desc=new ga(ft.dyn_dtree,ji),ft.bl_desc=new ga(ft.bl_tree,An),ft.bi_buf=0,ft.bi_valid=0,co(ft)}function mo(ft,Hi,Qt,xi){Ya(ft,(_<<1)+(xi?1:0),3),Uo(ft,Hi,Qt)}function ig(ft){Ya(ft,k<<1,3),ir(ft,Ee,Lt),pa(ft)}function pi(ft,Hi,Qt,xi){var at,Ki,bi=0;ft.level>0?(ft.strm.data_type===m&&(ft.strm.data_type=qr(ft)),kd(ft,ft.l_desc),kd(ft,ft.d_desc),bi=es(ft),at=ft.opt_len+3+7>>>3,(Ki=ft.static_len+3+7>>>3)<=at&&(at=Ki)):at=Ki=Qt+5,Qt+4<=at&&Hi!==-1?mo(ft,Hi,Qt,xi):ft.strategy===s||Ki===at?(Ya(ft,(k<<1)+(xi?1:0),3),Xu(ft,Lt,xt)):(Ya(ft,(N<<1)+(xi?1:0),3),qs(ft,ft.l_desc.max_code+1,ft.d_desc.max_code+1,bi+1),Xu(ft,ft.dyn_ltree,ft.dyn_dtree)),co(ft),xi&&eo(ft)}function Qn(ft,Hi,Qt){return ft.pending_buf[ft.d_buf+2*ft.last_lit]=Hi>>>8&255,ft.pending_buf[ft.d_buf+2*ft.last_lit+1]=255&Hi,ft.pending_buf[ft.l_buf+ft.last_lit]=255&Qt,ft.last_lit++,Hi===0?ft.dyn_ltree[2*Qt]++:(ft.matches++,Hi--,ft.dyn_ltree[2*(Li[Qt]+de+1)]++,ft.dyn_dtree[2*vs(Hi)]++),ft.last_lit===ft.lit_bufsize-1}n._tr_init=Ih,n._tr_stored_block=mo,n._tr_flush_block=pi,n._tr_tally=Qn,n._tr_align=ig}}),sd=oi({"../node_modules/pako/lib/zlib/adler32.js"(n,a){function s(c,u,m,b){for(var _=65535&c,k=c>>>16&65535,N=0;m!==0;){m-=N=m>2e3?2e3:m;do k=k+(_=_+u[b++]|0)|0;while(--N);_%=65521,k%=65521}return _|k<<16}a.exports=s}}),xh=oi({"../node_modules/pako/lib/zlib/crc32.js"(n,a){function s(){for(var m,b=[],_=0;_<256;_++){m=_;for(var k=0;k<8;k++)m=1&m?3988292384^m>>>1:m>>>1;b[_]=m}return b}var c=s();function u(m,b,_,k){var N=c,W=k+_;m^=-1;for(var ee=k;ee<W;ee++)m=m>>>8^N[255&(m^b[ee])];return~m}a.exports=u}}),Cm=oi({"../node_modules/pako/lib/zlib/messages.js"(n,a){a.exports={2:"need dictionary",1:"stream end",0:"","-1":"file error","-2":"stream error","-3":"data error","-4":"insufficient memory","-5":"buffer error","-6":"incompatible version"}}}),W_=oi({"../node_modules/pako/lib/zlib/deflate.js"(n){var a,s=Eo(),c=Cl(),u=sd(),m=xh(),b=Cm(),_=0,k=1,N=3,W=4,ee=5,oe=0,de=1,se=-2,Re=-3,ue=-5,Ne=-1,ze=1,He=2,be=3,Ee=4,Pe=0,Qe=2,Ze=8,Xe=9,bt=15,Ot=8,Yt=286,pt=30,Lt=19,xt=2*Yt+1,yi=15,Li=3,cn=258,Ci=cn+Li+1,ji=32,An=42,Ea=69,Ln=73,ga=91,vs=103,ss=113,Ya=666,ir=1,Ji=2,pa=3,Ca=4,da=3;function Wn(Ie,ai){return Ie.msg=b[ai],ai}function co(Ie){return(Ie<<1)-(Ie>4?9:0)}function eo(Ie){for(var ai=Ie.length;--ai>=0;)Ie[ai]=0}function Uo(Ie){var ai=Ie.state,Jt=ai.pending;Jt>Ie.avail_out&&(Jt=Ie.avail_out),Jt!==0&&(s.arraySet(Ie.output,ai.pending_buf,ai.pending_out,Jt,Ie.next_out),Ie.next_out+=Jt,ai.pending_out+=Jt,Ie.total_out+=Jt,Ie.avail_out-=Jt,ai.pending-=Jt,ai.pending===0&&(ai.pending_out=0))}function Zo(Ie,ai){c._tr_flush_block(Ie,Ie.block_start>=0?Ie.block_start:-1,Ie.strstart-Ie.block_start,ai),Ie.block_start=Ie.strstart,Uo(Ie.strm)}function oo(Ie,ai){Ie.pending_buf[Ie.pending++]=ai}function Xu(Ie,ai){Ie.pending_buf[Ie.pending++]=ai>>>8&255,Ie.pending_buf[Ie.pending++]=255&ai}function kd(Ie,ai,Jt,At){var gi=Ie.avail_in;return gi>At&&(gi=At),gi===0?0:(Ie.avail_in-=gi,s.arraySet(ai,Ie.input,Ie.next_in,gi,Jt),Ie.state.wrap===1?Ie.adler=u(Ie.adler,ai,gi,Jt):Ie.state.wrap===2&&(Ie.adler=m(Ie.adler,ai,gi,Jt)),Ie.next_in+=gi,Ie.total_in+=gi,gi)}function jg(Ie,ai){var Jt,At,gi=Ie.max_chain_length,_i=Ie.strstart,sr=Ie.prev_length,ya=Ie.nice_match,dr=Ie.strstart>Ie.w_size-Ci?Ie.strstart-(Ie.w_size-Ci):0,Ps=Ie.window,eT=Ie.w_mask,gu=Ie.prev,km=Ie.strstart+cn,HS=Ps[_i+sr-1],Oy=Ps[_i+sr];Ie.prev_length>=Ie.good_match&&(gi>>=2),ya>Ie.lookahead&&(ya=Ie.lookahead);do if(Ps[(Jt=ai)+sr]===Oy&&Ps[Jt+sr-1]===HS&&Ps[Jt]===Ps[_i]&&Ps[++Jt]===Ps[_i+1]){_i+=2,Jt++;do;while(Ps[++_i]===Ps[++Jt]&&Ps[++_i]===Ps[++Jt]&&Ps[++_i]===Ps[++Jt]&&Ps[++_i]===Ps[++Jt]&&Ps[++_i]===Ps[++Jt]&&Ps[++_i]===Ps[++Jt]&&Ps[++_i]===Ps[++Jt]&&Ps[++_i]===Ps[++Jt]&&_i<km);if(At=cn-(km-_i),_i=km-cn,At>sr){if(Ie.match_start=ai,sr=At,At>=ya)break;HS=Ps[_i+sr-1],Oy=Ps[_i+sr]}}while((ai=gu[ai&eT])>dr&&--gi!=0);return sr<=Ie.lookahead?sr:Ie.lookahead}function Ah(Ie){var ai,Jt,At,gi,_i,sr=Ie.w_size;do{if(gi=Ie.window_size-Ie.lookahead-Ie.strstart,Ie.strstart>=sr+(sr-Ci)){s.arraySet(Ie.window,Ie.window,sr,sr,0),Ie.match_start-=sr,Ie.strstart-=sr,Ie.block_start-=sr,ai=Jt=Ie.hash_size;do At=Ie.head[--ai],Ie.head[ai]=At>=sr?At-sr:0;while(--Jt);ai=Jt=sr;do At=Ie.prev[--ai],Ie.prev[ai]=At>=sr?At-sr:0;while(--Jt);gi+=sr}if(Ie.strm.avail_in===0)break;if(Jt=kd(Ie.strm,Ie.window,Ie.strstart+Ie.lookahead,gi),Ie.lookahead+=Jt,Ie.lookahead+Ie.insert>=Li)for(_i=Ie.strstart-Ie.insert,Ie.ins_h=Ie.window[_i],Ie.ins_h=(Ie.ins_h<<Ie.hash_shift^Ie.window[_i+1])&Ie.hash_mask;Ie.insert&&(Ie.ins_h=(Ie.ins_h<<Ie.hash_shift^Ie.window[_i+Li-1])&Ie.hash_mask,Ie.prev[_i&Ie.w_mask]=Ie.head[Ie.ins_h],Ie.head[Ie.ins_h]=_i,_i++,Ie.insert--,!(Ie.lookahead+Ie.insert<Li)););}while(Ie.lookahead<Ci&&Ie.strm.avail_in!==0)}function es(Ie,ai){var Jt=65535;for(Jt>Ie.pending_buf_size-5&&(Jt=Ie.pending_buf_size-5);;){if(Ie.lookahead<=1){if(Ah(Ie),Ie.lookahead===0&&ai===_)return ir;if(Ie.lookahead===0)break}Ie.strstart+=Ie.lookahead,Ie.lookahead=0;var At=Ie.block_start+Jt;if((Ie.strstart===0||Ie.strstart>=At)&&(Ie.lookahead=Ie.strstart-At,Ie.strstart=At,Zo(Ie,!1),Ie.strm.avail_out===0)||Ie.strstart-Ie.block_start>=Ie.w_size-Ci&&(Zo(Ie,!1),Ie.strm.avail_out===0))return ir}return Ie.insert=0,ai===W?(Zo(Ie,!0),Ie.strm.avail_out===0?pa:Ca):(Ie.strstart>Ie.block_start&&(Zo(Ie,!1),Ie.strm.avail_out),ir)}function qs(Ie,ai){for(var Jt,At;;){if(Ie.lookahead<Ci){if(Ah(Ie),Ie.lookahead<Ci&&ai===_)return ir;if(Ie.lookahead===0)break}if(Jt=0,Ie.lookahead>=Li&&(Ie.ins_h=(Ie.ins_h<<Ie.hash_shift^Ie.window[Ie.strstart+Li-1])&Ie.hash_mask,Jt=Ie.prev[Ie.strstart&Ie.w_mask]=Ie.head[Ie.ins_h],Ie.head[Ie.ins_h]=Ie.strstart),Jt!==0&&Ie.strstart-Jt<=Ie.w_size-Ci&&(Ie.match_length=jg(Ie,Jt)),Ie.match_length>=Li)if(At=c._tr_tally(Ie,Ie.strstart-Ie.match_start,Ie.match_length-Li),Ie.lookahead-=Ie.match_length,Ie.match_length<=Ie.max_lazy_match&&Ie.lookahead>=Li){Ie.match_length--;do Ie.strstart++,Ie.ins_h=(Ie.ins_h<<Ie.hash_shift^Ie.window[Ie.strstart+Li-1])&Ie.hash_mask,Jt=Ie.prev[Ie.strstart&Ie.w_mask]=Ie.head[Ie.ins_h],Ie.head[Ie.ins_h]=Ie.strstart;while(--Ie.match_length!=0);Ie.strstart++}else Ie.strstart+=Ie.match_length,Ie.match_length=0,Ie.ins_h=Ie.window[Ie.strstart],Ie.ins_h=(Ie.ins_h<<Ie.hash_shift^Ie.window[Ie.strstart+1])&Ie.hash_mask;else At=c._tr_tally(Ie,0,Ie.window[Ie.strstart]),Ie.lookahead--,Ie.strstart++;if(At&&(Zo(Ie,!1),Ie.strm.avail_out===0))return ir}return Ie.insert=Ie.strstart<Li-1?Ie.strstart:Li-1,ai===W?(Zo(Ie,!0),Ie.strm.avail_out===0?pa:Ca):Ie.last_lit&&(Zo(Ie,!1),Ie.strm.avail_out===0)?ir:Ji}function qr(Ie,ai){for(var Jt,At,gi;;){if(Ie.lookahead<Ci){if(Ah(Ie),Ie.lookahead<Ci&&ai===_)return ir;if(Ie.lookahead===0)break}if(Jt=0,Ie.lookahead>=Li&&(Ie.ins_h=(Ie.ins_h<<Ie.hash_shift^Ie.window[Ie.strstart+Li-1])&Ie.hash_mask,Jt=Ie.prev[Ie.strstart&Ie.w_mask]=Ie.head[Ie.ins_h],Ie.head[Ie.ins_h]=Ie.strstart),Ie.prev_length=Ie.match_length,Ie.prev_match=Ie.match_start,Ie.match_length=Li-1,Jt!==0&&Ie.prev_length<Ie.max_lazy_match&&Ie.strstart-Jt<=Ie.w_size-Ci&&(Ie.match_length=jg(Ie,Jt),Ie.match_length<=5&&(Ie.strategy===ze||Ie.match_length===Li&&Ie.strstart-Ie.match_start>4096)&&(Ie.match_length=Li-1)),Ie.prev_length>=Li&&Ie.match_length<=Ie.prev_length){gi=Ie.strstart+Ie.lookahead-Li,At=c._tr_tally(Ie,Ie.strstart-1-Ie.prev_match,Ie.prev_length-Li),Ie.lookahead-=Ie.prev_length-1,Ie.prev_length-=2;do++Ie.strstart<=gi&&(Ie.ins_h=(Ie.ins_h<<Ie.hash_shift^Ie.window[Ie.strstart+Li-1])&Ie.hash_mask,Jt=Ie.prev[Ie.strstart&Ie.w_mask]=Ie.head[Ie.ins_h],Ie.head[Ie.ins_h]=Ie.strstart);while(--Ie.prev_length!=0);if(Ie.match_available=0,Ie.match_length=Li-1,Ie.strstart++,At&&(Zo(Ie,!1),Ie.strm.avail_out===0))return ir}else if(Ie.match_available){if((At=c._tr_tally(Ie,0,Ie.window[Ie.strstart-1]))&&Zo(Ie,!1),Ie.strstart++,Ie.lookahead--,Ie.strm.avail_out===0)return ir}else Ie.match_available=1,Ie.strstart++,Ie.lookahead--}return Ie.match_available&&(At=c._tr_tally(Ie,0,Ie.window[Ie.strstart-1]),Ie.match_available=0),Ie.insert=Ie.strstart<Li-1?Ie.strstart:Li-1,ai===W?(Zo(Ie,!0),Ie.strm.avail_out===0?pa:Ca):Ie.last_lit&&(Zo(Ie,!1),Ie.strm.avail_out===0)?ir:Ji}function Ol(Ie,ai){for(var Jt,At,gi,_i,sr=Ie.window;;){if(Ie.lookahead<=cn){if(Ah(Ie),Ie.lookahead<=cn&&ai===_)return ir;if(Ie.lookahead===0)break}if(Ie.match_length=0,Ie.lookahead>=Li&&Ie.strstart>0&&(At=sr[gi=Ie.strstart-1])===sr[++gi]&&At===sr[++gi]&&At===sr[++gi]){_i=Ie.strstart+cn;do;while(At===sr[++gi]&&At===sr[++gi]&&At===sr[++gi]&&At===sr[++gi]&&At===sr[++gi]&&At===sr[++gi]&&At===sr[++gi]&&At===sr[++gi]&&gi<_i);Ie.match_length=cn-(_i-gi),Ie.match_length>Ie.lookahead&&(Ie.match_length=Ie.lookahead)}if(Ie.match_length>=Li?(Jt=c._tr_tally(Ie,1,Ie.match_length-Li),Ie.lookahead-=Ie.match_length,Ie.strstart+=Ie.match_length,Ie.match_length=0):(Jt=c._tr_tally(Ie,0,Ie.window[Ie.strstart]),Ie.lookahead--,Ie.strstart++),Jt&&(Zo(Ie,!1),Ie.strm.avail_out===0))return ir}return Ie.insert=0,ai===W?(Zo(Ie,!0),Ie.strm.avail_out===0?pa:Ca):Ie.last_lit&&(Zo(Ie,!1),Ie.strm.avail_out===0)?ir:Ji}function Ih(Ie,ai){for(var Jt;;){if(Ie.lookahead===0&&(Ah(Ie),Ie.lookahead===0)){if(ai===_)return ir;break}if(Ie.match_length=0,Jt=c._tr_tally(Ie,0,Ie.window[Ie.strstart]),Ie.lookahead--,Ie.strstart++,Jt&&(Zo(Ie,!1),Ie.strm.avail_out===0))return ir}return Ie.insert=0,ai===W?(Zo(Ie,!0),Ie.strm.avail_out===0?pa:Ca):Ie.last_lit&&(Zo(Ie,!1),Ie.strm.avail_out===0)?ir:Ji}function mo(Ie,ai,Jt,At,gi){this.good_length=Ie,this.max_lazy=ai,this.nice_length=Jt,this.max_chain=At,this.func=gi}function ig(Ie){Ie.window_size=2*Ie.w_size,eo(Ie.head),Ie.max_lazy_match=a[Ie.level].max_lazy,Ie.good_match=a[Ie.level].good_length,Ie.nice_match=a[Ie.level].nice_length,Ie.max_chain_length=a[Ie.level].max_chain,Ie.strstart=0,Ie.block_start=0,Ie.lookahead=0,Ie.insert=0,Ie.match_length=Ie.prev_length=Li-1,Ie.match_available=0,Ie.ins_h=0}function pi(){this.strm=null,this.status=0,this.pending_buf=null,this.pending_buf_size=0,this.pending_out=0,this.pending=0,this.wrap=0,this.gzhead=null,this.gzindex=0,this.method=Ze,this.last_flush=-1,this.w_size=0,this.w_bits=0,this.w_mask=0,this.window=null,this.window_size=0,this.prev=null,this.head=null,this.ins_h=0,this.hash_size=0,this.hash_bits=0,this.hash_mask=0,this.hash_shift=0,this.block_start=0,this.match_length=0,this.prev_match=0,this.match_available=0,this.strstart=0,this.match_start=0,this.lookahead=0,this.prev_length=0,this.max_chain_length=0,this.max_lazy_match=0,this.level=0,this.strategy=0,this.good_match=0,this.nice_match=0,this.dyn_ltree=new s.Buf16(2*xt),this.dyn_dtree=new s.Buf16(2*(2*pt+1)),this.bl_tree=new s.Buf16(2*(2*Lt+1)),eo(this.dyn_ltree),eo(this.dyn_dtree),eo(this.bl_tree),this.l_desc=null,this.d_desc=null,this.bl_desc=null,this.bl_count=new s.Buf16(yi+1),this.heap=new s.Buf16(2*Yt+1),eo(this.heap),this.heap_len=0,this.heap_max=0,this.depth=new s.Buf16(2*Yt+1),eo(this.depth),this.l_buf=0,this.lit_bufsize=0,this.last_lit=0,this.d_buf=0,this.opt_len=0,this.static_len=0,this.matches=0,this.insert=0,this.bi_buf=0,this.bi_valid=0}function Qn(Ie){var ai;return Ie&&Ie.state?(Ie.total_in=Ie.total_out=0,Ie.data_type=Qe,(ai=Ie.state).pending=0,ai.pending_out=0,ai.wrap<0&&(ai.wrap=-ai.wrap),ai.status=ai.wrap?An:ss,Ie.adler=ai.wrap===2?0:1,ai.last_flush=_,c._tr_init(ai),oe):Wn(Ie,se)}function ft(Ie){var ai=Qn(Ie);return ai===oe&&ig(Ie.state),ai}function Hi(Ie,ai){return Ie&&Ie.state?Ie.state.wrap!==2?se:(Ie.state.gzhead=ai,oe):se}function Qt(Ie,ai,Jt,At,gi,_i){if(!Ie)return se;var sr=1;if(ai===Ne&&(ai=6),At<0?(sr=0,At=-At):At>15&&(sr=2,At-=16),gi<1||gi>Xe||Jt!==Ze||At<8||At>15||ai<0||ai>9||_i<0||_i>Ee)return Wn(Ie,se);At===8&&(At=9);var ya=new pi;return Ie.state=ya,ya.strm=Ie,ya.wrap=sr,ya.gzhead=null,ya.w_bits=At,ya.w_size=1<<ya.w_bits,ya.w_mask=ya.w_size-1,ya.hash_bits=gi+7,ya.hash_size=1<<ya.hash_bits,ya.hash_mask=ya.hash_size-1,ya.hash_shift=~~((ya.hash_bits+Li-1)/Li),ya.window=new s.Buf8(2*ya.w_size),ya.head=new s.Buf16(ya.hash_size),ya.prev=new s.Buf16(ya.w_size),ya.lit_bufsize=1<<gi+6,ya.pending_buf_size=4*ya.lit_bufsize,ya.pending_buf=new s.Buf8(ya.pending_buf_size),ya.d_buf=1*ya.lit_bufsize,ya.l_buf=3*ya.lit_bufsize,ya.level=ai,ya.strategy=_i,ya.method=Jt,ft(Ie)}function xi(Ie,ai){return Qt(Ie,ai,Ze,bt,Ot,Pe)}function at(Ie,ai){var Jt,At,gi,_i;if(!Ie||!Ie.state||ai>ee||ai<0)return Ie?Wn(Ie,se):se;if(At=Ie.state,!Ie.output||!Ie.input&&Ie.avail_in!==0||At.status===Ya&&ai!==W)return Wn(Ie,Ie.avail_out===0?ue:se);if(At.strm=Ie,Jt=At.last_flush,At.last_flush=ai,At.status===An)if(At.wrap===2)Ie.adler=0,oo(At,31),oo(At,139),oo(At,8),At.gzhead?(oo(At,(At.gzhead.text?1:0)+(At.gzhead.hcrc?2:0)+(At.gzhead.extra?4:0)+(At.gzhead.name?8:0)+(At.gzhead.comment?16:0)),oo(At,255&At.gzhead.time),oo(At,At.gzhead.time>>8&255),oo(At,At.gzhead.time>>16&255),oo(At,At.gzhead.time>>24&255),oo(At,At.level===9?2:At.strategy>=He||At.level<2?4:0),oo(At,255&At.gzhead.os),At.gzhead.extra&&At.gzhead.extra.length&&(oo(At,255&At.gzhead.extra.length),oo(At,At.gzhead.extra.length>>8&255)),At.gzhead.hcrc&&(Ie.adler=m(Ie.adler,At.pending_buf,At.pending,0)),At.gzindex=0,At.status=Ea):(oo(At,0),oo(At,0),oo(At,0),oo(At,0),oo(At,0),oo(At,At.level===9?2:At.strategy>=He||At.level<2?4:0),oo(At,da),At.status=ss);else{var sr=Ze+(At.w_bits-8<<4)<<8;sr|=(At.strategy>=He||At.level<2?0:At.level<6?1:At.level===6?2:3)<<6,At.strstart!==0&&(sr|=ji),sr+=31-sr%31,At.status=ss,Xu(At,sr),At.strstart!==0&&(Xu(At,Ie.adler>>>16),Xu(At,65535&Ie.adler)),Ie.adler=1}if(At.status===Ea)if(At.gzhead.extra){for(gi=At.pending;At.gzindex<(65535&At.gzhead.extra.length)&&(At.pending!==At.pending_buf_size||(At.gzhead.hcrc&&At.pending>gi&&(Ie.adler=m(Ie.adler,At.pending_buf,At.pending-gi,gi)),Uo(Ie),gi=At.pending,At.pending!==At.pending_buf_size));)oo(At,255&At.gzhead.extra[At.gzindex]),At.gzindex++;At.gzhead.hcrc&&At.pending>gi&&(Ie.adler=m(Ie.adler,At.pending_buf,At.pending-gi,gi)),At.gzindex===At.gzhead.extra.length&&(At.gzindex=0,At.status=Ln)}else At.status=Ln;if(At.status===Ln)if(At.gzhead.name){gi=At.pending;do{if(At.pending===At.pending_buf_size&&(At.gzhead.hcrc&&At.pending>gi&&(Ie.adler=m(Ie.adler,At.pending_buf,At.pending-gi,gi)),Uo(Ie),gi=At.pending,At.pending===At.pending_buf_size)){_i=1;break}_i=At.gzindex<At.gzhead.name.length?255&At.gzhead.name.charCodeAt(At.gzindex++):0,oo(At,_i)}while(_i!==0);At.gzhead.hcrc&&At.pending>gi&&(Ie.adler=m(Ie.adler,At.pending_buf,At.pending-gi,gi)),_i===0&&(At.gzindex=0,At.status=ga)}else At.status=ga;if(At.status===ga)if(At.gzhead.comment){gi=At.pending;do{if(At.pending===At.pending_buf_size&&(At.gzhead.hcrc&&At.pending>gi&&(Ie.adler=m(Ie.adler,At.pending_buf,At.pending-gi,gi)),Uo(Ie),gi=At.pending,At.pending===At.pending_buf_size)){_i=1;break}_i=At.gzindex<At.gzhead.comment.length?255&At.gzhead.comment.charCodeAt(At.gzindex++):0,oo(At,_i)}while(_i!==0);At.gzhead.hcrc&&At.pending>gi&&(Ie.adler=m(Ie.adler,At.pending_buf,At.pending-gi,gi)),_i===0&&(At.status=vs)}else At.status=vs;if(At.status===vs&&(At.gzhead.hcrc?(At.pending+2>At.pending_buf_size&&Uo(Ie),At.pending+2<=At.pending_buf_size&&(oo(At,255&Ie.adler),oo(At,Ie.adler>>8&255),Ie.adler=0,At.status=ss)):At.status=ss),At.pending!==0){if(Uo(Ie),Ie.avail_out===0)return At.last_flush=-1,oe}else if(Ie.avail_in===0&&co(ai)<=co(Jt)&&ai!==W)return Wn(Ie,ue);if(At.status===Ya&&Ie.avail_in!==0)return Wn(Ie,ue);if(Ie.avail_in!==0||At.lookahead!==0||ai!==_&&At.status!==Ya){var ya=At.strategy===He?Ih(At,ai):At.strategy===be?Ol(At,ai):a[At.level].func(At,ai);if(ya!==pa&&ya!==Ca||(At.status=Ya),ya===ir||ya===pa)return Ie.avail_out===0&&(At.last_flush=-1),oe;if(ya===Ji&&(ai===k?c._tr_align(At):ai!==ee&&(c._tr_stored_block(At,0,0,!1),ai===N&&(eo(At.head),At.lookahead===0&&(At.strstart=0,At.block_start=0,At.insert=0))),Uo(Ie),Ie.avail_out===0))return At.last_flush=-1,oe}return ai!==W?oe:At.wrap<=0?de:(At.wrap===2?(oo(At,255&Ie.adler),oo(At,Ie.adler>>8&255),oo(At,Ie.adler>>16&255),oo(At,Ie.adler>>24&255),oo(At,255&Ie.total_in),oo(At,Ie.total_in>>8&255),oo(At,Ie.total_in>>16&255),oo(At,Ie.total_in>>24&255)):(Xu(At,Ie.adler>>>16),Xu(At,65535&Ie.adler)),Uo(Ie),At.wrap>0&&(At.wrap=-At.wrap),At.pending!==0?oe:de)}function Ki(Ie){var ai;return Ie&&Ie.state?(ai=Ie.state.status)!==An&&ai!==Ea&&ai!==Ln&&ai!==ga&&ai!==vs&&ai!==ss&&ai!==Ya?Wn(Ie,se):(Ie.state=null,ai===ss?Wn(Ie,Re):oe):se}function bi(Ie,ai){var Jt,At,gi,_i,sr,ya,dr,Ps,eT=ai.length;if(!Ie||!Ie.state||(_i=(Jt=Ie.state).wrap)===2||_i===1&&Jt.status!==An||Jt.lookahead)return se;for(_i===1&&(Ie.adler=u(Ie.adler,ai,eT,0)),Jt.wrap=0,eT>=Jt.w_size&&(_i===0&&(eo(Jt.head),Jt.strstart=0,Jt.block_start=0,Jt.insert=0),Ps=new s.Buf8(Jt.w_size),s.arraySet(Ps,ai,eT-Jt.w_size,Jt.w_size,0),ai=Ps,eT=Jt.w_size),sr=Ie.avail_in,ya=Ie.next_in,dr=Ie.input,Ie.avail_in=eT,Ie.next_in=0,Ie.input=ai,Ah(Jt);Jt.lookahead>=Li;){At=Jt.strstart,gi=Jt.lookahead-(Li-1);do Jt.ins_h=(Jt.ins_h<<Jt.hash_shift^Jt.window[At+Li-1])&Jt.hash_mask,Jt.prev[At&Jt.w_mask]=Jt.head[Jt.ins_h],Jt.head[Jt.ins_h]=At,At++;while(--gi);Jt.strstart=At,Jt.lookahead=Li-1,Ah(Jt)}return Jt.strstart+=Jt.lookahead,Jt.block_start=Jt.strstart,Jt.insert=Jt.lookahead,Jt.lookahead=0,Jt.match_length=Jt.prev_length=Li-1,Jt.match_available=0,Ie.next_in=ya,Ie.input=dr,Ie.avail_in=sr,Jt.wrap=_i,oe}a=[new mo(0,0,0,0,es),new mo(4,4,8,4,qs),new mo(4,5,16,8,qs),new mo(4,6,32,32,qs),new mo(4,4,16,16,qr),new mo(8,16,32,32,qr),new mo(8,16,128,128,qr),new mo(8,32,128,256,qr),new mo(32,128,258,1024,qr),new mo(32,258,258,4096,qr)],n.deflateInit=xi,n.deflateInit2=Qt,n.deflateReset=ft,n.deflateResetKeep=Qn,n.deflateSetHeader=Hi,n.deflate=at,n.deflateEnd=Ki,n.deflateSetDictionary=bi,n.deflateInfo="pako deflate (from Nodeca project)"}}),NS=oi({"../node_modules/pako/lib/utils/strings.js"(n){var a=Eo(),s=!0,c=!0;try{String.fromCharCode.apply(null,[0])}catch{s=!1}try{String.fromCharCode.apply(null,new Uint8Array(1))}catch{c=!1}var u,m=new a.Buf8(256);for(u=0;u<256;u++)m[u]=u>=252?6:u>=248?5:u>=240?4:u>=224?3:u>=192?2:1;function b(_,k){if(k<65534&&(_.subarray&&c||!_.subarray&&s))return String.fromCharCode.apply(null,a.shrinkBuf(_,k));for(var N="",W=0;W<k;W++)N+=String.fromCharCode(_[W]);return N}m[254]=m[254]=1,n.string2buf=function(_){var k,N,W,ee,oe,de=_.length,se=0;for(ee=0;ee<de;ee++)(64512&(N=_.charCodeAt(ee)))==55296&&ee+1<de&&(64512&(W=_.charCodeAt(ee+1)))==56320&&(N=65536+(N-55296<<10)+(W-56320),ee++),se+=N<128?1:N<2048?2:N<65536?3:4;for(k=new a.Buf8(se),oe=0,ee=0;oe<se;ee++)(64512&(N=_.charCodeAt(ee)))==55296&&ee+1<de&&(64512&(W=_.charCodeAt(ee+1)))==56320&&(N=65536+(N-55296<<10)+(W-56320),ee++),N<128?k[oe++]=N:N<2048?(k[oe++]=192|N>>>6,k[oe++]=128|63&N):N<65536?(k[oe++]=224|N>>>12,k[oe++]=128|N>>>6&63,k[oe++]=128|63&N):(k[oe++]=240|N>>>18,k[oe++]=128|N>>>12&63,k[oe++]=128|N>>>6&63,k[oe++]=128|63&N);return k},n.buf2binstring=function(_){return b(_,_.length)},n.binstring2buf=function(_){for(var k=new a.Buf8(_.length),N=0,W=k.length;N<W;N++)k[N]=_.charCodeAt(N);return k},n.buf2string=function(_,k){var N,W,ee,oe,de=k||_.length,se=new Array(2*de);for(W=0,N=0;N<de;)if((ee=_[N++])<128)se[W++]=ee;else if((oe=m[ee])>4)se[W++]=65533,N+=oe-1;else{for(ee&=oe===2?31:oe===3?15:7;oe>1&&N<de;)ee=ee<<6|63&_[N++],oe--;oe>1?se[W++]=65533:ee<65536?se[W++]=ee:(ee-=65536,se[W++]=55296|ee>>10&1023,se[W++]=56320|1023&ee)}return b(se,W)},n.utf8border=function(_,k){var N;for((k=k||_.length)>_.length&&(k=_.length),N=k-1;N>=0&&(192&_[N])==128;)N--;return N<0||N===0?k:N+m[_[N]]>k?N:k}}}),Zp=oi({"../node_modules/pako/lib/zlib/zstream.js"(n,a){function s(){this.input=null,this.next_in=0,this.avail_in=0,this.total_in=0,this.output=null,this.next_out=0,this.avail_out=0,this.total_out=0,this.msg="",this.state=null,this.data_type=2,this.adler=0}a.exports=s}}),iC=oi({"../node_modules/pako/lib/deflate.js"(n){var a=W_(),s=Eo(),c=NS(),u=Cm(),m=Zp(),b=Object.prototype.toString,_=0,k=4,N=0,W=1,ee=2,oe=-1,de=0,se=8;function Re(He){if(!(this instanceof Re))return new Re(He);this.options=s.assign({level:oe,method:se,chunkSize:16384,windowBits:15,memLevel:8,strategy:de,to:""},He||{});var be=this.options;be.raw&&be.windowBits>0?be.windowBits=-be.windowBits:be.gzip&&be.windowBits>0&&be.windowBits<16&&(be.windowBits+=16),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new m,this.strm.avail_out=0;var Ee=a.deflateInit2(this.strm,be.level,be.method,be.windowBits,be.memLevel,be.strategy);if(Ee!==N)throw new Error(u[Ee]);if(be.header&&a.deflateSetHeader(this.strm,be.header),be.dictionary){var Pe;if(Pe=typeof be.dictionary=="string"?c.string2buf(be.dictionary):b.call(be.dictionary)==="[object ArrayBuffer]"?new Uint8Array(be.dictionary):be.dictionary,(Ee=a.deflateSetDictionary(this.strm,Pe))!==N)throw new Error(u[Ee]);this._dict_set=!0}}function ue(He,be){var Ee=new Re(be);if(Ee.push(He,!0),Ee.err)throw Ee.msg||u[Ee.err];return Ee.result}function Ne(He,be){return(be=be||{}).raw=!0,ue(He,be)}function ze(He,be){return(be=be||{}).gzip=!0,ue(He,be)}Re.prototype.push=function(He,be){var Ee,Pe,Qe=this.strm,Ze=this.options.chunkSize;if(this.ended)return!1;Pe=be===~~be?be:be===!0?k:_,typeof He=="string"?Qe.input=c.string2buf(He):b.call(He)==="[object ArrayBuffer]"?Qe.input=new Uint8Array(He):Qe.input=He,Qe.next_in=0,Qe.avail_in=Qe.input.length;do{if(Qe.avail_out===0&&(Qe.output=new s.Buf8(Ze),Qe.next_out=0,Qe.avail_out=Ze),(Ee=a.deflate(Qe,Pe))!==W&&Ee!==N)return this.onEnd(Ee),this.ended=!0,!1;Qe.avail_out!==0&&(Qe.avail_in!==0||Pe!==k&&Pe!==ee)||(this.options.to==="string"?this.onData(c.buf2binstring(s.shrinkBuf(Qe.output,Qe.next_out))):this.onData(s.shrinkBuf(Qe.output,Qe.next_out)))}while((Qe.avail_in>0||Qe.avail_out===0)&&Ee!==W);return Pe===k?(Ee=a.deflateEnd(this.strm),this.onEnd(Ee),this.ended=!0,Ee===N):Pe!==ee||(this.onEnd(N),Qe.avail_out=0,!0)},Re.prototype.onData=function(He){this.chunks.push(He)},Re.prototype.onEnd=function(He){He===N&&(this.options.to==="string"?this.result=this.chunks.join(""):this.result=s.flattenChunks(this.chunks)),this.chunks=[],this.err=He,this.msg=this.strm.msg},n.Deflate=Re,n.deflate=ue,n.deflateRaw=Ne,n.gzip=ze}}),_m=oi({"../node_modules/pako/lib/zlib/inffast.js"(n,a){var s=30,c=12;a.exports=function(m,b){var _,k,N,W,ee,oe,de,se,Re,ue,Ne,ze,He,be,Ee,Pe,Qe,Ze,Xe,bt,Ot,Yt,pt,Lt,xt;_=m.state,k=m.next_in,Lt=m.input,N=k+(m.avail_in-5),W=m.next_out,xt=m.output,ee=W-(b-m.avail_out),oe=W+(m.avail_out-257),de=_.dmax,se=_.wsize,Re=_.whave,ue=_.wnext,Ne=_.window,ze=_.hold,He=_.bits,be=_.lencode,Ee=_.distcode,Pe=(1<<_.lenbits)-1,Qe=(1<<_.distbits)-1;e:do{He<15&&(ze+=Lt[k++]<<He,He+=8,ze+=Lt[k++]<<He,He+=8),Ze=be[ze&Pe];t:for(;;){if(ze>>>=Xe=Ze>>>24,He-=Xe,(Xe=Ze>>>16&255)==0)xt[W++]=65535&Ze;else{if(!(16&Xe)){if(64&Xe){if(32&Xe){_.mode=c;break e}m.msg="invalid literal/length code",_.mode=s;break e}Ze=be[(65535&Ze)+(ze&(1<<Xe)-1)];continue t}for(bt=65535&Ze,(Xe&=15)&&(He<Xe&&(ze+=Lt[k++]<<He,He+=8),bt+=ze&(1<<Xe)-1,ze>>>=Xe,He-=Xe),He<15&&(ze+=Lt[k++]<<He,He+=8,ze+=Lt[k++]<<He,He+=8),Ze=Ee[ze&Qe];;){if(ze>>>=Xe=Ze>>>24,He-=Xe,16&(Xe=Ze>>>16&255)){if(Ot=65535&Ze,He<(Xe&=15)&&(ze+=Lt[k++]<<He,(He+=8)<Xe&&(ze+=Lt[k++]<<He,He+=8)),(Ot+=ze&(1<<Xe)-1)>de){m.msg="invalid distance too far back",_.mode=s;break e}if(ze>>>=Xe,He-=Xe,Ot>(Xe=W-ee)){if((Xe=Ot-Xe)>Re&&_.sane){m.msg="invalid distance too far back",_.mode=s;break e}if(Yt=0,pt=Ne,ue===0){if(Yt+=se-Xe,Xe<bt){bt-=Xe;do xt[W++]=Ne[Yt++];while(--Xe);Yt=W-Ot,pt=xt}}else if(ue<Xe){if(Yt+=se+ue-Xe,(Xe-=ue)<bt){bt-=Xe;do xt[W++]=Ne[Yt++];while(--Xe);if(Yt=0,ue<bt){bt-=Xe=ue;do xt[W++]=Ne[Yt++];while(--Xe);Yt=W-Ot,pt=xt}}}else if(Yt+=ue-Xe,Xe<bt){bt-=Xe;do xt[W++]=Ne[Yt++];while(--Xe);Yt=W-Ot,pt=xt}for(;bt>2;)xt[W++]=pt[Yt++],xt[W++]=pt[Yt++],xt[W++]=pt[Yt++],bt-=3;bt&&(xt[W++]=pt[Yt++],bt>1&&(xt[W++]=pt[Yt++]))}else{Yt=W-Ot;do xt[W++]=xt[Yt++],xt[W++]=xt[Yt++],xt[W++]=xt[Yt++],bt-=3;while(bt>2);bt&&(xt[W++]=xt[Yt++],bt>1&&(xt[W++]=xt[Yt++]))}break}if(64&Xe){m.msg="invalid distance code",_.mode=s;break e}Ze=Ee[(65535&Ze)+(ze&(1<<Xe)-1)]}}break}}while(k<N&&W<oe);k-=bt=He>>3,ze&=(1<<(He-=bt<<3))-1,m.next_in=k,m.next_out=W,m.avail_in=k<N?N-k+5:5-(k-N),m.avail_out=W<oe?oe-W+257:257-(W-oe),_.hold=ze,_.bits=He}}}),Em=oi({"../node_modules/pako/lib/zlib/inftrees.js"(n,a){var s=Eo(),c=15,u=852,m=592,b=0,_=1,k=2,N=[3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258,0,0],W=[16,16,16,16,16,16,16,16,17,17,17,17,18,18,18,18,19,19,19,19,20,20,20,20,21,21,21,21,16,72,78],ee=[1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577,0,0],oe=[16,16,16,16,17,17,18,18,19,19,20,20,21,21,22,22,23,23,24,24,25,25,26,26,27,27,28,28,29,29,64,64];a.exports=function(se,Re,ue,Ne,ze,He,be,Ee){var Pe,Qe,Ze,Xe,bt,Ot,Yt,pt,Lt,xt=Ee.bits,yi=0,Li=0,cn=0,Ci=0,ji=0,An=0,Ea=0,Ln=0,ga=0,vs=0,ss=null,Ya=0,ir=new s.Buf16(c+1),Ji=new s.Buf16(c+1),pa=null,Ca=0;for(yi=0;yi<=c;yi++)ir[yi]=0;for(Li=0;Li<Ne;Li++)ir[Re[ue+Li]]++;for(ji=xt,Ci=c;Ci>=1&&ir[Ci]===0;Ci--);if(ji>Ci&&(ji=Ci),Ci===0)return ze[He++]=20971520,ze[He++]=20971520,Ee.bits=1,0;for(cn=1;cn<Ci&&ir[cn]===0;cn++);for(ji<cn&&(ji=cn),Ln=1,yi=1;yi<=c;yi++)if(Ln<<=1,(Ln-=ir[yi])<0)return-1;if(Ln>0&&(se===b||Ci!==1))return-1;for(Ji[1]=0,yi=1;yi<c;yi++)Ji[yi+1]=Ji[yi]+ir[yi];for(Li=0;Li<Ne;Li++)Re[ue+Li]!==0&&(be[Ji[Re[ue+Li]]++]=Li);if(se===b?(ss=pa=be,Ot=19):se===_?(ss=N,Ya-=257,pa=W,Ca-=257,Ot=256):(ss=ee,pa=oe,Ot=-1),vs=0,Li=0,yi=cn,bt=He,An=ji,Ea=0,Ze=-1,Xe=(ga=1<<ji)-1,se===_&&ga>u||se===k&&ga>m)return 1;for(;;){Yt=yi-Ea,be[Li]<Ot?(pt=0,Lt=be[Li]):be[Li]>Ot?(pt=pa[Ca+be[Li]],Lt=ss[Ya+be[Li]]):(pt=96,Lt=0),Pe=1<<yi-Ea,cn=Qe=1<<An;do ze[bt+(vs>>Ea)+(Qe-=Pe)]=Yt<<24|pt<<16|Lt;while(Qe!==0);for(Pe=1<<yi-1;vs&Pe;)Pe>>=1;if(Pe!==0?(vs&=Pe-1,vs+=Pe):vs=0,Li++,--ir[yi]==0){if(yi===Ci)break;yi=Re[ue+be[Li]]}if(yi>ji&&(vs&Xe)!==Ze){for(Ea===0&&(Ea=ji),bt+=cn,Ln=1<<(An=yi-Ea);An+Ea<Ci&&!((Ln-=ir[An+Ea])<=0);)An++,Ln<<=1;if(ga+=1<<An,se===_&&ga>u||se===k&&ga>m)return 1;ze[Ze=vs&Xe]=ji<<24|An<<16|bt-He}}return vs!==0&&(ze[bt+vs]=yi-Ea<<24|64<<16),Ee.bits=ji,0}}}),nC=oi({"../node_modules/pako/lib/zlib/inflate.js"(n){var a=Eo(),s=sd(),c=xh(),u=_m(),m=Em(),b=0,_=1,k=2,N=4,W=5,ee=6,oe=0,de=1,se=2,Re=-2,ue=-3,Ne=-4,ze=-5,He=8,be=1,Ee=2,Pe=3,Qe=4,Ze=5,Xe=6,bt=7,Ot=8,Yt=9,pt=10,Lt=11,xt=12,yi=13,Li=14,cn=15,Ci=16,ji=17,An=18,Ea=19,Ln=20,ga=21,vs=22,ss=23,Ya=24,ir=25,Ji=26,pa=27,Ca=28,da=29,Wn=30,co=31,eo=852,Uo=592,Zo=15;function oo(Qt){return(Qt>>>24&255)+(Qt>>>8&65280)+((65280&Qt)<<8)+((255&Qt)<<24)}function Xu(){this.mode=0,this.last=!1,this.wrap=0,this.havedict=!1,this.flags=0,this.dmax=0,this.check=0,this.total=0,this.head=null,this.wbits=0,this.wsize=0,this.whave=0,this.wnext=0,this.window=null,this.hold=0,this.bits=0,this.length=0,this.offset=0,this.extra=0,this.lencode=null,this.distcode=null,this.lenbits=0,this.distbits=0,this.ncode=0,this.nlen=0,this.ndist=0,this.have=0,this.next=null,this.lens=new a.Buf16(320),this.work=new a.Buf16(288),this.lendyn=null,this.distdyn=null,this.sane=0,this.back=0,this.was=0}function kd(Qt){var xi;return Qt&&Qt.state?(xi=Qt.state,Qt.total_in=Qt.total_out=xi.total=0,Qt.msg="",xi.wrap&&(Qt.adler=1&xi.wrap),xi.mode=be,xi.last=0,xi.havedict=0,xi.dmax=32768,xi.head=null,xi.hold=0,xi.bits=0,xi.lencode=xi.lendyn=new a.Buf32(eo),xi.distcode=xi.distdyn=new a.Buf32(Uo),xi.sane=1,xi.back=-1,oe):Re}function jg(Qt){var xi;return Qt&&Qt.state?((xi=Qt.state).wsize=0,xi.whave=0,xi.wnext=0,kd(Qt)):Re}function Ah(Qt,xi){var at,Ki;return Qt&&Qt.state?(Ki=Qt.state,xi<0?(at=0,xi=-xi):(at=1+(xi>>4),xi<48&&(xi&=15)),xi&&(xi<8||xi>15)?Re:(Ki.window!==null&&Ki.wbits!==xi&&(Ki.window=null),Ki.wrap=at,Ki.wbits=xi,jg(Qt))):Re}function es(Qt,xi){var at,Ki;return Qt?(Ki=new Xu,Qt.state=Ki,Ki.window=null,(at=Ah(Qt,xi))!==oe&&(Qt.state=null),at):Re}function qs(Qt){return es(Qt,Zo)}var qr,Ol,Ih=!0;function mo(Qt){if(Ih){var xi;for(qr=new a.Buf32(512),Ol=new a.Buf32(32),xi=0;xi<144;)Qt.lens[xi++]=8;for(;xi<256;)Qt.lens[xi++]=9;for(;xi<280;)Qt.lens[xi++]=7;for(;xi<288;)Qt.lens[xi++]=8;for(m(_,Qt.lens,0,288,qr,0,Qt.work,{bits:9}),xi=0;xi<32;)Qt.lens[xi++]=5;m(k,Qt.lens,0,32,Ol,0,Qt.work,{bits:5}),Ih=!1}Qt.lencode=qr,Qt.lenbits=9,Qt.distcode=Ol,Qt.distbits=5}function ig(Qt,xi,at,Ki){var bi,Ie=Qt.state;return Ie.window===null&&(Ie.wsize=1<<Ie.wbits,Ie.wnext=0,Ie.whave=0,Ie.window=new a.Buf8(Ie.wsize)),Ki>=Ie.wsize?(a.arraySet(Ie.window,xi,at-Ie.wsize,Ie.wsize,0),Ie.wnext=0,Ie.whave=Ie.wsize):((bi=Ie.wsize-Ie.wnext)>Ki&&(bi=Ki),a.arraySet(Ie.window,xi,at-Ki,bi,Ie.wnext),(Ki-=bi)?(a.arraySet(Ie.window,xi,at-Ki,Ki,0),Ie.wnext=Ki,Ie.whave=Ie.wsize):(Ie.wnext+=bi,Ie.wnext===Ie.wsize&&(Ie.wnext=0),Ie.whave<Ie.wsize&&(Ie.whave+=bi))),0}function pi(Qt,xi){var at,Ki,bi,Ie,ai,Jt,At,gi,_i,sr,ya,dr,Ps,eT,gu,km,HS,Oy,Cae,_ae,Rm,sA,lL,mM,tT=0,Ny=new a.Buf8(4),vQe=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];if(!Qt||!Qt.state||!Qt.output||!Qt.input&&Qt.avail_in!==0)return Re;(at=Qt.state).mode===xt&&(at.mode=yi),ai=Qt.next_out,bi=Qt.output,At=Qt.avail_out,Ie=Qt.next_in,Ki=Qt.input,Jt=Qt.avail_in,gi=at.hold,_i=at.bits,sr=Jt,ya=At,sA=oe;e:for(;;)switch(at.mode){case be:if(at.wrap===0){at.mode=yi;break}for(;_i<16;){if(Jt===0)break e;Jt--,gi+=Ki[Ie++]<<_i,_i+=8}if(2&at.wrap&&gi===35615){at.check=0,Ny[0]=255&gi,Ny[1]=gi>>>8&255,at.check=c(at.check,Ny,2,0),gi=0,_i=0,at.mode=Ee;break}if(at.flags=0,at.head&&(at.head.done=!1),!(1&at.wrap)||(((255&gi)<<8)+(gi>>8))%31){Qt.msg="incorrect header check",at.mode=Wn;break}if((15&gi)!==He){Qt.msg="unknown compression method",at.mode=Wn;break}if(_i-=4,Rm=8+(15&(gi>>>=4)),at.wbits===0)at.wbits=Rm;else if(Rm>at.wbits){Qt.msg="invalid window size",at.mode=Wn;break}at.dmax=1<<Rm,Qt.adler=at.check=1,at.mode=512&gi?pt:xt,gi=0,_i=0;break;case Ee:for(;_i<16;){if(Jt===0)break e;Jt--,gi+=Ki[Ie++]<<_i,_i+=8}if(at.flags=gi,(255&at.flags)!==He){Qt.msg="unknown compression method",at.mode=Wn;break}if(57344&at.flags){Qt.msg="unknown header flags set",at.mode=Wn;break}at.head&&(at.head.text=gi>>8&1),512&at.flags&&(Ny[0]=255&gi,Ny[1]=gi>>>8&255,at.check=c(at.check,Ny,2,0)),gi=0,_i=0,at.mode=Pe;case Pe:for(;_i<32;){if(Jt===0)break e;Jt--,gi+=Ki[Ie++]<<_i,_i+=8}at.head&&(at.head.time=gi),512&at.flags&&(Ny[0]=255&gi,Ny[1]=gi>>>8&255,Ny[2]=gi>>>16&255,Ny[3]=gi>>>24&255,at.check=c(at.check,Ny,4,0)),gi=0,_i=0,at.mode=Qe;case Qe:for(;_i<16;){if(Jt===0)break e;Jt--,gi+=Ki[Ie++]<<_i,_i+=8}at.head&&(at.head.xflags=255&gi,at.head.os=gi>>8),512&at.flags&&(Ny[0]=255&gi,Ny[1]=gi>>>8&255,at.check=c(at.check,Ny,2,0)),gi=0,_i=0,at.mode=Ze;case Ze:if(1024&at.flags){for(;_i<16;){if(Jt===0)break e;Jt--,gi+=Ki[Ie++]<<_i,_i+=8}at.length=gi,at.head&&(at.head.extra_len=gi),512&at.flags&&(Ny[0]=255&gi,Ny[1]=gi>>>8&255,at.check=c(at.check,Ny,2,0)),gi=0,_i=0}else at.head&&(at.head.extra=null);at.mode=Xe;case Xe:if(1024&at.flags&&((dr=at.length)>Jt&&(dr=Jt),dr&&(at.head&&(Rm=at.head.extra_len-at.length,at.head.extra||(at.head.extra=new Array(at.head.extra_len)),a.arraySet(at.head.extra,Ki,Ie,dr,Rm)),512&at.flags&&(at.check=c(at.check,Ki,dr,Ie)),Jt-=dr,Ie+=dr,at.length-=dr),at.length))break e;at.length=0,at.mode=bt;case bt:if(2048&at.flags){if(Jt===0)break e;dr=0;do Rm=Ki[Ie+dr++],at.head&&Rm&&at.length<65536&&(at.head.name+=String.fromCharCode(Rm));while(Rm&&dr<Jt);if(512&at.flags&&(at.check=c(at.check,Ki,dr,Ie)),Jt-=dr,Ie+=dr,Rm)break e}else at.head&&(at.head.name=null);at.length=0,at.mode=Ot;case Ot:if(4096&at.flags){if(Jt===0)break e;dr=0;do Rm=Ki[Ie+dr++],at.head&&Rm&&at.length<65536&&(at.head.comment+=String.fromCharCode(Rm));while(Rm&&dr<Jt);if(512&at.flags&&(at.check=c(at.check,Ki,dr,Ie)),Jt-=dr,Ie+=dr,Rm)break e}else at.head&&(at.head.comment=null);at.mode=Yt;case Yt:if(512&at.flags){for(;_i<16;){if(Jt===0)break e;Jt--,gi+=Ki[Ie++]<<_i,_i+=8}if(gi!==(65535&at.check)){Qt.msg="header crc mismatch",at.mode=Wn;break}gi=0,_i=0}at.head&&(at.head.hcrc=at.flags>>9&1,at.head.done=!0),Qt.adler=at.check=0,at.mode=xt;break;case pt:for(;_i<32;){if(Jt===0)break e;Jt--,gi+=Ki[Ie++]<<_i,_i+=8}Qt.adler=at.check=oo(gi),gi=0,_i=0,at.mode=Lt;case Lt:if(at.havedict===0)return Qt.next_out=ai,Qt.avail_out=At,Qt.next_in=Ie,Qt.avail_in=Jt,at.hold=gi,at.bits=_i,se;Qt.adler=at.check=1,at.mode=xt;case xt:if(xi===W||xi===ee)break e;case yi:if(at.last){gi>>>=7&_i,_i-=7&_i,at.mode=pa;break}for(;_i<3;){if(Jt===0)break e;Jt--,gi+=Ki[Ie++]<<_i,_i+=8}switch(at.last=1&gi,_i-=1,3&(gi>>>=1)){case 0:at.mode=Li;break;case 1:if(mo(at),at.mode=Ln,xi===ee){gi>>>=2,_i-=2;break e}break;case 2:at.mode=ji;break;case 3:Qt.msg="invalid block type",at.mode=Wn}gi>>>=2,_i-=2;break;case Li:for(gi>>>=7&_i,_i-=7&_i;_i<32;){if(Jt===0)break e;Jt--,gi+=Ki[Ie++]<<_i,_i+=8}if((65535&gi)!=(gi>>>16^65535)){Qt.msg="invalid stored block lengths",at.mode=Wn;break}if(at.length=65535&gi,gi=0,_i=0,at.mode=cn,xi===ee)break e;case cn:at.mode=Ci;case Ci:if(dr=at.length){if(dr>Jt&&(dr=Jt),dr>At&&(dr=At),dr===0)break e;a.arraySet(bi,Ki,Ie,dr,ai),Jt-=dr,Ie+=dr,At-=dr,ai+=dr,at.length-=dr;break}at.mode=xt;break;case ji:for(;_i<14;){if(Jt===0)break e;Jt--,gi+=Ki[Ie++]<<_i,_i+=8}if(at.nlen=257+(31&gi),gi>>>=5,_i-=5,at.ndist=1+(31&gi),gi>>>=5,_i-=5,at.ncode=4+(15&gi),gi>>>=4,_i-=4,at.nlen>286||at.ndist>30){Qt.msg="too many length or distance symbols",at.mode=Wn;break}at.have=0,at.mode=An;case An:for(;at.have<at.ncode;){for(;_i<3;){if(Jt===0)break e;Jt--,gi+=Ki[Ie++]<<_i,_i+=8}at.lens[vQe[at.have++]]=7&gi,gi>>>=3,_i-=3}for(;at.have<19;)at.lens[vQe[at.have++]]=0;if(at.lencode=at.lendyn,at.lenbits=7,lL={bits:at.lenbits},sA=m(b,at.lens,0,19,at.lencode,0,at.work,lL),at.lenbits=lL.bits,sA){Qt.msg="invalid code lengths set",at.mode=Wn;break}at.have=0,at.mode=Ea;case Ea:for(;at.have<at.nlen+at.ndist;){for(;km=(tT=at.lencode[gi&(1<<at.lenbits)-1])>>>16&255,HS=65535&tT,!((gu=tT>>>24)<=_i);){if(Jt===0)break e;Jt--,gi+=Ki[Ie++]<<_i,_i+=8}if(HS<16)gi>>>=gu,_i-=gu,at.lens[at.have++]=HS;else{if(HS===16){for(mM=gu+2;_i<mM;){if(Jt===0)break e;Jt--,gi+=Ki[Ie++]<<_i,_i+=8}if(gi>>>=gu,_i-=gu,at.have===0){Qt.msg="invalid bit length repeat",at.mode=Wn;break}Rm=at.lens[at.have-1],dr=3+(3&gi),gi>>>=2,_i-=2}else if(HS===17){for(mM=gu+3;_i<mM;){if(Jt===0)break e;Jt--,gi+=Ki[Ie++]<<_i,_i+=8}_i-=gu,Rm=0,dr=3+(7&(gi>>>=gu)),gi>>>=3,_i-=3}else{for(mM=gu+7;_i<mM;){if(Jt===0)break e;Jt--,gi+=Ki[Ie++]<<_i,_i+=8}_i-=gu,Rm=0,dr=11+(127&(gi>>>=gu)),gi>>>=7,_i-=7}if(at.have+dr>at.nlen+at.ndist){Qt.msg="invalid bit length repeat",at.mode=Wn;break}for(;dr--;)at.lens[at.have++]=Rm}}if(at.mode===Wn)break;if(at.lens[256]===0){Qt.msg="invalid code -- missing end-of-block",at.mode=Wn;break}if(at.lenbits=9,lL={bits:at.lenbits},sA=m(_,at.lens,0,at.nlen,at.lencode,0,at.work,lL),at.lenbits=lL.bits,sA){Qt.msg="invalid literal/lengths set",at.mode=Wn;break}if(at.distbits=6,at.distcode=at.distdyn,lL={bits:at.distbits},sA=m(k,at.lens,at.nlen,at.ndist,at.distcode,0,at.work,lL),at.distbits=lL.bits,sA){Qt.msg="invalid distances set",at.mode=Wn;break}if(at.mode=Ln,xi===ee)break e;case Ln:at.mode=ga;case ga:if(Jt>=6&&At>=258){Qt.next_out=ai,Qt.avail_out=At,Qt.next_in=Ie,Qt.avail_in=Jt,at.hold=gi,at.bits=_i,u(Qt,ya),ai=Qt.next_out,bi=Qt.output,At=Qt.avail_out,Ie=Qt.next_in,Ki=Qt.input,Jt=Qt.avail_in,gi=at.hold,_i=at.bits,at.mode===xt&&(at.back=-1);break}for(at.back=0;km=(tT=at.lencode[gi&(1<<at.lenbits)-1])>>>16&255,HS=65535&tT,!((gu=tT>>>24)<=_i);){if(Jt===0)break e;Jt--,gi+=Ki[Ie++]<<_i,_i+=8}if(km&&!(240&km)){for(Oy=gu,Cae=km,_ae=HS;km=(tT=at.lencode[_ae+((gi&(1<<Oy+Cae)-1)>>Oy)])>>>16&255,HS=65535&tT,!(Oy+(gu=tT>>>24)<=_i);){if(Jt===0)break e;Jt--,gi+=Ki[Ie++]<<_i,_i+=8}gi>>>=Oy,_i-=Oy,at.back+=Oy}if(gi>>>=gu,_i-=gu,at.back+=gu,at.length=HS,km===0){at.mode=Ji;break}if(32&km){at.back=-1,at.mode=xt;break}if(64&km){Qt.msg="invalid literal/length code",at.mode=Wn;break}at.extra=15&km,at.mode=vs;case vs:if(at.extra){for(mM=at.extra;_i<mM;){if(Jt===0)break e;Jt--,gi+=Ki[Ie++]<<_i,_i+=8}at.length+=gi&(1<<at.extra)-1,gi>>>=at.extra,_i-=at.extra,at.back+=at.extra}at.was=at.length,at.mode=ss;case ss:for(;km=(tT=at.distcode[gi&(1<<at.distbits)-1])>>>16&255,HS=65535&tT,!((gu=tT>>>24)<=_i);){if(Jt===0)break e;Jt--,gi+=Ki[Ie++]<<_i,_i+=8}if(!(240&km)){for(Oy=gu,Cae=km,_ae=HS;km=(tT=at.distcode[_ae+((gi&(1<<Oy+Cae)-1)>>Oy)])>>>16&255,HS=65535&tT,!(Oy+(gu=tT>>>24)<=_i);){if(Jt===0)break e;Jt--,gi+=Ki[Ie++]<<_i,_i+=8}gi>>>=Oy,_i-=Oy,at.back+=Oy}if(gi>>>=gu,_i-=gu,at.back+=gu,64&km){Qt.msg="invalid distance code",at.mode=Wn;break}at.offset=HS,at.extra=15&km,at.mode=Ya;case Ya:if(at.extra){for(mM=at.extra;_i<mM;){if(Jt===0)break e;Jt--,gi+=Ki[Ie++]<<_i,_i+=8}at.offset+=gi&(1<<at.extra)-1,gi>>>=at.extra,_i-=at.extra,at.back+=at.extra}if(at.offset>at.dmax){Qt.msg="invalid distance too far back",at.mode=Wn;break}at.mode=ir;case ir:if(At===0)break e;if(dr=ya-At,at.offset>dr){if((dr=at.offset-dr)>at.whave&&at.sane){Qt.msg="invalid distance too far back",at.mode=Wn;break}dr>at.wnext?(dr-=at.wnext,Ps=at.wsize-dr):Ps=at.wnext-dr,dr>at.length&&(dr=at.length),eT=at.window}else eT=bi,Ps=ai-at.offset,dr=at.length;dr>At&&(dr=At),At-=dr,at.length-=dr;do bi[ai++]=eT[Ps++];while(--dr);at.length===0&&(at.mode=ga);break;case Ji:if(At===0)break e;bi[ai++]=at.length,At--,at.mode=ga;break;case pa:if(at.wrap){for(;_i<32;){if(Jt===0)break e;Jt--,gi|=Ki[Ie++]<<_i,_i+=8}if(ya-=At,Qt.total_out+=ya,at.total+=ya,ya&&(Qt.adler=at.check=at.flags?c(at.check,bi,ya,ai-ya):s(at.check,bi,ya,ai-ya)),ya=At,(at.flags?gi:oo(gi))!==at.check){Qt.msg="incorrect data check",at.mode=Wn;break}gi=0,_i=0}at.mode=Ca;case Ca:if(at.wrap&&at.flags){for(;_i<32;){if(Jt===0)break e;Jt--,gi+=Ki[Ie++]<<_i,_i+=8}if(gi!==(4294967295&at.total)){Qt.msg="incorrect length check",at.mode=Wn;break}gi=0,_i=0}at.mode=da;case da:sA=de;break e;case Wn:sA=ue;break e;case co:return Ne;default:return Re}return Qt.next_out=ai,Qt.avail_out=At,Qt.next_in=Ie,Qt.avail_in=Jt,at.hold=gi,at.bits=_i,(at.wsize||ya!==Qt.avail_out&&at.mode<Wn&&(at.mode<pa||xi!==N))&&ig(Qt,Qt.output,Qt.next_out,ya-Qt.avail_out),sr-=Qt.avail_in,ya-=Qt.avail_out,Qt.total_in+=sr,Qt.total_out+=ya,at.total+=ya,at.wrap&&ya&&(Qt.adler=at.check=at.flags?c(at.check,bi,ya,Qt.next_out-ya):s(at.check,bi,ya,Qt.next_out-ya)),Qt.data_type=at.bits+(at.last?64:0)+(at.mode===xt?128:0)+(at.mode===Ln||at.mode===cn?256:0),(sr===0&&ya===0||xi===N)&&sA===oe&&(sA=ze),sA}function Qn(Qt){if(!Qt||!Qt.state)return Re;var xi=Qt.state;return xi.window&&(xi.window=null),Qt.state=null,oe}function ft(Qt,xi){var at;return Qt&&Qt.state&&2&(at=Qt.state).wrap?(at.head=xi,xi.done=!1,oe):Re}function Hi(Qt,xi){var at,Ki=xi.length;return Qt&&Qt.state?(at=Qt.state).wrap!==0&&at.mode!==Lt?Re:at.mode===Lt&&s(1,xi,Ki,0)!==at.check?ue:ig(Qt,xi,Ki,Ki)?(at.mode=co,Ne):(at.havedict=1,oe):Re}n.inflateReset=jg,n.inflateReset2=Ah,n.inflateResetKeep=kd,n.inflateInit=qs,n.inflateInit2=es,n.inflate=pi,n.inflateEnd=Qn,n.inflateGetHeader=ft,n.inflateSetDictionary=Hi,n.inflateInfo="pako inflate (from Nodeca project)"}}),cp=oi({"../node_modules/pako/lib/zlib/constants.js"(n,a){a.exports={Z_NO_FLUSH:0,Z_PARTIAL_FLUSH:1,Z_SYNC_FLUSH:2,Z_FULL_FLUSH:3,Z_FINISH:4,Z_BLOCK:5,Z_TREES:6,Z_OK:0,Z_STREAM_END:1,Z_NEED_DICT:2,Z_ERRNO:-1,Z_STREAM_ERROR:-2,Z_DATA_ERROR:-3,Z_BUF_ERROR:-5,Z_NO_COMPRESSION:0,Z_BEST_SPEED:1,Z_BEST_COMPRESSION:9,Z_DEFAULT_COMPRESSION:-1,Z_FILTERED:1,Z_HUFFMAN_ONLY:2,Z_RLE:3,Z_FIXED:4,Z_DEFAULT_STRATEGY:0,Z_BINARY:0,Z_TEXT:1,Z_UNKNOWN:2,Z_DEFLATED:8}}}),vf=oi({"../node_modules/pako/lib/zlib/gzheader.js"(n,a){function s(){this.text=0,this.time=0,this.xflags=0,this.os=0,this.extra=null,this.extra_len=0,this.name="",this.comment="",this.hcrc=0,this.done=!1}a.exports=s}}),aC=oi({"../node_modules/pako/lib/inflate.js"(n){var a=nC(),s=Eo(),c=NS(),u=cp(),m=Cm(),b=Zp(),_=vf(),k=Object.prototype.toString;function N(oe){if(!(this instanceof N))return new N(oe);this.options=s.assign({chunkSize:16384,windowBits:0,to:""},oe||{});var de=this.options;de.raw&&de.windowBits>=0&&de.windowBits<16&&(de.windowBits=-de.windowBits,de.windowBits===0&&(de.windowBits=-15)),!(de.windowBits>=0&&de.windowBits<16)||oe&&oe.windowBits||(de.windowBits+=32),de.windowBits>15&&de.windowBits<48&&(15&de.windowBits||(de.windowBits|=15)),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new b,this.strm.avail_out=0;var se=a.inflateInit2(this.strm,de.windowBits);if(se!==u.Z_OK)throw new Error(m[se]);if(this.header=new _,a.inflateGetHeader(this.strm,this.header),de.dictionary&&(typeof de.dictionary=="string"?de.dictionary=c.string2buf(de.dictionary):k.call(de.dictionary)==="[object ArrayBuffer]"&&(de.dictionary=new Uint8Array(de.dictionary)),de.raw&&(se=a.inflateSetDictionary(this.strm,de.dictionary))!==u.Z_OK))throw new Error(m[se])}function W(oe,de){var se=new N(de);if(se.push(oe,!0),se.err)throw se.msg||m[se.err];return se.result}function ee(oe,de){return(de=de||{}).raw=!0,W(oe,de)}N.prototype.push=function(oe,de){var se,Re,ue,Ne,ze,He=this.strm,be=this.options.chunkSize,Ee=this.options.dictionary,Pe=!1;if(this.ended)return!1;Re=de===~~de?de:de===!0?u.Z_FINISH:u.Z_NO_FLUSH,typeof oe=="string"?He.input=c.binstring2buf(oe):k.call(oe)==="[object ArrayBuffer]"?He.input=new Uint8Array(oe):He.input=oe,He.next_in=0,He.avail_in=He.input.length;do{if(He.avail_out===0&&(He.output=new s.Buf8(be),He.next_out=0,He.avail_out=be),(se=a.inflate(He,u.Z_NO_FLUSH))===u.Z_NEED_DICT&&Ee&&(se=a.inflateSetDictionary(this.strm,Ee)),se===u.Z_BUF_ERROR&&Pe===!0&&(se=u.Z_OK,Pe=!1),se!==u.Z_STREAM_END&&se!==u.Z_OK)return this.onEnd(se),this.ended=!0,!1;He.next_out&&(He.avail_out!==0&&se!==u.Z_STREAM_END&&(He.avail_in!==0||Re!==u.Z_FINISH&&Re!==u.Z_SYNC_FLUSH)||(this.options.to==="string"?(ue=c.utf8border(He.output,He.next_out),Ne=He.next_out-ue,ze=c.buf2string(He.output,ue),He.next_out=Ne,He.avail_out=be-Ne,Ne&&s.arraySet(He.output,He.output,ue,Ne,0),this.onData(ze)):this.onData(s.shrinkBuf(He.output,He.next_out)))),He.avail_in===0&&He.avail_out===0&&(Pe=!0)}while((He.avail_in>0||He.avail_out===0)&&se!==u.Z_STREAM_END);return se===u.Z_STREAM_END&&(Re=u.Z_FINISH),Re===u.Z_FINISH?(se=a.inflateEnd(this.strm),this.onEnd(se),this.ended=!0,se===u.Z_OK):Re!==u.Z_SYNC_FLUSH||(this.onEnd(u.Z_OK),He.avail_out=0,!0)},N.prototype.onData=function(oe){this.chunks.push(oe)},N.prototype.onEnd=function(oe){oe===u.Z_OK&&(this.options.to==="string"?this.result=this.chunks.join(""):this.result=s.flattenChunks(this.chunks)),this.chunks=[],this.err=oe,this.msg=this.strm.msg},n.Inflate=N,n.inflate=W,n.inflateRaw=ee,n.ungzip=W}}),Ni=oi({"../node_modules/pako/index.js"(n,a){var s={};(0,Eo().assign)(s,iC(),aC(),cp()),a.exports=s}}),ta=oi({"../signaling-agent/node_modules/sdp-transform/lib/grammar.js"(n,a){var s=a.exports={v:[{name:"version",reg:/^(\d*)$/}],o:[{name:"origin",reg:/^(\S*) (\d*) (\d*) (\S*) IP(\d) (\S*)/,names:["username","sessionId","sessionVersion","netType","ipVer","address"],format:"%s %s %d %s IP%d %s"}],s:[{name:"name"}],i:[{name:"description"}],u:[{name:"uri"}],e:[{name:"email"}],p:[{name:"phone"}],z:[{name:"timezones"}],r:[{name:"repeats"}],t:[{name:"timing",reg:/^(\d*) (\d*)/,names:["start","stop"],format:"%d %d"}],c:[{name:"connection",reg:/^IN IP(\d) (\S*)/,names:["version","ip"],format:"IN IP%d %s"}],b:[{push:"bandwidth",reg:/^(TIAS|AS|CT|RR|RS):(\d*)/,names:["type","limit"],format:"%s:%s"}],m:[{reg:/^(\S*) (\d*) ([\w/]*)(?: (.*))?/,names:["type","port","protocol","payloads"],format:"%s %d %s %s"}],a:[{push:"rtp",reg:/^rtpmap:(\d*) ([\w\-.]*)(?:\s*\/(\d*)(?:\s*\/(\S*))?)?/,names:["payload","codec","rate","encoding"],format:function(c){return c.encoding?"rtpmap:%d %s/%s/%s":c.rate?"rtpmap:%d %s/%s":"rtpmap:%d %s"}},{push:"fmtp",reg:/^fmtp:(\d*) ([\S| ]*)/,names:["payload","config"],format:"fmtp:%d %s"},{name:"control",reg:/^control:(.*)/,format:"control:%s"},{name:"rtcp",reg:/^rtcp:(\d*)(?: (\S*) IP(\d) (\S*))?/,names:["port","netType","ipVer","address"],format:function(c){return c.address!=null?"rtcp:%d %s IP%d %s":"rtcp:%d"}},{push:"rtcpFbXMessage",reg:/^rtcp-fb:(\*|\d*) x-message ([\S| ]*)/,names:["payload","param"],format:function(c){return"rtcp-fb:"+(c.payload==="*"?"%s":"%d")+" x-message %s"}},{push:"rtcpFbTrrInt",reg:/^rtcp-fb:(\*|\d*) trr-int (\d*)/,names:["payload","value"],format:"rtcp-fb:%d trr-int %d"},{push:"rtcpFb",reg:/^rtcp-fb:(\*|\d*) ([\w-_]*)(?: ([\w-_]*))?/,names:["payload","type","subtype"],format:function(c){return c.subtype!=null?"rtcp-fb:%s %s %s":"rtcp-fb:%s %s"}},{push:"ext",reg:/^extmap:(\d+)(?:\/(\w+))?(?: (urn:ietf:params:rtp-hdrext:encrypt))? (\S*)(?: (\S*))?/,names:["value","direction","encrypt-uri","uri","config"],format:function(c){return"extmap:%d"+(c.direction?"/%s":"%v")+(c["encrypt-uri"]?" %s":"%v")+" %s"+(c.config?" %s":"")}},{name:"extmapAllowMixed",reg:/^(extmap-allow-mixed)/},{push:"cryptoscale",reg:/^cryptoscale:(\d*) (client|server) ([\w_]*) (\S*)(?: (\S*))?/,names:["id","flavor","suite","config","sessionConfig"],format:function(c){return c.sessionConfig!=null?"cryptoscale:%d %s %s %s %s":"cryptoscale:%d %s %s %s"}},{push:"crypto",reg:/^crypto:(\d*) ([\w_]*) (\S*)(?: (\S*))?/,names:["id","suite","config","sessionConfig"],format:function(c){return c.sessionConfig!=null?"crypto:%d %s %s %s":"crypto:%d %s %s"}},{name:"setup",reg:/^setup:(\w*)/,format:"setup:%s"},{name:"connectionType",reg:/^connection:(new|existing)/,format:"connection:%s"},{name:"mid",reg:/^mid:([^\s]*)/,format:"mid:%s"},{name:"msid",reg:/^msid:(.*)/,format:"msid:%s"},{name:"ptime",reg:/^ptime:(\d*(?:\.\d*)*)/,format:"ptime:%d"},{name:"maxptime",reg:/^maxptime:(\d*(?:\.\d*)*)/,format:"maxptime:%d"},{name:"direction",reg:/^(sendrecv|recvonly|sendonly|inactive)/},{name:"icelite",reg:/^(ice-lite)/},{name:"iceUfrag",reg:/^ice-ufrag:(\S*)/,format:"ice-ufrag:%s"},{name:"icePwd",reg:/^ice-pwd:(\S*)/,format:"ice-pwd:%s"},{name:"fingerprint",reg:/^fingerprint:(\S*) (\S*)/,names:["type","hash"],format:"fingerprint:%s %s"},{push:"candidates",reg:/^candidate:(\S*) (\d*) (\S*) (\d*) (\S*) (\d*) typ (\S*)(?: raddr (\S*) rport (\d*))?(?: tcptype (\S*))?(?: generation (\d*))?(?: network-id (\d*))?(?: network-cost (\d*))?/,names:["foundation","component","transport","priority","ip","port","type","raddr","rport","tcptype","generation","network-id","network-cost"],format:function(c){var u="candidate:%s %d %s %d %s %d typ %s";return u+=c.raddr!=null?" raddr %s rport %d":"%v%v",u+=c.tcptype!=null?" tcptype %s":"%v",c.generation!=null&&(u+=" generation %d"),u+=c["network-id"]!=null?" network-id %d":"%v",u+=c["network-cost"]!=null?" network-cost %d":"%v"}},{push:"xCandidatesIpv6",reg:/^x-candidate-ipv6:(\S*) (\d*) (\S*) (\d*) (\S*) (\d*) typ (\S*)(?: raddr (\S*) rport (\d*))?(?: tcptype (\S*))?(?: generation (\d*))?/,names:["foundation","component","transport","priority","ip","port","type","raddr","rport","tcptype","generation"],format:function(c){var u="candidate:%s %d %s %d %s %d typ %s";return u+=c.raddr!=null?" raddr %s rport %d":"%v%v",u+=c.tcptype!=null?" tcptype %s":"%v",c.generation!=null&&(u+=" generation %d"),u}},{name:"endOfCandidates",reg:/^(end-of-candidates)/},{name:"remoteCandidates",reg:/^remote-candidates:(.*)/,format:"remote-candidates:%s"},{name:"iceOptions",reg:/^ice-options:(\S*)/,format:"ice-options:%s"},{push:"ssrcs",reg:/^ssrc:(\d*) ([\w_-]*)(?::(.*))?/,names:["id","attribute","value"],format:function(c){var u="ssrc:%d";return c.attribute!=null&&(u+=" %s",c.value!=null&&(u+=":%s")),u}},{push:"ssrcGroups",reg:/^ssrc-group:([\x21\x23\x24\x25\x26\x27\x2A\x2B\x2D\x2E\w]*) (.*)/,names:["semantics","ssrcs"],format:"ssrc-group:%s %s"},{name:"msidSemantic",reg:/^msid-semantic:\s?(\w*) (\S*)/,names:["semantic","token"],format:"msid-semantic: %s %s"},{push:"groups",reg:/^group:(\w*) (.*)/,names:["type","mids"],format:"group:%s %s"},{name:"rtcpMux",reg:/^(rtcp-mux)/},{name:"rtcpRsize",reg:/^(rtcp-rsize)/},{name:"sctpmap",reg:/^sctpmap:([\w_/]*) (\S*)(?: (\S*))?/,names:["sctpmapNumber","app","maxMessageSize"],format:function(c){return c.maxMessageSize!=null?"sctpmap:%s %s %s":"sctpmap:%s %s"}},{name:"xGoogleFlag",reg:/^x-google-flag:([^\s]*)/,format:"x-google-flag:%s"},{push:"rids",reg:/^rid:([\d\w]+) (\w+)(?: ([\S| ]*))?/,names:["id","direction","params"],format:function(c){return c.params?"rid:%s %s %s":"rid:%s %s"}},{push:"imageattrs",reg:new RegExp("^imageattr:(\\d+|\\*)[\\s\\t]+(send|recv)[\\s\\t]+(\\*|\\[\\S+\\](?:[\\s\\t]+\\[\\S+\\])*)(?:[\\s\\t]+(recv|send)[\\s\\t]+(\\*|\\[\\S+\\](?:[\\s\\t]+\\[\\S+\\])*))?"),names:["pt","dir1","attrs1","dir2","attrs2"],format:function(c){return"imageattr:%s %s %s"+(c.dir2?" %s %s":"")}},{name:"simulcast",reg:new RegExp("^simulcast:(send|recv) ([a-zA-Z0-9\\-_~;,]+)(?:\\s?(send|recv) ([a-zA-Z0-9\\-_~;,]+))?$"),names:["dir1","list1","dir2","list2"],format:function(c){return"simulcast:%s %s"+(c.dir2?" %s %s":"")}},{name:"simulcast_03",reg:/^simulcast:[\s\t]+([\S+\s\t]+)$/,names:["value"],format:"simulcast: %s"},{name:"framerate",reg:/^framerate:(\d+(?:$|\.\d+))/,format:"framerate:%s"},{name:"sourceFilter",reg:/^source-filter: *(excl|incl) (\S*) (IP4|IP6|\*) (\S*) (.*)/,names:["filterMode","netType","addressTypes","destAddress","srcList"],format:"source-filter: %s %s %s %s %s"},{name:"bundleOnly",reg:/^(bundle-only)/},{name:"label",reg:/^label:(.+)/,format:"label:%s"},{name:"sctpPort",reg:/^sctp-port:(\d+)$/,format:"sctp-port:%s"},{name:"maxMessageSize",reg:/^max-message-size:(\d+)$/,format:"max-message-size:%s"},{push:"tsRefClocks",reg:/^ts-refclk:([^\s=]*)(?:=(\S*))?/,names:["clksrc","clksrcExt"],format:function(c){return"ts-refclk:%s"+(c.clksrcExt!=null?"=%s":"")}},{name:"mediaClk",reg:/^mediaclk:(?:id=(\S*))? *([^\s=]*)(?:=(\S*))?(?: *rate=(\d+)\/(\d+))?/,names:["id","mediaClockName","mediaClockValue","rateNumerator","rateDenominator"],format:function(c){var u="mediaclk:";return u+=c.id!=null?"id=%s %s":"%v%s",u+=c.mediaClockValue!=null?"=%s":"",u+=c.rateNumerator!=null?" rate=%s":"",u+=c.rateDenominator!=null?"/%s":""}},{name:"keywords",reg:/^keywds:(.+)$/,format:"keywds:%s"},{name:"content",reg:/^content:(.+)/,format:"content:%s"},{name:"bfcpFloorCtrl",reg:/^floorctrl:(c-only|s-only|c-s)/,format:"floorctrl:%s"},{name:"bfcpConfId",reg:/^confid:(\d+)/,format:"confid:%s"},{name:"bfcpUserId",reg:/^userid:(\d+)/,format:"userid:%s"},{name:"bfcpFloorId",reg:/^floorid:(.+) (?:m-stream|mstrm):(.+)/,names:["id","mStream"],format:"floorid:%s mstrm:%s"},{name:"xMediaBw",reg:/^x-mediabw:(\S*) send=(\d*);recv=(\d*)/,names:["label","sendBw","receiveBw"],format:"x-mediabw:%s send=%d;recv=%d"},{name:"xSsrcRange",reg:/^x-ssrc-range:(\d*)-(\d*)/,names:["ssrcMin","ssrcMax"],format:"x-ssrc-range:%d-%d"},{name:"xSource",reg:/^x-source:(\S*)/,format:"x-source:%s"},{name:"xSourceStreamId",reg:/^x-source-streamid:(\S*)/,format:"x-source-streamid:%s"},{name:"xCaps",reg:/^x-caps:(\d*) (\S*)/,names:["payloadType","value"],format:"x-caps:%d %s"},{name:"signalingFbXMessage",reg:/^x-signaling-fb:(\*|\d*) x-message ([\S| ]*)/,names:["payload","param"],format:function(c){return"x-signaling-fb:"+(c.payload==="*"?"%s":"%d")+" x-message %s"}},{push:"xMediaSettings",reg:/^x-mediasettings:([\S| ]*)/,names:["settings"],format:"x-mediasettings:%s"},{name:"xDataProtocol",reg:/^x-data-protocol:\s?(.*)/,format:"x-data-protocol:%s"},{push:"invalid",names:["value"]}]};Object.keys(s).forEach(function(c){s[c].forEach(function(u){u.reg||(u.reg=/(.*)/),u.format||(u.format="%s")})})}}),Ta=oi({"../signaling-agent/node_modules/sdp-transform/lib/parser.js"(n){var a=function(_){return String(Number(_))===_?Number(_):_},s=function(_,k,N,W){if(W&&!N)k[W]=a(_[1]);else for(var ee=0;ee<N.length;ee+=1)_[ee+1]!=null&&(k[N[ee]]=a(_[ee+1]))},c=function(_,k,N){var W=_.name&&_.names;_.push&&!k[_.push]?k[_.push]=[]:W&&!k[_.name]&&(k[_.name]={});var ee=_.push?{}:W?k[_.name]:k;s(N.match(_.reg),ee,_.names,_.name),_.push&&k[_.push].push(ee)},u=ta(),m=RegExp.prototype.test.bind(/^([a-z])=(.*)/);n.parse=function(_){var k={},N=[],W=k;return _.split(/(\r\n|\r|\n)/).filter(m).forEach(function(ee){var oe=ee[0],de=ee.slice(2);oe==="m"&&(N.push({rtp:[],fmtp:[]}),W=N[N.length-1]);for(var se=0;se<(u[oe]||[]).length;se+=1){var Re=u[oe][se];if(Re.reg.test(de))return c(Re,W,de)}}),k.media=N,k};var b=function(_,k){var N=k.split(/=(.+)/,2);return N.length===2?_[N[0]]=a(N[1]):N.length===1&&k.length>1&&(_[N[0]]=void 0),_};n.parseParams=function(_){return _.split(/;\s?/).reduce(b,{})},n.parseFmtpConfig=n.parseParams,n.parsePayloads=function(_){return _.toString().split(" ").map(Number)},n.parseRemoteCandidates=function(_){for(var k=[],N=_.split(" ").map(a),W=0;W<N.length;W+=3)k.push({component:N[W],ip:N[W+1],port:N[W+2]});return k},n.parseImageAttributes=function(_){return _.split(" ").map(function(k){return k.substring(1,k.length-1).split(",").reduce(b,{})})},n.parseSimulcastStreamList=function(_){return _.split(";").map(function(k){return k.split(",").map(function(N){var W,ee=!1;return N[0]!=="~"?W=a(N):(W=a(N.substring(1,N.length)),ee=!0),{scid:W,paused:ee}})})}}}),Er=oi({"../signaling-agent/node_modules/sdp-transform/lib/writer.js"(n,a){var s=ta(),c=/%[sdv%]/g,u=function(k){var N=1,W=arguments,ee=W.length;return k.replace(c,function(oe){if(N>=ee)return oe;var de=W[N];switch(N+=1,oe){case"%%":return"%";case"%s":return String(de);case"%d":return Number(de);case"%v":return""}})},m=function(k,N,W){var ee=[k+"="+(N.format instanceof Function?N.format(N.push?W:W[N.name]):N.format)];if(N.names)for(var oe=0;oe<N.names.length;oe+=1){var de=N.names[oe];N.name?ee.push(W[N.name][de]):ee.push(W[N.names[oe]])}else ee.push(W[N.name]);return u.apply(null,ee)},b=["v","o","s","i","u","e","p","c","b","t","r","z","a"],_=["i","c","b","a"];a.exports=function(k,N){N=N||{},k.version==null&&(k.version=0),k.name==null&&(k.name=" "),k.media.forEach(function(de){de.payloads==null&&(de.payloads="")});var W=N.outerOrder||b,ee=N.innerOrder||_,oe=[];return W.forEach(function(de){s[de].forEach(function(se){se.name in k&&k[se.name]!=null?oe.push(m(de,se,k)):se.push in k&&k[se.push]!=null&&k[se.push].forEach(function(Re){oe.push(m(de,se,Re))})})}),k.media.forEach(function(de){oe.push(m("m",s.m[0],de)),ee.forEach(function(se){s[se].forEach(function(Re){Re.name in de&&de[Re.name]!=null?oe.push(m(se,Re,de)):Re.push in de&&de[Re.push]!=null&&de[Re.push].forEach(function(ue){oe.push(m(se,Re,ue))})})})}),oe.join(`\r
`)+`\r
`}}}),Ro=oi({"../signaling-agent/node_modules/sdp-transform/lib/index.js"(n){var a=Ta(),s=Er();n.write=s,n.parse=a.parse,n.parseParams=a.parseParams,n.parseFmtpConfig=a.parseFmtpConfig,n.parsePayloads=a.parsePayloads,n.parseRemoteCandidates=a.parseRemoteCandidates,n.parseImageAttributes=a.parseImageAttributes,n.parseSimulcastStreamList=a.parseSimulcastStreamList}}),Ms=oi({"../skype-calling-utilities/dist/skype-calling-utilities.bundle.js"(n,a){var s,c;s=n,c=(u,m)=>{var b={},_={exports:b},k=Object.defineProperty,N=Object.getOwnPropertyDescriptor,W=Object.getOwnPropertyNames,ee=Object.prototype.hasOwnProperty,oe=(Ci,ji)=>{for(var An in ji)k(Ci,An,{get:ji[An],enumerable:!0})},de=(Ci,ji,An,Ea)=>{if(ji&&typeof ji=="object"||typeof ji=="function")for(let Ln of W(ji))ee.call(Ci,Ln)||Ln===An||k(Ci,Ln,{get:()=>ji[Ln],enumerable:!(Ea=N(ji,Ln))||Ea.enumerable});return Ci},se=Ci=>de(k({},"__esModule",{value:!0}),Ci),Re={};oe(Re,{SlimCoreElectronControlCapturer:()=>yi}),_.exports=se(Re);var ue=dn;function Ne(Ci){if(!Ci)return`${Ci}`;if(Ci instanceof Map)return ze(Ci);const ji=Ci.toString();return ji.endsWith("[object Object]")?JSON.stringify(Ci):ji}function ze(Ci){const ji={};return Ci.forEach((An,Ea)=>{ji[Ea.toString()]=An}),JSON.stringify(ji)}var He,be=class{constructor(Ci){this.eventLogger=Ci,this.subscriptions=[]}subscribe(Ci){return new Ee(this.subscriptions,Ci)}dispose(Ci){this.subscriptions=[]}raiseEvents(Ci){this.subscriptions.slice().forEach(ji=>{try{ji.eventHandler!==void 0&&Ci(ji.eventHandler)}catch(An){this.eventLogger?.warn?.("Event handler exception caught!",Ne(An))}})}},Ee=class{constructor(Ci,ji){this.subscriptions=Ci,this.eventHandler=ji,this.subscriptions.push(this)}dispose(){(0,ue.remove)(this.subscriptions,Ci=>Ci===this),this.eventHandler=void 0}},Pe=class extends be{constructor(Ci){super(Ci)}changed(Ci,ji){return this.subscribe({changed:{skipEventConfig:ji,handler:Ci},on:void 0})}on(Ci,ji){return this.subscribe({changed:void 0,on:{name:String(Ci),handler:this._toEventCallback(ji)}})}once(Ci,ji,An){let Ea;const Ln=(...ga)=>{Ea.dispose(An),this._toEventCallback(ji)(...ga)};return Ea=this.on(Ci,this._fromEventCallback(Ln)),Ea}raiseChanged(Ci){this.raiseEvents(ji=>{if(!ji.changed)return;const{skipEventConfig:An,handler:Ea}=ji.changed;!this.getShouldSkipChangedEvent(Ci,An)&&Ea()})}event(Ci){return{raise:this._fromEventCallback((...ji)=>this._raiseEventImpl(String(Ci),...ji))}}_raiseEventImpl(Ci,...ji){this.raiseEvents(An=>An.on&&An.on.name===Ci&&An.on.handler(...ji))}_toEventCallback(Ci){return Ci}_fromEventCallback(Ci){return Ci}getShouldSkipChangedEvent(Ci,ji){return Ci?.skipDominantSpeakerUpdatesOnCall?!!ji?.skipDominantSpeakerUpdatesOnCall:!!Ci?.skipParticipantsUpdatesOnCall&&!!ji?.skipParticipantsUpdatesOnCall}async onAsync(Ci,ji){return this.on(Ci,ji)}async onceAsync(Ci,ji,An){return this.once(Ci,ji,An)}async changedAsync(Ci,ji){return this.changed(Ci,ji)}async disposeAsync(Ci){this.dispose(Ci)}};(Ci=>{function Ea(Ya){if(!Ya)return new Uint8Array(0);Ya.buttonType||(Ya.buttonType=0),Ya.xPos||(Ya.xPos=0),Ya.yPos||(Ya.yPos=0),Ya.wheelRotation||(Ya.wheelRotation=0);const ir=new ArrayBuffer(7),Ji=new DataView(ir),pa=3&Ya.type,Ca=(7&Ya.buttonType)<<2,da=(Ya.buttonDown?1:0)<<5,Wn=(Ya.wheelButtonDown?1:0)<<6;return Ji.setUint8(0,1),Ji.setUint8(1,pa|Ca|da|Wn|0),Ji.setUint16(2,Ya.xPos,!0),Ji.setUint16(4,Ya.yPos,!0),Ji.setUint8(6,Ya.wheelRotation),new Uint8Array(ir)}function Ln(Ya){const ir=new ArrayBuffer(3),Ji=new DataView(ir),pa=3&Ya.codeType,Ca=0,da=(Ya.keyUp?1:0)<<4,Wn=(Ya.repeat?1:0)<<5;return Ji.setUint8(0,0),Ji.setUint8(1,pa|Ca|da|Wn|0|0),Ji.setUint8(2,Ya.code),new Uint8Array(ir)}function ga(Ya){return Ya[0]}function vs(Ya){if(Ya[0]!==1||Ya.length!==7)return null;const ir=new DataView(Ya.buffer),Ji=ir.getUint8(1);return{type:3&Ji,buttonType:Ji>>2&7,buttonDown:!!(Ji>>5&1),wheelButtonDown:!!(Ji>>6&1),xPos:ir.getUint16(2,!0),yPos:ir.getUint16(4,!0),wheelRotation:ir.getUint8(6)}}function ss(Ya){if(Ya[0]!==0||Ya.length!==3)return null;const ir=new DataView(Ya.buffer),Ji=ir.getUint8(1);return{codeType:3&Ji,code:ir.getUint8(2),repeat:!!(Ji>>5&1),keyUp:!!(Ji>>4&1)}}Ci.encodeMouseEvent=Ea,Ci.encodeKeyboardEvent=Ln,Ci.decodeEventType=ga,Ci.decodeMouseEvent=vs,Ci.decodeKeyboardEvent=ss})(He||(He={}));var Qe=65535,Ze=3e3,Xe=250,bt=18,Ot=17,Yt=16,pt=91,Lt=50,xt=30,yi=class extends Pe{constructor(Ci,ji,An=!0,Ea=1){super(),this._logger=Ci,this._element=ji,this._captureRegionPreserveAspectRatio=An,this._mouseMoveCount=0,this._mouseMoveStartTime=0,this._isMouseDown=!1,this._isMouseOnRenderer=!1,this._captureMode=0,this._pollTimerID=0,this._resizeTimerID=0,this._mouseMoveThrottlingEnabled=!1,this._handleResizeEvents=()=>{clearTimeout(this._resizeTimerID),this._resizeTimerID=window.setTimeout(()=>{this.updateCaptureRegion()},Xe)},this._handleMouseLeave=Ln=>{!this._isOnScreenContent(Ln)&&this._isMouseOnRenderer&&(this._raiseCaptureEvent(2),this._logger.info("Mouse leaving render region")),this._isMouseOnRenderer=!1},this._handleMouseEnter=Ln=>{this._isOnScreenContent(Ln)&&(this._isMouseOnRenderer=!0,this._raiseCaptureEvent(1),this._logger.info("Mouse entering render region"))},this._handleLosingFocus=()=>{this._syncKeyStates(!0)},this._handleClick=Ln=>{this._isOnScreenContent(Ln)&&(this._raiseCaptureEvent(0),this._logger.info("Mouse clicked"))},this._handleMouseMove=Ln=>{if(!this._isOnScreenContent(Ln)&&this._isMouseOnRenderer)return this._raiseCaptureEvent(2),this._isMouseOnRenderer=!1,void this._logger.info("Mouse leaving render region");if(this._isOnScreenContent(Ln)&&!this._isMouseOnRenderer&&(this._raiseCaptureEvent(1),this._isMouseOnRenderer=!0,this._logger.info("Mouse entering render region")),this._captureMode!==2&&this._captureMode!==3)return;if(this._mouseMoveCount++,this._mouseMoveThrottlingEnabled){if(!this._isOnScreenContent(Ln)||!this._shouldMoveMouse())return}else if(!this._isOnScreenContent(Ln)||this._mouseMoveCount%2==0)return;const ga={type:0};this._normalizeMousePosition(Ln,ga),this._raiseMouseEvent(ga)},this._handleMouseDown=Ln=>{if(this._captureMode!==2&&this._captureMode!==3||!this._isOnScreenContent(Ln))return;const ga={type:2,buttonType:Li(Ln.button),buttonDown:!0};this._isMouseDown=!0,this._normalizeMousePosition(Ln,ga),this._raiseMouseEvent(ga)},this._handleMouseUp=Ln=>{if(this._captureMode!==2&&this._captureMode!==3||!this._isOnScreenContent(Ln))return;const ga={type:2,buttonType:Li(Ln.button),buttonDown:!1};this._isMouseDown=!1,this._normalizeMousePosition(Ln,ga),this._raiseMouseEvent(ga)},this._handleKeyDown=Ln=>{this._raiseKeyboardEvent({codeType:1,code:Ln.keyCode,repeat:Ln.repeat,keyUp:!1}),Ln.stopPropagation(),Ln.preventDefault()},this._handleKeyUp=Ln=>{this._raiseKeyboardEvent({codeType:1,code:Ln.keyCode,repeat:Ln.repeat,keyUp:!0}),Ln.stopPropagation(),Ln.preventDefault()},this._handleWheel=Ln=>{this._raiseMouseEvent({type:1,wheelRotation:Ln.deltaY>0?-120:120})},this._handleContextMenu=Ln=>{Ln.preventDefault()},this._ensureCanReceiveKeyboardInput(),this._element.ownerDocument?.defaultView?.addEventListener("resize",this._handleResizeEvents,!1),this._captureRegion={left:0,top:0,width:this._element.clientWidth,height:this._element.clientHeight},this._videoSize={width:Math.floor(ji.clientHeight*Ea),height:ji.clientHeight},this._origElementSize={width:0,height:0},this._checkElementSize(),this._mouseMoveStartTime=new Date(0).getTime()}get captureMode(){return this._captureMode}get captureRegion(){return this._captureRegion}setMouseMoveThrottlingFeatureFlag(Ci){this._mouseMoveThrottlingEnabled=Ci}dispose(Ci){this._logger.info(`dispose causeId: ${Ci}`),window.clearTimeout(this._pollTimerID),this._element.ownerDocument?.defaultView?.removeEventListener("resize",this._handleResizeEvents,!1),super.dispose(Ci)}updateVideoSize(Ci,ji){this._videoSize.width=Ci,this._videoSize.height=ji,this.updateCaptureRegion()}updateCaptureRegion(){this._captureRegionPreserveAspectRatio?(this._captureRegion.width=this._element.clientWidth,this._captureRegion.height=this._element.clientWidth*this._videoSize.height/this._videoSize.width,this._captureRegion.height>this._element.clientHeight?(this._captureRegion.width=this._element.clientHeight*this._videoSize.width/this._videoSize.height,this._captureRegion.height=this._element.clientHeight,this._captureRegion.left=(this._element.clientWidth-this._captureRegion.width)/2,this._captureRegion.top=0):(this._captureRegion.left=0,this._captureRegion.top=(this._element.clientHeight-this._captureRegion.height)/2)):(this._captureRegion.width=this._element.clientWidth,this._captureRegion.height=this._element.clientHeight,this._captureRegion.top=0,this._captureRegion.left=0)}setCaptureMode(Ci){this._captureMode===3&&Ci!==3&&this._syncKeyStates(!0),this._captureMode=Ci,Ci!==0?(this._element.style.pointerEvents==="none"&&this._logger.warn("Element pointer-events is 'none', event handlers will not work"),this._element.addEventListener("click",this._handleClick),this._element.addEventListener("pointermove",this._handleMouseMove),this._element.addEventListener("pointerdown",this._handleMouseDown),this._element.addEventListener("pointerup",this._handleMouseUp),this._element.addEventListener("pointerenter",this._handleMouseEnter),this._element.addEventListener("pointerleave",this._handleMouseLeave),Ci===3?(this._element.addEventListener("wheel",this._handleWheel),this._element.addEventListener("keydown",this._handleKeyDown),this._element.addEventListener("keyup",this._handleKeyUp),this._element.addEventListener("contextmenu",this._handleContextMenu),this._element.addEventListener("blur",this._handleLosingFocus)):(this._element.removeEventListener("wheel",this._handleWheel),this._element.removeEventListener("keydown",this._handleKeyDown),this._element.removeEventListener("keyup",this._handleKeyUp),this._element.removeEventListener("contextmenu",this._handleContextMenu),this._element.removeEventListener("blur",this._handleLosingFocus))):(this._element.removeEventListener("pointermove",this._handleMouseMove),this._element.removeEventListener("pointerdown",this._handleMouseDown),this._element.removeEventListener("pointerup",this._handleMouseUp),this._element.removeEventListener("pointerenter",this._handleMouseEnter),this._element.removeEventListener("pointerleave",this._handleMouseLeave),this._element.removeEventListener("click",this._handleClick),this._element.removeEventListener("wheel",this._handleWheel),this._element.removeEventListener("keydown",this._handleKeyDown),this._element.removeEventListener("keyup",this._handleKeyUp),this._element.removeEventListener("contextmenu",this._handleContextMenu),this._element.removeEventListener("blur",this._handleLosingFocus))}_ensureCanReceiveKeyboardInput(){this._element.tabIndex=this._element.tabIndex}_checkElementSize(){this._origElementSize.width===this._element.clientWidth&&this._origElementSize.height===this._element.clientHeight||(this.updateCaptureRegion(),this._origElementSize.width=this._element.clientWidth,this._origElementSize.height=this._element.clientHeight),this._pollTimerID=window.setTimeout(()=>{this._checkElementSize()},Ze)}_raiseMouseEvent(Ci){this.event("mouseControlEvent").raise(Ci)}_raiseKeyboardEvent(Ci){this.event("keyboardControlEvent").raise(Ci)}_raiseCaptureEvent(Ci){this.event("ctrlCaptureEvent").raise(Ci)}_normalizeMousePosition(Ci,ji){ji.xPos=(Ci.offsetX-this._captureRegion.left)/this._captureRegion.width*Qe,ji.yPos=(Ci.offsetY-this._captureRegion.top)/this._captureRegion.height*Qe}_isOnScreenContent(Ci){const ji=this._captureRegion.left,An=this._captureRegion.left+this._captureRegion.width,Ea=this._captureRegion.top,Ln=this._captureRegion.top+this._captureRegion.height;return ji<=Ci.offsetX&&Ci.offsetX<An&&Ea<=Ci.offsetY&&Ci.offsetY<Ln}_shouldMoveMouse(){if(this._mouseMoveStartTime){const Ci=new Date().getTime(),ji=Ci-this._mouseMoveStartTime;if(this._isMouseDown&&ji>=xt||!this._isMouseDown&&ji>=Lt)return this._mouseMoveStartTime=Ci,!0}else this._mouseMoveStartTime=new Date().getTime();return!1}_syncKeyStates(Ci){this._raiseKeyboardEvent({codeType:1,code:Ot,repeat:!1,keyUp:Ci}),this._raiseKeyboardEvent({codeType:1,code:Yt,repeat:!1,keyUp:Ci}),this._raiseKeyboardEvent({codeType:1,code:bt,repeat:!1,keyUp:Ci}),this._raiseKeyboardEvent({codeType:1,code:pt,repeat:!1,keyUp:Ci}),this._logger.info("Synced Key states.")}static formatMouseEvent(Ci){return He.encodeMouseEvent(Ci)}static formatKeyboardEvent(Ci){return He.encodeKeyboardEvent(Ci)}};function Li(Ci){switch(Ci){case 0:return 0;case 2:return 1;case 1:return 2;default:return}}if(typeof _.exports=="object"&&typeof b=="object"){var cn=(Ci,ji,An,Ea)=>{if(ji&&typeof ji=="object"||typeof ji=="function")for(let Ln of Object.getOwnPropertyNames(ji))Object.prototype.hasOwnProperty.call(Ci,Ln)||Ln===An||Object.defineProperty(Ci,Ln,{get:()=>ji[Ln],enumerable:!(Ea=Object.getOwnPropertyDescriptor(ji,Ln))||Ea.enumerable});return Ci};_.exports=cn(_.exports,b)}return _.exports},typeof n=="object"&&typeof a=="object"?a.exports=c(Hv,dn):typeof n=="object"?n["skype-calling-utilities"]=c(Hv,dn):s["skype-calling-utilities"]=c(s["@skype/rt-js-bindings"],s.lodash)}}),Dr=oi({"../node_modules/synctasks/dist/SyncTasks.js"(n){function a(ze){var He=de();return ze.then(function(be){He.resolve(be)},function(be){He.reject(be)}),He.promise().thenAsync(function(be){return be})}function s(ze){return ze!=null&&typeof ze.then=="function"}function c(ze){return ze!=null&&typeof ze.cancel=="function"}function u(ze,He){if(!n.config.catchExceptions)return ze();try{return ze()}catch(be){return He(be)}}Object.defineProperty(n,"__esModule",{value:!0}),n.config={exceptionsToConsole:!0,catchExceptions:!0,traceEnabled:!1,exceptionHandler:void 0,unhandledErrorHandler:function(ze){throw ze}},n.fromThenable=a;var m,b,_,k=[],N=typeof setImmediate<"u";function W(ze){k.push(ze),k.length===1&&(N?setImmediate(ee):setTimeout(ee,0))}function ee(){var ze=k;k=[];for(var He=0;He<ze.length;He++)ze[He]()}function oe(ze){if(ze.length===0)return se([]);var He,be=de(),Ee=ze.length,Pe=Array(ze.length);be.onCancel(function(Ze){ze.forEach(function(Xe){c(Xe)&&m.SyncTask.cancelOtherInternal(Xe,Ze)})});var Qe=function(){--Ee==0&&(He!==void 0?be.reject(He):be.resolve(Pe))};return ze.forEach(function(Ze,Xe){s(Ze)?Ze.then(function(bt){Pe[Xe]=bt,Qe()},function(bt){He===void 0&&(He=bt===void 0||bt),Qe()}):(Pe[Xe]=Ze,Qe())}),be.promise()}function de(){return new m.SyncTask}function se(ze){return new m.SyncTask().resolve(ze).promise()}function Re(ze){return new m.SyncTask().reject(ze).promise()}function ue(ze){var He=de(),be=!1;return He.onCancel(function(Ee){ze.forEach(function(Pe){c(Pe)&&m.SyncTask.cancelOtherInternal(Pe,Ee)})}),ze.forEach(function(Ee){s(Ee)?Ee.then(function(Pe){be||(be=!0,He.resolve(Pe))},function(Pe){be||(be=!0,He.reject(Pe))}):be||(be=!0,He.resolve(Ee))}),He.promise()}function Ne(ze,He){var be=de(),Ee=setTimeout(function(){be.resolve({timedOut:!0})},He);return ue([ze.then(function(Pe){return clearTimeout(Ee),{timedOut:!1,result:Pe}}),be.promise()])}n.asyncCallback=W,b=m||(m={}),_=function(){function ze(){this._completedSuccess=!1,this._completedFail=!1,this._traceEnabled=!1,this._cancelCallbacks=[],this._wasCanceled=!1,this._wasExplicitlyCanceled=!1,this._resolving=!1,this._storedCallbackSets=[],this._mustHandleError=!0}return ze.prototype._addCallbackSet=function(He,be){var Ee=this,Pe=new ze;return Pe.onCancel(function(Qe){He.wasCanceled=!0,He.cancelContext=Qe,Ee._cancelInternal(Qe)}),He.task=Pe,this._storedCallbackSets.push(He),be?this._mustHandleError=!1:Pe._mustHandleError=!1,this._resolving||(this._completedSuccess?this._resolveSuccesses():this._completedFail&&this._resolveFailures()),Pe.promise()},ze.prototype.onCancel=function(He){return this._completedSuccess||this._completedFail||(this._wasCanceled?He(this._cancelContext):this._cancelCallbacks.push(He)),this},ze.prototype.then=function(He,be){return this._addCallbackSet({successFunc:He,failFunc:be},!0)},ze.prototype.thenAsync=function(He,be){return this._addCallbackSet({successFunc:He,failFunc:be,asyncCallback:!0},!0)},ze.prototype.catch=function(He){return this._addCallbackSet({failFunc:He},!0)},ze.prototype.always=function(He){return this._addCallbackSet({successFunc:He,failFunc:He},!0)},ze.prototype.setTracingEnabled=function(He){return this._traceEnabled=He,this},ze.prototype.finally=function(He){return this._addCallbackSet({successFunc:He,failFunc:He},!1),this},ze.prototype.done=function(He){return this._addCallbackSet({successFunc:He},!1),this},ze.prototype.fail=function(He){return this._addCallbackSet({failFunc:He},!1),this},ze.prototype.resolve=function(He){return this._checkState(!0),this._completedSuccess=!0,this._storedResolution=He,this._cancelCallbacks=[],this._resolveSuccesses(),this},ze.prototype.reject=function(He){return this._checkState(!1),this._completedFail=!0,this._storedErrResolution=He,this._cancelCallbacks=[],this._resolveFailures(),ze._enforceErrorHandled(this),this},ze.prototype._checkState=function(He){if(this._completedSuccess||this._completedFail){this._completeStack&&console.error(this._completeStack.message,this._completeStack.stack);var be="Failed to "+(He?"resolve":"reject")+": the task is already "+(this._completedSuccess?"resolved":"rejected");throw new Error(be)}(n.config.traceEnabled||this._traceEnabled)&&(this._completeStack=new Error("resolve"))},ze._enforceErrorHandled=function(He){He._mustHandleError&&(ze._rejectedTasks.push(He),ze._enforceErrorHandledTimer||(ze._enforceErrorHandledTimer=setTimeout(function(){ze._enforceErrorHandledTimer=void 0;var be=ze._rejectedTasks;ze._rejectedTasks=[],be.forEach(function(Ee,Pe){Ee._mustHandleError&&n.config.unhandledErrorHandler(Ee._storedErrResolution)})},0)))},ze.prototype.cancel=function(He){if(this._wasExplicitlyCanceled)throw new Error("Already Canceled");this._wasExplicitlyCanceled=!0,this._cancelInternal(He)},ze.prototype._cancelInternal=function(He){var be=this;if(!this._wasCanceled){this._wasCanceled=!0,this._cancelContext=He;var Ee=this._cancelCallbacks;this._cancelCallbacks=[],Ee.length>0&&Ee.forEach(function(Pe){be._completedSuccess||be._completedFail||Pe(be._cancelContext)})}},ze.cancelOtherInternal=function(He,be){var Ee=He;Ee._storedCallbackSets&&Ee._cancelInternal?Ee._cancelInternal(be):He.cancel(be)},ze.prototype.promise=function(){return this},ze.prototype._resolveSuccesses=function(){var He=this;for(this._resolving=!0;this._storedCallbackSets.length;){var be=this._storedCallbackSets;this._storedCallbackSets=[],be.forEach(function(Ee){Ee.asyncCallback?W(function(){return He._resolveSuccessCallback(Ee)}):He._resolveSuccessCallback(Ee)})}this._resolving=!1},ze.prototype._resolveSuccessCallback=function(He){var be=this;He.successFunc?u(function(){var Ee=He.successFunc(be._storedResolution);c(Ee)&&(He.wasCanceled?ze.cancelOtherInternal(Ee,He.cancelContext):He.task.onCancel(function(Pe){return ze.cancelOtherInternal(Ee,Pe)})),s(Ee)?Ee.then(function(Pe){He.task.resolve(Pe)},function(Pe){He.task.reject(Pe)}):He.task.resolve(Ee)},function(Ee){be._handleException(Ee,"SyncTask caught exception in success block: "+Ee.toString()),He.task.reject(Ee)}):He.task.resolve(this._storedResolution)},ze.prototype._resolveFailures=function(){var He=this;for(this._resolving=!0;this._storedCallbackSets.length;){var be=this._storedCallbackSets;this._storedCallbackSets=[],be.forEach(function(Ee){Ee.asyncCallback?W(function(){return He._resolveFailureCallback(Ee)}):He._resolveFailureCallback(Ee)})}this._resolving=!1},ze.prototype._resolveFailureCallback=function(He){var be=this;He.failFunc?u(function(){var Ee=He.failFunc(be._storedErrResolution);c(Ee)&&(He.wasCanceled?ze.cancelOtherInternal(Ee,He.cancelContext):He.task.onCancel(function(Pe){return ze.cancelOtherInternal(Ee,Pe)})),s(Ee)?Ee.then(function(Pe){He.task.resolve(Pe)},function(Pe){He.task.reject(Pe)}):He.task.resolve(Ee)},function(Ee){be._handleException(Ee,"SyncTask caught exception in failure block: "+Ee.toString()),He.task.reject(Ee)}):He.task.reject(this._storedErrResolution)},ze.prototype._handleException=function(He,be){n.config.exceptionsToConsole&&console.error(be),n.config.exceptionHandler&&n.config.exceptionHandler(He)},ze.prototype.toEs6Promise=function(){var He=this;return new Promise(function(be,Ee){return He.then(be,Ee)})},ze._rejectedTasks=[],ze}(),b.SyncTask=_,n.all=oe,n.Defer=de,n.Resolved=se,n.Rejected=Re,n.race=ue,n.raceTimer=Ne}}),ms=oi({"../node_modules/sdp-transform/lib/grammar.js"(n,a){var s=a.exports={v:[{name:"version",reg:/^(\d*)$/}],o:[{name:"origin",reg:/^(\S*) (\d*) (\d*) (\S*) IP(\d) (\S*)/,names:["username","sessionId","sessionVersion","netType","ipVer","address"],format:"%s %s %d %s IP%d %s"}],s:[{name:"name"}],i:[{name:"description"}],u:[{name:"uri"}],e:[{name:"email"}],p:[{name:"phone"}],z:[{name:"timezones"}],r:[{name:"repeats"}],t:[{name:"timing",reg:/^(\d*) (\d*)/,names:["start","stop"],format:"%d %d"}],c:[{name:"connection",reg:/^IN IP(\d) (\S*)/,names:["version","ip"],format:"IN IP%d %s"}],b:[{push:"bandwidth",reg:/^(TIAS|AS|CT|RR|RS):(\d*)/,names:["type","limit"],format:"%s:%s"}],m:[{reg:/^(\S*) (\d*) ([\w/]*)(?: (.*))?/,names:["type","port","protocol","payloads"],format:"%s %d %s %s"}],a:[{push:"rtp",reg:/^rtpmap:(\d*) ([\w\-.]*)(?:\s*\/(\d*)(?:\s*\/(\S*))?)?/,names:["payload","codec","rate","encoding"],format:function(c){return c.encoding?"rtpmap:%d %s/%s/%s":c.rate?"rtpmap:%d %s/%s":"rtpmap:%d %s"}},{push:"fmtp",reg:/^fmtp:(\d*) ([\S| ]*)/,names:["payload","config"],format:"fmtp:%d %s"},{name:"control",reg:/^control:(.*)/,format:"control:%s"},{name:"rtcp",reg:/^rtcp:(\d*)(?: (\S*) IP(\d) (\S*))?/,names:["port","netType","ipVer","address"],format:function(c){return c.address!=null?"rtcp:%d %s IP%d %s":"rtcp:%d"}},{push:"rtcpFbXMessage",reg:/^rtcp-fb:(\*|\d*) x-message ([\S| ]*)/,names:["payload","param"],format:function(c){return"rtcp-fb:"+(c.payload==="*"?"%s":"%d")+" x-message %s"}},{push:"rtcpFbTrrInt",reg:/^rtcp-fb:(\*|\d*) trr-int (\d*)/,names:["payload","value"],format:"rtcp-fb:%d trr-int %d"},{push:"rtcpFb",reg:/^rtcp-fb:(\*|\d*) ([\w-_]*)(?: ([\w-_]*))?/,names:["payload","type","subtype"],format:function(c){return c.subtype!=null?"rtcp-fb:%s %s %s":"rtcp-fb:%s %s"}},{push:"ext",reg:/^extmap:(\d+)(?:\/(\w+))?(?: (urn:ietf:params:rtp-hdrext:encrypt))? (\S*)(?: (\S*))?/,names:["value","direction","encrypt-uri","uri","config"],format:function(c){return"extmap:%d"+(c.direction?"/%s":"%v")+(c["encrypt-uri"]?" %s":"%v")+" %s"+(c.config?" %s":"")}},{name:"extmapAllowMixed",reg:/^(extmap-allow-mixed)/},{push:"cryptoscale",reg:/^cryptoscale:(\d*) (client|server) ([\w_]*) (\S*)(?: (\S*))?/,names:["id","flavor","suite","config","sessionConfig"],format:function(c){return c.sessionConfig!=null?"cryptoscale:%d %s %s %s %s":"cryptoscale:%d %s %s %s"}},{push:"crypto",reg:/^crypto:(\d*) ([\w_]*) (\S*)(?: (\S*))?/,names:["id","suite","config","sessionConfig"],format:function(c){return c.sessionConfig!=null?"crypto:%d %s %s %s":"crypto:%d %s %s"}},{name:"setup",reg:/^setup:(\w*)/,format:"setup:%s"},{name:"connectionType",reg:/^connection:(new|existing)/,format:"connection:%s"},{name:"mid",reg:/^mid:([^\s]*)/,format:"mid:%s"},{name:"msid",reg:/^msid:(.*)/,format:"msid:%s"},{name:"ptime",reg:/^ptime:(\d*(?:\.\d*)*)/,format:"ptime:%d"},{name:"maxptime",reg:/^maxptime:(\d*(?:\.\d*)*)/,format:"maxptime:%d"},{name:"direction",reg:/^(sendrecv|recvonly|sendonly|inactive)/},{name:"icelite",reg:/^(ice-lite)/},{name:"iceUfrag",reg:/^ice-ufrag:(\S*)/,format:"ice-ufrag:%s"},{name:"icePwd",reg:/^ice-pwd:(\S*)/,format:"ice-pwd:%s"},{name:"fingerprint",reg:/^fingerprint:(\S*) (\S*)/,names:["type","hash"],format:"fingerprint:%s %s"},{push:"candidates",reg:/^candidate:(\S*) (\d*) (\S*) (\d*) (\S*) (\d*) typ (\S*)(?: raddr (\S*) rport (\d*))?(?: tcptype (\S*))?(?: generation (\d*))?(?: network-id (\d*))?(?: network-cost (\d*))?/,names:["foundation","component","transport","priority","ip","port","type","raddr","rport","tcptype","generation","network-id","network-cost"],format:function(c){var u="candidate:%s %d %s %d %s %d typ %s";return u+=c.raddr!=null?" raddr %s rport %d":"%v%v",u+=c.tcptype!=null?" tcptype %s":"%v",c.generation!=null&&(u+=" generation %d"),u+=c["network-id"]!=null?" network-id %d":"%v",u+=c["network-cost"]!=null?" network-cost %d":"%v"}},{push:"xCandidatesIpv6",reg:/^x-candidate-ipv6:(\S*) (\d*) (\S*) (\d*) (\S*) (\d*) typ (\S*)(?: raddr (\S*) rport (\d*))?(?: tcptype (\S*))?(?: generation (\d*))?/,names:["foundation","component","transport","priority","ip","port","type","raddr","rport","tcptype","generation"],format:function(c){var u="candidate:%s %d %s %d %s %d typ %s";return u+=c.raddr!=null?" raddr %s rport %d":"%v%v",u+=c.tcptype!=null?" tcptype %s":"%v",c.generation!=null&&(u+=" generation %d"),u}},{name:"endOfCandidates",reg:/^(end-of-candidates)/},{name:"remoteCandidates",reg:/^remote-candidates:(.*)/,format:"remote-candidates:%s"},{name:"iceOptions",reg:/^ice-options:(\S*)/,format:"ice-options:%s"},{push:"ssrcs",reg:/^ssrc:(\d*) ([\w_-]*)(?::(.*))?/,names:["id","attribute","value"],format:function(c){var u="ssrc:%d";return c.attribute!=null&&(u+=" %s",c.value!=null&&(u+=":%s")),u}},{push:"ssrcGroups",reg:/^ssrc-group:([\x21\x23\x24\x25\x26\x27\x2A\x2B\x2D\x2E\w]*) (.*)/,names:["semantics","ssrcs"],format:"ssrc-group:%s %s"},{name:"msidSemantic",reg:/^msid-semantic:\s?(\w*) (\S*)/,names:["semantic","token"],format:"msid-semantic: %s %s"},{push:"groups",reg:/^group:(\w*) (.*)/,names:["type","mids"],format:"group:%s %s"},{name:"rtcpMux",reg:/^(rtcp-mux)/},{name:"rtcpRsize",reg:/^(rtcp-rsize)/},{name:"sctpmap",reg:/^sctpmap:([\w_/]*) (\S*)(?: (\S*))?/,names:["sctpmapNumber","app","maxMessageSize"],format:function(c){return c.maxMessageSize!=null?"sctpmap:%s %s %s":"sctpmap:%s %s"}},{name:"xGoogleFlag",reg:/^x-google-flag:([^\s]*)/,format:"x-google-flag:%s"},{push:"rids",reg:/^rid:([\d\w]+) (\w+)(?: ([\S| ]*))?/,names:["id","direction","params"],format:function(c){return c.params?"rid:%s %s %s":"rid:%s %s"}},{push:"imageattrs",reg:new RegExp("^imageattr:(\\d+|\\*)[\\s\\t]+(send|recv)[\\s\\t]+(\\*|\\[\\S+\\](?:[\\s\\t]+\\[\\S+\\])*)(?:[\\s\\t]+(recv|send)[\\s\\t]+(\\*|\\[\\S+\\](?:[\\s\\t]+\\[\\S+\\])*))?"),names:["pt","dir1","attrs1","dir2","attrs2"],format:function(c){return"imageattr:%s %s %s"+(c.dir2?" %s %s":"")}},{name:"simulcast",reg:new RegExp("^simulcast:(send|recv) ([a-zA-Z0-9\\-_~;,]+)(?:\\s?(send|recv) ([a-zA-Z0-9\\-_~;,]+))?$"),names:["dir1","list1","dir2","list2"],format:function(c){return"simulcast:%s %s"+(c.dir2?" %s %s":"")}},{name:"simulcast_03",reg:/^simulcast:[\s\t]+([\S+\s\t]+)$/,names:["value"],format:"simulcast: %s"},{name:"framerate",reg:/^framerate:(\d+(?:$|\.\d+))/,format:"framerate:%s"},{name:"sourceFilter",reg:/^source-filter: *(excl|incl) (\S*) (IP4|IP6|\*) (\S*) (.*)/,names:["filterMode","netType","addressTypes","destAddress","srcList"],format:"source-filter: %s %s %s %s %s"},{name:"bundleOnly",reg:/^(bundle-only)/},{name:"label",reg:/^label:(.+)/,format:"label:%s"},{name:"sctpPort",reg:/^sctp-port:(\d+)$/,format:"sctp-port:%s"},{name:"maxMessageSize",reg:/^max-message-size:(\d+)$/,format:"max-message-size:%s"},{push:"tsRefClocks",reg:/^ts-refclk:([^\s=]*)(?:=(\S*))?/,names:["clksrc","clksrcExt"],format:function(c){return"ts-refclk:%s"+(c.clksrcExt!=null?"=%s":"")}},{name:"mediaClk",reg:/^mediaclk:(?:id=(\S*))? *([^\s=]*)(?:=(\S*))?(?: *rate=(\d+)\/(\d+))?/,names:["id","mediaClockName","mediaClockValue","rateNumerator","rateDenominator"],format:function(c){var u="mediaclk:";return u+=c.id!=null?"id=%s %s":"%v%s",u+=c.mediaClockValue!=null?"=%s":"",u+=c.rateNumerator!=null?" rate=%s":"",u+=c.rateDenominator!=null?"/%s":""}},{name:"keywords",reg:/^keywds:(.+)$/,format:"keywds:%s"},{name:"content",reg:/^content:(.+)/,format:"content:%s"},{name:"bfcpFloorCtrl",reg:/^floorctrl:(c-only|s-only|c-s)/,format:"floorctrl:%s"},{name:"bfcpConfId",reg:/^confid:(\d+)/,format:"confid:%s"},{name:"bfcpUserId",reg:/^userid:(\d+)/,format:"userid:%s"},{name:"bfcpFloorId",reg:/^floorid:(.+) (?:m-stream|mstrm):(.+)/,names:["id","mStream"],format:"floorid:%s mstrm:%s"},{name:"xMediaBw",reg:/^x-mediabw:(\S*) send=(\d*);recv=(\d*)/,names:["label","sendBw","receiveBw"],format:"x-mediabw:%s send=%d;recv=%d"},{name:"xSsrcRange",reg:/^x-ssrc-range:(\d*)-(\d*)/,names:["ssrcMin","ssrcMax"],format:"x-ssrc-range:%d-%d"},{name:"xSource",reg:/^x-source:(\S*)/,format:"x-source:%s"},{name:"xSourceStreamId",reg:/^x-source-streamid:(\S*)/,format:"x-source-streamid:%s"},{name:"xCaps",reg:/^x-caps:(\d*) (\S*)/,names:["payloadType","value"],format:"x-caps:%d %s"},{name:"signalingFbXMessage",reg:/^x-signaling-fb:(\*|\d*) x-message ([\S| ]*)/,names:["payload","param"],format:function(c){return"x-signaling-fb:"+(c.payload==="*"?"%s":"%d")+" x-message %s"}},{push:"xMediaSettings",reg:/^x-mediasettings:([\S| ]*)/,names:["settings"],format:"x-mediasettings:%s"},{name:"xDataProtocol",reg:/^x-data-protocol:\s?(.*)/,format:"x-data-protocol:%s"},{name:"xMultiStream",reg:/^x-multi-stream:(\d*) (\d*) (\d*) (\d*)/,names:["numberOfStreams","startSsrc","ssrcRange","ssrcGroupRange"],format:"x-multi-stream:%d %d %d %d"},{push:"invalid",names:["value"]}]};Object.keys(s).forEach(function(c){s[c].forEach(function(u){u.reg||(u.reg=/(.*)/),u.format||(u.format="%s")})})}}),zi=oi({"../node_modules/sdp-transform/lib/parser.js"(n){var a=function(_){return String(Number(_))===_?Number(_):_},s=function(_,k,N,W){if(W&&!N)k[W]=a(_[1]);else for(var ee=0;ee<N.length;ee+=1)_[ee+1]!=null&&(k[N[ee]]=a(_[ee+1]))},c=function(_,k,N){var W=_.name&&_.names;_.push&&!k[_.push]?k[_.push]=[]:W&&!k[_.name]&&(k[_.name]={});var ee=_.push?{}:W?k[_.name]:k;s(N.match(_.reg),ee,_.names,_.name),_.push&&k[_.push].push(ee)},u=ms(),m=RegExp.prototype.test.bind(/^([a-z])=(.*)/);n.parse=function(_){var k={},N=[],W=k;return _.split(/(\r\n|\r|\n)/).filter(m).forEach(function(ee){var oe=ee[0],de=ee.slice(2);oe==="m"&&(N.push({rtp:[],fmtp:[]}),W=N[N.length-1]);for(var se=0;se<(u[oe]||[]).length;se+=1){var Re=u[oe][se];if(Re.reg.test(de))return c(Re,W,de)}}),k.media=N,k};var b=function(_,k){var N=k.split(/=(.+)/,2);return N.length===2?_[N[0]]=a(N[1]):N.length===1&&k.length>1&&(_[N[0]]=void 0),_};n.parseParams=function(_){return _.split(/;\s?/).reduce(b,{})},n.parseFmtpConfig=n.parseParams,n.parsePayloads=function(_){return _.toString().split(" ").map(Number)},n.parseRemoteCandidates=function(_){for(var k=[],N=_.split(" ").map(a),W=0;W<N.length;W+=3)k.push({component:N[W],ip:N[W+1],port:N[W+2]});return k},n.parseImageAttributes=function(_){return _.split(" ").map(function(k){return k.substring(1,k.length-1).split(",").reduce(b,{})})},n.parseSimulcastStreamList=function(_){return _.split(";").map(function(k){return k.split(",").map(function(N){var W,ee=!1;return N[0]!=="~"?W=a(N):(W=a(N.substring(1,N.length)),ee=!0),{scid:W,paused:ee}})})}}}),hn=oi({"../node_modules/sdp-transform/lib/writer.js"(n,a){var s=ms(),c=/%[sdv%]/g,u=function(k){var N=1,W=arguments,ee=W.length;return k.replace(c,function(oe){if(N>=ee)return oe;var de=W[N];switch(N+=1,oe){case"%%":return"%";case"%s":return String(de);case"%d":return Number(de);case"%v":return""}})},m=function(k,N,W){var ee=[k+"="+(N.format instanceof Function?N.format(N.push?W:W[N.name]):N.format)];if(N.names)for(var oe=0;oe<N.names.length;oe+=1){var de=N.names[oe];N.name?ee.push(W[N.name][de]):ee.push(W[N.names[oe]])}else ee.push(W[N.name]);return u.apply(null,ee)},b=["v","o","s","i","u","e","p","c","b","t","r","z","a"],_=["i","c","b","a"];a.exports=function(k,N){N=N||{},k.version==null&&(k.version=0),k.name==null&&(k.name=" "),k.media.forEach(function(de){de.payloads==null&&(de.payloads="")});var W=N.outerOrder||b,ee=N.innerOrder||_,oe=[];return W.forEach(function(de){s[de].forEach(function(se){se.name in k&&k[se.name]!=null?oe.push(m(de,se,k)):se.push in k&&k[se.push]!=null&&k[se.push].forEach(function(Re){oe.push(m(de,se,Re))})})}),k.media.forEach(function(de){oe.push(m("m",s.m[0],de)),ee.forEach(function(se){s[se].forEach(function(Re){Re.name in de&&de[Re.name]!=null?oe.push(m(se,Re,de)):Re.push in de&&de[Re.push]!=null&&de[Re.push].forEach(function(ue){oe.push(m(se,Re,ue))})})})}),oe.join(`\r
`)+`\r
`}}}),Un=oi({"../node_modules/sdp-transform/lib/index.js"(n){var a=zi(),s=hn();n.write=s,n.parse=a.parse,n.parseParams=a.parseParams,n.parseFmtpConfig=a.parseFmtpConfig,n.parsePayloads=a.parsePayloads,n.parseRemoteCandidates=a.parseRemoteCandidates,n.parseImageAttributes=a.parseImageAttributes,n.parseSimulcastStreamList=a.parseSimulcastStreamList}}),Fa={};Gt(Fa,{HttpRequestDispatcherImplementation:()=>h2,generateCauseId:()=>hi,getOvb:()=>UR,getVersion:()=>wu,pluginlessStackFactory:()=>wIi,whiteList:()=>kIi}),nt.exports=In(Fa);var rr=$i(ba()),ro=8;function hi(){const n="abcdef0123456789",a=n.length;let s="";for(let c=0;c<ro;c++)s+=n.charAt(Math.floor(Math.random()*a));return s}function _h(n){return new RegExp("^[a-f0-9]{8}$").test(n)&&n.length===ro}var dp=Hv,yf=dn,Lg=class SQe{constructor(a,s,c=""){this.ulLogComponent=a,this.ulSafeComponent=s,this._getPrefix=(0,yf.isFunction)(c)?c:()=>c,this.logComponent=dp.LogFactory.instance().component(this.ulLogComponent),dp.LogFactory.instance().declareComponentSafe(this.ulLogComponent,s)}createChild(a){const s=(0,yf.isFunction)(a)?a:()=>a;return new SQe(this.ulLogComponent,this.ulSafeComponent,()=>this._getPrefix()?`${this._getPrefix()}/${s()}`:s())}log(...a){this._apply(s=>this.logComponent.debug2(null,s),a)}debug(...a){this._apply(s=>this.logComponent.debug4(null,s),a)}info(...a){this._apply(s=>this.logComponent.debug1(null,s),a)}warn(...a){this._apply(s=>this.logComponent.warn(null,s),a)}error(...a){this._apply(s=>this.logComponent.error(null,s),a)}_apply(a,s=[]){this._addPrefix(s),a(s.map(c=>c instanceof DOMException?c.toString():c).map(c=>(0,yf.isObject)(c)?JSON.stringify(c):c).join(", "))}_addPrefix(a){if(a&&a[0]){const s=`${this._getPrefix()} ${a[0]}`;a[0]=s}}},xb=Hv,_v=class{constructor(n,a){this.value=n,this.piiKind=a}},tw=["id"," orgid","username","phonenumber"];function kn(n){return typeof n=="string"?xb.pii.Mri(n):xb.pii.Omit(n)}function o2(n){try{return n.map(kn)}catch{return[]}}function xS(n,a=["id"],s={threadId:8}){if(!n||typeof n!="object")return n;try{let c=sG(n);return c=s2(c,a,s),c}catch{return{error:"failed to scrub object fields"}}}function eN(n){try{const a={};return Object.keys(n).forEach(s=>{const c=kn(s);a[c]=n[s]}),a}catch{return{error:"failed to scrub mri keys"}}}function tN(n){return JSON.stringify(eN(n))}function wy(n){return n&&xb.pii.Mri(n)}function Qu(n){const a=Zz(n);return a&&a.substr(0,8)}function Zz(n){return n&&n.substr(0,3)==="99:"?xb.pii.Omit(n):n}function sG(n){if(!n||typeof n!="object")return n;const a=new Set,s=JSON.stringify(n,(c,u)=>{if(typeof u=="object"&&u!==null){if(a.has(u))return;a.add(u)}return u});return JSON.parse(s)}function s2(n,a,s){if(!n||typeof n!="object")return n;const c={...n};for(const[u,m]of Object.entries(n))Array.isArray(m)?c[u]=m.map(b=>s2(b,a,s)):typeof m=="object"?c[u]=s2(m,a,s):u.toLowerCase()==="displayname"?c[u]="<redacted>":m&&(a.includes(u)||tw.includes(u.toLowerCase())?c[u]=kn(m):s[u]&&typeof m=="string"&&(c[u]=m.toString().substring(0,s[u])));return c}function l2(n){const a=String.raw`[\\]*['|\"]?\s*[\:|=]\s*[\\]*['|\"]?`,s=String.raw`[a-zA-Z\d#.~?!@$%^&*-_()+]*?`;return new RegExp(String.raw`((?:${n})${a})(${s})(\\{0,2}['\"])`,"g")}function $0(n){return(a,s,c,u)=>c?.toLowerCase()==="false"||c?.toLowerCase()==="true"?a:String.raw`${s}${n(c)}${u}`}function lG(n){if(!n)return null;const a=l2("[U|u]ser[N|n]ame|[O|o]rg[I|i]d");return n.replace(a,$0(kn))}function cG(n){if(!n)return null;const a=l2("[P|p]assword|[T|t]oken|[S|s]ecret|[A|a]uthorization|[D|d]isplay[N|n]ame|[P|p]honeNumber|[A|a]ddress|IP");return lG(n.replace(a,$0(()=>"<redacted>")))}var K_=$i(dn),BS=["response","responseText","responseURL","status","state","statusText","timeout","withCredentials","stack","message","name","error","piiSafe","phase","code","participantId","phrase","subCode","reason","conversationType","terminatedReason","terminatedReasonCode","terminatedReasonSubCode","errorMessage"];function Hs(n){try{return JSON.parse(JSON.stringify(n,BS,4))}catch{return{error:"failed to parse object"}}}var rC=n=>{try{return n.split(`
`)[0]}catch{return"invalid stack"}};function fi(n,a=!1){if(n==null)return"void";if(n instanceof Error||n instanceof String||n instanceof Number||n instanceof Boolean)return n.toString();try{return n.stack&&(n.stack=rC(n.stack)),(a?JSON.stringify(n):JSON.stringify(n,BS,4)).replace(/(\r\n\t|\n|\r\t|\s)/gm,"")}catch{return`failed to get error information:${n&&typeof n.toString=="function"&&n.toString()} ${n?.response&&JSON.stringify(n.response)}`}}function xo(n){try{return JSON.stringify(n,null,2)}catch{return`failed to stringify obj ${n}`}}function J_(n,a){try{return n.substring(0,a)}catch{return n}}function Og(n){return n||n===!1||n===""||n===0}function c2(n){const a={mediaPeerType:n.mediaPeerType,threadId:Qu(n.threadId)};return Og(n.messageId)&&(a.messageId=n.messageId),Og(n.enableGroupCallMeetupGeneration)&&(a.enableGroupCallMeetupGeneration=n.enableGroupCallMeetupGeneration),Og(n.endpointMetadata)&&(a.endpointMetadata=n.endpointMetadata),Og(n.onBehalfOf)&&(a.onBehalfOf=kn(n.onBehalfOf)),Og(n.onBehalfOfUserDisplayName)&&(a.onBehalfOfUserDisplayName=n.onBehalfOfUserDisplayName),Og(n.emergencyContent)&&(a.emergencyContent=n.emergencyContent),Og(n.isEmergency)&&(a.isEmergency=n.isEmergency),Og(n.broadcastContext)&&(a.broadcastContext=n.broadcastContext),n.meetingInfo&&(a.meetingInfo={tenantId:n.meetingInfo.tenantId,organizerId:kn(n.meetingInfo.organizerId)},Og(n.meetingInfo.meetingType)&&(a.meetingInfo.meetingType=n.meetingInfo.meetingType),Og(n.meetingInfo.replyChainMessageId)&&(a.meetingInfo.replyChainMessageId=n.meetingInfo.replyChainMessageId)),n.transferContext&&(a.transferContext={transferorMri:kn(n.transferContext.transferorMri),targetMri:kn(n.transferContext.targetMri),context:xS(n.transferContext.context)},Og(n.transferContext.transferType)&&(a.transferContext.transferType=n.transferContext.transferType)),xo(a)}function CD(n,a){try{const s=xS(n);return Object.keys(n).forEach(c=>{a.includes(c)?s[c]=kn(n[c]):c==="conversationId"&&(s[c]=Qu(n[c]))}),xo(K_.omit(s,["body.gp"]))}catch{return{error:"failed to get safe payload"}}}function H0(n){try{let a=xS(n,["id","groupCallInitiator","organizerId"]);return _D(a,"response.roster.participants"),_D(a,"response.additionalActionResponses.0.output.roster.participants"),_D(a,"response.muteUnmuteResponse"),a=K_.omit(a,["meetingChatProperties"]),a=Xz(a),a}catch{return"failed to return safe response"}}function Bh(n){try{return Xz(xS(n))}catch{return"failed to return safe request"}}function Xz(n){if(n?.config?.data){let a=n.config.data;a=JSON.parse(a),a=xS(a),n.config.data=xo(a)}return xo(n)}function iN(n){try{const a=xS(n,["id","groupCallInitiator"]);return _D(a,"body.participants"),xo(a)}catch{return"failed to return safe response"}}function d2(n){try{return xo(xS(n,["originalId"]))}catch{return"failed to return safe endpoint details"}}function _D(n,a){n&&K_.get(n,a)&&K_.set(n,a,eN(K_.get(n,a)))}function eV(n){const a=Math.floor(11*Math.random())+10;return Math.floor(n*(1-a/100))}function tV(n){if(!n)return!1;try{return atob(n),!0}catch{return!1}}function iV(n){return!!n&&typeof n.then=="function"}function nn(n){if(!n)return`${n}`;if(n instanceof Map)return u2(n);const a=n.toString();return a.endsWith("[object Object]")?JSON.stringify(n):a}function ky(n){try{if(n.status)return`status: ${n.status}, URL: ${n.responseURL}, statusText: ${n.responseText}`}catch{}return nn(n)}function u2(n){const a={};return n.forEach((s,c)=>{a[c.toString()]=s}),JSON.stringify(a)}function nV(n){const a=new ArrayBuffer(n.length),s=new Uint8Array(a);for(let c=0;c<n.length;c++)s[c]=n.charCodeAt(c);return s}function nN(n,a,s=0){return n&&a!==void 0&&a>-1&&n.length>a&&n.splice(s,n.length-a),n}function ld(n,a,s,c=0){nN(n,s===0?0:s-1,c),s!==0&&n.push(a)}var h2=class{constructor(n){n&&typeof n.createChild=="function"?this.logger=n.createChild("RequestDispatcher"):this.logger=new Lg("JS.TsCalling.RequestDispatcher",!1)}getRequestOptions(n,a,s,c,u){return{headers:a||{},timeout:c,payload:s||null,responseType:u}}getAsync(n,a){return this.sendRequest(n,a,"GET")}postAsync(n,a){return this.sendRequest(n,a,"POST")}putAsync(n,a){return this.sendRequest(n,a,"PUT")}removeAsync(n,a){return this.sendRequest(n,a,"DELETE")}async sendRequest(n,a={headers:{}},s){return a.useFetch?this.sendFetchRequest(n,a,s):this.sendAxiosRequest(n,a,s)}async sendAxiosRequest(n,a={headers:{}},s){const c=this.logger.createChild(`[${a.causeId||hi()}][AxiosRequest]`);c.info(`sending, ${s}-${n}`);const u=Date.now();let m;rV(a);try{const b=rr.default.request({url:n,method:s,headers:a.headers,timeout:typeof a.timeout=="number"?a.timeout:45e3,data:a.payload||"",responseType:a.responseType||a.dataType||"json",withCredentials:aV(a.withCredentials,!1),cancelToken:new rr.default.CancelToken(k=>{m=k})});iV(a.timeout)&&a.timeout.then(()=>{c.info("Aborting pending request"),m()},()=>{c.info("Timeout promise rejected, ignoring")});const _=await b;return c.info(`success, status=${_.status}`),{response:_.data,request:{status:_.status,statusText:_.statusText,headers:_.headers,responseURL:_.request.responseURL,readyState:_.request.readyState,response:_.request.response,responseText:_.request.responseType===""||_.request.responseType==="text"?_.request.responseText:"",withCredentials:_.request.withCredentials},duration:Date.now()-u}}catch(b){throw c.info("failed"),rr.default.isCancel(b)?(c.info(`response=${H0(b.message)}`),{aborted:!0}):(b.response?c.info(`response=${H0(b.response)}`):b.request?c.info(`no response, request=${Bh(b.request)}`):c.info(`request not made, error=${fi(b)}`),b||new Error("Request failed"))}}async sendFetchRequest(n,a={headers:{}},s){const c=this.logger.createChild(`[${a.causeId||hi()}][FetchRequest]`);c.info(`sending, ${s}-${n}`);const u=Date.now(),m=new AbortController;let b,_=null,k=null;const N=()=>{c.info("Aborting pending request"),m.abort()};rV(a);try{if(a.fetchUseKeepAlive&&a.payload?.toString().length>65e3&&c.warn("Using fetch with keep alive with more than 64kib data"),c.info(`${JSON.stringify(a.headers)}`),_=fetch(n,{method:s,headers:a.headers,body:a.payload,credentials:a.withCredentials?"include":"same-origin",signal:m.signal,keepalive:a.fetchUseKeepAlive}),iV(a.timeout))a.timeout.then(()=>{N()},()=>{c.info("Timeout promise rejected, ignoring")});else if(a.timeout){const ee=setTimeout(()=>N(),a.timeout);_=_.finally(()=>clearTimeout(ee))}k=await _;try{b=await k.json()}catch(ee){c.info(`unable to parse response as json with error ${ee}`)}const W={response:b,request:{status:k.status,statusText:k.statusText,headers:Object.fromEntries(k.headers.entries()),responseURL:k.url,response:b,withCredentials:a.withCredentials},duration:Date.now()-u};if(!k.ok)throw c.info(`failed response, status=${k.status}`),W;return c.info(`success, status=${k.status}`),W}catch(W){throw c.info(`failed error=${fi(W)}`),W.name==="AbortError"?{aborted:!0}:W||new Error("Request failed")}}};function aV(n,a){return n!==void 0?n:a}function rV(n){n.headers=n.headers||{},n.headers["content-type"]||(n.headers["content-type"]=n.contentType||"application/json")}var oV=dn,aN=class _Ce{constructor(a){this._callingLogger=a,this._maybeLog=(s,...c)=>{try{this._callingLogger[s](...c)}catch(u){this._callingLogger.info("[failed to log]",fi(u))}}}getPrefix(a,s){let c="";return s&&(c+=`[${s}]`),a&&(c+=`[${a}]`),c}createChild(a,s){return new _Ce(this._callingLogger.createChild(a,s))}createFnLogger(a,s,...c){return new _Ce(this._callingLogger.createChild(this.getPrefix(a,s)+c.join(""),!1))}logSuccess(a){this._maybeLog("info",`success=${a}}`)}logFailure(a){const s=fi(a);this._maybeLog("info",`failed=${s}}`)}log(...a){this._maybeLog("log",...a)}debug(...a){this._maybeLog("debug",...a)}info(...a){this._maybeLog("info",...a)}warn(...a){this._maybeLog("warn",...a)}error(...a){this._maybeLog("error",...a)}},dG=dn,rN=class{constructor(n){this.eventLogger=n,this.subscriptions=[]}subscribe(n){return new j0(this.subscriptions,n)}dispose(n){this.subscriptions=[]}raiseEvents(n){this.subscriptions.slice().forEach(a=>{try{a.eventHandler!==void 0&&n(a.eventHandler)}catch(s){this.eventLogger?.warn?.("Event handler exception caught!",nn(s))}})}},j0=class{constructor(n,a){this.subscriptions=n,this.eventHandler=a,this.subscriptions.push(this)}dispose(){(0,dG.remove)(this.subscriptions,n=>n===this),this.eventHandler=void 0}},Qs=class extends rN{constructor(n){super(n)}changed(n,a){return this.subscribe({changed:{skipEventConfig:a,handler:n},on:void 0})}on(n,a){return this.subscribe({changed:void 0,on:{name:String(n),handler:this._toEventCallback(a)}})}once(n,a,s){let c;const u=(...m)=>{c.dispose(s),this._toEventCallback(a)(...m)};return c=this.on(n,this._fromEventCallback(u)),c}raiseChanged(n){this.raiseEvents(a=>{if(!a.changed)return;const{skipEventConfig:s,handler:c}=a.changed;!this.getShouldSkipChangedEvent(n,s)&&c()})}event(n){return{raise:this._fromEventCallback((...a)=>this._raiseEventImpl(String(n),...a))}}_raiseEventImpl(n,...a){this.raiseEvents(s=>s.on&&s.on.name===n&&s.on.handler(...a))}_toEventCallback(n){return n}_fromEventCallback(n){return n}getShouldSkipChangedEvent(n,a){return n?.skipDominantSpeakerUpdatesOnCall?!!a?.skipDominantSpeakerUpdatesOnCall:!!n?.skipParticipantsUpdatesOnCall&&!!a?.skipParticipantsUpdatesOnCall}async onAsync(n,a){return this.on(n,a)}async onceAsync(n,a,s){return this.once(n,a,s)}async changedAsync(n,a){return this.changed(n,a)}async disposeAsync(n){this.dispose(n)}};function wu(){return"2025.07.01.32"}function UR(){return"1c7a031acaef8e0a65d66c2b89797f8a96375b44"}var sV=dn,uG=$i(Pr()),up={OS:{Android:"Android",iOS:"iOS",MacOS:"Mac OS"},Browsers:{Opera:"Opera",Edge:"Edge",Yandex:"Yandex",Safari:"Safari",MobileSafari:"Mobile Safari",WebKit:"WebKit"},Engines:{Blink:"Blink",EdgeHTML:"EdgeHTML",Gecko:"Gecko",WebKit:"WebKit"}},oN="Unknown",ED="0.0",ul=class D${constructor(){const a=navigator.userAgent,s=new uG.UAParser(a).getResult();this.browserInfo={name:s.browser.name||"Unknown",engine:s.engine.name||"Unknown",version:s.browser.version||ED,formFactor:G0(s)||"Unknown",osName:s.os.name||oN,osVersion:s.os.version||oN},this.modifyParserResult(s)}static get instance(){return D$._instance||(D$._instance=new D$),D$._instance}static isFormFactor(...a){return a.map(s=>s.toString()).includes(this.getBrowserInfo().formFactor)}static isEngine(...a){return a.map(s=>s.toString()).includes(this.getBrowserInfo().engine)}static isBrowser(...a){return a.map(s=>s.toString()).includes(this.getBrowserInfo().name)}static isVersionGreaterOrEqual(a){const s=this.getBrowserInfo().version,c=a.split(".").map(m=>parseInt(m,10)),u=s.split(".").map(m=>parseInt(m,10));return u[0]>c[0]||u[0]===c[0]&&u[1]>=c[1]}static getBrowserInfo(){return this.instance.browserInfo}static isRemote(){return window.navigator.mediaDevices?.isRemote}static toString(){const a=this.getBrowserInfo();return`${a.name}/${a.version} ${a.engine} ${a.formFactor}`}modifyParserResult(a){switch(a.engine.name){case up.Engines.EdgeHTML:this.browserInfo.engine="Edge";break;case up.Engines.Blink:this.browserInfo.engine="Chromium";break;case up.Engines.WebKit:a.browser.name?.includes("Safari")||(this.browserInfo.engine="Chromium");break;case up.Engines.Gecko:this.browserInfo.engine="Firefox"}a.engine.name===up.Engines.Blink&&a.browser.name===up.Browsers.Edge&&(this.browserInfo.name="EdgeAnaheim"),a.engine.name===up.Engines.Blink&&a.os.name===up.OS.Android&&(this.browserInfo.version=a.engine.version||ED),a.browser.name!==up.Browsers.Opera&&a.browser.name!==up.Browsers.Yandex||(this.browserInfo.version=a.engine.version||ED,a.browser.name===up.Browsers.Yandex&&(this.browserInfo.name="YandexBrowser")),(a.os.name===up.OS.iOS||a.browser.name?.includes(up.Browsers.Safari))&&(this.browserInfo.engine="Safari"),a.os.name!==up.OS.MacOS&&a.os.name!==up.OS.iOS||a.browser.name!==up.Browsers.WebKit||(this.browserInfo.engine="Safari",this.browserInfo.name="AppleWebView"),a.os.name===up.OS.iOS&&(this.browserInfo.version=a.os.version||ED),a.browser.name===up.Browsers.MobileSafari&&(this.browserInfo.name="Safari"),a.ua.includes("maglev")&&(this.browserInfo.name="Maglev",this.browserInfo.version=a.engine.version||ED),D$.isRemote()&&(this.browserInfo.engine="ChromiumAVD"),a.ua.includes("Cisco")&&(this.browserInfo.name="CiscoOS"),a.ua.includes("ZoomRoom")&&(this.browserInfo.name="ZoomRoom"),a.ua.includes("TeamsSamsungTVBrowser")&&(this.browserInfo.name="SamsungTV")}};function G0(n){if(hG()==="136")return"Hololens";if(/hostAudio-Processing/i.test(n.ua))return"RoomAudioProcessing";const s=n.device.type;return s==="mobile"||s==="tablet"?"Mobile":n.browser.name===void 0?"Unknown":"Desktop"}function hG(){const n="os-sku",a=window.external;return a?.getHostEnvironmentValue?JSON.parse(a.getHostEnvironmentValue(n))[n]:"-1"}var lV={src:["https://statics.teams.cdn.office.net/hashed/azuremediaplayer.min-d46c9f4.js","https://statics.teams.cdn.office.net/evergreen-assets/broadcast/player-skin.min.js"],css:["https://statics.teams.cdn.office.net/evergreen-assets/broadcast/player-skin.min.css?v=2","https://statics.teams.cdn.office.net/evergreen-assets/broadcast/video-player.css?v=3"],styles:["azuremediaplayer","amp-stream-skin","amp-big-play-centered"],lang:"en-us",disableFullscreenButton:!1,playerType:0},sN={src:["https://res.cdn.office.net/s01-ml-player/legacy/hls/hydra_player_hls_bundle_4.24351.2.js"],css:[],styles:[],lang:"en-us",disableFullscreenButton:!1,muteVideo:!1,playerType:1,hydraPlayerWebSdkUrls:["https://res-4.public.onecdn.static.microsoft/s01-ml-player/legacy/hls/hydra_player_hls_bundle_4.24351.2.js","https://res.cdn.office.net/s01-ml-player/legacy/hls/hydra_player_hls_bundle_4.24351.2.js"]},p2={src:[],css:[],styles:[],playerType:2,hydraPlayerWebSdkUrls:["https://res.cdn.office.net/s01-ml-player/4.24352.3/hydra_player_ums_bundle.js"]},g2=class{constructor(n,a,s,c){this.configIds=s,this.logger=c,this.defaultSettings=uV(),this.logger.info(`client settings: ${JSON.stringify(a)}`),this.defaultSettings.debug=a?.debug||!1,this.defaultSettings.playerType=a?.playerConfig?.playerType||this.defaultSettings.playerType,a?.playerConfig&&(this.defaultSettings.playerType===0?this.defaultSettings.ampSettings.liveStreamPlayerConfiguration=a.playerConfig:this.defaultSettings.playerType===1?this.defaultSettings.hlsSettings.liveStreamPlayerConfiguration=a.playerConfig:this.defaultSettings.playerType===2&&(this.defaultSettings.umsSettings.liveStreamPlayerConfiguration=a.playerConfig)),(0,sV.mergeWith)(this.defaultSettings,n,pG),this.logger.info(`applied settings: ${JSON.stringify(this.defaultSettings)}`)}get playerConfig(){return this.defaultSettings.playerType===0?this.defaultSettings.ampSettings.liveStreamPlayerConfiguration:this.defaultSettings.playerType===1?this.defaultSettings.hlsSettings.liveStreamPlayerConfiguration:this.defaultSettings.playerType===2?this.defaultSettings.umsSettings.liveStreamPlayerConfiguration:null}get config(){return this.defaultSettings}},cV=class{constructor(){this.defaultSettings={allowSdnPlugins:!0,capturePlayerLogs:!0,playerType:0,loadType:1,maxPlayerDiagnosticsCount:50,maxPlayerMemoryTraceLogCount:1e3,maxPlayerPlaybackEventCount:50,maxRetryCount:10,playerTelemetryTickMs:1e3,removeEmptyDefaultTextTrack:!0,sendSnapshotTelemetry:!1,sendSnapshotTelemetryEveryMs:1e4,sendInitialTelemetryAfterMs:6e4,sendTelemetry:!0,textTrackKind:"subtitles",maxRetryCountForLoadingResources:5,maxVideoTrackHistoryLogCount:100,hydraRuntimeFetchTimeout:6e3,ampSettings:{errorCodesEligibleForStreamingUrlSwitch:[4194309,2097564,2097556,2097752,2097753,5242884],liveStreamPlayerConfiguration:lV,sourceResetTimeoutInMs:1e3,streamingUrlSwitchMaxCount:2,resetStreamingUrlSwitchCount:!1,useBrowserWindowSizeForBitRate:!0,estimateAbsoluteTime:!0,maxAbsoluteTimeOffsetEstimationResultsLogCount:100,collectUserInitiatedSeekEventsTelemetry:!0,maxUserInitiatedSeekEventCount:100,noMediaTimeoutMs:-1},hlsSettings:{liveStreamPlayerConfiguration:sN,timeoutForSwitchingUrl:9e3,estimateAbsoluteTime:!0,maxAbsoluteTimeOffsetEstimationResultsLogCount:100,playlistInitialSequenceNumber:1,skipNonce:!1,maxStreamConnectionResultsLogCount:100,logHlsJsEvents:!1,logHlsJsEventsEveryMs:5e3,maxPlayerExperimentalEvents:100},umsSettings:{liveStreamPlayerConfiguration:p2,timeoutForSwitchingUrl:9e3,maxStreamConnectionResultsLogCount:100,minTargetEdgeLatency:.2,latencyCompensationThreshold:.5,maxPlayerExperimentalEvents:100}}}getSettings(){return this.defaultSettings}},dV=class extends cV{constructor(){super(),this.settings=super.getSettings(),this.settings.loadType=0,this.settings.allowSdnPlugins=!1,this.settings.umsSettings.minTargetEdgeLatency=.6,this.settings.umsSettings.latencyCompensationThreshold=.9}getSettings(){return this.settings}};function uV(){return(ul.isEngine("Safari")?new dV:new cV).getSettings()}function pG(n,a){if((0,sV.isArray)(n))return a.slice()}function q0(n){return!!n&&!!n.url&&!!n.decryptionToken}function iw(n,a,s){if(!n&&!s)throw new Error("Assert failed"+(a!==void 0?`: ${a}`:""))}var lN=class{constructor(n,a,s){this.name=n,this.stopCrash=a,this.start(s)}complete(){iw(this.startTime,"not started",this.stopCrash),iw(this.duration===void 0,"already completed",this.stopCrash),this.duration=Date.now()-this.startTime}updateDetails(n,a){if(this.details&&typeof this.details=="object")for(let s=0;s<n.length;s++)this.details[n[s]]=a[s]}fail(n){this.failReason=n,this.complete()}set detail(n){this.details=n}getTelemetryEvent(){iw(this.startTime,"not started",this.stopCrash);try{iw(this.duration!==void 0,"not completed",this.stopCrash)}catch(a){if(this.name!=="SetSource"&&this.name!=="Load")throw a}const n={name:this.name,startTime:this.startTime,duration:this.duration};return this.failReason&&(n.failReason=this.failReason),this.details&&(n.details=this.details),n}start(n){iw(!this.startTime,"already started",this.stopCrash),this.startTime=Date.now(),this.details=n}},gG=class{constructor(n,a,s){this.config=n,this.logger=a,this.playerDiagnosticsLog=s,this.currentScenarioMap=new Map,this.playerEvents=[],this.playbackEvents=[],this.userInitiatedSeekEvents=[],this.experimentalEvents=[],this.clientNetworkType=void 0,this.maxPlayerPlaybackEventCount=n.maxPlayerPlaybackEventCount||5,this.maxPlayerDiagnosticsCount=n.maxPlayerDiagnosticsCount||5,this.maxPlayerMemoryTraceLogCount=n.maxPlayerMemoryTraceLogCount||100,this.maxUserInitiatedSeekEventCount=n.ampSettings?.maxUserInitiatedSeekEventCount||100,this.stopCrash=n.stopCrash||!1,this.config.debug&&(this.playerDiagnosticsLog.memoryLog=[]),this.addNetworkTypeEventListener()}getPlayerDiagnosticSnapshot(){return this.currentPlayerDiagnosticSnapshot}registerStatsUpdated(n){this.currentPlayerDiagnosticSnapshot=n,Object.keys(this.playerDiagnosticsLog).forEach(a=>{const s=a,c=this.playerDiagnosticsLog[a];if(Array.isArray(c)){c.push(n[s]);const u=s==="memoryLog"&&c.length>this.maxPlayerMemoryTraceLogCount,m=s!=="memoryLog"&&c.length>this.maxPlayerDiagnosticsCount;(u||m)&&c.splice(0,1)}else this.playerDiagnosticsLog[a]=n[s]})}registerEventLoadAttempt(n,a){this.registerScenario(n,a)}registerEventLoadFailed(n,a){this.completeScenario(n,a)}registerEventLoadSucceeded(n,a){this.completeScenario(n,void 0,a)}registerPlayerLoadAttempt(){this.registerScenario("Load")}registerPlayerLoadSucceeded(n){this.completeScenario("Load",void 0,n)}registerPlayerLoadFailed(n){this.completeScenario("Load",n)}registerPlayerSetupAttempt(){this.registerScenario("Setup")}registerPlayerSetupSucceeded(){this.completeScenario("Setup")}registerPlayerSetupFailed(n){this.completeScenario("Setup",n)}registerStreamConnectionAttempt(n){this.registerScenario("StreamConnection")}registerStreamConnectionSucceeded(){this.completeScenario("StreamConnection")}registerStreamConnectionFailed(n){this.completeScenario("StreamConnection",n)}registerSetSourceAttempt(n,a){let s=n;a&&(s={src:n,reason:a}),this.registerScenario("SetSource",s)}registerSetSourceSucceeded(n){this.getScenario("SetSource").updateDetails(["src"],[n]),this.completeScenario("SetSource")}registerSetSourcedFailed(n,a){this.getScenario("SetSource").updateDetails(["src"],[a]),this.completeScenario("SetSource",n)}registerSdnPluginLoad(n,a,s){this.registerScenario("SdnPluginLoad",n);const c=a?void 0:s;this.completeScenario("SdnPluginLoad",c)}registerPlayerDestroyed(n){this.registerScenario("Destroyed",n),this.completeScenario("Destroyed")}registerPlaybackStateChanged(n,a){let s;n!=="Ready"||this.firstReadyStateTimestamp?n!=="Playing"||this.firstPlayingStateTimestamp||(this.firstPlayingStateTimestamp=Date.now()):this.firstReadyStateTimestamp=Date.now(),a&&n==="Buffering"&&(a?s=a.message:this.logger.debug(`Unexpected buffering payload: ${JSON.stringify(a)}`)),this.registerPlaybackEvent("StateChanged",n,s)}registerPlaybackError(n,a){this.registerPlaybackEvent("Error",{errorType:n,details:a})}registerDownloadBitratechanged(n){this.registerPlaybackEvent("BitrateChangedDownload",n)}registerStreamOptionsConfigured(n,a){this.registerPlaybackEvent("StreamOptionsConfigured",this.generateCleanedStreamOption(n),a)}registerPlaybackBitratechanged(n){this.registerPlaybackEvent("BitrateChangedPlayback",n)}registerPotentialMediaFreeze(n){this.registerPlaybackEvent("PotentialMediaFreeze",n)}registerCaptionToggle(n,a,s){const c={isEnabled:n,culture:a,playerTime:s};this.registerPlaybackEvent("CaptionsToggled",c)}registerFullScreenChange(n){this.registerPlaybackEvent("FullscreenChanged",n)}registerMute(n){this.registerPlaybackEvent("Mute",n)}registerVolumeChange(n){this.registerPlaybackEvent("Volume",n)}getExperimentalEvents(){return{playback_experimentalEvents:this.prepareForTelemetry(this.experimentalEvents)}}getUserInitiatedSeekEvents(){return{playback_userInitiatedSeekEvents:this.prepareForTelemetry(this.userInitiatedSeekEvents)}}getSnapshotReport(n={}){const a=this.playerEvents.map(u=>u.getTelemetryEvent()),s=this.playbackEvents;let c={};return this.currentPlayerDiagnosticSnapshot&&(c=this.filterAndPrepareTelemetry()),{isFullReport:!1,configIds:n.configIds||"",playerId:n.playerId||"",correlationId:n.correlationId||"",traceId:n.correlationId?n.correlationId.replace(/-/g,""):"",eTag:n.eTag||"",isFinal:n.isFinal??!1,isIframe:this.config.loadType===1,isFullscreenButtonDisabled:n.disableFullscreenButton??!1,threadId:n.threadId||"",telemetryTickMs:this.currentPlayerDiagnosticSnapshot&&this.currentPlayerDiagnosticSnapshot.statsInterval?this.currentPlayerDiagnosticSnapshot.statsInterval:-1,tsCallingVersion:wu(),...this.getInitializationReport(a,s),...this.getPlaybackReport(s),...this.getBitrateReport(s),...this.getSdnReport(a),...this.getSetSourceReport(a),...this.getExperimentalEvents(),...this.getUserInitiatedSeekEvents(),networkType:this.getClientNetworkType(),callSetupSucceeded:this.getCallSetupSucceeded(a),callDropped:this.getCallDropped(s),...c}}getReport(n={}){const a=this.playerEvents.map(c=>c.getTelemetryEvent()),s=this.playbackEvents;return{callendReason:n.callendReason,isFullReport:!0,configIds:n.configIds||"",playerId:n.playerId||"",correlationId:n.correlationId||"",traceId:n.correlationId?n.correlationId.replace(/-/g,""):"",eTag:n.eTag||"",isFinal:n.isFinal??!1,isIframe:this.config.loadType===1,isFullscreenButtonDisabled:n.disableFullscreenButton??!1,threadId:n.threadId||"",telemetryTickMs:this.currentPlayerDiagnosticSnapshot&&this.currentPlayerDiagnosticSnapshot.statsInterval?this.currentPlayerDiagnosticSnapshot.statsInterval:-1,tsCallingVersion:wu(),...this.getInitializationReport(a,s),...this.getPlaybackReport(s),...this.getBitrateReport(s),...this.getSdnReport(a),...this.getSetSourceReport(a),...this.getExperimentalEvents(),...this.getUserInitiatedSeekEvents(),networkType:this.getClientNetworkType(),callSetupSucceeded:this.getCallSetupSucceeded(a),callDropped:this.getCallDropped(s),...this.getPlayerDiagnosticLog()}}registerExperimentalEvent(n,a,s){const c=this.createTelemetryEvent(n,a,s);this.experimentalEvents.push(c),this.logTelemetryEvent(c)}registerUserInitiatedSeek(n){const a=(this.currentPlayerDiagnosticSnapshot?.currentPlayPosition?this.currentPlayerDiagnosticSnapshot.currentPlayPosition:-1)<n.newCurrentPlayPosition,s={...n,seekForward:a},c=this.createTelemetryEvent("UserInitiatedSeek",s);this.userInitiatedSeekEvents.push(c),this.userInitiatedSeekEvents.length>this.maxUserInitiatedSeekEventCount&&this.userInitiatedSeekEvents.splice(0,1)}createTelemetryEvent(n,a,s){const c={eventType:n,timestamp:Date.now(),currentPlayPosition:this.currentPlayerDiagnosticSnapshot&&this.currentPlayerDiagnosticSnapshot.currentPlayPosition?this.currentPlayerDiagnosticSnapshot.currentPlayPosition:-1};return a!==void 0&&(c.payload=this.prepareForTelemetry(a)),c.message=s,c}registerPlaybackEvent(n,a,s){const c=this.createTelemetryEvent(n,a,s);n==="Error"&&a?.errorType!=="PlaybackRetried"&&(c.fatal=!0),this.playbackEvents.push(c),this.playbackEvents.length>this.maxPlayerPlaybackEventCount&&this.playbackEvents.splice(0,1),this.logTelemetryEvent(c)}getPlayerDiagnosticLog(){if(!this.currentPlayerDiagnosticSnapshot)return{};const n={...this.currentPlayerDiagnosticSnapshot,...this.playerDiagnosticsLog},a={};return Object.keys(n).forEach(s=>{a[`player_${s}`]=this.prepareForTelemetry(n[s])}),a}getCallSetupSucceeded(n){const a=n.find(s=>s.name==="Load");return!!a&&!a.failReason}getCallDropped(n){return!!n.filter(a=>a.eventType==="Error").find(a=>a.fatal)}getInitializationReport(n,a){const s=n.find(c=>c.name==="Load");return{init_timeLoadToStreamConnectionEstablished:(s&&this.initialStreamConnectionEstablishedTimestamp?this.initialStreamConnectionEstablishedTimestamp-s.startTime:-1)||-1,init_timeLoadToReady:(s&&this.firstReadyStateTimestamp?this.firstReadyStateTimestamp-s.startTime:-1)||-1,init_timeLoadToPlaying:(s&&this.firstPlayingStateTimestamp?this.firstPlayingStateTimestamp-s.startTime:-1)||-1,init_allEvents:this.prepareForTelemetry(n)}}getPlaybackReport(n){const a=n.filter(He=>He.eventType==="StateChanged"),s=a.find(He=>He.payload==="Ready"),c=a.find(He=>He.payload==="Play"),u=a.find(He=>He.payload==="Start"),m=a.find(He=>He.payload==="Playing"),b=s&&c?c.timestamp-s.timestamp:-1,_=c&&u?u.timestamp-c.timestamp:-1,k=u&&m?m.timestamp-u.timestamp:-1,N=a.filter(He=>He.payload==="Seeked"),W=a.filter(He=>He.payload==="Seeking"),ee=a.filter(He=>He.payload==="Paused"),oe=a.filter(He=>He.payload==="Resume"),de=a.filter(He=>He.payload==="Buffering"),se=["BitrateChangedDownload","BitrateChangedPlayback","Error","Mute","StateChanged","Volume","StreamOptionsConfigured"],Re=n.filter(He=>He.eventType==="Error"),ue=n.filter(He=>He.eventType==="Volume"||He.eventType==="Mute"),Ne=n.filter(He=>He.eventType==="StreamOptionsConfigured"),ze=n.filter(He=>!se.includes(He.eventType));return{playback_timeReadyToPlay:b,playback_timePlayToStart:_,playback_timeStartToPlaying:k,playback_bufferingEvents:this.prepareForTelemetry(de),playback_errorEvents:this.prepareForTelemetry(Re),playback_pauseEvents:this.prepareForTelemetry(ee),playback_resumeEvents:this.prepareForTelemetry(oe),playback_otherEvents:this.prepareForTelemetry(ze),playback_seekedEvents:this.prepareForTelemetry(N),playback_seekingEvents:this.prepareForTelemetry(W),playback_stateChangeEvents:this.prepareForTelemetry(a),playback_volumeEvents:this.prepareForTelemetry(ue),playback_streamOptionsConfiguredEvents:this.prepareForTelemetry(Ne)}}generateCleanedStreamOption(n){return{...n,stream:{...n?.stream,decryptionToken:n?.stream?.decryptionToken?"valid":"empty",sdnContext:n?.stream?.sdnContext?"valid":"empty",keyAuthorizationToken:n?.stream?.keyAuthorizationToken?"valid":"empty"},altStream:n?.altStream?{...n?.altStream,decryptionToken:n?.altStream?.decryptionToken?"valid":"empty",sdnContext:n?.altStream?.sdnContext?"valid":"empty",keyAuthorizationToken:n?.stream?.keyAuthorizationToken?"valid":"empty"}:void 0}}getBitrateReport(n){const a=n.filter(b=>b.eventType==="BitrateChangedDownload"),s=a.sort(b=>Number(b.payload)),c=a.length?{bitrate_downloadChanges:this.prepareForTelemetry(a),bitrate_downloadChangeCount:a.length||-1,bitrate_downloadMin:s[0].payload||-1,bitrate_downloadMax:s[s.length-1].payload||-1}:{},u=n.filter(b=>b.eventType==="BitrateChangedPlayback"),m=u.sort(b=>Number(b.payload));return{...c,...u.length?{bitrate_playbackChanges:this.prepareForTelemetry(u),bitrate_playbackChangeCount:u.length||-1,bitrate_playbackMin:m[0].payload||-1,bitrate_playbackMax:m[m.length-1].payload||-1}:{}}}addNetworkTypeEventListener(){window.navigator?.connection?.type&&window.navigator?.connection?.addEventListener("change",()=>this.updateClientNetworkType())}updateClientNetworkType(){this.clientNetworkType=void 0,this.getClientNetworkType()}getClientNetworkType(){if(this.clientNetworkType===void 0){let n="Unknown";if(window.navigator?.connection?.type)switch(window.navigator?.connection?.type){case"cellular":n="WWAN";break;case"ethernet":n="Wired";break;case"wifi":n="Wireless";break;default:n="Unknown"}this.clientNetworkType=n}return this.clientNetworkType}getSdnReport(n){const a=n.filter(c=>c.name==="SdnPluginLoad"),s=a.length?a[a.length-1]:void 0;return{sdn_loaded:!(!s||s.failReason!==void 0),sdn_details:s&&s.details||"",sdn_error:s&&s.failReason||"",sdn_events:this.prepareForTelemetry(a)}}getSetSourceReport(n){const a=n.filter(s=>s.name==="SetSource");return{set_source_events:this.prepareForTelemetry(a)}}registerScenario(n,a){const s=this.currentScenarioMap.get(n),c=new lN(n,this.stopCrash,a);iw(!s,`previous scenario:${nn(s)} is not completed, new scenario:${nn(c)}`,this.stopCrash),this.currentScenarioMap.set(n,c),this.playerEvents.push(c)}getScenario(n){return this.currentScenarioMap.get(n)}completeScenario(n,a,s){const c=this.currentScenarioMap.get(n);iw(c,"no scenario to complete",this.stopCrash),a?c.fail(a):(n!=="StreamConnection"||this.initialStreamConnectionEstablishedTimestamp||(this.initialStreamConnectionEstablishedTimestamp=Date.now()),s&&(c.detail=s),c.complete()),this.currentScenarioMap.delete(n)}logTelemetryEvent(n){this.config.debug&&(this.logger.debug(`PlayerTelemetryEvent: ${JSON.stringify(n)}`),this.logger.debug(`PlayerDiagnosticData: ${JSON.stringify(this.currentPlayerDiagnosticSnapshot)}`))}filterAndPrepareTelemetry(){const n=new Set;n.add("serviceLatencyCdg"),n.add("endToEndLatencyCdg"),n.add("videoEdgeLatencyCdg");const a={};return Object.keys(this.currentPlayerDiagnosticSnapshot).forEach(s=>{n.has(s)||(a[`player_${s}`]=this.prepareForTelemetry(this.currentPlayerDiagnosticSnapshot[s]))}),a}prepareForTelemetry(n){return typeof n=="boolean"?n:typeof n=="string"||n===void 0?n||"":typeof n=="number"?n??-1:JSON.stringify(n)}},cN=dn;function Bt(n){return new Promise(a=>{a(n())})}var Pi=class{constructor(){this.isPendingInt=!0,this.promiseInt=new Promise((n,a)=>{this.resolveInt=n,this.rejectInt=a})}get resolve(){return n=>{this.isPendingInt=!1,this.resolveInt(n),this.clearTimeout()}}get reject(){return n=>{this.isPendingInt=!1,this.rejectInt(n),this.clearTimeout()}}get promise(){return this.promiseInt}get isPending(){return this.isPendingInt}setTimeout(n,a=`deferred timed out after ${n}ms`){this.isPendingInt&&(this.timeoutId=setTimeout(()=>{this.reject(a)},n))}clearTimeout(){this.timeoutId&&clearTimeout(this.timeoutId)}};function zn(n,a=`deferred timed out after ${n}ms`){const s=new Pi;return s.setTimeout(n,a),s}function Br(n){return new Promise(a=>setTimeout(a,n))}var ku=class{static build(n,a){return new Ev(n,a)}},Ev=class{constructor(n,a){this.ontimeout=n,this.name=a}start(n){if(this.timeoutId!==void 0)throw new Error(`Timer ${this.name} already started`);return this.timeoutId=window.setTimeout(()=>this.ontimeout(),n),this}stop(){if(this.timeoutId===void 0)throw new Error(`Timer ${this.name} is not defined`);clearTimeout(this.timeoutId),this.timeoutId=void 0}};function Sf(){const n=Y_(),a=ID();let s;return(s||(s={})).CaptionFunctionalityNotSupported="CaptionFunctionalityNotSupported",class{constructor(c,u){this.container=c,this.eventsHandler=u,this.videoElementEvents=[],this.playerEvents=[],this.maxMemoryTraceLogCount=1e4,this.videoSourceType="application/dash+xml",this.sdnPluginLoaded=!1,this.statsTimer=-1,this.statsInterval=1e3,this.videoSourceSetAttemptCount=0,this.totalBufferingTime=0,this.isBuffering=!1,this.totalPlayingTime=0,this.isPlaying=!1,this.videoTrackTotalDurations=[]}get contextWindow(){return this.container.ownerDocument.defaultView}configure(c,u,m){this.liveStreamOptions=c,this.playerId=m,u&&(this.configProvider=u,this.statsInterval=u.config.playerTelemetryTickMs||this.statsInterval,this.maxMemoryTraceLogCount=u.config.maxPlayerMemoryTraceLogCount||this.maxMemoryTraceLogCount)}getIceCandidates(){let c=[];try{const u=this.liveStreamOptions.stream.sdnContext||this.liveStreamOptions.altStream?.sdnContext||"",m=JSON.parse(u),b=JSON.parse(m.sdnConfig);if(!b.RTCIceCandidates)throw new Error("RTCIceCandidates not present in SDN Context");c=b.RTCIceCandidates}catch(u){this.log(`getIceCandidates failed: ${JSON.stringify(u.message)}`,"error")}return this.log(`getIceCandidates: ${JSON.stringify(c)}`,"debug"),c}loadPlayerScript(){let c=Promise.resolve("");const u=this.configProvider.playerConfig.nonce,m=this.configProvider.playerConfig.css;for(let b=0;b<m.length;b++)c=c.then(()=>this.retry(()=>this.loadCss(this.container.ownerDocument,m[b],u)));return c=c.then(()=>this.loadAmpScript()),c}loadAmpScript(){this.log("loadPlayerScript started");let c=Promise.resolve("");const u=this.configProvider.playerConfig?.nonce,m=this.configProvider.playerConfig?.src||[],b=Math.max(2,this.configProvider.config.maxRetryCountForLoadingResources);if(m.length===0)return Promise.reject("AMP Player Src is empty");for(let _=0;_<m.length;++_)c=c.then(()=>this.loadScriptPromise(m,_,u,b));return c}loadScriptPromise(c,u,m,b,_=""){return this.retry(()=>this.setScriptByLoad(this.container.ownerDocument,c[u],m),b).then(k=>`${c[u]}: ${k} `.concat(_)).catch(k=>this.retry(()=>this.setScriptByBlob(this.container.ownerDocument,c[u],m),b).then(N=>`${c[u]}: ${N}`.concat(` ${k} `,` ${_} `)).catch(N=>this.retry(()=>this.setScriptByInnerHtml(this.container.ownerDocument,c[u],m),1).then(W=>`${c[u]}: ${W}`.concat(` ${k} `,`${N} `,` ${_} `)).catch(W=>{let ee=_;return u<c.length&&(ee=ee.concat(`Failed to load script, nonce: ${m}, src: ${c[u]} index: ${u} `),ee=ee.concat(`${b} attempts LoadFailure `,`${b} attempts BlobFetchFailure: `,N,", 1 attempt InnerHtmlFailure: ",`${W} `)),Promise.reject(ee)})))}retry(c,u=this.configProvider.config.maxRetryCountForLoadingResources,m=1,b=200){return c(u).then(_=>`${_}, succeeded on load number: ${m} `).catch(_=>(this.log(`Error loading resource: ${_} -- ${u} retriesLeft`),--u==0?Promise.reject(`${_}`):new Promise(k=>setTimeout(()=>k(this.retry(c,u,m+1).then(N=>typeof N=="string"?`${N}, succeeded on load number: ${m}`:N).catch(N=>Promise.reject(`${_}`.concat(", ",N)))),b))))}setScriptByLoad(c,u,m){const b=c.createElement("script"),_=this.getElementLoadPromise(b,u);return b.src=u,m&&(b.nonce=m),c.head.appendChild(b),_.then(()=>Promise.resolve("Success: setScriptByLoad"))}setScriptByBlob(c,u,m){return this.safeResponse(u).then(b=>b.blob().then(_=>{if(_){const k=URL.createObjectURL(_);return this.setScriptByLoad(c,k,m).then(()=>Promise.resolve("Success: setScriptByBlob"))}return Promise.reject(`${b.status}, blob is null`)}))}setScriptByInnerHtml(c,u,m){return this.safeResponse(u).then(b=>b.text().then(_=>{if(_){const k=document.createElement("script");return k.innerHTML=_,m&&!this.configProvider.config.hlsSettings.skipNonce&&(k.nonce=m),c.head.appendChild(k),Promise.resolve("Success: setScriptByInnerHtml")}return Promise.reject(`status code:${b.status}, text is null`)}))}safeResponse(c){return fetch(c).then(u=>u.ok?u:Promise.reject(`${u.status}`))}tryLoadSdnPlugin(){return this.sdnPluginLoaded||!this.liveStreamOptions.sdn?Promise.resolve():this.configProvider.config.allowSdnPlugins?(this.log("tryLoadSdnPlugin started"),this.retry(()=>this.setScriptByLoad(this.container.ownerDocument,this.liveStreamOptions.sdn.url,this.configProvider.playerConfig.nonce)).then(()=>{this.log("SDN script loaded"),this.sdnPluginLoaded=!0,this.log("tryLoadSdnPlugin done")})):(this.log("Loading SDN plugins is not allowed"),Promise.reject("Loading SDN plugins is not allowed"))}createAmp(){this.log("createAmp started"),this.createVideoElement();const c=this.getAmpOptions();if(this.playerInstance=this.contextWindow.amp(this.video.id,c),!this.playerInstance)throw this.log("createAmp failed","error"),new Error("playerInstance is null");this.playerInstance.currentTechName()?.toLowerCase()==="html5"&&this.configProvider.config.ampSettings.estimateAbsoluteTime&&this.isControlsDisabled()?(this.absoluteTimeOffsetEstimator=new hV(this.log.bind(this)),this.diagnosticProvider=new n(this.playerInstance,this.contextWindow,new Date,this.configProvider,this.absoluteTimeOffsetEstimator),this.absoluteTimeOffsetEstimator.setEstimationResultCallback(this.onAbsoluteTimeOffsetEstimation.bind(this))):this.diagnosticProvider=new n(this.playerInstance,this.contextWindow,new Date,this.configProvider);const u={controlsEnabled:!this.isControlsDisabled(),logFn:this.log.bind(this),removeEmptyDefaultTextTrack:this.configProvider.config.removeEmptyDefaultTextTrack};this.diagnosticProvider.setValue("streamingEventType",this.liveStreamOptions.streamingEventType),this.diagnosticProvider.setValue("eventId",this.liveStreamOptions?.eventId||""),this.diagnosticProvider.setValue("templateId",this.liveStreamOptions?.templateId||""),this.diagnosticProvider.setValue("playerControlsEnabled",!this.isControlsDisabled()),this.captionsControl=new a(this.playerInstance,this,u,this.diagnosticProvider),this.registerPlayerEvents(),this.log("createAmp done")}isControlsDisabled(){return this.liveStreamOptions.allowPlayerControls!==void 0?!this.liveStreamOptions.allowPlayerControls:this.liveStreamOptions.streamingEventType==="Overflow"||this.liveStreamOptions.streamingEventType==="TownHall_Basic"||this.liveStreamOptions.streamingEventType==="TownHall_Premium"||this.liveStreamOptions.streamingEventType==="TownHall"}onAbsoluteTimeOffsetEstimation(c){if(this.diagnosticProvider.appendAbsoluteTimeOffsetEstimation(c),!c.isSuccess){const u=this.addEvent("CaptionFunctionalityNotSupported",{detail:{data:{fatal:!0,details:"absolute time offset estimation failed - captions will fail"}}});this.video.dispatchEvent(u)}}addEvent(c,u){let m={};return u?.detail&&(m={detail:u.detail}),new CustomEvent(c,m)}setSource(c){if(this.log("setSource started"),!this.playerInstance)throw this.log("setSource failed: playerInstance is null","error"),new Error("playerInstance is null");this.videoSourceSetAttemptCount++,this.videoSourceSetAttemptCount>0&&this.diagnosticProvider.setValue("retryCount",this.videoSourceSetAttemptCount-1);const u={src:c.url,type:this.videoSourceType,protectionInfo:c.decryptionToken?[{type:"AES",authenticationToken:c.decryptionToken}]:null};this.configureSdnSource(u,c),this.diagnosticProvider.setValue("streamUrl",c.url),this.diagnosticProvider.setValue("streamId",this.getStreamIdFromStreamUrl(c.url)),this.diagnosticProvider.setValue("streamDeliveryPipeline",c.streamDeliveryPipeline||""),this.playerInstance.src([u],this.getTextTracks()),this.absoluteTimeOffsetEstimator&&this.absoluteTimeOffsetEstimator.setManifestFileURL(c.url+"(format=m3u8-aapl-v4)"),this.log("setSource done")}getStreamIdFromStreamUrl(c){try{const u=new URL(c).pathname;if(u){const m=u.split("/");if(m?.length>1)return m[1]}return this.log(`unable to parse stream ID from stream URL: ${c}`,"warn"),""}catch{return this.log(`cannot parse stream ID from invalid stream URL: ${c}`,"warn"),""}}setPlayTime(c){c&&(this.log(`setPlayerTime: ${c}`),this.playerInstance.currentTime(c))}dispose(){this.log("dispose started"),this.diagnosticProvider&&(this.stopStatsCollection(),this.diagnosticProvider.dispose(),this.diagnosticProvider=null),this.captionsControl&&(this.captionsControl.dispose(),this.captionsControl=null),this.playerInstance&&(this.removePlayerEventListeners(),this.playerInstance.getMemoryLog(!0),this.playerInstance.dispose(),this.playerInstance=null),this.eventsHandler.ampDisposed(),this.video&&(this.removeVideoEventListeners(),this.video.parentNode&&this.video.parentNode.removeChild(this.video),this.video=null),this.absoluteTimeOffsetEstimator&&(this.absoluteTimeOffsetEstimator.stopStreamAbsoluteTimeOffsetRetrieval(),this.absoluteTimeOffsetEstimator=null),this.log("dispose done"),this.eventsHandler=null}updatePlaybackDiagnostics(){this.updateTotalPlayingTimeStatistic(),this.updateBufferingRateStatistic(),this.updateVideoTrackHistoryStatistic()}handlePlaybackStopped(){this.isBuffering=!1,this.isPlaying=!1,this.currentVideoPlaybackBitrate=null}showCaptions(c){this.log(`showCaptions: ${c}`),this.captionsControl.showCaptions(c)}addCues(c){c=c.filter(u=>u.text&&u.text.trim().length!==0),this.captionsControl.addCues(c)}clearCues(){this.captionsControl.clearCues()}captionsToggled(c,u,m){this.log(`captionsToggled: ${c} for culture ${u} at ${m}`),this.eventsHandler.message("captionsToggled").send(c,u,m)}createVideoElement(){this.log("createVideoElement started"),this.video=this.container.ownerDocument.createElement("video"),this.video.id="amp-player",this.video.setAttribute("playsinline","");const c=this.configProvider.playerConfig.lang;c&&(this.video.setAttribute("lang",c),this.log(`createVideoElement: language set to ${c}`));const u=this.configProvider.playerConfig.styles;for(let m=0;m<u.length;m++)this.video.classList.add(u[m]);this.container.appendChild(this.video),this.log("createVideoElement done")}getAmpOptions(){const c=[];this.configProvider.config.debug?c.push({target:"memory",maxMemoryTraceCount:this.maxMemoryTraceLogCount}):c.push({target:"console"});const u={TraceTargets:c,maxLogLevel:this.configProvider.config.debug?3:2},m={techOrder:["azureHtml5JS","html5"],nativeControlsForTouch:!1,autoplay:!0,preload:"auto",controls:!this.isControlsDisabled(),logo:{enabled:!1},height:"100%",width:"100%",traceConfig:u,disableFullscreenButton:this.configProvider.playerConfig?.disableFullscreenButton,staleDataTimeLimitInSec:30,heuristicProfile:this.contextWindow.amp.Player.HeuristicProfile.HighQuality,customPlayerSettings:{customHeuristicSettings:{bandwidthTestWithTimeThresholdDuringLive:!1,windowSizeHeuristics:this.configProvider.config.ampSettings.useBrowserWindowSizeForBitRate,useBrowserWindowForWindowSizeRule:this.configProvider.config.ampSettings.useBrowserWindowSizeForBitRate,useVariableFragmentSizeMode:!0}},plugins:{}};return this.initializePluginOptions(m),m}isStreamValid(c){return c&&!!c.url&&!!c.decryptionToken}initializePluginOptions(c){if(!this.sdnPluginLoaded||!this.liveStreamOptions.sdn)return;const u=this.isStreamValid(this.liveStreamOptions.stream)?this.liveStreamOptions.stream:this.liveStreamOptions.altStream;this.log(`initializePluginOptions, receivedSDNContext: ${JSON.stringify(u?.sdnContext)}`,"info");try{const m=this.liveStreamOptions.correlationId||this.playerId;switch(this.liveStreamOptions.sdn.name){case"hive":if(c.plugins={hive:{debugLevel:this.configProvider.config.debug?"debug":"notice",telemetryId:m}},u&&u.sdnContext)try{const b=JSON.parse(u.sdnContext);if(b.sdnConfig){const _=JSON.parse(b.sdnConfig);_.candidateTopicName="RequestIceCandidates",delete _.RTCIceCandidates,Object.assign(c.plugins.hive,_)}}catch(b){this.log(`initializePluginOptions, failed to parse Hive sdnConfig Json from sdnContext Json, error: ${b}`,"warn")}break;case"kollective":if(u&&u.sdnContext){let b=null,_=null,k=null;try{b=this.parseJson(u.sdnContext,"kollective sdn context")}catch(N){this.log(`initializePluginOptions, failed to parse Kollective sdnContext Json, error: ${N}`,"error")}if(b){try{_=this.parseJson(b.playbackinfo,"kollective sdn playback info")}catch(N){this.log(`initializePluginOptions, failed to parse Kollective sdnContext playbackinfo Json, error: ${N}`,"error")}try{k=this.parseJson(b.sdnConfig,"kollective sdn config")}catch(N){this.log(`initializePluginOptions, failed to parse Kollective sdnContext sdnConfig Json, error: ${N}`,"error")}}c.plugins={kollectiveSDN:{playbackInfo:_,sdnConfig:k,reportSessionId:m}}}break;case"ramp":u&&u.sdnContext&&(c.plugins={RampMOPlugin:this.parseJson(u.sdnContext,"ramp sdn context")},this.configProvider.config.debug&&(c.plugins.RampMOPlugin.verbose=!0));break;case"peer5":u.sdnContext&&(c.plugins={peer5:this.parseJson(u.sdnContext,"peer5 sdn context")})}}catch(m){this.log(`initializePluginOptions failed, error: ${m.message}`,"error")}this.log(`initializePluginOptions, configured plugin options: ${JSON.stringify(c.plugins)}`,"info")}getTextTracks(){const c=[];if(this.isControlsDisabled())c.push({id:"amp-player_default",kind:"captions",label:"default-text-track",src:"",srclang:"en"});else if(this.liveStreamOptions.supportedSubtitleLanguages){const u=this.liveStreamOptions.supportedSubtitleLanguages;for(let m=0;m<u.length;m++)c.push({id:`amp-player_${u[m].culture}`,kind:this.configProvider.config.textTrackKind,label:u[m].name||u[m].culture,src:"",srclang:u[m].culture.substr(0,2)})}return c}configureSdnSource(c,u){if(this.sdnPluginLoaded&&this.liveStreamOptions.sdn){switch(this.liveStreamOptions.sdn.name){case"hive":if(!u.sdnContext){c.sdnList=[];break}try{const m=JSON.parse(u.sdnContext);m.playbackinfo&&(c.sdnList=[{sdnName:"hive",sdnUrl:m.playbackinfo}])}catch{c.sdnList=[{sdnName:"hive",sdnUrl:u.sdnContext}]}break;case"kollective":if(!u.sdnContext){c.sdnList=[];break}try{const m=this.parseJson(u.sdnContext,"kollective sdn list context"),b=this.parseJson(m.playbackinfo,"kollective sdn list playback info"),_=this.parseJson(m.sdnConfig,"kollective sdn list sdn config");c.sdnList=[{sdnName:"kollectiveSDN",playbackInfo:b,sdnConfig:_}]}catch(m){return c.sdnList=[],void this.log(`configureSdnSource failed, error: ${m}`,"error")}break;case"ramp":case"peer5":c.sdnList=[];break;default:return}this.log(`configureSdnSource, configured source context: ${JSON.stringify(c)}`,"info")}}registerPlayerEvents(){this.registerPlayerEvent(this.contextWindow.amp.eventName.error,()=>{this.onAmpEvent(this.contextWindow.amp.eventName.error)}),this.registerPlayerEvent(this.contextWindow.amp.eventName.canplaythrough,()=>{this.onAmpEvent(this.contextWindow.amp.eventName.canplaythrough)}),this.registerPlayerEvent(this.contextWindow.amp.eventName.play,()=>{this.onAmpEvent(this.contextWindow.amp.eventName.play)}),this.registerPlayerEvent(this.contextWindow.amp.eventName.playing,()=>{this.onAmpEvent(this.contextWindow.amp.eventName.playing)}),this.registerPlayerEvent(this.contextWindow.amp.eventName.pause,()=>{this.onAmpEvent(this.contextWindow.amp.eventName.pause)}),this.registerPlayerEvent(this.contextWindow.amp.eventName.resume,()=>{this.onAmpEvent(this.contextWindow.amp.eventName.resume)}),this.registerPlayerEvent(this.contextWindow.amp.eventName.start,()=>{this.onAmpEvent(this.contextWindow.amp.eventName.start)}),this.registerPlayerEvent(this.contextWindow.amp.eventName.ended,()=>{this.onAmpEvent(this.contextWindow.amp.eventName.ended)}),this.registerPlayerEvent(this.contextWindow.amp.eventName.seeking,()=>{this.onAmpEvent(this.contextWindow.amp.eventName.seeking)}),this.registerPlayerEvent(this.contextWindow.amp.eventName.seeked,()=>{this.onAmpEvent(this.contextWindow.amp.eventName.seeked)}),this.registerPlayerEvent(this.contextWindow.amp.eventName.loadedmetadata,()=>{this.onAmpEvent(this.contextWindow.amp.eventName.loadedmetadata)}),this.registerPlayerEvent(this.contextWindow.amp.eventName.waiting,()=>{this.onAmpEvent(this.contextWindow.amp.eventName.waiting)}),this.registerPlayerEvent(this.contextWindow.amp.eventName.playbackbitratechanged,()=>{this.onAmpEvent(this.contextWindow.amp.eventName.playbackbitratechanged)}),this.registerPlayerEvent(this.contextWindow.amp.eventName.downloadbitratechanged,()=>{this.onAmpEvent(this.contextWindow.amp.eventName.downloadbitratechanged)}),this.registerPlayerEvent(this.contextWindow.amp.eventName.fullscreenchange,()=>{this.onAmpEvent(this.contextWindow.amp.eventName.fullscreenchange)}),this.registerPlayerEvent("potentialMediaFreeze",()=>{this.onAmpEvent("potentialMediaFreeze")}),this.registerPlayerEvent(this.contextWindow.amp.eventName.mute,()=>{this.onAmpEvent(this.contextWindow.amp.eventName.mute)}),this.registerPlayerEvent(this.contextWindow.amp.eventName.unmute,()=>{this.onAmpEvent(this.contextWindow.amp.eventName.unmute)}),this.registerPlayerEvent(this.contextWindow.amp.eventName.volumechange,()=>{this.onAmpEvent(this.contextWindow.amp.eventName.volumechange)}),this.registerPlayerEvent(this.contextWindow.amp.eventName.loadeddata,()=>{this.onAmpEvent(this.contextWindow.amp.eventName.loadeddata)}),this.registerPlayerEvent(this.contextWindow.amp.eventName.loadstart,()=>{this.onAmpEvent(this.contextWindow.amp.eventName.loadstart)}),Object.values(s).forEach(c=>{this.registerVideoEvent(c,u=>{this.handleUserExperienceErrorEvent(c,u.detail.data.details,u.detail.data.fatal)})}),this.configProvider.config.ampSettings.collectUserInitiatedSeekEventsTelemetry&&(this.playerEvents.push("currentTimeChanging"),this.playerInstance.addEventListener("currentTimeChanging",(c,u)=>this.onAmpCurrentTimeChangingEvent(c,u)))}onAmpCurrentTimeChangingEvent(c,u){if(c.type!=="currentTimeChanging"||!u.time)return;const m={newCurrentPlayPosition:u.time};this.eventsHandler.message("stateChanged").send("UserInitiatedSeek",m)}registerPlayerEvent(c,u){this.playerEvents.push(c),this.playerInstance.addEventListener(c,u)}registerVideoEvent(c,u){this.videoElementEvents.push({name:c,callback:u}),this.video.addEventListener(c,u)}removePlayerEventListeners(){this.playerEvents.forEach(c=>{this.playerInstance.removeEventListener(c)})}removeVideoEventListeners(){this.videoElementEvents.forEach(c=>{this.video.removeEventListener(c.name,c.callback)})}onAmpEvent(c){let u,m;switch(c){case this.contextWindow.amp.eventName.error:m=this.playerInstance.error(),u={currentTime:this.playerInstance.currentTime(),errorCode:m?m.code:0,message:m?m.message:""};break;case this.contextWindow.amp.eventName.canplaythrough:this.initializeStatsColletion();break;case this.contextWindow.amp.eventName.loadedmetadata:this.captionsControl.initialize(),this.absoluteTimeOffsetEstimator&&this.absoluteTimeOffsetEstimator.restartStreamAbsoluteTimeOffsetRetrieval();break;case this.contextWindow.amp.eventName.fullscreenchange:u={isFullscreen:this.playerInstance.isFullscreen()};break;case this.contextWindow.amp.eventName.playbackbitratechanged:u={bitrate:this.playerInstance.currentPlaybackBitrate()};break;case this.contextWindow.amp.eventName.downloadbitratechanged:u={bitrate:this.playerInstance.currentDownloadBitrate()};break;case this.contextWindow.amp.eventName.seeked:u={captionsTimestamp:this.isControlsDisabled()?this.playerInstance.currentMediaTime():this.playerInstance.currentTime()};break;case this.contextWindow.amp.eventName.volumechange:u={value:this.playerInstance.volume()}}this.updatePlaybackDiagnostics(),this.updatePlayerState(c),this.eventsHandler.message("statsUpdated").send(this.getPlayerDiagnostics()),this.eventsHandler.message("stateChanged").send(c,u)}updatePlayerState(c){this.updatePlayingState(c),this.updateBufferingState(c),this.updateCurrentVideoTrackBitrate(c),c!==this.contextWindow.amp.eventName.ended&&c!==this.contextWindow.amp.eventName.error||this.handlePlaybackStopped()}handleUserExperienceErrorEvent(c,u,m){const b={currentTime:this.video?this.video.currentTime:0,message:u,type:c,errorCode:0,fatal:m};this.updatePlaybackDiagnostics(),this.eventsHandler.message("statsUpdated").send(this.getPlayerDiagnostics()),this.eventsHandler.message("stateChanged").send(this.contextWindow.amp.eventName.error,b)}updatePlayingState(c){this.isPlaying?c!==this.contextWindow.amp.eventName.pause&&c!==this.contextWindow.amp.eventName.seeking&&c!==this.contextWindow.amp.eventName.ended&&c!==this.contextWindow.amp.eventName.error&&c!==this.contextWindow.amp.eventName.waiting||(this.isPlaying=!1):c===this.contextWindow.amp.eventName.playing&&(this.isPlaying=!0)}updateBufferingState(c){this.isBuffering?(c===this.contextWindow.amp.eventName.pause&&this.playerInstance.currentTechName()?.toLowerCase()==="html5"||c===this.contextWindow.amp.eventName.seeking||c===this.contextWindow.amp.eventName.ended||c===this.contextWindow.amp.eventName.error||c===this.contextWindow.amp.eventName.playing)&&(this.isBuffering=!1):c===this.contextWindow.amp.eventName.waiting&&(this.isBuffering=!0)}updateCurrentVideoTrackBitrate(c){c===this.contextWindow.amp.eventName.playbackbitratechanged&&this.playerInstance.currentPlaybackBitrate()!==this.currentVideoPlaybackBitrate&&(this.currentVideoPlaybackBitrate=this.playerInstance.currentPlaybackBitrate(),this.updateVideoTrackHistoryStatistic())}initializeStatsColletion(){this.diagnosticProvider.initialize(),this.statsTimer=window.setInterval(()=>{this.eventsHandler&&(this.updatePlaybackDiagnostics(),this.eventsHandler.message("statsUpdated").send(this.getPlayerDiagnostics()))},this.statsInterval)}stopStatsCollection(){this.updatePlaybackDiagnostics(),this.eventsHandler.message("statsUpdated").send(this.getPlayerDiagnostics()),this.statsTimer!==-1&&window.clearInterval(this.statsTimer),this.statsTimer=-1}updateVideoTrackHistoryStatistic(){const c=new Date;if(this.currentVideoPlaybackBitrate){const u=this.diagnosticProvider.getValue("videoTrackHistory"),m=this.diagnosticProvider.getValue("videoTrackTotalDurations");if(u.length>0&&this.currentVideoPlaybackBitrate===u[u.length-1].trackPlaybackBitrate){if(this.videoTrackHistoryUpdatedTimestamp){this.latestVideoTrackDuration+=(c.getTime()-this.videoTrackHistoryUpdatedTimestamp.getTime())/1e3,u[u.length-1].durationInSeconds=Number(this.latestVideoTrackDuration.toFixed(0));const b=this.videoTrackTotalDurations.find(k=>k.trackPlaybackBitrate===this.currentVideoPlaybackBitrate),_=m.find(k=>k.trackPlaybackBitrate===this.currentVideoPlaybackBitrate);b&&_&&(b.totalDurationInSeconds+=(c.getTime()-this.videoTrackHistoryUpdatedTimestamp.getTime())/1e3,_.totalDurationInSeconds=Number(b.totalDurationInSeconds.toFixed(0)))}}else{const b=this.playerInstance.videoBufferData();let _=null;if(b&&b.perceivedBandwidth&&(_=b.perceivedBandwidth),u.push({trackPlaybackBitrate:this.currentVideoPlaybackBitrate,trackSwitchTimestamp:c.getTime(),trackSwitchMeasuredBandwidth:this.diagnosticProvider?this.diagnosticProvider.getAverageMeasuredBandwidth():null,trackSwitchMeasuredByteSize:this.diagnosticProvider?this.diagnosticProvider.getAverageMeasuredVideoDownloadSize():null,trackSwitchPerceivedBandwidth:_,durationInSeconds:0}),this.latestVideoTrackDuration=0,u.length>this.configProvider.config.maxVideoTrackHistoryLogCount&&u.splice(0,1),!this.videoTrackTotalDurations.find(N=>N.trackPlaybackBitrate===this.currentVideoPlaybackBitrate)){const N={trackPlaybackBitrate:this.currentVideoPlaybackBitrate,totalDurationInSeconds:0},W={trackPlaybackBitrate:this.currentVideoPlaybackBitrate,totalDurationInSeconds:0};this.videoTrackTotalDurations.push(N),m.push(W)}}}this.videoTrackHistoryUpdatedTimestamp=c}updateTotalPlayingTimeStatistic(){const c=new Date;this.isPlaying&&this.totalPlayingTimeUpdatedTimestamp&&(this.totalPlayingTime+=c.getTime()-this.totalPlayingTimeUpdatedTimestamp.getTime()),this.totalPlayingTimeUpdatedTimestamp=c,this.diagnosticProvider.setValue("totalPlayingTimeInSeconds",Number((this.totalPlayingTime/1e3).toFixed(0)))}updateBufferingRateStatistic(){const c=new Date;this.isBuffering&&this.bufferingRateStatUpdatedTimestamp&&(this.totalBufferingTime+=c.getTime()-this.bufferingRateStatUpdatedTimestamp.getTime()),this.bufferingRateStatUpdatedTimestamp=c;const u=this.totalPlayingTime>0||this.totalBufferingTime>0?this.totalBufferingTime/(this.totalPlayingTime+this.totalBufferingTime):0;this.diagnosticProvider.setValue("bufferingRate",Number(u.toFixed(3)))}getPlayerDiagnostics(){const c=this.diagnosticProvider.getPlayerDiagnosticSnapshot();return c.statsInterval=this.statsInterval,this.configProvider.config.debug&&(c.memoryLog=this.playerInstance.getMemoryLog(!0)),c}log(c,u="info"){const m=`[AmpPlayer${this.configProvider.config.loadType===1?"IFrame":""}]: ${c}`;this.configProvider.config.debug&&console.log(m),this.eventsHandler.message("log").send(u,m)}getElementLoadPromise(c,u){return new Promise((m,b)=>{c.onload=()=>{m("Element Load success")},c.onerror=()=>{b(`Failed to load script: ${u}`)}})}loadCss(c,u,m){const b=c.createElement("link"),_=this.getElementLoadPromise(b,u);return b.href=u,b.rel="stylesheet",m&&(b.nonce=m),c.head.appendChild(b),_}parseJson(c,u){try{return JSON.parse(c)}catch(m){throw this.log(`Error parsing JSON for ${u}, error: ${JSON.stringify(m)}`),m}}}}function hp(){const n=Sf();return class{constructor(a,s){this.pipe=a,this.amp=new n(s,this)}processMessage(a){a.msgType==="Command"&&Promise.resolve().then(()=>this.amp[a.cmd].apply(this.amp,a.args)).then(s=>{this.pipe&&this.pipe.sendMsg({msgType:"CommandResult",cmd:a.cmd,result:JSON.stringify(s)})}).catch(s=>{this.pipe&&this.pipe.sendMsg({msgType:"CommandResult",cmd:a.cmd,error:s})})}message(a){return{send:this.fromMessage((...s)=>{this.sendMessageImpl(a,s)})}}ampDisposed(){this.pipe.dispose(),this.pipe=null,this.amp=null}fromMessage(a){return a}sendMessageImpl(a,s){this.pipe.sendMsg({msgType:"PlayerNotification",name:a,args:s})}}}Sf();var oC=hp();function nw(){function n(s){return s.msgType==="CommandResult"}function a(s){let c="unknown";try{c=typeof s=="string"?s:"toString"in s&&s.toString().indexOf("[object")!==0?s.toString():JSON.stringify(s)}catch{console.error("Failed to stringify error",s)}return c}return class{constructor(){this.processMsg=this.processMsg.bind(this),window.addEventListener("message",this.processMsg)}sendMsg(s){try{let c=s;n(s)&&s.error instanceof Event&&(console.debug("Stringifying error Event before trying to postMessage:",s),c={msgType:s.msgType,cmd:s.cmd,error:`Event: ${a(s.error)}`}),this.postMessage(c)}catch(c){console.error(`Unexpected exception caught from postMessage.
`,"message:",s,`
`,"exception:",c);const u={msgType:"PlayerNotification",name:"log",args:["error",`Unexpected error with postMessage: ${a(c)}`]};throw this.postMessage(u),c}}registerObserver(s){this.observer=s}dispose(){window.removeEventListener("message",this.processMsg),this.observer=null}processMsg(s){this.observer.processMessage(s.data)}postMessage(s){window.parent.postMessage(s,"*")}}}function AD(){const n=dN();return class{constructor(a){this.playlistFileDownloadPromise=Promise.resolve(),this.playlistFileDownloadRetryWaitTime=250,this.playlistFileDownloadMaxRetryCount=20,this.playlistFileDownloadCancellationFlag=!1,this.logFn=(s,c)=>a(`[HlsAbsoluteTimeOffsetEstimator]: ${s}`,c),this.hlsFileParser=new n(a)}get absoluteTimeOffset(){return this.estimatedAbsoluteTimeOffset}setEstimationResultCallback(a){this.onAbsoluteTimeOffsetEstimation=a}restartStreamAbsoluteTimeOffsetRetrieval(){this.stopStreamAbsoluteTimeOffsetRetrieval().then(()=>this.startStreamAbsoluteTimeOffsetRetrieval())}setManifestFileURL(a){this.cachedManifestUrl=a}startStreamAbsoluteTimeOffsetRetrieval(){this.playlistFileDownloadPromise=this.retryPlaylistFileDownload(()=>this.estimateStreamTimeFromPlaylist(this.currentManifestUrl)).then(()=>{this.logFn(`Succeeded in downloading playlist files to estimate
                    absolute stream time offset as: ${this.estimatedAbsoluteTimeOffset}`)}).catch(a=>{this.logFn(`Failed to download playlist files to estimate absolute stream time offset: ${a.message}`,"error")})}stopStreamAbsoluteTimeOffsetRetrieval(){return this.playlistFileDownloadCancellationFlag=!0,this.playlistFileDownloadPromise.then(()=>{this.playlistFileDownloadCancellationFlag=!1,this.currentManifestUrl=this.cachedManifestUrl,this.cachedManifestUrl=null})}retryPlaylistFileDownload(a,s=0){let c=Promise.resolve();return c=a().then(()=>(this.onAbsoluteTimeOffsetEstimation&&this.onAbsoluteTimeOffsetEstimation({timestamp:Date.now(),retries:s,isSuccess:!0,absoluteTimeOffsetEstimation:this.absoluteTimeOffset}),Promise.resolve())).catch(u=>(s++,this.logFn(`Error loading playlist file: ${u} -- attempt ${s}`),this.onAbsoluteTimeOffsetEstimation&&this.onAbsoluteTimeOffsetEstimation({timestamp:Date.now(),retries:s,isSuccess:!1,error:u.message}),s===this.playlistFileDownloadMaxRetryCount?Promise.reject(new Error(`${u} after ${s} attempts`)):this.playlistFileDownloadCancellationFlag?Promise.reject(new Error("cancelling playlist file download")):new Promise(m=>setTimeout(()=>m(this.retryPlaylistFileDownload(a,s)),this.playlistFileDownloadRetryWaitTime)))),c}estimateStreamTimeFromPlaylist(a){return this.hlsFileParser.getStreamRenditionsUrlsFromManifest(a).then(s=>{if(s.audioRenditions.length===0&&s.videoRenditions.length===0)throw new Error(`Unable to retrieve renditions URLs from manifest: ${a}`);return Promise.all([s.videoRenditions.length>0?this.hlsFileParser.getTextFileContent(s.videoRenditions[0]):Promise.resolve(null),s.audioRenditions.length>0?this.hlsFileParser.getTextFileContent(s.audioRenditions[0]):Promise.resolve(null)])}).then(s=>{let c;for(let u=0;u<s.length;u++){const m=s[u];if(m){this.logFn("Using segment duration and sequence number to calculate absolute time offset","debug");const b=this.hlsFileParser.getHlsFieldByName("SequenceNumber",m);if(b.length==0)throw new Error("Unable to retrieve sequence number from playlist file");const _=this.hlsFileParser.getHlsFieldByName("SegmentDuration",m,10);if(_.length==0)throw new Error("Unable to retrieve segment durations from playlist file");const k=_.map(Number);k.sort((ee,oe)=>ee-oe);const N=k[Math.floor(k.length/2)],W=Number(b[0])*Number(N);c=c?Math.max(c,W):W}}this.estimatedAbsoluteTimeOffset=c})}}}var hV=AD();function dN(){return class{constructor(n){this.fieldNameRegexMap={BaseUrl:/(.*)\/.*/,AudioManifestFile:/#EXT-X-MEDIA:TYPE=AUDIO.*URI=\"(.*)\"/,SequenceNumber:/#EXT-X-MEDIA-SEQUENCE:(\d+)/,SegmentDuration:/#EXTINF:(\d+(\.\d+)?)/},this.logFn=(a,s)=>n(`[HlsFileParser]: ${a}`,s)}getHlsFieldByName(n,a,s=1){const c=[];for(let u=1;u<=s;u++){const m=this.fieldNameRegexMap[n].exec(a);if(!(m&&m.length>0))break;c.push(m[1]),a=a.substring(m.index+m[0].length)}return c}getStreamRenditionsUrlsFromManifest(n){return n?this.getTextFileContent(n).then(a=>{const s={audioRenditions:[],videoRenditions:[]},c=a.split(`
`),u=this.getHlsFieldByName("BaseUrl",n);for(let m=0;m<c.length;m++)if(c[m].includes("#EXT-X-STREAM-INF")){const b=c[m+1];b.includes("http")?s.videoRenditions.push(b):u.length>0&&s.videoRenditions.push(`${u[0]}/${b}`)}else if(c[m].includes("EXT-X-MEDIA:TYPE")){const b=this.getHlsFieldByName("AudioManifestFile",c[m]);if(b.length>0){const _=b[0];_.includes("http")?s.audioRenditions.push(_):u.length>0&&s.audioRenditions.push(`${u[0]}/${_}`)}}return s}).catch(a=>(this.logFn(`Failed to extract stream renditions from manifest, error: ${a.message}`,"error"),{audioRenditions:[],videoRenditions:[]})):(this.logFn("No manifest URL provided to parse"),Promise.resolve({audioRenditions:[],videoRenditions:[]}))}getTextFileContent(n){return fetch(n).then(s=>{if(!s.ok)throw new Error(`http-error ${s.status} when downloading: ${n}`);return s.text()}).catch(s=>(this.logFn(`Error downloading resource: ${s}`,"error"),Promise.reject(s)))}}}function Y_(){return class{constructor(n,a,s,c,u){this.playerInstance=n,this.contextWindow=a,this.streamingStartedTimestamp=s,this.configProvider=c,this.absoluteTimeOffsetEstimator=u,this.currentDiagnosticSnapshot={playerType:0,currentPlayPosition:null,tech:null,perceivedBandwidth:null,playerHeight:null,playerWidth:null,mediaHeight:null,mediaWidth:null,windowHeight:null,windowWidth:null,videoStream:null,audioStream:null,totalDurationInSeconds:null,avgVideoDownloadLatency:null,avgAudioDownloadLatency:null,avgVideoDownloadBytes:null,avgAudioDownloadBytes:null,avgAudioDownloadBandwidth:null,avgVideoDownloadBandwidth:null,maxVideoDownloadBytes:null,minVideoDownloadBytes:null,videoDownloadSuccessCount:null,audioDownloadSuccessCount:null,videoDownloadFailureCount:null,audioDownloadFailureCount:null,videoBufferLength:null,videoCachedLength:null,audioBufferLength:null,audioCachedLength:null,videoEdgeLatency:null,audioEdgeLatency:null,playbackRate:null,playbackBitrate:null,downloadBitrate:null,audioDownloadBitrate:null,audioPlaybackBitrate:null,isFullscreen:null,streamType:null,playerVersion:null,isP2PSdnUsed:null,sdnName:null,livePosition:null,muted:null,volume:null,errorCode:null,currentMediaTime:null,currentAbsoluteTime:null,absoluteTimeOffsetEstimationResults:null,estimatedAbsoluteTimeOffset:null,videoDownloadFailures:null,audioDownloadFailures:null,heuristicProfile:null,encryption:null,retryFrequency:null,averageDownloadBitrate:null,totalDownloadedBytes:0,streamId:null,streamUrl:null,streamingEventType:null,playerControlsEnabled:null,streamDeliveryPipeline:null,retryCount:0,totalPlayingTimeInSeconds:0,bufferingRate:0,videoTrackHistory:[],videoTrackTotalDurations:[],memoryLog:null,statsInterval:null},this.videoDownloadLatencies=[],this.audioDownloadLatencies=[],this.audioDownloadBytes=[],this.videoDownloadBytes=[],this.audioDownloadBandwidths=[],this.videoDownloadBandwidths=[],this.videoDownloadSuccessCount=0,this.audioDownloadSuccessCount=0,this.videoDownloadFailureCount=0,this.audioDownloadFailureCount=0,this.audioDownloadFailures=[],this.videoDownloadFailures=[],this.totalDownloadedBytes=0,this.slidingWindowLengthForLatency=5,this.slidingWindowLengthForDownloadBytes=30,this.slidingWindowLengthForDownloadBandwidth=10,this.absoluteTimeOffsetEstimationResults=[],this.downloadFailuresLimit=10,this.onAudioDownloadCompleted=this.onAudioDownloadCompleted.bind(this),this.onAudioDownloadError=this.onAudioDownloadError.bind(this),this.onVideoDownloadCompleted=this.onVideoDownloadCompleted.bind(this),this.onVideoDownloadError=this.onVideoDownloadError.bind(this)}initialize(){this.playerVideoBuffer=this.playerInstance.videoBufferData(),this.playerAudioBuffer=this.playerInstance.audioBufferData(),this.registerForPlayerBufferEvents()}setValue(n,a){this.currentDiagnosticSnapshot[n]=a}getValue(n){return this.currentDiagnosticSnapshot[n]}appendAbsoluteTimeOffsetEstimation(n){this.absoluteTimeOffsetEstimationResults.push(n),this.absoluteTimeOffsetEstimationResults.length>this.configProvider.config.ampSettings.maxAbsoluteTimeOffsetEstimationResultsLogCount&&this.absoluteTimeOffsetEstimationResults.splice(0,1)}getPlayerDiagnosticSnapshot(){if(!this.playerInstance)return null;const n=window.screen,a=this.playerInstance.error(),s=b=>{const _=b.slice().sort();return _[Math.floor(_.length/2)]};this.currentDiagnosticSnapshot.errorCode=a&&a.code||0,this.currentDiagnosticSnapshot.currentPlayPosition=this.playerInstance.currentTime(),this.currentDiagnosticSnapshot.currentMediaTime=this.playerInstance.currentMediaTime()??this.playerInstance.currentTime(),this.currentDiagnosticSnapshot.currentAbsoluteTime=this.getCurrentAbsoluteTime(),this.currentDiagnosticSnapshot.absoluteTimeOffsetEstimationResults=this.absoluteTimeOffsetEstimationResults,this.currentDiagnosticSnapshot.estimatedAbsoluteTimeOffset=this.getCurrentAbsoluteTimeOffset(),this.currentDiagnosticSnapshot.playbackBitrate=this.playerInstance.currentPlaybackBitrate(),this.currentDiagnosticSnapshot.downloadBitrate=this.playerInstance.currentDownloadBitrate(),this.currentDiagnosticSnapshot.audioDownloadBitrate=this.lastAudioDownloadBitrate,this.currentDiagnosticSnapshot.perceivedBandwidth=this.playerVideoBuffer?this.playerVideoBuffer.perceivedBandwidth:0,this.currentDiagnosticSnapshot.tech=this.playerInstance.currentTechName(),this.currentDiagnosticSnapshot.playerVersion=this.playerInstance.getAmpVersion(),this.currentDiagnosticSnapshot.isP2PSdnUsed=this.isP2PSdnUsed(),this.currentDiagnosticSnapshot.sdnName=this.sdnName(),this.currentDiagnosticSnapshot.heuristicProfile=this.playerInstance.currentHeuristicProfile(),this.currentDiagnosticSnapshot.encryption=this.playerInstance.currentProtectionInfo()?this.playerInstance.currentProtectionInfo().type:"",this.currentDiagnosticSnapshot.streamType=this.getStreamType(this.currentDiagnosticSnapshot.streamType),this.currentDiagnosticSnapshot.totalDurationInSeconds=this.getTotalDurationInSeconds(),this.currentDiagnosticSnapshot.audioStream=this.getAudioStreamData(),this.currentDiagnosticSnapshot.videoStream=this.getVideoStreamData(),this.currentDiagnosticSnapshot.muted=this.playerInstance.muted(),this.currentDiagnosticSnapshot.volume=this.playerInstance.volume(),this.currentDiagnosticSnapshot.playbackRate=this.playerInstance.playbackRate();const c=this.getPlayerCachedLength(),u=this.getPlayerEdgeLatency();this.currentDiagnosticSnapshot.audioBufferLength=this.playerAudioBuffer?this.playerAudioBuffer.bufferLevel:0,this.currentDiagnosticSnapshot.audioCachedLength=c,this.currentDiagnosticSnapshot.audioEdgeLatency=u,this.currentDiagnosticSnapshot.videoBufferLength=this.playerVideoBuffer?this.playerVideoBuffer.bufferLevel:0,this.currentDiagnosticSnapshot.videoCachedLength=c,this.currentDiagnosticSnapshot.videoEdgeLatency=u,this.currentDiagnosticSnapshot.livePosition=this.getLivePosition(),this.currentDiagnosticSnapshot.mediaHeight=this.playerInstance.videoHeight(),this.currentDiagnosticSnapshot.mediaWidth=this.playerInstance.videoWidth(),this.currentDiagnosticSnapshot.playerHeight=this.playerInstance.height(),this.currentDiagnosticSnapshot.playerWidth=this.playerInstance.width(),this.currentDiagnosticSnapshot.windowHeight=n?n.height:0,this.currentDiagnosticSnapshot.windowWidth=n?n.width:0,this.currentDiagnosticSnapshot.isFullscreen=this.playerInstance.isFullscreen(),this.currentDiagnosticSnapshot.avgAudioDownloadLatency=s(this.audioDownloadLatencies),this.currentDiagnosticSnapshot.avgVideoDownloadLatency=s(this.videoDownloadLatencies),this.currentDiagnosticSnapshot.avgAudioDownloadBytes=s(this.audioDownloadBytes),this.currentDiagnosticSnapshot.avgVideoDownloadBytes=s(this.videoDownloadBytes),this.currentDiagnosticSnapshot.maxVideoDownloadBytes=Math.max.apply(null,this.videoDownloadBytes),this.currentDiagnosticSnapshot.minVideoDownloadBytes=Math.min.apply(null,this.videoDownloadBytes),this.currentDiagnosticSnapshot.avgAudioDownloadBandwidth=s(this.audioDownloadBandwidths),this.currentDiagnosticSnapshot.avgVideoDownloadBandwidth=s(this.videoDownloadBandwidths),this.currentDiagnosticSnapshot.audioDownloadFailureCount=this.audioDownloadFailureCount,this.currentDiagnosticSnapshot.audioDownloadSuccessCount=this.audioDownloadSuccessCount,this.currentDiagnosticSnapshot.videoDownloadFailureCount=this.videoDownloadFailureCount,this.currentDiagnosticSnapshot.videoDownloadSuccessCount=this.videoDownloadSuccessCount,this.currentDiagnosticSnapshot.audioDownloadFailures=this.audioDownloadFailures,this.currentDiagnosticSnapshot.videoDownloadFailures=this.videoDownloadFailures,this.currentDiagnosticSnapshot.totalDownloadedBytes=this.totalDownloadedBytes,this.currentDiagnosticSnapshot.retryFrequency=this.getRetryFrequency(),this.currentDiagnosticSnapshot.averageDownloadBitrate=this.getAverageDownloadBitrate();const m=this.getDiagnosticWritableField();return Object.keys(m).forEach(b=>{this.currentDiagnosticSnapshot[b]=m[b]}),this.currentDiagnosticSnapshot}getDiagnosticWritableField(){return{streamUrl:this.currentDiagnosticSnapshot.streamUrl,streamId:this.currentDiagnosticSnapshot.streamId,streamingEventType:this.currentDiagnosticSnapshot.streamingEventType,playerControlsEnabled:this.currentDiagnosticSnapshot.playerControlsEnabled,streamDeliveryPipeline:this.currentDiagnosticSnapshot.streamDeliveryPipeline,retryCount:this.currentDiagnosticSnapshot.retryCount,totalPlayingTimeInSeconds:this.currentDiagnosticSnapshot.totalPlayingTimeInSeconds,bufferingRate:this.currentDiagnosticSnapshot.bufferingRate,videoTrackHistory:this.currentDiagnosticSnapshot.videoTrackHistory,videoTrackTotalDurations:this.currentDiagnosticSnapshot.videoTrackTotalDurations,eventId:this.currentDiagnosticSnapshot.eventId||"",templateId:this.currentDiagnosticSnapshot.templateId||""}}dispose(){this.unsubscribeFromPlayerBufferEvents()}registerForPlayerBufferEvents(){this.playerVideoBuffer&&(this.playerVideoBuffer.addEventListener(this.contextWindow.amp.bufferDataEventName.downloadcompleted,this.onVideoDownloadCompleted),this.playerVideoBuffer.addEventListener(this.contextWindow.amp.bufferDataEventName.downloadfailed,this.onVideoDownloadError)),this.playerAudioBuffer&&(this.playerAudioBuffer.addEventListener(this.contextWindow.amp.bufferDataEventName.downloadcompleted,this.onAudioDownloadCompleted),this.playerAudioBuffer.addEventListener(this.contextWindow.amp.bufferDataEventName.downloadfailed,this.onAudioDownloadError))}unsubscribeFromPlayerBufferEvents(){this.playerVideoBuffer&&(this.playerVideoBuffer.removeEventListener(this.contextWindow.amp.bufferDataEventName.downloadcompleted,this.onVideoDownloadCompleted),this.playerVideoBuffer.removeEventListener(this.contextWindow.amp.bufferDataEventName.downloadfailed,this.onVideoDownloadError)),this.playerAudioBuffer&&(this.playerAudioBuffer.removeEventListener(this.contextWindow.amp.bufferDataEventName.downloadcompleted,this.onAudioDownloadCompleted),this.playerAudioBuffer.removeEventListener(this.contextWindow.amp.bufferDataEventName.downloadfailed,this.onAudioDownloadError))}isP2PSdnUsed(){return!!this.sdnName()}sdnName(){const n="options_";return this.playerInstance[n]&&this.playerInstance[n].sdn&&this.playerInstance[n].sdn.name}getStreamType(n){let a="";return this.playerInstance&&(a=this.playerInstance.isLive()?"LIVE":"DVR"),a===""||n==="LIVE"&&a!==n?n||"":a}getCurrentAbsoluteTime(){return this.absoluteTimeOffsetEstimator?this.absoluteTimeOffsetEstimator.absoluteTimeOffset?this.absoluteTimeOffsetEstimator.absoluteTimeOffset+this.playerInstance.currentTime():this.playerInstance.currentTime():this.playerInstance.currentAbsoluteTime()??this.playerInstance.currentTime()}getCurrentAbsoluteTimeOffset(){return this.getCurrentAbsoluteTime()-this.playerInstance.currentTime()}getTotalDurationInSeconds(){const n=(new Date().getTime()-this.streamingStartedTimestamp.getTime())/1e3;return Number(n.toFixed(0))}onVideoDownloadCompleted(){this.videoDownloadSuccessCount++,this.addToList(this.videoDownloadLatencies,this.playerVideoBuffer.downloadCompleted.totalDownloadMs,this.slidingWindowLengthForLatency),this.addToList(this.videoDownloadBytes,this.playerVideoBuffer.downloadCompleted.totalBytes,this.slidingWindowLengthForDownloadBytes),this.addToList(this.videoDownloadBandwidths,8*this.playerVideoBuffer.downloadCompleted.totalBytes*1e3/this.playerVideoBuffer.downloadCompleted.totalDownloadMs,this.slidingWindowLengthForDownloadBandwidth),this.totalDownloadedBytes+=this.playerVideoBuffer.downloadCompleted.totalBytes}onAudioDownloadCompleted(){this.audioDownloadSuccessCount++,this.addToList(this.audioDownloadLatencies,this.playerAudioBuffer.downloadCompleted.totalDownloadMs,this.slidingWindowLengthForLatency),this.addToList(this.audioDownloadBytes,this.playerAudioBuffer.downloadCompleted.totalBytes,this.slidingWindowLengthForDownloadBytes),this.addToList(this.audioDownloadBandwidths,8*this.playerAudioBuffer.downloadCompleted.totalBytes*1e3/this.playerAudioBuffer.downloadCompleted.totalDownloadMs,this.slidingWindowLengthForDownloadBandwidth),this.totalDownloadedBytes+=this.playerAudioBuffer.downloadCompleted.totalBytes;const n=this.playerAudioBuffer.downloadCompleted.mediaDownload.bitrate;n!==this.lastAudioDownloadBitrate&&(this.lastAudioDownloadBitrate=n)}addToList(n,a,s){n.push(a),n.length>s&&n.shift()}onVideoDownloadError(){this.videoDownloadFailureCount++,this.addDownloadFailureInfo(this.playerVideoBuffer.downloadFailed,this.videoDownloadFailures)}onAudioDownloadError(){this.audioDownloadFailureCount++,this.addDownloadFailureInfo(this.playerAudioBuffer.downloadFailed,this.audioDownloadFailures)}addDownloadFailureInfo(n,a){const s={bitrate:n.mediaDownload.bitrate,errorCode:n.code,mediaTime:n.mediaDownload.mediaTime,message:n.message,timestamp:Date.now()};this.addToList(a,s,this.downloadFailuresLimit)}getAudioStreamData(){const n=this.playerInstance.currentAudioStreamList();if(n)try{const a=n.streams[n.enabledIndices[0]];return{bitrate:a.bitrate,codec:a.codec,enabled:a.enabled,name:a.name,language:a.language}}catch{return}}getVideoStreamData(){const n=this.playerInstance.currentVideoStreamList();if(n)try{const a=n.streams[n.selectedIndex],s=this.playerInstance.currentPlaybackBitrate(),c=m=>({bitrate:m.bitrate,height:m.height,id:m.id,selectable:m.selectable,width:m.width}),u=a.tracks?a.tracks.map(c).find(m=>m.bitrate===s):null;return{codec:a.codec,name:a.name,currentTrack:u}}catch{return}}getLivePosition(){const n=this.playerInstance.buffered();if(n.length===0)return 0;let a=n.end(0);for(let s=1;s<n.length;s++)a=Math.max(a,n.end(s));return a}getAverageDownloadBitrate(){if(this.streamingStartedTimestamp&&this.totalDownloadedBytes){const n=(new Date().getTime()-this.streamingStartedTimestamp.getTime())/1e3;if(n>0)return 8*this.totalDownloadedBytes/n}return 0}getRetryFrequency(){const n=this.currentDiagnosticSnapshot.retryCount;if(this.streamingStartedTimestamp&&n){const a=(new Date().getTime()-this.streamingStartedTimestamp.getTime())/6e4;if(a>0)return n/a}return 0}getAverageMeasuredBandwidth(){if(this.videoDownloadBandwidths.length===0)return null;let n=0;for(let a=0;a<this.videoDownloadBandwidths.length;a++)n+=this.videoDownloadBandwidths[a];return n/this.videoDownloadBandwidths.length}getAverageMeasuredVideoDownloadSize(){if(this.videoDownloadBytes.length===0)return null;let n=0;for(let a=0;a<this.videoDownloadBytes.length;a++)n+=this.videoDownloadBytes[a];return n/this.videoDownloadBytes.length}getPlayerCachedLength(){const n=this.playerInstance.buffered();let a=0;for(let s=0;s<n.length;s++)a+=n.end(s)-n.start(s);return a}getPlayerEdgeLatency(){const n=this.playerInstance.buffered();if(n.length===0)return 0;let a=n.end(0);for(let s=1;s<n.length;s++)a=Math.max(a,n.end(s));return a-this.playerInstance.currentTime()}}}function ID(){return class{constructor(n,a,s,c){this.player=n,this.toggleListener=a,this.config=s,this.diagnosticProvider=c,this.onTextTrackChanged=this.onTextTrackChanged.bind(this),this.isHtml5Tech=this.player.currentTechName()?.toLowerCase()==="html5"}dispose(){this.unsubscribeFromTrackEvents(),this.player=null,this.toggleListener=null}initialize(){const n=this.getPlayerTextTracksAsArray();if(!this.config.controlsEnabled&&n.length>0)n[0].mode="showing";else for(let a=0;a<n.length;a++)n[a].mode="disabled";this.subscribeOnTrackEvents()}addCues(n){const a=this.player.getCurrentTextTrack();if(!a)return;const s=this.getCurrentAbsoluteTime()||1,c=this.getCurrentTime(),u=this.config.controlsEnabled?s-c:Math.max(s-c,0),m=this.isHtml5Tech?window.VTTCue:window.vttjs&&window.vttjs.VTTCue||window.VTTCue;for(let b=0;b<n.length;b++){const{start:_,end:k,text:N}=n[b],W=2,ee=new m(Number((_-u).toFixed(W)),Number((k-u).toFixed(W)),N);ee.size=100,!this.containsCue(a,ee)&&a.addCue(ee)}}clearCues(){const n=this.player.getCurrentTextTrack();if(n)try{if(n.activeCues&&n.removeCue)for(;n.activeCues.length>0;)n.removeCue(n.activeCues[0]);const a="setCues_";if(n.cues[a]){n.cues_&&(n.cues_.length=0),n.cues[a]([]);const s=Object.getOwnPropertyNames(n.cues);for(let c=0;c<s.length;c++)s[c]!=="length"&&s[c]!=="length_"&&s[c]!=="cues_"&&delete n.cues[s[c]]}}catch(a){this.config.logFn(`[clearCues]: ${a}`,"warn")}}showCaptions(n){this.config.logFn(`[CaptionsControl]: showCaptions(${n})`),n?this.show():this.hide()}hide(){this.previouslyVisibleTextTrack=this.player.getCurrentTextTrack(),this.previouslyVisibleTextTrack&&(this.previouslyVisibleTextTrack.mode="disabled"),this.player.captionToggle&&this.player.captionToggle.hide&&this.player.captionToggle.hide(),this.player.MoreOptionscaptionSubtitleButton&&this.player.MoreOptionscaptionSubtitleButton.hide&&this.player.MoreOptionscaptionSubtitleButton.hide(),this.player.MoreOptionscaptionSettingsButton&&this.player.MoreOptionscaptionSettingsButton.hide&&this.player.MoreOptionscaptionSettingsButton.hide()}show(){this.previouslyVisibleTextTrack&&(this.previouslyVisibleTextTrack.mode="showing"),this.player.captionToggle&&this.player.captionToggle.show&&this.player.captionToggle.show(),this.player.MoreOptionscaptionSubtitleButton&&this.player.MoreOptionscaptionSubtitleButton.show&&this.player.MoreOptionscaptionSubtitleButton.show(),this.player.MoreOptionscaptionSettingsButton&&this.player.MoreOptionscaptionSettingsButton.show&&this.player.MoreOptionscaptionSettingsButton.show()}subscribeOnTrackEvents(){const n=this.player.textTracks(),a="addEventListener";n&&n[a]&&(this.config.controlsEnabled&&n[a]("change",this.onTextTrackChanged),this.isHtml5Tech&&this.config.removeEmptyDefaultTextTrack&&n[a]("addtrack",this.onAddTrack.bind(this)))}unsubscribeFromTrackEvents(){const n=this.player.textTracks(),a="removeEventListener";n&&n[a]&&(this.config.controlsEnabled&&n[a]("change",this.onTextTrackChanged),this.isHtml5Tech&&this.config.removeEmptyDefaultTextTrack&&n[a]("addtrack",this.onAddTrack.bind(this)))}onTextTrackChanged(){const n=this.player.getCurrentTextTrack();if(!n||!this.currentTextTrack||this.currentTextTrack.label!==n.label||this.currentTextTrack.mode!==n.mode){if(n||this.currentTextTrack){const a=!!n&&n.mode==="showing",s=this.getCulture(n||this.currentTextTrack),c=this.getCurrentTime();this.toggleListener.captionsToggled(a,s,c),this.config.logFn(`[CaptionsControl]: track changed: culture '${s}', timestamp '${c}'`)}this.currentTextTrack=n}}onAddTrack(n){const a=n?.track;a?.kind==="captions"&&!a.label&&!a.id&&(this.player?.textTracks_?.removeTrack_(a),this.config.logFn("[CaptionsControl]: removing default empty text track"))}getCurrentTime(){return this.isHtml5Tech?this.player.currentTime():(this.config.controlsEnabled?this.player.currentTime():this.player.currentMediaTime())||1}getCurrentAbsoluteTime(){return this.diagnosticProvider.getCurrentAbsoluteTime()}getCulture(n){if(!n)return"";if(n.id){const a=n.id.split("_")[1];if(a)return a}return""}getPlayerTextTracksAsArray(){const n=this.player.textTracks();return n&&n.tracks_||[]}containsCue(n,a){return Array.from(n?.cues||[]).some(s=>this.areCueEquals(s,a))}areCueEquals(n,a){function s(m){return{start:m.start?m.start:m.startTime,end:m.end?m.end:m.endTime,text:m.text}}const c=s(n),u=s(a);return c.start===u.start&&c.end===u.end&&c.text===u.text}}}function Ree(){const n=nw(),a=hp(),s=new n,c=new a(s,document.body);s.registerObserver(c)}function mG(){let n=`(${Ree.toString()})();`;return n+=Sf.toString()+";",n+=nw.toString()+";",n+=hp.toString()+";",n+=ID.toString()+";",n+=Y_.toString()+";",n+=AD.toString()+";",n+=dN.toString()+";",n+="//# sourceURL=TsCallingAmpPlayer.js",n}var fG=class{sendMsg(n){this.peer.onMsg(n)}registerObserver(n){this.observer=n}onMsg(n){this.observer&&this.observer.processMessage(n)}connect(n){this.peer=n}dispose(){this.peer=null,this.observer=null}},Mee=class{constructor(n){this.container=n}get contextWindow(){return this.container.ownerDocument.defaultView}sendMsg(n){this.iframe?.contentWindow?.postMessage(n,"*")}registerObserver(n){this.observer=n}dispose(){this.contextWindow&&this.contextWindow.removeEventListener("message",this.processMsg),this.iframe&&this.container.hasChildNodes()&&this.container.removeChild(this.iframe),this.iframe=null}initializeAmpIframe(n){const a=this.initializeIframe();return this.setAmpIframeContent(n),this.finalizeIframe(a)}initializeIframe(){const n=new Pi;return this.iframe=this.container.ownerDocument.createElement("iframe"),this.iframe.id="player-iframe",this.iframe.sandbox.add("allow-scripts"),this.iframe.allowFullscreen=!0,this.iframe.allow="camera; microphone; autoplay",this.iframe.style.height="100%",this.iframe.style.width="100%",this.iframe.style.border="none",this.iframe.onload=()=>{n.resolve()},this.iframe.onerror=()=>{n.reject("iframe load failed")},n}finalizeIframe(n){return this.container.appendChild(this.iframe),this.processMsg=this.processMsg.bind(this),this.contextWindow.addEventListener("message",this.processMsg),n.promise}processMsg(n){n.origin==="null"&&n.source===this.iframe.contentWindow&&this.observer&&(n.data==="RequestIceCandidates"?this.observer.processMessage({msgType:"Command",cmd:"getIceCandidates",args:[]}):this.observer.processMessage(n.data))}setAmpIframeContent(n){const a=mG(),s=`
            <html class style='height: 100%; width: 100%; overflow: hidden'>
            <head></head>
            <body class style='height: 100%; width: 100%; margin: 0px'>
                ${n?`<script nonce='${n}'> ${a}<\/script>`:`<script> ${a}<\/script>`}
            </body>
            </html>
        `;this.iframe.srcdoc=s}};async function m2(n,a,s){if(a===0){const c=new fG,u=new fG;return c.connect(u),u.connect(c),u.registerObserver(new oC(u,n)),c}if(a===1){const c=new Mee(n);return await c.initializeAmpIframe(s),c}throw new Error(`Unsupported communication type ${a}`)}var bf=class extends Qs{constructor(n){super(n),this.logger=n,this.resultsMap=new Map,this.on("log",(a,s)=>{this.logger[a](s)})}async initialize(n,a,s,c){const u={config:s.config,playerConfig:s.playerConfig},m=s.playerConfig?.nonce||"";this.pipe=await m2(n,s.config.loadType,m),this.pipe.registerObserver(this),await this.message("configure").send(a,u,c)}message(n){return{send:this.fromMessage((...a)=>this.sendMessageImpl(n,...a))}}dispose(){super.dispose(),this.pipe.sendMsg(this.buildMsg("dispose")),this.pipe.dispose()}processMessage(n){let a;switch(n.msgType){case"CommandResult":a=this.getDeferred(n.cmd.toString()),a&&(n.error?(a.reject(n.error),this.logger.warn(`remote command failed: ${String(n.cmd)}, ${n.error}`)):n.result?a.resolve(n.result):a.resolve(),this.processCommandResult(n),this.resultsMap.delete(n.cmd.toString()));break;case"PlayerNotification":{const s=this.event(n.name);s.raise.apply(s,n.args);break}case"Command":this.processCommand(n).catch(s=>this.logger.warn(`error while processing command: ${JSON.stringify(n)}: ${s}`));break;default:this.logger.warn(`unexpected message received: ${JSON.stringify(n)}`)}}async processCommand(n){n.cmd.toString()==="getIceCandidates"?await this.message("getIceCandidates").send():this.logger.warn(`unsupported command received: ${JSON.stringify(n)}`)}processCommandResult(n){n.cmd.toString()==="getIceCandidates"?this.pipe.sendMsg({topic:"RequestIceCandidates",candidates:n.result}):this.logger.debug(`ignoring command result for: ${JSON.stringify(n)}`)}fromMessage(n){return n}sendMessageImpl(n,...a){return this.pipe.sendMsg(this.buildMsg(n,a)),this.waitForCompletion(n.toString())}buildMsg(n,a){return{msgType:"Command",cmd:n,args:a}}getDeferred(n){return this.resultsMap.get(n)}waitForCompletion(n){const a=this.getDeferred(n);a&&a.reject(new Error(`function ${n} is invoked again, before previous call is completed`));const s=new Pi;return this.resultsMap.set(n,s),s.promise}},Pee=class extends Qs{constructor(n,a){super(),this.player=n,this.logger=a,this.playerSubs=[],this.subscribeForPlayerEvents()}get isRendering(){return!!this.player&&this.player.isRendering()}get streamSize(){return this.player?this.player.getStreamSize():{width:0,height:0}}get rendererType(){return 0}get frameType(){return-1}seek(n){this.player.seek(n)}seekToLiveEdge(){this.player.seekToLiveEdge()}play(){this.player.play()}pause(){this.player.pause()}setVolume(n){this.player.setVolume(n)}selectVideoTrack(n){this.player.selectVideoTrack(n)}dispose(){this.stopPlayer(),super.dispose()}captions(){return this.player.getCaptionsControl()}getStats(){throw new Error("Method not implemented.")}setScalingMode(n,a){throw new Error("Method not implemented.")}captureFrame(n,a){throw new Error("Method not implemented.")}stopPlayer(){const n=this.player;this.player=null,n&&(this.logger.info("stopPlayer"),this.unsubscribeFromPlayerEvents(),n.stop())}subscribeForPlayerEvents(){this.playerSubs.push(this.player.on("fullscreenToggled",n=>this.onFullScreenToggled(n))),this.playerSubs.push(this.player.on("captionsToggled",(n,a,s)=>this.onCaptionsToggled(n,a,s))),this.playerSubs.push(this.player.on("playbackTimeUpdated",n=>this.onPlaybackTimeUpdated(n))),this.playerSubs.push(this.player.on("videoTracksChanged",n=>this.onVideoTracksChanged(n)))}unsubscribeFromPlayerEvents(){for(const n of this.playerSubs)n.dispose();this.playerSubs=[]}onFullScreenToggled(n){this.event("fullScreenToggled").raise(n)}onCaptionsToggled(n,a,s){this.logger.info(`Turned captions ${n?"ON":"OFF"} for culture [${a}] at player time [${s}]`),this.event("captionsToggled").raise(n,a,s)}onPlaybackTimeUpdated(n){this.event("playbackTimeUpdated").raise(n)}onVideoTracksChanged(n){this.event("videoTracksUpdated").raise(n)}},Dee=class{constructor(n,a){this.player=n,this.availableCultures=a,this.selectedCulture="",this.disposable=this.player.on("captionsToggled",(s,c,u)=>{this.selectedCulture=s?c:""})}async addCues(n){await this.player.message("addCues").send(n)}async clearCues(){await this.player.message("clearCues").send()}async showCaptions(n){await this.player.message("showCaptions").send(n)}getSelectedCulture(){return this.selectedCulture}getAvailableCultures(){return this.availableCultures}dispose(){this.disposable.dispose(),this.player=null}};function sC(){return"xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g,n=>{const a=16*Math.random()|0;return(n==="x"?a:3&a|8).toString(16)})}function vG(n){return new RegExp("^[{]?[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}[}]?$").test(n)&&n.length===36}var Lee=[2097152,2097552,2097556,2097557,2097564,2097652,2097654,2097655,2097656,2097752,3145728,4194305,4194306,4194307,4194308,4194309,5242880,5242881,5242882,5242884,5242885,5242886],f2=2097753,Tf=class extends Qs{constructor(n,a,s){super(),this.logger=n,this.liveStreamStatistic=a,this.configProvider=s,this.playerState="Destroyed",this.retryCount=0,this.captionsTimestamp=0,this.isSwitchStreamingUrlOngoing=!1,this.streamingUrlSwitchCount=0,this.isPlaybackUnsupported=!1,this.noMediaTimeoutId=-1,this.lastPlaybackError=void 0,this.id=sC(),this.logger.info(`AmpLiveStreamPlayer created: ID: ${this.id}`)}get playerId(){return this.id}async configure(n){if(!q0(n.stream)&&!q0(n.altStream))return void this.logger.error("Invalid Live Stream configuration provided: no valid primary or alternative stream");this.logger.info("Live Stream configuration provided"),this.liveStreamOptions=n;const a=q0(n.stream)?n.stream:n.altStream;if(this.playerInstance&&!this.isPlaybackUnsupported){try{await this.playerInstance.message("configure").send(n)}catch(s){const c=nn(s);this.logger.error(`configure failed: ${c}`)}await this.handleStreamInfoUpdate(a)}else this.selectedStreamDetails=a}async loadPlayer(n){if(this.playerInstance)return this.logger.error("playerLoadFailed: cannot load a player while current one is still active"),{setupSucceeded:!1,playerSetupError:{errorType:"MultiplePlayerLoad",errorMessage:"cannot load a player while current one is still active"}};if(!this.liveStreamOptions||!this.selectedStreamDetails||!q0(this.selectedStreamDetails))return this.logger.error("playerLoadFailed: empty/invalid primary and alternate stream info configured"),{setupSucceeded:!1,playerSetupError:{errorType:"InvalidStream",errorMessage:"empty/invalid primary and alternate stream info configured"}};this.playerInstance=new bf(this.logger.createChild("AmpPlayerWrapper")),this.playerInstance.on("stateChanged",(c,u)=>this.ampStateChanged(c,u)),this.playerInstance.on("captionsToggled",(c,u,m)=>this.captionsToggled(c,u,m)),this.playerInstance.on("statsUpdated",c=>this.liveStreamStatistic.registerStatsUpdated(c));const a=this.configProvider.config.ampSettings.noMediaTimeoutMs;let s;a!==-1&&this.noMediaTimeoutId===-1&&(this.noMediaTimeoutId=self.setTimeout(()=>this.callDropDueToMediaTimeout(),a)),await this.playerInstance.initialize(n,this.liveStreamOptions,this.configProvider,this.id),this.liveStreamStatistic.registerPlayerLoadAttempt(),this.loadSucceeded=!1,this.liveStreamStatistic.registerEventLoadAttempt("LoadScript"),this.srcLoadPromise||(this.srcLoadPromise=this.playerInstance.message("loadPlayerScript").send());try{s=await this.srcLoadPromise}catch(c){const u=nn(c);return this.logger.error(`playerLoadFailed: player scripts load failed: ${u}`),this.liveStreamStatistic.registerEventLoadFailed("LoadScript",`Load Script failed: ${c}`),this.liveStreamStatistic.registerPlayerLoadFailed(`script load failed: ${s}`),this.srcLoadPromise=null,{setupSucceeded:!1,playerSetupError:{errorType:"PlayerScriptLoadFailed",errorMessage:u}}}this.liveStreamStatistic.registerEventLoadSucceeded("LoadScript"),await this.tryLoadSdnPlugin(),this.liveStreamStatistic.registerEventLoadAttempt("CreateAmp");try{await this.playerInstance.message("createAmp").send()}catch(c){const u=nn(c);return this.logger.error(`playerLoadFailed: createAmp failed: ${u}`),this.liveStreamStatistic.registerEventLoadFailed("CreateAmp",`createAmp failed: ${c}`),this.liveStreamStatistic.registerPlayerLoadFailed(`create amp failed ${u}, script load: ${s}`),{setupSucceeded:!1,playerSetupError:{errorType:"PlayerInitializationFailed",errorMessage:u}}}this.liveStreamStatistic.registerEventLoadSucceeded("CreateAmp");try{return await this.setPlayerSource(this.selectedStreamDetails),this.loadSucceeded=!0,this.logger.info(`loadPlayer succeeded: ${this.loadSucceeded}`),this.liveStreamStatistic.registerPlayerLoadSucceeded(s),this.playerState="Initialized",{setupSucceeded:this.loadSucceeded}}catch(c){const u=nn(c);return this.loadSucceeded=!1,this.logger.error(`loadPlayer succeeded: ${this.loadSucceeded}: setSource failed: ${u}`),this.liveStreamStatistic.registerPlayerLoadFailed(`setPlayerSource failed; script load: ${s}`),{setupSucceeded:this.loadSucceeded,playerSetupError:{errorType:"SetSourceFailed",errorMessage:u}}}}getRenderer(){return!this.renderer&&this.playerInstance&&(this.renderer=new Pee(this,this.logger.createChild("LiveStreamRenderer"))),this.renderer}seek(n){throw new Error(`Method not implemented - cannot perform video seek operation with args: [timestamp: ${n}]`)}seekToLiveEdge(){throw new Error("Method not implemented - cannot perform video seek to live edge operation")}play(){throw new Error("Method not implemented - cannot perform video play operation")}pause(){throw new Error("Method not implemented - cannot perform video pause operation")}setVolume(n){throw new Error(`Method not implemented - cannot set video volume with args: [volume: ${n}]`)}selectVideoTrack(n){throw new Error(`Method not implemented - cannot select video track with args: [track: ${n}]`)}stop(){this.destroy("PlayerStopped")}getPlaybackState(){return this.playerState}getCaptionsTimestamp(){return this.captionsTimestamp}getCaptionsControl(){if(!this.captionsControl&&this.playerInstance){const n=this.liveStreamOptions.supportedSubtitleLanguages?this.liveStreamOptions.supportedSubtitleLanguages.map(a=>a.culture):[];this.captionsControl=new Dee(this.playerInstance,n)}return this.captionsControl}getStreamSize(){const n=this.liveStreamStatistic.getPlayerDiagnosticSnapshot();return n?{width:n.mediaWidth,height:n.mediaHeight}:{width:0,height:0}}isRendering(){const n=this.getStreamSize();return n.width>0&&n.height>0}ampStateChanged(n,a){switch(n){case"error":return this.handlePlaybackError(a);case"canplaythrough":return this.onCanplaythrough();case"play":return this.onPlay();case"playing":return this.onPlaying();case"pause":return this.onPause();case"resume":return this.onResume();case"start":return this.onStart();case"ended":return this.onEnded();case"seeking":return this.onSeeking();case"seeked":return this.onSeeked(a);case"loadedmetadata":return this.onMetadataLoaded();case"waiting":return this.onWaiting();case"playbackbitratechanged":return this.onPlaybackBitrateChanged(a);case"downloadbitratechanged":return this.onDownloadBitrateChanged(a);case"fullscreenchange":return this.onFullscreenChange(a);case"potentialMediaFreeze":return this.onPotentialMediaFreeze();case"mute":return this.onMute();case"unmute":return this.onUnmute();case"volumechange":return this.onVolumeChange(a);case"loadstart":return this.onLoadStart();case"loadeddata":return this.onLoadedData();case"UserInitiatedSeek":return this.onUserInitiatedSeek(a);default:this.logger.warn(`Unknown amp event ${n}`)}}onUserInitiatedSeek(n){this.liveStreamStatistic.registerUserInitiatedSeek(n)}captionsToggled(n,a,s){this.event("captionsToggled").raise(n,a,s),this.liveStreamStatistic.registerCaptionToggle(n,a,s)}async tryLoadSdnPlugin(){if(this.sdnPluginLoadPromise)return void this.raiseSdnPluginSkippedEvent("SDN plugin already loaded");if(!this.liveStreamOptions.sdn)return void this.raiseSdnPluginSkippedEvent("No SDNs configured in liveStreamOptions");if(!this.configProvider.config.allowSdnPlugins)return void this.raiseSdnPluginSkippedEvent("Client configured to not allow SDN plugins");switch(this.liveStreamOptions.sdn.name){case"hive":case"kollective":case"ramp":case"peer5":break;default:return this.logger.warn(`unsupported SDN provider: ${this.liveStreamOptions.sdn.name}`),void this.liveStreamStatistic.registerSdnPluginLoad(this.liveStreamOptions.sdn.name,!1,`Unsupported SDN provider: ${this.liveStreamOptions.sdn.name}`)}let n;this.liveStreamStatistic.registerEventLoadAttempt("SdnPluginLoad");try{this.sdnPluginLoadPromise=this.playerInstance.message("tryLoadSdnPlugin").send(),await this.sdnPluginLoadPromise,this.liveStreamStatistic.registerEventLoadSucceeded("SdnPluginLoad",this.liveStreamOptions.sdn.name)}catch(a){n=nn(a),this.sdnPluginLoadPromise=void 0,this.logger.error(`loadSdnPlugin failed: ${n}`),this.liveStreamStatistic.registerEventLoadFailed("SdnPluginLoad",n),this.event("sdnPluginLoadFailed").raise(n)}}raiseSdnPluginSkippedEvent(n){this.logger.warn(`skipping SDN plugin load: ${n}`),this.event("sdnPluginLoadSkipped").raise(n)}async setPlayerSource(n){if(!n)throw this.logger.error("setPlayerSource: streamDetails is undefined"),new Error("setPlayerSource: streamDetails is undefined");if(!this.playerInstance)throw this.logger.error("setPlayerSource: playerInstance is null"),new Error("playerInstance is null");this.logger.info(`setPlayerSource: AMP source set to: [${n.url}]`),this.lastKnownPlayTime=this.getCurrentTime()||this.lastKnownPlayTime;try{this.logger.info("setPlayerSource: src changed"),this.selectedStreamDetails=n,this.liveStreamStatistic.registerSetSourceAttempt(n.url),await this.playerInstance.message("setSource").send(n),this.liveStreamStatistic.registerSetSourceSucceeded()}catch(a){const s=nn(a);throw this.logger.error(`setPlayerSource: failed with error [${s}]`),this.liveStreamStatistic.registerSetSourcedFailed(s),a}}async handleStreamInfoUpdate(n){this.loadSucceeded&&n.url!==this.selectedStreamDetails.url?await this.setPlayerSource(n):this.loadSucceeded&&this.playerInstance&&this.getCurrentTime()>0&&this.setPlaybackState("Start")}async switchStreamingUrl(n,a){if(this.streamingUrlSwitchCount>=this.configProvider.config.ampSettings.streamingUrlSwitchMaxCount||!(0,cN.includes)(this.configProvider.config.ampSettings.errorCodesEligibleForStreamingUrlSwitch,n)&&!a)return!1;const s=this.selectedStreamDetails.url===this.liveStreamOptions.stream?.url,c=s?this.liveStreamOptions.altStream:this.liveStreamOptions.stream;return q0(c)?(this.isSwitchStreamingUrlOngoing=!0,this.streamingUrlSwitchCount++,this.setPlayerSource(c).then(()=>!0).catch(()=>!1)):(this.logger.error(`Stream to switch (${s?"alternative":"primary"}) is not valid`),!1)}destroy(n){this.srcLoadPromise=null,this.sdnPluginLoadPromise=null,this.renderer&&(this.renderer.dispose(),this.renderer=null),this.captionsControl&&(this.captionsControl.dispose(),this.captionsControl=null),this.playerInstance&&(this.liveStreamStatistic.registerPlayerDestroyed(n),this.playerInstance.dispose(),this.playerInstance=null,this.setPlaybackState("Destroyed"))}getCurrentTime(){const n=this.liveStreamStatistic.getPlayerDiagnosticSnapshot();return n&&n.currentPlayPosition||0}onCanplaythrough(){this.setPlaybackState("Ready")}onPlay(){(this.retryCount>0||this.lastKnownPlayTime)&&(this.logger.info(`Playing after retry count ${this.retryCount}, Setting current time to ${this.lastKnownPlayTime}`),this.playerInstance.message("setPlayTime").send(this.lastKnownPlayTime),this.retryCount=0,this.lastKnownPlayTime=void 0),this.setPlaybackState("Play")}onPlaying(){this.setPlaybackState("Playing")}onPause(){this.setPlaybackState("Paused")}onResume(){this.setPlaybackState("Resume")}onStart(){this.logger.info(`Playback started, retry count: ${this.retryCount}`),this.setPlaybackState("Start"),this.event("playbackStarted").raise(),self.clearTimeout(this.noMediaTimeoutId),this.isSwitchStreamingUrlOngoing&&(this.logger.info(`Playback started, switch count: ${this.streamingUrlSwitchCount}`),this.event("urlSwitched").raise(this.selectedStreamDetails===this.liveStreamOptions.altStream),this.isSwitchStreamingUrlOngoing=!1)}onEnded(){this.setPlaybackState("Ended")}onSeeking(){this.setPlaybackState("Seeking")}onSeeked(n){this.captionsTimestamp=n.captionsTimestamp,this.setPlaybackState("Seeked")}onMetadataLoaded(){this.setPlaybackState("LoadedMetadata")}onWaiting(){this.setPlaybackState("Buffering")}onLoadedData(){this.setPlaybackState("LoadedData")}onLoadStart(){this.setPlaybackState("LoadStart")}setPlaybackState(n){this.playerState=n,this.logger.debug(`playback state changed: ${n}`),this.liveStreamStatistic.registerPlaybackStateChanged(n),this.event("playbackStateChanged").raise()}onPlaybackBitrateChanged(n){this.liveStreamStatistic.registerPlaybackBitratechanged(n.bitrate)}onDownloadBitrateChanged(n){this.liveStreamStatistic.registerDownloadBitratechanged(n.bitrate)}onFullscreenChange(n){this.logger.debug(`fullscreenchange, isFullscreen=${n.isFullscreen}`),this.event("fullscreenToggled").raise(n.isFullscreen),this.liveStreamStatistic.registerFullScreenChange(n.isFullscreen)}onPotentialMediaFreeze(){this.logger.warn("Player detected a potential media freeze"),this.liveStreamStatistic.registerPotentialMediaFreeze()}onMute(){this.liveStreamStatistic.registerMute(!0)}onUnmute(){this.liveStreamStatistic.registerMute(!1)}onVolumeChange(n){this.liveStreamStatistic.registerVolumeChange(n.value)}stringifyPlayerError(n){return JSON.stringify(n,function(a,s){return a==="errorCode"?s.toString(16):s})}async handlePlaybackError(n){this.playerState="Error",this.lastPlaybackError=n;const s=this.stringifyPlayerError(n);if(this.logger.info(`Playback error ${s}`),!n.errorCode&&n.fatal==null)return void this.logger.error("onError: error details are not available");if((n.errorCode&4194307)===4194307)return this.isPlaybackUnsupported=!0,this.raisePlaybackError("UnsupportedPlatform",s),void this.destroy("PlaybackError");this.lastKnownPlayTime=this.getCurrentTime()||this.lastKnownPlayTime;const c=n.errorCode,u=268435455&c;this.logger.error(`onError: errorCode: 0x${c.toString(16)}, errorCodeExcludingTech: 0x${u.toString(16)}, message: ${n.message}`),this.retryCount<this.configProvider.config.maxRetryCount&&(n.fatal===!1||(0,cN.indexOf)(Lee,u)!==-1)?setTimeout(async()=>{this.logger.info(`Retry loading stream because of error code: 0x${c.toString(16)}`),this.retryCount++,this.raisePlaybackError("PlaybackRetried",s),this.setPlayerSource(this.selectedStreamDetails)},this.configProvider.config.ampSettings.sourceResetTimeoutInMs):await this.switchStreamingUrl(u,n.fatal)?this.configProvider.config.ampSettings.resetStreamingUrlSwitchCount&&(this.streamingUrlSwitchCount=0):(u===f2||n.message?.includes(f2.toString(16))?this.raisePlaybackError("NetworkError",s):this.raisePlaybackError("PlaybackError",s),this.destroy("PlaybackError"))}raisePlaybackError(n,a){this.liveStreamStatistic.registerPlaybackError(n,a),this.event("playbackError").raise(n,a)}callDropDueToMediaTimeout(){const n={currentTime:-1,errorCode:0,message:JSON.stringify({state:this.playerState,error:this.stringifyPlayerError(this.lastPlaybackError)}),fatal:!0},a=this.stringifyPlayerError(n);this.raisePlaybackError("MediaTimeout",a),this.destroy("MediaTimeout")}},tc=$i(No()),wr=class extends Qs{constructor(n,a,s){super(),this.logger=n,this.telemetryLogger=s,this.playerLoaded=!1,this.playbackState="Destroyed",this.playerSubs=[],this.isFinalTelemetrySent=!1,this.captionsTimestamp=0,this.configProvider=a;const c=this.createHydraPlayerSettings();this.eventHandler=this.createEventHandler(),this.addPlayerEventSubscribers(),this.hydraPlayer=new tc.HydraPlayer(c,this.eventHandler)}async configure(n){if(this.streamOptions=n,this.threadId=n.threadId,this.playerLoaded){const a=this.createHydraStreamOptions();await this.hydraPlayer.callPlayerApi("configureHydraPlayer",a)}}async loadPlayer(n){if(!await this.hydraPlayer.setup(n))return{setupSucceeded:!1,playerSetupError:{errorType:"HydraRuntimeLoadFailed",errorMessage:"Failed to create IFrame with Hydra runtime script"}};if(this.streamOptions){const s=this.createHydraStreamOptions();await this.hydraPlayer.callPlayerApi("configureHydraPlayer",s)}else this.logger.warn("No stream options configured before Hydra player loaded");const a=await this.hydraPlayer.callPlayerApi("loadHydraPlayer");return a.setupSucceeded&&(this.playerLoaded=!0,this.startTelemetryGathering()),this.getHydraPlayerSetupResult(a)}convertStreamDeliveryPipeline(n){switch(n){case"AMS":return tc.HydraStreamDeliveryPipeline.AMS;case"MiddleLaneHttpLiveStreaming":return tc.HydraStreamDeliveryPipeline.HLS;case"MiddleLaneUltraLowLatency":return tc.HydraStreamDeliveryPipeline.Ums;default:throw new Error(`Unable to convert StreamDeliveryPipeline ${n} to HydraStreamDeliveryPipeline`)}}convertStreamingEventType(n){switch(n){case"TLE":return tc.HydraStreamingEventType.TLE;case"Overflow":return tc.HydraStreamingEventType.Overflow;case"TownHall_Basic":return tc.HydraStreamingEventType.TownHallBasic;case"TownHall_Premium":return tc.HydraStreamingEventType.TownHallPremium;case"TownHall":return tc.HydraStreamingEventType.TownHall;default:throw new Error(`Unable to convert StreamingEventType ${n} to HydraStreamingEventType`)}}addPlayerEventSubscribers(){this.playerSubs.push(this.eventHandler.on("playbackStateChanged",n=>{this.onPlaybackStateChanged(n)})),this.playerSubs.push(this.eventHandler.on("playbackError",(n,a)=>{this.onPlaybackError(n,a)})),this.playerSubs.push(this.eventHandler.on("playbackSeeked",n=>{this.onPlaybackSeeked(n)})),this.playerSubs.push(this.eventHandler.on("urlSwitched",n=>{this.onUrlSwitched(n)})),this.playerSubs.push(this.eventHandler.on("sdnPluginLoadSkipped",n=>{this.onSdnPluginLoadSkipped(n)})),this.playerSubs.push(this.eventHandler.on("sdnPluginLoadFailed",n=>{this.onSdnPluginLoadFailed(n)})),this.playerSubs.push(this.eventHandler.on("playbackStarted",()=>{this.onPlaybackStarted()})),this.playerSubs.push(this.eventHandler.on("playbackTimeUpdated",n=>{this.onPlaybackTimeUpdated(n)})),this.playerSubs.push(this.eventHandler.on("videoTracksUpdated",n=>{this.onVideoTracksUpdated(n)})),this.playerSubs.push(this.eventHandler.on("statsUpdated",n=>{this.onStatsUpdated(n)})),this.playerSubs.push(this.eventHandler.on("log",(n,a)=>{this.onLog(n,a)})),this.playerSubs.push(this.eventHandler.on("capabilitiesUpdated",n=>{this.onCapabilitiesUpdated(n)}))}getTelemetryReport(){return this.hydraPlayer?.getFullTelemetryReport()}getSnapshotTelemetryReport(){return this.hydraPlayer?.getSnapshotTelemetryReport()}startTelemetryGathering(){let n,a;this.statsSub=window.setTimeout(async()=>{clearTimeout(this.statsSub),this.logger.debug(`initial telemetry report after ${this.configProvider.config.sendInitialTelemetryAfterMs} ms`),this.sendTelemetry(!1)},this.configProvider.config.sendInitialTelemetryAfterMs),this.configProvider.playerConfig.playerType===1?(n=this.configProvider.config.hydraPlayerHlsSettings?.ecsSettings?.sendSnapshotTelemetry||this.configProvider.config.sendSnapshotTelemetry,a=this.configProvider.config.hydraPlayerHlsSettings?.ecsSettings?.sendSnapshotTelemetryEveryMs||this.configProvider.config.sendSnapshotTelemetryEveryMs):(n=this.configProvider.config.hydraPlayerUmsSettings?.ecsSettings?.sendSnapshotTelemetry||this.configProvider.config.sendSnapshotTelemetry,a=this.configProvider.config.hydraPlayerUmsSettings?.ecsSettings?.sendSnapshotTelemetryEveryMs||this.configProvider.config.sendSnapshotTelemetryEveryMs),n&&(this.diagSub=window.setInterval(async()=>{this.sendSnapshotTelemetry()},a))}getHydraPlayerSetupResult(n){return{setupSucceeded:n.setupSucceeded,playerSetupError:n.playerSetupError?{errorType:this.convertHydraPlayerSetupError(n.playerSetupError.errorType),errorMessage:n.playerSetupError.errorMessage}:void 0}}convertHydraPlayerSetupError(n){switch(n){case tc.HydraPlayerSetupErrorType.InvalidStream:return"InvalidStream";case tc.HydraPlayerSetupErrorType.MultiplePlayerLoad:return"MultiplePlayerLoad";case tc.HydraPlayerSetupErrorType.PlayerInitializationFailed:return"PlayerInitializationFailed";case tc.HydraPlayerSetupErrorType.SetSourceFailed:return"SetSourceFailed";default:return}}getRenderer(){return!this.renderer&&this.hydraPlayer&&(this.renderer=new Pee(this,this.logger.createChild("LiveStreamRenderer"))),this.renderer}onStatsUpdated(n){this.playerStats=n}getStats(){return this.playerStats}onLog(n,a){this.logger[n](a)}onPlaybackStateChanged(n){try{this.playbackState=this.convertHydraPlaybackState(n),this.event("playbackStateChanged").raise()}catch(a){this.logger.warn(`Not handling playback state changed event: ${nn(a)}`)}}convertHydraPlaybackState(n){switch(n){case tc.HydraPlayerPlaybackState.LoadStart:return"LoadStart";case tc.HydraPlayerPlaybackState.LoadedData:return"LoadedData";case tc.HydraPlayerPlaybackState.LoadedMetadata:return"LoadedMetadata";case tc.HydraPlayerPlaybackState.Start:return"Start";case tc.HydraPlayerPlaybackState.CanPlayThrough:return"Ready";case tc.HydraPlayerPlaybackState.Play:return"Play";case tc.HydraPlayerPlaybackState.Playing:return"Playing";case tc.HydraPlayerPlaybackState.Pause:return"Paused";case tc.HydraPlayerPlaybackState.Waiting:return"Buffering";case tc.HydraPlayerPlaybackState.Seeking:return"Seeking";case tc.HydraPlayerPlaybackState.Seeked:return"Seeked";case tc.HydraPlayerPlaybackState.Ended:return"Ended";case tc.HydraPlayerPlaybackState.Error:return"Error";case tc.HydraPlayerPlaybackState.Destroyed:return"Destroyed";case tc.HydraPlayerPlaybackState.Initialized:return"Initialized";case tc.HydraPlayerPlaybackState.Stalled:return"Stalled";default:throw new Error(`Unable to convert HydraPlayerPlaybackState ${n} to PlaybackState`)}}onPlaybackError(n,a){try{const s=this.convertHydraPlaybackErrorType(n);this.event("playbackError").raise(s,a)}catch(s){this.logger.warn(`Not handling playback error event: ${nn(s)}`)}}convertHydraPlaybackErrorType(n){switch(n){case tc.HydraPlayerPlaybackErrorType.UnsupportedPlatform:return"UnsupportedPlatform";case tc.HydraPlayerPlaybackErrorType.NetworkError:return"NetworkError";case tc.HydraPlayerPlaybackErrorType.PlaybackRetried:return"PlaybackRetried";case tc.HydraPlayerPlaybackErrorType.PlaybackError:return"PlaybackError";case tc.HydraPlayerPlaybackErrorType.MediaTimeout:return"MediaTimeout";case tc.HydraPlayerPlaybackErrorType.Unknown:return"Unknown";default:throw new Error(`Unable to convert HydraPlayerPlaybackErrorType ${n} to PlaybackErrorType`)}}seek(n){this.hydraPlayer.callPlayerApi("seekHydraPlayer",n)}seekToLiveEdge(){this.hydraPlayer.callPlayerApi("seekHydraPlayerToLiveEdge")}play(){this.hydraPlayer.callPlayerApi("playHydraPlayer")}pause(){this.hydraPlayer.callPlayerApi("pauseHydraPlayer")}setVolume(n){this.hydraPlayer.callPlayerApi("setHydraPlayerVolume",n)}selectVideoTrack(n){this.hydraPlayer.callPlayerApi("selectHydraPlayerVideoTrack",n)}getStreamSize(){return this.playerStats?{width:this.playerStats.mediaWidth,height:this.playerStats.mediaHeight}:{width:0,height:0}}isRendering(){const n=this.getStreamSize();return n.width>0&&n.height>0}disposePlayer(){this.hydraPlayer?.dispose()}releasePlayer(){this.hydraPlayer&&(this.hydraPlayer.release(),this.hydraPlayer=null)}stop(){this.clearPlayerEventSubscribers(),this.destroyPlayer()}destroyPlayer(){this.renderer&&(this.renderer.dispose(),this.renderer=null),this.statsSub&&(clearTimeout(this.statsSub),this.statsSub=null),this.diagSub&&(clearInterval(this.diagSub),this.diagSub=null),this.disposePlayer(),this.sendFinalTelemetry(),this.releasePlayer()}getPlaybackState(){return this.playbackState}getCaptionsTimestamp(){return this.captionsTimestamp}sendFinalTelemetry(){this.isFinalTelemetrySent||(this.isFinalTelemetrySent=!0,this.sendTelemetry(!0))}sendTelemetry(n){if(this.configProvider.config.sendTelemetry&&this.telemetryLogger){const a={...this.getTelemetryReport(),isFinal:n,threadId:this.threadId,tsCallingVersion:wu(),correlationId:this.streamOptions.correlationId};this.logger.debug("generated live stream report: ",a),this.telemetryLogger.sendEvent({eventName:"live_events",props:a})}else this.logger.info("telemetry not sent")}sendSnapshotTelemetry(){if(this.telemetryLogger){const n={...this.getSnapshotTelemetryReport(),isFinal:!1,threadId:this.threadId,tsCallingVersion:wu(),correlationId:this.streamOptions.correlationId};this.logger.debug("sending snapshot telemetry: ",n),this.telemetryLogger.sendEvent({eventName:"live_events",props:n})}else this.logger.error("snapshot telemetry not sent, telemetryLogger is not set")}clearPlayerEventSubscribers(){for(const n of this.playerSubs)n.dispose();this.playerSubs=[]}onPlaybackSeeked(n){this.captionsTimestamp=n}onUrlSwitched(n){this.event("urlSwitched").raise(n)}onSdnPluginLoadSkipped(n){this.event("sdnPluginLoadSkipped").raise(n)}onSdnPluginLoadFailed(n){this.event("sdnPluginLoadFailed").raise(n)}onPlaybackStarted(){this.event("playbackStarted").raise()}onPlaybackTimeUpdated(n){this.event("playbackTimeUpdated").raise(n)}onVideoTracksUpdated(n){this.event("videoTracksChanged").raise(n)}onCapabilitiesUpdated(n){this.event("capabilitiesUpdated").raise(n)}},wD=class extends Qs{constructor(){super()}playbackStateChanged(n){this.event("playbackStateChanged").raise(n)}playbackSeeked(n){this.event("playbackSeeked").raise(n)}log(n,a){this.event("log").raise(n,a)}playbackError(n,a){this.event("playbackError").raise(n,a)}urlSwitched(n){this.event("urlSwitched").raise(n)}sdnPluginLoadSkipped(n){this.event("sdnPluginLoadSkipped").raise(n)}sdnPluginLoadFailed(n){this.event("sdnPluginLoadFailed").raise(n)}statsUpdated(n){this.event("statsUpdated").raise(n)}playbackStarted(){this.event("playbackStarted").raise()}playbackTimeUpdated(n){this.event("playbackTimeUpdated").raise(n)}videoTracksUpdated(n){this.event("videoTracksUpdated").raise(n)}capabilitiesUpdated(n){this.event("capabilitiesUpdated").raise(n)}},aw=$i(No());function Oee(n){if(n.playbackCoordinates)return n.playbackCoordinates;if(!n.url&&!n.hlsUrls)return[];const a=[];return(n.hlsUrls?n.hlsUrls:[n.url]).forEach(s=>{a.push({url:s,sdnContext:n.sdnContext})}),a}function Nee(n){return n.url?[{url:n.url,sdnContext:n.sdnContext}]:[]}var xee=["https://res-4.public.onecdn.static.microsoft/s01-ml-player/legacy/hls/hydra_player_hls_bundle_4.24351.2.js","https://res.cdn.office.net/s01-ml-player/legacy/hls/hydra_player_hls_bundle_4.24351.2.js"],yG=class extends wr{createEventHandler(){return new Bee}createHydraPlayerSettings(){return{playerType:aw.HydraPlayerType.Hls,hydraRuntimeFetchTimeout:this.configProvider.config.hydraRuntimeFetchTimeout,capturePlayerLogs:this.configProvider.config.capturePlayerLogs,allowSdnPlugins:this.configProvider.config.allowSdnPlugins,debugLogging:this.configProvider.config.debug??!1,muteVideo:this.configProvider.playerConfig?.muteVideo??!1,videoLang:this.configProvider.playerConfig?.lang,videoElementStyles:this.configProvider.playerConfig?.styles,maxPlayerDiagnosticsCount:this.configProvider.config.maxPlayerDiagnosticsCount,maxPlayerMemoryTraceLogCount:this.configProvider.config.maxPlayerMemoryTraceLogCount,maxPlayerPlaybackEventCount:this.configProvider.config.maxPlayerPlaybackEventCount,maxPlayerExperimentalEvents:this.configProvider.config.hlsSettings.maxPlayerExperimentalEvents,maxRetryCount:this.configProvider.config.maxRetryCount,playerTelemetryTickMs:this.configProvider.config.playerTelemetryTickMs,removeEmptyDefaultTextTrack:this.configProvider.config.removeEmptyDefaultTextTrack,maxRetryCountForLoadingResources:this.configProvider.config.maxRetryCountForLoadingResources,maxVideoTrackHistoryLogCount:this.configProvider.config.maxVideoTrackHistoryLogCount,maxStreamConnectionResultsLogCount:this.configProvider.config.hlsSettings.maxStreamConnectionResultsLogCount,maxAbsoluteTimeOffsetEstimationResultsLogCount:this.configProvider.config.hlsSettings.maxAbsoluteTimeOffsetEstimationResultsLogCount,skipNonce:this.configProvider.config.hlsSettings.skipNonce,configIds:this.configProvider.configIds,estimateAbsoluteTime:this.configProvider.config.hlsSettings.estimateAbsoluteTime,playlistInitialSequenceNumber:this.configProvider.config.hlsSettings.playlistInitialSequenceNumber,timeoutForSwitchingUrl:this.configProvider.config.hlsSettings.timeoutForSwitchingUrl,hlsConfig:this.configProvider.config.hlsSettings.hlsConfig,logHlsJsEvents:this.configProvider.config.hlsSettings.logHlsJsEvents,logHlsJsEventsEveryMs:this.configProvider.config.hlsSettings.logHlsJsEventsEveryMs,switchingPolicy:this.configProvider.config.hydraPlayerHlsSettings?.ecsSettings?.switchingPolicy,enableUuidTrace:this.configProvider.config.hlsSettings.enableUuidTrace,thaScript:this.configProvider.config.hlsSettings.thaScript,enableOffsetComputeBasedOfStreamTime:this.configProvider.config.hlsSettings.enableOffsetComputeBasedOfStreamTime,stopCrash:this.configProvider.config.stopCrash,stopTerminating:this.configProvider.config.hlsSettings.stopTerminating,stallDetectionPolicy:this.configProvider.config.hydraPlayerHlsSettings?.ecsSettings?.stallDetectionPolicy,playerRuntimeJsUrls:this.configProvider.config.hydraPlayerHlsSettings?.runtimeUrls??this.configProvider.playerConfig?.hydraPlayerWebSdkUrls??xee,disableSandbox:this.configProvider.config.hlsSettings.disableSandbox,ecsSettings:this.configProvider.config.hydraPlayerHlsSettings?.ecsSettings,nonce:this.configProvider.playerConfig?.nonce??""}}createHydraStreamOptions(){let n=aw.HydraStreamingEventType.TLE;n=this.streamOptions.streamingEventType?this.convertStreamingEventType(this.streamOptions.streamingEventType):this.streamOptions.overflow?aw.HydraStreamingEventType.Overflow:aw.HydraStreamingEventType.TLE;const a={stream:{playbackCoordinates:Oee(this.streamOptions.stream),urls:this.streamOptions.stream.hlsUrls?this.streamOptions.stream.hlsUrls:[this.streamOptions.stream.url],keyAuthorizationToken:this.streamOptions.stream.keyAuthorizationToken,keyDeliveryUrl:this.streamOptions.stream.keyDeliveryUrl,sdnContext:this.streamOptions.stream.sdnContext,streamDeliveryPipeline:this.streamOptions.stream.streamDeliveryPipeline?this.convertStreamDeliveryPipeline(this.streamOptions.stream.streamDeliveryPipeline):void 0},altStream:this.streamOptions.altStream?{playbackCoordinates:Oee(this.streamOptions.altStream),urls:this.streamOptions.altStream.hlsUrls?this.streamOptions.altStream.hlsUrls:[this.streamOptions.altStream.url],keyAuthorizationToken:this.streamOptions.altStream.keyAuthorizationToken,keyDeliveryUrl:this.streamOptions.altStream.keyDeliveryUrl,sdnContext:this.streamOptions.altStream.sdnContext,streamDeliveryPipeline:this.streamOptions.altStream.streamDeliveryPipeline?this.convertStreamDeliveryPipeline(this.streamOptions.altStream.streamDeliveryPipeline):void 0}:void 0,supportedSubtitleLanguages:this.streamOptions.supportedSubtitleLanguages,streamingEventType:n,allowPlayerControls:this.streamOptions.allowPlayerControls,sdn:this.streamOptions.sdn?{name:this.streamOptions.sdn.name,url:this.streamOptions.sdn.url,plugin:this.streamOptions.sdn.plugin}:void 0,thaContext:this.streamOptions.thaContext?{eventId:this.streamOptions.thaContext.eventId,organizer:{userId:this.streamOptions.thaContext.organizer?.userId,tenantId:this.streamOptions.thaContext.organizer?.tenantId},attendee:{userId:this.streamOptions.thaContext.attendee?.userId,tenantId:this.streamOptions.thaContext.attendee?.tenantId},coOrganizers:this.streamOptions.thaContext.coOrganizers}:void 0};return this.streamOptions.eventId&&(a.eventId=this.streamOptions.eventId),this.streamOptions.templateId&&(a.templateId=this.streamOptions.templateId),this.streamOptions.meetingMetadata&&(a.meetingMetadata=this.streamOptions.meetingMetadata),a}onCaptionsToggled(n,a,s){this.captionsControl&&this.captionsControl.toggleCaptions(n,a),this.event("captionsToggled").raise(n,a,s)}getCaptionsControl(){if(!this.captionsControl&&this.hydraPlayer){const n=this.streamOptions?.supportedSubtitleLanguages?this.streamOptions.supportedSubtitleLanguages.map(a=>a.culture):["en","es"];this.captionsControl=new hve(this.hydraPlayer,n)}return this.captionsControl}addPlayerEventSubscribers(){super.addPlayerEventSubscribers(),this.playerSubs.push(this.eventHandler.on("captionsToggled",(n,a,s)=>{this.onCaptionsToggled(n,a,s)}))}releasePlayer(){super.releasePlayer(),this.captionsControl&&(this.captionsControl.dispose(),this.captionsControl=null)}},hve=class{constructor(n,a){this.hydraPlayer=n,this.availableCultures=a,this.selectedCulture=""}async addCues(n){const a=this.convertCues(n);await this.hydraPlayer.callPlayerApi("addHydraPlayerCues",a)}convertCues(n){const a=[];return n.forEach(s=>{a.push({start:s.start,end:s.end,text:s.text})}),a}async clearCues(){await this.hydraPlayer.callPlayerApi("clearHydraPlayerCues")}async showCaptions(n){await this.hydraPlayer.callPlayerApi("showHydraPlayerCaptions",n)}getSelectedCulture(){return this.selectedCulture}getAvailableCultures(){return this.availableCultures}dispose(){this.hydraPlayer=null}toggleCaptions(n,a){this.selectedCulture=n?a:""}},Bee=class extends wD{constructor(){super()}captionsToggled(n,a,s){this.event("captionsToggled").raise(n,a,s)}},rw=$i(No()),v2=class extends wr{get tracks(){return this.trackInfo}createEventHandler(){return new pve}createHydraPlayerSettings(){return{playerType:rw.HydraPlayerType.Ums,hydraRuntimeFetchTimeout:this.configProvider.config.hydraRuntimeFetchTimeout,allowSdnPlugins:this.configProvider.config.allowSdnPlugins,debugLogging:this.configProvider.config.debug??!1,muteVideo:this.configProvider.playerConfig?.muteVideo??!1,videoLang:this.configProvider.playerConfig?.lang,videoElementStyles:this.configProvider.playerConfig?.styles,maxPlayerDiagnosticsCount:this.configProvider.config.maxPlayerDiagnosticsCount,maxPlayerMemoryTraceLogCount:this.configProvider.config.maxPlayerMemoryTraceLogCount,maxPlayerPlaybackEventCount:this.configProvider.config.maxPlayerPlaybackEventCount,maxPlayerExperimentalEvents:this.configProvider.config.umsSettings.maxPlayerExperimentalEvents,maxRetryCount:this.configProvider.config.maxRetryCount,playerTelemetryTickMs:this.configProvider.config.playerTelemetryTickMs,maxRetryCountForLoadingResources:this.configProvider.config.maxRetryCountForLoadingResources,maxVideoTrackHistoryLogCount:this.configProvider.config.maxVideoTrackHistoryLogCount,maxStreamConnectionResultsLogCount:this.configProvider.config.umsSettings.maxStreamConnectionResultsLogCount,configIds:this.configProvider.configIds,timeoutForSwitchingUrl:this.configProvider.config.umsSettings.timeoutForSwitchingUrl,latencyCompensationThreshold:this.configProvider.config.umsSettings.latencyCompensationThreshold,switchingPolicy:this.configProvider.config.hydraPlayerUmsSettings?.ecsSettings?.switchingPolicy,enableUuidTrace:this.configProvider.config.umsSettings.enableUuidTrace,thaScript:this.configProvider.config.umsSettings.thaScript,stopCrash:this.configProvider.config.stopCrash,stopTerminating:this.configProvider.config.umsSettings.stopTerminating,stallDetectionPolicy:this.configProvider.config.hydraPlayerUmsSettings?.ecsSettings?.stallDetectionPolicy,playerRuntimeJsUrls:this.configProvider.config.hydraPlayerUmsSettings?.runtimeUrls??this.configProvider.playerConfig?.hydraPlayerWebSdkUrls,disableSandbox:this.configProvider.config.umsSettings.disableSandbox,ecsSettings:this.configProvider.config.hydraPlayerUmsSettings?.ecsSettings,nonce:this.configProvider.playerConfig?.nonce??"",useLiveUmsCaptions:this.configProvider.config.umsSettings?.useLiveUmsCaptions??!1}}createHydraStreamOptions(){let n=rw.HydraStreamingEventType.TLE;n=this.streamOptions.streamingEventType?this.convertStreamingEventType(this.streamOptions.streamingEventType):this.streamOptions.overflow?rw.HydraStreamingEventType.Overflow:rw.HydraStreamingEventType.TLE;const a={stream:{playbackCoordinates:Nee(this.streamOptions.stream),urls:[this.streamOptions.stream.url],decryptionKey:this.streamOptions.stream.decryptionKey,sdnContext:this.streamOptions.stream.sdnContext,streamDeliveryPipeline:this.streamOptions.stream.streamDeliveryPipeline?this.convertStreamDeliveryPipeline(this.streamOptions.stream.streamDeliveryPipeline):void 0},altStream:this.streamOptions.altStream?{playbackCoordinates:Nee(this.streamOptions.altStream),urls:[this.streamOptions.altStream.url],decryptionKey:this.streamOptions.altStream.decryptionKey,sdnContext:this.streamOptions.altStream.sdnContext,streamDeliveryPipeline:this.streamOptions.altStream.streamDeliveryPipeline?this.convertStreamDeliveryPipeline(this.streamOptions.altStream.streamDeliveryPipeline):void 0}:void 0,streamingEventType:n,allowPlayerControls:this.streamOptions.allowPlayerControls,sdn:this.streamOptions.sdn?{name:this.streamOptions.sdn.name,url:this.streamOptions.sdn.url,plugin:this.streamOptions.sdn.plugin}:void 0,thaContext:this.streamOptions.thaContext?{eventId:this.streamOptions.thaContext.eventId,organizer:{userId:this.streamOptions.thaContext.organizer?.userId,tenantId:this.streamOptions.thaContext.organizer?.tenantId},attendee:{userId:this.streamOptions.thaContext.attendee?.userId,tenantId:this.streamOptions.thaContext.attendee?.tenantId},coOrganizers:this.streamOptions.thaContext.coOrganizers}:void 0};return this.streamOptions.eventId&&(a.eventId=this.streamOptions.eventId),this.streamOptions.templateId&&(a.templateId=this.streamOptions.templateId),this.streamOptions.meetingMetadata&&(a.meetingMetadata=this.streamOptions.meetingMetadata),a}addPlayerEventSubscribers(){super.addPlayerEventSubscribers(),this.playerSubs.push(this.eventHandler.on("trackListUpdated",n=>{this.onTrackListUpdated(n)})),this.playerSubs.push(this.eventHandler.on("trackSelected",n=>{this.onTrackSelected(n)}))}onTrackListUpdated(n){this.trackInfo=n;const a=nn(n);this.logger.info(`[onTrackListUpdated]: Track list updated to: ${a}`)}onTrackSelected(n){const a=nn(n);this.logger.info(`[onTrackSelected]: Track selected: ${a}`)}getCaptionsControl(){return!this.captionsControl&&this.hydraPlayer&&(this.captionsControl=new Fee(this.hydraPlayer,this.logger.createChild("CaptionsControl"))),this.captionsControl}releasePlayer(){super.releasePlayer(),this.captionsControl&&(this.captionsControl.dispose(),this.captionsControl=null)}},Fee=class{constructor(n,a){this.hydraPlayer=n,this.logger=a}async addCues(n){this.logger.warn("[addCues]: not implemented for UMS player")}async clearCues(){this.logger.warn("[clearCues]: not implemented for UMS player")}async showCaptions(n){await this.hydraPlayer.callPlayerApi("showHydraPlayerCaptions",n)}getSelectedCulture(){return this.logger.warn("[getSelectedCulture]: not implemented for UMS player"),""}getAvailableCultures(){return this.logger.warn("[getAvailableCultures]: not implemented for UMS player"),[]}dispose(){this.hydraPlayer=null}async selectTextTrack(n){await this.hydraPlayer.callPlayerApi("selectHydraPlayerTextTrack",n)}},pve=class extends wD{constructor(){super()}trackListUpdated(n){this.event("trackListUpdated").raise(n)}trackSelected(n){this.event("trackSelected").raise(n)}},gve=class extends Qs{constructor(n,a,s){super(),this.configProvider=n,this.logger=a,this.getTelemetryLogger=s,this.isAvailable=!0,this._isStreaming=!1,this.playerSubs=[],this.isFinalTelemetrySent=!1,this.telemetryLogger=this.getTelemetryLogger(),this.configProvider.playerConfig.playerType===1?this.player=new yG(this.logger.createChild("HlsHydraLiveStreamPlayer"),this.configProvider,this.telemetryLogger):this.configProvider.playerConfig.playerType===2?this.player=new v2(this.logger.createChild("UmsHydraLiveStreamPlayer"),this.configProvider,this.telemetryLogger):(this.initializeAmpTelemetry(),this.player=new Tf(this.logger.createChild("AmpLiveStreamPlayer"),this.liveStreamStatistic,this.configProvider)),this.subscribeForPlayerEvents()}get isStreaming(){return this._isStreaming}isActive(){return this.isAvailable&&this.isStreaming}async start(n,a){await this.setOptions(a),this.isFinalTelemetrySent=!1;const s=await this.player.loadPlayer(n);if(!s.setupSucceeded){this.player.stop(),this.logger.error("playerLoadFailed");const c=JSON.stringify(s.playerSetupError);throw this.sendFinalTelemetry(c),new Error(c)}return this._isStreaming=!0,this.liveStreamStatistic&&(this.statsSub=window.setTimeout(()=>{clearTimeout(this.statsSub),this.logger.debug(`initial telemetry report after ${this.configProvider.config.sendInitialTelemetryAfterMs} ms`),this.sendTelemetry(!1)},this.configProvider.config.sendInitialTelemetryAfterMs),this.configProvider.config.sendSnapshotTelemetry&&(this.diagSub=window.setInterval(()=>{this.sendSnapshotTelemetry()},this.configProvider.config.sendSnapshotTelemetryEveryMs))),this.player.getRenderer()}initializeAmpTelemetry(){const n={perceivedBandwidth:[],videoBufferLength:[],videoCachedLength:[],videoEdgeLatency:[],playerHeight:[],playerWidth:[],mediaHeight:[],mediaWidth:[],windowHeight:[],windowWidth:[],playbackRate:[],currentPlayPosition:[],currentMediaTime:[],statsInterval:[]};this.liveStreamStatistic=new gG(this.configProvider.config,this.logger.createChild("LiveStreamStatistic"),n)}async stop(){}async setOptions(n){return n.overflow!==void 0&&(n.streamingEventType||(n.streamingEventType=n.overflow?"Overflow":"TLE"),delete n.overflow),this.options=n,this.player.configure(n)}getStats(){return this.liveStreamStatistic?this.liveStreamStatistic.getPlayerDiagnosticSnapshot():this.player?.getStats?.()}dispose(){this.unsubscribeFromPlayerEvents(),this.player.stop(),this.statsSub&&(clearTimeout(this.statsSub),this.statsSub=null),this.diagSub&&(clearInterval(this.diagSub),this.diagSub=null),this.logger.debug("stopping live event"),this.sendFinalTelemetry("graceful disposed"),super.dispose()}sendFinalTelemetry(n){this.isFinalTelemetrySent||(this.isFinalTelemetrySent=!0,this.sendTelemetry(!0,n))}sendTelemetry(n,a){if(this.liveStreamStatistic)if(this.configProvider.config.sendTelemetry&&this.telemetryLogger){const s={configIds:this.configProvider.configIds,playerId:this.player.playerId,correlationId:this.options?.correlationId,eTag:this.configProvider.etag,isFinal:n,threadId:this.options?.threadId,disableFullscreenButton:this.configProvider.playerConfig.disableFullscreenButton,callendReason:a},c=this.liveStreamStatistic?.getReport(s);this.logger.debug("generated live stream report",c),this.telemetryLogger.sendEvent({eventName:"live_events",props:c})}else this.logger.info("telemetry not sent");else this.logger.info("telemetry not tracked in ILiveStream object")}sendSnapshotTelemetry(){if(this.liveStreamStatistic)if(this.telemetryLogger){const n=this.liveStreamStatistic.getSnapshotReport({configIds:this.configProvider.configIds,playerId:this.player.playerId,correlationId:this.options?.correlationId,eTag:this.configProvider.etag,isFinal:!1,threadId:this.options?.threadId,disableFullscreenButton:this.configProvider.playerConfig.disableFullscreenButton});this.logger.debug("sending snapshot telemetry: ",n),this.telemetryLogger.sendEvent({eventName:"live_events",props:n})}else this.logger.error("snapshot telemetry not sent, telemetryLogger is not set");else this.logger.info("telemetry not tracked in ILiveStream object")}subscribeForPlayerEvents(){this.playerSubs.push(this.player.on("playbackStateChanged",()=>{this.onPlaybackStateChanged()})),this.playerSubs.push(this.player.on("playbackError",(n,a)=>{this.onPlaybackError(n,a)})),this.playerSubs.push(this.player.on("urlSwitched",n=>{this.onUrlSwitched(n)})),this.playerSubs.push(this.player.on("sdnPluginLoadSkipped",n=>{this.onSdnPluginLoadSkipped(n)})),this.playerSubs.push(this.player.on("sdnPluginLoadFailed",n=>{this.onSdnPluginLoadFailed(n)})),this.playerSubs.push(this.player.on("playbackStarted",()=>{this.onPlaybackStarted()})),this.playerSubs.push(this.player.on("capabilitiesUpdated",n=>this.onCapabilitiesUpdated(n)))}unsubscribeFromPlayerEvents(){for(const n of this.playerSubs)n.dispose();this.playerSubs=[]}onPlaybackStarted(){this.event("playbackStarted").raise()}onPlaybackStateChanged(){const n=this.player.getPlaybackState();switch(n){case"Start":this.event("playbackStarted").raise();break;case"Ended":this.event("playbackNotLive").raise(),this.sendFinalTelemetry("playback ended");break;case"Seeked":this.event("playbackSeeked").raise(this.player.getCaptionsTimestamp());break;default:this.logger.debug(`playbackStateChanged: ${n}`)}this.event("playbackStateChanged").raise(this.player.getPlaybackState())}onPlaybackError(n,a){this.event("error").raise(n,a)}onUrlSwitched(n){this.event("urlSwitched").raise(n)}onSdnPluginLoadSkipped(n){this.event("sdnPluginLoadSkipped").raise(n)}onSdnPluginLoadFailed(n){this.event("sdnPluginLoadFailed").raise(n)}onCapabilitiesUpdated(n){this.event("capabilitiesUpdated").raise(n)}},mve=class{constructor(n,a,s){this.ecsConfig=n,this.logger=a,this.getTelemetryLogger=s}configure(n){this.configuration=n}async initialize(){const n="MDN_MIDDLELANE_TEAMS",a="liveStream",s=this.ecsConfig.getString(n,a);let c={};try{c=JSON.parse(s)}catch{this.logger.warn(`failed to parse ECS configuration for ${n}/${a}`)}const u=this.ecsConfig.getString("ConfigIDs",n);this._configProvider=new g2(c,this.configuration,u,this.logger.createChild("LiveStreamConfigProvider"))}createLiveStream(){return new gve(this._configProvider,this.logger.createChild("LiveStream"),this.getTelemetryLogger)}dispose(){}},fve=class extends Qs{constructor(){super(...arguments),this.isAudioOutputSelectionSupported=!1}createAudioPlayer(){return null}createAudioRenderer(){return null}getRawDeviceMediaStream(n){return null}askDevicePermission(){return Promise.resolve({audio:!1,video:!1})}getPermissionState(n){return"granted"}enumerateDevicesAsync(){return Promise.resolve([])}getPreferredCamera(){return null}selectDevices(){}getSelectedDevices(){return{}}startPreview(){return null}createPreview(){return Promise.resolve(new Bb)}createPreviewRenderer(){return Promise.resolve(new Bb)}createScreenSharingPreviewRenderer(){return Promise.resolve(new Bb)}getDeviceNameAsync(){return Promise.resolve("")}setDeviceEffectsAsync(){return Promise.resolve()}getDeviceEffectsCapabilityAsync(){return Promise.resolve(0)}setBackgroundImageAsync(){return Promise.resolve()}getImagePropertyAsync(){return Promise.resolve({width:0,height:0,uri:" "})}getMicrophoneGeometryArrayInfoAsync(n){return Promise.resolve({})}transformImageAsync(){return Promise.resolve(!1)}sendMessageDeviceVideoEffectsAsync(){return Promise.resolve({code:0})}sendMessageDeviceVideoExtensibilityAsync(){return Promise.resolve({code:0,type:"Error",response:{details:"The API has not been implemented."}})}setVideoCaptureConfigAsync(){return Promise.resolve()}captureVideoFrameWithoutEffectsAsync(){return Promise.resolve(new ImageData(0,0))}enableSignLanguageDetectionAsync(n,a){return Promise.resolve()}downloadAiModel(n,a){return Promise.resolve("")}setAudioProcessingFlags(n){}getSpeakerVolume(){return Promise.resolve(0)}getSpeakerSystemVolume(){return Promise.resolve(0)}setSpeakerVolume(n){return Promise.resolve()}setSpeakerSystemVolume(n){return Promise.resolve()}unmuteMicrophone(){return Promise.resolve()}unmuteSpeaker(){return Promise.resolve()}getNrgLevelsForDeviceTuner(n){return Promise.resolve(0)}getNrgLevelPollerForDeviceTuner(n){return Promise.resolve(new vve)}setAudioEffectsAsync(){return Promise.resolve()}getAudioFeatureCapability(n){return Promise.resolve(0)}getMicrophoneVolume(){return Promise.resolve(0)}setMicrophoneVolume(n){return Promise.resolve()}setDeviceTelemetryData(n,a,s,c=0){return Promise.resolve()}getSpeakerDeviceDomIdAsync(n,a){return Promise.reject()}mapBrowserDevices(n,a){return Promise.reject()}getSourceFormats(n){return Promise.resolve([])}enableShellSharing(){return Promise.resolve()}disableShellSharing(){return Promise.resolve()}enableParticipantCameras(){return Promise.resolve()}registerDerivedSource(n,a){return Promise.resolve()}unregisterDerivedSource(n){return Promise.resolve()}startAudioLoopbackDevice(n){return Promise.resolve()}async dispose(n){return Promise.resolve()}},Bb=class extends Qs{constructor(){super(...arguments),this.isRendering=!1,this.streamSize={width:0,height:0},this.rendererType=-1,this.frameType=-1}captureFrame(){return Promise.resolve(new zR)}getStats(){return Promise.resolve({framesDropped:0,framesTotal:0})}setScalingMode(){return Promise.resolve()}cameraAutoControl(n){return Promise.resolve(!1)}getCameraManualControlStates(n){return Promise.resolve([])}setCameraManualControlStates(n){return Promise.resolve([])}enumerateCameraManualControls(){return Promise.resolve([])}isCameraAdvancedControlCapable(){return Promise.resolve(!1)}dispose(){}},zR=class extends Qs{getSize(){return{width:0,height:0}}isMirrored(){return!1}},vve=class{getInputLevel(){return 0}getInputLevelNormalized(n,a){return 0}dispose(){}},jr=Qs,Uee="http://www.ietf.org/id/draft-holmer-rmcat-transport-wide-cc-extensions-01",zee="http://www.webrtc.org/experiments/rtp-hdrext/abs-send-time",SG="http://www.webrtc.org/experiments/rtp-hdrext/video-layers-allocation00",ke={MEDIA_STATE:{send:"sendonly",receive:"recvonly",sendReceive:"sendrecv",inactive:"inactive"},MEDIA_DIRECTION:{SEND:"send",RECV:"recv"},MEDIA_DEVICE_KIND:{audioInput:"audioinput",audioOutput:"audiooutput",videoInput:"videoinput",compositeAudio:"compositeAudio",virtualDevice:"virtualDevice"},MEDIA_DEVICE:{camera:"camera",microphone:"microphone",speaker:"speaker",compositeAudio:"compositeAudio",defaultId:"default",communicationsId:"communications",defaultDeviceLabel:"Default",audioIngestDevice:"audioIngestDevice",virtualDevice:"virtualDevice"},MEDIA_ERROR:{constraintNotSatisfiedError:"ConstraintNotSatisfiedError",iceConnectionError:"iceConnectionError",srtpError:"srtpError",permissionDeniedError:"permissionDeniedError",internalError:"internalError",sourceUnavailableError:"SourceUnavailableError",devicesNotFoundError:"DevicesNotFoundError",noDeviceSelected:"noDeviceSelected",noNetworkError:"noNetworkError",incompatibleOffer:"IncompatibleOffer",mediaStreamRequestError:"MediaStreamRequestError",extensionNotFoundError:"ExtensionNotFoundError",sharingCancelledError:"SharingCancelledError",permissionDeniedBySystemError:"PermissionsDeniedBySystem",chromeRuntimeNotDefinedError:"ChromeRuntimeNotDefinedError",mediaStreamRequestTimedOut:"MediaStreamRequestTimedout",unsupportedStream:"UnsupportedStream",webGlRendererError:"WebGlRendererError",audioPlaybackError:"audioPlaybackError",unexpectedClose:"unexpectedClose",incompatibleOriginator:"incompatibleOriginator"},HISTOGRAM_BATCH:{seconds1to3:2,seconds3to5:4,seconds5to8:7,seconds8to15:14,seconds15to60:59,seconds60toMax:1e6},RENEGOTIATION_ERROR:{local:"local",glare:"glare",signaling:"signaling",media:"media",escalation:"escalation"},MSI:{unsubscribe:-1,subscribeAny:-2},MEDIA_LABEL:{audio:"main-audio",video:"main-video",sharing:"applicationsharing-video",data:"data"},MEDIA_TYPE:{audio:"audio",video:"video",sharing:"sharing",data:"x-data",dataChannel:"application"},MODALITY:{audio:"audio",video:"video",sharing:"sharing",data:"data"},TRACK_KIND:{audio:"audio",video:"video"},ICE_TRANSPORT_POLICY:{all:"all",relay:"relay"},RENDERER_TYPE:{video:"video",sharing:"sharing"},CONTENT_TYPE:{SDP:"application/sdp",SDP_NGC:"application/sdp-ngc-1.0"},ALLOWED_CONTENT_TYPES:{SDP_ONLY:["application/sdp"],SDP_NGC:["application/sdp","application/sdp-ngc-0.5","application/sdp-ngc-1.0"]},STREAMING_STATE:{created:"created",started:"started",active:"active",inactive:"inactive",stopped:"stopped",removed:"removed",failed:"failed"},TIME_INTERVAL:{SEC_1:1},DISPLAY_SOURCE_ID:"display",EMPTY_DEVICE_ID:"0",SYSTEM_AUDIO_SOURCE_ID:"system",MULTIPLE_RECV_STREAMS:"multipleVideoStreams",PROFILES:{udpTlsRtpSavpf:"UDP/TLS/RTP/SAVPF",rtpSavpf:"RTP/SAVPF",rtpSavp:"RTP/SAVP",udpDtlsSctp:"UDP/DTLS/SCTP"},REPORTING_PROFILE:{RT_PROFILE:"REAL_TIME",BE_PROFILE:"BEST_EFFORT",NRT_PROFILE:"NEAR_REAL_TIME"},PAYLOAD_TYPE:{DATA_CHANNEL:"webrtc-datachannel",X_DATA:"127 126",MSRTC_RED:97,MSRTC_CNFB:120},VIDEO_CAPABILITIES:{MAX_FS_PATH:"max-fs",MAX_MBPS_PATH:"max-mbps",MAX_FPS_PATH:"max-fps",MAX_BR_PATH:"max-br",SSRC_PATH:"ssrc",RID_PATH:"rid",KEYFRAME_PATH:"KeyFrame",MAX_WIDTH:"max-width",MAX_HEIGHT:"max-height",MAX_STREAMS:"max-streams",MAX_LAYERS:"max-layers",PRIORITY_LAYOUT_MIN_MBPR:"priority-layout-min-mbpr",PRIORITY_LAYOUT_MIN_BITRATE:"priority-layout-min-bitrate",VLA_DEBUG:"vla-debug",LADDER_TYPE:"ladder-type"},TRANSPORT_CC:{EXT_URI:Uee,MSSDP_ENCODED_URI:Uee.replace(/\//g,"\\"),ATTRIBUTE:"transport-cc"},ABS_SEND_TIME:{EXT_URI:zee,MSSDP_ENCODED_URI:zee.replace(/\//g,"\\")},VLA:{EXT_URI:SG,EXT_URI_NON_ADV:SG+"-non-advertised",DEFAULT_VALUE:10},MACROBLOCK_SIZE:16,MAX_FS_1080P:8160,MEDIA_EVENT_FIELDS:{Extensions:["IceConnectionState","IceConnectionStatePrevious","SignalingState","SignalingStatePrevious"],metrics:["ReconnectInProgress","IceConnectedStateTime","ErrorType","ErrorDetail","InitialNegotiationType","InitialNegotiationCompleted","TerminationReason_subCode","TerminationReason_code"]},RES_TABLE:{SEND:[{w:320,h:180,fps:15,minBr:2e4,maxBr:175e3},{w:416,h:234,fps:15,minBr:125e3,maxBr:5e5},{w:640,h:360,fps:30,minBr:4e5,maxBr:575e3},{w:960,h:540,fps:30,minBr:5e5,maxBr:1125e3},{w:1280,h:720,fps:30,minBr:1e6,maxBr:25e5},{w:1920,h:1080,fps:30,minBr:175e4,maxBr:1e8}],RECV:[{w:320,h:180,fps:15,minBr:2e4,maxBr:175e3},{w:426,h:240,fps:15,minBr:125e3,maxBr:5e5},{w:640,h:360,fps:30,minBr:4e5,maxBr:575e3},{w:960,h:540,fps:30,minBr:5e5,maxBr:1125e3},{w:1280,h:720,fps:30,minBr:1e6,maxBr:25e5},{w:1920,h:1080,fps:30,minBr:175e4,maxBr:1e8}]},NATIVE_RATIO_PRECISION:6};function Ng(n,a){for(const s in n)n.hasOwnProperty(s)&&a(n[s],s)}function bG(n,a){for(const s in n)n.hasOwnProperty(s)&&(typeof n[s]=="object"?bG(n[s],a):a(n[s],s,n))}function ow(n){return n!=null&&!Number.isNaN(n)}function xg(n,a){return ow(a)?ow(n)?Math.min(n,a):a:n}function TG(n,a){return ow(a)?ow(n)?Math.max(n,a):a:n}function uN(n){let a=0;return n.forEach(s=>a+=s),a/=n.length,a}function VR(n,a){let s=!1;for(let c=n.length;c-- >0;)a(n[c],c,n)&&(n.splice(c,1),s=!0);return s}function Cf(n,a,s){const c=[];return n.forEach(u=>{a.some(m=>s(u,m))||c.push(u)}),c.length===0&&n.length===a.length}function FS(n){const a=[];for(const s in n)n.hasOwnProperty(s)&&a.push(n[s]);return a}function yve(n,a){for(const s in a)a.hasOwnProperty(s)&&(n[s]=a[s])}function Am(n){return!Object.keys(n).length}function kD(n){return Object.keys(n)}function Xp(n){const a={};return Ng(n,(s,c)=>{a[c]=s}),a}function fs(n){let a;if(!n||typeof n!="object")return n;if(n instanceof Date)return a=new Date,a.setTime(n.getTime()),a;if(n instanceof Array){a=[];for(let s=0,c=n.length;s<c;s++)a[s]=fs(n[s]);return a}if(n instanceof Object)return a={},Ng(n,function(s,c){a[c]=fs(s)}),a;throw new Error("Unable to copy: "+nn(n))}function _l(n){return Object.keys(n).forEach(a=>{n[a]===void 0&&delete n[a]}),n}function sw(){const n=()=>Math.floor(65536*(1+Math.random())).toString(16).substring(1);return n()+n()+n()+"4"+n().substring(1)+"b"+n().substring(1)+n()+n()+n()}function xc(n,a){let s;const c=typeof n;if(n===a)return!0;if(c!==typeof a||c!=="object"&&c!=="function")return!1;if(n===null||a===null)return n===a;if(n instanceof Date&&a instanceof Date)return+n==+a;if(n instanceof Map&&a instanceof Map)return Vee(n,a);for(s in n)if(!(s in a)||!xc(n[s],a[s]))return!1;for(s in a)if(!(s in n)||!xc(n[s],a[s]))return!1;return!0}function Vee(n,a){let s;if(n.size!==a.size)return!1;let c=!0;return n.forEach((u,m)=>{s=a.get(m),(s!==u||s===void 0&&!a.has(m))&&(c=!1)}),c}function W0(n,a){return a.reduce((s,c)=>{const u=n.includes(c)?c.length:0;return s.length<u?c:s},"")}function $ee(n,a){if(a.indexOf(n)===-1)throw{detail:`${n} mediaContent.contentType is not supported`,type:ke.MEDIA_ERROR.incompatibleOffer}}function CG(n,a){n.forEach(s=>{if(s!==""&&a.findIndex(c=>c===s)!==-1)throw{detail:`Required feature '${s}' is not acceptable.`,type:ke.MEDIA_ERROR.incompatibleOffer}})}function pV(n,a,s,c=0){for(let u=1;u<n.length;u++)if(n[u-1]+c<a&&a<=n[u]+c)return s?n[u]:n[u-1];return n[0]}function _G(n,a,s){return a<=n&&n<=s}function lw(n,...a){for(const s of a)if(s.hasOwnProperty(n))return s[n]}function y2(n,a){return n.filter(s=>!a.some(c=>c===s))}function S2(n,a){if(n===a)return n;let s=0,c=0,u="";for(let m=0;m<n.length&&!(u.length>n.length-m);m++){let b=m;c-s>u.length&&(u=n.substring(s,c),m=c-1),s=m,c=m;for(let _=0;_<a.length;_++)b<n.length&&a[_]===n[b++]?c=b:(b=m,c-s>u.length&&(u=n.substring(s,c),m=c-1),s=m,c=m)}return u}function Sve(n,a){const s=new Array(n.length+1);for(let c=0;c<n.length+1;c++){s[c]=new Array(a.length+1);for(let u=0;u<a.length+1;u++)s[c][u]=0}for(let c=1;c<n.length+1;c++)s[c][0]=c;for(let c=1;c<a.length+1;c++)s[0][c]=c;for(let c=1;c<n.length+1;c++)for(let u=1;u<a.length+1;u++){let m=1;n[c-1]===a[u-1]&&(m=0),s[c][u]=Math.min(s[c-1][u]+1,s[c][u-1]+1,s[c-1][u-1]+m)}return s[n.length][a.length]}function bve(n){return n.reduce((a,s)=>a+s,0)/(n.length?n.length:1)}function oa(n,a=3){return n&&parseFloat(n.toFixed(a))}function Q_(n,a){if(!n)return"";if(n.length<3)return n;const s=[],c=n.match(/\(([0-9a-zA-Z]+:[0-9a-zA-Z]+)\)/);c&&s.push(c[1]);try{if(a?.length){const u=new RegExp(`(${a.join("|")})`,"gi");let m=u.exec(n);for(;m;)s.push(m[1]),m=u.exec(n)}else s.push("no_keywords")}catch(u){s.push(`Error: ${nn(u)}`)}return s.length===0?"unknown":s.join(" ")}function K0(n,a,s=0){return n&&a!==void 0&&a>-1&&n.length>a&&n.splice(s,n.length-a),n}function Mo(n,a,s,c=0){K0(n,s===0?0:s-1,c),s!==0&&n.push(a)}function hN(n,a){const s={};for(const c in a)s[c]={get:a[c],configurable:!1,enumerable:!0};Object.defineProperties(n,s)}function _f(n){return n?.length>0?n[n.length-1]:void 0}var Hee=globalThis?.performance?.now&&globalThis?.performance?.timeOrigin,Tve=Hee?()=>globalThis.performance.now():()=>Date.now(),Cve=Hee?globalThis.performance.timeOrigin:0,pp=Tve,_ve=Cve;function Fb(n,a,s){if(n?.length>0){const c=[];for(const u of n){const m=fs(u);m[a]=m[a]&&m[a]-s,c.push(m)}return c}return n}function gV(n,a,s){if(!n)return;const c={seconds1to3:[],seconds3to5:[],seconds5to8:[],seconds8to15:[],seconds15to60:[],seconds60toMax:[]};for(const[u,m]of Object.entries(n))for(const b of m)Mo(c[u],b-a,s);return c}function _a(n,a,s=!1){const c=n?.map(a).filter(u=>u!==void 0&&!isNaN(u)&&u!==null&&(s===!1||u!==0));return c?.length?c.join(","):void 0}function Fh(n,a,s){const c=n?.map(a).filter(u=>u!==void 0&&!isNaN(u)&&u!==null).splice(-s);return c?.length?c:void 0}function Eve(n,a){const s=[];for(const c of Object.keys(n))a.has(c)||s.push(c);for(const c of s)delete n[c]}function pN(n,a){const s=[];for(const c of n.keys())a.has(c)||s.push(c);for(const c of s)n.delete(c)}function jee(n){return typeof n=="object"?nn(n):n}function EG(n){const a=Object.keys(n).map(Number).sort((c,u)=>c-u),s=a.reduce((c,u)=>c+(n[u]??0),0);return{getPercentile:c=>{const u=s*c;let m=0;for(const b of a)if(m+=n[b],m>=u)return b}}}function AG(n,a){return n.hasOwnProperty(a)?n[a]:n.hasOwnProperty(a.toLowerCase())?n[a.toLowerCase()]:void 0}function IG(n){const a=n.toLowerCase(),s='token_types="',c=a.indexOf(s);if(c===-1)return[];const u=a.indexOf('"',c+s.length);if(u===-1)return[];const m=a.substring(c+s.length,u).trim();return m===""?[]:m.split(" ")}function gN(n){return Math.ceil(n/16)*16}function cd(n,a,s,c){return JSON.stringify(Fb(K0(n,a),s,c))}var lC=dn;function Uh(n){return n.map(a=>new mV(a.w,a.h,a.fps,a.minBr,a.maxBr))}var mV=class{constructor(n,a,s=0,c=0,u=0){this.width=n,this.height=a,this.fps=s,this.minBitrate=c,this.maxBitrate=u,this.fs=Math.ceil(n/ke.MACROBLOCK_SIZE)*Math.ceil(a/ke.MACROBLOCK_SIZE)}toString(){return this.height?`${this.height}p`:`${this.fs}fs`}},gp=class lA{constructor(a){a||(this.resolutions=Uh(ke.RES_TABLE.SEND)),this.resolutions=Uh(a)}static initialize(a){lA.Send=new lA(a.config.sendResolutionTableOverride),lA.Recv=new lA(a.config.recvResolutionTableOverride),a.on("configUpdated",()=>{lA.Send=new lA(a.config.sendResolutionTableOverride),lA.Recv=new lA(a.config.recvResolutionTableOverride)})}get initialResolution(){return this.resolutions[this.resolutions.length-1]}getResolutionByFs(a){return this.getResolutionRecord(void 0,a)}getMaxFsForHeight(a){return this.getResolutionRecord(a).fs}getResolutionForBitrate(a){let s=this.resolutions.filter(u=>u.maxBitrate&&u.maxBitrate>=a).shift(),c=this.resolutions.filter(u=>u.minBitrate&&u.minBitrate<=a).pop();return s=s??c,c=c??s,{lowRes:s,highRes:c}}getBitrateForResolution(a,s){const c=this.getResolutionRecord(Math.min(a,s));return{minBitrate:c.minBitrate,maxBitrate:c.maxBitrate}}getResolutionRecord(a,s){if(this===lA.Send){for(let c=this.resolutions.length-1;c>=0;c--){if(a&&this.resolutions[c].height<=a)return this.resolutions[c];if(s&&this.resolutions[c].fs<=s)return this.resolutions[c]}return this.resolutions[0]}for(const c of this.resolutions)if(a&&c.height>=a||s&&c.fs>=s)return c;return this.resolutions[this.resolutions.length-1]}getNextLowerResolution(a,s){const c=Math.min(a,s),u=this.getResolutionRecord(c),m=this.resolutions.indexOf(u);return c===Math.min(u.width,u.height)||this===lA.Recv?this.resolutions[m-1]:this.resolutions[m]}getNextHigherResolution(a,s){const c=Math.min(a,s),u=this.getResolutionRecord(c),m=this.resolutions.indexOf(u);return c===Math.min(u.width,u.height)?this.resolutions[m+1]:this===lA.Recv?this.resolutions[m]:this.resolutions[m+1]}getResolutions(){return[...this.resolutions]}};gp.Recv=new gp(ke.RES_TABLE.RECV),gp.Send=new gp(ke.RES_TABLE.SEND);var yl=gp,J0=n=>yl.Send.getResolutionByFs(n).height,RD=n=>yl.Send.getMaxFsForHeight(n),$R={numVideoChannelsGvc:({current:n,constraints:a})=>Gee(n,a),specCompliantSimulcast:({current:n,constraints:a})=>Rl(n,a),multiviewResolutionLimits:({current:n,constraints:a,logger:s})=>wG(n,a,s),enableVla:({current:n,settings:a,constraints:s,settingsSuffix:c})=>T2(n,a,s,c),allowRemoteVla:({current:n,settings:a,constraints:s,settingsSuffix:c})=>T2(n,a,s,c),enableNonAdvVla:({current:n,settings:a,constraints:s,settingsSuffix:c})=>T2(n,a,s,c),outgoingVideoLimit:({current:n,settings:a,constraints:s})=>eg(n,a,s),webrtcCameraOpenFs:({current:n,settings:a,constraints:s,settingsSuffix:c})=>Z_(n,a,s,c),webrtcVideoCapabilityMaxFS:({current:n,settings:a,constraints:s,settingsSuffix:c})=>Z_(n,a,s,c)},b2=(n,a,s)=>({...MD(n,a,s),...MD(n,a,s,"1on1"),...MD(n,a,s,"Multiparty")}),MD=(n,a,s,c)=>{const u={};for(const m of Object.keys($R)){const b=`${m}${c??""}`;c&&!ow(a[b])||(u[b]=$R[m]({current:a[b],settings:a,constraints:s,settingsSuffix:c,logger:n}))}return u},Gee=(n,a)=>xg(n,a.maxIncomingStreams),wG=(n,a,s)=>{const c=a.maxParticipantResolutions;if(!c)return n;const u={more:n.more};if(Number.isInteger(c))Object.keys(n).forEach(m=>{u[m]=xg(c,n[m])});else{const m=Object.keys(c);if(!m.length)return s.warn(`ignoring invalid value provided for maxParticipantResolutions: ${c}}`),n;m.forEach(b=>{u[b]=xg(c[b],n[b]||n.more)})}return u},Rl=(n,a)=>a.maxSimulcastLayers!==void 0||n.allowOverride?{...n,video:Av(n.video,a),sharing:Av(n.sharing,a)}:n,Av=(n,a)=>{const s=n?.layerScaleFactors?.filter(c=>c<=a.maxSimulcastLayers);return s?.length>1?{...n,layerScaleFactors:s}:{...n,enableLocally:!1,allowEnableRemotely:!1}},Ru=n=>xg((0,lC.isNumber)(n?.outgoingVideoLimit)?n?.outgoingVideoLimit:n?.outgoingVideoLimit?.maxResolution,n?.maxOutgoingResolution),eg=(n,a,s)=>{const{outgoingVideoLimit:c}=s,u=(0,lC.isNumber)(c),m=Ru(s);if(a.sendVideoCapabilityManager?.isEnabled){const N=se=>se&&J0(se),W=(se,Re,ue,Ne)=>Re?TG(xg(Re,Ne),ue):se,ee=u?void 0:c?.maxFramerate,oe=u?void 0:c?.maxBitrate,de=Ru(s);return{...n,maxResolution:W(n?.maxResolution,de,N(a.sendVideoCapabilityManager?.minFS),N(a.sendVideoCapabilityManager?.maxFS)),maxFramerate:W(n?.maxFramerate,ee,a.sendVideoCapabilityManager?.minFPS,a.sendVideoCapabilityManager?.maxFPS),maxBitrate:W(n?.maxBitrate,oe)}}let b=xg(n?.maxResolution,m);if(m>0&&a.maxCameraFsViaCallConstraints>0){const N=J0(a.maxCameraFsViaCallConstraints);b=TG(xg(b,N),xg(m,N))}const _=xg(n?.maxBitrate,u?void 0:c?.maxBitrate),k=xg(n?.maxFramerate,u?void 0:c?.maxFramerate);return{...n,maxResolution:b,maxBitrate:_,maxFramerate:k}},Z_=(n,a,s,c)=>{if(Ru(s)>0&&a.maxCameraFsViaCallConstraints>0){const u=`outgoingVideoLimit${c??""}`,{maxResolution:m}=eg(a[u],a,s);return TG(n,m?RD(m):n)}return n},T2=(n,a,s,c)=>!((a.specCompliantSimulcast.constraintsDisableVla||a[`specCompliantSimulcast${c}`]?.constraintsDisableVla)&&s.maxSimulcastLayers<2)&&n,Bg=class extends jr{constructor(n){super(n),this.logger=n,this._constraints={},this._callConstraintsTelemetry=[]}get constraints(){return this._constraints}get callConstraintsTelemetry(){return this._callConstraintsTelemetry}addCallConstraintsTelemetryEvent(n,a){const s={timestamp:new Date().getTime(),type:a,value:n};this._callConstraintsTelemetry.push(s)}setConstraints(n){this.logger.debug("Setting new platform call constraints",JSON.stringify(n)),this._constraints=n,this.addCallConstraintsTelemetryEvent(n,"requested"),this.raiseChanged()}getSettings(n){return b2(this.logger,n,this._constraints)}},C2=dn,_2='"rtcmedia"';function mN(n){return{expires:n.expires,username:n.username,password:n.password,realm:n.realm}}var E2=class{constructor(n){this.version=n,this.reports={},this.version||(this.version=1)}watch(n){const a={time:Date.now(),duration:-1,version:this.version};return this.reports[n]&&(n=`${n}_last`),this.reports[n]=a,{end:s=>{s&&(a.error=s),a.duration=Date.now()-a.time}}}getReports(){return this.reports}};function fN(n){return{Service:n.Service,Relay:n.Relay,Token:n.Token}}var Ry="configFetch",fV="skypeTokenFetch",kG="trapTokenFetch",qee=class{constructor(n){this.updateRelaysPromise=null,this.trapTokens={},this.relaysOverride=[],this.timers=new E2,this.context=n,this.logger=n.logger.createChild("RM"),this.request=n.request,this.updateRelaysPromise||(this.updateRelaysPromise=this.updateRelaysFromConfigAsync(!0))}setRelayOverride(n){this.relaysOverride=n}setDefaultRelayConfig(n){this.config??(this.config=n)}async queryRelaysAsync(n={}){if(this.logger.info("query relays"),this.relaysOverride.length>0)return this.relaysOverride;this.updateRelaysPromise||(this.updateRelaysPromise=this.updateRelaysFromConfigAsync());const a=await this.updateRelaysPromise;return a?n.relayType==="turn"?a.Turn:n.isRemoteClientLync?a.Lync:a.Skype:[]}getAuthTokenStats(){}getStats(){return{config:fN(this.config),stats:this.timers.getReports()}}updateRelaysFromConfigAsync(n=!1){const a=this.getConfigAsync().then(()=>this.updateRelaysAsync()).then(s=>(this.updateRelaysPromise=a,s)).catch(s=>(this.updateRelaysPromise=null,n?this.logger.warn("failed to retrieve relays",ky(s)):this.logger.error("failed to retrieve relays",ky(s)),null));return a}refreshRelaysFromConfig(){this.request.isOnline()?this.updateRelaysFromConfigAsync():(this.updateRelaysPromise=null,this.logger.warn("not refreshing relays due to no network connection"))}updateRelaysAsync(){const n=this.config.Service.tokenUrl;let a;const s=async()=>(a=this.timers.watch(kG),this.context.trapTokenCredentialsProvider()),c=async()=>{const m=this.timers.watch(fV);let b="";try{b=await this.context.tokenProvider(),this.logger.info("fetching skypeToken")}catch(_){throw m.end(ky(_)),_}return m.end(),a=this.timers.watch(kG),(await this.request.get(n,{headers:{"X-Skypetoken":b,"api-version":2}})).response},u=this.context.trapTokenCredentialsProvider?s:c;return this.logger.info("Fetch TRAP token "+(this.context.trapTokenCredentialsProvider?"with provider":"directly")),u().then(m=>{a.end();let b=0;const _=this.config.Token.earlyRefreshMinutes,k=this.config.Token.earlyRefreshPercentage;this.storeTrapTokens(m),b=Math.max(m.expires-60*_,m.expires*k/100),setTimeout(this.refreshRelaysFromConfig.bind(this),1e3*b);const N=this.config.Relay.Turn.realm?this.config.Relay.Turn.realm:_2,W=mN(this.getTrapToken(N)),ee={addresses:this.config.Relay.Skype.addresses,fqdns:this.config.Relay.Skype.fqdns,tcpPort:this.config.Relay.Skype.tcpPort,udpPort:this.config.Relay.Skype.udpPort,type:"msturn"},oe={addresses:this.config.Relay.Lync.addresses,fqdns:this.config.Relay.Lync.fqdns,tcpPort:this.config.Relay.Lync.tcpPort,udpPort:this.config.Relay.Lync.udpPort,type:"msturn"},de={addresses:this.config.Relay.Turn.addresses,fqdns:this.config.Relay.Turn.fqdns,tcpPort:this.config.Relay.Turn.tcpPort,udpPort:this.config.Relay.Turn.udpPort,tlsPort:this.config.Relay.Turn.tlsPort,type:"turn"},se={Skype:[{...ee,...W}],Lync:[{...oe,...W}],Turn:[{...de,...W}]};return this.logger.info("relays from trap",[ee,oe,de]),se}).catch(m=>{throw a&&a.end(ky(m)),m})}storeTrapTokens(n){if(!n?.tokens)return void this.logger.error("failed to get tokens from trap response");const a={};n.tokens.forEach(s=>{a[s.realm]={expires:n.expires,username:s.username,password:s.password,realm:s.realm}}),this.trapTokens=a}getTrapToken(n){if(typeof n=="string"){const a=n.replace(/^"|"$/g,""),s=`"${a}"`,c=this.trapTokens[s]||this.trapTokens[a];if(c)return c}throw new Error(`token for relay not found, realm: ${n}`)}async getConfigAsync(){this.logger.info("retrieving configuration");const n=this.timers.watch(Ry);try{const a=await this.context.configProvider();n.end(),this.logger.info("retrieved configuration:",a),(0,C2.isEmpty)(a)||(this.config=a),this.logger.info("applied configuration:",this.config)}catch(a){this.logger.warn("failed to retrieve configuration",nn(a)),n.end(ky(a))}}};function Ave(n){return new qee(n)}var cw=dn,A2="aadTokenFetch",Wee=class{constructor(n){this.updateRelaysPromise=null,this.trapTokens={},this.relaysOverride=[],this.timers=new E2(2),this.context=n,this.authTokenFetcher=this.context.authTokenFetcher,this.logger=n.logger.createChild("RM2")}setRelayOverride(n){this.relaysOverride=n}setDefaultRelayConfig(n){this.config??(this.config=n),this.updateRelaysPromise||(this.updateRelaysPromise=this.updateRelaysFromConfigAsync(!0))}setClientSupportsGenericTokenApi(n){this.authTokenFetcher.supportsGenericTokenApi=n}async queryRelaysAsync(n={}){if(this.logger.info("query relays"),this.relaysOverride.length>0)return this.relaysOverride;this.updateRelaysPromise||(this.updateRelaysPromise=this.updateRelaysFromConfigAsync());const a=await this.updateRelaysPromise;return a?n.relayType==="turn"?a.Turn:n.isRemoteClientLync?a.Lync:a.Skype:[]}getStats(){return{config:fN(this.config),stats:this.timers.getReports()}}getAuthTokenStats(){return this.context.authTokenFetcher.getStats()}updateRelaysFromConfigAsync(n=!1){const a=this.getConfigAsync().then(()=>this.updateRelaysAsync()).then(s=>(this.updateRelaysPromise=a,s)).catch(s=>(this.updateRelaysPromise=null,n?this.logger.warn("failed to retrieve relays",ky(s)):this.logger.error("failed to retrieve relays",ky(s)),null));return a}refreshRelaysFromConfig(){this.context.isOnline()?this.updateRelaysFromConfigAsync():(this.updateRelaysPromise=null,this.logger.warn("not refreshing relays due to no network connection"))}async updateRelaysAsync(){const n=this.context.configProvider?.config.useNewTokenApi?A2:fV,a=this.timers.watch(n),s=hi();this.logger.info(`${s}[RM2] Fetch TRAP token`);try{const c=await this.context.authTokenFetcher.fetchTrapToken(s,this.config);a.end();let u=0;const m=this.config.Token.earlyRefreshMinutes,b=this.config.Token.earlyRefreshPercentage;this.storeTrapTokens(c),u=Math.max(c.expires-60*m,c.expires*b/100),setTimeout(this.refreshRelaysFromConfig.bind(this),1e3*u);const _=this.config.Relay.Turn.realm?this.config.Relay.Turn.realm:_2,k=mN(this.getTrapToken(_)),N={addresses:this.config.Relay.Skype.addresses,fqdns:this.config.Relay.Skype.fqdns,tcpPort:this.config.Relay.Skype.tcpPort,udpPort:this.config.Relay.Skype.udpPort,type:"msturn"},W={addresses:this.config.Relay.Lync.addresses,fqdns:this.config.Relay.Lync.fqdns,tcpPort:this.config.Relay.Lync.tcpPort,udpPort:this.config.Relay.Lync.udpPort,type:"msturn"},ee={addresses:this.config.Relay.Turn.addresses,fqdns:this.config.Relay.Turn.fqdns,tcpPort:this.config.Relay.Turn.tcpPort,udpPort:this.config.Relay.Turn.udpPort,tlsPort:this.config.Relay.Turn.tlsPort,type:"turn"},oe={Skype:[{...N,...k}],Lync:[{...W,...k}],Turn:[{...ee,...k}]};return this.logger.info("relays from trap",[N,W,ee]),oe}catch(c){throw this.logger.info(`Fetch TRAP token failed with error ${c}`),a&&a.end(ky(c)),c}}storeTrapTokens(n){const a={};if(n?.tokens)n.tokens.forEach(s=>{a[s.realm]={expires:n.expires,username:s.username,password:s.password,realm:s.realm}});else{if(!n.realm)return void this.logger.error("failed to get tokens from trap response");a[n.realm]=n}this.trapTokens=a}getTrapToken(n){if(typeof n=="string"){const a=n.replace(/^"|"$/g,""),s=`"${a}"`,c=this.trapTokens[s]||this.trapTokens[a];if(c)return c}throw new Error(`token for relay not found, realm: ${n}`)}async getConfigAsync(){this.logger.info("retrieving configuration");const n=this.timers.watch(Ry);try{const a=await this.context.relayConfigProvider();n.end(),this.logger.info("retrieved configuration:",a),(0,cw.isEmpty)(a)||(this.config=a),this.logger.info("applied configuration:",this.config)}catch(a){this.logger.warn("failed to retrieve configuration",ky(a)),n.end(ky(a))}}},vV=class{constructor(n,a,s,c,u){this.signalingAgentProvider=a,this.request=s,this.tokenProviders=c,this.configProvider=u,this.errors=[],this.clientSupportsGenericTokenAPI=!1,this.logger=n.createChild("AuthTokenFetcher")}set supportsGenericTokenApi(n){this.clientSupportsGenericTokenAPI=n}buildHeaders(n,a){const s={"api-version":2};switch(this.configProvider?.config.useTokenMigrationHeader&&(s["X-MS-Migration"]="True"),n){case 4:case 8:return s.Authorization=`Bearer ${a}`,s;case 1:return s["X-Skypetoken"]=a,s;default:throw new Error(`TokenType ${n} is not supported`)}}serviceSupportedTokenTypes(n){let a=null;if(n===void 0)a=this.clientSupportedTokenTypes();else{const s=n?.toLowerCase();a=this.constructTokenType(s)}return a===null&&this.configProvider?.config.useSkypeTokenWhenNoAuthenticateHeader&&(a|=1),a}extractWwwauthenticateHeaders(n){let a={};if(n){const s=AG(n,"www-authenticate");s&&(a={authenticationHeaders:[s]})}return a}convertStringToTokenType(n){switch(n){case"cae":return 8;case"aad":return 4;case"skype":return 1;default:return this.logger.info("[authTokenFetcher][convertStringToTokenType]unexpected: unrecognized token type ${tokenType}"),null}}getTokenTypeFromHeaders(n,a){if(!this.clientSupportsGenericTokenAPI)return 1;let s=null;const c=a?.authenticationHeaders;if(!c&&n)this.configProvider?.config.useSkypeTokenWhenNoAuthenticateHeader?(this.logger.info("[authTokenFetcher][getAuthHeadersTokenTypes] no www-authenticate header received, fallback to skype token"),s=1):(this.logger.info("[authTokenFetcher][getAuthHeadersTokenTypes] Service has not provided www-authenticate headers. use client supported tokens"),s=this.clientSupportedTokenTypes());else if(c||n){if(c&&n)for(const u of c){const m=IG(u);if(this.configProvider?.config.supportMissingTokenTypesInResponse&&m.length===0)this.logger.info("[authTokenFetcher][getAuthHeadersTokenTypes] Service has www-authenticate header, but no token types. Use client supported tokens"),s=this.clientSupportedTokenTypes();else for(const b of m){const _=this.convertStringToTokenType(b.toLowerCase());this.configProvider?.config.clientSupportsCaeToken&&_===8&&(s|=8),this.configProvider?.config.clientSupportsAadToken&&_===4&&(s|=4),this.configProvider?.config.clientSupportsSkypeToken&&_===1&&(s|=1)}}}else this.logger.info("[authTokenFetcher][getTokenTypeFromHeaders] retrying to fetch token woth client supported tokens"),s=this.clientSupportedTokenTypes();return s}constructTokenType(n){let a=null;return n.includes("aad")&&this.configProvider?.config.clientSupportsAadToken&&(a|=4),n.includes("cae")&&this.configProvider?.config.clientSupportsCaeToken&&(a|=8),n.includes("skype")&&this.configProvider?.config.clientSupportsSkypeToken&&(a|=1),a}getTokenMetadataForTrapService(n,a,s){const c={verb:"POST",path:n},u=JSON.stringify(c);let m=null;const b=this.extractWwwauthenticateHeaders(s),_=!!b?.authenticationHeaders;return m=s?this.getTokenTypeFromHeaders(_,b):this.serviceSupportedTokenTypes(a),this.logger.info(`[authTokenFetcher][getTokenMetadata] return token type=${m}, factoJson=${u}`),{tokenType:m,factorsJson:u,requestMetadataJson:b,isUnauthorized:_}}clientSupportedTokenTypes(){let n=null;return this.configProvider?.config.clientSupportsAadToken&&(n|=4),this.configProvider?.config.clientSupportsCaeToken&&(n|=8),this.configProvider?.config.clientSupportsSkypeToken&&(n|=1),n}async handleAuthTokenFailure(n,a,s,c){this.logger.info("[authTokenFetcher][handleAuthTokenFailure] failed to fetch token, retrying");try{const u=this.getTokenMetadataForTrapService(a,void 0,s);return this.logger.info(`[authTokenFetcher][handleAuthTokenFailure] token request options=${u}`),u.invalidToken=c,await this.signalingAgentProvider.getSignalingAgent().authTokenManager.getToken(n,!1,u)}catch(u){const m={status:u?.response?.status||u?.status,error:u,fatal:!0};this.errors.push(nn(m)),this.logger.error(`[authTokenFetcher] failed to fetch token trough new api with error: ${nn(m)}, quiting`)}}getRequestToken(n){const a=AG(n,"X-Skypetoken");if(a)return a;const s=AG(n,"Authorization");if(s){const c=s.split(" ");if(c.length===2)return c[1]}}async fetchTrapCredentials(n,a,s){const c=this.buildHeaders(a,n);return(await this.request.get(s,{headers:c}))?.response}async fetchTrapTokenWithNewTokenApi(n,a,s){let c;this.logger.info(`${s}[authTokenFetcher] fetching token through fetchTrapTokenWithNewTokenApi`);const u=this.getTokenMetadataForTrapService(n,a);try{return c=await this.signalingAgentProvider.getSignalingAgent().authTokenManager.getToken(s,!1,u),this.tokenTypeFetched=this.signalingAgentProvider.getSignalingAgent().authTokenManager.getLastTokenType(s),await this.fetchTrapCredentials(c,this.tokenTypeFetched,n)}catch(m){const b={status:m?.response?.status||m?.status,error:m,fatal:!1};this.errors.push(nn(b)),this.logger.error(`${s}[authTokenFetcher] fetchTrapTokenWithNewTokenApi failed with ${nn(b)}, retrying...`);const _=m?.response?.headers;if(_){const k=this.getRequestToken(_);return c=await this.handleAuthTokenFailure(s,n,_,k),this.tokenTypeFetched=this.signalingAgentProvider.getSignalingAgent().authTokenManager.getLastTokenType(s),await this.fetchTrapCredentials(c,this.tokenTypeFetched,n)}throw m}}async fetchTrapTokenThroughProvider(){return this.logger.info("[authTokenFetcher][authTokenFetcher] fetching token through fetchTrapTokenThroughProvider"),this.tokenProviders.trapTokenCredentialsProvider()}async fetchTrapTokensWithLegacyTokenFetcher(n,a){this.logger.info(`${a}[authTokenFetcher][authTokenFetcher] fetching token through fetchTrapTokensWithLegacyTokenFetcher`);try{this.tokenTypeFetched=1;const s=await this.tokenProviders.skypeTokenProvider();return(await this.request.get(n,{headers:{"X-Skypetoken":s,"api-version":2}})).response}catch(s){throw this.errors.push(nn(s)),this.logger.error(`${a}[authTokenFetcher] fetchTrapTokensWithLegacyTokenFetcher failed with ${nn(s)}`),s}}getStats(){return{tokenType:this.tokenTypeFetched,errors:nN(this.errors,this.configProvider?.config.diagnostics.telemetryLimits.numAuthTokenErrors??100)}}async fetchTrapToken(n,a){let s;this.logger.info(`${n}[AuthTokenFetcher] Start fetching token`);const c=a.Service.tokenUrl,u=a.Service.supportedTokenTypes;return s=this.configProvider?.config.useNewTokenApi?this.fetchTrapTokenWithNewTokenApi(c,u,n):this.tokenProviders.trapTokenCredentialsProvider?this.fetchTrapTokenThroughProvider():this.fetchTrapTokensWithLegacyTokenFetcher(c,n),s}},RG=class{constructor(n,a,s,c){this.config=n,this.signalingAgentProvider=a,this.ecsProvider=s,this.logger=c}getOrCreateRelayManager(){return this.config.relayManager?this.config.relayManager:this.relayManager||this.createRelayManager()}setConfigProvider(n){this.configProvider=n}createRelayManager(){return this.relayManager??(this.relayManager=this.buildRelayManager(this.config.httpRequestDispatcher,this.config.tokenProvider,this.config.configProvider,this.config.appStateProvider,this.config.trapTokenCredentialsProvider,this.configProvider))}buildRelayManager(n,a,s,c,u,m){const b=n||new h2(this.logger),_=this.ecsProvider.getEcsConfig("SkypeCalling","enableFetchApi"),k={get:(N,W)=>b.getAsync(N,{...b.getRequestOptions("GET",W?.headers,null,W?.timeout),useFetch:_}),isOnline:c.isOnline};if(this.configProvider?.config.useNewTokenApi){const N=new vV(this.logger,this.signalingAgentProvider,k,{skypeTokenProvider:a,trapTokenCredentialsProvider:u},m);return new Wee({logger:this.logger,relayConfigProvider:()=>s.getRelayConfig(),isOnline:c.isOnline,authTokenFetcher:N,configProvider:m})}return Ave({logger:this.logger,tokenProvider:a,trapTokenCredentialsProvider:u,configProvider:()=>s.getRelayConfig(),request:{get:(N,W)=>b.getAsync(N,{...b.getRequestOptions("GET",W?.headers,null,W?.timeout),useFetch:_}),isOnline:c.isOnline}})}},vN={REGISTRY_WEB:"skypecosi_concore_web_ts_calling_registry"},Ub={PARK:"*11",SHARED_LINE:"*12",SERVER_HOLD:"*13",CALL_PARK:"*14"},HR={totalParticipants:0,preheatedParticipants:0,lobbyParticipants:0,totalPresenters:0,requestingAttentionPresenters:0,totalAttendees:0,requestingAttentionAttendees:0,overflowAttendees:0},cC=Hv,yV=150,MG=30,Kee=class{constructor(n,a,s,c,u){this.eventName=n,this.eventStartTime=a,this.type=s,this.causeId=c,this.status="Pending",this.eventStartTimestamp=new Date().getTime(),this.data=[],this.causeId=c?.substring(0,8),this.type==="Event"&&delete this.status,u&&this.data.push(u)}set variant(n){this.eventVariant=n}recordSuccess(n,a){this.recordResult("Success",n,a)}recordFailure(n,a){this.recordResult("Failure",n,a)}recordTimeout(n,a){this.recordResult("Timeout",n,a)}addData(n){this.data.push(n)}isPending(){return this.status==="Pending"}getEvent(){const n={start:this.eventStartTime,duration:this.duration,status:this.status,result:this.result,causeId:this.causeId,resultCauseId:this.resultCauseId,variant:this.eventVariant,data:this.data.map(a=>this.prepareData(a,!0)).filter(a=>!!a)};return this.type==="Event"&&delete n.status,n.data.length||delete n.data,n.causeId||delete n.causeId,n.resultCauseId||delete n.resultCauseId,n.result||delete n.result,n.variant||delete n.variant,{[this.eventName]:n}}recordResult(n,a,s){this.status=n,this.result=this.prepareData(a),this.causeId!==s&&(this.resultCauseId=s),this.duration=new Date().getTime()-this.eventStartTimestamp}prepareData(n,a=!1){if(n==null)return"";if(typeof n=="string")return kn(n);if(typeof n=="number"||typeof n=="boolean")return String(n);if(typeof n=="function")return"";if(n instanceof Error)return n.toString();try{return Object.keys(n).length?a?n:Hs(n):""}catch{return"invalid"}}},PD=class{constructor(n,a,s,c){this.logger=n,this.startTime=a,this.maxEventsExceeded=s,this.perfModule=c,this.recordedEvents=[],this.ipcStats=[],this.ongoingOperations={}}recordEvent(n,a,s=hi()){this.logger.debug("Event:",n,cC.pii.Omit(a));const c=new Kee(n,this.getEventStartTime(),"Event",s,a);return this.pushToRecordedEvents(c),c}recordOperationSuccess(n,a=null,s,c,u){this.logger.info("Event success:",c,n,cC.pii.Omit(s),cC.pii.Omit(a)),this.recordOperationResult(n,a,"Success",s,c,u)}recordOperationFailure(n,a,s,c,u){this.logger.info("Event failure:",n,cC.pii.Omit(s),a),this.recordOperationResult(n,a,"Failure",s,c,u)}recordOperationTimeout(n,a,s,c,u){this.logger.info("Event timeout:",n,cC.pii.Omit(s),a),this.recordOperationResult(n,a,"Timeout",s,c,u)}maybeRecordOperationSuccess(n,a=null,s,c,u){this.hasOngoingEvent(n,s)&&this.recordOperationSuccess(n,a,s,c,u)}maybeRecordOperationFailure(n,a,s,c,u){this.hasOngoingEvent(n,s)&&this.recordOperationFailure(n,a,s,c,u)}maybeRecordOperationTimeout(n,a,s,c,u){this.hasOngoingEvent(n,s)&&this.recordOperationTimeout(n,a,s,c,u)}recordOperationResult(n,a,s,c,u,m){this.hasOngoingEvent(n,c)||this.recordOperation(n,u,c);let b=this.ongoingOperations[n];switch(c&&(b=b[c]),m&&b.addData(m),s){case"Success":b.recordSuccess(a,u);break;case"Failure":b.recordFailure(a,u);break;case"Timeout":b.recordTimeout(a,u);break;default:this.logger.error("Unknown operation record state in record operation result.")}c?delete this.ongoingOperations[n][c]:delete this.ongoingOperations[n]}recordOperation(n,a,s,c){this.logger.debug("Event create:",a,n,cC.pii.Omit(s),c);const u=new Kee(n,this.getEventStartTime(),"Operation",a,c);return this.ongoingOperations[n]||(this.ongoingOperations[n]={}),s?this.ongoingOperations[n][s]=u:this.ongoingOperations[n]=u,this.pushToRecordedEvents(u),u}setOperationVariant(n,a,s){let c;c=s?this.ongoingOperations[n][s]:this.ongoingOperations[n],c?c.variant=a:this.logger.error(`Could not find operation ${n} to set variant ${a}`)}updateOperationData(n,a,s,c){try{if(!this.ongoingOperations[n])return void this.recordEvent(n,a,s);c?this.ongoingOperations[n][c]&&this.ongoingOperations[n][c].addData(a):this.ongoingOperations[n].addData(a)}catch{return void this.logger.info(`Unable to update operation: ${n} data`)}}pushToRecordedEvents(n){if(this.maxEventsExceeded&&this.maxEventsExceeded()&&this.recordedEvents.shift(),this.recordedEvents.push(n),this.perfModule&&this.ipcStats.length<=MG){const a=this.perfModule.getIpcStats();a&&this.ipcStats.push({ingestionTime:this.getEventStartTime(),stats:a})}}hasOngoingEvent(n,a){return this.ongoingOperations[n]?!(a&&!this.ongoingOperations[n][a]&&(this.logger.warn(`Unable to find event for name\\id ${n}\\${cC.pii.Omit(a)}`),1)):(this.logger.warn(`Unable to find event for name ${n}`),!1)}getEventStartTime(){return new Date().getTime()-this.startTime}getEventTimestampBag(n,a){const s=a?[a.getEvent()]:this.recordedEvents.filter(u=>!n||!u.isPending()).map(u=>u.getEvent()),c=JSON.stringify({eventStart:this.startTime,events:s});return this.logger.info(`Call eventTimestampBag ${cC.pii.Omit(c)}`),c}getIPCStats(){return this.ipcStats.length!==0?JSON.stringify(this.ipcStats):""}removeRecordedEvent(n){const a=this.recordedEvents.indexOf(n);a>-1&&this.recordedEvents.splice(a,1)}},PG=class extends PD{constructor(n,a){super(n,a,()=>this.recordedEvents.length>yV),this.getHostName=()=>{try{return location.hostname==="localhost"||location.hostname==="127.0.0.1"?"localhost":"<redacted>"}catch{return"unknown"}},this.tsCallingVersion=wu(),this.logger=n.createChild("CallRegistryTelemetry")}setClientType(n){this.clientType=n}setEndpointId(n){this.endpointId=n}setSkypeId(n){this.skypeId=kn(n)}setApplicationType(n){this.applicationType=n}setRing(n){this.ring=n}setTenantId(n){this.tenantId=n}setUserHexCID(n){this.userHexCID=n}setAcsResourceId(n){this.acsResourceId=n}setRegion(n){this.region=n}setPartition(n){this.partition=n}getEvent(n,a){const s=c=>c===void 0?"":c;return{EndpointId:s(this.endpointId),SkypeId:s(this.skypeId),ApplicationType:s(this.applicationType),Ring:s(this.ring),TenantId:s(this.tenantId),userHexCID:s(this.userHexCID),AcsResourceId:s(this.acsResourceId),Region:s(this.region),Partition:s(this.partition),TsCallingVersion:s(this.tsCallingVersion),HostName:this.getHostName(),EventTimestampBag:this.getEventTimestampBag(n,a),DiagnosticInfo:this.callEndDiagnosticInfo,ClientType:s(this.clientType)}}removeNonPendingOperations(){this.recordedEvents=this.recordedEvents.filter(n=>n.isPending())}},DG=class extends PD{constructor(n,a,s){super(n,a,()=>this.inCallMode&&this.recordedEvents.length>yV,s),this.inCallMode=!1,this.tsCallingVersion=wu(),this.logger=n.createChild("CallTelemetry")}setClientType(n){this.clientType=n}setCallId(n){this.currentCallId&&(this.previousCallId=this.currentCallId),this.currentCallId=n}setConsultativeCallId(n){this.consultativeCallId=n}setEndpointId(n){this.endpointId=n}setParticipantId(n){this.participantId=n}setDisplayName(n){this.displayName=n}setPreheatFlags(n){this.preheatFlags=n}setCallOrigin(n){this.origin=n}setGroupId(n){this.groupId=n}setThreadId(n){this.threadId=n}setBackroomThreadId(n){this.backroomThreadId=n}setStreamThreadId(n){this.streamThreadId=n}setLobbyThreadId(n){this.lobbyThreadId=n}setComplianceRecordingContentLength(n){this.complianceRecordingContentLength=n}setConversationStartTime(n){this.conversationStartTime=n}setCompositionServiceState(n){this.compositionServiceState=n}setMessageId(n){this.messageId=n}setSkypeId(n){this.skypeId=kn(n)}setApplicationType(n){this.applicationType=n}setRing(n){this.ring=n}setTenantId(n){this.tenantId=n}setUserHexCID(n){this.userHexCID=n}setAcsResourceId(n){this.acsResourceId=n}setRegion(n){this.region=n}setPartition(n){this.partition=n}setFailureType(n){this.failureType=n}setIsCast(n){this.isCast=n?"True":"False"}setIsHuddleGroupCall(n){this.isHuddleGroupCall=n?"True":"False"}setIsEmergency(n){this.isEmergency=n?"True":"False"}setRole(n){this.isAnonymous=n==="admin"?"False":"True"}setCallType(n){this.callType=n}setConversationType(n){this.conversationType=n}setDirection(n){this.direction=n}setSelfParticipantRole(n){this.selfParticipantRole=n}setTerminationState(n){this.terminationState=n}setTerminationReason(n){this.terminationReason=n}setCallEndDiagnosticInfo(n){this.callEndDiagnosticInfo=n}setStackConfig(n){this.stackConfig=n}setJoinedFrom(n){this.joinedFrom=n}setMeetingCode(n){this.meetingCode=n}setMeetingUrl(n){this.meetingUrl=n}setHasMeetingRegistrationId(n){this.hasMeetingRegistrationId=n?"True":"False"}setHasParticipantPin(n){this.hasParticipantPin=n?"True":"False"}getEvent(n,a){const s=c=>c===void 0?"":c;return{CorrelationId:s(this.currentCallId),PreviousCorrelationId:s(this.previousCallId),ConsultativeCallId:s(this.consultativeCallId),EndpointId:s(this.endpointId),SkypeId:s(this.skypeId),ParticipantId:s(this.participantId),DisplayName:new _v(this.displayName??"",1),PreheatFlags:s(this.preheatFlags),CallType:s(this.callType),ConversationType:s(this.conversationType),Direction:s(this.direction),Origin:s(this.origin),SelfParticipantRole:s(this.selfParticipantRole),IsAnonymous:s(this.isAnonymous),GroupId:kn(s(this.groupId)),ThreadId:Qu(s(this.threadId)),MessageId:s(this.messageId),ApplicationType:s(this.applicationType),Ring:s(this.ring),TenantId:s(this.tenantId),UserHexCID:s(this.userHexCID),AcsResourceId:s(this.acsResourceId),Region:s(this.region),Partition:s(this.partition),FailureType:s(this.failureType),IsCast:s(this.isCast),IsHuddleGroupCall:s(this.isHuddleGroupCall),IsEmergency:s(this.isEmergency),TsCallingVersion:s(this.tsCallingVersion),TerminationState:s(this.terminationState),TerminationReason:s(this.terminationReason),StackConfig:s(this.stackConfig),EventTimestampBag:this.getEventTimestampBag(n,a),HostName:this.getHostName(),DiagnosticInfo:this.callEndDiagnosticInfo,JoinedFrom:this.joinedFrom,MeetingCode:this.meetingCode,MeetingUrl:this.meetingUrl,HasMeetingRegistrationId:this.hasMeetingRegistrationId,HasParticipantPin:this.hasParticipantPin,IPCStats:this.getIPCStats(),ComplianceRecordingContentLength:s(this.complianceRecordingContentLength),ConversationStartTime:s(this.conversationStartTime),BackroomThreadId:Qu(s(this.backroomThreadId)),StreamThreadId:Qu(s(this.streamThreadId)),LobbyThreadId:Qu(s(this.lobbyThreadId)),ClientType:s(this.clientType),CompositionServiceState:s(this.compositionServiceState)}}getShortEvent(){const n=a=>a===void 0?"":a;return{CorrelationId:n(this.currentCallId),EndpointId:n(this.endpointId),ParticipantId:n(this.participantId),DisplayName:new _v(this.displayName??"",1),CallType:n(this.callType),ConversationType:n(this.conversationType),Direction:n(this.direction),Origin:n(this.origin),SelfParticipantRole:n(this.selfParticipantRole),IsAnonymous:n(this.isAnonymous),ThreadId:Qu(n(this.threadId)),ApplicationType:n(this.applicationType),Ring:n(this.ring),TenantId:n(this.tenantId),UserHexCID:n(this.userHexCID),AcsResourceId:n(this.acsResourceId),Region:n(this.region),TsCallingVersion:n(this.tsCallingVersion),DiagnosticInfo:this.callEndDiagnosticInfo,JoinedFrom:this.joinedFrom,ClientType:n(this.clientType)}}switchToInCallTelemetry(){this.recordedEvents=this.recordedEvents.filter(n=>n.isPending()),this.inCallMode=!0}getHostName(){try{return location.host}catch{return"unknown"}}},I2=n=>Array.isArray(n)?n.map(a=>({endpointId:a.endpointId,participantId:a.participantId})):null,Ive=(n,a,s,c,u)=>{if(n){if(n.meetingUrl)return"MeetingUrl";if(n.meetingCode)return"MeetingCode"}return a||s?"ThreadContext":c?"GroupId":u?"Awareness":""};function dw(n,a,s){if(!n)return s.info(`sanitizeMeetingCode[${a}] empty / undefined meeting code parameter`),n;let c=n.replace(/\s/g,"");return c=c.replace(/-/g,""),s.info(`sanitizeMeetingCode[${a}] meetingCode: ${n}, sanitizedMeetingCode: ${c}`),c}function w2(n,a,s){if(!n)return s.info(`getMeetingCodeFromMeetingUrl[${a}] empty / undefined meeting Url parameter`),n;const c=new URL(n);let u="";if(c&&c.pathname&&c.pathname.split("/").length>=2){const m=c.pathname.split("/");m[m.length-2]==="meet"&&(u=m[m.length-1])}return s.info(`getMeetingCodeFromMeetingUrl[${a}] meetingUrl: ${n}, meetingUrlObject: ${xo(c)}, meetingCode: ${u}`),u}function k2(n,a,s,c){const u=dw(n&&n.meetingCode||"",s,c),m=dw(a&&a.meetingCode||"",s,c),b=(N,W)=>!!N&&!!W&&N===W;if(b(u,m))return!0;let _=w2(n&&n.meetingUrl||"",s,c);_=dw(_,s,c);let k=w2(a&&a.meetingUrl||"",s,c);if(k=dw(k,s,c),b(_,k)||b(_,m)||b(k,u))return!0;if(n&&n.meetingUrl&&a&&a.meetingUrl){const N=new URL(n.meetingUrl),W=new URL(a.meetingUrl);if(N.hostname===W.hostname&&N.pathname===W.pathname)return!0}return!1}function Ef(){}var $d={CODE:{SUCCESS:0,MEDIA_ERROR:410,CLIENT_ERROR_CODE:499,UNKNOWN_ERROR:497},SUB_CODE:{VDI_DISCONNECTED:3e3,ACTION_NOT_ALLOWED:3548,INVALID_DATA_TYPE:3757,ABANDONED:4990,ENDED_BY_REMOTE_ENDPOINT:5028,BEACON:4521,UNKNOWN_FAILURE:3545}},DD=4294967294,Af="_operationIdValue_",Y0="_causeIdValue_",LG="_callStartOptionsValue_",mp="_clientReasonValue_",OG="_guidIdValue_";function va(n,a){return uw(0,n,a)}function Fg(n,a){return uw(1,n,a)}var uu=(n,a,s)=>{if(n[a][Af])throw new Error("can not specify more than one operation id");n[a][Af]=s},Xa=(n,a,s)=>{if(n[a][Y0])throw new Error("can not specify more than one cause id");n[a][Y0]=s},R2=(n,a,s)=>{if(n[a][LG])throw new Error("can not specify options more than once");n[a][LG]=s},Jee=(n,a,s)=>{if(n[a][mp])throw new Error("can not specify reason more than once");n[a][mp]=s},NG=(n,a,s)=>{if(n[a][OG])throw new Error("can not specify more than one guid");n[a][OG]=s},uw=(n,a,s)=>(c,u,m)=>{const b=m.value,_=c[u]?.[Af],k=c[u]?.[Y0],N=c[u]?.[OG],W=c[u]?.[LG],ee=c[u]?.[mp],oe=s?.type||"Async";return m.value=function(...de){const se=this;let Re=hi();k!==void 0&&(de[k]&&(_h(de[k])||vG(de[k]))?Re=de[k]:de[k]=Re);let ue,Ne=_!==void 0?de[_]:void 0;if(Ne!==void 0){if(Array.isArray(Ne))try{const Ee=Ne.map(Pe=>Pe.toString()).sort().concat().toString();Ne=wve(Ee).toString()}catch{const Ee=`[${Ne}]${a} failed in array parsing in operationDecorator`,Pe={terminatedReason:32,terminatedReasonCode:$d.CODE.UNKNOWN_ERROR,terminatedReasonSubCode:$d.SUB_CODE.UNKNOWN_FAILURE,errorMessage:Ee};return Promise.reject(Pe)}else if(Ne&&typeof Ne=="object")try{let Ee=JSON.stringify(Ne);s&&s.operationIdKey&&Ne.hasOwnProperty(s.operationIdKey)&&(Ee=Ne[s.operationIdKey]),Ne=Ee}catch{const Ee=`[${Ne}]${a} failed in object parsing in operationDecorator`,Pe={terminatedReason:32,terminatedReasonCode:$d.CODE.UNKNOWN_ERROR,terminatedReasonSubCode:$d.SUB_CODE.UNKNOWN_FAILURE,errorMessage:Ee};return Promise.reject(Pe)}}ee!==void 0&&de[ee]&&(ue=de[ee]);const ze=Yee(se,n);if(ze.logOperation(Re,a),s&&s.singular&&ze.hasPendingOperation(a))return ze.logOperation(Re,a,"Not allowed, pending operation exists"),Promise.reject(60);if(s&&s.idempotencyLevel&&ze.getRecord(a)>0)switch(ze.logOperation(Re,a,`Called multiple times, handling operation according to specified policy: idempotency=${s.idempotencyLevel}`),s.idempotencyLevel){case"NoOp":return Promise.resolve();case"Error":return Promise.reject(60)}try{W!==void 0&&de[W]&&se.processCallStartOptions(de[W],Re)}catch{const Ee=`${a} failed in processCallStartOptions`,Pe={terminatedReason:32,terminatedReasonCode:$d.CODE.UNKNOWN_ERROR,terminatedReasonSubCode:$d.SUB_CODE.UNKNOWN_FAILURE,errorMessage:Ee};return Promise.reject(Pe)}if(N!==void 0&&de[N]&&_h(de[N])&&!vG(de[N])){let Ee=sC();Ee=Ee.replace(Ee.substring(0,8),de[N]),de[N]=Ee}const He=!(!s||!s.convertError),be=()=>oe==="Chained"?ze.executeChained(b.bind(this,...de),a,Ne,Re,He,ue,s):oe==="Sync"?ze.executeSync(b.bind(this,...de),a,Ne,Re,He,ue):ze.execute(b.bind(this,...de),a,Ne,Re,He,ue,s);if(a!=="StartCall"&&a!=="JoinCall"||ze.hasPendingOperation("_CallStartOrJoinInitiated")||ze.createPendingOperation("_CallStartOrJoinInitiated").catch(Ef),s&&s.triggerAttach&&(ze.hasPendingOperation("_ElectronSlimcoreReady")||ze.createPendingOperation("_ElectronSlimcoreReady").catch(Ef)),s&&s.type!=="Sync"){const Ee=s&&s.waitFor;if(Array.isArray(Ee))return Promise.all(Ee.map(Pe=>Pe&&ze.hasPendingOperation(Pe)&&ze.waitForOperation(Pe,void 0,Re))).then(be,be);if(Ee&&ze.hasPendingOperation(Ee))return ze.waitForOperation(Ee,void 0,Re).then(be,be)}return be()},m},Yee=(n,a)=>{if(a===0)return n._callOperationHandler;if(a===1)return n._participantOperationHandler;throw new Error("Unsupported operation handler type!")};function wve(n){let a=0;for(let s=0;s<n.length;s++)a=(a<<5)-a+n.charCodeAt(s),a|=0;return a}var xG=class{constructor(n){this._disposed=!1,this._logger=n.createChild("[ASYNC]"),this._endOperationDeferred=new Pi,this._endOperationDeferred.promise.catch(a=>{this._logger.info("Rejected all operations")}),this._deferredOperations={},this._deferredOperationsWithOperationId={},this._deferredOperationsWithCauseId={},this._logger=n}registerPromise(n,a){let s=!1;const c=()=>{s=!0};a.then(c,c);const u=this._endOperationDeferred.promise.catch(m=>{if(!s)throw new Error(`Operation ${n} did not complete, reason:${m}`)});return Promise.race([u,a])}updateOperationId(n,a){this._logger.info(`updateOperationId ${n} ${a}`),Object.keys(this._deferredOperationsWithOperationId).forEach(s=>{s&&this._deferredOperationsWithOperationId[s]&&(this._logger.info(`_deferredOperationsWithOperationId ${s}`),Object.keys(this._deferredOperationsWithOperationId[s]).forEach(c=>{c&&this._deferredOperationsWithOperationId[s][c]&&(this._logger.info(`_deferredOperationsWithOperationId ${c} ${a}`),c===n&&(this._deferredOperationsWithOperationId[s][a]=this._deferredOperationsWithOperationId[s][c],delete this._deferredOperationsWithOperationId[s][c]))}))}),Object.keys(this._deferredOperationsWithCauseId).forEach(s=>{s&&this._deferredOperationsWithCauseId[s]&&(this._logger.info(`_deferredOperationsWithCauseId ${s}`),Object.keys(this._deferredOperationsWithCauseId[s]).forEach(c=>{c&&this._deferredOperationsWithCauseId[s][c]&&(this._logger.info(`_deferredOperationsWithCauseId ${c} ${a}`),c===n&&(this._deferredOperationsWithOperationId[s][a]=this._deferredOperationsWithOperationId[s][c],delete this._deferredOperationsWithOperationId[s][c]))}))})}createPendingOperation(n,a,s=hi(),c={}){const u=new Pi;u.promise.catch(Ef);const m=this.getOperationInfoForLogging(s,n,a);let b;if(this._logger.info(`${m}[creating...]`),this._disposed)return this._logger.info(`${m}[create failed, call is disposed]`),Promise.reject(60);if(a){if(this._deferredOperationsWithOperationId[n]||(this._deferredOperationsWithOperationId[n]={}),this._deferredOperationsWithOperationId[n][a])return this._logger.warn(`${m} Deferred operation with given name and operation id is already defined`),Promise.reject(new Error(`Deferred operation with given name is already defined:${n}/${kn(a)}`));this._deferredOperationsWithOperationId[n][a]={deferred:u,causeId:s},this._deferredOperationsWithCauseId[s]||(this._deferredOperationsWithCauseId[s]={}),this._deferredOperationsWithCauseId[s][a]={deferred:u,options:c,operationName:n},b=this._endOperationDeferred.promise.catch(_=>{if(this.hasPendingOperationWithOperationId(n,a))throw new Error(`Operation ${n} ${a} did not complete, reason:${_}`)})}else{if(this._deferredOperations[n])return this._logger.warn(`${m} Deferred operation with given name is already defined`),Promise.reject(new Error(`Deferred operation with given name is already defined:${n}`));this._deferredOperationsWithCauseId[s]||(this._deferredOperationsWithCauseId[s]={}),this._deferredOperationsWithCauseId[s][""]={deferred:u,options:c,operationName:n},this._deferredOperations[n]={deferred:u,causeId:s},b=this._endOperationDeferred.promise.catch(_=>{if(this.hasPendingOperation(n))throw new Error(`Operation ${n} did not complete, reason:${_}`)})}return Promise.race([b,u.promise])}hasPendingOperation(n){return!!this._deferredOperations[n]}hasAtleastOneOfPendingOperation(n){for(const a of n)if(this.hasPendingOperation(a))return!0;return!1}hasPendingOperationWithOperationId(n,a){return!(!a||!this._deferredOperationsWithOperationId[n]||!this._deferredOperationsWithOperationId[n][a])}hasPendingOperationWithCauseId(n,a){const s=a||"";return this._deferredOperationsWithCauseId[n]&&!!this._deferredOperationsWithCauseId[n][s]}getPendingOperationWithCauseId(n,a){return this.hasPendingOperationWithCauseId(n,a)?this._deferredOperationsWithCauseId[n][a].deferred.promise:Promise.reject(`[${n}][${a}]: getPendingOperationWithCauseId for given causeId, operationId`)}resolveOperationWithCauseId(n,a,s){const c=a||"";if(this.hasPendingOperationWithCauseId(n,c)){const u=this._deferredOperationsWithCauseId[n][c],m=u.deferred.promise;return u.deferred.resolve(s),this._logger.info(`[${n}][${c}] resolved, result=${fi(s)||"void"}`),delete this._deferredOperationsWithCauseId[n][c],m}return Promise.reject(`[${n}][${c}] resolveOperationWithCauseId failed, operation not found`)}rejectOperationWithCauseId(n,a,s){const c=a||"";if(this.hasPendingOperationWithCauseId(n,c)){const u=this._deferredOperationsWithCauseId[n][c],m=u.deferred.promise;return m.catch(Ef),u.deferred.reject(s),this._logger.info(`[${n}][${c}] rejected, result=${fi(s)||"void"}`),delete this._deferredOperationsWithCauseId[n][c],m}return Promise.reject(`[${n}][${c}] rejectOperationWithCauseId failed, operation not found`)}maybeResolveOperationWithCauseId(n,a,s){this.hasPendingOperationWithCauseId(n,a)?this.resolveOperationWithCauseId(n,a,s).catch(c=>{this._logger.info(`${n}maybeResolveOperationWithCauseId failed, reason=${fi(c)}`)}):this._logger.info(`${n}maybeResolveOperationWithCauseId ignored, operation does not exist`)}maybeRejectOperationWithCauseId(n,a,s){this.hasPendingOperationWithCauseId(n,a)?this.rejectOperationWithCauseId(n,a,s).catch(Ef):this._logger.info(`${n}maybeRejectOperationWithCauseId ignored, operation does not exist`)}getPendingOperation(n,a,s=hi()){return!a&&this._deferredOperations[n]?this._deferredOperations[n].deferred.promise:a&&this._deferredOperationsWithOperationId[n]&&this._deferredOperationsWithOperationId[n][a]?this._deferredOperationsWithOperationId[n][a].deferred.promise:Promise.reject(`${this.getOperationInfoForLogging(s,n,a)}: Deferred operation with given name and operation does not exist`)}waitForOperation(n,a,s=hi()){return a&&this.hasPendingOperationWithOperationId(n,a)?this._deferredOperationsWithOperationId[n][a].deferred.promise:this.hasPendingOperation(n)?this._deferredOperations[n].deferred.promise:Promise.reject(`${this.getOperationInfoForLogging(s,n,a)}failed=wait failed, operation not found`)}resolveOperation(n,a,s,c=hi(),u=!1){if(!n)return Promise.reject("Unable to resolve deferred operation with empty name");if(s&&this.hasPendingOperationWithOperationId(n,s)){const m=this._deferredOperationsWithOperationId[n][s],b=m.deferred.promise;return m.deferred.resolve(a),this._logger.info(`${this.getOperationInfoForLogging(m.causeId,n,s)}resolved, result=${fi(a)||"void"}`),u||delete this._deferredOperationsWithOperationId[n][s],b}if(this.hasPendingOperation(n)){const m=this._deferredOperations[n],b=this._deferredOperations[n].deferred.promise;return this._deferredOperations[n].deferred.resolve(a),this._logger.info(`${this.getOperationInfoForLogging(m.causeId,n,s)}resolved, result=${fi(a)||"void"}`),u||delete this._deferredOperations[n],b}return Promise.reject(`${this.getOperationInfoForLogging(c,n,s)}failed=resolve failed, operation not found`)}rejectOperation(n,a,s,c=hi()){if(!n)return Promise.reject("Unable to reject deferred operation with empty name");if(s&&this.hasPendingOperationWithOperationId(n,s)){const u=this._deferredOperationsWithOperationId[n][s],m=u.deferred.promise;return m.catch(Ef),u.deferred.reject(a),this._logger.info(`${this.getOperationInfoForLogging(u.causeId,n,s)}rejected, reason=${fi(a)||"void"}`),delete this._deferredOperationsWithOperationId[n][s],m}if(this.hasPendingOperation(n)){const u=this._deferredOperations[n],m=u.deferred.promise;return m.catch(Ef),u.deferred.reject(a),this._logger.info(`${this.getOperationInfoForLogging(u.causeId,n,s)}rejected, reason=${fi(a)||"void"}`),delete this._deferredOperations[n],m}return Promise.reject(`${this.getOperationInfoForLogging(c,n,s)}failed=reject failed, operation not found`)}maybeResolveOperation(n,a,s,c=hi()){const u=this.getOperationInfoForLogging(c,n,s);s&&this.hasPendingOperationWithOperationId(n,s)||this.hasPendingOperation(n)?this.resolveOperation(n,a,s,c).catch(m=>{this._logger.info(`${u}maybeResolveOperation failed, reason=${fi(m)}`)}):this._logger.info(`${u}maybeResolveOperation ignored, operation does not exist`)}maybeResolveOperations(n,a,s,c=hi()){for(const u of n)this.maybeResolveOperation(u,a,s,c)}maybeRejectOperation(n,a,s,c=hi()){const u=this.getOperationInfoForLogging(c,n,s);s&&this.hasPendingOperationWithOperationId(n,s)||this.hasPendingOperation(n)?this.rejectOperation(n,a,s,c).catch(Ef):this._logger.info(`${u}maybeRejectOperation ignored, operation does not exist`)}maybeRejectOperations(n,a,s,c=hi()){for(const u of n)this.maybeRejectOperation(u,a,s,c)}rejectPendingOperations(n,a=hi()){this._disposed=!0,this._logger.info(`[${a}]rejectPendingOperations=${JSON.stringify(n)}`),Object.keys(this._deferredOperations).forEach(s=>{this.maybeRejectOperation(s,n,void 0,a),this._deferredOperationsWithOperationId[a]&&delete this._deferredOperationsWithOperationId[a][""]}),Object.keys(this._deferredOperationsWithOperationId).forEach(s=>{Object.keys(this._deferredOperationsWithOperationId[s]).forEach(c=>{this.maybeRejectOperation(s,n,c,a),this._deferredOperationsWithOperationId[a]&&delete this._deferredOperationsWithOperationId[a][c]})}),this._deferredOperations={},this._deferredOperationsWithOperationId={},this._endOperationDeferred.reject(n)}maybeRejectPendingOperationsWithPredicate(n,a=hi(),s){this._logger.info(`[${a}]rejectPendingOperationsWithPredicate`),Object.keys(this._deferredOperationsWithCauseId).forEach(c=>{Object.keys(this._deferredOperationsWithCauseId[c]).forEach(u=>{const m=this._deferredOperationsWithCauseId[c][u];m&&s(m.operationName,m.options)&&(this.maybeRejectOperation(m.operationName,n,u),this.maybeRejectOperationWithCauseId(c,u,n))})})}getOperationInfoForLogging(n,a,s=""){const c=s?`[${kn(s)}]`:"";return`[${n.substring(0,8)}][${a}]${c}`}},kve=dn,hw=class{constructor(n){this._logger=n,this._promise=Promise.resolve(void 0),this._actionQueue=[]}chainPromise(n,a,s=hi(),c=!1){const u=Date.now(),m=((typeof a=="function"?a():a)||"").toString();this._actionQueue.push(m),this._logger.info(`[${s}][${m}]enqueueing, queue=[${this._actionQueue}], reset=${c}`);const b=()=>{this._actionQueue=this._actionQueue.filter(_=>_!==m)};return c&&this.reset(s),this._promise=this._promise.catch(kve.noop).then(()=>{const _=Date.now()-u;return this._logger.info(`[${s}][${m}]begin, delayMs=${_}`),n()}),this._promise.then(()=>{b();const _=Date.now()-u;this._logger.info(`[${s}][${m}]success, durationMs=${_}`)},_=>{b();const k=Date.now()-u;this._logger.warn(`[${s}][${m}]failed=${xo(_)}, durationMs=${k}`)}),this._promise}reset(n){this._logger.info(`[${n}] resetting`),this._promise=Promise.resolve(void 0)}};function Qee(n){return!!n?.terminatedReasonCode}function SV(n){return Qee(n)?{code:n.terminatedReasonCode,subCode:n.terminatedReasonSubCode,phrase:n.errorMessage}:n}function yN(n){return!!n?.code}function Mu(n,a){let s;return s=yN(n)?n:{code:499,subCode:0,phrase:typeof n=="string"?n:fi(n)},s}function Zee(){return{code:0}}var Xee=class{constructor(){this.msElapsed=0,this.isPaused=!1,this._startTime=new Date().getTime(),this.pause=()=>{this.isPaused||(this.msElapsed+=new Date().getTime()-this._startTime,this.isPaused=!0)},this.resume=()=>{this.isPaused&&(this.isPaused=!1,this._startTime=new Date().getTime())},this.duration=()=>this.isPaused?this.msElapsed:this.msElapsed+new Date().getTime()-this._startTime,this.durationInMinutes=()=>{const n=this.duration()/6e4;return Math.ceil(n)},this.durationInSeconds=()=>{const n=this.duration()/1e3;return Math.ceil(n)}}get startTime(){return this._startTime}};function BG(){return new Xee}var bV=class extends xG{constructor(n,a,s,c,u){super(n),this.callTelemetry=a,this._ecsConfig=s,this._publishCallback=c,this._preconditionFunction=u,this._record={},this.logSuccess=(m,b,_)=>{this._logger.info(`${m} execution succeeded, result=${b?fi(b):"void"}, time=${_.duration()}`)},this.logFailure=(m,b,_)=>{this._logger.info(`${m} execution failed, reason=${this.stringifyForLogging(b)}, time=${_.duration()}`)},this.logTimeout=(m,b,_)=>{this._logger.info(`${m} execution timed out, reason=${this.stringifyForLogging(b)}, time=${_.duration()}`)},this.stringifyForLogging=m=>{let b;if(m instanceof Error)b=m.toString()||"Unknown Error";else try{b=JSON.stringify(m)}catch{b="Unable to stringify data"}return b},this.convertToTransactionEndIfErrorOrString=(m,b,_)=>{if(this._logger.info(`ecsEnableErrorConversion in operationHandler is: ${this._ecsConfig&&this._ecsConfig.enableErrorConversion}`),b&&this._ecsConfig&&this._ecsConfig.enableErrorConversion&&(typeof m=="string"||m instanceof Error)){const k=Mu(m);return this._logger.info(`${_} Error converted from ${m} to ${fi(k)}`),k}return m},this._logger=n.createChild("[Operation]"),this._chainedPromise=new hw(this._logger.createChild("[Chained]"))}resetOperationChain(n){this._chainedPromise.reset(n)}executeSync(n,a,s,c=hi(),u,m){const b=this.getOperationInfoForLogging(c,a,s),_=BG();this._logger.info(`${b}API calledSync`);const k=this.callTelemetry.recordOperation(a,c,s,m);let N;try{this._setRecord(a),N=n(),k.recordSuccess(N,c),this.logSuccess(b,N,_)}catch(W){const ee=this.convertToTransactionEndIfErrorOrString(W,u,b);k.recordFailure(ee,c),this.logFailure(b,ee,_)}return N}async executeChained(n,a,s,c=hi(),u,m,b){return this.checkPendingOperationAndExecute(n,!0,a,s,c,u,m,b)}async execute(n,a,s,c=hi(),u,m,b){return this.checkPendingOperationAndExecute(n,!1,a,s,c,u,m,b)}logOperation(n,a,...s){const c=s.length&&s.map(u=>this.stringifyForLogging(kn(u)));this._logger.info(`[${n.substring(0,8)}][${a}]API called, ${c?`with args=${c}`:""}`)}rejectPendingOperations(n,a=hi(),s){if(s){for(const c of Object.keys(this._deferredOperations))this.callTelemetry.maybeRecordOperationFailure(c,s,void 0,a);for(const c of Object.keys(this._deferredOperationsWithOperationId))for(const u of Object.keys(this._deferredOperationsWithOperationId[c]))this.callTelemetry.maybeRecordOperationFailure(c,s,u,a)}super.rejectPendingOperations(n,a)}maybeRejectOperations(n,a,s,c=hi(),u){if(u)for(const m of n)this.callTelemetry.maybeRecordOperationFailure(m,u,void 0,c);super.maybeRejectOperations(n,a,s,c)}checkPendingOperationAndExecute(n,a,s,c,u=hi(),m,b,_){const k=this.getOperationInfoForLogging(u,s,c);let N=null,W=null;return this.hasPendingOperationWithOperationId(s,c)||this.hasPendingOperation(s)?(this._logger.info(`${k}already pending, returning existing operation`),N=this.waitForOperation(s,c,u)):W=this.createPendingOperation(s,c,u,_),a?(this._logger.info(`${k}chained`),this._chainedPromise.chainPromise(()=>N||this.executeInternal(W,u,n,s,c,m,b,_),s,u)):N||this.executeInternal(W,u,n,s,c,m,b,_)}_setRecord(n){this._record.hasOwnProperty(n)||(this._record[n]=0),this._record[n]+=1}getRecord(n){return this._record[n]}_recordTelemetryTimeoutAndPublish(n,a,s,c,u,m,b){const _=n||60;return window.setTimeout(()=>{if(!this._publishCallback)return void this._logger.warn(`${u} is marked to publish telemetry but no publish callback is defined.`);if(!this.hasPendingOperationWithOperationId(c,b)&&!this.hasPendingOperation(c))return;const k=new Error(`${u} execution did not complete before telemetry timeout of ${_}s.`);this.logTimeout(u,k,m),this.callTelemetry.maybeRecordOperationTimeout(c,k,b,s),this._publishCallback(a),this.callTelemetry.removeRecordedEvent(a)},1e3*_)}_instantTelemetryPublish(n,a){this._publishCallback?(this._publishCallback(a),this.callTelemetry.removeRecordedEvent(a)):this._logger.warn(`${n} is marked to publish telemetry but no publish callback is defined.`)}parseInstantTelemetryParameters(n){let a,s=!1;return n&&(s=n.enableInstantTelemetry,a=n.telemetryTimeout),[s,a]}async executeInternal(n,a,s,c,u,m,b,_){const k=this.getOperationInfoForLogging(a,c,u);this._logger.info(`${k} executing operation...`);const N=BG(),W=this.callTelemetry.recordOperation(c,a,u,b),[ee,oe]=this.parseInstantTelemetryParameters(_);try{let de;this._setRecord(c),ee&&(de=this._recordTelemetryTimeoutAndPublish(oe,W,a,c,k,N,u)),_?.preconditionTags?.length&&this._preconditionFunction&&this._preconditionFunction(c,_.preconditionTags);const se=await s();de&&clearTimeout(de),this.callTelemetry.maybeRecordOperationSuccess(c,se,u),this.logSuccess(k,se,N),this.maybeResolveOperation(c,se,u,a)}catch(de){const se=this.convertToTransactionEndIfErrorOrString(de,m,k);this.callTelemetry.maybeRecordOperationFailure(c,SV(se),u),this.logFailure(k,se,N),this.maybeRejectOperation(c,se,u,a)}return ee&&this._instantTelemetryPublish(k,W),n}getEcsConfig(){return this._ecsConfig}},er={Cancel:487,Reject:603,NoNgcEndpoint:480,Forbidden:403,PreconditionFailed:412,Success:0,CallRedirected:302,BadRequest:400,NotFound:404,NotAcceptable:406,Timeout:408,Conflict:409,MediaError:410,ConfParticipantCountLimitReached:413,CallAccepted:450,CallForwarded:451,CallForwardedToVoicemail:452,P2pRejectCall:453,P2pFallbackForScreensharing:460,P2pFallbackDueToGroupCall:461,CallLegEndedOnService:470,CallDoesNotExist:481,NotAcceptableHere:488,NetworkError:490,GlareError:491,SkypeTokenError:495,LocalHttpStackError:496,UnknownError:497,LocalError:498,InternalServerError:500,CallModalityFailure:580,ServiceUnavailable:503},Ml={Success:0,CallRedirectedSuccess:3020,InsufficientCapabilities:5204,PolicyRestriction:5448,UserBlocked:10005,MaxLobbyParticipantLimitReached:5807,DowngradeToStreamingClient:3099,MediaDropDuringConnect:3100,MediaDropAfterConnect:3101,MediaRenegotiationError:3108,MediaPermissionError:3109,MediaUnknownError:3110,MediaOfferProcessingError:3111,MediaWhiteListingIssue:3112,MediaMuteMicrophoneError:3113,MediaMuteSpeakerError:3114,MediaUnmuteMicrophoneError:3115,MediaUnmuteSpeakerError:3115,AttachActionFailed:4103,AttachFailed:4105,RemovedFromConversation:5e3,DeniedInLobby:5854,RemovedFromCall:5300,TimedOutInLobby:5855,AnonymousJoinDisabledByPolicy:5723,B2bJoinDisabledByPolicy:5724,NoLobbyForBroadcastJoin:5354,NotAllowedDueToInformationBarrier:5810,TeamParkPolicyDisabled:10193,BroadcastLimitReached:800100,Suspended:58e4},LD={[er.Success]:1,[er.Cancel]:12,[er.Reject]:10,[er.NoNgcEndpoint]:2,[er.Timeout]:6,[er.CallAccepted]:30,[er.CallRedirected]:75,[er.NotFound]:24,[er.CallDoesNotExist]:46,[er.NotAcceptable]:5,[er.BadRequest]:5,[er.MediaError]:4,[er.ConfParticipantCountLimitReached]:59,[er.CallModalityFailure]:4,[er.NetworkError]:3,[er.LocalHttpStackError]:31,[er.LocalError]:25,[er.CallForwarded]:27,[er.CallForwardedToVoicemail]:28,[er.SkypeTokenError]:29,[er.InternalServerError]:7,[er.Conflict]:7,[er.GlareError]:7,[er.CallLegEndedOnService]:7,[er.NotAcceptableHere]:26,[er.UnknownError]:32,[er.Forbidden]:8,[er.PreconditionFailed]:65},ete={9401:33,9422:33,6102:1,6423:14,9402:14,9432:14,6519:3,9403:15,9410:36,9411:37,1e3:2,9407:17,13430:18,6009:19,10484:19,10604:19,10404:19,10420:19,10403:20,17401:20,10408:9,10486:11,10600:11,10686:11,10487:21,10500:3,10501:3,10502:3,10503:3,10504:3,10480:22,10482:22,10603:10,13406:23,13416:23},tte={500:39,403:41,404:42,480:40},OD={INCOMING_SKYPE_NGC_CALL:107,INCOMING_SKYPE_NGC_GVC_CALL:109,INCOMING_PSTN_NGC_CALL:111,INCOMING_SCREENSHARE_WITH_CHAT:119,INCOMING_CALLQUEUE_SUPERVISOR_CONTENT:125,INCOMING_TFL_TFW_CALL:126},ite={SHARED_LINE_CALL_RECORD:121,SHARED_LINE_V2_CALL_RECORD:123,MEETING_STARTED_NOTIFICATION:128},Rve={LOG_UPLOAD_EVENT:120},Ug={Unknown:"CallEndReasonUnknown",MediaError:"CallEndReasonMediaError",MediaPermissionError:"CallEndReasonMediaPermissionError",MediaDropDuringConnect:"CallEndReasonMediaDropDuringConnectError",MediaDropAfterConnect:"CallEndReasonMediaDropAfterConnectError",MediaOfferProcessingError:"CallEndReasonMediaOfferProcessingError",DowngradeToStreamingClient:"DowngradeToStreamingClient",IncompatibleOffer:"CallEndReasonIncompatibleOffer",MediaWhiteListingIssue:"MediaWhitelistingIssue",AttachFailed:"CallEndReasonAttachFailed",BadNotificationPayload:"CallEndReasonBadNotificationPayload",RetargetNotSupported:"RetargetNotSupported",CallEndReasonLocalUserInitiated:"CallEndReasonLocalUserInitiated",EndedByRemoteEndpoint:"EndedByRemoteEndpoint",CallEndReasonRedirected:"CallEndReasonRedirected",CallEndReasonVDIdisconnect:"CallEndReasonVDIdisconnect",CallEndReasonSuspended:"CallEndReasonSuspended"},FG=(n=>(n.GetSignalingMediaTypes="GetSignalingMediaTypes",n.CallStart="CallStart",n.WaitForAnswer="WaitForAnswer",n.WaitForConnect="WaitForConnect",n.Accept="Accept",n))(FG||{}),TV=(n=>(n.InitializeMediaSession="InitializeMediaSession",n.UpdateMediaModalities="UpdateMediaModalities",n.CreateOffer="CreateOffer",n.CreateAnswer="CreateAnswer",n.ProcessAnswer="ProcessAnswer",n.GetSignalingMediaTypes="GetSignalingMediaTypes",n.MuteUnmute="MuteUnmute",n.MuteUnmuteSpeakers="MuteUnmuteSpeakers",n.StartVideoSafe="StartVideoSafe",n.CompleteNegotiation="CompleteNegotiation",n.MuteInput="MuteInput",n.MuteOutput="MuteOutput",n.UnmuteInput="UnmuteInput",n.UnmuteOutput="UnmuteOutput",n.evaluateEndpointStatesForAccept="evaluateEndpointStatesForAccept",n.handleEndpointStatesForAccept="handleEndpointStatesForAccept",n))(TV||{}),jR=(n=>(n.InitializeMediaSession="InitializeMediaSession",n.ProcessOffer="ProcessOffer",n.ProcessOfferedModalities="ProcessOfferedModalities",n.TrySendingProvisionalAnswer="TrySendingProvisionalAnswer",n))(jR||{}),Zr=dn,pw=$i(dn),Mve=$i(dn),Pve=$i(Ni()),Pu={Success:"Success",ExpectedError:"ExpectedError",UnexpectedClientError:"UnexpectedClientError",UnexpectedServerError:"UnexpectedServerError"},gw={INCOMING_MESSAGE_ORIGIN:{TROUTER:"Trouter",BROKER:"Broker"},INVITATION_TYPE:{NUDGE:"nudge"},KNOWN_PAYLOAD_ENCODINGS:{GZIP:!0},WEBRTC_NOTIFICATION_TYPE:{CONTROL_VIDEO_STREAMING:"ControlVideoStreaming",DOMINANT_SPEAKER_INFO:"DominantSpeakerInfo",CSRC_INFO:"CsrcInfo"},PARTICIPANT_AUDIO_STATE:{CONNECTING:"Connecting",RINGING:"Ringing",CONNECTED:"Connected",OTHER:"Other"},HEADERS:{MESSAGE_ID:"X-Microsoft-Skype-Message-ID",ORIGINAL_MESSAGE_ID:"X-Microsoft-Skype-Original-Message-ID",CONTENT_ENCODING:"X-Microsoft-Skype-Content-Encoding",CORRELATION_ID:"X-Microsoft-Skype-Chain-ID",CONTENT_SHARING_CORRELATION_ID:"X-Microsoft-Skype-ContentSharing-Chain-ID",CLIENT_USER_AGENT:"X-Microsoft-Skype-Client",SKYPE_TOKEN:"X-Skypetoken",AUTHORIZATION:"Authorization",BEARER_KEYWORD:"Bearer",AAD_KEYWORD:"Aad",CAE_KEYWORD:"Cae",SKYPE_KEYWORD:"Skype",CACHE_SKYPE_TOKEN:"X-CacheSkypeToken",AUTHENTICATE:"www-authenticate",TOKEN_MIGRATION:"X-MS-Migration",BROKER_USE_BATCHING_HEADER_NAME:"X-UseBatching",PARTICIPANT_ID:"X-Microsoft-Skype-Participant-ID",CONTENT_TYPE:"Content-Type",RING:"MS-Teams-Ring",REGION:"MS-Teams-Region",PARTITION:"MS-Teams-Partition"},KNOWN_BOTS:{VOICEMAIL_BOT_ID:"28:14524421-25b4-403a-a0f7-e62d4379cabc"},HTTP_STACK_ERROR:{NONE:0,CANNOT_CONNECT:7,REQUEST_TIMEOUT:10,ATTEMPT_TIMEOUT:30,REQUEST_ABORTED:16,ATTEMPT_ABORTED:31,ABORTED_OTHER_ATTEMPT_SUCCESSFUL:32},HTTP_STATUS_CODES:{UNKNOWN:0,OK:200,CREATED:201,BAD_REQUEST:400,UNAUTHORIZED:401,NOT_FOUND:404,FORBIDDEN:403,PRECONDITION_FAILED:412,UNPROCESSABLE_ENTITY:422,NETWORK_ERROR:490,SKYPE_TOKEN_ERROR:495,OFFLINE:496,TIMEOUT:498,ABORTED:498,OTHER:499,INTERNAL_SERVER_ERROR:500,CONFLICT:409,BAD_GATEWAY:502,SERVICE_UNAVAILABLE:503,GATEWAY_TIMEOUT:504},CALL_END_SKYPE_TOKEN_ERROR:{code:495,subCode:4507,phrase:"CallEndReasonSkypeTokenFetchError",resultCategories:[Pu.UnexpectedClientError]},CALL_END_TOKEN_TIMEOUT_ERROR:{code:499,subCode:3119,phrase:"CallEndReasonTokenFetchTimeout",resultCategories:[Pu.UnexpectedClientError]},CALL_END_UNSUPPORTED_TOKEN_ERROR:{code:499,subCode:3126,phrase:"CallEndReasonUnsupportedTokenError",resultCategories:[Pu.UnexpectedClientError]},CALL_END_TOKEN_ERROR:{code:499,subCode:3127,phrase:"CallEndReasonTokenFetchError",resultCategories:[Pu.UnexpectedClientError]},CALL_END_TOKEN_TIMEOUT_INTERACTIVITY_REQUIRED:{code:499,subCode:3128,phrase:"CallEndReasonTokenTimeoutInterActvityRequired",resultCategories:[Pu.UnexpectedClientError]},CALL_END_LOCAL_HTTP_STACK_ERROR:{code:496,subCode:4520,phrase:"LocalHTTPStackError",resultCategories:[Pu.UnexpectedClientError]},CALL_END_UNKNOWN_ERROR:{code:497,subCode:3121,phrase:"CallEndReasonUnknownError",resultCategories:[Pu.UnexpectedClientError]},CALL_END_NETWORK_ERROR:{code:490,subCode:4502,phrase:"CallEndReasonNetworkError",resultCategories:[Pu.UnexpectedClientError]},CALL_END_DNS_HOST_NAME_RESOLVE_ERROR:{code:490,subCode:4522,phrase:"CallEndReasonDnsHostNameResolveError",resultCategories:[Pu.UnexpectedClientError]},CALL_END_LOCAL_DECLINE:{code:486,subCode:4508,phrase:"LocalDecline",resultCategories:[Pu.Success]},RESOURCE_NOT_FOUND_ERROR:{code:404,subCode:404,phrase:"ResourceNotFound",resultCategories:[Pu.ExpectedError]},CALL_STATUS:{IDLE:"Idle",RINGING:"Ringing",CONNECTING:"Connecting",CONNECTED:"Connected",CONNECTED_FOR_ROSTER_ONLY:"ConnectedForRosterOnly",LOCAL_TERMINATED:"LocalTerminated",REMOTE_TERMINATED:"RemoteTerminated"},MEDIA_TYPES:{AUDIO:"Audio",VIDEO:"Video",SCREEN_SHARER:"ScreenSharer",SCREEN_VIEWER:"ScreenViewer"},MUTE_SCOPE:{MYSELF:"Myself",EVERYONE_ELSE:"EveryoneElse",SPECIFIED_PARTICIPANTS:"SpecifiedParticipants"},URL_BASE:{CALLAGENT:"callAgent"},LINKS:{HANGUP:"hangup",MEDIA_REJECTION:"mediaRejection",MEDIA_ANSWER:"mediaAnswer",MEDIA_RENEGOTIATION:"mediaRenegotiation",ACCEPT:"accept",ATTACH:"attach",REJECT:"reject",REDIRECT:"redirect",REPLACE:"replace",TRANSFER:"transfer",NEW_OFFER:"newOffer",TRANSFER_ACCEPTANCE:"transferAcceptance",TRANSFER_COMPLETION:"transferCompletion",CONVERSATION_CONTROLLER:"conversationController",ADD_PARTICIPANT:"addParticipant",ADD_PARTICIPANTS_AND_MODALITY:"addParticipantsAndModality",LEAVE:"leave",NOTIFICATION_LINKS:"notificationLinks",REMOVE_PARTICIPANT:"removeParticipant",KEEPALIVE:"keepAlive",ADD_MODALITY:"AddModality",REMOVE_MODALITY:"RemoveModality",CONTENT_SHARING_CONTROLLER:"contentSharingController",CONTENT_SHARING_TAKE_CONTROL:"contentSharingTakeControl",CONTENT_SHARING_UPDATE_SESSION_STATE:"contentSharingUpdateSessionState",CONTENT_SHARING_UPDATE_PARTICIPANT_STATE:"contentSharingUpdateParticipantState",CONTENT_SHARING_NOTIFICATION_LINKS:"contentSharingNotificationLinks",CONTENT_SHARING_LEAVE:"contentSharingLeave",MUTE:"mute",UNMUTE:"unmute",ADMIT:"admit",ADMIT_ALL:"admitAll",CONTROL_VIDEO_STREAMING:"controlVideoStreaming",APPLY_CHANNEL_PARAMETERS:"applyChannelParameters",UPDATE_ENDPOINT_STATE:"updateEndpointState",UPDATE_ENDPOINT_METADATA:"updateEndpointMetadata",LMC_NOTIFICATION_LINKS:"lmcNotificationLinks",UPDATE_PARTICIPANT_ROLE:"updateParticipantRole",PUBLISH_STATE:"publishState",REMOVE_STATE:"removeState",UPDATE_MEETING_SETTINGS:"updateMeetingSettings",SEARCH_PARTICIPANTS:"searchParticipants",GET_ALL_PARTICIPANTS:"getAllParticipants",PARK:"park",UNPARK:"unpark",UPDATE_MEETING_LIVE_STATE:"updateMeetingLiveState",UPDATE_MEETING_GROUPS:"updateMeetingGroups",SET_MEETING_LAYOUT:"setMeetingLayout",UPDATE_PARTICIPANT_INTERPRETATION_STATE:"updateParticipantInterpretationState",JOIN_MEETING_GROUP:"joinMeetingGroup",LEAVE_MEETING_GROUP:"leaveMeetingGroup",SEND_MESSAGE:"sendMessage",UPDATE_PARTICIPANTS_PROPERTIES:"updateParticipantsProperties",UPDATE_MEDIA_DESCRIPTIONS:"updateMediaDescriptions",UPDATE_MEETING_STATES:"updateMeetingStates",UPDATE_MONITOR_SESSION:"monitor"},CONTENT_TYPE:{JSON:"application/json",SDP:"application/sdp"},TROUTER_EVENT_TYPE:{SKYPE_SKYPE_CALL:107,LYNC_SKYPE_CALL:105},MISC:{CONVERSATION:"conversation",LOBBY_CALL_CONTROLLER:"lobby",LOBBY_PARTICIPANT_STATE:"lobby"},SIGNALING_FSM_STATE:{IDLE:"Idle",INCOMING:"Incoming",WAITING_CALL_ACCEPTANCE_ACK:"WaitingCallAcceptanceAck",OUTGOING:"Outgoing",CONNECTED:"Connected",OUTGOING_FOR_ROSTER_ONLY:"OutgoingForRosterOnly",CONNECTED_FOR_ROSTER_ONLY:"ConnectedForRosterOnly"},MEDIA_RENEGOTIATION_FSM_STATE:{IDLE:"Idle",CALL_CONNECTED:"Connected",INCOMING_RENEGOTIATION:"IncomingRenegotiation",OUTGOING_RENEGOTIATION:"OutgoingRenegotiation",RENEGOTIATION_GLARE:"RenegotiationGlare"},CONTENT_SHARING_FSM_STATE:{IDLE:"Idle",CONTENT_SHARING_START_INITIATED:"ContentSharingStartInitiated",CONTENT_SHARING_JOIN_INITIATED:"ContentSharingJoinInitiated",CONTENT_SHARING_LEAVE_INITIATED:"ContentSharingLeaveInitiated",CONTENT_SHARING_DELETE_INITIATED:"ContentSharingDeleteInitiated",CONTENT_SHARING_CONNECTED:"ContentSharingConnected"},TIMEOUT_OPERATIONS:{ADD_PARTICIPANT:"AddParticipant",NUDGE_PARTICIPANT:"NudgeParticipant",REMOVE_PARTICIPANT:"RemoveParticipant",ADMIT_PARTICIPANT:"AdmitParticipant",ADMIT:"Admit",CALL_REDIRECT:"CallRedirect",CALL_ME_BACK:"CallMeBack",INCOMING_CALL_ESTABLISHMENT:"IncomingCallEstablishment",OUTGOING_CALL_ESTABLISHMENT:"OutgoingCallEstablishment",MEDIA_ANSWER:"MediaAnswer",MEDIA_ANSWER_ACKNOWLEDGEMENT:"MediaAnswerAcknowledgement",ADD_MODALITY:"AddModality",UNMUTE:"Unmute",UPDATE_MEETING_ROLE:"UpdateMeetingRole",MAX_PREAHEATED_TIMEOUT:"MaxPreheateadTimeout",PARK_COMPLETION:"ParkCompletion",UNPARK_COMPLETION:"UnparkCompletion",UPDATE_MEETING_LIVE_STATE_COMPLETION:"UpdateMeetingLiveStateCompletion",UPDATE_MEETING_GROUPS_COMPLETION:"UpgradeMeetingGroupsCompletion",UPDATE_PARTICIPANT_INTERPRETATION_STATE_COMPLETION:"UpdateParticipantInterpretationStateCompletion",UPDATE_PARTICIPANTS_PROPERTIES_COMPLETION:"UpdateParticipantsPropertiesCompletion",JOIN_MEETING_GROUP_COMPLETION:"JoinMeetingGroupCompletion",LEAVE_MEETING_GROUP_COMPLETION:"LeaveMeetingGroupCompletion",SET_MEETING_LAYOUT_COMPLETION:"SetMeetingLayoutCompletion",SEND_MESSAGE_COMPLETION:"SendMessageCompletion",DISABLE_PREHEAT_ASYNC_TIMEOUT:"DisablePreheatAsyncTimeout",UPDATE_MEETING_STATES_COMPLETION:"UpdateMeetingStatesCompletion",UPDATE_MONITOR_SESSION_COMPLETION:"UpdateMonitorSessionCompletion"},TIMEOUT_VALUES_IN_SECONDS:{ADD_PARTICIPANT_TIMEOUT:130,REMOVE_PARTICIPANT_TIMEOUT:60,INCOMING_CALL_ESTABLISHMENT_TIMEOUT:75,OUTGOING_CALL_ESTABLISHMENT_TIMEOUT:90,LONGER_OUTGOING_CALL_ESTABLISHMENT_TIMEOUT:185,MEDIA_ANSWER_TIMEOUT:35,MEDIA_ANSWER_ACKNOWLEDGEMENT_TIMEOUT:15,ADD_MODALITY_TIMEOUT:65,UNMUTE_TIMEOUT:35,ADMIT_PARTICIPANT_TIMEOUT:210,ADMIT_TIMEOUT:60,UPDATE_MEETING_ROLE_TIMEOUT:15,NUDGE_PARTICIPANT_TIMEOUT:60,CALL_ME_BACK_TIMEOUT:120,MAX_PREAHEATED_TIMEOUT:90,PARK_COMPLETION_TIMEOUT:45,UNPARK_COMPLETION_TIMEOUT:45,UPDATE_MEETING_LIVE_STATE_COMPLETION_TIMEOUT:45,UPDATE_MEETING_GROUPS_COMPLETION_TIMEOUT:45,SET_MEETING_LAYOUT_COMPLETION_TIMEOUT:45,UPDATE_PARTICIPANT_INTERPRETATION_STATE_COMPLETION_TIMEOUT:45,UPDATE_PARTICIPANTS_PROPERTIES_COMPLETION_TIMEOUT:45,JOIN_MEETING_GROUP_COMPLETION_TIMEOUT:45,LEAVE_MEETING_GROUP_COMPLETION_TIMEOUT:45,CONVERSATION_KEEP_ALIVE_TIMEOUT:2700,TOKEN_REQUIRED_TIMEOUT:20,SEND_MESSAGE_COMPLETION_TIMEOUT:15,DISABLE_PREHEAT_TIMEOUT:45,UPDATE_MEETING_STATES_COMPLETION_TIMEOUT:45,UPDATE_MONITOR_SESSION_COMPLETION_TIMEOUT:45},CALL_END_CODE:{REJECT:603,SUCCESS:0,CALL_REDIRECTED:302,CANCEL:487,TIMEOUT:408,SERVICE_UNAVAILABLE:500,BAD_REQUEST:406,NO_NGC_ENDPOINT:480,P2P_FALLBACK_FOR_SCREENSHARING:460,CONFLICT:409,MEDIA_ERROR:410,CONF_PARTICIPANT_COUNT_LIMIT_REACHED:413,CALL_DOES_NOT_EXIST:481,CALL_ACCEPTED:450,CALL_FORWARDED:451,CALL_FORWARDED_TO_VOICEMAIL:452,P2P_REJECT_CALL:453,P2P_FALLBACK_DUE_TO_GROUPCALL:461,CALL_LEG_ENDED_ON_SERVICE:470,NOT_ACCEPTABLE_HERE:488,NETWORK_ERROR:490,UNKNOWN_ERROR:497,LOCAL_ERROR:498,CALL_MODALITY_FAILURE:580,ATC_CONTROLLER_FAILURE:581,CVA_CONTROLLER_FAILURE:586,GLARE_ERROR:491,NOT_FOUND:404,SKYPE_TOKEN_ERROR:495,LOCAL_HTTP_STACK_ERROR:496,HTTP_OTHER_ERROR:499,DECODING_FAILED:407,NOT_AUTHORIZED:403,BAD_SERVICE_RESPONSE:400},CALL_END_SUB_CODE:{SUCCESS:0,CALL_REDIRECTED_SUCCESS:3020,DOWNGRADE_TO_STREAMING_CLIENT:3099,MEDIA_DROP_DURING_CONNECT:3100,MEDIA_DROP_AFTER_CONNECT:3101,MEDIA_ANSWER_PROCESSING_ERROR:3102,MEDIA_FINAL_ANSWER_PROCESSING_ERROR:3103,MEDIA_OFFER_TIMEOUT:3104,MEDIA_FINAL_ANSWER_TIMEOUT:3105,MEDIA_OFFER_NULL:3106,MEDIA_AUDIO_DEVICE_ERROR:3107,MEDIA_RENEGOTIATION_ERROR:3108,MEDIA_PERMISSION_ERROR:3109,MEDIA_UNKNOWN_ERROR:3110,MEDIA_OFFER_PROCESSING_ERROR:3111,MEDIA_WHITELISTING_ISSUE:3112,MEDIA_MUTE_MICROPHONE_ERROR:3114,MEDIA_MUTE_SPEAKER_ERROR:3115,MEDIA_UNMUTE_MICROPHONE_ERROR:3116,MEDIA_UNMUTE_SPEAKER_ERROR:3117,MEDIA_GLARE_ERROR:3118,CONVERSATION_TERMINATION_UNKNOWN_ERROR:3121,CONVERSATION_NOTIFICATION_TIMEOUT:3125,CALL_NOT_ATTEMPTED:4500,CONV_URL_NOT_SET:4501,FAILED_TO_REACH_SERVICE:4502,PLACE_CALL_FAILED:4503,ATTACH_CALL_FAILED:4504,BAD_NOTIFICATION_PAYLOAD:4505,CALL_ESTABLISHMENT_TIMEOUT:4506,SKYPE_TOKEN_ERROR:4507,CONVERSATION_RESOLUTION_CONFLICT:5704,CALL_PARTICIPANT_REMOVAL_TIMEOUT:4507,UNMUTE_REQUEST_TIMEOUT:4509,UNMUTE_REQUEST_REJECTED:4510,CONFLICT_IN_NG:4090,CONFLICT_WITH_P2P:4091,CONVERSATION_END_RECEIVED_FROM_SERVICE:4100,TRANSFER_COMPLETE_TIMEOUT:4101,ATTACH_TO_NON_EXISTENT_CALL:4102,ATTACH_ACTION_FAILED:4103,ATTACH_FAILED:4105,CONVERSATION_ESTABLISHMENT_FAILED:4106,BEFORE_CONNECT:4107,AFTER_CONNECT:4108,AFTER_ACCEPT:4109,TROUTER_CONNECTION_DROPPED:4111,DUE_TO_CALL_ASSIMILATION:4112,PREHEATED_CALL_TIMEDOUT:4113,UNPARK_COMPLETION_TIMEOUT:4114,PARK_COMPLETION_TIMEOUT:4115,UPDATE_MEETING_LIVE_STATE_COMPLETION_TIMEOUT:4116,UPDATE_MEETING_GROUPS_COMPLETION_TIMEOUT:4117,SET_MEETING_LAYOUT_COMPLETION_TIMEOUT:4118,UPDATE_PARTICIPANT_INTERPRETATION_STATE_TIMEOUT:4119,JOIN_MEETING_GROUP_TIMEOUT:4120,LEAVE_MEETING_GROUP_TIMEOUT:4121,UPDATE_PARTICIPANTS_PROPERTIES_TIMEOUT:4122,UPDATE_MEETING_STATES_COMPLETION_TIMEOUT:4123,UPDATE_MONITOR_SESSION_COMPLETION_TIMEOUT:4124,MISSING_REQUEST_URI:4511,MISC_ERROR:4512,LOCAL_HTTP_STACK_ERROR:4520,BEACON:4521,DNS_HOST_NAME_RESOLVE_ERROR:4522,CONVERSATION_ENDED_NO_NEW_OWNER_FOUND:5014,UNABLE_TO_GENERATE_MEETUP_ID:5015,UPDATE_MEETING_ROLE_REJECTED:5651,UPDATE_MEETING_ROLE_TIMEOUT:5652,PUBLISH_STATE_LINK_MISSING:5653,PUBLISH_STATE_INVALID_CONTENT:5654,PUBLISH_STATE_INVALID_SERVICE_RESPONSE:5655,REMOVE_STATE_LINK_MISSING:5656,REMOVE_STATE_MISSING_ARGUMENTS:5657,UPDATE_MEETING_SETTINGS_LINK_MISSING:5658,UPDATE_MEETING_SETTINGS_MISSING_ARGUMENTS:5659,ADMIT_ALL_LINK_MISSING:5660,ADMIT_TIMEOUT:5661,CALL_ACCEPTANCE_INVALID_SERVICE_RESPONSE:5670,ROSTER_HANDLING_INVALID_SERVICE_RESPONSE:5671,SEARCH_PARTICIPANTS_LINK_MISSING:5672,SEARCH_PARTICIPANTS_INVALID_SERVICE_RESPONSE:5673,GET_ALL_PARTICIPANTS_LINK_MISSING:5674,GET_ALL_PARTICIPANTS_INVALID_SCOPE:5675,GET_ALL_PARTICIPANTS_INVALID_SERVICE_RESPONSE:5676,PARK_UNPARK_TYPE_MISSING:5680,PARK_UNPARK_V2_DISABLED:5682,UPDATE_PARTICIPANTS_PROPERTIES_LINK_MISSING:5683,DISABLE_PREHEAT_TIMEOUT:5684,CALL_ENDED_BY_PLATFORM_AGENT:7e3,CONVERSATION_TERMINATION_INTERACTION_REQUIRED:71014},CALL_END_PHRASE:{UNKNOWN:"CallEndReasonUnknown",MEDIA_ERROR:"CallEndReasonMediaError",MEDIA_OFFER_TIMEOUT:"CallEndReasonMediaOfferTimeout",MEDIA_FINAL_ANSWER_TIMEOUT:"CallEndReasonMediaFinalAnswerTimeout",MEDIA_ANSWER_ERROR:"CallEndReasonMediaAnswerError",MEDIA_FINAL_ANSWER_ERROR:"CallEndReasonFinalAnswerError",MEDIA_PERMISSION_ERROR:"CallEndReasonMediaPermissionError",MEDIA_RENEGOTIATION_ERROR:"CallEndReasonRenegotiationError",MEDIA_DROP_DURING_CONNECT:"CallEndReasonMediaDropDuringConnectError",MEDIA_DROP_AFTER_CONNECT:"CallEndReasonMediaDropAfterConnectError",MEDIA_OFFER_PROCESSING_ERROR:"CallEndReasonMediaOfferProcessingError",MEDIA_WHITELISTING_ISSUE:"MediaWhitelistingIssue",AUDIO_ERROR:"CallEndReasonAudioDeviceError",CONVERSATION_NOTIFICATION_TIMEOUT:"ConversationNotificationTimeout",BAD_NOTIFICATION_PAYLOAD:"BadCallNotificationPayload",NETWORK_ERROR:"CallEndReasonNetworkError",LOCAL_USER_INITIATED:"CallEndReasonLocalUserInitiated",REMOTE_USER_INITIATED:"CallEndReasonRemoteUserInitiated",ESTABLISHMENT_TIMEOUT:"CallEndReasonEstablishmentTimeout",PARTICIPANT_REMOVAL_TIMEOUT:"CallParticipantRemovalTimeout",LOCAL_ERROR:"CallEndReasonLocalError",CALL_UPDATE_ERROR:"CallEndReasonCallUpdateError",CALL_REDIRECT_IS_NOT_ALLOWED:"CallRedirectisNotAllowed",P2P_FORK_CONNECTED:"CallEndReasonP2pForkConnected",P2P_FORK_FORWARDED:"CallEndReasonP2pForkForwarded",P2P_FORK_FORWARDED_TO_VOICEMAIL:"CallEndReasonP2pForkForwardedToVoiceMail",P2P_FALLBACK_FOR_SCREENSHARING:"CallEndReasonP2pFallbackForScreensharing",P2P_FALLBACK_FOR_GROUPCALL:"CallEndReasonP2pFallbackForGroupCall",P2P_FALLBACK_FOR_CALL_ASSIMILATION:"CallEndReasonP2pFallbackForCallAssimilation",P2P_FALLBACK_FOR_TRANSLATION:"CallEndReasonP2pFallbackForCallTranslation",P2P_FORK_REJECTED:"CallEndReasonP2pForkRejected",TROUTER_CONNECTION_DROPPED:"CallEndReasonTrouterConnectionDropped",REMOVED_FROM_CALL:"CallEndReasonRemovedFromCall",TRANSFER_COMPLETION_TIMEOUT:"CallEndReasonTransferCompletionTimeout",CALL_DOES_NOT_EXIST:"CallEndReasonCallDoesNotExist",ATTACH_ACTION_FAILED:"CallEndReasonAttachActionFailed",ATTACH_FAILED:"CallEndReasonAttachFailed",CONVERSATION_ESTABLISHMENT_FAILED:"CallEndReasonConversationEstablishmentFailed",CONV_END_FROM_SERVICE:"CallEndReasonConversationEndReceivedFromService",CONV_END_FROM_SERVICE_WITH_ERROR:"CallEndReasonConversationEndReceivedFromServiceWithError",SERVICE_ERROR:"CallEndReasonServiceError",CONFLICT:"CallEndReasonConflict",CALL_ALREADY_IN_P2P:"CallEndReasonCallAlreadyExistsInP2p",CONV_END_NO_MODALITY:"ConversationEndNoModalityConnected",CONV_END_FOR_ALL_INITIATED:"ConversationEndForAllInitiated",RENEGOTIATION_IN_PROGRESS:"NegotiationIsInProgress",ADD_PARTICIPANT_URL_MISSING:"AddParticipantUrlMissing",ADMIT_PARTICIPANT_URL_MISSING:"AdmitParticipantUrlMissing",ADMIT_ALL_URL_MISSING:"AdmitAllUrlMissing",UPDATE_PARTICIPANT_INTERPRETATION_STATE_URL_MISSING:"UpdateParticipantInterpretationStateUrlMissing",UPDATE_PARTICIPANTS_PROPERTIES_URL_MISSING:"UpdateParticipantsPropertiesUrlMissing",ADMIT_TIMEOUT:"AdmitTimeout",UNABLE_TO_GENERATE_MEETUP_ID:"Unable to generate GroupChat meetup id.",ENDED_BY_PMA:"Call ended by media agent.",OWNERSHIP_RESOLUTION_CONFLICT:"Conversation cannot be created due to a failure to resolve ownership.",CONVERSATION_ENDED_NO_NEW_OWNER_FOUND:"This conversation has ended since we were unable to determine a potential host for the group call.",UNMUTE_REQUEST_TIMEOUT:"UnmuteRequestTimeout",UNMUTE_REQUEST_REJECTED:"UnmuteRequestRejected",UPDATE_MEETING_ROLE_TIMEOUT:"UpdateMeetingRoleTimeout",UPDATE_MEETING_ROLE_REJECTED:"Update meeting role operation failed due to insufficient privileges.",PARK_REQUEST_FAILED:"Park Request Failed",PARK_COMPLETION_TIMEOUT:"ParkCompletionTimeout",PARK_COMPLETION_FAILED:"ParkCompletionFailed",UNPARK_REQUEST_FAILED:"UnparkFailed",UNPARK_COMPLETION_TIMEOUT:"UnparkCompletionTimeout",UNPARK_COMPLETION_FAILED:"UnparkCompletionFailed",BAD_SERVICE_RESPONSE:"BadServiceResponse",UPDATE_MEETING_LIVE_STATE_COMPLETION_TIMEOUT:"UpdateMeetingLiveStateCompletionTimeout",UPDATE_MEETING_GROUPS_COMPLETION_TIMEOUT:"UpdateMeetingGroupsCompletionTimeout",SET_MEETING_LAYOUT_COMPLETION_TIMEOUT:"SetMeetingLayoutCompletionTimeout",UPDATE_PARTICIPANT_INTERPRETATION_STATE_TIMEOUT:"UpdateParticipantInterpretationTimeout",JOIN_MEETING_GROUP_TIMEOUT:"JoinMeetingGroupTimeout",LEAVE_MEETING_GROUP_TIMEOUT:"LeaveMeetingGroupTimeout",DOWNGRADE_TO_STREAMING_CLIENT:"DowngradeToStreamingClient",MESSAGE_STATUS_WITH_FAILURE_COUNT:"NotZeroFailureCount",UPDATE_PARTICIPANTS_PROPERTIES_TIMEOUT:"UpdateParticipantsPropertiesTimeout",DISABLE_PREHEAT_TIMEOUT:"DisablePreheatTimeout",UPDATE_MEETING_STATES_COMPLETION_TIMEOUT:"UpdateMeetingStatesCompletionTimeout",UPDATE_MONITOR_SESSION_COMPLETION_TIMEOUT:"UpdateMonitorSessionCompletionTimeout"},TRANSACTION_END_CODE:{SUCCESS:0},URL_DEFAULTS:{UPLOAD_LOG_URL:"https://api.cc.skype.com/cc/v1/uploadlog/"},SUCCESS_TRANSACTION_END:{code:0,resultCategories:[Pu.Success]},VALIDATION:{VALIDATION_FAILED:6e3,NULL_OR_EMPTY:6001}},M2={REQUEST_TIMEOUT:{status:gw.HTTP_STATUS_CODES.TIMEOUT,statusText:"Request timed out",readyState:0,response:gw.HTTP_STACK_ERROR.REQUEST_TIMEOUT},ATTEMPT_TIMEOUT:{status:gw.HTTP_STATUS_CODES.TIMEOUT,statusText:"Attempt timed out",readyState:0,response:gw.HTTP_STACK_ERROR.ATTEMPT_TIMEOUT},REQUEST_ABORTED:{status:gw.HTTP_STATUS_CODES.ABORTED,statusText:"Request Aborted",readyState:0,response:gw.HTTP_STACK_ERROR.REQUEST_ABORTED},ATTEMPT_ABORTED:{status:gw.HTTP_STATUS_CODES.ABORTED,statusText:"Attempt Aborted",readyState:0,response:gw.HTTP_STACK_ERROR.ATTEMPT_ABORTED}},nte={MEDIA_ACKNOWLEDGEMENT:"/call/mediaAcknowledgement/",MEDIA_REJECTION:"/call/rejection/",ACKNOWLEDGEMENT:"/call/acknowledgement/",MEDIA_RENEGOTIATION:"/call/mediaRenegotiation/",REPLACE:"/call/replacement/",PROGRESS:"/call/progress/",MEDIA_ANSWER:"/call/mediaAnswer/",NEW_MEDIA_OFFER:"/call/newMediaOffer/",REDIRECTION:"/call/redirection/",BALANCE_UPDATE:"/call/balanceUpdate/",ACCEPT:"/call/acceptance/",CONTROL_VIDEO_STREAMING:"/call/controlVideoStreaming/",DOMINANT_SPEAKER_INFO:"/call/dominantSpeakerInfo/",CSRC_INFO:"/call/csrcInfo/",END:"/call/end/",RETARGET_COMPLETION:"/call/retargetCompletion/",TRANSFER:"/call/transfer/",TRANSFER_ACCEPTANCE:"/call/transferAcceptance/",TRANSFER_COMPLETION:"/call/transferCompletion/",PARK_COMPLETION:"/call/holdCompletion/",UNPARK_COMPLETION:"/call/resumeCompletion/",UPDATE_MEDIA_DESCRIPTIONS:"/call/updateMediaDescriptions",MONITOR_COMPLETION:"/call/monitorCompletion/"},CV={CONV_END:"/conversation/conversationEnd/",CONV_END_SUBSCRIBE:"/subscribe/conversation/conversationEnd/",CONV_END_JOIN:"/join/conversation/conversationEnd/",CONV_UPDATE:"/conversation/conversationUpdate/",CONV_LOCAL_PARTICIPANT_UPDATE:"/conversation/localParticipantUpdate/",CONV_ROSTER_UPDATE:"/conversation/rosterUpdate/",CONV_ADD_PARTICIPANT_SUCCESS:"/conversation/addParticipantSuccess/",CONV_ADD_PARTICIPANT_FAILURE:"/conversation/addParticipantFailure/",CONV_NUDGE_PARTICIPANT_SUCCESS:"/conversation/nudgeParticipantSuccess/",CONV_NUDGE_PARTICIPANT_FAILURE:"/conversation/nudgeParticipantFailure/",CONV_ADMIT_PARTICIPANT_SUCCESS:"/conversation/admitParticipantSuccess/",CONV_ADMIT_PARTICIPANT_FAILURE:"/conversation/admitParticipantFailure/",CONV_ADMIT_ALL_STATUS:"/conversation/admitAllStatus/",CONV_REMOVE_PARTICIPANT_SUCCESS:"/conversation/removeParticipantSuccess/",CONV_REMOVE_PARTICIPANT_FAILURE:"/conversation/removeParticipantFailure/",CONV_ADD_MODALITY_SUCCESS:"/conversation/addModalitySuccess/",CONV_ADD_MODALITY_FAILURE:"/conversation/addModalityFailure/",CONV_CONTENT_SHARING_UPDATE:"/conversation/contentSharingUpdate/",CONV_CONTENT_SHARING_END:"/conversation/contentSharingEnd/",CONV_BROADCAST_UPDATE:"/conversation/broadcastUpdate/",CONV_CONFIRM_UNMUTE:"/conversation/confirmUnmute/",CONV_UNMUTE_SUCCESS:"/conversation/unmuteSuccess/",CONV_UNMUTE_FAILURE:"/conversation/unmuteFailure/",UPDATE_MEETING_LIVE_STATE_STATUS:"/conversation/updateMeetingLiveStateStatus/",UPDATE_MEETING_GROUPS_STATUS:"/conversation/updateMeetingGroupsStatus/",SET_MEETING_LAYOUT_STATUS:"/conversation/setMeetingLayoutStatus/",UPDATE_PARTICIPANT_INTERPRETATION_STATE_STATUS:"/conversation/updateParticipantInterpretationStateStatus/",UPDATE_PARTICIPANT_PROPERTIES_STATUS:"/conversation/updateParticipantPropertiesStatus/",JOIN_MEETING_GROUP_STATUS:"/conversation/joinMeetingGroupStatus/",LEAVE_MEETING_GROUP_STATUS:"/conversation/leaveMeetingGroupStatus/",RECEIVE_MESSAGE:"/conversation/receiveMessage/",SEND_MESSAGE_STATUS:"/conversation/sendMessageStatus/",DISABLE_PREHEAT_ASYNC_STATUS:"/conversation/disablePreheatAsyncStatus/",UPDATE_MEETING_STATES_STATUS:"/conversation/updateMeetingStatesStatus/",MUTE_UNMUTE_ASYNC:"/conversation/muteUnmuteAsync/"},Fi={...nte,...CV},fp={CALL_NOTIFICATION:"callNotification",MEDIA_ANSWER:"mediaAnswer",MEDIA_ACKNOWLEDGEMENT:"mediaAcknowledgement",CALL_ACCEPTANCE:"callAcceptance",CALL_END:"callEnd",CALL_PROGRESS:"callProgress",CALL_ACCEPTANCE_ACKNOWLEDGEMENT:"callAcceptanceAcknowledgement",MEDIA_NEGOTIATION:"mediaNegotiation",MEDIA_NEGOTIATION_FAILURE:"mediaNegotiationFailure",BALANCE_UPDATE:"balanceUpdate",RETARGET_COMPLETED:"retargetCompleted",CALL_TRANSFER:"callTransfer",TRANSFER_COMPLETION:"transferCompletion",TRANSFER_ACCEPTANCE:"transferAcceptance",PARK_COMPLETION:"holdCompletion",UNPARK_COMPLETION:"resumeCompletion",UPDATE_MEETING_LIVE_STATE_RESPONSE:"updateMeetingLiveStateResponse",UPDATE_MEETING_GROUPS_RESPONSE:"updateMeetingGroupsResponse",SET_MEETING_LAYOUT_RESPONSE:"setMeetingLayoutResponse",UPDATE_MEETING_STATES_RESPONSE:"updateMeetingStatesResponse",MONITOR_COMPLETION:"monitorCompletion"},ge=gw,Dve=$i(dn),zb=class Eae{constructor(a){this.headers={},a&&Object.keys(a).forEach(s=>{this.headers[this.getLowerCaseName(s)]=a[s]})}isEmpty(){return Dve.isEmpty(this.headers)}set(a,s){this.headers[this.getLowerCaseName(a)]=s}get(a,s){return s?Eae.getHeaderValue(this.headers,a)||s:Eae.getHeaderValue(this.headers,a)}delete(a){delete this.headers[a],delete this.headers[a.toLowerCase()]}hasOwnPropertyCaseInsensitive(a){return Object.keys(this.headers).filter(function(s){return s.toUpperCase()===a.toUpperCase()}).length>0}getAll(){return this.headers}getLowerCaseName(a){return Eae.useLowerCaseHeaders?a.toLowerCase():a}static getHeaderValue(a,s){return a.hasOwnProperty(s)?a[s]:a.hasOwnProperty(s.toLowerCase())?a[s.toLowerCase()]:void 0}};function Vn(n,a,s=tr()){return lc(a,"trailingPath cannot be null"),xn(n,"signalingSession cannot be null"),xn(n.baseMessagingChannelUrl,"messaging channel url is not set"),`${n.baseMessagingChannelUrl}${ge.URL_BASE.CALLAGENT}/${n.sessionId}/${s}${a}`}function Lve(n){const a=n.match(new RegExp(`/${dC(ge.URL_BASE.CALLAGENT)}/+([^/]+)`,"i"));return a?a[1]:null}function UG(n){let a=1;return n.callingServiceSupportsAADTokens&&(a|=4),n.callingServiceSupportsCAETokens&&(a|=8),a}function ate(n){const a=n.toLowerCase(),s='token_types="',c=a.indexOf(s);if(c===-1)return[];const u=a.indexOf('"',c+s.length);if(u===-1)return[];const m=a.substring(c+s.length,u).trim();return m===""?[]:m.split(" ")}function P2(n){return!!n.match(/^8:/)}function SN(n){return n.replace(/^\d+:/,"")}function tr(){return My().substr(0,8)}function zG(n){return n&&/^[a-z0-9]{8}$/.test(n)?n+My().substr(8):My()}function My(){const n="xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx",a="0123456789abcdef";let s="",c=0,u=0;for(;u<36;){const m=n[u];switch(c=u%8==0?4294967295*Math.random()|0:c>>4,m){case"x":s+=a[15&c];break;case"y":s+=a[3&c|8];break;case"4":case"-":s+=m}u++}return s}function Zs(n,a){n||bN("Assert failed"+(a!==void 0?`:${a}`:""))}function lc(n,a){(!n||n instanceof String&&n===""||n instanceof Array&&n.length===0)&&bN("AssertNotNullOrEmpty failed. "+(a!==void 0?`: ${a}`:""))}function xn(n,a){n||bN("AssertNotNull failed. "+(a!==void 0?`: ${a}`:""))}function X_(n){lc(n,"callEndReason cannot be null or empty"),(n.code===void 0||n.subCode===void 0||n.phrase===void 0||n.code<0||n.subCode<0||n.phrase===" ")&&bN(`callEndReason must specify code, subCode and phrase. Invalid reason : ${fi(n)}`)}function bN(n){throw{code:ge.CALL_END_CODE.LOCAL_ERROR,subCode:ge.CALL_END_SUB_CODE.MISC_ERROR,phrase:n,resultCategories:[Pu.ExpectedError]}}function eE(n){xn(n,"MediaTypes passed cannot be null");const a=[],s=ge.MEDIA_TYPES;for(const c of Object.keys(s))D2(n,s[c])&&a.push(s[c]);return a}function VG(n,a){const s={};for(const c of Object.values(a)){const u=c.split("/");s[u[u.length-2]]=Vn(n,c)}return s}function ND(n,a){return n.length>=a.length&&n.indexOf(a,n.length-a.length)>-1}function D2(n,a){const s=a.toString().toLowerCase();return n.map(c=>c.toString().toLowerCase()).indexOf(s)>-1}function rte(n,a,s){return!n.hasOwnProperty(a)&&(n[a]=s,!0)}function mw(n,a){return!!n.hasOwnProperty(a)&&(delete n[a],!0)}function dC(n){return n.replace(/[.*+?^${}()|[\]\\]/g,"\\$&")}function Q0(n){let a=null;try{return a=JSON.parse(n),typeof a=="object"?a:null}catch{return null}}function Lr(n,a){if(!n)return{telemetryEndSubCode:ge.CALL_END_CODE.UNKNOWN_ERROR,error:ge.CALL_END_UNKNOWN_ERROR};let s;if(typeof n.response=="object")s=n.response;else try{s=JSON.parse(n.response)}catch{}if(n.skypeTokenError)return{telemetryEndSubCode:ge.CALL_END_CODE.SKYPE_TOKEN_ERROR,error:ge.CALL_END_SKYPE_TOKEN_ERROR};if(n.tokenTimeoutError&&!n.tokenInteractivityRequiredTimeout)return{telemetryEndSubCode:ge.CALL_END_CODE.HTTP_OTHER_ERROR,error:ge.CALL_END_TOKEN_TIMEOUT_ERROR};if(n.tokenError){const c=n.tokenErrorSubCode?{code:ge.CALL_END_TOKEN_ERROR.code,subCode:n.tokenErrorSubCode,phrase:ge.CALL_END_TOKEN_ERROR.phrase,resultCategories:ge.CALL_END_TOKEN_ERROR.resultCategories}:ge.CALL_END_TOKEN_ERROR;return{telemetryEndSubCode:ge.CALL_END_CODE.HTTP_OTHER_ERROR,error:c}}if(n.tokenInteractivityRequiredTimeout)return{telemetryEndSubCode:ge.CALL_END_CODE.HTTP_OTHER_ERROR,error:ge.CALL_END_TOKEN_TIMEOUT_INTERACTIVITY_REQUIRED};if(s&&(s.operationFailure||s.broadcastOperationFailure)){const c=s.operationFailure||s.broadcastOperationFailure;return{telemetryEndSubCode:c.code,error:c}}return s&&s._error?.toLowerCase()==="net::err_name_not_resolved"?{telemetryEndSubCode:ge.CALL_END_CODE.NETWORK_ERROR,error:ge.CALL_END_DNS_HOST_NAME_RESOLVE_ERROR}:s?.code?{telemetryEndSubCode:s.code,error:s}:isNaN(n.status)||n.status!==ge.CALL_END_CODE.NOT_FOUND?!isNaN(n.status)&&n.status?{telemetryEndSubCode:n.status,error:{code:n.status,subCode:isNaN(n.response)?0:n.response,phrase:n.statusText,resultCategories:[Pu.UnexpectedClientError]}}:!isNaN(n.response)&&n.response?{telemetryEndSubCode:0,error:{code:0,subCode:n.response,phrase:n.statusText,resultCategories:[Pu.UnexpectedClientError]}}:{telemetryEndSubCode:ge.CALL_END_CODE.NETWORK_ERROR,error:ge.CALL_END_NETWORK_ERROR}:{telemetryEndSubCode:ge.CALL_END_CODE.NOT_FOUND,error:ge.RESOURCE_NOT_FOUND_ERROR}}function Z0(n,a){if(n&&!n.isEmpty()&&a){const s=n.get(ge.HEADERS.ORIGINAL_MESSAGE_ID),c=n.get(ge.HEADERS.MESSAGE_ID);if(c&&D2(a,c)||s&&D2(a,s))return!0;a.length>9&&a.shift(),a.push(s||c)}return!1}function _V(n){const a="unknown";return n.headers?n.headers.get(ge.HEADERS.ORIGINAL_MESSAGE_ID,a):a}function Po(n){try{return n.headers.get(ge.HEADERS.ORIGINAL_MESSAGE_ID).replace("-","").substr(0,8)}catch{return tr()}}function ote(n,a,s){if(n&&a){const c=n.get(ge.HEADERS.ORIGINAL_MESSAGE_ID)||n.get(ge.HEADERS.MESSAGE_ID)||null;c&&(a[c]=s)}}function ste(n,a){return n&&a[n.get(ge.HEADERS.ORIGINAL_MESSAGE_ID)||n.get(ge.HEADERS.MESSAGE_ID)||null]||null}function lte(n){return n&&n.hasOwnPropertyCaseInsensitive(ge.HEADERS.CONTENT_ENCODING)}function cte(n){return n&&ge.KNOWN_PAYLOAD_ENCODINGS.hasOwnProperty(n.get(ge.HEADERS.CONTENT_ENCODING).toUpperCase())}function $G(n){const a=n.split(/\r?\n\r?\n/),s=a[0].split(/\r?\n/),c=a[1].split(/\r?\n/),u=s.shift().split(" "),m=u[0],b=u[1]||"",_=new zb;for(const k of s)try{const[N,W]=k.split(":").map(ee=>Mve.trim(ee));_.set(N,W)}catch(N){throw new Error(`Malformed header: ${k+N}`)}return{url:b,headers:_,method:m,body:c.join("")}}function EV(n){const a=atob(n);return Pve.inflate(a,{to:"string"})}function Pl(){let n,a,s=!0;return{isPending:()=>s,promise:new Promise((c,u)=>{n=c,a=u}),resolve:c=>{s&&(n(c),s=!1)},reject:c=>{s&&(a(c),s=!1)}}}function HG(n){let a=!1;try{if(a=n&&n.state()===2,navigator.onLine&&a)return 3;if(!navigator.onLine&&a)return 2;if(navigator.onLine&&!a)return 1}catch{}return 0}function dte(n){return[ge.HTTP_STATUS_CODES.UNKNOWN,ge.HTTP_STATUS_CODES.UNAUTHORIZED,ge.HTTP_STATUS_CODES.NETWORK_ERROR,ge.HTTP_STATUS_CODES.OFFLINE,ge.HTTP_STATUS_CODES.TIMEOUT,ge.HTTP_STATUS_CODES.INTERNAL_SERVER_ERROR,ge.HTTP_STATUS_CODES.BAD_GATEWAY,ge.HTTP_STATUS_CODES.SERVICE_UNAVAILABLE,ge.HTTP_STATUS_CODES.GATEWAY_TIMEOUT].indexOf(n)>=0}function jG(n,a){switch(n){case ge.HEADERS.CAE_KEYWORD.toLowerCase():return 8;case ge.HEADERS.AAD_KEYWORD.toLowerCase():return 4;case ge.HEADERS.SKYPE_KEYWORD.toLowerCase():return 1;default:return a?.info("unexpected: unrecognized token type ${tokenType}"),null}}function ute(n,a,s,c,u){if(!a)return 1;const{callingServiceSupportsAADTokens:m,callingServiceSupportsCAETokens:b,supportMissingTokenTypesInResponse:_,useSkypeTokenWhenNoAuthenticateHeader:k}=n,N=u?.authenticationHeaders;c?.info(`[getAuthHeadersTokenTypes] UnauthorizedResponse=${s} and authHeaders=${N}`);let W=null;if(!N&&s)k?(c?.info("[getAuthHeadersTokenTypes] no www-authenticate header received, fallback to skype token"),W=1):(c?.info("[getAuthHeadersTokenTypes] Service has not provided www-authenticate headers. use client supported tokens"),W=UG(n));else if(N||s){if(N&&s)for(const ee of N){const oe=ate(ee);if(_&&oe.length===0)c?.info("[getAuthHeadersTokenTypes] Service has www-authenticate header, but no token types. Use client supported tokens"),W=UG(n);else for(const de of oe){const se=jG(de.toLowerCase(),c);b&&se===8&&(W|=8),m&&se===4&&(W|=4),se===1&&(W|=1)}}}else c?.info("[getAuthHeadersTokenTypes] first time requesting token, request client supported token types"),W=UG(n);return W}function Ove(n){switch(n){case 0:return"GET";case 1:return"POST";case 2:return"PUT";case 3:return"DELETE"}}function Vb(n){let a={};if(n){const s=zb.getHeaderValue(n,ge.HEADERS.AUTHENTICATE);s&&(a={authenticationHeaders:[s]})}return a}function AV(n,a,s,c,u=!1,m,b){b?.createChild("[utils.ts]");const _={verb:Ove(s),path:c.url},k=JSON.stringify(_),N=Vb(m),W=ute(n,a,u,b,N);return b?.info(`[getTokenMetadata] return token type=${W}, factoJson=${k}, headers=${N?.authenticationHeaders}`),{tokenType:W,factorsJson:k,requestMetadataJson:N,isUnauthorized:u}}function TN(){return Math.floor(Date.now()/1e3)}function Nve(n){return n/1e3}function fw(n){return 1e3*n}function xve(n){const a=zb.getHeaderValue(n,ge.HEADERS.SKYPE_TOKEN);if(a)return a;const s=zb.getHeaderValue(n,ge.HEADERS.AUTHORIZATION);if(s){const c=s.split(" ");if(c.length===2)return c[1]}}function hte(n){switch(n){case"none":return"None";case"teamPark":return"TeamPark";case"callPark":return"CallParkV2";case"serverHold":return"ServerHold";case"serverHoldV2":return"MusicOnHoldV2";case"sharedLinePark":return"SharedLinePark";case"sharedLineParkV2":return"SharedLineAppearanceV2";default:return"UnknownType"}}function IV(n){switch(n){case"raiseHands":return"raiseHands";case"ufd":return"ufd";case"attendeeModalitiesUnrestricted":return"attendeeModalitiesUnrestricted";case"attendeeAudioRestricted":return"attendeeAudioRestricted";case"attendeeVideoRestricted":return"attendeeVideoRestricted";case"attendeeVideoUnrestricted":return"attendeeVideoUnrestricted";case"spotlight":return"spotlight";case"weatherPerson":return"weatherPerson";case"sharingLayoutType":return"sharingLayoutType";case"manageBreakoutRooms":return"manageBreakoutRooms";case"togetherMode":return"togetherMode";case"consentToRecording":return"consentToRecording";case"denyConsentToRecording":return"denyConsentToRecording";case"clientMediaUfd":return"clientMediaUfd";case"serverMediaUfd":return"serverMediaUfd";case"dhhSigner":return"dhhSigner";case"signLanguageInterpreter":return"signLanguageInterpreter";default:throw"Invalid state type when converting PublishType to PublishStateType."}}function L2(n){switch(n){case"raiseHands":return"raiseHands";case"ufd":return"ufd";case"attendeeModalitiesUnrestricted":return"attendeeModalitiesUnrestricted";case"attendeeAudioRestricted":return"attendeeAudioRestricted";case"attendeeVideoRestricted":return"attendeeVideoRestricted";case"attendeeVideoUnrestricted":return"attendeeVideoUnrestricted";case"spotlight":return"spotlight";case"weatherPerson":return"weatherPerson";case"sharingLayoutType":return"sharingLayoutType";case"manageBreakoutRooms":return"manageBreakoutRooms";case"togetherMode":return"togetherMode";case"consentToRecording":return"consentToRecording";case"denyConsentToRecording":return"denyConsentToRecording";case"clientMediaUfd":return"clientMediaUfd";case"serverMediaUfd":return"serverMediaUfd";case"dhhSigner":return"dhhSigner";case"signLanguageInterpreter":return"signLanguageInterpreter";default:throw"Invalid state type when converting PublishStateType to PublishType."}}function vw(n){let a={};return n.additionalData&&n.customHeaderContext?a=typeof n.additionalData=="object"?{...n.additionalData,customContext:n.customHeaderContext}:{additionalData:n.additionalData,customContext:n.customHeaderContext}:!n.additionalData&&n.customHeaderContext?a={customContext:n.customHeaderContext}:n.additionalData&&!n.customHeaderContext&&(a=n.additionalData),a}function pte(n){if(!n)return;let a="unknown";return n==="substrate"&&(a="substrate"),a}var X0=class ECe{static isInLobby(a,s){for(const c of a)if(c.endpointId===s&&c.isLobby)return!0;return!1}static isParticipantServerMuted(a){for(const s of a)if(s.mediaStreams&&!s.mappedTo){for(const c of s.mediaStreams)if(c.type==="audio"&&c.serverMuted===!0)return!0}return!1}static fromWireParticipant(a){return xn(a,"invalid wireParticipant"),lc(a.id,"participant must have valid Id"),new ECe({id:a.id,displayName:a.displayName,languageId:a.languageId,acceptedBy:a.acceptedBy})}static getPluginlessStateTypeFromWire(a){return IV(a)}static findOrCreateTypeState(a,s){let c=s.typeStates.findIndex(u=>u.type===a);if(c===-1){const u={participantStates:[],type:a};s.typeStates.push(u),c=s.typeStates.length-1}return c}static processPublishedStates(a,s){const c={typeStates:[]};c.typeStates=[];const u=a;return pw.forEach(u,m=>{const b=this.findOrCreateTypeState(this.getPluginlessStateTypeFromWire(m.stateType),c),_={id:s,publishedState:{content:m.content,stateId:m.stateId,typeRank:m.typeRank}};c.typeStates[b].participantStates.push(_)}),c}static fromRosterEndpoints(a){let s=[],c=!1,u=!1,m=!1,b=!1;return s=Object.keys(a).map(_=>{let k,N,W,ee=[],oe=!1,de=0;if(a[_].call&&(c=!0,ee=a[_].call.mediaStreams||null,de=a[_].call.serverMuteVersion||0,N=a[_].call.appliedInteractivityLevel||"unknown",W=a[_].call.negotiationTag),a[_].lobby&&(oe=!0,u=!0,ee=a[_].lobby.mediaStreams||null),a[_].broadcast?.sessionInformation&&(k=a[_].broadcast.sessionInformation.role||null),a[_].mappedParticipant&&(m=!0,ee=a[_].mappedParticipant.mediaStreams||null),!a[_].capabilities&&a[_].endpointCapabilities){const se=a[_].endpointCapabilities;a[_].capabilities={implicitCallback:16&se?"enabled":"disabled",cloudAudioVideoConference:1&se?"enabled":"disabled",cloudScreenSharing:2&se?"enabled":"disabled",hostlessConference:4&se?"enabled":"disabled",autoJoinOnConflict:32&se?"enabled":"disabled",serverMuteUnmute:64&se?"enabled":"disabled",supportsCompressedServicePayload:128&se?"enabled":"disabled",cloudMerge:8&se?"enabled":"disabled"}}return b=b||!!a[_].streamLobby||!!a[_].stream,{endpointId:_,participantId:a[_].participantId||null,clientVersion:a[_].clientVersion||null,endpointMetadata:a[_].endpointMetadata||null,originalId:a[_].originalId||null,contentSharing:a[_].contentSharing||null,capabilities:a[_].capabilities||null,endpointType:a[_].endpointType||"default",deviceType:a[_].deviceType||void 0,clientEndpointCapabilities:a[_].clientEndpointCapabilities||void 0,mediaStreams:ee,serverMuteVersion:de,broadcastMeetingRole:k,isLobby:oe,endpointState:a[_].endpointState||null,publishedStates:a[_].publishedStates||null,callLinks:a[_].callLinks||null,appliedInteractivityLevel:N||"unknown",mappedTo:a[_].mappedTo||null,meetingGroupDetails:a[_].meetingGroupDetails,streamInformation:a[_].streamInformation,propertyBag:a[_].propertyBag,streamLobby:a[_].streamLobby,stream:a[_].stream,endpointMeetingRoles:a[_].endpointMeetingRoles,negotiationTag:W}}),{endpointDetails:s,participantHasCallModality:c,participantIsInLobby:u,participantHasMappedEndpoint:m,participantHasStreamEndpoint:b}}static fromRoster(a,s=!1){xn(a,`invalid rosterParticipant ${JSON.stringify(a)}`),lc(a.details.id,"participant must have valid Id");const c=a.endpoints||{},u=this.fromRosterEndpoints(c),m=u.endpointDetails,b=u.participantHasCallModality,_=u.participantHasMappedEndpoint,k=u.participantHasStreamEndpoint;let N=u.participantIsInLobby;return b||N||_||s||k?(b&&(N=!1),new ECe({id:a.details.id,displayName:a.details.displayName,otpIdentity:a.details.otpIdentity,version:a.version||0,propertyBag:a.details.propertyBag||null,languageId:a.details.languageId,role:a.role||"",tenantId:a.details.tenantId||"",endpointDetails:m||[],acceptedBy:a.acceptedBy||"",isLobby:N,meetingRole:a.meetingRole,advancedMeetingRole:a.advancedMeetingRole,meetingRoles:a.meetingRoles,participantType:a.details.participantType,publishedStates:a.publishedStates||null,isIdentityMasked:a.details.isIdentityMasked,nonMaskedId:a.details.nonMaskedId||"",nonMaskedObjectId:a.details.nonMaskedObjectId||"",nonMaskedDisplayName:a.details.nonMaskedDisplayName||"",maskedIdSeqNumber:a.details.maskedIdSeqNumber||0,maskedId:a.details.maskedId||"",joinAsStreamingUser:a.joinAsStreamingUser,enableCaptcha:a.enableCaptcha})):null}static fromRosterSearchResults(a){xn(a,`invalid rosterParticipant ${JSON.stringify(a)}`),lc(a.details.id,"participant must have valid Id");const s=a.endpoints,{endpointDetails:c,participantHasCallModality:u,participantIsInLobby:m,participantHasMappedEndpoint:b,participantHasStreamEndpoint:_}=this.fromRosterEndpoints(s);let k=0;return u||_?k=3:m?k=10:b&&(k=3),{id:a.details.id,state:k,tenantId:a.details.tenantId||"",displayName:a.details.displayName,role:a.role||"",meetingRole:a.meetingRole,advancedMeetingRole:a.advancedMeetingRole,meetingRoles:a.meetingRoles,participantType:a.details.participantType,isServerMuted:this.isParticipantServerMuted(c),publishedStates:this.processPublishedStates(a.publishedStates,a.details.id),endpoints:c||[],isIdentityMasked:a.details.isIdentityMasked,nonMaskedId:a.details.nonMaskedId||"",nonMaskedDisplayName:a.details.nonMaskedDisplayName||"",nonMaskedObjectId:a.details.nonMaskedObjectId||"",maskedIdSeqNumber:a.details.maskedIdSeqNumber||0,maskedId:a.details.maskedId||"",joinAsStreamingUser:a.joinAsStreamingUser}}constructor(a){this.id=a.id,this.displayName=a.displayName||"",this.otpIdentity=a.otpIdentity,this.version=a.version,this.propertyBag=a.propertyBag,this.languageId=a.languageId||null,this.endpointDetails=a.endpointDetails||[],this.acceptedBy=a.acceptedBy,this.role=a.role,this.tenantId=a.tenantId,this.isLobby=a.isLobby,this.meetingRole=a.meetingRole,this.advancedMeetingRole=a.advancedMeetingRole,this.meetingRoles=a.meetingRoles,this.participantType=a.participantType,this.publishedStates=a.publishedStates,this.isIdentityMasked=a.isIdentityMasked,this.nonMaskedId=a.nonMaskedId,this.nonMaskedDisplayName=a.nonMaskedDisplayName,this.nonMaskedObjectId=a.nonMaskedObjectId,this.maskedIdSeqNumber=a.maskedIdSeqNumber,this.maskedId=a.maskedId,this.joinAsStreamingUser=a.joinAsStreamingUser,this.enableCaptcha=a.enableCaptcha}},Ft={HANDLE_MEDIA_ACKNOWLEDGEMENT:"HandleMediaAcknowledgement",HANDLE_MEDIA_NEGOTIATION_FAILURE:"HandleMediaNegotiationFailure",HANDLE_MEDIA_ANSWER:"HandleMediaAnswer",HANDLE_MEDIA_ANSWER_FAILED:"HandleMediaAnswerFailed",HANDLE_MEDIA_OFFER:"HandleMediaOffer",REJECT_RENEGOTIATION:"RejectRenegotiation",HANDLE_RETARGET_COMPLETED:"HandleRetargetCompleted",HANDLE_MEDIA_ANSWER_TIMEOUT:"HandleMediaAnswerTimeout",HANDLE_MEDIA_ACKNOWLEDGEMENT_TIMEOUT:"HandleMediaAcknowledgementTimeout",ACCEPT_RENEGOTIATION:"AcceptRenegotiation",START_RENEGOTIATION:"StartRenegotiation",MEDIA_FSM_STATE_CHANGED:"MediaFsmStateChanged",ADD_MODALITY_TIMEOUT:"AddModalityTimeout",ADD_PARTICIPANT:"AddParticipant",ADD_PARTICIPANT_TIMEOUT:"AddParticipantTimeout",ADD_PARTICIPANT_WITH_REPLACES:"AddParticipantWithReplaces",ADD_PARTICIPANT_WITH_REPLACES_TIMEOUT:"AddParticipantWithReplacesTimeout",ADD_PARTICIPANTS_AND_MODALITY:"AddParticipantsAndModality",ADMIT_PARTICIPANT:"AdmitParticipant",ADMIT_PARTICIPANT_TIMEOUT:"AdmitParticipantTimeout",ADMIT:"Admit",ADMIT_TIMEOUT:"AdmitTimeout",ADMIT_FAILURE:"AdmitFailure",ADMIT_SUCCESS:"AdmitSuccess",CALL_ME_BACK:"CallMeBack",CALL_ME_BACK_TIMEOUT:"CallMeBackTimeout",REMOVE_PARTICIPANT:"RemoveParticipant",REMOVE_PARTICIPANT_OTHERS:"RemoveParticipantOthers",REMOVE_PARTICIPANT_SPECIFIED:"RemoveParticipantSpecified",REMOVE_PARTICIPANT_TIMEOUT:"RemoveParticipantTimeout",HANDLE_ADD_PARTICIPANT_SUCCESS:"HandleAddParticipantSuccess",HANDLE_ADD_PARTICIPANT_FAILURE:"HandleAddParticipantFailure",HANDLE_ADMIT_PARTICIPANT_SUCCESS:"HandleAdmitParticipantSuccess",HANDLE_ADMIT_PARTICIPANT_FAILURE:"HandleAdmitParticipantFailure",HANDLE_ADD_PARTICIPANT_MODALITY_FAILURE:"HandleAddParticipantModalityFailure",HANDLE_REMOVE_PARTICIPANT_SUCCESS:"HandleRemoveParticipantSuccess",HANDLE_REMOVE_PARTICIPANT_FAILURE:"HandleRemoveParticipantFailure",HANDLE_ROSTER_UPDATE:"HandleRosterUpdate",HANDLE_ROSTER_UPDATE_FAIL:"HandleRosterUpdateFail",HANDLE_CONVERSATION_UPDATE:"HandleConversationUpdate",HANDLE_LOCAL_PARTICIPANT_UPDATE:"HandleLocalParticipantUpdate",SET_SUBJECT:"SetSubject",SET_JOINED_FROM:"SetJoinedFrom",SET_DEVICETYPE:"SetDeviceType",GET_EMERGENCY_CONTENT:"GetEmergencyContent",SET_MULTIPARTY:"SetMultiparty",SET_GROUPID:"SetGroupId",SET_THREADID:"SetThreadId",SET_CALLOPTIONS:"SetCallOptions",SET_TRANSFER_CONTEXT:"SetTransferContext",START_CALL:"StartCall",JOIN_CALL:"JoinCall",START_OR_JOIN_CALL:"StartOrJoinCall",JOIN_CONVERSATION_WITHOUT_CALL_MODALITY:"JoinConversationWithoutCallModality",HANDLE_INCOMING_CALL:"HandleIncomingCall",END_CALL:"EndCall",END_WITH_BEACON:"EndWithBeacon",REJECT_WITH_FETCH_KEEP_ALIVE:"RejectWithFetchKeepAlive",END_WITH_FETCH_KEEP_ALIVE:"EndWithFetchKeepAlive",CONFLICTED_CALL:"ConflictedCall",SET_PROVISIONAL_ANSWER:"SetProvisionalAnswer",SET_PROVISIONAL_ANSWER_FAILED:"SetProvisionalAnswerFailed",ACCEPT_CALL:"AcceptCall",ACCEPT_CALL_FAILED:"AcceptCallFailed",HANDLE_CALL_ACCEPTANCE_ACK:"HandleCallAcceptanceAck",HANDLE_CALL_ACCEPTANCE:"HandleCallAcceptance",HANDLE_CALL_ACCEPTANCE_SYNC:"HandleCallAcceptanceSync",HANDLE_CALL_ACCEPTANCE_FAILED:"HandleCallAcceptanceFailed",HANDLE_CALL_ESTABLISHMENT_TIMEOUT:"HandleCallEstablishmentTimeout",HANDLE_CALL_END:"HandleCallEnd",HANDLE_CALL_PROGRESS:"HandleCallProgress",TROUTER_URL_CHANGED:"TrouterUrlChanged",TROUTER_STATE_CHANGED:"TrouterStateChanged",TROUTER_URL_CHANGED_TO_INVALID:"TrouterUrlChangedToInvalid",TROUTER_URL_UPDATE_FAILED:"TrouterUrlUpdateFailed",ADD_CONTENT_SHARING_MODALITY:"AddContentSharingModality",ACCEPTED_BEFORE_RINGING:"AcceptedBeforeRinging",LEAVE_CONTENT_SHARING:"LeaveContentSharing",DELETE_CONTENT_SHARING:"DeleteContentSharing",TAKE_CONTROL_CONTENT_SHARING:"TakeControlContentSharing",UPDATE_SESSION_STATE_CONTENT_SHARING:"UpdateSessionStateContentSharing",JOIN_CONTENT_SHARING:"JoinContentSharing",UPDATE_PARTICIPANT_STATE_CONTENT_SHARING:"UpdateParticipantStateContentSharing",HANDLE_CONTENT_SHARING_UPDATE:"HandleContentSharingUpdate",HANDLE_CONTENT_SHARING_END:"HandleContentSharingEnd",CONTENT_SHARING_START_FROM_ROSTER:"ContentSharingStartFromRoster",CONTENT_SHARING_END_FROM_ROSTER:"ContentSharingEndFromRoster",HANDLE_ADD_MODALITY_SUCCESS:"HandleAddModalitySuccess",HANDLE_ADD_MODALITY_FAILURE:"HandleAddModalityFailure",ADD_BROADCAST_MODALITY:"AddBroadcastModality",ADD_MODALITY:"AddModality",UPDATE_BROADCAST_DETAILS:"UpdateBroadcastDetails",WAITING_FOR_ADD_BROADCAST_MODALITY_COMPLETION:"WaitingForAddBroadcastModalityCompletion",WAITING_FOR_ADD_MODALITY_COMPLETION:"WaitingForAddModalityCompletion",MUTE:"Mute",NUDGE_PARTICIPANT_TIMEOUT:"NudgeParticipantTimeout",UNMUTE:"Unmute",UNMUTE_TIMEOUT:"UnmuteTimeout",HANDLE_UNMUTE_CONFIRM:"HandleUnmuteConfirm",HANDLE_UNMUTE_SUCCESS:"HandleUnmuteSuccess",HANDLE_UNMUTE_FAILURE:"HandleUnmuteFailure",APPROVE_UNMUTE:"ApproveUnmute",REJECT_UNMUTE:"RejectUnmute",HANDLE_CONTROL_VIDEO_STREAMING:"HandleControlVideoStreaming",HANDLE_DOMINANT_SPEAKER_CHANGED_COUNT:"HandleDominantSpeakerChangedCount",HANDLE_CSRC_INFO:"HandleCsrcInfo",SEND_WEBRTC_MEDIA_NOTIFICATION:"SendWebRtcMediaNotification",HANDLE_BALANCE_UPDATE:"HandleBalanceUpdate",TRANSFER_CALL:"TransferCall",PARK_CALL:"ParkCall",CALL_REDIRECT:"CallRedirect",CALL_REDIRECT_REQUEST_FAILED:"CallRedirectRequestFailed",TRANSFER_COMPLETION_FAILED:"TransferCompletionFailed",TRANSFER_REQUEST_RECEIVED:"TransferRequestReceived",HANDLE_PARK_REQUESTED:"HandleParkRequested",HANDLE_SERVER_HOLD:"HandleServerHold",DUPLICATE_MESSAGE_IGNORED:"DuplicateMessageIgnored",CORRELATION_ID_UPDATED:"CorrelationIdUpdated",UNKNOWN_MESSAGE_TYPE:"UnkownMessageType",FAILED_TO_HANDLE_MESSAGE:"FailedToHandleMessage",CONNECTIVITY_CHANGED:"ConnectivityChanged",TROUTER_DECODE_PAYLOAD_FAILURE:"TrouterDecodePayloadFailure",UPDATE_ENDPOINT_STATE:"UpdateEndpointState",UPDATE_ENDPOINT_STATE_SUCCESS:"UpdateEndpointStateSuccess",UPDATE_ENDPOINT_STATE_FAILURE:"UpdateEndpointStateFailure",BROKER_DECODE_PAYLOAD_FAILURE:"BrokerDecodePayloadFailure",BROKER_SUBSCRIPTION_TIMEOUT:"BrokerSubscriptionTimeout",BROKER_SUBSCRIPTION_SUCCESSFUL:"BrokerSubscriptionSuccessful",BROKER_SUBSCRIPTION_FAILED:"BrokerSubscriptionFailed",FAILED_TO_HANDLE_TROUTER_MESSAGE:"FailedToHandleTrouterMessage",FAILED_TO_HANDLE_BROKER_MESSAGE:"FailedToHandleBrokerMessage",BROKER_DISABLED_SUBSCRIBE_URL_PRESENT:"BrokerDisabledSubscribeUrlPresent",CONNECTED:"Connected",IN_LOBBY:"InLobby",STAGING:"Staging",MESSAGE_MISSING_BODY:"MessageMissingBody",BROADCAST_STATE_CHANGED:"BroadcastStateChanged",HANDLE_CALL_NOTIFICATION:"HandleCallNotification",HANDLE_INCOMING_CALL_REPLACEMENT:"HandleIncomingCallReplacement",HANDLE_PSTN_BALANCE_UPDATE:"HandlePstnBalanceUpdate",IGNORE_OLD_ROSTER:"IgnoreOldRoster",HANDLE_MEDIA_ACK:"HandleMediaAck",HANDLE_MEDIA_PROVISIONAL_ACK:"HandleMediaProvisionalAck",UPDATE_CALL_STATUS:"UpdateCallStatus",SEND_ATTACH:"SendAttach",REQUEST_NEW_OFFER:"RequestNewOffer",HANDLE_NEW_OFFER:"HandleNewOffer",UPDATE_CONVERSATION_LINKS:"UpdateConversationLinks",UPDATE_CONVERSATION_LINKS_SUCCESS:"UpdateConversationLinksSuccess",UPDATE_CONVERSATION_LINKS_FAILED:"UpdateConversationLinksFailed",PROCESS_INITIAL_OFFER:"ProcessInitialOffer",SEND_PROGRESS:"SendProgress",SEND_PROGRESS_FAILED:"SendProgressFailed",PROCESS_CALL_ACCEPTANCE:"ProcessCallAcceptance",ACCEPTANCE_USER_IN_LOBBY:"AcceptanceUserInLobby",REJECT_INCOMING_CALL:"RejectIncomingCall",SEND_KEEP_ALIVE:"SendKeepAlive",SEND_KEEP_ALIVE_FAILED:"SendKeepAliveFailed",SEND_CONVERSATION_KEEP_ALIVE_FAILED:"SendConversationKeepAliveFailed",START_AUDIO:"StartAudio",STOP_AUDIO:"StopAudio",UPDATE_MEETING_ROLE:"UpdateMeetingRole",UPDATE_MEETING_ROLE_TIMEOUT:"UpdateMeetingRoleTimeout",PREHEAT_ENABLING:"EnablingPreheat",PREHEAT_DISABLING:"DisablingPreheat",PREHEAT_DISABLED:"PreheatDisabled",TRANSFER_REQUEST_SENT:"TransferRequestSent",CALL_REDIRECT_REQUEST_SENT:"CallRedirectRequestSent",TRANSFER_REQUEST_FAILED:"TransferRequestFailed",SEND_ACCEPT_TRANSFER:"SendAcceptTransfer",SEND_ACCEPT_TRANSFER_FAIL:"SendAcceptTransferFail",WAITING_FOR_TRANSFER_COMPLETION:"WaitingForTransferCompletion",WAITING_FOR_TRANSFER_COMPLETION_FAIL:"WaitingForTransferCompletionFail",WAITING_FOR_TRANSFER_ACCEPTANCE_FAIL:"WaitingForTransferAcceptanceFail",WAITING_FOR_TRANSFER_ACCEPTANCE:"WaitingForTransferAcceptance",TRANSFER_COMPLETED:"TransferCompleted",SEND_COMPLETE_TRANSFER:"SendCompleteTransfer",SEND_COMPLETE_TRANSFER_FAILED:"SendCompleteTransferFailed",PICKUP_CODE_SET:"PickupCodeSet",ADD_PARTICIPANT_WITH_PICKUP_CODE:"AddParticipantWithPickupCode",ADD_PARTICIPANT_WITH_PICKUP_CODE_TIMEOUT:"AddParticipantWithPickupCodeTimeout",PUBLISH_STATE:"PublishState",PUBLISH_STATE_FAILURE:"PublishStateFailure",REMOVE_STATE:"RemoveState",REMOVE_STATE_FAILURE:"RemoveStateFailure",UPDATE_MEETING_SETTINGS:"UpdateMeetingSettings",UPDATE_MEETING_SETTINGS_FAILURE:"UpdateMeetingSettingsFailure",UPDATE_ENDPOINT_METADATA_SUCCESS:"UpdateEndpointMetadataSuccess",UPDATE_ENDPOINT_METADATA_FAILURE:"UpdateEndpointMetadataFailure",SEARCH_PARTICIPANTS:"SearchParticipants",GET_ALL_PARTICIPANTS:"GetAllParticipants",SEARCH_PARTICIPANTS_FAILURE:"SearchParticipantsFailure",GET_ALL_PARTICIPANTS_FAILURE:"GetAllParticipantsFailure",PARK_REQUEST:"SendParkRequest",PARK_REQUEST_FAILED:"ParkRequestFailed",WAITING_FOR_PARK_COMPLETION:"WaitingForParkCompletion",WAITING_FOR_PARK_COMPLETION_TIMEOUT:"WaitingForParkCompletionTimeout",PARK_COMPLETED:"ParkCompleted",PARK_FAILED:"ParkFailed",SEND_UNPARK_REQUEST:"SendUnparkRequest",UNPARK_REQUEST_FAILED:"UnparkRequestFailed",WAITING_FOR_UNPARK_COMPLETION:"WaitingForUnparkCompletion",WAITING_FOR_UNPARK_COMPLETION_TIMEOUT:"WaitingForUnparkCompletionTimeout",UNPARK_COMPLETED:"UnparkCompleted",UNPARK_FAILED:"UnparkFailed",UPDATE_MEETING_LIVE_STATE:"UpdateMeetingLiveState",WAITING_FOR_UPDATE_MEETING_LIVE_STATE_COMPLETION:"WaitingForUpdateMeetingLiveStateCompletion",UPDATE_MEETING_LIVE_STATE_REQUEST_FAILED:"UpdateMeetingLiveStateRequestFailed",UPDATE_MEETING_LIVE_STATE_RESPONSE_FAILURE:"UpdateMeetingLiveStateResponseFailure",UPDATE_MEETING_LIVE_STATE_RESPONSE_SUCCESS:"UpdateMeetingLiveStateResponseSuccess",UPDATE_MEETING_GROUPS:"UpdateMeetingGroups",UPDATE_PARTICIPANT_INTERPRETATION_STATE:"UpdateParticipantInterpretationState",UPDATE_PARTICIPANTS_PROPERTIES:"UpdateParticipantsProperties",JOIN_MEETING_GROUP:"JoinMeetingGroup",LEAVE_MEETING_GROUP:"LeaveMeetingGroup",INCOMING_PROXIED_MESSAGES:"incomingProxiedMessages",WAITING_FOR_UPDATE_MEETING_GROUPS_COMPLETION:"WaitingForUpdateMeetingGroupsCompletion",UPDATE_MEETING_GROUPS_REQUEST_FAILED:"UpdateMeetingGroupsRequestFailed",UPDATE_MEETING_GROUPS_REQUEST_COMPLETED:"UpdateMeetingGroupsRequestCompleted",UPDATE_MEETING_GROUPS_RESPONSE_FAILURE:"UpdateMeetingGroupsResponseFailure",UPDATE_MEETING_GROUPS_RESPONSE_SUCCESS:"UpdateMeetingGroupsResponseSuccess",SET_MEETING_LAYOUT:"SetMeetingLayout",WAITING_FOR_SET_MEETING_LAYOUT_COMPLETION:"WaitingForSetMeetingLayoutCompletion",SET_MEETING_LAYOUT_REQUEST_FAILED:"SetMeetingLayoutRequestFailed",SET_MEETING_LAYOUT_RESPONSE_FAILURE:"SetMeetingLayoutResponseFailure",SET_MEETING_LAYOUT_RESPONSE_SUCCESS:"SetMeetingLayoutResponseSuccess",WAITING_FOR_UPDATE_PARTICIPANT_INTERPRETATION_STATE_COMPLETION:"WaitingForUpdateParticipantInterpretationStateCompletion",UPDATE_PARTICIPANT_INTERPRETATION_STATE_TIMEOUT:"UpdateParticipantInterpretationStateTimeout",UPDATE_PARTICIPANT_INTERPRETATION_STATE_REQUEST_FAILED:"UpdateParticipantInterpretationStateRequestFailed",UPDATE_PARTICIPANT_INTERPRETATION_STATE_REQUEST_COMPLETED:"UpdateParticipantInterpretationStateRequestCompleted",UPDATE_PARTICIPANT_INTERPRETATION_STATE_RESPONSE_FAILED:"UpdateParticipantInterpretationStateResponseFailed",UPDATE_PARTICIPANT_INTERPRETATION_STATE_RESPONSE_COMPLETED:"UpdateParticipantInterpretationStateResponseCompleted",WAITING_FOR_UPDATE_PARTICIPANTS_PROPERTIES_COMPLETION:"WaitingForUpdateParticipantsPropertiesCompletion",UPDATE_PARTICIPANTS_PROPERTIES_TIMEOUT:"UpdateParticipantsPropertiesTimeout",UPDATE_PARTICIPANTS_PROPERTIES_RESPONSE_FAILED:"UpdateParticipantsPropertiesResponseFailed",UPDATE_PARTICIPANTS_PROPERTIES_RESPONSE_COMPLETED:"UpdateParticipantsPropertiesResponseCompleted",WAITING_FOR_JOIN_MEETING_GROUP_COMPLETION:"WaitingForJoinMeetingGroupCompletion",JOIN_MEETING_GROUP_REQUEST_FAILED:"JoinMeetingGroupRequestFailed",JOIN_MEETING_GROUP_REQUEST_COMPLETED:"JoinMeetingGroupRequestCompleted",JOIN_MEETING_GROUP_RESPONSE_FAILED:"JoinMeetingGroupRequestFailed",JOIN_MEETING_GROUP_RESPONSE_COMPLETED:"JoinMeetingGroupRequestCompleted",WAITING_FOR_LEAVE_MEETING_GROUP_COMPLETION:"WaitingForLeaveMeetingGroupCompletion",LEAVE_MEETING_GROUP_REQUEST_FAILED:"LeaveMeetingGroupRequestFailed",LEAVE_MEETING_GROUP_REQUEST_COMPLETED:"LeaveMeetingGroupRequestCompleted",LEAVE_MEETING_GROUP_RESPONSE_FAILED:"LeaveMeetingGroupRequestFailed",LEAVE_MEETING_GROUP_RESPONSE_COMPLETED:"LeaveMeetingGroupRequestCompleted",SUBSCRIBE_URL_FOUND:"SubscribeUrlFound",SUBSCRIBE_URL_MISSING:"SubscribeUrlMissing",SEND_MESSAGE_COMPLETION:"SendMessageCompletion",SEND_MESSAGE_TIMEOUT:"SendMessageTimeout",DISABLE_PREHEAT_SUCCEEDED:"DiablePreheatSucceeded",ASYNC_DISABLE_PREHEAT_SUCCEEDED:"AsyncDisablePreheatSucceeded",DISABLE_PREHEAT_FAILED:"DiablePreheatFailed",ASYNC_DISABLE_PREHEAT_FAILED:"AsyncDiablePreheatFailed",ASYNC_DISABLE_PREHEAT_TIMEOUT:"AsyncDiablePreheatTimeout",DISABLE_PREHEAT_RESPONSE_RECEIVED:"DisablePreheatResponseReceived",SET_STREAM_INFORMATION_RECEIVED:"StreamInformationReceived",UPDATE_MEDIA_DESCRIPTIONS:"UpdateMediaDescriptions",UPDATE_MEDIA_DESCRIPTIONS_FAILED:"UpdateMediaDescriptionsFailed",NUDGE_TO_JOIN_REALTIME:"NudgeToJoinAsRealtime",UPDATE_MEETING_STATES:"UpdateMeetingStates",WAITING_FOR_UPDATE_MEETING_STATES_COMPLETION:"WaitingForUpdateMeetingStatesCompletion",UPDATE_MEETING_STATES_RESPONSE_SUCCESS:"UpdateMeetingStatesResponseSuccess",UPDATE_MEETING_STATES_RESPONSE_FAILURE:"UpdateMeetingStatesResponseFailure",UPDATE_MONITOR_SESSION:"UpdateMonitorSession",UPDATE_MONITOR_SESSION_REQUEST_FAILED:"UpdateMonitorSessionRequestFailed",UPDATE_MONITOR_SESSION_REQUEST_COMPLETED:"UpdateMonitorSessionRequestCompleted",UPDATE_MONITOR_SESSION_RESPONSE_FAILED:"UpdateMonitorSessionResponseFailed",UPDATE_MONITOR_SESSION_RESPONSE_COMPLETED:"UpdateMonitorSessionResponseCompleted",WAITING_FOR_UPDATE_MONITOR_SESSION_COMPLETION:"WaitingForUpdateMonitorSessionCompletion"},$n={SEND_MEDIA_ANSWER:{name:"SendMediaAnswer",controller:0},START_RENEGOTIATION:{name:"StartRenegotiation",controller:0},SEND_MEDIA_ACKNOWLEDGEMENT:{name:"SendMediaAcknowledgement",controller:0},SEND_MEDIA_REJECTION:{name:"SendMediaRejection",controller:0},ADD_PARTICIPANT:{name:"AddParticipant",controller:1},ADD_PARTICIPANT_WITH_REPLACES:{name:"AddParticipantWithReplaces",controller:1},NUDGE_PARTICIPANT:{name:"NudgeParticipant",controller:1},REMOVE_PARTICIPANT_NONE:{name:"RemoveParticipant",controller:1},REMOVE_PARTICIPANT_OTHERS:{name:"RemoveParticipantOthers",controller:1},REMOVE_PARTICIPANT_SPECIFIED:{name:"RemoveParticipantSpecified",controller:1},ADMIT_PARTICIPANT:{name:"AdmitParticipant",controller:1},ADMIT:{name:"Admit",controller:1},BROKER_SUBSCRIBE:{name:"BrokerSubscribe",controller:2},CALL_ME_BACK:{name:"CallMeBack",controller:1},SEND_ACCEPTANCE:{name:"SendAcceptance",controller:0},SEND_ACCEPTANCE_ACKNOWLEDGEMENT:{name:"SendAcceptanceAcknowledgement",controller:0},END_CALL:{name:"EndCall",controller:1},CANCEL_CALL:{name:"CancelCall",controller:1},REJECT_CALL:{name:"RejectCall",controller:0},JOIN_CONVERSATION:{name:"JoinConversation",controller:1},JOIN_CONVERSATION_WITHOUT_CALL_MODALITY:{name:"JoinConversationWithoutCallModality",controller:1},LEAVE_CONVERSATION:{name:"LeaveConversation",controller:1},DELETE_CONVERSATION:{name:"DeleteConversation",controller:1},START_CALL:{name:"StartCall",controller:1},PLACE_NUDGE_CALL:{name:"PlaceNudgeCall",controller:5},UPDATE_CONVERSATION_LINKS:{name:"UpdateConversationLinks",controller:1},SEND_CONVERSATION_KEEP_ALIVE:{name:"SendConversationKeepAlive",controller:1},SEND_CALL_ATTACH:{name:"SendCallAttach",controller:0},SEND_CALL_PROGRESS:{name:"SendCallProgress",controller:0},SEND_KEEP_ALIVE:{name:"SendKeepAlive",controller:0},ADD_CONTENT_SHARING_MODALITY:{name:"AddContentSharingModality",controller:1},DELETE_CONTENT_SHARING:{name:"DeleteContentSharing",controller:3},TAKE_CONTROL_CONTENT_SHARING:{name:"TakeControlContentSharing",controller:3},UPDATE_SESSION_STATE_CONTENT_SHARING:{name:"UpdateSessionStateContentSharing",controller:3},JOIN_CONTENT_SHARING:{name:"JoinContentSharing",controller:3},UPDATE_PARTICIPANT_STATE_CONTENT_SHARING:{name:"UpdateParticipantStateContentSharing",controller:3},UPDATE_CONTENT_SHARING_NOTIFICATION_LINKS:{name:"UpdateContentSharingNotificationLinks",controller:3},MUTE_ALL:{name:"MuteAll",controller:1},MUTE_ALL_SYNC:{name:"MuteAllSync",controller:1},MUTE_SPECIFIED:{name:"MuteSpecified",controller:1},MUTE_SPECIFIED_SYNC:{name:"MuteSpecifiedSync",controller:1},MUTE_MYSELF:{name:"MuteMyself",controller:1},UNMUTE:{name:"Unmute",controller:1},UNMUTE_SYNC:{name:"UnmuteMyselfSync",controller:1},SEND_CONTROL_VIDEO_STREAMING:{name:"SendControlVideoStreaming",controller:0},SEND_APPLY_CHANNEL_PARAMETERS:{name:"SendApplyChannelParameters",controller:0},APPROVE_UNMUTE:{name:"ApproveUnmute",controller:5},REJECT_UNMUTE:{name:"RejectUnmute",controller:5},SEND_CALL_REDIRECT_REQUEST:{name:"SendCallRedirectRequest",controller:0},SEND_TRANSFER_REQUEST:{name:"SendTransferRequest",controller:0},SEND_PARK_REQUEST:{name:"SendParkRequest",controller:0},SEND_SHARED_LINE_PARK_REQUEST:{name:"SharedLinePark",controller:0},SEND_SERVER_HOLD_REQUEST:{name:"ServerHoldRequest",controller:0},PARK_REQUEST:{name:"ParkRequest",controller:0},SEND_UNPARK_REQUEST:{name:"UnparkRequest",controller:0},TRANSFER_ACCEPTANCE:{name:"TransferAcceptance",controller:0},TRANSFER_COMPLETION:{name:"TransferCompletion",controller:0},TRANSFER_COMPLETION_FAILED:{name:"TransferCompletionFailed",controller:0},UPDATE_ENDPOINT_STATE:{name:"UpdateEndpointState",controller:1},DISABLE_PREHEAT:{name:"DisablePreheat",controller:5},REQUEST_NEW_OFFER:{name:"RequestNewOffer",controller:0},UPDATE_ENDPOINT_METADATA:{name:"UpdateEndpointMetadata",controller:1},UPDATE_MEETING_ROLE_ATTENDEE:{name:"UpdateMeetingRoleToAttendee",controller:1},UPDATE_MEETING_ROLE_PRESENTER:{name:"UpdateMeetingRoleToPresenter",controller:1},UPDATE_MEETING_ROLE_ORGANIZER:{name:"UpdateMeetingRoleToOrganizer",controller:1},ADD_PARTICIPANT_WITH_PICKUP_CODE:{name:"AddParticipantWithPickupCode",controller:1},PUBLISH_STATE:{name:"PublishState",controller:1},REMOVE_STATE:{name:"RemoveState",controller:1},UPDATE_MEETING_SETTINGS:{name:"UpdateMeetingSettings",controller:1},ADD_PARTICIPANTS_AND_MODALITY:{name:"AddParticipantsAndModality",controller:1},ADD_BROADCAST_MODALITY:{name:"AddBroadcastModality",controller:1},ADD_MODALITY:{name:"AddModality",controller:1},SEARCH_PARTICIPANTS:{name:"SearchParticipants",controller:1},GET_ALL_PARTICIPANTS:{name:"GetAllParticipants",controller:1},UPDATE_MEETING_LIVE_STATE:{name:"UpdateMeetingLiveState",controller:1},UPDATE_MEETING_GROUPS:{name:"UpdateMeetingGroups",controller:1},SET_MEETING_LAYOUT:{name:"SetMeetingLayout",controller:1},UPDATE_PARTICIPANT_INTERPRETATION_STATE:{name:"UpdateParticipantInterpretationState",controller:1},JOIN_MEETING_GROUP:{name:"JoinMeetingGroup",controller:1},LEAVE_MEETING_GROUP:{name:"LeaveMeetingGroup",controller:1},SEND_PROXIED_MESSAGE:{name:"SendProxiedMessage",controller:1},UPDATE_PARTICIPANTS_PROPERTIES:{name:"UpdateParticipantsProperties",controller:1},UPDATE_MEDIA_DESCRIPTIONS:{name:"UpdateMediaDescriptions",controller:0},UPDATE_MEETING_STATES:{name:"UpdateMeetingStates",controller:1},UPDATE_MONITOR_SESSION:{name:"UpdateMonitorSession",controller:0}},ei={EVENT_SOURCE:{LOCAL:"Local"},SOURCE:{NGC_SOURCE:"SkypeConcore"},EVENT_TYPE:{CONVERSATION_CALL_MODALITY:"skypecosi_concore_web_csa_conversation_callmodality",CONVERSATION_CONTENT_SHARING:"skypecosi_concore_web_csa_conversation_contentsharing",CONVERSATION_HTTP_REQUEST:"skypecosi_concore_web_csa_conversation_httprequest",CONVERSATION_TOKEN:"skypecosi_concore_web_csa_conversation_token"},EXTENSIONS:{DIRECTION:"Direction",CONTENT_SHARING_DIRECTION:"ContentSharingDirection",CONNECTED_DURATION_IN_MS:"ConnectedDurationInMsecs",PREHEATED_CALL_SETUP_DURATION_IN_S:"PreheatedCallSetupDurationInSeconds",CALL_CANCELATION_DURATION_IN_S:"CallCancelationDurationInSeconds",IS_PREHEATED:"IsPreheated",TIME_TO_RING_IN_MS:"TimeToRingInMsecs",CALL_TERMINATING_END:"CallTerminatingEnd",NETWORK_REQUESTS_PENDING:"NetworkRequestsPending",NETWORK_REQUESTS_COMPLETED:"NetworkRequestsCompleted",LOCAL_OPERATIONS_PERFORMED:"LocalOperationsPerformed",TROUTER_WAIT_OPERATIONS:"TrouterWaitOperations",CALL_START_TIME:"CallStartTime",CALL_END_TIME:"CallEndTime",IS_GROUP_CALL:"IsGroupCall",IS_HOSTLESS_CALL:"IsHostLessCall",IS_CAST_CALL:"IsCastCall",IS_HUDDLE_GROUP_CALL:"IsHuddleGroupCall",IS_MEETUP_CALL:"IsMeetupCall",IS_ON_BEHALF_OF_CALL:"IsOnBehalfOfCall",IS_SDP_IN_CALL_NOTIFICATION:"SdpInCallNotification",CALL_END_CODE:"Code",CALL_END_SUB_CODE:"SubCode",CALL_PHRASE:"Phrase",CALL_END_RESULT_CATEGORIES:"ResultCategories",CALL_END_CAUSE_ID:"CauseId",CONFLICTING_CALL_ID:"ConflictingCallId",CONVERSATION_SERVICE_URL:"ConversationServiceUrl",CONTENT_SHARING_SERVICE_URL:"ContentSharingServiceUrl",MEETING_INFO:"MeetingInfo",JOINED_FROM:"JoinedFrom",RESULT_VALUE:"ResultValue",RESULT_DETAIL:"ResultDetail",RESULT_CAUSE_ID:"ResultCauseId",LOCAL_OFFER_ANSWER_GENERATION_TIMESTAMPS:"LocalOfferAnswerGenerationTimestamps",SELF_PARTICIPANT_ROLE:"SelfParticipantRole",SCENARIO:"Scenario",CALLER_TYPE:"Caller_Type",CALLEE_TYPE:"Callee_Type",CALL_TYPE:"Call_Type",TEST_CONTEXT_ID:"Test_Context_Id",OUTGOING_MODALITIES:"Outgoing_Modalities",INCOMING_MODALITIES:"Incoming_Modalities",OFFERED_MODALITIES:"CallOfferredModalities",ANSWERED_MODALITIES:"CallAnsweredModalities",VBSS_OPERATIONS:"VBSS_Operations",CHANGING_CORRELATION_ID_NEW_ID:"ChangingCorrelationId_NewId",CHANGING_CORRELATION_ID_OLD_ID:"ChangingCorrelationId_OldId",MESSAGING_CHANNEL:"MessagingChannel",EVENT_TIMESTAMP_BAG:"EventTimestampBag",ROSTER_UPDATES_BAG:"RosterUpdatesBag",NETWORK_REQUESTS_BAG:"NetworkRequestBag",CLIENT_INFORMATION:"ClientInformation",ECS_ETAG:"EcsEtag",APPLICATION_TYPE:"ApplicationType",RING:"Ring",TENANT_ID:"TenantId",USER_HEX_CID:"UserHexCID",ACS_RESOURCE_ID:"AcsResourceId",REGION:"Region",PARTITION:"Partition",CALL_END_CLIENT_SUB_CODE:"CallEventCallEndClientSubCode",CALL_END_CLIENT_PHRASE:"CallEventCallEndClientPhrase",MEETING_CODE:"MeetingCode",MEETING_URL:"MeetingJoinUrl",BROADCAST_MEETING_ROLE:"BroadcastMeetingRole",MEETING_ROLE:"MeetingRole",ADVANCED_MEETING_ROLE:"AdvancedMeetingRole",MEETING_ROLES:"MeetingRoles",PARTICIPANT_TYPE:"ParticipantType",DISPLAY_NAME:"DisplayName",AUDIO_ONLY_WATERMARK:"ClientSupportsAudioOnlyWatermark",CLIENT_SUPPORT_WATERMARK:"ClientSupportsWatermark",TARGET_APPLICATION_TYPE:"TargetApplicationType",IS_REINVITELESS:"IsReinviteless",CLIENT_TYPE:"ClientType",CLIENT_SUPPORTS_PREVENT_SCREEN_CAPTURE:"ClientSupportsPreventScreenCapture"},MESSAGING_CHANNEL:{TROUTER:"Trouter",BROKER:"Broker"},SIGNALING_CONFIG:"JsCsaConfig",SIGNALING_CONFIG_FLAGS:{BROKER_OUTGOING_ENABLED:"BrokerOutgoingEnabled",BROKER_INCOMING_ENABLED:"BrokerIncomingEnabled",BROKER_REQUEST_BATCHING_ENABLED:"BrokerRequestBatchingEnabled",BROKER_EXCLUSIVELY_ENABLED:"BrokerExclusivelyEnabled",SUPPORTS_COMPRESSED_PAYLOAD:"SupportsCompressedPayload",SYNC_TROUTER_RESPONSE:"SyncTrouterResponse",SERVER_MUTE_UNMUTE:"serverMuteUnmute",HANDLE_OFFER_FROM_NOTIFICATION:"handleMediaOfferFromPushNotification",HANDLE_NEW_OFFER_REQUEST:"handleNewOfferRequest",SEND_PROGRESS_FROM_CC:"sendProgressFromCC",INTERNAL_HTTP_DISPATCHER:"internalHttpDispatcher",ENABLE_TOKEN_CACHE:"enableTokenCache",ENABLE_TOKEN_PREFETCH:"enableTokenPrefetch",SUPPORT_MEDIA_RETARGET_WHILE_INCOMING_RENEGOTIATION:"supportMediaRetargetWhileIncomingRenegotiation",ENABLE_CALL_ESTABLISHMENT_TIMEOUTS_FOR_START_OR_JOIN_CALL:"enableCallEstablishmentTimeoutsForStartJoinCall",ENABLE_TOKEN_CACHE_FOR_GENERIC_TOKEN_API:"enableTokenCacheForGenericTokenAPI",ENABLE_LONG_OUTGOING_1TO1_SETUP:"enableLongOutgoing1To1SetupTimeoutForWeb"},CONTEXT_ID:{CORRELATION_ID:"CorrelationId",SHARED_CORRELATION_ID:"SharedCorrelationId",SIGNALING_SESSION_ID:"SignalingSessionId",GROUP_ID:"GroupId",THREAD_ID:"ThreadId",TEAMS_MESSAGEID:"TeamsMessageId",TEAMS_MEETINGINFO:"TeamsMeetingInfo",ENDPOINT_ID:"EndpointId",PARTICIPANT_ID:"ParticipantId",CONTENT_SHARING_ID:"ContentSharingSessionId",CONTENT_SHARING_CORRELATION_ID:"ContentSharingCorrelationId"},CALL_TERMINATING_END:{LOCAL:"Local",REMOTE:"Remote"},RESULT_VALUE:{SUCCESS:"Success",FAILURE:"Failure"},DIRECTION:{INCOMING:"Incoming",OUTGOING:"Outgoing"},ROLE:{CALLER:"caller",CALLEE:"callee",JOIN:"join",JOIN_FOR_ROSTER_ONLY:"joinForRosterOnly",PREHEAT:"preheat"},VBSS_OPERATION:{START:"Start",STOP:"Stop",REJECTED:"Rejected",REMOTE_START:"RemoteStart",TIMEOUT:"Timeout",CALL_END:"CallEnd"},TROUTER_WAIT_OPERATION:{STARTED:"Started",ENDED:"Ended",FAILED:"Failed"},TOKEN_TELEMETRY_EVENT:{TOKEN_TELEMETRY:"TokenTelemetry"}};function gte(n){const s="enabled",xt={conversationKeepAliveTimeoutSec:2700,promotionUnmuteTimeoutSec:1e4},yi=!1,Li=!1,cn=!1,Ci=!1,ji=3600,An=86400,Ea=30,Ln=!1,ga=!0,vs=!0,ss=60,Ya="https://calling.teams.microsoft.com",ir=!0,Ji=!1,pa=!1,Ca=!1,da=!1,Wn=!1,co=!1,eo=0,Uo=0,Zo=!1,oo=!1,Xu=!1,kd=!1,jg=!0,Ah=!1,es=!1,qs=!1,qr=!1,Ol=!1;n.cloudScreenSharingFlag=n.cloudScreenSharingFlag==="disabled"?n.cloudScreenSharingFlag:s,n.isWebRtcEnabled=typeof RTCIceGatherer>"u",n.shouldServiceSendNGCUpgradeMessages=Xr(n.shouldServiceSendNGCUpgradeMessages,!0),n.isGVCOutgoingEnabled=Xr(n.isGVCOutgoingEnabled,!0),n.supportsCompressedServicePayload=Xr(n.supportsCompressedServicePayload,!0),n.supportsSynchronousTrouterResponse=Xr(n.supportsSynchronousTrouterResponse,!0),n.supportsHostlessGroupCalls=Xr(n.supportsHostlessGroupCalls,!0),n.doHostlessCalling=Xr(n.doHostlessCalling,!1),n.brokerExclusively=Xr(n.brokerExclusively,!1),n.brokerEnabledOutgoing=Xr(n.brokerEnabledOutgoing,!0),n.brokerEnabledIncoming=Xr(n.brokerEnabledIncoming,!0),n.brokerRequestBatching=Xr(n.brokerRequestBatching,!0),n.handleMediaOfferFromPushNotification=Xr(n.handleMediaOfferFromPushNotification,!0),n.handleNewOfferRequest=Xr(n.handleNewOfferRequest,!1),n.autoJoinOnConflict=Xr(n.autoJoinOnConflict,!0),n.endConflictedCall=Xr(n.endConflictedCall,!1),n.autoResolveConflictedCall=Xr(n.autoResolveConflictedCall,!1),n.shouldServiceSendCallEventMessages=Xr(n.shouldServiceSendCallEventMessages,!1),n.forceTrouterReconnectOnNetworkOnline=Xr(n.forceTrouterReconnectOnNetworkOnline,!0),n.attemptHttpRequestWithCachedSkypetoken=Xr(n.attemptHttpRequestWithCachedSkypetoken,!0),n.useInternalHttpDispatcher=Xr(n.useInternalHttpDispatcher,!1),n.enableTokenCache=Xr(n.enableTokenCache,!1),n.enableTokenPrefetch=Xr(n.enableTokenPrefetch,!1),n.hedgeDelayMs=Xr(n.hedgeDelayMs,4e3),n.hedgeMaxParallelAttempts=Xr(n.hedgeMaxParallelAttempts,3),n.useInternalHttpDispatcher&&(n.httpRequestDispatcher=new h2(n.logger)),n.enableQuickSendAcceptanceAck=Xr(n.enableQuickSendAcceptanceAck,!1),n.supportMediaRetargetWhileIncomingRenegotiation=Xr(n.supportMediaRetargetWhileIncomingRenegotiation,!1),n.callingServiceSupportsAADTokens=Xr(n.callingServiceSupportsAADTokens,yi),n.callingServiceSupportsCAETokens=Xr(n.callingServiceSupportsCAETokens,Li),n.aadTokenExpirationTimeInSeconds=Xr(n.aadTokenExpirationTimeInSeconds,ji),n.caeTokenExpirationTimeInSeconds=Xr(n.caeTokenExpirationTimeInSeconds,An),n.disableTokenMigrationHeader=Xr(n.disableTokenMigrationHeader,cn),n.enablePublishTokenTelemetry=Xr(n.enablePublishTokenTelemetry,Ci),n.forceClearExpiredTokens=Xr(n.forceClearExpiredTokens,Ln),n.enableRefreshToken=Xr(n.enableRefreshToken,ga),n.refreshTimeBeforeTokenTimeoutInSeconds=Xr(n.refreshTimeBeforeTokenTimeoutInSeconds,Ea),n.enableCallEstablishmentTimeoutsForStartJoinCall=Xr(n.enableCallEstablishmentTimeoutsForStartJoinCall,!1),n.csaTimeoutConfiguration=GG(n.csaTimeoutConfiguration,xt),n.reportPreviousErrorsForTimeout=Xr(n.reportPreviousErrorsForTimeout,Ca),n.callingTokenLogicalUrl=Xr(n.callingTokenLogicalUrl,Ya),n.enableAsyncDisablePreheat=Xr(n.enableAsyncDisablePreheat,da),n.forceLowercaseHttpHeaders=Xr(n.forceLowercaseHttpHeaders,Wn),n.enableResolveScreenSharingWhenNegotiationComplete=Xr(n.enableResolveScreenSharingWhenNegotiationComplete,co),n.maxReinvitelessMediaForVideoForWeb=Xr(n.maxReinvitelessMediaForVideoForWeb,eo),n.maxReinvitelessMediaForVBSSForWeb=Xr(n.maxReinvitelessMediaForVBSSForWeb,Uo),n.enableRefreshTokenRetry=Xr(n.enableRefreshTokenRetry,vs),n.enableRefreshTokenRetryInSeconds=Xr(n.enableRefreshTokenRetryInSeconds,ss),n.enableConversationTypeUpdateOnCallEnd=Xr(n.enableConversationTypeUpdateOnCallEnd,!1),n.supportMissingTokenTypesInResponse=Xr(n.supportMissingTokenTypesInResponse,ir),n.useSkypeTokenWhenNoAuthenticateHeader=Xr(n.useSkypeTokenWhenNoAuthenticateHeader,Ji),n.enableAutoPromotion=Xr(n.enableAutoPromotion,Zo),n.enableBatchedSendMessageStatus=Xr(n.enableBatchedSendMessageStatus,Xu),n.enableBatchedReceiveMessage=Xr(n.enableBatchedReceiveMessage,oo),n.enableAddParticipantEnhancements=Xr(n.enableAddParticipantEnhancements,kd),n.enableTokenCacheForGenericTokenAPI=Xr(n.enableTokenCacheForGenericTokenAPI,pa),n.disableRealTimeModeFromRoster=Xr(n.disableRealTimeModeFromRoster,jg),n.enableLongOutgoing1To1SetupTimeoutForWeb=Xr(n.enableLongOutgoing1To1SetupTimeoutForWeb,!1),n.checkAttendeeRoleInCreateContentSharing=Xr(n.checkAttendeeRoleInCreateContentSharing,!0),n.enableSpecificErrorCodesForCallEnd=Xr(n.enableSpecificErrorCodesForCallEnd,Ah),n.enableSplitConversationEndUrl=Xr(n.enableSplitConversationEndUrl,es),n.enableFetchRequestWithKeepAlive=Xr(n.enableFetchRequestWithKeepAlive,qs),n.enableFetchApi=Xr(n.enableFetchApi,qr),n.enableFetchApiForBeacon=Xr(n.enableFetchApiForBeacon,Ol)}function Xr(n,a){return n??a}function GG(n,a){return(a||n)&&{...a,...n}}var mte=class{constructor(){this.skypeTokenContext={},this.aadTokenContext={},this.caeTokenContext={}}getTokenContext(n){return n===4?this.aadTokenContext:n===8?this.caeTokenContext:n===1?this.skypeTokenContext:void 0}getTokenExpiry(n,a){return n===4?this.aadTokenContext?.expiryTime:n===8?this.caeTokenContext?.expiryTime:n===1?this.skypeTokenContext?.expiryTime:(a?.info("[getTokenExpiry] unrecognized token type, return Number.MAX_VALUE"),Number.MAX_VALUE)}getToken(n,a,s,c){return 8&n&&this.caeTokenContext?.token&&this.caeTokenContext.token!==c?{token:this.caeTokenContext.token,tokenType:8}:4&n&&this.aadTokenContext?.token&&this.aadTokenContext.token!==c?{token:this.aadTokenContext.token,tokenType:4}:1&n&&this.skypeTokenContext?.token&&this.skypeTokenContext.token!==c?{token:this.skypeTokenContext.token,tokenType:1}:(s?.info(`[getToken] no cached token found of token type: ${n}`),null)}setToken(n,a,s,c){switch(n){case 4:this.aadTokenContext.factorsJson=s,this.aadTokenContext.tokenType=n,this.aadTokenContext.token=a,this.aadTokenContext.expiryTime=c;break;case 1:this.skypeTokenContext.factorsJson=s,this.skypeTokenContext.tokenType=n,this.skypeTokenContext.token=a,this.skypeTokenContext.expiryTime=c;break;case 8:this.caeTokenContext.factorsJson=s,this.caeTokenContext.tokenType=n,this.caeTokenContext.token=a,this.caeTokenContext.expiryTime=c;break;default:throw new Error(`Invalid tokenType ${n}`)}}clearExpiredTokens(n){const a=Math.round(Date.now()/1e3);this.caeTokenContext?.expiryTime<=a&&(this.resetToken(8),n?.info("[cacheTokenManager] reset expired cae token")),this.aadTokenContext?.expiryTime<=a&&(this.resetToken(4),n?.info("[cacheTokenManager] reset expired aad token")),this.skypeTokenContext?.expiryTime<=a&&(this.resetToken(1),n?.info("[cacheTokenManager] reset expired skype token"))}resetToken(n){n===8?this.caeTokenContext={}:n===4?this.aadTokenContext={}:n===1&&(this.skypeTokenContext={})}},fte=class{constructor(n){this.timers={},this.startTimer=(a,s,c,u)=>{this.logger.info(`startTimer called for :  ${a} with timeoutInSeconds : ${c}s`);const m=window.setTimeout(s,1e3*c),b=u?`${a}${u}`:a;this.timers[b]=m},this.stopTimer=(a,s)=>{this.logger.info(`stopTimer called for : ${a}`);const c=s?`${a}${s}`:a;this.timers.hasOwnProperty(c)&&(clearTimeout(this.timers[c]),delete this.timers[c])},this.dispose=()=>{this.logger.info("timeoutManager :: dispose"),Object.keys(this.timers).forEach(a=>{this.stopTimer(a)})},this.logger=n}},qG=3600,WG=class{constructor(n,a,s,c){this.tokenProvider=a,this.tokenCachingEnabled=!1,this.enableTokenCacheForGenericTokenAPI=!1,this.cachedToken="",this.lastTokenType=1,this.lastToken="",this.clientSupportsGenericTokenAPI=!1,this.stopTimerFlag=!1,this.tokensPromiseMap={},this.logger=n.createChild("TokenManager"),s&&this.updateTokenSettings(s),this.cacheTimers=new fte(n),this.cacheTokenManager=new mte,this.telemetryManager=c,this.nextRefreshTimePointInSeconds=Number.MAX_VALUE}deletePromisesByTriggeredByRefresh(n,a){if(this.tokensPromiseMap[n]){const s=this.tokensPromiseMap[n];for(let c=s.length-1;c>=0;c--)s[c]?.tokenRequestOptions.triggeredByRefresh===a&&this.tokensPromiseMap[n].splice(c,1)}}startTokenRefreshTimer(n){const a="startTokenRefreshTimer";if(!this.enableRefreshToken)return void this.logger.info("[startTokenRefreshTimer] token refresh is disabled");if(this.stopTimerFlag)return this.logger.info("[startTokenRefreshTimer] stopTimerFlag=true so cancel timer"),void this.cacheTimers.dispose();this.logger.info(`[startTokenRefreshTimer] starting token refresh timer timeToStartInMilliseconds=${n}`);const s=TN(),c=Nve(n),u=s+c;this.nextRefreshTimePointInSeconds===Number.MAX_VALUE||this.nextRefreshTimePointInSeconds<s||u<this.nextRefreshTimePointInSeconds?(this.logger.info("[startTokenRefreshTimer] cancelling current refresh timer to create new one with shorter time"),this.cacheTimers.stopTimer(a),this.nextRefreshTimePointInSeconds=u,this.logger.info(`[startTokenRefreshTimer] start new timer with timeout=${c} at time=${s}`),this.cacheTimers.startTimer(a,()=>{this.nextRefreshTimePointInSeconds=Number.MAX_VALUE,this.refreshToken()},c)):this.logger.info("[startTokenRefreshTimer] no need to set a new refresh timer")}async refreshTokenWithContext(n){const a={triggeredByRefresh:!0},s=My(),c={causeId:s},u=Date.now();let m,b,_,k=2;this.logger.info(`[${s}][refreshTokenWithContext] refreshing token tokenType=${n.tokenType} factorsJson=${n.factorsJson}`);let N=null;try{const W=this.onTokenRequired({factorsJson:n.factorsJson,tokenType:n.tokenType,requestMetadataJson:c,invalidToken:void 0,isUnauthorized:void 0,triggeredByRefresh:!0}),ee=await this.timeoutPromiseRace(W,this.enableRefreshTokenRetryInSeconds,"ActiveRefresh Token Timeout");m=Date.now(),_=ee?.causeId,N=ee?.tokenType,this.lastTokenType=N,this.lastToken=ee.token,k=1,this.logger.info(`[${s}][refreshTokenWithContext] refresh token success for factorsJson ${n.factorsJson} and tokenType ${n.tokenType}`)}catch(W){b=W,_=b?.causeId,W?.timeOut?(this.logger.info(`[${s}][refreshTokenWithContext] refresh token timeout, UI did not respond with token in time ${fi(W)}`),k=5):(this.logger.info(`[${s}][refreshTokenWithContext] failed to refresh token, UI did not respond with token ${fi(W)}`),k=2),m=Date.now(),this.deletePromisesByTriggeredByRefresh(n.factorsJson,!0)}finally{a&&(a.requestCauseId=s,a.responseCauseId=_,a.supportTokenApi=this.clientSupportsGenericTokenAPI,a.requestTokenFactors=n.factorsJson,a.tokenRequestTime=u,a.tokenResponseTime=m,a.tokenRequestStatus=k,a.requestTokenType=n.tokenType,a.foundInCache=!1,a.responseTokenType=N,a.errorCode=b?.errorCode,a.errorSubCode=b?.errorSubCode,this.sendTokenTelemetry(a))}}refreshToken(){if(!this.clientSupportsGenericTokenAPI)return void this.logger.info("[refreshToken] refresh token is not supported due to new Token Api is not enabled");if(!this.enableTokenCacheForGenericTokenAPI)return void this.logger.info("[refreshToken] refresh token is not supported due to caching being disabled");const n=this.cacheTokenManager.getTokenContext(4),a=this.cacheTokenManager.getTokenContext(8),s=this.cacheTokenManager.getTokenContext(1);if(!n&&!a&&!s)return void this.logger.info("[refreshToken] no cached tokens available to refresh");const c=TN()+this.refreshTimeBeforeTokenTimeoutInSeconds;let u=Number.MAX_VALUE,m=!1;if(n)if(n.expiryTime>c){const b=n?.expiryTime-c;b<u&&(u=b)}else n.expiryTime<=c&&(this.refreshTokenWithContext(n),m=!0);if(a)if(a.expiryTime>c){const b=a?.expiryTime-c;b<u&&(u=b)}else a.expiryTime<=c&&(this.refreshTokenWithContext(a),m=!0);if(s)if(s.expiryTime>c){const b=s?.expiryTime-c;b<u&&(u=b)}else s.expiryTime<=c&&(this.refreshTokenWithContext(s),m=!0);m&&this.enableRefreshTokenRetry&&this.enableRefreshTokenRetryInSeconds>0&&this.enableRefreshTokenRetryInSeconds<u&&(u=this.enableRefreshTokenRetryInSeconds),u>=0&&u!==Number.MAX_VALUE&&this.startTokenRefreshTimer(fw(u))}async getTokenWithTokenType(n,a=!1,s,c){this.logger.info(`[${n}][getTokenWithTokenType] call with factorJson=${s?.factorsJson} and request tokenType ${s?.tokenType}`);const{factorsJson:u,requestMetadataJson:m,invalidToken:b,isUnauthorized:_}=s||{},k=Date.now(),N=s?.tokenType;let W,ee,oe,de=2,se=null;this.clearExpiredTokens(),this.startTokenRefreshTimer(1);try{if(a)this.invalidateCachedTokenWithTokenType(N,b,u);else if(this.enableTokenCacheForGenericTokenAPI){const ze=this.cacheTokenManager.getToken(N,u,this.logger,b);if(ze?.token)return this.logger.info(`[${n}][getTokenWithTokenType] returning cached token for factorsJson ${u} and request tokenType ${N}, response tokenType ${ze.tokenType}`),de=3,W=Date.now(),se=ze.tokenType,this.lastToken=ze.token,this.lastTokenType=se,ze}this.logger.info(`[${n}][getTokenWithTokenType] fetching new token for factorsJson ${u} and tokenType ${N}`);const Re=m||{};Re.causeId=n;const ue=this.onTokenRequired({factorsJson:u,tokenType:N,requestMetadataJson:Re,invalidToken:b,isUnauthorized:_,triggeredByRefresh:!1}),Ne=await this.timeoutPromiseRace(ue,ge.TIMEOUT_VALUES_IN_SECONDS.TOKEN_REQUIRED_TIMEOUT,"Token not received from UI in time");return W=Date.now(),oe=Ne?.causeId,se=Ne?.tokenType,this.lastToken=Ne?.token,this.lastTokenType=se,de=1,this.logger.info(`[${n}][getTokenWithTokenType] fetching new token success for factorsJson ${u} and tokenType ${N}`),Ne}catch(Re){throw this.logger.info(`[${n}][getTokenWithTokenType] failed to fetch token ${fi(Re)}`),ee=Re,oe=ee?.causeId,ee.timeOut&&(de=4),this.deletePromisesByTriggeredByRefresh(u,!1),Re}finally{const Re=!c?.tokenTelemetryData,ue=Re?{}:c?.tokenTelemetryData;ue&&(ue.requestCauseId=n,ue.responseCauseId=oe,ue.supportTokenApi=this.clientSupportsGenericTokenAPI,ue.requestTokenFactors=s?.factorsJson,ue.tokenRequestTime=k,ue.tokenResponseTime=W,ue.tokenRequestStatus=de,ue.requestTokenType=s?.tokenType,ue.foundInCache=de===3,ue.responseTokenType=se,ue.timeToResponse=W&&W-k,ue.errorCode=ee?.errorCode,ue.errorSubCode=ee?.errorSubCode),(!c||Re&&!c.signalingSession)&&(this.logger?.info("[getTokenWithTokenType] TokenContext is not provided, sending token telemetry to Token table"),this.sendTokenTelemetry(ue))}}async onTokenRequired(n){const{factorsJson:a,tokenType:s,requestMetadataJson:c,invalidToken:u,isUnauthorized:m,triggeredByRefresh:b}=n;if(this.logger.info(`[onTokenRequired] factorsJson=${a} tokenType=${s}`),!s)return this.logger.info(`[onTokenRequired] factorsJson=${a} with no token type`),Promise.reject({errorCode:ge.HTTP_STATUS_CODES.UNAUTHORIZED,errorSubCode:0,causeId:c?.causeId});if(this.tokensPromiseMap[a]&&!b){for(const k of this.tokensPromiseMap[a])if(k.tokenRequestOptions.tokenType===s)return this.logger.info(`[onTokenRequired] factorsJson=${a} and tokenType ${s} has pending request`),k.defered.promise}this.tokensPromiseMap[a]||(this.tokensPromiseMap[a]=[]);const _=new Pi;return this.tokensPromiseMap[a].push({tokenRequestOptions:n,defered:_}),this.tokenCallback({factorsJson:a,tokenType:s,requestMetadataJson:c,invalidToken:u,isUnauthorized:m}),_.promise}setTokenCaching(n,a){this.tokenCachingEnabled!==n&&(this.logger.info(`[authTokenManager]setTokenCaching=${n}`),this.tokenCachingEnabled=n)}setTokenCachingForGenericTokenAPI(n,a){this.enableTokenCacheForGenericTokenAPI!==n&&(this.logger.info(`[authTokenManager]setTokenCachingForGenericTokenAPI=${n}`),this.enableTokenCacheForGenericTokenAPI=n)}calculateTokenExpiry(n,a,s){const{factorsJson:c,tokenType:u}=a;let m=s-TN(),b=m,_=s;if(m&&m>0&&m>this.refreshTimeBeforeTokenTimeoutInSeconds){switch(u){case 4:m>this.aadTokenExpirationTimeInSeconds&&(m=this.aadTokenExpirationTimeInSeconds);break;case 8:m>this.caeTokenExpirationTimeInSeconds&&(m=this.caeTokenExpirationTimeInSeconds);break;default:m>qG&&(m=qG)}b=m-this.refreshTimeBeforeTokenTimeoutInSeconds,_=b+TN()}return this.logger.info(`[${n}][calculateTokenExpiry] calculate expiry to ${_} tokenType=${u} factorsJson=${c}`),_}addToCache(n,a,s,c){this.clearExpiredTokens(),this.cacheTokenManager.setToken(n,a,s,c)}clearExpiredTokens(){this.forceClearExpiredTokens&&this.cacheTokenManager.clearExpiredTokens(this.logger)}async getToken(n,a=!1,s,c){if(this.clientSupportsGenericTokenAPI){this.logger.info(`[${n}][getToken] callingTokenAPI is enabled so using new API to fetch it`);const{token:k}=await this.getTokenWithTokenType(n,a,s,c);return k}const u=Date.now();let m,b,_=2;try{if(a&&this.invalidateCachedToken(n),this.cachedToken&&this.tokenCachingEnabled)return this.logger.info(`[${n}][getToken] returning cached token`),_=3,this.lastTokenType=1,Promise.resolve(this.cachedToken);this.logger.info(`[${n}][getToken] fetching new token`);const k=await this.tokenProvider();return m=Date.now(),k?(this.tokenCachingEnabled&&(this.cachedToken=k),_=1,this.lastToken=k,this.lastTokenType=1,this.logger.info(`[${n}][getToken] fetching new token success`),k):(this.logger.info(`[${n}][getToken] received empty token`),Promise.reject("Received empty token"))}catch(k){throw this.logger.info(`[${n}][getToken] failed to fetch token=${fi(k)}`),b=k,this.cachedToken="",k}finally{const k=c?.tokenTelemetryData;k&&(k.requestCauseId=n,k.supportTokenApi=this.clientSupportsGenericTokenAPI,k.requestTokenFactors=s?.factorsJson,k.tokenRequestTime=u,k.tokenResponseTime=m,k.tokenRequestStatus=_,k.requestTokenType=s?.tokenType,k.foundInCache=_===3,k.responseTokenType=this.lastTokenType,k.timeToResponse=m&&m-u,k.errorCode=b?.errorCode,k.errorSubCode=b?.errorSubCode)}}invalidateCachedToken(n){this.cachedToken&&(this.logger.info(`[${n}][invalidateCachedToken]`),this.cachedToken="")}invalidateCachedTokenWithTokenType(n,a,s){n===8&&this.cacheTokenManager.getToken(8,s,this.logger)?.token===a&&(this.cacheTimers.stopTimer(s,n.toString()),this.cacheTokenManager.resetToken(8)),n===4&&this.cacheTokenManager.getToken(4,s,this.logger)?.token===a&&(this.cacheTimers.stopTimer(s,n.toString()),this.cacheTokenManager.resetToken(4)),n===1&&this.cacheTokenManager.getToken(1,s,this.logger)?.token===a&&(this.cacheTimers.stopTimer(s,n.toString()),this.cacheTokenManager.resetToken(1))}getLastToken(n){return this.logger.info(`[${n}][getLastToken]`),this.lastToken}async timeoutPromiseRace(n,a,s){let c;const u=new Promise((m,b)=>{c=window.setTimeout(()=>{b({phrase:s,timeOut:!0})},fw(a))});return Promise.race([n.then(m=>(clearTimeout(c),m)),u])}getLastTokenType(n){return this.logger.info(`[${n}][getLastTokenType] lastTokenType=${this.lastTokenType}`),this.lastTokenType}updateTokenSettings(n){const{clientSupportsGenericTokenAPI:a,aadTokenExpirationTimeInSeconds:s,caeTokenExpirationTimeInSeconds:c,refreshTimeBeforeTokenTimeoutInSeconds:u,enablePublishTokenTelemetry:m,enableRefreshToken:b,forceClearExpiredTokens:_,enableRefreshTokenRetry:k,enableRefreshTokenRetryInSeconds:N}=n;this.logger.info(`updateTokenSettings ${JSON.stringify(n)}`),this.clientSupportsGenericTokenAPI=a??this.clientSupportsGenericTokenAPI,this.aadTokenExpirationTimeInSeconds=s??this.aadTokenExpirationTimeInSeconds,this.caeTokenExpirationTimeInSeconds=c??this.caeTokenExpirationTimeInSeconds,this.refreshTimeBeforeTokenTimeoutInSeconds=u??this.refreshTimeBeforeTokenTimeoutInSeconds,this.enablePublishTokenTelemetry=m??this.enablePublishTokenTelemetry,this.forceClearExpiredTokens=_??this.forceClearExpiredTokens,this.enableRefreshToken=b??this.enableRefreshToken,this.enableRefreshTokenRetry=k??this.enableRefreshTokenRetry,this.enableRefreshTokenRetryInSeconds=N??this.enableRefreshTokenRetryInSeconds}updateToken(n,a,s,c,u){if(this.logger.info(`[${c}][updateToken] UI replies with a token with factorsJson=${n} updateMetadata=${JSON.stringify(a)} tokenExpirySecSinceEpoch?=${u}`),a.error){this.logger.info(`[${c}][updateToken] UI replies with error ${a.error} for factorsJson ${n}`);for(const b of this.tokensPromiseMap[n])b.tokenRequestOptions.requestMetadataJson.causeId===c&&b.defered.reject({phrase:a.error?.phrase,errorCode:a.error?.code,errorSubCode:a.error?.subCode,causeId:c});return}if(!s){this.logger.info(`[${c}][updateToken] received empty token`);for(const b of this.tokensPromiseMap[n])b.tokenRequestOptions.requestMetadataJson.causeId===c&&b.defered.reject({phrase:"Received empty token",causeId:c});return}if(u>TN()&&this.enableTokenCacheForGenericTokenAPI){this.logger.info(`[${c}][updateToken] caching Token with tokenType=${a.tokenType}`);const b={factorsJson:n,tokenType:a.tokenType,invalidToken:s};this.addToCache(a.tokenType,s,n,this.calculateTokenExpiry(c,b,u))}if(!this.tokensPromiseMap[n]){this.logger.warn(`[updateToken]: UI tries to update token with invalid factorsJson=${n}`);const b={responseCauseId:c,supportTokenApi:this.clientSupportsGenericTokenAPI,requestTokenFactors:n,tokenResponseTime:Date.now(),tokenRequestStatus:6,responseTokenType:a.tokenType};return void this.sendTokenTelemetry(b)}if(this.tokensPromiseMap[n]){const b=this.tokensPromiseMap[n];for(let _=b.length-1;_>=0;_--)(b[_]?.tokenRequestOptions.tokenType&a.tokenType)>0&&(b[_].defered.resolve({token:s,tokenType:a.tokenType,causeId:c}),this.tokensPromiseMap[n].splice(_,1))}if(this.logger.info(`[${c}][updateToken] resolved and upateToken with factorsJson=${n} tokenType=${a.tokenType}`),this.tokensPromiseMap[n].length===0&&delete this.tokensPromiseMap[n],a.tokenType!==4&&a.tokenType!==8&&a.tokenType!==1)return;if(Object.keys(this.tokensPromiseMap).length>0)for(const b of Object.values(this.tokensPromiseMap))for(let _=b.length-1;_>=0;_--){const k=b[_];k.tokenRequestOptions.factorsJson!==n&&(k.tokenRequestOptions.tokenType&a.tokenType)>0&&!k.tokenRequestOptions.isUnauthorized&&(k.defered.resolve({token:s,tokenType:a.tokenType,causeId:c}),b.splice(_,1))}for(const b of Object.keys(this.tokensPromiseMap))this.tokensPromiseMap[b].length===0&&delete this.tokensPromiseMap[b];const m=u-TN();this.startTokenRefreshTimer(m>=0?fw(m):0)}setTokenRequiredCallBack(n){this.tokenCallback=n}setDisableTimerFlag(n){this.logger.info(`[setDisableTimerFlag] set disableTimerFlag to ${n}`),this.stopTimerFlag=n}sendTokenTelemetry(n){if(!this.enablePublishTokenTelemetry)return;const a={};a[ei.TOKEN_TELEMETRY_EVENT.TOKEN_TELEMETRY]=JSON.stringify(n),this.telemetryManager?(this.logger.info("[sendTokenTelemetry] sending token telemetry:",a),this.telemetryManager.sendEvent(ei.EVENT_TYPE.CONVERSATION_TOKEN,a)):this.logger.warn("[sendTokenTelemetry] telemetryManager is undefined, cannot send token telemetry")}dispose(){this.cacheTimers&&this.cacheTimers.dispose()}},Bve={build:(n,a,s,c)=>new WG(n,a,s,c)},wV=class{constructor(n){this.piiScrubber=this.getPiiScrubber(n)}scrubParticipantsList(n){const a=[];return Array.isArray(n)&&n.forEach(s=>a.push(this.scrubMriOrOmit(s))),a}scrubMriOrOmit(n){return typeof n=="string"?this.piiScrubber.mri(n):this.piiScrubber.omit(n)}getPiiScrubber(n){return n&&typeof n.omit=="function"&&typeof n.mri=="function"?n:{omit:()=>"<pii:omit/>",mri:()=>"<pii:mri/>"}}},GR=$i(dn);function KG(n){switch(n){case 0:return"main-audio";case 1:return"main-video";case 2:return"applicationsharing-video";case 3:return"data"}throw new Error("Invalid media type")}function CN(n){switch(n){case"audio":return 0;case"video":return 1;case"applicationsharing-video":case"xapplicationsharing-video":return 2;case"data":return 3;default:return}}function vte(n,a){return n.endpoints?.endpointDetails?.some(s=>s.participantId===a)??!1}function JG(n,a){return n.endpoints?.endpointDetails.find(s=>s.participantId===a)}function O2(n,a){return n.participants.find(s=>vte(s,a))}function _N(n){return!!n?.meetingGroupDetails?.groups&&Object.keys(n.meetingGroupDetails.groups).some(a=>a==="stagingGroup")}function YG(n,a){let s=-1;try{if(n.endpoints)e:for(const c of n.endpoints.endpointDetails)if(c?.mediaStreams!==void 0){for(const u of c.mediaStreams)if(CN(u.type)===a){s=u.sourceId;break e}}else s=DD}catch{return-1}return s}function yte(n,a,s){if(!n?.endpoints)return-1;const c=n.endpoints.endpointDetails.find(m=>m?.participantId===a);if(!c?.mediaStreams)return YG(n,s);const u=c.mediaStreams.find(({type:m})=>CN(m)===s);return u?u.sourceId:-1}function N2(n,a,s){try{if(!n.endpoints)return;for(const c of n.endpoints.endpointDetails)if(c?.mediaStreams){for(const u of c.mediaStreams)if(s===u.sourceId&&CN(u.type)===a)return c.participantId??null}return}catch{return}}function Fve(n){return n.direction==="sendonly"&&n.label==="applicationsharing-video"}function Ste(n){if(n.endpoints?.endpointDetails)return n.endpoints.endpointDetails.length===1?n.endpoints.endpointDetails[0].participantId:n.endpoints.endpointDetails.find(a=>a?.mediaStreams?.some(Fve))?.participantId}function bte(n,a){return n.endpoints?.endpointDetails?.find(s=>s.mediaStreams?.find(c=>c.sourceId===a))}function kV(n){let a={};if(n.stateId)a.result=n.stateId;else if(n.results){const{results:s}=n;s.length===1&&s[0].stateId&&(a.result=s[0].stateId);const c={};n.results.forEach(u=>{const{result:m}=u,b=Uve(u);(a.code===void 0||m.code>a.code)&&(a.code=m.code,a.subCode=m.subCode),c[b]=u}),a.result=JSON.stringify(c)}else n.result&&(a={code:n.result.code,phrase:n.result.phrase,subCode:n.result.subCode,resultCategories:n.result.resultCategories},n.additionalDetail&&(a.result=n.additionalDetail));return a}function Uve(n){return n.participantId||n.participant&&n.participant.id}var RV=class{constructor(n,a){this.broadcastContext=null,this.broadcastControllerUrl="",this.broadcastCallbackUrl="",this.broadcastState=null,this.setContext=(s=null)=>{this.logger.info("BroadcastSession :: set broadcast context",s),this.broadcastContext=s},this.getContext=()=>(this.logger.info("BroadcastSession :: get broadcast context",this.broadcastContext||null),this.broadcastContext||null),this.signalingSession=n,this.signalingSessionCallback=a,this.logger=n.logger.createChild(()=>"[Broadcast]")}handleBroadcastStateChanged(n){const a=n.body;this.broadcastState=a;const s=Po(n);this.signalingSession.telemetryHelper.recordIncomingEvent(Ft.BROADCAST_STATE_CHANGED,n),this.logger.info(`[${s}] broadcast state changed=${this.broadcastState}`),this.updateBroadcastMetadata(s)}updateBroadcastCallbackUrl(n){const a=Vn(this.signalingSession,Fi.CONV_BROADCAST_UPDATE);this.broadcastCallbackUrl!==a&&(this.broadcastCallbackUrl=a,this.logger.info(`[${n}] broadcast callback url changed=${this.broadcastCallbackUrl}`),this.updateBroadcastMetadata(n))}handleBroadcastDetailsChanged(n,a){this.signalingSession.telemetryHelper.recordEvent(Ft.UPDATE_BROADCAST_DETAILS,{causeId:a}),n.activeModalities&&n.activeModalities.broadcast&&n.activeModalities.broadcast.controller!==this.broadcastControllerUrl&&(this.broadcastControllerUrl=n.activeModalities.broadcast.controller,this.broadcastAdditionalData=n.activeModalities.broadcast,this.logger.info(`[${a}] broadcast controller changed=${this.broadcastControllerUrl}`),this.signalingSessionCallback.onBroadcastMeetingConnected(ge.SUCCESS_TRANSACTION_END,a),this.updateBroadcastMetadata(a)),!this.broadcastControllerUrl||n.activeModalities&&n.activeModalities.broadcast||(this.broadcastControllerUrl="",this.broadcastContext=null,this.logger.info(`[${a}] broadcast controller changed=${this.broadcastControllerUrl}`),this.updateBroadcastMetadata(a),this.signalingSessionCallback.onBroadcastMeetingEnded(ge.SUCCESS_TRANSACTION_END,a))}handleAddBroadcastModalitySuccess(n,a){this.logger.info(`[${a}][handleAddBroadcastModalitySuccess]`)}handleAddBroadcastModalityFailure(n,a){this.logger.info(`[${a}][handleAddBroadcastModalityFailure]`);const s={...n.modalityFailure.broadcast};this.signalingSessionCallback.onBroadcastMeetingEnded(s,a)}updateBroadcastMetadata(n){const a={broadcastControllerUrl:this.broadcastControllerUrl,broadcastStateCallbackUrl:this.broadcastCallbackUrl,broadcastState:this.broadcastState,broadcastAdditionalData:this.broadcastAdditionalData};this.logger.info(`[${n}] update broadcast metadata=${a}`),this.signalingSessionCallback.onBroadcastMeetingUpdated&&this.signalingSessionCallback.onBroadcastMeetingUpdated(a,n)}},zve="http://broker.invalid/",Tte=30,Cte=5,_te=1,Ete=class{constructor(n){this._signalingSession=n,this.baseUrl=zve,this.currentSubscriptionUrl=null,this._currentSubscriptionTimeoutInSec=Tte,this._subscribers=[],this._disposed=!1,this._reportedResultCount=0,this._subscriptionRetryBackoffInSec=Cte,this._notifySubscribers=a=>{this._logger.info("_notifySubscribers"),Promise.resolve().then(()=>{a.split(",").forEach(s=>{const c=$G(EV(s));let u=c.body;lte(c.headers)&&cte(c.headers)&&(u=EV(u));const m={url:c.url,body:JSON.parse(u),headers:c.headers};this._logger.info("message length=",u.length,"n. of subscribers",this._subscribers.length),this._subscribers.forEach(b=>b(m))})}).catch(s=>{this._logger.error("_notifySubscribers, failed to decode message",s),this._signalingSession.telemetryHelper.recordEvent(Ft.BROKER_DECODE_PAYLOAD_FAILURE)})},this._subscribeToBroker=(a,s)=>{if(this._disposed)return void this._logger.warn("_subscribeToBroker, disposed, ignore subscription");const c=tr();this._logger.info("_subscribeToBroker, url: ",a,",timeout in sec",s),this.currentSubscriptionUrl=a,this._currentSubscriptionTimeoutInSec=s,this._clearAllPendingTimeouts(),this._setSubscriptionTimeout(s),this._signalingSession.http.sendGetRequest({url:this.currentSubscriptionUrl,requestName:$n.BROKER_SUBSCRIBE.name,customHeaders:this._getBrokerRequestHeaders(c),payload:null,skipHttpTelemetry:!this._reportSubscriptionInTelemetry(),causeId:tr(),operationType:"BrokerSubscribe"}).then(this._handleSubscriptionSuccess).catch(this._handleSubscriptionFailure)},this._clearAllPendingTimeouts=()=>{this._cancelRequestTimer&&(this._cancelRequestTimer.stop(),this._cancelRequestTimer=null),this._retryRequestTimer&&(this._retryRequestTimer.stop(),this._retryRequestTimer=null)},this._abortPendingRequest=()=>{this._signalingSession.http.cancelRequestIfPending($n.BROKER_SUBSCRIBE.name,tr())},this._setSubscriptionTimeout=a=>{this._cancelRequestTimer=ku.build(()=>{this._disposed||(this._signalingSession.http.hasPendingRequest($n.BROKER_SUBSCRIBE.name)?(this._logger.warn("timeout subscription"),this._signalingSession.telemetryHelper.recordEvent(Ft.BROKER_SUBSCRIPTION_TIMEOUT),this._signalingSession.http.cancelRequestIfPending($n.BROKER_SUBSCRIBE.name,tr())):this._logger.error("Unable to resolve timeout deferred, it is not defined!"))},"TIMEOUT").start(1e3*a)},this._handleSubscriptionSuccess=a=>{if(this._disposed)this._logger.warn("_handleSubscriptionSuccess, disposed, ignore subscription success");else if(this._reportSubscriptionInTelemetry(a)&&this._signalingSession.telemetryHelper.recordEvent(Ft.BROKER_SUBSCRIPTION_SUCCESSFUL),a?.response){const s=a.response;this._logger.info("_handleSubscriptionSuccess, response",s),s.message&&this._notifySubscribers(s.message);const c=s.nextSubscribeUrl||this.currentSubscriptionUrl,u=s.expirationTimeInSec||this._currentSubscriptionTimeoutInSec;this._subscribeToBroker(c,u)}else this._logger.info("_handleSubscriptionSuccess, empty response")},this._handleSubscriptionFailure=a=>{if(this._disposed)return void this._logger.warn("_handleSubscriptionFailure, disposed, ignore subscription");if(a.status>=400&&a.status<500&&a.status!==401&&this.isNotNetworkErrors(a.status))return void this._logger.warn(`_handleSubscriptionFailure, received status ${a.status}, stop subscribing`);const s=fi(a);this._logger.error("_handleSubscriptionFailure failed, re-subscribing",s),this._reportSubscriptionInTelemetry()&&this._signalingSession.telemetryHelper.recordEvent(Ft.BROKER_SUBSCRIPTION_FAILED),this._retryRequestTimer=ku.build(()=>{this._subscribeToBroker(this.currentSubscriptionUrl,this._currentSubscriptionTimeoutInSec)},"RETRY").start(1e3*this._subscriptionRetryBackoffInSec)},this._reportSubscriptionInTelemetry=a=>(this._reportedResultCount++,this._reportedResultCount<=_te),this._getBrokerRequestHeaders=a=>{const s=new zb;return s.set(ge.HEADERS.CONTENT_TYPE,ge.CONTENT_TYPE.JSON),this._signalingSession.signalingAgentConfig.brokerRequestBatching&&s.set(ge.HEADERS.BROKER_USE_BATCHING_HEADER_NAME,"1"),s},this._logger=this._signalingSession.logger.createChild("Broker"),this._signalingSession.signalingAgentConfig.csaTimeoutConfiguration?.brokerRetryBackOffInSec&&(this._subscriptionRetryBackoffInSec=this._signalingSession.signalingAgentConfig.csaTimeoutConfiguration.brokerRetryBackOffInSec)}subscribeToBroker(n){this._logger.info("subscribeToBroker called."),this._abortPendingRequest(),this._clearAllPendingTimeouts(),this._subscribeToBroker(n,this._currentSubscriptionTimeoutInSec)}onBrokerMessage(n){this._logger.info("onBrokerMessage callback added"),this._subscribers.push(n)}dispose(){this._disposed=!0,this._logger.info("dispose"),this._subscribers=[],this._clearAllPendingTimeouts(),this._abortPendingRequest()}isNotNetworkErrors(n){return n!==490&&n!==496&&n!==498&&n!==499}},Ate=class{constructor(n){this.requests={},this.logger=n}clear(n,a){const s=a||{code:ge.CALL_END_CODE.SUCCESS,subCode:ge.CALL_END_SUB_CODE.SUCCESS,phrase:ge.CALL_END_PHRASE.LOCAL_USER_INITIATED};Object.keys(this.requests).forEach(c=>{try{const u=parseInt(c,10);Object.keys(this.requests[u]).forEach(m=>{this.rejectOperation(u,m,n,s)})}catch(u){this.logger.warn(`CallOperations: clear error = ${u}`)}})}hasOperation(n,a){return this.requests.hasOwnProperty(n.valueOf())&&this.requests[n.valueOf()].hasOwnProperty(a)}getAllOperations(){return this.requests}getOperation(n,a){return this.hasOperation(n,a)?this.requests[n.valueOf()][a]:null}setOperation(n,a,s){return!this.hasOperation(n,a)&&(this.hasOwnProperty(n.valueOf())||(this.requests[n.valueOf()]={}),this.requests[n.valueOf()][a]=s,!0)}rejectOperation(n,a,s,c){if(this.hasOperation(n,a)){const u=n.valueOf(),m=this.requests[u][a].promise;delete this.requests[u][a],m.reject(c)}}resolveOperation(n,a,s,c){if(this.hasOperation(n,a)){const u=n.valueOf(),m=this.requests[u][a].promise;delete this.requests[u][a],m.resolve(s)}}},Ite=class{constructor(n){this.logger=n,this.localRequests=new Ate(n)}dispose(n,a,s){this.logger.info(`[${s}][dispose]`),this.rejectAllPendingOperations(n,a)}hasPendingOperation(n,a,s){return this.logger.info(`[${s}][hasPendingOperation] ${n} ${kn(a)}}`),this.localRequests.hasOperation(n,a)}rejectPendingOperation(n,a,s,c,u){this.logger.info(`[${u}][rejectPendingOperation] ${n} ${a} reason: ${s} endCode: ${c}`),this.localRequests.rejectOperation(n,a,s,c)}resolvePendingOperation(n,a,s,c){this.logger.info(`[${c}][resolvePendingOperation]: ${kn(a)}`),this.localRequests.resolveOperation(n,a,s,c)}setPendingOperation(n,a,s,c){return this.logger.info(`[${c}][setPendingOperation] ${n} value: ${s}`),this.localRequests.setOperation(n,a,s)}rejectAllPendingOperations(n,a){this.logger.info("rejectLocalQueuedOperations"),this.localRequests.clear(n,a)}};function wte(n,a){return xn(n,"signalingSession cannot be null"),xn(a,"content cannot be null"),{payload:{participants:{from:{id:n.participantManager.localParticipant.id,displayName:n.participantManager.localParticipant.displayName,endpointId:n.participantManager.localParticipant.endpointId,participantId:n.participantManager.localParticipant.participantId,languageId:n.participantManager.localParticipant.languageId},to:[]},contentSharing:{identifier:a.contentIdentifier,subject:a.subject,sessionState:a.sessionState,sequenceNumber:a.sequenceNumber,links:{sessionUpdate:Vn(n,Fi.CONV_CONTENT_SHARING_UPDATE),sessionEnd:Vn(n,Fi.CONV_CONTENT_SHARING_END)}},links:{addModalitySuccess:Vn(n,Fi.CONV_ADD_MODALITY_SUCCESS),addModalityFailure:Vn(n,Fi.CONV_ADD_MODALITY_FAILURE)}}}}function kte(n){return xn(n,"signalingSession cannot be null"),{payload:{contentSharing:{links:{sessionUpdate:Vn(n,Fi.CONV_CONTENT_SHARING_UPDATE),sessionEnd:Vn(n,Fi.CONV_CONTENT_SHARING_END)}},participants:{from:{id:n.participantManager.localParticipant.id,displayName:n.participantManager.localParticipant.displayName,endpointId:n.participantManager.localParticipant.endpointId,participantId:n.participantManager.localParticipant.participantId,languageId:n.participantManager.localParticipant.languageId}}}}}function Rte(n,a){return xn(n,"signalingSession cannot be null"),X_(a),{payload:{contentSharingTransactionEnd:a,participants:{from:{id:n.participantManager.localParticipant.id,displayName:n.participantManager.localParticipant.displayName,endpointId:n.participantManager.localParticipant.endpointId,participantId:n.participantManager.localParticipant.participantId,languageId:n.participantManager.localParticipant.languageId}}}}}function Mte(n){return xn(n,"signalingSession cannot be null"),{payload:{participants:{from:{id:n.participantManager.localParticipant.id,displayName:n.participantManager.localParticipant.displayName,endpointId:n.participantManager.localParticipant.endpointId,participantId:n.participantManager.localParticipant.participantId,languageId:n.participantManager.localParticipant.languageId}}}}}function Pte(n){return xn(n,"signalingSession cannot be null"),{payload:{participants:{from:{id:n.participantManager.localParticipant.id,displayName:n.participantManager.localParticipant.displayName,endpointId:n.participantManager.localParticipant.endpointId,participantId:n.participantManager.localParticipant.participantId,languageId:n.participantManager.localParticipant.languageId}},links:{sessionUpdate:Vn(n,Fi.CONV_CONTENT_SHARING_UPDATE),sessionEnd:Vn(n,Fi.CONV_CONTENT_SHARING_END)}}}}function Dte(n){return xn(n,"signalingSession cannot be null"),{payload:{participants:{from:{id:n.participantManager.localParticipant.id,displayName:n.participantManager.localParticipant.displayName,endpointId:n.participantManager.localParticipant.endpointId,participantId:n.participantManager.localParticipant.participantId,languageId:n.participantManager.localParticipant.languageId}}}}}function Lte(n,a,s){return xn(n,"signalingSession cannot be null"),xn(a,"sessionState cannot be null"),xn(s,"sequenceNumber cannot be null"),{payload:{sessionUpdateSequenceNumber:s,sessionState:a,participants:{from:{id:n.participantManager.localParticipant.id,displayName:n.participantManager.localParticipant.displayName,endpointId:n.participantManager.localParticipant.endpointId,participantId:n.participantManager.localParticipant.participantId,languageId:n.participantManager.localParticipant.languageId}}}}}var Ote=class{constructor(){this.msElapsed=0,this.isPaused=!1,this.startTime=new Date().getTime(),this.pause=()=>{this.isPaused||(this.msElapsed+=new Date().getTime()-this.startTime,this.isPaused=!0)},this.resume=()=>{this.isPaused&&(this.isPaused=!1,this.startTime=new Date().getTime())},this.duration=()=>this.isPaused?this.msElapsed:this.msElapsed+new Date().getTime()-this.startTime,this.durationInMinutes=()=>{const n=this.duration()/6e4;return Math.ceil(n)},this.durationInSeconds=()=>{const n=this.duration()/1e3;return Math.ceil(n)}}};function US(){return new Ote}var MV=class{constructor(n,a,s,c){this.signalingSession=n,this.correlationId=a,this.sessionId=null,this.fsmState=ge.CONTENT_SHARING_FSM_STATE.IDLE,this.addSessionPromise=null,this.removeSessionPromise=null,this.confirmInRosterPromise=null,this.links={},this.lastUpdateSequenceNumber=-1,this.nextClientSequenceNumberToUse=1,this.disposed=!1,this.isPresenter=!1,this.FSM_STATES=ge.CONTENT_SHARING_FSM_STATE,this.logger=n.logger.createChild(()=>`[${this.fsmState}][cs=${this.sessionId}][cc=${this.correlationId}]`),s&&(this.sessionId=s),c&&(this.links=c)}start(n,a,s,c){if(this.logger.info(`[${c}][start]`),lc(n,"Correct addModality url is not provided"),!this.checkState("start",this.FSM_STATES.IDLE,this.addSessionPromise))return Promise.reject(null);this.addSessionPromise=s,this.confirmInRosterPromise=Pl(),this.fsmState=this.FSM_STATES.CONTENT_SHARING_START_INITIATED,this.addTelemetryOperation($n.ADD_CONTENT_SHARING_MODALITY.name,{causeId:c});const u=new zb;return u.set(ge.HEADERS.CONTENT_SHARING_CORRELATION_ID,this.correlationId),this.signalingSession.http.sendPostRequest({url:n,payload:wte(this.signalingSession,a),requestName:$n.ADD_CONTENT_SHARING_MODALITY.name,customHeaders:u,onceTrouterReady:()=>{this.startContentSharingTimer(c)},causeId:c}).then(()=>{this.disposed||(this.presenterMri=this.signalingSession.participantManager.localParticipant.id,this.isPresenter=!0)}).catch(m=>{const b=Lr(m,this.signalingSession.signalingAgentConfig);return this.logger.info(`[${c}][start] error: ${fi(b)}`),this.disposed||(this.signalingSession.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.ADD_MODALITY),this.rejectPendingPromise(fi(m),b.error)),Promise.reject(null)})}delete(n,a){this.logger.info(`[${a}][delete]`);let s=!1;if(this.fsmState===this.FSM_STATES.IDLE)return this.logger.info(`[${a}][delete] skipped because state is already ${this.fsmState}`),n.resolve(),Promise.resolve();if(this.fsmState===this.FSM_STATES.CONTENT_SHARING_START_INITIATED)s=!0,this.rejectPendingPromise("Session delete called before start was finished");else if(!this.checkState("delete",this.FSM_STATES.CONTENT_SHARING_CONNECTED,n))return Promise.reject(null);s||lc(this.links[ge.LINKS.CONTENT_SHARING_CONTROLLER],"Correct controller url is not set"),this.removeSessionPromise=n,this.fsmState=this.FSM_STATES.CONTENT_SHARING_DELETE_INITIATED;const c=US(),u=this.addTelemetryOperation($n.DELETE_CONTENT_SHARING.name,{causeId:a});return(s?Promise.resolve(void 0):this.signalingSession.http.sendDeleteRequest({url:this.links[ge.LINKS.CONTENT_SHARING_CONTROLLER],requestName:$n.DELETE_CONTENT_SHARING.name,payload:Rte(this.signalingSession,{code:ge.CALL_END_CODE.SUCCESS,subCode:ge.CALL_END_SUB_CODE.SUCCESS,phrase:ge.CALL_END_PHRASE.LOCAL_USER_INITIATED}),causeId:a})).then(()=>{if(!this.disposed){const m={success:!0,duration:c.duration()};s&&(m.skipReason="Session delete called before start was finished"),this.updateTelemetryOperation(u,m),this.fsmState=this.FSM_STATES.IDLE,this.resolvePendingPromise()}}).catch(m=>{const b=Lr(m,this.signalingSession.signalingAgentConfig);if(this.logger.info(`[${a}][delete] error: ${fi(b)}`),!this.disposed){const _={success:!1,duration:c.duration()};this.updateTelemetryOperation(u,_),this.fsmState=this.FSM_STATES.IDLE,this.resolvePendingPromise()}return Promise.reject(null)})}join(n,a){if(this.logger.info(`[${a}][join]`),lc(this.links[ge.LINKS.CONTENT_SHARING_CONTROLLER],"Correct joinContentSharing url is not provided"),!this.checkState("join",this.FSM_STATES.IDLE,n))return;this.lastUpdateSequenceNumber=-1,this.nextClientSequenceNumberToUse=1,this.addSessionPromise=n,this.fsmState=this.FSM_STATES.CONTENT_SHARING_JOIN_INITIATED;const s=US(),c=this.addTelemetryOperation($n.JOIN_CONTENT_SHARING.name,{causeId:a});this.signalingSession.http.sendPostRequest({url:this.links[ge.LINKS.CONTENT_SHARING_CONTROLLER],payload:kte(this.signalingSession),requestName:$n.JOIN_CONTENT_SHARING.name,causeId:a}).then(u=>{if(!this.disposed){const m={success:!0,duration:s.duration()};this.updateTelemetryOperation(c,m),this.processStartOrJoinSuccess(u.response),this.resolvePendingPromise(u.response)}}).catch(u=>{const m=Lr(u,this.signalingSession.signalingAgentConfig);if(this.logger.info(`[${a}][join] error: ${fi(m)}`),!this.disposed){const b={success:!1,duration:s.duration()};this.updateTelemetryOperation(c,b);const _=m.error;this.rejectPendingPromise(fi(u),_)}})}takeControl(n,a){if(this.logger.info(`[${a}][takeControl]`),lc(this.links[ge.LINKS.CONTENT_SHARING_TAKE_CONTROL],"correct contentSharingTakeControl url is not provided"),!this.checkState("takeControl",this.FSM_STATES.CONTENT_SHARING_CONNECTED,n))return;const s=US(),c=this.addTelemetryOperation($n.TAKE_CONTROL_CONTENT_SHARING.name,{causeId:a});this.signalingSession.http.sendPostRequest({url:this.links[ge.LINKS.CONTENT_SHARING_TAKE_CONTROL],payload:Mte(this.signalingSession),requestName:$n.TAKE_CONTROL_CONTENT_SHARING.name,withoutTrouter:!0,causeId:a}).then(u=>{if(!this.disposed){const m={success:!0,duration:s.duration()};this.updateTelemetryOperation(c,m);const b={contentIdentifier:u.response.identifier,presenter:u.response.presenter.id,subject:u.response.subject||null,sessionState:u.response.sessionState||null};n.resolve(b)}}).catch(u=>{const m=Lr(u,this.signalingSession.signalingAgentConfig);if(this.logger.info(`[${a}][takeControl] error: ${fi(m)}`),!this.disposed){const b={success:!1,duration:s.duration()};this.updateTelemetryOperation(c,b);const _=new Error(fi(u));_.endCode=m.error,n.reject(_)}})}updateSessionState(n,a,s){if(this.logger.info(`[${s}][updateSessionState]`),lc(this.links[ge.LINKS.CONTENT_SHARING_UPDATE_SESSION_STATE],"Correct sendUpdateSessionState url is not provided"),!this.checkState("updateSessionState",this.FSM_STATES.CONTENT_SHARING_CONNECTED,a))return;const c=US(),u=this.addTelemetryOperation($n.UPDATE_SESSION_STATE_CONTENT_SHARING.name,{causeId:s});this.signalingSession.http.sendPostRequest({url:this.links[ge.LINKS.CONTENT_SHARING_UPDATE_SESSION_STATE],payload:Lte(this.signalingSession,n,this.nextClientSequenceNumberToUse++),requestName:$n.UPDATE_SESSION_STATE_CONTENT_SHARING.name,causeId:s}).then(()=>{if(!this.disposed){const m={success:!0,duration:c.duration()};this.updateTelemetryOperation(u,m),a.resolve()}}).catch(m=>{const b=Lr(m,this.signalingSession.signalingAgentConfig);if(this.logger.info(`[${s}][updateSessionState] error: ${fi(b)}`),!this.disposed){const _={success:!1,duration:c.duration()};this.updateTelemetryOperation(u,_);const k=new Error(fi(m));k.endCode=b.error,a.reject(k)}})}updateParticipantState(n,a){if(this.logger.info(`[${a}][updateParticipantState]`),lc(this.links[ge.LINKS.CONTENT_SHARING_UPDATE_PARTICIPANT_STATE],"correct confirmContentSharingView url is not provided"),!this.checkState("updateParticipantState",this.FSM_STATES.CONTENT_SHARING_CONNECTED,n))return;const s=US(),c=this.addTelemetryOperation($n.UPDATE_PARTICIPANT_STATE_CONTENT_SHARING.name,{causeId:a});this.signalingSession.http.sendPostRequest({url:this.links[ge.LINKS.CONTENT_SHARING_UPDATE_PARTICIPANT_STATE],payload:Dte(this.signalingSession),requestName:$n.UPDATE_PARTICIPANT_STATE_CONTENT_SHARING.name,withoutTrouter:!0,causeId:a}).then(()=>{if(!this.disposed){const u={success:!0,duration:s.duration()};this.updateTelemetryOperation(c,u),n.resolve()}}).catch(u=>{const m=Lr(u,this.signalingSession.signalingAgentConfig);if(this.logger.info(`[${a}][updateParticipantState] error: ${fi(m)}`),!this.disposed){const b={success:!1,duration:s.duration()};this.updateTelemetryOperation(c,b);const _=new Error(fi(u));_.endCode=m.error,n.reject(_)}})}updateNotificationLinks(n){if(this.logger.info(`[${n}][updateNotificationLinks]`),lc(this.links[ge.LINKS.CONTENT_SHARING_NOTIFICATION_LINKS],"correct notificationLinks url is not provided"),!this.checkState("updateState",this.FSM_STATES.CONTENT_SHARING_CONNECTED))return;const a=US(),s=this.addTelemetryOperation($n.UPDATE_CONTENT_SHARING_NOTIFICATION_LINKS.name,{causeId:n});this.signalingSession.http.sendPostRequest({url:this.links[ge.LINKS.CONTENT_SHARING_NOTIFICATION_LINKS],payload:Pte(this.signalingSession),requestName:$n.UPDATE_CONTENT_SHARING_NOTIFICATION_LINKS.name,withoutTrouter:!0,causeId:n}).then(()=>{if(!this.disposed){const c={success:!0,duration:a.duration()};this.updateTelemetryOperation(s,c)}}).catch(c=>{const u=Lr(c,this.signalingSession.signalingAgentConfig);if(this.logger.info(`[${n}][updateNotificationLinks] error: ${fi(u)}`),!this.disposed){const m={success:!1,duration:a.duration()};this.updateTelemetryOperation(s,m)}})}confirmInRoster(){this.confirmInRosterPromise&&this.confirmInRosterPromise.isPending&&(this.logger.info("Confirmed in roster"),this.confirmInRosterPromise.resolve())}handleAddModalitySuccess(n,a){return this.logger.info(`[${a}][handleAddModalitySuccess]`),this.checkState("handleAddModalitySuccess",this.FSM_STATES.CONTENT_SHARING_START_INITIATED)?n.modalitySuccess&&n.modalitySuccess.contentSharing?(this.addTelemetryOperation(Ft.HANDLE_ADD_MODALITY_SUCCESS,{causeId:a}),this.processStartOrJoinSuccess(n.modalitySuccess.contentSharing),this.confirmInRosterPromise.promise.then(()=>{delete this.confirmInRosterPromise,this.signalingSession.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.ADD_MODALITY),this.resolvePendingPromise(n.modalitySuccess.contentSharing)}),!0):(this.addTelemetryOperation(Ft.HANDLE_ADD_MODALITY_SUCCESS,{causeId:a,skipReason:"no content sharing blob"}),this.logger.info(`[${a}][handleAddModalitySuccess] ignored because modalitySuccess was missing or did not contain content sharing blob`),!1):(this.logger.info(`[${a}][handleAddModalitySuccess] ignored because session is not waiting to start`),!1)}handleAddModalityFailure(n,a){if(this.logger.info(`[${a}][handleAddModalityFailure]`),!this.checkState("handleAddModalityFailure",[this.FSM_STATES.CONTENT_SHARING_START_INITIATED,this.FSM_STATES.CONTENT_SHARING_CONNECTED]))return!1;if(!n.modalityFailure||!n.modalityFailure.contentSharing)return this.addTelemetryOperation(Ft.HANDLE_ADD_MODALITY_FAILURE,{causeId:a,skipReason:"no content sharing blob"}),!1;const s=n.modalityFailure.contentSharing;this.addTelemetryOperation(Ft.HANDLE_ADD_MODALITY_FAILURE,{reason:s,causeId:a});const c={...s};return this.sendTelemetryData(c),this.rejectPendingPromise(c.phrase,c),this.signalingSession.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.ADD_MODALITY),!0}handleStartFromRoster(n,a){this.logger.info(`[${a}][handleStartFromRoster]`),this.addTelemetryOperation(Ft.CONTENT_SHARING_START_FROM_ROSTER,{causeId:a})}handleStopFromRoster(n,a){this.logger.info(`[${a}][handleStopFromRoster]`),this.addTelemetryOperation(Ft.CONTENT_SHARING_END_FROM_ROSTER,{causeId:a}),this.sendTelemetryData(n)}handleStop(n,a){if(this.logger.info(`[${a}][handleStop]`),this.isSelfInitiatedAction(n))return this.logger.info(`[${a}][handleStop]handleStop skipped because session was ended by self`),!1;const s={...n.contentSharingTransactionEnd};return this.addTelemetryOperation(Ft.HANDLE_CONTENT_SHARING_END,{causeId:a}),this.sendTelemetryData(s),!0}handleUpdate(n,a){return this.logger.info(`[${a}][handleUpdate]`),n.sequenceNumber<=this.lastUpdateSequenceNumber?(this.logger.info(`handleUpdate skipped because of old sequence number: last received ${this.lastUpdateSequenceNumber}, update contained ${n.sequenceNumber}`),this.addTelemetryOperation(Ft.HANDLE_CONTENT_SHARING_UPDATE,{causeId:a,skipReason:"old sequence number"}),!1):(this.lastUpdateSequenceNumber=n.sequenceNumber,this.isPresenter=n.presenter.id===this.signalingSession.participantManager.localParticipant.id,this.addTelemetryOperation(Ft.HANDLE_CONTENT_SHARING_UPDATE,{causeId:a}),!0)}dispose(n,a){this.logger.info(`[${a}][dispose]`),this.disposed=!0,this.rejectPendingPromise("call ended",n||{code:ge.CALL_END_CODE.SUCCESS,subCode:ge.CALL_END_SUB_CODE.SUCCESS,phrase:ge.CALL_END_PHRASE.LOCAL_USER_INITIATED}),this.addTelemetryOperation(Ft.HANDLE_CALL_END,{causeId:a}),this.sendTelemetryData(n)}rejectPendingPromise(n,a){this.logger.info("rejectPendingPromise");const s=new Error(n);a&&(s.endCode=a),this.removeSessionPromise&&(this.removeSessionPromise.reject(s),this.removeSessionPromise=null),this.addSessionPromise&&(this.addSessionPromise.reject(s),this.addSessionPromise=null)}resolvePendingPromise(n){this.logger.info("resolvePendingPromise");let a=null;n&&(a={sessionId:n.sessionId,correlationId:n.contentSharingCorrelationId,contentIdentifier:n.identifier,presenter:n.presenter.id,subject:n.subject||null,sessionState:n.sessionState||null}),this.removeSessionPromise&&(this.removeSessionPromise.resolve(a),this.removeSessionPromise=null),this.addSessionPromise&&(this.addSessionPromise.resolve(a),this.addSessionPromise=null)}processStartOrJoinSuccess(n){this.logger.info("processStartOrJoinSuccess"),this.sessionId=n.sessionId,this.fsmState=this.FSM_STATES.CONTENT_SHARING_CONNECTED,this.lastUpdateSequenceNumber=-1,this.links[ge.LINKS.CONTENT_SHARING_CONTROLLER]=n.links.contentSharingController,this.links[ge.LINKS.CONTENT_SHARING_TAKE_CONTROL]=n.links.takeControl,this.links[ge.LINKS.CONTENT_SHARING_UPDATE_SESSION_STATE]=n.links.updateSessionState,this.links[ge.LINKS.CONTENT_SHARING_UPDATE_PARTICIPANT_STATE]=n.links.sync,this.links[ge.LINKS.CONTENT_SHARING_NOTIFICATION_LINKS]=n.links.notificationLinks,this.links[ge.LINKS.CONTENT_SHARING_LEAVE]=n.links.leave}checkState(n,a,s){let c;if(c=typeof a=="string"?this.fsmState===a:a.indexOf(this.fsmState)>-1,c)return!0;{const u=`${n} requires state ${a}, but state is ${this.fsmState}`;return this.logger.error(u),s&&s.reject(u),!1}}isSelfInitiatedAction(n){return n.presenter.participantId===this.signalingSession.participantManager.localParticipant.participantId}startContentSharingTimer(n){this.logger.info("startContentSharingTimer"),this.signalingSession.timeoutManager.startTimer(ge.TIMEOUT_OPERATIONS.ADD_MODALITY,()=>{this.addTelemetryOperation(Ft.ADD_MODALITY_TIMEOUT,{causeId:n}),this.signalingSession.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.ADD_MODALITY),this.rejectPendingPromise("timed out waiting for ContentSharing to start",{code:ge.CALL_END_CODE.TIMEOUT,subCode:ge.CALL_END_SUB_CODE.CALL_ESTABLISHMENT_TIMEOUT,phrase:ge.CALL_END_PHRASE.ESTABLISHMENT_TIMEOUT})},ge.TIMEOUT_VALUES_IN_SECONDS.ADD_MODALITY_TIMEOUT)}addTelemetryOperation(n,a){return this.signalingSession.telemetryHelper.addContentSharingOperation(this.correlationId,n,a)}updateTelemetryOperation(n,a){this.signalingSession.telemetryHelper.updateContentSharingOperation(this.correlationId,n,a)}sendTelemetryData(n){this.signalingSession.telemetryHelper.sendContentSharingTelemetryData(this.correlationId,this.signalingSession.sessionId,this.isPresenter,n,this.links[ge.LINKS.CONTENT_SHARING_CONTROLLER],this.sessionId)}},Vve=class{constructor(n,a){this.contentSharingToStartCallWith=null,this.contentSharingSessions={},this.DEFAULT_STOP_REASON={code:ge.CALL_END_CODE.SUCCESS,subCode:ge.CALL_END_SUB_CODE.SUCCESS,phrase:ge.CALL_END_PHRASE.REMOTE_USER_INITIATED},this.DEFAULT_STOP_ID="8:unknown",this.deleteContentSharingAsync=(s,c)=>{this.logger.info(`[${c}][deleteContentSharingAsync]`);const u=Pl();let m=this.contentSharingSessions[s];if(this.pendingSessionToStart&&this.pendingSessionToStart.correlationId===s&&(m=this.pendingSessionToStart),m){const b=()=>{this.contentSharingSessions[s]&&delete this.contentSharingSessions[s]};m.delete(u,c).then(b,b)}else this.rejectBecauseOfMissingSession(s,u);return u.promise},this.signalingSession=n,this.signalingSessionCallback=a,this.logger=n.logger.createChild(()=>"[ContentSharingManager]"),this.lastProcessedSequenceNumber=-1,this.lastProcessedSequenceNumberForParticipant={}}startContentSharingAsync(n,a,s,c,u,m,b){if(this.logger.info(`startContentSharingAsync called for: ${n}`),this.pendingSessionToStart){const W="There is already a ContentSharing session start pending";return this.logger.error(W),Promise.reject(new Error(W))}const _={contentIdentifier:n,subject:s||null,sessionState:a||null,sequenceNumber:1},k=Pl(),N=new MV(this.signalingSession,b||My());return this.pendingSessionToStart=N,u?(this.logger.info("Call connected, send content sharing request out immediately"),N.start(c,_,k,m)):(this.logger.info("Content sharing is to be started when startOutgoingCall is called"),N.addSessionPromise=k,N.fsmState=ge.CONTENT_SHARING_FSM_STATE.CONTENT_SHARING_START_INITIATED,this.contentSharingToStartCallWith=_),k.promise.then(()=>{this.contentSharingSessions.hasOwnProperty(N.correlationId)||(this.contentSharingSessions[N.correlationId]=N),this.pendingSessionToStart=null}).catch(()=>{this.pendingSessionToStart=null}),k.promise}joinContentSharingAsync(n,a){this.logger.info(`[${a}][joinContentSharingAsync]`);const s=Pl(),c=this.contentSharingSessions[n];return c?c.join(s,a):this.rejectBecauseOfMissingSession(n,s),s.promise}updateContentSharingSessionStateAsync(n,a,s){this.logger.info(`[${s}][updateContentSharingSessionStateAsync][sessionState=${JSON.stringify(a)}]`);const c=Pl(),u=this.contentSharingSessions[n];return u?u.updateSessionState(a,c,s):this.rejectBecauseOfMissingSession(n,c),c.promise}takeContentSharingControlAsync(n,a){this.logger.info(`[${a}][takeContentSharingControlAsync]`);const s=Pl(),c=this.contentSharingSessions[n];return c?c.takeControl(s,a):this.rejectBecauseOfMissingSession(n,s),s.promise}updateContentSharingParticipantStateAsync(n,a){this.logger.info(`[${a}][updateContentSharingParticipantStateAsync]`);const s=Pl(),c=this.contentSharingSessions[n];return c?c.updateParticipantState(s,a):this.rejectBecauseOfMissingSession(n,s),s.promise}updateContentSharingNotificationLinksAsync(n){this.logger.info(`[${n}][updateContentSharingNotificationLinksAsync]`);for(const a of Object.keys(this.contentSharingSessions))if(this.contentSharingSessions.hasOwnProperty(a)){const s=this.contentSharingSessions[a];s&&s.updateNotificationLinks(n)}}getContentSharingInfoToStartSharing(){if(this.contentSharingToStartCallWith){const n=this.pendingSessionToStart,a=ge.CONTENT_SHARING_FSM_STATE.CONTENT_SHARING_START_INITIATED;n&&n.fsmState===a||(this.contentSharingToStartCallWith=null,this.pendingSessionToStart=null)}return this.contentSharingToStartCallWith}dispose(n,a){this.logger.info(`[${a}][dispose]`);for(const s of Object.keys(this.contentSharingSessions))if(this.contentSharingSessions.hasOwnProperty(s)){const c=this.contentSharingSessions[s];c&&c.dispose(n,a)}}handleContentSharingUpdate(n){const a=n.body,s=Po(n),c=this.contentSharingSessions[a.contentSharingCorrelationId];c?c.handleUpdate(a,s)&&this.signalingSessionCallback.onContentSharingUpdated({sessionId:a.sessionId,correlationId:a.contentSharingCorrelationId,contentIdentifier:a.identifier,presenter:a.presenter.id,subject:a.subject||null,sessionState:a.sessionState||null},s):this.logger.info(`[${s}][handleContentSharingUpdate][failed][reason=no session with correlation ID ${a.correlationId}]`)}handleAddModalitySuccess(n,a){this.logger.info(`[${a}][handleAddModalitySuccess]`);const s=this.pendingSessionToStart;s?s.handleAddModalitySuccess(n,a):this.logger.info(`[${a}][handleAddModalitySuccess]Ignoring handleAddModalitySuccess because not waiting for one`)}handleAddModalityFailure(n,a){this.logger.info(`[${a}][handleAddModalityFailure]`);const s=this.pendingSessionToStart;s?s.handleAddModalityFailure(n,a):this.logger.info(`[${a}][handleAddModalityFailure]Ignoring handleAddModalityFailure because not waiting for one`)}handleIncomingContentSharingFromRoster(n,a,s){if(this.logger.info(`[${s}] handleIncomingContentSharingFromRoster: isFullRoster ${a} content ${fi(n)}`),(n.type==="MultiPartyEndpoint"||a)&&this.lastProcessedSequenceNumber>n.sequenceNumber)return void this.logger.info(`[${s}] handleIncomingContentSharingFromRoster invalid roster current sequenceNumber ${n.sequenceNumber} lastProcessedSequenceNumber ${this.lastProcessedSequenceNumber}`);const{sessionsWithPresenters:c,sessionsWithoutPresenters:u}=this.parseContentSharingSessionsFromRoster(n);this.startSessionsFromRoster(c,s),this.stopSessionsFromRoster(u,s),this.lastProcessedSequenceNumber=n.sequenceNumber}handleContentSharingEnd(n){const a=n.body,s=Po(n);this.logger.info("handleContentSharingEnd : ",fi(a));const c=this.contentSharingSessions[a.contentSharingCorrelationId];if(!c)return void this.logger.info("Ignoring contentSharingEnd since there is no corresponding sharing ongoing");if(!c.handleStop(a,s))return;const u={...a.contentSharingTransactionEnd};this.raiseContentSharingStopped(a.contentSharingCorrelationId,s,a.presenter.id,u)}parseContentSharingSessionsFromRoster(n){const a={},s={},c=new Set;for(const u of Object.keys(n.participants)){const m=n.participants[u];if(n.type==="Delta"&&this.lastProcessedSequenceNumberForParticipant.hasOwnProperty(u)&&m.version<=this.lastProcessedSequenceNumberForParticipant[u]||(m.version=m.version||-1,this.lastProcessedSequenceNumberForParticipant[u]=m.version,c.add(m.details.id),!m.endpoints))continue;const b=this.signalingSession.participantManager.localParticipant.participantId;for(const _ of Object.keys(m.endpoints)){const k=m.endpoints[_],N=k?.contentSharing?.sessionInformation;N?.role==="presenter"&&(a[N.contentSharingCorrelationId]={presenterId:m.details.id,sessionInfo:N,selfEndpointIsPresenter:k.participantId===b})}}for(const u of Object.keys(this.contentSharingSessions))!a[u]&&c.has(this.contentSharingSessions[u].presenterMri)&&(s[u]=this.contentSharingSessions[u]);return{sessionsWithPresenters:a,sessionsWithoutPresenters:s}}stopSessionsFromRoster(n,a){this.logger.info(`[${a}][stopSessionsFromRoster]`);for(const s of Object.keys(n))this.logger.info(`[${a}][stopSessionsFromRoster] stopping session with correlationId ${s}`),this.stopSession(n[s],a)}stopSession(n,a){this.logger.info(`[${a}][stopSession] Stopping session ${n.sessionId}`),n.handleStopFromRoster(this.DEFAULT_STOP_REASON,a),this.raiseContentSharingStopped(n.correlationId,a)}startSessionsFromRoster(n,a){this.logger.info(`[${a}][startSessionsFromRoster]`);for(const s of Object.keys(n)){this.logger.info(`[${a}][startSessionsFromRoster]`);const c=this.contentSharingSessions[s],u=n[s];if(this.pendingSessionToStart&&this.pendingSessionToStart.correlationId===s?this.pendingSessionToStart.confirmInRoster():c&&c.confirmInRoster(),c)c&&(this.contentSharingSessions[s].presenterMri=u.presenterId,this.logger.info(`[${a}][startSessionsFromRoster]Session ${s} is already present locally`));else{if(u.selfEndpointIsPresenter){this.logger.info(`[${a}][startSessionsFromRoster]This endpoint is presenting, dont fire callback`);continue}this.logger.info(`[${a}][startSessionsFromRoster]New sharing session found. Raising ContentSharingStarted`),this.raiseContentSharingStarted(u.presenterId,u.sessionInfo,a).handleStartFromRoster(u.presenterId,a)}}}raiseContentSharingStopped(n,a,s,c){this.logger.info(`[${a}][raiseContentSharingStopped]`),this.signalingSessionCallback.onContentSharingStopped({sessionId:this.contentSharingSessions[n].sessionId,correlationId:n,endedBy:s||this.DEFAULT_STOP_ID,reason:c||this.DEFAULT_STOP_REASON},a),delete this.contentSharingSessions[n]}raiseContentSharingStarted(n,a,s){this.logger.info(`[${s}][raiseContentSharingStarted]`);const c=new MV(this.signalingSession,a.contentSharingCorrelationId,a.contentSharingSessionId,{[ge.LINKS.CONTENT_SHARING_CONTROLLER]:a.contentSharingController});c.presenterMri=n,this.contentSharingSessions[c.correlationId]=c;const u={sessionId:a.contentSharingSessionId,correlationId:a.contentSharingCorrelationId,contentIdentifier:a.identifier,presenter:n,subject:a.subject||null,sessionState:a.sessionState||null};return this.signalingSessionCallback.onContentSharingStarted(u,s),c}rejectBecauseOfMissingSession(n,a){const s=`There is no ContentSharing session with the correlation ID ${n}`;this.logger.error(s),a&&a.reject(new Error(s))}},Nte={Default:{retryIntervalsMs:[200,1e3,5e3],maxRequestAttempts:4,perRequestTimeoutMs:45e3,perAttemptTimeoutMs:15e3,perRequestTimeoutWithHedgingMs:45e3,perAttemptTimeoutWithHedgingMs:3e4,hedgeDelayMs:4e3},BrokerSubscribe:{retryIntervalsMs:[100,200,500],maxRequestAttempts:4,perRequestTimeoutMs:3e4,perAttemptTimeoutMs:3e4,perRequestTimeoutWithHedgingMs:45e3,perAttemptTimeoutWithHedgingMs:3e4}},$ve={CallSetup:{requestHedgingCapability:["disabled"],hedgeDelayMs:4e3},Other:{requestHedgingCapability:["disabled"]},BrokerSubscribe:{requestHedgingCapability:["disabled"]}},xte="HttpRequestDispatcherFactory";function QG(n,a,s){a?.signalingSession?a.signalingSession.telemetryHelper?.addTokenTelemetry(n,a?.tokenTelemetryData):s?.info("[reportTokenTelemetryData] signaling session is not available, cannot send token telemetry")}function PV(n,a){const{signalingSession:s,operation:c,causeId:u,data:m,customHeaders:b={},forceFetchToken:_,tokenRequestOptions:k,useFetch:N,fetchUseKeepAlive:W}=n;if(s.disposed)return Promise.reject("Session already disposed");const ee=se=>{const Re=typeof se=="string"?new Error(se):se;throw s.signalingAgent.clientSupportsGenericTokenAPI?se.timeOut?Re.tokenTimeoutError=!0:(Re.tokenError=!0,Re.tokenErrorSubCode=se.errorSubCode):Re.skypeTokenError=!0,Re};let oe=!1;const de={signalingSession:s,tokenTelemetryData:{}};return s.signalingAgent.authTokenManager.getToken(u,_,k,de).catch(se=>(QG(n.requestId,de,a),!_&&Hve(s)&&s.signalingAgentConfig.attemptHttpRequestWithCachedSkypetoken&&s.signalingAgent.authTokenManager.getLastToken(u)?(oe=!0,a?.info(`[${u}][requestBuilder] failed to fetch token, using lastToken`),Promise.resolve(s.signalingAgent.authTokenManager.getLastToken(u))):(a?.info(`[${u}][requestBuilder] getToken failed with error ${se}`),ee(se)))).then(se=>{if(s.disposed)throw new Error("token returned too late. Object is already disposed");QG(n.requestId,de,a);const Re=new zb;if(Re.set(ge.HEADERS.CORRELATION_ID,s.correlationId),Re.set(ge.HEADERS.MESSAGE_ID,zG(u)),Re.set(ge.HEADERS.CLIENT_USER_AGENT,s.signalingAgentConfig.clientInformation),s.signalingAgent.clientSupportsGenericTokenAPI){const He=s.signalingAgent.authTokenManager.getLastTokenType(u);switch(s.signalingAgentConfig.disableTokenMigrationHeader||Re.set(ge.HEADERS.TOKEN_MIGRATION,"True"),He){case 8:case 4:Re.set(ge.HEADERS.AUTHORIZATION,`${ge.HEADERS.BEARER_KEYWORD} ${se}`),Re.delete(ge.HEADERS.SKYPE_TOKEN);break;case 1:Re.set(ge.HEADERS.SKYPE_TOKEN,se),Re.delete(ge.HEADERS.AUTHORIZATION);break;default:throw new Error(`Error in RequestBuilder. TokenType ${He} is not supported`)}}else Re.set(ge.HEADERS.SKYPE_TOKEN,se);const ue=s.participantManager.localParticipant;ue&&(ue.ring&&Re.set(ge.HEADERS.RING,ue.ring),ue.region&&Re.set(ge.HEADERS.REGION,ue.region),ue.partition&&Re.set(ge.HEADERS.PARTITION,ue.partition));const Ne=m?.payload?JSON.stringify(m.payload):null,ze={headers:{...Re?.getAll(),...b},payload:Ne,usedCachedSkypetoken:oe,reporting:{serviceName:c?`${xte}-${c}`:xte},useFetch:N,fetchUseKeepAlive:W};return s.telemetryHelper.addNetworkOperationStarted(c),ze}).catch(ee)}function Hve(n){const a=HG(n.signalingAgentConfig.trouterServiceProvider);return a===3||a===1}var DV=500,jve=1e4,Gve=4,LV=3e3,x2=3;function Bte(n){return new qve(n.causeId,n.logger,n.dispatcher,n.requestType,n.url,n.request,n.attemptFailureCallback,n.authRequiredCallback,n.settings)}var qve=class{constructor(n,a,s,c,u,m,b,_,k){this.causeId=n,this.logger=a,this.dispatcher=s,this.requestType=c,this.url=u,this.request=m,this.onRequestFailed=b,this.authRequiredCallback=_,this.settings=k,this.requestsSent=0,this.otherAttemptSuccessful=!1,this.pendingAttempts=[],this.hedgeDelayMs=LV,this.hedgeMaxParallelAttempts=x2,this.stopStandardRetryTimer=()=>{this.standardRetryTimer&&(this.standardRetryTimer.stop(),this.standardRetryTimer=null)},this.stopHedgeTimer=()=>{this.hedgeTimer&&(this.hedgeTimer.stop(),this.hedgeTimer=null)},this.stopAttemptTimeoutTimer=N=>{try{N.timeoutTimer&&(N.timeoutTimer.stop(),this.logger.info("attempt timer stopped"))}catch(W){this.logger.info(`stopAttemptTimeoutTimer error ${W}`)}},this.stopRequestTimer=()=>{try{this.requestTimer&&(this.requestTimer.stop(),this.logger.info("Request timer stopped"))}catch(N){this.logger.info(`stopRequestTimer error ${N}`)}this.requestTimer=null},this.canScheduleNextAttempt=()=>{if(this.stackError===ge.HTTP_STACK_ERROR.REQUEST_ABORTED||this.otherAttemptSuccessful||this.requestsSent>=this.settings.maxRequestAttempts)return this.logger.info(`canScheduleNextAttempt stack error ${this.stackError} otherAttemptSuccessful ${this.otherAttemptSuccessful} exceeded max attempt ${this.requestsSent>=this.settings.maxRequestAttempts}`),!1;if(this.settings.enableRequestHedging){const N=this.pendingAttempts.length<this.hedgeMaxParallelAttempts;return N||this.logger.info(`canScheduleNextAttempt enableRequestHedging attempts sent: ${this.pendingAttempts.length} max attempts: ${this.hedgeMaxParallelAttempts}`),N}{const N=this.requestsSent<this.settings.retryIntervalsMs.length;return N||this.logger.info(`canScheduleNextAttempt attempts sent: ${this.requestsSent} max attempts: ${this.settings.retryIntervalsMs.length}`),N}},this.scheduleNextRequest=N=>{this.settings.enableRequestHedging?(this.logger.info("scheduleNextRequest with hedging"),this.hedgeTimer=ku.build(()=>{this.attempt(),this.canScheduleNextAttempt()&&this.scheduleNextRequest(!1)},"HEDGE").start(this.getNextDelay(N))):(this.logger.info("scheduleNextRequest with retry"),this.standardRetryTimer=ku.build(()=>{this.attempt()},"RETRY").start(this.getNextDelay(N)))},this.standardizeFailedRequest=(N,W)=>{let ee;const oe=this.logger.createChild("[standardizeFailedRequest]");try{if(this.stackError===ge.HTTP_STACK_ERROR.REQUEST_TIMEOUT)oe.info("request timed out"),ee=M2.REQUEST_TIMEOUT;else if(this.stackError===ge.HTTP_STACK_ERROR.REQUEST_ABORTED)oe.info("request aborted"),ee=M2.REQUEST_ABORTED;else if(W&&W.status===ge.HTTP_STACK_ERROR.ATTEMPT_TIMEOUT)oe.info("request attempt timed out"),ee=M2.ATTEMPT_TIMEOUT;else if(W&&[ge.HTTP_STACK_ERROR.ATTEMPT_ABORTED,ge.HTTP_STACK_ERROR.ABORTED_OTHER_ATTEMPT_SUCCESSFUL].indexOf(W.status)>-1)oe.info("request attempt aborted"),ee=M2.ATTEMPT_ABORTED;else if(N){if(oe.info(`request ${Bh(N)}`),N.request?.response){const de=N;ee={response:{...typeof de?.request?.response=="string"?de?.response?.data:de?.request?.response,headers:de.response?.headers},status:de.request.status,statusText:de.request.statusText,readyState:de.request.readyState}}else N.status||N.statusCode||N.response?ee={response:N.response,status:[void 0,null,""].indexOf(N.status)>-1?N.statusCode:N.status,statusText:N.statusText,readyState:N.readyState}:(oe.info("Local http stack error"),ee={response:ge.CALL_END_SUB_CODE.LOCAL_HTTP_STACK_ERROR,status:ge.CALL_END_CODE.LOCAL_HTTP_STACK_ERROR,statusText:"LocalHTTPStackError",readyState:N.readyState||0});this.isBrowserOffline()&&ee.status===0&&ee.readyState===4&&(oe.info("offline"),ee={response:ge.HTTP_STACK_ERROR.CANNOT_CONNECT,status:ge.HTTP_STATUS_CODES.OFFLINE,statusText:"offline",readyState:ee.readyState}),N.response?.message&&(N.response.message.operationFailure||N.response.message.broadcastOperationFailure)?ee={response:N.response.message}:!N.response&&N.body?.operationFailure&&(ee={response:N.body})}else oe.info("no response"),ee={response:ge.HTTP_STACK_ERROR.NONE,status:ge.HTTP_STATUS_CODES.OTHER,statusText:"Empty Response",readyState:0}}catch(de){oe.info(`Failed to handle error ${de}`),ee={response:"",status:ge.HTTP_STATUS_CODES.OTHER,statusText:"FailedToHandleError",readyState:0}}return ee},this.hasPendingAttempts=()=>this.pendingAttempts.some(N=>N.pending),this.getRequestFromStatus=N=>N?.request?.status||0,this.isBrowserOffline=()=>navigator&&navigator.onLine===!1,this.logger=a.createChild(`[${this.causeId}][Dispatcher]`),this.logger.info(`created request, url=${u}`),!isNaN(this.settings.hedgeDelayMs)&&this.settings.hedgeDelayMs>=DV&&this.settings.hedgeDelayMs<=jve&&(this.hedgeDelayMs=this.settings.hedgeDelayMs),!isNaN(this.settings.hedgeMaxParallelAttempts)&&this.settings.hedgeMaxParallelAttempts>=0&&this.settings.hedgeMaxParallelAttempts<=Gve&&(this.hedgeMaxParallelAttempts=this.settings.hedgeMaxParallelAttempts),(isNaN(this.settings.perAttemptTimeoutMs)||this.settings.perAttemptTimeoutMs<=0)&&(this.settings.perAttemptTimeoutMs=15e3),(isNaN(this.settings.perRequestTimeoutMs)||this.settings.perRequestTimeoutMs<=0)&&(this.settings.perRequestTimeoutMs=45e3),(isNaN(this.settings.maxRequestAttempts)||this.settings.maxRequestAttempts<=0)&&(this.settings.maxRequestAttempts=4),(isNaN(this.settings.perRequestTimeoutWithHedgingMs)||this.settings.perRequestTimeoutWithHedgingMs<=0)&&(this.settings.perRequestTimeoutWithHedgingMs=45e3),(isNaN(this.settings.perAttemptTimeoutWithHedgingMs)||this.settings.perAttemptTimeoutWithHedgingMs<=0)&&(this.settings.perAttemptTimeoutWithHedgingMs=3e4)}sendRequest(){this.stackError=ge.HTTP_STACK_ERROR.NONE;const n=()=>{this.stackError=ge.HTTP_STACK_ERROR.REQUEST_TIMEOUT,this.cancelAllAttempts(ge.HTTP_STACK_ERROR.REQUEST_TIMEOUT)};return this.logger.info("send api called"),this.requestTimer=ku.build(n,"REQUEST_TIMEOUT").start(this.settings.enableRequestHedging?this.settings.perRequestTimeoutWithHedgingMs:this.settings.perRequestTimeoutMs),new Promise((a,s)=>{this.resolve=a,this.reject=s,this.scheduleNextRequest(!0)})}cancelRequest(){this.logger.info("cancelRequest"),this.stackError=ge.HTTP_STACK_ERROR.REQUEST_ABORTED,this.cancelAllAttempts(ge.HTTP_STACK_ERROR.ATTEMPT_ABORTED)}cancelOtherAttempts(n){this.pendingAttempts.splice(n-1,1),this.cancelAllAttempts(ge.HTTP_STACK_ERROR.ABORTED_OTHER_ATTEMPT_SUCCESSFUL)}cancelAllAttempts(n){this.stopHedgeTimer(),this.stopStandardRetryTimer(),this.pendingAttempts.forEach(a=>{a.status=n,a.cancelDeferred.resolve(),this.stopAttemptTimeoutTimer(a)}),this.stopRequestTimer()}getRequestMethod(n){switch(n){case 0:return this.dispatcher.getAsync.bind(this.dispatcher);case 1:return this.dispatcher.postAsync.bind(this.dispatcher);case 2:return this.dispatcher.putAsync.bind(this.dispatcher);case 3:return this.dispatcher.removeAsync.bind(this.dispatcher);default:return null}}async queueAttempt(n){const a=n&&this.isNotRetryable(n);if(this.logger.info("queueAttempt"),a||!this.canScheduleNextAttempt())return this.logger.info(`unable to retry isNotRetryable ${a} ${JSON.stringify(n)}`),this.stopHedgeTimer(),this.stopRequestTimer(),void(this.hasPendingAttempts()||(this.settings.reportPreviousErrorsForTimeout&&n===M2.ATTEMPT_TIMEOUT&&this.previousAttempt?this.reject(this.previousAttempt):this.reject(n)));if(this.isAuthFailedStatus(n)){this.logger.info("auth failed"),this.stopHedgeTimer(),this.stopStandardRetryTimer(),this.stopRequestTimer();try{const s=n?.response?.headers,c=xve(this.request?.headers),u=n.response?.status===ge.HTTP_STATUS_CODES.UNAUTHORIZED&&n.response?.operationFailure?.subCode===ge.CALL_END_SUB_CODE.CONVERSATION_TERMINATION_INTERACTION_REQUIRED,m=await this.authRequiredCallback(s,c,{IPCAFailure:u});this.request=m}catch(s){return s.authCallBackFailure=!0,n.error=s,void this.reject(n)}}this.previousAttempt=n,this.hedgeTimer?this.logger.info("scheduleNextRequest ignored as there's already active hedge timer"):this.scheduleNextRequest(!1)}attempt(){if(this.logger.info("attempt to send request"),this.stackError===ge.HTTP_STACK_ERROR.REQUEST_ABORTED||this.otherAttemptSuccessful)return;const n=new Date().getTime();this.requestsSent++;const a=this.requestsSent,s=Pl();this.request.timeout=s.promise;const c={cancelDeferred:s,status:ge.HTTP_STACK_ERROR.NONE,timeoutTimer:null,pending:!0},u=()=>{c.status=ge.HTTP_STACK_ERROR.ATTEMPT_TIMEOUT,c.cancelDeferred.resolve()},m=ku.build(u,"ATTEMPT_TIMEOUT").start(this.settings.enableRequestHedging?this.settings.perAttemptTimeoutWithHedgingMs:this.settings.perAttemptTimeoutMs);c.timeoutTimer=m,this.pendingAttempts.push(c),this.getRequestMethod(this.requestType)(this.url,this.request).then(b=>{if(this.logger.info(`attempt successful, request response=${H0(b)} status=${this.getRequestFromStatus(b)}`),this.otherAttemptSuccessful)throw"Other attempt succesful";if(this.stackError===ge.HTTP_STACK_ERROR.REQUEST_ABORTED)throw"Session disposed";if(!b)throw"Invalid response";c.pending=!1,this.otherAttemptSuccessful=!0,this.stopRequestTimer(),this.stopHedgeTimer(),this.stopAttemptTimeoutTimer(c),this.cancelOtherAttempts(a),this.resolve({success:!0,request:b.request,response:b.response,attempt:this.requestsSent,attemptStartTimestamp:n,attemptResponseTimestamp:new Date().getTime()})}).catch(b=>{c.pending=!1,this.stopAttemptTimeoutTimer(c);const _=this.standardizeFailedRequest(b,c);this.logger.info(`attempt failed, request: ${Bh(b)} status=${_.status}`),this.onRequestFailed({abandoned:this.otherAttemptSuccessful,success:!1,request:_,attempt:this.requestsSent,attemptStartTimestamp:n,attemptResponseTimestamp:new Date().getTime()}),this.queueAttempt(_)})}getNextDelay(n){let a;if(n)a=0;else if(this.settings.enableRequestHedging)a=this.hedgeDelayMs;else{if(!(this.requestsSent<=this.settings.retryIntervalsMs.length))throw"Unable to get next delay";a=this.settings.retryIntervalsMs[this.requestsSent-1]}return this.logger.info(`next delay= ${a} ms`),a}isRequestWithStatus(n,a){return!!n&&a.indexOf(n.status)>-1}isNotRetryable(n){return!dte(n?.status)}isAuthFailedStatus(n){return this.isRequestWithStatus(n,[ge.HTTP_STATUS_CODES.UNAUTHORIZED])}},Fte={1:"POST",0:"GET",2:"PUT",3:"DELETE"},ZG=class{constructor(n,a){this.signalingSession=n,this.callStartTime=a,this.pendingRequests={},this.sendGetRequest=s=>this.sendRequest(0,s),this.sendPostRequest=s=>this.sendRequest(1,s),this.sendPutRequest=s=>this.sendRequest(2,s),this.sendDeleteRequest=s=>this.sendRequest(3,s),this.cancelRequestIfPending=(s,c,u,m)=>{this.logger.info(`[${c}][cancelRequestIfPending]`),this.pendingRequests[s]?u?this.hasPendingRequest(s,u)&&this.cancelRequest(s,u,c,m):Object.keys(this.pendingRequests[s]).forEach(b=>this.cancelRequest(s,b,c,m)):this.logger.info(`[${c}][cancelRequestIfPending]no pending request with name=${s}`)},this.cancelAllRequests=s=>{this.logger.info(`[${s}][cancelAllRequests]`);const c=[];return Object.keys(this.pendingRequests).forEach(u=>{Object.keys(this.pendingRequests[u]).forEach(m=>{c.push(this.cancelRequest(u,m,s))})}),Promise.all(c).catch(()=>{})},this.hasPendingRequest=(s,c)=>!!this.pendingRequests[s]&&!!(c?this.pendingRequests[s][c]:this.pendingRequests[s]),this.cancelRequest=(s,c,u,m)=>{try{return this.pendingRequests[s][c].dispatcher&&this.pendingRequests[s][c].dispatcher.cancelRequest(),this.pendingRequests[s][c].aborted=!0,this.pendingRequests[s][c].errorDetails=m,this.logger.info(`[${u}][cancelRequest]Request=${s} aborted ${m?`with errorDetails ${JSON.stringify(m)}`:""}`),this.pendingRequests[s][c].requestPromise.catch(()=>{})}catch{return this.logger.warn(`[${u}][cancelRequest]Unable to cancel request=${s}, requestId=${c}`),Promise.resolve()}},this.buildRequestTelemetry=(s,c,u,m)=>({name:`${Fte[s]}-${c.requestName}`,url:c.url,eventStart:u-this.callStartTime,trouterReady:-1,requestReady:-1,status:-1,attempts:[],rtt:-1,uid:c.requestId,causeId:c.causeId,requestDispatcherConfig:m,enableRequestHedging:this.shouldEnableRequestHedging(m)}),this.addPendingRequest=s=>(this.pendingRequests[s.requestName]||(this.pendingRequests[s.requestName]={}),this.pendingRequests[s.requestName][s.requestId]={dispatcher:null,requestPromise:null,aborted:!1},this.pendingRequests[s.requestName][s.requestId]),this.sendRequest=(s,c)=>{if(!c.url){this.logger.error(c.requestName,"Link does not exist");const pt={code:ge.CALL_END_CODE.HTTP_OTHER_ERROR,subCode:ge.CALL_END_SUB_CODE.MISSING_REQUEST_URI,phrase:`Link does not exist for requestName: ${c.requestName}.`};return Promise.reject(pt)}c.requestId||(c.requestId=My()),c.causeId||(c.causeId=tr());let u=!1,m=!1;const b=this.logger.createChild(`[${c.causeId}][${c.requestName}]`);b.info("[scheduled]");const _=this.getInternalHttpDispatcherConfig(c.requestName,c.operationType);let k;c.skipHttpTelemetry||(c.skipHttpTelemetry=!1);const N=US(),W=new Date().getTime(),ee=[],oe=this.buildRequestTelemetry(s,c,W,_),de=()=>{this.signalingSession.disposed?this.logger.info("Unable to record telemetry, session disposed"):this.signalingSession.telemetryHelper.updateNetworkRequest(oe)},se=()=>{this.signalingSession.telemetryHelper.deleteNetworkRequest(oe)};de();const Re=(pt,Lt,xt)=>{if(!pt?.request)return void this.logger.warn(c.requestName,"missing request details, unable to record for telemetry!");b.info(`[finished][status=${pt.request.status}][statusText=${pt.request.statusText}][retryCount=${pt.attempt}]`);const yi=pt.request.status,Li=pt.request.response?.operationFailure?.subCode,cn={status:yi,statusSubCode:Li||xt,start:pt.attemptStartTimestamp-W,end:pt.attemptResponseTimestamp-W,online:HG(this.signalingSession.signalingAgentConfig.trouterServiceProvider)};pt.abandoned&&(cn.abandoned=!0),pt.request.statusText&&(cn.statusText=pt.request.statusText),!Lt&&m||(oe.status=yi,oe.statusSubCode=xt||Li),(Lt||!m&&yi>=200&&yi<400)&&(m=!0),oe.attempts.push(cn),de()};if(this.hasPendingRequest(c.requestName,c.requestId))return this.logger.warn(c.requestName,c.requestId,"is already pending request!!"),this.pendingRequests[c.requestName][c.requestId].requestPromise;k=this.addPendingRequest(c);const ue=(pt,Lt,xt,yi)=>{if(pt&&c.skipHttpTelemetry)return this.logger.info("Skipping telemetry"),void se();b.info(`[steps=${ee}]`),this.pendingRequests[c.requestName][c.requestId].aborted&&(oe.aborted=!0),this.hasPendingRequest(c.requestName,c.requestId)?(delete this.pendingRequests[Lt][xt],Object.keys(this.pendingRequests[Lt]).length||delete this.pendingRequests[Lt]):this.logger.warn("Unable to clean up!"),this.signalingSession.disposed||(yi&&(oe.error=yi),oe.rtt=N.duration(),this.signalingSession.telemetryHelper.addNetworkOperationCompleted(c.requestName,pt,N.duration()),de(),this.signalingSession.telemetryHelper.sendHttpTelemetryData(oe.uid))},Ne=pt=>(...Lt)=>{if(this.signalingSession.disposed){const xt=`[${c.causeId}][${c.requestName}][failed][reason=Session disposed]`;throw b.info("[failed][reason=Session disposed]"),new Error(xt)}if(this.hasPendingRequest(c.requestName,c.requestId)&&this.pendingRequests[c.requestName][c.requestId].aborted){let xt;const yi=`[${c.causeId}][${c.requestName}][failed][reason=request already aborted]`,Li=this.pendingRequests[c.requestName][c.requestId].errorDetails;throw Li?(xt=Li,xt.phrase=yi):xt=yi,b.info(`${yi}`),new Error(JSON.stringify(xt))}return pt(...Lt)},ze=Ne(()=>(ee.push("[waitForTrouter]"),c.withoutTrouter?Promise.resolve():this.signalingSession.ensureMessageChannelReady(c.requestName))),He=Ne(()=>(ee.push("[trouterReady]"),oe.trouterReady=N.duration(),c.onceTrouterReady&&c.onceTrouterReady(),de(),Promise.resolve())),be=Ne(()=>{const pt=this.signalingSession.signalingAgent.clientSupportsGenericTokenAPI,Lt=this.signalingSession.signalingAgentConfig.enableFetchApi||c.useFetch,xt=AV(this.signalingSession.signalingAgentConfig,pt,s,c,!1,void 0,this.logger);return ee.push("[buildRequest]"),PV({signalingSession:this.signalingSession,operation:c.requestName,data:c.payload,customHeaders:c.customHeaders?.getAll(),causeId:c.causeId,tokenRequestOptions:xt,requestId:c.requestId,useFetch:Lt,fetchUseKeepAlive:c.fetchUseKeepAlive},this.logger)}),Ee=pt=>{const Lt={request:{status:ge.HTTP_STATUS_CODES.OTHER,statusText:"Local error"},attempt:1,attemptResponseTimestamp:new Date().getTime(),attemptStartTimestamp:new Date().getTime()};let xt;pt&&(pt.skypeTokenError?(Lt.request={status:ge.CALL_END_SKYPE_TOKEN_ERROR.code,statusText:ge.CALL_END_SKYPE_TOKEN_ERROR.phrase},xt=ge.CALL_END_SKYPE_TOKEN_ERROR.subCode):pt.tokenError?(Lt.request={status:ge.CALL_END_TOKEN_ERROR.code,statusText:ge.CALL_END_TOKEN_ERROR.phrase},xt=pt.errorSubCode&&pt.errorSubCode>0?pt.errorSubCode:ge.CALL_END_TOKEN_ERROR.subCode):pt.tokenTimeoutError&&(u?(Lt.request={status:ge.CALL_END_TOKEN_TIMEOUT_INTERACTIVITY_REQUIRED.code,statusText:ge.CALL_END_TOKEN_TIMEOUT_INTERACTIVITY_REQUIRED.phrase},xt=ge.CALL_END_TOKEN_TIMEOUT_INTERACTIVITY_REQUIRED.subCode,pt.tokenInteractivityRequiredTimeout=!0):(Lt.request={status:ge.CALL_END_TOKEN_TIMEOUT_ERROR.code,statusText:ge.CALL_END_TOKEN_TIMEOUT_ERROR.phrase},xt=ge.CALL_END_TOKEN_TIMEOUT_ERROR.subCode))),Re(Lt,!1,xt)},Pe=Ne(pt=>(ee.push("[failedToBuildRequestOptions]"),Ee(pt),Promise.reject(pt))),Qe=Ne(pt=>(ee.push("[requestBuilt]"),oe.requestReady=N.duration(),pt.usedCachedSkypetoken&&(oe.usedCachedSkypetoken=pt.usedCachedSkypetoken),de(),Promise.resolve(pt))),Ze=(pt,Lt,xt)=>{ee.push("[authRequired]"),xt?.IPCAFailure&&(u=!0);const yi=this.signalingSession.signalingAgent.clientSupportsGenericTokenAPI,Li=AV(this.signalingSession.signalingAgentConfig,yi,s,c,!0,pt,this.logger);return Li.invalidToken=Lt,PV({signalingSession:this.signalingSession,operation:c.requestName,data:c.payload,customHeaders:c.customHeaders?.getAll(),causeId:c.causeId,forceFetchToken:!0,tokenRequestOptions:Li,requestId:c.requestId},this.logger)},Xe=Ne(pt=>{ee.push("[sendRequest]");const Lt={..._,enableRequestHedging:this.shouldEnableRequestHedging(_),hedgeDelayMs:_.hedgeDelayMs,hedgeMaxParallelAttempts:this.signalingSession.signalingAgentConfig.hedgeMaxParallelAttempts,retryIntervalsMs:c.disableRetry||!_.retryIntervalsMs?[]:_.retryIntervalsMs,reportPreviousErrorsForTimeout:this.signalingSession.signalingAgentConfig.reportPreviousErrorsForTimeout},xt=Bte({logger:this.logger,causeId:c.causeId,dispatcher:this.signalingSession.signalingAgentConfig.httpRequestDispatcher,url:c.url,request:pt,requestType:s,authRequiredCallback:Ze,attemptFailureCallback:yi=>{Re(yi,!1)},settings:Lt});return k.dispatcher=xt,de(),xt.sendRequest()}),bt=Ne(async pt=>(Re(pt,!0),b.info("[success]"),ue(!0,c.requestName,c.requestId),pt)),Ot=pt=>{const Lt=fi(pt);b.info(`onFailure err:${Lt}`);let xt=pt;return pt.error?.authCallBackFailure&&(xt=pt.error,b.info(`authCallBackerror:${fi(xt)}`),Ee(xt)),ue(!1,c.requestName,c.requestId,Lt),!pt||pt.readyState||pt.status?b.info(`[failed][reason=${Lt}]`):b.info(`[failed][offline][reason=${Lt}]`),Promise.reject(xt)},Yt=Promise.resolve().then(ze).then(He).then(be).catch(Pe).then(Qe).then(Xe).then(bt).catch(Ot);return k.requestPromise=Yt,Yt},this.logger=this.signalingSession.logger.createChild("[HTTP]")}getInternalHttpDispatcherConfig(n,a="Other"){let s={...Nte.Default,...$ve[a],...Nte[n]};return this.signalingSession&&this.signalingSession.signalingAgentConfig&&this.signalingSession.signalingAgentConfig.operationTypeHttpDispatcherConfigMap&&(s={...s,...this.signalingSession.signalingAgentConfig.operationTypeHttpDispatcherConfigMap[a]}),this.signalingSession&&this.signalingSession.signalingAgentConfig&&this.signalingSession.signalingAgentConfig.requestTypeHttpDispatcherConfigMap&&(s={...s,...this.signalingSession.signalingAgentConfig.requestTypeHttpDispatcherConfigMap.Default,...this.signalingSession.signalingAgentConfig.requestTypeHttpDispatcherConfigMap[n]}),this.logger.info(`getInternalHttpDispatcherConfig request type: ${n} config: ${xo(s)}`),s}shouldEnableRequestHedging(n){return!!(this.signalingSession.getMeetingInfo()&&n.requestHedgingCapability.indexOf("enabledForMeetings")>-1)||!this.signalingSession.multiParty&&n.requestHedgingCapability.indexOf("enabledForP2PCalls")>-1||!!(this.signalingSession.multiParty&&n.requestHedgingCapability.indexOf("enabledForGroupCalls")>-1)||n.requestHedgingCapability.indexOf("enabled")>-1}};function Ute(n,a,s){xn(n,"signalingSession cannot be null");let c=[];s&&(c=eE(s),n.telemetryHelper.addOutgoingModalities(c));const u=tr();return{payload:{mediaNegotiation:{callModalities:c,sender:{id:n.participantManager.localParticipant.id,displayName:n.participantManager.localParticipant.displayName,endpointId:n.participantManager.localParticipant.endpointId,participantId:n.participantManager.localParticipant.participantId,languageId:n.participantManager.localParticipant.languageId},links:{mediaAnswer:Vn(n,Fi.MEDIA_ANSWER,u),rejection:Vn(n,Fi.MEDIA_REJECTION,u)},mediaContent:a}}}}function Wve(n,a){return xn(n,"signalingSession cannot be null"),X_(a),{payload:{mediaNegotiationFailure:{sender:{id:n.participantManager.localParticipant.id,displayName:n.participantManager.localParticipant.displayName,endpointId:n.participantManager.localParticipant.endpointId,participantId:n.participantManager.localParticipant.participantId,languageId:n.participantManager.localParticipant.languageId},code:a.code,subCode:a.subCode,phrase:a.phrase},debugContent:{callId:n.correlationId,endpointId:n.participantManager.localParticipant.endpointId}}}}function Kve(n,a,s){xn(n,"signalingSession cannot be null");let c=[];return s&&(c=eE(s),n.telemetryHelper.addOutgoingModalities(c)),{payload:{mediaAnswer:{callModalities:c,sender:{id:n.participantManager.localParticipant.id,displayName:n.participantManager.localParticipant.displayName,endpointId:n.participantManager.localParticipant.endpointId,participantId:n.participantManager.localParticipant.participantId,languageId:n.participantManager.localParticipant.languageId},links:{mediaAcknowledgement:Vn(n,Fi.MEDIA_ACKNOWLEDGEMENT)},clientContentForMediaController:n.webRtcSignalingManager.getClientUrls(),mediaContent:a},debugContent:{callId:n.correlationId,endpointId:n.participantManager.localParticipant.endpointId}}}}var B2=class{constructor(n,a,s){this.telemetryHelper=s,this.vbssInitiated=!1,this.disposed=!1,this.fsmState=ge.MEDIA_RENEGOTIATION_FSM_STATE.IDLE,this.fsmStateCauseId="",this.links={},this.renegotiationOffersSeenSoFar=[],this.isOutgoingRenegotiationInProgress=()=>this.fsmState===ge.MEDIA_RENEGOTIATION_FSM_STATE.OUTGOING_RENEGOTIATION||this.fsmState===ge.MEDIA_RENEGOTIATION_FSM_STATE.RENEGOTIATION_GLARE,this.isIncomingRenegotiationInProgress=()=>this.fsmState===ge.MEDIA_RENEGOTIATION_FSM_STATE.INCOMING_RENEGOTIATION||this.fsmState===ge.MEDIA_RENEGOTIATION_FSM_STATE.RENEGOTIATION_GLARE,this.acceptRenegotiationAsync=(c,u,m)=>{this.logger.info(`[${m}][acceptRenegotiationAsync][mediaTypes=${u}]`),this.signalingSession.telemetryHelper.recordEvent(Ft.ACCEPT_RENEGOTIATION,{mediaTypes:u,causeId:m}),lc(this.links[ge.LINKS.MEDIA_ANSWER],"MediaAnswer link not set");const b=Pl();switch(this.fsmState){case ge.MEDIA_RENEGOTIATION_FSM_STATE.INCOMING_RENEGOTIATION:this.setFsmState(ge.MEDIA_RENEGOTIATION_FSM_STATE.CALL_CONNECTED,m);break;case ge.MEDIA_RENEGOTIATION_FSM_STATE.RENEGOTIATION_GLARE:this.setFsmState(ge.MEDIA_RENEGOTIATION_FSM_STATE.OUTGOING_RENEGOTIATION,m);break;default:return this.logger.info(`[${m}][acceptRenegotiationAsync]there is no incoming media renegotiation offer to accept`),b.reject(new Error("there is no incoming media renegotiation offer to accept")),b.promise}const _=()=>{this.signalingSession.timeoutManager.startTimer(ge.TIMEOUT_OPERATIONS.MEDIA_ANSWER_ACKNOWLEDGEMENT,this.handleMediaAnswerAcknowledgmentTimeout.bind(this,m),ge.TIMEOUT_VALUES_IN_SECONDS.MEDIA_ANSWER_ACKNOWLEDGEMENT_TIMEOUT)};return this.signalingSession.http.sendPostRequest({url:this.links[ge.LINKS.MEDIA_ANSWER],payload:Kve(this.signalingSession,c,u),requestName:$n.SEND_MEDIA_ANSWER.name,onceTrouterReady:_,causeId:m}).then(k=>{b.resolve(k.response)}).catch(k=>{const N=Lr(k,this.signalingSession.signalingAgentConfig);this.logger.info(`[${m}][acceptRenegotiationAsync] error: ${fi(N)}`),this.disposed||this.signalingSession.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.MEDIA_ANSWER_ACKNOWLEDGEMENT),b.reject(new Error(`acceptRenegotiationAsync failed because : ${fi(k)}`))}),b.promise},this.startRenegotiationAsync=(c,u,m,b)=>{this.logger.info(`[${b}][startRenegotiationAsync][mediaTypes=${m}]`),this.signalingSession.telemetryHelper.recordEvent(Ft.START_RENEGOTIATION,{causeId:b,mediaTypes:m}),lc(u,"MediaRenegotiation link not set");const _=Pl();switch(this.fsmState){case ge.MEDIA_RENEGOTIATION_FSM_STATE.CALL_CONNECTED:this.setFsmState(ge.MEDIA_RENEGOTIATION_FSM_STATE.OUTGOING_RENEGOTIATION,b);break;case ge.MEDIA_RENEGOTIATION_FSM_STATE.OUTGOING_RENEGOTIATION:case ge.MEDIA_RENEGOTIATION_FSM_STATE.INCOMING_RENEGOTIATION:case ge.MEDIA_RENEGOTIATION_FSM_STATE.RENEGOTIATION_GLARE:return this.logger.info(`[${b}][startRenegotiationAsync][failed] can only be performed with no current outstanding renegotiations, previous negotiation causeId=${this.fsmStateCauseId}`),this.signalingSessionCallback.onMediaRenegotiationRejection(this.getGlareError(),b),Promise.resolve(null);default:return this.logger.info(`[${b}][startRenegotiationAsync][failed] can only be performed on an established call`),_.reject(new Error("media renegotiation can only be performed on an established call")),_.promise}const k=m&&D2(m,ge.MEDIA_TYPES.SCREEN_SHARER);k?(this.vbssInitiated=!0,this.signalingSession.telemetryHelper.addVbssOperations(ei.VBSS_OPERATION.START)):!k&&this.vbssInitiated&&(this.vbssInitiated=!1,this.signalingSession.telemetryHelper.addVbssOperations(ei.VBSS_OPERATION.STOP));const N=()=>{this.signalingSession.timeoutManager.startTimer(ge.TIMEOUT_OPERATIONS.MEDIA_ANSWER,this.handleMediaAnswerTimeout.bind(this),ge.TIMEOUT_VALUES_IN_SECONDS.MEDIA_ANSWER_TIMEOUT)};return this.signalingSession.http.sendPostRequest({url:u,payload:Ute(this.signalingSession,c,m),requestName:$n.START_RENEGOTIATION.name,onceTrouterReady:N,causeId:b}).then(W=>{_.resolve(W.response)}).catch(W=>{const ee=Lr(W,this.signalingSession.signalingAgentConfig);if(this.logger.info(`[${b}][startRenegotiationAsync] error: ${fi(ee)}`),!this.disposed){switch(this.fsmState){case ge.MEDIA_RENEGOTIATION_FSM_STATE.OUTGOING_RENEGOTIATION:this.setFsmState(ge.MEDIA_RENEGOTIATION_FSM_STATE.CALL_CONNECTED,b);break;case ge.MEDIA_RENEGOTIATION_FSM_STATE.RENEGOTIATION_GLARE:this.setFsmState(ge.MEDIA_RENEGOTIATION_FSM_STATE.INCOMING_RENEGOTIATION,b)}this.signalingSession.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.MEDIA_ANSWER)}_.reject(new Error(`startRenegotiationAsync failed because : ${fi(W)}`))}),_.promise},this.handleMediaAcknowledgment=(c,u)=>{this.signalingSession.telemetryHelper.recordEvent(Ft.HANDLE_MEDIA_ACKNOWLEDGEMENT,{causeId:u}),this.signalingSession.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.MEDIA_ANSWER_ACKNOWLEDGEMENT),this.signalingSession.saveMediaControllerLinksIfAny(c),this.signalingSession.saveUpdatedCallLinksIfAny(c),this.signalingSessionCallback.onMediaAcknowledgementSuccess(!0,u)},this.onCallConnected=c=>{this.logger.info("onCallConnected"),this.setFsmState(ge.MEDIA_RENEGOTIATION_FSM_STATE.CALL_CONNECTED,c)},this.handleMediaNegotiationFailure=c=>{const u=Po(c);this.signalingSession.telemetryHelper.recordIncomingEvent(Ft.HANDLE_MEDIA_NEGOTIATION_FAILURE,c),this.handleMediaNegotiationFailureInternal(c.body.mediaNegotiationFailure,c.origin,u)},this.handleMediaAnswer=(c,u)=>{switch(this.logger.info(`[${u}][handleMediaAnswer]`),this.signalingSession.telemetryHelper.recordEvent(Ft.HANDLE_MEDIA_ANSWER,{causeId:u}),this.fsmState){case ge.MEDIA_RENEGOTIATION_FSM_STATE.OUTGOING_RENEGOTIATION:this.setFsmState(ge.MEDIA_RENEGOTIATION_FSM_STATE.CALL_CONNECTED,u);break;case ge.MEDIA_RENEGOTIATION_FSM_STATE.RENEGOTIATION_GLARE:this.setFsmState(ge.MEDIA_RENEGOTIATION_FSM_STATE.INCOMING_RENEGOTIATION,u);break;default:return}this.signalingSession.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.MEDIA_ANSWER);let m=[];c.mediaAnswer.callModalities&&c.mediaAnswer.callModalities.length>0&&(m=eE(c.mediaAnswer.callModalities),this.signalingSession.telemetryHelper.addIncomingModalities(m));const b={provisional:!1,renegotiation:!0,mediaTypes:m,remoteParticipantId:this.signalingSession.getParticipantIdForOfferAnswer(c.mediaAnswer.mediaContent),mediaContent:c.mediaAnswer.mediaContent};this.signalingSession.http.sendPostRequest({url:c.mediaAnswer.links.mediaAcknowledgement,payload:null,requestName:$n.SEND_MEDIA_ACKNOWLEDGEMENT.name,causeId:u}).catch(_=>{const k=Lr(_,this.signalingSession.signalingAgentConfig);this.logger.info(`[${u}][handleMediaAnswer] error: ${fi(k)}`),this.signalingSession.disposed||this.signalingSession.telemetryHelper.recordEvent(Ft.HANDLE_MEDIA_ANSWER_FAILED,{causeId:u})}),this.signalingSessionCallback.onAnswer(b,u)},this.handleMediaNegotiationOffer=c=>{const u=c.body,m=c.headers,b=Po(c);this.logger.info(`[${b}][handleMediaNegotiationOffer]`),this.signalingSession.telemetryHelper.recordIncomingEvent(Ft.HANDLE_MEDIA_OFFER,c);const _=Z0(m,this.renegotiationOffersSeenSoFar);switch(this.fsmState){case ge.MEDIA_RENEGOTIATION_FSM_STATE.OUTGOING_RENEGOTIATION:this.setFsmState(ge.MEDIA_RENEGOTIATION_FSM_STATE.RENEGOTIATION_GLARE,b),this.raiseMediaRenegotiationOffer(u,b);break;case ge.MEDIA_RENEGOTIATION_FSM_STATE.CALL_CONNECTED:this.setFsmState(ge.MEDIA_RENEGOTIATION_FSM_STATE.INCOMING_RENEGOTIATION,b),this.raiseMediaRenegotiationOffer(u,b);break;case ge.MEDIA_RENEGOTIATION_FSM_STATE.INCOMING_RENEGOTIATION:if(this.signalingSession&&this.signalingSession.signalingAgentConfig&&this.signalingSession.signalingAgentConfig.supportMediaRetargetWhileIncomingRenegotiation){this.raiseMediaRenegotiationOffer(u,b);break}this.rejectAndLog(b,_,u);break;default:this.rejectAndLog(b,_,u)}},this.rejectRenegotiationAsync=(c,u)=>{this.logger.info(`[${u}][rejectRenegotiationAsync]`),this.signalingSession.telemetryHelper.recordEvent(Ft.REJECT_RENEGOTIATION,{rejectionData:c,causeId:u}),lc(this.links[ge.LINKS.MEDIA_REJECTION],"MediaRejection link not set");const m=c||{code:ge.CALL_END_CODE.NOT_ACCEPTABLE_HERE,subCode:ge.CALL_END_SUB_CODE.MEDIA_ANSWER_PROCESSING_ERROR,phrase:ge.CALL_END_PHRASE.MEDIA_ANSWER_ERROR};switch(this.fsmState){case ge.MEDIA_RENEGOTIATION_FSM_STATE.INCOMING_RENEGOTIATION:return this.setFsmState(ge.MEDIA_RENEGOTIATION_FSM_STATE.CALL_CONNECTED,u),this.rejectMediaRenegotiation(this.links[ge.LINKS.MEDIA_REJECTION],m,u);case ge.MEDIA_RENEGOTIATION_FSM_STATE.RENEGOTIATION_GLARE:return this.setFsmState(ge.MEDIA_RENEGOTIATION_FSM_STATE.OUTGOING_RENEGOTIATION,u),this.rejectMediaRenegotiation(this.links[ge.LINKS.MEDIA_REJECTION],m,u);default:return this.logger.error(`[${u}][rejectRenegotiationAsync][failed] There is no incoming media renegotiation offer to reject`),Promise.resolve(null)}},this.handleRetargetCompleted=c=>{const u=c.body.retargetCompleted,m=Po(c);this.logger.info(`[${m}][handleRetargetCompleted][details=${fi(u)}]`),this.signalingSession.telemetryHelper.recordIncomingEvent(Ft.HANDLE_RETARGET_COMPLETED,c,Hs(u)),u.code===0?this.signalingSessionCallback.onReTargetCompletedSuccess(m):this.signalingSessionCallback.onReTargetCompletedFailure(u,m)},this.dispose=()=>{this.logger.info("mediaRenegotiationManager :: dispose"),this.disposed=!0},this.getGlareError=()=>({code:ge.CALL_END_CODE.GLARE_ERROR,subCode:ge.CALL_END_SUB_CODE.MEDIA_GLARE_ERROR,phrase:ge.CALL_END_PHRASE.RENEGOTIATION_IN_PROGRESS,previousNegotiationCauseId:this.fsmStateCauseId}),this.handleMediaNegotiationFailureInternal=(c,u,m)=>{switch(this.logger.info(`[${m}][handleMediaNegotiationFailureInternal][failureData=${Hs(c)}]`),this.signalingSession.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.MEDIA_ANSWER),this.fsmState){case ge.MEDIA_RENEGOTIATION_FSM_STATE.OUTGOING_RENEGOTIATION:this.setFsmState(ge.MEDIA_RENEGOTIATION_FSM_STATE.CALL_CONNECTED,m);break;case ge.MEDIA_RENEGOTIATION_FSM_STATE.RENEGOTIATION_GLARE:this.setFsmState(ge.MEDIA_RENEGOTIATION_FSM_STATE.INCOMING_RENEGOTIATION,m);break;default:return}this.vbssInitiated&&(this.vbssInitiated=!1,this.signalingSession.telemetryHelper.addVbssOperations(ei.VBSS_OPERATION.REJECTED)),this.signalingSession.telemetryHelper.addIncomingModalities(["Rejected"]),this.signalingSessionCallback.onMediaRenegotiationRejection({code:c.code,subCode:c.subCode,phrase:c.phrase},m)},this.signalingSession=n,this.signalingSessionCallback=a,this.logger=n.logger.createChild(()=>`[RenegotiationManager][${this.fsmState}][stateCauseId=${this.fsmStateCauseId}]`)}rejectAndLog(n,a,s){this.logger.error(`[${n}][handleMediaNegotiationOffer] Cannot handle the incoming mediaRenegotiation offer in present callstate. Either call not connected or renegotiation in progress. isDuplicateOffer=${a}`),a||this.rejectMediaRenegotiation(s.mediaNegotiation.links.rejection,this.getGlareError(),n)}setFsmState(n,a){this.fsmState=n,this.fsmStateCauseId=a,this.logger.info(`[setFsmState]state=${n}`),this.telemetryHelper.recordEvent(Ft.MEDIA_FSM_STATE_CHANGED,{state:n,causeId:a})}raiseMediaRenegotiationOffer(n,a){this.logger.info(`[${a}][raiseMediaRenegotiationOffer]`),this.links[ge.LINKS.MEDIA_ANSWER]=n.mediaNegotiation.links.mediaAnswer,this.links[ge.LINKS.MEDIA_REJECTION]=n.mediaNegotiation.links.rejection;let s=[];n.mediaNegotiation.callModalities&&n.mediaNegotiation.callModalities.length>0&&(s=eE(n.mediaNegotiation.callModalities),this.signalingSession.telemetryHelper.addIncomingModalities(s),D2(s,ge.MEDIA_TYPES.SCREEN_SHARER)&&this.signalingSession.telemetryHelper.addVbssOperations(ei.VBSS_OPERATION.REMOTE_START));const c={mediaTypes:s,remoteParticipantId:this.signalingSession.getParticipantIdForOfferAnswer(n.mediaNegotiation.mediaContent),mediaContent:n.mediaNegotiation.mediaContent,renegotiation:!0};this.signalingSessionCallback.onOffer(c,a)}rejectMediaRenegotiation(n,a,s){this.logger.info(`[${s}][rejectMediaRenegotiation][rejectionData=${Hs(a)}]`);const c=Pl();return this.signalingSession.http.sendPostRequest({url:n,payload:Wve(this.signalingSession,a),requestName:$n.SEND_MEDIA_REJECTION.name,causeId:s}).then(u=>{c.resolve(u.response)}).catch(u=>{const m=Lr(u,this.signalingSession.signalingAgentConfig);this.logger.info(`[${s}][rejectMediaRenegotiation] error: ${fi(m)}`),c.reject(new Error(`rejectMediaRenegotiation failed because : ${fi(u)}`))}),c.promise}handleMediaAnswerTimeout(n){this.logger.info(`[${n}][handleMediaAnswerTimeout]`),this.vbssInitiated&&(this.vbssInitiated=!1,this.signalingSession.telemetryHelper.addVbssOperations(ei.VBSS_OPERATION.TIMEOUT)),this.signalingSession.telemetryHelper.addIncomingModalities(["Timeout"]),this.signalingSession.telemetryHelper.recordEvent(Ft.HANDLE_MEDIA_ANSWER_TIMEOUT),this.signalingSession.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.MEDIA_ANSWER),this.handleMediaNegotiationFailureInternal({code:ge.CALL_END_CODE.TIMEOUT,subCode:ge.CALL_END_SUB_CODE.MEDIA_FINAL_ANSWER_TIMEOUT,phrase:ge.CALL_END_PHRASE.MEDIA_FINAL_ANSWER_TIMEOUT},ei.EVENT_SOURCE.LOCAL,n)}handleMediaAnswerAcknowledgmentTimeout(n){this.logger.info(`[${n}][handleMediaAnswerAcknowledgmentTimeout]`),this.signalingSession.telemetryHelper.recordEvent(Ft.HANDLE_MEDIA_ACKNOWLEDGEMENT_TIMEOUT),this.signalingSession.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.MEDIA_ANSWER_ACKNOWLEDGEMENT);const a={reason:"timed out waiting for Media Answer Acknowledgement"};this.signalingSessionCallback.onMediaAcknowledgementFailure(!0,a,n)}},xD=class{constructor(){this.requests={}}clear(n,a){const s=a||{code:ge.CALL_END_CODE.SUCCESS,subCode:ge.CALL_END_SUB_CODE.SUCCESS,phrase:ge.CALL_END_PHRASE.LOCAL_USER_INITIATED};Object.keys(this.requests).forEach(c=>{this.rejectOperation(c,n,s)})}hasOperation(n){return this.requests.hasOwnProperty(n)}getAllOperations(){return this.requests}getOperation(n){return this.hasOperation(n)?this.requests[n]:null}setOperation(n,a){return!this.hasOperation(n)&&(this.requests[n]=a,!0)}rejectOperation(n,a,s){const c=new Error(a);if(s&&(c.endCode=s),this.hasOperation(n)){const u=this.requests[n].promise;delete this.requests[n],u.reject(c)}}resolveOperation(n,a){if(this.hasOperation(n)){const s=this.requests[n].promise;delete this.requests[n],s.resolve(a)}}},Jve=class{constructor(n){this.logger=n,this.localAddParticipantRequests=new xD,this.localAdmitParticipantRequests=new xD,this.localCallMeBackRequests=new xD,this.localRemoveParticipantEndpointRequests=new xD,this.localRemoveParticipantRequests=new xD,this.localUpdateParticipantInterpretationStateRequest=new xD,this.participantIdMriMap=new Map}dispose(n,a,s){this.logger.info(`[${s}][dispose]`),this.rejectAllPendingOperations(n,a)}getAllPendingOperations(n,a){this.logger.info(`[${a}][getAllPendingOperations] ${n}`);const s=this.getOperationTable(n);return s?s.getAllOperations():null}getPendingOperation(n,a,s){this.logger.info(`[${s}][getPendingOperation] ${n} ${a}`);const c=this.getOperationTable(n);return c?c.getOperation(a):null}getRnlMri(n,a){this.logger.info(`[${a}][getRnlMri] ${n}`);for(const s of n)if(this.participantIdMriMap.has(s))return this.participantIdMriMap.get(s);return""}hasPendingOperation(n,a,s){this.logger.info(`[${s}][hasPendingOperation] ${n} ${kn(a)}`);const c=this.getOperationTable(n);return!!c&&c.hasOperation(a)}rejectPendingOperation(n,a,s,c,u){this.logger.info(`[${u}][rejectPendingOperation] ${n} ${kn(a)} reason: ${s}`);const m=this.getOperationTable(n);m&&m.rejectOperation(a,s,c)}resolvePendingOperation(n,a,s,c){this.logger.info(`[${c}][resolvePendingOperation]: ${kn(a)}`);const u=this.getOperationTable(n);u&&u.resolveOperation(a,s)}setPendingOperation(n,a,s,c){this.logger.info(`[${c}][setPendingOperation] ${n} ${kn(a)} value: ${s}`);const u=this.getOperationTable(n);if(!u)return!1;if(n===0){const m=s&&s.participant&&s.participant.participantId;m&&this.participantIdMriMap.set(m,a)}return u.setOperation(a,s)}setParticipantIdToMriMapping(n,a,s,c){c?(this.logger.info(`[${s}][setParticipantIdMriMap] ${wy(n)}: ${kn(a)} clear mapping.`),this.participantIdMriMap.delete(n)):n&&a&&(this.logger.info(`[${s}][setParticipantIdMriMap] ${wy(n)}: ${kn(a)}`),this.participantIdMriMap.set(n,a))}getOperationTable(n){switch(n){case 0:return this.localAddParticipantRequests;case 1:return this.localAdmitParticipantRequests;case 2:return this.localCallMeBackRequests;case 4:return this.localRemoveParticipantEndpointRequests;case 3:return this.localRemoveParticipantRequests;case 5:return this.localUpdateParticipantInterpretationStateRequest;default:return null}}rejectAllPendingOperations(n,a){this.logger.info("rejectLocalQueuedOperations"),this.localAddParticipantRequests.clear(n,a),this.localAdmitParticipantRequests.clear(n,a),this.localCallMeBackRequests.clear(n,a),this.localRemoveParticipantRequests.clear(n,a),this.localRemoveParticipantEndpointRequests.clear(n,a),this.localUpdateParticipantInterpretationStateRequest.clear(n,a)}};function XG(n,a,s,c){xn(n,"signalingSession cannot be null");const u=s.groupId?{id:s.groupId}:null,m=s.threadId?{threadId:s.threadId,messageId:s.messageId||null}:null;let b=[],_={};a&&a.length>0?(b=a.map(N=>({id:N.nonMaskedId?N.nonMaskedId:N.id,assertedId:N.assertedId,displayName:N.displayName,participantId:N.participantId,replacementDetails:s.replacementType===3?n.getReplacementDetailsByParticipantLegOfCall(s.callIdToReplace,N.id,N.replacementParticipantId):void 0})),_={addParticipantSuccess:Vn(n,Fi.CONV_ADD_PARTICIPANT_SUCCESS),addParticipantFailure:Vn(n,Fi.CONV_ADD_PARTICIPANT_FAILURE)}):_={addModalitySuccess:Vn(n,Fi.CONV_ADD_MODALITY_SUCCESS),addModalityFailure:Vn(n,Fi.CONV_ADD_MODALITY_FAILURE)};const k={payload:{disableUnmute:s&&s.disableUnmute,participants:{from:{id:n.participantManager.localParticipant.id,displayName:n.participantManager.localParticipant.displayName,endpointId:n.participantManager.localParticipant.endpointId,participantId:n.participantManager.localParticipant.participantId,languageId:n.participantManager.localParticipant.languageId},to:b},participantInvitationData:vw(s),replacementDetails:s.replacementType===3?void 0:c,groupContext:u,groupChat:m,links:_}};return s&&s.alternateId&&(k.payload.participants.from.alternateId=s.alternateId),s?.callingLineIdentity&&(k.payload.participants.from.callingLineIdentity=s.callingLineIdentity),s?.clientScenario&&(k.payload.debugContent={clientScenario:s.clientScenario}),k}function Yve(n,a,s,c){xn(n,"signalingSession cannot be null");const u=a.map(m=>(xn(m,"remoteParticipant cannot be null"),{id:m.id,assertedId:m.assertedId,displayName:m.displayName,participantId:m.participantId}));return{payload:{disableUnmute:s&&s.disableUnmute,participants:{from:{id:n.participantManager.localParticipant.id,displayName:n.participantManager.localParticipant.displayName,endpointId:n.participantManager.localParticipant.endpointId,participantId:n.participantManager.localParticipant.participantId,languageId:n.participantManager.localParticipant.languageId,alternateId:s?s.alternateId:null,callingLineIdentity:s?s.callingLineIdentity:null},to:u},participantInvitationData:vw(s),replacementDetails:c,links:{addParticipantSuccess:Vn(n,Fi.CONV_ADD_PARTICIPANT_SUCCESS),addParticipantFailure:Vn(n,Fi.CONV_ADD_PARTICIPANT_FAILURE)},debugContent:{clientScenario:s.clientScenario}}}}function Qve(n,a,s){return xn(n,"signalingSession cannot be null"),xn(a,"remoteParticipant cannot be null"),{payload:{participants:{from:{id:n.participantManager.localParticipant.id,displayName:n.participantManager.localParticipant.displayName,endpointId:n.participantManager.localParticipant.endpointId,participantId:n.participantManager.localParticipant.participantId,languageId:n.participantManager.localParticipant.languageId},to:[{id:a.id,displayName:a.displayName}]},links:{admitFailure:Vn(n,Fi.CONV_ADMIT_PARTICIPANT_FAILURE),admitSuccess:Vn(n,Fi.CONV_ADMIT_PARTICIPANT_SUCCESS)},debugContent:{causeId:s}}}}function zte(n){return xn(n,"signalingSession cannot be null"),{payload:{from:{id:n.participantManager.localParticipant.id,displayName:n.participantManager.localParticipant.displayName,endpointId:n.participantManager.localParticipant.endpointId,participantId:n.participantManager.localParticipant.participantId,languageId:n.participantManager.localParticipant.languageId},mediaTypes:["audio"]}}}function Zve(n,a,s,c=!1,u=null){xn(n,"signalingSession cannot be null"),xn(a,"muteScope be null"),xn(s,"participantList cannot be null");const m={from:{id:n.participantManager.localParticipant.id,displayName:n.participantManager.localParticipant.displayName,endpointId:n.participantManager.localParticipant.endpointId,participantId:n.participantManager.localParticipant.participantId,languageId:n.participantManager.localParticipant.languageId},scope:a,muteParticipants:s,mediaTypes:["audio"]};return c&&(m.links={clientCallback:Vn(n,Fi.MUTE_UNMUTE_ASYNC,u)},m.operationId=u),{payload:m}}function Xve(n,a,s,c,u,m){xn(n,"signalingSession cannot be null"),xn(a,"participantsIds cannot be null");const b=n.groupId?{id:n.groupId}:null,_=c?{threadId:c,messageId:u||null}:null,k=[];return a.forEach(N=>{const W={id:N};k.push(W)}),{payload:{participants:{from:{id:n.participantManager.localParticipant.id,displayName:n.participantManager.localParticipant.displayName,endpointId:n.participantManager.localParticipant.endpointId,participantId:n.participantManager.localParticipant.participantId,languageId:n.participantManager.localParticipant.languageId},invitationType:ge.INVITATION_TYPE.NUDGE,to:k},participantInvitationData:m,groupContext:b,groupChat:_,links:{nudgeParticipantSuccess:Vn(n,Fi.CONV_NUDGE_PARTICIPANT_SUCCESS),nudgeParticipantFailure:Vn(n,Fi.CONV_NUDGE_PARTICIPANT_FAILURE)}}}}function eye(n,a,s){xn(n,"signalingSession cannot be null"),xn(a,"participantsIds cannot be null");const c=[];return a.forEach(u=>{const m={id:u};c.push(m)}),{payload:{participants:{from:{id:n.participantManager.localParticipant.id,displayName:n.participantManager.localParticipant.displayName,endpointId:n.participantManager.localParticipant.endpointId,participantId:n.participantManager.localParticipant.participantId,languageId:n.participantManager.localParticipant.languageId},invitationType:ge.INVITATION_TYPE.NUDGE,to:c},participantInvitationData:s,links:{nudgeParticipantSuccess:Vn(n,Fi.CONV_NUDGE_PARTICIPANT_SUCCESS),nudgeParticipantFailure:Vn(n,Fi.CONV_NUDGE_PARTICIPANT_FAILURE),addParticipantSuccess:Vn(n,Fi.CONV_ADD_PARTICIPANT_SUCCESS),addParticipantFailure:Vn(n,Fi.CONV_ADD_PARTICIPANT_FAILURE)}}}}function e9(n,a){return xn(n,"signalingSession cannot be null"),X_(a),{payload:{transactionEnd:a}}}function tye(n,a,s){return xn(n,"signalingSession cannot be null"),xn(a,"remoteParticipant cannot be null"),{payload:{participants:{from:{id:n.participantManager.localParticipant.id,displayName:n.participantManager.localParticipant.displayName,endpointId:n.participantManager.localParticipant.endpointId,participantId:n.participantManager.localParticipant.participantId,languageId:n.participantManager.localParticipant.languageId},scope:s,toEndpoints:[{id:a.id,endpointId:a.endpointId}]},links:{removeParticipantSuccess:Vn(n,Fi.CONV_REMOVE_PARTICIPANT_SUCCESS),removeParticipantFailure:Vn(n,Fi.CONV_REMOVE_PARTICIPANT_FAILURE)}}}}function iye(n,a){return xn(n,"signalingSession cannot be null"),xn(a,"remoteParticipant cannot be null"),{payload:{participants:{from:{id:n.participantManager.localParticipant.id,displayName:n.participantManager.localParticipant.displayName,endpointId:n.participantManager.localParticipant.endpointId,participantId:n.participantManager.localParticipant.participantId,languageId:n.participantManager.localParticipant.languageId},to:[{id:a.id,displayName:a.displayName}]},links:{removeParticipantSuccess:Vn(n,Fi.CONV_REMOVE_PARTICIPANT_SUCCESS),removeParticipantFailure:Vn(n,Fi.CONV_REMOVE_PARTICIPANT_FAILURE)}}}}function nye(n,a=!1,s=null){xn(n,"signalingSession cannot be null");const c={from:{id:n.participantManager.localParticipant.id,displayName:n.participantManager.localParticipant.displayName,endpointId:n.participantManager.localParticipant.endpointId,participantId:n.participantManager.localParticipant.participantId,languageId:n.participantManager.localParticipant.languageId},mediaTypes:["audio"]};return a&&(c.links={clientCallback:Vn(n,Fi.MUTE_UNMUTE_ASYNC,s)},c.operationId=s),{payload:c}}function aye(n,a,s,c=""){xn(s==="specified","Only non-null non-empty scope of 'specified' is supported."),xn(n,"signalingSession cannot be null"),xn(a,"participantsIds cannot be null");const u=[];return a.forEach(m=>{const b={id:m,meetingRole:c};u.push(b)}),{payload:{from:{id:n.participantManager.localParticipant.id,endpointId:n.participantManager.localParticipant.endpointId,participantId:n.participantManager.localParticipant.participantId,languageId:n.participantManager.localParticipant.languageId},scope:s,to:u}}}function Vte(n,a,s){return xn(n,"signalingSession cannot be null"),xn(a,"options cannot be null"),{payload:{from:{id:n.participantManager.localParticipant.id},to:a,links:{updateParticipantInterpretationStateStatus:Vn(n,Fi.UPDATE_PARTICIPANT_INTERPRETATION_STATE_STATUS)},operationId:s}}}var v=$i(dn),S=class{constructor(n,a){this.participantManager=n,this.logger=a,this.handleRosterUpdate=(s,c,u,m)=>{if(s.type==="Delta"||s.type==="MultiPartyEndpoint"){if(s.sequenceNumber===void 0&&(s.sequenceNumber=this.lastRosterUpdateSeqNumber),this.logger.info(`[${m}][handleRosterUpdate][sequenceNumber=${s.sequenceNumber}]`),this.rostersInLifetime.add(s.sequenceNumber),s.type==="Delta")this.logger.info(`[${m}][handleRosterUpdate], RosterType: Delta, isFullRoster: ${u}`),this.handleDeltaRoster(s,u,c,m);else{if(this.logger.info(`[${m}][handleRosterUpdate], RosterType: MultiPartyEndpoint`),this.isRosterStale(s,m))return this.participantManager.signalingSession.telemetryHelper.recordEvent(Ft.IGNORE_OLD_ROSTER,{lastRosterUpdateSeqNumber:this.lastRosterUpdateSeqNumber,sequenceNumber:s.sequenceNumber,causeId:m}),void this.logger.info(`[${m}][handleRosterUpdate] Ignoring old roster update: received ${s.sequenceNumber}, but already handled ${this.lastRosterUpdateSeqNumber}`);for(const b of Object.keys(s.participants)){const _=X0.fromRoster(s.participants[b]);this.handleRosterParticipant(_,c,m)}this.checkForRemovedParticipants(c,s.participants,m),this.participantManager.signalingSessionCallback.onParticipantCountsUpdated(s.participantCounts,m)}if(s.sequenceNumber>this.lastRosterUpdateSeqNumber){this.participantManager.signalingSessionCallback.onParticipantCountsUpdated(s.participantCounts,m),this.lastRosterUpdateSeqNumber=s.sequenceNumber,this.firstRosterUpdateSeqNumber<0&&(this.firstRosterUpdateSeqNumber=this.lastRosterUpdateSeqNumber);const b=Object.keys(s.participants||0).length;this.participantCountInFirstRoster<0&&(this.participantCountInFirstRoster=b),this.maxConcurrentParticipantsDuringLeg=Math.max(this.maxConcurrentParticipantsDuringLeg,b)}this.recordTelemetry(s,u,m),this.participantManager.signalingSessionCallback.onRosterHandlingComplete()}else this.logger.warn(`[${m}][handleRosterUpdate][sequenceNumber=${s.sequenceNumber}] invalid roster type ${s.type}`)},this.isRosterStaleFromFull=(s,c)=>(this.logger.info(`[${c}][isRosterStale] ${s.sequenceNumber<this.lastFullRosterSeqNumber}`),s.sequenceNumber<this.lastFullRosterSeqNumber),this.isRosterStale=(s,c)=>(this.logger.info(`[${c}][isRosterStale] ${s.sequenceNumber<this.lastRosterUpdateSeqNumber}`),s.sequenceNumber<this.lastRosterUpdateSeqNumber),this.updateLocalParticipantFromSubscribe=(s,c)=>{this.logger.info(`[${c}][updateLocalParticipantFromSubscribe]`),this.updateLocalParticipant(s,c)},this.handleParticipantAcceptedBy=(s,c,u)=>{const m=c.hasOwnProperty(s.id),b=s.id===s.acceptedBy.id;this.logger.info(`[${u}][RosterManager::handleParticipantAcceptedBy] oldParticipantInRoster: ${m}`),this.participantManager.participantOperationHandler.setParticipantIdToMriMapping(s.participantId,s.id,u,!0),m&&!b&&this.handleRemovedDeltaRosterParticipant(new X0({id:s.id}),this.lastRosterUpdateSeqNumber,c,u)},this.lastRosterUpdateSeqNumber=-1,this.lastFullRosterSeqNumber=-1,this.firstRosterUpdateSeqNumber=-1,this.tombstoneSequence=new Map,this.latestRosterVersionForActiveParticipants=new Map,this.rostersInLifetime=new Set,this.maxConcurrentParticipantsDuringLeg=-1,this.participantCountInFirstRoster=-1}recordTelemetry(n,a,s){const c={participantCountInLastRoster:Object.keys(n.participants||0).length,participantCountInFirstRoster:this.participantCountInFirstRoster,sequenceNumberOfLastRoster:this.lastRosterUpdateSeqNumber,sequenceNumberOfLastFullRoster:this.lastFullRosterSeqNumber,sequenceNumberOfFirstRoster:this.firstRosterUpdateSeqNumber,rosterType:n.type,isFullRoster:a,maxConcurrentParticipantsDuringLeg:this.maxConcurrentParticipantsDuringLeg,totalParticipantsDuringLifetimeOfLeg:this.tombstoneSequence.size+this.latestRosterVersionForActiveParticipants.size,countOfMissingNotifications:this.getMissingNotificiations()};this.logger.info(`[recordTelemetry] data ${JSON.stringify(c,null,4)}`),this.participantManager.signalingSession.telemetryHelper.recordRosterEvent(c,Ft.HANDLE_ROSTER_UPDATE,s)}getMissingNotificiations(){const n=this.lastRosterUpdateSeqNumber-this.firstRosterUpdateSeqNumber+1-this.rostersInLifetime.size;return n>0?n:0}isParticipantRosterStale(n,a){if(this.logger.info(`[isParticipantRosterStale], rosterParticipantVersion ${a}`),a){if(this.tombstoneSequence.has(n))return a<=this.tombstoneSequence.get(n);if(this.latestRosterVersionForActiveParticipants.has(n))return a<=this.latestRosterVersionForActiveParticipants.get(n)}return!1}handleDeltaRoster(n,a,s,c){if(this.logger.info(`[${c}][handleDeltaRoster] isFullRoster ${a}`),this.isRosterStaleFromFull(n,c))return this.participantManager.signalingSession.telemetryHelper.recordEvent(Ft.IGNORE_OLD_ROSTER,{lastRosterUpdateSeqNumber:this.lastRosterUpdateSeqNumber,lastFullRosterSeqNumber:this.lastFullRosterSeqNumber,sequenceNumber:n.sequenceNumber,causeId:c}),void this.logger.info(`[${c}][handleRosterUpdate] Ignoring old roster update: received ${n.sequenceNumber}, but already handled full roster ${this.lastFullRosterSeqNumber}`);if(a){for(const u of Object.keys(s))if(!n.participants.hasOwnProperty(u)&&!this.isParticipantRosterStale(u,n.sequenceNumber)){const m=new X0({id:u});this.logger.info(`[${c}][handleRosterUpdate] participant missing from delta, full roster`),this.handleRemovedDeltaRosterParticipant(m,n.sequenceNumber,s,c)}this.lastFullRosterSeqNumber=n.sequenceNumber}else if(!n?.participants)return void this.logger.warn(`[${c}][handleRosterUpdate] participants blob empty in delta roster`);for(const u of Object.keys(n.participants)){const m=n.participants[u];if(!this.isParticipantRosterStale(u,m.version)){let b=X0.fromRoster(m);m.state&&m.state==="active"?(this.logger.info(`[${c}][handleDeltaRoster] participant active`),this.handleRosterParticipant(b,s,c),this.tombstoneSequence.has(u)&&this.tombstoneSequence.delete(u),this.latestRosterVersionForActiveParticipants.set(u,m.version)):m.state&&m.state==="inactive"?(b=b||new X0({id:m.details.id}),this.logger.info(`[${c}][handleDeltaRoster] participant inactive`),this.handleRemovedDeltaRosterParticipant(b,m.version,s,c)):this.logger.info(`[${c}][handleDeltaRoster] unexpected participant state ${m.state}`)}}this.handleRemoveParticipantRequests(this.getActiveParticipants(n.participants),c)}getRnlMri(n,a){const s=this.participantManager.participantOperationHandler;if(n){const c=this.getRnlParticipantIdsFromRoster(n,a);return s.getRnlMri(c,a)}return""}handleRemovedDeltaRosterParticipant(n,a,s,c){const u=n.id,m=this.getRnlMri(n,c);let b="";s.hasOwnProperty(u)?b=u:s.hasOwnProperty(m)&&(b=m),b&&this.handleRemovedParticipant(s,b,c),this.tombstoneSequence.set(u,a),this.latestRosterVersionForActiveParticipants.has(u)&&this.latestRosterVersionForActiveParticipants.delete(u)}handleRemovedParticipant(n,a,s){const c=this.participantManager.signalingSessionCallback,u=this.participantManager.signalingSession;n[a]!==!1&&(mw(this.participantManager.connectedRemoteParticipantIds,a),this.logger.info(`[${s}][handleRemovedParticipant] ${kn(a)} removed from roster`),c.onParticipantRemoved({id:a},s),u.clearParticipantCallLinks(a))}getActiveParticipants(n){const a={};for(const s of Object.keys(n))n[s].state!=="inactive"&&(a[s]=n[s]);return a}handleRosterParticipant(n,a,s){if(!n)return void this.logger.info(`[handleRosterParticipant][${s}] rosterParticipant processing skipped because null.`);if(n.id===this.participantManager.localParticipant.id){this.updateLocalParticipant(n,s);const ee=this.getLocalEndpoint(),oe=!(!ee?.stream&&!ee?.streamLobby),de=this.participantManager.signalingSession.callMode===0;return this.logger.info(`[handleRosterParticipant][${s}] isStreaming:${oe} isInitialMode:${de}`),void(oe&&de?this.participantManager.signalingSession.configureStreamingMode(s):oe||this.participantManager.signalingSession.setRealTimeState(1,s))}const c=this.participantManager.participantOperationHandler,u=this.participantManager.signalingSession,m=this.participantManager.signalingSessionCallback,b=n.id,_=this.getRnlMri(n,s),k=this.getRnlParticipantIdsFromRoster(n,s);u.remoteCaller&&k.indexOf(u.remoteCaller.participantId)!==-1&&(n.displayName=u.remoteCaller.displayName),rte(this.participantManager.connectedRemoteParticipantIds,n.id,!0);const N=a.hasOwnProperty(n.id),W=a.hasOwnProperty(_);(N||W)&&(a[n.id]=!1),c.hasPendingOperation(0,n.id,s)&&this.isParticipantInCall(n)?(this.logger.info(`participant ${kn(n.id)} appears in roster. Resolving AddParticipant request`),u.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.ADD_PARTICIPANT,n.id),c.resolvePendingOperation(0,n.id,n,s)):_&&c.hasPendingOperation(0,_,s)&&this.isParticipantInCall(n)?(this.logger.info(`RNL participant ${kn(_)} appears in roster. Resolving AddParticipant request`),u.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.ADD_PARTICIPANT,_),c.resolvePendingOperation(0,_,n,s)):c.hasPendingOperation(1,n.id,s)&&this.isParticipantInCall(n)&&(this.logger.info(`participant: ${kn(n.id)} appears in roster. Resolving AdmitParticipant request`),u.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.ADMIT_PARTICIPANT,n.id),c.resolvePendingOperation(1,n.id,n,s));for(const ee of n.endpointDetails)c.hasPendingOperation(0,ee.participantId,s)&&this.isParticipantInCall(n)&&(this.logger.info(`participant ${kn(n.id)} appears in roster. Resolving AddParticipant request`),u.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.ADD_PARTICIPANT,ee.participantId),c.resolvePendingOperation(0,ee.participantId,n,s));N?(this.logger.info(`participantIds=[${k}] updated ${kn(n.id)}`),m.onParticipantUpdated(n,s),u.setParticipantCallLinks(n)):W?(this.logger.info(`RNL participant participantIds=[${k}] removed old ${kn(_)} and added new ${kn(b)}`),m.onParticipantRemoved({id:_},s,!0),u.clearParticipantCallLinks(_),m.onParticipantJoined(n,s),u.setParticipantCallLinks(n)):c.hasPendingOperation(3,n.id,s)?this.logger.info(`participantIds=[${k}] ignored ${kn(n.id)}`):(this.logger.info(`participantIds=[${k}] joined ${kn(n.id)}`),m.onParticipantJoined(n,s),u.setParticipantCallLinks(n))}getLocalEndpoint(){return v.find(this.participantManager.localParticipant.endpointDetails,n=>this.participantManager.localParticipant.endpointId===n.endpointId)}getRnlParticipantIdsFromRoster(n,a){const s=[];for(const c of n.endpointDetails)s.push(c.participantId);return this.logger.info(`[${a}][getRnlParticipantIdsFromRoster] ${JSON.stringify(s)}`),s}isParticipantInCall(n){return n.endpointDetails?.[0]&&!n.endpointDetails[0].isLobby}updateLocalParticipant(n,a){const s=this.participantManager.localParticipant,c=this.participantManager.signalingSession,u=this.participantManager.signalingSessionCallback;c.setParticipantCallLinks(n),this.logger.info(`[${a}][updateLocalParticipant]`);let m=!1;if(n?.endpointDetails){const b=v.find(n.endpointDetails,k=>s.endpointId===k.endpointId),_=v.find(s.endpointDetails,k=>s.endpointId===k.endpointId);m=_N(b),b?.isLobby&&!_?.isLobby?c.telemetryHelper.recordEvent(Ft.IN_LOBBY,{causeId:a}):!b||b.isLobby||_&&!_.isLobby||(m?c.telemetryHelper.recordEvent(Ft.STAGING,{causeId:a}):c.telemetryHelper.recordEvent(Ft.CONNECTED,{causeId:a})),b?.broadcastMeetingRole&&s&&s.broadcastMeetingRole!==b.broadcastMeetingRole&&(s.broadcastMeetingRole=b.broadcastMeetingRole,c.telemetryHelper.setBroadcastMeetingRole(b.broadcastMeetingRole)),u.onMeetingGroupDetailsUpdated(b?.meetingGroupDetails,a)}if(n?.meetingRole&&c.telemetryHelper.setMeetingRole(n.meetingRole),n?.advancedMeetingRole&&c.telemetryHelper.setAdvancedMeetingRole(n.advancedMeetingRole),n?.meetingRoles&&c.telemetryHelper.setMeetingRoles(n.meetingRoles),n?.participantType&&c.telemetryHelper.setParticipantType(n.participantType),n&&(s.endpointDetails=n.endpointDetails||[],s.acceptedBy=n.acceptedBy,s.role=n.role,s.meetingRole=n.meetingRole,s.advancedMeetingRole=n.advancedMeetingRole,s.meetingRoles=n.meetingRoles,s.participantType=n.participantType,s.tenantId=n.tenantId,s.isLobby=n.isLobby,s.publishedStates=n.publishedStates,s.isStaging=m,s.version=n.version,s.propertyBag=n.propertyBag,s.isIdentityMasked=n.isIdentityMasked,s.maskedIdSeqNumber=n.maskedIdSeqNumber,s.maskedId=n.maskedId,n?.joinAsStreamingUser!==void 0&&(s.joinAsStreamingUser=n.joinAsStreamingUser),n?.enableCaptcha!==void 0&&(s.enableCaptcha=n.enableCaptcha),n?.otpIdentity!==void 0&&(s.otpIdentity=n.otpIdentity),this.participantManager.localParticipant.fromRoster=!0,u.onSelfParticipantUpdated(s,a)),this.isParticipantInCall(n)){const b=this.participantManager.participantOperationHandler,_=this.getRnlMri(n,a);_&&b.hasPendingOperation(0,_,a)&&(this.logger.info(`RNL participant ${kn(_)} appears in roster. Resolving AddParticipant request`),c.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.ADD_PARTICIPANT,_),b.resolvePendingOperation(0,_,n,a))}}checkForRemovedParticipants(n,a,s){const c=this.participantManager.signalingSessionCallback,u=this.participantManager.signalingSession,m=this.participantManager.participantOperationHandler;this.logger.info(`[${s}][checkForRemovedParticipants]`);for(const b of Object.keys(n))n.hasOwnProperty(b)&&n[b]!==!1&&!m.hasPendingOperation(0,b,s)&&(mw(this.participantManager.connectedRemoteParticipantIds,b),this.logger.info(`[${s}][checkForRemovedParticipants] ${kn(b)} removed from roster`),c.onParticipantRemoved({id:b},s),u.clearParticipantCallLinks(b));this.handleRemoveParticipantRequests(a,s)}handleRemoveParticipantRequests(n,a){const s=this.participantManager.signalingSession,c=this.participantManager.participantOperationHandler;this.logger.info(`handleRemoveParticipantRequests [${a}] dynamicRosterParticipants`);const u=[];Object.keys(n).forEach(b=>{const _=X0.fromRoster(n[b]);_&&_.endpointDetails&&_.endpointDetails.forEach(k=>{k.originalId&&u.push(k.originalId)})});const m=c.getAllPendingOperations(3,a);for(const b of Object.keys(m))u.indexOf(b)!==-1||n.hasOwnProperty(b)||(this.logger.info(`[${a}][handleRemoveParticipantRequests] ${kn(b)} no longer appears in roster. Resolving RemoveParticipant request`),mw(this.participantManager.connectedRemoteParticipantIds,b),s.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.REMOVE_PARTICIPANT,b),c.resolvePendingOperation(3,b,{id:b},a))}},P=class{constructor(n,a,s,c){this.connectedRemoteParticipantIds={},this.disposed=!1,this.unmuteApprovalLinks={},this._asyncMuteUnmuteDefers=new Map,this.muteAsyncEnabled=!1,this.unmuteAsyncEnabled=!1,this.setLocalParticipantId=(m,b)=>{m&&(this.logger.info(`[${b}][setLocalParticipantId][participantId=${m}]`),this.localParticipant.participantId=m,this.signalingSession.telemetryHelper.setParticipantId(this.localParticipant.participantId))},this.setEnableMuteAsync=m=>{this.muteAsyncEnabled=m},this.setEnableUnmuteAsync=m=>{this.unmuteAsyncEnabled=m},this.admitParticipantAsync=(m,b,_)=>{const k=`[${_}][admitParticipantAsync]`;this.logger.info(`${k}${this.piiUtils.scrubMriOrOmit(m.id)}`);const N=Pl();return this.participantOperationHandler.hasPendingOperation(1,m.id,_)?(this.logger.info(`${k}there is an existing pending request to admit the participant ${this.piiUtils.scrubMriOrOmit(m.id)}`),N.reject(new Error("there is an existing pending request to admit the participant"))):(this.participantOperationHandler.setPendingOperation(1,m.id,{participant:m,promise:N,causeId:_},_),this.sendNetworkRequestForAdmittingParticipant(m,b,_)),N.promise},this.addParticipantsAsync=(m,b,_,k,N)=>{const W=`[${N}][addParticipantsAsync]`,ee=m.map(se=>this.piiUtils.scrubMriOrOmit(se.id));this.logger.info(`${W} remoteParticipantsIds: ${ee}`);const oe=[],de=[];return m.forEach(se=>{const Re=Pl(),ue=k.replacementType===3?se.participantId:se.id;this.connectedRemoteParticipantIds.hasOwnProperty(se.id)?(this.logger.info(`${W}the given participant is already connected to the call ${this.piiUtils.scrubMriOrOmit(se.id)}`),Re.reject(new Error("the given participant is already connected to the call"))):this.participantOperationHandler.hasPendingOperation(0,ue,N)?(this.logger.info(`${W}there is an existing pending request to add the participant ${this.piiUtils.scrubMriOrOmit(se.id)}`),Re.reject(new Error("there is an existing pending request to add the participant"))):(se.participantId||(se.participantId=My(),this.logger.info(`participantId created ${se.participantId}`)),this.participantOperationHandler.setPendingOperation(0,ue,{participant:se,promise:Re,causeId:N},N),oe.push(se)),de.push(Re.promise)}),_&&this.sendNetworkRequestForAddingParticipant(oe,b,k,N),de},this.nudgeParticipantsAsync=(m,b,_,k,N,W,ee,oe)=>(this.logger.info(`[${k}][nudgeParticipantAsync] ${this.piiUtils.scrubParticipantsList(m)}`),_?this.sendNetworkRequestForNudgingParticipants(m,b,k,N,W,ee,oe):Promise.reject(`[${k}][nudgeParticipantAsync] Call not started`)),this.updateMeetingRolesAsync=(m,b,_,k=tr())=>{const N=Pl();if(!m||m.length<1){const W=`[${k}][updateMeetingRolesAsync] participantsInfo cannot be empty or null`,ee=new Error(W);ee.endCode={code:ge.CALL_END_CODE.REJECT,subCode:ge.CALL_END_SUB_CODE.UPDATE_MEETING_ROLE_REJECTED,phrase:W},this.logger.info(W),N.reject(ee)}else if(b)if(_){let W;b==="attendee"?W=$n.UPDATE_MEETING_ROLE_ATTENDEE.name:b==="presenter"?W=$n.UPDATE_MEETING_ROLE_PRESENTER.name:b==="organizer"?W=$n.UPDATE_MEETING_ROLE_ORGANIZER.name:N.reject(new Error(`[${k}] Invalid meetingRole value(${b})`)),this.logger.info(`[${k}][updateMeetingRolesAsync][meetingRole=${b}]`),this.signalingSession.ensureMessageChannelReady(W).then(()=>{this.sendNetworkRequestForUpdatingMeetingRoles(m,b,_,W,k,N)}).catch(ee=>{const oe=fi(ee);this.logger.info(`[${k}][updateMeetingRolesAsync][failed][reason=${oe}]`);const de={...Lr(ee,this.signalingSession.signalingAgentConfig).error};N.reject(de)})}else{const W=`[${k}][updateMeetingRolesAsync] updateMeetingRoleUrl cannot be empty or null`,ee=new Error(W);ee.endCode={code:ge.CALL_END_CODE.REJECT,subCode:ge.CALL_END_SUB_CODE.UPDATE_MEETING_ROLE_REJECTED,phrase:W},this.logger.info(W),N.reject(ee)}else{const W=`[${k}][updateMeetingRolesAsync] meetingRole cannot be empty or null`,ee=new Error(W);ee.endCode={code:ge.CALL_END_CODE.REJECT,subCode:ge.CALL_END_SUB_CODE.UPDATE_MEETING_ROLE_REJECTED,phrase:W},this.logger.info(W),N.reject(ee)}return N.promise},this.updateParticipantInterpretationStateAsync=(m,b,_)=>{const k=`[${_}][updateParticipantInterpretationStateAsync]`,N=m.map(oe=>this.piiUtils.scrubMriOrOmit(oe.id));this.logger.info(`${k} remoteParticipantsIds: ${N}`);const W=[],ee=[];return m.forEach(oe=>{const de=Pl();this.participantOperationHandler.hasPendingOperation(5,oe.id,_)?(this.logger.info(`${k}there is an existing pending request to update the participant ${this.piiUtils.scrubMriOrOmit(oe.id)}`),de.reject(new Error("there is an existing pending request to update the participant"))):(this.participantOperationHandler.setPendingOperation(5,oe.id,{option:oe,promise:de,causeId:_},_),W.push(oe)),ee.push(de.promise)}),this.sendNetworkRequestToUpdateParticipantInterpretationState(W,b,m,_),ee},this.callMeBackAsync=(m,b,_)=>{this.logger.info(`[${_}][callMeBackAsync] ${this.piiUtils.scrubMriOrOmit(m.id)}`);const k=Pl();return this.connectedRemoteParticipantIds.hasOwnProperty(m.id)?(this.logger.info(`the given participant is already connected to the call : ${this.piiUtils.scrubMriOrOmit(m.id)}`),k.reject(new Error("the given participant is already connected to the call"))):this.participantOperationHandler.hasPendingOperation(2,m.id,_)?(this.logger.info(`there is an existing pending request to call back the participant : ${this.piiUtils.scrubMriOrOmit(m.id)}`),k.reject(new Error("there is an existing pending request to call back the participant"))):(this.participantOperationHandler.setPendingOperation(2,m.id,{participant:m,promise:k},_),this.sendNetworkRequestForCallMeBack(m,b,_)),k.promise},this.isRosterStale=(m,b)=>this.rosterManager.isRosterStale(m,b),this.removeParticipantAsync=(m,b,_)=>{this.logger.info(`[${_}][removeParticipantAsync] ${this.piiUtils.scrubMriOrOmit(m.id)}`),lc(b,"correct removeParticipantUrl is not provided");const k=Pl();if(this.participantOperationHandler.hasPendingOperation(3,m.id,_))this.logger.info(`there is an existing pending request to remove the participant ${this.piiUtils.scrubMriOrOmit(m.id)}`),k.reject(new Error("there is an existing pending request to remove the participant"));else{this.participantOperationHandler.setPendingOperation(3,m.id,{participant:m,promise:k},_);const N=()=>{this.signalingSession.timeoutManager.startTimer(ge.TIMEOUT_OPERATIONS.REMOVE_PARTICIPANT,()=>{this.signalingSession.telemetryHelper.recordEvent(Ft.REMOVE_PARTICIPANT_TIMEOUT),this.signalingSession.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.REMOVE_PARTICIPANT,m.id),this.participantOperationHandler.rejectPendingOperation(3,m.id,"timed out waiting for participant to not show up in roster",{code:ge.CALL_END_CODE.TIMEOUT,subCode:ge.CALL_END_SUB_CODE.CALL_PARTICIPANT_REMOVAL_TIMEOUT,phrase:ge.CALL_END_PHRASE.PARTICIPANT_REMOVAL_TIMEOUT},_)},ge.TIMEOUT_VALUES_IN_SECONDS.REMOVE_PARTICIPANT_TIMEOUT,m.id)};this.signalingSession.http.sendPostRequest({url:b,payload:iye(this.signalingSession,m),requestName:$n.REMOVE_PARTICIPANT_NONE.name,onceTrouterReady:N,causeId:_}).catch(W=>{const ee=Lr(W,this.signalingSession.signalingAgentConfig);this.logger.info(`[${_}][removeParticipantAsync][failed][reason=${fi(ee)}]`),this.disposed||(this.signalingSession.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.REMOVE_PARTICIPANT,m.id),this.participantOperationHandler.rejectPendingOperation(3,m.id,W,ee.error,_))})}return k.promise},this.removeParticipantEndpointAsync=(m,b,_,k)=>{this.logger.info(`[${k}][removeParticipantEndpointAsync] ${J_(m.endpointId,8)} [endPointScope] ${_}`),lc(b,"correct removeParticipantUrl is not provided");const N=Pl();let W="";switch(_){case"all":W=$n.REMOVE_PARTICIPANT_OTHERS.name;break;case"specified":W=$n.REMOVE_PARTICIPANT_SPECIFIED.name;break;default:return Promise.reject(`invalid scope ${_} removeParticipantEndpointAsync`)}this.participantOperationHandler.setPendingOperation(4,m.endpointId,{participant:m,promise:N,scope:_},k);const ee=()=>{this.signalingSession.timeoutManager.startTimer(ge.TIMEOUT_OPERATIONS.REMOVE_PARTICIPANT,()=>{this.signalingSession&&!this.signalingSession.disposed&&(this.signalingSession.telemetryHelper.recordEvent(Ft.REMOVE_PARTICIPANT_TIMEOUT),this.signalingSession.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.REMOVE_PARTICIPANT,m.endpointId),this.participantOperationHandler.rejectPendingOperation(4,m.endpointId,"timed out waiting for participant endpoint sync response from service",{code:ge.CALL_END_CODE.TIMEOUT,subCode:ge.CALL_END_SUB_CODE.CALL_PARTICIPANT_REMOVAL_TIMEOUT,phrase:ge.CALL_END_PHRASE.PARTICIPANT_REMOVAL_TIMEOUT},k))},ge.TIMEOUT_VALUES_IN_SECONDS.REMOVE_PARTICIPANT_TIMEOUT,m.endpointId)};return this.signalingSession.http.sendPostRequest({url:b,payload:tye(this.signalingSession,m,_),requestName:W,onceTrouterReady:ee,causeId:k}).then(oe=>{if(oe.response?.code)if([ge.HTTP_STATUS_CODES.OK,ge.HTTP_STATUS_CODES.CREATED].indexOf(oe.response.code)!==-1)this.logger.info(`[${k}][removeParticipantEndpointAsync][endPointScope] ${_} [passed][reason=${fi(oe.response)}]`),N.resolve(oe.response);else{const de=new Error("invalid service response for removeParticipantEndpoint");de.endCode={code:oe.response.code,subCode:oe.response.subcode,phrase:oe.response.reason},this.logger.info(`[${k}][removeParticipantEndpointAsync][endPointScope] ${_} [failed][reason=${fi(oe.response)}]`),N.reject(de)}N.resolve()}).catch(oe=>{const de=Lr(oe,this.signalingSession.signalingAgentConfig);this.logger.info(`[${k}][removeParticipantEndpointAsync][endPointScope] ${_} [failed][reason=${fi(de)}]`),this.disposed||(this.signalingSession.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.REMOVE_PARTICIPANT,m.endpointId),this.participantOperationHandler.rejectPendingOperation(4,m.endpointId,fi(oe),de.error,k))}),N.promise},this.getParticipantsToInitiateCallWith=()=>{this.logger.info("getParticipantsToInitiateCallWith");const m=[],b=this.participantOperationHandler.getAllPendingOperations(0,tr());for(const _ of Object.keys(b))b.hasOwnProperty(_)&&b[_]&&m.push(b[_].participant);return m},this.initializeForIncomingCall=m=>{this.logger.info("initializeForIncomingCall"),this.participantOperationHandler.dispose("incoming calls cannot add/remove participants until call is connected",null,tr())},this.handleAddParticipantSuccess=m=>{const b=m.body,_=Po(m);this.logger.info(`[${_}][handleAddParticipantSuccess(${b.participantInfos?"new format":"old format"})]${fi(b)}]`),this.signalingSession.telemetryHelper.recordIncomingEvent(Ft.HANDLE_ADD_PARTICIPANT_SUCCESS,m),this.internalHandleCallMeBackSuccess(b,_)||this.signalingSession.telemetryHelper.recordEvent(Ft.HANDLE_ADD_PARTICIPANT_SUCCESS),this.signalingSession.signalingAgentConfig.enableAddParticipantEnhancements&&this.internalHandleAcceptedByParticipants(b,_)},this.handleAddParticipantFailure=m=>{const b=m.body,_=Po(m);this.logger.info(`[${_}][handleAddParticipantFailure(${b.participantInfos?"new format":"old format"})][${fi(b)}]`),b.modalityFailure?(this.logger.info(`[${_}][handleAddParticipantFailure][modalityFailure=${fi(b)}]`),this.signalingSession.telemetryHelper.recordIncomingEvent(Ft.HANDLE_ADD_PARTICIPANT_MODALITY_FAILURE,m)):this.internalHandleAddParticipantFailure(m,_)},this.handleAdmitParticipantSuccess=m=>{const b=m.body,_=Po(m);this.logger.info(`[${_}][handleAdmitParticipantSuccess][${fi(b)}]`),this.signalingSession.telemetryHelper.recordIncomingEvent(Ft.HANDLE_ADMIT_PARTICIPANT_SUCCESS,m),b.participants&&this.internalHandleAdmitParticipantSuccess(m,_)},this.handleAdmitParticipantFailure=m=>{const b=m.body,_=Po(m);this.logger.info(`[${_}][handleAdmitParticipantFailure][${fi(b)}]`),b.participants&&this.internalHandleAdmitParticipantFailure(m,_)},this.handleRemoveParticipantFailure=m=>{const b=m.body,_=Po(m);this.logger.info(`[${_}][handleRemoveParticipantFailure][${fi(b)}]`),this.signalingSession.telemetryHelper.recordIncomingEvent(Ft.HANDLE_REMOVE_PARTICIPANT_FAILURE,m);for(const k of Object.keys(b.participants))b.participants.hasOwnProperty(k)&&this.internalHandleRemoveParticipantFailure(k,b.participants[k],_)},this.handleRemoveParticipantSuccess=m=>{const b=m.body,_=Po(m);this.logger.info(`[${_}][handleRemoveParticipantSuccess][${fi(b)}]`),this.signalingSession.telemetryHelper.recordIncomingEvent(Ft.HANDLE_REMOVE_PARTICIPANT_SUCCESS,m)},this.handleUnmuteConfirmRequest=m=>{const b=m.body,_=Po(m);this.logger.info(`[${_}][handleUnmuteConfirmRequest][${fi(b)}]`),this.signalingSession.telemetryHelper.recordIncomingEvent(Ft.HANDLE_UNMUTE_CONFIRM,m),this.unmuteApprovalLinks[b.from.id]={approve:b.links.approveUnmute,reject:b.links.rejectUnmute},this.signalingSessionCallback.onUnmuteRequested(b.from.id,_)},this.approveUnmuteRequestAsync=(m,b)=>{this.logger.info(`[${b}][approveUnmuteRequestAsync]`);const _=Pl();return this.unmuteApprovalLinks.hasOwnProperty(m)?(this.signalingSession.ensureMessageChannelReady($n.APPROVE_UNMUTE.name).then(()=>{this.muteUnmute($n.APPROVE_UNMUTE.name,zte(this.signalingSession),_,this.unmuteApprovalLinks[m].approve,b)}).catch(k=>{const N=fi(k);this.logger.info(`[${b}][approveUnmuteRequestAsync][failed][reason=${N}]`),_.reject(new Error(k))}),_.promise):(_.reject(new Error("no unmute links found for given participant")),_.promise)},this.rejectUnmuteRequestAsync=(m,b,_)=>{this.logger.info(`[${b}][rejectUnmuteRequestAsync]`);const k=Pl();if(!this.unmuteApprovalLinks.hasOwnProperty(m))return k.reject(new Error("no unmute links found for given participant")),k.promise;const N=_||{code:ge.CALL_END_CODE.REJECT,subCode:ge.CALL_END_SUB_CODE.UNMUTE_REQUEST_REJECTED,phrase:ge.CALL_END_PHRASE.UNMUTE_REQUEST_REJECTED};return this.signalingSession.ensureMessageChannelReady($n.REJECT_UNMUTE.name).then(()=>{this.muteUnmute($n.REJECT_UNMUTE.name,e9(this.signalingSession,N),k,this.unmuteApprovalLinks[m].reject,b)}).catch(W=>{const ee=fi(W);this.logger.info(`[${b}][rejectUnmuteRequestAsync][failed][reason=${ee}]`),k.reject(new Error(W))}),k.promise},this.handleRosterUpdate=(m,b,_)=>{const k=this.getCurrentParticipantsInCallModality(!1);this.rosterManager.handleRosterUpdate(m,k,b,_)},this.updateLocalParticipantFromSubscribe=(m,b)=>{this.localParticipant.fromRoster||this.rosterManager.updateLocalParticipantFromSubscribe(m,b)},this.muteAsync=(m,b,_,k)=>{this.logger.info(`[${k}][muteAsync][muteScope=${b}]`);let N="specified";const W=[];let ee=$n.MUTE_SPECIFIED;switch(b){case ge.MUTE_SCOPE.MYSELF:ee=$n.MUTE_MYSELF,W.push({id:this.localParticipant.id});break;case ge.MUTE_SCOPE.EVERYONE_ELSE:ee=$n.MUTE_ALL_SYNC,N="all",_.forEach(se=>{W.push({id:se})});break;case ge.MUTE_SCOPE.SPECIFIED_PARTICIPANTS:lc(_,`[${k}]array of participantIds must be specified for SPECIFIED_PARTICIPANTS mute scope`),ee=$n.MUTE_SPECIFIED_SYNC,_.forEach(se=>{W.push({id:se})});break;default:Zs(!1,`[${k}]muteScope is a required param. please pass in a valid value.`)}const oe=Pl();if(b===ge.MUTE_SCOPE.SPECIFIED_PARTICIPANTS){const se=this.areParticipantsConnectedToCall(_);if(!se.result)return oe.reject(new Error(`[${k}]specified participant is not connected to call yet. Id = ${se.participant}`)),oe.promise}const de=this.muteAsyncEnabled&&(b===ge.MUTE_SCOPE.SPECIFIED_PARTICIPANTS||b===ge.MUTE_SCOPE.EVERYONE_ELSE);return this.signalingSession.ensureMessageChannelReady(ee.name).then(()=>{this.muteUnmute(ee.name,Zve(this.signalingSession,N,W,de,k),oe,m,k,!1,de)}).catch(se=>{const Re=fi(se),ue=Lr(se,this.signalingSession.signalingAgentConfig);this.logger.info(`[${k}][muteAsync][failed][reason=${Re}]`),oe.reject(ue)}),oe.promise},this.unmuteAsync=(m,b)=>{this.logger.info(`[${b}][unmuteAsync]`);const _=Pl();return this.signalingSession.ensureMessageChannelReady($n.UNMUTE_SYNC.name).then(()=>{this.muteUnmute($n.UNMUTE_SYNC.name,nye(this.signalingSession,this.unmuteAsyncEnabled,b),_,m,b,!0,this.unmuteAsyncEnabled)}).catch(k=>{const N=fi(k);this.logger.info(`[${b}][unmuteAsync][failed][reason=${N}]`),_.reject(new Error(k))}),_.promise},this.dispose=(m,b)=>{this.logger.info(`[${b}][dispose]`),this.disposed=!0,this.participantOperationHandler.dispose("call ended",m,b),this.signalingSession.telemetryHelper.setParticipantId(this.localParticipant.participantId),this._asyncMuteUnmuteDefers.forEach((_,k)=>{_.reject(m)}),this._asyncMuteUnmuteDefers.clear()},this.handleMuteUnmuteAsyncResponse=m=>{const b=Po(m),_=this.logger.createFnLogger("handleMuteUnmuteAsyncResponse",b);if(!m.body)return void _.error("ignored. Empty message body.");const k={info:m.body.muteUnmuteResponseAsync,operationId:m.body.operationId};if(_.info(`Received async response for mute/unmute operation, operation id = ${k.operationId}.`),this.disposed)return void _.info("ignored. Call disposed.");if(!k.operationId)return void _.error("operationId is undefined.");const N=this._asyncMuteUnmuteDefers.get(k.operationId);N?(N.resolve(k),this._asyncMuteUnmuteDefers.delete(k.operationId)):_.warn(`cannot find deferred promise for operation id [${k.operationId}].`)},this.internalHandleAcceptedByParticipants=(m,b)=>{if(m?.participantInfos){const _=m.participantInfos,k=this.getCurrentParticipantsInCallModality(!1);this.logger.info(`[${b}][internalHandleAcceptedByParticipants] handling participants with acceptedBy blob.`);for(const N of _)if(N?.acceptedBy){const W=N.id;this.participantOperationHandler.hasPendingOperation(0,W,b)&&(this.signalingSession.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.ADD_PARTICIPANT,W),this.logger.info(`[${b}][internalHandleAcceptedByParticipants] ${this.piiUtils.scrubMriOrOmit(W)} added using a different MRI. Resolving operation.`),this.participantOperationHandler.resolvePendingOperation(0,W,void 0,b)),this.rosterManager.handleParticipantAcceptedBy(N,k,b)}}},this.internalHandleCallMeBackSuccess=(m,b)=>{let _=!1;if(m?.participantInfos){const k=m.participantInfos;for(const N of k){const W=N.id;this.internalHandleCallMeBackSuccessHelper(W,b)&&(_=!0)}}else if(m?.participants)for(const k of m.participants)this.internalHandleCallMeBackSuccessHelper(k,b)&&(_=!0);return _},this.signalingSession=n,this.signalingSessionCallback=a,this.localParticipant=s,this.localParticipant.endpointId||(this.localParticipant.endpointId=this.signalingSession.getEndpointId());const u=J_(this.localParticipant.endpointId,8);this.logger=c.createChild(()=>`[PM][${u}]`),this.piiUtils=n.piiUtils,this.participantOperationHandler=new Jve(n.logger.createChild(()=>`[ParticipantOperationHandler][${u}]`)),this.rosterManager=new S(this,n.logger.createChild(()=>`[RosterManager][${u}]`)),this.localParticipant.participantId||(this.localParticipant.participantId=My()),typeof n.signalingAgentConfig.languageCode=="string"?this.localParticipant.languageId=n.signalingAgentConfig.languageCode:typeof n.signalingAgentConfig.languageCode=="function"&&(this.localParticipant.languageId=n.signalingAgentConfig.languageCode()),n.telemetryHelper.setParticipantId(this.localParticipant.participantId),n.telemetryHelper.setEndPointId(this.localParticipant.endpointId)}handleUpdateParticipantInterpretationStateCompletion(n){const a=n.body,s=Po(n),c=a.operationId;if(this.disposed)return void this.logger.info(`[${s}][handleUpdateParticipantInterpretationStateCompletion] ignored. Call disposed.`);c||this.logger.warn(`[${s}][handleUpdateParticipantInterpretationStateCompletion] operationId is undefined.`),this.logger.info(`[${s}][handleUpdateParticipantInterpretationStateCompletion] starts`);const u=n.body;if(u.participantInfos){for(const m of u.participantInfos)if(this.logger.info(m),this.participantOperationHandler.hasPendingOperation(5,m.participant.id,s))if(this.signalingSession.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.UPDATE_PARTICIPANT_INTERPRETATION_STATE_COMPLETION,m.participant.id),m.transactionEnd.code===ge.TRANSACTION_END_CODE.SUCCESS)this.logger.info(`[${s}]Update participant interpretation state succeeded for: ${this.piiUtils.scrubMriOrOmit(m.participant.id)}`),this.signalingSession.telemetryHelper.recordIncomingEvent(Ft.UPDATE_PARTICIPANT_INTERPRETATION_STATE_RESPONSE_COMPLETED,n),this.participantOperationHandler.resolvePendingOperation(5,m.participant.id,void 0,s);else{const b=m.transactionEnd.reason;this.logger.info(`[${s}]Update participant interpretation state failed for: ${this.piiUtils.scrubMriOrOmit(m.participant.id)} reason : ${fi(b)}`);const _=this.getCallEndGivenParticipantFailure(b);this.signalingSession.telemetryHelper.recordIncomingEvent(Ft.UPDATE_PARTICIPANT_INTERPRETATION_STATE_RESPONSE_FAILED,n,_),this.participantOperationHandler.rejectPendingOperation(5,m.participant.id,_.phrase,_,s)}}}setEnableCaptcha(n,a){this.logger.info(`[${a}][setEnableCaptcha] value:${n}`),this.localParticipant.enableCaptcha=n,this.signalingSessionCallback.onSelfParticipantUpdated(this.localParticipant,a)}areParticipantsConnectedToCall(n){this.logger.info(`areParticipantsConnectedToCall : ${fi(n)}`);const a=this.getCurrentParticipantsInCallModality(!0);for(const s of n)if(!a.hasOwnProperty(s))return this.logger.info(`areParticipantsConnectedToCall : returning false for :${this.piiUtils.scrubMriOrOmit(s)}`),{result:!1,participant:s};return this.logger.info("areParticipantsConnectedToCall : returning true"),{result:!0}}muteUnmute(n,a,s,c,u,m,b=!1){const _=this.logger.createFnLogger("muteUnmute",u);Zs(this.signalingSession.callMode!==2,"mute/unmute operations are not allowed in streaming mode"),_.info(`operation=${n}, isAsync=${b}`),c?(m&&this.signalingSession.timeoutManager.startTimer(ge.TIMEOUT_OPERATIONS.UNMUTE,()=>{if(this.signalingSession&&!this.signalingSession.disposed){this.signalingSession.telemetryHelper.recordEvent(Ft.UNMUTE_TIMEOUT),this.signalingSession.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.UNMUTE);const k=new Error("timed out waiting for response to request");k.endCode={code:ge.CALL_END_CODE.TIMEOUT,subCode:ge.CALL_END_SUB_CODE.UNMUTE_REQUEST_TIMEOUT,phrase:ge.CALL_END_PHRASE.UNMUTE_REQUEST_TIMEOUT},s.reject(k)}},ge.TIMEOUT_VALUES_IN_SECONDS.UNMUTE_TIMEOUT),b&&this._asyncMuteUnmuteDefers.set(u,s),this.signalingSession.http.sendPostRequest({url:c,payload:a,requestName:n,withoutTrouter:!0,causeId:u}).then(k=>{if(!this.disposed)if(b)_.info(`Inline response received for async operation, operation id: ${u}.`);else{if(k.response?.muteUnmuteResponse){const N={info:k.response.muteUnmuteResponse,operationId:k.response.operationId};switch(n){case $n.UNMUTE_SYNC.name:case $n.MUTE_ALL_SYNC.name:case $n.MUTE_SPECIFIED_SYNC.name:s.resolve(N)}}s.resolve()}}).catch(k=>{const N=Lr(k,this.signalingSession.signalingAgentConfig);_.info(`operation failed, reason=${fi(N)}`),this.disposed||(m&&this.signalingSession.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.UNMUTE),s.reject(N.error))})):s.reject(new Error(`[${u}][muteUnmute] cannot be performed now, the link is not yet available`))}sendNetworkRequestForUpdatingMeetingRoles(n,a,s,c,u,m){if(!s){const _=`[${u}][sendNetworkRequestForUpdatingMeetingRoles] failed because correct updateMeetingRoleUrl is not provided`;new Error(_).endCode={code:ge.CALL_END_CODE.REJECT,subCode:ge.CALL_END_SUB_CODE.UPDATE_MEETING_ROLE_REJECTED,phrase:_},this.logger.info(_),m.reject()}if(!n){const _=`[${u}][sendNetworkRequestForUpdatingMeetingRoles] failed because participants list is empty or null`,k=new Error(_);k.endCode={code:ge.CALL_END_CODE.REJECT,subCode:ge.CALL_END_SUB_CODE.UPDATE_MEETING_ROLE_REJECTED,phrase:_},this.logger.info(_),m.reject(k)}const b=()=>{this.signalingSession.timeoutManager.startTimer(ge.TIMEOUT_OPERATIONS.UPDATE_MEETING_ROLE,()=>{if(this.signalingSession&&!this.signalingSession.disposed){this.signalingSession.telemetryHelper.recordEvent(Ft.UPDATE_MEETING_ROLE,{causeId:u}),this.signalingSession.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.UPDATE_MEETING_ROLE);const _=new Error(`[${u}] Timed out waiting for response to request`);_.endCode={code:ge.CALL_END_CODE.TIMEOUT,subCode:ge.CALL_END_SUB_CODE.UPDATE_MEETING_ROLE_TIMEOUT,phrase:ge.CALL_END_PHRASE.UPDATE_MEETING_ROLE_TIMEOUT},m.reject(_)}},ge.TIMEOUT_VALUES_IN_SECONDS.UPDATE_MEETING_ROLE_TIMEOUT)};this.signalingSession.http.sendPostRequest({url:s,payload:aye(this.signalingSession,n,"specified",a),requestName:c,onceTrouterReady:b,causeId:u}).then(_=>{m.resolve(_.response)}).catch(_=>{const k=fi(_);this.logger.info(`[${u}][sendNetworkRequestForUpdatingMeetingRoles] failed: ${k}`);const N=new Error(`[${u}][CS response] Forbidden request`),W=Lr(_,this.signalingSession.signalingAgentConfig);N.code=W.error.code,N.subCode=W.error.subCode,N.phrase=W.error.phrase,this.disposed||(this.signalingSession.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.UPDATE_MEETING_ROLE),m.reject(N))})}sendNetworkRequestForNudgingParticipants(n,a,s,c,u,m,b){if(a){const _=()=>{this.signalingSession.timeoutManager.startTimer(ge.TIMEOUT_OPERATIONS.NUDGE_PARTICIPANT,()=>{this.signalingSession&&!this.signalingSession.disposed&&(this.signalingSession.telemetryHelper.recordEvent(Ft.NUDGE_PARTICIPANT_TIMEOUT),this.signalingSession.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.NUDGE_PARTICIPANT,n?n.join():""))},ge.TIMEOUT_VALUES_IN_SECONDS.NUDGE_PARTICIPANT_TIMEOUT,n?n.join():"")},k=m||u?Xve(this.signalingSession,n,u,m,b,c):eye(this.signalingSession,n,c);return this.signalingSession.http.sendPostRequest({url:a,payload:k,requestName:$n.NUDGE_PARTICIPANT.name,onceTrouterReady:_,causeId:s}).then(()=>{}).catch(N=>{const W=Lr(N,this.signalingSession.signalingAgentConfig);return this.logger.info(`[${s}][sendNetworkRequestForNudgingParticipant][failed][reason=${fi(W)}]`),this.disposed||this.signalingSession.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.NUDGE_PARTICIPANT,n?n.join():""),Promise.reject(W.error)})}return this.logger.info(`[${s}][sendNetworkRequestForNudgingParticipant] failed because correct nudgeParticipantUrl is not provided`),Promise.reject("Missing nudgeParticipant url")}sendNetworkRequestForAddingParticipant(n,a,s,c=tr()){if(a){let u=$n.ADD_PARTICIPANT.name,m=Ft.ADD_PARTICIPANT_TIMEOUT,b={};switch(s.replacementType){case 2:u=$n.ADD_PARTICIPANT_WITH_PICKUP_CODE.name,m=Ft.ADD_PARTICIPANT_WITH_PICKUP_CODE_TIMEOUT,b.unparkContent={pickupCode:s.pickupCode};break;case 1:u=$n.ADD_PARTICIPANT_WITH_REPLACES.name,m=Ft.ADD_PARTICIPANT_WITH_REPLACES_TIMEOUT,b=this.signalingSession.getCallReplacementDetailsForCall(s.callIdToReplace,c);break;case 3:u=$n.ADD_PARTICIPANT_WITH_REPLACES.name,m=Ft.ADD_PARTICIPANT_WITH_REPLACES_TIMEOUT,b=this.signalingSession.getReplacementDetailsByParticipantLegOfCall(s.callIdToReplace,n[0].id,n[0].replacementParticipantId,c);break;default:u=$n.ADD_PARTICIPANT.name,m=Ft.ADD_PARTICIPANT_TIMEOUT,b=null}const _=()=>{n.forEach(N=>{const W=s.replacementType===3?N.participantId:N.id;this.signalingSession.timeoutManager.startTimer(ge.TIMEOUT_OPERATIONS.ADD_PARTICIPANT,()=>{this.signalingSession&&!this.signalingSession.disposed&&(this.signalingSession.telemetryHelper.recordEvent(m,{causeId:c}),this.signalingSession.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.ADD_PARTICIPANT,W),this.participantOperationHandler.rejectPendingOperation(0,W,"timed out waiting for participant to show up in roster",{code:ge.CALL_END_CODE.TIMEOUT,subCode:ge.CALL_END_SUB_CODE.CALL_ESTABLISHMENT_TIMEOUT,phrase:ge.CALL_END_PHRASE.ESTABLISHMENT_TIMEOUT},c))},ge.TIMEOUT_VALUES_IN_SECONDS.ADD_PARTICIPANT_TIMEOUT,W)})},k=s.threadId||s.groupId?XG(this.signalingSession,n,s,b):Yve(this.signalingSession,n,s,b);this.signalingSession.http.sendPostRequest({url:a,payload:k,requestName:u,onceTrouterReady:_,causeId:c}).catch(N=>{const W=Lr(N,this.signalingSession.signalingAgentConfig);this.logger.info(`[${c}][sendNetworkRequestForAddingParticipant] failed:${fi(N)}`),this.disposed||n.forEach(ee=>{const oe=s.replacementType===3?ee.participantId:ee.id;this.signalingSession.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.ADD_PARTICIPANT,oe),this.participantOperationHandler.rejectPendingOperation(0,oe,N,W.error,c)})})}else this.logger.info(`[${c}][sendNetworkRequestForAddingParticipants] failed because correct addParticipantUrl is not provided`),n.forEach(u=>{const m=s.replacementType===3?u.participantId:u.id;this.participantOperationHandler.rejectPendingOperation(0,m,"correct addParticipantUrl is not provided",{code:ge.CALL_END_CODE.LOCAL_ERROR,subCode:ge.CALL_END_SUB_CODE.CALL_NOT_ATTEMPTED,phrase:ge.CALL_END_PHRASE.ADD_PARTICIPANT_URL_MISSING},c)})}sendNetworkRequestToUpdateParticipantInterpretationState(n,a,s,c=tr()){if(a){const u=$n.UPDATE_PARTICIPANT_INTERPRETATION_STATE.name,m=Ft.UPDATE_PARTICIPANT_INTERPRETATION_STATE_TIMEOUT,b=()=>{const k={code:ge.CALL_END_CODE.TIMEOUT,subCode:ge.CALL_END_SUB_CODE.UPDATE_PARTICIPANT_INTERPRETATION_STATE_TIMEOUT,phrase:ge.CALL_END_PHRASE.UPDATE_PARTICIPANT_INTERPRETATION_STATE_TIMEOUT};n.forEach(N=>{this.signalingSession.timeoutManager.startTimer(ge.TIMEOUT_OPERATIONS.UPDATE_PARTICIPANT_INTERPRETATION_STATE_COMPLETION,()=>{this.signalingSession&&!this.signalingSession.disposed&&(this.logger.info(`[${c}][sendNetworkRequestToUpdateParticipantInterpretationState] timed out`),this.signalingSession.telemetryHelper.recordEvent(m,{causeId:c}),this.signalingSession.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.UPDATE_PARTICIPANT_INTERPRETATION_STATE_COMPLETION,N.id),this.participantOperationHandler.rejectPendingOperation(5,N.id,"timed out waiting to update particiant interpretation state",k,c))},ge.TIMEOUT_VALUES_IN_SECONDS.UPDATE_PARTICIPANT_INTERPRETATION_STATE_COMPLETION_TIMEOUT,N.id)})},_=Vte(this.signalingSession,s,c);this.signalingSession.http.sendPostRequest({url:a,payload:_,requestName:u,onceTrouterReady:b,causeId:c}).catch(k=>{const N=Lr(k,this.signalingSession.signalingAgentConfig);this.logger.info(`[${c}][sendNetworkRequestToUpdateParticipantInterpretationState] failed:${fi(k)}`),this.disposed||n.forEach(W=>{this.signalingSession.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.UPDATE_PARTICIPANT_INTERPRETATION_STATE_COMPLETION,W.id),this.participantOperationHandler.rejectPendingOperation(5,W.id,k,N.error,c)})})}else{this.logger.info(`[${c}][sendNetworkRequestToUpdateParticipantInterpretationState] failed because correct updateParticipantUrl is not provided`);const u={code:ge.CALL_END_CODE.LOCAL_ERROR,subCode:ge.CALL_END_SUB_CODE.CALL_NOT_ATTEMPTED,phrase:ge.CALL_END_PHRASE.UPDATE_PARTICIPANT_INTERPRETATION_STATE_URL_MISSING};n.forEach(m=>{this.participantOperationHandler.rejectPendingOperation(5,m.id,"correct updateParticipantUrl is not provided",u,c)})}}sendNetworkRequestForCallMeBack(n,a,s){if(a){const c=()=>{this.signalingSession.timeoutManager.startTimer(ge.TIMEOUT_OPERATIONS.CALL_ME_BACK,()=>{this.signalingSession&&!this.signalingSession.disposed&&(this.signalingSession.telemetryHelper.recordEvent(Ft.CALL_ME_BACK_TIMEOUT,{causeId:s}),this.signalingSession.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.CALL_ME_BACK,n.id),this.participantOperationHandler.rejectPendingOperation(2,n.id,"timed out waiting for call me back success response",{code:ge.CALL_END_CODE.TIMEOUT,subCode:ge.CALL_END_SUB_CODE.CALL_ESTABLISHMENT_TIMEOUT,phrase:ge.CALL_END_PHRASE.ESTABLISHMENT_TIMEOUT},s))},ge.TIMEOUT_VALUES_IN_SECONDS.CALL_ME_BACK_TIMEOUT,n.id)},u={groupId:this.signalingSession.groupId,threadId:this.signalingSession.threadId,messageId:this.signalingSession.teamsMessageId};this.signalingSession.http.sendPostRequest({url:a,payload:XG(this.signalingSession,[n],u),requestName:$n.CALL_ME_BACK.name,onceTrouterReady:c,causeId:s}).catch(m=>{const b=Lr(m,this.signalingSession.signalingAgentConfig);this.logger.info(`[${s}][sendNetworkRequestForCallMeBack] failed: ${fi(b)}`),this.disposed||(this.signalingSession.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.CALL_ME_BACK,n.id),this.participantOperationHandler.rejectPendingOperation(2,n.id,m,b.error,s))})}else this.logger.info(`[${s}][sendNetworkRequestForCallMeBack] failed because correct addParticipantUrl is not provided`),this.participantOperationHandler.rejectPendingOperation(2,n.id,"correct addParticipantUrl is not provided",{code:ge.CALL_END_CODE.LOCAL_ERROR,subCode:ge.CALL_END_SUB_CODE.CALL_NOT_ATTEMPTED,phrase:ge.CALL_END_PHRASE.ADD_PARTICIPANT_URL_MISSING},s)}sendNetworkRequestForAdmittingParticipant(n,a,s){if(a){const c=()=>{this.signalingSession.timeoutManager.startTimer(ge.TIMEOUT_OPERATIONS.ADMIT_PARTICIPANT,()=>{this.signalingSession&&!this.signalingSession.disposed&&(this.signalingSession.telemetryHelper.recordEvent(Ft.ADMIT_PARTICIPANT_TIMEOUT),this.signalingSession.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.ADMIT_PARTICIPANT,n.id),this.participantOperationHandler.rejectPendingOperation(1,n.id,"timed out waiting for participant to show up in roster",{code:ge.CALL_END_CODE.TIMEOUT,subCode:ge.CALL_END_SUB_CODE.CALL_ESTABLISHMENT_TIMEOUT,phrase:ge.CALL_END_PHRASE.ESTABLISHMENT_TIMEOUT},s))},ge.TIMEOUT_VALUES_IN_SECONDS.ADMIT_PARTICIPANT_TIMEOUT,n.id)};this.signalingSession.http.sendPostRequest({url:a,payload:Qve(this.signalingSession,n,s),requestName:$n.ADMIT_PARTICIPANT.name,onceTrouterReady:c,causeId:s}).catch(u=>{const m=Lr(u,this.signalingSession.signalingAgentConfig);this.logger.info(`[${s}][sendNetworkRequestForAdmittingParticipant][failed][reason=${fi(m)}]`),this.disposed||(this.signalingSession.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.ADMIT_PARTICIPANT,n.id),this.participantOperationHandler.rejectPendingOperation(1,n.id,u,m.error,s))})}else this.logger.info(`[${s}][sendNetworkRequestForAdmittingParticipant] failed because correct admitParticipantUrl is not provided`),this.participantOperationHandler.rejectPendingOperation(1,n.id,"correct admitParticipantUrl is not provided",{code:ge.CALL_END_CODE.LOCAL_ERROR,subCode:ge.CALL_END_SUB_CODE.CALL_NOT_ATTEMPTED,phrase:ge.CALL_END_PHRASE.ADMIT_PARTICIPANT_URL_MISSING},s)}getCurrentParticipantsInCallModality(n){const a={},s=[ge.PARTICIPANT_AUDIO_STATE.CONNECTED];return n||s.push(ge.PARTICIPANT_AUDIO_STATE.CONNECTING,ge.PARTICIPANT_AUDIO_STATE.RINGING),this.signalingSessionCallback.getRemoteParticipantCollection()?.forEach(c=>{s.some(u=>u===c.audioState)&&(a[c.mri]=!0)}),a}internalHandleRemoveParticipantFailure(n,a,s){if(this.participantOperationHandler.hasPendingOperation(3,n,s)){this.signalingSession.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.REMOVE_PARTICIPANT,n),this.logger.info(`[${s}][internalHandleRemoveParticipantFailure] failed for ${this.piiUtils.scrubMriOrOmit(n)} reason ${fi(a)}`);const c=this.getCallEndGivenParticipantFailure(a);this.participantOperationHandler.rejectPendingOperation(3,n,c.phrase,c,s)}}internalHandleCallMeBackSuccessHelper(n,a){if(this.participantOperationHandler.hasPendingOperation(2,n,a)){const s={id:n};return this.logger.info(`participant : ${this.piiUtils.scrubMriOrOmit(n)} was successfully added. Resolving CallMeBack request`),this.signalingSession.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.CALL_ME_BACK,n),this.participantOperationHandler.resolvePendingOperation(2,s.id,s,a),!0}return!1}internalHandleAddParticipantFailure(n,a=tr()){const s=n.body;if(s.participantInfos)s.participantInfos.forEach(c=>{const u=[c.participant.participantId],m=this.participantOperationHandler.getRnlMri(u,a)||c.participant.id;this.rejectAddParticipantFailure(m,c.transactionEnd,n,a)});else if(s.participants)for(const c of Object.keys(s.participants))this.rejectAddParticipantFailure(c,s.participants[c],n,a)}rejectAddParticipantFailure(n,a,s,c){const u=this.getCallEndGivenParticipantFailure(a);this.signalingSession.telemetryHelper.recordIncomingEvent(Ft.HANDLE_ADD_PARTICIPANT_FAILURE,s,u),this.participantOperationHandler.hasPendingOperation(0,n,c)?(this.signalingSession.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.ADD_PARTICIPANT,n),this.logger.info(`participantAdd failed for : ${this.piiUtils.scrubMriOrOmit(n)} reason : ${fi(a)}`),this.participantOperationHandler.rejectPendingOperation(0,n,u.phrase,u,c)):this.participantOperationHandler.hasPendingOperation(2,n,c)&&(this.signalingSession.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.CALL_ME_BACK,n),this.logger.info(`callMeBack failed for : ${this.piiUtils.scrubMriOrOmit(n)} reason : ${fi(a)}`),this.participantOperationHandler.rejectPendingOperation(2,n,u.phrase,u,c))}internalHandleAdmitParticipantSuccess(n,a){const s=n.body;for(const c of s.participants)this.participantOperationHandler.hasPendingOperation(1,c,a)&&(this.signalingSession.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.ADMIT_PARTICIPANT,c),this.logger.info(`Admit participant success for : ${this.piiUtils.scrubMriOrOmit(c)}`),this.participantOperationHandler.resolvePendingOperation(1,c,void 0,a))}internalHandleAdmitParticipantFailure(n,a){const s=n.body;for(const c of Object.keys(s.participants))if(this.participantOperationHandler.hasPendingOperation(1,c,a)){this.signalingSession.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.ADMIT_PARTICIPANT,c);const u=s.participants[c];this.logger.info(`Admit participant failed for : ${this.piiUtils.scrubMriOrOmit(c)} reason : ${fi(u)}`);const m=this.getCallEndGivenParticipantFailure(u);this.signalingSession.telemetryHelper.recordIncomingEvent(Ft.HANDLE_ADMIT_PARTICIPANT_FAILURE,n,m),this.participantOperationHandler.rejectPendingOperation(1,c,m.phrase,m,a)}}getCallEndGivenParticipantFailure(n){let a={code:n.code,subCode:n.subCode,phrase:n.phrase,resultCategories:n.resultCategories};return n.code===ge.CALL_END_CODE.CALL_MODALITY_FAILURE&&n.callControllerTransactionEnd?a={...n.callControllerTransactionEnd}:n.code===ge.CALL_END_CODE.ATC_CONTROLLER_FAILURE&&n.atcControllerTransactionEnd?a={...n.atcControllerTransactionEnd}:n.code===ge.CALL_END_CODE.CVA_CONTROLLER_FAILURE&&n.cvaControllerTransactionEnd&&(a={...n.cvaControllerTransactionEnd}),a}};function G(n,a){xn(n,"signalingSession cannot be null"),lc(a,"sendMessageOptions cannot be null or empty");const s=[];for(const c of a){const u=c.scope===0?"all":"specified",m=[];c.to&&Object.keys(c.to).forEach(b=>{c.to[b].participantLegIdMap?Object.keys(c.to[b].participantLegIdMap).forEach(_=>{m.push({id:b,level:c.to[b].level,endpointId:c.to[b].participantLegIdMap[_].endpointId,participantId:_})}):m.push({id:b,level:c.to[b].level})}),s.push({links:{sendMessageStatus:Vn(n,Fi.SEND_MESSAGE_STATUS)},operationId:c.operationId,payload:c.payload,scope:u,to:m,type:c.type})}return{payload:{from:{displayName:n.participantManager.localParticipant.displayName,endpointId:n.participantManager.localParticipant.endpointId,id:n.participantManager.localParticipant.id,languageId:n.participantManager.localParticipant.languageId??"",participantId:n.participantManager.localParticipant.participantId},messageContent:s}}}function Q(n,a){return`${n}-${a}`}function me(n,a){return`${n}-${a}`}function De(n,a,s){return`${n}_${a}_${s}`}var We=class{constructor(n){this.signalingSession=n,this.scopeAllOperations=new Map,this.mriOperations=new Map,this.legOperations=new Map,this.logger=n.logger.createChild(()=>"[ProxiedMessageNotificationManager]")}sendProxiedMessageAsync(n,a,s){this.logger.createChild("sendProxiedMessageAsync",n).info(`Url: ${s}`);const c=[],u=[];for(const m of a)if(m.scope!==0){if(m.scope===1){for(const b in m.to)if(m.to[b].level==="participant"){const _=Q(b,m.operationId),k=Pl();this.mriOperations.set(_,k),c.push(k.promise),u.push(_),this.startTimeout(n,"participant",_)}else if(m.to[b].level==="endpoint")for(const _ in m.to[b].participantLegIdMap){const k=me(_,m.operationId),N=Pl();this.legOperations.set(k,N),c.push(N.promise),u.push(k),this.startTimeout(n,"endpoint",k)}}}else{const b=Pl();this.scopeAllOperations.set(m.operationId,b),c.push(b.promise),u.push(m.operationId),this.startTimeout(n,"all",m.operationId)}return this.sendProxiedMessageNetworkRequest(n,a,s,u),c}sendProxiedMessageNetworkRequest(n,a,s,c){const u=G(this.signalingSession,a),m=this.logger.createChild("sendProxiedMessageNetworkRequest",n);m.info(`Url: ${s}`),this.signalingSession.http.sendPostRequest({url:s,requestName:$n.SEND_PROXIED_MESSAGE.name,payload:u,causeId:n}).catch(b=>{const _=Lr(b,this.signalingSession.signalingAgentConfig);if(m.info(`failed:${fi(b)}`),this.signalingSession.disposed)m.info("signaling session is already disposed.");else for(const k of c){this.signalingSession.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.SEND_MESSAGE_COMPLETION,k);let N=null;this.scopeAllOperations.has(k)?(N=this.scopeAllOperations.get(k),this.scopeAllOperations.delete(k)):this.mriOperations.has(k)?(N=this.mriOperations.get(k),this.mriOperations.delete(k)):this.legOperations.get(k)?(N=this.legOperations.get(k),this.legOperations.delete(k)):m.warn(`could not find resolveString:${k} to reject it.`),N!==null&&N.reject({transactionEnd:_.error,causeId:n,resolveString:k})}})}startTimeout(n,a,s){const c=this.logger.createChild("startTimeout",n);c.info(`Creating timeout for level ${a} message with resolveString ${s}`),this.signalingSession.timeoutManager.startTimer(ge.TIMEOUT_OPERATIONS.SEND_MESSAGE_COMPLETION,()=>{this.signalingSession.telemetryHelper.recordEvent(Ft.SEND_MESSAGE_TIMEOUT,{causeId:n,resolveString:s}),c.info(`timed out waiting for level [${a}] message with resolveString [${s}]`),this.signalingSession.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.SEND_MESSAGE_COMPLETION,s);const u=a==="all"?this.scopeAllOperations:a==="participant"?this.mriOperations:a==="endpoint"?this.legOperations:null;u!==null?u.has(s)?(u.get(s).reject({transactionEnd:{code:ge.CALL_END_CODE.TIMEOUT,subCode:ge.CALL_END_SUB_CODE.CONVERSATION_NOTIFICATION_TIMEOUT,phrase:ge.CALL_END_PHRASE.CONVERSATION_NOTIFICATION_TIMEOUT},causeId:n,resolveString:s}),u.delete(s)):c.warn(`Could not find resolveString [${s}] on map for ${a}. Will not reject promise.`):c.warn(`Could not find a operations map for ${a}. Will not reject promise.`)},ge.TIMEOUT_VALUES_IN_SECONDS.SEND_MESSAGE_COMPLETION_TIMEOUT,s)}handleProxiedMessageNotificationItem(n,a,s){if(a.info(`Message contains ${n.participantInfos?.length} participantInfos.`),this.scopeAllOperations.size===0&&this.mriOperations.size===0&&this.legOperations.size===0)return void a.info("Received statusMessage but there is no pending operation.");const c=n.operationId;if(this.scopeAllOperations.has(c)){a.info(`Scope all resolveString:${c}`),this.signalingSession.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.SEND_MESSAGE_COMPLETION,c);const u={transactionEnd:{code:0,subCode:0,phrase:""},causeId:s,resolveString:c};return this.scopeAllOperations.get(c).resolve(u),this.scopeAllOperations.delete(c),void this.signalingSession.telemetryHelper.recordEvent(Ft.SEND_MESSAGE_COMPLETION,{causeId:s,operationId:c,level:"all"})}for(const u of n.participantInfos){const m=u.transactionEnd?.code===0,b=Q(u.participant.id,c),_=me(u.participant.participantId,c);if(b&&this.mriOperations.has(b)){a.info(`Scope mri resolveString:${b}`);const k={transactionEnd:u.transactionEnd,causeId:s,resolveString:b};m?this.mriOperations.get(b).resolve(k):this.mriOperations.get(b).reject(k),this.mriOperations.delete(b),this.signalingSession.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.SEND_MESSAGE_COMPLETION,b),this.signalingSession.telemetryHelper.recordEvent(Ft.SEND_MESSAGE_COMPLETION,{causeId:s,operationId:c,level:"mri"})}else if(_&&this.legOperations.has(_)){a.info(`Scope legId resolveString:${_}`);const k={transactionEnd:u.transactionEnd,causeId:s,resolveString:_};m?this.legOperations.get(_).resolve(k):this.legOperations.get(_).reject(k),this.legOperations.delete(_),this.signalingSession.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.SEND_MESSAGE_COMPLETION,_),this.signalingSession.telemetryHelper.recordEvent(Ft.SEND_MESSAGE_COMPLETION,{causeId:s,operationId:c,level:"leg"})}else a.warn(`Could not map this participantInfo to any pending operation operationId:${c}`)}}handleProxiedMessageNotification(n){const a=Po(n),s=this.logger.createChild("handleProxiedMessageNotification",a);let c;c=Array.isArray(n.body?.statuses)?n.body.statuses:[n.body],s.info(`Received ${c.length} proxied message notification(s).`);for(const u of c)this.handleProxiedMessageNotificationItem(u,s,a)}};function rt(n,a){return xn(n,"signalingSession cannot be null"),xn(a,"broadcastContext cannot be null"),{payload:{participants:{from:{id:n.participantManager.localParticipant.id,displayName:n.participantManager.localParticipant.displayName,endpointId:n.participantManager.localParticipant.endpointId,participantId:n.participantManager.localParticipant.participantId,languageId:n.participantManager.localParticipant.languageId}},broadcast:a,links:{addModalitySuccess:Vn(n,Fi.CONV_ADD_MODALITY_SUCCESS),addModalityFailure:Vn(n,Fi.CONV_ADD_MODALITY_FAILURE)}}}}function _t(n,a){return xn(n,"signalingSession cannot be null"),xn(a,"broadcastContext cannot be null"),{payload:{participants:{from:{id:n.participantManager.localParticipant.id,displayName:n.participantManager.localParticipant.displayName,endpointId:n.participantManager.localParticipant.endpointId,participantId:n.participantManager.localParticipant.participantId,languageId:n.participantManager.localParticipant.languageId}},groupContext:a.groupContext?{id:a.groupContext.groupId}:null,groupChat:a.groupChat?{threadId:a.groupChat.threadId,messageId:a.groupChat.messageId}:null,links:{addModalitySuccess:Vn(n,Fi.CONV_ADD_MODALITY_SUCCESS),addModalityFailure:Vn(n,Fi.CONV_ADD_MODALITY_FAILURE)}}}}function Ut(n,a){return xn(n,"signalingSession cannot be null"),{payload:{participants:{from:{id:n.participantManager.localParticipant.id,displayName:n.participantManager.localParticipant.displayName,endpointId:n.participantManager.localParticipant.endpointId,participantId:n.participantManager.localParticipant.participantId,languageId:n.participantManager.localParticipant.languageId}},links:{admitAllStatus:Vn(n,Fi.CONV_ADMIT_ALL_STATUS)},operationId:a,debugContent:{causeId:a}}}}function Di(n,a,s=!0){xn(n,"signalingSession cannot be null"),xn(a,"joinUrl cannot be null");const c={type:"Delta",rosterUpdate:Vn(n,Fi.CONV_ROSTER_UPDATE)},u=n.getEndpointCapabilities(),m={payload:{attach:{requireMediaContent:s,links:{end:Vn(n,Fi.END)},locationContent:n.getLocationContent(),networkContent:n.getNetworkContent(),areaContent:n.getAreaContent(),...n?.signalingAgent?.accountConfig?.applicationType?{applicationType:n.signalingAgent.accountConfig.applicationType}:{}},capabilities:null,endpointCapabilities:u,additionalActions:[{input:{capabilities:null,endpointCapabilities:u,conversationRequest:{applicationType:n.participantManager.localParticipant.applicationType,roster:c,links:{conversationEnd:Vn(n,n.signalingAgentConfig.enableSplitConversationEndUrl?Fi.CONV_END_JOIN:Fi.CONV_END),conversationUpdate:Vn(n,Fi.CONV_UPDATE),localParticipantUpdate:Vn(n,Fi.CONV_LOCAL_PARTICIPANT_UPDATE),addParticipantSuccess:Vn(n,Fi.CONV_ADD_PARTICIPANT_SUCCESS),addParticipantFailure:Vn(n,Fi.CONV_ADD_PARTICIPANT_FAILURE),receiveMessage:Vn(n,Fi.RECEIVE_MESSAGE)}},endpointMetadata:n.endpointMetadata,participants:{from:{id:n.participantManager.localParticipant.id,displayName:n.participantManager.localParticipant.displayName,endpointId:n.participantManager.localParticipant.endpointId,participantId:n.participantManager.localParticipant.participantId,languageId:n.participantManager.localParticipant.languageId}}},name:"join",url:a,waitForResponse:!0}]}};return n.signalingAgentConfig.ecsEtag&&(m.payload.debugContent={ecsEtag:n.signalingAgentConfig.ecsEtag}),m.payload.additionalActions.length>0&&n.deviceType&&n.deviceType!=="default"&&(m.payload.additionalActions[0].input.conversationRequest.deviceType=n.deviceType),m}function Ri(n){return xn(n,"signalingSession cannot be null"),{payload:{callAcceptanceAcknowledgement:{links:{mediaRenegotiation:Vn(n,Fi.MEDIA_RENEGOTIATION),transfer:Vn(n,Fi.TRANSFER),replacement:Vn(n,Fi.REPLACE),balanceUpdate:Vn(n,Fi.BALANCE_UPDATE),retargetCompletion:Vn(n,Fi.RETARGET_COMPLETION),controlVideoStreaming:Vn(n,Fi.CONTROL_VIDEO_STREAMING),updateMediaDescriptions:Vn(n,Fi.UPDATE_MEDIA_DESCRIPTIONS)}}}}}function Xi(n,a,s,c){xn(n,"signalingSession cannot be null");const u=eE(s);n.telemetryHelper.addOutgoingModalities(u);const m=n.getEndpointCapabilities();return{payload:{callAcceptance:{acceptedBy:{id:n.participantManager.localParticipant.id,displayName:n.participantManager.localParticipant.displayName,endpointId:n.participantManager.localParticipant.endpointId,participantId:n.participantManager.localParticipant.participantId,languageId:n.participantManager.localParticipant.languageId},acceptedCallModalities:u,capabilities:null,endpointCapabilities:m,clientEndpointCapabilities:c!==0?c:null,links:{mediaRenegotiation:Vn(n,Fi.MEDIA_RENEGOTIATION),transfer:Vn(n,Fi.TRANSFER),replacement:Vn(n,Fi.REPLACE),balanceUpdate:Vn(n,Fi.BALANCE_UPDATE),retargetCompletion:Vn(n,Fi.RETARGET_COMPLETION),controlVideoStreaming:Vn(n,Fi.CONTROL_VIDEO_STREAMING),updateMediaDescriptions:Vn(n,Fi.UPDATE_MEDIA_DESCRIPTIONS)},clientContentForMediaController:n.webRtcSignalingManager.getClientUrls(),mediaContent:a,pstnContent:n.pstnContent,callKeepAliveInterval:null,...n?.signalingAgent?.accountConfig?.applicationType?{applicationType:n.signalingAgent.accountConfig.applicationType}:{}}}}}function tn(n){return xn(n,"signalingSession cannot be null"),{payload:{callProgress:{sender:{id:n.participantManager.localParticipant.id,displayName:n.participantManager.localParticipant.displayName,endpointId:n.participantManager.localParticipant.endpointId,participantId:n.participantManager.localParticipant.participantId,languageId:n.participantManager.localParticipant.languageId},status:"ringing",phrase:"ringing"}}}}function Cn(n,a,s,c){xn(n,"signalingSession cannot be null");const u=n.participantManager.localParticipant;return{payload:{invitationRedirection:{target:{type:a,endpointType:c,id:s},sender:{id:u.id,endpointId:u.endpointId,participantId:u.participantId,languageId:u.languageId}}}}}function Ja(n,a,s){xn(n,"signalingSession cannot be null"),X_(a);const c={payload:{participants:{from:{id:n.participantManager.localParticipant.id,displayName:n.participantManager.localParticipant.displayName,endpointId:n.participantManager.localParticipant.endpointId,languageId:n.participantManager.localParticipant.languageId}},conversationTransactionEnd:{reason:"noError",code:ge.CALL_END_CODE.SUCCESS,phrase:ge.CALL_END_PHRASE.CONV_END_NO_MODALITY},callTransactionEnd:a}};return s&&a.code===ge.CALL_END_CODE.CANCEL&&(c.payload.callTransactionEnd.callQualityDiagnosticsInformation=s),c}function po(n,a,s,c){xn(n,"signalingSession cannot be null");let u=[];u=c.invitationType===ge.INVITATION_TYPE.NUDGE&&Array.isArray(c.participantsToNudge)?c.participantsToNudge.map(ze=>({id:ze})):n.participantManager.getParticipantsToInitiateCallWith(),n.signalingAgentConfig.doHostlessCalling||Zs(u.length>0,"remoteParticipants need to be set before a call can be made");const m={type:"Delta",rosterUpdate:Vn(n,Fi.CONV_ROSTER_UPDATE)},b=n.groupId?{id:n.groupId}:null,_=n.threadId?{threadId:n.threadId,messageId:n.teamsMessageId||null}:null,k=n.contentSharingManager.getContentSharingInfoToStartSharing(),N=k===null?null:{identifier:k.contentIdentifier,subject:k.subject,sessionState:k.sessionState,sessionUpdateSequenceNumber:k.sequenceNumber,links:{sessionUpdate:Vn(n,Fi.CONV_CONTENT_SHARING_UPDATE),sessionEnd:Vn(n,Fi.CONV_CONTENT_SHARING_END)}},W=n.broadcastSession?.getContext(),ee=n.getEndpointCapabilities();u.length===1&&n.telemetryHelper.setCalleeType(u[0].id),n.numberOfOriginalInvitees=u.length;const oe=[];u.forEach(ze=>{const He={id:ze.id};ze.displayName&&(He.displayName=ze.displayName),ze.participantId&&(He.participantId=ze.participantId),(c.callToVoicemail||n.transferContext&&n.transferContext.target&&n.transferContext.target.endpointType==="voicemail")&&(He.endpointType="voicemail"),oe.push(He)});const de=n.transferContext?n.transferContext.transferor:null,se=n.transferContext?n.transferContext.transferContext:null,Re={};c.callToVoicemail&&(c.voicemailResourcePath&&(Re.localResourcePath=c.voicemailResourcePath),c.voicemailItemId&&(Re.voicemailItemId=c.voicemailItemId));const ue={payload:{conversationRequest:{conversationType:c.conversationType,subject:n.convSubject,suppressDialout:c.suppressDialout,applicationType:c.applicationType,targetApplicationType:c.targetApplicationType,roster:m,properties:{allowConversationWithoutHost:n.signalingAgentConfig.doHostlessCalling,enableGroupCallEventMessages:n.signalingAgentConfig.shouldServiceSendCallEventMessages,enableGroupCallUpgradeMessage:n.signalingAgentConfig.shouldServiceSendNGCUpgradeMessages,enableGroupCallMeetupGeneration:n.enableGroupCallMeetupGeneration},links:{conversationEnd:Vn(n,n.signalingAgentConfig.enableSplitConversationEndUrl?c.subscribe?Fi.CONV_END_SUBSCRIBE:Fi.CONV_END_JOIN:Fi.CONV_END),conversationUpdate:Vn(n,Fi.CONV_UPDATE),localParticipantUpdate:Vn(n,Fi.CONV_LOCAL_PARTICIPANT_UPDATE),addParticipantSuccess:Vn(n,Fi.CONV_ADD_PARTICIPANT_SUCCESS),addParticipantFailure:Vn(n,Fi.CONV_ADD_PARTICIPANT_FAILURE),addModalitySuccess:Vn(n,Fi.CONV_ADD_MODALITY_SUCCESS),addModalityFailure:Vn(n,Fi.CONV_ADD_MODALITY_FAILURE),confirmUnmute:Vn(n,Fi.CONV_CONFIRM_UNMUTE),receiveMessage:Vn(n,Fi.RECEIVE_MESSAGE)}},broadcast:W,contentSharing:N,participants:{from:{id:n.participantManager.localParticipant.id,displayName:n.participantManager.localParticipant.displayName,endpointId:n.participantManager.localParticipant.endpointId,participantId:n.participantManager.localParticipant.participantId,languageId:n.participantManager.localParticipant.languageId,meetingRegistrationId:c.meetingRegistrationId,participantPin:c.participantPin},to:oe},capabilities:null,endpointCapabilities:ee,clientEndpointCapabilities:c.clientEndpointCapabilities?c.clientEndpointCapabilities:null,endpointMetadata:n.endpointMetadata,groupContext:b,groupChat:_,meetingInfo:n.getMeetingInfo(),meetingData:c.meetingData,meetingPreferences:c.meetingPreferences,endpointState:c.endpointState}};if(c.publishedStates?.publishedStates.length>0){let ze=[];ze=c.publishedStates.publishedStates.map(He=>{let be={};try{be=JSON.parse(He.content)}catch{n.logger.warn("createConversationRequest getPayload() failed to parse state.content")}return{stateType:He.type,level:He.level,content:be,sequenceNumber:n.getPublishStateSequenceNumber()}}),ue.payload.publishedStates=ze}n.deviceType&&n.deviceType!=="default"&&(ue.payload.conversationRequest.deviceType=n.deviceType);const Ne=eE(s);if(n.telemetryHelper.addOutgoingModalities(Ne),ue.payload.callInvitation={callModalities:Ne,replaces:null,transferor:de||null,clientTransferContext:se,customContext:c.customHeaderContext||null,links:{progress:Vn(n,Fi.PROGRESS),mediaAnswer:Vn(n,Fi.MEDIA_ANSWER),acceptance:Vn(n,Fi.ACCEPT),redirection:Vn(n,Fi.REDIRECTION),end:Vn(n,Fi.END)},clientContentForMediaController:n.webRtcSignalingManager.getClientUrls(),pstnContent:n.pstnContent,emergencyContent:n.getEmergencyContent(),mediaContent:a,voicemailSettings:Re,routingFlags:c.routingFlags,invitationData:c.invitationData,locationContent:n.getLocationContent(),networkContent:n.getNetworkContent(),areaContent:n.getAreaContent()},c.pickupCode&&(ue.payload.callInvitation.unparkContent={pickupCode:parseInt(c.pickupCode,10)}),c.onBehalfOf&&(ue.payload.callInvitation.onBehalfOf={id:c.onBehalfOf},c.onBehalfOfUserDisplayName&&(ue.payload.callInvitation.onBehalfOf.displayName=c.onBehalfOfUserDisplayName)),c.callQueueContext&&(ue.payload.callInvitation.callQueueContext=c.callQueueContext),c.scenario&&(ue.payload.conversationRequest.scenario=c.scenario),c.alternateId&&(ue.payload.participants.from.alternateId=c.alternateId),c.callingLineIdentity&&(ue.payload.participants.from.callingLineIdentity=c.callingLineIdentity),c.invitationType===ge.INVITATION_TYPE.NUDGE&&(ue.payload.participants.invitationType=c.invitationType),n.signalingAgentConfig.ecsEtag&&(ue.payload.debugContent={ecsEtag:n.signalingAgentConfig.ecsEtag}),c.clientEndpointDebugContent){ue.payload.debugContent||(ue.payload.debugContent={});try{ue.payload.debugContent.clientDebugContent=JSON.parse(c.clientEndpointDebugContent)}catch{Zs(!1,`Failed to parse ${c.clientEndpointDebugContent}`)}}if(c.captchaContentJson)try{ue.payload.conversationRequest.captchaContent=JSON.parse(c.captchaContentJson)}catch{Zs(!1,`Failed to parse ${c.captchaContentJson}`)}return c.participationPreferences&&(ue.payload.participationPreferences=c.participationPreferences),c.participantPropertyBag&&(ue.payload.participantPropertyBag=c.participantPropertyBag),ue}function Gr(n,a){return xn(n,"signalingSession cannot be null"),X_(a),{payload:{participants:{from:{id:n.participantManager.localParticipant.id,displayName:n.participantManager.localParticipant.displayName,endpointId:n.participantManager.localParticipant.endpointId,participantId:n.participantManager.localParticipant.participantId,languageId:n.participantManager.localParticipant.languageId}},conversationTransactionEnd:{reason:"noError",code:ge.CALL_END_CODE.SUCCESS,phrase:ge.CALL_END_PHRASE.CONV_END_FOR_ALL_INITIATED},callTransactionEnd:a}}}function Dl(n,a){return{payload:{from:{id:n.participantManager.localParticipant.id,displayName:n.participantManager.localParticipant.displayName,endpointId:n.participantManager.localParticipant.endpointId,participantId:n.participantManager.localParticipant.participantId,languageId:n.participantManager.localParticipant.languageId},scope:a}}}function hl(n,a,s,c,u){xn(n,"signalingSession cannot be null");const m={type:"Delta",rosterUpdate:Vn(n,Fi.CONV_ROSTER_UPDATE)},b=n.getEndpointCapabilities(),_=n.groupId?{id:n.groupId}:null,k=n.threadId?{threadId:n.threadId,messageId:n.teamsMessageId||null}:null,N={payload:{conversationRequest:{conversationType:c.conversationType,subject:n.convSubject,suppressDialout:c.suppressDialout,scenario:c.scenario,applicationType:c.applicationType,roster:m,properties:{allowConversationWithoutHost:n.signalingAgentConfig.doHostlessCalling,enableGroupCallEventMessages:n.signalingAgentConfig.shouldServiceSendCallEventMessages,enableGroupCallUpgradeMessage:n.signalingAgentConfig.shouldServiceSendNGCUpgradeMessages,enableGroupCallMeetupGeneration:n.enableGroupCallMeetupGeneration},links:{conversationEnd:Vn(n,n.signalingAgentConfig.enableSplitConversationEndUrl?c.subscribe?Fi.CONV_END_SUBSCRIBE:Fi.CONV_END_JOIN:Fi.CONV_END),conversationUpdate:Vn(n,Fi.CONV_UPDATE),localParticipantUpdate:Vn(n,Fi.CONV_LOCAL_PARTICIPANT_UPDATE),addParticipantSuccess:Vn(n,Fi.CONV_ADD_PARTICIPANT_SUCCESS),addParticipantFailure:Vn(n,Fi.CONV_ADD_PARTICIPANT_FAILURE),receiveMessage:Vn(n,Fi.RECEIVE_MESSAGE)}},groupContext:_,groupChat:k,participants:{from:{id:n.participantManager.localParticipant.id,displayName:n.participantManager.localParticipant.displayName,endpointId:n.participantManager.localParticipant.endpointId,participantId:n.participantManager.localParticipant.participantId,languageId:n.participantManager.localParticipant.languageId,meetingRegistrationId:c.meetingRegistrationId,participantPin:c.participantPin}},capabilities:null,endpointCapabilities:b,clientEndpointCapabilities:c.clientEndpointCapabilities?c.clientEndpointCapabilities:null,endpointMetadata:n.endpointMetadata,meetingInfo:n.getMeetingInfo(),meetingData:c.meetingData,meetingPreferences:c.meetingPreferences,endpointState:c.endpointState}};if(c.publishedStates?.publishedStates.length>0){let W=[];W=c.publishedStates.publishedStates.map(ee=>{let oe={};try{oe=JSON.parse(ee.content)}catch{n.logger.warn("joinConversationRequest getPayload() failed to parse state.content")}return{stateType:ee.type,level:ee.level,content:oe,sequenceNumber:n.getPublishStateSequenceNumber()}}),N.payload.publishedStates=W}if(c?.applyServerMute&&(N.payload.participants.from.applyServerMute=c.applyServerMute.value,c.applyServerMute.mediaTypes&&(N.payload.participants.from.mediaTypes=c.applyServerMute.mediaTypes)),n.deviceType&&n.deviceType!=="default"&&(N.payload.conversationRequest.deviceType=n.deviceType),!c.subscribe){const W=eE(s);n.telemetryHelper.addOutgoingModalities(W),N.payload.callInvitation={callModalities:W,replaces:null,transferor:null,links:{progress:Vn(n,Fi.PROGRESS),mediaAnswer:Vn(n,Fi.MEDIA_ANSWER),acceptance:Vn(n,Fi.ACCEPT),redirection:Vn(n,Fi.REDIRECTION),end:Vn(n,Fi.END)},clientContentForMediaController:n.webRtcSignalingManager.getClientUrls(),mediaContent:a,pstnContent:n.pstnContent,locationContent:n.getLocationContent(),networkContent:n.getNetworkContent(),areaContent:n.getAreaContent(),sharedLineCallInvitationContent:c.sharedLineCallInvitationContent,invitationData:c.invitationData,callQueueContext:c.callQueueContext}}if(n.signalingAgentConfig.ecsEtag&&(N.payload.debugContent={ecsEtag:n.signalingAgentConfig.ecsEtag}),u&&(N.payload.debugContent||(N.payload.debugContent={}),N.payload.debugContent.causeId=u),c.clientEndpointDebugContent){N.payload.debugContent||(N.payload.debugContent={});try{N.payload.debugContent.clientDebugContent=JSON.parse(c.clientEndpointDebugContent)}catch{Zs(!1,`Failed to parse ${c.clientEndpointDebugContent}`)}}if(c.captchaContentJson)try{N.payload.conversationRequest.captchaContent=JSON.parse(c.captchaContentJson)}catch{Zs(!1,`Failed to parse ${c.captchaContentJson}`)}return c.callQueueContext&&(N.payload.conversationRequest.callQueueContext=c.callQueueContext),c.participationPreferences&&(N.payload.participationPreferences=c.participationPreferences),c.participantPropertyBag&&(N.payload.participantPropertyBag=c.participantPropertyBag),N}function qi(n,a,s){return xn(n,"signalingSession cannot be null"),{payload:{from:{id:n.participantManager.localParticipant.id,displayName:n.participantManager.localParticipant.displayName,endpointId:n.participantManager.localParticipant.endpointId,participantId:n.participantManager.localParticipant.participantId,languageId:n.participantManager.localParticipant.languageId},..."meetingGroupId"in a&&{meetingGroup:a.meetingGroupId},..."meetingGroupLabel"in a&&{meetingGroupLabel:a.meetingGroupLabel},...a.groupPreferences&&{groupPreferences:a.groupPreferences},links:{joinMeetingGroupStatus:Vn(n,Fi.JOIN_MEETING_GROUP_STATUS)},operationId:s}}}function bn(n,a,s,c){xn(n,"signalingSession cannot be null"),X_(a);const u={payload:{participants:{from:{id:n.participantManager.localParticipant.id,displayName:n.participantManager.localParticipant.displayName,endpointId:n.participantManager.localParticipant.endpointId,participantId:n.participantManager.localParticipant.participantId,languageId:n.participantManager.localParticipant.languageId},scope:c&&c!=="all"?void 0:c},conversationTransactionEnd:{reason:"noError",code:ge.CALL_END_CODE.SUCCESS,phrase:ge.CALL_END_PHRASE.CONV_END_NO_MODALITY},callTransactionEnd:a}};return s&&a.code===ge.CALL_END_CODE.CANCEL&&(u.payload.callTransactionEnd.callQualityDiagnosticsInformation=s),u}function Wi(n,a,s){xn(n,"signalingSession cannot be null");const{meetingGroupId:c}=a;return{payload:{from:{id:n.participantManager.localParticipant.id,displayName:n.participantManager.localParticipant.displayName,endpointId:n.participantManager.localParticipant.endpointId,participantId:n.participantManager.localParticipant.participantId,languageId:n.participantManager.localParticipant.languageId},meetingGroup:c,links:{leaveMeetingGroupStatus:Vn(n,Fi.LEAVE_MEETING_GROUP_STATUS)},operationId:s}}}function ca(n,a,s){return xn(n,"signalingSession cannot be null"),xn(s,"newOfferLink cannot be null"),{payload:{mediaOfferRequirements:{compatibleContentTypes:a,links:{offerReady:Vn(n,Fi.NEW_MEDIA_OFFER)}}}}}function fr(n,a){return xn(a,"signalingSession cannot be null"),{payload:{callTransfer:{target:{id:a.participantManager.localParticipant.id},transferor:{details:{id:a.participantManager.localParticipant.id,endpointId:a.participantManager.localParticipant.endpointId,participantId:a.participantManager.localParticipant.participantId,languageId:a.participantManager.localParticipant.languageId},authorizationToken:null},parkType:n,links:{transferAcceptance:Vn(a,Fi.TRANSFER_ACCEPTANCE),transferCompletion:Vn(a,Fi.TRANSFER_COMPLETION)}}}}}function or(n,a,s){xn(n,"ParkRequestPayload: signalingSession cannot be null");const c={payload:{hold:{holdType:a,links:{holdCompletion:Vn(n,Fi.PARK_COMPLETION)}}}};return s&&(c.payload.debugContent=s),c}function Bo(n){return xn(n,"signalingSession cannot be null"),{payload:{callParticipantUpdate:{links:VG(n,nte),clientContentForMediaController:n.webRtcSignalingManager.getClientUrls()}}}}function rs(n,a,s,c,u,m){const b={payload:{from:{id:n.participantManager.localParticipant.id,displayName:n.participantManager.localParticipant.displayName,endpointId:n.participantManager.localParticipant.endpointId,participantId:n.participantManager.localParticipant.participantId,languageId:n.participantManager.localParticipant.languageId},publishedState:{content:c,level:s,stateType:a,sequenceNumber:n.getPublishStateSequenceNumber()},scope:u}};if(m&&m.length>0){const _=m.map(k=>({id:k}));b.payload.to=_}return b}function Bc(n,a){return xn(n,"signalingSession cannot be null"),X_(a),{payload:{callEnd:a}}}function cc(n,a,s,c){const u={from:{id:n.participantManager.localParticipant.id,displayName:n.participantManager.localParticipant.displayName,endpointId:n.participantManager.localParticipant.endpointId,participantId:n.participantManager.localParticipant.participantId,languageId:n.participantManager.localParticipant.languageId},sequenceNumber:n.getPublishStateSequenceNumber(),scope:a};return a==="specified"?u.stateIds=s:u.stateType=c,{payload:u}}function vp(n,a){return{payload:{from:{id:n.participantManager.localParticipant.id,displayName:n.participantManager.localParticipant.displayName,endpointId:n.participantManager.localParticipant.endpointId,participantId:n.participantManager.localParticipant.participantId,languageId:n.participantManager.localParticipant.languageId},searchOptions:a}}}function dc(n,a){return xn(n,"signalingSession cannot be null"),{payload:{from:{id:n.participantManager.localParticipant.id,endpointId:n.participantManager.localParticipant.endpointId,participantId:n.participantManager.localParticipant.participantId,languageId:n.participantManager.localParticipant.languageId,displayName:n.participantManager.localParticipant.displayName},...a,links:{setMeetingLayoutStatus:Vn(n,Fi.SET_MEETING_LAYOUT_STATUS)}}}}function zh(){return{payload:{transferAcceptance:{}}}}function Iv(n,a,s,c,u){return xn(a,"signalingSession cannot be null"),lc(n,"transferTarget cannot be null OR empty"),{payload:{callTransfer:{target:{id:n,endpointType:c==="TransferTypeVoicemail"?"voicemail":void 0},transferor:{details:{id:a.participantManager.localParticipant.id,endpointId:a.participantManager.localParticipant.endpointId,participantId:a.participantManager.localParticipant.participantId,languageId:a.participantManager.localParticipant.languageId},authorizationToken:null},links:{transferAcceptance:Vn(a,Fi.TRANSFER_ACCEPTANCE),transferCompletion:Vn(a,Fi.TRANSFER_COMPLETION)},replacementDetails:s,disableForwardingAndUnanswered:u&&u.disableForwardingAndUnanswered,transferContext:u&&u.clientTransferContext}}}}function If(n){return{payload:{transferCompletion:n}}}function $b(n,a){xn(n,"ResumePayload: signalingSession cannot be null");const s={payload:{resume:{links:{resumeCompletion:Vn(n,Fi.UNPARK_COMPLETION)}}}};return a&&(s.payload.debugContent=a),s}function Py(n,a){return xn(a,"clientMetadataJson cannot be null"),{payload:{participants:{from:{id:n.participantManager.localParticipant.id,displayName:n.participantManager.localParticipant.displayName,endpointId:n.participantManager.localParticipant.endpointId,participantId:n.participantManager.localParticipant.participantId,languageId:n.participantManager.localParticipant.languageId}},endpointMetadata:a}}}function Dy(n,a,s,c,u){xn(a,"clientStateJson cannot be null");const m={payload:{from:{id:n.participantManager.localParticipant.id,displayName:n.participantManager.localParticipant.displayName,endpointId:n.participantManager.localParticipant.endpointId,participantId:n.participantManager.localParticipant.participantId,languageId:n.participantManager.localParticipant.languageId},endpointState:a}};if(u)try{m.payload.captchaContent=JSON.parse(u)}catch{n.logger.warn("updateEndpointState getPayload() failed to parse captchaContentJson")}if(s?.publishedStates.length>0){let b=[];b=s.publishedStates.map(_=>{let k={};try{k=JSON.parse(_.content)}catch{n.logger.warn("updateEndpointState getPayload() failed to parse stateType.content")}return{stateType:_.type,level:_.level,content:k,sequenceNumber:n.getPublishStateSequenceNumber()}}),m.payload.publishedStates=b}return c&&(m.payload.links={updateEndpointStateStatus:Vn(n,Fi.DISABLE_PREHEAT_ASYNC_STATUS)}),m}function wv(n,a,s){xn(n,"signalingSession cannot be null");const{scope:c,toGroup:u,fromGroup:m,participants:b}=a;c==="specified"&&xn(b,"participantsIds cannot be null");const _={from:{id:n.participantManager.localParticipant.id,endpointId:n.participantManager.localParticipant.endpointId,participantId:n.participantManager.localParticipant.participantId,languageId:n.participantManager.localParticipant.languageId,displayName:n.participantManager.localParticipant.displayName},scope:c,fromGroup:m,toGroup:u,links:{updateMeetingGroupsStatus:Vn(n,Fi.UPDATE_MEETING_GROUPS_STATUS)},operationId:s};return b&&(_.to=b.map(k=>({id:k.mri,endpointId:k.endpointId,participantId:k.participantId}))),{payload:_}}function yw(n,a,s){return xn(n,"signalingSession cannot be null"),{payload:{from:{id:n.participantManager.localParticipant.id,endpointId:n.participantManager.localParticipant.endpointId,participantId:n.participantManager.localParticipant.participantId,languageId:n.participantManager.localParticipant.languageId,displayName:n.participantManager.localParticipant.displayName},meetingLiveState:a,links:{updateMeetingLiveStateStatus:Vn(n,Fi.UPDATE_MEETING_LIVE_STATE_STATUS)},operationId:s}}}function EN(n,a){const s={};return a.allowRaiseHands!==void 0&&(s.allowRaiseHands=a.allowRaiseHands),a.attendeeRestrictions!==void 0&&(s.attendeeRestrictions=a.attendeeRestrictions),a.lockMeeting!==void 0&&(s.lockMeeting=a.lockMeeting),a.breakoutRoomsEnabled!==void 0&&(s.breakoutRoomsEnabled=a.breakoutRoomsEnabled),a.allowPresentersToManageBreakoutRooms!==void 0&&(s.allowPresentersToManageBreakoutRooms=a.allowPresentersToManageBreakoutRooms),a.disableMdpClientAudioRecording!==void 0&&(s.disableMdpClientAudioRecording=a.disableMdpClientAudioRecording),a.refreshSettings!==void 0&&(s.refreshSettings=a.refreshSettings),a.aiInterpretationEnabled!==void 0&&(s.aiInterpretationEnabled=a.aiInterpretationEnabled),a.groupCopilotDetails!==void 0&&(s.groupCopilotDetails=a.groupCopilotDetails),{payload:{from:{id:n.participantManager.localParticipant.id,displayName:n.participantManager.localParticipant.displayName,endpointId:n.participantManager.localParticipant.endpointId,participantId:n.participantManager.localParticipant.participantId,languageId:n.participantManager.localParticipant.languageId},meetingSettings:s,sequenceNumber:n.getPublishStateSequenceNumber()}}}function F2(n,a,s,c){return xn(n,"signalingSession cannot be null"),{payload:{monitorContent:{sequenceId:n.getMonitorSequenceId(),monitorActionType:a,monitorData:s??{},links:{monitorCompletion:Vn(n,Fi.MONITOR_COMPLETION)}},debugContent:{causeId:c}}}}function eA(n){xn(n,"signalingSession cannot be null");const a={type:"Delta",rosterUpdate:Vn(n,CV.CONV_ROSTER_UPDATE)};return{payload:{participants:{from:{id:n.participantManager.localParticipant.id,displayName:n.participantManager.localParticipant.displayName,endpointId:n.participantManager.localParticipant.endpointId,participantId:n.participantManager.localParticipant.participantId,languageId:n.participantManager.localParticipant.languageId}},roster:a,links:VG(n,CV)}}}function rye(n,a,s){return xn(n,"signalingSession cannot be null"),{payload:{from:{id:n.participantManager.localParticipant.id,endpointId:n.participantManager.localParticipant.endpointId,participantId:n.participantManager.localParticipant.participantId},to:a,links:{updateParticipantPropertiesStatus:Vn(n,Fi.UPDATE_PARTICIPANT_PROPERTIES_STATUS)},operationId:s}}}function oye(n,a){return xn(n,"signalingSession cannot be null"),{payload:{mediaAnswer:{sender:{id:n.participantManager.localParticipant.id,displayName:n.participantManager.localParticipant.displayName,endpointId:n.participantManager.localParticipant.endpointId,participantId:n.participantManager.localParticipant.participantId,languageId:n.participantManager.localParticipant.languageId},mediaContent:a,pstnContent:n.pstnContent}}}}function jci(n,a){return xn(n,"signalingSession cannot be null"),{payload:{UpdateMediaDescriptions:{mediaDescriptions:a}}}}function Gci(n,a,s){return xn(n,"signalingSession cannot be null"),{payload:{from:{id:n.participantManager.localParticipant.id,endpointId:n.participantManager.localParticipant.endpointId,participantId:n.participantManager.localParticipant.participantId,languageId:n.participantManager.localParticipant.languageId,displayName:n.participantManager.localParticipant.displayName},meetingStates:a,updateMeetingStatesStatus:Vn(n,Fi.UPDATE_MEETING_STATES_STATUS),operationId:s}}}var qci=$i(dn),Wci=$i(Ro()),Kci=["CorrelationId","SignalingSessionId","Region","ParticipantId","ClientInformation","ResultCode","ResultDetail","ResultValue","Direction","ClientType","MeetingRoles"],Jci=class{constructor(n,a){this.signalingSession=n,this.logger=a,this.logConversationCallModalityEvent=s=>{const c=this.createCallModalityEvent(s);this.logger.info("sending modality telemetry:",this.getStringifiedEventData(c)),c.hostName=this.getHostDomainInfo(),this.telemetryLogger.sendEvent(ei.EVENT_TYPE.CONVERSATION_CALL_MODALITY,c)},this.logConversationContentSharingEvent=s=>{s[ei.CONTEXT_ID.CORRELATION_ID]=this.signalingSession.correlationId,s[ei.EXTENSIONS.ECS_ETAG]=this.signalingSession.signalingAgentConfig.ecsEtag,this.logger.info("sending content sharing telemetry:",this.getStringifiedEventData(s)),s.hostName=this.getHostDomainInfo(),this.telemetryLogger.sendEvent(ei.EVENT_TYPE.CONVERSATION_CONTENT_SHARING,s)},this.logHttpTelemetryEvent=s=>{s[ei.EXTENSIONS.ECS_ETAG]=this.signalingSession.signalingAgentConfig.ecsEtag,s[ei.SIGNALING_CONFIG]=this.getSignalingAgentConfig(),this.logger.info("sending http telemetry:",this.getStringifiedEventData(s)),s.hostName=this.getHostDomainInfo(),this.telemetryLogger.sendEvent(ei.EVENT_TYPE.CONVERSATION_HTTP_REQUEST,s)},this.getHostDomainInfo=()=>location.hostname==="localhost"||location.hostname==="127.0.0.1"?"localhost":"<redacted>",this.getSignalingAgentConfig=()=>{const s=[],c=this.signalingSession.signalingAgentConfig;return c.supportsCompressedServicePayload&&s.push(ei.SIGNALING_CONFIG_FLAGS.SUPPORTS_COMPRESSED_PAYLOAD),c.brokerEnabledOutgoing&&s.push(ei.SIGNALING_CONFIG_FLAGS.BROKER_OUTGOING_ENABLED),c.brokerEnabledIncoming&&s.push(ei.SIGNALING_CONFIG_FLAGS.BROKER_INCOMING_ENABLED),c.brokerRequestBatching&&s.push(ei.SIGNALING_CONFIG_FLAGS.BROKER_REQUEST_BATCHING_ENABLED),c.brokerExclusively&&s.push(ei.SIGNALING_CONFIG_FLAGS.BROKER_EXCLUSIVELY_ENABLED),c.supportsSynchronousTrouterResponse&&s.push(ei.SIGNALING_CONFIG_FLAGS.SYNC_TROUTER_RESPONSE),c.handleMediaOfferFromPushNotification&&s.push(ei.SIGNALING_CONFIG_FLAGS.HANDLE_OFFER_FROM_NOTIFICATION),c.handleNewOfferRequest&&s.push(ei.SIGNALING_CONFIG_FLAGS.HANDLE_NEW_OFFER_REQUEST),c.sendProgressFromCC&&s.push(ei.SIGNALING_CONFIG_FLAGS.SEND_PROGRESS_FROM_CC),c.useInternalHttpDispatcher&&s.push(ei.SIGNALING_CONFIG_FLAGS.INTERNAL_HTTP_DISPATCHER),c.enableTokenCache&&s.push(ei.SIGNALING_CONFIG_FLAGS.ENABLE_TOKEN_CACHE),c.enableTokenPrefetch&&s.push(ei.SIGNALING_CONFIG_FLAGS.ENABLE_TOKEN_PREFETCH),c.supportMediaRetargetWhileIncomingRenegotiation&&s.push(ei.SIGNALING_CONFIG_FLAGS.SUPPORT_MEDIA_RETARGET_WHILE_INCOMING_RENEGOTIATION),c.enableCallEstablishmentTimeoutsForStartJoinCall&&s.push(ei.SIGNALING_CONFIG_FLAGS.ENABLE_CALL_ESTABLISHMENT_TIMEOUTS_FOR_START_OR_JOIN_CALL),c.enableTokenCacheForGenericTokenAPI&&s.push(ei.SIGNALING_CONFIG_FLAGS.ENABLE_TOKEN_CACHE_FOR_GENERIC_TOKEN_API),c.enableLongOutgoing1To1SetupTimeoutForWeb&&s.push(ei.SIGNALING_CONFIG_FLAGS.ENABLE_LONG_OUTGOING_1TO1_SETUP),s.push(ei.SIGNALING_CONFIG_FLAGS.SERVER_MUTE_UNMUTE),s.join(",")},this.getStringifiedEventData=s=>{try{return JSON.stringify(s,Kci,4)}catch{return"invalid data"}},this.telemetryLogger=this.signalingSession.signalingAgentConfig.oneDsTelemetryLogger??this.signalingSession.signalingAgentConfig.telemetryManager}createCallModalityEvent(n){const a={};a.Type=ei.SOURCE.NGC_SOURCE;const s=(u,m=!1)=>{a[u]=m?JSON.stringify(n[u]):n[u]},c=(u,m=!1)=>{n.hasOwnProperty(u)&&s(u,m)};if(a.ResultDetail=n[ei.EXTENSIONS.RESULT_DETAIL],a.ResultValue=n[ei.EXTENSIONS.RESULT_VALUE],a.ResultCode=n[ei.EXTENSIONS.CALL_END_CODE],a.ResultCauseId=n[ei.EXTENSIONS.RESULT_CAUSE_ID],a[ei.SIGNALING_CONFIG]=this.getSignalingAgentConfig(),a[ei.CONTEXT_ID.CORRELATION_ID]=this.signalingSession.correlationId,a[ei.CONTEXT_ID.SIGNALING_SESSION_ID]=this.signalingSession.sessionId,s(ei.CONTEXT_ID.ENDPOINT_ID),s(ei.CONTEXT_ID.PARTICIPANT_ID),a[ei.EXTENSIONS.ECS_ETAG]=this.signalingSession.signalingAgentConfig.ecsEtag,s(ei.EXTENSIONS.CONVERSATION_SERVICE_URL),s(ei.EXTENSIONS.CALL_START_TIME,!0),s(ei.EXTENSIONS.CALL_END_TIME,!0),s(ei.EXTENSIONS.MESSAGING_CHANNEL,!0),a[ei.EXTENSIONS.IS_GROUP_CALL]=this.signalingSession.multiParty?"true":"false",a[ei.EXTENSIONS.IS_HOSTLESS_CALL]=this.signalingSession.isHostLessCall?"true":"false",a[ei.EXTENSIONS.IS_CAST_CALL]=this.signalingSession.isCastCall?"true":"false",a[ei.EXTENSIONS.IS_HUDDLE_GROUP_CALL]=this.signalingSession.isHuddleGroupCall?"true":"false",a[ei.EXTENSIONS.IS_ON_BEHALF_OF_CALL]=this.signalingSession.onBehalfOf?"true":"false",s(ei.EXTENSIONS.CLIENT_INFORMATION),s(ei.EXTENSIONS.IS_SDP_IN_CALL_NOTIFICATION),s(ei.EXTENSIONS.CALL_TERMINATING_END),s(ei.EXTENSIONS.CALL_END_CODE,!0),s(ei.EXTENSIONS.CALL_END_SUB_CODE,!0),c(ei.CONTEXT_ID.SHARED_CORRELATION_ID),c(ei.EXTENSIONS.DIRECTION),c(ei.EXTENSIONS.SELF_PARTICIPANT_ROLE),c(ei.EXTENSIONS.CONNECTED_DURATION_IN_MS,!0),c(ei.EXTENSIONS.TIME_TO_RING_IN_MS,!0),c(ei.EXTENSIONS.NETWORK_REQUESTS_COMPLETED),c(ei.EXTENSIONS.NETWORK_REQUESTS_PENDING),c(ei.EXTENSIONS.LOCAL_OPERATIONS_PERFORMED),c(ei.EXTENSIONS.EVENT_TIMESTAMP_BAG),c(ei.EXTENSIONS.ROSTER_UPDATES_BAG),c(ei.EXTENSIONS.NETWORK_REQUESTS_BAG),c(ei.EXTENSIONS.TROUTER_WAIT_OPERATIONS),c(ei.EXTENSIONS.LOCAL_OFFER_ANSWER_GENERATION_TIMESTAMPS),c(ei.EXTENSIONS.OUTGOING_MODALITIES),c(ei.EXTENSIONS.INCOMING_MODALITIES),c(ei.EXTENSIONS.OFFERED_MODALITIES),c(ei.EXTENSIONS.ANSWERED_MODALITIES),c(ei.EXTENSIONS.VBSS_OPERATIONS),c(ei.EXTENSIONS.CALLER_TYPE),c(ei.EXTENSIONS.CALLEE_TYPE),c(ei.EXTENSIONS.SCENARIO),c(ei.EXTENSIONS.PREHEATED_CALL_SETUP_DURATION_IN_S),c(ei.EXTENSIONS.CALL_CANCELATION_DURATION_IN_S),c(ei.EXTENSIONS.IS_PREHEATED),c(ei.EXTENSIONS.ACS_RESOURCE_ID),c(ei.EXTENSIONS.CALL_END_RESULT_CATEGORIES),c(ei.EXTENSIONS.APPLICATION_TYPE),c(ei.EXTENSIONS.RING),c(ei.EXTENSIONS.REGION),c(ei.EXTENSIONS.PARTITION),c(ei.EXTENSIONS.JOINED_FROM),c(ei.EXTENSIONS.MEETING_URL),c(ei.EXTENSIONS.MEETING_CODE),c(ei.EXTENSIONS.USER_HEX_CID),c(ei.EXTENSIONS.BROADCAST_MEETING_ROLE),c(ei.EXTENSIONS.MEETING_ROLE),c(ei.EXTENSIONS.ADVANCED_MEETING_ROLE),c(ei.EXTENSIONS.MEETING_ROLES,!0),c(ei.EXTENSIONS.PARTICIPANT_TYPE),c(ei.EXTENSIONS.DISPLAY_NAME),c(ei.EXTENSIONS.AUDIO_ONLY_WATERMARK),c(ei.EXTENSIONS.TARGET_APPLICATION_TYPE),c(ei.EXTENSIONS.IS_REINVITELESS),c(ei.EXTENSIONS.CLIENT_TYPE),c(ei.EXTENSIONS.CONFLICTING_CALL_ID),this.signalingSession.callType&&(a[ei.EXTENSIONS.CALL_TYPE]=this.signalingSession.callType),this.signalingSession.signalingAgentConfig.testCall&&(a[ei.EXTENSIONS.TEST_CONTEXT_ID]="Test"),this.signalingSession.groupId&&(a[ei.CONTEXT_ID.GROUP_ID]=kn(this.signalingSession.groupId)),this.signalingSession.threadId&&(a[ei.CONTEXT_ID.THREAD_ID]=Qu(this.signalingSession.threadId)),this.signalingSession.teamsMessageId&&(a[ei.CONTEXT_ID.TEAMS_MESSAGEID]=this.signalingSession.teamsMessageId),this.signalingSession.getMeetingInfo()){const u={...this.signalingSession.getMeetingInfo()};u.hasOwnProperty("organizerId")&&(u.organizerId=kn(u.organizerId)),a[ei.CONTEXT_ID.TEAMS_MEETINGINFO]=JSON.stringify(u)}return this.signalingSession.multiParty&&this.signalingSession.numberOfOriginalInvitees===0&&n.hasOwnProperty(ei.EXTENSIONS.SELF_PARTICIPANT_ROLE)&&n[ei.EXTENSIONS.SELF_PARTICIPANT_ROLE]===ei.ROLE.CALLER&&(a[ei.EXTENSIONS.IS_MEETUP_CALL]="true"),a}};function Yci(n,a){return new Jci(n,a)}var Qci=class{constructor(n,a,s){this.signalingSession=n,this.callStartTime=s,this.networkRequestsCompleted=[],this.networkRequestsStarted={},this.networkRequests={},this.localOperationsPerformed=[],this.recordedEvents=[],this.rosterUpdates=[],this.contentSharingOperationsPerformed={},this.outgoingModalities=[],this.incomingModalities=[],this.offeredModalities="",this.answeredModalities="",this.vbssOperations=[],this.vbssStarted=!1,this.localOfferAnswerGenerationTimestamps=[],this.trouterWaitOperations=[],this.telemetryData={},this.contentSharingBaseTelemetryData={},this.httpRequestTelemetryData={},this.connectedStopWatch=null,this.preheatedCallSetupDurationWatch=null,this.callCancelationDurationWatch=null,this.timeToRingStopWatch=null,this.isSdpInCallNotification=!1,this.isPreheated=0,this.isReinviteless=0,this.addBrokerChannel=()=>{this.setMessagingChannel(ei.MESSAGING_CHANNEL.BROKER)},this.addTrouterChannel=()=>{this.setMessagingChannel(ei.MESSAGING_CHANNEL.TROUTER)},this.addTrouterWaitOperation=c=>{this.trouterWaitOperations.push(this.recordOperation(c))},this.recordIncomingEvent=(c,u,m)=>{const b=Po(u),_={origin:u.origin,causeId:b,data:m};m||delete _.data,this.recordEvent(c,_)},this.recordIncomingEventCount=c=>{this.localOperationsPerformed.push(this.recordOperation(c));const u=this.recordedEvents.findIndex(m=>m[c]);if(u!==-1)this.recordedEvents[u][c]+=1;else{const m={};m[c]=1,this.recordedEvents.push(m)}},this.recordEvent=(c,u)=>{this.logger.debug("Event:",c,u),this.localOperationsPerformed.push(this.recordOperation(c));const m={};m[c]=this.timeSinceCallStart(),u&&(m.data=u),this.recordedEvents.push(m)},this.recordRosterEvent=(c,u,m)=>{this.localOperationsPerformed.push(this.recordOperation(u));const b={data:c,causeId:m},_={eventName:this.timeSinceCallStart(),data:b};this.rosterUpdates.push(_)},this.addOutgoingModalities=c=>{c&&this.outgoingModalities.push(c)},this.addIncomingModalities=c=>{c&&this.incomingModalities.push(c)},this.setOfferedModalities=(c,u)=>{this.offeredModalities=this.sdpTelemetryFormat(c,u)},this.setAnsweredModalities=(c,u)=>{this.answeredModalities=this.sdpTelemetryFormat(c,u)},this.setIsSdpInCallNotification=c=>{this.isSdpInCallNotification=c},this.addVbssOperations=c=>{c&&(c===ei.VBSS_OPERATION.START?this.vbssStarted=!0:this.vbssStarted=!1,this.vbssOperations.push(this.recordOperation(c)))},this.addNetworkOperationStarted=c=>{rte(this.networkRequestsStarted,c,this.recordOperation(c))},this.addNetworkOperationCompleted=(c,u,m)=>{const b=u?ei.RESULT_VALUE.SUCCESS:ei.RESULT_VALUE.FAILURE,_=m?`${c}:${b}:${m}`:`${c}:${b}`;this.networkRequestsCompleted.push(this.recordOperation(_)),mw(this.networkRequestsStarted,c)},this.updateNetworkRequest=c=>{this.networkRequests[c.uid]?qci.assign(this.networkRequests[c.uid],c):this.networkRequests[c.uid]=c},this.deleteNetworkRequest=c=>{delete this.networkRequests[c.uid]},this.addContentSharingOperation=(c,u,m)=>{this.contentSharingOperationsPerformed[c]||(this.contentSharingOperationsPerformed[c]=[]);const b={[u]:this.timeSinceCallStart()};this.contentSharingOperationsPerformed[c].push(b);const _=this.contentSharingOperationsPerformed[c].length-1;return m&&this.updateContentSharingOperation(c,_,m),_},this.updateContentSharingOperation=(c,u,m)=>{if(!this.contentSharingOperationsPerformed[c])return;const b=this.contentSharingOperationsPerformed[c][u],_=[];for(const k of Object.keys(m))_.push(`${k}: ${m[k]}`);b.data=_.join(", ")},this.setDirection=c=>{this.telemetryData[ei.EXTENSIONS.DIRECTION]=c},this.setEndPointId=c=>{this.telemetryData[ei.CONTEXT_ID.ENDPOINT_ID]=c,this.contentSharingBaseTelemetryData[ei.CONTEXT_ID.ENDPOINT_ID]=c,this.httpRequestTelemetryData[ei.CONTEXT_ID.ENDPOINT_ID]=c},this.setParticipantId=c=>{this.telemetryData[ei.CONTEXT_ID.PARTICIPANT_ID]=c,this.contentSharingBaseTelemetryData[ei.CONTEXT_ID.PARTICIPANT_ID]=c,this.httpRequestTelemetryData[ei.CONTEXT_ID.PARTICIPANT_ID]=c},this.addTokenTelemetry=(c,u)=>{c?this.networkRequests?.[c]?(this.networkRequests[c].tokenTelemetries||(this.networkRequests[c].tokenTelemetries=[]),this.networkRequests[c].tokenTelemetries.push(u)):this.logger.info(`[addTokenTelemtry] httprequest: ${c} is not found in networkRequests`):this.logger.error("[addTokenTelemetry] httprequest uid is undefined")},this.setConversationServiceUrl=c=>{this.telemetryData[ei.EXTENSIONS.CONVERSATION_SERVICE_URL]=c},this.setMeetingInfo=c=>{c||(this.telemetryData[ei.EXTENSIONS.MEETING_INFO]=c)},this.setJoinedFrom=c=>{this.telemetryData[ei.EXTENSIONS.JOINED_FROM]=c},this.setMeetingCode=c=>{this.telemetryData[ei.EXTENSIONS.MEETING_CODE]=c},this.setMeetingUrl=c=>{this.telemetryData[ei.EXTENSIONS.MEETING_URL]=c},this.setBroadcastMeetingRole=c=>{this.telemetryData[ei.EXTENSIONS.BROADCAST_MEETING_ROLE]=c},this.setMeetingRole=c=>{this.telemetryData[ei.EXTENSIONS.MEETING_ROLE]=c},this.setAdvancedMeetingRole=c=>{this.telemetryData[ei.EXTENSIONS.ADVANCED_MEETING_ROLE]=c},this.setParticipantType=c=>{this.telemetryData[ei.EXTENSIONS.PARTICIPANT_TYPE]=c},this.setSelfParticipantRole=c=>{this.telemetryData[ei.EXTENSIONS.SELF_PARTICIPANT_ROLE]=c},this.setDisplayName=c=>{const u=new _v(c,1);this.telemetryData[ei.EXTENSIONS.DISPLAY_NAME]=u},this.setAudioOnlyWatermark=c=>{this.telemetryData[ei.EXTENSIONS.AUDIO_ONLY_WATERMARK]=c},this.setWatermarkSupport=c=>{this.telemetryData[ei.EXTENSIONS.CLIENT_SUPPORT_WATERMARK]=c},this.setClientSupportsPreventScreenCapture=c=>{this.telemetryData[ei.EXTENSIONS.CLIENT_SUPPORTS_PREVENT_SCREEN_CAPTURE]=c},this.setScenario=c=>{this.telemetryData[ei.EXTENSIONS.SCENARIO]=c},this.setTargetApplicationType=c=>{c&&(this.telemetryData[ei.EXTENSIONS.TARGET_APPLICATION_TYPE]=c)},this.setCallerType=c=>{c&&(this.telemetryData[ei.EXTENSIONS.CALLER_TYPE]=c.split(":",1)[0])},this.setCalleeType=c=>{c&&(this.telemetryData[ei.EXTENSIONS.CALLEE_TYPE]=c.split(":",1)[0])},this.setTerminatingData=c=>{this.telemetryData[ei.EXTENSIONS.CALL_TERMINATING_END]=c.terminatingEnd,this.telemetryData[ei.EXTENSIONS.CALL_END_CODE]=c.endCode||ge.CALL_END_CODE.SUCCESS,this.telemetryData[ei.EXTENSIONS.CALL_END_SUB_CODE]=c.endSubCode||ge.CALL_END_SUB_CODE.SUCCESS,this.telemetryData[ei.EXTENSIONS.CALL_PHRASE]=c.phrase||ge.CALL_END_PHRASE.UNKNOWN,this.telemetryData[ei.EXTENSIONS.RESULT_VALUE]=c.resultValue||ei.RESULT_VALUE.SUCCESS,this.telemetryData[ei.EXTENSIONS.RESULT_DETAIL]=c.resultDetail||"Call gracefully hungup",this.telemetryData[ei.EXTENSIONS.RESULT_CAUSE_ID]=c.causeId||"unknown",this.telemetryData[ei.EXTENSIONS.CALL_END_RESULT_CATEGORIES]=c.resultCategories||[],this.telemetryData[ei.EXTENSIONS.CALL_END_CLIENT_SUB_CODE]=c.clientReasonSubCode,this.telemetryData[ei.EXTENSIONS.CALL_END_CLIENT_PHRASE]=c.clientReasonPhrase},this.startCallInitializationWatch=c=>{this.timeToRingStopWatch=US(),c&&(this.timeToRingStopWatch.msElapsed+=c)},this.startCallConnectedWatch=()=>{this.connectedStopWatch=US()},this.setIsPreheated=()=>{this.isPreheated=1},this.startPreheatedCallSetupDurationWatch=()=>{this.preheatedCallSetupDurationWatch=US()},this.stopPreheatedCallSetupDurationWatch=()=>{this.preheatedCallSetupDurationWatch.pause()},this.startCallCancelationDurationWatch=()=>{this.callCancelationDurationWatch=US()},this.stopCallCancelationDurationWatch=()=>{this.callCancelationDurationWatch&&this.callCancelationDurationWatch.pause()},this.getCallCancelationDuration=()=>this.callCancelationDurationWatch?this.callCancelationDurationWatch.durationInSeconds():0,this.resetCallCancelationDurationWatch=()=>{this.callCancelationDurationWatch=null},this.setOfferAnswerGenerationTimestamps=c=>{this.localOfferAnswerGenerationTimestamps.push(this.recordOperation(c))},this.setTimeToRingDuration=()=>{this.timeToRingStopWatch&&(this.telemetryData[ei.EXTENSIONS.TIME_TO_RING_IN_MS]=this.timeToRingStopWatch.duration(),this.timeToRingStopWatch=null)},this.dispose=()=>{this.sendCallModalityTelemetryData()},this.setMessagingChannel=c=>{this.telemetryData[ei.EXTENSIONS.MESSAGING_CHANNEL]||(this.telemetryData[ei.EXTENSIONS.MESSAGING_CHANNEL]=[]),this.telemetryData[ei.EXTENSIONS.MESSAGING_CHANNEL].some(u=>u.indexOf(c)!==-1)||this.telemetryData[ei.EXTENSIONS.MESSAGING_CHANNEL].push(this.recordOperation(c))},this.sendHttpTelemetryData=c=>{const u={...this.httpRequestTelemetryData};u[ei.CONTEXT_ID.CORRELATION_ID]=this.signalingSession.correlationId,u[ei.CONTEXT_ID.SIGNALING_SESSION_ID]=this.signalingSession.sessionId,u[ei.EXTENSIONS.CLIENT_INFORMATION]=this.signalingSession.signalingAgentConfig.clientInformation;const m=JSON.stringify({eventStart:this.callStartTime,events:this.networkRequests[c]});mw(this.networkRequests,c),u[ei.EXTENSIONS.NETWORK_REQUESTS_BAG]=m,this.telemetryLogger.logHttpTelemetryEvent(u)},this.sdpTelemetryFormat=(c,u)=>{if(!c)return"";const m=W=>{switch(W){case"main-audio":return"Audio";case"main-video":return"Video";case"applicationsharing-video":return"AppSharing";default:return}},b=W=>{switch(W){case"inactive":return"Inactive";case"sendonly":return u?"ReceiveFromPeer":"SendToPeer";case"recvonly":return u?"SendToPeer":"ReceiveFromPeer";default:return"Bidirectional"}},_={"main-audio":0,"main-video":0,"applicationsharing-video":0},k=[],N=Wci.parse(c);for(const W of N.media){const ee=m(W.label);if(!ee)continue;const oe=_[W.label]++,de=b(W.direction);k.push(`${ee}[${oe}] = ${de}`)}return k.join(", ")},this.setReinviteless=c=>{this.isReinviteless=c?1:0},this.logger=n.logger,this.telemetryLogger=Yci(n,this.logger),this.telemetryData[ei.EXTENSIONS.CALL_START_TIME]=this.callStartTime,this.telemetryData[ei.EXTENSIONS.CONVERSATION_SERVICE_URL]=n.signalingAgentConfig.conversationServiceUrl,this.fillCommonData(a,this.telemetryData),this.fillCommonData(a,this.httpRequestTelemetryData),this.fillCommonData(a,this.contentSharingBaseTelemetryData)}fillCommonData(n,a){a[ei.EXTENSIONS.APPLICATION_TYPE]=n.applicationType,a[ei.EXTENSIONS.RING]=n.ring,a[ei.EXTENSIONS.TENANT_ID]=n.tenantId,a[ei.EXTENSIONS.USER_HEX_CID]=n.userHexCID,a[ei.EXTENSIONS.ACS_RESOURCE_ID]=n.acsResourceId,a[ei.EXTENSIONS.REGION]=n.region,a[ei.EXTENSIONS.PARTITION]=n.partition,a[ei.EXTENSIONS.CLIENT_TYPE]=n.clientType}addChangingCorrelationId(n,a){this.telemetryData[ei.EXTENSIONS.CHANGING_CORRELATION_ID_OLD_ID]=n,this.telemetryData[ei.EXTENSIONS.CHANGING_CORRELATION_ID_NEW_ID]=a}addSharedCorrelationId(n){this.telemetryData[ei.CONTEXT_ID.SHARED_CORRELATION_ID]=n}setMeetingRoles(n){this.telemetryData[ei.EXTENSIONS.MEETING_ROLES]=n}setConflictingCallId(n){this.telemetryData[ei.EXTENSIONS.CONFLICTING_CALL_ID]=n}sendContentSharingTelemetryData(n,a,s,c,u,m){const b={...this.contentSharingBaseTelemetryData},_=this.contentSharingOperationsPerformed[n];_&&(b[ei.EXTENSIONS.EVENT_TIMESTAMP_BAG]=JSON.stringify(_)),b[ei.CONTEXT_ID.CONTENT_SHARING_CORRELATION_ID]=n,b[ei.CONTEXT_ID.SIGNALING_SESSION_ID]=a,b[ei.CONTEXT_ID.CONTENT_SHARING_ID]=m||"",b[ei.EXTENSIONS.CONTENT_SHARING_SERVICE_URL]=u,b[ei.EXTENSIONS.CONTENT_SHARING_DIRECTION]=s?ei.DIRECTION.OUTGOING:ei.DIRECTION.INCOMING,b[ei.EXTENSIONS.CALL_END_CODE]=c.code,b[ei.EXTENSIONS.CALL_END_SUB_CODE]=c.subCode,b[ei.EXTENSIONS.CALL_PHRASE]=c.phrase,b[ei.EXTENSIONS.CALL_END_RESULT_CATEGORIES]=this.getResultCategoryString(c.resultCategories),b[ei.EXTENSIONS.CALL_END_CAUSE_ID]=c.causeId,b[ei.EXTENSIONS.CLIENT_INFORMATION]=this.signalingSession.signalingAgentConfig.clientInformation,delete this.contentSharingOperationsPerformed[n],this.telemetryLogger.logConversationContentSharingEvent(b)}recordOperation(n){return`${n}:${this.timeSinceCallStart()}`}timeSinceCallStart(){return new Date().getTime()-this.callStartTime}sendCallModalityTelemetryData(){this.vbssStarted&&this.addVbssOperations(ei.VBSS_OPERATION.CALL_END);const n=s=>typeof s=="number"?s/1e3:0;if(this.telemetryData[ei.EXTENSIONS.CLIENT_INFORMATION]=this.signalingSession.signalingAgentConfig.clientInformation,this.telemetryData[ei.EXTENSIONS.CALL_END_TIME]=new Date().getTime(),this.connectedStopWatch&&(this.telemetryData[ei.EXTENSIONS.CONNECTED_DURATION_IN_MS]=this.connectedStopWatch.duration()),this.telemetryData[ei.EXTENSIONS.IS_PREHEATED]=this.isPreheated,this.preheatedCallSetupDurationWatch&&(this.telemetryData[ei.EXTENSIONS.PREHEATED_CALL_SETUP_DURATION_IN_S]=n(this.preheatedCallSetupDurationWatch.duration())),this.callCancelationDurationWatch&&(this.telemetryData[ei.EXTENSIONS.CALL_CANCELATION_DURATION_IN_S]=n(this.callCancelationDurationWatch.duration())),this.networkRequestsCompleted.length&&(this.telemetryData[ei.EXTENSIONS.NETWORK_REQUESTS_COMPLETED]=JSON.stringify(this.networkRequestsCompleted)),this.localOperationsPerformed.length&&(this.telemetryData[ei.EXTENSIONS.LOCAL_OPERATIONS_PERFORMED]=JSON.stringify(this.localOperationsPerformed)),this.trouterWaitOperations.length&&(this.telemetryData[ei.EXTENSIONS.TROUTER_WAIT_OPERATIONS]=JSON.stringify(this.trouterWaitOperations)),this.localOfferAnswerGenerationTimestamps.length&&(this.telemetryData[ei.EXTENSIONS.LOCAL_OFFER_ANSWER_GENERATION_TIMESTAMPS]=JSON.stringify(this.localOfferAnswerGenerationTimestamps)),this.incomingModalities.length&&(this.telemetryData[ei.EXTENSIONS.INCOMING_MODALITIES]=JSON.stringify(this.incomingModalities)),this.outgoingModalities.length&&(this.telemetryData[ei.EXTENSIONS.OUTGOING_MODALITIES]=JSON.stringify(this.outgoingModalities)),this.offeredModalities.length&&(this.telemetryData[ei.EXTENSIONS.OFFERED_MODALITIES]=this.offeredModalities),this.answeredModalities.length&&(this.telemetryData[ei.EXTENSIONS.ANSWERED_MODALITIES]=this.answeredModalities),this.telemetryData[ei.EXTENSIONS.CALL_END_RESULT_CATEGORIES]=this.getResultCategoryString(this.telemetryData[ei.EXTENSIONS.CALL_END_RESULT_CATEGORIES]),this.telemetryData[ei.EXTENSIONS.IS_SDP_IN_CALL_NOTIFICATION]=this.isSdpInCallNotification.toString(),this.vbssOperations.length&&(this.telemetryData[ei.EXTENSIONS.VBSS_OPERATIONS]=JSON.stringify(this.vbssOperations)),this.recordedEvents.length){const s=JSON.stringify({eventStart:this.callStartTime,events:this.recordedEvents});this.telemetryData[ei.EXTENSIONS.EVENT_TIMESTAMP_BAG]=s}if(this.rosterUpdates.length){const s=JSON.stringify({eventStart:this.callStartTime,events:this.rosterUpdates});this.telemetryData[ei.EXTENSIONS.ROSTER_UPDATES_BAG]=s}const a=[];for(const s of Object.keys(this.networkRequestsStarted))a.push(this.networkRequestsStarted[s]);a.length>0&&(this.telemetryData[ei.EXTENSIONS.NETWORK_REQUESTS_PENDING]=JSON.stringify(a)),this.telemetryData[ei.EXTENSIONS.IS_REINVITELESS]=this.isReinviteless,this.telemetryLogger.logConversationCallModalityEvent(this.telemetryData)}getResultCategoryString(n){return n&&Array.isArray(n)?n.join(","):""}},Zci=class{constructor(n,a){this.disposed=!1,this.lastSeenSeqNumbers={},this.isDominantSpeakerInfoLinkEnabled=!0,this.clientUrlsGenerated=!1,this.getClientUrls=()=>{this.clientUrlsGenerated=!0;let s=null;return this.isWebRtcCall&&(s={controlVideoStreaming:Vn(this.signalingSession,Fi.CONTROL_VIDEO_STREAMING),csrcInfo:Vn(this.signalingSession,Fi.CSRC_INFO)},this.isDominantSpeakerInfoLinkEnabled&&(s.dominantSpeakerInfo=Vn(this.signalingSession,Fi.DOMINANT_SPEAKER_INFO))),s},this.handleDominantSpeakerInfo=s=>{const c=s.body;this.logger.debug("handleDominantSpeakerInfo : ",fi(c)),this.signalingSession.telemetryHelper.recordIncomingEventCount(Ft.HANDLE_DOMINANT_SPEAKER_CHANGED_COUNT),this.handleWebRtcNotification(ge.WEBRTC_NOTIFICATION_TYPE.DOMINANT_SPEAKER_INFO,c.dominantSpeakerInformation)},this.handleControlVideoStreaming=s=>{const c=s.body;this.logger.debug("handleControlVideoStreaming: ",fi(c)),this.signalingSession.telemetryHelper.recordIncomingEvent(Ft.HANDLE_CONTROL_VIDEO_STREAMING,s),this.handleWebRtcNotification(ge.WEBRTC_NOTIFICATION_TYPE.CONTROL_VIDEO_STREAMING,c.controlVideoStreaming,!1)},this.handleCsrcInfo=s=>{const c=s.body;this.logger.debug("handleCsrcInfo : ",fi(c)),this.signalingSession.telemetryHelper.recordIncomingEvent(Ft.HANDLE_CSRC_INFO,s),this.handleWebRtcNotification(ge.WEBRTC_NOTIFICATION_TYPE.CSRC_INFO,c.csrcInfo)},this.sendWebRtcMediaNotificationAsync=({operation:s,requestUrl:c,requestBody:u,stackRetry:m=!0},b)=>{this.logger.info("sendWebRtcMediaNotificationAsync"),Zs(this.isWebRtcCall,"this is not a webrtc call"),lc(c,"correct media notification requestUrl is not provided"),lc(u,"media notification requestBody cannot be null or empty");const _=Pl(),k={url:c,payload:{payload:u},requestName:s,withoutTrouter:!0,causeId:b};return m||(k.disableRetry=!0),this.signalingSession.http.sendPostRequest(k).then(()=>{this.disposed||_.resolve()}).catch(N=>{const W=fi(N);if(this.logger.error(`sendWebRtcMediaNotificationAsync failed because : ${W}`),!this.disposed){const ee=new Error(N);ee.endCode=ge.CALL_END_NETWORK_ERROR,_.reject(ee)}}),_.promise},this.dispose=()=>{this.logger.info("WebRtcSignalingManager :: dispose"),this.disposed=!0},this.signalingSession=n,this.signalingSessionCallback=a,this.isWebRtcCall=n.signalingAgentConfig.isWebRtcEnabled,this.logger=n.logger,this.lastSeenSeqNumbers[ge.WEBRTC_NOTIFICATION_TYPE.CONTROL_VIDEO_STREAMING]=-1,this.lastSeenSeqNumbers[ge.WEBRTC_NOTIFICATION_TYPE.DOMINANT_SPEAKER_INFO]=-1,this.lastSeenSeqNumbers[ge.WEBRTC_NOTIFICATION_TYPE.CSRC_INFO]=-1}areClientURLsGenerated(){return this.clientUrlsGenerated}getIsDominantSpeakerInfoLinkEnabled(){return this.isDominantSpeakerInfoLinkEnabled}setIsDominantSpeakerInfoLinkEnabled(n){this.isDominantSpeakerInfoLinkEnabled=n}handleWebRtcNotification(n,a,s=!0){Zs(this.isWebRtcCall,"ignoring message in non-webrtc call");const c=this.lastSeenSeqNumbers[n];s&&a.sequenceNumber<=c?this.logger.info(`ignoring ${n} . Last seen seq = ${c} current seq = ${a.sequenceNumber}`):(a.sequenceNumber<=c&&this.logger.info(`let listener to handle older ${n} . Last seen seq = ${c} current seq = ${a.sequenceNumber}`),this.lastSeenSeqNumbers[n]=Math.max(a.sequenceNumber,this.lastSeenSeqNumbers[n]),this.signalingSessionCallback.onWebRtcMediaNotification(n,a))}},Xci=class{constructor(n,a,s,c,u,m){this.disposed=!1,this.convSubject=null,this.groupId=null,this.threadId=null,this.incomingCallCallerId=null,this.incomingCallPayload=null,this.multiParty=!0,this.isIncomingCall=!1,this.isHostLessCall=!1,this.isCastCall=!1,this.isHuddleGroupCall=!1,this.numberOfOriginalInvitees=0,this.teamsMessageId=null,this.enableGroupCallMeetupGeneration=!1,this.meetingInfo=null,this.meetingDetails=null,this.emergencyContent=null,this.transferContext=null,this.callType="default",this.callMode=0,this.transferor=null,this.onBehalfOf=null,this.onBehalfOfUserDisplayName=null,this.callQueueContext=null,this.callQueueSupervisorContent=null,this.bannerContent=null,this.callPhoneLineType=null,this.endpointMetadata={},this.sessionId=My(),this.remoteCaller=null,this.acceptedElsewhereBy=null,this.parkAdditionalContextJson=null,this.serverHoldLocation=null,this.breakoutDetails=null,this.callLimits=null,this.complianceRecordingContent=null,this.backroomThreadId=null,this.streamThreadId=null,this.lobbyThreadId=null,this.conversationStartTime=null,this.meetingLayoutDetails=null,this.compositionServiceDetails=null,this.realTimeState=0,this.disposing=!1,this.links={},this.provisionalMediaAnswersSeenSoFar=[],this.incomingTrouterMessagesSeenSoFar=[],this.incomingBrokerMessagesSeenSoFar=[],this.currentCallStatus=null,this.fsmState=ge.SIGNALING_FSM_STATE.IDLE,this.convJoined=!1,this.keepAliveTimer=null,this.keepAliveInterval=null,this.keepAliveCount=1,this.conversationKeepAliveTimer=null,this.conversationKeepAliveInterval=null,this.conversationKeepAliveCount=1,this.remoteUser=null,this.mediaTypesToUse=null,this.lastUsedOutgoingMediaContent=null,this.lastUsedJoinCallOptions=null,this.originalRoleBeforePreheat="",this.endpointStateSequenceNumber=0,this.publishStateSequenceNumber=0,this.monitorSequenceId=0,this.requestedPublishedStatesWhileConnecting=null,this.linkUpdateRequested={conversationLinks:!1,keepAliveLinks:!1},this.incomingMessageSyncResponseCache={},this.isPreheatOnly=!1,this.callStartTime=new Date().getTime(),this.callUsesMixer=!1,this.disablePreheatDefer=Pl(),this.participantReplacementDetails={},this.meetingLiveStateSequenceNumber=0,this.meetingLayoutSequenceNumber=0,this.localParticipantUpdateSequenceNumber=0,this.isRedirectAllowed=!1,this.updateSequenceNumber=-1,this.isPromotingToRealtime=!1,this.streamInformationReceived=!1,this.startOrJoinConvResponseReceived=!1,this.updateParticipantsPromises={},this.updateEndpointState=(b,_=tr(),k,N)=>{this.logger.info(`[${_}][requestedEndpointState=${fi(b,!0)}][captchaContentJson=${N}]`);const W=this.links[ge.LINKS.UPDATE_ENDPOINT_STATE],ee=this.getEndpointState();this.logger.info(`[${_}][currentEndpointState=${fi(ee,!0)}] startOrJoinConvResponseReceived=${this.startOrJoinConvResponseReceived}`);const oe={...ee,...b,endpointStateSequenceNumber:++this.endpointStateSequenceNumber};this.telemetryHelper.recordEvent(Ft.UPDATE_ENDPOINT_STATE,{newEndpointState:oe,causeId:_});const de=oe?.endpointProperties?.preheatProperties===0&&this.isPreheatOnly;if(de&&(this.telemetryHelper.recordEvent(Ft.PREHEAT_DISABLING,{causeId:_}),this.telemetryHelper.startPreheatedCallSetupDurationWatch(),this.telemetryHelper.startCallCancelationDurationWatch()),this.callMode===2&&de)return this.logger.info(`[${_}][updateEndpointState skipped as mode is streaming]`),this.handleEndpointStateUpdated(_,!0),Promise.resolve();if(!this.startOrJoinConvResponseReceived)return this.logger.info(`[${_}][updateEndpointState will be queued as we don't have a link yet]`),this.requestedEndpointStateWhileConnecting=b,this.requestedPublishedStatesWhileConnecting=k,de?this.disablePreheatDefer.promise:Promise.resolve();if(!this.shouldUpdateEndpointState(ee,oe)&&!this.http.hasPendingRequest($n.UPDATE_ENDPOINT_STATE.name))return this.logger.info(`[${_}][updateEndpointState will ignore current update as there is nothing new to send]`),Promise.resolve();if(!W)return this.logger.info(`[${_}][updateEndpointState operation cannot be performed now, the link is not yet available]`),Promise.reject("No link");this.latestEndpointState=oe;const se=this.signalingAgentConfig.enableAsyncDisablePreheat&&de;se&&this.timeoutManager.startTimer(ge.TIMEOUT_OPERATIONS.DISABLE_PREHEAT_ASYNC_TIMEOUT,()=>{const ue={code:ge.CALL_END_CODE.TIMEOUT,subCode:ge.CALL_END_SUB_CODE.DISABLE_PREHEAT_TIMEOUT,phrase:ge.CALL_END_PHRASE.DISABLE_PREHEAT_TIMEOUT};this.disablePreheatDefer.isPending()&&this.disablePreheatDefer.reject({response:ue})},ge.TIMEOUT_VALUES_IN_SECONDS.DISABLE_PREHEAT_TIMEOUT);const Re=this.http.sendPostRequest({url:W,requestName:$n.UPDATE_ENDPOINT_STATE.name,payload:Dy(this,oe,k,se,N),causeId:_}).then(()=>(se&&(this.logger.info(`[${_}][updateEndpointState] asyncDisablePreheat: true`),this.telemetryHelper.recordEvent(Ft.DISABLE_PREHEAT_RESPONSE_RECEIVED,{causeId:_})),Promise.resolve())).catch(ue=>{if(!se)throw ue;this.disablePreheatDefer.reject(ue)});return(se?this.disablePreheatDefer.promise:Re).then(()=>{this.logger.info(`[${_}][updateEndpointState] asyncDisablePreheat: ${se}`),this.telemetryHelper.recordEvent(se?Ft.ASYNC_DISABLE_PREHEAT_SUCCEEDED:Ft.DISABLE_PREHEAT_SUCCEEDED,{causeId:_}),this.disposed||this.handleEndpointStateUpdated(_,de)}).catch(ue=>{const Ne=Lr(ue,this.signalingAgentConfig);return this.logger.info(`[${_}][updateEndpointState] error: ${fi(Ne)}`),de&&(this.handleDisablePreheatError(Ne.error,se?Ft.ASYNC_DISABLE_PREHEAT_FAILED:Ft.DISABLE_PREHEAT_FAILED,_),this.stopCallPreheatTimer(),this.terminateEstablishedCall({code:Ne.error.code,subCode:Ne.error.subCode,phrase:Ne.error.phrase},{forEveryone:!1,causeId:_})),Promise.reject(Ne.error)})},this.setParticipantCallLinks=b=>{b&&b.endpointDetails&&(this.participantReplacementDetails[b.id]={},b.endpointDetails.forEach(_=>{_&&_.callLinks&&(this.participantReplacementDetails[b.id][_.participantId]=_.callLinks)}))},this.clearParticipantCallLinks=b=>{this.participantReplacementDetails?.hasOwnProperty(b)&&delete this.participantReplacementDetails[b]},this.getReplacementDetailsByParticipantLeg=(b,_,k=tr())=>(this.logger.info(`[${k}]getReplacementDetailsByParticipantLeg: participantMri ${this.piiUtils.scrubMriOrOmit(b)} participantLegId ${_}`),this.participantReplacementDetails?.hasOwnProperty(b)&&this.participantReplacementDetails[b].hasOwnProperty(_)?{replaces:this.participantReplacementDetails[b][_].replacement,replacementTargetParticipantId:_}:(this.logger.info(`[${k}]getReplacementDetailsByParticipantLeg: unable to find replacement details for participantLegId ${_}`),{})),this.getReplacementDetailsByParticipantLegOfCall=(b,_,k,N=tr())=>{this.logger.info(`[${N}]getReplacementDetailsByParticipantLegOfCall: callId ${b} participantMri ${this.piiUtils.scrubMriOrOmit(_)} participantLegId ${k}`);const W=this.signalingAgent.getSignalingSession(b);return W?W.getReplacementDetailsByParticipantLeg(_,k,N):{}},this.getMriByParticipantLegOfCall=(b,_,k)=>{this.logger.info(`[${k}]getMriByParticipantLegOfCall: callId: ${b} participantLegId ${_}`);const N=this.signalingAgent.getSignalingSession(b);return N?N.getMriByParticipantLeg(_,k):""},this.getMriByParticipantLeg=(b,_)=>{this.logger.info(`getMriByParticipantLeg[${_}] participantLegId ${b}`);for(const k of Object.keys(this.participantReplacementDetails))if(k&&this.participantReplacementDetails.hasOwnProperty(k)&&this.participantReplacementDetails[k]?.hasOwnProperty(b))return k;return""},this.handleEndpointStateUpdated=(b,_)=>{this.requestedEndpointStateWhileConnecting=null,this.requestedPublishedStatesWhileConnecting=null,_&&this.handlePreheatDisabled(b)},this.handlePreheatDisabled=b=>{this.isPreheatOnly=!1,this.telemetryHelper.setSelfParticipantRole(this.originalRoleBeforePreheat),this.telemetryHelper.recordEvent(Ft.PREHEAT_DISABLED,{causeId:b}),this.telemetryHelper.resetCallCancelationDurationWatch(),this.telemetryHelper.stopPreheatedCallSetupDurationWatch(),this.telemetryHelper.startCallConnectedWatch(),this.stopCallPreheatTimer(),this.disablePreheatDefer.isPending()&&this.disablePreheatDefer.resolve()},this.shouldUpdateEndpointState=(b,_)=>{if(!_)return!1;const k=_.state&&_.state.isMuted?1:0,N=_.endpointProperties&&_.endpointProperties.preheatProperties===1?1:0,W=b&&b.state&&b.state.isMuted?1:0,ee=b&&b.endpointProperties&&b.endpointProperties.preheatProperties===1?1:0,oe=b?.endpointProperties?.additionalEndpointProperties,de=_?.endpointProperties?.additionalEndpointProperties;return!!(k^W||N^ee||de!==oe)},this.setInitialTelemetry=(b,_)=>{let k,N;switch(b){case"Subscribe":this.telemetryHelper.recordEvent(Ft.JOIN_CONVERSATION_WITHOUT_CALL_MODALITY,{causeId:_.causeId,correlationId:_.correlationId}),this.telemetryHelper.setDirection(ei.DIRECTION.OUTGOING),this.telemetryHelper.setSelfParticipantRole(ei.ROLE.JOIN_FOR_ROSTER_ONLY),this.telemetryHelper.setConversationServiceUrl(_.conversationServiceUrl||this.signalingAgentConfig.conversationServiceUrl),this.telemetryHelper.setCallerType(this.participantManager.localParticipant.id);break;case"Acknowledge":this.telemetryHelper.recordEvent(Ft.HANDLE_INCOMING_CALL,{causeId:_.causeId}),this.telemetryHelper.setDirection(ei.DIRECTION.INCOMING),this.telemetryHelper.setSelfParticipantRole(ei.ROLE.CALLEE),this.telemetryHelper.setCalleeType(this.participantManager.localParticipant.id);break;case"JoinCall":k=this.gatherTelemetryForStartOrJoin(_.joinCallOptions,_.causeId,_.offerGenerationTime),this.telemetryHelper.recordEvent(Ft.JOIN_CALL,k),this.telemetryHelper.setDirection(ei.DIRECTION.OUTGOING),this.telemetryHelper.setSelfParticipantRole(ei.ROLE.JOIN);break;case"StartCall":case"StartCallToVoiceMail":case"StartCallWithNudge":case"StartCallAndUnpark":N=this.gatherTelemetryForStartOrJoin(_.callStartOptions,_.causeId,_.offerGenerationTime),this.telemetryHelper.recordEvent(Ft.START_CALL,N),this.telemetryHelper.setDirection(ei.DIRECTION.OUTGOING),this.telemetryHelper.setSelfParticipantRole(ei.ROLE.CALLER),this.telemetryHelper.startCallInitializationWatch(_.offerGenerationTime),this.telemetryHelper.setMeetingInfo(this.getMeetingInfo())}},this.getParticipantIdForOfferAnswer=b=>{xn(b,"mediaContent should be a non null value"),this.logger.info("getParticipantIdForOfferAnswer");let _=null;return!this.remoteUser||this.groupId||this.threadId||b.newOffer||b.escalationOccurring||(_=this.remoteUser.id),_},this.getMeetingInfo=()=>this.meetingInfo,this.getEmergencyContent=()=>(this.telemetryHelper.recordEvent(Ft.GET_EMERGENCY_CONTENT),this.emergencyContent),this.getEndpointId=()=>this.signalingAgent.endpointId,this.getConversationUrl=()=>this.links[ge.LINKS.CONVERSATION_CONTROLLER],this.setJoinedFrom=b=>{!this.disposed&&b&&(this.telemetryHelper.recordEvent(Ft.SET_JOINED_FROM),this.telemetryHelper.setJoinedFrom(b))},this.setMeetingCode=b=>{!this.disposed&&b&&this.telemetryHelper.setMeetingCode(b)},this.setMeetingUrl=b=>{!this.disposed&&b&&this.telemetryHelper.setMeetingUrl(b)},this.setSubject=b=>{this.disposed||(this.telemetryHelper.recordEvent(Ft.SET_SUBJECT),xn(b,"subject should be a non null value"),this.convSubject=b)},this.setDeviceType=b=>{this.disposed||(this.telemetryHelper.recordEvent(Ft.SET_DEVICETYPE),b&&(this.deviceType=b,this.logger.info("setDeviceType",this.deviceType)))},this.setOfferAnswerGenerationTimestamps=b=>{this.disposed||this.telemetryHelper.setOfferAnswerGenerationTimestamps(b)},this.setTimeToRingDuration=()=>{this.disposed||this.telemetryHelper.setTimeToRingDuration()},this.setGroupId=b=>{this.telemetryHelper.recordEvent(Ft.SET_GROUPID),this.groupId!==b&&b&&(Zs(!this.groupId,"conversation groupId has already been set. It cannot be overwritten"),this.groupId=b)},this.setThreadId=b=>{this.telemetryHelper.recordEvent(Ft.SET_THREADID),xn(b,"threadId should be a non null value"),this.threadId!==b&&(Zs(!this.threadId,"conversation threadId has already been set. It cannot be overwritten"),this.threadId=b)},this.setDisplayName=b=>{!this.disposed&&b&&this.telemetryHelper.setDisplayName(b)},this.setCallOptions=b=>{if(xn(b,"callOptions should be a non null value"),this.logger.info("setCallOptions",fi(b)),this.telemetryHelper.recordEvent(Ft.SET_CALLOPTIONS),b){this.teamsMessageId=b.teamsMessageId,this.meetingInfo=b.meetingInfo||null,this.emergencyContent=b.emergencyContent||null,this.enableGroupCallMeetupGeneration=b.enableGroupCallMeetupGeneration||!1,b.broadcastContext&&(this.broadcastSession=new RV(this,this.signalingSessionCallback),this.broadcastSession.setContext(b.broadcastContext));try{this.endpointMetadata=JSON.parse(b.endpointMetadata)}catch{this.logger.warn("Unable to parse endpoint metadata")}}},this.setTransferContext=b=>{xn(b,"transferContext should not be null"),this.logger.info("Transfer: setTransferContext",xS(b)),this.telemetryHelper.recordEvent(Ft.SET_TRANSFER_CONTEXT),this.transferContext=b},this.muteAsync=(b,_,k=tr())=>(Zs(this.callMode!==2||b!==ge.MUTE_SCOPE.MYSELF,"mute self operation is not allowed in streaming mode"),this.logger.info(`[${k}][muteAsync][scope=${b}]`),this.telemetryHelper.recordEvent(Ft.MUTE,{causeId:k}),Zs(this.fsmState===ge.SIGNALING_FSM_STATE.CONNECTED,`[${k}]mute operation for all or specified only allowed in a connected call`),this.participantManager.muteAsync(this.links[ge.LINKS.MUTE],b,_,k)),this.unmuteAsync=(b=tr())=>(Zs(this.callMode!==2,"unmute operation is not allowed in streaming mode"),this.logger.info(`[${b}][unmuteAsync]`),this.telemetryHelper.recordEvent(Ft.UNMUTE,{causeId:b}),Zs(this.fsmState===ge.SIGNALING_FSM_STATE.CONNECTED,"unmute operation only allowed in a connected call"),this.participantManager.unmuteAsync(this.links[ge.LINKS.UNMUTE],b)),this.recordTelemetryForStartAudio=(b,_)=>(this.telemetryHelper.recordEvent(Ft.START_AUDIO,{mediaNegotiationStatus:b,causeId:_}),Promise.resolve(null)),this.recordTelemetryForStopAudio=(b,_)=>(this.telemetryHelper.recordEvent(Ft.STOP_AUDIO,{mediaNegotiationStatus:b,causeId:_}),Promise.resolve(null)),this.rejectUnmuteRequestAsync=(b,_=tr(),k)=>(Zs(this.fsmState===ge.SIGNALING_FSM_STATE.CONNECTED,"rejectUnmute operation only allowed in a connected call"),lc(b,"requestor must be specified"),this.logger.info(`[${_}][rejectUnmuteRequestAsync][rejectionReason=${k}]`),this.telemetryHelper.recordEvent(Ft.REJECT_UNMUTE,{causeId:_,rejectionReason:k}),this.participantManager.rejectUnmuteRequestAsync(b,_,k)),this.approveUnmuteRequestAsync=(b,_=tr())=>(Zs(this.fsmState===ge.SIGNALING_FSM_STATE.CONNECTED,"approveUnmute operation only allowed in a connected call"),lc(b,"requestor must be specified"),this.logger.info(`[${_}][approveUnmuteRequestAsync]`),this.telemetryHelper.recordEvent(Ft.APPROVE_UNMUTE,{causeId:_}),this.participantManager.approveUnmuteRequestAsync(b,_)),this.sendWebRtcMediaNotificationAsync=(b,_,k=tr())=>(Zs(this.callMode!==2,"sendWebRtcMediaNotification operation is not allowed in streaming mode"),Zs(this.fsmState===ge.SIGNALING_FSM_STATE.CONNECTED,"webRtc media notification can only be sent in a connected call"),this.telemetryHelper.recordEvent(Ft.SEND_WEBRTC_MEDIA_NOTIFICATION,{causeId:k}),b===0?this.webRtcSignalingManager.sendWebRtcMediaNotificationAsync({operation:$n.SEND_APPLY_CHANNEL_PARAMETERS.name,requestUrl:this.links[ge.LINKS.APPLY_CHANNEL_PARAMETERS],requestBody:_,stackRetry:!1},k):this.webRtcSignalingManager.sendWebRtcMediaNotificationAsync({operation:$n.SEND_CONTROL_VIDEO_STREAMING.name,requestUrl:this.links[ge.LINKS.CONTROL_VIDEO_STREAMING],requestBody:_},k)),this.addParticipantsAsync=(b,_,k=tr())=>{lc(b,"remoteParticipants should be a non null value"),Zs(this.isCallOngoing()||this.isCallNotConnected(),"remoteParticipants can only be added before starting an outgoing call or to an ongoing call"),this.logger.info(`[${k}][addParticipantsAsync][addParticipantOptions=${fi(_)}]
            [remoteParticipantId=${b.map(oe=>this.piiUtils.scrubMriOrOmit(oe.id))}]`);let N=Ft.ADD_PARTICIPANT;switch(_.replacementType){case 2:N=Ft.ADD_PARTICIPANT_WITH_PICKUP_CODE;break;case 1:case 3:N=Ft.ADD_PARTICIPANT_WITH_REPLACES;break;default:N=Ft.ADD_PARTICIPANT}this.telemetryHelper.recordEvent(N,{causeId:k}),_.groupId=this.groupId||_.groupId,_.threadId=this.threadId||_.threadId;const W=_.threadId||_.groupId?this.links[ge.LINKS.ADD_PARTICIPANTS_AND_MODALITY]:this.links[ge.LINKS.ADD_PARTICIPANT],ee=this.participantManager.addParticipantsAsync(b,W,this.isCallConnectedOrConnectedForRoster(),_,k);return this.currentCallStatus||this.setMultiParty(this.participantManager.getParticipantsToInitiateCallWith().length!==1,k),ee},this.addGroupModalityAsync=(b,_)=>{Zs(this.isCallOngoing(),"GroupModality can only be added before starting an outgoing call or to an ongoing call"),this.logger.info(`[${_}][addGroupModalityAsync][addGroupModalityOptions=${fi(b)}]`);const k=Ft.ADD_PARTICIPANTS_AND_MODALITY;this.telemetryHelper.recordEvent(k,{causeId:_});const N=XG(this,null,b);return this.http.sendPostRequest({url:this.links[ge.LINKS.ADD_PARTICIPANTS_AND_MODALITY],payload:N,requestName:$n.ADD_PARTICIPANTS_AND_MODALITY.name,causeId:_}).then(()=>{GR.noop()}).catch(W=>{const ee=Lr(W,this.signalingAgentConfig);throw this.logger.info(`[${_}][sendNetworkRequestForAddingParticipant] failed:${fi(ee)}`),ee.error})},this.addModalityAsync=(b,_)=>{Zs(this.isCallOngoing(),"GroupModality can only be added before starting an outgoing call or to an ongoing call"),this.logger.info(`[${_}][addModalityAsync][modalityContext=${fi(b)}]`),this.telemetryHelper.recordEvent(Ft.ADD_MODALITY,{causeId:_});const k=_t(this,b);return this.http.sendPostRequest({url:this.links[ge.LINKS.ADD_MODALITY],payload:k,requestName:$n.ADD_MODALITY.name,causeId:_}).then(N=>(this.logger.info(`[${_}][addModalityAsync] response: ${fi(N)}`),this.telemetryHelper.recordEvent(Ft.WAITING_FOR_ADD_MODALITY_COMPLETION,{causeId:_}),ge.SUCCESS_TRANSACTION_END)).catch(N=>{const W=Lr(N);return this.logger.info(`[${_}][sendNetworkRequestForAddModalityAsync] failed:${fi(W)}`),Promise.reject(W.error)})},this.addBroadcastModalityAsync=(b,_)=>{if(Zs(this.isCallOngoing(),"BroadcastModality can only be added before starting an outgoing call or to an ongoing call"),this.logger.info(`[${_}][addBroadcastModalityAsync][addBroadcastContext=${fi(this.addBroadcastModalityAsync)}]`),this.telemetryHelper.recordEvent(Ft.ADD_BROADCAST_MODALITY,{causeId:_}),this.broadcastSession)return this.logger.info("There is already a broadcast session"),Promise.resolve(ge.SUCCESS_TRANSACTION_END);this.broadcastSession=new RV(this,this.signalingSessionCallback),this.broadcastSession.setContext(b);const k=rt(this,b);return this.http.sendPostRequest({url:this.links[ge.LINKS.ADD_MODALITY],payload:k,requestName:$n.ADD_BROADCAST_MODALITY.name,causeId:_}).then(N=>(this.logger.info(`[${_}][addBroadcastModalityAsync] response: ${fi(N)}`),this.telemetryHelper.recordEvent(Ft.WAITING_FOR_ADD_BROADCAST_MODALITY_COMPLETION,{causeId:_}),ge.SUCCESS_TRANSACTION_END)).catch(N=>{const W=Lr(N);return this.logger.info(`[${_}][sendNetworkRequestForAddBroadcastModalityAsync] failed:${fi(W)}`),this.endBroadcastMeeting(_),Promise.reject(W.error)})},this.nudgeParticipantsAsync=b=>{if(xn(b.participantsIds,"ParticipantsIds should be a non null value"),Zs(this.isCallOngoing(),"Participants can only be nudged before starting an outgoing call or to an ongoing call"),this.logger.info(`[${b.causeId}][nudgeParticipantsAsync][participantsIds=${this.piiUtils.scrubParticipantsList(b.participantsIds)}][invitationData=${b.invitationData}]`),b.participantsIds===void 0||b.participantsIds.length<1)return Promise.reject("List of participants to nudge is empty");this.telemetryHelper.recordEvent(Ft.ADD_PARTICIPANT,{withNudge:ge.INVITATION_TYPE.NUDGE,causeId:b.causeId});const _=this.groupId||b.newGroupId,k=this.threadId||b.newThreadId,N=this.teamsMessageId||b.newMessageId,W=k||_?this.links[ge.LINKS.ADD_PARTICIPANTS_AND_MODALITY]:this.links[ge.LINKS.ADD_PARTICIPANT];return this.participantManager.nudgeParticipantsAsync(b.participantsIds,W,this.fsmState===ge.SIGNALING_FSM_STATE.OUTGOING||this.fsmState===ge.SIGNALING_FSM_STATE.CONNECTED,b.causeId,b.invitationData,_,k,N)},this.callMeBackAsync=(b,_=tr())=>(xn(b,"remoteParticipant should be a non null value"),this.logger.info(`[${_}][callMeBackAsync][remoteParticipantId=${this.piiUtils.scrubMriOrOmit(b.id)}]`),this.telemetryHelper.recordEvent(Ft.CALL_ME_BACK,{causeId:_}),this.hasGroupModality()||Zs(!1,"threadId/groupId must be set before using call me back"),this.participantManager.callMeBackAsync(b,this.links[ge.LINKS.ADD_PARTICIPANTS_AND_MODALITY],_)),this.removeParticipantAsync=(b,_=tr(),k="none")=>{switch(xn(b,"remoteParticipant should be a non null value"),Zs(this.fsmState===ge.SIGNALING_FSM_STATE.CONNECTED,"participants can only be removed from an ongoing call"),this.logger.info(`[${_}][removeParticipantAsync][remoteParticipantId=${this.piiUtils.scrubMriOrOmit(b.id)}] [removeEndpointScope] ${k}`),k){case"all":this.telemetryHelper.recordEvent(Ft.REMOVE_PARTICIPANT_OTHERS,{causeId:_});break;case"specified":this.telemetryHelper.recordEvent(Ft.REMOVE_PARTICIPANT_SPECIFIED,{causeId:_});break;default:this.telemetryHelper.recordEvent(Ft.REMOVE_PARTICIPANT,{causeId:_})}return k!=="none"&&b.endpointId?this.participantManager.removeParticipantEndpointAsync(b,this.links[ge.LINKS.REMOVE_PARTICIPANT],k,_):this.participantManager.removeParticipantAsync(b,this.links[ge.LINKS.REMOVE_PARTICIPANT],_)},this.admitParticipantAsync=(b,_=tr())=>(xn(b,"remoteParticipant should be a non null value"),Zs(this.fsmState===ge.SIGNALING_FSM_STATE.CONNECTED,"remoteParticipants can only be admitted to an ongoing call"),this.hasGroupModality()||Zs(!1,"threadId/groupId must be set before admitting more participants to connected call"),this.logger.info(`[${_}][admitParticipantAsync][remoteParticipantId=${this.piiUtils.scrubMriOrOmit(b.id)}]`),this.telemetryHelper.recordEvent(Ft.ADMIT_PARTICIPANT,{causeId:_}),this.participantManager.admitParticipantAsync(b,this.links[ge.LINKS.ADMIT],_)),this.admitAsync=b=>{if(this.logger.info(`[${b}][admitAsync]`),this.telemetryHelper.recordEvent(Ft.ADMIT,{causeId:b}),!this.links[ge.LINKS.ADMIT_ALL]){const k={code:ge.CALL_END_CODE.REJECT,subCode:ge.CALL_END_SUB_CODE.ADMIT_ALL_LINK_MISSING,phrase:ge.CALL_END_PHRASE.ADMIT_ALL_URL_MISSING};return this.telemetryHelper.recordEvent(Ft.ADMIT_FAILURE,{causeId:b,transactionEnd:k}),this.logger.warn(`admitAsync error ${fi(k)}`),Promise.reject(k)}const _=Pl();return this.callOperationHandler.setPendingOperation(0,b,{promise:_,causeId:b},b),this.sendNetworkRequestForAdmit(b),_.promise},this.updateMeetingRolesAsync=(b,_,k=tr())=>(xn(b,"participants array should be a non null value"),xn(_,"meetingRole should be a non null value"),Zs(this.fsmState===ge.SIGNALING_FSM_STATE.CONNECTED,"remote participant roles can only be updated in an ongoing call"),this.logger.info(`[${k}][updateMeetingRolesAsync][participants=${this.piiUtils.scrubMriOrOmit(b)}]`),this.participantManager.updateMeetingRolesAsync(b,_,this.links[ge.LINKS.UPDATE_PARTICIPANT_ROLE],k)),this.startContentSharingAsync=(b,_,k,N,W=tr())=>(xn(b,"contentIdentifier should be a non null value"),Zs(this.isCallOngoing(),"contentSharing can only be added before starting an outgoing call or to an ongoing call"),this.logger.info(`[${W}][startContentSharingAsync]`),this.telemetryHelper.recordEvent(Ft.ADD_CONTENT_SHARING_MODALITY,{causeId:W}),this.contentSharingManager.startContentSharingAsync(b,_,k,this.links[ge.LINKS.ADD_MODALITY],this.fsmState===ge.SIGNALING_FSM_STATE.CONNECTED,W,N)),this.deleteContentSharingAsync=(b,_=tr())=>(this.logger.info(`[${_}][deleteContentSharingAsync][correlationId=${b}]`),this.telemetryHelper.recordEvent(Ft.DELETE_CONTENT_SHARING,{causeId:_,correlationId:b}),this.contentSharingManager.deleteContentSharingAsync(b,_)),this.joinContentSharingAsync=(b,_=tr())=>(this.logger.info(`[${_}][joinContentSharingAsync][correlationId=${b}]`),this.telemetryHelper.recordEvent(Ft.JOIN_CONTENT_SHARING,{causeId:_,correlationId:b}),this.contentSharingManager.joinContentSharingAsync(b,_)),this.updateContentSharingSessionStateAsync=(b,_,k=tr())=>(xn(_,"sessionState should be a non null value"),this.telemetryHelper.recordEvent(Ft.UPDATE_SESSION_STATE_CONTENT_SHARING,{causeId:k,correlationId:b}),this.logger.info(`[${k}][updateContentSharingSessionStateAsync][correlationId=${b}][sessionState=${_}]`),this.contentSharingManager.updateContentSharingSessionStateAsync(b,_,k)),this.takeContentSharingControlAsync=(b,_=tr())=>(this.telemetryHelper.recordEvent(Ft.TAKE_CONTROL_CONTENT_SHARING,{causeId:_,correlationId:b}),this.logger.info(`[${_}][takeContentSharingControlAsync][correlationId=${b}]`),this.contentSharingManager.takeContentSharingControlAsync(b,_)),this.updateContentSharingParticipantStateAsync=(b,_=tr())=>(this.telemetryHelper.recordEvent(Ft.UPDATE_PARTICIPANT_STATE_CONTENT_SHARING,{causeId:_}),this.logger.info(`[${_}][updateContentSharingParticipantStateAsync][correlationId=${b}]`),this.contentSharingManager.updateContentSharingParticipantStateAsync(b,_)),this.configureEndpointStateForStartOrJoin=b=>{const _={endpointStateSequenceNumber:this.endpointStateSequenceNumber};let k=!1;if(b&&(b.muted&&(k=!0,Object.assign(_,{state:{isMuted:b.muted}})),b.isPreheatOnly||b.additionalEndpointProperties)){const N={};k=!0,b.isPreheatOnly&&(N.preheatProperties=1),b.additionalEndpointProperties&&(N.additionalEndpointProperties=b.additionalEndpointProperties),Object.assign(_,{endpointProperties:N})}if(k)return _},this.gatherTelemetryForStartOrJoin=(b,_,k)=>{const N={causeId:_};return b&&(b.invitationType===ge.INVITATION_TYPE.NUDGE&&(N.withNudge=b.invitationType===ge.INVITATION_TYPE.NUDGE),b.parkContext&&(N.unpark=!0,N.context=b.parkContext),b.isPreheatOnly&&(N.isPreheatOnly=!0),b.targetApplicationType&&(N.targetApplicationType=b.targetApplicationType,this.telemetryHelper.setTargetApplicationType(b.targetApplicationType))),N},this.startOutgoingCall=(b,_,k,N,W=tr())=>{if(xn(b,"mediaContent should be a non null value"),xn(b.blob,"outgoingSdp should be a non null value"),Zs(this.isCallNotConnected(),"a call is already in progress"),this.logger.info(`[${W}][startOutgoingCall][start] applicationType=${this.participantManager.localParticipant.applicationType}`),this.disposed)return void this.logger.warn(`[${W}][startOutgoingCall][failed][reason=Session disposed]`);this.lastUsedJoinCallOptions={muted:k?k.muted:null,scenario:k?k.scenario:null,isPreheatOnly:k?k.isPreheatOnly:null,clientEndpointCapabilities:k?k.clientEndpointCapabilities:null,clientEndpointDebugContent:k?k.clientEndpointDebugContent:null},this.originalRoleBeforePreheat=ei.ROLE.CALLER,k&&k.scenario&&this.telemetryHelper.setScenario(k.scenario),this.logger.info(`[${W}][startOutgoingCall]options=${fi(this.gatherTelemetryForStartOrJoin(k,W,N))}`),this.isBrokerEnabledForOutgoingCall()&&this.setupBrokerChannel(),this.callUsesMixer=!(!k||!k.callUsesMixer),this.fsmState=ge.SIGNALING_FSM_STATE.OUTGOING,this.meetingData=k?.meetingData,this.meetingPreferences=k?.meetingPreferences;const ee={newCall:!0,suppressDialout:k&&k.suppressDialout||!1,conversationServiceUrl:this.signalingAgentConfig.conversationServiceUrl,onBehalfOf:k?k.onBehalfOf:null,onBehalfOfUserDisplayName:k?k.onBehalfOfUserDisplayName:null,callQueueContext:k?k.callQueueContext:null,callToVoicemail:!!k&&k.callToVoicemail,voicemailResourcePath:k?k.voicemailResourcePath:null,voicemailItemId:k?k.voicemailItemId:null,endpointState:this.configureEndpointStateForStartOrJoin(k),invitationType:k&&k.invitationType?k.invitationType:null,participantsToNudge:k&&Array.isArray(k.participantsToNudge)?k.participantsToNudge:null,routingFlags:k?k.routingFlags:null,parkContext:k?k.parkContext:null,pickupCode:k?k.pickupCode:null,scenario:k?k.scenario:null,isPreheatOnly:!!k&&k.isPreheatOnly,applicationType:this.participantManager.localParticipant.applicationType,clientEndpointCapabilities:k?k.clientEndpointCapabilities:0,clientEndpointDebugContent:k?k.clientEndpointDebugContent:null,invitationData:k?k.invitationData:null,conversationType:k?this.getConversationType(k.isEmergency,k.castCall,k.isHuddleGroupCall):null,meetingData:this.meetingData,meetingPreferences:this.meetingPreferences,alternateId:k?k.alternateId:null,meetingRegistrationId:k?k.meetingRegistrationId:null,participantPin:k?k.participantPin:null,publishedStates:k?k.publishedStates:null,targetApplicationType:k?k.targetApplicationType:null,captchaContentJson:k?k.captchaContentJson:null,customHeaderContext:k?k.customHeaderContext:null,participationPreferences:k?k.participationPreferences:null,participantPropertyBag:k?k.participantPropertyBag:null};this.isCastCall=k&&k.castCall,this.isHuddleGroupCall=k&&k.isHuddleGroupCall,this.onBehalfOf=ee.onBehalfOf,this.onBehalfOfUserDisplayName=ee.onBehalfOfUserDisplayName,this.callQueueContext=ee.callQueueContext,this.startOrJoinCall(ee,$n.START_CALL.name,W,b,_)},this.joinGivenConversation=(b,_,k,N,W,ee={},oe=tr())=>{if(xn(_,"correlationId should be a non null value"),lc(b||this.getConversationUrl(),"conversationUrl should be a non null value"),xn(k,"mediaContent should be a non null value"),xn(k.blob,"outgoingSdp should be a non null value"),this.isPromotingToRealtime=this.callMode===2,Zs(this.isCallNotConnected()||this.isPromotingToRealtime,"a call is already in progress"),this.logger.info(`[${oe}][joinGivenConversation][start][correlationId=${_}] applicationType=${this.participantManager.localParticipant.applicationType}`),this.disposed)return void this.logger.warn(`[${oe}][joinGivenConversation][failed][reason=Session disposed]`);const de=this.gatherTelemetryForStartOrJoin(ee,oe,W);this.lastUsedJoinCallOptions=ee,this.originalRoleBeforePreheat=ei.ROLE.JOIN,this.telemetryHelper.startCallInitializationWatch(W),ee&&ee.scenario&&this.telemetryHelper.setScenario(ee.scenario),this.logger.info(`[${oe}][joinGivenConversation]options=${fi(de)}`),this.isBrokerEnabledForIncomingCall()&&this.setupBrokerChannel(),this.fsmState=ge.SIGNALING_FSM_STATE.OUTGOING,this.updateCorrelationId(_,oe),this.meetingData=ee?.meetingData,this.meetingPreferences=ee?.meetingPreferences;const se={newCall:!1,suppressDialout:!0,conversationServiceUrl:b,endpointState:this.configureEndpointStateForStartOrJoin(ee),scenario:ee?ee.scenario:null,isPreheatOnly:!!ee&&ee.isPreheatOnly,applicationType:this.participantManager.localParticipant.applicationType,clientEndpointCapabilities:ee?ee.clientEndpointCapabilities:0,clientEndpointDebugContent:ee?ee.clientEndpointDebugContent:null,conversationType:ee?this.getConversationType(ee.isEmergency,!1):null,meetingPreferences:this.meetingPreferences,meetingData:this.meetingData,meetingRegistrationId:ee?.meetingRegistrationId,participantPin:ee?.participantPin,sharedLineCallInvitationContent:ee?.sharedLineCallInvitationContent,applyServerMute:ee?.applyServerMute,publishedStates:ee?.publishedStates,invitationData:ee?.invitationData,captchaContentJson:ee?.captchaContentJson,callQueueContext:ee?.callQueueContext,participationPreferences:ee?.participationPreferences,participantPropertyBag:ee?.participantPropertyBag};this.isCastCall=!1,this.startOrJoinCall(se,$n.JOIN_CONVERSATION.name,oe,k,N)},this.subscribeToCall=(b,_,k=0,N,W=tr())=>{xn(_,"correlationId should be a non null value"),Zs(this.fsmState===ge.SIGNALING_FSM_STATE.IDLE,"a call is already in progress");let ee=b;return ee||(ee=this.signalingAgentConfig.conversationServiceUrl,this.logger.info(`conversationServiceUrl passed is empty. so it is set to ${ee}`)),lc(ee,"conversationUrl should be a non null value"),this.logger.info(`[${W}][subscribeToCall][start][correlationId=${_}] applicationType=${this.participantManager.localParticipant.applicationType}`),this.disposed?(this.logger.warn(`[${W}][subscribeToCall][failed][reason=Session disposed]`),Promise.reject(ge.CALL_END_CODE.CALL_DOES_NOT_EXIST)):(this.isBrokerEnabledForIncomingCall()&&this.setupBrokerChannel(),this.lastUsedJoinCallOptions=N||{},this.lastUsedJoinCallOptions.clientEndpointCapabilities=k||this.lastUsedJoinCallOptions?.clientEndpointCapabilities,this.meetingData=N?.meetingData,this.meetingPreferences=N?.meetingPreferences,this.fsmState=ge.SIGNALING_FSM_STATE.OUTGOING_FOR_ROSTER_ONLY,this.updateCorrelationId(_,W),this.http.sendPostRequest({url:ee,requestName:$n.JOIN_CONVERSATION_WITHOUT_CALL_MODALITY.name,operationType:"CallSetup",payload:hl(this,null,null,{subscribe:!0,clientEndpointCapabilities:k,...N,applicationType:this.participantManager.localParticipant.applicationType,endpointState:this.configureEndpointStateForStartOrJoin({additionalEndpointProperties:N?.additionalEndpointProperties})},W),causeId:W}).then(oe=>{this.disposed||(this.fsmState=ge.SIGNALING_FSM_STATE.CONNECTED_FOR_ROSTER_ONLY,this.processConversationServiceResponseHeaders(oe,W),this.processConversationServiceResponse(oe.response,W,1),this.onCallStatusChanged(ge.CALL_STATUS.CONNECTED_FOR_ROSTER_ONLY,W))}).catch(oe=>{if(oe.stack&&!this.isFatalException(oe))return Promise.resolve();const de=Lr(oe,this.signalingAgentConfig);return this.logger.info(`[${W}][subscribeToCall] error: ${fi(oe)} xhrError: ${fi(de)}`),this.disposed?Promise.reject(this.getCallNotFoundTransactionEnd()):(this.fsmState=ge.SIGNALING_FSM_STATE.IDLE,this.telemetryHelper.setTerminatingData({terminatingEnd:ei.CALL_TERMINATING_END.LOCAL,resultValue:ei.RESULT_VALUE.FAILURE,endCode:de.telemetryEndSubCode,endSubCode:de.error.subCode,resultCategories:de.error.resultCategories,resultDetail:de.error.phrase||"SubscribeFailure",causeId:W}),this.onCallStatusChanged(ge.CALL_STATUS.LOCAL_TERMINATED,W,de.error),Promise.reject(de.error))}))},this.getCallReplacementDetailsForCall=(b,_=tr())=>{this.logger.info(`[${_}] getCallReplacementDetailsForCall callId ${b}`);const k=this.signalingAgent.getSignalingSession(b);return k?k.getCallReplacementDetails(_):{replaces:""}},this.getCallReplacementDetails=(b=tr())=>(this.logger.info(`[${b}] getCallReplacementDetails`),{replaces:this.links[ge.LINKS.REPLACE]}),this.transferCallAsync=(b,_,k,N,W=tr())=>{this.logger.info(`[${W}] transferCallAsync: transferTargetMri: ${this.piiUtils.scrubMriOrOmit(b)} transferType ${_} callTransferOptions: ${xo(N)}`),this.transferHelper(b,_,k,N,W)},this.redirectCall=(b,_=tr(),k)=>{const{id:N,endpointType:W,type:ee}=b.redirectOptions;if(this.logger.info(`[${_}] redirectCall: targetId: ${this.piiUtils.scrubMriOrOmit(N)} targetEndpointType ${W}`),!this.isRedirectAllowed){const de={code:ge.CALL_END_CODE.REJECT,phrase:ge.CALL_END_PHRASE.CALL_REDIRECT_IS_NOT_ALLOWED};return Promise.reject(de)}this.telemetryHelper.recordEvent(Ft.CALL_REDIRECT,{causeId:_});const oe=Cn(this,ee,N,W);return this.http.sendPostRequest({url:this.links[ge.LINKS.REDIRECT],requestName:$n.SEND_CALL_REDIRECT_REQUEST.name,payload:oe,causeId:_}).then(de=>(this.logger.info(`[${_}][redirectCall] succeeds. Leaving the call...`),this.telemetryHelper.recordEvent(Ft.CALL_REDIRECT_REQUEST_SENT,{causeId:_,targetEndpointType:W}),this.terminateEstablishedCall(k,b))).catch(de=>{const se=Lr(de);this.logger.info(`[${_}][redirectCall] error: ${fi(se)}`);const Re=se.error;return this.telemetryHelper.recordEvent(Ft.CALL_REDIRECT_REQUEST_FAILED,{causeId:_,transactionEnd:Re,endpointType:W}),this.disposed||(this.telemetryHelper.setTerminatingData({terminatingEnd:ei.CALL_TERMINATING_END.LOCAL,endCode:k.code,endSubCode:k.subCode,clientReasonSubCode:k.clientReasonSubCode,clientReasonPhrase:k.clientReasonPhrase,resultDetail:k.phrase||"RedirectCall",resultCategories:k.resultCategories,causeId:_}),this.onCallStatusChanged(ge.CALL_STATUS.LOCAL_TERMINATED,_,k),this.dispose(k,_)),Promise.reject(Re)})},this.transferHelper=(b,_,k,N,W=tr())=>{Zs(this.fsmState===ge.SIGNALING_FSM_STATE.CONNECTED,"call is not connected yet");let ee=!1;this.logger.info(`[${W}][transferHelper][replacementDetails=${fi(k)}] disableForwardingAndUnanswered=${N&&N.disableForwardingAndUnanswered}`),this.telemetryHelper.recordEvent(Ft.TRANSFER_CALL,{causeId:W}),this.timeoutManager.startTimer(ge.TIMEOUT_OPERATIONS.OUTGOING_CALL_ESTABLISHMENT,()=>{this.handleCallTransferTimeout(W,ee)},ge.TIMEOUT_VALUES_IN_SECONDS.OUTGOING_CALL_ESTABLISHMENT_TIMEOUT),this.http.sendPostRequest({url:this.links[ge.LINKS.TRANSFER],requestName:$n.SEND_TRANSFER_REQUEST.name,payload:Iv(b,this,k,_,N),causeId:W}).then(()=>{this.telemetryHelper.recordEvent(Ft.WAITING_FOR_TRANSFER_ACCEPTANCE,{causeId:W}),ee=!0}).catch(oe=>{const de=Lr(oe,this.signalingAgentConfig);this.logger.info(`[${W}][transferCallAsync] error: ${fi(de)}`),this.disposed||(this.signalingSessionCallback.onTransferCompleted({transferCompletion:{code:ge.CALL_END_CODE.NETWORK_ERROR,reason:fi(oe)}},W),this.telemetryHelper.recordEvent(Ft.TRANSFER_REQUEST_FAILED,{causeId:W,...de.error}))}),this.telemetryHelper.recordEvent(Ft.TRANSFER_REQUEST_SENT,{causeId:W,transferType:_})},this.consultTransferCallAsync=(b,_,k,N,W)=>{let ee,oe;if(this.logger.info(`[${N}] consultTransferCallAsync: transferTargetMri: ${this.piiUtils.scrubMriOrOmit(_)} transferTargetParticipantLegId: ${k}`),k?(oe=this.getMriByParticipantLegOfCall(b,k,N),ee=this.getReplacementDetailsByParticipantLegOfCall(b,_,k,N)):(oe=_,ee=this.getCallReplacementDetailsForCall(b,N)),!oe||!ee){const de=ee?"target mri corresponding not found":`unable to retrieve replacementDetails for transferTargetCallId: ${b}, transferTargetMri: ${_}, transferTargetParticipantLegId: ${k}`;return this.logger.info(`[${N}] consultTransferCallAsync: error: ${de}`),void this.signalingSessionCallback.onTransferCompleted({transferCompletion:{code:ge.CALL_END_CODE.BAD_REQUEST,reason:de}},N)}this.transferHelper(oe,"TransferTypeStandard",ee,W,N)},this.isParkByTransfer=(b,_)=>{const k=["serverHold","sharedLinePark","teamPark"].indexOf(b)>-1;return this.logger.info(`[${_}][isParkByTransfer][context=${b}] result = ${k}`),k},this.parkCallAsync=(b,_=tr())=>{if(b&&b==="none")throw{code:ge.CALL_END_CODE.REJECT,subCode:ge.CALL_END_SUB_CODE.PARK_UNPARK_TYPE_MISSING,phrase:"Unpark context is missing or none"};return Zs(this.fsmState===ge.SIGNALING_FSM_STATE.CONNECTED,"call is not connected yet"),this.logger.info(`[${_}][parkCallAsync][context=${b}]`),this.telemetryHelper.recordEvent(Ft.PARK_CALL,{causeId:_,parkType:hte(b)}),this.isParkByTransfer(b,_)?this.parkByTransfer(b,_):this.park(b,_)},this.unparkAsync=(b,_=tr())=>{if(b&&b==="none")throw{code:ge.CALL_END_CODE.REJECT,subCode:ge.CALL_END_SUB_CODE.PARK_UNPARK_TYPE_MISSING,phrase:"Unpark context is missing or none"};if(!this.links[ge.LINKS.UNPARK])throw{code:ge.CALL_END_CODE.REJECT,subCode:ge.CALL_END_SUB_CODE.PARK_UNPARK_TYPE_MISSING,phrase:"Unpark link not available"};this.logger.info(`[${_}][unparkAsync][context=${b}]`),this.timeoutManager.startTimer(ge.TIMEOUT_OPERATIONS.UNPARK_COMPLETION,()=>{this.handleUnparkError({code:ge.CALL_END_CODE.TIMEOUT,subCode:ge.CALL_END_SUB_CODE.UNPARK_COMPLETION_TIMEOUT,phrase:ge.CALL_END_PHRASE.UNPARK_COMPLETION_TIMEOUT},Ft.WAITING_FOR_UNPARK_COMPLETION_TIMEOUT,_,b)},ge.TIMEOUT_VALUES_IN_SECONDS.UNPARK_COMPLETION_TIMEOUT);const k={causeId:_};return this.http.sendPostRequest({url:this.links[ge.LINKS.UNPARK],requestName:$n.SEND_UNPARK_REQUEST.name,payload:$b(this,k),causeId:_}).then(N=>(this.logger.info(`[${_}][unparkAsync] response: ${fi(N)}`),this.telemetryHelper.recordEvent(Ft.WAITING_FOR_UNPARK_COMPLETION,{causeId:_}),Promise.resolve())).catch(N=>{const W=Lr(N,this.signalingAgentConfig);return this.logger.info(`[${_}][unparkAsync] error: ${fi(W)}`),this.disposed?Promise.reject(this.getCallNotFoundTransactionEnd()):(this.handleUnparkError(W.error,Ft.UNPARK_REQUEST_FAILED,_,b),Promise.reject(W.error))})},this.handleUpdateParticipantsPropertiesCompletion=b=>{const _=b.body,k=Po(b),N=this.logger.createChild(`[${k}][handleUpdateParticipantsPropertiesCompletion]`,this.correlationId),W={};if(this.disposed)N.info("ignored. Call disposed.");else{if(_.operationId||N.warn("operationId is undefined."),N.info("starts"),_.participantInfos)for(const ee of _.participantInfos){if(!ee.participant.id){N.warn("participant id is undefined."),this.telemetryHelper.recordEvent(Ft.UPDATE_PARTICIPANTS_PROPERTIES_RESPONSE_FAILED,"participant id is undefined in response, property");continue}if(!ee.participant.key){N.warn("property name (key) is undefined."),this.telemetryHelper.recordEvent(Ft.UPDATE_PARTICIPANTS_PROPERTIES_RESPONSE_FAILED,"property name (key) is undefined in response");continue}const oe=De(ee.participant.id,_.operationId,ee.participant.key),de={code:ee.transactionEnd.code,subCode:ee.transactionEnd.subCode,phrase:ee.transactionEnd.phrase,resultCategories:ee.transactionEnd.resultCategories};N.info(`Update participants properties completed for: ${this.piiUtils.scrubMriOrOmit(ee.participant.id)} with transactionEnd ${fi(de)}`),this.telemetryHelper.recordEvent(Ft.UPDATE_PARTICIPANTS_PROPERTIES_RESPONSE_COMPLETED,{causeId:k,resolveId:this.piiUtils.scrubMriOrOmit(oe),property:ee.participant.key,result:fi(de)}),W[oe]=de,this.updateParticipantsPromises[_.operationId].delete(oe)}this.checkAndCleanupPromisesForOperationId(_.operationId),this.signalingSessionCallback.onUpdateParticipantsPropertiesCompleted(W,_.operationId,k)}},this.getCallStatus=()=>this.currentCallStatus,this.processIncomingCallRequest=(b,_,k=tr())=>{xn(b,"request should be a non null value"),lc(b.body,"request should have a valid body"),lc(b.body.gp||b.body.cp,"request body should have payload"),Zs(this.isCallNotConnected(),"a call is already in progress");const N=this.logger.createChild(`[${k}][processIncomingCallRequest]`);if(this.callUsesMixer=b.fromMixer,N.info("[start]"),this.disposed)return void N.warn("processIncomingCallRequest canceled");this.telemetryHelper.startCallInitializationWatch(),this.isIncomingCall=!0,this.isBrokerEnabledForIncomingCall()&&this.setupBrokerChannel(),this.fsmState=ge.SIGNALING_FSM_STATE.INCOMING,this.participantManager.initializeForIncomingCall();let W={};try{_&&(W=JSON.parse(_))}catch{N.warn("Unable to parse endpoint metadata")}this.endpointMetadata=W;try{let ee;if(b?.body?.gp&&!tV(b.body.gp))N.info("unencoded payload, skipping decoding."),ee=b.body.gp;else{const oe=b.body.gp?atob(b.body.gp):EV(b.body.cp);ee=JSON.parse(oe)}if(!ee.callNotification)throw N.info("[failed][reason=CallNotification missing]"),new Error("CallNotification is missing");N.info(`incoming call payload: ${xo(xS(ee))}`),this.processIncomingCallPayload(ee,k),this.incomingCallPayload=ee}catch{this.endIncomingCallBecauseOfInvalidPayload(k)}},this.sendAttachToCall=(b=tr())=>(this.logger.info(`[${b}][sendAttachToCall]`),this.incomingCallPayload?(this.onCallStatusChanged(ge.CALL_STATUS.IDLE,b),this.sendAttachToCallInternal(b)):(this.endIncomingCallBecauseOfInvalidPayload(b),Promise.reject(ge.CALL_END_SUB_CODE.BAD_NOTIFICATION_PAYLOAD))),this.supportsNewOfferRequest=()=>this.signalingAgentConfig.handleNewOfferRequest,this.requestNewOffer=(b,_=tr())=>(this.telemetryHelper.recordEvent(Ft.REQUEST_NEW_OFFER,{compatibleContentTypes:b,causeId:_}),this.signalingAgentConfig.handleNewOfferRequest?(lc(this.links[ge.LINKS.NEW_OFFER],"newOffer link should be a non null value"),this.http.sendPostRequest({url:this.links[ge.LINKS.NEW_OFFER],requestName:$n.REQUEST_NEW_OFFER.name,payload:ca(this,b,this.links[ge.LINKS.NEW_OFFER]),causeId:_}).then(k=>this.disposed?Promise.reject(this.getCallNotFoundTransactionEnd()):Promise.resolve(k)).catch(k=>{const N=Lr(k,this.signalingAgentConfig);return this.logger.info(`[requestNewOffer][${_}] error ${fi(N)}`),this.disposed?Promise.reject(this.getCallNotFoundTransactionEnd()):(this.fsmState=ge.SIGNALING_FSM_STATE.IDLE,this.telemetryHelper.setTerminatingData({terminatingEnd:ei.CALL_TERMINATING_END.LOCAL,resultValue:ei.RESULT_VALUE.FAILURE,endCode:N.telemetryEndSubCode,endSubCode:N.error.subCode,resultCategories:N.error.resultCategories,resultDetail:N.error.phrase||"RequestNewOfferFailure",causeId:_}),this.onCallStatusChanged(ge.CALL_STATUS.LOCAL_TERMINATED,_,N.error),this.dispose(N.error,_),Promise.reject(N.error))})):Promise.reject("Disabled")),this.endAsync=(b,_={})=>{_.causeId=_.causeId||tr();const k=_.causeId;if(this.logger.info(`[${k}][endAsync][rejectionData=${b&&fi(b)}][endCallForAll=${_.forEveryone}]`),this.disposed)return this.logger.warn(`[${k}][endAsync] canceled but session already disposed`),Promise.resolve(null);if(this.disposing=!0,this.telemetryHelper.recordEvent(Ft.END_CALL,b?{code:b.code,subCode:b.subCode,causeId:k,callEndClientSubCode:b.clientReasonSubCode,callEndClientPhrase:b.clientReasonPhrase}:{causeId:k}),_.preventAllCallbacks){const W=Object.keys(this.signalingSessionCallback);for(const ee of W)this.signalingSessionCallback[ee]=GR.noop}const N=this.mediaRenegotiationManager?.isIncomingRenegotiationInProgress()||this.mediaRenegotiationManager?.isOutgoingRenegotiationInProgress();if(this.telemetryHelper.stopCallCancelationDurationWatch(),this.fsmState===ge.SIGNALING_FSM_STATE.INCOMING)return b.code===ge.CALL_END_CODE.CALL_REDIRECTED?this.redirectCall(_,k,b):this.rejectIncomingCall(b,k);if(this.fsmState===ge.SIGNALING_FSM_STATE.OUTGOING||this.fsmState===ge.SIGNALING_FSM_STATE.OUTGOING_FOR_ROSTER_ONLY)return this.cancelOutgoingCall(b,k);if(this.fsmState===ge.SIGNALING_FSM_STATE.WAITING_CALL_ACCEPTANCE_ACK)return this.rejectIncomingCall(b,k);if((this.fsmState===ge.SIGNALING_FSM_STATE.CONNECTED||N)&&_.forEveryone)return this.deleteConversation(b,k);if(this.fsmState===ge.SIGNALING_FSM_STATE.CONNECTED||this.fsmState===ge.SIGNALING_FSM_STATE.CONNECTED_FOR_ROSTER_ONLY||N)return this.terminateEstablishedCall(b,_);{this.logger.info(`[${k}][endAsync] there is no call to cancel or end or reject in current state`);const W={code:isNaN(b?.code)?ge.CALL_END_CODE.NOT_FOUND:b.code,subCode:isNaN(b?.subCode)?ge.CALL_END_SUB_CODE.CALL_NOT_ATTEMPTED:b.subCode,phrase:b?.phrase||ge.CALL_END_PHRASE.CALL_DOES_NOT_EXIST,resultCategories:b?.resultCategories||[Pu.ExpectedError],clientReasonSubCode:b?.clientReasonSubCode,clientReasonPhrase:b?.clientReasonPhrase};return this.telemetryHelper.setTerminatingData({terminatingEnd:ei.CALL_TERMINATING_END.LOCAL,resultDetail:W.phrase||"CallDoesNotExist",endCode:W.code,endSubCode:W.subCode,resultCategories:W.resultCategories,causeId:k,clientReasonSubCode:W.clientReasonSubCode,clientReasonPhrase:W.clientReasonPhrase}),this.onCallStatusChanged(ge.CALL_STATUS.LOCAL_TERMINATED,k,W),this.dispose(W,k),Promise.resolve(null)}},this.handleIncomingMsgAsync=(b,_=ge.INCOMING_MESSAGE_ORIGIN.TROUTER)=>{xn(b,"incoming message should be a non null value");const k=_V(b),N=Pl(),W=b.body,ee=b.url,oe={...b,origin:_},de=Po(oe);if(this.logger.info(`[${de}][handleIncomingMsgAsync][url=${ee}][messageId=${k}]`),!W)return this.logger.info(`[${de}][handleIncomingMsgAsync][failed][reason=received message with no body]`),this.telemetryHelper.recordEvent(Ft.MESSAGE_MISSING_BODY,{origin:_,messageId:k,causeId:de}),N.reject(new Error("received message with no body")),N.promise;if(this.disposed)return this.logger.info(`[${de}][handleIncomingMsgAsync][failed][reason=call is disposed]`),N.reject(this.getCallNotFoundTransactionEnd()),N.promise;if(this.isDuplicatedIncomingMessage(oe))return this.logger.info(`[${de}][handleIncomingMsgAsync][failed][reason=duplicate]`),this.telemetryHelper.recordEvent(Ft.DUPLICATE_MESSAGE_IGNORED,{origin:_,messageId:k,causeId:de}),N.resolve(new Error("Message was already handled")),N.promise;this.checkCorrelationIdChange(b,de);const se={[fp.CALL_NOTIFICATION]:ue=>{this.handleCallNotification(ue)},[fp.MEDIA_ANSWER]:ue=>{this.handleMediaAnswer(ue)},[fp.MEDIA_ACKNOWLEDGEMENT]:ue=>{this.handleMediaAcknowledgement(ue)},[fp.CALL_ACCEPTANCE]:ue=>{this.handleCallAcceptance(ue)},[fp.CALL_END]:ue=>{this.handleCallEnd(ue,!1)},[fp.CALL_PROGRESS]:ue=>{this.handleCallProgress(ue)},[fp.CALL_ACCEPTANCE_ACKNOWLEDGEMENT]:ue=>{this.handleCallAcceptanceAck(ue)},[fp.MEDIA_NEGOTIATION]:ue=>{this.mediaRenegotiationManager?.handleMediaNegotiationOffer(ue)},[fp.MEDIA_NEGOTIATION_FAILURE]:ue=>{this.mediaRenegotiationManager?.handleMediaNegotiationFailure(ue)},[fp.BALANCE_UPDATE]:ue=>{this.handlePSTNBalanceUpdate(ue)},[fp.RETARGET_COMPLETED]:ue=>{this.mediaRenegotiationManager?.handleRetargetCompleted(ue)},[fp.CALL_TRANSFER]:ue=>{this.handleTransferRequested(ue)},[fp.TRANSFER_COMPLETION]:ue=>{this.handleTransferCompletion(ue)},[fp.TRANSFER_ACCEPTANCE]:ue=>{this.handleTransferAcceptance(ue)},[fp.PARK_COMPLETION]:ue=>{this.handleParkCompletion(ue)},[fp.UNPARK_COMPLETION]:ue=>{this.handleUnparkCompletion(ue)},[fp.UPDATE_MEETING_LIVE_STATE_RESPONSE]:ue=>{this.handleUpdateMeetingLiveStateCompletion(ue)},[fp.UPDATE_MEETING_GROUPS_RESPONSE]:ue=>{this.handleUpdateMeetingGroupsCompletion(ue)},[fp.SET_MEETING_LAYOUT_RESPONSE]:ue=>{this.handleSetMeetingLayoutCompletion(ue)},[fp.UPDATE_MEETING_STATES_RESPONSE]:ue=>{this.handleUpdateMeetingStatesCompletion(ue)},[fp.MONITOR_COMPLETION]:ue=>{this.handleUpdateMonitorSessionCompletion(ue)}},Re={[Fi.CONTROL_VIDEO_STREAMING]:ue=>{this.webRtcSignalingManager.handleControlVideoStreaming(ue)},[Fi.DOMINANT_SPEAKER_INFO]:ue=>{this.webRtcSignalingManager.handleDominantSpeakerInfo(ue)},[Fi.CSRC_INFO]:ue=>{this.webRtcSignalingManager.handleCsrcInfo(ue)},[Fi.CONV_ROSTER_UPDATE]:ue=>{this.handleRosterUpdate(ue,!1)},[Fi.NEW_MEDIA_OFFER]:ue=>{this.handleNewMediaOffer(ue)},[Fi.CONV_ADD_PARTICIPANT_SUCCESS]:ue=>{this.participantManager.handleAddParticipantSuccess(ue)},[Fi.CONV_ADD_PARTICIPANT_FAILURE]:ue=>{this.participantManager.handleAddParticipantFailure(ue)},[Fi.CONV_ADMIT_PARTICIPANT_SUCCESS]:ue=>{this.participantManager.handleAdmitParticipantSuccess(ue)},[Fi.CONV_ADMIT_PARTICIPANT_FAILURE]:ue=>{this.participantManager.handleAdmitParticipantFailure(ue)},[Fi.CONV_ADMIT_ALL_STATUS]:ue=>{this.handleAdmitAllStatus(ue)},[Fi.CONV_REMOVE_PARTICIPANT_SUCCESS]:ue=>{this.participantManager.handleRemoveParticipantSuccess(ue)},[Fi.CONV_REMOVE_PARTICIPANT_FAILURE]:ue=>{this.participantManager.handleRemoveParticipantFailure(ue)},[Fi.CONV_CONFIRM_UNMUTE]:ue=>{this.participantManager.handleUnmuteConfirmRequest(ue)},[Fi.CONV_UPDATE]:ue=>{this.handleConversationUpdate(ue)},[Fi.CONV_LOCAL_PARTICIPANT_UPDATE]:ue=>{this.handleLocalParticipantUpdate(ue)},[Fi.CONV_ADD_MODALITY_SUCCESS]:ue=>{this.handleAddModalitySuccess(ue)},[Fi.CONV_ADD_MODALITY_FAILURE]:ue=>{this.handleAddModalityFailure(ue)},[Fi.CONV_BROADCAST_UPDATE]:ue=>{this.broadcastSession.handleBroadcastStateChanged(ue)},[Fi.CONV_CONTENT_SHARING_UPDATE]:ue=>{this.contentSharingManager?.handleContentSharingUpdate(ue)},[Fi.CONV_CONTENT_SHARING_END]:ue=>{this.contentSharingManager?.handleContentSharingEnd(ue)},[Fi.CONV_END]:ue=>{this.handleCallEnd(ue,!1)},[Fi.CONV_END_JOIN]:ue=>{this.handleCallEnd(ue,!1)},[Fi.CONV_END_SUBSCRIBE]:ue=>{this.handleCallEnd(ue,!0)},[Fi.UPDATE_PARTICIPANT_INTERPRETATION_STATE_STATUS]:ue=>{this.participantManager.handleUpdateParticipantInterpretationStateCompletion(ue)},[Fi.UPDATE_PARTICIPANT_PROPERTIES_STATUS]:ue=>{this.handleUpdateParticipantsPropertiesCompletion(ue)},[Fi.JOIN_MEETING_GROUP_STATUS]:ue=>{this.handleJoinMeetingGroupCompletion(ue)},[Fi.LEAVE_MEETING_GROUP_STATUS]:ue=>{this.handleLeaveMeetingGroupCompletion(ue)},[Fi.RECEIVE_MESSAGE]:ue=>{this.handleReceiveMessage(ue)},[Fi.SEND_MESSAGE_STATUS]:ue=>{this.proxiedMessageNotificationManager.handleProxiedMessageNotification(ue)},[Fi.DISABLE_PREHEAT_ASYNC_STATUS]:ue=>{this.handleDisablePreheatCompletion(ue)},[Fi.MUTE_UNMUTE_ASYNC]:ue=>{this.participantManager.handleMuteUnmuteAsyncResponse(ue)},[Fi.SET_MEETING_LAYOUT_STATUS]:ue=>{this.handleSetMeetingLayoutCompletion(ue)}};try{const ue=Object.keys(se).filter(ze=>W.hasOwnProperty(ze))[0],Ne=this.signalingAgentConfig.enableSplitConversationEndUrl&&(ND(oe.url,Fi.CONV_END_JOIN)||ND(oe.url,Fi.CONV_END_SUBSCRIBE))?Object.keys(Re).filter(ze=>oe.url&&ND(oe.url,ze))[1]:Object.keys(Re).filter(ze=>oe.url&&ND(oe.url,ze))[0];ue?se[ue](oe):Ne?Re[Ne](oe):(this.telemetryHelper.recordEvent(Ft.UNKNOWN_MESSAGE_TYPE,{messageId:k}),this.logger.info(`[${de}][handleIncomingMsgAsync][failed][reason=received unknown message]`)),N.resolve(!0)}catch(ue){this.telemetryHelper.recordEvent(Ft.FAILED_TO_HANDLE_MESSAGE,{messageId:k,error:fi(ue)}),this.logger.info(`[${de}][handleIncomingMsgAsync][failed][reason=${ue.message}]`),N.reject(new Error(ue.message))}return N.promise},this.canHandleIncomingMsgSync=b=>this.signalingAgentConfig.supportsSynchronousTrouterResponse?!!b.body.callAcceptance:!1,this.handleIncomingMsgSync=b=>{const _=_V(b),k=b.body,N=b.url,W=ge.INCOMING_MESSAGE_ORIGIN.TROUTER,ee={...b,origin:W},oe=Po(ee);this.logger.info(`[${oe}][handleIncomingMsgSync][url=${N}][messageId=${_}]`);const de=ee.headers;let se=ge.HTTP_STATUS_CODES.OK,Re="";const ue=new zb;if(Z0(de,this.incomingTrouterMessagesSeenSoFar)){this.logger.info(`[${oe}][handleIncomingMsgSync][failed][reason=duplicate]`);const ze=ste(de,this.incomingMessageSyncResponseCache);if(ze)return this.logger.info(`[${oe}][handleIncomingMsgSync][cachedResponse]`),ze;this.telemetryHelper.recordEvent(Ft.DUPLICATE_MESSAGE_IGNORED,{origin:W,messageId:_,causeId:oe}),this.logger.info(`[${oe}][handleIncomingMsgSync][failed][reason=cachedResponseNotFound]`),se=ge.HTTP_STATUS_CODES.BAD_REQUEST}else if(k){if(k.callAcceptance)try{Re=xo(this.handleCallAcceptanceSync(ee))}catch(ze){this.telemetryHelper.recordEvent(Ft.FAILED_TO_HANDLE_MESSAGE,{messageId:_,origin:W,causeId:oe,error:fi(ze)}),this.logger.info(`[${oe}][handleIncomingMsgSync][failed][reason=${ze?.message}]`),se=ge.HTTP_STATUS_CODES.BAD_REQUEST}}else this.logger.info(`[${oe}][handleIncomingMsgSync][failed][reason=received message with no body]`),this.telemetryHelper.recordEvent(Ft.MESSAGE_MISSING_BODY,{origin:W,messageId:_,causeId:oe}),se=ge.HTTP_STATUS_CODES.BAD_REQUEST;de&&(de.get(ge.HEADERS.CORRELATION_ID)&&ue.set(ge.HEADERS.CORRELATION_ID,de.get(ge.HEADERS.CORRELATION_ID)),de.get(ge.HEADERS.MESSAGE_ID)&&ue.set(ge.HEADERS.MESSAGE_ID,de.get(ge.HEADERS.MESSAGE_ID)));const Ne={resultCode:se,responseBody:Re,responseHeaders:ue.getAll()};return ote(de,this.incomingMessageSyncResponseCache,Ne),this.logger.info(`[${oe}][handleIncomingMsgSync][success][resultCode=${se}]`),Ne},this.acceptRenegotiationAsync=(b,_,k=tr())=>(xn(b.blob,"finalSdp should be a non null value"),Zs(this.fsmState===ge.SIGNALING_FSM_STATE.CONNECTED,"Renegotiation operations are only allowed when the call is connected and no disconnect operation is in flight"),this.logger.info(`[${k}][acceptRenegotiationAsync][mediaTypes=${_}]`),this.mediaRenegotiationManager.acceptRenegotiationAsync(b,_,k)),this.setProvisionalAnswerAsync=(b,_=tr())=>{xn(b.blob,"sdp should be a non null value"),this.telemetryHelper.recordEvent(Ft.SET_PROVISIONAL_ANSWER,{causeId:_});const k=Pl();return this.fsmState!==ge.SIGNALING_FSM_STATE.INCOMING?(this.logger.info(`[setProvisionalAnswerAsync][${_}] there is no incoming call to set provisional answer on.`),k.reject(new Error("there is no incoming call to set provisional answer on.")),k.promise):(this.http.sendPostRequest({url:this.links[ge.LINKS.MEDIA_ANSWER],requestName:$n.SEND_MEDIA_ANSWER.name,payload:oye(this,b),causeId:_}).then(N=>{this.disposed||this.onCallStatusChanged(ge.CALL_STATUS.CONNECTING,_),k.resolve(null),this.disposed||(this.telemetryHelper.recordEvent(Ft.HANDLE_MEDIA_ACKNOWLEDGEMENT,{causeId:_}),this.telemetryHelper.setTimeToRingDuration(),this.onCallStatusChanged(ge.CALL_STATUS.RINGING,_),this.signalingSessionCallback.onMediaAcknowledgementSuccess(!1,_))}).catch(N=>{const W=Lr(N,this.signalingAgentConfig);this.logger.info(`[setProvisionalAnswerAsync][${_}] error: ${fi(W)}`),this.disposed?k.reject(this.getCallNotFoundTransactionEnd()):(this.telemetryHelper.recordEvent(Ft.SET_PROVISIONAL_ANSWER_FAILED,{causeId:_}),k.reject(W.error))}),k.promise)},this.startRenegotiationAsync=(b,_,k=tr())=>(xn(b,"mediaContent should be a non null value"),Zs(this.fsmState===ge.SIGNALING_FSM_STATE.CONNECTED,"Renegotiation operations are only allowed when the call is connected and no disconnect operation is in flight"),this.logger.info(`[${k}][startRenegotiationAsync]`),this.mediaRenegotiationManager.startRenegotiationAsync(b,this.links[ge.LINKS.MEDIA_RENEGOTIATION],_,k)),this.updateMediaDescriptionsAsync=(b=tr(),_)=>{xn(_,"mediaDescriptions should be a non null value"),Zs(this.fsmState===ge.SIGNALING_FSM_STATE.CONNECTED,"updateMediaDescriptions operations are only allowed when the call is connected");const k=this.links[ge.LINKS.UPDATE_MEDIA_DESCRIPTIONS];return xn(k,"updateMediaDescriptionsUrl should be a non null value"),this.telemetryHelper.recordEvent(Ft.UPDATE_MEDIA_DESCRIPTIONS,{causeId:b}),this.http.sendPostRequest({url:k,requestName:$n.UPDATE_MEDIA_DESCRIPTIONS.name,payload:jci(this,_),causeId:b}).catch(N=>{const W=Lr(N,this.signalingAgentConfig);return this.logger.info(`[updateMediaDescriptionsAsync][${b}] error: ${fi(W)}`),this.disposed?Promise.reject(this.getCallNotFoundTransactionEnd()):(this.telemetryHelper.recordEvent(Ft.UPDATE_MEDIA_DESCRIPTIONS_FAILED,{causeId:b}),Promise.reject(W.error))})},this.acceptAsync=(b,_,k,N=tr())=>{xn(b,"mediaContent should be a non null value"),xn(b.blob,"outgoingSdp should be a non null value"),this.logger.info(`[${N}][acceptAsync][mediaTypes=${_}]`),this.telemetryHelper.recordEvent(Ft.ACCEPT_CALL,{causeId:N}),this.telemetryHelper.setAnsweredModalities(b.blob);const W=Pl();return this.fsmState!==ge.SIGNALING_FSM_STATE.INCOMING?(this.logger.warn("acceptAsync, there is no incoming call to accept"),W.reject(new Error("there is no incoming call to accept")),W.promise):(this.fsmState=ge.SIGNALING_FSM_STATE.WAITING_CALL_ACCEPTANCE_ACK,this.http.sendPostRequest({url:this.links[ge.LINKS.ACCEPT],requestName:$n.SEND_ACCEPTANCE.name,payload:Xi(this,b,_,k),causeId:N}).then(ee=>{this.disposed||(this.currentCallStatus===ge.CALL_STATUS.IDLE&&(this.telemetryHelper.setTimeToRingDuration(),this.telemetryHelper.recordEvent(Ft.ACCEPTED_BEFORE_RINGING,{causeId:N}),this.onCallStatusChanged(ge.CALL_STATUS.CONNECTING,N)),ee.response.callAcceptanceAcknowledgement&&(this.logger.info("acceptAsync, handling inlined callAcceptanceAcknowledgement"),this.internalHandleCallAcceptanceAck(ee.response,N))),W.resolve(null)}).catch(ee=>{const oe=Lr(ee,this.signalingAgentConfig);this.logger.info(`[acceptAsync][${N}] error: ${fi(oe)}`),this.disposed?W.reject(this.getCallNotFoundTransactionEnd()):(this.fsmState=ge.SIGNALING_FSM_STATE.INCOMING,this.telemetryHelper.recordEvent(Ft.ACCEPT_CALL_FAILED,{causeId:N,xhrError:oe}),W.reject(oe.error))}),W.promise)},this.rejectRenegotiationAsync=(b,_=tr())=>(Zs(this.fsmState===ge.SIGNALING_FSM_STATE.CONNECTED,"Renegotiation operations are only allowed when the call is connected and no disconnect operation is in flight"),this.logger.info(`[${_}][rejectRenegotiationAsync][rejectionData=${b}]`),this.mediaRenegotiationManager.rejectRenegotiationAsync(b,_)),this.saveMediaControllerLinksIfAny=b=>{b.links&&(this.links[ge.LINKS.CONTROL_VIDEO_STREAMING]=b.links.controlVideoStreaming||this.links[ge.LINKS.CONTROL_VIDEO_STREAMING],this.links[ge.LINKS.APPLY_CHANNEL_PARAMETERS]=b.links.applyChannelParameters||this.links[ge.LINKS.APPLY_CHANNEL_PARAMETERS])},this.getInitialMediaOfferFromIncomingCallPayload=(b=tr())=>{if(!this.signalingAgentConfig.handleMediaOfferFromPushNotification)return null;const _=this.incomingCallPayload?.callNotification?.mediaContent?this.incomingCallPayload.callNotification.mediaContent:null;return this.telemetryHelper.setIsSdpInCallNotification(!!_),_},this.updateCorrelationId=(b,_=tr())=>{if(this.logger.info(`[${_}][updateCorrelationId][old=${this.correlationId}][new=${b}]`),this.correlationId!==b&&!this.disposed){const k=this.correlationId;this.correlationId=b,this.telemetryHelper&&this.telemetryHelper.recordEvent&&this.telemetryHelper.recordEvent(Ft.CORRELATION_ID_UPDATED,{newId:this.correlationId,oldId:k,causeId:_}),this.signalingSessionCallback&&this.signalingSessionCallback.onCorrelationIdUpdated&&this.signalingSessionCallback.onCorrelationIdUpdated(this.correlationId,_)}},this.endIncomingCallBecauseOfInvalidPayload=b=>{this.logger.info(`[${b}][endIncomingCallBecauseOfInvalidPayload]`),this.fsmState=ge.SIGNALING_FSM_STATE.IDLE;const _={code:ge.CALL_END_CODE.BAD_REQUEST,subCode:ge.CALL_END_SUB_CODE.BAD_NOTIFICATION_PAYLOAD,phrase:ge.CALL_END_PHRASE.BAD_NOTIFICATION_PAYLOAD,resultCategories:[Pu.UnexpectedServerError]};this.telemetryHelper.setTerminatingData({terminatingEnd:ei.CALL_TERMINATING_END.LOCAL,resultValue:ei.RESULT_VALUE.FAILURE,endCode:_.code,endSubCode:_.subCode,resultDetail:_.phrase||"EndIncomingCall",resultCategories:_.resultCategories,causeId:b}),this.onCallStatusChanged(ge.CALL_STATUS.LOCAL_TERMINATED,b,_),this.dispose(_,b)},this.isDuplicatedIncomingMessage=b=>b.origin===ge.INCOMING_MESSAGE_ORIGIN.BROKER&&Z0(b.headers,this.incomingBrokerMessagesSeenSoFar)||b.origin===ge.INCOMING_MESSAGE_ORIGIN.TROUTER&&Z0(b.headers,this.incomingTrouterMessagesSeenSoFar),this.getEndpointState=()=>{let b;return b=this.startOrJoinConvResponseReceived?{...this.latestEndpointState}:{...this.requestedEndpointStateWhileConnecting},b},this.setMultiParty=(b,_)=>{const k=!!b;this.multiParty!==k&&(this.telemetryHelper.recordEvent(Ft.SET_MULTIPARTY,{isMultiparty:k,causeId:_}),this.multiParty=k)},this.setupTrouterChannel=()=>{this.logger.info(`Broker config: outgoing=${this.signalingAgentConfig.brokerEnabledOutgoing?"enabled":"disabled"}incoming=${this.signalingAgentConfig.brokerEnabledIncoming?"enabled":"disabled"}batching=${this.signalingAgentConfig.brokerRequestBatching?"enabled":"disabled"}exclusive=${this.signalingAgentConfig.brokerExclusively?"enabled":"disabled"}`);const b=_=>{_&&typeof _=="string"&&_.trim()&&(this.baseMessagingChannelUrl=this.previousTrouterUrl=this.currentTrouterUrl=_.trim(),this.telemetryHelper.addTrouterChannel())};this.brokerExclusiveEnabled()||(this.signalingAgentConfig.trouterServiceProvider?(this.signalingAgentConfig.trouterServiceProvider.state()===2&&this.signalingAgentConfig.trouterServiceProvider.getTrouterUrlAsync().then(b),this.signalingAgentConfig.trouterServiceProvider.onStateChanged(this.onTrouterStateChanged)):(b(this.signalingAgentConfig.trouterUrlGetter.trouterUrl()),this.signalingAgentConfig.trouterUrlGetter.trouterUrl.changed(this.onTrouterUrlChanged)))},this.isTrouterDisconnected=()=>{try{return this.signalingAgentConfig.trouterServiceProvider.state()===3}catch{return!1}},this.forceTrouterConnectionCheck=()=>{try{return void this.signalingAgentConfig.trouterServiceProvider.checkConnection(!1)}catch{return}},this.navigatorOnlineCallback=()=>{this.disposed||(this.reportConnectivityStatus(),this.isTrouterDisconnected()&&this.signalingAgentConfig.forceTrouterReconnectOnNetworkOnline&&this.forceTrouterConnectionCheck())},this.navigatorOfflineCallback=()=>{this.reportConnectivityStatus()},this.reportConnectivityStatus=()=>{if(!this.disposed){const b=HG(this.signalingAgentConfig.trouterServiceProvider);this.logger.info(`[Connectivity] status=${b}`),this.telemetryHelper.recordEvent(Ft.CONNECTIVITY_CHANGED,{status:b})}},this.onTrouterStateChanged=(b,_)=>{const k=tr();this.logger.info(`[${k}][onTrouterStateChanged][state=${b}]`),this.disposed?this.logger.info("onTrouterStateChanged ignored"):(this.reportConnectivityStatus(),b===2&&(this.telemetryHelper.addTrouterChannel(),this.updateLinksToTrouter(Ft.TROUTER_STATE_CHANGED,k)))},this.setupConnectionCheck=()=>{try{navigator&&navigator.onLine&&window&&window.addEventListener&&(window.addEventListener("online",this.navigatorOnlineCallback),window.addEventListener("offline",this.navigatorOfflineCallback))}catch{return}},this.tearDownConnectionCheck=()=>{try{navigator&&navigator.onLine&&window&&window.removeEventListener&&(window.removeEventListener("online",this.navigatorOnlineCallback),window.removeEventListener("offline",this.navigatorOfflineCallback))}catch{return}},this.getTrouterUrlAsync=()=>this.signalingAgentConfig.trouterServiceProvider?this.signalingAgentConfig.trouterServiceProvider.getTrouterUrlAsync():this.signalingAgentConfig.trouterUrlGetter.getTrouterUrlAsync(),this.brokerExclusiveEnabled=()=>this.signalingAgentConfig.brokerEnabledOutgoing&&this.signalingAgentConfig.brokerEnabledIncoming&&this.signalingAgentConfig.brokerExclusively,this.isBrokerEnabledForOutgoingCall=()=>this.signalingAgentConfig.brokerEnabledOutgoing,this.isBrokerEnabledForIncomingCall=()=>this.signalingAgentConfig.brokerEnabledIncoming,this.setupBrokerChannel=()=>{this.brokerService||(this.logger.info("setupBrokerChannel, Enable broker"),this.brokerService=new Ete(this),this.brokerService.onBrokerMessage(b=>{this.logger.info("setupBrokerChannel, message from broker",iN(b)),this.handleIncomingMsgAsync(b,ge.INCOMING_MESSAGE_ORIGIN.BROKER).catch(_=>{this.telemetryHelper.recordEvent(Ft.FAILED_TO_HANDLE_BROKER_MESSAGE),this.logger.info("setupBrokerChannel, Failed to handle message from broker",_)})}),this.baseMessagingChannelUrl||(this.telemetryHelper.addBrokerChannel(),this.baseMessagingChannelUrl=this.brokerService.baseUrl))},this.onTrouterUrlChanged=()=>{const b=tr();this.logger.info(`[${b}][onTrouterUrlChanged]`),this.disposed?this.logger.info("onTrouterUrlChanged ignored"):this.getTrouterUrlAsync().then(_=>{this.telemetryHelper.recordEvent(Ft.TROUTER_URL_CHANGED,{url:_}),this.telemetryHelper.addTrouterChannel(),this.updateLinksToTrouter(Ft.TROUTER_URL_CHANGED,b)}).catch(_=>{this.logger.info(`Failed to update links to trouter: ${_}`)})},this.updateLinksToTrouter=(b,_)=>{this.logger.info(`[${_}][updateLinksToTrouter][tag=${b}]`),this.ensureLatestTrouterUrl(b).then(()=>{this.previousTrouterUrl!==this.currentTrouterUrl?(this.previousTrouterUrl=this.currentTrouterUrl,this.updateConversationLinks(),this.updateKeepAliveUrl(),this.contentSharingManager?.updateContentSharingNotificationLinksAsync(_),this.broadcastSession&&this.broadcastSession.updateBroadcastCallbackUrl(_)):this.logger.info(`[${_}][updateLinksToTrouter]skip updating links, url did not change`)}).catch(k=>{this.disposed||this.telemetryHelper.recordEvent(Ft.TROUTER_URL_UPDATE_FAILED,{causeId:_}),this.logger.info(`[${_}][updateLinksToTrouter][failed][reason=${fi(k)}]`)})},this.updateLinks=(b,_)=>{this.ensureLatestTrouterUrl(Ft.TROUTER_URL_CHANGED).then(()=>{b(_)}).catch(k=>{this.disposed||this.telemetryHelper.recordEvent(Ft.TROUTER_URL_UPDATE_FAILED,{causeId:_}),this.logger.warn("Failed to update links")})},this.startCallPreheatTimer=b=>{this.timeoutManager.startTimer(ge.TIMEOUT_OPERATIONS.MAX_PREAHEATED_TIMEOUT,()=>{this.handleCallEstablishmentTimeout(b,ge.CALL_END_SUB_CODE.PREHEATED_CALL_TIMEDOUT,"Preheat timed out!"),this.terminateEstablishedCall({code:ge.CALL_END_CODE.TIMEOUT,subCode:ge.CALL_END_SUB_CODE.PREHEATED_CALL_TIMEDOUT,phrase:"Preheat timed out!"},{forEveryone:!1,causeId:b})},ge.TIMEOUT_VALUES_IN_SECONDS.MAX_PREAHEATED_TIMEOUT)},this.stopCallPreheatTimer=()=>{this.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.MAX_PREAHEATED_TIMEOUT)},this.updateKeepAliveUrl=()=>{this.logger.info("updateKeepAliveUrl"),this.links.hasOwnProperty(ge.LINKS.KEEPALIVE)?(this.linkUpdateRequested.keepAliveLinks=!1,this.logger.info("updateKeepAliveUrl, sending request"),this.sendToKeepAliveUrl(Bo(this))):this.linkUpdateRequested.keepAliveLinks=!0},this.updateConversationLinks=(b=tr())=>{this.logger.info(`[${b}][updateConversationLinks]`),this.telemetryHelper.recordEvent(Ft.UPDATE_CONVERSATION_LINKS,{causeId:b}),this.links.hasOwnProperty(ge.LINKS.NOTIFICATION_LINKS)?(this.linkUpdateRequested.conversationLinks=!1,this.logger.info("updateConversationLinks, sending request"),this.sendToUpdateConversationLinks(!0)):this.linkUpdateRequested.conversationLinks=!0},this.sendAttachToCallInternal=(b=tr())=>{this.telemetryHelper.recordEvent(Ft.SEND_ATTACH,{causeId:b}),this.logger.info(`[${b}][sendAttachToCallInternal]`);const _=new zb;return this.signalingAgentConfig.sendProgressFromCC&&_.set(ge.HEADERS.CACHE_SKYPE_TOKEN,"1"),this.http.sendPostRequest({url:this.incomingCallPayload.callNotification.links.attach,customHeaders:_,requestName:$n.SEND_CALL_ATTACH.name,payload:Di(this,this.incomingCallPayload.conversationInvitation.conversationController,!this.getInitialMediaOfferFromIncomingCallPayload()),causeId:b}).then(k=>{if(!this.disposed){this.processAttachResponse(this.incomingCallPayload,k,b);const N=k.response.additionalActionResponses;N&&N.length>0&&this.processConversationServiceResponse(N[0].output,b,0),this.onCallStatusChanged(ge.CALL_STATUS.RINGING,b),this.telemetryHelper.setTimeToRingDuration(),this.handleBrokerSubscription(k.response.callInvitation,b)}}).catch(k=>{const N=Lr(k,this.signalingAgentConfig);if(this.logger.info(`[${b}][sendAttachToCallInternal] error: ${fi(k)} xhrError: ${fi(N)}`),!this.disposed)throw this.fsmState=ge.SIGNALING_FSM_STATE.IDLE,this.telemetryHelper.setTerminatingData({terminatingEnd:ei.CALL_TERMINATING_END.LOCAL,resultValue:ei.RESULT_VALUE.FAILURE,endCode:N.telemetryEndSubCode,endSubCode:N.error.subCode,resultCategories:N.error.resultCategories,resultDetail:N.error.phrase||"SendAttachtoCallFailure",causeId:b}),this.onCallStatusChanged(ge.CALL_STATUS.LOCAL_TERMINATED,b,N.error),this.dispose(N.error,b),{code:N.telemetryEndSubCode,subCode:N.error.subCode,resultCategories:N.error.resultCategories}})},this._processCallAcceptance=(b,_)=>{if(this.logger.info(`[${_}][_processCallAcceptance]`),this.fsmState===ge.SIGNALING_FSM_STATE.OUTGOING){this.processCallAcceptance(b.body,_),this.telemetryHelper.setTimeToRingDuration();try{this.multiParty||this.callUsesMixer||this.participantManager.handleRosterUpdate(this.getFakeRoster(b.body),!0,_)}catch(k){const N={code:ge.CALL_END_CODE.BAD_SERVICE_RESPONSE,subCode:ge.CALL_END_SUB_CODE.CALL_ACCEPTANCE_INVALID_SERVICE_RESPONSE,phrase:k?.toString()};throw this.logger.info(`[${_}][_processCallAcceptance] ${xo(N)}`),this.telemetryHelper.recordRosterEvent(b,Ft.HANDLE_ROSTER_UPDATE_FAIL,_),N}}},this.restartKeepAliveInterval=(b,_=!1,k)=>{this.disposed||(window.clearInterval(this.keepAliveTimer),_&&(this.telemetryHelper.recordEvent(Ft.SEND_KEEP_ALIVE_FAILED,k),k?.code===ge.RESOURCE_NOT_FOUND_ERROR.code)?this.logger.info(`[${b}][restartKeepAliveInterval] keepAlive stopped since last request returned NOT_FOUND.`):this.keepAliveTimer=window.setInterval(this.sendKeepAlive.bind(this),this.keepAliveInterval))},this.isCallOngoing=()=>this.fsmState===ge.SIGNALING_FSM_STATE.CONNECTED||this.fsmState===ge.SIGNALING_FSM_STATE.IDLE,this.isCallNotConnected=()=>{const b=this.signalingAgentConfig.enableSplitConversationEndUrl&&this.fsmState===ge.SIGNALING_FSM_STATE.OUTGOING;return this.fsmState===ge.SIGNALING_FSM_STATE.IDLE||this.fsmState===ge.SIGNALING_FSM_STATE.OUTGOING_FOR_ROSTER_ONLY||this.fsmState===ge.SIGNALING_FSM_STATE.CONNECTED_FOR_ROSTER_ONLY||b},this.isCallConnectedOrConnectedForRoster=()=>this.fsmState===ge.SIGNALING_FSM_STATE.CONNECTED||this.fsmState===ge.SIGNALING_FSM_STATE.CONNECTED_FOR_ROSTER_ONLY,m&&(this.callStartTime=m),this.signalingSessionCallback=a,this.signalingAgentConfig=s,this.signalingAgent=u,this.urlIdentifier=c,this.piiUtils=new wV(s.piiScrubber),this.isHostLessCall=s.doHostlessCalling||!1,this.logger=s.logger.createChild(()=>`CSA[${this.correlationId}][${this.fsmState}]`,this.correlationId,!0),this.updateCorrelationId(c),this.logger.info(`[endpointId=${J_(this.signalingAgent.endpointId,8)}]`),this.logger.info(`[participantId=${n.participantId}]`),this.callOperationHandler=new Ite(this.logger.createChild(()=>`[CallOperationHandler][${n.participantId}]`)),this.http=new ZG(this,this.callStartTime),this.telemetryHelper=new Qci(this,n,this.callStartTime),this.mediaRenegotiationManager=new B2(this,a,this.telemetryHelper),this.participantManager=new P(this,a,n,new aN(this.logger)),this.proxiedMessageNotificationManager=new We(this),this.timeoutManager=new fte(this.logger),this.contentSharingManager=new Vve(this,a),this.webRtcSignalingManager=new Zci(this,a),this.pstnContent={emergencyCallCountry:s.emergencyCallCountry||"",platformName:s.clientInformation,publicApiCall:!1},this.setupTrouterChannel(),this.setupConnectionCheck()}onPromotionCompleted(n,a,s){this.logger.info(`[${s}][onPromotionCompleted] isFailed=${n} error=${fi(a)}]`),this.isPromotingToRealtime=!1,this.signalingSessionCallback.onPromotionCompleted(n,a,s)}setRealTimeState(n,a){let s=n;(n===2&&this.realTimeState===1||n===1&&this.realTimeState===2)&&(s=3),s!==this.realTimeState&&(this.logger.info(`[${a}][setRealTimeState] changed: input=${n} old=${this.realTimeState}, new=${s}`),this.realTimeState=s,s===3?this.setCallMode(1,a):this.callMode!==0||s!==2&&(this.signalingAgentConfig.disableRealTimeModeFromRoster||s!==1)||this.setCallMode(1,a))}setCallMode(n,a){this.callMode!==n&&(this.logger.info(`[${a}][setCallMode] oldMode=${this.callMode}, newMode=${n}`),this.callMode=n,this.signalingSessionCallback.onCallModeChanged(this.callMode,a))}configureStreamingMode(n){this.callMode!==2?(this.logger.info(`[${n}][configureStreamingMode]`),this.setCallMode(2,n),this.cleanUpDueToStreaming(n),this.onCallStatusChanged(ge.CALL_STATUS.CONNECTED,n)):this.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.OUTGOING_CALL_ESTABLISHMENT)}updateDominantSpeakerHistoryMessageSubscription(n){this.webRtcSignalingManager.getIsDominantSpeakerInfoLinkEnabled()!==n&&(this.logger.info(`Signaling dominant speaker history subscription updated: ${n}`),this.webRtcSignalingManager.setIsDominantSpeakerInfoLinkEnabled(n),this.webRtcSignalingManager.areClientURLsGenerated()&&this.updateKeepAliveUrl())}cleanUpDueToStreaming(n){this.setRealTimeState(0,n),this.fsmState=ge.SIGNALING_FSM_STATE.CONNECTED,this.isPromotingToRealtime=!1,this.provisionalMediaAnswersSeenSoFar=[],this.mediaRenegotiationManager?.dispose(),this.mediaRenegotiationManager=new B2(this,this.signalingSessionCallback,this.telemetryHelper),this.keepAliveTimer&&window.clearInterval(this.keepAliveTimer),this.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.OUTGOING_CALL_ESTABLISHMENT);const a={code:ge.CALL_END_CODE.SUCCESS,subCode:ge.CALL_END_SUB_CODE.DOWNGRADE_TO_STREAMING_CLIENT,phrase:ge.CALL_END_PHRASE.DOWNGRADE_TO_STREAMING_CLIENT},s=$n;for(const c of Object.keys(s))s[c].controller!==0&&s[c].controller!==4&&s[c].controller!==3||this.http.cancelRequestIfPending(s[c].name,n,void 0,a)}updateEndpointMetadata(n,a=tr()){let s={};try{s=JSON.parse(n)}catch{return Promise.reject("Invalid metadata")}return this.http.sendPutRequest({url:this.links[ge.LINKS.UPDATE_ENDPOINT_METADATA],requestName:$n.UPDATE_ENDPOINT_METADATA.name,payload:Py(this,s),causeId:a}).then(()=>{this.telemetryHelper.recordEvent(Ft.UPDATE_ENDPOINT_METADATA_SUCCESS,{causeId:a})}).catch(c=>{const u=Lr(c,this.signalingAgentConfig);return this.logger.info(`[${a}][updateEndpointMetadata] error: ${fi(u)}`),this.telemetryHelper.recordEvent(Ft.UPDATE_ENDPOINT_METADATA_FAILURE,{...u.error}),Promise.reject(u.error)})}isOneToOnePSTNCall(){return this.signalingSessionCallback.isOneToOnePstnCall()}getLocationContent(){return this.isOneToOnePSTNCall()?Q0(this.locationInfoContent):null}getNetworkContent(){return this.isOneToOnePSTNCall()?Q0(this.networkInfoContent):null}getAreaContent(){return this.isOneToOnePSTNCall()?Q0(this.areaContent):null}setLocationInfo(n,a,s){this.locationInfoContent=n,this.networkInfoContent=a,this.areaContent=s}setStreamInformationReceived(){this.disposed||this.streamInformationReceived||(this.streamInformationReceived=!0,this.telemetryHelper.recordEvent(Ft.SET_STREAM_INFORMATION_RECEIVED))}getEndpointCapabilities(){let n=0;return this.signalingAgentConfig.brokerEnabledIncoming&&(n|=16),this.signalingAgentConfig.isGVCJoiningEnabled&&(n|=1),this.signalingAgentConfig.cloudScreenSharingFlag!=="disabled"&&(n|=2),this.signalingAgentConfig.supportsHostlessGroupCalls&&(n|=4),this.signalingAgentConfig.autoJoinOnConflict&&(n|=32),this.signalingAgentConfig.supportsCompressedServicePayload&&(n|=128),this.signalingAgentConfig.enableAutoPromotion&&(n|=65536),this.signalingAgentConfig.enableBatchedSendMessageStatus&&(n|=16384),this.signalingAgentConfig.enableBatchedReceiveMessage&&(n|=8192),n|=64,n|=1024,this.signalingAgent?.accountConfig?.clientSupportsAudioOnlyWatermark&&(n|=4096,this.telemetryHelper.setAudioOnlyWatermark(!0)),this.signalingAgent?.accountConfig?.clientSupportsWatermark&&(n|=2048,this.telemetryHelper.setWatermarkSupport(!0)),this.signalingAgent?.accountConfig?.clientSupportsPreventScreenCapture&&(n|=131072,this.telemetryHelper.setClientSupportsPreventScreenCapture(!0)),(this.getMaxReinvitelessMediaForVBSSForWeb()||this.getMaxReinvitelessMediaForVideoForWeb())&&(this.telemetryHelper.setReinviteless(this.callUsesMixer),n|=512),n}handleAdmitAllStatus(n){const a=n.body?.transactionResponse,s=Po(n);this.logger.info(`[${s}][handleAdmitAllStatus][${fi(a)}]`);const c=a?.operationId;if(c&&this.callOperationHandler.hasPendingOperation(0,c,s)){this.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.ADMIT,c);const u=a?.result?.code,m=a?.result?.subCode,b=a?.result?.resultCategories,_=a?.additionalDetail;if(u===0||u>=200&&u<300){const k={code:u,subCode:m,resultCategories:b,result:xo(_)};this.telemetryHelper.recordEvent(Ft.ADMIT_SUCCESS,{causeId:c,transactionEnd:k}),this.callOperationHandler.resolvePendingOperation(0,c,k,s)}else{const k={code:u||ge.CALL_END_CODE.BAD_REQUEST,subCode:m||0,resultCategories:b,result:a,phrase:ge.CALL_END_PHRASE.BAD_SERVICE_RESPONSE};this.telemetryHelper.recordEvent(Ft.ADMIT_FAILURE,{causeId:c,transactionEnd:k}),this.callOperationHandler.rejectPendingOperation(0,c,"AdmitAllStatus response contains failure",k,s)}}else this.logger.warn(`[${s}][handleAdmitAllStatus] invalid admitAllStatus response or no pending operation. operationId=${c}`)}sendNetworkRequestForAdmit(n){const a=()=>{this.timeoutManager.startTimer(ge.TIMEOUT_OPERATIONS.ADMIT,()=>{this.telemetryHelper.recordEvent(Ft.ADMIT_TIMEOUT,{causeId:n}),this.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.ADMIT,n),this.callOperationHandler.rejectPendingOperation(0,n,"timed out waiting for admit operation",{code:ge.CALL_END_CODE.TIMEOUT,subCode:ge.CALL_END_SUB_CODE.ADMIT_TIMEOUT,phrase:ge.CALL_END_PHRASE.ADMIT_TIMEOUT},n)},ge.TIMEOUT_VALUES_IN_SECONDS.ADMIT_TIMEOUT,n)};this.http.sendPostRequest({url:this.links[ge.LINKS.ADMIT_ALL],requestName:$n.ADMIT.name,payload:Ut(this,n),causeId:n,onceTrouterReady:a}).catch(s=>{const c=Lr(s,this.signalingAgentConfig);this.telemetryHelper.recordEvent(Ft.ADMIT_FAILURE,{causeId:n,...c.error}),this.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.ADMIT,n),this.callOperationHandler.rejectPendingOperation(0,n,s,c.error,n)})}getConversationType(n,a,s){return n?"emergencyGroupCall":a?"cast":s?"huddleGroupCall":null}getMaxReinvitelessMediaForVideoForWeb(){return this.signalingAgentConfig.maxReinvitelessMediaForVideoForWeb}getMaxReinvitelessMediaForVBSSForWeb(){return this.signalingAgentConfig.maxReinvitelessMediaForVBSSForWeb}convertParkType(n){return n==="teamPark"?"TransferTypeTeamPark":n==="sharedLinePark"?"TransferTypeSharedLinePark":n==="serverHold"?"TransferTypeServerHold":(this.logger.info(`convertParkType, parkType: ${n} is unknown`),"none")}parkByTransfer(n,a){this.timeoutManager.startTimer(ge.TIMEOUT_OPERATIONS.OUTGOING_CALL_ESTABLISHMENT,()=>{this.handleCallTransferTimeout(a)},ge.TIMEOUT_VALUES_IN_SECONDS.OUTGOING_CALL_ESTABLISHMENT_TIMEOUT);const s=this.getNetworkRequestName(n);return this.http.sendPostRequest({url:this.links[ge.LINKS.TRANSFER],requestName:s,payload:fr(n,this),causeId:a}).catch(c=>{const u=Lr(c,this.signalingAgentConfig);return this.logger.info(`[${a}][parkByTransfer] error: ${fi(u)}`),this.disposed?Promise.reject(this.getCallNotFoundTransactionEnd()):(this.signalingSessionCallback.onTransferCompleted({transferCompletion:{code:ge.CALL_END_CODE.NETWORK_ERROR,reason:fi(c)}},a),this.telemetryHelper.recordEvent(Ft.TRANSFER_REQUEST_FAILED,{causeId:a,...u.error}),Promise.reject(u.error))}),this.telemetryHelper.recordEvent(Ft.TRANSFER_REQUEST_SENT,{causeId:a,transferType:this.convertParkType(n)}),Promise.resolve()}park(n,a){this.logger.info(`[${a}][park] context ${n}`),this.timeoutManager.startTimer(ge.TIMEOUT_OPERATIONS.PARK_COMPLETION,()=>{this.handleParkError({code:ge.CALL_END_CODE.TIMEOUT,subCode:ge.CALL_END_SUB_CODE.PARK_COMPLETION_TIMEOUT,phrase:ge.CALL_END_PHRASE.PARK_COMPLETION_TIMEOUT},Ft.WAITING_FOR_PARK_COMPLETION_TIMEOUT,a,n)},ge.TIMEOUT_VALUES_IN_SECONDS.PARK_COMPLETION_TIMEOUT);const s=this.getHoldTypeInRequest(n),c={causeId:a};return this.http.sendPostRequest({url:this.links[ge.LINKS.PARK],requestName:$n.PARK_REQUEST.name,payload:or(this,s,c),causeId:a}).then(u=>{this.logger.info(`[${a}][park] response: ${fi(u)}`),this.telemetryHelper.recordEvent(Ft.WAITING_FOR_PARK_COMPLETION,{causeId:a}),xn(u.response.holdResponse.links,"server response does not include park links"),this.links[ge.LINKS.UNPARK]=u.response.holdResponse.links.resume}).catch(u=>{const m=Lr(u,this.signalingAgentConfig);return this.logger.info(`[${a}][park] error: ${fi(m)}`),this.disposed?Promise.reject(this.getCallNotFoundTransactionEnd()):(this.handleParkError(m.error,Ft.PARK_REQUEST_FAILED,a,n),Promise.reject(m.error))}),Promise.resolve()}getHoldTypeInRequest(n){switch(n){case"serverHoldV2":return"musicOnHold";case"sharedLineParkV2":return"sharedLineAppearance";case"callPark":return"callPark";default:return null}}handleParkError(n,a,s,c){this.disposed?this.logger.info("handleParkError ignored"):(this.logger.info(`[${s}] handleParkError reject reason: ${fi(n)}`),this.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.PARK_COMPLETION),this.signalingSessionCallback.onParkCompleted&&(this.telemetryHelper.recordEvent(a,{...n,parkContext:c,causeId:s}),this.signalingSessionCallback.onParkCompleted(n,s)),this.links[ge.LINKS.UNPARK]=void 0)}handleParkCompletion(n){const a=n.body,s=Po(n),c=a.holdCompletion;this.handleOperationCompletionCommon(c,s,void 0,fi(a),"handleParkCompletion",ge.TIMEOUT_OPERATIONS.PARK_COMPLETION,Ft.PARK_COMPLETED,Ft.PARK_FAILED,this.signalingSessionCallback.onParkCompleted,this.handleParkError.bind(this))}handleUnparkError(n,a,s,c){this.disposed?this.logger.info("handleUnparkError ignored"):(this.logger.info(`[${s}] handleUnparkError reject reason: ${n}`),this.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.UNPARK_COMPLETION),this.signalingSessionCallback.onUnparkCompleted&&(this.telemetryHelper.recordEvent(a,{...n,parkContext:c,causeId:s}),this.signalingSessionCallback.onUnparkCompleted(n,s)),this.links[ge.LINKS.UNPARK]=void 0)}handleUnparkCompletion(n){const a=n.body,s=Po(n);if(this.disposed)return void this.logger.info(`[${s}]handleUnparkCompletion ignored`);this.logger.info(`[${s}][handleUnparkCompletion] body ${fi(a)}`);const c=a.resumeCompletion;c.code===ge.TRANSACTION_END_CODE.SUCCESS?(this.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.UNPARK_COMPLETION),this.telemetryHelper.recordEvent(Ft.UNPARK_COMPLETED,{...c,causeId:s}),this.signalingSessionCallback.onUnparkCompleted(c,s),this.links[ge.LINKS.UNPARK]=void 0):this.handleUnparkError(c,Ft.UNPARK_FAILED,s)}getNetworkRequestName(n){return{none:null,teamPark:$n.SEND_PARK_REQUEST.name,sharedLinePark:$n.SEND_SHARED_LINE_PARK_REQUEST.name,serverHold:$n.SEND_SERVER_HOLD_REQUEST.name}[n]}updateMeetingsGroupsAsync(n,a){this.logger.info(`[${n}][updateMeetingsGroupsAsync] scope=${a.scope}`),this.telemetryHelper.recordEvent(Ft.UPDATE_MEETING_GROUPS,{causeId:n,options:a}),this.timeoutManager.startTimer(ge.TIMEOUT_OPERATIONS.UPDATE_MEETING_GROUPS_COMPLETION,()=>{this.handleUpdateMeetingGroupsError({code:ge.CALL_END_CODE.TIMEOUT,subCode:ge.CALL_END_SUB_CODE.UPDATE_MEETING_GROUPS_COMPLETION_TIMEOUT,phrase:ge.CALL_END_PHRASE.UPDATE_MEETING_GROUPS_COMPLETION_TIMEOUT},Ft.WAITING_FOR_UPDATE_MEETING_GROUPS_COMPLETION,n,n,a)},ge.TIMEOUT_VALUES_IN_SECONDS.UPDATE_MEETING_GROUPS_COMPLETION_TIMEOUT);const s=wv(this,a,n);return this.http.sendPostRequest({url:this.links[ge.LINKS.UPDATE_MEETING_GROUPS],requestName:$n.UPDATE_MEETING_GROUPS.name,payload:s,causeId:n}).then(c=>{this.logger.info(`[${n}][updateMeetingsGroupsAsync] response: ${fi(c)}`),this.telemetryHelper.recordEvent(Ft.WAITING_FOR_UPDATE_MEETING_GROUPS_COMPLETION,{causeId:n})}).catch(c=>{const u=Lr(c,this.signalingAgentConfig);return this.logger.info(`[${n}][updateMeetingsGroupsAsync] error: ${fi(u)}`),this.disposed?Promise.reject(this.getCallNotFoundTransactionEnd()):(this.handleUpdateMeetingGroupsError(u.error,Ft.UPDATE_MEETING_GROUPS_REQUEST_FAILED,n,n,a),Promise.reject(u.error))})}updateMonitorSessionAsync(n,a){this.logger.info(`[${a}][updateMonitorSessionAsync]`),this.telemetryHelper.recordEvent(Ft.UPDATE_MONITOR_SESSION,{causeId:a,options:n}),this.timeoutManager.startTimer(ge.TIMEOUT_OPERATIONS.UPDATE_MONITOR_SESSION_COMPLETION,()=>{this.handleUpdateMonitorSessionError({code:ge.CALL_END_CODE.TIMEOUT,subCode:ge.CALL_END_SUB_CODE.UPDATE_MONITOR_SESSION_COMPLETION_TIMEOUT,phrase:ge.CALL_END_PHRASE.UPDATE_MONITOR_SESSION_COMPLETION_TIMEOUT},Ft.WAITING_FOR_UPDATE_MONITOR_SESSION_COMPLETION,a,n)},ge.TIMEOUT_VALUES_IN_SECONDS.UPDATE_MONITOR_SESSION_COMPLETION_TIMEOUT);const s=F2(this,n.monitorActionType,n.monitorData,a);return this.http.sendPostRequest({url:this.links[ge.LINKS.UPDATE_MONITOR_SESSION],requestName:$n.UPDATE_MONITOR_SESSION.name,payload:s,causeId:a}).then(c=>{this.logger.info(`[${a}][updateMonitorSessionAsync] response: ${fi(c)}`),this.telemetryHelper.recordEvent(Ft.WAITING_FOR_UPDATE_MONITOR_SESSION_COMPLETION,{causeId:a})}).catch(c=>{const u=Lr(c,this.signalingAgentConfig);return this.logger.info(`[${a}][updateMonitorSessionAsync] error: ${fi(u)}`),this.disposed?Promise.reject(this.getCallNotFoundTransactionEnd()):(this.handleUpdateMonitorSessionError(u.error,Ft.UPDATE_MONITOR_SESSION_REQUEST_FAILED,a,n),Promise.reject(u.error))})}updateParticipantInterpretationStateAsync(n,a){return lc(a,"options should be a non null value"),this.logger.info(`[${n}][updateParticipantInterpretationStateAsync]`),this.telemetryHelper.recordEvent(Ft.UPDATE_PARTICIPANT_INTERPRETATION_STATE,{causeId:n,options:a}),this.participantManager.updateParticipantInterpretationStateAsync(a,this.links[ge.LINKS.UPDATE_PARTICIPANT_INTERPRETATION_STATE],n)}async sendProxiedMessageAsync(n,a){return a&&a.length!==0?this.links[ge.LINKS.SEND_MESSAGE]?this.proxiedMessageNotificationManager.sendProxiedMessageAsync(n,a,this.links[ge.LINKS.SEND_MESSAGE]):Promise.reject({code:ge.VALIDATION.VALIDATION_FAILED,subCode:ge.VALIDATION.NULL_OR_EMPTY,phrase:"missing url for CONSTANTS.LINKS.SEND_MESSAGE"}):Promise.reject({code:ge.VALIDATION.VALIDATION_FAILED,subCode:ge.VALIDATION.NULL_OR_EMPTY,phrase:"options should be a non empty array"})}async updateParticipantsPropertiesAsync(n,a,s,c){this.telemetryHelper.recordEvent(Ft.UPDATE_PARTICIPANTS_PROPERTIES,{causeId:c,updateParticipantsPropertiesContext:n});const u=this.links[ge.LINKS.UPDATE_PARTICIPANTS_PROPERTIES],m=[],b=n.scope;if(b==="self"){const _={id:this.participantManager.localParticipant.id,propertyBag:n.propertyBag};m.push(_)}else{if(b!=="specified")return Promise.reject("This scope is not Supported");{const _=n.participants;for(const k of _){const N={id:k.id,propertyBag:k.propertyBag};m.push(N)}}}return this.sendNetworkRequestForUpdateParticipantsProperties(m,a,u,s,c)}sendNetworkRequestForUpdateParticipantsProperties(n,a,s,c,u){const m=this.logger.createChild(`[${u}][sendNetworkRequestForUpdateParticipantsProperties]`,this.correlationId);if(s){const b=()=>{const k={code:ge.CALL_END_CODE.TIMEOUT,subCode:ge.CALL_END_SUB_CODE.UPDATE_PARTICIPANTS_PROPERTIES_TIMEOUT,phrase:ge.CALL_END_PHRASE.UPDATE_PARTICIPANTS_PROPERTIES_TIMEOUT};this.timeoutManager.startTimer(ge.TIMEOUT_OPERATIONS.UPDATE_PARTICIPANTS_PROPERTIES_COMPLETION,()=>{this.handleUpdateParticipantsPropertiesOnTimeout(a,k,Ft.UPDATE_PARTICIPANTS_PROPERTIES_TIMEOUT,c,u)},ge.TIMEOUT_VALUES_IN_SECONDS.UPDATE_PARTICIPANTS_PROPERTIES_COMPLETION_TIMEOUT,c)},_=rye(this,n,c);return this.updateParticipantsPromises[c]=a,this.http.sendPostRequest({url:s,payload:_,requestName:$n.UPDATE_PARTICIPANTS_PROPERTIES.name,onceTrouterReady:b,causeId:u}).then(k=>{m.info(`response: ${fi(k)}`)}).catch(k=>{const N=Lr(k,this.signalingAgentConfig);m.info(`failed: ${fi(N)}`);const W={...N.error};return this.disposed||(this.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.UPDATE_PARTICIPANTS_PROPERTIES_COMPLETION,c),delete this.updateParticipantsPromises[c]),this.telemetryHelper.recordEvent(Ft.UPDATE_PARTICIPANTS_PROPERTIES_RESPONSE_FAILED,{causeId:u,transactionEnd:W}),Promise.reject(W)})}{const b={code:ge.CALL_END_CODE.REJECT,subCode:ge.CALL_END_SUB_CODE.UPDATE_PARTICIPANTS_PROPERTIES_LINK_MISSING,phrase:"updateParticipantsProperties link is missing"};return m.warn(b),this.telemetryHelper.recordEvent(Ft.UPDATE_PARTICIPANTS_PROPERTIES_RESPONSE_FAILED,{causeId:u,error:b}),Promise.reject(b)}}checkAndCleanupPromisesForOperationId(n){this.updateParticipantsPromises[n]&&(this.updateParticipantsPromises[n].size===0?(delete this.updateParticipantsPromises[n],this.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.UPDATE_PARTICIPANTS_PROPERTIES_COMPLETION,n)):this.logger.info(`remaining promises for the operation  ${n} (count: ${this.updateParticipantsPromises[n].size}):
                ${this.piiUtils.scrubMriOrOmit(xo(this.updateParticipantsPromises[n]))}`))}handleUpdateParticipantsPropertiesOnTimeout(n,a,s,c,u){if(this.disposed)return void this.logger.info("handleUpdateParticipantsPropertiesOnTimeout ignored");this.logger.createChild(`[${u}][handleUpdateParticipantsPropertiesOnTimeout]`,this.correlationId).info(`reason: ${a}`),this.telemetryHelper.recordEvent(s,{...a,causeId:u});const m={};n.forEach(b=>{m[b]=a,this.updateParticipantsPromises[c].delete(b)}),this.checkAndCleanupPromisesForOperationId(c),this.signalingSessionCallback.onUpdateParticipantsPropertiesCompleted(m,c,u)}joinMeetingGroupAsync(n,a){this.logger.info(`[${n}][joinMeetingGroupAsync]`),this.telemetryHelper.recordEvent(Ft.JOIN_MEETING_GROUP,{causeId:n,options:a}),this.timeoutManager.startTimer(ge.TIMEOUT_OPERATIONS.JOIN_MEETING_GROUP_COMPLETION,()=>{this.handleJoinMeetingGroupError({code:ge.CALL_END_CODE.TIMEOUT,subCode:ge.CALL_END_SUB_CODE.JOIN_MEETING_GROUP_TIMEOUT,phrase:ge.CALL_END_PHRASE.JOIN_MEETING_GROUP_TIMEOUT},Ft.WAITING_FOR_JOIN_MEETING_GROUP_COMPLETION,n,n,a)},ge.TIMEOUT_VALUES_IN_SECONDS.JOIN_MEETING_GROUP_COMPLETION_TIMEOUT);const s=qi(this,a,n);return this.http.sendPostRequest({url:this.links[ge.LINKS.JOIN_MEETING_GROUP],requestName:$n.JOIN_MEETING_GROUP.name,payload:s,causeId:n}).then(c=>{this.logger.info(`[${n}][joinMeetingGroupAsync] response: ${fi(c)}`),this.telemetryHelper.recordEvent(Ft.WAITING_FOR_JOIN_MEETING_GROUP_COMPLETION,{causeId:n})}).catch(c=>{const u=Lr(c,this.signalingAgentConfig);return this.logger.info(`[${n}][joinMeetingGroupAsync] error: ${fi(u)}`),this.disposed?Promise.reject(this.getCallNotFoundTransactionEnd()):(this.handleJoinMeetingGroupError(u.error,Ft.JOIN_MEETING_GROUP_REQUEST_FAILED,n,n,a),Promise.reject(u.error))})}leaveMeetingGroupAsync(n,a){this.logger.info(`[${n}][leaveMeetingGroupAsync]`),this.telemetryHelper.recordEvent(Ft.LEAVE_MEETING_GROUP,{causeId:n,options:a}),this.timeoutManager.startTimer(ge.TIMEOUT_OPERATIONS.LEAVE_MEETING_GROUP_COMPLETION,()=>{this.handleLeaveMeetingGroupError({code:ge.CALL_END_CODE.TIMEOUT,subCode:ge.CALL_END_SUB_CODE.LEAVE_MEETING_GROUP_TIMEOUT,phrase:ge.CALL_END_PHRASE.LEAVE_MEETING_GROUP_TIMEOUT},Ft.WAITING_FOR_LEAVE_MEETING_GROUP_COMPLETION,n,n,a)},ge.TIMEOUT_VALUES_IN_SECONDS.LEAVE_MEETING_GROUP_COMPLETION_TIMEOUT);const s=Wi(this,a,n);return this.http.sendPostRequest({url:this.links[ge.LINKS.LEAVE_MEETING_GROUP],requestName:$n.LEAVE_MEETING_GROUP.name,payload:s,causeId:n}).then(c=>{this.logger.info(`[${n}][leaveMeetingGroupAsync] response: ${fi(c)}`),this.telemetryHelper.recordEvent(Ft.WAITING_FOR_LEAVE_MEETING_GROUP_COMPLETION,{causeId:n})}).catch(c=>{const u=Lr(c,this.signalingAgentConfig);return this.logger.info(`[${n}][leaveMeetingGroupAsync] error: ${fi(u)}`),this.disposed?Promise.reject(this.getCallNotFoundTransactionEnd()):(this.handleLeaveMeetingGroupError(u.error,Ft.LEAVE_MEETING_GROUP_REQUEST_FAILED,n,n,a),Promise.reject(u.error))})}handleUpdateMeetingGroupsError(n,a,s,c,u){this.disposed?this.logger.info(`[${s}][handleUpdateMeetingGroupsError] ignored. Call disposed, err: ${JSON.stringify(n)}`):(this.logger.info(`[${s}][handleUpdateMeetingGroupsError] reject reason: ${JSON.stringify(n)}`),this.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.UPDATE_MEETING_GROUPS_COMPLETION),this.telemetryHelper.recordEvent(a,{...n,updateMeetingGroupsOptions:u,causeId:s}),this.signalingSessionCallback.onUpdateMeetingGroupsCompleted(n,s,c))}handleUpdateMeetingGroupsCompletion(n){const a=n.body,s=Po(n),c=a.updateMeetingGroupsResponse.operationId;if(this.disposed)return void this.logger.info(`[${s}][handleUpdateMeetingGroupsCompletion] ignored. Call disposed.`);c||this.logger.warn(`[${s}][handleUpdateMeetingGroupsCompletion] operationId is undefined.`),this.logger.info(`[${s}][handleUpdateMeetingGroupsCompletion] starts`);const{updateMeetingGroupsResponse:u}=a,m=kV(u);m.code===ge.TRANSACTION_END_CODE.SUCCESS?(this.logger.info(`[${s}][handleUpdateMeetingGroupsCompletion] update meeting group succeeded`),this.telemetryHelper.recordEvent(Ft.UPDATE_MEETING_GROUPS_RESPONSE_SUCCESS,{...m,causeId:s})):(this.logger.info(`[${s}][handleUpdateMeetingGroupsCompletion] update meeting group failed code=${m.code} subCode=${m.subCode}`),this.telemetryHelper.recordEvent(Ft.UPDATE_MEETING_GROUPS_RESPONSE_FAILURE,{...m,causeId:s})),this.logger.info(`[${s}][handleUpdateMeetingGroupsCompletion] completes`),this.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.UPDATE_MEETING_GROUPS_COMPLETION),this.signalingSessionCallback.onUpdateMeetingGroupsCompleted(m,s,c)}handleJoinMeetingGroupError(n,a,s,c,u){this.disposed?this.logger.info(`[${s}][handleJoinedMeetingGroupError] ignored. Call disposed, err: ${JSON.stringify(n)}`):(this.logger.info(`[${s}][handleJoinedMeetingGroupError] reject reason: ${JSON.stringify(n)}`),this.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.JOIN_MEETING_GROUP_COMPLETION),this.telemetryHelper.recordEvent(a,{...n,joinMeetingGroupOptions:u,causeId:s}),this.signalingSessionCallback.onJoinMeetingGroupCompleted(n,s,c))}handleJoinMeetingGroupCompletion(n){const a=n.body.joinMeetingGroupResponse,s=Po(n),c=a.operationId;if(this.disposed)return void this.logger.info(`[${s}][handleJoinMeetingGroupCompletion] ignored. Call disposed.`);c||this.logger.warn(`[${s}][handleJoinMeetingGroupCompletion] operationId is undefined.`),this.logger.info(`[${s}][handleJoinMeetingGroupCompletion] starts`);const u=kV(a);u.code===ge.TRANSACTION_END_CODE.SUCCESS?(this.logger.info(`[${s}][handleJoinMeetingGroupCompletion] join meeting group succeeded`),this.telemetryHelper.recordEvent(Ft.JOIN_MEETING_GROUP_RESPONSE_COMPLETED,{...u,causeId:s})):(this.logger.info(`[${s}][handleJoinMeetingGroupCompletion] join meeting group failed code=${u.code} subCode=${u.subCode}`),this.telemetryHelper.recordEvent(Ft.JOIN_MEETING_GROUP_RESPONSE_FAILED,{...u,causeId:s})),this.logger.info(`[${s}][handleJoinMeetingGroupCompletion] complete`),this.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.JOIN_MEETING_GROUP_COMPLETION),this.signalingSessionCallback.onJoinMeetingGroupCompleted(u,s,c)}handleLeaveMeetingGroupError(n,a,s,c,u){this.disposed?this.logger.info(`[${s}][handleLeaveMeetingGroupError] ignored. Call disposed, err: ${JSON.stringify(n)}`):(this.logger.info(`[${s}][handleLeaveMeetingGroupError] reject reason: ${JSON.stringify(n)}`),this.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.LEAVE_MEETING_GROUP_COMPLETION),this.telemetryHelper.recordEvent(a,{...n,leaveMeetingGroupOptions:u,causeId:s}),this.signalingSessionCallback.onLeaveMeetingGroupCompleted(n,s,c))}handleLeaveMeetingGroupCompletion(n){const a=n.body.leaveMeetingGroupResponse,s=Po(n),c=a.operationId;if(this.disposed)return void this.logger.info(`[${s}][handleLeaveMeetingGroupCompletion] ignored. Call disposed.`);c||this.logger.warn(`[${s}][handleLeaveMeetingGroupCompletion] operationId is undefined.`),this.logger.info(`[${s}][handleLeaveMeetingGroupCompletion] starts`);const u=kV(a);u.code===ge.TRANSACTION_END_CODE.SUCCESS?(this.logger.info(`[${s}][handleLeaveMeetingGroupCompletion] leave meeting group succeeded`),this.telemetryHelper.recordEvent(Ft.LEAVE_MEETING_GROUP_RESPONSE_COMPLETED,{...u,causeId:s})):(this.logger.info(`[${s}][handleLeaveMeetingGroupCompletion] leave meeting group failed code=${u.code} subCode=${u.subCode}`),this.telemetryHelper.recordEvent(Ft.LEAVE_MEETING_GROUP_RESPONSE_FAILED,{...u,causeId:s})),this.logger.info(`[${s}][handleLeaveMeetingGroupCompletion] complete`),this.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.LEAVE_MEETING_GROUP_COMPLETION),this.signalingSessionCallback.onLeaveMeetingGroupCompleted(u,s,c)}handleDisablePreheatError(n,a,s){this.disposed?this.logger.info(`[${s}][handleDisablePreheatError] ignored. Call disposed, err: ${JSON.stringify(n)}`):(this.logger.info(`[${s}][handleDisablePreheatError] reject reason: ${JSON.stringify(n)}`),this.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.DISABLE_PREHEAT_ASYNC_TIMEOUT),this.telemetryHelper.recordEvent(a,{...n,causeId:s}),this.disablePreheatDefer.isPending()&&this.disablePreheatDefer.reject(n))}handleDisablePreheatCompletion(n){const a=n.body,s=Po(n),c=a.transactionEnd;if(this.disposed)this.logger.info(`[${s}][handleDisablePreheatCompletion] ignored. Call disposed.`);else if(this.disablePreheatDefer.isPending()){if(this.logger.info(`[${s}][handleDisablePreheatCompletion] starts`),this.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.DISABLE_PREHEAT_ASYNC_TIMEOUT),c.code===ge.TRANSACTION_END_CODE.SUCCESS)this.logger.info(`[${s}][handleDisablePreheatCompletion] update endpoint state succeeded`),this.handleEndpointStateUpdated(s,!0);else if(this.logger.info(`[${s}][handleDisablePreheatCompletion] update endpoint state failed code=${c.code} subCode=${c.subCode}`),this.disablePreheatDefer.isPending()){const u={response:c};this.disablePreheatDefer.reject(u)}}else this.logger.info(`[${s}][handleDisablePreheatCompletion] ignored. Disable preheat promise is resolved/rejected.`)}handleReceiveMessage(n){const a=Po(n);if(this.disposed)return void this.logger.info(`[${a}][handleReceiveMessage] ignored. Call disposed.`);let s;s=Array.isArray(n.body?.messageContent)?n.body.messageContent:[n.body];let c="";const u=[];for(let m=0;m<s.length;m++){const b=s[m];c+=b?.operationId,m<s.length-1&&(c+=","),u.push({operationId:b.operationId,messageType:b.type,payload:b.payload,from:{[b.from.id]:{participantLegIdMap:{[b.from.participantId]:{...b.from.endpointId&&{endpointId:b.from.endpointId}}},level:"endpoint"}}})}this.logger.info(`[${a}][handleReceiveMessage] complete. OperationIds:${c}`),this.telemetryHelper.recordEvent(Ft.INCOMING_PROXIED_MESSAGES,{causeId:a,operationIds:c}),this.signalingSessionCallback.onIncomingProxiedMessages(u,a)}publishStateAsync(n,a,s,c,u,m){this.logger.info(`[${s}][publishStateAsync][publishType=${n} publishLevel=${a}]`),this.telemetryHelper.recordEvent(Ft.PUBLISH_STATE,{causeId:s,publishType:n,publishLevel:a});const b=this.links[ge.LINKS.PUBLISH_STATE];if(!b){const k={code:ge.CALL_END_CODE.REJECT,subCode:ge.CALL_END_SUB_CODE.PUBLISH_STATE_LINK_MISSING,phrase:"publish state link is missing"};return this.logger.warn(k),Promise.reject(k)}let _={};try{_=JSON.parse(c)}catch{const N={code:ge.CALL_END_CODE.REJECT,subCode:ge.CALL_END_SUB_CODE.PUBLISH_STATE_INVALID_CONTENT,phrase:"publish state content is invalid"};return this.logger.warn(N),Promise.reject(N)}return this.http.sendPostRequest({url:b,requestName:$n.PUBLISH_STATE.name,payload:rs(this,n,a,_,u,m),causeId:s,requestId:s}).then(k=>{if(k?.response?.publishStateResponse)return this.parsePublishStateResult(k,s);{const N=`Invalid CS response which does not contains publishStateResponse. Respone: ${k?.response?JSON.stringify(k.response):"no response"}`;throw this.logger.warn(N),{response:{code:ge.CALL_END_CODE.DECODING_FAILED,subCode:ge.CALL_END_SUB_CODE.PUBLISH_STATE_INVALID_SERVICE_RESPONSE,phrase:N}}}}).catch(k=>{const N=Lr(k,this.signalingAgentConfig);this.logger.info(`[${s}][publishStateAsync] error: ${fi(N)}`);const W=N.error;return this.telemetryHelper.recordEvent(Ft.PUBLISH_STATE_FAILURE,{causeId:s,transactionEnd:W}),Promise.reject(W)})}getPublishStateSequenceNumber(){return++this.publishStateSequenceNumber}getMonitorSequenceId(){return++this.monitorSequenceId}parsePublishStateResult(n,a){let s={};if(n?.response?.publishStateResponse){if(n.response.publishStateResponse.stateId)return n.response.publishStateResponse.stateId;if(n.response.publishStateResponse.results){if(n.response.publishStateResponse.results.length===1){if(n.response.publishStateResponse.results[0].stateId)return n.response.publishStateResponse.results[0].stateId;this.logger.warn("invalid response format")}return n.response.publishStateResponse.results.forEach(u=>{s[u.participantId]={code:u.result.code,phrase:u.result.phrase,subCode:u.result.subCode}}),JSON.stringify(s)}if(n.response.publishStateResponse.result)return s={code:n.response.publishStateResponse.result.code,phrase:n.response.publishStateResponse.result.phrase,subCode:n.response.publishStateResponse.result.subCode,result:n.response.publishStateResponse.additionalDetail},JSON.stringify(s)}const c=`Invalid CS response which does not contains publishStateResponse. Respone: ${n?.response?JSON.stringify(n.response):"no response"}`;throw this.logger.warn(c),{response:{code:ge.CALL_END_CODE.DECODING_FAILED,subCode:ge.CALL_END_SUB_CODE.PUBLISH_STATE_INVALID_SERVICE_RESPONSE,phrase:c}}}removeStateAsync(n,a,s,c){if(this.logger.info(`[${n}][removeStateAsync][scope=${a} publishType=${s} stateIds=${c}]`),this.telemetryHelper.recordEvent(Ft.REMOVE_STATE,{causeId:n,scope:a,publishType:s,stateIds:c}),!s&&!c){const m={code:ge.CALL_END_CODE.REJECT,subCode:ge.CALL_END_SUB_CODE.REMOVE_STATE_MISSING_ARGUMENTS,phrase:"remove state operation miss arguments"};return this.logger.warn(m),Promise.reject(m)}const u=this.links[ge.LINKS.REMOVE_STATE];if(!u){const m={code:ge.CALL_END_CODE.REJECT,subCode:ge.CALL_END_SUB_CODE.REMOVE_STATE_LINK_MISSING,phrase:"remove state link is missing"};return this.logger.warn(m),Promise.reject(m)}return this.http.sendPostRequest({url:u,requestName:$n.REMOVE_STATE.name,payload:cc(this,a,c,s),causeId:n,requestId:n}).then(m=>this.parseRemoveStateResult(m,n)).catch(m=>{const b=Lr(m,this.signalingAgentConfig);this.logger.info(`[${n}][removeStateAsync] error: ${fi(b)}`);const _=b.error;return this.telemetryHelper.recordEvent(Ft.REMOVE_STATE_FAILURE,{causeId:n,transactionEnd:_}),Promise.reject(_)})}parseRemoveStateResult(n,a){let s={};return n?.response?.removeStateResponse&&(n.response.removeStateResponse.results?n.response.removeStateResponse.results.forEach(c=>{s[c.stateId]={code:c.result.code,phrase:c.result.phrase,subCode:c.result.subCode}}):n.response.removeStateResponse.result&&(s={code:n.response.removeStateResponse.result.code,phrase:n.response.removeStateResponse.result.phrase,subCode:n.response.removeStateResponse.result.subCode,result:n.response.removeStateResponse.additionalDetail})),JSON.stringify(s)}updateMeetingSettingsAsync(n,a){this.telemetryHelper.recordEvent(Ft.UPDATE_MEETING_SETTINGS,{causeId:a,meetingSettings:n});const s=this.links[ge.LINKS.UPDATE_MEETING_SETTINGS];if(!s){const c={code:ge.CALL_END_CODE.REJECT,subCode:ge.CALL_END_SUB_CODE.UPDATE_MEETING_SETTINGS_LINK_MISSING,phrase:"update meeting settings link is missing"};return this.logger.warn(c),Promise.reject(c)}if(!Object.keys(n).length){const c={code:ge.CALL_END_CODE.REJECT,subCode:ge.CALL_END_SUB_CODE.UPDATE_MEETING_SETTINGS_MISSING_ARGUMENTS,phrase:"update meeting settings missing arguments"};return this.logger.warn(c),Promise.reject(c)}return this.http.sendPutRequest({url:s,requestName:$n.UPDATE_MEETING_SETTINGS.name,payload:EN(this,n),causeId:a,requestId:a}).then(()=>{GR.noop()}).catch(c=>{const u=Lr(c,this.signalingAgentConfig);this.logger.info(`[${a}][updateMeetingSettingsAsync] error: ${fi(u)}`);const m=u.error;throw this.telemetryHelper.recordEvent(Ft.UPDATE_MEETING_SETTINGS_FAILURE,{causeId:a,transactionEnd:m}),m})}searchParticipantsAsync(n,a){this.logger.info(`[${a}][searchParticipantsAsync][queryOptions=${n}]`),this.telemetryHelper.recordEvent(Ft.SEARCH_PARTICIPANTS,{causeId:a,queryOptions:n});const s=this.links[ge.LINKS.SEARCH_PARTICIPANTS];if(!s){const c={code:ge.CALL_END_CODE.REJECT,subCode:ge.CALL_END_SUB_CODE.SEARCH_PARTICIPANTS_LINK_MISSING,phrase:"search participants link is missing"};return this.logger.warn(c),Promise.reject(c)}return this.http.sendPostRequest({url:s,requestName:$n.SEARCH_PARTICIPANTS.name,payload:vp(this,n),causeId:a,requestId:a}).then(c=>{if(c?.response?.participants)return this.parseSearchParticipantsResult(c,a);{const u=`Invalid CS response which does not contain proper search results. Respone: ${c?.response?JSON.stringify(c.response):"no response"}`;throw this.logger.warn(u),{response:{code:ge.CALL_END_CODE.DECODING_FAILED,subCode:ge.CALL_END_SUB_CODE.SEARCH_PARTICIPANTS_INVALID_SERVICE_RESPONSE,phrase:u}}}}).catch(c=>{const u=Lr(c,this.signalingAgentConfig);this.logger.info(`[${a}][searchParticipantsAsync] error: ${fi(u)}`);const m=u.error;return this.telemetryHelper.recordEvent(Ft.SEARCH_PARTICIPANTS_FAILURE,{causeId:a,transactionEnd:m}),Promise.reject(m)})}parseSearchParticipantsResult(n,a){const s=[];if(n?.response){const c=n.response.participants;if(c)for(const u of Object.keys(c))s.push(X0.fromRosterSearchResults(n.response.participants[u]))}return{participants:s}}getAllParticipantsAsync(n,a){this.logger.info(`[${a}][getAllParticipantsAsync][scope=${n}]`),this.telemetryHelper.recordEvent(Ft.GET_ALL_PARTICIPANTS,{causeId:a,scope:n});const s=this.links[ge.LINKS.GET_ALL_PARTICIPANTS];if(!s){const c={code:ge.CALL_END_CODE.REJECT,subCode:ge.CALL_END_SUB_CODE.GET_ALL_PARTICIPANTS_LINK_MISSING,phrase:"get all participants link is missing"};return this.logger.warn(c),Promise.reject(c)}if(n!=="lobby"){const c={code:ge.CALL_END_CODE.REJECT,subCode:ge.CALL_END_SUB_CODE.GET_ALL_PARTICIPANTS_INVALID_SCOPE,phrase:"get all participants scope is invalid"};return this.logger.warn(c),Promise.reject(c)}return this.http.sendPostRequest({url:s,requestName:$n.GET_ALL_PARTICIPANTS.name,payload:Dl(this,n),causeId:a,requestId:a}).then(c=>{if(c?.response)return{participants:c.response.participants};{const u="Invalid CS response which does not contain results.";throw this.logger.warn(u),{response:{code:ge.CALL_END_CODE.DECODING_FAILED,subCode:ge.CALL_END_SUB_CODE.GET_ALL_PARTICIPANTS_INVALID_SERVICE_RESPONSE,phrase:u}}}}).catch(c=>{const u=Lr(c,this.signalingAgentConfig);this.logger.info(`[${a}][getAllParticipantsAsync] error: ${fi(u)}`);const m=u.error;return this.telemetryHelper.recordEvent(Ft.GET_ALL_PARTICIPANTS_FAILURE,{causeId:a,transactionEnd:m}),Promise.reject(m)})}resetState(){this.currentCallStatus=null,this.fsmState=ge.SIGNALING_FSM_STATE.IDLE}saveUpdatedCallLinksIfAny(n){n.links&&(this.logger.info(`saveUpdatedCallLinksIfAny, updated call links found, update to new links ${fi(n)}`),this.links[ge.LINKS.MEDIA_RENEGOTIATION]=n.links.mediaRenegotiation||this.links[ge.LINKS.MEDIA_RENEGOTIATION],this.links[ge.LINKS.TRANSFER]=n.links.transfer||this.links[ge.LINKS.TRANSFER],this.links[ge.LINKS.REPLACE]=n.links.replacement||this.links[ge.LINKS.REPLACE],this.links[ge.LINKS.HANGUP]=n.links.callLeg||this.links[ge.LINKS.HANGUP],this.links[ge.LINKS.KEEPALIVE]=n.links.callLeg||this.links[ge.LINKS.KEEPALIVE],this.links[ge.LINKS.PARK]=n.links.hold||this.links[ge.LINKS.PARK],this.links[ge.LINKS.UPDATE_MEDIA_DESCRIPTIONS]=n.links.updateMediaDescriptions||this.links[ge.LINKS.UPDATE_MEDIA_DESCRIPTIONS],this.links[ge.LINKS.UPDATE_MONITOR_SESSION]=n.links.monitor||this.links[ge.LINKS.UPDATE_MONITOR_SESSION])}ensureMessageChannelReady(n){return this.disposed?(this.logger.info("ensureMessageChannelReady: error: call already disposed"),Promise.reject(this.getCallNotFoundTransactionEnd())):this.brokerService?(this.telemetryHelper.addTrouterWaitOperation(`${ei.TROUTER_WAIT_OPERATION.STARTED}:${n}`),this.telemetryHelper.addTrouterWaitOperation(`${ei.TROUTER_WAIT_OPERATION.ENDED}:${n}`),Promise.resolve()):this.ensureLatestTrouterUrl(n)}ensureLatestTrouterUrl(n){return this.telemetryHelper.addTrouterWaitOperation(`${ei.TROUTER_WAIT_OPERATION.STARTED}:${n}`),this.getTrouterUrlAsync().then(a=>!a||typeof a=="string"&&!a.trim()?(this.telemetryHelper.recordEvent(Ft.TROUTER_URL_CHANGED_TO_INVALID),this.telemetryHelper.addTrouterWaitOperation(`${ei.TROUTER_WAIT_OPERATION.ENDED}:${n}`),Promise.reject(new Error("Invalid trouter url"))):this.disposed?(this.logger.info("ensureLatestTrouterUrl, trouterUrlGetter returned too late. Object is already disposed"),Promise.reject(this.getCallNotFoundTransactionEnd())):(this.telemetryHelper.addTrouterWaitOperation(`${ei.TROUTER_WAIT_OPERATION.ENDED}:${n}`),this.baseMessagingChannelUrl=this.currentTrouterUrl=a,Promise.resolve())).catch(a=>(this.disposed||this.telemetryHelper.addTrouterWaitOperation(`${ei.TROUTER_WAIT_OPERATION.FAILED}:${n}`),this.logger.info(`ensureLatestTrouterUrl, failed because:${a}`),Promise.reject(a)))}signalTransferAcceptedAsync(n,a=tr()){return this.logger.info(`[signalTransferAcceptedAsync][${a}] transferType ${n}`),this.disposed?(this.logger.info(`[signalTransferAcceptedAsync][${a}] Call already ended, skip acceptance request`),Promise.reject({code:ge.CALL_END_CODE.CALL_DOES_NOT_EXIST,reason:null})):(this.telemetryHelper.recordEvent(Ft.SEND_ACCEPT_TRANSFER,{causeId:a,transferType:n}),this.http.sendPostRequest({url:this.links[ge.LINKS.TRANSFER_ACCEPTANCE],requestName:$n.TRANSFER_ACCEPTANCE.name,payload:zh(),causeId:a}).catch(s=>{const c=Lr(s,this.signalingAgentConfig);return this.logger.info(`[signalTransferAcceptedAsync][${a}] error: ${fi(c)}`),this.telemetryHelper.recordEvent(Ft.SEND_ACCEPT_TRANSFER_FAIL,{causeId:a}),Promise.reject(c.error)}))}signalTransferCompletedAsync(n,a=tr()){return this.logger.info(`[signalTransferCompletedAsync][${a}] rejectReason ${n}`),this.disposed?(this.logger.info(`[signalTransferCompletedAsync][${a}]  Call already ended by transferor, skip completion request`),Promise.reject({code:ge.CALL_END_CODE.CALL_DOES_NOT_EXIST,reason:null})):(n.code!==0?this.telemetryHelper.recordEvent(Ft.TRANSFER_COMPLETION_FAILED,{code:n.code,subcode:n.subCode,causeId:a}):this.telemetryHelper.recordEvent(Ft.TRANSFER_COMPLETED,{causeId:a}),this.telemetryHelper.recordEvent(Ft.SEND_COMPLETE_TRANSFER,{causeId:a}),this.http.sendPostRequest({url:this.links[ge.LINKS.TRANSFER_COMPLETION],requestName:$n.TRANSFER_COMPLETION.name,payload:If(n),causeId:a}).catch(s=>{this.telemetryHelper.recordEvent(Ft.SEND_COMPLETE_TRANSFER_FAILED,{causeId:a});const c=Lr(s,this.signalingAgentConfig);return this.logger.info(`[signalTransferCompletedAsync][${a}] error: ${fi(c)}`),Promise.reject(c.error)}))}async rejectCallWithFetchAndKeepAlive(n){this.telemetryHelper.recordEvent(Ft.REJECT_WITH_FETCH_KEEP_ALIVE,{causeId:n});const a={code:ge.CALL_END_CODE.REJECT,subCode:ge.CALL_END_SUB_CODE.BEACON,phrase:ge.CALL_END_PHRASE.LOCAL_USER_INITIATED,resultCategories:[Pu.Success]};await this.http.sendDeleteRequest({url:this.links[ge.LINKS.REJECT],requestName:$n.REJECT_CALL.name,payload:Bc(this,a),causeId:n??tr(),requestId:My(),useFetch:!0,fetchUseKeepAlive:!0})}async endCallWithFetchAndKeepAlive(n,a,s,c){this.telemetryHelper.recordEvent(Ft.END_WITH_FETCH_KEEP_ALIVE,{causeId:c}),await this.http.sendPostRequest({url:n,requestName:$n.END_CALL.name,payload:a,causeId:c??tr(),requestId:My(),useFetch:!0,fetchUseKeepAlive:!0})}endWithBeacon(n){if(this.disposed)return!1;const a=()=>{this.onCallStatusChanged(ge.CALL_STATUS.LOCAL_TERMINATED,n,s),this.dispose(s,n)};if(this.signalingAgentConfig.enableFetchRequestWithKeepAlive&&window.Request?.prototype?.hasOwnProperty("keepalive")&&this.currentCallStatus===ge.CALL_STATUS.RINGING)return this.rejectCallWithFetchAndKeepAlive(n),a(),!0;const s={code:ge.CALL_END_CODE.SUCCESS,subCode:ge.CALL_END_SUB_CODE.BEACON,phrase:ge.CALL_END_PHRASE.LOCAL_USER_INITIATED},c=JSON.stringify(bn(this,s).payload),u=this.links[ge.LINKS.LEAVE].indexOf("?")===-1?"?":"&",m=this.signalingAgent?.authTokenManager?.getLastTokenType(n),b=this.signalingAgent?.authTokenManager?.getLastToken(n);let _="";switch(m){case 4:case 8:this.logger.info(`[endWithBeacon] with tokenType:${m},token size:${b.length},query parameter:access_token`),_=`${this.links[ge.LINKS.LEAVE]}${u}access_token=${b}`;break;default:this.logger.info(`[endWithBeacon] with tokenType:${m},token size:${b.length},query parameter:skypeToken`),_=`${this.links[ge.LINKS.LEAVE]}${u}skypeToken=${b}`}return this.signalingAgentConfig.enableFetchApiForBeacon&&window.Request?.prototype?.hasOwnProperty("keepalive")?(this.endCallWithFetchAndKeepAlive(_,c,s,n),a(),!0):!!navigator?.sendBeacon&&(this.telemetryHelper.recordEvent(Ft.END_WITH_BEACON,{causeId:n}),navigator.sendBeacon(_,c))}setFsmState(n){this.fsmState=n}setIsHostless(n,a){const s=!!n;this.isHostLessCall!==s&&(this.logger.info(`[${a}][setIsHostless] isHostless=${s}`),this.isHostLessCall=s)}hasGroupModality(){return this.threadId||this.groupId}processConversationServiceResponseHeaders(n,a){this.logger.info(`[${a}][processConversationServiceResponseHeaders]`);try{const s=n.request.headers[ge.HEADERS.CORRELATION_ID]||n.request.headers[ge.HEADERS.CORRELATION_ID.toLowerCase()];this.updateCorrelationId(s,a)}catch(s){this.logger.info(`[${a}][processConversationServiceResponseHeaders] failed, reason=${fi(s)}`)}}processConversationServiceResponse(n,a,s){const c=this.logger.createChild(`[${a}][processConversationServiceResponse]`);if(c.info(`responseType :${s}`),this.processConversationServiceUpdate(n,a),n.subscriptionDetails?.selfParticipant){const u=X0.fromRoster(n.subscriptionDetails.selfParticipant,!0);c.info("converted selfParticipant to Participant type"),this.participantManager.updateLocalParticipantFromSubscribe(u,a)}n.selfParticipant?.enableCaptcha&&this.participantManager.setEnableCaptcha(!0,a),this.handleBrokerSubscription(n,a),n.roster&&this.internalHandleRosterUpdate(n.roster,!0,a),s===0&&(this.startOrJoinConvResponseReceived=!0,this.handlePendingEndpointState(a))}processConversationServiceUpdate(n,a){const s=this.logger.createChild(`[${a}][processConversationServiceUpdate]`);s.info(),this.convJoined=!0;const c=n.sequenceNumber>=0?n.sequenceNumber:-1;c<this.updateSequenceNumber?s.info(`seqNum=${c} is less than latest seqNum=${this.updateSequenceNumber}`):(this.updateSequenceNumber=c,this.links[ge.LINKS.CONVERSATION_CONTROLLER]=n.conversationController,this.links[ge.LINKS.ADD_PARTICIPANT]=n.links.addParticipant,this.links[ge.LINKS.ADD_PARTICIPANTS_AND_MODALITY]=n.links.addParticipantAndModality,this.links[ge.LINKS.LEAVE]=n.links.leave,this.links[ge.LINKS.NOTIFICATION_LINKS]=n.links.notificationLinks,this.links[ge.LINKS.REMOVE_PARTICIPANT]=n.links.removeParticipant,this.links[ge.LINKS.ADD_MODALITY]=n.links.addModality,this.links[ge.LINKS.REMOVE_MODALITY]=n.links.removeModality,this.links[ge.LINKS.MUTE]=n.links.mute||null,this.links[ge.LINKS.UNMUTE]=n.links.unmute||null,this.links[ge.LINKS.ADMIT]=n.links.admit||null,this.links[ge.LINKS.ADMIT_ALL]=n.links.admitAll||null,this.links[ge.LINKS.UPDATE_ENDPOINT_STATE]=n.links.updateEndpointState||null,this.links[ge.LINKS.UPDATE_ENDPOINT_METADATA]=n.links.updateEndpointMetadata||null,this.links[ge.LINKS.UPDATE_PARTICIPANT_ROLE]=n.links.updateParticipantRole||null,this.links[ge.LINKS.PUBLISH_STATE]=n.links.publishState||null,this.links[ge.LINKS.REMOVE_STATE]=n.links.removeState||null,this.links[ge.LINKS.UPDATE_MEETING_SETTINGS]=n.links.updateMeetingSettings||null,this.links[ge.LINKS.SEARCH_PARTICIPANTS]=n.links.searchParticipants||null,this.links[ge.LINKS.GET_ALL_PARTICIPANTS]=n.links.getAllParticipants||null,this.links[ge.LINKS.UPDATE_MEETING_LIVE_STATE]=n.links.updateMeetingLiveState||null,this.links[ge.LINKS.UPDATE_MEETING_GROUPS]=n.links.updateMeetingGroups||null,this.links[ge.LINKS.SET_MEETING_LAYOUT]=n.links.setMeetingLayout||null,this.links[ge.LINKS.UPDATE_PARTICIPANT_INTERPRETATION_STATE]=n.links.updateParticipantInterpretationState||null,this.links[ge.LINKS.UPDATE_PARTICIPANTS_PROPERTIES]=n.links.updateParticipantProperties||null,this.links[ge.LINKS.JOIN_MEETING_GROUP]=n.links.joinMeetingGroup||null,this.links[ge.LINKS.LEAVE_MEETING_GROUP]=n.links.leaveMeetingGroup||null,this.links[ge.LINKS.SEND_MESSAGE]=n.links.sendMessage||null,this.links[ge.LINKS.UPDATE_MEETING_STATES]=n.links.updateMeetingStates||null,this.convSubject=n.subject,n.state&&(this.setMultiParty(n.state.isMultiParty,a),this.setIsHostless(n.state.isHostless||!1,a),this.conversationType=n.state.conversationType,this.isCastCall=n.state.conversationType==="cast",this.isHuddleGroupCall=n.state.conversationType==="huddleGroupCall"),n.activeModalities&&n.activeModalities.groupChat&&this.updateGroupChatIds(n.activeModalities.groupChat,a),n.activeModalities&&n.activeModalities.broadcast&&(this.broadcastSession||(this.broadcastSession=new RV(this,this.signalingSessionCallback)),this.broadcastSession.handleBroadcastDetailsChanged(n,a)),this.handleMeetingDetailsChanged(n,a),this.handleMeetingStatesChanged(n,a),this.linkUpdateRequested.conversationLinks?(s.info("Updating CS links as requested"),this.updateLinks(this.updateConversationLinks,a)):this.scheduleConversationKeepAlive(),n.meetingData&&(this.meetingData=n.meetingData),n.meetingInfo&&(this.meetingInfo=n.meetingInfo),n.region&&(this.region=n.region),n.callLimits&&(this.callLimits=n.callLimits),n.complianceRecordingContent&&(this.complianceRecordingContent=n.complianceRecordingContent),n.conversationStartTime&&(this.conversationStartTime=n.conversationStartTime),n.layoutDetails&&(this.meetingLayoutDetails=n.layoutDetails),n.compositionServiceDetails&&(this.compositionServiceDetails=n.compositionServiceDetails),this.signalingSessionCallback.onConversationUpdated({conversationType:this.conversationType,groupId:this.groupId,threadId:this.threadId,teamsMessageId:this.teamsMessageId,isMultiParty:this.multiParty,commandUrlPresence:this.getCommandUrlPresence(),meetingData:this.meetingData,region:this.region,meetingInfo:this.meetingInfo,callLimits:this.callLimits,complianceRecordingContent:this.complianceRecordingContent,conversationStartTime:this.conversationStartTime,isHuddleGroupCall:this.isHuddleGroupCall,backroomThreadId:this.backroomThreadId,streamThreadId:this.streamThreadId,lobbyThreadId:this.lobbyThreadId,meetingLayoutDetails:this.meetingLayoutDetails,compositionServiceDetails:this.compositionServiceDetails},a))}processLocalParticipantUpdateResponse(n,a){this.logger.info(`[${a}][processLocalParticipantUpdateResponse]`),n.sequenceNumber&&n.sequenceNumber<this.localParticipantUpdateSequenceNumber||(this.breakoutDetails=n.breakoutDetails||{},this.signalingSessionCallback.onBreakoutDetailsUpdated(this.breakoutDetails,a),n.nudgeToJoinAsRealtime===!0&&(this.telemetryHelper.recordEvent(Ft.NUDGE_TO_JOIN_REALTIME,{causeId:a}),this.signalingSessionCallback.onNudgeToJoinRealtime(a)))}handlePendingEndpointState(n){this.requestedEndpointStateWhileConnecting&&(this.logger.info(`[${n}][handlePendingEndpointState]sending pending endpoint state now that we are connected.`),this.updateEndpointState(this.requestedEndpointStateWhileConnecting,n,this.requestedPublishedStatesWhileConnecting).catch(a=>{this.isPreheatOnly&&this.disablePreheatDefer.isPending()&&(this.logger.info("handlePendingEndpointState failed"),this.disablePreheatDefer.reject(a))}))}handleMeetingDetailsChanged(n,a){this.logger.info(`[${a}][handleMeetingDetailsChanged]`),n.meetingDetails&&!GR.isEqual(n.meetingDetails,this.meetingDetails)&&this.signalingSessionCallback.onMeetingDetailsUpdated&&(this.meetingDetails=n.meetingDetails,this.meetingDetails.meetingCapability?.meetingLiveState&&(this.meetingLiveStateSequenceNumber=this.meetingDetails.meetingCapability.meetingLiveState.seqNum,this.logger.info(`[${a}][handleMeetingDetailsChanged] update meeting seqNum as ${this.meetingLiveStateSequenceNumber}`)),this.signalingSessionCallback.onMeetingDetailsUpdated(this.meetingDetails,a))}handleMeetingStatesChanged(n,a){this.logger.info(`[${a}][handleMeetingStatesChanged]`),this.signalingSessionCallback.onMeetingStatesUpdated&&this.signalingSessionCallback.onMeetingStatesUpdated(n.meetingStates,a)}handleBrokerSubscription(n,a){this.logger.info(`[${a}][handleBrokerSubscription]`),n.links.subscribe?(this.telemetryHelper.recordEvent(Ft.SUBSCRIBE_URL_FOUND,a),this.brokerService&&!GR.isEqual(n.links.subscribe,this.brokerService.currentSubscriptionUrl)?this.brokerService.subscribeToBroker(n.links.subscribe):(this.logger.info(`[${a}][handleBrokerSubscription] broker subscribe ignored. Broker is disabled or subscribe url is same.`),this.telemetryHelper.recordEvent(Ft.BROKER_DISABLED_SUBSCRIBE_URL_PRESENT,a))):this.telemetryHelper.recordEvent(Ft.SUBSCRIBE_URL_MISSING,a)}cancelOutgoingCall(n,a){const s=Pl();this.logger.info(`[${a}][cancelOutgoingCall][rejectionData=${n&&fi(n)}]`);const c={code:isNaN(n?.code)?ge.CALL_END_CODE.CANCEL:n.code,subCode:n?.subCode||ge.CALL_END_SUB_CODE.SUCCESS,phrase:n?.phrase||ge.CALL_END_PHRASE.LOCAL_USER_INITIATED,resultCategories:n?.resultCategories||[Pu.Success],clientReasonSubCode:n?.clientReasonSubCode,clientReasonPhrase:n?.clientReasonPhrase};if(this.signalingAgentConfig.enableSpecificErrorCodesForCallEnd&&(c.code=ge.CALL_END_CODE.CANCEL,c.subCode=ge.CALL_END_SUB_CODE.SUCCESS,c.phrase=ge.CALL_END_PHRASE.LOCAL_USER_INITIATED,c.resultCategories=[Pu.Success]),this.links.hasOwnProperty(ge.LINKS.LEAVE)){this.logger.info(`[${a}][cancelOutgoingCall] cancelling outgoing call`),this.fsmState=ge.SIGNALING_FSM_STATE.IDLE;const u={cancelationDuration:this.telemetryHelper.getCallCancelationDuration()},m={terminatingEnd:ei.CALL_TERMINATING_END.LOCAL,resultDetail:c.phrase||"CancelOutgoingCall",endCode:c.code,endSubCode:c.subCode,causeId:a,clientReasonSubCode:c.clientReasonSubCode,clientReasonPhrase:c.clientReasonPhrase,resultCategories:c.resultCategories};this.http.sendPostRequest({url:this.links[ge.LINKS.LEAVE],requestName:$n.CANCEL_CALL.name,payload:Ja(this,c,u),causeId:a}).then(b=>{this.disposed||(this.telemetryHelper.setTerminatingData(m),this.onCallStatusChanged(ge.CALL_STATUS.LOCAL_TERMINATED,a,c),this.dispose(c,a)),s.resolve(null)}).catch(b=>{const _=Lr(b,this.signalingAgentConfig);this.logger.info(`[cancelOutgoingCall][${a}] error: ${fi(b)} xhrError: ${fi(_)}`),this.disposed||(this.telemetryHelper.setTerminatingData(m),this.onCallStatusChanged(ge.CALL_STATUS.LOCAL_TERMINATED,a,c),this.dispose(c,a)),s.resolve(null)})}else this.logger.info(`[${a}][cancelOutgoingCall] Conversation Service Leave Url is not yet set. Cannot leave conversation. Disposing anyways.`),c.subCode=ge.CALL_END_SUB_CODE.CONV_URL_NOT_SET,this.telemetryHelper.setTerminatingData({terminatingEnd:ei.CALL_TERMINATING_END.LOCAL,resultDetail:c.phrase||"CancelOutgoingCall",endCode:c.code,endSubCode:c.subCode,causeId:a,clientReasonSubCode:c.clientReasonSubCode,clientReasonPhrase:c.clientReasonPhrase,resultCategories:c.resultCategories}),this.onCallStatusChanged(ge.CALL_STATUS.LOCAL_TERMINATED,a,c),this.dispose(c,a),s.resolve(null);return s.promise}terminateEstablishedCall(n,a){const s=a.causeId||tr();this.logger.info(`[${s}][terminateEstablishedCall]`);const c=Pl();this.fsmState=ge.SIGNALING_FSM_STATE.IDLE;const u=this.convJoined?$n.LEAVE_CONVERSATION.name:$n.END_CALL.name,m=US(),b={code:n?.code||ge.CALL_END_CODE.SUCCESS,subCode:n?.subCode||ge.CALL_END_SUB_CODE.SUCCESS,phrase:n?.phrase||ge.CALL_END_PHRASE.LOCAL_USER_INITIATED,resultCategories:n?.resultCategories,clientReasonSubCode:n?.clientReasonSubCode,clientReasonPhrase:n?.clientReasonPhrase};b.resultCategories=b.resultCategories||[Pu.Success];const _={terminatingEnd:ei.CALL_TERMINATING_END.LOCAL,endCode:b.code,endSubCode:b.subCode,resultDetail:b.phrase||"TerminateEstablishedCall",causeId:s,clientReasonSubCode:b.clientReasonSubCode,clientReasonPhrase:b.clientReasonPhrase,resultCategories:b.resultCategories};return this.leaveConversation(b,a).then(()=>{this.logger.info(`[${s}][terminateEstablishedCall]success`),this.disposed||(this.telemetryHelper.setTerminatingData(_),this.telemetryHelper.addNetworkOperationCompleted(u,!0,m.duration()),this.onCallStatusChanged(ge.CALL_STATUS.LOCAL_TERMINATED,s,b),this.dispose(b,s)),c.resolve(null)}).catch(k=>{const N=Lr(k,this.signalingAgentConfig);this.logger.info(`[${s}][terminateEstablishedCall][failed] error: ${fi(k)} xhrError: ${fi(N)}]`),this.disposed||(this.telemetryHelper.setTerminatingData(_),this.telemetryHelper.addNetworkOperationCompleted(u,!1,m.duration()),this.onCallStatusChanged(ge.CALL_STATUS.LOCAL_TERMINATED,s,b),this.dispose(b,s)),c.resolve(null)}),c.promise}deleteConversation(n,a){this.logger.info(`[${a}][deleteConversation]`);const s=Pl();this.fsmState=ge.SIGNALING_FSM_STATE.IDLE;const c=$n.DELETE_CONVERSATION.name,u=US(),m={code:n?.code||ge.CALL_END_CODE.SUCCESS,subCode:n?.subCode||ge.CALL_END_SUB_CODE.SUCCESS,phrase:n?.phrase||ge.CALL_END_PHRASE.CONV_END_FOR_ALL_INITIATED,resultCategories:n?.resultCategories||[Pu.Success],clientReasonSubCode:n?.clientReasonSubCode,clientReasonPhrase:n?.clientReasonPhrase},b={terminatingEnd:ei.CALL_TERMINATING_END.LOCAL,endCode:m.code,endSubCode:m.subCode,resultDetail:m.phrase,causeId:a,clientReasonSubCode:m.clientReasonSubCode,clientReasonPhrase:m.clientReasonPhrase,resultCategories:m.resultCategories};return this.deleteConversationController(m,a).then(()=>{this.logger.info(`[${a}][deleteConversation]success`),this.disposed||(this.telemetryHelper.setTerminatingData(b),this.telemetryHelper.addNetworkOperationCompleted(c,!0,u.duration()),this.onCallStatusChanged(ge.CALL_STATUS.LOCAL_TERMINATED,a,m),this.dispose(m,a)),s.resolve(null)}).catch(_=>{const k=Lr(_,this.signalingAgentConfig);this.logger.info(`[${a}][deleteConversation][failed] error: ${fi(_)} xhrError: ${fi(k)}`),this.disposed||(this.telemetryHelper.setTerminatingData(b),this.telemetryHelper.addNetworkOperationCompleted(c,!1,u.duration()),this.onCallStatusChanged(ge.CALL_STATUS.LOCAL_TERMINATED,a,m),this.dispose(m,a)),s.resolve(null)}),s.promise}leaveConversation(n,a){const s=a.causeId||tr();if(this.convJoined){this.logger.info(`[${s}][leaveConversation]`);const c={cancelationDuration:this.telemetryHelper.getCallCancelationDuration()};return this.http.sendPostRequest({url:this.links[ge.LINKS.LEAVE],requestName:$n.LEAVE_CONVERSATION.name,payload:bn(this,n,c,a.scope),withoutTrouter:!0,causeId:s})}return this.logger.info(`[${s}][leaveConversation] ignore, not joined to conversation`),Promise.resolve(void 0)}deleteConversationController(n,a){return this.convJoined?(this.logger.info(`[${a}][deleteConversationController]`),this.http.sendDeleteRequest({url:this.links[ge.LINKS.CONVERSATION_CONTROLLER],requestName:$n.DELETE_CONVERSATION.name,payload:Gr(this,n),withoutTrouter:!0,causeId:a})):(this.logger.info(`[${a}][deleteConversationController]ignored, not joined to conversation`),Promise.resolve(void 0))}rejectIncomingCall(n,a){this.telemetryHelper.recordEvent(Ft.REJECT_INCOMING_CALL,a),this.logger.info(`[${a}][rejectIncomingCall]`);const s=Pl();this.fsmState=ge.SIGNALING_FSM_STATE.IDLE;const c={code:isNaN(n?.code)?ge.CALL_END_CODE.REJECT:n.code,subCode:n?.subCode||ge.CALL_END_SUB_CODE.SUCCESS,phrase:n?.phrase||ge.CALL_END_PHRASE.LOCAL_USER_INITIATED,resultCategories:n?.resultCategories,clientReasonSubCode:n?.clientReasonSubCode,clientReasonPhrase:n?.clientReasonPhrase,...this.signalingAgent?.accountConfig?.applicationType?{applicationType:this.signalingAgent.accountConfig.applicationType}:{}};c.resultCategories=c.resultCategories||[Pu.Success];const u={terminatingEnd:ei.CALL_TERMINATING_END.LOCAL,endCode:c.code,endSubCode:c.subCode,resultDetail:c.phrase||"RejectCall",causeId:a,clientReasonSubCode:c.clientReasonSubCode,clientReasonPhrase:c.clientReasonPhrase,resultCategories:c.resultCategories};return this.http.sendDeleteRequest({url:this.links[ge.LINKS.REJECT],requestName:$n.REJECT_CALL.name,payload:Bc(this,c),causeId:a}).then(m=>{this.disposed||(this.telemetryHelper.setTerminatingData(u),this.onCallStatusChanged(ge.CALL_STATUS.LOCAL_TERMINATED,a,c),this.dispose(c,a)),s.resolve(null)}).catch(m=>{const b=Lr(m,this.signalingAgentConfig);this.logger.info(`[rejectIncomingCall][${a}] error: ${fi(m)} xhrError: ${fi(b)}`),this.disposed||(this.telemetryHelper.setTerminatingData(u),this.onCallStatusChanged(ge.CALL_STATUS.LOCAL_TERMINATED,a,c),this.dispose(c,a)),s.resolve(null)}),s.promise}onCallStatusChanged(n,a,s){const c=`[${a}][onCallStatusChanged]`;if(this.logger.info(`${c}${this.currentCallStatus}=>${n}]`),this.disposed)this.logger.info(`${c}Call is already disposed!!`);else if(s&&this.logger.info(`${c}[statusCode=${fi(s)}]`),this.isPromotingToRealtime)n===ge.CALL_STATUS.CONNECTED&&this.onPromotionCompleted(!1,void 0,a);else if(this.isValidStateTransitions(n)){this.currentCallStatus=n;const u={callStatus:n,statusCode:s,causeId:a};this.isPreheatOnly&&(u.isPreheatOnly=!0),this.telemetryHelper.recordEvent(Ft.UPDATE_CALL_STATUS,u),this.signalingSessionCallback.onCallStatusChanged(n,s,a),this.currentCallStatus===ge.CALL_STATUS.CONNECTED&&(this.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.OUTGOING_CALL_ESTABLISHMENT),this.telemetryHelper.resetCallCancelationDurationWatch(),this.isPreheatOnly&&this.startCallPreheatTimer(a))}}updateMeetingLiveStateAsync(n,a){this.logger.info(`[${n}][updateMeetingLiveStateAsync][options=${JSON.stringify(a)}]`),this.telemetryHelper.recordEvent(Ft.UPDATE_MEETING_LIVE_STATE,{causeId:n,meetingLiveStateOptions:a}),this.timeoutManager.startTimer(ge.TIMEOUT_OPERATIONS.UPDATE_MEETING_LIVE_STATE_COMPLETION,()=>{this.handleUpdateMeetingLiveStateError({code:ge.CALL_END_CODE.TIMEOUT,subCode:ge.CALL_END_SUB_CODE.UPDATE_MEETING_LIVE_STATE_COMPLETION_TIMEOUT,phrase:ge.CALL_END_PHRASE.UPDATE_MEETING_LIVE_STATE_COMPLETION_TIMEOUT},Ft.WAITING_FOR_UPDATE_MEETING_LIVE_STATE_COMPLETION,n,n,a)},ge.TIMEOUT_VALUES_IN_SECONDS.UPDATE_MEETING_LIVE_STATE_COMPLETION_TIMEOUT);const s=yw(this,{...a,sequenceNumber:this.meetingLiveStateSequenceNumber},n);return this.http.sendPostRequest({url:this.links[ge.LINKS.UPDATE_MEETING_LIVE_STATE],requestName:$n.UPDATE_MEETING_LIVE_STATE.name,payload:s,causeId:n}).then(c=>{this.logger.info(`[${n}][updateMeetingLiveStateAsync] response: ${fi(c)}`),this.telemetryHelper.recordEvent(Ft.WAITING_FOR_UPDATE_MEETING_LIVE_STATE_COMPLETION,{causeId:n})}).catch(c=>{const u=Lr(c,this.signalingAgentConfig);return this.logger.info(`[${n}][updateMeetingLiveStateAsync] error: ${fi(u)}`),this.disposed?Promise.reject(this.getCallNotFoundTransactionEnd()):(this.handleUpdateMeetingLiveStateError(u.error,Ft.UPDATE_MEETING_LIVE_STATE_REQUEST_FAILED,n,n,a),Promise.reject(u.error))})}updateMeetingStatesAsync(n,a){const s=this.logger.createChild(`[${n}][updateMeetingStatesAsync]`,this.correlationId);if(s.info(`meetingStatesOptions: ${JSON.stringify(a)}`),!a)return Promise.reject({code:ge.VALIDATION.VALIDATION_FAILED,subCode:ge.VALIDATION.NULL_OR_EMPTY,phrase:"meetingStatesOptions should be a non empty object"});this.telemetryHelper.recordEvent(Ft.UPDATE_MEETING_STATES,{causeId:n,meetingStatesOptions:a}),this.timeoutManager.startTimer(ge.TIMEOUT_OPERATIONS.UPDATE_MEETING_STATES_COMPLETION,()=>{for(const u in a.meetingStates)this.handleUpdateMeetingStatesError({code:ge.CALL_END_CODE.TIMEOUT,subCode:ge.CALL_END_SUB_CODE.UPDATE_MEETING_STATES_COMPLETION_TIMEOUT,phrase:ge.CALL_END_PHRASE.UPDATE_MEETING_STATES_COMPLETION_TIMEOUT},Ft.WAITING_FOR_UPDATE_MEETING_STATES_COMPLETION,n,a.operationId+"_"+u)},ge.TIMEOUT_VALUES_IN_SECONDS.UPDATE_MEETING_STATES_COMPLETION_TIMEOUT);const c=Gci(this,{...a.meetingStates},n);return this.http.sendPostRequest({url:this.links[ge.LINKS.UPDATE_MEETING_STATES],requestName:$n.UPDATE_MEETING_STATES.name,payload:c,causeId:n}).then(u=>{s.info(`response: ${fi(u)}`),this.telemetryHelper.recordEvent(Ft.WAITING_FOR_UPDATE_MEETING_STATES_COMPLETION,{causeId:n})}).catch(u=>{const m=Lr(u,this.signalingAgentConfig);if(s.error(`error: ${fi(m)}`),!this.disposed){for(const b in a.meetingStates)this.handleUpdateMeetingStatesError(m.error,Ft.UPDATE_MEETING_STATES_RESPONSE_FAILURE,n,a.operationId+"_"+b);return Promise.reject(m.error)}return Promise.reject(this.getCallNotFoundTransactionEnd())})}handleUpdateMeetingLiveStateError(n,a,s,c,u){this.disposed?this.logger.info(`[${s}][handleUpdateMeetingLiveStateError] ignored. Call disposed, err: ${JSON.stringify(n)}`):(this.logger.info(`[${s}][handleUpdateMeetingLiveStateError] reject reason: ${n}`),this.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.UPDATE_MEETING_LIVE_STATE_COMPLETION),this.telemetryHelper.recordEvent(a,{...n,updateMeetingGroupsOptions:u,causeId:s}),this.signalingSessionCallback.onUpdateMeetingLiveStateCompleted&&this.signalingSessionCallback.onUpdateMeetingLiveStateCompleted(n,s,c))}handleUpdateMeetingLiveStateCompletion(n){const a=n.body,s=Po(n),c=a.updateMeetingLiveStateResponse.result,u=a.updateMeetingLiveStateResponse.operationId;u||this.logger.warn(`[${s}][handleUpdateMeetingLiveStateCompletion] operationId is undefined.`),this.logger.info(`[${s}][handleUpdateMeetingLiveStateCompletion] meetingLiveUpdate completes with operationId=${u}`),this.handleOperationCompletionCommon(c,s,u,fi(a),"handleUpdateMeetingLiveStateCompletion",ge.TIMEOUT_OPERATIONS.UPDATE_MEETING_LIVE_STATE_COMPLETION,Ft.UPDATE_MEETING_LIVE_STATE_RESPONSE_SUCCESS,Ft.UPDATE_MEETING_LIVE_STATE_RESPONSE_FAILURE,this.signalingSessionCallback.onUpdateMeetingLiveStateCompleted,this.handleUpdateMeetingLiveStateError.bind(this))}handleUpdateMeetingStatesError(n,a,s,c){this.disposed?this.logger.info(`[${s}][handleUpdateMeetingStatesError] ignored. Call disposed, err: ${JSON.stringify(n)}`):(this.logger.info(`[${s}][handleUpdateMeetingStatesError] reject reason: ${n}`),this.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.UPDATE_MEETING_STATES_COMPLETION),this.telemetryHelper.recordEvent(a,{...n,causeId:s}),this.signalingSessionCallback.onUpdateMeetingStatesCompleted&&this.signalingSessionCallback.onUpdateMeetingStatesCompleted(n,s,c))}handleUpdateMeetingStatesCompletion(n){const a=n.body,s=Po(n),c=a.updateMeetingStatesResponse,u=a.operationId,m=this.logger.createChild(`[${s}][handleUpdateMeetingStatesCompletion]`,this.correlationId);u||m.warn("operationId is undefined.");for(const b of c)m.info(`UpdateMeetingStates completes with operationId=${u}.`),this.handleOperationCompletionCommon(b.transactionEnd,s,u+"_"+b.meetingStateName,fi(a),"handleUpdateMeetingStatesCompletion",ge.TIMEOUT_OPERATIONS.UPDATE_MEETING_STATES_COMPLETION,Ft.UPDATE_MEETING_STATES_RESPONSE_SUCCESS,Ft.UPDATE_MEETING_STATES_RESPONSE_FAILURE,this.signalingSessionCallback.onUpdateMeetingStatesCompleted,this.handleUpdateMeetingStatesError.bind(this))}handleUpdateMonitorSessionCompletion(n){const a=n.body,s=Po(n);this.logger.info(`[${s}][handleUpdateMeetingStatesCompletion]`,this.correlationId);const c=a.monitorCompletion;this.handleOperationCompletionCommon(c,s,void 0,fi(a),"handleUpdateMonitorSessionCompletion",ge.TIMEOUT_OPERATIONS.UPDATE_MONITOR_SESSION_COMPLETION,Ft.UPDATE_MONITOR_SESSION_RESPONSE_COMPLETED,Ft.UPDATE_MONITOR_SESSION_RESPONSE_FAILED,this.signalingSessionCallback.onUpdateMonitorSessionCompleted,this.handleUpdateMonitorSessionError.bind(this))}handleUpdateMonitorSessionError(n,a,s,c){this.disposed?this.logger.info(`[${s}][handleUpdateMonitorSessionError] ignored. Call disposed, err: ${JSON.stringify(n)}`):(this.logger.info(`[${s}][handleUpdateMonitorSessionError] reject reason: ${JSON.stringify(n)}`),this.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.UPDATE_MONITOR_SESSION_COMPLETION),this.telemetryHelper.recordEvent(a,{...n,monitorOptions:c,causeId:s}),this.signalingSessionCallback.onUpdateMonitorSessionCompleted(n,s))}setMeetingLayoutAsync(n,a){this.logger.info(`[${n}][setMeetingLayoutAsync][options=${JSON.stringify(a)}]`),this.telemetryHelper.recordEvent(Ft.SET_MEETING_LAYOUT,{causeId:n,setMeetingLayoutOptions:a}),this.timeoutManager.startTimer(ge.TIMEOUT_OPERATIONS.SET_MEETING_LAYOUT_COMPLETION,()=>{this.handleSetMeetingLayoutError({code:ge.CALL_END_CODE.TIMEOUT,subCode:ge.CALL_END_SUB_CODE.SET_MEETING_LAYOUT_COMPLETION_TIMEOUT,phrase:ge.CALL_END_PHRASE.SET_MEETING_LAYOUT_COMPLETION_TIMEOUT},Ft.WAITING_FOR_SET_MEETING_LAYOUT_COMPLETION,n,n,a)},ge.TIMEOUT_VALUES_IN_SECONDS.SET_MEETING_LAYOUT_COMPLETION_TIMEOUT);const s=dc(this,{...a,sequenceNumber:this.meetingLayoutSequenceNumber});return this.http.sendPostRequest({url:this.links[ge.LINKS.SET_MEETING_LAYOUT],requestName:$n.SET_MEETING_LAYOUT.name,payload:s,causeId:n}).then(c=>{this.logger.info(`[${n}][setMeetingLayoutAsync] response: ${fi(c)}`),this.telemetryHelper.recordEvent(Ft.WAITING_FOR_SET_MEETING_LAYOUT_COMPLETION,{causeId:n})}).catch(c=>{const u=Lr(c);return this.logger.info(`[${n}][setMeetingLayoutAsync] error: ${fi(u)}`),this.disposed?Promise.reject(this.getCallNotFoundTransactionEnd()):(this.handleSetMeetingLayoutError(u.error,Ft.SET_MEETING_LAYOUT_REQUEST_FAILED,n,n,a),Promise.reject(u.error))})}handleSetMeetingLayoutError(n,a,s,c,u){this.disposed?this.logger.info(`[${s}][handleSetMeetingLayoutError] ignored. Call disposed, err: ${JSON.stringify(n)}`):(this.logger.info(`[${s}][handleSetMeetingLayoutError] reject reason: ${n}`),this.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.SET_MEETING_LAYOUT_COMPLETION),this.telemetryHelper.recordEvent(a,{...n,updateMeetingGroupsOptions:u,causeId:s}),this.signalingSessionCallback.onSetMeetingLayoutCompleted&&this.signalingSessionCallback.onSetMeetingLayoutCompleted(n,s,c))}handleSetMeetingLayoutCompletion(n){const a=n.body,s=Po(n),c=a.transactionEnd,u=a.operationId;c.result=a.layoutDetails,u||this.logger.warn(`[${s}][handleSetMeetingLayoutCompletion] operationId is undefined.`),this.handleOperationCompletionCommon(c,s,void 0,fi(a),"handleSetMeetingLayoutCompletion",ge.TIMEOUT_OPERATIONS.SET_MEETING_LAYOUT_COMPLETION,Ft.SET_MEETING_LAYOUT_RESPONSE_SUCCESS,Ft.SET_MEETING_LAYOUT_RESPONSE_FAILURE,this.signalingSessionCallback.onSetMeetingLayoutCompleted,this.handleSetMeetingLayoutError.bind(this))}handleOperationCompletionCommon(n,a,s,c,u,m,b,_,k,N){this.disposed?this.logger.info(`[${a}][${u}] ignored. Call disposed.`):(this.logger.info(`[${a}][${u}] body ${c}`),n.code===ge.TRANSACTION_END_CODE.SUCCESS?(this.timeoutManager.stopTimer(m),this.telemetryHelper.recordEvent(b,{...n,causeId:a}),k&&k(n,a,s)):N&&N(n,_,a,s))}isValidStateTransitions(n){if(this.currentCallStatus===ge.CALL_STATUS.LOCAL_TERMINATED&&n===ge.CALL_STATUS.CONNECTING)return!0;const a=s=>{switch(s){case ge.CALL_STATUS.IDLE:case ge.CALL_STATUS.CONNECTED_FOR_ROSTER_ONLY:return 0;case ge.CALL_STATUS.CONNECTING:return 1;case ge.CALL_STATUS.RINGING:return 2;case ge.CALL_STATUS.CONNECTED:return 3;case ge.CALL_STATUS.LOCAL_TERMINATED:case ge.CALL_STATUS.REMOTE_TERMINATED:return 4;default:return-1}};return a(n)>a(this.currentCallStatus)}handlePSTNBalanceUpdate(n){const a=n.body.balanceUpdate,s=Po(n);this.logger.info(`[${s}][handlePSTNBalanceUpdate]`),this.telemetryHelper.recordIncomingEvent(Ft.HANDLE_PSTN_BALANCE_UPDATE,n),a.updateBalance?this.signalingSessionCallback.onPSTNBalanceUpdate(a):this.logger.info(Ft.HANDLE_PSTN_BALANCE_UPDATE,"this was a pstn keepAlive message - ignore")}handleCallAcceptanceAck(n){const a=n.body,s=Po(n);this.logger.info(`[${s}][handleCallAcceptanceAck]`),this.telemetryHelper.recordIncomingEvent(Ft.HANDLE_CALL_ACCEPTANCE_ACK,n),this.internalHandleCallAcceptanceAck(a,s)}internalHandleCallAcceptanceAck(n,a){this.logger.info(`[${a}][internalHandleCallAcceptanceAck] ${fi(n)}`),this.fsmState!==ge.SIGNALING_FSM_STATE.CONNECTED&&(this.links[ge.LINKS.MEDIA_RENEGOTIATION]=n.callAcceptanceAcknowledgement.links.mediaRenegotiation,this.links[ge.LINKS.TRANSFER]=n.callAcceptanceAcknowledgement.links.transfer,this.links[ge.LINKS.REPLACE]=n.callAcceptanceAcknowledgement.links.replacement,this.links[ge.LINKS.HANGUP]=n.callAcceptanceAcknowledgement.links.callLeg,this.links[ge.LINKS.KEEPALIVE]=n.callAcceptanceAcknowledgement.links.callLeg,this.links[ge.LINKS.PARK]=n.callAcceptanceAcknowledgement.links.hold,this.links[ge.LINKS.UPDATE_MEDIA_DESCRIPTIONS]=n.callAcceptanceAcknowledgement.links.updateMediaDescriptions,this.links[ge.LINKS.UPDATE_MONITOR_SESSION]=n.callAcceptanceAcknowledgement.links.monitor,this.saveMediaControllerLinksIfAny(n.callAcceptanceAcknowledgement),this.scheduleKeepAlives(n.callAcceptanceAcknowledgement.callKeepAliveInterval),this.signalingSessionCallback.updateIsSharedLineAppearanceV2Activated(n.callAcceptanceAcknowledgement.callProperties?.isSharedLineAppearanceV2Activated),this.fsmState=ge.SIGNALING_FSM_STATE.CONNECTED,this.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.INCOMING_CALL_ESTABLISHMENT),this.isPreheatOnly||this.telemetryHelper.startCallConnectedWatch(),this.mediaRenegotiationManager.onCallConnected(a),this.onCallStatusChanged(ge.CALL_STATUS.CONNECTED,a),this.linkUpdateRequested.keepAliveLinks&&(this.logger.info(`[${a}][internalHandleCallAcceptanceAck] updating CC links as requested`),this.updateLinks(this.updateKeepAliveUrl,a)))}isFatalException(n){let a=!0;try{JSON.parse(n.message).code===ge.CALL_END_CODE.CONFLICT&&(a=!1,this.logger.info("isFatalException: received non-fatal 409 error"))}catch{this.logger.error("isFatalException: failed to parse error")}return a}startOrJoinCall(n,a,s,c,u){if(this.logger.info(`[${s}]startOrJoinCall[${a}]`),this.disposed)return void this.logger.info(`[${s}][${a}] session already disposed, ignore`);this.telemetryHelper.recordEvent(Ft.START_OR_JOIN_CALL,{causeId:s,requestName:a}),this.setMultiParty(this.participantManager.getParticipantsToInitiateCallWith().length!==1,s);const m=this.getConversationUrl()?this.getConversationUrl():n.conversationServiceUrl;this.telemetryHelper.setConversationServiceUrl(m),this.logger.info(`options.conversationServiceUrl ${n.conversationServiceUrl} conversationServiceUrl ${m}`),n.isPreheatOnly?(this.isPreheatOnly=!0,this.telemetryHelper.recordEvent(Ft.PREHEAT_ENABLING,{causeId:s}),this.telemetryHelper.setSelfParticipantRole(ei.ROLE.PREHEAT),this.telemetryHelper.setIsPreheated()):this.telemetryHelper.startCallCancelationDurationWatch(),this.mediaTypesToUse=u,this.lastUsedOutgoingMediaContent=c,this.telemetryHelper.setCallerType(this.participantManager.localParticipant.id);const b=!this.multiParty&&this.signalingAgentConfig.enableLongOutgoing1To1SetupTimeoutForWeb,_=b?ge.TIMEOUT_VALUES_IN_SECONDS.LONGER_OUTGOING_CALL_ESTABLISHMENT_TIMEOUT:ge.TIMEOUT_VALUES_IN_SECONDS.OUTGOING_CALL_ESTABLISHMENT_TIMEOUT;this.logger.info(`[${s}][${a}]target endpointType = ${this.transferContext&&this.transferContext.target?this.transferContext.target.endpointType:"default"} timeout = ${_} LongerTimeout = ${b}`);const k=n.newCall?po(this,c,u,n):hl(this,c,u,n,s);this.signalingAgentConfig.enableCallEstablishmentTimeoutsForStartJoinCall&&this.timeoutManager.startTimer(ge.TIMEOUT_OPERATIONS.OUTGOING_CALL_ESTABLISHMENT,()=>{this.handleCallEstablishmentTimeout(s)},_),this.signalingSessionCallback.onTransferredCallAcceptance(s),n.endpointState&&(this.latestEndpointState=n.endpointState),this.http.sendPostRequest({url:m,requestName:a,operationType:"CallSetup",payload:k,causeId:s}).then(N=>{this.disposed||(this.processConversationServiceResponseHeaders(N,s),this.processConversationServiceResponse(N.response,s,0),this.onCallStatusChanged(ge.CALL_STATUS.CONNECTING,s))}).catch(N=>{if(N.stack&&!this.isFatalException(N))return;const W=Lr(N,this.signalingAgentConfig);if(this.logger.info(`[startOrJoinCall][${s}][${a}] error: ${fi(N)} xhrError: ${fi(W)}`),!this.disposed){if(this.isPromotingToRealtime)return void this.onPromotionCompleted(!0,W.error,s);this.fsmState=ge.SIGNALING_FSM_STATE.IDLE,this.telemetryHelper.setTerminatingData({terminatingEnd:ei.CALL_TERMINATING_END.LOCAL,resultValue:ei.RESULT_VALUE.FAILURE,endCode:W.telemetryEndSubCode,endSubCode:W.error.subCode,resultCategories:W.error.resultCategories,resultDetail:W.error.phrase||"StartOrJoinCallFailure",causeId:s}),this.onCallStatusChanged(ge.CALL_STATUS.LOCAL_TERMINATED,s,W.error),this.dispose(W.error,s)}})}processIncomingCallPayload(n,a){this.remoteUser=X0.fromWireParticipant(n.callNotification.from),this.participantManager.setLocalParticipantId(n.callNotification.to.participantId,a),n?(n.conversationInvitation&&(this.links[ge.LINKS.CONVERSATION_CONTROLLER]=n.conversationInvitation.conversationController,this.setMultiParty(n.conversationInvitation.isMultiParty,a),this.setIsHostless(!!n.conversationInvitation.isHostless,a)),n.callNotification&&(this.links[ge.LINKS.ATTACH]=n.callNotification.links?.attach,this.links[ge.LINKS.REDIRECT]=n.callNotification.links?.redirection,this.onBehalfOf=n.callNotification.onBehalfOf?.id,this.onBehalfOfUserDisplayName=n.callNotification.onBehalfOf?.displayName,this.callQueueContext=n.callNotification.callQueueContext,this.callPhoneLineType=n.callNotification.callPhoneLineType,this.callType=n.callNotification.callType,this.incomingCallCallerId=n.callNotification.from?.id,this.callUsesMixer=!!n.callNotification.mediaContent?.fromMixer,this.isRedirectAllowed=!!n.callNotification.redirectionProperties?.isRedirectAllowed,this.callQueueSupervisorContent=n.callNotification.callQueueSupervisorContent,this.bannerContent=n.callNotification.bannerContent),n.debugContent&&this.updateCorrelationId(n.debugContent.callId,a),n.callNotification.transferor&&(this.transferor=n.callNotification.transferor.details?n.callNotification.transferor.details.id:null),n.groupChat&&this.updateGroupChatIds(n.groupChat,a),n.meetingData&&(this.meetingData=n.meetingData),n.meetingInfo&&(this.meetingInfo=n.meetingInfo)):this.logger.info(`[${a}][processIncomingCallPayload] empty incoming payload content`)}processAttachResponse(n,a,s){this.telemetryHelper.recordEvent(Ft.PROCESS_INITIAL_OFFER,{causeId:s}),this.links[ge.LINKS.MEDIA_ANSWER]=a.response.callInvitation.links.mediaAnswer,this.links[ge.LINKS.ACCEPT]=a.response.callInvitation.links.acceptance,this.links[ge.LINKS.REJECT]=a.response.callInvitation.links.callLeg,this.links[ge.LINKS.REDIRECT]=a.response.callInvitation.links.redirection,this.links[ge.LINKS.NEW_OFFER]=a.response.callInvitation.links.newOffer,this.signalingAgentConfig.sendProgressFromCC||this.sendProgress(a),this.remoteCaller=a.response.participants.from;const c=this.getInitialMediaOfferFromIncomingCallPayload()||a.response.callInvitation.mediaContent;this.telemetryHelper.setCallerType(this.getParticipantIdForOfferAnswer(c));const u=eE(a.response.callInvitation.callModalities);this.telemetryHelper.addIncomingModalities(u),this.telemetryHelper.setOfferedModalities(c.blob,!0),this.callUsesMixer=c.fromMixer,this.isRedirectAllowed=!(!a.response.callInvitation.redirectionProperties||!a.response.callInvitation.redirectionProperties.isRedirectAllowed),this.signalingSessionCallback.onOffer({subject:n.conversationInvitation.subject,remoteParticipantId:this.getParticipantIdForOfferAnswer(c),remoteEndpointId:a.response.participants.from.endpointId,transferor:a.response.callInvitation.transferor,clientTransferContext:n.callNotification.transferContext,customHeaderContext:a.response.callInvitation.customContext,mediaTypes:u,mediaContent:c,renegotiation:!1,invitationData:a.response.callInvitation.invitationData,riskLevel:a.response.callInvitation.spamProperties&&a.response.callInvitation.spamProperties.riskLevel,stirAttestation:a.response.callInvitation.spamProperties&&a.response.callInvitation.spamProperties.stirAttestation,isRedirectAllowed:this.isRedirectAllowed},s)}sendProgress(n,a=tr()){this.logger.info(`[${a}][sendProgress]`),this.telemetryHelper.recordEvent(Ft.SEND_PROGRESS,{causeId:a}),this.http.sendPostRequest({url:n.response.callInvitation.links.progress,requestName:$n.SEND_CALL_PROGRESS.name,payload:tn(this),causeId:a}).catch(s=>{const c=Lr(s,this.signalingAgentConfig);this.logger.info(`[${a}][sendProgress] error: ${fi(c)}`),this.disposed||this.telemetryHelper.recordEvent(Ft.SEND_PROGRESS_FAILED,{causeId:a,...c.error})})}handleCallNotification(n){const a=Po(n);if(this.logger.info(`[${a}][handleCallNotification]`),this.telemetryHelper.recordIncomingEvent(Ft.HANDLE_CALL_NOTIFICATION,n),!ND(n.url,Fi.REPLACE))throw new Error(`[${a}][handleCallNotification]IncomingCallNotification should not be received in handleIncomingMsg`);this.telemetryHelper.recordIncomingEvent(Ft.HANDLE_INCOMING_CALL_REPLACEMENT,n),this.logger.info(`[${a}][handleCallNotification]replacementCallNotification`),this.signalingSessionCallback&&this.signalingSessionCallback.onIncomingCallReplacement(n.body,a)}handleMediaAnswer(n){this.telemetryHelper.recordIncomingEvent(Ft.HANDLE_MEDIA_ANSWER,n);const a=n.body,s=Po(n);if(this.logger.info(`[${s}][handleMediaAnswer]`),this.mediaRenegotiationManager.isOutgoingRenegotiationInProgress())this.mediaRenegotiationManager.handleMediaAnswer(a,s);else if(this.fsmState!==ge.SIGNALING_FSM_STATE.CONNECTED){if(this.fsmState===ge.SIGNALING_FSM_STATE.OUTGOING){if(Z0(n.headers,this.provisionalMediaAnswersSeenSoFar))return void this.logger.info(`[${s}][handleMediaAnswer] ignoring provisional answer retried by service`);a.mediaAnswer.sender&&(this.remoteUser=a.mediaAnswer.sender),this.resetCallEstablishmentTimeout(s),a.mediaAnswer.noRingBack||(this.telemetryHelper.setTimeToRingDuration(),this.onCallStatusChanged(ge.CALL_STATUS.RINGING,s));const c=a.mediaAnswer.mediaContent;this.signalingSessionCallback.onAnswer({provisional:!0,renegotiation:!1,remoteEndpointId:a.mediaAnswer.sender?a.mediaAnswer.sender.endpointId:My(),remoteParticipantId:this.getParticipantIdForOfferAnswer(c),mediaContent:c},s)}}}async _sendCallAcceptanceAcknowledgement(n,a){this.http.sendPostRequest({url:n.body.callAcceptance.links.acknowledgement,requestName:$n.SEND_ACCEPTANCE_ACKNOWLEDGEMENT.name,payload:Ri(this),causeId:a}).catch(s=>{const c=Lr(s,this.signalingAgentConfig);this.logger.info(`[${a}][_sendCallAcceptanceAcknowledgement] error: ${fi(c)}`),this.disposed||this.telemetryHelper.recordEvent(Ft.HANDLE_CALL_ACCEPTANCE_FAILED,{causeId:a,...c.error})})}handleCallAcceptance(n){const a=Po(n);this.telemetryHelper.recordIncomingEvent(Ft.HANDLE_CALL_ACCEPTANCE,n,{enableQuickSendAcceptanceAck:this.signalingAgentConfig.enableQuickSendAcceptanceAck,causeId:a}),this.logger.info(`[${a}][handleCallAcceptance]enableQuickSendAcceptanceAck:
            ${this.signalingAgentConfig.enableQuickSendAcceptanceAck}`),this.signalingAgentConfig.enableQuickSendAcceptanceAck?(this._sendCallAcceptanceAcknowledgement(n,a),this._processCallAcceptance(n,a)):(this._processCallAcceptance(n,a),this.http.sendPostRequest({url:n.body.callAcceptance.links.acknowledgement,requestName:$n.SEND_ACCEPTANCE_ACKNOWLEDGEMENT.name,payload:Ri(this),causeId:a}).catch(s=>{const c=Lr(s,this.signalingAgentConfig);this.logger.info(`[${a}][handleCallAcceptance] error: ${fi(c)}`),this.disposed||this.telemetryHelper.recordEvent(Ft.HANDLE_CALL_ACCEPTANCE_FAILED,{causeId:a,...c.error})}))}handleCallAcceptanceSync(n){const a=Po(n);this.telemetryHelper.recordIncomingEvent(Ft.HANDLE_CALL_ACCEPTANCE_SYNC,n,{enableQuickSendAcceptanceAck:this.signalingAgentConfig.enableQuickSendAcceptanceAck,causeId:a}),this.logger.info(`[${a}][handleCallAcceptanceSync] enableQuickSendAcceptanceAck:
            ${this.signalingAgentConfig.enableQuickSendAcceptanceAck}`),this.signalingAgentConfig.enableQuickSendAcceptanceAck?GR.defer(this._processCallAcceptance,n,a):this._processCallAcceptance(n,a);const s=Ri(this).payload;return this.telemetryHelper.addNetworkOperationCompleted($n.SEND_ACCEPTANCE_ACKNOWLEDGEMENT.name,!0),s}getFakeRoster(n){const a=this.participantManager.getParticipantsToInitiateCallWith();let s;s=a.length===1?a[0].id:n.callAcceptance.acceptedBy.id;const c={id:s,displayName:n.callAcceptance.acceptedBy.id===s?n.callAcceptance.acceptedBy.displayName:"",languageId:n.callAcceptance.acceptedBy.languageId},u=n.callAcceptance.acceptedBy.endpointId;return{type:"MultiPartyEndpoint",participants:{[s]:{acceptedBy:n.callAcceptance.acceptedBy.id,details:c,endpoints:{[u]:{call:{},contentSharing:{},capabilities:n.callAcceptance.capabilities,participantId:n.callAcceptance.acceptedBy.participantId}}}}}}processCallAcceptance(n,a){this.logger.info(`[${a}][processCallAcceptance] ${fi(n)}`),this.telemetryHelper.recordEvent(Ft.PROCESS_CALL_ACCEPTANCE,{causeId:a}),this.fsmState=ge.SIGNALING_FSM_STATE.CONNECTED,this.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.OUTGOING_CALL_ESTABLISHMENT),this.isPreheatOnly||this.telemetryHelper.startCallConnectedWatch(),this.mediaRenegotiationManager.onCallConnected(a);let s=!1;n.callAcceptance.controllerName===ge.MISC.LOBBY_CALL_CONTROLLER&&(this.logger.info(`[${a}][processCallAcceptance] Controller name is lobby so putting user in lobby`),this.participantManager.localParticipant.isLobby=!0,this.participantManager.localParticipant.endpointDetails.push({isLobby:!0,endpointId:this.participantManager.localParticipant.endpointId,participantId:this.participantManager.localParticipant.participantId}),s=!0,this.telemetryHelper.recordEvent(Ft.ACCEPTANCE_USER_IN_LOBBY,{causeId:a})),this.participantManager.localParticipant.isStaging=_N(n.callAcceptance),this.signalingSessionCallback.onMeetingGroupDetailsUpdated(n.callAcceptance.meetingGroupDetails,a),this.signalingSessionCallback.updateIsSharedLineAppearanceV2Activated(n.callAcceptance.callProperties?.isSharedLineAppearanceV2Activated),this.logger.info(`[${a}][processCallAcceptance] for localParticipant, isStaging is set to ${this.participantManager.localParticipant.isStaging}`);let c=this.mediaTypesToUse,u=My();n.callAcceptance.acceptedBy&&(this.remoteUser=X0.fromWireParticipant(n.callAcceptance.acceptedBy),u=n.callAcceptance.acceptedBy.endpointId),n.callAcceptance.acceptedCallModalities&&n.callAcceptance.acceptedCallModalities.length>0&&(c=n.callAcceptance.acceptedCallModalities);const m=n.callAcceptance.mediaContent;this.callUsesMixer=m.fromMixer;const b=eE(c);this.telemetryHelper.addIncomingModalities(b),this.telemetryHelper.setAnsweredModalities(m.blob,!0),this.links[ge.LINKS.MEDIA_RENEGOTIATION]=n.callAcceptance.links.mediaRenegotiation,this.links[ge.LINKS.TRANSFER]=n.callAcceptance.links.transfer,this.links[ge.LINKS.REPLACE]=n.callAcceptance.links.replacement,this.links[ge.LINKS.HANGUP]=n.callAcceptance.links.callLeg,this.links[ge.LINKS.KEEPALIVE]=n.callAcceptance.links.callLeg,this.links[ge.LINKS.PARK]=n.callAcceptance.links.hold,this.links[ge.LINKS.UPDATE_MEDIA_DESCRIPTIONS]=n.callAcceptance.links.updateMediaDescriptions,this.links[ge.LINKS.UPDATE_MONITOR_SESSION]=n.callAcceptance.links.monitor,this.saveMediaControllerLinksIfAny(n.callAcceptance),this.scheduleKeepAlives(n.callAcceptance.callKeepAliveInterval);const _=this.getParticipantIdForOfferAnswer(m);this.signalingSessionCallback.onAnswer({provisional:!1,renegotiation:!1,remoteEndpointId:u,remoteParticipantId:_,callAcceptedByNGCVoicemail:_===ge.KNOWN_BOTS.VOICEMAIL_BOT_ID,mediaTypes:b,mediaContent:m},a),this.setRealTimeState(2,a),this.onCallStatusChanged(ge.CALL_STATUS.CONNECTED,a),s&&this.signalingSessionCallback.onSelfParticipantUpdated(this.participantManager.localParticipant,a),this.linkUpdateRequested.keepAliveLinks&&(this.logger.info(`[${a}][processCallAcceptance] Updating CC links as requested`),this.updateLinks(this.updateKeepAliveUrl,a))}updateGroupChatIds(n,a){const s=this.groupId,c=this.threadId,u=this.teamsMessageId,m=this.backroomThreadId,b=this.streamThreadId,_=this.lobbyThreadId;this.groupId=n.groupId,this.threadId=n.threadId,this.teamsMessageId=n.messageId,this.backroomThreadId=n.backroomThreadId,this.streamThreadId=n.streamThreadId,this.lobbyThreadId=n.lobbyThreadId,this.groupId===s&&this.threadId===c&&this.teamsMessageId===u&&this.backroomThreadId===m&&this.streamThreadId===b&&this.lobbyThreadId===_||this.signalingSessionCallback.onConversationUpdated({conversationType:this.conversationType,groupId:this.groupId,threadId:this.threadId,teamsMessageId:this.teamsMessageId,isMultiParty:this.multiParty,commandUrlPresence:this.getCommandUrlPresence(),meetingData:this.meetingData,region:this.region,meetingInfo:this.meetingInfo,callLimits:this.callLimits,isHuddleGroupCall:this.isHuddleGroupCall,backroomThreadId:this.backroomThreadId,streamThreadId:this.streamThreadId,lobbyThreadId:this.lobbyThreadId},a)}handleCallEnd(n,a){let s=n.body.callEnd||n.body;const c=Po(n);if(this.logger.info(`[${c}][handleCallEnd][content=${fi(s)}]`),this.telemetryHelper.recordEvent(Ft.HANDLE_CALL_END,{origin:n.origin,code:s?s.code:"unknown",subCode:s?s.subCode:"unknown",resultCategories:s?s.resultCategories:[],causeId:c}),this.signalingAgentConfig.enableConversationTypeUpdateOnCallEnd&&(this.conversationType=s?.conversationType||this.conversationType,this.signalingSessionCallback.onConversationTypeUpdated(this.conversationType,c)),this.fsmState!==ge.SIGNALING_FSM_STATE.IDLE)if(s.code===ge.CALL_END_CODE.CONFLICT&&this.multiParty&&s.conversationUrl?.Location)this.handleConversationResolutionConflict(s,c);else{this.disposing=!0,s.callControllerTransactionEnd&&(this.logger.info("handleCallEnd: using CC end details specified in CS end"),s=s.callControllerTransactionEnd),s.broadcastOperationFailure&&(this.logger.info("handleCallEnd: using broadcastOperationFailure end details specified in CS end"),s=s.broadcastOperationFailure);const u=s.code===ge.CALL_END_CODE.SUCCESS||s.code===ge.CALL_END_CODE.CANCEL||s.code===ge.CALL_END_CODE.REJECT;this.telemetryHelper.setTerminatingData({terminatingEnd:ei.CALL_TERMINATING_END.REMOTE,resultDetail:s.phrase,resultValue:u?ei.RESULT_VALUE.SUCCESS:ei.RESULT_VALUE.FAILURE,endCode:s.code,endSubCode:s.subCode,resultCategories:s?s.resultCategories:[],causeId:c});const m={code:s.code,subCode:s.subCode,phrase:s.phrase,resultCategories:s.resultCategories,pickupCode:""},b=this.fsmState===ge.SIGNALING_FSM_STATE.CONNECTED_FOR_ROSTER_ONLY||this.fsmState===ge.SIGNALING_FSM_STATE.OUTGOING_FOR_ROSTER_ONLY;s.acceptedElsewhereBy&&(this.acceptedElsewhereBy={id:s.acceptedElsewhereBy.id,displayName:s.acceptedElsewhereBy.displayName}),s.unparkContent&&(s.unparkContent.CallParkAdditionalContext&&(this.parkAdditionalContextJson=JSON.stringify(s.unparkContent.CallParkAdditionalContext),this.serverHoldLocation=s.unparkContent.CallParkAdditionalContext.ConversationControllerLocation),s.unparkContent.pickupCode&&(m.pickupCode=s.unparkContent.pickupCode));const _=this.signalingAgentConfig.enableSplitConversationEndUrl;_&&b===a?(this.logger.info("fsmstate = SIGNALING_FSM_STATE.CONNECTED_FOR_ROSTER_ONLY or OUTGOING_FOR_ROSTER_ONLY"),this.onCallStatusChanged(ge.CALL_STATUS.REMOTE_TERMINATED,c,m),this.dispose(m,c)):_||(this.fsmState=ge.SIGNALING_FSM_STATE.IDLE,this.onCallStatusChanged(ge.CALL_STATUS.REMOTE_TERMINATED,c,m),this.dispose(m,c))}else this.logger.info(`[${c}][handleCallEnd] not handling incoming callEnd since fsmstate = SIGNALING_FSM_STATE.IDLE`)}handleConversationResolutionConflict(n,a){this.logger.info(`[${a}][handleConversationResolutionConflict]`);const s={...n,phrase:n.phrase||"Conflict Resolution Error"};if(this.fsmState===ge.SIGNALING_FSM_STATE.OUTGOING_FOR_ROSTER_ONLY||this.fsmState===ge.SIGNALING_FSM_STATE.CONNECTED_FOR_ROSTER_ONLY)this.fsmState=ge.SIGNALING_FSM_STATE.IDLE,this.http.cancelRequestIfPending($n.JOIN_CONVERSATION_WITHOUT_CALL_MODALITY.name,a,void 0,s),this.subscribeToCall(n.conversationUrl.Location,n.correlationId,this.lastUsedJoinCallOptions?this.lastUsedJoinCallOptions.clientEndpointCapabilities:0,{meetingData:this.meetingData,meetingPreferences:this.meetingPreferences,additionalEndpointProperties:this.lastUsedJoinCallOptions?.additionalEndpointProperties},a);else{this.fsmState=ge.SIGNALING_FSM_STATE.IDLE,this.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.OUTGOING_CALL_ESTABLISHMENT);const c={meetingData:this.meetingData,meetingPreferences:this.meetingPreferences};if(this.lastUsedJoinCallOptions){const u=this.lastUsedJoinCallOptions.scenario;c.muted=this.lastUsedJoinCallOptions.muted,c.scenario=`409Redirect${u||""}`,c.isPreheatOnly=this.lastUsedJoinCallOptions.isPreheatOnly,c.clientEndpointCapabilities=this.lastUsedJoinCallOptions.clientEndpointCapabilities,c.clientEndpointDebugContent=this.lastUsedJoinCallOptions.clientEndpointDebugContent,c.additionalEndpointProperties=this.lastUsedJoinCallOptions.additionalEndpointProperties}else c.scenario="409RedirectJoin";this.setInitialTelemetry("JoinCall",{correlationId:n.correlationId,causeId:a,conversationServiceUrl:n.conversationUrl.Location,joinCallOptions:c,offerGenerationTime:void 0}),this.http.cancelRequestIfPending($n.JOIN_CONVERSATION.name,a,void 0,s),this.http.cancelRequestIfPending($n.START_CALL.name,a,void 0,s),this.joinGivenConversation(n.conversationUrl.Location,n.correlationId,this.lastUsedOutgoingMediaContent,this.mediaTypesToUse,void 0,c,a)}}handleCallProgress(n){this.telemetryHelper.recordIncomingEvent(Ft.HANDLE_CALL_PROGRESS,n);const a=Po(n);this.logger.info(`[${a}][handleCallProgress]`);const s=n.body.callProgress;this.fsmState===ge.SIGNALING_FSM_STATE.OUTGOING&&(this.telemetryHelper.setTimeToRingDuration(),this.resetCallEstablishmentTimeout(a),this.onCallStatusChanged(ge.CALL_STATUS.RINGING,a),s.status==="forwarded"&&this.signalingSessionCallback.onCallForwarded({destinationType:s.forwardingDestinationType||"user"},a))}resetCallEstablishmentTimeout(n){const a=this.isOneToOnePSTNCall()?ge.TIMEOUT_VALUES_IN_SECONDS.LONGER_OUTGOING_CALL_ESTABLISHMENT_TIMEOUT:ge.TIMEOUT_VALUES_IN_SECONDS.OUTGOING_CALL_ESTABLISHMENT_TIMEOUT;this.logger.info(`resetCallEstablishmentTimeout: ${a}s`),this.timeoutManager.stopTimer(ge.TIMEOUT_OPERATIONS.OUTGOING_CALL_ESTABLISHMENT),this.timeoutManager.startTimer(ge.TIMEOUT_OPERATIONS.OUTGOING_CALL_ESTABLISHMENT,()=>{this.handleCallEstablishmentTimeout(n)},a)}handleMediaAcknowledgement(n){this.telemetryHelper.recordIncomingEvent(Ft.HANDLE_MEDIA_ACK,n);const a=n.body,s=Po(n);this.currentCallStatus!==ge.CALL_STATUS.CONNECTED?this.telemetryHelper.recordEvent(Ft.HANDLE_MEDIA_PROVISIONAL_ACK,{causeId:s}):this.mediaRenegotiationManager.handleMediaAcknowledgment(a,s)}handleConversationUpdate(n){const a=n.body,s=Po(n);this.logger.info(`[${s}][handleConversationUpdate]content=${fi(a)}`),this.telemetryHelper.recordIncomingEvent(Ft.HANDLE_CONVERSATION_UPDATE,n),this.processConversationServiceResponse(a,s,2)}endBroadcastMeeting(n){this.logger.info(`[${n}][endBroadcastMeeting]`),this.broadcastSession=null}handleLocalParticipantUpdate(n){const a=n.body,s=Po(n);this.logger.info(`[${s}][handleLocalParticipantUpdate]content=${fi(a)}`),this.telemetryHelper.recordIncomingEvent(Ft.HANDLE_LOCAL_PARTICIPANT_UPDATE,n),this.processLocalParticipantUpdateResponse(a,s)}handleAddModalityFailure(n){const a=n.body,s=Po(n);this.logger.info(`[${s}][handleAddModalityFailure]`),this.telemetryHelper.recordIncomingEvent(Ft.HANDLE_ADD_MODALITY_FAILURE,n),a.modalityFailure.contentSharing?this.contentSharingManager?.handleAddModalityFailure(a,s):a.modalityFailure.groupChat?this.signalingSessionCallback.onChatModalitySetupFailed({code:a.modalityFailure.groupChat.code,subCode:a.modalityFailure.groupChat.subCode,phrase:a.modalityFailure.groupChat.phrase,resultCategories:a.modalityFailure.groupChat.resultCategories},s):a.modalityFailure.broadcast&&this.broadcastSession&&this.broadcastSession.handleAddBroadcastModalityFailure(a,s)}handleAddModalitySuccess(n){const a=n.body,s=Po(n);this.logger.info(`[${s}][handleAddModalitySuccess]`),this.telemetryHelper.recordIncomingEvent(Ft.HANDLE_ADD_MODALITY_SUCCESS,n),a.modalitySuccess.contentSharing?this.contentSharingManager?.handleAddModalitySuccess(a,s):a.modalitySuccess.groupChat?this.logger.info(`[${s}][handleAddModalitySuccess] group modality ${fi(a.modalitySuccess.groupChat)}`):a.modalitySuccess.broadcast&&this.broadcastSession&&this.broadcastSession.handleAddBroadcastModalitySuccess(a,s)}handleTransferRequested(n){const a=n.body.callTransfer,s=Po(n);this.logger.info(`[${s}][handleTransferRequested]`),a.parkType?(this.telemetryHelper.recordIncomingEvent(Ft.HANDLE_PARK_REQUESTED,n,{type:a.parkType}),this.telemetryHelper.addSharedCorrelationId(a.sharedCorrelationId)):a.target.endpointType==="voicemail"?(this.logger.info(`[${s}][handleTransferRequested] target endpointType = ${a.target.endpointType}`),this.telemetryHelper.recordIncomingEvent(Ft.TRANSFER_REQUEST_RECEIVED,n)):this.telemetryHelper.recordIncomingEvent(Ft.TRANSFER_REQUEST_RECEIVED,n),this.links[ge.LINKS.TRANSFER_ACCEPTANCE]=a.links.transferAcceptance,this.links[ge.LINKS.TRANSFER_COMPLETION]=a.links.transferCompletion,this.signalingSessionCallback.onTransferRequested?this.signalingSessionCallback.onTransferRequested(a,s):this.logger.info(`[${s}][handleTransferRequested] failed, no callback defined`)}handleTransferAcceptance(n){const a=Po(n);this.logger.info(`[${a}][handleTransferAcceptance]`),this.telemetryHelper.recordIncomingEvent(Ft.WAITING_FOR_TRANSFER_COMPLETION,n),this.signalingSessionCallback.onTransferAccepted?this.signalingSessionCallback.onTransferAccepted(a):this.logger.info(`[${a}][handleTransferAcceptance]failed, no callback defined`)}handleTransferCompletion(n){const a=n.body,s=Po(n);this.logger.info(`[${s}][handleTransferCompletion]`),a.sharedCorrelationId&&this.telemetryHelper.addSharedCorrelationId(a.sharedCorrelationId),a.unparkContent?.pickupCode!==void 0&&(a.unparkContent.pickupCode=a.unparkContent.pickupCode.toString(),this.telemetryHelper.recordIncomingEvent(Ft.PICKUP_CODE_SET,n)),this.signalingSessionCallback.onTransferCompleted?(n.body.transferCompletion&&(n.body.transferCompletion.code===0?this.telemetryHelper.recordIncomingEvent(Ft.TRANSFER_COMPLETED,n):(this.logger.info(`[${s}][handleTransferCompletion]-1-code: ${a.transferCompletion.code}, message: ${fi(n)}`),this.telemetryHelper.recordIncomingEvent(Ft.TRANSFER_COMPLETION_FAILED,n,{code:a.transferCompletion.code,subcode:a.transferCompletion.subCode,resultCategories:a.transferCompletion.resultCategories}))),this.signalingSessionCallback.onTransferCompleted(a,s)):(n.body.transferCompletion&&(n.body.transferCompletion.code===ge.CALL_END_CODE.NETWORK_ERROR?this.telemetryHelper.recordIncomingEvent(Ft.WAITING_FOR_TRANSFER_COMPLETION_FAIL,n):this.telemetryHelper.recordIncomingEvent(Ft.TRANSFER_COMPLETION_FAILED,n,{code:a.transferCompletion.code,subcode:a.transferCompletion.subCode,resultCategories:a.transferCompletion.resultCategories})),this.logger.info(`[${s}][handleTransferCompletion]failed, no callback defined`))}handleRosterUpdate(n,a){const s=n.body,c=Po(n);this.disposing||this.disposed?this.logger.info(`[${c}][handleRosterUpdate]failed=ignore call ending or ended`):this.internalHandleRosterUpdate(s,a,c)}handleNewMediaOffer(n){const a=Po(n);this.telemetryHelper.recordIncomingEvent(Ft.HANDLE_NEW_OFFER,n);const s=n.body.mediaOfferReady.mediaContent;this.callUsesMixer=s.fromMixer,this.signalingSessionCallback.onNewOffer({mediaContent:s,renegotiation:!1},a)}internalHandleRosterUpdate(n,a,s){if(n&&n.type!=="Delta"&&n.type!=="MultiPartyEndpoint")this.logger.warn(`[${s}][internalHandleRosterUpdate] roster.type=${n.type} is invalid`);else{this.logger.info(`[${s}][internalHandleRosterUpdate]`);try{this.participantManager.handleRosterUpdate(n,a,s),this.contentSharingManager?.handleIncomingContentSharingFromRoster(n,a,s)}catch(c){const u={code:ge.CALL_END_CODE.BAD_SERVICE_RESPONSE,subCode:ge.CALL_END_SUB_CODE.ROSTER_HANDLING_INVALID_SERVICE_RESPONSE,phrase:c?.toString()};throw this.logger.info(`[${s}][internalHandleRosterUpdate] ${xo(u)}`),this.telemetryHelper.recordRosterEvent(n,Ft.HANDLE_ROSTER_UPDATE_FAIL,s),u}}}scheduleKeepAlives(n){const a=.9*n*1e3;this.logger.info(`scheduleKeepAlives: every ${a} milliseconds`),this.keepAliveInterval=a,this.keepAliveTimer=window.setInterval(this.sendKeepAlive.bind(this),this.keepAliveInterval)}scheduleConversationKeepAlive(){if(!this.conversationKeepAliveTimer&&!this.disposed){if(!this.conversationKeepAliveInterval){const n=eV(1e3*this.signalingAgentConfig.csaTimeoutConfiguration.conversationKeepAliveTimeoutSec);this.logger.info(`sendConversationKeepAlive: every ${n} milliseconds`),this.conversationKeepAliveInterval=n}this.conversationKeepAliveTimer=window.setInterval(this.sendConversationKeepAlive.bind(this),this.conversationKeepAliveInterval)}}sendConversationKeepAlive(){this.logger.info("sendConversationKeepAlive"),this.disposed?this.logger.info("sendConversationKeepAlive ignored"):(this.logger.info("sendConversationKeepAlive keepAlive count = "+this.conversationKeepAliveCount++),this.sendToUpdateConversationLinks(!0))}sendKeepAlive(){this.logger.info("sendKeepAlive"),this.disposed?this.logger.info("sendKeepAlive ignored"):(this.logger.info("sendKeepAlive keepAlive count = "+this.keepAliveCount++),this.sendToKeepAliveUrl(null))}sendToUpdateConversationLinks(n,a=tr()){if(this.disposed)return Promise.resolve();const s=this.logger.createChild(`[${a}][sendToUpdateConversationLinks]`,this.correlationId),c=n?eA(this):{},u=n?$n.UPDATE_CONVERSATION_LINKS.name:$n.SEND_CONVERSATION_KEEP_ALIVE.name,m=this.links[ge.LINKS.NOTIFICATION_LINKS];return s.info(`shouldUpdateUrl: ${n}, url: ${m}, payload: ${fi(c)}`),m?(this.conversationKeepAliveTimer&&(window.clearInterval(this.conversationKeepAliveTimer),this.conversationKeepAliveTimer=0),this.http.sendPostRequest({url:m,payload:c,withoutTrouter:!0,requestName:u,causeId:a}).then(b=>{this.disposed||(this.telemetryHelper.recordEvent(Ft.UPDATE_CONVERSATION_LINKS_SUCCESS,{causeId:a}),this.processConversationServiceResponse(b.response,a,2))}).catch(b=>{const _=Lr(b,this.signalingAgentConfig),k=dte(_.error.code);this.logger.info(`[${a}][updateConversationLinks] error: ${fi(_)}, retryable: ${k}`),this.disposed||(this.telemetryHelper.recordEvent(Ft.UPDATE_CONVERSATION_LINKS_FAILED,{causeId:a,..._.error}),k?this.scheduleConversationKeepAlive():this.links[ge.LINKS.NOTIFICATION_LINKS]=null)})):Promise.resolve()}sendToKeepAliveUrl(n,a=tr()){const s=this.logger.createChild(`[${a}][sendToKeepAliveUrl]`,this.correlationId);return s.info(`payload: ${fi(n)}`),window.clearInterval(this.keepAliveTimer),this.disposed?Promise.resolve():(this.telemetryHelper.recordEvent(Ft.SEND_KEEP_ALIVE),this.http.sendPostRequest({url:this.links[ge.LINKS.KEEPALIVE],payload:n,requestName:$n.SEND_KEEP_ALIVE.name,withoutTrouter:!0,causeId:a}).then(()=>{this.restartKeepAliveInterval(a)}).catch(c=>{const u=Lr(c,this.signalingAgentConfig);s.info(`error: ${fi(u)}`),this.restartKeepAliveInterval(a,!0,u.error)}))}handleCallEstablishmentTimeout(n,a,s){const c={code:ge.CALL_END_CODE.TIMEOUT,subCode:a||ge.CALL_END_SUB_CODE.CALL_ESTABLISHMENT_TIMEOUT,phrase:s||ge.CALL_END_PHRASE.ESTABLISHMENT_TIMEOUT,resultCategories:[Pu.UnexpectedClientError]};this.isPromotingToRealtime?this.onPromotionCompleted(!0,c,n):(this.telemetryHelper.recordEvent(Ft.HANDLE_CALL_ESTABLISHMENT_TIMEOUT),this.telemetryHelper.setTerminatingData({terminatingEnd:ei.CALL_TERMINATING_END.LOCAL,resultValue:ei.RESULT_VALUE.FAILURE,resultDetail:c.phrase,endCode:c.code,endSubCode:c.subCode,causeId:n,resultCategories:c.resultCategories}),this.fsmState=ge.SIGNALING_FSM_STATE.IDLE,this.onCallStatusChanged(ge.CALL_STATUS.LOCAL_TERMINATED,n,c),this.dispose(c,n))}handleCallTransferTimeout(n,a){if(this.disposed)return void this.logger.info("Transfer: handleCallTransferTimeout ignored");const s={code:ge.CALL_END_CODE.TIMEOUT,phrase:ge.CALL_END_PHRASE.TRANSFER_COMPLETION_TIMEOUT};this.signalingSessionCallback.onTransferCompleted&&(a===!1?this.telemetryHelper.recordEvent(Ft.TRANSFER_COMPLETION_FAILED,{code:ge.CALL_END_CODE.TIMEOUT,subcode:ge.CALL_END_SUB_CODE.TRANSFER_COMPLETE_TIMEOUT,causeId:n}):a===!0&&this.telemetryHelper.recordEvent(Ft.WAITING_FOR_TRANSFER_ACCEPTANCE_FAIL,{causeId:n}),this.signalingSessionCallback.onTransferCompleted({transferCompletion:s},n))}checkCorrelationIdChange(n,a){if(n&&n.headers){const s=n.headers.get(ge.HEADERS.CORRELATION_ID);if(s&&s.length){const c=[Fi.CONV_CONTENT_SHARING_UPDATE,Fi.CONV_CONTENT_SHARING_END].some(u=>n.url&&ND(n.url,u));this.correlationId===s||c||(this.logger.info(`[${a}]checkCorrelationIdChange:${this.correlationId} => ${s}`),this.telemetryHelper.addChangingCorrelationId(this.correlationId,s),this.updateCorrelationId(s,a))}}}getCommandUrlPresence(){let n=0;return this.links[ge.LINKS.MUTE]&&(n|=1),this.links[ge.LINKS.UNMUTE]&&(n|=2),n}getCallNotFoundTransactionEnd(){return{code:ge.CALL_END_CODE.CALL_DOES_NOT_EXIST,subCode:0,phrase:ge.CALL_END_PHRASE.CALL_DOES_NOT_EXIST}}dispose(n,a){this.disposed||(this.logger.info(`[${a}][dispose] end reason ${fi(n)}`),this.disposed=!0,this.disposing=!1,this.tearDownConnectionCheck(),this.conversationKeepAliveTimer&&(window.clearInterval(this.conversationKeepAliveTimer),this.conversationKeepAliveTimer=0),this.keepAliveTimer&&window.clearInterval(this.keepAliveTimer),this.brokerService&&this.brokerService.dispose(),this.http.cancelAllRequests(a).then(()=>{this.signalingAgent.onCallCompleted(this.sessionId,a),this.signalingAgentConfig.trouterUrlGetter&&this.signalingAgentConfig.trouterUrlGetter.trouterUrl.changed.off(this.onTrouterUrlChanged),this.signalingAgentConfig.trouterServiceProvider&&this.signalingAgentConfig.trouterServiceProvider.offStateChanged(this.onTrouterStateChanged),this.timeoutManager.dispose(),this.timeoutManager=null,this.participantManager.dispose(n,a),this.callOperationHandler.dispose("call ended",n,a),this.participantManager=null,this.mediaRenegotiationManager?.dispose(),this.mediaRenegotiationManager=null,this.contentSharingManager?.dispose(n,a),this.contentSharingManager=null,this.telemetryHelper.dispose(),this.telemetryHelper=null,this.webRtcSignalingManager.dispose(),this.webRtcSignalingManager=null}))}};function edi(n,a,s,c,u,m){return new Xci(n,a,s,c,u,m)}var tdi=class{constructor(n){this.endpointId=My(),this.signalingSessions={},this.clientSupportsGenericTokenAPI=!1,this.getNewSignalingSession=(s,c,u,m)=>{const b=tr();xn(s,"selfParticipant should be a non null value"),xn(c,"signalingSessionCallback should be a non null value");const _=u||My();lc(_,"signalingSession id generated cannot be null or empty"),this.checkConfigChange(b);const k=edi(s,c,this.signalingAgentConfig,_,this,m),N=k.sessionId;return this.signalingSessions[N]=k,this.logger.info(`[${b}]Created new signalingSession with correlation ID ${_} and session ID ${N}`),k},this.resolvePotentialCallConflict=s=>{const c=tr();if(this.logger.info(`[${c}][resolvePotentialCallConflict]`),s.multiParty)return;const u=Object.values(this.signalingSessions).find(_=>this.isSessionInConflictingState(_,s));if(!u)return;let m;if(m=s.isIncomingCall?this.getConflictingSessionToEnd(s,u):this.getConflictingSessionToEnd(u,s),!m)return;const b=m===s?u:s;return this.logger.info("Call conflict done.",` conflictingSession.correlationId=${u.correlationId}`,` conflictingSession.urlIdentifier=${u.urlIdentifier}`,` sessionToEnd.correlationId=${m.correlationId}`,` sessionToEnd.urlIdentifier=${m.urlIdentifier}`),m.telemetryHelper.setConflictingCallId(b.correlationId),m.telemetryHelper.recordEvent(Ft.CONFLICTED_CALL),this.signalingAgentConfig.endConflictedCall?(this.endConflictedSession(m,c),m):void 0},this.handleIncomingNotification=s=>{if(xn(s,"request should be a non null value"),this.logger.info(`handleIncomingNotification to : ${s.url}`),!s.body&&!s.rawBody)return this.logger.error("request has no body"),this.buildNotificationResponse(ge.HTTP_STATUS_CODES.BAD_REQUEST);let c=ge.HTTP_STATUS_CODES.OK;const u=Lve(s.url);if(u){const b=this.signalingSessions.hasOwnProperty(u);if(this.logger.info(`Is session found:${b}`),b){const _=this.signalingSessions[u];if(s.headers=new zb(s.headers),lte(s.headers))try{if(!cte(s.headers))throw new Error("Unsupported encoding");const k=EV(s.rawBody),N=JSON.parse(k);s.body=N}catch{return _.telemetryHelper.recordEvent(Ft.TROUTER_DECODE_PAYLOAD_FAILURE),this.buildNotificationResponse(ge.HTTP_STATUS_CODES.BAD_REQUEST)}if(_.canHandleIncomingMsgSync(s))return _.handleIncomingMsgSync(s);window.setTimeout(()=>{if(this.signalingSessions.hasOwnProperty(u)){const k=this.signalingSessions[u];k.handleIncomingMsgAsync(s).catch(N=>{k&&k.telemetryHelper&&k.telemetryHelper.recordEvent(Ft.FAILED_TO_HANDLE_TROUTER_MESSAGE),this.logger.error(`handling IncomingMsg failed with error: ${N}`)})}},0)}else this.logger.info(`Incoming message for session ID ${u}, but session was not found!`),c=ge.HTTP_STATUS_CODES.NOT_FOUND}else this.logger.error(`Could not retrieve session ID from Url path. Path = ${s.url}`),c=ge.HTTP_STATUS_CODES.BAD_REQUEST;const m=this.buildNotificationResponse(c);return this.logger.info(`Result code:${fi(m)}`),m},this.onCallCompleted=(s,c)=>{this.signalingSessions.hasOwnProperty(s)?(delete this.signalingSessions[s],this.logger.info(`[${c}][onCallCompleted] Session ID ${s} found. Deleted from signalingSession table`)):this.logger.info(`[${c}][onCallCompleted] Session ID ${s} not found. Could not delete from signalingSession table`)},this.applyAuthTokenCacheConfig=s=>{this.signalingAgentConfig.enableTokenCache?(this.authTokenManager.setTokenCaching(!0,s),this.signalingAgentConfig.enableTokenPrefetch&&this.authTokenManager.getToken(s).then(()=>{this.logger.info(`[${s}] token prefetch success`)}).catch(c=>{this.logger.info(`[${s}] token prefetch failure, error=${fi(c)}`)})):this.authTokenManager.setTokenCaching(!1,s),this.signalingAgentConfig.enableTokenCacheForGenericTokenAPI?this.authTokenManager.setTokenCachingForGenericTokenAPI(!0,s):this.authTokenManager.setTokenCachingForGenericTokenAPI(!1,s)},this.endConflictedSession=(s,c)=>{this.logger.info("Call conflict, ending signalingSession with callId=",s.correlationId,"urlIdentifier=",s.urlIdentifier),s.endAsync({code:ge.CALL_END_CODE.CONFLICT,subCode:ge.CALL_END_SUB_CODE.CONFLICT_IN_NG,phrase:ge.CALL_END_PHRASE.CONFLICT},{forEveryone:!1,causeId:c})},this.getConflictingSessionToEnd=(s,c)=>{if(!P2(s.incomingCallCallerId)||!P2(c.participantManager.localParticipant.id))return;const u=SN(s.incomingCallCallerId),m=c.participantManager.getParticipantsToInitiateCallWith();if(m.length===0)return;const b=SN(m[0].id),_=SN(c.participantManager.localParticipant.id);return b===u?_>u?s:c:void 0},this.isSessionInConflictingState=(s,c)=>{if(!s)return this.logger.info("Call conflict, ignore, session already disposed"),!1;const u=[ge.CALL_STATUS.IDLE,ge.CALL_STATUS.CONNECTING,ge.CALL_STATUS.RINGING];return!s.multiParty&&u.indexOf(s.getCallStatus())>-1&&c.isIncomingCall!==s.isIncomingCall},this.buildNotificationResponse=(s,c)=>this.signalingAgentConfig.supportsSynchronousTrouterResponse?{resultCode:s,responseBody:c}:s,gte(n),this.signalingAgentConfig=n,this.logger=n.logger.createChild("SignalingAgent"),xn(n,"signalingAgentConfig should be a non null value"),this.logger.info(n.isWebRtcEnabled?"webRTC enabled":"ORTC enabled");const a={aadTokenExpirationTimeInSeconds:n.aadTokenExpirationTimeInSeconds,caeTokenExpirationTimeInSeconds:n.caeTokenExpirationTimeInSeconds,disableTokenMigrationHeader:n.disableTokenMigrationHeader,enablePublishTokenTelemetry:n.enablePublishTokenTelemetry,refreshTimeBeforeTokenTimeoutInSeconds:n.refreshTimeBeforeTokenTimeoutInSeconds,forceClearExpiredTokens:n.forceClearExpiredTokens,enableRefreshToken:n.enableRefreshToken,enableRefreshTokenRetry:n.enableRefreshTokenRetry,enableRefreshTokenRetryInSeconds:n.enableRefreshTokenRetryInSeconds};this.authTokenManager=Bve.build(this.logger,n.skypeToken,a,n.telemetryManager),this.applyAuthTokenCacheConfig(tr()),zb.useLowerCaseHeaders=n.forceLowercaseHttpHeaders}updateSignalingAgentConfig(n){const a=tr(),s=JSON.stringify(n,(c,u)=>c?String(u):u);this.logger.info(`[${a}] updateSignalingAgentConfig, SignalingAgentConfig: ${s}`),this.logger.info(`[${a}] ecsEtag=${n.ecsEtag}`),gte(n),this.updatedSignalingAgentConfig=n,this.authTokenManager?.updateTokenSettings({aadTokenExpirationTimeInSeconds:n.aadTokenExpirationTimeInSeconds,caeTokenExpirationTimeInSeconds:n.caeTokenExpirationTimeInSeconds,refreshTimeBeforeTokenTimeoutInSeconds:n.refreshTimeBeforeTokenTimeoutInSeconds,disableTokenMigrationHeader:n.disableTokenMigrationHeader,enablePublishTokenTelemetry:n.enablePublishTokenTelemetry,forceClearExpiredTokens:n.forceClearExpiredTokens,enableRefreshToken:n.enableRefreshToken,enableRefreshTokenRetry:n.enableRefreshTokenRetry,enableRefreshTokenRetryInSeconds:n.enableRefreshTokenRetryInSeconds}),zb.useLowerCaseHeaders=n.forceLowercaseHttpHeaders}updateUrls(n,a,s){this.logger.info(`updateUrls: conversationServiceUrl: ${n}, uploadLogRequestUrl: ${a}, enforceUrls: ${s}`),this.updatedSignalingAgentConfig=this.updatedSignalingAgentConfig||this.signalingAgentConfig,s||!this.updatedSignalingAgentConfig.isConversationServiceUrlFromEcs?this.updatedSignalingAgentConfig.conversationServiceUrl=n||this.updatedSignalingAgentConfig.conversationServiceUrl:this.updatedSignalingAgentConfig.conversationServiceUrl=this.updatedSignalingAgentConfig.conversationServiceUrl||n,s||!this.updatedSignalingAgentConfig.isUploadLogRequestUrlFromEcs?this.updatedSignalingAgentConfig.uploadLogRequestUrl=a||this.updatedSignalingAgentConfig.uploadLogRequestUrl:this.updatedSignalingAgentConfig.uploadLogRequestUrl=this.updatedSignalingAgentConfig.uploadLogRequestUrl||a}update(n){this.logger.info(`update accountConfiguration ${JSON.stringify(n)}`),n&&n.clientSupportsGenericTokenAPI!==this.clientSupportsGenericTokenAPI&&(this.clientSupportsGenericTokenAPI=n.clientSupportsGenericTokenAPI,this.authTokenManager.updateTokenSettings({clientSupportsGenericTokenAPI:this.clientSupportsGenericTokenAPI})),this.accountConfig=n}sendPushAsync(n,a,s,c,u=tr()){const m=new wV(this.signalingAgentConfig.piiScrubber),b=`sendPush[local participant mri = ${m.scrubMriOrOmit(n)}][recipientList = ${m.scrubMriOrOmit(a)}][headers = ${s})][causeId = ${u}]`;if(!n?.id)return this.logger.info(`${b} Empty localParticipantId`),Promise.reject("invalid localParticipantId");if(!a||a.length===0||a.every(W=>W&&W.id===""))return this.logger.info(`${b} Empty recipientList`),Promise.reject("invalid recipientList");if(!s)return this.logger.info(`${b} Empty headers`),Promise.reject("invalid headers");if(!c||Q0(c)===null)return this.logger.info(`${b} Invalid body.`),Promise.reject("invalid body");const _={...Q0(c),To:Array.from(a,W=>W.id),From:n.id},k=new zb(s);k.hasOwnPropertyCaseInsensitive(ge.HEADERS.CORRELATION_ID)||k.set(ge.HEADERS.CORRELATION_ID,sC()),k.hasOwnPropertyCaseInsensitive(ge.HEADERS.MESSAGE_ID)||k.set(ge.HEADERS.MESSAGE_ID,sC()),k.hasOwnPropertyCaseInsensitive(ge.HEADERS.PARTICIPANT_ID)||k.set(ge.HEADERS.PARTICIPANT_ID,sC()),k.hasOwnPropertyCaseInsensitive(ge.HEADERS.CONTENT_TYPE)||k.set(ge.HEADERS.CONTENT_TYPE,"application/json"),k.hasOwnPropertyCaseInsensitive(ge.HEADERS.CLIENT_USER_AGENT)&&k.set(ge.HEADERS.CLIENT_USER_AGENT,k.get(ge.HEADERS.CLIENT_USER_AGENT)+`/TsCallingVersion=${wu()}/Ovb=${UR()}`);const N=this.signalingAgentConfig.httpRequestDispatcher.getRequestOptions("POST",k?.getAll(),JSON.stringify(_),3e4);return N.useFetch=this.signalingAgentConfig.enableFetchApi,new Promise((W,ee)=>{this.signalingAgentConfig.httpRequestDispatcher.postAsync(this.signalingAgentConfig.uploadLogRequestUrl||ge.URL_DEFAULTS.UPLOAD_LOG_URL,N).then(()=>{W()}).catch(oe=>{ee(oe)})})}getSignalingSession(n){for(const a of Object.keys(this.signalingSessions)){const s=this.signalingSessions[a];if(s.correlationId===n)return s}return null}updateToken(n,a,s,c,u){this.authTokenManager.updateToken(n,a,s,c,u)}setTokenRequiredCallBack(n){this.authTokenManager.setTokenRequiredCallBack(n)}resetAuthTokenManager(){this.setTokenRequiredCallBack(null),this.authTokenManager.setDisableTimerFlag(!0),this.authTokenManager.dispose()}checkConfigChange(n){this.updatedSignalingAgentConfig&&this.updatedSignalingAgentConfig!==this.signalingAgentConfig&&(this.signalingAgentConfig=this.updatedSignalingAgentConfig,this.updatedSignalingAgentConfig=null,this.applyAuthTokenCacheConfig(n))}},idi=/;aliases=.*$/i,AN="8:",ndi=";aliases=",adi="2:",U8e="4:";function $te(n){return n&&n.replace(idi,"")}function sye(n,a){let s=n;return a&&(s+=ndi+adi+a),s}var Hte=(n,a)=>a&&a.phase!==void 0&&!!n[a.phase],IN=(n,a)=>a&&a.phase!==void 0&&a.phase===n;function OV(n){const a={},s=m=>{const b={status:"Pending"};a[m]=b},c=(m,b)=>{a[m].t=b,delete a[m].status},u=(m,b,_)=>{a[m].status="Failed",a[m].t=b,a[m].reason=fi(_)};return{execute:async(m,b)=>{const _=n.createChild(`[phase=${m}]`);s(m),_.info("started");const k=new Date().getTime();try{const N=await b(),W=+new Date-k;return _.logSuccess(`done, time=${W}`),c(m,W),N}catch(N){const W=+new Date-k;throw _.logFailure(`time=${W}, error=${fi(N)}`),u(m,W,N),{phase:m,error:N,phases:a}}},executeSync:(m,b)=>{const _=n.createChild(`[phase=${m}]`);_.info("started"),s(m);const k=new Date().getTime();try{const N=b(),W=+new Date-k;return c(m,W),_.logSuccess(`done, time=${W}`),N}catch(N){const W=+new Date-k;throw _.logFailure(`time=${W}, error=${fi(N)}`),u(m,W,N),{phase:m,error:N,phases:a}}},getTelemetryData:()=>a}}function t9(n,a){return a.indexOf(n)!==-1}var zg,Ao,z8e,rdi={0:[1,2,8,6,10,11,9],1:[2,6,7,10,13],2:[1,3,6,7,9,10,13,14],3:[6,7,4,5,10,13],8:[1,11,10,2,9,6,7],4:[6,7,3,5,10,13],5:[6,7,3,4,10,13],9:[3,6,7,10,13],10:[3,6,7,9,4,5,13,15],13:[3,6,7,4,5],14:[3,6,7,10,13],15:[3,6,7,4,5,13],11:[12,1,2,6,7],12:[2,6,7],6:[7],7:[]};(n=>{var a,s,c,u;(a=n.VideoEffectType||(n.VideoEffectType={})).Off="off",a.BackgroundBlur="blur",a.BackgroundReplacement="replacement",a.PresenterMode="presenterMode",a.None="none",(s=n.PowerPreference||(n.PowerPreference={})).Default="default",s.HighPerformance="high-performance",s.LowPower="low-power",(c=n.ProcessorType||(n.ProcessorType={})).Wasm="Wasm",c.Webgl2="Webgl2",(u=n.EffectQualityChangeReason||(n.EffectQualityChangeReason={}))[u.ExternalParam=0]="ExternalParam",u[u.Performance=1]="Performance",u[u.RendererSize=2]="RendererSize"})(zg||(zg={})),(n=>{var a,s,c,u,m;(a=n.CallType||(n.CallType={}))[a.P2P=0]="P2P",a[a.Conference=1]="Conference",a[a.PSTN=2]="PSTN",a[a.BroadcastingConf=3]="BroadcastingConf",(s=n.AudioUsageMode||(n.AudioUsageMode={}))[s.Default=0]="Default",s[s.LongRangeSpeaker=1]="LongRangeSpeaker",s[s.Auditorium=2]="Auditorium",(c=n.AecPerfProfile||(n.AecPerfProfile={}))[c.Normal=0]="Normal",c[c.Soc=1]="Soc",c[c.Mobile=2]="Mobile",c[c.NoisyTimestamps=3]="NoisyTimestamps",(u=n.VqeMode||(n.VqeMode={}))[u.Off=0]="Off",u[u.SkypeNS=1]="SkypeNS",u[u.SkypeAEC=2]="SkypeAEC",u[u.SkypeVQE=3]="SkypeVQE",u[u.DeepNS=4]="DeepNS",u[u.DeepVQE=5]="DeepVQE",(m=n.AudioEffectType||(n.AudioEffectType={})).Off="Off",m.NoiseSuppressionDeep="Deep NS",m.NoiseSuppressionClassic="Classic NS",m.EchoCancellationClassic="Classic AEC",m.VoiceQualityEnhancementClassic="Classic VQE",m.VoiceQualityEnhancementDeep="Deep VQE"})(Ao||(Ao={})),(n=>{var a,s;(a=n.FrameType||(n.FrameType={}))[a.None=0]="None",a[a.Software=1]="Software",a[a.Hardware=2]="Hardware",(s=n.LogLevel||(n.LogLevel={}))[s.Default=0]="Default",s[s.Debug=1]="Debug",s[s.Info=2]="Info",s[s.Warning=3]="Warning",s[s.Error=4]="Error"})(z8e||(z8e={}));var tE=dn,lye=(n=>(n[n.CallStateChanged=0]="CallStateChanged",n[n.TrouterStateChanged=1]="TrouterStateChanged",n[n.MultiPartyModeSet=2]="MultiPartyModeSet",n[n.MediaRetargetSucceeded=3]="MediaRetargetSucceeded",n[n.MediaRetargetFailed=4]="MediaRetargetFailed",n))(lye||{}),jte=(n=>(n[n.StartModality=0]="StartModality",n[n.StopModality=1]="StopModality",n[n.StreamStateChanged=2]="StreamStateChanged",n[n.NegotiationStateChanged=3]="NegotiationStateChanged",n))(jte||{}),V8e=(n=>(n[n.SelectSource=0]="SelectSource",n[n.AttachSource=1]="AttachSource",n[n.DetachSource=2]="DetachSource",n))(V8e||{}),$8e=(n=>(n[n.Available=0]="Available",n[n.Subscribe=1]="Subscribe",n[n.Subscribed=2]="Subscribed",n[n.Unsubscribe=3]="Unsubscribe",n[n.Unsubscribed=4]="Unsubscribed",n[n.RenderingStarted=5]="RenderingStarted",n[n.RenderingStopped=6]="RenderingStopped",n))($8e||{}),dd=class{};dd.agentEnvironmentId="agent_environment_id",dd.correlationId="CorrelationId",dd.participantId="participant_id",dd.displayName="display_name",dd.tenantId="TenantId",dd.userHexCID="UserHexCID",dd.acsResourceId="AcsResourceId",dd.endpointId="endpoint_id",dd.mediaLegId="media_leg_id",dd.webMediaConfigIds="web_media_config_ids",dd.tsCallingVersion="ts_calling_version",dd.rpcSessionId="rpc_session_id";var Hb=class{};Hb.diagnostics="MediaDiagnostic",Hb.qoeStats="QoE",Hb.webrtcSession="webrtc_session",Hb.webrtcSessionInitial="webrtc_session_initial",Hb.realtimeTelemetry="realtimetelemetry",Hb.webrtcMediaSession="webrtc_call_session",Hb.mediaSession="pluginless_modality_session",Hb.callSession="pluginless_call_session";var H8e=class{constructor(n){this.eventName=n,this.ended=!1,this.events=[]}setLocalUserId(n){this.localUserId=n}start(){this.ended||(this.startTime=Date.now())}end(n=0){this.ended||(this.ended=!0,this.resultCode=n)}asStatsRecord(n={}){if((0,tE.isEmpty)(this.events))return null;const a=(0,tE.uniqBy)(this.events,s=>JSON.stringify(s)).map(s=>{const c={[s.type]:s.timestamp-this.startTime};return(0,tE.isEmpty)(s.data)||(c.data=s.data),c});return{name:this.eventName,record:(0,tE.assign)({LocalUser:this.localUserId,ResultCode:String(this.resultCode),EventTimestampBag:JSON.stringify({eventStart:this.startTime,events:a})},n)}}add(n){!this.ended&&n.type&&((0,tE.isUndefined)(this.startTime)&&(this.startTime=Date.now()),(0,tE.isUndefined)(n.timestamp)&&(n.timestamp=Date.now()),this.events.push(n))}},j8e=class bQe extends H8e{constructor(){super(Hb.callSession)}callStateChanged(a){super.add({type:lye[0],data:bQe.callStateToString[a]||a})}event(a){super.add({type:lye[a]})}};j8e.callStateToString={0:"None",1:"Notified",2:"Connecting",3:"Connected",4:"LocalHold",5:"RemoteHold",6:"Disconnecting",7:"Disconnected",8:"Observing",10:"Lobby"};var odi=j8e,U2=class DU extends H8e{constructor(a,s){super(Hb.mediaSession),this.mediaType=a,this.mediaDirection=s,this.streamDirection=DU.mediaDirectionToStream[this.mediaDirection]}addEvent(a,s){super.add({type:a,data:s})}lifecycle(a){this.addEvent(jte[a])}streamStateChanged(a,s=this.streamDirection){const c=jte[2];this.addEvent(c,{state:DU.streamStateToString[a],direction:DU.streamDirectionToString[s]})}negotiationStateChanged(a,s,c=this.streamDirection){const u=jte[3];this.addEvent(u,{state:DU.negotiationStateToString[a],reason:s})}asStatsRecord(a={}){return super.asStatsRecord((0,tE.assign)({MediaType:DU.mediaTypeToString[this.mediaType],Role:DU.mediaDirectionToRole[this.mediaDirection]},a))}};U2.negotiationStateToString={started:"NegotiationStarted",rejected:"NegotiationRejected",completed:"NegotiationCompleted"},U2.streamStateToString={created:"StreamCreated",started:"StreamStarted",active:"StreamActive",inactive:"StreamInactive",stopped:"StreamStopped",removed:"StreamRemoved",failed:"StreamFailed",cancelled:"StreamCancelled"},U2.streamDirectionToString={send:"Send",receive:"Receive"},U2.mediaTypeToString={0:"Audio",1:"Video",2:"ScreenShare",3:"Data"},U2.mediaDirectionToRole={1:"Receiver",2:"Sender",4:"Bidirectional"},U2.mediaDirectionToStream={1:"receive",2:"send"};var cye=U2,sdi=class extends cye{constructor(){super(0,4)}start(){super.start(),super.lifecycle(0)}stop(){super.lifecycle(1)}},G8e=class extends cye{constructor(n){super(n,2),this.mediaType=n}start(){super.start(),super.lifecycle(0)}stop(){super.lifecycle(1)}event(n){super.addEvent(V8e[n])}},ldi=class extends cye{constructor(n,a){super(n,1),this.mediaType=n,this.remoteParticipantId=a,this.rendererCounter=0}newRendererId(){return this.rendererCounter+=1,String(this.rendererCounter)}event(n,a,s){super.addEvent($8e[n],(0,tE.isUndefined)(s)?{rendererId:a}:{rendererId:a,sourceId:s})}asStatsRecord(){return super.asStatsRecord({TargetUser:this.remoteParticipantId})}},cdi=class{constructor(){this.allStats=[],this.ended=!1}setLocalUserId(n){this.localUserId=n}get call(){return this.callStats||this.startCall()}get audio(){return this.audioStats||this.newSession(0)}get video(){return this.videoStats||this.newSession(1)}get screenShare(){return this.sharingStats||this.newSession(2)}renderer(n,a){let s=this.renderingStats[a];return s||(s=this.renderingStats[a]=this.receive(n,a)),s}startCall(){return this.callStats?this.callStats:(this.callStats=new odi,this.callStats.start(),this.addStats(this.callStats))}endCall(n=0){this.ended=!0,this.call.end(n),this.allStats.forEach(a=>a.end()),this.cleanUp()}cleanUp(){this.audioStats&&(this.audioStats.stop(),this.audioStats=null),this.videoStats&&(this.videoStats.stop(),this.videoStats=null),this.sharingStats&&(this.sharingStats.stop(),this.sharingStats=null)}newSession(n){let a;switch(n){case 0:a=this.audioStats=new sdi;break;case 1:a=this.videoStats=new G8e(n);break;case 2:a=this.sharingStats=new G8e(n)}return this.addStats(a)}receive(n,a){const s=new ldi(n,a);return s.start(),this.addStats(s)}buildStatsRecords(){return this.allStats.map(n=>n.asStatsRecord()).filter(n=>!!n)}addStats(n){return this.ended||(this.allStats.push(n),n.setLocalUserId(this.localUserId)),n}},dye=class Aae{constructor(){this.startTime=Date.now(),this.localStats=new cdi,this.tsCallingVersion=wu()}setRpcSessionId(a){this.rpcSessionId=a}setCallId(a){this.callId=a}setTenantId(a){this.tenantId=a}setUserHexCID(a){this.userHexCID=a}setParticipantId(a){this.participantId=a}setDisplayName(a){this.displayName=a}setEndpointId(a){this.endpointId=a}setMediaLegId(a){this.mediaLegId=a}setMediaStats(a){this.mediaStats=a}setAcsResourceId(a){this.acsResourceId=a}appendDataChannelInfo(a){this.mediaStats?.data&&a&&(this.mediaStats.data.DataHandlers=a)}appendSharingControlInfo(a){this.mediaStats?.data&&(this.mediaStats.data.SharingControlEnabled=a?"true":"false")}appendMediaControlPlaneInfo(a){this.mediaStats?.data&&a&&(this.mediaStats.data.MediaControlPlane=a)}appendTerminationInfo(a,s){this.mediaStats?.data&&(this.mediaStats.data.TerminatedReason=`${a}`,this.mediaStats.data.TerminatedState=`${s}`)}appendPictureInPictureInfo(a){this.mediaStats?.data&&a&&(this.mediaStats.data.PictureInPicture=a)}appendCallDeviceManagerInfo(a){this.mediaStats?.data&&a&&(this.mediaStats.data.CallDeviceManager=a)}async buildVDItelemetryReport(a){const{transport:s,rpc:c,rpcRemote:u,transportRemote:m}=await a.getStats(this.startTime);return{CallId:this.callId,ParticipantId:this.participantId,Transport:JSON.stringify(s),Rpc:JSON.stringify(c),Rpc_Remote:JSON.stringify(u),Transport_Remote:JSON.stringify(m)}}buildFromMediaStats(){return this.mediaStats?.type==="WebRtcMediaStats"?[this.buildEvent(this.mediaStats.data,Hb.webrtcSession)]:[]}buildShortCallEvent(a){const s={};return s[dd.correlationId]=this.callId||"",s[dd.participantId]=this.participantId||"",s[dd.displayName]=new _v(this.displayName||"",1),s[dd.tenantId]=this.tenantId||"",s[dd.tsCallingVersion]=this.tsCallingVersion||"",s[dd.rpcSessionId]=this.rpcSessionId||"",s.metrics_TerminationReason_code=new _v(a.data.metrics.TerminationReason_code,0),s.metrics_TerminationReason_subCode=new _v(a.data.metrics.TerminationReason_subCode,0),s.metrics_eventType=new _v(a.eventType,0),[{eventName:Hb.webrtcMediaSession,props:this.buildProps(a.data,null,s)}]}buildMediaTelemetry(){if(!this.mediaStats)return;const a=this.buildEvent(this.mediaStats.data,null).props,s={};return Object.keys(a).forEach(c=>{a[c].piiKind===void 0?s[c]=a[c]:s[c]=a[c].value}),s}buildMidCallTelemetry(a){if(!this.mediaStats)return[];const s=this.buildEvent(this.mediaStats.data,Hb.webrtcSession),c=s.props,u=a.reduce((m,b)=>(c[b]&&(m[b]=c[b]),m),{});return[{eventName:s.eventName,props:u}]}buildFromCallSetupStats(a){return this.mediaStats?.type==="WebRtcMediaStats"?(this.mediaStats.data.trouterUrl=a,[this.buildEvent(this.mediaStats.data,Hb.webrtcSessionInitial)]):[]}buildFromLocalStats(){return this.localStats.buildStatsRecords().map(a=>this.buildEvent(a.record,a.name))}buildEvent(a,s){const c={};return c[dd.agentEnvironmentId]=Aae.agentEnvironmentId,c[dd.correlationId]=this.callId||"",c[dd.tenantId]=this.tenantId||"",c[dd.userHexCID]=this.userHexCID||"",c[dd.participantId]=this.participantId||"",c[dd.displayName]=new _v(this.displayName||"",1),c[dd.endpointId]=this.endpointId||"",c[dd.mediaLegId]=this.mediaLegId||"",c[dd.webMediaConfigIds]=this.webMediaConfigIds||"",c[dd.tsCallingVersion]=this.tsCallingVersion||"",c[dd.acsResourceId]=this.acsResourceId||"",c[dd.rpcSessionId]=this.rpcSessionId||"",{eventName:s,props:this.buildProps(a,null,c)}}normalizeKey(a){return a.replace(/[^a-zA-Z0-9._]/g,"_")}buildProps(a,s,c){return Object.keys(a).forEach(u=>{const m=this.normalizeKey(u),b=s?`${s}_${m}`:m,_=a[u];if((0,tE.isString)(_))c[b]=this.getPiiAwareValue(u,_);else if((0,tE.isArray)(_)){if(_.length>0){const k=_,N=k.map(W=>W.value).toString();c[b]=new _v(N,k[0].type)}}else if((0,tE.isObject)(_))if(_.__VALUE__){const k=_;(0,tE.isBoolean)(k.value)&&(k.value=k.value?"true":"false"),c[b]=new _v(k.value,k.type)}else this.buildProps(_,b,c)}),c}getPiiAwareValue(a,s){return Aae.piiProps.hasOwnProperty(a)?new _v(s,Aae.piiProps[a]):s}build(){return(0,tE.flatten)([this.buildFromMediaStats(),this.buildFromLocalStats()])}};dye.agentEnvironmentId=sC(),dye.piiProps={IPAddr:13,MACAddr:13,IPAddress:13,OpaqueData:0,LocalSite:13,RemoteSite:13,BaseAddress:13,LocalAddress:13,RemoteAddress:13,NetworkName:12,LocalUser:10,TargetUser:10,[dd.displayName]:1};var ddi=dye,udi=dn;function i9(n){return n?W8e(n.code,n.subCode):0}function q8e(n,a){const s={clientVersion:n.clientVersion,participantId:n.participantId,endpointId:n.endpointId,endpointType:n.endpointType,endpointMetadata:n.endpointMetadata,originalId:n.originalId,capabilities:n.capabilities,clientEndpointCapabilities:n.clientEndpointCapabilities,mappedTo:n.mappedTo,meetingGroupDetails:n.meetingGroupDetails,endpointMeetingRoles:n.endpointMeetingRoles};return n.mediaStreams&&(s.mediaStreams=n.mediaStreams),n.appliedInteractivityLevel&&(s.appliedInteractivityLevel=n.appliedInteractivityLevel),n.deviceType&&(s.deviceType=n.deviceType),n.streamInformation&&32&a&&(s.streamInformation=n.streamInformation),n.propertyBag&&(s.propertyBag=n.propertyBag),n.negotiationTag&&(s.negotiationTag=n.negotiationTag),s}function W8e(n,a=null){if(n===er.Success)switch(a){case Ml.RemovedFromConversation:case Ml.RemovedFromCall:return 44;case Ml.DeniedInLobby:return 55;case Ml.TimedOutInLobby:return 56;default:return 1}if(a!==null&&a>=2e5&&a<=299999){const s=a-2e5;return ete[s]?ete[s]:0}return a!==null&&a>=4e5&&a<=499999?tte[n]?tte[n]:43:n===er.Forbidden?a===Ml.UserBlocked?64:a===Ml.PolicyRestriction?62:a===Ml.AnonymousJoinDisabledByPolicy?66:a===Ml.NoLobbyForBroadcastJoin?67:a===Ml.NotAllowedDueToInformationBarrier?68:a===Ml.TeamParkPolicyDisabled?70:a===Ml.B2bJoinDisabledByPolicy?71:8:n===er.PreconditionFailed&&a===Ml.InsufficientCapabilities?63:n===er.ServiceUnavailable?a===Ml.BroadcastLimitReached?69:48:n===er.InternalServerError?7:n===er.ConfParticipantCountLimitReached?a===Ml.MaxLobbyParticipantLimitReached?73:59:LD[n]?LD[n]:n}function K8e(n){if(n===1)return er.Success;const a=Object.keys(LD).filter(s=>LD[s]===n);if(a.length>=1)for(const s of a){const c=parseInt(s);if(c&&LD[c]===n)return c}return er.UnknownError}function qR(n,a){if(a!==void 0&&a!==3&&a!==1)return{mediaType:n,isDisabled:a===0,label:KG(n)}}function wN(n){if(n.sendMediaModalities)return n;const a={mediaStates:[]};let s=qR(0,n.audioDirection?n.audioDirection:4);return s&&a.mediaStates.push(s),s=qR(1,n.withVideo?4:n.videoDirection),s&&a.mediaStates.push(s),s=qR(2,n.screenshareDirection?n.screenshareDirection:1),s&&a.mediaStates.push(s),n.sendMediaModalities=a,n}function hdi(n){const a=pdi(n.type),s=gdi(n.endpointType);return{type:a,id:n.id,endpointType:s}}function pdi(n){if(n==="mri")return"mri";throw"Unknown RedirectionTargetIdType"}function gdi(n){switch(n){case"voicemail":return"voicemail";case"default":return"default";default:throw"Unknown RedirectionEndpointType"}}var J8e=class{constructor(n){this.mediaStateConfiguration=n}isDisabled(n){if(this.mediaStateConfiguration?.mediaStates){const a=this.mediaStateConfiguration.mediaStates.find(s=>s.mediaType===n);return!!a&&!!a.isDisabled}return!1}isInactiveOrDisabled(n){if(this.mediaStateConfiguration?.mediaStates){const a=this.mediaStateConfiguration.mediaStates.find(s=>s.mediaType===n);return!a||!!a.isDisabled}return!1}isSending(n){return!!this.mediaStateConfiguration?.mediaStates&&!!this.mediaStateConfiguration.mediaStates.find(a=>a.mediaType===n&&!a.isDisabled)}disableModality(n){this.setModality(n,!0)}enableModality(n){this.setModality(n,!1)}removeModality(n){this.mediaStateConfiguration?.mediaStates&&(0,udi.remove)(this.mediaStateConfiguration.mediaStates,a=>a.mediaType===n)}setCallAcceptOptions(n){const a=this.isDisabled(1),s=this.isDisabled(2),c=this.isSending(3);if(n.sendMediaModalities)this.mediaStateConfiguration=n.sendMediaModalities;else{n.answerMediaType===void 0&&(n.answerMediaType=n.withVideo?1:0);const u={mediaStates:[]};switch(n.answerMediaType){case 0:u.mediaStates.push(qR(0,4));break;case 1:u.mediaStates.push(qR(0,4)),u.mediaStates.push(qR(1,4));break;case 2:u.mediaStates.push(qR(1,0))}this.mediaStateConfiguration=u}a&&this.setModality(1,!0),s&&this.setModality(2,!0),c&&this.setModality(3,!1),n.sendMediaModalities=this.mediaStateConfiguration}setModality(n,a){if(this.mediaStateConfiguration?.mediaStates){const s=this.mediaStateConfiguration.mediaStates.find(c=>c.mediaType===n);s?s.isDisabled=a:this.mediaStateConfiguration.mediaStates.push({mediaType:n,isDisabled:a,label:KG(n)})}}};function kc(n){return n||n===!1||n===""||n===0}function mdi(n){const a={};kc(n.callStartTime)&&(a.callStartTime=n.callStartTime),kc(n.callVoicemailStartOptions)&&(a.callVoicemailStartOptions=n.callVoicemailStartOptions),kc(n.invitationType)&&(a.invitationType=n.invitationType),kc(n.meetingPreferences)&&(a.meetingPreferences=n.meetingPreferences),kc(n.parkContext)&&(a.parkContext=n.parkContext),kc(n.pickupCode)&&(a.pickupCode=n.pickupCode),kc(n.participantsToNudge)&&(a.participantsToNudgeSize=n.participantsToNudge.length);const s=n.callStartOptions;if(s){const c={};kc(s.additionalEndpointProperties)&&(c.additionalEndpointProperties=s.additionalEndpointProperties),kc(s.clientEndpointCapabilities)&&(c.clientEndpointCapabilities=s.clientEndpointCapabilities),kc(s.connectionType)&&(c.connectionType=s.connectionType),kc(s.invitationDataJson)&&(c.invitationDataJson=s.invitationDataJson),kc(s.isCast)&&(c.isCast=s.isCast),kc(s.isHuddleGroupCall)&&(c.isHuddleGroupCall=s.isHuddleGroupCall),kc(s.label)&&(c.label=s.label),kc(s.maxVideoChannels)&&(c.maxVideoChannels=s.maxVideoChannels),kc(s.maxVbssChannels)&&(c.maxVbssChannels=s.maxVbssChannels),kc(s.mediaConfiguration)&&(c.mediaConfiguration=s.mediaConfiguration),kc(s.muteFlags)&&(c.muteFlags=s.muteFlags),kc(s.muted)&&(c.muted=s.muted),kc(s.negotiationTag)&&(c.negotiationTag=s.negotiationTag),kc(s.preheatFlags)&&(c.preheatFlags=s.preheatFlags),kc(s.ringOthers)&&(c.ringOthers=s.ringOthers),kc(s.routingFlags)&&(c.routingFlags=s.routingFlags),kc(s.scenario)&&(c.scenario=s.scenario),kc(s.screenshareDirection)&&(c.screenshareDirection=s.screenshareDirection),kc(s.sendMediaModalities)&&(c.sendMediaModalities=s.sendMediaModalities),kc(s.sharedLineCallInvitationContentJson)&&(c.sharedLineCallInvitationContentJson=s.sharedLineCallInvitationContentJson),kc(s.targetApplicationType)&&(c.targetApplicationType=s.targetApplicationType),kc(s.captchaContentJson)&&(c.captchaContentJson=s.captchaContentJson),kc(s.callQueueContext)&&(c.callQueueContext=s.callQueueContext),kc(s.clientEndpointDebugContent)&&(c.clientEndpointDebugContentSize=s.clientEndpointDebugContent.length),kc(s.alternateId)&&(c.alternateId=kn(s.alternateId)),kc(s.callKey)&&(c.callKeySize=s.callKey.length),kc(s.encryptedKey)&&(c.encryptedKeySize=s.encryptedKey.length),a.callStartOptions=c}return a}function NV(n){switch(n){case 0:return"Audio";case 1:return"Video";case 2:return"ScreenShare"}throw new Error("MediaType required")}function Y8e(n){switch(n){case"Audio":return 0;case"Video":return 1;case"ScreenShare":return 2}throw new Error("MediaType required")}function fdi(n){switch(n){case 0:return"Monitor";case 1:return"Whisper";case 2:return"Barge";case 3:return"Takeover";default:return}}var Gte={NEGOTIATION_COMPLETED:"NegotiationCompleted",INITIAL:{OFFER_GENERATION_STARTED:"InitialOfferGenerationStarted",OFFER_GENERATION_ENDED:"InitialOfferGenerationEnded",ANSWER_PROCESSING_STARTED:"InitialAnswerProcessingStarted",ANSWER_PROCESSING_ENDED:"InitialAnswerProcessingEnded",OFFER_PROCESSING_STARTED:"InitialOfferProcessingStarted",OFFER_PROCESSING_ENDED:"InitialOfferProcessingEnded",ANSWER_GENERATION_STARTED:"InitialAnswerGenerationStarted",ANSWER_GENERATION_ENDED:"InitialAnswerGenerationEnded"},RENEGOTIATION:{OFFER_GENERATION_STARTED:"RenegotiationOfferGenerationStarted",OFFER_GENERATION_ENDED:"RenegotiationOfferGenerationEnded",ANSWER_PROCESSING_STARTED:"RenegotiationAnswerProcessingStarted",ANSWER_PROCESSING_ENDED:"RenegotiationAnswerProcessingEnded",OFFER_PROCESSING_STARTED:"RenegotiationOfferProcessingStarted",OFFER_PROCESSING_ENDED:"RenegotiationOfferProcessingEnded",ANSWER_GENERATION_STARTED:"RenegotiationAnswerGenerationStarted",ANSWER_GENERATION_ENDED:"RenegotiationAnswerGenerationEnded"}},vdi=class{constructor(n,a){this.mediaSession=n,this.signalingSession=a,this.operationNames=Gte.INITIAL,this.configureModalitiesAsync=this.mediaSession.configureModalitiesAsync.bind(this.mediaSession),this.getAllowedModalities=this.mediaSession.getAllowedModalities.bind(this.mediaSession),this.rejectNegotiationAsync=this.mediaSession.rejectNegotiationAsync.bind(this.mediaSession),this.createRemoteRenderer=this.mediaSession.createRemoteRenderer.bind(this.mediaSession),this.getStatsAsync=this.mediaSession.getStatsAsync.bind(this.mediaSession),this.getLastKnownStats=this.mediaSession.getLastKnownStats.bind(this.mediaSession),this.getCallTechnicalInfo=this.mediaSession.getCallTechnicalInfo.bind(this.mediaSession),this.muteHold=this.mediaSession.muteHold.bind(this.mediaSession),this.muteInputAsync=this.mediaSession.muteInputAsync.bind(this.mediaSession),this.unmuteInputAsync=this.mediaSession.unmuteInputAsync.bind(this.mediaSession),this.muteOutputAsync=this.mediaSession.muteOutputAsync.bind(this.mediaSession),this.unmuteOutputAsync=this.mediaSession.unmuteOutputAsync.bind(this.mediaSession),this.getSpeakerVolume=this.mediaSession.getSpeakerVolume.bind(this.mediaSession),this.setSpeakerVolume=this.mediaSession.setSpeakerVolume.bind(this.mediaSession),this.terminate=this.mediaSession.terminate.bind(this.mediaSession),this.createAudioElement=this.mediaSession.createAudioElement.bind(this.mediaSession),this.getSessionConfig=this.mediaSession.getSessionConfig.bind(this.mediaSession),this.getDiagnostics=this.mediaSession.getDiagnostics.bind(this.mediaSession),this.getIncomingRawAudioStream=this.mediaSession.getIncomingRawAudioStream.bind(this.mediaSession),this.getUnmixedAudioProvider=this.mediaSession.getUnmixedAudioProvider.bind(this.mediaSession),this.useNullAudioStreamClient=this.mediaSession.useNullAudioStreamClient.bind(this.mediaSession),this.getSubscriptionManager=this.mediaSession.getSubscriptionManager.bind(this.mediaSession),this.configureSpatialAudio=this.mediaSession.configureSpatialAudio.bind(this.mediaSession),this.setParticipantSpatialAudioPositions=this.mediaSession.setParticipantSpatialAudioPositions.bind(this.mediaSession),this.setCallConstraints=this.mediaSession.setCallConstraints.bind(this.mediaSession),this.startMediaDescriptionsUpdateAsync=this.mediaSession.startMediaDescriptionsUpdateAsync.bind(this.mediaSession),this.completeMediaDescriptionsUpdateAsync=this.mediaSession.completeMediaDescriptionsUpdateAsync.bind(this.mediaSession),this.rejectMediaDescriptionsUpdateAsync=this.mediaSession.rejectMediaDescriptionsUpdateAsync.bind(this.mediaSession),this.registerRemoteQualityStateChangedEvent=this.mediaSession.registerRemoteQualityStateChangedEvent.bind(this.mediaSession),this.getMediaControlPlaneInstance=this.mediaSession.getMediaControlPlaneInstance.bind(this.mediaSession)}enableTeamsRealTimeTelemetry(){this.mediaSession.enableTeamsRealTimeTelemetry()}getMediaStatsReport(){return this.mediaSession.getMediaStatsReport()}processOfferAsync(n,a){return this.signalingSession.setOfferAnswerGenerationTimestamps(this.operationNames.OFFER_PROCESSING_STARTED),this.mediaSession.processOfferAsync(n,a).then(s=>(this.signalingSession.setOfferAnswerGenerationTimestamps(this.operationNames.OFFER_PROCESSING_ENDED),s))}createAnswerAsync(n,a){return this.signalingSession.setOfferAnswerGenerationTimestamps(this.operationNames.ANSWER_GENERATION_STARTED),this.mediaSession.createAnswerAsync(n,a).then(s=>(this.signalingSession.setOfferAnswerGenerationTimestamps(this.operationNames.ANSWER_GENERATION_ENDED),n||(this.operationNames=Gte.RENEGOTIATION),s))}createOfferAsync(n,a){return this.signalingSession.setOfferAnswerGenerationTimestamps(this.operationNames.OFFER_GENERATION_STARTED),this.mediaSession.createOfferAsync(n,a).then(s=>(this.signalingSession.setOfferAnswerGenerationTimestamps(this.operationNames.OFFER_GENERATION_ENDED),s))}processAnswerAsync(n,a,s,c=!1){return this.signalingSession.setOfferAnswerGenerationTimestamps(this.operationNames.ANSWER_PROCESSING_STARTED),this.mediaSession.processAnswerAsync(n,a,s,c).then(()=>{this.signalingSession.setOfferAnswerGenerationTimestamps(this.operationNames.ANSWER_PROCESSING_ENDED),this.operationNames=Gte.RENEGOTIATION})}completeNegotiationAsync(n){return this.mediaSession.completeNegotiationAsync(n).then(a=>(this.signalingSession.setOfferAnswerGenerationTimestamps(Gte.NEGOTIATION_COMPLETED),a))}sendDtmf(n){return this.mediaSession.sendDtmf?this.mediaSession.sendDtmf(n):Promise.reject("Not Implemented")}reconnectAsync(n,a=!1,s){return this.mediaSession.reconnectAsync(n,a,s)}completeEscalationAsync(n){return this.mediaSession.completeEscalationAsync(n)}rejectEscalationAsync(n,a){return this.mediaSession.rejectEscalationAsync(n,a)}getAcceptedTypes(){return this.mediaSession.getAcceptedTypes()}getLocalMediaTrackId(n){return this.mediaSession.getLocalMediaTrackId?this.mediaSession.getLocalMediaTrackId(n):null}getAudioSenderStats(){return this.mediaSession.getAudioSenderStats()}processNotification(n,a){this.mediaSession.processNotification(n,a)}};function Q8e(n,a,s){if(a?.serverMuteVersion===void 0||s?.serverMuteVersion===void 0||s.serverMuteVersion>=a.serverMuteVersion)return;const c=s&&s.mediaStreams,u=c&&c.filter(_=>_.type==="audio"||_.type==="audio-teleconferencing"),m=a&&a.mediaStreams,b=m&&m.filter(_=>_.type==="audio"||_.type==="audio-teleconferencing");u&&u.length&&(s.serverMuteVersion=a.serverMuteVersion,u[0].serverMuted=b[0].serverMuted,n.info(`handleServerMutedVersion: patching server muted state in audio streams updated:${JSON.stringify(u[0])} as we encountered stale muteServerVersion. Updated to ${a.serverMuteVersion}`))}function Z8e(n,a,s,c){if(s.reason!=="success"||a===void 0||s.serverMuteVersion<=a.serverMuteVersion)return n.info(`handleMuteUnmuteParticipantInfo: ignoring updating since we encountered invalid state: ${s.reason} serverMuteVersion: ${s.serverMuteVersion}`),!1;const u=a&&a.mediaStreams,m=u&&u.filter(b=>b.type==="audio"||b.type==="audio-teleconferencing");return!!m&&(m[0].serverMuted=c,a.serverMuteVersion=s.serverMuteVersion,n.info(`handleMuteUnmuteParticipantInfo: updating since we encountered valid state serverMuteVersion: ${s.serverMuteVersion} to: ${c} streams: ${m[0].sourceId}`),!0)}var qte=Hv;function ydi(n,a,s,c){const u=JSON.stringify(n),m=JSON.parse(u);return m&&(uye(n,m,a,qte.pii.Omit),uye(n,m,s,qte.pii.Mri),uye(n,m,c,qte.pii.UserName)),JSON.stringify(m)}function uye(n,a,s,c){s?.forEach(u=>{n[u]&&(a[u]=c(n[u]))})}function hye(n){return`id=${qte.pii.Mri(n.id)}, participantId=${n.participantId}`}function Sdi(n){const a=[],s=["transferorMri","targetMri"];return ydi(xS(n),a,s)}var bdi=dn,X8e=ye.setImmediate?n=>{ye.setImmediate(n)}:n=>{(0,bdi.defer)(n)},e7e=class Sq{constructor(){this.deferredOperations=new Map,this.deferredOperationsNames=[],this.isRunning=!1}setLogger(a){this._logger=a.createChild("[DeferHandler]")}setDeferToQueueMicrotask(a){a&&ye.queueMicrotask?Sq.defer=s=>ye.queueMicrotask(s):Sq.defer=X8e}createDeferRunner(a){const s={};return c=>this.runDeferred(s,c,a)}runDeferredWithoutDedup(a,s){const c={};this.runDeferred(c,a,s)}runDeferred(a,s,c){this.deferredOperations.has(a)||(this.deferredOperations.set(a,s),c&&this.deferredOperationsNames.push(" "+c),this.isRunning||(this.isRunning=!0,this._startDeferalTime=Date.now(),this.causeId=hi(),this._logger?.info(`[${this.causeId}]Deferring operations`),Sq.defer(()=>{this._timeToRun=Date.now()-this._startDeferalTime,this.deferredOperations.forEach(u=>{Sq.runWithTryCatch(u)}),this.deferredOperations.clear(),this.isRunning=!1,this._logger?.info(`[${this.causeId}]Deferred operations ran after ${this._timeToRun}ms | Completed after ${Date.now()-this._startDeferalTime}ms | Operations:${this.deferredOperationsNames}`),this.deferredOperationsNames=[]})))}static runWithTryCatch(a){try{a&&a()}catch{}}};e7e.defer=X8e;var Tdi=e7e,n9=class{};n9.instance=new Tdi;var t7e=dn,WR={send:"sendonly",receive:"recvonly",sendReceive:"sendrecv"},jb={audio:"audio",video:"video",sharing:"applicationsharing-video",audioteleconference:"audio-teleconferencing",xsharing:"xapplicationsharing-video"},pye=class extends Qs{constructor(n,a,s){super(a),this.mediaSession=n,this.isAvailable=!1,this.mediaSessionInitPromise=new Pi,this.currentIsStreaming=!1,n&&this.mediaSessionInitPromise.resolve(),this.id=s,this.logger=a.createChild(`Stream[${this.id}]`)}set isStreaming(n){this.currentIsStreaming=n,this.logger.info(`isStreaming has changed to ${this.currentIsStreaming}`),this.raiseChanged()}get isStreaming(){return this.currentIsStreaming}update({sourceId:n=null,direction:a=WR.receive,participantId:s=null,endpointId:c=null}={},u,m){this.logger.info(`[${u}][update before]  sourceId=${n}, direction=${a}, isAvailable=${this.isAvailable}, participantId=${s}, endpointId=${J_(c,8)}, ${this.negotiationTag?`, negotiationTag=${this.negotiationTag}`:""}`),this.id=n;const b=a===WR.sendReceive||a===WR.send;this.isAvailable!==b&&(this.negotiationTag=m?.get(c)),this.isAvailable=b,this.mediaSession?.getSessionConfig().config.streamAvailabilityConsiderModalities&&this.getIsModalityDisabled()&&(this.logger.info(`Disabling current modality, disabled: ${JSON.stringify(this.mediaSession?.getDisabledModalities?.()||"")}`),this.isAvailable=!1),this.participantId=s,this.endpointId=c,this.logger.info(`[${u}][update after]  sourceId=${n}, direction=${a}, isAvailable=${this.isAvailable}, participantId=${s}, endpointId=${J_(c,8)}, ${this.negotiationTag?`, negotiationTag=${this.negotiationTag}`:""}`),this.raiseChanged()}setMediaSession(n,a){const s=n?.getAllowedModalities?.()||{};this.logger.info(`[${a}][setMediaSession] ${JSON.stringify(s)}`),this.mediaSession=n,n?this.mediaSessionInitPromise.resolve():this.mediaSessionInitPromise.reject(new Error("MediaSession is null"))}isActive(){return this.isAvailable&&this.isStreaming}getIsModalityDisabled(){return!1}},Cdi=class extends pye{},_di=dn,Edi=class extends pye{constructor(n,a,s,c,u,m){super(void 0,n,a),this.configProvider=s,this.streamOptions=c,this.telemetryLogger=u,this.callInfo=m,this.type=2,this.finalTelemetrySent=!1,this.player=new v2(n.createChild("UmsHydraLiveStreamPlayer"),this.configProvider,this.telemetryLogger),this.isAvailable=!0}getStreamOptions(){return this.streamOptions}getDiagnosticData(){return JSON.stringify({id:this.id,type:this.type,rank:this.rank,isAvailable:this.isAvailable,isStreaming:this.isStreaming})}getStats(){const n=this.player.getSnapshotTelemetryReport(),a={isAvailable:this.isAvailable,isStreaming:this.isStreaming,...n};return(0,_di.isEqual)(this.lastStreamStats,a)||(this.streamStatsUpdatedTimestamp=Date.now(),this.lastStreamStats=a),{id:this.id,type:this.type,timestampUpdated:this.streamStatsUpdatedTimestamp,rank:this.rank,...this.lastStreamStats}}stop(){return Promise.resolve(void 0)}async start(n){if(this.logger.info("[start]: Starting UMS stream"),!this.renderer){if(await this.player.configure(this.streamOptions),!(await this.player.loadPlayer(n)).setupSucceeded)return this.player.stop(),this.logger.error("[start]: Failed to load UMS player"),Promise.reject("Failed to load UMS player");this.renderer=this.player.getRenderer()}return this.isStreaming=!0,this.renderer}sendSnapshotTelemetry(){const n=this.player.getSnapshotTelemetryReport();this.logger.debug(`[sendSnapshotTelemetry] sending snapshot telemetry report: ${JSON.stringify(n)}`);const a={...this.callInfo,...n};this.telemetryLogger.sendEvent({eventName:"live_events",props:a})}sendTelemetry(n){if(this.finalTelemetrySent)return;n&&(this.finalTelemetrySent=!0);const a=this.player.getTelemetryReport();this.logger.debug(`[sendTelemetry] sending telemetry report: ${JSON.stringify(a)}`);const s={...this.callInfo,...a};this.telemetryLogger.sendEvent({eventName:"live_events",props:s})}};function Adi(n){switch(n){case 1:return"crop";case 0:return"stretch";default:return"fit"}}var i7e=class extends Qs{constructor(){super(...arguments),this.isRendering=!1,this.frameType=-1}get rendererType(){return 0}captureFrame(){if(this.renderer.captureFrame)return this.renderer.captureFrame();throw new Error("Not implemented yet")}async getStats(){if(this.renderer.getStats)return this.renderer.getStats();throw new Error("Renderer does not support stats")}async setScalingMode(n){this.renderer.setScalingMode(Adi(n))}async cameraAutoControl(n){throw new Error("Not implemented")}async getCameraManualControlStates(n){throw new Error("Not implemented")}async setCameraManualControlStates(n){throw new Error("Not implemented")}async enumerateCameraManualControls(){throw new Error("Not implemented")}async isCameraAdvancedControlCapable(){throw new Error("Not implemented")}onVideoSizeChanged(n,a){this.streamSize={width:n,height:a},this.event("videoSizeChanged").raise(n,a),this.raiseChanged()}},Idi=class extends i7e{constructor(){super(),this.disposed=!1}initialize(n,a,s){this.disposed||this.renderer||(this.renderer=a.createPreviewRenderer(n,s),this.renderer.on("onVideoSizeChanged",(c,u)=>this.onVideoSizeChanged(c,u)))}onVideoSizeChanged(n,a){this.isRendering=n>0&&a>0,super.onVideoSizeChanged(n,a)}setVideoMirroring(n){this.renderer.setVideoMirroring(n)}startVideoAsync(){return this.renderer.startVideoAsync()}dispose(){this.disposed=!0,this.renderer&&(this.renderer.dispose(),this.renderer=null)}},wdi=class extends i7e{constructor(n,a,s,c,u){super(),this.logger=n,this.target=a,this.rendererStats=c,this.configProvider=u,this.subscriptionActive=!1,this.firstFrameRendered=!1,this.rendererId=c.newRendererId(),this.renderer=s.createRemoteRenderer(a),this.renderer.on("onVideoSizeChanged",(m,b)=>this.onVideoSizeChanged(m,b)),this.renderer.on("onVideoStateChanged",m=>this.onVideoStateChanged(m)),this.renderer.on("onIsRenderingChanged",m=>this.onIsRenderingChanged(m))}toString(){return`rvr:${this.rendererId}`}onVideoStateChanged(n){this.rendererStats.streamStateChanged(n.stream)}onVideoSizeChanged(n,a){this.configProvider.config.videoIsRenderingCheck&&this.setIsRendering(n>0&&a>0),super.onVideoSizeChanged(n,a)}setIsRendering(n){this.isRendering!==n&&(this.isRendering=n,this.logger.info(`isRendering has changed to ${this.isRendering}`),this.rendererStats.event(this.isRendering?5:6,this.rendererId),this.isRendering&&!this.firstFrameRendered&&(this.firstFrameRendered=!0,this.event("firstFrameRendered").raise()))}onIsRenderingChanged(n){this.setIsRendering(n),this.raiseChanged()}subscribeVideoAsync(n){this.currentVideoStream=n,this.rendererStats.event(1,this.rendererId,n.id);const a=this.renderer.subscribeVideoAsync(n.id,n.type===1);return this.subscriptionActive=!0,a.then(()=>{this.rendererStats.event(2,this.rendererId,n.id),this.watchStream(n)}),a}watchStream(n){this.changeSub&&this.changeSub.dispose(),this.changeSub=n.changed(()=>{n.isAvailable?this.subscriptionActive||this.subscribeVideoAsync(n):(this.subscriptionActive=!1,this.rendererStats.event(3,this.rendererId),this.renderer.unsubscribeNow(),this.rendererStats.event(4,this.rendererId))})}dispose(){this.renderer&&(this.subscriptionActive&&(this.rendererStats.event(3,this.rendererId),this.currentVideoStream&&!this.currentVideoStream.isAvailable&&this.renderer.unsubscribeNow()),this.renderer.dispose(),this.subscriptionActive&&this.rendererStats.event(4,this.rendererId),this.renderer=null,this.currentVideoStream=null),this.changeSub&&(this.changeSub.dispose(),this.changeSub=null)}},gye=class extends Qs{constructor(n,a,s){super(s),this.getRawStream=n,this.disposeStream=a,this.logger=s,this.isClientDisposed=!1,this.clientId=sw()}get isDisposed(){return this.isClientDisposed}notifyStreamChange(){this.logger.info(`clientId:${this.clientId} - Stream changed`),this.raiseChanged(),this.event("notifiedOnStreamChanged").raise(this.clientId)}async getMediaStream(){return this.checkDisposed(),this.logger.info(`clientId:${this.clientId} - Stream requested`),this.event("rawStreamRequested").raise(this.clientId),this.getRawStream()}dispose(){this.checkDisposed(),this.disposeStream?.(),this.isClientDisposed=!0,this.event("clientDisposed").raise(this.clientId),super.dispose(),this.logger.info(`clientId:${this.clientId} - Raw stream client disposed`)}checkDisposed(){if(this.isClientDisposed)throw new Error("Raw stream client is already disposed")}},kdi=class{constructor(n,a){this.stream=n,this.rawBaseClient=new gye(async()=>this.stream,()=>this.dispose(),a)}client(){return this.rawBaseClient}updateAndNotifyClient(n){this.rawBaseClient&&(this.stream=n,this.rawBaseClient.notifyStreamChange())}dispose(){this.rawBaseClient=null,this.stream=null}},Rdi=class{constructor(n,a,s){this.videoStream=n,this.subscriptionManager=a,this.logger=s,this.subscriptionActive=!1,this.modality=n.type===0?ke.MODALITY.video:ke.MODALITY.sharing,this.createSubscription(),this.rawBaseClient=new gye(async()=>this.subscriptionClient?.subscribedStream,()=>this.unsubscribeVideo(),s),this.videoStream.changed(()=>{this.rawBaseClient?.isDisposed||(this.logger.info(`isAvailable: ${n.isAvailable}, subscriptionActive: ${this.subscriptionActive}`),n.isAvailable?this.subscriptionActive||this.createSubscription():(this.subscriptionActive=!1,this.unsubscribeVideo()))})}client(){return this.rawBaseClient}createSubscription(){this.rawBaseClient?.isDisposed?this.logger.error("createSubscription skipped, raw stream client disposed: stream already exists"):(this.logger.info("createSubscription: Creating new subscription"),this.subscriptionClient=this.subscriptionManager.subscribeVideo(this.modality,this.videoStream.mediaSourceId),this.setClientSubscription(),this.subscriptionActive=!0)}unsubscribeVideo(){this.logger.info("unsubscribeVideo: Disposing subcription"),this.subscriptionClient?.unsubscribe(),this.subscriptionClient?.dispose(),this.subscriptionClient=null}setClientSubscription(){this.logger.info("setClientSubscription: setting onMediaStreamChanged callback"),this.subscriptionClient.setOnMediaStreamChangedHandler(()=>this.rawBaseClient?.notifyStreamChange())}},n7e=class{constructor(n){this.logger=n,this.handlerMap=new Map}dispose(){this.logger.info("dispose"),this.handlerMap.forEach(n=>n.client().dispose()),this.handlerMap.clear()}handlerAdded(n){const a=n.client();a.on("clientDisposed",()=>this.deleteRawStreamManagerById(a.clientId)),this.handlerMap.set(a.clientId,n)}deleteRawStreamManagerById(n){this.handlerMap.delete(n)}},Mdi=class extends n7e{constructor(n){super(n)}streamChanged(n){this.handlerMap.forEach(a=>a.updateAndNotifyClient(n))}createIRawStreamClient(n,a){const s=new kdi(n,this.logger);super.handlerAdded(s);const c=s.client();return this.logger.info(`[${a}] - clientId:${c.clientId}, client created`),c}updateHandlers(n){n.forEach((a,s)=>{this.handlerMap.has(s)||this.handlerMap.set(s,a)})}},Pdi=class extends n7e{constructor(n){super(n)}createIRawStreamClient(n,a,s){const c=new Rdi(n,a,this.logger);super.handlerAdded(c);const u=c.client();return this.logger.info(`[${s}] - clientId:${u.clientId}, client created`),u}},Ddi=dn,Wte=class extends pye{constructor(n,a,s,c){super(n,s,c),this.rendererStats=a,this.rawIncomingVideoStreamManager=new Pdi(this.logger.createChild(`rawVideoStream, [sourceId:${this.id}]`)),this.type=0}get mediaSourceId(){return this.id}getDiagnosticData(){return JSON.stringify({id:this.id,msi:this.mediaSourceId,rank:this.rank,type:this.type,isAvailable:this.isAvailable,isStreaming:this.isStreaming})}getStats(){const n={isAvailable:this.isAvailable,isStreaming:this.isStreaming};return(0,Ddi.isEqual)(this.lastStreamStats,n)||(this.streamStatsUpdatedTimestamp=Date.now(),this.lastStreamStats=n),{id:this.id,type:this.type,timestampUpdated:this.streamStatsUpdatedTimestamp,msi:this.mediaSourceId,rank:this.rank,...this.lastStreamStats}}stop(){return this.mediaSessionInitPromise.reject(new Error("Video stream stopped")),Promise.resolve(void 0)}getRawStream(n=hi()){return this.logger.info(`[${n}] - getRawStream called for incoming video stream`),this.rawIncomingVideoStreamManager.createIRawStreamClient(this,this.mediaSession.getSubscriptionManager(),n)}start(n,a){return this.logger.info(`video start: target=${n}, options=${JSON.stringify(a)}`),this.mediaSessionInitPromise.promise.then(()=>new wdi(this.logger.createChild("RemoteVideoRenderer"),n,this.mediaSession,this.rendererStats,this.mediaSession?.getSessionConfig())).then(s=>(a&&s.setScalingMode(a.scalingMode),this.logger.info(`subscribeVideoAsync: videoRenderer=${s}, id=${this.id}`),s.subscribeVideoAsync(this).catch(c=>{throw s.dispose(),c}).then(()=>(this.isStreaming=!0,s))))}update(n,a,s){this.logger.info(`[${a}][update] stream=${JSON.stringify(n)}`);const c=this.isAvailable;super.update(n,a,s),this.isAvailable&&this.isAvailable!==c&&this.rendererStats.event(0)}getIsModalityDisabled(){return!!this.mediaSession?.getDisabledModalities?.().video}},mye=class extends Wte{constructor(n,a,s,c){super(n,a,s,c),this.type=1}getIsModalityDisabled(){return!!this.mediaSession?.getDisabledModalities?.().sharing}},a7e=1,r7e=2,o7e=3,fye=class L$ extends Qs{constructor(a,s,c,u){super(),this.participantId=a,this.mediaSession=s,this.localStats=c,this.audioSourceIds=[],this.streams={},this.lastUmsStreamId=1;const m=c.receive(1,a),b=c.receive(2,a);this.audio=new Cdi(s,u,a7e);const _=new Wte(s,m,u,r7e),k=new mye(s,b,u,o7e);this.mediaSession?.getSessionConfig()?.config.participantStreamInitialSubscriptions&&(_.changed(()=>this.event("streamChanged").raise()),k.changed(()=>this.event("streamChanged").raise())),this.streams[0]=[_],this.streams[1]=[k],this.streams[2]=[],this.logger=u.createChild("PluginlessCallStreamManager")}setMediaSession(a,s){this.logger.info(`[${s}][setMediaSession]`),this.mediaSession=a,[[this.audio],this.streams[0],this.streams[1]].forEach(c=>c.forEach(u=>u.setMediaSession(a,s)))}updateStreams(a,s,c,u){this.logger.info(`[${s}][updateStreams]`);const m=k=>a.filter(N=>k.includes(N.type)).sort(L$.compareStreams);let b=m([jb.audio]);b.length===0&&(b=m([jb.audioteleconference])),b.length>0&&(this.audioSourceIds=b.map(k=>k.sourceId));const _=b[0];_&&this.audio.update(_,s),this.updateMediaStreams(m([jb.video]),0,s,c),u?this.updateMediaStreams(m([jb.sharing,jb.xsharing]),1,s,c):this.updateMediaStreams(m([jb.sharing]),1,s,c)}hasAudioSource(a){return this.audioSourceIds.some(s=>s===a)||this.audio.id===a}useUmsStream(a,s,c,u,m,b){this.logger.info(`[${b}][useUmsStream] Updating ums streams`);const _=this.getUmsInformation(a,u),k=this.streams[2],N=k.filter(W=>!_.some(ee=>L$.compareUmsStreams(W,ee)));N.forEach(W=>(0,t7e.remove)(k,W)),N.length&&this.logger.info(`[${b}][useUmsStream] Removing ${N.length} ums streams`),_.forEach(W=>{let ee=k.find(oe=>L$.compareUmsStreams(oe,W));ee||(ee=new Edi(this.logger.createChild("UmsStream"),this.lastUmsStreamId++,s,W,m,c),this.logger.info(`[${b}][useUmsStream] Adding ums stream with metadata: ${JSON.stringify(W)}`),k.push(ee))})}getUmsStreamMetadata(a,s){let c=null,u=null;if(c=a.find(function(m){return m.deliveryPipelineType==="MiddleLaneUltraLowLatency"&&s===m.isPrimary}),c){const m=c.urls;if(m&&m.length>0){c.identifier||this.logger.warn(`[getUmsStreamMetadata]: no ums stream identifier found, isPrimary: ${s}`);const b=c.decryptionKey?.id,_=c.decryptionKey?.value;b&&_||this.logger.warn(`[getUmsStreamMetadata]: no valid ums stream decryption key found, isPrimary: ${s}`);const k=c.deliveryPipelineType||void 0;u={url:m[0],streamDeliveryPipeline:k,decryptionKey:b&&_?{id:b,value:_}:null}}else this.logger.info(`[getUmsStreamMetadata]: no ums URLs found, isPrimary: ${s}`)}else this.logger.info(`[getUmsStreamMetadata]: no ums stream information found, isPrimary: ${s}`);return u}getUmsInformation(a,s){const c=[];let u=null,m=null;for(const b in a){const _=a[b].streams;if(_){if(u)this.logger.info(`[getUmsInformation]: primary ums stream already found, skipping finding primary stream for participant: ${b}`);else{const k=this.getUmsStreamMetadata(_,!0);k?u=k:this.logger.info(`[getUmsInformation]: no primary ums stream found for participant: ${b}`)}if(m)this.logger.info(`[getUmsInformation]: alternate ums stream already found, skipping finding alternate stream for participant: ${b}`);else{const k=this.getUmsStreamMetadata(_,!1);k?m=k:this.logger.info(`[getUmsInformation]: no alternate ums stream found for participant: ${b}`)}}else this.logger.warn(`[getUmsInformation]: no stream information found for participant: ${b}`)}return(u||m)&&c.push({stream:u,altStream:m,threadId:s}),c}static compareStreams(a,s){const c=a.direction==="sendonly"||a.direction==="sendrecv",u=s.direction==="sendonly"||s.direction==="sendrecv";return c&&!u?-1:u&&!c?1:s.sourceId-a.sourceId}static compareUmsStreams(a,s){const c=a.getStreamOptions();return L$.compareUmsStreamMetadata(c.stream,s.stream)&&L$.compareUmsStreamMetadata(c.altStream,s.altStream)}static compareUmsStreamMetadata(a,s){return!a&&!s||!(!a&&s||a&&!s)&&a.decryptionKey.id===s.decryptionKey.id&&a.decryptionKey.value===s.decryptionKey.value&&a.url===s.url}updateMediaStreams(a,s,c,u){const m=this.streams[s],b=m.filter(_=>!a.some(k=>k.sourceId===_.id));b.forEach(_=>(0,t7e.remove)(m,_)),b.length&&this.logger.info(`[${c}][updateMediaStreams] Removing ${b.length} streams of type ${s}`),a.forEach((_,k)=>{let N=m.find(W=>W.id===_.sourceId);N||(s===0?N=new Wte(this.mediaSession,this.localStats.receive(1,this.participantId),this.logger,_.sourceId):s===1&&(N=new mye(this.mediaSession,this.localStats.receive(2,this.participantId),this.logger,_.sourceId)),this.logger.info(`[${c}][updateMediaStreams] Adding stream ${_.sourceId} of type ${s}`),m.push(N),N.changed(()=>this.event("streamChanged").raise())),N.update(_,c,u),N.rank=a.length-k})}},Ldi={0:[1],1:[2,6,3,4,5,7,8],2:[6,3,4,8],3:[1,4,5,8],7:[3,4,8],4:[],5:[3,4,8],6:[3,4],8:[3,5,4]},Odi={0:"Disconnected",1:"Connecting",2:"Ringing",3:"Connected",5:"Connected",4:"Disconnected",7:"Connecting"},s7e=class extends Qs{constructor(n,a,s,c,u,m=hi(),b=[]){super(s),this.mri=n,this.callTelemetry=u,this.cachedMediaStreams=b,this.state=0,this.voiceLevel=0,this.isServerMuted=!1,this.endpointType="default",this.balanceUpdates={},this._raiseChangeDeferRunner=n9.instance.createDeferRunner("CallParticipant.RaiseChange"),this.filteredParticipantEndpointDetails={},this.recordTelemetryForStateChange=(_,k,N,W)=>{if(W){const ee="_SetParticipantStateInvalid",oe={state:k,reason:N,endpoints:[]};this.endpoints?.endpointDetails?.length&&(oe.endpoints=I2(this.endpoints.endpointDetails)),this.callTelemetry.recordEvent(ee,oe,_)}},this.checkIfIncomingServerMutedIsUpdated=_=>{_.endpointDetails.forEach(k=>{const N=this.filteredParticipantEndpointDetails[k.participantId];N!==void 0&&Q8e(this.logger,N,k)})},this.handleServerMutedInfoUpdate=_=>{let k=!1;for(const N of _){const W=this.filteredParticipantEndpointDetails[N.participantId];Z8e(this.logger,W,N,!0)&&(k=!0)}k&&this.updateIsServerMuted()},this.id=this.mri,this.logger=s.createChild(()=>`ICallParticipant[${kn(this.id)}][${this.state}]`),this.logger.info(`[${m}]created`),this.streamManager=new fye(this.id,a,c,this.logger),this.streamManager.on("streamChanged",()=>this.raiseChanged())}get audio(){return this.streamManager.audio}get streams(){return this.streamManager.streams}getDiagnosticData(){return JSON.stringify({id:kn(this.id),state:this.state,isServerMuted:this.isServerMuted})}async getDiagnosticDataAsync(){return this.getDiagnosticData()}isSameParticipantsMri(n){return this.id===n}setMediaSession(n,a=hi()){this.streamManager.setMediaSession(n,a)}applyCachedMediaStreams(n=hi()){const a=this.logger.createFnLogger("applyCachedMediaStreams",n);this.cachedMediaStreams?.length?(a.info("applying cachedMediaStreams"),this.updateStreams(this.cachedMediaStreams,n,!1)):a.info("cachedMediaStreams is empty")}updateStreams(n,a=hi(),s=!1,c,u=!1){this.logger.createFnLogger("updateStreams",a).info(`isStreamingMode=${s} mediaStreams=${xo(n)}`),n?.length&&(this.cachedMediaStreams=n),s||(this.streamManager.updateStreams(n,a,c,u),this.raiseChangedDeferred())}hasAudioSource(n){return this.streamManager.hasAudioSource(n)}raiseChangedDeferred(){this._raiseChangeDeferRunner(()=>this.raiseChanged())}updateIsServerMuted(){if(!Object.values(this.filteredParticipantEndpointDetails).length)return void this._updateIsServerMuted(!1);let n=!1;Object.values(this.filteredParticipantEndpointDetails).forEach(s=>{const c=_=>s.mediaStreams?.filter(k=>k.type===_).sort(fye.compareStreams);let u=c(jb.audio)?.[0];u||(u=c(jb.audioteleconference)?.[0]);const m=!!u?.serverMuted,b=s.endpointState?.state;m!==!1||b?.isMuted||(n=!0)});const a=!n;this._updateIsServerMuted(a)}_updateIsServerMuted(n){n!==this.isServerMuted&&(this.isServerMuted=n,this.logger.info(`_updateIsServerMuted updating to: ${this.isServerMuted}`),this.raiseChanged())}updateVoiceLevel(n){this.voiceLevel!==n&&(this.voiceLevel=n,this.raiseChanged())}setState(n,a,s){if(this.state===n)return;const c=this.logger.createFnLogger("setState",s);if(this.state===3&&n===6)return void c.info("Ignore Connected->EarlyMedia transition, it is a race between media and signaling");const u=Ldi[this.state].indexOf(n)>=0;this.recordTelemetryForStateChange(s,n,a,!u),u?(c.info(`state=${this.state}->${n} reason=${this.stateReason}->${a}`),this.state=n,this.stateReason=a,this.raiseChangedDeferred()):c.logFailure(`Invalid state transition ${this.state}->${n} attempted`)}processParticipantDetails(n,a,s){const c=this.logger.createFnLogger("processParticipantDetails","");this.role=n.role,this.meetingRole=n.meetingRole,this.advancedMeetingRole=n.advancedMeetingRole,this.meetingRoles=n.meetingRoles,this.participantType=n.participantType,this.displayName=n.displayName,this.tenantId=n.tenantId,this.propertyBag=n.propertyBag,this.version=n.version,this.otpIdentity=n.otpIdentity,this.isIdentityMasked=!!n.isIdentityMasked,this.nonMaskedId=n.nonMaskedId,this.nonMaskedDisplayName=n.nonMaskedDisplayName,this.nonMaskedObjectId=n.nonMaskedObjectId,this.maskedIdSeqNumber=n.maskedIdSeqNumber,this.maskedId=n.maskedId,this.joinAsStreamingUser=n.joinAsStreamingUser,n.endpointDetails?.length&&(this.endpoints={endpointDetails:[]},this.participantCapabilities={canConference:!1,canShareScreen:!1,canMerge:!0},this.checkIfIncomingServerMutedIsUpdated(n),this.filteredParticipantEndpointDetails={},n.endpointDetails.forEach(u=>{const m=q8e(u,a);if(this.endpoints.endpointDetails.push(m),!m.mappedTo){if(this.filteredParticipantEndpointDetails[u.participantId]={endpointId:u.endpointId,serverMuteVersion:u.serverMuteVersion,endpointState:u.endpointState,mediaStreams:u.mediaStreams},u.capabilities&&(this.participantCapabilities.canConference||u.capabilities.cloudAudioVideoConference!=="enabled"||(this.participantCapabilities.canConference=!0),this.participantCapabilities.canShareScreen||u.capabilities.cloudScreenSharing!=="enabled"||(this.participantCapabilities.canShareScreen=!0),this.participantCapabilities.canMerge||u.capabilities.cloudMerge!=="enabled"||(this.participantCapabilities.canMerge=!0)),this.contentSharingRole=0,u.contentSharing&&u.contentSharing.sessionInformation){const b=u.contentSharing.sessionInformation;b.role==="attendee"?this.contentSharingRole=1:b.role==="presenter"&&(this.contentSharingRole=2)}m.streamInformation&&s&&s()}}),this.updateIsServerMuted(),c.info(`endpointDetails=${d2(this.endpoints)}`),this.raiseChangedDeferred())}toCafeParticipant(){return{audioState:Odi[this.state],mri:this.mri}}getSourceIdForMediaType(n){const a=YG(this,n);return a===-1&&this.logger.warn("getSourceIdForMediaType failed"),a}useUmsStream(n,a,s,c,u,m){this.streamManager.useUmsStream(n,a,s,c,u,m),this.raiseChangedDeferred()}hasSourceId(n,a){return N2(this,n,a)!==void 0}},BD=class extends Qs{constructor(n,a,s,c,u,m="",b,_){super(),this.callTelemetry=n,this.signalingSession=s,this.contentSharingGuid=c,this.contentSharingIdentity=u,this.state=m,this.subject=b,this.handleOperationFailure=(k,N,W)=>{W.logFailure(k);const ee=this.getTerminatedReasonFromError(k);return N.updateStatusTo&&(this.contentSharingStatus=N.updateStatusTo,this.rejectContentSharing(ee)),Promise.reject(ee)},this._logger=a.createChild(()=>`[ContentSharingSession][${this.contentSharingGuid}]`),this.contentSharingStatus=0,this.contentSharingTerminationReason=null,this.contentSharingState=m,this._callOperationHandler=new bV(this._logger,this.callTelemetry),_&&(this.sessionId=_)}get contentSharingStatus(){return this.status}set contentSharingStatus(n){if(this._logger.info(`[set contentSharingStatus][currentStatus=${this.status}][newStatus=${n}]`),this.callTelemetry.recordEvent("_SetContentSharingStatus",{newStatus:n,oldStatus:this.status}),this.status!==n&&this.status!==7&&this.status!==8){if(this._logger.info(`[set contentSharingStatus] Changing content sharing status to: ${n}`),this.status=n,this.status===7){const a={terminatedReason:12,terminatedReasonCode:0,terminatedReasonSubCode:0,errorMessage:"[set contentSharingStatus] Content sharing is disconnected"};this._callOperationHandler.maybeResolveOperation("StopContentSharing"),this._callOperationHandler.rejectPendingOperations(a)}if(this.status===2||this.status===5){const a={terminatedReason:60,terminatedReasonCode:0,terminatedReasonSubCode:0,errorMessage:"Content sharing cannot be ended when not presenting"};this._callOperationHandler.maybeRejectOperation("StopContentSharing",a)}this.status===3&&(this._callOperationHandler.maybeResolveOperation("StartContentSharing"),this._callOperationHandler.maybeResolveOperation("TakeContentSharingControl")),this.raiseChanged()}}get contentSharingState(){return this.state}set contentSharingState(n){this.state!==n&&(this.state=n,this.raiseChanged())}startContentSharing(n=hi()){const a=this._logger.createFnLogger("StartContentSharing",n);if(this.contentSharingStatus!==0){const s=`[${n}][startContentSharing][failed][reason=InvalidState]`,c={terminatedReason:60,terminatedReasonCode:0,terminatedReasonSubCode:0,errorMessage:s};return a.logFailure(`state=${this.contentSharingStatus}, reason=${s}`),Promise.reject(c)}return this.signalingSession.startContentSharingAsync(this.contentSharingIdentity,this.contentSharingState,this.subject,this.contentSharingGuid,n).then(s=>{this.sessionId=s.sessionId,this.contentSharingStatus=3,this.presenterId=this.signalingSession.participantManager.localParticipant.id}).catch(s=>this.handleOperationFailure(s,{causeId:n,operation:"StartContentSharing",updateStatusTo:8},a)),this._callOperationHandler.waitForOperation("StartContentSharing")}joinContentSharing(n=hi()){const a=this._logger.createFnLogger("JoinContentSharing",n);if(this.contentSharingStatus!==2){const s=`[${n}][joinContentSharing][failed][reason=InvalidState]`,c={terminatedReason:60,terminatedReasonCode:0,terminatedReasonSubCode:0,errorMessage:s};return a.logFailure(`state=${this.contentSharingStatus}, reason=${s}`),Promise.reject(c)}return this.signalingSession.joinContentSharingAsync(this.contentSharingGuid,n).then(s=>(this.contentSharingStatus=4,this.contentSharingState=s.sessionState,this.presenterId=s.presenter,Promise.resolve())).catch(s=>this.handleOperationFailure(s,{causeId:n,operation:"JoinContentSharing",updateStatusTo:8},a))}updateContentSharingSessionState(n,a,s=hi()){const c=this._logger.createFnLogger("UpdateContentSharingSessionState",s);if(this.contentSharingStatus!==3){const u=`[${s}][updateContentSharingSessionState][failed][reason=InvalidState]`,m={terminatedReason:60,terminatedReasonCode:0,terminatedReasonSubCode:0,errorMessage:u};return c.logFailure(`state=${this.contentSharingStatus}, reason=${u}`),Promise.reject(m)}return this.signalingSession.updateContentSharingSessionStateAsync(this.contentSharingGuid,a,s).then(()=>Promise.resolve()).catch(u=>this.handleOperationFailure(u,{causeId:s,operation:"UpdateContentSharingSessionState",operationId:n},c))}takeContentSharingControl(n=hi()){const a=this._logger.createFnLogger("TakeContentSharingControl",n);if(this.contentSharingStatus!==5){const s=`[${n}][updateContentSharingSessionState][failed][reason=InvalidState]`,c={terminatedReason:60,terminatedReasonCode:0,terminatedReasonSubCode:0,errorMessage:s};return a.logFailure(`state=${this.contentSharingStatus}, reason=${s}`),Promise.reject(c)}return this.signalingSession.takeContentSharingControlAsync(this.contentSharingGuid,n).then(()=>{this.contentSharingStatus=3,this.presenterId=this.signalingSession.participantManager.localParticipant.id}).catch(s=>this.handleOperationFailure(s,{causeId:n,operation:"TakeContentSharingControl"},a)),this._callOperationHandler.waitForOperation("TakeContentSharingControl")}updateContentSharingParticipantStateToViewer(n=hi()){const a=this._logger.createFnLogger("UpdateParticipantState",n);if(this.contentSharingStatus!==4){const s=`[${n}][updateContentSharingSessionState][failed][reason=InvalidState]`,c={terminatedReason:60,terminatedReasonCode:0,terminatedReasonSubCode:0,errorMessage:s};return a.logFailure(`state=${this.contentSharingStatus}, reason=${s}`),Promise.reject(c)}return this.signalingSession.updateContentSharingParticipantStateAsync(this.contentSharingGuid,n).then(()=>(this.contentSharingStatus=this.presenterId===this.signalingSession.participantManager.localParticipant.id?3:5,Promise.resolve())).catch(s=>this.handleOperationFailure(s,{causeId:n,operation:"UpdateParticipantState"},a))}stopContentSharing(n=hi()){const a=this._logger.createFnLogger("StopContentSharing",n);if(this.contentSharingStatus===2||this.contentSharingStatus===4||this.contentSharingStatus===5){const s=`[${n}][stopContentSharing][failed][reason=InvalidState]`,c={terminatedReason:60,terminatedReasonCode:0,terminatedReasonSubCode:0,errorMessage:s};return a.logFailure(`state=${this.contentSharingStatus}, reason=${s}`),Promise.reject(c)}return this.signalingSession.deleteContentSharingAsync(this.contentSharingGuid,n).then(()=>(this.contentSharingStatus=7,this._callOperationHandler.waitForOperation("StopContentSharing"))).catch(s=>this.handleOperationFailure(s,{causeId:n,operation:"StopContentSharing"},a))}dispose(n=hi()){const a={terminatedReason:12,terminatedReasonCode:0,terminatedReasonSubCode:0,errorMessage:"Call ended"};this._callOperationHandler.rejectPendingOperations(a,n),this.contentSharingStatus=7,this.contentSharingState="",super.dispose()}rejectContentSharing(n={terminatedReason:12,terminatedReasonCode:0,terminatedReasonSubCode:0,errorMessage:"[rejectContentSharing] Content sharing is disconnected"}){if(this.status!==7&&this.status!==8)throw new Error(`Tried to reject content sharing with status=${this.status}`);this._callOperationHandler.maybeResolveOperation("StopContentSharing"),this._callOperationHandler.rejectPendingOperations(n)}getTerminatedReasonFromError(n){const a=n?.endCode?.code||0,s={terminatedReason:32,terminatedReasonCode:a,terminatedReasonSubCode:n?.endCode?.subCode||0,errorMessage:n};switch(a){case er.NotFound:s.terminatedReason=34,s.errorMessage="Active session not found on server";break;case er.Forbidden:s.terminatedReason=8,s.errorMessage="Failed due to insufficient permissions"}return s}};Kt([va("StartContentSharing"),ki(0,Xa)],BD.prototype,"startContentSharing"),Kt([va("JoinContentSharing"),ki(0,Xa)],BD.prototype,"joinContentSharing"),Kt([va("UpdateContentSharingSessionState"),ki(0,uu),ki(2,Xa)],BD.prototype,"updateContentSharingSessionState"),Kt([va("TakeContentSharingControl"),ki(0,Xa)],BD.prototype,"takeContentSharingControl"),Kt([va("UpdateParticipantState"),ki(0,Xa)],BD.prototype,"updateContentSharingParticipantStateToViewer"),Kt([va("StopContentSharing",{waitFor:"StartContentSharing"}),ki(0,Xa)],BD.prototype,"stopContentSharing");var FD,Ndi=class{constructor(n){this.value=n,this.next=void 0}},l7e=class{constructor(){this.length=0}enqueue(n){const a=new Ndi(n);this.front?(this.rear.next=a,this.rear=a):(this.front=a,this.rear=a),this.length++}dequeue(){if(!this.front)return;const n=this.front;return this.front===this.rear?(this.front=void 0,this.rear=void 0):this.front=this.front.next,this.length--,n.value}peek(){return this.front?.value}size(){return this.length}back(){return this.rear?.value}},vye=dn,c7e=class{constructor(n){this.comparator=n,this.heap=[]}enqueue(n){this.heap.push(n),this.bubbleUp()}dequeue(){const n=this.peek();if(n!==void 0){const a=this.heap.pop();this.size()>0&&(this.heap[0]=a,this.bubbleDown())}return n}peek(){return this.heap[0]}size(){return this.heap.length}bubbleUp(){let n=this.size()-1,a=this.getParentIndex(n);for(;!this.isRoot(n)&&this.comparator(this.heap[n],this.heap[a]);)[this.heap[a],this.heap[n]]=[this.heap[n],this.heap[a]],n=a,a=this.getParentIndex(n)}bubbleDown(){if(this.size()<=1)return;let n=this.getRootIndex(),a=this.getLeftIndex(n),s=this.getRightIndex(n);for(;this.heap[a]&&this.comparator(this.heap[a],this.heap[n])||this.heap[s]&&this.comparator(this.heap[s],this.heap[n]);)!this.heap[s]||this.comparator(this.heap[a],this.heap[s])?([this.heap[n],this.heap[a]]=[this.heap[a],this.heap[n]],n=a):([this.heap[n],this.heap[s]]=[this.heap[s],this.heap[n]],n=s),a=this.getLeftIndex(n),s=this.getRightIndex(n)}getRootIndex(){return 0}isRoot(n){return n===0}getLeftIndex(n){return 2*n+1}getRightIndex(n){return 2*n+2}getParentIndex(n){return Math.floor((n-1)/2)}},xdi=class{constructor(n,a,s){this.maxPacketRate=a,this.rateLimiterCheckInterval=s,this.maxDataRate=0,this.packetsEndTimeForPacketRate=0,this.packetsEndTimeForBitrate=0,this.maxDataRate=n/8}canSend(n){if(this.maxDataRate===0&&this.maxPacketRate===0)return!0;const a=pp();if(this.maxPacketRate&&this.packetsEndTimeForPacketRate>a+this.rateLimiterCheckInterval||this.maxDataRate&&this.packetsEndTimeForBitrate>a+this.rateLimiterCheckInterval)return!1;const s=this.maxPacketRate?1e3/this.maxPacketRate:0,c=this.maxDataRate?n.length/this.maxDataRate*1e3:0;return this.packetsEndTimeForPacketRate=Math.max(this.packetsEndTimeForPacketRate,a)+s,this.packetsEndTimeForBitrate=Math.max(this.packetsEndTimeForBitrate,a)+c,!0}},Bdi=class{constructor(n){this.dataIds=new Map,this.maxBitrate=n.config.webrtcDataChannel.maxBitrate,this.maxPacketRate=n.config.webrtcDataChannel.maxPacketRate,this.maxQueueSize=n.config.webrtcDataChannel.maxQueueSize,n.config.webrtcDataChannel.dataIds.forEach(a=>{this.dataIds.set(a.dataId,a)})}getMaxBitrate(n){return this.dataIds.get(n)?.maxBitrate??this.maxBitrate}getMaxPacketRate(n){return this.dataIds.get(n)?.maxPacketRate??this.maxPacketRate}getMaxQueueSize(n){return this.dataIds.get(n)?.maxQueueSize??this.maxQueueSize}getConfig(n){const a=this.dataIds.get(n)||{dataId:n};return a.maxBitrate=a.maxBitrate??this.maxBitrate,a.maxPacketRate=a.maxPacketRate??this.maxPacketRate,a.maxQueueSize=a.maxQueueSize??this.maxQueueSize,a.priorityWeight=a.priorityWeight??1,a}},Fdi=class{constructor(n,a,s){this.dataIdConfig=a,this.rateLimiterCheckInterval=s,this.timeOffset=0,this.packets=new l7e,this.startTime=n(),this.finishTime=this.startTime,this.rateLimiter=new xdi(a.maxBitrate,a.maxPacketRate,this.rateLimiterCheckInterval),this.getCurrentTime=n,this.stats={bufferSize:a.maxQueueSize,remainingBytes:0,remainingPackets:0}}enqueue(n){if(n.length===0)return 0;const a=(0,vye.sumBy)(n,m=>m.length),s=this.dataIdConfig.maxQueueSize;if(s&&this.stats.remainingBytes+a>s)throw new Error(`dataId ${this.dataIdConfig.dataId} send queue is full`);const c=this.getCurrentTime();let u=0;return this.packets.size()===0?(this.startTime=c,this.finishTime=c,this.timeOffset=0,u=c):u=this.finishTime,n.forEach(m=>{u+=m.length*this.dataIdConfig.priorityWeight,this.packets.enqueue({finishTime:u,packet:m}),this.stats.remainingBytes+=m.length,this.stats.remainingPackets++}),this.finishTime=u,a}dequeue(){const n=this.peek();if(n!==void 0){if(!this.rateLimiter.canSend(n.packet))return;this.packets.dequeue(),this.stats.remainingBytes-=n.packet.length,this.stats.remainingPackets--}return n}updateTimeOffset(){this.packets.size()?this.timeOffset=this.getCurrentTime()-this.startTime:(this.startTime=this.getCurrentTime(),this.finishTime=this.startTime,this.timeOffset=0)}peek(){if(this.packets.size()===0)return;const n=this.packets.peek();return{finishTime:n.finishTime+this.timeOffset,packet:n.packet}}getConfig(){return this.dataIdConfig}getStats(){return(0,vye.clone)(this.stats)}},Udi=class{constructor(n){this.senders=new Map,this.currentVirtualClock=0,this.dataIdConfigManager=new Bdi(n),this.virtualTimeQueue=new c7e((a,s)=>a.minTime<s.minTime),this.sendStats={bufferSize:0,remainingBytes:0,remainingPackets:0},this.rateLimiterCheckInterval=n.config.webrtcDataChannel.rateLimiterCheckInterval}getPacketsToSend(n){if(this.virtualTimeQueue.size()===0)return[];const a=[],s=[];for(;n>=0&&this.virtualTimeQueue.size();){const c=this.virtualTimeQueue.peek();if(c.size>n)break;this.virtualTimeQueue.dequeue();const u=c.dataId,m=this.senders.get(u);if(m.peek()!==void 0){const b=m.dequeue();if(b!==void 0){a.push(b.packet),this.sendStats.remainingBytes-=b.packet.length,n-=b.packet.length,this.sendStats.remainingPackets--,this.currentVirtualClock=Math.max(this.currentVirtualClock,b.finishTime);const _=m.peek();_&&this.virtualTimeQueue.enqueue({dataId:u,minTime:_.finishTime,size:_.packet.length})}else s.push(u)}}return s.forEach(c=>{const u=this.senders.get(c);u.updateTimeOffset();const m=u.peek();m&&this.virtualTimeQueue.enqueue({dataId:c,minTime:m.finishTime,size:m.packet.length})}),a}appendPackets(n,a){let s=this.senders.get(n);s===void 0&&(s=new Fdi(()=>this.currentVirtualClock,this.dataIdConfigManager.getConfig(n),this.rateLimiterCheckInterval),this.senders.set(n,s));const c=s.getStats(),u=s.enqueue(a);if(this.sendStats.remainingBytes+=u,this.sendStats.remainingPackets+=a.length,c.remainingPackets===0){const m=s.peek();m!==void 0&&this.virtualTimeQueue.enqueue({dataId:n,minTime:m.finishTime,size:m.packet.length})}}getStats(n){if(n===void 0)return(0,vye.clone)(this.sendStats);const a=this.senders.get(n);return a===void 0?{bufferSize:this.dataIdConfigManager.getMaxQueueSize(n),remainingBytes:0,remainingPackets:0}:a.getStats()}},zdi=class{constructor(n){this.data={protocolCounters:{},id:void 0,label:void 0,ordered:void 0,negotiated:void 0},this.data.id=n.id,this.data.label=n.label,this.data.ordered=n.ordered,this.data.negotiated=n.negotiated,this.data.protocol=n.protocol||void 0,this.data.maxPacketLifeTime=n.maxPacketLifeTime??void 0,this.data.maxRetransmits=n.maxRetransmits??void 0}recordProtocolEvent(n,a,s){this.data.protocolCounters[s]||(this.data.protocolCounters[s]={});const c=this.data.protocolCounters[s];switch(c[n]||(c[n]={successful:0,failed:0,fragmented:0,dismissed:0}),a){case 0:c[n].successful++;break;case 1:c[n].failed++;break;case 2:c[n].fragmented++;break;case 3:c[n].dismissed++}}recordError(n){this.data.error=n}getObjectRef(){return this.data}},Vdi=class{constructor(n,a,s){this.dataId=n,this.diagnostics=a,this.logger=s,this.pendingFragments=[]}depacketize(n){const a=new DataView(n.buffer),s=63&a.getUint8(2);if(s!==this.dataId)throw new Error(`Invalid packet dataId: ${this.dataId} !== ${s}`);const c=11,u=((15&a.getUint8(0))<<8)+a.getUint8(1),m=128&a.getUint8(2),b=a.getUint16(3),_=a.getUint8(5),k=a.getUint32(6),N=a.getUint8(10);if(m){this.pendingFragments.length&&this.logger.warn(`Unfinished message: dataId: ${this.dataId} seqNum: ${b}`),this.remainingPackets=_,_!==0&&this.diagnostics.recordProtocolEvent("recv",2,s),this.pendingFragments=[],this.sourceId=k,this.recipients=[];for(let W=0;W<N;W++){const ee=a.getUint32(c+4*W);this.recipients.push(ee)}}else{if(this.pendingFragments.length===0)return this.logger.safe.error(`No start flag dataId: ${this.dataId} seqNum: ${b}`),this.diagnostics.recordProtocolEvent("recv",3,s),null;if(this.nextSeqNum!==b)return this.logger.safe.error(`Invalid sequence number: dataId: ${this.dataId} seqNum: ${b}`),this.diagnostics.recordProtocolEvent("recv",3,s),null;this.remainingPackets-=1}if(this.nextSeqNum=b+1&65535,this.pendingFragments.push(n.slice(u)),this.remainingPackets===0){const W=this.pendingFragments.reduce((de,se)=>de+se.length,0),ee=new Uint8Array(W);let oe=0;for(const de of this.pendingFragments)ee.set(de,oe),oe+=de.length;return this.pendingFragments=[],{dataId:this.dataId,sourceId:this.sourceId,data:ee,recipients:this.recipients}}return null}},$di=class{constructor(n){this.dataId=n,this.seqNum=0}packetize(n){if(n.dataId!==this.dataId)throw new Error(`Invalid dataId: ${this.dataId} !== ${n.dataId}`);const a=11,s=a+4*n.recipients.length,c=new Uint8Array(n.data.length+s),u=new DataView(c.buffer);u.setUint8(0,16+(s>>8)),u.setUint8(1,255&s),u.setUint8(2,128|63&n.dataId),u.setUint16(3,this.seqNum),u.setUint8(5,0),u.setUint32(6,n.sourceId),u.setUint8(10,n.recipients.length);for(let m=0;m<n.recipients.length;m++)u.setUint32(a+4*m,n.recipients[m]);return c.set(n.data,s),this.seqNum+=1,[c]}},Hdi=class{constructor(n,a,s){this.dataId=n,this.fragmentationSize=a,this.diagnostics=s,this.seqNum=0}packetize(n){if(n.dataId!==this.dataId)throw new Error(`Invalid dataId: ${this.dataId} !== ${n.dataId}`);const a=11,s=a+4*n.recipients.length,c=[],u=this.fragmentationSize-s;if(u<0)throw new Error(`message dataId: ${this.dataId} payload size: ${s} exceeds limit`);let m=n.data.length?Math.ceil(n.data.length/u):1;const b=m-1;b>0&&this.diagnostics.recordProtocolEvent("send",2,this.dataId);let _=n.data.length,k=!0,N=0;for(;m>0;){const W=Math.min(_,u),ee=new Uint8Array(W+s),oe=new DataView(ee.buffer);oe.setUint8(0,16+(s>>8)),oe.setUint8(1,255&s),k?(k=!1,oe.setUint8(2,128|63&n.dataId)):oe.setUint8(2,63&n.dataId),oe.setUint16(3,this.seqNum),oe.setUint8(5,b),oe.setUint32(6,n.sourceId),oe.setUint8(10,n.recipients.length);for(let de=0;de<n.recipients.length;de++)oe.setUint32(a+4*de,n.recipients[de]);ee.set(n.data.slice(N,N+W),s),N+=W,c.push(ee),this.seqNum+=1,m-=1,_-=W}return c}},d7e=class extends jr{constructor(n,a,s,c){super(),this.dataChannel=n,this.sessionDiagnostics=a,this.stateInternal="Created",this.packetizers=new Map,this.depacketizers=new Map,this.sendScheduleTimer=0,this.pendingPackets=new l7e,this.sourceIdInternal=DD,this.label=n.label,this.diagnostics=this.sessionDiagnostics.newDataChannelDiagnostics(n),this.logger=s.createChild(`[WebRtcDataChannel ${this.label}]`),this.logger.safe.info(`Created with settings ${nn(this.getDataChannelSettings(n))}`),this.bufferedAmountLowThreshold=c.config.webrtcDataChannel.bufferedAmountLowThreshold,this.bufferedAmountHighThreshold=c.config.webrtcDataChannel.bufferedAmountHighThreshold,this.fragmentationSize=c.config.webrtcDataChannel.enableFragmentation?c.config.webrtcDataChannel.fragmentationSize:0,c.config.webrtcDataChannel.enableSendScheduler&&(this.sendScheduler=new Udi(c)),this.rateLimiterCheckInterval=c.config.webrtcDataChannel.rateLimiterCheckInterval,this.discardOnSendFailure=c.config.webrtcDataChannel.discardOnSendFailure,this.subscribeOnDataChannelEvents()}getDataIdStats(n){return this.sendScheduler?.getStats(n)}get state(){return this.stateInternal}set sourceId(n){this.sourceIdInternal=n}setDataChannel(n){this.dataChannel&&(this.logger.info(`Replacing internal data channel ${this.label}:${this.dataChannel.id} with ${n.label}:${n.id} with settings ${nn(this.getDataChannelSettings(n))}`),this.unsubscribeOnDataChannelEvents(),this.dataChannel.close()),this.dataChannel=n,this.diagnostics=this.sessionDiagnostics.newDataChannelDiagnostics(n),this.subscribeOnDataChannelEvents()}dispose(){this.logger.info("dispose"),this.dataChannel&&(this.logger.info(`dataChannel.close ${this.dataChannel.id}`),this.unsubscribeOnDataChannelEvents(),this.dataChannel.close(),this.dataChannel=null,this.setState("Destroyed"),super.dispose())}sendMessage(n,a=this.sourceIdInternal,s,c=[]){try{this.packetizers.has(n)||(this.fragmentationSize?this.packetizers.set(n,new Hdi(n,this.fragmentationSize,this.diagnostics)):this.packetizers.set(n,new $di(n)));const u=this.packetizers.get(n).packetize({dataId:n,sourceId:a,data:s,recipients:c});this.sendScheduler!==void 0?(this.sendScheduler.appendPackets(n,u),this.scheduleSend()):u.forEach(m=>{this.dataChannel.send(m)}),this.diagnostics.recordProtocolEvent("send",0,n)}catch(u){throw this.logger.unsafe.warn(`Failed to construct protocol message: ${nn(u)}`),this.diagnostics.recordProtocolEvent("send",1,n),u}}scheduleSend(){if(this.state!=="Connected")return;const n=a=>{try{this.dataChannel.send(a)}catch(s){return this.logger.unsafe.warn(`Failed to send message: ${nn(s)}`),!1}return!0};if(this.dataChannel.bufferedAmount<=this.dataChannel.bufferedAmountLowThreshold){const a=Date.now();let s=this.bufferedAmountHighThreshold-this.dataChannel.bufferedAmount;for(;this.pendingPackets.size();){const c=this.pendingPackets.peek();if(c.length>s||!n(c))break;this.pendingPackets.dequeue(),s-=c.length}if(this.pendingPackets.size()===0&&s>0){const c=this.sendScheduler.getPacketsToSend(s);for(const u of c)if(n(u)===!1&&this.discardOnSendFailure===!1){this.pendingPackets.enqueue(u);break}}if(this.dataChannel.bufferedAmount<=this.dataChannel.bufferedAmountLowThreshold){if(this.sendScheduleTimer)return;if(this.sendScheduler.getStats().remainingPackets>0){const c=Math.max(a+this.rateLimiterCheckInterval-Date.now(),20);this.sendScheduleTimer=window.setTimeout(()=>{this.sendScheduleTimer=0,this.scheduleSend()},c)}}}}subscribeOnDataChannelEvents(){this.dataChannel.binaryType="arraybuffer",this.dataChannel.onmessage=n=>{const a=new Uint8Array(n.data),s=63&a[2];try{this.depacketizers.has(s)||this.depacketizers.set(s,new Vdi(s,this.diagnostics,this.logger));const c=this.depacketizers.get(s).depacketize(a);c&&(this.diagnostics.recordProtocolEvent("recv",0,s),this.event("onmessage").raise(s,c.sourceId,c.data))}catch(c){this.logger.unsafe.warn(`Failed to parse incoming message: ${nn(c)}`),this.diagnostics.recordProtocolEvent("recv",1,s)}},this.dataChannel.onerror=n=>{const a=n?.target,s=nn(n?.error??n);this.logger.safe.warn(`onerror: label:${a.label} id:${a.id} ${s} `),this.diagnostics.recordError(s)},this.dataChannel.readyState==="open"&&this.dataChannel.id%2==0&&(this.logger.safe.info(`readyState is already 'open' label:${this.dataChannel.label} id:${this.dataChannel.id}`),this.setState("Connected")),this.dataChannel.onopen=n=>{const a=n.target;this.logger.safe.info(`onopen label:${a.label} id:${a.id}`),a.id%2==0&&this.setState("Connected")},this.dataChannel.onclose=n=>{const a=n.target;this.logger.safe.info(`onclose label:${a.label} id:${a.id}`),this.setState("Closed")},this.dataChannel.onclosing=n=>{const a=n.target;this.logger.safe.debug(`onclosing label:${a.label} id:${a.id}`),this.setState("Closed")},this.sendScheduler!==void 0&&(this.dataChannel.bufferedAmountLowThreshold=this.bufferedAmountLowThreshold,this.dataChannel.onbufferedamountlow=()=>{this.scheduleSend()})}unsubscribeOnDataChannelEvents(){this.dataChannel.onmessage=null,this.dataChannel.onerror=null,this.dataChannel.onopen=null,this.dataChannel.onclose=null,this.dataChannel.onclosing=null,this.dataChannel.onbufferedamountlow=null}setState(n){this.stateInternal=n,this.event("onStateChanged").raise(),n==="Connected"&&this.sendScheduler!==void 0&&this.scheduleSend()}getDataChannelSettings(n){return{ordered:n.ordered,maxRetransmits:n.maxRetransmits,maxPacketLifeTime:n.maxPacketLifeTime}}},jdi="main-channel",Gdi=class extends jr{constructor(n,a,s,c){const u=s.createChild("PluginlessDataChannel");super(u),this.pc=n,this.diagnostics=a,this.configProvider=c,this._state="Inactive",this.logger=u,this.subscribeOnDatachannel()}get state(){return this._state}getDataChannel(n){if(!this.dataChannel){this.logger.safe.info(`[${n}] creating new dataChannel`);try{const a=this.configProvider.config.dataChannelDebugInitSettings||{};this.dataChannel=new d7e(this.pc.createDataChannel(jdi,a),this.diagnostics,this.logger,this.configProvider),this.subscribeForDataChannelEvents()}catch(a){const s=nn(a);return this.logger.safe.error(`[${n}] createDataChannel failed: ${s}`),this.diagnostics.createChannelFailReason=s,this.setState("Failed"),null}}return this.dataChannel}updateDataModalityState(n){this._state!=="Failed"&&this._state!=="Disabled"&&(n===ke.MEDIA_STATE.sendReceive?this.setState("Active"):n===ke.MEDIA_STATE.inactive&&this.setState("Inactive"))}disable(){this.setState("Disabled")}dispose(){this.stopDataChannel(),this.pc=null,super.dispose()}subscribeOnDatachannel(){this.pc.ondatachannel=n=>{this.onDataChannel(n.channel)}}onDataChannel(n){this.logger.safe.info(`onDataChannel id=${n.id} label=${n.label}`),n.id%2==0?this.dataChannel?(this.logger.safe.info("Found existing data channel, replacing"),this.dataChannel.setDataChannel(n)):(this.dataChannel=new d7e(n,this.diagnostics,this.logger,this.configProvider),this.subscribeForDataChannelEvents()):this.logger.safe.info(`onDataChannel ignoring id ${n.id}`)}subscribeForDataChannelEvents(){this.dataChannel.on("onStateChanged",()=>{this.dataChannel.state==="Closed"&&(this.stopDataChannel(),this.setState("Inactive"))})}setState(n){if(this._state!==n){this.diagnostics.dataChannelSessionState=n;const a=hi();this._state=n,this.logger.safe.info(`[${a}] SessionDataChannelState changed, state=${this._state}`),this._state==="Inactive"||this._state==="Disabled"?this.stopDataChannel():this._state==="Active"&&this.getDataChannel(a),this.event("onStateChanged").raise(this._state)}}stopDataChannel(){this.dataChannel&&(this.logger.safe.info("stopDataChannel"),this.dataChannel.dispose(),this.dataChannel=null)}},u7e=class extends Qs{constructor(n){super(),this.mainChannel=null,this.sourceId=DD,this._state="Inactive",this.dataHandlers=new Map,this.dataHandlerTelemetry=new Map,this.startTime=Date.now(),this.sendMessage=async(a,s,c)=>{if(!this.mainChannel||this.mainChannel.state!=="Connected"||this.state!=="Active")throw new Error("No active data channel to send data from");this.mainChannel.sendMessage(a,this.sourceId,s,c)},this.logger=n.createChild("PluginlessDataChannel")}get state(){return this._state}registerSessionDataChannel(n,a){this.sessionDataChannel&&this.stop(a),this.sessionDataChannel=n,this.subscribeForSessionDataChannelEvents()}setDataChannelSourceId(n){this.logger.debug(`setDataChannelSourceId ${n}`),this.mainChannel&&(this.mainChannel.sourceId=n),this.sourceId=n}requestDataChannelHandler(n){return this.sessionDataChannel.getDataChannel(n)}async sendUserEvents(n,a){if(!this.mainChannel)throw this.logger.info("sendUserEvents() no data channel available"),new Error("Main DataChannel is not active");{const s=a?a.map(c=>parseInt(c,10)):[];this.mainChannel.sendMessage(0,this.sourceId,new TextEncoder().encode(n),s)}}async addHandler(n,a){if(this.logger.info(`Adding handler with dataId ${n}`),this.dataHandlers.get(n))throw new Error(`Data Id ${n} is already registered`);const s={isStarted:!1,handler:a};this.dataHandlers.set(n,s),this.recordDataHandlerEvent(n,"added"),this.mainChannel?.state==="Connected"&&this.startHandler(n,s)}async removeHandler(n){if(this.logger.info(`Removing handler with dataId ${n}`),!this.dataHandlers.has(n))throw new Error(`Handler associated with Data Id ${n} is not attached`);const a=this.dataHandlers.get(n);a.isStarted&&this.stopHandler(n,a),this.dataHandlers.delete(n)}async updateNegotiationTag(n){}getTelemetry(){if(!this.dataHandlerTelemetry.size)return"";const n={};for(const[a,s]of this.dataHandlerTelemetry)n[a]=s;return JSON.stringify(n)}start(n){this.mainChannel?this.logger.info(`[${n}] already started`):(this.logger.info(`[${n}] starting`),this.mainChannel=this.sessionDataChannel.getDataChannel(n),this.subscribeForMainDataChannelEvents())}stop(n){this.mainChannel&&(this.logger.info(`[${n}] stopping`),this.mainChannel.dispose(),this.mainChannel=null)}dispose(){this.stop(void 0),this.sessionDataChannel=null,super.dispose()}setConfigProviderView(n){this.configProviderView=n}subscribeForMainDataChannelEvents(){this.mainChannel.on("onmessage",(n,a,s)=>{this.dataHandlers.has(n)&&(this.recordDataHandlerEvent(n,"recvd"),this.dataHandlers.get(n).handler.onDataReceived(n,s,a)),this.event("remoteUserEventsReceived").raise(n.toString(),new TextDecoder().decode(s))}),this.onMainChannelStateChanged(),this.mainChannel.on("onStateChanged",()=>this.onMainChannelStateChanged())}onMainChannelStateChanged(){if(this.mainChannel)switch(this.mainChannel.state){case"Connected":this.startHandlers();break;case"Closed":case"Destroyed":this.stopHandlers()}}startHandlers(){for(const[n,a]of this.dataHandlers.entries())a.isStarted||this.startHandler(n,a)}stopHandlers(){for(const[n,a]of this.dataHandlers.entries())a.isStarted&&this.stopHandler(n,a)}startHandler(n,a){this.logger.info(`Starting dataHandler id: ${n}`),a.handler.onStarted(n,(s,c)=>(this.recordDataHandlerEvent(n,"sent"),this.sendMessage(n,s,c)),()=>{const s=this.mainChannel?.getDataIdStats(n);if(s!==void 0){const c={bufferSize:s.bufferSize,remainingBytes:s.remainingBytes,remainingPackets:s.remainingPackets};return Promise.resolve(c)}return Promise.reject(new Error(`Stats of dataId ${n} is not available`))}),a.isStarted=!0,this.recordDataHandlerEvent(n,"started")}stopHandler(n,a){this.logger.info(`Stopping dataHandler id: ${n}`),a.handler.onStopped(n),a.isStarted=!1,this.recordDataHandlerEvent(n,"removed")}subscribeForSessionDataChannelEvents(){this.sessionDataChannel.on("onStateChanged",n=>{const a=hi();switch(n){case"Active":this.start(a),this.setState("Active");break;case"Inactive":this.stop(a),this.setState("Inactive");break;case"Failed":this.stop(a),this.setState("Failed");break;case"Disabled":this.stop(a),this.setState("Disabled");break;default:this.logger.warn(`[${a}] unhandled SessionDataChannelState ${n}`)}})}recordDataHandlerEvent(n,a){this.dataHandlerTelemetry.has(n)||this.dataHandlerTelemetry.set(n,[{}]);const s=this.dataHandlerTelemetry.get(n);let c=s[s.length-1];if(a==="added"&&c.added!==void 0){c={},s.push(c);const u=this.configProviderView?.config.maxStoredDataChannelValues??15;s.length>u&&s.shift()}switch(a){case"added":case"started":case"removed":c[a]=Date.now()-this.startTime;break;case"recvd":case"sent":c[a]=isNaN(c[a])?1:c[a]+1}}setState(n){this._state!==n&&(this._state=n,this.logger.info(`PluginlessDataChannelState changed, state=${this._state}`),this.event("onDataChannelStateUpdated").raise(this._state))}},qdi=$i(Ms());(n=>{function c(k){if(!k)return new Uint8Array(0);k.buttonType||(k.buttonType=0),k.xPos||(k.xPos=0),k.yPos||(k.yPos=0),k.wheelRotation||(k.wheelRotation=0);const N=new ArrayBuffer(7),W=new DataView(N),ee=3&k.type,oe=(7&k.buttonType)<<2,de=(k.buttonDown?1:0)<<5,se=(k.wheelButtonDown?1:0)<<6;return W.setUint8(0,1),W.setUint8(1,ee|oe|de|se|0),W.setUint16(2,k.xPos,!0),W.setUint16(4,k.yPos,!0),W.setUint8(6,k.wheelRotation),new Uint8Array(N)}function u(k){const N=new ArrayBuffer(3),W=new DataView(N),ee=3&k.codeType,oe=0,de=(k.keyUp?1:0)<<4,se=(k.repeat?1:0)<<5;return W.setUint8(0,0),W.setUint8(1,ee|oe|de|se|0|0),W.setUint8(2,k.code),new Uint8Array(N)}function m(k){return k[0]}function b(k){if(k[0]!==1||k.length!==7)return null;const N=new DataView(k.buffer),W=N.getUint8(1);return{type:3&W,buttonType:W>>2&7,buttonDown:!!(W>>5&1),wheelButtonDown:!!(W>>6&1),xPos:N.getUint16(2,!0),yPos:N.getUint16(4,!0),wheelRotation:N.getUint8(6)}}function _(k){if(k[0]!==0||k.length!==3)return null;const N=new DataView(k.buffer),W=N.getUint8(1);return{codeType:3&W,code:N.getUint8(2),repeat:!!(W>>5&1),keyUp:!!(W>>4&1)}}n.encodeMouseEvent=c,n.encodeKeyboardEvent=u,n.decodeEventType=m,n.decodeMouseEvent=b,n.decodeKeyboardEvent=_})(FD||(FD={}));var yye=dn,Sye=Hv,Wdi=3e4,bye=1e4,Kdi=2e3,Jdi=6,Vg="",h7e=class extends PD{constructor(n,a,s,c,u,m,b,_,k){super(n,c,()=>this.recordedEvents.length>100),this.auditLogger=a,this.config=s,this.negotiationTag=u,this.callId=m,this.participantId=b,this.endpointId=_,this.dataSourceId=k,this.messagesFromUnknownSender={},this.tsCallingVersion=wu()}setCallId(n){this.callId=n}setParticipantId(n){this.participantId=n}setDataSourceId(n){this.dataSourceId=n}callStateChanged(n){this.recordEvent("CallState",{state:n})}dataChannelAvailable(n){n?this.recordEvent("DataChannelAvailable"):this.recordEvent("DataChannelUnavailable")}shutdownSession(n){this.negotiationTag&&this.negotiationTag!==n?this.recordEvent("ShutdownByOtherSession",null,n):this.recordEvent("Shutdown")}recordProtocolMessage(n,a){n||(a in this.messagesFromUnknownSender||(this.messagesFromUnknownSender[a]=0),this.messagesFromUnknownSender[a]++)}sendAuditEvent(n,a,s,c,u){if(!this.auditLogger)return void this.logger.warn("AuditLogger is not set");const m=_=>_??"",b={TenantId:m(this.tenantId),CorrelationId:m(this.callId),ParticipantId:m(this.participantId),EndpointId:m(this.endpointId),TsCallingVersion:m(this.tsCallingVersion),sharingNegotiationTag:m(this.negotiationTag),timestamp:Date.now(),eventType:a,role:p7e(this.role),initiator:p7e(s),controlCauseId:n,viewerParticipantId:m(u.participantId),viewerEndpointId:m(u.endpointId),viewerDataSourceId:m(u.dataSourceId),sharerParticipantId:m(c.participantId),sharerEndpointId:m(c.endpointId),sharerDataSourceId:m(c.dataSourceId)};try{this.auditLogger.sendEvent({eventName:"mdsc_gtc_audit",props:b})}catch(_){this.logger.error("Failed to send audit event",_)}}},Ydi=class extends h7e{constructor(n,a,s,c,u,m,b,_,k,N){super(n,a,s,c,u,m,b,_,k),this.role=2;const W=Ste(N);if(W){this.sharerParticipantId=W;const ee=(0,yye.find)(N.endpoints.endpointDetails,oe=>oe.participantId===W);ee&&(this.sharerEndpointId=ee.endpointId,this.sharerClientVersion=ee.clientVersion)}}startHandshake(n){this.recordOperation("AvailableHandshake",n)}delayHandshakeSending(n,a,s){const c={delay:a,maxDelay:s};this.updateOperationData("AvailableHandshake",c,n)}handshakeSucceeded(n,a){const s={retries:a};this.recordOperationSuccess("AvailableHandshake",s,null,n)}handshakeFailed(n,a,s){const c={retries:a,reason:Xdi(s)};this.recordOperationFailure("AvailableHandshake",c,null,n)}requestControl(n,a){this.recordOperation("ControlRequest",n,n),this.recordAuditEvent(n,2,"ControlRequest",a)}requestControlAccepted(n,a){this.recordOperationSuccess("ControlRequest",n,n),this.recordAuditEvent(n,1,"ControlRequestAccepted",a),this.recordAuditEvent(n,2,"ControlStarted",a)}requestControlRejected(n,a,s){const c={reason:Sw(a)};a===2?this.recordOperationTimeout("ControlRequest",c,n,n):this.recordOperationFailure("ControlRequest",c,n,n),this.recordAuditEvent(n,1,"ControlRequestDeclined",s)}controlGiven(n,a){this.recordEvent("ControlGiven",{sharerSourceId:a},n),this.recordAuditEvent(n,1,"ControlGiven",a),this.recordAuditEvent(n,2,"ControlStarted",a)}controlTerminated(n,a,s,c){const u={sharerSourceId:s,reason:Sw(a)};this.recordEvent("ControlTerminated",u,n);const m=c?1:2;this.recordAuditEvent(n,m,"ControlTerminated",s)}recordAuditEvent(n,a,s,c){if(this.config.disableAudit)return;const u={participantId:this.sharerParticipantId,endpointId:this.sharerEndpointId,dataSourceId:c},m={participantId:this.participantId,endpointId:this.endpointId,dataSourceId:this.dataSourceId};this.sendAuditEvent(n,s,a,u,m)}getEvent(n,a){const s=c=>c??"";return{CorrelationId:s(this.callId),ParticipantId:s(this.participantId),EndpointId:s(this.endpointId),NegotiationTag:s(this.negotiationTag),TsCallingVersion:s(this.tsCallingVersion),TenantId:s(this.tenantId),SharerParticipantId:s(this.sharerParticipantId),SharerClientVersion:s(this.sharerClientVersion),EventTimestampBag:super.getEventTimestampBag(n,a),ProtocolMessages:JSON.stringify({UnknownSender:this.messagesFromUnknownSender})}}},Qdi=class extends h7e{constructor(n,a,s,c,u,m,b,_,k){super(n,a,s,c,u,m,b,_,k),this.role=1}availableAckChanged(n){n?this.recordEvent("AvailableAckEnabled"):this.recordEvent("AvailableAckDisabled")}controlRequest(n,a,s){this.recordOperation("ControlRequest",n,n),this.recordAuditEvent(n,2,"ControlRequest",a,s)}controlRequestAccept(n,a,s){const c={status:"accepting",participantId:s};this.updateOperationData("ControlRequest",c,n,n),this.recordAuditEvent(n,1,"ControlRequestAccepted",a,s)}controlRequestAccepted(n,a,s){const c={participantId:s};this.recordOperationSuccess("ControlRequest",c,n,n),this.recordAuditEvent(n,2,"ControlStarted",a,s)}controlRequestRejected(n,a,s,c){const u={reason:Sw(a),participantId:c};a===4?this.recordOperationTimeout("ControlRequest",u,n,n):this.recordOperationFailure("ControlRequest",u,n,n),this.recordAuditEvent(n,1,"ControlRequestDeclined",s,c)}giveControl(n,a,s){this.recordOperation("GiveControl",n,n),this.recordAuditEvent(n,1,"ControlGiven",a,s)}giveControlSucceeded(n,a,s){const c={participantId:s};this.recordOperationSuccess("GiveControl",c,n,n),this.recordAuditEvent(n,2,"ControlStarted",a,s)}giveControlFailed(n,a,s,c){const u={reason:Sw(a)};this.recordOperationTimeout("GiveControl",u,n,n),this.recordAuditEvent(n,1,"ControlGiveFailed",s,c)}controlTerminated(n,a,s,c,u){const m={controllerSourceId:c,reason:Sw(a)};this.recordEvent("ControlTerminated",m,n);const b=u?2:1;this.recordAuditEvent(n,b,"ControlTerminated",s,c)}recordAuditEvent(n,a,s,c,u){if(this.config.disableAudit)return;const m=bte(c,u)??c.endpoints?.endpointDetails?.[0],b={participantId:m?.participantId,endpointId:m?.endpointId,dataSourceId:u},_={participantId:this.participantId,endpointId:this.endpointId,dataSourceId:this.dataSourceId};this.sendAuditEvent(n,s,a,_,b)}getEvent(n,a){const s=c=>c===void 0?"":c;return{CorrelationId:s(this.callId),ParticipantId:s(this.participantId),EndpointId:s(this.endpointId),NegotiationTag:s(this.negotiationTag),TsCallingVersion:s(this.tsCallingVersion),TenantId:s(this.tenantId),EventTimestampBag:this.getEventTimestampBag(n,a),ProtocolMessages:JSON.stringify({UnknownSender:this.messagesFromUnknownSender})}}},Zdi=class extends Qs{constructor(n,a,s,c){super(n),this._logger=n,this._call=a,this._telemetryLoggers=s,this._config=c,this.controlState=0,this._role=0,this._enabled=!1,this._availableAckEnabled=!0,this._clientConfiguration={},this._dataChannelAvailable=!1,this._availableHandshakeSent=!1,this._controlRequest=null,this._controlRequestSubscription=null,this._controlCauseId=null,this._controllerParticipant=null,this._controllerParticipantSubscription=null,this._controllerSourceId=null,this._screenSharingVideoRenderer=null,this._screenSharingVideoRendererSubscriptions=[],this._sharerParticipant=null,this._pendingSharer=null,this._controlCapturer=null,this._captureEventSubscription=null,this._mouseControlEventSubscription=null,this._keyboardControlEventSubscription=null,this._requestControlTimer=null,this._grantControlTimer=null,this._acceptControlTimer=null,this._terminateControlTimer=null,this._delayedSendHandshakeTimer=null,this._availableAckTimer=null,this._retryAttempt=0,this._raiseRenderedAtViewer=null,this._participantSubscriptions={},this._viewerSessionLastTerminatedReason=0,this._completedViewerSessions=[],this.isEscalationInProgress=!1,this._logger.info("constructor"),this._callId=this._call.callId,this._call.on("callIdChanged",u=>{this._callId=u,this._recordSessionTelemetry(m=>m.setCallId(u))}),this._participantId=this._call.participantId,this._call.on("callLegIdChanged",u=>{this._participantId=u,this._recordSessionTelemetry(m=>{m.setParticipantId(u),m.setDataSourceId(this.getLocalEndpointDataSourceId())})}),this._endpointId=this._call.endpointId}get role(){return this._role}setAdapters(n,a,s){this._controlInjector=n,this._rendererAdapter=a,this._dataChannelAdapter=s,this._dataChannelAdapter.on("stateChange",c=>{this._onDataChannelStatusChanged(c),this._recordSessionTelemetry(u=>u.dataChannelAvailable(c))}),this._dataChannelAdapter.on("protocolMessage",(c,u,m,b)=>this.processProtocolMessage(c,u,m,b)),this._dataChannelAdapter.on("controlMessage",(c,u)=>this.processControlMessage(c,u))}testSetControlInjector(n){}enableScreenSharingControl(n,a,s,c){if(this._logger.info(`enableScreenSharingControl() enabled=${n} disabledReason=${a}`),this._availableAckEnabled!==n||this._allowControlForUser!==c){if(this._allowControlForUser=c,n)this._raiseScreenSharingControlCapableEvent(!0,Vg);else{if(a===0){const u={reason:2,detail:s};this.event("sharingControlError").raise(u)}this._raiseScreenSharingControlCapableEvent(!1,Vg)}this._availableAckEnabled!==n&&this._recordSharerSessionTelemetry(u=>u.availableAckChanged(n),!1),this._availableAckEnabled=n}}_canEnableGiveControl(){return this._controlInjector.canBeEnabled()}setRaiseRenderedAtViewer(n){this._raiseRenderedAtViewer=n}setScreenSharingControlFeatureFlag(n,a){this._logger.info(`setScreenSharingControlFeatureFlag() enabled=${n} clientConfiguration=${JSON.stringify(a)}`),this._enabled=n,this._availableAckEnabled=n,this._clientConfiguration={...a},this._enabled&&this._handleCallState(this._callState)}isScreenSharingControlEnabled(){return this._enabled}isInternalViewerControlEnabled(){return!this._clientConfiguration.externalViewerControlInitialization}isInternalSharerControlEnabled(){return!this._clientConfiguration.externalSharerControlInitialization}_disposeRenderer(n){this._disposeControlCapturer(n);for(const a of this._screenSharingVideoRendererSubscriptions)a.dispose();this._screenSharingVideoRendererSubscriptions=[],this._screenSharingVideoRenderer=null}setRenderer(n,a){this._logger.info("setRenderer");const s=hi();if(this._disposeRenderer(s),!n)return Promise.resolve();const c=a||this._rendererAdapter.getTarget(n);return Bt(()=>{this._setViewingRenderer(n,c)})}_isDataChannelActive(){return this._dataChannelAdapter.isActive()&&this._dataChannelAvailable}_raiseScreenSharingControlCapableEvent(n,a,s){if(this._enabled&&this._isDataChannelActive()){this._logger.info(`_raiseScreenSharingControlCapableEvent() enabled=true, capable=${n}, role=${this._role}`);const c={capable:n,id:a,disabledBySharer:s};this.event("sharingControlCapable").raise(c)}else{this._logger.info(`_raiseScreenSharingControlCapableEvent() enabled=false, capable=${n}, role=${this._role}`);const c={capable:!1,id:a};this.event("sharingControlCapable").raise(c)}}initControlForSharer(n){this._logger.info(`initControlForSharer() negotiationTag: ${n}`),this._isSharing()&&this._logger.warn("initControlForSharer() when already sharing"),this._resetControlState(),this._screenSharingVideoRenderer=null,this._disposeControlCapturer(),this._logger.info(`role is changing from=${this._role} to=1`),this._role=1,this._availableHandshakeSent=!1,this._raiseScreenSharingControlCapableEvent(this._canEnableGiveControl(),Vg),this._initiateSharerSessionTelemetry(n)}enableControlInjector(n){this._logger.info(`enableControlInjector() trackId: ${n}`),this._canEnableGiveControl()?this._controlInjector.enableInjector(n).catch(a=>{const s={reason:0,detail:JSON.stringify({errorMsg:a})};this.event("sharingControlError").raise(s)}):this._logger.info("enableControlInjector() give control cannot be enabled")}shutdownControlForSharer(){if(this._logger.info("shutdownControlForSharer()"),this._isSharing()||this._logger.warn("shutdownControlForSharer() when not sharing"),this._controlRequest){this._logger.warn("Rejecting pending control requests");const n=this._getDataSourceIdForParticipantLeg(this._controlRequest),a=this._controlRequest;this._clearControlRequest(),this._raiseControlRequestCanceled(a),this._sendControlRejectRequest(a.causeId,5,a.participant,n)}if(this._controllerParticipant){const n={inControl:!1,id:this._controllerParticipant.participant.id,terminatedReason:5};this._recordSharerSessionTelemetry(a=>a.controlTerminated(this._controlCauseId,n.terminatedReason,this._controllerParticipant.participant,this._controllerSourceId)),this.event("sharingControlChanged").raise(n)}this._finalizeSharerSessionTelemetry(),this._teardownSharerRemoteControl(),this._controlInjector.disableInjector().catch(n=>{const a={reason:0,detail:JSON.stringify({errorMsg:n})};this.event("sharingControlError").raise(a)}),this._resetControlState(),this._resetParticipantSubscriptions(),this._availableAckEnabled=this._enabled,this._logger.info(`role is changing from=${this._role} to=0`),this._role=0}_resetParticipantSubscriptions(){this._logger.info("resetParticipantSubscriptions() Stopping tracking all participant state changes"),(0,yye.each)(this._participantSubscriptions,n=>{n.dispose()}),this._participantSubscriptions={}}_initiateViewerSessionTelemetry(n,a,s){if(!s&&!a||!s&&(0,yye.find)(this._completedViewerSessions,c=>a===c))return null;if(this._currentViewerSessionTelemetry){if(this._currentViewerSessionTelemetry.negotiationTag===a)return null;this._finalizeViewerSessionTelemetry(a)}return this._logger.info(`Initiating new viewer session telemetry for ${a}`),this._currentViewerSessionTelemetry=new Ydi(this._logger,this._telemetryLoggers?.gtcAudit,this._config,new Date().getTime(),a,this._callId,this._participantId,this._endpointId,this.getLocalEndpointDataSourceId(),n),this._currentViewerSessionTelemetry.callStateChanged(this._callState),this._isDataChannelActive()&&this._currentViewerSessionTelemetry.dataChannelAvailable(!0),this._currentViewerSessionTelemetry}_recordViewerSessionTelemetry(n,a=!0){this._currentViewerSessionTelemetry?n&&n(this._currentViewerSessionTelemetry):a&&this._logger.error("Cannot record telemetry without current session")}_finalizeViewerSessionTelemetry(n){if(!this._currentViewerSessionTelemetry)return;this._currentViewerSessionTelemetry.shutdownSession(n);const a=this._currentViewerSessionTelemetry.getEvent();this._sendTelemetryEvent("mdsc_gtc_viewer_session",a),this._currentViewerSessionTelemetry.negotiationTag&&this._completedViewerSessions.push(this._currentViewerSessionTelemetry.negotiationTag),this._currentViewerSessionTelemetry.messagesFromUnknownSender&&Object.keys(this._currentViewerSessionTelemetry.messagesFromUnknownSender).length&&Sye.RootToolsManager.logExternalForDDL("ScreenSharingControl_viewer: messages received from unkonwn sender",JSON.stringify(a.ProtocolMessages)),this._currentViewerSessionTelemetry=null}_initiateSharerSessionTelemetry(n){if(this._currentSharerSessionTelemetry){if(this._currentSharerSessionTelemetry.negotiationTag===n)return null;this._finalizeSharerSessionTelemetry(this._currentSharerSessionTelemetry.negotiationTag)}this._logger.info(`Initiating new sharer session telemetry for ${n}`),this._currentSharerSessionTelemetry=new Qdi(this._logger,this._telemetryLoggers?.gtcAudit,this._config,new Date().getTime(),n,this._callId,this._participantId,this._endpointId,this.getLocalEndpointDataSourceId()),this._isDataChannelActive()&&this._currentSharerSessionTelemetry.dataChannelAvailable(!0)}_recordSharerSessionTelemetry(n,a=!0){this._currentSharerSessionTelemetry?n&&n(this._currentSharerSessionTelemetry):a&&this._logger.error("Cannot record telemetry without current session")}_finalizeSharerSessionTelemetry(n){if(!this._currentSharerSessionTelemetry)return;this._currentSharerSessionTelemetry.shutdownSession(n);const a=this._currentSharerSessionTelemetry.getEvent();this._sendTelemetryEvent("mdsc_gtc_sharer_session",a),this._currentSharerSessionTelemetry.messagesFromUnknownSender&&Object.keys(this._currentSharerSessionTelemetry.messagesFromUnknownSender).length&&Sye.RootToolsManager.logExternalForDDL("ScreenSharingControl_sharer: messages received from unkonwn sender",JSON.stringify(a.ProtocolMessages)),this._currentSharerSessionTelemetry=null}_recordSessionTelemetry(n){n&&(this._currentSharerSessionTelemetry&&n(this._currentSharerSessionTelemetry),this._currentViewerSessionTelemetry&&n(this._currentViewerSessionTelemetry))}_sendTelemetryEvent(n,a){this._logger.info(`Sending event ${n}: `),Object.keys(a).forEach(s=>{this._logger.info(`     ${s} => ${a[s]}`)}),this._telemetryLoggers?.media?.sendEvent({eventName:n,props:a})}reportSharingSessionChangeForViewer(n,a){a&&this._initiateViewerSessionTelemetry(n,a,!1)}initControlForViewer(n,a){if(this._logger.info(`initControlForViewer(${kn(n?.id)}, ${a})`),n){if(this._isViewing()&&this._logger.warn("initControlForViewer: called when already viewing"),this._callState!==3)return this._logger.info(`initControlForViewer: postponed until call is connected, callState=${this._callState}`),this._pendingNegotiationTag=a,void(this._pendingSharer=n);this._logger.info(`role is changing from=${this._role} to=2`),this._role=2,this._sharerParticipant?this._sharerParticipant.id!==n.id&&(this._logger.info(`initControlForViewer: sharer switched, new sharer id=${kn(n.id)}`),this._availableHandshakeSent=!1,this.controlState===4&&this._terminateControl(!1)):(this._logger.info(`initControlForViewer: setting sharer to id=${kn(n.id)}`),this._sharerParticipant=n,this._availableHandshakeSent=!1),this._initiateViewerSessionTelemetry(n,a,!0),this._enabled&&this._isDataChannelActive()&&!this._availableHandshakeSent&&(this._resetControlState(),this._sharerParticipant=n,this._logger.info("initControlForViewer: sending Available message to sharer"),this._startAvailableHandshake())}else this._logger.warn("initControlForViewer: Sharer undefined, ignoring")}shutdownControlForViewer(n){if(this._logger.info(`shutdownControlForViewer() isViewing: ${this._isViewing()}`),this._pendingSharer=null,(!n||n.id===this._sharerParticipant?.id)&&this._isViewing()){if(this._logger.info(`shutdownControlForViewer: sharerParticipant id=${n?kn(n.id):null}`),this.controlState===1){if(this._sharerParticipant){const s=this._getSharerDataSourceId();this._sendRequest({action:2,terminatedReason:6,causeId:this._controlCauseId},s)}else this._logger.warn("shutdownControlForViewer: sharer participant is null");const a={inControl:!1,id:Vg,terminatedReason:6};this._requestControlPromise?this._requestControlPromise.reject(new Error(JSON.stringify({controlInfo:a,details:""}))):this._logger.error("shutdownControlForViewer: Unexpected, no promise could be resolved, controlState=RequestSent")}else if(this.controlState===4){const a={inControl:!1,id:Vg,terminatedReason:6};this._recordViewerSessionTelemetry(s=>s.controlTerminated(this._controlCauseId,a.terminatedReason,this._controllerSourceId,!1)),this.event("sharingControlChanged").raise(a)}this._teardownViewerRemoteControl(),this._resetControlState(),this._screenSharingVideoRenderer=null,this._terminateAvailableHandshake&&this._terminateAvailableHandshake(2),this._availableHandshakeSent=!1,this._finalizeViewerSessionTelemetry(),this._role===2?(this._logger.info(`_raiseScreenSharingControlCapableEvent  with user role=${this._role}, MRI=${Vg}, isCapable=false`),this._raiseScreenSharingControlCapableEvent(!1,Vg)):this._logger.warn(`can't call _raiseScreenSharingControlCapableEvent, role=${this._role}`),this._logger.info(`role is changing from=${this._role} to=0`),this._role=0}}_resetControlRequest(n){this._clearControlRequest(),this._controlRequest=n,this._registerParticipantListener(n),n.participantState===3&&(this._logger.info(`participantState: Connected, raising: sharingIncomingControlRequest for participantId: ${kn(n.participant.id)}`),this.event("sharingIncomingControlRequest").raise(n.participant.id))}_clearControlRequest(){this._logger.info("_clearControlRequest()"),this._stopListeningToParticipantChanges(this._controlRequest),this._controlRequest=null}_stopListeningToParticipantChanges(n){this._controlRequestSubscription&&(this._logger.info(`_stopListeningToParticipantChanges: stopping tracking changes for ${kn(n.participant.id)}`),this._controlRequestSubscription.dispose(),this._controlRequestSubscription=null)}_registerParticipantListener(n){this._logger.info(`_registerParticipantListener: tracking changes for ${kn(n.participant.id)}`),this._logger.info(`request.participantState: ${n.participantState} | request.participant.state: ${n.participant.state}`),this._controlRequestSubscription=n.participant.changed(()=>{if(n.participant.state!==n.participantState)switch(this._logger.info(`request.participantState about to changed from: ${n.participantState} to: ${n.participant.state}`),n.participantState=n.participant.state,n.participantState){case 3:this.event("sharingIncomingControlRequest").raise(n.participant.id),this._logger.info(`participantState: Connected, raising: sharingIncomingControlRequest for participantId: ${kn(n.participant.id)}`);break;case 0:case 5:case 4:this.denyControlRequest().catch(a=>{this._logger.info(`It is ok if denyControlRequest rejects here as screensharing may have just been stopped. Err: ${a}`)}),this._logger.info(`_registerParticipantListener: participant ${kn(n.participant.id)} is no longer connected. resetting`),this._clearControlRequest(),this._raiseControlRequestCanceled(n);break;case 1:case 2:case 6:case 7:this._logger.info(`participantState: ${n.participantState}, participantId: ${kn(n.participant.id)}`);break;default:this._logger.error(`_registerParticipantListener: Unexpected participantState ${n.participantState} unhandled`)}})}_resetControllerParticipant(n){this._controllerParticipantSubscription&&(this._logger.info(`_resetControllerParticipant: stopping tracking changes for ${kn(this._controllerParticipant.participant.id)}`),this._controllerParticipantSubscription.dispose(),this._controllerParticipantSubscription=null),n&&(this._logger.info(`_resetControllerParticipant: tracking changes for ${kn(n.participant.id)}`),this._controllerParticipantSubscription=n.participant.changed(()=>{n.participant.state!==3&&this.handleParticipantRemoved(n.participant.id)})),this._controlCauseId=n?.causeId??null,this._controllerParticipant=n}handleParticipantRemoved(n){if(this._participantSubscriptions[n]&&(this._logger.info(`handleParticipantRemoved(): Stopping tracking state changes for ${kn(n)}`),this._participantSubscriptions[n].dispose(),delete this._participantSubscriptions[n]),this._isSharing()){if(this._controllerParticipant&&this._controllerParticipant.participant.id===n){this._logger.info("handleParticipantRemoved: controller left call, tearing down control session"),this._teardownSharerRemoteControl(),this.controlState=0;const a=5;this._recordSharerSessionTelemetry(c=>c.controlTerminated(this._controlCauseId,a,this._controllerParticipant.participant,this._controllerSourceId,!0)),this._resetControllerParticipant();const s={inControl:!1,id:n,terminatedReason:a};this.event("sharingControlChanged").raise(s)}this._raiseScreenSharingControlCapableEvent(!1,n)}else if(this._sharerParticipant&&this._sharerParticipant.id===n&&this.controlState===4){this._logger.info("handleParticipantRemoved: sharer left call, tearing down control session"),this._teardownViewerRemoteControl(),this.controlState=0;const a={inControl:!1,id:Vg,terminatedReason:6};this.event("sharingControlChanged").raise(a)}}callStateChanged(n){this._callState=n,this._recordSessionTelemetry(a=>a.callStateChanged(n)),this.isScreenSharingControlEnabled()&&this._handleCallState(n)}setIsEscalationInProgress(n){this.isEscalationInProgress=n}_getHandshakeDelay(){if(!this._config.handshakeSendDelay?.minParticipantThreshold)return 0;let n=0;if(this._call.participants.length>=this._config.handshakeSendDelay.minParticipantThreshold)for(const s of this._call.participants)s.endpoints?.endpointDetails.some(c=>c.appliedInteractivityLevel==="interactive")&&n++;if(n<=this._config.handshakeSendDelay.minParticipantThreshold)return 0;const a=Math.ceil((n-this._config.handshakeSendDelay.minParticipantThreshold)/this._config.handshakeSendDelay.increaseEveryN);return Math.min(this._config.handshakeSendDelay.maxDelay,a*this._config.handshakeSendDelay.delayPerN)}_handleCallState(n){switch(n){case 3:this._handleCallConnected();break;case 7:this._handleCallDisconnected();break;case 4:case 5:this.isInternalViewerControlEnabled()&&this.shutdownControlForViewer()}}_handleCallConnected(){this._logger.info("_handleCallConnected()"),this._pendingSharer&&(this.initControlForViewer(this._pendingSharer,this._pendingNegotiationTag),this._pendingSharer=null)}_handleCallDisconnected(){this._logger.info("_handleCallDisconnected()"),this._isSharing()?this.isInternalSharerControlEnabled()&&this.shutdownControlForSharer():this.isInternalViewerControlEnabled()&&this.shutdownControlForViewer()}_videoSizeChanged(n,a){this._controlCapturer!==null&&this._controlCapturer.updateVideoSize(n,a)}_onRenderStarted(){const n={action:11,terminatedReason:0};if(this._sharerParticipant){const a=this._getSharerDataSourceId();this._sendRequest(n,a)}else this._logger.error("Attempted to send sharing rendered message to null sharerParticipant")}_setViewingRenderer(n,a){try{this._screenSharingVideoRenderer=n,this._screenSharingVideoRendererSubscriptions.push(this._rendererAdapter.subscribeVideoSizeChangedEvent(this._screenSharingVideoRenderer,(c,u)=>{this._videoSizeChanged(c,u)})),this._screenSharingVideoRendererSubscriptions.push(this._rendererAdapter.subscribeRenderStartedEvent(this._screenSharingVideoRenderer,()=>{this._onRenderStarted()}));let s=1;n.streamSize&&n.streamSize.width>0&&n.streamSize.height>0&&(s=n.streamSize.width/n.streamSize.height),this._controlCapturer=new qdi.SlimCoreElectronControlCapturer(this._logger,a,!0,s),this.controlState===4?(this._logger.info("_setViewingRenderer: detected local state is controlling"),this._setupViewerRemoteControl()):this._teardownViewerRemoteControl()}catch(s){this._logger.error(`_setViewingRenderer: unable to set _screenSharingVideoRenderer error=${s}`)}}_onDataChannelStatusChanged(n){this._logger.info(`_onDataChannelStatusChanged(): Data channel status=${n}, isEscalationInProgress=${this.isEscalationInProgress}`),n?this._dataChannelAvailable||(this._dataChannelAvailable=!0,this._recordSessionTelemetry(a=>a.dataChannelAvailable(!0)),this._enabled&&(this._isViewing()?this._availableHandshakeSent||(this._sharerParticipant?(this._logger.info("_onDataChannelStatusChanged: sending Available message to sharer"),this._startAvailableHandshake()):this._logger.error("Unexpected null _sharerParticipant trying to send Available to sharer")):this._isSharing()&&(this.isEscalationInProgress||this._raiseScreenSharingControlCapableEvent(!0,Vg)))):this._dataChannelAvailable&&(this._recordSessionTelemetry(a=>a.dataChannelAvailable(!1)),this._dataChannelAvailable=!1,this._availableHandshakeSent=!1,this._terminateAvailableHandshake&&this._terminateAvailableHandshake(3),this.isEscalationInProgress||this._raiseScreenSharingControlCapableEvent(!1,Vg))}_isSharing(){return this._role===1}_isViewing(){return this._role===2}_handleAvailableRequest(n,a,s){if(this._isSharing())return this._enabled&&this._availableAckEnabled&&this._canEnableGiveControl()?a?.id?void(this._allowControlForUser&&typeof this._allowControlForUser=="function"?this._allowControlForUser(a).then(c=>{c?this._acceptAvailableRequest(n.handshakeId,a,s):this._rejectAvailableRequest(n.handshakeId,s,1)}):this._acceptAvailableRequest(n.handshakeId,a,s)):(this._logger.info("Unknown sender. Rejecting available ack"),void this._rejectAvailableRequest(n.handshakeId,s,10)):(this._logger.info(`Rejecting available ack - enabled=${this._enabled}, availableAck=${this._availableAckEnabled}, controlInjector=${this._canEnableGiveControl()}`),void this._rejectAvailableRequest(n.handshakeId,s,9));this._logger.warn(`Ignoring available request since role=${this._role} is not sharing. Expecting for viewer side retries`)}_acceptAvailableRequest(n,a,s){this._raiseScreenSharingControlCapableEvent(!0,a.id),this._participantSubscriptions[a.id]||(this._logger.info(`Tracking participant status for ${kn(a.id)}`),this._participantSubscriptions[a.id]=a.changed(()=>{a.state!==3&&(this._logger.info(`Participant ${kn(a.id)} is not connected. removing`),this.handleParticipantRemoved(a.id))})),this._logger.info(`Acking Available for handShake:${s}:${n}`),this.event("controlAvailableHandshake").raise(n,s,3),this._sendRequest({action:9,terminatedReason:0,handshakeId:n},s)}_rejectAvailableRequest(n,a,s){this._logger.info(`Rejecting Available for handShake:${a}:${n}`),this.event("controlAvailableHandshake").raise(n,a,7,this._getAvailableHandshakeTerminatedFromControlTerminated(s)),this._sendRequest({action:10,terminatedReason:s,handshakeId:n},a)}processProtocolMessage(n,a,s,c){return Bt(()=>{this._processProtocolMessage(n,a,s,c)})}_raiseControlRequestCanceled(n){this.event("sharingIncomingControlRequestCancelled").raise(n.participant.id)}_handleControlRequest(n,a,s,c){this._recordSharerSessionTelemetry(u=>u.controlRequest(c,n,a)),this._enabled?this._controlRequest?(this._logger.warn("Sharer is already processing a control request...rejecting new requests"),this._sendControlRejectRequest(c,3,n,a)):this._controllerParticipant&&this._controllerParticipant.participant===n?this._controllerParticipant.participantId&&this._controllerParticipant.participantId!==s?(this._logger.warn(`rejecting control request from second endpoint. participantId: ${s}`),this._sendControlRejectRequest(c,3,n,a)):(this._logger.warn("Got control request for someone already in control"),this._resetControllerParticipant(),this._resetControlRequest({participant:n,participantState:n.state,participantId:s,causeId:c})):n?(this._logger.info(`resetControlRequest for participantId: ${s}`),this._resetControlRequest({participant:n,participantState:n.state,participantId:s,causeId:c})):this._logger.error("Got ControlRequest message but could not find a sender participant, ignoring"):(this._logger.warn("Sharer control is disabled - rejecting request"),this._sendControlRejectRequest(c,9,n,a))}_handleAcceptRequest(n,a){if(this.controlState===1){const s=this._sendRequest({action:5,terminatedReason:0},a);this._logger.info(`_handleAcceptRequest controlMessage.action: ${Gb(n.action)} _sendRequest isSent: ${s}`),s?(this._setupViewerRemoteControl(),this.controlState=4,this._requestControlPromise?this._requestControlPromise.resolve():this._logger.error(`Unexpected, no promise could be resolved - controlState=RequestSent action=${Gb(n.action)}`),this._recordViewerSessionTelemetry(c=>c.requestControlAccepted(this._controlCauseId,a))):this._requestControlPromise?this._requestControlPromise.reject(new Error(JSON.stringify({controlInfo:void 0,details:"request control is accepted, but failed to send ack"}))):this._logger.error(`Unexpected, no promise could be resolved - controlState=${Eh(this.controlState)} action=${Gb(n.action)}`),this._cancelRequestControlTimer()}else this._logger.warn(`AcceptRequest message received in controlState=${Eh(this.controlState)}`)}_handleRejectRequest(n,a){if(this.controlState===1){this._logger.info(`_handleRejectRequest: controlState: ${Eh(this.controlState)}, about to be changed to: ${Eh(0)}`),this.controlState=0;const s={inControl:!1,id:Vg,terminatedReason:n.terminatedReason};this._requestControlPromise?this._requestControlPromise.reject(new Error(JSON.stringify({controlInfo:s,details:""}))):this._logger.error(`Unexpected, no promise could be resolved - controlState=RequestSent action=${Gb(n.action)}`),this._recordViewerSessionTelemetry(c=>c.requestControlRejected(this._controlCauseId,n.terminatedReason,a)),this._cancelRequestControlTimer(),this._controlCauseId=null}else this._logger.warn(`RejectRequest message received in controlState=${Eh(this.controlState)} reason=${n.terminatedReason}`)}_handleCancelControlRequest(n,a){if(this._logger.info(`_handleCancelControlRequest action=${Gb(n.action)} sender=${a}, controlRequest participantId: ${this._controlRequest.participantId}, controlRequest participantState: ${this._controlRequest.participantState}:`),this._controlRequest){const s=this._controlRequest;this._logger.info(`_handleCancelControlRequest action=${Gb(n.action)} sender=${a}, about to raise: _raiseControlRequestCanceled state: ${this._controlRequest.participantState} `),this._recordSharerSessionTelemetry(c=>c.controlRequestRejected(n.causeId,n.terminatedReason,s.participant,a)),this._clearControlRequest(),this._raiseControlRequestCanceled(s)}}_handleGiveControl(n,a,s){const c=this._sendRequest({action:5,terminatedReason:0},a);if(this._logger.info(`_handleGiveControl: controlMessage.action: ${Gb(n.action)} _sendRequest isSent: ${c}`),this._controlCauseId=n.causeId,c){this._setupViewerRemoteControl(),this._logger.info(`controlState: ${Eh(this.controlState)}, about to be changed to: ${Eh(4)}`),this.controlState=4,this._recordViewerSessionTelemetry(m=>m.controlGiven(this._controlCauseId,a));const u={inControl:!0,id:Vg,terminatedReason:n.terminatedReason};this.event("sharingControlChanged").raise(u)}}_handleAck(n,a,s){if(this.controlState===2)if(this._controllerParticipant&&this._controllerParticipant.participant.id===a.id){const c=this._getDataSourceIdForParticipantLeg(this._controllerParticipant);s!==c&&this._logger.warn(`acknowledging source id: ${s} does not match requesting source id: ${c}`),this._logger.info(`Setting up remote control for controller source id=${c}`),this._setupSharerRemoteControl(c),this._logger.info(`controlState: ${Eh(this.controlState)}, about to be changed to: ${Eh(3)}`),this.controlState=3;const u={inControl:!0,id:this._controllerParticipant.participant.id,terminatedReason:n.terminatedReason};this.event("sharingControlChanged").raise(u),this._grantControlPromise?(this._grantControlPromise.resolve(),this._cancelGrantControlTimer(),this._recordSharerSessionTelemetry(m=>m.giveControlSucceeded(this._controlCauseId,this._controllerParticipant.participant,c))):this._acceptControlPromise?(this._acceptControlPromise.resolve(),this._cancelAcceptControlTimer(),this._recordSharerSessionTelemetry(m=>m.controlRequestAccepted(this._controlCauseId,this._controllerParticipant.participant,c))):this._logger.error(`Unexpected, no promise could be resolved - controlState=WaitingForControlAck action=${Gb(n.action)}`)}else a?this._logger.warn(`Ignoring ack from participant that does not match controller id=${kn(a.id)}`):this._logger.warn(`Ignoring ack from null participant source id=${s}`);else this.controlState===5?(this._logger.info(`controlState: ${Eh(this.controlState)}, about to be changed to: ${Eh(0)}`),this.controlState=0,this._resetControllerParticipant(),this._terminateControlPromise?(this._terminateControlPromise.resolve(),this._cancelTerminateControlTimer()):this._logger.error(`Unexpected, no promise could be resolved - controlState=WaitingForTerminateAck action=${Gb(n.action)}`)):this._logger.warn(`Unexpected ack in control controlState=${Eh(this.controlState)}`)}_handleTerminate(n,a,s){let c;this._isViewing()?(this._teardownViewerRemoteControl(),c=Vg,this._recordViewerSessionTelemetry(m=>m.controlTerminated(this._controlCauseId,n.terminatedReason,s,!0))):(this._teardownSharerRemoteControl(),a?c=a.id:this._logger.error("Got terminate message but could not find a sender participant!"),this._recordSharerSessionTelemetry(m=>m.controlTerminated(this._controlCauseId,n.terminatedReason,this._controllerParticipant.participant,s,!0))),this._logger.info(`controlMessage action: ${Gb(n.action)}, controllerId: ${c}`),this._logger.info(`controlState: ${Eh(this.controlState)}, about to be changed to: ${Eh(0)}`),this.controlState=0,this._resetControllerParticipant();const u={inControl:!1,id:c,terminatedReason:n.terminatedReason};this.event("sharingControlChanged").raise(u),n.action===8&&this._sendRequest({action:5,terminatedReason:0},s)}_handleAvailableAck(n){this._terminateAvailableHandshake&&(this._logger.info(`_handleAvailableAck: terminate available handshake reason: 1,handshakeId: ${n.handshakeId}`),this._terminateAvailableHandshake(1,n.handshakeId)),this._role===2?this._raiseScreenSharingControlCapableEvent(!0,Vg):this._logger.info(`Ignoring AvailableAck as viewer session is not initialized, role: ${this._role}`)}_handleAvailableNack(n){this._logger.info(`_handleAvailableNack: action=${Gb(n.action)} terminate reason: ${Sw(n.terminatedReason)}`),this._viewerSessionLastTerminatedReason=n.terminatedReason,n.terminatedReason!==10?(this._terminateAvailableHandshake&&(this._terminateAvailableHandshake(this._getAvailableHandshakeTerminatedFromControlTerminated(n.terminatedReason),n.handshakeId),this._logger.info(`_handleAvailableNack: terminateAvailableHandshake reason=${Sw(n.terminatedReason)}`)),n.terminatedReason===1?(this._logger.warn("_handleAvailableNack: control terminate reason: SharerDenied"),this._raiseScreenSharingControlCapableEvent(!0,Vg,!0)):this._raiseScreenSharingControlCapableEvent(!1,Vg)):this._logger.warn("_handleAvailableNack: control terminate reason: UnknownSender")}_handleRenderedAtViewer(n,a){this._raiseRenderedAtViewer&&(a?(this._logger.info(`raiseRenderedAtViewer senderId=${kn(a.id)}, action=${Gb(n.action)}`),this._raiseRenderedAtViewer(a.id)):this._logger.error("Got RenderedAtViewer message but could not find a sender participant!"))}_processProtocolMessage(n,a,s,c){let u;this._recordSessionTelemetry(m=>m.recordProtocolMessage(a,c));try{u=JSON.parse(n)}catch{return void this._logger.error("Error parsing controlMessage")}switch(a||this._logger.warn(`protocol message from unknown sender with sourceId=${c}`),this._logger.info(`_processProtocolMessage action=${Gb(u.action)}, sourceId=${c}`),u.action){case 0:this._handleAvailableRequest(u,a,c);break;case 1:this._handleControlRequest(a,c,s,u.causeId);break;case 3:this._handleAcceptRequest(u,c);break;case 4:this._handleRejectRequest(u,c);break;case 2:this._handleCancelControlRequest(u,c);break;case 6:this._handleGiveControl(u,c,a);break;case 5:this._handleAck(u,a,c);break;case 8:case 7:this._handleTerminate(u,a,c);break;case 9:this._handleAvailableAck(u);break;case 10:this._handleAvailableNack(u);break;case 11:this._handleRenderedAtViewer(u,a);break;default:this._logger.error(`Unknown request action received on control protocol data sink, action=${Gb(u.action)}`)}}_getAvailableHandshakeTerminatedFromControlTerminated(n){switch(n){case 10:return 6;case 1:return 7;default:return 0}}_sendRequest(n,a){if(a<0)return this._logger.warn(`Unexpected: invalid sourceID=${a}`),!1;this._logger.info(`_sendRequest() action=${Gb(n.action)} recipient sourceid=${a}`);const s={type:0,message:JSON.stringify(n)},c=[a];return this._dataChannelAdapter.sendProtocolMessage(nV(JSON.stringify(s)),c),!0}async processControlMessage(n,a){if(a===this._controllerSourceId){if(this.controlState===3)return this._processControlMessage(n,a);this._logger.debug(`Ignoring control message, wrong controlState. Expected: RemoteControlling, got: ${Eh(this.controlState)}`)}else this._logger.debug(`Ignoring control message, wrong sourceId. Expected: ${a}, got: ${this._controllerSourceId}`)}_processControlMessage(n,a){return this._controlInjector.injectRawInput(n,a)}_resetControlState(){this._logger.info("_resetControlState()"),this.controlState=0,this._resetControllerParticipant(),this._sharerParticipant=null,this._controlCauseId=null,this._clearControlRequest(),this._cancelRequestControlTimer(),this._cancelAcceptControlTimer(),this._cancelGrantControlTimer(),this._cancelTerminateControlTimer()}_setupSharerRemoteControl(n){this._logger.info(`_setupSharerRemoteControl() sourceId=${n}`),this._controllerSourceId=n,this._controlInjector.showVirtualCursor(n).catch(a=>{const s={reason:3,detail:JSON.stringify({sourceId:n,errorMsg:a})};this.event("sharingControlError").raise(s)})}_teardownSharerRemoteControl(){this._logger.info("_teardownSharerRemoteControl()"),this._controllerSourceId=null,this._controlInjector.showVirtualCursor(0).catch(n=>{const a={reason:3,detail:JSON.stringify({sourceId:0,errorMsg:n})};this.event("sharingControlError").raise(a)})}_setupViewerRemoteControl(){this._logger.info("_setupViewerRemoteControl()"),this._setCapturerMode(3)}_teardownViewerRemoteControl(){this._logger.info("_teardownViewerRemoteControl()"),this._setCapturerMode(0)}_clearCapturerEventSubscriptions(){this._logger.info("_clearCapturerEventSubscriptions()"),this._captureEventSubscription&&(this._captureEventSubscription.dispose(),this._captureEventSubscription=null),this._mouseControlEventSubscription&&(this._mouseControlEventSubscription.dispose(),this._mouseControlEventSubscription=null),this._keyboardControlEventSubscription&&(this._keyboardControlEventSubscription.dispose(),this._keyboardControlEventSubscription=null)}sendRemoteControlEvent(n,a){if(a)switch(n){case"mouseControlEvent":this._sendControlEvent(FD.encodeMouseEvent(a));break;case"keyboardControlEvent":this._sendControlEvent(FD.encodeKeyboardEvent(a));break;default:return void this._logger.error("sendRemoteControlEvent: Invalid type=",n)}else this._logger.error("sendRemoteControlEvent: Invalid argument.")}_sendControlEvent(n){if(!this._isDataChannelActive()||!this._sharerParticipant||this.controlState!==4)return void this._logger.error(`_sendControlEvent: Dropping message - No data channel or wrong controlState. dataConnected: ${this._isDataChannelActive()} controlState: ${Eh(this.controlState)})`);const a=[this._getSharerDataSourceId()];this._dataChannelAdapter.sendControlMessage(n,a)}_setCapturerMode(n){this._logger.info(`_setCapturerMode() capturerMode=${n}`),this._controlCapturer?(this._controlCapturer.setCaptureMode(n),this._clearCapturerEventSubscriptions(),n===1?this._captureEventSubscription=this._controlCapturer.on("ctrlCaptureEvent",a=>{a===0&&this.event("sharingRendererClicked").raise()}):n===2?this._captureEventSubscription=this._controlCapturer.on("ctrlCaptureEvent",a=>{a===1?this.event("sharingRendererMouseEntering").raise():a===2&&this.event("sharingRendererMouseLeaving").raise()}):n===3&&(this._mouseControlEventSubscription=this._controlCapturer.on("mouseControlEvent",a=>{this._sendControlEvent(FD.encodeMouseEvent(a))}),this._keyboardControlEventSubscription=this._controlCapturer.on("keyboardControlEvent",a=>{this._sendControlEvent(FD.encodeKeyboardEvent(a))}),this._captureEventSubscription=this._controlCapturer.on("ctrlCaptureEvent",a=>{a===1?this.event("sharingRendererMouseEntering").raise():a===2&&this.event("sharingRendererMouseLeaving").raise()}))):this._logger.info("_controlCapturer not set, relying on external controlCapturer")}setPointerImage(n,a){return this._logger.warn("setPointerImage is deprecated. Use setLocalPointerImage or setRemotePointerImage"),n?this.setRemotePointerImage(n,a):this.setLocalPointerImage(a)}setLocalPointerImage(n){return n.length===0?Promise.reject(new Error("setLocalPointerImage invalid image length")):this._setPointerImage(0,n)}async setRemotePointerImage(n,a){if(!n)throw new Error("setRemotePointerImage participant is null");if(a.length===0)throw new Error("setRemotePointerImage invalid image length");const s=this._getParticipantsDataSourceIds(n);if(s.length===0)throw new Error("setRemotePointerImage unable to map participant to sourceIds");this._logger.info(`set pointer image for ${s.length} sources`);for(const c of s)await this._setPointerImage(c,a)}_setPointerImage(n,a){return this._isSharing()||this._logger.warn("_setPointerImage called when not sharing"),this._controlInjector.setPointerImage(n,a)}startPointerMode(){return this._enabled?this._isDataChannelActive()?this.controlState!==0?Promise.reject(new Error(`startPointerMode called in bad control controlState=${Eh(this.controlState)}`)):this._isViewing()?Bt(()=>{this._setCapturerMode(2)}):Promise.reject(new Error("startPointerMode when not viewing")):Promise.reject(new Error("startPointerMode when data channel not active")):Promise.reject(new Error("startPointerMode when feature not enabled"))}stopPointerMode(){return this.controlState!==0?Promise.reject(new Error(`stopPointerMode called in bad control controlState=${Eh(this.controlState)}`)):this._isViewing()?Bt(()=>{this._setCapturerMode(1)}):Promise.reject(new Error("stopPointerMode when not viewing"))}_startAvailableHandshake(){const n=this._getSharerDataSourceId(),a=sC(),s=this._getHandshakeDelay(),c=Math.floor(Math.random()*s);if(this._logger.info(`_startAvailableHandshake() - handshakeId: ${n}:${a} ${c>0?`delay: ${c}ms maxDelay: ${s}ms`:""}}`),this._terminateAvailableHandshake&&(this._logger.warn("Replacing existing availble handshake"),this._terminateAvailableHandshake(4)),this._recordViewerSessionTelemetry(u=>u.startHandshake(a)),n<0)this._logger.warn(`_startAvailableHandshake() - sharer: ${kn(this._sharerParticipant?.id)} has no data channel, retrying later`),this._waitForAvailableAck(a);else{const u=()=>{this.event("controlAvailableHandshake").raise(a,n,1),this._sendRequest({action:0,terminatedReason:0,handshakeId:a},n)||this._logger.error("Failed to send Available message to sharer, will retry after backoff"),this._waitForAvailableAck(a)};c>0?(this._delayedSendHandshakeTimer=window.setTimeout(u,c),this._recordViewerSessionTelemetry(m=>m.delayHandshakeSending(a,c,s))):u()}this._availableHandshakeSent=!0,this._terminateAvailableHandshake=(u=0,m)=>{this._logger.info(`_terminateAvailableHandshake() - handshakeId: ${n}:${a}, status: ${u}`),u===1?this._recordViewerSessionTelemetry(b=>b.handshakeSucceeded(a,this._retryAttempt)):(this._logger.error(`GTC handshake terminated with code ${u}, last terminated reason: ${Sw(this._viewerSessionLastTerminatedReason)}`),Sye.RootToolsManager.logExternalForDDL(`GTC handshake terminated with code ${u},`,this._viewerSessionLastTerminatedReason.toString()),this._recordViewerSessionTelemetry(b=>b.handshakeFailed(a,this._retryAttempt,u))),this._terminateAvailableHandshake=null,this.event("controlAvailableHandshake").raise(a,n,u===1?5:6,u),m&&m!==a&&this._logger.warn(`AvailableSeries: Got handshake from another series - expected: ${a}, received: ${m}`),this._availableAckTimer&&(clearTimeout(this._availableAckTimer),this._availableAckTimer=null),this._delayedSendHandshakeTimer&&(clearTimeout(this._delayedSendHandshakeTimer),this._delayedSendHandshakeTimer=null),this._retryAttempt=0}}_waitForAvailableAck(n){this._logger.info("_waitForAvailableAck()"),this._availableAckTimer=window.setTimeout(()=>{this._logger.warn(`No Ack received for Available message from attempt=${this._retryAttempt}`),this._availableAckTimer=null;const a=this._getSharerDataSourceId();if(this._retryAttempt<=Jdi)a>=0?(this._logger.info(`Re-sending Available message handshakeId: ${a}:${n}`),this.event("controlAvailableHandshake").raise(n,a,2),this._sendRequest({action:0,terminatedReason:0,handshakeId:n},a)):this._logger.warn(`_waitForAvailableAck() - sharer: ${kn(this._sharerParticipant?.id)} has no data channel, retrying later`),this._waitForAvailableAck(n);else{if(this._logger.error("Reached Available retry limit! Control capability will be false"),this._terminateAvailableHandshake)this._terminateAvailableHandshake(5);else{const s={reason:4,detail:JSON.stringify({sourceId:a,errorMsg:`Timed out after ${this._retryAttempt} tries`})};this.event("sharingControlError").raise(s)}this._raiseScreenSharingControlCapableEvent(!1,Vg)}},Kdi*++this._retryAttempt)}requestControl(){return this._enabled?this._isDataChannelActive()?this.controlState!==0?Promise.reject(new Error(`requestControl called in bad controlState=${Eh(this.controlState)}`)):this._isViewing()?this._sharerParticipant?this._requestControlPromise?Promise.reject(new Error("request control promise has not been resolved yet while requesting control")):this._terminateControlPromise?Promise.reject(new Error("terminate control promise has not been resolved yet while requesting control")):this._requestControl():Promise.reject(new Error("requestControl unexpected null sharer")):Promise.reject(new Error("requestControl when not viewing")):Promise.reject(new Error("requestControl when data channel not active")):Promise.reject(new Error("requestControl when feature not enabled"))}_requestControl(){const n=this._controlCauseId=hi();this._logger.info(`_requestControl(), controlState: ${this.controlState}, controlCauseId: ${n}`),this._requestControlPromise=new Pi;const a=()=>{this._requestControlPromise=null};this._requestControlPromise.promise.then(a,a);const s=this._getSharerDataSourceId();if(!this._sendRequest({action:1,terminatedReason:0,causeId:n},s)){const c={inControl:!1,id:Vg,terminatedReason:7};return this._requestControlPromise.reject(new Error),this._logger.error("_requestControl(): failed to send the request."),Promise.reject(new Error(JSON.stringify({controlInfo:c,details:""})))}return this._recordViewerSessionTelemetry(c=>c.requestControl(n,s)),this.controlState=1,this._requestControlTimer=window.setTimeout(()=>{if(this.controlState===1){this.controlState=0,this._controlCauseId=null,this._logger.warn("No response to control request - canceling"),this._sendRequest({action:2,terminatedReason:2,causeId:n},s)||this._logger.error("Failed to send the cancel control request");const c={inControl:!1,id:Vg,terminatedReason:2};this._recordViewerSessionTelemetry(u=>u.requestControlRejected(n,c.terminatedReason,s)),this._requestControlPromise?this._requestControlPromise.reject(new Error(JSON.stringify({controlInfo:c,details:"we did not get any response to the control - terminating control"}))):this._logger.error("Unexpected, no promise could be resolved - controlState=RequestSent")}else this._requestControlPromise?this._requestControlPromise.reject(new Error(JSON.stringify({controlInfo:void 0,details:"request control - times out in bad state - do nothing"}))):this._logger.error(`Unexpected, no promise could be resolved - controlState=${Eh(this.controlState)}`);this._requestControlTimer=null},Wdi),this._requestControlPromise.promise}_cancelRequestControlTimer(){this._requestControlTimer&&(this._requestControlPromise&&this._requestControlPromise.reject(new Error("cancelled by _cancelRequestControlTimer")),clearTimeout(this._requestControlTimer),this._requestControlTimer=null)}cancelControl(){return this._enabled?this._isDataChannelActive()?this.controlState!==1?Promise.reject(new Error(`cancelControl called in bad state=${Eh(this.controlState)}`)):this._isViewing()?this._sharerParticipant?this._requestControlPromise?this._terminateControlPromise?Promise.reject(new Error("Terminate control promise has not been resolved yet while cancelling control")):this._cancelControl():Promise.reject(new Error("Request control promise has been resolved while cancelling control")):Promise.reject(new Error("cancelControl unexpected null sharer")):Promise.reject(new Error("cancelControl when not viewing")):Promise.reject(new Error("cancelControl when data channel not active")):Promise.reject(new Error("cancelControl when feature not enabled"))}_cancelControl(){this._logger.info("_cancelControl()");const n=this._getSharerDataSourceId();if(this.controlState!==1)return Promise.reject(new Error("Cancel control - in bad state - do nothing"));if(this._cancelRequestControlTimer(),this.controlState=0,this._logger.info("Viewer cancels the control"),!this._sendRequest({action:2,terminatedReason:8,causeId:this._controlCauseId},n))return Promise.reject(new Error("Failed to send cancel control request"));{const a={inControl:!1,id:Vg,terminatedReason:8};this._recordViewerSessionTelemetry(s=>s.requestControlRejected(this._controlCauseId,a.terminatedReason,n)),this._controlCauseId=null,this._requestControlPromise.reject(new Error(JSON.stringify({controlInfo:a,details:""})))}return new Promise((a,s)=>{a()})}acceptControlRequest(){return this._enabled?this._isDataChannelActive()?this._controlRequest?this._isSharing()?this._acceptControlPromise?Promise.reject(new Error("Accept control promise has not been resolved yet while accepting control")):this._grantControlPromise?Promise.reject(new Error("Grant control promise has not been resolved yet while accepting control")):this._terminateControlPromise?Promise.reject(new Error("Terminate control promise has not been resolved yet while accepting control")):this._acceptControlRequest():Promise.reject(new Error("acceptControlRequest when not sharing")):Promise.reject(new Error("acceptControlRequest while no control request pending")):Promise.reject(new Error("acceptControlRequest when data channel not active")):Promise.reject(new Error("acceptControlRequest when feature not enabled"))}async _acceptControlRequest(){this._logger.info("_acceptControlRequest()"),this._acceptControlPromise=new Pi;const n=()=>{this._acceptControlPromise=null};if(this._acceptControlPromise.promise.then(n,n),this._controllerParticipant){this._logger.warn("_acceptControlRequest called while another participant already has control - terminating control");try{await this._terminateControl(!1)}catch(m){this._logger.error("_acceptControlRequest: failed to gracefully terminate control of previous controller",m)}this._resetControllerParticipant()}const a=this._getDataSourceIdForParticipantLeg(this._controlRequest),s=this._controlRequest.participant.id,c=this._controlRequest.causeId,u=this._controlRequest.participant;return this._sendControlAcceptRequest(c,u,a)?(this._resetControllerParticipant(this._controlRequest),this._clearControlRequest(),this.controlState=2,this._acceptControlTimer=window.setTimeout(()=>{if(this.controlState===2){this.controlState=0,this._resetControllerParticipant(),this._logger.error("No ack received when accepting control request - terminating control"),this._sendRequest({action:7,terminatedReason:4,causeId:c},a)||this._logger.error("Failed to send the TerminateNoAck request");const m={inControl:!1,id:s,terminatedReason:4};this._recordSharerSessionTelemetry(b=>b.controlRequestRejected(c,m.terminatedReason,u,a)),this.event("sharingControlChanged").raise(m),this._acceptControlPromise?this._acceptControlPromise.reject(new Error("No ack received when accept control - terminating control")):this._logger.error("Unexpected, no promise could be resolved - controlState=WaitingForControlAck")}else this._acceptControlPromise?this._acceptControlPromise.reject(new Error("accept control - times out in bad state - do nothing")):this._logger.error(`Unexpected, no promise could be resolved - controlState=${Eh(this.controlState)}`);this._acceptControlTimer=null},bye),this._acceptControlPromise.promise):(this._logger.error("Failed to send the accept control request"),this._acceptControlPromise.reject(new Error),Promise.reject(new Error("Failed to send the accept control request!")))}_sendControlAcceptRequest(n,a,s){const c=this._sendRequest({action:3,terminatedReason:0,causeId:n},s);return this._recordSharerSessionTelemetry(u=>u.controlRequestAccept(n,a,s)),c}_sendControlRejectRequest(n,a,s,c){const u=this._sendRequest({action:4,terminatedReason:a},c);return this._recordSharerSessionTelemetry(m=>m.controlRequestRejected(n,a,s,c)),u}_cancelAcceptControlTimer(){this._acceptControlTimer&&(this._acceptControlPromise&&this._acceptControlPromise.reject(new Error("cancelled by _cancelAcceptControlTimer")),clearTimeout(this._acceptControlTimer),this._acceptControlTimer=null)}denyControlRequest(){return this._enabled?this._isDataChannelActive()?this._controlRequest?this._isSharing()?this._acceptControlPromise?Promise.reject(new Error("Accept control promise has not been resolved yet while denying control")):this._grantControlPromise?Promise.reject(new Error("Grant control promise has not been resolved yet while denying control")):this._terminateControlPromise?Promise.reject(new Error("Terminate control promise has not been resolved yet while denying control")):this._denyControlRequest():Promise.reject(new Error("denyControlRequest when not sharing")):Promise.reject(new Error("denyControlRequest while no control request pending")):Promise.reject(new Error("denyControlRequest when data channel not active")):Promise.reject(new Error("denyControlRequest when feature not enabled"))}_denyControlRequest(){this._logger.info("_denyControlRequest()");const n=this._getDataSourceIdForParticipantLeg(this._controlRequest),a=this._sendControlRejectRequest(this._controlRequest.causeId,1,this._controlRequest.participant,n);return this._clearControlRequest(),a?Promise.resolve():Promise.reject(new Error("Failed to send the deny control requst"))}grantControl(n){return this._enabled?this._isDataChannelActive()?this._controlRequest?Promise.reject(new Error("grantControl called while control request pending")):this._isSharing()?n?this._acceptControlPromise?Promise.reject(new Error("Accept control promise has not been resolved yet while granting control")):this._grantControlPromise?Promise.reject(new Error("Grant control promise has not been resolved yet while granting control")):this._terminateControlPromise?Promise.reject(new Error("Terminate control promise has not been resolved yet while granting control")):this._grantControl(n):Promise.reject(new Error("grantControl null participant")):Promise.reject(new Error("grantControl when not sharing")):Promise.reject(new Error("grantControl when data channel not active")):Promise.reject(new Error("grantControl when feature not enabled"))}_grantControl(n){this._logger.info("_grantControl()"),this._grantControlPromise=new Pi;const a=()=>{this._grantControlPromise=null};if(this._grantControlPromise.promise.then(a,a),this.controlState===3){if(this._controllerParticipant.participant?.id===n.id)return this._logger.warn("_grantControl called for participant who already has control"),this._grantControlPromise.resolve(),new Promise((b,_)=>{b()});{this._logger.warn("_grantControl called while another participant already has control - terminating control"),this._teardownSharerRemoteControl();const b=this._getDataSourceIdForParticipantLeg(this._controllerParticipant);this._sendRequest({action:7,terminatedReason:5},b)||this._logger.error("Failed to send the terminateNoAck request")}}const s=this._mapParticipantToSourceId(n),c=hi(),u=this._sendRequest({action:6,terminatedReason:0,causeId:c},s);if(this._recordSharerSessionTelemetry(b=>b.giveControl(c,n,s)),!u)return this._logger.error("Failed to send the grant control request"),this._grantControlPromise.reject(new Error),Promise.reject(new Error("Failed to send the grant control request!"));const m=this._getParticipantIdForDataSourceId(n,s);return this._resetControllerParticipant({participant:n,participantState:n.state,participantId:m,causeId:c}),this.controlState=2,this._grantControlTimer=window.setTimeout(()=>{this.controlState===2?(this.controlState=0,this._resetControllerParticipant(),this._logger.error("No ack received when granting control - terminating control"),this._sendRequest({action:7,terminatedReason:4},s)||this._logger.error("Failed to send the terminateNoAck request"),this._recordSharerSessionTelemetry(b=>b.giveControlFailed(c,4,n,s)),this._grantControlPromise?this._grantControlPromise.reject(new Error("No ack received when granting control - terminating control")):this._logger.error("Unexpected, no promise could be resolved - controlState=WaitingForControlAck")):this._grantControlPromise?this._grantControlPromise.reject(new Error("Grant control - times out in bad state - do nothing")):this._logger.error(`Unexpected, no promise could be resolved - controlState=${Eh(this.controlState)}`),this._grantControlTimer=null},bye),this._grantControlPromise.promise}_cancelGrantControlTimer(){this._grantControlTimer&&(this._grantControlPromise&&this._grantControlPromise.reject(new Error("cancelled by _cancelGrantControlTimer")),clearTimeout(this._grantControlTimer),this._grantControlTimer=null)}_mapParticipantToSourceId(n){return this._dataChannelAdapter.isActive()?YG(n,3):(this._logger.error("Null data channel cannot map participant to source id"),-1)}_getParticipantsDataSourceIds(n){const a=[];try{if(n?.endpoints?.endpointDetails){if(n.endpoints.endpointDetails.length===1&&!n.endpoints.endpointDetails[0]?.mediaStreams)return a.push(DD),a;for(const s of n.endpoints.endpointDetails)if(s?.mediaStreams){for(const c of s.mediaStreams)if(CN(c.type)===3){if(a.push(c.sourceId),a.length>=8)return this._logger.error("Excessive amount of data streams"),a;break}}}}catch(s){this._logger.error(`_getParticipantsDataSourceIds caught exception error=${s}`)}return a}_getParticipantIdForDataSourceId(n,a){return N2(n,3,a)}_getDataSourceIdForParticipantId(n,a){return this._dataChannelAdapter.isActive()?yte(n,a,3):(this._logger.error("Null data channel cannot map participant to source id"),-1)}_getDataSourceIdForParticipantLeg(n){return this._getDataSourceIdForParticipantId(n.participant,n.participantId)}_getSharerDataSourceId(){const n=Ste(this._sharerParticipant);return n?this._getDataSourceIdForParticipantId(this._sharerParticipant,n):(this._logger.warn("Unable to identify the sharer participantId, falling back to first data channel"),this._mapParticipantToSourceId(this._sharerParticipant))}getLocalEndpointDataSourceId(){const n=JG(this._call,this._participantId);return n?.mediaStreams?n.mediaStreams.find(({type:s})=>CN(s)===3)?.sourceId??-1:-1}terminateControl(n){if(this._isViewing()){if(this.controlState!==4)return Promise.reject(new Error("terminateControl called while not in control"));if(!this._sharerParticipant)return Promise.reject(new Error("terminateControl called but _sharerParticipant is null"))}else{if(!this._isSharing())return Promise.reject(new Error("terminateControl called but not sharing nor viewing"));if(!this._controllerParticipant)return Promise.reject(new Error("terminateControl called but controllerParticipant is null"))}return this._requestControlPromise?Promise.reject(new Error("Request control promise has not been resolved yet while terminating control")):this._acceptControlPromise?Promise.reject(new Error("Accept control promise has not been resolved yet while terminating control")):this._grantControlPromise?Promise.reject(new Error("Grant control promise has not been resolved yet while terminating control")):this._terminateControlPromise?Promise.reject(new Error("Terminate control promise has not been resolved yet while terminating control")):this._terminateControl(!0,n)}_terminateControl(n,a){this._logger.info("_terminateControl()"),this._terminateControlPromise=new Pi;const s=()=>{this._terminateControlPromise=null};this._terminateControlPromise.promise.then(s,s);let c=0;const u=n?8:7;let m,b;if(this._isViewing()){if(this.controlState!==4)return this._logger.error("Local viewer called terminateControl when not controlling"),this._terminateControlPromise.reject(new Error),Promise.reject(new Error("Local viewer called terminateControl when not controlling"));this._teardownViewerRemoteControl(),c=a??6,m=this._getSharerDataSourceId(),this._recordViewerSessionTelemetry(N=>N.controlTerminated(this._controlCauseId,c,m)),b=Vg,this._logger.info(`Terminating remote control reason: ${Sw(c)},  recipient: ${m}, controllerId: ${b}`)}else{if(this.controlState!==3||!this._controllerParticipant)return this._logger.error("Local sharer called terminateControl when no one is in control"),this._terminateControlPromise.reject(new Error),Promise.reject(new Error("Local sharer called terminateControl when no one is in control"));this._teardownSharerRemoteControl(),c=a??5,m=this._getDataSourceIdForParticipantLeg(this._controllerParticipant),this._recordSharerSessionTelemetry(N=>N.controlTerminated(this._controlCauseId,c,this._controllerParticipant.participant,m)),b=kn(this._controllerParticipant.participant.id),this._logger.info(`Terminating control on the sharer side, reason: ${Sw(c)}, recipient: ${m}, controllerId: ${b}`)}const _={action:u,terminatedReason:c};if(!this._sendRequest(_,m)){if(n)return this._logger.error("Failed to send the terminate control request"),this._terminateControlPromise.reject(new Error),Promise.reject(new Error("Failed to send the grant control request!"));this._logger.error("Failed to send the terminateNoAck request")}this.controlState=n?5:0;const k={inControl:!1,id:b,terminatedReason:_.terminatedReason};return this._logger.info(`raising event sharingControlChanged reason=${Sw(k.terminatedReason)} controlState=${Eh(this.controlState)}`),this.event("sharingControlChanged").raise(k),n?(this._terminateControlTimer=window.setTimeout(()=>{this.controlState===5?(this.controlState=0,this._resetControllerParticipant(),this._logger.error("No ack received when terminating control - resending terminate request"),this._sendRequest({action:7,terminatedReason:4},m)||this._logger.error("Failed to send the terminateNoAck request"),this._terminateControlPromise?this._terminateControlPromise.reject(new Error("No ack received when terminating control - resending terminate request")):this._logger.error("Unexpected, no promise could be resolved - controlState=WaitingForTerminateAck")):this._terminateControlPromise?this._terminateControlPromise.reject(new Error("terminate control - times out in bad state - do nothing")):this._logger.error(`Unexpected, no promise could be resolved - controlState=${Eh(this.controlState)}`),this._terminateControlTimer=null},bye),this._terminateControlPromise.promise):(this._terminateControlPromise.resolve(),new Promise((N,W)=>{N()}))}_cancelTerminateControlTimer(){this._terminateControlTimer&&(this._terminateControlPromise&&this._terminateControlPromise.reject(new Error("cancelled by _cancelTerminateControlTimer")),clearTimeout(this._terminateControlTimer),this._terminateControlTimer=null,this._logger.info("_cancelTerminateControlTimer()"))}_disposeControlCapturer(n=hi()){this._logger.info(`_disposeControlCapturer causeId: ${n}`),this._clearCapturerEventSubscriptions(),this._controlCapturer&&(this._controlCapturer.dispose(n),this._controlCapturer=null)}dispose(n){this._logger.info(`dispose causeId: ${n}`),this._dataChannelAdapter.dispose(n),this._resetControlState(),this._disposeRenderer(n),this._cancelRequestControlTimer(),this._cancelAcceptControlTimer(),this._cancelGrantControlTimer(),this._cancelTerminateControlTimer(),this._terminateAvailableHandshake&&this._terminateAvailableHandshake(2),this._call=null,this._resetParticipantSubscriptions(),this._finalizeViewerSessionTelemetry(),this._finalizeSharerSessionTelemetry(),super.dispose(n)}};function Xdi(n){switch(n){case 1:return"Succeeded";case 2:return"Shutdown";case 3:return"DataChannel";case 4:return"Replaced";case 5:return"TimedOut";case 6:return"UnknownSender";case 7:return"SharerDenied";default:return"Unknown"}}function Gb(n){switch(n){case 0:return"Available";case 1:return"ControlRequest";case 2:return"CancelControlRequest";case 3:return"AcceptRequest";case 4:return"RejectRequest";case 5:return"Ack";case 6:return"GiveControl";case 7:return"TerminateNoAck";case 8:return"Terminate";case 9:return"AvailableAck";case 10:return"AvailableNack";case 11:return"RenderedAtViewer";default:return"Unknown"}}function Eh(n){switch(n){case 0:return"None";case 1:return"RequestSent";case 2:return"WaitingForControlAck";case 3:return"RemoteControlling";case 4:return"LocalControlling";case 5:return"WaitingForTerminateAck";default:return"Unknown"}}function Sw(n){switch(n){case 0:return"None";case 1:return"SharerDenied";case 2:return"SharerNoResponse";case 3:return"SharerBusy";case 4:return"AckTimeout";case 5:return"SharerTerminated";case 6:return"ViewerTerminated";case 7:return"DataChannelError";case 8:return"ViewerCancelled";case 9:return"SharerControlDisabled";case 10:return"UnknownSender";case 11:return"MultipleSharers";default:return"Unknown"}}function p7e(n){switch(n){case 1:return"Sharer";case 2:return"Viewer";default:return"Unknown"}}var g7e=(n=>(n[n.LEFT=0]="LEFT",n[n.RIGHT=1]="RIGHT",n[n.MIDDLE=2]="MIDDLE",n[n.BACK=3]="BACK",n[n.FORWARD=4]="FORWARD",n))(g7e||{}),m7e=(n=>(n[n.SCAN_CODE=0]="SCAN_CODE",n[n.VIRTUAL_KEY=1]="VIRTUAL_KEY",n[n.RECOGNITION_INPUT=2]="RECOGNITION_INPUT",n))(m7e||{}),eui=class{constructor(n){this.logger=n}toEdgeControlMouseEvent(n){let a;switch(n.type){case 0:return{event:this.toMouseMoveEvent(n),apiName:"injectMouseMoveEvent"};case 1:return{event:this.toMouseWheelEvent(n),apiName:"injectMouseWheelEvent"};case 2:return{event:this.toMouseButtonPressedEvent(n),apiName:"injectMouseButtonEvent"};default:throw a=`Uncovered mouse control event type. Event: ${n}`,this.logger.error(a),Error(a)}}toEdgeControlKeyboardEvent(n){return{event:{repeat:n.repeat,keyUp:n.keyUp,codeType:m7e[n.codeType],keyCode:n.code},apiName:"injectKeyEvent"}}toMouseMoveEvent(n){return{xPos:n.xPos,yPos:n.yPos}}toMouseWheelEvent(n){return{wheelButtonDown:n.wheelButtonDown,wheelRotation:n.wheelRotation}}toMouseButtonPressedEvent(n){return{xPos:n.xPos,yPos:n.yPos,button:g7e[n.buttonType],buttonDown:n.buttonDown}}};async function tui(n,a,s){return new Promise((c,u)=>{const m=Buffer.from(n,"base64"),b=document.createElement("canvas").getContext("2d"),_=new Blob([m],{type:"image/png"});let k=new Image;k.onload=()=>{b.drawImage(k,0,0,k.width,k.height,0,0,a,s);const N=b.getImageData(0,0,a,s);window.URL.revokeObjectURL(k.src),k=null,c(Array.from(N.data))},k.onerror=N=>{u(N)},k.src=window.URL.createObjectURL(_)})}var xV="ncbjelpjchkpbikbpkcchkhkblodoama",iui=class{constructor(n){this.logger=n}async sendInjectInputEventMessage(n,a){return this.logger.info("EdgeControlInjectorApi - sendInjectInputEventMessage"),new Promise((s,c)=>{window.top.chrome.runtime.sendMessage(xV,{api:n,deviceId:this.virtualInputDeviceId,event:a},u=>{u.error?c(u.error.message):s(0)})})}async createInputDeviceId(n,a,s){this.virtualInputDeviceId&&this.logger.warn("EdgeControlInjectorApi - createInputDeviceId virtual input already exists.");try{this.virtualInputDeviceId=await this.sendCreateInputDeviceMessage(n,s)}catch(c){this.logger.error(`EdgeControlInjectorApi - createInputDevice failed, error: ${JSON.stringify(c)}`),a()}}async sendSetLocalUserAvatarMessage(n){const a=await this.generateAvatarBitmap(n);return new Promise((s,c)=>{const u=window.top;a&&u.chrome.runtime.sendMessage(xV,{api:"setLocalUserAvatar",avatarBitmap:a},m=>{m.error?c(m.error.message):s()})})}async sendCloseVirtualInputDeviceMessage(){const n=this.virtualInputDeviceId;return n?(this.logger.info("EdgeControlInjectorApi - sendCloseVirtualInputDeviceMessage called"),new Promise((a,s)=>{const c=window.top;c.chrome.runtime.sendMessage(xV,{api:"closeInputDevice",deviceId:n},u=>{u?u.error?s(u.error.message):(this.virtualInputDeviceId=null,a(u.deviceId)):s(c.chrome.runtime.lastError.message)})})):(this.logger.info("EdgeControlInjectorApi - VirtualInputDevice does not exists, nothing to close."),Promise.resolve())}async sendCreateInputDeviceMessage(n,a){this.logger.info("EdgeControlInjectorApi - sendCreateInputDeviceMessage called");const s=await this.generateAvatarBitmap(a);return new Promise((c,u)=>{const m=window.top,b=_=>{_?_.deviceId?c(_.deviceId):_.error?u(_.error.message):u("Error: Unexpected response from API"):u(m.chrome.runtime.lastError.message)};s?m.chrome.runtime.sendMessage(xV,{api:"createInputDevice",mediaStreamTrackId:n,avatarBitmap:s},b):m.chrome.runtime.sendMessage(xV,{api:"createInputDevice",mediaStreamTrackId:n},b)})}async generateAvatarBitmap(n){if(!n)return null;try{return{width:32,height:32,data:await tui(n,32,32)}}catch(a){return this.logger.error(`EdgeControlInjectorApi - generateAvatarBitmap error: ${JSON.stringify(a)}, continue without avatar.`),null}}};async function nui(n){return new Promise((a,s)=>{n.info("EdgeControlInjectorApi - sendIsVirtualInputSupportedMessage");const c=window.top;c.chrome.runtime.sendMessage(xV,{api:"isVirtualInputSupported"},u=>{u?u.error?a(u.error.message):a(u):s(c.chrome.runtime.lastError?.message)})})}var f7e,Tye,aui=class{constructor(n,a,s){this.logger=n,this.sharingTrackId=a,this.onInitErrorCallback=s,this.images=new Map,this.controlEventConverter=new eui(n),this.edgeApi=new iui(this.logger)}showVirtualCursor(n,a){if(this.logger.info(`EdgeControlInjector - showVirtualCursor, id: ${n} sharingTrackId: ${this.sharingTrackId}`),a){this.edgeApi.createInputDeviceId(this.sharingTrackId,this.onInitErrorCallback,this.images[n]);const s=this.images[0];s?this.edgeApi.sendSetLocalUserAvatarMessage(s):this.logger.error("EdgeControllerInjector - local avatar is missing, continue without local avatar")}else this.edgeApi.sendCloseVirtualInputDeviceMessage()}setAvatar(n,a){this.logger.info(`${n} EdgeControlInjector - setAvatar, id: ${n}, data: ${JSON.stringify(a)}`),this.images[n]=a}async injectMouseEvent(n,a){this.logger.info(`${n} EdgeControlInjector - injectMouseEvent ${JSON.stringify(a)}`);const s=this.controlEventConverter.toEdgeControlMouseEvent(a);return this.edgeApi.sendInjectInputEventMessage(s.apiName,s.event)}async injectKeyboardEvent(n,a){const s=this.controlEventConverter.toEdgeControlKeyboardEvent(a);return this.edgeApi.sendInjectInputEventMessage(s.apiName,s.event)}injectClipboardText(n,a){return this.logger.info(`${n} EdgeControlInjector - injectClipboardText is unimplemented`),Promise.resolve(0)}dispose(n){this.logger.info("EdgeControlInjector - dispose"),this.edgeApi.sendCloseVirtualInputDeviceMessage()}},v7e=typeof navigator<"u"&&navigator.mediaDevices?.getUserMedia!==void 0,y7e=(n=>(n.AVD="43",n.Citrix="44",n.VMware="45",n))(y7e||{});function rui(n=""){const a=n.match(new RegExp("^SkypeSpaces/(\\d+)/"));a?.length&&Object.values(y7e).includes(a[1])&&(Tye=a[1]),oui()}function Kte(){return!!Tye}function Cye(){return Tye}function oui(){typeof window<"u"&&typeof navigator<"u"&&(navigator.webkitGetUserMedia!==void 0&&typeof webkitRTCPeerConnection<"u"&&Kte()?(window.RTCPeerConnection=webkitRTCPeerConnection,navigator.getUserMedia=(n,a,s)=>{const c=u=>{u?.deviceId?.exact&&(u.mandatory||(u.mandatory={}),u.mandatory.sourceId=u.deviceId.exact,delete u.deviceId)};return n&&(c(n.audio),c(n.video)),navigator.webkitGetUserMedia(n,a,s)}):v7e&&S7e())}function S7e(){navigator.getUserMedia=function(n,a,s){return navigator.mediaDevices.getUserMedia(n).then(a).catch(s)}}typeof window<"u"&&typeof navigator<"u"&&(f7e=window,window.URL=window.URL||window.webkitURL||window.mozURL||window.msURL,window.MediaStream=window.MediaStream||window.webkitMediaStream||window.mozMediaStream||window.msMediaStream,window.AudioContext=window.AudioContext||window.webkitAudioContext);var Cc={window:f7e},Jte=class{constructor(n){this.logger=n,this.activeSourceId=0,this.pendingPointerImages=new Map}static create(n,a){return n.config.enableGiveControl?Kte()||window.ControlInjector?new lui(a):ul.isBrowser("EdgeAnaheim")?new sui(a):new b7e(a):new b7e(a)}async enableInjector(n){this.injector&&this.logger.warn("Control injector already present when enabling injector");try{this.injector=this.createInjector(n)}catch(a){throw this.logger.error(`Control injector creation failed: ${a}`),a}this.pendingPointerImages.forEach((a,s)=>{this.injector.setAvatar(s,a)}),this.pendingPointerImages.clear()}async disableInjector(){this.injector||this.logger.warn("Control injector not present when disabling injector"),this.logger.info("ControlInjector disposed"),this.injector.dispose(),this.injector=null}async setPointerImage(n,a){this.injector?this.injector.setAvatar(n,a):this.pendingPointerImages.set(n,a)}async showVirtualCursor(n){if(this.logger.info(`showVirtualCursor ${n} ${this.activeSourceId}`),!this.injector)throw new Error("Control injector not present");n?(this.activeSourceId&&this.injector.showVirtualCursor(this.activeSourceId,!1),this.injector.showVirtualCursor(n,!0),this.activeSourceId=n):this.activeSourceId&&(this.injector.showVirtualCursor(this.activeSourceId,!1),this.activeSourceId=0)}async injectRawInput(n,a){if(!this.injector)throw new Error("Control injector not present");const s=this.injector;return new Promise((c,u)=>{let m,b;const _=FD.decodeEventType(n);switch(_){case 1:m=FD.decodeMouseEvent(n),s.injectMouseEvent(a,m).then(k=>k===0?c():u());break;case 0:b=FD.decodeKeyboardEvent(n),s.injectKeyboardEvent(a,b).then(k=>k===0?c():u());break;default:this.logger.error(`Invalid event type in raw input: ${_}`),u()}})}},sui=class extends Jte{constructor(n){super(n.createChild("EdgeControlInjector")),this.edgeVirtualInputSupported=!1,nui(n).then(a=>{this.edgeVirtualInputSupported=a,n.info(`Edge supports virtual input device: ${JSON.stringify(this.edgeVirtualInputSupported)}`)}).catch(a=>{n.info(`Edge IsVirtualInputSupported: ${JSON.stringify(a)}`)})}canBeEnabled(){return this.edgeVirtualInputSupported}createInjector(n){if(!this.edgeVirtualInputSupported)return void this.logger.info("Edge doesn't support give control");const a=new aui(this.logger,n,()=>{this.logger.error("An error occured, disabling control injector."),this.disableInjector()});return this.logger.info("Edge ControlInjector created"),a}},lui=class extends Jte{constructor(n){super(n.createChild("WindowControlInjector"))}canBeEnabled(){return!!window.ControlInjector}createInjector(n){const a=window.ControlInjector(n);return this.logger.info("Window ControlInjector created"),a}},b7e=class extends Jte{constructor(n){super(n.createChild("NoopControlInjector"))}canBeEnabled(){return!1}createInjector(){throw new Error("Control injector creation is disabled")}},cui=class{constructor(n){this.logger=n,this.logger.info("RendererAdapter")}getTarget(n){return n.target}subscribeVideoSizeChangedEvent(n,a){const s=n;return s.streamSize&&a(s.streamSize.width,s.streamSize.height),s.renderer.on("onVideoSizeChanged",a)}subscribeRenderStartedEvent(n,a){return n.renderer.on("onVideoStarted",(s,c)=>a())}};function dui(n){return String.fromCharCode.apply(null,n)}var uui=class extends Qs{constructor(n,a){super(n),this.logger=n,this._call=a}isActive(){return!(!this.protocolSendFunc||!this.controlSendFunc)}sendProtocolMessage(n,a){return this.protocolSendFunc?this.protocolSendFunc(n,a):(this.logger.error("Cannot send protocol message, ProtocolHandler hasn't started"),Promise.resolve())}sendControlMessage(n,a){return this.controlSendFunc?this.controlSendFunc(n,a):(this.logger.error("Cannot send control message, ControlHandler hasn't started"),Promise.resolve())}getProtocolHandler(){return{onStarted:async(n,a)=>{this.logger.info(`ProtocolHandler started for ${n}`),this.protocolSendFunc=a,this.isActive()&&this.event("stateChange").raise(!0)},onStopped:async n=>{this.logger.info(`ProtocolHandler stopped for ${n}`);const a=this.isActive();this.protocolSendFunc=null,a&&this.event("stateChange").raise(!1)},onDataReceived:async(n,a,s)=>{if(n===1){const c=JSON.parse(dui(a)),u=this._call.mapDataChannelSourceIdToParticipant(s);let m;return u&&(m=N2(u,3,s)),this.event("protocolMessage").raise(c.message,u,m,s)}}}}getControlHandler(){return{onStarted:async(n,a)=>{this.logger.info(`ControlHandler started for ${n}`),this.controlSendFunc=a,this.isActive()&&this.event("stateChange").raise(!0)},onStopped:async n=>{this.logger.info(`ControlHandler stopped for ${n}`);const a=this.isActive();this.controlSendFunc=null,a&&this.event("stateChange").raise(!1)},onDataReceived:async(n,a,s)=>{if(n===2)return this.event("controlMessage").raise(a,s)}}}},T7e=class extends Zdi{constructor(n,a,s,c,u,m){const b={disableAudit:u.getEcsConfig("SkypeCalling","gtcAuditDisabled")??!1},_=u.getEcsConfig("SkypeCalling","gtcHandshakeSendDelay");if(_)try{b.handshakeSendDelay=JSON.parse(_)}catch(ee){n.error(`Failed to parse ecs config gtcAvailableAckDelay: ${nn(ee)}`)}super(n.createChild("ScreenSharingControl"),s,c,b),this.dataChannel=a;const k=Jte.create(m,n),N=new cui(this._logger),W=new uui(this._logger,s);this.setAdapters(k,N,W)}setupDataHandlers(){this.dataChannel.addHandler(1,this.getProtocolHandler()),this.dataChannel.addHandler(2,this.getControlHandler())}startOrStopControlForViewer(n,a,s){if(n&&s?.appliedInteractivityLevel!=="nonInteractive"){if(a&&this.role===0){const c=a.streams[1].find(u=>u.isAvailable)?.negotiationTag;this.initControlForViewer(a,c)}}else this.role===2&&this.shutdownControlForViewer()}getProtocolHandler(){return this._dataChannelAdapter.getProtocolHandler()}getControlHandler(){return this._dataChannelAdapter.getControlHandler()}};function hui(n){const a=[];for(const s in n)if(n[s].participantLegIdMap)for(const c in n[s].participantLegIdMap){const u=n[s].participantLegIdMap[c].endpointId;a.push({id:s,mri:s,participantId:c,...u&&{endpointId:u}})}else a.push({id:s,mri:s});return a}function pui(n){switch(n){case 1:return"specified";case 0:return"all";case 3:return"attendees";case 2:return"presenters";case 4:return"self";default:return"none"}}var C7e={};Gt(C7e,{addReceiveDirectionality:()=>gui,allowDataChannel:()=>z2,areNegotiatedDirectionsAcceptable:()=>BV,areNegotiatedDirectionsFulfilled:()=>Aye,areSendDirectionsFulfilled:()=>mui,canUseWebrtc1_0:()=>wye,convertToCodecInfo:()=>kye,getAllowedCodecs:()=>nie,getSrtpInfo:()=>Xte,hasReceiveDirectionality:()=>Rc,hasSendDirectionality:()=>Ur,invertModalities:()=>r9,ipAddressConverter:()=>Rye,ipV4RegExp:()=>Yte,ipV6RegExp:()=>_ye,ipv4AddressConverter:()=>Mye,ipv6AddressConverter:()=>E7e,isOnHold:()=>$g,mediaTypeToModality:()=>KR,modalityToMediaType:()=>kN,negotiateDirectionality:()=>a9,negotiateModalities:()=>Eye,parseCandidateString:()=>tie,preferSdesSrtp:()=>l9,printMediaStream:()=>V2,removeChangedSendDirection:()=>eie,removeSendDirectionality:()=>o9,scrubConstraints:()=>uC,scrubDevices:()=>FV,scrubObjectExcludingFields:()=>Iye,scrubObjectFields:()=>s9,scrubSelectedDevices:()=>_7e,sendStreamsToModalities:()=>iie,shouldDisableAudioSendersTroughSetParams:()=>c9,shouldDisableVideoSendersTroughSetParams:()=>UV});var yp=class ACe extends jr{constructor(a){super(),this.isAudioOutputSelectionSupportedValue=!1,a.on("configUpdated",()=>this.updateConfig()),this.updateConfig(),this.isRollbackSupported()}get isAudioOutputSelectionSupported(){return this.isAudioOutputSelectionSupportedValue}get isBrowserRollbackSupported(){return this.isRollbackSupportedValue}static hasApplyConstraints(){return MediaStreamTrack.prototype.applyConstraints!==void 0}static hasPermissionsApi(){return navigator.permissions!==void 0}static get hardwareConcurrency(){return window.navigator.hardwareConcurrency}static get unmaskedGlRenderer(){if(this.renderer)return this.renderer===ke.MEDIA_ERROR.webGlRendererError?void 0:this.renderer;try{const a=document.createElement("canvas").getContext("webgl"),s=a?.getExtension("WEBGL_debug_renderer_info"),c=s&&a.getParameter(s.UNMASKED_RENDERER_WEBGL);return this.renderer=c,c}catch{return void(this.renderer=ke.MEDIA_ERROR.webGlRendererError)}}async isRollbackSupported(){let a;try{if(a=Cc.window.RTCPeerConnection&&new Cc.window.RTCPeerConnection({sdpSemantics:"unified-plan"}),a){const s=await a.createOffer();await a.setLocalDescription(s),await a.setLocalDescription({type:"rollback"}),this.isRollbackSupportedValue=!0}}catch{this.isRollbackSupportedValue=!1}finally{a?.close()}}static async isCodecsSupported(a){const s={format:"annexb"},c=1280,u=720,m=["no-preference","prefer-software","prefer-hardware"],b=[];for(const _ of a)for(const k of m){const N=await window.VideoEncoder?.isConfigSupported({codec:_,hardwareAcceleration:k,hevc:s,width:c,height:u}),W=await window.VideoDecoder?.isConfigSupported({codec:_,hardwareAcceleration:k,hevc:s});if(N||W){const ee={name:_,mode:N?.config.hardwareAcceleration,encode:N?.supported,decode:W?.supported};b.push(ee)}}return b}static async hasH264CodecSupport(a){const s=`v=0
o=- 596983 0 IN IP4 127.0.0.1
s=session
c=IN IP4 0.0.0.0
t=0 0
a=msid-semantic: WMS *
m=video 3480 RTP/SAVPF 107 99
a=rtpmap:107 H264/90000
a=rtpmap:99 rtx/90000
a=fmtp:107 max-fs=240;max-mbps=3600;max-br=208;max-fps=1500;profile-level-id=42C02A;packetization-mode=1
a=fmtp:99 apt=107
a=setup:actpass
a=mid:video
a=recvonly
a=rtcp-mux
a=ice-ufrag:CvYq
a=ice-pwd:axsjsa0GOz3kz6TuGvNgJZWO
a=fingerprint:sha-256 34:DF:5C:15:60:FF:28:3E:E8:96:4B:F8:85:61:E4:C0:57:D1:60:82:21:FD:BC:D2:90:41:06:FA:03:FD:12:A2
`,c=Cc.window.RTCPeerConnection&&new Cc.window.RTCPeerConnection;if(!c)return!1;try{return await c.setRemoteDescription({sdp:s,type:"offer"}),!0}catch(u){return a.error("H264 not supported",u),!1}finally{try{c.close()}catch{}}}static hasMediaApi(){return navigator.getUserMedia&&typeof RTCPeerConnection<"u"}static hasCapabilitiesApi(){return!!Cc.window.RTCRtpReceiver?.getCapabilities}static isAudioOutputSelectionSupportedByBrowser(){return!!Cc.window?.HTMLAudioElement?.prototype.setSinkId}updateConfig(){const a=ACe.isAudioOutputSelectionSupportedByBrowser();a!==this.isAudioOutputSelectionSupportedValue&&(this.isAudioOutputSelectionSupportedValue=a,this.event("isAudioOutputSelectionSupportedChanged").raise())}static hasUnifiedPlanSupport(){let a;try{a=Cc.window.RTCPeerConnection&&new Cc.window.RTCPeerConnection({sdpSemantics:"unified-plan"})}catch{return!1}let s=!1;return a&&(s=!!a.addTransceiver,a.close()),s}static hasEncodedStreamsApi(){return!!RTCRtpReceiver.prototype.createEncodedStreams||ACe.hasScriptTransformApi()}static hasScriptTransformApi(){return!!window.RTCRtpScriptTransform}static isWakeLockSupported(){return!!window.navigator.wakeLock}},Yte=RegExp(/^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(:[0-9]{1,5})?$/),_ye=RegExp(/^\[?(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|:((:[0-9a-fA-F]{1,4}){1,5}|:)((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,5}([0-9a-fA-F]{1,4})?:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\]?(?::\d{1,5})?$/);function Qte(n){switch(n){case ke.MEDIA_STATE.send:return ke.MEDIA_STATE.receive;case ke.MEDIA_STATE.receive:return ke.MEDIA_STATE.send;default:return n}}function a9(n,a){const s=Ur(n)&&Ur(a),c=Rc(n)&&Rc(a);return s&&c?ke.MEDIA_STATE.sendReceive:s?ke.MEDIA_STATE.send:c?ke.MEDIA_STATE.receive:n===ke.MEDIA_STATE.inactive&&a||n&&a===ke.MEDIA_STATE.inactive?ke.MEDIA_STATE.inactive:void 0}function r9(n){const a={},s=Qte(n.audio);s&&(a.audio=s);const c=Qte(n.video);c&&(a.video=c);const u=Qte(n.sharing);u&&(a.sharing=u);const m=Qte(n.data);return m&&(a.data=m),a}function o9(n){return n===ke.MEDIA_STATE.sendReceive?ke.MEDIA_STATE.receive:void 0}function Ur(n){return n===ke.MEDIA_STATE.send||n===ke.MEDIA_STATE.sendReceive}function Rc(n){return n===ke.MEDIA_STATE.receive||n===ke.MEDIA_STATE.sendReceive}function gui(n){return Rc(n)?n:n===ke.MEDIA_STATE.send?ke.MEDIA_STATE.sendReceive:ke.MEDIA_STATE.receive}function $g(n){return!(n.audio!==ke.MEDIA_STATE.inactive||n.video&&n.video!==ke.MEDIA_STATE.inactive||n.sharing&&n.sharing!==ke.MEDIA_STATE.inactive)}function Eye(n,a){const s={},c=a9(n.audio,a.audio);c&&(s.audio=c);const u=a9(n.video,a.video);u&&(s.video=u);const m=a9(n.sharing,a.sharing);m&&(s.sharing=m);const b=a9(n.data,a.data);return b&&(s.data=b),s}function Zte(n,a,s,c){const u=Ur(a)&&Ur(s)||!Ur(a)&&!Ur(c);let m=!c||Rc(a)&&Rc(s)||!Rc(a)&&!Rc(c);return n.config.fixExtraNegotiation&&(m=m||Rc(a)&&!Rc(s)&&!Rc(c)),u&&m}function BV(n,a,s,c){return Zte(n,a.audio,s.audio,c.audio)&&Zte(n,a.video,s.video,c.video)&&Zte(n,a.sharing,s.sharing,c.sharing)&&Zte(n,a.data,s.data,c.data)}function Aye(n,a){function s(c,u){const m=Ur(c)===Ur(u),b=Rc(c)===Rc(u)||Rc(c)&&!u;return m&&b}return s(n.audio,a.audio)&&s(n.video,a.video)&&s(n.sharing,a.sharing)&&s(n.data,a.data)}function mui(n,a){const s=(c,u)=>Ur(c)===Ur(u);return s(n.audio,a.audio)&&s(n.video,a.video)&&s(n.sharing,a.sharing)&&s(n.data,a.data)}function Xte(n){const a={dtls:!1,sdes:!1};return a.dtls=!!n.fingerprint,n.media.forEach(s=>{a.dtls=a.dtls||!!s.fingerprint,a.sdes=a.sdes||!!s.crypto}),a}function eie(n,a){if(!a||Am(a))return n;const s={};return Ng(n,(c,u)=>{u===ke.MODALITY.data?s[u]=vui(c,a[u]):s[u]=fui(c,a[u])}),s}function fui(n,a){return Ur(n)&&!Ur(a)?o9(n)||a:n}function vui(n,a){return Ur(n)&&!Ur(a)?a:n}function tie(n){const a=(n||"").split(" ");return{component:a[1],protocol:a[2],priority:a[3],ip:a[4],port:a[5],type:a[7]}}function kN(n){switch(n){case"audio":return"Audio";case"video":return"Video";case"sharing":return"ScreenShare";default:return null}}function KR(n){switch(n){case"Audio":return"audio";case"Video":return"video";case"ScreenShare":return"sharing";default:return null}}function iie(n){const a={};return kD(n).forEach(s=>a[s]=!!n[s]),a}function s9(n,a,s){if(!n)return n;const c={...n};for(const[u,m]of Object.entries(n))typeof m=="object"?c[u]=s9(m,a):m&&a.includes(u)&&(c[u]=s?s(m):kn(m));return c}function Iye(n,a,s){if(!n)return n;const c={...n};for(const[u,m]of Object.entries(n))typeof m=="object"?c[u]=Iye(m,a):m&&!a.includes(u)&&(c[u]=s?s(m):kn(m));return c}function _7e(n){return n&&Iye(n,[])}function FV(n,a){if(!n)return n;const s=s9(n,["deviceId","groupId","guid"]);return s9(s,["label"],c=>Q_(c,a))}function uC(n){return s9(n,["sourceId","deviceId"])}function l9(n,a){return!(!n.config.webrtcForceSdesForS1||!n.config.checkSupportForWebrtc_1_0||n.mediaConfig.simulcastSessionEnabled)||(a?n.config.preferSdesSrtpPstn:n.config.preferSdesSrtp)}function wye(n){return!n||yp.hasUnifiedPlanSupport()}function z2(n){return!!n.configProvider.mediaConfig.simulcastSessionEnabled&&(n.config.isPstnCall?n.configProvider.config.enableDataChannelPstn:n.configProvider.config.enableDataChannel)}function nie(n,a){switch(a){case ke.MEDIA_TYPE.audio:return n.config.allowedAudioCodecs;case ke.MEDIA_TYPE.video:return n.config.allowedVideoCodecs;default:return[]}}function kye(n){return n.map(a=>{const s={codec:a.mimeType.split("/").pop(),rate:a.clockRate};return a.channels&&(s.encoding=a.channels),a.sdpFmtpLine&&(s.fmtpLine=a.sdpFmtpLine),s})}function V2(n){return`${n?.id}:${JSON.stringify(n?.getTracks().map(a=>a.id))}}`}function Rye(n){try{if(Yte.test(n))return Mye(n);if(_ye.test(n))return E7e(n)}catch{return n}return n}function E7e(n){let a,s=n.lastIndexOf("]")+1,c="",u="";s>0?(a=n.substring(0,s),u=n.substring(s)):(a=n,s=a.length);const m=a.lastIndexOf(":");if(a.includes(".")){const b=Mye(a.substring(m+1,s-1-m));c=a.substring(0,m+1)+b}else m<a.length-1||a[m-1]===":"&&a.match(/:/g).length<7?c=a.substring(0,m+1)+"x":a.match(/:/g).length===7&&(c=a.substring(0,m)+"0:x");return c?u?c+"]"+u:(n.substring(0,1)==="["&&(c=c.substring(1)),c):n}function Mye(n){const a=n.substring(0,n.lastIndexOf(".")+1)+"x",s=n.lastIndexOf(":");return s>0?a+n.substring(s):a}function UV(n,a,s){return!(!a&&!s)&&(s?n.config.disableSendersTroughSetParametersVideo&&(s===ke.MODALITY.sharing||s===ke.MODALITY.video):n.config.disableSendersTroughSetParametersVideo&&(a.mediaType==="Video"||a.mediaType==="ScreenShare"))}function c9(n,a){return n.config.disableSendersTroughSetParametersAudio&&a.mediaType==="Audio"}function yui(n){let a=[];return n.forEach(s=>{try{let c=a.find(u=>u.participantId===s.participantId&&u.endpointId===s.endpointId);c||(c={participantId:s.participantId,endpointId:s.endpointId},a.push(c)),s.type!=="audio"&&s.type!=="audioteleconference"||(c.serverMuted=s.serverMuted),c[s.type]=s.direction}catch{a=[]}}),a}var d9=dn,A7e=dn,I7e={maxOutgoingResolution:({settings:n})=>Tui(n),maxParticipantResolutions:({settings:n})=>bui(n),maxIncomingStreams:({settings:n})=>_ui(n),maxSimulcastLayers:({settings:n})=>Eui(n),outgoingVideoLimit:({settings:n,constraints:a})=>Cui(n,a)},w7e=(n,a,s)=>(n.info(`Converting settings to constraints and mapping, [requestedConstraints=${JSON.stringify(s)}], [settings=${JSON.stringify(a)}]`),Sui((0,A7e.cloneDeep)(s),(0,A7e.cloneDeep)(a))),Sui=(n,a)=>Object.keys(n).reduce((s,c)=>{const u=I7e[c]?I7e[c]({constraints:n,settings:a}):void 0;return u&&(s[c]=u),s},{}),bui=n=>n.multiviewResolutionLimits,Tui=n=>n.outgoingVideoLimit?.maxResolution,Cui=(n,a)=>{const s=a?.outgoingVideoLimit;if(!s)return;const{outgoingVideoLimit:c={}}=fs(n);if(typeof s=="number")return c?.maxResolution;const u=Object.keys(s).reduce((m,b)=>{const _=c?.[b];return _&&(m[b]=_),m},{});return Object.keys(u).length?u:void 0},_ui=n=>n.numVideoChannelsGvc,Eui=n=>{const a=n.specCompliantSimulcast,s=a.video?.layerScaleFactors,c=a.sharing?.layerScaleFactors,u=s?.length?Math.max(...s):1,m=c?.length?Math.max(...s):1;return Math.min(u,m)},$2=dn,Aui=n=>{const a=["maxResolution","maxBitrate","maxFramerate"],s=u=>a.includes(u),c=Object.entries(n);return c.length!==0&&c.every(([u,m])=>(0,$2.isNumber)(m)&&s(u))},Iui=n=>!!(0,$2.isNumber)(n)||!!Aui(n)&&!Am(n),wui={maxIncomingStreams:$2.isNumber,maxSimulcastLayers:$2.isNumber,maxOutgoingResolution:$2.isNumber,maxParticipantResolutions:n=>!!ow(n)&&(!!(0,$2.isNumber)(n)||"more"in n&&Object.values(n).every(a=>(0,$2.isNumber)(a))),outgoingVideoLimit:n=>!!ow(n)&&Iui(n)},kui=n=>(n=JSON.parse(JSON.stringify(n)),Object.entries(wui).reduce((a,[s,c])=>(c(n[s])&&(a[s]=n[s]),a),{}));function zV(n,a){if(Array.isArray(n))return a.slice()}var k7e=(n,a)=>{for(const s in a){const c=n[s],u=a[s];n[s]=typeof u=="object"?k7e({...c},u):xg(c,u)}return n},Rui=class{constructor(n,a,s,c,u,m,b){this.logger=n,this.defaultSettings=a,this._mediaConfig=s,this._userAgentConfig=c,this._countryCode=u,this.platformCallConstraintsProvider=m,this.currentCallConstraints=b,this.mergedConstraints={},this.callConstraintsTelemetry=[],this.iceTransportPolicy=ke.ICE_TRANSPORT_POLICY.all,this.validIceTransportPolicies=[ke.ICE_TRANSPORT_POLICY.all,ke.ICE_TRANSPORT_POLICY.relay],this.mergeConstraintsTelemetryWithGlobal(),this.mergedConstraints=this.mergeConstraintsWithGlobal(this.currentCallConstraints),this.settings=this.mergeSettings((0,d9.cloneDeep)(this.defaultSettings))}get config(){return this.settings}get mediaConfig(){return this._mediaConfig}get userAgentConfig(){return this._userAgentConfig}get countryCode(){return this._countryCode}addCallConstraintsTelemetryEvent(n,a){const s={timestamp:new Date().getTime(),type:a,value:n};Mo(this.callConstraintsTelemetry,s,this.config.numCallConstraintsEvents)}getCallConstraintsTelemetry(){return this.callConstraintsTelemetry}getCallConstraints(){return this.mergedConstraints}setCallConstraints(n={}){this.addCallConstraintsTelemetryEvent(n,"requested"),this.logger.safe.debug("Saving new call constraints",JSON.stringify(n));const a=this.transformConstraints(kui(n));return this.logger.safe.debug("Validated call constraints",JSON.stringify(a)),this.mergedConstraints=this.mergeConstraintsWithGlobal(a),this.settings=this.mergeSettings((0,d9.cloneDeep)(this.defaultSettings)),w7e(this.logger,this.settings,a)}getIceTransportPolicy(){return this.settings.iceTransportPolicyForced||this.iceTransportPolicy}setIceTransportPolicy(n){this.validIceTransportPolicies.includes(n)?(this.logger.info(`Setting transport policy to ${this.iceTransportPolicy}`),this.iceTransportPolicy=n):this.logger.debug(`Unknown incoming transport policy, using ${this.iceTransportPolicy}`)}overrideMaxSessionBandwidth(n){return this.defaultSettings.maxBandwidthInKbps!==n&&(this.defaultSettings.maxBandwidthInKbps=n,this.settings.maxBandwidthInKbps=n,this.mediaConfig.maxBandwidthInKbps=n,!0)}transformConstraints(n){const a=(0,d9.cloneDeep)(n);return"maxOutgoingResolution"in a&&(a.outgoingVideoLimit={maxResolution:a.maxOutgoingResolution},delete a.maxOutgoingResolution),typeof a.outgoingVideoLimit=="number"&&(a.outgoingVideoLimit={maxResolution:a.outgoingVideoLimit}),a}mergeConstraintsTelemetryWithGlobal(){this.platformCallConstraintsProvider.callConstraintsTelemetry.forEach(n=>Mo(this.callConstraintsTelemetry,n,this.defaultSettings.numCallConstraintsEvents))}mergeConstraintsWithGlobal(n={}){const a=this.transformConstraints(this.platformCallConstraintsProvider.constraints);if(!Object.keys(a).length)return n;const s=(0,d9.cloneDeep)(n);return k7e(s,a),this.logger.safe.debug(`Merging call constraints ${JSON.stringify(n)} and global constraints ${JSON.stringify(a)}. Result: ${JSON.stringify(s)}`),s}mergeSettings(n){if(!n.enablePlatformCallConstraints||!n.enablePlatformCallConstraintsPerCall)return n;const a=b2(this.logger,n,this.mergedConstraints);return this.logger.safe.info(`Merging settings with platform call constraints: ${nn(a)}`),(0,d9.assign)({},n,a,zV)}},VV=dn,aie=[ke.MODALITY.audio,ke.MODALITY.video,ke.MODALITY.sharing],Mui=class{constructor(n,a,s,c,u){this.peerConnection=a,this.mediaManager=s,this.reinvitelessContext=u,this.entityTransceiverMap=new Map,this.logger=n.createChild("TM"),this.configProvider=c.configProvider,this.isMultiparty=c.config.isConference,this.isPstnCall=c.config.isPstnCall,this.isParkedCall=c.config.isParkedCall,this.numVideoChannels=this.isMultiparty&&this.configProvider.config.numVideoChannelsGvc||1,c.configProvider.config.enableRollbackHandler&&this.mediaManager.setRollbackUpdateHandler(this.handleMediaEntitiesRollback.bind(this))}getTransceivers(){return this.peerConnection.getTransceivers().filter(Pye)}assureTransceivers(n){this.assureNegotiatedOrder(),this.addModalities(n),this.logTransceiversInfo("assureTransceivers"),this.setDirections(n)}syncTransceivers(n){this.syncWithMediaEntities(),this.setDirections(n)}assureNegotiatedOrder(){const n=this.getTransceivers();this.mediaManager.getMediaEntities().forEach(a=>{aie.indexOf(a.getModality())!==-1&&(M7e(this.entityTransceiverMap.get(a),n)||this.createTransceiverForEntity(a))})}addModalities(n){const a=this.mediaManager.isEmpty();this.isMultiparty||!a||this.isPstnCall||(n.video=n.video||"inactive",n.sharing=n.sharing||"inactive"),this.configProvider.config.webrctRemoveVideoModalitiesForPstn&&this.isPstnCall&&!this.isParkedCall&&(delete n.video,delete n.sharing);for(const s of aie){if(this.mediaManager.getMediaEntitiesByModality(s)[0]||!n[s])continue;const c=s===ke.MODALITY.video?this.numVideoChannels:1;(0,VV.times)(c,u=>{const m=this.mediaManager.createMediaEntity(s);m.setExtension("reinviteless",a&&this.reinvitelessContext.maxStreamsForModality[s]>u),this.createTransceiverForEntity(m)})}}createTransceiverForEntity(n){const a=n.getModality();this.logger.safe.info(`createTransceiver: modality=${a}`);const s=a===ke.MODALITY.audio?ke.MEDIA_TYPE.audio:ke.MEDIA_TYPE.video,c=n.getSimulcastContext(),u=this.createTransceiver(s,c);this.setCodecPreferences(u,s,!0),this.setExtensionPreferences(u,a),this.entityTransceiverMap.set(n,u),n.setExtension("unnegotiatedModality",!0)}setCodecPreferences(n,a,s){const c=nie(this.configProvider,a);if(!c?.length||!yp.hasCapabilitiesApi()||this.configProvider.config.filterCodecsInSdp)return;const u=Cc.window.RTCRtpReceiver.getCapabilities(a);if(!u)return;const m=[];if(s)for(const b of c){const _=u.codecs.filter(k=>R7e(b,k));m.push(..._)}else for(const b of u.codecs)c.some(_=>R7e(_,b))&&m.push(b);m.length&&n.setCodecPreferences&&n.setCodecPreferences(m)}setExtensionPreferences(n,a){if(!this.configProvider.config.headerExtensionsToUpdate?.[a])return;if(!n.getHeaderExtensionsToNegotiate||!n.setHeaderExtensionsToNegotiate)return void this.logger.safe.debug("setExtensionPreferences: transceiver.setHeaderExtensionsToNegotiate is not supported");const s=this.configProvider.config.headerExtensionsToUpdate[a],c=n.getHeaderExtensionsToNegotiate();for(const u of c){const m=s.find(b=>b.uri===u.uri);m&&(u.direction=m.direction)}try{n.setHeaderExtensionsToNegotiate(c)}catch(u){this.logger.safe.error(`setExtensionPreferences: transceiver.setHeaderExtensionsToNegotiate failed, err ${nn(u)}`)}}async createSender(n,a,s){const c=await this.associateTrackWithTransceiver(n,a,s);if(!c)throw new Error(`Transceiver for modality=${s} is not found`);const u=this.findEntityForTransceiver(c),m=s!==ke.MODALITY.sharing||u?.getExtension("reinviteless")?ke.MEDIA_STATE.sendReceive:ke.MEDIA_STATE.send;return c.direction=m,this.logger.safe.info(`Replace track completed direction:${c.direction} for transceiver mid=${c.mid}`),c.sender}removeSender(n){this.removeSenderInternal(n,!1)}async removeSenderAsync(n){return this.removeSenderInternal(n,!0)}removeSenderInternal(n,a){if((this.peerConnection.connectionState||this.peerConnection.iceConnectionState)==="closed")return void this.logger.safe.info("Not removing sender from pc, connection is closed");const s=this.getTransceivers().find(b=>b.sender===n);if(!s)throw new Error(`Transceiver for sender with track=${n.track?.id} is not found`);const c=this.findEntityForTransceiver(s),u=!!c?.getExtension("reinviteless");this.logger.safe.info(`Remove sender with track=${n.track?.id} for transceiver mid=${s.mid}, reinviteless=${u}, doAsync=${a}`);let m=Promise.resolve();return u&&a?m=s.sender.replaceTrack(null):this.peerConnection.removeTrack(n),a?m:void 0}createTransceiver(n,a){const s={direction:"inactive"};return this.addSimulcastEnvelopeIfNeeded(s,a),this.peerConnection.addTransceiver(n,s)}addSimulcastEnvelopeIfNeeded(n,a){a?.shouldUseSimulcast()&&(n.sendEncodings=(0,VV.times)(a.config.layerScaleFactors.length,s=>{const c={rid:`${a.ridList[s]}`,scaleResolutionDownBy:a.config.layerScaleFactors[s]};if(this.configProvider.config.specCompliantSimulcast?.disableTilde&&(c.active=!1),a.config.layerScalabilityModes?.length>0){const u=a.config.layerScalabilityModes[s];u!==void 0&&u.length>0?c.scalabilityMode=u:this.logger.safe.warn(`Scalability mode was not set for rid: ${c.rid}`)}return this.logger.safe.debug(`Added layer ${s} with rid: ${c.rid} SF: ${c.scaleResolutionDownBy} SM: ${c.scalabilityMode}`),c}))}async associateTrackWithTransceiver(n,a,s){const c=this.findAvailableTransceiverToSend(s);if(c){this.logger.safe.info(`Associate track=${n?.id} (${s}) with existing transceiver mid=${c.mid}`);try{if(this.isMultiparty&&UV(this.configProvider,void 0,s)){this.logger.safe.info(`Disabling encodings for transceiver mid=${c.mid}`);const u=c.sender.getParameters();u.encodings.forEach(m=>m.active=!1),await c.sender.setParameters(u)}await c.sender.replaceTrack(n),this.configProvider.config.useSetStreamsForSender&&c.sender.setStreams&&c.sender.setStreams(a)}catch(u){throw this.logger.safe.error(`replaceTrack failed, err ${JSON.stringify(u)}`),u}return c}return null}syncWithMediaEntities(){const n=this.getTransceivers();this.mediaManager.getMediaEntities().forEach(a=>{let s=this.entityTransceiverMap.get(a);s=M7e(s,n)?s:n.find(c=>c.mid===a.getMid()),this.entityTransceiverMap.set(a,s)}),this.logTransceiversInfo("syncWithMediaEntities")}getTransceiversByModality(n){return this.mediaManager.getMediaEntitiesByModality(n).map(a=>this.entityTransceiverMap.get(a)).filter(Pye)}setDirections(n){const a=!$g(n);for(const s of aie)for(const[c,u]of this.getTransceiversByModality(s).entries()){if(this.findEntityForTransceiver(u)?.getExtension("reinviteless")&&a){u.direction="sendrecv";continue}const b=n[s]||ke.MEDIA_STATE.inactive;u.direction=c===0&&u.currentDirection?b:Pui(b)}this.logTransceiversInfo("setDirections")}handleMediaEntitiesRollback(n,a){n.forEach(s=>{const c=this.entityTransceiverMap.get(s),u=a.find(m=>m.getMid()===s.getMid());this.entityTransceiverMap.set(u,c)}),this.logTransceiversInfo("handleMediaEntitiesRollback")}findAvailableTransceiverToSend(n){const a=this.mediaManager.getMediaEntitiesByModality(n)[0];return this.entityTransceiverMap.get(a)}findEntityForTransceiver(n){for(const[a,s]of this.entityTransceiverMap)if(s===n)return a}logTransceiversInfo(n){let a=`${n}: transceivers details:`;for(const s of aie){const c=this.getTransceiversByModality(s);a+=` ${s}(${c.length}) [${c.map(u=>`mid=${u.mid}, direction=${u.direction}`).join(";")}]`}this.logger.safe.debug(a)}};function R7e(n,a){return!(!(0,VV.isUndefined)(n.channels)&&n.channels!==a.channels||!(0,VV.isUndefined)(n.clockRate)&&n.clockRate!==a.clockRate||!(0,VV.isUndefined)(n.mimeType)&&n.mimeType.toLowerCase()!==a.mimeType.toLowerCase()||!(0,VV.isUndefined)(n.sdpFmtpLine)&&a.sdpFmtpLine.toLowerCase().indexOf(n.sdpFmtpLine.toLowerCase())===-1)}function Pui(n){let a=n;return Ur(n)&&(a=o9(n)),a||ke.MEDIA_STATE.inactive}function Pye(n){return n&&n.direction!=="stopped"&&!n.stopped}function M7e(n,a){return Pye(n)&&a.indexOf(n)!==-1}var Dui=class extends jr{constructor(n,a,s){super(),this.configProvider=n,this.workerProvider=a,this.logger=s,this.transformsCollections=new Map}async initialize(){return this.configProvider.config.useInsertableStreams&&this.workerProvider&&yp.hasEncodedStreamsApi()&&(this.worker=new ehi(this.workerProvider,this.logger)),this.worker?this.worker.initialize():Promise.resolve()}initTransformsCollection(n,a,s){const c=yp.hasScriptTransformApi()||this.workerProvider;if(!this.configProvider.config.useInsertableStreams||!yp.hasEncodedStreamsApi()||c&&!this.isWorkerLoaded()||n.track===null)return null;if(!this.transformsCollections.has(n)){const m=this.worker?new Oui(this.worker,n):new Lui(n);this.transformsCollections.set(n,{collection:m,mediaType:s,objType:a})}const u=this.transformsCollections.get(n);return this.event("onTransformsCollectionCreated").raise(u),u.collection}clearTransformsCollection(n){const a=this.transformsCollections.get(n);a&&(this.event("onTransformsCollectionCleared").raise(a),a.collection.clearTransforms())}dispose(){for(const n of this.transformsCollections.values())this.event("onTransformsCollectionCleared").raise(n),n.collection.clearTransforms();this.transformsCollections.clear(),this.worker?.dispose(),super.dispose()}isWorkerLoaded(){return!!this.worker?.isWorkerLoaded()}},Lui=class{constructor(n){const{readable:a,writable:s}=n.createEncodedStreams();this.streamTransformer=new lhi(a,s)}addTransform(n){n.createBaseInstance(this.streamTransformer)}clearTransforms(){this.streamTransformer.clearTransforms()}},Oui=class{constructor(n,a){if(this.workerHandler=n,this.clientId=a.track.id,yp.hasScriptTransformApi())return void(a.transform=new RTCRtpScriptTransform(this.workerHandler.worker,{clientId:this.clientId}));const{readable:s,writable:c}=a.createEncodedStreams(),u=[s,c];this.workerHandler.sendTransformCommand(this.clientId,{operation:"init",readable:s,writable:c},u)}addTransform(n){n.createWorkerInstance(this.workerHandler,this.clientId)}clearTransforms(){this.workerHandler.sendTransformCommand(this.clientId,{operation:"clear"})}},Nui=class{constructor(n,a=!1){this.logger=n,this.disabled=a,this.audioContext=new AudioContext,this.destination=this.audioContext.createMediaStreamDestination()}get stream(){return this.destination.stream}isSingleInputStream(){return this.mixerImp?.mixerType===0}dispose(){this.audioContext.close(),this.audioContext=null}stopMixing(){this.disabled=!0,this.mixerImp?.reset()}startMixing(n){this.disabled=!1,this.mixerImp?.setupMixer(this.audioContext,this.destination,n)}setMixerType(n,a){this.mixerImp?.mixerType!==n&&(this.mixerImp?.reset(),this.mixerImp=this.createMixer(n),this.disabled||this.mixerImp.setupMixer(this.audioContext,this.destination,a))}setStreamSources(n){this.disabled||this.mixerImp.setStreamSources?.(n)}setParticipantSpatialAudioPositions(n){this.mixerImp.setParticipantSpatialAudioPositions?.(n)}createMixer(n){switch(n){case 0:return new Bui;case 1:return new Fui(this.logger.createChild("MixingStreamsMixer"));case-1:return new xui;default:throw new Error(`unknown mixer type: ${n}`)}}},xui=class{constructor(){this.mixerType=-1}reset(){}setupMixer(n,a,s){}},Bui=class{constructor(){this.mixerType=0}reset(){this.sourceNode.disconnect()}setupMixer(n,a,s){this.sourceNode=n.createMediaStreamSource(s[0]),this.sourceNode.connect(a)}},Fui=class{constructor(n){this.logger=n,this.sourcePositions=new Map,this.sourceNodes=[],this.pannerNodes=[],this.mixerType=1}reset(){this.logger.safe.info("resetting SpatialMultiStreamMixer");for(const n of this.sourceNodes)n.disconnect();this.sourceNodes=[];for(const n of this.pannerNodes)n.disconnect();this.pannerNodes=[]}setupMixer(n,a,s){(this.sourceNodes.length||this.pannerNodes.length)&&this.reset();for(const c of s){const u=n.createMediaStreamSource(c),m=new PannerNode(n,{panningModel:"HRTF"});u.connect(m),m.connect(a),this.sourceNodes.push(u),this.pannerNodes.push(m)}this.logger.safe.info(`setupMixer is done for ${s.length} streams.`)}setStreamSources(n){for(let a=0;a<n.length;a++)this.setStreamPosition(a,n[a])}setParticipantSpatialAudioPositions(n){this.sourcePositions=new Map(n.map(a=>[a.sourceId,a]))}setStreamPosition(n,a){const s=this.sourcePositions.get(a)??{x:0,y:0},c=this.pannerNodes[n];c?(c.positionX.value=s.x,c.positionY.value=s.y):this.logger.warn(`panner node for stream ${n} is not found`)}},Uui=class extends jr{constructor(n){super(),this.logger=n,this.mediaStreams=[],this.cnStream=null,this.isConfigured=!1,this.isNegotiated=!1,this.activeCodec="None"}get streams(){return this.mediaStreams}get comfortNoiseStream(){return this.cnStream}get configured(){return this.isConfigured}get active(){return this.isNegotiated}get codec(){return this.activeCodec}setupStreams(n,a){this.logger.safe.debug(`setup ${n} streams with extra Comfort Noise stream: ${a}`),this.mediaStreams=[];const s=[];for(;n--;){const u=new MediaStreamTrackGenerator({kind:"audio"});s.push(u),this.streams.push(new MediaStream([u]))}const c=a?new MediaStreamTrackGenerator({kind:"audio"}):null;return this.cnStream=c?new MediaStream([c]):null,this.event("onStreamsChanged").raise(),{streams:s.map(u=>u.writable),cnStream:c?.writable}}setStreamSources(n){this.isNegotiated&&this.event("onStreamSourcesUpdated").raise(n)}setConfiguredState(n){this.isConfigured!==n&&(this.isConfigured=n,this.event("onConfiguredStateChanged").raise(this.isConfigured))}setNegotiatedState(n){this.isNegotiated!==n&&(this.isNegotiated=n,this.event("onActiveStateChanged").raise(this.isNegotiated))}setDetectedCodec(n){this.activeCodec!==n&&(this.activeCodec=n,this.event("onActiveCodecChanged").raise(this.activeCodec))}},zui="encodedStreamsWorklet",Vui=class TQe{constructor(){this.context=new AudioContext({sampleRate:5e4})}dispose(){this.context.close()}createTimerPort(){return new AudioWorkletNode(this.context,zui,{numberOfInputs:0,numberOfOutputs:1,outputChannelCount:[1]}).port}static async create(a){const s=new TQe;return await s.context.audioWorklet.addModule(a),s}},$ui=0,Dye={MUCHv2:{CODEC:{NAME:"x-much2",RATE:48e3,ENCODING:2},SUBSTITUTION:{NAME:"L16",RATE:48e3,ENCODING:2},PT:113},SatinFB:{CODEC:{NAME:"SATINFB",RATE:48e3,ENCODING:2},SUBSTITUTION:{NAME:"L16",RATE:48e3,ENCODING:2},PT:109}},rie=class{constructor(n,a,s,c){this.worker=n,this.clientId=a,this.transformType=s,this.listener=c,this.worker.subscribeClient(this.clientId,this.transformType,u=>this.processMsg(u)),this.worker.sendTransformCommand(this.clientId,{operation:"add",transformType:this.transformType})}dispose(){this.worker.unsubscribeClient(this.clientId),this.worker.sendTransformCommand(this.clientId,{operation:"clear"})}processMsg(n){if(this.listener&&n.name in this.listener)return this.listener[n.name].apply(this.listener,n.args);throw`unexpected message received for transform type ${this.transformType}: ${JSON.stringify(n)}`}};function Hui(n,a,s){return new jui(n,a,s)}var jui=class extends rie{constructor(n,a,s){super(n,a,2,s)}init(n,a){this.worker.sendTransformCommand(this.clientId,{operation:"invoke",func:{transformType:this.transformType,name:"init",args:[n,a]}})}setTimerWorkletPort(n){this.worker.sendTransformCommand(this.clientId,{operation:"invoke",func:{transformType:this.transformType,name:"setTimerWorkletPort",args:[n]}},[n])}setCodec(n,a){this.worker.sendTransformCommand(this.clientId,{operation:"invoke",func:{transformType:this.transformType,name:"setCodec",args:[n,a]}})}passWriteableStreams(n,a){const s=n.concat(a);this.worker.sendTransformCommand(this.clientId,{operation:"invoke",func:{transformType:this.transformType,name:"passWriteableStreams",args:[n,a]}},s)}setAvailableStreams(n){this.worker.sendTransformCommand(this.clientId,{operation:"invoke",func:{transformType:this.transformType,name:"setAvailableStreams",args:[n]}})}setRecvPayloads(n){this.worker.sendTransformCommand(this.clientId,{operation:"invoke",func:{transformType:this.transformType,name:"setRecvPayloads",args:[n]}})}debugLogging(n){this.worker.sendTransformCommand(this.clientId,{operation:"invoke",func:{transformType:this.transformType,name:"debugLogging",args:[n]}})}sendApiRecordingData(){this.worker.sendTransformCommand(this.clientId,{operation:"invoke",func:{transformType:this.transformType,name:"sendApiRecordingData",args:[]}})}},Gui=class extends jr{constructor(n,a,s,c){super(),this.logger=n,this.maxNumOfStreamsFactor=s,this.statsProvider=new Wui,this.contributingSources=[],this.unmixedAudioProvider=new Uui(this.logger),this.codec="None",this.recvPayloads=[],this.initCompleted=!1,this.enabledApiRecording=!1,this.timerWorkletNode=null;try{this.enabledApiRecording=localStorage.getItem("enableApiRecording")==="true"}catch{}this.streamMixer=new Nui(this.logger,c),this.unmixedAudioProvider.setConfiguredState(!!a.mediaConfig.spatialAudioEnabled),this.wasmHealerPullStrategy=a.config.useInsertableStreams?.audioWasmCodec?.wasmHealerPullStrategy||-1,this.injectWebMA()}get stream(){return this.streamMixer.stream}dispose(){super.dispose(),this.streamMixer.dispose(),this.imp?.dispose(),this.timerWorkletNode?.then(n=>n.dispose()),this.timerWorkletNode=null,this.removeWebMA()}activateTransform(n){this.logger.safe.debug("Activating WASM decoder transform"),n.addTransform(this)}deactivateTransform(){this.logger.safe.debug("Deactivating WASM decoder transform"),this.imp.dispose(),this.imp=null,this.initCompleted=!1,this.codec="None",this.streamMixer.setMixerType(-1,[])}createBaseInstance(n){this.logger.warn("WASM decoder could only be instantiated in worker")}createWorkerInstance(n,a){this.logger.info(`Creating TimerWorkletNode from url: ${n.timerWorkletUrl}`),this.timerWorkletNode=Vui.create(n.timerWorkletUrl),this.imp=Hui(n,a,this),this.imp.init(this.enabledApiRecording,this.wasmHealerPullStrategy)}setCodec(n){if(this.logger.safe.debug(`Setting codec to ${n}`),!this.initCompleted)return this.logger.safe.debug("Decoder is not initialized yet, postponing codec setting"),void(this.codec=n);this.codec!==n&&(this.codec=n,this.setCodecInternal())}setRecvPayloads(n){this.recvPayloads=n,this.initCompleted?this.imp.setRecvPayloads(n):this.logger.safe.debug("Decoder is not initialized yet, postponing Recv payload setting")}negotiationCompleted(n){this.logger.safe.debug(`Negotiation completed, negotiated=${n}`),this.unmixedAudioProvider.setNegotiatedState(n),n||(this.codec="None",this.imp?.setCodec(this.codec,this.streamMixer.isSingleInputStream()))}setParticipantSpatialAudioPositions(n){this.streamMixer.setParticipantSpatialAudioPositions(n)}disableStreamsMixer(n){n?this.streamMixer.stopMixing():this.streamMixer.startMixing(this.unmixedAudioProvider.streams.concat(this.unmixedAudioProvider.comfortNoiseStream??[]))}getStatsProvider(){return this.statsProvider}getUnmixedAudioProvider(){return this.unmixedAudioProvider}configureSpatialAudio(n){this.unmixedAudioProvider.setConfiguredState(n)}async storeApiRecording(){if(this.enabledApiRecording&&this.initCompleted)return this.recordingCompletePromise?.resolve(),this.recordingCompletePromise=new Pi,this.imp.sendApiRecordingData(),this.recordingCompletePromise.promise}initDone(n,a){if(this.healerCapabilities=a,this.logger.safe.info(`Init done, errorCode=${n}`),n!==0)return void this.event("initFailed").raise(n);this.logger.safe.info(`healerCapabilities=${JSON.stringify(a)}`),this.initCompleted=!0;const s=Math.floor(this.healerCapabilities.maxNumStreamsPerPacket*this.maxNumOfStreamsFactor),c=this.unmixedAudioProvider.setupStreams(s,!0);this.imp.passWriteableStreams(c.streams,c.cnStream),this.setCodecInternal(),this.imp.setRecvPayloads(this.recvPayloads)}requestTimerWorkletPort(){this.timerWorkletNode?.then(n=>this.imp?.setTimerWorkletPort(n.createTimerPort()))}usedDecoderChanged(n){this.logger.safe.info(`Used decoder changed to custom=${n}, configured codec=${this.codec}`),this.event("usedDecoderChanged").raise(n),this.unmixedAudioProvider.setDetectedCodec(this.codec)}packetReceived(n,a,s,c){this.statsProvider.ssrc=a,this.statsProvider.addPushStats(n,c),this.contributingSources.length===s.length&&this.contributingSources.every((u,m)=>u===s[m])||(this.contributingSources=s,this.event("contributingSourcesChanged").raise(s))}newDataWrittenToStreams(n){const a=Array.from(new Int32Array(n));this.unmixedAudioProvider.setStreamSources(a),this.streamMixer.setStreamSources(a);const s=a.reduce((c,u,m)=>(u===$ui&&c.push(m),c),[]);this.imp?.setAvailableStreams(s)}packetDecoded(n,a,s){this.statsProvider.addPullStats(n,a,s,s.extra.samplingRatekHz*this.healerCapabilities.frameLengthMs)}apiRecordingAvailable(n,a,s){if(this.logger.safe.debug(`API recording available: errorCode=${n}, name=${a}, buffer length=${s.byteLength}`),this.recordingCompletePromise?.resolve(),s.byteLength===0)return;const c=new Blob([s],{type:"application/octet-stream"}),u=URL.createObjectURL(c),m=document.createElement("a");m.href=u,m.download=a,m.click()}setCodecInternal(){this.streamMixer.setMixerType(qui(this.codec),this.unmixedAudioProvider.streams.concat(this.unmixedAudioProvider.comfortNoiseStream??[])),this.imp.setCodec(this.codec,this.streamMixer.isSingleInputStream()),this.statsProvider.codecName=this.codec}injectWebMA(){const n=window.webMA;n&&(n.wasmDecoder={debugLogging:a=>this.imp?.debugLogging(a),sendApiRecordingData:()=>this.imp?.sendApiRecordingData()})}removeWebMA(){const n=window.webMA;n&&delete n.wasmDecoder}};function qui(n){switch(n){case"SatinFB":return 0;case"MUCHv2":return 1;case"None":return-1;default:throw new Error(`unknown codec: ${n}`)}}var Wui=class{constructor(){this.customHealerStats={numSamplesPerFrame:0,FECPayloadDecodedSamples:0,concealSamples:0,stretchSamples:0,healedSamples:0,decodedSamples:0,redPacketsCount:0,pushProcessingTimes:{},pullProcessingTimes:{},pullProcessingTimePerStreamNumber:{},pullTimings:{},pullNumOfStreamsCounter:{}},this.inboudStats={silentConcealedSamples:0,concealedSamples:0,totalSamplesReceived:0,audioLevel:0,jitterBufferDelay:0,jitterBufferEmittedCount:0},this.decoderStats={pushCount:0,pushErrCount:0,pullCount:0,pullErrCount:0},this.packetPushProccesingTimes=new u9(0,1e3),this.packetPullProccesingTimes=new u9(0,1e3),this.numOfStreamsCounter=new u9(0,10),this.pullProcessingTimePerStreamNumber={},this.packetPullTimings=new u9(0,1e3)}get codecName(){return this.codec}set codecName(n){this.codec=n}addPushStats(n,a){this.decoderStats.pushCount++,this.decoderStats.pushErrCount+=n!==0?1:0,this.inboudStats.jitterBufferDelay+=a.webrtc.jitterBufferDelay,this.customHealerStats.packetDurationInMs=a.extra.packetDurationInMs,this.packetPushProccesingTimes.addSample(a.extra.processingTime),this.customHealerStats.cnpPushCount=a.extra.totalCountCNPackets,this.customHealerStats.redPacketsCount+=a.extra.redundancyTimestampOffset!==0?1:0}addPullStats(n,a,s,c){var u;this.decoderStats.pullCount++,this.decoderStats.pullErrCount+=n!==0?1:0,this.inboudStats.audioLevel=s.webrtc.audioLevel,this.inboudStats.totalAudioEnergy=s.webrtc.totalAudioEnergy,this.inboudStats.jitterBufferEmittedCount=s.webrtc.jitterBufferEmittedCount,this.inboudStats.totalSamplesReceived=s.webrtc.totalSamplesReceived,this.inboudStats.concealedSamples=s.webrtc.concealedSamples,this.inboudStats.silentConcealedSamples=s.webrtc.silentConcealedSamples,this.numOfStreamsCounter.addSample(a),this.customHealerStats.FECPayloadDecodedSamples=s.extra.FECPayloadDecodedSamples,this.customHealerStats.numSamplesPerFrame=c,this.customHealerStats.pullAdspPayloadType=s.extra.pullAdspPayloadType,this.customHealerStats.concealSamples=s.extra.concealSamples,this.customHealerStats.stretchSamples=s.extra.stretchSamples,this.customHealerStats.healedSamples=s.extra.healedSamples,this.customHealerStats.decodedSamples=s.extra.decodeSamples,this.packetPullProccesingTimes.addSample(s.extra.processingTime),this.customHealerStats.cnpPullCount=s.extra.totalCountCNGeneratedFrames,this.customHealerStats.cngSamples=s.extra.cngSamples,(u=this.pullProcessingTimePerStreamNumber)[a]??(u[a]=new u9(0,200)),this.pullProcessingTimePerStreamNumber[a].addSample(s.extra.processingTime),this.packetPullTimings.addSample(s.pullTiming)}getWebRtcCompatibleStats(){return this.inboudStats}getWasmStats(){this.customHealerStats.pushProcessingTimes=this.packetPushProccesingTimes.getFrequencies(),this.customHealerStats.pullProcessingTimes=this.packetPullProccesingTimes.getFrequencies(),this.customHealerStats.pullNumOfStreamsCounter=this.numOfStreamsCounter.getFrequencies(),this.customHealerStats.pullTimings=this.packetPullTimings.getFrequencies();for(const n of Object.keys(this.pullProcessingTimePerStreamNumber))this.customHealerStats.pullProcessingTimePerStreamNumber[n]=this.pullProcessingTimePerStreamNumber[n].getFrequencies();return this.customHealerStats}getDecoderStats(){return this.decoderStats}},u9=class{constructor(n,a){this.minSample=n,this.maxSample=a,this.frequencyDict={}}addSample(n){if(n===void 0)return;const a=Math.min(this.maxSample,Math.max(this.minSample,n));this.frequencyDict[a]=(this.frequencyDict[a]??0)+1}getFrequencies(){return{...this.frequencyDict}}};function Kui(n,a,s){return new Jui(n,a,s)}var Jui=class extends rie{constructor(n,a,s){super(n,a,3,s)}init(n){this.worker.sendTransformCommand(this.clientId,{operation:"invoke",func:{transformType:this.transformType,name:"init",args:[n]}})}setCodec(n){this.worker.sendTransformCommand(this.clientId,{operation:"invoke",func:{transformType:this.transformType,name:"setCodec",args:[n]}})}debugLogging(n){this.worker.sendTransformCommand(this.clientId,{operation:"invoke",func:{transformType:this.transformType,name:"debugLogging",args:[n]}})}},P7e=["SatinFB"],Yui=class extends jr{constructor(n){super(),this.logger=n,this.codec="None",this.injectWebMA()}getCodecName(){return this.codec}dispose(){super.dispose(),this.imp?.dispose(),this.removeWebMA()}activateTransform(n){this.logger.safe.debug("Activating WASM encoder transform"),n.addTransform(this)}deactivateTransform(){this.logger.safe.debug("Deactivating WASM encoder transform"),this.imp.dispose(),this.imp=null,this.encodersInitCodes=void 0,this.codec="None"}createBaseInstance(n){this.logger.warn("WASM encoder could only be instantiated in worker")}createWorkerInstance(n,a){this.imp=Kui(n,a,this),this.imp.init(P7e)}setCodec(n){if(this.logger.safe.debug(`Setting codec to ${n}`),!this.encodersInitCodes)return this.logger.safe.debug("Encoder is not initialized yet, postponing codec setting"),void(this.codec=n);this.codec!==n&&(this.codec=n,this.setCodecInternal())}isCodecAllowed(n){return P7e.includes(n)}negotiationCompleted(n){n||(this.codec="None",this.imp?.setCodec(this.codec))}initDone(n){this.logger.safe.info(`initDone: ${JSON.stringify(n)}`),this.encodersInitCodes=n,this.setCodecInternal()}packetEncoded(n){n!==0&&this.logger.safe.info(`encode failed: ${n}`)}setCodecInternal(){const n=this.encodersInitCodes[this.codec]??-2147024809;if(this.codec!=="None"&&n!==0)return this.logger.safe.error(`WASM encoder is failed to init codec ${this.codec}, err code: ${n}`),void this.event("initCodecFailed").raise(n);this.event("codecChanged").raise(this.codec),this.imp.setCodec(this.codec)}injectWebMA(){const n=window.webMA;n&&(n.wasmEncoder={debugLogging:a=>this.imp?.debugLogging(a)})}removeWebMA(){const n=window.webMA;n&&delete n.wasmEncoder}},Qui=dn,Zui=class extends jr{constructor(n,a,s){super(),this.encStreamsManager=n,this.logger=a,this.configProvider=s,this.isEnabled=!1,this.sessionStats=new Xui,this.subs=[],this.codecContext=this.configProvider.mediaConfig.audioCodecContext,this.codecConfig=this.configProvider.config.useInsertableStreams?.audioWasmCodec}get decoder(){return this.decoderImp}get encoder(){return this.encoderImp}init(n,a){if(!n||!this.codecContext||!this.codecConfig?.enable)return;this.isEnabled=!0;const s=this.codecConfig.maxNumOfStreamsFactor||1;this.decoderImp=new Gui(this.logger.createChild("AudioWasmDecoder"),this.configProvider,s,a),this.codecConfig.enableSend&&(this.encoderImp=new Yui(this.logger.createChild("AudioWasmEncoder"))),this.subscribeToStreamManagerEvents(this.encStreamsManager),this.subscribeToCodecsEvents()}dispose(){super.dispose(),this.unsubscribeFromEvents(),this.decoderImp?.dispose(),this.encoderImp?.dispose()}getSessionEvents(){return this.sessionStats.getSessionEvents()}prepareForNegotiation(n){if(!this.isEnabled)return;const a=this.decoderImp?.getUnmixedAudioProvider()?.configured?"MUCHv2":this.codecConfig.codec||"None";this.codecContext.codec!==a&&(this.codecContext.initSendFailed=!1),this.codecContext.lastUsedCodec=this.codecContext.codec,this.codecContext.codec=a,this.codecContext.enabledLocally=!this.codecContext.initFailed&&a!=="None",this.codecContext.enabledForSend=this.codecContext.enabledLocally&&!this.codecContext.initSendFailed&&!!this.codecConfig?.enableSend&&this.encoder?.isCodecAllowed(a),this.logger.safe.info(`Audio codec state: context=${JSON.stringify(this.codecContext)}`),this.codecContext.initFailed||!n&&this.codecContext.disabledRemotely||(this.sessionStats.toggleState(a!=="None"),this.decoderImp?.setCodec(a),this.encoderImp?.setCodec(this.codecContext.enabledForSend?a:"None"))}negotiationCompleted(){if(!this.isEnabled)return!1;const n=this.codecContext.enabledLocally&&!this.codecContext.disabledRemotely;return this.decoderImp?.negotiationCompleted(n),this.encoderImp?.negotiationCompleted(n),this.sessionStats.negotiationCompleted(n,this.codecContext.enabledForSend),n}configureSpatialAudio(n,a){return!!this.isEnabled&&(this.decoderImp?.configureSpatialAudio(n),(n&&this.codecContext.codec!=="MUCHv2"||!n&&this.codecContext.codec==="MUCHv2")&&this.event("negotiationNeeded").raise(a),!0)}subscribeToStreamManagerEvents(n){this.subs.push(n.on("onTransformsCollectionCreated",a=>this.handleTransformsCollectionCreated(a)),n.on("onTransformsCollectionCleared",a=>this.handleTransformsCollectionCleared(a)))}handleTransformsCollectionCreated(n){n.mediaType==="Audio"&&(this.decoderImp&&n.objType==="Receiver"?this.decoderImp.activateTransform(n.collection):this.encoderImp&&n.objType==="Sender"&&this.encoderImp.activateTransform(n.collection))}handleTransformsCollectionCleared(n){n.mediaType==="Audio"&&(this.decoderImp&&n.objType==="Receiver"?this.decoderImp.deactivateTransform():this.encoderImp&&n.objType==="Sender"&&this.encoderImp.deactivateTransform())}subscribeToCodecsEvents(){this.decoderImp&&this.subs.push(this.decoderImp.on("initFailed",n=>this.handleCodecInitFailed("decoder",n))),this.encoderImp&&this.subs.push(this.encoderImp.on("initCodecFailed",n=>this.handleCodecInitFailed("encoder",n)))}unsubscribeFromEvents(){this.subs.forEach(n=>n.dispose()),this.subs=[]}handleCodecInitFailed(n,a){n==="decoder"?this.codecContext.initFailed=!0:this.codecContext.initSendFailed=!0;const s=hi();this.logger.safe.warn(`[${s}] Audio ${n} init failed ${a}`),this.sessionStats.initFailed(a,n),this.event("negotiationNeeded").raise(s)}},D7e=class CQe{constructor(){this.sessionEvents={negotiationAttempts:[],toggleCount:0,negotiatedCount:0,failedNegotiationCount:0,decoderInitError:0,encoderInitError:0}}toggleState(a){this.sessionEvents.toggleCount++,this.inProgressNegotiation={ts:Date.now(),enabled:a,negotiated:!1,sendEnabled:!1},Mo(this.sessionEvents.negotiationAttempts,this.inProgressNegotiation,CQe.maxStoreNegotiations)}negotiationCompleted(a,s){this.inProgressNegotiation&&(this.sessionEvents.negotiatedCount+=a?1:0,this.sessionEvents.failedNegotiationCount+=this.inProgressNegotiation.enabled&&!a?1:0,this.inProgressNegotiation.negotiated=a,this.inProgressNegotiation.sendEnabled=s,this.inProgressNegotiation=void 0)}initFailed(a,s){s==="decoder"?this.sessionEvents.decoderInitError=a:this.sessionEvents.encoderInitError=a}getSessionEvents(){return(0,Qui.clone)(this.sessionEvents)}};D7e.maxStoreNegotiations=5;var Xui=D7e,ehi=class{constructor(n,a){this.workerProvider=n,this.logger=a,this.clientsMap=new Map,this.loaded=!1,this.initDefer=new Pi;try{this.worker=n.getWorker(this.logger),this.worker.onmessage=s=>this.handleEvent(s.data),this.worker.onerror=s=>{this.logger.safe.error(`error inside worker: ${s.message}`),this.initDefer.resolve()}}catch{this.logger.safe.error("failed to create worker"),this.initDefer.resolve()}}get timerWorkletUrl(){return this.workerProvider.getTimerWorkletUrl()}initialize(){return Promise.race([this.initDefer.promise,Br(5e3).then(()=>{this.loaded??this.logger.safe.warn("worker initialization timeout")})])}isWorkerLoaded(){return this.loaded}sendTransformCommand(n,a,s=[]){const c={type:"transform",clientId:n,payload:a};this.worker?.postMessage(c,s)}subscribeClient(n,a,s){const c=this.clientsMap.get(n)??new Map;c.set(a,s),this.clientsMap.set(n,c)}unsubscribeClient(n){this.clientsMap.delete(n)}dispose(){const n={type:"generic",payload:{operation:"dispose"}};this.worker?.postMessage(n),this.worker?.terminate()}handleEvent(n){switch(n.type){case"init":this.initDefer.resolve(),this.loaded=!0,this.logger.safe.info("worker initialized");break;case"transform":{const a=this.clientsMap.get(n.payload.clientId),s=a?.get(n.payload.event.transformType);s?s(n.payload.event):this.logger.safe.error(`received event for unknown Client ${n.payload.clientId} or transformType ${n.payload.event.transformType}: ${n.payload.event.name}`)}break;case"log":switch(n.level){case"debug":this.logger.safe.debug(n.msg);break;case"info":this.logger.safe.info(n.msg);break;case"warn":this.logger.safe.warn(n.msg);break;case"error":this.logger.safe.error(n.msg);break;default:this.logger.safe.error(`unknown log level ${n.level}`)}break;default:this.logger.safe.error(`received unsupported event from worker ${n.type}`)}}},thi=7,ihi=31,nhi=class{constructor(n){this.logger=n,this.transformType=0}transform(n){return this.processChunk(n),n}dispose(){}getStartCodeSize(n){const a=n.getUint32(0);return a===1?4:(4294967040&a)==256?3:0}processChunk(n){if(n.type!=="key")return;const a=this.isH264KeyFrame(n.data)?`${this.getH264Profile(n.data)}(H264)`:"unknown";this.logger.info(`keyframe metadata: ${JSON.stringify(n.getMetadata())}, profile=${a}`)}isH264KeyFrame(n){if(n.byteLength<7)return!1;const a=new DataView(n),s=this.getStartCodeSize(a);return!!s&&(a.getUint8(s)&ihi)===thi}getH264Profile(n){const a=new DataView(n),s=this.getStartCodeSize(a);return(16777215&a.getUint32(s)).toString(16)}},ahi=class extends rie{constructor(n,a){super(n,a,0,void 0)}},L7e=class{constructor(n){this.logger=n}createBaseInstance(n){this.imp=new nhi(this.logger.safe),n.addTransform(this.imp)}createWorkerInstance(n,a){this.imp=new ahi(n,a)}},rhi=class{constructor(){this.transformType=1,this.muted=!1}transform(n){return this.muted?null:n}mute(n){this.muted=n}dispose(){}},ohi=class extends rie{constructor(n,a){super(n,a,1,void 0)}mute(n){this.worker.sendTransformCommand(this.clientId,{operation:"invoke",func:{transformType:this.transformType,name:"mute",args:[n]}})}},shi=class{constructor(n){this.logger=n}createBaseInstance(n){this.imp=new rhi,n.addTransform(this.imp)}createWorkerInstance(n,a){this.imp=new ohi(n,a)}mute(n){this.logger.safe.info(`Dropping audio chunks: ${n}`),this.imp.mute(n)}},lhi=class{constructor(n,a){this.transforms=[];const s=new TransformStream({transform:(c,u)=>{let m=c;for(const b of this.transforms)if(m=b.transform(m),!m)return;u.enqueue(m)}});n.pipeThrough(s).pipeTo(a)}clearTransforms(){for(const n of this.transforms)n.dispose();this.transforms=[]}addTransform(n){this.transforms.push(n)}getTransform(n){return this.transforms.find(a=>a.transformType===n)}},chi=class extends Qs{constructor(){super(),this.subs=[]}get streams(){return this.sessionAudioProvider?.streams??[]}get comfortNoiseStream(){return this.sessionAudioProvider?.comfortNoiseStream??null}get configured(){return this.sessionAudioProvider?.configured??!1}get active(){return this.sessionAudioProvider?.active??!1}get codec(){return this.sessionAudioProvider?.codec??"None"}setSessionStreamsProvider(n){this.unsubscribeFromStreamEvents(),this.sessionAudioProvider=n,this.subscribeForStreamEvents(),this.event("onStreamsChanged").raise(),this.event("onActiveStateChanged").raise(this.active)}dispose(){super.dispose(),this.unsubscribeFromStreamEvents()}subscribeForStreamEvents(){this.sessionAudioProvider&&this.subs.push(this.sessionAudioProvider.on("onStreamsChanged",()=>this.event("onStreamsChanged").raise()),this.sessionAudioProvider.on("onStreamSourcesUpdated",n=>this.event("onStreamSourcesUpdated").raise(n)),this.sessionAudioProvider.on("onConfiguredStateChanged",n=>this.event("onConfiguredStateChanged").raise(n)),this.sessionAudioProvider.on("onActiveStateChanged",n=>this.event("onActiveStateChanged").raise(n)),this.sessionAudioProvider.on("onActiveCodecChanged",n=>this.event("onActiveCodecChanged").raise(n)))}unsubscribeFromStreamEvents(){this.subs.forEach(n=>n.dispose()),this.subs=[]}},dhi=class extends Qs{constructor(n,a,s,c,u){super(),this.allowVirtualDeviceInCall=n,this.defaultDeviceManager=a,this.logger=s,this.callStats=c,this.isMediaSending=u,this.stats=[],this.selectedVirtualDevice={camera:void 0,screenshare:void 0},this.subs=[this.defaultDeviceManager.on("onVirtualDevicesChanged",()=>this.handleRegisteredDeviceChange())],this.logger.info(`allowVirtualDeviceInCall: ${n}`)}get isVirtualDeviceEnabled(){return this.allowVirtualDeviceInCall}selectDevices(n){const a=this.defaultDeviceManager.getRegisteredDevices(),s=a.find(m=>m.id===n.camera),c=a.find(m=>m.id===n.screenshare);this.logger.info(`Selecting virtual devices, camera: ${s?.id}, screenshare: ${c?.id}`);const u={camera:this.selectedVirtualDevice.camera?.id,screenshare:this.selectedVirtualDevice.screenshare?.id};n.camera!==u.camera||n.screenshare!==u.screenshare?(this.selectedVirtualDevice={camera:s,screenshare:c},this.addToCallStat({type:"VirtualDeviceSelected",payload:this.selectedVirtualDevice}),this.event("onSelectedVirtualDevicesChanged").raise(n,u)):this.logger.info("Virtual Device did not change.")}getSelectedDevices(){return Object.entries(this.selectedVirtualDevice).reduce((n,[a,s])=>(n[a]=s?.id,n),{})}getDeviceManager(n){return this.allowVirtualDeviceInCall?this.getDeviceManagersForVirtualDevice(n)[0]:this.defaultDeviceManager}getDeviceManagersForVirtualDevice(n){return n==="Video"&&this.selectedVirtualDevice.camera?(this.logger.info(`Using Virtual Device (DM), type: ${n}`),this.selectedVirtualDevice.camera.getDeviceManagers()):n==="ScreenShare"&&this.selectedVirtualDevice.screenshare?(this.logger.info(`Using Virtual Device (DM), type: ${n}`),this.selectedVirtualDevice.screenshare.getDeviceManagers()):(this.logger.info(`Using default DM, type: ${n}`),[this.defaultDeviceManager])}getDefaultDeviceManager(){return this.defaultDeviceManager}dispose(){this.stats=[],this.subs.forEach(n=>n.dispose()),super.dispose()}hasDevice(n){return this.defaultDeviceManager.id===n||[...this.selectedVirtualDevice.camera?.getDeviceManagers()??[],...this.selectedVirtualDevice.screenshare?.getDeviceManagers()??[]].some(a=>a?.id===n)}addToCallStat(n){const a=this.stats.push(n);this.callStats.appendCallDeviceManagerInfo({events:JSON.stringify(a)})}handleRegisteredDeviceChange(){const n=this.defaultDeviceManager.getRegisteredDevices(),{camera:a,screenshare:s}=this.selectedVirtualDevice;let c=!1,u=!1;a&&(c=n.some(m=>m.id===a.id),this.logger.info(`Selected camera(${a.id}) in call, isCameraValid:${c}`)),s&&(u=n.some(m=>m.id===s.id),this.logger.info(`Selected SS(${s.id}) in call, isScreenShareValid:${u}`)),this.selectDevices({camera:c?a.id:void 0,screenshare:u?s.id:void 0})}isModalityEnabled(n){return this.isMediaSending(Y8e(n))}},uhi=class{constructor(n,a){this.logger=n,this.configProvider=a,this.debounceMap=new Map,this.enabledViaApi=!1,this.configProvider.config.remoteUFD?.enabledViaApi&&this.init()}init(){this.configProvider.config.remoteUFD?.enabled&&Object.keys(this.configProvider.config.remoteUFD.list).length&&(this.enabledViaApi=!0,this.logger.info(`Remote UFDs list: ${JSON.stringify(this.configProvider.config.remoteUFD.list)}`))}raiseIfNeeded(n,a,s){if(this.shouldBeRaised(n,a))if(this.configProvider.config.localUFDDebounceTime)s(this.getState(n));else{clearTimeout(this.debounceMap.get(n.type));const c=setTimeout(s,this.configProvider.config.remoteUFD.debounceTime,this.getState(n));this.debounceMap.set(n.type,c)}}dispose(){for(const n of this.debounceMap.values())clearTimeout(n);this.debounceMap.clear(),this.enabledViaApi=!1}shouldBeRaised(n,a){return!(!this.configProvider.config.remoteUFD?.enabled||!this.enabledViaApi||a>this.configProvider.config.remoteUFD.maxParticipantNumber||!this.configProvider.config.remoteUFD.list[n.type])}getState(n){return{type:"clientMediaUfd",level:"endpoint",content:JSON.stringify([n])}}},hhi={reconnect:{metrics:["ReconnectAttempts","ReconnectConnectedCount","RetargetCompletedCount","TerminationReason_code","TerminationReason_subCode","UFDs"],Extensions:["StartTime","EndTime"]},rejectNegotiation:{metrics:["NetworkEvents","ErrorDetail","UFDs","RollbackNegotiation","TerminationReason_code","TerminationReason_subCode"],Extensions:["IceConnectionState","IceConnectionStatePrevious","StartTime","EndTime"]},visibilityHidden:ke.MEDIA_EVENT_FIELDS,lowBattery:ke.MEDIA_EVENT_FIELDS},phi=class extends Qs{constructor(n){super(),this.configProvider=n}setDiagnosticsReport(n){this.diagnosticsReport=n}setEventType(n){if(!this.configProvider.config.smallCallTelemetry.enable)return;const a=Object.keys(this.configProvider.config.smallCallTelemetry.mediaUFDEventDictionary),s=this.getLastKnownMediaSessionStats();if(s&&(a?.forEach(c=>{if(c===n){const u=this.configProvider.config.smallCallTelemetry.mediaUFDEventDictionary[c],m={eventType:n,data:this.buildFromDictionary(s,u)};this.setTerminationCodeAndSubCodeToSuccess(m.data),this.event("sendSmallCallTelemetry").raise(m)}}),n==="reconnect"||n==="rejectNegotiation"||n==="visibilityHidden"||n==="lowBattery")){const c={eventType:n,data:this.buildFromDictionary(s,hhi[n])};c.data.metrics.TerminationReason_code===void 0&&this.setTerminationCodeAndSubCodeToSuccess(c.data),this.event("sendSmallCallTelemetry").raise(c)}}getEndCallSmallTelemetry(n){const a=this.getLastKnownMediaSessionStats(),s=this.buildFromDictionary(a,ke.MEDIA_EVENT_FIELDS);return n&&(s.metrics.TerminationReason_code=$d.CODE.SUCCESS,s.metrics.TerminationReason_subCode=$d.SUB_CODE.BEACON),{eventType:n?"tabClosed":"endCall",data:s}}getSmallTelemetryOnBatteryLow(){const n=this.getLastKnownMediaSessionStats(),a=this.buildFromDictionary(n,ke.MEDIA_EVENT_FIELDS);return this.setTerminationCodeAndSubCodeToSuccess(a),{eventType:"lowBattery",data:a}}getLastKnownMediaSessionStats(){if(!this.diagnosticsReport)return;const n=this.diagnosticsReport.rawRootRef.sessions.length;return this.diagnosticsReport.getSessionTelemetry(this.diagnosticsReport.rawRootRef.sessions[n-1]?.sessionId)}buildFromDictionary(n,a){const s={Extensions:{},metrics:{}};if(!n)return s;for(const c in a)n[c]&&(s[c]={},a[c].forEach(u=>{n[c][u]!==void 0&&(s[c][u]=n[c][u])}));return s}setTerminationCodeAndSubCodeToSuccess(n){n.metrics.TerminationReason_code===void 0&&(n.metrics.TerminationReason_code=$d.CODE.SUCCESS,n.metrics.TerminationReason_subCode=$d.CODE.SUCCESS)}},ghi=class extends Qs{constructor(n,a){super(),this.diagnostics=n,this.configProvider=a,this.hasSentLowBatteryEvent=!1,navigator?.getBattery?.().then(s=>{this.batteryManager=s,s.addEventListener("levelchange",this.onLevelChange.bind(this))})}dispose(){this.batteryManager&&this.batteryManager.removeEventListener("levelchange",this.onLevelChange)}onLevelChange(n){const a=100*n.level;this.diagnostics.setBatteryLevel(a),a<=this.configProvider.config.lowBatteryThreshold&&!this.hasSentLowBatteryEvent&&(this.event("batteryStatusChanged").raise(a),this.hasSentLowBatteryEvent=!0)}},bw=n=>`${n.type}:${n.mediaType}`,mhi=class{constructor(n,a){this.logger=n,this.configProvider=a,this.timestamps={},this.lastSentUFDValues=new Map,this.disabledUFDs=new Set}shouldRaise(n,a,s){if(!this.isEnabled(n,a,s))return!1;const c=bw(n);if(n.value!=="Good"&&this.shouldUFDBeDisabled(c)&&!this.disabledUFDs.has(c)&&(this.logger.info(`Disabling remote UFD: ${JSON.stringify(n)}`),this.disabledUFDs.add(c),setTimeout(()=>{this.disabledUFDs.delete(c)},this.configProvider.config.remoteUFD.disableInterval)),this.disabledUFDs.has(c)&&n.value!=="Good")return!1;const u=this.lastSentUFDValues.get(c);return!(this.disabledUFDs.has(c)&&n.value==="Good"&&(!u||u==="Good"))}registerSentUFDs(n){n.forEach(a=>{const s=bw(a);this.lastSentUFDValues.set(s,a.value)})}shouldUFDBeDisabled(n){var a;const s=this.configProvider.config.remoteUFD.maxNumberOfBadUFDsForThrottling;(a=this.timestamps)[n]??(a[n]=[]);const c=this.timestamps[n];return ld(c,Date.now(),s),!(c.length<s)&&c[s-1]-c[0]<this.configProvider.config.remoteUFD.throttlingTimeInterval}isEnabled(n,a,s){return!(!this.configProvider.config.remoteUFD?.enabled||!s||a>this.configProvider.config.remoteUFD.maxParticipantNumber||!this.configProvider.config.remoteUFD.list[n.type])}},fhi=class{constructor(n,a,s){this.logger=n,this.configProvider=a,this.publishState=s,this.bundledUFDs=new Map,this.sentBundleWindow=[],this.enabledViaApi=!1,this.configProvider.config.remoteUFD?.enabledViaApi&&this.init()}raiseIfNeeded(n,a){const s=bw(n);if(!this.remoteUFDFilter?.shouldRaise(n,a,this.enabledViaApi))return;const c=this.bundledUFDs.get(s);n.value==="Good"&&c&&c.value!=="Good"?this.bundledUFDs.delete(s):this.bundledUFDs.set(s,n)}dispose(){this.enabledViaApi=!1,this.bundledUFDs.clear(),clearTimeout(this.bundleInterval)}init(){!this.enabledViaApi&&this.configProvider.config.remoteUFD?.enabled&&Object.keys(this.configProvider.config.remoteUFD.list).length&&(this.enabledViaApi=!0,this.logger.info(`Initialized with remote UFDs list: ${JSON.stringify(this.configProvider.config.remoteUFD.list)}`),this.remoteUFDFilter=new mhi(this.logger,this.configProvider),this.bundleInterval=window.setInterval(()=>this.sendUfdBundle(),this.configProvider.config.remoteUFD.bundlingInterval))}sendUfdBundle(){if(!this.bundledUFDs.size)return;if(this.sentBundleWindow.length>=this.configProvider.config.remoteUFD.maxNumberOfBundles){if(this.sentBundleWindow[0]+this.configProvider.config.remoteUFD.bundlingWindowInterval>Date.now())return;this.sentBundleWindow.shift()}const n=this.getState();this.logger.info(`Sending remote UFDs: ${n.content}`),this.remoteUFDFilter.registerSentUFDs(Array.from(this.bundledUFDs.values())),this.publishState(n),this.bundledUFDs.clear(),this.sentBundleWindow.push(Date.now())}getState(){return{type:"clientMediaUfd",level:"endpoint",content:JSON.stringify(Array.from(this.bundledUFDs.values()))}}},vhi=[1,2,9,10,11,12,30,27,28],yhi="remote",O7e="remote",Shi=class extends Qs{constructor(n,a){super(),this.isStreaming=n,this.mediaType=a}},na=class Pv extends Qs{constructor(a,s,c,u,m,b,_,k,N,W,ee,oe,de,se,Re,ue,Ne,ze){super(c),this.signalingAgent=a,this.mediaAgent=s,this.logger=c,this.telemetryLoggers=u,this.currentUserSkypeIdentity=m,this.groupId=b,this.threadId=_,this.ecsProvider=W,this.trouterService=ee,this.accountConfiguration=oe,this.vdi3diagnostics=ze,this.participants=[],this.isServerMuted=!1,this.isSpeakerMuted=!1,this.isVideoOn=!1,this.isScreenSharingOn=!1,this.callStartedAt=null,this.callHeldAt=null,this.conversationStartTime=null,this.callType=-1,this.failureType=2,this.isEmergency=!1,this.contentSharingSessions=[],this.endpoints={endpointDetails:[]},this.isPreheatEnabled=!1,this.localMediaStreams=[],this.enableRealtimeTelemetry=!1,this.isSharedLineAppearanceV2Activated=!1,this.enableCaptcha=!1,this.requestedHoldState=!1,this.mediaStateConfigurationHelper=new J8e({mediaStates:[qR(0,4)]}),this.canToggleAudio=!0,this.canToggleVideo=!0,this.connectCallPromise=Promise.resolve(),this.canToggleScreenSharing=!0,this.callUsesMixer=!1,this.isEscalationInProgress=!1,this.retryOutgoingRenegotiation={retry:!1,causeId:""},this.isHoldInProgress=!1,this.isMuteOnHold=!1,this.callSetupFailed=!1,this.isSomeoneSharing=!1,this.isSomeoneStreamingVideo=!1,this.activeTalkersHistory=[],this.callGotConnected=!1,this.mediaRelayWhiteListingIssue=!1,this.signalingSessionCallOptions=null,this.tsCallingTelemetryReported=!1,this.isCallSetupTelemetrySent=!1,this._isAudioStreamConnected=!1,this._wasAudioStreamConnected=!1,this._callInLobby=!1,this._callIsSetupComplete=!1,this._transferState=0,this._parkState=0,this._muteState=0,this._callCreationTime=new Date().getTime(),this._commandUrlPresence=0,this._capabilities={canMuteOthers:!1,canUnmuteSelf:!1},this._spamRiskLevel=null,this._spamStirAttestation=null,this._callMode=0,this._isUpdatePropertiesSpecifiedAllowedByEcs=!1,this._deferUsingMicrotask=!1,this._enableResolveScreenSharingWhenNegotiationComplete=!1,this._publishedStatesModified=0,this._participantPublishedStatesMap={},this._endpointPublishedStatesMap={},this._participantChangedEventSkipConfig={skipParticipantsUpdatesOnCall:!0},this._dominantSpeakerChangedEventSkipConfig={skipDominantSpeakerUpdatesOnCall:!0},this.receiveOnlyAudioOnCallStart=!1,this.lastContributingSourceReport=Date.now(),this.instanceNumber=Pv.instanceCount++%1e3,this._enableMuteAsync=!1,this._enableUnmuteAsync=!1,this._enableEndpointMeetingRoleCheckForClientCapability=!1,this._enableUserMeetingRolesCheckForClientCapability=!1,this._enableAddModalityGeneric=!1,this._delayedElevationPending=!1,this._delayedElevationQueued=!1,this.maxVbssChannels=0,this.startVM=(be,Ee,Pe,Qe,Ze)=>this.signalingSession.startOutgoingCall(Pe,Qe,{voicemailResourcePath:Ee.callVoicemailStartOptions.voicemailResourcePath,voicemailItemId:Ee.callVoicemailStartOptions.voicemailItemId,callToVoicemail:!0},Date.now()-Ze,be),this.getSignalingSessionCallOptions=be=>{const Ee={suppressDialout:!be.callStartOptions.ringOthers,isPreheatOnly:!(1&~be.callStartOptions.preheatFlags),onBehalfOf:this.onBehalfOfMri,onBehalfOfUserDisplayName:this.onBehalfOfUserDisplayName,callQueueContext:be.callStartOptions?.callQueueContext,muted:!(1&~be.callStartOptions.muteFlags),invitationType:be.invitationType,participantsToNudge:be.participantsToNudge,routingFlags:be.callStartOptions&&be.callStartOptions.routingFlags,parkContext:be.parkContext,pickupCode:be.pickupCode,scenario:be.callStartOptions&&be.callStartOptions.scenario,callUsesMixer:this.callUsesMixer,clientEndpointCapabilities:be.callStartOptions.clientEndpointCapabilities,clientEndpointDebugContent:be.callStartOptions.clientEndpointDebugContent,isEmergency:this.isEmergency,meetingData:this.meetingData,meetingPreferences:be.meetingPreferences,alternateId:be.callStartOptions?be.callStartOptions.alternateId:null,meetingRegistrationId:be.callStartOptions?be.callStartOptions.meetingRegistrationId:"",participantPin:be.callStartOptions?be.callStartOptions.participantPin:"",additionalEndpointProperties:be.callStartOptions?.additionalEndpointProperties||null,publishedStates:be.callStartOptions?.publishedStates||null,targetApplicationType:be.callStartOptions?.targetApplicationType,isHuddleGroupCall:be.callStartOptions?.isHuddleGroupCall,captchaContentJson:be.callStartOptions?.captchaContentJson,customHeaderContext:be.callStartOptions?.customHeaderContext,participationPreferences:be.callStartOptions?.participationPreferences,callingLineIdentity:be.callStartOptions?be.callStartOptions.callingLineIdentity:null,participantPropertyBag:be.callStartOptions?be.callStartOptions.participantPropertyBag:null},Pe=be.callStartOptions?.invitationDataJson;if(Pe)try{Ee.invitationData=JSON.parse(Pe)}catch{throw new Error(`Invalid JSON in invitationData: ${Pe}`)}return Ee},this.startOutgoingCall=(be,Ee,Pe,Qe,Ze)=>this.signalingSession.startOutgoingCall(Pe,Qe,this.getSignalingSessionCallOptions(Ee),Date.now()-Ze,be),this.joinGivenConversation=(be,Ee,Pe,Qe,Ze,Xe)=>{const bt=!(1&~Ee.callStartOptions.muteFlags),Ot=!(1&~Ee.callStartOptions.preheatFlags),Yt=Ee.callStartOptions?.invitationDataJson,pt=Ee.callStartOptions?.sharedLineCallInvitationContentJson;this.logger.info(`[${be}][joinGivenConversation] muted=${bt}, isPreheatOnly=${Ot},
            sharedLineCallInvitationContentJson=${pt}, invitationDataJson=${Yt},
            captchaContentJson=${!!Ee?.callStartOptions?.captchaContentJson}`);const Lt={muted:bt,isPreheatOnly:Ot,clientEndpointCapabilities:Ee.callStartOptions.clientEndpointCapabilities,clientEndpointDebugContent:Ee.callStartOptions.clientEndpointDebugContent,isEmergency:this.isEmergency,meetingData:this.meetingData,meetingPreferences:Ee.meetingPreferences,meetingRegistrationId:Ee.callStartOptions?Ee.callStartOptions.meetingRegistrationId:"",participantPin:Ee.callStartOptions?Ee.callStartOptions.participantPin:"",additionalEndpointProperties:Ee?.callStartOptions?.additionalEndpointProperties,applyServerMute:Ee?.applyServerMute,publishedStates:Ee?.callStartOptions.publishedStates,invitationData:Ee?.callStartOptions.invitationDataJson,captchaContentJson:Ee?.callStartOptions.captchaContentJson,callQueueContext:Ee?.callStartOptions.callQueueContext,participationPreferences:Ee?.callStartOptions.participationPreferences,participantPropertyBag:Ee?.callStartOptions.participantPropertyBag};if(pt)try{Lt.sharedLineCallInvitationContent=JSON.parse(pt)}catch{throw new Error(`Invalid JSON in sharedLineCallInvitationContent: ${pt}`)}if(Yt)try{Lt.invitationData=JSON.parse(Yt)}catch{throw new Error(`Invalid JSON in invitationDataJson: ${Yt}`)}return this.signalingSession.joinGivenConversation(Xe,this.callId,Pe,Qe,Date.now()-Ze,Lt,be)},this.getParticipantByLegId=(be,Ee,Pe)=>{this.logger.info(`getMriByParticipantLegId[${Pe}] participantLegId ${be}`);for(const Qe of Ee.participants)for(const Ze of Qe.endpoints.endpointDetails)if(Ze&&Ze.participantId&&Ze.participantId===be)return Qe;return null},this.executeCallTransfer=(be,Ee,Pe,Qe)=>{this._setTransferState(1);const Ze=this._callOperationHandler.createPendingOperation("_CallTransferInProgress",void 0,Ee,{preconditionTags:["NOT_SUPPORTED_IN_STREAMING_MODE"]});return Pe===0?this.signalingSession.transferCallAsync(be,"TransferTypeStandard",void 0,Qe,Ee):Pe===2&&this.signalingSession.transferCallAsync(be,"TransferTypeVoicemail",void 0,Qe,Ee),Ze},this.executeConsultCallTransfer=(be,Ee,Pe,Qe,Ze)=>{this._setTransferState(1);const Xe=this._callOperationHandler.createPendingOperation("_CallTransferInProgress",void 0,Qe,{preconditionTags:["NOT_SUPPORTED_IN_STREAMING_MODE"]});return this.signalingSession.consultTransferCallAsync(be,Ee,Pe,Qe,Ze),Xe},this.createUpdateParticipantPromise=(be,Ee)=>this._callOperationHandler.createPendingOperation("UpdateParticipantsProperties",be,Ee),this._getCallEndOperation=()=>this._callOperationHandler.hasPendingOperation("StopCall")?this._callOperationHandler.waitForOperation("StopCall"):this._callOperationHandler.hasPendingOperation("Reject")?this._callOperationHandler.waitForOperation("Reject"):this._callOperationHandler.hasPendingOperation("CallRedirect")?this._callOperationHandler.waitForOperation("CallRedirect"):Promise.resolve(),this._onAcknowledgeError=(be,Ee,Pe,Qe)=>{Pe.logFailure(be);let Ze,Xe={code:2,success:!1,fatal:!0},bt=7;throw IN("SendAttach",be)&&(Ze={code:er.InternalServerError,subCode:Ml.AttachFailed,phrase:Ug.AttachFailed}),IN("ProcessIncomingCallRequest",be)&&(Ze={code:er.NotAcceptable,subCode:Ml.AttachActionFailed,phrase:Ug.BadNotificationPayload},Xe={code:0,success:!1,fatal:!0}),Hte(jR,be)&&(bt=47),be?.error&&be.error.type===this.mediaAgent.constants.MEDIA_ERROR.incompatibleOffer&&(Ze={code:er.MediaError,subCode:Ml.MediaOfferProcessingError,phrase:Ug.IncompatibleOffer}),this.callTelemetry.updateOperationData("Acknowledge",{phases:Qe,error:Hs(be)},Ee),this._callOperationHandler.maybeRejectOperation("Acknowledge",Xe,void 0,Ee),this.stopInternal({rejectReason:Ze,causeId:Ee,terminatedReason:bt}),Xe},this._onAcknowledgeSuccess=(be,Ee,Pe)=>(be.logSuccess("success"),this.callTelemetry.updateOperationData("Acknowledge",{phases:Ee},Pe),{code:1,success:!0}),this._processOfferedModalities=(be,Ee)=>{this.handleOfferedModalities(be,Ee);const Pe=this.callUsesMixer?void 0:{modalityOverride:be};return this.updateMediaModalities(Pe,Ee)},this._handleOfferProcessingError=(be,Ee,Pe)=>(Pe.logFailure(`handleOfferProcessingError=${be}`),be?.error?.type===this.mediaAgent.constants.MEDIA_ERROR.incompatibleOffer?(this.callTelemetry.recordEvent("IncompatibleOffer",void 0,Ee),this.signalingSession.supportsNewOfferRequest()?(this.newOfferRequestDeferred=new Pi,this.attachToCallAndGetOffer.promise.then(()=>this.mediaSession.rejectNegotiationAsync(be.error,Ee)).then(()=>this.signalingSession.requestNewOffer(this.mediaSession.getAcceptedTypes(),Ee)).then(()=>this.newOfferRequestDeferred.promise).then(Qe=>this.mediaSession.processOfferAsync(Qe,Ee)).catch(Qe=>(this.callTelemetry.recordEvent("NewOfferFailed",fi(Qe),Ee),Promise.reject(Qe)))):Promise.reject(be)):Promise.reject(be)),this._trySendProvisionalMediaAnswer=be=>Promise.resolve(void 0).then(()=>this.mediaSession.createAnswerAsync(!0,be)).then(Ee=>Ee.blob?(this.mediaAcknowledgmentOperation=this._callOperationHandler.createPendingOperation("_MediaAcknowledgment",void 0,hi(),{preconditionTags:["NOT_SUPPORTED_IN_STREAMING_MODE"]}),this.signalingSession.setProvisionalAnswerAsync(Ee).then(()=>this.mediaAcknowledgmentOperation)):Promise.resolve(void 0)),this.checkForCallIdUpdate=(be,Ee)=>{if(this.callId!==be){this.logger.info(`[${Ee}][checkForCallIdUpdate] old=${this.callId}, new=${be}`),this.setCallId(be);try{this.event("callIdChanged").raise(this.callId)}catch(Pe){this.logger.error(`Error raising call ID change: ${Pe}`)}this.raiseChanged()}},this.handleRemoteParticipantStateInOneToOneCall=be=>{if(!this.callUsesMixer&&this.state===3){const Ee=this.participants[0];Ee&&Ee.setState(3,void 0,be)}},this.handleRemoteParticipantJoinedInOneToOneCall=(be,Ee)=>{if(!this.callUsesMixer&&this.state===3){const Pe=this.participants.filter(Qe=>Qe.id===be.id)[0];Pe?Pe.setState(3,void 0,Ee):this.logger.logFailure(`[${Ee}][handleRemoteParticipantJoinedInOneToOneCall]unable to find particpant ${kn(be.id)}`)}},this.handleRemoteParticipantStateInObservingCall=(be,Ee,Pe)=>{const Qe=Ee.isLobby;if(this.state===8){const Ze=Qe?7:3;be.setState(Ze,void 0,Pe)}},this.getTelemetryFromPhaseExecution=be=>{const Ee={phase:be.phase,phases:be.phases,code:be.error&&be.error.code,subCode:be.error&&be.error.subCode,message:be.error&&be.error.message,error:be.error};return(Ee.code||Ee.message)&&delete Ee.error,Ee},this._setTransferState=be=>{this.transferState!==be&&(this.logger.info(`Transfer: state set: ${be}`),this._transferState=be,this.callTelemetry.recordEvent("_SetTransferState",{state:be}),this.raiseChanged())},this._setParkState=be=>{this.parkState!==be&&(this.logger.info(`Parking: state set: ${be}`),this._parkState=be,this.callTelemetry.recordEvent("_SetParkState",{state:be}),this.raiseChanged())},this.prepareNegotiationResultForTelemtry=be=>({isComplete:be.isComplete,activeModalities:be.activeModalities,configuredModalities:be.configuredModalities,initiator:kn(be.initiator),attemptedModalities:be.attemptedModalities,offeredModalities:be.offeredModalities}),this.prepareTelemetryForOfferAnswer=be=>be&&be.mediaContent&&{isRenegotiation:!!be.renegotiation,isEscalation:!!be.mediaContent.isTwoPartyToMultiPartyEscalation,mediaTypes:be.mediaTypes,newOffer:be.mediaContent.newOffer},this.updateLocalParticipantEndpoints=be=>{const Ee=this.logger.createFnLogger("updateLocalParticipantEndpoints",""),Pe=[];(0,Zr.forEach)(be,Ze=>{const Xe=q8e(Ze,this.getSelfClientEndpointCapabilities());Pe.push(Xe)}),this.endpoints.endpointDetails=Pe;const Qe=this.getDataChannelSourceId();Qe!==-1&&this.dataChannel&&this.dataChannel.setDataChannelSourceId(Qe),Ee.info(`selfEndpointDetails=${d2(this.endpoints)}`)},this.handleParticipantsMutedUpdated=(be,Ee)=>{const Pe=this.logger.createFnLogger("handleParticipantsMutedUpdated",Ee);if(be?.info!==void 0){this.logger.info(`handleParticipantsMutedUpdated: number of infos: ${Object.keys(be.info).length}`);for(const Qe of Object.keys(be.info)){const Ze=this.getParticipant(Qe);Ze?Ze.handleServerMutedInfoUpdate(be.info[Qe]):Pe.info(`Cannot find local participant ${kn(Qe)}`)}}else Pe.info("Ignored, no mute participant info.")},this.handleSelfUnmuteUpdatedInfo=(be,Ee)=>{const Pe=this.logger.createFnLogger("handleSelfUnmuteUpdatedInfo",Ee);if(be?.info!==void 0)for(const Qe of Object.keys(be.info)){const Ze=be.info[Qe];if(Qe===this.localSignalingParticipant.id){const Xe=(0,Zr.find)(Ze,Ot=>Ot.participantId===this.localSignalingParticipant.participantId);if(Xe===void 0){Pe.info(`Cannot find local participant ${kn(Qe)}`);continue}const bt=(0,Zr.find)(this.localSignalingParticipant.endpointDetails,Ot=>Ot.participantId===Xe.participantId);Z8e(this.logger,bt,Xe,!1)&&this.handleSelfServerMutedState(Ee)}}else Pe.info("Ignored, no unmute participant info.")},this.state=0,this.terminatedReason=0,this.callStats=new ddi,this.callDeviceManager=this.createCallDeviceManager(),this.callTelemetry=new DG(this.logger,this._callCreationTime),this.collectMediaStatsDeferred=new Pi,this.setCallId(k),this.setGroupId(b),this.setThreadId(_),this.setMessageId(de),this.setSkypeId(this.currentUserSkypeIdentity.id),this.setParticipantId(N),this.setCallOrigin(0),this.vdi3diagnostics&&this.callStats.setRpcSessionId(this.vdi3diagnostics.getRPCSessionId()),this.logger=this.logger.createChild(()=>{const be=(this.endpointId||"").substr(0,8),Ee=(this.participantId||"").substr(0,8);return`Web/${this.instanceNumber}[${this.callId}][${be}][${Ee}][${this.state}]`}),this._enableMuteAsync=this.ecsProvider.getEcsConfig("SkypeCalling","enableAsyncMute"),this._enableUnmuteAsync=this.ecsProvider.getEcsConfig("SkypeCalling","enableAsyncUnmute"),this._enableEndpointMeetingRoleCheckForClientCapability=this.ecsProvider.getEcsConfig("SkypeCalling","enableEndpointMeetingRoleCheckForClientCapability"),this._enableUserMeetingRolesCheckForClientCapability=this.ecsProvider.getEcsConfig("SkypeCalling","enableUserMeetingRolesCheckForClientCapability"),this._enableAddModalityGeneric=this.ecsProvider.getEcsConfig("SkypeCalling","enableAddModalityGeneric"),this.initializeSignalingSession(N),this.signalingSession.setLocationInfo(se,Re,Ne),this.streamManager=new fye(this.participantId,null,this.callStats.localStats,this.logger),this.mediaAgent&&(this.dataChannel=new u7e(this.logger),this.dataChannel.on("remoteUserEventsReceived",(be,Ee)=>this.event("remoteUserEventsReceived").raise(be,Ee)),this.dataChannel.on("onDataChannelStateUpdated",be=>{be==="Failed"&&(this.logger.error("onDataChannelStateUpdated: datachannel creation failed, will remove data modality"),this.mediaStateConfigurationHelper.removeModality(3),this.updateSignalingDSHMessageSubscription(!0),this.updateMediaModalities())}),this.screenSharingControl=new T7e(this.logger,this.dataChannel,this,this.telemetryLoggers,this.ecsProvider,this.mediaAgent.getConfigProvider()),this.mediaAgent.handleSendMidCallTelemetry(this.sendMidCallTelemetry.bind(this)),this.remoteUFDHandler=this.mediaAgent.getConfigProvider().config.remoteUFD?.remoteUFDHandlerV2?new fhi(this.logger.createChild("remoteUFDHandlerV2"),this.mediaAgent.getConfigProvider(),this.publishState.bind(this)):new uhi(this.logger.createChild("remoteUFDHandler"),this.mediaAgent.getConfigProvider()),this.smallCallTelemetry=new phi(this.mediaAgent.getConfigProvider()),this.smallCallTelemetry.on("sendSmallCallTelemetry",be=>this.reportSmallCallEvent(be)));const He={enableErrorConversion:this.ecsProvider.getEcsConfig("SkypeCalling","enableErrorConversion")};this._deferUsingMicrotask=this.ecsProvider.getEcsConfig("SkypeCalling","deferUsingMicrotask"),n9.instance.setDeferToQueueMicrotask(this._deferUsingMicrotask),n9.instance.setLogger(c),this.logger.info(`operationHandlerEcsConfig: ${JSON.stringify(He)}`),this._preferredMpLocation=this.ecsProvider.getEcsConfig("SkypeCalling","preferredMpLocation"),this.logger.debug(`preferredMpLocation: ${this._preferredMpLocation}`),this._isUpdatePropertiesSpecifiedAllowedByEcs=this.ecsProvider.getEcsConfig("SkypeCalling","enableUpdateParticipantsSpecified"),this._enableResolveScreenSharingWhenNegotiationComplete=this.ecsProvider.getEcsConfig("SkypeCalling","enableResolveScreenSharingWhenNegotiationComplete"),this._callOperationHandler=new bV(this.logger,this.callTelemetry,He,void 0,(be,Ee)=>{this.preconditions(be,Ee)}),this._participantOperationHandler=new bV(this.logger,this.callTelemetry,He),this.setMeetingData(ue),this.initializeLiveStreamConfigProvider()}get callMode(){return this._callMode}get callId(){return this._callId}get endpointId(){return this._endpointId}get isHostless(){return this.signalingSession.isHostLessCall}get transferState(){return this._transferState}get parkState(){return this._parkState}get capabilities(){return this._capabilities}get publishedStates(){return this._publishedStates}get dataChannelAdapter(){return this.dataChannel}get participantId(){try{const a=this.signalingSession?.participantManager?.localParticipant?.participantId;this._participantId=a||this._participantId}catch{this.logger.error("Error updating participantId")}return this._participantId}get displayName(){return this.localSignalingParticipant.displayName}get role(){return this.localSignalingParticipant.role}get meetingRole(){return this.localSignalingParticipant.meetingRole}get advancedMeetingRole(){return this.localSignalingParticipant.advancedMeetingRole}get meetingRoles(){return this.localSignalingParticipant.meetingRoles}get maskedIdentityDetails(){return{isIdentityMasked:this.localSignalingParticipant.isIdentityMasked,maskedIdSeqNumber:this.localSignalingParticipant.maskedIdSeqNumber,maskedId:this.localSignalingParticipant.maskedId}}get participantType(){return this.localSignalingParticipant.participantType}get isMuted(){return this._muteState===2||this._muteState===3}get tenantId(){return this.localSignalingParticipant.tenantId}get mediaLegId(){return this._mediaLegId}get isIncomingOneOnOneVideoCall(){return this.isOneToOneCall()&&this.isSomeoneStreamingVideo}get mediaStreams(){return this.streamManager.streams}get origin(){return this._origin}get propertyBag(){return this.localSignalingParticipant.propertyBag}get version(){return this.localSignalingParticipant.version}get isAudioStreamConnected(){return this._isAudioStreamConnected}set isAudioStreamConnected(a){this._isAudioStreamConnected!==a&&(this._isAudioStreamConnected=a,this._wasAudioStreamConnected=this._wasAudioStreamConnected||a,this.raiseChanged())}setMeetingRole(a){a!==this.localSignalingParticipant.meetingRole&&(this.logger.info(`changing self role to [${a}]`),this.localSignalingParticipant.meetingRole=a,this.event("meetingRoleUpdated").raise(a))}setAdvancedMeetingRole(a){a!==this.localSignalingParticipant.advancedMeetingRole&&(this.logger.info(`changing self advanced meeting role to [${a}]`),this.localSignalingParticipant.advancedMeetingRole=a,this.event("advancedMeetingRoleUpdated").raise(a))}setMeetingRoles(a){(0,Zr.isEqual)(a,this.localSignalingParticipant.meetingRoles)||(this.logger.info(`changing self meeting roles to [${a}]`),this.localSignalingParticipant.meetingRoles=a,this.event("meetingRolesUpdated").raise(a))}setParticipantType(a){a!==this.localSignalingParticipant.participantType&&(this.logger.info(`changing self participant user type to [${a}]`),this.localSignalingParticipant.participantType=a,this.event("participantTypeUpdated").raise(a))}setPropertyBag(a){a&&!(0,Zr.isEqual)(a,this.localSignalingParticipant.propertyBag)&&(this.logger.info(`changing self participant property bag to [${a}]`),this.localSignalingParticipant.propertyBag=a,this.event("propertyBagUpdated").raise(a))}setPropertyRosterVersion(a){a!==this.localSignalingParticipant.version&&(this.logger.info(`changing self participant property version to [${a}]`),this.localSignalingParticipant.version=a,this.event("propertyRosterVersionUpdated").raise(a))}setMaskedIdentityDetails(a=!1,s,c){this.localSignalingParticipant.isIdentityMasked===a&&this.localSignalingParticipant.maskedIdSeqNumber===s&&this.localSignalingParticipant.maskedId===c||(this.localSignalingParticipant.isIdentityMasked=a,this.localSignalingParticipant.maskedIdSeqNumber=s,this.localSignalingParticipant.maskedId=c,this.logger.info(`self participant masked identity details updated to [${JSON.stringify(this.maskedIdentityDetails)}]`),this.event("maskedIdentityDetailsUpdated").raise(this.maskedIdentityDetails))}setIsSomeoneStreamingVideo(a){this.logger.debug(`setting isSomeoneStreamingVideo to [${a}]`),this.isSomeoneStreamingVideo=a}setJoinAsStreamingUser(a){a!==this.joinAsStreamingUser&&(this.logger.info(`setting self join as streaming user to [${a}]`),this.joinAsStreamingUser=a)}setOtpIdentity(a){a!==this.otpIdentity&&(this.logger.info("setting self participant optIdentity"),this.otpIdentity=a)}get spamRiskLevel(){return this._spamRiskLevel}set spamRiskLevel(a){a&&(this._spamRiskLevel=a)}isMultiVBSSEnabled(){return this.maxVbssChannels>=1}get spamStirAttestation(){return this._spamStirAttestation}set spamStirAttestation(a){a&&(this._spamStirAttestation=a)}getScreenHandle(a){if(!this.sharedScreenHandle){const s=!!this.mediaSession&&this.mediaSession.getSessionConfig().mediaConfig.simulcastSessionEnabled,c=!!this.mediaSession&&this.mediaSession.getSessionConfig().config.enableAudioSharing&&!this.mediaSession.getSessionConfig().config.requireUserActionForAudioSharing,u=this.mediaStateConfigurationHelper.isSending(0)&&c&&s,m=a?.getType()===3?a?.getDeviceId():void 0,b=this.callDeviceManager.getDeviceManager(NV(2));b.setAudioSharingRequested(u),this.sharedScreenHandle=b.createDevicesHandle({audio:u,sharing:!0},"pluginlessCall:getScreenHandle()",m),this.sharedScreenHandle.on("onStreamStateChanged",(_,k)=>this.onSharingStreamStateChanged(_))}return this.sharedScreenHandle}setCallOrigin(a){this.logger.info(`Set call origin to ${a}`),this._origin=a,this.callTelemetry.setCallOrigin(a),this.callTelemetry.recordEvent("_SetCallOrigin",{origin:a})}setMediaLegId(a){this._mediaLegId=a,this.callStats.setMediaLegId(a)}setCallId(a){this.callTelemetry.setCallId(a),this.callStats.setCallId(a),this._callId=a}setEndpointId(a){this._endpointId=a,this.logger.info(`[endpointId=${J_(this._endpointId,8)}]`),this.callTelemetry.setEndpointId(a),this.callStats.setEndpointId(a)}setFailureType(a){this.callTelemetry.setFailureType(a),this.failureType=a}setParticipantId(a){this._participantId!==a&&(this._participantId=a,this.logger.info(`[participantId=${this._participantId}]`),this.callTelemetry.setParticipantId(this.participantId),this.event("callLegIdChanged").raise(this.participantId))}setDisplayName(a,s=hi()){this.logger.info(`[${s}][setDisplayName] displayName=${J_(a,4)}`),this.localSignalingParticipant.displayName=a,this.participantType==="anonymous"&&(this.callStats.setDisplayName(a),this.callTelemetry.setDisplayName(a),this.signalingSession.setDisplayName(a))}setCallerMri(a){this.callerMri=a,this.logger.info(`[callerMri=${kn(this.callerMri)}]`)}setDisplayNameSource(a){this.displayNameSource=a,this.logger.info(`[displayNameSource=${this.displayNameSource}]`)}setTransferorMri(a){const s=$te(a);s!==this.transferorMri&&(this.transferorMri=s,this.logger.info(`transferorMri: ${kn(this.transferorMri)}`),this.raiseChanged())}setGroupId(a,s=hi()){this.logger.info(`[${s}][setGroupId] groupId=${kn(a)}`),this.groupId!==a&&(this.groupId=a,this.callTelemetry.setGroupId(a),this.event("groupIdChanged").raise(a))}setMeetingData(a){if(a){if(a.meetingCode&&(!this.meetingData||this.meetingData&&a.meetingCode!==this.meetingData.meetingCode)){const s=a.meetingCode;this.logger.info(`[setMeetingData] meetingCode=${!!s}`),this.callTelemetry.setMeetingCode(s),this.signalingSession.setMeetingCode(s)}if(a.meetingUrl&&(!this.meetingData||this.meetingData&&a.meetingUrl!==this.meetingData.meetingUrl)){const s=a.meetingUrl.split("?")[0];this.logger.info(`[setMeetingData] meetingUrl=${!!a.meetingUrl}`),this.callTelemetry.setMeetingUrl(s),this.signalingSession.setMeetingUrl(s)}}this.meetingData=a}setHuddleGroupCall(a){this.isHuddleGroupCall!==!!a&&(this.logger.info(`[setHuddleGroupCall] new isHuddleGroupCall=${a}`),this.isHuddleGroupCall=a,this.callTelemetry.setIsHuddleGroupCall(!0))}onConversationStartTimeChanged(a,s=hi()){if(this.logger.info(`onConversationStartTimeChanged: Conv start time=${a}`),a&&this._rawConversationStartTime!==a){this.logger.info(`[${s}][onConversationStartTimeChanged] rawConvStartTime=${a}`);try{this.conversationStartTime=new Date(a),this._rawConversationStartTime=a,this.callTelemetry.setConversationStartTime(a)}catch(c){this.logger.warn(`Failed to parse the raw conv start timestamp. Error: ${c}, rawConvStartTime: ${a}`)}}}setComplianceRecordingContent(a,s){try{if(!(0,Zr.isEqual)(this.complianceRecordingContent,s)){this.complianceRecordingContent=s;const c=s?JSON.stringify(s):"";this.callTelemetry.setComplianceRecordingContentLength(c.length),this.logger.info(`[${a}][setComplianceRecordingContent] complianceRecordingContentLength=${c.length}`)}}catch(c){this.logger.error(`[${a}][setComplianceRecordingContent] ${c}`)}}setThreadId(a,s=hi()){this.threadId!==a&&(this.logger.info(`[${s}][setThreadId] threadId=${Qu(a)}`),this.threadId=a,this.callTelemetry.setThreadId(a))}setBackroomThreadId(a,s=hi()){this.backroomThreadId!==a&&(this.logger.info(`[${s}][setBackroomThreadId] backroomThreadId=${Qu(a)}`),this.backroomThreadId=a,this.callTelemetry.setBackroomThreadId(a))}setStreamThreadId(a,s=hi()){this.streamThreadId!==a&&(this.logger.info(`[${s}][setStreamThreadId] streamThreadId=${Qu(a)}`),this.streamThreadId=a,this.callTelemetry.setStreamThreadId(a))}setLobbyThreadId(a,s=hi()){this.lobbyThreadId!==a&&(this.logger.info(`[${s}][setLobbyThreadId] lobbyThreadId=${Qu(a)}`),this.lobbyThreadId=a,this.callTelemetry.setLobbyThreadId(a))}setMeetingLayoutDetails(a,s=hi()){(0,Zr.isEqual)(this.meetingLayoutDetails,a)||(this.logger.info(`[${s}][meetingLayoutDetails updated]`),this.meetingLayoutDetails=a,this.event("meetingLayoutChanged").raise(this.meetingLayoutDetails))}setCompositionServiceDetails(a,s=hi()){(0,Zr.isEqual)(this.compositionServiceDetails,a)||(this.logger.info(`[${s}][compositionServiceDetails updated]`),this.compositionServiceDetails=a,this.event("compositionServiceDetailsChanged").raise(this.compositionServiceDetails),this.callTelemetry.setCompositionServiceState(a?.state))}setMessageId(a,s=hi()){this.logger.info(`[${s}][setMessageId] messageId=${kn(a)}`),this.messageId=a,this.callTelemetry.setMessageId(a)}setSkypeId(a,s=hi()){this.skypeId!==a&&(this.logger.info(`[${s}][setSkypeId]`),this.skypeId=a,this.callTelemetry.setSkypeId(a))}setCallType(a,s){const c=this.logger.createFnLogger("setCallType",s);c.info(`current=${this.callType}, newValue: ${a}`),this.callType!==2||a!==1?a!==this.callType&&(this.callType=a,this.callTelemetry.setCallType(a),a===2&&this.callStats.localStats.call.event(2),this.raiseChanged()):c.logFailure("De-escalating to P2P should not happen!")}setConversationType(a,s){this.logger.createFnLogger("setConversationType",s).info(`current=${this.conversationType}, newValue=${a}`),a!==this.conversationType&&(this.conversationType=a,this.callTelemetry.setConversationType(a),this.raiseChanged())}setCallUsesMixer(a,s){this.callUsesMixer!==!!a&&(this.logger.info(`[${s}][setCallUsesMixer] new value=${a}`),this.callUsesMixer=a,this.callTelemetry.recordEvent("_CallUsesMixer",{newValue:a},s),this.dataChannel.setConfigProviderView(this.mediaSession?.getSessionConfig()))}_setMaxVbssChannels(a,s){this.logger.createFnLogger("MaxVbssChannels",s).info(`current=${this.maxVbssChannels}, newValue=${a}`),a!==this.maxVbssChannels&&(this.maxVbssChannels=a,this.callTelemetry.recordEvent("_setMaxVbssChannels",{MaxVbssChannels:a},s),this.raiseChanged())}setIsEscalationInProgress(a,s){this.logger.info(`[${s}][setIsEscalationInProgress] currentValue=${this.isEscalationInProgress}, newValue=${a}`),this.isEscalationInProgress=a,this.allowScreenSharingControl()&&this.screenSharingControl.setIsEscalationInProgress(a),this.callTelemetry.recordEvent("_EscalationInProgress",void 0,s)}setFromApplicationType(a,s){a&&(this.fromApplicationType=a,this.callTelemetry.recordEvent("_SetFromApplicationType",{fromApplicationType:a},s))}setCalleeAlternateId(a,s){a&&(this.calleeAlternateId=a,this.callTelemetry.recordEvent("_SetCalleeAlternateId",{hasCalleeAlternateId:!!a},s))}setEnableCaptcha(a){a!==this.localSignalingParticipant.enableCaptcha&&(this.logger.info(`setting self participant to enable captcha to [${a}]`),this.localSignalingParticipant.enableCaptcha=a,this.enableCaptcha=a)}processCallStartOptions(a,s){const c=this.logger.createFnLogger("_ProcessCallStartOptions",s);try{1&a.preheatFlags&&(this.isPreheatEnabled=!0)}catch(u){c.logFailure(u)}}getlocalScreenShareStream(){return(0,Zr.find)(this.localMediaStreams,a=>a.mediaType===2)}setRoutingTimeout(a){this.routingTimeout=a,this.logger.info(`[routingTimeout=${this.routingTimeout}]`)}setMeetingLayout(a,s){const c=this.logger.createFnLogger("SetMeetingLayout",a);return Promise.resolve().then(()=>this.signalingSession.setMeetingLayoutAsync(a,s)).catch(u=>(c.logFailure(fi(u)),Promise.reject(Mu(u)))).then(()=>this._callOperationHandler.waitForOperation("SetMeetingLayout",a)).catch(u=>{throw this.callTelemetry.updateOperationData("AddBroadcastModality",{error:Hs(u)},a),c.logFailure(u),u})}async selectDevices(a){this.callDeviceManager.isVirtualDeviceEnabled?this.callDeviceManager.selectDevices(a):this.logger.error("allowVirtualDeviceInCall not enabled.")}async getSelectDevices(){return this.callDeviceManager.getSelectedDevices()}createStage(a){throw new Error("Method not implemented.")}updateDisplayName(a){this.logger.info("updating displayName"),this.setDisplayName(a),this.signalingSession.participantManager.localParticipant.displayName=a}init(a){if(this.logger.info(`init callInitOptions:${c2(a)}`),this.signalingSessionCallOptions={teamsMessageId:a.messageId,enableGroupCallMeetupGeneration:a.enableGroupCallMeetupGeneration,meetingInfo:a.meetingInfo,emergencyContent:a.emergencyContent?JSON.parse(a.emergencyContent):void 0,broadcastContext:a.broadcastContext,endpointMetadata:a.endpointMetadata},this.setMessageId(a.messageId),this.onBehalfOfMri=a.onBehalfOf,this.onBehalfOfUserDisplayName=a.onBehalfOfUserDisplayName,a.threadId&&(this.setThreadId(a.threadId),this.signalingSession.setThreadId(a.threadId)),this.groupId&&this.signalingSession.setGroupId(this.groupId),this.signalingSession.setCallOptions(this.signalingSessionCallOptions),a.transferContext){switch(this.logger.info("Transfer: Call.init, set transferContext",Sdi(a.transferContext)),this.signalingSession.setTransferContext(a.transferContext.context),a.transferContext.transferType){case 1:this.setCallOrigin(2);break;case 0:this.setCallOrigin(1);break;case 2:this.setCallOrigin(3);break;default:throw new Error(`TransferType: ${a.transferContext.transferType} doesn't have a switch option`)}a.transferContext.context.callAcceptanceCallback?this._transferredCallAcceptanceCallback=a.transferContext.context.callAcceptanceCallback:this.logger.info("[failed]Transfer: Missing transferred call acceptance callback"),a.transferContext.transferorMri&&this.setTransferorMri(a.transferContext.transferorMri)}this.setIsEmergency(!!a.isEmergency),this.raiseChanged()}async initAsync(a){return this.init(a)}getIncomingRawAudioStream(a=hi()){if(!this.mediaSession)throw this.logger.error("can not execute getIncomingRawAudioStream as there is no mediaSession"),new Error("NoMediaSession");return this.mediaSession.getIncomingRawAudioStream(a)}getUnmixedAudioProvider(){return this.unmixedAudioProvider?Promise.resolve(this.unmixedAudioProvider):Promise.reject("No audio provider available")}setDeviceManager(a){}async startVideo(a,s=hi()){return this.startStopVideo(!0,s,a)}async stopVideo(a,s=hi()){return this.startStopVideo(!1,s,a)}async dumpVideoSourceImages(){return Promise.reject(60)}async hold(a,s=hi(),c,u){const m=this.logger.createFnLogger("Hold",s);return m.info(`[Hold][${s}] negotiationTag ${a} hold options: ${xo(c)}`),this.state===4?(m.logFailure("Trying to put a call on hold which is already held state, early resolving the promise"),Promise.resolve(void 0)):c?.isLocal?this.localHold(s,c,u):this.holdWithRenegotiate(s,c)}async holdWithRenegotiate(a,s){return this.isValidHoldResumeCallState(this.state)?this.setHold(!0,a,s):(this.logger.logFailure(`[Hold][${a}] Trying to hold a call in an invalid state: ${this.state}`),Promise.reject(`Trying to hold a call in an invalid state: ${this.state}`))}async localHold(a,s,c){return this.isValidHoldResumeCallState(this.state)?this.setHold(!0,a,s,c):(this.logger.logFailure(`[LocalHold][${a}] Trying to hold a call in an invalid state: ${this.state}`),Promise.reject(`Trying to hold a call in an invalid state: ${this.state}`))}async unhold(a,s=hi()){const c=this.logger.createFnLogger("Unhold",s);return this.state===3?(c.logFailure("Trying to resume a call which is already in connected state, early resolving the promise"),Promise.resolve(void 0)):this.state===4?(c.info(`current hold state ${this.requestedHoldState}`),this.setHold(!1,s)):(c.logFailure(`Trying to resume a call in an invalid state: ${this.state}`),Promise.reject(`Trying to resume a call in an invalid state: ${this.state}`))}canMerge(a,s){const c=a.isOneToOneCall(),u=this.state===3,m=a.state===4,b=c&&u&&m;return this.logger.info(`[${s}][canMerge] Call ${a.callId} isOneToOne ${c} isCallConnected ${u} call.state ${this.state} isMergeOnHold ${m} mergeCall.state ${a.state} CanMerge result: ${b}`),b}async updateEndpointMetadata(a,s=hi()){return this.signalingSession.updateEndpointMetadata(a,s)}async sendDtmfTone(a){if(this.mediaSession){const s=this.toneToString(a);return s?(this.logger.info(`[${Xa}][sendDtmfTone]DtmfTone: <omitted>`),Promise.resolve(this.mediaSession.sendDtmf(s))):Promise.reject(new Error("Unsupported DtmfTone"))}return Promise.reject(new Error("no mediaSession"))}async setAudioUsageMode(a){return Promise.reject(60)}async setAudioMidcallConfig(a,s){return Promise.reject(60)}async setAudioMidcallConfigJson(a,s=hi()){if(!a)return Promise.reject(60);ow(a.enableSpatialAudio)&&this.mediaSession?.configureSpatialAudio(a.enableSpatialAudio,s),a.noiseSuppressionMode&&await this.setNoiseSuppressionMode(a.noiseSuppressionMode,a.enableAEC)}async setParticipantSpatialAudioPositions(a,s=hi()){const c=a.map(u=>({sourceId:this.participants.find(m=>m.id===u.participantId)?.audio.id,x:u.x,y:u.y}));return this.mediaSession?.setParticipantSpatialAudioPositions(c,s)}async setNoiseSuppressionMode(a,s){return this.mediaSession.getSessionConfig().config.wasmvqe.enableVqe||this.mediaSession.getSessionConfig().config.wasmdns.enableNoiseSuppression?a==="Auto"?this.mediaSession.getSessionConfig().config.wasmvqe.enableVqe?this.mediaAgent.getDeviceManager().setAudioEffects(this.mediaAgent.getDeviceManager().effectsManager.vqeModeToAudioEffectType(this.mediaSession.getSessionConfig().config.wasmvqe.defaultVqeMode)):this.mediaAgent.getDeviceManager().setAudioEffects(this.mediaAgent.getDeviceManager().effectsManager.vqeModeToAudioEffectType(this.mediaAgent.getDeviceManager().effectsManager.nsModeToVqeMode(this.mediaSession.getSessionConfig().config.wasmdns.noiseSuppressionMode,s))):this.mediaSession.getSessionConfig().config.wasmvqe.enableVqe?this.mediaAgent.getDeviceManager().setAudioEffects(this.mediaAgent.getDeviceManager().effectsManager.vqeModeToAudioEffectType(this.mediaAgent.getDeviceManager().effectsManager.nsModeToVqeMode(a,this.mediaSession.getSessionConfig().config.wasmvqe.enableAec))):this.mediaAgent.getDeviceManager().setAudioEffects(this.mediaAgent.getDeviceManager().effectsManager.vqeModeToAudioEffectType(this.mediaAgent.getDeviceManager().effectsManager.nsModeToVqeMode(a,s))):Promise.resolve()}setInitialTelemetry(a,s,c,u){let m,b,_,k,N;switch(a){case"Subscribe":case"SubscribeWithMeetingData":this.callTelemetry.setDirection("Outgoing"),this.callTelemetry.setSelfParticipantRole("SUBSCRIBE"),c||this.callTelemetry.setOperationVariant(a,"CCWM"),this.signalingSession.setInitialTelemetry(a,{correlationId:this.callId,causeId:u,conversationServiceUrl:c});break;case"Acknowledge":this.state!==0&&this.state!==8&&this.callTelemetry.maybeRecordOperationSuccess(a,{code:4}),this.callTelemetry.setDirection("Incoming"),this.callTelemetry.setSelfParticipantRole("callee"),this.signalingSession.setInitialTelemetry(a,{causeId:u});break;case"JoinCall":case"JoinWithMeetingData":this.callTelemetry.setDirection("Incoming"),this.callTelemetry.setSelfParticipantRole("join"),1&s.callStartOptions.preheatFlags&&this.callTelemetry.setOperationVariant(a,"Preheat"),m=this.telemetryDataFromCallStartOptions(s.callStartOptions),m&&this.callTelemetry.updateOperationData(a,m,u),b=!(1&~s.callStartOptions.muteFlags),_=!(1&~s.callStartOptions.preheatFlags),k={muted:b,isPreheatOnly:_},this.signalingSession.setInitialTelemetry(a,{correlationId:this.callId,causeId:u,conversationServiceUrl:c,joinCallOptions:k,offerGenerationTime:Date.now()-s.callStartTime});break;case"StartCall":case"StartWithMeetingData":this.callTelemetry.setDirection("Outgoing"),this.callTelemetry.setSelfParticipantRole("caller"),1&s.callStartOptions.preheatFlags&&this.callTelemetry.setOperationVariant(a,"Preheat"),m=this.telemetryDataFromCallStartOptions(s.callStartOptions),m&&this.callTelemetry.updateOperationData(a,m,u),N=s.callStartOptions,this.signalingSession.setInitialTelemetry(a,{correlationId:this.callId,causeId:u,conversationServiceUrl:c,callStartOptions:N,offerGenerationTime:Date.now()-s.callStartTime});break;case"StartCallToVoiceMail":case"StartCallWithNudge":case"StartCallAndUnpark":this.callTelemetry.setDirection("Outgoing"),this.callTelemetry.setSelfParticipantRole("caller"),this.signalingSession.setInitialTelemetry(a,{correlationId:this.callId,causeId:u,conversationServiceUrl:c,startCallOptions:s.callStartOptions,offerGenerationTime:Date.now()-s.callStartTime})}}async setHold(a,s,c,u){const m=this.logger.createFnLogger("setHold",s,`hold=${a}`);if(!this.canToggleAudio||this.callHoldResumeDeferred)return Promise.reject(new Error("can not set hold as it is already in progress"));this.callHoldResumeDeferred=new Pi,this.isHoldInProgress=a,this.canToggleAudio=!1,this.canToggleVideo=!1,this.canToggleScreenSharing=!1,this.requestedHoldState=a;const b=()=>{this.canToggleAudio=!0,this.canToggleScreenSharing=!0,this.canToggleVideo=!0};m.info(`start, holdOptions: ${JSON.stringify(c)}`);const _=this.callHoldResumeDeferred.promise,k=a?"Hold":"Unhold",N={debugContent:{clientScenario:this.convertClientScenario(u)}};try{if(a?this.isMuteOnHold=c&&c.isLocal&&this.state!==5:this.prepareModalitiesForResume(s),!this.isMuteOnHold){const ee=await this.updateMediaModalities(void 0,s);this.updateMediaState(ee,s),this.updateScreenSharingState(ee,s)}a&&(this.prepareModalitiesForHold(s),this.state===5&&this.finishCallHoldResume(),this.setCallState(4,s)),this.isMuteOnHold&&this.setMuteOnHold(a,s),b();const W={code:0,subCode:0,phrase:""};this.callTelemetry.recordOperationSuccess(k,W,null,s,N)}catch(W){this.callTelemetry.recordOperationFailure(k,{error:Hs(W)},null,s,N),m.logFailure(W),b(),this.callHoldResumeDeferred?.reject(new Error(`Failed setting hold state to ${a}`)),this.callHoldResumeDeferred=null}return _}transferCall(a){return this.logger.warn("transferCall is deprecated, please use callBlindTransfer instead"),this.callBlindTransfer(a)}callBlindTransfer(a,s=hi(),c){return this.executeCallTransfer(a,s,0,c)}callSafeTransfer(a,s=hi(),c){return this.executeCallTransfer(a,s,0,c)}transferCallToVoicemail(a,s=hi()){return this.executeCallTransfer(a.transferTargetMri,s,2,void 0)}callConsultativeTransfer(a,s=hi(),c,u){const m=this.logger.createFnLogger("ConsultativeTransfer",s);let b;a.participants.length>1?(b=this.getParticipantByLegId(c,a),b||(m.warn("getParticipantByLegId did not find a match in the participants list, defaulting to first participant"),b=a.participants[0])):b=a.participants[0];const _=b&&b.acceptedBy||b&&b.id;return m.info(`transferTargetParticipantLegId: ${c} targetMri: ${kn(_)}`),this.executeConsultCallTransfer(a.callId,_,c,s,u)}async consultativeTransferWithPickupCode(a,s){const c=this.logger.createFnLogger("ConsultativeTransferWithPickupCode",s);if(c.info(`pickup code: ${a}`),!a||isNaN(Number(a)))return c.info("pickup code cannot be empty"),Promise.reject(Mu("TransactionDisallowed"));const u=this._callOperationHandler.createPendingOperation("_CallTransferInProgress",void 0,s,{preconditionTags:["NOT_SUPPORTED_IN_STREAMING_MODE"]}),m=`4:${Ub.SERVER_HOLD}`,b={unparkContent:{pickupCode:Number(a)}},_={disableForwardingAndUnanswered:!1};return this.signalingSession.transferCallAsync(m,"TransferTypeStandard",b,_,s),u}callRedirect(a,s=hi()){return this.logger.createFnLogger("CallRedirect",s).info(`redirectOptions: ${JSON.stringify(a)}`),this.stopInternal({terminatedReason:75,redirectOptions:a,causeId:s}).then(()=>({code:er.CallRedirected,subCode:Ml.CallRedirectedSuccess,phrase:Ug.CallEndReasonRedirected,resultCategories:["Success"]}))}convertParkContext(a){switch(a){case 1:return"sharedLinePark";case 4:return"sharedLineParkV2";case 0:return"teamPark";case 3:return"serverHoldV2";case 5:return"callPark";default:return"serverHold"}}convertClientScenario(a){switch(a){case 0:return"breakoutRoom";case 1:return"musicOnHoldV2";case 2:return"sharedLineAppearanceV2";default:return}}park(a,s=hi()){const c=this.convertParkContext(a);return this.logger.info(`[${s}] [ParkCall] start -  context ${a} parkType ${c}`),a===5?(this.callTelemetry.recordOperation(`${hte(c)}`,s),this._pendingParkPromise=this._callOperationHandler.createPendingOperation("CallParkV2",void 0,s)):this._pendingParkPromise=this._callOperationHandler.waitForOperation("ParkCall"),c!=="serverHoldV2"&&c!=="callPark"&&this._setParkState(1),this.signalingSession.parkCallAsync(c,s).catch(u=>{this.logger.info(`[${s}] [ParkCall] error in parkCallAsync (synchronous error) : ${Hs(u)}. Hold promise will be rejected by signaling callback`),this.callTelemetry.updateOperationData("ParkCall",{error:Hs(u)},s)}),this._pendingParkPromise}async unpark(a,s){const c=this.convertParkContext(a);return this.logger.info(`[${s}] [UnparkCall] start -  context ${a} parkType ${c}`),this._pendingUnparkPromise=this._callOperationHandler.waitForOperation("UnparkCall"),this.signalingSession.unparkAsync(c,s).catch(u=>{this.logger.info(`[${s}] [UnparkCall] error in unparkAsync (synchronous error) : ${Hs(u)}. Unhold promise will be rejected by signaling callback`),this.callTelemetry.updateOperationData("UnparkCall",{error:Hs(u)},s)}),this._pendingUnparkPromise}getServerHoldLocation(){return this._pendingParkPromise.then(()=>(this.logger.info(`getServerHoldLocation ${this.serverHoldLocation}`),this.serverHoldLocation))}getParkAdditionalContextJson(){return this._pendingParkPromise.then(()=>(this.logger.info(`getParkAdditionalContextJson ${this.parkAdditionalContextJson}`),this.parkAdditionalContextJson))}getJoinBlob(){return Promise.resolve(JSON.stringify({conversationUrl:this.signalingSession.getConversationUrl(),conversationId:this.callId}))}getTechnicalInformationJson(){return Promise.resolve(JSON.stringify(this.mediaSession.getCallTechnicalInfo()))}isOneToOneCall(a=!1){if(a){const s=(this.state,[0,1]);return this.callType===1&&s.includes(this.participants.length)}return this.callType===1&&this.participants.length===1}setMuteOnHold(a,s){this.mediaSession.muteHold(a,s),a||(this.computeCallState(s),this.isMuteOnHold=!1),this.finishCallHoldResume()}finishCallHoldResume(a){a?this.callHoldResumeDeferred?.reject(a):this.callHoldResumeDeferred?.resolve(),this.isHoldInProgress=!1,this.callHoldResumeDeferred=null}computeCallState(a){let s=3;this._callInLobby?s=10:this.signalingSession.participantManager.localParticipant.isStaging&&(s=13),this.logger.info(`[${a}][computeCallState] the call state will be set to ${s}`),this.setCallState(s,a)}async prepareModalitiesForResume(a){this.mediaStateConfigurationHelper.isSending(1)&&await this.turnOnLocalVideoPreview(a)}async prepareModalitiesForHold(a){await this.turnOffLocalVideoPreview(a)}updateMediaState(a,s){this.setVideoOn(a.video===this.mediaAgent.constants.MEDIA_STATE.sendReceive||a.video===this.mediaAgent.constants.MEDIA_STATE.send,s),this.setAudioOn(a.audio===this.mediaAgent.constants.MEDIA_STATE.sendReceive||a.audio===this.mediaAgent.constants.MEDIA_STATE.send,s)}updateScreenSharingState(a,s){this.setScreenSharingOn(a.sharing===this.mediaAgent.constants.MEDIA_STATE.send,s)}onSharingStreamStateChanged(a){const s=hi();this.logger.info(`[${s}] Sharing stream state moved to ${a}`);const c={mediaType:2,mediaDirection:1,mediaStreamState:Pv.streamingStatetoMediaStreamState(a)};this.event("mediaStreamStateChanged").raise(c),this.callStats.localStats.screenShare.streamStateChanged(a),a==="stopped"&&(this.canToggleScreenSharing=!0,this.stopScreenSharing(),this.conversationType!=="screenSharingCall"||this.participants.some(u=>u.state===3)||this.stop(!0,s))}async startScreenSharing(a,s,c,u=hi()){this.allowScreenSharingControl()&&(this.screenSharingControl.isInternalViewerControlEnabled()&&this.screenSharingControl.shutdownControlForViewer(),this.screenSharingControl.isInternalSharerControlEnabled()&&this.screenSharingControl.initControlForSharer(c));const m=this.logger.createFnLogger("StartScreenSharing",u);return m.info(`started. negotiationTag is ${c}`),this.canToggleScreenSharing?this.isScreenSharingOn?(m.logSuccess("Resolving early because screen sharing is already on"),Promise.resolve()):(this.screenSharingRenegotiationDeferred&&(m.logFailure("called before the renegotiation deferred for the previous one has been closed"),this.screenSharingRenegotiationDeferred.resolve()),this.screenSharingRenegotiationDeferred=new Pi,this.callStats.localStats.newSession(2),this.callStats.localStats.screenShare.start(),this.mediaStateConfigurationHelper.isDisabled(2)&&m.info("sharing modality was skipped till now. Adding it now"),this.canToggleScreenSharing=!1,this.callStats.localStats.screenShare.event(0),this.getScreenHandle(a).acquire().then(()=>(m.logSuccess("sharing stream acquired"),this.mediaStateConfigurationHelper.enableModality(2),this.allowDataChannel()&&this.mediaStateConfigurationHelper.enableModality(3),this._delayedElevationPending&&!this._delayedElevationQueued?this.triggerDelayedReconnectIfNeeded(u):Promise.resolve())).then(()=>this.updateMediaModalities(void 0,u,c)).then(()=>(m.logSuccess("updateMediaModalities done"),this.callStats.localStats.screenShare.negotiationStateChanged("started"),this.setScreenSharingOn(!0,u),this.canToggleScreenSharing=!0,this.screenSharingRenegotiationDeferred.promise)).then(()=>{this.enableControlInjector(),this.callStats.localStats.screenShare.negotiationStateChanged("completed")}).catch(b=>{this.callTelemetry.updateOperationData("StartScreenSharing",{error:Hs(b)},u),this.setScreenSharingOn(!1,u),this.mediaStateConfigurationHelper.removeModality(2),this.canToggleScreenSharing=!0,this.disposeSharingScreenHandle();const _=b.error;throw _&&_.code===er.GlareError?(this.callStats.localStats.screenShare.negotiationStateChanged("rejected","glare"),m.logFailure("starting screen sharing failure with reason glare")):b.reason==="ScreenSharingStopped"?(this.callStats.localStats.screenShare.negotiationStateChanged("rejected","sharingStopped"),m.logFailure("expected starting screen sharing failure with reason stopped")):(this.callStats.localStats.screenShare.negotiationStateChanged("rejected","other"),m.logFailure(b)),b})):Promise.reject(new Error("cannot start screen sharing"))}async stopScreenSharing(a,s,c=hi()){const u=this.logger.createFnLogger("StopScreenSharing",c);if(u.info(`started. negotiationTag is ${s}`),!this.canToggleScreenSharing)throw u.logFailure("cannot stop screen sharing"),new Error("cannot stop screen sharing");if(this.isScreenSharingOn||this._callOperationHandler.hasPendingOperation("StartScreenSharing")){this.screenSharingRenegotiationDeferred&&(this.screenSharingRenegotiationDeferred.reject({reason:"ScreenSharingStopped"}),this.screenSharingRenegotiationDeferred=null),this.mediaStateConfigurationHelper.removeModality(2),this.canToggleScreenSharing=!1,this.allowScreenSharingControl()&&this.screenSharingControl.isInternalSharerControlEnabled()&&this.screenSharingControl.shutdownControlForSharer(),await this.updateMediaModalities(void 0,c,s),this.canToggleScreenSharing=!0,this.callStats.localStats.screenShare.stop(),this.disposeSharingScreenHandle(),this.mediaAgent.getDeviceManager().shareSystemSound(!1),this.mediaAgent.getDeviceManager().setAudioSharingRequested(!1);try{this.setScreenSharingOn(!1,c)}catch(m){throw u.logFailure(m),this.callTelemetry.updateOperationData("StopScreenSharing",{error:Hs(m)},c),m}}else u.logFailure("screensharing is not on, ignore this operation")}async startDataChannel(a,s=hi()){if(!this.allowDataChannel())throw new Error("startDataChannel is disabled since ECS flag prohibits it");this.mediaStateConfigurationHelper.enableModality(3),await this.updateMediaModalities({},s)}async stopDataChannel(a,s=hi()){if(!this.allowDataChannel())throw new Error("stopDataChannel is disabled since ECS flag prohibits it");this.mediaStateConfigurationHelper.removeModality(3),await this.updateMediaModalities({},s)}allowDataChannel(){return this.mediaSession?!!this.mediaSession.getSessionConfig().mediaConfig.simulcastSessionEnabled&&(this.isOneToOnePSTNCall()?this.mediaSession.getSessionConfig().config.enableDataChannelPstn:this.mediaSession.getSessionConfig().config.enableDataChannel):(this.logger.warn("datachannel not allowed as there is no mediaSession"),!1)}isInitialSignalingDSHSubscriptionEnabled(){const a=this.mediaSession?.getSessionConfig()?.config;return a?!this.allowDataChannel()||a.enableInitialSignalingDSHSubscription:(this.logger.warn("Initial signaling dsh subscription is enabled as there is no mediaSession, sessionConfig or sessionConfig.config"),!0)}allowScreenSharingControl(){return this.screenSharingControl?.isScreenSharingControlEnabled()&&this.allowDataChannel()}updateSignalingDSHMessageSubscription(a){this.signalingSession.updateDominantSpeakerHistoryMessageSubscription(a),a&&this.mediaSession?.getDiagnostics?.().dshDiagnostics.setCurrentActiveStrategy("signaling")}async sendUserEvents(a,s){return this.dataChannel.sendUserEvents(a,s)}async shareSystemSound(a,s=hi()){const c=this.logger.createFnLogger("ShareSystemSounds",s,`shareSystemSound=${a}`);if(!(this.mediaSession&&this.mediaSession.getSessionConfig().mediaConfig.simulcastSessionEnabled&&this.mediaSession.getSessionConfig().config.enableAudioSharing&&this.mediaSession.getSessionConfig().config.requireUserActionForAudioSharing))return c.error("shareSystemSound not allowed"),Promise.reject(60);try{return void this.mediaAgent.getDeviceManager().shareSystemSound(a)}catch{return c.error("shareSystemSound failed with device error"),Promise.reject(58)}}async mute(a=sC()){return this.isMuted?Promise.reject(Mu("TransactionDisallowed")):this.muteUnmute(!0,a)}async unmute(a=sC()){return this._callOperationHandler.hasPendingOperation("_PromotionToRealtime")&&await this._callOperationHandler.waitForOperation("_PromotionToRealtime"),this.muteUnmute(!1,a)}async muteSpeaker(a=hi()){return this.muteUnmuteSpeaker(!0,a)}async unmuteSpeaker(a=hi()){return this.muteUnmuteSpeaker(!1,a)}async getSpeakerVolume(a=hi()){return await this.mediaSession.getSpeakerVolume(a)}async setSpeakerVolume(a,s=hi()){return this.mediaSession.setSpeakerVolume(a,s)}async muteParticipants(a,s,c=sC()){const u=this.logger.createFnLogger("MuteParticipants",c,`muteScope=${a}`);u.info(`callParticipants count=${s.length}`);const m=Pv.convertMuteScope(a);if(m===void 0)return u.logFailure(`Unrecognized ${a}`),Promise.reject(new Error("Unrecognized muteScope"));if(t9(this.state,[11,12]))return u.logFailure("Can not mute/unmute during preheat call"),Promise.reject(60);const b=[];return s.forEach(_=>{b.push(_.id)}),this.signalingSession.muteAsync(m,b,c).then(_=>this.handleParticipantsMutedUpdated(_,c)).catch(_=>(this.callTelemetry.updateOperationData("MuteParticipants",{error:Hs(_)},c),u.logFailure(_),_?.endCode?Promise.reject(_.endCode):Promise.reject(_)))}async startAudio(a,s=hi()){const c=this.logger.createFnLogger("StartAudio",s);if(this.receiveOnlyAudioOnCallStart=!1,this.state!==3)return c.logFailure("Cannot startAudio when call is not connected"),Promise.reject(60);if(this.mediaStateConfigurationHelper.enableModality(0),this.callUsesMixer&&this.mediaStateConfigurationHelper.removeModality(1),this.mediaStateConfigurationHelper.isSending(1))try{await this.turnOnLocalVideoPreview(s)}catch(m){return c.logFailure(m),Promise.reject(25)}const u=await this.startStopAudio(!0,s);return await this.signalingSession.recordTelemetryForStartAudio(u),{code:u}}async stopAudio(a,s=hi()){const c=this.logger.createFnLogger("StopAudio",s);if(this.state!==3)return c.logFailure("Cannot stopAudio when call is not connected"),Promise.reject(60);this.mediaStateConfigurationHelper.removeModality(0);const u=await this.startStopAudio(!1,s);return await this.turnOffLocalVideoPreview(s),await this.signalingSession.recordTelemetryForStopAudio(u),{code:u}}assimilate(a,s,c,u=hi()){return Promise.reject(new Error("Not implemented"))}async merge(a,s,c=hi()){const u=this.logger.createFnLogger("MergeCall",c);u.error(`merge callId ${a.callId} callMergeOptions ${JSON.stringify(s)}`);const m=this.canMerge(a,c);if(!m)return u.info(`Error. ${fi(m)}`),Promise.reject(Mu("TransactionDisallowed"));const b=[];return a.participants.forEach(_=>{b.push(this._callOperationHandler.createPendingOperation("MergeCall",_.id,c))}),(await this.mergeCallByAddParticipantWithReplaces(s,a.participants,a,1,"MergeCall",c,b,void 0))[0]}async mergeParticipants(a,s,c,u,m){const b=this.logger.createFnLogger("MergeParticipants",u),_=[];if(!a)return Promise.reject(Mu("Invalid callToMerge"));if(s.length===0)return Promise.reject(Mu("Invalid participantIds"));const k=[];for(const N of s){let W=O2(a,N);if(!W&&JG(a,N)&&(b.info("found self endpoint, use localSignalingParticipant"),W=this.localSignalingParticipant),W){const ee=sC(),oe={id:W.id,participantId:ee,replacementParticipantId:N,nonMaskedId:W.nonMaskedId};_.push(oe),k.push(this._callOperationHandler.createPendingOperation("MergeParticipant",ee,u))}else{const ee={code:406,subCode:5201,phrase:`participantLegId ${N} is invalid!`};k.push(Promise.reject(Mu(ee)))}}return this.mergeCallByAddParticipantWithReplaces(c,_,a,3,"MergeParticipant",u,k,m)}async mergeWithPickupCode(a,s,c=hi()){const u=this.logger.createFnLogger("MergeWithPickupCode",c);if(u.info(`mergeWithPickupCode: pickup code: ${a}, groupId: ${kn(s.groupId)}, threadId: ${Qu(s.threadId)} messageId: ${s.messageId}`),!a||isNaN(Number(a)))return u.info("mergeWithPickupCode: pickup code cannot be empty"),Promise.reject(Mu("mergeWithPickupCode: pickup code cannot be empty"));const m={additionalData:s.additionalData,groupId:s.groupId,threadId:s.threadId,messageId:s.messageId,replacementType:2,pickupCode:Number(a)},b={id:`4:${Ub.SERVER_HOLD}`};return Promise.resolve().then(()=>Promise.all(this.signalingSession.addParticipantsAsync([b],m,c))).then(_=>(_.length>0&&this.signalingNotifications.onParticipantJoined(_[0],c),Promise.resolve({code:0,subCode:0,phrase:"TransactionComplete"}))).catch(_=>{u.logFailure(`Participant was not added to call, error=${fi(_)}`);const k=this._handleParticipantOperationFailure("MergeWithPickupCode",_,c,null,!0).reason;return Promise.reject(_?_.endCode:k||0)})}async setMaxVideoChannels(a){return Promise.reject(60)}async setMaxVbssChannels(a){return Promise.reject(60)}async stop(a=!1,s=hi(),c,u){const m=this.logger.createFnLogger("StopAudio",s);if(this.state===6)return m.logFailure("Trying to stop a call which is already Disconnecting"),Promise.reject(new Error("cannot stop call in Disconnecting state"));if(this.state===7)return m.logFailure("Trying to stop a call which is already Disconnected"),Promise.reject(new Error("cannot stop call in Disconnected state"));if(this.disposedPromise)return m.logFailure("Call already ended"),Promise.reject("Call already ended");let b=0;this.state===1&&(b=10);const _=u?{clientReasonSubCode:u.clientSubCode,clientReasonPhrase:u.clientPhrase}:{};u?.clientSubCode===$d.SUB_CODE.VDI_DISCONNECTED&&this.mediaSession?.getSessionConfig()?.config.vdiDisconnectedTracking.enabled&&this.mediaSession?.getSessionConfig()?.config.vdiDisconnectedTracking.clientPhrases.includes(u?.clientPhrase)&&(_.code=$d.CODE.MEDIA_ERROR,_.subCode=$d.SUB_CODE.VDI_DISCONNECTED,_.phrase=Ug.CallEndReasonVDIdisconnect,_.resultCategories=["UnexpectedClientError"],b=4);const k={terminatedReason:b,forEveryone:a,causeId:s,...c,rejectReason:_};return this.stopInternal(k)}publishState(a,s){const c=L2(a.type),u=this.getPluginlessPublishLevel(a.level),m=a.participantIds&&a.participantIds.length>0?"specified":void 0;return this.callTelemetry.setOperationVariant("PublishState",m==="specified"?`${c}Specified`:`${c}None`,s),this.signalingSession.publishStateAsync(c,u,s,a.content,m,a.participantIds)}publishStatesForEveryone(a,s){const c=L2(a.type),u=this.getPluginlessPublishLevel(a.level);return this.callTelemetry.setOperationVariant("PublishState",`${c}All`),this.signalingSession.publishStateAsync(c,u,s,a.content,"all")}removeState(a,s){return this.signalingSession.removeStateAsync(s,"specified",void 0,a.stateIds).then(c=>Promise.resolve())}removeStatesForEveryone(a,s){const c=L2(a.type);return this.signalingSession.removeStateAsync(s,"all",c,void 0).then(u=>Promise.resolve())}updateMeetingSettings(a,s){return this.signalingSession.updateMeetingSettingsAsync({allowRaiseHands:a.allowRaiseHands,attendeeRestrictions:a.attendeeRestrictions,lockMeeting:a.lockMeeting,breakoutRoomsEnabled:a.breakoutRoomsEnabled,allowPresentersToManageBreakoutRooms:a.allowPresentersToManageBreakoutRooms,disableMdpClientAudioRecording:a.disableMdpClientAudioRecording,refreshSettings:a.refreshSettings,aiInterpretationEnabled:a.aiInterpretationEnabled,groupCopilotDetails:a.groupCopilotDetails},s)}updateMeetingGroups(a,s){this.logger.info(`[UpdateMeetingGroups][${a}] options ${xo(s)}`);const c=this._callOperationHandler.waitForOperation("UpdateMeetingGroups",a),u={fromGroup:s.fromGroup,toGroup:s.toGroup,scope:pui(s.scope)};return s.participants&&(u.participants=hui(s.participants)),this.signalingSession.updateMeetingsGroupsAsync(a,u).catch(m=>{this.logger.info(`[${a}] [UpdateMeetingGroups] error in updateMeetingGroups (synchronous error) : ${Hs(m)}. updateMeetingGroupsPromise will be rejected by signaling callback`),this.callTelemetry.updateOperationData("UpdateMeetingGroups",{error:Hs(m)},a)}),c}updateMeetingLiveState(a,s){return this.logger.info(`[UpdateMeetingLiveState][${a}] options ${xo(s)}`),this.signalingSession.updateMeetingLiveStateAsync(a,s).catch(c=>{this.logger.info(`[${a}] [UpdateMeetingLiveState] error in updateMeetingLiveState (synchronous error) : ${Hs(c)}. promise will be rejected by signaling callback`),this.callTelemetry.updateOperationData("UpdateMeetingLiveState",{error:Hs(c)},a)}),this._callOperationHandler.waitForOperation("UpdateMeetingLiveState",a)}updateMeetingStates(a,s=hi()){var c;this.logger.info(`[UpdateMeetingStates][${s}]`);const u={},m=[];a.operationId=a.operationId||s;for(const b of Object.keys(a.meetingStates)){const _=a.operationId+"_"+b;m.push(_);const k=this._callOperationHandler.createPendingOperation("UpdateMeetingStates",_,s);u[c=a.operationId]??(u[c]={}),u[a.operationId][b]=k,this.callTelemetry.recordOperation("UpdateMeetingStates",s,_)}return Promise.resolve().then(()=>this.signalingSession.updateMeetingStatesAsync(s,a)).then(b=>{for(const _ of m)this.callTelemetry.updateOperationData("UpdateMeetingStates",{data:Hs(b)},s,_)}).catch(b=>{for(const _ of m)this.callTelemetry.updateOperationData("UpdateMeetingStates",{error:Hs(b)},s,_);this.logger.logFailure(b)}).then(()=>u)}async updateParticipantInterpretationState(a,s){if(this.logger.info(`[UpdateParticipantInterpretationState][${a}] options ${xo(s)}`),s.length===0)return Promise.reject(Mu("Invalid UpdateParticipantInterpretationState options"));const c=this.signalingSession.updateParticipantInterpretationStateAsync(a,s),u=[];s.forEach(m=>{u.push(this._callOperationHandler.createPendingOperation("UpdateParticipantInterpretationState",m.id,a))});for(let m=0;m<c.length;m++){const b=c[m],_=s[m];b.then(()=>{this.logger.logSuccess(`updateParticipantInterpretationState succeeded for [id=${kn(_.id)}]`);const k={code:0,subCode:0,phrase:""};this.callTelemetry.recordOperationSuccess("UpdateParticipantInterpretationState",k,_.id,a),this._callOperationHandler.maybeResolveOperation("UpdateParticipantInterpretationState",k,_.id,a)}).catch(k=>{this.logger.error(`[${a}] [UpdateParticipantInterpretationState] error in updateParticipantInterpretationState (synchronous error) : ${Hs(k)}. updateParticipantInterpretationStatePromise will be rejected by signaling callback`),this.callTelemetry.updateOperationData("UpdateParticipantInterpretationState",{error:Hs(k)},a);const N=this._handleParticipantOperationFailure("UpdateParticipantInterpretationState",k,a,_.id).reason,W=k?.endCode||N||0;this._callOperationHandler.maybeRejectOperation("UpdateParticipantInterpretationState",W,_.id,a)})}return Promise.resolve(u)}async updateParticipantsProperties(a,s){const c=this.logger.createFnLogger("UpdateParticipantsProperties",s);if(c.info(`options ${kn(xo(a))}`),!a)return Promise.reject(Mu("Invalid input: UpdateParticipantsPropertiesContext"));const u={},m=a.scope,b=a.operationId,_=new Set;if(m==="self"){const k=this.signalingSession.participantManager.localParticipant.id;for(const N in a.propertyBag){const W=De(k,b,N),ee=this.createUpdateParticipantPromise(W,s);u[W]={[k]:ee},_.add(W),this.callTelemetry.recordOperation("UpdateParticipantsProperties",s,kn(W))}}else{if(m!=="specified"||!this._isUpdatePropertiesSpecifiedAllowedByEcs)return Promise.reject("This scope is not supported.");{const k=a.participants;for(const N of k){const W=N.id;for(const ee in N.propertyBag){const oe=De(W,b,ee),de=this.createUpdateParticipantPromise(oe,s);u[oe]={[W]:de},_.add(oe),this.callTelemetry.recordOperation("UpdateParticipantsProperties",s,kn(oe))}}}}return c.info(`promises created: ${kn(xo(u))}`),this.signalingSession.updateParticipantsPropertiesAsync(a,_,b,s).catch(k=>{const N=fi(k);c.info(`[failed][reason=${N}]`);const W={...k};this.callTelemetry.updateOperationData("UpdateParticipantsProperties",{error:Hs(N)},s);for(const ee of Object.keys(u))this._callOperationHandler.maybeRejectOperation("UpdateParticipantsProperties",W,ee,s)}),Promise.resolve().then(()=>u)}joinMeetingGroup(a,s){this.logger.info(`[JoinMeetingGroup][${a}] options ${xo(s)}`);const c=this._callOperationHandler.waitForOperation("JoinMeetingGroup",a),u={..."meetingGroupId"in s&&{meetingGroupId:s.meetingGroupId},..."meetingGroupLabel"in s&&{meetingGroupLabel:s.meetingGroupLabel},...s.groupPreferences&&{groupPreferences:s.groupPreferences}};return this.signalingSession.joinMeetingGroupAsync(a,u).catch(m=>{const b=Hs(m);this.logger.info(`[${a}] [JoinMeetingGroup] error in joinMeetingGroup (synchronous error) : ${b}. joinMeetingGroupPromise will be rejected by signaling callback`),this.callTelemetry.updateOperationData("JoinMeetingGroup",{error:b},a)}),c}leaveMeetingGroup(a,s){this.logger.info(`[LeaveMeetingGroup][${a}] options ${xo(s)}`);const c=this._callOperationHandler.waitForOperation("LeaveMeetingGroup",a),u={meetingGroupId:s.meetingGroupId};return this.signalingSession.leaveMeetingGroupAsync(a,u).catch(m=>{const b=Hs(m);this.logger.info(`[${a}] [LeaveMeetingGroup] error in leaveMeetingGroup (synchronous error) : ${b}. leaveMeetingGroupPromise will be rejected by signaling callback`),this.callTelemetry.updateOperationData("LeaveMeetingGroup",{error:b},a)}),c}sendMessages(a,s){var c,u;this.logger.info(`[SendMessages][${a}]`);const m={};for(const b of s)if(b.scope===0){const _=this._callOperationHandler.createPendingOperation("SendMessages",b.operationId,a);m[b.operationId]={all:_},this.callTelemetry.recordOperation("SendMessages",a,b.operationId)}else if(b.scope===1){for(const _ in b.to)if(b.to[_].level==="participant"){const k=Q(_,b.operationId),N=this._callOperationHandler.createPendingOperation("SendMessages",k,a);m[c=b.operationId]??(m[c]={}),m[b.operationId][_]=N,this.callTelemetry.recordOperation("SendMessages",a,k)}else if(b.to[_].level==="endpoint")for(const k in b.to[_].participantLegIdMap){const N=me(k,b.operationId),W=this._callOperationHandler.createPendingOperation("SendMessages",N,a);m[u=b.operationId]??(m[u]={}),m[b.operationId][k]=W,this.callTelemetry.recordOperation("SendMessages",a,N)}}return this.signalingSession.sendProxiedMessageAsync(a,s).then(b=>{for(const _ of b)_.then(k=>{this._callOperationHandler.maybeResolveOperation("SendMessages",k.transactionEnd,k.resolveString,k.causeId)}).catch(k=>{this._callOperationHandler.maybeRejectOperation("SendMessages",k.transactionEnd,k.resolveString,k.causeId)});return m})}async updateMonitorSession(a,s=hi()){this.logger.info(`updateMonitorSession: monitorActionType: ${a.monitorActionType}, monitorData: ${a.monitorData}`);const c=fdi(a.monitorActionType);if(c===void 0){const b={code:$d.CODE.CLIENT_ERROR_CODE,subCode:$d.SUB_CODE.INVALID_DATA_TYPE,phrase:`Invalid monitor action type ${a.monitorActionType}`};return Promise.reject(b)}const u={monitorActionType:c,monitorData:a.monitorData},m=this._callOperationHandler.waitForOperation("UpdateMonitorSession","",s);return this.signalingSession.updateMonitorSessionAsync(u,s).catch(b=>{const _=Hs(b);this.logger.info(`[${s}] [UpdateMonitorSession] error in updateMonitorSession (synchronous error): ${JSON.stringify(_)}. updateMonitorSessionPromise will be rejected by signaling callback`),this.callTelemetry.updateOperationData("UpdateMonitorSession",{error:_},s)}),m}switchInterpreterGroup(a){return Promise.reject(new Error("Not implemented"))}setLiveInterpretationAttributes(a,s){return Promise.reject(new Error("Not implemented"))}async updateMeetingRoles(a,s,c=hi()){return this.state===3&&this.signalingSession.hasOwnProperty("updateMeetingRolesAsync")?this.signalingSession.updateMeetingRolesAsync(a,s,c):Promise.reject({code:$d.CODE.CLIENT_ERROR_CODE,subCode:$d.SUB_CODE.ACTION_NOT_ALLOWED,phrase:"ActionNotAllowed"})}stopInternal(a){const s=this.logger.createFnLogger("stopInternal",a.causeId),c=a.terminatedReason||0;let u=a.rejectReason&&(a.rejectReason.code||a.rejectReason.subCode)?a.rejectReason:this.getRejectionInfoFromTerminatedReason(c);if(a.rejectReason&&(u||(u={}),u.clientReasonSubCode=a.rejectReason.clientReasonSubCode,u.clientReasonPhrase=a.rejectReason.clientReasonPhrase),s.info(`started, terminatedReason=${c}, rejectReason=${xo(u)}`),this.state===6)return s.logFailure("Trying to stop a call which is already Disconnecting"),this.disconnectingPromise;if(this.state===7)return s.logFailure("Trying to stop a call which is already Disconnected"),this.disconnectingPromise;this.setCallState(6,a.causeId,c);const m={causeId:a.causeId,forEveryone:a.forEveryone,scope:this.mapEndpointScope(a.scope),redirectOptions:a.redirectOptions&&hdi(a.redirectOptions)};return a.scope===1&&(u.code=$d.CODE.SUCCESS,u.subCode=$d.SUB_CODE.ENDED_BY_REMOTE_ENDPOINT,u.phrase=Ug.EndedByRemoteEndpoint),this.disconnectingPromise=Promise.all([this.cleanUpMedia(a.causeId,u).then(()=>{this.callTelemetry.recordOperationSuccess("_MediaCleanUp")}).catch(b=>{throw s.logFailure(`cleanUpMedia failed with reason=${fi(b)}`),this.callTelemetry.recordOperationFailure("_MediaCleanUp",{error:Hs(b)},a.causeId),b}),this.signalingSession.endAsync(u,m).catch(b=>{throw s.logFailure(`endAsync failed with reason=${fi(b)}`),b})]).catch(b=>{throw s.logFailure(b),this.cleanUp(a.causeId,u),b}).then(()=>this.cleanUp(a.causeId,u)).catch(b=>{throw this.callTelemetry.updateOperationData("StopCall",{error:Hs(b)},a.causeId),this.setCallState(7,a.causeId,c),b}),this.disconnectingPromise}async cleanUp(a,s){return this.logger.info(`[${a}][cleanup]start`),this.disposedPromise||(this.disposedPromise=this.cleanUpFinalize(a,s),this._getCallEndOperation().catch(Ef).then(()=>{const c={code:$d.CODE.CLIENT_ERROR_CODE,subCode:$d.SUB_CODE.ABANDONED};this._callOperationHandler.rejectPendingOperations(61,a,c),this._participantOperationHandler.rejectPendingOperations(47,a,c)})),this.disposedPromise}async cleanUpMedia(a,s){return this.mediaDisposedPromise||(this.callTelemetry.recordOperation("_MediaCleanUp",a),this.mediaDisposedPromise=(async()=>{this.callDeviceManager?.dispose(),this.callDeviceManager=null,this.turnOffLocalVideoPreview(a),this.localVideoContainer=null,this.disposeContentSharingSessions(),this.disposeSharingScreenHandle();const c=this.mediaSession;if(this.reportMediaStats=!!c,!c)return;this.unmixedAudioProvider.dispose(),this.dataChannel.dispose(),this.screenSharingControl.dispose(a),this.remoteUFDHandler.dispose(),this.mediaSession=null,this.streamManager.setMediaSession(null,a),this.participants?.forEach(m=>{m.setMediaSession(null,a)});const u=c.terminate(a,s);this.isVideoOn=!1,this.setMediaStream(this.isVideoOn,!1,1),this.setMediaStream(!1,!1,2),this.setMediaStream(!1,!1,0),this.isScreenSharingOn=!1,this.screenSharingRenegotiationDeferred?.reject(s),this.screenSharingRenegotiationDeferred=null,this.mediaStateConfigurationHelper.removeModality(1),this.mediaStateConfigurationHelper.removeModality(0),this.mediaStateConfigurationHelper.removeModality(3),this.mediaStateConfigurationHelper.removeModality(2),this.batteryStatus?.dispose(),c?.getSessionConfig()?.config?.useOneDsLogger&&c.getSessionConfig().config.addTelemetryReportingCallback&&window.removeEventListener("beforeunload",this.beforeUnloadTelemetrySender);try{await u}finally{await this.collectCallStats(c),this.callStats.appendMediaControlPlaneInfo(JSON.stringify(c.getMediaControlPlaneInstance()?.getTelemetryReport()))}})()),this.mediaDisposedPromise}async cleanUpFinalize(a,s){try{await this.cleanUpMedia(a,s)}catch(u){this.logger.info(`[${a}][cleanUpMedia] failure: ${fi(u)}`),this.callTelemetry.recordOperationFailure("_MediaCleanUp",{error:Hs(u)},a)}this.callTelemetry.recordOperationSuccess("_MediaCleanUp");const c=this.reportCallEndStats(this.reportMediaStats);this.mediaSession?.getSessionConfig().config.waitReportStatsAtCallStop&&await c}async createContentSharingSession(a,s,c,u,m=hi()){if(this.signalingSession.signalingAgentConfig.checkAttendeeRoleInCreateContentSharing&&(this.advancedMeetingRole||this.meetingRole)==="attendee"){const _={terminatedReason:8,terminatedReasonCode:403,terminatedReasonSubCode:0,errorMessage:"Failed due to insufficient permissions"};return Promise.reject(_)}const b=new BD(this.callTelemetry,this.logger,this.signalingSession,a,s,u,c);return this.contentSharingSessions.push(b),b.changed(()=>this.removeContentSessionIfEnded(b)),this.event("contentSharingChanged").raise(),Promise.resolve(b)}stopWithBeacon(a=hi()){if(this.state===6||this.state===7)return!0;this.mediaSession?.getSessionConfig()?.config?.enableCallStateChangesOnPageClose&&(this.callEndDiagnosticsInfo={callControllerCode:$d.CODE.SUCCESS,callControllerSubCode:$d.SUB_CODE.BEACON},this.callTelemetry.setCallEndDiagnosticInfo(this.callEndDiagnosticsInfo),this.setCallState(6,a,1));const s=this.signalingSession.endWithBeacon(a);return this.mediaSession?.getSessionConfig()?.config?.enableCallStateChangesOnPageClose&&this.setCallState(7,a,1),s}disposeContentSharingSessions(){this.contentSharingSessions.forEach(a=>{a.dispose(),this.removeContentSessionIfEnded(a)}),this.event("contentSharingChanged").raise()}isPreheatedOnly(){return!!(this.state===12||this.state===2&&this._callOperationHandler.hasPendingOperation("JoinPreheatedCall")||this.state===9&&this._callOperationHandler.hasPendingOperation("JoinPreheatedCall"))}removeContentSessionIfEnded(a){a.contentSharingStatus!==7&&a.contentSharingStatus!==8||(this.logger.info("stopping the content sharing session."),(0,Zr.remove)(this.contentSharingSessions,s=>s.contentSharingGuid===a.contentSharingGuid).length&&this.event("contentSharingChanged").raise())}getRejectionInfoFromTerminatedReason(a){switch(a){case 53:return{code:er.MediaError,subCode:Ml.MediaWhiteListingIssue,phrase:Ug.MediaWhiteListingIssue};case 4:return{code:er.MediaError,subCode:this._wasAudioStreamConnected?Ml.MediaDropAfterConnect:Ml.MediaDropDuringConnect,phrase:this._wasAudioStreamConnected?Ug.MediaDropAfterConnect:Ug.MediaDropDuringConnect};case 47:return{code:er.MediaError,subCode:Ml.MediaOfferProcessingError,phrase:Ug.MediaOfferProcessingError};case 38:return{code:er.MediaError,subCode:Ml.MediaRenegotiationError,phrase:Ug.RetargetNotSupported};case 10:return{code:er.Reject,subCode:Ml.Success,phrase:Ug.CallEndReasonLocalUserInitiated};case 25:return{code:er.UnknownError,subCode:Ml.MediaUnknownError,phrase:Ug.MediaError};case 58:return{code:er.MediaError,subCode:Ml.MediaPermissionError,phrase:Ug.MediaPermissionError};case 7:return{code:er.UnknownError,subCode:Ml.Success,phrase:Ug.Unknown};case 0:case 1:return{code:er.Success,subCode:Ml.Success,phrase:Ug.CallEndReasonLocalUserInitiated};case 75:return{code:er.CallRedirected,subCode:Ml.CallRedirectedSuccess,phrase:Ug.CallEndReasonRedirected,resultCategories:["Success"]};case 77:return{code:er.Success,subCode:Ml.Suspended,phrase:Ug.CallEndReasonSuspended}}return null}async acknowledge(a,s,c=hi()){const u=this.logger.createFnLogger("Acknowledge",c),m=Date.now();if(this.setInitialTelemetry("Acknowledge",{callStartTime:m},"",c),this.state!==0&&this.state!==8)throw new Error(`Trying to acknowledge a call that has already been acted on ${this.state}`);u.info(`isMultiParty=${a.isMultiParty}`),u.info(`fromMixer=${a.fromMixer}`),u.info(`participantId=${a.participantId}`),u.info(`callType=${a.callType}`),this.attachToCallAndGetOffer=new Pi,this.setCallType(a.isMultiParty?2:1,c),this.setCallUsesMixer(!!a.fromMixer,c),this.setCallerMri($te(a.callerId)),this.setDisplayNameSource(a.displayNameSource),this.setTransferorMri(a.transferorId),this.transferorType=a.transferorType,this.transferorDisplayName=a.transferorDisplayName,this.incomingCallType=a.callType,this.consultativeCallId=a.consultativeCallId,this.callQueueInfo=a.callQueueInfo,this.setFromApplicationType(a.fromApplicationType,c),this.setCalleeAlternateId(a.calleeAlternateId,c),this.setRoutingTimeout(a.routingTimeout),this.callStats.localStats.startCall();const b=OV(u);try{if(b.executeSync("ProcessIncomingCallRequest",()=>this.signalingSession.processIncomingCallRequest(a,s,c)),this.setParticipantId(this.participantId),b.executeSync("ResolvePotentialConflict",()=>this.signalingAgent.resolvePotentialCallConflict(this.signalingSession))===this.signalingSession)return Promise.reject({code:7,success:!1});const _=async()=>{b.executeSync("InitializeMediaSession",()=>this.initializeMediaSession(c)),this.updateSignalingDSHMessageSubscription(this.isInitialSignalingDSHSubscriptionEnabled());const N=this.signalingSession.getInitialMediaOfferFromIncomingCallPayload();this.callStats.setParticipantId(this.participantId),this.onBehalfOfMri=this.signalingSession.onBehalfOf,this.onBehalfOfUserDisplayName=this.signalingSession.onBehalfOfUserDisplayName,this.callQueueContext=this.signalingSession.callQueueContext,this.callQueueSupervisorContent=this.signalingSession.callQueueSupervisorContent,this.bannerContent=this.signalingSession.bannerContent,this.callPhoneLineType=this.signalingSession.callPhoneLineType;const W=await b.execute("WaitForMediaOffer",()=>N?Promise.resolve(N):this.attachToCallAndGetOffer.promise);let ee;try{ee=await b.execute("ProcessOffer",()=>this.mediaSession.processOfferAsync(W,c))}catch(oe){ee=await this._handleOfferProcessingError(oe,c,u)}await b.execute("ProcessOfferedModalities",()=>this._processOfferedModalities(ee,c))},k=b.execute("SendAttach",()=>this.signalingSession.sendAttachToCall(c)).then(()=>this.setCallState(1,c));return await Promise.all([k,_()]).catch(async N=>{throw await k,N}),await b.execute("TrySendingProvisionalAnswer",()=>this._trySendProvisionalMediaAnswer(c)),b.executeSync("OnAcknowledgeSuccess",()=>this._onAcknowledgeSuccess(u,b.getTelemetryData(),c))}catch(_){return this._onAcknowledgeError(_,c,u,b.getTelemetryData())}}_onMessageIdChanged(a,s){a&&this.messageId!==a&&this.setMessageId(a,s)}async accept(a,s=hi()){const c=this.logger.createFnLogger("Accept",s);if(c.info(`accept, answerMediaType: ${a.answerMediaType},
                            withVideo: ${a.withVideo},
                            muted: ${a.muted},
                            getSendMediaModalities: ${JSON.stringify(a.sendMediaModalities)},
                            clientEndpointCapabilities: ${a.clientEndpointCapabilities},
                            muteFlags: ${a.muteFlags}`),this.state!==1)throw new Error("Only calls in Notified state can be accepted");this.setCallOptions({callStartOptions:a,callStartTime:Date.now()}),this.setSessionIceTransportPolicy(a?.mediaConfiguration);const u=this._callOperationHandler.createPendingOperation("_ConnectCall",void 0,s);this.callStats.localStats.audio.start();const m=OV(c);this.mediaSession.createAudioElement(s);const b=a.muted||!(1&~a.muteFlags),_=!(2&~a.muteFlags);this.setMuted(b?2:this.isServerMuted?1:0,s),this.setSpeakerMuted(_,s),this.setCallState(2,s),this.connectCallPromise=this._callOperationHandler.waitForOperation("Accept");try{a.forceAudioSendModalityWithNullStream&&this.mediaSession.useNullAudioStreamClient(),this.mediaStateConfigurationHelper.setCallAcceptOptions(a),this.mediaStateConfigurationHelper.isSending(1)&&await m.execute("StartVideoSafe",()=>this.startVideoSafe(s)),this.mediaStateConfigurationHelper.isSending(0)&&this.setAudioOn(!0,s);const k=await m.execute("UpdateMediaModalities",()=>this.updateMediaModalities(void 0,s)),N=m.executeSync("GetSignalingMediaTypes",()=>this.getSignalingMediaTypes(k)),W=await m.execute("evaluateEndpointStatesForAccept",()=>this.evaluateEndpointStatesForAccept(this._muteState===2,a?.additionalEndpointProperties,s));await m.execute("MuteUnmuteSpeakers",()=>this.muteUnmuteSpeaker(this.isSpeakerMuted,s));const ee=m.execute("handleEndpointStatesForAccept",()=>this.handleEndpointStatesForAccept(W,s));c.info("Queued the handleEndpointStatesForAccept");const oe=await m.execute("CreateAnswer",()=>this.mediaSession.createAnswerAsync(!1,s));await m.execute("Accept",()=>this.signalingSession.acceptAsync(oe,N,a.clientEndpointCapabilities,s)),await m.execute("WaitForConnect",()=>u),this.handleRemoteParticipantStateInOneToOneCall(s),await m.execute("CompleteNegotiation",()=>this.completeNegotiationAsync(s)),await ee,this.callTelemetry.updateOperationData("Accept",{phases:m.getTelemetryData()},s)}catch(k){let N=7,W={};throw this.callTelemetry.updateOperationData("Accept",this.getTelemetryFromPhaseExecution(k),s),k?.error&&(W={...k.error}),Hte(TV,k)&&(N=47),this.mediaSession?.getSessionConfig().config.stopCallOnAcceptFailure&&this.stopInternal({terminatedReason:N,causeId:s,rejectReason:W}),k.terminatedReason=N,c.logFailure(k),k}}async reject(a=hi(),s){const c=s?{clientReasonSubCode:s.clientSubCode,clientReasonPhrase:s.clientPhrase}:{};return this.state!==1?Promise.reject(60):this.stopInternal({terminatedReason:10,causeId:a,rejectReason:c})}async join(a,s={},c=hi()){const u=Date.now();return this.setInitialTelemetry("JoinCall",{callStartOptions:s,callStartTime:u},a.conversationUrl,c),this.setCallerMri($te(a.groupCallInitiator)),this.connectCallPromise=this._callOperationHandler.waitForOperation("JoinCall"),this.signalingSession.signalingAgentConfig.enableSplitConversationEndUrl&&this.signalingSession.setFsmState(ge.SIGNALING_FSM_STATE.OUTGOING),this.joinOrStartCall({callStartOptions:wN(s),callStartTime:u},this.joinGivenConversation,c,a.conversationUrl)}async joinPreheatedCall(a,s){const c=this.logger.createFnLogger("JoinPreheatedCall",s),u=this.isServerMuted||!(1&~a.muteFlags),m=!(2&~a.muteFlags),b=OV(c);this.connectCallPromise=this._callOperationHandler.waitForOperation("JoinPreheatedCall");try{const _={endpointProperties:{preheatProperties:0}};this.setCallState(2,s),!this.isCallModeStreaming()&&u&&(_.state={isMuted:!0}),c.info(`captchaContentJson=${!!a.captchaContentJson} publishedStates=${!!a.publishedStates} muteFlags=${a.muteFlags}}`),await this.signalingSession.updateEndpointState(_,s,a.publishedStates,a.captchaContentJson),this.computeCallState(s),this.isCallModeStreaming()||(u||(await b.execute("UnmuteInput",()=>this.mediaSession.unmuteInputAsync(s)),this.setMuted(0,s)),m||(await b.execute("UnmuteOutput",()=>this.mediaSession.unmuteOutputAsync(s)),this.setSpeakerMuted(!1,s)))}catch(_){let N;return c.logFailure(`error: 7 ${fi(_)}`),yN(_)?N=_:IN("UnmuteInput",_)?N={code:er.LocalError,subCode:Ml.MediaUnmuteMicrophoneError,phrase:fi(_),causeId:s}:IN("UnmuteOutput",_)&&(N={code:er.LocalError,subCode:Ml.MediaUnmuteSpeakerError,phrase:fi(_),causeId:s}),this.callTelemetry.updateOperationData("JoinPreheatedCall",{phases:b.getTelemetryData(),error:Hs(_)},s),this.stopInternal({causeId:s,terminatedReason:7,rejectReason:N}),Promise.reject(N)}}async start(a={},s=hi()){const c=Date.now();return this.setCallerMri(AN+this.currentUserSkypeIdentity.id),this.setInitialTelemetry("StartCall",{callStartOptions:a,callStartTime:c},"",s),this.connectCallPromise=this._callOperationHandler.waitForOperation("StartCall"),this.signalingSession.signalingAgentConfig.enableSplitConversationEndUrl&&this.signalingSession.setFsmState(ge.SIGNALING_FSM_STATE.OUTGOING),this.joinOrStartCall({callStartOptions:wN(a),callStartTime:c},this.startOutgoingCall,s)}async startCallToVoicemail(a,s=hi()){const c=Date.now();return this.setCallerMri(AN+this.currentUserSkypeIdentity.id),this.setInitialTelemetry("StartCallToVoiceMail",{callVoicemailStartOptions:a,callStartTime:c},"",s),this.connectCallPromise=this._callOperationHandler.waitForOperation("StartCallToVoiceMail"),this.joinOrStartCall({callVoicemailStartOptions:a,callStartTime:c},this.startVM,s)}async joinCallWithoutCallModality(a,s={},c=hi()){const u=Date.now();this.setCallerMri(a.groupCallInitiator),this.setCallType(2,c);const m={callStartOptions:wN(s),callStartTime:u};return this.setInitialTelemetry("Subscribe",m,a.conversationUrl,c),this.state!==0?(this.logger.info(`[${c}][joinCallWithoutCallModality]Trying to subscribe to a call that has already been acted on`),Promise.reject(60)):(this.setCallOptions(m),this.setCallState(8,c),this.signalingSession.subscribeToCall(a.conversationUrl,this.callId,s.clientEndpointCapabilities,{meetingRegistrationId:s.meetingRegistrationId,participantPin:s.participantPin,clientEndpointDebugContent:s.clientEndpointDebugContent,additionalEndpointProperties:s.additionalEndpointProperties},c).catch(b=>yN(b)?(this.logger.info(`[${c}][joinCallWithoutCallModality] ${fi(b)}`),Promise.reject(b)):Promise.reject(i9(b))),this._callOperationHandler.waitForOperation("Subscribe",void 0,c))}startWithMeetingData(a,s){const c=Date.now();return this.setCallerMri(AN+this.currentUserSkypeIdentity.id),this.setInitialTelemetry("StartWithMeetingData",{callStartOptions:s,callStartTime:c},"",a),this.connectCallPromise=this._callOperationHandler.waitForOperation("StartWithMeetingData"),this.joinOrStartCall({callStartOptions:wN(s),callStartTime:c,meetingPreferences:{shouldResurrect:s.shouldResurrect}},this.startOutgoingCall,a)}joinWithMeetingData(a,s,c){const u=Date.now();return this.setInitialTelemetry("JoinWithMeetingData",{callStartOptions:c,callStartTime:u},s.conversationUrl,a),this.setCallerMri($te(s.groupCallInitiator)),this.connectCallPromise=this._callOperationHandler.waitForOperation("JoinWithMeetingData"),this.joinOrStartCall({callStartOptions:wN(c),callStartTime:u,meetingPreferences:{shouldResurrect:c.shouldResurrect}},this.joinGivenConversation,a,s.conversationUrl)}subscribeWithMeetingData(a,s,c){const u=Date.now();this.setCallerMri(s.groupCallInitiator),this.setCallType(2,a);const m={callStartOptions:wN(c),callStartTime:u};return this.setInitialTelemetry("SubscribeWithMeetingData",m,s.conversationUrl,a),this.state!==0?(this.logger.info(`[${a}][subscribeWithMeetingData]Trying to subscribe to a call that has already been acted on`),Promise.reject(60)):(this.setCallOptions(m),this.setCallState(8,a),this.signalingSession.subscribeToCall(s.conversationUrl,this.callId,c.clientEndpointCapabilities,{meetingPreferences:{shouldResurrect:c.shouldResurrect},meetingData:this.meetingData,meetingRegistrationId:c.meetingRegistrationId,participantPin:c.participantPin,additionalEndpointProperties:c.additionalEndpointProperties},a).catch(b=>yN(b)?(this.logger.info(`[${a}][subscribeWithMeetingData] ${fi(b)}`),Promise.reject(b)):Promise.reject(i9(b))),this._callOperationHandler.waitForOperation("SubscribeWithMeetingData",void 0,a))}async startCallWithNudge(a,s={},c=hi()){this.setCallerMri(AN+this.currentUserSkypeIdentity.id),this.connectCallPromise=this._callOperationHandler.waitForOperation("StartCallWithNudge");const u=Date.now();if(this.logger.info(`[${c}][startCallWithNudge]startCallWithNudge for participants: ${o2(a)}`),this.participants.length)return Promise.reject(48);if(s.isCast&&s.isHuddleGroupCall)return this.logger.logFailure(`isCast: ${s.isCast} isHuddleGroupCall: ${s.isHuddleGroupCall}`),Promise.reject(new Error("isCast or isHuddleGroupCall can only be set exclusively."));const m={};return m.callStartOptions=wN(s),m.invitationType=ge.INVITATION_TYPE.NUDGE,m.participantsToNudge=a,m.callStartTime=u,this.setInitialTelemetry("StartCallWithNudge",m,"",c),this.joinOrStartCall(m,this.startOutgoingCall,c)}async startAndUnpark(a,s,c={},u=hi()){this.setCallerMri(AN+this.currentUserSkypeIdentity.id);const m=this.logger.createFnLogger("StartCallAndUnpark",u),b=Date.now();this.setInitialTelemetry("StartCallAndUnpark",{callStartTime:b},"",u),m.info(`startAndUnpark for context: ${a}, pickupCode :${s}`),this.connectCallPromise=this._callOperationHandler.waitForOperation("StartCallAndUnpark");const _={};switch(_.callStartOptions=wN(c),_.pickupCode=s,_.parkContext=Ub.SERVER_HOLD,a){case 0:_.parkContext=Ub.PARK;break;case 1:_.parkContext=Ub.SHARED_LINE;break;case 5:_.parkContext=Ub.CALL_PARK;break;case 2:_.parkContext=Ub.SERVER_HOLD;break;default:throw new Error(`[startAndUnpark] unsupported ParkContext name: ${a}`)}return this.addParticipant(`4:${_.parkContext}`).catch(k=>m.logFailure("Failed to add participant to unparked call")),this.joinOrStartCall(_,this.startOutgoingCall,u)}async admitParticipant(a,s=hi()){const c=sye(a),u=this.getParticipant(c),m=this._getParticipantLegId(u),b=m?{participantLegId:m}:{};if(u&&u.state!==7){const _={code:0,subCode:3552,phrase:"Participant is not in lobby state"};return this.callTelemetry.maybeRecordOperationSuccess("AdmitParticipant",_,a,s,b),Promise.reject(_)}return this.admitParticipantToCall(c,s,m)}admit(a,s){return this.signalingSession.admitAsync(s)}async callMeBack(a,s,c=hi()){const u=sye(`${AN}${this.currentUserSkypeIdentity.id}`,this.currentUserSkypeIdentity.sipUri);return this.addCallMeBackParticipant(a,s||u,c)}async addParticipant(a,s={},c=hi()){return(await this.addParticipantsImpl([a],s,c,"addParticipant"))[0]}async addParticipants(a,s={},c=hi()){return this.addParticipantsImpl(a,s,c,"addParticipants")}async addParticipantsImpl(a,s={},c=hi(),u){if(this.logger.info(`[${c}][${u}] start`),this.isEmergency&&this.state===0&&(this.participants.length!==0||a.length!==1))return Promise.reject(new Error("Only 1 participant (the emergency operator) may be added to unstarted emergency calls"));if(s.participantInvitationData)try{JSON.stringify(s.participantInvitationData)}catch(N){throw this.logger.info(`[${c}][${u}] ${N}`),N}const m=[],b=[];if(a.forEach(N=>{const W=this.getOrCreateParticipant(N,c,!0);W.state===0||W.state===4?(b.push(W),m.push(this._participantOperationHandler.createPendingOperation("AddParticipant",W.id,c))):W.state===3?m.push(Promise.resolve(W)):this._participantOperationHandler.hasPendingOperationWithOperationId("AddParticipant",W.id)&&m.push(this._participantOperationHandler.waitForOperation("AddParticipant",W.id))}),b.length===0)return Promise.resolve(m);const _=!!s.disableUnmute,k=this.addParticipantsToCall(b,c,s.participantInvitationData,s.groupId,s.threadId,s.messageId,_,s.alternateId,s.customHeaderContext,s.callingLineIdentity);return(0,Zr.zip)(k,b).forEach(async([N,W])=>{try{await N;const ee=this._getParticipantLegId(this.getParticipant(W.id)),oe=ee?{participantLegId:ee}:{};this.callTelemetry.recordOperationSuccess("AddParticipant",{code:0,subCode:0,phrase:""},W.id,c,oe),this._participantOperationHandler.maybeResolveOperation("AddParticipant",W,W.id,c)}catch(ee){this._participantOperationHandler.maybeRejectOperation("AddParticipant",ee,W.id,c)}}),this.raiseChanged(this._participantChangedEventSkipConfig),Promise.resolve(m)}async nudgeParticipants(a,s,c={},u=hi()){return this.state!==2&&this.state!==3?Promise.reject(48):this.signalingSession.nudgeParticipantsAsync({participantsIds:s,causeId:u,invitationData:c.participantInvitationData,newGroupId:c.groupId,newThreadId:c.threadId,newMessageId:c.messageId})}mapRemoveEndpointScope(a){switch(a){case 0:return"specified";case 1:return"all";default:return"none"}}mapEndpointScope(a){return a===1?"all":"none"}async removeParticipant(a,s=hi(),c,u){const m=this.logger.createFnLogger("removeParticipant",s);m.info("start");const b=this.mapRemoveEndpointScope(u);return this.signalingSession.removeParticipantAsync({id:a,endpointId:c},s,b).catch(_=>{m.logFailure(`Participant was not removed from call, error=${_}`);const k=this._handleParticipantOperationFailure("RemoveParticipant",_,s,a).reason;return Promise.reject(k||38)})}async cancelNudge(a,s){throw new Error("Method not implemented.")}async searchParticipants(a,s){return this.signalingSession.searchParticipantsAsync(a.searchQueryOptions,s)}async getAllParticipants(a,s){return this.signalingSession.getAllParticipantsAsync(a.scope,s)}set dominantSpeakerInfo(a){this.internalDominantSpeakerInfo=a}get dominantSpeakerInfo(){return this.internalDominantSpeakerInfo?this.internalDominantSpeakerInfo:this.mediaSession?.getSessionConfig().config.emptyInitialDSH?{speakerList:[],timestamp:null,noCurrentDominantSpeaker:!1}:{speakerList:this.participants.filter(a=>a.state===3).map(a=>a.id),timestamp:null,noCurrentDominantSpeaker:!1}}set slowedDownActiveTalkerInfo(a){(0,Zr.isEqual)(this.internalSlowedDownActiveTalkerInfo?.speakerList,a.speakerList)||(this.internalSlowedDownActiveTalkerInfo=a,this.raiseChanged())}get slowedDownActiveTalkerInfo(){return this.internalSlowedDownActiveTalkerInfo}startVideoSafe(a){return this.startVideo(a).catch(s=>{this.logger.info(JSON.stringify(s),"startVideoSafe",a)})}async joinOrStartCall(a,s,c,u){const m=this.logger.createFnLogger("joinOrStartCall",c);if(this.state!==0&&this.state!==8&&!a.isPromotingToRealtime)return m.logFailure("Trying to start a call that has already been acted on"),Promise.reject(60);if(this.signalingAgent.resolvePotentialCallConflict(this.signalingSession)===this.signalingSession)return Promise.reject(57);this.callStats.localStats.startCall();const b=this.state===8||this.participants.length!==1;m.info(`isMultiparty=${b}, reason: participants.length=${this.participants.length}`),this.setCallType(b?2:1,c),this.setCallUsesMixer(b,c),this._setMaxVbssChannels(a?.callStartOptions?.maxVbssChannels,c),this.setCallOptions(a);const _=a.callStartOptions||{};if(1&~_.preheatFlags){const W=!!_&&(_.muted||!(1&~_.muteFlags)),ee=_?.muteFlags?!(2&~_.muteFlags):this.isSpeakerMuted;this.setMuted(W?2:this.isServerMuted?1:0,c),this.setSpeakerMuted(ee,c),this.setCallState(2,c)}else this.setMuted(2,c),this.setSpeakerMuted(!0,c),this.setCallState(11,c);const k=Ive(this.meetingData,this.threadId,this.messageId,this.groupId,!!u);this.callTelemetry.setJoinedFrom(k),this.signalingSession.setJoinedFrom(k),this.setHuddleGroupCall(!!a.callStartOptions?.isHuddleGroupCall);const N=this._callOperationHandler.createPendingOperation("_ConnectCall","",c);return N.catch(Ef),await this.joinOrStartWithMedia(a,s,a.callStartTime,N,c,u),a.callStartOptions?.meetingRegistrationId&&this.callTelemetry.setHasMeetingRegistrationId(!0),a.callStartOptions?.participantPin&&this.callTelemetry.setHasParticipantPin(!0),N}setSessionIceTransportPolicy(a){const s=a?.connectionType;let c=ke.ICE_TRANSPORT_POLICY.all;switch(s){case"AllSupported":c=ke.ICE_TRANSPORT_POLICY.all;break;case"NoDirectConnection":c=ke.ICE_TRANSPORT_POLICY.relay}this.mediaSession?.getSessionConfig().setIceTransportPolicy?.(c)}async joinOrStartWithMedia(a,s,c,u,m,b){const _=this.logger.createFnLogger("joinOrStartWithMedia",m);this.callStats.localStats.audio.start();const k=a.callStartOptions,N=k&&1&k.preheatFlags;if(this._startCallPhase=OV(_),a.callStartOptions?.sendMediaModalities&&(this.mediaStateConfigurationHelper=new J8e(a.callStartOptions.sendMediaModalities)),this._preferredMpLocation){a.callStartOptions=a.callStartOptions||{};const W=a.callStartOptions.clientEndpointDebugContent?JSON.parse(a.callStartOptions.clientEndpointDebugContent):{};a.callStartOptions.clientEndpointDebugContent=JSON.stringify({preferredMpLocation:this._preferredMpLocation,...W})}try{k&&!N&&this.mediaStateConfigurationHelper.isInactiveOrDisabled(0)&&this.mediaStateConfigurationHelper.isSending(2)&&(this.setCallUsesMixer(!0,m),await this.getScreenHandle().acquire()),this.mediaStateConfigurationHelper.isSending(0)&&this.setAudioOn(!0,m),this.callUsesMixer||this.mediaStateConfigurationHelper.disableModality(2),_.info(`skipSharingModality=${!this.callUsesMixer}`),this._startCallPhase.executeSync("InitializeMediaSession",()=>this.initializeMediaSession(m,k?.mediaConfiguration)),this.updateSignalingDSHMessageSubscription(this.isInitialSignalingDSHSubscriptionEnabled()),this.mediaSession.getSessionConfig().config.alwaysNegotiateDataChannel&&this.mediaStateConfigurationHelper.enableModality(3),this.setSessionIceTransportPolicy(a?.callStartOptions?.mediaConfiguration),this.mediaSession.createAudioElement(m),this.callUsesMixer||b||this.isOneToOnePSTNCall()||a.callVoicemailStartOptions||this.setIsSomeoneStreamingVideo(!0);const W=this._callOperationHandler.createPendingOperation("_WaitForAnswer","",m,{preconditionTags:["NOT_SUPPORTED_IN_STREAMING_MODE"]});W.catch(Ef);let ee=!1;a.isPromotingToRealtime?(this.isSpeakerMuted=!0,ee=!0,await this._startCallPhase.execute("MuteInput",()=>this.mediaSession.muteInputAsync(m)),await this._startCallPhase.execute("MuteOutput",()=>this.mediaSession.muteOutputAsync(m))):k&&(N?(ee=!0,await this._startCallPhase.execute("MuteInput",()=>this.mediaSession.muteInputAsync(m)),await this._startCallPhase.execute("MuteOutput",()=>this.mediaSession.muteOutputAsync(m)),this.setMuted(2,m),this.setCallUsesMixer(!0,m)):this.mediaStateConfigurationHelper.isSending(1)&&await this._startCallPhase.execute("StartVideoSafe",()=>this.startVideoSafe(m))),k?.forceAudioSendModalityWithNullStream&&this.mediaSession.useNullAudioStreamClient();const oe=await this._startCallPhase.execute("UpdateMediaModalities",()=>this.updateMediaModalities(void 0,m));if(!this.mediaSession?.createOfferAsync)throw{error:"NoMediaSession",phase:"CreateOffer"};const de=await this._startCallPhase.execute("CreateOffer",()=>this.mediaSession.createOfferAsync(m)),se=this._startCallPhase.executeSync("GetSignalingMediaTypes",()=>this.getSignalingMediaTypes(this.calculateModalityDirections({},m)));if(this.mediaStateConfigurationHelper.isSending(2)&&this.updateScreenSharingState(oe,m),ee||(await this._startCallPhase.execute("MuteUnmute",()=>this.muteUnmute(this._muteState===2,m)),await this._startCallPhase.execute("MuteUnmuteSpeakers",()=>this.muteUnmuteSpeaker(this.isSpeakerMuted,m))),this._startCallPhase.executeSync("CallStart",()=>s(m,a,de,se,c,b)),await this._startCallPhase.execute("WaitForConnect",()=>u),!this.isCallModeStreaming()||a.isPromotingToRealtime){const Re=await this._startCallPhase.execute("WaitForAnswer",()=>W);if(!this.mediaSession?.processAnswerAsync)throw{error:"NoMediaSession",phase:"ProcessAnswer"};await this._startCallPhase.execute("ProcessAnswer",()=>this.mediaSession.processAnswerAsync(Re,m,!1)),await this._startCallPhase.execute("CompleteNegotiation",()=>this.completeNegotiationAsync(m))}this.callTelemetry.updateOperationData("_ConnectCall",{phases:this._startCallPhase.getTelemetryData()},m),this._startCallPhase=void 0,k?.screenshareDirection!==2&&k?.screenshareDirection!==4||(this.allowScreenSharingControl()&&this.screenSharingControl.isInternalSharerControlEnabled()&&this.screenSharingControl.initControlForSharer(""),this.enableControlInjector())}catch(W){this.catchJoinOrStartCallError(W,m,_)}}catchJoinOrStartCallError(a,s,c){let u,m=0;throw c.logFailure(fi(a)),a?.error&&(u={...a.error}),IN("MuteInput",a)?(m=7,u={code:er.LocalError,subCode:Ml.MediaMuteMicrophoneError,phrase:fi(a),causeId:s}):IN("MuteOutput",a)?(m=7,u={code:er.LocalError,subCode:Ml.MediaMuteSpeakerError,phrase:fi(a),causeId:s}):a?.type===this.mediaAgent.constants.MEDIA_ERROR.incompatibleOffer||Hte(TV,a)?m=47:a?.type===this.mediaAgent.constants.MEDIA_ERROR.permissionDeniedError?(m=58,u={code:er.MediaError,subCode:Ml.MediaPermissionError,phrase:fi(a),causeId:s}):IN("WaitForAnswer",a)||IN("WaitForConnect",a)?m=a.error:Hte(FG,a)&&(m=7),this.callTelemetry.updateOperationData("_ConnectCall",this.getTelemetryFromPhaseExecution(a),s),this._startCallPhase=void 0,this.callSetupFailed=!0,Promise.all([this._callOperationHandler.maybeRejectOperation("_WaitForAnswer",m,"",s),this._callOperationHandler.maybeRejectOperation("_ConnectCall",m,"",s)]).then(()=>{this.isPromotingToRealtime()||this.stopInternal({causeId:s,terminatedReason:m,rejectReason:u})}).catch(Ef),m}addCallMeBackParticipant(a,s,c){const u=this._participantOperationHandler.waitForOperation("CallMeBack",a),m=this.logger.createFnLogger("CallMeBack",c),b={id:a,assertedId:s};return this.signalingSession.callMeBackAsync(b).then(()=>{m.logSuccess(`successfully executed call me back, participantId = ${kn(a)}`),this._participantOperationHandler.resolveOperation("CallMeBack",0,a)}).catch(_=>{m.logFailure(`Call me back failed, participantId = ${kn(a)}, error = ${_}`),this._handleParticipantOperationFailure("CallMeBack",_,c,s,!1);const k=this._processError(_);let N={};k&&(N={...k}),N.failureReason=k.reason?k.reason:11,this._participantOperationHandler.rejectOperation("CallMeBack",N,a)}),u}addParticipantsToCall(a,s,c,u,m,b,_,k,N,W){const ee=this.logger.createFnLogger("addParticipantsToCall",s);a.forEach(se=>{se.setState(1,void 0,s)});const oe=a.map(se=>({id:se.mri}));ee.info(`participantIds=${a.map(se=>kn(se.id))}, disableUnmute=${_}`);const de={additionalData:c,groupId:u,threadId:m,messageId:b,disableUnmute:_,alternateId:k,customHeaderContext:N,callingLineIdentity:W};try{const se=this.signalingSession.addParticipantsAsync(oe,de,s);return(0,Zr.zip)(se,oe).map(async([Re,ue])=>{try{const Ne=await Re;this.signalingNotifications.onParticipantJoined(Ne,s);const ze=this._getParticipantLegId(this.getParticipant(ue.id)),He=ze?{participantLegId:ze}:{};this.callTelemetry.recordOperationSuccess("AddParticipant",{code:0,subCode:0,phrase:""},Ne.id,s,He)}catch(Ne){const ze=this._handleParticipantOperationFailure("AddParticipant",Ne,s,ue.id).reason;throw this._removeParticipant(ue,s,ze),ze}})}catch(se){return ee.logFailure(`Participants was not added to call, error=${se}`),(0,Zr.range)(oe.length).map(()=>Promise.reject(1))}}async mergeCallByAddParticipantWithReplaces(a,s,c,u,m,b,_,k){const N=this.logger.createFnLogger("mergeCallByAddParticipantWithReplaces",b),W=this.convertClientScenario(k),ee={additionalData:a.additionalData,groupId:a.groupId,threadId:a.threadId,messageId:a.messageId,callIdToReplace:c.callId,replacementType:u,clientScenario:W},oe=await this.signalingSession.addParticipantsAsync(s,ee,b);for(let de=0;de<oe.length;de++){const se=u===3?s[de].participantId:s[de].id;try{await oe[de],N.logSuccess(` [participantInfos id =${kn(s[de].id)}]`);const Re={debugContent:{replacementParticipantLegId:s[de].replacementParticipantId||void 0,clientScenario:W},participantLegId:s[de].participantId},ue={code:0,subCode:0,phrase:""};this.callTelemetry.recordOperationSuccess(m,ue,se,b,Re),this._callOperationHandler.maybeResolveOperation(m,ue,se,b)}catch(Re){N.logFailure(`Participant was not added to call, error=${Hs(Re)}`);const ue=this._handleParticipantOperationFailure(m,Re,b,se,!0,W).reason;this._removeParticipant(s[de],b,ue);const Ne=Re?Re.endCode:ue||0;this._callOperationHandler.maybeRejectOperation(m,Ne,se,b)}}return Promise.resolve(_)}admitParticipantToCall(a,s,c){const u=this.logger.createFnLogger("admitParticipantToCall",s),m={id:a};return u.info("start"),this.signalingSession.admitParticipantAsync(m,s).then(b=>{u.info(`successfully admitted participant to call, participantId = ${kn(a)}`);const _=c?{participantLegId:c}:{},k={code:0,subCode:0,phrase:""};this.callTelemetry.recordOperationSuccess("AdmitParticipant",k,a,s,_)}).catch(b=>{u.logFailure(`Participant was not admitted to call, error=${b}`);const _=this._handleParticipantOperationFailure("AdmitParticipant",b,s,a);return Promise.reject(_)})}_processError(a){let s;const c={reason:s};if(a?.endCode){const u=W8e(a.endCode.code,a.endCode.subCode);s=Pv.getParticipantReasonFromTerminatedReason(u),c.reason=s,c.code=a.endCode.code,c.subCode=a.endCode.subCode,c.resultCategories=a.endCode.resultCategories,c.phrase=a.endCode.phrase}else c.phrase=`${a}`;return this.logger.info(`_processError error=${a} telemetryData=${JSON.stringify(c)}`),c}_handleParticipantOperationFailure(a,s,c,u,m=!0,b){this.callTelemetry.updateOperationData(a,{error:Hs(s)},c,u);const _=this._processError(s),k=this.getParticipant(u);_.code&&k&&(k.callEndDiagnosticsInfo={callControllerCode:_.code,callControllerSubCode:_.subCode,phrase:_.phrase,resultCategories:_.resultCategories});try{if(m){const N={debugContent:{clientScenario:b},participantLegId:this._getParticipantLegId(k)||void 0};this.callTelemetry.recordOperationFailure(a,_,u,c,N)}}catch(N){this.logger.info(`_handleParticipantOperationFailure error during recordOperationFailure ${N}`)}return _}_getParticipantLegId(a){return(0,Zr.has)(a,"endpoints.endpointDetails")&&a.endpoints.endpointDetails.length&&a.endpoints.endpointDetails[0].participantId?a.endpoints.endpointDetails[0].participantId:null}isOneToOnePSTNCall(a=!1){const s=this.signalingSession.isIncomingCall?this.callerMri:this.participants.length>0?this.participants[0].id:"";return this.isOneToOneCall(a)&&(0,Zr.startsWith)(s,U8e)&&(!this.incomingCallType||!this.callUsesMixer)}isParkedCall(){return this.isOneToOnePSTNCall()&&!!this.callOptions?.parkContext}async updateMediaModalities(a={},s=hi(),c){let u;const m=this.logger.createFnLogger("updateMediaModalities",s);return m.info(`callUsesMixer=${this.callUsesMixer},isSomeoneSharing=${this.isSomeoneSharing},isSomeoneStreamingVideo=${this.isSomeoneStreamingVideo}`),m.info(`options=${xo(a)},requestHoldState=${this.requestedHoldState},requestedScreenSharingState=${this.mediaStateConfigurationHelper.isSending(2)}`),u=a.modalityOverride?a.modalityOverride:this.requestedHoldState&&!this.isMuteOnHold?this.getMediaModalitiesForHold(s):this.calculateModalityDirections(a?.offered,s),m.info(`modalities=${xo(u)}`),await this.mediaSession.configureModalitiesAsync(u,s,c),u}calculateModalityDirections(a={},s){const c=this.logger.createFnLogger("calculateModalityDirections",s);c.info(`callUsesMixer=${this.callUsesMixer}, isEscalationInProgress=${this.isEscalationInProgress}`);const u={audio:this.calculateAudioDirection(a.audio,c),video:this.calculateVideoDirection(a.video,c),sharing:this.calculateSharingDirection(a.sharing,c),data:this.calculateDataDirection(a.data,c)};return c.info(`done, modalities=${xo(u)}`),this.deleteExtraneousModalities(u,s),u}calculateAudioDirection(a,s){return s.info(`calculateAudioDirection, offer=${a}, requestedAudioState=${this.mediaStateConfigurationHelper.isSending(0)}`),this.receiveOnlyAudioOnCallStart?(s.info("calculateAudioDirection, direction=recvonly, receiveOnlyAudioOnCallStart=true"),"recvonly"):this.mediaStateConfigurationHelper.isInactiveOrDisabled(0)||a==="inactive"?"inactive":this.mediaSession.getAllowedModalities().audio.some(c=>c===WR.send||c===WR.sendReceive)?"sendrecv":a==="sendonly"?"inactive":"recvonly"}calculateVideoDirection(a,s){const c=this.mediaStateConfigurationHelper.isSending(1);if(s.info(`calculateVideoDirection, offer=${a}, requestedVideoState=${c}, isSomeoneStreamingVideo=${this.isSomeoneStreamingVideo}`),this.mediaStateConfigurationHelper.isInactiveOrDisabled(0))return"inactive";let u=c,m=this.isSomeoneStreamingVideo||this.callUsesMixer||this.isEscalationInProgress;return a&&(u=u&&(a==="sendrecv"||a==="sendonly"),m=m&&(a==="sendrecv"||a==="recvonly")),u?"sendrecv":m?"recvonly":"inactive"}calculateSharingDirection(a,s){return s.info(`calculateSharingDirection, offer=${a}, requestedScreenSharingState=${this.mediaStateConfigurationHelper.isSending(2)}, isSomeoneSharing=${this.isSomeoneSharing}`),a==="inactive"?"inactive":this.mediaStateConfigurationHelper.isSending(2)?"sendonly":this.isSomeoneSharing||this.callUsesMixer||this.isEscalationInProgress?"recvonly":void 0}calculateDataDirection(a,s){const c=this.mediaStateConfigurationHelper.isSending(3);if(s.info(`calculateDataDirection, offer=${a}, dataEnabled=${c}`),this.allowDataChannel())return c?a==="inactive"?"inactive":"sendrecv":void 0;s.info("calculateDataDirection, disabling data since ECS flag prohibits it")}getMediaModalitiesForHold(a){this.logger.info(`[${a}][getMediaModalitiesForHold]`);const s="inactive",c={audio:s,video:s,data:this.allowDataChannel()?s:void 0,sharing:s};return this.deleteExtraneousModalities(c,a),c}deleteExtraneousModalities(a,s){!Ur(a.video)&&this.mediaStateConfigurationHelper.isDisabled(1)&&(this.logger.info(`[${s}][deleteExtraneousModalities] skipping videoModality`),delete a.video),!Ur(a.sharing)&&this.mediaStateConfigurationHelper.isDisabled(2)&&(this.logger.info(`[${s}][deleteExtraneousModalities] skipping sharingModality`),delete a.sharing)}getSignalingMediaTypes(a){const s=u=>u===this.mediaAgent.constants.MEDIA_STATE.send||u===this.mediaAgent.constants.MEDIA_STATE.sendReceive,c=[];return a.audio&&a.audio!==this.mediaAgent.constants.MEDIA_STATE.inactive&&c.push("Audio"),s(a.video)&&c.push("Video"),a.sharing===this.mediaAgent.constants.MEDIA_STATE.send?c.push("ScreenSharer"):a.sharing===this.mediaAgent.constants.MEDIA_STATE.receive&&c.push("ScreenViewer"),c}enableControlInjector(){if(this.allowScreenSharingControl())if(this.getlocalScreenShareStream()){const a=this.mediaSession?.getLocalMediaTrackId("ScreenShare")??"";this.screenSharingControl.enableControlInjector(a)}else this.logger.warn("enableControlInjector: no local screenshare stream found")}createCallDeviceManager(){return new dhi(this.mediaAgent.getConfigProvider().config.allowVirtualDeviceInCall,this.mediaAgent.getDeviceManager(),this.logger.createChild("CallDeviceManager"),this.callStats,a=>this.isMediaSending(a))}initializeSignalingSession(a){if(this.signalingSession)return void this.logger.info("Session already exists!");const s=ge.CALL_STATUS;if(this.localSignalingParticipant={id:sye(`${AN}${this.currentUserSkypeIdentity.id}`,this.currentUserSkypeIdentity.sipUri),displayName:this.currentUserSkypeIdentity.displayName,endpointDetails:[],languageId:null,participantId:a,endpointId:null},this.accountConfiguration){if(this.localSignalingParticipant.applicationType=this.accountConfiguration.applicationType,this.callTelemetry.setApplicationType(this.accountConfiguration.applicationType),this.localSignalingParticipant.ring=this.accountConfiguration.ring,this.callTelemetry.setRing(this.accountConfiguration.ring),this.localSignalingParticipant.region=this.accountConfiguration.region,this.callTelemetry.setRegion(this.accountConfiguration.region),this.localSignalingParticipant.userHexCID=this.accountConfiguration.userHexCID,this.callTelemetry.setUserHexCID(this.accountConfiguration.userHexCID),this.localSignalingParticipant.partition=this.accountConfiguration.partition,this.callTelemetry.setPartition(this.accountConfiguration.partition),this.localSignalingParticipant.acsResourceId=this.accountConfiguration.acsResourceId,this.callTelemetry.setAcsResourceId(this.accountConfiguration.acsResourceId),this.callStats.setAcsResourceId(this.accountConfiguration.acsResourceId),this.accountConfiguration.serviceUrls){const u=this.accountConfiguration.serviceUrls.calling_conversationServiceUrl,m=this.accountConfiguration.serviceUrls.calling_uploadLogRequestUrl;this.signalingAgent.updateUrls(u,m,this.accountConfiguration.enforceUrls)}this.localSignalingParticipant.clientType=this.accountConfiguration.clientType,this.callTelemetry.setClientType(this.accountConfiguration.clientType)}this.callStats.localStats.setLocalUserId(this.localSignalingParticipant.id),this._callOperationHandler&&this._callOperationHandler.resetOperationChain(),this.signalingNotifications={onPromotionCompleted:(u,m,b)=>{this.logger.info(`[${b}][onPromotionCompleted] isFailed=${u} reason=${xo(m)} callMode=${this.callMode}`);const _=u?m:{code:0,subCode:0};if(this.callTelemetry.recordEvent("PromotionCompleted",{reason:_},b),u){const k=i9(m);this._callOperationHandler.maybeRejectOperation("_WaitForAnswer",k,"",b),this._callOperationHandler.maybeRejectOperation("_CallStartOrJoinInitiated",k,"",b),this._callOperationHandler.maybeRejectOperation("_ConnectCall",k,"",b),this.promotionCompletedDeferred?.reject(k)}else this._callOperationHandler.maybeResolveOperation("_CallStartOrJoinInitiated",void 0,void 0,b),this._callOperationHandler.maybeResolveOperation("_ConnectCall",void 0,void 0,b);this.participants.forEach(k=>{k.applyCachedMediaStreams(b)})},onCallStatusChanged:(u,m,b=hi())=>{const _=this.logger.createFnLogger("onCallStatusChanged",b);let k=`[status=${u}]`;if(m&&(k+=`[reason=${xo(m)}]`,m.code!==void 0&&(this.callEndDiagnosticsInfo={callControllerCode:m.code,callControllerSubCode:m.subCode,phrase:m.phrase,resultCategories:m.resultCategories},(m.overflowJoinInformation||m.registrationInformation)&&(this.callEndDiagnosticsInfo.additionalDiagnostics={overflowInformation:m.overflowJoinInformation,registrationInformation:m.registrationInformation}))),_.info(k),this.callTelemetry.recordEvent("_SignalingStateChanged",{status:u,reason:m},b),u===s.CONNECTING)this._callOperationHandler.maybeResolveOperation("_CallStartOrJoinInitiated",void 0,void 0,b);else if(u===s.RINGING)this.audioStreamState===2?(this.setCallState(9,b),this.participants.forEach(N=>N.setState(6,void 0,b))):this.participants.forEach(N=>N.setState(2,void 0,b)),this._callOperationHandler.maybeResolveOperation("Subscribe",void 0,void 0,b);else if(u===s.CONNECTED_FOR_ROSTER_ONLY)this._callOperationHandler.maybeResolveOperation("Subscribe",void 0,void 0,b),this._callOperationHandler.maybeResolveOperation("SubscribeWithMeetingData",void 0,void 0,b);else if(u===s.CONNECTED){this._callIsSetupComplete=!0;const N=this.getLocalSignalingEndpointDetails();(N?.isLobby||N?.streamLobby)&&(this._callInLobby=!0,this.updateCapabilities(b,!0));const W=this.signalingSession.participantManager.localParticipant.isStaging;if(this.state===11)this.setCallState(12,b);else if(this._callOperationHandler.hasPendingOperation("JoinPreheatedCall"))_.info("wait for joinPreheatedCall to resolved");else if(this._callInLobby)_.info("[inLobby] Override Connected state from signaling agent"),this.setCallState(10,b);else if(W)this.setCallState(13,b);else{if(this.state===3&&!this._callOperationHandler.hasPendingOperation("_CallStartOrJoinInitiated")&&!this._callOperationHandler.hasPendingOperation("_ConnectCall"))return void _.info("Return: Don't re-send setup telemetry if call was already connected and operations are completed");this.setCallState(3,b),this.handleRemoteParticipantStateInOneToOneCall(b)}this._callOperationHandler.maybeResolveOperation("_CallStartOrJoinInitiated",void 0,void 0,b),this._callOperationHandler.maybeResolveOperation("_ConnectCall",void 0,void 0,b),this.reportTsCallingTelemetry(!0)}else if(u===s.LOCAL_TERMINATED||u===s.REMOTE_TERMINATED){let N=this.callSetupFailed?7:i9(m);if(this.state===8&&this._callOperationHandler.hasAtleastOneOfPendingOperation(["StartCall","JoinCall","StartWithMeetingData","JoinWithMeetingData"]))return this.signalingSession.resetState(),this._callOperationHandler.maybeRejectOperation("Subscribe",N,void 0,b),this._callOperationHandler.maybeRejectOperation("SubscribeWithMeetingData",N,void 0,b),void _.info("Subscribe failed, there is pending start/join operation, ignore call end message");if(N!==1&&m?.code===er.MediaError&&m?.subCode===Ml.MediaPermissionError&&(N=58,_.info(`[terminated][reason=${xo(m)}]`)),(this.state===2||this.state===6||this.state===8)&&this._callOperationHandler.hasAtleastOneOfPendingOperation(["StartCall","JoinCall","StartWithMeetingData","JoinWithMeetingData","Subscribe","SubscribeWithMeetingData"])){const ee={code:this.callEndDiagnosticsInfo.callControllerCode,subCode:this.callEndDiagnosticsInfo.callControllerSubCode,phrase:this.callEndDiagnosticsInfo.phrase,reason:N};this._callOperationHandler.maybeRejectOperations(["Accept","JoinCall","JoinWithMeetingData","JoinPreheatedCall","StartCall","StartCallAndUnpark","StartCallToVoiceMail","StartCallWithNudge","StartWithMeetingData","Subscribe","SubscribeWithMeetingData"],N,void 0,b,ee)}this.signalingSession.acceptedElsewhereBy&&(this.acceptedElsewhereBy={id:this.signalingSession.acceptedElsewhereBy.id,displayName:this.signalingSession.acceptedElsewhereBy.displayName}),this.signalingSession.parkAdditionalContextJson&&(this.parkAdditionalContextJson=this.signalingSession.parkAdditionalContextJson),this.signalingSession.serverHoldLocation&&(this.serverHoldLocation=this.signalingSession.serverHoldLocation),this._callOperationHandler.hasPendingOperation("CallParkV2")&&m.pickupCode&&m.code===0&&this._callOperationHandler.resolveOperation("CallParkV2",""+m.pickupCode,void 0,b),N!==1&&this.mediaRelayWhiteListingIssue&&(N=53,_.info(`[terminated][reason=${xo(m)}]`)),this._callOperationHandler.maybeRejectOperation("CallParkV2",N,"",b),this._callOperationHandler.maybeRejectOperation("_WaitForAnswer",N,"",b),this._callOperationHandler.maybeRejectOperation("_ConnectCall",N,"",b);const W=this.mediaSession?.getSessionConfig().config.setDisconnectAfterCleanUp;if(W?this.setTerminatedReason(N):this.setCallState(7,b,N),this.participants.forEach(ee=>ee.setState(4,void 0,b)),!this.disconnectingPromise){const ee={...m,remoteTerminated:u===s.REMOTE_TERMINATED};this.disconnectingPromise=this.cleanUp(b,ee).catch(oe=>{_.logFailure(`Error when cleaning up the call, callId = ${this.callId}, error = ${oe}`)})}W&&this.disconnectingPromise.finally(()=>{this.state!==7&&this.setCallState(7,b,N)})}},onOffer:(u,m=hi())=>{const b=this.logger.createFnLogger("onOffer",m);b.info(`${xo((0,Zr.omit)(xS(u),"mediaContent","remoteParticipantId"))}`),this.setMediaLegId(u.mediaContent.mediaLegId),this.callTelemetry.recordEvent("_WebOnOffer",this.prepareTelemetryForOfferAnswer(u),m),u.transferor?.details?.id&&this.setTransferorMri(u.transferor.details.id),u.transferor?.transferorType&&(this.transferorType=u.transferor.transferorType),u.transferor?.details?.displayName&&(this.transferorDisplayName=u.transferor.details.displayName),this.clientTransferContext=u.clientTransferContext,this.customHeaderContext=u.customHeaderContext,this.invitationData=u.invitationData,this.spamRiskLevel=u.riskLevel,this.spamStirAttestation=u.stirAttestation,u.mediaContent.isTwoPartyToMultiPartyEscalation&&this.setIsEscalationInProgress(!0,m),u.renegotiation?this.requestedHoldState&&this._pendingParkPromise?this.renegotiateIncoming(u.mediaContent,m):this._delayedElevationPending||this._delayedElevationQueued?(this.signalingSession.rejectRenegotiationAsync({},m),this.triggerDelayedReconnectIfNeeded(m,"onOffer")):this._callOperationHandler.executeChained(()=>this.renegotiateIncoming(u.mediaContent,m),"_RenegotiateIncoming",m,m,void 0,void 0,{preconditionTags:["NOT_SUPPORTED_IN_STREAMING_MODE"]}):(b.info("resolving attach / offer promise"),this.attachToCallAndGetOffer.resolve(u.mediaContent))},onNewOffer:(u,m=hi())=>{const b=this.logger.createFnLogger("onNewOffer",m);this.newOfferRequestDeferred?(b.info("onNewOffer"),this.newOfferRequestDeferred.resolve(u.mediaContent)):b.info("callback received but new offer was not requested")},onAnswer:(u,m=hi())=>{const b=this.logger.createFnLogger("onAnswer",m);if(b.info(`${xo((0,Zr.omit)(u,"mediaContent","remoteParticipantId"))}`),this.setMediaLegId(u.mediaContent.mediaLegId),this.callTelemetry.recordEvent("_WebOnAnswer",this.prepareTelemetryForOfferAnswer(u),m),u.renegotiation)b.info("resolving previous renegotiation promise"),this.renegotiationAnswerDeferred.resolve(u.mediaContent);else if(b.info("resolving final answer promise"),u.provisional){const _=this.isOneToOnePSTNCall()&&(0,Zr.startsWith)(u.remoteParticipantId,U8e);this.mediaSession.processAnswerAsync(u.mediaContent,m,!0,_)}else this._callOperationHandler.maybeResolveOperation("_WaitForAnswer",u.mediaContent,void 0,m),this.handleRemoteParticipantStateInOneToOneCall(m);u.provisional||!u.mediaContent.fromMixer||this.callUsesMixer||this._callOperationHandler.executeChained(async()=>{this.setCallUsesMixer(!0,m),this.mediaStateConfigurationHelper.isDisabled(2)&&this.mediaStateConfigurationHelper.removeModality(2),await this.updateMediaModalities(void 0,m);const _=!(this.isSomeoneSharing||this.isScreenSharingOn||this.isVideoOn);return(this.isOneToOnePSTNCall()?this.mediaSession.getSessionConfig().config.callElevationDelayReconnectPSTN:this.mediaSession.getSessionConfig().config.callElevationDelayReconnect)&&_?(b.info("Delayed elevation: pending"),this._delayedElevationPending=!0,Promise.resolve()):this.mediaSession.reconnectAsync(m,!0)},"_CallEscalatedToConference",m,m,void 0,void 0,{preconditionTags:["NOT_SUPPORTED_IN_STREAMING_MODE"]})},onMediaAcknowledgementSuccess:(u,m=hi())=>{this.logger.info(`isRenegotiation: ${u}`,"onMediaAcknowledgementSuccess",m),this._callOperationHandler.resolveOperation("_MediaAcknowledgment",void 0,void 0,m)},onMediaAcknowledgementFailure:(u,m,b=hi())=>{this.logger.createFnLogger("onMediaAcknowledgementFailure",b).logFailure(xo(m)),this._callOperationHandler.rejectOperation("_MediaAcknowledgment",m,b)},onMediaRenegotiationRejection:(u,m=hi())=>{this.logger.createFnLogger("onMediaRenegotiationRejection",m).logFailure(xo(u)),this.renegotiationAnswerDeferred.reject(u)},onRosterHandlingComplete:()=>{this.logger.info(`[onRosterHandlingComplete] ${this._publishedStatesModified}`),this._publishedStatesModified!==0&&(this.processPublishedStates(),this._publishedStatesModified=0)},onMeetingGroupDetailsUpdated:(u,m=hi())=>{this.meetingGroupDetails!==u&&(this.callTelemetry.recordEvent("_UpdateMeetingGroupDetails",u,m),this.logger.info(`[${m}][onMeetingGroupDetailsUpdated] update meetingGroupDetails from ${JSON.stringify(this.meetingGroupDetails)} to ${JSON.stringify(u)}`),this.meetingGroupDetails=u,this.raiseChanged())},onSelfParticipantUpdated:(u,m=hi())=>{this.logger.info(`[${m}][onSelfParticipantUpdated]`),this.updateLocalParticipant(u,m),this.raiseChanged()},onParticipantMriUpdated:(u,m,b=hi())=>{this.logger.info(`[${b}][onParticipantMriUpdated]`);const _=this.getParticipant(u);_&&(_.id=m,this.raiseChangedDeferred())},onParticipantUpdated:(u,m=hi())=>{this.logger.info(`[${m}][onParticipantUpdated]: ${hye(u)}`);const b=this.getOrCreateParticipant(u.id,m,!0);b.displayName=u.displayName;const _=Pv.getStreamsFromEndpoints(u.endpointDetails,this.isMultiVBSSEnabled()),k=(0,Zr.some)(u.endpointDetails,N=>N?.streamInformation);this.callUsesMixer||_.length>0||k?(this.updateParticipantStreams(b,u,_,m),this.updateCallParticipantFromSignalingParticipant(b,u,m)):b.setState(3,void 0,m),b.processParticipantDetails(u,this.getSelfClientEndpointCapabilities(),()=>{this.signalingSession?.setStreamInformationReceived()}),this.updatePublishedStates(u),this.calculateIsSomeoneStreaming(m),this.raiseChangedDeferred()},onParticipantRemoved:(u,m=hi(),b=!1)=>{if(this.logger.info(`[${m}][onParticipantRemoved]`),b){const _=this.getParticipant(u.id);this.callTelemetry.recordOperationSuccess("_ParticipantJoined",null,_?.id,m,{participantJoinedButReplaced:"Participant joined with original MRI and replaced with participant of RNL MRI"})}else this.callTelemetry.recordOperationSuccess("RemoveParticipant",null,u.id,m),this._participantOperationHandler.maybeRejectOperation("AddParticipant",1,u.id,m);this._removeParticipant(u,m),this.removePublishedStatesByParticipant(u.id),this.calculateIsSomeoneStreaming(m)},onParticipantJoined:(u,m=hi())=>{this.logger.info(`[${m}][onParticipantJoined]`);const b=!this.getParticipant(u.id),_=this.getOrCreateParticipant(u.id,m,!1);_.displayName=u.displayName,_.state===0&&_.setState(1,void 0,m);const k=Pv.filterVirtualEndpoints(u.endpointDetails),N=Pv.getStreamsFromEndpoints(k,this.isMultiVBSSEnabled()),W=(0,Zr.some)(u.endpointDetails,ee=>ee?.streamInformation);this.callUsesMixer||N.length>0||W?(this.updateParticipantStreams(_,u,N,m),this.updateCallParticipantFromSignalingParticipant(_,u,m),this.calculateIsSomeoneStreaming(m)):(this.handleRemoteParticipantJoinedInOneToOneCall(u,m),this.handleRemoteParticipantStateInObservingCall(_,u,m),u.acceptedBy&&u.acceptedBy!==u.id&&(_.acceptedBy=u.acceptedBy)),this.callTelemetry.recordOperationSuccess("_ParticipantJoined",I2(u.endpointDetails),_.id,m),_.processParticipantDetails(u,this.getSelfClientEndpointCapabilities(),()=>{this.signalingSession?.setStreamInformationReceived()}),this.updatePublishedStates(u),b&&this.event("participantAdded").raise(_),this.raiseChangedDeferred()},onCallModeChanged:(u,m)=>{this.callTelemetry.recordEvent("_CallModeChanged",{newCallMode:u,oldCallMode:this._callMode},m),this.logger.info(`onCallModeChanged[${m}]: new=${u} old=${this._callMode} `),u&&this._callMode!==u&&(this._callMode=u,this.isCallModeStreaming()&&this.cleanUpDueToStreaming(m),this._callMode===1&&(this.participants.forEach(b=>{b.applyCachedMediaStreams(m)}),this.promotionCompletedDeferred?.resolve()),this.monitorCallStart(),this.updateCapabilities(m),this.raiseChanged())},getRemoteParticipantCollection:()=>this.participants.map(u=>u.toCafeParticipant()),onReTargetCompletedSuccess:u=>{const m=this.logger.createFnLogger("onReTargetCompletedSuccess",u);m.info(`started, isEscalationInProgress=${this.isEscalationInProgress}`),this.callTelemetry.recordEvent("_WebRetargetSuccess",void 0,u),this.callStats.localStats.call.event(3);const b=this.isEscalationInProgress;this.screenSharingControl&&this.screenSharingControl.shutdownControlForViewer(),this.updateSignalingDSHMessageSubscription(this.isInitialSignalingDSHSubscriptionEnabled()),this.mediaSession.completeEscalationAsync(u).then(()=>(m.logSuccess("completeEscalationAsync"),this.callTelemetry.recordEvent("_WebOnEscalationSuccess",void 0,u),this.handleCallEscalation(b,u),this.updateMediaStatus(u))).catch(_=>{m.logFailure(`completeEscalationAsync, error=${fi(_)}`),this.setIsEscalationInProgress(!1,u),this.callTelemetry.recordEvent("_WebOnEscalationFailure",Hs(_),u),this.stopInternal({causeId:u,terminatedReason:47})})},onReTargetCompletedFailure:(u,m)=>{this.logger.createFnLogger("onReTargetCompletedFailure",m).logFailure(`reason=${fi(u)}, isEscalationInProgress=${this.isEscalationInProgress}`),this.callTelemetry.recordEvent("_WebRetargetFailure",Hs(u),m),this.isEscalationInProgress&&(this.setIsEscalationInProgress(!1,m),this.setCallUsesMixer(!1,m),this.updateMediaStatus(m)),this.callStats.localStats.call.event(4),this.mediaSession.rejectEscalationAsync(u,m)},onChatModalitySetupFailed:u=>{this.logger.debug(`onChatModalitySetupFailed: ${u}`)},onConversationUpdated:(u,m)=>{this.logger.info(`onConversationUpdated[${m}]: ${JSON.stringify(xS(u,["organizerId","meetingData"]))}`),this.setConversationType(u.conversationType,m),this._onMessageIdChanged(u.teamsMessageId,m),this.setGroupId(u.groupId,m),this.setThreadId(u.threadId,m),this.setBackroomThreadId(u.backroomThreadId,m),this.setStreamThreadId(u.streamThreadId,m),this.setLobbyThreadId(u.lobbyThreadId,m),this.setCallType(u.isMultiParty?2:1,m),this.setMeetingLayoutDetails(u.meetingLayoutDetails,m),this.setCompositionServiceDetails(u.compositionServiceDetails,m),this._commandUrlPresence=u.commandUrlPresence,this.updateCapabilities(m),this.region=u.region,this.setMeetingData(u.meetingData),this.meetingInfo=u.meetingInfo,this.callLimits=u.callLimits,this.setComplianceRecordingContent(m,u.complianceRecordingContent),this.setHuddleGroupCall(u.isHuddleGroupCall),this.onConversationStartTimeChanged(u.conversationStartTime,m),this.raiseChanged()},onMeetingDetailsUpdated:u=>{this.meetingDetails=u,this.mediaSession&&!this.enableRealtimeTelemetry&&this.meetingDetails.meetingCapability?.enableRealtimeTelemetry&&(this.mediaSession.enableTeamsRealTimeTelemetry(),this.enableRealtimeTelemetry=!0),this.raiseChanged()},onMeetingStatesUpdated:u=>{(0,Zr.isEqual)(u,this.meetingStates)||(this.meetingStates=u,this.logger.info(`[onMeetingStatesUpdated] meetingStates updated to ${JSON.stringify(this.meetingStates)}`),this.raiseChanged())},onParticipantCountsUpdated:u=>{(0,Zr.isEqual)(u,this.participantCounts)||(this.participantCounts={...HR,...u},this.event("participantCountsUpdated").raise(this.participantCounts),this.mediaSession?.processNotification("ParticipantCountChanged",{count:u.totalParticipants}))},updateIsSharedLineAppearanceV2Activated:u=>{this.isSharedLineAppearanceV2Activated!==u&&(this.logger.info(`_updateIsSharedLineAppearanceV2Activated: new value is ${u}`),this.isSharedLineAppearanceV2Activated=u,this.event("sharedLineAppearanceV2ActivatedChanged").raise(this.isSharedLineAppearanceV2Activated))},onBroadcastMeetingUpdated:u=>{u&&(this.broadcastMeeting&&this.broadcastMeeting.metadataChanged(JSON.stringify(u)),this.broadcastMetadata=u,this.raiseChanged())},onBroadcastMeetingConnected:(u,m)=>{this.logger.info(`[${m}][onBroadcastMeetingConnected]`),this._callOperationHandler.hasPendingOperation("AddBroadcastModality")&&(u.code===0?this._callOperationHandler.resolveOperation("AddBroadcastModality",u,m):this._callOperationHandler.rejectOperation("AddBroadcastModality",u,m))},onBroadcastMeetingEnded:(u,m)=>{this.logger.info(`[${m}][onBroadcastMeetingEnded]`),this._callOperationHandler.hasPendingOperation("AddBroadcastModality")&&this._callOperationHandler.rejectOperation("AddBroadcastModality",u,m),this.signalingSession.endBroadcastMeeting(m)},onTransferRequested:(u,m)=>{const b=this.logger.createFnLogger("onTransferRequested",m);b.info("Transfer: onTransferRequested, target participant",hye(u.target));let _="",k="",N=0;u.target.endpointType==="voicemail"&&(N=2);try{_=u.target.id,k=u.transferor.details.id,u&&u.parkType&&u.parkType!=="none"&&(N=1)}catch(oe){return b.logFailure(oe),this.callTelemetry.recordEvent("_OnTransferRequestedInvalid"),void this.signalingSession.signalTransferCompletedAsync({code:K8e(7)})}const W=this.convertToTransferType(N,u.parkType),ee={transferContext:{transferorMri:k,targetMri:_,transferType:N,context:{target:u.target,transferor:u.transferor,transferContext:u.transferContext,newCallModalities:u.newCallModalities,links:u.links,replacementDetails:u.replacementDetails,isConsultative:u.isConsultative,callAcceptanceCallback:()=>{b.logSuccess("Transfer: callAcceptanceCallback called"),this.signalingSession.signalTransferAcceptedAsync(W)}}},onCompleted:oe=>{b.logSuccess("Transfer: onCompleted called"),this.signalingSession.signalTransferCompletedAsync({code:K8e(oe)})}};this.callTelemetry.recordEvent("_OnTransferRequested",{transferType:N}),this.event("transferRequested").raise(ee)},onTransferredCallAcceptance:u=>{const m=this.logger.createFnLogger("onTransferredCallAcceptance",u);this._transferredCallAcceptanceCallback&&(m.info("[Transfer] Invoke call acceptance callback for original call"),this._transferredCallAcceptanceCallback())},onTransferAccepted:u=>{this.logger.info("Transfer: onTransferAccepted"),this._callOperationHandler.hasPendingOperation("_CallTransferInProgress")&&this._setTransferState(2),this._callOperationHandler.hasPendingOperation("BlindTransfer")&&this._callOperationHandler.maybeResolveOperation("_CallTransferInProgress",void 0,void 0,u),this._callOperationHandler.hasPendingOperation("ParkCall")&&this._setParkState(2)},onTransferCompleted:(u,m)=>{const b=this.logger.createFnLogger("onTransferCompleted",m);b.info("Transfer: onTransferCompleted");const _=u.transferCompletion,k=i9(_);if(_&&(b.info(`Transfer: Call Transfer Code: ${_.code}`),_.code===0)){if(this._callOperationHandler.hasPendingOperation("_CallTransferInProgress")&&(this._callOperationHandler.resolveOperation("_CallTransferInProgress",void 0,void 0,m),this._setTransferState(3)),this._callOperationHandler.hasPendingOperation("ConsultativeTransferWithPickupCode")){const N={code:0,subCode:0,phrase:"TransactionComplete"};this._callOperationHandler.resolveOperation("ConsultativeTransferWithPickupCode",N,void 0,m),this._setTransferState(3)}this._callOperationHandler.hasPendingOperation("ParkCall")&&(u.unparkContent?.CallParkAdditionalContext?.ConversationControllerLocation&&(this.serverHoldLocation=u.unparkContent.CallParkAdditionalContext.ConversationControllerLocation),u.unparkContent?.pickupCode!==void 0?(this._callOperationHandler.resolveOperation("ParkCall",u.unparkContent.pickupCode,void 0,m),b.logSuccess(`pickupCode=${u.unparkContent.pickupCode}`),this._setParkState(3)):(this._callOperationHandler.rejectOperation("ParkCall",32,m),b.logFailure(`terminatedReason=${k}`),this._setParkState(4)))}else{if(this._callOperationHandler.hasPendingOperation("_CallTransferInProgress")&&(this._callOperationHandler.rejectOperation("_CallTransferInProgress",k,void 0,m),b.logFailure(`terminatedReason=${k}`),this.transferDiagnosticsInfo={callControllerCode:_.code,callControllerSubCode:_.subCode,phrase:_.phrase,resultCategories:_.resultCategories},this._setTransferState(4)),this._callOperationHandler.hasPendingOperation("ConsultativeTransferWithPickupCode")){const N={code:_.code,subCode:_.subCode,resultCategories:_.resultCategories};this._callOperationHandler.rejectOperation("ConsultativeTransferWithPickupCode",N,void 0,m)}this._callOperationHandler.hasPendingOperation("ParkCall")&&(this._callOperationHandler.rejectOperation("ParkCall",k,void 0,m),b.logFailure(`terminatedReason=${k}`),this.transferDiagnosticsInfo={callControllerCode:_.code,callControllerSubCode:_.subCode,phrase:_.phrase,resultCategories:_.resultCategories},this._setParkState(4))}},onParkCompleted:(u,m)=>{this.logger.createFnLogger("onParkCompleted",m).info(`transactionEnd ${fi(u)}`),this._callOperationHandler.hasPendingOperation("CallParkV2")?u.code===0&&u.unparkContent?.pickupCode!==void 0?(this._callOperationHandler.resolveOperation("CallParkV2",""+u.unparkContent?.pickupCode,void 0,m),this.callTelemetry.maybeRecordOperationSuccess("CallParkV2"),this.serverHoldLocation=u.unparkContent?.CallParkAdditionalContext?.ConversationControllerLocation,this.parkAdditionalContextJson=JSON.stringify(u.unparkContent.CallParkAdditionalContext)):this._callOperationHandler.rejectOperation("CallParkV2",u,m):this._callOperationHandler.hasPendingOperation("ParkCall")&&(u.code===0?(this._callOperationHandler.resolveOperation("ParkCall","",void 0,m),this._setParkState(3)):(this._callOperationHandler.rejectOperation("ParkCall",u,m),this._setParkState(4)))},onUnparkCompleted:(u,m)=>{this.logger.createFnLogger("onUnparkCompleted",m).info(`transactionEnd ${fi(u)}`),this._callOperationHandler.hasPendingOperation("UnparkCall")&&(u.code===0?this._callOperationHandler.resolveOperation("UnparkCall",u,void 0,m):this._callOperationHandler.rejectOperation("UnparkCall",u,m))},onIncomingCallReplacement:(u,m)=>{const b=this.logger.createFnLogger("onIncomingCallReplacement",m);this.callTelemetry.recordEvent("_onIncomingCallReplacement",{},m),u.callNotification.callType="replaces",u.callNotification.consultativeCallId=this.callId,b.info(`consultativeCallId=${this.callId}`),u.body={gp:u,evt:OD.INCOMING_SKYPE_NGC_CALL,nsp:void 0},this.event("replacementRequested").raise(u)},onContentSharingStopped:u=>{this.logger.debug("ScreenSharing: onContentSharingStopped");for(const m of this.contentSharingSessions)m.contentSharingGuid===u.correlationId&&(m.contentSharingStatus=7)},onContentSharingStarted:u=>{this.logger.debug("ScreenSharing: onContentSharingStarted");const m=new BD(this.callTelemetry,this.logger.createChild("ContentSharingSession"),this.signalingSession,u.correlationId||sC(),u.contentIdentifier,u.sessionState,u.subject,u.sessionId);m.contentSharingStatus=2,this.contentSharingSessions.push(m),m.changed(()=>this.removeContentSessionIfEnded(m)),this.event("contentSharingChanged").raise()},onContentSharingUpdated:u=>{this.logger.debug("ScreenSharing: onContentSharingUpdated");const m=(0,Zr.find)(this.contentSharingSessions,b=>b.contentSharingGuid===u.correlationId);m?(u.presenter&&(m.presenterId=u.presenter),u.subject&&m.subject!==u.subject&&(m.subject=u.subject),u.sessionState&&m.contentSharingState!==u.sessionState&&(m.contentSharingState=u.sessionState),m.contentSharingStatus===3&&this.localSignalingParticipant.id!==u.presenter?m.contentSharingStatus=5:m.contentSharingStatus===5&&this.localSignalingParticipant.id===u.presenter&&(m.contentSharingStatus=3)):this.logger.warn("onContentSharingUpdated: session not found")},onWebRtcMediaNotification:(u,m)=>{this.mediaSession?.processNotification(u,m)},onCorrelationIdUpdated:(u,m)=>this.checkForCallIdUpdate(u,m),onUnmuteRequested:u=>{},onCallForwarded:u=>{u&&u.destinationType!==this.forwardingDestinationType&&(this.forwardingDestinationType=u.destinationType,this.raiseChanged())},onPSTNBalanceUpdate:u=>{},isOneToOnePstnCall:()=>this.isOneToOnePSTNCall(),onUpdateMeetingLiveStateCompleted:(u,m,b)=>{this.logger.info(`[onUpdateMeetingLiveStateCompleted] [${m}] transactionEnd ${fi(u)}`),this.onOperationCompleteCommonHandler(u,m,"UpdateMeetingLiveState",b)},onUpdateMeetingStatesCompleted:(u,m,b)=>{this.logger.info(`[onUpdateMeetingStatesCompleted] [${m}] transactionEnd ${fi(u)}`),this.onOperationCompleteCommonHandler(u,m,"UpdateMeetingStates",b)},onUpdateMeetingGroupsCompleted:(u,m,b)=>{this.logger.info(`[onUpdateMeetingGroupsCompleted] [${m}] transactionEnd ${fi(u)}`),this.onOperationCompleteCommonHandler(u,m,"UpdateMeetingGroups",b)},onSetMeetingLayoutCompleted:(u,m,b)=>{this.logger.info(`[onSetMeetingLayoutCompleted] causeId [${m}] operationId: ${b}`),this.onOperationCompleteCommonHandler(u,m,"SetMeetingLayout")},onJoinMeetingGroupCompleted:(u,m,b)=>{this.logger.info(`[onJoinMeetingGroupCompleted] [${m}] transactionEnd ${fi(u)}`),this.onOperationCompleteCommonHandler(u,m,"JoinMeetingGroup",b)},onLeaveMeetingGroupCompleted:(u,m,b)=>{this.logger.info(`[onJoinMeetingGroupCompleted] [${m}] transactionEnd ${fi(u)}`),this.onOperationCompleteCommonHandler(u,m,"LeaveMeetingGroup",b)},onBreakoutDetailsUpdated:(u,m)=>{this.logger.info(`[onBreakoutDetailsUpdated] [${m}]`),this.breakoutDetails=u,this.raiseChanged()},onIncomingProxiedMessages:(u,m)=>{this.logger.info(`[onIncomingProxiedMessages] [${m}] payload ${fi(u,!0)}`),this.event("incomingProxiedMessages").raise(u)},onUpdateParticipantsPropertiesCompleted:(u,m,b)=>{this.logger.createFnLogger("onUpdateParticipantsPropertiesCompleted",b).info(`promisesToResolve ${kn(xo(u))}`);for(const _ of Object.keys(u))u[_].code===$d.CODE.SUCCESS?this._callOperationHandler.maybeResolveOperation("UpdateParticipantsProperties",u[_],_,b):this._callOperationHandler.maybeRejectOperation("UpdateParticipantsProperties",u[_],_,b)},onUpdateMonitorSessionCompleted:(u,m)=>{this.logger.info(`[onUpdateMonitorSessionCompleted] [${m}] transactionEnd ${fi(u)}`),this.onOperationCompleteCommonHandler(u,m,"UpdateMonitorSession")},onNudgeToJoinRealtime:u=>{this.logger.info("[onNudgeToJoinRealtime]",u),this.callTelemetry.recordEvent("NudgeToJoinRealTime",u),this.canPromoteToRealTime(1)&&this.promoteToRealtime(1,u).then(()=>this.logger.info(`[onNudgeToJoinRealtime][${u}] completed`)).catch(m=>this.logger.info(`[onNudgeToJoinRealtime][${u}] failed to auto promote: ${fi(m)}`))},onConversationTypeUpdated:(u,m)=>{this.logger.info(`[onConversationTypeUpdated] [${m}] conversationType ${u}`),this.setConversationType(u,m)}};const c=Object.create(this.localSignalingParticipant);this.signalingSession=this.signalingAgent.getNewSignalingSession(c,this.signalingNotifications,this.callId,this._callCreationTime),this.signalingSession.participantManager.setEnableMuteAsync(this._enableMuteAsync),this.signalingSession.participantManager.setEnableUnmuteAsync(this._enableUnmuteAsync),this.accountConfiguration&&this.accountConfiguration.deviceType&&this.signalingSession.setDeviceType(this.accountConfiguration.deviceType),this.setCallId(this.callId||this.signalingSession.correlationId),this.signalingSession.participantManager&&this.signalingSession.participantManager.localParticipant&&(this.setDisplayName(this.signalingSession.participantManager.localParticipant.displayName),this.setEndpointId(this.signalingSession.participantManager.localParticipant.endpointId),this.setParticipantId(this.signalingSession.participantManager.localParticipant.participantId),this.callStats.setParticipantId(this.participantId))}updateParticipantStreams(a,s,c,u){const m=Pv.getNegotiationTagsFromEndpoints(s.endpointDetails);a.updateStreams(c,u,this.isCallModeStreaming(),m,this.isMultiVBSSEnabled());const b=this.getStreamInformationMap(s);this.logger.info(`[updateParticipantStreams]: streaming mode with new streamInfoMap: ${xo(b)}`);const _={callId:this.callId,participantId:this.participantId,endpointId:this.endpointId};this.meetingData&&(_.meetingId=this.meetingData.meetingCode);const k=this.telemetryLoggers?this.telemetryLoggers.tlePlayer:null;a.useUmsStream(b,this._liveStreamConfigProvider,_,this.threadId,k,u)}cleanUpDueToStreaming(a){this.logger.info(`cleanUpDueToStreaming[${a}]: cleaning streams and media and canceling cc operations`),this.cancelAllCallingOperationsDueToStreaming(a);const s={code:er.Success,subCode:Ml.DowngradeToStreamingClient,phrase:Ug.DowngradeToStreamingClient};this.participants.forEach(c=>c.updateStreams([],a,this.isMultiVBSSEnabled())),this.cleanUpMedia(a,s).then(()=>{this.callTelemetry.recordOperationSuccess("_MediaCleanUp")}).catch(c=>{this.callTelemetry.recordOperationFailure("_MediaCleanUp",{error:Hs(c)},a)}).finally(()=>{this.mediaDisposedPromise=null}),this.finishCallHoldResume(s),this.renegotiationAnswerDeferred?.reject(s),this.newOfferRequestDeferred?.reject(s),this._parkState=0,this._transferState=0,this.isServerMuted||(this._muteState=0),this.isSpeakerMuted=!1,this.requestedHoldState=!1,this.isMuteOnHold=!1}cancelAllCallingOperationsDueToStreaming(a){this._callOperationHandler.maybeRejectPendingOperationsWithPredicate(74,a,(s,c)=>(0,Zr.some)(c?.preconditionTags,u=>u==="NOT_SUPPORTED_IN_STREAMING_MODE"))}onOperationCompleteCommonHandler(a,s,c,u){a.code===0?this._callOperationHandler.maybeResolveOperation(c,a,u,s):this._callOperationHandler.maybeRejectOperation(c,a,u,s)}convertToTransferType(a,s){let c="none";return a===1&&s&&s!=="none"?s==="teamPark"?c="TransferTypeTeamPark":s==="sharedLinePark"?c="TransferTypeSharedLinePark":s==="serverHold"&&(c="TransferTypeServerHold"):a===0?c="TransferTypeStandard":a===2?c="TransferTypeVoicemail":this.logger.info(`Irrelevant combination of transferTye: ${a} and parkType: ${s}`),c}raiseChangedDeferred(a){(!this.raiseChangedDefer||this.raiseChangedDefer.isSkippable&&!a)&&(n9.instance.runDeferredWithoutDedup(()=>{delete this.raiseChangedDefer,this.raiseChanged(a)},"Call.raiseChanged"),this.raiseChangedDefer={isSkippable:!!a})}static getStreamsFromEndpoints(a,s){if(!a)return[];const c=Pv.filterVirtualEndpoints(a);return c.forEach(u=>{u.mediaStreams=s?u.mediaStreams:u.mediaStreams?.filter(m=>m.type!==jb.xsharing),(0,Zr.forEach)(u.mediaStreams,m=>{m.participantId=u.participantId,m.endpointId=u.endpointId})}),(0,Zr.flatMap)(c,u=>u&&u.mediaStreams||[])}preconditions(a,s){this.logger.info(`check call mode currentMode is ${this.callMode} operationName is ${a}`),(0,Zr.some)(s,c=>c==="NOT_SUPPORTED_IN_STREAMING_MODE")&&this.isCallModeStreaming(!0)}mapCallSetupIntent(a){switch(a){case 0:return"None";case 1:return"AutoPromotion";case 2:return"PromotionWithAudio";case 3:return"PromotionWithVideo";default:return"Unknown"}}async promoteToRealtime(a,s){this.logger.info(`[${s}][promoteToRealtime] started with intent=${a}`);const c=this.getPromoteToRealtimeCallOptions(a,this.callOptions);this.callTelemetry.updateOperationData("_PromotionToRealtime",{intent:a},s),this.callTelemetry.recordEvent("StartPromotion",{intent:this.mapCallSetupIntent(a)},s);try{this.promotionCompletedDeferred=new Pi,await Promise.all([this.joinOrStartCall(c,this.joinGivenConversation,s,void 0),this.promotionCompletedDeferred.promise])}catch(u){throw this.logger.logFailure(`[${s}][promoteToRealtime] failed with reason=${fi(u)}`),this.cleanUpDueToStreaming(s),this.signalingSession.cleanUpDueToStreaming(s),u}}async promoteToRealtimeAndUnmute(a){return this.logger.info(`[${a}][promoteToRealtimeAndUnmute]`),this.isPromotingToRealtime()?(this.logger.info(`[${a}][promoteToRealtimeAndUnmute] already promoting to realtime.`),this._callOperationHandler.waitForOperation("_PromotionToRealtime").then(()=>this.muteUnmute(!1,a))):this.canPromoteToRealTime(2)?(this.unmutePendingPromise=new Pi,setTimeout(()=>{this.unmutePendingPromise?.reject("promoteToRealtime unmute timed out")},1e3*this.signalingSession.signalingAgentConfig.csaTimeoutConfiguration.promotionUnmuteTimeoutSec),Promise.all([this.promoteToRealtime(2,a),this.unmutePendingPromise.promise]).then(()=>{}).finally(()=>this.unmutePendingPromise=null)):Promise.reject("manual promotion with audio is not allowed")}isPromotingToRealtime(){return this._callOperationHandler.hasPendingOperation("_PromotionToRealtime")}getPromoteToRealtimeCallOptions(a,s){let c,u=1;a===1?c={value:!0,mediaTypes:["audio"]}:a===3?(c={value:!0,mediaTypes:["audio"]},u=4):a===2&&(c={value:!1});const m={...s.callStartOptions,sendMediaModalities:{mediaStates:[qR(0,4),qR(1,u)].filter(b=>b!=null)},preheatFlags:0};return{...s,callStartOptions:m,applyServerMute:c,isPromotingToRealtime:!0,callStartTime:Date.now()}}canPromoteToRealTime(a){const s=this.logger.createChild("[canPromoteToRealTime]");return s.info(`[promoteType:${a}]`),this.isCallModeStreaming()?this.isPromotingToRealtime()?(s.info("already promoting to realtime"),!1):a===1||a===2:(s.info("cant promote since call mode is not streaming"),!1)}isCallModeStreaming(a=!1){if(this.callMode===2){if(!a)return!0;throw this.logger.info("reject check callmode"),{code:499,subCode:3551,phrase:"TransactionNotAllowedForStreamMode"}}return!1}setCallOptions(a){this.receiveOnlyAudioOnCallStart=!!a.callStartOptions?.receiveOnlyAudioOnCallStart,this.callOptions=a,this.logger.info(`callOptions: ${xo(mdi(a))}`)}getSelfClientEndpointCapabilities(){return this.callOptions?.callStartOptions?.clientEndpointCapabilities}getLocalSignalingEndpointDetails(){return(0,Zr.find)(this.localSignalingParticipant.endpointDetails,a=>a?.endpointId===this._endpointId)}getStreamInformationMap(a){const s={};return a&&this.accountConfiguration?.clientSupportsUms&&(0,Zr.forEach)(a.endpointDetails,c=>{c?.streamInformation&&c.participantId&&c.participantId!==this._participantId&&(s[c.participantId]=c.streamInformation)}),s}updateSATInfo(a=[]){const s=this.mediaSession?.getSessionConfig().config.slowedDownTalkerInfoAggregationTime;if(!s||s<0)return;const c=Date.now(),u=c-1e3*s;this.activeTalkersHistory=this.activeTalkersHistory.filter(({timestamp:b})=>b>u).concat({speakers:a.map(b=>b.id),timestamp:c});const m=Object.entries(this.activeTalkersHistory.reduce((b,{speakers:_})=>{for(const k of _)b[k]??(b[k]=0),b[k]++;return b},{})).sort(([,b],[,_])=>_-b).map(([b])=>b);this.slowedDownActiveTalkerInfo={speakerList:m,timestamp:new Date(c)}}enableRemoteUFDs(a){this.logger.info((a?"Enabling":"Disabling")+" remote UFDs"),a?this.remoteUFDHandler.init():this.remoteUFDHandler.dispose()}setPlatformCallConstraints(a){this.setCallConstraints(a).catch(s=>{this.logger.error(s)})}setCallConstraints(a){return this.mediaSession?(this.logger.info(`Applying platform constraints to current call ${JSON.stringify(a)}`),this.mediaSession.setCallConstraints(a,hi())):(this.logger.info("Saving platform constraints until media session is created"),this.temporaryCallConstraints=a,new Promise((s,c)=>{this.resolveTemporaryCallConstraints=s,this.rejectTemporaryCallConstraints=c}))}initializeMediaSession(a,s){if(this.mediaSession)return;const c=this.logger.createFnLogger("initializeMediaSession",a),u=((k,N)=>{const W={};return Object.keys(N).forEach(ee=>{W[ee]=(...oe)=>N[ee]&&k()&&N[ee](...oe)}),W})(()=>!this.isCallModeStreaming()||this.isPromotingToRealtime(),{onSessionErrorOccurred:(k,N=hi())=>{c.error(`[${N}][onSessionErrorOccurred]: ${xo(k)}`);const W=[this.mediaAgent.constants.MEDIA_ERROR.iceConnectionError,this.mediaAgent.constants.MEDIA_ERROR.internalError];(0,Zr.includes)(W,k.type)&&this.event("mediaConnectionFailed").raise(),this.callTelemetry.recordEvent("SessionError",{type:k.type},N)},onNegotiationRequired:(k=hi(),N)=>{this.executeNegotiation(k,"onNegotiationRequired",!0,N)},onContributingSourcesChanged:k=>{const N=this.mediaSession?.getSessionConfig().config.contributingSourcesLogInterval,W=N&&Date.now()>=this.lastContributingSourceReport+N,ee=W?new Map(k.map(de=>[de,"<unknown>"])):new Map,oe=[];for(const de of this.participants){const se=k.some(ue=>de.hasAudioSource(ue)),Re=se?1:0;de.updateVoiceLevel(Re),se&&(oe.push(de),W&&ee.set(de.audio.id,kn(de.id)))}this.updateSATInfo(oe),W&&(c.info(`[onContributingSourcesChanged], ${k.length?Array.from(ee).join(";"):"none"}`),this.lastContributingSourceReport=Date.now())},onDominantSpeakerChanged:(k,N)=>{const W=hi(),ee=[],oe=[];k.forEach(de=>{const se=(0,Zr.find)(this.participants,Re=>Re.hasAudioSource(de));se?(ee.push(se.id),oe.push(kn(se.id))):oe.push(this.streamManager.audio.id===de?"<self>":"<unknown>")}),c.info(`[${W}][onDominantSpeakerChanged], msidList = ${k} => speakerList = ${oe}, timestamp = ${N}`),this.dominantSpeakerInfo={speakerList:ee,timestamp:N,noCurrentDominantSpeaker:!1},this.event("dominantSpeakerChanged").raise(),this.raiseChanged(this._dominantSpeakerChangedEventSkipConfig)},onAudioStateChanged:(k,N)=>{const W=hi(),ee=this.logger.createFnLogger("onAudioStateChanged",W);ee.info(xo(k)),this.callStats.localStats.audio.streamStateChanged(k.stream,k.direction);const oe=Pv.streamingStatetoMediaStreamState(k.stream);if(this.audioStreamState=oe,!oe)return;this.callTelemetry.recordEvent("AudioStateChanged",{state:k,reason:N},W),oe===2&&this.state===2&&(this.setCallState(9,W),this.participants.forEach(se=>se.setState(6,void 0,W)));const de={mediaType:0,mediaDirection:Pv.streamingDirectionToMediaDirectionMapping(k.direction),mediaStreamState:oe};if(this.event("mediaStreamStateChanged").raise(de),!this.isCallSetupTelemetrySent&&this.mediaSession?.getSessionConfig().config.sendCallStartupTelemetry&&this.sendCallSetupTelemetry(),de.mediaDirection===0&&(this.isAudioStreamConnected=(0,Zr.includes)([2,1],de.mediaStreamState)),(0,Zr.includes)([3,4],de.mediaStreamState)&&(ee.logFailure(`audio stream state changed to ${k.stream} with reason ${N}`),!N||["timeout","connection-dropped","connectivity-check-failure","suspended"].indexOf(N)>=0)){this.event("mediaConnectionFailed").raise();const se=N==="suspended"?77:this.mediaRelayWhiteListingIssue?53:4;this.mediaRelayWhiteListingIssue&&this.callTelemetry.recordEvent("_MediaWhiteListingIssueDetected"),this.stopInternal({causeId:W,terminatedReason:se})}},onQualityChanged:k=>{const N={type:Pv.convertQualityEventType(k.type),value:Pv.convertQualityLevel(k.value),isLocalSource:k.isLocalSource,mediaType:Pv.convertMediaType(k.mediaType)};this.muteUnmuteWorkaround(N),N.type===32&&(this.mediaRelayWhiteListingIssue=N.value===3,this.mediaRelayWhiteListingIssue&&this.event("mediaConnectionWhitelistingWarning").raise()),N.type===5&&N.value===3&&this.trouterService.checkConnection(!0),this.callTelemetry.recordEvent("AudioQualityChanged",N),this.remoteUFDHandler.raiseIfNeeded(k,this.participantCounts?.totalParticipants,W=>{this.publishState(W,hi())}),this.event("callQualityChanged").raise(N)},onOptimalVideoReceiversCountChanged:k=>{c.debug(`onOptimalVideoReceiversCountChanged: ${k}`),this.optimalVideoCount!==k&&(this.optimalVideoCount=k,this.raiseChanged())},onDataChannelUpdated:k=>{const N=hi();c.debug(`[${N}] onDataChannelUpdated`),this.dataChannel.registerSessionDataChannel(k,N)},onUpdateMediaDescriptionsRequired:(k,N)=>{this.executeNegotiation(k,"onUpdateMediaDescriptionsRequired",!1,N)},onRealtimeTelemetryReport:()=>{this.reportTelemetryEvents([{eventName:Hb.realtimeTelemetry,props:{user_object_id:{value:AN+this.currentUserSkypeIdentity.id,piiKind:10},display_name:{value:this.displayName,piiKind:1},call_context_id:{value:this.signalingSession.correlationId,piiKind:0},participant_id:{value:this.participantId,piiKind:0},media_leg_id:{value:this.mediaLegId,piiKind:0},DiagnosticLevel:{value:255,piiKind:0},eventpdclevel:{value:2,piiKind:0},eventpriority:{value:5,piiKind:0},call_technical_info:{value:JSON.stringify(this.mediaSession.getCallTechnicalInfo()),piiKind:0}}}],"realtimeMedia","mdsc")},onTransportConnected:()=>{this.allowDataChannel()||this.mediaStateConfigurationHelper.isSending(3)||this.isInitialSignalingDSHSubscriptionEnabled()||!this.callUsesMixer||this.updateSignalingDSHMessageSubscription(!0),this.unmixedAudioProvider.setSessionStreamsProvider(this.mediaSession.getUnmixedAudioProvider()),this.event("transportConnected").raise()},onTransportDisconnected:()=>{this.event("transportDisconnected").raise()},onTransportFailed:()=>{this.event("transportFailed").raise()},onUpdateSignalingDSHMessageSubscription:k=>this.updateSignalingDSHMessageSubscription(k)});this.callTelemetry.recordEvent("CreatingConference","",a),this.callDeviceManager||(c.info(`[${a}][initializeMediaSession] Creating new callDeviceManager`),this.callDeviceManager=this.createCallDeviceManager());const m={maxReinvitelessMediaForVBSSMultiparty:this.signalingSession.getMaxReinvitelessMediaForVBSSForWeb(),maxReinvitelessMediaForVideoMultiparty:this.signalingSession.getMaxReinvitelessMediaForVideoForWeb()};this.callTelemetry.recordEvent("_ReinvitelessConfig",{reinvitelessConfig:m},a);const b=this.mediaAgent?.getConfigProvider().config.identifyOneToOneCallWithoutParticipants;this.mediaSession=new vdi(this.mediaAgent.createSession(u,this.signalingSession,{isConference:this.callUsesMixer,isPstnCall:this.isOneToOnePSTNCall(b),isParkedCall:this.isParkedCall(),reinvitelessConfig:m},this.callDeviceManager,this.smallCallTelemetry,s),this.signalingSession),this.batteryStatus=new ghi(this.mediaSession.getDiagnostics(),this.mediaAgent.getConfigProvider()),this.batteryStatus.on("batteryStatusChanged",()=>this.reportSmallCallEvent(this.smallCallTelemetry?.getSmallTelemetryOnBatteryLow())),this.temporaryCallConstraints&&(c.info(`Applying saved call constraints to current call ${JSON.stringify(this.temporaryCallConstraints)}`),this.mediaSession.setCallConstraints(this.temporaryCallConstraints,hi()).then(this.resolveTemporaryCallConstraints).catch(this.rejectTemporaryCallConstraints).finally(()=>{this.temporaryCallConstraints=void 0,this.rejectTemporaryCallConstraints=void 0,this.resolveTemporaryCallConstraints=void 0})),this.dataChannel.setConfigProviderView(this.mediaSession.getSessionConfig()),this.callTelemetry.recordEvent("CreatedConference","",a),this.streamManager.setMediaSession(this.mediaSession,a),this.participants.forEach(k=>{k.setMediaSession(this.mediaSession,a)});const _=this.mediaSession.getSessionConfig()?.config;_?.useOneDsLogger&&_?.addTelemetryReportingCallback&&(this.beforeUnloadTelemetrySender=()=>{this.sendLastKnownStats()},window.addEventListener("beforeunload",this.beforeUnloadTelemetrySender)),this.screenSharingControl&&this.allowDataChannel()&&this.screenSharingControl.setupDataHandlers(),this.unmixedAudioProvider=new chi}executeNegotiation(a,s,c,u){const m=this.logger.createFnLogger(s,a);if(this.isCallModeStreaming()||this.isEscalationInProgress)return void m.info(`ignored due to being in streaming=${this.isCallModeStreaming()},
                isEscalationInProgress=${this.isEscalationInProgress}`);const b=hi();this.state===3||this.state===4||this.state===5||this.state===10||this.isPreheatedOnly()?(m.info(`started, state: ${this.state}, runNegotiation: ${c}`),c?(this.callTelemetry.recordEvent("NegotiationRequired","",a),this._callOperationHandler.executeChained(()=>this.renegotiateOutgoing(a,u),"_RenegotiateOutgoing",b,a,void 0,void 0,{preconditionTags:["NOT_SUPPORTED_IN_STREAMING_MODE"]})):(this.callTelemetry.recordEvent("UpdateMediaDescriptions","",a),this._callOperationHandler.executeChained(()=>this.updateMediaDescriptions(a,u),"_UpdateMediaDescriptions",void 0,a,void 0,void 0,{preconditionTags:["NOT_SUPPORTED_IN_STREAMING_MODE"]}))):m.info(`not started, state: ${this.state}`)}async muteUnmuteWorkaround(a){if(this.mediaSession?.getSessionConfig().config.enableMuteSpeakerUnmuteSpeakerWorkaround&&!this.isSpeakerMuted&&a.type===25&&a.value===3&&a.mediaType===0){this.logger.log("Performing muteSpeaker->unmuteSpeaker workaround");const s=hi();await this.muteSpeaker(s),await this.unmuteSpeaker(s)}}sendLastKnownStats(){if(this.tsCallingTelemetryReported)return;this.callEndDiagnosticsInfo={callControllerCode:$d.CODE.SUCCESS,callControllerSubCode:$d.SUB_CODE.BEACON},this.callTelemetry.setCallEndDiagnosticInfo(this.callEndDiagnosticsInfo);const a=this.callTelemetry.getShortEvent();a.Code=this.callEndDiagnosticsInfo.callControllerCode,a.SubCode=this.callEndDiagnosticsInfo.callControllerSubCode;let s="csa_conversation_callmodality";if(this.reportTelemetryEvents([{eventName:s,props:a}],"signaling","skypecosi_concore_web"),s=this._callIsSetupComplete?"in_call_session":"call_setup_session",this.reportTelemetryEvents([{eventName:s,props:this.callTelemetry.getEvent(!0)}],"signaling","skypecosi_concore_web_ts_calling"),this.mediaSession){const c=this.mediaSession.getLastKnownStats(!0);this.callStats.setMediaStats(c),this.reportSmallCallEvent(null,!0),this.reportTelemetryEvents(this.callStats.buildFromLocalStats(),"signaling","skypecosi_concore_web")}this.reportVDITelemetryEvents()}reportSmallCallEvent(a,s){this.reportTelemetryEvents(this.callStats.buildShortCallEvent(a??this.smallCallTelemetry?.getEndCallSmallTelemetry(s)),"media","mdsc")}invertDirectionality(a){switch(a){case this.mediaAgent.constants.MEDIA_STATE.sendReceive:return WR.sendReceive;case this.mediaAgent.constants.MEDIA_STATE.send:return WR.receive;case this.mediaAgent.constants.MEDIA_STATE.receive:return WR.send;default:return null}}completeNegotiationAsync(a){const s=this.logger.createFnLogger("completeNegotiationAsync",a),c=this.mediaSession.completeNegotiationAsync(a).then(u=>{s.info(`activeModalities=${u&&Object.keys(u.activeModalities)}`);const m=this.mediaSession.getSessionConfig().config.avoidFakeStreamsDuringEscalation&&this.isEscalationInProgress;if(!this.callUsesMixer&&!m){if(this.mediaStateConfigurationHelper.isSending(3)&&u.initiator){const k=u.offeredModalities.data===this.mediaAgent.constants.MEDIA_STATE.sendReceive,N=u.activeModalities.data===this.mediaAgent.constants.MEDIA_STATE.sendReceive;k&&!N&&(this.logger.info(`[${a}][completeNegotiationAsync] Disabling data modality as it was not wanted by remote`),this.mediaStateConfigurationHelper.removeModality(3))}const b=this.participants[0],_=b?.endpoints?.endpointDetails.length&&b.endpoints.endpointDetails[0].mediaStreams?.length;if(b&&!_){const k=(W,ee,oe)=>({participantId:O7e,endpointId:yhi,type:W,direction:this.invertDirectionality(ee),sourceId:oe,serverMuted:!1}),N=[];N.push(k(jb.audio,u.activeModalities.audio,a7e)),u.activeModalities.video&&N.push(k(jb.video,u.activeModalities.video,r7e)),u.activeModalities.sharing&&N.push(k(jb.sharing,u.activeModalities.sharing,o7e)),b.updateStreams(N,a,this.isMultiVBSSEnabled()),!this.callIsHeld()&&this.calculateIsSomeoneStreaming(a)}}if(s.logSuccess(xo(u)),this.mediaAgent.getConfigProvider().config.syncMuteStateWithAudioDirection&&u?.activeModalities?.audio){const b=u.activeModalities.audio===this.mediaAgent.constants.MEDIA_STATE.receive||u.activeModalities.audio===this.mediaAgent.constants.MEDIA_STATE.inactive;this.setMuted(b?2:this.isServerMuted?1:0,a)}return u});return c.catch(u=>{s.logFailure(u),this.callTelemetry.recordEvent("_CompleteNegotiationFailed",{e:u},a)}),c}async renegotiateOutgoing(a,s){this.renegotiationAnswerDeferred=new Pi;const c=this.logger.createFnLogger("renegotiateOutgoing",a),u=this.inLocalHold()?this.getMediaModalitiesForHold(a):this.calculateModalityDirections({},a);if(this._delayedElevationPending&&!this._delayedElevationQueued){if(Ur(u.video)||Ur(u.sharing))return c.info("mediaModalities",u),void await this.triggerDelayedReconnectIfNeeded(a,"renegotiateOutgoing");c.info("Delayed elevation (renegotiateOutgoing): no outgoing video or sharing, skipping elevation for now")}c.info("start");const m=OV(c);try{try{const b=await m.execute("MediaCreateOffer",()=>this.mediaSession.createOfferAsync(a,s)),_=this.getSignalingMediaTypes(u);await m.execute("SignalingStartNegotiation",()=>this.signalingSession.startRenegotiationAsync(b,_,a));const k=await m.execute("SignalingRenegotiationAnswer",()=>this.renegotiationAnswerDeferred.promise);await m.execute("MediaProcessAnswer",()=>this.mediaSession.processAnswerAsync(k,a,!1));const N=await m.execute("CompleteNegotiation",()=>this.completeNegotiationAsync(a));this.onNegotiationCompletion(N,!0,u,a,m.getTelemetryData())}catch(b){if(c.logFailure(b),!b.phase)throw this.callTelemetry.recordEvent("OutgoingNegotiationFailure",b,a),b;let _="unknown";const k=this.mediaAgent.constants.RENEGOTIATION_ERROR;if(_=k.local,b.phase==="SignalingRenegotiationAnswer"||b.phase==="SignalingStartNegotiation"?_=b.error.code===er.GlareError?k.glare:b.error.code===415?k.media:k.signaling:b.phase==="MediaCreateOffer"&&b.error.type===this.mediaAgent.constants.MEDIA_ERROR.noNetworkError&&(_=k.media),this.callTelemetry.recordEvent("OutgoingNegotiationFailure",this.getTelemetryFromPhaseExecution(b),a),b.error.message?.includes("The requested call does not exist"))throw new Error("Call drop due to remote replying with call not found");c.logFailure(_);const N={type:_,detail:b.error};await this.mediaSession.rejectNegotiationAsync(N,a),this.onNegotiationFailure(b.error,_,a,u)}}catch(b){c.logFailure(b),this.callTelemetry.recordEvent("NegotiationFatalError",Hs(b),a),this.stopInternal({causeId:a,terminatedReason:47})}}async renegotiateIncoming(a,s){this.mediaAcknowledgmentOperation=this._callOperationHandler.createPendingOperation("_MediaAcknowledgment",null,s,{preconditionTags:["NOT_SUPPORTED_IN_STREAMING_MODE"]}),this.mediaAcknowledgmentOperation.catch(Ef);const c=this.logger.createFnLogger("renegotiateIncoming",s);if(c.info("start"),a.newOffer&&!this.mediaAgent.getCapabilities().retargeting)return c.logFailure("Retarget offer received, but pluginless has no support for retarget"),void this.stopInternal({causeId:s,terminatedReason:38});const u=OV(c);try{const m=await u.execute("MediaProcessOffer",()=>this.mediaSession.processOfferAsync(a,s));this.handleOfferedModalities(m,s),this.getRenegotiationOfferType(m)===2&&await this.prepareModalitiesForResume(s);const b=await this.updateMediaModalities({offered:m},s);this.getRenegotiationOfferType(m)===1&&await this.prepareModalitiesForHold(s),this.updateMediaState(b,s),this.isRenegotiationHoldOrResume(b)&&this.updateScreenSharingState(b,s);const _=await u.execute("MediaCreateAnswer",()=>this.mediaSession.createAnswerAsync(!1,s)),k=this.getSignalingMediaTypes(b);await u.execute("SignalingAcceptRenegotiation",()=>this.signalingSession.acceptRenegotiationAsync(_,k,s)),await u.execute("SignalingMediaAcknowledgement",()=>this.mediaAcknowledgmentOperation);const N=await u.execute("CompleteNegotiation",()=>this.completeNegotiationAsync(s));this.onNegotiationCompletion(N,!1,m,s,u.getTelemetryData())}catch(m){try{if(!m.phase||m.phase==="CompleteNegotiation")throw this.callTelemetry.recordEvent("IncomingNegotiationFailure",m,s),m;const b=m;this.callTelemetry.recordEvent("IncomingNegotiationFailure",this.getTelemetryFromPhaseExecution(m),s);const _={type:this.mediaAgent.constants.RENEGOTIATION_ERROR.local,detail:m.error};if(b.phase==="SignalingAcceptRenegotiation"||b.phase==="SignalingMediaAcknowledgement")return c.logFailure("Error in renegotiateIncoming() -> rejecting media negotiation"),_.type=this.mediaAgent.constants.RENEGOTIATION_ERROR.signaling,this._callOperationHandler.maybeRejectOperation("_MediaAcknowledgment",_,void 0,s),void await this.mediaSession.rejectNegotiationAsync(_,s);this._callOperationHandler.maybeRejectOperation("_MediaAcknowledgment",_,void 0,s),await this.mediaSession.rejectNegotiationAsync(_,s),await this.signalingSession.rejectRenegotiationAsync(void 0,s)}catch(b){c.logFailure(b),this.callTelemetry.recordEvent("NegotiationFatalError",Hs(b),s),this.stopInternal({causeId:s,terminatedReason:47})}}}async updateMediaDescriptions(a,s){const c=this.logger.createFnLogger("updateMediaDescriptions",a);c.info("start");try{const u=await this.mediaSession.startMediaDescriptionsUpdateAsync(a,s);c.info(`send updateMediaDesriptions, descriptions=${xo(u)}`),await this.signalingSession.updateMediaDescriptionsAsync(a,u);const m=await this.mediaSession.completeMediaDescriptionsUpdateAsync(a);if(this.mediaAgent.getConfigProvider().config.syncMuteStateWithAudioDirection&&m?.appliedModalities?.audio){const b=m.appliedModalities.audio===this.mediaAgent.constants.MEDIA_STATE.receive||m.appliedModalities.audio===this.mediaAgent.constants.MEDIA_STATE.inactive;this.setMuted(b?2:this.isServerMuted?1:0,a)}this.onUpdateMediaDescriptionsCompletion(m,a)}catch(u){c.logFailure(u),this.callTelemetry.recordEvent("UpdateMediaDescriptionsFailure",u,a);const m=await this.mediaSession.rejectMediaDescriptionsUpdateAsync(a,!0);this.onUpdateMediaDescriptionsFailure(u,m,a)}}handleCallEscalation(a,s){const c=this.logger.createFnLogger("handleCallEscalation",s);if(c.info(`current callType=${this.callType}, escalationInProgress=${a}, isEscalationInProgress=${this.isEscalationInProgress}`),a){const u=this.participants[0];u&&u.audio.participantId===O7e?u.updateStreams([{type:jb.audio,direction:"inactive",sourceId:null,serverMuted:!1},{type:jb.video,direction:"inactive",sourceId:null,serverMuted:!1},{type:jb.sharing,direction:"inactive",sourceId:null,serverMuted:!1}],s,this.isMultiVBSSEnabled()):c.info("no 1-1 participant found, stream update ignored"),this.setCallType(2,s),this.setCallUsesMixer(!0,s),this.setIsEscalationInProgress(!1,s),this.callTelemetry.recordEvent("_EscalationCompleted",void 0,s),this.raiseChanged()}}async reportTsCallingTelemetry(a){if(this.tsCallingTelemetryReported)return;await this.connectCallPromise.catch(Ef);const s=a?"call_setup_session":"in_call_session";this.callTelemetry.setCallEndDiagnosticInfo(this.callEndDiagnosticsInfo),this.reportTelemetryEvents([{eventName:s,props:this.callTelemetry.getEvent(a)}],"signaling","skypecosi_concore_web_ts_calling"),a?this.callTelemetry.switchToInCallTelemetry():this.tsCallingTelemetryReported=!0}async sendMidCallTelemetry(a){this.mediaSession&&a?.length&&(this.callStats.setMediaStats(await this.mediaSession.getStatsAsync(!0)),this.appendInfoToCallStats(),this.reportTelemetryEvents(this.callStats.buildMidCallTelemetry(a),"media","mdsc_mid_call_telemetry"))}sendCallSetupTelemetry(){this.mediaSession&&(this.collectCallStats(this.mediaSession),this.reportCallSetupStats(),this.isCallSetupTelemetrySent=!0)}collectCallStats(a){const s=()=>this.collectMediaStatsDeferred.resolve();return a.getStatsAsync(!1).then(c=>this.callStats.setMediaStats(c)).then(s,s)}reportCallSetupStats(){this.collectMediaStatsDeferred.promise.then(()=>{this.reportTelemetryEvents(this.callStats.buildFromCallSetupStats(this.signalingSession.baseMessagingChannelUrl),"media","mdsc"),this.event("statsReported").raise(),this.collectMediaStatsDeferred=new Pi})}async reportCallEndStats(a){this.callTelemetry.setTerminationState(this.state),this.callTelemetry.setTerminationReason(this.terminatedReason),this.callStats.localStats.endCall(this.terminatedReason),a&&this.mediaAgent.getConfigProvider().config?.smallCallTelemetry?.enable&&this.reportSmallCallEvent(null),this.reportTelemetryEvents(this.callStats.buildFromLocalStats(),"signaling","skypecosi_concore_web"),this.reportTsCallingTelemetry(!this._callIsSetupComplete),a&&(await this.collectMediaStatsDeferred.promise,this.callStats.appendTerminationInfo(this.terminatedReason,this.state),this.appendInfoToCallStats(),this.reportTelemetryEvents(this.callStats.buildFromMediaStats(),"media","mdsc")),this.reportVDITelemetryEvents(),this.event("statsReported").raise(),this.collectMediaStatsDeferred=new Pi}async reportVDITelemetryEvents(){this.vdi3diagnostics&&this.reportTelemetryEvents([{eventName:"vdi_webrtc_session",props:await this.callStats.buildVDItelemetryReport(this.vdi3diagnostics)}],"media","mdsc")}reportTelemetryEvents(a,s,c){const u=this.telemetryLoggers?this.telemetryLoggers[s]:null;u?a.forEach(m=>u.sendEvent({eventName:`${c?`${c}_`:""}${m.eventName}`,props:m.props})):this.logger.debug(`reportTelemetryEvents no logger for tenant ${s}`)}onLocalPreviewSizeChanged(a,s){this.logger.debug(`onLocalPreviewSizeChanged: ${a}x${s}`)}onLocalPreviewStateChanged(a){this.logger.debug(`onLocalPreviewStateChanged: ${a}`),this.callStats.localStats.video.streamStateChanged(a.stream)}async configureVideoModalitiesAsync(a,s,c){if(!this.mediaSession)return this.logger.warn("Tried to configure modalities after call end"),Promise.resolve();a&&this._delayedElevationPending&&!this._delayedElevationQueued&&await this.triggerDelayedReconnectIfNeeded(s,"configureVideoModalitiesAsync"),await this.updateMediaModalities(void 0,s,c),a||this.turnOffLocalVideoPreview(s),this.setVideoOn(a,s)}turnOffLocalVideoPreview(a){return this.localVideoRenderer&&(this.localVideoRenderer.dispose(),this.localVideoRenderer=null),this.disposeLocalVideoHandle(),Promise.resolve(void 0)}turnOnLocalVideoPreview(a){return this.mediaSession?.getSessionConfig().config.useDeviceHandleForLocalVideo?this.acquireLocalVideo(a):(this.localVideoContainer||(this.localVideoContainer=document.createElement("div")),this.turnOnLocalVideoPreviewUsingRenderer(a))}acquireLocalVideo(a){const s=this.logger.createFnLogger("_StartPreviewVideo",a);if(!this.mediaStateConfigurationHelper.isSending(1))return Promise.reject("could not start video preview, not configured to send");try{this.disposeLocalVideoHandle();const c=this.callDeviceManager.getDeviceManager(NV(1));return this.localVideoHandle=c.createDevicesHandle({video:!0},"pluginlessCall:acquireLocalVideo()"),this.localVideoHandle.on("onStreamStateChanged",u=>this.onLocalPreviewStateChanged({stream:u})),this.localVideoHandle.acquire()}catch(c){return s.logFailure(c),void this.disposeLocalVideoHandle()}}turnOnLocalVideoPreviewUsingRenderer(a){const s=this.logger.createFnLogger("_StartPreviewVideo",a),c=this.mediaStateConfigurationHelper.isSending(1);if(!c||!this.localVideoContainer)return Promise.reject(`could not start video preview: requestedVideoState=${c}, localVideoContainer=${this.localVideoContainer}`);this.turnOffLocalVideoPreview(a);const u=Bt(()=>{this.localVideoRenderer=this.callDeviceManager.getDeviceManager(NV(1)).createPreviewRenderer(this.localVideoContainer,"Video"),this.localVideoRenderer.on("onVideoSizeChanged",(m,b)=>this.onLocalPreviewSizeChanged(m,b)),this.localVideoRenderer.on("onVideoStateChanged",m=>this.onLocalPreviewStateChanged(m))}).then(()=>this.localVideoRenderer.startVideoAsync(a));return u.catch(m=>s.logFailure(m)),u}async startStopVideo(a,s,c){const u=this.logger.createFnLogger(a?"startVideo":"stopVideo",s);return u.info("start"),this.canToggleVideo?(a?(this.callStats.localStats.newSession(1),this.callStats.localStats.video.start()):this.callStats.localStats.video.stop(),a&&this.mediaStateConfigurationHelper.isDisabled(1)&&u.info("Video modality was skipped till now. Adding it now."),a?this.mediaStateConfigurationHelper.enableModality(1):this.mediaStateConfigurationHelper.removeModality(1),this.canToggleVideo=!1,this.videoTogglePromise=(async()=>{try{let m=!1;a&&(await this.turnOnLocalVideoPreview(s),m=!0),await this.configureVideoModalitiesAsync(m,s,c)}catch(m){throw u.logFailure(m),this.mediaStateConfigurationHelper.removeModality(1),await this.configureVideoModalitiesAsync(!1,s,c),m}finally{this.canToggleVideo=!0}})(),this.videoTogglePromise):a===this.mediaStateConfigurationHelper.isSending(1)?(await this.videoTogglePromise,void this.turnOnLocalVideoPreview(s)):(u.logFailure(`video switching is in progress ${a}]`),Promise.reject({reason:1}))}async startStopAudio(a,s){const c=this.logger.createFnLogger(a?"startAudio":"stopAudio",s);try{const u=await this.updateMediaModalities(void 0,s);this.updateMediaState(u,s)}catch(u){return c.logFailure(u),9}return 0}updateEndpointStateForMute(a,s){try{this.signalingSession.updateEndpointState({state:{isMuted:a}},s).catch(c=>{this.logger.logFailure(`updateEndpointStateForMute failure: ${c}`)})}catch(c){this.logger.logFailure(`updateEndpointStateForMute failure: ${c}`)}}async handleServerMutedState(a){const s=this.logger.createFnLogger(`handleServerMutedState, isServerMuted=${!!this.isServerMuted}`,a);if(!this.isServerMuted){const c=this._muteState===3;if(this._muteState===1||c)try{s.info("is unmuting, as we are no longer server muted"),await this.handleMuteUnmuteOnMediaSession(!1,a),this.setMuted(0,a),this.unmutePendingPromise?.resolve(),c&&this.updateEndpointStateForMute(!1,a)}catch(u){throw s.logFailure(u),u}}if(this.isServerMuted&&this._muteState===0){s.info("is muting, as we are unmuted");try{await this.handleMuteUnmuteOnMediaSession(!0,a),this.setMuted(1,a)}catch(c){throw s.logFailure(c),c}}}async handleMuteUnmuteOnMediaSession(a,s){const c=this.logger.createFnLogger(`handleMuteUnmuteOnMediaSession, value=${!!a}`,s);if(this.mediaSession?.getAllowedModalities&&!this.isServerMuted){const u=this.isMuted||this.isServerMuted,m=this.mediaSession.getAllowedModalities().audio.some(b=>b===WR.send||b===WR.sendReceive);(u&&m||!u&&!m)&&(c.info(`updating audio modalities: Muted ${u} -> ${a}; audioAllowed = ${m}`),await this.updateMediaModalities(void 0,s))}return a?(c.info("mediaSession.muteInputAsync"),await this.mediaSession?.muteInputAsync(s)):a||(c.info("mediaSession.unmuteInputAsync"),await this.mediaSession?.unmuteInputAsync(s)),Promise.resolve()}canMuteOthers(){const a=this._enableUserMeetingRolesCheckForClientCapability&&this.meetingRoles?.some(c=>c==="attendee")||(this.advancedMeetingRole||this.meetingRole)==="attendee",s=this._enableEndpointMeetingRoleCheckForClientCapability&&!!this.endpoints?.endpointDetails.find(c=>this._endpointId===c.endpointId)?.endpointMeetingRoles?.some(c=>c==="attendee");return!a&&!s}updateCapabilities(a,s=!1){let c=!1,u=!1;t9(this.state,[11,12])||(this.isServerMuted&&!this._callInLobby?2&this._commandUrlPresence&&(c=!0):this.isMuted&&(c=!0),u=!!(1&this._commandUrlPresence)&&this.canMuteOthers()),this._capabilities.canUnmuteSelf===c&&this._capabilities.canMuteOthers===u||(this._capabilities.canUnmuteSelf=c,this._capabilities.canMuteOthers=u,this.logger.info(`[${a}][updateCapabilities] Computed self capabilities: ${JSON.stringify(this._capabilities)}`),s&&this.raiseChanged())}async evaluateEndpointStatesForAccept(a,s,c){const u=this.logger.createFnLogger(`evaluateEndpointStatesForAccept, isMuted=${!!a}`,c),m={};try{await this.handleMuteUnmuteOnMediaSession(a,c),Object.assign(m,{state:{isMuted:a}}),u.info("is updating endpointState for mute"),s&&(Object.assign(m,{endpointProperties:{additionalEndpointProperties:s}}),u.info("is updating endpointState for additionalEndpointProperties"))}catch(b){throw u.logFailure(b),Mu(b)}return m}async handleEndpointStatesForAccept(a,s){const c=this.logger.createFnLogger("handleEndpointStatesForAccept",s);try{await this.signalingSession.updateEndpointState(a,s)}catch(u){throw c.logFailure(u),Mu(u)}}async muteUnmute(a,s){const c=this.logger.createFnLogger(`muteUnmute, value=${!!a} isServerMuted=${this.isServerMuted} inLobby=${this._callInLobby}`,s);if(t9(this.state,[11,12]))return c.logFailure("Can not mute/unmute during preheat call"),Promise.reject(Mu("TransactionDisallowed"));const u=!a&&(!this.isServerMuted||this._callInLobby);try{if((a||u)&&await this.handleMuteUnmuteOnMediaSession(a,s),a)this.setMuted(2,s),c.info("is updating endpointState for mute"),this.updateEndpointStateForMute(!0,s);else{if(!u)return c.info("is unmuting on server"),this._muteState===2&&this.setMuted(3,s),this.isCallModeStreaming()?this.promoteToRealtimeAndUnmute(s):this.signalingSession.unmuteAsync(s).then(m=>{this.handleSelfUnmuteUpdatedInfo(m,s)});c.info("is updating endpointState for unmute"),this.setMuted(0,s),this.updateEndpointStateForMute(!1,s)}}catch(m){throw c.logFailure(m),Mu(m)}}async muteUnmuteSpeaker(a,s){this.setSpeakerMuted(a,s),this.mediaSession&&(a?await this.mediaSession.muteOutputAsync(s):await this.mediaSession.unmuteOutputAsync(s))}getParticipant(a){return this.participants.filter(s=>s.isSameParticipantsMri(a))[0]}getOrCreateParticipant(a,s,c){let u=this.getParticipant(a);return u||(u=new s7e(a,this.mediaSession,this.logger,this.callStats.localStats,this.callTelemetry,s),u.changed(()=>this.onParticipantChanged(u)),this.participants.push(u),c&&this.event("participantAdded").raise(u),this.monitorCallStart(),u)}onParticipantChanged(a){this.event("participantUpdated").raise(a),this.raiseChangedDeferred(this._participantChangedEventSkipConfig)}setCallState(a,s,c=0){if(this.state===a)return;const u=this.logger.createFnLogger("setCallState",s);u.info(`currentState=${this.state}, newState=${a}, terminatedReason=${this.terminatedReason}`),(rdi[this.state].indexOf(a)>=0||(u.logFailure("invalid state transition"),a===7))&&(this.callTelemetry.recordEvent("_SetCallState",{state:a,reason:c},s),this.state=a,this.callStats.localStats.call.callStateChanged(a),a===6&&this._startCallPhase&&(this.callTelemetry.updateOperationData("_ConnectCall",{phases:this._startCallPhase.getTelemetryData()},s),this._startCallPhase=void 0),a===7&&this.setTerminatedReason(c),a===3&&(this.callGotConnected=!0,this.callHeldAt=null),this.callIsHeld()&&!this.callHeldAt&&(this.callHeldAt=new Date),u.logSuccess(`changed to ${a}, terminatedReason: ${this.terminatedReason}, failureType=${this.failureType}`),this.screenSharingControl.callStateChanged(this.state),this.monitorCallStart(),this.event("callStateChanged").raise(),this.updateCapabilities(s),this.raiseChanged(),this.callTelemetry.recordEvent("_RaiseCallStateChangeEvent",{state:a,reason:c},s))}setTerminatedReason(a){if(this.terminatedReason=a,!(0,Zr.includes)(vhi,a)){const s=this.terminatedReason===44,c=this.terminatedReason===55,u=this.terminatedReason===56;this.setFailureType(!this.callGotConnected||!this._wasAudioStreamConnected||s||c||u?0:1)}}setMediaStream(a,s,c){if(a){if(!(0,Zr.find)(this.localMediaStreams,u=>u.mediaType===c)){const u=new Shi(s,c);this.logger.info(`setMediaStream ${JSON.stringify(u)}`),this.localMediaStreams.push(u)}}else this.logger.info(`setMediaStream removing ${c}`),(0,Zr.remove)(this.localMediaStreams,u=>u.mediaType===c)}setVideoOn(a,s){this.logger.info(`[${s}]videoOn=${a}`),this.isVideoOn=a,this.setMediaStream(this.isVideoOn,!0,1),this.callTelemetry.recordEvent("_SetLocalVideo",{value:a},s),this.raiseChanged()}setAudioOn(a,s){this.logger.info(`[${s}]audioOn=${a}`),this.setMediaStream(a,!0,0),this.callTelemetry.recordEvent("_SetLocalAudio",{value:a},s)}setScreenSharingOn(a,s){this.logger.info(`[${s}]screenSharingOn=${a}`),this.isScreenSharingOn=a,this.setMediaStream(this.isScreenSharingOn,this.isScreenSharingOn,2),this.callTelemetry.recordEvent("_SetScreenSharing",{screenSharingOn:a},s),this.event("userActivityChanged").raise(),this.raiseChanged()}disposeSharingScreenHandle(){this.sharedScreenHandle&&(this.sharedScreenHandle.dispose(),this.sharedScreenHandle=null)}disposeLocalVideoHandle(){this.localVideoHandle?.dispose(),this.localVideoHandle=null}setMuted(a,s){this._muteState!==a&&(this._muteState=a,this.callTelemetry.recordEvent("_SetMuted",{isMuted:a},s),this.logger.info(`[${s}]participantMuteState:${a}, isMuted: ${this.isMuted}`),this.updateCapabilities(s),this.raiseChanged(),this.event("muteStateChanged").raise(this.isMuted,s))}setSpeakerMuted(a,s){this.logger.info(`[${s}]speakerMute=${a}]`),this.isSpeakerMuted=a,this.raiseChanged()}monitorCallStart(){this.state!==3||!this.participants.length&&this.callMode!==2||this.callStartedAt||(this.callStartedAt=new Date)}_removeParticipant(a,s,c=0){const u=this.logger.createFnLogger("removeParticipant",s);u.info(`mri=${hye(a)}`);const m=(0,Zr.remove)(this.participants,b=>b.isSameParticipantsMri(a.id))[0];m?(m.setState(4,c,s),this.event("participantRemoved").raise(m)):u.logFailure(`unable to remove participant ${kn(a.id)}`),this.raiseChanged(this._participantChangedEventSkipConfig)}setIsSomeoneSharing(a,s){const c=this.isSomeoneSharing!==a&&!(a&&this.screenSharingRenegotiationDeferred&&this.callUsesMixer);c&&(this.isSomeoneSharing=a);let u=c;if(this.callUsesMixer&&this.mediaSession?.getSessionConfig().config.enableStopSharingWithIncomingOffer&&(u||(u=s)),!this.isMultiVBSSEnabled()&&u&&this.isSomeoneSharing&&this.isScreenSharingOn&&(this.stopScreenSharing(),this.logger.info("sharingStolen: Cleaning up local screenshare because remote screenshare is running"),this.event("sharingStolen").raise()),this.allowScreenSharingControl()&&this.screenSharingControl?.isInternalViewerControlEnabled()){const m=this.localSignalingParticipant.endpointDetails.find(_=>this._endpointId===_.endpointId),b=this.participants.find(_=>_.streams[1].some(k=>k.isAvailable));this.screenSharingControl.startOrStopControlForViewer(this.isSomeoneSharing,b,m)}}handleOfferedModalities(a,s){const c=this.mediaAgent.constants.MEDIA_STATE,u=this.logger.createFnLogger("handleOfferedModalities",s);try{u.info(`offeredModalities=${xo(a)}`)}catch(m){u.logFailure(m)}a.hasOwnProperty("video")||this.mediaStateConfigurationHelper.isSending(1)?a.hasOwnProperty("video")&&!this.mediaStateConfigurationHelper.isSending(1)&&this.mediaStateConfigurationHelper.removeModality(1):this.mediaStateConfigurationHelper.disableModality(1),a.hasOwnProperty("sharing")||this.mediaStateConfigurationHelper.isSending(2)||this.mediaStateConfigurationHelper.disableModality(2),a.sharing!==c.receive||this.mediaStateConfigurationHelper.isSending(2)||this.mediaStateConfigurationHelper.removeModality(2),a.data===c.sendReceive&&this.allowDataChannel()&&this.mediaStateConfigurationHelper.enableModality(3),this.isReivitelessEnabled()||(this.setIsSomeoneSharing(a.sharing===c.receive,!0),this.setIsSomeoneStreamingVideo(a.video===c.receive||a.video===c.sendReceive))}getRenegotiationOfferType(a){if(a){if(this.state===5){if(a.audio==="sendrecv")return 2}else if(this.modalitiesAreHold(a))return 1}return 0}isRenegotiationHoldOrResume(a){return this.getRenegotiationOfferType(a)===1||this.getRenegotiationOfferType(a)===2}isReivitelessEnabled(){return(this.signalingSession.getMaxReinvitelessMediaForVideoForWeb()>0||this.signalingSession.getMaxReinvitelessMediaForVBSSForWeb()>0)&&this.callUsesMixer}isValidHoldResumeCallState(a){return[3,5,10,13].includes(a)}onNegotiationCompletion(a,s,c={},u,m){const b=this.logger.createFnLogger("onNegotiationCompletion",u);b.info(`byLocal=${s}, result=${xo(a)}`),this.callTelemetry.recordEvent("NegotiationCompletion",{phaseTelemetryBag:m,...this.prepareNegotiationResultForTelemtry(a)},u);const _=this.isOneToOneCall();if(_&&!this.callUsesMixer){const se=this.modalitiesAreHold(a.activeModalities)?5:3;this.participants[0].setState(se,void 0,u),b.info(`isOneToOneCall: participant[0] state set to ${se}`)}const k=this.modalitiesAreHold(a.configuredModalities),N=this.modalitiesAreHold(a.activeModalities);let W;const ee=this.signalingSession.participantManager.localParticipant.isStaging;b.info(`isStaging= ${ee}`),this.requestedHoldState?(k&&N||b.info(`Not expected modalities when processing local hold: ${k} ${N}`),this.state!==4&&b.info(`Not expected state when processing local hold: ${this.state}, switching back to LocalHold`)):s||this.callHoldResumeDeferred?!k&&N?W=5:k||N||this._callInLobby||this.isPreheatedOnly()||(W=ee?13:3):this.state===4||this._callInLobby||this.isPreheatedOnly()||(W=_&&this.participants[0].state===5?5:ee?13:3),W&&this.setCallState(W,u),this.callHoldResumeDeferred&&(b.info(`isHoldInProgress=${this.isHoldInProgress}, state=${this.state}, completed=${N}`),this.isHoldInProgress?N&&this.finishCallHoldResume():this.inLocalHold()||this.finishCallHoldResume(this.isValidHoldResumeCallState(W)?void 0:new Error(`Call state changed to ${W} instead of Connected, Lobby, Staging or RemoteHold`))),this.requestedHoldState||(this.setIsSomeoneSharing((0,Zr.some)(this.participants,se=>(0,Zr.some)(se.streams[1],Re=>Re.isAvailable))),this.setIsSomeoneStreamingVideo((0,Zr.some)(this.participants,se=>(0,Zr.some)(se.streams[0],Re=>Re.isAvailable))));const oe=c&&c.sharing===this.mediaAgent.constants.MEDIA_STATE.send,de=a?.activeModalities?.sharing===this.mediaAgent.constants.MEDIA_STATE.send;if(this.resolveScreenSharingRenegotiation(u,oe,de,a.isComplete),this.retryOutgoingRenegotiation.retry){const se=this.retryOutgoingRenegotiation.causeId;this._callOperationHandler.executeChained(()=>this.updateMediaModalities(void 0,se),"_Renegotiate",se,se,void 0,void 0,{preconditionTags:["NOT_SUPPORTED_IN_STREAMING_MODE"]}),this.retryOutgoingRenegotiation.retry=!1}}onUpdateMediaDescriptionsFailure(a,s,c){const u=s?.requestedModalities.sharing===this.mediaAgent.constants.MEDIA_STATE.send;this.screenSharingRenegotiationDeferred&&u&&(this.screenSharingRenegotiationDeferred.reject(a),this.screenSharingRenegotiationDeferred=null)}onUpdateMediaDescriptionsCompletion(a,s){this.logger.createFnLogger("onUpdateMediaDescriptionsCompletion",s).info(`result=${xo(a)}`),this.callTelemetry.recordEvent("UpdateMediaDescriptionsCompletion",a,s);const c=a?.requestedModalities?.sharing===this.mediaAgent.constants.MEDIA_STATE.send,u=a?.appliedModalities?.sharing===this.mediaAgent.constants.MEDIA_STATE.send;this.resolveScreenSharingRenegotiation(s,c,u,!0)}resolveScreenSharingRenegotiation(a,s,c,u){const m=this.logger.createFnLogger("resolveScreenShareRenegotiation",a);if(m.info(`invoked with wasSharingOfferred: ${s}, isSharingActive: ${c}, isComplete: ${u}`),this.screenSharingRenegotiationDeferred){if(s&&c)m.info("resolving screenSharingRenegotiationDeferred"),this.screenSharingRenegotiationDeferred.resolve(),this.screenSharingRenegotiationDeferred=null;else if(this._enableResolveScreenSharingWhenNegotiationComplete&&u&&!this.retryOutgoingRenegotiation.retry&&this.canToggleScreenSharing){const b=new Error(`screenSharing error: wasSharingOfferred: ${s}, isSharingActive: ${c}`);m.info(`reject screenSharingRenegotiationDeferred ${b}`),this.screenSharingRenegotiationDeferred.reject(b),this.screenSharingRenegotiationDeferred=null}}}async updateMediaStatus(a){if(this.calculateIsSomeoneStreaming(a),this.mediaSession){const s=await this.updateMediaModalities(void 0,a);this.callTelemetry.updateOperationData("_UpdateLocalMediaStatus",s,a)}}calculateIsSomeoneStreaming(a){let s=!1,c=!1;for(const u of this.participants)if(s||(s=(0,Zr.some)(u.streams[1],m=>m.isAvailable)),c||(c=(0,Zr.some)(u.streams[0],m=>m.isAvailable)),s&&c)break;this._delayedElevationPending&&(s||c)&&this.triggerDelayedReconnectIfNeeded(a,"roster update"),this.setIsSomeoneSharing(s),this.setIsSomeoneStreamingVideo(c)}async triggerDelayedReconnectIfNeeded(a,s=""){const c=()=>{this._delayedElevationPending=!1,this._delayedElevationQueued=!1,this.mediaSession?.getDiagnostics()?.registerElevation("completed")};this.logger.info(`Delayed elevation (${s}): pending=${this._delayedElevationPending} queued=${this._delayedElevationQueued}`),this._delayedElevationPending&&!this._delayedElevationQueued?(this._delayedElevationQueued=!0,this._callOperationHandler.maybeRejectOperations(["_RenegotiateIncoming","_RenegotiateOutgoing","_Renegotiate"]),this.mediaSession?.getDiagnostics()?.registerElevation("attempted"),await this.mediaSession.reconnectAsync(a,!0,c)):this.logger.info(`Delayed elevation: was not queued, pending=${this._delayedElevationPending} isQueued=${this._delayedElevationQueued}`)}onNegotiationFailure(a,s,c,u){const m=u&&u.sharing===this.mediaAgent.constants.MEDIA_STATE.send;if(s===this.mediaAgent.constants.RENEGOTIATION_ERROR.glare)return this.screenSharingRenegotiationDeferred&&m&&this.callStats.localStats.screenShare.negotiationStateChanged("rejected","glare"),void(this.retryOutgoingRenegotiation={retry:!0,causeId:c});this.finishCallHoldResume(a),this.screenSharingRenegotiationDeferred&&m&&(this.screenSharingRenegotiationDeferred.reject(a),this.screenSharingRenegotiationDeferred=null)}static getParticipantReasonFromTerminatedReason(a){switch(a){case 1:return 0;case 9:return 2;case 10:return 3;case 2:return 4;case 24:return 8;case 3:return 9;case 4:return 10;case 14:return 12;case 0:default:return 11;case 15:return 13;case 16:return 14;case 17:return 15;case 18:return 16;case 19:return 17;case 20:return 18;case 11:return 19;case 21:return 20;case 22:return 21;case 23:return 22;case 33:return 25;case 36:return 26;case 37:return 27;case 41:return 30;case 39:return 28;case 42:return 31;case 40:return 29;case 43:return 32;case 44:return 33;case 45:return 34;case 46:return 35;case 47:return 36;case 48:return 37;case 49:return 38;case 50:return 39;case 51:return 40;case 52:return 41;case 54:return 42;case 55:return 44;case 56:return 45;case 12:return 23;case 59:return 46;case 73:return 59;case 61:return 47;case 60:return 48;case 62:return 49;case 63:return 50;case 64:return 5;case 65:return 51;case 8:return 52}}isRemoteParticipantInStaging(a){if(!a.endpointDetails)return!1;for(const s of a.endpointDetails)if(!_N(s))return!1;return!0}updateCallParticipantFromSignalingParticipant(a,s,c){if((0,Zr.every)(s.endpointDetails,N=>N?.isLobby||N?.streamLobby))return void a.setState(7,void 0,c);const u=(0,Zr.some)(s.endpointDetails,N=>N?.streamInformation),m=s.endpointDetails&&(0,Zr.some)(s.endpointDetails,N=>N.mappedTo),b=Pv.filterVirtualEndpoints(s.endpointDetails),_=b&&b[0].mediaStreams,k=this.isRemoteParticipantInStaging(s);if(_&&_.length>0){const N=_.every(ee=>ee.direction==="inactive");let W=N?5:k?8:3;this.state!==1||N||this.callUsesMixer||(W=2),this.logger.info(`[updateCallParticipantFromSignalingParticipant]: with mediaStreams is not empty, ParticipantState is set to ${W}`),a.setState(W,void 0,c)}else if(_||m||u){const N=k?8:3;this.logger.info(`[updateCallParticipantFromSignalingParticipant]: ParticipantState is set to ${N}, mediaStreams=${!!_}, hasMappedEndpoints=${m}, hasPlayerStreams=${u}`),a.setState(N,void 0,c)}}handleSelfServerMutedState(a){const s=Pv.filterVirtualEndpoints(this.localSignalingParticipant.endpointDetails),c=(0,Zr.find)(s,_=>this._endpointId===_.endpointId),u=c&&c.mediaStreams,m=u&&u.filter(_=>_.type==="audio"||_.type==="audio-teleconferencing"),b=c&&(c.stream||c.streamLobby);if(b){const _=b.serverMuted??!1;c.serverMuteVersion=0,_!==this.isServerMuted&&(this.isServerMuted=_,this.callTelemetry.recordEvent("_SelfParticipantUpdated",{isServerMuted:this.isServerMuted}),this.logger.info(`updateLocalParticipant: server muted set to ${_}`),this.event("serverMutedChanged").raise(_,a),this.updateCapabilities(a,!0),this.isServerMuted&&this.setMuted(1,a))}else if(m&&m.length>0){const _=m.some(k=>k.serverMuted);_!==this.isServerMuted&&(this.isServerMuted=_,this.callTelemetry.recordEvent("_SelfParticipantUpdated",{isServerMuted:this.isServerMuted}),this.logger.info(`updateLocalParticipant: server muted set to ${_}`),this.event("serverMutedChanged").raise(_,a),this.updateCapabilities(a,!0),this.handleServerMutedState(a))}}checkIfIncomingServerMutedIsUpdated(a){const s=(0,Zr.find)(this.localSignalingParticipant.endpointDetails,u=>u.participantId===this.localSignalingParticipant.participantId);if(s===void 0)return;const c=(0,Zr.find)(a.endpointDetails,u=>u.participantId===this.localSignalingParticipant.participantId);Q8e(this.logger,s,c)}convertWiredPublishedState(a){if(!a)return;const s=IV(a.stateType);return{content:a.content,stateType:s,typeRank:a.typeRank,stateId:a.stateId}}updatePublishedStateModified(a,s){a!==this.currentUserSkypeIdentity.id||s&&s!==this.participantId?this._publishedStatesModified=2|this._publishedStatesModified:this._publishedStatesModified=1|this._publishedStatesModified}updatePublishedStates(a){try{let s=[];(0,Zr.forEach)(a.publishedStates,u=>{s.push(this.convertWiredPublishedState(u))}),(0,Zr.isEqual)(this._participantPublishedStatesMap[a.id],s)||(s.length!==0||this._participantPublishedStatesMap[a.id]!==void 0&&this._participantPublishedStatesMap[a.id]!==null)&&(this._participantPublishedStatesMap[a.id]=s,this.updatePublishedStateModified(a.id));const c=[];(0,Zr.forEach)(a.endpointDetails,u=>{c.push(u.participantId),s=[],(0,Zr.forEach)(u.publishedStates,m=>{const b=this.convertWiredPublishedState(m);if(this._endpointPublishedStatesMap[a.id]||(this._endpointPublishedStatesMap[a.id]={},this._endpointPublishedStatesMap[a.id][u.participantId]=[]),b.stateType==="clientMediaUfd")try{const _=JSON.parse(JSON.stringify(b.content));this.mediaSession.registerRemoteQualityStateChangedEvent(_,u.participantId)}catch(_){this.logger.error(`Error while parsing state.content for ClientMediaUFD: ${_}`)}s.push(b)}),this._endpointPublishedStatesMap[a.id]&&!(0,Zr.isEqual)(this._endpointPublishedStatesMap[a.id][u.participantId],s)&&(s.length!==0||this._endpointPublishedStatesMap[a.id][u.participantId]!==null&&this._endpointPublishedStatesMap[a.id][u.participantId]!==void 0)&&(this._endpointPublishedStatesMap[a.id][u.participantId]=s,this.updatePublishedStateModified(a.id,u.participantId))}),this._endpointPublishedStatesMap[a.id]&&Object.keys(this._endpointPublishedStatesMap[a.id]).forEach(u=>{c.some(m=>m===u)||(delete this._endpointPublishedStatesMap[a.id][u],this.updatePublishedStateModified(a.id,u))})}catch(s){this.logger.error(`updatePublishedStates ${JSON.stringify(s)}`)}this.logger.info(`updatePublishedStates ${tN(this._participantPublishedStatesMap)}`),this.logger.info(`updatePublishedStates ${tN(this._endpointPublishedStatesMap)}`)}removePublishedStatesByParticipant(a){this._endpointPublishedStatesMap[a]&&delete this._endpointPublishedStatesMap[a],this._participantPublishedStatesMap[a]&&delete this._participantPublishedStatesMap[a],this.updatePublishedStateModified(a)}findOrCreateTypeState(a){let s=this._publishedStates.typeStates.findIndex(c=>c.type===a);if(s===-1){const c={participantStates:[],type:a};this._publishedStates.typeStates.push(c),s=this._publishedStates.typeStates.length-1}return s}processPublishedStates(){this.logger.info(`processPublishedStates ${tN(this._participantPublishedStatesMap)}`),this.logger.info(`processPublishedStates ${tN(this._endpointPublishedStatesMap)}`);try{this._publishedStates||(this._publishedStates={typeStates:[]}),this._publishedStates.typeStates=[];for(const a of Object.keys(this._participantPublishedStatesMap)){const s=this._participantPublishedStatesMap[a];(0,Zr.forEach)(s,c=>{const u=this.findOrCreateTypeState(c.stateType),m={id:a,publishedState:{content:c.content,stateId:c.stateId,typeRank:c.typeRank}};this._publishedStates.typeStates[u].participantStates.push(m)})}for(const a of Object.keys(this._endpointPublishedStatesMap))for(const s of Object.keys(this._endpointPublishedStatesMap[a]))this._endpointPublishedStatesMap[a][s].forEach(c=>{const u=this.findOrCreateTypeState(c.stateType),m={id:s,publishedState:{content:c.content,stateId:c.stateId,typeRank:c.typeRank}},b={id:a,endpoints:[m]},_=this._publishedStates.typeStates[u].participantStates.filter(k=>k.id===a);_&&_.length>0?(_[0].endpoints||(_[0].endpoints=[]),_[0].endpoints.push(m)):this._publishedStates.typeStates[u].participantStates.push(b)});this.event("publishedStatesChanged").raise(this._publishedStates),this.raiseChanged()}catch(a){this.logger.error(`processPublishedStates ${a}}`)}}updateLocalParticipant(a,s){const c=this.logger.createFnLogger("updateLocalParticipant",s);this.checkIfIncomingServerMutedIsUpdated(a),this.localSignalingParticipant.endpointDetails=a.endpointDetails,this.localSignalingParticipant.role=a.role,this.setMeetingRole(a.meetingRole),this.setAdvancedMeetingRole(a.advancedMeetingRole),this.setMeetingRoles(a.meetingRoles),this.setParticipantType(a.participantType),this.setDisplayName(a.displayName),this.setPropertyBag(a.propertyBag),this.setPropertyRosterVersion(a.version),this.setMaskedIdentityDetails(a.isIdentityMasked,a.maskedIdSeqNumber,a.maskedId),this.setOtpIdentity(a.otpIdentity),this.localSignalingParticipant.tenantId=a.tenantId,this.localSignalingParticipant.isLobby=a.isLobby,a.joinAsStreamingUser&&(this.localSignalingParticipant.joinAsStreamingUser=a.joinAsStreamingUser,this.setJoinAsStreamingUser(a.joinAsStreamingUser)),a.enableCaptcha!==void 0&&this.setEnableCaptcha(a.enableCaptcha),this.callTelemetry.setTenantId(a.tenantId),this.callStats.setTenantId(a.tenantId);const u=this.localSignalingParticipant.isLobby;a.endpointDetails&&this.updateLocalParticipantEndpoints(a.endpointDetails),this.updatePublishedStates(a),this.handleSelfServerMutedState(s);const m=this.getLocalSignalingEndpointDetails();this._callInLobby=u||!!m?.streamLobby,this.signalingSession.participantManager.localParticipant.isStaging=a.isStaging;const b=this.signalingSession.participantManager.localParticipant.isStaging;c.info(`callInLobby = ${u}, callSetupComplete = ${this._callIsSetupComplete}, callIsHeld = ${this.callIsHeld()}, isStaging = ${b}`),!this._callIsSetupComplete||this.callIsHeld()||t9(this.state,[11,12])||(u?this.setCallState(10,s):b&&t9(this.state,[3,13,10,9,2])?this.setCallState(13,s):this.setCallState(3,s));const _=Pv.getStreamsFromEndpoints(a.endpointDetails,this.isMultiVBSSEnabled());if(this.callTelemetry.recordEvent("_UpdateLocalParticipantStream",yui(_),s),this.streamManager.updateStreams(_,s),this.updateCapabilities(s,!0),this.allowScreenSharingControl()&&this.screenSharingControl?.isInternalViewerControlEnabled()){const k=a.endpointDetails.find(W=>this._endpointId===W.endpointId),N=this.participants.find(W=>W.streams[1].some(ee=>ee.isAvailable));this.screenSharingControl.startOrStopControlForViewer(this.isSomeoneSharing,N,k)}}modalitiesAreHold(a){return!(a.audio&&a.audio!=="inactive"||a.video&&a.video!=="inactive"||a.sharing&&a.sharing!=="inactive")}toneToString(a){switch(a){case 0:return"0";case 1:return"1";case 2:return"2";case 3:return"3";case 4:return"4";case 5:return"5";case 6:return"6";case 7:return"7";case 8:return"8";case 9:return"9";case 10:return"*";case 11:return"#";default:return null}}static streamingStatetoMediaStreamState(a){switch(a){case"started":return 0;case"active":return 2;case"inactive":return 1;case"stopped":return 3;default:return 4}}static streamingDirectionToMediaDirectionMapping(a){switch(a){case"send":return 1;case"receive":return 0;default:return}}static convertMuteScope(a){switch(a){case 0:return"EveryoneElse";case 1:return"SpecifiedParticipants";default:return}}callIsHeld(){return this.state===4||this.state===5}inLocalHold(){return this.isHoldInProgress||this.state===4}telemetryDataFromCallStartOptions(a){const s={};return a.muteFlags&&(s.muteMicrophone=!!(1&a.muteFlags),s.muteSpeaker=!!(2&a.muteFlags)),Object.keys(s).length?s:void 0}reconnect(){const a=hi();return this.mediaSession.reconnectAsync(a)}async provideCallQualityFeedback(a,s,c,u){}async showCQFInfo(a,s){throw new Error("Not implemented")}async isCqfRendered(a){}async provideCallQualityFeedbackEx(a,s,c,u,m,b){}testTriggerMediaRelayWhiteListingIssue(){this.logger.info("Simulating media relay whitelisting issue for test purposes");const a=this.mediaSession.mediaSession.callback,s={type:"NetworkRelaysNotReachable",value:"Bad",isLocalSource:!0,mediaType:"Audio"};a.onQualityChanged(s);const c={direction:"send",stream:"failed",content:"audio"};a.onAudioStateChanged(c)}async getMediaTelemetry(a=!1){return this.mediaSession&&(this.callStats.setMediaStats(await this.mediaSession.getStatsAsync(a)),this.appendInfoToCallStats()),this.callStats.buildMediaTelemetry()}getMediaSessionStats(){return this.mediaSession?.getMediaStatsReport()}async getMediaSessionStatsAsync(){return this.mediaSession?.getMediaStatsReport()}async getAudioSendStats(){return this.mediaSession?.getAudioSenderStats()}getDiagnosticsForE2E(){return this.mediaSession?.getDiagnostics().e2eDiagnostics}appendInfoToCallStats(){this.callStats.appendDataChannelInfo(this.dataChannel.getTelemetry()),this.callStats.appendSharingControlInfo(this.screenSharingControl?.isScreenSharingControlEnabled()),this.callStats.appendMediaControlPlaneInfo(JSON.stringify(this.mediaSession?.getMediaControlPlaneInstance()?.getTelemetryReport()))}getMediaLogs(){return this.mediaAgent.getMediaLogs()}testSetCallState(a){this.logger.info(`Overwriting call state for test purposes: ${this.state} -> ${a} `),this.state=a}testSetCallType(a){this.logger.info(`Overwriting call state for test purposes: ${this.callType} -> ${a} `),this.callType=a}addGroupModality(a,s=hi()){const c=this.logger.createFnLogger("AddGroupModality",s);if(!a.threadId&&!a.groupId)return Promise.reject(Mu("No threadId/groupId was provided."));if(this.state===6||this.state===7)return c.info(`Not adding modality because CallState is ${this.state} groupId=${kn(a.groupId)}, threadId = ${Qu(a.threadId)} messageId = ${a.messageId}`),Promise.reject(Mu("TransactionDisallowed"));let u;if(a.additionalData)try{u=JSON.stringify(a.additionalData)}catch(m){c.logFailure(`additionalData: ${a.additionalData} is not valid Json, error: ${m}`);const b={code:er.BadRequest,subCode:0,phrase:`additionalData is not valid Json, error: ${m}`};return Promise.reject(b)}if(c.info(`groupId=${kn(a.groupId)}, threadId = ${Qu(a.threadId)} messageId = ${a.messageId} additionalData = ${kn(u)}`),this._enableAddModalityGeneric){const m={groupContext:{id:a.groupId},groupChat:{threadId:a.threadId,messageId:a.messageId}};return this.signalingSession.addModalityAsync(m,s).catch(b=>(c.logFailure(fi(b)),Promise.reject(b)))}{const m={groupId:a.groupId,threadId:a.threadId,messageId:a.messageId,additionalData:u};return this.signalingSession.addGroupModalityAsync(m,s).catch(b=>(c.logFailure(fi(b)),Promise.reject(b)))}}addBroadcastModality(a,s){const c=this.logger.createFnLogger("AddBroadcastModality",s);return Promise.resolve().then(()=>{this.signalingSession.addBroadcastModalityAsync(a,s)}).catch(u=>(c.logFailure(fi(u)),Promise.reject(Mu(u)))).then(()=>this._callOperationHandler.waitForOperation("AddBroadcastModality")).catch(u=>{throw this.callTelemetry.updateOperationData("AddBroadcastModality",{error:Hs(u)},s),c.logFailure(u),u})}static convertQualityEventType(a){switch(a){case"NetworkSendQuality":return 1;case"NetworkRecvQuality":return 2;case"NetworkDelay":return 3;case"NetworkBandwidthLow":return 4;case"NetworkReconnect":return 5;case"NetworkPacketLoss":return 6;case"NetworkJitter":return 7;case"NetworkRateMatching":return 8;case"DeviceCaptureNotFunctioning":return 9;case"DeviceRenderNotFunctioning":return 10;case"DeviceRenderGlitches":return 11;case"DeviceLowSNR":return 12;case"DeviceLowSpeechLevel":return 13;case"DeviceClipping":return 14;case"DeviceEcho":return 15;case"DeviceNearEndToEchoRatio":return 16;case"DeviceHalfDuplexAec":return 17;case"DeviceMultipleEndpoints":return 18;case"DeviceHowling":return 19;case"DeviceRenderZeroVolume":return 20;case"DeviceRenderMute":return 21;case"NetworkSendCatastrophic":return 22;case"NetworkRecvCatastrophic":return 23;case"CpuInsufficient":return 24;case"DeviceCaptureMute":return 25;case"DeviceCaptureNotMuteButSilent":return 26;case"DeviceSpeakWhileMuted":return 27;case"VideoVbssRendered":return 28;case"NetworkEthernetInterfaceUsed":return 29;case"NetworkWlanInterfaceUsed":return 30;case"NetworkWwanInterfaceUsed":return 31;case"NetworkRelaysNotReachable":return 32;case"VideoCapturerDeviceStartFailed":return 33;case"VideoCapturerDeviceStartTimedOut":return 34;case"VideoCapturerDeviceStartFailureLackSystemRes":return 35;case"VideoCapturerDeviceStartFailureMFResConflict":return 36;case"NoNetwork":return 37;case"NetworkNotWorking":return 38;case"DeviceCaptureNotFunctioningDeviceInUse":return 39;case"DeviceRenderNotFunctioningDeviceInUse":return 40;case"VideoCaptureDeviceFreeze":return 45;case"ZeroCaptureDevicesEnumerated":return 43;case"ZeroRenderDevicesEnumerated":return 44;case"VideoCapturePermissionDenied":return 47;case"ScreenshareRecordingDisabled":return 55;case"AudioCapturePermissionDenied":return 46;case"VideoCaptureFreezeRecovered":return 48;case"DeviceRenderHowling":return 49;case"PresentationAudioLoopbackDeviceState":return 53;case"RemoteNetworkConnectivityIssue":return 52;case"AudioCaptureUltrasoundDetected":return 54;case"MusicModeNotAvailable":return 57;case"CameraLighting":return 61;case"AudioLoopbackDeviceReady":return 63;case"NoRequiredVideoCodecs":return 64;case"SpatialAudioMUCHUnavailable":return 65;case"AudioMixMUCHUnavailable":return 80;default:return}}static convertQualityLevel(a){switch(a){case"Unknown":return 0;case"Good":return 1;case"Poor":return 2;case"Bad":return 3;default:return}}static convertMediaType(a){switch(a){case"Audio":return 0;case"Video":return 1;case"ScreenShare":return 2;case"Data":return 3;default:return}}getPluginlessPublishLevel(a){switch(a){case"user":return"user";case"endpoint":return"endpoint";default:throw"Invalid level type."}}setIsEmergency(a){this.logger.info(`Set isEmergency:${a}`),this.isEmergency=a,this.callTelemetry.setIsEmergency(a)}static filterVirtualEndpoints(a){return a&&(0,Zr.filter)(a,s=>!s.mappedTo)}mapDataChannelSourceIdToParticipant(a){let s=null;return s=this.callType===1?this.participants[0]:(0,Zr.find)(this.participants,c=>c.hasSourceId(3,a)),s?.id?this.logger.info(`ParticipantId: ${kn(s.id)} to SourceId: ${a}`):this.logger.warn(`No Participant found for SourceId: ${a}`),s}getDataChannelSourceId(){const a=(0,Zr.find)(this.endpoints.endpointDetails,c=>c!==null&&c.participantId===this._participantId);if(!a)return this.logger.warn(`No participantLeg found for participantId: ${this._participantId}`),-1;if(!a.mediaStreams)return this.logger.warn(`ParticipantLeg ${this._participantId} does not have valid mediaStreams`),-1;const s=(0,Zr.find)(a.mediaStreams,c=>CN(c.type)===3);return s?s.sourceId:(this.logger.warn(`participantLeg ${this._participantId} has no data channel`),-1)}initializeLiveStreamConfigProvider(){const a="MDN_MIDDLELANE_TEAMS",s="liveStream",c=this.ecsProvider.getEcsConfig(a,s),u=this.ecsProvider.getEcsConfig("ConfigIDs",a);this._liveStreamConfigProvider=new g2(c,null,u,this.logger.createChild("LiveStreamConfigProvider"))}isMediaSending(a){return this.mediaStateConfigurationHelper.isSending(a)}async setAudioStreamConnectedAsync(a){this.isAudioStreamConnected=a}async setSpamRiskLevelAsync(a){this.spamRiskLevel=a}async setSpamStirAttestationAsync(a){this.spamStirAttestation=a}async setDominantSpeakerInfoAsync(a){this.dominantSpeakerInfo=a}async setSlowedDownActiveTalkerInfoAsync(a){this.slowedDownActiveTalkerInfo=a}};na.instanceCount=0,na.getNegotiationTagsFromEndpoints=n=>{if(!n)return;const a=new Map;return na.filterVirtualEndpoints(n).forEach(s=>{a.set(s.endpointId,s.negotiationTag)}),a},Kt([va("SetMeetingLayout"),ki(0,Xa)],na.prototype,"setMeetingLayout"),Kt([va("Initialize",{type:"Sync",convertError:!0,idempotencyLevel:"NoOp"})],na.prototype,"init"),Kt([va("StartVideo",{waitFor:"_UpdateMediaDescriptions",preconditionTags:["NOT_SUPPORTED_IN_STREAMING_MODE"]}),ki(1,Xa)],na.prototype,"startVideo"),Kt([va("StopVideo",{waitFor:"_UpdateMediaDescriptions",preconditionTags:["NOT_SUPPORTED_IN_STREAMING_MODE"]}),ki(1,Xa)],na.prototype,"stopVideo"),Kt([va("DumpVideoSourceImages")],na.prototype,"dumpVideoSourceImages"),Kt([ki(1,Xa)],na.prototype,"hold"),Kt([va("Hold",{preconditionTags:["NOT_SUPPORTED_IN_STREAMING_MODE"]}),ki(0,Xa)],na.prototype,"holdWithRenegotiate"),Kt([va("LocalHold",{preconditionTags:["NOT_SUPPORTED_IN_STREAMING_MODE"]}),ki(0,Xa)],na.prototype,"localHold"),Kt([va("Unhold",{waitFor:["Hold","LocalHold"],preconditionTags:["NOT_SUPPORTED_IN_STREAMING_MODE"]}),ki(1,Xa)],na.prototype,"unhold"),Kt([va("UpdateEndpointMetadata"),ki(1,Xa)],na.prototype,"updateEndpointMetadata"),Kt([va("SendDtmfTone",{preconditionTags:["NOT_SUPPORTED_IN_STREAMING_MODE"]})],na.prototype,"sendDtmfTone"),Kt([va("SetAudioUsage")],na.prototype,"setAudioUsageMode"),Kt([va("SetAudioMidcallConfig")],na.prototype,"setAudioMidcallConfig"),Kt([va("SetAudioMidcallConfigJon",{preconditionTags:["NOT_SUPPORTED_IN_STREAMING_MODE"]}),ki(1,Xa)],na.prototype,"setAudioMidcallConfigJson"),Kt([va("SetParticipantSpatialAudioPositions",{waitFor:"_ElectronSlimcoreReady",preconditionTags:["NOT_SUPPORTED_IN_STREAMING_MODE"]}),ki(1,Xa)],na.prototype,"setParticipantSpatialAudioPositions"),Kt([va("BlindTransfer",{singular:!0,type:"Chained",preconditionTags:["NOT_SUPPORTED_IN_STREAMING_MODE"]}),ki(1,Xa)],na.prototype,"callBlindTransfer"),Kt([va("SafeTransfer",{singular:!0,type:"Chained",preconditionTags:["NOT_SUPPORTED_IN_STREAMING_MODE"]}),ki(1,Xa)],na.prototype,"callSafeTransfer"),Kt([va("TransferToVoicemail",{singular:!0,type:"Chained",preconditionTags:["NOT_SUPPORTED_IN_STREAMING_MODE"]}),ki(1,Xa)],na.prototype,"transferCallToVoicemail"),Kt([va("ConsultativeTransfer",{singular:!0,type:"Chained",preconditionTags:["NOT_SUPPORTED_IN_STREAMING_MODE"]}),ki(1,Xa)],na.prototype,"callConsultativeTransfer"),Kt([va("ConsultativeTransferWithPickupCode",{singular:!0,type:"Chained",preconditionTags:["NOT_SUPPORTED_IN_STREAMING_MODE"]})],na.prototype,"consultativeTransferWithPickupCode"),Kt([va("CallRedirect",{singular:!0,type:"Chained",preconditionTags:["NOT_SUPPORTED_IN_STREAMING_MODE"]}),ki(1,Xa)],na.prototype,"callRedirect"),Kt([va("ParkCall",{type:"Chained",preconditionTags:["NOT_SUPPORTED_IN_STREAMING_MODE"]}),ki(1,Xa)],na.prototype,"park"),Kt([va("UnparkCall",{type:"Chained",preconditionTags:["NOT_SUPPORTED_IN_STREAMING_MODE"]}),ki(1,Xa)],na.prototype,"unpark"),Kt([va("getTechnicalInformationJson",{preconditionTags:["NOT_SUPPORTED_IN_STREAMING_MODE"]})],na.prototype,"getTechnicalInformationJson"),Kt([va("StartScreenSharing",{waitFor:"_UpdateMediaDescriptions",preconditionTags:["NOT_SUPPORTED_IN_STREAMING_MODE"]}),ki(3,Xa)],na.prototype,"startScreenSharing"),Kt([va("StopScreenSharing",{waitFor:"_UpdateMediaDescriptions",preconditionTags:["NOT_SUPPORTED_IN_STREAMING_MODE"]}),ki(2,Xa)],na.prototype,"stopScreenSharing"),Kt([va("StartDataChannel",{type:"Chained",preconditionTags:["NOT_SUPPORTED_IN_STREAMING_MODE"]}),ki(1,Xa)],na.prototype,"startDataChannel"),Kt([va("StopDataChannel",{type:"Chained",preconditionTags:["NOT_SUPPORTED_IN_STREAMING_MODE"]}),ki(1,Xa)],na.prototype,"stopDataChannel"),Kt([va("ShareSystemSounds",{waitFor:"_UpdateMediaDescriptions",preconditionTags:["NOT_SUPPORTED_IN_STREAMING_MODE"]}),ki(1,Xa)],na.prototype,"shareSystemSound"),Kt([va("Mute",{waitFor:"JoinPreheatedCall",preconditionTags:["NOT_SUPPORTED_IN_STREAMING_MODE"]}),ki(0,NG),ki(0,Xa)],na.prototype,"mute"),Kt([va("Unmute",{waitFor:["JoinPreheatedCall"]}),ki(0,NG),ki(0,Xa)],na.prototype,"unmute"),Kt([va("MuteSpeaker",{preconditionTags:["NOT_SUPPORTED_IN_STREAMING_MODE"]}),ki(0,Xa)],na.prototype,"muteSpeaker"),Kt([va("UnmuteSpeaker",{preconditionTags:["NOT_SUPPORTED_IN_STREAMING_MODE"]}),ki(0,Xa)],na.prototype,"unmuteSpeaker"),Kt([va("GetSpeakerVolume",{preconditionTags:["NOT_SUPPORTED_IN_STREAMING_MODE"]}),ki(0,Xa)],na.prototype,"getSpeakerVolume"),Kt([va("SetSpeakerVolume",{preconditionTags:["NOT_SUPPORTED_IN_STREAMING_MODE"]}),ki(1,Xa)],na.prototype,"setSpeakerVolume"),Kt([va("MuteParticipants",void 0),ki(2,NG),ki(2,Xa)],na.prototype,"muteParticipants"),Kt([va("StartAudio",{type:"Chained",preconditionTags:["NOT_SUPPORTED_IN_STREAMING_MODE"]}),ki(1,Xa)],na.prototype,"startAudio"),Kt([va("StopAudio",{type:"Chained",preconditionTags:["NOT_SUPPORTED_IN_STREAMING_MODE"]}),ki(1,Xa)],na.prototype,"stopAudio"),Kt([va("Assimilate"),ki(3,Xa)],na.prototype,"assimilate"),Kt([ki(2,Xa)],na.prototype,"merge"),Kt([va("MergeParticipants"),ki(1,uu),ki(3,Xa)],na.prototype,"mergeParticipants"),Kt([va("MergeWithPickupCode"),ki(0,uu),ki(2,Xa)],na.prototype,"mergeWithPickupCode"),Kt([va("SetMaxVideoChannels")],na.prototype,"setMaxVideoChannels"),Kt([va("SetMaxVbssChannels")],na.prototype,"setMaxVbssChannels"),Kt([va("StopCall"),ki(1,Xa),ki(3,Jee)],na.prototype,"stop"),Kt([va("PublishState"),ki(1,uu)],na.prototype,"publishState"),Kt([va("PublishState"),ki(1,uu)],na.prototype,"publishStatesForEveryone"),Kt([va("RemoveState"),ki(1,uu)],na.prototype,"removeState"),Kt([va("RemoveState"),ki(1,uu)],na.prototype,"removeStatesForEveryone"),Kt([va("UpdateMeetingSettings"),ki(1,uu)],na.prototype,"updateMeetingSettings"),Kt([va("UpdateMeetingGroups"),ki(0,uu)],na.prototype,"updateMeetingGroups"),Kt([va("UpdateMeetingLiveState"),ki(0,uu)],na.prototype,"updateMeetingLiveState"),Kt([va("UpdateMeetingStates"),ki(1,uu)],na.prototype,"updateMeetingStates"),Kt([va("UpdateParticipantInterpretationState"),ki(0,uu)],na.prototype,"updateParticipantInterpretationState"),Kt([va("UpdateParticipantsProperties")],na.prototype,"updateParticipantsProperties"),Kt([va("JoinMeetingGroup"),ki(0,uu)],na.prototype,"joinMeetingGroup"),Kt([va("LeaveMeetingGroup"),ki(0,uu)],na.prototype,"leaveMeetingGroup"),Kt([va("SendMessages"),ki(0,uu)],na.prototype,"sendMessages"),Kt([va("UpdateMonitorSession"),ki(1,Xa)],na.prototype,"updateMonitorSession"),Kt([va("SwitchInterpreterGroup")],na.prototype,"switchInterpreterGroup"),Kt([va("SetLiveInterpretationAttributes")],na.prototype,"setLiveInterpretationAttributes"),Kt([va("UpdateMeetingRole")],na.prototype,"updateMeetingRoles"),Kt([va("CreateContentSharingSession"),ki(4,Xa)],na.prototype,"createContentSharingSession"),Kt([va("StopCallWithBeacon",{type:"Sync"}),ki(0,Xa)],na.prototype,"stopWithBeacon"),Kt([va("Acknowledge",{type:"Chained",convertError:!0,idempotencyLevel:"Error",preconditionTags:["NOT_SUPPORTED_IN_STREAMING_MODE"]}),ki(2,Xa)],na.prototype,"acknowledge"),Kt([va("Accept",{type:"Chained",preconditionTags:["NOT_SUPPORTED_IN_STREAMING_MODE"]}),ki(1,Xa)],na.prototype,"accept"),Kt([va("Reject",{preconditionTags:["NOT_SUPPORTED_IN_STREAMING_MODE"]}),ki(0,Xa),ki(1,Jee)],na.prototype,"reject"),Kt([va("JoinCall",{type:"Chained",idempotencyLevel:"Error"}),ki(1,R2),ki(2,Xa)],na.prototype,"join"),Kt([va("JoinPreheatedCall",{waitFor:"_CallStartOrJoinInitiated"})],na.prototype,"joinPreheatedCall"),Kt([va("StartCall",{type:"Chained",idempotencyLevel:"Error"}),ki(0,R2),ki(1,Xa)],na.prototype,"start"),Kt([va("StartCallToVoiceMail",{type:"Chained",idempotencyLevel:"Error"}),ki(1,Xa)],na.prototype,"startCallToVoicemail"),Kt([va("Subscribe",{type:"Chained",idempotencyLevel:"Error"}),ki(2,Xa)],na.prototype,"joinCallWithoutCallModality"),Kt([va("StartWithMeetingData",{type:"Chained",idempotencyLevel:"Error"})],na.prototype,"startWithMeetingData"),Kt([va("JoinWithMeetingData",{type:"Chained",idempotencyLevel:"Error"})],na.prototype,"joinWithMeetingData"),Kt([va("SubscribeWithMeetingData",{type:"Chained",idempotencyLevel:"Error"})],na.prototype,"subscribeWithMeetingData"),Kt([va("StartCallWithNudge",{type:"Chained",idempotencyLevel:"Error"}),ki(1,R2),ki(2,Xa)],na.prototype,"startCallWithNudge"),Kt([va("StartCallAndUnpark",{type:"Chained",idempotencyLevel:"Error",preconditionTags:["NOT_SUPPORTED_IN_STREAMING_MODE"]}),ki(2,R2),ki(3,Xa)],na.prototype,"startAndUnpark"),Kt([Fg("AdmitParticipant"),ki(0,uu),ki(1,Xa)],na.prototype,"admitParticipant"),Kt([va("Admit")],na.prototype,"admit"),Kt([Fg("CallMeBack"),ki(0,uu),ki(2,Xa)],na.prototype,"callMeBack"),Kt([ki(0,uu),ki(2,Xa)],na.prototype,"addParticipant"),Kt([Fg("AddParticipants"),ki(0,uu),ki(2,Xa)],na.prototype,"addParticipants"),Kt([ki(0,uu),ki(2,Xa)],na.prototype,"addParticipantsImpl"),Kt([Fg("NudgeParticipants"),ki(0,uu),ki(3,Xa)],na.prototype,"nudgeParticipants"),Kt([Fg("RemoveParticipant"),ki(0,uu),ki(1,Xa)],na.prototype,"removeParticipant"),Kt([Fg("CancelNudge"),ki(0,uu),ki(0,Xa)],na.prototype,"cancelNudge"),Kt([va("SearchParticipants"),ki(1,uu),ki(1,Xa)],na.prototype,"searchParticipants"),Kt([va("GetAllParticipants"),ki(1,uu),ki(1,Xa)],na.prototype,"getAllParticipants"),Kt([va("_PromotionToRealtime"),ki(1,Xa)],na.prototype,"promoteToRealtime"),Kt([ki(0,Xa)],na.prototype,"turnOffLocalVideoPreview"),Kt([va("_StartPreviewVideo"),ki(0,Xa)],na.prototype,"turnOnLocalVideoPreview"),Kt([ki(0,Xa)],na.prototype,"acquireLocalVideo"),Kt([ki(0,Xa)],na.prototype,"turnOnLocalVideoPreviewUsingRenderer"),Kt([va("_UpdateLocalMediaStatus",{type:"Chained"}),ki(0,Xa)],na.prototype,"updateMediaStatus"),Kt([ki(0,Xa)],na.prototype,"calculateIsSomeoneStreaming"),Kt([va("_Reconnect")],na.prototype,"reconnect"),Kt([va("AddGroupModality"),ki(1,Xa)],na.prototype,"addGroupModality"),Kt([va("AddBroadcastModality")],na.prototype,"addBroadcastModality");var N7e=na;function bhi(n){const a=new TextDecoder("utf-8"),s=atob(n),c=Uint8Array.from(s,u=>u.charCodeAt(0));return a.decode(c)}var Thi=$i(Ni()),Chi=new RegExp("/callAgent/","i"),_hi=class{constructor(n,a){this.signalingAgentProvider=n,this.callRegistry=a}handleMessage(n){if(!n.eventId){if(n.url.search(Chi)>-1){const a=this.signalingAgentProvider.getSignalingAgent().handleIncomingNotification(n);return typeof a=="number"?{isHandled:!0,resultCode:a}:{isHandled:!0,resultCode:a.resultCode,responseBody:a.responseBody,responseHeaders:a.responseHeaders}}return{isHandled:!1}}if(n.eventId in Rve){this.callRegistry.logUploadNotification(n);const a=this.signalingAgentProvider.getSignalingAgent().handleIncomingNotification(n);return typeof a=="number"?{isHandled:!0,resultCode:a}:{isHandled:!0,resultCode:a.resultCode,responseBody:a.responseBody,responseHeaders:a.responseHeaders}}return{isHandled:!1}}},Ehi=class{constructor(n,a,s){this.callRegistry=n,this.recentInvitations=[],this.logger=a.createChild("IncomingCallMessageHandler"),this.ecsProvider=s}handleMessage(n){const a=this.handleIncomingCall(n);return a?{isHandled:a,resultCode:200}:{isHandled:a}}handleIncomingCall(n){const a=hi(),s=this.logger.createFnLogger("handleIncomingCall",a);if(this.isProxiableNotification(n))return this.callRegistry.proxyPushNotification(n),!0;if(!this.isIncomingCallMessage(n))return!1;let c;this.callRegistry.pushHandlingStarted(a);try{if(n?.body?.gp&&!tV(n.body.gp))s.info("unencoded payload, skipping decoding."),c=n.body.gp;else{const N=Lye(n,s);c=JSON.parse(N)}c.body=n.body}catch(N){return this.callRegistry.pushHandlingEnded(a,{result:"Failed to parse incoming call notification payload",code:er.BadRequest,subCode:3080,participantId:"",callId:"",resultCategories:["UnexpectedServerError"]}),s.logFailure(`Error parsing notification payload: ${N}`),!1}const u=this.isCallTransferNotification(n)?this.buildTransferCallPayload(c):this.buildNGCCallPayload(c);if(!u)return this.callRegistry.pushHandlingEnded(a,{result:"Failed to get incoming call notification payload",code:er.BadRequest,subCode:3081,participantId:"",callId:"",resultCategories:["UnexpectedClientError"]}),!1;if(this.callRegistry.calls.some(N=>N.callId===u.convoCallId&&N.participantId===u.participantId))return s.logFailure(`Duplicate call filtered because it was in the call registry, callId = ${u.convoCallId}, participantId = ${u.participantId}`),this.callRegistry.pushHandlingEnded(a,{result:"Failed due to duplicate call filtered because it was in the call registry",code:er.LocalError,subCode:3082,participantId:u?.participantId,callId:u?.convoCallId,resultCategories:["ExpectedError"]}),!1;const m=this.isCallReplacementNotification(n);if(s.log(`replacementCall=${m}`),!m&&this.recentInvitations.some(N=>N.convoCallId===u.convoCallId&&N.participantId===u.participantId))return s.logFailure(`Duplicate call filtered because it was in the recent calls list, callId = ${u.convoCallId}, participantId = ${u.participantId}`),this.callRegistry.pushHandlingEnded(a,{result:"Failed due to duplicate call filtered because it was in the recent calls list",code:er.LocalError,subCode:3083,participantId:u?.participantId,callId:u?.convoCallId,resultCategories:["ExpectedError"]}),!1;this.recentInvitations.length===5&&this.recentInvitations.shift(),this.recentInvitations.push({convoCallId:u.convoCallId,participantId:u.participantId});let b=this.callRegistry.calls.find(N=>N.callId===u.convoCallId&&N.state===8);if(!b)if(u.groupId)try{b=this.callRegistry.createCallWithGroupId(u.groupId,u.convoCallId,u.participantId,a)}catch{this.callRegistry.pushHandlingEnded(a,{result:"Failed to create incoming call notification with groupId",code:er.BadRequest,subCode:3084,participantId:u?.participantId,callId:u?.convoCallId,resultCategories:["UnexpectedClientError"]})}else try{b=this.callRegistry.createCall(u.conversationId,u.convoCallId,u.participantId,void 0,a)}catch{this.callRegistry.pushHandlingEnded(a,{result:"Failed to create incoming call notification",code:er.BadRequest,subCode:3084,participantId:u?.participantId,callId:u?.convoCallId,resultCategories:["UnexpectedClientError"]})}b.init({threadId:u.conversationId,messageId:u.messageId,mediaPeerType:2});const _=()=>{this.callRegistry.pushHandlingEnded(a,{code:ge.HTTP_STATUS_CODES.OK,subCode:er.Success,participantId:u?.participantId,callId:u?.convoCallId,resultCategories:["Success"]})},k=N=>{const W=b.callEndDiagnosticsInfo,ee=W?W.callControllerSubCode:3085+N.code;this.callRegistry.pushHandlingEnded(a,{result:"Failed to acknowledge incoming call notification",code:W?.callControllerCode||er.LocalError,subCode:ee,participantId:u?.participantId,callId:u?.convoCallId,resultCategories:W?.resultCategories||["UnexpectedClientError"]})};return this.callRegistry.testEndpointMetadata?b.acknowledge(u,this.callRegistry.testEndpointMetadata,a).then(_).catch(k):b.acknowledge(u,void 0,a).then(_).catch(k),!0}isIncomingCallMessage(n){return Object.keys(OD).some(a=>OD[a]===n.eventId)?n.eventId!==OD.INCOMING_TFL_TFW_CALL||this.ecsProvider?.getEcsConfig("SkypeCalling","enableTFWTFLOneToOneCall"):this.isCallTransferNotification(n)}isCallTransferNotification(n){return n.callNotification&&(n.callNotification.callType==="transfer"||n.callNotification.callType==="replaces")}isCallReplacementNotification(n){return n.callNotification&&n.callNotification.callType==="replaces"}isProxiableNotification(n){return Object.keys(ite).some(a=>ite[a]===n.eventId)}buildTransferCallPayload(n){const a={body:n.body,callerId:n.callNotification.from.id,displayNameSource:pte(n.callNotification.from.displayNameSource),groupId:null,conversationId:null,convoCallId:n.debugContent.callId,isMultiParty:n.conversationInvitation?.isMultiParty,fromMixer:n.callNotification.fromMixer,ngcCall:!0,participantId:n.callNotification.to.participantId,transferorId:n.callNotification.transferor&&n.callNotification.transferor.details&&n.callNotification.transferor.details.id,transferorType:n.callNotification.transferor&&n.callNotification.transferor.transferorType,transferorDisplayName:n.callNotification.transferor&&n.callNotification.transferor.details&&n.callNotification.transferor.details.displayName,callType:n.callNotification.callType,consultativeCallId:n.callNotification.consultativeCallId,messageId:null,callQueueInfo:n.callNotification.applicationContent,videoCall:void 0,launchTime:void 0,pushReceivedTime:void 0,registrationId:void 0,calleeAlternateId:n.callNotification.to?.calleeAlternateId};return this.logger.info("Incoming transfer paylod",CD(a,["callerId","transferorId"])),a}buildNGCCallPayload(n){if(!n.callNotification)return this.logger.error("Missing callNotification in parsed incoming NGC call payload"),null;const a={groupId:n.groupContext?.id,conversationId:n.groupChat?.threadId,messageId:n.groupChat?.messageId,callerId:n.callNotification.from.id,displayNameSource:pte(n.callNotification.from.displayNameSource),isMultiParty:n.conversationInvitation.isMultiParty,fromMixer:n.callNotification.fromMixer,convoCallId:n.debugContent.callId,participantId:n.debugContent.participantId,ngcCall:!0,body:n.body,transferorId:n.callNotification.transferor&&n.callNotification.transferor.details&&n.callNotification.transferor.details.id,transferorType:n.callNotification.transferor&&n.callNotification.transferor.transferorType,transferorDisplayName:n.callNotification.transferor&&n.callNotification.transferor.details&&n.callNotification.transferor.details.displayName,callType:n.callNotification.callType,callQueueInfo:n.callNotification.applicationContent,videoCall:void 0,launchTime:void 0,pushReceivedTime:void 0,registrationId:void 0,fromApplicationType:n.callNotification.fromApplicationType,calleeAlternateId:n.callNotification.to?.calleeAlternateId,routingTimeout:n.callNotification.routingTimeout};return this.logger.info("Incoming NGC paylod",CD(a,["callerId","transferorId"])),a}},oie=class extends Qs{constructor(n,a,s,c,u,m=null,b,_,k){super(),this.trouterService=n,this.signalingAgentProvider=a,this.mediaAgent=s,this.callingLogger=c,this.telemetryLoggers=u,this.ecsProvider=m,this.skypeIdentity=b,this.oneDsTelemetryLoggers=_,this.vdi3diagnostics=k,this.calls=[],this.isDisposing=!1,this._disposedPromise=new Pi,this.testEndpointMetadata=null,this._disconnectingPromiseDefers=new Map,this.skypeIdentity&&(this.identity=this.skypeIdentity.id),this.callSubscriptionsMap=new Map,this.logger=new aN(this.callingLogger).createChild(`CallRegistry/${hi()}`),this.registryTelemetry=new PG(this.logger,new Date().getTime()),this._callOperationHandler||(this._callOperationHandler=new bV(this.logger,this.registryTelemetry,{},W=>{this._publishTelemetry(W)}));const N=this.mediaAgent.getConfig().disconnectOnPageHide;this._windowUninitEvent=N?"pagehide":"beforeunload",this.signalingAgentProvider.getSignalingAgent().setTokenRequiredCallBack(this.onTokenRequired.bind(this)),this._createNewCallInDisconnectedState=this.ecsProvider.getEcsConfig("SkypeCalling","createNewCallInDisconnectedState"),this._invokeDeleteCallInDisconnectedState=this.ecsProvider.getEcsConfig("SkypeCalling","invokeDeleteCallInDisconnectedState")}init(n,a,s=hi()){return this.logger.createFnLogger("init",s).info("init"),this.login(n)}uninit(){return this.logout()}login(n,a=hi()){return this.logger.createFnLogger("login",a).info("login"),this.skypeIdentity=n,this.identity=this.skypeIdentity.id,this.initialize(a)}initialize(n=hi(),a){const s=this.logger.createFnLogger("initialize",n),c=a&&a.applicationType?a.applicationType:"null";s.info(`initialize with applicationType: ${c}`),this.accountConfiguration=a,this.accountConfiguration&&this.event("accountConfigurationReceived").raise(this.accountConfiguration),this.signalingAgentProvider.getSignalingAgent().update(a),this.incomingCallMessageHandler=new Ehi(this,this.logger,this.ecsProvider),this.trouterService.registerMessageHandler(new _hi(this.signalingAgentProvider,this)),this.trouterService.registerMessageHandler(this.incomingCallMessageHandler),s.info("Call registry init, endpointMetadata",this.testEndpointMetadata);try{this.windowUninitListener=()=>{this._disregardWindowUninitEvents||this.stopCallsWithBeacon()},window.addEventListener(this._windowUninitEvent,this.windowUninitListener)}catch(u){s.logFailure(`Not adding beforeunload listener: ${u}`)}return Promise.resolve(void 0)}logout(n=hi()){const a=this.logger.createFnLogger("logout",n);a.info("logout");try{this.trouterService.clearMessageHandlers(),window.removeEventListener(this._windowUninitEvent,this.windowUninitListener)}catch(s){a.info(`Not removing beforeunload listener: ${s}`)}return Promise.resolve(void 0)}_publishTelemetry(n){if(!this.telemetryLoggers?.signaling)return;this.registryTelemetry.setSkypeId(this.identity);try{const s=this.signalingAgentProvider.getSignalingAgent();this.registryTelemetry.setEndpointId(s.endpointId)}catch{this.logger.warn("Could not get end point ID from signaling agent for call registry telemetry.")}this.accountConfiguration&&(this.registryTelemetry.setAcsResourceId(this.accountConfiguration.acsResourceId),this.registryTelemetry.setApplicationType(this.accountConfiguration.applicationType),this.registryTelemetry.setPartition(this.accountConfiguration.partition),this.registryTelemetry.setRegion(this.accountConfiguration.region),this.registryTelemetry.setRing(this.accountConfiguration.ring),this.registryTelemetry.setTenantId(this.accountConfiguration.tenantId),this.registryTelemetry.setUserHexCID(this.accountConfiguration.userHexCID),this.registryTelemetry.setClientType(this.accountConfiguration.clientType));const a=vN.REGISTRY_WEB;this.telemetryLoggers.signaling.sendEvent({eventName:a,props:this.registryTelemetry.getEvent(null,n)})}async dispose(n=hi()){const a=this.logger.createFnLogger("dispose",n);if(a.info("dispose"),this.isDisposing)return a.warn("call registry is already in disposing stage!"),this._disposedPromise.promise;this.isDisposing=!0;const s=()=>{this.calls=[],this.event("disposed").raise(),super.dispose(),this._disposedPromise.resolve()},c=this.calls.map(m=>m.stop()),u=()=>this.logout();return this.clearCallSubscription(),this.signalingAgentProvider.getSignalingAgent().resetAuthTokenManager(),Promise.all(c).then(u,u).then(s,s),this._disposedPromise.promise}get disposePromise(){return this._disposedPromise.promise}createCallAsync(n){const a=this.logger.createFnLogger("createCallAsync",n.causeId),s=`callId:${n.callId}, localParticipantId: ${kn(n.localParticipantId)},
            causeId:${n.causeId}, type:${n.type}, `;switch(n.type){case"MeetingData":s.concat(`meetingUrl:${!!n.meetingData?.meetingUrl}, meetingCode:${!!n.meetingData?.meetingCode}`);break;case"GroupId":s.concat(`groupId:${kn(n.groupId)}`);break;case"ThreadId":s.concat(`threadId:${Qu(n.threadId)}, messageId:${n.messageId}`);break;default:throw new Error("Invalid type in passing parameter.")}a.info(s);const c=this.mediaAgent?.getConfig().useOneDsLogger?this.oneDsTelemetryLoggers:this.telemetryLoggers,u=this._getCurrentCall(n,a);if(u){if(u.state===6){const m=new Pi;return this._disconnectingPromiseDefers.set(u.callId,m),m.promise}return Promise.resolve(u)}return Promise.resolve(this._createNewCall(n,c,a))}createCallWithMeetingData(n,a,s,c){const u=this.logger.createFnLogger("createCallWithMeetingData",c);if(u.info(`meetingData:${!!n}, callId:${a}, localParticipantId: ${kn(s)}`),!n)return u.info("meetingData cannot be null"),null;const m=this._generateCreateCallOptions(c,a,s,null,null,null,n),b=this._getCurrentCall(m,u);if(b)return b;const _=this.mediaAgent?.getConfig().useOneDsLogger?this.oneDsTelemetryLoggers:this.telemetryLoggers;return this._createNewCall(m,_,u)}createCall(n,a,s,c,u=hi()){return this._createCall(n,a,s,c,u)}createCallWithGroupId(n,a,s,c){return this._createCall("",a,s,void 0,c,n)}_createNewCall(n,a,s){let c=null,u=null,m=null,b=null;switch(n.type){case"MeetingData":b=n.meetingData;break;case"GroupId":c=n.groupId;break;case"ThreadId":u=n.threadId,m=n.messageId}const _=new N7e(this.signalingAgentProvider.getSignalingAgent(),this.mediaAgent,new aN(this.callingLogger),a,this.skypeIdentity,c,u,n.callId,n.localParticipantId,this.ecsProvider,this.trouterService,this.accountConfiguration,m,this.locationInfoContent,this.networkInfoContent,b,this.areaContent,this.vdi3diagnostics);_.on("callStateChanged",async()=>{if(_.state===7&&this._createNewCallInDisconnectedState){const N=this._disconnectingPromiseDefers.get(_.callId);N&&(this._disconnectingPromiseDefers.delete(_.callId),N.resolve(this._createNewCall(n,a,s))),this._invokeDeleteCallInDisconnectedState&&setTimeout(()=>{this.deleteCall(_)},0)}}),this.calls.push(_),this.event("callAdded").raise(_),this.raiseChanged(),s.info(`Created new call with id ${_.callId}`);const k=_.on("replacementRequested",N=>{this.incomingCallMessageHandler.handleMessage(N)});return this.addCallSubscriptionToMap(_,k),_}_getCurrentCall(n,a){let s=null;return n.type==="MeetingData"&&(s=this.getCallUsingMeetingData(n.meetingData,n.callId,n.localParticipantId,void 0,void 0,n.causeId),s)?(a.info("Call Registry has an entry for this call's meeting data"),s):(s=this.getCall(n.callId,n.localParticipantId,n.causeId),s?(a.info("Call Registry has an entry for this callId, participantId"),s):n.type==="ThreadId"&&(s=this.getCallUsingThreadIdMessageId(n.threadId,n.callId,n.messageId,n.causeId),s)?(a.info("Call Registry has an entry for this threadId, messageId"),s):(n.type==="GroupId"&&(s=this.calls.find(c=>c.groupId===n.groupId),s)&&a.info("Call Registry has an entry for this groupId"),s))}_generateCreateCallOptions(n,a,s,c,u,m,b){let _=null;return _=c?{type:"GroupId",callId:a,localParticipantId:s,causeId:n,groupId:c}:u?{type:"ThreadId",callId:a,localParticipantId:s,causeId:n,threadId:u,messageId:m}:{type:"MeetingData",callId:a,localParticipantId:s,causeId:n,meetingData:b},_}_createCall(n,a,s,c,u=hi(),m){const b=this.logger.createFnLogger("createCall",u);b.info(`threadId:${Qu(n)}, callId:${a}, localParticipantId: ${kn(s)}, messageId:${c}, groupId:${kn(m)}`);const _=this._generateCreateCallOptions(u,a,s,m,n,c,null),k=this._getCurrentCall(_,b);if(k)return k;const N=this.mediaAgent?.getConfig().useOneDsLogger?this.oneDsTelemetryLoggers:this.telemetryLoggers;return this._createNewCall(_,N,b)}getCall(n,a,s=hi()){const c=this.logger.createFnLogger(`getCall[callId=${n}][participantId=${kn(a)}]`,s);if(!n)return c.logFailure("callId is undefined"),null;const u=this.calls.find(m=>m.callId===n);return u&&c.info("Call Registry already has an entry for this call"),u}async deleteCallAsync(n){return Bt(()=>this.deleteCall(n))}deleteCall(n){const a=this.calls.indexOf(n);return a!==-1&&(this.callSubscriptionsMap.get(n).forEach(s=>{s.dispose()}),this.callSubscriptionsMap.delete(n),this.calls.splice(a,1),this.event("callRemoved").raise(n),this.raiseChanged(),!0)}async setConfiguration(n){this.accountConfiguration=n,this.accountConfiguration&&this.event("accountConfigurationReceived").raise(this.accountConfiguration),this.signalingAgentProvider.getSignalingAgent().update(n)}updateDisplayName(n){return this.skypeIdentity.displayName=n,this.calls.forEach(a=>{a.updateDisplayName(n)}),Promise.resolve()}fireIntent(n,a){return Promise.resolve()}getCallState(n,a){return Promise.reject("Not implemented")}getSetup(){}getEcsConfig(){return Promise.reject()}updateSkypeToken(n){this.logger.debug("CallRegistry.updateSkypeToken() called but not supported in the current set up.")}updateToken(n,a,s,c,u){this.logger.info(`[updateToken], causeId = ${c} tokenType = ${a.tokenType}, factorsJson = ${n}, tokenExpiredTime = ${u}`);try{return this.signalingAgentProvider.getSignalingAgent().updateToken(n,a,s,c,u),Promise.resolve(Zee())}catch(m){return this.logger.info(`Failed to update token with ${n}, error is ${m}`),Promise.reject(Mu(`Failed to update token with ${n}, error is ${m}`))}}onTokenRequired(n){const{requestMetadataJson:a,factorsJson:s,tokenType:c,invalidToken:u}=n;this.logger.info(`[onTokenRequired], tokenType ${c}, factorsJson ${s}, requestMetadataJson ${JSON.stringify(a)}`),this.event("tokenRequired").raise(s,c,a,u)}pushHandlingStarted(n){this.logger.info(`handleIncomingCallStarted, causeId=${n}`),this.event("pushHandlingStarted").raise(n)}pushHandlingEnded(n,a){this.logger.info(`pushHandlingEnded, causeId=${n}`),this.event("pushHandlingEnded").raise(n,a)}debugInformation(n){const a=n?`CallInformation
 * CallId=${n.callId}`:void 0;return Promise.resolve(a)}setLocationInfo(n,a,s=hi()){if(this.logger.info(`setLocationInfo, ${s}, infoType:${n}, contentJson ${a?"is set":"is undefined"}`),a)try{JSON.parse(a)}catch(c){return Promise.reject(`invalid contentJson: ${c}`)}return this.locationInfoType=n,this.locationInfoType===1&&(this.locationInfoContent=a,this.logger.info(`locationInfoContent set to ${this.locationInfoContent}`)),this.locationInfoType===2&&(this.networkInfoContent=a,this.logger.info(`networkInfoContent set to ${this.networkInfoContent}`)),this.locationInfoType===3&&(this.areaContent=a,this.logger.info(`areaContent set to ${this.areaContent}`)),this.event("locationInfoSet").raise(n,a),Promise.resolve()}createDownloader(){return null}async getUnassembledLocalRecordingSessions(n=hi()){return Promise.reject("Not implemented")}submitBrbReport(n,a){return Promise.reject("Not implemented")}extendBrbFeedback(n,a){return Promise.reject("Not implemented")}proxyPushNotification(n){this.logger.info(`Proxying push notification with event ID ${n.eventId}`);try{const a={eventId:n.eventId,payload:Lye(n,this.logger)};this.event("proxiedPushNotification").raise(a)}catch(a){this.logger.error(`Error proxying push notification: ${a}`)}}logUploadNotification(n){this.logger.info(`Log upload notification with event ID ${n.eventId}`);try{const a={eventId:n.eventId,payload:Lye(n,this.logger)};this.event("logUploadNotification").raise(a)}catch(a){this.logger.error(`Error raising log upload notification: ${a}`)}}sendPush(n,a,s,c){const u={id:n},m=[];return a.forEach(b=>{m.push({id:b})}),this.signalingAgentProvider.getSignalingAgent().sendPushAsync(u,m,s,c)}enableWindowUninitEventHandler(){this._disregardWindowUninitEvents=!1}disableWindowUninitEventHandler(){this._disregardWindowUninitEvents=!0}async enableWindowUninitEventHandlerAsync(){this.enableWindowUninitEventHandler()}async disableWindowUninitEventHandlerAsync(){this.disableWindowUninitEventHandler()}getCallUsingThreadIdMessageId(n,a,s,c){this.logger.info(`[getCallUsingThreadIdMessageId][${c}] threadID: ${Qu(n)} callId: ${a} messageId: ${s}`);let u=null;return n&&(u=this.calls.find(m=>m.threadId===n&&(a&&m.callId===a||s!=null&&m.messageId===s)),u)&&this.logger.logFailure(`[getCallUsingThreadIdMessageId][${c}]Call Registry already has an entry for threadId: ${Qu(u.threadId)}, callId: ${u.callId}, messageId: ${u.messageId}`),u}getCallUsingMeetingData(n,a,s,c,u,m=hi()){const b=this.logger.createFnLogger("getCallUsingMeetingData",m);if(b.info(`[callId=${a}][participantId=${kn(s)}] meetingData: ${!!n} 
            threadId: ${Qu(c)} messageId: ${u}`),!a)return b.logFailure("callId is undefined"),null;let _;for(const k of this.calls){if(k.callId===a){_=k;break}if(k2(k.meetingData,n,m,this.logger)){_=k;break}}return _}stopCallsWithBeacon(){for(const n of this.calls)n.stopWithBeacon()}addCallSubscriptionToMap(n,a){this.callSubscriptionsMap.set(n,(this.callSubscriptionsMap.get(n)||[]).concat(a))}clearCallSubscription(){this.callSubscriptionsMap.forEach(n=>{n.forEach(a=>{a.dispose()})}),this.callSubscriptionsMap.clear()}};function Lye(n,a){const s=a.createFnLogger("decodeNotificationPayload");let c="{}";if(n?.body?.gp)s.info("using notification.body.gp"),c=bhi(n.body.gp);else if(n?.body?.cp){s.info("using notification.body.cp");const u=atob(n.body.cp);c=Thi.inflate(u,{to:"string"})}return c}Kt([va("Initialize",{enableInstantTelemetry:!0})],oie.prototype,"initialize"),Kt([va("Logout",{enableInstantTelemetry:!0})],oie.prototype,"logout");var x7e=dn,Ahi=class{constructor(n){this.deviceManager=n}get childDeviceManagers(){return this.deviceManager.getRegisteredDevices()}createPreview(n,a){return this.executeOnVirtualDeviceManager(s=>n(s,"Video"),a)}getRawDeviceMediaStream(n,a,s){return this.executeOnVirtualDeviceManager(c=>c.getRawDeviceMediaStream(n,a),s)}setDeviceEffectsAsync(n,a){return this.executeOnVirtualDeviceManager(s=>s.setVideoEffects(a),n)}setRawMediaStream(n,a,s){this.executeOnVirtualDeviceManager(c=>c.setRawMediaStream(n,a),s)}unsetRawMediaStream(n,a){this.executeOnVirtualDeviceManager(s=>s.unsetRawMediaStream(n),a)}getVirtualDevice(n){return this.childDeviceManagers.find(a=>a.id===n)}executeOnVirtualDeviceManager(n,a){return this.getVirtualDevice(a).getDeviceManagers().map(s=>n(s))}},Ihi="default_output_device",B7e=class ICe extends Qs{constructor(a){super(),this._deviceManager=a,this.virtualDeviceAdapter=new Ahi(this._deviceManager),a.on("onDevicesChanged",s=>{const c=this._deviceManager.getDeviceDescriptions(s),u=this._mapDevices(c);this._raiseDevicesChanged(u)}),a.on("onSelectedDevicesChanged",s=>this._raiseDevicesChanged()),a.on("onPermissionStateChanged",()=>this.event("onPermissionStateChanged").raise()),a.on("onVideoEffectsEvent",(s,c)=>this.event("videoEffectsEvent").raise(s,c)),a.on("onVideoEffectApplied",()=>this.event("videoEffectApplied").raise()),a.on("onEffectsError",(s,c,u)=>this.event("onEffectsError").raise(Y8e(s),c,u))}get isAudioOutputSelectionSupported(){return this._deviceManager.isAudioOutputSelectionSupported}getPermissionState(a){return a==="camera"?this.getPermissionStateHelper(this._deviceManager.getPermissionState("camera")):a==="microphone"?this.getPermissionStateHelper(this._deviceManager.getPermissionState("microphone")):"unknown"}async getPermissionStateAsync(a){return this.getPermissionState(a)}askDevicePermission(a){return this._deviceManager.askDevicePermission?this._deviceManager.askDevicePermission(a):Promise.resolve({audio:!0,video:!0})}enumerateDevicesAsync(){return this._deviceManager.enumerateDevicesAsync().then(a=>this._mapDevices(a))}getPreferredCamera(){throw new Error("Not implemented")}selectDevices(a){if(Object.keys(a).some(c=>this.isVirtualDevice(c)))throw new Error("Virtual Device selection on DM is not supported");const s=(0,x7e.assign)({},this._deviceManager.getSelectedDevices(),a);this._deviceManager.selectDevices(s)}selectDevicesAsync(a){return Bt(()=>this.selectDevices(a))}getSelectedDevices(){return this._deviceManager.getSelectedDevices()}getSelectedDevicesAsync(){return Bt(()=>this.getSelectedDevices())}getDeviceNameAsync(a){return this._deviceManager.getDeviceNameAsync(a)}getSpeakerDeviceDomIdAsync(a,s){return this._deviceManager.getSpeakerDeviceDomIdAsync(a)}mapBrowserDevices(a,s){return Promise.reject(new Error("Not implemented"))}async setDeviceEffectsAsync(a,s){if(!this.isVirtualDevice(a))return this._deviceManager.setVideoEffects(s);Promise.all(this.virtualDeviceAdapter.setDeviceEffectsAsync(a,s))}getDeviceEffectsCapabilityAsync(a,s){return this._deviceManager.effectsManager.getEffectsCapability("Video")}setBackgroundImageAsync(a,s,c){return this._deviceManager.effectsManager.configure("Video",{imagePath:s,headers:c})}getImagePropertyAsync(a){return Promise.reject(new Error("Not implemented"))}getMicrophoneGeometryArrayInfoAsync(a){return Promise.reject(new Error("Not implemented"))}transformImageAsync(a,s,c,u){return Promise.reject(new Error("Not implemented"))}setAudioProcessingFlags(a){return this._deviceManager.setAudioProcessingFlags(a)}async sendMessageDeviceVideoEffectsAsync(a,s){return await this._deviceManager.sendMessageDeviceVideoEffectsAsync(a,s)}sendMessageDeviceVideoExtensibilityAsync(a,s){return Promise.reject(new Error("Not implemented"))}setVideoCaptureConfigAsync(a,s){return Promise.reject(new Error("Not implemented"))}captureVideoFrameWithoutEffectsAsync(a,s,c){return Promise.reject(new Error("Not implemented"))}enableSignLanguageDetectionAsync(a,s){return Promise.reject(new Error("Not implemented"))}downloadAiModel(a,s){return Promise.reject(new Error("Not implemented"))}getSpeakerVolume(){return Promise.reject(new Error("Not implemented"))}getSpeakerSystemVolume(){return Promise.reject(new Error("Not implemented"))}setSpeakerVolume(a){return Promise.reject(new Error("Not implemented"))}setSpeakerSystemVolume(a){return Promise.reject(new Error("Not implemented"))}unmuteMicrophone(){return Promise.reject(new Error("Not implemented"))}unmuteSpeaker(){return Promise.reject(new Error("Not implemented"))}getNrgLevelsForDeviceTuner(a){return Promise.reject(new Error("Not implemented"))}async getNrgLevelPollerForDeviceTuner(a){return await this._deviceManager.getNrgLevelPollerForDeviceTuner()}setAudioEffectsAsync(a,s){return this._deviceManager.setAudioEffects(s)}getAudioFeatureCapability(a){return this._deviceManager.effectsManager.getEffectsCapability("Audio")}getAudioFeatureProviderName(){return Promise.resolve(this._deviceManager.effectsManager.getAudioEffectsProviderName())}getMicrophoneVolume(){return Promise.reject(new Error("Not implemented"))}setMicrophoneVolume(a){return Promise.reject(new Error("Not implemented"))}setDeviceTelemetryData(a,s,c,u=0){return Promise.reject(new Error("Not implemented"))}getSourceFormats(a){return Promise.reject(new Error("Not implemented"))}enableShellSharing(){return Promise.reject(new Error("Not implemented"))}disableShellSharing(){return Promise.reject(new Error("Not implemeted"))}enableParticipantCameras(){return Promise.reject(new Error("Not implemeted"))}registerDerivedSource(a,s){return Promise.reject(new Error("Not implemeted"))}unregisterDerivedSource(a){return Promise.reject(new Error("Not implemeted"))}startPreview(a,s,c){const u=new Idi,m=(async()=>{if(s.kind==="camera"&&this.isVirtualDevice(s.device))return this.virtualDeviceAdapter.createPreview(this.startRenderer.bind(this,u,a,c),s.device)[0];if(s.kind==="sharing")return this.startRenderer(u,a,c,this._deviceManager,"ScreenShare");if(s.kind!=="camera"||!(0,x7e.isUndefined)(s.device))throw new Error("Not yet supported");return this.startRenderer(u,a,c,this._deviceManager,"Video")})();return{instance:u,promise:m}}async createPreview(a,s,c){const{instance:u,promise:m}=this.startPreview(a,s,c);return await m,u}async createPreviewRenderer(a,s){return this.createPreview(a,{kind:"camera"},s)}async createScreenSharingPreviewRenderer(a,s){return this.createPreview(a,{kind:"sharing"},s)}getRawDeviceMediaStream(a,s,c){const u=NV(a);return this.isVirtualDevice(c)?this.virtualDeviceAdapter.getRawDeviceMediaStream(u,s,c)[0]:this._deviceManager.getRawDeviceMediaStream(u,s)}setRawMediaStream(a,s,c){const u=NV(s);return this.isVirtualDevice(c)?this.virtualDeviceAdapter.setRawMediaStream(a,u,c):this._deviceManager.setRawMediaStream(a,u)}unsetRawMediaStream(a,s){const c=NV(a);return this.isVirtualDevice(s)?this.virtualDeviceAdapter.unsetRawMediaStream(c,s):this._deviceManager.unsetRawMediaStream(c)}createAudioRenderer(){return this._deviceManager.createAudioRenderer()}startAudioLoopbackDevice(a){return Promise.reject(new Error("Not implemented"))}async dispose(a){return this._deviceManager.dispose(a)}async registerCompositeVideoDevice(a,s,c){return this._deviceManager.registerVirtualDevice(a,s,c)}async unregisterCompositeVideoDevice(a){return this._deviceManager.unregisterVirtualDevice(a)}async createAudioPlayer(){return Promise.reject(new Error("Not implemented"))}_raiseDevicesChanged(a){(a?Promise.resolve(a):this.enumerateDevicesAsync()).then(s=>{this.raiseChanged(),this.event("devicesChanged").raise(s)})}getPermissionStateHelper(a){switch(a){case"granted":return"granted";case"denied":return"denied";case"prompt":return"prompt";default:return"unknown"}}_mapDevices(a){return a?.map(s=>this._mapDeviceDesc(s))}_mapDeviceDesc(a){const s=ICe._mapDeviceType(a.kind);return s===6?{id:a.id,label:a.label,kind:s,position:0,defaultVideoId:a.id,devicesIds:[]}:s===1?{id:a.id,browserId:a.browserId,label:a.label,kind:s,position:ICe._mapCameraPosition(a.position)}:s===4?{id:null,browserId:null,label:a.label,kind:s,formFactor:a.formFactor,isPcInternalDevice:a.isPcInternalDevice,microphoneId:a.microphoneId,speakerId:a.speakerId}:{id:a.id,browserId:a.browserId===Ihi?"default":a.browserId,label:a.label,kind:s,isSystemDefault:!!a.isSystemDefault}}static _mapDeviceType(a){switch(a){case"camera":return 1;case"microphone":return 2;case"speaker":return 3;case"compositeAudio":return 4;case"virtualDevice":return 6;default:throw new Error(`Invalid device type '${a}'`)}}static _mapCameraPosition(a){switch(a){case"front":return 1;case"back":return 2;case"external":return 3;default:return 0}}isVirtualDevice(a){return a&&this._deviceManager.getRegisteredDevices().some(s=>s.id===a)}async startRenderer(a,s,c,u,m){try{a.initialize(s,u,m),await a.startVideoAsync(),c&&(a.setScalingMode(c.scalingMode),a.setVideoMirroring(!c.ignoreMirroring))}catch(b){throw a.dispose(),b}}},Oye=Hv,H2=Hv,whi=class extends H2.AbstractLogAppender{constructor(n){super(new H2.StandardLogFormatter(H2.SLF_Flags.Component)),this._logger=n}log(n,a,s,c){if(!this._logger)return;const u=n.level<=H2.LogLevel.Debug4?this._logger.debug:n.level<=H2.LogLevel.Debug2?this._logger.log:n.level<=H2.LogLevel.Debug1?this._logger.info:n.level<=H2.LogLevel.Warning?this._logger.warn:this._logger.error;u&&u.apply(this._logger,[this.formatter().format(n,a,s,c)])}},khi=Hv,Rhi=$i(Dr()),F7e=["CorrelationId","agent_environment_id","UserInfo_TenantId","participant_id","endpoint_id","mediaLegId","metrics_ConfigIds","ts_calling_version","uiVersion"],U7e={video:[...F7e,"Extensions_WebRTCStats_ssrc_video_recv_framesDecoded","Extensions_WebRTCStats_ssrc_video_recv_packetsReceived","Extensions_WebRTCStats_ssrc_video_recv_ssrc","Extensions_WebRTCStats_ssrc_video_recv_bytesReceived","Extensions_WebRTCStats_ssrc_video_recv_googFrameRateDecoded","Extensions_Video_SubscriptionEvents","Extensions_Video_recv_ResolutionDurations","Extensions_Video_recv_StreamsMax","Extensions_Video_recv_frameRateAvg","Extensions_Video_recv_DurationSeconds","Extensions_Video_recv_FreezeHistogram","Extensions_Video_recv_FreezeTimestamps","Extensions_WebRTCStats_ssrc_video_recv_keyFramesDecoded","Extensions_Video_recv_TotalFreezeDurationMs","Extensions_Video_recv_packetsLostRateMax","metrics_ReconnectAttempts","metrics_ReconnectConnectedCount","metrics_RetargetCompletedCount","metrics_UFDs","Payload"],sharing:[...F7e,"Extensions_WebRTCStats_ssrc_sharing_recv_framesDecoded","Extensions_WebRTCStats_ssrc_sharing_recv_packetsReceived","Extensions_WebRTCStats_ssrc_sharing_recv_ssrc","Extensions_WebRTCStats_ssrc_sharing_recv_bytesReceived","Extensions_WebRTCStats_ssrc_sharing_recv_googFrameRateDecoded","Extensions_WebRTCStats_ssrc_sharing_recv_keyFramesDecoded","Extensions_Sharing_SubscriptionEvents","Extensions_Sharing_recv_ResolutionDurations","Extensions_Sharing_recv_StreamsMax","Extensions_Sharing_recv_frameRateAvg","Extensions_Sharing_recv_DurationSeconds","Extensions_Sharing_recv_FreezeHistogram","Extensions_Sharing_recv_FreezeTimestamps","Extensions_Sharing_recv_TotalFreezeDurationMs","Extensions_Sharing_recv_packetsLostRateMax","metrics_ReconnectAttempts","metrics_ReconnectConnectedCount","metrics_RetargetCompletedCount","metrics_UFDs","Payload"]},Mhi=class extends Qs{constructor(){super(...arguments),this.stabilizationTimeInAvg=2e4}send(n){n&&setTimeout(()=>{this.event("sendMidCallTelemetry").raise(U7e[n])},this.stabilizationTimeInAvg)}},Phi=class extends Qs{constructor(n,a){super(),this._telemetryService=n,this._ecsProvider=a,this._ecsProvider.on("OnECSChanged",()=>khi.RootToolsManager.OnEcsChange())}fetchEcsConfig(n,a){return Rhi.Resolved().then(()=>this._ecsProvider.getEcsConfig(n,a))}sendTelemetry(n,a){this._telemetryService.getGenericTelemetryLogger&&n?this._telemetryService.getGenericTelemetryLogger(n).sendEvent({eventName:"rt_log",props:a}):this._telemetryService.sendEvents([{eventName:"rt_log",props:a}])}sendMidCallTelemetry(n){Object.keys(U7e).includes(n)&&this.event("onMidCallTelemetry").raise(n)}};function Dhi(n,a,s){if(!Oye.RootToolsManager.isDelegateSet()){const c=new Phi(n.telemetryService,a);if(Oye.RootToolsManager.setDelegate(c),c.on("onMidCallTelemetry",u=>s.send(u)),n.logger){const u=new whi(n.logger);Oye.LogFactory.instance().addAppender(u)}}n.logger=new Lg("JS.TsCalling.Pluginless",!0),n.mediaAgentFactoryConfig.logger=new Lg("JS.TsCalling.MediaAgentUnsafe",!1),n.mediaAgentFactoryConfig.safeLogger=new Lg("JS.TsCalling.MediaAgent",!0),n.signalingAgentConfig.logger=new Lg("JS.TsCalling.SignalingAgent",!0)}var Lhi=dn,Ohi=class wCe{constructor(a){this._prefix=a,this._children=[],this._useConsoleLogger=!1,this.createChild=(s,c)=>{const u=typeof s=="function"?"":s,m=new wCe((this._prefix||"")+u);return this._children.push(m),this._useConsoleLogger&&m.useConsoleLogger(),m},this.createFnLogger=(s,c,...u)=>{const m=`[${c}][${s}]`,b=new wCe((this._prefix||"")+m);return this._children.push(b),this._useConsoleLogger&&b.useConsoleLogger(),b}}logInfo(){}logFailure(){}logSuccess(){}log(...a){}debug(...a){}info(...a){}warn(...a){}error(...a){}useConsoleLogger(){this._useConsoleLogger=!0;const a=(...s)=>{console.info(this._prefix||"",...s)};this.log=a,this.debug=a,this.info=a,this.warn=a,this.error=a,(0,Lhi.each)(this._children,s=>s.useConsoleLogger())}},Nhi=class{constructor(n){this.configProvider=n,this.window=Cc.window,this.updateCapabilityOverrides(),this.configProviderSub=n.on("configUpdated",()=>this.updateCapabilityOverrides())}get audio(){return this.getCapability("audio")}get video(){return this.getCapability("video")}get screensharing(){return this.getCapability("screensharing")}get retargeting(){return this.getCapability("retargeting")}dispose(){this.configProviderSub&&this.configProviderSub.dispose()}updateCapabilityOverrides(){let n;this.configProvider.config.capabilities&&(n=this.configProvider.config.capabilities),this.overrides=n||{}}hasMediaCapture(){return!!this.window.navigator.getUserMedia}getCapability(n){return this.overrides[n]!==void 0?!!this.overrides[n]:this.hasMediaCapture()&&this.hasWebRtc()}hasWebRtc(){return this.window.RTCPeerConnection!==void 0}},Nye=class Iae extends jr{constructor(a,s,c){super(a),this.logger=a,this.configProvider=s,this.diagnostics=c,this.eventStates=new Map,this.debounceMap=new Map,this.logger.safe.info("Initialized")}signalEvent(a,s,c="Audio",u=!0,m=hi(),b,_){const k={type:a,value:s,isLocalSource:u,mediaType:c,deviceManagerId:b,diagnosticData:_};this.shouldRaiseEvent(k)&&this.diagnostics.registerQualityChangedEvent(k);const N=bw(k),W=this.eventStates.get(N);if(this.configProvider.config.localUFDDebounceTime&&W){clearTimeout(this.debounceMap.get(N));const ee=setTimeout(this.raiseEvent.bind(this),this.configProvider.config.localUFDDebounceTime,k,m);this.debounceMap.set(N,ee)}else this.raiseEvent(k,m)}raiseEvent(a,s){const c=bw(a);this.shouldRaiseEvent(a)&&(this.eventStates.set(c,a),this.logger.safe.info(`[${s}] Raising UFD ${a.type} for ${a.mediaType}: ${a.value}`),this.event("onQualityChanged").raise(a))}signalDeviceEvent(a,s,c,u){const m=Iae.getQualityEventType(a,c,this.configProvider);m?this.signalEvent(m,s,c,void 0,hi(),u):this.logger.warn(`Unknown device quality event type: ${a}`)}raisePendingWhitelistingUFD(){this.lastWhitelistingUFD&&(this.logger.safe.debug(`Raising whitelisting UFD ${this.lastWhitelistingUFD.type}: ${this.lastWhitelistingUFD.value}`),this.event("onQualityChanged").raise(this.lastWhitelistingUFD),this.cancelPendingWhitelistingUFD())}cancelPendingWhitelistingUFD(){if(this.lastWhitelistingUFD){const a=bw(this.lastWhitelistingUFD);this.eventStates.delete(a)}this.lastWhitelistingUFD=void 0}applyCurrentState(a){this.cancelPendingWhitelistingUFD();let s=0;for(const c of this.eventStates.values())c.value!=="Good"&&(a(c),s++);s>0&&this.logger.safe.info(`Applied ${s} UFDs`)}reset(){this.logger.safe.info("Resetting UFD states");for(const[a,s]of this.eventStates.entries())Iae.persistent.has(s.type)||this.eventStates.delete(a);this.lastWhitelistingUFD=void 0}shouldRaiseEvent(a){const s=bw(a),c=this.eventStates.get(s);return c&&c.value===a.value?!(!this.configProvider.config.alwaysRaiseBadDeviceEvents||!Iae.deviceQualityEvents.has(a.type)||a.value==="Good"):!(!c&&a.value==="Good"||(a.type==="NetworkRelaysNotReachable"?(this.lastWhitelistingUFD=a,1):a.type==="NetworkRecvQuality"&&!this.configProvider.config.webrtcStatNetworkDetectionEnabled))}static getQualityEventType(a,s,c){switch(a){case 0:return s==="Audio"?"DeviceCaptureNotFunctioning":"VideoCapturerDeviceStartFailed";case 1:return"DeviceRenderNotFunctioning";case 2:return s==="Audio"?"DeviceCaptureNotFunctioning":"VideoCapturerDeviceStartTimedOut";case 3:return"DeviceCaptureMute";case 4:switch(s){case"ScreenShare":return"ScreenshareRecordingDisabled";case"Audio":return c.config.enableSignalingAudioPermissionDeniedUFD?"AudioCapturePermissionDenied":"DeviceCaptureNotMuteButSilent";case"Video":return"VideoCapturePermissionDenied";default:return}default:return}}};Nye.persistent=new Set(["ZeroCaptureDevicesEnumerated","ZeroRenderDevicesEnumerated"]),Nye.deviceQualityEvents=new Set(["DeviceCaptureNotFunctioning","VideoCapturerDeviceStartFailed","VideoCapturerDeviceStartTimedOut","DeviceCaptureMute","ScreenshareRecordingDisabled","DeviceCaptureNotMuteButSilent","VideoCapturePermissionDenied"]);var xhi=Nye,UD=dn,Bhi="function",sie="object",lie="undefined",h9="prototype",xye=Object,Fhi=xye[h9];function zD(n,a){return n||a}function qb(n,a){return n[a]}var Bye,iE=void 0,Wb=null,Fye="",cie="function",p9="object",VD="prototype",Uye="__proto__",j2="undefined",die="constructor",zye="Symbol",Uhi="_polyfill",G2="length",uie="name",Ly="call",hie="toString",tA=zD(Object),Vye=qb(tA,VD),z7e=zD(String),q2=qb(z7e,VD),zhi=zD(Math),V7e=zD(Array),$ye=qb(V7e,VD),$D=qb($ye,"slice");function zS(n,a){try{return{v:n.apply(this,a)}}catch(s){return{e:s}}}function Vhi(n,a){var s=zS(n);return s.e?a:s.v}function pie(n){return function(a){return typeof a===n}}function $7e(n){var a="[object "+n+"]";return function(s){return!(!s||$hi(s)!==a)}}function $hi(n){return Vye[hie].call(n)}function _c(n){return typeof n===j2||n===j2}function ic(n){return n===Wb||_c(n)}function Hhi(n){return n===Wb||!Hye(n)}function Hye(n){return!!n||n!==iE}function jhi(n){return n===Wb||H7e(typeof n)}function H7e(n){return!Bye&&(Bye=["string","number","boolean",j2,"symbol","bigint"]),n!==p9&&Bye.indexOf(n)!==-1}var wf=pie("string"),js=pie(cie);function JR(n){return!(!n&&ic(n)||!n||typeof n!==p9)}var Fo=qb(V7e,"isArray"),Ghi=$7e("Date"),HD=pie("number"),RN=pie("boolean"),qhi=$7e("Error");function $V(n){return!!(n&&n.then&&js(n.then))}function j7e(n){return!(!n||Vhi(function(){return!(n&&0+n)},!n))}var gie=qb(tA,"getOwnPropertyDescriptor");function iA(n,a){return!!n&&Vye.hasOwnProperty[Ly](n,a)}var nE=zD(qb(tA,"hasOwn"),Whi);function Whi(n,a){return iA(n,a)||!!gie(n,a)}function El(n,a,s){if(n&&JR(n)){for(var c in n)if(nE(n,c)&&a[Ly](n,c,n[c])===-1)break}}var mie={e:"enumerable",c:"configurable",v:"value",w:"writable",g:"get",s:"set"};function G7e(n){var a={};if(a[mie.c]=!0,a[mie.e]=!0,n.l){a.get=function(){return n.l.v};var s=gie(n.l,"v");s&&s.set&&(a.set=function(c){n.l.v=c})}return El(n,function(c,u){a[mie[c]]=_c(u)?a[mie[c]]:u}),a}var nA=qb(tA,"defineProperty"),Khi=qb(tA,"defineProperties");function Fc(n,a,s){return nA(n,a,G7e(s))}function jye(n,a){var s={};return El(a,function(c,u){s[c]=G7e(u)}),Khi(n,s)}function q7e(n,a,s,c,u){var m={};return El(n,function(b,_){fie(m,b,a?_:b),fie(m,_,b)}),c?c(m):m}function fie(n,a,s,c){nA(n,a,{value:s,enumerable:!0,writable:!1})}var aA=zD(z7e),Jhi="[object Error]";function Gs(n,a){var s=Fye,c=Vye[hie][Ly](n);c===Jhi&&(n={stack:aA(n.stack),message:aA(n.message),name:aA(n.name)});try{s=(s=JSON.stringify(n,Wb,a?typeof a=="number"?a:4:iE))&&s.replace(/"(\w+)"\s*:\s{0,1}/g,"$1: ")||aA(n)}catch(u){s=" - "+Gs(u,a)}return c+": "+s}function Tw(n){throw new Error(n)}function rA(n){throw new TypeError(n)}var W7e=qb(tA,"freeze");function Yhi(n){return n}function Qhi(n){return n[Uye]||Wb}var K7e=qb(tA,"assign"),hC=qb(tA,"keys");function jD(n){return W7e&&El(n,function(a,s){(Fo(s)||JR(s))&&jD(s)}),MN(n)}var MN=zD(W7e,Yhi),Gye=zD(qb(tA,"getPrototypeOf"),Qhi);function Zhi(n){return q7e(n,1,0,MN)}function Xhi(n){return q7e(n,0,0,MN)}function epi(n){var a={};return El(n,function(s,c){fie(a,s,c[1]),fie(a,c[0],c[1])}),MN(a)}function tpi(n){return epi(n)}var qye,J7e=Xhi({asyncIterator:0,hasInstance:1,isConcatSpreadable:2,iterator:3,match:4,matchAll:5,replace:6,search:7,species:8,split:9,toPrimitive:10,toStringTag:11,unscopables:12}),Y7e="__tsUtils$gblCfg";function Q7e(){var n;return typeof globalThis!==j2&&(n=globalThis),n||typeof self===j2||(n=self),n||typeof window===j2||(n=window),n||typeof ye===j2||(n=ye),n}function Z7e(){if(!qye){var n=zS(Q7e).v||{};qye=n[Y7e]=n[Y7e]||{}}return qye}var vie=HV;function HV(n,a,s){var c=a&&a[n];return function(u){var m=u&&u[n]||c;if(m||s){var b=arguments;return(m||s).apply(u,m?$D[Ly](b,1):b)}rA('"'+aA(n)+'" not defined for '+Gs(u))}}function ipi(n){return function(a){return a[n]}}var npi=qb(zhi,"max"),X7e=vie("slice",q2),Kb=vie("substring",q2),Cw=HV("substr",q2,api);function api(n,a,s){return ic(n)&&rA("Invalid "+Gs(n)),s<0?Fye:((a=a||0)<0&&(a=npi(a+n[G2],0)),_c(s)?X7e(n,a):X7e(n,a,a+s))}function yie(n,a){return Kb(n,0,a)}var Wye,Sie,kv,eGe="_urid";function rpi(){if(!Wye){var n=Z7e();Wye=n.gblSym=n.gblSym||{k:{},s:{}}}return Wye}function Kye(n){var a={description:aA(n),toString:function(){return zye+"("+n+")"}};return a[Uhi]=!0,a}function opi(n){var a=rpi();if(!nE(a.k,n)){var s=Kye(n),c=hC(a.s).length;s[eGe]=function(){return c+"_"+s[hie]()},a.k[n]=s,a.s[s[eGe]()]=aA(n)}return a.k[n]}function spi(n){var a;!Sie&&(Sie={});var s=J7e[n];return s&&(a=Sie[s]=Sie[s]||Kye(zye+"."+s)),a}function W2(){kv=Z7e()}function lpi(n){var a={};return!kv&&W2(),a.b=kv.lzy,nA(a,"v",{configurable:!0,get:function(){var s=n();return kv.lzy||nA(a,"v",{value:s}),a.b=kv.lzy,s}}),a}function YR(n){return nA({toJSON:function(){return n}},"v",{value:n})}var g9,tGe="window";function bie(n,a){var s;return function(){return!kv&&W2(),(!s||kv.lzy)&&(s=YR(zS(n,a).v)),s.v}}function PN(n){return!kv&&W2(),(!g9||n===!1||kv.lzy)&&(g9=YR(zS(Q7e).v||Wb)),g9.v}function Zu(n,a){var s=g9&&a!==!1?g9.v:PN(a);return s&&s[n]?s[n]:n===tGe?qD():Wb}function iGe(){return!!GD()}var GD=bie(Zu,["document"]);function cpi(){return!!qD()}var qD=bie(Zu,[tGe]);function dpi(){return!!QR()}var m9,nGe,Tie,QR=bie(Zu,["navigator"]),upi=bie(function(){return!!zS(function(){return process&&(process.versions||{}).node}).v});function Cie(){return m9=YR(zS(Zu,[zye]).v)}function hpi(n){var a=(kv.lzy?0:m9)||Cie();return a.v?a.v[n]:iE}function ppi(){return!!gpi()}function gpi(){return!kv&&W2(),((kv.lzy?0:m9)||Cie()).v}function Jye(n,a){var s=J7e[n];!kv&&W2();var c=(kv.lzy?0:m9)||Cie();return c.v?c.v[s||n]:spi(n)}function ZR(n,a){!kv&&W2();var s=(kv.lzy?0:m9)||Cie();return s.v?s.v(n):Kye(n)}function jV(n){return!kv&&W2(),((nGe=(kv.lzy?0:nGe)||YR(zS(hpi,["for"]).v)).v||opi)(n)}function Yye(n){return!!n&&js(n.next)}function mpi(n){return!Hhi(n)&&js(n[Jye(3)])}function aGe(n,a,s){if(n&&(Yye(n)||(!Tie&&(Tie=YR(Jye(3))),n=n[Tie.v]?n[Tie.v]():null),Yye(n))){var c=iE,u=iE;try{for(var m=0;!(u=n.next()).done&&a[Ly](s||n,u.value,m,n)!==-1;)m++}catch(b){c={e:b},n.throw&&(u=Wb,n.throw(c))}finally{try{u&&!u.done&&n.return&&n.return(u)}finally{if(c)throw c.e}}}}function GV(n,a,s){return n.apply(a,s)}function XR(n,a){return!_c(a)&&n&&(Fo(a)?GV(n.push,n,a):Yye(a)||mpi(a)?aGe(a,function(s){n.push(s)}):n.push(a)),n}function Ra(n,a,s){if(n)for(var c=n[G2]>>>0,u=0;u<c&&(!(u in n)||a[Ly](n,n[u],u,n)!==-1);u++);}var Rv=vie("indexOf",$ye);function f9(n,a,s){return(n&&n.slice||$D).apply(n,$D[Ly](arguments,1))}function fpi(n,a,s){return Rv(n,a,s)!==-1}var Qye,vpi=HV("includes",$ye,fpi),DN=zD(qb(tA,"create"),ypi);function ypi(n){if(!n)return{};var a=typeof n;function s(){}return a!==p9&&a!==cie&&rA("Prototype must be an Object or function: "+Gs(n)),s[VD]=n,new s}function rGe(n,a){return(tA.setPrototypeOf||function(s,c){var u;!Qye&&(Qye=YR(((u={})[Uye]=[],u instanceof Array))),Qye.v?s[Uye]=c:El(c,function(m,b){return s[m]=b})})(n,a)}function Spi(n,a,s){function c(){this[die]=a,zS(Fc,[this,uie,{v:n,c:!0,e:!1}])}return zS(Fc,[a,uie,{v:n,c:!0,e:!1}]),(a=rGe(a,s))[VD]=s===Wb?DN(s):(c[VD]=s[VD],new c),a}function oGe(n,a){a&&(n[uie]=a)}function Zye(n,a,s){var c=Error,u=c[VD][uie],m=Error.captureStackTrace;return Spi(n,function(){var b=this,_=arguments;try{zS(oGe,[c,n]);var k=GV(c,b,$D[Ly](_))||b;if(k!==b){var N=Gye(b);N!==Gye(k)&&rGe(k,N)}return m&&m(k,b[die]),a&&a(k,_),k}finally{zS(oGe,[c,u])}},c)}function Jb(){return(Date.now||bpi)()}function bpi(){return new Date().getTime()}function Tpi(n){return function(s){return ic(s)&&rA("strTrim called ["+Gs(s)+"]"),s&&s.replace&&(s=s.replace(n,Fye)),s}}var Xye,eSe,tSe,pC=HV("trim",q2,Tpi(/^\s+|(?=\s)\s+$/g));function kf(n){if(!n||typeof n!==p9)return!1;tSe||(tSe=!cpi()||qD());var a=!1;if(n!==tSe){eSe||(Xye=Function[VD][hie],eSe=Xye[Ly](tA));try{var s=Gye(n);(a=!s)||(iA(s,die)&&(s=s[die]),a=s&&typeof s===cie&&Xye[Ly](s)===eSe)}catch{}}return a}function Cpi(n){return n.value&&cGe(n),!0}var sGe=[Ipi,cGe,kpi,wpi];function _pi(n,a,s,c){var u;return Ra(n,function(m){if(m.k===a)return u=m,-1}),u||(u={k:a,v:a},n.push(u),c(u)),u.v}function iSe(n,a,s,c){var u=s.handler,m=s.path?c?s.path.concat(c):s.path:[],b={handler:s.handler,src:s.src,path:m},_=typeof a,k=!1,N=!1;a&&_===p9?k=kf(a):N=a===Wb||H7e(_);var W={type:_,isPrim:N,isPlain:k,value:a,result:a,path:m,origin:s.src,copy:function(ee,oe){return iSe(n,ee,oe?b:s,oe)},copyTo:function(ee,oe){return lGe(n,ee,oe,b)}};return W.isPrim?u&&u[Ly](s,W)?W.result:a:_pi(n,a,m,function(ee){Fc(W,"result",{g:function(){return ee.v},s:function(se){ee.v=se}});for(var oe=0,de=u;!(de||(oe<sGe.length?sGe[oe++]:Cpi))[Ly](s,W);)de=Wb})}function lGe(n,a,s,c){if(!ic(s))for(var u in s)a[u]=iSe(n,s[u],c,u);return a}function Epi(n,a,s){return lGe([],n,a,{handler:s,src:a,path:[]})}function Api(n,a){return iSe([],n,{handler:a,src:n})}function Ipi(n){var a=n.value;if(Fo(a)){var s=n.result=[];return s.length=a.length,n.copyTo(s,a),!0}return!1}function wpi(n){var a=n.value;return!!Ghi(a)&&(n.result=new Date(a.getTime()),!0)}function kpi(n){return n.type===cie}function cGe(n){var a=n.value;if(a&&n.isPlain){var s=n.result={};return n.copyTo(s,a),!0}return!1}function Rpi(n,a){return Ra(a,function(s){Epi(n,s)}),n}function dGe(n,a,s,c,u,m,b){return Rpi(Api(n)||{},$D[Ly](arguments))}var WD=ipi(G2);function uGe(){return Jb()}var Mpi=HV("endsWith",q2,Ppi);function Ppi(n,a,s){wf(n)||rA("'"+Gs(n)+"' is not a string");var c=wf(a)?a:aA(a),u=!_c(s)&&s<n[G2]?s:n[G2];return Kb(n,u-c[G2],u)===c}var qV=vie("indexOf",q2),K2=HV("startsWith",q2,Dpi);function Dpi(n,a,s){wf(n)||rA("'"+Gs(n)+"' is not a string");var c=wf(a)?a:aA(a),u=s>0?s:0;return Kb(n,u,u+c[G2])===c}var nSe="ref",aSe="unref",rSe="hasRef",Lpi="enabled";function Opi(n,a,s){var c,u=!0,m=n?a(Wb):Wb;function b(){return u=!1,m&&m[aSe]&&m[aSe](),c}function _(){m&&s(m),m=Wb}function k(){return m=a(m),u||b(),c}function N(W){!W&&m&&_(),W&&!m&&k()}return(c={cancel:_,refresh:k})[rSe]=function(){return m&&m[rSe]?m[rSe]():u},c[nSe]=function(){return u=!0,m&&m[nSe]&&m[nSe](),c},c[aSe]=b,{h:c=nA(c,Lpi,{get:function(){return!!m},set:N}),dn:function(){m=Wb}}}function oSe(n,a,s){var c=Fo(a),u=c?a.length:0,m=(u>0?a[0]:c?iE:a)||setTimeout,b=(u>1?a[1]:iE)||clearTimeout,_=s[0];s[0]=function(){k.dn(),GV(_,iE,$D[Ly](arguments))};var k=Opi(n,function(N){if(N){if(N.refresh)return N.refresh(),N;GV(b,iE,[N])}return GV(m,iE,s)},function(N){GV(b,iE,[N])});return k.h}function KD(n,a){return oSe(!0,iE,$D[Ly](arguments))}function Npi(n,a,s){return oSe(!0,n,$D[Ly](arguments,1))}function xpi(n,a){return oSe(!1,iE,$D[Ly](arguments))}(PN()||{}).Symbol,(PN()||{}).Reflect;var _ie,Bpi="hasOwnProperty",hGe=function(n,a){return(hGe=xye.setPrototypeOf||{__proto__:[]}instanceof Array&&function(s,c){s.__proto__=c}||function(s,c){for(var u in c)c[Bpi](u)&&(s[u]=c[u])})(n,a)};function VS(n,a){function s(){this.constructor=n}typeof a!==Bhi&&a!==null&&rA("Class extends value "+String(a)+" is not a constructor or null"),hGe(n,a),n[h9]=a===null?DN(a):(s[h9]=a[h9],new s)}function pGe(n,a){for(var s=0,c=a.length,u=n.length;s<c;s++,u++)n[u]=a[s];return n}var Eie="constructor",JD="prototype",Aie="function",Iie="_dynInstFuncs",sSe="_isDynProxy",WV="_dynClass",Fpi="_dynCls$",lSe="_dynInstChk",v9=lSe,gGe="_dfOpts",mGe="_unknown_",cSe="__proto__",wie="_dyn"+cSe,fGe="__dynProto$Gbl",dSe="_dynInstProto",kie="useBaseInst",uSe="setInstFuncs",hSe=Object,y9=hSe.getPrototypeOf,vGe=hSe.getOwnPropertyNames,yGe=PN(),pSe=yGe[fGe]||(yGe[fGe]={o:(_ie={},_ie[uSe]=!0,_ie[kie]=!0,_ie),n:1e3});function Rie(n){return n&&(n===hSe[JD]||n===Array[JD])}function gSe(n){return Rie(n)||n===Function[JD]}function J2(n){var a;if(n){if(y9)return y9(n);var s=n[cSe]||n[JD]||(n[Eie]?n[Eie][JD]:null);a=n[wie]||s,iA(n,wie)||(delete n[dSe],a=n[wie]=n[dSe]||n[wie],n[dSe]=s)}return a}function Mie(n,a){var s=[];if(vGe)s=vGe(n);else for(var c in n)typeof c=="string"&&iA(n,c)&&s.push(c);if(s&&s.length>0)for(var u=0;u<s.length;u++)a(s[u])}function mSe(n,a,s){return a!==Eie&&typeof n[a]===Aie&&(s||iA(n,a))&&a!==cSe&&a!==JD}function Pie(n){rA("DynamicProto: "+n)}function Upi(n){var a=DN(null);return Mie(n,function(s){!a[s]&&mSe(n,s,!1)&&(a[s]=n[s])}),a}function fSe(n,a){for(var s=n.length-1;s>=0;s--)if(n[s]===a)return!0;return!1}function zpi(n,a,s,c){function u(k,N,W){var ee=N[W];if(ee[sSe]&&c){var oe=k[Iie]||{};oe[v9]!==!1&&(ee=(oe[N[WV]]||{})[W]||ee)}return function(){return ee.apply(k,arguments)}}var m=DN(null);Mie(s,function(k){m[k]=u(a,s,k)});for(var b=J2(n),_=[];b&&!gSe(b)&&!fSe(_,b);)Mie(b,function(k){!m[k]&&mSe(b,k,!y9)&&(m[k]=u(a,b,k))}),_.push(b),b=J2(b);return m}function Vpi(n,a,s,c){var u=null;if(n&&iA(s,WV)){var m=n[Iie]||DN(null);if((u=(m[s[WV]]||DN(null))[a])||Pie("Missing ["+a+"] "+Aie),!u[lSe]&&m[v9]!==!1){for(var b=!iA(n,a),_=J2(n),k=[];b&&_&&!gSe(_)&&!fSe(k,_);){var N=_[a];if(N){b=N===c;break}k.push(_),_=J2(_)}try{b&&(n[a]=u),u[lSe]=1}catch{m[v9]=!1}}}return u}function $pi(n,a,s){var c=a[n];return c===s&&(c=J2(a)[n]),typeof c!==Aie&&Pie("["+n+"] is not a "+Aie),c}function Hpi(n,a,s,c,u){function m(k,N){var W=function(){return(Vpi(this,N,k,W)||$pi(N,k,W)).apply(this,arguments)};return W[sSe]=1,W}if(!Rie(n)){var b=s[Iie]=s[Iie]||DN(null);if(!Rie(b)){var _=b[a]=b[a]||DN(null);b[v9]!==!1&&(b[v9]=!!u),Rie(_)||Mie(s,function(k){mSe(s,k,!1)&&s[k]!==c[k]&&(_[k]=s[k],delete s[k],(!iA(n,k)||n[k]&&!n[k][sSe])&&(n[k]=m(n,k)))})}}}function jpi(n,a){if(y9){for(var s=[],c=J2(a);c&&!gSe(c)&&!fSe(s,c);){if(c===n)return!0;s.push(c),c=J2(c)}return!1}return!0}function vSe(n,a){return iA(n,JD)?n.name||a||mGe:((n||{})[Eie]||{}).name||a||mGe}function Ec(n,a,s,c){iA(n,JD)||Pie("theClass is an invalid class definition.");var u=n[JD];jpi(u,a)||Pie("["+vSe(n)+"] not in hierarchy of ["+vSe(a)+"]");var m=null;iA(u,WV)?m=u[WV]:(m=Fpi+vSe(n,"_")+"$"+pSe.n,pSe.n++,u[WV]=m);var b=Ec[gGe],_=!!b[kie];_&&c&&c[kie]!==void 0&&(_=!!c[kie]);var k=Upi(a);s(a,zpi(u,a,k,_));var N=!!y9&&!!b[uSe];N&&c&&(N=!!c[uSe]),Hpi(u,m,a,k,N!==!1)}Ec[gGe]=pSe.o;var ySe,SSe=Zhi,gC=tpi,Y2=SSe({Unknown:0,NonRetryableStatus:1,InvalidEvent:2,SizeLimitExceeded:3,KillSwitch:4,QueueFull:5}),bSe="toLowerCase",Die="blkVal",Ll="length",Lie="rdOnly",Oie="notify",Nie="warnToConsole",S9="throwInternal",KV="setDf",LN="watch",Hg="logger",xie="apply",hu="push",b9="splice",SGe="hdlr",JV="cancel",T9="initialize",ON="identifier",Bie="removeNotificationListener",Fie="addNotificationListener",eM="isInitialized",Uie="getNotifyMgr",C9="getPlugin",bGe="pollInternalLogs",Q2="name",YV="time",Yb="processNext",TGe="getProcessTelContext",QV="enabled",CGe="stopPollingInternalLogs",NN="unload",zie="onComplete",_Ge="version",EGe="loggingLevelConsole",Z2="createNew",YD="teardown",Vie="messageId",X2="message",ZV="isAsync",QD="diagLog",$ie="_doTeardown",_9="update",tM="getNext",E9="setNextPlugin",AGe="protocol",TSe="userAgent",Hie="split",CSe="nodeType",eU="replace",Gpi="logInternalMessage",ZD="type",_Se="handler",A9="status",IGe="getResponseHeader",wGe="getAllResponseHeaders",ESe="isChildEvt",XV="data",e$="getCtx",iM="setCtx",ASe="complete",I9="urlString",kGe="sendPOST",ISe="headers",t$="timeout",RGe="setRequestHeader",MGe="traceId",PGe="spanId",DGe="traceFlags";function qpi(n,a){ySe||(ySe=Zye("AggregationError",function(c,u){u[Ll]>1&&(c.errors=u[1])}));var s=n;throw Ra(a,function(c,u){s+=`
`.concat(u," > ").concat(Gs(c))}),new ySe(s,a||[])}var jie="Promise",LGe="rejected";function _w(n,a){return tU(n,function(s){return a?a({status:"fulfilled",rejected:!1,value:s}):s},function(s){return a?a({status:LGe,rejected:!0,reason:s}):s})}function tU(n,a,s,c){var u=n;try{if($V(n))(a||s)&&(u=n.then(a,s));else try{a&&(u=a(n))}catch(m){if(!s)throw m;u=s(m)}}finally{}return u}var Gie,OGe=["pending","resolving","resolved",LGe],NGe="dispatchEvent";function Wpi(n){var a;return n&&n.createEvent&&(a=n.createEvent("Event")),!!a&&a.initEvent}function Kpi(n,a,s,c){var u=GD();!Gie&&(Gie=YR(!!zS(Wpi,[u]).v));var m=Gie.v?u.createEvent("Event"):c?new Event(a):{};if(s&&s(m),Gie.v&&m.initEvent(a,!1,!0),m&&n[NGe])n[NGe](m);else{var b=n["on"+a];if(b)b(m);else{var _=Zu("console");_&&(_.error||_.log)(a,Gs(m))}}}var wSe,xGe="unhandledRejection",Jpi=xGe.toLowerCase(),BGe=[],Ypi=0,Qpi=10;function FGe(n){return js(n)?n.toString():Gs(n)}function Zpi(n,a,s){var c,u,m=f9(arguments,3),b=0,_=!1,k=[],N=Ypi++,W=!1,ee=null;function oe(be,Ee){try{return BGe.push(N),W=!0,ee&&ee.cancel(),ee=null,n(function(Pe,Qe){k.push(function(){try{var Ze=b===2?be:Ee,Xe=_c(Ze)?c:js(Ze)?Ze(c):Ze;$V(Xe)?Xe.then(Pe,Qe):Ze?Pe(Xe):b===3?Qe(Xe):Pe(Xe)}catch(bt){Qe(bt)}}),_&&ue()},m)}finally{BGe.pop()}}function de(be){return oe(void 0,be)}function se(be){var Ee=be,Pe=be;return js(be)&&(Ee=function(Qe){return be&&be(),Qe},Pe=function(Qe){throw be&&be(),Qe}),oe(Ee,Pe)}function Re(){return OGe[b]}function ue(){if(k.length>0){var be=k.slice();k=[],W=!0,ee&&ee.cancel(),ee=null,a(be)}}function Ne(be,Ee){return function(Pe){if(b===Ee){if(be===2&&$V(Pe))return b=1,void Pe.then(Ne(2,1),Ne(3,1));b=be,_=!0,c=Pe,ue(),W||be!==3||ee||(ee=KD(ze,Qpi))}}}function ze(){if(!W)if(W=!0,upi())process.emit(xGe,c,u);else{var be=qD()||PN();!wSe&&(wSe=YR(zS(Zu,[jie+"RejectionEvent"]).v)),Kpi(be,Jpi,function(Ee){return Fc(Ee,"promise",{g:function(){return u}}),Ee.reason=c,Ee},!!wSe.v)}}function He(){return"IPromise "+Re()+(_?" - "+FGe(c):"")}return nA(u={then:oe,catch:de,finally:se},"state",{get:Re}),ppi()&&(u[Jye(11)]="IPromise"),u.toString=He,function(){js(s)||rA(jie+": executor is not a function - "+FGe(s));var Ee=Ne(3,0);try{s.call(u,Ne(2,0),Ee)}catch(Pe){Ee(Pe)}}(),u}function UGe(n){return function(a){var s=f9(arguments,1);return n(function(c,u){try{var m=[],b=1;aGe(a,function(_,k){_&&(b++,tU(_,function(N){m[k]=N,--b==0&&c(m)},u))}),--b==0&&c(m)}catch(_){u(_)}},s)}}function Xpi(n){return function(a){var s=f9(arguments,1);return $V(a)?a:n(function(c){c(a)},s)}}function egi(n){return function(a){var s=f9(arguments,1);return n(function(c,u){u(a)},s)}}function tgi(n){Ra(n,function(a){try{a()}catch{}})}function igi(n){var a=HD(n)?n:0;return function(s){KD(function(){tgi(s)},a)}}function Sp(n,a){return Zpi(Sp,igi(a),n,a)}var kSe,RSe,ngi=UGe(Sp),agi=Xpi(Sp),XD=egi(Sp);function rgi(n,a){!kSe&&(kSe=YR(zS(Zu,[jie]).v||null));var s=kSe.v;if(!s)return Sp(n);js(n)||rA(jie+": executor is not a function - "+Gs(n));var c=0;function u(){return OGe[c]}var m=new s(function(b,_){function k(W){c=2,b(W)}function N(W){c=3,_(W)}n(k,N)});return nA(m,"state",{get:u}),m}function eL(n,a){return!RSe&&(RSe=YR(rgi)),RSe.v.call(this,n,a)}var zGe,MSe,ogi=UGe(eL),w9="reject",VGe="Rejected",sgi=0,PSe={};function $Ge(){}function qie(n,a,s){!PSe[n]&&(PSe[n]=Zye(n));var c=Jb();return new PSe[n]("Task [".concat(a.id,"] ").concat(s||"","- ").concat(a.st?"Running":"Waiting",": ").concat(lgi(c,a.st||a.cr)))}function lgi(n,a){return(n-a||"0")+" ms"}function HGe(n,a){var s=Jb()-a;Ra(n,function(c){(c&&!c.rj&&c.st&&c.st<s||!c.st&&c.cr&&c.cr<s)&&c&&c[w9](c.rj||qie("Aborted",c,"Stale "))})}function jGe(n,a){var s=Rv(n,a);s!==-1&&n.splice(s,1)}function cgi(n,a,s){MSe=MSe||{toString:function(){return"[[SchedulerState]]"}},nA(n,zGe=zGe||{toString:function(){return"[[SchedulerName]]"}},{get:a}),nA(n,MSe,{get:s})}function DSe(n,a){var s,c,u=[],m=[],b=6e5,_=b/10,k=0,N=(a?a+".":"")+sgi++;n=n||eL;var W=function(){var ue=WD(u)+WD(m)>0;b>0&&(c||(c=KD(function(){HGe(u,b),HGe(m,b),c&&(c.enabled=WD(u)+WD(m)>0)},_)).unref(),c&&(c.enabled=ue))},ee=function(ue,Ne,ze){var He,be=N+"."+k++;Ne&&(be+="-("+Ne+")");var Ee=((He={id:be,cr:Jb(),to:ze})[w9]=function(Pe){Ee.rj=Pe||qie(VGe,Ee),Ee[w9]=$Ge},He);return Ee.p=s?de(Ee,s,ue):n(oe(Ee,ue)),s=Ee,Ee.p},oe=function(ue,Ne){return ue.st=Jb(),u.push(ue),W(),function(ze,He){var be=function(Qe){ue.rj=ue.rj||Qe||qie(VGe,ue),ue[w9]=$Ge,se(ue),ze=null,He&&He(Qe),He=null},Ee=ue.id;if(ue.rj)be(ue.rj);else{ue[w9]=be;try{var Pe=Ne(Ee);ue.to&&$V(Pe)&&(ue.t=KD(function(){be(qie("Timeout",ue))},ue.to)),tU(Pe,function(Qe){se(ue);try{ze&&ze(Qe)}catch(Ze){He&&He(Ze)}He=null,ze=null},be)}catch(Qe){be(Qe)}}}},de=function(ue,Ne,ze){return m.push(ue),W(),n(function(He,be){_w(Ne.p,function(){jGe(m,ue),oe(ue,ze)(He,be)})})},se=function(ue){jGe(u,ue),ue.t&&ue.t.cancel(),ue.t=null,s&&s===ue&&(s=null,WD(u)+WD(m)===0&&(c&&c.cancel(),c=null))},Re={idle:!0,queue:ee,setStaleTimeout:function(ue,Ne){c&&c.cancel(),c=null,b=ue,_=Ne||ue/10,W()}};return Fc(Re,"idle",{g:function(){return WD(u)+WD(m)===0}}),cgi(Re,function(){return N},function(){return{l:s,r:u,w:m}}),Re}var nM=void 0,qc="",iU="channels",Rf="core",LSe="createPerfMgr",OSe="disabled",i$="extensionConfig",n$="extensions",aM="processTelemetry",Wie="priority",Kie="eventsSent",k9="eventsDiscarded",Jie="eventsSendRequest",nU="perfEvent",NSe="offlineEventsStored",xSe="offlineBatchSent",BSe="offlineBatchDrop",Yie="getPerfMgr",FSe="domain",USe="path",dgi="Not dynamic - ",ugi=/-([a-z])/g,hgi=/([^\w\d_$])/g,pgi=/^(\d+[\w\d_$])/;function zSe(n){return!ic(n)}function VSe(n){var a=n;return a&&wf(a)&&(a=(a=(a=a[eU](ugi,function(s,c){return c.toUpperCase()}))[eU](hgi,"_"))[eU](pgi,function(s,c){return"_"+c})),a}function mC(n,a){return!(!n||!a)&&qV(n,a)!==-1}function $Se(n){return n&&n.toISOString()||""}function GGe(n){return qhi(n)?n[Q2]:qc}function a$(n,a,s,c,u){var m=s;return n&&((m=n[a])===s||u&&!u(m)||c&&!c(s)||(m=s,n[a]=m)),m}function ggi(n,a,s){var c;return n?!(c=n[a])&&ic(c)&&(c=_c(s)?{}:s,n[a]=c):c=_c(s)?{}:s,c}function mgi(n,a){var s=null,c=null;return js(n)?s=n:c=n,function(){var u=arguments;if(s&&(c=s()),c)return c[a][xie](c,u)}}function Qie(n,a,s,c,u){n&&a&&s&&u!==!1&&(n[a]=mgi(s,c))}function qGe(n,a,s,c){return n&&a&&JR(n)&&Fo(s)&&Ra(s,function(u){wf(u)&&Qie(n,u,a,u,c)}),n}function r$(n){return n&&K7e&&(n=xye(K7e({},n))),n}function WGe(n,a,s,c,u,m){var b=arguments,_=b[0]||{},k=b[Ll],N=!1,W=1;for(k>0&&RN(_)&&(N=_,_=b[W]||{},W++),JR(_)||(_={});W<k;W++){var ee=b[W],oe=Fo(ee),de=JR(ee);for(var se in ee)if(oe&&se in ee||de&&nE(ee,se)){var Re=ee[se],ue=void 0;if(N&&Re&&((ue=Fo(Re))||kf(Re))){var Ne=_[se];ue?Fo(Ne)||(Ne=[]):kf(Ne)||(Ne={}),Re=WGe(N,Ne,Re)}Re!==void 0&&(_[se]=Re)}}return _}function o$(n){try{return n.responseText}catch{}return null}function fgi(n,a){return n?"XDomainRequest,Response:"+o$(n)||"":a}function KGe(n,a){return n?"XMLHttpRequest,Status:"+n[A9]+",Response:"+o$(n)||n.response||"":a}function JGe(n,a){return a&&(HD(a)?n=[a].concat(n):Fo(a)&&(n=a.concat(n))),n}var vgi="Microsoft_ApplicationInsights_BypassAjaxInstrumentation",YGe="withCredentials",ygi="timeout";function Sgi(n,a,s,c,u,m){function b(k,N,W){try{k[N]=W}catch{}}u===void 0&&(u=!1);var _=new XMLHttpRequest;return b(_,vgi,c),s&&b(_,YGe,s),_.open(n,a,!u),s&&b(_,YGe,s),!u&&m&&b(_,ygi,m),_}function bgi(n){var a={};return wf(n)&&Ra(pC(n)[Hie](/[\r\n]+/),function(s){if(s){var c=s.indexOf(": ");if(c!==-1){var u=pC(s.substring(0,c))[bSe](),m=pC(s.substring(c+1));a[u]=m}else a[pC(s)]=1}}),a}function HSe(n,a,s){if(!n[s]&&a&&a[IGe]){var c=a[IGe](s);c&&(n[s]=pC(c))}return n}var Tgi="kill-duration",Cgi="kill-duration-seconds",_gi="time-delta-millis";function Zie(n,a){var s={};return n[wGe]?s=bgi(n[wGe]()):a&&(s=HSe(s,n,_gi),s=HSe(s,n,Tgi),s=HSe(s,n,Cgi)),s}var Egi="location",Agi="console",QGe="JSON",Igi="crypto",wgi="msCrypto",kgi="ReactNative",Rgi="msie",Mgi="trident/",ZGe="XMLHttpRequest",jSe=null,XGe=null,R9=null,GSe=null;function e9e(n,a){var s=!1;if(n){try{if(!(s=a in n)){var c=n[h9];c&&(s=a in c)}}catch{}if(!s)try{s=!_c(new n()[a])}catch{}}return s}function Xie(n){return typeof location===sie&&location?location:Zu(Egi)}function Pgi(){return typeof console!==lie?console:Zu(Agi)}function t9e(){return!!(typeof JSON===sie&&JSON||Zu(QGe)!==null)}function Dgi(){return t9e()?JSON||Zu(QGe):null}function Lgi(){return Zu(Igi)}function Ogi(){return Zu(wgi)}function i9e(){var n=QR();return!(!n||!n.product)&&n.product===kgi}function qSe(){var n=QR();if(n&&(n[TSe]!==XGe||jSe===null)){var a=((XGe=n[TSe])||qc)[bSe]();jSe=mC(a,Rgi)||mC(a,Mgi)}return jSe}function n9e(n){return GSe!==null&&n!==!1||(GSe=dpi()&&!!QR().sendBeacon),GSe}function a9e(n){var a=!1;try{a=!!Zu("fetch");var s=Zu("Request");a&&n&&s&&(a=e9e(s,"keepalive"))}catch{}return a}function Ngi(){return R9===null&&(R9=typeof XDomainRequest!==lie)&&r9e()&&(R9=R9&&!e9e(Zu(ZGe),"withCredentials")),R9}function r9e(){var n=!1;try{n=!!Zu(ZGe)}catch{}return n}var o9e=4294967296,aU=4294967295,s9e=123456789,l9e=987654321,c9e=!1,ene=s9e,tne=l9e;function xgi(n){n<0&&(n>>>=0),ene=s9e+n&aU,tne=l9e-n&aU,c9e=!0}function Bgi(){try{var n=2147483647&Jb();xgi((Math.random()*o9e^n)+n)}catch{}}function M9(n){var a=0,s=Lgi()||Ogi();return s&&s.getRandomValues&&(a=s.getRandomValues(new Uint32Array(1))[0]&aU),a===0&&qSe()&&(c9e||Bgi(),a=Fgi()&aU),a===0&&(a=Math.floor(o9e*Math.random()|0)),n||(a>>>=0),a}function Fgi(n){var a=((tne=36969*(65535&tne)+(tne>>16)&aU)<<16)+(65535&(ene=18e3*(65535&ene)+(ene>>16)&aU))>>>0&aU;return a>>>=0,a}function WSe(n){n===void 0&&(n=22);for(var a="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",s=M9()>>>0,c=0,u=qc;u[Ll]<n;)c++,u+=a.charAt(63&s),s>>>=6,c===5&&(s=(M9()<<2&4294967295|3&s)>>>0,c=0);return u}var d9e="3.2.1",Ugi="."+WSe(6),zgi=0;function u9e(n){return n[CSe]===1||n[CSe]===9||!+n[CSe]}function Vgi(n,a){var s=a[n.id];if(!s){s={};try{u9e(a)&&Fc(a,n.id,{e:!1,v:s})}catch{}}return s}function s$(n,a){return a===void 0&&(a=!1),VSe(n+zgi+++(a?"."+d9e:qc)+Ugi)}function h9e(n){var a={id:s$("_aiData-"+(n||qc)+"."+d9e),accept:function(s){return u9e(s)},get:function(s,c,u,m){var b=s[a.id];return b?b[VSe(c)]:(m&&((b=Vgi(a,s))[VSe(c)]=u),u)},kill:function(s,c){if(s&&s[c])try{delete s[c]}catch{}}};return a}function ine(n){return n&&JR(n)&&(n.isVal||n.fb||nE(n,"v")||nE(n,"mrg")||nE(n,"ref")||n.set)}function p9e(n,a,s){var c,u=s.dfVal||Hye;if(a&&s.fb){var m=s.fb;Fo(m)||(m=[m]);for(var b=0;b<m[Ll];b++){var _=m[b],k=a[_];if(u(k)?c=k:n&&(u(k=n.cfg[_])&&(c=k),n.set(n.cfg,aA(_),k)),u(c))break}}return!u(c)&&u(s.v)&&(c=s.v),c}function KSe(n,a,s){var c,u=s;return s&&ine(s)&&(u=p9e(n,a,s)),u&&(ine(u)&&(u=KSe(n,a,u)),Fo(u)?(c=[])[Ll]=u[Ll]:kf(u)&&(c={}),c&&(El(u,function(m,b){b&&ine(b)&&(b=KSe(n,a,b)),c[m]=b}),u=c)),u}function JSe(n,a,s,c){var u,m,b,_,k,N,W,ee,oe=c;ine(oe)?(u=oe.isVal,m=oe.set,N=oe[Lie],W=oe[Die],_=oe.mrg,!(k=oe.ref)&&_c(k)&&(k=!!_),b=p9e(n,a,oe)):b=c,W&&n[Die](a,s);var de=!0,se=a[s];!se&&ic(se)||(ee=se,de=!1,u&&ee!==b&&!u(ee)&&(ee=b,de=!0),m&&(de=(ee=m(ee,b,a))===b)),de?ee=b&&KSe(n,a,b):(kf(ee)||Fo(b))&&_&&b&&(kf(b)||Fo(b))&&El(b,function(Re,ue){JSe(n,ee,Re,ue)}),n.set(a,s,ee),k&&n.ref(a,s),N&&n[Lie](a,s)}var xN=jV("[[ai_dynCfg_1]]"),g9e=jV("[[ai_blkDynCfg_1]]"),$gi=jV("[[ai_frcDynCfg_1]]");function m9e(n){var a;return n&&(Fo(n)?(a=[])[Ll]=n[Ll]:kf(n)&&(a={}),a)?(El(n,function(s,c){a[s]=m9e(c)}),a):n}function f9e(n){if(n){var a=n[xN]||n;if(a.cfg&&(a.cfg===n||a.cfg[xN]===a))return a}return null}function Hgi(n){if(n&&(kf(n)||Fo(n)))try{n[g9e]=!0}catch{}return n}function YSe(n,a,s){var c=!1;return s&&!n[a.blkVal]&&((c=s[$gi])||s[g9e]||(c=kf(s)||Fo(s))),c}function v9e(n){rA("InvalidAccess:"+n)}var jgi=["push","pop","shift","unshift","splice"],P9=function(n,a,s,c){n&&n[S9](3,108,"".concat(s," [").concat(a,"] failed - ")+Gs(c))};function Ggi(n,a,s){Fo(a)&&Ra(jgi,function(c){var u=a[c];a[c]=function(){for(var m=[],b=0;b<arguments.length;b++)m[b]=arguments[b];var _=u[xie](this,m);return rne(n,a,s,"Patching"),_}})}function nne(n,a){var s=gie(n,a);return s&&s.get}function qgi(n,a,s,c){var u={n:s,h:[],trk:function(N){N&&N.fn&&(Rv(u.h,N)===-1&&u.h[hu](N),n.trk(N,u))},clr:function(N){var W=Rv(u.h,N);W!==-1&&u.h[b9](W,1)}},m=!0,b=!1;function _(){m&&(b=b||YSe(_,n,c),c&&!c[xN]&&b&&(c=rne(n,c,s,"Converting")),m=!1);var N=n.act;return N&&u.trk(N),c}function k(N){if(c!==N){_[n.ro]&&!n.upd&&v9e("["+s+"] is read-only:"+Gs(a)),m&&(b=b||YSe(_,n,c),m=!1);var W=b&&_[n.rf];if(b)if(W){El(c,function(oe){c[oe]=N?N[oe]:nM});try{El(N,function(oe,de){ane(n,c,oe,de)}),N=c}catch(oe){P9((n.hdlr||{})[Hg],s,"Assigning",oe),b=!1}}else c&&c[xN]&&El(c,function(oe){var de=nne(c,oe);if(de){var se=de[n.prop];se&&se.chng()}});if(N!==c){var ee=N&&YSe(_,n,N);!W&&ee&&(N=rne(n,N,s,"Converting")),c=N,b=ee}n.add(u)}}_[n.prop]={chng:function(){n.add(u)}},Fc(a,u.n,{g:_,s:k})}function ane(n,a,s,c){if(a){var u=nne(a,s);u&&u[n.prop]?a[s]=c:qgi(n,a,s,c)}return a}function QSe(n,a,s,c){if(a){var u=nne(a,s),m=u&&!!u[n.prop],b=c&&c[0],_=c&&c[1],k=c&&c[2];if(!m){if(k)try{Hgi(a)}catch(N){P9((n.hdlr||{})[Hg],s,"Blocking",N)}try{ane(n,a,s,a[s]),u=nne(a,s)}catch(N){P9((n.hdlr||{})[Hg],s,"State",N)}}b&&(u[n.rf]=b),_&&(u[n.ro]=_),k&&(u[n.blkVal]=!0)}return a}function rne(n,a,s,c){try{El(a,function(u,m){ane(n,a,u,m)}),a[xN]||(nA(a,xN,{get:function(){return n[SGe]}}),Ggi(n,a,s))}catch(u){P9((n.hdlr||{})[Hg],s,c,u)}return a}var D9="[[ai_",L9="]]";function Wgi(n){var a,s,c=ZR(D9+"get"+n.uid+L9),u=ZR(D9+"ro"+n.uid+L9),m=ZR(D9+"rf"+n.uid+L9),b=ZR(D9+"blkVal"+n.uid+L9),_=ZR(D9+"dtl"+n.uid+L9),k=null,N=null;function W(se,Re){var ue=s.act;try{s.act=se,se&&se[_]&&(Ra(se[_],function(ze){ze.clr(se)}),se[_]=[]),Re({cfg:n.cfg,set:n.set.bind(n),setDf:n[KV].bind(n),ref:n.ref.bind(n),rdOnly:n[Lie].bind(n)})}catch(ze){var Ne=n[Hg];throw Ne&&Ne[S9](1,107,Gs(ze)),ze}finally{s.act=ue||null}}function ee(){if(k){var se=k;k=null,N&&N[JV](),N=null;var Re=[];if(Ra(se,function(ue){if(ue&&(ue[_]&&(Ra(ue[_],function(Ne){Ne.clr(ue)}),ue[_]=null),ue.fn))try{W(ue,ue.fn)}catch(Ne){Re[hu](Ne)}}),k)try{ee()}catch(ue){Re[hu](ue)}Re[Ll]>0&&qpi("Watcher error(s): ",Re)}}function oe(se){if(se&&se.h[Ll]>0){k||(k=[]),N||(N=KD(function(){N=null,ee()},0));for(var Re=0;Re<se.h[Ll];Re++){var ue=se.h[Re];ue&&Rv(k,ue)===-1&&k[hu](ue)}}}function de(se,Re){if(se){var ue=se[_]=se[_]||[];Rv(ue,Re)===-1&&ue[hu](Re)}}return(a={prop:c,ro:u,rf:m})[Die]=b,a[SGe]=n,a.add=oe,a[Oie]=ee,a.use=W,a.trk=de,s=a}function Kgi(n,a){var s={fn:a,rm:function(){s.fn=null,n=null,a=null}};return Fc(s,"toJSON",{v:function(){return"WatcherHandler"+(s.fn?"":"[X]")}}),n.use(s,a),s}function Jgi(n,a,s){var c,u=f9e(a);if(u)return u;var m,b=s$("dyncfg",!0),_=a&&s!==!1?a:m9e(a);function k(){m[Oie]()}function N(Ne,ze,He){try{Ne=ane(m,Ne,ze,He)}catch(be){P9(n,ze,"Setting value",be)}return Ne[ze]}function W(Ne){return Kgi(m,Ne)}function ee(Ne,ze){m.use(null,function(He){var be=m.upd;try{_c(ze)||(m.upd=ze),Ne(He)}finally{m.upd=be}})}function oe(Ne,ze){var He;return QSe(m,Ne,ze,(He={},He[0]=!0,He))[ze]}function de(Ne,ze){var He;return QSe(m,Ne,ze,(He={},He[1]=!0,He))[ze]}function se(Ne,ze){var He;return QSe(m,Ne,ze,(He={},He[2]=!0,He))[ze]}function Re(Ne,ze){return ze&&El(ze,function(He,be){JSe(ue,Ne,He,be)}),Ne}var ue=((c={uid:null,cfg:_})[Hg]=n,c[Oie]=k,c.set=N,c[KV]=Re,c[LN]=W,c.ref=oe,c[Lie]=de,c[Die]=se,c._block=ee,c);return Fc(ue,"uid",{c:!1,e:!1,w:!1,v:b}),rne(m=Wgi(ue),_,"config","Creating"),ue}function Ygi(n,a){n?(n[Nie](a),n[S9](2,108,a)):v9e(a)}function Qb(n,a,s,c){var u=Jgi(s,n||{},c);return a&&u[KV](u.cfg,a),u}function Mf(n,a,s){var c=n[xN]||n;return!c.cfg||c.cfg!==n&&c.cfg[xN]!==c?(Ygi(s,dgi+Gs(n)),Qb(n,null,s)[LN](a)):c[LN](a)}function O9(n,a){if(n&&n[NN])return n[NN](a)}function y9e(n,a,s){var c;return s||(c=eL(function(u){s=u})),n&&WD(n)>0?_w(O9(n[0],a),function(){y9e(f9(n,1),a,s)}):s(),c}var Qgi=500,S9e="Microsoft_ApplicationInsights_BypassAjaxInstrumentation";function Ew(n){return{mrg:!0,v:n}}function rU(n){return{isVal:wf,v:aA(qc)}}var one,N9,ZSe=[Kie,k9,Jie,nU],sne=null;function Zgi(n,a){return function(){var s=arguments,c=b9e(a);if(c){var u=c.listener;u&&u[n]&&u[n][xie](u,s)}}}function Xgi(){var n=Zu("Microsoft");return n&&(sne=n.ApplicationInsights),sne}function b9e(n){var a=sne;return a||n.disableDbgExt===!0||(a=sne||Xgi()),a?a.ChromeDbgExt:null}function emi(n){if(!one){one={};for(var a=0;a<ZSe[Ll];a++)one[ZSe[a]]=Zgi(ZSe[a],n)}return one}var T9e="warnToConsole",tmi="AI (Internal): ",imi="AI: ",nmi="AITR_",ami={loggingLevelConsole:0,loggingLevelTelemetry:1,maxMessageLimit:25,enableDebug:!1},rmi=((N9={})[0]=null,N9[1]="errorToConsole",N9[2]=T9e,N9[3]="debugToConsole",N9);function C9e(n){return n?'"'+n[eU](/\"/g,qc)+'"':qc}function XSe(n,a){var s=Pgi();if(s){var c="log";s[n]&&(c=n),js(s[c])&&s[c](a)}}var ebe=function(){function n(a,s,c,u){c===void 0&&(c=!1);var m=this;m[Vie]=a,m[X2]=(c?imi:tmi)+a;var b=qc;t9e()&&(b=Dgi().stringify(u));var _=(s?" message:"+C9e(s):qc)+(u?" props:"+C9e(b):qc);m[X2]+=_}return n.dataType="MessageData",n}();function tbe(n,a){return(n||{})[Hg]||new l$(a)}var _9e,oU,l$=function(){function n(a){this.identifier="DiagnosticLogger",this.queue=[];var s,c,u,m,b,_=0,k={};Ec(n,this,function(N){function W(se,Re){if(!oe()){var ue=!0,Ne=nmi+Re[Vie];if(k[Ne]?ue=!1:k[Ne]=!0,ue&&(se<=c&&(N.queue[hu](Re),_++,de(se===1?"error":"warn",Re)),_===u)){var ze="Internal events throttle limit per PageView reached for this app.",He=new ebe(23,ze,!1);N.queue[hu](He),se===1?N.errorToConsole(ze):N[Nie](ze)}}}function ee(se){return Mf(Qb(se,ami,N).cfg,function(Re){var ue=Re.cfg;s=ue[EGe],c=ue.loggingLevelTelemetry,u=ue.maxMessageLimit,m=ue.enableDebug})}function oe(){return _>=u}function de(se,Re){var ue=b9e(a||{});ue&&ue[QD]&&ue[QD](se,Re)}b=ee(a||{}),N.consoleLoggingLevel=function(){return s},N[S9]=function(se,Re,ue,Ne,ze){ze===void 0&&(ze=!1);var He=new ebe(Re,ue,ze,Ne);if(m)throw Gs(He);var be=rmi[se]||T9e;if(_c(He[X2]))de("throw"+(se===1?"Critical":"Warning"),He);else{if(ze){var Ee=+He[Vie];!k[Ee]&&s>=se&&(N[be](He[X2]),k[Ee]=!0)}else s>=se&&N[be](He[X2]);W(se,He)}},N.debugToConsole=function(se){XSe("debug",se),de("warning",se)},N[Nie]=function(se){XSe("warn",se),de("warning",se)},N.errorToConsole=function(se){XSe("error",se),de("error",se)},N.resetInternalMessageCount=function(){_=0,k={}},N[Gpi]=W,N[NN]=function(se){b&&b.rm(),b=null}})}return n.__ieDyn=1,n}();function E9e(n){return n||new l$}function ud(n,a,s,c,u,m){m===void 0&&(m=!1),E9e(n)[S9](a,s,c,u,m)}function x9(n,a){E9e(n)[Nie](a)}var rM,A9e="toGMTString",I9e="toUTCString",ibe="cookie",nbe="expires",w9e="isCookieUseDisabled",abe="disableCookiesUsage",c$="_ckMgr",lne=null,rbe=null,k9e=null,R9e={},cne={},omi=((_9e={cookieCfg:Ew((oU={},oU[FSe]={fb:"cookieDomain",dfVal:zSe},oU.path={fb:"cookiePath",dfVal:zSe},oU.enabled=nM,oU.ignoreCookies=nM,oU.blockedCookies=nM,oU)),cookieDomain:nM,cookiePath:nM})[abe]=nM,_9e);function obe(){!rM&&(rM=lpi(function(){return GD()}))}function smi(n,a){var s=une[c$]||cne[c$];return s||(s=une[c$]=une(n,a),cne[c$]=s),s}function dne(n){return!n||n.isEnabled()}function M9e(n,a){return!!(a&&n&&Fo(n.ignoreCookies))&&Rv(n.ignoreCookies,a)!==-1}function lmi(n,a){return!!(a&&n&&Fo(n.blockedCookies)&&Rv(n.blockedCookies,a)!==-1)||M9e(n,a)}function P9e(n,a){var s=a[QV];if(ic(s)){var c=void 0;_c(n[w9e])||(c=!n[w9e]),_c(n[abe])||(c=!n[abe]),s=c}return s}function D9e(n,a){var s;return n&&(s=n.getCookieMgr()),s||(s=smi(a,(n||{})[Hg])),s}function une(n,a){var s,c,u,m,b,_,k,N,W;n=Qb(n||cne,null,a).cfg,b=Mf(n,function(oe){oe[KV](oe.cfg,omi),c=oe.ref(oe.cfg,"cookieCfg"),u=c[USe]||"/",m=c[FSe],_=P9e(n,c)!==!1,k=c.getCookie||cmi,N=c.setCookie||B9e,W=c.delCookie||B9e},a);var ee=((s={isEnabled:function(){var oe=P9e(n,c)!==!1&&_&&L9e(a),de=cne[c$];return oe&&de&&ee!==de&&(oe=dne(de)),oe},setEnabled:function(oe){_=oe!==!1,c[QV]=oe},set:function(oe,de,se,Re,ue){var Ne=!1;if(dne(ee)&&!lmi(c,oe)){var ze={},He=pC(de||qc),be=qV(He,";");if(be!==-1&&(He=pC(yie(de,be)),ze=O9e(Kb(de,be+1))),a$(ze,FSe,Re||m,j7e,_c),!ic(se)){var Ee=qSe();if(_c(ze[nbe])){var Pe=Jb()+1e3*se;if(Pe>0){var Qe=new Date;Qe.setTime(Pe),a$(ze,nbe,N9e(Qe,Ee?A9e:I9e)||N9e(Qe,Ee?A9e:I9e)||qc,j7e)}}Ee||a$(ze,"max-age",qc+se,null,_c)}var Ze=Xie();Ze&&Ze[AGe]==="https:"&&(a$(ze,"secure",null,null,_c),rbe===null&&(rbe=!dmi((QR()||{})[TSe])),rbe&&a$(ze,"SameSite","None",null,_c)),a$(ze,USe,ue||u,null,_c),N(oe,x9e(He,ze)),Ne=!0}return Ne},get:function(oe){var de=qc;return dne(ee)&&!M9e(c,oe)&&(de=k(oe)),de},del:function(oe,de){var se=!1;return dne(ee)&&(se=ee.purge(oe,de)),se},purge:function(oe,de){var se,Re=!1;if(L9e(a)){var ue=((se={})[USe]=de||"/",se[nbe]="Thu, 01 Jan 1970 00:00:01 GMT",se);qSe()||(ue["max-age"]="0"),W(oe,x9e(qc,ue)),Re=!0}return Re}})[NN]=function(oe){b&&b.rm(),b=null},s);return ee[c$]=ee,ee}function L9e(n){if(lne===null){lne=!1,!rM&&obe();try{var a=rM.v||{};lne=a[ibe]!==void 0}catch(s){ud(n,2,68,"Cannot access document.cookie - "+GGe(s),{exception:Gs(s)})}}return lne}function O9e(n){var a={};return n&&n[Ll]&&Ra(pC(n)[Hie](";"),function(s){if(s=pC(s||qc)){var c=qV(s,"=");c===-1?a[s]=null:a[pC(yie(s,c))]=pC(Kb(s,c+1))}}),a}function N9e(n,a){return js(n[a])?n[a]():null}function x9e(n,a){var s=n||qc;return El(a,function(c,u){s+="; "+c+(ic(u)?qc:"="+u)}),s}function cmi(n){var a=qc;if(!rM&&obe(),rM.v){var s=rM.v[ibe]||qc;k9e!==s&&(R9e=O9e(s),k9e=s),a=pC(R9e[n]||qc)}return a}function B9e(n,a){!rM&&obe(),rM.v&&(rM.v[ibe]=n+"="+a)}function dmi(n){return!(!wf(n)||!mC(n,"CPU iPhone OS 12")&&!mC(n,"iPad; CPU OS 12")&&!(mC(n,"Macintosh; Intel Mac OS X 10_14")&&mC(n,"Version/")&&mC(n,"Safari"))&&(!mC(n,"Macintosh; Intel Mac OS X 10_14")||!Mpi(n,"AppleWebKit/605.1.15 (KHTML, like Gecko)"))&&!mC(n,"Chrome/5")&&!mC(n,"Chrome/6")&&(!mC(n,"UnrealEngine")||mC(n,"Chrome"))&&!mC(n,"UCBrowser/12")&&!mC(n,"UCBrowser/11"))}var umi={perfEvtsSendAll:!1};function hmi(n){n.h=null;var a=n.cb;n.cb=[],Ra(a,function(s){zS(s.fn,[s.arg])})}function BN(n,a,s,c){Ra(n,function(u){u&&u[a]&&(s?(s.cb[hu]({fn:c,arg:u}),s.h=s.h||KD(hmi,0,s)):zS(c,[u]))})}var hne=function(){function n(a){var s,c;this.listeners=[];var u=[],m={h:null,cb:[]},b=Qb(a,umi);c=b[LN](function(_){s=!!_.cfg.perfEvtsSendAll}),Ec(n,this,function(_){Fc(_,"listeners",{g:function(){return u}}),_[Fie]=function(k){u[hu](k)},_[Bie]=function(k){for(var N=Rv(u,k);N>-1;)u[b9](N,1),N=Rv(u,k)},_[Kie]=function(k){BN(u,Kie,m,function(N){N[Kie](k)})},_[k9]=function(k,N){BN(u,k9,m,function(W){W[k9](k,N)})},_[Jie]=function(k,N){BN(u,Jie,N?m:null,function(W){W[Jie](k,N)})},_[nU]=function(k){k&&(!s&&k[ESe]()||BN(u,nU,null,function(N){k[ZV]?KD(function(){return N[nU](k)},0):N[nU](k)}))},_[NSe]=function(k){k&&k[Ll]&&BN(u,NSe,m,function(N){N[NSe](k)})},_[xSe]=function(k){k&&k[XV]&&BN(u,xSe,m,function(N){N[xSe](k)})},_[BSe]=function(k,N){if(k>0){var W=N||0;BN(u,BSe,m,function(ee){ee[BSe](k,W)})}},_[NN]=function(k){var N,W=function(){c&&c.rm(),c=null,u=[],m.h&&m.h[JV](),m.h=null,m.cb=[]};if(BN(u,"unload",null,function(ee){var oe=ee[NN](k);oe&&(N||(N=[]),N[hu](oe))}),N)return eL(function(ee){return _w(ogi(N),function(){W(),ee()})});W()}})}return n.__ieDyn=1,n}(),d$="ctx",sbe="ParentContextKey",B9="ChildrenContextKey",pmi=null,pne=function(){function n(a,s,c){var u,m=this;m.start=Jb(),m[Q2]=a,m[ZV]=c,m[ESe]=function(){return!1},js(s)&&Fc(m,"payload",{g:function(){return!u&&js(s)&&(u=s(),s=null),u}}),m[e$]=function(b){return b?b===n[sbe]||b===n[B9]?m[b]:(m[d$]||{})[b]:null},m[iM]=function(b,_){b&&(b===n[sbe]?(m[b]||(m[ESe]=function(){return!0}),m[b]=_):b===n[B9]?m[b]=_:(m[d$]=m[d$]||{})[b]=_)},m[ASe]=function(){var b=0,_=m[e$](n[B9]);if(Fo(_))for(var k=0;k<_[Ll];k++){var N=_[k];N&&(b+=N[YV])}m[YV]=Jb()-m.start,m.exTime=m[YV]-b,m[ASe]=function(){}}}return n.ParentContextKey="parent",n.ChildrenContextKey="childEvts",n}(),F9e=function(){function n(a){this.ctx={},Ec(n,this,function(s){s.create=function(c,u,m){return new pne(c,u,m)},s.fire=function(c){c&&(c[ASe](),a&&js(a[nU])&&a[nU](c))},s[iM]=function(c,u){c&&((s[d$]=s[d$]||{})[c]=u)},s[e$]=function(c){return(s[d$]||{})[c]}})}return n.__ieDyn=1,n}(),lbe="CoreUtils.doPerf";function fC(n,a,s,c,u){if(n){var m=n;if(m[Yie]&&(m=m[Yie]()),m){var b=void 0,_=m[e$](lbe);try{if(b=m.create(a(),c,u)){if(_&&b[iM]&&(b[iM](pne[sbe],_),_[e$]&&_[iM])){var k=_[e$](pne[B9]);k||(k=[],_[iM](pne[B9],k)),k[hu](b)}return m[iM](lbe,b),s(b)}}catch(N){b&&b[iM]&&b[iM]("exception",N)}finally{b&&m.fire(b),m[iM](lbe,_)}}}return s()}function gmi(){return pmi}function U9e(){var n=cbe();return Kb(n,0,8)+"-"+Kb(n,8,12)+"-"+Kb(n,12,16)+"-"+Kb(n,16,20)+"-"+Kb(n,20)}function cbe(){for(var n,a=["0","1","2","3","4","5","6","7","8","9","a","b","c","d","e","f"],s=qc,c=0;c<4;c++)s+=a[15&(n=M9())]+a[n>>4&15]+a[n>>8&15]+a[n>>12&15]+a[n>>16&15]+a[n>>20&15]+a[n>>24&15]+a[n>>28&15];var u=a[8+(3&M9())|0];return Cw(s,0,8)+Cw(s,9,4)+"4"+Cw(s,13,3)+u+Cw(s,16,3)+Cw(s,19,12)}var mmi="00000000000000000000000000000000",fmi="0000000000000000";function z9e(n,a,s){return!(!n||n[Ll]!==a||n===s||!n.match(/^[\da-f]*$/i))}function V9e(n){return z9e(n,32,mmi)}function $9e(n){return z9e(n,16,fmi)}var vmi=h9e("plugin");function sU(n){return vmi.get(n,"state",{},!0)}function H9e(n,a){for(var s,c=[],u=null,m=n[tM]();m;){var b=m[C9]();if(b){u&&u[E9]&&b[aM]&&u[E9](b);var _=!!(s=sU(b))[eM];b[eM]&&(_=b[eM]()),_||c[hu](b),u=b,m=m[tM]()}}Ra(c,function(k){var N=n[Rf]();k[T9](n.getCfg(),N,a,n[tM]()),s=sU(k),k[Rf]||s[Rf]||(s[Rf]=N),s[eM]=!0,delete s[YD]})}function dbe(n){return n.sort(function(a,s){var c=0;if(s){var u=s[aM];a[aM]?c=u?a[Wie]-s[Wie]:1:u&&(c=-1)}else c=a?1:-1;return c})}function ymi(n){var a={};return{getName:function(){return a[Q2]},setName:function(s){a[Q2]=s},getTraceId:function(){return a[MGe]},setTraceId:function(s){V9e(s)&&(a[MGe]=s)},getSpanId:function(){return a[PGe]},setSpanId:function(s){$9e(s)&&(a[PGe]=s)},getTraceFlags:function(){return a[DGe]},setTraceFlags:function(s){a[DGe]=s}}}var j9e,Smi="TelemetryPluginChain",G9e="_hasRun",q9e="_getTelCtx",W9e=0;function bmi(n,a,s){for(;n;){if(n[C9]()===s)return n;n=n[tM]()}return cU([s],a.config||{},a)}function ube(n,a,s,c){var u=null,m=[];a||(a=Qb({},null,s[Hg])),c!==null&&(u=c?bmi(n,s,c):n);var b={_next:k,ctx:{core:function(){return s},diagLog:function(){return tbe(s,a.cfg)},getCfg:function(){return a.cfg},getExtCfg:W,getConfig:ee,hasNext:function(){return!!u},getNext:function(){return u},setNext:function(de){u=de},iterate:oe,onComplete:_}};function _(de,se){for(var Re=[],ue=2;ue<arguments.length;ue++)Re[ue-2]=arguments[ue];de&&m[hu]({func:de,self:_c(se)?b.ctx:se,args:Re})}function k(){var de=u;if(u=de?de[tM]():null,!de){var se=m;se&&se[Ll]>0&&(Ra(se,function(Re){try{Re.func.call(Re.self,Re.args)}catch(ue){ud(s[Hg],2,73,"Unexpected Exception during onComplete - "+Gs(ue))}}),m=[])}return de}function N(de,se){var Re=null,ue=a.cfg;if(ue&&de){var Ne=ue[i$];!Ne&&se&&(Ne={}),ue[i$]=Ne,(Ne=a.ref(ue,i$))&&(!(Re=Ne[de])&&se&&(Re={}),Ne[de]=Re,Re=a.ref(Ne,de))}return Re}function W(de,se){var Re=N(de,!0);return se&&El(se,function(ue,Ne){if(ic(Re[ue])){var ze=a.cfg[ue];!ze&&ic(ze)||(Re[ue]=ze)}JSe(a,Re,ue,Ne)}),a[KV](Re,se)}function ee(de,se,Re){var ue;Re===void 0&&(Re=!1);var Ne=N(de,!1),ze=a.cfg;return!Ne||!Ne[se]&&ic(Ne[se])?!ze[se]&&ic(ze[se])||(ue=ze[se]):ue=Ne[se],ue||!ic(ue)?ue:Re}function oe(de){for(var se;se=b._next();){var Re=se[C9]();Re&&de(Re)}}return b}function lU(n,a,s,c){var u=Qb(a),m=ube(n,u,s,c),b=m.ctx;function _(N){var W=m._next();return W&&W[aM](N,b),!W}function k(N,W){return N===void 0&&(N=null),Fo(N)&&(N=cU(N,u.cfg,s,W)),lU(N||b[tM](),u.cfg,s,W)}return b[Yb]=_,b[Z2]=k,b}function gne(n,a,s){var c=Qb(a.config),u=ube(n,c,a,s),m=u.ctx;function b(k){var N=u._next();return N&&N[NN](m,k),!N}function _(k,N){return k===void 0&&(k=null),Fo(k)&&(k=cU(k,c.cfg,a,N)),gne(k||m[tM](),a,N)}return m[Yb]=b,m[Z2]=_,m}function hbe(n,a,s){var c=Qb(a.config),u=ube(n,c,a,s).ctx;function m(_){return u.iterate(function(k){js(k[_9])&&k[_9](u,_)})}function b(_,k){return _===void 0&&(_=null),Fo(_)&&(_=cU(_,c.cfg,a,k)),hbe(_||u[tM](),a,k)}return u[Yb]=m,u[Z2]=b,u}function cU(n,a,s,c){var u=null,m=!c;if(Fo(n)&&n[Ll]>0){var b=null;Ra(n,function(_){if(m||c!==_||(m=!0),m&&_&&js(_[aM])){var k=Tmi(_,a,s);u||(u=k),b&&b._setNext(k),b=k}})}return c&&!u?cU([c],a,s):u}function Tmi(n,a,s){var c,u=null,m=js(n[aM]),b=js(n[E9]),_={getPlugin:function(){return n},getNext:function(){return u},processTelemetry:W,unload:ee,update:oe,_id:c=n?n[ON]+"-"+n[Wie]+"-"+W9e++:"Unknown-0-"+W9e++,_setNext:function(de){u=de}};function k(){var de;return n&&js(n[q9e])&&(de=n[q9e]()),de||(de=lU(_,a,s)),de}function N(de,se,Re,ue,Ne){var ze=!1,He=n?n[ON]:Smi,be=de[G9e];return be||(be=de[G9e]={}),de.setNext(u),n&&fC(de[Rf](),function(){return He+":"+Re},function(){be[c]=!0;try{var Ee=u?u._id:qc;Ee&&(be[Ee]=!1),ze=se(de)}catch(Qe){var Pe=!u||be[u._id];Pe&&(ze=!0),u&&Pe||ud(de[QD](),1,73,"Plugin ["+He+"] failed during "+Re+" - "+Gs(Qe)+", run flags: "+Gs(be))}},ue,Ne),ze}function W(de,se){function Re(ue){if(!n||!m)return!1;var Ne=sU(n);return!Ne[YD]&&!Ne[OSe]&&(b&&n[E9](u),n[aM](de,ue),!0)}N(se=se||k(),Re,"processTelemetry",function(){return{item:de}},!de.sync)||se[Yb](de)}function ee(de,se){function Re(){var ue=!1;if(n){var Ne=sU(n),ze=n[Rf]||Ne[Rf];!n||ze&&ze!==de.core()||Ne[YD]||(Ne[Rf]=null,Ne[YD]=!0,Ne[eM]=!1,n[YD]&&n[YD](de,se)===!0&&(ue=!0))}return ue}N(de,Re,"unload",function(){},se[ZV])||de[Yb](se)}function oe(de,se){function Re(){var ue=!1;if(n){var Ne=sU(n),ze=n[Rf]||Ne[Rf];!n||ze&&ze!==de.core()||Ne[YD]||n[_9]&&n[_9](de,se)===!0&&(ue=!0)}return ue}N(de,Re,"update",function(){},!1)||de[Yb](se)}return MN(_)}function K9e(){var n=[];function a(c){c&&n[hu](c)}function s(c,u){Ra(n,function(m){try{m(c,u)}catch(b){ud(c[QD](),2,73,"Unexpected error calling unload handler - "+Gs(b))}}),n=[]}return{add:a,run:s}}function J9e(){var n=[];function a(c){var u=n;n=[],Ra(u,function(m){try{(m.rm||m.remove).call(m)}catch(b){ud(c,2,73,"Unloading:"+Gs(b))}})}function s(c){c&&XR(n,c)}return{run:a,add:s}}var FN="getPlugin",Cmi=((j9e={})[i$]={isVal:zSe,v:{}},j9e),mne=function(){function n(){var a,s,c,u,m,b=this;function _(W){W===void 0&&(W=null);var ee=W;if(!ee){var oe=s||lU(null,{},b[Rf]);ee=c&&c[FN]?oe[Z2](null,c[FN]):oe[Z2](null,c)}return ee}function k(W,ee,oe){Qb(W,Cmi,tbe(ee)),!oe&&ee&&(oe=ee[TGe]()[tM]());var de=c;c&&c[FN]&&(de=c[FN]()),b[Rf]=ee,s=lU(oe,W,ee,de)}function N(){a=!1,b[Rf]=null,s=null,c=null,m=J9e(),u=K9e()}N(),Ec(n,b,function(W){W[T9]=function(ee,oe,de,se){k(ee,oe,se),a=!0},W[YD]=function(ee,oe){var de,se=W[Rf];if(se&&(!ee||se===ee[Rf]())){var Re,ue=!1,Ne=ee||gne(null,se,c&&c[FN]?c[FN]():c),ze=oe||((de={reason:0})[ZV]=!1,de);return W[$ie]&&W[$ie](Ne,ze,He)===!0?Re=!0:He(),Re}function He(){ue||(ue=!0,u.run(Ne,oe),m.run(Ne[QD]()),Re===!0&&Ne[Yb](ze),N())}},W[_9]=function(ee,oe){var de=W[Rf];if(de&&(!ee||de===ee[Rf]())){var se,Re=!1,ue=ee||hbe(null,de,c&&c[FN]?c[FN]():c),Ne=oe||{reason:0};return W._doUpdate&&W._doUpdate(ue,Ne,ze)===!0?se=!0:ze(),se}function ze(){Re||(Re=!0,k(ue.getCfg(),ue.core(),ue[tM]()))}},Qie(W,"_addUnloadCb",function(){return u},"add"),Qie(W,"_addHook",function(){return m},"add"),Fc(W,"_unloadHooks",{g:function(){return m}})}),b[QD]=function(W){return _(W)[QD]()},b[eM]=function(){return a},b.setInitialized=function(W){a=W},b[E9]=function(W){c=W},b[Yb]=function(W,ee){ee?ee[Yb](W):c&&js(c[aM])&&c[aM](W,null)},b._getTelCtx=_}return n.__ieDyn=1,n}();function _mi(n,a,s){var c={id:a,fn:s};return XR(n,c),{remove:function(){Ra(n,function(u,m){if(u.id===c.id)return n[b9](m,1),-1})}}}function Emi(n,a,s){for(var c=!1,u=n[Ll],m=0;m<u;++m){var b=n[m];if(b)try{if(b.fn[xie](null,[a])===!1){c=!0;break}}catch(_){ud(s,2,64,"Telemetry initializer failed: "+GGe(_),{exception:Gs(_)},!0)}}return!c}var dU,Ami=function(n){function a(){var s,c,u=n.call(this)||this;function m(){s=0,c=[]}return u.identifier="TelemetryInitializerPlugin",u.priority=199,m(),Ec(a,u,function(b,_){b.addTelemetryInitializer=function(k){return _mi(c,s++,k)},b[aM]=function(k,N){Emi(c,k,N?N[QD]():b[QD]())&&b[Yb](k,N)},b[$ie]=function(){m()}}),u}return VS(a,n),a.__ieDyn=1,a}(mne),Y9e="Plugins must provide initialize method",Imi="_notificationManager",Q9e="SDK is still unloading...",wmi="SDK is not initialized",pbe=jD(((dU={cookieCfg:{}})[n$]={rdOnly:!0,ref:!0,v:[]},dU[iU]={rdOnly:!0,ref:!0,v:[]},dU[i$]={ref:!0,v:{}},dU[LSe]=nM,dU.loggingLevelConsole=0,dU.diagnosticLogInterval=nM,dU));function kmi(n,a){return new F9e(a)}function Rmi(n,a,s){var c,u=[],m=[],b={};return Ra(s,function(_){(ic(_)||ic(_[T9]))&&Tw(Y9e);var k=_[Wie],N=_[ON];_&&k&&(ic(b[k])?b[k]=N:x9(n,"Two extensions have same priority #"+k+" - "+b[k]+", "+N)),!k||k<a?u[hu](_):m[hu](_)}),(c={})[Rf]=u,c[iU]=m,c}function Z9e(n,a){var s=!1;return Ra(a,function(c){if(c===n)return s=!0,-1}),s}function gbe(n,a,s,c){s&&El(s,function(u,m){c&&kf(m)&&kf(a[u])&&gbe(n,a[u],m,c),c&&kf(m)&&kf(a[u])?gbe(n,a[u],m,c):n.set(a,u,m)})}function X9e(n,a){var s=null,c=-1;return Ra(n,function(u,m){if(u.w===a)return s=u,c=m,-1}),{i:c,l:s}}function Mmi(n,a){var s=X9e(n,a).l;return s||(s={w:a,rm:function(){var c=X9e(n,a);c.i!==-1&&n[b9](c.i,1)}},n[hu](s)),s}function Pmi(n,a,s){Ra(a,function(c){var u=Mf(n,c.w,s);delete c.w,c.rm=function(){u.rm()}})}function Dmi(n,a,s,c){return a.add(n[LN](function(u){var m=u.cfg.disableDbgExt;m===!0&&c&&(s[Bie](c),c=null),s&&!c&&m!==!0&&(c=emi(u.cfg),s[Fie](c))})),c}function Lmi(n){return Fc({rm:function(){n.rm()}},"toJSON",{v:function(){return"aicore::onCfgChange<"+JSON.stringify(n)+">"}})}var Omi=function(){function n(){var a,s,c,u,m,b,_,k,N,W,ee,oe,de,se,Re,ue,Ne,ze,He,be,Ee,Pe,Qe,Ze,Xe,bt,Ot,Yt;Ec(n,this,function(pt){function Lt(Ji){return bt&&bt[QV]||Yt||(Ji||c&&c.queue[Ll]>0)&&(Ot||(Ot=!0,ir(a[LN](function(pa){var Ca=pa.cfg.diagnosticLogInterval;Ca&&Ca>0||(Ca=1e4);var da=!1;bt&&(da=bt[QV],bt[JV]()),(bt=xpi(Ea,Ca)).unref(),bt[QV]=da}))),bt[QV]=!0),bt}function xt(){var Ji={};Ze=[];var pa=function(Ca){Ca&&Ra(Ca,function(da){if(da[ON]&&da[_Ge]&&!Ji[da.identifier]){var Wn=da[ON]+"="+da[_Ge];Ze[hu](Wn),Ji[da.identifier]=da}})};pa(oe),ee&&Ra(ee,function(Ca){pa(Ca)}),pa(W)}function yi(){s=!1,(a=Qb({},pbe,pt[Hg])).cfg[EGe]=1,Fc(pt,"config",{g:function(){return a.cfg},s:function(pa){pt.updateCfg(pa,!1)}}),Fc(pt,"pluginVersionStringArr",{g:function(){return Ze||xt(),Ze}}),Fc(pt,"pluginVersionString",{g:function(){return Xe||(Ze||xt(),Xe=Ze.join(";")),Xe||qc}}),Fc(pt,"logger",{g:function(){return c||(c=new l$(a.cfg),a[Hg]=c),c},s:function(pa){a[Hg]=pa,c!==pa&&(O9(c,!1),c=pa)}}),pt[Hg]=new l$(a.cfg),Qe=[];var Ji=pt.config[n$]||[];Ji.splice(0,Ji[Ll]),XR(Ji,Qe),se=new Ami,u=[],O9(m,!1),m=null,b=null,_=null,O9(k,!1),k=null,N=null,W=[],ee=null,oe=null,de=!1,Re=null,ue=s$("AIBaseCore",!0),Ne=K9e(),be=null,Ee=null,ze=J9e(),Pe=[],Xe=null,Ze=null,Yt=!1,bt=null,Ot=!1}function Li(){var Ji=lU(ji(),a.cfg,pt);return Ji[zie](Lt),Ji}function cn(Ji){var pa=Rmi(pt[Hg],Qgi,W);N=null,Xe=null,Ze=null,oe=dbe(XR(oe=(ee||[])[0]||[],pa[iU]));var Ca=XR(dbe(pa[Rf]),oe);Qe=MN(Ca);var da=pt.config[n$]||[];da.splice(0,da[Ll]),XR(da,Qe);var Wn=Li();oe&&oe[Ll]>0&&H9e(Wn[Z2](oe),Ca),H9e(Wn,Ca),Ji&&vs(Ji)}function Ci(Ji){var pa=null,Ca=null,da=[];return Ra(Qe,function(Wn){if(Wn[ON]===Ji&&Wn!==se)return Ca=Wn,-1;Wn.getChannel&&da[hu](Wn)}),!Ca&&da[Ll]>0&&Ra(da,function(Wn){if(!(Ca=Wn.getChannel(Ji)))return-1}),Ca&&(pa={plugin:Ca,setEnabled:function(Wn){sU(Ca)[OSe]=!Wn},isEnabled:function(){var Wn=sU(Ca);return!Wn[YD]&&!Wn[OSe]},remove:function(Wn,co){var eo;Wn===void 0&&(Wn=!0);var Uo=[Ca],Zo=((eo={reason:1})[ZV]=Wn,eo);An(Uo,Zo,function(oo){oo&&cn({reason:32,removed:Uo}),co&&co(oo)})}}),pa}function ji(){if(!N){var Ji=(Qe||[]).slice();Rv(Ji,se)===-1&&Ji[hu](se),N=cU(dbe(Ji),a.cfg,pt)}return N}function An(Ji,pa,Ca){if(Ji&&Ji[Ll]>0){var da=gne(cU(Ji,a.cfg,pt),pt);da[zie](function(){var Wn=!1,co=[];Ra(W,function(Uo,Zo){Z9e(Uo,Ji)?Wn=!0:co[hu](Uo)}),W=co,Xe=null,Ze=null;var eo=[];ee&&(Ra(ee,function(Uo,Zo){var oo=[];Ra(Uo,function(Xu){Z9e(Xu,Ji)?Wn=!0:oo[hu](Xu)}),eo[hu](oo)}),ee=eo),Ca&&Ca(Wn),Lt()}),da[Yb](pa)}else Ca(!1)}function Ea(){if(c&&c.queue){var Ji=c.queue.slice(0);c.queue[Ll]=0,Ra(Ji,function(pa){var Ca,da=((Ca={})[Q2]=Re||"InternalMessageId: "+pa[Vie],Ca.iKey=Ee,Ca[YV]=$Se(new Date),Ca.baseType=ebe.dataType,Ca.baseData={message:pa[X2]},Ca);pt.track(da)})}}function Ln(Ji,pa,Ca,da){var Wn=1,co=!1,eo=null;function Uo(){Wn--,co&&Wn===0&&(eo&&eo[JV](),eo=null,pa&&pa(co),pa=null)}return da=da||5e3,oe&&oe[Ll]>0&&Li()[Z2](oe).iterate(function(Zo){if(Zo.flush){Wn++;var oo=!1;Zo.flush(Ji,function(){oo=!0,Uo()},Ca)||oo||(Ji&&eo==null?eo=KD(function(){eo=null,Uo()},da):Uo())}}),co=!0,Uo(),!0}function ga(){var Ji;ir(a[LN](function(pa){if(pa.cfg.enablePerfMgr){var Ca=pa.cfg[LSe];Ji!==Ca&&(Ca||(Ca=kmi),ggi(pa.cfg,LSe,Ca),Ji=Ca,_=null),b||_||!js(Ca)||(_=Ca(pt,pt[Uie]()))}else _=null,Ji=null}))}function vs(Ji){var pa=hbe(ji(),pt);pa[zie](Lt),pt._updateHook&&pt._updateHook(pa,Ji)===!0||pa[Yb](Ji)}function ss(Ji){var pa=pt[Hg];pa?(ud(pa,2,73,Ji),Lt()):Tw(Ji)}function Ya(Ji){var pa=pt[Uie]();pa&&pa[k9]([Ji],2)}function ir(Ji){ze.add(Ji)}yi(),pt._getDbgPlgTargets=function(){return[Qe]},pt[eM]=function(){return s},pt[T9]=function(Ji,pa,Ca,da){de&&Tw(Q9e),pt[eM]()&&Tw("Core cannot be initialized more than once"),Ji=(a=Qb(Ji,pbe,Ca||pt[Hg],!1)).cfg,ir(a[LN](function(eo){Ee=eo.cfg.instrumentationKey;var Uo=eo.ref(eo.cfg,i$);El(Uo,function(Zo){eo.ref(Uo,Zo)}),ic(Ee)&&Tw("Please provide instrumentation key")})),He=Dmi(a,ze,(m=da)&&pt[Uie](),He),ga(),pt[Hg]=Ca;var Wn=Ji[n$];if((W=[])[hu].apply(W,pGe(pGe([],pa,!1),Wn)),ee=Ji[iU],cn(null),oe&&oe[Ll]!==0||Tw("No "+iU+" available"),ee&&ee[Ll]>1){var co=pt[C9]("TeeChannelController");co&&co.plugin||ud(c,1,28,"TeeChannel required")}Pmi(Ji,Pe,c),Pe=null,s=!0,pt.releaseQueue(),pt[bGe]()},pt.getChannels=function(){var Ji=[];return oe&&Ra(oe,function(pa){Ji[hu](pa)}),MN(Ji)},pt.track=function(Ji){fC(pt[Yie](),function(){return"AppInsightsCore:track"},function(){Ji===null&&(Ya(Ji),Tw("Invalid telemetry item")),!Ji[Q2]&&ic(Ji[Q2])&&(Ya(Ji),Tw("telemetry name required")),Ji.iKey=Ji.iKey||Ee,Ji[YV]=Ji[YV]||$Se(new Date),Ji.ver=Ji.ver||"4.0",!de&&pt[eM]()?Li()[Yb](Ji):u[hu](Ji)},function(){return{item:Ji}},!Ji.sync)},pt[TGe]=Li,pt[Uie]=function(){return m||(m=new hne(a.cfg),pt[Imi]=m),m},pt[Fie]=function(Ji){pt.getNotifyMgr()[Fie](Ji)},pt[Bie]=function(Ji){m&&m[Bie](Ji)},pt.getCookieMgr=function(){return k||(k=une(a.cfg,pt[Hg])),k},pt.setCookieMgr=function(Ji){k!==Ji&&(O9(k,!1),k=Ji)},pt[Yie]=function(){return b||_||gmi()},pt.setPerfMgr=function(Ji){b=Ji},pt.eventCnt=function(){return u[Ll]},pt.releaseQueue=function(){if(s&&u[Ll]>0){var Ji=u;u=[],Ra(Ji,function(pa){Li()[Yb](pa)})}},pt[bGe]=function(Ji){return Re=Ji||null,Yt=!1,bt&&bt[JV](),Lt(!0)},pt[CGe]=function(){Yt=!0,bt&&bt[JV](),Ea()},qGe(pt,function(){return se},["addTelemetryInitializer"]),pt[NN]=function(Ji,pa,Ca){var da;Ji===void 0&&(Ji=!0),s||Tw(wmi),de&&Tw(Q9e);var Wn,co=((da={reason:50})[ZV]=Ji,da.flushComplete=!1,da);Ji&&!pa&&(Wn=eL(function(Zo){pa=Zo}));var eo=gne(ji(),pt);function Uo(Zo){co.flushComplete=Zo,de=!0,Ne.run(eo,co),pt[CGe](),eo[Yb](co)}return eo[zie](function(){ze.run(pt[Hg]),y9e([k,m,c],Ji,function(){yi(),pa&&pa(co)})},pt),Ea(),Ln(Ji,Uo,6,Ca),Wn},pt[C9]=Ci,pt.addPlugin=function(Ji,pa,Ca,da){if(!Ji)return da&&da(!1),void ss(Y9e);var Wn=Ci(Ji[ON]);if(Wn&&!pa)return da&&da(!1),void ss("Plugin ["+Ji[ON]+"] is already loaded!");var co={reason:16};function eo(Zo){W[hu](Ji),co.added=[Ji],cn(co),da&&da(!0)}if(Wn){var Uo=[Wn.plugin];An(Uo,{reason:2,isAsync:!!Ca},function(Zo){Zo?(co.removed=Uo,co.reason|=32,eo()):da&&da(!1)})}else eo()},pt.updateCfg=function(Ji,pa){var Ca;if(pa===void 0&&(pa=!0),pt[eM]()){Ca={reason:1,cfg:a.cfg,oldCfg:dGe({},a.cfg),newConfig:dGe({},Ji),merge:pa},Ji=Ca.newConfig;var da=a.cfg;Ji[n$]=da[n$],Ji[iU]=da[iU]}a._block(function(Wn){var co=Wn.cfg;gbe(Wn,co,Ji,pa),pa||El(co,function(eo){nE(Ji,eo)||Wn.set(co,eo,nM)}),Wn[KV](co,pbe)},!0),a[Oie](),Ca&&vs(Ca)},pt.evtNamespace=function(){return ue},pt.flush=Ln,pt.getTraceCtx=function(Ji){return be||(be=ymi()),be},pt.setTraceCtx=function(Ji){be=Ji||null},pt.addUnloadHook=ir,Qie(pt,"addUnloadCb",function(){return Ne},"add"),pt.onCfgChange=function(Ji){return Lmi(s?Mf(a.cfg,Ji,pt[Hg]):Mmi(Pe,Ji))},pt.getWParam=function(){return iGe()||a.cfg.enableWParam?0:-1}})}return n.__ieDyn=1,n}(),oM="",eqe="&NoResponseBody=true",mbe="POST",Nmi=function(){function n(){var a,s,c,u,m,b,_,k,N,W,ee,oe,de,se=0;Ec(n,this,function(Re,ue){var Ne=!0;function ze(pt,Lt){Pe(Lt,200,{},pt)}function He(pt,Lt){ud(c,2,26,"Failed to send telemetry.",{message:pt}),Pe(Lt,400,{})}function be(pt){He("No endpoint url is provided for the batch",pt)}function Ee(pt,Lt){for(var xt,yi=0,Li=null,cn=0;Li==null&&cn<pt[Ll];)yi=pt[cn],k||yi!==1?yi!==2||!a9e(Lt)||Lt&&ee?yi!==3||!n9e()||(Lt?W:N)||(Li=Ze):Li=bt:Ngi()?Li=Ot:r9e()&&(Li=Xe),cn++;return Li?((xt={_transport:yi,_isSync:Lt})[kGe]=Li,xt):null}function Pe(pt,Lt,xt,yi){try{pt&&pt(Lt,xt,yi)}catch{}}function Qe(pt,Lt){var xt=QR(),yi=pt[I9];if(!yi)return be(Lt),!0;yi=pt[I9]+(oe?eqe:oM);var Li=pt[XV],cn=u?Li:new Blob([Li],{type:"text/plain;charset=UTF-8"});return xt.sendBeacon(yi,cn)}function Ze(pt,Lt,xt){var yi=pt[XV];try{if(yi)if(Qe(pt,Lt))ze(oM,Lt);else{var Li=m&&m.beaconOnRetry;Li&&js(Li)?Li(pt,Lt,Qe):(_&&_[kGe](pt,Lt,!0),ud(c,2,40,". Failed to send telemetry with Beacon API, retried with normal sender."))}}catch(cn){u&&x9(c,"Failed to send telemetry using sendBeacon API. Ex:"+Gs(cn)),Pe(Lt,u?0:400,{},oM)}}function Xe(pt,Lt,xt){var yi,Li,cn,Ci=pt[ISe]||{};!xt&&a&&(yi=eL(function(Ln,ga){Li=Ln,cn=ga})),u&&xt&&pt.disableXhrSync&&(xt=!1);var ji=pt[I9];if(!ji)return be(Lt),void(Li&&Li(!1));var An=Sgi(mbe,ji,Ne,!0,xt,pt[t$]);function Ea(Ln){var ga=m&&m.xhrOnComplete;if(ga&&js(ga))ga(Ln,Lt,pt);else{var vs=o$(Ln);Pe(Lt,Ln[A9],Zie(Ln,u),vs)}}return u||An[RGe]("Content-type","application/json"),Ra(hC(Ci),function(Ln){An[RGe](Ln,Ci[Ln])}),An.onreadystatechange=function(){u||(Ea(An),An.readyState===4&&Li&&Li(!0))},An.onload=function(){u&&Ea(An)},An.onerror=function(Ln){Pe(Lt,u?An[A9]:400,Zie(An,u),u?oM:KGe(An)),cn&&cn(Ln)},An.ontimeout=function(){Pe(Lt,u?An[A9]:500,Zie(An,u),u?oM:KGe(An)),Li&&Li(!1)},An.send(pt[XV]),yi}function bt(pt,Lt,xt){var yi,Li,cn,Ci,ji=pt[I9],An=pt[XV],Ea=u?An:new Blob([An],{type:"application/json"}),Ln=new Headers,ga=An[Ll],vs=!1,ss=!1,Ya=pt[ISe]||{},ir=((yi={method:mbe,body:Ea})[S9e]=!0,yi);pt.headers&&hC(pt.headers)[Ll]>0&&(Ra(hC(Ya),function(da){Ln.append(da,Ya[da])}),ir[ISe]=Ln),Ne&&u&&(ir.credentials="include"),xt&&(ir.keepalive=!0,se+=ga,u?pt._sendReason===2&&(vs=!0,oe&&(ji+=eqe)):vs=!0);var Ji=new Request(ji,ir);try{Ji[S9e]=!0}catch{}if(!xt&&a&&(Li=eL(function(da,Wn){cn=da,Ci=Wn})),!ji)return be(Lt),void(cn&&cn(!1));function pa(da){Pe(Lt,u?0:400,{},u?oM:da)}function Ca(da,Wn,co){var eo=da[A9],Uo=m.fetchOnComplete;Uo&&js(Uo)?Uo(da,Lt,co||oM,Wn):Pe(Lt,eo,{},co||oM)}try{_w(fetch(u?ji:Ji,u?ir:null),function(da){if(xt&&(se-=ga,ga=0),!ss)if(ss=!0,da.rejected)pa(da.reason&&da.reason[X2]),Ci&&Ci(da.reason);else{var Wn=da.value;try{u||Wn.ok?u&&!Wn.body?(Ca(Wn,null,oM),cn&&cn(!0)):_w(Wn.text(),function(co){Ca(Wn,pt,co.value),cn&&cn(!0)}):(pa(Wn.statusText),cn&&cn(!1))}catch(co){pa(Gs(co)),Ci&&Ci(co)}}})}catch(da){ss||(pa(Gs(da)),Ci&&Ci(da))}return vs&&!ss&&(ss=!0,Pe(Lt,200,{}),cn&&cn(!0)),u&&!ss&&pt[t$]>0&&de&&de.set(function(){ss||(ss=!0,Pe(Lt,500,{}),cn&&cn(!0))},pt[t$]),Li}function Ot(pt,Lt,xt){var yi=qD(),Li=new XDomainRequest,cn=pt[XV];Li.onload=function(){var Ln=o$(Li),ga=m&&m.xdrOnComplete;ga&&js(ga)?ga(Li,Lt,pt):Pe(Lt,200,{},Ln)},Li.onerror=function(){Pe(Lt,400,{},u?oM:fgi(Li))},Li.ontimeout=function(){Pe(Lt,500,{})},Li.onprogress=function(){};var Ci=yi&&yi.location&&yi.location[AGe]||"",ji=pt[I9];if(ji){if(!u&&ji.lastIndexOf(Ci,0)!==0){var An="Cannot send XDomain request. The endpoint URL protocol doesn't match the hosting page protocol.";return ud(c,2,40,". "+An),void He(An,Lt)}var Ea=u?ji:ji[eU](/^(https?:)/,"");Li.open(mbe,Ea),pt[t$]&&(Li[t$]=pt[t$]),Li.send(cn),u&&xt?de&&de.set(function(){Li.send(cn)},0):Li.send(cn)}else be(Lt)}function Yt(){se=0,s=!1,a=!1,c=null,u=null,m=null,b=null,_=null,k=!1,N=!1,W=!1,ee=!1,oe=!1,de=null}Yt(),Re[T9]=function(pt,Lt){c=Lt,s&&ud(c,1,28,"Sender is already initialized"),Re.SetConfig(pt),s=!0},Re._getDbgPlgTargets=function(){return[s,u,b,a]},Re.SetConfig=function(pt){try{if(m=pt.senderOnCompleteCallBack||{},b=!!pt.disableCredentials,u=!!pt.isOneDs,a=!!pt.enableSendPromise,k=!!pt.disableXhr,N=!!pt.disableBeacon,W=!!pt.disableBeaconSync,de=pt.timeWrapper,oe=!!pt.addNoResponse,ee=!!pt.disableFetchKeepAlive,_={sendPOST:Xe},u||(Ne=!1),b){var Lt=Xie();Lt&&Lt.protocol&&Lt.protocol[bSe]()==="file:"&&(Ne=!1)}return!0}catch{}return!1},Re.getSyncFetchPayload=function(){return se},Re.getSenderInst=function(pt,Lt){return pt&&pt[Ll]?Ee(pt,Lt):null},Re.getFallbackInst=function(){return _},Re[$ie]=function(pt,Lt){Yt()}})}return n.__ieDyn=1,n}(),tqe="on",iqe="attachEvent",nqe="addEventListener",aqe="detachEvent",rqe="removeEventListener",fbe="events",F9="visibilitychange",fne="pagehide",oqe="pageshow",sqe="unload",lqe="beforeunload",cqe=s$("aiEvtPageHide"),dqe=s$("aiEvtPageShow"),xmi=/\.[\.]+/g,Bmi=/[\.]+$/,Fmi=1,vne=h9e("events"),Umi=/^([^.]*)(?:\.(.+)|)/;function uqe(n){return n&&n[eU]?n[eU](/^[\s\.]+|(?=[\s\.])[\.\s]+$/g,qc):n}function vbe(n,a){var s;if(a){var c=qc;Fo(a)?(c=qc,Ra(a,function(m){(m=uqe(m))&&(m[0]!=="."&&(m="."+m),c+=m)})):c=uqe(a),c&&(c[0]!=="."&&(c="."+c),n=(n||qc)+c)}var u=Umi.exec(n||qc)||[];return(s={})[ZD]=u[1],s.ns=(u[2]||qc).replace(xmi,".").replace(Bmi,qc)[Hie](".").sort().join("."),s}function hqe(n,a,s){s===void 0&&(s=!0);var c=vne.get(n,fbe,{},s),u=c[a];return u||(u=c[a]=[]),u}function pqe(n,a,s,c){n&&a&&a[ZD]&&(n[rqe]?n[rqe](a[ZD],s,c):n[aqe]&&n[aqe](tqe+a[ZD],s))}function zmi(n,a,s,c){var u=!1;return n&&a&&a[ZD]&&s&&(n[nqe]?(n[nqe](a[ZD],s,c),u=!0):n[iqe]&&(n[iqe](tqe+a[ZD],s),u=!0)),u}function gqe(n,a,s,c){for(var u=a[Ll];u--;){var m=a[u];m&&(s.ns&&s.ns!==m.evtName.ns||c&&!c(m)||(pqe(n,m.evtName,m[_Se],m.capture),a[b9](u,1)))}}function Vmi(n,a,s){if(a[ZD])gqe(n,hqe(n,a[ZD]),a,s);else{var c=vne.get(n,fbe,{});El(c,function(u,m){gqe(n,m,a,s)}),hC(c)[Ll]===0&&vne.kill(n,fbe)}}function U9(n,a){return a?vbe("xx",Fo(a)?[n].concat(a):[n,a]).ns[Hie]("."):n}function ybe(n,a,s,c,u){var m;u===void 0&&(u=!1);var b=!1;if(n)try{var _=vbe(a,c);if((b=zmi(n,_,s,u))&&vne.accept(n)){var k=((m={guid:Fmi++,evtName:_})[_Se]=s,m.capture=u,m);hqe(n,_.type)[hu](k)}}catch{}return b}function Sbe(n,a,s,c,u){if(u===void 0&&(u=!1),n)try{var m=vbe(a,c),b=!1;Vmi(n,m,function(_){return!((!m.ns||s)&&_[_Se]!==s||(b=!0,0))}),b||pqe(n,m,s,u)}catch{}}function $mi(n,a,s){var c=!1,u=qD();u&&(c=ybe(u,n,a,s),c=ybe(u.body,n,a,s)||c);var m=GD();return m&&(c=ybe(m,n,a,s)||c),c}function Hmi(n,a,s){var c=qD();c&&(Sbe(c,n,a,s),Sbe(c.body,n,a,s));var u=GD();u&&Sbe(u,n,a,s)}function u$(n,a,s,c){var u=!1;return a&&n&&n[Ll]>0&&Ra(n,function(m){m&&(s&&Rv(s,m)!==-1||(u=$mi(m,a,c)||u))}),u}function jmi(n,a,s,c){var u=!1;return a&&n&&Fo(n)&&!(u=u$(n,a,s,c))&&s&&s[Ll]>0&&(u=u$(n,a,null,c)),u}function z9(n,a,s){n&&Fo(n)&&Ra(n,function(c){c&&Hmi(c,a,s)})}function Gmi(n,a,s){return jmi([lqe,sqe,fne],n,a,s)}function qmi(n,a){z9([lqe,sqe,fne],n,a)}function mqe(n,a,s){function c(b){var _=GD();n&&_&&_.visibilityState==="hidden"&&n(b)}var u=U9(cqe,s),m=u$([fne],n,a,u);return a&&Rv(a,F9)!==-1||(m=u$([F9],c,a,u)||m),!m&&a&&(m=mqe(n,null,s)),m}function Wmi(n,a){var s=U9(cqe,a);z9([fne],n,s),z9([F9],null,s)}function fqe(n,a,s){function c(b){var _=GD();n&&_&&_.visibilityState==="visible"&&n(b)}var u=U9(dqe,s),m=u$([oqe],n,a,u);return!(m=u$([F9],c,a,u)||m)&&a&&(m=fqe(n,null,s)),m}function Kmi(n,a){var s=U9(dqe,a);z9([oqe],n,s),z9([F9],null,s)}var UN,h$="",Jmi="https://browser.events.data.microsoft.com/OneCollector/1.0/",vqe="version",bbe="properties",yqe="initialize",Sqe="logger",Ymi="indexOf",zN="timings",bqe="pollInternalLogs",oA="value",Tqe="kind",Tbe="length",Cbe="processTelemetryStart",Cqe="1DS-Web-JS-4.2.1",_qe=Fhi.hasOwnProperty,Qmi=((UN={})[0]=0,UN[2]=6,UN[1]=1,UN[3]=7,UN[4098]=6,UN[4097]=1,UN[4099]=7,UN);function VN(n){return!(n===h$||ic(n))}function Zmi(n){if(n){var a=qV(n,"-");if(a>-1)return yie(n,a)}return h$}function Xmi(n){return!!(n&&HD(n)&&n>=1&&n<=4)}function efi(n,a,s){if(!a&&!VN(a)||typeof n!="string")return null;var c=typeof a;if(c==="string"||c==="number"||c==="boolean"||Fo(a))a={value:a};else if(c!=="object"||_qe.call(a,"value")){if(ic(a[oA])||a[oA]===h$||!wf(a[oA])&&!HD(a[oA])&&!RN(a[oA])&&!Fo(a[oA]))return null}else a={value:s?JSON.stringify(a):a};if(Fo(a[oA])&&!nfi(a[oA]))return null;if(!ic(a[Tqe])){if(Fo(a[oA])||!tfi(a[Tqe]))return null;a[oA]=a[oA].toString()}return a}function Eqe(n,a,s){var c=-1;if(!_c(n))if(a>0&&(a===32?c=8192:a<=13&&(c=a<<5)),ifi(s))c===-1&&(c=0),c|=s;else{var u=Qmi[_be(n)]||-1;c!==-1&&u!==-1?c|=u:u===6&&(c=u)}return c}function uU(n,a,s){var c;return s===void 0&&(s=!0),n&&(c=n.get(a),s&&c&&decodeURIComponent&&(c=decodeURIComponent(c))),c||h$}function Aqe(n){n===void 0&&(n="D");var a=U9e();return n==="B"?a="{"+a+"}":n==="P"?a="("+a+")":n==="N"&&(a=a.replace(/-/g,h$)),a}function yne(n,a,s,c,u){var m={},b=!1,_=0,k=arguments[Tbe],N=arguments;for(RN(N[0])&&(b=N[0],_++);_<k;_++)El(N[_],function(W,ee){b&&ee&&JR(ee)?Fo(ee)?(m[W]=m[W]||[],Ra(ee,function(oe,de){m[W][de]=oe&&JR(oe)?yne(!0,m[W][de],oe):oe})):m[W]=yne(!0,m[W],ee):m[W]=ee});return m}var sM=uGe;function tfi(n){return n===0||n>0&&n<=13||n===32}function ifi(n){return n>=0&&n<=9}function nfi(n){return n[Tbe]>0}function Sne(n,a){var s=n;s[zN]=s[zN]||{},s[zN][Cbe]=s[zN][Cbe]||{},s[zN][Cbe][a]=sM()}function _be(n){var a=0;if(n!=null){var s=typeof n;s==="string"?a=1:s==="number"?a=2:s==="boolean"?a=3:s===sie&&(a=4,Fo(n)?(a=4096,n[Tbe]>0&&(a|=_be(n[0]))):_qe.call(n,"value")&&(a=8192|_be(n[oA])))}return a}function afi(){return!!Zu("chrome")}function V9(n){return n>0}var rfi=jD({endpointUrl:Jmi,propertyStorageOverride:{isVal:ofi}});function ofi(n){return!n||n.getProperty&&n.setProperty||Tw("Invalid property storage override passed."),!0}var sfi=function(n){function a(){var s=n.call(this)||this;return Ec(a,s,function(c,u){c[yqe]=function(m,b,_,k){fC(c,function(){return"AppInsightsCore.initialize"},function(){try{u[yqe](Qb(m,rfi,_||c[Sqe],!1).cfg,b,_,k)}catch(ee){var N=c[Sqe],W=Gs(ee);W[Ymi]("channels")!==-1&&(W+=`
 - Channels must be provided through config.channels only!`),ud(N,1,514,"SDK Initialization Failed - no telemetry will be sent: "+W)}},function(){return{config:m,extensions:b,logger:_,notificationManager:k}})},c.track=function(m){fC(c,function(){return"AppInsightsCore.track"},function(){var b=m;if(b){b[zN]=b[zN]||{},b[zN].trackStart=sM(),Xmi(b.latency)||(b.latency=1);var _=b.ext=b.ext||{};_.sdk=_.sdk||{},_.sdk.ver=Cqe;var k=b.baseData=b.baseData||{};k[bbe]=k[bbe]||{};var N=k[bbe];N[vqe]=N[vqe]||c.pluginVersionString||h$}u.track(b)},function(){return{item:m}},!m.sync)},c[bqe]=function(m){return u[bqe](m||"InternalLog")}}),s}return VS(a,n),a.__ieDyn=1,a}(Omi),Ebe=SSe({Normal:1,CostDeferred:2,RealTime:3,Immediate:4}),lfi=SSe({Normal:1,Critical:2}),bne="REAL_TIME",cfi="NEAR_REAL_TIME",dfi="BEST_EFFORT",$N="",Abe="drop",ufi="send",Iqe="requeue",hfi="rspFail",pfi="oth",wqe="no-cache, no-store",Ibe="application/x-json-stream",Tne="cache-control",$9="content-type",gfi="kill-tokens",mfi="kill-duration",ffi="time-delta-millis",wbe="client-version",kqe="client-id",kbe="time-delta-to-apply-millis",Rbe="upload-time",Mbe="apikey",Pbe="AuthMsaDeviceTicket",Rqe="WebAuthToken",Mqe="AuthXToken",vfi="NoResponseBody",Cne="msfpc",Pqe="trace",Dbe="user",Lbe="allowRequestSending",Dqe="firstRequestSent",Lqe="shouldAddClockSkewHeaders",Oqe="getClockSkewHeaderValue",Obe="setClockSkew",Gl="length",hU="concat",lM="iKey",Pf="count",pU="events",Zb="push",p$="split",_ne="splice",Nbe="toLowerCase",g$="hdrs",xbe="useHdrs",H9="initialize",Nqe="setTimeoutOverride",xqe="clearTimeoutOverride",yfi="payloadPreprocessor",Bqe="overrideEndpointUrl",Fqe="avoidOptions",Sfi="disableEventTimings",bfi="stringifyObjects",Bbe="enableCompoundKey",Uqe="disableXhrSync",zqe="disableFetchKeepAlive",Tfi="addNoResponse",Cfi="excludeCsMetaData",Vqe="useSendBeacon",$qe="alwaysUseXhrOverride",_fi="unloadTransports",Hqe="serializeOfflineEvt",jqe="getOfflineRequestDetails",Fbe="createPayload",Ube="createOneDSPayload",Gqe="payloadBlob",cM="headers",j9="_thePayload",qqe="urlString",vC="batches",aE="sendType",zbe="addHeader",Vbe="canSendRequest",Ene="sendQueuedRequests",Wqe="isCompletelyIdle",$be="setUnloading",Efi="isTenantKilled",Kqe="sendSynchronousBatch",Hbe="_transport",Ane="getWParam",Jqe="isBeacon",Ine="timings",jbe="isTeardown",Gbe="isSync",wne="data",Afi="timeout",qbe="_sendReason",Yqe="setKillSwitchTenants",Qqe="_backOffTransmission",kne="identifier",Ifi="disableOptimizeObj",wfi="ignoreMc1Ms0CookieProcessing",Zqe="eventsLimitInMem",Xqe="autoFlushEventsLimit",kfi="disableAutoBatchFlushLimit",Rfi="overrideInstrumentationKey",Mfi="disableTelemetry",Wbe="baseData",Rne="sendAttempt",gU="latency",m$="sync";function eWe(n){var a=(n.ext||{}).intweb;return a&&VN(a[Cne])?a[Cne]:null}function tWe(n){for(var a=null,s=0;a===null&&s<n[Gl];s++)a=eWe(n[s]);return a}var G9=function(){function n(a,s){var c=s?[][hU](s):[],u=this,m=tWe(c);u[lM]=function(){return a},u.Msfpc=function(){return m||$N},u[Pf]=function(){return c[Gl]},u[pU]=function(){return c},u.addEvent=function(b){return!!b&&(c[Zb](b),m||(m=eWe(b)),!0)},u[p$]=function(b,_){var k;if(b<c[Gl]){var N=c[Gl]-b;ic(_)||(N=_<N?_:N),k=c[_ne](b,N),m=tWe(c)}return new n(a,k)}}return n.create=function(a,s){return new n(a,s)},n}(),Pfi=function(){function n(){var a=!0,s=!0,c=!0,u="use-collector-delta",m=!1;Ec(n,this,function(b){b[Lbe]=function(){return a},b[Dqe]=function(){c&&(c=!1,m||(a=!1))},b[Lqe]=function(){return s},b[Oqe]=function(){return u},b[Obe]=function(_){m||(_?(u=_,s=!0,m=!0):s=!1,a=!0)}})}return n.__ieDyn=1,n}(),Dfi=1e3,Lfi=function(){function n(){var a={};function s(c){var u=[];return c&&Ra(c,function(m){u[Zb](pC(m))}),u}Ec(n,this,function(c){c[Yqe]=function(u,m){if(u&&m)try{var b=s(u[p$](","));if(m==="this-request-only")return b;for(var _=parseInt(m,10)*Dfi,k=0;k<b[Gl];++k)a[b[k]]=Jb()+_}catch{return[]}return[]},c[Efi]=function(u){var m=a,b=pC(u);return m[b]!==void 0&&m[b]>Jb()||(delete m[b],!1)}})}return n.__ieDyn=1,n}(),Ofi=.8,Nfi=1.2,iWe=3e3,xfi=6e5;function Bfi(n){return!(n>=300&&n<500&&n!=429||n==501||n==505)}function nWe(n){var a=0,s=iWe*Ofi,c=iWe*Nfi,u=Math.floor(Math.random()*(c-s))+s;return a=Math.pow(2,n)*u,Math.min(a,xfi)}var f$,Ffi=20,Ufi=3984588,aWe=65e3,rWe=2e6,zfi=Math.min(rWe,aWe),oWe="metadata",Mne="f",Vfi=/\./,$fi=function(){function n(a,s,c,u,m,b){var _="data",k="baseData",N="ext",W=!!u,ee=!0,oe=s,de={},se=!!b,Re=m||Eqe;Ec(n,this,function(ue){function Ne(He,be){var Ee=de[He];return Ee===void 0&&(He.length>=7&&(Ee=K2(He,"ext.metadata")||K2(He,"ext.web")),de[He]=Ee),Ee}function ze(He,be,Ee,Pe,Qe,Ze,Xe){El(He,function(bt,Ot){var Yt=null;if(Ot||VN(Ot)){var pt=Ee,Lt=bt,xt=Qe,yi=be;if(W&&!Pe&&Vfi.test(bt)){var Li=bt.split("."),cn=Li.length;if(cn>1){xt&&(xt=xt.slice());for(var Ci=0;Ci<cn-1;Ci++){var ji=Li[Ci];yi=yi[ji]=yi[ji]||{},pt+="."+ji,xt&&xt.push(ji)}Lt=Li[cn-1]}}if(Yt=Pe&&Ne(pt)||!oe||!oe.handleField(pt,Lt)?efi(Lt,Ot,c):oe.value(pt,Lt,Ot,c)){var An=Yt.value;if(yi[Lt]=An,Ze&&Ze(xt,Lt,Yt),typeof An=="object"&&!Fo(An)){var Ea=xt;Ea&&(Ea=Ea.slice()).push(Lt),ze(Ot,An,pt+"."+Lt,Pe,Ea,Ze)}}}})}ue.createPayload=function(He,be,Ee,Pe,Qe,Ze){return{apiKeys:[],payloadBlob:$N,overflow:null,sizeExceed:[],failedEvts:[],batches:[],numEvents:0,retryCnt:He,isTeardown:be,isSync:Ee,isBeacon:Pe,sendType:Ze,sendReason:Qe}},ue.appendPayload=function(He,be,Ee){var Pe=He&&be&&!He.overflow;return Pe&&fC(a,function(){return"Serializer:appendPayload"},function(){for(var Qe=be.events(),Ze=He.payloadBlob,Xe=He.numEvents,bt=!1,Ot=[],Yt=[],pt=He.isBeacon,Lt=pt?aWe:Ufi,xt=pt?zfi:rWe,yi=0,Li=0;yi<Qe.length;){var cn=Qe[yi];if(cn){if(Xe>=Ee){He.overflow=be.split(yi);break}var Ci=ue.getEventBlob(cn);if(Ci&&Ci.length<=xt){var ji=Ci.length;if(Ze.length+ji>Lt){He.overflow=be.split(yi);break}Ze&&(Ze+=`
`),Ze+=Ci,++Li>Ffi&&(Cw(Ze,0,1),Li=0),bt=!0,Xe++}else Ci?Ot.push(cn):Yt.push(cn),Qe.splice(yi,1),yi--}yi++}if(Ot.length>0&&He.sizeExceed.push(G9.create(be.iKey(),Ot)),Yt.length>0&&He.failedEvts.push(G9.create(be.iKey(),Yt)),bt){He.batches.push(be),He.payloadBlob=Ze,He.numEvents=Xe;var An=be.iKey();Rv(He.apiKeys,An)===-1&&He.apiKeys.push(An)}},function(){return{payload:He,theBatch:{iKey:be.iKey(),evts:be.events()},max:Ee}}),Pe},ue.getEventBlob=function(He){try{return fC(a,function(){return"Serializer.getEventBlob"},function(){var be={};be.name=He.name,be.time=He.time,be.ver=He.ver,be.iKey="o:"+Zmi(He.iKey);var Ee,Pe={};se||(Ee=function(bt,Ot,Yt){Hfi(Re,Pe,bt,Ot,Yt)});var Qe=He[N];Qe&&(be[N]=Pe,El(Qe,function(bt,Ot){ze(Ot,Pe[bt]={},"ext."+bt,!0,null,null,!0)}));var Ze=be[_]={};Ze.baseType=He.baseType;var Xe=Ze[k]={};return ze(He.baseData,Xe,k,!1,[k],Ee,ee),ze(He.data,Ze,_,!1,[],Ee,ee),JSON.stringify(be)},function(){return{item:He}})}catch{return null}}})}return n.__ieDyn=1,n}();function Hfi(n,a,s,c,u){if(u&&a){var m=n(u.value,u.kind,u.propertyType);if(m>-1){var b=a[oWe];b||(b=a[oWe]={f:{}});var _=b[Mne];if(_||(_=b[Mne]={}),s)for(var k=0;k<s.length;k++){var N=s[k];_[N]||(_[N]={f:{}});var W=_[N][Mne];W||(W=_[N][Mne]={}),_=W}_=_[c]={},Fo(u.value)?_.a={t:m}:_.t=m}}}function Pne(n,a){return{set:function(s,c){for(var u=[],m=2;m<arguments.length;m++)u[m-2]=arguments[m];return Npi([n,a],s,c,u)}}}var Kbe="sendAttempt",jfi="&"+vfi+"=true",Gfi="?cors=true&"+$9[Nbe]()+"="+Ibe,qfi=((f$={})[1]=Iqe,f$[100]=Iqe,f$[200]="sent",f$[8004]=Abe,f$[8003]=Abe,f$),Jbe={},Ybe={};function mU(n,a,s){Jbe[n]=a,s!==!1&&(Ybe[a]=n)}function Dne(n,a){var s=!1;if(n&&a){var c=hC(n);if(c&&c[Gl]>0)for(var u=a[Nbe](),m=0;m<c[Gl];m++){var b=c[m];if(b&&iA(a,b)&&b[Nbe]()===u){s=!0;break}}}return s}function v$(n,a,s,c){a&&s&&s[Gl]>0&&(c&&Jbe[a]?(n[g$][Jbe[a]]=s,n[xbe]=!0):n.url+="&"+a+"="+s)}function Wfi(n,a,s){for(var c=0;c<n[Gl];c++)if(n[c].name===a)return void(n[c].value=s);n[Zb]({name:a,value:s})}function Kfi(n,a){for(var s=0;s<n[Gl];s++)if(n[s].name===a)return void n[_ne](s,1)}mU(Pbe,Pbe,!1),mU(wbe,wbe),mU(kqe,"Client-Id"),mU(Mbe,Mbe),mU(kbe,kbe),mU(Rbe,Rbe),mU(Mqe,Mqe);var Jfi=function(){function n(a,s,c,u){var m,b,_,k,N,W,ee,oe,de,se,Re,ue,Ne,ze,He,be,Ee,Pe,Qe,Ze,Xe,bt,Ot,Yt,pt,Lt,xt,yi,Li,cn,Ci,ji=!1;Ec(n,this,function(An){ss();var Ea=!0;function Ln(pi,Qn){try{return Ci&&Ci.getSenderInst(pi,Qn)}catch{}return null}function ga(){try{return{enableSendPromise:!1,isOneDs:!0,disableCredentials:!Ea,disableXhr:!1,disableBeacon:!ji,disableBeaconSync:!ji,disableFetchKeepAlive:Xe,timeWrapper:Li,addNoResponse:Ot,senderOnCompleteCallBack:{xdrOnComplete:vs,fetchOnComplete:Ya,xhrOnComplete:ir,beaconOnRetry:pa}}}catch{}return null}function vs(pi,Qn,ft){var Hi=o$(pi);Ji(Qn,200,{},Hi),Ih(Hi)}function ss(){var pi;m=null,b=new Lfi,_=!1,k=new Pfi,ji=!1,N=0,W=null,ee=null,oe=null,de=null,se=!0,Re=[],ue={},Ne=[],ze=null,He=!1,be=null,Ee=!1,Pe=!1,Qe=pi,Ze=pi,Xe=pi,bt=pi,Ot=pi,Yt=[],pt=pi,Lt=pi,xt=[],yi=!1,Li=Pne(),cn=!1,Ci=null}function Ya(pi,Qn,ft,Hi){var Qt=function(Ki,bi,Ie){Ji(Qn,Ki,bi,Ie),Ih(Ie)},xi={},at=pi[cM];at&&at.forEach(function(Ki,bi){xi[bi]=Ki}),Qt(pi.status,xi,ft||$N)}function ir(pi,Qn,ft){var Hi=o$(pi);Ji(Qn,pi.status,Zie(pi,!0),Hi),Ih(Hi)}function Ji(pi,Qn,ft,Hi){try{pi(Qn,ft,Hi)}catch(Qt){ud(ee,2,518,Gs(Qt))}}function pa(pi,Qn,ft){var Hi=200,Qt=pi[j9],xi=pi[qqe]+(Ot?jfi:$N);try{var at=QR();if(Qt){var Ki=!!de.getPlugin("LocalStorage"),bi=[],Ie=[];Ra(Qt[vC],function(ai){if(bi&&ai&&ai[Pf]()>0)for(var Jt=ai[pU](),At=0;At<Jt[Gl];At++){if(!at.sendBeacon(xi,ze.getEventBlob(Jt[At]))){bi[Zb](ai[p$](At));break}Ie[Zb](ai[At])}else bi[Zb](ai[p$](0))}),Ie[Gl]>0&&(Qt.sentEvts=Ie),Ki||mo(bi,8003,Qt[aE],!0)}else Hi=0}catch(ai){x9(ee,"Failed to send telemetry using sendBeacon API. Ex:"+Gs(ai)),Hi=0}finally{Ji(Qn,Hi,{},$N)}}function Ca(pi){return pi===2||pi===3}function da(pi){return Ee&&Ca(pi)&&(pi=2),pi}function Wn(){return!_&&N<s}function co(){var pi=Ne;return Ne=[],pi}function eo(pi,Qn,ft){var Hi=!1;return pi&&pi[Gl]>0&&!_&&oe[Qn]&&ze&&(Hi=Qn!==0||Wn()&&(ft>0||k[Lbe]())),Hi}function Uo(pi){var Qn={};return pi&&Ra(pi,function(ft,Hi){Qn[Hi]={iKey:ft[lM](),evts:ft[pU]()}}),Qn}function Zo(pi,Qn,ft,Hi,Qt){if(pi&&pi[Gl]!==0)if(_)mo(pi,1,Hi);else{Hi=da(Hi);try{var xi=pi,at=Hi!==0;fC(de,function(){return"HttpManager:_sendBatches"},function(Ki){Ki&&(pi=pi.slice(0));for(var bi=[],Ie=null,ai=sM(),Jt=oe[Hi]||(at?oe[1]:oe[0]),At=Jt&&Jt[Hbe],gi=bt&&(Ee||Ca(Hi)||At===3||Jt._isSync&&At===2);eo(pi,Hi,Qn);){var _i=pi.shift();_i&&_i[Pf]()>0&&(b.isTenantKilled(_i[lM]())?bi[Zb](_i):(Ie=Ie||ze[Fbe](Qn,ft,at,gi,Qt,Hi),ze.appendPayload(Ie,_i,a)?Ie.overflow!==null&&(pi=[Ie.overflow][hU](pi),Ie.overflow=null,kd(Ie,ai,sM(),Qt),ai=sM(),Ie=null):(kd(Ie,ai,sM(),Qt),ai=sM(),pi=[_i][hU](pi),Ie=null)))}Ie&&kd(Ie,ai,sM(),Qt),pi[Gl]>0&&(Ne=pi[hU](Ne)),mo(bi,8004,Hi)},function(){return{batches:Uo(xi),retryCount:Qn,isTeardown:ft,isSynchronous:at,sendReason:Qt,useSendBeacon:Ca(Hi),sendType:Hi}},!at)}catch(Ki){ud(ee,2,48,"Unexpected Exception sending batch: "+Gs(Ki))}}}function oo(pi,Qn){var ft={url:m,hdrs:{},useHdrs:!1};Qn?(ft[g$]=yne(ft[g$],ue),ft.useHdrs=hC(ft.hdrs)[Gl]>0):El(ue,function(Ki,bi){Ybe[Ki]?v$(ft,Ybe[Ki],bi,!1):(ft[g$][Ki]=bi,ft[xbe]=!0)}),v$(ft,kqe,"NO_AUTH",Qn),v$(ft,wbe,Cqe,Qn);var Hi=$N;Ra(pi.apiKeys,function(Ki){Hi[Gl]>0&&(Hi+=","),Hi+=Ki}),v$(ft,Mbe,Hi,Qn),v$(ft,Rbe,Jb().toString(),Qn);var Qt=Ol(pi);if(VN(Qt)&&(ft.url+="&ext.intweb.msfpc="+Qt),k[Lqe]()&&v$(ft,kbe,k[Oqe](),Qn),de[Ane]){var xi=de[Ane]();xi>=0&&(ft.url+="&w="+xi)}for(var at=0;at<Re[Gl];at++)ft.url+="&"+Re[at].name+"="+Re[at].value;return ft}function Xu(pi,Qn,ft){pi[Qn]=pi[Qn]||{},pi[Qn][W.identifier]=ft}function kd(pi,Qn,ft,Hi){if(pi&&pi.payloadBlob&&pi.payloadBlob[Gl]>0){var Qt=!!pt,xi=oe[pi.sendType];!Ca(pi[aE])&&pi[Jqe]&&pi.sendReason===2&&(xi=oe[2]||oe[3]||xi);var at=Pe;(pi.isBeacon||xi[Hbe]===3)&&(at=!1);var Ki=oo(pi,at);at=at||Ki[xbe];var bi=sM();fC(de,function(){return"HttpManager:_doPayloadSend"},function(){for(var Ie=0;Ie<pi.batches[Gl];Ie++)for(var ai=pi[vC][Ie][pU](),Jt=0;Jt<ai[Gl];Jt++){var At=ai[Jt];if(He){var gi=At[Ine]=At[Ine]||{};Xu(gi,"sendEventStart",bi),Xu(gi,"serializationStart",Qn),Xu(gi,"serializationCompleted",ft)}At[Kbe]>0?At[Kbe]++:At[Kbe]=1}mo(pi[vC],1e3+(Hi||0),pi[aE],!0);var _i={data:pi[Gqe],urlString:Ki.url,headers:Ki[g$],_thePayload:pi,_sendReason:Hi,timeout:Qe,disableXhrSync:Ze,disableFetchKeepAlive:Xe};at&&(Dne(_i[cM],Tne)||(_i[cM][Tne]=wqe),Dne(_i[cM],$9)||(_i[cM][$9]=Ibe));var sr=null;xi&&(sr=function(ya){k[Dqe]();var dr=function(eT,gu){Ah(eT,gu,pi,Hi)},Ps=pi[jbe]||pi[Gbe];try{xi.sendPOST(ya,dr,Ps),Lt&&Lt(_i,ya,Ps,pi[Jqe])}catch(eT){x9(ee,"Unexpected exception sending payload. Ex:"+Gs(eT)),Ji(dr,0,{})}}),fC(de,function(){return"HttpManager:_doPayloadSend.sender"},function(){if(sr)if(pi[aE]===0&&N++,Qt&&!pi.isBeacon&&xi[Hbe]!==3){var ya={data:_i[wne],urlString:_i[qqe],headers:yne({},_i[cM]),timeout:_i[Afi],disableXhrSync:_i[Uqe],disableFetchKeepAlive:_i[zqe]},dr=!1;fC(de,function(){return"HttpManager:_doPayloadSend.sendHook"},function(){try{pt(ya,function(Ps){dr=!0,se||Ps[j9]||(Ps[j9]=Ps[j9]||_i[j9],Ps[qbe]=Ps[qbe]||_i[qbe]),sr(Ps)},pi.isSync||pi[jbe])}catch{dr||sr(_i)}})}else sr(_i)})},function(){return{thePayload:pi,serializationStart:Qn,serializationCompleted:ft,sendReason:Hi}},pi[Gbe])}pi.sizeExceed&&pi.sizeExceed[Gl]>0&&mo(pi.sizeExceed,8003,pi[aE]),pi.failedEvts&&pi.failedEvts[Gl]>0&&mo(pi.failedEvts,8002,pi[aE])}function jg(pi,Qn){He&&Ra(pi,function(ft){Xu(ft[Ine]=ft[Ine]||{},"sendEventCompleted",Qn)})}function Ah(pi,Qn,ft,Hi){var Qt=9e3,xi=null,at=!1,Ki=!1;try{var bi=!0;if(typeof pi!==lie){if(Qn){k[Obe](Qn[ffi]);var Ie=Qn[mfi]||Qn["kill-duration-seconds"];Ra(b[Yqe](Qn[gfi],Ie),function(Jt){Ra(ft[vC],function(At){if(At[lM]()===Jt){xi=xi||[];var gi=At[p$](0);ft.numEvents-=gi[Pf](),xi[Zb](gi)}})})}if(pi==200||pi==204)return void(Qt=200);(!Bfi(pi)||ft.numEvents<=0)&&(bi=!1),Qt=9e3+pi%1e3}if(bi){Qt=100;var ai=ft.retryCnt;ft[aE]===0&&(ai<c?(at=!0,qr(function(){ft[aE]===0&&N--,Zo(ft[vC],ai+1,ft[jbe],Ee?2:ft[aE],5)},Ee,nWe(ai))):(Ki=!0,Ee&&(Qt=8001)))}}finally{at||(k[Obe](),es(ft,Qt,Hi,Ki)),mo(xi,8004,ft[aE])}}function es(pi,Qn,ft,Hi){try{Hi&&W[Qqe]();var Qt=pi[vC];Qn===200&&(Qt=pi.sentEvts||pi[vC],Hi||pi[Gbe]||W._clearBackOff(),qs(Qt)),mo(Qt,Qn,pi[aE],!0)}finally{pi[aE]===0&&(N--,ft!==5&&An.sendQueuedRequests(pi[aE],ft))}}function qs(pi){if(He){var Qn=sM();Ra(pi,function(ft){ft&&ft[Pf]()>0&&jg(ft[pU](),Qn)})}}function qr(pi,Qn,ft){Qn?pi():Li.set(pi,ft)}function Ol(pi){for(var Qn=0;Qn<pi.batches[Gl];Qn++){var ft=pi[vC][Qn].Msfpc();if(ft)return encodeURIComponent(ft)}return $N}function Ih(pi){var Qn=xt;try{for(var ft=0;ft<Qn[Gl];ft++)try{Qn[ft](pi)}catch(Qt){ud(ee,1,519,"Response handler failed: "+Qt)}if(pi){var Hi=JSON.parse(pi);VN(Hi.webResult)&&VN(Hi.webResult[Cne])&&be.set("MSFPC",Hi.webResult[Cne],31536e3)}}catch{}}function mo(pi,Qn,ft,Hi){if(pi&&pi[Gl]>0&&u){var Qt=u[ig(Qn)];if(Qt){var xi=ft!==0;fC(de,function(){return"HttpManager:_sendBatchesNotification"},function(){qr(function(){try{Qt.call(u,pi,Qn,xi,ft)}catch(at){ud(ee,1,74,"send request notification failed: "+at)}},Hi||xi,0)},function(){return{batches:Uo(pi),reason:Qn,isSync:xi,sendSync:Hi,sendType:ft}},!xi)}}}function ig(pi){var Qn=qfi[pi];return VN(Qn)||(Qn=pfi,pi>=9e3&&pi<=9999?Qn=hfi:pi>=8e3&&pi<=8999?Qn=Abe:pi>=1e3&&pi<=1999&&(Qn=ufi)),Qn}An[H9]=function(pi,Qn,ft){yi||(de=Qn,be=Qn.getCookieMgr(),ee=(W=ft).diagLog(),XR(Yt,Mf(pi,function(Hi){var Qt,xi=Hi.cfg,at=Hi.cfg.extensionConfig[ft.identifier];Li=Pne(at[Nqe],at[xqe]),VN(xi.anonCookieName)?Wfi(Re,"anoncknm",xi.anonCookieName):Kfi(Re,"anoncknm"),pt=at[yfi],Lt=at.payloadListener;var Ki=at.httpXHROverride,bi=at[Bqe]?at[Bqe]:xi.endpointUrl;m=bi+Gfi,Pe=!!_c(at[Fqe])||!at[Fqe],He=!at[Sfi];var Ie=at.valueSanitizer,ai=at[bfi],Jt=!!xi[Bbe];_c(at[Bbe])||(Jt=!!at[Bbe]),Qe=at.xhrTimeout,Ze=!!at[Uqe],Xe=!!at[zqe],Ot=at[Tfi]!==!1,cn=!!at[Cfi],Qn.getPlugin("LocalStorage")&&(Xe=!0),ji=!i9e(),ze=new $fi(de,Ie,ai,Jt,Eqe,cn),ic(at[Vqe])||(ji=!!at[Vqe]);var At=ga();Ci?Ci.SetConfig(At):(Ci=new Nmi)[H9](At,ee);var gi=Ki,_i=at[$qe]?Ki:null,sr=at[$qe]?Ki:null,ya=[3,2];if(!Ki){se=!1;var dr=[];i9e()?(dr=[2,1],ya=[2,1,3]):dr=[1,2,3],(Ki=Ln(dr=JGe(dr,at.transports),!1))||x9(ee,"No available transport to send events"),gi=Ln(dr,!0)}_i||(_i=Ln(ya=JGe(ya,at[_fi]),!0)),bt=!se&&(ji&&n9e()||!Xe&&a9e(!0)),(Qt={})[0]=Ki,Qt[1]=gi||Ln([1,2,3],!0),Qt[2]=_i||gi||Ln([1],!0),Qt[3]=sr||Ln([2,3],!0)||gi||Ln([1],!0),oe=Qt})),yi=!0)},An.addResponseHandler=function(pi){return xt[Zb](pi),{rm:function(){var Qn=xt.indexOf(pi);Qn>=0&&xt[_ne](Qn,1)}}},An[Hqe]=function(pi){try{if(ze)return ze.getEventBlob(pi)}catch{}return $N},An[jqe]=function(){try{return oo(ze&&ze[Fbe](0,!1,!1,!1,1,0),Pe)}catch{}return null},An[Ube]=function(pi,Qn){try{var ft=[];Ra(pi,function(Ki){Qn&&(Ki=r$(Ki));var bi=G9.create(Ki[lM],[Ki]);ft[Zb](bi)});for(var Hi=null;ft[Gl]>0&&ze;){var Qt=ft.shift();Qt&&Qt[Pf]()>0&&(Hi=Hi||ze[Fbe](0,!1,!1,!1,1,0),ze.appendPayload(Hi,Qt,a))}var xi=oo(Hi,Pe),at={data:Hi[Gqe],urlString:xi.url,headers:xi[g$],timeout:Qe,disableXhrSync:Ze,disableFetchKeepAlive:Xe};return Pe&&(Dne(at[cM],Tne)||(at[cM][Tne]=wqe),Dne(at[cM],$9)||(at[cM][$9]=Ibe)),at}catch{}return null},An._getDbgPlgTargets=function(){return[oe[0],b,ze,oe]},An[zbe]=function(pi,Qn){ue[pi]=Qn},An.removeHeader=function(pi){delete ue[pi]},An[Vbe]=function(){return Wn()&&k[Lbe]()},An[Ene]=function(pi,Qn){_c(pi)&&(pi=0),Ee&&(pi=da(pi),Qn=2),eo(Ne,pi,0)&&Zo(co(),0,!1,pi,Qn||0)},An[Wqe]=function(){return!_&&N===0&&Ne[Gl]===0},An[$be]=function(pi){Ee=pi},An.addBatch=function(pi){if(pi&&pi[Pf]()>0){if(b.isTenantKilled(pi[lM]()))return!1;Ne[Zb](pi)}return!0},An.teardown=function(){Ne[Gl]>0&&Zo(co(),0,!0,2,2),Ra(Yt,function(pi){pi&&pi.rm&&pi.rm()}),Yt=[]},An.pause=function(){_=!0},An.resume=function(){_=!1,An[Ene](0,4)},An[Kqe]=function(pi,Qn,ft){pi&&pi[Pf]()>0&&(ic(Qn)&&(Qn=1),Ee&&(Qn=da(Qn),ft=2),Zo([pi],0,!1,Qn,ft||0))}})}return n.__ieDyn=1,n}(),Yfi=.25,sWe=500,Qfi=20,lWe=6,cWe=2,Zfi=4,dWe=2,Xfi=1,Qbe=1e4,fU="eventsDiscarded",uWe="",Df=void 0,evi=jD({eventsLimitInMem:{isVal:V9,v:Qbe},immediateEventLimit:{isVal:V9,v:500},autoFlushEventsLimit:{isVal:V9,v:0},disableAutoBatchFlushLimit:!1,httpXHROverride:{isVal:tvi,v:Df},overrideInstrumentationKey:Df,overrideEndpointUrl:Df,disableTelemetry:!1,ignoreMc1Ms0CookieProcessing:!1,setTimeoutOverride:Df,clearTimeoutOverride:Df,payloadPreprocessor:Df,payloadListener:Df,disableEventTimings:Df,valueSanitizer:Df,stringifyObjects:Df,enableCompoundKey:Df,disableOptimizeObj:!1,transports:Df,unloadTransports:Df,useSendBeacon:Df,disableFetchKeepAlive:Df,avoidOptions:!1,xhrTimeout:Df,disableXhrSync:Df,alwaysUseXhrOverride:!1,maxEventRetryAttempts:{isVal:HD,v:lWe},maxUnloadEventRetryAttempts:{isVal:HD,v:cWe},addNoResponse:Df,excludeCsMetaData:Df});function tvi(n){return n&&n.sendPOST}var q9,ivi=function(n){function a(){var s,c=n.call(this)||this;c.identifier="PostChannel",c.priority=1011,c.version="4.2.1";var u,m,b,_,k,N,W,ee,oe,de,se,Re,ue,Ne,ze,He,be,Ee,Pe,Qe,Ze,Xe,bt,Ot,Yt,pt=!1,Lt=[],xt=!1,yi=0,Li=0,cn={},Ci=bne;return Ec(a,c,function(ji,An){function Ea(){qmi(null,Ee),Wmi(null,Ee),Kmi(null,Ee)}function Ln(bi){var Ie=bi[Ane];bi[Ane]=function(){var ai=0;return Qe&&(ai|=2),ai|Ie.call(bi)}}function ga(bi){var Ie=uWe;return bi&&bi[Gl]&&Ra(bi,function(ai){Ie&&(Ie+=`
`),Ie+=ai}),Ie}function vs(bi){var Ie=uWe;try{ir(bi),Ie=ee[Hqe](bi)}catch{}return Ie}function ss(bi){(bi||qD().event).type!=="beforeunload"&&(ze=!0,ee[$be](ze)),Uo(2,2)}function Ya(bi){ze=!1,ee[$be](ze)}function ir(bi){bi.ext&&bi.ext[Pqe]&&delete bi.ext[Pqe],bi.ext&&bi.ext[Dbe]&&bi.ext[Dbe].id&&delete bi.ext[Dbe].id,Ne&&(bi.ext=r$(bi.ext),bi[Wbe]&&(bi[Wbe]=r$(bi[Wbe])),bi[wne]&&(bi[wne]=r$(bi[wne])))}function Ji(bi,Ie){if(bi[Rne]||(bi[Rne]=0),bi[gU]||(bi[gU]=1),ir(bi),bi[m$]){if(N||xt)bi[gU]=3,bi[m$]=!1;else if(ee)return Ne&&(bi=r$(bi)),void ee[Kqe](G9.create(bi[lM],[bi]),bi[m$]===!0?1:bi[m$],3)}var ai=bi[gU],Jt=Li,At=b;ai===4&&(Jt=yi,At=m);var gi=!1;if(Jt<At)gi=!kd(bi,Ie);else{var _i=1,sr=Qfi;ai===4&&(_i=4,sr=1),gi=!0,jg(bi[lM],bi[gU],_i,sr)&&(gi=!kd(bi,Ie))}gi&&pi(fU,[bi],Y2.QueueFull)}function pa(bi,Ie,ai){var Jt=es(bi,Ie,ai);return ee[Ene](Ie,ai),Jt}function Ca(){return Li>0}function da(){if(Re>=0&&es(Re,0,ue)&&ee[Ene](0,ue),yi>0&&!k&&!xt){var bi=cn[Ci][2];bi>=0&&(k=co(function(){k=null,pa(4,0,1),da()},bi))}var Ie=cn[Ci][1];!_&&!u&&Ie>=0&&!xt&&(Ca()?_=co(function(){_=null,pa(W===0?3:1,0,1),W++,W%=2,da()},Ie):W=0)}function Wn(){s=null,pt=!1,Lt=[],u=null,xt=!1,yi=0,m=500,Li=0,b=Qbe,cn={},Ci=bne,_=null,k=null,N=0,W=0,oe={},de=0,bt=!1,se=0,Re=-1,ue=null,Ne=!0,ze=!1,He=lWe,be=cWe,Ee=null,Ot=null,Yt=!1,Pe=Pne(),ee=new Jfi(sWe,dWe,Xfi,{requeue:mo,send:ft,sent:Hi,drop:Qt,rspFail:xi,oth:at}),Ih(),Zo(),Ki()}function co(bi,Ie){Ie===0&&N&&(Ie=1);var ai=1e3;return N&&(ai=nWe(N-1)),Pe.set(bi,Ie*ai)}function eo(){return _!==null&&(_.cancel(),_=null,W=0,!0)}function Uo(bi,Ie){eo(),u&&(u.cancel(),u=null),xt||pa(1,bi,Ie)}function Zo(){oe[4]={batches:[],iKeyMap:{}},oe[3]={batches:[],iKeyMap:{}},oe[2]={batches:[],iKeyMap:{}},oe[1]={batches:[],iKeyMap:{}}}function oo(bi,Ie,ai){var Jt=oe[Ie];Jt||(Jt=oe[Ie=1]);var At=Jt.iKeyMap[bi];return!At&&ai&&(At=G9.create(bi),Jt.batches[Zb](At),Jt.iKeyMap[bi]=At),At}function Xu(bi,Ie){ee[Vbe]()&&!N&&(de>0&&Li>de&&(Ie=!0),Ie&&u==null&&ji.flush(bi,function(){},20))}function kd(bi,Ie){Ne&&(bi=r$(bi));var ai=bi[gU],Jt=oo(bi[lM],ai,!0);return!!Jt.addEvent(bi)&&(ai!==4?(Li++,Ie&&bi[Rne]===0&&Xu(!bi.sync,se>0&&Jt[Pf]()>=se)):yi++,!0)}function jg(bi,Ie,ai,Jt){for(;ai<=Ie;){var At=oo(bi,Ie,!0);if(At&&At[Pf]()>0){var gi=At[p$](0,Jt),_i=gi[Pf]();if(_i>0)return ai===4?yi-=_i:Li-=_i,Qn(fU,[gi],Y2.QueueFull),!0}ai++}return Ah(),!1}function Ah(){for(var bi=0,Ie=0,ai=function(At){var gi=oe[At];gi&&gi[vC]&&Ra(gi[vC],function(_i){At===4?bi+=_i[Pf]():Ie+=_i[Pf]()})},Jt=1;Jt<=4;Jt++)ai(Jt);Li=Ie,yi=bi}function es(bi,Ie,ai){var Jt=!1,At=Ie===0;return!At||ee[Vbe]()?fC(ji.core,function(){return"PostChannel._queueBatches"},function(){for(var gi=[],_i=4;_i>=bi;){var sr=oe[_i];sr&&sr.batches&&sr.batches[Gl]>0&&(Ra(sr[vC],function(ya){ee.addBatch(ya)?Jt=Jt||ya&&ya[Pf]()>0:gi=gi[hU](ya[pU]()),_i===4?yi-=ya[Pf]():Li-=ya[Pf]()}),sr[vC]=[],sr.iKeyMap={}),_i--}gi[Gl]>0&&pi(fU,gi,Y2.KillSwitch),Jt&&Re>=bi&&(Re=-1,ue=0)},function(){return{latency:bi,sendType:Ie,sendReason:ai}},!At):(Re=Re>=0?Math.min(Re,bi):bi,ue=Math.max(ue,ai)),Jt}function qs(bi,Ie){pa(1,0,Ie),Ah(),qr(function(){bi&&bi(),Lt[Gl]>0?u=co(function(){u=null,qs(Lt.shift(),Ie)},0):(u=null,da())})}function qr(bi){ee[Wqe]()?bi():u=co(function(){u=null,qr(bi)},Yfi)}function Ol(){eo(),Ih(),Ci=bne,da()}function Ih(){(cn={})[bne]=[2,1,0],cn[cfi]=[6,3,0],cn[dfi]=[18,9,0]}function mo(bi,Ie){var ai=[],Jt=He;ze&&(Jt=be),Ra(bi,function(At){At&&At[Pf]()>0&&Ra(At[pU](),function(gi){gi&&(gi[m$]&&(gi[gU]=4,gi[m$]=!1),gi[Rne]<Jt?(Sne(gi,ji[kne]),Ji(gi,!1)):ai[Zb](gi))})}),ai[Gl]>0&&pi(fU,ai,Y2.NonRetryableStatus),ze&&Uo(2,2)}function ig(bi,Ie){var ai=Xe||{},Jt=ai[bi];if(Jt)try{Jt.apply(ai,Ie)}catch(At){ud(ji.diagLog(),1,74,bi+" notification failed: "+At)}}function pi(bi,Ie){for(var ai=[],Jt=2;Jt<arguments.length;Jt++)ai[Jt-2]=arguments[Jt];Ie&&Ie[Gl]>0&&ig(bi,[Ie][hU](ai))}function Qn(bi,Ie){for(var ai=[],Jt=2;Jt<arguments.length;Jt++)ai[Jt-2]=arguments[Jt];Ie&&Ie[Gl]>0&&Ra(Ie,function(At){At&&At[Pf]()>0&&ig(bi,[At.events()][hU](ai))})}function ft(bi,Ie,ai){bi&&bi[Gl]>0&&ig("eventsSendRequest",[Ie>=1e3&&Ie<=1999?Ie-1e3:0,ai!==!0])}function Hi(bi,Ie){Qn("eventsSent",bi,Ie),da()}function Qt(bi,Ie){Qn(fU,bi,Ie>=8e3&&Ie<=8999?Ie-8e3:Y2.Unknown)}function xi(bi){Qn(fU,bi,Y2.NonRetryableStatus),da()}function at(bi,Ie){Qn(fU,bi,Y2.Unknown),da()}function Ki(){se=Ze?0:Math.max(sWe*(dWe+1),b/6)}Wn(),ji._getDbgPlgTargets=function(){return[ee,s]},ji[H9]=function(bi,Ie,ai){fC(Ie,function(){return"PostChannel:initialize"},function(){An[H9](bi,Ie,ai),Xe=Ie.getNotifyMgr();try{Ee=U9(s$(ji[kne]),Ie.evtNamespace&&Ie.evtNamespace()),ji._addHook(Mf(bi,function(Jt){var At=Jt.cfg,gi=lU(null,At,Ie);s=gi.getExtCfg(ji[kne],evi),Pe=Pne(s[Nqe],s[xqe]),Ne=!s[Ifi]&&afi(),Qe=s[wfi],Ln(Ie),b=s[Zqe],m=s.immediateEventLimit,de=s[Xqe],He=s.maxEventRetryAttempts,be=s.maxUnloadEventRetryAttempts,Ze=s[kfi],Ki(),Ot=s[Rfi],Yt=!!s[Mfi],bt&&Ea();var _i=At.disablePageUnloadEvents||[];bt=Gmi(ss,_i,Ee),bt=mqe(ss,_i,Ee)||bt,bt=fqe(Ya,At.disablePageShowEvents,Ee)||bt})),ee[H9](bi,ji.core,ji)}catch(Jt){throw ji.setInitialized(!1),Jt}},function(){return{theConfig:bi,core:Ie,extensions:ai}})},ji.processTelemetry=function(bi,Ie){Sne(bi,ji[kne]),Ie=Ie||ji._getTelCtx(Ie);var ai=bi;Yt||pt||(Ot&&(ai[lM]=Ot),Ji(ai,!0),ze?Uo(2,2):da()),ji.processNext(ai,Ie)},ji.getOfflineSupport=function(){try{var bi=ee&&ee[jqe]();if(ee)return{getUrl:function(){return bi?bi.url:null},serialize:vs,batch:ga,shouldProcess:function(Ie){return!Yt},createPayload:function(Ie){return null},createOneDSPayload:function(Ie){if(ee[Ube])return ee[Ube](Ie,Ne)}}}catch{}return null},ji._doTeardown=function(bi,Ie){Uo(2,2),pt=!0,ee.teardown(),Ea(),Wn()},ji.setEventQueueLimits=function(bi,Ie){s[Zqe]=b=V9(bi)?bi:Qbe,s[Xqe]=de=V9(Ie)?Ie:0,Ki();var ai=Li>bi;if(!ai&&se>0)for(var Jt=1;!ai&&Jt<=3;Jt++){var At=oe[Jt];At&&At[vC]&&Ra(At[vC],function(gi){gi&&gi[Pf]()>=se&&(ai=!0)})}Xu(!0,ai)},ji.pause=function(){eo(),xt=!0,ee.pause()},ji.resume=function(){xt=!1,ee.resume(),da()},ji._loadTransmitProfiles=function(bi){Ol(),El(bi,function(Ie,ai){var Jt=ai[Gl];if(Jt>=2){var At=Jt>2?ai[2]:0;if(ai[_ne](0,Jt-2),ai[1]<0&&(ai[0]=-1),ai[1]>0&&ai[0]>0){var gi=ai[0]/ai[1];ai[0]=Math.ceil(gi)*ai[1]}At>=0&&ai[1]>=0&&At>ai[1]&&(At=ai[1]),ai[Zb](At),cn[Ie]=ai}})},ji.flush=function(bi,Ie,ai){var Jt;if(bi===void 0&&(bi=!0),!xt)if(ai=ai||1,bi)Ie||(Jt=eL(function(gi){Ie=gi})),u==null?(eo(),es(1,0,ai),u=co(function(){u=null,qs(Ie,ai)},0)):Lt[Zb](Ie);else{var At=eo();pa(1,1,ai),Ie&&Ie(),At&&da()}return Jt},ji.setMsaAuthTicket=function(bi){ee[zbe](Pbe,bi)},ji.setAuthPluginHeader=function(bi){ee[zbe](Rqe,bi)},ji.removeAuthPluginHeader=function(){ee.removeHeader(Rqe)},ji.hasEvents=Ca,ji._setTransmitProfile=function(bi){Ci!==bi&&cn[bi]!==void 0&&(eo(),Ci=bi,da())},qGe(ji,function(){return ee},["addResponseHandler"]),ji[Qqe]=function(){N<Zfi&&(N++,eo(),da())},ji._clearBackOff=function(){N&&(N=0,eo(),da())}}),c}return VS(a,n),a.__ieDyn=1,a}(mne),hWe="locale",Zbe="ver",nvi="browser",avi="browserVer",rvi="popSample",ovi="eventFlags",Xbe="name",svi="serviceName",Im=gC({UserExt:[0,"user"],DeviceExt:[1,"device"],TraceExt:[2,"trace"],WebExt:[3,"web"],AppExt:[4,"app"],OSExt:[5,"os"],SdkExt:[6,"sdk"],IntWebExt:[7,"intweb"],UtcExt:[8,"utc"],LocExt:[9,"loc"],CloudExt:[10,"cloud"],DtExt:[11,"dt"]}),rE=gC({id:[0,"id"],ver:[1,Zbe],appName:[2,Xbe],locale:[3,hWe],expId:[4,"expId"],env:[5,"env"]}),Aw=gC({domain:[0,"domain"],browser:[1,nvi],browserVer:[2,avi],screenRes:[3,"screenRes"],userConsent:[4,"userConsent"],consentDetails:[5,"consentDetails"]}),vU=gC({locale:[0,hWe],localId:[1,"localId"],id:[2,"id"]}),W9=gC({osName:[0,Xbe],ver:[1,Zbe]}),lvi=gC({ver:[0,Zbe],seq:[1,"seq"],installId:[2,"installId"],epoch:[3,"epoch"]}),cvi=gC({msfpc:[0,"msfpc"],anid:[1,"anid"],serviceName:[2,svi]}),dvi=gC({popSample:[0,rvi],eventFlags:[1,ovi]}),eTe=gC({tz:[0,"tz"]}),uvi=gC({sessionId:[0,"sesId"]}),tL=gC({localId:[0,"localId"],deviceClass:[1,"deviceClass"],make:[2,"make"],model:[3,"model"]}),yU=gC({role:[0,"role"],roleInstance:[1,"roleInstance"],roleVer:[2,"roleVer"]}),hvi=gC({traceId:[0,"traceID"],traceName:[1,Xbe],parentId:[2,"parentID"]}),pvi=gC({traceId:[0,"traceId"],spanId:[1,"spanId"],traceFlags:[2,"traceFlags"]});function pWe(){return q9===void 0&&(q9=!!mWe(0)),q9}function gWe(){return pWe()?mWe(0):null}function mWe(n){var a,s,c=null;try{var u=PN();if(!u)return null;s=new Date,(c=n===0?u.localStorage:u.sessionStorage)&&js(c.setItem)&&(c.setItem(s,s),a=c.getItem(s)!==s,c.removeItem(s),a&&(c=null))}catch{c=null}return c}function gvi(n,a,s){var c=gWe();if(c!==null)try{return c.setItem(a,s),!0}catch(u){q9=!1,ud(n,1,504,"Browser failed write to local storage. "+u)}return!1}function mvi(n,a){var s=gWe();if(s!==null)try{return s.getItem(a)}catch(c){q9=!1,ud(n,1,503,"Browser failed read of local storage. "+c)}return null}function fvi(){return this.getId()}function vvi(n){this.setId(n)}var fWe=function(){function n(){Ec(n,this,function(a){a.setId=function(s){a.customId=s},a.getId=function(){return wf(a.customId)?a.customId:a.automaticId}})}return n._staticInit=void Fc(n.prototype,"id",{g:fvi,s:vvi}),n}(),vWe="ai_session",yvi=function(){function n(a,s,c){var u,m,b,_=tbe(a),k=D9e(a);Ec(n,this,function(N){var W=Mf(s,function(){b=s,N.config=b});function ee(){var ue=k.get(m());if(ue&&js(ue.split))oe(ue);else{var Ne=mvi(_,m());Ne&&oe(Ne)}N.automaticSession.getId()||de()}function oe(ue){var Ne=N.automaticSession,ze=ue.split("|");ze.length>0&&Ne.setId(ze[0]);try{if(ze.length>1){var He=+ze[1];Ne.acquisitionDate=+new Date(He),Ne.acquisitionDate=Ne.acquisitionDate>0?Ne.acquisitionDate:0}if(ze.length>2){var be=+ze[2];Ne.renewalDate=+new Date(be),Ne.renewalDate=Ne.renewalDate>0?Ne.renewalDate:0}}catch(Ee){ud(_,1,510,"Error parsing ai_session cookie, session will be reset: "+Ee)}Ne.renewalDate===0&&ud(_,2,517,"AI session renewal date is 0, session will be reset.")}function de(){var ue=N.automaticSession,Ne=new Date().getTime(),ze=N.config.sessionAsGuid;!_c(ze)&&ze?RN(ze)?ue.setId(Aqe()):ue.setId(Aqe(ze)):ue.setId(WSe(b.idLength||22)),ue.acquisitionDate=Ne,ue.renewalDate=Ne,se(ue.getId(),ue.acquisitionDate,ue.renewalDate),pWe()||ud(_,2,505,"Browser does not support local storage. Session durations will be inaccurate.")}function se(ue,Ne,ze){var He=Ne+N.config.sessionExpirationMs,be=ze+N.config.sessionRenewalMs,Ee=new Date,Pe=[ue,Ne,ze];He<be?Ee.setTime(He):Ee.setTime(be);var Qe=N.config.cookieDomain||null;k.set(m(),Pe.join("|")+";expires="+Ee.toUTCString(),null,Qe),u=new Date().getTime()}function Re(ue,Ne,ze){gvi(_,m(),[ue,Ne,ze].join("|"))}c&&c.add(W),m=function(){return N.config.namePrefix?vWe+N.config.namePrefix:vWe},N.automaticSession=new fWe,N.update=function(){N.automaticSession.getId()||ee();var ue=N.automaticSession,Ne=N.config,ze=new Date().getTime(),He=ze-ue.acquisitionDate>Ne.sessionExpirationMs,be=ze-ue.renewalDate>Ne.sessionRenewalMs;He||be?de():(!u||ze-u>n.cookieUpdateInterval)&&(ue.renewalDate=ze,se(ue.getId(),ue.acquisitionDate,ue.renewalDate))},N.backup=function(){var ue=N.automaticSession;Re(ue.getId(),ue.acquisitionDate,ue.renewalDate)}})}return n.cookieUpdateInterval=6e4,n}(),tTe=["AX","EX","SF","CS","CF","CT","CU","DC","DF","H5","HL","WS","WP"];function yWe(n,a){a===void 0&&(a=tTe);var s=null;if(n)for(var c=n.split(","),u=0;u<c.length;u++)Svi(c[u],a)&&(s?s+=","+c[u]:s=c[u]);return s}function Svi(n,a){if(a===void 0&&(a=tTe),!n||n.length<4)return!1;for(var s=!1,c=256,u=n.substring(0,3).toString().toUpperCase(),m=0;m<a.length;m++)if(a[m]+":"===u&&n.length<=c){s=!0;break}return s}function bvi(){return this.getExpId()}var SWe=function(){function n(a,s,c){var u,m=null,b=tTe.slice(0),_="Treatments",k=null;Ec(n,this,function(N){if(Re(a),iGe()){var W=GD().documentElement;W&&(N.locale=W.lang)}function ee(ue){var Ne,ze={},He=GD();if(He){Ne=He&&He.querySelectorAll("meta");for(var be=0;be<Ne.length;be++){var Ee=Ne[be];Ee.name&&Ee.name.toLowerCase().indexOf(ue)===0&&(ze[Ee.name.replace(ue,"")]=Ee.content)}}return ze}function oe(ue){ue!==m&&(m=yWe(ue,b))}function de(){return oe(uU(u,_)),m}function se(ue){return oe(ue),m}function Re(ue){var Ne=Mf(ue,function(){u=s&&s.getCookieMgr(),k=ue||{},N.env=k.env||ee("awa-").env});c&&c.add(Ne)}N.getExpId=function(){return k.expId?se(k.expId):de()}})}return n.validateAppExpId=yWe,n._staticInit=void Fc(n.prototype,"expId",{g:bvi}),n}(),Tvi=function(){function n(){}return n}(),Cvi=function(){function n(){}return n}();function _vi(){return this.getMsfpc()}function Evi(){return this.getAnid()}var Avi=function(){function n(s,c,u){var m;Ec(n,this,function(b){function _(k){var N=Mf(k,function(){m=c&&c.getCookieMgr();var W=k||{};W.serviceName&&(b.serviceName=W.serviceName)});u&&u.add(N)}_(s),b.getMsfpc=function(){return uU(m,"MSFPC")},b.getAnid=function(){return uU(m,"ANON").slice(0,34)}})}var a;return n._staticInit=(Fc(a=n.prototype,"msfpc",{g:_vi}),void Fc(a,"anid",{g:Evi})),n}(),Ivi=function(){function n(){var a=new Date().getTimezoneOffset(),s=a%60,c=(a-s)/60,u="+";c>0&&(u="-"),c=Math.abs(c),s=Math.abs(s),this.tz=u+(c<10?"0"+c:c.toString())+":"+(s<10?"0"+s:s.toString())}return n}(),HN={WIN:/(windows|win32)/i,WINRT:/ arm;/i,WINPHONE:/windows\sphone\s\d+\.\d+/i,OSX:/(macintosh|mac os x)/i,IOS:/(ipad|iphone|ipod)(?=.*like mac os x)/i,LINUX:/(linux|joli|[kxln]?ubuntu|debian|[open]*suse|gentoo|arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk)/i,ANDROID:/android/i,CROS:/CrOS/i},bWe={5.1:"XP","6.0":"Vista",6.1:"7",6.2:"8",6.3:"8.1","10.0":"10"},wvi="([\\d,.]+)",TWe="([\\d,_,.]+)",y$="Unknown",CWe=[{r:HN.WINPHONE,os:"Windows Phone"},{r:HN.WINRT,os:"Windows RT"},{r:HN.WIN,os:"Windows"},{r:HN.IOS,os:"iOS"},{r:HN.ANDROID,os:"Android"},{r:HN.LINUX,os:"Linux"},{r:HN.CROS,os:"Chrome OS"},{s:"x11",os:"Unix"},{s:"blackberry",os:"BlackBerry"},{s:"symbian",os:"Symbian"},{s:"nokia",os:"Nokia"},{r:HN.OSX,os:"Mac OS X"}];function kvi(n){for(var a=0;a<CWe.length;a++){var s=CWe[a];if(s.r&&n.match(s.r)||s.s&&n.indexOf(s.s)!==-1)return s.os}return y$}function Rvi(n,a){return a==="Windows"?_We(n,"Windows NT"):a==="Android"?_We(n,a):a==="Mac OS X"?Mvi(n):a==="iOS"?Pvi(n):y$}function _We(n,a){var s=n.match(new RegExp(a+" "+wvi));return s?bWe[s[1]]?bWe[s[1]]:s[1]:y$}function Mvi(n){var a=n.match(new RegExp("Mac OS X "+TWe));if(a){var s=a[1].replace(/_/g,".");if(s){var c=EWe(s);return c?s.split(c)[0]:s}}return y$}function Pvi(n){var a=n.match(new RegExp("OS "+TWe));if(a){var s=a[1].replace(/_/g,".");if(s){var c=EWe(s);return c?s.split(c)[0]:s}}return y$}function EWe(n){return n.indexOf(".")>-1?".":n.indexOf("_")>-1?"_":null}var AWe=function(){function n(a,s){var c=this,u=null,m=null,b=null,_=null,k=function(de){b=de},N=function(de){_=de},W=function(){return b||u},ee=function(){return _||m},oe=Mf(a,function(){if((a||{}).populateOperatingSystemInfo){var de=QR()||{},se=a.userAgent||de.userAgent||"",Re=(a.userAgentData||{}).platform||(de.userAgentData||{}).platform;if(se){var ue=kvi(se.toLowerCase());u=ue,m=Rvi(se,ue)}u&&u!==y$||!wf(Re)||(u=Re)}});s&&s.add(oe),Fc(c,"name",{s:k,g:W}),Fc(c,"ver",{s:N,g:ee})}return n}(),iTe="MicrosoftApplicationsTelemetryDeviceId";function Dvi(n,a,s,c){a?a.setProperty(s,c):n.set(s,c,31536e3)}function Lvi(n,a,s){return a?a.getProperty(s)||"":uU(n,s)}var Ovi=function(){function n(a,s,c){var u,m=0;Ec(n,this,function(b){b.seq=m,b.epoch=M9(!1).toString(),b.getSequenceId=function(){return++m};var _=Mf(a,function(k){u=s&&s.getCookieMgr();var N=k.cfg.propertyStorageOverride;if(u.isEnabled()||N){var W=Lvi(u,N,iTe);W||(W=U9e()),Dvi(u,N,iTe,W),b.installId=W}else u.purge(iTe)});c&&c.add(_)})}return n.__ieDyn=1,n}(),Nvi=function(){function n(a,s,c,u,m){var b=this;b.traceId=s||cbe();var _=Mf(a,function(){var k=a;if(k.enableDistributedTracing&&!c&&(c=cbe().substring(0,16)),b.parentId=b.parentId||c,k.enableApplicationInsightsTrace&&!u){var N=Xie();N&&N.pathname&&(u=N.pathname)}b.name=b.name||u});m&&m.add(_)}return n}(),IWe="setLocalId";function xvi(){return this.getLocalId()}function Bvi(n){this[IWe](n)}var Fvi=function(){function n(a,s,c,u){var m,b,_;Ec(n,this,function(k){if(ee(s),typeof navigator<"u"){var N=navigator;k.locale=N.userLanguage||N.language}function W(){if(!m.hashIdentifiers&&!m.dropIdentifiers){var oe=uU(_,"MUID");oe&&(b="t:"+oe)}return b}function ee(oe){var de=Mf(oe,function(){if(_=c&&c.getCookieMgr(),m=oe,b=null,_&&_.isEnabled()&&(W(),m.enableApplicationInsightsUser)){var se=uU(_,n.userCookieName);if(se){var Re=se.split(n.cookieSeparator);Re.length>0&&(k.id=Re[0])}if(!k.id){k.id=WSe(a&&!_c(a.idLength)?a.idLength:22);var ue=$Se(new Date);k.accountAcquisitionDate=ue;var Ne=[k.id,ue],ze=m.cookieDomain?m.cookieDomain:void 0;_.set(n.userCookieName,Ne.join(n.cookieSeparator),31536e3,ze)}}});u&&u.add(de)}k.getLocalId=function(){return b||W()},k[IWe]=function(oe){b=oe}})}return n.cookieSeparator="|",n.userCookieName="ai_user",n._staticInit=void Fc(n.prototype,"localId",{g:xvi,s:Bvi}),n}(),Uvi=1048576,zvi=2097152,Vvi=4194304,$vi=function(){function n(a,s){var c=this;c.popSample=100;var u=Mf(a,function(){c.eventFlags=0,a.hashIdentifiers&&(c.eventFlags=c.eventFlags|Uvi),a.dropIdentifiers&&(c.eventFlags=c.eventFlags|zvi),a.scrubIpOnly&&(c.eventFlags=c.eventFlags|Vvi)});s&&s.add(u)}return n}(),wWe=["Required","Analytics","SocialMedia","Advertising"],Lne="([\\d,.]+)",kWe="Unknown",RWe="Edg/",nTe=[{ua:"OPR/",b:"Opera"},{ua:"PhantomJS",b:"PhantomJS"},{ua:"Edge",b:"Edge"},{ua:RWe,b:"Edge"},{ua:"Electron",b:"Electron"},{ua:"Chrome",b:"Chrome"},{ua:"Trident",b:"MSIE"},{ua:"MSIE ",b:"MSIE"},{ua:"Firefox",b:"Firefox"},{ua:"Safari",b:"Safari"},{ua:"SkypeShell",b:"SkypeShell"}],aTe=[{br:"Microsoft Edge",b:"Edge"},{br:"Google Chrome",b:"Chrome"},{br:"Opera",b:"Opera"}];function MWe(n,a){return a.indexOf(n)>-1}function Hvi(n,a){for(var s=0;s<a.length;s++)if(n==a[s].brand)return a[s].version;return null}function jvi(n){if(n){for(var a=0;a<nTe.length;a++)if(MWe(nTe[a].ua,n))return nTe[a].b}return kWe}function Gvi(n,a){return a==="MSIE"?qvi(n):Wvi(a,n)}function qvi(n){var a=n.match(new RegExp("MSIE "+Lne));if(a)return a[1];var s=n.match(new RegExp("rv:"+Lne));return s?s[1]:void 0}function Wvi(n,a){n==="Safari"?n="Version":n==="Edge"&&MWe(RWe,a)&&(n="Edg");var s=a.match(new RegExp(n+"/"+Lne));return s||n==="Opera"&&(s=a.match(new RegExp("OPR/"+Lne)))?s[1]:kWe}function Kvi(){var n={h:0,w:0},a=qD();return a&&a.screen&&(n.h=screen.height,n.w=screen.width),n}function Jvi(){return this.getUserConsent()}var Yvi=function(){function n(a,s,c){var u=D9e(s),m=a||{},b=null,_=null,k=null,N=null,W=null,ee=null,oe=null;Ec(n,this,function(de){Ze(a);var se=Xie();if(se){var Re=se.hostname;Re&&(de.domain=se.protocol==="file:"?"local":Re)}var ue=Kvi();function Ne(Xe,bt){if(Fo(bt))try{for(var Ot=0;Ot<aTe.length;Ot++){var Yt=Hvi(aTe[Ot].br,bt);if(Yt)return W=aTe[Ot].b,void(ee=Yt)}}catch{}if(Xe){var pt=jvi(Xe);W=pt,ee=Gvi(Xe,pt)}}function ze(Xe){k=Xe}function He(Xe){N=Xe}function be(){return k||W}function Ee(){return N||ee}de.screenRes=ue.w+"X"+ue.h,de.getUserConsent=function(){return m.userConsented||!!uU(u,m.userConsentCookieName||"MSCC")},de.getUserConsentDetails=function(){var Xe=null;try{var bt=m.callback;if(bt&&bt.userConsentDetails){var Ot=bt.userConsentDetails();if(Ot){Xe=m.disableConsentDetailsSanitize?Ot:{};for(var Yt=0;Yt<wWe.length;Yt++){var pt=wWe[Yt];Xe[pt]=Ot[pt]||!1}}}return oe!==null&&((Xe=Xe||{}).GPC_DataSharingOptIn=!!oe),Xe?JSON.stringify(Xe):null}catch{}};var Pe=function(){return oe},Qe=function(Xe){oe=RN(Xe)?Xe:null,m.gpcDataSharingOptIn=oe};function Ze(Xe){var bt=Mf(Xe,function(){if((m=Xe).populateBrowserInfo){var Ot=m.userAgent,Yt=(m.userAgentData||{}).brands;if(Ot!==b||Yt!==_){if(!Ot||!Yt||Yt.length===0){var pt=QR();pt&&(Ot=Ot||pt.userAgent||"",Yt=Yt||(pt.userAgentData||{}).brands)}Ne(Ot,Yt),b=Ot,_=Yt}}oe=RN(m.gpcDataSharingOptIn)?m.gpcDataSharingOptIn:null});c&&c.add(bt)}jye(de,{userConsent:{g:de.getUserConsent},browser:{s:ze,g:be},browserVer:{s:He,g:Ee},gpcDataSharingOptIn:{g:Pe,s:Qe}})})}return n._staticInit=void Fc(n.prototype,"userConsent",{g:Jvi}),n}();function oE(n,a,s,c,u){var m=a.ext[Im[n]];if(m)try{El(c,function(b,_){if(wf(_)||HD(_)||RN(_)){var k=m[s[b]];!u&&(k||wf(k)||HD(k)||RN(k))&&(_=k),m[s[b]]=_}})}catch{}return m}var One,Qvi=function(){function n(a,s,c,u){Ec(n,this,function(m){m.app=new SWe(s,c,u),m.cloud=new Tvi,m.user=new Fvi(a,s,c,u),m.os=new AWe(s,u),m.web=new Yvi(s,c,u);var b=new Ovi(a,c,u),_=new Avi(s,c,u),k=new $vi(s,u);m.loc=new Ivi,m.device=new Cvi;var N=new yvi(c,s,u);m.session=new fWe;var W=void 0,ee=Zvi(new Nvi(s,W,W,W,u),se()),oe=!(s||{}).eventContainExtFields;function de(){var Re=m.session;if(Re&&wf(Re.customId))return Re.customId;N.update();var ue=N.automaticSession;if(ue){var Ne=ue.getId();Ne&&wf(Ne)&&(Re.automaticId=Ne)}return Re.automaticId}function se(){var Re=ee;return c&&c.getTraceCtx&&(Re=c.getTraceCtx(!1)||ee),Re}m.getTraceCtx=function(){return ee},m.getSessionId=de,m.applyApplicationContext=function(Re){var ue,Ne=m.app;oE(4,Re,rE,((ue={})[0]=Ne.id,ue[1]=Ne.ver,ue[2]=Ne.name,ue[3]=Ne.locale,ue[4]=Ne.getExpId(),ue[5]=Ne.env,ue),oe)},m.applyUserContext=function(Re){var ue,Ne=m.user;oE(0,Re,vU,((ue={})[1]=Ne.getLocalId(),ue[0]=Ne.locale,ue[2]=Ne.id,ue),oe)},m.applyWebContext=function(Re){var ue,Ne=m.web;oE(3,Re,Aw,((ue={})[0]=Ne.domain,ue[1]=Ne.browser,ue[2]=Ne.browserVer,ue[3]=Ne.screenRes,ue[5]=Ne.getUserConsentDetails(),ue[4]=Ne.getUserConsent(),ue),oe)},m.applyOsContext=function(Re){var ue,Ne=m.os;oE(5,Re,W9,((ue={})[0]=Ne.name,ue[1]=Ne.ver,ue),oe)},m.applySdkContext=function(Re){var ue;oE(6,Re,lvi,((ue={})[2]=b.installId,ue[1]=b.getSequenceId(),ue[3]=b.epoch,ue),oe)},m.applyIntWebContext=function(Re){var ue;oE(7,Re,cvi,((ue={})[0]=_.getMsfpc(),ue[1]=_.getAnid(),ue[2]=_.serviceName,ue),oe)},m.applyUtcContext=function(Re){var ue,Ne=((ue={})[0]=k.popSample,ue);k.eventFlags>0&&(Ne[1]=k.eventFlags),oE(8,Re,dvi,Ne,oe)},m.applyLocContext=function(Re){var ue;oE(9,Re,eTe,((ue={})[0]=m.loc.tz,ue),oe)},m.applySessionContext=function(Re){var ue;oE(4,Re,uvi,((ue={})[0]=de(),ue),oe)},m.applyDeviceContext=function(Re){var ue,Ne=m.device;oE(1,Re,tL,((ue={})[0]=Ne.localId,ue[2]=Ne.make,ue[3]=Ne.model,ue[1]=Ne.deviceClass,ue),oe)},m.applyCloudContext=function(Re){var ue,Ne=m.cloud;oE(10,Re,yU,((ue={})[0]=Ne.role,ue[1]=Ne.roleInstance,ue[2]=Ne.roleVer,ue),oe)},m.applyAITraceContext=function(Re){var ue;if(s.enableApplicationInsightsTrace){var Ne=se();Ne&&oE(2,Re,hvi,((ue={})[0]=Ne.getTraceId(),ue[1]=Ne.getName(),ue[2]=Ne.getSpanId(),ue),!1)}},m.applyDistributedTraceContext=function(Re){var ue,Ne=se();if(Ne){var ze=((ue={})[0]=Ne.getTraceId(),ue[1]=Ne.getSpanId(),ue),He=Ne.getTraceFlags();ic(He)||(ze[2]=He),oE(11,Re,pvi,ze,!1)}}})}return n.__ieDyn=1,n}();function Zvi(n,a){var s=n||{};return{getName:function(){return s.name},setName:function(c){a&&a.setName(c),s.name=c},getTraceId:function(){return s.traceId},setTraceId:function(c){a&&a.setTraceId(c),V9e(c)&&(s.traceId=c)},getSpanId:function(){return s.parentId},setSpanId:function(c){a&&a.setSpanId(c),$9e(c)&&(s.parentId=c)},getTraceFlags:function(){return s.traceFlags},setTraceFlags:function(c){a&&a.setTraceFlags(c),s.traceFlags=c}}}var Xvi=[Im[4],Im[0],Im[3],Im[5],Im[6],Im[7],Im[8],Im[9],Im[1],Im[2],Im[11],Im[10]],eyi=jD({populateBrowserInfo:!1,populateOperatingSystemInfo:!1,userAgent:rU(),userAgentData:Ew({brands:One,mobile:One,platform:One}),userConsentCookieName:rU(),userConsented:!1,serviceName:rU(),env:rU(),expId:rU(),sessionRenewalMs:18e5,sessionExpirationMs:864e5,sessionAsGuid:null,cookieDomain:rU(),namePrefix:rU(),enableApplicationInsightsTrace:!1,enableApplicationInsightsUser:!1,hashIdentifiers:!1,dropIdentifiers:!1,scrubIpOnly:!1,callback:Ew({userConsentDetails:null}),gpcDataSharingOptIn:One,idLength:22,enableDistributedTracing:!1,eventContainExtFields:!1}),tyi=function(n){function a(){var s,c,u,m=n.call(this)||this;return m.identifier="SystemPropertiesCollector",m.priority=3,m.version="4.2.1",Ec(a,m,function(b,_){function k(){s=null,c={}}function N(ee){var oe=b.identifier,de=b.core;b._addHook(Mf(ee,function(){var se=lU(null,ee,de);u=se.getExtCfg(oe,eyi)})),s=new Qvi(ee,u,de,b._unloadHooks),de&&de.setTraceCtx&&de.setTraceCtx(s.getTraceCtx())}function W(ee,oe){ee&&El(ee,function(de,se){oe[de]||(oe[de]=se)})}k(),b.initialize=function(ee,oe,de){_.initialize(ee,oe,de),N(ee)},b.processTelemetry=function(ee,oe){Sne(ee,b.identifier),oe=b._getTelCtx(oe);var de=ee.ext=ee.ext?ee.ext:{};ee.data=ee.data?ee.data:{},Ra(Xvi,function(se){de[se]=de[se]||{}}),s&&(s.applyUtcContext(ee),s.applyApplicationContext(ee),s.applyUserContext(ee),s.applyWebContext(ee),s.applyOsContext(ee),s.applySdkContext(ee),s.applyIntWebContext(ee),s.applyLocContext(ee),s.applySessionContext(ee),s.applyDeviceContext(ee),u.enableApplicationInsightsTrace&&s.applyAITraceContext(ee),u.enableDistributedTracing&&s.applyDistributedTraceContext(ee),s.applyCloudContext(ee)),Ra(hC(de),function(se){hC(de[se]).length===0&&delete de[se]}),W(c,ee.data),b.processNext(ee,oe)},b.getPropertiesContext=function(){return s},b.setProperty=function(ee,oe){c[ee]=oe},b._doTeardown=function(ee,oe){var de=(ee||{}).core();if(de&&de.getTraceCtx&&s){var se=de.getTraceCtx(!1);se&&se===s.getTraceCtx()&&de.setTraceCtx(null)}k()},b._getDbgPlgTargets=function(){return[u]}}),m}return VS(a,n),a.__ieDyn=1,a}(mne),jN=function(){function n(a){this._setOverride=function(s,c){a.setOverride(s,c)},this._getOverride=function(s){return a.getOverride(s)}}return n}(),iyi=function(n){function a(s,c,u){var m=n.call(this,s)||this,b=m;b.setId=function(k){b._setOverride(rE.id,k)},b.getId=function(){return b._getOverride(rE.id)},b.setVer=function(k){b._setOverride(rE.ver,k)},b.getVer=function(){return b._getOverride(rE.ver)},b.setName=function(k){b._setOverride(rE.appName,k)},b.getName=function(){return b._getOverride(rE.appName)},b.setLocale=function(k){b._setOverride(rE.locale,k)},b.getLocale=function(){return b._getOverride(rE.locale)},b.setEnv=function(k){b._setOverride(rE.env,k)},b.getEnv=function(){return b._getOverride(rE.env)},b.setExpId=function(k){b._setOverride(rE.expId,SWe.validateAppExpId(k))},b.getExpId=function(){return b._getOverride(rE.expId)};var _=Mf(c,function(){c&&(_c(c.env)||b.setEnv(c.env),ic(c.expId)||b.setExpId(c.expId))});return u&&u.add(_),m}return VS(a,n),a}(jN),nyi=function(n){function a(s){var c=n.call(this,s)||this,u=c;return u.setRole=function(m){u._setOverride(yU.role,m)},u.getRole=function(){return u._getOverride(yU.role)},u.setRoleInstance=function(m){u._setOverride(yU.roleInstance,m)},u.getRoleInstance=function(){return u._getOverride(yU.roleInstance)},u.setRoleVer=function(m){u._setOverride(yU.roleVer,m)},u.getRoleVer=function(){return u._getOverride(yU.roleVer)},c}return VS(a,n),a}(jN),ayi=function(n){function a(s){var c=n.call(this,s)||this,u=c;return u.setProperty=function(m,b){u._setOverride(m,b)},u.getProperty=function(m){return u._getOverride(m)},c}return VS(a,n),a}(jN),ryi=function(n){function a(s){var c=n.call(this,s)||this,u=c;return u.setLocalId=function(m){u._setOverride(tL.localId,m)},u.getLocalId=function(){return u._getOverride(tL.localId)},u.setDeviceClass=function(m){u._setOverride(tL.deviceClass,m)},u.getDeviceClass=function(){return u._getOverride(tL.deviceClass)},u.setMake=function(m){u._setOverride(tL.make,m)},u.getMake=function(){return u._getOverride(tL.make)},u.setModel=function(m){u._setOverride(tL.model,m)},u.getModel=function(){return u._getOverride(tL.model)},c}return VS(a,n),a}(jN),oyi=function(n){function a(s){var c=n.call(this,s)||this,u=c;return u.setTz=function(m){u._setOverride(eTe.tz,m)},u.getTz=function(){return u._getOverride(eTe.tz)},c}return VS(a,n),a}(jN),syi=function(n){function a(s,c,u){var m=n.call(this,s)||this,b=m,_=null;b.setOsName=function(N){b._setOverride(W9.osName,N)},b.getOsName=function(){return b._getOverride(W9.osName)},b.setVer=function(N){b._setOverride(W9.ver,N)},b.getVer=function(){return b._getOverride(W9.ver)};var k=Mf(c,function(){!_&&c.userAgent&&c.populateOperatingSystemInfo&&(_=new AWe(c,u)),_&&(b.setOsName(_.name),b.setVer(_.ver))});return u&&u.add(k),m}return VS(a,n),a}(jN);function PWe(n,a){if(n)for(var s=0;s<a.length;s++){var c=a[s];ic(n[c])&&(n[c]={}),n=n[c]}return n}function lyi(n,a,s){if(n&&a){var c=a.split("."),u=c[c.length-1];c.length>1&&(n=PWe(n,c.slice(0,-1))),ic(s)?_c(n[u])||delete n[u]:n[u]=s}}var rTe,DWe,cyi=function(){function n(a){var s=this,c=[];s.setOverride=function(u,m){u&&c.push({key:u,value:m})},s.hasOverride=function(u){var m=!1;return Ra(c,function(b){b.key===u&&(m=!0)}),m},s.getOverride=function(u){var m;return Ra(c,function(b){b.key===u&&(m=b.value)}),m},s.applyOverrides=function(u,m){if(c.length>0)try{var b=PWe(u,a);Ra(c,function(_){lyi(b,_.key,_.value)})}catch{}}}return n}(),dyi=function(n){function a(s){var c=n.call(this,s)||this,u=c;return u.setLocalId=function(m){u._setOverride(vU.localId,m)},u.getLocalId=function(){return u._getOverride(vU.localId)},u.setLocale=function(m){u._setOverride(vU.locale,m)},u.getLocale=function(){return u._getOverride(vU.locale)},u.setId=function(m){u._setOverride(vU.id,m)},u.getId=function(){return u._getOverride(vU.id)},c}return VS(a,n),a}(jN),uyi=function(n){function a(s,c,u){var m=n.call(this,s)||this,b=m;b.setDomain=function(k){b._setOverride(Aw.domain,k)},b.getDomain=function(){return b._getOverride(Aw.domain)},b.setBrowser=function(k){b._setOverride(Aw.browser,k)},b.getBrowser=function(){return b._getOverride(Aw.browser)},b.setBrowserVer=function(k){b._setOverride(Aw.browserVer,k)},b.getBrowserVer=function(){return b._getOverride(Aw.browserVer)},b.setScreenRes=function(k){b._setOverride(Aw.screenRes,k)},b.getScreenRes=function(){return b._getOverride(Aw.screenRes)},b.setUserConsent=function(k){b._setOverride(Aw.userConsent,k)},b.getUserContext=function(){return b._getOverride(Aw.userConsent)};var _=Mf(c,function(){c&&(_c(c.userConsented)||b.setUserConsent(c.userConsented))});return u&&u.add(_),m}return VS(a,n),a}(jN),SU="ext",hyi="data",pyi=function(){function n(a,s,c,u){var m=this,b={};function _(k){for(var N="",W=0;W<k.length;W++)N&&(N+="_"),N+=k[W];return _c(b[N])&&(b[N]=new cyi(k)),N?b[N]:null}m.data=new ayi(_([hyi])),m.app=new iyi(_([SU,Im.AppExt]),s,u),m.user=new dyi(_([SU,Im.UserExt])),m.os=new syi(_([SU,Im.OSExt]),s,u),m.web=new uyi(_([SU,Im.WebExt]),s,u),m.device=new ryi(_([SU,Im.DeviceExt])),m.loc=new oyi(_([SU,Im.LocExt])),m.cloud=new nyi(_([SU,Im.CloudExt])),m.applyOverrides=function(k,N){var W=hC(b);W&&W.length>0&&Ra(W,function(ee){b[ee].applyOverrides(k,N)})}}return n}(),bU=void 0,gyi=jD({env:bU,expId:bU,populateOperatingSystemInfo:!1,userAgent:bU,userAgentData:Ew({brands:bU,mobile:bU,platform:bU}),userConsented:bU}),Nne="OverridePropertiesPlugin",myi=function(n){function a(){var s=n.call(this)||this;s.identifier=Nne,s.priority=4,s.version="4.2.1";var c=null;return Ec(a,s,function(u,m){u.initialize=function(b,_,k){m.initialize(b,_,k),u._baseInit(b,_,k)},u.processTelemetry=function(b,_){Sne(b,s.identifier),_=u._getTelCtx(_);var k=u.getOverrideContext();k&&k.applyOverrides(b,_),u.processNext(b,_)},u._baseInit=function(b,_,k){c=new pyi(b,s._getTelCtx().getExtCfg(s.identifier,gyi),_,u._unloadHooks)},u.setProperty=function(b,_){c&&c.data.setProperty(b,_)},u.getOverrideContext=function(){return c}}),s}return VS(a,n),a.__ieDyn=1,a}(mne),oTe="_dropInst",fyi=["channelConfiguration","propertyStorageOverride"];function vyi(n){if(n&&Fo(n.extensionConfig)){var a=n.extensionConfig,s={};El(a,function(c,u){js(u)||K2(c,"Symbol(")||(s[c]=u)}),n.extensionConfig=s}return n}function sTe(n,a){if(a)for(var s=hC(a),c=0;c<s.length;c++){var u=s[c];nE(n,u)||K2(u,"Symbol(")||(n[u]=a[u])}}function lTe(n,a,s){var c;return Fc(n,a,{g:function(){return jhi(s)?s:(Fo(s)?(Fo(c)||(c=[]),c.length=s.length):JR(c)||(c={}),El(s,function(u,m){K2(u,"Symbol(")||lTe(c,u,m)}),c)}})}function yyi(n){return n.pause&&n.teardown&&n.flush}function LWe(n,a){var s=null;if(a){a.endpointUrl&&(s=a.endpointUrl);var c=(a.extensionConfig||{})[n]||{};c.overrideEndpointUrl&&(s=c.overrideEndpointUrl)}return s}var OWe=jD({cookieCfg:{},channelConfiguration:Ew({}),propertyConfiguration:Ew({}),extensions:{rdOnly:!0,ref:!0,v:[],blkVal:!0},channels:{rdOnly:!0,ref:!0,v:[],blkVal:!0},extensionConfig:Ew({}),createPerfMgr:DWe,loggingLevelConsole:0}),Syi=jD({propertyConfiguration:Ew({}),cookieCfg:Ew({}),extensions:{rdOnly:!0,ref:!0,v:[],blkVal:!0},channels:{rdOnly:!0,ref:!0,v:[],blkVal:!0},extensionConfig:Ew((rTe={},rTe[Nne]=Ew({}),rTe)),createPerfMgr:DWe,loggingLevelConsole:0}),byi=function(n){function a(s,c){var u=n.call(this)||this;return Ec(a,u,function(m,b){function _(W){var ee=[];return W&&Ra(W,function(oe){oe.iKey===s&&ee.push(oe)}),ee}function k(W){if(m[W]&&m.listeners)for(var ee=0;ee<m.listeners.length;ee++){var oe=m.listeners[ee];if(oe&&oe[W])return!0}return!1}var N={eventsSent:function(W){if(k("eventsSent")){var ee=_(W);ee.length>0&&m.eventsSent(ee)}},eventsDiscarded:function(W,ee){if(k("eventsDiscarded")){var oe=_(W);oe.length>0&&m.eventsDiscarded(oe,ee)}},eventsSendRequest:function(W,ee){k("eventsSendRequest")&&m.eventsSendRequest(W,ee)},perfEvent:function(W){k("perfEvent")&&m.perfEvent(W)}};c.addNotificationListener(N)}),u}return VS(a,n),a.__ieDyn=1,a}(hne),Tyi=function(){function n(){var a,s,c,u,m,b,_,k,N,W,ee,oe,de,se,Re=null,ue=null;Ec(n,this,function(Ne){function ze(){a=Qb({},OWe,null),s=[],c=null,u=null,m=[],b=[],_={},k=null,N=null,W=null,oe=null,de=null,se=!1,a.cfg.loggingLevelConsole=1,ee=new l$(a.cfg),Fc(Ne,"sharedConfig",{g:function(){return se&&Pe(),a.cfg}})}function He(Ot,Yt){var pt;if(Yt===void 0&&(Yt=null),Ot){(yyi(Ot)?b:m).push(Ot);var Lt=Ot.identifier,xt=a.cfg.extensionConfig;a.setDf(xt,((pt={})[Lt]={ref:!0,v:Yt||{}},pt))}return Ot}function be(){var Ot=a.cfg,Yt=Ot.channels,pt=new ivi,Lt=pt.identifier,xt=!1;N=null,W=null,Ra(Yt,function(yi){xt||Ra(yi,function(Li){if(!js(Li)&&(He(Li),Li.identifier===Lt))return N=Li,xt=!0,-1})}),xt||(N=He(pt,Ot.channelConfiguration),Yt.length>0?XR(Yt[0],N):Ot.channels.push([N]))}function Ee(Ot){var Yt=a.cfg;s=[],k=He(new tyi,Yt.propertyConfiguration),s.push(k),Yt.extensions&&Ra(Yt.extensions,function(pt){js(pt)||He(pt)}),Ot&&Ra(Ot,function(pt){pt&&!js(pt)&&s.push(He(pt))})}function Pe(){c||(se||ud(Ne.diagLog(),2,520,"The Shared Manager is not yet created, the returned shared instance will be overwritten"),a.cfg.instrumentationKey=a.cfg.instrumentationKey||"_not_defined_",u=new hne,(c=new NWe(Ne,Ne.diagLog(),u)).initialize(a.cfg,s),c.isInitialized()&&(jye((a=f9e(c.config)).cfg,{channelConfiguration:{g:function(){return a.cfg.extensionConfig[N.identifier]}},propertyConfiguration:{g:function(){return a.cfg.extensionConfig[k.identifier]}}}),N&&(W=LWe(N.identifier,a.cfg))),Re&&c.setCookieMgr(Re))}function Qe(Ot,Yt){var pt=[],Lt=a.cfg,xt={};if(El(Lt.extensionConfig,function(cn,Ci){cn===N.identifier||cn===k.identifier||K2(cn,"Symbol(")||(cn!==Nne?lTe(xt,cn,Ci):(xt[cn]={},sTe(xt[cn],Ci)))}),Yt){Yt.extensions&&Yt.extensions.length>0&&(pt=XR(pt,Yt.extensions));var yi=Yt.extensionConfig;yi&&(nE(yi,N.identifier)&&hC(yi).length>0&&ud(Ne.diagLog(),2,511,"Instances cannot override the shared Post channel configuration, the shared will be used!"),sTe(xt,yi))}var Li={instrumentationKey:Ot,channels:Ze(Yt),extensions:pt,extensionConfig:xt};return sTe(Li,Yt),Li}function Ze(Ot){var Yt=a.cfg,pt=[[]];return Yt.channels&&Ra(Yt.channels,function(Lt,xt){js(Lt)||(pt[xt]=pt[xt]||[],pt[xt]=pt[xt].concat(Lt))}),Ot&&Ot.channels&&Ra(Ot.channels,function(Lt,xt){js(Lt)||(pt[xt]=pt[xt]||[],pt[xt]=pt[xt].concat(Lt))}),pt}function Xe(Ot){var Yt=[];return s&&s.length>0&&(Yt=Yt.concat(s)),Ot&&Ot.length>0&&(Yt=Yt.concat(Ot)),Yt}function bt(Ot,Yt,pt,Lt){var xt=_[Ot];xt&&(xt.inst&&xt.inst.isInitialized()?xt.inst.unload(Yt,function(yi){pt&&pt(Ot,yi)},Lt):pt&&pt(Ot,{reason:50,isAsync:Yt,flushComplete:!1}))}ze(),Ne.diagLog=function(){return ee||(ee=new l$(a.cfg)),ee},Ne.getCookieMgr=function(){return Pe(),Re||c.getCookieMgr()},Ne.setCookieMgr=function(Ot){Re=Ot,c&&c.setCookieMgr(Ot)},Ne.getPerfMgr=function(){return de||a&&a.cfg.enablePerfMgr&&(de=ue||new F9e(Ne.getNotifyMgr())),de},Ne.setPerfMgr=function(Ot){ue=Ot,de=Ot},Ne.create=function(Ot,Yt){se?ud(Ne.diagLog(),2,514,"Shared Manager has already been initialized."):(a=Qb(vyi(Ot?WGe({},Ot):{}),OWe,null),c=null,be(),Ee(Yt),se=!0)},Ne.getInst=function(Ot){return(_[Ot]||{}).inst},Ne.newInst=function(Ot,Yt,pt){var Lt=Ne.getInst(Ot);if(Lt)return ud(Ne.diagLog(),2,514,"Instance already exists for ["+Ot+"]"),Lt;if(Pe(),c.isInitialized()){var xt=Qe(Ot,Yt);if(N){var yi=LWe(N.identifier,xt);W&&yi&&W!==yi&&ud(Ne.diagLog(),2,511,"The endpointUrl mismatch, shared Url ["+W+"] is different from configured ["+yi+"] shared will be used!")}var Li=new byi(Ot,u);if(Lt=new NWe(Ne,Ne.diagLog(),Li),_[Ot]={iKey:Ot,inst:Lt,notifyMgr:Li},Lt.setPerfMgr(Ne.getPerfMgr()),Lt.initialize(xt,Xe(pt)),Lt.isInitialized()){var cn=Lt.config;jye(cn,{propertyConfiguration:{g:function(){return cn.extensionConfig[Nne]}}});try{delete cn.endpointUrl,delete cn.channelConfiguration,delete cn.propertyStorageOverride}catch{ud(Ne.diagLog(),2,108,"Failed to remove unused defaults!")}El(a.cfg,function(Ci,ji){nE(cn,Ci)||K2(Ci,"Symbol(")||vpi(fyi,Ci)||lTe(cn,Ci,ji)})}else ud(Ne.diagLog(),2,520,"Failed to initialize new instance!"),Lt=null,delete _[Ot]}return Lt},Ne.getSharedPlugin=function(Ot){Pe();var Yt=null,pt=c.getPlugin(Ot);return pt&&(Yt=pt.plugin),Yt},Ne.getPropertyManager=function(){return Pe(),k},Ne.getPostChannel=function(){return Pe(),N},Ne.getNotifyMgr=function(){return oe||(oe=new hne),oe},Ne.unload=function(Ot,Yt,pt){var Lt,xt=hC(_),yi=xt.length+1,Li={reason:50,isAsync:Ot,flushComplete:!1};function cn(Ci,ji){--yi==0&&(ze(),Yt&&Yt(ji))}return Ot&&!Yt&&(Lt=eL(function(Ci){Yt=Ci})),c&&(Ra(xt,function(Ci){bt(Ci,Ot,function(ji,An){cn(ji,An)},pt)}),c.isInitialized()&&(c.unload(Ot,function(Ci){cn(null,Li=Ci)},pt),c=null)),cn(null,Li),Lt},Ne.addUnloadHook=function(Ot){Pe(),c.addUnloadHook(Ot)},Ne.addSharedPlugin=function(Ot,Yt,pt,Lt){return Pe(),c.addPlugin(Ot,Yt,pt,Lt)},Ne.updateCfg=function(Ot,Yt){return Pe(),c.updateCfg(Ot,Yt)},Ne.evtNamespace=function(){return Pe(),c.evtNamespace()},Ne.addUnloadCb=function(Ot){Pe(),c.addUnloadCb(Ot)},Ne.onCfgChange=function(Ot){return Pe(),c.onCfgChange(Ot)},Ne[oTe]=function(Ot){Ot&&_.iKey&&delete _[Ot]}})}return n.__ieDyn=1,n}(),NWe=function(n){function a(s,c,u){var m,b=n.call(this)||this,_=s;return Ec(a,b,function(k,N){k.getSharedPropertyManager=function(){return _.getPropertyManager()},k.getSharedPostChannel=function(){return _.getPostChannel()},k.getOverridePropertyManager=function(){return m},k.initialize=function(W,ee){fC(k,function(){return"ApplicationInsights:initialize"},function(){var oe=[m=new myi];ee&&(oe=oe.concat(ee));var de=W.propertyConfiguration||{};if(W.propertyConfiguration)try{delete W.propertyConfiguration}catch{W.propertyConfiguration={}}W.extensionConfig=W.extensionConfig||{},W.extensionConfig[m.identifier]=de,W=Qb(W,Syi,c||k.logger,!1).cfg;try{N.initialize(W,oe,c,u)}catch(se){ud(k.logger,1,514,"Failed to initialize SDK."+Gs(se))}},function(){return{config:W,extensions:ee}})},k.unload=function(W,ee,oe){return _[oTe]&&_[oTe]((k.config||{}).instrumentationKey),N.unload(W,ee,oe)}}),b}return VS(a,n),a.__ieDyn=1,a}(sfi),xWe=class{constructor(n){this.key=n.config.bwSeedOptions.localStorageKey||"bwSeed";const a=localStorage.getItem(this.key);parseInt(a)||localStorage.setItem(this.key,n.config.bwSeedOptions.constValue.toString())}getSeed(){const n=localStorage.getItem(this.key),a=parseInt(n);return isNaN(a)?void 0:a}saveSeed(n){localStorage.setItem(this.key,n.toString())}static localStorageAvailable(){try{const n=window.localStorage,a="someKey";return n.setItem(a,"someValue"),n.removeItem(a),!0}catch{return!1}}},Cyi=class bq{constructor(a){bq.value??(bq.value=a.config.bwSeedOptions.constValue)}getSeed(){return bq.value}saveSeed(a){bq.value=a}},_yi=class{constructor(n){this.value=n}addValue(n){}getAggregated(){return this.value}},Eyi=class{addValue(n){this.value=n}getAggregated(){return this.value}},BWe=class{constructor(n){this.size=n,this.items=[]}clear(){this.items=[]}},Du=class extends BWe{get isFull(){return this.items.length>=this.size}add(n){return this.isFull&&this.items.shift(),this.items.push(n),!0}},Ayi=class extends BWe{add(n){return!(this.items.length>=this.size||(this.items.push(n),0))}},Iyi=class{constructor(n){this.values=new Du(n)}addValue(n){this.values.add(n)}getAggregated(){return Math.floor(uN(this.values.items))}},Al=class{constructor(){this.total=0,this.duration=0,this.max=0,this.minNonZero=Number.MAX_SAFE_INTEGER}get avg(){return this.duration!==0?this.total/this.duration:0}get maxSample(){return this.max}get minNonZeroSample(){return this.minNonZero}captureSample(n){(n||n===0)&&(this.total+=n,this.duration++,this.max=Math.max(n,this.max),n!==0&&(this.minNonZero=Math.min(n,this.minNonZero)))}},wyi=class{constructor(){this.sampleCounts={}}get min(){const n=Object.keys(this.sampleCounts).map(Number).filter(a=>a>0);return n.length>0?Math.min(...n):0}get max(){const n=Object.keys(this.sampleCounts).map(Number);return n.length>0?Math.max(...n):0}get mode(){const n=Object.keys(this.sampleCounts).map(Number);return n.length>0?n.reduce((a,s)=>this.sampleCounts[s]>this.sampleCounts[a]?s:a,n[0]):0}captureSample(n){var a;if(n!==void 0){const s=`${n}`;(a=this.sampleCounts)[s]??(a[s]=0),this.sampleCounts[s]++}}},Id=class{get delta(){if(this.cur!==void 0&&this.last!==void 0)return this.cur-this.last}captureSample(n,a){n!==void 0&&(this.cur!==void 0&&(this.last=this.cur),this.cur=n)}},Hd=class{constructor(n=0){this.precision=n}get delta(){if(this.currentSample!==void 0&&this.prevSample!==void 0){let n=1;return this.currentTimestamp!==void 0&&this.prevTimestamp!==void 0&&(n=(this.currentTimestamp-this.prevTimestamp)/1e3),n&&oa((this.currentSample-this.prevSample)/n,this.precision)}}captureSample(n,a){if(this.currentTimestamp!==a){if(n===void 0)return this.prevSample=void 0,this.currentSample=void 0,this.prevTimestamp=void 0,void(this.currentTimestamp=void 0);this.currentSample!==void 0&&(this.prevSample=this.currentSample),this.prevTimestamp=this.currentTimestamp,this.currentTimestamp=a,this.currentSample=n}}},kyi=class{constructor(){this.startTime=Date.now()}get elapsed(){return oa((Date.now()-this.startTime)/1e3,0)}},K9=class{constructor(n){this.numOfHistogramSamples=n,this.eventCount=0,this.totalActiveDuration=0,this.countBuckets={seconds1to3:0,seconds3to5:0,seconds5to8:0,seconds8to15:0,seconds15to60:0,seconds60toMax:0},this.timestampBuckets={seconds1to3:[],seconds3to5:[],seconds5to8:[],seconds8to15:[],seconds15to60:[],seconds60toMax:[]},this.averager=new Al}get active(){return!!this.current}get ongoingDuration(){return this.current?.elapsed||0}get avgDuration(){return this.averager.avg}get longestDuration(){return this.averager.maxSample}get numEvents(){return this.eventCount}get totalDuration(){return this.current?this.totalActiveDuration+this.current.elapsed:this.totalActiveDuration}get timestamps(){return fs(this.timestampBuckets)}get counts(){return fs(this.countBuckets)}set active(n){if(!this.current&&n)this.current=new kyi;else if(this.current&&!n){const a=this.current.elapsed;this.averager.captureSample(a),this.totalActiveDuration+=a;for(const s of Object.keys(ke.HISTOGRAM_BATCH))if(a<=ke.HISTOGRAM_BATCH[s]){this.countBuckets[s]++,Mo(this.timestampBuckets[s],this.current.startTime,this.numOfHistogramSamples);break}this.eventCount++,this.current=void 0}}},Xb=class{constructor(){this.sampleChangeCount=0,this.sampleDurations={}}get durations(){return fs(this.sampleDurations)}get sortedDurations(){return Object.keys(this.sampleDurations).sort((n,a)=>this.sampleDurations[a]-this.sampleDurations[n])}get durationRatios(){const n={};let a=0;for(const s in this.sampleDurations)a+=this.sampleDurations[s];for(const s in this.sampleDurations)n[s]=oa(this.sampleDurations[s]/a*100);return n}get changeCount(){return this.sampleChangeCount}captureSample(n){this.sampleDurations[n]||(this.sampleDurations[n]=0),this.sampleDurations[n]++,n!==this.lastSample&&(this.sampleChangeCount++,this.lastSample=n)}},xne=class{constructor(n,a){this.validTimeBetweenFramesArrival=n,this.invalidFPSAboveMax=a,this.lastSampleTimestamp=-1,this.fpsHarmonicSumWeigtsTs=0,this.fpsHarmonicWeigtedSumsFramePerDelayTs=0}captureSample(n){const a=Date.now();if(n>0&&this.lastSampleTimestamp>0){const s=a-this.lastSampleTimestamp;if(this.lastSampleTimestamp=a,s<0||s>this.validTimeBetweenFramesArrival||n>this.invalidFPSAboveMax)return;const c=s/n;this.fpsHarmonicSumWeigtsTs+=s,this.fpsHarmonicWeigtedSumsFramePerDelayTs+=s*c}(this.lastSampleTimestamp<0||n===0)&&(this.lastSampleTimestamp=a)}get harmonicMean(){return this.fpsHarmonicWeigtedSumsFramePerDelayTs>0?1e3*this.fpsHarmonicSumWeigtsTs/this.fpsHarmonicWeigtedSumsFramePerDelayTs:0}},S$=class{constructor(n){this.samplesNum=n,this.samples=[],this.sortedSamples=[],this.lastReport={avg:-1,max:-1,median:-1,p90:-1,volatilityPercent:-1}}isReportComplete(){return this.samples.length===this.samplesNum}getReport(){return this.lastReport}captureSample(n){n===void 0||n<0||(Mo(this.samples,n,this.samplesNum),this.sortedSamples=fs(this.samples).sort((a,s)=>a-s),this.lastReport={avg:this.getAvg(),median:this.calculatePercentile(50),p90:this.calculatePercentile(90),max:this.calculatePercentile(100),volatilityPercent:this.getVolatility()})}getAvg(){return uN(this.samples)}getVolatility(){const n=this.getAvg();if(n===0)return 0;let a=0;return this.samples.forEach(s=>{a+=Math.abs(s-n)}),oa(a/this.samples.length*100/n,2)}calculatePercentile(n){if(n<0||n>100)throw new Error("Percentile must be between 0 and 100");const a=n/100*(this.sortedSamples.length-1),s=Math.floor(a),c=Math.ceil(a),u=a-s;return c>=this.sortedSamples.length?this.sortedSamples[s]:this.sortedSamples[s]*(1-u)+this.sortedSamples[c]*u}},FWe=class{constructor(){this.duration=0,this.reportAggr={avg:0,max:0,median:0,p90:0,volatilityPercent:0}}captureSample(n){!n||n.avg<0||(this.reportAggr={avg:this.reportAggr.avg+n.avg,max:Math.max(this.reportAggr.max,n.max),median:this.reportAggr.median+n.median,p90:this.reportAggr.p90+n.p90,volatilityPercent:this.reportAggr.volatilityPercent+n.volatilityPercent},this.duration++)}getReport(){if(this.duration!==0)return{avg:this.reportAggr.avg/this.duration,max:this.reportAggr.max,median:this.reportAggr.median/this.duration,p90:this.reportAggr.p90/this.duration,volatilityPercent:this.reportAggr.volatilityPercent/this.duration}}},b$=class{constructor(n,a=0){this.overshootType=n,this.allowedOvershoot=a,this.past=[],this.totalOvershootDuration=0,this.lastAllowed=0}get isOvershooting(){return!!this.current}get events(){return this.current?[...this.past,this.current]:this.past}get totalDuration(){return this.totalOvershootDuration}captureSample(n,a){const s=oa(n-a);s>this.allowedOvershoot&&(this.lastAllowed===0||a===this.lastAllowed||!this.current&&a>this.lastAllowed)?(this.totalOvershootDuration++,this.current?(this.current.min=Math.min(this.current.min,s),this.current.max=Math.max(this.current.max,s)):this.current={timestamp:Date.now(),min:s,max:s,type:this.overshootType}):this.current&&(this.current.duration=Date.now()-this.current.timestamp,this.past.push(this.current),this.current=void 0),this.lastAllowed=a}},Bne=class{constructor(n=!1){this.disableNormalization=n,this.prevLost=0,this.prevReceived=0,this.minPackets=100}calculate(n,a){if(n===void 0||a===void 0)return;const s=n-this.prevReceived,c=a-this.prevLost;if(s+c<this.minPackets)return;this.prevReceived=n,this.prevLost=a;const u=c*(this.disableNormalization?1:this.minPackets)/(c+s);return u>(this.disableNormalization?1:this.minPackets)?0:u}},UWe=class{constructor(){this.capturedSamples=[]}captureSample(n){n&&this.capturedSamples.push(n)}calculateStd(){if(!this.capturedSamples.length)return;const n=this.capturedSamples.reduce((c,u)=>c+u,0)/this.capturedSamples.length,a=this.capturedSamples.map(c=>(c-n)**2),s=a.reduce((c,u)=>c+u,0)/a.length;return oa(Math.sqrt(s),2)}getFirst(){return this.capturedSamples[0]}getLast(){if(this.capturedSamples.length)return this.capturedSamples[this.capturedSamples.length-1]}calculatePercentile(n){if(!this.capturedSamples.length)return;const a=this.capturedSamples.sort((m,b)=>m-b),s=(a.length-1)*n,c=Math.floor(s),u=s-c;return a[c+1]!==void 0?a[c]+u*(a[c+1]-a[c]):a[c]}};function zWe(n){if(!n)return;const a=["libvpx","ffmpeg"];let s=!0;for(const c of a)if(n.toLowerCase().includes(c)){s=!1;break}return s}var Ryi=class{constructor(n){this.samplesCount=n,this.capturedSamples=[]}captureSample(n){n!==void 0&&Mo(this.capturedSamples,n,this.samplesCount)}getRate(){if(!this.capturedSamples.length)return;const n=this.samplesCount/this.capturedSamples.length;return this.capturedSamples.reduce((a,s)=>a+s)*n/this.samplesCount}},VWe=class{constructor(n=5){this.limit=n,this.curWidth=0,this.curHeight=0,this.resolutionSwitches=[]}captureSample(n,a){n===this.curWidth&&a===this.curHeight||(Mo(this.resolutionSwitches,`${n}x${a}`,this.limit),this.curWidth=n,this.curHeight=a)}get switches(){if(this.resolutionSwitches.length)return this.resolutionSwitches}};function $We(n,a,s){return n&&a?Math.ceil(n/ke.MACROBLOCK_SIZE)*Math.ceil(a/ke.MACROBLOCK_SIZE)*s:0}var HWe=class{constructor(){this.macroblockRateAveragerReceived=new Al,this.macroblockRateAveragerDecoded=new Al,this.maxDecoderLoss=0,this.decoderLoss=0}captureSample(n,a){this.macroblockRateAveragerReceived.captureSample(n),this.macroblockRateAveragerDecoded.captureSample(a);let s=this.maxDecoderLoss;n&&(s=(n-a)/n*100),this.decoderLoss=s,this.maxDecoderLoss=Math.max(s,this.maxDecoderLoss)}getReport(){return{macroblockRateReceivedMax:this.macroblockRateAveragerReceived.maxSample,macroblockRateReceivedAvg:this.macroblockRateAveragerReceived.avg,macroblockRateDecodedMax:this.macroblockRateAveragerDecoded.maxSample,macroblockRateDecodedAvg:this.macroblockRateAveragerDecoded.avg,macroblockRateMaxDecoderLossPercent:Math.floor(this.maxDecoderLoss),macroblockRateDecoderLossPercent:Math.floor(this.decoderLoss)}}},Myi=class{constructor(){this.codecReport={}}captureSample(n,a){var s,c;const u=n.split("/").pop();return this.activeMsi===void 0||this.activeMsi!==a?(this.activeMsi=a,this.previousCodec=u,void((s=this.codecReport)[a]??(s[a]={[u]:1,codecSwitchCounter:0}))):this.previousCodec!==u?((c=this.codecReport[a])[u]??(c[u]=0),this.codecReport[a][u]++,this.codecReport[a].codecSwitchCounter++,void(this.previousCodec=u)):void this.codecReport[a][u]++}get report(){return this.codecReport}},Pyi=class{constructor(n=5){this.limit=n,this.curPowerEfficientCodecState=!1,this.powerEfficientCodecEvents=[],this.powerEfficientCodecEventOnCount=0,this.powerEfficientCodecEventOffCount=0}captureSample(n,a){if(n!==this.curPowerEfficientCodecState){const s={timestamp:Date.now(),powerEfficient:n,frameHeight:a};Mo(this.powerEfficientCodecEvents,s,this.limit),this.curPowerEfficientCodecState=n,n?this.powerEfficientCodecEventOnCount++:this.powerEfficientCodecEventOffCount++}}get events(){if(this.powerEfficientCodecEvents.length)return this.powerEfficientCodecEvents}get eventOnCount(){return this.powerEfficientCodecEventOnCount}get eventOffCount(){return this.powerEfficientCodecEventOffCount}get curPowerEfficientEncoderState(){return this.curPowerEfficientCodecState}},Dyi=class{constructor(){this.bandwidthAverager=new Al}addValue(n){this.bandwidthAverager.captureSample(n)}getAggregated(){return Math.floor(this.bandwidthAverager.avg)}},jWe=-1,Lyi=class{constructor(n){this.configProvider=n,this.aggregator=this.getAggregator(),this.storage=this.getStorage(),this.cappingValue=this.configProvider.config.bwSeedOptions.cappingValue,this.minValue=this.configProvider.config.bwSeedOptions.minValue??jWe}getSeed(){const n=this.storage.getSeed()??jWe;return this.cappingValue>0?Math.min(Math.max(n,this.minValue),this.cappingValue):Math.max(n,this.minValue)}saveSeed(n){this.aggregator.addValue(n);const a=this.aggregator.getAggregated();this.storage.saveSeed(a)}getAggregator(){switch(this.configProvider.config.bwSeedOptions.aggregation){case"avg":return this.configProvider.config.bwSeedOptions.aggregateLastN>0?new Iyi(this.configProvider.config.bwSeedOptions.aggregateLastN):new Dyi;case"last":return new Eyi;default:return new _yi(this.configProvider.config.bwSeedOptions.constValue)}}getStorage(){return this.configProvider.config.bwSeedOptions.useLocalStorage&&xWe.localStorageAvailable()?new xWe(this.configProvider):new Cyi(this.configProvider)}},Oyi=dn;function cTe(n,a){const s=n.width/n.height,c=(0,Oyi.clone)(n);return s>a?c.width=Math.floor(n.height*a):s<a&&(c.height=Math.floor(n.width/a)),c}var Fne=class _Qe{constructor(a,s,c=!0,u=!1,m){this.audio=a,this.video=s,this.withTimeout=c,this.withEffect=u,this.withOverridenStream=m}clone(){const a=fs(this.video),s=fs(this.audio);return new _Qe(s,a,this.withTimeout,this.withEffect,this.withOverridenStream)}},GWe=class{constructor(n){this.logger=n}dispose(){}updateVideoConstraints(n,a,s){const c=this.calculateConstraints(a,s);this.logger.safe.info(`Calculated constraints: ${JSON.stringify(c)} from capabilities: ${JSON.stringify(a)}`);const u=c.resolution,m=c.fps,b=u&&(!_G(u.width,n.video.minWidth,n.video.maxWidth)||!_G(u.height,n.video.minHeight,n.video.maxHeight)),_=n.video.fps!==m;if(!b&&!_)return n;const k=n.clone();return b&&this.setResolution(k,u),_&&(k.video.fps=m),k}updateResolution(n,a){const s=n.clone();return this.setResolution(s,a),s}setResolution(n,a){n.video.maxWidth=a.width,n.video.minWidth=a.width,n.video.maxHeight=a.height,n.video.minHeight=a.height}getKey(n){return n.video?Am(n.video)?"video":n.video.deviceId&&n.video.minWidth&&n.video.minHeight?`${n.video.deviceId}x${n.video.minWidth}x${n.video.minHeight}`:n.video.minWidth&&n.video.minHeight?`${n.video.minWidth}x${n.video.minHeight}`:n.video.deviceId?`${n.video.deviceId}`:(this.logger.safe.error(`Cannot create key for constraints: ${uC(n)}`),""):"audio"}convertConstraints(n,a={}){if(!n)return null;const s=fs(a);return n?.deviceId&&(s.deviceId=n.deviceId),s}},Nyi=class{constructor(){this.MAX_SHARING_WIDTH=1920,this.MAX_SHARING_HEIGHT=1080}getResolutionTable(n,a){const s=this.constraintToMaxResolution(n,a);return this.generateResolutionTable(s)}constraintToMaxResolution(n,a){const s=this.getPortraitOrLandscapeMaxResolution(n),c=cTe({width:n.width,height:n.height},a),u=s.width/c.width,m=s.height/c.height,b=Math.min(u,m);return this.resizeResolution(c,b)}resizeResolution(n,a){return{width:Math.round(n.width*a),height:Math.round(n.height*a)}}getPortraitOrLandscapeMaxResolution(n){return n.width>n.height?{width:this.MAX_SHARING_WIDTH,height:this.MAX_SHARING_HEIGHT}:{width:this.MAX_SHARING_HEIGHT,height:this.MAX_SHARING_WIDTH}}ceilToMackroblockSize(n){const a=n.width,s=n.height;return{width:Math.ceil(a/ke.MACROBLOCK_SIZE)*ke.MACROBLOCK_SIZE,height:Math.ceil(s/ke.MACROBLOCK_SIZE)*ke.MACROBLOCK_SIZE}}generateResolutionTable(n){return[1,2/3,1/3,1/6].map(a=>this.resizeResolution(n,a)).map(a=>this.ceilToMackroblockSize(a))}},xyi=class{constructor(n){this.logger=n,this.FPS_TABLE=[15,7.5,3.75,1.875],this.resolutionTableCalculator=new Nyi,this.initialAspectRatio=null}calculateConstraints(n,a){this.initialAspectRatio||(this.initialAspectRatio=a.width/a.height);const s=this.resolutionTableCalculator.getResolutionTable(a,this.initialAspectRatio);let c={resolution:s[s.length-1],fps:this.FPS_TABLE[this.FPS_TABLE.length-1]};return s.some(u=>{const m=this.getFs(u);return this.FPS_TABLE.some(b=>{const _=this.getMbps(m,b);return m<=n.maxFs&&b<=n.maxFps&&_<=n.maxMbps&&(c={resolution:u,fps:b},!0)})})?this.logger.safe.info(`Calculated resolution: ${JSON.stringify(c)}`):this.logger.safe.error(`None of available resolutions are suitable: ${JSON.stringify(s)}. Fallback to: ${JSON.stringify(c)}`),c}getMbps(n,a){return n*a}getFs(n){return Math.ceil(n.width/ke.MACROBLOCK_SIZE)*Math.ceil(n.height/ke.MACROBLOCK_SIZE)}},qWe=class{constructor(n,a){this.logger=n,this.maxCapabilities=a}ensureValidity(n){this.throwIfMissing(n);const a=this.calculateMissing(n);return this.maxCapabilities&&this.applyMaxCapabilities(a),this.logger.safe.info(`Validating capabilities ${JSON.stringify(a)}`),a}throwIfMissing(n){if(!n.maxFs&&!n.maxMbps&&!n.maxFps||n.maxFs&&!n.maxMbps&&!n.maxFps||!n.maxFs&&n.maxMbps&&!n.maxFps||!n.maxFs&&!n.maxMbps&&n.maxFps)throw new Error(`Missing video capabilities ${JSON.stringify(n)}`)}calculateMissing(n){const a=Xp(n);return!n.maxFs&&n.maxMbps&&n.maxFps&&(a.maxFs=n.maxMbps/n.maxFps),n.maxFs&&!n.maxMbps&&n.maxFps&&(a.maxMbps=n.maxFs*n.maxFps),n.maxFs&&n.maxMbps&&!n.maxFps&&(a.maxFps=n.maxMbps/n.maxFs),a}applyMaxCapabilities(n){this.maxCapabilities.maxFs&&(n.maxFs=Math.min(n.maxFs,this.maxCapabilities.maxFs)),this.maxCapabilities.maxMbps&&(n.maxMbps=Math.min(n.maxMbps,this.maxCapabilities.maxMbps)),this.maxCapabilities.maxFps&&(n.maxFps=Math.min(n.maxFps,this.maxCapabilities.maxFps))}},Byi=8160,Fyi=15,WWe=class extends GWe{constructor(n,a){super(n),this.initialConstraints={maxWidth:1920,minWidth:1920,maxHeight:1080,minHeight:1080,fps:15},this.maxCapabilities={maxFs:Byi,maxFps:Fyi},this.validator=new qWe(this.logger.createChild("CV"),this.maxCapabilities),this.constraintsCalculator=new xyi(this.logger.createChild("CC")),a.config.resizeModeForSharing&&(this.initialConstraints.resizeMode=a.config.resizeModeForSharing)}createConstraintsObject(n){if(!n.sharing)throw new Error(`Sharing constraints are not presented: ${JSON.stringify(n)}`);const a=this.convertConstraints(n.sharing,this.initialConstraints),s=n.audio?n.audio:null;return s?.deviceId===ke.SYSTEM_AUDIO_SOURCE_ID&&delete s.deviceId,new Fne(s,a,!1,!1,n.withOverridenStream)}generatePolicies(n){return[n]}calculateConstraints(n,a){this.logger.safe.info(`Stream resolution is ${JSON.stringify(a)}`);const s=this.validator.ensureValidity(n);return this.constraintsCalculator.calculateConstraints(s,a)}},Uyi=class extends WWe{constructor(n,a,s){super(n,s);const c=a.screen.width/a.screen.height;c<1&&([this.initialConstraints.maxWidth,this.initialConstraints.maxHeight]=[this.initialConstraints.maxHeight,this.initialConstraints.maxWidth],[this.initialConstraints.minWidth,this.initialConstraints.minHeight]=[this.initialConstraints.minHeight,this.initialConstraints.minWidth]);let u=cTe({width:this.initialConstraints.maxWidth,height:this.initialConstraints.maxHeight},c);[this.initialConstraints.maxWidth,this.initialConstraints.maxHeight]=[u.width,u.height],u=cTe({width:this.initialConstraints.minWidth,height:this.initialConstraints.minHeight},c),[this.initialConstraints.minWidth,this.initialConstraints.minHeight]=[u.width,u.height]}},zyi=class extends GWe{constructor(n,a){super(a),this.configProvider=n}get currentMaxFS(){return this.streamConstraintsMaxFS??this.configProvider.config.webrtcCameraOpenFs}createConstraintsObject(n){const a={};n.audioProcessingFlags!==void 0&&(ul.isEngine("Chromium","ChromiumAVD")?(a.autoGainControl=!!(1&n.audioProcessingFlags),a.echoCancellation=!!(2&n.audioProcessingFlags),a.noiseSuppression=!!(4&n.audioProcessingFlags),this.configProvider.config.useGoogPrefixAudioConstraints&&(a.googAutoGainControl=!!(1&n.audioProcessingFlags),a.googAutoGainControl2=!!(1&n.audioProcessingFlags),a.googEchoCancellation=!!(2&n.audioProcessingFlags),a.googHighpassFilter=!!(4&n.audioProcessingFlags),a.googNoiseSuppression=!!(4&n.audioProcessingFlags),a.googTypingNoiseDetection=!!(4&n.audioProcessingFlags))):ul.isEngine("Safari","Firefox")?(a.autoGainControl=!!(1&n.audioProcessingFlags),a.echoCancellation=!!(2&n.audioProcessingFlags),a.noiseSuppression=!!(4&n.audioProcessingFlags)):this.logger.warn(`Unsupported browser engine for audio processing flags ${ul.getBrowserInfo().engine}`));const s=this.convertConstraints(n.audio,a);this.streamConstraintsMaxFS=n.videoMaxFS;const c=this.convertConstraints(n.video,this.initialVideoConstraints(this.currentMaxFS));return new Fne(s,c,n.withTimeout,n.withEffect,n.withOverridenStream)}calculateConstraints(n){const a=Math.min(n.maxFs,this.currentMaxFS);return{resolution:yl.Send.getResolutionByFs(a),fps:n.maxFps}}initialVideoConstraints(n){const a=yl.Send.getResolutionByFs(n);return{maxWidth:a.width,minWidth:a.width,maxHeight:a.height,minHeight:a.height,fps:this.configProvider.config.maxCameraOpenFps}}},KWe=class{static getProvider(n,a,s){if(n==="ScreenShare"){const c=s.createChild("SharingCP");return ul.isBrowser("Safari")?new Uyi(c,Cc.window,a):new WWe(c,a)}return new zyi(a,s.createChild("VideoCP"))}},Une=class{constructor(n,a,s){this.error=n,this.constraints=a,this.configProvider=s,this.permissionDeniedBySystemErrorMsg=["Permission denied by system","The request is not allowed by the user agent or the platform in the current context, possibly because the user denied permission."]}getMediaError(){let n;switch(this.error.name){case"SourceUnavailableError":case"TrackStartError":case"NotReadableError":case"AbortError":n={type:ke.MEDIA_ERROR.sourceUnavailableError,detail:`media device is already used by another process: ${nn(this.error)}`};break;case"ConstraintNotSatisfiedError":case"OverconstrainedError":n={type:ke.MEDIA_ERROR.constraintNotSatisfiedError,detail:`could not obtain constrained media stream: ${nn(this.error)}`};break;case"DevicesNotFoundError":case"NotFoundError":n=this.configProvider.config.permissionDeniedUFDWorkaround?{type:ke.MEDIA_ERROR.permissionDeniedBySystemError,detail:`no system permissions: ${nn(this.error)}`}:{type:ke.MEDIA_ERROR.devicesNotFoundError,detail:`specified device not found: ${nn(this.error)}`};break;case"NotAllowedError":n=this.permissionDeniedBySystemErrorMsg.some(a=>a===this.error.message)?{type:ke.MEDIA_ERROR.permissionDeniedBySystemError,detail:`no system permissions: ${nn(this.error)}`}:{type:ke.MEDIA_ERROR.permissionDeniedError,detail:`permission to use media device was denied: ${nn(this.error)}`};break;case"PermissionDeniedError":case"PermissionDismissedError":n={type:ke.MEDIA_ERROR.permissionDeniedError,detail:`permission to use media device was denied: ${nn(this.error)}`};break;case ke.MEDIA_ERROR.extensionNotFoundError:n={type:ke.MEDIA_ERROR.extensionNotFoundError,detail:`extension is not found: ${nn(this.error)}`};break;case ke.MEDIA_ERROR.chromeRuntimeNotDefinedError:n={type:ke.MEDIA_ERROR.chromeRuntimeNotDefinedError,detail:`chrome runtime is not defined: ${nn(this.error)}`};break;case ke.MEDIA_ERROR.sharingCancelledError:n=this.getSharingCancelledError(this.error);break;case ke.MEDIA_ERROR.mediaStreamRequestTimedOut:n={type:ke.MEDIA_ERROR.mediaStreamRequestTimedOut,detail:"Media Stream request timed out."};break;default:n=this.error.message===ke.MEDIA_ERROR.sharingCancelledError?this.getSharingCancelledError(this.error):{type:ke.MEDIA_ERROR.mediaStreamRequestError,detail:`media stream request error: ${nn(this.error)}`}}return n.isAudio=!!this.constraints.audio,n.detail+=` constraints: ${nn(uC(this.constraints))}`,n.message=n.detail,n}getSharingCancelledError(n){return{type:ke.MEDIA_ERROR.sharingCancelledError,detail:`screen sharing cancelled: ${nn(n)}`}}},JWe=class{constructor(n,a){this.logger=n,this.configProvider=a}static isSupported(){return!0}getStream(n){const a=this.constraintsAdapter.toGumConstraints(n);return this.logger.safe.info(`Constraints to be applied: ${JSON.stringify(uC(a))}`),new Promise((s,c)=>{Cc.window.navigator.getUserMedia(a,s,c)}).catch(s=>{throw new Une(s,n,this.configProvider).getMediaError()})}applyConstraints(n,a){if(!n?.getVideoTracks()?.[0])return Promise.reject("No video tracks found");const s=n.getVideoTracks()[0];return this.applyConstraintsForTrack(s,a)}applyConstraintsForTrack(n,a){const s=this.constraintsAdapter.toTrackConstraints(a);return n.applyConstraints?(this.logger.safe.info(`Apply constraints: ${JSON.stringify(s)} on ${JSON.stringify(n.id)}`),n.applyConstraints(s).catch(c=>{throw new Une(c,a,this.configProvider).getMediaError()})):Promise.reject("track.applyConstraints() is not supported")}},Vyi=class{constructor(n){this.configProvider=n}toGumConstraints(n){const a={};return n.audio&&(a.audio=fs(n.audio),a.audio.deviceId&&delete a.audio.deviceId,n.audio.deviceId&&n.audio.deviceId!==ke.MEDIA_DEVICE.defaultId&&(a.audio.deviceId=n.audio.deviceId)),n.video&&(a.video={mandatory:{}},n.video.deviceId&&(a.video.mandatory.sourceId=n.video.deviceId),n.video.minWidth&&(a.video.mandatory.minWidth=n.video.minWidth),n.video.maxWidth&&(a.video.mandatory.maxWidth=n.video.maxWidth),n.video.minHeight&&(a.video.mandatory.minHeight=n.video.minHeight),n.video.maxHeight&&(a.video.mandatory.maxHeight=n.video.maxHeight),n.video.fps&&(a.video.mandatory.maxFrameRate=n.video.fps,this.configProvider.config.setMinFpsForWebkit&&(a.video.mandatory.minFrameRate=this.configProvider.config.minCameraOpenFps,a.video.mandatory.idealFrameRate=n.video.fps)),Am(a.video.mandatory)&&delete a.video.mandatory),a}toTrackConstraints(n){const a={};return n.video&&(n.video.minWidth&&(a.width=n.video.minWidth),n.video.minHeight&&(a.height=n.video.minHeight),n.video.fps&&(a.frameRate=n.video.fps)),a}},$yi=class{constructor(n){this.configProvider=n}toGumConstraints(n){const a={};if(n.audio&&(a.audio=fs(n.audio),a.audio.deviceId&&delete a.audio.deviceId,n.audio.deviceId&&n.audio.deviceId!==ke.MEDIA_DEVICE.defaultId&&(a.audio.deviceId={exact:n.audio.deviceId})),n.video){a.video={width:{},height:{},frameRate:{}},n.video.deviceId&&(a.video.deviceId={exact:n.video.deviceId}),n.video.minWidth&&(a.video.width.min=n.video.minWidth),n.video.maxWidth&&(a.video.width.max=n.video.maxWidth),n.video.minHeight&&(a.video.height.min=n.video.minHeight),n.video.maxHeight&&(a.video.height.max=n.video.maxHeight),n.video.fps&&(a.video.frameRate.max=n.video.fps,a.video.frameRate.min=this.configProvider.config.minCameraOpenFps,a.video.frameRate.ideal=n.video.fps);for(const s in a.video)Am(a.video[s])&&delete a.video[s]}return a}toTrackConstraints(n){const a={};return n.video&&(n.video.minWidth&&(a.width=n.video.minWidth),n.video.minHeight&&(a.height=n.video.minHeight),n.video.fps&&(a.frameRate=n.video.fps)),a}},Hyi=class{toGumConstraints(n){if(!n?.video)throw new Error(`constraints cannot be applied: ${n}`);const a={video:{}},s=n.video.deviceId&&n.video.deviceId!==ke.DISPLAY_SOURCE_ID;return n.video.resizeMode&&(a.video.resizeMode=n.video.resizeMode),s&&(a.video.deviceId={exact:n.video.deviceId}),n.video.maxWidth&&(a.video.width={max:n.video.maxWidth},s&&(a.video.width.ideal=n.video.maxWidth)),n.video.maxHeight&&(a.video.height={max:n.video.maxHeight},s&&(a.video.height.ideal=n.video.maxHeight)),n.video.fps&&(a.video.frameRate=n.video.fps),n.audio&&(a.audio=!n.audio.deviceId||{deviceId:{exact:n.audio.deviceId}}),a}toTrackConstraints(n){const a=navigator.mediaDevices.getSupportedConstraints();if(!a)throw new Error("Constraints are not supported by browser");const s={};return a.width&&n.video.minWidth&&(s.width=n.video.minWidth),a.height&&n.video.minHeight&&(s.height=n.video.minHeight),a.frameRate&&n.video.fps&&(s.frameRate=n.video.fps),s.resizeMode=n.video.resizeMode,s}},jyi=class extends JWe{constructor(n,a){if(super(a.createChild("WebRTCProvider"),n),this.timeoutId=null,navigator.webkitGetUserMedia!==void 0&&webkitRTCPeerConnection!==void 0&&Kte()){if(!this.configProvider.config.overrideGumFromWebkit||!v7e)return void(this.constraintsAdapter=new Vyi(n));this.logger.safe.info("Overriding getUserMedia from webkit"),S7e()}this.constraintsAdapter=new $yi(n)}getStream(n){if(!n.withTimeout||!this.configProvider.config.gumRequestTimeout)return super.getStream(n);const a=this.startGumRequestTimer(n),s=super.getStream(n).then(c=>{if(!this.timeoutId)throw this.stopStreamAfterTimeout(c,n),this.getMediaStreamTimeoutError(n);return this.stopGumRequestTimer(),c});return Promise.race([a,s]).catch(c=>{throw this.stopGumRequestTimer(),c})}getMediaStreamTimeoutError(n){const a={name:ke.MEDIA_ERROR.mediaStreamRequestTimedOut,message:`Media stream request timed out. Constraints: ${nn(uC(n))}`};return new Une(a,n,this.configProvider).getMediaError()}startGumRequestTimer(n){return new Promise((a,s)=>{this.timeoutId=window.setTimeout(()=>{this.timeoutId=null,s(this.getMediaStreamTimeoutError(n))},this.configProvider.config.gumRequestTimeout)})}stopGumRequestTimer(){this.timeoutId&&(clearTimeout(this.timeoutId),this.timeoutId=null)}stopStreamAfterTimeout(n,a){this.logger.safe.info(`Stopping media stream acquired after timeout: ${JSON.stringify(n.id)} with constraints: ${JSON.stringify(a)}`);try{n.getTracks().forEach(s=>{this.logger.safe.info(`Track is stopped: ${JSON.stringify(s.id)}`),s.stop()}),this.logger.safe.info(`Media stream stopped: ${n.id}`)}catch(s){this.logger.safe.warn(`Failed to stop media stream: ${nn(s)}`)}}},YWe=class extends JWe{constructor(n,a){super(n.createChild("WebRTCDispProvider"),a),this.constraintsAdapter=new Hyi}static isSupported(){return!!window.navigator.mediaDevices.getDisplayMedia}getStream(n){const a=this.constraintsAdapter.toGumConstraints(n);return this.logger.safe.info(`Constraints to be used: ${JSON.stringify(a)}`),Promise.resolve().then(()=>n.video?.deviceId&&n.video?.deviceId!==ke.DISPLAY_SOURCE_ID?Cc.window.navigator.mediaDevices.getUserMedia(a):Cc.window.navigator.mediaDevices.getDisplayMedia(a)).catch(s=>{throw new Une(s,n,this.configProvider).getMediaError()})}},Gyi=class{constructor(n){this.detail=n}getStream(n){throw this.getError(n)}applyConstraints(n,a){throw this.getError(a)}applyConstraintsForTrack(n,a){throw this.getError(a)}getError(n){return{type:ke.MEDIA_ERROR.unsupportedStream,detail:this.detail,message:this.detail,isAudio:!!n.audio}}},QWe=class{static getStreamProvider(n,a,s){return n==="ScreenShare"?YWe.isSupported()?new YWe(s,a):(s.error("GUM stream provider cannot be created for display stream"),new Gyi("Sharing not supported")):new jyi(a,s)}},qyi=[30,15,7.5,3.75,1.875];function dTe(n){return n?.getVideoTracks?.()[0]?ZWe(n.getVideoTracks()[0]):null}function ZWe(n){const a=n?.getSettings?.();return a?{width:a.width,height:a.height}:null}function XWe(n){return n?.getVideoTracks?.()[0]?eKe(n.getVideoTracks()[0]):0}function eKe(n){const a=n?.getSettings?.();return a?pV(qyi,a.frameRate,!0):0}var Wyi=class extends jr{constructor(n,a,s,c,u,m,b){super(b),this.id=n,this.masterStream=a,this.currentConstraints=s,this.constraintsProvider=c,this.streamProvider=u,this.configProvider=m,this._isDisposed=!1,this.masterStreamSubscriptions=[],this.mixerSubscriptions=[],this.parentId=a.id,this.logger=b.createChild(`C:${this.parentId}:${this.id}`),this.subscribeOnMasterStreamEvents()}get rawTrack(){return this.mediaTrack}get rawStream(){return this.rawMediaStream||(this.rawMediaStream=new MediaStream([this.mediaTrack]),this.configProvider.config.reassignMediaStreamAudioTrackAfterCreation&&this.rawMediaStream.getAudioTracks().length>0&&(this.rawMediaStream.removeTrack(this.rawMediaStream.getAudioTracks()[0]),this.rawMediaStream.addTrack(this.mediaTrack))),this.rawMediaStream}get deviceId(){return this.masterStream.deviceId}get mediaType(){return this.masterStream.mediaType}get originalMediaStream(){return this.masterStream.getOriginalMediaStream()}getCurrentConstraints(){return this.currentConstraints}getMasterStream(){return this.masterStream}dispose(n){this._isDisposed||(this._isDisposed=!0,this.logger.safe.info(`dispose: ${n}`),this.logger=this.logger.createChild("DISPOSED"),this.event("onStreamClientDisposing").raise(this),this.mediaTrack&&(this.unsubscribeFromMediaTrackEvents(),this.mediaTrack=null),this.masterStream&&(this.unsubscribeFromMasterStreamEvents(),this.masterStream.disposeClient(this),this.masterStream=null),this.unsubscribeFromMixerTrackEvents(),super.dispose(),this.event("onStreamClientDisposed").raise(this))}async applyCapabilities(n){if(!this.mediaTrack)return!1;const a=this.constraintsProvider.updateVideoConstraints(this.currentConstraints,n,this.getResolution());if(!a||!this.configProvider.config.recoverOnStreamUnmute&&this.currentConstraints===a)return!1;const s=async u=>{try{return await this.streamProvider.applyConstraintsForTrack(this.mediaTrack,a),this.currentConstraints=a,!0}catch(m){if(u)throw this.logger.safe.error(`Apply constraints error: ${JSON.stringify(m)}`),m;return this.logger.safe.warn(`Apply constraints failed and will be re-tried, error ${JSON.stringify(m)}`),!1}},c=this.currentConstraints.withEffect&&this.configProvider.config.effectsApplyConstraintsRetryMs;return!await s(!c)&&c&&(await Br(this.configProvider.config.effectsApplyConstraintsRetryMs),await s(!0)),!0}start(){return this.masterStream.start()}clone(n){return this.masterStream||this.logger.safe.error(`clone: master stream is null, reason: ${n}`),this.masterStream.getClient(`streamclient: ${n}`)}setMuted(n,a){this.isMuted=n,this.applyState(a)}setHold(n,a){this.isHold=n,this.applyState(a)}isSameStream(n){return this.parentId===n.parentId}getResolution(){if(!["Video","ScreenShare","PanoramicVideo"].some(u=>u===this.mediaType))return null;const n={width:this.currentConstraints.video.minWidth,height:this.currentConstraints.video.minHeight},a=ZWe(this.mediaTrack),s=a?.width?a:n,c=`Track resolution is ${s.width}x${s.height}.`;return a?.width?this.logger.safe.info(c):this.logger.safe.error(`${c}. Resolution not found, assuming default resolution.'`),s}getFrameRate(){if(!["Video","ScreenShare","PanoramicVideo"].some(a=>a===this.mediaType))return null;const n=eKe(this.mediaTrack);return n===0?this.logger.safe.error("Stream frame rate is not avalable, returning 0"):this.logger.safe.info(`Stream fps is ${n}`),n}update(n){n?this.mediaTrack?this.logger.safe.error(`Media track is already created: ${this.mediaTrack.id}`):(this.mediaTrack=this.getTrackByMediaType(n,this.mediaType),this.updateTrackConstraints(),this.subscribeOnMediaTrackEvents(this.mediaTrack),this.hasMasterAudio=n&&n.getAudioTracks().length>0,this.hasMasterVideo=n&&n.getVideoTracks().length>0,this.hasMasterAudio&&this.hasMasterVideo&&(this.rawMediaStream=n),this.logger.safe.info(`Updated: ${V2(n)}`)):this.logger.safe.error("No master media stream, skipping update")}resetEffectsOutputConstraints(n){this.masterStream.resetEffectsOutputConstraints(n)}async updateTrackConstraints(){if(this.mediaType!=="ScreenShare")return;const n=this.masterStream.getResolution();if(n){const a=this.currentConstraints.clone();a.video.maxWidth=n.width,a.video.minWidth=n.width,a.video.maxHeight=n.height,a.video.minHeight=n.height;try{await this.streamProvider.applyConstraintsForTrack(this.mediaTrack,a),this.currentConstraints=a}catch(s){this.logger.safe.error(`Apply constraints error: ${JSON.stringify(s)}`)}}}getTrackByMediaType(n,a){return a==="Audio"?n.getAudioTracks()[0]:n.getVideoTracks()[0]}applyState(n){this.mediaTrack?.enabled!==void 0&&(this.mediaTrack.enabled=!this.isMuted&&!this.isHold,this.logger.safe.info(`[${n}] Track ${JSON.stringify(this.mediaTrack.id)} enabled state set to => ${this.mediaTrack.enabled}`))}subscribeOnMediaTrackEvents(n){n.onended=a=>{this.logger.safe.info(`Track ${n.id} ended: ${JSON.stringify(a)}`),this.event("onStreamClientEnded").raise(this,a)},n.onmute=()=>{this.logger.safe.info(`Track ${n.id} muted`),this.event("onStreamClientMuted").raise(this,!0)},n.onunmute=()=>{this.logger.safe.info(`Track ${n.id} unmuted`),this.event("onStreamClientMuted").raise(this,!1)}}unsubscribeFromMediaTrackEvents(){this.mediaTrack.onended=null,this.mediaTrack.onmute=null,this.mediaTrack.onunmute=null}unsubscribeFromMixerTrackEvents(){this.mixerSubscriptions.forEach(n=>n.dispose()),this.mixerSubscriptions=[]}subscribeOnMasterStreamEvents(){this.masterStreamSubscriptions.push(this.masterStream.on("onStreamStarted",(n,a)=>this.event("onStreamClientStarted").raise(this,a)),this.masterStream.on("onStreamError",(n,a)=>this.event("onStreamClientError").raise(this,a)),this.masterStream.on("onStreamTrackMuted",(n,a)=>this.event("onStreamClientMuted").raise(this,a)),this.masterStream.on("onStreamDisposing",n=>this.dispose()),this.masterStream.on("onStreamQualityChanged",(n,a,s,c)=>this.event("onStreamQualityChanged").raise(this,a,s,c)),this.masterStream.on("onStreamTrackEnded",(n,a)=>this.event("onStreamClientEnded").raise(this,a)))}unsubscribeFromMasterStreamEvents(){this.masterStreamSubscriptions.forEach(n=>n.dispose()),this.masterStreamSubscriptions=[]}hasAudio(){return this.hasMasterAudio}hasVideo(){return this.hasMasterVideo}isActive(){return this.mediaTrack?.enabled&&!this.mediaTrack?.muted&&this.mediaTrack?.readyState==="live"}onVideoStreamQualityChanged(n,a,s){this.logger.safe.debug(`onStreamQualityChanged: ${JSON.stringify(n)}@${a}, reason=${s}`),this.masterStream.onVideoStreamQualityChanged(n,a,s)}isDisposed(){return this._isDisposed}},Kyi=class extends jr{constructor(n,a,s,c,u,m){super(m),this.stream=n,this.constraints=a,this.constraintsProvider=s,this.gumStreamProvider=c,this.configProvider=u,this.logger=m,this.clients=[],this.streams=[],this.clientId=0,this.mediaStreamSubscription=this.stream.on("onStreamAcquired",()=>this.onStreamAcquired())}getClient(){const n=new Wyi(this.clientId++,this.stream,this.constraints,this.constraintsProvider,this.gumStreamProvider,this.configProvider,this.logger);return this.addClient(n),n}disposeClient(n){this.removeClient(n),this.clients.length||this.event("onAllClientsDisposed").raise()}dispose(){this.mediaStreamSubscription.dispose(),this.clients.length&&this.logger.safe.error(`Not all clients are disposed! ${JSON.stringify(this.clients.map(n=>n.id))}`),this.streams.forEach(n=>this.disposeStream(n)),super.dispose()}getOrCreateStream(){const n=this.streams.length?this.streams[this.streams.length-1]:this.stream.rawStream;if(!n)return null;const a=n.clone();return this.logger.safe.info(`Cloned: ${V2(n)} -> ${V2(a)}`),this.resetStream(a),this.streams.push(a),a}addClient(n){this.updateClient(n),this.clients.push(n)}updateClient(n){const a=this.getOrCreateStream();a&&n.update(a)}removeClient(n){const a=this.clients.indexOf(n);this.clients.splice(a,1)}addStream(){this.clients.forEach(n=>this.updateClient(n))}disposeStream(n){n.getTracks().forEach(a=>{this.logger.safe.info(`Stopping track: ${JSON.stringify(a.id)}`),a.stop()})}onStreamAcquired(){this.addStream()}resetStream(n){n.getTracks().forEach(a=>{this.logger.safe.info(`Resetting state for track: ${a.id}`),a.enabled=!0})}},tKe=class{constructor(){}getPolicies(n){if(n.audio&&!n.video&&this.hasAudioProcessingConstraints(n))return[n,new Fne({deviceId:n.audio.deviceId},null)];if(!n.video)return[n];const a=this.getSuitableResolutions(n).map(m=>this.getConstraintsForResolution(n,m)),s=n.audio,c={deviceId:n.video.deviceId},u=new Fne(s,c,n.withTimeout);return a.push(u),a}getSuitableResolutions(n){return yl.Send.getResolutions().filter(a=>a.width<=n.video.maxWidth&&a.height<=n.video.maxHeight).reverse()}getConstraintsForResolution(n,a){const s=n.clone();return s.video.minWidth=a.width,s.video.minHeight=a.height,s}hasAudioProcessingConstraints(n){const a=n&&n.audio;return a&&(a.echoCancellation!==void 0||a.autoGainControl!==void 0||a.noiseSuppression!==void 0)}},Jyi=class{static getStrategy(n,a,s,c,u,m){return m?new Zyi(s,c):n==="Video"?new Qyi(a,s,c,u):new Yyi(a,s,c)}},uTe=class{constructor(n,a,s){this.gumStreamProvider=n,this.serialQueue=a,this.logger=s}getStream(n){return this.logger.safe.info(`Requesting stream with constraints: ${JSON.stringify(uC(n))}`),this.serialQueue.add(()=>this.request(n))}},Yyi=class extends uTe{constructor(n,a,s){super(n,a,s.createChild("SimpleStrat"))}request(n){return this.gumStreamProvider.getStream(n)}},Qyi=class extends uTe{constructor(n,a,s,c){super(n,a,s.createChild("MultStrat")),this.policyGenerator=new tKe}request(n){const a=this.policyGenerator.getPolicies(n);return this.makeRequests(a)}makeRequests(n){const a=n[0];return this.logger.safe.info(`Requesting media stream with policy: ${JSON.stringify(a)}`),this.makeRequestWithPolicy(a).catch(s=>{const c=n.slice(1);if(c.length&&ke.MEDIA_ERROR.constraintNotSatisfiedError===s.type)return this.logger.safe.warn("Could not obtain constrained media stream, will attempt weaker policy"),this.makeRequests(c);throw s})}makeRequestWithPolicy(n){return this.gumStreamProvider.getStream(n)}},Zyi=class extends uTe{constructor(n,a){super(null,n,a.createChild("WithOveriddenStreamStart"))}request(n){return new Promise((a,s)=>a(n.withOverridenStream))}},iKe=class EQe extends jr{constructor(a,s,c,u,m){super(u),this.serialQueue=s,this.configProvider=c,this.effectManager=m,this.gumRequestTime=0,this.id=EQe.streamId++,this.logger=u.createChild(`MediaStream:${this.id}`),this.mediaType=this.getMediaType(a),this.initialize(a)}get rawStream(){return this.mediaStream}get deviceId(){return this.originalMediaStream?this.originalMediaStream.getTracks()?.[0]?.getSettings?.()?.deviceId:null}start(){return this.mediaStreamStartPromise||(this.mediaStreamStartPromise=this.startStream(this.currentConstraints)),this.mediaStreamStartPromise}dispose(a){this.event("onStreamDisposing").raise(this),this.stopMediaStream(a).catch(s=>{this.event("onStreamError").raise(this,s)}).finally(()=>{this.constraintsProvider=null,this.serialQueue=null,this.configProvider=null,this.logger=this.logger.createChild("DISPOSED"),this.clientGenerationStrategy.dispose(),this.event("onStreamDisposed").raise(this),super.dispose()})}disposeClient(a){this.clientGenerationStrategy.disposeClient(a)}getClient(a){return this.logger.safe.debug(`getClient: ${a}`),this.clientGenerationStrategy.getClient()}getOriginalMediaStream(){return this.originalMediaStream}getResolution(){if(!["Video","ScreenShare","PanoramicVideo"].some(m=>m===this.mediaType))return null;const a={width:this.currentConstraints.video.minWidth,height:this.currentConstraints.video.minHeight},s=dTe(this.mediaStream),c=s??a,u=`Stream resolution is ${c.width}x${c.height}.`;return s?this.logger.safe.info(u):this.logger.safe.error(`${u}. Resolution not found, assuming default resolution.'`),c}getFrameRate(){if(!["Video","ScreenShare","PanoramicVideo"].some(s=>s===this.mediaType))return null;const a=XWe(this.mediaStream);return a===0?this.logger.safe.error("Stream frame rate is not avalable, returning 0"):this.logger.safe.info(`Stream fps is ${a}`),a}getMediaType(a){if(a.sharing)return"ScreenShare";if(a.video)return"Video";if(a.audio)return"Audio";throw new Error(`Media type is not defined: ${JSON.stringify(a)}`)}resetEffectsOutputConstraints(a){const s=dTe(this.originalMediaStream);this.effectManager.resetOutputConstraints("Video",{width:Math.min(a.width,s.width||Number.MAX_SAFE_INTEGER),height:Math.min(a.height,s.height||Number.MAX_SAFE_INTEGER)})}initialize(a){this.constraintsProvider=KWe.getProvider(this.mediaType,this.configProvider,this.logger),this.currentConstraints=this.constraintsProvider.createConstraintsObject(a),this.gumStreamProvider=QWe.getStreamProvider(this.mediaType,this.configProvider,this.logger),this.mediaStreamRequestStrategy=Jyi.getStrategy(this.mediaType,this.gumStreamProvider,this.serialQueue,this.logger,this.configProvider,!!this.currentConstraints.withOverridenStream),this.clientGenerationStrategy=new Kyi(this,this.currentConstraints,this.constraintsProvider,this.gumStreamProvider,this.configProvider,this.logger),this.clientGenerationStrategy.on("onAllClientsDisposed",()=>this.onAllClientsDisposed())}onAllClientsDisposed(){this.logger.safe.info("All clients are disposed, disposing master stream"),this.dispose()}async startStream(a){try{await this.getOrCreateMediaStream(a),this.event("onStreamStarted").raise(this,this.currentConstraints)}catch(s){throw this.event("onStreamError").raise(this,s),s}}async getOrCreateMediaStream(a){if(this.mediaStream)return Promise.resolve();const s=this.getRequestStartTimestamp(),c=await this.mediaStreamRequestStrategy.getStream(a);return this.gumRequestTime=this.getRequestDuration(s),this.handleMediaStreamRequestSuccess(c,a)}async handleMediaStreamRequestSuccess(a,s){this.logger.safe.info(`Media stream acquired: ${V2(a)} with constraints: ${JSON.stringify(uC(s))}`),this.originalMediaStream=a,this.subscribeToTrackEvents(this.originalMediaStream),this.currentConstraints=s,this.mediaStream=await this.applyEffects(a),this.applyState(this.mediaStream),this.event("onStreamAcquired").raise(this,this.gumRequestTime,this.mediaType!=="Audio"&&this.getResolution()||void 0)}async applyEffects(a){switch(this.mediaType){case"Video":return this.getVideoEffectStream(a);case"Audio":return this.startNoiseSuppression(a);case"ScreenShare":return this.delayScreenShare(a)}return a}async delayScreenShare(a){return this.configProvider.config.useDelayedScreenShareStream?this.effectManager.startEffect("ScreenShare",a):a}async startNoiseSuppression(a){return this.configProvider.config.applyAudioEffectOnDemand&&!this.currentConstraints.withEffect?a:(this.logger.safe.info(`ECS keys for wasmvqe are: ${JSON.stringify(this.configProvider.config.wasmvqe)}`),this.logger.safe.info(`ECS keys for wasmdns are: ${JSON.stringify(this.configProvider.config.wasmdns)}`),await this.effectManager.startEffect("Audio",a))}async getVideoEffectStream(a){if(!this.currentConstraints.withEffect||this.currentConstraints.withOverridenStream&&this.configProvider.config.useRawMediaApiForVideoEffects)return a;this.sub=this.effectManager.on("onVideoStreamQualityChanged",(c,u,m)=>this.onVideoStreamQualityChanged(c,u,m));const s=await this.effectManager.startEffect("Video",a);return this.logger.safe.info(`Media stream switched: ${V2(a)} -> ${V2(s)}`),s}subscribeToTrackEvents(a){const s=a?this.getTrackByMediaType(a,this.mediaType):null;s&&(s.onended=c=>{this.logger.safe.info(`Track ${s.id} ended: ${JSON.stringify(c)}`),this.event("onStreamTrackEnded").raise(this,c)},s.onmute=()=>{this.logger.safe.info(`Track ${s.id} muted`),this.event("onStreamTrackMuted").raise(this,!0)},s.onunmute=()=>{this.logger.safe.info(`Track ${s.id} unmute`),this.event("onStreamTrackMuted").raise(this,!1)})}unsubscribeFromTrackEvents(a){const s=a?this.getTrackByMediaType(a,this.mediaType):null;s&&(s.onended=null,s.onmute=null,s.onunmute=null)}getTrackByMediaType(a,s){return s==="Audio"?a.getAudioTracks()[0]:a.getVideoTracks()[0]}removeVideoEffectStream(){this.sub?.dispose(),this.effectManager.stopEffect("Video",this.mediaStream)}applyState(a){a.getAudioTracks()?.forEach(c=>this.applyAudioState(c));const s=a.getVideoTracks()[0];this.applyVideoState(s)}applyAudioState(a){a&&(this.hasNonDefaultAudioProcessingConstraints()||this.mediaType==="ScreenShare"?this.applyContentHint(a,"music"):this.configProvider.config.defaultAudioContentHint&&this.applyContentHint(a,this.configProvider.config.defaultAudioContentHint),a.muted&&this.event("onStreamTrackMuted").raise(this,!0),this.logger.safe.info(`Audio track added: ${JSON.stringify(a.id)}`))}applyVideoState(a){a&&(this.mediaType==="ScreenShare"&&this.configProvider.config.webrtcDisplayStreamContentHint&&this.applyContentHint(a,this.configProvider.config.webrtcDisplayStreamContentHint),this.logger.safe.info(`Video track added: ${JSON.stringify(a.id)}`))}applyContentHint(a,s){this.logger.safe.info(`Apply content hint: ${s}`),a.contentHint=s}hasNonDefaultAudioProcessingConstraints(){const a=this.currentConstraints.audio;if(a){const s=this.configProvider.config.defaultAudioProcessingFlags;let c;return a.echoCancellation===void 0&&a.autoGainControl===void 0&&a.noiseSuppression===void 0||(c=0,a.echoCancellation!==void 0&&(c+=a.echoCancellation?2:0),a.autoGainControl!==void 0&&(c+=a.autoGainControl?1:0),a.noiseSuppression!==void 0&&(c+=a.noiseSuppression?4:0)),c!==s}return!1}getRequestStartTimestamp(){return Date.now()}getRequestDuration(a){return a===0?0:Date.now()-a}stopMediaStream(a){return this.mediaStreamStartPromise?(this.logger.safe.info(`Queueing media stream stop: ${a}`),this.serialQueue.add(()=>this.stopMediaStreamInternal())):Promise.resolve()}stopOneMediaStream(a){try{a.getTracks().forEach(s=>{this.logger.safe.info(`Track is stopped: ${JSON.stringify(s.id)}`),s.stop()}),this.logger.safe.info(`Media stream stopped: ${a.id}`)}catch(s){this.logger.safe.warn(`Failed to stop media stream: ${nn(s)}`)}}stopMediaStreamInternal(){this.mediaType==="Video"&&this.configProvider.config.enableVideoEffects&&this.removeVideoEffectStream(),this.mediaStream&&(this.stopOneMediaStream(this.mediaStream),this.mediaStream=null),this.originalMediaStream&&(this.stopOneMediaStream(this.originalMediaStream),this.unsubscribeFromTrackEvents(this.originalMediaStream),this.originalMediaStream=null)}onVideoStreamQualityChanged(a,s,c){this.logger.safe.debug(`onStreamQualityChanged: ${JSON.stringify(a)}@${s}, reason=${c}`),this.event("onStreamQualityChanged").raise(this,a,s,c)}};iKe.streamId=0;var Xyi=iKe,eSi=class{static getStrategy(n){switch(n.config.diagnostics.performanceMonitoring.monitoringStrategy){case"decodeTime":default:return new tSi(n);case"renderedFps":return new iSi(n);case"rendererVolatility":return new nSi(n)}}},tSi=class{constructor(n){this.configProvider=n,this.decodeThresholds=this.configProvider.config.diagnostics.performanceMonitoring.decodeThresholds,this.defaultThreshold=this.configProvider.config.diagnostics.performanceMonitoring.defaultThrehold,this.badPerfCount=new Map}checkQuality(n){let a=!1,s=!1;const c=yl.Recv.getResolutionRecord(Math.min(n.frameHeight,n.frameWidth)).height,u=this.decodeThresholds[c]||this.defaultThreshold,m=n.decodeTimeTracker.getReport();return m.median>u.maxDecodeTime&&(this.badPerfCount.set(n.msi,this.badPerfCount.get(n.msi)||1),a=!0),m.median<u.maxDecodeTime&&this.badPerfCount.get(n.msi)&&(this.badPerfCount.set(n.msi,this.badPerfCount.get(n.msi)-1),s=!0),a?0:s?2:1}},iSi=class{constructor(n){this.configProvider=n,this.fpsDiffThresholds=this.configProvider.config.diagnostics.performanceMonitoring.fpsDiffThresholds,this.defaultFpsDiffThreshold=this.configProvider.config.diagnostics.performanceMonitoring.defaultFpsDiffThreshold,this.badPerfCount=new Map}checkQuality(n){let a=!1,s=!1;const c=yl.Recv.getResolutionRecord(Math.min(n.frameHeight,n.frameWidth)).height,u=this.fpsDiffThresholds[c]||this.defaultFpsDiffThreshold,m=n.incomingFps.getReport(),b=n.rendererFps.getReport(),_=m.median-b.median;return _>=u.fpsDiff&&(this.badPerfCount.set(n.msi,this.badPerfCount.get(n.msi)||1),a=!0),_<u.fpsDiff&&this.badPerfCount.get(n.msi)&&(this.badPerfCount.set(n.msi,this.badPerfCount.get(n.msi)-1),s=!0),a?0:s?2:1}},nSi=class{constructor(n){this.configProvider=n,this.volatilityThresholds=this.configProvider.config.diagnostics.performanceMonitoring.volatilityThresholds,this.defaultVolatilityThreshold=this.configProvider.config.diagnostics.performanceMonitoring.defaultVolatilityThreshold,this.badPerfCount=new Map}checkQuality(n){let a=!1,s=!1;const c=yl.Recv.getResolutionRecord(Math.min(n.frameHeight,n.frameWidth)).height,u=this.volatilityThresholds[c]||this.defaultVolatilityThreshold,m=n.rendererFps.getReport(),b=n.incomingFps.getReport(),_=Math.abs(m.volatilityPercent-b.volatilityPercent);return u&&_>=u&&(this.badPerfCount.set(n.msi,this.badPerfCount.get(n.msi)||1),a=!0),_<u&&this.badPerfCount.get(n.msi)&&(this.badPerfCount.set(n.msi,this.badPerfCount.get(n.msi)-1),s=!0),a?0:s?2:1}},aSi=class{constructor(n,a){this.streamClient=n,this.logger=a,this.rawBaseClient=new gye(()=>this.getStream(),()=>this.activeRawInputMediaStreamClient?.dispose(),a)}client(){return this.rawBaseClient}disposeActiveMediaStreamClient(){this.logger.info("Disposing active media stream client"),this.activeRawInputMediaStreamClient?.dispose("Disposed by RawDeviceStreamManager"),this.activeRawInputMediaStreamClient=null}async getStream(){return this.activeRawInputMediaStreamClient?.originalMediaStream?.active?(this.logger.info("Returning stream from active mediaStreamClient"),this.activeRawInputMediaStreamClient.originalMediaStream):(this.activeRawInputMediaStreamClient=await this.streamClient(),await this.activeRawInputMediaStreamClient.start(),this.activeRawInputMediaStreamClient.originalMediaStream)}},rSi=class{constructor(n,a){this.logger=n,this.raiseTelemetryEvent=a,this.handlerMap=new Map([["Audio",new Map],["Video",new Map],["ScreenShare",new Map]])}dispose(n){this.logger.info(`disposing IRawStream ${n}`),this.handlerMap.get(n).forEach(a=>a.client().dispose())}disposeAll(){this.logger.info("Dispose All clients"),this.handlerMap.forEach(n=>n.forEach(a=>a.client().dispose()))}notifyChange(n){this.handlerMap.get(n).forEach(a=>{a.disposeActiveMediaStreamClient(),a.client().notifyStreamChange()})}createIRawStreamClient(n,a){this.logger.info(`Create new IRawStream client for ${a}`);const s=new aSi(n,this.logger);return this.handlerAdded(s,a),s.client()}handlerAdded(n,a){const s=n.client();this.setClientSubscription(s,a),this.handlerMap.get(a).set(s.clientId,n)}deleteRawStreamManagerById(n,a){this.logger.info(`Deleting from map: ${a}`),this.handlerMap.get(a).delete(n)}setClientSubscription(n,a){this.logger.info(`Setting subscription on IRawStream client for ${a}`),n.on("clientDisposed",s=>{this.deleteRawStreamManagerById(n.clientId,a),this.raiseTelemetryEvent("IRawStream_client_disposed",{mediaType:a,clientId:s})}),n.on("rawStreamRequested",s=>{this.raiseTelemetryEvent("IRawStream_media_stream_changed",{mediaType:a,clientId:s})}),n.on("notifiedOnStreamChanged",s=>this.raiseTelemetryEvent("IRawStream_media_stream_changed",{mediaType:a,clientId:s}))}},hTe=class extends jr{constructor(n,a,s){super(n),this.logger=n,this.configProvider=a,this.audioRendererDiagnostics=s,this.window=Cc.window,this.isMuted=!1,this.isPlayingAllowed=!1,this.hadPlaybackError=!1,this.id=sw(),this.onAudioError=c=>{const u=c&&c.target||this.audio;if(this.hadPlaybackError=!0,u?.error){const m=u.error.code,b=`error with rendering audio code: ${m}, message: ${u.error.message}`;this.event("onAudioPlaybackError").raise(m,ke.MEDIA_ERROR.audioPlaybackError,b),this.logger.safe.error(b)}else this.logger.safe.error("error with audio rendering")},this.onAudioPaused=async()=>{if(this.configProvider.config.audioRendererRestartOnPause&&this.canPlay&&!this.isMuted){const c=hi();this.logger.safe.info(`[${c}] audio playback is paused by OS, resuming it`),await this.startStream(c)}},this.onAudioPlayed=()=>{this.audioRendererDiagnostics?.registerSuccessfullReopen(this.deviceId),this.logger.safe.info("Audio element started playing")}}get canPlay(){return this.stream&&this.isPlayingAllowed}get muted(){return this.isMuted}async setMuted(n,a){return this.isMuted=n,n?this.stopStream(a):this.startStream(a)}async getSpeakerVolume(n){const a=this.audio?.volume??0;return this.logger.safe.info(`[${n}] get speaker volume: ${a}`),a}async setSpeakerVolume(n,a){this.assureAudioElement(a),this.audio.volume=n,this.logger.safe.info(`[${a}] set speaker volume: ${n}`)}getStream(){return this.stream}getDeviceId(){return this.deviceId}async play(n){if(this.stream=n,this.isPlayingAllowed=!0,!this.isMuted)return this.startStream()}stop(){this.stopStream(),this.isPlayingAllowed=!1}async setOutputDevice(n,a=hi()){if(this.audio)if(this.configProvider.config.disableAudioOutputSelection)this.logger.safe.warn(`[${a}] audio-output selection is disabled, disableAudioOutputSelection: true`);else if(this.audio.setSinkId){if(n&&n!==this.currentSinkId){this.logger.safe.info(`[${a}] setting audio output device ID to ${kn(n)}`),this.deviceId=n;try{this.configProvider.config.audioSetSinkIdWorkaround&&this.stream&&!this.stream.active?(this.audio.srcObject=null,await this.audio.setSinkId(n),this.audio.srcObject=this.stream):await this.audio.setSinkId(n),this.currentSinkId=n}catch(s){this.logger.safe.warn(`[${a}] setSinkId operation was aborted with error ${nn(s)}`)}this.configProvider.config.audioRendererRestartOnDeviceError&&this.hadPlaybackError&&!this.isMuted&&(this.audioRendererDiagnostics?.registerReopenRequest(n),this.logger.safe.info(`[${a}] audio playback error happened, restarting audio stream on new device`),await this.startStream(a),this.hadPlaybackError=!1)}}else this.logger.safe.warn(`[${a}] setting output device is not supported`);else this.deviceId=n}dispose(){this.logger.safe.info("dispose"),super.dispose(),this.audio&&(this.stop(),this.stream=void 0,this.audio.removeEventListener("error",this.onAudioError),this.audio.removeEventListener("pause",this.onAudioPaused),this.audio.removeEventListener("play",this.onAudioPlayed),this.window.document.body.removeChild(this.audio),this.event("onAudioElementRemoved").raise(this.audio),this.currentSinkId=void 0,this.audio=void 0),this.detachGainNode()}async startStream(n=hi()){if(this.canPlay)try{await this.assureAudioElement(n),this.logger.safe.info(`[${n}] attaching stream to renderer: ${this.stream?.id}`),this.configProvider.config.speakerGainLevel&&this.reattachToGainNode(this.stream,this.configProvider.config.speakerGainLevel),this.audio.srcObject=this.stream,await this.audio.play(),this.event("onAudioStateChanged").raise(this.stream,this.id)}catch(a){this.logger.safe.warn(`[${n}] play operation was aborted with error ${nn(a)}`)}}async assureAudioElement(n=hi()){if(!this.audio)return this.logger.safe.info(`[${n}] creating audio element`),this.audio=this.window.document.createElement("audio"),this.audio.addEventListener("error",this.onAudioError),this.audio.addEventListener("pause",this.onAudioPaused),this.audio.addEventListener("play",this.onAudioPlayed),this.window.document.body.appendChild(this.audio),this.audio.autoplay=!0,this.event("onAudioElementAdded").raise(this.audio),this.setOutputDevice(this.deviceId,n)}stopStream(n=hi()){this.audio&&this.canPlay&&(this.detachGainNode(),this.configProvider.config.audioRendererUsePauseOnDetach?(this.logger.safe.info(`[${n}] Pausing with stream: ${this.stream?.id}`),this.audio.pause()):(this.logger.safe.info(`[${n}] Detaching from stream: ${this.stream?.id}`),this.audio.srcObject=null),this.event("onAudioStateChanged").raise(null,this.id))}attachToGainNode(n,a){this.audioContext=new Cc.window.AudioContext,this.sourceNode=this.audioContext.createMediaStreamSource(n),this.gainNode=this.audioContext.createGain(),this.gainNode.gain.value=a,this.sourceNode.connect(this.gainNode),this.gainNode.connect(this.audioContext.destination)}detachGainNode(){this.sourceNode?.disconnect(),this.sourceNode=void 0,this.gainNode?.disconnect(),this.gainNode=void 0,this.audioContext?.close(),this.audioContext=void 0}reattachToGainNode(n,a){this.detachGainNode(),this.attachToGainNode(n,a)}},iL=class{constructor(n){this.logger=n,this.queue=Promise.resolve()}add(n,a=hi()){let s;s=n instanceof Pi?()=>n.promise:n;const c=this.queue.then(s);return this.queue=c.catch(u=>{if(this.queue){let m="";u instanceof TypeError&&(m=u.stack),this.logger.safe.error(`[${a}] Error from promiseQueue! ${nn(u)} ${m}`)}}),c}dispose(){this.queue=null}},nKe=dn,pTe=(n=>(n[n.NONE=0]="NONE",n[n.VIDEO=1]="VIDEO",n[n.AUDIO=2]="AUDIO",n))(pTe||{});function oSi(n,a,s){const{ssrc:c,keyFramesDecoded:u,nackCount:m,firCount:b,pliCount:_,decoderImplementation:k,packetsLost:N}=n.inboundRTP,{frameRateReceived:W,frameRateDecoded:ee,bitrate:oe,decodeTime:de,isFrozen:se}=n.extensions??{},{sourceId:Re,msid:ue,streamSize:Ne,rendererSize:ze}=s,He=n.renderer?.modality===ke.MODALITY.sharing,{audioLevel:be}=a.inboundRTP,{mimeType:Ee}=a.codec??{},{healedRatio:Pe,lossRate:Qe}=a.extensions??{};return{streamSize:{overlayTab:1,format:"{0}x{1}",values:[Ne?.width,Ne?.height],undefinedFallback:0},rendererSize:{overlayTab:1,format:"{0}x{1}",values:[ze?.width,ze?.height],undefinedFallback:0},ssrc:{overlayTab:1,values:[c]},msid:{overlayTab:1,text:"sourceId/msid",format:"{0}/{1}",values:[Re(),ue()]},fps:{overlayTab:1,text:"FPS(r/d)",format:"{0}/{1}",values:[W,ee],highlightUndefined:!0,lowerThreshold:1,upperThreshold:45,allowedDeviationThreshold:.2,suppressHighlighting:He},bitrate:{overlayTab:1,format:"{0} kbps",values:[gTe(oe)],lowerThreshold:24,suppressHighlighting:He},decodeTime:{overlayTab:1,format:"{0} ms",values:[de],upperThreshold:15,highlightUndefined:!0,suppressHighlighting:He},keyFramesDecoded:{overlayTab:1,text:"KFs",values:[u]},nacksFirsPlisSent:{overlayTab:1,text:"N/F/P",format:"{0}/{1}/{2}",values:[m,b,_],undefinedFallback:0,highlightChange:!0},packetsLost:{overlayTab:1,text:"lost",values:[N],undefinedFallback:0,highlightChange:!0},codecImplementationName:{overlayTab:1,text:"decoder",values:[k],highlightUndefined:!0},isFrozen:{overlayTab:1,values:[se?"YES":"NO"],fixedValueThreshold:"NO"},audioCodec:{overlayTab:2,values:[Ee?.split("/").pop()]},audioLevel:{overlayTab:2,values:[oa(be,4)]},healedRatio:{overlayTab:2,values:[oa(Pe,4)],upperThreshold:.2},lossRate:{overlayTab:2,values:[oa(Qe,4)],upperThreshold:.1}}}function aKe(n,a){const{rid:s,ssrc:c,frameWidth:u,frameHeight:m,framesPerSecond:b,keyFramesEncoded:_,nackCount:k,firCount:N,pliCount:W,encoderImplementation:ee,qualityLimitationReason:oe}=n.outboundRTP,{cameraOpenResolution:de,bitrate:se,encodeTime:Re,frameRateEncoded:ue,frameRateSent:Ne,qp:ze}=n.extensions??{},{mimeType:He}=a.codec??{},{lossRate:be}=a.extensions??{},{audioLevel:Ee}=a.mediaSource??{};return{rid:{overlayTab:1,values:[s],hideUndefined:!0},cameraSize:{overlayTab:1,format:"{0}x{1}",values:[de?.width,de?.height]},inputSize:{overlayTab:1,format:"{0}x{1}",values:[n.mediaSource?.width,n.mediaSource?.height]},sentSize:{overlayTab:1,format:"{0}x{1}",values:[u,m]},ssrc:{overlayTab:1,values:[c]},fps:{overlayTab:1,text:"FPS(i/e/s)",format:"{0}/{1}/{2}",values:[b,ue,Ne],lowerThreshold:7,upperThreshold:45,allowedDeviationThreshold:.2},bitrate:{overlayTab:1,format:"{0} kbps",values:[gTe(se)],lowerThreshold:24},encodeTime:{overlayTab:1,format:"{0} ms",values:[Re],upperThreshold:15},keyFramesEncoded:{overlayTab:1,text:"KFs",values:[_]},qp:{overlayTab:1,values:[ze]},nacksFirsPlisRecv:{overlayTab:1,text:"N/F/P",format:"{0}/{1}/{2}",values:[k,N,W],undefinedFallback:0,highlightChange:!0},codecImplementationName:{overlayTab:1,text:"encoder",values:[ee],highlightUndefined:!0},qualityLimitationReason:{overlayTab:1,text:"limited",values:[oe],fixedValueThreshold:"none"},bwe:{overlayTab:1,format:"{0} kbps",values:[gTe(n.transport?.selectedCandidatePair?.availableOutgoingBitrate)],lowerThreshold:100},audioCodec:{overlayTab:2,values:[He?.split("/").pop()]},audioLevel:{overlayTab:2,values:[oa(Ee,4)]},lossRate:{overlayTab:2,values:[oa(be,4)]}}}function gTe(n){return n&&Math.floor((n||0)/1e3)}var rKe=class{constructor(n){this.container=n,this.formatRegexPattern=new RegExp(/{(\d+)}/g),this.elements={},this.previousSamples={},this.overlayTab=1,this.createTableCell=(a,s,c)=>{this.elements[a]=document.createElement("td"),this.elements[a].title=a,this.addElementStyle(a,c),this.elements[s].appendChild(this.elements[a])},this.topElement=n.ownerDocument.createElement("div"),this.topElement.classList.add("vdi-occlusion"),this.topElement.style.position="absolute",this.topElement.style.top="0px",this.topElement.style.left="0px",this.topElement.style.zIndex="100",this.topElement.style.transform="inherit",this.topElement.style.backgroundColor="rgba(0, 0, 0, 0.25)",this.topElement.style.pointerEvents="all",this.topElement.style.minWidth="15px",this.topElement.style.minHeight="15px",this.topElement.style.cursor="pointer",this.topElement.onclick=()=>{this.overlayTab=cSi(this.overlayTab)},this.container.appendChild(this.topElement),this.table=document.createElement("table"),this.table.style.borderCollapse="collapse",this.table.style.fontSize="smaller",this.topElement.appendChild(this.table)}dispose(){this.topElement.removeChild(this.table),this.container.removeChild(this.topElement),this.table=null,this.topElement=null,this.container=null}createTableColumn(n,a){for(const s of Object.keys(n)){const c=n[s];c.overlayTab===this.overlayTab&&(c.hideUndefined&&c.values.every(u=>!u)||this.createTableRow(s,c,a))}}createTableRow(n,a,s){this.elements[n]||(this.elements[n]=document.createElement("tr"),this.table.appendChild(this.elements[n]));const c=`${n}-title`,u=`${n}-${s}`,m=this.formatValue(a),b=this.previousSamples[u]!==m;this.previousSamples[u]=m;const _=dSi(a)||!(!a.highlightChange||!b);this.elements[c]||(this.createTableCell(c,n,!1),this.elements[c].innerText=a.text?a.text:n),this.createTableCell(u,n,!a.suppressHighlighting&&_),this.elements[u].innerText=m}clearTable(){for(;this.table.hasChildNodes();)this.table.removeChild(this.table.lastChild);this.elements={}}getOverlayTab(){return this.overlayTab}addElementStyle(n,a){this.elements[n].style.color=a?"#F72F35":"#FBF719",this.elements[n].style.fontSize="smaller",this.elements[n].style.lineHeight="1",this.elements[n].style.padding="0px 1px 0px 1px",this.elements[n].style.maxWidth="60px",this.elements[n].style.overflow="hidden",this.elements[n].style.whiteSpace="nowrap",this.elements[n].style.textOverflow="ellipsis"}formatValue(n){const{values:a,format:s,undefinedFallback:c="N/A"}=n;return s?s.replace(this.formatRegexPattern,(u,m)=>a?.[m]?.toString()??c.toString()):a?.[0]?.toString()??c.toString()}},sSi=class{constructor(n,a,s){this.container=a,this.renderer=s,this.subs=[],n&&!this.overlay&&(this.overlay=new rKe(this.container),this.rendererStats={msid:()=>this.renderer.getLocalMsi(),sourceId:()=>this.renderer.getMsi()},this.subs.push(this.renderer.on("onVideoSizeChanged",(c,u)=>this.rendererStats.streamSize={width:c,height:u})),this.subs.push(this.renderer.on("onRendererSizeChanged",(c,u)=>this.rendererStats.rendererSize={width:Math.ceil(u.width),height:Math.ceil(u.height)})))}setStats(n,a){this.overlay&&(this.overlay.clearTable(),this.overlay.createTableColumn(oSi(n,a,this.rendererStats),n.inboundRTP.id))}dispose(){this.subs.forEach(n=>n.dispose()),this.subs=[],this.overlay?.dispose(),this.overlay=null,this.container=null,this.renderer=null}},lSi=class{constructor(n,a){this.container=a,n&&!this.overlay&&(this.overlay=new rKe(this.container))}setStats(n,a){if(!this.overlay)return;if(this.overlay.clearTable(),this.overlay.getOverlayTab()===2)return void this.overlay.createTableColumn(aKe(n,a),n.outboundRTP.id);const s=[n,...n.altLayouts??[]];for(const c of s)this.overlay.createTableColumn(aKe(c,a),c.outboundRTP.id)}dispose(){this.overlay?.dispose(),this.overlay=null,this.container=null}};function cSi(n){const a=Object.keys(pTe).filter(c=>isNaN(Number(c))),s=(n+1)%a.length;return pTe[a[s]]}function dSi(n){const{values:a,lowerThreshold:s,upperThreshold:c,highlightUndefined:u,fixedValueThreshold:m,allowedDeviationThreshold:b}=n;for(const _ of a){if(_===void 0&&_===null&&u||m&&m!==_)return!0;if(_==null||!(0,nKe.isNumber)(_))return!1;if(s&&Number(_)<=s||c&&Number(_)>=c)return!0;if(b){const k=(0,nKe.mean)(a),N=k*b;if(Math.abs(Number(_)-k)>N)return!0}}return!1}function uSi(n){switch(n){case"crop":return"cover";case"stretch":return"fill";default:return"contain"}}var oKe=class AQe extends jr{constructor(a,s,c){const u=s.createChild(""+AQe.rendererId++);super(u),this.container=a,this.configProvider=c,this.video=this.container.ownerDocument.createElement("video"),this.lastNotifiedVideoWidth=0,this.lastNotifiedVideoHeight=0,this.isVideoAttached=!1,this.onVideoDataUpdated=()=>{let m=this.video.videoWidth,b=this.video.videoHeight;(m<32||b<32)&&(m=b=0),this.lastNotifiedVideoWidth===m&&this.lastNotifiedVideoHeight===b||(this.lastNotifiedVideoWidth=m,this.lastNotifiedVideoHeight=b,this.event("onVideoSizeChanged").raise(m,b)),this.playVideo()},this.onVideoError=()=>{this.logger.safe.info(`onVideoError: error with video rendering: ${JSON.stringify(this.video.error)||"no video"}`),this.event("onVideoRendererStateChanged").raise({timestamp:Date.now(),state:"onError",payload:JSON.stringify(this.video.error)||"no video"})},this.onVideoPaused=()=>{this.logger.safe.info("onVideoPaused: video playback is paused"),this.event("onVideoRendererStateChanged").raise({timestamp:Date.now(),state:"onVideoPaused"}),this.playVideo()},this.onVideoPlayed=()=>{this.logger.safe.info("onVideoPlayed"),this.event("onVideoRendererStateChanged").raise({timestamp:Date.now(),state:"onVideoPlayed"})},this.onContextMenu=m=>{m.preventDefault()},this.logger=u,this.video.style.width="100%",this.video.style.height="100%",this.video.setAttribute("playsinline","true"),this.video.disablePictureInPicture=!0,this.video.autoplay=!0,this.video.muted=!0,this.attachEventListeners(),this.logger.safe.info("created")}getVideoElement(){return this.video}dispose(){super.dispose(),this.isVideoAttached&&(this.container.removeChild(this.video),this.isVideoAttached=!1),this.detachEventListeners(),this.attachMediaStream(null),this.video=null,this.stream=null,this.canvas=null,this.context=null}attachMediaStream(a){this.stream!==a&&(this.stream&&(this.video.srcObject=null),a&&(this.video.hidden=a.getVideoTracks().length===0,this.video.srcObject=a,this.isVideoAttached||(this.container.appendChild(this.video),this.isVideoAttached=!0)),this.stream=a)}setScalingMode(a){this.video.style.objectFit=uSi(a)}getMediaStream(){return this.stream}getTrackId(){return this.stream?.getTracks()[0]?.id??void 0}async captureFrame(){const a=this.stream;if(!a)throw this.logger.safe.error("Mediastream not found"),new Error("Mediastream not found");const s=a.getVideoTracks?.()?.[0]?.getSettings(),c=s?.width,u=s?.height;if(!c||!u)throw this.logger.safe.error("Failed to get video track width/height"),new Error("Failed to get video track width/height");const m=this.getImageData(c,u);return{getSize:()=>({width:c,height:u}),isMirrored:()=>!1,getImageData:()=>m}}playVideo(){this.video?.paused&&this.video.play().catch(a=>{this.logger.safe.error(`Play video error: ${a}`)})}getImageData(a,s){if(this.canvas??(this.canvas=this.container.ownerDocument.createElement("canvas")),this.context??(this.context=this.canvas.getContext("2d")),!this.context)throw this.logger.safe.error("Failed to get canvas 2d context"),new Error("Failed to get canvas 2d context");return this.canvas.width=a,this.canvas.height=s,this.context.drawImage(this.video,0,0,a,s),this.context.getImageData(0,0,a,s)}attachEventListeners(){this.video.addEventListener("loadedmetadata",this.onVideoDataUpdated),this.video.addEventListener("timeupdate",this.onVideoDataUpdated),this.video.addEventListener("error",this.onVideoError),this.video.addEventListener("pause",this.onVideoPaused),this.video.addEventListener("contextmenu",this.onContextMenu),this.video.addEventListener("play",this.onVideoPlayed)}detachEventListeners(){this.video.removeEventListener("loadedmetadata",this.onVideoDataUpdated),this.video.removeEventListener("timeupdate",this.onVideoDataUpdated),this.video.removeEventListener("error",this.onVideoError),this.video.removeEventListener("pause",this.onVideoPaused),this.video.removeEventListener("contextmenu",this.onContextMenu),this.video.removeEventListener("play",this.onVideoPlayed)}};oKe.rendererId=0;var sKe=oKe,hSi=class extends sKe{constructor(n,a,s,c,u){super(n,s.createChild("local"),c),this.mediaStreamProvider=a,this.mediaType=u,this.isDisposed=!1,this.serialQueue=new iL(this.logger.createChild("rendererQueue")),this.logger.safe.info("ctor"),this.overlayStats=new lSi(this.configProvider.config.showStatsInCall,n)}dispose(){this.logger.safe.info("dispose"),this.isDisposed=!0,this.event("onRendererDisposed").raise(this),super.dispose(),this.mediaStream&&(this.mediaStream.dispose(),this.mediaStream=null),this.overlayStats.dispose()}setVideoMirroring(n){this.configProvider.config.localPreviewMirroringSupported&&(this.getVideoElement().style.transform=n?"scaleX(-1)":void 0)}startVideoAsync(n=hi()){return this.logger.safe.info(`[${n}] starting local video`),this.event("onRendererStarted").raise(this),this.serialQueue.add(()=>this.restartVideo(),n)}updateStreamAsync(n=hi()){return this.logger.safe.info(`[${n}] updating local video`),this.serialQueue.add(()=>this.restartVideo(),n)}onDiagnosticUpdated(n){n.video?.send?.length&&n.audio?.send?.length&&this.overlayStats.setStats(n.video.send[0],n.audio.send[0])}async restartVideo(){try{let n;if(this.mediaType==="Video")n=await this.mediaStreamProvider.getVideoStream(!1,"localVideoRenderer");else{if(this.mediaType!=="ScreenShare")throw new Error("Not yet supported");n=await this.mediaStreamProvider.getDisplayStream("localSSRenderer")}if(await n.start(),this.isDisposed)throw n.dispose(),new Error("local video renderer is disposed");this.attachStream(n)}catch(n){throw this.mediaStreamProvider.raiseTelemetryEvent("video_preview_error",{mediaType:this.mediaType,error:nn(n)}),n}}attachStream(n){if(this.mediaStream!==n)if(this.mediaStream?.parentId!==n?.parentId){this.logger.safe.info(`attach media stream ${n?.id}`);try{this.mediaStream&&(this.mediaStream.dispose(),this.mediaStream=null),n&&super.attachMediaStream(n.rawStream),this.mediaStream=n}catch(a){throw n&&n.dispose(),a}}else n.dispose()}},pSi=class extends jr{constructor(n,a,s){super(s),this.mediaStream=n,this.logger=s,this.mediaStreamSubscriptions=[],this.isHold=!1,this.isMuted=this.mediaStream.getMuted(),this._isDisposed=!1,this.originalId=n.id,this.subscribeOnMediaStreamEvents(),this.update(a),this.logger.safe.info("ctor"),this.mediaType=this.mediaStream.mediaType}get id(){return this.originalId}get parentId(){return this.originalId}get rawStream(){return this.gumStream}get rawTrack(){return this.getTrackByMediaType(this.rawStream,this.mediaType)}get deviceId(){return this.mediaStream.deviceId}update(n){n&&(this.gumStream=n,this.enableDisableTracks())}dispose(){this._isDisposed?this.logger.safe.info("already disposed"):(this._isDisposed=!0,this.logger.safe.info("dispose"),this.logger=this.logger.createChild("DISPOSED"),this.event("onStreamClientDisposing").raise(this),this.mediaStream&&(this.mediaStream.disposeClient(this),this.unsubscribeFromMediaStreamEvents(),this.mediaStream=null),this.event("onStreamClientDisposed").raise(this))}clone(){const n=this.mediaStream.getClient();return this.isMuted&&n.setMuted(!0),this.isHold&&n.setHold(!0),n}applyCapabilities(n){return this.mediaStream.applyCapabilities(n)}setMuted(n,a=hi()){this.isMuted=n||this.mediaStream.getMuted(),this.logger.safe.info(`[${a}] setMuted => ${this.isMuted}`),this.enableDisableTracks()}setHold(n){this.isHold=n,this.enableDisableTracks()}start(){return this.mediaStream.start()}hasAudio(){return this.mediaStream.hasAudio()}hasVideo(){return this.mediaStream.hasVideo()}hasDisplay(){return this.mediaStream.hasDisplay()}isSameStream(n){return this.parentId===n.parentId}getResolution(){return this.mediaStream.getResolution()}getFrameRate(){return this.mediaStream.getFrameRate()}isActive(){return!0}isDisposed(){return this._isDisposed}subscribeOnMediaStreamEvents(){this.mediaStreamSubscriptions.push(this.mediaStream.on("onStreamStarted",(n,a)=>{this.event("onStreamClientStarted").raise(this,a)})),this.mediaStreamSubscriptions.push(this.mediaStream.on("onStreamError",(n,a)=>{this.event("onStreamClientError").raise(this,a)})),this.mediaStreamSubscriptions.push(this.mediaStream.on("onStreamTrackMuted",(n,a)=>{this.event("onStreamClientMuted").raise(this,a)})),this.mediaStreamSubscriptions.push(this.mediaStream.on("onStreamTrackEnded",(n,a)=>{this.event("onStreamClientEnded").raise(this,a)}))}unsubscribeFromMediaStreamEvents(){this.mediaStreamSubscriptions.forEach(n=>n.dispose()),this.mediaStreamSubscriptions=[]}enableDisableTracks(){this.gumStream?this.gumStream.getTracks().forEach(n=>{n.enabled!==void 0&&(n.enabled=!this.isMuted&&!this.isHold,this.logger.safe.info(`Track ${JSON.stringify(n.id)} enabled state set to => ${n.enabled}`))}):this.logger.safe.warn("gumStream stream doesn't exist")}getTrackByMediaType(n,a){return a==="Audio"?n.getAudioTracks()[0]:n.getVideoTracks()[0]}},lKe=class IQe extends jr{constructor(a,s,c,u){super(c),this.streamConstraints=a,this.serialQueue=s,this.configProvider=u,this.clientId=0,this.clients=[],this.gumStreams={},this.clientGumStreams=[],this.streamsDump=[],this.isMuted=!1,this.isHold=!1,this.gumStartTime=0,this.streamId=IQe.streamGeneration++,this.logger=c.createChild(`MediaStream:${this.streamId}`),this.mediaType=this.getMediaType(this.streamConstraints),this.constraintsProvider=KWe.getProvider(this.mediaType,this.configProvider,this.logger),this.currentConstraints=this.constraintsProvider.createConstraintsObject(a)}get id(){return this.streamId}get rawStream(){return this.currentGumStream}get deviceId(){return this.rawStream?.getTracks()?.[0]?.getSettings?.()?.deviceId??null}applyCapabilities(a){if(this.currentGumStream){const s=this.constraintsProvider.updateVideoConstraints(this.currentConstraints,a,this.getResolution());if(!s)return Promise.resolve(!1);if(this.currentConstraints!==s){this.currentConstraints=s;const c=this.currentConstraints;return this.hasDisplay()?this.applyConstraints(this.currentConstraints).then(()=>xc(this.currentConstraints,c)).catch(u=>(this.logger.safe.error(`Apply constraints error: ${nn(u)}`),!1)):this.applyConstraintsInternal().then(()=>xc(this.currentConstraints,c))}}return Promise.resolve(!1)}getClient(){let a;this.currentGumStream?(a=this.getClone(),this.clientGumStreams.push({[this.constraintsProvider.getKey(this.currentConstraints)]:a})):this.clientGumStreams.push({});const s=new pSi(this,a,this.logger.createChild("Client:"+this.clientId++));return this.clients.push(s),s}getClone(){return this.hasDisplay()?this.currentGumStream:this.currentGumStream.clone()}setMuted(a){this.isMuted=a,this.clients.forEach(s=>{s.setMuted(a)}),this.enableDisableTracks()}getMuted(){return this.isMuted}setHold(a){this.isHold=a,this.clients.forEach(s=>{s.setHold(a)}),this.enableDisableTracks()}start(){return this.mediaStreamStartPromise||(this.mediaStreamStartPromise=this.startStream(this.currentConstraints)),this.mediaStreamStartPromise}dispose(){for(let a=this.clients.length-1;a>=0;a--)this.clients[a].dispose()}disposeClient(a){const s=this.clients.indexOf(a);s>=0&&(this.clients.splice(s,1),this.streamsDump.push(this.clientGumStreams[s]),this.clientGumStreams.splice(s,1),this.clients.length===0)&&this.disposeStream()}async disposeStream(){this.event("onStreamDisposing").raise(this);try{await this.stopGumStream(),this.event("onStreamDisposed").raise(this)}catch(a){this.event("onStreamError").raise(this,a)}this.constraintsProvider=null,this.serialQueue=null,this.configProvider=null,this.logger=this.logger.createChild("DISPOSED"),super.dispose()}hasAudio(){return!!this.currentGumStream&&this.currentGumStream.getAudioTracks().length!==0}hasVideo(){return!!this.currentGumStream&&this.currentGumStream.getVideoTracks().length!==0&&this.currentConstraints.video&&this.currentConstraints.video.deviceId!==ke.DISPLAY_SOURCE_ID}hasDisplay(){return!!this.currentGumStream&&this.currentGumStream.getVideoTracks().length!==0&&this.currentConstraints.video&&this.currentConstraints.video.deviceId===ke.DISPLAY_SOURCE_ID}getVideoDeviceId(){return this.currentConstraints.video.deviceId}getResolution(){if(!["Video","ScreenShare","PanoramicVideo"].some(m=>m===this.mediaType))return null;const a={width:this.currentConstraints.video.minWidth,height:this.currentConstraints.video.minHeight},s=dTe(this.currentGumStream),c=s??a,u=`Stream resolution is ${c.width}x${c.height}.`;return s?this.logger.safe.info(u):this.logger.safe.error(`${u}. Resolution not found, assuming default resolution.'`),c}getFrameRate(){if(!["Video","ScreenShare","PanoramicVideo"].some(s=>s===this.mediaType))return null;const a=XWe(this.currentGumStream);return a===0?this.logger.safe.error("Stream frame rate is not avalable, returning 0"):this.logger.safe.info(`Stream fps is ${a}`),a}async startStream(a){let s;s=a.video?this.applyConstraintsInternal():this.updateGumStreamInternal(a);try{await s,this.event("onStreamStarted").raise(this,a)}catch(c){throw this.event("onStreamError").raise(this,c),c}}getMediaType(a){if(a.sharing)return"ScreenShare";if(a.video)return"Video";if(a.audio)return"Audio";throw new Error(`Media type is not defined: ${JSON.stringify(a)}`)}updateClients(a){const s=this.constraintsProvider.getKey(a);this.clients.forEach((c,u)=>{this.clientGumStreams[u][s]||(this.clientGumStreams[u][s]=this.getClone()),c.update(this.clientGumStreams[u][s])})}applyConstraints(a){const s=this.getGumStreamProvider();return Promise.all(this.clients.map(c=>s.applyConstraints(c.rawStream,a))).then(()=>{})}applyConstraintsInternal(){return new Promise((a,s)=>{this.logger.safe.info(`applying stream constraints: ${JSON.stringify(uC(this.currentConstraints))}`);const c=new Pi;this.clients.forEach(m=>{m.onApplyConstraints&&m.onApplyConstraints(c.promise)});const u=this.serialQueue.add(()=>{const m=new tKe().getPolicies(this.currentConstraints);return this.mediaStreamStartPromise=this.updateGumStreamInternal(m[0]),m.slice(1).forEach(b=>{this.mediaStreamStartPromise=this.mediaStreamStartPromise.catch(_=>{if(ke.MEDIA_ERROR.constraintNotSatisfiedError===_.type)return this.logger.safe.warn("could not obtain constrained media stream, will attempt weaker policy"),this.updateGumStreamInternal(b);throw _.constraints=b,_})}),this.mediaStreamStartPromise}).then(()=>{c.resolve()}).catch(m=>{throw this.logger.safe.error(`failed to apply constraints: ${JSON.stringify(uC(m.constraints))} error: ${nn(m)}`),c.reject(m),m});a(u)})}enableDisableTracks(){this.currentGumStream&&this.currentGumStream.getTracks().forEach(a=>{a.enabled!==void 0&&(a.enabled=!(a.kind==="audio"&&this.isMuted||this.isHold),this.logger.safe.info(`control media stream track kind: ${a.kind} enabled: ${a.enabled} muted: ${a.muted}`))})}getGumStreamProvider(){return QWe.getStreamProvider(this.mediaType,this.configProvider,this.logger.createChild("MSProvider"))}async updateGumStreamInternal(a){this.logger.safe.info(`querying user media for stream: ${JSON.stringify(a)}`),this.logger.safe.info("Getting GUM stream");const s=await this.getGumStream(a);this.logger.safe.info("Updating gum stream audio tracks"),this.updateGumStreamAudioTracks(s),this.currentGumStream=s,this.logger.safe.info("Updating stream constraints"),this.updateConstraints(a,s),this.logger.safe.info("Caching GUM stream"),this.cacheGumStream(this.currentConstraints,s),this.updateClients(this.currentConstraints),this.updateGumStreamVideoTracks(s),this.enableDisableTracks(),this.logger.safe.info("media stream updated");const c=this.stopRequestCalculation();this.event("onStreamAcquired").raise(this,c,(this.hasVideo()||this.hasDisplay())&&this.getResolution()||void 0)}async getGumStream(a){const s=this.gumStreams[this.constraintsProvider.getKey(a)];if(s)return s;const c=this.getGumStreamProvider();return this.startRequestCalculation(),c.getStream(a)}updateGumStreamAudioTracks(a){a.getAudioTracks().forEach(s=>{s.onended=c=>{this.logger.safe.info(`Audio stream track ended: ${JSON.stringify(c.error?.name||c)}`),this.event("onStreamTrackEnded").raise(this,c)},s.onmute=()=>{this.logger.safe.info("Audio stream track muted"),this.event("onStreamTrackMuted").raise(this,!0)},s.onunmute=()=>{this.logger.safe.info("Audio stream track unmuted"),this.event("onStreamTrackMuted").raise(this,!1)},s.muted&&this.event("onStreamTrackMuted").raise(this,!0),this.logger.safe.info(`Audio track added: ${JSON.stringify(s.id)}`)})}updateGumStreamVideoTracks(a){const[s]=a.getVideoTracks();s&&(s.onmute=c=>{this.logger.safe.error(`Video stream track muted: ${JSON.stringify(uC(this.currentConstraints))}; ${JSON.stringify(c)}`)},s.onended=c=>{this.logger.safe.info(`Video stream track ended: ${JSON.stringify(uC(this.currentConstraints))}; ${JSON.stringify(c?.error.name||c)}`),this.event("onStreamTrackEnded").raise(this,c)},this.hasDisplay()&&this.configProvider.config.webrtcDisplayStreamContentHint&&this.applyContentHint(s,this.configProvider.config.webrtcDisplayStreamContentHint),this.logger.safe.info(`Video track added: ${JSON.stringify(s.id)}`))}cacheGumStream(a,s){const c=this.constraintsProvider.getKey(a);this.gumStreams[c]!==s&&(this.gumStreams[c]&&(this.logger.safe.info(`Stream cache hit for ${c}, stopping old stream`),this.stopOneGumStream(this.gumStreams[c])),this.gumStreams[c]=s)}updateConstraints(a,s){this.currentConstraints=a.video?this.constraintsProvider.updateResolution(a,this.getResolution()):a,this.logger.safe.info(`Stream constraints updated: ${JSON.stringify(this.currentConstraints)}`)}applyContentHint(a,s){["","text","detail","motion"].indexOf(s)<0?this.logger.safe.error(`Cannot apply content hint: ${s}`):(this.logger.safe.info(`Apply content hint: ${s}`),a.contentHint=s)}startRequestCalculation(){this.gumStartTime=Date.now()}stopRequestCalculation(){if(this.gumStartTime===0)return 0;const a=Date.now()-this.gumStartTime;return this.gumStartTime=0,a}stopGumStream(){return this.mediaStreamStartPromise?(this.logger.safe.info("queueing media stream stop"),this.serialQueue.add(()=>{this.stopGumStreamInternal()})):Promise.resolve()}stopOneGumStream(a){try{a.getTracks().forEach(s=>{this.logger.safe.info(`Track is stopped: ${JSON.stringify(s.id)}`),s.onended=null,s.onmute=null,s.stop()}),this.logger.safe.info("media stream stopped")}catch(s){this.logger.safe.warn(`failed to stop media stream: ${nn(s)}`)}}stopGumStreamInternal(){this.currentGumStream&&([...this.clientGumStreams,...this.streamsDump,this.gumStreams].forEach(a=>{Ng(a,s=>{this.stopOneGumStream(s)})}),this.gumStreams={},this.clientGumStreams=[],this.streamsDump=[],this.currentGumStream=null)}};lKe.streamGeneration=0;var gSi=lKe,mSi=class wae extends jr{constructor(a,s,c){super(a),this.logger=a,this.configProvider=s,this.effectsManager=c,this.cachedStreamsSubs=new Map,this.cachedStreamsMap=new Map,this.mediaStreamSerialQueue=new iL(this.logger),this.couldUseWebrtc_1_0=!1}getMediaStream(a,s){this.logger.safe.info(`retrieving media stream: ${JSON.stringify(uC(a))}`),this.cachedStreamsMap.size||(this.couldUseWebrtc_1_0=wye(this.configProvider.config.checkSupportForWebrtc_1_0));let c=this.getSuitableStream(a);c||(this.logger.safe.info(`cached stream is not found. Creating a new one with constraints: ${nn(uC(a))}`),c=this.createCachedStream(a)),this.logger.safe.info(`starting cached stream id=${c.id}`,s);const u=c.getClient(s);return u.start().catch(m=>{this.logger.safe.error(`could not start media stream: ${c.id}, total streams: ${this.cachedStreamsMap.size}, error: ${nn(m)}`),this.removeStream(c)}),u}dispose(){this.cachedStreamsSubs&&(this.cachedStreamsSubs.forEach(a=>{a.forEach(s=>{s.dispose()})}),this.cachedStreamsSubs=null),this.cachedStreamsMap&&(this.cachedStreamsMap.forEach(a=>a.dispose("MSM dispose")),this.cachedStreamsMap=null),this.mediaStreamSerialQueue&&(this.mediaStreamSerialQueue.dispose(),this.mediaStreamSerialQueue=null),super.dispose()}getCachedStreams(){return this.cachedStreamsMap}getActiveConstraints(){const a={audio:!1,video:!1,sharing:!1};return this.cachedStreamsMap.forEach((s,c)=>{c.audio&&(a.audio=!0),c.video&&(a.video=!0),c.sharing&&(a.sharing=!0)}),a}onDevicesChanged(a){this.configProvider.config.enablePermissionsWorkaround&&wae.isDeviceListEmpty(a)?this.logger.safe.info("Device list is empty, permission workaround enabled"):this.cachedStreamsMap.forEach((s,c)=>{if(!c.sharing){const u=this.isDeviceOutdated(c.audio,a),m=this.isDeviceOutdated(c.video,a);(u||m)&&this.cachedStreamsMap.delete(c)}})}getSuitableStream(a){let s;return this.cachedStreamsMap.forEach((c,u)=>{this.isSuitable(this.addDeviceIdIfNecessary(c,u),a)&&(s=u)}),s&&this.cachedStreamsMap.get(s)}addDeviceIdIfNecessary(a,s){if(!a.deviceId)return s;const c=this.cloneStreamConstraints(s);return s.audio&&s.audio.deviceId===void 0&&(c.audio.deviceId=a.deviceId),s.video&&s.video.deviceId===void 0&&(c.video.deviceId=a.deviceId),s.sharing&&(c.sharing.deviceId=ke.DISPLAY_SOURCE_ID),c}cloneStreamConstraints(a){return{...fs(a),withOverridenStream:a.withOverridenStream}}createCachedStream(a){const s=this.createStream(a);return this.event("onStreamCreated").raise(s.id,s.mediaType),this.subscribeOnStreamEvents(s),this.logger.safe.info(`created media stream, id: ${s.id} total: ${this.cachedStreamsMap.size}`),this.cachedStreamsMap.set(a,s),s}disposeCurrentDeviceStream(a){for(const[s,c]of this.cachedStreamsMap.entries())a.sharing||s.sharing||(wae.deviceChanged(a.audio,s.audio)||wae.deviceChanged(a.video,s.video))&&c.dispose("MSM dispose oneStreamPerDeviceType")}createStream(a){return this.configProvider.config.oneStreamPerDeviceType&&this.couldUseWebrtc_1_0&&this.disposeCurrentDeviceStream(a),this.configProvider.config.webrtcSimulcastSessionEnabled&&yp.hasApplyConstraints()&&this.couldUseWebrtc_1_0?new Xyi(a,this.mediaStreamSerialQueue,this.configProvider,this.logger,this.effectsManager):new gSi(a,this.mediaStreamSerialQueue,this.logger,this.configProvider)}subscribeOnStreamEvents(a){const s=[];s.push(a.on("onStreamAcquired",(c,u,m)=>this.onStreamAcquired(c,u,m))),s.push(a.on("onStreamDisposing",c=>this.onStreamDisposing(c))),this.cachedStreamsSubs.set(a,s)}unsubscribeFromStreamEvents(a){this.cachedStreamsSubs.get(a).forEach(s=>s.dispose()),this.cachedStreamsSubs.delete(a)}removeStream(a){this.logger.safe.info(`release media stream generation: ${a.id} cached: ${this.cachedStreamsMap.size}`),this.cachedStreamsSubs.has(a)?(this.unsubscribeFromStreamEvents(a),this.cachedStreamsMap.delete(this.getConstraintsForStream(a)),this.getStreamsCountByType("Audio")||this.effectsManager.stopEffect("Audio"),this.cachedStreamsMap.size||this.event("onAllStreamsRemoved").raise()):this.logger.safe.warn(`skipping unknown stream ${a.id}`)}getConstraintsForStream(a){let s;return this.cachedStreamsMap.forEach((c,u)=>{a===c&&(s=u)}),s}isSuitable(a,s){const c=!(!a.withOverridenStream||!s.withOverridenStream),u=c||s.sharing||this.isAcceptable(a.audio,s.audio)&&a.audioProcessingFlags===s.audioProcessingFlags,m=c||this.isAcceptable(a.video,s.video),b=this.configProvider.config.requireUserActionForAudioSharing&&s.sharing&&!!a.audio!=!!s.audio,_=this.isAcceptable(a.sharing,s.sharing),k=_&&this.isAcceptable(a.audio,s.audio),N=b?k:_,W=a.withEffect===s.withEffect,ee=a.withOverridenStream?.id===s.withOverridenStream?.id;return!s.force&&u&&m&&N&&W&&ee}isAcceptable(a,s){return!a&&!s||a&&s&&a.deviceId===s.deviceId}isDeviceOutdated(a,s){return a?.deviceId&&!s.some(c=>c.deviceId===a.deviceId)}onStreamDisposing(a){this.logger.safe.info(`onStreamDisposing event ${a.id}`),this.event("onStreamDisposing").raise(a.id,a.mediaType),this.removeStream(a)}onStreamAcquired(a,s,c){const u=a.mediaType==="Audio"?void 0:!!a.rawStream.getAudioTracks()[0],m=a.mediaType==="ScreenShare"?this.getSharingSource(a):void 0,b=a.mediaType==="Audio"||u?a.rawStream?.getAudioTracks?.()[0]?.getSettings?.()?.sampleRate:void 0;this.event("onStreamAcquired").raise({id:a.id,mediaType:a.mediaType,timestamp:s,resolution:c,withAudio:u,source:m,sampleRate:b})}getSharingSource(a){const s=a.rawStream.getVideoTracks()[0];return s.getConstraints()?.deviceId?"camera":s.getSettings()?.displaySurface??"unknown"}static deviceChanged(a,s){return!(!a||!s)&&a.deviceId!==s.deviceId}static isDeviceListEmpty(a){return a.every(s=>s.label==="")}getStreamsCountByType(a){let s=0;return this.cachedStreamsMap.forEach(c=>{s+=c.mediaType===a?1:0}),s}},cKe=class{constructor(n){this.configProvider=n,this.data={deviceList:[],deviceSelectionChangeCount:0,deviceSelectionChangeCountFromInterface:0,permissionStates:{microphone:"unknown",camera:"unknown"},devicesCount:{microphone:0,camera:0,speaker:0,compositeAudio:0,audioIngestDevice:0,virtualDevice:0},devicesChangeCount:0,devicesPollChangeCount:0,deviceTelemetryEvents:[],videoEffectsEvents:[],audioEffectsEvents:[],workerEvents:[],audioSourceNumOfReopenRequests:0,audioSourceNumOfSuccessfulReopens:0,audioRenderDeviceErrorFlags:[],audioCaptureDeviceErrorFlags:[]},Object.defineProperty(this.data,"rawUsedDevices",{get:()=>this.rawUsedDevices,configurable:!1,enumerable:!1})}set permissionStates(n){this.data.permissionStates=n}setSelectedDevices(n,a){const s={microphone:Q_(n.microphone?.label,this.configProvider.config.devices.piiSafeWords),camera:Q_(n.camera?.label,this.configProvider.config.devices.piiSafeWords),speaker:Q_(n.speaker?.label,this.configProvider.config.devices.piiSafeWords)};this.rawUsedDevices={microphone:n.microphone?.label,camera:n.camera?.label,speaker:n.speaker?.label},this.data.usedDevices&&(this.data.deviceSelectionChangeCount++,a&&this.data.deviceSelectionChangeCountFromInterface++),this.data.usedDevices=s}setDeviceList(n,a,s){this.data.deviceList=n.map(c=>({label:Q_(c.label,this.configProvider.config.devices.piiSafeWords),kind:c.type})),s&&(this.data.deviceDebugStrings=fs(s)),this.data.devicesCount.microphone=n.filter(c=>c.type==="microphone").length,this.data.devicesCount.camera=n.filter(c=>c.type==="camera").length,this.data.devicesCount.speaker=n.filter(c=>c.type==="speaker").length,this.data.devicesCount.compositeAudio=n.filter(c=>c.type==="compositeAudio").length,this.data.devicesChangeCount++,a&&this.data.devicesPollChangeCount++}registerDeviceTelemetryEvent(n){if(n.eventType==="stream_acquired"){const a=n.payload;a.mediaType==="Video"&&(this.data.latestCameraOpenResolution=a.resolution)}n.payload.mediaType==="Audio"&&(n.eventType==="stream_acquired"&&(this.data.audioSourceNumOfReopenRequests++,this.data.audioSourceNumOfSuccessfulReopens++),n.eventType==="stream_error"&&this.data.audioSourceNumOfReopenRequests++),ld(this.data.deviceTelemetryEvents,n,this.configProvider.config.diagnostics.collectionLimits.numDeviceEvents)}logAudioDeviceError(n,a){switch(n){case"reconnect_on_audio_playback_error":{const s=this.getAudioPlaybackErrorCode(a.error);this.registerAudioRenderError(s);break}case"enumeration_failed":this.registerAudioRenderError(1),this.registerAudioCaptureError(1);break;case"permissions_state_changed":a.microphone==="denied"&&this.registerAudioCaptureError(0x800000000000);break;case"stream_ended_error":this.registerAudioCaptureError(4194304)}}getAudioPlaybackErrorCode(n){switch(n){case 3:return 4194304;case 4:return 128;default:return 9223372036854776e3}}registerVideoEffectsEvent(n){ld(this.data.videoEffectsEvents,n,this.configProvider.config.diagnostics.collectionLimits.numVideoEffectsEvents)}registerAudioEffectsEvent(n){ld(this.data.audioEffectsEvents,n,this.configProvider.config.diagnostics.collectionLimits.numAudioEffectsEvents)}registerWorkerEvent(n){ld(this.data.workerEvents,n,this.configProvider.config.diagnostics.collectionLimits.numWorkerEvents)}registerAudioCaptureError(n){const a={timestamp:Date.now(),audioDeviceErrorFlag:n};ld(this.data.audioCaptureDeviceErrorFlags,a,this.configProvider.config.diagnostics.collectionLimits.numAudioCaptureErrors)}registerAudioRenderError(n){const a={timestamp:Date.now(),audioDeviceErrorFlag:n};ld(this.data.audioRenderDeviceErrorFlags,a,this.configProvider.config.diagnostics.collectionLimits.numAudioRenderErrors)}getObjectRef(){return this.data}},zne=class{constructor(n,a,s,c,u){this.deviceId=n,this.label=a,this.kind=s,this.groupId=c,this.capabilities=u,this.type=this.getType(this.kind),this.guid=`${this.type}:${this.deviceId}`,this.isSystemDefault=this.deviceId===ke.MEDIA_DEVICE.defaultId}toDeviceDesc(){return{id:this.guid,browserId:this.deviceId,label:this.label,kind:this.type}}getType(n){switch(n){case ke.MEDIA_DEVICE_KIND.audioInput:return ke.MEDIA_DEVICE.microphone;case ke.MEDIA_DEVICE_KIND.audioOutput:return ke.MEDIA_DEVICE.speaker;case ke.MEDIA_DEVICE_KIND.videoInput:return ke.MEDIA_DEVICE.camera;case ke.MEDIA_DEVICE_KIND.compositeAudio:return ke.MEDIA_DEVICE.compositeAudio;case ke.MEDIA_DEVICE_KIND.virtualDevice:return ke.MEDIA_DEVICE.virtualDevice;default:throw new Error(`Device kind to recognized: ${n}`)}}},fSi=class extends zne{constructor(n,a,s,c){super(n,a,s,c)}},vSi=class extends zne{constructor(n,a,s,c,u){super(n,a,s,c,u)}toDeviceDesc(){const n=super.toDeviceDesc();return n.isSystemDefault=this.isSystemDefault,n}},ySi=class extends zne{constructor(n,a,s,c,u){if(super(n,a,s,c,u),this.position="unknown",u&&u.facingMode&&u.facingMode.length===1)switch(u.facingMode[0]){case"user":this.position="front";break;case"environment":this.position="back"}}toDeviceDesc(){const n=super.toDeviceDesc();return n.position=this.position,n}},SSi=class extends zne{constructor(n,a,s,c,u,m){super(null,s,c,""),this.micDevice=n,this.speakerDevice=a,this.formFactor=u,this.isPcInternalDevice=m,this.guid=null,this.isSystemDefault=!1}get micDeviceId(){return this.micDevice.guid}get speakerDeviceId(){return this.speakerDevice.guid}toDeviceDesc(){const n=super.toDeviceDesc();return n.microphoneId=this.micDeviceId,n.speakerId=this.speakerDeviceId,n.formFactor=this.formFactor,n.isPcInternalDevice=this.isPcInternalDevice,n}};function dKe(n){const a=n.getCapabilities&&n.getCapabilities();switch(a&&(delete a.groupId,delete a.deviceId),n.kind){case ke.MEDIA_DEVICE_KIND.audioInput:case ke.MEDIA_DEVICE_KIND.audioOutput:return new vSi(n.deviceId,n.label,n.kind,n.groupId,a);case ke.MEDIA_DEVICE_KIND.videoInput:return new ySi(n.deviceId,n.label,n.kind,n.groupId,a);default:throw new Error(`Device kind is not recognized: ${n.kind}`)}}function uKe(n,a,s){return new SSi(n,a,s,"compositeAudio",0,!1)}function bSi(n){const a={deviceId:ke.MEDIA_DEVICE.defaultId,label:ke.MEDIA_DEVICE.defaultDeviceLabel,kind:TSi(n),groupId:"",toJSON:()=>JSON.stringify(a)};return dKe(a)}function TSi(n){switch(n){case ke.MEDIA_DEVICE.microphone:return ke.MEDIA_DEVICE_KIND.audioInput;case ke.MEDIA_DEVICE.speaker:return ke.MEDIA_DEVICE_KIND.audioOutput;case ke.MEDIA_DEVICE.camera:return ke.MEDIA_DEVICE_KIND.videoInput;default:throw new Error(`Device type to recognized: ${n}`)}}function CSi(n,a,s,c,u={str:""}){u.str+=`|input(${a.length})`;let m=[];const b=[c.config.devices.blacklist[n],c.defaultConfig.devices.blacklist[n]];for(const _ of b)try{const k=new RegExp(_,"i");m=a.filter(N=>_&&N.label.match(k)?(u.str+=`|-blacklisted(${N.label})`,!1):N.deviceId!==ke.MEDIA_DEVICE.communicationsId||(u.str+="|-communications",!1));break}catch(k){u.str+=`|filterError('${_}', ${nn(k)})`,m=a}if(m.length){const _=_Si(s,m,u);if(_&&(_.isSystemDefault=!0,u.str+=`|default(${kn(_.guid)})`),_&&_.deviceId!==ke.MEDIA_DEVICE.defaultId&&m.length>1&&(m=m.filter(k=>k.deviceId!==ke.MEDIA_DEVICE.defaultId||(u.str+="|-defaultId",!1))),n===ke.MEDIA_DEVICE.camera||_||(u.str+="|+syntheticDefault",m.unshift(bSi(n))),s.forEach(k=>{const N=m.find(W=>W.guid===k.guid);N&&!N.label&&k.label&&(u.str+=`|migrateLabel(${kn(N.guid)})`,N.label=k.label)}),n===ke.MEDIA_DEVICE.speaker){const k=m.filter(N=>N.label==="");k.length>1&&k.length===m.length&&(m=_?[_]:[m[0]],u.str+=`|-filteredEmptyLabels(${k.length})`)}}return m}function _Si(n,a,s){if(a.length===1)return s.str+="|default:only",a[0];const c=a.find(u=>u.isSystemDefault&&u.deviceId===ke.MEDIA_DEVICE.defaultId);if(!c)return s.str+="|default:noSynthetic",a.find(u=>u.isSystemDefault)||a[0];{const u=a.filter(N=>N!==c);if(u.length===1)return s.str+="|default:firstNonDefault",u[0];if(c.groupId!==""){const N=u.filter(W=>W.groupId===c.groupId);if(N.length===1)return s.str+=`|default:groupId(${kn(N[0].guid)})`,N[0]}const m=u.map(N=>N.label),b=W0(c.label,m),_=u.find(N=>N.label===b);if(_)return s.str+=`|default:label(${kn(_.guid)})`,_;const k=n.find(N=>N.isSystemDefault);if(k){const N=u.find(W=>W.deviceId===k.deviceId);if(N)return s.str+=`|default:previousList(${kn(N.guid)})`,N}}return s.str+="|default:anyOrNull",a.find(u=>u.isSystemDefault)||null}function ESi(n,a,s=.5,c={str:""}){const u=[];if(n.length&&a.length){const m=ASi(n.filter(_=>_.groupId!==""),a.filter(_=>_.groupId!==""),c);m.length&&(u.push(...m.map(_=>uKe(_.microphone,_.speaker,mTe(_.microphone.label,_.speaker.label)))),c.str+=`|directMatched(${u.length})`);const b=u.length;u.push(...ISi(n.filter(_=>!u.some(k=>k.micDeviceId===_.guid)),a.filter(_=>!u.some(k=>k.speakerDeviceId===_.guid)),s,c)),c.str+=`|otherMatched(${u.length-b})`}return u}function ASi(n,a,s={str:""}){const c=new Set;for(const m of[...n,...a])c.add(m.groupId);const u=[];for(const m of c.values()){let b=n.filter(k=>k.groupId===m),_=a.filter(k=>k.groupId===m);if(b&&_){if(b.length===1&&_.length===1)u.push({microphone:b[0],speaker:_[0]}),s.str+=`|pairSimple(${kn(b[0].guid)}, ${kn(_[0].guid)})`;else if(b.length>1||_.length>1){let k=hKe(b,_);for(;k;)s.str+=`|pairComplex(${kn(k.microphone.guid)}, ${kn(k.speaker.guid)})`,u.push(k),b=b.filter(N=>N!==k.microphone),_=_.filter(N=>N!==k.speaker),k=hKe(b,_)}}}return u}function hKe(n,a){let s=999,c=null;if(n.length>0&&a.length>0)for(const u of n)for(const m of a){const b=Sve(u.label,m.label);b<s&&(s=b,c={microphone:u,speaker:m})}return c}function ISi(n,a,s,c){const u=[];return n.length&&a.length&&n.forEach(m=>{const b=a.filter(N=>N.groupId===m.groupId);if(!b.length)return void(c.str+=`|lbl_nocand(${kn(m.guid)})`);let _=S2(m.label,b[0].label).length;const k=b.sort((N,W)=>{const ee=S2(m.label,N.label),oe=S2(m.label,W.label);return ee.length>_&&(_=ee.length),oe.length>_&&(_=oe.length),oe.length-ee.length});if(k.length){const N=_/m.label.length;N>s&&(u.push(uKe(m,k[0],mTe(m.label,k[0].label))),c.str+=`|lbl_matched(${kn(m.guid)} & ${kn(k[0].guid)}, ${Math.round(1e4*N)/100}%)`)}}),u}function mTe(n,a){if(n===a)return n;let s=S2(n,a);s=s.trim().replace(/^\((.+)\)$/,"$1");let c="",u="",m=0;const b=[fTe(n),fTe(a)];if(b[0]===0||b[1]===0)return s;for(let k=0;k<s.length;k++)if(s[k]==="(")m++,u+=s[k];else if(s[k]===")"){if(!(m>0))break;m--,u+=s[k],c+=u,u=""}else m>0?u+=s[k]:c+=s[k];const _=fTe(c);return _!==b[0]&&_!==b[1]||(c=c.replace(/\w+\s?\((.+)\)/,"$1"),c=mTe(s,c)),c.trim()}function fTe(n){const a=["(",")"];let s=0;for(let c=0;c<n.length;c++)a.some(u=>n[c]===u)&&s++;return s}var pKe={microphone:"",camera:"",speaker:"",compositeAudio:"",audioIngestDevice:"",virtualDevice:""},wSi=class extends jr{constructor(n,a){super(a),this.configProvider=n,this.logger=a,this.debugInfo=pKe,this.lists=new Map,this.lists.set(ke.MEDIA_DEVICE.microphone,[]),this.lists.set(ke.MEDIA_DEVICE.camera,[]),this.configProvider.userAgentConfig.isAudioOutputSelectionSupported&&(this.lists.set(ke.MEDIA_DEVICE.speaker,[]),this.lists.set(ke.MEDIA_DEVICE.compositeAudio,[])),n.userAgentConfig.on("isAudioOutputSelectionSupportedChanged",()=>this.onConfigUpdated()),this.logger.safe.info("Initialized")}get devices(){const n=[];return this.lists.forEach(a=>n.push(...a)),n}getDevicesByType(n){return this.lists.get(n)??[]}updateDevices(n,a=!1){if(xc(this.latestRawList,n))return;this.latestRawList=n;const s=this.devices;this.debugInfo.microphone="microphone",this.debugInfo.camera="camera",this.debugInfo.speaker="speaker",this.debugInfo.compositeAudio="compositeAudio",this.updatePrimitiveDeviceList(ke.MEDIA_DEVICE.microphone,n.filter(b=>b.type===ke.MEDIA_DEVICE.microphone)),this.updatePrimitiveDeviceList(ke.MEDIA_DEVICE.camera,n.filter(b=>b.type===ke.MEDIA_DEVICE.camera)),this.lists.get(ke.MEDIA_DEVICE.speaker)&&(this.updatePrimitiveDeviceList(ke.MEDIA_DEVICE.speaker,n.filter(b=>b.type===ke.MEDIA_DEVICE.speaker)),this.lists.get(ke.MEDIA_DEVICE.compositeAudio)&&this.updateCompositeAudioDeviceList(this.lists.get(ke.MEDIA_DEVICE.microphone),this.lists.get(ke.MEDIA_DEVICE.speaker)));const c=this.lists.get(ke.MEDIA_DEVICE.compositeAudio)||[];this.lists.set(ke.MEDIA_DEVICE.microphone,this.orderDeviceList(this.lists.get(ke.MEDIA_DEVICE.microphone),c)),this.lists.get(ke.MEDIA_DEVICE.speaker)&&this.lists.set(ke.MEDIA_DEVICE.speaker,this.orderDeviceList(this.lists.get(ke.MEDIA_DEVICE.speaker),c));const u=this.lists.get(ke.MEDIA_DEVICE.microphone);this.setTopItemToDefault(u);const m=this.lists.get(ke.MEDIA_DEVICE.speaker);this.setTopItemToDefault(m),xc(s,this.devices)||(this.logger.safe.info("Device lists updated and changed"),this.logger.safe.info(this.debugInfo.microphone),this.logger.safe.info(this.debugInfo.camera),this.logger.safe.info(this.debugInfo.speaker),this.logger.safe.info(this.debugInfo.compositeAudio),this.event("onDevicesChanged").raise(this.devices,a))}updateVirtualDeviceList(n){const a=this.lists.get(ke.MEDIA_DEVICE.virtualDevice),s=n.map(c=>new fSi(c.id,c.label,"virtualDevice",""));xc(a,s)?this.logger.safe.info("Device lists did not change."):(this.lists.set(ke.MEDIA_DEVICE.virtualDevice,s),this.event("onDevicesChanged").raise(this.devices,!1))}updateActiveMicrophone(n){if(!n||n.deviceId===ke.MEDIA_DEVICE.defaultId)return;const a=this.lists.get(ke.MEDIA_DEVICE.microphone),s=a.findIndex(c=>c.isSystemDefault);s!==-1&&a[s]!==n?(this.logger.safe.info("Removing synthetic default microphone"),n.isSystemDefault=!0,a.splice(s,1),this.lists.set(ke.MEDIA_DEVICE.microphone,a),this.event("onDevicesChanged").raise(this.devices,!1)):n.isSystemDefault=!0}updatePrimitiveDeviceList(n,a){const s={str:this.debugInfo[n]};this.lists.set(n,CSi(n,a,this.lists.get(n)||[],this.configProvider,s)),this.debugInfo[n]=s.str}updateCompositeAudioDeviceList(n,a){const s={str:this.debugInfo.compositeAudio};this.lists.set(ke.MEDIA_DEVICE.compositeAudio,ESi(n,a,this.configProvider.config.devices.compositeLabelMatchingThreshold,s)),this.debugInfo.compositeAudio=s.str}orderDeviceList(n,a){return n.sort((s,c)=>this.getDevicePriority(c,this.getCompositeAudioDeviceCounterpart(c,a))-this.getDevicePriority(s,this.getCompositeAudioDeviceCounterpart(s,a)))}getCompositeAudioDeviceCounterpart(n,a){const s=a.find(c=>c.micDeviceId===n.guid||c.speakerDeviceId===n.guid);return s?s[n.type===ke.MEDIA_DEVICE.speaker?"micDevice":"speakerDevice"]:null}getDevicePriority(n,a){let s=0;return this.configProvider.config.devices.overrideDefault&&a&&(!n.isSystemDefault&&a.isSystemDefault?(this.debugInfo[n.type]+=`|overrideDefault(${kn(n.guid)})`,s+=10):n.isSystemDefault&&!a.isSystemDefault&&n.type==="microphone"&&(s+=15)),n.isSystemDefault&&(s+=5),a&&(s+=1,a.isSystemDefault&&(s+=2)),s}setTopItemToDefault(n){n?.length&&(n.forEach(a=>a.isSystemDefault=!1),n[0].isSystemDefault=!0)}onConfigUpdated(){let n=!1;this.configProvider.userAgentConfig.isAudioOutputSelectionSupported?this.lists.has(ke.MEDIA_DEVICE.speaker)||(this.lists.set(ke.MEDIA_DEVICE.speaker,[]),this.lists.set(ke.MEDIA_DEVICE.compositeAudio,[]),n=!0):(this.lists.has(ke.MEDIA_DEVICE.speaker)&&(this.lists.delete(ke.MEDIA_DEVICE.speaker),n=!0),this.lists.has(ke.MEDIA_DEVICE.compositeAudio)&&(this.lists.delete(ke.MEDIA_DEVICE.compositeAudio),n=!0)),n&&(this.logger.safe.info("Updating device list due to config update"),this.updateDevices(this.latestRawList||[]))}},T$=class vr extends jr{constructor(a,s){super(s),this.pollingInterval=0,vr.enumeratorUsers.add(this),vr.initialize(this,a,s)}startDevicePolling(a){this.pollingInterval=a?vr.configProvider.config.devices.pollingIntervalIdle:vr.configProvider.config.devices.pollingIntervalActive,vr.updatePollingTask()}stopDevicePolling(a){this.pollingInterval=a?0:vr.configProvider.config.devices.pollingIntervalIdle,vr.updatePollingTask()}dispose(){super.dispose(),this.stopDevicePolling(!0),vr.enumeratorUsers.delete(this),vr.enumeratorUsers.size===0&&(vr.logger.safe.info("disposing"),vr.initializeCalled=!1,vr.isDeviceListAvailable=new Pi,vr.list=void 0,vr.window.navigator.mediaDevices.ondevicechange=void 0)}static get isPolling(){return vr.currentPollingInterval!==0}static initialize(a,s,c){vr.initializeCalled||(vr.initializeCalled=!0,vr.window=Cc.window,vr.configProvider=s,vr.logger=c,vr.list=new wSi(s,c.createChild("DeviceList")),s.userAgentConfig.on("isAudioOutputSelectionSupportedChanged",()=>vr.enumerateDevices()),s.on("configUpdated",()=>{s.config.devices.pollingIntervalIdle!==void 0&&vr.pollingTimer!==null&&a.startDevicePolling(!0)}),s.config.devices.pollingIntervalIdle&&s.config.devices.idlePollingOnStart&&a.startDevicePolling(!0),vr.window.navigator.mediaDevices&&(vr.window.navigator.mediaDevices.ondevicechange=()=>{c.safe.info("enumerating due to ondevicechange callback"),vr.enumerateDevices().catch(u=>{c.safe.error(`unable to enumerate ondevicechange: ${nn(u)}`)})}),vr.enumerateDevices())}static async enumerateDevices(a=!1){if(!vr.window.navigator?.mediaDevices?.enumerateDevices){const s=new Error("device enumeration unsupported");throw vr.isDeviceListAvailable.isPending&&vr.isDeviceListAvailable.reject(s),s}if(vr.enumerateDevicesPromise&&!a)return vr.logger.safe.info("enumeration request postponed"),vr.hasPendingUpdate=!0,void(vr.isDeviceListAvailable.isPending&&ul.isEngine("Firefox")&&vr.isDeviceListAvailable.resolve());try{if(!vr.enumerateDevicesPromise)if(vr.configProvider.config.devices.enumerateDevicesTimeout){const c=zn(vr.configProvider.config.devices.enumerateDevicesTimeout);vr.enumerateDevicesPromise=c.promise,vr.window.navigator.mediaDevices.enumerateDevices().then(c.resolve,c.reject)}else vr.enumerateDevicesPromise=vr.window.navigator.mediaDevices.enumerateDevices();const s=await vr.enumerateDevicesPromise;vr.list.updateDevices(s.map(c=>dKe(c)),a),vr.isDeviceListAvailable.isPending&&vr.isDeviceListAvailable.resolve()}catch(s){const c=nn(s);throw vr.logger.safe.warn(`error with enumerating devices: ${c}`),vr.raiseFailedEnumeration(c),vr.isDeviceListAvailable.isPending&&vr.isDeviceListAvailable.reject(s),s}finally{vr.enumerateDevicesPromise=void 0,vr.hasPendingUpdate&&(vr.hasPendingUpdate=!1,vr.logger.safe.info("running postponed enumeration"),vr.enumerateDevices())}}static updatePollingTask(){let a=Number.MAX_SAFE_INTEGER;for(const c of vr.enumeratorUsers.values())c.pollingInterval<a&&(a=c.pollingInterval);if(a===Number.MAX_SAFE_INTEGER&&(a=0),(vr.pollingTimer||vr.currentPollingInterval!==a)&&vr.pollingTimer&&(vr.window.clearTimeout(vr.pollingTimer),vr.pollingTimer=void 0),vr.currentPollingInterval=a,a===0)return;const s=async()=>{if(vr.currentPollingInterval)try{await vr.enumerateDevices(!0),vr.pollingTimer=vr.window.setTimeout(s,vr.currentPollingInterval)}catch(c){throw vr.pollingTimer=null,c}};vr.logger.safe.info(`starting device polling with interval ${a}ms`),vr.pollingTimer=1,s()}static raiseFailedEnumeration(a){for(const s of vr.enumeratorUsers.values())s.event("onDeviceEnumerationfailed").raise(a)}};T$.isDeviceListAvailable=new Pi,T$.initializeCalled=!1,T$.currentPollingInterval=0,T$.hasPendingUpdate=!1,T$.enumeratorUsers=new Set;var Mv=T$,kSi=class extends jr{constructor(n,a,s){super(s),this.deviceList=n,this.configProvider=a,this.logger=s,this.userSelectedDevices={microphone:null,camera:null,speaker:null},this.currentlySelectedDevices={microphone:null,camera:null,speaker:null,audioIngestDevice:null},this.deviceList.on("onDevicesChanged",c=>this.onDevicesChanged(c)),n.devices.length>0&&this.onDevicesChanged(n.devices),this.logger.safe.info("Initialized")}get selectedDevices(){return fs(this.currentlySelectedDevices)}selectDevices(n){let a=!1;if(Ng(n,(s,c)=>{const u=this.getDeviceToSelect(c,this.deviceList.getDevicesByType(c==="audioIngestDevice"?"microphone":c),s);c==="camera"&&(this.userSelectedDevices[c]=u?.guid||this.userSelectedDevices[c]),u?.guid!==this.currentlySelectedDevices[c]?.guid&&(this.userSelectedDevices[c]=u?.guid||this.userSelectedDevices[c],a=!0),this.currentlySelectedDevices[c]=u}),a){const s=FS(this.currentlySelectedDevices).map(c=>JSON.stringify(FV(c,this.configProvider.config.devices.piiSafeWords)));this.logger.safe.info(`Changed from public interface: ${s}`),this.event("onSelectedDevicesChanged").raise(this.selectedDevices,!0)}}getDeviceToSelect(n,a,s){let c;const u=this.userSelectedDevices[n];return s?c=a.find(m=>m.guid===s):u&&(c=a.find(m=>m.guid===u)),n==="audioIngestDevice"?c:c||a[0]}onDevicesChanged(n){let a=!1;if(Object.keys(this.currentlySelectedDevices).forEach(s=>{const c=s==="audioIngestDevice"?"microphone":s,u=n.filter(m=>m.type===c);if(u.length>0){const m=this.getDeviceToSelect(s,u);m?.guid!==this.currentlySelectedDevices[s]?.guid&&(this.currentlySelectedDevices[s]=m,a=!0)}else this.currentlySelectedDevices[s]&&(this.currentlySelectedDevices[s]=null,a=!0)}),a){const s=FS(this.currentlySelectedDevices).map(c=>JSON.stringify(FV(c,this.configProvider.config.devices.piiSafeWords)));this.logger.safe.info(`Changed due to device list change: ${s}`),this.event("onSelectedDevicesChanged").raise(this.selectedDevices,!1)}}},RSi=class extends jr{constructor(n,a){super(n),this.logger=n,this.mediaStream=a,this.subs=[],this.subscribeOnMediaStreamEvents(a)}acquire(){return this.mediaStream?this.mediaStream.start().then(()=>this.logger.safe.info("Stream acquired")).catch(n=>{throw this.logger.safe.warn(`Failed to acquire the stream: ${nn(n)}`),n}):Promise.reject("Disposed")}dispose(){this.logger.safe.info("Disposing stream"),this.unsubscribeFromMediaStreamEvents(),this.mediaStream&&(this.mediaStream.dispose(),this.mediaStream=null),super.dispose()}subscribeOnMediaStreamEvents(n){this.subs=[n.on("onStreamClientStarted",()=>this.event("onStreamStateChanged").raise("active")),n.on("onStreamClientMuted",(a,s)=>this.event("onStreamStateChanged").raise(s?"inactive":"active")),n.on("onStreamClientEnded",()=>this.event("onStreamStateChanged").raise("stopped")),n.on("onStreamClientError",(a,s)=>{const c=s.type===ke.MEDIA_ERROR.permissionDeniedError||s.type===ke.MEDIA_ERROR.sharingCancelledError;this.event("onStreamStateChanged").raise(c?"cancelled":"failed")})]}unsubscribeFromMediaStreamEvents(){this.subs.forEach(n=>n.dispose()),this.subs=[]}},C$=[ke.MEDIA_STATE.inactive,ke.MEDIA_STATE.receive,ke.MEDIA_STATE.send,ke.MEDIA_STATE.sendReceive],MSi=[ke.MEDIA_STATE.inactive,ke.MEDIA_STATE.receive],PSi=class extends jr{constructor(n,a,s){super(s),this.configProvider=n,this.deviceManager=a,this.logger=s,this.currentState={microphone:"unknown",camera:"unknown"},this.lastGum={audio:!1,video:!1},this.registeredTrackers=new Set,this.accessIssuePermissionOther={audio:!1,video:!1},this.window=Cc.window,this.permittedModalities={audio:C$,video:C$,sharing:C$},this.initialize()}async initialize(){!yp.hasPermissionsApi()||this.currentState.microphone!=="unknown"&&this.currentState.camera!=="unknown"?this.currentState.microphone!=="unknown"&&this.currentState.camera!=="unknown"||this.logger.safe.warn(`Permissions API is not supported in this browser. Microphone: ${this.currentState.microphone}, camera: ${this.currentState.camera}`):(this.logger.safe.info("Initializing"),await this.registerPermissionTracker("microphone"),await this.registerPermissionTracker("camera"))}getPermissionState(n){return this.currentState[n]||"unknown"}isPermissionKnown(n){const a=this.getPermissionState(n);return a!=="unknown"&&a!=="prompt"}get browserPermittedModalities(){return this.permittedModalities}get knownPermissionStates(){return fs(this.currentState)}update(n,a){const s=fs(a);n.audio||delete s.audio,n.video||delete s.video;const c=fs(this.permittedModalities);Ng(s,(u,m)=>{this.permittedModalities[m]=u?C$:MSi}),xc(c,this.permittedModalities)||this.event("onDevicesPermissionChanged").raise()}async askDevicePermission(n){const a=n?fs(n):{audio:!0,video:this.deviceManager.hasCamera()};if(this.accessIssuePermissionOther={audio:!1,video:!1},this.configProvider.config.permissions.rememberNegative&&(a.audio=a.audio&&this.permittedModalities.audio===C$,a.video=a.video&&this.permittedModalities.video===C$),a.sharing)throw new Error("askDevicePermission does not support sharing constraints.");const s={audio:!1,video:!1};this.lastGum={audio:!1,video:!1};const c=async(b,_,k)=>{const N={audio:!!b.audio,video:!!b.video,sharing:!0};return!(this.configProvider.config.permissions.adpRequestAVLast&&a.audio&&a.video)||this.lastGum.audio&&this.lastGum.video||(this.logger.safe.info("Prompting for audio and video to ensure omnibar state"),await this.askDevicePermissionPrompt({audio:!0,video:!0},!1)),this.update(a,N),this.deviceManager.raiseTelemetryEvent("ask_device_permission",{constraints:n,resultConstraints:b,error:k,reason:_}),N};await this.initialize();const u=this.getPermissionState("microphone"),m=this.getPermissionState("camera");if(this.logger.safe.info(`Permission state { audio: ${u}, video: ${m} }`),this.configProvider.config.permissions.useNegativeInAdp&&(!a.audio||u==="denied")&&(!a.video||m==="denied"))return c(s,"navigator_permissions_denied");if(this.configProvider.config.permissions.usePositiveInAdp&&(!a.audio||a.audio&&u==="granted")&&(!a.video||a.video&&m==="granted"))return c(a,"navigator_permissions_granted");try{return c(this.getConstrainsWithPermissionError(await this.askDevicePermissionPrompt(a,this.configProvider.config.permissions.adpFallback)),"stream_acquisition")}catch(b){return c(s,"stream_acquisition",b)}}async askDevicePermissionPrompt(n,a=!0){const s={audio:!1,video:!1};try{const c=this.deviceManager.getMediaStream(n);return c&&(this.lastGum=fs(n),await c.start(),s.audio=c.hasAudio(),s.video=c.hasVideo(),this.disposeLater(c)),s}catch(c){if(n.audio&&n.video&&a){try{s.video=this.configProvider.config.permissions.adpFallbackVideo&&(await this.askDevicePermissionPrompt({video:!0})).video}catch(u){u.type!==ke.MEDIA_ERROR.permissionDeniedError&&u.type!==ke.MEDIA_ERROR.permissionDeniedBySystemError&&(this.accessIssuePermissionOther.video=!0)}try{s.audio=this.configProvider.config.permissions.adpFallbackAudio&&(await this.askDevicePermissionPrompt({audio:!0})).audio}catch(u){u.type!==ke.MEDIA_ERROR.permissionDeniedError&&u.type!==ke.MEDIA_ERROR.permissionDeniedBySystemError&&(this.accessIssuePermissionOther.audio=!0)}}else if(a)throw c;return s}}getConstrainsWithPermissionError(n){return this.configProvider.config.permissions.disableOnPermissionDeniedOnly?{audio:this.accessIssuePermissionOther.audio||n.audio,video:this.accessIssuePermissionOther.video||n.video}:n}disposeLater(n){setTimeout(()=>{n.dispose()},this.configProvider.config.mediaStreamHoldInterval)}async registerPermissionTracker(n){if(!this.registeredTrackers.has(n))try{const a=await this.window.navigator.permissions.query({name:n});this.handlePermissionStateChanged(n,a.state),a.onchange=()=>this.handlePermissionStateChanged(n,a.state),this.registeredTrackers.add(n)}catch(a){this.logger.safe.error(`Error querying permissions for ${n}: ${nn(a)}`)}}handlePermissionStateChanged(n,a){if(this.logger.safe.info(`Permission state for ${n} changed ${this.currentState[n]} -> ${a}`),this.configProvider.config.permissions.enumerateDevicesAfterChange){this.logger.safe.info(`enumerateDevicesAfterChange: ${JSON.stringify(this.configProvider.config.permissions)}`),Mv.logger.safe.info("enumerating due to permission change");try{Mv.enumerateDevices()}catch(s){Mv.logger.safe.error(`unable to enumerate on permission change: ${nn(s)}`)}}this.currentState[n]=a,this.deviceManager.raiseTelemetryEvent("permissions_state_changed",this.knownPermissionStates),this.deviceManager.handlePermissionStateChange()}},DSi=class extends Qs{constructor(n,a=sw()){super(),this.dms=n,this.label=a,this.id=sw(),this.receivedEvents=new Map,this.subscribeToDeviceManagers(n)}getDeviceManagers(){return this.dms}dispose(){super.dispose(),this.dms?.forEach(n=>n.dispose()),this.dms=null}subscribeToDeviceManagers(n){n.forEach((a,s)=>{a.on("onVideoEffectsEvent",(...c)=>this.eventHandler("onVideoEffectsEvent",a,()=>this.event("onVideoEffectsEvent").raise(...c))),a.on("onVideoEffectApplied",(...c)=>this.eventHandler("onVideoEffectApplied",a,()=>this.event("onVideoEffectApplied").raise(...c))),a.on("onDeviceTelemetryEvent",c=>this.event("onDeviceTelemetryEvent").raise({deviceId:`${this.id}/${s}`,...c})),a.on("onVideoEffectsTelemetryEvent",c=>this.event("onVideoEffectsTelemetryEvent").raise({deviceId:`${this.id}/${s}`,...c})),a.on("onDevicesPermissionChanged",()=>this.event("onDevicesPermissionChanged").raise(`${this.id}/${s}`)),a.on("onStreamUpdateRequested",(...c)=>this.event("onStreamUpdateRequested").raise(...c))})}eventHandler(n,a,s){let c=this.receivedEvents.get(n);if(c??(c=new Set),c.add(a),this.dms.every(u=>c.has(u)))return s(),void c.clear();this.receivedEvents.set(n,c)}},pu=()=>(n,a,s)=>{const c=s.value;return s.value=function(...u){return this.serialQueue.add(c.bind(this,...u))},s},LSi=class{constructor(n,a,s){this.configProvider=n,this.statistics=a,this.logger=s}isWasmEffectSupported(){return this.configProvider.config.webcv.useWasmEffects?!!window.MediaStreamTrackProcessor||(this.logger.info("wasmEffects disabled, insertable streams are not supported"),!1):(this.logger.info("wasmEffects disabled by feature flag"),!1)}isWebgl2EffectSupported(){return this.isCurrentRendererSupported()&&this.isWebGL2Supported()}isCurrentRendererSupported(){const n=this.configProvider.config.webcv.webGLUnsupportedRenderers;let a=!1;const s=yp.unmaskedGlRenderer;return s&&!n.some(c=>c===s)?a=!0:(this.statistics.setError("RendererIsNotSupported",`Blacklisted from ${JSON.stringify(n)}`),this.logger.info(`Unsupported renderer: ${nn(s)}`)),a}isWebGL2Supported(){try{const n=document.createElement("canvas").getContext("webgl2");if(!n)return this.statistics.setError("WebGL2IsNotSupported"),this.logger.info("WebGL2 context is not supported"),!1;const a=n.getSupportedExtensions(),s=this.configProvider.config.webcv.webGLRequiredExtensions.filter(c=>!a.includes(c));if(s.length>0)return this.statistics.setError("WebGL2RequiredExtensionsNotSupported","Required WebGL2 extensions not supported."),this.logger.info(`Unsupported WebGL2 extensions: ${nn(s)}`),!1}catch(n){return this.statistics.setError("WebGL2IsNotSupported",`Error: ${nn(n)}`),this.logger.error(`isWebGL2Supported: ${nn(n)}`),!1}return!0}},gKe=class{constructor(n){this.loadDuration=-1,this.error=new Ayi(n)}hasData(){return this.error.items.length>0||this.loadDuration>0}startLoadTimer(){this.loadStartTimestamp=Date.now()}stopLoadTimer(){this.loadDuration=Date.now()-this.loadStartTimestamp}clearErrors(){this.error.clear()}setError(n,a){this.error.add({type:n,message:a})}getReport(){return{loadDuration:this.loadDuration,error:this.error.items}}},TU=class extends jr{constructor(n,a,s,c){super(s),this.webcvProvider=n,this.configProvider=a,this.logger=s,this.wasmLoader=c,this.serialQueue=new iL(this.logger),this.videoEffectToWebCVEffectMapping={0:zg.VideoEffectType.Off,1:zg.VideoEffectType.BackgroundBlur,16:zg.VideoEffectType.BackgroundReplacement,512:zg.VideoEffectType.PresenterMode,256:zg.VideoEffectType.None,2048:zg.VideoEffectType.None,262144:zg.VideoEffectType.None},this.currentEffect=0,this.effectProviderSubs=[],this.statistics=new gKe(this.configProvider.config.effectsTelemetryBufferSize),this.processorType=zg.ProcessorType.Webgl2,this.queryMessageProcessor=new OSi(this.configProvider,this.logger)}get isEffectEnabled(){return this.currentEffect!==0||this.queryMessageProcessor.payload.effectType!==0}async init(){if(!this.effectProvider)try{this.effectProvider=await this.initializeVideoEffectProvider()}catch(n){throw Error(n)}}async dispose(){this.logger.safe.debug("Dispose"),this.effectProvider&&(this.effectProviderSubs.forEach(n=>n.dispose()),this.effectProviderSubs=null,await this.effectProvider.disposeAsync()),super.dispose()}async configure(n){if(this.logger.safe.debug(`Set config: ${JSON.stringify(n)}`),this.effectConfig={backgroundImageUrl:n.imagePath,headers:n.headers},this.effectProvider)return this.effectProvider.configureEffect(this.effectConfig);this.logger.safe.debug("WebCV is not initialized. Do nothing")}async setEffectAsync(n){if(this.currentEffect===n)return void this.logger.safe.debug(`Effect ${this.currentEffect} is already set`);this.effectProvider||(this.logger.safe.debug("Initializing effect provider"),await this.init()),this.logger.safe.debug(`Set effect: ${n}`);const a=this.getWebCVEffect(n);if(!a)throw new Error(`Effect with type ${n} is not supported`);if(this.shouldCollectStats(n)&&this.notifyAboutLastSessionStats("EffectChanged"),this.currentEffect=n,this.effectProvider)try{await this.effectProvider.setEffectAsync(a)}catch(s){throw await this.handleFailedProcessing(),this.notifyError("FailedToInitialize",`Failed to apply ${a}, error:${nn(s)}`),s}else this.logger.safe.debug("WebCV is not initialized. Do nothing")}async processingVideoEffectMessage(n){let a={code:0,response:{effects:[]},type:"EnableEffects"};try{await this.init()}catch(c){return this.logger.error(`Failed to initialize WebCV, error:${nn(c)}`),this.notifyError("FailedToInitialize",`Initialization failed, error:${nn(c)}`),a}const s=this.currentEffect;this.logger.info(`Processing video effect request type: ${JSON.stringify(n.type)}`),a=await this.queryMessageProcessor.processVideoEffectMessage(n),this.queryMessageProcessor.reconfigure&&(await this.configure({imagePath:this.queryMessageProcessor.payload.imageConfig.backgroundImageUrl,headers:this.queryMessageProcessor.payload.imageConfig.headers}),this.queryMessageProcessor.reconfigure=!1);try{this.shouldCollectStats(s)&&this.notifyAboutLastSessionStats("EffectChanged"),await this.effectProvider.setEffectAsync(this.getWebCVEffect(this.queryMessageProcessor.payload.effectType),this.queryMessageProcessor.payload)}catch{this.logger.error("Failed to apply video effect")}return a}async setSourceAsync(n){if(this.logger.safe.debug(`Set source: ${n?n.id:"no stream"}`),!this.effectProvider)return this.logger.safe.debug("WebCV is not initialized. Do nothing"),n;let a=n;try{a=await this.effectProvider.setSourceAsync(n)}catch(s){await this.handleFailedProcessing(),this.notifyError("FailedToInitialize",`Failed to set source, error:${nn(s)}`)}return a}async removeSourceAsync(n){if(this.logger.safe.debug(`Remove source: ${n?n.id:"no stream"}`),this.effectProvider)return this.effectProvider.removeSourceAsync(n);this.logger.safe.debug("WebCV is not initialized. Do nothing")}async getEffectsCapability(){let n=0;const a=await this.getCapability();this.logger.safe.debug(`Get capabilty with return: ${JSON.stringify(a)}`);for(const s of a)n|=s;return n}getStats(n){if(!this.effectProvider)return;const a=this.effectProvider.getStats(),s=this.statistics.getReport();return a||s.error.length?{timestamp:Date.now(),statsReason:n,...this.createTelemetryEvent(a,s)}:void 0}getVersion(){return this.effectProvider?.getVersion?.()??"Unknown"}async resetOutputConstraints(n,a=zg.EffectQualityChangeReason.ExternalParam){const s={...this.configProvider.config.webcv.qualityConfig};return s.outputResolution=n.height,this.effectProvider?.configureStreamProcessor(s,zg.EffectQualityChangeReason.ExternalParam)}createTelemetryEvent(n,a){return{payload:{version:this.getVersion(),...a,...n,isWasmEnabled:this.processorType===zg.ProcessorType.Wasm}}}notifyError(n,a){this.statistics.setError(n,a),this.notifyAboutLastSessionStats("EffectError")}notifyAboutLastSessionStats(n){const a=this.getStats(n);a&&this.event("onVideoEffectTelemetryEvent").raise(a)}async initializeVideoEffectProvider(){if(!this.webcvProvider)return this.logger.safe.debug("WebCV provider is not set"),null;this.statistics.startLoadTimer();const n=await this.webcvProvider.getVideoEffectProvider();if(this.statistics.stopLoadTimer(),!n)return this.statistics.setError("FailedToInitialize"),this.logger.safe.warn("WebCV is not initialized"),null;this.logger.safe.debug(`WebCV v${n.getVersion?.()} is initialized`);const a=await this.webcvProvider.getModelConfig();return await n.configureModel(a),this.configProvider.config.webcv.loadWorkerCallback=this.wasmLoader.getWorkerFunction("wasmcv"),this.configProvider.config.webcv.loadTimerWorkerCallback=this.wasmLoader.getWorkerFunction("timer"),await n.configure({...this.configProvider.config.webcv,processorType:this.processorType}),this.effectConfig&&await n.configureEffect(this.effectConfig),this.effectProviderSubs=[n.on("onEffectApplied",()=>this.event("onMediaStreamUpdateRequested").raise("Video")),n.on("onEffectStopped",()=>this.notifyAboutLastSessionStats("EffectStopped")),n.on("onVideoEffectQualityChanged",s=>this.event("onVideoEffectQualityChanged").raise(s)),n.on("onVideoStreamQualityChanged",s=>this.event("onVideoStreamQualityChanged").raise(s.resolution,s.fps,s.reason)),n.on("onCapabilitiesChanged",()=>this.event("onVideoEffectCapabilitiesChanged").raise()),n.on("onFirstFrameProcessed",()=>this.onFirstFrameProcessed()),n.on("onErrorNotified",s=>this.notifyError("WebcvProcessorError",s)),n.on("videoFreezeDetected",s=>this.event("videoFreezeDetected").raise(s))],n}async getCapability(){if(!this.configProvider.config.enableVideoEffects)return this.logger.debug("Video effects disabled"),[0];if(!this.webcvProvider)return this.logger.debug("WebCVProvider is not configured"),[0];const n=new LSi(this.configProvider,this.statistics,this.logger.createChild("CapabilityChecker"));let a=[0];return n.isWasmEffectSupported()?(a=[0,1,16,262144,512,2048],this.processorType=zg.ProcessorType.Wasm):n.isWebgl2EffectSupported()&&(a=[0,1,16],this.processorType=zg.ProcessorType.Webgl2),a}getWebCVEffect(n){return this.videoEffectToWebCVEffectMapping[n]||zg.VideoEffectType.None}onFirstFrameProcessed(){this.event("onVideoEffectApplied").raise(),this.logger.safe.debug("onVideoEffectApplied event raised")}async handleFailedProcessing(){this.currentEffect=0;try{await this.effectProvider.setEffectAsync(zg.VideoEffectType.Off)}catch(n){this.notifyError("WebcvProcessorError",`Failed to handle error state, error:${nn(n)}`)}}shouldCollectStats(n){return this.currentEffect!==0&&n!==0&&this.currentEffect!==n}};Kt([pu()],TU.prototype,"init"),Kt([pu()],TU.prototype,"dispose"),Kt([pu()],TU.prototype,"configure"),Kt([pu()],TU.prototype,"setSourceAsync"),Kt([pu()],TU.prototype,"removeSourceAsync"),Kt([pu()],TU.prototype,"getEffectsCapability");var OSi=class{constructor(n,a){this.configProvider=n,this.logger=a,this.currentEffects=0,this.currentEffectPayload={effectType:0},this.shouldReconfigure=!1}get payload(){return this.currentEffectPayload.effectType=this.currentEffects,this.currentEffectPayload}get reconfigure(){return this.shouldReconfigure}set reconfigure(n){this.shouldReconfigure=n}async processVideoEffectMessage(n){switch(n.type){case"EnableEffects":return await this.processEnableEffectsMessage(n);case"DisableEffects":return await this.processDisableEffectsMessage(n);case"QueryEffects":return await this.processQueryEffectsMessage(n);default:return this.logger.error(`Unsupported video effect message type: ${n.type}`),null}}async processEnableEffectsMessage(n){const a={code:0,response:{effects:[]},type:"EnableEffects"};for(let s=0;s<n.request.effects.length;s++){const c=n.request.effects[s];switch(c.type){case"BackgroundModification":if(c.options.variant==="Blur"){this.currentEffects|=1;const u={type:"BackgroundModification",options:{variant:"Blur"}};a.response.effects.push(u),this.currentEffects&=-262673}else if(c.options.variant==="Replacement"){this.currentEffects|=16;const u={type:"BackgroundModification",options:{variant:"Replacement",location:c.options.location}};this.shouldReconfigure=!0,this.currentEffectPayload.imageConfig={backgroundImageUrl:c.options.location,headers:c.options?.headers},a.response.effects.push(u),this.currentEffects&=-262658}else if(c.options.variant==="WeatherPerson"){if(!this.configProvider.config.webcv.useWasmEffects){this.logger.error("WeatherPerson effect is not supported on non wasm effect provider");break}this.currentEffects|=512;const u={type:"BackgroundModification",options:{variant:"WeatherPerson"}};a.response.effects.push(u),this.currentEffects&=-262162}else if(c.options.variant==="Bokeh"){if(!this.configProvider.config.webcv.useWasmEffects){this.logger.error("Bokeh effect is not supported on non wasm effect provider");break}this.currentEffects|=262144;const u={type:"BackgroundModification",options:{variant:"Bokeh"}};a.response.effects.push(u),this.currentEffects&=-530}break;case"TouchUp":this.logger.error("TouchUp effect is not supported on non wasm effect provider");break;case"AutoAdjust":if(!this.configProvider.config.webcv.useWasmEffects){this.logger.error("AutoAdjust effect is not supported on non wasm effect provider");break}this.currentEffects|=2048,a.response.effects.push({type:"AutoAdjust"})}}return a}async processQueryEffectsMessage(n){const a={code:0,response:{effects:[]},type:"QueryEffects"};if(1&this.currentEffects){const s={type:"BackgroundModification",options:{variant:"Blur"},state:"On"};a.response.effects.push(s)}else{const s={type:"BackgroundModification",options:{variant:"Blur"},state:"Off"};a.response.effects.push(s)}if(262144&this.currentEffects&&this.configProvider.config.webcv.useWasmEffects){const s={type:"BackgroundModification",options:{variant:"Bokeh"},state:"On"};a.response.effects.push(s)}else if(this.configProvider.config.webcv.useWasmEffects){const s={type:"BackgroundModification",options:{variant:"Bokeh"},state:"Off"};a.response.effects.push(s)}else{const s={type:"BackgroundModification",options:{variant:"Bokeh"},state:"Unavailable"};a.response.effects.push(s)}if(16&this.currentEffects){const s={variant:"Replacement",location:""};this.currentEffectPayload?.imageConfig&&(s.location=this.currentEffectPayload?.imageConfig.backgroundImageUrl);const c={type:"BackgroundModification",options:s,state:"On"};a.response.effects.push(c)}else{const s={type:"BackgroundModification",options:{variant:"Replacement",location:""},state:"Off"};a.response.effects.push(s)}if(512&this.currentEffects&&this.configProvider.config.webcv.useWasmEffects){const s={type:"BackgroundModification",options:{variant:"WeatherPerson"},state:"On"};a.response.effects.push(s)}else if(this.configProvider.config.webcv.useWasmEffects){const s={type:"BackgroundModification",options:{variant:"WeatherPerson"},state:"Off"};a.response.effects.push(s)}else{const s={type:"BackgroundModification",options:{variant:"WeatherPerson"},state:"Unavailable"};a.response.effects.push(s)}if(256&this.currentEffects){const s={type:"TouchUp",state:"Unavailable",options:{strength:0}};a.response.effects.push(s)}if(2048&this.currentEffects&&this.configProvider.config.webcv.useWasmEffects){const s={type:"AutoAdjust",state:"On"};a.response.effects.push(s)}else if(this.configProvider.config.webcv.useWasmEffects){const s={type:"AutoAdjust",state:"Off"};a.response.effects.push(s)}else{const s={type:"AutoAdjust",state:"Unavailable"};a.response.effects.push(s)}return a}async processDisableEffectsMessage(n){const a={code:0,response:{effects:[]},type:"DisableEffects"},s=n,c={effects:[]};for(let u=0;u<s.request.effects.length;u++){const m=s.request.effects[u];switch(m.type){case"BackgroundModification":if(m.options.variant==="Blur"){const b={type:"BackgroundModification",options:{variant:"Blur"}};c.effects.push(b),this.currentEffects&=-2}if(m.options.variant==="Bokeh"){const b={type:"BackgroundModification",options:{variant:"Bokeh"}};c.effects.push(b),this.currentEffects&=-262145}if(m.options.variant==="Replacement"){const b={variant:"Replacement",location:""};this.payload?.imageConfig!==void 0&&(b.location=this.payload?.imageConfig.backgroundImageUrl);const _={type:"BackgroundModification",options:b};c.effects.push(_),this.currentEffects&=-17}if(m.options.variant==="WeatherPerson"){const b={type:"BackgroundModification",options:{variant:"WeatherPerson"}};c.effects.push(b),this.currentEffects&=-513}break;case"TouchUp":this.logger.error("TouchUp effect is not supported now"),c.effects.push({type:"TouchUp",options:{strength:0}}),this.currentEffects&=-257,this.currentEffectPayload.softfocusStrength=0;break;case"AutoAdjust":c.effects.push({type:"AutoAdjust"}),this.currentEffects&=-2049}}return a.response=c,a}},CU=class extends jr{constructor(n,a,s,c,u,m){super(u),this.wasmdnsProvider=n,this.wasmaecProvider=a,this.wasmVqeProvider=s,this.configProvider=c,this.logger=u,this.wasmLoader=m,this.serialQueue=new iL(this.logger),this.stopped=!0,this.hasError=!1,this.isProviderReady=!1,this.statistics=new gKe(this.configProvider.config.effectsTelemetryBufferSize),this.currentEffect=Ao.AudioEffectType.Off,this.currentEffectCapability=0,this.audioEffectToWasmAudioEffectType={0:Ao.AudioEffectType.Off,1:Ao.AudioEffectType.NoiseSuppressionClassic,2:Ao.AudioEffectType.NoiseSuppressionDeep,4:Ao.AudioEffectType.EchoCancellationClassic,8:Ao.AudioEffectType.VoiceQualityEnhancementClassic,16:Ao.AudioEffectType.VoiceQualityEnhancementDeep},this.noiseSuppressionModeToWasmDnsEffectMapping={Off:Ao.AudioEffectType.Off,High:Ao.AudioEffectType.NoiseSuppressionDeep,Low:Ao.AudioEffectType.NoiseSuppressionClassic},this.wasmLoaderSub=this.wasmLoader?.on("onLoadError",b=>{this.handleWasmLoaderError(b)})}get isEffectEnabled(){return this.currentEffect!==Ao.AudioEffectType.Off}shouldFallbackToNativeProcessing(){return this.configProvider.config.wasmvqe.enableVqe||this.configProvider.config.wasmdns.enableNoiseSuppression?this.configProvider.config.wasmvqe.asyncInitialization&&!this.isProviderReady?(this.logger.safe.info("shouldFallbackToNativeProcessing: provider is not yet initialized"),!0):this.hasError?(this.logger.safe.info("shouldFallbackToNativeProcessing: error was encountred initializing the package"),!0):this.configProvider.config.wasmvqe.enableVqe&&!this.wasmVqeProvider?(this.logger.safe.info("shouldFallbackToNativeProcessing: VQE provider is enabled but not loaded"),!0):!(!this.configProvider.config.wasmdns.enableNoiseSuppression||this.wasmdnsProvider&&this.wasmaecProvider||(this.logger.safe.info("shouldFallbackToNativeProcessing: DNS/AEC provider is enabled but not loaded"),0)):(this.logger.safe.info("shouldFallbackToNativeProcessing: custom processing is not enabled"),!0)}nsModeToVqeMode(n,a){switch(n){case"High":return a?Ao.VqeMode.DeepVQE:Ao.VqeMode.DeepNS;case"Low":return a?Ao.VqeMode.SkypeVQE:Ao.VqeMode.SkypeNS;default:return a?Ao.VqeMode.SkypeAEC:Ao.VqeMode.Off}}vqeModeToNsMode(n){switch(n){case Ao.VqeMode.DeepVQE:case Ao.VqeMode.DeepNS:return"High";case Ao.VqeMode.SkypeVQE:case Ao.VqeMode.SkypeNS:return"Low";case Ao.VqeMode.SkypeAEC:case Ao.VqeMode.Off:default:return"Off"}}vqeModeToAudioEffectType(n){switch(n){case Ao.VqeMode.DeepVQE:return 16;case Ao.VqeMode.DeepNS:return 2;case Ao.VqeMode.SkypeVQE:return 8;case Ao.VqeMode.SkypeNS:return 1;case Ao.VqeMode.SkypeAEC:return 4;case Ao.VqeMode.Off:default:return 0}}audioEffectTypeToVqeMode(n){switch(n){case 16:return Ao.VqeMode.DeepVQE;case 2:return Ao.VqeMode.DeepNS;case 8:return Ao.VqeMode.SkypeVQE;case 1:return Ao.VqeMode.SkypeNS;case 4:return Ao.VqeMode.SkypeAEC;default:return Ao.VqeMode.Off}}async setSourceWithAsyncInitialization(n){if(this.hasError)return n;if(!this.isProviderReady)return this.logger.safe.info("Provider is not ready. Initializing provider async"),this.initialize(),n;if(this.shouldFallbackToNativeProcessing())return this.logger.safe.info("No custom audio effect is used. Fallback to native audio processing"),n;try{const a=await this.vqeProvider.setSourceAsync(n);return this.aecRefStream&&(this.logger.safe.debug(`Setting the reference stream to: ${this.aecRefStream.id}`),this.setAecRefStream(this.aecRefStream,this.rendererId)),a}catch(a){return this.notifyError("WasmVqeProcessorError",`setSourceAsync: Failed to asynchronously set source for VQE (${a})`),n}}async setSourceAsync(n){if(this.logger.safe.debug(`Set source: ${n?n.id:"no stream"}, currentEffect = ${this.currentEffect}`),this.stopped||this.stop(),this.shouldFallbackToNativeProcessing())return this.logger.safe.info("No custom audio effect is used. Fallback to native audio processing"),n;if(await this.initializeProvider(),await this.configureEffect(),this.isProviderReady=!0,!(this.vqeProvider||this.dnsProvider&&this.aecProvider)){const s=this.vqeProvider?this.dnsProvider?"AEC":"DNS":"VQE";return this.statistics.setError("FailedToInitialize",`setSourceAsync: audio effect provider not initialized (${s}).`),this.logger.safe.warn(`Unable to configure audio effects: audio effect provider not initialized (${s}).`),n}if(!this.configProvider.config.wasmvqe.enableVqe&&!this.configProvider.config.wasmdns.enableNoiseSuppression)return n;if(this.effectProviderSubs=[this.vqeProvider?.on("onEffectStopped",()=>this.notifyAboutLastSessionStats()),this.vqeProvider?.on("onMetricsUpdated",()=>this.notifyAboutLastSessionStats()),this.vqeProvider?.on("onErrorNotified",(s,c)=>this.notifyError("WasmVqeProcessorError",s,c)),this.dnsProvider?.on("onEffectStopped",()=>this.notifyAboutLastSessionStats()),this.dnsProvider?.on("onMetricsUpdated",()=>this.notifyAboutLastSessionStats()),this.dnsProvider?.on("onErrorNotified",s=>this.notifyError("WasmDnsProcessorError",s)),this.aecProvider?.on("onErrorNotified",s=>this.notifyError("WasmAecProcessorError",s))],this.configProvider.config.wasmvqe.enableVqe)try{const s=await this.vqeProvider.setSourceAsync(n);return this.aecRefStream&&(this.logger.safe.debug(`Setting the reference stream to: ${this.aecRefStream.id}`),this.setAecRefStream(this.aecRefStream,this.rendererId)),s}catch(s){return this.notifyError("WasmVqeProcessorError",`setSourceAsync: Failed to asynchronously set source for VQE (${s})`),n}let a=n;try{a=await this.aecProvider.setSourceAsync(n),this.aecRefStream&&(this.logger.safe.debug(`Setting the reference stream to: ${this.aecRefStream.id}`),this.setAecRefStream(this.aecRefStream,this.rendererId))}catch(s){this.notifyError("WasmAecProcessorError",`setSourceAsync: Failed to asynchronously set source for AEC (${s})`)}try{return await this.dnsProvider.setSourceAsync(a)}catch(s){this.notifyError("WasmDnsProcessorError",`setSourceAsync: Failed to asynchronously set source for DNS (${s})`)}return a}setAecRefStream(n,a){try{if(!n&&this.rendererId!==a)return void this.logger.safe.debug(`Ref stream can't be set to null by renderer ${a}`);if(this.logger.safe.debug(`Setting the reference stream to: ${n?n.id:"Null"} requested by renderer ${a}`),this.aecRefStream=n,this.rendererId=a,!(this.vqeProvider||this.dnsProvider&&this.aecProvider)){const s=this.vqeProvider?this.dnsProvider?"AEC":"DNS":"VQE";return this.statistics.setError("FailedToInitialize",`setAecRefStream: audio effect provider not initialized (${s}).`),void this.logger.safe.warn(`Unable to setAecRefStream for audio effects: audio effect provider not initialized (${s}).`)}this.configProvider.config.wasmvqe.enableVqe?this.vqeProvider.setRefStream(n):this.configProvider.config.wasmdns.enableNoiseSuppression&&this.aecProvider.setRefStream(n)}catch(s){this.notifyError("WasmVqeProcessorError",`setRefStream: Failed to set reference stream for echo cancellation (${s})`)}}async setEffectAsync(n){const a=this.audioEffectToWasmAudioEffectType[n];if(this.currentEffect===a)return;const s=this.currentEffect===Ao.AudioEffectType.Off||a===Ao.AudioEffectType.Off;if(this.currentEffect=a,this.userNoiseSuppressionMode=this.audioEffectTypeToVqeMode(n),await this.initializeProvider(),await this.configureEffect(),!(this.vqeProvider||this.dnsProvider&&this.aecProvider)){const c=this.vqeProvider?this.dnsProvider?"AEC":"DNS":"VQE";throw this.notifyError("FailedToInitialize",`setEffectAsync: audio effect provider not initialized (${c}).`),Error("FailedToInitialize")}try{this.configProvider.config.wasmvqe.enableVqe?await this.vqeProvider.setEffectAsync(a):this.configProvider.config.wasmdns.enableNoiseSuppression&&(await this.dnsProvider.setEffectAsync(a),await this.aecProvider.setEffectAsync(a)),this.configProvider.config.applyAudioEffectOnDemand&&this.configProvider.config.wasmvqe.enableVqe&&s&&this.requestStreamUpdate(),this.logger.safe.debug(`The audio effect was set to '${a}'`)}catch(c){throw this.notifyError("WasmVqeProcessorError",`setEffectAsync: Failed to apply '${a}' audio effect, error: ${nn(c)}`),c}}stop(){try{this.dnsProvider?.dispose(),this.dnsProvider=null,this.aecProvider?.dispose(),this.aecProvider=null,this.vqeProvider?.dispose(),this.vqeProvider=null,this.effectProviderSubs?.forEach(n=>n?.dispose()),this.effectProviderSubs=null,this.wasmLoaderSub?.dispose(),this.wasmLoaderSub=null,this.stopped=!0,this.isProviderReady=!1,this.logger.safe.debug("The audio effects provider was stopped.")}catch(n){this.logger.safe.error(`Failed to stop the audio effects provider (${n})`)}}dispose(){try{this.hasError=!1,this.stop(),super.dispose(),this.logger.safe.debug("The audio effects provider was disposed.")}catch(n){this.logger.safe.error(`dispose: Failed to dispose the audio effects provider (${n})`)}}async getEffectsCapability(){return this.currentEffectCapability=0,this.configProvider.config.wasmvqe.enableVqe?(this.currentEffectCapability|=1,this.currentEffectCapability|=2,this.configProvider.config.wasmvqe.enableAec&&(this.currentEffectCapability|=4,this.currentEffectCapability|=8,this.currentEffectCapability|=16)):this.configProvider.config.wasmdns.enableNoiseSuppression&&(this.currentEffectCapability|=1,this.currentEffectCapability|=2,this.currentEffectCapability|=4),this.currentEffectCapability}getVersion(){return`WasmDns ${this.dnsProvider?.getVersion()??"Unknown"} / WasmAec ${this.aecProvider?.getVersion()??"Unknown"} / WasmVqe ${this.vqeProvider?.getVersion()??"Unknown"}`}getStats(){let n=this.configProvider.config.wasmvqe.enableVqe?this.vqeProvider?.getStats():this.dnsProvider?.getStats();if(!n){if(!this.statistics.hasData())return null;n={}}return n.userNoiseSuppressionMethod=this.userNoiseSuppressionMode,{timestamp:Date.now(),...this.createTelemetryEvent(n)}}notifyError(n,a,s=!1){this.logger.error(`Audio effect error: ${n}, message: ${a}`),this.statistics.setError(n,a),this.notifyAboutLastSessionStats(),s&&(this.stop(),this.requestStreamUpdate(),this.hasError=!0),this.event("onEffectsError").raise("Audio",n,a)}async initialize(){this.stopped||this.stop(),this.statistics.startLoadTimer(),await this.initializeProvider(),this.effectProviderSubs=[this.vqeProvider?.on("onEffectStopped",()=>this.notifyAboutLastSessionStats()),this.vqeProvider?.on("onMetricsUpdated",()=>this.notifyAboutLastSessionStats()),this.vqeProvider?.on("onErrorNotified",(n,a)=>this.notifyError("WasmVqeProcessorError",n,a))],await this.configureEffect(),this.isProviderReady=!0,this.statistics.stopLoadTimer(),this.requestStreamUpdate()}async initializeProvider(){if(this.configProvider.config.wasmvqe.enableVqe&&!this.vqeProvider)return this.logger.safe.debug("Initializing VQE provider ..."),void(this.vqeProvider=await this.initializeAudioEffectProvider(Ao.AudioEffectType.VoiceQualityEnhancementDeep));this.configProvider.config.wasmdns.enableNoiseSuppression&&!this.dnsProvider&&(this.logger.safe.debug("Initializing DNS provider ..."),this.dnsProvider=await this.initializeAudioEffectProvider(Ao.AudioEffectType.NoiseSuppressionDeep)),this.configProvider.config.wasmdns.enableNoiseSuppression&&!this.aecProvider&&(this.logger.safe.debug("Initializing AEC provider ..."),this.aecProvider=await this.initializeAudioEffectProvider(Ao.AudioEffectType.EchoCancellationClassic))}async configureEffect(n){this.statistics.clearErrors();let a=n;if(!a){let s=this.configProvider.mediaConfig.noiseSuppressionMode;this.logger.safe.info(`Configuring the audio effect manager for Noise Suppression mode: ${s}`),s==="Auto"&&(s=this.configProvider.config.wasmvqe.enableVqe?this.vqeModeToNsMode(this.configProvider.config.wasmvqe.defaultVqeMode):this.configProvider.config.wasmdns.noiseSuppressionMode,this.logger.safe.info(`Overriding 'Auto' with ${s}`)),a={...this.configProvider.config.wasmdns,...this.configProvider.config.wasmvqe},a.noiseSuppressionMode=s}if(await this.getEffectsCapability(),this.configProvider.config.wasmvqe.enableVqe)try{if(!this.vqeProvider)return void this.logger.safe.error("VQE provider is not initialized");this.userNoiseSuppressionMode&&(a.defaultVqeMode=this.userNoiseSuppressionMode),a.loadAudioWorkletCallback=this.wasmLoader?.audioWorklet?.getWasmVqeWorklet,a.loadWasmWorkerCallback=this.wasmLoader?.audioWorklet?.getWasmVqeWorker,this.logger.safe.debug("Configuring VQE audio effects ..."),await this.vqeProvider.configureEffect(a),this.logger.safe.debug(`The audio effects were configured as follows: ${nn(a)}, and current capability is ${this.currentEffectCapability}.`)}catch(s){this.notifyError("FailedToInitialize",`Audio effect provider configuration failed (${s}), while trying to use this configuration: ${nn(a)},
                    under the following capability: ${this.currentEffectCapability}.`,!0)}else if(this.configProvider.config.wasmdns.enableNoiseSuppression){a.noiseSuppressionMode||(this.logger.safe.debug("configureEffect was called without a noiseSuppressionMode. Using noiseSuppressionMode from config provider ..."),a.noiseSuppressionMode=this.configProvider.mediaConfig.noiseSuppressionMode),this.currentEffect=this.noiseSuppressionModeToWasmDnsEffectMapping[a.noiseSuppressionMode],this.logger.safe.debug(`currentEffect is ${this.currentEffect}`);try{if(!this.dnsProvider||!this.aecProvider)return void this.logger.safe.debug("DNS & AEC providers not initialized");this.logger.safe.debug("Configuring DNS/AEC audio effects ..."),a.loadAudioWorkletCallback=this.wasmLoader?.audioWorklet?.getWasmDnsWorklet,await this.dnsProvider.configureEffect(a),a.loadAudioWorkletCallback=this.wasmLoader?.audioWorklet?.getWasmAecWorklet,await this.aecProvider.configureEffect(a),this.logger.safe.debug(`The audio effects were configured as follows: ${nn(a)}, and current capability is ${this.currentEffectCapability}.`)}catch(s){this.notifyError("FailedToInitialize",`Audio effect provider configuration failed (${s}), while trying to use this configuration: ${nn(a)},
                    under the following capability: ${this.currentEffectCapability}.`,!0)}}}async initializeAudioEffectProvider(n){if(!this.wasmVqeProvider&&n===Ao.AudioEffectType.VoiceQualityEnhancementDeep)return this.statistics.setError("FailedToInitialize","initializeAudioEffectProvider: WasmVqe package not available."),this.logger.safe.warn("WasmVqe package not available."),null;if(!this.wasmdnsProvider&&n===Ao.AudioEffectType.NoiseSuppressionDeep)return this.statistics.setError("FailedToInitialize","initializeAudioEffectProvider: WasmDns package not available."),this.logger.safe.warn("WasmDns package not available."),null;if(!this.wasmaecProvider&&n===Ao.AudioEffectType.EchoCancellationClassic)return this.statistics.setError("FailedToInitialize","initializeAudioEffectProvider: WasmAec package not available."),this.logger.safe.warn("WasmAec package not available."),null;let a;try{this.configProvider.config.wasmvqe.enableVqe&&n===Ao.AudioEffectType.VoiceQualityEnhancementDeep&&(a=await this.wasmVqeProvider.getAudioEffectProvider()),this.configProvider.config.wasmdns.enableNoiseSuppression&&n===Ao.AudioEffectType.NoiseSuppressionDeep&&(a=await this.wasmdnsProvider.getAudioEffectProvider()),this.configProvider.config.wasmdns.enableNoiseSuppression&&n===Ao.AudioEffectType.EchoCancellationClassic&&(a=await this.wasmaecProvider.getAudioEffectProvider())}catch(s){this.logger.safe.warn(`initializeAudioEffectProvider: Failed to initialize the audio effect provider (${s})`),this.statistics.setError("FailedToInitialize",`initializeAudioEffectProvider: Failed to initialize the audio effect provider (${s})`)}return this.statistics.stopLoadTimer(),a?(n===Ao.AudioEffectType.VoiceQualityEnhancementDeep&&this.logger.safe.debug(`WasmVqe v${a.getVersion?.()} initialized!`),n===Ao.AudioEffectType.NoiseSuppressionDeep&&this.logger.safe.debug(`WasmDns v${a.getVersion?.()} initialized!`),n===Ao.AudioEffectType.EchoCancellationClassic&&this.logger.safe.debug(`WasmAec v${a.getVersion?.()} initialized!`),a):(this.logger.safe.warn("Unitialized Wasm audio effect provider."),null)}createTelemetryEvent(n){return{payload:{audioEffectsCapability:this.currentEffectCapability,version:this.getVersion(),isProviderReady:this.isProviderReady,...this.statistics.getReport(),...n}}}notifyAboutLastSessionStats(){const n=this.getStats();n&&this.event("onAudioEffectTelemetryEvent").raise(n)}handleWasmLoaderError(n){n==="wasmvqe"&&this.notifyError("FailedToInitialize","Error loading additional scripts",!0)}requestStreamUpdate(){this.hasError||(this.logger.warn("Requesting stream update"),this.event("onMediaStreamUpdateRequested").raise("Audio"))}};Kt([pu()],CU.prototype,"setSourceWithAsyncInitialization"),Kt([pu()],CU.prototype,"setSourceAsync"),Kt([pu()],CU.prototype,"setAecRefStream"),Kt([pu()],CU.prototype,"setEffectAsync"),Kt([pu()],CU.prototype,"stop"),Kt([pu()],CU.prototype,"dispose");var mKe=class{constructor(n){this.logger=n}async setSourceAsync(n){let a=document.createElement("video");return a.srcObject=n,this.logger.info(`Stream settings before play: ${JSON.stringify(this.getSettings(n))}`),await a.play(),this.logger.info(`Stream settings after play: ${JSON.stringify(this.getSettings(n))}`),a.pause(),a.srcObject=null,a.remove(),a=null,n}getSettings(n){return n.getVideoTracks()?.[0]?.getSettings()}},NSi=class extends jr{constructor(n,a){super(),this.configProvider=n,this.logger=a}isEffectEnabled(n){switch(n){case"Video":return this.videoEffectManager?.isEffectEnabled;case"Audio":return this.audioEffectManager?.isEffectEnabled;default:return!1}}shouldFallbackToNativeProcessing(n){return n==="Audio"&&this.audioEffectManager?.shouldFallbackToNativeProcessing()}addEffectManager(n,a){switch(n){case"Audio":this.addAudioEffectManagerAndSubscribe(a);break;case"Video":this.configProvider.config.waitForVideoEffectStreamStart&&(this.delayedVideoEffectManager=new mKe(this.logger.createChild("DelayedVideoEffectManager"))),this.addVideoEffectManagerAndSubscribe(a);break;case"ScreenShare":this.delayedScreenShareEffectManager=new mKe(this.logger.createChild("DelayedScreenShareEffectManager"))}}async startEffect(n,a){switch(n){case"Audio":return this.initAudioEffectsWithTimeout(a);case"Video":if(this.configProvider.config.waitForVideoEffectStreamStart){const s=await this.videoEffectManager.setSourceAsync(a);return this.delayedVideoEffectManager.setSourceAsync(s)}return this.videoEffectManager.setSourceAsync(a);case"ScreenShare":return this.delayedScreenShareEffectManager.setSourceAsync(a);default:return a}}async setEffectType(n,a){switch(n){case"Audio":return this.audioEffectManager?.setEffectAsync(a);case"Video":return this.videoEffectManager?.setEffectAsync(a)}}async processingVideoEffectMessage(n){return this.videoEffectManager.processingVideoEffectMessage(n)}stopEffect(n,a){switch(n){case"Audio":this.logger.safe.info("stopping audio effect"),this.audioEffectManager?.dispose();break;case"Video":this.logger.safe.info("stopping video effect"),this.videoEffectManager?.removeSourceAsync(a)}}resetOutputConstraints(n,a,s){n==="Video"&&this.videoEffectManager?.resetOutputConstraints(a,s)}getStats(n,a){switch(n){case"Audio":return this.audioEffectManager?.getStats();case"Video":return this.videoEffectManager?.getStats(a);default:return}}async configure(n,a){if(n==="Video")return this.videoEffectManager?.configure(a)}async getEffectsCapability(n){switch(n){case"Audio":return this.audioEffectManager?.getEffectsCapability();case"Video":return this.videoEffectManager?.getEffectsCapability();default:return 0}}setAecRefStream(n,a){return this.audioEffectManager.setAecRefStream(n,a)}vqeModeToAudioEffectType(n){return this.audioEffectManager.vqeModeToAudioEffectType(n)}nsModeToVqeMode(n,a){return this.audioEffectManager.nsModeToVqeMode(n,a)}getAudioEffectsProviderName(){let n="None";return this.configProvider.config.wasmvqe.enableVqe?n="DeepVqe":this.configProvider.config.wasmdns.enableNoiseSuppression&&(n="DNS"),n}dispose(){super.dispose(),this.audioEffectManager?.dispose(),this.audioEffectManager=null,this.videoEffectManager?.dispose(),this.videoEffectManager=null}async initAudioEffectsWithTimeout(n){return new Promise((a,s)=>{const c=window.setTimeout(()=>{const u=`AudioEffects init timeout. Init took more then ${this.configProvider.config.wasmvqe.initializationTimeoutMs} ms`;this.logger.warn(u),this.audioEffectManager.notifyError("InitializationTimeout",u),a(n)},this.configProvider.config.wasmvqe.initializationTimeoutMs);this.configProvider.config.wasmvqe.asyncInitialization?this.audioEffectManager.setSourceWithAsyncInitialization(n).then(u=>{clearTimeout(c),a(u)}):this.audioEffectManager.setSourceAsync(n).then(u=>{clearTimeout(c),a(u)})})}addAudioEffectManagerAndSubscribe(n){this.audioEffectManager||(this.audioEffectManager=new CU(n.wasmdnsProvider,n.wasmaecProvider,n.wasmVqeProvider,this.configProvider,this.logger.createChild("AudioEffectManager"),n.wasmLoader),this.audioEffectManager.on("onAudioEffectTelemetryEvent",a=>{this.event("onAudioEffectTelemetryEvent").raise(a)}),this.audioEffectManager.on("onMediaStreamUpdateRequested",a=>{this.event("onMediaStreamUpdateRequested").raise(a)}),this.audioEffectManager.on("onEffectsError",(a,s,c)=>{this.event("onEffectsError").raise(a,s,c)}))}addVideoEffectManagerAndSubscribe(n){this.videoEffectManager||(this.videoEffectManager=new TU(n.webcvProvider,this.configProvider,this.logger.createChild("VideoEffectManager"),n.wasmLoader),this.videoEffectManager.on("onMediaStreamUpdateRequested",a=>{this.event("onMediaStreamUpdateRequested").raise(a)}),this.videoEffectManager.on("onVideoEffectQualityChanged",a=>{this.event("onVideoEffectQualityChanged").raise(a)}),this.videoEffectManager.on("onVideoStreamQualityChanged",(a,s,c)=>{this.event("onVideoStreamQualityChanged").raise(a,s,c)}),this.videoEffectManager.on("onVideoEffectCapabilitiesChanged",()=>{this.event("onVideoEffectCapabilitiesChanged").raise()}),this.videoEffectManager.on("onVideoEffectTelemetryEvent",a=>{this.event("onVideoEffectTelemetryEvent").raise(a)}),this.videoEffectManager.on("onVideoEffectApplied",()=>{this.event("onVideoEffectApplied").raise()}),this.videoEffectManager.on("videoFreezeDetected",a=>{this.event("videoFreezeDetected").raise(a)}))}},vTe=class{constructor(n){this.audioContext=new Cc.window.AudioContext,n?(this.sourceNode=this.audioContext.createMediaStreamSource(n),this.analyzerNode=this.createAnalyserNode(this.sourceNode),this.freqs=new Uint8Array(this.analyzerNode.frequencyBinCount),this.ffreqs=new Float32Array(this.analyzerNode.frequencyBinCount)):(this.freqs=new Uint8Array(0),this.ffreqs=new Float32Array(0))}dispose(){this.sourceNode.disconnect(),this.audioContext.close(),this.audioContext=null,this.sourceNode=null,this.analyzerNode=null,this.freqs=null}getData(n){return n===1?this.analyzerNode?.getByteFrequencyData(this.freqs):n===0&&this.analyzerNode?.getByteTimeDomainData(this.freqs),this.freqs}getDataFloat(n){return n===1?this.analyzerNode?.getFloatFrequencyData(this.ffreqs):n===0&&this.analyzerNode?.getFloatTimeDomainData(this.ffreqs),this.ffreqs}getInputLevel(){return this.analyzerNode?.getByteFrequencyData(this.freqs),bve(this.freqs)}getInputLevelNormalized(n=65535,a=255){return Math.floor(this.getInputLevel()*n/a)}createAnalyserNode(n){const a=this.audioContext.createAnalyser();return a.fftSize=1024,a.smoothingTimeConstant=.1,n.connect(a),a}},xSi=class{constructor(n,a){this.getAudioStream=n,this.logger=a,this.initialized=!1,this.disposeCachedStream=!1}async init(){if(this.initialized=!0,!this.cachedStream)return this.createStream();this.createAnalyzer()}getInputLevel(){if(!this.initialized||!this.audioStreamAnalyzer)return 0;try{return this.audioStreamAnalyzer.getDataFloat(0).reduce((a,s)=>Math.max(Math.abs(s),a),0)}catch(n){return this.logger.error(JSON.stringify(n)),0}}getInputLevelNormalized(n,a){throw new Error("Method not implemented.")}dispose(n){this.logger.safe.info(`[${n}] AudioStreamAnalyzerWrapper disposed`),this.disposeStreamAnalyzer(),this.disposeStream(),this.initialized=!1}async updateStreamAfterDeviceChange(){this.initialized&&this.disposeCachedStream&&(this.disposeStream(),await this.createStream())}setStream(n,a){this.initialized?(a!=="AudioStreamAnalyzerWrapper"&&this.disposeStream(),this.cachedStream=n,this.createAnalyzer()):this.cachedStream=n}createAnalyzer(){this.disposeStreamAnalyzer(),this.audioStreamAnalyzer=new vTe(this.cachedStream.getMasterStream().rawStream),this.logger.safe.info("AudioStreamAnalyzerWrapper created")}async createStream(){await this.getAudioStream(!1,"AudioStreamAnalyzerWrapper"),this.disposeCachedStream=!0}disposeStreamAnalyzer(){this.audioStreamAnalyzer?.dispose(),this.audioStreamAnalyzer=null}disposeStream(){this.disposeCachedStream&&(this.cachedStream?.getMasterStream()?.dispose(),this.cachedStream?.dispose(),this.cachedStream=null,this.disposeCachedStream=!1)}},BSi=class wQe extends jr{constructor(a,s,c,u,m,b,_,k,N,W){super(a),this.logger=a,this.configProvider=s,this.diagnostics=c,this.domOverrides=u,this.ufdManager=m,this.id=sw(),this.virtualDeviceRecord=new Map,this.deviceEnumerator=new Mv(this.configProvider,this.logger.createChild("DeviceEnumerator")),this.deviceSelection=new kSi(Mv.list,this.configProvider,this.logger.createChild("DeviceSelection")),this.permissionManager=new PSi(this.configProvider,{getMediaStream:ee=>this.getMediaStream({...ee,withEffect:!1,withTimeout:!0,force:!1,audioProcessingFlags:ee.audio&&!ee.video?this.getAudioProcessingFlags():void 0},"permissionManager"),hasCamera:()=>this.hasDeviceType("camera"),raiseTelemetryEvent:(ee,oe)=>this.raiseTelemetryEvent(ee,oe),getActiveConstraints:()=>this.mediaStreamManager.getActiveConstraints(),handlePermissionStateChange:()=>this.handlePermissionStateChange()},this.logger.createChild("PermissionManager")),this.activeRenderers=[],this.selectedDevices={camera:null,microphone:null,speaker:null,audioIngestDevice:null},this.pendingDevices=null,this.deviceManagerSubscriptions=[],this.streamManagerSubscriptions=[],this.streamSubscriptions=new Map,this.rendererSubscriptions=new Map,this.rawDeviceStreamManager=new rSi(this.logger.createChild("RawDeviceStream"),this.raiseTelemetryEvent.bind(this)),this.customDeviceMediaStreamMap=new Map,this.clientAudioRenderers=new Map,this.audioStreamAnalyzerWrapper=new xSi((ee,oe)=>this.getAudioStream(ee,oe),this.logger.createChild("AudioStreamAnalyzerWrapper")),this.audioSharingRequested=!1,this.virtualDeviceSubs=new Map,this.effectsManagerInternal=new NSi(this.configProvider,this.logger.createChild("EffectsManager")),this.effectsManagerInternal.addEffectManager("Audio",{wasmdnsProvider:_,wasmaecProvider:k,wasmVqeProvider:N,wasmLoader:W}),this.effectsManagerInternal.addEffectManager("Video",{webcvProvider:b,wasmLoader:W}),this.effectsManagerInternal.addEffectManager("ScreenShare",null),this.mediaStreamManager=new mSi(this.logger.createChild("MediaStreamManager"),this.configProvider,this.effectsManager),this.deviceManagerSubscriptions=[this.permissionManager.on("onDevicesPermissionChanged",()=>this.event("onDevicesPermissionChanged").raise()),Mv.list.on("onDevicesChanged",(ee,oe)=>this.onDevicesChanged(ee,oe)),this.deviceSelection.on("onSelectedDevicesChanged",(ee,oe)=>this.onSelectedDevicesChanged(ee,oe)),this.effectsManager.on("onAudioEffectTelemetryEvent",ee=>{this.diagnostics.registerAudioEffectsEvent(fs(ee)),this.event("onAudioEffectsTelemetryEvent").raise(ee)}),this.effectsManager.on("onMediaStreamUpdateRequested",ee=>this.onMediaStreamUpdateRequested(ee,!0)),this.effectsManager.on("onVideoEffectQualityChanged",ee=>this.onVideoEffectsQualityEventHandler(ee)),this.effectsManager.on("onVideoEffectTelemetryEvent",ee=>{this.diagnostics.registerVideoEffectsEvent(fs(ee)),this.event("onVideoEffectsTelemetryEvent").raise(ee)}),this.effectsManager.on("onVideoEffectApplied",()=>{this.raiseTelemetryEvent("video_effect_applied",{}),this.event("onVideoEffectApplied").raise()}),this.effectsManager.on("onEffectsError",(ee,oe,de)=>this.event("onEffectsError").raise(ee,oe,de))],this.subscribeOnStreamManagerEvents(),this.subscribeOnDeviceEnumeratorEvents(),this.deviceList.length&&this.onSelectedDevicesChanged(this.deviceSelection.selectedDevices,!1),this.createChildDeviceManager=ee=>new wQe(ee,s,new cKe(s),u,m,b,_,k,N,W)}get deviceList(){return Mv.list.devices}get isDeviceListAvailable(){return Mv.isDeviceListAvailable}get isAudioOutputSelectionSupported(){return this.configProvider.userAgentConfig.isAudioOutputSelectionSupported}get effectsManager(){return this.effectsManagerInternal}createPreviewRenderer(a,s){const c=new hSi(a,this,this.logger.createChild("videorenderer"),this.configProvider,s);return this.domOverrides.onMediaElementAdded&&this.domOverrides.onMediaElementAdded(c.getVideoElement()),this.subscribeOnRendererEvents(c),c}async askDevicePermission(a){await this.isDeviceListAvailable.promise;const s=await this.permissionManager.askDevicePermission(a);if(this.configProvider.config.devices.enumerateDevicesAfterADP)try{await Mv.enumerateDevices()}catch(c){this.logger.safe.warn(`Post-ADP device enumeration failed: ${nn(c)}`)}return s}getPermissionState(a){return this.permissionManager.getPermissionState(a)}handlePermissionStateChange(){this.diagnostics&&(this.diagnostics.permissionStates=this.permissionManager.knownPermissionStates),this.event("onPermissionStateChanged").raise()}onMediaStreamUpdateRequested(a,s=!1){if(a==="Video"&&(this.updateRenderersAsync(),this.effectsManager.isEffectEnabled("Video")))return this.logger.safe.info("onStreamUpdateRequested will be called after the first frame is proccessed of the video effect stream"),void this.effectsManager.once("onVideoEffectApplied",()=>this.event("onStreamUpdateRequested").raise(a));this.event("onStreamUpdateRequested").raise(a,s)}createAudioRenderer(){const a=new hTe(this.logger.createChild("CustomAudioRenderer"),this.configProvider),s=a.id;this.clientAudioRenderers.set(s,a);const c=a.play.bind(a),u=a.stop.bind(a);return this.raiseTelemetryEvent("custom_audio_renderer_created",this.getSelectedDevices()),{play:c,stop:u,dispose:()=>{this.clientAudioRenderers.get(s)?.dispose(),this.clientAudioRenderers.delete(s)},setMuted:(m,b=hi())=>a.setMuted(m,b),isMuted:()=>a.muted}}setAudioSharingRequested(a){this.audioSharingRequested=a}createDevicesHandle(a,s,c){const u=a.sharing?"ScreenShare":a.video?"Video":"Audio";return new RSi(this.logger.createChild("DevicesHandle"),this.getMediaStream({...a,...c&&{deviceId:c},withTimeout:!1,withEffect:!1,audioProcessingFlags:this.audioProcessingFlags,force:!1,withOverridenStream:this.customDeviceMediaStreamMap.get(u)?.active&&this.customDeviceMediaStreamMap.get(u)},s))}shareSystemSound(a){this.configProvider.config.postponeAudioMixerForAudioSharing&&(this.audioSharingRequested=a,this.event("onAudioSharingToggled").raise(a))}getAllowedModalities(){const a=Xp(this.permissionManager.browserPermittedModalities);return this.hasDeviceType("microphone")||(a.audio=[ke.MEDIA_STATE.inactive,ke.MEDIA_STATE.receive]),this.hasDeviceType("camera")||(a.video=[ke.MEDIA_STATE.inactive,ke.MEDIA_STATE.receive]),a}getRawDeviceMediaStream(a,s){if(a!=="ScreenShare"&&!this.hasDeviceType(this.getDeviceType(a)))throw new Error("NoInputDevice");this.audioSharingRequested=s;const c=this.getStreamHandlerByType(a);if(!c)return this.logger.safe.debug(`method not found for ${a}`),null;const u=this.rawDeviceStreamManager.createIRawStreamClient(c,a);return this.raiseTelemetryEvent("IRawStream_client_created",a),u}setRawMediaStream(a,s){if(!a)throw this.logger.error(`Could not set ${a} as to ${s}`),new Error("InvalidStream");this.customDeviceMediaStreamMap.set(s,a),this.onMediaStreamUpdateRequested(s),this.raiseTelemetryEvent("set_raw_outgoing_media_stream",s)}unsetRawMediaStream(a){this.customDeviceMediaStreamMap.get(a)?(this.customDeviceMediaStreamMap.delete(a),this.onMediaStreamUpdateRequested(a),this.raiseTelemetryEvent("unset_raw_outgoing_media_stream",a)):this.logger.safe.debug("no custom stream")}async setVideoEffects(a){return this.effectsManager.setEffectType("Video",a)}async sendMessageDeviceVideoEffectsAsync(a,s){return this.effectsManager.processingVideoEffectMessage(s)}async setAudioEffects(a){return this.effectsManager.setEffectType("Audio",a)}async getAudioStream(a,s,c=!1){const u=this.configProvider.config.devices.enumerateBeforeGettingStream;return u&&(u!=="always"&&Mv.isPolling||await Mv.enumerateDevices()),this.getMediaStream({audio:!0,withTimeout:this.permissionManager.isPermissionKnown("microphone"),withEffect:!c&&this.effectsManager.isEffectEnabled("Audio"),audioProcessingFlags:this.getAudioProcessingFlags(),force:a,withOverridenStream:!c&&this.customDeviceMediaStreamMap.get("Audio")?.active&&this.customDeviceMediaStreamMap.get("Audio")},s)}async getVideoStream(a,s,c=!1,u){const m=this.configProvider.config.devices.enumerateBeforeGettingStream;return m&&(m!=="always"&&Mv.isPolling||await Mv.enumerateDevices()),this.getMediaStream({video:!0,withTimeout:this.permissionManager.isPermissionKnown("camera"),withEffect:!c&&this.configProvider.config.enableVideoEffects&&this.effectsManager.isEffectEnabled("Video"),force:a,withOverridenStream:!c&&this.customDeviceMediaStreamMap.get("Video")?.active&&this.customDeviceMediaStreamMap.get("Video"),videoMaxFS:u},s)}getDisplayStream(a,s=!1){const c=!(!this.configProvider.config.enableAudioSharing||!this.audioSharingRequested);return this.getMediaStream({audio:c,sharing:!0,withTimeout:!1,withEffect:!1,audioProcessingFlags:c?0:void 0,force:!1,withOverridenStream:!s&&this.customDeviceMediaStreamMap.get("ScreenShare")?.active&&this.customDeviceMediaStreamMap.get("ScreenShare")},a)}async enumerateDevicesAsync(){return await this.isDeviceListAvailable.promise,this.getDeviceDescriptions(this.deviceList)}async getDeviceNameAsync(a){return await this.isDeviceListAvailable.promise,this.deviceList.find(c=>c.guid===a)?.label??""}async getSpeakerDeviceDomIdAsync(a){return await this.isDeviceListAvailable.promise,this.deviceList.find(c=>c.guid===a)?.deviceId??""}selectDevices(a){return this.pendingDevices?(this.logger.safe.info(`Overriding device selection until enumeration is complete with ${JSON.stringify(_7e(this.pendingDevices))}`),void(this.pendingDevices=a)):this.isDeviceListAvailable.isPending?(this.logger.safe.info("Postponing device selection until enumeration is complete"),this.pendingDevices=a,void this.isDeviceListAvailable.promise.then(()=>{this.logger.safe.info("Performing postponed device selection");const s=this.pendingDevices;this.pendingDevices=null,this.selectDevices(s)})):void this.deviceSelection.selectDevices(a)}getSelectedDevices(){return this.toSelectedDevices(this.deviceSelection.selectedDevices)}setAudioProcessingFlags(a){a!==this.audioProcessingFlags&&(this.logger.debug(`Setting audio processing flags: ${this.audioProcessingFlags} -> ${a}`),this.audioProcessingFlags=a,this.event("onStreamUpdateRequested").raise("Audio"))}getOutputDeviceId(){return this.selectedDevices.speaker?.deviceId}getDeviceDescriptions(a){return(a||this.deviceList).map(s=>s.toDeviceDesc())}getDevicesCount(){return this.deviceList.reduce((a,s)=>(a[s.type]++,a),{camera:0,speaker:0,microphone:0,compositeAudio:0,virtualDevice:0,audioIngestDevice:0})}async getKnownPermissionStates(){return await this.permissionManager.initialize(),this.permissionManager.knownPermissionStates}getLocalVideoRenderers(){return this.activeRenderers}dispose(){this.deviceManagerSubscriptions?.forEach(a=>a.dispose()),this.deviceManagerSubscriptions=null,this.virtualDeviceSubs?.forEach(a=>a.forEach(s=>s.dispose())),this.virtualDeviceSubs?.clear(),this.virtualDeviceSubs=null,this.virtualDeviceRecord?.forEach(a=>a.dispose()),this.virtualDeviceRecord=null,this.unsubscribeFromStreamManagerEvents(),this.deviceEnumerator.dispose(),this.mediaStreamManager.dispose(),this.activeVideoEffectSub?.dispose(),this.activeVideoStreamForEffect?.dispose(),this.disposeRawStreamAccess(),this.disposeClientAudioRenderer(),this.effectsManager.dispose(),super.dispose()}async registerVirtualDevice(a,s){const c=a.length?a.map(({id:_},k)=>{const N=this.createChildDeviceManager(this.logger.createChild(`VirtualDevice-${k}`));return N.selectDevices({camera:_}),N}):[this.createChildDeviceManager(this.logger.createChild("VirtualDevice"))],u=new DSi(c,s),m=u.id,b=[u.on("onVideoEffectApplied",(..._)=>this.event("onVideoEffectApplied").raise(..._)),u.on("onVideoEffectsEvent",(..._)=>this.event("onVideoEffectsEvent").raise(..._)),u.on("onDeviceTelemetryEvent",(..._)=>this.event("onDeviceTelemetryEvent").raise(..._)),u.on("onVideoEffectsTelemetryEvent",(..._)=>this.event("onVideoEffectsTelemetryEvent").raise(..._)),u.on("onDevicesPermissionChanged",(..._)=>this.event("onDevicesPermissionChanged").raise(..._)),u.on("onStreamUpdateRequested",(..._)=>this.event("onStreamUpdateRequested").raise(..._))];return this.virtualDeviceSubs.set(m,b),this.virtualDeviceRecord.set(m,u),Mv.list.updateVirtualDeviceList(this.getRegisteredDevices()),this.raiseTelemetryEvent("register_virtual_device",{deviceCount:c.length,id:m}),this.event("onVirtualDevicesChanged").raise(),m}async unregisterVirtualDevice(a){this.virtualDeviceRecord.has(a)?(this.virtualDeviceSubs.get(a).forEach(s=>s.dispose()),this.virtualDeviceSubs.delete(a),this.virtualDeviceRecord.get(a).dispose(),this.virtualDeviceRecord.delete(a),Mv.list.updateVirtualDeviceList(this.getRegisteredDevices()),this.event("onVirtualDevicesChanged").raise(),this.raiseTelemetryEvent("unregister_virtual_device",{id:a})):this.logger.error(`No virtual device found with id ${a}`)}getRegisteredDevices(){return Array.from(this.virtualDeviceRecord.values())}async getNrgLevelPollerForDeviceTuner(){return await this.audioStreamAnalyzerWrapper.init(),this.audioStreamAnalyzerWrapper}getAudioProcessingFlags(){if(!this.effectsManager.shouldFallbackToNativeProcessing("Audio"))return this.audioProcessingFlags??this.configProvider.config.defaultAudioProcessingFlags;this.logger.safe.info("Applying netive audio processing flags")}disposeClientAudioRenderer(){this.clientAudioRenderers.size&&(this.clientAudioRenderers.forEach(a=>{a.dispose()}),this.clientAudioRenderers.clear(),this.raiseTelemetryEvent("custom_audio_renderer_disposed",this.getSelectedDevices()))}disposeRawStreamAccess(){this.rawDeviceStreamManager.disposeAll(),this.rawDeviceStreamManager=null}toSelectedDevices(a){return Object.entries(a).reduce((s,[c,u])=>(u&&(s[c]=u.guid),s),{})}getStreamConstraints(a){const s={deviceId:a?.deviceId||void 0};return this.configProvider.config.audioSampleRate&&(s.sampleRate=this.configProvider.config.audioSampleRate),s}hasDeviceType(a){return FS(this.deviceList).some(s=>s.type===a)}getConstraints(a){if(!a.audio&&!a.video&&!a.sharing)throw new Error("requesting nothing");if(this.logger.safe.info(`retrieving media stream: ${JSON.stringify(a)}`),a.sharing){let N;const W=this.selectedDevices.audioIngestDevice;return N=W&&a.deviceId?{deviceId:W.deviceId}:a.audio&&!a.deviceId?{deviceId:ke.SYSTEM_AUDIO_SOURCE_ID}:void 0,{audio:N,sharing:{deviceId:a.deviceId||ke.DISPLAY_SOURCE_ID},withTimeout:a.withTimeout,withEffect:!1,audioProcessingFlags:a.audioProcessingFlags,force:!1,withOverridenStream:a.withOverridenStream}}const s=this.selectedDevices.microphone,c=this.selectedDevices.camera,u=a.audio&&s,m=a.video&&c;if(!u&&!m)throw{type:ke.MEDIA_ERROR.noDeviceSelected,detail:`audio requested ${a.audio}, video requested: ${a.video} Devices: ${JSON.stringify(this.deviceList.map(N=>JSON.stringify(FV(N,this.configProvider.config.devices.piiSafeWords))))}`};const b=this.getStreamConstraints(s),_=this.getStreamConstraints(c);let k=a.audioProcessingFlags;return k!==void 0&&a.audio&&!a.video&&s?.capabilities&&(s.capabilities.echoCancellation&&!s.capabilities.echoCancellation.includes(!!(2&k))&&(k^=2),s.capabilities.autoGainControl&&!s.capabilities.autoGainControl.includes(!!(1&k))&&(k^=1),s.capabilities.noiseSuppression&&!s.capabilities.noiseSuppression.includes(!!(4&k))&&(k^=4)),k!==a.audioProcessingFlags&&this.logger.safe.warn(`Unable to fulfill processing flags ${a.audioProcessingFlags}, using ${k} instead`),{audio:a.audio?b:void 0,video:a.video?_:void 0,withTimeout:a.withTimeout,withEffect:a.withEffect,audioProcessingFlags:k,force:a.force,withOverridenStream:a.withOverridenStream,videoMaxFS:a.videoMaxFS}}getMediaStream(a,s){const c=this.getConstraints(a),u=this.mediaStreamManager.getMediaStream(c,s);return this.subscribeOnStreamEvents(u),u.start().then(()=>{const m=u.hasAudio(),b=u.hasVideo();m&&(this.signalDeviceGood("Audio",u.rawTrack.muted),this.audioStreamAnalyzerWrapper.setStream(u,s)),b&&this.signalDeviceGood(u.mediaType,u.rawTrack.muted),this.permissionManager.update(a,a)}).catch(m=>this.handleUserMediaError(a,m)),u}signalDeviceGood(a,s){this.ufdManager.signalDeviceEvent(0,"Good",a,this.id),this.ufdManager.signalDeviceEvent(2,"Good",a,this.id),this.ufdManager.signalDeviceEvent(4,"Good",a,this.id),s||a!=="Audio"&&!this.configProvider.config.raiseVideoMuteUfd||this.ufdManager.signalDeviceEvent(3,"Good",a,this.id)}handleUserMediaError(a,s){const c=this.getMediaType(a),u=a.audio&&a.video,m=(_,k)=>{!u&&this.ufdManager.signalDeviceEvent(_,k,c,this.id)},b=_=>{!u&&c==="Audio"&&this.diagnostics.registerAudioRenderError(_)};switch(s.type){case ke.MEDIA_ERROR.permissionDeniedError:c!=="ScreenShare"&&(m(4,"Bad"),b(0x800000000000),this.configProvider.config.permissions.persistOnDeniedError&&this.refreshPermissions(a));break;case ke.MEDIA_ERROR.permissionDeniedBySystemError:m(4,"Bad"),b(0x800000000000);break;case ke.MEDIA_ERROR.sourceUnavailableError:m(0,"Bad"),b(512);break;case ke.MEDIA_ERROR.mediaStreamRequestTimedOut:m(2,"Bad"),b(35184372088832);break;default:this.logger.safe.error(`getMediaStream() error: ${nn(s)}`),m(0,"Bad"),b(4194304)}}refreshPermissions(a){const s=a.audio&&!a.video,c=!a.audio&&a.video;s?this.permissionManager.update({audio:!0},{audio:!1}):c&&this.permissionManager.update({video:!0},{video:!1})}getMediaType(a){if(a.sharing)return"ScreenShare";if(a.video)return"Video";if(a.audio)return"Audio";throw new Error(`mediaType is not defined for this constraint ${JSON.stringify(a)}`)}subscribeOnStreamEvents(a){const s=[];s.push(a.on("onStreamClientStarted",(c,u)=>this.onStreamStarted(c,u))),s.push(a.on("onStreamClientDisposing",c=>this.onStreamDisposing(c))),s.push(a.on("onStreamClientEnded",(c,u)=>this.onStreamEnded(c,u))),s.push(a.on("onStreamClientMuted",(c,u)=>this.onStreamMuted(c,u))),s.push(a.on("onStreamClientError",(c,u)=>this.onStreamError(c,u))),this.configProvider.config.useRawMediaApiForVideoEffects&&s.push(a.on("onStreamClientDisposed",c=>this.removeVideoEffectStream(c))),this.streamSubscriptions.set(a,s)}async removeVideoEffectStream(a){if(a.getCurrentConstraints().withEffect){this.logger.safe.info(`this.activeVideoEffectSub: ${this.activeVideoEffectSub} to be disposed`),this.activeVideoEffectSub?.dispose();const s=await this.activeVideoStreamForEffect?.getMediaStream();this.effectsManager.stopEffect("Video",s)}}unsubscribeFromStreamEvents(a){this.streamSubscriptions.has(a)&&(this.streamSubscriptions.get(a).forEach(s=>s.dispose()),this.streamSubscriptions.delete(a))}subscribeOnRendererEvents(a){const s=[];s.push(a.on("onRendererDisposed",c=>this.onRendererDisposed(c))),s.push(a.on("onRendererStarted",c=>this.onRendererStarted(c))),this.rendererSubscriptions.set(a,s)}unsubscribeFromRendererEvents(a){this.rendererSubscriptions.has(a)&&(this.rendererSubscriptions.get(a).forEach(s=>s.dispose()),this.rendererSubscriptions.delete(a))}subscribeOnStreamManagerEvents(){this.streamManagerSubscriptions=[],this.streamManagerSubscriptions.push(this.mediaStreamManager.on("onAllStreamsRemoved",()=>this.onAllStreamsRemoved())),this.streamManagerSubscriptions.push(this.mediaStreamManager.on("onStreamAcquired",a=>this.onStreamAcquired(a))),this.streamManagerSubscriptions.push(this.mediaStreamManager.on("onStreamCreated",(a,s)=>this.onStreamCreated(a,s))),this.streamManagerSubscriptions.push(this.mediaStreamManager.on("onStreamDisposing",(a,s)=>this.onMasterStreamDisposing(a,s)))}subscribeOnDeviceEnumeratorEvents(){this.deviceEnumerator.on("onDeviceEnumerationfailed",a=>this.raiseTelemetryEvent("enumeration_failed",{error:a}))}unsubscribeFromStreamManagerEvents(){this.streamManagerSubscriptions.forEach(a=>a.dispose())}async updateRenderersAsync(){try{await Promise.all(this.activeRenderers.map(a=>a.updateStreamAsync())),this.logger.safe.info("Renderers updates finished")}catch(a){this.logger.safe.error(`Error updating renderers: ${nn(a)}`)}}onSelectedDevicesChanged(a,s){const c=this.selectedDevices;if(this.selectedDevices=a,this.diagnostics.setSelectedDevices(a,s),!("camera"in c^"camera"in this.selectedDevices||"microphone"in c^"microphone"in this.selectedDevices)){const m=this.toSelectedDevices(this.selectedDevices),b=this.toSelectedDevices(c);this.event("onSelectedDevicesChanged").raise(m,b),m.microphone!==b.microphone&&(this.rawDeviceStreamManager.notifyChange("Audio"),this.audioStreamAnalyzerWrapper.updateStreamAfterDeviceChange()),m.camera!==b.camera&&this.rawDeviceStreamManager.notifyChange("Video"),this.clientAudioRenderers.forEach(_=>{_.setOutputDevice(this.getOutputDeviceId())})}const u=this.configProvider.config.devices.piiSafeWords;this.raiseTelemetryEvent("selected_devices_changed",{microphone:this.selectedDevices.microphone&&Q_(this.selectedDevices.microphone.label,u),camera:this.selectedDevices.camera&&Q_(this.selectedDevices.camera.label,u),speaker:this.selectedDevices.speaker&&Q_(this.selectedDevices.speaker.label,u),fromInterface:s}),this.updateRenderersAsync()}onDevicesChanged(a,s){this.event("onDevicesChanged").raise(a,s),this.mediaStreamManager.onDevicesChanged(a),this.diagnostics.setDeviceList(a,s,this.getDeviceListDebugInfo());const c=this.getDevicesCount(),u=c.microphone>0,m=c.speaker>0;this.ufdManager.signalEvent("ZeroCaptureDevicesEnumerated",u?"Good":"Bad"),u||this.diagnostics.registerAudioCaptureError(1),this.isAudioOutputSelectionSupported&&(this.ufdManager.signalEvent("ZeroRenderDevicesEnumerated",m?"Good":"Bad"),m||this.diagnostics.registerAudioRenderError(1));const b=new Map;let _=1;this.raiseTelemetryEvent("devices_changed",{devices:a.map(k=>{const N=b.get(k.groupId)||_++;return b.set(k.groupId,N),{label:Q_(k.label,this.configProvider.config.devices.piiSafeWords),isSystemDefault:k.isSystemDefault,kind:k.kind,type:k.type,capabilities:k.capabilities,groupId:`${N}`}}),debug:this.getDeviceListDebugInfo()})}getDeviceListDebugInfo(){return Mv.list.debugInfo}raiseTelemetryEvent(a,s){this.logger.safe.info(`Device event: ${a}: ${JSON.stringify(this.scrubPayload(a,s))}`);const c={eventType:a,timestamp:Date.now(),payload:s};this.diagnostics.registerDeviceTelemetryEvent(fs(c)),this.diagnostics.logAudioDeviceError(a,s),this.event("onDeviceTelemetryEvent").raise(c)}scrubPayload(a,s){return a==="devices_changed"?{devices:FS(s.devices).map(c=>FV(c,this.configProvider.config.devices.piiSafeWords)),debug:s.debug}:s}async onStreamStarted(a,s){if(this.permissionManager.browserPermittedModalities.audio.some(c=>c===ke.MEDIA_STATE.send)||this.permissionManager.browserPermittedModalities.video.some(c=>c===ke.MEDIA_STATE.send))try{await Mv.enumerateDevices()}catch(c){this.logger.safe.warn(`onStreamStarted device enumeration failed: ${nn(c)}`)}if(a.rawTrack){switch(a.mediaType){case"Audio":this.deviceEnumerator.startDevicePolling(),this.updateActiveMicrophone(a,s);break;case"Video":this.deviceEnumerator.startDevicePolling()}this.configProvider.config.useRawMediaApiForVideoEffects&&a.getCurrentConstraints().withEffect&&(this.activeVideoEffectSub=this.effectsManager.on("onVideoStreamQualityChanged",(c,u,m)=>a.onVideoStreamQualityChanged(c,u,m)))}else this.logger.safe.warn(`stream:${a.id} is already disposed`)}updateActiveMicrophone(a,s){if(a.deviceId){const c=this.deviceList.find(u=>u.deviceId===a.deviceId);if(!c&&a.deviceId!=="default")return void this.logger.safe.error("Active device not found",`Device id from track: '${kn(a.deviceId)}', known devices: [${this.deviceList.map(u=>JSON.stringify(FV(u,this.configProvider.config.devices.piiSafeWords)))}]}`,JSON.stringify(uC(s)));c&&a.deviceId!=="default"&&s.audio&&s.audio.deviceId===ke.MEDIA_DEVICE.defaultId&&Mv.list.updateActiveMicrophone(c)}}onStreamDisposing(a){this.unsubscribeFromStreamEvents(a)}onStreamMuted(a,s){(a.mediaType==="Audio"||this.configProvider.config.raiseVideoMuteUfd)&&this.ufdManager.signalDeviceEvent(3,s?"Bad":"Good",a.mediaType,this.id),a.mediaType==="Audio"&&this.event("onAudioStreamMuted").raise(s),this.raiseTelemetryEvent(s?"stream_muted":"stream_unmuted",a.mediaType)}onStreamEnded(a,s){s.error?(this.raiseTelemetryEvent("stream_ended_error",{mediaType:a.mediaType,error:{type:s.error.name,detail:s.error.message}}),s.error.name==="SourceUnavailableError"&&this.ufdManager.signalDeviceEvent(0,"Bad","Audio",this.id)):(a.mediaType!=="Audio"&&a.mediaType!=="Video"||this.ufdManager.signalDeviceEvent(0,"Bad",a.mediaType,this.id),this.raiseTelemetryEvent("stream_ended",a.mediaType))}onStreamError(a,s){this.raiseTelemetryEvent("stream_error",{mediaType:a.mediaType,error:s})}onAllStreamsRemoved(){this.deviceEnumerator.stopDevicePolling(),this.audioSharingRequested=!1}onStreamAcquired({id:a,mediaType:s,timestamp:c,resolution:u,withAudio:m,source:b,sampleRate:_}){c!==0&&this.raiseTelemetryEvent("stream_acquired",{id:a,mediaType:s,timestamp:c,resolution:u,withAudio:m,source:b,sampleRate:_})}onStreamCreated(a,s){this.raiseTelemetryEvent("stream_created",{id:a,mediaType:s})}onMasterStreamDisposing(a,s){this.raiseTelemetryEvent("stream_disposed",{id:a,mediaType:s})}onRendererDisposed(a){VR(this.activeRenderers,s=>s===a),this.domOverrides.onMediaElementRemoved?.(a.getVideoElement()),this.unsubscribeFromRendererEvents(a)}onRendererStarted(a){this.activeRenderers.push(a),this.event("onLocalRendererStarted").raise(a)}onVideoEffectsQualityEventHandler(a){const s=this.deviceSelection.selectedDevices.camera;if(s?.deviceId){const c={type:"onVideoEffectQualityChanged",payload:{message:a.message,effectType:a.effectType}};this.event("onVideoEffectsEvent").raise(s.deviceId,c)}}getDeviceType(a){if(a==="Video")return"camera";if(a==="Audio")return"microphone";throw new Error(`DeviceType for mediaType: ${a} doesn't exist`)}getStreamHandlerByType(a){return a==="Video"?()=>this.getVideoStream(!1,"rawStream",!0):a==="Audio"?()=>this.getAudioStream(!1,"rawStream",!0):a==="ScreenShare"?()=>Promise.resolve(this.getDisplayStream("rawStream",!0)):null}},yTe=dn;function FSi(){return ul.isEngine("ChromiumAVD")?new USi:ul.isEngine("Safari")?new zSi:ul.isEngine("Firefox")?new VSi:Kte()?new $Si:ul.isEngine("Chromium")?new HSi:new Vne}var Vne=class{getInitialSettings(){return{resizeModeForSharing:"none",enableAudioProcessingFallback:!0,allowVirtualDeviceInCall:!1,activeSpeaker:{timeToPromote:1e4},dtmf:{toneDuration:200,toneGap:100},mediaStreamHoldInterval:5e3,webrtcContributingSourcesPollingStartDelay:1e3,webrtcContributingSourcesPollingInterval:1e3,webrtcContributingSourcesPollingEmptySources:0,webrtcIceGatheringTimeoutMs:2e4,webrtcAllowedMediaContentType:ke.ALLOWED_CONTENT_TYPES.SDP_NGC,webrtcMediaContentType:ke.CONTENT_TYPE.SDP,useNGC1webrtcContentType:!1,webrtcScreensharingCapabilityMaxFS:8160,webrtcScreensharingCapabilityMaxFPS:1500,webrtcStatHwSilentDetectionDuration:5,webrtcStatHwSilentDetectionLevel:14,webrtcStatPollInterval:1e3,webrtcStatStoredRecordsNumber:60,webrtcStatNetworkDetectionDuration:10,webrtcHealedRatioWindowSize:5,webrtcHealedRatioExtendedWindowSize:20,webrtcStatNetworkDetectionHysteresis:.01,webrtcStatNetworkDetectionBadLevel:.17,webrtcStatNetworkDetectionGoodLevel:.15,webrtcMinAudioSamplesRecvForNetworkRecvQuality:48e4,webrtcVideoCapabilityCheckIntervalMin:2e4,webrtcVideoCapabilityCheckIntervalMinMultiparty:5e3,webrtcVideoCapabilityCheckIntervalMax:3e4,webrtcVideoCapabilityCheckIntervalMaxMultiparty:5500,webrtcScreensharingCapabilityCheckIntervalMin:0,webrtcScreensharingCapabilityCheckIntervalMax:0,webrtcVideoCapabilityMaxFS:3600,webrtcVideoCapabilityMaxFPS:3e3,webrtcMultiPartyRecvVideoMaxFS:3600,webrtcRecvVideoMaxFS:8160,webrtcCameraOpenFs:3600,minCameraOpenFps:15,maxCameraOpenFps:30,maxCameraFsViaCallConstraints:-1,webrtcMultipartyMaxScalingFs:3600,webrtcMaxScalingFs:8160,webrtcVideoScaling:!1,webrtcVideoScalingMultiparty:!0,enableOptimalVideoCount:!1,ovcBandwidthPerVideoReceiver:2e5,ovcSlidingWindowPercentile:.3,ovcSlidingWindowSamples:20,nonEstimatedDefaultVideoReceiversCount:4,ovcMaxCount:4,ovcMaxCountXL:4,ovcMaxCountMultiStream:16,ovcXLParticipantsCount:100,ovcIgnoreFirstSamples:10,ovcAvailableConcurrencyForBiggerGrid:4,ovcMemoryForBiggerGrid:2,ovcRampUpCooldown:15e3,ovcRampDownCooldown:1e4,webrtcStatNetworkDetectionEnabled:!0,webrtcUseNewStatsApi:!0,useAudioAnalyzer:!0,webrtcVideoSubscriptionDisposeTimeout:2e3,webrtcCompareContentTypeInOffer:!0,iceServerTransport:"udp,tcp,tls",iceHostCandidateOnly:!0,iceUdpAddressType:"ip",iceTcpAddressType:"ip",renegotiationAttempts:3,reconnectTimeLimit:9e4,initialReconnectTimeLimit:0,maxReconnectDelayTime:5,waitForRelayOnReconnect:!0,relayWaitSaneTimeoutMs:25e3,reconnectOnDisconnect:!1,reconnectWithNoRelays:!1,reconnectWithProbes:!1,reconnectWaitTimeAfterProbe:1e3,reconnectOnPcClose:!0,reconnectWakeupTimeLimit:18e4,webrtcSpeakingWhileMutedDetectionWindow:3,webrtcSpeakingWhileMutedBadDuration:3,webrtcSpeakingWhileMutedDetectionLevel:4e3,webrtcNegotiateDisabledDataModality:!1,recoverableMediaErrors:[ke.MEDIA_ERROR.iceConnectionError,ke.MEDIA_ERROR.noNetworkError,ke.MEDIA_ERROR.srtpError,ke.MEDIA_ERROR.incompatibleOffer,ke.MEDIA_ERROR.internalError].join(","),forceReconnectErrors:[ke.MEDIA_ERROR.audioPlaybackError].join(","),sendCallStartupTelemetry:!0,webrtcMultiPartyRecvVideoSignaling:!0,webrtcVideoDelayThreshold:10,webrtcEndOfCallFreezeThreshold:3,webrtcSubscriptionEventLimit:300,webrtcHandleRollback:!0,webrtcHandleRemoteRollback:!0,losingConnectivityTimeoutMs:-1,iceCandidateFilterMDns:!0,webrtcInjectTransportCCAudio:!1,webrtcInjectTransportCCAudioMultiparty:!0,webrtcRejectedFeatures:"byPass",webrtcRequiredFeatures:"nonByPass",webrtcSimulcastSessionEnabled:!1,webrtcSimulcastStreamsCountForVideo:1,webrtcSimulcastStreamsCountForSharing:1,webrtcFmtParamListSupported:!0,webrtcNegotiatedSsrcRangeForVideo:0,webrtcNegotiatedSsrcRangeForSharing:0,webrtcNegotiatedSsrcRangeForVideoOneToOne:0,webrtcNegotiatedSsrcRangeForSharingOneToOne:0,webrtcAllowRestoreKeyframe:!1,webrtcEnabledCustomBwEstimationForVideo:!1,webrtcDisabledSenderBitrate:1e3,maxStoredPreferredResolutionCount:4,maxStoredQualityLimitationReasonEvents:30,maxStoredUFDCount:50,simulcastTelemetryLayoutsPerSession:5,simulcastTelemetryNumModalitySessions:3,simulcastTelemetryNumFMTP:10,maxSendVideoCapabilities:{enableForVideo:!1,enableForSharing:!1,useMaximumWidthHeight:!1,sendMaxMbps:!1,sendMaxFs:!1},maxReportedOvershootingEvents:20,broadcastMode:{townHallScenarioNames:["premiumtownhall","basetownhall"]},performanceFallbackMaxFsFor1080pSend:3600,sendVideoCapabilityManager:{priorityOrder:["Performance","BroadcastMode","HardwareEncoder","Software1080P"],allowOptIn:["HardwareEncoder"]},video1080p:{software:{}},permissions:{usePositiveInAdp:!1,useNegativeInAdp:!1,adpFallback:!0,adpFallbackAudio:!0,adpFallbackVideo:!0,adpRequestAVLast:!0,rememberNegative:!1,persistOnDeniedError:!0,disableOnPermissionDeniedOnly:!0,enumerateDevicesAfterChange:!0},devices:{blacklist:{microphone:"stereo mix \\(",camera:"(^ir camera|avstream media device)",speaker:"stereo mix \\("},overrideDefault:!1,compositeLabelMatchingThreshold:.5,piiSafeWords:["airpod","bluetooth","hands-free","stereo","wireless","citrix hdx","remote audio","vmware","built-in","integrated","internal","teams","high definition","facetime","macbook","smartaudio","front","rear","back","iphone","ipad","display","displayport","dp","hdmi","amd","nvidia","intel","analog","digital","dock","line( in| out)?","s/pdif","external","thunderbolt\\d*","usb","panoramic","desktop","capture","cable","cam","virtual","manycam","snap camera","obs","vb-audio","vaio","effect","sink","source","default","test"],pollingIntervalActive:3e3,enumerateDevicesTimeout:25e3,enumerateDevicesAfterADP:!1,setSinkImmediately:!0,enumerateBeforeGettingStream:"always"},useGoogPrefixAudioConstraints:!0,multiviewResolutionLimits:{1:720,2:720,3:540,4:360,more:360},maxSpotlightResolution:1080,excludeUnsizedRenderersFromMultiviewResolutionLimits:!1,multiviewResolutionLimitUpdateThrottleDelay:300,useMultiviewLimitsOnInitialRequest:!0,useApplyChannelParametersForSourceRequests:!0,maxVideoFreezeTimestampsInBucket:5,webrtcSendBandwidthAlwaysReportAfterDrop:!1,webrtcSendBandwidthIgnoredUpdateLimit:6,webrtcSendBandwidthThreshold:.1,checkSupportForWebrtc_1_0:!1,webrtcLastAppliedVideoCapabilitiesCount:5,webrtcLastAppliedVideoCapabilitiesSequenceCount:5,gumRequestTimeout:2e4,overrideGumFromWebkit:!1,setMinFpsForWebkit:!1,videoCaptureFreezeTimeout:5e3,webrtcCloseAfterIceFailure:!0,audioBandwidthInKbps:90,maxBandwidthInKbps:7e3,maxBandwidthInKbpsFallback:7e3,videoBandwidthAllocation:.3,enableQosSupport:!1,forceUnbundledTransport:!1,allowedAudioCodecs:[],allowedVideoCodecs:[],allowedVideoCodecsMultiparty:[{clockRate:9e4,mimeType:"video/H264"},{clockRate:9e4,mimeType:"video/rtx"}],filterCodecsInSdp:!1,filterCodecsInSdpMultiparty:!0,filterCodecsInSdpV2:!1,reduceRtcpFbInSdp:[],reduceRtcpFbInSdpMultiparty:["goog-remb","transport-cc","ccm/fir","nack","nack/pli"],subscribeToSsrcForVideo:!1,audioRendererUsePauseOnDetach:!0,audioRendererRestartOnPause:!1,audioRendererRestartOnDeviceError:!0,disableAudioOutputSelection:!1,preferSdesSrtp:!1,preferSdesSrtpPstn:!1,useLocalStorageForOneDs:!0,oneDSDisabledPageUnloadEvents:[],oneDSLocalStorage:{sendStaleEvents:!1,accessThresholdInMs:6e5},oneDSNotificationManager:{blockNotificationsOnPageUnload:!1,blockEventsDiscardedNotifications:!1},useOneDsLogger:!1,addTelemetryReportingCallback:!0,eventsLimitInMem:200,eventLatency:Ebe.Normal,eventLatencyRealTime:Ebe.RealTime,enableCompoundKey:!1,telemetryTenants:{signaling:"53fdaa090eb946b5a1d6cbdeb4f2ef66-bcbf6380-2590-41cc-ae60-9e467cd51835-7413",gtcAudit:"53fdaa090eb946b5a1d6cbdeb4f2ef66-bcbf6380-2590-41cc-ae60-9e467cd51835-7413",media:"1cae5691997646c98b01d15beddae7a3-ce16e198-bc32-420f-ac64-42bb916111af-6865",realtimeMedia:"5aea257f81424f5d8574e57a50974ead-d3a768ce-590c-4595-ab85-3dd046114290-6701",tlePlayer:"2efdf03d07594586a5977c404e185186-71b046c4-f48f-4ba7-96d3-2a74b54e1d46-7326"},transmitProfileName:"REAL_TIME",transmitProfileTimings:[],waitReportStatsAtCallStop:!1,oneStreamPerDeviceType:!1,enableWebRtcInternalsLogs:!1,enableMultiViewStats:!0,webrtcBWJumpLowerLimit:1e5,webrtcBWJumpUpperLimit:3e5,uplinkBWStabilizationSlidingWindowSize:10,uplinkBWStabilizationMaxDeviation:.1,uplinkBWStabilizationMinBandwidth:1e5,downlinkBWStabilizationSlidingWindowSize:10,downlinkBWStabilizationMaxDeviation:.1,downlinkBWStabilizationMinBandwidth:1e5,maxKeyFrameTimestampsInBucket:5,enableAudioSharing:!1,audioSharingContextOptions:{sampleRate:48e3},enableStopSharingWithIncomingOffer:!0,enableDevtoolsAPI:!1,enableDataChannel:!1,enableDataChannelMultiparty:!0,enableDataChannelPstn:!1,alwaysNegotiateDataChannel:!0,webrtcDataChannel:{enableFragmentation:!1,fragmentationSize:0,enableSendScheduler:!1,rateLimiterCheckInterval:250,discardOnSendFailure:!1,bufferedAmountLowThreshold:65535,bufferedAmountHighThreshold:262144,maxBitrate:0,maxPacketRate:0,maxQueueSize:524288,dataIds:[]},acceptDisabledDataModality:!0,rejectUnbundledDataModality:!0,sctpPort:5e3,removeRtcpRsizeFromLocalSdp:!1,enableGiveControl:!1,maxStoredDataChannelValues:15,mediaControlPlaneConfig:{enableBweNotifications:!0,enableDominantSpeakerHistory:!0,enableSourceRequests:!0,enableSendBandwidthNotificationsEnabled:!1,sourceRequestsMessagesTimeout:1e4,storedSRRecordsCount:60,verboseTelemetry:!1,sendBeforeAck:!1,handshakeTimeout:1e4,setResendingMechanism:!1},localPreviewMirroringSupported:!1,enableVideoEffects:!0,useRawMediaApiForVideoEffects:!1,waitForVideoEffectStreamStart:!1,forceKeyFrameV2ScaleFactor:1.1,effectsTelemetryBufferSize:20,useDelayedScreenShareStream:!1,applyAudioEffectOnDemand:!1,wasmdns:{pTime:10,goodPerfThreshold:8,poorPerfThreshold:10,badPerfThreshold:12,perfWindowLength:10,enableNoiseSuppression:!1,noiseSuppressionMode:"Off",backgroundMode:!1},wasmvqe:{enableAec:!1,enableVqe:!1,asyncInitialization:!1,initializationTimeoutMs:1e4,backgroundMode:!1,performanceThresholdMs:8,performanceWindowDurationSecs:10,defaultVqeMode:Ao.VqeMode.Off,callType:Ao.CallType.Conference,audioUsageMode:Ao.AudioUsageMode.Default,performanceProfile:Ao.AecPerfProfile.Normal},webcv:{qualityConfig:{outputFps:{min:15,max:30},outputResolution:720,preserveResolution:!0,degradationLadder:[{resolution:{width:1920,height:1080},fps:{min:15,max:30}},{resolution:{width:1280,height:720},fps:{min:15,max:30}},{resolution:{width:960,height:540},fps:{min:15,max:30}},{resolution:{width:640,height:360},fps:{min:13,max:30}},{resolution:{width:416,height:234},fps:{min:10,max:20}},{resolution:{width:320,height:180},fps:{min:10,max:20}}],initialLadderResolution:720,improvementFpsThresholdPercent:20,statsIntervalSec:5,enableMaskPropagation:!1,maskPropagationFramesInterval:30},powerPreference:zg.PowerPreference.HighPerformance,useInsertableStreams:!1,webGLUnsupportedRenderers:["Google SwiftShader"],webGLRequiredExtensions:["EXT_color_buffer_float","WEBGL_debug_renderer_info","OES_texture_float_linear"],usePreheat:!1,useSharedArrayBuffer:!0,useWasmEffects:!1,processorType:zg.ProcessorType.Webgl2},insertFakeCandidateIfNeeded:!0,useSdpCapabilitiesLegacySession:!0,useSdpCapabilities:!0,enableH264SpsPpsIdrKeyframe:!0,disableMsSdp:!1,disableSdes:!1,disableIceReinvite:!1,iceDisconnectedTimeoutMs:3e4,enableLocalVideoConstraints:!0,webrtcAudioChannelSignalingFeedback:"app recv:dsh",webrtcVideoChannelSignalingFeedback:"app send:src recv:src,vc",webrtcResolutionManagerCooldownTimeout:15e3,webrtcResolutionManagerRetryDelay:5e3,webrtcNativeCpuOveruseDisabled:!1,webrtcDisplayStreamContentHint:"text",h264SendProfileOverride:"42C02A",learnCodecSendCapabilitiesFromSenderApi:!1,addFmtpToInitialSubscription:!0,h264SubscribeProfile:"64001f",notRenderingTimeInterval:{video:3,sharing:10},notRenderingLowBitrateThreshold:6,notRenderingLowFramerateThreshold:3,isBytesRecvUsedInIsRenderingCalculation:!0,useConnectionState:!0,transportStateFailedFix:!1,useDtlsTrasportConnectionCheck:!1,enableNetworkRecvQualityUFD:!0,enableNetworkSendQualityUFD:!0,enableSignalingAudioPermissionDeniedUFD:!1,webrtcJitterLowThreshold:.2,webrtcJitterHighThreshold:.35,webrtcJitterSticknessTime:5e3,webrtcLossRateLowThreshold:.2,webrtcLossRateHighThreshold:.3,webrtcLossRateSticknessTime:5e3,webrtcMinPacketsSentForNetworkSendQuality:200,webrtcLossRateWindowSize:3,webrtcJitterWindowSize:3,networkSendQualityDiagnostics:!1,networkRecvQualityDiagnostics:!1,webrtcJitterExtendedWindowSize:6,webrtcLossRateExtendedWindowSize:6,freezeMinDuration:128,freezeIntervalFrequency:1e3,disableNormalizationToCalculatePacketLossRate:!1,healedRatioPrecision:8,jitterPrecision:3,requestNewStreamOnUnmute:!0,raiseVideoMuteUfd:!1,useMediaQualityController:!1,useMediaQualityControllerForceKeyFrame:!1,bandwidthAllocatorV2:{sharingLadder:[8e4,5e5,8e5,1e6,12e5,25e5,3e6],videoLadders:[{maxFS:240,ladder:[4e4,7e4,1e5,15e4,25e4,3e5,35e4]}],defaultVideoMaxFS:240},layoutControlTimeout:1e4,extmapAllowMixed:!1,enableVla:!1,allowRemoteVla:!1,enableNonAdvVla:!1,specCompliantSimulcast:{},specCompliantSimulcastMultiparty:{video:{enableLocally:!1,allowEnableRemotely:!1,layerScaleFactors:[1],minFsForSimulcast:[920],useApplyConstraints:!1},sharing:{enableLocally:!1,allowEnableRemotely:!1,layerScaleFactors:[1]},allowOverride:!1,constraintsDisableVla:!0,collectResolutionInfo:!0,maxBrControlEnabled:!1,allowedBweOvershootRatio:1,allowResLimit:!1,disableTilde:!1},enforceOpusFmtpMultiparty:{usedtx:1},videoIsRenderingCheck:!1,fixSdpForPartialIceRestart:!1,mapSsrcToTrackForStats:!1,enableVideoOrientationExtension:!1,speakerGainLevel:0,ignoreClosedDtlsTransportState:!1,disconnectOnPageHide:!1,renderThroughCanvas:!1,isRenderingBasedOnRawStatistics:!1,enableDevicePixelRatio:!0,useSetParametersToApplyCapabilities:!1,useSetParametersToApplySSCapabilities:!1,enablePlatformCallConstraints:!1,enablePlatformCallConstraintsPerCall:!1,enableDynamicCallConstraints:!0,numCallConstraintsEvents:6,setParametersMaxBitrateUndefined:!1,onAddTrackRemoveOtherTracks:!0,avoidFakeStreamsDuringEscalation:!0,navConnectionPollingInterval:1e3,navConnectionNumSamplesToCollect:60,acceptProvisionalAnswer:!1,acceptProvisionalAnswerPstn:!0,acceptProvisionalAnswerFromPstnOnly:!0,createProvisionalAnswer:{enabled:!1,enabledPstn:!1,forceRecvonly:!1,streamsBeforeSetFullRD:!1,setProperAnswerType:!1,connectTransport:!0,audioState:"active",dtlsRole:"",dtlsRolePstn:""},webrtcPranswerCheckAudioEnergy:!1,webrtcPranswerMediaPollingTimeout:500,webrtcPranswerWaitFinalAnswer:!1,webrtcPranswerAudioThreshold:0,webrtcPranswerWaitIntervalBeforePolling:500,webrtcPranswerStopPollingAfterError:!1,disableIncomingDtlsRoleOverride:!1,disableOutgoingDtlsRoleOverride:!1,statsAllowAnyVideoSendTrack:!1,pictureInPicture:{enablePictureInPicture:!1,aspectRatioHorizontal:16,aspectRatioVertical:9,maxActiveStreams:1,minStreamGridCellWidth:160,dominantStreamChangeDebounce:3e3,statisticsBufferSize:20,multiStreamWorkerURL:""},showStatsInCall:!1,useSetStreamsForSender:!0,addPrefixForMsidInSdp:!1,enableMuteSpeakerUnmuteSpeakerWorkaround:!1,alwaysRaiseBadDeviceEvents:!1,removeRecvStreamOnEnded:!0,requiredVideoCodecs:["h264"],primaryVideoCodecs:["h264","vp8","vp9"],removeUnsupportedVideoModality:!1,enableActiveSpeakerBasedDSH:!0,enableInitialSignalingDSHSubscription:!0,enableSignalingDSHFallback:!1,emptyInitialDSH:!0,bwPercentiles:[5,50,95],enableTimerTracker:!0,diagnostics:{sideBySide:!0,useForTelemetry:!1,collectWhileNotConnected:!1,traceLogging:!1,enabledStatsProcessors:{dataChannel:!0,transport:!0,audio:!0,video:!0,sharing:!0,bandwidth:!0,recvVideoStreamsCounter:!0,aggregated:!0,multiview:!0,simulcast:!0,networkInfo:!0,macroblockRate:!0},collectionLimits:{numOfHistogramSamples:100,numDeviceEvents:200,numVideoEffectsEvents:100,numAudioEffectsEvents:100,numOvershootEvents:100,numIsRenderingEvents:100,numStatsReports:600,numStatsErrors:100,numSubscriptionEvents:100,numPerformanceEvents:50,numUFDs:100,numNativeSessions:3,numSessions:3,numNetworkEvents:50,numReconnects:50,numReconnectRecords:20,numCapabilitiesRequested:60,numCapabilitiesApplied:60,numAudioCaptureErrors:100,numAudioRenderErrors:100,numResolutionSwitches:10,numSamplesForE2E:4,numWorkerEvents:50,numTransportStateEvents:100,numElevation:5,numVideoStatsAfterSubscription:30,numVideoSubscriptionStats:30,numPowerEfficientEncoderEvents:60},telemetryLimits:{numOfHistogramSamples:50,numDeviceEvents:40,numVideoEffectsEvents:20,numAudioEffectsEvents:30,numWorkerEvents:25,numOvershootEvents:20,numIsRenderingEvents:4,numPreferredResolutions:3,numSubscriptionEvents:100,numPerformanceEvents:30,numUFDs:50,numAggregatedSamples:60,numStatsErrors:20,numCapabilitiesRequested:5,numCapabilitiesApplied:3,numNetworkEvents:20,numReconnects:10,numRendererStateChangedEvents:10,numAuthTokenErrors:20,numPowerEfficientEncoderEvents:20},teamsRealtimeTelemetry:{pollingInterval:15},performanceMonitoring:{usePerfConstrainedOvc:!1,useCpuSample:!1,useComputePressure:!1,fluctuationSamplesNum:5,enableRemoteVideoCalculator:!1,enableLowerResolution:!1,monitoringStrategy:"decodeTime",decodeThresholds:{1080:{fps:30,maxDecodeTime:20},720:{fps:30,maxDecodeTime:15},540:{fps:30,maxDecodeTime:11},360:{fps:30,maxDecodeTime:9},234:{fps:15,maxDecodeTime:10},180:{fps:15,maxDecodeTime:10}},defaultThrehold:{fps:30,maxDecodeTime:60},fpsDiffThresholds:{1080:{fps:30,fpsDiff:4},720:{fps:30,fpsDiff:4},540:{fps:30,fpsDiff:4},360:{fps:30,fpsDiff:4},234:{fps:15,fpsDiff:2},180:{fps:15,fpsDiff:2}},defaultFpsDiffThreshold:{fps:30,fpsDiff:10},volatilityThresholds:{1080:10,720:10,540:10,360:10,234:5,180:5},defaultVolatilityThreshold:10,remoteVideoTrackInterval:10,telemetryResolutionRequestSpanMs:5e3,cpuMetricCollector:3},features:{takeFreezeTelemetryFromGathererV2:!0,useLastSampleDeltaPerSecondConverter:!1,useNewerStatisticsMetrics:!1,useNewNetworkUFD:!0,useNewSendBandwidthCalculation:!0,useNewStatsForLocalVideoStreamWatcher:!0,useFallbackToNewExtensions:!0,logContributingSourcesError:!0,useTwoSampleVBSSFreezeDetection:!0,useNewSimulcastTelemetryExtension:!1}},requireUserActionForAudioSharing:!1,postponeAudioMixerForAudioSharing:!1,reassignMediaStreamAudioTrackAfterCreation:!1,deactiveAudioSender:!1,webrtcForceSdesForS1:!1,webrctRemoveVideoModalitiesForPstn:!1,removeSendersOnConfigureModalities:!0,negotiationParallelStreamAcquisitionCreateOffer:!1,negotiationParallelStreamAcquisitionCreateAnswer:!1,streamAvailabilityConsiderModalities:!0,setBWSeed:!0,bwSeedOptions:{mids:["*"],aggregation:"last",aggregateLastN:null,constValue:6e5,minValue:-1,cappingValue:15e5,useLocalStorage:!0,localStorageKey:"bwSeed"},stopCallOnAcceptFailure:!0,allowMediaBypass:!0,enablePermissionsWorkaround:!1,disposeSendersSync:!1,disposeStreamsSync:!1,maxVideoStatsAfterSubscription:30,ecsConfigTimeout:2e4,contributingSourcesLogInterval:1e4,useNewTokenApi:!1,audioRendererFailedReconnectTimes:0,audioRendererFailedRetryCodes:[3],effectsApplyConstraintsRetryMs:1e3,isSpotlightEnabled:!0,addAudioStreamBeforeConnection:!1,redReceiveEnabled:!1,mediaEventDictionary:ke.MEDIA_EVENT_FIELDS,smallCallTelemetry:{enable:!1,mediaUFDEventDictionary:{}},applySenderParamsBeforeStart:!0,applyMaxCapabilitiesToSenderParamsDirectly:!1,reuseLastSetParameters:!0,hevcCodecs:["hev1.1.6.L120.90","hev1.1.4.L93.B0","hev1.1.6.L93.B0"],useInactiveAudioTrack:!1,enableRollbackHandler:!1,callElevationDelayReconnect:!1,callElevationDelayReconnectPSTN:!1,enableCachingFMTP:!0,enableCachingFMTPAwait:!1,enableCachingFMTPDelay:0,setDisconnectAfterCleanUp:!1,sendResolutionTableOverride:ke.RES_TABLE.SEND,recvResolutionTableOverride:ke.RES_TABLE.RECV,maxSendVideoCapabilitiesMultiparty:{enableForVideo:!0,enableForSharing:!1,useMaximumWidthHeight:!0,sendMaxMbps:!1,sendMaxFs:!1},participantStreamInitialSubscriptions:!0,holdRetryActivationDelay:-1,holdSkipActivation:!0,recoverOnStreamUnmute:!1,isAv1Allowed:!1,audioSharingMemoryLeakFix:!0,h264SdpProfileMultiparty:"64001f",rejectIncompatibleOriginator:!0,coeffOfValidTimeDelayBetweenFramesArrival:2,invalidFPSAboveMax:40,useWakeLockApi:!0,noRequiredCodecsWorkaround:!1,vdiDisconnectedTracking:{enabled:!0,clientPhrases:["failure"]},multiStreamSupported:!1,nonMultiStreamChannels:9,useTokenMigrationHeader:!1,clientSupportsAadToken:!1,clientSupportsCaeToken:!1,clientSupportsSkypeToken:!0,supportMissingTokenTypesInResponse:!0,useSkypeTokenWhenNoAuthenticateHeader:!1,useKeyFrameApi:!1,enablePlayVideoOnStreamUnmuteWorkaround:!1,useDeviceHandleForLocalVideo:!0,enableCallStateChangesOnPageClose:!0,remoteUFD:{enabled:!1,enabledViaApi:!1,maxParticipantNumber:20,debounceTime:1e3,list:{},remoteUFDHandlerV2:!0,maxNumberOfBadUFDsForThrottling:3,throttlingTimeInterval:6e4,disableInterval:6e4,bundlingInterval:6e3,maxNumberOfBundles:4,bundlingWindowInterval:6e4},fixOpusComfortNoise:!0,streamModalitiesExcludeData:!0,muteDuringRemotePranswer:!0,syncMuteStateWithAudioDirection:!1,permissionDeniedUFDWorkaround:!1,audioSetSinkIdWorkaround:!1,identifyOneToOneCallWithoutParticipants:!1,emptyIceCandidateMarksGatheredAnswerer:!1,disableSendersTroughSetParametersVideo:!1,disableSendersTroughSetParametersAudio:!1,maxNumberOfPinnedVideos:1,localUFDDebounceTime:0,audioSampleRate:0,lowBatteryThreshold:10,fixExtraNegotiation:!1}}getEnforcedSettings(){return{}}},STe=class extends Vne{getInitialSettings(){const n=super.getInitialSettings();return n.oneStreamPerDeviceType=!0,n.removeUnsupportedVideoModality=!0,n.webrtcPranswerWaitForMediaPollingInterval=100,n.diagnostics.features.useLastSampleDeltaPerSecondConverter=!0,ul.isFormFactor("Mobile")&&(n.webrtcCameraOpenFs=920,n.webrtcVideoCapabilityMaxFS=920),n}},USi=class extends Vne{getEnforcedSettings(){return{useAudioAnalyzer:!1,enableAudioSharing:!1}}},zSi=class extends STe{getEnforcedSettings(){const n={webrtcSimulcastSessionEnabled:!0,webrtcAllowRestoreKeyframe:!0,permissions:{usePositiveInAdp:!1,useNegativeInAdp:!1,adpFallback:!0,adpFallbackAudio:!0,adpFallbackVideo:!1,adpRequestAVLast:!1,rememberNegative:!1},devices:{pollingIntervalIdle:1e4},audioRendererRestartOnPause:!0,subscribeToSsrcForVideo:!0,noRequiredCodecsWorkaround:!0,degradationPreference:"maintain-framerate"};return ul.isVersionGreaterOrEqual("15.0")||(n.statsAllowAnyVideoSendTrack=!0),ul.isVersionGreaterOrEqual("16.0")&&ul.isFormFactor("Mobile")&&(n.enablePermissionsWorkaround=!0),ul.isVersionGreaterOrEqual("17.0")&&ul.isFormFactor("Mobile")&&(n.recoverOnStreamUnmute=!0,n.enablePlayVideoOnStreamUnmuteWorkaround=!0),n}},VSi=class extends STe{getEnforcedSettings(){return{webrtcSimulcastSessionEnabled:!0,webrtcAllowRestoreKeyframe:!0,useDtlsTrasportConnectionCheck:!0,videoIsRenderingCheck:!1,fixSdpForPartialIceRestart:!0,mapSsrcToTrackForStats:!0,ignoreClosedDtlsTransportState1on1:!0,subscribeToSsrcForVideo1on1:!0,devices:{enumerateDevicesTimeout:0,pollingIntervalIdle:1e4,idlePollingOnStart:!0},webrtcInjectTransportCCAudioMultiparty:!1,videoCaptureFreezeTimeout:0,filterCodecsInSdp:!0,useSetParametersToApplyCapabilities:!0,removeRecvStreamOnEnded:!0,webrtcDisabledSenderBitrate:0,disableAudioOutputSelection:!0,permissionDeniedUFDWorkaround:!0}}},$Si=class extends Vne{getEnforcedSettings(){const n={checkSupportForWebrtc_1_0:!1,requireUserActionForAudioSharing:!0,webrtcSimulcastSessionEnabled:!0,webrtcAllowRestoreKeyframe:!0,useAudioAnalyzer:!1,enablePlatformCallConstraints:!0,specCompliantSimulcastMultiparty:{video:{layerScaleFactors:[1,2],enableLocally:!0,allowEnableRemotely:!0},maxBrControlEnabled:!0,allowResLimit:!0,allowOverride:!0,disableTilde:!1},extmapAllowMixedMultiparty:!0,enableVlaMultiparty:!0,allowRemoteVlaMultiparty:!0,enableNonAdvVlaMultiparty:!0,useMediaQualityControllerMultiparty:!0,useSdpCapabilities:!1,enableRollbackHandler:!0,allowedAudioCodecs:[{channels:2,clockRate:48e3,mimeType:"audio/opus"},{channels:1,clockRate:8e3,mimeType:"audio/G722"},{channels:1,clockRate:8e3,mimeType:"audio/PCMU"},{channels:1,clockRate:8e3,mimeType:"audio/PCMA"},{channels:1,clockRate:8e3,mimeType:"audio/CN"},{channels:1,clockRate:8e3,mimeType:"audio/telephone-event"}],setMinFpsForWebkit:!0};return Cye()==="43"?(0,yTe.mergeWith)(n,{postponeAudioMixerForAudioSharing:!0,enableAudioSharing:!0,filterCodecsInSdp:!0,webrtcPranswerWaitForMediaPollingInterval:250,specCompliantSimulcastMultiparty:{video:{useApplyConstraints:!1}},localPreviewMirroringSupported:!0,webrtcContributingSourcesPollingStartDelay:3e3,devices:{setSinkImmediately:!1}}):Cye()==="44"?(0,yTe.mergeWith)(n,{postponeAudioMixerForAudioSharing:!0,enableAudioSharing:!0,disposeSendersSync:!0,disposeStreamsSync:!0,filterCodecsInSdp:!0,useInactiveAudioTrack:!0,specCompliantSimulcastMultiparty:{video:{useApplyConstraints:!0,minFsForSimulcast:[920]}},webrtcPranswerWaitForMediaPollingInterval:250,webrtcContributingSourcesPollingStartDelay:5e3}):Cye()==="45"?(0,yTe.mergeWith)(n,{setParametersMaxBitrateUndefined:!0,specCompliantSimulcastMultiparty:{video:{useApplyConstraints:!0,minFsForSimulcast:[920]}}}):n}},HSi=class extends STe{getEnforcedSettings(){const n={};return ul.isVersionGreaterOrEqual("74.0")&&(n.webrtcSimulcastSessionEnabled=!0,n.webrtcAllowRestoreKeyframe=!0,n.enableAudioSharing=!0),ul.isVersionGreaterOrEqual("122.0")&&(n.useKeyFrameApi=!0),ul.isFormFactor("RoomAudioProcessing")&&(n.defaultAudioProcessingFlags=0,n.wasmvqe={enableAec:!1,enableVqe:!1,backgroundMode:!1},n.wasmdns={enableNoiseSuppression:!1,backgroundMode:!1}),(ul.isBrowser("CiscoOS")||ul.isBrowser("ZoomRoom"))&&(n.waitReportStatsAtCallStop=!0,n.setDisconnectAfterCleanUp=!0),ul.isFormFactor("Mobile")&&(n.enableAudioSharing=!1,n.audioRendererFailedReconnectTimes=3,n.devices={pollingIntervalIdle:1e4}),ul.isBrowser("SamsungTV")&&(n.useSetParametersToApplyCapabilities=!0),ul.isVersionGreaterOrEqual("98.0")&&ul.isFormFactor("Desktop")&&(n.specCompliantSimulcastMultiparty={video:{layerScaleFactors:[1,2],enableLocally:!0,allowEnableRemotely:!0,useApplyConstraints:!0,minFsForSimulcast:[920]},maxBrControlEnabled:!0,allowResLimit:!0,disableTilde:!1},n.extmapAllowMixedMultiparty=!0,n.enableVlaMultiparty=!0,n.allowRemoteVlaMultiparty=!0,n.enableNonAdvVlaMultiparty=!0,n.useMediaQualityControllerMultiparty=!0),ul.isVersionGreaterOrEqual("100.0")&&(n.redReceiveEnabledMultiparty=!0),n.webcv={useWasmEffects:!0,processorType:zg.ProcessorType.Wasm},n}},fKe=class{constructor(n){this.settings=n,this.isTransportUnbundled=!1,this.webrtcRejectedFeatures="",this.webrtcRequiredFeatures="",this.spatialAudioEnabled=!1,this._maxBandwidthInKbps=0,this._noiseSuppressionMode="Auto",this._enableMediaBypass=!1,this.audioContext={enabledLocally:!1,disabledRemotely:!1,enabledForSend:!1,initFailed:!1,initSendFailed:!1,codec:"None",lastUsedCodec:"None"}}setMediaConfiguration(n,a){this.maxBandwidthInKbps=Math.floor((n.maxBandwidthInBps||0)/1e3),this.isTransportUnbundled=this.settings.forceUnbundledTransport||this.settings.enableQosSupport&&(n.enableMediaQoS||!!n.mediaPortRanges),this._mediaPortRanges=n.mediaPortRanges,this.simulcastSessionEnabled=this.settings.webrtcSimulcastSessionEnabled&&wye(this.settings.checkSupportForWebrtc_1_0),this._noiseSuppressionMode=n.noiseSuppressionMode||"Auto",this._enableMediaBypass=this.settings.allowMediaBypass&&n.enableMediaBypass,this.webrtcRejectedFeatures=this._enableMediaBypass?"":this.settings.webrtcRejectedFeatures,this.webrtcRequiredFeatures=this._enableMediaBypass?"":this.settings.webrtcRequiredFeatures,this.spatialAudioEnabled=a?a.spatialAudioEnabled:n.enableSpatialAudio}get mediaBypassEnabled(){return this._enableMediaBypass}get noiseSuppressionMode(){return this._noiseSuppressionMode}get maxBandwidthInKbps(){return this._maxBandwidthInKbps}set maxBandwidthInKbps(n){this._maxBandwidthInKbps=n,this.settings.maxBandwidthInKbps&&(this._maxBandwidthInKbps=Math.min(this.settings.maxBandwidthInKbps,this._maxBandwidthInKbps||Number.MAX_SAFE_INTEGER))}get audioPortRange(){if(this.isTransportUnbundled&&this._mediaPortRanges&&this._mediaPortRanges.audioMin&&this._mediaPortRanges.audioMax)return{min:this._mediaPortRanges.audioMin,max:this._mediaPortRanges.audioMax}}get videoPortRange(){if(this.isTransportUnbundled&&this._mediaPortRanges&&this._mediaPortRanges.videoMin&&this._mediaPortRanges.videoMax)return{min:this._mediaPortRanges.videoMin,max:this._mediaPortRanges.videoMax}}get audioCodecContext(){return this.settings.useInsertableStreams?.audioWasmCodec?.enable?this.audioContext:void 0}},jSi=class extends jr{constructor(n,a,s={}){super(n),this.logger=n,this.platformCallConstraintsProvider=a,this.platformConfig=FSi(),this.sessionCount=0,this._consoleOverrides={},this.uaConfig=new yp(this),this.mediaConfiguration={},this.configReceivedDefer=new Pi,this.logger.info(`initializing configProvider ${this.constructor.name} from BrowserInfo: ${ul.toString()}`),this.initialSettings=(0,UD.mergeWith)({},(0,UD.cloneDeep)(this.platformConfig.getInitialSettings()),(0,UD.cloneDeep)(s),this.platformConfig.getEnforcedSettings(),zV),this.settings=this.initialSettings,this.settingsWithoutOverrides=this.initialSettings,this.stackSettings=(0,UD.cloneDeep)(s),this.mediaSettings=new fKe(this.settings),this.platformCallConstraintsProvider.changed(()=>{this.updateSettings();const c=this.platformCallConstraintsProvider.constraints,u=this.logger.createChild("SettingsToCallConstraintsConverter"),m=w7e(u,this.settings,c);this.platformCallConstraintsProvider.addCallConstraintsTelemetryEvent(m,"applied")}),this.configReceivedTimeout=window.setTimeout(()=>{this.configReceivedTimeout=void 0,this.configReceivedDefer.resolve()},this.settings.ecsConfigTimeout),this.logger.safe.info("Initialized")}getCallConstraints(){return this.platformCallConstraintsProvider.constraints}setCallConstraints(n){return this.platformCallConstraintsProvider.setConstraints(n),n}getCallConstraintsTelemetry(){return this.logger.error("Not supported globally, returning empty array"),[]}addCallConstraintsTelemetryEvent(n,a){this.logger.error("Not supported globally")}overrideMaxSessionBandwidth(n){return this.logger.error("Not supported globally"),!1}getIceTransportPolicy(){return this.logger.warn(`Not supported globally, returning default ${ke.ICE_TRANSPORT_POLICY.all}`),ke.ICE_TRANSPORT_POLICY.all}setIceTransportPolicy(n){this.logger.error("Not supported globally")}getConfigReceivedOrTimeout(){return this.configReceivedDefer.promise}getConfigView(n,a){const s=n?"Multiparty":"1on1",c=Object.entries((0,UD.cloneDeep)(this.settings)).reduce((m,[b,_])=>(m[b]=_,b.endsWith(s)&&(m[b.replace(s,"")]=_),m),{}),u=new fKe(c);return u.setMediaConfiguration(this.mediaConfiguration,a?.mediaConfig),new Rui(this.logger.createChild("ConfigProviderView"),c,u,this.userAgentConfig,this.countryCode,this.platformCallConstraintsProvider,a?.getCallConstraints())}updateConfig(n,a,s,c){this.etag=a||this.etag,this.configIds=s||this.configIds,this.country=c||this.country,this.event("newConfigReceived").raise(n,a,s),this.settingsWithoutOverrides=(0,UD.mergeWith)({},this.settingsWithoutOverrides,n,zV),this.updateSettings(),this.configReceivedTimeout&&(window.clearTimeout(this.configReceivedTimeout),this.configReceivedTimeout=void 0),this.configReceivedDefer.resolve()}updateSessionCount(n){this.sessionCount=n,n===0&&this.pendingSettings&&(this.logSettings("Applying pending configuration",this.pendingSettings),this.updateSettings(this.pendingSettings),this.pendingSettings=null),n>0&&this.configReceivedTimeout&&this.configReceivedDefer.resolve()}get config(){return this.settings}get stackConfig(){return this.stackSettings}get consoleOverrides(){return this._consoleOverrides}get defaultConfig(){return this.initialSettings}get userAgentConfig(){return this.uaConfig}get countryCode(){return this.country}setMediaConfiguration(n){this.mediaConfiguration=n,this.mediaSettings.setMediaConfiguration(n)}get mediaConfig(){return this.mediaSettings}get ETag(){return this.etag}get ecsConfigIds(){return this.configIds}setConsoleOverrides(n){this._consoleOverrides=(0,UD.mergeWith)({},this._consoleOverrides,n,zV),this.updateSettings()}setConsoleOverride(n,a){this._consoleOverrides[n]=a,this.updateSettings()}clearConsoleOverride(n){delete this._consoleOverrides[n],this.updateSettings()}clearAllConsoleOverrides(){this._consoleOverrides={},this.updateSettings()}updateSettings(n=this.settingsWithoutOverrides){if(this.sessionCount>0)return this.pendingSettings=n,void this.logSettings("pendingSettings updated",n);this.settings=this.mergeSettings(n),this.event("configUpdated").raise(),this.logSettings("Settings updated",this.settings)}logSettings(n,a){const s=Object.entries(a).reduce((c,[u,m])=>(m!==this.initialSettings[u]&&(c[u]=m),c),{});this.logger.safe.info(`${n}: ${JSON.stringify(s)}`)}mergeSettings(n){if(!n.enablePlatformCallConstraints&&!this._consoleOverrides.enablePlatformCallConstraints)return this.mergeSettingsWithConsoleOverrides(n);let a=n;const{setConsoleOverridesBeforeCallConstraints:s}=this._consoleOverrides;return s&&(a=this.mergeSettingsWithConsoleOverrides(a)),a=this.mergeSettingsWithPlatformConstraints(a),s||(a=this.mergeSettingsWithConsoleOverrides(a)),a}mergeSettingsWithConsoleOverrides(n){return this.logger.safe.info(`Merging settings with console overrides: ${nn(this._consoleOverrides)}`),(0,UD.mergeWith)({},n,this._consoleOverrides,zV)}mergeSettingsWithPlatformConstraints(n){const a=this.platformCallConstraintsProvider.getSettings(n);return this.logger.safe.info(`Merging settings with platform call constraints: ${nn(a)}`),(0,UD.assign)({},n,a,zV)}},vKe=class{constructor(){this.data={clientDSH:void 0,signalingDSH:void 0,serverDSH:void 0,activeStrategy:void 0,lastMsgOrigin:void 0,changedCountContributingSources:0,changedCountDSH:0}}contributingSourcesChanged(){this.data.changedCountContributingSources++}setCurrentActiveStrategy(n){this.data.activeStrategy=n}resetState(){return this.data.lastMsgOrigin=void 0,this}recordHistoryEvent(n,a){var s,c;this.data.changedCountDSH++,(s=this.data)[c=a+"DSH"]??(s[c]={count:0,duplicateCount:0}),this.data.lastMsgOrigin=a;const u=this.data[a+"DSH"];u.count++,u.firstMsgTime??(u.firstMsgTime=Date.now()),xc(this.data.lastHistory,n)&&u.duplicateCount++,this.data.lastHistory=n,this.data.lastMsgDate=Date.now()}getObjectRef(){return this.data}},yKe=class{constructor(n,a,s,c,u,m,b,_){this.mediaStream=n,this.receiver=a,this.modality=s,this.sourceStreamId=c,this.controller=u,this.videoCapabilities=m,this.getMaxAllowedVideoFS=b,this.substreamIndex=_,this.msi=-1,this.operations=Promise.resolve()}dispose(){this.receiver=null,this.mediaStream=null}getId(){return this.mediaStream.id}getModality(){return this.modality}getMsi(){return this.msi}getMediaStream(){return this.mediaStream}getReceiver(){return this.receiver}getSourceStreamId(){return this.sourceStreamId}getSubstreamIndex(){return this.substreamIndex}requestSource(n){this.msi=n;const a=this.operations.then(()=>{let s;return this.videoCapabilities&&(this.videoCapabilities.resetToInitial(),this.getMaxAllowedVideoFS&&this.videoCapabilities.setMaxFS(Math.min(this.getMaxAllowedVideoFS(),this.videoCapabilities.getMaxFS())),s=this.videoCapabilities.buildFmtp(),this.videoCapabilities.resetToInitial()),this.controller.requestSource(this.mediaStream.id,n,s)});return this.operations=a.catch(()=>{}),a}},GSi=class{constructor(n){this.subscription=n}get subscribedStream(){return this.subscription.stream?.getMediaStream()}get msi(){return this.checkDisposed(),this.subscription.msi}get modality(){return this.checkDisposed(),this.subscription.modality}get localMsi(){return this.checkDisposed(),this.subscription.localMsi}setOnMediaStreamChangedHandler(n){this.checkDisposed(),this.mediaStreamChanged=n,this.subscription.isStreamReady&&this.notifyMediaStreamChanged()}setOnErrorHandler(n){this.checkDisposed(),this.error=n}dispose(){this.subscription&&(this.subscription.dispose(hi(),this),this.subscription=null)}unsubscribe(){this.subscription&&(this.subscription.unsubscribe(),this.subscription=null)}notifyMediaStreamChanged(){if(this.mediaStreamChanged){const n=this.subscription.stream,a=this.subscription.isStreamReady;this.mediaStreamChanged(n&&a?n.getMediaStream():null)}}notifyError(n){this.error&&this.error(n)}checkDisposed(){if(!this.subscription)throw new Error("subscription disposed")}},qSi=class extends jr{constructor(n,a,s){super(),this.modality=n,this.msi=a,this.disposeDelay=s,this.clients=[],this.streamReady=!1}createClient(){const n=new GSi(this);return this.clients.push(n),n}get isStreamReady(){return this.streamReady}get localMsi(){return this.subStream?.getSourceStreamId()}get isInactive(){return!this.clients.length}get stream(){return this.subStream}set stream(n){try{if(n===this.subStream)return;this.subStream&&(this.unsubscribe(!1),this.notifyStreamChanged()),this.subStream=n,n&&(this.streamReady=!1,n.requestSource(this.msi).then(()=>{this.streamReady=!0,this.notifyStreamChanged()}).catch(a=>{this.notifyError(a)}))}catch(a){this.event("onFailed").raise(this,a)}}notifyError(n){this.clients.forEach(a=>{a.notifyError(n)}),this.event("onFailed").raise(this,n)}dispose(n,a){a?(VR(this.clients,s=>s===a),this.isInactive&&(this.disposeTimeout=window.setTimeout(()=>{this.disposeTimeout=null,this.unsubscribeIfInactive()},this.disposeDelay))):(this.clients=[],this.unsubscribe())}unsubscribeIfInactive(){this.isInactive&&(this.disposeTimeout&&clearTimeout(this.disposeTimeout),this.unsubscribe())}unsubscribe(n=!0){this.subStream&&(this.subStream.requestSource(-1).catch(()=>{}),this.streamReady=!1,this.subStream=null),n&&this.event("onDisposed").raise(this)}notifyStreamChanged(){this.clients.forEach(n=>n.notifyMediaStreamChanged()),this.event("onStreamChanged").raise()}},SKe=class extends jr{constructor(n,a,s,c){super(n),this.configProvider=a,this.diagnostics=c,this.videoSubscriptions=[],this.isMcpSrAvailable=!1,this.subscriptionEvents=new Map,this.setLogger(n),this.diagnostics??(this.diagnostics=new bTe(this.configProvider,()=>{})),this.setStreamProvider(s),this.logger.safe.info("created")}getSubscriptionsCount(){return this.videoSubscriptions.filter(n=>n.isStreamReady).length}setStreamProvider(n){this.streamProvider=n,this.streamProvider.setOnStreamsChangedHandler(()=>this.streamsChanged())}setLogger(n){this.logger=n}subscribeVideo(n,a=-2){let s=this.videoSubscriptions.find(u=>u.msi===a&&u.modality===n),c=this.getAvailableStream(n);if(s)!s.stream&&c?this.assignStream(s,c):this.logger.safe.info(`subscription #${a} for modality ${n} already exists, stream assigned: ${!!s.stream}`);else{const u=Date.now();this.disposeInactiveSubscriptionIfNeeded(n),c=this.getAvailableStream(n);const m=c?.getSourceStreamId();this.logger.safe.info(`creating new subscription #${a} for modality ${n}`),this.event("onSubscriptionChanged").raise(1,n,a,m,null),this.diagnostics.addSubscribe(n,a,m),s=new qSi(n,a,this.configProvider.config.webrtcVideoSubscriptionDisposeTimeout);const b=[];b.push(s.on("onDisposed",_=>this.onSubscriptionDisposed(_))),b.push(s.on("onStreamChanged",()=>{const _=s.stream?.getId(),k=s.localMsi;if(this.updateTrackIds(),s.isStreamReady){const N=Date.now();this.event("onSubscriptionChanged").raise(2,n,a,k,N-u,_),this.diagnostics.addSubscribed(n,a,k,N-u)}})),b.push(s.on("onFailed",(_,k)=>this.onSubscriptionFailed(_,k))),this.subscriptionEvents.set(s,b),this.videoSubscriptions.push(s),c?this.assignStream(s,c):this.logger.safe.info(`waiting for available stream for subscription #${a}`)}return s.createClient()}dispose(){const n=hi();this.videoSubscriptions.concat().forEach(a=>a.dispose(n)),this.streamProvider.setOnStreamsChangedHandler(null),super.dispose(),this.logger.safe.info("disposed")}reriseSubscribeEvents(){this.logger.safe.info(`rerising subscription events: ${this.videoSubscriptions.length}`);const n=[];this.videoSubscriptions.forEach(a=>{const s=a.modality,c=a.msi,u=a.localMsi;this.event("onSubscriptionChanged").raise(1,s,c,u),this.diagnostics.addSubscribe(s,c,u),n.push(...this.getSubscriptionVideoTrackIds(a))}),this.diagnostics.subscribedTrackIds=n}setDiagnostics(n){this.diagnostics=n??new bTe(this.configProvider,a=>{this.logger.safe.warn(`Unhandled stats error from inactive subscription manager: ${a}`)})}streamChangedByMsi(n){this.logger.safe.info(`streams changed, subscriptions active: ${this.videoSubscriptions.length}`);const a=this.videoSubscriptions.find(s=>s.msi===n);a?this.assignSubscriptionToStream(a):this.logger.safe.error(`Subscription for msi ${n} not found`)}mcpSourceRequestsAvailable(){this.isMcpSrAvailable=!0}streamsChanged(){this.logger.safe.info(`streams changed, subscriptions active: ${this.videoSubscriptions.length}`),this.videoSubscriptions.forEach(n=>{this.assignSubscriptionToStream(n)})}assignSubscriptionToStream(n){const a=!n.stream||this.isStreamRemoved(n.stream);if(this.logger.safe.info(`Subscription for ${n.modality} #${n.msi} needs new stream: ${a}`),!a)return;const s=this.getAvailableStream(n.modality);s?this.assignStream(n,s):this.resignStream(n)}getAvailableStream(n){let a=this.streamProvider.getStreams();return n==="video"&&!this.isMcpSrAvailable&&this.configProvider.config.multiStreamSupported&&(a=a.filter(s=>s.getSubstreamIndex()===void 0)),a.find(s=>n===s.getModality()&&s.getMsi()===-1)}isStreamRemoved(n){return!this.streamProvider.getStreams().some(a=>a===n)}assignStream(n,a){this.logger.safe.info(`assigning stream #${a.getId()} to subscription #${n.msi}`),n.stream=a}resignStream(n){if(n.stream)this.logger.safe.info(`removing stream from subscription #${n.msi}`),n.stream=null;else{const a=this.streamProvider.getStreams().filter(s=>n.modality===s.getModality()&&s.getMsi()!==-1).length;this.logger.safe.warn(`no stream available for ${n.modality} #${n.msi}, ${n.modality} used stream count: ${a}`)}}disposeInactiveSubscriptionIfNeeded(n){this.getAvailableStream(n)||this.videoSubscriptions.find(a=>a.modality===n&&a.isInactive)?.unsubscribeIfInactive()}onSubscriptionDisposed(n){const a=hi(),s=n.modality,c=n.msi,u=n.localMsi;this.event("onSubscriptionChanged").raise(3,s,c,u),this.diagnostics.addUnsubscribe(s,c,u),this.logger.safe.info(`disposing subscription for ${s} #${c}`),VR(this.videoSubscriptions,m=>m===n),this.streamsChanged(),this.updateTrackIds(),this.subscriptionEvents.has(n)&&(this.subscriptionEvents.get(n).forEach(m=>m.dispose(a)),this.subscriptionEvents.delete(n))}updateTrackIds(){const n=[],a=[];this.videoSubscriptions.forEach(s=>{if(!s.isStreamReady)return;const c=s.stream?.getId().split("-")[1];a.push(c),n.push(...this.getSubscriptionVideoTrackIds(s))}),this.event("onTrackIdsChanged").raise(n),this.diagnostics.subscribedTrackIds=n,this.configProvider.config.subscribeToSsrcForVideo&&this.event("onTrackSsrcChanged").raise(a)}getSubscriptionVideoTrackIds(n){return n?.stream?.getMediaStream()?.getVideoTracks().map(a=>a.id)??[]}onSubscriptionFailed(n,a){this.event("onSubscriptionFailed").raise(-1,n.modality,n.msi,n.localMsi,a),this.diagnostics.addFailed(n.modality,n.msi,n.localMsi,nn(a))}},bTe=class{constructor(n,a){this.configProvider=n,this.addStatsError=a,this.data={video:{events:[],counters:{attempted:0,subscribed:0,unsubscribed:0,failed:0}},sharing:{events:[],counters:{attempted:0,subscribed:0,unsubscribed:0,failed:0}},subscribedTrackIds:[]}}set subscribedTrackIds(n){this.data.subscribedTrackIds=n}addSubscribe(n,a,s){const c=this.getModalityData(n);if(c){const u={evt:1,msi:a,localMsi:s,ts:Date.now()};Mo(c.events,u,this.configProvider.config.diagnostics.collectionLimits.numSubscriptionEvents),c.counters.attempted++}}addSubscribed(n,a,s,c){const u=this.getModalityData(n);if(u){const m={evt:2,msi:a,localMsi:s,ts:Date.now(),duration:c};Mo(u.events,m,this.configProvider.config.diagnostics.collectionLimits.numSubscriptionEvents),u.counters.subscribed++}}addUnsubscribe(n,a,s){const c=this.getModalityData(n);if(c){const u={evt:3,msi:a,localMsi:s,ts:Date.now()};Mo(c.events,u,this.configProvider.config.diagnostics.collectionLimits.numSubscriptionEvents),c.counters.unsubscribed++}}addFailed(n,a,s,c){const u=this.getModalityData(n);if(u){const m={evt:-1,msi:a,localMsi:s,ts:Date.now(),error:c};Mo(u.events,m,this.configProvider.config.diagnostics.collectionLimits.numSubscriptionEvents),u.counters.failed++}}getObjectRef(){return this.data}getModalityData(n){switch(n){case ke.MEDIA_TYPE.video:return this.data.video;case ke.MEDIA_TYPE.sharing:return this.data.sharing;default:return void this.addStatsError(`Unsupported modality ${n}`)}}},WSi=class{constructor(n,a){this.configProvider=n,this.addStatsError=a,this.data={videoMaxCapabilitiesEvents:[],videoMaxCapabilitiesErrors:[],sharingMaxCapabilitiesEvents:[],sharingMaxCapabilitiesErrors:[],currentVideoSsrcRequestedCapabilities:{},currentVideoSsrcAppliedCapabilities:{},currentSharingSsrcRequestedCapabilities:{},currentSharingSsrcAppliedCapabilities:{},numVideoControlMessages:0,numOutOfOrderVideoControlMessages:0,numWebcamFreezeIntervals:0,numProcessedStreamFreezeIntervals:0}}onMaxCapabilitiesRequested(n){const a={causeId:n.causeId,events:[{eventType:"req",timestamp:Date.now(),capabilities:n.capabilities,isSimulcast:n.isSimulcastEnabled}]};try{if(n.modality===ke.MODALITY.video){Mo(this.data.videoMaxCapabilitiesEvents,a,this.configProvider.config.diagnostics.collectionLimits.numCapabilitiesRequested),this.data.currentVideoSsrcRequestedCapabilities={};for(const s of n.capabilities)this.data.currentVideoSsrcRequestedCapabilities[`${s.ssrc??0}`]=s}else if(n.modality===ke.MODALITY.sharing){Mo(this.data.sharingMaxCapabilitiesEvents,a,this.configProvider.config.diagnostics.collectionLimits.numCapabilitiesRequested),this.data.currentSharingSsrcRequestedCapabilities={};for(const s of n.capabilities)this.data.currentSharingSsrcRequestedCapabilities[`${s.ssrc??0}`]=s}}catch(s){this.addStatsError?.("onMaxCapabilitiesRequested",nn(s))}}onMaxCapabilitiesApplied(n){try{const a=this.getEventForCause(n.modality,n.causeId),s={eventType:"app",timestamp:Date.now(),capabilities:n.capabilities,error:`${n.error}`||"none"};if(a&&(Mo(a.events,s,this.configProvider.config.diagnostics.collectionLimits.numCapabilitiesApplied,1),n.error&&(n.modality===ke.MODALITY.video?Mo(this.data.videoMaxCapabilitiesErrors,a,this.configProvider.config.diagnostics.collectionLimits.numCapabilitiesApplied,1):n.modality===ke.MODALITY.sharing&&Mo(this.data.sharingMaxCapabilitiesErrors,a,this.configProvider.config.diagnostics.collectionLimits.numCapabilitiesApplied,1))),n.modality===ke.MODALITY.video){this.data.currentVideoSsrcAppliedCapabilities={};for(const c of n.capabilities)this.data.currentVideoSsrcAppliedCapabilities[`${c.ssrc??0}`]=c}else if(n.modality===ke.MODALITY.sharing){this.data.currentSharingSsrcAppliedCapabilities={};for(const c of n.capabilities)this.data.currentSharingSsrcAppliedCapabilities[`${c.ssrc??0}`]=c}}catch(a){this.addStatsError?.("onMaxCapabilitiesApplied",nn(a))}}addVideoControlMessage(n=!1){this.data.numVideoControlMessages++,n&&this.data.numOutOfOrderVideoControlMessages++}getObjectRef(){return this.data}registerWebcamFreeze(){this.data.numWebcamFreezeIntervals++}registerProcessedStreamFreeze(){this.data.numProcessedStreamFreezeIntervals++}getEventForCause(n,a){return(n===ke.MODALITY.video?this.data.videoMaxCapabilitiesEvents:this.data.sharingMaxCapabilitiesEvents).find(s=>s.causeId===a)}},KSi=class{constructor(n){this.configProvider=n,this.data={renderers:[],firstTimeToFirstFrameVideo:-1,firstTimeToFirstFrameSharing:-1,timeToFirstFrameSinceSubscriptionStartVideo:-1,timeToFirstFrameSinceSubscriptionStartSharing:-1,isRenderingEvents:{video:[],sharing:[]},preferredResolution:{video:void 0,sharing:void 0}}}setTimeToFirstFrame(n,a){n!==-1&&(a===ke.MODALITY.video&&this.data.firstTimeToFirstFrameVideo===-1?this.data.firstTimeToFirstFrameVideo=n:a===ke.MODALITY.sharing&&this.data.firstTimeToFirstFrameSharing===-1&&(this.data.firstTimeToFirstFrameSharing=n))}setTimeToFirstFrameSinceSubscriptionStart(n,a){n!==-1&&(a===ke.MODALITY.video&&this.data.timeToFirstFrameSinceSubscriptionStartVideo===-1?this.data.timeToFirstFrameSinceSubscriptionStartVideo=n:a===ke.MODALITY.sharing&&this.data.timeToFirstFrameSinceSubscriptionStartSharing===-1&&(this.data.timeToFirstFrameSinceSubscriptionStartSharing=n))}setIsRendering(n,a){this.data.isRenderingEvents[a]&&Mo(this.data.isRenderingEvents[a],{isRendering:n,ts:Date.now()},this.configProvider.config.diagnostics.collectionLimits.numIsRenderingEvents)}setPreferredResolution(n,a){(n.width||n.height)&&(this.data.preferredResolution[a]=n)}newRendererDiagnostics(){const n=new JSi(this,this.configProvider),a=n.on("onDisposed",()=>{this.removeDeadRenderers(),a.dispose()});return this.data.renderers.push(n.getObjectRef()),n}getObjectRef(){return this.data}removeDeadRenderers(){this.data.renderers=this.data.renderers.filter(n=>n.alive)}},JSi=class extends jr{constructor(n,a){super(),this.managerDiagnostics=n,this.configProvider=a,this.isAlive=!0,this.data={alive:!0,totalFreezeDuration:0,isRendering:!1,timeToFirstFrame:-1,timeToFirstFrameSinceSubscriptionStart:-1,rendererStates:[]},delete this.data.alive,Object.defineProperty(this.data,"alive",{get:()=>this.isAlive,enumerable:!1,configurable:!1})}set trackId(n){this.data.trackId=n}set rendererSize(n){this.data.rendererSize=n,n.toString=()=>`${n.width}x${n.height}`,this.managerDiagnostics.setPreferredResolution(n,this.data.modality)}set msi(n){this.data.msi=n}set modality(n){this.data.modality=n}set isRendering(n){this.data.isRendering=n,this.managerDiagnostics.setIsRendering(n,this.data.modality)}set timeToFirstFrame(n){this.data.timeToFirstFrame=n,this.managerDiagnostics.setTimeToFirstFrame(n,this.data.modality)}set timeToFirstFrameSinceSubscriptionStart(n){this.data.timeToFirstFrameSinceSubscriptionStart=n,this.managerDiagnostics.setTimeToFirstFrameSinceSubscriptionStart(n,this.data.modality)}addFreezeDuration(n){this.data.totalFreezeDuration+=n}addStateChange(n){Mo(this.data.rendererStates,n,this.configProvider.config.diagnostics.telemetryLimits.numRendererStateChangedEvents)}dispose(){this.isAlive=!1,this.event("onDisposed").raise()}getObjectRef(){return this.data}},YSi=dn,bKe=$i(Un()),_U=dn;function TKe(n){let a="";return Ng(n,(s,c)=>{a+=(a?";":"")+c,s!==void 0&&(a+=`=${s}`)}),a}var sE=class{constructor(n){this.parameters={},n&&n.split(";").forEach(a=>{const s=a.split("=");this.parameters[s[0]]=s[1]})}setIfMissing(n,a){this.contains(n)||(this.parameters[n]=a)}removeIfPresent(n){this.contains(n)&&delete this.parameters[n]}get(n){return this.parameters[n]}names(){return Object.keys(this.parameters)}contains(n){return this.parameters.hasOwnProperty(n)}toString(){return TKe(this.parameters)}};function $ne(n,a,s){if(!n.rtp)return;const c=n.rtp.filter(u=>u.payload===a)[0];c&&Lf(n,{codec:c.codec,rate:c.rate,payload:c.payload,encoding:c.encoding},u=>(u.rtp.payload=s,u))}function TTe(n){const a=new Set;for(const u of n.media)for(const m of u.rtp??[])a.add(m.payload);const s=[96,127];for(let u=s[0];u<=s[1];u++)if(!a.has(u))return u;const c=[35,64];for(let u=c[0];u<=c[1];u++)if(!a.has(u))return u;return-1}function QSi(n,a){const s=new Set,c=[];for(const u of n.media)for(const m of u.rtp??[])s.add(m.payload);for(let u=a[0];u<=a[1];u++)s.has(u)||c.push(u);return c}function Lf(n,a,s,c){CKe(n,a,!0,c,s)}function Hne(n,a,s,c){CKe(n,a,!1,c,s)}function CKe(n,a,s,c=!0,u){if(n.rtp){for(let m=0;m<n.rtp.length;m++){const b=n.rtp[m],_=b.payload;if(a.codec.toLowerCase()!==b.codec.toLowerCase()||a.rate!==b.rate||a.encoding!==b.encoding||a.payload&&a.payload!==b.payload)continue;const k={rtp:b};n.fmtp||(n.fmtp=[]);const N=n.fmtp.find(ee=>b.payload===ee.payload);k.fmtp=N,n.rtcpFb||(n.rtcpFb=[]),k.rtcpFb=n.rtcpFb.filter(ee=>ee.payload===b.payload);const W=k.rtcpFb.length>0;if(u(k)===null)n.payloads=n.payloads.toString().split(" ").filter(ee=>b.payload!==+ee).join(" "),n.fmtp=n.fmtp.filter(ee=>b.payload!==ee.payload),n.rtcpFb=n.rtcpFb.filter(ee=>b.payload!==ee.payload),n.rtp[m]=null;else{if(k.rtp.payload!==_){const ee=k.rtp.payload;n.payloads=n.payloads.toString().split(" ").map(oe=>+oe===_?ee:+oe).join(" "),k.fmtp&&(k.fmtp.payload=ee),k.rtcpFb&&k.rtcpFb.forEach(oe=>oe.payload=ee),c&&n.fmtp.filter(oe=>oe.config&&oe.config.indexOf(`apt=${_}`)>-1).forEach(oe=>oe.config=oe.config.replace(`apt=${_}`,`apt=${ee}`))}!N&&k.fmtp&&n.fmtp.push(k.fmtp),!W&&k.rtcpFb&&k.rtcpFb.forEach(ee=>n.rtcpFb.push(ee))}if(s)break}n.rtp=n.rtp.filter(m=>!!m)}}function Iw(n,a){if(!n.rtp)return;let s=-1;if(n.rtp.forEach(function(c,u){a.codec.toLowerCase()!==c.codec.toLowerCase()||a.rate!==c.rate||a.encoding!==c.encoding||a.payload&&a.payload!==c.payload||(s=u)}),s>=0&&n.rtp.length>1){const c=n.rtp[s].payload;n.rtp.splice(s,1),n.payloads=n.payloads.split(" ").filter(u=>c!==+u).join(" "),n.fmtp=n.fmtp?.filter(u=>c!==u.payload)}}function _Ke(n,a){n.rtp.unshift({payload:a.payload,codec:a.codec,rate:a.rate,encoding:a.encoding}),n.payloads=`${a.payload} ${n.payloads}`}function EKe(n,a,s){return!(0,_U.isUndefined)(n.rate)&&n.rate!==a.rate||!(0,_U.isUndefined)(n.codec)&&n.codec.toLowerCase()!==a.codec.toLowerCase()||!(0,_U.isUndefined)(n.encoding)&&(!(0,_U.isUndefined)(a.encoding)&&n.encoding!==a.encoding||(0,_U.isUndefined)(a.encoding)&&n.encoding!==1)?!1:(0,_U.isUndefined)(n.fmtpLine)?!0:!!s?.find(u=>u.payload===a.payload&&u.config.toLowerCase().indexOf(n.fmtpLine.toLowerCase())!==-1)}function AKe(n,a){return a===n||a==="*"}function IKe(n,a,s,c){if(!n.rtp?.length)return;let u=n.rtp.filter(m=>a.some(b=>EKe(b,m,n.fmtp)));n.type===ke.MEDIA_TYPE.video&&(u=u.filter(m=>{const b=n.fmtp?.find(_=>_.payload===m.payload&&_.config.startsWith("apt="));if(b){const _=+b.config.split(";")[0].split("=")[1];return u.some(k=>k.payload===_)}return!0})),u.length?(n.rtp=u,s&&(n.rtp=(0,_U.flatten)(a.map(m=>n.rtp.filter(b=>EKe(m,b,n.fmtp))))),n.payloads=n.rtp.map(m=>m.payload).join(" "),n.fmtp=n.fmtp?.filter(m=>n.rtp.some(b=>AKe(b.payload,m.payload))),n.rtcpFb=n.rtcpFb?.filter(m=>n.rtp.some(b=>AKe(b.payload,m.payload)))):c&&c.warn("Empty rtp list after filtering")}function J9(n){if(n.label)switch(n.label){case ke.MEDIA_LABEL.audio:return"Audio";case ke.MEDIA_LABEL.video:return"Video";case ke.MEDIA_LABEL.sharing:return"ScreenShare";case ke.MEDIA_LABEL.data:return"Data"}else switch(n.type){case ke.MEDIA_TYPE.audio:return"Audio";case ke.MEDIA_TYPE.video:return"Video";case ke.MEDIA_TYPE.data:case ke.MEDIA_TYPE.dataChannel:return"Data"}return null}function GN(n){if(n.label)switch(n.label){case ke.MEDIA_LABEL.audio:return ke.MODALITY.audio;case ke.MEDIA_LABEL.video:return ke.MODALITY.video;case ke.MEDIA_LABEL.sharing:return ke.MODALITY.sharing;case ke.MEDIA_LABEL.data:return ke.MODALITY.data}else switch(n.type){case ke.MEDIA_TYPE.audio:return ke.MODALITY.audio;case ke.MEDIA_TYPE.video:return ke.MODALITY.video;case ke.MEDIA_TYPE.data:case ke.MEDIA_TYPE.dataChannel:return ke.MODALITY.data}return null}function jne(n){switch(n){case ke.MODALITY.audio:return ke.MEDIA_LABEL.audio;case ke.MODALITY.video:return ke.MEDIA_LABEL.video;case ke.MODALITY.sharing:return ke.MEDIA_LABEL.sharing;case ke.MODALITY.data:return ke.MEDIA_LABEL.data;default:return null}}function wKe(n){return n.media.reduce((a,s)=>{if(s.port!==0){const c=GN(s);if(!(c in a)){const u=s.direction?s.direction.toLowerCase():ke.MEDIA_STATE.sendReceive;a[c]=u}}return a},{})}function ZSi(n){switch(n){case ke.MODALITY.audio:return ke.MEDIA_TYPE.audio;case ke.MODALITY.video:case ke.MODALITY.sharing:return ke.MEDIA_TYPE.video;case ke.MODALITY.data:return ke.MEDIA_TYPE.data;default:return null}}function kKe(n){const a=n.groups?.find(s=>s.type==="BUNDLE");if(a){const s=a.mids?.toString().split(" ")[0];return n.media.find(c=>{const u=typeof c.mid=="number"?c.mid.toString():c.mid;return s===u})||null}return null}function $S(n){return n.port===0}function CTe(n){let a;return n&&Lf(n,{codec:"h264",rate:9e4},s=>{s.fmtp?.config&&(a=ebi(s.fmtp.config))}),a}function XSi(n){const a=n.media.map(s=>parseFloat(s.mid||"0"));for(let s=1;s<=Math.max(...a)+1;s++)if(!a.includes(s))return s.toString();return"-1"}function ebi(n){const a=new sE(n);return{maxFs:+a.get(ke.VIDEO_CAPABILITIES.MAX_FS_PATH),maxMbps:+a.get(ke.VIDEO_CAPABILITIES.MAX_MBPS_PATH),maxFps:+a.get(ke.VIDEO_CAPABILITIES.MAX_FPS_PATH)/100,maxBr:1200*+a.get(ke.VIDEO_CAPABILITIES.MAX_BR_PATH)}}function tbi(n){const a=/a=x-multi-stream:(\d+)/,s=n.match(a);if(s)return parseInt(s[1])}var Y9=dn;function ibi(){const n=[{jsep:"active",msSdp:"tcp-act"},{jsep:"passive",msSdp:"tcp-pass"},{jsep:"so",msSdp:"tcp-so"}];function a(m,b){if(m.port&&!m.candidates.length){const _=kKe(b);_&&(m.port=_.port,m.connection=_.connection)}}function s(m,b){delete m.generation,delete m["network-id"],delete m["network-cost"],m.transport.match(/tcp/i)&&c(m,b)}function c(m,b){n.some(function(_){if(b){if(_.msSdp===m.transport.toLowerCase())return m.transport="tcp",m.tcptype=_.jsep,!0}else if(m.tcptype&&_.jsep===m.tcptype.toLowerCase())return m.transport=_.msSdp,delete m.tcptype,!0;return!1})}function u(m,b,_){const k=b.connection||_.connection,N=function(W,ee,oe){return W.port===oe&&W.ip===ee};return!!k&&(m.component===1?N(m,k.ip,b.port):!!b.rtcp&&N(m,b.rtcp.ip||k.ip,b.rtcp.port))}this.fromMsSdp=function(m){m.candidates=m.candidates||[],m.xCandidatesIpv6&&(m.xCandidatesIpv6.forEach(function(b){m.candidates.push(b)}),delete m.xCandidatesIpv6),m.candidates.forEach(function(b){s(b,!0)})},this.toMsSdp=function(m,b){m.candidates=m.candidates||[],m.candidates.sort(function(_,k){return _.foundation!==k.foundation?_.foundation-k.foundation:_.component!==k.component?_.component-k.component:+u(k,m,b)-+u(_,m,b)}),m.candidates=m.candidates.filter(function(_,k){s(_,!1);const N=m.candidates[k-1];return!N||N.component!==_.component||N.foundation!==_.foundation}),a(m,b)}}var nbi={build:()=>new ibi},abi=class{toMsSdp(n,a){a==="offer"?n.rtcp&&(n.rtcp={port:n.port}):delete n.rtcp}},rbi={build:()=>new abi},Gne={STREAM_ID:{audio:"mainAudio",video:"mainVideo",sharing:"applicationsharingVideo"},STREAM_ID_DELIMITER:"-"},RKe=[{label:ke.MEDIA_LABEL.audio,id:Gne.STREAM_ID.audio},{label:ke.MEDIA_LABEL.video,id:Gne.STREAM_ID.video},{label:ke.MEDIA_LABEL.sharing,id:Gne.STREAM_ID.sharing}].reduce((n,a)=>(n[a.label]=a.id,n),{}),MKe=sw(),obi=class{constructor(n){this.configuration=n}fromMsSdp(n){if(n.port===0)return;const a="-";if(!this.isRecvOnly(n)||this.configuration.unifiedPlanEnabled){if(n.msid){n.ssrcs&&n.ssrcs.length===1&&(this.addStream(n,n.ssrcs[0].id,n.ssrcs[0].value,n.msid),n.ssrcs.shift());const s=n.msid.split(" ");(this.configuration.addPrefixForMsid||s[0]===a)&&(n.msid=this.getMsidValue(s[0],s[1]||s[0],n.label))}if(n.ssrcs)this.updateMsids(n.ssrcs,(s,c)=>this.configuration.addPrefixForMsid||s===a?this.getMsidValue(s,c,n.label):`${s} ${c}`);else{const s=this.getFlowSsrcs(n);s.length>0?s.forEach(c=>{this.addStream(n,c,MKe,this.getMsidValue(s[0],s[0],n.label))}):n.xSsrcRange&&this.addStream(n,n.xSsrcRange.ssrcMin,MKe,this.getMsidValue(n.xSsrcRange.ssrcMin,n.xSsrcRange.ssrcMin,n.label))}}delete n.xSsrcRange}toMsSdp(n,a){if(n.port===0)return;let s;n.ssrcs?.[0]&&(s=n.ssrcs[0].id),s!==void 0&&(n.xMultiStream||(n.xSsrcRange={ssrcMin:s,ssrcMax:s+a}))}getFlowSsrcs(n){if(n.ssrcGroups&&n.type===ke.MEDIA_TYPE.video){let a;if(n.ssrcGroups.some(s=>s.semantics==="FID"&&(a=s,!0)),a)return a.ssrcs.split(" ").map(s=>+s)}return[]}addStream(n,a,s,c){n.ssrcs=n.ssrcs||[],n.ssrcs.push({attribute:"cname",id:a,value:s}),n.ssrcs.push({attribute:"msid",id:a,value:c})}updateMsids(n,a){n.filter(s=>s.attribute==="msid").forEach(s=>{const c=s.value.split(" ");s.value=a(c[0],c[1]||c[0])})}getMsidValue(n,a,s){const c=this.getMsidPrefix(s);return c+n+" "+c+a}getMsidPrefix(n){return RKe[n]?RKe[n]+Gne.STREAM_ID_DELIMITER:""}isRecvOnly(n){return n.direction==="recvonly"}},PKe={audio:"main-audio",video:"main-video"},DKe=class{constructor(n,a){this.context=n,this.mediaManager=a,this.logger=this.context.logger,this.candidateTransform=nbi.build(),this.streamTransform=new obi(this.context.configuration),this.rtcpTransform=rbi.build()}toMsSdp(n,a){return n.msidSemantic={semantic:"WMS",token:"*"},n.media.forEach((s,c)=>{if(s.protocol=ke.PROFILES.rtpSavp,s.label=s.label||this.getLabel(s.type),$S(s)){for(const m in s)s.hasOwnProperty(m)&&["type","port","protocol","payloads"].indexOf(m)<0&&delete s[m];s.payloads="34"}const u=this.getSsrcRangeForIndex(s.direction,c);this.streamTransform.toMsSdp(s,u),s.crypto&&s.crypto.forEach(function(m){m.config+="|2^31"}),s.port!==0&&n.fingerprint&&(s.fingerprint=n.fingerprint),this.candidateTransform.toMsSdp(s,n),this.rtcpTransform.toMsSdp(s,a),s.invalid&&(this.logger.unsafe.error(`Unknown SDP attributes! ${JSON.stringify(s.invalid)}`),delete s.invalid),this.transformExtensions(s,!1),s.port!==0&&(s.type===ke.MEDIA_TYPE.audio&&this.context.configProvider.config.webrtcAudioChannelSignalingFeedback?s.signalingFbXMessage={payload:"*",param:this.context.configProvider.config.webrtcAudioChannelSignalingFeedback}:s.type===ke.MEDIA_TYPE.video&&this.context.configProvider.config.webrtcVideoChannelSignalingFeedback&&(s.signalingFbXMessage={payload:"*",param:this.context.configProvider.config.webrtcVideoChannelSignalingFeedback}))}),delete n.fingerprint,n}fromMsSdp(n,a){for(let s=n.media.length-1;s>=0;--s){const c=n.media[s];if((c.ssrcs?.[0]||c.xSsrcRange)&&(n.msidSemantic={semantic:"WMS",token:"*"}),$S(c))c.direction||(c.direction="inactive");else{if(this.streamTransform.fromMsSdp(c),delete c.cryptoscale,c.fingerprint&&(!this.isOffer(a)||this.context.configProvider.config.disableIncomingDtlsRoleOverride&&c.setup||(c.setup="actpass")),c.crypto)for(let u=c.crypto.length-1;u>=0;--u){const m=c.crypto[u];m.config.match(/.*\|\d+:\d+/)?c.crypto.splice(u,1):m.config=m.config.replace(/(.*)\|2\^\d+/,"$1")}c.remoteCandidates&&(delete c.candidates,delete c.xCandidatesIpv6,delete c.remoteCandidates),this.candidateTransform.fromMsSdp(c),c.rtcpFbXMessage&&delete c.rtcpFbXMessage,c.invalid&&this.logger.unsafe.info(`Unknown SDP attributes! ${JSON.stringify(c.invalid)}`),this.transformExtensions(c,!0)}}return n}transformExtensions(n,a){const s=[{name:ke.ABS_SEND_TIME.EXT_URI,encoded:ke.ABS_SEND_TIME.MSSDP_ENCODED_URI},{name:ke.TRANSPORT_CC.EXT_URI,encoded:ke.TRANSPORT_CC.MSSDP_ENCODED_URI}];n.ext&&n.ext.forEach(function(c){s.some(function(u){const m=a?u.encoded:u.name,b=a?u.name:u.encoded;return m===c.uri&&(c.uri=b,!0)})})}isOffer(n){return n==="offer"}getLabel(n){return PKe.hasOwnProperty(n)&&PKe[n]||"undefined"}getSsrcRangeForIndex(n,a){const s=this.mediaManager.getMediaEntities()[a],c=s?.getSimulcastContext();return Ur(n)&&c?c.getSsrcRange():0}},_Te=4294967040,ETe=class{constructor(){this.ssrc=Math.floor(Math.random()*(_Te-1))+1}nextAudioStreamSsrc(){return this.nextSsrc(0)}nextVideoStreamSsrc(){return this.nextSsrc(99)}nextSsrc(n){let a=this.ssrc;do a=this.ssrc,this.ssrc=(this.ssrc+n+1)%_Te,this.ssrc===0&&(this.ssrc=1);while(a+n>_Te);return{min:a,max:a+n}}},sbi=dn,lbi=class{constructor(n,a,s){this.mediaEntity=n,this.logger=a,this.configProvider=s,this.activeRids=[],this.isLocalDescSet=!1,this.enabledLocally=!1,this.enabledRemotely=!1;const c=kN(this.mediaEntity.getModality());this.config=cbi(c,this.configProvider),this.config?this.logger.safe.debug(`Adding simulcast info to ${n.getModality()} with mid: ${n.getMid()}, config: ${JSON.stringify(this.config)}`):this.logger.safe.debug(`Simulcast is disabled for ${n.getModality()}`)}get ridList(){return this.config?(0,sbi.times)(this.config.layerScaleFactors.length,n=>n+1):[]}localDescriptionIsApplied(){this.isLocalDescSet=!0}enableInLocalDesc(){this.enabledLocally=!0}shouldBeEnabledInLocalDesc(){return!!this.config&&(this.config.enableLocally||this.enabledRemotely)}enableInRemoteDesc(){this.enabledRemotely=!0}shouldBeEnabledInRemoteDesc(){return!!this.config&&(this.enabledLocally||this.config.allowEnableRemotely&&this.isMidRidHeaderExtPresented()&&!this.isLocalDescSet)}shouldUseSimulcast(){return this.shouldBeEnabledInLocalDesc()}getSsrcRange(){return this.shouldUseSimulcast()?99:0}isMidRidHeaderExtPresented(){return this.mediaEntity.getRtpHeaderExtensions()?.some(a=>a.headerType==="mid"||a.headerType==="rid"||a.headerType==="rrid")}};function cbi(n,a){return n==="Video"?a.config.specCompliantSimulcast?.video:n==="ScreenShare"?a.config.specCompliantSimulcast?.sharing:null}var dbi=dn,ubi=[2812,4218,8437,16875,33750,67500,108e3,135e3,198e3,244800,27e4,352500,52e4],hbi=class{constructor(n,a,s,c){this.initialMaxFS=n,this.initialMaxFPS=a,this.isAv1Allowed=s,this.h264SubscribeProfile=c,this.maxFS=n,this.maxFPS=a}setMaxFS(n,a){return!(this.maxFS===n||(this.maxFS=n,!a)||(a(this),0))}getMaxFS(){return this.maxFS}getMaxFPS(){return this.maxFPS}getMaxMBPS(){return this.calculateMbps(this.maxFS,this.maxFPS)}calculateMbps(n,a){return pV(ubi,n*a/100,!0)}resetToInitial(){this.maxFS=this.initialMaxFS,this.maxFPS=this.initialMaxFPS}fmtpParams(){return{"max-fs":this.getMaxFS(),"max-mbps":this.getMaxMBPS(),"max-fps":this.getMaxFPS()}}buildFmtp(){const n=[];let a=this.fmtpParams();return this.h264SubscribeProfile&&(a["profile-level-id"]=this.h264SubscribeProfile),n.push(a),this.isAv1Allowed&&(a=this.fmtpParams(),a.codec="AV1",n.push(a)),n}},LKe=class Tq{constructor(a,s){this.entity=a,this.configProvider=s,this.supportedSendProfiles={}}toString(){return`MediaEntity: ${this.entity.modality} 
mid: ${this.entity.mid} localRecvCaps: ${JSON.stringify(this.localRecvCapabilities?.buildFmtp())}  remoteRecvCaps: ${JSON.stringify(this.remoteRecvCapabilities)}  localSsrc: ${this.getLocalSsrc()} remoteSsrc: ${this.getRemoteSsrc()} localTrackId: ${this.getLocalTrackId()} remoteStreamId: ${this.getRemoteStreamId()} remoteTrackId: ${this.getRemoteTrackId()} xSourceStreamId: ${this.getXSourceStreamId()} subStreamIndex: ${this.getSubstreamIndex()} extensions: ${JSON.stringify(this.entity.extensions)} rtpExt: ${JSON.stringify(this.entity.rtpExt)}         `}static getVideoCababilities(a,s,c){if(a!==ke.MEDIA_TYPE.video)return null;let u,m;s===ke.MODALITY.sharing?(u=c.config.webrtcScreensharingCapabilityMaxFS,m=c.config.webrtcScreensharingCapabilityMaxFPS):(u=c.config.webrtcVideoCapabilityMaxFS,m=c.config.webrtcVideoCapabilityMaxFPS,c.config.useMultiviewLimitsOnInitialRequest&&c.config.multiviewResolutionLimits[1]&&(u=yl.Send.getMaxFsForHeight(c.config.multiviewResolutionLimits[1])));const b=c.config.isAv1Allowed&&s===ke.MODALITY.sharing;return new hbi(u,m,b,c.config.h264SubscribeProfile)}static create(a,s,c){const u=ZSi(s),m=new Tq({modality:s,mid:c,mtype:u,extensions:{}},a);return m.localRecvCapabilities=Tq.getVideoCababilities(u,s,a),m}clone(){const a=new Tq((0,dbi.cloneDeep)(this.entity),this.configProvider);return a.setSimulcastContext(this.simulcastContext),a.localRecvCapabilities=this.localRecvCapabilities,a.remoteRecvCapabilities=this.remoteRecvCapabilities,a.supportedSendProfiles=this.supportedSendProfiles,a}getModality(){return this.entity.modality}getType(){return this.entity.mtype}getMid(){return this.entity.mid}disable(){this.entity.mid=null}update(a,s){this.entity.modality!==a&&(this.localRecvCapabilities=Tq.getVideoCababilities(this.entity.mtype,a,this.configProvider)),this.entity.modality=a,this.entity.mid=s,this.isEnabled()&&this.setExtension("rollback",!1)}isDisabled(){return!this.entity.mid}isEnabled(){return!!this.entity.mid}getLocalRecvCapabilities(){return this.localRecvCapabilities}getRemoteRecvCapabilities(){return{sourceId:this.getXSourceStreamId(),capabilities:this.remoteRecvCapabilities?[this.remoteRecvCapabilities]:[]}}setRemoteRecvCapabilities(a){this.remoteRecvCapabilities=a}getRemoteStreamId(){return this.entity.remoteStreamId}setRemoteStreamId(a){this.entity.remoteStreamId=a}setRemoteSsrc(a){this.entity.remoteSsrc=a}getRemoteSsrc(){return this.entity.remoteSsrc}setLocalSsrc(a){this.entity.localSsrc=a}getLocalSsrc(){return this.entity.localSsrc}getRemoteTrackId(){return this.entity.remoteTrackId}setRemoteTrackId(a){this.entity.remoteTrackId=a}getXSourceStreamId(){return this.entity.xSourceStreamId}setXSourceStreamId(a){this.entity.xSourceStreamId=a}setLocalTrackId(a){this.entity.localTrackId=a}getLocalTrackId(){return this.entity.localTrackId}setSubStreamIndex(a){this.entity.subStreamIndex=a}getSubstreamIndex(){return this.entity.subStreamIndex}getExtension(a){return this.entity.extensions[a]}setExtension(a,s){this.entity.extensions[a]=s}getRtpHeaderExtensions(){return this.entity.rtpExt}setRtpHeaderExtensions(a){this.entity.rtpExt=a}setSimulcastContext(a){this.simulcastContext=a}getSimulcastContext(){return this.simulcastContext}addSupportedSendProfile(a,s){this.supportedSendProfiles[a]===void 0&&(this.supportedSendProfiles[a]=new Set),this.supportedSendProfiles[a].add(s)}isSendProfileSupported(a,s){const c=this.supportedSendProfiles[a];if(c!==void 0){const u=s.slice(0,2);for(const m of c)if(m.startsWith(u))return!0}return!1}serialize(){return fs(this.entity)}},pbi={toffset:"toffset","abs-send-time":"abs-send-time","video-orientation":"video-orientation","draft-holmer-rmcat-transport-wide-cc-extensions-01":"transport-cc","video-content-type":"video-content-type","video-timing":"video-timing","color-space":"color-space","video-layers-allocation00":"vla","video-layers-allocation00-non-advertised":"non-adv-vla",mid:"mid","rtp-stream-id":"rid","repaired-rtp-stream-id":"rrid","fast_bandwidth_feedback#version_3":"fast_bandwidth_feedback#version_3","frame-counters-gvc":"frame-counters-gvc"},gbi=class{constructor(n){this.context=n,this.mediaEntities=[],this.mediaEntitiesBackup=[],this.mediaTracks=[],this.ssrcGenerator=new ETe,this.rollbackHandlers=[],this.logger=n.logger.createChild("MM2"),this.configProvider=n.configProvider}fromOffer(n,a,s=!1){this.logger.safe.debug(`fromOffer, modalities: ${JSON.stringify(a)} disableOnly: ${s}`),this.updateMediaEntitiesFromModel(n,s),this.updateSharingEntity(!!a.sharing),n.media.forEach(c=>{this.logger.safe.debug(`Media entity for mid: ${c.mid}, ${this.getMediaEntityByMid(c.mid)}`);const u=this.getMediaEntityByMid(c.mid);u&&this.saveLocalSsrc(u,c)})}fromRemote(n,a){const s=this.mediaEntities.length===0;this.updateMediaEntitiesFromModel(n,!1,a),n.media.forEach((c,u)=>{const m=this.getMediaEntityByMid(c.mid);m&&(this.saveRemoteMsid(m,c),this.saveRemoteSsrc(m,c),this.saveRtpHeaderExtensions(m,c),m.setXSourceStreamId(c.xSourceStreamId||this.generateSourceStreamId(u)),m.setRemoteRecvCapabilities(CTe(c)),m.setSubStreamIndex(c.subStreamIndex)),this.logger.safe.debug(`Media entity for mid: ${c.mid}, ${m}`)}),s&&this.updateReinvitelessState(n)}isEmpty(){return this.mediaEntities.length===0}createMediaEntity(n,a){const s=LKe.create(this.configProvider,n,a);return this.logger.safe.debug(`Creating media entity for modality: ${n}, mid: ${a}`),this.context.useSimulcast&&!this.mediaEntities.find(c=>c.getModality()===n)&&this.setSimulcastContext(s),s.setExtension("reinviteless",!1),this.mediaEntities.push(s),s}getMediaEntities(){return this.mediaEntities}getMediaEntity(n){return this.mediaEntities[n]}getMediaEntityByMid(n){return this.mediaEntities.find(a=>a.getMid()===n)}getMediaEntitiesByModality(n){return this.mediaEntities.filter(a=>a.getModality()===n)}getMediaEntitiesByMediaType(n){const a=kN(n);return this.getMediaEntitiesByModality(a)}getMediaEntityByRemoteStreamId(n){return this.mediaEntities.find(a=>a.getRemoteStreamId()===n)}getMediaEntityByLocalTrackId(n){return this.mediaEntities.find(a=>a.getLocalTrackId()===n)}getMediaEntityByXSourceStreamId(n){return this.mediaEntities.find(a=>a.getXSourceStreamId()===n)}reset(){this.mediaEntities=[],this.rollbackHandlers=[]}syncModalities(n,a,s=!1){this.logger.safe.debug(`syncModalities, modalities: ${JSON.stringify(a)}, disableOnly: ${s},`),this.fromOffer(n,a,s)}setLocalTracksInfo(n){this.mediaTracks=n}getLocalTracksInfo(){return this.mediaTracks}backup(){this.logger.safe.debug("backup"),this.mediaEntitiesBackup=[],this.mediaEntities.forEach(n=>{this.mediaEntitiesBackup.push(n.clone())})}commit(){this.mediaEntitiesBackup=[],this.mediaEntities.forEach(n=>{n.setExtension("unnegotiatedModality",!1)})}rollback(){this.logger.safe.debug(`rollback, if backup exists: ${!!this.mediaEntitiesBackup.length}`),this.mediaEntitiesBackup.length&&(this.rollbackHandlers.forEach(n=>n(this.mediaEntities,this.mediaEntitiesBackup)),this.mediaEntities.forEach((n,a)=>{this.mediaEntitiesBackup[a]?this.mediaEntities[a]=this.mediaEntitiesBackup[a]:(n.disable(),n.setExtension("rollback",!0))}))}updateMediaEntitiesWithLocalTracks(){this.mediaTracks?(this.mediaEntities.forEach(n=>n.setLocalTrackId(null)),this.mediaTracks.forEach(n=>{const a=this.getMediaEntitiesByModality(n.modality)[0];a?(this.logger.safe.debug(`Setting local track id ${n.trackId} for modality ${n.modality}`),a.setLocalTrackId(n.trackId)):this.logger.safe.error(`Media entity is not found for modality: ${JSON.stringify(n.modality)}`)})):this.logger.safe.debug("No mediaTracks, not updating local tracks for media entities")}updateMediaEntitiesWithActivityState(n,a){this.logger.safe.debug(`Updating activity indexes for ${n} to ${JSON.stringify(a)}`);const s=KR(n),c=this.getMediaEntitiesByModality(s)[0];if(!c)return void this.logger.safe.error(`Media entity is not found for modality: ${JSON.stringify(s)}`);const u=c.getSimulcastContext();u&&(u.activeRids=a)}setRollbackUpdateHandler(n){this.rollbackHandlers.push(n)}saveRtpHeaderExtensions(n,a){if(n.isDisabled())return void n.setRtpHeaderExtensions(void 0);const s=a.ext?.map(c=>this.getHeaderExtension(c));this.logger.safe.debug(`RTP header ext for mid=${a.mid}, modality=${n.getModality()}: ${JSON.stringify(s)}`),n.setRtpHeaderExtensions(s)}getHeaderExtension(n){let a="unknown";for(const[s,c]of Object.entries(pbi))if(n.uri.endsWith(s)){a=c;break}return{headerType:a,value:n.value}}saveRemoteMsid(n,a){if($S(a))n.setRemoteStreamId(null);else if(a.msid)n.setRemoteStreamId(a.msid.split(" ")[0]);else if(a.ssrcs){const s=a.ssrcs.find(c=>c.attribute==="msid");s?n.setRemoteStreamId(s.value.split(" ")[0]):this.logger.safe.warn(`No ssrc msid for media of type ${a.type} with mid ${a.mid}`)}}saveRemoteSsrc(n,a){if(a.ssrcs?.length){const s=a.ssrcs[0];n.setRemoteSsrc(+s.id)}}saveLocalSsrc(n,a){const s=a.ssrcs?.[0]?.id;if(!Ur(a.direction))return this.logger.safe.debug(`set local SSRC to ${s}`),void n.setLocalSsrc(+s);this.logger.safe.debug("has no send direction");const c=s||n.getLocalSsrc()||this.ssrcGenerator.nextVideoStreamSsrc().min;n.setLocalSsrc(+c)}updateMediaEntitiesFromModel(n,a,s){n.media.forEach((c,u)=>{if(this.mediaEntities[u])if($S(c))this.logger.safe.debug(`Disabling media entity for mid: ${c.mid}`),this.mediaEntities[u].disable();else{const m=c.mid||this.mediaEntities[u].getMid(),b=this.mediaEntities[u].getModality();this.logger.safe.debug(`Updating media entity for mid: ${m}, modality: ${b}`),this.mediaEntities[u].update(b,m),this.logger.safe.debug(`updated entity: ${this.mediaEntities[u]}`)}else a||this.createMediaEntity(GN(c),c.mid||u.toString());this.mediaEntities[u]&&s&&!(this.mediaEntities[u].getModality()in s)&&(this.logger.safe.debug(`Disabling media entity for mid: ${c.mid} as it is not found in modalities ${JSON.stringify(s)}`),this.mediaEntities[u].disable())})}updateSharingEntity(n){if(n&&!this.getMediaEntitiesByModality(ke.MODALITY.sharing).length){const a=this.getMediaEntitiesByModality(ke.MODALITY.video).pop();a.update(ke.MODALITY.sharing,a.getMid())}}setSimulcastContext(n){if(!n||n.getSimulcastContext())return;const a=new lbi(n,this.logger.createChild(`SimContext:${n.getModality()}`),this.configProvider);n.setSimulcastContext(a)}generateSourceStreamId(n){return n+10}updateReinvitelessState(n){const a={[ke.MODALITY.audio]:0,[ke.MODALITY.video]:0,[ke.MODALITY.sharing]:0};for(const s of n.media){const c=GN(s);a[c]!==void 0&&a[c]++;const u=this.getMediaEntityByMid(s.mid);if(u){const m=this.context.reinviteltessContext?.maxStreamsForModality[c]>=a?.[c]&&(!s.direction||s.direction==="sendrecv");u.setExtension("reinviteless",m)}}}},ATe=class{constructor(n){this.modifierList=n}modify(n){for(const a of this.modifierList)a.modify(n)}},mbi=class{constructor(n,a,s,c){this.context=n,this.mediaManager=a,this.modalities=s,this.cname=c}build(n){switch(n.sdpSource){case 0:return new ATe([new GKe(this.context.configProvider),new Nbi(this.context.configProvider),new aTi(this.mediaManager,this.context.configProvider),new nTi(this.mediaManager),new zbi(this.context.configProvider),new Bbi(this.context.configProvider),new jKe(this.context.configProvider,this.mediaManager,n.sdpType,!1,this.context.getLogger().createChild("OverrideH264SendProfile")),new UKe(this.mediaManager,this.context.configProvider,n.sdpType),new FKe(this.mediaManager,this.context.configProvider,this.context.config.isConference,!1),new pTi(this.context.configProvider,n.sdpType),new HKe(this.context.configProvider)]);case 2:return new ATe([new OKe(this.mediaManager,this.modalities),new xbi,new NKe(this.mediaManager,!0),new Qbi(this.context.configProvider,this.mediaManager),new Abi(this.modalities,this.mediaManager),new Hbi,new $Ke,new Vbi,new $bi(this.context.configProvider),new Ubi(this.context.configProvider),new Jbi(this.context.configProvider),new jKe(this.context.configProvider,this.mediaManager,n.sdpType,!0,this.context.getLogger().createChild("OverrideH264SendProfile")),new wbi,new ybi(this.context),new tTi(this.mediaManager,this.context.configProvider),new Obi(this.context.configProvider),new lTi,new sTi(this.context.configProvider),new rTi(this.context.configProvider),new Mbi(this.mediaManager,this.modalities,this.context.configProvider),new Ebi(this.context),new cTi(this.context.configProvider),new Cbi(this.context.configProvider),new UKe(this.mediaManager,this.context.configProvider,n.sdpType),new zKe(this.mediaManager,this.context.configProvider,n.sdpType),new FKe(this.mediaManager,this.context.configProvider,this.context.config.isConference,!0),new Gbi(this.context.configProvider,this.context.getLogger()),new Rbi,new uTi(this.context.configProvider),new HKe(this.context.configProvider),new gTi(n,this.context),new Xbi(this.context.configProvider),new ITe(this.context.configProvider)]);case 1:return new ATe([new xKe(this.context,this.modalities.data),new NKe(this.mediaManager,!1),new Pbi(this.context.configProvider),new OKe(this.mediaManager,this.modalities),new kbi(this.mediaManager),new $Ke,new Fbi(this.context.configProvider),new Sbi(this.mediaManager,n.sdpType==="offer",this.context.configProvider),new iTi(this.mediaManager,this.context.getLogger()),new oTi(this.context.configProvider,this.mediaManager),new Ibi(this.context.config.isConference,this.cname),new Dbi(this.mediaManager),new Lbi,new qKe(this.context.configProvider),new _bi(this.context.configProvider),new dTi(this.context.configProvider),new hTi(this.context.configProvider),new zKe(this.mediaManager,this.context.configProvider,n.sdpType),new Kbi(this.mediaManager,this.context.configProvider,n.sdpType),new ITe(this.context.configProvider)])}}},fbi=class{constructor(n,a,s){this.context=n,this.mediaManager=a,this.sessionType=s,this.msSdpT=new DKe(this.context,this.mediaManager)}modify(n){this.msSdpT.toMsSdp(n,this.sessionType)}},vbi=class{constructor(n,a,s){this.context=n,this.mediaManager=a,this.sessionType=s,this.msSdpT=new DKe(this.context,this.mediaManager)}modify(n){this.msSdpT.fromMsSdp(n,this.sessionType)}},ybi=class{constructor(n){this.context=n}modify(n){const a=l9(this.context.configProvider,this.context.config.isPstnCall),s=Xte(n),c=n.media.find(u=>!!u.crypto);n.media.forEach(u=>{u.type!==ke.MEDIA_TYPE.dataChannel&&(!a&&u.fingerprint&&u.crypto&&delete u.crypto,u.protocol=!s.dtls||s.sdes&&a?ke.PROFILES.rtpSavpf:ke.PROFILES.udpTlsRtpSavpf,$S(u)&&u.protocol===ke.PROFILES.rtpSavpf&&c&&(u.crypto=c.crypto))})}},Sbi=class{constructor(n,a,s){this.mediaManager=n,this.isOffer=a,this.configProvider=s}modify(n){n.media.forEach((a,s)=>{const c=a.setup,u=this.mediaManager.getMediaEntities()[s],m=u.getExtension("setup");c&&u.isEnabled()&&(c!=="actpass"?u.setExtension("setup",c):this.isOffer&&m!==void 0&&m!=="actpass"&&!this.configProvider.config.disableOutgoingDtlsRoleOverride&&(a.setup=m))})}},bbi=class{modify(n){n.media.forEach(a=>{a.direction===ke.MEDIA_STATE.sendReceive&&(a.direction=ke.MEDIA_STATE.receive),a.direction===ke.MEDIA_STATE.send&&(a.direction=ke.MEDIA_STATE.inactive)})}},OKe=class{constructor(n,a){this.mediaManager=n,this.modalities=a}modify(n){let a=0;n.media.forEach((s,c)=>{const u=parseInt(s.mid,10);!isNaN(u)&&u>=a&&(a=u+1)}),n.media.forEach((s,c)=>{const u=this.mediaManager.getMediaEntities()[c];if($S(s)||u.isDisabled()||!(u.getModality()in this.modalities)){const m=u.getExtension("midApplied")?void 0:s.mid||""+a++;c===0?s.direction=ke.MEDIA_STATE.inactive:n.media[c]=qne(s.type,void 0,s.protocol,m)}})}},NKe=class{constructor(n,a){this.mediaManager=n,this.remote=a}modify(n){const a=this.mediaManager.getMediaEntities();for(let s=0;s<a.length;s++){const c=a[s],u=n.media[s];if(c.getExtension("rollback")){if(u&&!this.remote)n.media[s]=null;else if(!u&&this.remote){const m=c.getType()===ke.MEDIA_TYPE.data?ke.MEDIA_TYPE.dataChannel:c.getType(),b=m===ke.MEDIA_TYPE.dataChannel?ke.PROFILES.udpDtlsSctp:ke.PROFILES.udpTlsRtpSavpf;n.media.push(qne(m,void 0,b,void 0))}}}n.media=n.media.filter(s=>s)}},Tbi=class{constructor(n){this.mediaManager=n}modify(n){this.mediaManager.getMediaEntities().forEach((a,s)=>{const c=n.media[s];a.getModality()!==ke.MODALITY.data||c&&c.type===ke.MEDIA_TYPE.dataChannel||n.media.splice(s,0,qne(ke.MEDIA_TYPE.data,ke.MEDIA_LABEL.data,ke.PROFILES.rtpSavp,void 0))})}},xKe=class{constructor(n,a){this.context=n,this.direction=a}modify(n){n.media.forEach(a=>{a.type===ke.MEDIA_TYPE.dataChannel&&(a.type=ke.MEDIA_TYPE.data,a.payloads=ke.PAYLOAD_TYPE.X_DATA)}),z2(this.context)&&wm(n,ke.MEDIA_TYPE.data).forEach(a=>{a.rtp=a.rtp||[],a.fmtp=a.fmtp||[],a.rtp.push({codec:"x-data",payload:127,rate:9e4}),a.rtp.push({codec:"rtx",payload:126,rate:9e4}),a.fmtp.push({payload:126,config:"apt=127"});const s=this.getNonOverlappingSsrc(n);a.xSsrcRange={ssrcMin:s,ssrcMax:s},a.rtcpMux="rtcp-mux",a.xDataProtocol="sctp",a.direction=this.direction})}getNonOverlappingSsrc(n){let a,s=!0;do a=Math.floor(4294967293*Math.random())+2,wm(n).forEach(c=>{c?.ssrcs?.[0]?.id===a&&(s=!1)});while(!s);return a}},BKe=class{constructor(n){this.configProvider=n,this.uri="urn:3gpp:video-orientation",this.value=13}modify(n){if(this.configProvider.config.enableVideoOrientationExtension)for(const a of wm(n,ke.MEDIA_TYPE.video))this.modifyMedia(a)}},Cbi=class extends BKe{modifyMedia(n){n.ext??(n.ext=[]),n.ext.some(a=>a.uri===this.uri)||n.ext.push({value:this.getAvailableValue(n.ext),uri:this.uri})}getAvailableValue(n){const a=n.map(s=>s.value);return a.includes(this.value)?Math.max(...a)+1:this.value}},_bi=class extends BKe{modifyMedia(n){n.ext=n.ext?.filter(a=>a.uri!==this.uri)}},Ebi=class{constructor(n){this.context=n}modify(n){const a=n.groups?.find(s=>s.type==="BUNDLE");for(let s=n.media.length-1;s>=0;s--){const c=n.media[s];if(c.type===ke.MEDIA_TYPE.data){const u=this.context.configProvider.config.rejectUnbundledDataModality&&!this.context.configProvider.mediaConfig.isTransportUnbundled&&!a?.mids?.toString().includes(c.mid),m=z2(this.context);m||this.context.configProvider.config.acceptDisabledDataModality?(c.port=m&&!u?c.port:0,c.payloads=ke.PAYLOAD_TYPE.DATA_CHANNEL,c.type=ke.MEDIA_TYPE.dataChannel,c.protocol=ke.PROFILES.udpDtlsSctp,c.sctpPort??(c.sctpPort=this.context.configProvider.config.sctpPort),delete c.xDataProtocol,delete c.rtp,delete c.fmtp,delete c.rtcp,delete c.rtcpMux,delete c.ext,delete c.ssrcs,delete c.ssrcGroups,delete c.xSsrcRange):n.media.splice(s,1)}}}},Abi=class{constructor(n,a){this.modalities=n,this.mediaManager=a}modify(n){wm(n).forEach(a=>{const s=GN(a),c=this.mediaManager.getMediaEntityByMid(a.mid);!(this.modalities[s]!==ke.MEDIA_STATE.send||c.getExtension("reinviteless")||a.direction&&a.direction.toLowerCase()===ke.MEDIA_STATE.receive)&&(a.direction=ke.MEDIA_STATE.receive)})}},Ibi=class{constructor(n,a){this.isMultiparty=n,this.cname=a}modify(n){this.isMultiparty&&wm(n).forEach(a=>{const s=a.direction;s!==ke.MEDIA_STATE.receive&&s!==ke.MEDIA_STATE.inactive||(a.ssrcs?.[0]?a.ssrcs=[{id:a.ssrcs[0].id,attribute:"cname",value:this.cname}]:a.type===ke.MEDIA_TYPE.audio?a.ssrcs=[{id:4195875351,attribute:"cname",value:this.cname}]:a.type===ke.MEDIA_TYPE.video&&(a.ssrcs=[{id:1,attribute:"cname",value:this.cname}]))})}},wbi=class{modify(n){const a=new Set;wm(n,ke.MEDIA_TYPE.video).forEach(c=>{c.ssrcs&&c.ssrcs.length>1&&a.add(+c.ssrcs[0].id)});const s=wm(n,ke.MEDIA_TYPE.video).find(c=>c.direction===ke.MEDIA_STATE.sendReceive||c.direction===ke.MEDIA_STATE.send);wm(n,ke.MEDIA_TYPE.video).forEach(c=>{const u=c.direction;if((u===ke.MEDIA_STATE.receive||u===ke.MEDIA_STATE.inactive)&&c.ssrcs&&c.ssrcs.length===1){const m=c.ssrcs[0].id;(m===1||s&&s.ssrcs[0].id===m||!s&&a.has(m))&&(delete c.ssrcs,delete c.ssrcGroups)}})}},kbi=class{constructor(n){this.mediaManager=n}modify(n){n.media.forEach((a,s)=>{const c=this.mediaManager.getMediaEntities()[s];a.label=jne(c.getModality())})}},Rbi=class{modify(n){n.media.forEach(a=>{delete a.label})}},Mbi=class{constructor(n,a,s){this.mediaManager=n,this.modalities=a,this.configProvider=s}modify(n){let a=this.configProvider.mediaConfig.maxBandwidthInKbps;const s=n.bandwidth?.find(b=>b.type==="CT");s&&(!a||a>+s.limit)&&(a=+s.limit);const c=this.configProvider.config.audioBandwidthInKbps||0,u=Math.max(a-c,0),m=this.configProvider.config.videoBandwidthAllocation&&Ur(this.modalities.video)&&Ur(this.modalities.sharing);wm(n,ke.MEDIA_TYPE.video).forEach(b=>{if(delete b.bandwidth,u){let _=u;if(m){const k=this.mediaManager.getMediaEntityByMid(b.mid).getModality()===ke.MODALITY.video?this.configProvider.config.videoBandwidthAllocation:1-this.configProvider.config.videoBandwidthAllocation;_=Math.round(u*k)}b.bandwidth=[{limit:_,type:"AS"}]}})}},Pbi=class{constructor(n){this.configProvider=n}modify(n){const a=this.configProvider.mediaConfig.maxBandwidthInKbps;a&&(n.bandwidth=[{limit:a,type:"CT"}])}},Dbi=class{constructor(n){this.mediaManager=n}modify(n){n.media.forEach((a,s)=>{const c=this.mediaManager.getMediaEntities()[s],u=c.getExtension("iceUfrag");c.setExtension("iceRestart",!!a.iceUfrag&&!!u&&u!==a.iceUfrag),c.setExtension("iceUfrag",a.iceUfrag)})}},Lbi=class{modify(n){const a=new Set(["urn:ietf:params:rtp-hdrext:csrc-audio-level","http://www.webrtc.org/experiments/rtp-hdrext/playout-delay"]);wm(n).forEach(s=>{s.ext&&(s.ext=s.ext.filter(c=>!a.has(c.uri)))})}},Obi=class{constructor(n){this.configProvider=n}modify(n){this.configProvider.config.extmapAllowMixed&&(n.extmapAllowMixed="extmap-allow-mixed")}},Nbi=class{constructor(n){this.configProvider=n}modify(n){this.configProvider.config.extmapAllowMixed||delete n.extmapAllowMixed}},xbi=class{modify(n){wm(n).forEach(a=>{delete a.signalingFbXMessage})}},FKe=class{constructor(n,a,s,c){this.mediaManager=n,this.configProvider=a,this.isConference=s,this.remote=c}modify(n){if(this.configProvider.config.isAv1Allowed&&this.isConference){const a=QSi(n,[96,127]);this.mediaManager.getMediaEntities().forEach((s,c)=>{let u=0;const m=n.media[c];if(s.getModality()!==ke.MODALITY.audio){if(!this.remote){const b=JKe(m,{codec:"AV1",rate:9e4},a,!0,u);u=a.length-1,b.forEach(_=>{JKe(m,{codec:"rtx",rate:9e4,payload:_+1},a,!1,u),u--})}this.remote&&this.configProvider.config.av1LevelIndex&&Hne(m,{codec:"AV1",rate:9e4},b=>{const _=(k,N)=>k.replace(/level-idx=\d+((\.\d+)+)?/g,`level-idx=${N}`);b.fmtp.config=_(b.fmtp.config,this.configProvider.config.av1LevelIndex)})}})}}},UKe=class{constructor(n,a,s){this.mediaManager=n,this.configProvider=a,this.sdpType=s,this.baseModifier=new VKe(this.mediaManager,this.configProvider,this.sdpType,!1)}modify(n){this.configProvider.config.filterCodecsInSdpV2||this.baseModifier.modify(n)}},zKe=class{constructor(n,a,s){this.mediaManager=n,this.configProvider=a,this.sdpType=s,this.baseModifier=new VKe(this.mediaManager,this.configProvider,this.sdpType,!0)}modify(n){this.configProvider.config.filterCodecsInSdpV2&&this.baseModifier.modify(n)}},VKe=class{constructor(n,a,s,c=!1){this.mediaManager=n,this.configProvider=a,this.sdpType=s,this.alwaysReorder=c}modify(n){this.configProvider.config.filterCodecsInSdp&&this.sdpType==="offer"&&this.mediaManager.getMediaEntities().forEach((a,s)=>{const c=n.media[s];if(!c)return;const u=nie(this.configProvider,c.type);u.length&&IKe(c,kye(u),!!a.getExtension("unnegotiatedModality")||this.alwaysReorder,null)})}},Bbi=class{constructor(n){this.configProvider=n}modify(n){const a=n.media.find(c=>c.type===ke.MEDIA_TYPE.audio);if(!a)return;const s=this.configProvider.mediaConfig.audioCodecContext;if(!s?.enabledLocally)return this.removeSubstitutionCodec(a,"SatinFB"),void this.removeSubstitutionCodec(a,"MUCHv2");s.codec!==s.lastUsedCodec&&s.lastUsedCodec!=="None"&&this.removeSubstitutionCodec(a,s.lastUsedCodec),s.enabledLocally&&!s.disabledRemotely&&this.addSubstitutionCodecIfNeeded(a,s.codec,n)}addSubstitutionCodecIfNeeded(n,a,s){if(this.isSubstitutionCodecAdded(n,a))return;const c=TTe(s);if(c===-1)return;const u=dM(a,"SUBSTITUTION");wTe(s,u.payload,c),_Ke(n,u)}removeSubstitutionCodec(n,a){Iw(n,dM(a,"SUBSTITUTION"))}isSubstitutionCodecAdded(n,a){let s=!1;return Lf(n,dM(a,"SUBSTITUTION"),()=>{s=!0}),s}},Fbi=class{constructor(n){this.configProvider=n}modify(n){const a=n.media.find(m=>m.type===ke.MEDIA_TYPE.audio);if(!a)return;const s=this.configProvider.mediaConfig.audioCodecContext;if(!s?.enabledLocally||s.disabledRemotely)return this.removeSubstitutionCodec(a,"SatinFB"),void this.removeSubstitutionCodec(a,"MUCHv2");const c=dM(s.codec,"SUBSTITUTION"),u=dM(s.codec,"CODEC");Lf(a,c,m=>{m.rtp.codec=u.codec,m.rtp.rate=u.rate,m.rtp.encoding=u.encoding,s.codec==="SatinFB"&&(m.fmtp={payload:u.payload,config:"decoderversion=1"})})}removeSubstitutionCodec(n,a){Iw(n,dM(a,"SUBSTITUTION"))}},Ubi=class{constructor(n){this.configProvider=n}modify(n){const a=n.media.find(b=>b.type===ke.MEDIA_TYPE.audio);if(!a)return;const s=this.configProvider.mediaConfig.audioCodecContext;if(!s?.enabledLocally)return this.removeCodec(a,"SatinFB"),void this.removeCodec(a,"MUCHv2");const c=dM(s.codec,"CODEC"),u=dM(s.codec,"SUBSTITUTION");let m=!1;Lf(a,c,b=>{s.enabledForSend&&(b.rtp.codec=u.codec,b.rtp.rate=u.rate,b.rtp.encoding=u.encoding,b.fmtp={payload:c.payload,config:"ptime=20"}),m=!0}),s.disabledRemotely=!m}removeCodec(n,a){Iw(n,dM(a,"CODEC")),Iw(n,dM(a,"SUBSTITUTION"))}},$Ke=class{modify(n){Iw(n.media.find(a=>a.type===ke.MEDIA_TYPE.audio),{codec:"CN",rate:16e3})}},zbi=class{constructor(n){this.configProvider=n}modify(n){const a=n.media.find(b=>b.type===ke.MEDIA_TYPE.audio),s=this.configProvider.mediaConfig.audioCodecContext;if(this.configProvider.config.fixOpusComfortNoise){if(!a||s&&(!s.enabledLocally||s.disabledRemotely))return}else if(!a||!s?.enabledLocally||s.disabledRemotely)return;let c=!1;const u={codec:"CN",rate:48e3};if(Lf(a,u,()=>{c=!0}),c)return;const m=TTe(n);m!==-1&&(this.configProvider.config.fixOpusComfortNoise?u.payload=m:(wTe(n,ke.PAYLOAD_TYPE.MSRTC_CNFB,m),u.payload=ke.PAYLOAD_TYPE.MSRTC_CNFB),_Ke(a,u))}},Vbi=class{modify(n){Iw(n.media.find(a=>a.type===ke.MEDIA_TYPE.audio),{codec:"g722",rate:8e3,encoding:2})}},$bi=class{constructor(n){this.configProvider=n}modify(n){const a=this.configProvider.config.enforceOpusFmtp;a&&Lf(n.media.find(s=>s.type===ke.MEDIA_TYPE.audio),{codec:"opus",rate:48e3,encoding:2},s=>{s.fmtp||(s.fmtp={payload:s.rtp.payload});const c=new sE(s.fmtp.config);Object.keys(a).forEach(u=>{c.removeIfPresent(u),c.setIfMissing(u,`${a[u]}`)}),s.fmtp.config=c.toString()})}},Hbi=class{modify(n){const a=n.media.find(s=>s.type===ke.MEDIA_TYPE.audio);if(a&&$S(a)){const s=n.media.find(c=>!!c.iceUfrag);s&&(a.port=9,a.direction="inactive",a.iceUfrag=s.iceUfrag,a.icePwd=s.icePwd,a.rtcpMux="rtcp-mux",s.crypto&&(a.crypto=s.crypto),s.fingerprint&&(a.fingerprint=s.fingerprint,a.setup=s.setup),a.rtp=[{payload:0,codec:"PCMU",rate:8e3}],a.payloads="0")}}},jbi=class{constructor(n){this.otherPartyCodecs=n}modify(n){const a=n.media.find(u=>u.type===ke.MEDIA_TYPE.audio),s=["cn","telephone-event"],c=a.rtp.filter(u=>this.otherPartyCodecs.indexOf(u.codec.toLowerCase())!==-1&&s.indexOf(u.codec.toLowerCase())===-1);if(c.length===0)throw new Error("there is no matching primary audio codec");a.rtp.filter(u=>u!==c[0]&&s.indexOf(u.codec.toLowerCase())===-1).forEach(u=>{Iw(a,u)})}},Gbi=class{constructor(n,a){this.configProvider=n,this.logger=a}modify(n){this.configProvider.config.webrtcInjectTransportCCAudio&&wm(n,ke.MEDIA_TYPE.audio).forEach(a=>{if(!a.ext?.find(b=>b.uri===ke.TRANSPORT_CC.EXT_URI))return void this.logger.safe.info("transport-cc ext not present in sdp, skipping injecting transport-cc attribute for audio");const c=a.rtp?.find(b=>b.codec.toLowerCase()==="opus");if(!c)return void this.logger.safe.info("opus codec not found, skipping injecting transport-cc attribute for audio");const u=c.payload;a.rtcpFb?.find(b=>b.type===ke.TRANSPORT_CC.ATTRIBUTE&&b.payload===u)?this.logger.safe.info("opus codec already has transport-cc attribute"):(a.rtcpFb=a.rtcpFb||[],a.rtcpFb.push({payload:u,type:ke.TRANSPORT_CC.ATTRIBUTE}),this.logger.safe.info("injected transport-cc attribute"))})}},qbi=class{constructor(n,a){this.mediaManager=n,this.configProvider=a}modify(n){n.media.forEach((a,s)=>{if($S(a)||a.type!==ke.MEDIA_TYPE.video)return;const c=this.mediaManager.getMediaEntities()[s];Lf(a,{codec:"h264",rate:9e4},u=>{const m=c.getLocalRecvCapabilities();if(!m)return;u.fmtp||(u.fmtp={payload:u.rtp.payload});const b=new sE(u.fmtp.config);this.configProvider.config.h264SdpProfile?(b.removeIfPresent("profile-level-id"),b.setIfMissing("profile-level-id",this.configProvider.config.h264SdpProfile)):b.setIfMissing("profile-level-id","42C02A"),b.setIfMissing("max-fs",m.getMaxFS().toString()),b.setIfMissing("max-mbps",m.getMaxMBPS().toString()),b.setIfMissing("max-fps",m.getMaxFPS().toString()),u.fmtp.config=b.toString()})})}},HKe=class{constructor(n){this.configProvider=n}modify(n){if(!this.configProvider.config.removeRtcpRsizeFromLocalSdp)return;const a=n.media.find(s=>s.type===ke.MEDIA_TYPE.audio);a?.rtcpRsize&&delete a.rtcpRsize}},Wbi=class{constructor(n){this.configProvider=n}modify(n){if(!this.configProvider.config.multiStreamSupported||this.configProvider.config.numVideoChannelsGvc<this.configProvider.config.nonMultiStreamChannels)return;let a=0;for(let ee=0;ee<n.media.length;ee++)if(J9(n.media[ee])==="Video"){if(n.media[ee].xMultiStream)break;a++}const s=n.media.findIndex(ee=>ee.xMultiStream),c=n.media[s];if(!c)return;const u=c.xMultiStream.startSsrc,m=c.xMultiStream.ssrcGroupRange,b=c.xMultiStream.ssrcRange;delete c.xMultiStream;const _=this.configProvider.config.numVideoChannelsGvc-a-1;c.subStreamIndex=_;const k=[];for(let ee=0;ee<_;ee++){const oe=(0,Y9.cloneDeep)(c);oe.mid=XSi(n),oe.xSourceStreamId=c.xSourceStreamId,oe.subStreamIndex=ee,k.push(oe.mid);const de=u+ee*b;oe.ssrcGroups=[{ssrcs:`${de} ${de+m}`,semantics:"FID"}],oe.xSsrcRange={ssrcMin:de,ssrcMax:de+b-1},n.media.splice(s+ee,0,oe)}const N=u+_*b;c.ssrcGroups=[{ssrcs:`${N} ${N+m}`,semantics:"FID"}],c.xSsrcRange={ssrcMin:N,ssrcMax:N+b-1};const W=n.groups.find(ee=>ee.mids.includes(c.mid));W.mids=`${W.mids} ${k.join(" ")}`}},Kbi=class{constructor(n,a,s){this.mediaManager=n,this.configProvider=a,this.type=s}modify(n){if(!this.configProvider.config.multiStreamSupported||this.configProvider.config.numVideoChannelsGvc<=this.configProvider.config.nonMultiStreamChannels+1)return;const s=this.mediaManager.getMediaEntitiesByModality(ke.MODALITY.video);let c=-1,u=-1;if(s.forEach((_,k)=>{const N=n.media.findIndex(W=>W.mid===_.getMid());k===this.configProvider.config.nonMultiStreamChannels-1&&(u=N),c=N}),c===-1||u===-1)return;const m=n.media[c];n.media.splice(u+1,c-u-1);const b=this.configProvider.config.numVideoChannelsGvc-this.configProvider.config.nonMultiStreamChannels;m.xMultiStream={numberOfStreams:b,startSsrc:1,ssrcRange:1,ssrcGroupRange:1},this.type==="answer"&&(m.xMultiStream.numberOfStreams=Math.min(b,this.configProvider.mediaConfig.multiStreamChannelsOffered),m.ssrcGroups&&delete m.ssrcGroups,m.xSsrcRange&&delete m.xSsrcRange)}},Jbi=class{constructor(n){this.configProvider=n}modify(n){wm(n,ke.MEDIA_TYPE.video).forEach(a=>{Lf(a,{codec:"h264",rate:9e4},s=>{if(s.fmtp){const c=new sE,u=new sE(s.fmtp.config);["level-asymmetry-allowed","packetization-mode","profile-level-id"].forEach(m=>{if(u.contains(m)){let b=u.get(m);m==="profile-level-id"&&(b=this.configProvider.config.h264SendProfileOverride||b),c.setIfMissing(m,b)}}),s.fmtp.config=c.toString()}})})}},jKe=class{constructor(n,a,s,c,u){this.configProvider=n,this.mediaManager=a,this.sdpType=s,this.remote=c,this.log=u}process(n,a,s){wm(n,ke.MEDIA_TYPE.video).forEach(c=>{J9(c)===a&&Lf(c,{codec:"h264",rate:9e4},u=>{if(u.fmtp){const m=new sE(u.fmtp.config),b=new sE;let _=!1;for(const k of m.names()){let N=m.get(k);if(k==="profile-level-id"){const W=this.mediaManager.getMediaEntities().filter(oe=>oe.getModality()===GN(c)).filter(oe=>oe.isEnabled()),ee=s(W,N);typeof ee==typeof N&&ee!==N&&(N=ee,_=!0)}b.setIfMissing(k,N)}_&&(u.fmtp.config=b.toString())}})})}modify(n){const a=this.configProvider.config.preferredH264SendProfileFallback,s=this.configProvider.config.preferredH264SharingSendProfile,c=this.configProvider.config.preferredH264VideoSendProfile;if(this.remote){const u=m=>(b,_)=>b.some(k=>k.isSendProfileSupported("H264",m))?(this.log.safe.info(`Overriding H264 send profile: ${_} => ${m}`),m):(this.log.safe.info(`Applying fallback H264 profile: ${_} => ${a}`),a);c&&this.process(n,"Video",u(c)),s&&this.process(n,"ScreenShare",u(s))}else this.sdpType==="answer"&&(c||s)&&this.configProvider.config.enableFallbackH264SendProfileForLocalAnswer&&this.process(n,"Video",(u,m)=>m===c||m===s?(this.log.safe.info(`Restoring fallback profile in local answer: ${m} => ${a}`),a):m)}},GKe=class{constructor(n){this.configProvider=n}modify(n){this.configProvider.config.enableH264SpsPpsIdrKeyframe&&wm(n,ke.MEDIA_TYPE.video).forEach(a=>{Hne(a,{codec:"h264",rate:9e4},s=>{if(s.fmtp){const c=new sE(s.fmtp.config);c.setIfMissing("sps-pps-idr-in-keyframe","1"),s.fmtp.config=c.toString()}})})}},qKe=class{constructor(n){this.configProvider=n}modify(n){this.configProvider.config.enableH264SpsPpsIdrKeyframe&&wm(n,ke.MEDIA_TYPE.video).forEach(a=>{Hne(a,{codec:"h264",rate:9e4},s=>{if(s.fmtp){const c=new sE(s.fmtp.config);c.removeIfPresent("sps-pps-idr-in-keyframe"),s.fmtp.config=c.toString()}})})}},ITe=class{constructor(n){this.configProvider=n}modify(n){const a=(n.groups||[]).findIndex(c=>c.type==="BUNDLE"),s=n.groups?n.groups[a]:void 0;s&&(this.configProvider.mediaConfig.isTransportUnbundled?(s.mids=this.createBundleFromMedia(wm(n,ke.MEDIA_TYPE.video)),s.mids||n.groups.splice(a,1)):s.mids=this.createBundleFromMedia(wm(n)))}createBundleFromMedia(n){return n.map(a=>a.mid?.toString()).filter(a=>a).join(" ")}},Ybi=class{modify(n){n.media.forEach(a=>{$S(a)&&a.bundleOnly&&(a.port=9,delete a.invalid)})}},Qbi=class{constructor(n,a){this.configProvider=n,this.mediaManager=a}modify(n){if(!this.configProvider.mediaConfig.isTransportUnbundled&&!n.groups?.find(a=>a.type==="BUNDLE")){let a=!1;if(n.media.forEach((s,c)=>{const u=this.mediaManager.getMediaEntities()[c];!a&&u.isEnabled()?(s.mid=u.getMid(),a=!0):(u.disable(),s.port=0)}),a){n.groups||(n.groups=[]);const s={type:"BUNDLE"};n.groups.push(s)}}}},Zbi=class{constructor(n,a){this.configProvider=n,this.logger=a}modify(n){n.media.forEach(a=>{const s=!!a.candidates;if(a.candidates&&(a.candidates=a.candidates.filter(c=>{let u=!0,m=!0,b=!0;return this.configProvider.config.iceCandidateType&&(u=!!c.type.match(new RegExp(this.configProvider.config.iceCandidateType,"i"))),this.configProvider.config.iceCandidateTransport&&(m=!!c.transport.match(new RegExp(this.configProvider.config.iceCandidateTransport,"i"))),this.configProvider.config.iceCandidateFilterMDns&&(b=!this.isMdns(c.ip),b||this.logger.safe.info(`Filtering out mDNS candidate ${kn(c.ip)}:${kn(c.port)}`)),u&&m&&b})),s&&a.connection&&this.configProvider.config.iceCandidateFilterMDns&&(a.candidates&&a.candidates.length!==0||(a.candidates=[KKe(a.port)]),this.isMdns(a.connection.ip)||!this.hasMatchingCandidate(a))){const c=this.getDefaultCandidate(a);a.connection.ip=c.ip,a.port=c.port}})}hasMatchingCandidate(n){const a=n.connection;return a&&!!n.candidates.find(this.createIpAndPortMatcher(a.ip,n.port))}getDefaultCandidate(n){return n.candidates.slice().sort((a,s)=>a.type===s.type?0:a.type==="host"||s.type==="relay"?1:a.type==="relay"||s.type==="host"?-1:0)[0]}isMdns(n){return n.indexOf(".local")>-1||n.indexOf(".encrypted")>-1}createIpAndPortMatcher(n,a){return s=>s.ip===n&&s.port===a}},Xbi=class{constructor(n){this.configProvider=n}modify(n){this.configProvider.config.useOneRelayCandidateForRemoteSDP&&n.media.forEach(a=>{if(a.candidates){const s=a.candidates.filter(c=>!!c.type.match(new RegExp("relay","i")));s.length>0&&(a.candidates=s.slice(0,1))}})}},eTi=class{modify(n){const a=wm(n)[0];a&&(a.candidates=[KKe()])}},tTi=class{constructor(n,a){this.mediaManager=n,this.configProvider=a}modify(n){n.media.forEach((a,s)=>{this.fromMsSdp(a,s)})}fromMsSdp(n,a){if($S(n)||n.rids&&n.simulcast)return;const s=this.mediaManager.getMediaEntities()[a],c=s?.getSimulcastContext();c?.shouldBeEnabledInRemoteDesc()&&(c.enableInRemoteDesc(),n.simulcast={dir1:"recv",list1:this.configProvider.config.specCompliantSimulcast?.disableTilde?c.ridList.map(u=>`${u}`).join(";"):c.ridList.map(u=>`${c.activeRids.includes(u)?"":"~"}${u}`).join(";")},n.rids=c.ridList.map(u=>({id:u,direction:"recv"})))}},iTi=class{constructor(n,a){this.mediaManager=n,this.logger=a}modify(n){n.media.forEach((a,s)=>{this.toMsSdp(a,s)})}toMsSdp(n,a){const s=this.mediaManager.getMediaEntities()[a],c=s?.getSimulcastContext();c&&(c.localDescriptionIsApplied(),c.shouldBeEnabledInLocalDesc()&&(c.enableInLocalDesc(),this.removeSimulcastEnvelope(n),this.addStreamSsrc(n,s.getLocalSsrc())))}removeSimulcastEnvelope(n){n.rids&&delete n.rids,n.simulcast&&delete n.simulcast}addStreamSsrc(n,a){if(!a)return;if(n.ssrcs)return void this.logger.safe.debug(`Media mid: ${n.mid} already contains ssrc: ${JSON.stringify(n.ssrcs)}`);const s=a;this.setSsrc(n,s)}setSsrc(n,a){n.ssrcs=[{id:a,attribute:"fake_attribute",value:"fake_value"}]}},nTi=class{constructor(n){this.mediaManager=n}modify(n){n.media.forEach((a,s)=>{const c=this.mediaManager.getMediaEntities()[s],u=c?.getLocalTrackId();(!a.msid&&c?.getSimulcastContext()?.shouldUseSimulcast()&&u||c?.getExtension("reinviteless"))&&(a.msid=`- ${u??s}`)})}},aTi=class{constructor(n,a){this.mediaManager=n,this.configProvider=a}modify(n){const a=this.mediaManager.getMediaEntities(),s=(0,Y9.flatMap)(a,_=>_.getRtpHeaderExtensions()),c=s.find(_=>_?.headerType==="vla")?.value,u=s.find(_=>_?.headerType==="non-adv-vla")?.value,m=c??u??(0,Y9.flatMap)(n.media,_=>_.ext||[]).find(_=>_.uri===ke.VLA.EXT_URI)?.value,b=mTi(n,this.configProvider.config.extmapAllowMixed,ke.VLA.DEFAULT_VALUE);n.media.forEach((_,k)=>{const N=J9(_);if(!this.configProvider.config.enableVla||N!=="Video"&&N!=="ScreenShare"||_.ext?.find(oe=>oe.uri===ke.VLA.EXT_URI))return;const W=a[k]?.getRtpHeaderExtensions(),ee=W?W.find(oe=>oe.headerType==="vla")?.value??W.find(oe=>oe.headerType==="non-adv-vla")?.value:m??b;ee&&(_.ext=_.ext||[],_.ext.push({value:ee,uri:ke.VLA.EXT_URI}))})}},rTi=class{constructor(n){this.configProvider=n}modify(n){n.media.forEach(a=>{const s=J9(a);if(this.configProvider.config.allowRemoteVla&&(s==="Video"||s==="ScreenShare"))return;const c=a.ext?.findIndex(u=>u.uri===ke.VLA.EXT_URI);c>-1&&a.ext.splice(c,1)})}},WKe=class{constructor(n){this.configProvider=n}modify(n,a,s){n.media.forEach(c=>{const u=J9(c);if(!this.configProvider.config.enableNonAdvVla||u!=="Video"&&u!=="ScreenShare"||c.ext?.find(b=>b.uri===s))return;const m=c.ext?.find(b=>b.uri===a);m&&(m.uri=s)})}},oTi=class extends WKe{constructor(n,a){super(n),this.mediaManager=a}modify(n){const a=this.mediaManager.getMediaEntities();(0,Y9.flatMap)(a,s=>s.getRtpHeaderExtensions()).some(s=>s?.headerType==="vla")||super.modify(n,ke.VLA.EXT_URI,ke.VLA.EXT_URI_NON_ADV)}},sTi=class extends WKe{constructor(n){super(n)}modify(n){super.modify(n,ke.VLA.EXT_URI_NON_ADV,ke.VLA.EXT_URI)}},lTi=class{modify(n){n.media.forEach(a=>{a.ext?.forEach(s=>s.uri=this.normalizeSlashesInUri(s.uri))})}normalizeSlashesInUri(n){return n.replace(/\\/g,"/")}},cTi=class{constructor(n){this.configProvider=n}modify(n){if(this.configProvider.config.fixSdpForPartialIceRestart){const[{iceUfrag:a,icePwd:s}={}]=n.media;a!==void 0&&s!==void 0&&n.media.forEach(c=>{c.iceUfrag=a,c.icePwd=s})}}},dTi=class{constructor(n){this.configProvider=n}modify(n){if(this.configProvider.config.reduceRtcpFbInSdp?.length)for(const a of wm(n,ke.MEDIA_TYPE.video))a.rtcpFb=a.rtcpFb&&this.getFbList(a.rtcpFb)}getFbList(n){const a=[],s=[];for(const c of n){const u=c.subtype?`${c.type}/${c.subtype}`:`${c.type}`;a.includes(u)||(this.configProvider.config.reduceRtcpFbInSdp.includes(u)?(a.push(u),s.push({...c,payload:"*"})):s.push(c))}return s}},uTi=class{constructor(n){this.configProvider=n}modify(n){if(!this.configProvider.config.redReceiveEnabled)return;const a=n.media.find(u=>u.type===ke.MEDIA_TYPE.audio);let s=0;Lf(a,{codec:"opus",rate:48e3,encoding:2},u=>{s=u.rtp.payload});const c={codec:"RED",rate:8e3};Lf(a,c,u=>{u.rtp.rate=48e3,u.rtp.encoding=2,s&&(u.fmtp={payload:u.rtp.payload,config:`${s}/${s}`})}),Iw(a,c)}},hTi=class{constructor(n){this.configProvider=n}modify(n){this.configProvider.config.redReceiveEnabled&&Lf(n.media.find(a=>a.type===ke.MEDIA_TYPE.audio),{codec:"red",rate:48e3,encoding:2},a=>{a.rtp.codec="RED",a.rtp.rate=8e3,delete a.rtp.encoding})}},pTi=class{constructor(n,a){this.configProvider=n,this.sdpType=a}modify(n){if(!this.configProvider.config.redReceiveEnabled||this.sdpType!=="offer")return;const a=n.media.find(m=>m.type===ke.MEDIA_TYPE.audio),s={codec:"red",rate:48e3,encoding:2};let c=0;if(Lf(a,s,m=>{c=m.rtp.payload}),c===ke.PAYLOAD_TYPE.MSRTC_RED)return;const u=TTe(n);u!==-1&&(wTe(n,ke.PAYLOAD_TYPE.MSRTC_RED,u),Lf(a,s,m=>{m.rtp.payload=ke.PAYLOAD_TYPE.MSRTC_RED}))}},gTi=class{constructor(n,a){this.modification=n,this.context=a,this.logger=a.getLogger().createChild("IncomingDtlsRoleModifier")}modify(n){if(this.modification.sdpType!=="answer")if(this.modification.sdpType==="offer"&&this.modification.sdpSource===2){if(this.modification.isOrWasProvisional){const a=this.context.config.isPstnCall?this.context.configProvider.config.createProvisionalAnswer.dtlsRolePstn:this.context.configProvider.config.createProvisionalAnswer.dtlsRole;if(!a)return;this.logger.debug(`Configured DTLS role override: ${a}`),n.media.forEach((s,c)=>{const u=s.setup;s.direction!=="inactive"&&(u&&u!=="actpass"?this.logger.warn(`Remote DTLS role is ${u}, cannot change`):(s.setup=a,this.logger.debug(`Remote DTLS role changed from ${u} to ${s.setup} for mid=${s.mid}`)))})}}else this.logger.error(`Tried to apply invalid change to DTLS role: ${this.modification.sdpType} ${this.modification.sdpSource}`)}};function qne(n,a,s,c){const u={type:n,port:0,label:a,payloads:n===ke.MEDIA_TYPE.dataChannel||n===ke.MEDIA_TYPE.data?ke.PAYLOAD_TYPE.DATA_CHANNEL:"36",protocol:s,connection:{ip:"10.10.10.10",version:4}};return c&&(u.mid=c),u}function wm(n,a=null){return n.media.filter(s=>!($S(s)||a&&s.type!==a))}function KKe(n=1234){return{component:1,ip:"10.10.10.10",foundation:"1755259772",priority:2122197247,port:n!==9?n:1234,transport:"UDP",type:"host"}}function mTi(n,a,s,c=!1){const u=(0,Y9.flatMap)(n.media,k=>k.ext||[]).map(k=>k.value);if(u.length===0)return s;const m=2,b=14;if(c&&!u.includes(s))return s;let _;for(let k=m;k<=b;k++)if(!u.includes(k)){_=k;break}return!_&&a&&(_=Math.max(...u)+1),_}function dM(n,a){if(!Dye[n]?.[a])throw`unsupported codec ${n} or type ${a}`;const s=Dye[n][a];return{codec:s.NAME,rate:s.RATE,encoding:s.ENCODING,payload:Dye[n].PT}}function wTe(n,a,s){for(const c of n.media)$ne(c,a,s)}function JKe(n,a,s,c,u){const m=new Set;return Hne(n,a,b=>{b.rtp.payload<96&&(m.add(b.rtp.payload),b.rtp.payload=s[u]??b.rtp.payload,u++)},c),m}var Wne=class kQe{constructor(a,s,c,u){this.context=a,this.sessionType=s,this.sdp=c,this.remote=u,this.mediaManager=this.context.mediaManager,this.sdpTransform=this.context.sdpTransform,this.logger=this.context.logger.createChild("SessionDescr"),this.sdpModel=bKe.parse(this.sdp),u&&new Wbi(this.context.configProvider).modify(this.sdpModel),this.sdpModel.media.forEach(m=>{(0,YSi.isUndefined)(m.mid)||(m.mid=m.mid.toString())}),this.remote&&!this.context.configProvider.config.disableMsSdp&&new vbi(a,this.mediaManager,s).modify(this.sdpModel)}getSdp(){return bKe.write(this.sdpModel)}clone(){return new kQe(this.context,this.sessionType,this.sdp,this.remote)}getModalities(){return this.modalities||wKe(this.sdpModel)}updateModalities(a){this.logger.debug("updateModalities",a),this.modalities=a}getSrtpInfo(){return Xte(this.sdpModel)}getVideoCodecs(){const a={};return this.sdpModel.media.forEach(s=>{s.type==="video"&&s.rtp.map(c=>c.codec.toLowerCase()).forEach(c=>a[c]=!0)}),Object.keys(a)}usePrimaryAudioCodecOnly(a){new jbi(a).modify(this.sdpModel)}isCodecSwitchSupported(){return!this.sdpModel.media.some(a=>a.type===ke.MEDIA_TYPE.audio&&a.xMediaSettings&&this.containsMediaSetting(a.xMediaSettings,"codecswitchunsupported"))}toLocal(){return this.sdpModel=this.sdpTransform.toLocal(this.sdpModel,this.mediaManager,this.sessionType),this.getSdp()}toOffer(){return this.toOfferAnswer()}toAnswer(){return this.toOfferAnswer()}toOfferAnswer(){const a=this.sessionType==="offer";return new Zbi(this.context.configProvider,this.logger).modify(this.sdpModel),new Ybi().modify(this.sdpModel),a&&this.mediaManager.isEmpty()&&this.mediaManager.fromOffer(this.sdpModel,this.modalities),this.mediaManager.syncModalities(this.sdpModel,this.modalities,!a),this.sdpModel=a?this.sdpTransform.toOffer(this.sdpModel,this.mediaManager,this.modalities):this.sdpTransform.toAnswer(this.sdpModel,this.mediaManager,this.modalities),this.context.configProvider.config.disableMsSdp||new fbi(this.context,this.mediaManager,this.sessionType).modify(this.sdpModel),new qbi(this.mediaManager,this.context.configProvider).modify(this.sdpModel),this.modalities=wKe(this.sdpModel),this.getSdp()}setModalities(a){this.modalities=a,this.mediaManager.fromRemote(this.sdpModel,this.modalities)}toRemote(a=!1){return this.sdpModel=this.sdpTransform.toRemote(this.sdpModel,this.mediaManager,this.modalities,this.sessionType,a),this.getSdp()}getVideoRecvCapabilities(){return CTe(this.getMediaByLabel(ke.MEDIA_LABEL.video))}getSharingRecvCapabilities(){return CTe(this.getMediaByLabel(ke.MEDIA_LABEL.sharing))}getMediaByType(a){return this.sdpModel.media.find(s=>s.type===a)}isUnbundled(){const a=this.sdpModel.groups?.find(u=>u.type==="BUNDLE"),s=this.sdpModel.media.find(u=>u.type===ke.MEDIA_TYPE.audio),c=this.sdpModel.media.find(u=>u.type===ke.MEDIA_TYPE.video);return a?!a.mids.toString().split(" ").find(u=>u===s.mid):!!c}couldBeUnbundled(){return!this.sdpModel.groups?.find(a=>a.type==="BUNDLE")||this.hasUnbundledIceCandidates()}containsMediaSetting(a,s){return a.some(c=>c.settings.indexOf(s)!==-1)}getMediaByLabel(a){return this.sdpModel.media.find(s=>s.label===a)}hasIceCandidatesForMediaType(a,s=""){const c=this.sdpModel.media?this.sdpModel.media.filter(u=>u.type===a&&!!u.candidates&&u.candidates.length!==0):[];return s?c.some(u=>!!u.candidates&&u.candidates.some(m=>m.type===s)):!!c.length}hasIceCandidates(){return this.hasIceCandidatesForMediaType(ke.MEDIA_TYPE.audio)||this.hasIceCandidatesForMediaType(ke.MEDIA_TYPE.video)}hasRelayIceCandidates(){return this.hasIceCandidatesForMediaType(ke.MEDIA_TYPE.audio,"relay")||this.hasIceCandidatesForMediaType(ke.MEDIA_TYPE.video,"relay")}hasUnbundledIceCandidates(){const a=this.sdpModel.media.filter(s=>s.type===ke.MEDIA_TYPE.video&&s.port!==0);return this.hasIceCandidatesForMediaType(ke.MEDIA_TYPE.audio)&&(!a.length||this.hasIceCandidatesForMediaType(ke.MEDIA_TYPE.video))}hasUnbundledRelayIceCandidates(){const a=this.sdpModel.media.filter(s=>s.type===ke.MEDIA_TYPE.video&&s.port!==0);return this.hasIceCandidatesForMediaType(ke.MEDIA_TYPE.audio,"relay")&&(!a.length||this.hasIceCandidatesForMediaType(ke.MEDIA_TYPE.video,"relay"))}isIceRestart(){return this.mediaManager.getMediaEntities().some(a=>a.getExtension("iceRestart"))}isMSRTC(){return!!this.sdpModel.xMediaBw}insertFakeCandidateIfNeeded(){return!this.hasIceCandidates()&&(new eTi().modify(this.sdpModel),!0)}forceRecvonly(){new bbi().modify(this.sdpModel)}getBweType(){const a=this.sdpModel.media.find(c=>c.port!==0&&c.type===ke.MEDIA_TYPE.video);return a?a.ext?.find(c=>c.uri===ke.TRANSPORT_CC.EXT_URI||c.uri===ke.TRANSPORT_CC.MSSDP_ENCODED_URI)?"SSBWE":"REMB":"Unknown"}fixDataModality(){new Tbi(this.mediaManager).modify(this.sdpModel)}getPayloadsForMedia(a){return this.sdpModel.media.find(c=>c.type===a&&c.port!==0)?.rtp??[]}},fTi=class{constructor(n){this.context=n}createLocalOffer(n){return new Wne(this.context,"offer",n)}createRemoteOffer(n){return new Wne(this.context,"offer",n,!0)}createLocalAnswer(n){return new Wne(this.context,"answer",n)}createRemoteAnswer(n){return new Wne(this.context,"answer",n,!0)}},YKe=class{static build(n){return new fTi(n=n||{})}};function QKe(n){let a="";return n.dtls&&(a+="dtls"),n.sdes&&(a+="sdes"),a}var vTi=class{constructor(){this.info={OfferedSrtp:"none",NegotiatedSrtp:"none",IceConnectionState:"none",IceConnectionStatePrevious:"none",SignalingState:"none",SignalingStatePrevious:"none",RelayCandidate:"none",IceTransportPolicy:"none",IceServers:"none",FakeIceCandidate:!1,BweType:"none",SdpSemantics:"none",BundlePolicy:"none",IPAddress:"none",ReflexiveLocalIP:"none",NumberOfInterfaces:0,EncodedStreamWorker:!1,AudioCodecEvents:"none"}}setCandidateDetails(n){n.type==="host"&&n.protocol==="udp"?this.setIPAddressInfo(n.ip):n.type==="srflx"&&this.setReflexiveLocalIP(n.ip)}setOfferedModalities(n){this.offeredModalities=n,this.activeModalities=n}setNegotiatedModalities(n){this.negotiatedModalities=n,this.activeModalities=n}setNegotiatedSrtpInfo(n){this.info.NegotiatedSrtp=QKe(n)}setOfferedSrtpInfo(n){this.info.OfferedSrtp=QKe(n)}setIceConnectionState(n){this.info.IceConnectionStatePrevious=this.info.IceConnectionState,this.info.IceConnectionState=n}setSignalingConnectionState(n){this.info.SignalingStatePrevious=this.info.SignalingState,this.info.SignalingState=n}setRelayCandidateInfo(n){this.info.RelayCandidate=JSON.stringify(n)}fillExtensionInfo(n){yve(n,this.info)}setIceTransportPolicy(n){this.info.IceTransportPolicy=n}setIceServers(n){const a=n.map(s=>{const c={...s};return c.username&&(c.username="true"),c.credential&&(c.credential="true"),c});this.info.IceServers=JSON.stringify(a)}setFakeIceCandidate(n){this.info.FakeIceCandidate=n}setBweType(n){n!=="Unknown"&&(this.info.BweType=n)}setSdpSemantics(n){this.info.SdpSemantics=n}setBundlePolicy(n){this.info.BundlePolicy=n}setEncodedStreamWorkerLoaded(n){this.info.EncodedStreamWorker=n}setAudioCodecEvents(n){this.info.AudioCodecEvents=JSON.stringify(n)}setIPAddressInfo(n){this.info.NumberOfInterfaces+=1,this.info.IPAddress==="none"&&(this.info.IPAddress=n)}setReflexiveLocalIP(n){this.info.ReflexiveLocalIP==="none"&&(this.info.ReflexiveLocalIP=n)}},yTi=class{constructor(){this.presentationAPIUserDuration=0,this.presentationAudioDuration=0,this.isActiveScreenSharing=!1}handleInputLevel(n,a){this.isActiveScreenSharing&&(n==="ScreenShare"&&a>0&&(this.presentationAPIUserDuration+=ke.TIME_INTERVAL.SEC_1),n==="Audio"&&a>0&&(this.presentationAudioDuration+=ke.TIME_INTERVAL.SEC_1))}updateScreenSharingStream(n,a){a==="ScreenShare"&&(this.isActiveScreenSharing=!!n)}getPresentationAudioDuration(){return this.presentationAudioDuration}getPresentationAudioAPIUserDuration(){return this.presentationAPIUserDuration}},STi=class RQe{constructor(a){this.name=a,this.sharedState={mark:new Map,measure:[]}}mark(a,s){const c=pp();this.sharedState.mark.set(a,{name:a,ts:c,startTime:oa(_ve+c),details:s})}measure(a,s){const c=this.sharedState.mark.get(s.start),u=this.sharedState.mark.get(s.end);if(c&&u){const m={...s,parentName:this.name===a?"":this.name};this.sharedState.measure.push({name:a,details:m,duration:oa(u.ts-c.ts),startTime:c.startTime})}}markAndMeasure(a,s,c,u){this.sharedState.mark.has(s)===!1&&this.mark(s,c);const m=this.sharedState.mark.get(a),b=this.sharedState.mark.get(s);if(m&&b){const _={...u,parentName:this.name===s?"":this.name};this.sharedState.measure.push({name:s,details:_,duration:oa(b.ts-m.ts),startTime:m.startTime})}}clone(a){const s=new RQe(`${this.name}|${a}`);return s.setSharedState(this.sharedState),s}setSharedState(a){this.sharedState=a}getReport(){return this.sharedState.measure.map(a=>({name:a.name,duration:a.duration,ts:a.startTime,parentName:a.details.parentName}))}},ZKe=class MQe{mark(){}measure(){}markAndMeasure(){}clone(){return new MQe}getReport(){return[]}},XKe=class{constructor(n){this.enableTimerTracker=n,this.timerTrackers={},this.timerTrackerOptions={}}getTimerTracker(n,a){if(!this.enableTimerTracker)return new ZKe;const s=new STi(n);if(this.timerTrackers[n]){const c=this.timerTrackerOptions[n];if(c?.first)return new ZKe;c?.last&&(this.timerTrackers[n]=[s]),c?.all&&this.timerTrackers[n].push(s)}else this.timerTrackers[n]=[s],this.timerTrackerOptions[n]=a;return s}getReport(){if(this.enableTimerTracker)return Object.keys(this.timerTrackers).reduce((n,a)=>{const s=this.timerTrackerOptions[a];return(s.first||s.last)&&(n[a]=[this.timerTrackers[a][0]?.getReport()]),s.all&&(n[a]=Object.values(this.timerTrackers[a]).map(c=>c?.getReport())),n},{})}},bTi=class{constructor(n,a){this.configProvider=n,this.sessionInfo=a,this.data={fakeCandidate:!1,bweType:"Unknown",offeredSrtp:"unknown",negotiatedSrtp:"unknown",callSetupTimeReport:{}},this.timerTrackerManager=new XKe(this.configProvider.config.enableTimerTracker),hN(this.data,{callSetupTimeReport:()=>this.timerTrackerManager.getReport()})}getTimerTracker(n,a){return this.timerTrackerManager.getTimerTracker(n,a)}set offeredModalities(n){this.data.offeredModalities=n,this.data.activeModalities=n,this.sessionInfo.setOfferedModalities(n)}set negotiatedModalities(n){this.data.negotiatedModalities=n,this.data.activeModalities=n,this.sessionInfo.setNegotiatedModalities(n)}set fakeCandidate(n){var a;(a=this.data).fakeCandidate||(a.fakeCandidate=n),this.sessionInfo.setFakeIceCandidate(n)}set bweType(n){this.data.bweType=n,this.sessionInfo.setBweType(n)}set negotiatedSrtp(n){this.data.negotiatedSrtp=eJe(n),this.sessionInfo.setNegotiatedSrtpInfo(n)}set offeredSrtp(n){this.data.offeredSrtp=eJe(n),this.sessionInfo.setOfferedSrtpInfo(n)}set meetingScenario(n){this.data.meetingScenario=n}set isTownHall(n){this.data.isTownHall=n}getObjectRef(){return this.data}};function eJe(n){let a="";return n.dtls&&(a+="dtls"),n.sdes&&(a+="sdes"),a}var TTi=class{constructor(n){this.data=n,this.reopenRequestDeviceIds=new Set}registerReopenRequest(n){this.reopenRequestDeviceIds.has(n)||(this.data.sinkNumOfReopenRequests++,this.reopenRequestDeviceIds.add(n))}registerSuccessfullReopen(n){this.reopenRequestDeviceIds.has(n)&&(this.data.sinkNumOfSuccessfulReopens++,this.reopenRequestDeviceIds.delete(n))}getObjectRef(){return this.data}},CTi=class{constructor(n){this.configProvider=n,this.data={signalingState:"none",signalingStatePrevious:"none",iceConnectionState:"none",iceConnectionStatePrevious:"none",numCallbacksScheduled:0,numCallbacksExecuted:0,numCallbacksExecutedImmediately:0,scheduledCallbacks:[],events:[],timers:{}},this.scheduledCallbacks=new Map,this.stateTrackers={},hN(this.data,{scheduledCallbacks:()=>this.scheduledCallbacks.values(),timers:()=>{const a={};for(const s of Object.keys(this.stateTrackers))a[s]=this.stateTrackers[s].durations;return a}})}dispose(){for(const n of Object.values(this.stateTrackers))n.dispose()}set hasConnectionState(n){this.data.hasConnectionState=n}set transportState(n){this.data.transportStatePrevious=this.data.transportState,this.data.transportState=n,this.addStateEvent("transport",this.data.transportStatePrevious,this.data.transportState)}set signalingState(n){this.data.signalingStatePrevious=this.data.signalingState,this.data.signalingState=n,this.addStateEvent("signaling",this.data.signalingStatePrevious,this.data.signalingState)}set iceConnectionState(n){this.data.iceConnectionStatePrevious=this.data.iceConnectionState,this.data.iceConnectionState=n,this.addStateEvent("ice",this.data.iceConnectionStatePrevious,this.data.iceConnectionState)}set connectionState(n){this.data.connectionStatePrevious=this.data.connectionState,this.data.connectionState=n,this.addStateEvent("connection",this.data.connectionStatePrevious,this.data.connectionState)}set dtlsTransportState(n){this.data.dtlsTtransportStatePrevious=this.data.dtlsTransportState,this.data.dtlsTransportState=n,this.addStateEvent("dtlsTransport",this.data.dtlsTtransportStatePrevious,this.data.dtlsTransportState)}set provisional(n){this.addStateEvent("provisional",`${this.data.isProvisional}`,`${n}`),this.data.isProvisional=n}scheduleDoOnConnected(n,a,s,c){this.scheduledCallbacks.set(n,`${a}: ${s?"p":""}${c?"n":""}`),this.addCallbackEvent(a,s,c),this.data.numCallbacksScheduled++}runDoOnConnected(n,a=!1){this.scheduledCallbacks.get(n)&&this.scheduledCallbacks.delete(n),this.data.numCallbacksExecuted++,a&&this.data.numCallbacksExecutedImmediately++}getObjectRef(){return this.data}addCallbackEvent(n,a,s){ld(this.data.events,{evType:"callback",timestamp:Date.now(),logName:n,allowProvisional:a,mayRunImmediately:s},this.configProvider.config.diagnostics.collectionLimits.numTransportStateEvents)}addStateEvent(n,a,s){ld(this.data.events,{evType:"stateChanged",timestamp:Date.now(),changedState:n,previous:a,current:s},this.configProvider.config.diagnostics.collectionLimits.numTransportStateEvents);const c=this.stateTrackers[n]??new _Ti;c.state=s,this.stateTrackers[n]=c}},_Ti=class{constructor(){this.stopwatches={}}set state(n){if(this.stateInternal===n)return;this.running?.stop();const a=this.stopwatches[n]??new tg;this.stopwatches[n]=a,a.start(),this.running=a,this.stateInternal=n}get durations(){const n={};for(const a in this.stopwatches){const s=this.stopwatches[a];n[a]=s.elapsed}return n}dispose(){this.running?.stop(),this.running=void 0}},tJe=/profile-level-id=(.{6})/,ETi=class{constructor(n,a,s=()=>{},c=()=>this,u=()=>{},m=new vKe,b){this.configProvider=n,this.dmDiagnostics=a,this.addSessionStatsError=s,this.newNativeSession=c,this.commitNativeSession=u,this.dshDiagnostics=m,this.getSessionRef=b,this.data={startTime:Date.now(),duration:0,relayCandidate:"none",iceTransportPolicy:"none",iceServers:"none",sdpSemantics:"none",bundlePolicy:"none",iceCandidateErrors:[],H264Profiles:[],h264CodecCapabilities:{sendProfiles:[],receiveProfiles:[]},numInterfaces:0,statsReports:[],aggregatedModalityStats:{},multiViewStats:[],networkInfo:[],statsErrors:[],statsOnSubscribed:{},negotiation:{},recvVideoStreamCount:{min:0,max:0,mode:0},reportedReceiveBandwidth:[],reportedSendBandwidthLayouts:[],encodedStreamWorker:!1,audioCodecEvents:"none",totalVideoRecvMblocksRates:{macroblockRateReceivedMax:0,macroblockRateReceivedAvg:0,macroblockRateDecodedMax:0,macroblockRateDecodedAvg:0,macroblockRateMaxDecoderLossPercent:0,macroblockRateDecoderLossPercent:0},loopIntervalMax:-1,loopIntervalMedian:-1,fetchTimeMax:-1,fetchTimeMedian:-1,videoPerformanceEvent:[],localVideoPerformanceEvents:[],ovcToSubscriptionEvents:[],presentationAPIUserDuration:0,presentationAudioDuration:0,earlyMediaNumStatsPolls:0,audioRenderer:null},this.presentationAudioTelemetry=new yTi,hN(this.data,{duration:()=>this.data.endTime?this.data.endTime-this.data.startTime:Date.now()-this.data.startTime,bandwidthReport:()=>this.bandwidthStatsRef?.getBandwidthReport(),presentationAPIUserDuration:()=>this.presentationAudioTelemetry.getPresentationAudioAPIUserDuration(),presentationAudioDuration:()=>this.presentationAudioTelemetry.getPresentationAudioDuration()}),Object.defineProperty(this.data,"IPAddress",{enumerable:!1,writable:!0,configurable:!0}),Object.defineProperty(this.data,"reflexiveLocalIP",{enumerable:!1,writable:!0,configurable:!0})}get deviceManager(){return this.dmDiagnostics}get audioLevel(){return this.analyzer?.getInputLevelNormalized()}get reflexiveLocalIP(){return this.data.reflexiveLocalIP}set bandwidthDiagnostic(n){this.bandwidthStatsRef=n}get callIsMuted(){return this.getSessionRef?.().callIsMuted}get sharingAudioLevel(){return this.analyzerSharing?.getInputLevelNormalized()}set relayCandidateInfo(n){this.data.relayCandidate=JSON.stringify(n)}set iceTransportPolicy(n){this.data.iceTransportPolicy=n}set reinvitelessContext(n){this.data.reinvitelessContext=n}set iceServers(n){const a=n.map(s=>{const c={...s};return c.username&&(c.username="true"),c.credential&&(c.credential="true"),c});this.data.iceServers=JSON.stringify(a)}set sdpSemantics(n){this.data.sdpSemantics=n}set isCodecsSupported(n){this.data.codecSupport=n}set bundlePolicy(n){this.data.bundlePolicy=n}set latestRawReport(n){this.data.latestRawReport=n}set recvVideoStreamsCount(n){this.data.recvVideoStreamCount=n}set aggregatedStatsRef(n){this.data.aggregatedModalityStats=n}set multiViewStats(n){this.data.multiViewStats=n}set videoCapabilities(n){if(!n?.codecs)return;const a=[];n.codecs.forEach(s=>{if(s.mimeType==="h264"&&s.sdpFmtpLine){const c=tJe.exec(s.sdpFmtpLine)?.[1];c&&a.push(c)}}),this.data.H264Profiles=[...new Set(this.data.H264Profiles.concat(a))]}setSupportedH264Profiles(n,a){if(!n?.codecs&&!a?.codecs)return;const s=c=>{const u=[];return c.codecs?.forEach(m=>{if(m.mimeType==="h264"&&m.sdpFmtpLine){const b=tJe.exec(m.sdpFmtpLine)?.[1];b&&!u.includes(b)&&u.push(b)}}),u};this.data.h264CodecCapabilities.sendProfiles=s(n),this.data.h264CodecCapabilities.receiveProfiles=s(a)}set sentBWSeed(n){var a;(a=this.data).initialBWSeed??(a.initialBWSeed=n),this.data.sentBWSeed=n}reportedSendBandwidthLayouts(n){ld(this.data.reportedSendBandwidthLayouts,n,this.configProvider.config.diagnostics.telemetryLimits.numAggregatedSamples)}set maxSessionBandwidth(n){this.data.maxSessionBandwidth=n}set bwStabilizationTime(n){this.data.bwStabilizationTime=n}set bwDownlinkStabilizationTime(n){this.data.bwDownlinkStabilizationTime=n}set statsOnSubscribed(n){this.data.statsOnSubscribed=n}set loopIntervalMax(n){this.data.loopIntervalMax=n}set loopIntervalMedian(n){this.data.loopIntervalMedian=n}set fetchTimeMax(n){this.data.fetchTimeMax=n}set fetchTimeMedian(n){this.data.fetchTimeMedian=n}set simulcastReport(n){this.data.simulcast=n}setTotalVideoRecvMblocksRates(n){this.data.totalVideoRecvMblocksRates=n}set dataChannelSessionState(n){this.data.dataChannelSessionState=n}set createChannelFailReason(n){this.data.dataChannelCreationError=n}setCandidateDetails(n){n.type==="host"&&n.protocol==="udp"?(this.data.numInterfaces++,this.data.IPAddress||(this.data.IPAddress=n.ip)):n.type!=="srflx"||this.data.reflexiveLocalIP||(this.data.reflexiveLocalIP=n.ip)}setAudioSendStream(n,a){if(this.configProvider.config.useAudioAnalyzer){const s=new vTe(n.rawStream);a==="ScreenShare"&&n.hasAudio()?(this.analyzerSharing?.dispose(),this.analyzerSharing=s):a==="Audio"&&(this.analyzer?.dispose(),this.analyzer=s)}}addNetworkInfo(n){ld(this.data.networkInfo,n,this.configProvider.config.diagnostics.telemetryLimits.numAggregatedSamples)}addIceCandidateError(n){this.data.iceCandidateErrors.push(n)}clearIceCandidateErrors(){this.data.iceCandidateErrors=[]}registerEarlyMediaPoll(){this.data.earlyMediaNumStatsPolls++}addReportedReceiveBandwidth(n){ld(this.data.reportedReceiveBandwidth,n,this.configProvider.config.diagnostics.telemetryLimits.numAggregatedSamples)}addOvcSubscriptionReport(n,a,s){this.data.ovcToSubscriptionEvents[this.data.ovcToSubscriptionEvents.length-1]?.ovc.count!==n&&ld(this.data.ovcToSubscriptionEvents,{ovc:{ts:Date.now(),count:n,subsCount:a,...s},subs:[]},this.configProvider.config.diagnostics.collectionLimits.numSubscriptionEvents)}addSubscriptionToOvcEvent(n){const a=this.data.ovcToSubscriptionEvents[this.data.ovcToSubscriptionEvents.length-1];a&&ld(a.subs,{ts:Date.now(),count:n},this.configProvider.config.diagnostics.collectionLimits.numSubscriptionEvents)}addStatsReport(n){ld(this.data.statsReports,n,this.configProvider.config.diagnostics.collectionLimits.numStatsReports)}addStatsError(n,a){const s=this.data.statsErrors.find(c=>c.error===a&&c.origin===n);s?s.count++:ld(this.data.statsErrors,{origin:n,error:a,count:1},this.configProvider.config.diagnostics.collectionLimits.numStatsErrors),this.addSessionStatsError(`nativeSession:${n}`,a)}setPresentationAudioOnScreenSharing(n,a){this.presentationAudioTelemetry.updateScreenSharingStream(n,a)}handlePresentationAudioInputLevel(){this.presentationAudioTelemetry.handleInputLevel("Audio",this.audioLevel),this.presentationAudioTelemetry.handleInputLevel("ScreenShare",this.sharingAudioLevel)}terminate(){this.data.endTime=Date.now(),this.analyzer?.dispose(),this.analyzer=null,this.analyzerSharing?.dispose(),this.analyzerSharing=null}newQualityManagerDiagnostics(){const n=new WSi(this.configProvider,(a,s)=>this.addStatsError(`qualityManagerDiagnostics:${a}`,s));return this.data.qualityManager=n.getObjectRef(),n}newRemoteVideoManagerDiagnostics(){const n=new KSi(this.configProvider);return this.data.remoteVideoManager=n.getObjectRef(),n}newNegotiationDiagnostics(n){const a=new bTi(this.configProvider,n);return this.data.negotiation=a.getObjectRef(),a}newSubscriptionManagerDiagnostics(){const n=new bTe(this.configProvider,a=>this.addStatsError("subscriptionManagerDiagnostics",a));return this.data.subscriptionManager=n.getObjectRef(),n}newDataChannelDiagnostics(n){const a=new zdi(n);return this.data.dataChannel=a.getObjectRef(),a}newTransportStateDiagnostics(){const n=new CTi(this.configProvider);return this.data.transportState=n.getObjectRef(),n}set encodedStreamWorker(n){this.data.encodedStreamWorker=n}set audioCodecEvents(n){this.data.audioCodecEvents=n}getObjectRef(){return this.data}registerVideoPerformanceEvent(n,a,s){const c={type:a,perfEvent:n,resRequestEvent:null,resChangedEvent:[],perfConstrainedOvc:s};ld(this.data.videoPerformanceEvent,c,this.configProvider.config.diagnostics.telemetryLimits.numAggregatedSamples)}registerLocalVideoPerformanceEvent(n){ld(this.data.localVideoPerformanceEvents,{timestamp:Date.now(),description:n.description,activeModalities:n.activeModalities,isTransient:n.isTransient},this.configProvider.config.diagnostics.collectionLimits.numPerformanceEvents)}registerResolutionChangeRequest(n){const a=this.data.videoPerformanceEvent[this.data.videoPerformanceEvent.length-1];a&&(a.resRequestEvent=n)}registerResolutionChangeEvent(n){const a=this.data.videoPerformanceEvent[this.data.videoPerformanceEvent.length-1];n.ts-a?.resRequestEvent?.ts<this.configProvider.config.diagnostics.performanceMonitoring.telemetryResolutionRequestSpanMs&&a.resChangedEvent.push(n)}set contributingSourcesError(n){this.data.contributingSourcesError=n}newAudioRendererDiagnostics(){return this.data.audioRenderer=this.getSessionRef?.().audioRenderer,this.data.audioRenderer?new TTi(this.data.audioRenderer):null}},Q9=Symbol("sessionDiagnosticsRef"),ATi=class{constructor(n,a,s,c,u,m,b){this.logger=n,this.configProvider=a,this.diagnosticsReport=s,this.dmDiagnostics=c,this.ufdDiagnostics=u,this.dshDiagnostics=new vKe,this.data={creationTime:Date.now(),callNumber:0,sessionId:"unknown",isMultiParty:!1,dtmfSuccessCount:0,dtmfFailureCount:0,iceInitTime:0,iceConnectedStateTime:0,negotiationCount:0,rejectedNegotiationCount:0,initialNegotiationCompleted:!1,finalAnswerTime:0,transportReconnectedCount:0,rollbackNegotiation:[],activeModalities:{},allowedAudioSend:!0,allowedVideoSend:!0,allowedScreensharingSend:!0,noIceCandidatesEventCount:{good:0,bad:0},noRelayIceCandidatesEventCount:{good:0,bad:0},microphoneInUseEventCount:{good:0,bad:0},cameraInUseEventCount:{good:0,bad:0},cameraFreezeEventCount:{start:0,end:0},rawMedia:{audio:{recv:{numAttempts:0,durationRatio:0},send:{numAttempts:0,durationRatio:0}}},ufds:[],remoteUfds:[],remoteUfdsCount:{},statsErrors:[],webrtcSessions:[],isOngoing:!1,duration:0,callMutedRatio:0,callOsMuted:0,callHwSilent:0,callSwMuted:0,callIsMuted:!1,callSpeakerMuted:0,callIsSpeaking:0,networkRecvUFD:void 0,networkSendUFD:void 0,zeroCaptureDevicesRatio:0,zeroRenderDevicesRatio:0,deviceRenderFailuresRatio:0,deviceCaptureFailuresRatio:0,deviceManager:void 0,ufdManager:void 0,relayTimers:void 0,authTokenFetcherStats:void 0,dominantSpeaker:this.dshDiagnostics.getObjectRef(),[Q9]:this,callConstraints:[],audioRenderer:{sinkNumOfReopenRequests:0,sinkNumOfSuccessfulReopens:0},elevation:[],batteryLevel:void 0},this.transportDisconnected=!1,this.commonMuteTracker=new tg,this.swMuteTracker=new tg,this.osMuteTracker=new tg,this.speakerMuteTracker=new tg,this.hwSilentTracker=new tg,this.isSpeakingTracker=new tg,this.networkRecvTracker=new _$,this.networkSendTracker=new _$,this.zeroCaptureTracker=new _$,this.zeroRenderTracker=new _$,this.deviceRenderTracker=new _$,this.deviceCaptureTracker=new _$,this.rawMediaTimers={audio:{send:new tg,recv:new tg}},this.dmFragmenter=new wTi(this.dmDiagnostics),this.ufdFragmenter=new ITi(this.ufdDiagnostics),this.durationTimer=new tg,this.data.callNumber=m,this.data.sessionId=b,this.durationTimer.start(),hN(this.data,{isOngoing:()=>this.data.terminationTime===void 0,duration:()=>this.durationTimer.elapsed,callMutedRatio:()=>Kne(this.commonMuteTracker.elapsed,this.data.duration),callOsMuted:()=>this.osMuteTracker.elapsed,callHwSilent:()=>this.hwSilentTracker.elapsed,callSwMuted:()=>this.swMuteTracker.elapsed,callIsMuted:()=>this.swMuteTracker.isRunning,callSpeakerMuted:()=>this.speakerMuteTracker.elapsed,callIsSpeaking:()=>this.isSpeakingTracker.elapsed,zeroCaptureDevicesRatio:()=>this.zeroCaptureTracker.getRatio("Bad"),zeroRenderDevicesRatio:()=>this.zeroRenderTracker.getRatio("Bad"),deviceRenderFailuresRatio:()=>this.deviceRenderTracker.getRatio("Bad"),deviceCaptureFailuresRatio:()=>this.deviceCaptureTracker.getRatio("Bad"),networkRecvUFD:()=>({good:this.networkRecvTracker.getCount("Good"),poor:this.networkRecvTracker.getCount("Poor"),bad:this.networkRecvTracker.getCount("Bad"),goodRatio:this.networkRecvTracker.getRatio("Good"),poorRatio:this.networkRecvTracker.getRatio("Poor"),badRatio:this.networkRecvTracker.getRatio("Bad")}),networkSendUFD:()=>({good:this.networkSendTracker.getCount("Good"),poor:this.networkSendTracker.getCount("Poor"),bad:this.networkSendTracker.getCount("Bad"),goodRatio:this.networkSendTracker.getRatio("Good"),poorRatio:this.networkSendTracker.getRatio("Poor"),badRatio:this.networkSendTracker.getRatio("Bad")}),deviceManager:()=>this.dmFragmenter.getFragment(this.dmDiagnostics),relayTimers:()=>this._relayManager?.getStats(),authTokenFetcherStats:()=>this._relayManager?.getAuthTokenStats(),callConstraints:()=>this.configProvider.getCallConstraintsTelemetry(),ufdManager:()=>this.ufdFragmenter.getFragment(this.ufdDiagnostics)}),hN(this.data.rawMedia.audio.recv,{durationRatio:()=>Kne(this.rawMediaTimers.audio.recv.elapsed,this.data.duration)}),hN(this.data.rawMedia.audio.send,{durationRatio:()=>Kne(this.rawMediaTimers.audio.send.elapsed,this.data.duration)})}get telemetryReport(){const n={type:"WebRtcMediaStats",data:this.diagnosticsReport.getSessionTelemetry(this.data.sessionId)},a={};return bG(n.data,(s,c,u)=>{let m=0;Yte.test(s)?(m=13,a[c]="IPv4"):_ye.test(s)&&(m=4,a[c]="IPv6"),u[c]={type:m,value:s,__VALUE__:!0}}),n.data.metrics.piiFields={type:0,value:JSON.stringify(a),__VALUE__:!0},n}get mediaStatsReport(){return this.diagnosticsReport.getMediaSessionStats(this.data.sessionId)}get realtimeTelemetryReport(){return this.diagnosticsReport.getTeamsRealtimeTelemetry(this.data.sessionId)}get e2eDiagnostics(){return this.diagnosticsReport.getDiagnosticsForE2eTests(this.data.sessionId)}set relayManager(n){this._relayManager=n}set isMultiParty(n){this.data.isMultiParty=n}set mediaLegId(n){this.data.mediaLegId=n.process()}set ETag(n){this.data.ETag=n}set configIds(n){this.data.configIds=n}set reconnect(n){this.data.reconnect=n}set relay(n){this.data.relay={address:n.addresses.join(),expires:n.expires,realm:n.realm,credentials:!(!n.username||!n.password),ports:[n.udpPort?`udp:${n.udpPort}`:"",n.tcpPort?`tcp:${n.tcpPort}`:"",n.tlsPort?`tls:${n.tlsPort}`:""].join(","),fqdns:n.fqdns?n.fqdns.join():"none"}}set sessionError(n){this.data.error=n}set dtmfResult(n){n?this.data.dtmfSuccessCount++:this.data.dtmfFailureCount++}set swMute(n){n?this.swMuteTracker.start():this.swMuteTracker.stop(),this.updateCommonMute()}set speakerMute(n){n?this.speakerMuteTracker.start():this.speakerMuteTracker.stop()}set hwSilent(n){n?this.hwSilentTracker.start():this.hwSilentTracker.stop()}set isSpeaking(n){n?this.isSpeakingTracker.start():this.isSpeakingTracker.stop()}set iceInitTime(n){this.data.iceInitTime||(this.data.iceInitTime=n)}set finalAnswerTime(n){this.data.finalAnswerTime||(this.data.finalAnswerTime=n)}set iceConnectedStateTimestamp(n){this.data.iceConnectedStateTime||(this.data.iceConnectedStateTime=n)}set allowedModalities(n){this.data.allowedAudioSend=n.audio.some(a=>Ur(a)),this.data.allowedVideoSend=n.video.some(a=>Ur(a)),this.data.allowedScreensharingSend=n.sharing.some(a=>Ur(a))}negotiationStart(n){var a;(a=this.data).initialNegotiationType??(a.initialNegotiationType=n),this.data.negotiationCount++}negotiationCompleted(n){this.data.initialNegotiationCompleted=!0,this.data.activeModalities=n,this.data.error=void 0}negotiationRejected(){this.data.rejectedNegotiationCount++}registerRollbackEvent(n){this.data.rollbackNegotiation.push({type:n.type,attempt:this.data.rollbackNegotiation.length+1,error:n.error})}registerRawMediaAccess(n,a,s){const c=this.data.rawMedia[n]?.[a];if(c){c.numAttempts++;const u=this.rawMediaTimers[n]?.[a];s?u?.start():u?.stop()}}registerQualityStateChangedEvent(n){switch(n.type){case"NoNetwork":n.value==="Good"?this.data.noIceCandidatesEventCount.good++:this.data.noIceCandidatesEventCount.bad++;break;case"NetworkRelaysNotReachable":n.value==="Good"?this.data.noRelayIceCandidatesEventCount.good++:this.data.noRelayIceCandidatesEventCount.bad++;break;case"DeviceCaptureNotFunctioning":this.deviceCaptureTracker.updateLevel(n.value),n.value==="Good"?this.data.microphoneInUseEventCount.good++:this.data.microphoneInUseEventCount.bad++;break;case"DeviceRenderNotFunctioning":this.deviceRenderTracker.updateLevel(n.value);break;case"VideoCapturerDeviceStartFailed":n.value==="Good"?this.data.cameraInUseEventCount.good++:this.data.cameraInUseEventCount.bad++;break;case"DeviceCaptureMute":n.value==="Bad"?this.osMuteTracker.start():this.osMuteTracker.stop(),this.updateCommonMute();break;case"NetworkRecvQuality":this.networkRecvTracker.updateLevel(n.value);break;case"NetworkSendQuality":this.networkSendTracker.updateLevel(n.value);break;case"ZeroCaptureDevicesEnumerated":this.zeroCaptureTracker.updateLevel(n.value);break;case"ZeroRenderDevicesEnumerated":this.zeroRenderTracker.updateLevel(n.value);break;case"VideoCaptureDeviceFreeze":n.value==="Good"?this.data.cameraFreezeEventCount.end++:this.data.cameraFreezeEventCount.start++}n.type!=="DeviceSpeakWhileMuted"&&Mo(this.data.ufds,{...n,timestamp:Date.now()},this.configProvider.config.diagnostics.collectionLimits.numUFDs)}registerRemoteQualityStateChangedEvent(n,a){n.forEach(s=>{var c,u,m;(c=this.data.remoteUfdsCount)[u=bw(s)]??(c[u]={});const b=this.data.remoteUfdsCount[bw(s)];b[m=s.value.toLowerCase()]??(b[m]=0),b[s.value.toLowerCase()]++,ld(this.data.remoteUfds,{...s,participantId:a,timestamp:Date.now()},this.configProvider.config.diagnostics.collectionLimits.numUFDs)})}registerTransportConnected(){this.transportDisconnected&&(this.transportDisconnected=!1,this.data.transportReconnectedCount++)}registerTransportDisconnected(){this.transportDisconnected=!0}registerTransportFailed(){this.transportDisconnected=!1}terminated(n){this.commonMuteTracker.stop(),this.swMuteTracker.stop(),this.osMuteTracker.stop(),this.speakerMuteTracker.stop(),this.hwSilentTracker.stop(),this.isSpeakingTracker.stop(),this.rawMediaTimers.audio.recv.stop(),this.rawMediaTimers.audio.send.stop(),this.networkSendTracker.dispose(),this.networkRecvTracker.dispose(),this.zeroCaptureTracker.dispose(),this.zeroRenderTracker.dispose(),this.deviceCaptureTracker.dispose(),this.data.terminationReason=fs(n),this.data.terminationTime=Date.now(),this.durationTimer.stop(),this.dmFragmenter.terminated(this.dmDiagnostics),this.ufdFragmenter.terminated(this.ufdDiagnostics)}addStatsError(n,a){const s=this.data.statsErrors.find(c=>c.error===a&&c.origin===n);this.logger.safe.error(`Stats error from '${n}': ${a} (${s?.count??1})`),s?s.count++:Mo(this.data.statsErrors,{origin:n,error:a,count:1},this.configProvider.config.diagnostics.collectionLimits.numStatsErrors)}newNativeSessionDiag(n=!0){let a;return a=new ETi(this.configProvider,this.dmDiagnostics,(s,c)=>this.addStatsError(s,c),s=>this.newNativeSessionDiag(s),()=>this.pushNativeSessionDiag(a.getObjectRef()),this.dshDiagnostics.resetState(),()=>this.getObjectRef()),n&&Mo(this.data.webrtcSessions,a.getObjectRef(),this.configProvider.config.diagnostics.collectionLimits.numNativeSessions),a}pushNativeSessionDiag(n){Mo(this.data.webrtcSessions,n,this.configProvider.config.diagnostics.collectionLimits.numNativeSessions)}getObjectRef(){return this.data}setBatteryLevel(n){this.data.batteryLevel=n}updateCommonMute(){this.swMuteTracker.isRunning||this.osMuteTracker.isRunning?this.commonMuteTracker.start():this.swMuteTracker.isRunning||this.osMuteTracker.isRunning||this.commonMuteTracker.stop()}registerElevation(n){ld(this.data.elevation,{event:n,timestamp:Date.now()},this.configProvider.config.diagnostics.collectionLimits.numElevation)}},ITi=class{constructor(n){this.fragmentBase=fs(n)}getFragment(n){const a=this.fragmentTerminated??n,s={};for(const[c,u]of Object.entries(a.count))for(const[m,b]of Object.entries(u)){const _=this.fragmentBase.count[c]?this.fragmentBase.count[c][m]:void 0,k=_?b-_:b;k&&(s[c]??(s[c]={}),s[c][m]=k)}return{count:s}}terminated(n){this.fragmentTerminated=fs(n)}},wTi=class{constructor(n){this.initTimestamp=Number.MIN_SAFE_INTEGER,this.terminatedTimestamp=Number.MAX_SAFE_INTEGER,this.fragmentBase=this.sanitizeDiagnostics(n),this.initTimestamp=Date.now()}getFragment(n){const a=this.fragmentTerminated??n;return{devicesChangeCount:a.devicesChangeCount-this.fragmentBase.devicesChangeCount,deviceSelectionChangeCount:a.deviceSelectionChangeCount-this.fragmentBase.deviceSelectionChangeCount,deviceSelectionChangeCountFromInterface:a.deviceSelectionChangeCountFromInterface-this.fragmentBase.deviceSelectionChangeCountFromInterface,devicesPollChangeCount:a.devicesPollChangeCount-this.fragmentBase.devicesPollChangeCount,audioSourceNumOfSuccessfulReopens:a.audioSourceNumOfSuccessfulReopens-this.fragmentBase.audioSourceNumOfSuccessfulReopens||void 0,audioSourceNumOfReopenRequests:a.audioSourceNumOfReopenRequests-this.fragmentBase.audioSourceNumOfReopenRequests||void 0,audioCaptureDeviceErrorFlag:n.audioCaptureDeviceErrorFlags.filter(s=>s.timestamp>this.initTimestamp&&s.timestamp<this.terminatedTimestamp).reduce((s,c)=>Number(BigInt(s)|BigInt(c.audioDeviceErrorFlag)),0),audioRenderDeviceErrorFlag:n.audioRenderDeviceErrorFlags.filter(s=>s.timestamp>this.initTimestamp&&s.timestamp<this.terminatedTimestamp).reduce((s,c)=>Number(BigInt(s)|BigInt(c.audioDeviceErrorFlag)),0)}}terminated(n){this.fragmentTerminated=this.sanitizeDiagnostics(n),this.terminatedTimestamp=Date.now()}sanitizeDiagnostics(n){return{devicesChangeCount:n.devicesChangeCount,deviceSelectionChangeCount:n.deviceSelectionChangeCount,deviceSelectionChangeCountFromInterface:n.deviceSelectionChangeCountFromInterface,devicesPollChangeCount:n.devicesPollChangeCount,audioSourceNumOfSuccessfulReopens:n.audioSourceNumOfSuccessfulReopens,audioSourceNumOfReopenRequests:n.audioSourceNumOfReopenRequests,audioCaptureDeviceErrorFlag:0,audioRenderDeviceErrorFlag:0}}},tg=class{constructor(){this.startTime=0,this.elapsedInternal=0,this.countInternal=0}get isRunning(){return!!this.startTime}get elapsed(){return Math.round(this.startTime?this.elapsedInternal+pp()-this.startTime:this.elapsedInternal)}get count(){return this.countInternal}start(){this.startTime||(this.startTime=pp(),this.countInternal++)}stop(){this.startTime&&(this.elapsedInternal+=pp()-this.startTime,this.startTime=0)}},_$=class{constructor(){this.currentLevel="Good",this.stopWatches={},this.startTime=pp(),this.getStopWatch(this.currentLevel).start()}updateLevel(n){this.currentLevel!==n&&(this.getStopWatch(this.currentLevel).stop(),this.currentLevel=n,this.getStopWatch(this.currentLevel).start())}getCount(n){const a=this.stopWatches[n];return a?a.count:0}getRatio(n){return Kne(this.getStopWatch(n).elapsed,Math.round((this.endTime||pp())-this.startTime))}dispose(n){this.getStopWatch(this.currentLevel).stop(),this.endTime=pp()}getStopWatch(n){let a=this.stopWatches[n];return a||(a=new tg,this.stopWatches[n]=a),a}};function Kne(n,a){return n/(a||1)}function kTi(n,a,s){return _l({recv:_l({id:a?.inboundRTP.id,ssrc:a?.inboundRTP.ssrc,mediaType:a?.inboundRTP.mediaType??a?.inboundRTP.kind,bytesReceived:_a(n.audio?.recv,c=>c.inboundRTP.bytesReceived),packetsReceived:_a(n.audio?.recv,c=>c.inboundRTP.packetsReceived),packetsLost:_a(n.audio?.recv,c=>c.inboundRTP.packetsLost),googCodecName:a?.codec?.mimeType.split("/").pop(),googTrackId:a?.track?.trackIdentifier,transport_id:a?.transport?.id,transportId:a?.inboundRTP.transportId,transport_selectedCandidatePairId:a?.transport?.selectedCandidatePairId,transport_dtlsCipher:a?.transport?.dtlsCipher,transport_srtpCipher:a?.transport?.srtpCipher,pair_id:a?.transport?.selectedCandidatePair?.id,pair_responsesSent:_a(n.audio?.recv,c=>c.transport?.selectedCandidatePair?.responsesSent),pair_requestsReceived:_a(n.audio?.recv,c=>c.transport?.selectedCandidatePair?.requestsReceived),pair_googRemoteCandidateType:a?.transport?.selectedCandidatePair?.remoteCandidate?.candidateType,pair_consentRequestsSent:_a(n.audio?.recv,c=>c.transport?.selectedCandidatePair?.consentRequestsSent),pair_googTransportType:a?.transport?.selectedCandidatePair?.localCandidate?.protocol,pair_googLocalCandidateType:a?.transport?.selectedCandidatePair?.localCandidate?.candidateType,pair_googWritable:a?.transport?.selectedCandidatePair?.writable,pair_requestsSent:_a(n.audio?.recv,c=>c.transport?.selectedCandidatePair?.requestsSent),pair_googRtt:_a(n.audio?.recv,c=>1e3*c.transport?.selectedCandidatePair?.currentRoundTripTime,!0),pair_googActiveConnection:a?.transport?.selectedCandidatePair?.nominated,pair_packetsDiscardedOnSend:a?.transport?.selectedCandidatePair?.packetsDiscardedOnSend,pair_bytesReceived:_a(n.audio?.recv,c=>c.transport?.selectedCandidatePair?.bytesReceived),pair_responsesReceived:_a(n.audio?.recv,c=>c.transport?.selectedCandidatePair?.responsesReceived),pair_remoteCandidateId:a?.transport?.selectedCandidatePair?.remoteCandidate?.id,pair_localCandidateId:a?.transport?.selectedCandidatePair?.localCandidate?.id,pair_packetsSent:_a(n.audio?.recv,c=>c.transport?.selectedCandidatePair?.packetsSent),pair_googLocalAddress:a?.transport?.selectedCandidatePair?.localCandidate?.ip??a?.transport?.selectedCandidatePair?.localCandidate?.address,pair_googRemoteAddress:a?.transport?.selectedCandidatePair?.remoteCandidate?.ip??a?.transport?.selectedCandidatePair?.remoteCandidate?.address,pair_bytesSent:_a(n.audio?.recv,c=>c.transport?.selectedCandidatePair?.bytesSent),pair_googReadable:a?.transport?.selectedCandidatePair?.nominated}),send:_l({id:s?.outboundRTP.id,ssrc:s?.outboundRTP.ssrc,mediaType:s?.outboundRTP.mediaType??s?.outboundRTP.kind,bytesSent:_a(n.audio?.send,c=>c.outboundRTP.bytesSent),packetsSent:_a(n.audio?.send,c=>c.outboundRTP.packetsSent),packetsLost:_a(n.audio?.send,c=>c.remoteInboundRTP?.packetsLost),googCodecName:s?.codec?.mimeType.split("/").pop(),googTrackId:s?.track?.trackIdentifier,transport_id:s?.transport?.id,transportId:s?.outboundRTP.transportId,transport_selectedCandidatePairId:s?.transport?.selectedCandidatePairId,transport_dtlsCipher:s?.transport?.dtlsCipher,transport_srtpCipher:s?.transport?.srtpCipher,pair_id:s?.transport?.selectedCandidatePair?.id,pair_responsesSent:_a(n.audio?.send,c=>c.transport?.selectedCandidatePair?.responsesSent),pair_requestsReceived:_a(n.audio?.send,c=>c.transport?.selectedCandidatePair?.requestsReceived),pair_googRemoteCandidateType:s?.transport?.selectedCandidatePair?.remoteCandidate?.candidateType,pair_consentRequestsSent:_a(n.audio?.send,c=>c.transport?.selectedCandidatePair?.consentRequestsSent),pair_googTransportType:s?.transport?.selectedCandidatePair?.localCandidate?.protocol,pair_googLocalCandidateType:s?.transport?.selectedCandidatePair?.localCandidate?.candidateType,pair_googWritable:s?.transport?.selectedCandidatePair?.writable,pair_requestsSent:_a(n.audio?.send,c=>c.transport?.selectedCandidatePair?.requestsSent),pair_googRtt:_a(n.audio?.send,c=>1e3*c.transport?.selectedCandidatePair?.currentRoundTripTime,!0),pair_googActiveConnection:s?.transport?.selectedCandidatePair?.nominated,pair_packetsDiscardedOnSend:s?.transport?.selectedCandidatePair?.packetsDiscardedOnSend,pair_bytesReceived:_a(n.audio?.send,c=>c.transport?.selectedCandidatePair?.bytesReceived),pair_responsesReceived:_a(n.audio?.send,c=>c.transport?.selectedCandidatePair?.responsesReceived),pair_remoteCandidateId:s?.transport?.selectedCandidatePair?.remoteCandidate?.id,pair_localCandidateId:s?.transport?.selectedCandidatePair?.localCandidate?.id,pair_packetsSent:_a(n.audio?.send,c=>c.transport?.selectedCandidatePair?.packetsSent),pair_googLocalAddress:s?.transport?.selectedCandidatePair?.localCandidate?.ip??s?.transport?.selectedCandidatePair?.localCandidate?.address,pair_googRemoteAddress:s?.transport?.selectedCandidatePair?.remoteCandidate?.ip??s?.transport?.selectedCandidatePair?.remoteCandidate?.address,pair_bytesSent:_a(n.audio?.send,c=>c.transport?.selectedCandidatePair?.bytesSent),pair_googReadable:s?.transport?.selectedCandidatePair?.nominated})})}function iJe(n,a,s,c){return _l({recv:_l({id:s?.inboundRTP.id,ssrc:s?.inboundRTP.ssrc,mediaType:s?.inboundRTP.mediaType??s?.inboundRTP.kind,bytesReceived:_a(a[n]?.recv,u=>u.inboundRTP.bytesReceived),packetsReceived:_a(a[n]?.recv,u=>u.inboundRTP.packetsReceived),packetsLost:_a(a[n]?.recv,u=>u.inboundRTP.packetsLost),googCodecName:s?.codec?.mimeType.split("/").pop(),codecImplementationName:s?.inboundRTP.decoderImplementation,googTrackId:s?.track?.trackIdentifier,transport_id:s?.transport?.id,transportId:s?.inboundRTP.transportId,transport_selectedCandidatePairId:s?.transport?.selectedCandidatePairId,transport_dtlsCipher:s?.transport?.dtlsCipher,transport_srtpCipher:s?.transport?.srtpCipher,pair_id:s?.transport?.selectedCandidatePair?.id,pair_responsesSent:_a(a[n]?.recv,u=>u.transport?.selectedCandidatePair?.responsesSent),pair_requestsReceived:_a(a[n]?.recv,u=>u.transport?.selectedCandidatePair?.requestsReceived),pair_googRemoteCandidateType:s?.transport?.selectedCandidatePair?.remoteCandidate?.candidateType,pair_consentRequestsSent:_a(a[n]?.recv,u=>u.transport?.selectedCandidatePair?.consentRequestsSent),pair_googTransportType:s?.transport?.selectedCandidatePair?.localCandidate?.protocol,pair_googLocalCandidateType:s?.transport?.selectedCandidatePair?.localCandidate?.candidateType,pair_googWritable:s?.transport?.selectedCandidatePair?.writable,pair_requestsSent:_a(a[n]?.recv,u=>u.transport?.selectedCandidatePair?.requestsSent),pair_googRtt:_a(a[n]?.recv,u=>1e3*u.transport?.selectedCandidatePair?.currentRoundTripTime,!0),pair_googActiveConnection:s?.transport?.selectedCandidatePair?.nominated,pair_packetsDiscardedOnSend:s?.transport?.selectedCandidatePair?.packetsDiscardedOnSend,pair_bytesReceived:_a(a[n]?.recv,u=>u.transport?.selectedCandidatePair?.bytesReceived),pair_responsesReceived:_a(a[n]?.recv,u=>u.transport?.selectedCandidatePair?.responsesReceived),pair_remoteCandidateId:s?.transport?.selectedCandidatePair?.remoteCandidate?.id,pair_localCandidateId:s?.transport?.selectedCandidatePair?.localCandidate?.id,pair_packetsSent:_a(a[n]?.recv,u=>u.transport?.selectedCandidatePair?.packetsSent),pair_googLocalAddress:s?.transport?.selectedCandidatePair?.localCandidate?.ip??s?.transport?.selectedCandidatePair?.localCandidate?.address,pair_googRemoteAddress:s?.transport?.selectedCandidatePair?.remoteCandidate?.ip??s?.transport?.selectedCandidatePair?.remoteCandidate?.address,pair_bytesSent:_a(a[n]?.recv,u=>u.transport?.selectedCandidatePair?.bytesSent),pair_googReadable:s?.transport?.selectedCandidatePair?.nominated,framesDecoded:_a(a[n]?.recv,u=>u.inboundRTP.framesDecoded),googFrameHeightReceived:_a(a[n]?.recv,u=>u.inboundRTP.frameHeight),googFrameWidthReceived:_a(a[n]?.recv,u=>u.inboundRTP.frameWidth),googFrameRateReceived:_a(a[n]?.recv,u=>u.extensions?.frameRateReceived||0),googNacksSent:_a(a[n]?.recv,u=>u.inboundRTP.nackCount),googPlisSent:_a(a[n]?.recv,u=>u.inboundRTP.pliCount),keyFramesDecoded:_a(a[n]?.recv,u=>u.inboundRTP.keyFramesDecoded),googFirsSent:_a(a[n]?.recv,u=>u.inboundRTP.firCount),googJitterBufferMs:_a(a[n]?.recv,u=>u.extensions?.jitterBufferMs),googFrameRateDecoded:_a(a[n]?.recv,u=>u.extensions?.frameRateDecoded||0),googFrameRateOutput:s?.extensions?.trackRecvFps,jitter:s?.inboundRTP.jitter}),send:_l({id:c?.outboundRTP.id,ssrc:c?.outboundRTP.ssrc,mediaType:c?.outboundRTP.mediaType??c?.outboundRTP.kind,bytesSent:_a(a[n]?.send,u=>u.outboundRTP.bytesSent),packetsSent:_a(a[n]?.send,u=>u.outboundRTP.packetsSent),packetsLost:_a(a[n]?.send,u=>u.remoteInboundRTP?.packetsLost),googCodecName:c?.codec?.mimeType.split("/").pop(),codecImplementationName:c?.outboundRTP.encoderImplementation,googTrackId:c?.track?.trackIdentifier,transport_id:c?.transport?.id,transportId:c?.outboundRTP.transportId,transport_selectedCandidatePairId:c?.transport?.selectedCandidatePairId,transport_dtlsCipher:c?.transport?.dtlsCipher,transport_srtpCipher:c?.transport?.srtpCipher,pair_id:c?.transport?.selectedCandidatePair?.id,pair_responsesSent:_a(a[n]?.send,u=>u.transport?.selectedCandidatePair?.responsesSent),pair_requestsReceived:_a(a[n]?.send,u=>u.transport?.selectedCandidatePair?.requestsReceived),pair_googRemoteCandidateType:c?.transport?.selectedCandidatePair?.remoteCandidate?.candidateType,pair_consentRequestsSent:_a(a[n]?.send,u=>u.transport?.selectedCandidatePair?.consentRequestsSent),pair_googTransportType:c?.transport?.selectedCandidatePair?.localCandidate?.protocol,pair_googLocalCandidateType:c?.transport?.selectedCandidatePair?.localCandidate?.candidateType,pair_googWritable:c?.transport?.selectedCandidatePair?.writable,pair_requestsSent:_a(a[n]?.send,u=>u.transport?.selectedCandidatePair?.requestsSent),pair_googRtt:_a(a[n]?.send,u=>1e3*u.transport?.selectedCandidatePair?.currentRoundTripTime,!0),pair_googActiveConnection:c?.transport?.selectedCandidatePair?.nominated,pair_packetsDiscardedOnSend:c?.transport?.selectedCandidatePair?.packetsDiscardedOnSend,pair_bytesReceived:_a(a[n]?.send,u=>u.transport?.selectedCandidatePair?.bytesReceived),pair_responsesReceived:_a(a[n]?.send,u=>u.transport?.selectedCandidatePair?.responsesReceived),pair_remoteCandidateId:c?.transport?.selectedCandidatePair?.remoteCandidate?.id,pair_localCandidateId:c?.transport?.selectedCandidatePair?.localCandidate?.id,pair_packetsSent:_a(a[n]?.send,u=>u.transport?.selectedCandidatePair?.packetsSent),pair_googLocalAddress:c?.transport?.selectedCandidatePair?.localCandidate?.ip??c?.transport?.selectedCandidatePair?.localCandidate?.address,pair_googRemoteAddress:c?.transport?.selectedCandidatePair?.remoteCandidate?.ip??c?.transport?.selectedCandidatePair?.remoteCandidate?.address,pair_bytesSent:_a(a[n]?.send,u=>u.transport?.selectedCandidatePair?.bytesSent),pair_googReadable:c?.transport?.selectedCandidatePair?.nominated,framesEncoded:_a(a[n]?.send,u=>u.outboundRTP.framesEncoded),googNacksReceived:_a(a[n]?.send,u=>u.outboundRTP.nackCount),googPlisReceived:_a(a[n]?.send,u=>u.outboundRTP.pliCount),googFirsReceived:_a(a[n]?.send,u=>u.outboundRTP.firCount),keyFramesEncoded:_a(a[n]?.send,u=>u.outboundRTP.keyFramesEncoded),googFrameHeightInput:c?.mediaSource?.height,googFrameWidthInput:c?.mediaSource?.width,googFrameRateInput:_a(a[n]?.send,u=>u.mediaSource?.framesPerSecond),googFrameHeightSent:_a(a[n]?.send,u=>u.outboundRTP.frameHeight),googFrameWidthSent:_a(a[n]?.send,u=>u.outboundRTP.frameWidth),googFrameRateSent:_a(a[n]?.send,u=>u.extensions?.frameRateSent),googRtt:_a(a[n]?.send,u=>1e3*(u.remoteInboundRTP?.roundTripTime??0),!0),hugeFramesSent:c?.outboundRTP.hugeFramesSent,qpSum:_a(a[n]?.send,u=>u.outboundRTP.qpSum),qualityLimitationDurations:c?JSON.stringify(c?.outboundRTP.qualityLimitationDurations):void 0,qualityLimitationReason:c?.outboundRTP.qualityLimitationReason,qualityLimitationResolutionChanges:c?.outboundRTP.qualityLimitationResolutionChanges,jitter:c?.remoteInboundRTP?.jitter,retransmittedPacketsSent:_a(a[n]?.send,u=>u.outboundRTP.retransmittedPacketsSent)})})}function RTi(n,a,s){const c=a.config.diagnostics.telemetryLimits,u=n.aggregatedModalityStats,m=_f(u.audio?.recv),b=_f(u.audio?.send),_=_f(u.video?.recv),k=_f(u.video?.send),N=_f(u.sharing?.recv),W=_f(u.sharing?.send),ee=ze=>ze&&K0(fs(ze).map(He=>Fb(K0(He.events,c.numCapabilitiesApplied,1),"timestamp",n.startTime)),a.config.diagnostics.telemetryLimits.numCapabilitiesRequested),oe=ee(n.qualityManager?.videoMaxCapabilitiesEvents),de=ee(n.qualityManager?.videoMaxCapabilitiesErrors),se=ee(n.qualityManager?.sharingMaxCapabilitiesEvents),Re=ee(n.qualityManager?.sharingMaxCapabilitiesErrors),ue=n.negotiation.bweType!=="REMB"?n.bandwidthReport:void 0,Ne=n.negotiation.bweType==="REMB"?n.bandwidthReport:void 0;return _l({BundlePolicy:n.bundlePolicy,FakeIceCandidate:n.negotiation.fakeCandidate,h264AvailableProfiles:JSON.stringify(n.H264Profiles),h264CodecCapabilities:JSON.stringify(n.h264CodecCapabilities),IceConnectionState:n.transportState?.iceConnectionState,IceConnectionStatePrevious:n.transportState?.iceConnectionStatePrevious,IceServers:n.iceServers,IceTransportPolicy:n.iceTransportPolicy,NegotiatedSrtp:JSON.stringify(n.negotiation.negotiatedSrtp),OfferedSrtp:JSON.stringify(n.negotiation.offeredSrtp),RelayCandidate:n.relayCandidate,SdpSemantics:n.sdpSemantics,iceCandidateErrors:JSON.stringify(n.iceCandidateErrors),SignalingState:n.transportState?.signalingState,SignalingStatePrevious:n.transportState?.signalingStatePrevious,WebRTCStats_statsErrors:JSON.stringify(s),MaxSessionBandwidth:n.maxSessionBandwidth,Bandwidth_uplinkStabilizationTime:JSON.stringify(n.bwStabilizationTime),Bandwidth_downlinkStabilizationTime:JSON.stringify(n.bwDownlinkStabilizationTime),totalVideoControlMessages:n.qualityManager?.numVideoControlMessages,outOfOrderVideoControlMessages:n.qualityManager?.numOutOfOrderVideoControlMessages,webcamFreezeIntervals:n.qualityManager?.numWebcamFreezeIntervals,processedStreamFreezeIntervals:n.qualityManager?.numProcessedStreamFreezeIntervals,IPAddress:n.IPAddress??"none",ReflexiveLocalIP:n.reflexiveLocalIP??"none",NumberOfInterfaces:n.numInterfaces,StartTime:n.startTime,EndTime:n.endTime,AudioTransportRecvBitrate:m?.transport?.extensions?.recvBWAvg,AudioTransportSendBitrate:m?.transport?.extensions?.sendBWAvg,AudioPayloadRecvBitrate:m?.aggregated?.bitrateAvg,AudioPayloadSendBitrate:b?.aggregated?.bitrateAvg,VideoPayloadRecvBitrate:_?.aggregated?.bitrateAvg,VideoPayloadSendBitrate:k?.aggregated?.bitrateAvg,WebRTCStats_bweStat_googAvailableReceiveBandwidth:_a(u.video?.recv,ze=>ze.transport?.selectedCandidatePair?.availableIncomingBitrate)??_a(u.video?.send,ze=>ze.transport?.selectedCandidatePair?.availableIncomingBitrate),WebRTCStats_bweStat_googAvailableSendBandwidth:_a(u.video?.send,ze=>ze.transport?.selectedCandidatePair?.availableOutgoingBitrate)??_a(u.video?.recv,ze=>ze.transport?.selectedCandidatePair?.availableOutgoingBitrate),Bandwidth_jumpsHistogram:JSON.stringify(k?.transport?.extensions?.bwJumpsHistogram),StartCallBWESendSide:JSON.stringify(ue?.startOfTheCall),EndCallBWESendSide:JSON.stringify(ue?.endOfTheCall),BWEStdSendSide:JSON.stringify(ue?.std),BwPercentilesSendSide:JSON.stringify(ue?.bwPercentiles),AvgBwSendSide:JSON.stringify(ue?.avgBwe),StartCallBWE:JSON.stringify(Ne?.startOfTheCall),EndCallBWE:JSON.stringify(Ne?.endOfTheCall),BWEStd:JSON.stringify(Ne?.std),BwPercentiles:JSON.stringify(Ne?.bwPercentiles),AvgBw:JSON.stringify(Ne?.avgBwe),WebRTCStats_ssrc:_l({audio:kTi(u,m,b),video:iJe("video",u,_,k),sharing:iJe("sharing",u,N,W)}),Audio_recv_jitterBufferAvgSize:m?.aggregated?.avgJitterBufferSize,Audio_recv_packetsLostRateMax:oa(m?.aggregated?.lossRateMax,6),Audio_recv_jitterAvg:m?.aggregated?.jitterAvg,Audio_recv_jitterMax:m?.aggregated?.jitterMax,Audio_recv_networkAvgLossRate:oa(m?.aggregated?.networkAvgLossRate,6),Audio_recv_packetsLostAvg:m?.aggregated?.packetsLostAvg,Audio_recv_healedRatioAvg:m?.aggregated?.healedRatioAvg,Audio_recv_healedRatioMax:m?.aggregated?.healedRatioMax,Audio_send_rttAvg:b?.aggregated?.rttAvg&&oa(1e3*b.aggregated.rttAvg),Audio_send_rttMax:b?.aggregated?.rttMax&&oa(1e3*b.aggregated.rttMax),Audio_send_RawInputVolume:_a(u.audio?.send,ze=>ze.aggregated?.rawInputVolume),Audio_send_packetsLostRateMax:oa(b?.aggregated?.lossRateMax,6),Audio_send_presentationAPIUserDuration:n.presentationAPIUserDuration,Audio_send_presentationDuration:n.presentationAudioDuration,Video_recv_DurationSeconds:_?.aggregated?.duration,Video_recv_FreezeHistogram:JSON.stringify(_?.aggregated?.freezeCountHistogram),Video_recv_FreezeTimestamps:JSON.stringify(gV(_?.aggregated?.freezeTimestampsHistogram,n.startTime,c.numOfHistogramSamples)),Video_recv_LongestFreezeDuration:_?.aggregated?.longestFreeze,Video_recv_OngoingFreeze:_?.extensions?.isFrozen,Video_recv_OngoingFreezeDuration:_?.aggregated?.ongoingFreezeDuration,Video_recv_TotalFreezeDuration:_?.aggregated?.totalFreezeDuration,Video_recv_RecvAvgFreezeDuration:_?.aggregated?.avgFreezeDuration,Video_recv_NumResolutionSwitches:_?.aggregated?.numResolutionSwitches,Video_recv_ResolutionDurations:JSON.stringify(_?.aggregated?.resolutionDurations),Video_recv_StreamsMax:n.recvVideoStreamCount.max,Video_recv_StreamsMin:n.recvVideoStreamCount.min,Video_recv_StreamsMode:n.recvVideoStreamCount.mode,Video_recv_TimeToFirstFrame:n.remoteVideoManager?.firstTimeToFirstFrameVideo,Video_recv_TimeToFirstFrameSinceSubscriptionStart:n.remoteVideoManager?.firstTimeToFirstFrameVideo,Video_recv_bitrateAvg:_?.aggregated?.bitrateAvg,Video_recv_bitrateMax:_?.aggregated?.bitrateMax,Video_recv_frameRateAvg:_?.aggregated?.avgFrameRate,Video_recv_jitterBufferAvgSize:_?.aggregated?.avgJitterBufferSize,Video_recv_packetsLostRateMax:oa(_?.aggregated?.lossRateMax,6),Video_recv_isRenderingEvents:JSON.stringify(K0(n.remoteVideoManager?.isRenderingEvents.video,c.numIsRenderingEvents)),Video_recv_FpsHarmonicAverage:_?.aggregated?.fpsHarmonicAverage,Video_recv_PreferredResolution:n.remoteVideoManager?.preferredResolution.video?.toString(),Video_recv_statsOnSubscribed:JSON.stringify(n.statsOnSubscribed.video),Video_SubscriptionEvents:JSON.stringify(Fb(n.subscriptionManager?.video.events,"ts",n.startTime)),Video_SubscriptionCounters:JSON.stringify(n.subscriptionManager?.video.counters),Video_send_CaptureFramerateAvg:k?.aggregated?.captureFramerateAvg,Video_send_DurationSeconds:k?.aggregated?.duration,Video_send_FreezeIntervals:k?.extensions?.captureFreezeIntervalsCount,Video_send_MaxCapabilities:JSON.stringify(oe),Video_send_MaxCapabilitiesErrors:JSON.stringify(de),Video_send_OvershootDurations:JSON.stringify({fs:k?.aggregated?.totalFsOvershootDuration,fps:k?.aggregated?.totalFpsOvershootDuration,br:k?.aggregated?.totalBrOvershootDuration}),Video_send_OvershootEvents:cd(k?.aggregated?.overshootEvents,c.numOvershootEvents,"timestamp",n.startTime),Video_send_QpAvg:k?.aggregated?.qpAvg,Video_send_bitrateAvg:k?.aggregated?.bitrateAvg,Video_send_bitrateMax:k?.aggregated?.bitrateMax,Video_send_frameRateAvg:k?.aggregated?.frameRateAvg,Video_send_AllocateBWAvg:k?.aggregated?.bweAvg,Video_send_CameraOpenWidth:k?.extensions?.cameraOpenResolution?.width,Video_send_CameraOpenHeight:k?.extensions?.cameraOpenResolution?.height,Video_send_packetsLostRateMax:oa(k?.aggregated?.lossRateMax,6),Video_send_resolutionSwitches:JSON.stringify(k?.aggregated?.resolutionSwitches),Video_send_performanceEvents:cd(n.localVideoPerformanceEvents,c.numPerformanceEvents,"timestamp",n.startTime),Video_send_Simulcast:JSON.stringify(n.simulcast?.video),Video_send_powerEfficientEncoderEvents:cd(k?.extensions?.powerEfficientEncoderEvents,c.numPowerEfficientEncoderEvents,"timestamp",n.startTime),Video_send_powerEfficientEncoderEventOnCount:k?.extensions?.powerEfficientEncoderEventOnCount,Video_send_powerEfficientEncoderEventOffCount:k?.extensions?.powerEfficientEncoderEventOffCount,Sharing_recv_DurationSeconds:N?.aggregated?.duration,Sharing_recv_FreezeHistogram:JSON.stringify(N?.aggregated?.freezeCountHistogram),Sharing_recv_FreezeTimestamps:JSON.stringify(gV(N?.aggregated?.freezeTimestampsHistogram,n.startTime,c.numOfHistogramSamples)),Sharing_recv_LongestFreezeDuration:N?.aggregated?.longestFreeze,Sharing_recv_OngoingFreeze:N?.extensions?.isFrozen,Sharing_recv_TotalFreezeDuration:N?.aggregated?.totalFreezeDuration,Sharing_recv_RecvAvgFreezeDuration:N?.aggregated?.avgFreezeDuration,Sharing_recv_NumResolutionSwitches:N?.aggregated?.numResolutionSwitches,Sharing_recv_ResolutionDurations:JSON.stringify(N?.aggregated?.resolutionDurations),Sharing_recv_StreamsMax:n.recvVideoStreamCount.max,Sharing_recv_StreamsMin:n.recvVideoStreamCount.min,Sharing_recv_StreamsMode:n.recvVideoStreamCount.mode,Sharing_recv_TimeToFirstFrame:n.remoteVideoManager?.firstTimeToFirstFrameSharing,Sharing_recv_TimeToFirstFrameSinceSubscriptionStart:n.remoteVideoManager?.firstTimeToFirstFrameVideo,Sharing_recv_bitrateAvg:N?.aggregated?.bitrateAvg,Sharing_recv_bitrateMax:N?.aggregated?.bitrateMax,Sharing_recv_frameRateAvg:N?.aggregated?.avgFrameRate,Sharing_recv_jitterBufferAvgSize:N?.aggregated?.avgJitterBufferSize,Sharing_recv_packetsLostRateMax:oa(N?.aggregated?.lossRateMax,6),Sharing_recv_FpsHarmonicAverage:N?.aggregated?.fpsHarmonicAverage,Sharing_recv_isRenderingEvents:JSON.stringify(K0(n.remoteVideoManager?.isRenderingEvents.sharing,c.numIsRenderingEvents)),Sharing_recv_PreferredResolution:n.remoteVideoManager?.preferredResolution.sharing?.toString(),Sharing_recv_statsOnSubscribed:JSON.stringify(n.statsOnSubscribed.sharing),Sharing_SubscriptionEvents:JSON.stringify(Fb(n.subscriptionManager?.sharing.events,"ts",n.startTime)),Sharing_SubscriptionCounters:JSON.stringify(n.subscriptionManager?.sharing.counters),Sharing_send_CaptureFramerateAvg:W?.aggregated?.captureFramerateAvg,Sharing_send_DurationSeconds:W?.aggregated?.duration,Sharing_send_MaxCapabilities:JSON.stringify(se),Sharing_send_MaxCapabilitiesErrors:JSON.stringify(Re),Sharing_send_OvershootDurations:JSON.stringify({fs:W?.aggregated?.totalFsOvershootDuration,fps:W?.aggregated?.totalFpsOvershootDuration,br:W?.aggregated?.totalBrOvershootDuration}),Sharing_send_resolutionSwitches:W?.aggregated?.resolutionSwitches,Sharing_send_OvershootEvents:cd(W?.aggregated?.overshootEvents,c.numOvershootEvents,"timestamp",n.startTime),Sharing_send_QpAvg:W?.aggregated?.qpAvg,Sharing_send_bitrateAvg:W?.aggregated?.bitrateAvg,Sharing_send_bitrateMax:W?.aggregated?.bitrateMax,Sharing_send_frameRateAvg:W?.aggregated?.frameRateAvg,Sharing_send_AllocateBWAvg:W?.aggregated?.bweAvg,Sharing_send_packetsLostRateMax:oa(W?.aggregated?.lossRateMax,6),Sharing_send_Simulcast:JSON.stringify(n.simulcast?.sharing),Data_ProtocolCounters:JSON.stringify(n.dataChannel?.protocolCounters),Data_Error:n.dataChannel?.error,Data_SessionState:n.dataChannelSessionState?.toString(),Data_CreateChannelError:n.dataChannelCreationError,multipleVideoStreams:JSON.stringify(Fb(n.multiViewStats,"startTime",n.startTime)),ReportedReceiveBandwidth:JSON.stringify(n.reportedReceiveBandwidth),ReportedSendBandwidth:JSON.stringify(n.reportedSendBandwidthLayouts),OvcToSubscriptions:JSON.stringify(n.ovcToSubscriptionEvents),EncodedStreamWorker:n.encodedStreamWorker,AudioCodecEvents:JSON.stringify(n.audioCodecEvents),HevcCodecSupport:JSON.stringify(n.codecSupport),MeetingScenario:JSON.stringify(n.negotiation.meetingScenario),IsTownHall:n.negotiation.isTownHall,InitialBWSeed:n.initialBWSeed,SentBWSeed:n.sentBWSeed,videoPerformanceEvent:JSON.stringify(n.videoPerformanceEvent),EarlyMedia_NumStatsPolls:n.earlyMediaNumStatsPolls})}var kTe=n=>_l({id:n.outboundRTP.ssrc.toString(),codecName:n.codec?.mimeType?.split("/").pop().toUpperCase(),bitrate:n.extensions?.bitrate,jitter:n.remoteInboundRTP?.jitter,packets:n.outboundRTP.packetsSent,packetsPerSecond:n.extensions?.packetsPerSecond,packetsLost:n.remoteInboundRTP?.packetsLost,packetsLostPerSecond:n.extensions?.packetsLostPerSecond,rtt:n.remoteInboundRTP?.roundTripTime,frameRateInput:n.mediaSource?.framesPerSecond,frameWidthInput:n.mediaSource?.width,frameHeightInput:n.mediaSource?.height,framesEncoded:n.outboundRTP.framesEncoded,frameRateEncoded:n.extensions?.frameRateEncoded,framesSent:n.outboundRTP.framesSent,frameRateSent:n.extensions?.frameRateSent,frameWidthSent:n.outboundRTP.frameWidth,frameHeightSent:n.outboundRTP.frameHeight,keyFramesEncoded:n.outboundRTP.keyFramesEncoded,nackCount:n.outboundRTP.nackCount,firCount:n.outboundRTP.firCount,pliCount:n.outboundRTP.pliCount,transportId:n.outboundRTP.transportId,isFsOvershooting:n.extensions?.isFsOvershooting,isFpsOvershooting:n.extensions?.isFpsOvershooting,isBrOvershooting:n.extensions?.isBrOvershooting,totalFsOvershootDuration:n.extensions?.totalFsOvershootDuration,totalFpsOvershootDuration:n.extensions?.totalFpsOvershootDuration,totalBrOvershootDuration:n.extensions?.totalBrOvershootDuration,altLayouts:n.altLayouts?.map(kTe)}),nJe=n=>_l({id:n.inboundRTP.ssrc.toString(),codecName:n.codec?.mimeType?.split("/").pop().toUpperCase(),bitrate:n.extensions?.bitrate,jitter:n.inboundRTP.jitter,packets:n.inboundRTP.packetsReceived,packetsPerSecond:n.extensions?.packetsPerSecond,packetsLost:n.inboundRTP.packetsLost,packetsLostPerSecond:n.extensions?.packetsLostPerSecond,packetsDiscarded:n.inboundRTP.packetsDiscarded,rtt:n.remoteOutboundRTP?.roundTripTime,msi:n.renderer?.msi,jitterBufferMs:n.extensions?.jitterBufferMs,frameRateOutput:n.extensions?.frameRateDecoded,frameRateDecoded:n.extensions?.frameRateDecoded,frameRateReceived:n.extensions?.frameRateReceived,frameWidthReceived:n.inboundRTP.frameWidth,frameHeightReceived:n.inboundRTP.frameHeight,longestFreezeDuration:n.extensions?.longestFreeze,totalFreezeDuration:n.extensions?.totalFreezeDuration,framesReceived:n.inboundRTP.framesReceived,framesDropped:n.inboundRTP.framesDropped,framesDecoded:n.inboundRTP.framesDecoded,keyFramesDecoded:n.inboundRTP.keyFramesDecoded,nackCount:n.inboundRTP.nackCount,firCount:n.inboundRTP.firCount,pliCount:n.inboundRTP.pliCount,transportId:n.inboundRTP.transportId}),MTi=n=>_l({id:n.outboundRTP.ssrc.toString(),codecName:n.codec?.mimeType?.split("/").pop().toUpperCase(),bitrate:n.extensions?.bitrate,jitter:n.remoteInboundRTP?.jitter,packets:n.outboundRTP.packetsSent,packetsPerSecond:n.extensions?.packetsPerSecond,packetsLost:n.remoteInboundRTP?.packetsLost,packetsLostPerSecond:n.extensions?.packetsLostPerSecond,packetsDiscarded:n.remoteInboundRTP?.packetsDiscarded,rtt:n.remoteInboundRTP?.roundTripTime,audioLevel:n.mediaSource?.audioLevel,transportId:n.outboundRTP.transportId}),PTi=n=>_l({id:n.inboundRTP.ssrc.toString(),codecName:n.codec?.mimeType?.split("/").pop().toUpperCase(),bitrate:n.extensions?.bitrate,jitter:n.inboundRTP.jitter,packets:n.inboundRTP.packetsReceived,packetsPerSecond:n.extensions?.packetsPerSecond,packetsLost:n.inboundRTP.packetsLost,packetsLostPerSecond:n.extensions?.packetsLostPerSecond,packetsDiscarded:n.inboundRTP.packetsDiscarded,rtt:n.remoteOutboundRTP?.roundTripTime,jitterBufferMs:n.extensions?.jitterBufferMs,audioLevel:n.inboundRTP.audioLevel,healedRatio:n.extensions?.healedRatio,transportId:n.inboundRTP.transportId}),DTi=n=>_l({id:n.id,state:n.state,dataChannelIdentifier:n.dataChannelIdentifier,messagesSent:n.messagesSent,bytesSent:n.bytesSent,messagesReceived:n.messagesReceived,bytesReceived:n.bytesReceived,sendBitrate:n.extensions?.sendBitrate,recvBitrate:n.extensions?.recvBitrate,messagesSentPerSecond:n.extensions?.sendMessageRate,messagesReceivedPerSecond:n.extensions?.recvMessageRate}),LTi=n=>_l({id:n.id,rtt:n.selectedCandidatePair?.currentRoundTripTime,availableIncomingBitrate:n.selectedCandidatePair?.availableIncomingBitrate,availableOutgoingBitrate:n.selectedCandidatePair?.availableOutgoingBitrate,relayProtocol:n.selectedCandidatePair?.localCandidate?.relayProtocol,candidateType:`${n.selectedCandidatePair?.localCandidate?.candidateType??""}:${n.selectedCandidatePair?.remoteCandidate?.candidateType??""}`});function OTi(n){return(n.audio?.send??[]).map(MTi)}function NTi(n){return(n.audio?.recv??[]).map(PTi)}function xTi(n){return n.video?.send?.length?n.video.send.map(kTe):[]}function BTi(n){return(n.video?.recv??[]).map(nJe)}function FTi(n){return n.sharing?.send?.length?n.sharing.send.map(kTe):[]}function UTi(n){return(n.sharing?.recv??[]).map(nJe)}function zTi(n){return(n.data??[]).map(DTi)}function VTi(n){return Object.values(n.transports??{}).map(LTi)}function $Ti(n){return{audio:{send:OTi(n),recv:NTi(n)},video:{send:xTi(n),recv:BTi(n)},screenShare:{send:FTi(n),recv:UTi(n)},data:zTi(n),transports:VTi(n)}}function HTi(n,a){const s=n.qualityManager&&K0(fs(n.qualityManager.videoMaxCapabilitiesEvents),a.config.diagnostics.telemetryLimits.numCapabilitiesRequested),c=n.qualityManager&&K0(fs(n.qualityManager.sharingMaxCapabilitiesEvents),a.config.diagnostics.telemetryLimits.numCapabilitiesRequested);return _l({Video_SubscriptionEvents:JSON.stringify(n.subscriptionManager?.video.events),Sharing_SubscriptionEvents:JSON.stringify(n.subscriptionManager?.sharing.events),Video_send_MaxCapabilities:JSON.stringify(s),Sharing_send_MaxCapabilities:JSON.stringify(c),RelayCandidate:n.relayCandidate,Video_recv_TimeToFirstFrame:n.remoteVideoManager?.firstTimeToFirstFrameVideo,Sharing_recv_TimeToFirstFrame:n.remoteVideoManager?.firstTimeToFirstFrameSharing,Video_recv_TimeToFirstFrameSinceSubscriptionStart:n.remoteVideoManager?.timeToFirstFrameSinceSubscriptionStartVideo,Sharing_recv_TimeToFirstFrameSinceSubscriptionStart:n.remoteVideoManager?.timeToFirstFrameSinceSubscriptionStartSharing,IceServers:n.iceServers})}function jTi(n,a,s){return _l({DeviceEvents:JSON.stringify(Fb(s.deviceManager.deviceTelemetryEvents.filter(c=>c.timestamp>a),"timestamp",n.creationTime)),IceConnectedStateTime:1e4*n.iceConnectedStateTime})}function GTi(n,a,s,c){const u=c.config.diagnostics.telemetryLimits,m=n.webrtcSessions[n.webrtcSessions.length-1];return _l({MediaLegId:n.mediaLegId,CreationTime:ww(n.creationTime),CallNumber:n.callNumber,SessionId:n.sessionId,MultiParty:n.isMultiParty,ErrorType:n.error?.type??"none",ErrorDetail:n.error?.detail??"none",IncompatibleOffer:n.error?.type===ke.MEDIA_ERROR.incompatibleOffer,TerminationTime:ww(n.terminationTime),TerminationReason_code:n.terminationReason?.code,TerminationReason_subCode:n.terminationReason?.subCode,TerminationReason_phrase:n.terminationReason?.phrase,TerminationReason_remoteTerminated:n.terminationReason?.remoteTerminated,TerminationReason_clientReasonPhrase:n.terminationReason?.clientReasonPhrase,TerminationReason_clientReasonSubCode:n.terminationReason?.clientReasonSubCode,TerminationReason_resultCategories:n.terminationReason?.resultCategories,CallDuration:ww(n.duration),IceInitTime:ww(n.iceInitTime),IceConnectedStateTime:ww(n.iceConnectedStateTime),NegotiationCount:n.negotiationCount,RejectedNegotiationCount:n.rejectedNegotiationCount,InitialNegotiationCompleted:n.initialNegotiationCompleted,InitialNegotiationType:n.initialNegotiationType,FinalAnswerTime:ww(n.finalAnswerTime),TransportReconnectedCount:n.transportReconnectedCount,RollbackNegotiation:JSON.stringify(n.rollbackNegotiation),Relay:n.relay?JSON.stringify(n.relay):void 0,ActiveModalities:JSON.stringify(n.activeModalities),AllowedAudioSend:n.allowedAudioSend,AllowedVideoSend:n.allowedVideoSend,AllowedScreensharingSend:n.allowedScreensharingSend,RelayManager:JSON.stringify(n.relayTimers),AuthTokenStats:JSON.stringify(n.authTokenFetcherStats),CallMutedRatio:n.callMutedRatio,CallOsMuted:ww(n.callOsMuted),CallHwSilent:ww(n.callHwSilent),CallSwMuted:ww(n.callSwMuted),CallSpeakerMuted:ww(n.callSpeakerMuted),CallIsSpeaking:ww(n.callIsSpeaking),DtmfSuccess:n.dtmfSuccessCount,DtmfFailure:n.dtmfFailureCount,ContributingSourcesError:m.contributingSourcesError,ReconnectInProgress:n.reconnect?.isReconnecting,RetargetIncomingCount:n.reconnect?.retargetCount.incoming,RetargetOutgoingCount:n.reconnect?.retargetCount.outgoing,RetargetCompletedCount:n.reconnect?.retargetCount.completed,RetargetRejectedCount:n.reconnect?.retargetCount.rejected,EscalationAttemptedCount:n.reconnect?.escalationCount.attempted,EscalationCompletedCount:n.reconnect?.escalationCount.completed,EscalationRejectedCount:n.reconnect?.escalationCount.rejected,Elevation:JSON.stringify(n.elevation),ReconnectAttemptedCount:n.reconnect?.reconnectCount.attempted,ReconnectConnectedCount:n.reconnect?.reconnectCount.connected,ReconnectAttempts:cd(n.reconnect?.records,u.numReconnects,"startTime",n.creationTime),NetworkEvents:cd(n.reconnect?.tmpRecords,u.numNetworkEvents,"startTime",n.creationTime),NoIceCandidatesGoodEventCount:n.noIceCandidatesEventCount.good,NoIceCandidatesBadEventCount:n.noIceCandidatesEventCount.bad,NoRelayIceCandidatesGoodEventCount:n.noRelayIceCandidatesEventCount.good,NoRelayIceCandidatesBadEventCount:n.noRelayIceCandidatesEventCount.bad,MicrophoneInUseGoodEventCount:n.microphoneInUseEventCount.good,MicrophoneInUseBadEventCount:n.microphoneInUseEventCount.bad,CameraInUseGoodEventCount:n.cameraInUseEventCount.good,CameraInUseBadEventCount:n.cameraInUseEventCount.bad,CameraFreezeStartEventCount:n.cameraFreezeEventCount.start,CameraFreezeEndEventCount:n.cameraFreezeEventCount.end,NetworkRecvGood:n.networkRecvUFD.good,NetworkRecvGoodRatio:n.networkRecvUFD.goodRatio,NetworkRecvPoor:n.networkRecvUFD.poor,NetworkRecvPoorRatio:n.networkRecvUFD.poorRatio,NetworkRecvBad:n.networkRecvUFD.bad,NetworkRecvBadRatio:n.networkRecvUFD.badRatio,NetworkSendGood:n.networkSendUFD.good,NetworkSendGoodRatio:n.networkSendUFD.goodRatio,NetworkSendPoor:n.networkSendUFD.poor,NetworkSendPoorRatio:n.networkSendUFD.poorRatio,NetworkSendBad:n.networkSendUFD.bad,NetworkSendBadRatio:n.networkSendUFD.badRatio,Connection_Downlink:_a(m.networkInfo,b=>b.downlink),Connection_EffectiveType:m.networkInfo.map(b=>b.effectiveType).filter(b=>b).join(","),Connection_Rtt:_a(m.networkInfo,b=>b.rtt),Connection_SaveData:_f(m.networkInfo)?.saveData,RawOutputAudioAccessAttempted:n.rawMedia.audio.recv.numAttempts,RawOutputAudioAccessDurationRatio:n.rawMedia.audio.recv.durationRatio,RawInputAudioOverrideAttempted:n.rawMedia.audio.send.numAttempts,RawInputAudioOverrideDurationRatio:n.rawMedia.audio.send.durationRatio,ZeroCaptureDevicesEnumeratedEventRatio:oa(n.zeroCaptureDevicesRatio,ke.NATIVE_RATIO_PRECISION),ZeroRenderDevicesEnumeratedEventRatio:oa(n.zeroRenderDevicesRatio,ke.NATIVE_RATIO_PRECISION),DeviceCaptureNotFunctioningEventRatio:oa(n.deviceCaptureFailuresRatio,ke.NATIVE_RATIO_PRECISION),DeviceRenderNotFunctioningEventRatio:oa(n.deviceRenderFailuresRatio,ke.NATIVE_RATIO_PRECISION),UFDs:cd(n.ufds,u.numUFDs,"timestamp",n.creationTime),remoteUFDs:cd(n.remoteUfds,u.numUFDs,"timestamp",n.creationTime),UFDs_count:JSON.stringify(n.ufdManager.count),remoteUFDs_count:JSON.stringify(n.remoteUfdsCount),MediaQosEnabled:s.configuration.mediaConfig?.enableMediaQoS??!1,PortRangeConfigured:!!s.configuration.mediaConfig?.mediaPortRanges,hardwareConcurrency:s.configuration.userAgentConfig.hardwareConcurrency,ETag:n.ETag,ConfigIds:n.configIds,GPUName:s.configuration.userAgentConfig.unmaskedGlRenderer,PermissionStates:JSON.stringify(s.deviceManager.permissionStates),DeviceList:JSON.stringify(s.deviceManager.deviceList),DeviceListDebug:JSON.stringify(s.deviceManager.deviceDebugStrings),DevicesChangeCount:n.deviceManager.devicesChangeCount,DevicesPollChangeCount:n.deviceManager.devicesPollChangeCount,DeviceSelectionChangeCount:n.deviceManager.deviceSelectionChangeCount,DeviceSelectionChangeFromInterfaceCount:n.deviceManager.deviceSelectionChangeCountFromInterface,DevicesCount:JSON.stringify(s.deviceManager.devicesCount),UsedMicrophone:s.deviceManager.usedDevices?.microphone,UsedSpeaker:s.deviceManager.usedDevices?.speaker,UsedCamera:s.deviceManager.usedDevices?.camera,DeviceEvents:cd(s.deviceManager.deviceTelemetryEvents.filter(b=>b.timestamp>a),u.numDeviceEvents,"timestamp",n.creationTime),VideoEffects:cd(s.deviceManager.videoEffectsEvents.filter(b=>b.timestamp>a),u.numVideoEffectsEvents,"timestamp",n.creationTime),AudioEffects:cd(s.deviceManager.audioEffectsEvents.filter(b=>b.timestamp>a),u.numAudioEffectsEvents,"timestamp",n.creationTime),WorkerEvents:cd(s.deviceManager.workerEvents.filter(b=>b.timestamp>a),u.numWorkerEvents,"timestamp",n.creationTime),MediaByPassEnabled:!!s.configuration.mediaConfig.enableMediaBypass,CallConstraints:JSON.stringify(n.callConstraints),DominantSpeaker:JSON.stringify(aJe(n.dominantSpeaker,n.terminationTime)),AudioSourceNumOfReopenRequests:n.deviceManager.audioSourceNumOfReopenRequests||void 0,AudioSourceNumOfSuccessfulReopens:n.deviceManager.audioSourceNumOfSuccessfulReopens||void 0,AudioCaptureErrorCodeFlagsInit:n.deviceManager.audioCaptureDeviceErrorFlag,AudioRenderErrorCodeFlagsInit:n.deviceManager.audioRenderDeviceErrorFlag,AudioSinkNumOfReopenRequests:n.audioRenderer.sinkNumOfReopenRequests,AudioSinkNumOfSuccessfulReopens:n.audioRenderer.sinkNumOfSuccessfulReopens,CallSetupTimeTracker:JSON.stringify(n.webrtcSessions[0].negotiation.callSetupTimeReport),LastSessionSetupTimeTracker:n.webrtcSessions.length>1?JSON.stringify(m.negotiation.callSetupTimeReport):void 0,BatteryLevel:n.batteryLevel})}function ww(n){return 1e4*n}function aJe(n,a=Number(new Date)){if(!n)return;const s=fs(n);return n.lastMsgDate&&(n.timeSinceLastMsg=n.lastMsgDate-a),delete s.lastMsgDate,delete s.lastHistory,_l(s)}function Mc(n,a,s=0){const c=a.filter(m=>m!==void 0);let u;switch(n){case"Difference":u=c[c.length-1]-c[0];break;case"Average":u=c.reduce((m,b)=>m+b,0)/c.length;break;case"LastValue":u=c[c.length-1]}return u||u===0?`${typeof u=="number"?+u.toFixed(s):u}`:void 0}function Z9(n,a,s){return(s?n.map(c=>c?.[a]?.[s]):n.map(c=>c?.[a])).filter(c=>c!==void 0).reduce((c,u)=>c.concat(u),[])}function qTi(n){const a=n.find(s=>s?.transports);return a?a.transports[Object.keys(a.transports)[0]]:void 0}function rJe(n){const a=n[n.length-1]?.extensions?.powerEfficient;return a===void 0?"":a?"hw":"sw"}function oJe(n,a){return n&a?"Bidirectional":n?"ReceiveFromPeer":a?"SendToPeer":"Inactive"}function WTi(n){const a=n[n.length-1]?.extensions?.callIsMuted,s=n[n.length-1]?.extensions?.rawInputVolume;return a?"0":!a&&s>0?"2":a||s!==0?void 0:"1"}function KTi(n,a){const s=Z9(n,"audio","send"),c=Z9(n,"audio","recv"),u=qTi(n);if(s.length||c.length)return _l({mediaType:"Audio",mediaDirection:oJe(c.length,s.length),"Received BW estimate":Mc("Average",c.map(m=>m?.transport?.selectedCandidatePair?.availableIncomingBitrate)),"Recv Loss Rate (Avg)":Mc("LastValue",c.map(m=>m?.extensions?.lossRate/100),3),"Rtp Packets Received":Mc("Difference",c.map(m=>m?.inboundRTP.packetsReceived)),"Rtp Packet Sent":Mc("Difference",s.map(m=>m?.outboundRTP.packetsSent)),"Sent BW estimate":Mc("Average",s.map(m=>m?.transport?.selectedCandidatePair?.availableOutgoingBitrate)),"Send Audio Codec":Mc("LastValue",s.map(m=>m?.codec?.mimeType))?.split("/").pop(),"Send RTT (Avg)":Mc("LastValue",s.map(m=>m?.extensions?.rttAvg)),"Audio NW jitter avg":Mc("LastValue",c.map(m=>m?.extensions?.jitterAvg),3),"Audio send bps":Mc("Average",s.map(m=>m?.extensions?.bitrate)),"JB delay (ms)":Mc("LastValue",c.map(m=>m?.extensions?.jitterBufferDelayMs)),"Recv Audio Codec":Mc("LastValue",c.map(m=>m?.codec?.mimeType))?.split("/").pop(),"Current Render Device Name":a?.speaker,"Current Capture Device Name":a?.microphone,"Latest Network Type":u?.selectedCandidatePair?.localCandidate?.networkType,"Latest Transport Protocol":u?.selectedCandidatePair?.localCandidate?.protocol,"Latest Reflexive Address":Rye(u?.extensions?.reflexiveLocalIP),"Local Address":Rye(u?.selectedCandidatePair?.localCandidate?.ip),"Local short-term Healed Data Ratio":Mc("LastValue",c.map(m=>m?.extensions?.healedRatio)),"Send activity (0=muted; 1=inactive; 2=active)":WTi(s)})}function JTi(n){const a={},s=c=>{n.map(u=>u?.video?.[c]).forEach(u=>{u?.forEach(m=>{var b;const _=m?.mediaEntity?.remoteSsrc;a[_]??(a[_]={}),(b=a[_])[c]??(b[c]=[]),a[_][c].push(m)})})};return s("recv"),s("send"),a}function YTi(n,a){const s=[],c=JTi(n);for(const{send:u,recv:m}of Object.values(c)){let b={mediaType:"Camera",mediaDirection:oJe(m?.length,u?.length)};m&&(b={...b,...lJe(m)}),u&&(b={...b,...sJe(u,a)}),s.push(_l(b))}return s}function sJe(n,a){const s=Mc("LastValue",n.map(u=>u?.codec?.mimeType))?.split("/").pop(),c=s?s+` ${rJe(n)}`:void 0;return{"Rtp Packet Sent":Mc("Difference",n.map(u=>u?.outboundRTP.packetsSent)),"Sent BW estimate":Mc("Average",n.map(u=>u?.transport?.selectedCandidatePair?.availableOutgoingBitrate)),"Send Current Bitrate":Mc("Average",n.map(u=>u?.extensions?.bitrate)),"Allocated Send Bandwidth Average":Mc("LastValue",n.map(u=>u?.extensions?.bitrateAvg)),"Send Actual Height":Mc("LastValue",n.map(u=>u?.outboundRTP.frameHeight)),"Send Actual Width":Mc("LastValue",n.map(u=>u?.outboundRTP.frameWidth)),"Send Current Frame Rate":Mc("Average",n.map(u=>u?.extensions?.frameRateSent)),"Send RTT (Avg)":Mc("LastValue",n.map(u=>u?.extensions?.rttAvg)),"Sent Codec Name":c,"Webcam Freeze Intervals":Mc("LastValue",n.map(u=>u?.extensions?.captureFreezeIntervalsCount)),"Current Capture Device Name":a?.camera,"Number of Sync Frame Request per Minute":Mc("LastValue",n.map(u=>u?.extensions?.pliRate))}}function lJe(n){const a=Mc("LastValue",n.map(u=>u?.mediaEntity?.xSourceStreamId)),s=Mc("LastValue",n.map(u=>u?.codec?.mimeType))?.split("/").pop(),c=s?s+` ${rJe(n)}`:void 0;return{"Recv Loss Rate (Avg)":Mc("LastValue",n.map(u=>u?.extensions?.lossRate),3),"Received BW estimate":Mc("Average",n.map(u=>u?.transport?.selectedCandidatePair?.availableIncomingBitrate)),"Receive Current Bitrate":Mc("Average",n.map(u=>u?.extensions?.bitrate)),"Rtp Packets Received":Mc("Difference",n.map(u=>u?.inboundRTP.packetsReceived)),"Receive Actual Height":Mc("LastValue",n.map(u=>u?.inboundRTP.frameHeight)),"Receive Actual Width":Mc("LastValue",n.map(u=>u?.inboundRTP.frameWidth)),"Receive Current Frame Rate":Mc("Average",n.map(u=>u?.extensions?.frameRateReceived)),"Received Codec Name":c,"Received Total Freeze Fraction (ms per min)":Mc("LastValue",n.map(u=>u?.extensions?.totalFreezeFraction)),videoSourceId:a?parseInt(a):void 0,"Received Fps Time Weighted Harmonic Average":Mc("LastValue",n.map(u=>u?.extensions?.fpsHarmonicAverage))}}function QTi(n){const a=Z9(n,"sharing","send"),s=Z9(n,"sharing","recv");if(!s.length&&!a.length)return;let c={mediaType:"AppSharing",mediaDirection:"Bidirectional","Render Device Name":""};return s.length&&(c={...c,...lJe(s)}),a.length&&(c={...c,...sJe(a,{camera:"Screen sharing"})}),_l(c)}function cJe(n,a,s){const c=KTi(n,a);c&&s.channels.push(c);const u=YTi(n,a);u.length&&s.channels.push(...u);const m=QTi(n);m&&s.channels.push(m)}function ZTi(n,a){const s=Z9(n,"inactiveTracks"),c={channels:[]};return cJe(n,a,c),s.length&&cJe(s,void 0,c),c}function dJe(n,a,s,c,u){return _l({recv:_l({id:s?.inboundRTP.id,ssrc:s?.inboundRTP.ssrc,mediaType:s?.inboundRTP.mediaType??s?.inboundRTP.kind,bytes:Fh(a[n]?.recv,m=>m.inboundRTP.bytesReceived,u),packets:Fh(a[n]?.recv,m=>m.inboundRTP.packetsReceived,u),packetsLost:Fh(a[n]?.recv,m=>m.inboundRTP.packetsLost,u),codec:s?.codec?.mimeType.split("/").pop(),codecReport:s?.aggregated?.codecReport,framesDecoded:Fh(a[n]?.recv,m=>m.inboundRTP.framesDecoded,u),height:Fh(a[n]?.recv,m=>m.inboundRTP.frameHeight,u),width:Fh(a[n]?.recv,m=>m.inboundRTP.frameWidth,u),frameRate:Fh(a[n]?.recv,m=>m.extensions?.frameRateReceived,u)}),send:_l({id:c?.outboundRTP.id,ssrc:c?.outboundRTP.ssrc,mediaType:c?.outboundRTP.mediaType??c?.outboundRTP.kind,bytes:Fh(a[n]?.send,m=>m.outboundRTP.bytesSent,u),packets:Fh(a[n]?.send,m=>m.outboundRTP.packetsSent,u),packetsLost:Fh(a[n]?.send,m=>m.remoteInboundRTP?.packetsLost,u),codec:c?.codec?.mimeType.split("/").pop(),framesEncoded:Fh(a[n]?.send,m=>m.outboundRTP.framesEncoded,u),heightInput:c?.mediaSource?.height,widthInput:c?.mediaSource?.width,height:Fh(a[n]?.send,m=>m.outboundRTP.frameHeight,u),width:Fh(a[n]?.send,m=>m.outboundRTP.frameWidth,u),frameRate:Fh(a[n]?.send,m=>m.extensions?.frameRateSent,u)})})}function XTi(n,a,s,c){return _l({recv:_l({id:a?.inboundRTP.id,ssrc:a?.inboundRTP.ssrc,mediaType:a?.inboundRTP.mediaType??a?.inboundRTP.kind,bytes:Fh(n.audio?.recv,u=>u.inboundRTP.bytesReceived,c),packets:Fh(n.audio?.recv,u=>u.inboundRTP.packetsReceived,c),packetsLost:Fh(n.audio?.recv,u=>u.inboundRTP.packetsLost,c),codec:a?.codec?.mimeType.split("/").pop(),audioLevel:Fh(n.audio?.recv,u=>Math.floor(65535*u.inboundRTP.audioLevel),c)}),send:_l({id:s?.outboundRTP.id,ssrc:s?.outboundRTP.ssrc,mediaType:s?.outboundRTP.mediaType??s?.outboundRTP.kind,bytes:Fh(n.audio?.send,u=>u.outboundRTP.bytesSent,c),packets:Fh(n.audio?.send,u=>u.outboundRTP.packetsSent,c),packetsLost:Fh(n.audio?.send,u=>u.remoteInboundRTP?.packetsLost,c),codec:s?.codec?.mimeType.split("/").pop(),audioLevel:Fh(n.audio?.send,u=>Math.floor(65535*u.aggregated.audioLevel),c)})})}function eCi(n){return _l({negotiationCount:n.negotiationCount,rejectedNegotiationCount:n.rejectedNegotiationCount})}function tCi(n,a,s,c,u){const m=n.aggregatedModalityStats,b=_f(m.audio?.recv),_=_f(m.audio?.send),k=_f(m.video?.recv),N=_f(m.video?.send),W=_f(m.sharing?.recv),ee=_f(m.sharing?.send),oe=[],de=[];return n.statsOnSubscribed.video?.forEach(se=>oe.push(se)),n.statsOnSubscribed.sharing?.forEach(se=>de.push(se)),_l({multipleVideoStreams:n.multiViewStats,WebRTCStats_ssrc:_l({audio:XTi(m,b,_,u),video:dJe("video",m,k,N,u),sharing:dJe("sharing",m,W,ee,u),negotiationStats:eCi(a)}),CallSwMuted:1e3*a.callSwMuted,DeviceEvents:Fb(s.deviceManager.deviceTelemetryEvents.filter(se=>se.timestamp>c),"timestamp",a.creationTime),VideoEffects:Fb(s.deviceManager.videoEffectsEvents.filter(se=>se.timestamp>c),"timestamp",a.creationTime),AudioEffects:Fb(s.deviceManager.audioEffectsEvents.filter(se=>se.timestamp>c),"timestamp",a.creationTime),statsErrors:a.statsErrors,WorkerEvents:Fb(s.deviceManager.workerEvents.filter(se=>se.timestamp>c),"timestamp",a.creationTime),transportState:n.transportState})}var iCi=class{constructor(n,a){this.rootRef=n,this.configProvider=a}get rawRootRef(){return this.rootRef}getSessionTelemetry(n){const a=this.getLatestSession(n);if(!a)return;const s={metrics:{},Extensions:{}},c=pp();try{const u=a.callNumber>1?this.rootRef.sessions.find(_=>a.callNumber-1===_.callNumber):void 0,m=u?.terminationTime??0,b=a.webrtcSessions[a.webrtcSessions.length-1];s.metrics=GTi(a,m,this.rootRef,this.configProvider),s.Extensions=RTi(b,this.configProvider,a.statsErrors)}catch(u){a[Q9].addStatsError("DiagnosticsReport:getSessionTelemetry",nn(u)),s.Extensions.WebRTCStats_statsErrors=JSON.stringify(a.statsErrors)}return s.metrics.ReportGenerationTimeMs=oa(pp()-c),s}getTeamsRealtimeTelemetry(n){const a=this.getLatestSession(n);if(a)try{const s=a.webrtcSessions[a.webrtcSessions.length-1],c=this.configProvider.config.diagnostics.teamsRealtimeTelemetry.pollingInterval;return ZTi(s.statsReports.slice(s.statsReports.length-c),this.rootRef.deviceManager.rawUsedDevices)}catch(s){throw a[Q9].addStatsError("DiagnosticsReport:getRealTimeTelemetry",nn(s)),s}}getMediaSessionStats(n){const a=this.getLatestSession(n);if(a)try{const s=a.callNumber>1?this.rootRef.sessions.find(_=>a.callNumber-1===_.callNumber):void 0,c=s?.terminationTime??0,u=a.webrtcSessions[a.webrtcSessions.length-1],m=u?.statsReports.length?u.statsReports[u.statsReports.length-1]:void 0,b=m?$Ti(m):void 0;return b&&(b.extensions=HTi(u,this.configProvider),b.metrics=jTi(a,c,this.rootRef)),b}catch(s){throw a[Q9].addStatsError("DiagnosticsReport:getMediaSessionStats",nn(s)),s}}getDiagnosticsForE2eTests(n){const a=this.getLatestSession(n);let s={statsErrors:[]};if(a){try{const c=a.webrtcSessions[a.webrtcSessions.length-1],u=a.callNumber>1?this.rootRef.sessions.find(b=>a.callNumber-1===b.callNumber):void 0,m=u?.terminationTime??0;s=tCi(c,a,this.rootRef,m,this.configProvider.config.diagnostics.collectionLimits.numSamplesForE2E)}catch(c){const u="DiagnosticsReport:getDiagnosticsForE2eTests",m=nn(c);a[Q9].addStatsError(u,m),Mo(s.statsErrors,{origin:u,error:m,count:1},this.configProvider.config.diagnostics.collectionLimits.numStatsErrors)}return s}}getLatestSession(n){return this.rootRef.sessions.filter(a=>a.sessionId===n).sort((a,s)=>a.callNumber-s.callNumber).pop()}},nCi=class{constructor(n,a,s){this.configProvider=n,this.deviceManagerDiagnostics=a,this.ufdManagerDiagnostics=s,this.root={creationTime:Date.now(),numTotalSessions:0,deviceManager:this.deviceManagerDiagnostics.getObjectRef(),ufdManager:this.ufdManagerDiagnostics.getObjectRef(),configuration:{stackConfig:this.configProvider.stackConfig,defaultConfig:this.configProvider.defaultConfig,mediaConfig:{},userAgentConfig:{isAudioOutputSelectionSupported:this.configProvider.userAgentConfig.isAudioOutputSelectionSupported,isBrowserRollbackSupported:this.configProvider.userAgentConfig.isBrowserRollbackSupported,hardwareConcurrency:yp.hardwareConcurrency,unmaskedGlRenderer:yp.unmaskedGlRenderer,hasMediaApi:yp.hasMediaApi(),hasCapabilitiesApi:yp.hasCapabilitiesApi(),hasUnifiedPlanSupport:void 0},consoleOverrides:this.configProvider.consoleOverrides,fullConfig:fs(this.configProvider.config),ecsConfigUpdates:[]},browserInfo:ul.getBrowserInfo(),sessions:[]},this.diagnosticsReport=new iCi(this.root,this.configProvider),this.configProvider.on("newConfigReceived",(c,u,m)=>{this.root.configuration.ecsConfigUpdates.push({timestamp:Date.now(),etag:u,configIds:m,config:c})}),this.configProvider.on("configUpdated",()=>{this.root.configuration.consoleOverrides=this.configProvider.consoleOverrides,this.root.configuration.fullConfig=fs(this.configProvider.config)})}get reportGenerator(){return this.diagnosticsReport}get rootRef(){return this.root}set mediaConfig(n){this.root.configuration.mediaConfig=n}newSession(n,a,s){this.root.configuration.userAgentConfig.hasUnifiedPlanSupport=this.configProvider.mediaConfig.simulcastSessionEnabled;const c=new ATi(s,n,this.diagnosticsReport,this.root.deviceManager,this.root.ufdManager,++this.root.numTotalSessions,a);return Mo(this.root.sessions,c.getObjectRef(),this.configProvider.config.diagnostics.collectionLimits.numSessions),c}},uJe=class PQe{constructor(a,s){this.safe=a,this.unsafe=s,this.safe||(this.safe=this.unsafe)}warn(...a){this.unsafe.warn(...a)}error(...a){this.unsafe.error(...a)}debug(...a){this.unsafe.debug(...a)}info(...a){this.unsafe.info(...a)}createChild(a){return new PQe(this.safe.createChild(a),this.unsafe.createChild(a))}},hJe=dn,aCi=class{constructor(n){this.logger=n,this.extensionId="nkeimhogjdpnpccoofpliimaahmaaome",this.editorExtensionId="ncbjelpjchkpbikbpkcchkhkblodoama",this.logId="TeamsWebRTCLogs",this.loggingState="unknown",this.connectionCount=0,window.webRtcInternalsCollector=this}get isExtensionAvailable(){return this.loggingState!=="unavailable"}async updateSessionCount(n){this.isExtensionAvailable&&(this.connectionCount===0&&n===1?(this.loggingState==="stopped"&&await this.discardLogs(),await this.initialStartLogging()):n===0&&await this.stopLogging(),this.connectionCount=n)}async collect(){return this.isExtensionAvailable?this.collectPromise?this.collectPromise:this.collectPromise=new Promise(async n=>{try{this.connectionCount>0&&(this.logger.safe.info(`Stopping logger for gathering, open connections: ${this.connectionCount}`),await this.stopLogging()),await this.storeLogs();const a=await this.gatherFromStorage();this.connectionCount>0&&await this.continueLogging(),n(a.length>0?a.join(`\r
`):"")}catch(a){this.logger.safe.error("Error while collecting logs",a),n(JSON.stringify(a))}this.collectPromise=void 0}):""}async initialStartLogging(){try{await this.startLogging()}catch(n){if(n?.includes("A log is already open"))try{const a=n.match(/State=(\w+)/);await this.cleanState(a?.[1]),await this.startLogging()}catch(a){this.logger.safe.error("Error while starting logging at cleanup phase",a),this.loggingState="unknown"}else this.logger.safe.error("Error while starting logging",n),this.loggingState="unavailable"}}async continueLogging(){try{await this.startLogging()}catch(n){this.logger.safe.error("Error while continuing logging",n),this.loggingState="stopped"}}async startLogging(){await this.sendMessage(this.extensionId,{method:"logging.start"}),this.logger.safe.info("Logging started"),this.loggingState="started"}async cleanState(n){try{if(n==="started")await this.stopLogging(),await this.discardLogs();else{if(n!=="stopped")throw new Error(`Unexpected logging state: ${n}`);await this.discardLogs()}}catch(a){this.logger.safe.error("Error while cleaning state",a)}}async stopLogging(){try{await this.sendMessage(this.extensionId,{method:"logging.stop"}),this.logger.safe.info("Logging stopped"),this.loggingState="stopped"}catch(n){this.logger.safe.error("Error while stopping logging",n)}}async discardLogs(){try{await this.sendMessage(this.extensionId,{method:"logging.discard"}),this.logger.safe.info("Logs discarded"),this.loggingState="closed"}catch(n){this.logger.safe.error("Error while discarding logs",n)}}async storeLogs(){try{await this.sendMessage(this.extensionId,{method:"logging.store",logId:this.logId}),this.logger.safe.info(`Logs stored to ${this.logId}`),this.loggingState="closed"}catch(n){this.logger.safe.error("Error while storing logs",n)}}async gatherFromStorage(){const n=[];let a={offset:0};do a=await this.sendMessage(this.editorExtensionId,{api:"getWebRtcLog",logId:this.logId,offset:a.offset}),n.push(a.data),this.logger.safe.info(`Batch gathered with offset: ${a.offset}, moreData: ${a.moreData}`);while(a.moreData);return this.logger.safe.info("Finished gathering"),n}sendMessage(n,a){return new Promise((s,c)=>{const u=chrome.runtime;u.sendMessage(n,a,m=>{if(!m||m?.error){const b=m?JSON.stringify(m.error):u.lastError;c(`sendMessage ${JSON.stringify(a)} failed with error: ${b}`)}s(m)})})}},rCi=(()=>{let n;function a(s,c){return c.config.enableWebRtcInternalsLogs&&ul.isBrowser("EdgeAnaheim")&&chrome?.runtime?(n||(n=new aCi(s)),n):(s.safe.info("WebRTC internal logging is disabled"),{collect:()=>Promise.resolve(""),updateSessionCount:()=>Promise.resolve()})}return{getInstance:a}})(),oCi=class{getId(){return 0}getDeviceId(){return ke.EMPTY_DEVICE_ID}getPreviewAsync(n,a){return Promise.resolve(null)}getDescription(){return"display"}getType(){return 1}getIcon(n,a){return Promise.resolve(null)}},sCi=class{constructor(n){this.descr=n}getId(){return 0}getDeviceId(){return this.descr.browserId}getPreviewAsync(n,a){return Promise.resolve(null)}getDescription(){return this.descr.label}getType(){return 3}getIcon(n,a){return Promise.resolve(null)}},lCi=class{constructor(n){this.deviceManager=n,this.sharingSource=new oCi}onScreensChanged(n){return{dispose:()=>{}}}enumerateScreensAsync(){return Promise.resolve([this.sharingSource])}enumerateWindowsAsync(){return Promise.resolve([])}async enumerateCamerasAsync(){return(await this.deviceManager.enumerateDevicesAsync()).filter(n=>n.kind==="camera").map(n=>new sCi(n))}},cCi=class{constructor(n){this.configProvider=n,this.data={records:[],tmpRecords:[],isReconnecting:!1,networkRecoveredCount:0,disconnectedRecoveredCount:0,reconnectCount:{attempted:0,connected:0},retargetCount:{incoming:0,outgoing:0,completed:0,rejected:0},escalationCount:{attempted:0,completed:0,rejected:0}}}registerState(n){const a=n==="connected"?this.activeTmpRecord:this.getTmpRecord();a&&a.events[a.events.length-1]?.type!==n&&(a.events.push({type:n,time:Date.now()-a.startTime}),n==="networkOnline"?this.data.networkRecoveredCount++:n==="connected"&&this.data.disconnectedRecoveredCount++,n!=="reconnect"&&n!=="connected"||(a.endTime=Date.now()-a.startTime,this.activeTmpRecord=null))}registerReconnectAttempt(n){this.activeRecord&&(this.activeAttempt={direction:n,startTime:Date.now()-this.activeRecord.startTime,status:!1},this.data.isReconnecting=!0,ld(this.activeRecord.attempts,this.activeAttempt,this.configProvider.config.diagnostics.collectionLimits.numReconnectRecords))}registerReconnectAttemptStatus(n){n==="completed"&&(this.data.isReconnecting=!1),this.activeAttempt&&this.activeRecord&&(this.activeAttempt.endTime=Date.now()-this.activeRecord.startTime,this.activeAttempt.status=n==="completed")}registerReconnect(n){if(this.data.reconnectCount[n]++,this.data.isReconnecting=n==="attempted",n==="attempted"){if(this.activeRecord)return;this.activeRecord={startTime:Date.now(),attempts:[]},ld(this.data.records,this.activeRecord,this.configProvider.config.diagnostics.collectionLimits.numReconnects)}else if(n==="connected"){if(!this.activeRecord)return;this.activeTmpRecord&&this.registerState("connected"),this.activeRecord.endTime=Date.now()-this.activeRecord.startTime,this.activeRecord=void 0,this.activeAttempt=void 0}}registerRetarget(n){this.data.retargetCount[n]++}registerEscalation(n){this.data.escalationCount[n]++}getObject(){return this.data}getTmpRecord(){return(!this.activeTmpRecord||this.activeTmpRecord.endTime>0)&&(this.activeTmpRecord={startTime:Date.now(),events:[]},this.data.tmpRecords.push(this.activeTmpRecord)),this.activeTmpRecord}},pJe=class{constructor(){}process(n){return this.mediaLegId=n||this.mediaLegId||sw().toUpperCase(),this.mediaLegId}},dCi=class{constructor(n,a){this.relayManager=n,this.diagnostics=a}initialize(){}setRelayOverride(){}async queryRelaysAsync(n){const a=await this.relayManager.queryRelaysAsync(n);return a.length>0&&(this.diagnostics.relay=a[0]),a}getStats(){return this.relayManager.getStats?.()??{stats:{unavailable:"1"}}}getAuthTokenStats(){return this.relayManager.getAuthTokenStats()}},uCi=class{constructor(n,a,s){this.stats=n,this.diag=a,s&&a&&(s.reconnect=a.getObject())}registerState(n){this.diag?.registerState(n)}registerReconnectAttempt(n){this.stats.registerReconnectAttempt(n),this.diag?.registerReconnectAttempt(n)}registerReconnectAttemptStatus(n){switch(n){case"completed":this.stats.registerReconnectAttemptCompleted();break;case"rejected":this.stats.registerReconnectAttemptRejected()}this.diag?.registerReconnectAttemptStatus(n)}registerReconnect(n){switch(n){case"attempted":this.stats.registerReconnectAttempted();break;case"connected":this.stats.registerReconnectConnected()}this.diag?.registerReconnect(n)}registerRetarget(n){switch(n){case"completed":this.stats.registerRetargetCompleted();break;case"rejected":this.stats.registerRetargetRejected();break;case"incoming":this.stats.registerRetargetIncoming();break;case"outgoing":this.stats.registerRetargetOutgoing()}this.diag?.registerRetarget(n)}registerEscalation(n){switch(n){case"attempted":this.stats.registerEscalationStart();break;case"completed":this.stats.registerEscalationCompleted();break;case"rejected":this.stats.registerEscalationRejected()}this.diag?.registerEscalation(n)}},gJe=class{constructor(n){this.initialCallbacks=n,this.queueCallbacks={onTerminated:this.genCallback(this.initialCallbacks.onTerminated),onSessionErrorOccurred:this.genCallback(this.initialCallbacks.onSessionErrorOccurred),onNegotiationRequired:this.genCallback(this.initialCallbacks.onNegotiationRequired),onAudioStateChanged:this.genCallback(this.initialCallbacks.onAudioStateChanged),onAudioHwSilentChanged:this.genCallback(this.initialCallbacks.onAudioHwSilentChanged),onTransportDisconnected:this.genCallback(this.initialCallbacks.onTransportDisconnected),onTransportConnected:this.genCallback(this.initialCallbacks.onTransportConnected),onTransportInitialized:this.genCallback(this.initialCallbacks.onTransportInitialized),onTransportFailed:this.genCallback(this.initialCallbacks.onTransportFailed),onUpdateMediaDescriptionsRequired:this.genCallback(this.initialCallbacks.onUpdateMediaDescriptionsRequired),onTeamsRealtimeTelemetryReport:this.genCallback(this.initialCallbacks.onTeamsRealtimeTelemetryReport)},this.queue=[]}flush(){this.queue.forEach(n=>{n.method.apply(null,n.args)}),this.clear()}clear(){this.queue=[]}genCallback(n){return(...a)=>this.queue.push({method:n,args:a})}},mJe=class{constructor(n,a){this.relayConfig=n,this.logger=a}async ensureOnline(){if(this.relayConfig.length===0)return this.logger.safe.warn("No TURN servers defined"),0;if(this.probeDeferred)return this.probeDeferred.promise;this.logger.safe.info(`Starting TURN probes with ${JSON.stringify(this.relayConfig[0].urls)}`),this.checkStart=Date.now();let n=0;this.probeDeferred=new Pi;const a=async()=>{await this.performCheck()&&this.finalize()},s=()=>{a(),n<3e3&&(n+=1e3),this.probeTimer=setTimeout(s,n)};return s(),this.probeDeferred.promise}finalize(){this.probeTimer&&(clearTimeout(this.probeTimer),this.probeTimer=0),this.probeDeferred&&(this.probeDeferred.resolve(Date.now()-this.checkStart),this.probeDeferred=null)}dispose(){this.finalize()}async performCheck(){this.logger.safe.info("Probing...");const n=this.tryCreatePc();if(!n)return!1;n.createDataChannel("probe");const a=new Pi;function s(u){n.onicecandidate=void 0,n.close(),a.resolve(u)}let c=!1;return n.onicecandidate=u=>{const m=u.candidate;if(!m)return c||this.logger.safe.info("still offline"),void s(c);const b=m.type??tie(m.candidate).type;b!=="srflx"&&b!=="relay"||(this.logger.safe.info(`Back online through ${b} candidate`),c=!0,b==="srflx"&&(this.ipFromRelay=m.address,s(!0)))},await n.setLocalDescription(await n.createOffer()),a.promise}tryCreatePc(){try{return new Cc.window.RTCPeerConnection({iceServers:this.relayConfig})}catch(n){return this.logger.safe.info(`Failed to create PC, errCode=${n.code}`),null}}},fJe=(n,a)=>n.reduce((s,c)=>{const u=[],m=c.addresses&&c.addresses[0],b=c.fqdns&&c.fqdns.length>0,_=a.iceUdpAddressType,k=a.iceTcpAddressType,N=a.iceServerTransport;if(!m&&!b)return s;if(N.includes("udp")&&c.udpPort){const W=!b||_!=="fqdn"&&m?m:c.fqdns[0];u.push(`turn:${W}:${c.udpPort}?transport=udp`)}if(N.includes("tcp")&&c.tcpPort){const W=!b||k!=="fqdn"&&m?m:c.fqdns[0];u.push(`turn:${W}:${c.tcpPort}?transport=tcp`)}return N.includes("tls")&&c.tlsPort&&b&&u.push(`turns:${c.fqdns[0]}:${c.tlsPort}`),s.concat({urls:u,credential:c.password,username:c.username})},[]),vJe=(n,a)=>n.reduce((s,c)=>{const u=[],m=c.addresses&&c.addresses[0],b=c.fqdns&&c.fqdns.length>0,_=a.iceUdpAddressType,k=a.iceServerTransport;if(!m&&!b)return s;if(k.includes("udp")&&c.udpPort){const N=!b||_!=="fqdn"&&m?m:c.fqdns[0];u.push(`stun:${N}:${c.udpPort}`)}return k.includes("tls")&&c.tlsPort&&b&&u.push(`turns:${c.fqdns[0]}:${c.tlsPort}`),s.concat({urls:u,credential:c.password,username:c.username})},[]),hCi=class{constructor(n,a,s,c,u,m,b,_){this.session=n,this.context=a,this.diagnostics=s,this.sessionOperationQueue=c,this.callback=u,this.sessionCallbacks=m,this.configProvider=b,this.relayManager=_,this.wasConnected=!1,this.isDisconnected=!1,this.isReconnectConference=!1,this.escalationType=0,this._isSignalingStable=!0,this.reconnectDelayTime=0,this._isReconnectScheduled=!1,this.isDisposing=!1,this.isWaitingForNetwork=!1,this.onOnline=()=>{this.logger.safe.info("onOnline: Network is up"),this.diagnostics.registerState("networkOnline"),this.isOnlineDeferred?.resolve(),this.isOnlineDeferred=null},this.onOffline=()=>{this.logger.safe.info("onOffline: Network is down"),this.diagnostics.registerState("networkOffline"),this.isOnlineDeferred=new Pi},this.logger=a.getLogger().createChild("ReconnectManagerV2"),this.ufdManager=a.getUfdManager(),this.session.callbacks=m,this.reconnectManagerMessageQueue=new gJe(m),window.addEventListener("online",this.onOnline),window.addEventListener("offline",this.onOffline)}get isOnline(){return!this.isOnlineDeferred}async createRelayProber(){if(!this._relayProber){const n=Date.now(),a=vJe(await this.relayManager.queryRelaysAsync({relayType:"turn"}),this.configProvider.config),s=Date.now()-n;this.logger.safe.info(`RelayProber configuration fetched in ${s} ms`),s>5e3&&this.diagnostics.registerState("relayConfigFetched"),this._relayProber=new mJe(a,this.logger.createChild("RelayProber"))}return this._relayProber}dispose(){this.isDisposing=!0,window.removeEventListener("online",this.onOnline),window.removeEventListener("offline",this.onOffline),this._relayProber?.dispose(),this.isOnlineDeferred?.reject(new Error("dispose")),this.reconnectTimer&&this.resetReconnectTimer()}get settings(){return(this.reconnectSession||this.session).getSessionConfig().config}getCurrentSession(){return this.reconnectSession||this.session}getMainSession(){return this.session||this.reconnectSession}getReconnectSession(){return this.reconnectSession}async onIceDisconnect(n){if(this.wasConnected)this.raiseReconnectEvent("Bad",n);else if(!this.settings.reconnectWithNoRelays&&!this.session.hasRelayCandidates())return void this.onReconnectFailed("no relays",n);if(this.isDisconnected=!0,!this.isReconnecting()&&!this.isWaitingForNetwork)return this.logger.safe.info(`[${n}] reconnect attempt after iceDisconnect error`),this.session.transportStateProvider?.isFailed&&this.diagnostics.registerState("failed"),this.diagnostics.registerReconnect("attempted"),this.reconnectAsync(n)}onTransportDisconnect(n){this.isDisconnected=!0,this.wasConnected&&(this.diagnostics.registerState("disconnected"),this.handleTmpConnectivityLoss(n))}onConnected(n){this.isDisconnected=!1,this.logger.safe.info(`[${n}] set allow UFD`),this.diagnostics.registerState("connected"),this.raiseReconnectEvent("Good",n),this.wasConnected=!0,this._relayProber?.finalize()}onNegotiationCompletedAsync(n){return this.logger.safe.info(`[${n}] handle negotiation completed`),this.setSignalingState(!0),this.isReconnecting()&&(this.diagnostics.registerRetarget("completed"),this.escalationType===2&&this.blockCurrentSession(n)),Promise.resolve()}async onSessionErrorOccurred(n,a){this.logger.safe.info(`[${a}] handle session error`,nn(n)),await this.rejectReconnect(a),this.isReconnectAllowed()?await this.scheduleReconnectRetry(a,!1,!1):this.callback.onSessionErrorOccurred(n,a,this.wasConnected)}onNegotiationRejection(n,a){this.logger.safe.info(`[${a}] handle negotiation rejection`),this.diagnostics.registerRetarget("rejected");const s=this.escalationType===1;return this.rejectReconnect(a).then(()=>{const c=n.type===ke.RENEGOTIATION_ERROR.glare&&s;(n.type!==ke.RENEGOTIATION_ERROR.glare||s)&&(this.isRecoverableError(n.type)||c?this.scheduleReconnectRetry(a,c,s):this.onReconnectFailed(nn(n),a))})}async ensureNetwork(n){const a=this.isOnline;if(!this.isOnline){this.logger.safe.info(`[${n}] waiting for network...`);try{await this.isOnlineDeferred.promise}catch{return void this.logger.safe.info(`${n} call disposed while waiting for network`)}this.logger.safe.info(`[${n}] network seems up`)}if(this.isDisconnected){const s=await this.createRelayProber(),c=await s.ensureOnline();this.logger.safe.info(`[${n}] probing complete in ${c} ms`),this.diagnostics.registerState("relaysUp"),a&&c<1e3&&this.logger.safe.info(`[${n}] looks like network failed on remote side, recovery was quick`)}}oldSessionIsOnline(n){return!!this.session?.transportStateProvider?.isConnected&&(this.logger.safe.info(`[${n}] old session recovered`),this.isReconnecting()||this.diagnostics.registerReconnect("connected"),!0)}async waitForNetworkAndTryLightweightRecovery(n){const a=this.oldSessionIsOnline(n);if(a||!this.settings.reconnectWithProbes)return a;this.setReconnectTimer(),this.isWaitingForNetwork=!0;const s=this.getMaxNetworkWaitTime();return this.logger.safe.info(`[${n}] can wait up to ${s} ms`),await Promise.race([this.ensureNetwork(n),Br(s)]),this.isWaitingForNetwork=!1,this.session&&(this.session.transportStateProvider?.isConnected||this.session.transportStateProvider?.isFailed||(this.logger.safe.info(`[${n}] giving session a moment to recover`),await Br(this.settings.reconnectWaitTimeAfterProbe)),this.oldSessionIsOnline(n))?(this.resetReconnectTimer(),!0):this.checkIfTimerFailed(n)?(this.logger.safe.info(`[${n}] session reconnect timer reached during network checks`),!0):!!this.isDisposing&&(this.logger.safe.info(`[${n}] session is disposed`),!0)}reconnectAsync(n,a=!1,s=!1,c){return this.logger.safe.info(`[${n}] queueing reconnect, force=${a}, escalation=${s}`),this.diagnostics.registerReconnectAttempt(s?"local escalation":"out"),this.context.getSmallCallTelemetry()?.setEventType("reconnect"),this._isReconnectScheduled=!0,s&&(this.escalationType=1,this.onReconnectCompleted=c),this.sessionOperationQueue.queueOperation(async()=>{if(this._isReconnectScheduled=!1,a||!await this.waitForNetworkAndTryLightweightRecovery(n))return this.isReconnecting()?(this.logger.safe.info(`[${n}] ongoing reconnect is in progress`),void this.sessionOperationQueue.completeCurrentOperation()):(this.diagnostics.registerState("reconnect"),await this.initReconnect(n),await this.reconnectSession.configureModalitiesAsync(this.getConfiguredModalities(),n),void this.sessionOperationQueue.completeCurrentOperation());this.sessionOperationQueue.completeCurrentOperation()},n)}async acceptReconnectStartAsync(n,a){return this.logger.safe.info(`[${a}] accepting reconnect`),this.diagnostics.registerRetarget("incoming"),n?(this.escalationType=2,this.diagnostics.registerEscalation("attempted")):(!this.isReconnecting()&&this.isDisconnected?this.diagnostics.registerReconnect("attempted"):this.isReconnecting()&&await this.rejectReconnect(a),this.diagnostics.registerState("reconnect"),this.diagnostics.registerReconnectAttempt("in")),this.initReconnect(a)}acceptReconnectFinish(n){const a=this.getConfiguredModalities();return this.reconnectSession.configureModalitiesAsync(a,n).then(()=>a)}isReconnecting(){return!!this.reconnectSession}isReconnectScheduled(){return this._isReconnectScheduled}cleanUp(){this.sessionCallbacks=null,this.reconnectSession=null}async terminateAsync(n){try{await this.session?.terminate(n,{})}catch{}try{await this.terminateReconnectSessionAsync(n,!0)}catch{}this.cleanUp()}completeReconnect(n){return this.logger.safe.info(`[${n}] completing reconnect`),this.escalationType===2&&(this.unblockCurrentSession(n),this.diagnostics.registerEscalation("completed")),this.escalationType=0,this.reconnectSession&&(this.context.config.isConference=this.isReconnectConference,this.disposeActiveSession(n),this.session=this.reconnectSession,this.reconnectManagerMessageQueue.clear(),this.diagnostics.registerReconnectAttemptStatus("completed"),this._isSignalingStable||this.diagnostics.registerRetarget("completed"),this.isDisconnected&&this.diagnostics.registerReconnect("connected"),this.resetReconnectTimer(),this.reconnectDelayTime=0,this.reconnectSession=null,this.negotiationPausePromise=null,this.session.callbacks=this.sessionCallbacks||{}),Promise.resolve()}async rejectReconnect(n){this.logger.safe.info(`[${n}] rejecting reconnect`),this.setSignalingState(!1),this.escalationType===2&&this.diagnostics.registerEscalation("rejected"),this.escalationType=0,this.reconnectSession&&(await this.terminateReconnectSessionAsync(n,!1),this.diagnostics.registerReconnectAttemptStatus("rejected")),this.session&&(this.reconnectManagerMessageQueue.flush(),this.session.callbacks=this.sessionCallbacks,this.unblockCurrentSession(n))}configureModalitiesAsync(n,a,s){this.lastKnownConfiguredModalities=n;const c=[];return this.session&&c.push(this.session.configureModalitiesAsync(n,a,s)),this.reconnectSession&&c.push(this.reconnectSession.configureModalitiesAsync(n,a,s)),Promise.all(c).then(()=>Promise.resolve())}canSendDtmf(){return this.getMainSession().canSendDtmf()}muteHold(n,a){this.getMainSession().muteHold(n,a)}muteInputAsync(n){return this.getMainSession().muteInputAsync(n)}unmuteInputAsync(n){return this.getMainSession().unmuteInputAsync(n)}muteOutputAsync(n){return this.getMainSession().muteOutputAsync(n)}unmuteOutputAsync(n){return this.getMainSession().unmuteOutputAsync(n)}async getSpeakerVolume(n){return this.getMainSession().getSpeakerVolume(n)}async setSpeakerVolume(n,a){return this.getMainSession().setSpeakerVolume(n,a)}_deviceSelectionChanged(){this.session&&this.session.deviceSelectionChanged(),this.reconnectSession&&this.reconnectSession.deviceSelectionChanged()}disposeActiveSession(n){if(this.session&&this.isReconnecting()){this.logger.safe.info(`[${n}] About to dispose current session...`);const a=this.session;return this.lastKnownConfiguredModalities=this.session.getConfiguredModalities(),a.callbacks=this.reconnectManagerMessageQueue.queueCallbacks,a.move(this.reconnectSession,n),this.session=null,a.terminate(n,{},!1)}return Promise.resolve()}registerRetargetOutgoing(){this.diagnostics.registerRetarget("outgoing")}isSignalingStable(){return this._isSignalingStable}getConfiguredModalities(){return this.getMainSession().getConfiguredModalities()||this.lastKnownConfiguredModalities}checkIfTimerFailed(n){return!(this.isReconnectAllowed()||this.session&&!this.session.transportStateProvider?.isFailed||(this.onReconnectFailed("the time limit was reached",n),0))}async scheduleReconnectRetry(n,a,s){const c=this.getReconnectDelayTime();if(this.logger.safe.info(`[${n}] scheduling reconnect retry attempt in ${c}`),await Br(c),a||!this.checkIfTimerFailed(n))return this.reconnectAsync(n,s,s,this.onReconnectCompleted)}isRecoverableError(n){return ke.RENEGOTIATION_ERROR.media===n||ke.RENEGOTIATION_ERROR.signaling===n}async resetReconnectSession(n){this.logger.safe.info(`[${n}] Resetting reconnect session. Session exists: old: ${!!this.session}, new: ${!!this.reconnectSession}`),this.isReconnectConference=this.escalationType!==0||this.context.config.isConference;const a=this.escalationType!==0||this.context.config.isConference&&this.wasConnected&&!this.isDisconnected,s=this.getMainSession(),c=this.configProvider.getConfigView(this.isReconnectConference,s.getSessionConfig()),u=s.clone(a,c);u.callbacks={...this.sessionCallbacks,onTransportConnected:m=>{this.escalationType!==2&&this.completeReconnect(m),this.onReconnectCompleted?.(),this.raiseReconnectEvent("Good",m),this.sessionCallbacks.onTransportConnected(m)}},this.session&&(this.session.callbacks={...this.reconnectManagerMessageQueue.queueCallbacks,onSessionErrorOccurred:(m,b)=>(m.type!==ke.MEDIA_ERROR.iceConnectionError&&this.reconnectManagerMessageQueue.queueCallbacks.onSessionErrorOccurred(m,b),Promise.resolve())}),this.reconnectSession&&(this.reconnectSession.move(u,n),this.logger.safe.info(`[${n}] reconnect session still exists during reconnect clone operation`),await this.terminateReconnectSessionAsync(n,!1)),this.logger.safe.info(`[${n}] New session reset.`),this.reconnectSession=u}async initReconnect(n){this.logger.safe.info(`[${n}] initiate reconnect`),this.setReconnectTimer(),await this.resetReconnectSession(n),this.setSignalingState(!1),this.session&&(this.blockCurrentSession(n),await Promise.all([this.reconnectSession.muteInputAsync(n),this.reconnectSession.muteOutputAsync(n)]))}blockCurrentSession(n){this.logger.safe.debug(`[${n}] blocking current session negotiations`),this.negotiationPausePromise=this.session.pauseNegotiations(n)}unblockCurrentSession(n){this.negotiationPausePromise&&(this.logger.safe.debug(`[${n}] unblocking current session negotiations`),this.negotiationPausePromise.resolve(),this.negotiationPausePromise=null)}raiseReconnectEvent(n,a){this.ufdManager.signalEvent("NetworkReconnect",n,"Audio",!0,a)}async terminateReconnectSessionAsync(n,a){if(this.reconnectSession){const s=new gJe(this.sessionCallbacks);this.reconnectSession.callbacks={...s.queueCallbacks,onTerminated:a?this.sessionCallbacks.onTerminated:s.queueCallbacks.onTerminated},await this.reconnectSession.terminate(n,{},!1),s.clear(),this.reconnectSession=null}}setReconnectTimer(){const n=this.wasConnected?this.settings.reconnectTimeLimit:this.settings.initialReconnectTimeLimit;n>0&&!this.reconnectTimer&&(this.reconnectTimerStart=Date.now(),this.reconnectTimer=window.setTimeout(()=>this.resetReconnectTimer(),n))}resetReconnectTimer(){clearTimeout(this.reconnectTimer),this.reconnectTimer=null}isReconnectAllowed(){return!!this.reconnectTimer&&!this.isDisposing}getReconnectDelayTime(){return 1e3*Math.min(++this.reconnectDelayTime,this.settings.maxReconnectDelayTime)}getMaxNetworkWaitTime(){const n=this.reconnectTimerStart>0?Date.now()-this.reconnectTimerStart:0;return Math.max(this.settings.reconnectTimeLimit-n,0)}onReconnectFailed(n,a){this.callback.onSessionErrorOccurred({type:ke.MEDIA_ERROR.iceConnectionError,detail:`Reconnect failed, error - ${nn(n)}`},a,this.wasConnected)}setSignalingState(n){this._isSignalingStable=n}async handleTmpConnectivityLoss(n){this.logger.safe.info(`[${n}] Session went into disconnected state, giving it ${this.settings.losingConnectivityTimeoutMs}ms to recover`),this.settings.losingConnectivityTimeoutMs!==-1&&(await Br(this.settings.losingConnectivityTimeoutMs),this.isDisconnected&&this.raiseReconnectEvent("Poor",n)),this.isDisconnected&&this.settings.reconnectOnDisconnect&&(this.logger.safe.info(`[${n}] Session is still down, triggering reconnect`),this.onIceDisconnect(n))}},pCi=class{constructor(n,a){this.stats=n,this.diagnostics=a}set mediaLegId(n){this.stats.setMediaLegId(n.process()),this.diagnostics&&(this.diagnostics.mediaLegId=n)}set isMultiParty(n){n&&this.stats.setMultiParty(),this.diagnostics&&(this.diagnostics.isMultiParty=n)}set allowedModalities(n){this.stats.setSendModalities(n),this.diagnostics&&(this.diagnostics.allowedModalities=n)}set sessionError(n){this.stats.setError(n),this.diagnostics&&(this.diagnostics.sessionError=n)}set finalAnswerTime(n){this.stats.setFinalAnswerTimestamp(n),this.diagnostics&&(this.diagnostics.finalAnswerTime=n)}set dtmfResult(n){this.stats.dtmfResult(n),this.diagnostics&&(this.diagnostics.dtmfResult=n)}set swMute(n){this.stats.setSwMute(n),this.diagnostics&&(this.diagnostics.swMute=n)}set speakerMute(n){this.stats.setSpeakerMute(n),this.diagnostics&&(this.diagnostics.speakerMute=n)}set hwSilent(n){this.stats.setHwSilent(n),this.diagnostics&&(this.diagnostics.hwSilent=n)}set isSpeaking(n){this.stats.setSpeakingState(n),this.diagnostics&&(this.diagnostics.isSpeaking=n)}set iceConnectedStateTimestamp(n){this.stats.setIceConnectedStateTimestamp(n),this.diagnostics&&(this.diagnostics.iceConnectedStateTimestamp=n)}set iceInitTime(n){this.stats.setIceInitTimestamp(n),this.diagnostics&&(this.diagnostics.iceInitTime=n)}set ETag(n){this.stats.setETag(n),this.diagnostics&&(this.diagnostics.ETag=n)}set configIds(n){this.stats.setConfigIds(n),this.diagnostics&&(this.diagnostics.configIds=n)}set relay(n){this.stats.setRelay(n),this.diagnostics&&(this.diagnostics.relay=n)}negotiationStart(n){switch(this.diagnostics?.negotiationStart(n),n){case"Offering":this.stats.negotiation.offering.started();break;case"Answering":this.stats.negotiation.answering.started()}}negotiationCompleted(n){this.stats.negotiation.current.completed(n),this.diagnostics?.negotiationCompleted(n)}negotiationRejected(){this.stats.negotiation.current.rejected(),this.diagnostics?.negotiationRejected()}registerTransportConnected(){this.stats.registerTransportConnected(),this.diagnostics?.registerTransportConnected()}registerTransportDisconnected(){this.stats.registerTransportDisconnected(),this.diagnostics?.registerTransportDisconnected()}registerTransportFailed(){this.stats.registerTransportFailed(),this.diagnostics?.registerTransportFailed()}registerRollbackEvent(n){this.stats.registerRollbackEvent(n),this.diagnostics?.registerRollbackEvent(n)}registerRawMediaAccess(n,a,s){a==="send"?this.stats.registerSetInputRawMedia(s):this.stats.registerOutputRawMediaAccess(),this.diagnostics?.registerRawMediaAccess(n,a,s)}registerQualityStateChangedEvent(n){this.stats.registerQualityStateChangedEvent(n),this.diagnostics?.registerQualityStateChangedEvent(n)}terminated(n){this.stats.terminated(n),this.diagnostics?.terminated(n)}registerRemoteQualityStateChangedEvent(n,a){this.stats.registerRemoteQualityStateChangedEvent(n,a),this.diagnostics?.registerRemoteQualityStateChangedEvent(n,a)}},gCi=class{constructor(n){this.logger=n,this.operationQueue=null,this.currentOperationDeferred=null,this.operationQueue=new iL(this.logger)}queueOperation(n,a=hi()){this.logger.safe.info(`[${a}] queueing operation`);const s=new Pi,c=this.operationQueue.add(()=>(this.currentOperationDeferred=s,n()),a);return this.operationQueue.add(s,a),c}completeCurrentOperation(){this.currentOperationDeferred&&(this.logger.safe.info("completing operation"),this.currentOperationDeferred.resolve())}},mCi=class extends jr{constructor(n,a,s,c,u,m,b,_=s.getLogger().createChild("SessionV2",a)){super(_),this.context=s,this.callback=c,this.statistics=u,this.configProvider=m,this.diagnostics=b,this.logger=_,this.audioStreamStates={[ke.STREAMING_STATE.inactive]:[ke.STREAMING_STATE.started,ke.STREAMING_STATE.active,ke.STREAMING_STATE.failed],[ke.STREAMING_STATE.started]:[ke.STREAMING_STATE.active,ke.STREAMING_STATE.removed,ke.STREAMING_STATE.stopped,ke.STREAMING_STATE.failed],[ke.STREAMING_STATE.active]:[ke.STREAMING_STATE.removed,ke.STREAMING_STATE.stopped,ke.STREAMING_STATE.failed]},this.mediaLegId=new pJe,this.rejectedNegotiations=0,this.negotiationState=null,this.audioStreamState=ke.STREAMING_STATE.inactive,this.deviceManagerDisposables=[],this.visibilityChangedHandler=()=>{if(this.logger.safe.debug(`document.visibilityState changed: ${document.visibilityState}`),document.visibilityState==="visible"&&this.pcClosedInfo){const N=this.pcClosedInfo;this.pcClosedInfo=null,Date.now()<N.timestamp+this.configProvider.config.reconnectWakeupTimeLimit?(this.logger.safe.info(`[${N.causeId}] start reconnect after wakeup`),this.startReconnect(N.causeId)):(this.logger.safe.info(`[${N.causeId}] terminate a call after wakeup because allowed time limit for reconnect exceeded`),this.endCallOnFailure(N.mediaError,N.causeId))}document.visibilityState==="hidden"&&this.context.getSmallCallTelemetry()?.setEventType("visibilityHidden")},this.ufdManager=s.getUfdManager(),this.ufdManagerDisposable=this.ufdManager.on("onQualityChanged",N=>this.qualityChanged(N)),this.sessionOperationQueue=new gCi(this.logger),this.mediaLegId=new pJe,this.diagnosticsWrapper=new pCi(this.statistics,this.diagnostics),this.statistics.setId(a),this.diagnosticsWrapper.mediaLegId=this.mediaLegId,this.diagnosticsWrapper.ETag=this.configProvider.ETag,this.diagnosticsWrapper.configIds=this.configProvider.ecsConfigIds,this.diagnosticsWrapper.isMultiParty=!!s.config.isConference,this.recoverableErrors=this.configProvider.config.recoverableMediaErrors.split(","),this.forceReconnectErrors=this.configProvider.config.forceReconnectErrors.split(",");const k=this.getSessionCallbacks();n.callbacks=k,n.relayManagerProvider=this,this.reconnectManager=new hCi(n,s,new uCi(this.statistics,this.diagnostics?new cCi(this.configProvider):void 0,this.diagnostics),this.sessionOperationQueue,this.getReconnectManagerCallbacks(),k,this.configProvider,this.getRelayManager()),this.deviceManager=this.context.callDeviceManager.getDefaultDeviceManager(),this.deviceManagerDisposables.push(this.deviceManager.on("onDevicesPermissionChanged",()=>this.diagnosticsWrapper.allowedModalities=this.getAllowedModalities())),this.deviceManagerDisposables.push(this.deviceManager.on("onSelectedDevicesChanged",()=>this.deviceSelectionChanged())),this.deviceManagerDisposables.push(this.deviceManager.on("onDevicesChanged",(N,W)=>this.deviceListChanged(W))),this.statistics.setDevicesCount(this.deviceManager.getDevicesCount()),this.diagnostics&&(this.diagnostics.relayManager=this.getRelayManager()),this.ufdManager.applyCurrentState(N=>this.qualityChanged(N)),document.addEventListener("visibilitychange",this.visibilityChangedHandler),this.requestWakeLock()}async requestWakeLock(){if(yp.isWakeLockSupported()&&this.configProvider.config.useWakeLockApi)try{this.wakeLock=await window.navigator.wakeLock.request("screen")}catch(n){this.logger.safe.info(`Wakelock request failed - ${n.message}`)}}enableTeamsRealTimeTelemetry(){this.realtimeTelemetryInterval||(this.logger.safe.info("teams realtime telemetry is enabled"),this.getSessionCallbacks().onTeamsRealtimeTelemetryReport(),this.realtimeTelemetryInterval=window.setInterval(()=>{this.getSessionCallbacks().onTeamsRealtimeTelemetryReport()},1e3*this.configProvider.config.diagnostics.teamsRealtimeTelemetry.pollingInterval))}getMediaStatsReport(){return this.diagnostics?.mediaStatsReport}createOfferAsync(n,a){return this.sessionOperationQueue.queueOperation(async()=>{this.diagnosticsWrapper.negotiationStart("Offering");try{const s=await this.getCurrentSession().createOfferAsync(n,a);return this.updateSelectedDevices(),s.mediaLegId=this.mediaLegId.process(s.mediaLegId),this.diagnosticsWrapper.mediaLegId=this.mediaLegId,this.reconnectManager.isReconnecting()&&!this.reconnectManager.isSignalingStable()&&(this.reconnectManager.registerRetargetOutgoing(),s.newOffer=!0),s}catch(s){throw this.diagnosticsWrapper.sessionError=s,s}},n)}registerRemoteQualityStateChangedEvent(n,a){this.diagnosticsWrapper.registerRemoteQualityStateChangedEvent(n,a)}setCallConstraints(n,a){return this.getCurrentSession().setCallConstraints(n,a)}processOfferAsync(n,a){return this.sessionOperationQueue.queueOperation(async()=>{this.diagnosticsWrapper.negotiationStart("Answering"),n.mediaLegId=this.mediaLegId.process(n.mediaLegId);try{n.newOffer&&await this.reconnectManager.acceptReconnectStartAsync(n.escalationOccurring,a);const s=await this.getCurrentSession().processOfferAsync(n,a);if(n.newOffer){const c=await this.reconnectManager.acceptReconnectFinish(a);return s.sharing===ke.MEDIA_STATE.sendReceive&&(s.sharing=c.sharing===ke.MEDIA_STATE.send?ke.MEDIA_STATE.send:ke.MEDIA_STATE.receive),s}return s}catch(s){throw this.diagnosticsWrapper.sessionError=s,s}},a)}async processAnswerAsync(n,a,s,c){try{return this.configProvider.config.muteDuringRemotePranswer&&(s&&!this.callMuteState&&(this.logger.safe.info(`[${a}] Muting input before processing full answer`),await this.muteInputAsync(a),this.lastMuteFromPranswer=!0),!s&&this.lastMuteFromPranswer&&(this.logger.safe.info(`[${a}] Unmuting input before processing full answer`),await this.unmuteInputAsync(a),this.lastMuteFromPranswer=!1)),await this.getCurrentSession().processAnswerAsync(n,a,s,c)}catch(u){throw this.lastMuteFromPranswer=!1,this.diagnosticsWrapper.sessionError=u,u}}async completeNegotiationAsync(n){this.rejectedNegotiations=0;try{const a=await this.getCurrentSession().completeNegotiationAsync(n);return this.negotiationState=a,this.diagnosticsWrapper.finalAnswerTime=Date.now(),this.diagnosticsWrapper.negotiationCompleted?.(a.activeModalities),await this.reconnectManager.onNegotiationCompletedAsync(n),this.sessionOperationQueue.completeCurrentOperation(),this.negotiationState}catch(a){throw this.diagnosticsWrapper.sessionError=a,a}}ignoreNotReconnectError(n){return n.detail?.type!==ke.MEDIA_ERROR.incompatibleOriginator}async rejectNegotiationAsync(n,a){this.logger.safe.info(`[${a}] rejectNegotiationAsync`,n);try{if(this.reconnectManager.isReconnecting()&&this.ignoreNotReconnectError(n))return await this.reconnectManager.onNegotiationRejection(n,a),this.registerNegotiationRejection(this.negotiationState),this.sessionOperationQueue.completeCurrentOperation(),this.negotiationState;{const s=await this.getCurrentSession().rejectNegotiationAsync(n,a,this.isRenegotiationAllowed(n.type));return this.sessionOperationQueue.completeCurrentOperation(),this.registerNegotiationRejection(s),s}}catch(s){throw this.diagnosticsWrapper.sessionError=s,s}}completeEscalationAsync(n){return this.reconnectManager.completeReconnect(n)}rejectEscalationAsync(n){return this.reconnectManager.rejectReconnect(n)}async terminate(n,a){this.logger.safe.info(`terminate reject reason: ${JSON.stringify(a||"")}`),this.registerVideoEffectsTelemetryEvent(this.deviceManager.effectsManager.getStats("Video","StatsQuery")),this.registerAudioEffectsTelemetryEvent(this.deviceManager.effectsManager.getStats("Audio")),this.statistics.setPermissionStates(await this.deviceManager.getKnownPermissionStates()),this.diagnosticsWrapper.terminated(a);const s=()=>this.cleanUp();return this.reconnectManager.terminateAsync(n).then(s,s)}async getStatsAsync(n){return this.configProvider.config.diagnostics.useForTelemetry?this.diagnostics?.telemetryReport:this.getMainSession().getStatsAsync(n).then(a=>this.prepareStats(a))}getLastKnownStats(n=!1){return this.configProvider.config.diagnostics.useForTelemetry?this.diagnostics?.telemetryReport:this.prepareStats(this.getMainSession().getLastKnownStats(n),n)}getCallTechnicalInfo(){return this.diagnostics?.realtimeTelemetryReport}async createAnswerAsync(n,a){try{const s=await this.getCurrentSession().createAnswerAsync(n,a);return this.updateSelectedDevices(),s.mediaLegId=this.mediaLegId.process(s.mediaLegId),this.diagnosticsWrapper.mediaLegId=this.mediaLegId,s}catch(s){throw this.diagnosticsWrapper.sessionError=s,s}}configureModalitiesAsync(n,a,s){return Ng(n,(c,u)=>{c||delete n[u]}),this.reconnectManager.configureModalitiesAsync(n,a,s)}getAllowedModalities(){return this.deviceManager.getAllowedModalities()}createRemoteRenderer(n){return this.getMainSession().createRemoteRenderer(n)}async sendDtmf(n){try{const a=await this.getMainSession().sendDtmf(n);return this.diagnosticsWrapper.dtmfResult=!0,a}catch(a){throw this.diagnosticsWrapper.dtmfResult=!1,a}}canSendDtmf(){return this.reconnectManager.canSendDtmf()}muteHold(n,a){this.reconnectManager.muteHold(n,a)}muteInputAsync(n){return this.callMuteState=!0,this.diagnosticsWrapper.swMute=!0,this.lastMuteFromPranswer=!1,this.reconnectManager.muteInputAsync(n)}unmuteInputAsync(n){return this.callMuteState=!1,this.diagnosticsWrapper.swMute=!1,this.lastMuteFromPranswer=!1,this.reconnectManager.unmuteInputAsync(n)}muteOutputAsync(n){return this.diagnosticsWrapper.speakerMute=!0,this.reconnectManager.muteOutputAsync(n)}unmuteOutputAsync(n){return this.diagnosticsWrapper.speakerMute=!1,this.reconnectManager.unmuteOutputAsync(n)}async getSpeakerVolume(n){return this.reconnectManager.getSpeakerVolume(n)}async setSpeakerVolume(n,a){return this.reconnectManager.setSpeakerVolume(n,a)}getAcceptedTypes(){return this.reconnectManager.getCurrentSession().getAcceptedTypes()}useNullAudioStreamClient(){this.getCurrentSession().useNullAudioStreamClient()}createAudioElement(n){this.getCurrentSession().createAudioElement(n)}getIncomingRawAudioStream(n){return this.diagnosticsWrapper.registerRawMediaAccess("audio","recv",!0),this.getCurrentSession().getIncomingRawAudioStream(n)}getUnmixedAudioProvider(){return this.getCurrentSession().getUnmixedAudioProvider()}deviceSelectionChanged(){this.updateSelectedDevices(),this.reconnectManager._deviceSelectionChanged()}registerDeviceTelemetryEvent(n){this.getCurrentSession().onDeviceEvent(n),this.statistics.registerDeviceTelemetryEvent(n)}registerVideoEffectsTelemetryEvent(n){this.statistics.registerVideoEffectsTelemetryEvent(n)}registerAudioEffectsTelemetryEvent(n){this.statistics.registerAudioEffectsTelemetryEvent(n)}reconnectAsync(n,a=!1,s){return this.reconnectManager.reconnectAsync(n,!0,a,s)}isReconnecting(){return this.reconnectManager.isReconnecting()}getRelayManager(){return this.relayManager??(this.relayManager=new dCi(this.context.maContext.getRelayManager(),this.diagnosticsWrapper))}getSessionConfig(){return this.reconnectManager.getCurrentSession().getSessionConfig()}getDiagnostics(){return this.diagnostics}async getAudioSenderStats(){return this.getCurrentSession().getAudioSenderStats()}getLocalMediaTrackId(n){return this.reconnectManager.getMainSession().getLocalMediaTrackId(n)}getSubscriptionManager(){return this.getCurrentSession().getSubscriptionManager()}getDisabledModalities(){return this.getCurrentSession().getDisabledModalities()}configureSpatialAudio(n,a){this.getCurrentSession().configureSpatialAudio(n,a)}setParticipantSpatialAudioPositions(n,a){this.getCurrentSession().setParticipantSpatialAudioPositions(n,a)}startMediaDescriptionsUpdateAsync(n,a){return this.getCurrentSession().startMediaDescriptionsUpdateAsync(n,a)}completeMediaDescriptionsUpdateAsync(n){return this.getCurrentSession().completeMediaDescriptionsUpdateAsync(n)}rejectMediaDescriptionsUpdateAsync(n,a){return this.getCurrentSession().rejectMediaDescriptionsUpdateAsync(n,a)}processNotification(n,a){this.getCurrentSession().processNotification(n,a)}getMediaControlPlaneInstance(){return this.getCurrentSession().getMediaControlPlaneInstance()}async cleanUp(){this.callback=null,this.deviceManagerDisposables.forEach(n=>n.dispose()),this.ufdManagerDisposable.dispose(),this.reconnectManager.dispose(),this.pcClosedInfo=null,document.removeEventListener("visibilitychange",this.visibilityChangedHandler),window.clearInterval(this.realtimeTelemetryInterval),this.wakeLock&&(await this.wakeLock.release(),this.wakeLock=null)}updateSelectedDevices(){const n=this.deviceManager.getSelectedDevices(),a=s=>s?this.deviceManager.getDeviceNameAsync(s).then(c=>Q_(c,this.configProvider.config.devices.piiSafeWords)):Promise.resolve("none");Promise.all([a(n.microphone),a(n.speaker),a(n.camera)]).then(([s,c,u])=>{this.statistics.setUsedDevices({microphone:s,speaker:c,camera:u})})}getCurrentSession(){return this.reconnectManager.getCurrentSession()}getMainSession(){return this.reconnectManager.getMainSession()}setAudioStreamState(n,a,s){this.isAudioStateValid(n)?this.raiseAudioStateChanged(n,a,s):this.logger.safe.error(`[${a}] audio state transition is invalid: ${this.audioStreamState} -> ${n}`)}isAudioStateValid(n){return this.audioStreamStates[this.audioStreamState].indexOf(n)>=-1}raiseAudioStateChanged(n,a,s){if(this.logger.safe.info(`[${a}] audio state changed to ${n}`),this.callback.onAudioStateChanged){const c={content:"audio",direction:"receive",stream:n};this.callback.onAudioStateChanged(c,s)}}getReconnectManagerCallbacks(){return{onSessionErrorOccurred:(n,a,s)=>{this.isNetworkMediaError(n)&&!s&&this.ufdManager.raisePendingWhitelistingUFD(),this.endCallOnFailure(n,a)}}}isNetworkMediaError(n){return n.type===ke.MEDIA_ERROR.iceConnectionError||n.type===ke.MEDIA_ERROR.noNetworkError}isRecoverableMediaError(n){return this.recoverableErrors.includes(n.type)}startReconnect(n=hi()){return this.reconnectManager.onIceDisconnect(n)}shouldForceReconnect(n){return this.forceReconnectErrors.includes(n.type)}isUnexpectedPcClose(n){return n.type===ke.MEDIA_ERROR.unexpectedClose}getSessionCallbacks(){return this.sessionCallbacks||(this.sessionCallbacks={onTerminated:()=>{this.logger.safe.warn("call onTerminated"),this.event("onTerminated").raise(this)},onSessionErrorOccurred:(n,a=hi())=>this.isUnexpectedPcClose(n)?this.handlePcClosed(n,a):this.shouldForceReconnect(n)?this.reconnectManager.reconnectAsync(a,!0):this.isRecoverableMediaError(n)?this.reconnectManager.isReconnecting()?this.reconnectManager.onSessionErrorOccurred(n,a):this.startReconnect(a):(this.endCallOnFailure(n,a),Promise.resolve()),onNegotiationRequired:(n,a)=>this.callback.onNegotiationRequired(n,a),onAudioHwSilentChanged:n=>{this.diagnosticsWrapper.hwSilent=n},onAudioStateChanged:(n,a)=>{this.setAudioStreamState(n,a)},onTransportConnected:(n=hi())=>{this.logger.safe.info(`[${n}] Transport connectivity established`),this.ufdManager.cancelPendingWhitelistingUFD(),this.reconnectManager.onConnected(n),this.diagnosticsWrapper.registerTransportConnected(),this.diagnosticsWrapper.iceConnectedStateTimestamp=Date.now(),this.callback?.onTransportConnected(n)},onTransportDisconnected:(n=hi())=>{this.logger.safe.warn(`[${n}] Transport connectivity lost`),this.reconnectManager.onTransportDisconnect(n),this.diagnosticsWrapper.registerTransportDisconnected(),this.callback?.onTransportDisconnected?.(n)},onTransportFailed:()=>{this.diagnosticsWrapper.registerTransportFailed(),this.callback?.onTransportFailed?.()},onTransportInitialized:()=>{this.diagnosticsWrapper.iceInitTime=Date.now()},onUpdateMediaDescriptionsRequired:(n,a)=>this.callback.onUpdateMediaDescriptionsRequired(n,a),onTeamsRealtimeTelemetryReport:()=>this.callback.onRealtimeTelemetryReport()}),this.sessionCallbacks}registerNegotiationRejection(n){this.rejectedNegotiations++,this.diagnosticsWrapper.negotiationRejected?.(),n.rollback&&this.diagnosticsWrapper.registerRollbackEvent(n.rollback)}isRenegotiationAllowed(n){return this.rejectedNegotiations<this.context.configProvider.config.renegotiationAttempts&&!this.reconnectManager.isReconnectScheduled&&(ke.RENEGOTIATION_ERROR.signaling===n||ke.RENEGOTIATION_ERROR.media===n)}prepareStats(n,a=!1){this.statistics.setDeviceList(this.deviceManager.getDeviceDescriptions(),this.deviceManager.getDeviceListDebugInfo()),this.statistics.setRelayManagerTimers(this.getRelayManager().getStats()),this.statistics.setVideoEffectStats(this.context.callDeviceManager.getDeviceManager("Video").effectsManager.getStats("Video","StatsQuery")),this.statistics.setAudioEffectStats(this.deviceManager.effectsManager.getStats("Audio"));const s=this.statistics.generateStatistics(n,this.mediaLegId,a);return this.configProvider.config.diagnostics.features.useNewerStatisticsMetrics&&(s.data.metrics=this.diagnostics?.telemetryReport?.data.metrics),!n.data.Extensions?.StartTime&&this.configProvider.config.diagnostics.features.useFallbackToNewExtensions&&(s.data.Extensions=this.diagnostics?.telemetryReport?.data.Extensions),s}deviceListChanged(n){n&&this.statistics.deviceChangedByPoll(),this.statistics.devicesChanged(),this.statistics.setDevicesCount(this.deviceManager.getDevicesCount())}qualityChanged(n){const a=n.deviceManagerId;!a||this.context.callDeviceManager.hasDevice(a)?(this.context.getSmallCallTelemetry()?.setEventType(n.type),this.callback?.onQualityChanged&&(this.diagnosticsWrapper.registerQualityStateChangedEvent(n),n.type==="DeviceSpeakWhileMuted"&&(this.diagnosticsWrapper.isSpeaking=n.value!=="Good"),this.callback.onQualityChanged(n))):this.logger.info(`${a} - is not added to Call, skipping UFD.`)}endCallOnFailure(n,a,s){this.callback&&(this.callback.onSessionErrorOccurred&&this.callback.onSessionErrorOccurred(n,a),this.diagnosticsWrapper.sessionError=n,this.setAudioStreamState(ke.STREAMING_STATE.failed,a,s))}async handlePcClosed(n,a){const s=this.configProvider.config.reconnectWakeupTimeLimit;return this.logger.safe.info(`[${a}] handle unexpected PC closed event`,`visibilityState=${document.visibilityState}, wakeupLimit=${this.configProvider.config.reconnectWakeupTimeLimit}`),document.visibilityState==="visible"?this.startReconnect(a):s?void(this.pcClosedInfo={timestamp:Date.now(),causeId:a,mediaError:n}):this.endCallOnFailure(n,a,"suspended")}},fCi=class{constructor(n){this.creationTime=n,this.records=[],this.activeRecord=null,this.activeAttempt=null,this.reconnectState=!1}getReport(){return this.records.length?JSON.stringify(this.records):""}isReconnecting(){return this.reconnectState}onReconnectStart(){this.reconnectState=!0,this.activeRecord||(this.activeRecord={attempts:[],endTime:null,startTime:Date.now()-this.creationTime},this.records.push(this.activeRecord))}onReconnectAttempt(n){if(!this.activeRecord)return null;this.activeAttempt={direction:n,status:!1,endTime:null,startTime:this.getTimestamp()},this.reconnectState=!0,this.activeRecord.attempts.push(this.activeAttempt)}onReconnectConnected(){if(!this.activeRecord)return null;this.reconnectState=!1,this.activeRecord.endTime=this.getTimestamp(),this.activeRecord=this.activeAttempt=null}onReconnectCompleted(){this.reconnectState=!1,this.resolveReconnectAttempt(!0)}onReconnectRejected(){this.resolveReconnectAttempt(!1)}resolveReconnectAttempt(n){this.activeAttempt&&this.activeRecord&&(this.activeAttempt.status=n,this.activeAttempt.endTime=this.getTimestamp())}getTimestamp(){return Date.now()-this.creationTime-this.activeRecord.startTime}},yJe=window.navigator,SJe=class{constructor(n="Good"){this.stopWatches=[],this.currentLevel=n,this.getStopWatch(n).start()}updateLevel(n){this.currentLevel!==n&&(this.getStopWatch(this.currentLevel).stop(),this.currentLevel=n,this.getStopWatch(this.currentLevel).start())}getCount(n){const a=this.stopWatches[n];return a?a.count:0}getElapsed(n){const a=this.stopWatches[n];return a?a.elapsed:0}getStopWatch(n){let a=this.stopWatches[n];return a||(a=new tg,this.stopWatches[n]=a),a}},vCi=RegExp(/^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\:[0-9]{2,5})?$/),yCi=RegExp(/^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))(:[0-9]{2,5})?$/),SCi=class{constructor(n,a,s){this.configProvider=n,this.callNumber=a,this.sessionDiagnostics=s,this.negotiation={offering:this.offering(),answering:this.answering(),current:this.current()},this.creationTime=Date.now(),this.negotiationCount=0,this.initialNegotiationCompleted=!1,this.activeModalities={},this.multiParty=!1,this.noIceCandidatesGoodEventCount=0,this.noIceCandidatesBadEventCount=0,this.noRelayIceCandidatesGoodEventCount=0,this.noRelayIceCandidatesBadEventCount=0,this.cameraInUseBadEventCount=0,this.cameraInUseGoodEventCount=0,this.microphoneInUseBadEventCount=0,this.microphoneInUseGoodEventCount=0,this.cameraFreezeStartEventCount=0,this.cameraFreezeEndEventCount=0,this.networkRecv=new SJe,this.networkSend=new SJe,this.retargetIncomingCount=0,this.retargetOutgoingCount=0,this.retargetCompletedCount=0,this.retargetRejectedCount=0,this.reconnectAttemptedCount=0,this.reconnectConnectedCount=0,this.escalationAttemptedCount=0,this.escalationCompletedCount=0,this.escalationRejectedCount=0,this.durationTimer=new tg,this.terminationReason={},this.terminationTime=0,this.sessionId="0",this.rejectedNegotiationCount=0,this.mediaError={type:"none",detail:"none"},this.incompatibleOffer=!1,this.dtmfSuccess=0,this.dtmfFailure=0,this.relay=null,this.relayManagerTimers=null,this.allowedAudioSend=!0,this.allowedVideoSend=!0,this.allowedScreensharingSend=!0,this.iceInitTime=0,this.finalAnswerTime=0,this.iceConnectedStateTime=0,this.usedDevices=null,this.deviceSelectionChangeCount=0,this.devicesChangeCount=0,this.devicesPollChangeCount=0,this.mute=new tg,this.osMute=new tg,this.hwSilent=new tg,this.isSpeaking=new tg,this.swMute=new tg,this.speakerMute=new tg,this.deviceTelemetryEvents=[],this.videoEffectsTelemetryEvents=new Du(this.configProvider.config.effectsTelemetryBufferSize),this.audioEffectsTelemetryEvents=new Du(this.configProvider.config.effectsTelemetryBufferSize),this.devicesCount=null,this.reconnectStats=new fCi(this.creationTime),this.transportDisconnected=!1,this.transportReconnectedCount=0,this.ufds=[],this.remoteUfds=[],this.mediaQosEnabled=!1,this.portRangeConfigured=!1,this.rollbackNegotiation=[],this.rawOutputAudioAccess={attempt:0,timer:new tg},this.rawInputAudioOverride={attempt:0,timer:new tg},this.connectionEffectiveTypeSeries=new Du(this.configProvider.config.navConnectionNumSamplesToCollect),this.connectionRttSeries=new Du(this.configProvider.config.navConnectionNumSamplesToCollect),this.connectionDownlinkSeries=new Du(this.configProvider.config.navConnectionNumSamplesToCollect),this.navigatorConnectionInterval=setInterval(()=>{const c=yJe?.connection;c&&(typeof c.downlink=="number"&&this.connectionDownlinkSeries.add(c.downlink),typeof c.rtt=="number"&&this.connectionRttSeries.add(c.rtt),typeof c.effectiveType=="number"&&this.connectionEffectiveTypeSeries.add(c.effectiveType))},this.configProvider.config.navConnectionPollingInterval),this.durationTimer.start()}terminated(n){this.terminationReason=fs(n),this.terminationTime=Date.now(),this.durationTimer.stop(),this.osMute.stop(),this.swMute.stop(),this.hwSilent.stop(),this.isSpeaking.stop(),this.mute.stop(),this.speakerMute.stop(),this.rawInputAudioOverride.timer.stop(),this.rawOutputAudioAccess.timer.stop(),clearInterval(this.navigatorConnectionInterval)}setMultiParty(){this.multiParty=!0}updateCommonMute(){this.swMute.isRunning||this.osMute.isRunning?this.mute.start():this.mute.stop()}setDeviceList(n,a){this.deviceList=n.map(s=>({label:Q_(s.label,this.configProvider.config.devices.piiSafeWords),kind:s.kind})),a&&(this.deviceDebugStrings=fs(a))}setPermissionStates(n){this.permissionStates=n}setSwMute(n){n?this.swMute.start():this.swMute.stop(),this.updateCommonMute()}setSpeakerMute(n){n?this.speakerMute.start():this.speakerMute.stop()}setHwSilent(n){n?this.hwSilent.start():this.hwSilent.stop()}setSpeakingState(n){n?this.isSpeaking.start():this.isSpeaking.stop()}setETag(n){this.ETag=n}setConfigIds(n){this.configIds=n}setVideoEffectStats(n){n&&this.videoEffectsTelemetryEvents.add(n)}setAudioEffectStats(n){n&&this.audioEffectsTelemetryEvents.add(n)}registerQualityStateChangedEvent(n){switch(n.type){case"NoNetwork":n.value==="Good"?this.noIceCandidatesGoodEventCount++:this.noIceCandidatesBadEventCount++;break;case"NetworkRelaysNotReachable":n.value==="Good"?this.noRelayIceCandidatesGoodEventCount++:this.noRelayIceCandidatesBadEventCount++;break;case"DeviceCaptureNotFunctioning":n.value==="Good"?this.microphoneInUseGoodEventCount++:this.microphoneInUseBadEventCount++;break;case"VideoCapturerDeviceStartFailed":n.value==="Good"?this.cameraInUseGoodEventCount++:this.cameraInUseBadEventCount++;break;case"DeviceCaptureMute":n.mediaType==="Audio"&&(n.value==="Bad"?this.osMute.start():this.osMute.stop(),this.updateCommonMute());break;case"NetworkRecvQuality":this.networkRecv.updateLevel(n.value);break;case"NetworkSendQuality":this.networkSend.updateLevel(n.value);break;case"VideoCaptureDeviceFreeze":n.value==="Good"?this.cameraFreezeEndEventCount++:this.cameraFreezeStartEventCount++}n.type!=="DeviceSpeakWhileMuted"&&this.ufds.push({...n,timestamp:Date.now()-this.creationTime}),this.ufds.length>this.configProvider.config.maxStoredUFDCount&&this.ufds.shift()}registerRemoteQualityStateChangedEvent(n,a){n.forEach(s=>{ld(this.remoteUfds,{...s,participantId:a,timestamp:Date.now()},this.configProvider.config.diagnostics.collectionLimits.numUFDs)})}registerRetargetIncoming(){this.retargetIncomingCount++}registerRetargetOutgoing(){this.retargetOutgoingCount++}registerRetargetCompleted(){this.retargetCompletedCount++}registerRetargetRejected(){this.retargetRejectedCount++}registerEscalationStart(){this.escalationAttemptedCount++}registerEscalationCompleted(){this.escalationCompletedCount++}registerEscalationRejected(){this.escalationRejectedCount++}registerRollbackEvent(n){n&&this.rollbackNegotiation.push({type:n.type,attempt:this.rollbackNegotiation.length+1,error:n.error?n.error:""})}registerReconnectAttempted(){this.reconnectAttemptedCount++,this.reconnectStats.onReconnectStart()}registerReconnectConnected(){this.reconnectConnectedCount++,this.reconnectStats.onReconnectConnected()}registerDeviceTelemetryEvent(n){n.timestamp=n.timestamp-this.creationTime,this.deviceTelemetryEvents.push(n)}registerVideoEffectsTelemetryEvent(n){n&&(n.timestamp=n.timestamp-this.creationTime,this.videoEffectsTelemetryEvents.add(n))}registerAudioEffectsTelemetryEvent(n){if(n){n.timestamp=n.timestamp-this.creationTime;const a=this.audioEffectsTelemetryEvents.items.pop();a&&this.audioEffectsChanged(a,n)&&this.audioEffectsTelemetryEvents.add(a),this.audioEffectsTelemetryEvents.add(n)}}audioEffectsChanged(n,a){return n.payload.fallback!==a.payload.fallback||a.payload.userNoiseSuppressionMethod!==void 0&&n.payload.userNoiseSuppressionMethod!==a.payload.userNoiseSuppressionMethod||a.payload.userAudioEffect!==void 0&&n.payload.userAudioEffect!==a.payload.userAudioEffect}registerReconnectAttempt(n){this.reconnectStats.onReconnectAttempt(n)}registerReconnectAttemptCompleted(){this.reconnectStats.onReconnectCompleted()}registerReconnectAttemptRejected(){this.reconnectStats.onReconnectRejected()}setMediaLegId(n){this.mediaLegId=n}setId(n){this.sessionId=n}setError(n){n.type===ke.MEDIA_ERROR.incompatibleOffer&&(this.incompatibleOffer=!0),this.mediaError.type=n.type||ke.MEDIA_ERROR.internalError,this.mediaError.detail=n.detail||n.toString()}setRelay(n){this.relay={address:n.addresses.join(),expires:n.expires,realm:n.realm,credentials:!(!n.username||!n.password),ports:[n.udpPort?`udp:${n.udpPort}`:"",n.tcpPort?`tcp:${n.tcpPort}`:"",n.tlsPort?`tls:${n.tlsPort}`:""].join(","),fqdns:n.fqdns?n.fqdns.join():"none"}}setRelayManagerTimers(n){this.relayManagerTimers=n}setSendModalities(n){this.allowedAudioSend=n.audio.some(a=>Ur(a)),this.allowedVideoSend=n.video.some(a=>Ur(a)),this.allowedScreensharingSend=n.sharing.some(a=>Ur(a))}setIceInitTimestamp(n){this.iceInitTime||(this.iceInitTime=n)}setFinalAnswerTimestamp(n){this.finalAnswerTime||(this.finalAnswerTime=n)}setIceConnectedStateTimestamp(n){this.iceConnectedStateTime||(this.iceConnectedStateTime=n)}dtmfResult(n){n?++this.dtmfSuccess:++this.dtmfFailure}setUsedDevices(n){this.usedDevices&&JSON.stringify(n)!==JSON.stringify(this.usedDevices)&&this.deviceSelectionChangeCount++,this.usedDevices=n}setDevicesCount(n){this.devicesCount=n}setMediaQosEnabled(n){this.mediaQosEnabled=n}setPortRangeConfigured(n){this.portRangeConfigured=n}devicesChanged(){this.devicesChangeCount++}deviceChangedByPoll(){this.devicesPollChangeCount++}registerOutputRawMediaAccess(){this.rawOutputAudioAccess.attempt++,this.rawOutputAudioAccess.timer.start()}registerSetInputRawMedia(n){this.rawInputAudioOverride.attempt++,n?this.rawInputAudioOverride.timer.start():this.rawInputAudioOverride.timer.stop()}getReport(){const n=this.usedDevices||{microphone:"none",speaker:"none",camera:"none"};return{RawOutputAudioAccessDurationRatio:this.getDurationRatio(this.rawOutputAudioAccess.timer.elapsed),RawOutputAudioAccessAttempted:this.rawOutputAudioAccess.attempt,RawInputAudioOverrideDurationRatio:this.getDurationRatio(this.rawInputAudioOverride.timer.elapsed),RawInputAudioOverrideAttempted:this.rawInputAudioOverride.attempt,SessionId:this.sessionId,CallNumber:this.callNumber,NoIceCandidatesBadEventCount:this.noIceCandidatesBadEventCount,NoIceCandidatesGoodEventCount:this.noIceCandidatesGoodEventCount,NoRelayIceCandidatesBadEventCount:this.noRelayIceCandidatesBadEventCount,NoRelayIceCandidatesGoodEventCount:this.noRelayIceCandidatesGoodEventCount,CameraInUseBadEventCount:this.cameraInUseBadEventCount,CameraInUseGoodEventCount:this.cameraInUseGoodEventCount,MicrophoneInUseBadEventCount:this.microphoneInUseBadEventCount,MicrophoneInUseGoodEventCount:this.microphoneInUseGoodEventCount,CameraFreezeStartEventCount:this.cameraFreezeStartEventCount,CameraFreezeEndEventCount:this.cameraFreezeEndEventCount,RetargetIncomingCount:this.retargetIncomingCount,RetargetOutgoingCount:this.retargetOutgoingCount,RetargetCompletedCount:this.retargetCompletedCount,RetargetRejectedCount:this.retargetRejectedCount,ReconnectAttemptedCount:this.reconnectAttemptedCount,ReconnectConnectedCount:this.reconnectConnectedCount,EscalationAttemptedCount:this.escalationAttemptedCount,EscalationCompletedCount:this.escalationCompletedCount,EscalationRejectedCount:this.escalationRejectedCount,CreationTime:this.getHpTimeFromMillis(this.creationTime),InitTime:this.getHpTimeFromMillis(this.creationTime),TerminationTime:this.getHpTimeFromMillis(this.terminationTime),CallDuration:this.getHpTimeFromMillis(this.getCurrentDuration()),InitialNegotiationType:this.initialNegotiationType||"none",InitialNegotiationCompleted:this.initialNegotiationCompleted,ActiveModalities:JSON.stringify(this.activeModalities),NegotiationCount:this.negotiationCount,RejectedNegotiationCount:this.rejectedNegotiationCount,MediaLegId:this.mediaLegId,MultiParty:this.multiParty,ErrorType:this.mediaError.type,ErrorDetail:this.mediaError.detail,TerminationReason:this.terminationReason,IncompatibleOffer:this.incompatibleOffer,DtmfSuccess:this.dtmfSuccess,DtmfFailure:this.dtmfFailure,Relay:this.relay?JSON.stringify(this.relay):"none",RelayManager:this.relayManagerTimers?JSON.stringify(this.relayManagerTimers):"none",AllowedAudioSend:this.allowedAudioSend,AllowedVideoSend:this.allowedVideoSend,AllowedScreensharingSend:this.allowedScreensharingSend,IceInitTime:this.getHpTimeFromMillis(this.iceInitTime),FinalAnswerTime:this.getHpTimeFromMillis(this.finalAnswerTime),IceConnectedStateTime:this.getHpTimeFromMillis(this.iceConnectedStateTime),UsedMicrophone:n.microphone,UsedSpeaker:n.speaker,UsedCamera:n.camera,DeviceSelectionChangeCount:this.deviceSelectionChangeCount,DevicesChangeCount:this.devicesChangeCount,DevicesPollChangeCount:this.devicesPollChangeCount,DevicesCount:this.devicesCount?JSON.stringify(this.devicesCount):"none",ETag:this.ETag||"",ConfigIds:this.configIds?Array.isArray(this.configIds)?this.configIds.join(","):this.configIds:"",CallMutedRatio:this.getDurationRatio(this.mute.elapsed),CallOsMuted:this.getHpTimeFromMillis(this.osMute.elapsed),CallHwSilent:this.getHpTimeFromMillis(this.hwSilent.elapsed),CallSwMuted:this.getHpTimeFromMillis(this.swMute.elapsed),CallSpeakerMuted:this.getHpTimeFromMillis(this.speakerMute.elapsed),CallIsSpeaking:this.getHpTimeFromMillis(this.isSpeaking.elapsed),NetworkRecvGood:this.networkRecv.getCount("Good")-1,NetworkRecvPoor:this.networkRecv.getCount("Poor"),NetworkRecvBad:this.networkRecv.getCount("Bad"),NetworkSendGood:this.networkSend.getCount("Good")-1,NetworkSendPoor:this.networkSend.getCount("Poor"),NetworkSendBad:this.networkSend.getCount("Bad"),NetworkRecvGoodRatio:this.getDurationRatio(this.networkRecv.getElapsed("Good")),NetworkRecvPoorRatio:this.getDurationRatio(this.networkRecv.getElapsed("Poor")),NetworkRecvBadRatio:this.getDurationRatio(this.networkRecv.getElapsed("Bad")),NetworkSendGoodRatio:this.getDurationRatio(this.networkSend.getElapsed("Good")),NetworkSendPoorRatio:this.getDurationRatio(this.networkSend.getElapsed("Poor")),NetworkSendBadRatio:this.getDurationRatio(this.networkSend.getElapsed("Bad")),DeviceEvents:JSON.stringify(this.deviceTelemetryEvents),DeviceList:JSON.stringify(this.deviceList),DeviceListDebug:JSON.stringify(this.deviceDebugStrings),VideoEffects:JSON.stringify(this.videoEffectsTelemetryEvents.items),AudioEffects:JSON.stringify(this.audioEffectsTelemetryEvents.items),PermissionStates:JSON.stringify(this.permissionStates),ReconnectAttempts:this.reconnectStats.getReport(),NetworkEvents:JSON.stringify(Fb(K0(this.sessionDiagnostics?.getObjectRef().reconnect?.tmpRecords,this.configProvider.config.diagnostics.telemetryLimits.numNetworkEvents),"startTime",this.creationTime)),ReconnectInProgress:this.reconnectStats.isReconnecting(),TransportReconnectedCount:this.transportReconnectedCount,UFDs:JSON.stringify(this.ufds),remoteUFDs:JSON.stringify(this.remoteUfds),remoteUfdsCount:this.sessionDiagnostics?.getObjectRef().remoteUfdsCount,MediaQosEnabled:this.mediaQosEnabled,PortRangeConfigured:this.portRangeConfigured,RollbackNegotiation:JSON.stringify(this.rollbackNegotiation),hardwareConcurrency:yp.hardwareConcurrency,GPUName:yp.unmaskedGlRenderer,Connection_Downlink:_a(this.connectionDownlinkSeries.items,a=>a),Connection_EffectiveType:this.connectionEffectiveTypeSeries.items.filter(a=>a).join(","),Connection_Rtt:_a(this.connectionRttSeries.items,a=>a),Connection_SaveData:yJe?.connection?.saveData,MediaByPassEnabled:!!this.configProvider.mediaConfig.mediaBypassEnabled,CallConstraints:JSON.stringify(this.configProvider.getCallConstraintsTelemetry()),DominantSpeaker:JSON.stringify(aJe(this.sessionDiagnostics?.getObjectRef().dominantSpeaker,this.terminationTime))}}generateStatistics(n,a,s=!1){if(this.setMediaLegId(a.process()),n.type!=="WebRtcMediaStats")throw new Error(`Unknown stats type - ${n.type}`);if(s){const m=this.deviceTelemetryEvents.length;this.deviceTelemetryEvents.splice(0,m-1),this.deviceDebugStrings=pKe,this.audioEffectsTelemetryEvents.clear()}n.data.metrics=this.getReport();const c=this.sessionDiagnostics?.getObjectRef().statsErrors;if(c?.length)if(n.data.Extensions?.WebRTCStats?.statsErrors){const m=JSON.parse(n.data.Extensions.WebRTCStats.statsErrors);m.push(...c),n.data.Extensions.WebRTCStats.statsErrors=JSON.stringify(m)}else n.data.Extensions.WebRTCStats.statsErrors=JSON.stringify(c);const u={};return bG(n.data,(m,b,_)=>{let k=0;vCi.test(m)?(k=13,u[b]="IPv4"):yCi.test(m)&&(k=4,u[b]="IPv6"),_[b]={type:k,value:m,__VALUE__:!0}}),n.data.metrics.piiFields={type:0,value:JSON.stringify(u),__VALUE__:!0},n}registerTransportConnected(){this.transportDisconnected&&(this.transportDisconnected=!1,this.transportReconnectedCount++)}registerTransportDisconnected(){this.transportDisconnected=!0}registerTransportFailed(){this.transportDisconnected=!1}resetError(){this.setError({type:"none",detail:"none"})}offering(){return{started:()=>{this.currentNegotiationType="Offering",this.negotiationStarted()}}}answering(){return{started:()=>{this.currentNegotiationType="Answering",this.negotiationStarted()}}}negotiationStarted(){this.initialNegotiationType=this.initialNegotiationType||this.currentNegotiationType,++this.negotiationCount}current(){return{completed:n=>{this.initialNegotiationCompleted=!0,this.activeModalities=n,this.resetError()},rejected:()=>{++this.rejectedNegotiationCount}}}getDurationRatio(n){const a=this.getCurrentDuration();return n/(a!==0?a:1)}getCurrentDuration(){return this.durationTimer.elapsed}getHpTimeFromMillis(n){return 1e4*n}},bJe=class{constructor(n,a,s,c){this.onActiveSpeakersChanged=n,this.onDominantSpeakersChanged=a,this.logger=s,this.diagnostics=c}setStrategy(n){this.disposeStrategy(),this.dshStrategy=n,this.dshStrategy?.setOnDominantSpeakerChanged(this.onDominantSpeakerHistoryChanged.bind(this)),this.diagnostics?.setCurrentActiveStrategy("client")}onContributingSourcesChanged(n){this.onActiveSpeakersChanged(n),this.diagnostics?.contributingSourcesChanged(),this.dshStrategy?.setSources(n)}onDominantSpeakerHistoryChanged(n,a){this.onDominantSpeakersChanged(n),this.diagnostics?.recordHistoryEvent(n,a),a!=="client"&&this.dshStrategy&&(this.logger.safe.info("Disposing client DSH strategy and switching to MP provided DSH"),this.disposeStrategy())}dispose(){this.disposeStrategy(),this.onActiveSpeakersChanged=null,this.onDominantSpeakersChanged=null}disposeStrategy(){this.dshStrategy?.dispose(),this.dshStrategy=null}},TJe=class{constructor(n){this.listener=n,this.streams=[]}add(n){this.streams.some(a=>a.getId()===n.getId())||(this.streams.push(n),this.listener.streamAdded(n))}remove(n){let a;VR(this.streams,s=>s.getId()===n&&(a=s,!0))&&this.listener.streamRemoved(a)}getStreams(){return this.streams}clear(){this.streams.forEach(n=>n.dispose()),this.streams=[]}},X9=$i(Un()),CJe=class{constructor(n,a,s){this.logger=n,this.qualityManager=a,this.configProvider=s}getControlItem(){return this.controlItem}setControlItem(n){this.controlItem=n}dispose(){this.controlItem=null}setVideoControlMessage(n){this.controlItem=this.messageToControlItem(n),this.logger.safe.info(`BW limit requested to ${this.controlItem.bandwidth}`)}modifyDescriptor(n){if(!this.controlItem)return n;const a=X9.parse(n.sdp);if(!a.media[1])return this.logger.unsafe.warn("video modality is disabled, skipping sdp modification, ",n),n;const s=this.getCurrentResolutionBitrate();this.logger.safe.info(`Select the BW limit as min of requested ${this.controlItem.bandwidth} and Current Resolution Max BR ${s}`);const c=this.getSessionBitrate(a),u=Math.min(s,this.controlItem.bandwidth,c);if(a.media[1].bandwidth)a.media[1].bandwidth[0].limit=u;else{const m={limit:u,type:"AS"};a.media[1].bandwidth=[m]}return n.sdp=X9.write(a),n}messageToControlItem(n){const a=new sE(n.controlVideoStreaming.controlInfo[0].fmtParams),s="max-br",c=1.2;if(!a.contains(s))return null;const u=Math.round(+a.get(s)*c);return{sourceId:n.controlVideoStreaming.controlInfo[0].sourceId,streamMsid:n.controlVideoStreaming.controlInfo[0].streamMsid,bandwidth:u}}getCurrentResolutionBitrate(){const n=this.qualityManager.getCurrentResolution(),a=yl.Send.getResolutionByFs(n);return n&&a?Math.floor(yl.Send.getBitrateForResolution(a.width,a.height).maxBitrate/1e3):Number.MAX_VALUE}getSessionBitrate(n){let a=Number.MAX_SAFE_INTEGER;return this.configProvider.mediaConfig.maxBandwidthInKbps&&(a=this.configProvider.mediaConfig.maxBandwidthInKbps),n.bandwidth&&(a=Math.min(+n.bandwidth[0].limit,a)),a-(this.configProvider.config.audioBandwidthInKbps||0)}},bCi=class{constructor(n,a,s){this.pc=n,this.configProvider=a,this.logger=s.createChild("MediaRollbackModifier")}modifyDescriptor(n){const a=X9.parse(n.sdp);return X9.parse(this.pc.localDescription.sdp).media.forEach((s,c)=>{const u=a.media[c];($S(s)&&!s.bundleOnly||!u||$S(u))&&(this.logger.safe.info(`Adding disabled media ${s.type}, position ${c}`),a.media[c]=qne(s.type,void 0,s.protocol,void 0))}),new ITe(this.configProvider).modify(a),n.sdp=X9.write(a),n}},_Je=class{constructor(n,a){this.diagnostics=n,this.configProvider=a,this.recvExtenders=new Map,this.sendExtenders=new Map}processStats(n){if(!n)return;const a=new Set;if(n.send){this.diagnostics.handlePresentationAudioInputLevel();for(const s of n.send)try{a.add(s.outboundRTP.id);let c=this.sendExtenders.get(s.outboundRTP.id)??new AJe(this.diagnostics,this.configProvider);s.outboundRTP.bytesSent<c.lastBytes&&(c=new AJe(this.diagnostics,this.configProvider)),this.sendExtenders.set(s.outboundRTP.id,c),c.processSample(s)}catch(c){this.diagnostics.addStatsError("AudioStatsProcessor:send",nn(c))}}if(pN(this.sendExtenders,a),a.clear(),n.recv)for(const s of n.recv)try{a.add(s.inboundRTP.id);let c=this.recvExtenders.get(s.inboundRTP.id)??new EJe(this.configProvider);s.inboundRTP.bytesReceived<c.lastBytes&&(c=new EJe(this.configProvider)),this.recvExtenders.set(s.inboundRTP.id,c),c.processSample(s)}catch(c){this.diagnostics.addStatsError("AudioStatsProcessor:recv",nn(c))}pN(this.recvExtenders,a)}},EJe=class{constructor(n){this.configProvider=n,this.useLastSampleDeltaPerSecondConverter=this.configProvider.config.diagnostics.features.useLastSampleDeltaPerSecondConverter,this.duration=0,this.lossRateCalculator=new Bne(this.configProvider.config.disableNormalizationToCalculatePacketLossRate),this.bytesReceivedDiff=this.useLastSampleDeltaPerSecondConverter?new Hd:new Id,this.totalSamplesReceivedDiff=this.useLastSampleDeltaPerSecondConverter?new Hd:new Id,this.concealedSamplesDiff=this.useLastSampleDeltaPerSecondConverter?new Hd:new Id,this.silentConcealedSamplesDiff=this.useLastSampleDeltaPerSecondConverter?new Hd:new Id,this.packetsDelta=this.useLastSampleDeltaPerSecondConverter?new Hd:new Id,this.packetsLostDelta=this.useLastSampleDeltaPerSecondConverter?new Hd:new Id,this.concealedRatioAverager=new Al,this.stretchedRatioAverager=new Al,this.codecSwitchesTracker=new Xb,this.packetDurationTracker=new Xb,this.jitterAverager=new Al,this.jitterBufferDelayAverager=new Al,this.lastBytes=0}processSample(n){let a,s,c,u,m;const b=this.lossRateCalculator.calculate(n.inboundRTP.packetsReceived,n.inboundRTP.packetsLost)??0;this.lastBytes=n.inboundRTP.bytesReceived,this.bytesReceivedDiff.captureSample(n.inboundRTP.bytesReceived,n.inboundRTP.timestamp),this.totalSamplesReceivedDiff.captureSample(n.inboundRTP.totalSamplesReceived,n.inboundRTP.timestamp),this.concealedSamplesDiff.captureSample(n.inboundRTP.concealedSamples,n.inboundRTP.timestamp),this.silentConcealedSamplesDiff.captureSample(n.inboundRTP.silentConcealedSamples,n.inboundRTP.timestamp);const _=this.bytesReceivedDiff.delta&&8*this.bytesReceivedDiff.delta;this.packetsDelta.captureSample(n.inboundRTP.packetsReceived,n.inboundRTP.timestamp),this.packetsLostDelta.captureSample(n.inboundRTP.packetsLost,n.inboundRTP.timestamp);const k=n.inboundRTP.jitterBufferDelay&&n.inboundRTP.jitterBufferEmittedCount&&oa(n.inboundRTP.jitterBufferDelay/n.inboundRTP.jitterBufferEmittedCount*1e3,0);if(this.jitterAverager.captureSample(1e3*n.inboundRTP.jitter),this.jitterBufferDelayAverager.captureSample(n.inboundRTP.jitterBufferDelay),a=this.totalSamplesReceivedDiff.delta&&this.concealedSamplesDiff.delta&&this.silentConcealedSamplesDiff.delta&&oa((this.concealedSamplesDiff.delta-this.silentConcealedSamplesDiff.delta)/this.totalSamplesReceivedDiff.delta),n.customHealerStats){n.customHealerStats.numSamplesPerFrame&&(u=n.customHealerStats.decodedSamples/n.customHealerStats.numSamplesPerFrame,m=n.customHealerStats.cngSamples/n.customHealerStats.numSamplesPerFrame),a=n.customHealerStats.healedSamples/(n.customHealerStats.decodedSamples+n.customHealerStats.healedSamples),c=n.customHealerStats.concealSamples&&n.customHealerStats.concealSamples/(n.customHealerStats.decodedSamples+n.customHealerStats.healedSamples),s=n.customHealerStats.stretchSamples&&n.customHealerStats.stretchSamples/(n.customHealerStats.decodedSamples+n.customHealerStats.healedSamples);const N=n.customHealerStats.packetDurationInMs&&n.customHealerStats.packetDurationInMs>100?100:n.customHealerStats.packetDurationInMs;this.concealedRatioAverager.captureSample(c),this.stretchedRatioAverager.captureSample(s),this.codecSwitchesTracker.captureSample(`${n.customHealerStats.pullAdspPayloadType}`),this.packetDurationTracker.captureSample(`${N}`)}n.extensions={lossRate:b,packetsPerSecond:this.packetsDelta.delta,packetsLostPerSecond:this.packetsLostDelta.delta,duration:this.duration,healedRatio:a,jitterBufferMs:k,bitrate:_||0,customHealerStats:n.customHealerStats&&{concealedDataRatio:c,concealedDataRatioMax:this.concealedRatioAverager.maxSample,stretchedDataRatio:s,stretchedDataRatioMax:this.stretchedRatioAverager.maxSample,numberOfDecodedFrames:u,usageMetricsCodecId:this.codecSwitchesTracker.sortedDurations,percentageOfPtime:this.packetDurationTracker.durationRatios,pushPacketProcessingTimes:n.customHealerStats.pushProcessingTimes,pullPacketProcessingTimes:n.customHealerStats.pullProcessingTimes,pullProcessingTimePerStreamNumber:n.customHealerStats.pullProcessingTimePerStreamNumber,pullTimings:n.customHealerStats.pullTimings,cnpPushCount:n.customHealerStats.cnpPushCount,cnpPullCount:n.customHealerStats.cnpPullCount,numberOfCNFrames:m,redPacketsCount:n.customHealerStats.redPacketsCount,pullNumOfStreamsCounter:n.customHealerStats.pullNumOfStreamsCounter},jitterAvg:oa(this.jitterAverager.avg),jitterBufferDelayMs:oa(this.jitterBufferDelayAverager.avg)},this.duration++}},TCi=class{constructor(){this.duration=0,this.lossRateAverager=new Al,this.bitrateAverager=new Al,this.jitterBufferAverager=new Al,this.jitterAverager=new Al,this.jitterBufferDelayAverager=new Al,this.healedRatioAverager=new Al}processSample(n,a,s){const c=n[0],u={inboundRTP:c.inboundRTP};if(c.transport&&Object.defineProperty(u,"transport",{value:c.transport,configurable:!1,enumerable:!1}),c.codec&&(u.codec=c.codec),c.track&&(u.track=c.track),c.remoteOutboundRTP&&(u.remoteOutboundRTP=c.remoteOutboundRTP),c.extensions){this.lossRateAverager.captureSample(c.extensions.lossRate),this.bitrateAverager.captureSample(c.extensions.bitrate),this.healedRatioAverager.captureSample(c.extensions.healedRatio),this.jitterBufferAverager.captureSample(c.extensions.jitterBufferMs),this.jitterAverager.captureSample(1e3*c.inboundRTP.jitter),this.jitterBufferDelayAverager.captureSample(c.inboundRTP.jitterBufferDelay);const m=c.inboundRTP.packetsReceived+c.inboundRTP.packetsLost;u.aggregated={lossRateMax:this.lossRateAverager.maxSample,lossRateAvg:this.lossRateAverager.avg,networkAvgLossRate:m>0?c.inboundRTP.packetsLost/m:0,packetsLostAvg:this.duration>0?c.inboundRTP.packetsLost/this.duration:0,duration:this.duration,bitrateAvg:oa(this.bitrateAverager.avg,0),bitrateMax:oa(this.bitrateAverager.maxSample,0),jitterAvg:this.jitterAverager.avg,jitterMax:this.jitterAverager.maxSample,avgJitterBufferSize:this.jitterBufferAverager.avg,healedRatioAvg:this.healedRatioAverager.avg,healedRatioMax:this.healedRatioAverager.maxSample,customHealerStats:c.extensions.customHealerStats&&{concealedDataRatio:c.extensions.customHealerStats.concealedDataRatio,concealedDataRatioMax:c.extensions.customHealerStats.concealedDataRatioMax,stretchedDataRatio:c.extensions.customHealerStats.stretchedDataRatio,stretchedDataRatioMax:c.extensions.customHealerStats.stretchedDataRatioMax,numberOfDecodedFrames:c.extensions.customHealerStats.numberOfDecodedFrames,usageMetricsCodecId:c.extensions.customHealerStats.usageMetricsCodecId,percentageOfPtime:c.extensions.customHealerStats.percentageOfPtime,pushPacketProcessingTimes:c.extensions.customHealerStats.pushPacketProcessingTimes,pullPacketProcessingTimes:c.extensions.customHealerStats.pullPacketProcessingTimes,pullProcessingTimePerStreamNumber:c.extensions.customHealerStats.pullProcessingTimePerStreamNumber,pullTimings:c.extensions.customHealerStats.pullTimings,cnpPushCount:c.extensions.customHealerStats.cnpPushCount,cnpPullCount:c.extensions.customHealerStats.cnpPullCount,numberOfCNFrames:c.extensions.customHealerStats.numberOfCNFrames,redPacketsCount:c.extensions.customHealerStats.redPacketsCount,pullNumOfStreamsCounter:c.extensions.customHealerStats.pullNumOfStreamsCounter}},this.duration++}Mo(a,u,s)}},AJe=class{constructor(n,a){this.diagnostics=n,this.configProvider=a,this.useLastSampleDeltaPerSecondConverter=this.configProvider.config.diagnostics.features.useLastSampleDeltaPerSecondConverter,this.duration=0,this.lossRateCalculator=new Bne(this.configProvider.config.disableNormalizationToCalculatePacketLossRate),this.packetsDelta=this.useLastSampleDeltaPerSecondConverter?new Hd:new Id,this.packetsLostDelta=this.useLastSampleDeltaPerSecondConverter?new Hd:new Id,this.bytesSendDiff=this.useLastSampleDeltaPerSecondConverter?new Hd:new Id,this.rttAverager=new Al,this.lastBytes=0}processSample(n){const a=this.lossRateCalculator.calculate(n.remoteInboundRTP?.packetsReceived,n.remoteInboundRTP?.packetsLost)??0;this.packetsDelta.captureSample(n.outboundRTP.packetsSent,n.outboundRTP.timestamp),this.packetsLostDelta.captureSample(n.remoteInboundRTP?.packetsLost,n.remoteInboundRTP?.timestamp),this.lastBytes=n.outboundRTP.bytesSent,this.bytesSendDiff.captureSample(n.outboundRTP.bytesSent,n.outboundRTP.timestamp);const s=this.bytesSendDiff.delta;this.rttAverager.captureSample(1e3*(n.remoteInboundRTP?.roundTripTime??0)),n.extensions={lossRate:a,packetsPerSecond:this.packetsDelta.delta,packetsLostPerSecond:this.packetsLostDelta.delta,duration:this.duration,bitrate:s?8*s:0,rttAvg:oa(this.rttAverager.avg),callIsMuted:this.diagnostics.callIsMuted,rawInputVolume:this.diagnostics.audioLevel},this.duration++}},CCi=class{constructor(n){this.diagnostics=n,this.duration=0,this.lossRateAverager=new Al,this.bitrateAverager=new Al,this.rttAverager=new Al}processSample(n,a,s){const c=n[0],u={outboundRTP:c.outboundRTP};c.transport&&Object.defineProperty(u,"transport",{value:c.transport,configurable:!1,enumerable:!1}),c.codec&&(u.codec=c.codec),c.track&&(u.track=c.track),c.mediaSource&&(u.mediaSource=c.mediaSource),c.remoteInboundRTP&&(u.remoteInboundRTP=c.remoteInboundRTP),c.extensions&&(this.lossRateAverager.captureSample(c.extensions.lossRate),this.bitrateAverager.captureSample(c.extensions.bitrate),this.rttAverager.captureSample(c.remoteInboundRTP?.roundTripTime),u.aggregated={duration:this.duration,lossRateMax:this.lossRateAverager.maxSample,bitrateAvg:oa(this.bitrateAverager.avg,0),bitrateMax:oa(this.bitrateAverager.maxSample,0),rttAvg:oa(this.rttAverager.avg),rttMax:oa(this.rttAverager.maxSample),rawInputVolume:this.diagnostics.audioLevel,audioLevel:c.track?.audioLevel??c.mediaSource?.audioLevel},this.duration++),Mo(a,u,s)}},_Ci=dn,Jne=class{constructor(n,a){this.diagnostics=n,this.configProvider=a,this.recvExtenders=new Map,this.sendExtenders=new Map}processStats(n){if(!n)return;const a=new Set;if(n.send&&(0,_Ci.flatMap)(n.send,s=>[s,...s.altLayouts??[]]).forEach(s=>{try{a.add(s.outboundRTP.id);let c=this.sendExtenders.get(s.outboundRTP.id)??new kJe(this.diagnostics,this.configProvider);s.outboundRTP.bytesSent<c.lastBytes&&(c=new kJe(this.diagnostics,this.configProvider)),this.sendExtenders.set(s.outboundRTP.id,c),c.processSample(s)}catch(c){this.diagnostics.addStatsError("VideoStatsProcessor:send",nn(c))}}),pN(this.sendExtenders,a),a.clear(),n.recv)for(const s of n.recv)try{a.add(s.inboundRTP.id);let c=this.recvExtenders.get(s.inboundRTP.id)??new IJe(this.configProvider);s.inboundRTP.bytesReceived<c.lastBytes&&(c=new IJe(this.configProvider)),this.recvExtenders.set(s.inboundRTP.id,c),c.processSample(s)}catch(c){this.diagnostics.addStatsError("VideoStatsProcessor:recv",nn(c))}pN(this.recvExtenders,a)}},IJe=class{constructor(n){this.configProvider=n,this.useLastSampleDeltaPerSecondConverter=this.configProvider.config.diagnostics.features.useLastSampleDeltaPerSecondConverter,this.duration=0,this.lossRateCalculator=new Bne(this.configProvider.config.disableNormalizationToCalculatePacketLossRate),this.bytesReceivedDelta=this.useLastSampleDeltaPerSecondConverter?new Hd:new Id,this.framesReceivedDelta=this.useLastSampleDeltaPerSecondConverter?new Hd:new Id,this.framesDecodedDelta=this.useLastSampleDeltaPerSecondConverter?new Hd:new Id,this.trackFramesDelta=this.useLastSampleDeltaPerSecondConverter?new Hd:new Id,this.decodeTimeDelta=this.useLastSampleDeltaPerSecondConverter?new Hd(2):new Id,this.packetsDelta=this.useLastSampleDeltaPerSecondConverter?new Hd:new Id,this.packetsLostDelta=this.useLastSampleDeltaPerSecondConverter?new Hd:new Id,this.freezeHistogram=new K9(this.configProvider.config.diagnostics.collectionLimits.numOfHistogramSamples),this.harmonicDecodedFps=new xne(this.configProvider.config.webrtcStatPollInterval*this.configProvider.config.coeffOfValidTimeDelayBetweenFramesArrival,this.configProvider.config.invalidFPSAboveMax),this.prevTimeToFirstFrame=-1,this.hasPrevFramerate=!1,this.lastBytes=0,this.macroblockStatsTracker=new HWe}processSample(n){const a=this.lossRateCalculator.calculate(n.inboundRTP.packetsReceived,n.inboundRTP.packetsLost)??0;this.framesReceivedDelta.captureSample(n.inboundRTP.framesReceived,n.inboundRTP.timestamp),this.framesDecodedDelta.captureSample(n.inboundRTP.framesDecoded,n.inboundRTP.timestamp),this.trackFramesDelta.captureSample(n.inboundRTP.framesReceived??n.track?.framesReceived,n.inboundRTP.timestamp),this.packetsDelta.captureSample(n.inboundRTP.packetsReceived,n.inboundRTP.timestamp),this.packetsLostDelta.captureSample(n.inboundRTP.packetsLost,n.inboundRTP.timestamp);const s=this.framesReceivedDelta.delta,c=this.framesDecodedDelta.delta;this.harmonicDecodedFps.captureSample(c),this.decodeTimeDelta.captureSample(n.inboundRTP.totalDecodeTime,n.inboundRTP.timestamp);const u=this.decodeTimeDelta.delta&&c&&oa(this.decodeTimeDelta.delta/c*1e3,2),m=c>0&&s>0,b=n.renderer?.timeToFirstFrame??(m?0:-1);this.freezeHistogram.active=b!==-1&&this.prevTimeToFirstFrame!==-1&&!m,n.mediaEntity?.modality==="sharing"&&this.configProvider.config.diagnostics.features.useTwoSampleVBSSFreezeDetection&&(this.freezeHistogram.active=this.freezeHistogram.active&&!this.hasPrevFramerate),this.prevTimeToFirstFrame=b,this.hasPrevFramerate=m,this.lastBytes=n.inboundRTP.bytesReceived,this.bytesReceivedDelta.captureSample(n.inboundRTP.bytesReceived,n.inboundRTP.timestamp);const _=this.bytesReceivedDelta.delta,k=n.inboundRTP.jitterBufferEmittedCount&&oa((n.inboundRTP.jitterBufferDelay??0)/n.inboundRTP.jitterBufferEmittedCount*1e3),N=$We(n.inboundRTP.frameWidth,n.inboundRTP.frameHeight,s||0),W=$We(n.inboundRTP.frameWidth,n.inboundRTP.frameHeight,c||0);this.macroblockStatsTracker.captureSample(N,W),n.extensions={lossRate:a,packetsPerSecond:this.packetsDelta.delta,packetsLostPerSecond:this.packetsLostDelta.delta,duration:this.duration,frameRateReceived:s,frameRateDecoded:c,trackRecvFps:this.trackFramesDelta.delta,decodeTime:u||0,jitterBufferMs:k,bitrate:_?8*_:0,isFrozen:this.freezeHistogram.active,macroblockRateReceived:N,macroblockRateDecoded:W,macroblockRateStats:this.macroblockStatsTracker.getReport(),longestFreeze:this.freezeHistogram.longestDuration,totalFreezeDuration:this.freezeHistogram.totalDuration,powerEfficient:n.inboundRTP.powerEfficientDecoder!==void 0?n.inboundRTP.powerEfficientDecoder:zWe(n.inboundRTP.decoderImplementation),totalFreezeFraction:this.duration?this.freezeHistogram.totalDuration/this.duration:0,fpsHarmonicAverage:oa(this.harmonicDecodedFps.harmonicMean)},this.duration++}},wJe=class{constructor(n){this.configProvider=n,this.duration=0,this.lossRateAverager=new Al,this.bitrateAverager=new Al,this.jitterAverager=new Al,this.frameRateAverager=new Al,this.freezeHistogram=new K9(this.configProvider.config.diagnostics.collectionLimits.numOfHistogramSamples),this.harmonicDecodedFps=new xne(this.configProvider.config.webrtcStatPollInterval*this.configProvider.config.coeffOfValidTimeDelayBetweenFramesArrival,this.configProvider.config.invalidFPSAboveMax),this.resolutionDurations=new Xb,this.codecCalculator=new Myi}processSample(n,a,s){const c=n.sort((m,b)=>b.inboundRTP.frameHeight*b.inboundRTP.frameWidth-m.inboundRTP.frameHeight*m.inboundRTP.frameWidth)[0],u={inboundRTP:c.inboundRTP};c.transport&&Object.defineProperty(u,"transport",{value:c.transport,configurable:!1,enumerable:!1}),c.codec&&(u.codec=c.codec,this.configProvider.config.isAv1Allowed&&c.mediaEntity?.modality==="sharing"&&this.codecCalculator.captureSample(c.codec.mimeType,c.renderer?.msi)),c.track&&(u.track=c.track),c.remoteOutboundRTP&&(u.remoteOutboundRTP=c.remoteOutboundRTP),c.extensions&&(u.extensions=c.extensions),c.extensions&&(this.harmonicDecodedFps.captureSample(c.extensions.frameRateDecoded),this.lossRateAverager.captureSample(c.extensions.lossRate),this.bitrateAverager.captureSample(c.extensions.bitrate),this.jitterAverager.captureSample(1e3*(c.inboundRTP.jitter??0)),this.frameRateAverager.captureSample(c.extensions.frameRateReceived??c.extensions.frameRateDecoded),this.freezeHistogram.active=c.extensions.isFrozen,c.inboundRTP.frameWidth&&c.inboundRTP.frameHeight&&this.resolutionDurations.captureSample(`${c.inboundRTP.frameWidth}x${c.inboundRTP.frameHeight}`),u.aggregated={lossRateMax:this.lossRateAverager.maxSample,duration:this.duration,avgFrameRate:oa(this.frameRateAverager.avg),fpsHarmonicAverage:oa(this.harmonicDecodedFps.harmonicMean),avgJitterBufferSize:oa(this.jitterAverager.avg),bitrateAvg:oa(this.bitrateAverager.avg,0),bitrateMax:oa(this.bitrateAverager.maxSample,0),bitrateMinNonZero:oa(this.bitrateAverager.minNonZeroSample,0),ongoingFreezeDuration:this.freezeHistogram.ongoingDuration,numFreezes:this.freezeHistogram.numEvents,avgFreezeDuration:oa(this.freezeHistogram.avgDuration),longestFreeze:this.freezeHistogram.longestDuration,totalFreezeDuration:this.freezeHistogram.totalDuration,freezeCountHistogram:this.freezeHistogram.counts,freezeTimestampsHistogram:this.freezeHistogram.timestamps,numResolutionSwitches:this.resolutionDurations.changeCount,resolutionDurations:this.resolutionDurations.durations,resolutionDurationRatios:this.resolutionDurations.durationRatios,macroblockRateStats:c.extensions.macroblockRateStats,codecReport:this.codecCalculator?.report},this.duration++),ld(a,u,s)}},kJe=class{constructor(n,a){this.diagnostics=n,this.configProvider=a,this.useLastSampleDeltaPerSecondConverter=this.configProvider.config.diagnostics.features.useLastSampleDeltaPerSecondConverter,this.duration=0,this.lossRateCalculator=new Bne(this.configProvider.config.disableNormalizationToCalculatePacketLossRate),this.lossRateAverager=new Al,this.freezeHistogram=new K9(this.configProvider.config.diagnostics.collectionLimits.numOfHistogramSamples),this.hasPrevFramerate=!1,this.captureFreezeIntervalsCount=0,this.bytesSendDelta=this.useLastSampleDeltaPerSecondConverter?new Hd:new Id,this.encodedFramesDelta=this.useLastSampleDeltaPerSecondConverter?new Hd:new Id,this.sentFramesDelta=this.useLastSampleDeltaPerSecondConverter?new Hd:new Id,this.packetsDelta=this.useLastSampleDeltaPerSecondConverter?new Hd:new Id,this.packetsLostDelta=this.useLastSampleDeltaPerSecondConverter?new Hd:new Id,this.harmonicEncodedFps=new xne(this.configProvider.config.webrtcStatPollInterval*this.configProvider.config.coeffOfValidTimeDelayBetweenFramesArrival,this.configProvider.config.invalidFPSAboveMax),this.encodeTimeDelta=this.useLastSampleDeltaPerSecondConverter?new Hd(2):new Id,this.qpDelta=this.useLastSampleDeltaPerSecondConverter?new Hd(3):new Id,this.fsOvershoot=new b$("fs"),this.fpsOvershoot=new b$("fps",1),this.brOvershoot=new b$("br"),this.plisDelta=new Id,this.pliRate=new Ryi(60),this.resolutionSwitcherTracker=new VWe(this.configProvider.config.diagnostics.collectionLimits.numResolutionSwitches),this.bitrateAverager=new Al,this.rttAverager=new Al,this.powerEfficientEncoderChangeTracker=new Pyi(this.configProvider.config.diagnostics.collectionLimits.numPowerEfficientEncoderEvents),this.lastBytes=0}processSample(n){const a=this.lossRateCalculator.calculate(n.remoteInboundRTP?.packetsReceived,n.remoteInboundRTP?.packetsLost);this.lossRateAverager.captureSample(a),this.plisDelta.captureSample(n.outboundRTP.pliCount),this.pliRate.captureSample(this.plisDelta.delta),this.packetsDelta.captureSample(n.outboundRTP.packetsSent,n.outboundRTP.timestamp),this.packetsLostDelta.captureSample(n.remoteInboundRTP?.packetsLost,n.remoteInboundRTP?.timestamp),this.lastBytes=n.outboundRTP.bytesSent,this.bytesSendDelta.captureSample(n.outboundRTP.bytesSent,n.outboundRTP.timestamp);const s=this.bytesSendDelta.delta,c=s?8*s:void 0;this.bitrateAverager.captureSample(c),this.rttAverager.captureSample(1e3*(n.remoteInboundRTP?.roundTripTime??0)),this.encodedFramesDelta.captureSample(n.outboundRTP.framesEncoded,n.outboundRTP.timestamp);const u=this.encodedFramesDelta.delta;this.sentFramesDelta.captureSample(n.outboundRTP.framesSent,n.outboundRTP.timestamp);const m=this.sentFramesDelta.delta||0;this.harmonicEncodedFps.captureSample(u);const b=n.mediaSource?.framesPerSecond;b===0&&this.lastCaptureFramerate!==void 0&&this.lastCaptureFramerate>0&&this.captureFreezeIntervalsCount++,this.lastCaptureFramerate=b;const _=u>0&&m>0;this.freezeHistogram.active=!_,n.mediaEntity?.modality==="sharing"&&this.configProvider.config.diagnostics.features.useTwoSampleVBSSFreezeDetection&&(this.freezeHistogram.active=this.freezeHistogram.active&&!this.hasPrevFramerate),this.hasPrevFramerate=_,this.encodeTimeDelta.captureSample(n.outboundRTP.totalEncodeTime,n.outboundRTP.timestamp);const k=this.encodeTimeDelta.delta&&u&&oa(this.encodeTimeDelta.delta/u*1e3,2);this.qpDelta.captureSample(n.outboundRTP.qpSum,n.outboundRTP.timestamp);const N=this.qpDelta.delta&&u&&oa(this.qpDelta.delta/u,2);n.outboundRTP.frameWidth&&n.outboundRTP.frameHeight&&this.resolutionSwitcherTracker.captureSample(n.outboundRTP.frameWidth,n.outboundRTP.frameHeight);const W=this.diagnostics.deviceManager?.latestCameraOpenResolution,ee=n.appliedCapabilities??n.requestedCapabilities;ee&&(n.outboundRTP.frameHeight!==void 0&&n.outboundRTP.frameWidth!==void 0&&this.fsOvershoot.captureSample(n.outboundRTP.frameHeight/16*(n.outboundRTP.frameWidth/16),ee.maxFs),this.fpsOvershoot.captureSample(m,ee.maxFps),ee.maxBr&&this.brOvershoot.captureSample(c,ee.maxBr));const oe=[...this.fsOvershoot.events,...this.brOvershoot.events,...this.fpsOvershoot.events];if(oe.sort((de,se)=>de.timestamp-se.timestamp),n.outboundRTP.frameHeight&&(n.outboundRTP.powerEfficientEncoder||n.outboundRTP.encoderImplementation)){const de=n.outboundRTP.powerEfficientEncoder!==void 0?n.outboundRTP.powerEfficientEncoder:zWe(n.outboundRTP.encoderImplementation);this.powerEfficientEncoderChangeTracker.captureSample(de,n.outboundRTP.frameHeight)}n.extensions={cameraOpenResolution:W,lossRate:a,packetsPerSecond:this.packetsDelta.delta,packetsLostPerSecond:this.packetsLostDelta.delta,duration:this.duration,pliRate:this.pliRate.getRate(),frameRateEncoded:this.encodedFramesDelta.delta,frameRateSent:m,bitrate:c||0,encodeTime:k||0,qp:N||0,isFrozen:this.freezeHistogram.active,longestFreeze:this.freezeHistogram.longestDuration,totalFreezeDuration:this.freezeHistogram.totalDuration,ongoingFreezeDuration:this.freezeHistogram.ongoingDuration,freezeCountHistogram:this.freezeHistogram.counts,captureFreezeIntervalsCount:this.captureFreezeIntervalsCount,isFsOvershooting:this.fsOvershoot.isOvershooting,isFpsOvershooting:this.fpsOvershoot.isOvershooting,isBrOvershooting:this.brOvershoot.isOvershooting,totalFsOvershootDuration:this.fsOvershoot.totalDuration,totalFpsOvershootDuration:this.fpsOvershoot.totalDuration,totalBrOvershootDuration:this.brOvershoot.totalDuration,overshootEvents:oe,powerEfficient:this.powerEfficientEncoderChangeTracker.curPowerEfficientEncoderState,powerEfficientEncoderEvents:this.powerEfficientEncoderChangeTracker.events,powerEfficientEncoderEventOnCount:this.powerEfficientEncoderChangeTracker.eventOnCount,powerEfficientEncoderEventOffCount:this.powerEfficientEncoderChangeTracker.eventOffCount,bitrateAvg:oa(this.bitrateAverager.avg,0),rttAvg:oa(this.rttAverager.avg)},this.duration++}},RJe=class{constructor(n){this.configProvider=n,this.duration=0,this.lossRateAverager=new Al,this.bitrateAverager=new Al,this.sendBWEAverager=new Al,this.rttAverager=new Al,this.framerateAverager=new Al,this.captureFpsAverager=new Al,this.captureFreezeIntervalsCount=0,this.lastCaptureFps=void 0,this.resolutionDurations=new Xb,this.fsOvershoot=new b$("fs"),this.fpsOvershoot=new b$("fps",1),this.brOvershoot=new b$("br"),this.harmonicEncodedFps=new xne(this.configProvider.config.webrtcStatPollInterval*this.configProvider.config.coeffOfValidTimeDelayBetweenFramesArrival,this.configProvider.config.invalidFPSAboveMax)}processSample(n,a,s){n.length>1&&n.sort((m,b)=>{const _=m.appliedCapabilities??m.requestedCapabilities,k=b.appliedCapabilities??b.requestedCapabilities;return _?.maxMbps&&k?.maxMbps?k.maxMbps-_.maxMbps:0});const c=n[0],u={outboundRTP:c.outboundRTP};if(c.transport&&Object.defineProperty(u,"transport",{value:c.transport,configurable:!1,enumerable:!1}),c.codec&&(u.codec=c.codec),c.track&&(u.track=c.track),c.mediaSource&&(u.mediaSource=c.mediaSource),c.remoteInboundRTP&&(u.remoteInboundRTP=c.remoteInboundRTP),c.extensions&&(u.extensions=c.extensions),c.extensions){this.lossRateAverager.captureSample(c.extensions.lossRate),this.bitrateAverager.captureSample(c.extensions.bitrate),this.sendBWEAverager.captureSample(c.transport?.selectedCandidatePair?.availableOutgoingBitrate),this.rttAverager.captureSample(c.remoteInboundRTP?.roundTripTime),this.framerateAverager.captureSample(c.extensions.frameRateSent);const m=c.mediaSource?.framesPerSecond;this.captureFpsAverager.captureSample(m),m===0&&this.lastCaptureFps!==void 0&&this.lastCaptureFps>0&&this.captureFreezeIntervalsCount++,this.lastCaptureFps=m,c.outboundRTP.frameWidth&&c.outboundRTP.frameHeight&&this.resolutionDurations.captureSample(`${c.outboundRTP.frameWidth}x${c.outboundRTP.frameHeight}`);const b=c.appliedCapabilities??c.requestedCapabilities;b&&(c.outboundRTP.frameHeight!==void 0&&c.outboundRTP.frameWidth!==void 0&&this.fsOvershoot.captureSample(c.outboundRTP.frameHeight/16*(c.outboundRTP.frameWidth/16),b.maxFs),this.fpsOvershoot.captureSample(c.extensions.frameRateSent,b.maxFps),b.maxBr&&this.brOvershoot.captureSample(c.extensions?.bitrate,b.maxBr)),this.harmonicEncodedFps.captureSample(c.extensions.frameRateEncoded);const _=[...this.fsOvershoot.events,...this.fpsOvershoot.events,...this.brOvershoot.events];_.sort((k,N)=>k.timestamp-N.timestamp),u.aggregated={lossRateMax:this.lossRateAverager.maxSample,duration:this.duration,frameRateAvg:oa(this.framerateAverager.avg),captureFramerateAvg:oa(this.captureFpsAverager.avg),fpsHarmonicAverage:oa(this.harmonicEncodedFps.harmonicMean),qpAvg:oa(c.outboundRTP.qpSum/c.outboundRTP.framesSent),rttAvg:oa(this.rttAverager.avg),bitrateAvg:oa(this.bitrateAverager.avg,0),bitrateMax:oa(this.bitrateAverager.maxSample,0),bitrateMinNonZero:oa(this.bitrateAverager.minNonZeroSample,0),bweAvg:oa(this.sendBWEAverager.avg,0),captureFreezeIntervalsCount:this.captureFreezeIntervalsCount,numResolutionSwitches:this.resolutionDurations.changeCount,resolutionDurations:this.resolutionDurations.durations,resolutionDurationRatios:this.resolutionDurations.durationRatios,isFsOvershooting:this.fsOvershoot.isOvershooting,isFpsOvershooting:this.fpsOvershoot.isOvershooting,isBrOvershooting:this.brOvershoot.isOvershooting,totalFsOvershootDuration:this.fsOvershoot.totalDuration,totalFpsOvershootDuration:this.fpsOvershoot.totalDuration,totalBrOvershootDuration:this.brOvershoot.totalDuration,overshootEvents:_},this.duration++}ld(a,u,s)}},RTe=class{constructor(n){this.configProvider=n,this.samplesCountPerSubscription=0,this.data=new Du(this.configProvider.config.diagnostics.collectionLimits.numVideoSubscriptionStats)}prepareCollectingStatsOnSubscribed(n){this.samplesCountPerSubscription=0,this.data.add({timestamp:Date.now(),framesDecoded:[],bytesReceived:[],height:[],msi:n})}captureStatsOnSubscribed(n,a,s){if(this.samplesCountPerSubscription>=this.configProvider.config.diagnostics.collectionLimits.numVideoStatsAfterSubscription)return;const c=_f(this.data.items);c&&(n&&c.framesDecoded.push(n),a&&c.bytesReceived.push(a),s&&c.height.push(s)),this.samplesCountPerSubscription++}get videoStatsOnSubscribed(){return this.data.items}},MJe=class{constructor(n,a){this.diagnostics=n,this.configProvider=a,this.extenders=new Map}processStats(n){const a=new Set;for(const s in n)try{a.add(s);const c=n[s],u=this.extenders.get(c.id)??new ECi(this.configProvider,this.diagnostics);this.extenders.set(c.id,u),u.processSample(c)}catch(c){this.diagnostics.addStatsError("TransportStatsProcessor",nn(c))}pN(this.extenders,a)}},ECi=class{constructor(n,a){this.configProvider=n,this.diagnostics=a,this.useLastSampleDeltaPerSecondConverter=this.configProvider.config.diagnostics.features.useLastSampleDeltaPerSecondConverter,this.bwJumpsHistogramCollector=new K9(this.configProvider.config.diagnostics.collectionLimits.numOfHistogramSamples),this.sendBWEAverager=new Al,this.recvBWEAverager=new Al,this.sendBW=this.useLastSampleDeltaPerSecondConverter?new Hd:new Id,this.recvBW=this.useLastSampleDeltaPerSecondConverter?new Hd:new Id,this.sendBWAverager=new Al,this.recvBWAverager=new Al}processSample(n){this.sendBWEAverager.captureSample(n.selectedCandidatePair?.availableOutgoingBitrate),this.recvBWEAverager.captureSample(n.selectedCandidatePair?.availableIncomingBitrate),this.sendBW.captureSample(n.selectedCandidatePair?.bytesSent,n.selectedCandidatePair?.timestamp),this.recvBW.captureSample(n.selectedCandidatePair?.bytesReceived,n.selectedCandidatePair?.timestamp);const a=this.sendBW.delta,s=this.recvBW.delta,c=a?8*a:void 0,u=s?8*s:void 0;this.sendBWAverager.captureSample(c),this.recvBWAverager.captureSample(u);const m=n.selectedCandidatePair?.availableOutgoingBitrate;m&&(this.bwJumpsHistogramCollector.active=this.bwJumpsHistogramCollector.active&&m<this.configProvider.config.webrtcBWJumpUpperLimit||m<this.configProvider.config.webrtcBWJumpLowerLimit),n.extensions={sendBWEAvg:oa(this.sendBWEAverager.avg,0),sendBWEMax:oa(this.sendBWEAverager.maxSample,0),recvBWEAvg:oa(this.recvBWEAverager.avg,0),recvBWEMax:oa(this.recvBWEAverager.maxSample,0),sendBitrate:c,recvBitrate:u,sendBWAvg:oa(this.sendBWAverager.avg,0),sendBWMax:oa(this.sendBWAverager.maxSample,0),recvBWAvg:oa(this.recvBWAverager.avg,0),recvBWMax:oa(this.recvBWAverager.maxSample,0),bwJumpsHistogram:this.bwJumpsHistogramCollector.counts,reflexiveLocalIP:this.diagnostics.reflexiveLocalIP}}},ACi=class{constructor(n,a){this.diagnostics=n,this.configProvider=a,this.extenders=new Map}processStats(n){if(!n)return;const a=new Set;for(const s of n)try{a.add(s.id);const c=this.extenders.get(s.id)??new ICi(this.configProvider);this.extenders.set(s.id,c),c.processSample(s)}catch(c){this.diagnostics.addStatsError("DataChannelStatsProcessor",nn(c))}pN(this.extenders,a)}},ICi=class{constructor(n){this.configProvider=n,this.useLastSampleDeltaPerSecondConverter=this.configProvider.config.diagnostics.features.useLastSampleDeltaPerSecondConverter,this.sendBytesDeltaCalculator=this.useLastSampleDeltaPerSecondConverter?new Hd:new Id,this.recvBytesDeltaCalculator=this.useLastSampleDeltaPerSecondConverter?new Hd:new Id,this.sendMessagesDeltaCalculator=this.useLastSampleDeltaPerSecondConverter?new Hd:new Id,this.recvMessagesDeltaCalculator=this.useLastSampleDeltaPerSecondConverter?new Hd:new Id}processSample(n){this.sendBytesDeltaCalculator.captureSample(n.bytesSent,n.timestamp),this.recvBytesDeltaCalculator.captureSample(n.bytesReceived,n.timestamp);const a=this.sendBytesDeltaCalculator.delta,s=this.recvBytesDeltaCalculator.delta,c=a?8*a:void 0,u=s?8*s:void 0;this.sendMessagesDeltaCalculator.captureSample(n.messagesSent,n.timestamp),this.recvMessagesDeltaCalculator.captureSample(n.messagesReceived,n.timestamp);const m=this.sendMessagesDeltaCalculator.delta,b=this.recvMessagesDeltaCalculator.delta;n.extensions={sendBitrate:c,recvBitrate:u,sendMessageRate:m,recvMessageRate:b}}},MTe=class{constructor(n,a,s,c){this.slidingWindowSize=n,this.maxDeviation=a,this.minBandwidth=s,this.directionalityCheck=c,this.slidingWindow=new Du(this.slidingWindowSize),this.currentModality=null,this.previousModality=null,this.inProcess=!1}processBandwidth(n,a,s){this.currentModality?this.handleStopEvent(a,s):this.handleStartEvent(a,s),this.inProcess&&(this.stabilizationTime++,this.slidingWindow.add(n),this.inProcess=!this.slidingWindow.isFull||!this.isBandwidthStable())}getReport(n=!1){if(this.stabilizationTime!==void 0)return{time:this.inProcess?this.stabilizationTime:Math.max(this.stabilizationTime-this.slidingWindowSize,0),bandwidth:n?oa(this.averageBandwidth,2):this.averageBandwidth,finished:!this.inProcess,modality:this.previousModality}}handleStartEvent(n,a){this.currentModality=this.GetModalityString(n),a&&this.currentModality&&!this.previousModality&&(this.previousModality=this.currentModality,this.stabilizationTime=0,this.slidingWindow.clear(),this.inProcess=!0)}handleStopEvent(n,a){a&&(this.directionalityCheck(n.audio)||this.directionalityCheck(n.video)||this.directionalityCheck(n.sharing))||(this.currentModality=null,this.inProcess=!1)}GetModalityString(n){return[this.directionalityCheck(n.audio)?ke.MODALITY.audio:null,this.directionalityCheck(n.video)?ke.MODALITY.video:null,this.directionalityCheck(n.sharing)?ke.MODALITY.sharing:null].filter(Boolean).join(", ")}isBandwidthStable(){if(this.averageBandwidth=uN(this.slidingWindow.items),this.averageBandwidth<this.minBandwidth)return!1;{const n=this.averageBandwidth*this.maxDeviation,a=this.averageBandwidth-n,s=this.averageBandwidth+n;return this.slidingWindow.items.every(c=>_G(c,a,s))}}},wCi=class{constructor(n,a){this.diagnostics=n,this.configProvider=a,this.uplinkStabilizationTelemetry=new MTe(this.configProvider.config.uplinkBWStabilizationSlidingWindowSize,this.configProvider.config.uplinkBWStabilizationMaxDeviation,this.configProvider.config.uplinkBWStabilizationMinBandwidth,Ur),this.downlinkStabilizationTelemetry=new MTe(this.configProvider.config.downlinkBWStabilizationSlidingWindowSize,this.configProvider.config.downlinkBWStabilizationMaxDeviation,this.configProvider.config.downlinkBWStabilizationMinBandwidth,Rc),this.bandwidthCalculator=new UWe,this.bandwidthAvg=new Al}processStats(n){const a=this.diagnostics.getObjectRef(),s=a?.negotiation.activeModalities;if(!s||!n.transports)return;const c=n.transports[Object.keys(n.transports)[0]],u=a?.reportedReceiveBandwidth?.[a.reportedReceiveBandwidth.length-1],m=c?.selectedCandidatePair?.availableOutgoingBitrate,b=n.audio?.send?.length>0||n.video?.send?.length>0||n.sharing?.send?.length>0,_=n.audio?.recv?.length>0||n.video?.recv?.length>0||n.sharing?.recv?.length>0;this.bweType!==a?.negotiation.bweType&&(this.bandwidthCalculator=new UWe,this.bandwidthAvg=new Al,this.bweType=a?.negotiation.bweType);const k=a?.negotiation.bweType==="REMB"?"availableIncomingBitrate":"availableOutgoingBitrate",N=c?.selectedCandidatePair?.[k];this.bandwidthCalculator.captureSample(N),this.bandwidthAvg.captureSample(N);try{this.uplinkStabilizationTelemetry.processBandwidth(m,s,b),this.downlinkStabilizationTelemetry.processBandwidth(u,s,_)}catch(W){this.diagnostics.addStatsError("BandwidthStatsProcessor",nn(W))}}getStabilizedReport(n=!1){return this.uplinkStabilizationTelemetry.getReport(n)}getDownlinkStabilizedReport(n=!1){return this.downlinkStabilizationTelemetry.getReport(n)}calculateBwPercentiles(){if(!this.bandwidthCalculator.getFirst())return;const n=this.configProvider.config.bwPercentiles,a={};return n.forEach(s=>{Object.defineProperty(a,s,{value:this.bandwidthCalculator.calculatePercentile(s/100),enumerable:!0})}),a}getBandwidthReport(){return{startOfTheCall:this.bandwidthCalculator.getFirst(),endOfTheCall:this.bandwidthCalculator.getLast(),std:this.bandwidthCalculator.calculateStd(),bwPercentiles:this.calculateBwPercentiles(),avgBwe:oa(this.bandwidthAvg.avg,2)}}},kCi=class{constructor(n,a){this.diagnostics=n,this.configProvider=a,this.videoSimulcastStreamsData={},this.videoLayoutProcessor=new PJe(this.diagnostics,ke.MODALITY.video),this.sharingSimulcastStreamsData={},this.sharingLayoutProcessor=new PJe(this.diagnostics,ke.MODALITY.sharing)}processStats(n){if(n.video?.send?.length){const a=n.video.send[0],s=[a,...a.altLayouts??[]];this.processSimulcastStream(s,this.videoSimulcastStreamsData),this.videoLayoutProcessor.processLayout(s)}if(n.sharing?.send?.length){const a=n.sharing.send[0],s=[a,...a.altLayouts??[]];this.processSimulcastStream(s,this.sharingSimulcastStreamsData),this.sharingLayoutProcessor.processLayout(s)}this.diagnostics.simulcastReport=this.getSimulcastDiagnostics()}processSimulcastStream(n,a){const{numAggregatedSamples:s}=this.configProvider.config.diagnostics.telemetryLimits;for(const c of n){const u=c.outboundRTP.rid;if(!u)continue;a[u]??(a[u]={sentLayerProcessor:new PTe,appliedLayerProcessor:new PTe,requestedLayerProcessor:new PTe,encoderProcessor:new RCi,debugResolutionTracker:new Xb,outboundStats:[],report:{ssrc:c.outboundRTP.ssrc,time:{requested:0,applied:0,sent:0},duration:{requested:0,applied:0,sent:0},restarts:{requested:0,applied:0,sent:0},resolution:{requested:{},applied:{},sent:{}},framerate:{requested:{},applied:{},sent:{}},bitrate:{requested:{},applied:{},sent:{}},encoder:{},stats:{},overshootEvents:[]}});const m=a[u],{sentLayer:b,requestedLayer:_,appliedLayer:k}=this.getLayers(c);m.sentLayerProcessor.processLayer(b),m.appliedLayerProcessor.processLayer(k),m.requestedLayerProcessor.processLayer(_),m.encoderProcessor.processVideo(c),k&&b&&m.debugResolutionTracker.captureSample(`${k.width}x${k.height}:${b.width}x${b.height}`),ld(m.outboundStats,c.outboundRTP,s),m.report.time.sent=m.sentLayerProcessor.getTime(),m.report.time.applied=m.appliedLayerProcessor.getTime(),m.report.time.requested=m.requestedLayerProcessor.getTime(),m.report.duration.sent=m.sentLayerProcessor.getDuration(),m.report.duration.applied=m.appliedLayerProcessor.getDuration(),m.report.duration.requested=m.requestedLayerProcessor.getDuration(),m.report.restarts.sent=m.sentLayerProcessor.getRestarts(),m.report.restarts.applied=m.appliedLayerProcessor.getRestarts(),m.report.restarts.requested=m.requestedLayerProcessor.getRestarts(),m.report.resolution.sent=m.sentLayerProcessor.getResolutionDurations(),m.report.resolution.applied=m.appliedLayerProcessor.getResolutionDurations(),m.report.resolution.requested=m.requestedLayerProcessor.getResolutionDurations(),m.report.resolution.debug=m.debugResolutionTracker.durations,m.report.framerate.sent=m.sentLayerProcessor.getFpsDurations(),m.report.framerate.applied=m.appliedLayerProcessor.getFpsDurations(),m.report.framerate.requested=m.requestedLayerProcessor.getFpsDurations(),m.report.bitrate.sent=m.sentLayerProcessor.getBitrateDurations(),m.report.bitrate.applied=m.appliedLayerProcessor.getBitrateDurations(),m.report.bitrate.requested=m.requestedLayerProcessor.getBitrateDurations(),m.report.encoder=m.encoderProcessor.getEncoderReport(),m.report.stats.fir=_a(m.outboundStats,N=>N.firCount),m.report.stats.nack=_a(m.outboundStats,N=>N.nackCount),m.report.stats.pli=_a(m.outboundStats,N=>N.pliCount),m.report.stats.packetsSent=_a(m.outboundStats,N=>N.packetsSent),m.report.overshootEvents=c.extensions?.overshootEvents,m.report.totalBrOvershootDuration=c.extensions?.totalBrOvershootDuration,m.report.totalFpsOvershootDuration=c.extensions?.totalFpsOvershootDuration,m.report.totalFsOvershootDuration=c.extensions?.totalFsOvershootDuration,m.report.totalFreezeDuration=c.extensions?.totalFreezeDuration,m.report.ongoingFreezeDuration=c.extensions?.ongoingFreezeDuration,m.report.freezeHistogram=c.extensions?.freezeCountHistogram}}getSimulcastDiagnostics(){if(!Am(this.videoSimulcastStreamsData)||!Am(this.sharingSimulcastStreamsData))return{video:{streams:Object.fromEntries(Object.entries(this.videoSimulcastStreamsData).map(([n,{report:a}])=>[n,a])),layouts:this.videoLayoutProcessor.getLayoutReport()},sharing:{streams:Object.fromEntries(Object.entries(this.sharingSimulcastStreamsData).map(([n,{report:a}])=>[n,a])),layouts:this.sharingLayoutProcessor.getLayoutReport()}}}getLayers(n){const a=n.outboundRTP.rid,s=this.diagnostics.getObjectRef().qualityManager,c=b=>Object.values(b).find(_=>_.rid===a),u=n.mediaEntity?.modality==="sharing"?c(s.currentSharingSsrcAppliedCapabilities):c(s.currentVideoSsrcAppliedCapabilities),m=n.mediaEntity?.modality==="sharing"?c(s.currentSharingSsrcRequestedCapabilities):c(s.currentVideoSsrcRequestedCapabilities);return{sentLayer:n.outboundRTP.frameHeight&&{height:n.outboundRTP.frameHeight,width:n.outboundRTP.frameWidth,framerate:n.extensions?.frameRateSent,bitrate:n.extensions?.bitrate},appliedLayer:u&&DTe(u),requestedLayer:m&&DTe(m)}}},PJe=class{constructor(n,a){this.diagnostics=n,this.modality=a,this.sentResolutionTracker=new Xb,this.requestedResolutionTracker=new Xb,this.appliedResolutionTracker=new Xb,this.debugResolutionTracker=new Xb}processLayout(n){const a=N=>N.filter(W=>W.width&&W.height).sort((W,ee)=>W.height-ee.height).map(W=>`${W.width}x${W.height}`).join(":"),s=N=>Object.values(N).map(DTe),c=a(n.map(N=>({height:N.outboundRTP.frameHeight,width:N.outboundRTP.frameWidth,framerate:N.extensions?.frameRateSent,bitrate:N.extensions?.bitrate}))),u=this.diagnostics.getObjectRef().qualityManager,m=this.modality==="sharing"?u.currentSharingSsrcAppliedCapabilities:u.currentVideoSsrcAppliedCapabilities,b=this.modality==="sharing"?u.currentSharingSsrcRequestedCapabilities:u.currentVideoSsrcRequestedCapabilities,_=a(s(m)),k=a(s(b));c&&this.sentResolutionTracker.captureSample(c),k&&this.requestedResolutionTracker.captureSample(k),_&&this.appliedResolutionTracker.captureSample(_),_&&c&&this.debugResolutionTracker.captureSample(`${_}->${c}`)}getLayoutReport(){return{requested:this.requestedResolutionTracker.durations,sent:this.sentResolutionTracker.durations,applied:this.appliedResolutionTracker.durations,debug:this.debugResolutionTracker.durations}}},RCi=class{constructor(){this.report={}}processVideo(n){var a,s;const{encoderImplementation:c,frameWidth:u,frameHeight:m,rid:b}=n.outboundRTP,{encodeTime:_}=n.extensions;if(!c||!m)return;const k=MCi(c,b),N=`${u}x${m}`;(a=this.report)[k]??(a[k]={resolutionTracker:new Xb,encodingHistograms:{},report:{resolution:{},encodeTime:{},restarts:0}});const W=this.report[k];W.resolutionTracker.captureSample(N),(s=W.encodingHistograms)[N]??(s[N]=new Xb),W.encodingHistograms[N].captureSample(LCi(_)),W.report.resolution=W.resolutionTracker.durations,W.report.encodeTime[N]=W.encodingHistograms[N].durations,this.prevEncoder&&this.prevEncoder!==k&&W.report.restarts++,this.prevEncoder=k}getEncoderReport(){return Object.fromEntries(Object.entries(this.report).map(([n,{report:a}])=>[n,a]))}},PTe=class{constructor(){this.resolutionTracker=new Xb,this.fpsTracker=new Xb,this.bitrateTracker=new Xb,this.durationTracker=new tg,this.startedAt=0}processLayer(n){n?(this.startedAt||(this.startedAt=pp()),this.durationTracker.start(),this.resolutionTracker.captureSample(`${n.width}x${n.height}`),this.fpsTracker.captureSample(DCi(n.framerate)),this.bitrateTracker.captureSample(PCi(n.bitrate))):this.durationTracker.stop()}getResolutionDurations(){return this.resolutionTracker.durations}getFpsDurations(){return this.fpsTracker.durations}getBitrateDurations(){return this.bitrateTracker.durations}getRestarts(){return Math.max(0,this.durationTracker.count-1)}getTime(){return this.startedAt}getDuration(){return this.durationTracker.elapsed}};function DTe(n){const a={...yl.Send.getResolutionByFs(n.maxFs)};return n.maxFs===405&&(a.width=426,a.height=240),{width:a.width,height:a.height,framerate:n.maxFps,bitrate:n.maxBr}}function MCi(n,a){if(n.startsWith("SimulcastEncoderAdapter")){const s=n.indexOf("(")+1,c={},u=n.indexOf(")");n.substring(s,u).split(",").forEach((m,b)=>{c[`${b+1}`]=m.trim()}),n=c[a]??"Unknown"}switch(n){case"OpenH264":return"H264:SW";case"ExternalEncoder":case"MediaFoundationVideoEncodeAccelerator":case"VideoToolbox":case"WMFVideoEncoder":case"VTVideoEncoder":case"VaapiVideoEncodeAccelerator":return"H264:HW";default:return"H264:Other"}}function PCi(n){return LTe(n,[{limit:4e6,label:"4M+"},{limit:25e5,label:"2.5M-4M"},{limit:15e5,label:"1.5M-2.5M"},{limit:1e6,label:"1M-1.5M"},{limit:8e5,label:"800k-1M"},{limit:5e5,label:"500k-800k"},{limit:25e4,label:"250k-500k"},{limit:1e5,label:"100k-250k"},{limit:5e4,label:"50k-100k"},{limit:1e4,label:"10k-50k"},{limit:0,label:"0-10k"}])}function DCi(n){return LTe(n,[{limit:60,label:"60+"},{limit:30,label:"31-60"},{limit:15,label:"16-30"},{limit:7,label:"8-15"},{limit:3,label:"4-7"},{limit:1,label:"1-3"}])}function LCi(n){return LTe(n,[{limit:100,label:"100+ ms"},{limit:30,label:"30-100 ms"},{limit:10,label:"10-30 ms"},{limit:5,label:"5-10 ms"},{limit:2,label:"2-5 ms"},{limit:1,label:"1-2 ms"}])}function LTe(n,a){for(const{limit:s,label:c}of a)if(n>s)return c;return`${n}`}var OCi=class{constructor(n,a){this.configProvider=n,this.diagnostics=a,this.dataChannelStatsProcessor=new ACi(this.diagnostics,this.configProvider),this.transportStatsProcessor=new MJe(this.diagnostics,this.configProvider),this.audioStatsProcessor=new _Je(this.diagnostics,this.configProvider),this.videoStatsProcessor=new Jne(this.diagnostics,this.configProvider),this.sharingStatsProcessor=new Jne(this.diagnostics,this.configProvider),this.bandwidthStatsProcessor=new wCi(this.diagnostics,this.configProvider),this.simulcastStatsProcessor=new kCi(this.diagnostics,this.configProvider),this.macroblockStatsTracker=new HWe,this.statsAggregators={audio:{recv:new TCi,send:new CCi(this.diagnostics)},video:{recv:new wJe(this.configProvider),send:new RJe(this.configProvider)},sharing:{recv:new wJe(this.configProvider),send:new RJe(this.configProvider)}},this.aggregatedModalityStats={},this.recvVideoStreamsCounter=new wyi,this.multiviewData={},this.multiviewKeySet=new Set,this.statsOnSubscribedData={video:{},sharing:{}},this.statsOnSubscribed={video:[],sharing:[]},this.diagnostics.aggregatedStatsRef=this.aggregatedModalityStats,this.diagnostics.statsOnSubscribed=this.statsOnSubscribed,this.diagnostics.bandwidthDiagnostic=this.bandwidthStatsProcessor}processStats(n){const a=this.configProvider.config.diagnostics.enabledStatsProcessors;this.execute(()=>this.dataChannelStatsProcessor.processStats(n.data),"dataChannelStatsProcessor",a.dataChannel),this.execute(()=>this.transportStatsProcessor.processStats(n.transports),"transportStatsProcessor",a.transport),this.execute(()=>this.audioStatsProcessor.processStats(n.audio),"audioStatsProcessor",a.audio),this.execute(()=>this.videoStatsProcessor.processStats(n.video),"videoStatsProcessor",a.video),this.execute(()=>this.sharingStatsProcessor.processStats(n.sharing),"sharingStatsProcessor",a.sharing),this.execute(()=>{this.bandwidthStatsProcessor.processStats(n),this.diagnostics.bwStabilizationTime=this.bandwidthStatsProcessor.getStabilizedReport(!0),this.diagnostics.bwDownlinkStabilizationTime=this.bandwidthStatsProcessor.getDownlinkStabilizedReport(!0)},"bandwidthStatsProcessor",a.bandwidth),this.execute(()=>{this.recvVideoStreamsCounter.captureSample(n.video?.recv?.length),this.diagnostics.recvVideoStreamsCount={min:this.recvVideoStreamsCounter.min,max:this.recvVideoStreamsCounter.max,mode:this.recvVideoStreamsCounter.mode}},"recvVideoStreamsCounter",a.recvVideoStreamsCounter),this.execute(()=>this.processAggregated(n),"processAggregated",a.aggregated),this.execute(()=>this.processMultiview(n.video?.recv??[]),"processMultiview",a.multiview),this.execute(()=>this.simulcastStatsProcessor.processStats(n),"processSimulcastStats",a.simulcast),this.execute(()=>this.processNetworkInfoStats(),"processNetworkInfoStats",a.networkInfo),this.execute(()=>this.processMacroblockRateStats(n.video?.recv),"processMacroblockRateStats",a.macroblockRate)}signalNoConnection(){this.transportStatsProcessor=new MJe(this.diagnostics,this.configProvider),this.audioStatsProcessor=new _Je(this.diagnostics,this.configProvider),this.videoStatsProcessor=new Jne(this.diagnostics,this.configProvider),this.sharingStatsProcessor=new Jne(this.diagnostics,this.configProvider)}processNetworkInfoStats(){const n=navigator?.connection;n&&this.diagnostics.addNetworkInfo({downlink:n.downlink,rtt:n.rtt,effectiveType:n.effectiveType,saveData:n.saveData})}processMultiview(n){const a=new Set;for(const s of n){const c=s.inboundRTP.id;a.add(c);let u=this.multiviewData[c];u&&this.multiviewKeySet.has(c)?u.stats.duration++:(u={bitrateAverager:new Al,jitterAverager:new Al,frameRateAverager:new Al,freezeHistogram:new K9(this.configProvider.config.diagnostics.collectionLimits.numOfHistogramSamples),resolutionDurations:new Xb,isRenderingEvents:[],statsOnSubscribed:new RTe(this.configProvider),stats:{ssrc:s.inboundRTP.ssrc,startTime:Date.now(),duration:0,framesDecoded:[],bytesReceived:[],height:[],width:[]}},u.statsOnSubscribed.prepareCollectingStatsOnSubscribed(s.renderer?.msi),this.multiviewData[c]=u),u.statsOnSubscribed.captureStatsOnSubscribed(s.inboundRTP.framesDecoded,s.inboundRTP.bytesReceived,s.inboundRTP.frameHeight),u.bitrateAverager.captureSample(s.extensions?.bitrate),u.jitterAverager.captureSample(1e3*(s.inboundRTP.jitter??0)),u.frameRateAverager.captureSample(s.extensions.frameRateReceived),u.freezeHistogram.active=s.extensions?.isFrozen,s.inboundRTP.frameWidth&&s.inboundRTP.frameHeight&&u.resolutionDurations.captureSample(`${s.inboundRTP.frameWidth}x${s.inboundRTP.frameHeight}`);const m=s.renderer?.isRendering??!1;(!u.isRenderingEvents.length&&m||u.isRenderingEvents.length&&_f(u.isRenderingEvents).isRendering!==m)&&Mo(u.isRenderingEvents,{isRendering:m,ts:Date.now()},this.configProvider.config.diagnostics.collectionLimits.numIsRenderingEvents),u.stats.frameRateAvg=oa(u.frameRateAverager.avg),u.stats.bitrateAvg=oa(u.bitrateAverager.avg,0),u.stats.bitrateMax=oa(u.bitrateAverager.maxSample,0),u.stats.bitrateMinNonZero=oa(u.bitrateAverager.minNonZeroSample),u.stats.freezeHistogram=u.freezeHistogram.counts,u.stats.freezeTimestamps=u.freezeHistogram.timestamps,u.stats.avgFreezeDuration=oa(u.freezeHistogram.avgDuration),u.stats.totalFreezeDuration=u.freezeHistogram.totalDuration,u.stats.ongoingFreeze=u.freezeHistogram.active,u.stats.ongoingFreezeDuration=u.freezeHistogram.ongoingDuration,u.stats.numResolutionSwitches=u.resolutionDurations.changeCount,u.stats.rendererSize=`${s.renderer?.rendererSize?.width}x${s.renderer?.rendererSize?.height}`,u.stats.resolutionDurations=u.resolutionDurations.durations,u.stats.timeToFirstFrame=s.renderer?.timeToFirstFrame,u.stats.timeToFirstFrameSinceSubscriptionStart=s.renderer?.timeToFirstFrameSinceSubscriptionStart,u.stats.isRenderingEvents=u.isRenderingEvents,u.stats.statsOnSubscribed=u.statsOnSubscribed.videoStatsOnSubscribed,u.stats.msi=s.renderer?.msi,u.stats.rendererStates=s.renderer?.rendererStates,Mo(u.stats.framesDecoded,s.inboundRTP.framesDecoded,this.configProvider.config.diagnostics.telemetryLimits.numAggregatedSamples),Mo(u.stats.bytesReceived,s.inboundRTP.bytesReceived,this.configProvider.config.diagnostics.telemetryLimits.numAggregatedSamples),Mo(u.stats.height,s.inboundRTP.frameHeight,this.configProvider.config.diagnostics.telemetryLimits.numAggregatedSamples),Mo(u.stats.width,s.inboundRTP.frameWidth,this.configProvider.config.diagnostics.telemetryLimits.numAggregatedSamples);const b=s.extensions?.macroblockRateStats??{};for(const _ in b)u.stats[_]=oa(b[_],0)}this.diagnostics.multiViewStats=Object.values(this.multiviewData).map(s=>s.stats),this.multiviewKeySet=a}processAggregated(n){for(const a of["audio","video","sharing"])if(n[a])for(const s in n[a])this.processAggregatedModality(n,a,s)}processAggregatedModality(n,a,s){var c,u;const m=n[a]?.[s]?.length??0;m>0&&((c=this.aggregatedModalityStats)[a]??(c[a]={}),(u=this.aggregatedModalityStats[a])[s]??(u[s]=[]),m>1&&(a==="audio"||a==="sharing")&&this.diagnostics.addStatsError("webrtcStatistics:processAggregatedModality",`Multiple ${a} ${s} streams: ${m}`),this.statsAggregators[a][s].processSample(n[a][s],this.aggregatedModalityStats[a][s],this.configProvider.config.diagnostics.telemetryLimits.numAggregatedSamples),a!=="sharing"&&a!=="video"||s!=="recv"||this.processStatsOnSubscribed(n[a][s],a))}processStatsOnSubscribed(n,a){const s=new Set;for(const c of n)if(c.inboundRTP){const u=`${c.inboundRTP.id}x${c.renderer?.msi}`;let m=this.statsOnSubscribedData[a]?.[u];s.add(u),m||(m=new RTe(this.configProvider),m.prepareCollectingStatsOnSubscribed(c.renderer?.msi),this.statsOnSubscribedData[a][u]=m,this.statsOnSubscribed[a].push(...m.videoStatsOnSubscribed)),m.captureStatsOnSubscribed(c.inboundRTP.framesDecoded,c.inboundRTP.bytesReceived)}Eve(this.statsOnSubscribedData[a],s)}processMacroblockRateStats(n){if(!n?.length)return;let a=0,s=0;for(const c of n)a+=c.extensions?.macroblockRateReceived,s+=c.extensions?.macroblockRateDecoded;this.macroblockStatsTracker.captureSample(a,s),this.diagnostics.setTotalVideoRecvMblocksRates(this.macroblockStatsTracker.getReport())}execute(n,a,s){try{s&&n()}catch(c){this.diagnostics.addStatsError(`webrtcStatistics:${a}`,nn(c))}}},NCi=dn,xCi=class{constructor(n,a,s,c){this.logger=n,this.configProvider=a,this.diagnostics=s,this.mediaManager=c,this.webrtcStats=new OCi(this.configProvider,this.diagnostics),this.ssrcToRecvTrackMap=new Map,this.activeChannels={}}setAudioDecoderStatsProvider(n){this.audioDecoderStatsProvider=n}setAudioEncoderCodecName(n){this.audioEncoderCodecName=n}signalNoConnection(){this.webrtcStats.signalNoConnection()}processRawReport(n){this.diagnostics.latestRawReport=n;const a={loopTime:-1,fetchTime:-1,convertTime:-1,processingTime:-1,legacyProcessingTime:-1};try{let s=pp(),c=s;const u=this.convertStatsReport(n);return u.perfCounters=a,s=pp(),a.convertTime=s-c,c=s,this.webrtcStats.processStats(u),this.diagnostics.addStatsReport(u),s=pp(),a.processingTime=s-c,u}catch(s){const c=nn(s);return this.logger.safe.error(`Error processing raw stats: ${c}`),void this.diagnostics.addStatsError("StatisticsGatherer:processRawReport",c)}}setSsrcTrackPair(n,a){a===null?this.ssrcToRecvTrackMap.delete(n):this.ssrcToRecvTrackMap.set(n,a)}convertStatsReport(n){const a={transports:this.processTransportStats(n)};return this.appendPcStats(n,a),this.appendSendMediaStats(n,a),this.appendRecvMediaStats(n,a),n["data-channel"]&&(a.data=Object.values(n["data-channel"])),a}processTransportStats(n){if(n.transport){const a={};for(const s in n.transport){const c=n.transport[s];if(a[s]=Xp(c),c.selectedCandidatePairId){const u=Xp(n["candidate-pair"][c.selectedCandidatePairId]);u.localCandidate=n["local-candidate"][u.localCandidateId],u.remoteCandidate=n["remote-candidate"][u.remoteCandidateId],a[s].selectedCandidatePair=u}c.localCertificateId&&n.certificate&&(a[s].localCertificate=n.certificate[c.localCertificateId]),c.remoteCertificateId&&n.certificate&&(a[s].remoteCertificate=n.certificate[c.remoteCertificateId])}return a}if(n["candidate-pair"]){const a={};for(const s in n["candidate-pair"]){const c=Xp(n["candidate-pair"][s]);c.selected&&(c.localCandidate=n["local-candidate"][c.localCandidateId],c.remoteCandidate=n["remote-candidate"][c.remoteCandidateId],a.faketransport={id:"faketransport",timestamp:c.timestamp,type:"transport",selectedCandidatePair:c,selectedCandidatePairId:c.id})}return a}}appendPcStats(n,a){let s="";n["peer-connection"]&&(Object.keys(n["peer-connection"]).forEach(c=>{s===""?s=c:(this.logger.safe.error(`Unexpected second peer connection stats id ${c}, also found ${s}`),this.diagnostics.addStatsError("StatisticsGatherer","Unexpected second peer connection stats"))}),a.peerConnection=n["peer-connection"][s])}appendSendMediaStats(n,a){var s,c,u,m;for(const b in n["outbound-rtp"]){const _=n["outbound-rtp"][b],k={outboundRTP:_};_.codecId&&n.codec&&(k.codec=n.codec[_.codecId]),Object.defineProperty(k,"transport",{value:a.transports[_.transportId??"faketransport"],configurable:!1,enumerable:!1}),_.remoteId&&n["remote-inbound-rtp"]&&(k.remoteInboundRTP=n["remote-inbound-rtp"][_.remoteId]),_.mediaSourceId&&n["media-source"]&&(k.mediaSource=n["media-source"][_.mediaSourceId]),_.trackId&&n.track&&(k.track=n.track[_.trackId]);const N=zCi(this.mediaManager,k.track?.trackIdentifier??k.mediaSource?.trackIdentifier,_.rid)??UCi(this.mediaManager,_.ssrc,_.rid)??$Ci(this.mediaManager,k.outboundRTP.mid,_.rid);if(!N?.getLocalTrackId())continue;k.mediaEntity=N.serialize(),!k.mediaSource&&k.mediaEntity&&n["media-source"]&&(k.mediaSource=Object.values(n["media-source"]).find(ee=>ee.trackIdentifier===k.mediaEntity.localTrackId));const W=_.kind==="video"?N?.getModality()==="sharing"?"sharing":"video":_.kind;if((s=this.activeChannels)[W]??(s[W]={}),(c=this.activeChannels[W]).send??(c.send={}),Ur(this.diagnostics.getObjectRef().negotiation.activeModalities?.[W])){if(a[W]||(a[W]={}),a[W].send||(a[W].send=[]),_.kind==="video"){const ee=DJe(this.diagnostics,W,_.ssrc)??DJe(this.diagnostics,W,0);ee&&(k.requestedCapabilities=ee);const oe=LJe(this.diagnostics,W,_.ssrc)??LJe(this.diagnostics,W,0);oe&&(k.appliedCapabilities=oe);const de=a[W].send.find(se=>se.outboundRTP.trackId===k.outboundRTP.trackId);if(de){const se=parseInt(de.outboundRTP.rid,10)>parseInt(k.outboundRTP.rid,10);if(!de.altLayouts&&se&&(de.altLayouts=[]),se)de.altLayouts.push(k);else{k.altLayouts=[],k.altLayouts.push(de);const Re=a[W].send.indexOf(de);a[W].send[Re]=k}continue}}_.kind==="audio"&&k.codec&&this.audioEncoderCodecName&&this.audioEncoderCodecName!=="None"&&(this.configProvider.config.diagnostics.traceLogging&&this.logger.safe.debug("replacing send audio codec with custom audio encoder codec"),k.codec.mimeType=this.audioEncoderCodecName),this.activeChannels[W].send[_.id]=k,a[W].send.push(k)}else this.activeChannels[W].send[_.id]&&W!=="sharing"&&(a.inactiveTracks??(a.inactiveTracks={}),(u=a.inactiveTracks)[W]??(u[W]={}),(m=a.inactiveTracks[W]).send??(m.send=[]),a.inactiveTracks[W].send.push(this.activeChannels[W].send[_.id]))}}appendRecvMediaStats(n,a){var s,c,u,m;const b=this.diagnostics.getObjectRef().subscriptionManager?.subscribedTrackIds;for(const _ in n["inbound-rtp"]){const k=n["inbound-rtp"][_],N={inboundRTP:k};k.codecId&&n.codec&&(N.codec=n.codec[k.codecId]),k.kind==="audio"&&N.inboundRTP.ssrc===this.audioDecoderStatsProvider?.ssrc&&(this.configProvider.config.diagnostics.traceLogging&&this.logger.safe.debug("replacing recv audio stats with custom audio decoder stats"),N.codec||(N.codec={transportId:k.transportId??"faketransport",id:"fakeCodec",payloadType:999,timestamp:k.timestamp,type:"codec",mimeType:"unk"}),N.codec.mimeType=this.audioDecoderStatsProvider.codecName,N.inboundRTP=(0,NCi.merge)(N.inboundRTP,this.audioDecoderStatsProvider.getWebRtcCompatibleStats()),N.customHealerStats=this.audioDecoderStatsProvider.getWasmStats()),a.transports[k.transportId??"faketransport"]&&Object.defineProperty(N,"transport",{value:a.transports[k.transportId??"faketransport"],configurable:!1,enumerable:!1}),k.remoteId&&n["remote-outbound-rtp"]&&(N.remoteOutboundRTP=n["remote-outbound-rtp"][k.remoteId]);const W=N.inboundRTP.trackIdentifier??this.ssrcToRecvTrackMap.get(k.ssrc);if(k.trackId||W){k.trackId&&n.track?N.track=n.track[k.trackId]:W&&(N.track={id:"ssrcToTrackId",kind:k.kind,timestamp:k.timestamp,type:"track",trackIdentifier:W});const de=VCi(this.diagnostics,N.track?.trackIdentifier);de&&(N.renderer=de)}const ee=FCi(this.mediaManager,N.track?.trackIdentifier)??BCi(this.mediaManager,k.ssrc);if(!ee)continue;N.mediaEntity=ee.serialize();const oe=k.kind==="video"&&N.track?ee?.getModality()==="sharing"?"sharing":"video":k.kind;(s=this.activeChannels)[oe]??(s[oe]={}),(c=this.activeChannels[oe]).recv??(c.recv={}),k.kind!=="video"||b.some(de=>de&&de===N.track?.trackIdentifier)?Rc(this.diagnostics.getObjectRef().negotiation.activeModalities?.[oe])&&(a[oe]||(a[oe]={}),a[oe].recv||(a[oe].recv=[]),this.activeChannels[oe].recv[k.id]=N,a[oe].recv.push(N)):this.activeChannels[oe].recv[k.id]&&oe!=="sharing"&&(a.inactiveTracks??(a.inactiveTracks={}),(u=a.inactiveTracks)[oe]??(u[oe]={}),(m=a.inactiveTracks[oe]).recv??(m.recv=[]),a.inactiveTracks[oe].recv.push(this.activeChannels[oe].recv[k.id]))}}};function OTe(n,a){return!a||n.getSimulcastContext()?.activeRids.map(String).some(s=>s===a)}function BCi(n,a){return n.getMediaEntities().find(s=>s.getRemoteSsrc()===a)}function FCi(n,a){const s=n.getMediaEntities();return a!==void 0?s.find(c=>c.getRemoteTrackId()===a):void 0}function UCi(n,a,s){return n.getMediaEntities().find(c=>c.getLocalSsrc()===a&&OTe(c,s))}function zCi(n,a,s){const c=n.getMediaEntities();return a?c.find(u=>u.getLocalTrackId()===a&&OTe(u,s)):void 0}function DJe(n,a,s){const c=n.getObjectRef().qualityManager;return a==="video"?c?.currentVideoSsrcRequestedCapabilities[`${s}`]:a==="sharing"?c?.currentSharingSsrcRequestedCapabilities[`${s}`]:void 0}function LJe(n,a,s){const c=n.getObjectRef().qualityManager;return a==="video"?c?.currentVideoSsrcAppliedCapabilities[`${s}`]:a==="sharing"?c?.currentSharingSsrcAppliedCapabilities[`${s}`]:void 0}function VCi(n,a){return n.getObjectRef().remoteVideoManager?.renderers.find(s=>s.trackId===a)}function $Ci(n,a,s){const c=n.getMediaEntities();return a?c.find(u=>u.getMid()===a&&OTe(u,s)):void 0}var OJe=class{constructor(){this.googCandidatePair={},this.ssrc={},this.googComponent={},this.VideoBwe={bweforvideo:{}}}},HCi=class{constructor(){this.statistics=new OJe,this.statsDiffMap=new Map,this.ssrcTrackMap=new Map}build(n){return this.statistics=new OJe,this.constructGoogCandidatePair(n),this.constructGoogSsrc(n),this.constructGoogComponent(n),this.constructDataChannel(n),this.constructBwe(n),this.statistics}setSsrcTrackPair(n,a){a===null?this.ssrcTrackMap.delete(n):this.ssrcTrackMap.set(n,a)}setAudioDecoderStatsProvider(n){this.audioDecoderStatsProvider=n}setAudioEncoderCodecName(n){this.audioEncoderCodecName=n}constructGoogSsrc(n){const a={};if(n.hasOwnProperty("outbound-rtp")){const s=n["outbound-rtp"];Object.keys(s).forEach(c=>{const u=`ssrc_${s[c].ssrc}_send`,m=this.constructSendSsrc(n,s[c]);a[u]=m})}if(n.hasOwnProperty("inbound-rtp")){const s=n["inbound-rtp"];Object.keys(s).forEach(c=>{const u=`ssrc_${s[c].ssrc}_recv`,m=this.constructRecvSsrc(n,s[c]);a[u]=m})}this.statistics.ssrc=a}constructSendSsrc(n,a){const s=a.trackId?n.track[a.trackId]:null,c=a.mediaSourceId?n["media-source"][a.mediaSourceId]:null,u=n["remote-inbound-rtp"]?.[a.remoteId],m=`ssrc_${a.ssrc}_send`,b=c?.trackIdentifier??s?.trackIdentifier??this.ssrcTrackMap.get(a.ssrc);let _={id:m,ssrc:a.ssrc,mediaType:a.mediaType??a.kind,bytesSent:a.bytesSent,bytesSentDiff:this.calculateDiff(m,a.bytesSent,4),packetsSent:a.packetsSent,packetsLost:u?.packetsLost,jitter:u?.jitter,googRtt:this.getRtt(u),googCodecName:this.getCodec(n,a.codecId),transportId:a.transportId,googTrackId:b};return _.mediaType==="audio"&&(_={..._,...this.constructAudioSendSsrc(a,c)}),_.mediaType==="video"&&(_={..._,...this.constructVideoSendSsrc(a,c,m,s)}),_l(_)}constructAudioSendSsrc(n,a){const s={audioInputLevel:a?.audioLevel,totalAudioEnergy:a?.totalAudioEnergy,fecPacketsSent:n.fecPacketsSent};return this.audioEncoderCodecName&&this.audioEncoderCodecName!=="None"&&(s.googCodecName=this.audioEncoderCodecName),s}constructVideoSendSsrc(n,a,s,c){return{framesEncoded:n.framesEncoded,googFrameRateEncoded:this.calculateDiff(s,n.framesEncoded,2),googFrameRateSent:this.calculateDiff(s,n.framesSent??c?.framesSent,1),googFrameRateInput:a?.framesPerSecond,googFrameHeightSent:n.frameHeight??c?.frameHeight,googFrameWidthSent:n.frameWidth??c?.frameWidth,googFrameHeightInput:a?.height,googFrameWidthInput:a?.width,hugeFramesSent:n.hugeFramesSent??c?.hugeFramesSent,keyFramesEncoded:n.keyFramesEncoded,qpSum:n.qpSum,qp:this.calculateDiff(s,n.qpSum,8),googPlisReceived:n.pliCount,googFirsReceived:n.firCount,googNacksReceived:n.nackCount,qualityLimitationDurations:n.qualityLimitationDurations,qualityLimitationReason:n.qualityLimitationReason,qualityLimitationResolutionChanges:n.qualityLimitationResolutionChanges,codecImplementationName:n.encoderImplementation,rid:n.rid,encodeTime:n.totalEncodeTime&&Math.round(1e3*this.calculateDiff(s,n.totalEncodeTime,6))}}constructRecvSsrc(n,a){const s=a.trackId?n.track[a.trackId]:null,c=`ssrc_${a.ssrc}_recv`,u=a.trackIdentifier??s?.trackIdentifier??this.ssrcTrackMap.get(a.ssrc);let m={id:c,ssrc:a.ssrc,mediaType:a.mediaType??a.kind,bytesReceived:a.bytesReceived,bytesReceivedDiff:this.calculateDiff(c,a.bytesReceived,5),packetsReceived:a.packetsReceived,packetsLost:a.packetsLost,jitter:a.jitter,googJitterBufferMs:a.jitterBufferEmittedCount&&Math.round(a.jitterBufferDelay/a.jitterBufferEmittedCount*1e3),googCodecName:this.getCodec(n,a.codecId),googTrackId:u,transportId:a.transportId};return m.mediaType==="audio"&&(m={...m,...this.constructAudioRecvSsrc(a,s)}),m.mediaType==="video"&&(m={...m,...this.constructVideoRecvSsrc(a,c,s)}),_l(m)}constructAudioRecvSsrc(n,a){const s=this.audioDecoderStatsProvider?.ssrc===n.ssrc?this.audioDecoderStatsProvider?.getWebRtcCompatibleStats():n,c={audioOutputLevel:s.audioLevel??a?.audioLevel,totalAudioEnergy:s.totalAudioEnergy??a?.totalAudioEnergy,concealedSamples:s.concealedSamples,silentConcealedSamples:s.silentConcealedSamples,totalSamplesReceived:s.totalSamplesReceived,healedRatio:s.totalSamplesReceived&&(s.concealedSamples-s.silentConcealedSamples)/s.totalSamplesReceived,fecPacketsReceived:s.fecPacketsReceived,fecPacketsDiscarded:s.fecPacketsDiscarded,packetsDiscarded:s.packetsDiscarded};if(this.audioDecoderStatsProvider?.ssrc===n.ssrc){c.googJitterBufferMs=s.jitterBufferEmittedCount&&Math.round(s.jitterBufferDelay/s.jitterBufferEmittedCount*1e3),c.googCodecName=this.audioDecoderStatsProvider.codecName;const u=this.audioDecoderStatsProvider.getDecoderStats();c.pushCount=u.pushCount,c.pushErrCount=u.pushErrCount,c.pullCount=u.pullCount,c.pullErrCount=u.pullErrCount}return c}constructVideoRecvSsrc(n,a,s){return{framesDecoded:n.framesDecoded,googFrameRateDecoded:this.calculateDiff(a,n.framesDecoded,3),googFrameRateReceived:this.calculateDiff(a,n.framesReceived??s?.framesReceived,0),googFrameHeightReceived:n.frameHeight??s?.frameHeight,googFrameWidthReceived:n.frameWidth??s?.frameWidth,keyFramesDecoded:n.keyFramesDecoded,googPlisSent:n.pliCount,googFirsSent:n.firCount,googNacksSent:n.nackCount,codecImplementationName:n.decoderImplementation,decodeTime:n.totalDecodeTime&&Math.round(1e3*this.calculateDiff(a,n.totalDecodeTime,7))}}constructGoogCandidatePair(n){const a=n["candidate-pair"];a&&Object.keys(a).forEach(s=>{const c=this.constructPair(n,a[s]);this.statistics.googCandidatePair[c.id]=c})}constructPair(n,a){const s=n["local-candidate"][a.localCandidateId],c=n["remote-candidate"][a.remoteCandidateId];return _l({bytesReceived:a.bytesReceived,bytesSent:a.bytesSent,googTransportType:s.protocol,googRtt:a.currentRoundTripTime?Math.round(1e3*a.currentRoundTripTime):void 0,googLocalAddress:`${s.ip?s.ip:s.address}:${s.port}`,googLocalCandidateType:s.candidateType,localRelayProtocol:s.relayProtocol,localNetworkType:s.networkType,googRemoteAddress:`${c.ip?c.ip:c.address}:${c.port}`,googRemoteCandidateType:c.candidateType,googActiveConnection:a.nominated,requestsReceived:a.requestsReceived,requestsSent:a.requestsSent,responsesReceived:a.responsesReceived,responsesSent:a.responsesSent,consentRequestsSent:a.consentRequestsSent,id:a.id,remoteCandidateId:a.remoteCandidateId,localCandidateId:a.localCandidateId,googWritable:a.writable,selected:a.selected,packetsDiscardedOnSend:a.packetsDiscardedOnSend})}constructGoogComponent(n){n.transport&&Object.keys(n.transport).forEach(a=>{this.statistics.googComponent[a]={id:a,selectedCandidatePairId:n.transport[a].selectedCandidatePairId}})}constructDataChannel(n){if(!n.hasOwnProperty("data-channel"))return;const a=n["data-channel"];this.statistics.data=Object.keys(a).map(s=>{const c=a[s];return{bytesReceived:c.bytesReceived,bytesSent:c.bytesSent,dataChannelIdentifier:c.dataChannelIdentifier,label:c.label,messagesReceived:c.messagesReceived,messagesSent:c.messagesSent,protocol:c.protocol,state:c.state,timestamp:c.timestamp,type:c.type}})}constructBwe(n){const a=Object.values(n["outbound-rtp"]??{})?.find(m=>{const b=m.mediaType??m.kind;return b==="audio"||b==="video"});if(!a)return;const s=n.transport?.[a.transportId];if(!s)return;const c=n["candidate-pair"]?.[s.selectedCandidatePairId];if(!c)return;const u={googAvailableSendBandwidth:c.availableOutgoingBitrate,googAvailableReceiveBandwidth:c.availableIncomingBitrate};this.statistics.VideoBwe.bweforvideo=_l(u)}getRtt(n){const a=n?.roundTripTime;return a?Math.round(1e3*a):void 0}getCodec(n,a){if(a&&n.codec&&n.codec[a])return n.codec[a].mimeType.split("/").pop()}calculateDiff(n,a,s){if(a===void 0)return;let c=a;const u=this.statsDiffMap.has(n)?this.statsDiffMap.get(n):new Map;if(u.has(s)){const m=u.get(s);m<=a&&(c=a-m)}return u.set(s,a),this.statsDiffMap.set(n,u),isNaN(c)?void 0:c}},NJe=dn,uM=dn,jCi=class{constructor(n){this.healedRatio=0,this.healedRatioMax=0,this.healedRatioDuration=0,this.healedRatioTotal=0,this.totalSamplesReceivedDiff=0;const a=n.config;this.networkDetectionDuration=a.webrtcStatNetworkDetectionDuration,this.networkRecvQualityDiagnostics=a.networkRecvQualityDiagnostics,this.networkRecvQualityDiagnostics&&(this.healedRatioAccumulator=new Du(a.webrtcHealedRatioExtendedWindowSize),this.concealedSamplesAccumulator=new Du(a.webrtcHealedRatioExtendedWindowSize),this.silentConcealedSamplesAccumulator=new Du(a.webrtcHealedRatioExtendedWindowSize),this.totalSamplesReceivedAccumulator=new Du(a.webrtcHealedRatioExtendedWindowSize),this.concealedSamplesDiffAccumulator=new Du(a.webrtcHealedRatioExtendedWindowSize),this.silentConcealedSamplesDiffAccumulator=new Du(a.webrtcHealedRatioExtendedWindowSize),this.totalSamplesReceivedDiffAccumulator=new Du(a.webrtcHealedRatioExtendedWindowSize))}captureHealedRatioSamples(n,a,s){!n||!a||!s||n.length<=this.networkDetectionDuration||a.length<=this.networkDetectionDuration||s.length<=this.networkDetectionDuration||this.setHealedRatioPerDuration(n,a,s)}getHealedRatioMax(){return this.healedRatioMax}getHealedRatioAvg(){return this.healedRatioDuration?this.healedRatioTotal/this.healedRatioDuration:0}getHealedRatio(){return this.healedRatio}getTotalSamplesReceivedDiff(){return this.totalSamplesReceivedDiff}setHealedRatioPerDuration(n,a,s){const c=-1-this.networkDetectionDuration,u=Math.max((0,uM.last)(n)-(0,uM.nth)(n,c),0),m=Math.max((0,uM.last)(a)-(0,uM.nth)(a,c),0);this.totalSamplesReceivedDiff=Math.max((0,uM.last)(s)-(0,uM.nth)(s,c),0),this.totalSamplesReceivedDiff!==0&&(this.healedRatio=(u-m)/this.totalSamplesReceivedDiff,this.healedRatioDuration++,this.healedRatioTotal+=this.healedRatio,this.healedRatioMax=Math.max(this.healedRatioMax,this.healedRatio),this.networkRecvQualityDiagnostics&&(this.concealedSamplesAccumulator.add((0,uM.last)(n)),this.silentConcealedSamplesAccumulator.add((0,uM.last)(a)),this.totalSamplesReceivedAccumulator.add((0,uM.last)(s)),this.concealedSamplesDiffAccumulator.add(u),this.silentConcealedSamplesDiffAccumulator.add(m),this.totalSamplesReceivedDiffAccumulator.add(this.totalSamplesReceivedDiff),this.healedRatioAccumulator.add(this.healedRatio)))}getDiagnostics(n){return{quality:(0,uM.last)(n),qualityLevels:n,concealedSamples:this.concealedSamplesAccumulator.items,silentConcealedSamples:this.silentConcealedSamplesAccumulator.items,totalSamplesReceived:this.totalSamplesReceivedAccumulator.items,concealedSamplesDiff:this.concealedSamplesDiffAccumulator.items,silentConcealedSamplesDiff:this.silentConcealedSamplesDiffAccumulator.items,totalSamplesReceivedDiff:this.totalSamplesReceivedDiffAccumulator.items,healedRatio:this.healedRatioAccumulator.items.map(a=>oa(a))}}},GCi=class{constructor(n){this.configProvider=n,this.audioAnalyzers=new Map,this.jitterBufferDuration=0,this.jitterBufferTotal=0,this.jitterTotal=0,this.jitterDuration=0,this.rttDuration=0,this.rttTotal=0,this.rttMax=0,this.jitterMax=0}captureJitterBuffer(n){this.jitterBufferDuration+=ke.TIME_INTERVAL.SEC_1,this.jitterBufferTotal+=n}captureJitter(n){const a=1e3*n;this.jitterTotal+=a,this.jitterMax=Math.max(a,this.jitterMax),this.jitterDuration+=ke.TIME_INTERVAL.SEC_1}getJitterAvg(){return this.jitterDuration?oa(this.jitterTotal/this.jitterDuration):0}getAvgJitterBuffer(){return this.jitterBufferDuration?Math.round(this.jitterBufferTotal/this.jitterBufferDuration):0}captureRtt(n){if(n!==null){const a=parseInt(n);this.rttDuration+=ke.TIME_INTERVAL.SEC_1,this.rttTotal+=a,this.rttMax=Math.max(this.rttMax,a)}}getAvgRtt(){return this.rttDuration?oa(this.rttTotal/this.rttDuration):0}getMaxRtt(){return this.rttMax}getJitterMax(){return this.jitterMax}updateSendStream(n,a){if(!this.configProvider.config.useAudioAnalyzer)return;const s=this.audioAnalyzers.get(a);s&&(s.dispose(),this.audioAnalyzers.delete(a)),n?.rawStream?.getAudioTracks().length&&this.audioAnalyzers.set(a,new vTe(n.rawStream))}getInputLevel(n){return this.audioAnalyzers.get(n)?.getInputLevelNormalized()}},qCi=class{constructor(n,a){this.dropBadBandwidth=n,this.dropGoodBandwidth=a,this.dropDurationCounts={},Object.keys(ke.HISTOGRAM_BATCH).forEach(s=>{this.dropDurationCounts[s]=0})}recordSendBandwidth(n){this.currentDropDuration&&n<this.dropGoodBandwidth||n<this.dropBadBandwidth?this.initiateDrop():this.currentDropDuration&&n>this.dropGoodBandwidth&&this.recoverDrop()}getReport(){const n=Xp(this.dropDurationCounts);return this.currentDropDuration&&(n.ongoingDuration=this.currentDropDuration),n}initiateDrop(){this.currentDropDuration?this.currentDropDuration++:this.currentDropDuration=1}recoverDrop(){for(const n of Object.keys(ke.HISTOGRAM_BATCH))if(this.currentDropDuration<=ke.HISTOGRAM_BATCH[n]){this.dropDurationCounts[n]+=1,this.currentDropDuration=0;break}}},Yne=dn,Qne=class{constructor(n,a,s,c){this.lowThreshold=n,this.highThreshold=a,this.isLowerBetter=s,this.curInLowerRange=s,this.stateTracker=new WCi(c)}onSample(n,a){let s=this.curInLowerRange;this.curInLowerRange?n>this.highThreshold&&(s=!1):n<this.lowThreshold&&(s=!0);const c=this.stateTracker.onNewState(this.getQuality(s),a);return c!==this.getQuality(this.curInLowerRange)&&(this.curInLowerRange=s),c}getQuality(n){return n===this.isLowerBetter?"Good":"Bad"}},WCi=class{constructor(n){this.stickinessTime=n}onNewState(n,a){return n!=="Good"&&n!=="Bad"?this.curState:this.stickinessTime===0?n:n===this.curState?(this.stickTimerStarted=0,this.curState):(this.curState==="Bad"?this.stickTimerStarted===0?this.stickTimerStarted=a:a-this.stickTimerStarted>this.stickinessTime&&(this.curState=n,this.stickTimerStarted=0):(this.curState=n,this.stickTimerStarted=0),this.curState)}},xJe=class{constructor(n,a,s,c){this.stateProcessor=n,this.windowSize=a,this.extendedWindowSize=s,this.addDiagnosticData=c,this.dataAccumulator=new Du(s),this.avgAccumulator=new Du(s)}getLatestSendQuality(n,a,s){if(this.dataAccumulator.add(n),this.dataAccumulator.items.length>=this.windowSize){const c=this.dataAccumulator.items.slice(-this.windowSize),u=(0,Yne.mean)(c);return this.addDiagnosticData&&this.avgAccumulator.add(u),this.stateProcessor.onSample(u,a)}return s}getData(){return this.dataAccumulator.items.map(n=>oa(n))}getAggregatedData(){return this.avgAccumulator.items.map(n=>oa(n))}},KCi=class{constructor(n,a,s){this.configProvider=n,this.newStatsApi=a,this.webrtcHealedRatio=s,this.sendAccumulator=new Du(this.configProvider.config.webrtcLossRateExtendedWindowSize),this.lostAccumulator=new Du(this.configProvider.config.webrtcLossRateExtendedWindowSize),this.sendDiffAccumulator=new Du(this.configProvider.config.webrtcLossRateExtendedWindowSize),this.lostDiffAccumulator=new Du(this.configProvider.config.webrtcLossRateExtendedWindowSize),this.totalAccumulator=new Du(this.configProvider.config.webrtcLossRateExtendedWindowSize),this.sendQualityAccumulator=new Du(this.configProvider.config.webrtcLossRateExtendedWindowSize),this.sendDiagnosticsEnabled=this.configProvider.config.networkSendQualityDiagnostics,this.recvDiagnosticsEnabled=this.configProvider.config.networkRecvQualityDiagnostics,this.recvQualityAccumulator=new Du(this.configProvider.config.webrtcHealedRatioExtendedWindowSize);const c=Number(this.configProvider.config.webrtcStatNetworkDetectionHysteresis);this.networkDetectionBadLevelHigh=Number(this.configProvider.config.webrtcStatNetworkDetectionBadLevel)+c/2,this.networkDetectionBadLevelLow=this.networkDetectionBadLevelHigh-c,this.networkDetectionGoodLevelHigh=Number(this.configProvider.config.webrtcStatNetworkDetectionGoodLevel)+c/2,this.networkDetectionGoodLevelLow=this.networkDetectionGoodLevelHigh-c;const u=new Qne(n.config.webrtcJitterLowThreshold,n.config.webrtcJitterHighThreshold,!0,n.config.webrtcJitterSticknessTime),m=new Qne(n.config.webrtcLossRateLowThreshold,n.config.webrtcLossRateHighThreshold,!0,n.config.webrtcLossRateSticknessTime);this.jitterCalculator=new xJe(u,n.config.webrtcJitterWindowSize,n.config.webrtcJitterExtendedWindowSize,this.sendDiagnosticsEnabled),this.lossRateCalculator=new xJe(m,n.config.webrtcLossRateWindowSize,n.config.webrtcLossRateExtendedWindowSize,this.sendDiagnosticsEnabled)}calculateNetworkSendQualityLevel(n,a,s,c){if(!n||!a)return{quality:c};if(n.length<2||a.length<2||(0,Yne.last)(n)<this.configProvider.config.webrtcMinPacketsSentForNetworkSendQuality)return{quality:c};const u=Date.now(),m=(0,Yne.last)(s),b=this.jitterCalculator.getLatestSendQuality(m,u,c),[_,k]=n.slice(-2),[N,W]=a.slice(-2),ee=this.getLossRate(k,_,W,N),oe=this.lossRateCalculator.getLatestSendQuality(ee,u,c),de=b==="Good"&&oe==="Good"?"Good":"Bad";return this.sendDiagnosticsEnabled&&(this.sendAccumulator.add(k),this.lostAccumulator.add(W),this.sendQualityAccumulator.add(de)),this.sendDiagnosticsEnabled?{quality:de,packetsSend:this.sendAccumulator.items,packetsLost:this.lostAccumulator.items,packetsSendDiff:this.sendDiffAccumulator.items,packetsLostDiff:this.lostDiffAccumulator.items,lossRates:this.lossRateCalculator.getData(),lossRatesAggregated:this.lossRateCalculator.getAggregatedData(),jitter:this.jitterCalculator.getData(),jitterAggregated:this.jitterCalculator.getAggregatedData(),qualityLevels:this.sendQualityAccumulator.items}:{quality:de}}calculateNetworkRecvQualityLevel(n){if(this.newStatsApi){const a=n;return this.calculateNetworkRecvQualityLevelNewStatsApi(a.concealedSamples,a.silentConcealedSamples,a.totalSamplesReceived,a.oldNetworkLevel)}{const a=n;return this.calculateNetworkRecvQualityLevelLegacyStatsApi(a.googDecodingCTN,a.googDecodingPLC,a.oldNetworkLevel)}}calculateNetworkRecvQualityLevelLegacyStatsApi(n,a,s){const c=this.configProvider.config.webrtcStatNetworkDetectionDuration;if(!n||!a||n.length<2*c)return{quality:s};let u=n.length-1-c;const m=n[n.length-1];for(;u>=0&&m-n[u]<100*c;)u--;if(u<0)return{quality:s};const b=m-n[u],_=a[a.length-1]-a[u];if(b<=0)return{quality:s};const k=_/b;return{quality:this.getRecvQuality(k,s)}}calculateNetworkRecvQualityLevelNewStatsApi(n,a,s,c){const u=this.configProvider.config.webrtcStatNetworkDetectionDuration;if(!n||n.length<=u||!a||a.length<=u||!s||s.length<=u)return{quality:c};if((0,Yne.last)(s)<this.configProvider.config.webrtcMinAudioSamplesRecvForNetworkRecvQuality)return{quality:c};if(this.webrtcHealedRatio.getTotalSamplesReceivedDiff()===0)return{quality:c};const m=this.webrtcHealedRatio.getHealedRatio(),b=this.getRecvQuality(m,c);return this.recvDiagnosticsEnabled?(this.recvQualityAccumulator.add(b),this.webrtcHealedRatio.getDiagnostics(this.recvQualityAccumulator.items)):{quality:b}}getRecvQuality(n,a){return n<this.networkDetectionGoodLevelLow?"Good":n<this.networkDetectionGoodLevelHigh?a==="Good"?"Good":"Poor":n<this.networkDetectionBadLevelLow?"Poor":n<this.networkDetectionBadLevelHigh?a==="Bad"?"Bad":"Poor":"Bad"}getLossRate(n,a,s,c){const u=n-a,m=s-c,b=u+m;return this.sendDiagnosticsEnabled&&(this.sendDiffAccumulator.add(u),this.lostDiffAccumulator.add(m),this.totalAccumulator.add(b)),b>0?m/b:0}},JCi=class{constructor(n){this.configProvider=n,this.qualityLimitationReasonEvents=[]}setQualityLimitationReason(n){this.lastQualityLimitationReason!==n&&this.qualityLimitationReasonEvents.push({event:n,startTime:Date.now(),endTime:Date.now()}),this.qualityLimitationReasonEvents.length>this.configProvider.config.maxStoredQualityLimitationReasonEvents&&this.qualityLimitationReasonEvents.shift(),this.lastQualityLimitationReason=n}getQualityLimitationReasonEvents(){return this.qualityLimitationReasonEvents.reduce((n,a,s)=>a.event==="none"?n:[...n,{...a,endTime:this.qualityLimitationReasonEvents[s+1]?.startTime??Date.now()}],[])}},YCi=class{constructor(){this.bitrateData={[ke.MEDIA_DIRECTION.SEND]:{lastBytes:0,lastTimestamp:0,maxSample:0,bitrateTotal:0,nSamples:0,allocateBW:0,allocateBWSamples:0},[ke.MEDIA_DIRECTION.RECV]:{lastBytes:0,lastTimestamp:0,maxSample:0,bitrateTotal:0,nSamples:0}}}captureSample(n,a){const s=Date.now()/1e3;if(this.bitrateData[n].lastTimestamp!==0&&a>this.bitrateData[n].lastBytes){const c=s-this.bitrateData[n].lastTimestamp,u=8*(a-this.bitrateData[n].lastBytes)/c;this.onBitrateSample(n,u)}this.bitrateData[n].lastTimestamp=s,this.bitrateData[n].lastBytes=a}getMax(n){return Math.round(this.bitrateData[n].maxSample)}getAvg(n){return this.bitrateData[n].nSamples===0?0:Math.round(this.bitrateData[n].bitrateTotal/this.bitrateData[n].nSamples)}stopCapture(n){this.bitrateData[n].lastBytes=0,this.bitrateData[n].lastTimestamp=0}onBitrateSample(n,a){a>this.bitrateData[n].maxSample&&(this.bitrateData[n].maxSample=a),this.bitrateData[n].bitrateTotal+=a,this.bitrateData[n].nSamples++}captureAllocateBandwidth(n){if(n){const a=parseInt(n[n.length-1]);this.bitrateData[ke.MEDIA_DIRECTION.SEND].allocateBW+=a,this.bitrateData[ke.MEDIA_DIRECTION.SEND].allocateBWSamples+=1}}getAllocateBandwidthAvg(){const n=this.bitrateData[ke.MEDIA_DIRECTION.SEND].allocateBW,a=this.bitrateData[ke.MEDIA_DIRECTION.SEND].allocateBWSamples;if(n>0&&a>0)return Math.floor(n/a)}},QCi=class{constructor(n,a){this.maxAppliedCapabilitiesCount=a,this.events=[],this.events.push({eventType:"req",timestamp:Date.now(),capabilities:n.capabilities,isSimulcast:n.isSimulcastEnabled})}setMaxCapabilitiesApplied(n){this.events.push({eventType:"app",timestamp:Date.now(),capabilities:n.capabilities,error:n.error?`${n.error}`:"none"}),this.maxAppliedCapabilitiesCount&&this.events.length>this.maxAppliedCapabilitiesCount+1&&this.events.splice(1,1)}getEvents(){return this.events}},ZCi=class{constructor(n,a){this.configProvider=n,this.logger=a,this.resolutionChangeRequestRecords={},this.currentResolutionsByRid={},this.resolutionChangeCounterByRid={},this.events=[],this.errors=[]}setMaxCapabilitesRequested(n){const a=new QCi(n,this.configProvider.config.webrtcLastAppliedVideoCapabilitiesCount);this.events.push({causeId:n.causeId,seq:a}),this.recordResolutionChange(n),this.configProvider.config.webrtcLastAppliedVideoCapabilitiesSequenceCount&&this.events.length>this.configProvider.config.webrtcLastAppliedVideoCapabilitiesSequenceCount&&this.events.shift()}setMaxCapabilitesApplied(n){const a=this.events.find(s=>s.causeId===n.causeId);a?(a.seq.setMaxCapabilitiesApplied(n),n.error&&this.errors.push(a)):this.logger.safe.warn(`Requested capabilities with id ${n.causeId} not found`)}getEvents(){return this.events.map(n=>({causeId:n.causeId,events:n.seq.getEvents()}))}getErrors(){return this.errors.map(n=>({causeId:n.causeId,events:n.seq.getEvents()}))}getResolutionRecords(){if(this.configProvider.config.specCompliantSimulcast?.collectResolutionInfo)return{req:this.resolutionChangeRequestRecords,count:this.resolutionChangeCounterByRid}}recordResolutionChange(n){if(this.configProvider.config.specCompliantSimulcast?.collectResolutionInfo){const a=Object.keys(this.currentResolutionsByRid),s=c=>c.rid||"default";[...a,...n.capabilities.map(c=>s(c))].forEach(c=>{const u=n.capabilities.find(k=>s(k)===c),m=this.currentResolutionsByRid[c]||0,b=u?.maxFs||0;if(m===b)return;this.resolutionChangeRequestRecords[c]||(this.resolutionChangeRequestRecords[c]=[],this.resolutionChangeCounterByRid[c]=0);const _=this.resolutionChangeRequestRecords[c].find(k=>k.from===m&&k.to===b);_?_.counter++:this.resolutionChangeRequestRecords[c].push({from:m,to:b,counter:1}),this.currentResolutionsByRid[c]=b,this.resolutionChangeCounterByRid[c]++})}}},XCi=class{constructor(){this.delayCur=[],this.delayTotal=0,this.delayEventCount=0}analyzeDelay(n,a){if(a&&a!==""){this.delayCur.length===n&&this.delayCur.shift();const s=parseInt(a);this.delayCur.push(s),this.delayTotal+=s,this.delayEventCount+=ke.TIME_INTERVAL.SEC_1}}getDelayCur(){if(this.delayCur.length>0){const n=this.delayCur.reduce((a,s)=>a+s)/this.delayCur.length;return n<0?0:n}}getDelayAvg(){if(this.delayEventCount>0&&this.delayTotal>0){const n=this.delayTotal/this.delayEventCount;return n<0?0:n}}},e_i=class{constructor(n,a){this.configProvider=n,this.startTime=a,this.recvTotalFreezeDuration=-1,this.recvFreezeDurations=[],this.recvFreezeIsOngoing=!1,this.recvCurrentFreezeDuration=0,this.recvFreezeCount=0,this.receiveFreezeDurationCounts={},this.longestRecvFreezeDuration=0,this.sendCameraFreezeIntervalsCount=0,this.previousInputFrame=0,this.recvCurrentFreezeStartTimestamp=0,this.receiveFreezeDurationTimestamps={},this.finalFreezeIsOngoing=!1,this.finalRecvCurrentFreezeDuration=0,this.mediaStarted=!1,this.lastBytesRecv=0,this.currentLowBitrateDuration=0,Object.keys(ke.HISTOGRAM_BATCH).forEach(s=>{this.receiveFreezeDurationCounts[s]=0,this.receiveFreezeDurationTimestamps[s]=[]})}gatherFreezeData({frameRateDecoded:n,frameRateRecv:a,bytesReceived:s,mediaType:c}){if(n){const u=parseInt(n[n.length-1],10),m=a?.length>0?parseInt(a[a.length-1],10):void 0;s!==void 0&&c!=="ScreenShare"&&this.configProvider.config.isBytesRecvUsedInIsRenderingCalculation&&!this.configProvider.config.isRenderingBasedOnRawStatistics&&this.calculateBitrate(s,u),this.recvTotalFreezeDuration===-1&&(this.recvTotalFreezeDuration=0),u>0&&(this.mediaStarted=!0),u!==0&&m!==0||!this.mediaStarted?u>0&&(m===void 0||m>0)&&this.recvFreezeIsOngoing&&this.stopRecvDataGathering(!1):(this.recvFreezeIsOngoing||(this.recvCurrentFreezeStartTimestamp=Date.now()-this.startTime),this.recvFreezeIsOngoing=!0,this.recvCurrentFreezeDuration+=ke.TIME_INTERVAL.SEC_1,this.recvTotalFreezeDuration+=ke.TIME_INTERVAL.SEC_1)}}getIsRendering(n){return this.recvCurrentFreezeDuration<n&&this.currentLowBitrateDuration<n&&this.mediaStarted}detectCaptureFreeze(n){if(n){const a=parseInt(n[n.length-1],10);this.previousInputFrame>0&&a===0&&(this.sendCameraFreezeIntervalsCount+=1),this.previousInputFrame=a}}getSendCameraFreezeIntervals(){return this.sendCameraFreezeIntervalsCount>0?this.sendCameraFreezeIntervalsCount:void 0}stopRecvDataGathering(n=!0){this.finalFreezeIsOngoing=this.recvFreezeIsOngoing,this.recvFreezeIsOngoing=!1,n&&(this.mediaStarted=!1),this.recvCurrentFreezeDuration>0&&(this.populateLongestRecvFreezeDuration(),this.populateRecvFreezeDurationCounts(),this.recvFreezeDurations.push(this.recvCurrentFreezeDuration),this.recvFreezeCount+=1),this.finalRecvCurrentFreezeDuration=this.recvCurrentFreezeDuration,this.recvCurrentFreezeDuration=0}getRecvFreezeDurationCounts(){return this.recvFreezeCount>0?JSON.stringify(this.receiveFreezeDurationCounts):void 0}getRecvFreezeDurationTimestamps(n){if(this.recvFreezeCount===0)return;const a={};return Object.keys(this.receiveFreezeDurationTimestamps).forEach(s=>{const c=this.receiveFreezeDurationTimestamps[s].length;a[s]=c>n?this.receiveFreezeDurationTimestamps[s].slice(c-n):this.receiveFreezeDurationTimestamps[s]}),JSON.stringify(a)}getRecvFreezeIsOngoing(n){return this.finalRecvCurrentFreezeDuration>=n&&this.finalFreezeIsOngoing}getRecvTotalFreezeDuration(){return this.recvTotalFreezeDuration>=0?this.recvTotalFreezeDuration:void 0}getRecvAvgFreezeDuration(){if(this.recvTotalFreezeDuration>0&&this.recvFreezeCount>0)return this.recvTotalFreezeDuration/this.recvFreezeCount}getLongestRecvFreezeDuration(){return this.longestRecvFreezeDuration>0?this.longestRecvFreezeDuration:void 0}populateRecvFreezeDurationCounts(){for(const n of Object.keys(ke.HISTOGRAM_BATCH))if(this.recvCurrentFreezeDuration<=ke.HISTOGRAM_BATCH[n]){this.receiveFreezeDurationCounts[n]+=1,this.receiveFreezeDurationTimestamps[n].push(this.recvCurrentFreezeStartTimestamp);break}this.recvCurrentFreezeStartTimestamp=0}populateLongestRecvFreezeDuration(){this.recvCurrentFreezeDuration>this.longestRecvFreezeDuration&&(this.longestRecvFreezeDuration=this.recvCurrentFreezeDuration)}calculateBitrate(n,a){const c=(n-this.lastBytesRecv)/125;this.lastBytesRecv=n,c<this.configProvider.config.notRenderingLowBitrateThreshold&&a<this.configProvider.config.notRenderingLowFramerateThreshold?this.currentLowBitrateDuration++:this.currentLowBitrateDuration=0}},t_i=class{constructor(){this.mediaData={[ke.MEDIA_DIRECTION.SEND]:{totalMediaDuration:-1,totalFrameCount:0,mediaStartTimestamp:new Date,mediaStarted:!1,timeSinceLastDecode:0,cameraFrameRate:0},[ke.MEDIA_DIRECTION.RECV]:{totalMediaDuration:-1,totalFrameCount:0,mediaStartTimestamp:new Date,mediaStarted:!1,timeSinceLastDecode:0,cameraFrameRate:0}},this.gatheringSendData=!1}captureMediaData(n,a,s){const c=this.mediaData[n];if(n===ke.MEDIA_DIRECTION.SEND&&(this.gatheringSendData=!0),a){const u=parseInt(a[a.length-1],10);c.totalFrameCount+=u}if(s){c.totalMediaDuration===-1&&(c.totalMediaDuration=0);const u=parseInt(s[s.length-1],10);c.mediaStarted||u>0&&(c.mediaStarted=!0,c.mediaStartTimestamp=new Date)}c.mediaStarted&&(c.totalMediaDuration+=ke.TIME_INTERVAL.SEC_1)}captureFrameRate(n){const a=this.mediaData[ke.MEDIA_DIRECTION.SEND];if(n){const s=parseInt(n[n.length-1],10);a.cameraFrameRate+=s}}stopRecvDataGathering(){const n=this.mediaData[ke.MEDIA_DIRECTION.RECV],a=new Date().getTime();n.timeSinceLastDecode=n.totalMediaDuration>0?Math.round((a-n.mediaStartTimestamp.getTime())/1e3):0,n.mediaStarted=!1}isGatheringSendData(){return this.gatheringSendData}stopSendDataGathering(){const n=this.mediaData[ke.MEDIA_DIRECTION.SEND],a=new Date;n.timeSinceLastDecode=n.totalMediaDuration>0?Math.round((a.getTime()-n.mediaStartTimestamp.getTime())/1e3):0,this.gatheringSendData=!1,n.mediaStarted=!1}getAvgFrameRate(n){const a=this.mediaData[n];if(a.totalMediaDuration>0&&a.totalFrameCount>0)return a.totalFrameCount/a.totalMediaDuration}getTotalDuration(n){const a=this.mediaData[n];return a.totalMediaDuration>=0?a.totalMediaDuration:void 0}getTimeSinceLastDecode(n){const a=this.mediaData[n];return a.timeSinceLastDecode>0?a.timeSinceLastDecode:void 0}getSendCameraFramerate(){const n=this.mediaData[ke.MEDIA_DIRECTION.SEND];if(n.totalMediaDuration>0)return n.cameraFrameRate/n.totalMediaDuration}},NTe={fs:0,fps:1},i_i=class{constructor(n){this.logger=n,this.allowed=new Map,this.lastParams=new Map,this.currentEvents=new Map,this.finishedEvents=[]}setMaxCapabilities(n){n.forEach(a=>{if(a.ssrc||a.ssrc===0){this.finishIfActive(a.ssrc),this.allowed.set(a.ssrc,{fs:a.maxFs+NTe.fs,fps:a.maxFps+NTe.fps});const s=this.lastParams.get(a.ssrc);s&&this.setCurrentParams(a.ssrc,s.fs,s.fps)}})}setCurrentParams(n,a,s){this.lastParams.set(n,{fs:a,fps:s});const c=this.getAllowedParams(n);c&&(a>c.fs||s>c.fps)?(this.captureOvershoot(n,s,c.fps,"fps"),this.captureOvershoot(n,a,c.fs,"fs")):c&&this.finishIfActive(n)}flush(){this.currentEvents.forEach((n,a)=>this.finishIfActive(a))}getEvents(){const n=[...fs(this.finishedEvents)],a=Date.now();return this.currentEvents.forEach(s=>s.forEach(c=>n.push({ssrc:c.ssrc,timestamp:c.timestamp,duration:a-c.timestamp,overshootType:c.overshootType,amount:c.amount}))),n}captureOvershoot(n,a,s,c){const u=this.currentEvents.get(n)||[],m=u.findIndex(N=>N.overshootType===c),b=u[m],_=a-s,k=NTe[c];_<=k&&b?(b.duration=Date.now()-b.timestamp,this.finishedEvents.push(b),this.logger.debug(`stopped overshooting ${c} by ${b.amount}`),u.splice(m,1)):_>k&&!b?(this.logger.safe.info(`overshooting ${c} by ${a-s}`),u.push({ssrc:n,timestamp:Date.now(),duration:-1,overshootType:c,amount:{min:_,max:_}})):_>k&&b&&(b.amount={min:Math.min(b.amount.min,_),max:Math.max(b.amount.max,_)}),u.length?this.currentEvents.set(n,u):this.currentEvents.has(n)&&this.currentEvents.delete(n)}getAllowedParams(n){return this.allowed.get(n)||this.allowed.get(0)}finishIfActive(n){const a=this.currentEvents.get(n);if(a){const s=Date.now();a.forEach(c=>{c.duration=s-c.timestamp,this.finishedEvents.push(c),this.logger.debug(`finished overshooting ${c.overshootType} by min:${c.amount.min} max:${c.amount.max} for ${c.duration}ms for ssrc ${n}`)}),this.currentEvents.delete(n)}}},n_i=class{constructor(){this.qpData={[ke.MEDIA_DIRECTION.SEND]:{frames:0,qpSum:0},[ke.MEDIA_DIRECTION.RECV]:{frames:0,qpSum:0}}}captureQpData(n,a,s){const c=this.qpData[n];if(s&&s.length>0){const u=parseInt(s[s.length-1],10);u>0&&(c.frames=u)}if(a){const u=parseInt(a,10);u>0&&(c.qpSum=u)}}getQpAverage(n){const a=this.qpData[n];if(a.qpSum>0&&a.frames>0)return a.qpSum/a.frames}},a_i=class{constructor(){this.resolutionChangedCount=0,this.resDurations={},this.preferredResolutionDurations={},this.preferredResolutions=[]}get resolutionSwitchCount(){return this.resolutionChangedCount}get resolutionDurationRatios(){return this.countResolutionDurationRatio(this.resDurations)}get preferredResolutionDurationRatios(){return this.countResolutionDurationRatio(this.preferredResolutionDurations)}get preferredResolution(){return this.preferredResolutions}captureSample(n){n&&n.width&&n.height&&(this.isResolutionChanged(this.lastResolution,n)&&this.resolutionChanged(n),this.updateResolutionDuration(this.getResolutionKey(n),this.resDurations)),this.lastPreferredResolution&&this.updatePreferredResolutionDurations()}capturePreferredResolution(n,a){const s=this.getResolutionKey(n);this.preferredResolution.includes(s)||(this.preferredResolutions.length>=a&&this.preferredResolutions.shift(),this.preferredResolutions.push(s)),this.isResolutionChanged(this.lastPreferredResolution,n)&&(this.preferredResolutionChanged(n),this.updatePreferredResolutionDurations())}getResolutionKey(n){return`${n.width}x${n.height}`}isResolutionChanged(n,a){return!n||n.width!==a.width||n.height!==a.height}countResolutionDurationRatio(n){const a={};let s=0;for(const c in n)s+=n[c];for(const c in n)a[c]=oa(n[c]/s*100,2);return a}updatePreferredResolutionDurations(){this.updateResolutionDuration(this.getResolutionKey(this.lastPreferredResolution),this.preferredResolutionDurations)}updateResolutionDuration(n,a){a[n]||(a[n]=0),a[n]++}preferredResolutionChanged(n){this.lastPreferredResolution=n}resolutionChanged(n){this.lastResolution=n,this.resolutionChangedCount++}},r_i=class{constructor(){this.streamsTimers={}}countRecvStreams(n){const a=`${n}`;this.streamsTimers.hasOwnProperty(a)||(this.streamsTimers[a]=0),this.streamsTimers[a]++}getStreamCounts(){const n={min:void 0,max:void 0,mode:void 0},a=Object.keys(this.streamsTimers).map(Number);return a.length===0||a.length===1&&a[0]===0||(n.min=Math.min(...a.filter(s=>s>0)),n.max=Math.max(...a),n.mode=a.reduce((s,c)=>this.streamsTimers[c]>this.streamsTimers[s]?c:s,a[0])),n}},o_i=class{constructor(n){this.configProvider=n,this.subscriptionEvents=[],this.subscriptionCounters={attempted:0,subscribed:0,unsubscribed:0,failed:0}}addSubscriptionEvent(n){switch(this.subscriptionEvents.length>this.configProvider.config.webrtcSubscriptionEventLimit&&this.subscriptionEvents.shift(),this.subscriptionEvents.push(n),n.evt){case 1:this.subscriptionCounters.attempted++;break;case 2:this.subscriptionCounters.subscribed++;break;case 3:this.subscriptionCounters.unsubscribed++;break;case-1:this.subscriptionCounters.failed++}}getSubscriptionEvents(){return this.subscriptionEvents.length>0?{events:this.subscriptionEvents}:void 0}getSubscriptionCounters(){return this.subscriptionEvents.length>0?this.subscriptionCounters:void 0}},Zne=class{constructor(n,a,s,c="Video"){this.startTime=n,this.configProvider=a,this.logger=s,this.mediaType=c,this.subscriptionCounter=0,this.videoFreezeTelemetry=new e_i(this.configProvider,this.startTime),this.videoDelayTelemetry=new XCi,this.videoSubscriptionEvents=new o_i(this.configProvider),this.videoQPEvents=new n_i,this.videoResolutionTelemetry=new a_i,this.videoGeneralTelemetry=new t_i,this.videoStreamsCounters=new r_i,this.videoBitrate=new YCi,this.videoMaxCapabilities=new ZCi(this.configProvider,this.logger),this.videoOvershoot=new i_i(this.logger),this.videoQualityLimitations=new JCi(this.configProvider),this.videoStatsOnSubscribed=new RTe(this.configProvider),this.videoResolutionSwitchTracker=new VWe(this.configProvider.config.diagnostics?.collectionLimits?.numResolutionSwitches),this.timeToFirstFrame=-1,this.timeToFirstFrameSinceSubscriptionStart=-1,this.currentTrackId="",this.recvTotalFreezeDurationMs=0,this.isRenderingEvents=[]}get trackId(){return this.currentTrackId}set trackId(n){this.currentTrackId=n}get isRecvDataGatheringEnabled(){return this.subscriptionCounter>0}startStopRecvDataGathering(n){this.logger.safe.info("Receive data gathering is "+(n?"enabled":"disabled")),n?this.subscriptionCounter++:this.subscriptionCounter--,this.subscriptionCounter<0&&this.logger.safe.error(`Subscription counter should not be less than 0. Actual value is ${this.subscriptionCounter}`),this.subscriptionCounter===0&&this.stopRecvGathering()}stopDataGathering(){this.stopRecvGathering(),this.stopSendGathering()}stopRecvGathering(){this.videoFreezeTelemetry.stopRecvDataGathering(),this.videoGeneralTelemetry.stopRecvDataGathering(),this.videoBitrate.stopCapture(ke.MEDIA_DIRECTION.RECV)}isSendGathering(){return this.videoGeneralTelemetry.isGatheringSendData()}stopSendGathering(){this.videoGeneralTelemetry.stopSendDataGathering(),this.videoBitrate.stopCapture(ke.MEDIA_DIRECTION.SEND),this.videoOvershoot.flush()}gatherRecvFreezeData(n,a,s){this.videoFreezeTelemetry.gatherFreezeData({frameRateDecoded:n,frameRateRecv:a,bytesReceived:s,mediaType:this.mediaType})}detectCaptureFreeze(n){this.videoFreezeTelemetry.detectCaptureFreeze(n)}getRecvFreezeDurationCounts(){return this.videoFreezeTelemetry.getRecvFreezeDurationCounts()}getRecvFreezeDurationTimestamps(){return this.videoFreezeTelemetry.getRecvFreezeDurationTimestamps(this.configProvider.config.maxVideoFreezeTimestampsInBucket)}getRecvTotalFreezeDuration(){return this.videoFreezeTelemetry.getRecvTotalFreezeDuration()}setRecvTotalFreezeDurationMs(n){this.recvTotalFreezeDurationMs=n!==void 0?this.recvTotalFreezeDurationMs+=n:void 0}analyzeDelay(n,a){this.videoDelayTelemetry.analyzeDelay(n,a)}getDelayCur(){return this.videoDelayTelemetry.getDelayCur()}getDelayAvg(){return this.videoDelayTelemetry.getDelayAvg()}addSubscriptionEvent(n){this.videoSubscriptionEvents.addSubscriptionEvent(n)}getSubscriptionEvents(){return this.videoSubscriptionEvents.getSubscriptionEvents()}getSubscriptionCounters(){return this.videoSubscriptionEvents.getSubscriptionCounters()}captureQpData(n,a,s){this.videoQPEvents.captureQpData(n,a,s)}getQpAverage(n){return this.videoQPEvents.getQpAverage(n)}captureMediaData(n,a,s){this.videoGeneralTelemetry.captureMediaData(n,a,s)}getIsRendering(){const n=this.configProvider.config.notRenderingTimeInterval[this.mediaType==="Video"?"video":"sharing"];return this.videoFreezeTelemetry.getIsRendering(n)}captureFrameRate(n){this.videoGeneralTelemetry.captureFrameRate(n)}getTotalDuration(n){return this.videoGeneralTelemetry.getTotalDuration(n)}captureResolutionSample(n){this.videoResolutionTelemetry.captureSample(n)}countRecvStreams(n){this.videoStreamsCounters.countRecvStreams(n)}captureBitrateSample(n,a){this.videoBitrate.captureSample(n,a)}captureAllocateBandwidth(n){this.videoBitrate.captureAllocateBandwidth(n)}capturePreferredResolution(n,a){this.videoResolutionTelemetry.capturePreferredResolution(n,a)}setMaxCapabilitesRequested(n,a=!1){this.videoMaxCapabilities.setMaxCapabilitesRequested(n),a||n.capabilities.length===1&&!n.capabilities[0]?.ssrc||this.setMaxCapabilitiesOvershoot(n.capabilities)}setMaxCapabilitesApplied(n,a=!1){this.videoMaxCapabilities.setMaxCapabilitesApplied(n),a||n.capabilities.length===1&&!n.capabilities[0]?.ssrc||this.setMaxCapabilitiesOvershoot(n.capabilities)}getMaxCapabilitiesEvents(){const n=this.videoMaxCapabilities.getEvents();return JSON.stringify(n)}getMaxCapabilitiesResolutionChanges(){const n=this.videoMaxCapabilities.getResolutionRecords();return n?JSON.stringify(n):""}getMaxCapabilitiesErrors(){const n=this.videoMaxCapabilities.getErrors();return n?JSON.stringify(n):""}setCurrentParameters(n,a,s){this.videoOvershoot.setCurrentParams(n,a.height/16*(a.width/16),s)}setMaxCapabilitiesOvershoot(n){this.videoOvershoot.setMaxCapabilities(n)}getOvershootEvents(){let n=this.videoOvershoot.getEvents();return n=n.slice(Math.max(0,n.length-(this.configProvider.config.maxReportedOvershootingEvents+1)),n.length),n.forEach(a=>a.timestamp=a.timestamp-this.startTime),JSON.stringify(n)}getOvershootTotalDurations(){const n=this.videoOvershoot.getEvents();return n.forEach(a=>a.timestamp=a.timestamp-this.startTime),JSON.stringify({fs:n.reduce((a,s)=>s.overshootType==="fs"?a+s.duration:a,0),fps:n.reduce((a,s)=>s.overshootType==="fps"?a+s.duration:a,0)})}setQualityLimitationReason(n){this.videoQualityLimitations.setQualityLimitationReason(n)}getQualityLimitationReasonEvents(){return this.videoQualityLimitations.getQualityLimitationReasonEvents()}captureTimeToFirstFrame(n,a){n!==-1&&(this.timeToFirstFrame=n,this.timeToFirstFrameSinceSubscriptionStart=a)}getTimeToFirstFrame(){return this.timeToFirstFrame}setIsRendering(n){Mo(this.isRenderingEvents,{isRendering:n,ts:Date.now()},this.configProvider.config.diagnostics.telemetryLimits.numIsRenderingEvents)}setMsi(n){this.msi=n}setLocalMsi(n){this.localMsi=n}prepareCollectingStatsOnSubscribed(n){this.videoStatsOnSubscribed.prepareCollectingStatsOnSubscribed(n)}captureStatsOnSubscribed(n,a){this.videoStatsOnSubscribed.captureStatsOnSubscribed(n,a)}calculateResolutinSwitches(n,a){this.videoResolutionSwitchTracker.captureSample(n,a)}getReport(n,a,s=!1){const c={};if(c[a+"DurationSeconds"]=this.getTotalDuration(n),c[a+"QpAvg"]=this.getQpAverage(n),c[a+"frameRateAvg"]=this.videoGeneralTelemetry.getAvgFrameRate(n),c[a+"bitrateAvg"]=this.videoBitrate.getAvg(n),c[a+"bitrateMax"]=this.videoBitrate.getMax(n),n===ke.MEDIA_DIRECTION.SEND)c[a+"DelayCur"]=this.getDelayCur(),c[a+"DelayAvg"]=this.getDelayAvg(),c[a+"TimeSinceLastEncodeStart"]=this.videoGeneralTelemetry.getTimeSinceLastDecode(n),c[a+"AllocateBWAvg"]=this.videoBitrate.getAllocateBandwidthAvg(),c[a+"CaptureFramerateAvg"]=this.videoGeneralTelemetry.getSendCameraFramerate(),c[a+"FreezeIntervals"]=this.videoFreezeTelemetry.getSendCameraFreezeIntervals(),c[a+"MaxCapabilities"]=s?"":this.getMaxCapabilitiesEvents(),c[a+"MaxCapabilitiesErrors"]=s?"":this.getMaxCapabilitiesErrors(),c[a+"OvershootEvents"]=this.getOvershootEvents(),c[a+"OvershootDurations"]=this.getOvershootTotalDurations(),c[a+"qualityLimitationReasonEvents"]=JSON.stringify(this.getQualityLimitationReasonEvents()),c[a+"MaxCapabilitiesResolutions"]=this.getMaxCapabilitiesResolutionChanges(),c[a+"ResolutionsSwitches"]=this.videoResolutionSwitchTracker.switches?JSON.stringify(this.videoResolutionSwitchTracker.switches):"";else if(n===ke.MEDIA_DIRECTION.RECV){c[a+"TimeSinceLastDecodeStart"]=this.videoGeneralTelemetry.getTimeSinceLastDecode(n),c[a+"FreezeHistogram"]=this.getRecvFreezeDurationCounts(),c[a+"FreezeTimestamps"]=this.getRecvFreezeDurationTimestamps(),c[a+"LongestFreezeDuration"]=this.videoFreezeTelemetry.getLongestRecvFreezeDuration(),c[a+"RecvAvgFreezeDuration"]=this.videoFreezeTelemetry.getRecvAvgFreezeDuration(),c[a+"TotalFreezeDuration"]=this.getRecvTotalFreezeDuration(),c[a+"TotalFreezeDurationMs"]=this.recvTotalFreezeDurationMs,c[a+"OngoingFreeze"]=this.videoFreezeTelemetry.getRecvFreezeIsOngoing(this.configProvider.config.webrtcEndOfCallFreezeThreshold),c[a+"NumResolutionSwitches"]=this.videoResolutionTelemetry.resolutionSwitchCount,c[a+"PreferredResolution"]=this.videoResolutionTelemetry.preferredResolution,c[a+"PreferredResolutionDurations"]=JSON.stringify(this.videoResolutionTelemetry.preferredResolutionDurationRatios),c[a+"ResolutionDurations"]=JSON.stringify(this.videoResolutionTelemetry.resolutionDurationRatios);const u=this.videoStreamsCounters.getStreamCounts();c[a+"StreamsMin"]=u.min,c[a+"StreamsMax"]=u.max,c[a+"StreamsMode"]=u.mode,c[a+"TimeToFirstFrame"]=this.timeToFirstFrame,c[a+"TimeToFirstFrameSinceSubscriptionStart"]=this.timeToFirstFrameSinceSubscriptionStart,c[a+"LocalMsi"]=this.localMsi,c[a+"Msi"]=this.msi,c[a+"isRenderingEvents"]=JSON.stringify(this.isRenderingEvents),c[a+"statsOnSubscribed"]=JSON.stringify(this.videoStatsOnSubscribed.videoStatsOnSubscribed)}return c}},BJe=Symbol("mslbase"),Xne=Symbol("mslsamples"),FJe=class{constructor(n,a){this.logger=n,this.configProvider=a,this.currentLayouts={},this.collectedModalitySessions=[],this.startTimestamp=Date.now()}get collectedSessions(){return this.collectedModalitySessions}get highestFidelitySSRC(){if(!this.currentModalitySession)return;let n;for(const a in this.currentLayouts)n=this.getHigherFidelitySSRC(a,n);return parseInt(n)}processStats(n){const a=Object.values(n.ssrc??{}).filter(c=>c.rid&&c.ssrc&&c.googFrameHeightInput&&this.lastMaxCapabilitiesEvent?.capabilities.some(u=>u.rid===c.rid)),s=new Map(a.map(c=>[`${c.ssrc}`,c.rid]));for(const c in this.currentLayouts)s.has(c)||this.collectLayout(c);!this.currentModalitySession&&s.size>0&&(this.currentModalitySession={timestamp:Date.now()-this.startTimestamp,duration:0,numLayouts:0,layouts:[]},this.logger.safe.info("Modality session started")),a.forEach(c=>{this.currentLayouts[`${c.ssrc}`]||this.addLayout(c)}),s.size===0&&this.currentModalitySession&&this.collectSession(),a.forEach(c=>this.processLayoutData(c))}setMaxCapabilities(n,a){if(this.lastMaxCapabilitiesEvent=n,Object.keys(this.currentLayouts).length)for(const s of n.capabilities){const c=Object.values(this.currentLayouts).find(u=>u.rid===s.rid);c&&(a?(Mo(c.fmtp,{...s,timestamp:Date.now()-this.startTimestamp-this.currentModalitySession.timestamp-c.timestamp,causeId:n.causeId},this.configProvider.config.simulcastTelemetryNumFMTP),c.gatherer.setMaxCapabilitesApplied(n)):c.gatherer.setMaxCapabilitesRequested(n),c.gatherer.setMaxCapabilitiesOvershoot([s]))}}finish(){this.logger.safe.info("Finishing statistics gathering");for(const n in this.currentLayouts)this.collectLayout(n);this.currentModalitySession&&this.collectSession()}addLayout(n){const a=`${n.ssrc}`,s=n.rid,c=this.lastMaxCapabilitiesEvent?.capabilities.find(b=>b.rid===s);this.logger.safe.info(`Adding layout for ssrc ${a} rid ${s}`);const u=Date.now()-this.startTimestamp-this.currentModalitySession.timestamp,m=new Zne(u,this.configProvider,this.logger.createChild(`Telemetry#${a}`));this.currentLayouts[a]={ssrc:n.ssrc,rid:s,fmtp:[{...c,timestamp:u,causeId:this.lastMaxCapabilitiesEvent?.causeId}],timestamp:u,duration:0,gatherer:m,[BJe]:{firCount:n.googFirsReceived,nackCount:n.googNacksReceived,pliCount:n.googPlisReceived,framesEncoded:n.framesEncoded,bytesSent:n.bytesSent,packetsSent:n.packetsSent,packetsLost:n.packetsLost,qpSum:n.qpSum},[Xne]:{firCount:[],nackCount:[],pliCount:[],framesEncoded:[],bytesSent:[],packetsSent:[],packetsLost:[],qpSum:[],frameHeightInput:[],frameHeightSent:[],frameRateInput:[],frameRateSent:[]}},m.setMaxCapabilitiesOvershoot([c]),this.currentModalitySession.numLayouts++}processLayoutData(n){const a=`${n.ssrc}`,s=this.currentLayouts[a];this.processMediaStats(s,n),s.gatherer.captureMediaData(ke.MEDIA_DIRECTION.SEND,[String(n.googFrameRateSent)],[String(n.framesEncoded)]),s.gatherer.captureFrameRate([String(n.googFrameRateInput)]),s.gatherer.captureQpData(ke.MEDIA_DIRECTION.SEND,String(n.qpSum),[String(n.framesEncoded)]),s.gatherer.captureBitrateSample(ke.MEDIA_DIRECTION.SEND,n.bytesSent),s.gatherer.detectCaptureFreeze([String(n.googFrameRateInput)]),s.gatherer.setCurrentParameters(n.ssrc,{width:n.googFrameWidthSent,height:n.googFrameHeightSent},n.googFrameRateSent)}processMediaStats(n,a){const s=n[BJe],c=a.googFirsReceived-s.firCount,u=a.googNacksReceived-s.nackCount,m=a.googPlisReceived-s.pliCount,b=a.framesEncoded-s.framesEncoded,_=a.bytesSent-s.bytesSent,k=a.packetsSent-s.packetsSent,N=a.packetsLost-s.packetsLost,W=a.qpSum-s.qpSum,ee=n[Xne],oe=this.configProvider.config.webrtcStatStoredRecordsNumber;Mo(ee.firCount,c,oe),Mo(ee.nackCount,u,oe),Mo(ee.pliCount,m,oe),Mo(ee.framesEncoded,b,oe),Mo(ee.bytesSent,_,oe),Mo(ee.packetsSent,k,oe),Mo(ee.packetsLost,N,oe),Mo(ee.qpSum,W,oe),Mo(ee.frameHeightInput,a.googFrameHeightInput,oe),Mo(ee.frameHeightSent,a.googFrameHeightSent,oe),Mo(ee.frameRateInput,a.googFrameRateInput,oe),Mo(ee.frameRateSent,a.googFrameRateSent,oe)}collectLayout(n){this.logger.safe.info(`Collecting layout for ssrc ${n}`),this.currentLayouts[n].duration=Date.now()-this.startTimestamp-this.currentModalitySession.timestamp-this.currentLayouts[n].timestamp,this.currentLayouts[n].gatherer.isSendGathering()&&this.currentLayouts[n].gatherer.stopSendGathering();const a=this.currentLayouts[n].gatherer.getReport(ke.MEDIA_DIRECTION.SEND,"",!1);for(const s in a)this.currentLayouts[n][s]=a[s];for(const s in this.currentLayouts[n][Xne])this.currentLayouts[n][s]=_a(this.currentLayouts[n][Xne][s],c=>c);delete this.currentLayouts[n].gatherer,Mo(this.currentModalitySession.layouts,this.currentLayouts[n],this.configProvider.config.simulcastTelemetryLayoutsPerSession),delete this.currentLayouts[n]}collectSession(){this.logger.safe.info("Collecting session");for(const n in this.currentLayouts)this.collectLayout(n);this.currentModalitySession.duration=Date.now()-this.startTimestamp-this.currentModalitySession.timestamp,Mo(this.collectedModalitySessions,this.currentModalitySession,this.configProvider.config.simulcastTelemetryNumModalitySessions),this.currentModalitySession=void 0,this.lastMaxCapabilitiesEvent=void 0}getHigherFidelitySSRC(n,a){if(!n||!a)return n||a;const[s]=this.currentLayouts[n].fmtp.slice(-1),[c]=this.currentLayouts[a].fmtp.slice(-1);return(s?.maxMbps??0)>0&&(c?.maxMbps??0)>0?s.maxMbps>c.maxMbps?n:a:n||a}},s_i=["googFrameHeightReceived","googFrameWidthReceived","googFrameHeightSent","googFrameWidthSent","googFrameRateInput","googFrameRateSent","googNacksSent","googNacksReceived","googPlisSent","googPlisReceived","googFirsSent","googFirsReceived","framesDecoded","googFrameRateDecoded","googFrameRateReceived","framesEncoded","packetsLost","packetsSent","packetsReceived","bytesReceived","bytesSent","googEncodeUsagePercent","audioInputLevel","audioOutputLevel","googDecodingCTN","googDecodingPLC","keyFramesEncoded","keyFramesDecoded","googRtt","concealedSamples","silentConcealedSamples","totalSamplesReceived","healedRatio","jitter","googJitterBufferMs","qpSum","fecPacketsReceived","fecPacketsDiscarded","fecPacketsSent","packetsDiscarded","pushCount","pushErrCount","pullCount","pullErrCount"],l_i=["bytesSent","bytesReceived","googRtt","packetsSent","requestsSent","consentRequestsSent","responsesSent","requestsReceived","responsesReceived"],c_i=["googAvailableReceiveBandwidth","googAvailableSendBandwidth","googTransmitBitrate"];function jd(n,a,s){const c=s.value;s.value=function(...u){try{return c.apply(this,u)}catch(m){this.processStatsError(a,m)}}}var d_i=10,wd=class{constructor(n,a,s,c,u,m){this.logger=n,this.sessionInfo=a,this.configProvider=s,this.mediaManager=c,this.multiparty=u,this.newStatsApi=m,this.statsErrors=[],this.subscribedTrackIds=[],this.iceCandidateErrors=[],this.terminated=!1,this.hwSilent=!1,this.isSpeaking=!1,this.networkSendLevel={quality:"Good"},this.networkRecvLevel={quality:"Good"},this.audioTelemetry=new GCi(this.configProvider),this.cameraOpenResolution={width:0,height:0},this.streamSenderStarted={},this.totalVideoControlMessages=0,this.outOfOrderVideoControlMessages=0,this.subscribedTrackSsrc=[],this.multiViewVideoTelemetry={},this.h264AvailableProfiles=[],this.h264CodecCapabilities={sendProfiles:[],receiveProfiles:[]},this.timeToFirstFrame={},this.timeToFirstFrameSinceSubscriptionStart={},this.missedInitialPreferredResolution={},this.MSIDs=new Set,this.MSIDsPairs={},this.timerTrackerManager=new XKe(this.configProvider.config.enableTimerTracker),this.extensions={WebRTCStats:{},AudioTransportRecvBitrate:0,AudioTransportSendBitrate:0,AudioPayloadSendBitrate:0,AudioPayloadRecvBitrate:0,VideoPayloadSendBitrate:0,VideoPayloadRecvBitrate:0,TimerAudioTransportRecvBitrate:0,TimerAudioTransportSendBitrate:0,TimerAudioPayloadRecvBitrate:0,TimerAudioPayloadSendBitrate:0,TimerVideoPayloadRecvBitrate:0,TimerVideoPayloadSendBitrate:0,StartTime:Date.now(),EndTime:Date.now(),Audio_recv_jitterBufferAvgSize:0,Audio_recv_jitterMax:0,Audio_recv_jitterAvg:0,Audio_send_rttAvg:0,Audio_send_rttMax:0,MaxSessionBandwidth:0,Video_recv_MSIDs:[],Audio_send_presentationUserAPIDuration:"",Audio_send_presentationDuration:""},this.report={type:"WebRtcMediaStats",data:{Extensions:this.extensions}},this.lastSSRCs=new Map,this.videoTelemetry=new Zne(this.extensions.StartTime,this.configProvider,this.logger.createChild("Video"),"Video"),this.sharingTelemetry=new Zne(this.extensions.StartTime,this.configProvider,this.logger.createChild("Sharing"),"ScreenShare"),this.bandwidthTelemetry=new qCi(this.configProvider.config.webrtcBWJumpLowerLimit,this.configProvider.config.webrtcBWJumpUpperLimit),this.stabilizationTelemetry=new MTe(this.configProvider.config.uplinkBWStabilizationSlidingWindowSize,this.configProvider.config.uplinkBWStabilizationMaxDeviation,this.configProvider.config.uplinkBWStabilizationMinBandwidth,Ur),this.storedRecordsNumber=Number(this.configProvider.config.webrtcStatStoredRecordsNumber),this.hwSilentDetectionDuration=Number(this.configProvider.config.webrtcStatHwSilentDetectionDuration),this.hwSilentDetectionLevel=Number(this.configProvider.config.webrtcStatHwSilentDetectionLevel),this.audioHealedRatioTelemetry=new jCi(this.configProvider),this.networkQualityTelemetry=new KCi(this.configProvider,this.newStatsApi,this.audioHealedRatioTelemetry),this.speakingWhileMutedBadDuration=Number(this.configProvider.config.webrtcSpeakingWhileMutedBadDuration),this.speakingWhileMutedDetectionLevel=Number(this.configProvider.config.webrtcSpeakingWhileMutedDetectionLevel),this.videoDelayTimePeriod=this.configProvider.config.webrtcVideoDelayThreshold,this.maxStoredPreferredResolutions=this.configProvider.config.maxStoredPreferredResolutionCount,this.simulcastVideo=new FJe(this.logger.createChild("simulcastVideo"),this.configProvider),this.simulcastSharing=new FJe(this.logger.createChild("simulcastSharing"),this.configProvider)}get currentVideoRecvTrackId(){return this.extensions.WebRTCStats.ssrc_video_recv?.googTrackId}get currentSharingRecvTrackId(){return this.extensions.WebRTCStats.ssrc_sharing_recv?.googTrackId}get isMultiViewVideoTelemetry(){return Object.getOwnPropertyNames(this.multiViewVideoTelemetry).length>0}onDeviceEvent(n){if(n.eventType==="stream_acquired"){const a=n.payload;a.mediaType==="Video"&&(this.cameraOpenResolution=a.resolution)}}onMaxCapabilitiesRequested(n){(n.modality===ke.MODALITY.video?this.videoTelemetry:this.sharingTelemetry).setMaxCapabilitesRequested(n),(n.modality===ke.MODALITY.video?this.simulcastVideo:this.simulcastSharing).setMaxCapabilities(n,!1)}onMaxCapabilitiesApplied(n){(n.modality===ke.MODALITY.video?this.videoTelemetry:this.sharingTelemetry).setMaxCapabilitesApplied(n),(n.modality===ke.MODALITY.video?this.simulcastVideo:this.simulcastSharing).setMaxCapabilities(n,!0)}setSubscribedTrackIds(n){this.subscribedTrackIds=n||[]}setSubscribedTrackSsrc(n){this.subscribedTrackSsrc=n||[]}addSubscriptionEvent(n,a,s,c,u,m,b){const _={evt:n,ts:Date.now()-this.extensions.StartTime,msi:s,localMsi:c,duration:m};u&&(_.error=nn(u));const k=this.getHandlerForModality(a);if(k.addSubscriptionEvent(_),b&&this.setMSIDsPair(s,c,b),n===1||n===3){const N=n===1;k.startStopRecvDataGathering(N)}n===2&&k.prepareCollectingStatsOnSubscribed(s)}setMSIDsPair(n,a,s){const c=`ssrc_${s.replace(/\D/g,"")}_recv`;this.MSIDsPairs[c]={msi:n,localMsi:a}}getHandlerForModality(n){switch(n){case ke.MODALITY.video:return this.videoTelemetry;case ke.MODALITY.sharing:return this.sharingTelemetry;default:throw new Error(`Handler not found for modality: ${n}`)}}setTerminated(){this.extensions.EndTime=new Date().getTime(),this.terminated=!0}startWaitingForStreamStart(n){this.streamStartDetection||this.sessionInfo.setOfferedModalities(n),this.streamStartDetection=!0}processStatsDict(n){if(this.processSimulcastStats(n),this.constructWebRtcReportForSingleStream(this.extensions.WebRTCStats,n),this.streamStartDetection&&(this.setStartTime(this.sessionInfo.offeredModalities)||this.terminated)&&(this.streamStartDetection=!1),Object.keys(this.missedInitialPreferredResolution).length>0&&(this.currentVideoRecvTrackId||this.currentSharingRecvTrackId)&&this.setMissedInitialPreferredResolution(),this.constructWebRTCDataReport(this.extensions.WebRTCStats,n),this.calculateHwSilentState(),this.calculateSpeakingState(),this.setHealedRatioSamples(),this.calculateNetworkRecvQualityLevel(),this.calculateNetworkSendQualityLevel(),this.sessionInfo.activeModalities&&(this.processBandwidthStats(),this.processAudioStats(),this.processVideoStatsRecv(this.videoTelemetry,this.extensions.WebRTCStats.ssrc_video_recv,!0),this.processVideoStatsSend(this.videoTelemetry,this.extensions.WebRTCStats.ssrc_video_send),this.processSharingStats(),this.processStreamsCounters()),this.configProvider.config.enableMultiViewStats){const a=this.extensions.WebRTCStats[ke.MULTIPLE_RECV_STREAMS]?this.extensions.WebRTCStats[ke.MULTIPLE_RECV_STREAMS]:{};this.constructWebRtcReportForMultipleStreams(a,n);for(const s of Object.keys(a)){const c=a[s];this.processVideoStatsRecv(this.multiViewVideoTelemetry[s],c)}this.extensions.WebRTCStats[ke.MULTIPLE_RECV_STREAMS]=a}this.extensions.WebRTCStats.statsErrors=JSON.stringify(this.statsErrors)}setTimeToFirstFrame(n,a,s){s in this.timeToFirstFrame||(this.timeToFirstFrame[s]=n,this.timeToFirstFrameSinceSubscriptionStart[s]=a)}getCurrentTimeToFirstFrame(n){return this.timeToFirstFrame[n]?this.timeToFirstFrame[n]:-1}getCurrentTimeToFirstFrameSinceSubscriptionStart(n){return this.timeToFirstFrameSinceSubscriptionStart[n]?this.timeToFirstFrameSinceSubscriptionStart[n]:-1}getVideoTelemetryBySsrc(n){let a;return this.extensions.WebRTCStats.ssrc_video_recv&&this.extensions.WebRTCStats.ssrc_video_recv.id===n?a=this.videoTelemetry:this.extensions.WebRTCStats.ssrc_sharing_recv&&this.extensions.WebRTCStats.ssrc_sharing_recv.id===n?a=this.sharingTelemetry:this.isMultiViewVideoTelemetry&&(a=this.multiViewVideoTelemetry[n]),a}getIsRendering(n){const a=this.getVideoTelemetryBySsrc(n);return a?a.getIsRendering():void 0}setFreezeDuration(n,a){for(const s of Object.keys(this.multiViewVideoTelemetry))this.multiViewVideoTelemetry[s].trackId===a&&this.isSubscribed(a)&&this.multiViewVideoTelemetry[s].setRecvTotalFreezeDurationMs(n);this.currentSharingRecvTrackId===a&&this.isSubscribed(a)&&this.sharingTelemetry.setRecvTotalFreezeDurationMs(n),this.currentVideoRecvTrackId===a&&this.isSubscribed(a)&&this.videoTelemetry.setRecvTotalFreezeDurationMs(n)}addVideoControlMessage(n){this.totalVideoControlMessages++,n&&this.outOfOrderVideoControlMessages++}setStreamSenderStarted(n,a){this.streamSenderStarted[n]=a}addReportedReceiveBandwidth(n){this.limitCaptureAmount(this.extensions,"ReportedReceiveBandwidth",n)}setHealedRatioSamples(){this.audioHealedRatioTelemetry.captureHealedRatioSamples(this.extensions?.WebRTCStats?.ssrc_audio_recv?.concealedSamples,this.extensions?.WebRTCStats?.ssrc_audio_recv?.silentConcealedSamples,this.extensions?.WebRTCStats?.ssrc_audio_recv?.totalSamplesReceived)}processSimulcastStats(n){this.simulcastVideo.processStats(n),this.simulcastSharing.processStats(n)}processBandwidthStats(){const n=this.extensions.WebRTCStats.bweStat?.googAvailableSendBandwidth;if(n){const a=this.streamSenderStarted.Video||this.streamSenderStarted.ScreenShare;this.bandwidthTelemetry.recordSendBandwidth(n[n.length-1]),this.stabilizationTelemetry.processBandwidth(parseInt(n[n.length-1]),this.sessionInfo.activeModalities,a)}}processAudioStats(){if(this.extensions.WebRTCStats.ssrc_audio_send&&this.limitCaptureAmount(this.extensions,"Audio_send_RawInputVolume",this.audioTelemetry.getInputLevel("Audio")),this.extensions.WebRTCStats.ssrc_audio_recv?.googJitterBufferMs!==void 0&&this.audioTelemetry.captureJitterBuffer((0,NJe.last)(this.extensions.WebRTCStats.ssrc_audio_recv.googJitterBufferMs)),this.extensions.WebRTCStats.ssrc_audio_recv?.jitter!==void 0&&this.audioTelemetry.captureJitter((0,NJe.last)(this.extensions.WebRTCStats.ssrc_audio_recv.jitter)),this.extensions.WebRTCStats.ssrc_audio_send?.googRtt){const n=this.extensions.WebRTCStats.ssrc_audio_send.googRtt;this.audioTelemetry.captureRtt(n[n.length-1])}}stopGatheringIfNeeded(n,a,s,c){const u=`${a}${s}`;c!==this.lastSSRCs.get(u)&&(this.lastSSRCs.set(u,c),a===ke.MEDIA_DIRECTION.SEND?n.stopSendGathering():n.stopRecvGathering())}processVideoStatsSend(n,a){a&&Ur(this.sessionInfo.activeModalities.video)?(this.stopGatheringIfNeeded(n,ke.MEDIA_DIRECTION.SEND,"Video",a.ssrc),n.captureMediaData(ke.MEDIA_DIRECTION.SEND,a.googFrameRateSent,a.framesEncoded),n.captureFrameRate(a.googFrameRateInput),n.analyzeDelay(this.videoDelayTimePeriod,a.googAvgEncodeMs),n.captureQpData(ke.MEDIA_DIRECTION.SEND,a.qpSum,a.framesEncoded),n.captureBitrateSample(ke.MEDIA_DIRECTION.SEND,this.getLastSampleInt(a.bytesSent)),n.detectCaptureFreeze(a.googFrameRateInput),n.captureAllocateBandwidth(this.extensions.WebRTCStats.bweStat?.googAvailableSendBandwidth),n.setCurrentParameters(parseInt(a.ssrc),{width:this.getLastSampleInt(a.googFrameWidthSent),height:this.getLastSampleInt(a.googFrameHeightSent)},this.getLastSampleInt(a.googFrameRateSent)),n.setQualityLimitationReason(a.qualityLimitationReason),this.configProvider.config.specCompliantSimulcast?.collectResolutionInfo&&n.calculateResolutinSwitches(this.getLastSampleInt(a.googFrameWidthSent),this.getLastSampleInt(a.googFrameHeightSent))):n.isSendGathering()&&(n.stopSendGathering(),this.lastSSRCs.delete(`${ke.MEDIA_DIRECTION.SEND}Video`))}processVideoStatsRecv(n,a,s=!1){a&&Rc(this.sessionInfo.activeModalities.video)&&this.videoTelemetry.isRecvDataGatheringEnabled?(s&&this.stopGatheringIfNeeded(n,ke.MEDIA_DIRECTION.RECV,"Video",a.ssrc),n.trackId=a.googTrackId,n.gatherRecvFreezeData(a.googFrameRateDecoded,a.googFrameRateReceived,this.getLastSampleInt(a.bytesReceived)),n.captureMediaData(ke.MEDIA_DIRECTION.RECV,a.googFrameRateReceived,a.googFrameRateDecoded),n.captureTimeToFirstFrame(this.getCurrentTimeToFirstFrame(a.googTrackId),this.getCurrentTimeToFirstFrameSinceSubscriptionStart(a.googTrackId)),n.captureQpData(ke.MEDIA_DIRECTION.RECV,a.qpSum,a.framesDecoded),n.captureBitrateSample(ke.MEDIA_DIRECTION.RECV,this.getLastSampleInt(a.bytesReceived)),n.captureResolutionSample({width:this.getLastSampleInt(a.googFrameWidthReceived),height:this.getLastSampleInt(a.googFrameHeightReceived)}),n.captureStatsOnSubscribed(this.getLastSampleInt(a.framesDecoded),this.getLastSampleInt(a.bytesReceived))):s&&this.lastSSRCs.delete(`${ke.MEDIA_DIRECTION.RECV}Video`)}processSharingStats(){const n=this.extensions.WebRTCStats.ssrc_sharing_send,a=this.extensions.WebRTCStats.ssrc_sharing_recv;n&&Ur(this.sessionInfo.activeModalities.sharing)?(this.stopGatheringIfNeeded(this.sharingTelemetry,ke.MEDIA_DIRECTION.SEND,"Sharing",n.ssrc),this.sharingTelemetry.captureMediaData(ke.MEDIA_DIRECTION.SEND,n.googFrameRateSent,n.framesEncoded),this.sharingTelemetry.captureFrameRate(n.googFrameRateInput),this.sharingTelemetry.analyzeDelay(this.videoDelayTimePeriod,n.googAvgEncodeMs),this.sharingTelemetry.captureQpData(ke.MEDIA_DIRECTION.SEND,n.qpSum,n.framesEncoded),this.sharingTelemetry.captureBitrateSample(ke.MEDIA_DIRECTION.SEND,this.getLastSampleInt(n.bytesSent)),this.sharingTelemetry.detectCaptureFreeze(n.googFrameRateInput),this.sharingTelemetry.captureAllocateBandwidth(this.extensions.WebRTCStats.bweStat?.googAvailableSendBandwidth),this.sharingTelemetry.setCurrentParameters(parseInt(n.ssrc),{width:this.getLastSampleInt(n.googFrameWidthSent),height:this.getLastSampleInt(n.googFrameHeightSent)},this.getLastSampleInt(n.googFrameRateSent)),this.limitCaptureAmount(this.extensions,"Sharing_send_RawInputVolume",this.audioTelemetry.getInputLevel("ScreenShare"))):this.sharingTelemetry.isSendGathering()&&(this.sharingTelemetry.stopSendGathering(),this.lastSSRCs.delete(`${ke.MEDIA_DIRECTION.SEND}Sharing`)),a&&Rc(this.sessionInfo.activeModalities.sharing)&&this.sharingTelemetry.isRecvDataGatheringEnabled?(this.stopGatheringIfNeeded(this.sharingTelemetry,ke.MEDIA_DIRECTION.RECV,"Sharing",a.ssrc),this.sharingTelemetry.trackId=a.googTrackId,this.sharingTelemetry.gatherRecvFreezeData(a.googFrameRateDecoded,a.googFrameRateReceived),this.sharingTelemetry.captureMediaData(ke.MEDIA_DIRECTION.RECV,a.googFrameRateReceived,a.googFrameRateDecoded),this.sharingTelemetry.captureTimeToFirstFrame(this.getCurrentTimeToFirstFrame(a.googTrackId),this.getCurrentTimeToFirstFrameSinceSubscriptionStart(a.googTrackId)),this.sharingTelemetry.captureQpData(ke.MEDIA_DIRECTION.RECV,a.qpSum,a.framesDecoded),this.sharingTelemetry.captureBitrateSample(ke.MEDIA_DIRECTION.RECV,this.getLastSampleInt(a.bytesReceived)),this.sharingTelemetry.captureResolutionSample({width:this.getLastSampleInt(a.googFrameWidthReceived),height:this.getLastSampleInt(a.googFrameHeightReceived)}),this.sharingTelemetry.captureStatsOnSubscribed(this.getLastSampleInt(a.framesDecoded),this.getLastSampleInt(a.bytesReceived))):this.lastSSRCs.delete(`${ke.MEDIA_DIRECTION.RECV}Sharing`)}processStreamsCounters(){const n=this.extensions.WebRTCStats.recvCounters;n&&(this.videoTelemetry.countRecvStreams(n[ke.MODALITY.video]),this.sharingTelemetry.countRecvStreams(n[ke.MODALITY.sharing]))}setMissedInitialPreferredResolution(){Ng(this.missedInitialPreferredResolution,(n,a)=>{this.setPreferredResolution(a,n)}),this.missedInitialPreferredResolution={}}setPreferredResolution(n,a,s){if((s===ke.MEDIA_TYPE.video&&!this.currentVideoRecvTrackId||s===ke.MEDIA_TYPE.sharing&&!this.currentSharingRecvTrackId)&&(this.missedInitialPreferredResolution[n]=a),this.currentVideoRecvTrackId===n&&this.videoTelemetry.capturePreferredResolution(a,this.maxStoredPreferredResolutions),this.currentSharingRecvTrackId===n&&this.sharingTelemetry.capturePreferredResolution(a,this.maxStoredPreferredResolutions),this.isMultiViewVideoTelemetry){const c=this.multiViewVideoTelemetry[this.getSsrcIdFromMultipleVideoStream(n)];c&&c.capturePreferredResolution(a,this.maxStoredPreferredResolutions)}}setIsRendering(n,a,s){a===ke.MEDIA_TYPE.video&&this.videoTelemetry.setIsRendering(n),a===ke.MEDIA_TYPE.sharing&&this.sharingTelemetry.setIsRendering(n),this.isMultiViewVideoTelemetry&&this.multiViewVideoTelemetry[this.getSsrcIdFromMultipleVideoStream(s)]?.setIsRendering(n)}setMaxSessionBandwidth(n){this.extensions.MaxSessionBandwidth=n}isSubscribed(n,a){let s=this.subscribedTrackIds.some(c=>c===n);return!s&&this.configProvider.config.subscribeToSsrcForVideo&&(s=this.subscribedTrackSsrc.some(c=>c===`${a}`)),s||!this.multiparty&&this.configProvider.config.subscribeToSsrcForVideo}getReport(n=!1,a=!1){try{a&&this.resetPairValues(),n||(this.videoTelemetry.stopDataGathering(),this.sharingTelemetry.stopDataGathering());const s=this.videoTelemetry.getTotalDuration(ke.MEDIA_DIRECTION.RECV),c=this.videoTelemetry.getTotalDuration(ke.MEDIA_DIRECTION.SEND),u=this.sharingTelemetry.getTotalDuration(ke.MEDIA_DIRECTION.RECV),m=this.sharingTelemetry.getTotalDuration(ke.MEDIA_DIRECTION.SEND);if(s>=0&&(Ng(this.videoTelemetry.getReport(ke.MEDIA_DIRECTION.RECV,"Video_recv_",a),(b,_)=>this.extensions[_]=b),!Am(this.multiViewVideoTelemetry))){const b=[];for(const _ of Object.keys(this.multiViewVideoTelemetry)){const k={id:_};Ng(this.multiViewVideoTelemetry[_].getReport(ke.MEDIA_DIRECTION.RECV,"Video",a),(N,W)=>{N!==void 0&&(k[W]=N)}),b.push(k)}this.extensions[ke.MULTIPLE_RECV_STREAMS]=JSON.stringify(b)}u>=0&&Ng(this.sharingTelemetry.getReport(ke.MEDIA_DIRECTION.RECV,"Sharing_recv_",a),(b,_)=>this.extensions[_]=b),c>=0&&(Ng(this.videoTelemetry.getReport(ke.MEDIA_DIRECTION.SEND,"Video_send_",a),(b,_)=>this.extensions[_]=b),this.extensions.Bandwidth_jumpsHistogram=JSON.stringify(this.bandwidthTelemetry.getReport()),this.extensions.Bandwidth_uplinkStabilizationTime=JSON.stringify(this.stabilizationTelemetry.getReport(!0)),this.extensions.Video_send_CameraOpenWidth=this.cameraOpenResolution.width,this.extensions.Video_send_CameraOpenHeight=this.cameraOpenResolution.height),m>=0&&Ng(this.sharingTelemetry.getReport(ke.MEDIA_DIRECTION.SEND,"Sharing_send_",a),(b,_)=>this.extensions[_]=b),n||a||(this.simulcastVideo.finish(),this.extensions.Video_send_Simulcast=JSON.stringify(this.simulcastVideo.collectedSessions),this.simulcastSharing.finish(),this.extensions.Sharing_send_Simulcast=JSON.stringify(this.simulcastSharing.collectedSessions)),this.iceCandidateErrors.length>0&&(this.extensions.iceCandidateErrors=JSON.stringify(this.iceCandidateErrors)),this.extensions.Audio_recv_jitterBufferAvgSize=this.audioTelemetry.getAvgJitterBuffer(),this.extensions.Audio_recv_jitterMax=this.audioTelemetry.getJitterMax(),this.extensions.Audio_recv_jitterAvg=this.audioTelemetry.getJitterAvg(),this.extensions.Video_SubscriptionEvents=a?"":JSON.stringify(this.videoTelemetry.getSubscriptionEvents()),this.extensions.Video_SubscriptionCounters=a?"":JSON.stringify(this.videoTelemetry.getSubscriptionCounters()),this.extensions.Sharing_SubscriptionEvents=a?"":JSON.stringify(this.sharingTelemetry.getSubscriptionEvents()),this.extensions.Sharing_SubscriptionCounters=a?"":JSON.stringify(this.sharingTelemetry.getSubscriptionCounters()),this.extensions.Audio_recv_healedRatioMax=this.audioHealedRatioTelemetry.getHealedRatioMax(),this.extensions.Audio_recv_healedRatioAvg=this.audioHealedRatioTelemetry.getHealedRatioAvg(),this.extensions.Audio_send_rttAvg=this.audioTelemetry.getAvgRtt(),this.extensions.Audio_send_rttMax=this.audioTelemetry.getMaxRtt();for(const b of Object.keys(this.extensions))this.extensions[b]===void 0&&delete this.extensions[b];return delete this.extensions.WebRTCStats[ke.MULTIPLE_RECV_STREAMS],this.sessionInfo.fillExtensionInfo(this.extensions),Object.keys(this.extensions.WebRTCStats).length>0&&!this.extensions.WebRTCStats.hasStatsError&&this.calculateAverages(),this.extensions.H264_available_profiles=this.h264AvailableProfiles.join(),this.extensions.H264_codec_capabilities=JSON.stringify(this.h264CodecCapabilities),this.extensions.Video_recv_MSIDs=Array.from(this.MSIDs),this.totalVideoControlMessages>0&&(this.extensions.totalVideoControlMessages=this.totalVideoControlMessages,this.extensions.outOfOrderVideoControlMessages=this.outOfOrderVideoControlMessages),fs(this.report)}catch(s){throw this.processStatsError("Report",s),{error:s,partialReport:fs(this.report)}}}getAudioHwSilent(){return this.hwSilent}getSpeakingState(){return this.isSpeaking}getNetworkSendLevel(){return this.networkSendLevel}getNetworkRecvLevel(){return this.networkRecvLevel}addIceCandidateError(n){this.iceCandidateErrors.push(n)}clearIceCandidateErrors(){this.iceCandidateErrors=[]}addH264AvailableProfiles(n){this.h264AvailableProfiles=[...new Set(this.h264AvailableProfiles.concat(n))]}setSupportedH264Profiles(n,a){this.h264CodecCapabilities.sendProfiles=n,this.h264CodecCapabilities.receiveProfiles=a}updateSendStream(n,a){this.audioTelemetry.updateSendStream(n,a)}getTimerTracker(n,a){return this.timerTrackerManager.getTimerTracker(n,a)}resetPairValues(){Object.keys(this.extensions.WebRTCStats).forEach(n=>{delete this.extensions.WebRTCStats[n].pair})}limitCaptureAmount(n,a,s){s!==void 0&&(n[a]=Array.isArray(n[a])?n[a]:[],n[a].push(s),n[a].length>this.storedRecordsNumber&&n[a].shift())}setStartTime(n){const a=this.extensions.WebRTCStats;if(!a.ssrc_audio_send||!a.ssrc_audio_recv)return!1;const s=(c,u)=>!c||u&&u===-1?u:new Date().getTime();return this.extensions.TimerAudioPayloadRecvBitrate=Rc(n.audio)?s(a.ssrc_audio_recv.bytesReceived,this.extensions.TimerAudioPayloadRecvBitrate):-1,this.extensions.TimerAudioPayloadSendBitrate=Ur(n.audio)?s(a.ssrc_audio_send.bytesSent,this.extensions.TimerAudioPayloadSendBitrate):-1,this.extensions.TimerAudioTransportRecvBitrate=Rc(n.audio)?s(a.ssrc_audio_recv.bytesReceived,this.extensions.TimerAudioTransportRecvBitrate):-1,this.extensions.TimerAudioTransportSendBitrate=Ur(n.audio)?s(a.ssrc_audio_send.bytesSent,this.extensions.TimerAudioTransportSendBitrate):-1,!!(a.ssrc_video_send&&a.ssrc_video_recv&&(this.extensions.TimerVideoPayloadRecvBitrate=Rc(n.video)?s(a.ssrc_video_recv.bytesReceived,this.extensions.TimerVideoPayloadRecvBitrate):-1,this.extensions.TimerVideoPayloadSendBitrate=Ur(n.video)?s(a.ssrc_video_send.bytesSent,this.extensions.TimerVideoSendBitrate):-1,this.extensions.TimerVideoPayloadRecvBitrate&&this.extensions.TimerVideoPayloadSendBitrate&&this.extensions.TimerAudioPayloadRecvBitrate&&this.extensions.TimerAudioPayloadSendBitrate&&this.extensions.TimerAudioTransportRecvBitrate&&this.extensions.TimerAudioTransportSendBitrate))}calculateAverages(){const n=this.extensions.EndTime,a=(c,u)=>c&&n-u>0&&u!==0&&u!==-1?Math.round(8*c/(n-u)):0,s=c=>{const u=c.split(".").reduce((m,b)=>m==null?m:m[b],this.extensions.WebRTCStats);return Array.isArray(u)?u[u.length-1]:u};this.extensions.AudioPayloadRecvBitrate=a(s("ssrc_audio_recv.bytesReceived"),this.extensions.TimerAudioPayloadRecvBitrate),this.extensions.AudioPayloadSendBitrate=a(s("ssrc_audio_send.bytesSent"),this.extensions.TimerAudioPayloadSendBitrate),this.extensions.VideoPayloadRecvBitrate=a(s("ssrc_video_recv.bytesReceived"),this.extensions.TimerVideoPayloadRecvBitrate),this.extensions.VideoPayloadSendBitrate=a(s("ssrc_video_send.bytesSent"),this.extensions.TimerVideoPayloadSendBitrate),this.extensions.AudioTransportRecvBitrate=a(s("ssrc_audio_send.pair.bytesReceived"),this.extensions.TimerAudioTransportRecvBitrate),this.extensions.AudioTransportSendBitrate=a(s("ssrc_audio_send.pair.bytesSent"),this.extensions.TimerAudioTransportSendBitrate)}addFilteredFields(n,a,s=[]){for(const c in a)if(a.hasOwnProperty(c)&&c!=="type")if(s.indexOf(c)!==-1){const u=n[c]||[];u.push(this.formatFields(a,c)),u.length>this.storedRecordsNumber&&u.shift(),n[c]||(n[c]=u)}else n[c]=a[c]}formatFields(n,a){const s=n[a];switch(a){case"audioInputLevel":case"audioOutputLevel":return this.newStatsApi?Math.floor(65535*s):2*s;case"googJitterBufferMs":return parseInt(s);case"healedRatio":return oa(parseFloat(s),this.configProvider.config.healedRatioPrecision);case"jitter":return oa(parseFloat(s),this.configProvider.config.jitterPrecision);default:return s}}processSource(n,a,s){let c;if(this.addFilteredFields(n,a,s_i),a.transportId){const u=s.googComponent?.[a.transportId];n.transport||(n.transport={}),u&&(this.addFilteredFields(n.transport,u),u.selectedCandidatePairId&&(c=s.googCandidatePair?.[u.selectedCandidatePairId]))}else c=Object.values(s.googCandidatePair).find(u=>u.selected);c&&(n.pair||(n.pair={}),this.addFilteredFields(n.pair,c,l_i))}getWebrtcReport(n,a,s,c){const u=n.ssrc[s],m=c?u.id.replace(/[0-9]+/,c):u.id;a[m]?u.ssrc!==a[m].ssrc&&(m.endsWith("video_send")?this.videoTelemetry.stopSendGathering():m.endsWith("video_recv")?this.videoTelemetry.stopRecvGathering():m.endsWith("sharing_send")?this.sharingTelemetry.stopSendGathering():m.endsWith("sharing_recv")&&this.sharingTelemetry.stopRecvGathering()):a[m]={},this.processSource(a[m],u,n)}constructWebRTCDataReport(n,a){if(!a.data?.length)return;const s=a.data.sort((u,m)=>m.timestamp-u.timestamp),c=s.find(u=>u.state==="open");n.data=c||s[0]}constructWebRtcReportForSingleStream(n,a){if(!a.ssrc)return;const s=this.selectSsrcsToCollect(a.ssrc);n.recvCounters=s.recvCounters,delete s.recvCounters,delete s.multiRecv,Ng(s,c=>{Ng(c,(u,m)=>{this.getWebrtcReport(a,n,u,m)})}),a.VideoBwe?.bweforvideo&&(n.bweStat||(n.bweStat={}),this.addFilteredFields(n.bweStat,a.VideoBwe.bweforvideo,c_i))}constructWebRtcReportForMultipleStreams(n,a){a.ssrc&&this.selectSsrcsToCollect(a.ssrc).multiRecv.forEach(s=>this.getWebrtcReport(a,n,s))}getMediaType(n,a){let s=a?a.getModality():n.mediaType;return n.googTrackId?.match("applicationsharing")&&s!==ke.MEDIA_TYPE.sharing&&(s=ke.MEDIA_TYPE.sharing),s}selectSsrcsToCollect(n){const a={send:{},recv:{},recvCounters:{video:0,sharing:0},multiRecv:[]};if(!this.sessionInfo.activeModalities)return a;let s=[];for(const c of Object.keys(n)){const u=n[c],m=u.googTrackId;if(!m&&u.mediaType!==ke.MEDIA_TYPE.audio)continue;const b=this.getMediaEntity(m,u),_=this.getMediaType(u,b),k=b?.getXSourceStreamId();if(c.endsWith("send"))switch(_){case ke.MEDIA_TYPE.audio:Ur(this.sessionInfo.activeModalities.audio)&&(a.send.audio=c);break;case ke.MEDIA_TYPE.video:if(this.extensions.Video_send_SourceId=k,this.simulcastVideo.highestFidelitySSRC){this.simulcastVideo.highestFidelitySSRC===u.ssrc&&(a.send.video=c);break}this.streamSenderStarted.Video&&Ur(this.sessionInfo.activeModalities.video)&&b?.getLocalTrackId()&&(b?.getLocalTrackId()===u.googTrackId||this.configProvider.config.statsAllowAnyVideoSendTrack&&!a.send.video)&&(!u.rid||u.rid==="1")&&(a.send.video=c);break;case ke.MEDIA_TYPE.sharing:if(this.simulcastSharing.highestFidelitySSRC){this.simulcastSharing.highestFidelitySSRC===u.ssrc&&(a.send.sharing=c);break}this.streamSenderStarted.ScreenShare&&Ur(this.sessionInfo.activeModalities.sharing)&&b?.getLocalTrackId()===u.googTrackId&&(a.send.sharing=c);break;default:this.logger.warn(`Unknown media type '${_}'`)}else if(c.endsWith("recv"))switch(_){case ke.MEDIA_TYPE.audio:Rc(this.sessionInfo.activeModalities.audio)&&(a.recv.audio=c);break;case ke.MEDIA_TYPE.video:k!==void 0&&this.MSIDs.add(k),this.isSubscribed(u.googTrackId,u.ssrc)&&Rc(this.sessionInfo.activeModalities.video)&&(s.push(u),+u.googFrameRateReceived>0&&a.recvCounters[ke.MODALITY.video]++);break;case ke.MEDIA_TYPE.sharing:this.isSubscribed(u.googTrackId,u.ssrc)&&Rc(this.sessionInfo.activeModalities.sharing)&&(a.recv.sharing=c,+u.googFrameRateReceived>0&&a.recvCounters[ke.MODALITY.sharing]++);break;default:this.logger.warn(`Unknown media type '${_}'`)}}if(s.length>0){s=s.sort((u,m)=>+m.googFrameHeightReceived-+u.googFrameHeightReceived);const c=s.find(u=>u.mediaType===ke.MEDIA_TYPE.video);c&&(a.recv.video=c.id),this.multiparty&&this.configProvider.config.enableMultiViewStats&&(a.multiRecv=s.map(u=>u.id),a.multiRecv.forEach(u=>{this.multiViewVideoTelemetry[u]||(this.multiViewVideoTelemetry[u]=new Zne(this.extensions.StartTime,this.configProvider,this.logger.createChild(`Video[${u}]`,"Video")),this.multiViewVideoTelemetry[u].setMsi(this.MSIDsPairs[u]?.msi),this.multiViewVideoTelemetry[u].setLocalMsi(this.MSIDsPairs[u]?.localMsi),this.multiViewVideoTelemetry[u].prepareCollectingStatsOnSubscribed(this.MSIDsPairs[u]?.msi))}))}return a}getMediaEntityForTrack(n){if(n)return this.mediaManager.getMediaEntities().find(a=>a.getLocalTrackId()===n||a.getRemoteTrackId()===n)}getMediaEntityByRemoteSsrc(n){if(n)return this.mediaManager.getMediaEntities().find(a=>a.getRemoteSsrc()===+n)}getMediaEntity(n,a){const s=`${a.ssrc}`,c=a.id;let u=this.getMediaEntityForTrack(n);return!u&&this.configProvider.config.subscribeToSsrcForVideo&&c.endsWith("recv")&&(u=this.getMediaEntityByRemoteSsrc(s)),u}calculateHwSilentState(){const n=this.extensions.WebRTCStats.ssrc_audio_send?.audioInputLevel;if(!n||n.length<2*this.hwSilentDetectionDuration)return;let a=!0;for(let s=n.length-this.hwSilentDetectionDuration-1;s<n.length;s++)if(n[s]>this.hwSilentDetectionLevel){a=!1;break}this.hwSilent!==a&&(this.hwSilent=a,this.logger.safe.info(`HW silent changed to ${this.hwSilent}`))}calculateSpeakingState(){const n=this.newStatsApi&&this.configProvider.config.useAudioAnalyzer?this.extensions.Audio_send_RawInputVolume:this.extensions.WebRTCStats.ssrc_audio_send?.audioInputLevel;if(!n||n.length<=this.speakingWhileMutedBadDuration)return;let a=!1;for(let s=n.length-this.speakingWhileMutedBadDuration;s<n.length;s++)if(n[s]>this.speakingWhileMutedDetectionLevel){a=!0;break}this.isSpeaking=a}calculateNetworkRecvQualityLevel(){this.configProvider.config.enableNetworkRecvQualityUFD&&this.extensions.WebRTCStats.ssrc_audio_recv&&(this.networkRecvLevel=this.networkQualityTelemetry.calculateNetworkRecvQualityLevel({googDecodingCTN:this.extensions.WebRTCStats.ssrc_audio_recv.googDecodingCTN??[],googDecodingPLC:this.extensions.WebRTCStats.ssrc_audio_recv.googDecodingPLC??[],concealedSamples:this.extensions.WebRTCStats.ssrc_audio_recv.concealedSamples??[],silentConcealedSamples:this.extensions.WebRTCStats.ssrc_audio_recv.silentConcealedSamples??[],totalSamplesReceived:this.extensions.WebRTCStats.ssrc_audio_recv.totalSamplesReceived??[],oldNetworkLevel:this.networkRecvLevel.quality}))}calculateNetworkSendQualityLevel(){this.extensions.WebRTCStats.ssrc_audio_send&&(this.networkSendLevel=this.networkQualityTelemetry.calculateNetworkSendQualityLevel(this.extensions.WebRTCStats.ssrc_audio_send.packetsSent,this.extensions.WebRTCStats.ssrc_audio_send.packetsLost,this.extensions.WebRTCStats.ssrc_audio_send.jitter,this.networkSendLevel.quality))}processStatsError(n,a){const s=nn(a);this.logger.safe.error(`webrtcStatistics error [${n}]: ${s}`);const c=this.statsErrors.find(u=>u.error===s&&u.origin===n);c?c.count++:this.statsErrors.push({origin:n,error:s,count:1}),this.statsErrors.length>d_i&&this.statsErrors.splice(1)}getLastSampleInt(n){return typeof n=="number"?n:n&&parseInt(n[n.length-1])||0}getSsrcIdFromMultipleVideoStream(n){let a;const s=this.extensions.WebRTCStats[ke.MULTIPLE_RECV_STREAMS]||{};for(const c in s){const u=s[c];if(u&&u.googTrackId===n){a=c;break}}return a}};Kt([jd],wd.prototype,"onDeviceEvent"),Kt([jd],wd.prototype,"onMaxCapabilitiesRequested"),Kt([jd],wd.prototype,"onMaxCapabilitiesApplied"),Kt([jd],wd.prototype,"addSubscriptionEvent"),Kt([jd],wd.prototype,"processSimulcastStats"),Kt([jd],wd.prototype,"processBandwidthStats"),Kt([jd],wd.prototype,"processAudioStats"),Kt([jd],wd.prototype,"processVideoStatsSend"),Kt([jd],wd.prototype,"processVideoStatsRecv"),Kt([jd],wd.prototype,"processSharingStats"),Kt([jd],wd.prototype,"processStreamsCounters"),Kt([jd],wd.prototype,"setMissedInitialPreferredResolution"),Kt([jd],wd.prototype,"setPreferredResolution"),Kt([jd],wd.prototype,"setIsRendering"),Kt([jd],wd.prototype,"setMaxSessionBandwidth"),Kt([jd],wd.prototype,"setStartTime"),Kt([jd],wd.prototype,"calculateAverages"),Kt([jd],wd.prototype,"addFilteredFields"),Kt([jd],wd.prototype,"formatFields"),Kt([jd],wd.prototype,"processSource"),Kt([jd],wd.prototype,"getWebrtcReport"),Kt([jd],wd.prototype,"constructWebRTCDataReport"),Kt([jd],wd.prototype,"constructWebRtcReportForSingleStream"),Kt([jd],wd.prototype,"constructWebRtcReportForMultipleStreams"),Kt([jd],wd.prototype,"selectSsrcsToCollect"),Kt([jd],wd.prototype,"calculateHwSilentState"),Kt([jd],wd.prototype,"calculateSpeakingState"),Kt([jd],wd.prototype,"calculateNetworkRecvQualityLevel"),Kt([jd],wd.prototype,"calculateNetworkSendQualityLevel");var u_i="VideoBwe",h_i="bweforvideo",p_i="googAvailableReceiveBandwidth",g_i="googAvailableSendBandwidth",m_i="mediaType",f_i="framesDecoded",v_i="googFrameRateDecoded",y_i="googFrameRateReceived",S_i="googFrameRateInput",b_i="googTrackId";function T_i(n){const a={};return n.result().forEach(s=>{s.names().forEach(c=>{a[s.type]=a[s.type]||{},a[s.type][s.id]=a[s.type][s.id]||{},a[s.type][s.id][c]=s.stat(c)}),a[s.type][s.id].id=s.id}),a}var C_i=class extends jr{constructor(n,a,s,c){super(),this.logger=n,this.configProvider=a,this.mediaManager=s,this.window=Cc.window,this._sessionInfo=new vTi,this.statisticsMapper=new HCi,this.useNewStatsApi=this.configProvider.config.webrtcUseNewStatsApi&&this.configProvider.mediaConfig.simulcastSessionEnabled,this.webRtcStatistics=new wd(this.logger.createChild("WebrtcStatistics"),this._sessionInfo,this.configProvider,s,c,this.useNewStatsApi)}setAudioDecoderStatsProvider(n){this.statisticsMapper?.setAudioDecoderStatsProvider(n)}setAudioEncoderCodecName(n){this.statisticsMapper?.setAudioEncoderCodecName(n)}get sessionInfo(){return this._sessionInfo}get isDisposed(){return this.pc===null&&this.interval===0}initialize(n){this.pc=n}startWaitingForStreamStart(n){this.webRtcStatistics.startWaitingForStreamStart(n)}onDeviceEvent(n){this.webRtcStatistics.onDeviceEvent(n)}onMaxCapabilitiesRequested(n){this.webRtcStatistics.onMaxCapabilitiesRequested(n)}onMaxCapabilitiesApplied(n){this.webRtcStatistics.onMaxCapabilitiesApplied(n)}onSendersChanged(n,a){this.webRtcStatistics.setStreamSenderStarted(n,a)}addSubscriptionEvent(n,a,s,c,u,m,b){this.webRtcStatistics.addSubscriptionEvent(n,a,s,c,u,m,b)}setSubscribedTrackIds(n){this.webRtcStatistics.setSubscribedTrackIds(n)}setSubscribedTrackSsrc(n){this.webRtcStatistics.setSubscribedTrackSsrc(n)}setPreferredResolution(n,a,s){this.webRtcStatistics.setPreferredResolution(n,a,s)}setIsRendering(n,a,s){this.webRtcStatistics.setIsRendering(n,a,s)}setMaxSessionBandwidth(n){this.webRtcStatistics.setMaxSessionBandwidth(n)}setTerminated(){this.webRtcStatistics.setTerminated()}addIceCandidateError(n){this.webRtcStatistics.addIceCandidateError(n)}clearIceCandidateErrors(){this.webRtcStatistics.clearIceCandidateErrors()}updateSendStream(n,a){this.webRtcStatistics.updateSendStream(n,a)}getTimerTracker(n,a){return this.webRtcStatistics.getTimerTracker(n,a)}setH264AvailableProfiles(n){if(!n?.codecs)return;let a=[];n.codecs.forEach(s=>{if(s.mimeType==="h264"&&s.sdpFmtpLine){const c=/profile-level-id=(.{6})/.exec(s.sdpFmtpLine);c?.[1]&&(a=a.concat(c[1]))}}),this.webRtcStatistics.addH264AvailableProfiles(a)}setSupportedH264Profiles(n,a){if(!n?.codecs&&!a?.codecs)return;const s=m=>{const b=[];return m.codecs?.forEach(_=>{if(_.mimeType==="h264"&&_.sdpFmtpLine){const k=/profile-level-id=(.{6})/.exec(_.sdpFmtpLine)?.[1];k&&!b.includes(k)&&b.push(k)}}),b},c=s(n),u=s(a);this.webRtcStatistics.setSupportedH264Profiles(c,u)}processRawReport(n){this.processStatsDict(this.statisticsMapper.build(n))}processLegacyReport(n){this.processStatsDict(T_i(n))}getReport(n,a=!1){const s=this.webRtcStatistics.getReport(n,a);return this.addStreamInfoForE2ETests(s),s}dispose(){this.interval&&(this.window.clearInterval(this.interval),this.interval=0),this.pc=null}getLastStatistics(){return this.statistics}setTimeToFirstFrame(n,a,s){this.webRtcStatistics.setTimeToFirstFrame(n,a,s)}setFreezeDuration(n,a){this.webRtcStatistics.setFreezeDuration(n,a)}addVideoControlMessage(n=!1){this.webRtcStatistics.addVideoControlMessage(n)}setSsrcTrackPair(n,a){this.statisticsMapper.setSsrcTrackPair(n,a)}updateStatsWithLocalSsrcTrackInfo(){for(const n of this.mediaManager.getMediaEntities()){const a=n.getLocalSsrc();a&&this.statisticsMapper.setSsrcTrackPair(a,n.getLocalTrackId())}}addReportedReceiveBandwidth(n){this.webRtcStatistics.addReportedReceiveBandwidth(n)}addStreamInfoForE2ETests(n){const a=this._sessionInfo.negotiatedModalities;if(a&&!this.isDisposed)try{n.localStreams=this.getSendersReport(this.pc.getSenders(),{audio:Ur(a.audio),video:Ur(a.video)}),n.remoteStreams=this.getReceiversReport(this.pc.getReceivers(),{audio:Rc(a.audio),video:Rc(a.video)})}catch(s){this.logger.safe.warn(`addStreamInfoForE2ETests failed: ${nn(s)}`)}}getReceiversReport(n,a){const s=[];return n.forEach(c=>{const u={tracks:[]};s.push(u),c.track&&(c.track.kind==="audio"&&a.audio||c.track.kind==="video"&&a.video)&&u.tracks.push({stream:void 0,track:c.track})}),s}getSendersReport(n,a){const s=[],c={tracks:[]};return s.push(c),n.forEach(u=>{u.track&&(u.track.kind==="audio"&&a.audio||u.track.kind==="video"&&a.video)&&c.tracks.push({stream:void 0,track:u.track})}),s}processStatsDict(n){this.webRtcStatistics.processStatsDict(n);let a=0,s=0;const c=n[u_i]?.[h_i];c&&(a=Number(c[p_i]),s=Number(c[g_i]));const u=1e3*((this.configProvider.mediaConfig.maxBandwidthInKbps||Math.floor(Number.MAX_SAFE_INTEGER/1e3))-(this.configProvider.config.audioBandwidthInKbps||0)),m=isNaN(a)?0:a,b=isNaN(s)?0:s,_={estimatedReceiveBandwidth:Math.min(m,u),estimatedSendBandwidth:Math.min(b,u),remoteVideoStreams:{},localVideoStreams:{},isSpeaking:this.webRtcStatistics.getSpeakingState(),audioHwSilent:this.webRtcStatistics.getAudioHwSilent(),networkSendLevel:this.webRtcStatistics.getNetworkSendLevel(),networkRecvLevel:this.webRtcStatistics.getNetworkRecvLevel()};Ng(n.ssrc,k=>{if(k[m_i]!=="video")return;const N=k[b_i],W=k.id;W.indexOf("_recv")!==-1?(_.remoteVideoStreams[N]={trackId:N,frameRateReceived:Number(k[y_i]),frameRateDecoded:Number(k[v_i]),framesDecoded:Number(k[f_i])},this.configProvider.config.isRenderingBasedOnRawStatistics||(_.remoteVideoStreams[N].isRendering=this.webRtcStatistics.getIsRendering(W))):N&&W.indexOf("_send")!==-1&&(_.localVideoStreams[N]={trackId:N,ssrc:Number(k.ssrc),frameRateInput:Number(k[S_i])})}),xc(this.statistics,_)||(this.statistics=_,this.notifyStatisticsChanged())}notifyStatisticsChanged(){this.event("onStatisticsChanged").raise(this.statistics)}},UJe=class extends jr{constructor(n,a,s,c,u){super(),this.logger=n,this.configProvider=a,this.diagnostics=s,this.mediaManager=c,this.window=Cc.window,this.useNewStatsApi=this.configProvider.config.webrtcUseNewStatsApi&&this.configProvider.mediaConfig.simulcastSessionEnabled,this.loopIntervalTracker=new S$(this.configProvider.config.diagnostics.performanceMonitoring.fluctuationSamplesNum),this.loopIntervalAggregator=new FWe,this.fetchTimeTracker=new S$(this.configProvider.config.diagnostics.performanceMonitoring.fluctuationSamplesNum),this.fetchTimeAggregator=new FWe,this.gathererV1=new C_i(this.logger.createChild("V1"),this.configProvider,this.mediaManager,u),this.gathererV1.on("onStatisticsChanged",m=>this.event("onStatisticsChanged").raise(m)),this.useNewStatsApi&&a.config.diagnostics.sideBySide&&(this.gathererV2=new xCi(this.logger.createChild("V2"),this.configProvider,this.diagnostics,this.mediaManager))}initialize(n){this.pc=n,this.gathererV1.initialize(n),this.interval??(this.interval=this.window.setInterval(()=>this.processStats(),this.configProvider.config.webrtcStatPollInterval))}setAudioDecoderStatsProvider(n){this.gathererV1.setAudioDecoderStatsProvider(n),this.gathererV2?.setAudioDecoderStatsProvider(n)}setAudioEncoderCodecName(n){this.gathererV1.setAudioEncoderCodecName(n),this.gathererV2?.setAudioEncoderCodecName(n)}dispose(){super.dispose(),this.interval&&(this.window.clearInterval(this.interval),this.interval=void 0),this.gathererV1.dispose(),this.pc=void 0}get isDisposed(){return!this.pc&&this.interval===void 0}async processStats(){if(this.configProvider.config.diagnostics.collectWhileNotConnected){if(!this.pc||this.pc.iceConnectionState==="closed")return}else if(!this.pc||this.pc.iceConnectionState!=="connected"&&this.pc.iceConnectionState!=="completed")return void this.gathererV2?.signalNoConnection();if(this.useNewStatsApi){const n=pp(),a=this.loopTimer===void 0?-1:n-this.loopTimer;this.loopTimer=n,this.loopIntervalTracker.captureSample(a),this.loopIntervalAggregator.captureSample(this.loopIntervalTracker.getReport());const s=this.loopIntervalAggregator.getReport();s&&(this.diagnostics.loopIntervalMax=s.max,this.diagnostics.loopIntervalMedian=s.median);const c={};(await this.pc.getStats()).forEach(k=>{this.cleanupPii(k);const N=k.type;delete k.type,c[N]??(c[N]={}),c[N][k.id]=k});const u=pp()-n;this.fetchTimeTracker.captureSample(u),this.fetchTimeAggregator.captureSample(this.fetchTimeTracker.getReport());const m=this.fetchTimeAggregator.getReport();m&&(this.diagnostics.fetchTimeMax=m.max,this.diagnostics.fetchTimeMedian=m.median);const b=this.gathererV2?.processRawReport(c);let _=pp();this.gathererV1.processRawReport(c),_=pp()-_,b&&(this.configProvider.config.diagnostics.traceLogging&&this.logger.safe.debug("Raising onDiagnosticUpdated event"),this.event("onDiagnosticUpdated").raise(b)),b?.perfCounters&&(b.perfCounters.loopTime=a,b.perfCounters.fetchTime=u,b.perfCounters.legacyProcessingTime=_)}else this.pc.getStats(n=>{n.result&&this.gathererV1.processLegacyReport(n)})}cleanupPii(n){switch(n.type){case"local-candidate":case"remote-candidate":{const a=n;Object.defineProperty(a,"address",{enumerable:!1}),Object.defineProperty(a,"url",{enumerable:!1}),Object.defineProperty(a,"relatedAddress",{enumerable:!1}),Object.defineProperty(a,"ip",{enumerable:!1}),Object.defineProperty(a,"usernameFragment",{enumerable:!1});break}case"certificate":{const a=n;Object.defineProperty(a,"fingerprint",{enumerable:!1}),Object.defineProperty(a,"base64Certificate",{enumerable:!1});break}}}get sessionInfo(){return this.gathererV1.sessionInfo}onMaxCapabilitiesApplied(n){this.gathererV1.onMaxCapabilitiesApplied(n)}clearIceCandidateErrors(){this.gathererV1.clearIceCandidateErrors()}setSsrcTrackPair(n,a){this.gathererV1.setSsrcTrackPair(n,a),this.gathererV2?.setSsrcTrackPair(n,a)}addSubscriptionEvent(n,a,s,c,u,m,b){this.gathererV1.addSubscriptionEvent(n,a,s,c,u,m,b)}setSubscribedTrackSsrc(n){this.gathererV1.setSubscribedTrackSsrc(n)}addIceCandidateError(n){this.gathererV1.addIceCandidateError(n)}setH264AvailableProfiles(n){this.gathererV1.setH264AvailableProfiles(n)}setSupportedH264Profiles(n,a){this.gathererV1.setSupportedH264Profiles(n,a)}setTerminated(){this.gathererV1.setTerminated()}onDeviceEvent(n){this.gathererV1.onDeviceEvent(n)}getReport(n,a=!1){const s=this.gathererV1.getReport(n,a);if(this.gathererV2&&this.configProvider.config.diagnostics.sideBySide){const c=this.loopIntervalAggregator.getReport();c&&(s.data.Extensions.LoopIntervalMax=`${oa(c.max,1)}`,s.data.Extensions.LoopIntervalMedian=`${oa(c.median,1)}`);const u=this.fetchTimeAggregator.getReport();u&&(s.data.Extensions.FetchTimeMax=`${oa(u.max,1)}`,s.data.Extensions.FetchTimeMedian=`${oa(u.median,1)}`);const m=this.diagnostics.getObjectRef();s.data.Extensions.multipleVideoStreams=JSON.stringify(Fb(m.multiViewStats,"startTime",m.startTime)),s.data.Extensions.OvcToSubscriptions=JSON.stringify(m.ovcToSubscriptionEvents),s.data.Extensions.videoPerformanceEvent=JSON.stringify(m.videoPerformanceEvent);const b=m.bandwidthReport;m.negotiation.bweType==="REMB"?(s.data.Extensions.StartCallBWE=JSON.stringify(b?.startOfTheCall),s.data.Extensions.EndCallBWE=JSON.stringify(b?.endOfTheCall),s.data.Extensions.BWEStd=JSON.stringify(b?.std),s.data.Extensions.BwPercentiles=JSON.stringify(b?.bwPercentiles),s.data.Extensions.AvgBwe=JSON.stringify(b?.avgBwe)):(s.data.Extensions.StartCallBWESendSide=JSON.stringify(b?.startOfTheCall),s.data.Extensions.EndCallBWESendSide=JSON.stringify(b?.endOfTheCall),s.data.Extensions.BWEStdSendSide=JSON.stringify(b?.std),s.data.Extensions.BwPercentilesSendSide=JSON.stringify(b?.bwPercentiles),s.data.Extensions.AvgBwSendSide=JSON.stringify(b?.avgBwe)),s.data.Extensions.InitialBWSeed=JSON.stringify(m.initialBWSeed),s.data.Extensions.SentBWSeed=JSON.stringify(m.sentBWSeed),s.data.Extensions.Bandwidth_downlinkStabilizationTime=JSON.stringify(m.bwDownlinkStabilizationTime),s.data.Extensions.ReinvitelessContext=JSON.stringify(m.reinvitelessContext),s.data.Extensions.ReportedSendBandwidth=JSON.stringify(m.reportedSendBandwidthLayouts),s.data.Extensions.Data_ProtocolCounters=JSON.stringify(m.dataChannel?.protocolCounters),s.data.Extensions.Data_Error=m.dataChannel?.error,s.data.Extensions.Data_SessionState=m.dataChannelSessionState?.toString(),s.data.Extensions.Data_CreateChannelError=m.dataChannelCreationError;const _=m.aggregatedModalityStats?.video?.recv||[],k=m.aggregatedModalityStats?.audio?.recv||[],N=m.aggregatedModalityStats?.sharing?.recv||[],W=m.aggregatedModalityStats?.video?.send||[],ee=m.aggregatedModalityStats?.sharing?.send||[],oe=s.data.Extensions.WebRTCStats,de=_[_.length-1],se=N[N.length-1],Re=k[k.length-1],ue=W[W.length-1],Ne=ee[ee.length-1],ze=de?.aggregated?.macroblockRateStats??{},He=Re?.aggregated?.customHealerStats??{};if(He?.pullPacketProcessingTimes){const be=EG(He.pullPacketProcessingTimes);He.pullPacketProcessingTimeP50=be.getPercentile(.5),He.pullPacketProcessingTimeP95=be.getPercentile(.95)}if(He?.pushPacketProcessingTimes){const be=EG(He.pushPacketProcessingTimes);He.pushPacketProcessingTimeP50=be.getPercentile(.5),He.pushPacketProcessingTimeP95=be.getPercentile(.95)}for(const be in ze)s.data.Extensions[`Video_recv_${be}`]=`${oa(ze[be],0)}`;for(const be in m.totalVideoRecvMblocksRates)s.data.Extensions[`totalVideoRecv_${be}`]=`${oa(m.totalVideoRecvMblocksRates[be],0)}`;for(const be in He)if(He[be]!==void 0){const Ee=typeof He[be]!="number"?JSON.stringify(He[be]):He[be];s.data.Extensions[`Audio_recv_customHealer_${be}`]=Ee}s.data.Extensions.MeetingScenario=JSON.stringify(m.negotiation.meetingScenario),s.data.Extensions.IsTownHall=JSON.stringify(m.negotiation.isTownHall),s.data.Extensions.Audio_send_presentationAPIUserDuration=JSON.stringify(m.presentationAPIUserDuration),s.data.Extensions.Audio_send_presentationDuration=JSON.stringify(m.presentationAudioDuration),s.data.Extensions.CodecSupport=JSON.stringify(m.codecSupport),s.data.Extensions.Video_recv_FpsHarmonicAverage=de?.extensions.fpsHarmonicAverage?.toString(),s.data.Extensions.Sharing_recv_FpsHarmonicAverage=se?.extensions.fpsHarmonicAverage?.toString(),s.data.Extensions.Sharing_recv_CodecReport=JSON.stringify(se?.aggregated?.codecReport),s.data.Extensions.Video_send_performanceEvents=JSON.stringify(K0(Fb(m.localVideoPerformanceEvents,"timestamp",m.startTime),this.configProvider.config.diagnostics.telemetryLimits.numPerformanceEvents)),oe?.ssrc_sharing_send&&((oe?.ssrc_sharing_send).retransmittedPacketsSent=_a(m.aggregatedModalityStats?.sharing?.send,be=>be.outboundRTP.retransmittedPacketsSent)),this.configProvider.config.diagnostics.features.takeFreezeTelemetryFromGathererV2&&(_.length&&(s.data.Extensions.Video_recv_FreezeHistogram=JSON.stringify(de.aggregated?.freezeCountHistogram),s.data.Extensions.Video_recv_LongestFreezeDuration=JSON.stringify(de?.aggregated?.longestFreeze),s.data.Extensions.Video_recv_OngoingFreeze=JSON.stringify(de?.extensions?.isFrozen),s.data.Extensions.Video_recv_OngoingFreezeDuration=JSON.stringify(de?.aggregated?.ongoingFreezeDuration),s.data.Extensions.Video_recv_TotalFreezeDuration=JSON.stringify(de?.aggregated?.totalFreezeDuration),s.data.Extensions.Video_recv_RecvAvgFreezeDuration=JSON.stringify(de?.aggregated?.avgFreezeDuration),s.data.Extensions.Video_recv_FreezeTimestamps=JSON.stringify(gV(de?.aggregated?.freezeTimestampsHistogram,m.startTime,this.configProvider.config.diagnostics.telemetryLimits.numOfHistogramSamples))),N.length&&(s.data.Extensions.Sharing_recv_FreezeHistogram=JSON.stringify(se.aggregated?.freezeCountHistogram),s.data.Extensions.Sharing_recv_LongestFreezeDuration=JSON.stringify(se?.aggregated?.longestFreeze),s.data.Extensions.Sharing_recv_OngoingFreeze=JSON.stringify(se?.extensions?.isFrozen),s.data.Extensions.Sharing_recv_OngoingFreezeDuration=JSON.stringify(se?.aggregated?.ongoingFreezeDuration),s.data.Extensions.Sharing_recv_TotalFreezeDuration=JSON.stringify(se?.aggregated?.totalFreezeDuration),s.data.Extensions.Sharing_recv_RecvAvgFreezeDuration=JSON.stringify(se?.aggregated?.avgFreezeDuration),s.data.Extensions.Sharing_recv_FreezeTimestamps=JSON.stringify(gV(se?.aggregated?.freezeTimestampsHistogram,m.startTime,this.configProvider.config.diagnostics.telemetryLimits.numOfHistogramSamples)))),s.data.Extensions.EarlyMedia={NumStatsPolls:`${m.earlyMediaNumStatsPolls}`},s.data.Extensions.Audio_recv_packetsLostRateMax=`${oa(Re?.aggregated?.lossRateMax,6)||0}`,s.data.Extensions.Audio_recv_networkAvgLossRate=`${oa(Re?.aggregated?.networkAvgLossRate,6)||0}`,s.data.Extensions.Video_recv_packetsLostRateMax=`${oa(de?.aggregated?.lossRateMax,6)||0}`,s.data.Extensions.Sharing_recv_packetsLostRateMax=`${oa(se?.aggregated?.lossRateMax,6)||0}`,s.data.Extensions.Video_send_packetsLostRateMax=`${oa(ue?.aggregated?.lossRateMax,6)||0}`,s.data.Extensions.Sharing_send_packetsLostRateMax=`${oa(Ne?.aggregated?.lossRateMax,6)||0}`,this.configProvider.config.diagnostics.features.useNewSimulcastTelemetryExtension&&(s.data.Extensions.Video_send_Simulcast=JSON.stringify(m.simulcast?.video),s.data.Extensions.Sharing_send_Simulcast=JSON.stringify(m.simulcast?.sharing)),s.data.Extensions.Video_send_powerEfficientEncoderEvents=cd(ue?.extensions?.powerEfficientEncoderEvents,this.configProvider.config.diagnostics.telemetryLimits.numPowerEfficientEncoderEvents,"timestamp",m.startTime),s.data.Extensions.Video_send_powerEfficientEncoderEventOnCount=JSON.stringify(ue?.extensions?.powerEfficientEncoderEventOnCount),s.data.Extensions.Video_send_powerEfficientEncoderEventOffCount=JSON.stringify(ue?.extensions?.powerEfficientEncoderEventOffCount)}return _l(s)}startWaitingForStreamStart(n){this.gathererV1.startWaitingForStreamStart(n)}getTimerTracker(n,a){return this.gathererV1.getTimerTracker(n,a)}getLastStatistics(){return this.gathererV1.getLastStatistics()}updateSendStream(n,a){this.gathererV1.updateSendStream(n,a)}setSubscribedTrackIds(n){this.gathererV1.setSubscribedTrackIds(n)}setMaxSessionBandwidth(n){this.gathererV1.setMaxSessionBandwidth(n)}updateStatsWithLocalSsrcTrackInfo(){this.gathererV1.updateStatsWithLocalSsrcTrackInfo()}onSendersChanged(n,a){this.gathererV1.onSendersChanged(n,a)}setPreferredResolution(n,a,s){this.gathererV1.setPreferredResolution(n,a,s)}setIsRendering(n,a,s){this.gathererV1.setIsRendering(n,a,s)}setTimeToFirstFrame(n,a,s){this.gathererV1.setTimeToFirstFrame(n,a,s)}setFreezeDuration(n,a){this.gathererV1.setFreezeDuration(n,a)}addVideoControlMessage(n){this.gathererV1.addVideoControlMessage(n)}onMaxCapabilitiesRequested(n){this.gathererV1.onMaxCapabilitiesRequested(n)}addReportedReceiveBandwidth(n){this.gathererV1.addReportedReceiveBandwidth(n)}},eae=101,__i=[48e3,32e3,24e3,16e3,12e3],E_i=class{constructor(n){this.context=n,this.cname=sw(),this.dataMedia={type:ke.MEDIA_TYPE.data,protocol:ke.PROFILES.rtpSavp,port:0},this.configProvider=n.configProvider,this.logger=n.getLogger().createChild("WebkitSdpTrans")}fixTelephoneEvent(n){let a;return __i.forEach(s=>{Iw(n,{codec:"telephone-event",rate:s})}),$ne(n,eae,999),Lf(n,{codec:"telephone-event",rate:8e3},s=>(a=s.rtp.payload,s.rtp.payload=eae,s)),$ne(n,999,a||eae),a}toLocal(n,a,s){const c=a.isEmpty(),u=fs(n);let m;return u.media.forEach(b=>{if(b.type==="audio")c&&(m=this.fixTelephoneEvent(b)),VJe(b);else{m&&$ne(b,eae,m);const k=a.getLocalSsrcs().get(GN(b));this.enforceFixedSsrc(b,k)}const _=nie(this.configProvider,b.type);s==="offer"&&xTe(b,_,c,this.logger)}),new GKe(this.configProvider).modify(u),delete u.extmapAllowMixed,u}toOffer(n,a,s){return this.fromNative(n,a,s,!0)}toAnswer(n,a,s){return this.fromNative(n,a,s,!1)}toRemote(n,a,s,c){const u=fs(n);let m,b,_=this.configProvider.mediaConfig.maxBandwidthInKbps;u.bandwidth&&(!_||_>+n.bandwidth[0].limit)&&(_=+n.bandwidth[0].limit),u.media.forEach((se,Re)=>{a.getMediaEntity(Re).isDisabled()&&se.type!==ke.MEDIA_TYPE.audio&&(se.port=0)});let k=I_i(u);if(!k){let se=!1;u.media.forEach((Re,ue)=>{const Ne=a.getMediaEntity(ue);!se&&Ne.isEnabled()?(Re.mid=Ne.getMid(),se=!0):(Ne.disable(),Re.port=0)}),se&&(u.groups||(u.groups=[]),k={type:"BUNDLE"},u.groups.push(k))}u.media.forEach(se=>{const Re=GN(se);s[Re]===ke.MEDIA_STATE.send&&(se.direction&&se.direction.toLowerCase()===ke.MEDIA_STATE.receive||(se.direction=ke.MEDIA_STATE.receive))});const N=u.media.filter(se=>se.type===ke.MEDIA_TYPE.video);if(N.length>0){const se=N.filter(Re=>Re.port!==0);if(se.length>0){b=fs(se[0]),b.bandwidth&&delete b.bandwidth;const Re=this.configProvider.config.audioBandwidthInKbps?this.configProvider.config.audioBandwidthInKbps:0;_&&_-Re>0&&(b.bandwidth=[{limit:_-Re,type:"AS"}]),b.mid="video",b.direction=null,delete b.label,b.ssrcs=[],b.ssrcGroups=[],delete b.msid,se.forEach(ue=>{ue.ssrcs&&(b.ssrcs=b.ssrcs.concat(ue.ssrcs)),ue.ssrcGroups&&(b.ssrcGroups=b.ssrcGroups.concat(ue.ssrcGroups)),b.direction=w_i(b.direction,ue.direction||ke.MEDIA_STATE.sendReceive)}),zJe(b)}else b=eq(ke.MEDIA_TYPE.video,void 0,N[0].protocol,N[0].payloads)}const W=u.media.find(se=>se.type===ke.MEDIA_TYPE.audio);if(W)if(W.port!==0)m=fs(W),m.mid="audio",delete m.label,A_i(m),VJe(m),zJe(m);else{m=eq(ke.MEDIA_TYPE.audio,void 0,W.protocol,W.payloads);const se=u.media.find(Re=>!!Re.iceUfrag);se&&(m.port=9,m.direction="inactive",m.mid="audio",m.iceUfrag=se.iceUfrag,m.icePwd=se.icePwd,m.rtcpMux="rtcp-mux",se.crypto&&(m.crypto=se.crypto),se.fingerprint&&(m.fingerprint=se.fingerprint,m.setup=se.setup),m.rtp=[{payload:0,codec:"PCMU",rate:8e3}],m.payloads="0")}u.media.forEach((se,Re)=>{se.type===ke.MEDIA_TYPE.data&&(se.type=ke.MEDIA_TYPE.dataChannel,se.payloads=ke.PAYLOAD_TYPE.DATA_CHANNEL,se.protocol=ke.PROFILES.udpDtlsSctp,se.mid="data",delete se.xDataProtocol,delete se.direction,$S(se)&&(u.media[Re]=eq(se.type,void 0,se.protocol,se.payloads)))});const ee=z2(this.context)?u.media.find(se=>se.type===ke.MEDIA_TYPE.dataChannel):null;u.media=[m,b,ee].filter(se=>se),a.getMediaEntities()[0].getModality()!==ke.MODALITY.audio&&u.media.reverse();const oe=l9(this.context.configProvider,this.context.config.isPstnCall),de=Xte(n);return u.media.forEach(se=>{se.type!==ke.MEDIA_TYPE.dataChannel&&(!oe&&se.fingerprint&&se.crypto&&delete se.crypto,se.protocol=!de.dtls||de.sdes&&oe?ke.PROFILES.rtpSavpf:ke.PROFILES.udpTlsRtpSavpf)}),c==="offer"&&(xTe(m,this.configProvider.config.allowedAudioCodecs,!1,this.logger),xTe(b,this.configProvider.config.allowedVideoCodecs,!1,this.logger)),$Je(u,this.configProvider.mediaConfig.isTransportUnbundled),u}splitMedia(n,a,s,c,u){const m=n.getMid(),b=n.getModality(),_=fs(a);if(_.label=jne(b),_.direction=c,_.mid=m,_.ssrcs=[],_.ssrcGroups=[],n.getModality()===ke.MODALITY.data)return _.type=ke.MEDIA_TYPE.data,_.payloads=ke.PAYLOAD_TYPE.X_DATA,_;const k=s.filter(N=>N.modality===b);if(k&&k.length){const N=[];a.ssrcs&&(k.forEach(W=>{const ee=a.ssrcs.filter(oe=>oe.attribute==="msid"&&W.trackId===HJe(oe.value)).map(oe=>oe.id);N.push(...ee)}),_.ssrcs=a.ssrcs.filter(W=>N.indexOf(+W.id)>-1),_.ssrcs.forEach(W=>{W.attribute==="cname"&&(W.value=this.cname)})),a.ssrcGroups&&(_.ssrcGroups=a.ssrcGroups.filter(W=>W.ssrcs.split(" ").find(ee=>N.indexOf(+ee)>-1)))}else{if(c===ke.MEDIA_STATE.send||c===ke.MEDIA_STATE.sendReceive)return eq(a.type,jne(b),a.protocol,a.payloads);c!==ke.MEDIA_STATE.receive&&c!==ke.MEDIA_STATE.inactive||(u[a.type].ssrcs?.[0]?_.ssrcs=[{id:u[a.type].ssrcs[0].id,attribute:"cname",value:this.cname}]:a.type===ke.MEDIA_TYPE.audio?_.ssrcs=[{id:4195875351,attribute:"cname",value:this.cname}]:a.type===ke.MEDIA_TYPE.video&&(_.ssrcs=[{id:1,attribute:"cname",value:this.cname}]))}return _}fromNative(n,a,s,c){const u=fs(n),m=this.configProvider.mediaConfig.maxBandwidthInKbps;m&&(u.bandwidth=[{limit:m,type:"CT"}]),new qKe(this.configProvider).modify(u);const b=u.media.find(oe=>oe.type===ke.MEDIA_TYPE.audio),_=u.media.find(oe=>oe.type===ke.MEDIA_TYPE.video),k=u.media.find(oe=>oe.type===ke.MEDIA_TYPE.dataChannel),N={};N[ke.MODALITY.audio]=b,N[ke.MODALITY.video]=_,N[ke.MODALITY.sharing]=_,N[ke.MODALITY.data]=k||this.dataMedia;const W={};W[ke.MEDIA_TYPE.audio]=b,W[ke.MEDIA_TYPE.video]=_,W[ke.MEDIA_TYPE.data]=k||this.dataMedia;const ee={};return ee[ke.MODALITY.audio]=a.getMediaEntitiesByModality(ke.MODALITY.audio)[0],ee[ke.MODALITY.video]=a.getMediaEntitiesByModality(ke.MODALITY.video)[0],ee[ke.MODALITY.sharing]=a.getMediaEntitiesByModality(ke.MODALITY.sharing)[0],ee[ke.MODALITY.data]=a.getMediaEntitiesByModality(ke.MODALITY.data)[0],u.media=[],a.getMediaEntities().forEach(oe=>{let de,se=s[oe.getModality()];!oe.isEnabled()||N[oe.getModality()].port===0||oe!==ee[oe.getModality()]&&se===ke.MEDIA_STATE.send?(de=eq(oe.getType(),jne(oe.getModality()),N[oe.getModality()].protocol,N[oe.getModality()].payloads),N[oe.getModality()].payloads===ke.PAYLOAD_TYPE.DATA_CHANNEL&&(de.payloads=ke.PAYLOAD_TYPE.DATA_CHANNEL)):(se!==ke.MEDIA_STATE.inactive&&oe!==ee[oe.getModality()]&&(se=ke.MEDIA_STATE.receive),de=this.splitMedia(oe,N[oe.getModality()],a.getLocalTracksInfo(),se,W),oe!==ee[oe.getModality()]&&(de.candidates=[]));const Re=N[oe.getModality()].setup;Re&&(Re!=="actpass"?oe.setExtension("setup",Re):c&&oe.getExtension("setup")!==void 0&&(de.setup=oe.getExtension("setup")!=="actpass"?oe.getExtension("setup"):Re));const ue=N[oe.getModality()].iceUfrag,Ne=oe.getExtension("iceUfrag");oe.setExtension("iceRestart",!!ue&&!!Ne&&Ne!==ue),oe.setExtension("iceUfrag",ue),$S(de)&&oe.disable(),u.media.push(de)}),new xKe(this.context,s.data).modify(u),$Je(u,this.configProvider.mediaConfig.isTransportUnbundled),u}enforceFixedSsrc(n,a){let s=-1;if(!n.ssrcs)return;const c=[];if(n.ssrcs.forEach(u=>{u.attribute==="msid"&&c.push({ssrc:u.id,trackId:HJe(u.value)})}),n.ssrcs.forEach(u=>{u.attribute==="cname"&&s++,a&&(u.id=this.getVideoSSRC(s,a))}),n.ssrcGroups){const u=n.ssrcs.filter(m=>m.attribute==="cname").map(m=>m.id);n.ssrcGroups.forEach((m,b)=>{m.ssrcs=[u[2*b],u[2*b+1]].join(" ")})}}getVideoSSRC(n,a){return n%2==1?a+50:a}};function A_i(n){Iw(n,{codec:"g722",rate:8e3,encoding:2})}function zJe(n){const a=new Set(["urn:ietf:params:rtp-hdrext:sdes:mid","urn:ietf:params:rtp-hdrext:sdes:rtp-stream-id","urn:ietf:params:rtp-hdrext:sdes:repaired-rtp-stream-id"]);n.ext&&(n.ext=n.ext.filter(s=>!a.has(s.uri)))}function VJe(n){Iw(n,{codec:"CN",rate:16e3})}function I_i(n){return n.groups?n.groups.find(a=>a.type==="BUNDLE"):null}function $Je(n,a){const s=n.groups?.findIndex(u=>u.type==="BUNDLE"),c=n.groups?n.groups[s]:void 0;c&&(a?(c.mids=n.media.filter(u=>u.type===ke.MEDIA_TYPE.video).map(u=>u.mid).filter(u=>u).join(" "),c.mids||delete n.groups[s]):c.mids=n.media.map(u=>u.mid).filter(u=>u).join(" "))}function eq(n,a,s,c){return{type:n,port:0,label:a,payloads:c,protocol:s}}function HJe(n){return n.split(" ")[1]}function w_i(n,a){return n===ke.MEDIA_STATE.sendReceive||a===ke.MEDIA_STATE.sendReceive?ke.MEDIA_STATE.sendReceive:n===a?n:n&&a&&n!==a?ke.MEDIA_STATE.sendReceive:n||a}function xTe(n,a,s,c){a.length&&n?.port&&IKe(n,kye(a),s,c)}var k_i=$i(Un()),R_i=class{getCapabilities(n){const a=RTCRtpReceiver.getCapabilities(n);return a.codecs.forEach(s=>{s.mimeType=s.mimeType.toLowerCase().split("/").pop()}),Promise.resolve(a)}},M_i=class{getCapabilities(n){const a=RTCRtpSender.getCapabilities(n);return a.codecs.forEach(s=>{s.mimeType=s.mimeType.toLowerCase().split("/").pop()}),Promise.resolve(a)}},P_i=class{constructor(n,a){this.noRequiredCodecsWorkaround=a,this.selfGlobal=n.global.capabilityGatherer=n.global.capabilityGatherer||{},this.getCapabilities("video")}async getCapabilities(n){if(n!=="video"&&n!=="audio")return Promise.reject(new Error(`capabilities for ${n} are not supported`));if(!this.selfGlobal.gatherTask){const a=new Pi;this.selfGlobal.gatherTask=a.promise;const s=Cc.window.webkitRTCPeerConnection!==void 0,c=s?new Cc.window.webkitRTCPeerConnection(null):new Cc.window.RTCPeerConnection(null),u=m=>s?new Promise((b,_)=>{c.createOffer(b,_,m)}):(this.noRequiredCodecsWorkaround&&c.addTrack(c.addTransceiver("video").receiver.track),c.createOffer(m));try{const m=await u({offerToReceiveVideo:1,offerToReceiveAudio:1}),b={};k_i.parse(m.sdp).media.forEach(_=>{b[_.type]=_.rtp.map(k=>{const N={mimeType:k.codec.toLowerCase()};if(_.type==="video"){const W=_.fmtp?.find(ee=>ee.payload===k.payload);N.sdpFmtpLine=W?.config}return N})}),c.close(),a.resolve(b)}catch(m){this.selfGlobal.gatherTask=null,c.close(),a.reject(m)}}return this.selfGlobal.gatherTask.then(a=>({codecs:a[n]}))}},E$={build:(n,a,s=!1,c=!1)=>c?new M_i:!a&&yp.hasCapabilitiesApi()?new R_i:new P_i(n,s)},tq=$i(Un()),jJe="rollback";function D_i(){const n=[].slice.apply(arguments);let a=n[0]&&GJe(n[0].type);n.splice(0,a?1:0,null);const s=new(Function.prototype.bind.apply(Cc.window.RTCSessionDescription,n)),c=Object.getOwnPropertyDescriptor(Cc.window.RTCSessionDescription.prototype,"type");return Object.defineProperty(s,"type",{get:()=>a?jJe:c.get.call(s),set(u){a=GJe(u),a||c.set.call(s,u)}}),s}function GJe(n){return jJe===n}var qJe={build:()=>D_i},L_i=[{codec:"telephone-event",rate:8e3},{codec:"cn",rate:16e3}];function O_i(n){const a=[],s=qJe.build(),c=[].slice.apply(arguments);c.splice(0,1,null),m("iceTransportPolicy","iceTransports");const u=new(Function.prototype.bind.apply(Cc.window.webkitRTCPeerConnection,c));function m(Re,ue){c[1]?.[Re]&&(c[1][ue]=c[1][Re])}function b(){_(),ee(),oe(),W(),N()}function _(){[{name:"createOffer",reverseArgs:!0},"createAnswer","setRemoteDescription","setLocalDescription"].forEach(function(Re){const ue=Re.name||Re,Ne=u[ue];u[ue]=function(){const ze=arguments;return new Promise(function(He,be){const Ee=[He,be];ze.length>0&&Ee.splice(Re.reverseArgs?Ee.length:0,0,ze[0]),Ne.apply(u,Ee)})}})}function k(Re,ue){let Ne;Object.defineProperty(this,"dtmf",{get:()=>Re.kind==="audio"?(Ne=Ne||u.createDTMFSender(Re),Ne):null}),this.track=Re,this._stream=ue}function N(){u.getSenders&&u.addTrack&&u.removeTrack||(u.getSenders=function(){return a.slice()},u.addTrack=function(Re,ue){if(!Re||!ue)throw new Error("both media track and stream need to be provided");u.getLocalStreams().some(function(ze){return ze.id===ue.id})||u.addStream(ue);let Ne=a.find(function(ze){return ze.track.id===Re.id});return Ne||(Ne=new k(Re,ue),a.push(Ne)),Ne},u.removeTrack=function(Re){u.getLocalStreams().filter(function(ue){return ue.id===Re._stream.id}).forEach(function(ue){u.removeStream(ue)}),VR(a,ue=>ue===Re)})}function W(){const Re=u.createOffer;u.createOffer=function(ue){const Ne=arguments;return ue&&ue.offerToReceiveVideo>1&&(ue.offerToReceiveVideo=1),Re.apply(u,Ne)}}function ee(){["createOffer","createAnswer","setLocalDescription"].forEach(function(ue){const Ne=u[ue];u[ue]=function(){const ze=arguments;return n.getCapabilities("video").then(function(){return Ne.apply(Ne,ze)})}});const Re=u.setRemoteDescription;u.setRemoteDescription=function(ue){return n.getCapabilities("video").then(function(Ne){const ze=Ne.codecs,He=tq.parse(ue.sdp);return He.media.forEach(function(be){if(be.type==="video"&&(be.rtp.some(function(Ee){return ze.some(function(Pe){return Ee.codec.toLowerCase()===Pe.mimeType})})?de(be):be.port=0),!se(be)){const Ee=kKe(He);Ee?be.crypto=Ee.crypto:be.port||He.media.some(function(Pe){return!!Pe.port&&(be.crypto=Pe.crypto,!0)})}}),ue.sdp=tq.write(He),Re(ue)})}}function oe(){const Re=u.createAnswer;u.createAnswer=function(){const ue=arguments;return Re.apply(u,ue).then(function(Ne){if(!u.localDescription?.sdp)return Ne;const ze=tq.parse(u.localDescription.sdp),He=[];if(ze.media.forEach(function(be){L_i.forEach(function(Ee){Lf(be,Ee,function(Pe){He.push(Pe)})})}),He.length){const be=tq.parse(Ne.sdp);let Ee=!1;be.media.forEach(function(Pe){He.forEach(function(Qe){Lf(Pe,{codec:Qe.rtp.codec,rate:Qe.rtp.rate},function(Ze){Ze.rtp.payload!==Qe.rtp.payload&&(Ze.rtp.payload=Qe.rtp.payload,Ee=!0)})})}),Ee&&(Ne=new s({type:Ne.type,sdp:tq.write(be)}))}return Ne})}}function de(Re){Lf(Re,{codec:"h264",rate:9e4},function(ue){if(ue.fmtp){const Ne=new sE,ze=new sE(ue.fmtp.config);["level-asymmetry-allowed","packetization-mode","profile-level-id"].forEach(function(He){if(ze.contains(He)){let be=ze.get(He);He==="profile-level-id"&&(be="42C02A"),Ne.setIfMissing(He,be)}}),ue.fmtp.config=Ne.toString()}})}function se(Re){return Re.protocol!=="RTP/SAVPF"}return b(),u}var N_i={build:n=>O_i.bind(null,n)},x_i=class{constructor(n){const a=n.configProvider.config.useSdpCapabilitiesLegacySession,s=n.configProvider.config.noRequiredCodecsWorkaround;this.RTCRtpReceiver=E$.build(n,a,s),this.SdpTransform=E_i,this.RTCPeerConnection=N_i.build(this.RTCRtpReceiver),this.RTCSessionDescription=qJe.build()}};function B_i(){function n(){throw new Error("unsupported platform")}this.SdpTransform=n,this.RTCPeerConnection=n,this.RTCSessionDescription=n,this.RTCRtpReceiver=n,this.RTCRtpSender=n}function F_i(){return Cc.window.webkitRTCPeerConnection!==void 0}var U_i={build:n=>F_i()?new x_i(n):new B_i},WJe=class{constructor(n,a,s,c){this.logger=n,this.configProvider=a,this.activeSpeakerManager=s,this.contributingSourcesProvider=c,this.lastSources=[],this.emptySourcesCount=0,this.poll=()=>{const u=this.contributingSourcesProvider?.getContributingSources();if(!u)return this.logger.safe.info(`Contributing sources are not supported on this client. Retries attempts: ${this.emptySourcesCount}`),void(this.emptySourcesCount>0?(this.emptySourcesCount--,this.timer=window.setTimeout(this.poll,this.configProvider.config.webrtcContributingSourcesPollingInterval)):this.dispose());this.activeSpeakerManager.onContributingSourcesChanged(u.filter(m=>{const b=this.lastSources.find(_=>_.source===m.source);return!b||b.timestamp!==m.timestamp}).map(m=>m.source)),this.updateLastSources(u),this.timer=window.setTimeout(this.poll,this.configProvider.config.webrtcContributingSourcesPollingInterval)},this.emptySourcesCount=this.configProvider.config.webrtcContributingSourcesPollingEmptySources,this.startPolling(this.configProvider.config.webrtcContributingSourcesPollingStartDelay)}dispose(){this.stopPolling(),this.contributingSourcesProvider=void 0}useCustomCodec(n){n?this.stopPolling():this.startPolling()}updateContributingSources(n){this.activeSpeakerManager.onContributingSourcesChanged(n)}startPolling(n=this.configProvider.config.webrtcContributingSourcesPollingInterval){!this.timer&&this.contributingSourcesProvider&&(this.logger.safe.info("Polling started"),this.timer=window.setTimeout(this.poll,n))}stopPolling(){this.timer&&(this.logger.safe.info("Polling stopped"),window.clearTimeout(this.timer),this.timer=void 0)}updateLastSources(n){this.lastSources=n.map(a=>({source:a.source,timestamp:a.timestamp}))}},KJe=class{constructor(n,a,s,c){this.logger=n,this.peerConnection=a,this.logDiagnosticsError=s,this.sessionDiagnostics=c}getContributingSources(){try{if(!this.peerConnection?.getReceivers)return;const n=this.peerConnection.getReceivers().find(a=>a.track.kind==="audio");return n?n.getContributingSources?.():[]}catch(n){return this.logger.safe.error("Failed to get contributing sources",n),void(this.logDiagnosticsError&&this.sessionDiagnostics&&(this.sessionDiagnostics.contributingSourcesError=`${n}`))}}},z_i=class{constructor(n){this.mediaEntities=[],this.mediaEntitiesBackup=[],this.mediaTracks=[],this.localSsrcs=new Map,this.ssrcGenerator=new ETe,this.logger=n.logger.createChild("MM"),this.configProvider=n.configProvider,this.numVideoChannels=n.numVideoChannels}fromOffer(n,a){n.media.forEach(s=>{if(s.type===ke.MEDIA_TYPE.audio)ke.MODALITY.audio in a&&this.addMediaEntity(ke.MODALITY.audio);else if(s.type===ke.MEDIA_TYPE.video){if(ke.MODALITY.video in a)for(let c=0;c<this.numVideoChannels;c++)this.addMediaEntity(ke.MODALITY.video);ke.MODALITY.sharing in a&&this.addMediaEntity(ke.MODALITY.sharing)}else s.type===ke.MEDIA_TYPE.data&&ke.MODALITY.data in a&&this.addMediaEntity(ke.MODALITY.data)})}fromRemote(n,a){n.media.forEach((s,c)=>{const u=GN(s);if($S(s)||!(u in a))this.mediaEntities[c]?this.mediaEntities[c].disable():this.addDisabledMediaEntity(u),this.mediaEntities[c].setRemoteStreamId(null),this.mediaEntities[c].setRemoteTrackId(null);else{if(this.mediaEntities[c]?this.mediaEntities[c].update(u,s.mid||this.generateMid(c)):this.addMediaEntity(u,s.mid||this.generateMid(c)),s.msid)this.mediaEntities[c].setRemoteStreamId(s.msid.split(" ")[0]),this.mediaEntities[c].setRemoteTrackId(s.msid.split(" ")[1]);else if(s.ssrcs){const b=s.ssrcs.find(_=>_.attribute==="msid");b?(this.mediaEntities[c].setRemoteStreamId(b.value.split(" ")[0]),this.mediaEntities[c].setRemoteTrackId(b.value.split(" ")[1])):this.logger.safe.warn(`No ssrc msid for media of type ${s.type} with mid ${s.mid}`)}const m=s.xSourceStreamId||this.generateSourceStreamId(c);this.mediaEntities[c].setXSourceStreamId(m)}})}isEmpty(){return this.mediaEntities.length===0}addMediaEntity(n,a){this.createMediaEntity(n,a||this.generateMid(this.mediaEntities.length))}addDisabledMediaEntity(n){this.createMediaEntity(n)}getMediaEntities(){return this.mediaEntities}createMediaEntity(n,a){const s=LKe.create(this.configProvider,n,a);return this.mediaEntities.push(s),s}getMediaEntity(n){return this.mediaEntities[n]}getMediaEntityByMid(n){return this.mediaEntities.find(a=>a.getMid()===n)}getMediaEntitiesByModality(n){return this.mediaEntities.filter(a=>a.getModality()===n)}getMediaEntityByRemoteStreamId(n){return this.mediaEntities.find(a=>a.getRemoteStreamId()===n)}getMediaEntityByLocalTrackId(n){return this.mediaEntities.find(a=>a.getLocalTrackId()===n)}getMediaEntityByXSourceStreamId(n){return this.mediaEntities.find(a=>a.getXSourceStreamId()===n)}reset(){this.mediaEntities=[]}syncModalities(n,a,s){this.disableModalities(a),s||(this.enableModalities(a),this.addModalities(a))}enableModalities(n){this.mediaEntities.forEach((a,s)=>{a.getModality()in n&&a.isDisabled()&&a.update(a.getModality(),this.generateMid(s))})}disableModalities(n){this.mediaEntities.forEach(a=>{a.getModality()in n||a.disable()})}setRollbackUpdateHandler(n){}addModalities(n){const a={};this.mediaEntities.map(s=>s.getModality()).forEach(s=>{a[s]=!0});for(const s in n)s in a||this.addMediaEntity(s)}setLocalTracksInfo(n){this.mediaTracks=n,this.updateLocalSsrc(this.mediaTracks)}getLocalTracksInfo(){return this.mediaTracks}getLocalSsrcs(){return this.localSsrcs}updateMediaEntitiesWithLocalTracks(){this.mediaTracks&&(this.mediaEntities.forEach(n=>n.setLocalTrackId(null)),this.mediaTracks.forEach(n=>{const a=this.getMediaEntitiesByModality(n.modality)[0];a?a.setLocalTrackId(n.trackId):this.logger.safe.error(`Media entity is not found for modality: ${JSON.stringify(n.modality)}`)}))}updateMediaEntitiesWithActivityState(n,a){}backup(){this.mediaEntitiesBackup=[],this.mediaEntities.forEach(n=>{this.mediaEntitiesBackup.push(n.clone())})}commit(){this.mediaEntitiesBackup=[]}rollback(){this.mediaEntities=this.mediaEntitiesBackup}generateSourceStreamId(n){return n+10}generateMid(n){return`media_${n}`}updateLocalSsrc(n){n.forEach(a=>{if(!this.localSsrcs.get(a.modality)){const s=this.ssrcGenerator.nextVideoStreamSsrc().min;this.logger.safe.debug(`Ssrc updated for modality: ${a.modality}: ${s}`),this.localSsrcs.set(a.modality,s)}})}},BTe=$i(Un()),JJe=class{constructor(n,a,s,c,u){this.logger=n,this.RtcDescType=a,this.sessionDescription=s,this.negotiationQueue=c,this.mediaManager=u}configure(n){this.peerConnection=n}renegotiateNow(){return this.renegotiate(null,!0)}renegotiate(n,a=!1,s="local"){if(!this.peerConnection)throw new Error("trying to renegotiate without a peerConnection");const c=s==="local"?this.createNegotiationTaskForHaveLocalOffer(n):this.createNegotiationTaskForHaveRemoteOffer();return a?(this.logger.safe.info(`forced ${s} renegotiation starting`),Promise.resolve(c())):this.negotiationQueue.add(c)}normalizeRemoteSdpSDES(n,a){if(a.media[0].crypto)n.media.forEach(s=>{delete s.fingerprint,delete s.setup,s.crypto=s.crypto.filter(c=>a.media[0].crypto.some(u=>u.id===c.id)).slice(0,1)}),n.fingerprint&&delete n.fingerprint;else{const s=this.mediaManager.getMediaEntities().find(c=>c.getExtension("setup")!==void 0);n.media.forEach(c=>{const u=s?.getExtension("setup")||"actpass";c.setup==="actpass"&&(c.setup=u==="active"?"passive":"active")})}}normalizeRemoteSdpExtensions(n,a){n.media.forEach((s,c)=>{const u=new Set(a.media[c].ext?.map(m=>m.value)||[]);s.ext=s.ext?.filter(m=>u.has(m.value))})}createNegotiationTaskForHaveLocalOffer(n){return async()=>{let a=this.peerConnection.remoteDescription.sdp;const s=this.peerConnection.localDescription.sdp;this.logger.safe.info(`local renegotiation starting remoteSdp=${!!a} localSdp=${!!s}`);const c=BTe.parse(a),u=BTe.parse(s);this.normalizeRemoteSdpSDES(c,u),this.normalizeRemoteSdpExtensions(c,u),a=BTe.write(c);let m=new this.RtcDescType({sdp:a,type:"answer"});n&&n.forEach(b=>{m=b.modifyDescriptor(m)});try{this.logger.safe.info("creating offer");const b=await this.peerConnection.createOffer(),_=this.sessionDescription.createLocalOffer(b.sdp),k=new this.RtcDescType({sdp:_.toLocal(),type:"offer"});this.logger.safe.info("setting local description"),this.logger.unsafe.debug(`local description, sdp: ${k.sdp}`),await this.peerConnection.setLocalDescription(k),this.logger.safe.info("setting remote description"),this.logger.unsafe.debug(`remote description, sdp: ${m.sdp}`),await this.peerConnection.setRemoteDescription(m),this.logger.safe.debug("local renegotiation done")}catch(b){throw this.logger.safe.error("local renegotiation failed: ",b.toString()),b}}}createNegotiationTaskForHaveRemoteOffer(){return this.logger.safe.info("createNegotiationTaskForRemote"),async()=>{this.logger.safe.info("proceed with setting local sdp start");try{this.logger.safe.info("creating answer");const n=await this.peerConnection.createAnswer();this.logger.safe.info("applying answer");const a=this.sessionDescription.createLocalAnswer(n.sdp),s=new this.RtcDescType({sdp:a.toLocal(),type:"answer"});this.logger.safe.info("setting [answer] local description"),this.logger.unsafe.debug(`[answer] local description, sdp: ${s.sdp}`),await this.peerConnection.setLocalDescription(s),this.logger.safe.info("local answer for renegotiation is done")}catch(n){throw this.logger.safe.error("local answer for renegotiation failed: ",n.toString()),n}}}},FTe=15e3,V_i=5e3,$_i=class{constructor(n,a,s){this.settings=n,this.listener=a,this.logger=s,this.lastSendBW=0,this.coolingDown=!1,this.cooldownTimer=null,this.cooldownEnd=0,this.active=!1,this.maxResolution=this.settings.maxResolution,this.settings.scalingEnabled?this.active=!0:this.logger.safe.info("Resolution management disabled: no resolution management for 1x1 calls")}dispose(){this.currentResolution=null,this.pendingResolution=null,this.maxResolution=null,this.listener=null,this.active=!1,clearTimeout(this.cooldownTimer),this.cooldownTimer=null,this.listener=null}setMaxResolution(n){const a=yl.Send.getResolutionByFs(n);a!==this.maxResolution&&(this.logger.safe.info(`Setting max resolution: ${a}`),this.maxResolution=a,this.lastSendBW&&this.processEstimatedBandwidth(this.lastSendBW))}updateEstimatedSendBandwidth(n){n!==this.lastSendBW&&(this.logger.safe.debug(`Send BW: ${n}`),this.processEstimatedBandwidth(n))}resetCurrentResolution(){this.currentResolution=null}getCurrentResolution(){return this.currentResolution?.fs}setCurrentResolution(n){this.currentResolution=n}applyRes(n){this.pendingResolution=n,this.coolingDown&&(!this.currentResolution||n.fs>this.currentResolution.fs)||(this.coolingDown=!0,this.logger.safe.info(`Changing resolution to ${n}`),this.listener&&this.listener.onResolutionChanged(n.fs).then(a=>{a?(n===this.pendingResolution&&(this.pendingResolution=null),this.coolingDown&&!this.currentResolution&&(this.coolingDown=!1),this.currentResolution=n,this.cooldown()):(this.logger.safe.info("Unable to apply resolution at the moment"),this.cooldown(V_i))}).catch(a=>{this.logger.safe.error(`Error while applying new resolution: ${JSON.stringify(a)}`),this.pendingResolution=null}))}cooldown(n=FTe){!this.active||this.coolingDown&&this.cooldownEnd-Date.now()>FTe||(this.cooldownTimer&&clearTimeout(this.cooldownTimer),this.coolingDown=!0,this.cooldownEnd=Date.now()+FTe,this.cooldownTimer=setTimeout(()=>{this.logger.safe.debug("Resolution changer cooled down"),this.coolingDown=!1,this.cooldownTimer=null,this.pendingResolution?this.proposeResolution(this.pendingResolution):this.processEstimatedBandwidth(this.lastSendBW)},n))}proposeResolution(n){let a=n;this.maxResolution&&this.maxResolution.fs<a.fs&&(a=this.maxResolution),this.currentResolution&&a.fs===this.currentResolution.fs||this.applyRes(a)}processEstimatedBandwidth(n){const{lowRes:a,highRes:s}=yl.Send.getResolutionForBitrate(n),c=n<this.lastSendBW?s:a;n<this.lastSendBW&&c&&this.currentResolution&&this.currentResolution.fs<c.fs||(c&&this.proposeResolution(c),this.lastSendBW=n)}};function YJe(n,a){const s=a.config.maxBandwidthInKbpsFallback>0?a.config.maxBandwidthInKbpsFallback:Math.floor(Number.MAX_SAFE_INTEGER/1e3),c=1e3*((a.mediaConfig.maxBandwidthInKbps||s)-(a.config.audioBandwidthInKbps||0)),u=n.transport?.selectedCandidatePair?.availableOutgoingBitrate??0;return Math.min(c,u)}var H_i=class extends jr{constructor(n,a){super(a),this.configProvider=n,this.logger=a,this.lastReportedAgo=1/0,this._forceUpdate=!1}forceUpdate(){this._forceUpdate=!0}onBandwidthChanged(n){this._forceUpdate?this.updateBandwidth(n,"forceUpdate"):this.processEstimatedBandwidth(n)}processEstimatedBandwidth(n){if(this.lastReportedAgo++,!n||this.bandwidth===n)return;const a=this.configProvider.config.webrtcSendBandwidthIgnoredUpdateLimit,s=this.configProvider.config.webrtcSendBandwidthThreshold,c=this.lastReportedAgo===1/0,u=!a&&!s,m=a&&this.lastReportedAgo>=a,b=s&&Math.abs((n-this.bandwidth)/this.bandwidth)>=s,_=this.configProvider.config.webrtcSendBandwidthAlwaysReportAfterDrop&&n<this.bandwidth;if(c||u||m||b||_){const k=+c|+u<<1|+m<<2|+b<<3|+_<<4,N=this.getUpdateReason(k);this.updateBandwidth(n,N)}}updateBandwidth(n,a){this.bandwidth=n,this.logger.safe.debug(`Updating send bandwidth: ${this.bandwidth}, reason: ${a}`),this.notifySendBandwidthChanged()}notifySendBandwidthChanged(){this._forceUpdate=!1,this.event("onSendBandwidthChanged").raise(this.bandwidth),this.lastReportedAgo=0}getUpdateReason(n){return 1&n?"firstReport":2&n?"throttlingDisabled":4&n?"noReportsForTooLong":8&n?"bigMovement":22&n?"drop":"none"}},QJe=class{constructor(n,a,s,c,u,m,b){this.listener=n,this.statisticsGatherer=a,this.diagnostics=s,this.logger=c,this.configProvider=u,this.isSimulcastEnabled=b,this.serialQueue=new iL(this.logger),this.modality=ke.MODALITY.video;const _=m.maxResolution?{maxFs:m.maxResolution.fs}:null;this.validator=new qWe(this.logger.createChild("CapsValidator"),_),this.resolutionManager=new $_i(m,this,this.logger.createChild("rm")),this.statisticsGatherer.on("onStatisticsChanged",k=>this.onStatisticsChanged(k)),this.statisticsGatherer.on("onDiagnosticUpdated",k=>this.onDiagnosticUpdated(k))}async setMaxCapabilities(n,a){const s={modality:this.modality,causeId:n,capabilities:a,isSimulcastEnabled:this.isSimulcastEnabled};this.statisticsGatherer.onMaxCapabilitiesRequested(s),this.diagnostics?.onMaxCapabilitiesRequested(s),this.causeId=n;const c=this.validator.ensureValidity(a[0]);this.streamSenderParams={...a[0],...c},this.resolutionManager.setMaxResolution(this.streamSenderParams.maxFs),this.configProvider.mediaConfig.simulcastSessionEnabled&&await this.applyCapabilities(this.getParamsToApply())}resetCurrentResolution(){this.resolutionManager.resetCurrentResolution()}getCurrentResolution(){return this.resolutionManager.getCurrentResolution()}setCurrentResolution(n){this.resolutionManager.setCurrentResolution(n)}async onResolutionChanged(n){return this.applyCapabilities(this.getParamsToApply(n))}dispose(){this.resolutionManager.dispose(),this.resolutionManager=null}async applyCapabilities(n){return n?this.lastAppliedSenderParams===n?(this.logger.safe.info(`Capabilities already applied: ${JSON.stringify(n)}`),!0):(this.logger.safe.info(`Capabilities to apply: ${JSON.stringify(n)}`),this.lastAppliedSenderParams=n,this.listener.onReceiveCapabilitiesChanged(this.modality,this.causeId,[n])):(this.logger.safe.error("Send capabilities are not set. Cannot apply constraints"),!1)}getParamsToApply(n){if(!this.streamSenderParams)return null;const a=n||this.resolutionManager.getCurrentResolution();if(!a||this.streamSenderParams.maxFs<=a)return this.streamSenderParams;const s=Xp(this.streamSenderParams);return s.maxFs=a,s}onStatisticsChanged(n){this.configProvider.config.diagnostics.features.useNewSendBandwidthCalculation||this.resolutionManager.updateEstimatedSendBandwidth(n.estimatedSendBandwidth)}onDiagnosticUpdated(n){try{if(this.configProvider.config.diagnostics.features.useNewSendBandwidthCalculation){if(!n.video?.send?.length||!n.video.send[0])return;this.configProvider.config.diagnostics.traceLogging&&this.logger.safe.debug("Caught onDiagnosticUpdated: Estimating send bandwidth");const a=YJe(n.video.send[0],this.configProvider);this.resolutionManager.updateEstimatedSendBandwidth(a)}}catch(a){this.logger.error("Failed to processes diagnostics update: "+a)}}};Kt([pu()],QJe.prototype,"applyCapabilities");var j_i=class{constructor(n,a,s,c,u){this.modality=n,this.listener=a,this.statisticsGatherer=s,this.diagnostics=c,this.isSimulcastEnabled=u}setMaxCapabilities(n,a){const s={modality:this.modality,causeId:n,capabilities:a,isSimulcastEnabled:this.isSimulcastEnabled};this.statisticsGatherer.onMaxCapabilitiesRequested(s),this.diagnostics?.onMaxCapabilitiesRequested(s),this.listener.onReceiveCapabilitiesChanged(this.modality,n,a)}dispose(){}resetCurrentResolution(){}getCurrentResolution(){return null}setCurrentResolution(n){}},ZJe=class{constructor(n,a,s,c,u,m){this.logger=n,this.settings=a,this.listener=s,this.statsGatherer=c,this.diagnostics=u,this.configProvider=m,this.mediaSourceModels=[],this.pendingCapabilities=new Map}dispose(){this.mediaSourceModels.forEach(n=>{n.handler&&(n.handler.dispose(),n.handler=null)}),this.mediaSourceModels=null}updateRegisteredSources(n){this.logger.safe.info(`Local media params updated: ${JSON.stringify(n)}`);const a=[];this.mediaSourceModels.forEach(m=>a.push(m.sourceId));const s=n.map(m=>m.sourceId),c=y2(a,s);this.removeSourcesWithIds(c);const u=y2(s,a);this.addSourcesWithIds(u,n)}setMaxCapabilities(n,a){for(const s of n){if(!s.capabilities.length)continue;if(!s.sourceId){this.logger.safe.info(`SourceId is not defined to apply recv capabilities: ${JSON.stringify(s)}`);continue}const c=this.getModelWithSourceId(s.sourceId);if(!c){this.logger.safe.info(`Model is not registered for sourceId: ${s.sourceId}`),this.configProvider.config.enableCachingFMTP&&this.pendingCapabilities.set(s.sourceId,s);continue}this.logger.safe.info(`Capabilities handler found for sourceId: ${s.sourceId}`);const u=this.getOrCreateHandlerForModel(c,s.isSimulcast);u?u.setMaxCapabilities(s.causeId||a,s.capabilities):this.logger.safe.info(`Handler is not found for sourceId: ${s.sourceId}`)}this.logger.safe.debug("Max capabilities application completed")}setPendingCapabilities(){if(!this.configProvider.config.enableCachingFMTP)return;this.logger.safe.info(`Apply pending capabilities for sources [${Array.from(this.pendingCapabilities.keys())}]`);const n=Array.from(this.pendingCapabilities.values());this.setMaxCapabilities(n),this.pendingCapabilities.clear()}clearPendingCapabilities(){this.pendingCapabilities.clear()}resetCurrentResolution(){const n=this.mediaSourceModels.find(a=>a.modality===ke.MODALITY.video);n?.handler&&n.handler.resetCurrentResolution()}getCurrentResolution(){const n=this.mediaSourceModels.find(a=>a.modality===ke.MODALITY.video);return n?.handler?n.handler.getCurrentResolution():this.currentResolution?.fs}setCurrentResolution(n){const a=this.mediaSourceModels.find(s=>s.modality===ke.MODALITY.video);a?.handler?a.handler.setCurrentResolution(n):this.currentResolution=n}getOrCreateHandlerForModel(n,a){return n.handler||(n.handler=this.getCapabilitiesHandler(n.modality,a)),n.handler}addSourcesWithIds(n,a){n.forEach(s=>{const c=a.find(u=>u.sourceId===s);this.registerSource(s,c.modality)})}removeSourcesWithIds(n){n.forEach(a=>this.unregisterSource(a))}registerSource(n,a){this.logger.safe.info(`SourceId ${n} registered with mediaType: ${a}`),this.mediaSourceModels.push({modality:a,sourceId:n})}unregisterSource(n){const a=this.mediaSourceModels.find(s=>s.sourceId===n);a?(a.handler&&a.handler.dispose(),this.mediaSourceModels.splice(this.mediaSourceModels.indexOf(a),1),this.logger.safe.info(`SourceId ${n} unregistered`)):this.logger.safe.info(`Model doesn't exist with sourceId ${n}`)}getModelWithSourceId(n){return this.mediaSourceModels.find(a=>a.sourceId===n)}getCapabilitiesHandler(n,a){if(n===ke.MODALITY.audio)return null;if(n===ke.MODALITY.video&&!a&&this.settings.customBwEstimationEnabled){const s=new QJe(this.listener,this.statsGatherer,this.diagnostics,this.logger.createChild("ach"),this.configProvider,this.settings,a);return this.currentResolution&&s.setCurrentResolution(this.currentResolution),s}return new j_i(n,this.listener,this.statsGatherer,this.diagnostics,a)}},XJe=class extends jr{constructor(n,a,s,c,u,m){super(n),this.logger=n,this.multiParty=a,this.configProvider=s,this.mediaManager=c,this.statsGatherer=u,this.diagnostics=m,this.rendererResolutions=new Map,this.rendererResolutionsApplied=new Map,this.rendererResolutionMax=new Map,this.hasPendingLimitResolutionUpdate=!1,this.spotlightedRenderers=[]}addRenderer(n){this.rendererResolutions.set(n,{width:0,height:0}),n.on("onRendererSizeChanged",(a,s)=>{this.onRendererSizeChanged(a,s)}),this.scheduleUpdateLimitedResolutions()}removeRenderer(n){this.rendererResolutions.delete(n),this.rendererResolutionsApplied.delete(n),this.rendererResolutionMax.delete(n),this.scheduleUpdateLimitedResolutions()}clearRenderers(){this.rendererResolutions.clear(),this.rendererResolutionsApplied.clear(),this.rendererResolutionMax.clear()}getMaxAllowedVideoFS(){const n=this.getMaxHeightFromConfig(this.sizedRenderersCount);return this.getMaxFSForHeight(n)}limitResolutionOnPoorPerformance(n){const a=this.getRendererByMsi(n);if(!a)return;const s=a.resolution.height>a.resolution.width,c=yl.Recv.getNextLowerResolution(a.resolution.width,a.resolution.height);if(!c)return;const u={width:s?c.height:c.width,height:s?c.width:c.height};this.rendererResolutionMax.set(a.renderer,u),this.diagnostics?.registerResolutionChangeRequest({ts:Date.now(),msi:a.renderer.getMsi(),res:u}),this.logger.safe.info(`Poor perf. Limiting resolution for renderer msi: ${a.renderer.getMsi()} from ${a.resolution.height}p to ${u.height}p`),this.onRendererSizeChanged(a.renderer,u)}get renderersCount(){return this.rendererResolutions.size}get sizedRenderersCount(){return this.configProvider.config.excludeUnsizedRenderersFromMultiviewResolutionLimits?[...this.rendererResolutions.values()].filter(n=>n.height>0).length:this.renderersCount}getMaxFSForHeight(n){return this.limitMaxFS(yl.Recv.getMaxFsForHeight(n))}getRendererByMsi(n){for(const[a,s]of this.rendererResolutions.entries())if(a.getMsi()===n)return{renderer:a,resolution:s};return null}applyRendererResolution(n,a){this.setMaxFSCapabilities(n,a),this.rendererResolutionsApplied.set(n,a);const s=n.getMediaStream()&&n.getMediaStream().getVideoTracks();s?.[0]&&this.statsGatherer.setPreferredResolution(s[0].id,a,n.getModality())}onRendererSizeChanged(n,a){this.rendererResolutions.set(n,a),this.scheduleUpdateLimitedResolutions()}scheduleUpdateLimitedResolutions(){this.hasPendingLimitResolutionUpdate||(this.hasPendingLimitResolutionUpdate=!0,window.setTimeout(()=>{this.hasPendingLimitResolutionUpdate=!1;const n=this.groupMaxRenderersResolutionsByMsi();this.logger.safe.info(`Updating resolution limits: renderers count ${this.renderersCount}, with size: ${this.sizedRenderersCount}, resolution limits: ${JSON.stringify(this.configProvider.config.multiviewResolutionLimits)}`),this.spotlightedRenderers=this.findSpotlightedRenderers(),this.spotlightedRenderers.length>0&&this.logger.safe.info(`Spotlighted renderers: ${this.spotlightedRenderers.map(a=>a.getMsi())}, max spotlight height: ${this.configProvider.config.maxSpotlightResolution}`);for(const[a,s]of this.rendererResolutions.entries()){if(!s.height)continue;const c=n.get(a.getMsi()),u=this.limitRendererResolution(a,c||s),m=this.rendererResolutionsApplied.get(a);(!m||m.height!==u.height||m.width!==u.width)&&this.applyRendererResolution(a,u)}},this.configProvider.config.multiviewResolutionLimitUpdateThrottleDelay))}findSpotlightedRenderers(){if(this.sizedRenderersCount<=1||!this.configProvider.config.isSpotlightEnabled)return[];let n=!1,a=0;for(const[m,b]of this.rendererResolutions.entries())b.height&&b.height!==a&&(a&&(n=!0),a=b.height);if(!n)return[];const s=new c7e((m,b)=>m.resolution.width>b.resolution.width);for(const[m,b]of this.rendererResolutions.entries())s.enqueue({renderer:m,resolution:b});const c=[];let u=this.configProvider.config.maxNumberOfPinnedVideos;for(;u;){const m=s.peek()?.resolution?.width,b=[];for(;s.peek()?.resolution?.width===m;)b.push(s.dequeue().renderer);if(!(u-b.length>=0))break;u-=b.length,c.push(...b)}return c}getMaxHeightFromConfig(n,a=!1){return a?this.configProvider.config.maxSpotlightResolution:this.configProvider.config.multiviewResolutionLimits[`${n}`]||this.configProvider.config.multiviewResolutionLimits.more}getMaxHeight(n){const a=this.spotlightedRenderers.some(u=>u.getMsi()===n.getMsi());let s=this.getMaxHeightFromConfig(this.sizedRenderersCount,a);const c=this.rendererResolutionMax.get(n);return c&&(s=Math.min(s,Math.min(c.height,c.width))),s}limitRendererResolution(n,a){const s=this.getMaxHeight(n);if(!s)return a;if(a.height>a.width&&a.width>s){const c=s/a.width;return{height:Math.ceil(a.height*c),width:s,limited:!0}}if(a.width>a.height&&a.height>s){const c=s/a.height;return{height:s,width:Math.ceil(a.width*c),limited:!0}}return a}setMaxFSCapabilities(n,a){const s=n.getMediaStream();if(!s)return void this.logger.safe.warn("renderer has no stream attached");const c=this.mediaManager.getMediaEntityByRemoteStreamId(s.id);if(!c?.getLocalRecvCapabilities())return void this.logger.safe.warn(`no capabilities for provided modality: ${n.getModality()}`);const u=a.limited?this.getMaxFSForHeight(a.height):this.getMaxFS(a.width,a.height),m=c.getLocalRecvCapabilities();m.setMaxFS(u,()=>{if(this.logger.safe.info(`updated max-fs video capability to ${u} for renderer msi: ${n.getMsi()}`),this.multiParty&&this.configProvider.config.webrtcMultiPartyRecvVideoSignaling){const b=n.getMsi(),_=m.buildFmtp();this.event("onSourceRequestRequired").raise(s.id,b,_)}else this.event("onNegotiationRequired").raise()})}getMaxFS(n,a){return this.limitMaxFS(yl.Recv.getMaxFsForHeight(a))}limitMaxFS(n){return this.multiParty?Math.min(n,this.configProvider.config.webrtcMultiPartyRecvVideoMaxFS):Math.min(n,this.configProvider.config.webrtcRecvVideoMaxFS)}groupMaxRenderersResolutionsByMsi(){const n=new Map;return this.rendererResolutions.forEach((a,s)=>{const c=s.getMsi(),u=n.get(c);(!u||a.width>u.width&&a.height>u.height)&&n.set(c,a)}),n}},G_i=class extends jr{constructor(n,a){super(),this.configProvider=n,this.getModality=a,this.isRendering=!1,this.currentFreezeDuration=0,this.mediaStarted=!1,this.lastBytesRecv=0,this.currentLowBitrateDuration=0}captureRawStatistics(n){const a=n.googFrameRateDecoded,s=n.googFrameRateReceived,c=n.bytesReceived;c!==void 0&&this.getModality()!==ke.MODALITY.sharing&&this.configProvider.config.isBytesRecvUsedInIsRenderingCalculation&&this.calculateBitrate(c,a),a>0&&(this.mediaStarted=!0),a===0||s===0?this.currentFreezeDuration+=ke.TIME_INTERVAL.SEC_1:a>0&&(s===void 0||s>0)&&(this.currentFreezeDuration=0);const u=this.configProvider.config.notRenderingTimeInterval[this.getModality()];this.setIsRendering(u)}updateRenderingTracker(n){const a=n.extensions.frameRateDecoded||0,s=n.extensions.frameRateReceived||0,c=n.extensions.bitrate;c!==void 0&&this.getModality()!==ke.MODALITY.sharing&&this.configProvider.config.isBytesRecvUsedInIsRenderingCalculation&&this.calculateLowBitrateDuration(c,a),a>0&&(this.mediaStarted=!0),a===0||s===0?this.currentFreezeDuration+=ke.TIME_INTERVAL.SEC_1:a>0&&(s===void 0||s>0)&&(this.currentFreezeDuration=0);const u=this.configProvider.config.notRenderingTimeInterval[this.getModality()];this.setIsRendering(u)}calculateLowBitrateDuration(n,a){n/1e3<this.configProvider.config.notRenderingLowBitrateThreshold&&a<this.configProvider.config.notRenderingLowFramerateThreshold?this.currentLowBitrateDuration++:this.currentLowBitrateDuration=0}calculateBitrate(n,a){const s=8*(n-this.lastBytesRecv);this.lastBytesRecv=n,this.calculateLowBitrateDuration(s,a)}setIsRendering(n){const a=this.currentFreezeDuration<n&&this.currentLowBitrateDuration<n&&this.mediaStarted;a!==this.isRendering&&(this.isRendering=a,this.event("onIsRenderingChanged").raise(this.isRendering))}},q_i=class extends jr{constructor(n,a,s){super(),this.videoElement=n,this.configProvider=a,this.getTimeToFirstFrame=s,this.prevCurrentTime=0,this.prevDecodedFrameCount=0,this.prevTimestamp=Date.now(),this.currentFreezeDuration=0,this.freezeDurationTimer=window.setInterval(()=>{this.calcFreezeDurationMs()},this.configProvider.config.freezeIntervalFrequency)}calcFreezeDurationMs(){const n=this.videoElement.currentTime,a=n===this.prevCurrentTime,s=this.videoElement.webkitDecodedFrameCount,c=s===void 0||s===this.prevDecodedFrameCount;if(this.prevCurrentTime=n,this.prevDecodedFrameCount=s,this.getTimeToFirstFrame()!==-1)if(a&&c){const u=Date.now();this.currentFreezeDuration+=u-this.prevTimestamp,this.prevTimestamp=u}else{if(this.currentFreezeDuration>this.configProvider.config.freezeMinDuration){const u=this.calcFreeze();this.event("onFreezeEnded").raise(u)}this.currentFreezeDuration=0}this.prevTimestamp=Date.now()}getEndOfTheFreeze(){let n=0;return this.currentFreezeDuration>0&&(n=this.calcFreeze(),this.currentFreezeDuration=0),n}dispose(){const n=this.getEndOfTheFreeze();this.event("onFreezeEnded").raise(n),clearInterval(this.freezeDurationTimer)}calcFreeze(){const n=Date.now()-this.prevTimestamp;return this.currentFreezeDuration+n}},W_i=class extends jr{constructor(n,a,s,c){super(),this.videoElement=n,this.minInterval=a,this.maxInterval=s,this.window=Cc.window,this.devicePixelRatio=c&&window.devicePixelRatio||1,this.originalVideoElementSize={width:n.offsetWidth,height:n.offsetHeight},this.initializeSizeTracking()}get width(){return this.originalVideoElementSize.width*this.devicePixelRatio}get height(){return this.originalVideoElementSize.height*this.devicePixelRatio}initializeSizeTracking(){const n=Math.floor(Math.random()*Math.abs(this.maxInterval-this.minInterval))+this.minInterval;this.elementSizeTrackingRef=this.window.setInterval(()=>{this.videoElementSizeChanged()&&(this.saveCurrentVideoElementSize(),this.raiseChanged())},n)}triggerVideoElementSizeChange(){this.originalVideoElementSize.height&&this.originalVideoElementSize.width&&this.raiseChanged()}dispose(){this.elementSizeTrackingRef&&this.window.clearInterval(this.elementSizeTrackingRef)}videoElementSizeChanged(){return this.originalVideoElementSize.width!==this.videoElement.offsetWidth||this.originalVideoElementSize.height!==this.videoElement.offsetHeight}saveCurrentVideoElementSize(){this.originalVideoElementSize.width=this.videoElement.offsetWidth,this.originalVideoElementSize.height=this.videoElement.offsetHeight}},K_i=class extends sKe{constructor(n,a,s,c,u,m){super(u,n.createChild("remote"),a),this.diagnostics=s,this.subscriptionManager=c,this.sessionDiagnostics=m,this.disposed=!1,this.currentIsRendering=!1,this.startTimeTTFF=0,this.timeToFirstFrame=-1,this.isTimeToFirstFrameReported=!1,this.configProvider.config.freezeIntervalFrequency&&(this.freezeTracker=new q_i(this.getVideoElement(),this.configProvider,()=>this.timeToFirstFrame),this.freezeTracker.on("onFreezeEnded",b=>{this.diagnostics?.addFreezeDuration(b),this.event("onFreezeEnded").raise(b)})),this.configProvider.config.isRenderingBasedOnRawStatistics&&(this.isRenderingTracker=new G_i(this.configProvider,this.getModality.bind(this)),this.isRenderingChangedSubscription=this.isRenderingTracker.on("onIsRenderingChanged",b=>{this.setIsRendering(b)})),this.overlayStats=new sSi(this.configProvider.config.showStatsInCall,u,this)}getEndOfTheFreeze(){return this.freezeTracker?.getEndOfTheFreeze()}resetTimeToFirstFrameFlag(){this.isTimeToFirstFrameReported=!1}setIsRendering(n){this.currentIsRendering!==n&&(this.currentIsRendering=n,this.captureIsRenderingEvent(n))}updateStatsOverlay(n,a){this.overlayStats.setStats(n,a)}updateIsRenderingTracker(n){this.isRenderingTracker?.updateRenderingTracker(n)}subscribeVideoAsync(n,a){return this.timeToFirstFrameSinceSubscriptionStart=Date.now(),new Promise((s,c)=>{this.modality=a?ke.MODALITY.sharing:ke.MODALITY.video,this.diagnostics&&(this.diagnostics.msi=n,this.diagnostics.modality=this.modality),this.trackElementSizeChange(),this.unsubscribe(),this.on("onVideoSizeChanged",(m,b)=>{if(this.modality===ke.MODALITY.video&&this.sessionDiagnostics?.registerResolutionChangeEvent({ts:Date.now(),msi:n,res:{width:m,height:b}}),this.isTimeToFirstFrameReported)return;if(this.timeToFirstFrame===-1){const k=Date.now();this.timeToFirstFrame=k-this.startTimeTTFF,this.timeToFirstFrameSinceSubscriptionStart=Date.now()-this.timeToFirstFrameSinceSubscriptionStart}const _=this.getTrackId();_&&(this.diagnostics.timeToFirstFrameSinceSubscriptionStart=this.timeToFirstFrameSinceSubscriptionStart,this.diagnostics.timeToFirstFrame=this.timeToFirstFrame,this.sizeTracker?.triggerVideoElementSizeChange(),this.event("onVideoStarted").raise(this.timeToFirstFrame,this.timeToFirstFrameSinceSubscriptionStart,_),this.isTimeToFirstFrameReported=!0)}),this.on("onVideoRendererStateChanged",m=>{this.diagnostics.addStateChange(m)});const u=this.subscriptionManager.subscribeVideo(this.modality,n);this.subscription=u,this.logger.safe.info(`subscribing renderer to type: ${u.modality} msi: ${u.msi}`),u.setOnMediaStreamChangedHandler(m=>{const b=this.getMediaStream();this.attachMediaStream(m),m&&(this.startTimeTTFF=Date.now());const _=this.getTrackId();_&&this.diagnostics&&(this.diagnostics.trackId=_),this.logger.safe.info(`subscribed renderer to type: ${u.modality} msi: ${u.msi} on stream #${m?m.id:"none"}`),m&&b!==m&&this.sizeTracker?.triggerVideoElementSizeChange(),s()}),u.setOnErrorHandler(m=>{this.logger.safe.error(`failed to subscribe renderer ${nn(m)}`),JSON.stringify(m)==="webRtcSession cleanup"&&(this.logger.safe.info(`Retry to subscribe to video stream with msi: ${n}. Previous session was cleaned up`),this.subscriptionManager.streamChangedByMsi(n),s()),c(m)})})}dispose(){this.disposed?this.logger.safe.warn("renderer already disposed"):(this.disposed=!0,this.logger.safe.info("disposing"),this.unsubscribe(),this.captureIsRenderingEvent(!1),this.freezeTracker?.dispose(),this.sizeTracker?.dispose(),this.isRenderingChangedSubscription?.dispose(),this.overlayStats.dispose(),this.diagnostics?.dispose(),this.event("onRendererDisposed").raise(this),super.dispose())}getModality(){return this.modality}getMsi(){return this.subscription?.msi??-1}getLocalMsi(){return this.subscription?.localMsi}getCurrentResolution(){return this.resolution??{width:0,height:0}}unsubscribeNow(){this.subscription?.unsubscribe(),this.subscription=null}trackElementSizeChange(){const n=this.modality===ke.MODALITY.sharing,a=n?this.configProvider.config.webrtcScreensharingCapabilityCheckIntervalMin:this.configProvider.config.webrtcVideoCapabilityCheckIntervalMin,s=n?this.configProvider.config.webrtcScreensharingCapabilityCheckIntervalMax:this.configProvider.config.webrtcVideoCapabilityCheckIntervalMax;a&&s?(this.sizeTracker=new W_i(this.getVideoElement(),a,s,this.configProvider.config.enableDevicePixelRatio),this.sizeTracker.changed(()=>this.onSizeTrackerChanged())):this.logger.safe.info("skipping video size tracking")}onSizeTrackerChanged(){this.resolution={width:this.sizeTracker.width,height:this.sizeTracker.height},this.logger.safe.info(`video renderer size changed to ${this.resolution.width}x${this.resolution.height}`),this.diagnostics&&(this.diagnostics.rendererSize=this.resolution),this.event("onRendererSizeChanged").raise(this,this.resolution)}unsubscribe(){this.subscription?.dispose(),this.subscription=null}captureIsRenderingEvent(n){this.diagnostics&&(this.diagnostics.isRendering=n),this.event("onIsRenderingChanged").raise(n,this.getModality(),this.getTrackId())}},eYe=class{constructor(n,a,s,c,u,m){this.logger=n,this.configProvider=a,this.statsGatherer=s,this.sessionDiagnostics=c,this.remoteVideoResolutionManager=u,this.domOverrides=m,this.remoteRendererSubscriptions=new Map,this.diagnostics=c?.newRemoteVideoManagerDiagnostics()}createRenderer(n,a,s){const c=new K_i((s??this.logger).createChild("videorenderer"),this.configProvider,this.diagnostics?.newRendererDiagnostics(),a,n,this.sessionDiagnostics);return this.domOverrides.onMediaElementAdded&&this.domOverrides.onMediaElementAdded(c.getVideoElement()),this.addRenderer(c),c}moveRenderers(n){this.renderers.forEach(a=>{a.resetTimeToFirstFrameFlag(),n.addRenderer(a),this.removeRenderer(a)})}getMaxAllowedVideoFS(){return this.remoteVideoResolutionManager.getMaxAllowedVideoFS()}dispose(){this.renderers.forEach(n=>n.resetTimeToFirstFrameFlag()),this.renderers.forEach(n=>{const a=n.getTrackId(),s=n.getEndOfTheFreeze();this.statsGatherer.setFreezeDuration(s,a)}),this.remoteRendererSubscriptions.forEach((n,a)=>{a.dispose(),n.forEach(s=>s.dispose())}),this.remoteRendererSubscriptions.clear(),this.remoteVideoResolutionManager.clearRenderers()}processStatsReport(n){this.configProvider.config.isRenderingBasedOnRawStatistics&&this.onDiagnosticUpdated(n),this.updateOverlayStats(n)}processLegacyStats(n){this.configProvider.config.isRenderingBasedOnRawStatistics||this.renderers.forEach(a=>{const s=a.getTrackId();if(n.remoteVideoStreams[s]){const c=n.remoteVideoStreams[s].isRendering;c!==void 0&&a.setIsRendering(c)}})}playVideo(){this.renderers.forEach(n=>n.playVideo())}get renderers(){return Array.from(this.remoteRendererSubscriptions,([n])=>n)}addRenderer(n){this.remoteRendererSubscriptions.set(n,this.subscribeOnEvents(n)),this.logger.safe.info("Added renderer to manager"),this.remoteVideoResolutionManager.addRenderer(n)}generateVideoRecvStats(n){const a=new Map,s=c=>{c?.forEach(u=>{const m=u.track?.trackIdentifier??u.inboundRTP.trackIdentifier;a.set(m,u)})};return s(n.sharing?.recv),s(n.video?.recv),a}updateOverlayStats(n){const a=this.generateVideoRecvStats(n);this.renderers.forEach(s=>{const c=s.getTrackId();a.has(c)&&n.audio?.recv?.length&&s.updateStatsOverlay(a.get(c),n.audio.recv[0])})}onDiagnosticUpdated(n){const a=[...n.video?.recv??[],...n.sharing?.recv??[]];if(a.length){const s=new Map;a.forEach(c=>{s.set(c.track?.trackIdentifier,c)}),this.renderers.forEach(c=>{const u=c.getTrackId();s.has(u)&&c.updateIsRenderingTracker(s.get(u))})}}subscribeOnEvents(n){return[n.on("onRendererDisposed",a=>this.onRendererDisposed(a)),n.on("onVideoStarted",(a,s,c)=>this.onVideoStarted(a,s,c)),n.on("onFreezeEnded",a=>{const s=n.getTrackId();this.statsGatherer.setFreezeDuration(a,s)}),n.on("onIsRenderingChanged",(a,s,c)=>this.statsGatherer.setIsRendering(a,s,c))]}onRendererDisposed(n){this.logger.safe.debug("Renderer removed from manager"),this.removeRenderer(n),this.domOverrides.onMediaElementRemoved&&this.domOverrides.onMediaElementRemoved(n.getVideoElement())}removeRenderer(n){this.remoteRendererSubscriptions.get(n).forEach(a=>a.dispose()),this.remoteRendererSubscriptions.delete(n),this.remoteVideoResolutionManager.removeRenderer(n)}onVideoStarted(n,a,s){this.statsGatherer.setTimeToFirstFrame(n,a,s)}},tYe=class extends jr{constructor(n,a,s){super(),this.configProvider=a,this.callDeviceManager=s,this.lastFramerateInput=-1,this.trackInfo=[],this.timeoutId=null,this.logger=n.createChild("localStreamWatcher"),this.callDeviceManagerSub=s.on("onSelectedVirtualDevicesChanged",()=>{this.logger.info("VirtualDevice changed, updating subscriptions"),this.handleDeviceManagerChange()})}get effectsManager(){return this.callDeviceManager.getDeviceManager("Video").effectsManager}startWatching(n,a){(this.configProvider.config.videoCaptureFreezeTimeout||a)&&(this.trackInfo=n,this.performanceMonitor=a,this.configProvider.config.videoCaptureFreezeTimeout&&(this.videoEffectManagerSubscription||(this.videoEffectManagerSubscription=this.effectsManager.on("videoFreezeDetected",s=>this.onVideoFreezeDetected(s)))))}stopWatching(){this.trackInfo=[],this.videoEffectManagerSubscription?.dispose(),this.videoEffectManagerSubscription=null,this.performanceMonitor=void 0,this.lastFramerateInput!==0||this.timeoutId||this.event("onVideoCaptureFreeze").raise(!1,!this.effectsManager.isEffectEnabled("Video")),this.disposeTimer(),this.lastFramerateInput=-1}dispose(n){this.callDeviceManagerSub?.dispose(),super.dispose(n),this.stopWatching()}onDiagnosticUpdated(n){if(!this.trackInfo.length||!n.video?.send?.length)return;this.configProvider.config.diagnostics.traceLogging&&this.logger.safe.debug("Caught onDiagnosticUpdated: Updating local video stream watcher");const a=n.video?.send[0],s=[];let c,u=0;[a,...a.altLayouts??[]].forEach(m=>{const b=m.mediaSource,_=b?.framesPerSecond??0;this.trackInfo.some(k=>k.trackId===b.trackIdentifier)&&((!c||u<_)&&(c=b,u=_),this.performanceMonitor&&s.push(m.outboundRTP))}),this.performanceMonitor?.monitor(s),this.configProvider.config.videoCaptureFreezeTimeout&&(c?u!==this.lastFramerateInput&&(u===0?this.scheduleCaptureFreezeStart(c.trackIdentifier,!this.effectsManager.isEffectEnabled("Video")):this.lastFramerateInput===0&&(this.timeoutId?this.disposeTimer():(this.logger.info(`onVideoCaptureFreeze end for trackId: ${c.trackIdentifier}`),this.event("onVideoCaptureFreeze").raise(!1,!this.effectsManager.isEffectEnabled("Video")))),this.lastFramerateInput=u):this.logger.safe.warn("WebRTC Stats for send video not found"))}onStatisticsChanged(n){if(!this.trackInfo.length||!this.configProvider.config.videoCaptureFreezeTimeout)return;let a;Object.keys(n.localVideoStreams).forEach(s=>{const c=n.localVideoStreams[s];this.trackInfo.some(u=>u.trackId===c.trackId)&&(!a||a.frameRateInput<c.frameRateInput)&&(a=c)}),a?a.frameRateInput!==this.lastFramerateInput&&(a.frameRateInput===0?this.scheduleCaptureFreezeStart(a.trackId,!this.effectsManager.isEffectEnabled("Video")):this.lastFramerateInput===0&&(this.timeoutId?this.disposeTimer():(this.logger.info(`onVideoCaptureFreeze end for trackId: ${a.trackId}`),this.event("onVideoCaptureFreeze").raise(!1,!this.effectsManager.isEffectEnabled("Video")))),this.lastFramerateInput=a.frameRateInput):this.logger.safe.warn("WebRTC Stats for send video not found")}onVideoFreezeDetected(n){this.logger.info(`onVideoCaptureFreeze, webcam freeze detected trackId: ${n}`),this.event("onVideoCaptureFreeze").raise(!1,!0)}scheduleCaptureFreezeStart(n,a){this.timeoutId=window.setTimeout(()=>{this.timeoutId=null,this.logger.safe.info(`onVideoCaptureFreeze start for trackId: ${n} (isWebcamStream: ${a})`),this.event("onVideoCaptureFreeze").raise(!0,a)},this.configProvider.config.videoCaptureFreezeTimeout)}disposeTimer(){this.timeoutId&&(clearTimeout(this.timeoutId),this.timeoutId=null)}handleDeviceManagerChange(){this.videoEffectManagerSubscription?.dispose(),this.videoEffectManagerSubscription=this.effectsManager.on("videoFreezeDetected",n=>this.onVideoFreezeDetected(n))}},J_i=class{constructor(n){this.queue=[],this.logger=n}cleanup(){this.queue.forEach(n=>{n.reject({notSent:n.tones})}),this.queue=[]}waitForNotification(n){return n?(this.logger.unsafe.info("sending dtmf tones: ",n),new Promise((a,s)=>{this.queue.push({tones:n,resolve:a,reject:s})})):Promise.reject(new Error("invalid input"))}toneSent(n){this.queue[0]&&(n===this.queue[0].tones[0]?(this.queue[0].tones=this.queue[0].tones.substr(1),this.queue[0].tones===""&&(this.queue[0].resolve(),this.queue.shift())):(this.queue[0].reject(new Error(`sent tone does not match: expected '${this.queue[0].tones[0]}' got '${n}'`)),this.queue.shift(),this.toneSent(n)))}},Y_i=class{constructor(n){this.webRtcSender=null,this.configProvider=n.configProvider,this.queue=new J_i(n.logger)}sendDtmf(n,a){return n?.getSenders?(this.syncSender(n),this.webRtcSender?(this.webRtcSender.ontonechange=this.onToneChange.bind(this),this.webRtcSender.insertDTMF(this.webRtcSender.toneBuffer+a,this.configProvider.config.dtmf.toneDuration,this.configProvider.config.dtmf.toneGap),this.queue.waitForNotification(a)):Promise.reject(new Error("not available"))):Promise.reject(new Error("bad peerConnection"))}canSendDtmf(n){return!!n?.getSenders&&(this.syncSender(n),!!this.webRtcSender&&this.webRtcSender.canInsertDTMF)}dispose(){this.queue.cleanup()}syncSender(n){const a=n.getSenders().filter(s=>s.track&&s.track.kind==="audio").filter(s=>s.dtmf?.canInsertDTMF)[0];this.webRtcSender&&a&&a.dtmf!==this.webRtcSender&&(this.webRtcSender.ontonechange=null,this.queue.cleanup()),this.webRtcSender=a?a.dtmf:null}onToneChange(n){n.tone&&this.queue.toneSent(n.tone)}},iYe={build:n=>new Y_i(n)},Q_i=class extends jr{constructor(n,a,s,c,u){super(s),this.pc=n,this.cryptoMethod=a,this.logger=s,this.configProvider=c,this.diagnostics=u,this.iceConnectionStateInternal="new",this.isWaitingAcceptProvisionalInternal=!1,this.state="new",this.toBeCalledOnConnected=[],this.toBeCalledOnProvisionalConnected=[],this.handleSignalingStateChange=()=>{const m=this.pc.signalingState,b=this.signalingStateInternal;if(this.logger.safe.info(`RTCPeerConnection onsignalingstatechange signalingState: ${this.signalingStateInternal} -> ${m}`),this.signalingStateInternal=m,this.diagnostics.signalingState=m,this.event("signalingStateChanged").raise(this.signalingStateInternal,b,hi()),!this.configProvider.config.useDtlsTrasportConnectionCheck||this.transport||this.cryptoMethod!==1||this.hasPcConnectionState)return;const _=this.pc.getReceivers().find(k=>!!k.transport);this.transport=_?.transport,this.transport&&(this.transport.onstatechange=this.handleDtlsTransportStateChange)},this.handleIceConnectionStateChange=()=>{const m=this.pc.iceConnectionState;this.logger.safe.info(`RTCPeerConnection oniceconnectionstatechange iceConnectionState: ${m} pc.signalingState: ${this.pc.signalingState}`),this.iceConnectionStateInternal=m,this.diagnostics.iceConnectionState=m,this.event("iceConnectionStateChanged").raise(this.iceConnectionStateInternal,hi()),this.shouldRaise(0)&&this.updateState(m)},this.handleConnectionStateChange=()=>{const m=this.pc.connectionState;this.logger.safe.info(`RTCPeerConnection onconnectionStatechange connectionState: ${m} pc.signalingState: ${this.pc.signalingState}`),this.connectionStateInternal=m,this.diagnostics.connectionState=m,this.event("connectionStateChanged").raise(this.connectionStateInternal,hi()),this.shouldRaise(1)&&this.updateState(m)},this.handleDtlsTransportStateChange=()=>{const m=this.transport.state;this.logger.safe.info(`RTCDtlsTransport onstatechange state: ${m} pc.signalingState: ${this.pc.signalingState}`),this.dtlsStateInternal=m,this.diagnostics.dtlsTransportState=m,this.event("dtlsTransportStateChanged").raise(this.dtlsStateInternal,hi()),this.shouldRaise(3)&&this.updateState(m)},this.iceConnectionStateInternal=this.pc.iceConnectionState,this.connectionStateInternal=this.pc.connectionState,this.signalingStateInternal=this.pc.signalingState,this.pc.oniceconnectionstatechange=this.handleIceConnectionStateChange,this.pc.onsignalingstatechange=this.handleSignalingStateChange,this.logger.safe.debug(`ctor ctryptoMethod ${this.cryptoMethod===1?"dtls":"sdes"}, hasPcConnectionState ${this.hasPcConnectionState}`),this.cryptoMethod===1&&this.hasPcConnectionState&&(this.pc.onconnectionstatechange=this.handleConnectionStateChange),this.diagnostics.hasConnectionState=this.hasPcConnectionState}get hasPcConnectionState(){return"connectionState"in this.pc&&this.configProvider.config.useConnectionState}get isWaitingAcceptProvisional(){return this.isWaitingAcceptProvisionalInternal}set isWaitingAcceptProvisional(n){this.isWaitingAcceptProvisionalInternal!==n&&(this.logger.safe.debug(`isProvisional set ${this.isWaitingAcceptProvisionalInternal} -> ${n}`),this.isWaitingAcceptProvisionalInternal=n,this.diagnostics.provisional=n,this.updateState(this.state,!1))}get iceConnectionState(){return this.iceConnectionStateInternal}get signalingState(){return this.signalingStateInternal}get isIceConnected(){return this.iceConnectionStateInternal==="connected"||this.iceConnectionStateInternal==="completed"}get isTransportConnected(){return this.state==="connected"||this.state==="completed"}get isFailed(){return this.configProvider.config.transportStateFailedFix?this.state==="failed":this.state==="failed"||this.state==="closed"}get isConnected(){return this.isTransportConnected&&this.signalingStateInternal!=="closed"}doOnConnected(n,a="unknown",s=!1,c=!0){return this.diagnostics.scheduleDoOnConnected(n,a,s,c),c&&this.isConnected&&(s||!this.isWaitingAcceptProvisionalInternal)?(this.logger.safe.info(`Running callback immediately ${a}`),this.diagnostics.runDoOnConnected(n,!0),void n()):s?(this.logger.safe.info(`Queuing provisional connected callback '${a}'`),void this.toBeCalledOnProvisionalConnected.push(n)):(this.logger.safe.info(`Queuing connected callback '${a}'`),void this.toBeCalledOnConnected.push(n))}dispose(){this.pc.oniceconnectionstatechange=void 0,this.pc.onsignalingstatechange=void 0,this.transport&&(this.transport.onstatechange=void 0),this.pc.onconnectionstatechange&&(this.pc.onconnectionstatechange=void 0),this.diagnostics.dispose()}updateState(n,a=!0){if(a&&(this.statePrevious=this.state),this.state=n,this.event("stateChanged").raise(this.state,this.statePrevious,hi()),this.diagnostics.transportState=n,this.isConnected){if(!this.isWaitingAcceptProvisionalInternal&&this.toBeCalledOnConnected.length)for(this.logger.safe.info(`Running ${this.toBeCalledOnConnected.length} callbacks on connected`);this.toBeCalledOnConnected.length;){const s=this.toBeCalledOnConnected.shift();this.diagnostics.runDoOnConnected(s),s()}if(this.toBeCalledOnProvisionalConnected.length)for(this.logger.safe.info(`Running ${this.toBeCalledOnProvisionalConnected.length} callbacks on provisional connected`);this.toBeCalledOnProvisionalConnected.length;){const s=this.toBeCalledOnProvisionalConnected.shift();this.diagnostics.runDoOnConnected(s),s()}}}shouldRaise(n){switch(n){case 3:if(this.cryptoMethod!==1)throw new Error(`DTLS transport is used with cryptoMethod=${this.cryptoMethod}`);return!this.configProvider.config.ignoreClosedDtlsTransportState||this.transport.state!=="closed";case 1:return this.cryptoMethod===1&&!this.transport;case 0:return!(!this.configProvider.config.ignoreClosedDtlsTransportState||!this.transport||this.pc.iceConnectionState!=="closed")||this.cryptoMethod===0||!this.transport&&!this.hasPcConnectionState||this.transport&&this.pc.iceConnectionState==="disconnected"||this.transport?.state==="connected"&&this.pc.iceConnectionState==="connected";default:return this.logger.safe.error(`unknown StateMethod=${n}`),!1}}},nYe=class{constructor(n,a,s,c,u,m){this.logger=n,this.emulator=a,this.qualityManager=s,this.diagnostics=c,this.configProvider=u,this.statsGatherer=m,this.previousSequenceNumber=new Map,this.modifiers=this.configProvider.mediaConfig.simulcastSessionEnabled?[]:[new CJe(this.logger.createChild("rembModifier"),this.qualityManager,this.configProvider)]}dispose(){this.cleanupDevToolsInjector(),this.modifiers&&(this.modifiers.forEach(n=>n.dispose()),this.modifiers=null),this.emulator=null,this.logger=this.logger.createChild("DISPOSED")}handleMessage(n){const a=n.controlInfo[0].sourceId;if(this.previousSequenceNumber.has(a)&&n.sequenceNumber<this.previousSequenceNumber.get(a))return this.statsGatherer.addVideoControlMessage(!0),this.diagnostics?.addVideoControlMessage(!0),this.logger.safe.info(`Discarded old media stream control message for sourceId ${a}: (${JSON.stringify(n)})`),Promise.resolve();this.previousSequenceNumber.set(a,n.sequenceNumber),this.statsGatherer.addVideoControlMessage(),this.diagnostics?.addVideoControlMessage(),this.configProvider.config.enableDevtoolsAPI&&this.injectFmtpHandler(n);const s={controlVideoStreaming:n};return this.configureResolution(s),this.modifiers.length?(this.modifiers.forEach(c=>c.setVideoControlMessage(s)),this.emulator.renegotiate(this.modifiers)):Promise.resolve()}configureResolution(n){this.logger.safe.info(`Signaling FMTP: ${JSON.stringify(n.controlVideoStreaming)}`);const a=String(n.controlVideoStreaming.sequenceNumber),s=n.controlVideoStreaming.controlInfo[0].fmtParamsList,c=n.controlVideoStreaming.controlInfo[0].fmtParams,u=s&&this.configProvider.config.webrtcFmtParamListSupported?this.parseFmtParamsList(s):[this.parseFmtParams(c)],m=+n.controlVideoStreaming.controlInfo[0].sourceId,b=[{causeId:a,isSimulcast:u.some(_=>_.rid!==void 0)||u.length>1,capabilities:u,sourceId:m}];this.qualityManager.setMaxCapabilities(b)}parseFmtParamsList(n){return n.map(a=>this.parseFmtParams(a))}parseFmtParams(n){const a=new sE(n);return{maxFs:+a.get(ke.VIDEO_CAPABILITIES.MAX_FS_PATH),maxMbps:+a.get(ke.VIDEO_CAPABILITIES.MAX_MBPS_PATH),maxFps:+a.get(ke.VIDEO_CAPABILITIES.MAX_FPS_PATH)/100,maxBr:1200*+a.get(ke.VIDEO_CAPABILITIES.MAX_BR_PATH),ssrc:+a.get(ke.VIDEO_CAPABILITIES.SSRC_PATH),rid:a.get(ke.VIDEO_CAPABILITIES.RID_PATH),keyframe:this.shouldGenerateKeyFrame(a),vlaDebug:a.get(ke.VIDEO_CAPABILITIES.VLA_DEBUG)}}shouldGenerateKeyFrame(n){return n.get(ke.VIDEO_CAPABILITIES.KEYFRAME_PATH)?!!+n.get(ke.VIDEO_CAPABILITIES.KEYFRAME_PATH):this.configProvider.config.webrtcAllowRestoreKeyframe}injectFmtpHandler(n){const a=window;a?.webMA&&(a.webMA.fmtp||(a.webMA.fmtp={handleMessage:this.handleMessage.bind(this)}),a.webMA.fmtp.lastFmtp=n)}cleanupDevToolsInjector(){const n=window;n?.webMA&&delete n.webMA.fmtp}},iq=(n=>(n[n.ThreeStreamSimulcast=0]="ThreeStreamSimulcast",n[n.HardwareEncoder=1]="HardwareEncoder",n[n.Encode1080P=2]="Encode1080P",n[n.BroadcastMode=3]="BroadcastMode",n))(iq||{}),aYe=class extends jr{constructor(n,a){super(a),this.mediaType=n,this.logger=a,this.features={}}notify(){super.raiseChanged()}find(n){var a;return(a=this.features)[n]??(a[n]={})}set(n,a,s){const c=this.find(n);let u=!1;return a!==void 0&&c.server!==a&&(this.logger.safe.info(`Server support for [${this.mediaType}][${iq[n]}] changed from ${c.server} to ${a}`),c.server=a,u=!0),s!==void 0&&c.client!==s&&(this.logger.safe.info(`Client support for [${this.mediaType}][${iq[n]}] changed from ${c.client} to ${s}`),c.client=s,u=!0),u}toggleServer(n,a){return!!this.set(n,a,void 0)&&(this.notify(),!0)}toggleClient(n,a){return!!this.set(n,void 0,a)&&(this.notify(),!0)}toggle(n,a){return!!this.set(n,a,a)&&(this.notify(),!0)}hasAnySupport(n){const a=this.find(n);return a.client===!0||a.server===!0}hasFullSupport(n){const a=this.find(n);return a.client===!0&&a.server===!0}hasClientSupport(n){return this.find(n).client===!0}hasServerSupport(n){return this.find(n).server===!0}},Z_i=class extends jr{constructor(n){super(n),this.logger=n,this.modalities={Video:new aYe("Video",this.logger),ScreenShare:new aYe("ScreenShare",this.logger)},this.blocked=new Set;for(const a of Object.keys(this.modalities))this.modalities[a].changed(()=>{this.notify(this.modalities[a],!1)})}notify(n,a){this.blocked.has(n.mediaType)&&a!==!0||(this.blocked.add(n.mediaType),this.logger.safe.info(`Notify: ${n.mediaType}`),this.event("onVideoFeaturesChanged").raise(n),this.blocked.delete(n.mediaType))}manageFeatureSupport(n){for(const a of Object.values(this.modalities))this.blocked.add(a.mediaType);n();for(const a of[...this.blocked])this.notify(this.modalities[a],!0)}get(n){if(!this.modalities[n])throw this.logger.safe.error(`Unsupported media type: ${n}`),new Error(`Unsupported media type: ${n}`);return this.modalities[n]}},rYe=class kae{constructor(a){this.configProvider=a}getVideoControlMessage(a,s,c){const u={controlVideoStreaming:{sequenceNumber:++kae.sequence,globalTimeStamp:new Date().toString(),controlInfo:[{control:"start",sourceId:s,streamMsid:a}]}};return c&&(u.controlVideoStreaming.controlInfo[0].fmtParams=TKe(c)),u}getSourceRequestMessage(a,s,c,u){if(!c)throw new Error("Failed to construct SourceRequestMessage, missing fmtParams");const m={sourceId:s,streamMsid:a,fmtParams:c};return m.subStreamIndex=u,{type:"sr",controlVideoStreaming:{sequenceNumber:++kae.sequence,controlInfo:m}}}getSignalingSourceRequestMessage(a,s,c,u,m){if(!u)throw new Error("Failed to construct SourceRequestMessage, missing fmtParams");const b={sourceId:s,streamMsid:a,fmtParams:u};return b.subStreamIndex=m,{applyChannelParameters:{multiChannelParameter:{mids:[c],mediaParameter:JSON.stringify({controlVideoStreaming:{sequenceNumber:++kae.sequence,controlInfo:b}})}}}}getBandwidthInfoMessage(a){return{type:"ssbwe",BwMessage:a}}getMaxVideoSendCapabilitiesMessage(a){const{streamMIDs:s,capabilities:c,useMax:u,sendMaxFs:m,sendMaxMbps:b}=a;let _=gN(c.maxWidth),k=gN(c.maxHeight);u&&(_=k=Math.max(_,k));const N={[ke.VIDEO_CAPABILITIES.MAX_FPS_PATH]:c.maxFps,[ke.VIDEO_CAPABILITIES.MAX_WIDTH]:_,[ke.VIDEO_CAPABILITIES.MAX_HEIGHT]:k};return m&&(N[ke.VIDEO_CAPABILITIES.MAX_FS_PATH]=c.maxFs),b&&(N[ke.VIDEO_CAPABILITIES.MAX_MBPS_PATH]=c.maxMbps),{applyChannelParameters:{multiChannelParameter:{mids:s,mediaParameter:JSON.stringify({maxVideoSendCapabilities:{caps:N}})}}}}getMaxVideoSendCapabilitiesContent(a,s,c,u){const m={};if(c){let ee=gN(c.maxWidth),oe=gN(c.maxHeight);this.configProvider.config.maxSendVideoCapabilities.useMaximumWidthHeight&&(ee=oe=Math.max(ee,oe)),m[ke.VIDEO_CAPABILITIES.MAX_WIDTH]=ee,m[ke.VIDEO_CAPABILITIES.MAX_HEIGHT]=oe,m[ke.VIDEO_CAPABILITIES.MAX_FPS_PATH]=c.maxFps,this.configProvider.config.maxSendVideoCapabilities.sendMaxFs&&(m[ke.VIDEO_CAPABILITIES.MAX_FS_PATH]=c.maxFs),this.configProvider.config.maxSendVideoCapabilities.sendMaxMbps&&(m[ke.VIDEO_CAPABILITIES.MAX_MBPS_PATH]=c.maxMbps)}else u&&[ke.VIDEO_CAPABILITIES.MAX_WIDTH,ke.VIDEO_CAPABILITIES.MAX_HEIGHT,ke.VIDEO_CAPABILITIES.MAX_FPS_PATH,ke.VIDEO_CAPABILITIES.MAX_FS_PATH,ke.VIDEO_CAPABILITIES.MAX_MBPS_PATH].forEach(ee=>{u[ee]&&(m[ee]=u[ee])});const b=a.getSimulcastContext();let _,k,N,W;if(b&&b.config.layerScaleFactors.length>2&&(_=b.config.layerScaleFactors.length,k=b.config.layerScaleFactors.length,s.hasClientSupport(0)||(k=2),this.configProvider.config.minFrameSizeForThreeStreamSimulcast&&c&&c.maxFs<this.configProvider.config.minFrameSizeForThreeStreamSimulcast&&(k=2)),_!==void 0&&(m[ke.VIDEO_CAPABILITIES.MAX_STREAMS]=_),k!==void 0&&(m[ke.VIDEO_CAPABILITIES.MAX_LAYERS]=k),s.hasClientSupport(3)&&this.configProvider.config.broadcastMode?.prioritizeLayoutOnServer){const ee=this.configProvider.config.broadcastMode;ee.priorityLayoutMinFS&&ee.priorityLayoutMinFPS&&(W=ee.priorityLayoutMinFS,W*=ee.priorityLayoutMinFPS),ee.priorityLayoutMinBitrate&&(N=ee.priorityLayoutMinBitrate)}return N&&(m[ke.VIDEO_CAPABILITIES.PRIORITY_LAYOUT_MIN_BITRATE]=N),W&&(m[ke.VIDEO_CAPABILITIES.PRIORITY_LAYOUT_MIN_MBPR]=W),s.hasClientSupport(1)&&this.configProvider.config.preferredHardwareLadderType&&(m[ke.VIDEO_CAPABILITIES.LADDER_TYPE]=this.configProvider.config.preferredHardwareLadderType),m}getMultiChannelParametersMessage(a,s){return{applyChannelParameters:{multiChannelParameter:{mids:a,mediaParameter:JSON.stringify(s)}}}}};rYe.sequence=0;var X_i=rYe,oYe=class{constructor(n,a,s,c){this.logger=n,this.configProvider=a,this.sender=s,this.mediaControlPlane=c,this.messageGenerator=new X_i(this.configProvider),this.lastVideoSendMaxCapabilities={}}sendSourceRequest(n,a,s,c,u){if(this.configProvider.config.useApplyChannelParametersForSourceRequests){const b=this.messageGenerator.getSourceRequestMessage(n,a,c,u),_=this.messageGenerator.getSignalingSourceRequestMessage(n,a,s,c,u);return this.sendMessage("ApplyChannelParametersSourceRequest",b,_)}const m=this.messageGenerator.getVideoControlMessage(n,a,c?.[0]);return this.sendMessage("ControlVideoStreaming",m)}sendMaxVideoSendCapabilities(n,a){const s=this.messageGenerator.getMaxVideoSendCapabilitiesMessage({streamMIDs:n,capabilities:a,sendMaxFs:this.configProvider.config.maxSendVideoCapabilities.sendMaxFs,sendMaxMbps:this.configProvider.config.maxSendVideoCapabilities.sendMaxMbps,useMax:this.configProvider.config.maxSendVideoCapabilities.useMaximumWidthHeight});return this.sendMessage("ApplyChannelParametersVideoCapabilities",s)}async sendBandwidthInfo(n){const a=this.messageGenerator.getBandwidthInfoMessage(n);return this.mediaControlPlane?.sendMsg(a)}sendMaxVideoSendCapabilitiesV2(n,a,s){if(this.lastVideoSendMaxCapabilities[n.getMid()]===void 0){if(!s)return this.logger.safe.info("Skip sending empty max-capabilities message"),Promise.resolve();this.lastVideoSendMaxCapabilities[n.getMid()]={}}const c=this.messageGenerator.getMaxVideoSendCapabilitiesContent(n,a,s,this.lastVideoSendMaxCapabilities[n.getMid()]);if(s||!xc(this.lastVideoSendMaxCapabilities[n.getMid()],c)){this.lastVideoSendMaxCapabilities[n.getMid()]=c;const u=this.messageGenerator.getMultiChannelParametersMessage([n.getMid()],{maxVideoSendCapabilities:{caps:c}});return this.sendMessage("ApplyChannelParametersVideoCapabilities",u)}return this.logger.safe.info("Skip sending duplicate max-capabilties message"),Promise.resolve()}async sendMessage(n,a,s){let c;return n==="ApplyChannelParametersSourceRequest"&&(c=a.controlVideoStreaming.sequenceNumber),this.logger.safe.info(`sending video control message: ${JSON.stringify(a)}`),this.sender.send(n,a,c,s)}},eEi=0,tEi=class DQe{constructor(a,s,c){this.context=a,this.callId=s,this.callback=c,this.callbacks={},this.multiParty=this.context.config?.isConference,this.configProvider=this.context.configProvider,this.logger=this.context.getLogger().createChild("webrtc-"+ ++eEi),this.deviceManager=this.context.callDeviceManager.getDefaultDeviceManager(),this.webrtcAdapter=U_i.build({global:this.context.maContext,configProvider:this.configProvider}),this.iceHostCandidateOnly=this.multiParty&&lw("iceHostCandidateOnly",this.context.config,this.configProvider.config),this.mediaManager=new z_i({logger:this.logger,configProvider:this.configProvider,numVideoChannels:this.multiParty&&this.configProvider.config.numVideoChannelsGvc||1,useSimulcast:!1}),this.sessionDescription=YKe.build({sdpTransform:new this.webrtcAdapter.SdpTransform(this.context),mediaManager:this.mediaManager,logger:this.logger,configProvider:this.configProvider,configuration:this.getStreamTransformConfiguration()}),this.allowedMediaContentType=lw("webrtcAllowedMediaContentType",this.context.config,this.configProvider.config).concat(),this.receiveStreamCollection=new TJe({streamAdded:u=>this.streamAdded(u),streamRemoved:u=>this.streamRemoved(u)}),this.stats=new UJe(this.logger.createChild("stats"),this.configProvider,void 0,this.mediaManager,this.multiParty),this.maxResolution=this.multiParty?yl.Send.getResolutionByFs(this.configProvider.config.webrtcMultipartyMaxScalingFs):yl.Send.getResolutionByFs(this.configProvider.config.webrtcMaxScalingFs),this.qualityManager=new ZJe(this.logger.createChild("qm"),{scalingEnabled:this.configProvider.config.webrtcVideoScaling,cooldownTimeout:this.configProvider.config.webrtcResolutionManagerCooldownTimeout,retryDelay:this.configProvider.config.webrtcResolutionManagerRetryDelay,maxResolution:this.maxResolution,customBwEstimationEnabled:!0},{onReceiveCapabilitiesChanged:(u,m,b)=>this.applyCapabilitiesForModality(u,m,b)},this.stats,void 0,this.configProvider),this.localVideoStreamWatcher=new tYe(this.logger,this.configProvider,this.context.callDeviceManager),this.activeSpeakerManager=new bJe(this.callback.onContributingSourcesChanged,this.callback.onDominantSpeakerChanged,this.logger.createChild("ActiveSpeakerManager")),this.senders={},this.negotiationQueue=new iL(this.logger),this.negotiationEmulator=new JJe(this.logger.createChild("negotiationEmulator"),this.webrtcAdapter.RTCSessionDescription,this.sessionDescription,this.negotiationQueue,this.mediaManager),this.streamConfigurationHandler=new nYe(this.logger,this.negotiationEmulator,this.qualityManager,null,this.configProvider,this.stats),this.mediaMessageController=new oYe(this.logger,this.configProvider,{send:this.context.sendWebRtcMediaNotificationAsyncCallback}),this.toBeCalledAfterConnected=[],this.iceTransportPolicy=this.configProvider.config.iceTransportPolicyForced||this.context.config.iceTransportPolicy||ke.ICE_TRANSPORT_POLICY.all,this.isMuteHold=!1,this.peerConnection=null,this.mediaStreams=new Map,this.doAudioMute=this.context.config.muted,this.iceCandidatesDeferred=new Pi,this.relayCandidateGathered=!1,this.iceCandidatesTimer=null,this.triggerRenegotiationFlag=!1,this.canTriggerRenegotiation=!0,this.noIceCandidates=!1,this.noRelayIceCandidates=!1,this.forceMediaStreamUpdate=!1,this.negotiatedModalities={},this.disabledModalities={},this.iceDisconnectedTimer=null,this.statisticsReport=Promise.resolve({}),this.terminated=!1,this.initiator=!1,this.streamsChangedListener=null,this.dtmfSender=iYe.build({logger:this.logger,configProvider:this.configProvider}),this.mediaContentType=lw("webrtcMediaContentType",this.context.config,this.configProvider.config),this.streamsChangedNotificationScheduled=!1,this.subscriptionManager=new SKe(this.logger.createChild("subs"),this.configProvider,{getStreams:()=>this.getStreams(),setOnStreamsChangedHandler:u=>this.onStreamsChanged(u)}),this.remoteVideoResolutionManager=new XJe(this.logger.createChild("rvrm"),this.multiParty,this.configProvider,this.mediaManager,this.stats),this.remoteVideoManager=new eYe(this.logger.createChild("RemoteVideoManager"),this.configProvider,this.stats,void 0,this.remoteVideoResolutionManager,this.context.maContext.domOverrides),this.hwSilent=!1,this.configuredModalitiesPromise=Promise.resolve(),this.negotiationCompletedPromise=new Pi,this.ssrcGenerator=new ETe,this.ssrcs={Audio:this.getSsrcRangeForMediaType("Audio"),Video:this.getSsrcRangeForMediaType("Video"),ScreenShare:this.getSsrcRangeForMediaType("ScreenShare")},this.forceKeyFramePromise=null,this.transportStateProvider={isFailed:this.isFailed.bind(this),isConnected:this.isConnected.bind(this)},this.ufdManager=a.getUfdManager(),this.stats.on("onStatisticsChanged",u=>{this.remoteVideoManager.processLegacyStats(u),this.localVideoStreamWatcher?.onStatisticsChanged(u),this.updateQualityLevels(u)}),this.negotiationCompletedPromise.promise.catch(()=>{}),this.negotiationCompletedPromise.reject("placeholder"),this.remoteVideoResolutionManager.on("onNegotiationRequired",()=>this.triggerRenegotiation(!0)),this.remoteVideoResolutionManager.on("onSourceRequestRequired",(u,m,b)=>this.requestSource(u,m,b)),this.setSubsForSubscriptionManager(),this.localVideoStreamWatcher.on("onVideoCaptureFreeze",u=>{this.isConnected()&&this.ufdManager.signalEvent("VideoCaptureDeviceFreeze",u?"Bad":"Good","Video")}),this.configProvider.mediaConfig.maxBandwidthInKbps&&this.stats.setMaxSessionBandwidth(this.configProvider.mediaConfig.maxBandwidthInKbps),this.createAudioRenderer(),this.configProvider.config.webrtcVideoScaling&&this.onOptimalVideoReceiversCountChanged(this.configProvider.config.nonEstimatedDefaultVideoReceiversCount)}get audioStream(){return this.mediaStreams.get("Audio")}get videoStream(){return this.mediaStreams.get("Video")}get displayStream(){return this.mediaStreams.get("ScreenShare")}useNullAudioStreamClient(){}getIncomingRawAudioStream(){return null}configureSpatialAudio(a,s){}setParticipantSpatialAudioPositions(a,s){}getAcceptedTypes(){return this.allowedMediaContentType}clone(a=!1){const s=Xp(this.context);s.config=Xp(this.context.config),s.config.webrtcMediaContentType=this.mediaContentType,s.config.webrtcAllowedMediaContentType=this.allowedMediaContentType,a?s.config.isConference=!0:(s.config.iceHostCandidateOnly=!1,this.configProvider.config.waitForRelayOnReconnect&&(s.config.webrtcIceGatheringTimeoutIncreased=!0));const c=new DQe(s,this.callId,this.callback);return this.relayManagerProvider&&(c.relayManagerProvider=this.relayManagerProvider),c.callbacks.onNegotiationRequired=this.callbacks.onNegotiationRequired,c}setInternals(a){a.subscriptionManager&&(this.subscriptionManager&&this.subscriptionManager.dispose(),this.subscriptionManager=a.subscriptionManager,this.subscriptionManager.setStreamProvider({getStreams:()=>this.getStreams(),setOnStreamsChangedHandler:s=>this.onStreamsChanged(s)}),this.setSubsForSubscriptionManager(),this.subscriptionManager.reriseSubscribeEvents(),this.notifyStreamsChanged()),a.audioRenderer&&(a.audioRenderer.play(this.audioRenderer.getStream()),this.audioRenderer=a.audioRenderer),a.remoteVideoManager&&a.remoteVideoManager.moveRenderers(this.remoteVideoManager)}setSubsForSubscriptionManager(){this.subscriptionManagerSubs=[this.subscriptionManager.on("onTrackIdsChanged",a=>this.stats.setSubscribedTrackIds(a)),this.subscriptionManager.on("onTrackSsrcChanged",a=>this.stats.setSubscribedTrackSsrc(a)),this.subscriptionManager.on("onSubscriptionChanged",(a,s,c,u,m,b)=>this.stats.addSubscriptionEvent(a,s,c,u,null,m,b)),this.subscriptionManager.on("onSubscriptionFailed",(a,s,c,u,m)=>this.stats.addSubscriptionEvent(a,s,c,u,m))]}move(a,s){a.setInternals({subscriptionManager:this.subscriptionManager,audioRenderer:this.audioRenderer,remoteVideoManager:this.remoteVideoManager}),a.muteHold(this.isMuteHold,s),this.doAudioMute?a.muteInputAsync(s):a.unmuteInputAsync(s),this.subscriptionManager=null,this.audioRenderer=null,this.callbacks.onTerminated=null}setMute(a,s,c){this.logger.safe.info(`[${c}] call setMuteAsync with mute state ${s}, audio stream exists: ${!!this.audioStream}`),a==="Audio"&&this.audioStream?this.audioStream.setMuted(s,c):a==="Video"&&this.videoStream?this.videoStream.setMuted(s,c):a==="ScreenShare"&&this.displayStream&&this.displayStream.setMuted(s,c),this.updateQualityLevels(this.stats.getLastStatistics())}setCallConstraints(a,s){return Promise.reject(new Error("Not supported"))}configureModalitiesAsync(a,s){const c=this.configuredModalitiesPromise.then(()=>{if(!a||!a.audio&&!a.video&&!a.sharing)throw new Error(`Invalid parameters! ${JSON.stringify(a)}`);const u=!this.configuredModalities||!Aye(a,this.negotiatedModalities);return this.configuredModalities=a,this.logger.safe.info(`[${s}] configure modalities`,`audio: ${a.audio}`,`video: ${a.video}`,`sharing: ${a.sharing}`,`peerconnection: ${!!this.peerConnection}`,`pc.signalingState: ${this.peerConnection?this.peerConnection.signalingState:"-"}`,`needNewRenegotiation: ${u}`),u&&this.triggerRenegotiation(!1,s),this.configuredModalities});return this.configuredModalitiesPromise=c.catch(u=>{this.logger.safe.warn(`[${s}] Error during configuring modalities: ${nn(u)}`)}).then(()=>{}),c.then(()=>{})}getConfiguredModalities(){return this.configuredModalities}getDisabledModalities(){return this.disabledModalities}getSubscriptionManager(){return null}createAudioElement(a){}createOfferAsync(a){const s=this.negotiationQueue.add(()=>new Promise(c=>{this.logger.safe.info(`[${a}] create [offer] configured: ${JSON.stringify(this.configuredModalities)}`),this.initiator=!0,this.throwIfModalitiesNotConfigured("no configured modalities to create offer for"),this.canTriggerRenegotiation=!1,this.negotiatingModalities=this.configuredModalities,this.offeredModalities=this.negotiatingModalities,this.configProvider.config.webrtcNegotiateDisabledDataModality&&!this.offeredModalities[ke.MODALITY.data]&&this.multiParty&&(this.offeredModalities[ke.MODALITY.data]=ke.MEDIA_STATE.inactive),$g(this.offeredModalities)&&!Am(this.negotiatedModalities)&&Object.keys(this.offeredModalities).forEach(u=>{this.negotiatedModalities[u]===void 0&&delete this.offeredModalities[u]}),c(this.updatePeerConnectionStreamsAsync(this.offeredModalities,!0,!0,a).then(()=>{const u=this.createNegotiationConstraints(this.offeredModalities);return this.logger.safe.info(`[${a}] create [offer] offered: ${JSON.stringify(this.offeredModalities)} constraints: ${JSON.stringify(u)}`),this.peerConnection.createOffer(u)}).then(u=>{this.logger.unsafe.debug(`[${a}] create [offer] offer from peer connection`,"sdp:",u.sdp);const m=this.sessionDescription.createLocalOffer(u.sdp);this.hasIceCandidates(m)||this.resetCandidateGathering(a),this.stats.startWaitingForStreamStart(this.offeredModalities);const b=new this.webrtcAdapter.RTCSessionDescription({sdp:m.toLocal(),type:"offer"});return this.setupIceGatheringTimeout(a),Promise.all([this.peerConnection.setLocalDescription(b),this.iceCandidatesDeferred.promise])}).then(()=>{const u=this.sessionDescription.createLocalOffer(this.peerConnection.localDescription.sdp);u.updateModalities(this.offeredModalities),this.checkIceCandidates(u);const m=u.toOffer();this.logger.unsafe.debug("CREATE OFFER","sdp:",m);const b={blob:m,contentType:this.mediaContentType};return this.configProvider.config.webrtcRequiredFeatures===""||this.multiParty||(b.requiredFeatures=this.configProvider.config.webrtcRequiredFeatures),this.configProvider.countryCode&&(b.clientLocation=this.configProvider.countryCode),this.doRetargetIfNeeded(b,u,a),b}))}),a);return this.resetNegotiationQueue(a),s}processOfferAsync(a,s){const c=this.negotiationQueue.add(()=>new Promise(u=>{const m=a.blob;if(this.logger.unsafe.debug(`[${s}] process [offer]`,"sdp:",m),this.configProvider.config.webrtcCompareContentTypeInOffer&&($ee(a.contentType,this.allowedMediaContentType),this.mediaContentType=a.contentType),a.requiredFeatures){const _=this.configProvider.config.webrtcRejectedFeatures.split(",");CG(a.requiredFeatures.split(","),_)}this.initiator=!1,this.offeredDescription=this.sessionDescription.createRemoteOffer(m),this.canTriggerRenegotiation=!1,this.offeredModalities=r9(this.offeredDescription.getModalities()),this.peerConnection||(this.context.configProvider.mediaConfig.isTransportUnbundled?this.context.configProvider.mediaConfig.isTransportUnbundled=this.offeredDescription.couldBeUnbundled():this.context.configProvider.mediaConfig.isTransportUnbundled=this.offeredDescription.isUnbundled());let b=Promise.resolve(this.offeredModalities);if(Ur(this.offeredModalities.video)||Rc(this.offeredModalities.video)||Ur(this.offeredModalities.sharing)||Rc(this.offeredModalities.sharing)){const _=this.offeredDescription.getVideoCodecs();b=this.webrtcAdapter.RTCRtpReceiver.getCapabilities("video").then(k=>{if(!k.codecs.some(N=>_.some(W=>N.mimeType===W))){this.logger.safe.warn(`[${s}] offer doesn't contain any supported video codecs`);const N=Xp(this.offeredModalities);return this.disabledModalities.video=N.video,this.disabledModalities.sharing=N.sharing,N.video=void 0,N.sharing=void 0,N}return this.offeredModalities}).catch(k=>(this.logger.safe.error(`[${s}] failed to get video capability ${nn(k)}`),this.offeredModalities))}u(b.then(_=>(this.logger.safe.info(`[${s}] process [offer] offered: ${JSON.stringify(this.offeredModalities)} acceptable: ${JSON.stringify(_)}`),_)))}),s);return this.resetNegotiationQueue(s),c}createAnswerAsync(a,s){return new Promise(c=>{if(a)return void c({blob:"",contentType:this.mediaContentType});this.logger.safe.info(`[${s}] create [answer] offered: ${JSON.stringify(this.offeredModalities)} configured: ${JSON.stringify(this.configuredModalities)}`),this.throwIfModalitiesNotConfigured("no configured modalities to create answer for"),this.negotiatingModalities=this.configuredModalities;let u=Eye(this.offeredModalities,this.negotiatingModalities);const m=this.offeredDescription.clone();c(this.updatePeerConnectionStreamsAsync(u,!0,!1,s).then(()=>this.handleCodecSwitchUnsupported(s)).then(()=>{this.offeredDescription.setModalities(u);const b=this.offeredDescription.toRemote();this.mediaManager.updateMediaEntitiesWithLocalTracks(),this.registerMediaSources();const _=new this.webrtcAdapter.RTCSessionDescription({sdp:b,type:"offer"});return this.updateDescriptor(_,m),this.logger.unsafe.info(`[${s}] create [answer] set remote description`,"negotiated:",u,"sdp:",_.sdp),this.peerConnection.setRemoteDescription(_)}).then(()=>(this.callbacks.onTransportInitialized&&this.callbacks.onTransportInitialized(),this.updatePeerConnectionStreamsAsync(u,!1,!0,s))).then(()=>(this.handleSharingRecvCapabilities(m),this.handleVideoRecvCapabilities(m))).then(()=>this.peerConnection.createAnswer()).then(b=>{this.logger.unsafe.debug(`[${s}] create [answer] answer from peer connection`,"sdp:",b.sdp);const _=this.sessionDescription.createLocalAnswer(b.sdp);this.hasIceCandidates(_)||this.resetCandidateGathering(s),this.stats.startWaitingForStreamStart(u);const k=new this.webrtcAdapter.RTCSessionDescription({sdp:_.toLocal(),type:"answer"});return this.setupIceGatheringTimeout(s),Promise.all([this.peerConnection.setLocalDescription(k),this.iceCandidatesDeferred.promise])}).then(()=>{const b=this.sessionDescription.createLocalAnswer(this.peerConnection.localDescription.sdp);b.updateModalities(u),this.checkIceCandidates(b);const _=b.toAnswer();u=b.getModalities(),BV(this.configProvider,this.configuredModalities,this.negotiatingModalities,u)||this.triggerRenegotiation(!0,s),this.setNegotiatedModalities(u),this.stats.sessionInfo.setBweType(b.getBweType()),this.logger.unsafe.debug("CREATE ANSWER","sdp:",_);const k={blob:_,contentType:this.mediaContentType};return this.configProvider.countryCode&&(k.clientLocation=this.configProvider.countryCode),k}))})}processAnswerAsync(a,s,c){const u=a.blob;if(this.logger.unsafe.debug(c?"PROCESS PRANSWER":"PROCESS ANSWER","sdp:",u),c)return this.logger.safe.info(`[${s}] process [pranswer] ignored`),Promise.resolve();this.mediaContentType=a.contentType,this.allowedMediaContentType.indexOf(this.mediaContentType)===-1&&this.allowedMediaContentType.push(this.mediaContentType);const m=this.sessionDescription.createRemoteAnswer(u),b=m.clone(),_=r9(m.getModalities());this.setNegotiatedModalities(_),m.setModalities(this.negotiatedModalities);const k=m.toRemote();this.mediaManager.updateMediaEntitiesWithLocalTracks(),this.registerMediaSources(),this.stats.sessionInfo.setBweType(m.getBweType());const N=new this.webrtcAdapter.RTCSessionDescription({sdp:k,type:"answer"});return this.updateDescriptor(N,b),this.logger.unsafe.info(`[${s}] process [answer] set remote description`,"negotiated:",this.negotiatedModalities,"sdp:",N.sdp),this.peerConnection.setRemoteDescription(N).then(()=>(this.callbacks.onTransportInitialized&&this.callbacks.onTransportInitialized(),this.negotiatedModalities)).then(()=>(this.handleSharingRecvCapabilities(b),this.handleVideoRecvCapabilities(b))).then(W=>{W&&this.triggerRenegotiation(!0,s)})}completeNegotiationAsync(a){return new Promise(s=>{this.mediaManager.commit();const c=this.configuredModalities,u=this.forceMediaStreamUpdate&&!$g(this.negotiatedModalities)||!BV(this.configProvider,c,this.negotiatingModalities,this.negotiatedModalities)||this.triggerRenegotiationFlag,m=!u;this.canTriggerRenegotiation=!0,this.logger.safe.info(`[${a}] negotiation completed isComplete: ${m} configured: ${JSON.stringify(this.configuredModalities)} negotiating: ${JSON.stringify(this.negotiatingModalities)} offered: ${JSON.stringify(this.offeredModalities)} negotiated: ${JSON.stringify(this.negotiatedModalities)}`),u&&this.triggerRenegotiation(!1,a),this.negotiationCompletedPromise.resolve(),s({isComplete:m,activeModalities:this.negotiatedModalities,offeredModalities:this.offeredModalities,attemptedModalities:this.negotiatingModalities,configuredModalities:this.configuredModalities,initiator:this.initiator})})}rejectNegotiationAsync(a,s,c=!1){return Promise.resolve().then(()=>{if(this.mediaManager.rollback(),this.logger.safe.warn(`[${s}] negotiation rejected isComplete: ${!c} error: ${nn(a)} configured: ${JSON.stringify(this.configuredModalities)} negotiating: ${JSON.stringify(this.negotiatingModalities)} offered: ${JSON.stringify(this.offeredModalities)} negotiated: ${JSON.stringify(this.negotiatedModalities)}`),this.peerConnection){if(this.peerConnection.signalingState==="have-local-offer")return this.logger.safe.info(`[${s}] rolling back local description`),this.configProvider.config.webrtcHandleRollback?(this.logger.safe.info(`[${s}] rolling back using local renegotiation`),this.negotiationEmulator.renegotiateNow().then(()=>{this.logger.safe.info(`[${s}] rolling back using local complete`)})):this.peerConnection.setLocalDescription(new this.webrtcAdapter.RTCSessionDescription({type:"rollback"}));this.logger.safe.error(`[${s}] cannot rollback local description in currrent state: ${this.peerConnection.signalingState}`)}}).then(()=>{this.canTriggerRenegotiation=!0,this.negotiationCompletedPromise.reject("negotiation rejected"),this.getAddedMediaTypes(this.negotiatedModalities,this.negotiatingModalities).forEach(u=>{this.removeTrackByMediaType(u),this.disposeStreamByMediaType(u)}),this.registerLocalStreams()}).then(()=>(c&&(this.logger.safe.info(`[${s}] retrying failed negotiation`),this.triggerRenegotiation(!1,s)),{isComplete:!c,activeModalities:this.negotiatedModalities,offeredModalities:this.offeredModalities,attemptedModalities:this.negotiatingModalities,configuredModalities:this.configuredModalities,initiator:this.initiator}))}startMediaDescriptionsUpdateAsync(a){return Promise.reject(new Error("Not supported"))}completeMediaDescriptionsUpdateAsync(a){return Promise.reject(new Error("Not supported"))}rejectMediaDescriptionsUpdateAsync(a,s){return Promise.reject(new Error("Not supported"))}createRemoteRenderer(a){return this.remoteVideoManager.createRenderer(a,this.subscriptionManager,this.logger)}getStatsAsync(a){return this.terminated||(this.statisticsReport=this.statisticsReport.then(()=>this.stats.getReport(a)).catch(s=>(this.logger.safe.error(`getting statistics should never fail: ${s.error}`),s.partialReport))),this.statisticsReport}getLastKnownStats(a=!1){return this.stats.getReport(!1,a)}muteHold(a,s){this.isMuteHold=a;const c=[ke.MODALITY.audio,ke.MODALITY.video,ke.MODALITY.sharing].filter(u=>Ur(this.negotiatedModalities[u])&&(u!==ke.MODALITY.audio||!this.doAudioMute));for(const u of c)this.setMute(kN(u),a,s)}async muteInputAsync(a){this.doAudioMute=!0,this.setMute("Audio",!0,a)}async unmuteInputAsync(a){this.doAudioMute=!1,this.setMute("Audio",!1,a)}muteOutputAsync(a){return this.audioRenderer.setMuted(!0,a),Promise.resolve()}unmuteOutputAsync(a){return this.audioRenderer.setMuted(!1,a),Promise.resolve()}async getSpeakerVolume(a){return this.audioRenderer.getSpeakerVolume(a)}async setSpeakerVolume(a,s){return this.audioRenderer.setSpeakerVolume(a,s)}sendDtmf(a){return this.dtmfSender.sendDtmf(this.peerConnection,a)}canSendDtmf(){return this.dtmfSender.canSendDtmf(this.peerConnection)}pauseNegotiations(a=hi()){const s=new Pi;return this.negotiationCompletedPromise.promise.catch(()=>{}).then(()=>{this.setNegotiationPromise(s,a)}),s}onDeviceEvent(a){this.stats.onDeviceEvent(a)}deviceSelectionChanged(){this.peerConnection&&(this.audioRenderer&&this.audioRenderer.getStream()&&this.audioRenderer.setOutputDevice(this.deviceManager.getOutputDeviceId()),$g(this.negotiatedModalities)||(this.forceMediaStreamUpdate=!0,this.triggerRenegotiation(!0)))}async terminate(a,s,c=!0){this.logger.safe.info(`[${a}] terminate`),this.stats.setTerminated(),this.canTriggerRenegotiation=!1,this.cleanUp(a);try{c&&await this.getStatsAsync(!1)}catch(u){this.logger.safe.error(`[${a}] Error while gathering stats ${nn(u)}`)}finally{this.stats.dispose(),this.terminated=!0}}processNotification(a,s){a==="DominantSpeakerInfo"&&this.activeSpeakerManager.onDominantSpeakerHistoryChanged(s.previousDominantSpeakerHistory,"signaling"),a==="ControlVideoStreaming"&&this.streamConfigurationHandler.handleMessage(s)}cleanUp(a){this.negotiationQueue.dispose(),this.localVideoStreamWatcher.dispose(),this.remoteVideoManager.dispose(),this.resetPeerConnection(a),this.subscriptionManagerSubs.forEach(s=>s.dispose()),this.subscriptionManager&&this.subscriptionManager.dispose(),this.clearIceDisconnectedTimer(),this.callbacks.onTerminated&&this.callbacks.onTerminated(),this.negotiationCompletedPromise.reject("webRtcSession cleanup")}resetPeerConnection(a){this.logger.safe.info(`[${a}] reset peer connection`),this.audioRenderer&&this.audioRenderer.dispose(),this.dtmfSender&&(this.dtmfSender.dispose(),this.dtmfSender=null),this.peerConnection&&this.peerConnection.close(),this.toBeCalledAfterConnected=[],this.disposeStreams(),this.peerConnection=null,this.contributingSources?.dispose(),this.activeSpeakerManager.dispose(),this.negotiationEmulator.configure(null),this.peerConnectionPromise=null,this.resetCandidateGathering(a),this.canTriggerRenegotiation=!0,this.negotiatedModalities={}}resetNegotiationQueue(a=hi()){this.negotiationCompletedPromise.reject("promise expired"),this.setNegotiationPromise(new Pi,a)}setNegotiationPromise(a,s=hi()){this.terminated||(this.negotiationCompletedPromise=a,this.negotiationQueue.add(this.negotiationCompletedPromise,s))}updateQualityLevels(a){if(!a)return;this.hwSilent!==a.audioHwSilent&&(this.hwSilent=a.audioHwSilent,this.callbacks.onAudioHwSilentChanged&&this.callbacks.onAudioHwSilentChanged(this.hwSilent)),this.ufdManager.signalEvent("NetworkRecvQuality",a.networkRecvLevel.quality,void 0,void 0,void 0,void 0,{recvQualityData:a.networkRecvLevel}),this.ufdManager.signalEvent("NetworkSendQuality",a.networkSendLevel.quality,void 0,void 0,void 0,void 0,{sendQualityData:a.networkSendLevel});const s=!(!a.isSpeaking||!this.doAudioMute);this.ufdManager.signalEvent("DeviceSpeakWhileMuted",s?"Bad":"Good")}triggerRenegotiation(a,s=hi()){this.canTriggerRenegotiation?(this.canTriggerRenegotiation=!1,this.triggerRenegotiationFlag=!1,this.logger.safe.info(`[${s}] triggering renegotiation`),this.mediaManager.backup(),this.callbacks.onNegotiationRequired&&this.callbacks.onNegotiationRequired(s)):a&&(this.logger.safe.info(`[${s}] renegotiation postponed`),this.triggerRenegotiationFlag=!0)}throwIfModalitiesNotConfigured(a){if(!this.configuredModalities)throw new Error(a)}addTrack(a,s,c){if(!a)return;const u=this.modalityByMediaType(c);if(this.logger.safe.info(`add media track kind: ${a.kind} id: ${a.id}`),this.senders[u])throw new Error("track already created, modality:"+u+", kind:"+a.kind+", id:"+a.id);this.peerConnection.iceConnectionState!=="closed"&&(this.senders[u]=this.peerConnection.addTrack(a,s))}registerMediaSources(){const a=[];if(this.mediaStreams.forEach((s,c)=>{const u={sourceId:this.getSourceIdForStream(s),defaultSSRC:this.ssrcs[c].min,modality:this.modalityByMediaType(c)};a.push(u)}),this.qualityManager.updateRegisteredSources(a),this.videoStream){const s=this.videoStream.getResolution();this.qualityManager.setCurrentResolution(new mV(s.width,s.height))}}updateStream(a,s){return a.start().then(()=>{try{const c=this.mediaStreams.get(s);if(c&&a.isSameStream(c)||(this.updateSsrcRangeForMediaType(s),this.removeTrackByMediaType(s),this.disposeStreamByMediaType(s),!this.peerConnection))return a.dispose(),null;if(this.addTrack(a.rawTrack,a.rawStream,s),a.onApplyConstraints=u=>{this.removeTrackByMediaType(s),u.then(()=>{this.addTrack(a.rawTrack,a.rawStream,s),this.registerLocalStreams(),this.mediaManager.updateMediaEntitiesWithLocalTracks()})},this.mediaStreams.set(s,a),s==="Video"){const u=[this.getMediaTrackInfo(s)];this.localVideoStreamWatcher.startWatching(u)}}catch(c){throw this.removeTrackByMediaType(s),this.disposeStreamByMediaType(s),a.dispose(),c}})}getSourceIdForStream(a){const s=a.rawStream.getTracks()[0].id,c=this.mediaManager.getMediaEntityByLocalTrackId(s);return c?(this.logger.safe.info(`Media entity found: ${JSON.stringify(c.getXSourceStreamId())}`),c.getXSourceStreamId()):(this.logger.safe.error(`Media entity is not found for stream: ${JSON.stringify(s)}`),0)}updatePeerConnectionStreamsAsync(a,s,c,u){const m=Ur(this.negotiatedModalities.audio),b=Ur(this.negotiatedModalities.video),_=Ur(this.negotiatedModalities.sharing),k=$g(this.negotiatedModalities),N=Ur(a.audio),W=Ur(a.video),ee=Ur(a.sharing),oe=$g(a);return k||oe||(this.stats.onSendersChanged("Audio",N),this.stats.onSendersChanged("Video",W),this.stats.onSendersChanged("ScreenShare",ee)),this.assurePeerConnectionAsync(u).then(async()=>{if(this.logger.safe.info("updatePeerConnectionStreamsAsync","pc state",this.peerConnection.signalingState,"hold","[",k,"->",oe,"]","audio","[",m,"->",N,"]","video","[",b,"->",W,"]","sharing","[",_,"->",ee,"]"),k!==oe){if(this.videoStream&&this.videoStream.setHold(oe),this.audioStream&&this.audioStream.setHold(oe),this.displayStream&&this.displayStream.setHold(oe),oe)return;if(!oe&&this.audioStream){this.removeTrackByMediaType("Audio");const de=this.audioStream.clone();this.audioStream.dispose(),this.mediaStreams.set("Audio",de),this.addTrack(this.audioStream.rawStream.getAudioTracks()[0],this.audioStream.rawStream,"Audio")}}if((m!==N||b!==W||_!==ee||this.forceMediaStreamUpdate)&&(c&&(this.forceMediaStreamUpdate=!1),s&&(this.logger.safe.info("not using any media(track api) track, remove all senders"),N||(this.removeTrackByMediaType("Audio"),this.disposeStreamByMediaType("Audio")),c&&W||(this.removeTrackByMediaType("Video"),this.disposeStreamByMediaType("Video")),c&&ee||(this.removeTrackByMediaType("ScreenShare"),this.disposeStreamByMediaType("ScreenShare"))),c)){const de=[];if(W){const se=await this.deviceManager.getVideoStream(!1);de.push(this.updateStream(se,"Video"))}if(ee){const se=this.deviceManager.getDisplayStream();de.push(this.updateStream(se,"ScreenShare"))}if(N){const se=await this.deviceManager.getAudioStream(!1);de.push(this.updateStream(se,"Audio").then(()=>{this.audioStream.setMuted(this.doAudioMute)}))}return Promise.all(de).then(()=>this.registerLocalStreams())}})}getMediaTrackInfo(a){const s=this.modalityByMediaType(a),c=this.mediaStreams.get(a).rawStream.getTracks()[0].id;return c||this.logger.safe.error(`No media track for modality found: ${s}`),{trackId:c,modality:s}}getSsrcRangeForMediaType(a){const s={min:1,max:1};switch(a){case"Audio":return this.ssrcGenerator.nextAudioStreamSsrc();case"Video":case"ScreenShare":return this.ssrcGenerator.nextVideoStreamSsrc();default:return s}}updateSsrcRangeForMediaType(a){a!=="Video"&&a!=="ScreenShare"||(this.ssrcs[a]=this.ssrcGenerator.nextVideoStreamSsrc())}getStreamTransformConfiguration(){return{unifiedPlanEnabled:!1,addPrefixForMsid:this.configProvider.config.addPrefixForMsidInSdp}}registerLocalStreams(){const a=[];this.mediaStreams.forEach((s,c)=>{a.push(this.getMediaTrackInfo(c))}),this.mediaManager.setLocalTracksInfo(a)}handleVideoRecvCapabilities(a){if(this.configProvider.config.enableLocalVideoConstraints&&Rc(a.getModalities().video)){if(this.videoStream){const s=a.getVideoRecvCapabilities();if(!s)return this.logger.safe.error("No fmt params found for video modality"),Promise.resolve(!1);const c=this.generateReceiveCapabilities(s,this.videoStream);this.qualityManager.setMaxCapabilities([c])}this.logger.safe.error("remote endpoint didn't specify video receive capability")}return Promise.resolve(!1)}handleSharingRecvCapabilities(a){if(this.configProvider.config.enableLocalVideoConstraints&&Rc(a.getModalities().sharing)&&this.displayStream){const s=a.getSharingRecvCapabilities();if(!s)return void this.logger.safe.error("No fmt params found for sharing modality");const c=this.generateReceiveCapabilities(s,this.displayStream);this.qualityManager.setMaxCapabilities([c])}}generateReceiveCapabilities(a,s){const c={ssrc:0,rid:"0",keyframe:!1,...a},u={causeId:hi(),isSimulcast:!1,sourceId:this.getSourceIdForStream(s),capabilities:[c]};return this.logger.safe.info(`Generated receive capabilities for stream ${s.id}: ${JSON.stringify(u)}`),u}updateDescriptor(a,s){const c=s.getVideoRecvCapabilities(),u={sourceId:0,streamMsid:0,bandwidth:0};if(c&&this.videoStream&&!this.displayStream&&(u.sourceId=this.getSourceIdForStream(this.videoStream),u.streamMsid=this.videoStream.id,u.bandwidth=c.maxBr?c.maxBr:Number.MAX_VALUE),u.bandwidth>0){u.bandwidth=Math.floor(u.bandwidth/1200);const m=new CJe(this.logger.createChild("rembModifier"),this.qualityManager,this.configProvider);m.setControlItem(u),m.modifyDescriptor(a)}}removeTrackByMediaType(a){return this.removeTracksByModality(this.modalityByMediaType(a))}modalityByMediaType(a){switch(a){case"Audio":return ke.MODALITY.audio;case"Video":return ke.MODALITY.video;case"ScreenShare":return ke.MODALITY.sharing;default:throw new Error(`Modality is not defined for media type: ${a}`)}}removeTracksByModality(a){this.forceKeyFramePromise&&a==="sharing"?this.forceKeyFramePromise.then(()=>{this.removeTracksByModality(a)}):a in this.senders&&(this.logger.safe.info(`remove sender track kind: ${this.senders[a].track.kind} track id: ${this.senders[a].track.id}`),this.peerConnection.iceConnectionState!=="closed"&&this.peerConnection.removeTrack(this.senders[a]),delete this.senders[a])}handleCodecSwitchUnsupported(a){return this.offeredDescription.isCodecSwitchSupported()?Promise.resolve():this.webrtcAdapter.RTCRtpReceiver.getCapabilities(ke.MEDIA_TYPE.audio).then(s=>{const c=s.codecs.map(u=>u.mimeType);this.offeredDescription.usePrimaryAudioCodecOnly(c)}).catch(s=>{this.logger.safe.error(`[${a}] failed to set primary codec based on audio capability ${nn(s)}`)})}disposeStreamByMediaType(a){const s=this.mediaStreams.get(a);s&&(this.mediaStreams.delete(a),s.dispose(),a==="Video"&&this.localVideoStreamWatcher.stopWatching())}disposeStreams(){this.mediaStreams.forEach((a,s)=>this.disposeStreamByMediaType(s))}assurePeerConnectionAsync(a){if(!this.peerConnectionPromise){if(!this.relayManagerProvider)throw new Error("relay manager provider is not set!");this.logger.safe.info("fetching relay details from RelayManager...");const s={relayType:"turn",isRemoteClientLync:this.context.config.isRemoteClientLync};this.peerConnectionPromise=this.relayManagerProvider.getRelayManager().queryRelaysAsync(s).then(c=>{if(this.terminated)throw new Error("session already disposed");const u={optional:[]},m=fJe(c,this.configProvider.config),b=this.configureCrypto(u);this.configureCpuThreshold(u),this.logger.safe.info("create peer connection");const _=this.context.configProvider.mediaConfig.isTransportUnbundled?"balanced":"max-bundle",k=this.peerConnection=new this.webrtcAdapter.RTCPeerConnection({iceServers:m,rtcpMuxPolicy:"require",iceTransportPolicy:this.iceTransportPolicy,bundlePolicy:_,sdpSemantics:"plan-b",audioPortRange:this.configProvider.mediaConfig.audioPortRange,videoPortRange:this.configProvider.mediaConfig.videoPortRange,enableDtlsSrtp:b===1,offerExtmapAllowMixed:!1},u);this.negotiationEmulator.configure(k),this.stats.initialize(k),this.stats.sessionInfo.setIceServers(m),this.stats.sessionInfo.setIceTransportPolicy(this.iceTransportPolicy),this.stats.sessionInfo.setBundlePolicy(_);const N=this.webrtcAdapter.RTCRtpReceiver.getCapabilities("video"),W=this.webrtcAdapter.RTCRtpSender.getCapabilities("video");this.stats.setH264AvailableProfiles(N),this.stats.setSupportedH264Profiles(W,N),k.onnegotiationneeded=()=>{this.logger.safe.info(`onnegotiationneeded signalingState: ${k.signalingState}`)},k.onsignalingstatechange=()=>{this.stats.sessionInfo.setSignalingConnectionState(k.signalingState),this.logger.safe.info(`onsignalingstatechange signalingState: ${k.signalingState}`)},k.onicecandidateerror=de=>{const[se,Re]=[de.address,de.port];this.logger.safe.warn(`On ICE candidate error ${de.url} | ${se}:${Re}: code ${de.errorCode}: ${de.errorText}`),this.isConnected()&&!this.iceCandidatesDeferred.isPending||this.stats.addIceCandidateError({address:se,port:+Re,url:de.url,errorCode:de.errorCode,errorText:de.errorText})};const ee=de=>{if(!this.isConnected())return this.logger.safe.info("onaddstream handling postponed till PC is connected"),void this.toBeCalledAfterConnected.push(()=>ee(de));const se=de.stream;this.logger.safe.info(`onaddstream stream: ${se.id}`);let Re=this.mediaManager.getMediaEntityByRemoteStreamId(se.id);if(Re||(this.logger.safe.info(`cannot find media entity with stream id ${se.id} trying to fallback`),se.getAudioTracks()[0]&&(Re=this.mediaManager.getMediaEntitiesByModality(ke.MODALITY.audio)[0])),Re){const ue=this.createReceiveStream(se,Re);this.receiveStreamCollection.add(ue)}else this.logger.safe.error(`could not find media entity for an added stream: ${se.id}`)};k.onaddstream=ee,k.ontrack=de=>{this.logger.safe.info(`ontrack track: ${de.track}`)};const oe=de=>{if(!this.isConnected())return this.logger.safe.info("onremovestream handling postponed till PC is connected"),void this.toBeCalledAfterConnected.push(()=>oe(de));this.logger.safe.info(`onremovestream stream: ${de.stream.id}`),this.receiveStreamCollection.remove(de.stream.id)};k.onremovestream=oe,k.onicecandidate=de=>{const se=de.candidate;if(se){const Ne=tie(se.candidate);this.logger.safe.info(`[${a}] onicecandidate candidate: prio:${Ne.priority} type:${Ne.type} port:${Ne.port}`),this.logger.unsafe.info(`[${a}] candidate details: ${se.candidate}`),!this.relayCandidateGathered&&se.candidate.indexOf("typ relay")>-1&&(this.stats.sessionInfo.setRelayCandidateInfo({priority:se.priority||se.candidate.split(" ")[3],time:Date.now()-this.iceRelayCandidatesGatherStartTime}),this.relayCandidateGathered=!0)}else this.logger.safe.info(`[${a}] onicecandidate candidate: null`);if(!this.iceCandidatesDeferred.isPending)return;const Re=!this.initiator||!this.context.config.webrtcIceGatheringTimeoutIncreased,ue=this.iceHostCandidateOnly||m.length===0;if(!se&&Re||ue){se&&this.logger.safe.info(`[${a}] Not waiting for ICE candidates, hoping that host/prflx is enough`),this.logger.safe.info(`[${a}] Is connected:`,this.isConnected(),k.iceConnectionState,k.signalingState);let Ne=!0;this.context.configProvider.mediaConfig.isTransportUnbundled&&se&&(Ne=this.sessionDescription.createLocalOffer(this.peerConnection.localDescription.sdp).hasUnbundledIceCandidates()),Ne&&this.completeCandidateGathering(a)}else if(this.relayCandidateGathered){let Ne=!0;this.context.configProvider.mediaConfig.isTransportUnbundled&&(Ne=this.sessionDescription.createLocalOffer(this.peerConnection.localDescription.sdp).hasUnbundledRelayIceCandidates()),Ne&&(this.stats.clearIceCandidateErrors(),this.completeCandidateGathering(a))}},k.onicegatheringstatechange=()=>{this.logger.safe.info(`onicegatheringstatechange iceGatheringState: ${k.iceGatheringState}`)},k.oniceconnectionstatechange=()=>{const de=hi();if(!this.terminated){if(this.stats.sessionInfo.setIceConnectionState(k.iceConnectionState),this.logger.safe.info(`[${de}] oniceconnectionstatechange iceConnectionState: ${k.iceConnectionState} pc.signalingState: ${k.signalingState}`),k.iceConnectionState==="connected"||k.iceConnectionState==="completed")this.onTransportConnected(de);else if(k.iceConnectionState==="failed"){if(this.iceCandidatesDeferred.isPending)return this.logger.safe.info(`[${de}] ice failed while gathering candidates, suppressing error`),void this.completeCandidateGathering(de);this.raiseError({type:ke.MEDIA_ERROR.iceConnectionError,detail:"ice transport failed"},de),this.configProvider.config.webrtcCloseAfterIceFailure&&k.close(),this.onTransportFailed()}k.iceConnectionState==="disconnected"?(this.onTransportDisconnected(de),this.startIceDisconnectedTimer(de)):this.clearIceDisconnectedTimer()}},this.multiParty&&(this.contributingSources=new WJe(this.logger.createChild("ContributingSources"),this.configProvider,this.activeSpeakerManager,new KJe(this.logger.createChild("ContributingSourcesProvider"),k)))})}return this.peerConnectionPromise}configureCrypto(a){let s=!1;const c=l9(this.context.configProvider,this.context.config.isPstnCall);if(this.offeredDescription){const u=this.offeredDescription.getSrtpInfo();this.stats.sessionInfo.setOfferedSrtpInfo(u),s=!u.dtls||u.sdes&&c}else s=c;return s&&(this.logger.safe.info("configuring peer connection to use sdes"),a.optional.push({DtlsSrtpKeyAgreement:!1})),this.stats.sessionInfo.setNegotiatedSrtpInfo({dtls:!s,sdes:!!s}),s?0:1}configureCpuThreshold(a){this.configProvider.config.webrtcNativeCpuOveruseDisabled&&this.multiParty&&a.optional.push({googCpuOveruseDetection:!1})}completeCandidateGathering(a){this.iceCandidatesDeferred.isPending&&(this.logger.safe.info(`[${a}] ICE candidates gathered completely`),this.iceCandidatesDeferred.resolve())}onTransportConnected(a){if(this.logger.safe.info(`[${a}] audio transport connected`),this.stats.clearIceCandidateErrors(),!this.terminated)for(this.callbacks.onAudioStateChanged(ke.STREAMING_STATE.active,a),this.callbacks.onTransportConnected&&this.callbacks.onTransportConnected(a);this.toBeCalledAfterConnected.length;)this.toBeCalledAfterConnected.shift()()}onTransportDisconnected(a){this.callbacks.onTransportDisconnected&&this.callbacks.onTransportDisconnected(a)}onTransportFailed(){this.callbacks.onTransportFailed&&this.callbacks.onTransportFailed()}startIceDisconnectedTimer(a){this.configProvider.config.iceDisconnectedTimeoutMs&&(this.iceDisconnectedTimer=setTimeout(()=>{this.logger.safe.error(`[${a}] ice disconnected for ${this.configProvider.config.iceDisconnectedTimeoutMs}ms. Raise CONSTANTS.MEDIAthis._ERROR.iceConnectionError`),this.raiseError({type:ke.MEDIA_ERROR.iceConnectionError,detail:"ice transport disconnected"},a)},this.configProvider.config.iceDisconnectedTimeoutMs))}clearIceDisconnectedTimer(){this.iceDisconnectedTimer&&(clearTimeout(this.iceDisconnectedTimer),this.iceDisconnectedTimer=null)}raiseError(a,s=hi()){this.logger.safe.error(`[${s}] Media error occurred type: ${a.type} detail: ${a.detail}`),this.callbacks.onSessionErrorOccurred&&this.callbacks.onSessionErrorOccurred(a,s)}createNegotiationConstraints(a){function s(c){return!!c&&(Rc(c)||c==="inactive")}return{offerToReceiveAudio:s(a.audio),offerToReceiveVideo:s(a.video)||s(a.sharing)}}resetCandidateGathering(a){this.logger.safe.info(`[${a}] reset candidate gathering`),this.iceCandidatesDeferred.promise.then(()=>{},()=>{}),this.iceCandidatesDeferred.reject(new Error("reset candidate gathering")),this.iceCandidatesDeferred=new Pi}checkIceCandidates(a){const s=this.hasIceCandidates(a);if(s===this.noIceCandidates&&(this.noIceCandidates=!this.noIceCandidates,this.ufdManager.signalEvent("NoNetwork",this.noIceCandidates?"Bad":"Good"),this.noIceCandidates))throw{type:ke.MEDIA_ERROR.noNetworkError,detail:"no ice candidates"};if(s){const c=this.hasRelayIceCandidates(a);if(c===this.noRelayIceCandidates){if(!c&&(this.peerConnection.iceConnectionState==="connected"||this.peerConnection.iceConnectionState==="completed"))return;this.noRelayIceCandidates=!this.noRelayIceCandidates,this.ufdManager.signalEvent("NetworkRelaysNotReachable",this.noRelayIceCandidates?"Bad":"Good")}}}hasIceCandidates(a){return this.configProvider.mediaConfig.isTransportUnbundled?a.hasUnbundledIceCandidates():a.hasIceCandidates()}hasRelayIceCandidates(a){return this.configProvider.mediaConfig.isTransportUnbundled?a.hasUnbundledRelayIceCandidates():a.hasRelayIceCandidates()}doRetargetIfNeeded(a,s,c){const u=s.isIceRestart();this.logger.safe.info(`[${c}] ICE restart: ${u}`),this.context.configProvider.mediaConfig.isTransportUnbundled&&this.offeredDescription?.isMSRTC()&&u&&!this.multiParty&&s.getSrtpInfo().sdes&&(a.newOffer=!0)}getAddedMediaTypes(a,s){a||(a={}),s||(s={});const c=[];return UTe(a.audio,s.audio)&&c.push("Audio"),UTe(a.video,s.video)&&c.push("Video"),UTe(a.sharing,s.sharing)&&c.push("ScreenShare"),c}applyCapabilitiesForModality(a,s,c){return a===ke.MODALITY.video?this.applyCapabilitiesForVideo(s,c[0]):a===ke.MODALITY.sharing?this.applyCapabilitiesForSharing(s,c[0]):Promise.resolve(!1)}applyCapabilitiesForSharing(a,s){return this.displayStream?this.applyCapabilities(this.displayStream,s).then(c=>(this.stats.onMaxCapabilitiesApplied({causeId:a,modality:ke.MODALITY.sharing,capabilities:[s]}),this.configProvider.config.webrtcAllowRestoreKeyframe?this.forceKeyframe(this.senders[ke.MODALITY.sharing]).then(()=>c):Promise.resolve(c))):(this.logger.safe.info(`${JSON.stringify(s)} is ignored as no sharing stream is sent, no renegotiation`),Promise.resolve(!1))}forceKeyframe(a){if(!a)return this.logger.safe.error("forceKeyframe: No sender available for sharing"),null;if(this.forceKeyFramePromise)return this.logger.safe.warn("forceKeyframe: already in progress"),this.forceKeyFramePromise;this.logger.safe.info("Restoring keyframe");const s=a.track;return this.forceKeyFramePromise=a.replaceTrack(null).then(()=>a.replaceTrack(s)).then(()=>{this.forceKeyFramePromise=null,this.logger.safe.info("Restoring keyframe finished")}).catch(c=>{this.forceKeyFramePromise=null,this.logger.safe.error(`Restoring keyframe failed: ${c}`),delete this.senders[ke.MODALITY.sharing]}),this.forceKeyFramePromise}applyCapabilitiesForVideo(a,s){return this.negotiationCompletedPromise.isPending?(this.logger.safe.info("##### Renegotiation is in progress, no local resolution switch for now #####"),this.negotiationCompletedPromise.promise.then(()=>Promise.resolve(!1))):this.videoStream?this.scheduleApplyCapabilities(this.videoStream,a,s):(this.logger.safe.info(`${JSON.stringify(s)} is ignored as no video is sent, no renegotiation`),Promise.resolve(!0))}scheduleApplyCapabilities(a,s,c){this.logger.safe.info("Queueing local renegotiation...");let u=!1;return this.negotiationQueue.add(()=>(this.logger.safe.info("############# LOCAL RENEGOTIATION START #############"),this.applyCapabilities(a,c).then(()=>{this.stats.onMaxCapabilitiesApplied({causeId:s,modality:ke.MODALITY.video,capabilities:[c]}),u=!0})),s),this.negotiationEmulator.renegotiate().then(()=>(this.logger.safe.info(`############# LOCAL RENEGOTIATION END. RESULT: ${u}  #############`),u))}applyCapabilities(a,s){return a?(this.logger.safe.info(`Changing resolution to ${JSON.stringify(s)}`),a.applyCapabilities(s)):(this.logger.safe.info(`Resolution ${JSON.stringify(s)} ignored, no stream is being sent`),Promise.resolve(!1))}onOptimalVideoReceiversCountChanged(a){this.callback.onOptimalVideoReceiversCountChanged&&this.callback.onOptimalVideoReceiversCountChanged(a)}getStreams(){return this.receiveStreamCollection.getStreams()}onStreamsChanged(a){this.streamsChangedListener=a}notifyStreamsChanged(){this.logger.safe.info(`Scheduling stream changed notification: ${this.streamsChangedNotificationScheduled}`),this.streamsChangedNotificationScheduled||this.negotiationCompletedPromise.promise.catch(()=>{}).then(()=>{this.streamsChangedNotificationScheduled=!1,this.streamsChangedListener&&this.streamsChangedListener()})}streamAdded(a){ke.MODALITY.audio===a.getModality()&&(this.audioRenderer.setOutputDevice(this.deviceManager.getOutputDeviceId()),this.audioRenderer.play(a.getMediaStream())),this.notifyStreamsChanged()}streamRemoved(a){ke.MODALITY.audio===a.getModality()&&this.audioRenderer.getStream()===a.getMediaStream()&&this.audioRenderer.stop(),this.notifyStreamsChanged()}setNegotiatedModalities(a){this.negotiatedModalities=a,this.stats.sessionInfo.setNegotiatedModalities(a)}setupIceGatheringTimeout(a){this.iceRelayCandidatesGatherStartTime=Date.now();const s=this.context.config.webrtcIceGatheringTimeoutIncreased?this.configProvider.config.relayWaitSaneTimeoutMs:this.configProvider.config.webrtcIceGatheringTimeoutMs;if(!s)return;this.iceCandidatesTimer>0&&clearTimeout(this.iceCandidatesTimer);const c=this.iceCandidatesDeferred;this.iceCandidatesTimer=setTimeout(()=>{this.iceCandidatesTimer=0,c.isPending&&(this.logger.safe.warn(`[${a}] ICE candidates gathering terminated due to timeout ${s}`),c.resolve())},s)}createAudioRenderer(){this.audioRenderer=new hTe(this.logger.createChild("AudioRenderer"),this.configProvider),this.context.maContext.domOverrides.onMediaElementAdded&&this.audioRenderer.on("onAudioElementAdded",this.context.maContext.domOverrides.onMediaElementAdded),this.context.maContext.domOverrides.onMediaElementRemoved&&this.audioRenderer.on("onAudioElementRemoved",this.context.maContext.domOverrides.onMediaElementRemoved)}isConnected(){const a=this.peerConnection;return a&&(a.iceConnectionState==="connected"||a.iceConnectionState==="completed")}isFailed(){return this.peerConnection&&(this.peerConnection.iceConnectionState==="failed"||this.peerConnection.iceConnectionState==="closed")}hasRelayCandidates(){return this.relayCandidateGathered}createReceiveStream(a,s){const c=this.configProvider.config.addFmtpToInitialSubscription?s.getLocalRecvCapabilities():null,u=this.configProvider.config.useMultiviewLimitsOnInitialRequest&&s.getModality()!==ke.MODALITY.sharing?()=>this.remoteVideoManager.getMaxAllowedVideoFS():null;return new yKe(a,null,s.getModality(),+s.getXSourceStreamId(),this,c,u)}requestSource(a,s,c){if(!this.multiParty)return Promise.resolve();const u=this.mediaManager.getMediaEntityByRemoteStreamId(a);return!this.isMuteHold&&this.negotiatedModalities[u.getModality()]!==ke.MEDIA_STATE.inactive||s===-1?this.negotiationCompletedPromise.isPending?this.negotiationCompletedPromise.promise.catch(()=>{}).then(()=>this.requestSource(a,s,c)):Promise.resolve().then(()=>this.mediaMessageController.sendSourceRequest(u.getXSourceStreamId(),s,u?.getMid(),c,u.getSubstreamIndex())):Br(10).then(()=>this.requestSource(a,s,c))}getSessionConfig(){return this.configProvider}getUnmixedAudioProvider(){return null}};function UTe(n,a){return!Ur(n)&&Ur(a)}var iEi={build:(n,a,s)=>new tEi(n,a,s)},nEi=dn,zTe=class extends jr{constructor(n,a){super(a),this.logger=a,this.id=-1,this.parentId=-1,this.rawStream=null,this.rawTrack=null,this.deviceId=null,this.mediaType=n}start(){return this.logger.safe.debug("start"),Promise.resolve()}clone(){return this.logger.safe.debug("clone"),this}setMuted(n,a){this.logger.safe.debug("setMuted")}setHold(n){this.logger.safe.debug("setHold")}getResolution(){return this.logger.safe.debug("getResolution"),{width:240,height:180}}getFrameRate(){return this.logger.safe.debug("getFrameRate"),1}hasAudio(){return this.logger.safe.debug("hasAudio"),!1}hasVideo(){return this.logger.safe.debug("hasVideo"),!1}isSameStream(n){return this.logger.safe.debug("isSameStream"),n===this}applyCapabilities(n){return this.logger.safe.debug("applyCapabilities"),Promise.resolve(!1)}onApplyConstraints(n){this.logger.safe.debug("onApplyConstraints")}update(n){this.logger.safe.debug("update")}isActive(){return!1}isDisposed(){return!1}},qN=class LQe extends jr{constructor(a,s,c,u,m){super(m),this.callDeviceManager=a,this.configProvider=s,this.sessionConfig=c,this.serialQueue=u,this.logger=m,this.mediaStreams={Audio:null,Video:null,ScreenShare:null},this.streamSubscriptions=new Map,this.deviceManagerSubscriptions=[],this.isNullAudioStream=!1}get currentMediaTypes(){return kD(this.mediaStreams).filter(a=>!!this.mediaStreams[a])}async getStreams(){return this.mediaStreams}useNullAudioStreamClient(){this.isNullAudioStream=!0}async update(a,s){const c=kD(a).filter(u=>a[u]);return xc(c,this.currentMediaTypes)?(this.logger.safe.info("Requested modalities have not changed. Do nothing"),iie(this.mediaStreams)):(this.logger.safe.info(`Starting media session with modalities: ${JSON.stringify(a)}`),await this.updateStreams(c,s),this.subscribeOnDeviceManagerEvents(),iie(this.mediaStreams))}async stopAsync(){this.logger.safe.info("Stopping streams async"),this.stop()}stop(){this.logger.safe.info("Stopping streams"),this.unsubscribeFromDeviceManagerEvents(),kD(this.mediaStreams).forEach(a=>this.removeStreamByType(a))}dispose(){this.stop(),super.dispose()}async updateStreams(a,s){const c=this.getAvailableMediaTypes(),u=(0,nEi.intersection)(a,c),m=kD(this.mediaStreams).filter(k=>this.mediaStreams[k]),b=s?[]:y2(u,m),_=y2(m,u);b.length&&this.logger.safe.info(`Adding media streams for types: ${JSON.stringify(b)}`),await Promise.all(b.map(async k=>{await this.addStream(k,!1),this.mediaStreams[k]&&this.event("onStreamAdded").raise(k)})),_.length&&this.logger.safe.info(`Removing media streams for types: ${JSON.stringify(_)}`),_.forEach(k=>{this.event("onStreamRemoving").raise(k),this.removeStreamByType(k)})}getAvailableMediaTypes(){const a=this.callDeviceManager.getDefaultDeviceManager().getSelectedDevices(),s=[];return a.microphone&&s.push("Audio"),a.camera&&s.push("Video"),s.push("ScreenShare"),s}async addStream(a,s){if(this.mediaStreams[a])return void this.logger.safe.warn(`Stream with type: ${a} is already registered`);const c=await this.getStream(a,s);this.subscribeOnMediaStreamEvents(c);try{await c.start()}catch(u){return this.logger.safe.error(`Media stream request error: ${JSON.stringify(u)}`),void this.event("onStreamError").raise(a,u)}this.mediaStreams[a]=c}removeStreamByType(a){const s=this.mediaStreams[a];s?(this.unsubscribeFromMediaStreamEvents(s),s.dispose(),this.mediaStreams[a]=null):this.logger.safe.warn(`Stream with type: ${a} is not registered`)}async updateStream(a,s,c=!1){c&&a==="Audio"?await this.updateStreamWithEffect(a):(this.removeStreamByType(a),await this.addStream(a,s)),this.event("onStreamUpdated").raise(a)}async updateStreamWithEffect(a){const s=this.mediaStreams[a];s&&this.unsubscribeFromMediaStreamEvents(s);const c=await this.getStreamByMediaType(a,!0);this.subscribeOnMediaStreamEvents(c);try{await c.start()}catch(u){return this.logger.safe.error(`updateStreamWithEffect. Media stream request error: ${JSON.stringify(u)}`),void this.event("onStreamError").raise(a,u)}this.mediaStreams[a]=c,s?.dispose()}subscribeOnMediaStreamEvents(a){if(this.streamSubscriptions.has(a))return;const s=[];s.push(a.on("onStreamClientError",(c,u)=>this.onStreamError(c,u))),s.push(a.on("onStreamClientDisposing",c=>this.onStreamDisposing(c))),this.streamSubscriptions.set(a,s)}unsubscribeFromMediaStreamEvents(a){this.streamSubscriptions.has(a)&&(this.streamSubscriptions.get(a).forEach(s=>s.dispose()),this.streamSubscriptions.delete(a))}async getStream(a,s){const c=this.mediaStreams[a];return c?(this.logger.safe.info(`Stream exists with id: ${c.id}, type: ${a}`),c):this.getStreamByMediaType(a,s)}async getStreamByMediaType(a,s){switch(a){case"Audio":return this.isNullAudioStream?new zTe("Audio",this.logger.createChild("NullStreamClient")):this.getDeviceManagerByType("Audio").getAudioStream(s,"sessionStream");case"Video":return this.getDeviceManagerByType("Video").getVideoStream(s,"sessionStream",!1,this.sessionConfig.outgoingVideoMaxFS);case"ScreenShare":return this.getDeviceManagerByType("ScreenShare").getDisplayStream("sessionStream");default:throw new Error(`Media type is not supported: ${a}`)}}getMediaTypeForStream(a){const s=Object.keys(this.mediaStreams).find(c=>this.mediaStreams[c]===a);return s||this.logger.safe.error(`Media type is not found for stream: ${nn(a)}`),s}subscribeOnDeviceManagerEvents(){if(this.deviceManagerSubscriptions.length!==0)return;if(this.callDeviceManager.isVirtualDeviceEnabled){const s=this.callDeviceManager.on("onSelectedVirtualDevicesChanged",(c,u)=>{const m=c;if(!c.camera){this.logger.info("Virtual DeviceID for camera is undefined, falling back to default device");const{camera:b}=this.callDeviceManager.getDefaultDeviceManager().getSelectedDevices();m.camera=b}this.callDeviceManager.isModalityEnabled("Video")&&u.camera!==m.camera&&(this.logger.info("Updating stream for camera"),this.updateStreamForVirtualDeviceChange("Video")),this.callDeviceManager.isModalityEnabled("ScreenShare")&&u.screenshare!==m.screenshare&&(this.logger.info("Updating stream for screenshare"),this.updateStreamForVirtualDeviceChange("ScreenShare"))});this.deviceManagerSubscriptions.push(s)}const a=this.callDeviceManager.getDefaultDeviceManager();this.deviceManagerSubscriptions.push(a.on("onSelectedDevicesChanged",(s,c)=>this.onSelectedDevicesChanged(s,c)),a.on("onStreamUpdateRequested",(s,c)=>this.requestStreamUpdate(s,!1,c)),a.on("onAudioSharingToggled",s=>this.onAudioSharingToggled(s)))}unsubscribeFromDeviceManagerEvents(){this.deviceManagerSubscriptions.length!==0&&(this.deviceManagerSubscriptions.forEach(a=>a.dispose()),this.deviceManagerSubscriptions=[])}getMediaTypesToUpdate(a,s){const c=[];return this.currentMediaTypes.some(u=>u==="Audio")&&a.microphone&&a.microphone!==s.microphone&&c.push("Audio"),!this.callDeviceManager.getSelectedDevices().camera&&this.currentMediaTypes.some(u=>u==="Video")&&a.camera&&a.camera!==s.camera&&c.push("Video"),c}removeStream(a){const s=this.getMediaTypeForStream(a);this.removeStreamByType(s)}async onSelectedDevicesChanged(a,s){if(this.configProvider.config.enablePermissionsWorkaround&&LQe.isDeviceListEmpty(a,s))return void this.logger.safe.info("Device list is empty, permission workaround enabled");const c=this.getMediaTypesToUpdate(a,s);this.logger.safe.info(`Media types to update: ${JSON.stringify(c)}`),await Promise.all(c.map(u=>this.updateStream(u,!1)))}async onAudioSharingToggled(a){if(this.configProvider.config.postponeAudioMixerForAudioSharing&&a)return this.updateStream("ScreenShare",!0)}async requestStreamUpdate(a,s,c=!1){if(this.currentMediaTypes.some(u=>u===a)||s)return this.logger.safe.debug(`UpdateStream with media type: ${a}, force: ${s}`),this.updateStream(a,s,c);this.logger.safe.debug(`Stream with media type: ${a} is not active. Do nothing`)}onStreamError(a,s){this.removeStream(a)}onStreamDisposing(a){this.removeStream(a)}static isDeviceListEmpty(a,s){return!a.camera&&!a.microphone||!s.microphone&&!s.camera}getDeviceManagerByType(a){return this.callDeviceManager.getDeviceManager(a)}async updateStreamForVirtualDeviceChange(a){return this.updateStream(a,!1)}};Kt([pu()],qN.prototype,"getStreams"),Kt([pu()],qN.prototype,"update"),Kt([pu()],qN.prototype,"stopAsync"),Kt([pu()],qN.prototype,"onSelectedDevicesChanged"),Kt([pu()],qN.prototype,"onAudioSharingToggled"),Kt([pu()],qN.prototype,"requestStreamUpdate"),Kt([pu()],qN.prototype,"updateStreamForVirtualDeviceChange");var aEi=qN,sYe=dn,rEi=[5e4,1e6,15e5,2e6,25e5,375e4,4e6],oEi=[7e4,2e5,4e5,8e5,15e5,2499990,25e5];function sEi(n,a){const s=new lEi(n.createChild("BandwidthAllocator"));return s.setLadder("ScreenShare",a.config.sharingBitrateLadderOverride||rEi),s.setLadder("Video",a.config.videoBitrateLadderOverride||oEi),s}var lEi=class{constructor(n){this.logger=n,this.availableBandwidth=0,this.receivers=new Map,this.currentLayout={},this.ladders={}}setAvailableBandwidth(n){this.availableBandwidth=n,this.logger.safe.debug(`Total available bandwidth updated: ${n}`),this.updateLayouts()}getAvailableBandwidth(){return this.availableBandwidth}addReceiverCapability(n,a){this.logger.safe.debug(`Receiver maxBr set: ${n}/${a}`),this.receivers.set(n,a),this.updateLayouts()}getReceiverCapabilities(){const n={};for(const a of Object.keys(this.receivers)){const s=this.receivers.get(a);s&&(n[a]=s)}return n}removeReceiver(n){this.logger.safe.debug(`Receiver maxBr removed: ${n}`),this.receivers.delete(n),this.updateLayouts()}getLayouts(){return this.currentLayout}setLadder(n,a){this.ladders[n]=a}updateLayouts(){const n=this.generateLayouts();(0,sYe.isEqual)(n,this.currentLayout)||(this.currentLayout=n,this.logger.safe.debug(`Bandwidth distribution updated: ${nn(n)}`))}generateLayouts(){const n={},a={};for(const m of Object.keys(this.ladders)){const b=this.receivers.get(m);b&&(a[m]=b||Number.MAX_SAFE_INTEGER,n[m]=0)}let s=this.availableBandwidth,c=0;const u=()=>{if(!s)return!1;for(const m of Object.values(a))if(m)return!0;return!1};for(;u();){for(const m of Object.keys(n)){const b=this.ladders[m];let _=b[c]||b[b.length-1];_=Math.min(_,s,a[m]),n[m]+=_,s-=_,a[m]-=_}c++}return n}};function cEi(n,a){const s=Object.keys(n).filter(c=>n[c]>0).length>1;for(const c of Object.keys(n)){const u=a.get(c);if(n[c]===void 0||!u?.minValue&&!u?.minValueMixedMode)continue;const m=s?u?.minValueMixedMode:u?.minValue;n[c]=Math.max(m??u?.minValue??0,n[c])}return n}function lYe(n,a){const s=n.config.bandwidthAllocatorV2;let c=[],u=-1;for(const m of s.videoLadders)(a>=m.maxFS&&u<m.maxFS||u===-1)&&(c=m.ladder,u=m.maxFS);return c}function dEi(n,a){const s=new uEi(n.createChild("BandwidthAllocator2"));return s.setPriority("ScreenShare","Video"),s.setLadder("ScreenShare",a.config.bandwidthAllocatorV2.sharingLadder),s.setLadder("Video",lYe(a,a.config.bandwidthAllocatorV2.defaultVideoMaxFS)),s}var uEi=class{constructor(n){this.logger=n,this.availableBandwidth=0,this.receivers=new Map,this.currentLayout={},this.ladder=[],this.priority=[]}getReceiverCapabilities(){const n={};for(const a of Object.keys(this.receivers)){const s=this.receivers.get(a);s&&(n[a]=s)}return n}setAvailableBandwidth(n){this.availableBandwidth=n,this.logger.safe.debug(`Total available bandwidth updated: ${n}`),this.updateLayouts()}getAvailableBandwidth(){return this.availableBandwidth}addReceiverCapability(n,a){this.logger.safe.debug(`Receiver maxBr set: ${n}/${a}`),this.receivers.set(n,a),this.updateLayouts()}removeReceiver(n){this.logger.safe.debug(`Receiver maxBr removed: ${n}`),this.receivers.delete(n),this.updateLayouts()}getLayouts(){return this.currentLayout}setPriority(...n){this.priority=n}setLadder(n,a){this.logger.safe.info(`Set ladder for ${n}: ${JSON.stringify(a)}`);for(const s of this.ladder)delete s[n];this.priority.indexOf(n)===-1&&this.priority.push(n);for(let s=0;s<a.length;++s)s>=this.ladder.length&&this.ladder.push({}),this.ladder[s][n]=a[s]}updateLayouts(){const n=this.generateLayouts();(0,sYe.isEqual)(n,this.currentLayout)||(this.currentLayout=n,this.logger.safe.debug(`Bandwidth distribution updated: ${nn(n)}`))}generateLayouts(){const n={};let a=this.availableBandwidth;for(const s of this.priority)this.receivers.get(s)&&(n[s]=0);for(let s=0;s<this.ladder.length&&a;++s){const c=this.ladder[s];for(const u of this.priority){const m=c[u];if(m&&this.receivers.get(u)){const b=Math.max(0,Math.min(m-n[u],a));a-=b,n[u]+=b}}}if(a){const s=a;let c=0;for(const u of this.priority)c+=this.receivers.get(u)??0;for(const u of this.priority){const m=this.receivers.get(u);if(m){const b=Math.min(a,Math.ceil(m*s/c));b&&this.logger.safe.info(`[AllocateSurplus][${u}] ${n[u]} + ${m} | ${a}`),a-=b,n[u]+=b}}}return n}},hEi=class{constructor(n,a,s){this.timeout=a,this.logger=s,this.isFirstTimeDeferred=!0,this.internalCallback=c=>{this.logger.safe.debug(`Trigger reason: ${c}`),n()}}invoke(n){this.logger.safe.debug(`Schedule shouldDefer: ${n}`),this.isFirstTimeDeferred?n?(this.isFirstTimeDeferred=!1,this.startTimer()):(this.stopTimer(),this.internalCallback("request")):this.timeoutId&&n||this.internalCallback("request")}dispose(){this.stopTimer()}startTimer(){this.timeoutId||(this.timeoutId=setTimeout(()=>{this.internalCallback("timeout"),this.timeoutId=void 0},this.timeout),this.logger.safe.debug(`Timer started for : ${this.timeout}ms`))}stopTimer(){this.timeoutId&&(clearTimeout(this.timeoutId),this.timeoutId=void 0,this.logger.safe.debug("Timer stopped"))}},pEi=class{constructor(n){this.logger=n,this.currentFrameSize=yl.Send.initialResolution.fs}setAvailableBandwidth(n){n!==this.lastSendBW&&(this.logger.safe.debug(`Available bandwidth updated ${n}`),this.processEstimatedBandwidth(n))}setMaxFrameSize(n){this.logger.safe.debug(`SetMaxFrameSize ${n}`),n!==this.maxFrameSize?(this.maxFrameSize=n,this.lastSendBW?(this.logger.safe.debug(`Setting max frame size: ${n}`),this.processEstimatedBandwidth(this.lastSendBW)):this.logger.safe.debug("Last send bwe is not defined. Do nothing")):this.logger.safe.debug(`Max frame size did not change. Do nothing, maxFs: ${n}`)}getFrameSize(){return this.currentFrameSize}processEstimatedBandwidth(n){if(this.logger.safe.debug(`Process estimated bandwidth ${n}`),n===0)return this.lastSendBW=0,void this.proposeResolution(0);const{lowRes:a,highRes:s}=yl.Send.getResolutionForBitrate(n);this.logger.safe.debug("low",a,"hi",s);const c=n<this.lastSendBW?s.fs:a.fs;n<this.lastSendBW&&this.currentFrameSize<c?this.logger.safe.debug(`proposed resolution is above the existing one, so we should stay on the current resolution, last bw: ${n}`):(c&&this.proposeResolution(c),this.logger.safe.debug(`Updating last bw: ${n}`),this.lastSendBW=n)}proposeResolution(n){this.logger.safe.debug(`Propose resolution ${n}`);const a=this.maxFrameSize?Math.min(n,this.maxFrameSize):n;a!==this.currentFrameSize&&(this.currentFrameSize=a,this.logger.safe.debug(`Proposed new frame size: ${a} based on bandwidth: ${this.lastSendBW}`))}},cYe=1e8,gEi=[{bwe:2e5,param:5e5},{bwe:5e5,param:12e5},{bwe:8e5,param:25e5},{bwe:12e5,param:4e6}],mEi=[{bwe:2e5,param:240},{bwe:3e5,param:405},{bwe:5e5,param:920},{bwe:9e5,param:2040}],dYe=(n,a,s)=>{for(const c of s)if(a<c.bwe)return Math.min(n,c.param);return n},VTe=(n,a,s=gEi)=>dYe(n,a,s),uYe=(n,a,s=mEi)=>dYe(n,a,s),hYe=class extends jr{constructor(n,a,s){super(a),this.configProvider=n,this.logger=a,this.layoutsNumber=s,this.totalBandwidth=cYe,this.totalBandwidthMax=0,this.logger.safe.debug("Created")}dispose(){this.logger.safe.debug("Disposed"),this.outputLayouts=null,super.dispose()}setAvailableBandwidth(n){this.storeAvailableBandwidth(n),this.inputLayouts?(this.recalculateLayouts(),this.checkForChangesAndNotify()):this.logger.safe.debug("Layouts are not set. Skip update")}setLayouts(n,a){this.storeAvailableBandwidth(a),n.length===this.layoutsNumber?(this.logger.safe.debug(`Set layouts: ${JSON.stringify(n)}`),this.inputLayouts=this.getPrioritizedLayouts(n),this.recalculateLayouts(),this.checkForChangesAndNotify()):this.logger.safe.warn(`Incorrect number of layouts! ${JSON.stringify(n)}, expected ${this.layoutsNumber}`)}getLayouts(){return this.inputLayouts}getPrioritizedLayouts(n){return n}checkForChangesAndNotify(){const n=this.getLayouts();xc(this.outputLayouts,n)?this.logger.safe.debug("Layout has not changed, skip update"):(this.outputLayouts=n.slice(),this.event("onLayoutsChanged").raise())}storeAvailableBandwidth(n){this.logger.safe.debug(`Set available bandwidth: ${n}`),this.totalBandwidth=n,this.totalBandwidthMax=Math.max(this.totalBandwidthMax,this.totalBandwidth)}},fEi=class extends hYe{constructor(n,a){super(n,a,2),this.resolutionManager=new pEi(this.logger.createChild("BWEControlledResolutionManager"))}getLayouts(){return this.hiFiLayout?[this.loFiLayout,this.hiFiLayout]:[this.loFiLayout]}dispose(){super.dispose(),this.resolutionManager=null}getHighLayoutBandwidth(n){const a=this.inputLayouts?.[0].maxBr||0,s=Math.max(n-a,0);this.logger.safe.debug(`Setting available bandwidth for layouts. High: ${s}, low: ${a||"not set"}, total: ${n}`);const c=this.configProvider.config.specCompliantSimulcast?.allowedBweOvershootRatio||1;return Math.floor(s*c)}recalculateLayouts(){const n=this.hiFiLayout,a=this.getHighLayoutBandwidth(this.totalBandwidth);this.resolutionManager.setAvailableBandwidth(a),this.resolutionManager.setMaxFrameSize(this.inputLayouts[1].maxFs),this.loFiLayout=this.getMinimalLayoutParams(this.inputLayouts),this.hiFiLayout=this.getHighLayoutParams(this.inputLayouts,a,this.loFiLayout),this.loFiLayout=this.adjustLowLayoutBasedOnHighLayout(this.hiFiLayout,this.loFiLayout,n)}adjustLowLayoutBasedOnHighLayout(n,a,s){return this.configProvider.config.useMediaQualityControllerForceKeyFrame&&!n&&s&&(this.logger.safe.debug("Forcing kayframe on low layout due to disabling high layout"),a.keyframe=!0),n&&a.maxBr===n.maxBr&&a.maxBr--,a}getPrioritizedLayouts(n){return n.sort((a,s)=>a.maxFs-s.maxFs?a.maxFs-s.maxFs:a.maxFps-s.maxFps)}getHighLayoutParams(n,a,s){const c=n[1];if(c.maxBr<=a)return this.logger.safe.debug(`High layout bandwidth suits requested caps. Applying as-is: ${JSON.stringify(c)}`),c;const u={...n[1],maxFs:this.resolutionManager.getFrameSize(),maxBr:Math.min(a,n[1].maxBr),maxFps:n[1].maxFps},m=u.maxBr<s.maxBr||u.maxFs<s.maxFs||u.maxFs===s.maxFs&&u.maxFps<=s.maxFps,b=`Potential high layout: ${JSON.stringify(u)}`;return!this.hiFiLayout&&m?(this.logger.safe.debug(`High layout is already disabled. Do nothing. ${b}`),null):this.hiFiLayout&&m?(this.logger.safe.debug(`High layout gets disabled. ${b}`),null):(this.hiFiLayout&&xc(u,this.hiFiLayout)?this.logger.safe.debug(`High layout has not been changed. Do nothing. ${b}`):this.hiFiLayout?this.logger.safe.debug(`High layout updated. ${b}`):this.logger.safe.debug(`High layout enabled. ${b}`),u)}getMinimalLayoutParams(n){const a=Math.min(n[0].maxBr,n[1].maxBr),s=this.configProvider.config.specCompliantSimulcast.maxBrControlEnabled?VTe(a,this.totalBandwidth,this.configProvider.config.specCompliantSimulcast.bitrateToBweTable):a;return{...n[0],maxBr:s,maxFps:Math.min(n[0].maxFps,n[1].maxFps),maxFs:Math.min(n[0].maxFs,n[1].maxFs)}}},vEi=class extends hYe{constructor(n,a,s){super(a,s,1),this.couldLimitFs=n}getLayouts(){return[this.layout]}recalculateLayouts(){let n=this.inputLayouts[0].maxFs;if(this.configProvider.config.specCompliantSimulcast.allowResLimit&&this.couldLimitFs&&this.totalBandwidthMax){const c=this.configProvider.config.specCompliantSimulcast.fsToBweTable;n=uYe(this.inputLayouts[0].maxFs,this.totalBandwidthMax,c)}const a=this.configProvider.config.specCompliantSimulcast.bitrateToBweTable,s=VTe(this.inputLayouts[0].maxBr,this.totalBandwidth,a);this.layout={...this.inputLayouts[0],maxFs:n,maxBr:s}}},yEi=class extends jr{constructor(n){super(n),this.logger=n,this.logger.safe.debug("Created")}dispose(){this.logger.safe.debug("Disposed"),super.dispose()}setAvailableBandwidth(n){this.logger.safe.debug(`Available bandwidth updated ${n}`)}setLayouts(n,a){this.layouts=n,this.setAvailableBandwidth(a)}getLayouts(){return this.layouts}},SEi=(n,a)=>n.maxFs===a.maxFs?n.maxFps===a.maxFps?n.maxBr-a.maxBr:n.maxFps-a.maxFps:n.maxFs-a.maxFs,bEi=(n,a)=>n.maxFs===a.maxFs?n.maxFps-a.maxFps:n.maxFs-a.maxFs,TEi=class extends jr{constructor(n,a,s){super(s),this.settings=n,this.configProvider=a,this.logger=s,this.totalBandwidthMax=0,this.totalBandwidth=cYe,this.inputLayouts=null,this.outputLayouts=null,this.maxOutputLayers=0,this.ladder=[],this.settings.ladder?this.ladder.push(...this.settings.ladder):this.ladder.push(...yl.Send.getResolutions())}dispose(){this.logger.safe.debug("Disposed"),super.dispose()}setAvailableBandwidth(n){this.updateAvailableBandwidth(n),this.update()}setLayouts(n,a){this.inputLayouts=n,this.updateAvailableBandwidth(a),this.update()}getLayouts(){return this.outputLayouts??[]}updateAvailableBandwidth(n){this.totalBandwidth!==Math.max(1,n)&&(this.logger.safe.debug(`Available bandwidth updated ${n}`),this.totalBandwidth=Math.max(1,n),this.totalBandwidthMax=Math.max(this.totalBandwidthMax,this.totalBandwidth))}debug(n,a,...s){let c;const u=m=>({FS:m.maxFs,FPS:m.maxFps,BR:m.maxBr,KF:m.keyframe?"1":"0",id:`rid:${m.rid}`??`0x${m.ssrc.toString(16).padStart(8,"0")}`});c=Array.isArray(a)?a.map(u):u(a),this.logger.safe.info(`${n}: <${s.map(m=>JSON.stringify(m)).join("><")}> ${JSON.stringify(c)}`)}update(){const n=this.settings.allowedOvershoot||1,a=this.adjustLayout(this.inputLayouts,this.totalBandwidth*n);if(xc(this.outputLayouts,a))this.logger.safe.debug("Layout has not changed, skip update");else{if(this.settings.allowLayerBitrateOverlap&&a.length&&a.length<this.inputLayouts.length&&(this.setMinimumQuality(a[0],this.inputLayouts),this.debug("SetMinimumQuality",a[0])),this.outputLayouts&&this.settings.forceKeyFrameWhenLayerIsRemoved&&this.outputLayouts.length>a.length)for(const s of a)this.logger.safe.debug(`Force key frame for rid:${s.rid}`),s.keyframe=!0;this.outputLayouts=a,this.maxOutputLayers=Math.max(this.maxOutputLayers,this.outputLayouts.length),this.event("onLayoutsChanged").raise()}}adjustLayout(n,a){const s=[];if(n.length){if(n=n.map(c=>Object.assign({},c)).sort(SEi),this.debug("OriginalLayout",n),this.settings.minFrameSizeForSimulcast?.length>1){const c=this.settings.minFrameSizeForSimulcast;n.length===3&&c?.length===2&&n[n.length-1].maxFs<c[1]&&this.debug("DisableLowResStream",n.pop())}for(this.settings.highPriorityLayoutMinFS&&n.length>1&&n[n.length-1].maxFs>=this.settings.highPriorityLayoutMinFS&&this.settings.lowPriorityLayoutMaxFS?.length&&this.limitResolutionOnLowerSimulcastStreams(n);n.length>0&&a>0;){const c=n.shift();this.debug("Next",c,a),this.settings.allowLayerBitrateOverlap||this.setMinimumQuality(c,n);let u=a-c.maxBr;if(s.length>0){if(u<0&&this.degradeBitrateOrResolution(c,a)&&(this.debug("DegradeBitrateOrResolution",c),u=a-c.maxBr),u>=0){let m=!1;for(const b of s)if(m=bEi(b,c)>=0,this.settings.allowLayerBitrateOverlap||c.maxBr<b.maxBr&&(m=!0),m){this.debug("Drop",c,s.length);break}m||(s.push(c),this.debug("Accept",c,s.length))}}else s.push(c),this.debug("Accept",c,s.length);a=u}this.debug("AdjustedLayout",s,a)}if(s.length===1)if(this.settings.minSinglecastBitrate||this.settings.singlecastLadder){const c=Math.max(this.settings.minSinglecastBitrate??this.totalBandwidth,this.totalBandwidth);this.settings.forceSinglecastLadder&&this.settings.singlecastLadder?this.forceLadder(s[0],c,this.settings.singlecastLadder)&&this.debug("ForceSinglecastLadder",s[0],c):s[0].maxBr>c&&this.degradeBitrateOrResolution(s[0],c,this.settings.singlecastLadder)&&this.debug("DegradeSinglecast",s[0],c)}else{if(this.settings.limitMaxResolution&&this.maxOutputLayers<=1){const c=this.configProvider.config.specCompliantSimulcast?.fsToBweTable;s[0].maxFs=uYe(s[0].maxFs,this.totalBandwidthMax,c),this.debug("LimitMaxFS",s[0],this.totalBandwidthMax)}if(this.settings.limitMaxBitrate){const c=this.configProvider.config.specCompliantSimulcast?.bitrateToBweTable;s[0].maxBr=VTe(s[0].maxBr,this.totalBandwidth,c),this.debug("LimitMaxBitrate",s[0],this.totalBandwidth)}}return s}limitResolutionOnLowerSimulcastStreams(n){const a=n.pop();if(n.length===1){const s=this.settings.lowPriorityLayoutMaxFS[0];this.degradeResolutionTo(n[0],s)&&this.debug("DegradeResolutionTo",n[0],0,s)}else{const s=[...this.settings.lowPriorityLayoutMaxFS];s.sort(),n.splice(Math.min(2,s.length));for(let c=0;c<n.length;++c)this.degradeResolutionTo(n[c],s[c])&&this.debug("DegradeResolutionTo",n[c],c,s[c])}n.push(a)}setMinimumQuality(n,a){for(const s of a)n.maxBr=Math.min(s.maxBr,n.maxBr),n.maxFs=Math.min(s.maxFs,n.maxFs),n.maxFps=Math.min(s.maxFps,n.maxFps),n.maxMbps=n.maxFs*n.maxFps}degradeResolutionTo(n,a){for(;n.maxFs>a;)if(!this.degradeResolution(n))return!1;return!0}degradeResolution(n){const a=this.mapLayoutToLadder(n);if(a>=this.ladder.length)return!1;if(a>0){const s=this.ladder[a-1];return n.maxBr=Math.min(n.maxBr,s.maxBitrate),n.maxMbps=s.fs*s.fps,n.maxFps=s.fps,n.maxFs=s.fs,!0}return!1}degradeBitrateOrResolution(n,a,s){s??(s=this.ladder);const c=this.mapLayoutToLadder(n,s);if(c>=s.length)return!1;if(a>=s[c].minBitrate)return n.maxBr=a,!0;let u=c;for(;u>0;){const m=s[--u];if(a>=m.minBitrate)return n.maxMbps=m.fs*m.fps,n.maxFps=m.fps,n.maxFs=m.fs,n.maxBr=Math.min(a,m.maxBitrate),!0}return!1}forceLadder(n,a,s){s??(s=this.ladder);const c=this.mapLayoutToLadder(n,s);if(c>=s.length)return!1;let u=Math.min(a,n.maxBr);if(u>=s[c].minBitrate){const m=s[c];return u=Math.min(u,m.maxBitrate),(n.maxMbps!==m.fs*m.fps||n.maxBr!==u)&&(n.maxMbps=m.fs*m.fps,n.maxFps=m.fps,n.maxFs=m.fs,n.maxBr=u,!0)}return this.degradeBitrateOrResolution(n,u,s)}mapLayoutToLadder(n,a){let s=0,c=0;for(a??(a=this.ladder);c<a.length&&!(a[c].fs>n.maxFs)&&!(a[c].fs===n.maxFs&&a[c].fps>n.maxFps);)s=c++;return s}},CEi=class extends jr{constructor(n,a,s,c){super(c),this.supportSingleBwControl=n,this.firstTime=a,this.configProvider=s,this.logger=c,this.multiStream=!1,this.wasMultistream=!0,this.deferredOperation=new hEi(()=>this.updateStrategy(),this.configProvider.config.layoutControlTimeout,this.logger.createChild("DeferredOperation")),this.simulcastStrategySettings=void 0,this.wasMultistream=!1,this.createStrategy(this.multiStream,this.firstTime)}configure(n){const a=this.isMultiStream(n);this.multiStream!==a&&(this.multiStream=a,this.simulcastStrategySettings||this.deferredOperation.invoke(this.multiStream&&!this.configProvider.config.specCompliantSimulcast?.maxBrControlEnabled))}onFeaturesChanged(n){const a={},s=this.configProvider.config.specCompliantSimulcast;let c=!1;n.hasServerSupport(0)&&(c=!0),n.hasClientSupport(2)&&this.configProvider.config.video1080p?.useSimulcastLayoutControlStrategy&&(c=!0),n.hasClientSupport(3)&&this.configProvider.config.broadcastMode?.prioritizeLayoutOnClient&&(c=!0),a.limitMaxBitrate=s?.maxBrControlEnabled,a.limitMaxResolution=s?.allowResLimit,a.allowedOvershoot=s?.allowedBweOvershootRatio,a.forceKeyFrameWhenLayerIsRemoved=this.configProvider.config.useMediaQualityControllerForceKeyFrame,c&&a.limitMaxResolution&&(a.limitMaxResolution=this.firstTime&&!this.wasMultistream),n.hasClientSupport(2)&&(n.hasClientSupport(1)||(a.highPriorityLayoutMinFS=this.configProvider.config.video1080p?.software?.highPriorityLayoutMinFS,a.lowPriorityLayoutMaxFS=this.configProvider.config.video1080p?.software?.lowPriorityLayoutMaxFS),a.minSinglecastBitrate=this.configProvider.config.video1080p?.minSinglecastBitrate,this.configProvider.config.video1080p?.singlecastLayoutLadder&&(a.singlecastLadder=Uh(this.configProvider.config.video1080p.singlecastLayoutLadder)),a.forceSinglecastLadder=this.configProvider.config.video1080p?.forceSinglecastLadder),n.hasClientSupport(3)&&(a.highPriorityLayoutMinFS=this.configProvider.config.broadcastMode?.priorityLayoutMinFS,a.lowPriorityLayoutMaxFS=this.configProvider.config.broadcastMode?.lowPriorityLayoutMaxFS),n.hasServerSupport(0)&&(a.minSinglecastBitrate=a.minSinglecastBitrate??s?.minSinglecastBitrate,a.allowLayerBitrateOverlap=s?.allowLayerBitrateOverlap,s?.singlecastLadder&&(a.singlecastLadder=a.singlecastLadder??Uh(s?.singlecastLadder)),s.dropLowResolutionHigherStreams&&(a.minFrameSizeForSimulcast=s.video?.minFsForSimulcast)),!!this.simulcastStrategySettings===c&&xc(a,this.simulcastStrategySettings)||(c?(this.logger.safe.info(`[SLCS] Configure [${this.simulcastStrategySettings?"existing":"initial"}][${this.wasMultistream}]: ${JSON.stringify(a)}`),this.simulcastStrategySettings=a):(this.simulcastStrategySettings&&this.logger.safe.info("[SLCS] Disable"),this.simulcastStrategySettings=void 0),this.deferredOperation.invoke(!1))}setLayouts(n,a){xc(this.latestLayouts,n)&&this.latestBandwidth===a?this.logger.safe.debug("Layouts and bandwidth are not changed. Skipping update"):(this.latestLayouts=n,this.latestBandwidth=a,this.strategy.setLayouts(this.latestLayouts,a))}setAvailableBandwidth(n){this.latestBandwidth!==n?(this.strategy.setAvailableBandwidth(n),this.latestBandwidth=n):this.logger.safe.debug("Bandwidth is not changed. Skipping update")}getLayouts(){return this.strategy.getLayouts()}dispose(){this.strategy.dispose(),this.strategy=null,this.deferredOperation.dispose(),this.deferredOperation=null,super.dispose()}updateStrategy(){this.strategy.dispose(),this.createStrategy(this.multiStream),this.latestLayouts&&this.strategy.setLayouts(this.latestLayouts,this.latestBandwidth)}isMultiStream(n){return n>1}createStrategy(n,a=!1){this.strategy=this.getNewStrategy(n,a),this.strategy.on("onLayoutsChanged",()=>{this.wasMultistream=this.wasMultistream||this.isMultiStream(this.strategy.getLayouts().length),this.event("onLayoutsChanged").raise()})}getNewStrategy(n,a){return this.simulcastStrategySettings?new TEi(this.simulcastStrategySettings,this.configProvider,this.logger.createChild("SimulcastLayoutControlStrategy")):n?new fEi(this.configProvider,this.logger.createChild("BWEControlledStrategy")):this.configProvider.config.specCompliantSimulcast?.maxBrControlEnabled&&this.supportSingleBwControl?new vEi(a,this.configProvider,this.logger.createChild("BWEControlledStrategySingle")):new yEi(this.logger.createChild("NoControlStrategy"))}},_Ei=class extends jr{constructor(n,a,s){super(a),this.configProvider=n,this.logger=a,this.videoFeatures=s,this.bandwidthAllocator=null,this.sendBandwidthCalculator=new H_i(this.configProvider,this.logger.createChild("SendBandwidthCalculator")),this.layoutProviders=new Map,this.hadLayoutProvider=new Set,this.useNewBandwidthAllocator=!1,this.highestVideoMaxFsWithSharingEnabled=0,this.bandwidthAllocator=sEi(this.logger,this.configProvider),this.sendBandwidthCalculator.on("onSendBandwidthChanged",c=>this.onAvailableBandwidthChanged(c)),this.configProvider.config.sendBandwidthSeedValue&&this.bandwidthAllocator.setAvailableBandwidth(this.configProvider.config.sendBandwidthSeedValue),this.useVideoFeatures("Video")&&this.videoFeatures.on("onVideoFeaturesChanged",c=>{if(this.useVideoFeatures(c.mediaType)){const u=this.layoutProviders.get(c.mediaType);u&&u.onFeaturesChanged(c)}if(!this.useNewBandwidthAllocator&&this.configProvider.config.bandwidthAllocatorV2.enableAllocator){let u=!1;c.hasServerSupport(0)&&(u=!0),c.hasClientSupport(2)&&this.configProvider.config.video1080p?.useNewBandwidthAllocator&&(u=!0),u&&this.switchBandwidthAllocator()}})}dispose(){this.bandwidthAllocator=null,this.layoutProviders.forEach(n=>n.dispose()),this.layoutProviders.clear(),this.layoutProviders=null,super.dispose()}addReceiver(n,a){this.logger.safe.debug(`Set receiver max capabilities for ${n}: ${JSON.stringify(a)}`),this.configureProviders(n,a.length);const s=a.map(u=>u.maxBr).reduce((u,m)=>u+m);if(this.useNewBandwidthAllocator&&n==="Video"&&this.layoutProviders.has("ScreenShare")&&this.configProvider.config.bandwidthAllocatorV2.enableDynamicVideoLadder){const u=Math.max(...a.map(m=>m.maxFs));u>this.highestVideoMaxFsWithSharingEnabled&&(this.highestVideoMaxFsWithSharingEnabled=u,this.bandwidthAllocator.setLadder("Video",lYe(this.configProvider,u)))}this.bandwidthAllocator.addReceiverCapability(n,s);const c=this.bandwidthAllocator.getLayouts();this.layoutProviders.get(n).setLayouts(a,c[n]),this.updateBandwidthDistribution()}removeReceiver(n){this.logger.safe.debug(`Removing receiver for ${n}`),this.layoutProviders.get(n)?.dispose(),this.layoutProviders.delete(n),this.highestVideoMaxFsWithSharingEnabled=0,this.bandwidthAllocator.removeReceiver(n),this.updateBandwidthDistribution()}getLayouts(n){return this.layoutProviders.get(n).getLayouts()}onStatisticsChanged(n){this.sendBandwidthCalculator.onBandwidthChanged(n.estimatedSendBandwidth)}onDiagnosticUpdated(n){n.video?.send?.length&&n.video?.send[0]&&(this.configProvider.config.diagnostics.traceLogging&&this.logger.safe.debug("Caught onDiagnosticUpdated: Estimating send bandwidth"),this.sendBandwidthCalculator.onBandwidthChanged(YJe(n.video.send[0],this.configProvider)))}useVideoFeatures(n){return!(n!=="Video"||!this.configProvider.config.specCompliantSimulcast?.enableSimulcastLayoutControlStrategy&&!this.configProvider.config.broadcastMode?.prioritizeLayoutOnClient&&!this.configProvider.config.video1080p?.useSimulcastLayoutControlStrategy)}switchBandwidthAllocator(){const n=dEi(this.logger,this.configProvider);n.setAvailableBandwidth(this.bandwidthAllocator.getAvailableBandwidth());const a=this.bandwidthAllocator.getReceiverCapabilities();for(const s of Object.keys(a))n.addReceiverCapability(s,a[s]);this.useNewBandwidthAllocator=!0,this.bandwidthAllocator=n,this.updateBandwidthDistribution()}configureProviders(n,a){if(!this.layoutProviders.has(n)){const s=this.createProvider(n);this.layoutProviders.set(n,s)}this.useVideoFeatures(n)&&a>2&&this.videoFeatures.get(n).toggleServer(0,!0),this.layoutProviders.get(n).configure(a)}createProvider(n){const a=new CEi(n==="Video",!this.hadLayoutProvider.has(n),this.configProvider,this.logger.createChild(`LG:${n}`));return a.on("onLayoutsChanged",()=>{const s=a.getLayouts();this.logger.safe.debug(`New layouts generated: ${JSON.stringify(s)}`),this.event("onLayoutsUpdated").raise(n)}),this.hadLayoutProvider.add(n),this.useVideoFeatures(n)&&a.onFeaturesChanged(this.videoFeatures.get(n)),a}onAvailableBandwidthChanged(n){this.bandwidthAllocator.setAvailableBandwidth(n),this.updateBandwidthDistribution()}adjustBandwidthDistribution(n,a){const s=new Map;a?(s.set("ScreenShare",this.configProvider.config.bandwidthAllocatorV2?.sharing?.remote),s.set("Video",this.configProvider.config.bandwidthAllocatorV2?.video?.remote)):(s.set("ScreenShare",this.configProvider.config.bandwidthAllocatorV2?.sharing?.local),s.set("Video",this.configProvider.config.bandwidthAllocatorV2?.video?.local));const c=cEi({...n},s);for(const u of["Video","ScreenShare"])c[u]!==n[u]&&this.logger.safe.info(`Adjusted ${a?"remote":"local"} ${u} BWE from ${n[u]} to ${c[u]}`);return c}updateBandwidthDistribution(){const n=this.bandwidthAllocator.getLayouts();let a;a=n,this.useNewBandwidthAllocator&&(a=this.adjustBandwidthDistribution(n,!1));for(const[s,c]of Object.entries(a))this.layoutProviders.get(s)?.setAvailableBandwidth(c);this.configProvider.config.mediaControlPlaneConfig?.enableSendBandwidthNotificationsEnabled&&(a=n,this.useNewBandwidthAllocator&&(a=this.adjustBandwidthDistribution(n,!0)),this.event("onBandwidthAllocationUpdated").raise(a))}},lE=dn;function pYe(n,a,s){if(n!=="Video"||!s)return s;const{maxBitrate:c,maxResolution:u,maxFramerate:m}=a.config.outgoingVideoLimit??{},b=c??1/0;let _=u?RD(u):1/0,k=m??1/0;return a.config.sendVideoCapabilityManager?.isEnabled&&(_=1/0,k=1/0),b===1/0&&_===1/0&&k===1/0?s:s.map(N=>({...N,maxFs:xg(N.maxFs,_),maxBr:xg(N.maxBr,b),maxFps:xg(N.maxFps,k)}))}var EEi=new Set(["maintain-framerate","maintain-resolution","balanced"]),gYe=class{constructor(n,a){this.configProvider=n,this.logger=a}async setActive(n,a){const s=this.getSenderParameters(n);return s.encodings[0].active=a,this.setSenderParameters(n,s,"setActive")}getScaleFactor(n,a){if(!a.width||!a.height)return this.logger.safe.warn("Stream resolution is not set yet. Cannot calculate scale factor. Returning 1"),1;const s=yl.Send.getResolutionByFs(n);let c=Math.min(a.width,a.height)/s.height;return this.logger.safe.debug(`Scale factor is taken from resolution: ${JSON.stringify(a)} and new Fs: ${n} as ${c}`),c<1&&(this.logger.safe.warn("Scale factor cannot be less than 1! Limiting to 1"),c=1),c}async generateKeyFrameIfNeeded(n,a){if(!a.track)return void this.logger.safe.info("No track attached. Skipping");const s=this.getSenderParameters(a),c=n.filter(u=>u.keyframe).map(u=>u.rid);if(c.length!==0&&s.encodings.some(u=>u.active))if(this.configProvider.config.useKeyFrameApi){const u=[];s.encodings.forEach(m=>{!m.active||m.rid&&!c.includes(m.rid)?u.push({keyFrame:!1}):u.push({keyFrame:!0})}),await this.setSenderParameters(a,s,"generateKeyFrameAPI",!0,{encodingOptions:u})}else{const u=s.encodings.map((b,_)=>b.active?b.rid&&!c.includes(b.rid)?null:{idx:_,factor:b.scaleResolutionDownBy||1}:null).filter(b=>b);for(const b of u)s.encodings[b.idx].scaleResolutionDownBy=b.factor*this.configProvider.config.forceKeyFrameV2ScaleFactor;this.logger.safe.debug(`Restoring keyframe starting. Update scaleResolutionDownBy for encodings: ${JSON.stringify(s.encodings)}`),await this.setSenderParameters(a,s,"generateKeyFrameStart");const m=this.getSenderParameters(a);for(const b of u)m.encodings[b.idx].scaleResolutionDownBy=b.factor;await this.setSenderParameters(a,m,"generateKeyFrameEnd"),this.logger.safe.debug(`Restoring keyframe completed. Set scaleResolutionDownBy back for encodings: ${JSON.stringify(m.encodings)}`)}else this.logger.safe.info("No keyframes needed. Skipping")}getSenderParameters(n){const a=n.getParameters();if(a.encodings?.length||(a.encodings=[{}]),this.configProvider.config.reuseLastSetParameters&&this.lastSetEncodings){this.logger.safe.info(`Override returned encodings ${JSON.stringify(a.encodings)}`);const s=(0,lE.merge)((0,lE.cloneDeep)(a.encodings),this.lastSetEncodings);this.logger.safe.info(`Overrided encodings ${JSON.stringify(s)}`),a.encodings=s}return a}async setSenderParameters(n,a,s,c=!0,u){try{await n.setParameters(a,u),this.logger.safe.info(`${s}: Parameters applied for sender: encodings: ${JSON.stringify(a.encodings)}, degradationPreference: ${a.degradationPreference}`),this.lastSetEncodings=a.encodings}catch(m){const b=`${s}: setParameters failed. Parameters: ${JSON.stringify(a.encodings)}, error:  ${nn(m)}`;if(this.logger.safe.error(b),c)throw new Error(b)}}getAdjustedBitrate(n,a){let s=n||0;const{maxBitrate:c}=yl.Send.getBitrateForResolution(a.width,a.height);return s=Math.min(s||c,c),s}async updateStreamParameters(n,a,s){if(n.getCurrentConstraints().withEffect&&a?.maxFs){const c=yl.Send.getResolutionByFs(a.maxFs),u={width:c.width,height:c.height};this.logger.safe.info(`Applying video constrains for video effetcs ${JSON.stringify(u)}`),n.resetEffectsOutputConstraints(u)}s&&await n.applyCapabilities(a)}augmentDegradationPreference(n,a){EEi.has(a)&&n.degradationPreference!==a&&(n.degradationPreference=a,this.logger.safe.info(`degradationPreference changed to: ${n.degradationPreference}`))}async setEncodingsActiveState(n,a,s){this.logger.safe.info(s);const c=this.getSenderParameters(n);return c.encodings.forEach(u=>u.active=a),this.setSenderParameters(n,c,s)}},AEi=class{constructor(n,a,s){this.config=n,this.configProvider=a,this.logger=s,this.capabilitiesHelper=new gYe(this.configProvider,this.logger)}get streamResolution(){return this.stream?.getCurrentConstraints().withEffect?this._streamResolutionFromCapabilities:this._streamResolution}setSender(n){this.rtpSender=n}updateStream(n){this.stream=n,this._streamResolution=n.getResolution(),this._streamResolutionFromCapabilities=this._streamResolution}setActive(n){return this.capabilitiesHelper.setActive(this.rtpSender,n)}async setCapabilities(n){(0,lE.isEqual)(this.currentCapabilities,n)?this.logger.safe.info(`Capabilities already applied: ${JSON.stringify(n)}. Do nothing`):(this.defaultCapabilities=(0,lE.cloneDeep)(n),this.currentCapabilities=(0,lE.cloneDeep)(n),await this.applyLastCapabilities(),await this.capabilitiesHelper.generateKeyFrameIfNeeded(n,this.rtpSender))}async updateStreamQualityParams(n,a,s){if(n&&!(0,lE.isEqual)(this.streamResolution,n))return this._streamResolution=n,this._streamResolutionFromCapabilities=n,this.logger.safe.info(`Stream params changed: ${JSON.stringify(n)}@${a}@${s} id: ${this.rtpSender.track?.id}`),this.applyLastCapabilities();this.logger.safe.debug(`Resolution is not defined or same: ${JSON.stringify(n)}@${a}`)}async startSender(){return UV(this.configProvider,this.stream)||c9(this.configProvider,this.stream)?this.capabilitiesHelper.setEncodingsActiveState(this.rtpSender,!0,"Starting senders."):void 0}async stopSender(){return this.capabilitiesHelper.setEncodingsActiveState(this.rtpSender,!1,"Stopping senders.")}async applyLastCapabilities(){if(!this.currentCapabilities)return void this.logger.safe.info("Capabilities are not set. Do nothing");this.currentCapabilities=pYe(this.stream.mediaType,this.configProvider,this.defaultCapabilities),await this.applyStreamCapabilities(this.currentCapabilities);const n=this.capabilitiesHelper.getSenderParameters(this.rtpSender),a=(0,lE.cloneDeep)(n);return this.currentCapabilities.forEach(s=>{const c=this.getEncondingIndexForRid(s.rid,n.encodings);this.updateEncodingsWithCaps(n.encodings[c],s)}),this.capabilitiesHelper.augmentDegradationPreference(n,this.configProvider.config.degradationPreference),this.updateActiveStates(n,this.currentCapabilities),this.logger.safe.info(`Encoding params new: ${JSON.stringify(n.encodings)}, old: ${JSON.stringify(a.encodings)}`),this.capabilitiesHelper.setSenderParameters(this.rtpSender,n,"applyCapabilities")}async applyCallConstraints(n){return this.logger.safe.info(`[${n}] Applying call constraints`),this.applyLastCapabilities()}async applyStreamCapabilities(n){if(this.stream.mediaType!=="Video"||!n.length)return;let a=n[0];for(const c of n)a.maxFs<c.maxFs&&(a=c);if(n.length>1){const c=this.configProvider.config.specCompliantSimulcast.video.minFsForSimulcast;if(a=(0,lE.cloneDeep)(a),c?.length>0)for(let u=0;u<c.length;++u)n.length>u+1&&(a.maxFs=Math.max(c[u]||0,a.maxFs),a.maxFps=Math.max(...n.map(m=>m.maxFps)))}const s=this.configProvider.config.specCompliantSimulcast.video.useApplyConstraints;await this.capabilitiesHelper.updateStreamParameters(this.stream,a,s),s&&(this._streamResolution=this.stream.getResolution())}getEncondingIndexForRid(n,a){if(!n)return this.logger.safe.error("No RID found in incoming params. Returning index 0"),0;const s=a.findIndex(c=>c.rid===n);return s<0||s-1>this.config.layerScaleFactors.length?(this.logger.safe.error("Incorrect index deduced from requested RID. Returning index 0"),0):s}updateEncodingsWithCaps(n,a){n?(n.maxBitrate=a.maxBr,n.scaleResolutionDownBy=this.capabilitiesHelper.getScaleFactor(a.maxFs,this.streamResolution),n.maxFramerate=a.maxFps,this.config.defaultScalabilityMode&&(n.scalabilityMode=this.config.defaultScalabilityMode)):this.logger.safe.error(`SenderParams does not exist for caps: ${JSON.stringify(a)}`)}updateActiveStates(n,a){const s=n.encodings.map(m=>m.rid),c=s.filter(m=>a.some(b=>m===b.rid)),u=y2(s,c);c.forEach(m=>this.changeEncodingState(n,m,!0)),u.forEach(m=>this.changeEncodingState(n,m,!1))}changeEncodingState(n,a,s){const c=n.encodings.find(u=>u.rid===a);c?c.active=s:this.logger.safe.error(`Encoding not found for RID: ${a}`)}},IEi=class{constructor(n,a){this.configProvider=n,this.logger=a,this.capabilitiesHelper=new gYe(this.configProvider,this.logger)}get params(){return this.currentCapabilities?.find(n=>n.rid==="1")??this.currentCapabilities?.[0]}get useSetParameter(){if(this.stream.mediaType==="ScreenShare"){if(this.configProvider.config.useSetParametersToApplySSCapabilities)return this.logger.safe.info("useSetParametersToApplySSCapabilities: true"),!0;if(this.configProvider.config.useSetParametersToApplySSCapabilities===!1)return this.logger.safe.info("useSetParametersToApplySSCapabilities: false"),!1}return!!this.configProvider.config.useSetParametersToApplyCapabilities&&(this.logger.safe.info("useSetParametersToApplyCapabilities"),!0)}async applyCallConstraints(n){return this.logger.safe.info(`[${n}] Applying call constraints`),this.applyLastCapabilities(3)}setSender(n){this.rtpSender=n}updateStream(n){this.stream=n,this.streamResolution=n.getResolution()}setActive(n){return this.capabilitiesHelper.setActive(this.rtpSender,n)}async setCapabilities(n){(0,lE.isEqual)(this.currentCapabilities,n)?this.logger.safe.info(`Capabilities already applied: ${JSON.stringify(n)}. Do nothing`):n.length===1?(this.defaultCapabilities=(0,lE.cloneDeep)(n),this.currentCapabilities=(0,lE.cloneDeep)(n),await this.applyLastCapabilities(0),await this.capabilitiesHelper.generateKeyFrameIfNeeded(n,this.rtpSender)):this.logger.safe.error("Incorrect number of sender params!")}async updateStreamQualityParams(n,a,s){if(n&&!(0,lE.isEqual)(this.streamResolution,n))return this.streamResolution=n,this.logger.safe.debug(`Stream params changed: ${JSON.stringify(n)}@${a}`),this.applyLastCapabilities(s);this.logger.safe.debug(`Resolution is not defined or same: ${JSON.stringify(n)}@${a}`)}async startSender(n){this.logger.safe.info(`Replace sender with track: ${n.id}`),await this.rtpSender.replaceTrack(n),this.logger.safe.info("replaceTrack completed"),UV(this.configProvider,this.stream)&&await this.capabilitiesHelper.setEncodingsActiveState(this.rtpSender,!0,"Starting senders."),c9(this.configProvider,this.stream)&&await this.capabilitiesHelper.setEncodingsActiveState(this.rtpSender,!0,"Starting senders."),this.configProvider.config.applySenderParamsBeforeStart&&this.currentCapabilities&&await this.capabilitiesHelper.generateKeyFrameIfNeeded(this.currentCapabilities,this.rtpSender)}async stopSender(){return UV(this.configProvider,this.stream)||c9(this.configProvider,this.stream)?this.capabilitiesHelper.setEncodingsActiveState(this.rtpSender,!1,"Stopping senders."):(this.logger.safe.info("Replace sender with track: null"),await this.rtpSender.replaceTrack(null),void this.logger.safe.info("replaceTrack completed"))}async applyLastCapabilities(n){this.currentCapabilities?(this.currentCapabilities=pYe(this.stream.mediaType,this.configProvider,this.defaultCapabilities),this.logger.safe.info(`Applying params: ${JSON.stringify(this.params)}`),await this.applyParams(this.params,n),await this.applyBitrate(this.params.maxBr)):this.logger.safe.debug("Capabilities are not yet set, nothing to apply")}applyBitrate(n){let a=n||0;return this.stream.mediaType==="Video"&&(a=this.capabilitiesHelper.getAdjustedBitrate(a,this.streamResolution)),this.setSingleEncodingParameters(this.rtpSender,{maxBitrate:a},"applyBitrate",!1)}async applyParams(n,a){if(this.useSetParameter)return this.setSingleEncodingParameters(this.rtpSender,{scaleResolutionDownBy:this.capabilitiesHelper.getScaleFactor(n.maxFs,this.streamResolution),maxFramerate:n.maxFps},"applyParams");a!==2&&await this.capabilitiesHelper.updateStreamParameters(this.stream,n,!0)}async setSingleEncodingParameters(n,a,s,c=!0){const u=this.capabilitiesHelper.getSenderParameters(n);return(0,lE.merge)(u.encodings[0],a),u.encodings[0].maxBitrate===0&&(this.configProvider.config.setParametersMaxBitrateUndefined?u.encodings[0].maxBitrate=void 0:delete u.encodings[0].maxBitrate),this.capabilitiesHelper.augmentDegradationPreference(u,this.configProvider.config.degradationPreference),this.capabilitiesHelper.setSenderParameters(this.rtpSender,u,s,c)}},wEi=class{constructor(n,a,s){this.transitionStates=n,this.logger=s,this.stateCurrent=a}get state(){return this.stateCurrent}isDestinationStateValid(n){return this.transitionStates[this.stateCurrent].indexOf(n)>-1}setState(n){return this.isDestinationStateValid(n)?(this.stateCurrent=n,!0):(n!==this.stateCurrent&&this.logger.safe.info(`Invalid state transition ${this.stateCurrent} -> ${n}`),!1)}isCurrentStateMatchedWith(n){return this.stateCurrent===n||(this.logger.safe.info(`State does not match. Current: ${this.stateCurrent} required: ${n}`),!1)}},kEi=class extends jr{constructor(n,a){super(n),this.logger=n,this.configProvider=a,this.audioContext=new Cc.window.AudioContext(this.configProvider.config.audioSharingContextOptions),this.destination=this.audioContext.createMediaStreamDestination(),this.streamNodeMap=new Map,this.logger.safe.info(`Destination stream: ${this.destination.stream.id}, track: ${this.getDestinationTrack().id}`),this.subscribeOnMediaTrackEvents(this.getDestinationTrack())}get numberOfStreams(){return this.streamNodeMap.size}addSourceStream(n){if(!n.rawStream||this.streamNodeMap.has(n.rawStream))return;const a=n.on("onStreamClientDisposing",()=>{this.removeSourceStream(n.rawStream),a.dispose()});this.logger.safe.info(`Add stream: ${n.rawStream.id}, track: ${$Te(n.rawStream).id}`),this.addStream(n.rawStream,n.mediaType)}getDestinationTrack(){return $Te(this.destination.stream)}dispose(){super.dispose(),this.unsubscribeFromMediaTrackEvents(this.getDestinationTrack());for(const n of this.streamNodeMap.keys())this.removeSourceStream(n);this.audioContext.close(),this.audioContext=null}addStream(n,a="Audio"){const s=this.audioContext.createMediaStreamSource(n);s.connect(this.destination),this.streamNodeMap.set(n,{mediaType:a,sourceNode:s})}removeSourceStream(n){const a=this.streamNodeMap.get(n);a&&(this.logger.safe.info(`Remove stream: ${n.id}, track: ${$Te(n).id}`),a.sourceNode.disconnect(),this.streamNodeMap.delete(n))}subscribeOnMediaTrackEvents(n){n.onended=a=>{this.logger.safe.info(`Track ${n.id} ended: ${JSON.stringify(a)}`)},n.onmute=()=>{this.logger.safe.info(`Track ${n.id} muted`)},n.onunmute=()=>{this.logger.safe.info(`Track ${n.id} unmuted`)}}unsubscribeFromMediaTrackEvents(n){n.onended=null,n.onmute=null,n.onunmute=null}};function $Te(n){return n.getAudioTracks()[0]}var REi=class extends jr{constructor(n,a,s,c,u,m,b){super(),this.mediaConnection=n,this.contextStream=s,this.logger=c,this.configProvider=u,this.encStreamsManager=m,this.capabilitiesManager=b,this.isMuted=!1,this.isActiveInternal=!1,this.stream=a.clone("streamSender ctor"),this.subscribeOnStreamClientMuted(),this.capabilitiesManager.updateStream(this.stream)}get rawTrack(){return this.audioMixer?.getDestinationTrack()||this.stream.rawTrack}get trackId(){return this.rawTrack?.id}applyCallConstraints(n){return this.capabilitiesManager.applyCallConstraints(n)}async init(){this.sender=await this.createSender(),this.isActiveInternal=!0,this.addStreamTransforms(),this.capabilitiesManager.setSender(this.sender)}async start(){this.isActive()?this.logger.safe.info("Already active. Do nothing"):(this.logger.safe.info("Starting"),this.isActiveInternal=!0,await this.capabilitiesManager.startSender(this.rawTrack),this.logger.safe.info("Started"))}async stop(){this.isActive()?(this.logger.safe.info("Stopping"),this.isActiveInternal=!1,await this.capabilitiesManager.stopSender(),this.logger.safe.info("Stopped")):this.logger.safe.info("Already stopped. Do nothing")}async setCapabilities(n){this.configProvider.config.applySenderParamsBeforeStart||await this.start();try{await this.capabilitiesManager.setCapabilities(n)}catch(a){this.logger.safe.error(`Error setting capabilities: ${nn(a)}`)}await this.start()}updateStreamQualityParams(n,a,s){return this.capabilitiesManager.updateStreamQualityParams(n,a,s)}setMuted(n,a,s){this.isMuted=n,this.stream.setMuted(n,a),n&&this.audioMixer&&this.audioMixer.numberOfStreams!==1||this.audioMuteTransform?.mute(n),!this.configProvider.config.requestNewStreamOnUnmute||n||s||this.stream.isActive()||this.event("onNewStreamNeeded").raise()}async setHold(n,a){if(this.configProvider.config.holdSkipActivation)return;const s=!n;this.logger.safe.info(`[${a}] change isActive state to ${s}`);try{return this.capabilitiesManager.setActive(s)}catch(c){const u=this.configProvider.config.holdRetryActivationDelay;if(u>=0)return this.logger.safe.info(`[${a}] retrying after delay of ${u}`),await Br(u),this.logger.safe.info(`[${a}] change isActive state to ${s}, second attempt`),this.capabilitiesManager.setActive(s);throw c}}async setMainStream(n){return this.stream.dispose(),this.onStreamClientMutedSubscription?.dispose(),this.stream=n.clone("streamSender setMainStream"),this.stream.setMuted(this.isMuted),this.audioMixer?.addSourceStream(this.stream),this.isActive()&&(this.logger.safe.info(`Replace sender with track: ${this.rawTrack?.id}`),await this.sender.replaceTrack(this.rawTrack),this.logger.safe.info("Replace completed")),this.capabilitiesManager.updateStream(this.stream),this.subscribeOnStreamClientMuted(),this.capabilitiesManager.applyLastCapabilities(1)}async addAdditionalStream(n){if(this.stream.mediaType==="Audio"){if(this.configProvider.config.postponeAudioMixerForAudioSharing&&this.setupAudioMixer(),this.audioMixer||this.logger.safe.error(`addAdditionalStream is called when audioMixer is not created. Main stream type is ${this.stream.mediaType}.`),this.audioMixer?.addSourceStream(n),this.audioMuteTransform?.mute(!1),this.configProvider.config.postponeAudioMixerForAudioSharing){if(!this.sender)return void this.logger.safe.error("Sender not created, cannot replace track");this.logger.safe.info(`addAdditionalStream replace sender with track: ${this.rawTrack?.id}`),await this.sender.replaceTrack(this.rawTrack),this.logger.safe.info("addAdditionalStream replace completed")}}else this.logger.safe.error("Not adding additional stream for non-audio stream")}dispose(){this.removeSender(),this.cleanUp()}async terminateAsync(){await this.removeSenderAsync(),this.cleanUp()}getActiveStreamIndexes(){return this.getSenderParameters().encodings.filter(n=>n.active).map(n=>+n.rid)}isActive(){return this.sender&&(UV(this.configProvider,this.stream)||c9(this.configProvider,this.stream))?this.getSenderParameters().encodings[0].active:this.isActiveInternal}removeSender(){this.logger.safe.info("Removing sender from pc");try{this.mediaConnection.removeSender(this.sender)}catch(n){this.logger.safe.warn(`Error removing sender: ${nn(n)}`)}}async removeSenderAsync(){this.logger.safe.info("Removing sender from pc");try{await this.mediaConnection.removeSenderAsync(this.sender)}catch(n){this.logger.safe.warn(`Error removing sender: ${nn(n)}`)}}async createSender(){return this.configProvider.config.postponeAudioMixerForAudioSharing||this.setupAudioMixer(),this.mediaConnection.createSender(this.rawTrack,this.contextStream,KR(this.stream.mediaType))}addStreamTransforms(){const n=this.encStreamsManager.initTransformsCollection(this.sender,"Sender",this.stream.mediaType);n&&(this.stream.mediaType==="Audio"?this.configProvider.config.useInsertableStreams?.audioExtendedMute&&(this.audioMuteTransform=new shi(this.logger.createChild("SendAudioPayload")),n.addTransform(this.audioMuteTransform)):this.configProvider.config.useInsertableStreams?.videoStreamAnalyzer&&n.addTransform(new L7e(this.logger.createChild(`SendStreamAnalyzer [${this.stream.mediaType}]`))))}setupAudioMixer(){this.configProvider.config.enableAudioSharing?this.stream.mediaType==="Audio"?this.configProvider.config.audioSharingMemoryLeakFix&&this.audioMixer?this.logger.safe.debug("Audio mixer already created, not creating new one"):(this.audioMixer=new kEi(this.logger.createChild("AudioMixer"),this.configProvider),this.audioMixer.addSourceStream(this.stream)):this.logger.safe.error("Not setting up audio mixer for non-audio stream"):this.logger.safe.info("Audio sharing is disabled, not setting up audio mixer")}getSenderParameters(){const n=this.sender.getParameters();return n.encodings?.length||(n.encodings=[{}]),n}subscribeOnStreamClientMuted(){this.configProvider.config.recoverOnStreamUnmute&&(this.onStreamClientMutedSubscription=this.stream.on("onStreamClientMuted",async(n,a)=>{a||await this.capabilitiesManager.applyLastCapabilities(1)}))}cleanUp(){super.dispose(),this.encStreamsManager.clearTransformsCollection(this.sender),this.sender=null,this.audioMixer?.dispose(),this.stream.dispose(),this.onStreamClientMutedSubscription?.dispose(),this.stream=null,this.isActiveInternal=!1}},hM=class OQe extends jr{constructor(a,s,c,u,m,b,_,k,N,W,ee){super(),this.mediaConnection=a,this.mainStream=s,this.contextStream=c,this.mediaType=u,this.serialQueue=m,this.logger=b,this.configProvider=_,this.isAlwaysActive=k,this.encStreamsManager=N,this.simulcastContext=W,this.sendVideoCapabilityManager=ee,this.isMuted=!1,this.isHold=!1,this.previousParameters=[],this.state=new wEi(OQe.transitionStates,"NotStarted",this.logger.createChild("state")),this.pendingStream=null,this.pendingParams=null,this.lastAppliedParams=null,this.subscribeOnQualityUpdates(this.mainStream),ee&&this.sendVideoCapabilityManager.on("onCapabilitiesChanged",oe=>{this.event("onMaxVideoSendCapabilitiesChanged").raise(oe),this.configProvider.config.applyMaxCapabilitiesToSenderParamsDirectly&&this.lastAppliedParams&&!this.pendingParams&&this.updateParameters(this.lastAppliedParams)})}async start(){this.state.setState("Started")&&(this.sender=new REi(this.mediaConnection,this.mainStream,this.contextStream,this.logger.createChild("Sender"),this.configProvider,this.encStreamsManager,this.getCapabilitiesManager(this.simulcastContext)),await this.sender.init(),this.notifyMaxVideoSendCapabilitiesChanged(),this.configProvider.config.deactiveAudioSender&&this.mediaType==="Audio"&&(this.logger.safe.info("start(): Deactivating audio sender"),await this.sender.stop()),this.sender.on("onNewStreamNeeded",()=>{this.logger.safe.info("onNewStreamNeeded"),this.event("onNewStreamNeeded").raise()}))}async activate(){if(this.state.setState("Active")&&(this.pendingStream&&(this.logger.safe.info("activate(): updating from pendingStream"),await this.updateStreamInternal(this.pendingStream),this.pendingStream=null),this.isAlwaysActive&&!this.isMuted&&this.mediaType==="Audio"&&(this.logger.safe.info("activate(): starting sender"),await this.sender.start()),this.isAlwaysActive?(this.event("onSendersChanged").raise(this,!0),this.logger.safe.info("Sender set to always active")):await this.sender.stop(),this.configProvider.config.enableCachingFMTP&&this.pendingParams)){const a=async()=>{this.configProvider.config.enableCachingFMTPDelay>0&&(this.logger.safe.info("Applying delay before applying pending parameters"),await Br(this.configProvider.config.enableCachingFMTPDelay)),this.logger.safe.info("Apply pending parameters");const s=this.updateParametersInternal(this.pendingParams);return this.pendingParams=null,s};this.configProvider.config.enableCachingFMTPAwait?(this.logger.safe.info("Apply pending parameters"),await a()):(this.logger.safe.info("Apply pending parameters in background"),a().catch(s=>this.logger.safe.error("Error applying pending parameters",s)))}}updateStream(a){return this.updateStreamInternal(a)}async addAdditionalStream(a){return this.sender.addAdditionalStream(a)}async updateParameters(a){if(this.state.isCurrentStateMatchedWith("Active"))return this.updateParametersInternal(a);this.configProvider.config.enableCachingFMTP?(this.logger.safe.info("Postpone params update until sender is activated"),this.pendingParams=a):this.logger.safe.warn("Ignore params update as sender is not activated")}async terminateAsync(){this.state.setState("Disposed")&&(this.logger.safe.info("Terminating async"),await this.sender.terminateAsync(),this.cleanUp())}dispose(){this.state.setState("Disposed")&&(this.logger.safe.info("Disposing"),this.sender.dispose(),this.cleanUp())}async setHold(a,s){if(this.isHold!==a)return this.logger.safe.info(`[${s}] Setting hold to: ${a}`),this.isHold=a,this.sender.setHold(a,s);this.logger.safe.info(`[${s}] Already in hold=${a} state`)}setMuted(a,s,c){this.logger.safe.info(`[${s}] Setting muted to: ${a}`),this.isMuted=a,this.sender.setMuted(this.isMuted,s,c),!this.isMuted&&this.mediaType==="Audio"&&this.state.isCurrentStateMatchedWith("Active")&&this.sender.start()}getActiveStreamIndexes(){return this.sender?this.sender.getActiveStreamIndexes():[]}getTrackInfo(){return{modality:KR(this.mediaType),trackId:this.sender.trackId}}applyCallConstraints(a){return this.sendVideoCapabilityManager?.applyCallConstraints(a),this.sender.applyCallConstraints(a)}getCapabilitiesManager(a){return a?.shouldUseSimulcast()?new AEi(a.config,this.configProvider,this.logger.createChild("SimCapMgrV2")):new IEi(this.configProvider,this.logger.createChild("SnglCapMgrV2"))}async updateStreamInternal(a){return this.logger.info(`updateStreamInternal(): id: ${a.id}, parentId: ${a.parentId}), mediaType: ${this.mediaType}`),this.state.isCurrentStateMatchedWith("Active")?this.mainStream!==a?(this.logger.safe.debug(`Switching streams: ${this.mainStream.parentId}:${this.mainStream.id} -> ${a.parentId}:${a.id}`),this.unsubscribeFromQualityEvents(),this.mainStream.dispose(),this.mainStream=a,this.subscribeOnQualityUpdates(this.mainStream),this.notifyMaxVideoSendCapabilitiesChanged(),await this.sender.setMainStream(this.mainStream),this.logger.debug(`track info after stream update: ${JSON.stringify(this.getTrackInfo())}`),this.sender.updateStreamQualityParams(this.mainStream.getResolution(),this.mainStream.getFrameRate(),1)):void this.logger.safe.info("Stream has not been changed. Skipping update"):(this.logger.safe.info("Postponing stream update until sender is activated"),void this.setPendingStream(a))}async updateParametersInternal(a){if(this.configProvider.config.applyMaxCapabilitiesToSenderParamsDirectly){this.lastAppliedParams=a;const s=this.sendVideoCapabilityManager?.getCapabilities();s&&(a=a.map(c=>{const u={...c};return u.maxFs>s.maxFs&&(this.logger.safe.info(`Reducing SSRC:${u.ssrc} video FS from ${u.maxFs} to ${s.maxFs}`),u.maxFs=s.maxFs),u.maxFps>s.maxFps&&(this.logger.safe.info(`Reducing SSRC:${u.ssrc} video FPS from ${u.maxFps} to ${s.maxFps}`),u.maxFps=s.maxFps),u}))}await this.sender.setCapabilities(a),Cf(this.previousParameters,a,(s,c)=>s.ssrc===c.ssrc)||(this.previousParameters=a,this.event("onSendersChanged").raise(this,!0))}setPendingStream(a){this.pendingStream=a;const s=a.on("onStreamClientDisposing",()=>{this.pendingStream===a&&(this.pendingStream=null,s.dispose())})}subscribeOnQualityUpdates(a){this.sub=a.on("onStreamQualityChanged",(s,c,u,m)=>this.updateStreamQualityParams(c,u,m))}updateStreamQualityParams(a,s,c){return c===zg.EffectQualityChangeReason.Performance&&this.notifyMaxVideoSendCapabilitiesChanged({resolution:a,fps:s}),this.sender.updateStreamQualityParams(a,s,2)}unsubscribeFromQualityEvents(){this.sub?.dispose(),this.sub=null}notifyMaxVideoSendCapabilitiesChanged(a){if(!["Video","ScreenShare"].includes(this.mediaType))return;const{width:s,height:c}=a?.resolution??this.mainStream.getResolution(),u=a?.fps??this.mainStream.getFrameRate();if(!s||!c||!u)return;const m=new mV(s,c),b={maxFs:m.fs,maxMbps:m.fs*u,maxFps:u,maxWidth:m.width,maxHeight:m.height};this.logger.safe.info(`Capabilities for ${this.mediaType} stream: ${JSON.stringify(b)}`),this.sendVideoCapabilityManager?this.sendVideoCapabilityManager.manage(b,!a):this.event("onMaxVideoSendCapabilitiesChanged").raise(b)}cleanUp(){this.sendVideoCapabilityManager?.dispose(),this.sendVideoCapabilityManager=null,this.unsubscribeFromQualityEvents(),this.mainStream.dispose(),this.mainStream=null,this.pendingStream&&this.pendingStream.dispose(),this.pendingStream=null,this.sender=null,this.contextStream=null,this.event("onSendersChanged").raise(this,!1),super.dispose()}};hM.transitionStates={NotStarted:["Started","Disposed"],Started:["Active","Disposed"],Active:["NotStarted","Disposed"],Disposed:[]},Kt([pu()],hM.prototype,"start"),Kt([pu()],hM.prototype,"activate"),Kt([pu()],hM.prototype,"updateStream"),Kt([pu()],hM.prototype,"addAdditionalStream"),Kt([pu()],hM.prototype,"updateParameters"),Kt([pu()],hM.prototype,"terminateAsync"),Kt([pu()],hM.prototype,"setHold"),Kt([pu()],hM.prototype,"updateStreamQualityParams");var MEi=hM,PEi=class{constructor(n){this.durationThreshold=n,this.signals={}}track(n,a){this.signals[n]===void 0&&(this.signals[n]={wasNotified:!1}),this.signals[n].currentTime=pp(),!!this.signals[n].currentState!=!!a&&(this.signals[n].currentState=a,this.signals[n].lastChanged=this.signals[n].currentTime,this.signals[n].wasNotified=!1)}update(n){const a=[];for(const s of Object.keys(n))this.signals[s]===void 0&&(this.signals[s]={wasNotified:!1});for(const s of Object.keys(this.signals))this.track(s,n[s]);for(const s in this.signals){const c=this.signals[s];if(c.currentState!==void 0){if(c.wasNotified)continue;c.currentTime-c.lastChanged>=this.durationThreshold&&(c.wasNotified=!0,a.push(c.currentState))}}return a}},DEi=class extends jr{constructor(n,a){super(),this.logger=n,this.timeout=-1,this.signals=new PEi(a.performanceMonitor.durationThreshold??3e3),this.config={monitorQualityLimitationReasons:a.performanceMonitor?.monitorQualityLimitationReasons,monitorMaxFS:a.performanceMonitor?.monitorMaxFS,mitigationTimeout:a.performanceMonitor?.mitigation?.timeout,startupDelay:a.performanceMonitor?.startupDelay}}key(n,a){return`${n.rid}:${a}`}suspend(n){n>0&&(this.logger.safe.info(`Suspending for ${(n/1e3).toFixed(1)} seconds`),this.timeout=pp()+n)}acceptLayout(n){return n.some(a=>a.rid===void 0)?(this.logger.safe.info("Ignore layout with missing RID"),!1):!(this.caps&&Math.max(0,...n.map(a=>a.maxFs))>this.caps.maxFs)||(this.logger.safe.info("Ignore layout update while waiting for maxCapabilities to propagate to server"),!1)}resetLayout(){this.signals.update({}),this.layout=void 0}updateMaxCapabilities(n){this.logger.safe.info(`Max capabilities updated: ${JSON.stringify(n)}`),this.caps&&n.maxFs<this.caps.maxFs&&this.layout?.length>0&&(this.logger.safe.info("Stop monitoring current layout as maxFS will be reduced"),this.resetLayout()),this.caps=n}updateLayout(n){if((n||this.layout)&&this.logger.safe.info(`New layout: ${JSON.stringify(n)}`),n&&this.acceptLayout(n)){if((n=n.map(a=>Object.assign({},a))).sort((a,s)=>a.maxFs===s.maxFs?a.maxFps===s.maxFps?a.maxBr-s.maxBr:a.maxFps-s.maxFps:a.maxFs-s.maxFs),this.layout?.length)for(let a=0;a<n?.length;++a){const s=n[a],c=this.layout.find(u=>u.rid===s.rid);c&&c.maxFs!==s.maxFs&&(this.logger.safe.info(`Reset '${this.key(c,"FS")}'`),this.signals.track(this.key(c,"FS"),void 0))}this.layout=n,this.timeout===-1&&(this.timeout=0,this.logger.safe.info("Starting performance monitor"),this.suspend(this.config.startupDelay))}else this.resetLayout(),this.timeout=-1}onMitigationApplied(){this.logger.safe.info("Mitigation was applied - resetting current layout"),this.resetLayout(),this.suspend(this.config.mitigationTimeout)}monitor(n){const a={};let s=0;if(!this.layout||this.layout.length<1||n.length<this.layout.length||this.timeout>pp())return void this.signals.update(a);for(this.timeout>0&&(this.logger.safe.info("Resuming"),this.timeout=0),s=0;s<this.layout.length;++s){const u=this.layout[s],m=n.find(b=>b.rid===u.rid);if(m){const b=Math.ceil(m.frameWidth/ke.MACROBLOCK_SIZE)*Math.ceil(m.frameHeight/ke.MACROBLOCK_SIZE);if(this.config.monitorQualityLimitationReasons){const _=m.qualityLimitationReason;this.config.monitorQualityLimitationReasons.indexOf(`${_}`)!==-1&&(a[this.key(u,"QL")]={layout:u,type:"QL",expected:"none",actual:_})}this.config.monitorMaxFS&&b<u.maxFs&&(a[this.key(u,"FS")]={layout:u,type:"FS",expected:u.maxFs,actual:b})}}const c=this.signals.update(a).map(u=>{const m=Object.assign({},u);return m.layout=this.layout?.find(b=>b.rid===m.layout.rid)??m.layout,m});c.length&&(this.logger.safe.info(`Raise event: ${JSON.stringify(c)}`),this.event("onVideoQualityDegraded").raise(c))}},LEi=class extends jr{constructor(n,a,s,c){super(n),this.logger=n,this.configProvider=a,this.diagnostics=s,this.videoFeatureManager=c,this.activeModalities=new Set,this.callbacks=[];const u=this.configProvider.config.specCompliantSimulcast?.performanceMonitor?.mitigation??{};this.config={allowDisabling1080pSinglecast:u.enableFor1080pSinglecast,allowDisabling1080pSimulcast:u.enableFor1080pSimulcast,allowDisablingThreeStreamSimulcast:u.enableForThreeStreamSimulcast,allowReversals:u.enableReversals}}hasSoftwareEncodedVideoAndSharing(){return!this.videoFeatureManager.get("Video").hasClientSupport(1)&&!this.videoFeatureManager.get("ScreenShare").hasClientSupport(1)&&this.hasActiveSenders("Video","ScreenShare")}hasActiveSenders(...n){return n.every(a=>this.activeModalities.has(a))}getAdaptationInfo(n,a){return{description:n,activeModalities:[...this.activeModalities],isTransient:a&&this.config.allowReversals}}notify(n){this.logger.safe.warn(`${n.description} activeModalities: ${n.activeModalities.join("/")} isTansient: ${n.isTransient}`),this.diagnostics.registerLocalVideoPerformanceEvent(n)}schedule(n,a,s){this.callbacks.push({mediaType:n,state:a,callback:s})}override(n,a,s){this.configProvider.config[n]=a,this.logger.safe.info(`Overwriting ${n} with ${this.configProvider.config[n]}. Reason: ${s}`)}disable1080pSoftwareEncode(n){const a=this.videoFeatureManager.get("Video");if(!n.find(b=>b.maxFs===ke.MAX_FS_1080P)||!a.hasClientSupport(2)||a.hasClientSupport(1))return!1;if(n.length===1&&!this.config.allowDisabling1080pSinglecast)return this.logger.safe.info("Will not disable 1080p for singlecast"),!1;if(n.length>1&&!this.config.allowDisabling1080pSimulcast)return this.logger.safe.info("Will not disable 1080p for simulcast"),!1;const s=this.configProvider.config.performanceFallbackMaxFsFor1080pSend,c={},u={webrtcCameraOpenFs:this.configProvider.config.webrtcCameraOpenFs,maxCameraFsViaCallConstraints:this.configProvider.config.maxCameraFsViaCallConstraints,webrtcVideoCapabilityMaxFS:this.configProvider.config.webrtcVideoCapabilityMaxFS};for(const b in u)u[b]>0&&(c[b]=Math.min(s,u[b]));const m=Object.keys(c);if(m.some(b=>u[b]!==c[b])){m.forEach(_=>{this.override(_,c[_],"mitigating 1080p performance issues")}),this.event("onNewStreamNeeded").raise(c.webrtcCameraOpenFs);const b=this.getAdaptationInfo("Disabled software 1080p",this.hasSoftwareEncodedVideoAndSharing());return b.isTransient&&this.schedule("ScreenShare",!1,()=>{m.forEach(_=>{this.override(_,u[_],"removing mitigation for 1080p performance issues")}),this.event("onNewStreamNeeded").raise(),this.notify(this.getAdaptationInfo("Re-enabled software 1080p",!0))}),this.notify(b),!0}return!1}disableThreeStreamSimulcast(n){const a=this.videoFeatureManager.get("Video");if(n.length!==3)return!1;if(!this.config.allowDisablingThreeStreamSimulcast)return this.logger.safe.info("Will not disable 3-stream simulcast"),!1;if(a.hasClientSupport(1))return!1;if(a.hasFullSupport(0)){const s=this.getAdaptationInfo("Disabled 3-stream simulcast",this.hasSoftwareEncodedVideoAndSharing());return a.toggleClient(0,!1),s.isTransient&&this.schedule("ScreenShare",!1,()=>{a.toggleClient(0,!0),this.notify(this.getAdaptationInfo("Re-enabled Three stream simulcast",!0))}),this.notify(s),!0}return!1}updateSenderState(n,a){if(a===this.activeModalities.has(n))return;a?this.activeModalities.add(n):this.activeModalities.delete(n);const s=this.callbacks.filter(c=>c.mediaType===n&&c.state===a);this.callbacks=this.callbacks.filter(c=>c.mediaType!==n||c.state!==a);for(const c of s)c.callback()}mitigatePerformanceIssue(n){return!!this.disable1080pSoftwareEncode(n)||!!this.disableThreeStreamSimulcast(n)}},OEi=class{constructor(n,a,s){this.callback=n,this.logger=a,this.settings=s,this.triggers=0,this.budget=0,this.budget=this.burst}get interval(){return this.settings?.interval??0}get burst(){return this.settings?.burst??0}cancel(){this.timer&&(clearTimeout(this.timer),this.timer=void 0)}schedule(){this.timer||(this.timer=setTimeout(()=>{this.cancel(),this.commit()||(this.budget=Math.min(this.budget+1,this.burst)),this.budget<this.burst&&this.schedule()},this.interval))}commit(){return this.triggers>0&&(this.callback.apply(this),this.triggers=0,!0)}dispose(){this.cancel()}trigger(){++this.triggers,this.burst!==0||this.interval!==0?this.burst?(this.budget>0&&(--this.budget,this.commit(),this.cancel(),this.budget||this.logger.safe.warn(`Max burst limit reached: ${this.burst}`)),this.triggers>0&&this.logger.safe.debug(`Triggered while out of budget: ${this.triggers} / ${this.burst}`),this.schedule()):this.timer||(this.commit(),this.schedule()):this.commit()}},NEi=class extends jr{constructor(n,a,s,c){super(n),this.logger=n,this.configProvider=a,this.frameSizeLimits={},this.initialMaxFS=this.configProvider.config.webrtcCameraOpenFs,this.subs=[],this.cadence=new OEi(this.commitCallConstraints.bind(this),this.logger.createChild("Cadence"),this.configProvider.config.sendVideoCapabilityManager?.constraintsCadence),this.configProvider.config.enableVideoFeatureManager&&s&&(this.features=s.get("Video"),this.subs.push(s.on("onVideoFeaturesChanged",m=>{m.mediaType==="Video"&&this.onFeaturesChanged(m)}))),c&&this.subs.push(c.on("onNewStreamNeeded",m=>{this.limitFrameSize("Performance",m),this.updateConstraintsAndNotify()})),this.configProvider.config.video1080p?.software?.isEnabled&&this.limitFrameSize("Software1080P",ke.MAX_FS_1080P),this.settings=this.configProvider.config.sendVideoCapabilityManager,this.settings.defaultFS&&(this.initialMaxFS=this.settings.defaultFS);const u=this.getCallConstraints().maxFS;u&&u!==this.initialMaxFS&&(this.logger.safe.info(`Detected initial resolution opt-in: ${this.initialMaxFS} => ${u}`),this.limitFrameSize("Opt-In",u))}getCapabilities(){if(this.appliedCapabilities)return{...this.appliedCapabilities}}applyCallConstraints(n){this.lastCauseId=n,this.cadence.trigger()}manage(n,a){a&&(this.streamConstraints={maxFPS:n.maxFps,maxFS:n.maxFs},this.features&&this.streamConstraints.maxFS>=ke.MAX_FS_1080P&&this.configProvider.config.video1080p?.useSimulcastLayoutControlStrategy&&this.features.toggleClient(2,!0)),this.requestedCapabilities={...n},this.updateConstraintsAndNotify()}dispose(n){for(const a of this.subs)a.dispose(n);this.subs=[],this.cadence.dispose(),super.dispose()}onFeaturesChanged(n){const a=(s,c)=>{this.limitFrameSize(iq[s],n.hasClientSupport(s)?c:void 0)};a(1,this.configProvider.config.hardwareEncodedVideoMaxFS),a(3,this.configProvider.config.broadcastMode?.maxVideoFS),this.updateConstraintsAndNotify()}getCallConstraints(){const n=this.configProvider.config.outgoingVideoLimit,a={},s=typeof n=="number"?n:n?.maxResolution;return s&&(a.maxFS=RD(s)),a.maxFPS=typeof n=="number"?void 0:n?.maxFramerate,a}commitCallConstraints(){this.limitFrameSize("Opt-In",this.getCallConstraints().maxFS,this.lastCauseId),this.updateConstraintsAndNotify()}buildCapabilities(){const n={...this.requestedCapabilities};if(this.constraints?.maxFS<n.maxFs||this.constraints?.maxFPS<n.maxFps){n.maxFps=xg(this.constraints.maxFPS,n.maxFps),n.maxFs=xg(this.constraints.maxFS,n.maxFs);const a={...yl.Send.getResolutionByFs(n.maxFs)};n.maxMbps=a.fs*n.maxFps,n.maxWidth=a.width,n.maxHeight=a.height}return n}limitFrameSize(n,a,s){this.frameSizeLimits[n]!==a&&(s?this.logger.safe.info(`[${s}] FS limit for '${n}' changed from ${this.frameSizeLimits[n]} to ${a}`):this.logger.safe.info(`FS limit for '${n}' changed from ${this.frameSizeLimits[n]} to ${a}`),this.frameSizeLimits[n]=a)}notify(){this.appliedCapabilities=this.buildCapabilities(),this.requestedCapabilities.maxFs!==this.appliedCapabilities.maxFs&&this.logger.safe.debug(`Changed video send capability max-fs from ${this.requestedCapabilities.maxFs} to ${this.appliedCapabilities.maxFs}`),this.requestedCapabilities.maxFps!==this.appliedCapabilities.maxFps&&this.logger.safe.debug(`Changed video send capability max-fps from ${this.requestedCapabilities.maxFps} to ${this.appliedCapabilities.maxFps}`),this.logger.safe.info(`Reporting video capabilities: ${JSON.stringify(this.appliedCapabilities)}`),this.event("onCapabilitiesChanged").raise(this.appliedCapabilities)}updateConstraintsAndNotify(){this.updateConstraints()&&this.notify()}updateConstraints(){const n=this.getCallConstraints(),a={};let s=!1;for(const c of this.settings.priorityOrder)if(this.frameSizeLimits[c]>0){s=this.settings.allowOptIn.indexOf(c)!==-1,a.maxFS=this.frameSizeLimits[c],this.logger.safe.info(`Using FS ${a.maxFS} from '${c}'. Opt-In is ${s?"allowed":"not allowed"}`);break}if(a.maxFS===void 0&&(a.maxFS=this.initialMaxFS,s=this.settings.maxFS>this.initialMaxFS),a.maxFPS=n.maxFPS,this.frameSizeLimits["Opt-In"]>0){const c=this.frameSizeLimits["Opt-In"];(c<a.maxFS||s)&&(this.logger.safe.info(`Applying opt-in: ${a.maxFS} => ${c}`),a.maxFS=c)}if(this.streamConstraints&&(this.logger.safe.debug(`Applying stream constraints: ${JSON.stringify(this.streamConstraints)} to ${JSON.stringify(a)}`),a.maxFS&&(a.maxFS=xg(a.maxFS,this.streamConstraints.maxFS)),a.maxFPS&&(a.maxFPS=xg(a.maxFPS,this.streamConstraints.maxFPS))),a.maxFS===this.constraints?.maxFS&&a.maxFPS===this.constraints?.maxFPS||(this.logger.safe.info(`Final constraints changed from ${JSON.stringify(this.constraints)} to ${JSON.stringify(a)}`),this.constraints=a),this.constraints&&this.requestedCapabilities){if(this.appliedCapabilities){const c=this.buildCapabilities();return c.maxFs!==this.appliedCapabilities.maxFs||c.maxFps!==this.appliedCapabilities.maxFps}return!0}return!1}},xEi=class extends jr{constructor(n,a,s,c,u,m,b,_,k,N,W){super(a),this.mediaManager=n,this.logger=a,this.callDeviceManager=s,this.configProvider=c,this.sessionConfig=u,this.statisticsGatherer=m,this.diagnostics=b,this.qmDiagnostics=_,this.isMultiparty=k,this.encStreamsManager=N,this.videoFeatureManager=W,this.senders=new Map,this.senderSubs=new Map,this.senderId=0,this.previousMediaModalities={Audio:!1,Video:!1,ScreenShare:!1},this.muted=new Map([["Audio",!1],["Video",!1]]),this.serialQueue=new iL(this.logger),this.streamsProvider=new aEi(this.callDeviceManager,this.configProvider,this.sessionConfig,this.serialQueue,this.logger.createChild("StreamsProvider")),this.streamProviderSubscriptions=[this.streamsProvider.on("onStreamAdded",ee=>this.onStreamUpdated(ee,!1)),this.streamsProvider.on("onStreamUpdated",ee=>this.onStreamUpdated(ee,!0))],this.localVideoStreamWatcher=new tYe(this.logger,this.configProvider,this.callDeviceManager),this.localVideoStreamWatcherSub=this.localVideoStreamWatcher.on("onVideoCaptureFreeze",(ee,oe)=>this.onVideoCaptureFreeze(ee,oe)),this.configProvider.config.useMediaQualityController&&(this.mediaQualityController=new _Ei(this.configProvider,this.logger.createChild("MQC"),this.videoFeatureManager),this.mediaQualityController.on("onLayoutsUpdated",ee=>{const oe=this.mediaQualityController.getLayouts(ee);return this.logger.safe.debug(`Update layouts for ${ee}: ${JSON.stringify(oe)}`),ee==="Video"&&this.simulcastPerformanceMonitor&&this.simulcastPerformanceMonitor.updateLayout(oe),this.updateParameters(this.lastCauseId,ee,oe)}),this.mediaQualityController.on("onBandwidthAllocationUpdated",ee=>{this.event("onBandwidthAllocationChanged").raise(ee)})),this.configProvider.config.specCompliantSimulcast?.performanceMonitor&&(this.simulcastPerformanceMonitor=new DEi(this.logger.createChild("SPM"),this.configProvider.config.specCompliantSimulcast),this.simulcastPerformanceMonitor.on("onVideoQualityDegraded",ee=>this.onVideoQualityDegraded(ee))),this.configProvider.config.specCompliantSimulcast?.performanceMonitor?.mitigation&&(this.simulcastPerformanceAdaptationManager=new LEi(this.logger.createChild("SPAM"),this.configProvider,this.diagnostics,this.videoFeatureManager),this.simulcastPerformanceAdaptationManager.on("onNewStreamNeeded",ee=>{this.configProvider.config.sendVideoCapabilityManager?.isEnabled||(this.sessionConfig.outgoingVideoMaxFS=ee,this.streamsProvider.requestStreamUpdate("Video",!0))}))}dispose(){this.senders.forEach((n,a)=>{this.event("onSendStreamChanged").raise(null,a),this.configProvider.config.disposeSendersSync?n.dispose():n.terminateAsync()}),this.senders.clear(),this.senderSubs.forEach(n=>n.forEach(a=>a.dispose())),this.senderSubs.clear(),this.streamProviderSubscriptions.forEach(n=>n.dispose()),this.streamProviderSubscriptions=[],this.configProvider.config.disposeStreamsSync?this.streamsProvider.stop():this.streamsProvider.stopAsync(),this.localVideoStreamWatcherSub.dispose(),this.localVideoStreamWatcher.dispose(),this.logger=this.logger.createChild("DISPOSED"),this.mediaQualityController?.dispose(),super.dispose()}registerRtpSenderManager(n){this.logger.safe.debug(`Registering RTP sender manager ${n}`),this.mediaConnection=n}useNullAudioStreamClient(){this.logger.safe.debug("Using null audio stream client"),this.streamsProvider.useNullAudioStreamClient()}get pendingStreamsPromise(){return this.streamsPromise}clearStreamsPromise(){this.streamsPromise=void 0}async update(n,a,s,c){c?.mark("startUpdateStreams");let u=BEi(n,this.configProvider.config.streamModalitiesExcludeData);const m=!!(1&a),b=!!(2&a),_=!!(4&a);_&&(u={Audio:!0,Video:!1,Data:!1,ScreenShare:!1});const k=_?Promise.resolve(u):this.streamsProvider.update(u,m);let N,W;return b||_?(delete u.Data,N=Xp(u),W=m?void 0:N):(N=await k,W=N),this.logger.safe.info(`[${s}] Streams updated, modalities requested: ${JSON.stringify(u)} (flags: ${a}), result: ${JSON.stringify(N)}`),c?.markAndMeasure("startUpdateStreams","updateStreamsWithModalities"),await this.updateSenders(W,s),c?.markAndMeasure("updateStreamsWithModalities","updateSenders"),b&&(this.streamsPromise=(async()=>{const ee=await k;return this.streamsPromise=void 0,await this.updateSenders(ee,s),this.setAndUpdateLocalTracksInfo(!1),this.mergeAndSaveModalities(ee,n)})()),this.applyMuteState(s,!0),this.setAndUpdateLocalTracksInfo(!1),this.mergeAndSaveModalities(N,n)}mergeAndSaveModalities(n,a){this.previousMediaModalities=Xp(n);const s=Xp(a);return Ng(a,(c,u)=>{const m=kN(u);Ur(c)&&!n[m]&&(s[u]=o9(c))}),s}async activate(n){this.logger.safe.info(`[${n}] activate senders`),await Promise.all([...this.senders.values()].map(async a=>a.activate())),this.setAndUpdateLocalTracksInfo(!1)}applyCallConstraints(n){const a=this.senders.get("Video");return a?a.applyCallConstraints(n):(this.logger.info(`[${n}] Caching call constraints until sender is created`),this.callConstraintsCauseId=n,this.applyCallConstraintsDeferred=new Pi,this.applyCallConstraintsDeferred.promise)}async applyCapabilities(n,a,s){this.logger.safe.info(`[${n}] Applying incoming ${a} FMTP: ${JSON.stringify(s)}`);const c=kN(a);this.lastCauseId=n;let u=s;return this.mediaQualityController&&(this.mediaQualityController.addReceiver(c,s),u=this.mediaQualityController.getLayouts(c)),this.simulcastPerformanceAdaptationManager?.updateSenderState(c,!0),this.updateParameters(n,c,u)}getLocalMediaSources(){const n=this.getTracksInfo(),a=[];return n.forEach(s=>{a.some(c=>c.modality===s.modality)||a.push({sourceId:this.getSourceIdForTrack(s),modality:s.modality})}),a}setMuted(n,a,s){this.muted.set(n,a),this.applyMuteState(s,!1)}async setHold(n,a){await Promise.all([...this.senders.values()].map(async s=>s.setHold(n,a)))}onStatisticsChanged(n){this.configProvider.config.diagnostics.features.useNewSendBandwidthCalculation||this.mediaQualityController?.onStatisticsChanged(n),this.configProvider.config.diagnostics.features.useNewStatsForLocalVideoStreamWatcher||this.localVideoStreamWatcher.onStatisticsChanged(n)}onDiagnosticUpdated(n){this.configProvider.config.diagnostics.features.useNewSendBandwidthCalculation&&this.mediaQualityController?.onDiagnosticUpdated(n),this.configProvider.config.diagnostics.features.useNewStatsForLocalVideoStreamWatcher&&this.localVideoStreamWatcher.onDiagnosticUpdated(n)}async updateParameters(n,a,s){try{const c=this.senders.get(a);c?await c.updateParameters(s):this.logger.safe.info(`[${this.lastCauseId}] Capabilities ignored ${JSON.stringify(s)}, no ${JSON.stringify(a)} sender`),this.logger.safe.debug(`[${n}] Capabilities completed`);const u={modality:KR(a),causeId:n,capabilities:s};this.statisticsGatherer.onMaxCapabilitiesApplied(u),this.qmDiagnostics.onMaxCapabilitiesApplied(u)}catch(c){const u=nn(c);this.logger.safe.error(`[${n}] Error applying capabilities ${u}`);const m={modality:KR(a),causeId:n,capabilities:s,error:u};this.statisticsGatherer.onMaxCapabilitiesApplied(m),this.qmDiagnostics.onMaxCapabilitiesApplied(m)}}applyMuteState(n,a){for(const[s,c]of this.muted)this.senders.get(s)&&this.senders.get(s).setMuted(c,n,a)}setAndUpdateLocalTracksInfo(n){const a=this.getTracksInfo();this.logger.safe.debug(`Local tracks info: ${JSON.stringify(a)}`),this.mediaManager.setLocalTracksInfo(a),n&&(this.mediaManager.updateMediaEntitiesWithLocalTracks(),this.configProvider.config.mapSsrcToTrackForStats&&this.statisticsGatherer.updateStatsWithLocalSsrcTrackInfo())}getTracksInfo(){const n=[];return this.senders.forEach(a=>n.push(a.getTrackInfo())),n}async updateSenders(n,a=hi()){const s=await this.streamsProvider.getStreams(),c=n||iie(s);this.logger.safe.info(`[${a}] Updating senders with modalities: ${JSON.stringify(c)}, override: ${!!n}`),await Promise.all(kD(c).map(async u=>{const m=c[u];if(m===this.previousMediaModalities[u])return;if(!m)return this.logger.safe.info(`[${a}] Removing sender for ${JSON.stringify(u)}`),void await this.removeSender(u);const b=(await this.streamsProvider.getStreams())?.[u];if(await this.createAndStartSender(b,u),this.logger.safe.info(`[${a}] Sender for ${JSON.stringify(u)} is added`),this.applyCallConstraintsDeferred&&u==="Video"){const _=this.senders.get("Video");try{await _.applyCallConstraints(this.callConstraintsCauseId),this.applyCallConstraintsDeferred.resolve()}catch(k){this.applyCallConstraintsDeferred.reject(k)}this.applyCallConstraintsDeferred=void 0,this.callConstraintsCauseId=void 0}await this.addAudioSharingStream(b),this.event("onSendStreamChanged").raise(b,u)})),this.logger.safe.info(`[${a}] Senders updated. Enabled: ${JSON.stringify(Object.keys(c).filter(u=>c[u]))}`)}createCapabilityManager(n,a){if(n==="Video"&&this.configProvider.config.sendVideoCapabilityManager?.isEnabled)return new NEi(a.createChild("SVCM"),this.configProvider,this.videoFeatureManager,this.simulcastPerformanceAdaptationManager)}createAndStartSender(n,a){if(this.senders.get(a))return this.logger.safe.error(`Sender already created, modality: ${JSON.stringify(a)}`),this.senders.get(a).start();const s=this.mediaManager.getMediaEntitiesByModality(KR(a))[0],c=s?.getSimulcastContext(),u=!this.configProvider.config.specCompliantSimulcast?.disableTilde&&!!c?.shouldUseSimulcast(),m=a==="Audio"||!this.isMultiparty||u,b=this.logger.createChild(`Sender_${JSON.stringify(a)}:${this.senderId++}`),_=this.createCapabilityManager(a,b),k=new MEi(this.mediaConnection,n||new zTe(a,this.logger.createChild("tempStream")),new MediaStream,a,this.serialQueue,b,this.configProvider,m,this.encStreamsManager,c,_);this.senders.set(a,k);const N=[k.on("onSendersChanged",(W,ee)=>this.onSenderStateChanged(W,ee)),k.on("onNewStreamNeeded",()=>this.streamsProvider.requestStreamUpdate(a,!0)),k.on("onMaxVideoSendCapabilitiesChanged",W=>{this.event("onMaxVideoSendCapabilitiesChanged").raise(a,W),a==="Video"&&this.simulcastPerformanceMonitor&&this.simulcastPerformanceMonitor.updateMaxCapabilities(W)})];return this.senderSubs.set(k,N),k.start()}async removeSender(n){const a=this.senders.get(n);a&&(this.senders.delete(n),this.event("onSendStreamChanged").raise(null,n),await a.terminateAsync(),this.senderSubs.get(a).forEach(s=>s.dispose()),this.senderSubs.delete(a),this.logger.safe.info(`Removed sender with mediaType: ${JSON.stringify(n)}`)),this.mediaQualityController?.removeReceiver(n),this.simulcastPerformanceAdaptationManager?.updateSenderState(n,!1),n==="Video"&&this.simulcastPerformanceMonitor&&this.simulcastPerformanceMonitor.updateLayout(void 0)}getSourceIdForTrack(n){const a=n.trackId,s=this.mediaManager.getMediaEntityByLocalTrackId(a);return s?(this.logger.safe.info(`Media entity found: ${JSON.stringify(s.getXSourceStreamId())}`),s.getXSourceStreamId()):(this.logger.safe.error(`Media entity is not found for stream: ${JSON.stringify(a)}`),0)}onVideoCaptureFreeze(n,a){n||(a?this.qmDiagnostics.registerWebcamFreeze():this.qmDiagnostics.registerProcessedStreamFreeze()),this.event("onVideoCaptureFreeze").raise(n)}onVideoQualityDegraded(n){const a=this.mediaQualityController?.getLayouts("Video")??[];let s=!1;for(const c of n)if(this.logger.safe.warn(`rid:${c.layout.rid} ${c.type} degraded - expected: ${c.expected}, actual: ${c.actual}`),!s&&this.simulcastPerformanceAdaptationManager)switch(c.type){case"QL":c.actual==="cpu"&&(s=this.simulcastPerformanceAdaptationManager.mitigatePerformanceIssue(a));break;case"FS":c.layout.rid==="1"&&(s=this.simulcastPerformanceAdaptationManager.mitigatePerformanceIssue(a))}s&&this.simulcastPerformanceMonitor&&this.simulcastPerformanceMonitor.onMitigationApplied()}async onStreamUpdated(n,a){if(!this.senders.has(n))return void this.logger.safe.warn(`Sender with media type ${n} does not exist, do not update media stream`);let s=(await this.streamsProvider.getStreams())[n];if(s||(this.logger.safe.info(`Stream is missing for mediaType: ${n}, using fake stream...`),s=new zTe(n,this.logger.createChild("NullStreamClient"))),s.isDisposed())return void this.logger.safe.info(`Stream is already disposed for mediaType: ${n}`);this.event("onSendStreamChanged").raise(s,n);const c=this.senders.get(n);await this.addAudioSharingStream(s),await c.updateStream(s),this.logger.safe.debug(`Stream updated for mediaType: ${n}, updated: ${a}`),this.setAndUpdateLocalTracksInfo(a)}onSenderStateChanged(n,a){if(this.mediaManager.updateMediaEntitiesWithActivityState(n.mediaType,n.getActiveStreamIndexes()),this.statisticsGatherer.onSendersChanged(n.mediaType,a),n.mediaType==="Video")if(a){const s=this.getTracksInfo().filter(c=>c.modality===ke.MODALITY.video);this.localVideoStreamWatcher.startWatching(s,this.simulcastPerformanceMonitor)}else this.localVideoStreamWatcher.stopWatching()}async addAudioSharingStream(n){n?.mediaType==="ScreenShare"&&n?.hasAudio()&&(this.logger.safe.info("Adding audio stream from sharing to audio sender"),await this.senders.get("Audio")?.addAdditionalStream(n))}};function BEi(n,a=!0){const s={Audio:Ur(n.audio),Video:Ur(n.video),ScreenShare:Ur(n.sharing)};return a||(s.Data=Ur(n.data)),s}var FEi=class{constructor(n,a,s,c,u){this.recvStream=n,this.mainTrack=a,this.receiveStreamCollection=s,this.logger=c,this.settings=u,this.removeOtherTracks(a),this.subscribeOnStreamEvents()}get stream(){return this.recvStream.getMediaStream()}dispose(){this.unsubscribeFromStreamEvents(),this.receiveStreamCollection=null,this.mainTrack=null,this.recvStream.dispose()}getId(){return this.recvStream.getId()}getModality(){return this.recvStream.getModality()}getMsi(){return this.recvStream.getMsi()}getMediaStream(){return this.stream}getReceiver(){return this.recvStream.getReceiver()}requestSource(n){return this.recvStream.requestSource(n)}getSourceStreamId(){return this.recvStream.getSourceStreamId()}getSubstreamIndex(){return this.recvStream.getSubstreamIndex()}removeOtherTracks(n){this.settings.onAddTrackRemoveOtherTracks&&this.stream.getTracks().forEach(a=>{a.id!==n.id&&this.stream.removeTrack(a)})}subscribeOnStreamEvents(){const n=a=>this.logger.safe.info(`${a} track: ${this.mainTrack.id}, stream: ${this.stream.id}`);this.stream.onremovetrack=()=>{n("onremovetrack"),this.receiveStreamCollection.remove(this.stream.id)},this.mainTrack.onended=()=>{n("onended"),this.settings.removeRecvStreamOnEnded&&this.receiveStreamCollection.remove(this.stream.id)},this.mainTrack.onmute=()=>n("onmute"),this.mainTrack.onunmute=()=>n("onunmute")}unsubscribeFromStreamEvents(){this.stream.onremovetrack=null,this.mainTrack.onended=null,this.mainTrack.onmute=null,this.mainTrack.onunmute=null}},UEi=class{constructor(n){this.startTimestamp=0,this.totalTime=0,this.lastActiveTime=0,this.id=n}},zEi=class{constructor(n){this.speakersHistory=[],this.sources=[],this.configProvider=n.configProvider,this.ping=this.setupTimer()}setSources(n=[]){const a=n.map(this.getOrCreateSource.bind(this)),s=this.excludeSources(this.sources,a);a.forEach(c=>{this.isAlreadyActive(c)||this.updateSourceTimestamp(c),this.updateSourceLastActiveTime(c)}),s.forEach(c=>{this.updateTotalTime(c),this.resetStartTimestamp(c)}),this.ping||(this.ping=this.setupTimer())}setOnDominantSpeakerChanged(n){this.callback=n}dispose(){this.clearTimer(),this.sources=null,this.callback=null}excludeSources(n,a){return n.filter(s=>!a.some(c=>s.id===c.id))}trigger(){if(!this.hasAnyoneSpoken())return void this.clearTimer();const n=(c,u)=>u.totalTime-c.totalTime||u.lastActiveTime-c.lastActiveTime,a=c=>c.id,s=this.sources.map(this.updateTotalTime).sort(n).map(a).slice(0,this.configProvider.config.ovcMaxCount);s.length&&!xc(this.speakersHistory,s)&&(this.speakersHistory=s,this.callback&&this.callback(this.speakersHistory,"client")),this.sources.map(this.resetTotalTime).filter(this.isAlreadyActive).forEach(this.updateSourceTimestamp)}isAlreadyActive(n){return!!n.startTimestamp}setupTimer(){return window.setInterval(this.trigger.bind(this),this.configProvider.config.activeSpeaker.timeToPromote)}clearTimer(){this.ping&&(clearInterval(this.ping),this.ping=null)}getOrCreateSource(n){if(this.isExist(n))return this.sourceById(n);{const a=new UEi(n);return this.sources.push(a),a}}isExist(n){return this.sources.some(a=>n===a.id)}hasAnyoneSpoken(){return this.sources.some(n=>n.startTimestamp!==0||n.totalTime!==0)}sourceById(n){return this.sources.find(a=>n===a.id)}updateSourceTimestamp(n){n.startTimestamp=Date.now()}updateSourceLastActiveTime(n){n.lastActiveTime=Date.now()}updateTotalTime(n){return n.startTimestamp&&(n.totalTime+=Date.now()-n.startTimestamp),n}resetStartTimestamp(n){return n.startTimestamp=0,n}resetTotalTime(n){return n.totalTime=0,n}},VEi=class extends jr{constructor(n,a){super(),this.configProvider=n,this.logger=a,this.bandwidthEstimationAvailable=!1,this.smoothingWindow=[],this.totalSamples=0,this.isStarted=!1,this.maxCountStatic=this.configProvider.config.ovcMaxCount,this.previousParticipantsCount=0,this.isMcpSrAvailable=!1;const s=window.navigator;this.updateStaticConstraint(s.hardwareConcurrency,this.configProvider.config.ovcAvailableConcurrencyForBiggerGrid,4),this.updateStaticConstraint(s.deviceMemory,this.configProvider.config.ovcMemoryForBiggerGrid,4),this.throttler=new $Ei(this.logger.createChild("ovcThrottler"),this.configProvider.config.ovcRampDownCooldown,this.configProvider.config.ovcRampUpCooldown)}start(){this.logger.safe.debug("Starting OptimalVideoCountCalculator"),this.isStarted=!0,this.throttler.changed(()=>this.event("calculatorStateChanged").raise(2,{ovc:this.throttler.value,ovcPayload:this.payload}))}stop(){this.isStarted=!1}dispose(){super.dispose(),this.logger.safe.debug("Disposing OptimalVideoCountCalculator"),this.throttler.dispose()}processEstimatedBandwidth(n){this.bandwidthConstrainedOvc=this.getOVCEstimate(n),this.payload={bandwidth:n,reason:0},this.throttler.setValue(this.getOvcValue(),0)}updateParticipantCount(n){if(!this.configProvider||n===this.previousParticipantsCount)return;const a=this.configProvider.config.ovcXLParticipantsCount;n>a&&this.previousParticipantsCount<=a&&(this.maxCountStatic=this.configProvider.config.ovcMaxCountXL),n<=a&&this.previousParticipantsCount>a&&(this.configProvider.config.multiStreamSupported&&this.isMcpSrAvailable?this.maxCountStatic=this.configProvider.config.ovcMaxCountMultiStream:this.maxCountStatic=this.configProvider.config.ovcMaxCount),this.previousParticipantsCount=n,this.payload?.bandwidth&&(this.bandwidthConstrainedOvc=this.getOVCEstimate(this.payload.bandwidth),this.payload.reason=2),this.throttler.setValue(this.getOvcValue(),2)}setPerfConstrainedValue(n){this.perfConstrainedOvc=n,this.logger.safe.info(`Setting perfConstrainedOvc to ${n}`),this.payload&&this.getOvcValue()===n&&(this.payload={reason:1}),this.throttler.setValue(this.getOvcValue(),1)}mcpSourceRequestsAvailable(){this.configProvider.config.multiStreamSupported&&(this.isMcpSrAvailable=!0,this.maxCountStatic===this.configProvider.config.ovcMaxCount&&(this.maxCountStatic=this.configProvider.config.ovcMaxCountMultiStream),this.payload?.bandwidth&&(this.bandwidthConstrainedOvc=this.getOVCEstimate(this.payload.bandwidth),this.payload.reason=2),this.throttler.setValue(this.getOvcValue(),2))}getOVCEstimate(n){this.bandwidthEstimationAvailable||(this.bandwidthEstimationAvailable=this.isStarted&&n>0&&(this.totalSamples++>=this.configProvider.config.ovcIgnoreFirstSamples||Math.floor(n)/this.configProvider.config.ovcBandwidthPerVideoReceiver>=this.configProvider.config.nonEstimatedDefaultVideoReceiversCount));let a=this.configProvider.config.nonEstimatedDefaultVideoReceiversCount;return this.bandwidthEstimationAvailable&&(a=Math.floor(this.sampleSmoothed(n)/this.configProvider.config.ovcBandwidthPerVideoReceiver)),a}getOvcValue(){return Math.max(1,Math.min(this.bandwidthConstrainedOvc??this.maxCountStatic,this.perfConstrainedOvc??this.maxCountStatic,this.maxCountStatic))}sampleSmoothed(n){if(this.smoothingWindow.length>=this.configProvider.config.ovcSlidingWindowSamples?this.smoothingWindow.shift():this.smoothingWindow.length===this.configProvider.config.ovcSlidingWindowSamples-1&&(this.smoothingWindow=this.smoothingWindow.map(()=>n)),this.smoothingWindow.push(n),this.smoothingWindow.length>=this.configProvider.config.ovcSlidingWindowSamples){const a=this.smoothingWindow.slice().sort(),s=uN(a);return a[a.length-1]-(a[a.length-1]-s*(1-this.configProvider.config.ovcSlidingWindowPercentile))}return n}updateStaticConstraint(n,a,s){n&&n<a&&(this.maxCountStatic=Math.min(this.maxCountStatic,s))}},$Ei=class extends jr{constructor(n,a,s){super(n),this.logger=n,this.throttleDownCooldown=a,this.throttleUpCooldown=s,this.wasRampingUp=!0,this.lastUpdateTime=0}get value(){return this.lastValue}setValue(n,a){if(n===this.lastValue)return;const s=n>this.lastValue,c=this.lastValue!==void 0&&s!==this.wasRampingUp?s?this.throttleUpCooldown:this.throttleDownCooldown:-1,u=Date.now();u-this.lastUpdateTime<c&&(a!==2||s)||(this.lastValue!==void 0&&(this.lastUpdateTime=u,this.wasRampingUp=s),this.logger.safe.info(`optimal video receivers count updated ${this.lastValue} -> ${n}, reason: ${a}`),this.lastValue=n,this.raiseChanged())}},HTe=class Cq{constructor(a,s=30){this.logger=a,this.maxEventNum=s,this.report=[],this.started=!1}isSupported(){return!!window.chrome?.runtime?.connect}start(){this.isSupported?(this.started=!0,this.logger.debug("Starting collecting CPU metric"),this.port=window.chrome.runtime.connect(Cq.extensionID,{name:Cq.extensionName}),this.port.onMessage.addListener(a=>{a&&Mo(this.report,{timeStamp:Date.now(),value:a},this.maxEventNum)})):this.logger.debug("Chrome runtime is not supported")}stop(){this.port?.disconnect(),this.port=null,this.started=!1}getSamples(){return this.report}getLastSample(){return _f(this.report)}getCurrentCpuSample(){return new Promise((a,s)=>{this.started&&a(_f(this.report)),this.isSupported()||s("Not supported"),this.port=window.chrome.runtime.connect(Cq.extensionID,{name:Cq.extensionName}),this.port.onMessage.addListener(c=>{this.stop(),c||s("Not supported"),a({timeStamp:Date.now(),value:c})})})}clearStats(){this.report=[]}};HTe.extensionID="nkeimhogjdpnpccoofpliimaahmaaome",HTe.extensionName="processCpu";var HEi=HTe,mYe=class{constructor(n){this.logger=n,this.started=!1}static isSupported(){return globalThis.PressureObserver!==void 0}get cpuState(){return this.currentCpuState}start(){if(this.logger.safe.debug("Starting CPU pressure observer"),this.started)this.logger.safe.debug("CPU pressure observer is already started");else{try{this.cpuObserver=new globalThis.PressureObserver(n=>{n.forEach(a=>{a.source==="cpu"&&this.currentCpuState!==a.state&&(this.logger.safe.debug(`CPU pressure state changed: ${JSON.stringify(n)}`),this.currentCpuState=a.state)})},{sampleRate:1})}catch(n){throw this.logger.safe.error(`Error while creating pressure observer: ${n}`),n}this.started=!0,this.cpuObserver?.observe("cpu")}}stop(){this.started=!1,this.cpuObserver?.disconnect()}},jEi=class extends jr{constructor(n,a,s,c){super(),this.statsGatherer=n,this.diagnostics=a,this.configProvider=s,this.logger=c,this.paused=!1,this.started=!1,this.trackInterval=this.configProvider.config.diagnostics.performanceMonitoring.remoteVideoTrackInterval,this.badPerfIds=new Set,this.perfTrackerMap=new Map,this.subs=[],this.rendererFpsCap=40,this.configProvider.config.diagnostics.performanceMonitoring.useComputePressure&&mYe.isSupported()&&(this.cpuPressureObserver=new mYe(this.logger)),this.configProvider.config.diagnostics.performanceMonitoring.useCpuSample&&(this.cpuMetricCollector=new HEi(this.logger,this.configProvider.config.diagnostics.performanceMonitoring.cpuMetricCollector))}start(){this.logger.safe.debug("Starting RemoteVideoPerformanceCalculator"),this.started?this.logger.safe.debug("RemoteVideoPerformanceCalculator already running. Do nothing."):(this.calculatorStrategy=eSi.getStrategy(this.configProvider),this.started=!0,this.cpuPressureObserver?.start(),this.subs.push(this.statsGatherer.on("onDiagnosticUpdated",n=>this.processStats(n))))}stop(){this.logger.safe.debug("Stopping RemoteVideoPerformanceCalculator"),this.started=!1,this.subs.forEach(n=>{n.dispose()}),this.cpuMetricCollector?.stop(),this.cpuPressureObserver?.stop()}dispose(){this.logger.safe.debug("Disposing RemoteVideoPerformanceCalculator"),this.cleanupMaps(),this.stop()}cleanupMaps(){this.badPerfIds.clear(),this.perfTrackerMap.clear()}async processStats(n){try{if(this.paused||!n.video?.recv?.length)return;this.configProvider.config.diagnostics.traceLogging&&this.logger.safe.debug("Caught onDiagnosticUpdated: Calculating remote video performance"),n.video?.recv?.forEach(async a=>{const s=a.renderer?.msi;if(!this.perfTrackerMap.has(s)){const m={id:a.mediaEntity?.remoteTrackId,decodeTimeTracker:new S$(this.trackInterval),macroblockLossTracker:new S$(this.trackInterval),macroblockMaxLossTracker:0,freezeDurationPercent:0,frameHeight:0,frameWidth:0,rendererFps:new S$(this.trackInterval),incomingFps:new S$(this.trackInterval),framesReceived:0,framesDecoded:0,decoder:"",msi:s};this.perfTrackerMap.set(s,m)}const c=this.perfTrackerMap.get(s);if(a.inboundRTP.totalDecodeTime&&a.inboundRTP.framesDecoded){const m=oa(a.inboundRTP.totalDecodeTime/a.inboundRTP.framesDecoded*1e3,2);c.decodeTimeTracker.captureSample(m)}const u=a.extensions?.macroblockRateStats?.macroblockRateDecoderLossPercent;c.macroblockLossTracker.captureSample(u),c.macroblockMaxLossTracker=a.extensions?.macroblockRateStats?.macroblockRateMaxDecoderLossPercent,a.extensions?.duration&&(c.freezeDurationPercent=a.extensions?.totalFreezeDuration/a.extensions?.duration*100),c.frameHeight=a.inboundRTP.frameHeight||0,c.frameWidth=a.inboundRTP.frameWidth||0,a.extensions?.frameRateDecoded!==void 0&&a.inboundRTP.framesPerSecond!==void 0&&a.extensions?.frameRateDecoded<=this.rendererFpsCap&&a.inboundRTP.framesPerSecond<=this.rendererFpsCap&&(c.rendererFps.captureSample(a.extensions?.frameRateDecoded),c.incomingFps.captureSample(a.inboundRTP.framesPerSecond)),a.inboundRTP.framesReceived&&a.inboundRTP.framesDecoded&&(c.framesReceived=a.inboundRTP.framesReceived,c.framesDecoded=a.inboundRTP.framesDecoded),c.decoder=a.inboundRTP.decoderImplementation,c.rendererFps.isReportComplete()&&c.incomingFps.isReportComplete()&&c.decodeTimeTracker.isReportComplete()&&(this.paused=!0,await this.checkQuality(c,n.perfCounters,n.video?.recv?.length),this.paused=!1)})}catch(a){this.logger.error("Failed to processes diagnostics update: "+a)}}async checkQuality(n,a,s){if(!s)return;const c=[];let u;try{u=await this.cpuMetricCollector?.getCurrentCpuSample()}catch{this.logger.safe.debug("CPU sampling is not supported")}const m={ts:Date.now(),trackId:n.id,decodeTime:n.decodeTimeTracker.getReport(),macroblockLossPercent:n.macroblockLossTracker.getReport(),macroblockMaxLossPercent:n.macroblockMaxLossTracker,freezeDurationPercent:n.freezeDurationPercent,perfCounters:a,cpuUsage:u,rendererFps:n.rendererFps.getReport(),incomingFps:n.incomingFps.getReport(),framesDecoded:n.framesDecoded,framesReceived:n.framesReceived,msi:n.msi,frameHeight:n.frameHeight,decoder:n.decoder};c.push(m);const b=this.calculatorStrategy.checkQuality(n);if(b===0){if(this.logger.safe.debug(`Bad perf detected for msi ${n.msi}: ${JSON.stringify(c)}`),this.configProvider.config.diagnostics.performanceMonitoring.usePerfConstrainedOvc&&!yl.Recv.getNextLowerResolution(n.frameWidth,n.frameHeight)){const _=Math.max(s-1,1);return this.logger.info(`Min resolution reached, decreasing OVC to: ${_}`),this.diagnostics.registerVideoPerformanceEvent(c,1,_),this.event("calculatorStateChanged").raise(2,{ovc:_}),void this.perfTrackerMap.clear()}this.diagnostics.registerVideoPerformanceEvent(c,1),this.event("calculatorStateChanged").raise(1,{msi:n.msi})}b===2&&(this.diagnostics.registerVideoPerformanceEvent(c,0),this.logger.safe.debug(`Good perf detected for msi ${n.msi}: ${JSON.stringify(c)}`),this.event("calculatorStateChanged").raise(0,{msi:n.msi})),this.perfTrackerMap.delete(n.msi)}},GEi=class extends jr{constructor(n,a,s,c){super(),this.statsGatherer=n,this.diagnostics=a,this.configProvider=s,this.logger=c,this.calculators=new Map,this.subs=[]}on(n,a){switch(n){case"onIncomingVideoQualityChanged":this.addCalculator(0),this.startCalculator(0);break;case"onOptimalVideoCountChanged":this.addCalculator(2),this.startCalculator(2)}return this.subscribe({changed:void 0,on:{name:String(n),handler:a}})}addCalculator(n){let a=this.calculators.get(n);if(!a){switch(n){case 0:if(!this.configProvider.config.diagnostics.performanceMonitoring.enableRemoteVideoCalculator)return;a=new jEi(this.statsGatherer,this.diagnostics,this.configProvider,this.logger.createChild("RemoteVideoPerformanceCalculator"));break;case 2:if(!this.configProvider.config.enableOptimalVideoCount)return;a=new VEi(this.configProvider,this.logger.createChild("OptimalVideoCountCalculator"));break;case 1:throw new Error("Not implemented")}this.subs.push(a.on("calculatorStateChanged",(s,c)=>{this.handleChanged(n,s,c)})),this.calculators.set(n,a)}}startCalculator(n){this.logger.safe.debug(`adding calculator with id ${n}`);const a=this.calculators.get(n);a&&a.start()}stopCalculator(n){this.logger.safe.debug(`stopping calculator with id ${n}`);const a=this.calculators.get(n);a&&a.stop()}processNotification(n,a){switch(n){case"BandwidthNotification":this.calculators.get(2)?.processEstimatedBandwidth(a.bw);break;case"ParticipantCountChanged":this.calculators.get(2)?.updateParticipantCount(a.count);break;case"McpSourceRequestsAvailable":this.calculators.get(2)?.mcpSourceRequestsAvailable();break;default:this.logger.safe.info(`Notification message handler not found for type: ${n}`)}}dispose(){super.dispose(),this.calculators.forEach(n=>{n.dispose()}),this.subs.forEach(n=>{n.dispose()})}handleChanged(n,a,s){switch(this.logger.info(`calculatorStateChanged  ${a}: calculatorType ${n} ${JSON.stringify(s)}`),n){case 0:if(a===2){this.calculators.get(2)?.setPerfConstrainedValue(s?.ovc);break}this.configProvider.config.diagnostics.performanceMonitoring.enableLowerResolution&&this.event("onIncomingVideoQualityChanged").raise(a,s?.msi);break;case 2:this.event("onOptimalVideoCountChanged").raise(s?.ovc,s?.ovcPayload)}}},tae=dn,qEi=class{constructor(n){this.configProvider=n,this.outboundNetworkQuality="Good",this.inboundNetworkQuality="Good",this.jitterAccumulator=new Du(this.configProvider.config.webrtcJitterWindowSize),this.healedRatioAccumulator=new Du(this.configProvider.config.webrtcHealedRatioWindowSize),this.jitterStateProcessor=new Qne(n.config.webrtcJitterLowThreshold,n.config.webrtcJitterHighThreshold,!0,n.config.webrtcJitterSticknessTime),this.lossRateStateProcessor=new Qne(n.config.webrtcLossRateLowThreshold,n.config.webrtcLossRateHighThreshold,!0,n.config.webrtcLossRateSticknessTime)}processReport(n){n.audio?.recv?.length&&(this.inboundNetworkQuality=this.processInboundSample((0,tae.last)(n.audio.recv))),n.audio?.send?.length&&(this.outboundNetworkQuality=this.processOutboundSample((0,tae.last)(n.audio.send)))}getInboundNetworkQuality(){return this.inboundNetworkQuality}getOutboundNetworkQuality(){return this.outboundNetworkQuality}processInboundSample(n){const a=this.inboundNetworkQuality,{totalSamplesReceived:s}=n.inboundRTP,{healedRatio:c}=n.extensions??{};c!=null&&this.healedRatioAccumulator.add(c);const u=(0,tae.mean)(this.healedRatioAccumulator.items);return!s||s<this.configProvider.config.webrtcMinAudioSamplesRecvForNetworkRecvQuality?a:u&&this.healedRatioAccumulator.isFull?this.determineInboundQualityLevel(u):a}determineInboundQualityLevel(n){const a=this.inboundNetworkQuality,s=this.configProvider.config.webrtcStatNetworkDetectionHysteresis,c=this.configProvider.config.webrtcStatNetworkDetectionBadLevel,u=this.configProvider.config.webrtcStatNetworkDetectionGoodLevel;return n<u-s/2?"Good":n<u+s/2?a==="Good"?"Good":"Poor":n<c-s/2?"Poor":n<c+s/2?a==="Bad"?"Bad":"Poor":"Bad"}processOutboundSample(n){const a=this.outboundNetworkQuality,{packetsSent:s,timestamp:c}=n.outboundRTP,{jitter:u}=n.remoteInboundRTP??{},{lossRate:m}=n.extensions??{};if(!s||s<this.configProvider.config.webrtcMinPacketsSentForNetworkSendQuality)return a;u!=null&&this.jitterAccumulator.add(u);const b=(0,tae.mean)(this.jitterAccumulator.items),_=this.jitterAccumulator.isFull?this.jitterStateProcessor.onSample(b,c):"Good",k=m?this.lossRateStateProcessor.onSample(m,c):"Good";return _==="Good"&&k==="Good"?"Good":"Bad"}},WEi=dn,KEi=class{constructor(n){this.configProvider=n,this.speechWindow=new Du(n.config.webrtcSpeakingWhileMutedDetectionWindow)}processReport(n){if(!n.audio?.send?.length)return!1;const a=n.audio.send[0],{rawInputVolume:s,callIsMuted:c}=a.extensions??{},{audioLevel:u}=a.mediaSource??{},{useAudioAnalyzer:m,webrtcSpeakingWhileMutedDetectionLevel:b}=this.configProvider.config;if(!c)return this.speechWindow.clear(),!1;const _=m?s:u;return _!=null&&this.speechWindow.add(_),!!this.speechWindow.isFull&&(0,WEi.mean)(this.speechWindow.items)>b}},JEi=class{constructor(n){this.context=n,this.cname=sw()}toLocal(n,a,s){return this.modify({sdpSource:0,sdpType:s},n,a)}toOffer(n,a,s){return this.modify({sdpSource:1,sdpType:"offer"},n,a,s)}toAnswer(n,a,s){return this.modify({sdpSource:1,sdpType:"answer"},n,a,s)}toRemote(n,a,s,c,u=!1){return this.modify({sdpSource:2,sdpType:c,isOrWasProvisional:u},n,a,s)}modify(n,a,s,c){const u=new mbi(this.context,s,c,this.cname).build(n),m=fs(a);return u.modify(m),m}},YEi=class{get sdp(){return this.originalDescription.sdp}set sdp(n){this.originalDescription=new Cc.window.RTCSessionDescription({sdp:n,type:this.originalDescription.type})}get type(){return this.originalDescription.type}set type(n){this.originalDescription=new Cc.window.RTCSessionDescription({sdp:this.originalDescription.sdp,type:n})}constructor(n){this.originalDescription=new Cc.window.RTCSessionDescription(n)}toJSON(){return this.originalDescription.toJSON()}},QEi=class{constructor(n,a,s,c,u,m,b,_,k,N,W){this.logger=n,this.configProvider=a,this.diagnostics=s,this.reinvitelessContext=c,this.mediaManager=u,this.audioCodecManager=m,this.ufdManager=b,this.sessionContext=_,this.qualityManager=k,this.streamSendersManager=N,this.callbacks=W,this.negotiationQueue=new iL(this.logger),this.negotiatedModalitiesInternal={},this.disabledModalitiesInternal={},this.initiatorInternal=!1,this.noIceCandidates=!1,this.noRelayIceCandidates=!1,this.isRollbackSupported=!1,this.canTriggerRenegotiation=!0,this.triggerRenegotiationFlag=!1,this.capabilityGatherer=E$.build({global:this.sessionContext.maContext},this.configProvider.config.useSdpCapabilities,this.configProvider.config.noRequiredCodecsWorkaround),this.mediaContentTypeInternal=lw("webrtcMediaContentType",this.sessionContext.config,this.configProvider.config),this.allowedMediaContentTypeInternal=lw("webrtcAllowedMediaContentType",this.sessionContext.config,this.configProvider.config).concat(),this.useNGC1webrtcContentType=lw("useNGC1webrtcContentType",this.sessionContext.config,this.configProvider.config),this.negotiationCompletedDefer=new Pi,this.iceCandidatesDeferred=new Pi,this.iceCandidateReceivedInternal=!1,this.initialNegotiationCompleted=!1,this.terminated=!1,this.sessionDescription=YKe.build({sdpTransform:new JEi(this.sessionContext),mediaManager:this.mediaManager,logger:this.logger,configProvider:this.configProvider,configuration:{unifiedPlanEnabled:!0,addPrefixForMsid:this.configProvider.config.addPrefixForMsidInSdp}}),this.negotiationEmulator=new JJe(this.logger.createChild("negotiationEmulator"),YEi,this.sessionDescription,this.negotiationQueue,this.mediaManager),this.negotiationCompletedDefer.promise.catch(()=>{}),this.negotiationCompletedDefer.reject("placeholder")}get configuredModalities(){return this.configuredModalitiesInternal}get offeredModalities(){return this.offeredModalitiesInternal}get disabledModalities(){return this.disabledModalitiesInternal}get negotiatedModalities(){return this.negotiatedModalitiesInternal}get allowedMediaContentType(){return this.allowedMediaContentTypeInternal}get negotiationCompletedPromise(){return this.negotiationCompletedDefer}get iceRelayGatheringStartTime(){return this.iceRelayCandidatesGatherStartTime}get iceCandidatesDefer(){return this.iceCandidatesDeferred}get initiator(){return this.initiatorInternal}set rollbackSupported(n){this.isRollbackSupported=n}set iceCandidateReceived(n){this.iceCandidateReceivedInternal=n}get mediaContentType(){return this.useNGC1webrtcContentType?ke.CONTENT_TYPE.SDP_NGC:this.mediaContentTypeInternal}setInternals(n,a,s){this.logger.safe.debug(`Setting internals tm: ${!!n} tsp: ${!!a} dc: ${!!s}`),this.transceiverManager=n,this.transportStateProvider=a,this.dataChannel=s}terminate(n){this.logger.safe.info(`[${n}] terminating`),this.terminated=!0,this.canTriggerRenegotiation=!1,this.negotiatedModalitiesInternal={},this.resetCandidateGathering(n),this.negotiationCompletedDefer.reject("webRtcSession cleanup"),this.negotiationQueue.dispose()}pauseNegotiations(n=hi()){const a=new Pi;return this.negotiationCompletedDefer.promise.catch(()=>{}).then(()=>{this.setNegotiationPromise(a,n)}),a}async configureModalities(n,a,s){const c=async()=>{if(await this.configureModalitiesPromise,!n.audio&&!n.video&&!n.sharing)throw new Error(`Invalid parameters! ${JSON.stringify(n)}`);const u=Xp(n),m=Xp(this.negotiatedModalities);this.configProvider.config.alwaysNegotiateDataChannel&&(delete u.data,delete m.data);const b=!this.configuredModalities||!Aye(u,m);this.logger.safe.info(`[${a}] configureModalities ${nn(this.configuredModalities)} -> ${nn(n)} (${b?`update from ${nn(this.negotiatedModalities)}`:"fulfilled"})`),this.configuredModalities=n,b&&!this.updateSendStreamsReinviteless(a,s)&&(this.configProvider.config.removeSendersOnConfigureModalities&&!$g(this.configuredModalities)&&await this.streamSendersManager.update(n,1,a),this.triggerRenegotiation(!1,a,s))};return this.configureModalitiesPromise=c(),this.configureModalitiesPromise.catch(u=>{this.logger.safe.warn(`[${a}] Error during configuring modalities: ${nn(u)}`)}),this.configureModalitiesPromise}async completeNegotiation(n){this.mediaManager.commit();let a=BV(this.configProvider,this.configuredModalities,this.negotiatingModalities,this.negotiatedModalities)&&!this.triggerRenegotiationFlag;this.canTriggerRenegotiation=!0,this.logger.safe.info(`[${n}] negotiation completed isComplete: ${a} configured: ${JSON.stringify(this.configuredModalities)} negotiating: ${JSON.stringify(this.negotiatingModalities)} offered: ${JSON.stringify(this.offeredModalities)} negotiated: ${JSON.stringify(this.negotiatedModalities)}`);let s=this.negotiatedModalities;if(this.streamSendersManager.pendingStreamsPromise){this.logger.safe.info(`[${n}] Waiting for stream acquisitions to complete...`);const c=await this.streamSendersManager.pendingStreamsPromise;this.streamSendersManager.clearStreamsPromise(),this.logger.safe.info(`[${n}] Stream acquisitions completed: ${nn(c)}`),BV(this.configProvider,c,this.negotiatingModalities,this.negotiatedModalities)||(this.logger.safe.warn(`[${n}] Some streams were not acquired successfully, considering the negotiation as incomplete`),s=c,a=!1)}return a||this.triggerRenegotiation(!1,n),this.initialNegotiationCompleted=!0,this.negotiationCompletedDefer.resolve(),{isComplete:a,activeModalities:s,offeredModalities:this.offeredModalities,attemptedModalities:this.negotiatingModalities,configuredModalities:this.configuredModalities,initiator:this.initiatorInternal}}async rejectNegotiation(n,a,s=!1){let c;this.mediaManager.rollback(),this.logger.safe.warn(`[${a}] negotiation rejected isComplete: ${!s} error: ${nn(n)} configured: ${JSON.stringify(this.configuredModalities)} negotiating: ${JSON.stringify(this.negotiatingModalities)} offered: ${JSON.stringify(this.offeredModalities)} negotiated: ${JSON.stringify(this.negotiatedModalities)}`),this.qualityManager.clearPendingCapabilities();const u=eie(this.negotiatedModalities,this.negotiatingModalities);this.logger.safe.debug(`[${a}] configured modalities for rollback: ${JSON.stringify(u)}`),this.transceiverManager?.syncTransceivers(u),this.sessionContext.getSmallCallTelemetry()?.setEventType("rejectNegotiation"),this.dataChannel?.updateDataModalityState(this.negotiatingModalities.data);const m=$g(u);$g(this.negotiatedModalities)!==m&&await this.streamSendersManager.setHold(m,a),m?this.logger.safe.info(`[${a}] Hold is configured. Not updating streams`):await this.streamSendersManager.update(u,0,a);const b=this.transportStateProvider?.signalingState;if(b==="have-local-offer"){c={},this.logger.safe.info(`[${a}] rolling back local description`);try{if(!this.isRollbackSupported||this.configProvider.config.webrtcHandleRollback){c.type="LocalRN",this.logger.safe.info(`[${a}] rolling back using local renegotiation`);const _=[this.callbacks.getRollbackModifier(this.logger)];await this.negotiationEmulator.renegotiate(_,!0),this.logger.safe.info(`[${a}] rolling back using local complete`)}else this.logger.safe.info(`[${a}] rolling back using rollback`),c.type="Rollback",await this.callbacks.setLocalDescription({type:"rollback"})}catch(_){this.logger.safe.error(`[${a}] rollback error: ${nn(_)}`),c.error=_}}else if(b==="have-remote-offer"){c={};try{if(!this.isRollbackSupported||this.configProvider.config.webrtcHandleRemoteRollback){c.type="RemoteRN",this.logger.safe.info(`[${a}] applying answer for remote renegotiation`);const _=[this.callbacks.getRollbackModifier(this.logger)];await this.negotiationEmulator.renegotiate(_,!0,"remote")}else this.logger.safe.info(`[${a}] rolling back using rollback on remote description`),c.type="Rollback",await this.callbacks.setRemoteDescription({type:"rollback"})}catch(_){this.logger.safe.error(`[${a}] rollback error: ${nn(_)}`),c.error=_}}else this.callbacks.hasPC()&&this.logger.safe.error(`[${a}] cannot rollback local description in current state: ${this.transportStateProvider.signalingState}`);return this.canTriggerRenegotiation=!0,this.negotiationCompletedDefer.reject("negotiation rejected"),s&&(this.logger.safe.info(`[${a}] retrying failed negotiation`),this.triggerRenegotiation(!1,a)),{isComplete:!s,activeModalities:u,offeredModalities:this.offeredModalities,attemptedModalities:this.negotiatingModalities,configuredModalities:this.configuredModalities,initiator:this.initiatorInternal,rollback:c}}triggerRenegotiation(n,a=hi(),s){this.canTriggerRenegotiation?(this.canTriggerRenegotiation=!1,this.triggerRenegotiationFlag=!1,this.logger.safe.info(`[${a}] triggering renegotiation`),this.mediaManager.backup(),this.callbacks.onNegotiationRequired(a,s)):n&&(this.logger.safe.info(`[${a}] renegotiation postponed`),this.triggerRenegotiationFlag=!0)}configureCrypto(n,a){let s=!1;const c=l9(this.configProvider,a);if(this.offeredDescription){const u=this.offeredDescription.getSrtpInfo();this.diagnostics.offeredSrtp=u,s=!u.dtls||u.sdes&&c}else s=c;return s&&(this.logger.safe.info("configuring peer connection to use sdes"),n.optional.push({DtlsSrtpKeyAgreement:!1})),this.diagnostics.negotiatedSrtp={dtls:!s,sdes:!!s},s?0:1}createOffer(n,a){const s=this.negotiationQueue.add(()=>this.createOfferAsync(n,a),n);return this.resetNegotiationQueue(n),s}processOffer(n,a){const s=this.negotiationQueue.add(()=>this.processOfferAsync(n,a),a);return this.resetNegotiationQueue(a),s}async createAnswer(n,a){if((this.sessionContext.config.isPstnCall?!this.configProvider.config.createProvisionalAnswer.enabledPstn:!this.configProvider.config.createProvisionalAnswer.enabled)&&n)return this.logger.safe.info("createAnswer(): Ignoring provisional answer"),{blob:"",contentType:this.mediaContentType};const s=n?"pranswer":"answer",c=n?"createProvisionalAnswerAsync":"createAnswerAsync",u=this.diagnostics.getTimerTracker(c,{first:!0});if(u.mark("start"),this.logger.safe.info(`[${a}] create [${s}] offered: ${JSON.stringify(this.offeredModalities)} configured: ${JSON.stringify(this.configuredModalities)}`),!this.configuredModalities)throw new Error("no configured modalities to create answer for");let m=this.negotiatingModalities=Eye(this.offeredModalities,this.configuredModalities);await this.callbacks.assurePC(a,u.clone("assurePeerConnectionAsync"));const b=this.transportStateProvider.isWaitingAcceptProvisional;if(this.transportStateProvider.isWaitingAcceptProvisional=n,u.markAndMeasure("start","assurePeerConnectionAsync"),this.logger.safe.info(`[${a}] updatePeerConnectionStreamsAsync, pc state: ${JSON.stringify(this.transportStateProvider.signalingState)}`),!this.offeredDescription.isCodecSwitchSupported())try{const se=(await this.capabilityGatherer.getCapabilities(ke.MEDIA_TYPE.audio)).codecs.map(Re=>Re.mimeType);this.offeredDescription.usePrimaryAudioCodecOnly(se)}catch(se){this.logger.safe.error(`[${a}] failed to set primary codec based on audio capability ${nn(se)}`)}u.markAndMeasure("assurePeerConnectionAsync","handleCodecSwitchUnsupported"),this.audioCodecManager.prepareForNegotiation(this.initiatorInternal),this.offeredDescription.setModalities(m),await this.detectSendProfileSupport();const _=this.offeredDescription.toRemote(n||b);this.configProvider.config.createProvisionalAnswer.streamsBeforeSetFullRD&&!n&&b&&["have-remote-offer","stable"].includes(this.transportStateProvider.signalingState)&&!this.initialNegotiationCompleted&&(this.logger.safe.info(`[${a}] create [${s}] provisional was applied, requesting streams and activating senders before set remote description is finished`),await this.updateStreamSenders(u,a,n,m)),this.logger.unsafe.info(`[${a}] create [${s}] set remote description', 'negotiated:`,m,"sdp:",_),await this.callbacks.setRemoteDescription({sdp:_,type:"offer"}),u.markAndMeasure("handleCodecSwitchUnsupported","setRemoteDescription"),this.dataChannel?.updateDataModalityState(this.negotiatingModalities.data),await this.updateStreamSenders(u,a,n,m),u.markAndMeasure("assurePeerConnectionAsync","assureStreamsAndDataChannel"),u.markAndMeasure("setRemoteDescription","assureStreamsAndDataChannel"),this.callbacks.onTransportInitialized();const k=this.configProvider.config.createProvisionalAnswer.setProperAnswerType?await this.callbacks.createAnswer({type:s}):await this.callbacks.createAnswer();u.markAndMeasure("assureStreamsAndDataChannel","createAnswer"),this.logger.unsafe.info(`[${a}] create [${s}] answer from peer connection type: ${k.type}, sdp:`,k.sdp);const N=this.sessionDescription.createLocalAnswer(k.sdp);this.hasIceCandidates(N)||this.resetCandidateGathering(a),this.callbacks.startWaitingForStreamStart(m),this.setupIceGatheringTimeout(a);const W=N.toLocal();this.logger.unsafe.info(`[${a}] create [${s}] set local description sdp:`,W),await this.callbacks.setLocalDescription({sdp:W,type:this.configProvider.config.createProvisionalAnswer.setProperAnswerType?s:"answer"}),u.markAndMeasure("createAnswer","sLD"),await this.iceCandidatesDeferred.promise,u.markAndMeasure("sLD","candidates");const ee=this.sessionDescription.createLocalAnswer(this.callbacks.getLocalDescription().sdp);this.fixLocalDescription(ee),ee.updateModalities(m),this.checkIceCandidates(ee),n&&this.configProvider.config.createProvisionalAnswer.forceRecvonly&&(this.logger.safe.info(`[${a}] create [${s}] munge returned local sdp to recvonly modalities`),ee.forceRecvonly());const oe=ee.toAnswer();this.audioCodecManager.decoder?.setRecvPayloads(ee.getPayloadsForMedia(ke.MEDIA_TYPE.audio)),this.checkAudioCodecNegotiated(a),n?this.logger.safe.debug(`[${a}] create [${s}] skip stream senders manager activation`):(this.logger.safe.debug(`[${a}] create [${s}] activating stream senders manager`),await this.streamSendersManager.activate(a)),u.markAndMeasure("candidates","streamSendersManagerActivate"),n?this.logger.safe.debug(`[${a}] create [${s}] skip updating sources and capabilities`):(this.logger.safe.debug(`[${a}] create [${s}] updating sources and capabilities`),this.callbacks.updateLocalMediaSources(),this.applyReceiveCapabilities(a)),m=ee.getModalities(),this.reinvitelessContext.enabled&&(m=eie(this.negotiatingModalities,m)),BV(this.configProvider,this.configuredModalities,this.negotiatingModalities,m)||this.triggerRenegotiation(!0,a),this.negotiatedModalities=m,this.diagnostics.bweType=ee.getBweType(),this.logger.unsafe.info(`[${a}] CREATE ANSWER`,"sdp:",oe);const de={blob:oe,contentType:this.mediaContentType};return this.configProvider.countryCode&&(de.clientLocation=this.configProvider.countryCode),this.reinvitelessContext.enabled&&(de.mediaDescriptions=this.getMediaDescriptions(m)),this.callbacks.setBWSeed(de),u.markAndMeasure("start",c),de}async detectSendProfileSupport(){if(this.configProvider.config.preferredH264VideoSendProfile||this.configProvider.config.preferredH264SharingSendProfile){let n=this.capabilityGatherer;this.configProvider.config.learnCodecSendCapabilitiesFromSenderApi&&(n=E$.build({global:this.sessionContext.maContext},this.configProvider.config.useSdpCapabilities,this.configProvider.config.noRequiredCodecsWorkaround,!0));const a=await n.getCapabilities("video"),s=this.mediaManager.getMediaEntities().filter(c=>{const u=c.getModality();return u===ke.MEDIA_TYPE.video||u===ke.MEDIA_TYPE.sharing}).filter(c=>c.isEnabled());for(const c of a.codecs)if(c.sdpFmtpLine&&c.mimeType.toLocaleLowerCase().includes("h264")){const u=c.sdpFmtpLine.match(/profile-level-id=([a-fA-F0-9]{6})/);u?.length===2&&s.forEach(m=>m.addSupportedSendProfile("H264",u[1]))}}}async updateStreamSenders(n,a,s,c){this.transceiverManager.syncTransceivers(c),this.mediaManager.getMediaEntities().forEach(m=>{m.setExtension("midApplied",!0)});const u=$g(this.negotiatingModalities);if($g(this.negotiatedModalities)!==u&&(n?.mark("startConfigureHold"),await this.streamSendersManager.setHold(u,a),n?.markAndMeasure("startConfigureHold","configureHold")),u)this.logger.safe.info(`[${a}] Hold is configured. Not updating streams`);else{let m=this.configProvider.config.negotiationParallelStreamAcquisitionCreateAnswer&&!this.initialNegotiationCompleted?2:0;s&&(m=4),await this.streamSendersManager.update(c,m,a),n?.markAndMeasure("configureHold","updateStreams")}}configureBroadcastScenario(n,a){const s=this.configProvider.config.broadcastMode;this.diagnostics.meetingScenario=n.meetingScenario,(s?.prioritizeLayoutOnServer||s?.prioritizeLayoutOnClient||s?.maxSessionBandwidthKbps)&&n.meetingScenario&&s.townHallScenarioNames?.length&&s.townHallScenarioNames.map(c=>c.toLowerCase()).indexOf(n.meetingScenario.toLowerCase())!==-1&&(this.sessionContext.config.isTownHall=!0,this.diagnostics.isTownHall=!0,s?.maxSessionBandwidthKbps&&this.configProvider.overrideMaxSessionBandwidth(s.maxSessionBandwidthKbps)&&(this.logger.safe.info(`Adjusting maxSessionBandwidth for TownHall: ${this.configProvider.mediaConfig.maxBandwidthInKbps}`),this.triggerRenegotiation(!0,a)))}async processAnswer(n,a,s,c=!1){try{const u=n.blob;this.logger.unsafe.debug(s?`[${a}] PROCESS PRANSWER`:`[${a}] PROCESS ANSWER`,"sdp:",u);const m=s?"pranswer":"answer";if(s&&(!ZEi(this.sessionContext,c)||this.transportStateProvider.signalingState!=="have-local-offer"))return void this.logger.safe.info(`[${a}] process [${m}] ignored`);this.configureBroadcastScenario(n,a);const b=this.diagnostics.getTimerTracker(s?"processProvisionalAnswerAsync":"processAnswerAsync",{first:!0});b.mark("start");const _=this.sessionDescription.createRemoteAnswer(u);let k=r9(_.getModalities());this.reinvitelessContext.enabled&&(k=eie(this.offeredModalities,k)),_.setModalities(k),await this.detectSendProfileSupport();const N=_.toRemote();if(s||(this.useNGC1webrtcContentType||(this.mediaContentType=n.contentType),this.allowedMediaContentType.indexOf(this.mediaContentType)===-1&&this.allowedMediaContentType.push(this.mediaContentType),$g(k)||(await this.streamSendersManager.update(k,1,a),b.markAndMeasure("start","streamSendersManagerUpdate"),Ur(this.offeredModalities.data)&&!k.data&&this.dataChannel?.disable()),this.negotiatedModalities=k,this.callbacks.updateLocalMediaSources(),this.diagnostics.bweType=_.getBweType()),this.callbacks.onTransportInitialized(),this.logger.unsafe.info(`[${a}] process [${m}] set remote description`,"negotiated:",k,"sdp:",N),b.mark("startSetRemoteDescription"),await this.callbacks.setRemoteDescription({sdp:N,type:m}),b.markAndMeasure("startSetRemoteDescription","setRemoteDescription"),s)return;await this.streamSendersManager.activate(a),b.markAndMeasure("setRemoteDescription","streamSendersManagerActivate"),this.applyReceiveCapabilities(a),this.checkAudioCodecNegotiated(a),this.transceiverManager.syncTransceivers(k),b.markAndMeasure("start","processAnswerAsync")}catch(u){if(s)return void this.logger.safe.warn(`Error thrown during pranswer generation, ignoring: ${nn(u)}`);throw u}}async createOfferAsync(n,a){const s=this.diagnostics.getTimerTracker("createOfferAsync",{first:!0});if(s.mark("start"),this.logger.safe.info(`[${n}] create [offer] configured: ${JSON.stringify(this.configuredModalities)}`),this.initiatorInternal=!0,!this.configuredModalities)throw new Error("no configured modalities to create offer for");this.canTriggerRenegotiation=!1,this.negotiatingModalities=this.configuredModalities,await this.callbacks.assurePC(n,s.clone("assurePeerConnectionAsync")),s.markAndMeasure("start","assurePeerConnectionAsync"),this.logger.safe.info(`[${n}] updatePeerConnectionStreamsAsync, pc state: ${JSON.stringify(this.transportStateProvider.signalingState)}`),$g(this.negotiatingModalities)&&!Am(this.negotiatedModalities)&&Object.keys(this.negotiatingModalities).forEach(oe=>{this.negotiatedModalities[oe]===void 0&&delete this.negotiatingModalities[oe]}),this.transceiverManager?.assureTransceivers(this.negotiatingModalities),this.dataChannel?.updateDataModalityState(this.negotiatingModalities.data);const c=$g(this.negotiatingModalities);let u;$g(this.negotiatedModalities)!==c&&(s?.mark("startConfigureHold"),await this.streamSendersManager.setHold(c,n),s?.markAndMeasure("startConfigureHold","configureHold")),c?(this.logger.safe.info(`[${n}] Hold is configured. Not updating streams`),u=this.negotiatingModalities):(u=await this.streamSendersManager.update(this.negotiatingModalities,this.configProvider.config.negotiationParallelStreamAcquisitionCreateOffer&&!this.initialNegotiationCompleted?2:0,n),s?.markAndMeasure("configureHold","updateStreams"),this.dataChannel&&this.negotiatingModalities.data&&(u.data=this.negotiatingModalities.data)),s.markAndMeasure("assurePeerConnectionAsync","assureStreamsAndDataChannel"),this.offeredModalities=u,!z2(this.sessionContext)&&this.configProvider.config.webrtcNegotiateDisabledDataModality&&!this.offeredModalities[ke.MODALITY.data]&&this.sessionContext.config?.isConference&&(this.offeredModalities[ke.MODALITY.data]=ke.MEDIA_STATE.inactive),this.audioCodecManager.prepareForNegotiation(this.initiatorInternal),this.logger.safe.info(`[${n}] create [offer] offered: ${JSON.stringify(this.offeredModalities)}`);const m=await this.callbacks.createOffer();s.markAndMeasure("assureStreamsAndDataChannel","createOffer"),this.logger.unsafe.info(`[${n}] create [offer] offer from peer connection, sdp: ${m.sdp}`);const b=this.sessionDescription.createLocalOffer(m.sdp);this.hasIceCandidates(b)||this.resetCandidateGathering(n),this.callbacks.startWaitingForStreamStart(u),this.setupIceGatheringTimeout(n);const _=b.toLocal();this.logger.unsafe.info(`[${n}] create [offer] set local description`,"sdp:",_),await this.callbacks.setLocalDescription({sdp:_,type:"offer"}),s.markAndMeasure("createOffer","sLD"),await this.iceCandidatesDeferred.promise,s.markAndMeasure("sLD","candidates");const k=this.sessionDescription.createLocalOffer(this.callbacks.getLocalDescription().sdp);this.fixLocalDescription(k),k.updateModalities(this.offeredModalities),this.checkIceCandidates(k);const N=k.toOffer();this.logger.unsafe.info(`[${n}] CREATE OFFER`,"sdp:",N);const W={blob:N,contentType:this.mediaContentType};this.configProvider.mediaConfig.webrtcRequiredFeatures===""||this.sessionContext.config.isConference||(W.requiredFeatures=this.configProvider.mediaConfig.webrtcRequiredFeatures),this.audioCodecManager.decoder?.setRecvPayloads(k.getPayloadsForMedia(ke.MEDIA_TYPE.audio)),this.configProvider.countryCode&&(W.clientLocation=this.configProvider.countryCode),this.mediaManager.getMediaEntities().forEach(oe=>{oe.setExtension("midApplied",!0)});const ee=b.isIceRestart();return this.logger.safe.info(`[${n}] ICE restart: ${ee}`),this.configProvider.mediaConfig.isTransportUnbundled&&this.offeredDescription?.isMSRTC()&&ee&&!this.sessionContext.config.isConference&&b.getSrtpInfo().sdes&&(W.newOffer=!0),this.reinvitelessContext.enabled&&(this.mediaManager.updateMediaEntitiesWithLocalTracks(),W.mediaDescriptions=this.getMediaDescriptions(this.offeredModalities)),a&&(W.negotiationTag=a),this.callbacks.setBWSeed(W),s.markAndMeasure("start","createOfferAsync"),W}async processOfferAsync(n,a){const s=this.diagnostics.getTimerTracker("processOfferAsync",{first:!0});s.mark("start"),this.mediaManager.backup();const c=n.blob;if(this.logger.unsafe.info(`[${a}] process [offer]`,"sdp:",c),this.configProvider.config.webrtcCompareContentTypeInOffer&&!this.useNGC1webrtcContentType&&($ee(n.contentType,this.allowedMediaContentType),this.mediaContentType=n.contentType),this.configureBroadcastScenario(n,a),this.offerOriginator&&this.offerOriginator!==n.originator&&this.configProvider.config.rejectIncompatibleOriginator)throw{detail:"mediaContent.originator is different on renegotiation",type:ke.MEDIA_ERROR.incompatibleOriginator};if(this.offerOriginator=n.originator,n.requiredFeatures){const m=this.configProvider.mediaConfig.webrtcRejectedFeatures.split(",");CG(n.requiredFeatures.split(","),m)}if(this.initiatorInternal=!1,this.offeredDescription=this.sessionDescription.createRemoteOffer(c),this.configProvider.config.multiStreamSupported){const m=tbi(c),b=this.configProvider.config.numVideoChannelsGvc-this.configProvider.config.nonMultiStreamChannels;this.configProvider.mediaConfig.multiStreamChannelsOffered=m,m<b&&(this.logger.safe.info(`Received ${m} multi stream channels, ${b} channels supported`),this.triggerRenegotiation(!0,a))}this.canTriggerRenegotiation=!1,this.offeredModalities=r9(this.offeredDescription.getModalities()),this.callbacks.hasPC()||(this.configProvider.mediaConfig.isTransportUnbundled?this.configProvider.mediaConfig.isTransportUnbundled=this.offeredDescription.couldBeUnbundled():this.configProvider.mediaConfig.isTransportUnbundled=this.offeredDescription.isUnbundled());let u=this.configProvider.config.removeUnsupportedVideoModality?this.offeredModalities:Xp(this.offeredModalities);if(Ur(this.offeredModalities.video)||Rc(this.offeredModalities.video)||Ur(this.offeredModalities.sharing)||Rc(this.offeredModalities.sharing)){const m=this.offeredDescription.getVideoCodecs();try{s.mark("startGetCapabilities");const b=await this.capabilityGatherer.getCapabilities("video");s.markAndMeasure("startGetCapabilities","getCapabilities"),b.codecs.some(_=>m.some(k=>_.mimeType===k&&this.configProvider.config.primaryVideoCodecs.includes(k)))||(this.logger.safe.warn(`[${a}] offer doesn't contain any supported video codecs`),this.disabledModalities.video=u.video,this.disabledModalities.sharing=u.sharing,delete u.video,delete u.sharing)}catch(b){this.logger.safe.error(`[${a}] failed to get video capability ${nn(b)}`)}}return(!z2(this.sessionContext)&&(Ur(this.offeredModalities.data)||Rc(this.offeredModalities.data))||this.dataChannel?.state==="Failed")&&(this.logger.safe.info(`[${a}] Supressing data modality as data channel is not possible`),u=Xp(u),delete u.data),s.markAndMeasure("start","processOfferAsync"),this.logger.safe.info(`[${a}] process [offer] offered: ${JSON.stringify(this.offeredModalities)} acceptable: ${JSON.stringify(u)}`),u}async startMediaDescriptionsUpdate(n,a){this.dataChannel?.updateDataModalityState(this.reinvitelessRequestedModalities?.data);const s=$g(this.negotiatedModalities),c=$g(this.reinvitelessRequestedModalities);return s!==c&&await this.streamSendersManager.setHold(c,n),c?this.reinvitelessAppliedModalities=this.reinvitelessRequestedModalities:(this.reinvitelessAppliedModalities=await this.streamSendersManager.update(this.reinvitelessRequestedModalities,0,n),this.dataChannel&&this.reinvitelessRequestedModalities.data&&(this.reinvitelessAppliedModalities.data=this.reinvitelessRequestedModalities.data)),this.callbacks.updateLocalMediaSources(),await this.streamSendersManager.activate(n),this.getMediaDescriptions(this.reinvitelessAppliedModalities,a)}async completeMediaDescriptionsUpdate(n){this.logger.safe.info(`[${n}] complete media descriptions update`),this.negotiatedModalities=this.reinvitelessAppliedModalities;const a=this.reinvitelessAppliedModalities,s=this.reinvitelessRequestedModalities;return this.reinvitelessAppliedModalities={},this.reinvitelessRequestedModalities={},{appliedModalities:a,requestedModalities:s}}async rejectMediaDescriptionsUpdate(n,a=!1){this.logger.safe.info(`[${n}] reject media descriptions update`),a&&(this.logger.safe.info(`[${n}] trigger renegotiation after failed media descriptions update`),this.triggerRenegotiation(!1,n));const s=await this.streamSendersManager.update(this.negotiatedModalities,1,n),c=this.reinvitelessRequestedModalities;return this.reinvitelessAppliedModalities={},this.reinvitelessRequestedModalities={},{appliedModalities:s,requestedModalities:c}}getMediaDescriptions(n,a){if($g(n))return{};const s=[];for(const c of this.mediaManager.getMediaEntities()){if(!c.getExtension("reinviteless"))continue;const u=n[c.getModality()],m={mid:c.getMid(),direction:!c.getLocalTrackId()&&Ur(u)?o9(u):u};s.push(m)}return{descriptions:s,negotiationTag:a}}updateSendStreamsReinviteless(n,a){if(Am(this.negotiatedModalities)||$g(this.negotiatedModalities)||$g(this.configuredModalities))return!1;this.reinvitelessRequestedModalities=Xp(this.negotiatedModalities);for(const[s,c]of Object.entries(this.configuredModalities))this.mediaManager.getMediaEntitiesByModality(s)[0]?.getExtension("reinviteless")&&(this.reinvitelessRequestedModalities[s]=c);return!xc(this.reinvitelessRequestedModalities,this.negotiatedModalities)&&(this.callbacks.onUpdateMediaDescriptionsRequired(n,a),xc(this.reinvitelessRequestedModalities,this.configuredModalities))}checkAudioCodecNegotiated(n){const a=this.audioCodecManager.negotiationCompleted();if(this.audioCodecManager.decoder?.getUnmixedAudioProvider()?.configured){const s=a?"Good":"Bad";this.ufdManager.signalEvent("SpatialAudioMUCHUnavailable",s,"Audio",!0,n)}}fixLocalDescription(n){this.configProvider.config.insertFakeCandidateIfNeeded&&(this.iceCandidateReceivedInternal||!this.iceCandidateReceivedInternal&&this.transportStateProvider.isIceConnected)&&(this.diagnostics.fakeCandidate=n.insertFakeCandidateIfNeeded()),n.fixDataModality()}applyReceiveCapabilities(n){const a=this.mediaManager.getMediaEntities().map(s=>s.getRemoteRecvCapabilities());this.sessionContext.config?.isConference?this.qualityManager.setPendingCapabilities():this.qualityManager.setMaxCapabilities(a,n)}resetNegotiationQueue(n){this.negotiationCompletedDefer.reject("promise expired"),this.setNegotiationPromise(new Pi,n)}setNegotiationPromise(n,a=hi()){this.terminated||(this.negotiationCompletedDefer=n,this.negotiationQueue.add(this.negotiationCompletedDefer,a))}hasIceCandidates(n){return this.configProvider.mediaConfig.isTransportUnbundled?n.hasUnbundledIceCandidates():n.hasIceCandidates()}checkIceCandidates(n){const a=this.hasIceCandidates(n);if(a===this.noIceCandidates&&(this.noIceCandidates=!this.noIceCandidates,this.ufdManager.signalEvent("NoNetwork",this.noIceCandidates?"Bad":"Good"),this.noIceCandidates))throw{type:ke.MEDIA_ERROR.noNetworkError,detail:"no ice candidates"};if(a){const s=this.hasRelayIceCandidates(n);if(s===this.noRelayIceCandidates){if(!s&&this.transportStateProvider.isIceConnected)return;this.noRelayIceCandidates=!this.noRelayIceCandidates,this.ufdManager.signalEvent("NetworkRelaysNotReachable",this.noRelayIceCandidates?"Bad":"Good")}}}hasRelayIceCandidates(n){return this.configProvider.mediaConfig.isTransportUnbundled?n.hasUnbundledRelayIceCandidates():n.hasRelayIceCandidates()}setupIceGatheringTimeout(n){this.iceRelayCandidatesGatherStartTime=Date.now();const a=this.sessionContext.config.webrtcIceGatheringTimeoutIncreased?this.configProvider.config.relayWaitSaneTimeoutMs:this.configProvider.config.webrtcIceGatheringTimeoutMs;if(!a)return;this.iceCandidatesTimer&&clearTimeout(this.iceCandidatesTimer);const s=this.iceCandidatesDeferred;this.iceCandidatesTimer=window.setTimeout(()=>{this.iceCandidatesTimer=void 0,s.isPending&&(this.logger.safe.warn(`[${n}] ICE candidates gathering terminated due to timeout ${a}`),s.resolve())},a)}resetCandidateGathering(n){this.logger.safe.info(`[${n}] reset candidate gathering`),this.iceCandidatesDeferred.promise.then(()=>{},()=>{}),this.iceCandidatesDeferred.reject(new Error("reset candidate gathering")),this.iceCandidatesDeferred=new Pi,this.iceCandidateReceivedInternal=!1}set offeredModalities(n){this.offeredModalitiesInternal=n,this.diagnostics.offeredModalities=n}set negotiatedModalities(n){this.logger.safe.info(`setNegotiatedModalities ${JSON.stringify(n)}`),this.negotiatedModalitiesInternal=n,this.diagnostics.negotiatedModalities=n}set configuredModalities(n){this.configuredModalitiesInternal=n}set mediaContentType(n){this.mediaContentTypeInternal=n}};function ZEi(n,a=!1){const s=!n.configProvider.config.acceptProvisionalAnswerFromPstnOnly||a;return n.config.isPstnCall?n.configProvider.config.acceptProvisionalAnswerPstn&&s:n.configProvider.config.acceptProvisionalAnswer}var XEi=class{constructor(n){this.mcpConfig=n,this.data={sourceRequestsSignaling:{},sourceRequestsMCP:{},fallbackMCPMessagesCounter:0,sourceRequestsResponses:{},errors:[]}}setRecord(n,a,s){const c={sequenceNumber:a,timestamp:Date.now(),sourceId:s?.sourceId,fmtp:s?.fmtParams};n.records??(n.records=[]),Mo(n.records,c,this.mcpConfig.storedSRRecordsCount)}recordSignalingOperation(n,a){var s;(s=this.data.sourceRequestsSignaling)[n]??(s[n]={counter:0}),this.data.sourceRequestsSignaling[n].counter++}recordMCPOperation(n,a,s){var c;(c=this.data.sourceRequestsMCP)[n]??(c[n]={counter:0}),this.data.sourceRequestsMCP[n].counter++,this.mcpConfig.verboseTelemetry&&this.setRecord(this.data.sourceRequestsMCP[n],a,s)}recordError(n,a){const s=[Date.now(),a,n];Mo(this.data.errors,s,this.mcpConfig.storedSRRecordsCount)}recordSignalingOperationDuration(n,a){const s=this.data.sourceRequestsSignaling[n]?.records?.find(c=>c.sequenceNumber===a);s&&(s.duration=Date.now()-s.timestamp)}recordMCPMessageFallback(n,a){if(this.data.fallbackMCPMessagesCounter++,this.mcpConfig.verboseTelemetry){const s=this.data.sourceRequestsMCP[a]?.records?.find(c=>c.sequenceNumber===n);s&&(s.fallback=!0,s.fallbackTimestamp=Date.now())}}recordSrResultReceived(n,a,s){var c;if(this.mcpConfig.verboseTelemetry){const u=this.data.sourceRequestsMCP[s]?.records?.find(m=>m.sequenceNumber===a);u&&(u.duration=Date.now()-u.timestamp,u.result=n)}(c=this.data.sourceRequestsResponses)[n]??(c[n]=0),this.data.sourceRequestsResponses[n]++}getObjectRef(){return this.data}},jTe=5,e0i=class{constructor(n){this.mcpConfig=n,this.storage={createTime:Date.now(),startedCount:0,stoppedCount:0,clientCapabilities:[],events:[]},this.sourceRequestSenderDiagnostics=new XEi(this.mcpConfig)}get getSourceRequestSenderDiagnostics(){return this.sourceRequestSenderDiagnostics}logStarted(){if(this.storage.startedCount++,this.storage.startedCount>jTe)return;const n={startedTs:A$(this.storage.createTime),mpCapabilities:{},sentMessages:{},recvMessages:{},sentFailed:0,recvFailed:0,cachedDshReceived:!1};this.storage.events.push(n),this.lastEventConnecting=!0}logStopped(){this.storage.stoppedCount++;const n=this.getCurrentDCSessionEvent();n&&(n.stoppedTs=A$(this.storage.createTime)),this.lastEventConnecting=!1}logSentMsg(n){var a,s;const c=this.getCurrentDCSessionEvent();c&&((a=c.sentMessages)[s=n.type]??(a[s]=0),c.sentMessages[n.type]++)}logReceivedMsg(n){var a,s;this.lastEventConnecting=!1;const c=this.getCurrentDCSessionEvent();c&&((a=c.recvMessages)[s=n.type]??(a[s]=0),c.recvMessages[n.type]++,n.type!=="dsh"||c.handshakeDuration||(c.cachedDshReceived=!0))}logHandshakeStarted(n){const a=this.getCurrentDCSessionEvent();a&&(a.handshakeStartedTs=Date.now()),this.storage.clientCapabilities=n}logHandshakeCompleted(n){const a=this.getCurrentDCSessionEvent();a&&(a.handshakeDuration||(a.handshakeDuration=A$(a.handshakeStartedTs)),a.mpCapabilities.send=n.send_capabilities,a.mpCapabilities.recv=n.receive_capabilities)}logHandshakeFailed(n){const a=this.getCurrentDCSessionEvent();a&&(a.handshakeDuration=A$(a.handshakeStartedTs),a.handshakeFailedWithError=n)}logSentFailed(n){const a=this.getCurrentDCSessionEvent();a&&(a.sentFailed++,a.lastSentFailed={ts:A$(this.storage.createTime),error:n})}logRecvFailed(n){const a=this.getCurrentDCSessionEvent();a&&(a.recvFailed++,a.lastRecvFailed={ts:A$(this.storage.createTime),error:n})}logTimeout(){if(this.storage.startedCount>=jTe&&!this.lastEventConnecting)return;const n={timeoutTs:Date.now()},a=this.getCurrentDCSessionEvent();a&&(n.handshakeStartedTs=a.handshakeStartedTs),this.lastEventConnecting&&this.storage.events.pop(),this.storage.events.push(n),this.lastEventConnecting=!1}getReport(){const n=this.sourceRequestSenderDiagnostics.getObjectRef();return this.storage.sourceRequestsReport=n,this.storage}getCurrentDCSessionEvent(){const n=this.storage.events[this.storage.events.length-1];return this.storage.startedCount<=jTe&&n?.startedTs!==void 0?n:null}};function A$(n){return Date.now()-n}var t0i=4294967292,i0i=class extends Qs{constructor(n,a,s){super(),this.dataChannel=n,this.logger=a,this.mcpConfig=s,this.mcpState="Created",this.handshakeTimeout=null,this.telemetryLogger=new e0i(this.mcpConfig),this.mcpSupportedFeatures={sourceRequestsEnabled:!1,sourceRequestsResponseEnabled:!1,dominantSpeakerHistoryEnabled:this.mcpConfig?.enableDominantSpeakerHistory,senderSideBandwidthEstimationEnabled:!1},this.subscribeToDataChannel()}getTelemetryLogger(){return this.telemetryLogger}mcpFeaturesSupported(n){return this.mcpSupportedFeatures[n]}switchMcpFeature(n,a){this.logger.warn(`Switching ${n} to ${a}`),this.mcpSupportedFeatures[n]=a}getConfig(){return this.mcpConfig??{}}getMcpState(){return this.mcpState}dispose(){super.dispose(),clearTimeout(this.handshakeTimeout),this.handshakeTimeout=null,this.mcpState="Inactive",this.switchMcpFeature("sourceRequestsEnabled",!1),this.switchMcpFeature("sourceRequestsResponseEnabled",!1)}getTelemetryReport(){return this.logger.debug(`Telemetry ${JSON.stringify(this.telemetryLogger.getReport())}`),this.telemetryLogger.getReport()}async sendMsg(n){return this.sendMsgInternal(n)}async onDCStarted(){this.logger.info("Data channel is started, starting handshake"),this.telemetryLogger.logStarted(),await this.startHandshake()}async onDCStopped(){this.logger.info("Data channel handler is stopped"),this.telemetryLogger.logStopped(),this.mcpState="Inactive"}subscribeToDataChannel(){this.dataChannel.on("onStateChanged",()=>this.onDataChannelStateChanged()),this.dataChannel.on("onmessage",(n,a,s)=>this.processIncomingData(n,s))}onDataChannelStateChanged(){switch(this.dataChannel.state){case"Connected":this.onDCStarted();break;case"Closed":case"Destroyed":this.onDCStopped()}}async startHandshake(){try{this.mcpState="Handshaking";const n=[];this.mcpConfig.enableDominantSpeakerHistory&&n.push("dsh"),this.mcpConfig.enableBweNotifications&&n.push("bwe"),this.mcpConfig.enableSourceRequests&&n.push("sr"),this.mcpConfig.enableSendBandwidthNotificationsEnabled&&n.push("ssbwe"),this.telemetryLogger.logHandshakeStarted(n),this.logger.info(`Send syn, client capabilities: ${JSON.stringify(n)}`),await this.sendMsgInternal({type:"syn",client_capabilities:n}),this.handshakeTimeout=window.setTimeout(()=>{this.handshakeTimeout=null,this.telemetryLogger.logTimeout(),this.mcpState="TimedOut",this.switchMcpFeature("sourceRequestsEnabled",!1),this.logger.warn(`Timeout after ${this.mcpConfig.handshakeTimeout}ms, raising onHandshakeTimeout`),this.event("onHandshakeTimeout").raise()},this.mcpConfig.handshakeTimeout)}catch(n){this.logger.error(`Handshake failed with: ${nn(n)}`),this.telemetryLogger.logHandshakeFailed(nn(n))}}async sendMsgInternal(n){const a=Array.isArray(n)?n:[n],s=new TextEncoder().encode(JSON.stringify(a)),c=new Uint8Array(1+s.length);c[0]=1,c.set(s,1);try{await this.dataChannel.sendMessage(18,void 0,c,[t0i]);for(const u of a)this.telemetryLogger.logSentMsg(u)}catch(u){throw this.logger.error(`Send failed: ${nn(u)}`),this.telemetryLogger.logSentFailed(nn(u)),u}}processIncomingData(n,a){if(n!==18)return;if(a[0]!==1){const u=`Unsupported header version ${a[0]}`;return this.logger.info(u),void this.telemetryLogger.logRecvFailed(u)}const s=new DataView(a.buffer,1);let c;try{const u=new TextDecoder().decode(s);c=JSON.parse(u)}catch(u){return this.logger.error(`Failed to parse received data, error ${nn(u)}`),void this.telemetryLogger.logRecvFailed(nn(u))}for(const u of c)switch(this.telemetryLogger.logReceivedMsg(u),u.type){case"syn":break;case"ack":this.processAckMsg(u);break;case"bwe":this.processBweMsg(u);break;case"dsh":this.processDshMsg(u);break;case"sr_res":this.processSrResMsg(u);break;default:{const m=`Unsupported msg type ${u.type}`;this.logger.error(m),this.telemetryLogger.logRecvFailed(m)}}}processDshMsg(n){this.mcpConfig.enableDominantSpeakerHistory&&(this.logger.debug(`DSH received: ${JSON.stringify(n)}`),this.event("mpDshChanged").raise(n.history))}processSrResMsg(n){this.mcpConfig.enableSourceRequests&&this.event("mpSrResReceived").raise(n.sequenceNumber,n.result),this.mcpState="Active"}processBweMsg(n){this.mcpConfig.enableBweNotifications&&this.event("mpSendBandwidthChanged").raise(n.bw)}processAckMsg(n){this.telemetryLogger.logHandshakeCompleted(n),this.logger.info(`Ack received: ${JSON.stringify(n)}`),this.switchMcpFeature("dominantSpeakerHistoryEnabled",!(!this.mcpConfig.enableDominantSpeakerHistory||!n.send_capabilities?.includes("dsh"))),this.switchMcpFeature("sourceRequestsEnabled",!(!this.mcpConfig.enableSourceRequests||!n.receive_capabilities?.includes("sr"))),this.switchMcpFeature("sourceRequestsResponseEnabled",!(!this.mcpConfig.enableSourceRequests||!n.send_capabilities?.includes("sr_res"))),this.switchMcpFeature("senderSideBandwidthEstimationEnabled",!(!this.mcpConfig.enableSendBandwidthNotificationsEnabled||!n.receive_capabilities?.includes("ssbwe"))),this.logger.info(`Mcp handshake completed:
            Dominant speaker history: ${this.mcpSupportedFeatures.dominantSpeakerHistoryEnabled},
            Source requests: ${this.mcpSupportedFeatures.sourceRequestsEnabled},
            Source requests response: ${this.mcpSupportedFeatures.sourceRequestsResponseEnabled},
            Bandwidth estimation response: ${this.mcpSupportedFeatures.senderSideBandwidthEstimationEnabled}`),this.event("mcpHandshakeCompleted").raise(),clearTimeout(this.handshakeTimeout),this.handshakeTimeout=null,this.mcpState="Active"}},n0i=class{constructor(n,a,s){this.mediaControlPlane=n,this.sendSignalingMessage=a,this.logger=s,this.pendingSourceRequests=new Map,this.mediaControlPlane&&(this.diagnostics=this.mediaControlPlane.getTelemetryLogger().getSourceRequestSenderDiagnostics,this.mediaControlPlane.on("mpSrResReceived",(c,u)=>this.onMsgReceived(c,u)))}mapToSignalingOperation(n){switch(n){case"ApplyChannelParametersSourceRequest":case"ApplyChannelParametersVideoCapabilities":return 0;case"ControlVideoStreaming":return 1;default:return this.logger.error("Unknown send operation"),null}}send(n,a,s,c){switch(n){case"ApplyChannelParametersSourceRequest":return this.sendMcpMessage(n,a,s,c);case"ApplyChannelParametersVideoCapabilities":case"ControlVideoStreaming":return this.sendSignalingMessage?(this.diagnostics?.recordSignalingOperation(n),this.sendSignalingMessage(this.mapToSignalingOperation(n),a)):Promise.reject(new Error("no signaling session"));default:return this.logger.warn(`Unable to send message reason: Operation unknown ${n}`),Promise.reject(new Error("Unable to send message"))}}setResendingMechanism(n,a,s,c){const u=window.setTimeout(()=>{this.logger.warn(`Timed out message ${n}, sending message through signaling`),this.resendPendingMessageThroughSignaling(n,c)},this.mediaControlPlane?.getConfig().sourceRequestsMessagesTimeout);this.pendingSourceRequests.set(n,{sequenceNumber:n,timeoutId:u,deferred:a,message:s,operation:c})}isAllowedToSendMcpMessage(){if(!this.mediaControlPlane)return!1;const n=this.mediaControlPlane.getMcpState(),a=this.mediaControlPlane.getConfig();return n!=="Created"&&(n==="Handshaking"?a.sendBeforeAck&&a.enableSourceRequests:n==="Active"&&this.mediaControlPlane.mcpFeaturesSupported("sourceRequestsEnabled"))}isResendingMechanismRequired(n){return this.mediaControlPlane.getConfig().setResendingMechanism&&n==="ApplyChannelParametersSourceRequest"}async sendMcpMessage(n,a,s,c){if(this.isAllowedToSendMcpMessage()){const u=new Pi;this.isResendingMechanismRequired(n)&&this.setResendingMechanism(s,u,c,n);try{return this.diagnostics.recordMCPOperation(n,s,a.controlVideoStreaming?.controlInfo),await this.mediaControlPlane.sendMsg(a),this.logger.info(`Sending ${a.type} by MCP sequenceNumber:${s}`),this.isResendingMechanismRequired(n)?u.promise:Promise.resolve()}catch(m){const b=nn(m);this.diagnostics.recordError(b,s),this.logger.error(`sendMsgInternal failed with error: ${b}`),this.isResendingMechanismRequired(n)&&this.clearPendingSourceRequestTimeout(s)}}if(!this.sendSignalingMessage)throw new Error("no signaling session");return this.diagnostics?.recordSignalingOperation(n),this.logger.info(`Sending SR by signaling sequenceNumber:${s}`),this.sendSignalingMessage(this.mapToSignalingOperation(n),c)}async resendPendingMessageThroughSignaling(n,a){this.diagnostics.recordMCPMessageFallback(n,a);const s=this.pendingSourceRequests.get(n);try{this.diagnostics.recordSignalingOperation(s.operation),await this.sendSignalingMessage(this.mapToSignalingOperation(s.operation),s.message),s.deferred.resolve()}catch{this.logger.warn(`Failed to resend source request via signaling ${n}`),s.deferred.reject(new Error("Sending source request failed via signaling"))}finally{this.clearPendingSourceRequestTimeout(n)}}clearPendingSourceRequestTimeout(n){const a=this.pendingSourceRequests.get(n);a&&(this.pendingSourceRequests.delete(n),clearTimeout(a.timeoutId))}onMsgReceived(n,a){this.logger.info(`Received SR result: ${a} for sequenceNumber: ${n}`);const s=this.pendingSourceRequests.get(n);if(s){switch(this.diagnostics.recordSrResultReceived(a,n,s.operation),a){case"ok":case"duplicate":case"out_of_order":s.deferred.resolve();break;default:s.deferred.reject(`SequenceNumber: ${n} failed with ${a}!`)}this.clearPendingSourceRequestTimeout(n)}else this.logger.warn(`No pending SR found for sequenceNumber: ${n}`)}},a0i=0,r0i=class NQe{constructor(a,s,c){this.context=a,this.callId=s,this.callback=c,this.callbacks={},this.multiParty=this.context.config?.isConference,this.configProvider=this.context.configProvider,this.logger=this.context.getLogger().createChild("webrtc2-"+ ++a0i),this.videoFeatureManager=new Z_i(this.logger.createChild("VFM")),this.ufdManager=this.context.getUfdManager(),this.deviceManager=this.context.callDeviceManager.getDefaultDeviceManager(),this.capabilityGatherer=E$.build({global:this.context.maContext},this.configProvider.config.useSdpCapabilities,this.configProvider.config.noRequiredCodecsWorkaround),this.reinvitelessContext=s0i(this.context.config.reinvitelessConfig,this.multiParty),this.iceHostCandidateOnly=this.multiParty&&lw("iceHostCandidateOnly",this.context.config,this.configProvider.config),this.mediaManager=new gbi({logger:this.logger,configProvider:this.configProvider,numVideoChannels:this.multiParty&&this.configProvider.config.numVideoChannelsGvc||1,useSimulcast:this.multiParty,reinviteltessContext:this.reinvitelessContext}),this.receiveStreamCollection=new TJe({streamAdded:u=>this.streamAdded(u),streamRemoved:u=>this.streamRemoved(u)}),this.diagnostics=this.context.diagnostics,this.qmDiagnostics=this.diagnostics.newQualityManagerDiagnostics(),this.statsGatherer=new UJe(this.logger.createChild("stats"),this.configProvider,this.diagnostics,this.mediaManager,this.multiParty),this.networkQualityDiagnostics=new qEi(this.configProvider),this.speechDetectionDiagnostics=new KEi(this.configProvider),this.qualityManager=new ZJe(this.logger.createChild("qm"),{scalingEnabled:this.configProvider.config.webrtcVideoScaling,customBwEstimationEnabled:this.configProvider.config.webrtcEnabledCustomBwEstimationForVideo},this,this.statsGatherer,this.qmDiagnostics,this.configProvider),this.activeSpeakerManager=new bJe(this.callback.onContributingSourcesChanged,this.callback.onDominantSpeakerChanged,this.logger.createChild("ActiveSpeakerManager"),this.diagnostics.dshDiagnostics),this.wasConnected=!1,this.isAudioInputMuted=this.context.config.muted,this.isAudioOutputMuted=!1,this.relayCandidateGathered=!1,this.iceDisconnectedTimer=null,this.statisticsReport=Promise.resolve({type:"WebRtcMediaStats",data:{}}),this.terminated=!1,this.dtmfSender=iYe.build({logger:this.logger,configProvider:this.configProvider}),this.streamsChangedNotificationScheduled=!1,this.subscriptionManager=new SKe(this.logger.createChild("subs"),this.configProvider,{getStreams:()=>this.receiveStreamCollection.getStreams(),setOnStreamsChangedHandler:u=>this.streamsChangedListener=u},this.diagnostics.newSubscriptionManagerDiagnostics()),this.remoteVideoResolutionManager=new XJe(this.logger.createChild("rvrm"),this.multiParty,this.configProvider,this.mediaManager,this.statsGatherer,this.diagnostics),this.remoteVideoManager=new eYe(this.logger.createChild("RemoteVideoManager"),this.configProvider,this.statsGatherer,this.diagnostics,this.remoteVideoResolutionManager,this.context.maContext.domOverrides),this.encStreamsManager=new Dui(this.configProvider,this.context.maContext.getEncodedStreamsWorkerProvider?.(),this.logger.createChild("EncodedStreamsManager")),this.streamSendersManager=new xEi(this.mediaManager,this.logger.createChild("SSM"),this.context.callDeviceManager,this.configProvider,this.context.config,this.statsGatherer,this.diagnostics,this.qmDiagnostics,this.multiParty,this.encStreamsManager,this.videoFeatureManager),this.hwSilent=!1,this.deviceManagerSubs=[],this.isMuteHold=!1,this.rawIncomingAudioStreamManager=new Mdi(this.logger.createChild("rawIncomingAudioStream")),this.useNullAudioStream=!1,this.audioCodecManager=new Zui(this.encStreamsManager,this.logger,this.configProvider),this.perfMonitorSubs=[],this.performanceMonitor=new GEi(this.statsGatherer,this.diagnostics,this.configProvider,this.logger.createChild("PerformanceMonitor")),this.negotiation=new QEi(this.logger.createChild("negotiation"),this.configProvider,this.diagnostics.newNegotiationDiagnostics(this.statsGatherer.sessionInfo),this.reinvitelessContext,this.mediaManager,this.audioCodecManager,this.ufdManager,this.context,this.qualityManager,this.streamSendersManager,{onNegotiationRequired:(u,m)=>this.callbacks.onNegotiationRequired?.(u,m),onUpdateMediaDescriptionsRequired:(u,m)=>this.callbacks.onUpdateMediaDescriptionsRequired?.(u,m),updateLocalMediaSources:this.updateLocalMediaSources.bind(this),assurePC:this.assurePeerConnectionAsync.bind(this),hasPC:()=>!!this.peerConnection,createOffer:u=>this.peerConnection.createOffer(u),createAnswer:u=>this.peerConnection.createAnswer(u),setLocalDescription:u=>this.peerConnection.setLocalDescription(u),getLocalDescription:()=>this.peerConnection.localDescription,setRemoteDescription:u=>this.peerConnection.setRemoteDescription(u),setBWSeed:this.setBWSeed.bind(this),onTransportInitialized:()=>this.callbacks.onTransportInitialized(),startWaitingForStreamStart:u=>{this.statsGatherer.startWaitingForStreamStart(u)},getRollbackModifier:u=>new bCi(this.peerConnection,this.configProvider,u)}),this.streamConfigurationHandler=new nYe(this.logger,this.negotiation.negotiationEmulator,this.qualityManager,this.qmDiagnostics,this.configProvider,this.statsGatherer),this.pauseNegotiations=this.negotiation.pauseNegotiations.bind(this.negotiation),this.configureModalitiesAsync=this.negotiation.configureModalities.bind(this.negotiation),this.createOfferAsync=this.negotiation.createOffer.bind(this.negotiation),this.processOfferAsync=this.negotiation.processOffer.bind(this.negotiation),this.createAnswerAsync=this.negotiation.createAnswer.bind(this.negotiation),this.processAnswerAsync=this.negotiation.processAnswer.bind(this.negotiation),this.completeNegotiationAsync=this.negotiation.completeNegotiation.bind(this.negotiation),this.rejectNegotiationAsync=this.negotiation.rejectNegotiation.bind(this.negotiation),this.startMediaDescriptionsUpdateAsync=this.negotiation.startMediaDescriptionsUpdate.bind(this.negotiation),this.completeMediaDescriptionsUpdateAsync=this.negotiation.completeMediaDescriptionsUpdate.bind(this.negotiation),this.rejectMediaDescriptionsUpdateAsync=this.negotiation.rejectMediaDescriptionsUpdate.bind(this.negotiation),this.statsGatherer.on("onDiagnosticUpdated",u=>this.processStatsReport(u)),this.statsGatherer.on("onStatisticsChanged",u=>this.processLegacyStats(u)),this.remoteVideoResolutionManager.on("onNegotiationRequired",()=>this.negotiation.triggerRenegotiation(!0)),this.remoteVideoResolutionManager.on("onSourceRequestRequired",(u,m,b)=>this.requestSource(u,m,b)),this.setSubsForSubscriptionManager(),this.setSubsForStreamManagerEvents(),this.configProvider.mediaConfig.maxBandwidthInKbps&&(this.statsGatherer.setMaxSessionBandwidth(this.configProvider.mediaConfig.maxBandwidthInKbps),this.diagnostics.maxSessionBandwidth=this.configProvider.mediaConfig.maxBandwidthInKbps),this.createAudioRenderer(),this.setSubsForDeviceManager(),this.context.callDeviceManager.isVirtualDeviceEnabled&&this.setupCallDeviceManagerSubs(),this.configProvider.config.enableActiveSpeakerBasedDSH&&this.activeSpeakerManager.setStrategy(new zEi({configProvider:this.configProvider})),this.perfMonitorSubs.push(this.performanceMonitor.on("onIncomingVideoQualityChanged",(u,m)=>{this.onIncomingVideoQualityChanged(u,m)})),this.configProvider.config.webrtcVideoScaling&&(this.perfMonitorSubs.push(this.performanceMonitor.on("onOptimalVideoCountChanged",(u,m)=>{this.onOptimalVideoCountChanged(u,m)})),this.onOptimalVideoCountChanged(this.configProvider.config.nonEstimatedDefaultVideoReceiversCount)),this.configProvider.config.setBWSeed&&(this.bandwidthCache=new Lyi(this.configProvider)),this.diagnostics.reinvitelessContext=this.reinvitelessContext,this.multiParty&&this.configProvider.config.enableVideoFeatureManager&&this.videoFeatureManager.manageFeatureSupport(()=>{if(this.detectVideoFeatures(),this.configProvider.config.enableDevtoolsAPI){const u=window?.webMA;u?.initVideoFeatures&&u.initVideoFeatures(this.videoFeatureManager)}})}initializeMediaControlPlane(a){const s=this.dataChannel.getDataChannel(a);s?(this.mediaControlPlane=new i0i(s,this.logger.createChild("MediaControlPlane"),this.configProvider.config.mediaControlPlaneConfig),this.mediaControlPlane.on("mpSendBandwidthChanged",c=>{this.performanceMonitor.processNotification("BandwidthNotification",{bw:c}),this.bandwidthCache?.saveSeed(c),this.statsGatherer.addReportedReceiveBandwidth(c),this.diagnostics.addReportedReceiveBandwidth(c)}),this.mediaControlPlane.on("mcpHandshakeCompleted",()=>{this.callback.onUpdateSignalingDSHMessageSubscription(!this.mediaControlPlane.mcpFeaturesSupported("dominantSpeakerHistoryEnabled")),this.mediaControlPlane.mcpFeaturesSupported("dominantSpeakerHistoryEnabled")&&this.diagnostics.dshDiagnostics.setCurrentActiveStrategy("server"),this.mediaControlPlane.mcpFeaturesSupported("sourceRequestsEnabled")&&(this.subscriptionManager.mcpSourceRequestsAvailable(),this.notifyStreamsChanged()),this.mediaControlPlane.mcpFeaturesSupported("senderSideBandwidthEstimationEnabled")&&this.configProvider.config.specCompliantSimulcast.enableSimulcastLayoutControlStrategy&&this.videoFeatureManager.get("Video").toggleServer(0,!0)}),this.mediaControlPlane.on("onHandshakeTimeout",()=>{this.configProvider.config.enableSignalingDSHFallback&&this.callback.onUpdateSignalingDSHMessageSubscription(!0)}),this.mediaControlPlane.on("mpDshChanged",c=>{this.activeSpeakerManager.onDominantSpeakerHistoryChanged(c,"server")})):this.logger.safe.error(`[${a}] Unable to initialize MediaControlPlane due to datachannel creation failure`)}getMediaControlPlaneInstance(){return this.mediaControlPlane}getAcceptedTypes(){return this.negotiation.allowedMediaContentType}clone(a,s){const c=Xp(this.context);c.config=Xp(this.context.config),c.config.webrtcMediaContentType=this.negotiation.mediaContentType,c.config.webrtcAllowedMediaContentType=this.negotiation.allowedMediaContentType,c.configProvider=s,c.diagnostics=this.context.diagnostics?.newNativeSession(!1),a?(c.config.isConference=!0,c.config.isPstnCall=!1):(c.config.iceHostCandidateOnly=!1,this.configProvider.config.waitForRelayOnReconnect&&(c.config.webrtcIceGatheringTimeoutIncreased=!0));const u=new NQe(c,this.callId,this.callback);return this.useNullAudioStream&&u.useNullAudioStreamClient(),this.relayManagerProvider&&(u.relayManagerProvider=this.relayManagerProvider),u.callbacks.onNegotiationRequired=this.callbacks.onNegotiationRequired,u}async setCallConstraints(a,s){const c=this.configProvider.setCallConstraints(a);if(this.logger.safe.info(`[${s}] Setting call constraints ${JSON.stringify(c)}, enableDynamicCallConstraints: ${this.configProvider.config.enableDynamicCallConstraints}`),this.configProvider.config.enableDynamicCallConstraints)try{await this.streamSendersManager.applyCallConstraints(s),this.configProvider.addCallConstraintsTelemetryEvent(c,"applied")}catch(u){throw this.logger.safe.error(`Error while applying constraints: ${u}`),u}else this.configProvider.addCallConstraintsTelemetryEvent(c,"applied");return c}setInternals(a,s){this.logger.safe.info(`[${s}] Setting internals from previous session`),this.diagnostics.commitNativeSession(),a.subscriptionManager&&(this.subscriptionManager?.dispose(),this.subscriptionManager=a.subscriptionManager,this.subscriptionManager.setDiagnostics(this.diagnostics.newSubscriptionManagerDiagnostics()),this.subscriptionManager.setStreamProvider({getStreams:()=>this.receiveStreamCollection.getStreams(),setOnStreamsChangedHandler:c=>this.streamsChangedListener=c}),this.subscriptionManager.setLogger(this.logger.createChild("subs")),this.setSubsForSubscriptionManager(),this.subscriptionManager.reriseSubscribeEvents(),this.notifyStreamsChanged()),a.audioRenderer&&(a.audioRenderer.play(this.audioRenderer.getStream()),this.audioRenderer=a.audioRenderer),a.remoteVideoManager?.moveRenderers(this.remoteVideoManager),a.rawIncomingAudioStreamManager&&this.rawIncomingAudioStreamManager.updateHandlers(a.rawIncomingAudioStreamManager.handlerMap),this.audioRenderer.getStream()&&this.rawIncomingAudioStreamManager.streamChanged(this.audioRenderer.getStream())}setSubsForDeviceManager(){const a=this.getVideoDeviceManager();this.configProvider.config.enablePlayVideoOnStreamUnmuteWorkaround&&this.deviceManagerSubs.push(a.on("onAudioStreamMuted",s=>{s||(this.remoteVideoManager.playVideo(),a.getLocalVideoRenderers().forEach(c=>c.playVideo()))}))}setSubsForSubscriptionManager(){this.subscriptionManagerSubs=[this.subscriptionManager.on("onTrackIdsChanged",a=>this.statsGatherer.setSubscribedTrackIds(a)),this.subscriptionManager.on("onTrackSsrcChanged",a=>this.statsGatherer.setSubscribedTrackSsrc(a)),this.subscriptionManager.on("onSubscriptionChanged",(a,s,c,u,m,b)=>this.onSubscriptionChanged(a,s,c,u,m,b)),this.subscriptionManager.on("onSubscriptionFailed",(a,s,c,u,m)=>this.statsGatherer.addSubscriptionEvent(a,s,c,u,m))]}onSubscriptionChanged(a,s,c,u,m,b){s===ke.MODALITY.video&&(a===2&&this.diagnostics.addSubscriptionToOvcEvent(this.subscriptionManager.getSubscriptionsCount()),a===3&&this.diagnostics.addSubscriptionToOvcEvent(this.subscriptionManager.getSubscriptionsCount())),this.statsGatherer.addSubscriptionEvent(a,s,c,u,null,m,b)}setSubsForStreamManagerEvents(){this.streamSendersManager.on("onSendStreamChanged",(a,s)=>{this.statsGatherer.updateSendStream(a,s),a?.hasAudio()&&this.diagnostics.setAudioSendStream(a,s),this.diagnostics.setPresentationAudioOnScreenSharing(a,s)}),this.streamSendersManager.on("onVideoCaptureFreeze",a=>{this.transportStateProvider.isConnected&&!this.transportStateProvider.isWaitingAcceptProvisional&&this.ufdManager.signalEvent("VideoCaptureDeviceFreeze",a?"Bad":"Good","Video")}),this.streamSendersManager.on("onMaxVideoSendCapabilitiesChanged",(a,s)=>this.onMaxVideoSendCapabilitiesChanged(a,s)),this.streamSendersManager.on("onBandwidthAllocationChanged",a=>this.onSendBandwidthChanged(a))}move(a,s){this.logger.safe.info(`[${s}] moving to new session`),a.setInternals({subscriptionManager:this.subscriptionManager,audioRenderer:this.audioRenderer,remoteVideoManager:this.remoteVideoManager,rawIncomingAudioStreamManager:this.rawIncomingAudioStreamManager},s),a.muteHold(this.isMuteHold,s),this.isAudioInputMuted?a.muteInputAsync(s):a.unmuteInputAsync(s),this.isAudioOutputMuted?a.muteOutputAsync(s):a.unmuteOutputAsync(s),this.subscriptionManager=null,this.audioRenderer=null,this.rawIncomingAudioStreamManager=null,this.callbacks.onTerminated=null}setMute(a,s,c){this.logger.safe.info(`[${c}] call setMute for ${a} with mute state ${s}`),this.streamSendersManager.setMuted(a,s,c),this.processLegacyStats(this.statsGatherer.getLastStatistics())}getConfiguredModalities(){return this.negotiation.configuredModalities}getDisabledModalities(){return this.negotiation.disabledModalities}createAudioElement(a){this.configProvider.config.devices.setSinkImmediately&&this.audioRenderer.setOutputDevice(this.deviceManager.getOutputDeviceId()),this.audioRenderer.assureAudioElement(a)}useNullAudioStreamClient(){this.useNullAudioStream=!0,this.streamSendersManager.useNullAudioStreamClient()}createRemoteRenderer(a){return this.remoteVideoManager.createRenderer(a,this.subscriptionManager,this.logger)}getStatsAsync(a){if(this.statsGatherer&&!this.statsGatherer.isDisposed){if(this.audioCodecManager){const s=this.audioCodecManager.getSessionEvents();this.statsGatherer.sessionInfo.setAudioCodecEvents(s),this.diagnostics.audioCodecEvents=s}this.statisticsReport=this.statisticsReport.then(()=>this.statsGatherer.getReport(a)).catch(s=>(this.logger.safe.error(`getting statistics should never fail: ${s.error}`),s.partialReport))}return this.statisticsReport}getLastKnownStats(a){return this.statsGatherer.getReport(!1,a)}muteHold(a,s){this.logger.safe.info(`[${s}] set muteHold state ${a}`),this.isMuteHold=a;const c=[ke.MODALITY.audio,ke.MODALITY.video,ke.MODALITY.sharing].filter(u=>Ur(this.negotiation.negotiatedModalities[u])&&(u!==ke.MODALITY.audio||!this.isAudioInputMuted));for(const u of c)this.setMute(kN(u),a,s)}async muteInputAsync(a){this.isAudioInputMuted=!0,this.setMute("Audio",!0,a)}async unmuteInputAsync(a){this.isAudioInputMuted=!1,this.setMute("Audio",!1,a)}async muteOutputAsync(a){return this.isAudioOutputMuted=!0,this.audioCodecManager.decoder?.disableStreamsMixer(!0),this.audioRenderer?.setMuted(!0,a)}async unmuteOutputAsync(a){return this.isAudioOutputMuted=!1,this.audioCodecManager.decoder?.disableStreamsMixer(!1),this.audioRenderer?.setMuted(!1,a)}async getSpeakerVolume(a){return this.audioRenderer?.getSpeakerVolume(a)||0}async setSpeakerVolume(a,s){return this.audioRenderer?.setSpeakerVolume(a,s)}sendDtmf(a){return this.dtmfSender.sendDtmf(this.peerConnection,a)}canSendDtmf(){return this.dtmfSender.canSendDtmf(this.peerConnection)}onDeviceEvent(a){this.statsGatherer.onDeviceEvent(a)}deviceSelectionChanged(){this.peerConnection&&this.audioRenderer?.getStream()&&this.audioRenderer.setOutputDevice(this.deviceManager.getOutputDeviceId())}async terminate(a,s,c=!0){this.logger.safe.info(`[${a}] terminate`),this.statsGatherer.setTerminated(),this.diagnostics.terminate(),this.perfMonitorSubs.forEach(u=>u?.dispose()),this.performanceMonitor.dispose(),this.terminated=!0,this.negotiation.terminate(a),await this.audioCodecManager.decoder?.storeApiRecording(),this.rawIncomingAudioStreamManager?.dispose(),this.remoteVideoManager.dispose(),this.dataChannel&&(this.dataChannel.dispose(),this.dataChannel=null),this.logger.safe.info(`[${a}] reset peer connection`),this.contributingSources?.dispose(),this.activeSpeakerManager.dispose(),this.qualityManager?.dispose(),this.qualityManager=null,this.audioRenderer?.dispose(),this.dtmfSender?.dispose(),this.dtmfSender=null,this.streamSendersManager?.dispose(),this.streamSendersManager=null,this.transceiverManager=null,this.encStreamsManager.dispose(),this.receiveStreamCollection.clear(),this.transportStateProvider?.dispose(),this.transportStateProvider=null,this.audioCodecManager.dispose(),this.mediaManager.reset(),this.mediaControlPlane?.dispose(),this.peerConnection?.close(),this.peerConnection=null,this.negotiation.negotiationEmulator.configure(null),this.peerConnectionPromise=null,this.subscriptionManagerSubs.forEach(u=>u.dispose()),this.subscriptionManager&&this.subscriptionManager.dispose(),this.deviceManagerSubs.forEach(u=>u.dispose()),this.callDeviceManagerSub?.dispose(),this.clearIceDisconnectedTimer(),this.callbacks.onTerminated&&this.callbacks.onTerminated();try{c&&await this.getStatsAsync(!1)}catch(u){this.logger.safe.error(`[${a}] Error while gathering stats ${nn(u)}`)}finally{this.statsGatherer.dispose()}}getIncomingRawAudioStream(a){this.logger.info("IRawStream for incoming audio stream requested");const s=this.audioRenderer.getStream();return this.rawIncomingAudioStreamManager.createIRawStreamClient(s,a)}getUnmixedAudioProvider(){return this.audioCodecManager.decoder?.getUnmixedAudioProvider()}configureSpatialAudio(a,s){this.configProvider.mediaConfig.spatialAudioEnabled=a,this.audioCodecManager.configureSpatialAudio(a,s)||this.ufdManager.signalEvent("SpatialAudioMUCHUnavailable","Bad","Audio",!0,s)}setParticipantSpatialAudioPositions(a,s){if(!this.audioCodecManager?.decoder||!this.getUnmixedAudioProvider()?.configured)throw this.logger.safe.error(`[${s}] setParticipantSpatialAudioPositions is called while MUCH audio decoder is not created or not enabled`),"setParticipantSpatialAudioPositions not allowed";this.audioCodecManager.decoder?.setParticipantSpatialAudioPositions(a)}processNotification(a,s){a==="McpSourceRequestsAvailable"&&(this.subscriptionManager.mcpSourceRequestsAvailable(),this.notifyStreamsChanged()),a==="DominantSpeakerInfo"&&this.activeSpeakerManager.onDominantSpeakerHistoryChanged(s.previousDominantSpeakerHistory,"signaling"),a==="ControlVideoStreaming"&&this.streamConfigurationHandler.handleMessage(s),this.performanceMonitor.processNotification(a,s)}processStatsReport(a){try{if(this.remoteVideoManager.processStatsReport(a),this.configProvider.config.diagnostics.features.useNewNetworkUFD){this.networkQualityDiagnostics.processReport(a);const s=this.networkQualityDiagnostics.getInboundNetworkQuality();this.ufdManager.signalEvent("NetworkRecvQuality",s);const c=this.networkQualityDiagnostics.getOutboundNetworkQuality();this.ufdManager.signalEvent("NetworkSendQuality",this.isAudioInputMuted?"Good":c)}this.ufdManager.signalEvent("DeviceSpeakWhileMuted",this.speechDetectionDiagnostics.processReport(a)?"Bad":"Good"),this.streamSendersManager.onDiagnosticUpdated(a);for(const s of this.getVideoDeviceManager().getLocalVideoRenderers())s.onDiagnosticUpdated(a)}catch(s){this.logger.error("Failed to processes diagnostics update: "+s)}}processLegacyStats(a){a&&(this.remoteVideoManager.processLegacyStats(a),this.hwSilent!==a.audioHwSilent&&(this.hwSilent=a.audioHwSilent,this.callbacks.onAudioHwSilentChanged&&this.callbacks.onAudioHwSilentChanged(this.hwSilent)),this.configProvider.config.diagnostics.features.useNewNetworkUFD||(this.ufdManager.signalEvent("NetworkRecvQuality",a.networkRecvLevel.quality,void 0,void 0,void 0,void 0,{recvQualityData:a.networkRecvLevel}),this.ufdManager.signalEvent("NetworkSendQuality",this.isAudioInputMuted?"Good":a.networkSendLevel.quality,void 0,void 0,void 0,void 0,{sendQualityData:a.networkSendLevel})),this.streamSendersManager.onStatisticsChanged(a))}assurePeerConnectionAsync(a,s){return this.peerConnectionPromise??(this.peerConnectionPromise=this.getPeerConnectionPromise(a,s)),this.peerConnectionPromise}async getPeerConnectionPromise(a,s){if(!this.relayManagerProvider)throw new Error("relay manager provider is not set!");this.logger.safe.info(`[${a}] fetching relay details from RelayManager...`);const c={relayType:"turn",isRemoteClientLync:this.context.config.isRemoteClientLync};s.mark("startQueryRelaysAsync");const u=await this.relayManagerProvider.getRelayManager().queryRelaysAsync(c);if(s.markAndMeasure("startQueryRelaysAsync","queryRelaysAsync"),this.terminated)throw new Error("session already disposed");const m={optional:[]},b=fJe(u,this.configProvider.config),_=this.negotiation.configureCrypto(m,this.context.config.isPstnCall);this.configureCpuThreshold(m),this.logger.safe.info("create peer connection");const k="unified-plan",N=this.context.configProvider.mediaConfig.isTransportUnbundled?"balanced":"max-bundle";try{this.peerConnection=new Cc.window.RTCPeerConnection({iceServers:b,rtcpMuxPolicy:"require",iceTransportPolicy:this.configProvider.getIceTransportPolicy(),iceCandidatePoolSize:this.configProvider.config.iceCandidatePoolSize,bundlePolicy:N,sdpSemantics:k,audioPortRange:this.configProvider.mediaConfig.audioPortRange,videoPortRange:this.configProvider.mediaConfig.videoPortRange,enableDtlsSrtp:_===1,encodedInsertableStreams:!!this.configProvider.config.useInsertableStreams},m)}catch(de){throw de.code===DOMException.INVALID_STATE_ERR&&this.ufdManager.signalEvent("NoNetwork","Bad"),de}const W=this.peerConnection;this.negotiation.rollbackSupported=_===1&&this.context.configProvider.userAgentConfig.isBrowserRollbackSupported,this.negotiation.negotiationEmulator.configure(W),this.statsGatherer.initialize(W),this.statsGatherer.sessionInfo.setIceServers(b),this.statsGatherer.sessionInfo.setIceTransportPolicy(this.configProvider.getIceTransportPolicy()),this.statsGatherer.sessionInfo.setSdpSemantics(k),this.statsGatherer.sessionInfo.setBundlePolicy(N),this.diagnostics.iceServers=b,this.diagnostics.iceTransportPolicy=this.configProvider.getIceTransportPolicy(),this.diagnostics.sdpSemantics=k,this.diagnostics.bundlePolicy=N,await this.checkVideoCodecsSupport(),s.markAndMeasure("queryRelaysAsync","checkVideoCodecsSupport"),W.onnegotiationneeded=()=>{this.logger.safe.info(`onnegotiationneeded signalingState: ${W.signalingState}`)},W.onicecandidateerror=de=>{const se=de,[Re,ue]=[se.address,se.port];if(this.logger.safe.warn(`On ICE candidate error ${se.url} | ${Re}:${ue}: code ${se.errorCode}: ${se.errorText}`),!this.transportStateProvider.isConnected||this.negotiation.iceCandidatesDefer.isPending){const Ne={address:Re,port:+ue,url:se.url,errorCode:se.errorCode,errorText:se.errorText};this.statsGatherer.addIceCandidateError(Ne),this.diagnostics.addIceCandidateError(Ne)}},W.onaddstream=de=>{this.logger.safe.info(`onaddstream stream: ${de.stream.id}`)};const ee=(de,se,Re,ue)=>{this.logger.safe.info(`ontrack processing ${de.kind}: ${se.id}`);let Ne=se.active;if(!se.active&&this.configProvider.config.useInactiveAudioTrack&&de.kind==="audio"&&(this.logger.safe.warn("ontrack override forcing to use inactive audio stream"),Ne=!0),!Ne||ue?.currentDirection==="stopped"||ue?.stopped)return void this.logger.safe.info("ontrack ignore non active stream");let ze=this.mediaManager.getMediaEntityByRemoteStreamId(se.id);if(ze||(this.logger.safe.info(`cannot find media entity with stream id ${se.id} trying to fallback`),se.getAudioTracks()[0]&&(ze=this.mediaManager.getMediaEntitiesByModality(ke.MODALITY.audio)[0])),ze){const He=this.createReceiveStream(se,Re,de,ze);ze.setRemoteTrackId(de.id),this.addReceiveStreamTransforms(Re,ze.getModality()),this.receiveStreamCollection.add(He)}else this.logger.safe.error(`could not find media entity for an added stream: ${se.id}`)};W.ontrack=de=>{const{track:se,receiver:Re,transceiver:ue}=de,Ne=de.streams[0]??new MediaStream([se]),ze=()=>ee(se,Ne,Re,ue);if((!this.configProvider.config.addAudioStreamBeforeConnection||ke.TRACK_KIND.audio!==se.kind)&&!this.transportStateProvider.isConnected||this.transportStateProvider.isWaitingAcceptProvisional)return this.logger.safe.info(`ontrack queueing to be run once connected ${se.kind}: ${Ne.id}`),void this.transportStateProvider.doOnConnected(ze,"ontrack",!1);ze()},W.onremovestream=de=>{this.logger.safe.info(`onremovestream ${de.stream.id}`),this.transportStateProvider.doOnConnected(()=>this.receiveStreamCollection.remove(de.stream.id),"onremovestream")},W.onicecandidate=de=>{const se=de.candidate;if(se){const Ne=tie(se.candidate);if(this.logger.safe.info(`[${a}] onicecandidate candidate: component:${Ne.component} protocol:${Ne.protocol} prio:${Ne.priority} type:${Ne.type} port:${Ne.port}`),this.logger.unsafe.info(`[${a}] candidate details: ${se.candidate}`),Ne.component!=="1")return;if(this.negotiation.iceCandidateReceived=!0,this.statsGatherer.sessionInfo.setCandidateDetails(Ne),this.diagnostics.setCandidateDetails(Ne),!this.relayCandidateGathered&&se.candidate.indexOf("typ relay")>-1){const ze={priority:se.priority?.toString()||Ne.priority,time:Date.now()-this.negotiation.iceRelayGatheringStartTime};this.statsGatherer.sessionInfo.setRelayCandidateInfo(ze),this.diagnostics.relayCandidateInfo=ze,this.relayCandidateGathered=!0}}else this.logger.safe.info(`[${a}] onicecandidate candidate: null`);if(!this.negotiation.iceCandidatesDefer.isPending)return;const Re=!this.context.config.webrtcIceGatheringTimeoutIncreased||this.configProvider.config.emptyIceCandidateMarksGatheredAnswerer&&!this.negotiation.initiator,ue=this.iceHostCandidateOnly||b.length===0;if(!se&&Re||ue){se&&this.logger.safe.info(`[${a}] Not waiting for ICE candidates, hoping that host/prflx is enough`),this.logger.safe.info(`[${a}] Is connected:`,this.transportStateProvider.isConnected,this.transportStateProvider.iceConnectionState,this.transportStateProvider.signalingState);let Ne=!0;this.context.configProvider.mediaConfig.isTransportUnbundled&&se&&(Ne=this.negotiation.sessionDescription.createLocalOffer(W.localDescription.sdp).hasUnbundledIceCandidates()),Ne&&this.completeCandidateGathering(a)}else if(this.relayCandidateGathered){let Ne=!0;this.context.configProvider.mediaConfig.isTransportUnbundled&&(Ne=this.negotiation.sessionDescription.createLocalOffer(W.localDescription.sdp).hasUnbundledRelayIceCandidates()),Ne&&(this.statsGatherer.clearIceCandidateErrors(),this.diagnostics.clearIceCandidateErrors(),this.completeCandidateGathering(a))}},W.onicegatheringstatechange=()=>{this.logger.safe.info(`onicegatheringstatechange iceGatheringState: ${W.iceGatheringState}`)},this.transportStateProvider=new Q_i(W,_,this.logger.createChild("TransportStateProvider"),this.configProvider,this.diagnostics.newTransportStateDiagnostics()),this.transportStateProvider.on("stateChanged",(de,se,Re)=>{if(this.terminated)return;const ue=this.wasConnected?Re:a;if(this.statsGatherer.sessionInfo.setIceConnectionState(de),de==="connecting"&&s.mark("transportConnecting"),de==="connected"||de==="completed")s.markAndMeasure("transportConnecting","transportConnected"),this.onTransportConnected(ue);else if(de==="failed"||de==="closed"&&se!=="failed"){if(this.negotiation.iceCandidatesDefer.isPending)return this.logger.safe.info(`[${ue}] ice failed while gathering candidates, suppressing error`),void this.completeCandidateGathering(ue);this.raiseError({type:ke.MEDIA_ERROR.iceConnectionError,detail:"ice transport failed"},ue),this.configProvider.config.webrtcCloseAfterIceFailure&&W.close(),this.callbacks.onTransportFailed?.()}de==="disconnected"?(this.callbacks.onTransportDisconnected?.(a),this.startIceDisconnectedTimer(ue)):this.clearIceDisconnectedTimer()}),this.transportStateProvider.on("signalingStateChanged",(de,se,Re)=>{this.configProvider.config.reconnectOnPcClose&&!this.terminated&&de==="closed"&&this.transportStateProvider.isTransportConnected&&this.raiseError({type:ke.MEDIA_ERROR.unexpectedClose,detail:"PeerConnection is closed"},Re),se==="have-remote-pranswer"&&de==="stable"&&this.configProvider.config.webrtcPranswerWaitFinalAnswer&&this.transportStateProvider.isTransportConnected&&(this.logger.safe.info(`[${Re}] remote final answer, activating audio`),this.callbacks.onAudioStateChanged?.(ke.STREAMING_STATE.active,a))}),this.transceiverManager=new Mui(this.logger,this.peerConnection,this.mediaManager,this.context,this.reinvitelessContext),this.streamSendersManager.registerRtpSenderManager(this.transceiverManager),z2(this.context)&&!this.dataChannel&&(this.dataChannel=new Gdi(this.peerConnection,this.diagnostics,this.logger,this.configProvider),this.callback.onDataChannelUpdated?.(this.dataChannel),this.multiParty&&this.initializeMediaControlPlane(a)),this.sourceRequestSender=new n0i(this.mediaControlPlane,this.context.sendWebRtcMediaNotificationAsyncCallback,this.logger.createChild("SourceRequestSender")),this.mediaMessageController=new oYe(this.logger.createChild("SourceRequester"),this.configProvider,this.sourceRequestSender,this.mediaControlPlane),this.negotiation.setInternals(this.transceiverManager,this.transportStateProvider,this.dataChannel),this.multiParty&&(this.contributingSources=new WJe(this.logger.createChild("ContributingSources"),this.configProvider,this.activeSpeakerManager,new KJe(this.logger.createChild("ContributingSourcesProvider"),W,this.configProvider.config.diagnostics.features.logContributingSourcesError,this.diagnostics))),s.mark("startInitialize"),await this.encStreamsManager.initialize(),s.markAndMeasure("startInitialize","encStreamsManagerInitialize");const oe=this.encStreamsManager.isWorkerLoaded();this.initAudioCodec(oe),this.statsGatherer.sessionInfo.setEncodedStreamWorkerLoaded(oe),this.diagnostics.encodedStreamWorker=oe}configureCpuThreshold(a){this.configProvider.config.webrtcNativeCpuOveruseDisabled&&this.multiParty&&a.optional.push({googCpuOveruseDetection:!1})}completeCandidateGathering(a){this.negotiation.iceCandidatesDefer.isPending&&(this.logger.safe.info(`[${a}] ICE candidates gathered completely`),this.negotiation.iceCandidatesDefer.resolve())}detectVideoFeatures(){const a=this.videoFeatureManager.get("Video"),s=this.configProvider.config.specCompliantSimulcast;if(s?.enableSimulcastLayoutControlStrategy&&s?.video?.layerScaleFactors?.length>2&&a.toggleClient(0,!0),this.context.config.isTownHall){const m=this.configProvider.config.broadcastMode;(m?.prioritizeLayoutOnServer||m?.prioritizeLayoutOnClient)&&a.toggleClient(3,!0),m?.maxSessionBandwidthKbps&&(this.statsGatherer.setMaxSessionBandwidth(this.configProvider.mediaConfig.maxBandwidthInKbps),this.diagnostics.maxSessionBandwidth=this.configProvider.mediaConfig.maxBandwidthInKbps)}const c=this.mediaManager.getMediaEntitiesByModality("video"),u=this.configProvider.config.preferredH264VideoSendProfile;u?.startsWith("64")&&c.length>0&&c[0].isSendProfileSupported("H264",u)&&a.toggleClient(1,!0)}onTransportConnected(a){if(this.statsGatherer.clearIceCandidateErrors(),this.diagnostics.clearIceCandidateErrors(),!this.terminated){if(this.transportStateProvider.isWaitingAcceptProvisional)return this.logger.safe.info(`[${a}] transport connected provisional`),this.configProvider.config.createProvisionalAnswer.audioState&&this.callbacks.onAudioStateChanged?.(this.configProvider.config.createProvisionalAnswer.audioState,a),void(this.configProvider.config.createProvisionalAnswer.connectTransport&&this.callbacks.onTransportConnected?.(a));this.logger.safe.info(`[${a}] audio transport connected`),this.wasConnected=!0,this.configProvider.config.webrtcPranswerWaitForMediaPollingInterval&&this.transportStateProvider.signalingState==="have-remote-pranswer"?this.handleEarlyMediaAudioState(a):this.callbacks.onAudioStateChanged?.(ke.STREAMING_STATE.active,a),this.multiParty&&this.configProvider.config.enableVideoFeatureManager&&(this.videoFeatureManager.manageFeatureSupport(()=>{this.detectVideoFeatures()}),this.configProvider.config.maxSendVideoCapabilities.enableForVideoV2&&this.videoFeatureManager.on("onVideoFeaturesChanged",s=>{if(s.mediaType==="Video"&&this.configProvider.config.maxSendVideoCapabilities.enableForVideoV2){const c=this.mediaManager.getMediaEntitiesByModality("video");c.length>0&&this.mediaMessageController.sendMaxVideoSendCapabilitiesV2(c[0],s)}})),this.callbacks.onTransportConnected?.(a)}}async getAudioSenderStats(a=.5){const s=this.peerConnection?.getSenders().filter(c=>c.track?.kind==="audio")[0];if(!s)return Promise.resolve(void 0);try{const c=zn(1e3*a,"Unable to get audio receiver stats report");s.getStats().then(c.resolve,c.reject);const u=await c.promise;for(const m of u.values())if(m.type==="outbound-rtp")return Promise.resolve(m)}catch(c){return this.logger.safe.error(`Error getting audio sender stats: ${nn(c)}`),Promise.resolve(void 0)}return Promise.resolve(void 0)}handleEarlyMediaAudioState(a){const s=this.peerConnection.getReceivers().filter(b=>b.track.kind==="audio")[0];if(!s)return this.logger.safe.warn(`[${a}] Connected transport with provisional answer with no audio receiver`),void this.callbacks.onAudioStateChanged?.(ke.STREAMING_STATE.active,a);this.callbacks.onAudioStateChanged?.(ke.STREAMING_STATE.started,a);const c=this.configProvider.config.webrtcPranswerMediaPollingTimeout,u=this.configProvider.config.webrtcPranswerWaitForMediaPollingInterval;this.logger.safe.info(`[${a}] Starting polling for early media audio stats`);const m=async()=>{try{if(!this.canPollAudioStats())return;let b;this.logger.safe.debug(`[${a}] Polling audio receiver stats to detect early media start`);const _=zn(c,"Unable to get audio receiver stats report");s.getStats().then(_.resolve,_.reject);const k=await _.promise;this.diagnostics.registerEarlyMediaPoll();for(const N of k.values())if(N.type==="inbound-rtp"){b=N;break}if(!this.canPollAudioStats())return void this.logger.safe.info(`[${a}] Finished polling early media audio stats, terminated: ${!this.terminated}`);if((this.configProvider.config.webrtcPranswerCheckAudioEnergy?b?.totalAudioEnergy:b?.bytesReceived)>this.configProvider.config.webrtcPranswerAudioThreshold)return this.logger.safe.info(`[${a}] Finished polling early media audio stats, activating audio`),void this.callbacks.onAudioStateChanged?.(ke.STREAMING_STATE.active,a);this.logger.safe.info(`[${a}] No audio data received yet, polling again in ${u}ms`),setTimeout(m,u)}catch(b){const _=nn(b);if(this.logger.safe.error(`[${a}] Error polling stats for pranswer: ${_}. Will stop polling: ${this.configProvider.config.webrtcPranswerStopPollingAfterError}`),this.diagnostics.addStatsError("WebrtcSession::earlyMediaPolling",_),this.configProvider.config.webrtcPranswerStopPollingAfterError)return void this.callbacks.onAudioStateChanged?.(ke.STREAMING_STATE.active,a);setTimeout(m,u)}};setTimeout(m,this.configProvider.config.webrtcPranswerWaitIntervalBeforePolling)}canPollAudioStats(){return!this.terminated&&this.transportStateProvider.signalingState==="have-remote-pranswer"}startIceDisconnectedTimer(a){this.configProvider.config.iceDisconnectedTimeoutMs&&(this.iceDisconnectedTimer=setTimeout(()=>{this.logger.safe.error(`[${a}] ice disconnected for ${this.configProvider.config.iceDisconnectedTimeoutMs}ms. Raise ${ke.MEDIA_ERROR.iceConnectionError}`),this.raiseError({type:ke.MEDIA_ERROR.iceConnectionError,detail:"ice transport disconnected"},a)},this.configProvider.config.iceDisconnectedTimeoutMs))}clearIceDisconnectedTimer(){this.iceDisconnectedTimer&&(clearTimeout(this.iceDisconnectedTimer),this.iceDisconnectedTimer=null)}raiseError(a,s=hi()){this.logger.safe.error(`[${s}] Media error occurred type: ${a.type} detail: ${a.detail}`),this.callbacks.onSessionErrorOccurred&&this.callbacks.onSessionErrorOccurred(a,s)}notifyStreamsChanged(){this.streamsChangedNotificationScheduled||(this.logger.safe.info("Scheduling NotifyStreamsChanged"),this.streamsChangedNotificationScheduled=!0,this.negotiation.negotiationCompletedPromise.promise.catch(()=>{}).then(()=>{this.streamsChangedNotificationScheduled=!1,this.logger.safe.info("Executing NotifyStreamsChanged callback"),this.streamsChangedListener?.()}))}async streamAdded(a){if(ke.MODALITY.audio===a.getModality()&&(this.webrtcAudioRecvStream=a.getMediaStream(),await this.audioRenderer.setOutputDevice(this.deviceManager.getOutputDeviceId()),await this.updateAudioRendererStream(this.webrtcAudioRecvStream)),this.configProvider.config.mapSsrcToTrackForStats){const s=this.mediaManager.getMediaEntityByRemoteStreamId(a.getMediaStream().id);this.statsGatherer.setSsrcTrackPair(s.getRemoteSsrc(),s.getRemoteTrackId())}this.notifyStreamsChanged()}async updateAudioRendererStream(a){await this.audioRenderer.play(a),this.rawIncomingAudioStreamManager.streamChanged(a)}streamRemoved(a){ke.MODALITY.audio===a.getModality()?(this.audioRenderer.getStream()===a.getMediaStream()&&(this.audioRenderer.stop(),this.rawIncomingAudioStreamManager.streamChanged(null)),this.webrtcAudioRecvStream=null):ke.MODALITY.video===a.getModality()&&this.mediaManager.getMediaEntityByRemoteStreamId(a.getMediaStream().id)?.getLocalRecvCapabilities()?.resetToInitial(),this.clearReceiveStreamTransforms(a.getReceiver()),a.dispose(),this.notifyStreamsChanged()}hasRelayCandidates(){return this.relayCandidateGathered}createReceiveStream(a,s,c,u){const m=this.configProvider.config.addFmtpToInitialSubscription?u.getLocalRecvCapabilities():null,b=this.configProvider.config.useMultiviewLimitsOnInitialRequest&&u.getModality()!==ke.MODALITY.sharing?()=>this.remoteVideoManager.getMaxAllowedVideoFS():null,_=new yKe(a,s,u.getModality(),+u.getXSourceStreamId(),this,m,b,u.getSubstreamIndex());return new FEi(_,c,this.receiveStreamCollection,this.logger.createChild("RecvStream"),this.configProvider.config)}async requestSource(a,s,c){if(!this.multiParty)return;const u=this.mediaManager.getMediaEntityByRemoteStreamId(a);if((this.isMuteHold||this.negotiation.negotiatedModalities[u.getModality()]===ke.MEDIA_STATE.inactive)&&s!==-1)return await Br(10),this.requestSource(a,s,c);if(this.negotiation.negotiationCompletedPromise.isPending)try{await this.negotiation.negotiationCompletedPromise.promise}catch(m){this.logger.safe.info("source request should be sent even if negotiation rejected",m)}if(!this.transportStateProvider.isConnected||this.transportStateProvider.isWaitingAcceptProvisional){this.logger.safe.info("requestSource is postponed till transport is connected");const m=new Pi;this.transportStateProvider.doOnConnected(()=>m.resolve(),"requestSource"),await m.promise}return this.mediaMessageController.sendSourceRequest(u.getXSourceStreamId(),s,u?.getMid(),c,u.getSubstreamIndex())}async onReceiveCapabilitiesChanged(a,s,c){if(!this.streamSendersManager)return!1;try{return await this.streamSendersManager.applyCapabilities(s,a,c),!0}catch{return!1}}onOptimalVideoCountChanged(a,s){this.callback.onOptimalVideoReceiversCountChanged&&this.callback.onOptimalVideoReceiversCountChanged(a),this.diagnostics.addOvcSubscriptionReport(a,this.subscriptionManager?.getSubscriptionsCount(),s)}async onSendBandwidthChanged(a){if(!this.transportStateProvider.isConnected||this.transportStateProvider.isWaitingAcceptProvisional||!this.mediaControlPlane.mcpFeaturesSupported("senderSideBandwidthEstimationEnabled"))return;const s=[],c=Object.keys(a);for(const u of c){const m=this.mediaManager.getMediaEntitiesByModality(KR(u)).filter(b=>b.isEnabled()&&b.getLocalTrackId()!==null);if(m.length===0||a[u]===0)return;s.push({streamMsid:m[0].getXSourceStreamId(),bw:a[u]})}await this.mediaMessageController.sendBandwidthInfo(s),this.diagnostics.reportedSendBandwidthLayouts(a)}onMaxVideoSendCapabilitiesChanged(a,s){(a==="Video"&&this.configProvider.config.maxSendVideoCapabilities.enableForVideo||a==="ScreenShare"&&this.configProvider.config.maxSendVideoCapabilities.enableForSharing)&&this.transportStateProvider.doOnConnected(()=>this.notifyMaxVideoCapabilitiesChanged(a,s),"maxCapabilities")}notifyMaxVideoCapabilitiesChanged(a,s){const c=KR(a),u=this.mediaManager.getMediaEntitiesByModality(c)[0];if(!u)return;const m=u.getMid();a==="Video"&&this.configProvider.config.maxSendVideoCapabilities.enableForVideoV2?this.mediaMessageController.sendMaxVideoSendCapabilitiesV2(u,this.videoFeatureManager.get("Video"),s):this.mediaMessageController.sendMaxVideoSendCapabilities([m],s)}createAudioRenderer(){this.audioRenderer=new hTe(this.logger.createChild("AudioRenderer"),this.configProvider,this.diagnostics.newAudioRendererDiagnostics()),this.ufdManager.signalDeviceEvent(1,"Good","Audio"),this.context.maContext.domOverrides.onMediaElementAdded&&this.audioRenderer.on("onAudioElementAdded",this.context.maContext.domOverrides.onMediaElementAdded),this.context.maContext.domOverrides.onMediaElementRemoved&&this.audioRenderer.on("onAudioElementRemoved",this.context.maContext.domOverrides.onMediaElementRemoved),this.audioRenderer.on("onAudioPlaybackError",(a,s,c)=>this.onAudioPlaybackError(a,s,c)),this.audioRenderer.on("onAudioStateChanged",(a,s)=>this.deviceManager.effectsManager.setAecRefStream(a,s))}onAudioPlaybackError(a,s,c){const u={type:s,detail:c,isAudio:!0};this.ufdManager.signalDeviceEvent(1,"Bad","Audio"),this.deviceManager.raiseTelemetryEvent("reconnect_on_audio_playback_error",{error:a,mediaError:s,message:c}),this.context.reconnectRetry&&this.configProvider.config.audioRendererFailedRetryCodes?.includes(a)&&(this.logger.warn(`Reconnect required, attempt No: ${this.context.reconnectRetry}`),this.context.reconnectRetry--,this.raiseError(u))}getSessionConfig(){return this.configProvider}getLocalMediaTrackId(a){const s=this.mediaManager.getLocalTracksInfo(),c=KR(a),u=s.find(m=>m.modality===c);return u?u.trackId:null}addReceiveStreamTransforms(a,s){const c=this.encStreamsManager.initTransformsCollection(a,"Receiver",kN(s));c&&s!==ke.MODALITY.audio&&this.configProvider.config.useInsertableStreams?.videoStreamAnalyzer&&c.addTransform(new L7e(this.logger.createChild(`RecvStreamAnalyzer [${s}/${a.track.id}]`)))}clearReceiveStreamTransforms(a){this.encStreamsManager.clearTransformsCollection(a)}async checkVideoCodecsSupport(){try{const a=await this.capabilityGatherer.getCapabilities("video");this.statsGatherer.setH264AvailableProfiles(a);const s=E$.build({global:this.context.maContext},this.configProvider.config.useSdpCapabilities,this.configProvider.config.noRequiredCodecsWorkaround,!0),c=await s.getCapabilities("video"),u=E$.build({global:this.context.maContext},!1),m=await u.getCapabilities("video");this.statsGatherer.setSupportedH264Profiles(c,m);const b=await yp.isCodecsSupported(this.configProvider.config.hevcCodecs);this.diagnostics.videoCapabilities=a,this.diagnostics.setSupportedH264Profiles(c,m),this.diagnostics.isCodecsSupported=b;const _=new Set(a?.codecs?.map(k=>k.mimeType.toLocaleLowerCase())||[]);for(const k of this.configProvider.config.requiredVideoCodecs)if(!_.has(k)){this.ufdManager.signalEvent("NoRequiredVideoCodecs","Bad","Video");break}}catch(a){this.logger.safe.error(`failed to get video capability ${nn(a)}`)}}setBWSeed(a){if(!this.bandwidthCache)return;const s=this.bandwidthCache.getSeed();a.applyChannelParameters={multiChannelParameter:{mids:this.configProvider.config.bwSeedOptions.mids,mediaParameter:JSON.stringify({sendSideBWSeed:{seedValueBitsPerSec:s}})}},this.diagnostics.sentBWSeed=s}getSubscriptionManager(){return this.subscriptionManager}initAudioCodec(a){this.audioCodecManager.init(a,this.isAudioOutputMuted),this.audioCodecManager.encoder?.on("codecChanged",c=>this.statsGatherer.setAudioEncoderCodecName(c));const s=this.audioCodecManager.decoder;s&&(s.on("usedDecoderChanged",c=>{this.updateAudioRendererStream(c?s.stream:this.webrtcAudioRecvStream),this.statsGatherer.setAudioDecoderStatsProvider(c?s.getStatsProvider():void 0),this.contributingSources?.useCustomCodec(c)}),s.on("contributingSourcesChanged",c=>this.contributingSources?.updateContributingSources(c)),this.audioCodecManager.on("negotiationNeeded",c=>this.negotiation.triggerRenegotiation(!0,c)))}onIncomingVideoQualityChanged(a,s){a===1&&this.remoteVideoResolutionManager.limitResolutionOnPoorPerformance(s)}getVideoDeviceManager(){return this.context.callDeviceManager.getDeviceManager("Video")}setupCallDeviceManagerSubs(){this.callDeviceManagerSub=this.context.callDeviceManager.on("onSelectedVirtualDevicesChanged",()=>{this.logger.info("VirtualDevice changed, disposing deviceManager subscriptions"),this.deviceManagerSubs.forEach(a=>a.dispose()),this.logger.info("New subscriptions for deviceManager created"),this.setSubsForDeviceManager()})}updateLocalMediaSources(){this.mediaManager.updateMediaEntitiesWithLocalTracks(),this.configProvider.config.mapSsrcToTrackForStats&&this.statsGatherer.updateStatsWithLocalSsrcTrackInfo();const a=this.streamSendersManager.getLocalMediaSources();this.qualityManager.updateRegisteredSources(a)}},o0i={build:(n,a,s)=>new r0i(n,a,s)};function s0i(n,a){const s=(a?n?.maxReinvitelessMediaForVideoMultiparty:n?.maxReinvitelessMediaForVideo1on1)||0,c=(a?n?.maxReinvitelessMediaForVBSSMultiparty:n?.maxReinvitelessMediaForVBSS1on1)||0;return{enabled:s>0||c>0,maxStreamsForModality:{video:s,sharing:c}}}var l0i=class{constructor(n,a,s,c,u,m,b,_){this.logger=n,this.context=a,this.configProvider=s,this.diagnostics=c,this.ufdManager=u,this.deviceManager=m,this.capabilities=b,this.midCallTelemetry=_,this.activeSessions=[],this.pendingDeviceTelemetryEvents=[],this.pendingVideoEffectsTelemetryEvents=[],this.pendingAudioEffectsTelemetryEvents=[],this.callsCount=0,this.mediaConfig={},this.configProvider.on("configUpdated",()=>this.configApplied()),this.deviceManager.on("onDeviceTelemetryEvent",k=>this.onDeviceTelemetryEvent(k)),this.deviceManager.on("onVideoEffectsTelemetryEvent",k=>this.onVideoEffectsTelemetryEvent(k)),this.deviceManager.on("onAudioEffectsTelemetryEvent",k=>this.onAudioEffectsTelemetryEvent(k))}createSession(n,a,s,c,u,m){const b=(0,hJe.merge)({},this.mediaConfig,m);this.configProvider.setMediaConfiguration(b);const _=this.configProvider.getConfigView(s?.isConference),k=this.logger,N=a.correlationId,W=this.diagnostics.newSession(_,N,this.logger.createChild("sessionDiagnostics"));u?.setDiagnosticsReport(this.diagnostics.reportGenerator);const ee={getLogger:()=>k,getUfdManager:()=>this.ufdManager,sendWebRtcMediaNotificationAsyncCallback:(Re,ue)=>a.sendWebRtcMediaNotificationAsync(Re,ue),maContext:this.context,config:s??{},configProvider:_,diagnostics:W.newNativeSessionDiag(),reconnectRetry:_.config.audioRendererFailedReconnectTimes,callDeviceManager:c,getSmallCallTelemetry:()=>u},oe=(_.mediaConfig.simulcastSessionEnabled?o0i:iEi).build(ee,N,n),de=new SCi(_,++this.callsCount,W);de.setMediaQosEnabled(!!b.enableMediaQoS),de.setPortRangeConfigured(!!b.mediaPortRanges);const se=new mCi(oe,N,ee,n,de,this.configProvider,W);for(se.on("onTerminated",Re=>this.onSessionTerminated(Re)),this.activeSessions.push(se),this.configProvider.updateSessionCount(this.activeSessions.length),this.webRtcInternalsCollector=rCi.getInstance(this.logger.createChild("WebRtcInternals"),_),this.webRtcInternalsCollector.updateSessionCount(this.activeSessions.length);this.pendingDeviceTelemetryEvents.length>0;)se.registerDeviceTelemetryEvent(this.pendingDeviceTelemetryEvents.pop());for(;this.pendingVideoEffectsTelemetryEvents.length>0;)se.registerVideoEffectsTelemetryEvent(this.pendingVideoEffectsTelemetryEvents.pop());for(;this.pendingAudioEffectsTelemetryEvents.length>0;)se.registerAudioEffectsTelemetryEvent(this.pendingAudioEffectsTelemetryEvents.pop());return se}getDeviceManager(){return this.deviceManager}getCapabilities(){return this.capabilities}getScreenSharingManager(){return new lCi(this.deviceManager)}updateConfig(n,a,s,c){this.configProvider.updateConfig(n,a,s,c)}getConfig(){return this.configProvider.config}getConfigProvider(){return this.configProvider}setMediaConfig(n){(0,hJe.merge)(this.mediaConfig,n),this.diagnostics.mediaConfig=this.mediaConfig}getMediaLogs(){return this.webRtcInternalsCollector?this.webRtcInternalsCollector.collect():Promise.resolve("")}getDiagnosticsData(){return this.diagnostics.rootRef}dispose(n){return Promise.all([...this.activeSessions.map(async a=>{await a.terminate(n,{}).catch(()=>{}),a.dispose()})]).then(()=>{},()=>{})}handleSendMidCallTelemetry(n){this.midCallTelemetry?.on("sendMidCallTelemetry",n)}configApplied(){window&&(this.configProvider.config.enableDevtoolsAPI?window.webMA||this.injectDevtoolsAPI():window.webMA&&delete window.webMA)}injectDevtoolsAPI(){const n=[],a={config:{addOverride:(s,c)=>this.configProvider.setConsoleOverride(s,c),setOverrides:s=>this.configProvider.setConsoleOverrides(s),clearOverride:s=>this.configProvider.clearConsoleOverride(s),clearAllOverrides:()=>this.configProvider.clearAllConsoleOverrides(),setPlatformConstraints:s=>this.configProvider.setCallConstraints(s),setCallConstraints:s=>{this.activeSessions.length&&this.activeSessions[this.activeSessions.length-1].setCallConstraints(s,"webMA")},setRelayConfigOverride:s=>this.context.getRelayManager().setRelayOverride(s),manageVideoFeatures:s=>{n.push(s)}},diagnosticsReport:this.diagnostics.reportGenerator,initVideoFeatures:s=>{n.forEach(c=>{c((u,m,b)=>{let _;const k=iq[b];return k!==void 0&&((m==="video"||m==="sharing")&&(_=s.get("Video")),_!==void 0)&&(u?(_.toggleServer(k,!0),!0):(_.toggleClient(k,!0),!0))})})},deviceManager:{setAudioProcessingFlags:s=>this.deviceManager.setAudioProcessingFlags(s)},ufdManager:{raiseUFD:(s,c="Bad",u="Video")=>this.ufdManager.signalEvent(s,c,u)}};window.webMA=a}onDeviceTelemetryEvent(n){this.activeSessions.length>0?this.activeSessions.forEach(a=>a.registerDeviceTelemetryEvent(n)):this.pendingDeviceTelemetryEvents.push(n)}onVideoEffectsTelemetryEvent(n){this.activeSessions.length>0?this.activeSessions.forEach(a=>a.registerVideoEffectsTelemetryEvent(n)):this.pendingVideoEffectsTelemetryEvents.push(n)}onAudioEffectsTelemetryEvent(n){this.activeSessions.length>0?this.activeSessions.forEach(a=>a.registerAudioEffectsTelemetryEvent(n)):this.pendingAudioEffectsTelemetryEvents.push(n)}onSessionTerminated(n){VR(this.activeSessions,a=>a===n),this.configProvider.updateSessionCount(this.activeSessions.length),this.webRtcInternalsCollector.updateSessionCount(this.activeSessions.length),this.activeSessions.length===0&&this.ufdManager.reset()}},iae=class{static build(n,a,s,c,u,m,b,_){return new l0i(n,a,s,c,u,m,b,_)}};iae.constants=ke,iae.helper=C7e;var c0i=class extends Qs{constructor(n,a,s){super(),this.logger=n,this.callbacks=a,this.deviceManagerDiagnostics=s,this.createWasmCVWorker=()=>(this.logger.info("Creating wasmcv worker"),this.create({msg:"wasmcv"})),this.createEncodedStreamsWorker=()=>(this.logger.info("Creating encoded-stream worker"),this.create({msg:"encoded-stream"})),this.createTimerWorker=()=>(this.logger.info("Creating timer worker"),this.create({msg:"timer"})),this.getWasmVqeWorker=()=>(this.logger.info("Creating wasmvqe worker"),this.create({msg:"wasmvqe"}))}getWorkerFunction(n){if(this.logger.info(`getWorkerFunction, loaderName: ${n}`),!this.callbacks?.createGenericWebRTCWorker)switch(n){case"encoded-stream":return this.callbacks?.createEncodedStreamsWorker;case"wasmcv":return this.callbacks?.createWasmCVWorker;default:return}switch(n){case"encoded-stream":return this.createEncodedStreamsWorker;case"wasmcv":return this.createWasmCVWorker;case"timer":return this.createTimerWorker;default:return}}get audioWorklet(){return this.callbacks?.createGenericWebRTCWorker?{getWasmVqeWorker:this.getWasmVqeWorker,getWasmDnsWorklet:this.callbacks?.audioWorklet?.getWasmDnsWorklet,getWasmAecWorklet:this.callbacks?.audioWorklet?.getWasmAecWorklet,getWasmVqeWorklet:this.callbacks?.audioWorklet?.getWasmVqeWorklet,getEncodedStreamsTimerWorklet:this.callbacks?.audioWorklet?.getEncodedStreamsTimerWorklet}:this.callbacks?.audioWorklet}create(n){let a;try{a=this.callbacks.createGenericWebRTCWorker()}catch{return}const s=Date.now(),c=m=>{const b=JSON.stringify(m);this.logger.error(`Worker ${JSON.stringify(n)} error: ${b}`),this.deviceManagerDiagnostics?.registerWorkerEvent({timestamp:Date.now(),workerType:n.msg,msg:"generic-worker-error",payload:b}),a.removeEventListener("error",c),this.event("onLoadError").raise(n.msg)},u=m=>{let b;m?.data?.msg==="wasm-worker-loaded"&&(this.logger.info(`Worker ${JSON.stringify(n)} event: ${JSON.stringify(m.data)}`),b={timestamp:Date.now(),workerType:n.msg,workerLoadTimeMs:Date.now()-s,msg:JSON.stringify(m?.data?.msg),payload:JSON.stringify(m?.data?.payload)},a.removeEventListener("message",u)),m?.data?.msg==="wasm-worker-load-error"&&c(m),b&&this.deviceManagerDiagnostics?.registerWorkerEvent(b)};return a.addEventListener("error",c),a.addEventListener("message",u),a.postMessage(n),a}},d0i=class kCe{constructor(a,s,c){this.workerProvider=a,this.workerUrl=s,this.workletUrl=c}static async create(a,s){const c=a.getWorkerFunction("encoded-stream"),u=!c&&s?await s.getWorkerUrl():void 0;try{const m=await a.audioWorklet?.getEncodedStreamsTimerWorklet?.();return new kCe(c,u,m)}catch{return new kCe(c,u,void 0)}}getTimerWorkletUrl(){return this.workletUrl}getWorker(a){try{if(a.safe.info("creating worker"),this.workerProvider)return this.workerProvider();if(this.workerUrl)return a.safe.warn("WasmLoader didn't provide worker function, falling back to legacy worker provider"),new Worker(this.workerUrl);a.safe.error("no worker provider")}catch(s){a.safe.error(`failed to create worker ${nn(s)}`)}return null}},u0i=class{constructor(){this.data={count:{}}}registerQualityChangedEvent(n){var a,s,c;(a=this.data.count)[s=bw(n)]??(a[s]={});const u=this.data.count[bw(n)];u[c=n.value.toLowerCase()]??(u[c]=0),u[n.value.toLowerCase()]++}getObjectRef(){return this.data}},h0i=class{constructor(n,a,s){this.mediaAgents=[],n.logger??(n.logger=new Ohi),n.domOverrides??(n.domOverrides={}),this.config=n;const c=n.mediaSettings;rui(n.clientInformation),this.logger=new uJe(n.safeLogger?.createChild("MA",c.debug),n.logger.createChild("MA",c.debug)),this.configProvider=new jSi(this.logger.createChild("configProvider"),s,c);const u=new cKe(this.configProvider),m=new u0i;this.mediaAgentDiagnostics=new nCi(this.configProvider,u,m),this.ufdManager=new xhi(this.logger.createChild("UFD"),this.configProvider,m),this.wasmLoader=new c0i(this.logger.createChild("WasmLoader"),n.createWasmWorkerCbs,u),this.deviceManager=new BSi(this.logger.createChild("DeviceManager"),this.configProvider,u,n.domOverrides,this.ufdManager,n.webcvProvider,n.wasmdnsProvider,n.wasmaecProvider,n.wasmVqeProvider,this.wasmLoader),this.capabilities=new Nhi(this.configProvider),yl.initialize(this.configProvider),a.on("OnECSChanged",()=>{const b=a.getEcsConfig("SkypeWebMedia","mediaAgent");b?this.configProvider.updateConfig(b,a.ETag,a.getEcsConfig("ConfigIDs","SkypeWebMedia"),a.getEcsConfig("Headers","CountryCode")):this.logger.warn("No SkypeWebMedia.mediaAgent config.")})}getDeviceManager(){return this.deviceManager}async buildAgent(n,a,s){if(!yp.hasMediaApi())throw[new fYe(`${n} not supported by media agent provider`,"not_supported")];if(this.config?.detectH264Support&&!await yp.hasH264CodecSupport(this.config.logger))throw[new fYe("H264 is not supported","not_supported")];const c=await d0i.create(this.wasmLoader,this.config.encodedStreamsWorkerProvider),u={getRelayManager:()=>a.getOrCreateRelayManager(),getWebCVProvider:()=>this.config.webcvProvider,getWasmDnsProvider:()=>this.config.wasmdnsProvider,getWasmAecProvider:()=>this.config.wasmaecProvider,getWasmVqeProvider:()=>this.config.wasmVqeProvider,getEncodedStreamsWorkerProvider:()=>c,domOverrides:this.config.domOverrides,configProvider:this.configProvider};a.setConfigProvider(this.configProvider);const m=iae.build(this.logger,u,this.configProvider,this.mediaAgentDiagnostics,this.ufdManager,this.deviceManager,this.capabilities,s);return m.constants=iae.constants,this.mediaAgents.push(m),m}async dispose(n){return Promise.all([this.deviceManager.dispose(),this.ufdManager.dispose(),this.configProvider.dispose(),this.capabilities.dispose(),...this.mediaAgents.map(a=>a.dispose(n))]).then(()=>{this.mediaAgents=[]})}},fYe=class extends Error{constructor(n,a="failure"){super(n),this.reason=a}},vYe=class{constructor(){this.supportedPlatforms=new Map([["Chrome","59.0"],["EdgeAnaheim","79.0"],["Safari","13.1"],["Electron","3.0"],["Firefox","96.0"],["Maglev","1.0"]]),this.experimentalPlatforms=new Map}getPlatformSupportLevel(n){const a=ul.getBrowserInfo(),s=this.supportedPlatforms.get(a.name);if(n&&s&&ul.isVersionGreaterOrEqual(s))return 1;if(n&&!s){if(ul.isEngine("Chromium","ChromiumAVD"))return 2;const c=this.experimentalPlatforms.get(a.name);if(c&&ul.isVersionGreaterOrEqual(c))return 2}return 0}},p0i=class extends Qs{constructor(n,a,s){super(),this.relayManagerProvider=n,this.configProvider=a,this.logger=s,this.currentInfo={},this.currentAreaContent={},this.isEnabled=!1,this.isEnabled=this.configProvider.config.enableE911,a.on("configUpdated",()=>{const c=this.isEnabled;this.isEnabled=this.configProvider.config.enableE911,!this.isEnabled||c===this.isEnabled&&this.prober||(this.prober?.dispose(),this.prober=void 0,this.configProvider.config.probeE911OnInit&&this.probeForIP("config"))})}get info(){return this.currentInfo}get areaContent(){return this.currentAreaContent}async getInfo(){return this.isEnabled&&!this.prober&&await this.probeForIP("publicGetInfo"),this.currentInfo}setClientInfo(n,a){if(this.isEnabled)switch(this.logger.info(`Client info for ${n} set`),n){case 3:this.mergeClientAreaInfo(JSON.parse(a));break;case 1:break;case 2:this.mergeClientNetworkInfo(JSON.parse(a))}}mergeClientAreaInfo(n){const a=JSON.stringify(this.currentAreaContent);this.currentAreaContent.geoCoordinates=n.geoCoordinates,_l(this.currentAreaContent),JSON.stringify(this.currentAreaContent)!==a&&this.raiseChanged()}mergeClientNetworkInfo(n){if(Object.keys(n).length===0){const c=Object.keys(this.currentInfo).length+Object.keys(this.currentAreaContent).length;return this.currentInfo={},this.currentAreaContent={},void(c>0&&this.raiseChanged())}const a=this.currentInfo.bssid!==n.bssid||this.currentInfo.bssidv6!==n.bssidv6||this.currentInfo.mac!==n.mac||this.currentInfo.macv6!==n.macv6||this.currentInfo.subnetLengthIpv4!==n.subnetLengthIpv4||this.currentInfo.subnetLengthIpv6!==n.subnetLengthIpv6,s=this.currentInfo.e911;this.currentInfo.bssid=n.bssid,this.currentInfo.bssidv6=n.bssidv6,this.currentInfo.e911=n.e911,this.currentInfo.mac=n.mac,this.currentInfo.macv6=n.macv6,this.currentInfo.subnetLengthIpv4=n.subnetLengthIpv4,this.currentInfo.subnetLengthIpv6=n.subnetLengthIpv6,_l(this.currentInfo),a?this.probeForIP("clientNetworkInfoChanged").then(c=>{c||this.raiseChanged()}):JSON.stringify(s)!==JSON.stringify(n.e911)&&this.raiseChanged()}async probeForIP(n){return this.probingPromise?(this.logger.info(`Probing already in progress, tried to start for: ${n}`),this.probingPromise):(this.probingPromise=this.probeForIPInternal(n),this.probingPromise.then(a=>(this.probingPromise=void 0,a)).catch(a=>(this.probingPromise=void 0,this.logger.error(`E911 probing failed: ${nn(a)}`),!1)))}async probeForIPInternal(n){this.logger.info(`Probing for public IP address: ${n}`);const a=await this.ensureProber();if(await a.ensureOnline(),a.ipFromRelay){if((this.currentInfo.ipv4||this.currentInfo.ipv6)!==a.ipFromRelay)return delete this.currentInfo.ipv4,delete this.currentInfo.ipv6,this.currentInfo[Yte.test(a.ipFromRelay)?"ipv4":"ipv6"]=a.ipFromRelay,this.raiseChanged(),!0}else if(Object.keys(this.currentInfo).length!==0)return this.currentInfo={},this.raiseChanged(),!0;return!1}async ensureProber(){if(this.prober)return this.prober;const n=vJe(await this.relayManagerProvider.getOrCreateRelayManager().queryRelaysAsync({relayType:"turn"}),this.configProvider.config);return this.prober=new mJe(n,new uJe(this.logger.createChild("Prober"),this.logger.createChild("ProberUnsafe"))),this.prober}},GTe=class extends Qs{constructor(n){super(),this.ecsFilters=n,this.config=null}get ETag(){return this.etag}async setEcsConfig(n){this.config=JSON.parse(n.ecsBlob),this.etag=n.etag,this.event("OnECSChanged").raise()}async setUserEcsServerUrl(n,a){throw new Error("Not implemented")}async getUserEcsServerUrl(n){throw new Error("Not implemented")}async setActiveUserForEcs(n){throw new Error("Not implemented")}async getEcsQueryParameters(){const n={};n.CLRelease=wu();const a="_TS_BUILC_VERSION_".replace("C","D"),s=this.ecsFilters?.["UserInfo.Ring"]?.value,c=this.getTeamsExperience();n.CLRelease===a&&(n.CLRelease="9999.99"),s&&(n.audienceGroup=s,n.teamsRing=s),c&&(n.Experience=c),this.ecsFilters?.vdi?.value==="vdi3"&&(n.vdi="vdi3");const u=ul.getBrowserInfo();return n.BrowserName=u.name,n.BrowserEngine=u.engine,n.BrowserVersion=u.version,n.FormFactor=u.formFactor,n.OsName=u.osName,n.OsVer=u.osVersion,yp.hardwareConcurrency&&(n.CPUCount=yp.hardwareConcurrency),JSON.stringify(n)}async ecsGetUserQueryParameters(n){return this.getEcsQueryParameters()}async shouldTriggerCQF(n,a,s){throw new Error("Not implemented")}getEcsConfig(n,a){const s=this.config?.[n];return a?s?.[a]:s}createEcsConfiguration(){return new class{constructor(n){this.provider=n}getBoolean(n,a){return this.provider.getEcsConfig(n,a)}getNumber(n,a){return this.provider.getEcsConfig(n,a)}getString(n,a){const s=this.provider.getEcsConfig(n,a);return JSON.stringify(s)}}(this)}getTeamsExperience(){return this.ecsFilters?.isTeams2?.value===!0?"teams2":this.ecsFilters?.isTeams2?.value===!1?"teams1":void 0}},qTe=class{constructor(n){this._sharingSource=n}getId(){return this._sharingSource.getId()}getDeviceId(){return this._sharingSource.getDeviceId()}getType(){return this.mapSharingSourceType(this._sharingSource.getType())}getPreview(n,a,s){return Promise.reject("not implemented")}getPreviewAsync(n,a){return this._sharingSource.getPreviewAsync(n,a)}getDescription(){return this._sharingSource.getDescription()}getIcon(n,a){return this._sharingSource.getIcon(n,a)}getBounds(){}mapSharingSourceType(n){switch(n){case 1:return 1;case 2:return 2;case 3:return 3;default:throw new Error("Invalid sharing source type")}}},g0i=class extends Qs{constructor(n){super(),this._screenSharingManager=n,this._screenSharingManager.onScreensChanged(()=>{this.event("screensChanged").raise()})}enumerateScreensAsync(){return this._screenSharingManager.enumerateScreensAsync().then(n=>n.map(a=>new qTe(a)))}enumerateWindowsAsync(){return this._screenSharingManager.enumerateWindowsAsync().then(n=>n.map(a=>new qTe(a)))}enumerateCamerasAsync(){return this._screenSharingManager.enumerateCamerasAsync().then(n=>n.map(a=>new qTe(a)))}},yYe=Hv,m0i=(n,a)=>{if(!a)return n;const s={...n};if(a.ngIncoming&&a.ngOutgoing){const c=f0i(a.ngIncoming.isVBSSEnabled,a.ngOutgoing.isVBSSEnabled);s.cloudScreenSharingFlag=os(c,n.cloudScreenSharingFlag)}return a.ngOutgoing&&(s.emergencyCallCountry=v0i(a.ngOutgoing.isEmergencyCallingEnabled,n.emergencyCallCountry),s.isGVCOutgoingEnabled=os(a.ngOutgoing.isGVCEnabled,n.isGVCOutgoingEnabled),s.brokerEnabledOutgoing=os(a.ngOutgoing.isBrokerEnabled,n.brokerEnabledOutgoing)),a.ngIncoming&&(s.isGVCJoiningEnabled=os(a.ngIncoming.isGVCEnabled,n.isGVCJoiningEnabled),s.brokerEnabledIncoming=os(a.ngIncoming.isBrokerEnabled,n.brokerEnabledIncoming)),s.conversationServiceUrl=WTe(a.conversationServiceUrl,n.conversationServiceUrl),s.uploadLogRequestUrl=WTe(a.uploadLogRequestUrl,n.uploadLogRequestUrl),s.isConversationServiceUrlFromEcs=!!a.conversationServiceUrl,s.isUploadLogRequestUrlFromEcs=!!a.uploadLogRequestUrl,s.callingTokenLogicalUrl=WTe(a.callingTokenLogicalUrl,n.callingTokenLogicalUrl),s.doHostlessCalling=os(a.allowHostlessCalls,n.doHostlessCalling),s.supportsCompressedServicePayload=os(a.supportCompressedTrouterPayload,n.supportsCompressedServicePayload),s.brokerRequestBatching=os(a.allowBrokerSubscribeBatching,n.brokerRequestBatching),s.brokerExclusively=os(a.brokerExclusively,n.brokerExclusively),s.handleMediaOfferFromPushNotification=os(a.handleMediaOfferFromPushNotification,n.handleMediaOfferFromPushNotification),s.handleNewOfferRequest=os(a.handleNewOfferRequest,n.handleNewOfferRequest),s.sendProgressFromCC=os(a.sendProgressFromCC,n.sendProgressFromCC),s.useInternalHttpDispatcher=os(a.webInternalHttpDispatcher,n.useInternalHttpDispatcher),(a.webInternalHttpDispatcherConfigNetworkRequest||n.requestTypeHttpDispatcherConfigMap)&&(a.webInternalHttpDispatcherConfigNetworkRequest=a.webInternalHttpDispatcherConfigNetworkRequest||{},n.requestTypeHttpDispatcherConfigMap=n.requestTypeHttpDispatcherConfigMap||{},s.requestTypeHttpDispatcherConfigMap={...n.requestTypeHttpDispatcherConfigMap,...a.webInternalHttpDispatcherConfigNetworkRequest}),(a.operationTypeHttpDispatcherConfigMap||n.operationTypeHttpDispatcherConfigMap)&&(a.operationTypeHttpDispatcherConfigMap=a.operationTypeHttpDispatcherConfigMap||{},n.operationTypeHttpDispatcherConfigMap=n.operationTypeHttpDispatcherConfigMap||{},s.operationTypeHttpDispatcherConfigMap={...n.operationTypeHttpDispatcherConfigMap,...a.operationTypeHttpDispatcherConfigMap}),(a.csaTimeoutConfiguration||n.csaTimeoutConfiguration)&&(a.csaTimeoutConfiguration=a.csaTimeoutConfiguration||{},n.csaTimeoutConfiguration=n.csaTimeoutConfiguration||{},s.csaTimeoutConfiguration={...n.csaTimeoutConfiguration,...a.csaTimeoutConfiguration}),s.autoJoinOnConflict=os(a.autoJoinOnConflict,n.autoJoinOnConflict),s.enableQuickSendAcceptanceAck=os(a.enableQuickSendAcceptanceAck,n.enableQuickSendAcceptanceAck),s.supportMediaRetargetWhileIncomingRenegotiation=os(a.supportMediaRetargetWhileIncomingRenegotiation,n.supportMediaRetargetWhileIncomingRenegotiation),s.enableCallEstablishmentTimeoutsForStartJoinCall=os(a.enableCallEstablishmentTimeoutsForStartJoinCall,n.enableCallEstablishmentTimeoutsForStartJoinCall),s.callingServiceSupportsCAETokens=os(a.callingServiceSupportsCAETokens,n.callingServiceSupportsCAETokens),s.callingServiceSupportsAADTokens=os(a.callingServiceSupportsAADTokens,n.callingServiceSupportsAADTokens),s.aadTokenExpirationTimeInSeconds=os(a.aadTokenExpirationTimeInSeconds,n.aadTokenExpirationTimeInSeconds),s.caeTokenExpirationTimeInSeconds=os(a.caeTokenExpirationTimeInSeconds,n.caeTokenExpirationTimeInSeconds),s.disableTokenMigrationHeader=os(a.disableTokenMigrationHeader,n.disableTokenMigrationHeader),s.enablePublishTokenTelemetry=os(a.enablePublishTokenTelemetry,n.enablePublishTokenTelemetry),s.refreshTimeBeforeTokenTimeoutInSeconds=os(a.refreshTimeBeforeTokenTimeoutInSeconds,n.refreshTimeBeforeTokenTimeoutInSeconds),s.forceClearExpiredTokens=os(a.forceClearExpiredTokens,n.forceClearExpiredTokens),s.enableRefreshToken=os(a.enableRefreshToken,n.enableRefreshToken),s.enableAsyncDisablePreheat=os(a.enableAsyncDisablePreheat,n.enableAsyncDisablePreheat),s.forceLowercaseHttpHeaders=os(a.forceLowercaseHttpHeaders,n.forceLowercaseHttpHeaders),s.enableResolveScreenSharingWhenNegotiationComplete=os(a.enableResolveScreenSharingWhenNegotiationComplete,n.enableResolveScreenSharingWhenNegotiationComplete),s.maxReinvitelessMediaForVideoForWeb=os(a.maxReinvitelessMediaForVideoForWeb,n.maxReinvitelessMediaForVideoForWeb),s.maxReinvitelessMediaForVBSSForWeb=os(a.maxReinvitelessMediaForVBSSForWeb,n.maxReinvitelessMediaForVBSSForWeb),s.enableRefreshTokenRetry=os(a.enableRefreshTokenRetry,n.enableRefreshTokenRetry),s.enableRefreshTokenRetryInSeconds=os(a.enableRefreshTokenRetryInSeconds,n.enableRefreshTokenRetryInSeconds),s.enableConversationTypeUpdateOnCallEnd=os(a.enableConversationTypeUpdateOnCallEnd,n.enableConversationTypeUpdateOnCallEnd),s.supportMissingTokenTypesInResponse=os(a.supportMissingTokenTypesInResponse,n.supportMissingTokenTypesInResponse),s.useSkypeTokenWhenNoAuthenticateHeader=os(a.useSkypeTokenWhenNoAuthenticateHeader,n.useSkypeTokenWhenNoAuthenticateHeader),s.enableAutoPromotion=os(a.enableAutoPromotion,n.enableAutoPromotion),s.enableTokenCache=os(a.enableTokenCache,n.enableTokenCache),s.enableBatchedSendMessageStatus=os(a.enableBatchedSendMessageStatus,n.enableBatchedSendMessageStatus),s.enableBatchedReceiveMessage=os(a.enableBatchedReceiveMessage,n.enableBatchedReceiveMessage),s.enableTokenCacheForGenericTokenAPI=os(a.enableTokenCacheForGenericTokenAPI,n.enableTokenCacheForGenericTokenAPI),s.disableRealTimeModeFromRoster=os(a.disableRealTimeModeFromRoster,n.disableRealTimeModeFromRoster),s.enableLongOutgoing1To1SetupTimeoutForWeb=os(a.enableLongOutgoing1To1SetupTimeoutForWeb,n.enableLongOutgoing1To1SetupTimeoutForWeb),s.checkAttendeeRoleInCreateContentSharing=os(a.checkAttendeeRoleInCreateContentSharing,n.checkAttendeeRoleInCreateContentSharing),s.enableSpecificErrorCodesForCallEnd=os(a.enableSpecificErrorCodesForCallEnd,n.enableSpecificErrorCodesForCallEnd),s.enableSplitConversationEndUrl=os(a.enableSplitConversationEndUrl,n.enableSplitConversationEndUrl),s.enableFetchRequestWithKeepAlive=os(a.enableFetchRequestWithKeepAlive,n.enableFetchRequestWithKeepAlive),s.enableFetchApi=os(a.enableFetchApi,n.enableFetchApi),s.enableFetchApiForBeacon=os(a.enableFetchApiForBeacon,n.enableFetchApiForBeacon),s};function os(n,a){return n??a}function WTe(n,a){return n||a}function f0i(n,a){return a&&n?"enabled":n?"recvOnly":n===!1&&a===!1?"disabled":void 0}function v0i(n,a){return n===!1?"":a}var KTe,y0i="SkypeCalling",S0i=class{constructor(n,a,s,c){this.signalingAgentConfig=n,this.ecsProvider=a,this.logger=s,this.telemetryLogger=c,this.ecsProvider.on("OnECSChanged",()=>this.onEcsUpdate()),this.signalingAgentConfig.clientInformation+=`/TsCallingVersion=${wu()}/Ovb=${UR()}`,this.signalingAgentConfig.piiScrubber={omit:yYe.pii.Omit,mri:yYe.pii.Mri},this.signalingAgent=new tdi(this.getSignalingAgentConfig())}getSignalingAgent(){return this.signalingAgent}onEcsUpdate(){const n=this.ecsProvider.getEcsConfig(y0i);this.logger.info(`onEcsUpdate, ecsTag=${this.ecsProvider.ETag||""}, ecsConfig=${JSON.stringify(n)}`),this.signalingAgentConfig=m0i(this.signalingAgentConfig,n),this.signalingAgentConfig.ecsEtag=this.ecsProvider.ETag,this.signalingAgent.updateSignalingAgentConfig(this.getSignalingAgentConfig())}getSignalingAgentConfig(){return this.signalingAgentConfig.oneDsTelemetryLogger=this.telemetryLogger,this.signalingAgentConfig}},b0i={build:(n,a,s,c)=>new S0i(n,a,s,c)},T0i=$i(dn),C0i="toLowerCase",nae="blkVal",cE="length",aae="rdOnly",JTe="notify",SYe="warnToConsole",rae="throwInternal",oae="setDf",YTe="watch",nL="logger",bYe="apply",pM="push",_0i="splice",TYe="hdlr",E0i="cancel",A0i="initialize",CYe="identifier",_Ye="isInitialized",EYe="getPlugin",I0i="name",QTe="time",aL="processNext",w0i="getProcessTelContext",AYe="unload",k0i="loggingLevelConsole",nq="createNew",EU="teardown",ZTe="messageId",aq="message",XTe="isAsync",AU="diagLog",IYe="_doTeardown",rq="update",IU="getNext",eCe="setNextPlugin",wYe="userAgent",tCe="nodeType",sae="replace",R0i="logInternalMessage",kYe="isChildEvt",oq="getCtx",rL="setCtx",RYe="complete";function M0i(n,a){KTe||(KTe=Zye("AggregationError",function(c,u){u[cE]>1&&(c.errors=u[1])}));var s=n;throw Ra(a,function(c,u){s+=`
`.concat(u," > ").concat(Gs(c))}),new KTe(s,a||[])}var P0i=void 0,gM="",dE="core",D0i="disabled",lae="extensionConfig",I$="processTelemetry",L0i="priority",MYe="getPerfMgr",O0i="Not dynamic - ",N0i=/-([a-z])/g,x0i=/([^\w\d_$])/g,B0i=/^(\d+[\w\d_$])/;function F0i(n){return!ic(n)}function iCe(n){var a=n;return a&&wf(a)&&(a=(a=(a=a[sae](N0i,function(s,c){return c.toUpperCase()}))[sae](x0i,"_"))[sae](B0i,function(s,c){return"_"+c})),a}function PYe(n,a){return!(!n||!a)&&qV(n,a)!==-1}function U0i(n){return n&&n.toISOString()||""}function z0i(n,a){var s=null,c=null;return js(n)?s=n:c=n,function(){var u=arguments;if(s&&(c=s()),c)return c[a][bYe](c,u)}}function DYe(n,a,s,c,u){n&&a&&s&&u!==!1&&(n[a]=z0i(s,c))}var V0i="console",LYe="JSON",$0i="crypto",H0i="msCrypto",j0i="msie",G0i="trident/",nCe=null,OYe=null;function q0i(){return typeof console!==lie?console:Zu(V0i)}function NYe(){return!!(typeof JSON===sie&&JSON||Zu(LYe)!==null)}function W0i(){return NYe()?JSON||Zu(LYe):null}function K0i(){return Zu($0i)}function J0i(){return Zu(H0i)}function Y0i(){var n=QR();if(n&&(n[wYe]!==OYe||nCe===null)){var a=((OYe=n[wYe])||gM)[C0i]();nCe=PYe(a,j0i)||PYe(a,G0i)}return nCe}var xYe=4294967296,wU=4294967295,BYe=123456789,FYe=987654321,UYe=!1,cae=BYe,dae=FYe;function Q0i(n){n<0&&(n>>>=0),cae=BYe+n&wU,dae=FYe-n&wU,UYe=!0}function Z0i(){try{var n=2147483647&Jb();Q0i((Math.random()*xYe^n)+n)}catch{}}function uae(n){var a=0,s=K0i()||J0i();return s&&s.getRandomValues&&(a=s.getRandomValues(new Uint32Array(1))[0]&wU),a===0&&Y0i()&&(UYe||Z0i(),a=X0i()&wU),a===0&&(a=Math.floor(xYe*Math.random()|0)),a>>>=0,a}function X0i(n){var a=((dae=36969*(65535&dae)+(dae>>16)&wU)<<16)+(65535&(cae=18e3*(65535&cae)+(cae>>16)&wU))>>>0&wU;return a>>>=0,a}function eAi(n){for(var a="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",s=uae()>>>0,c=0,u=gM;u[cE]<n;)c++,u+=a.charAt(63&s),s>>>=6,c===5&&(s=(uae()<<2&4294967295|3&s)>>>0,c=0);return u}var zYe="3.3.1",tAi="."+eAi(6),iAi=0;function VYe(n){return n[tCe]===1||n[tCe]===9||!+n[tCe]}function nAi(n,a){var s=a[n.id];if(!s){s={};try{VYe(a)&&Fc(a,n.id,{e:!1,v:s})}catch{}}return s}function $Ye(n,a){return a===void 0&&(a=!1),iCe(n+iAi+++(a?"."+zYe:gM)+tAi)}function aAi(n){var a={id:$Ye("_aiData-"+n+"."+zYe),accept:function(s){return VYe(s)},get:function(s,c,u,m){var b=s[a.id];return b?b[iCe(c)]:(m&&((b=nAi(a,s))[iCe(c)]=u),u)},kill:function(s,c){if(s&&s[c])try{delete s[c]}catch{}}};return a}function hae(n){return n&&JR(n)&&(n.isVal||n.fb||nE(n,"v")||nE(n,"mrg")||nE(n,"ref")||n.set)}function HYe(n,a,s){var c,u=s.dfVal||Hye;if(a&&s.fb){var m=s.fb;Fo(m)||(m=[m]);for(var b=0;b<m[cE];b++){var _=m[b],k=a[_];if(u(k)?c=k:n&&(u(k=n.cfg[_])&&(c=k),n.set(n.cfg,aA(_),k)),u(c))break}}return!u(c)&&u(s.v)&&(c=s.v),c}function aCe(n,a,s){var c,u=s;return s&&hae(s)&&(u=HYe(n,a,s)),u&&(hae(u)&&(u=aCe(n,a,u)),Fo(u)?(c=[])[cE]=u[cE]:kf(u)&&(c={}),c&&(El(u,function(m,b){b&&hae(b)&&(b=aCe(n,a,b)),c[m]=b}),u=c)),u}function rCe(n,a,s,c){var u,m,b,_,k,N,W,ee,oe=c;hae(oe)?(u=oe.isVal,m=oe.set,N=oe[aae],W=oe[nae],_=oe.mrg,!(k=oe.ref)&&_c(k)&&(k=!!_),b=HYe(n,a,oe)):b=c,W&&n[nae](a,s);var de=!0,se=a[s];!se&&ic(se)||(ee=se,de=!1,u&&ee!==b&&!u(ee)&&(ee=b,de=!0),m&&(de=(ee=m(ee,b,a))===b)),de?ee=b&&aCe(n,a,b):(kf(ee)||Fo(b))&&_&&b&&(kf(b)||Fo(b))&&El(b,function(Re,ue){rCe(n,ee,Re,ue)}),n.set(a,s,ee),k&&n.ref(a,s),N&&n[aae](a,s)}var WN=jV("[[ai_dynCfg_1]]"),jYe=jV("[[ai_blkDynCfg_1]]"),rAi=jV("[[ai_frcDynCfg_1]]");function GYe(n){var a;return n&&(Fo(n)?(a=[])[cE]=n[cE]:kf(n)&&(a={}),a)?(El(n,function(s,c){a[s]=GYe(c)}),a):n}function oAi(n){if(n){var a=n[WN]||n;if(a.cfg&&(a.cfg===n||a.cfg[WN]===a))return a}return null}function sAi(n){if(n&&(kf(n)||Fo(n)))try{n[jYe]=!0}catch{}return n}function oCe(n,a,s){var c=!1;return s&&!n[a.blkVal]&&((c=s[rAi])||s[jYe]||(c=kf(s)||Fo(s))),c}function qYe(n){rA("InvalidAccess:"+n)}var lAi=["push","pop","shift","unshift","splice"],sq=function(n,a,s,c){n&&n[rae](3,108,"".concat(s," [").concat(a,"] failed - ")+Gs(c))};function cAi(n,a,s){Fo(a)&&Ra(lAi,function(c){var u=a[c];a[c]=function(){for(var m=[],b=0;b<arguments.length;b++)m[b]=arguments[b];var _=u[bYe](this,m);return mae(n,a,s,"Patching"),_}})}function pae(n,a){var s=gie(n,a);return s&&s.get}function dAi(n,a,s,c){var u={n:s,h:[],trk:function(N){N&&N.fn&&(Rv(u.h,N)===-1&&u.h[pM](N),n.trk(N,u))},clr:function(N){var W=Rv(u.h,N);W!==-1&&u.h[_0i](W,1)}},m=!0,b=!1;function _(){m&&(b=b||oCe(_,n,c),c&&!c[WN]&&b&&(c=mae(n,c,s,"Converting")),m=!1);var N=n.act;return N&&u.trk(N),c}function k(N){if(c!==N){_[n.ro]&&!n.upd&&qYe("["+s+"] is read-only:"+Gs(a)),m&&(b=b||oCe(_,n,c),m=!1);var W=b&&_[n.rf];if(b)if(W){El(c,function(oe){c[oe]=N?N[oe]:P0i});try{El(N,function(oe,de){gae(n,c,oe,de)}),N=c}catch(oe){sq((n.hdlr||{})[nL],s,"Assigning",oe),b=!1}}else c&&c[WN]&&El(c,function(oe){var de=pae(c,oe);if(de){var se=de[n.prop];se&&se.chng()}});if(N!==c){var ee=N&&oCe(_,n,N);!W&&ee&&(N=mae(n,N,s,"Converting")),c=N,b=ee}n.add(u)}}_[n.prop]={chng:function(){n.add(u)}},Fc(a,u.n,{g:_,s:k})}function gae(n,a,s,c){if(a){var u=pae(a,s);u&&u[n.prop]?a[s]=c:dAi(n,a,s,c)}return a}function sCe(n,a,s,c){if(a){var u=pae(a,s),m=u&&!!u[n.prop],b=c&&c[0],_=c&&c[1],k=c&&c[2];if(!m){if(k)try{sAi(a)}catch(N){sq((n.hdlr||{})[nL],s,"Blocking",N)}try{gae(n,a,s,a[s]),u=pae(a,s)}catch(N){sq((n.hdlr||{})[nL],s,"State",N)}}b&&(u[n.rf]=b),_&&(u[n.ro]=_),k&&(u[n.blkVal]=!0)}return a}function mae(n,a,s,c){try{El(a,function(u,m){gae(n,a,u,m)}),a[WN]||(nA(a,WN,{get:function(){return n[TYe]}}),cAi(n,a,s))}catch(u){sq((n.hdlr||{})[nL],s,c,u)}return a}var lq="[[ai_",cq="]]";function uAi(n){var a,s,c=ZR(lq+"get"+n.uid+cq),u=ZR(lq+"ro"+n.uid+cq),m=ZR(lq+"rf"+n.uid+cq),b=ZR(lq+"blkVal"+n.uid+cq),_=ZR(lq+"dtl"+n.uid+cq),k=null,N=null;function W(se,Re){var ue=s.act;try{s.act=se,se&&se[_]&&(Ra(se[_],function(ze){ze.clr(se)}),se[_]=[]),Re({cfg:n.cfg,set:n.set.bind(n),setDf:n[oae].bind(n),ref:n.ref.bind(n),rdOnly:n[aae].bind(n)})}catch(ze){var Ne=n[nL];throw Ne&&Ne[rae](1,107,Gs(ze)),ze}finally{s.act=ue||null}}function ee(){if(k){var se=k;k=null,N&&N[E0i](),N=null;var Re=[];if(Ra(se,function(ue){if(ue&&(ue[_]&&(Ra(ue[_],function(Ne){Ne.clr(ue)}),ue[_]=null),ue.fn))try{W(ue,ue.fn)}catch(Ne){Re[pM](Ne)}}),k)try{ee()}catch(ue){Re[pM](ue)}Re[cE]>0&&M0i("Watcher error(s): ",Re)}}function oe(se){if(se&&se.h[cE]>0){k||(k=[]),N||(N=KD(function(){N=null,ee()},0));for(var Re=0;Re<se.h[cE];Re++){var ue=se.h[Re];ue&&Rv(k,ue)===-1&&k[pM](ue)}}}function de(se,Re){if(se){var ue=se[_]=se[_]||[];Rv(ue,Re)===-1&&ue[pM](Re)}}return(a={prop:c,ro:u,rf:m})[nae]=b,a[TYe]=n,a.add=oe,a[JTe]=ee,a.use=W,a.trk=de,s=a}function hAi(n,a){var s={fn:a,rm:function(){s.fn=null,n=null,a=null}};return Fc(s,"toJSON",{v:function(){return"WatcherHandler"+(s.fn?"":"[X]")}}),n.use(s,a),s}function pAi(n,a,s){var c,u=oAi(a);if(u)return u;var m,b=$Ye("dyncfg",!0),_=a&&s!==!1?a:GYe(a);function k(){m[JTe]()}function N(Ne,ze,He){try{Ne=gae(m,Ne,ze,He)}catch(be){sq(n,ze,"Setting value",be)}return Ne[ze]}function W(Ne){return hAi(m,Ne)}function ee(Ne,ze){m.use(null,function(He){var be=m.upd;try{_c(ze)||(m.upd=ze),Ne(He)}finally{m.upd=be}})}function oe(Ne,ze){var He;return sCe(m,Ne,ze,(He={},He[0]=!0,He))[ze]}function de(Ne,ze){var He;return sCe(m,Ne,ze,(He={},He[1]=!0,He))[ze]}function se(Ne,ze){var He;return sCe(m,Ne,ze,(He={},He[2]=!0,He))[ze]}function Re(Ne,ze){return ze&&El(ze,function(He,be){rCe(ue,Ne,He,be)}),Ne}var ue=((c={uid:null,cfg:_})[nL]=n,c[JTe]=k,c.set=N,c[oae]=Re,c[YTe]=W,c.ref=oe,c[aae]=de,c[nae]=se,c._block=ee,c);return Fc(ue,"uid",{c:!1,e:!1,w:!1,v:b}),mae(m=uAi(ue),_,"config","Creating"),ue}function gAi(n,a){qYe(a)}function kU(n,a,s,c){var u=pAi(s,n||{},c);return a&&u[oae](u.cfg,a),u}function fae(n,a,s){var c=n[WN]||n;return!c.cfg||c.cfg!==n&&c.cfg[WN]!==c?(gAi(s,O0i+Gs(n)),kU(n,null,s)[YTe](a)):c[YTe](a)}var dq,vae=null;function mAi(){var n=Zu("Microsoft");return n&&(vae=n.ApplicationInsights),vae}function fAi(n){var a=vae;return a||n.disableDbgExt===!0||(a=vae||mAi()),a?a.ChromeDbgExt:null}var WYe="warnToConsole",vAi="AI (Internal): ",yAi="AI: ",SAi="AITR_",bAi={loggingLevelConsole:0,loggingLevelTelemetry:1,maxMessageLimit:25,enableDebug:!1},TAi=((dq={})[0]=null,dq[1]="errorToConsole",dq[2]=WYe,dq[3]="debugToConsole",dq);function KYe(n){return n?'"'+n[sae](/\"/g,gM)+'"':gM}function lCe(n,a){var s=q0i();if(s){var c="log";s[n]&&(c=n),js(s[c])&&s[c](a)}}var JYe=function(){function n(a,s,c,u){c===void 0&&(c=!1);var m=this;m[ZTe]=a,m[aq]=(c?yAi:vAi)+a;var b=gM;NYe()&&(b=W0i().stringify(u));var _=(s?" message:"+KYe(s):gM)+(u?" props:"+KYe(b):gM);m[aq]+=_}return n.dataType="MessageData",n}();function YYe(n,a){return(n||{})[nL]||new QYe(a)}var QYe=function(){function n(a){this.identifier="DiagnosticLogger",this.queue=[];var s,c,u,m,b,_=0,k={};Ec(n,this,function(N){function W(se,Re){if(!oe()){var ue=!0,Ne=SAi+Re[ZTe];if(k[Ne]?ue=!1:k[Ne]=!0,ue&&(se<=c&&(N.queue[pM](Re),_++,de(se===1?"error":"warn",Re)),_===u)){var ze="Internal events throttle limit per PageView reached for this app.",He=new JYe(23,ze,!1);N.queue[pM](He),se===1?N.errorToConsole(ze):N[SYe](ze)}}}function ee(se){return fae(kU(se,bAi,N).cfg,function(Re){var ue=Re.cfg;s=ue[k0i],c=ue.loggingLevelTelemetry,u=ue.maxMessageLimit,m=ue.enableDebug})}function oe(){return _>=u}function de(se,Re){var ue=fAi(a||{});ue&&ue[AU]&&ue[AU](se,Re)}b=ee(a||{}),N.consoleLoggingLevel=function(){return s},N[rae]=function(se,Re,ue,Ne,ze){ze===void 0&&(ze=!1);var He=new JYe(Re,ue,ze,Ne);if(m)throw Gs(He);var be=TAi[se]||WYe;if(_c(He[aq]))de("throw"+(se===1?"Critical":"Warning"),He);else{if(ze){var Ee=+He[ZTe];!k[Ee]&&s>=se&&(N[be](He[aq]),k[Ee]=!0)}else s>=se&&N[be](He[aq]);W(se,He)}},N.debugToConsole=function(se){lCe("debug",se),de("warning",se)},N[SYe]=function(se){lCe("warn",se),de("warning",se)},N.errorToConsole=function(se){lCe("error",se),de("error",se)},N.resetInternalMessageCount=function(){_=0,k={}},N[R0i]=W,N[AYe]=function(se){b&&b.rm(),b=null}})}return n.__ieDyn=1,n}();function CAi(n){return n||new QYe}function yae(n,a,s,c,u,m){m===void 0&&(m=!1),CAi(n)[rae](a,s,c,u,m)}var cCe="ctx",dCe="ParentContextKey",uq="ChildrenContextKey",uCe=function(){function n(a,s,c){var u,m=this;m.start=Jb(),m[I0i]=a,m[XTe]=c,m[kYe]=function(){return!1},js(s)&&Fc(m,"payload",{g:function(){return!u&&js(s)&&(u=s(),s=null),u}}),m[oq]=function(b){return b?b===n[dCe]||b===n[uq]?m[b]:(m[cCe]||{})[b]:null},m[rL]=function(b,_){b&&(b===n[dCe]?(m[b]||(m[kYe]=function(){return!0}),m[b]=_):b===n[uq]?m[b]=_:(m[cCe]=m[cCe]||{})[b]=_)},m[RYe]=function(){var b=0,_=m[oq](n[uq]);if(Fo(_))for(var k=0;k<_[cE];k++){var N=_[k];N&&(b+=N[QTe])}m[QTe]=Jb()-m.start,m.exTime=m[QTe]-b,m[RYe]=function(){}}}return n.ParentContextKey="parent",n.ChildrenContextKey="childEvts",n}(),hCe="CoreUtils.doPerf";function hq(n,a,s,c,u){if(n){var m=n;if(m[MYe]&&(m=m[MYe]()),m){var b=void 0,_=m[oq](hCe);try{if(b=m.create(a(),c,u)){if(_&&b[rL]&&(b[rL](uCe[dCe],_),_[oq]&&_[rL])){var k=_[oq](uCe[uq]);k||(k=[],_[rL](uCe[uq],k)),k[pM](b)}return m[rL](hCe,b),s(b)}}catch(N){b&&b[rL]&&b[rL]("exception",N)}finally{b&&m.fire(b),m[rL](hCe,_)}}}return s()}function pq(){var n=_Ai();return Kb(n,0,8)+"-"+Kb(n,8,12)+"-"+Kb(n,12,16)+"-"+Kb(n,16,20)+"-"+Kb(n,20)}function _Ai(){for(var n,a=["0","1","2","3","4","5","6","7","8","9","a","b","c","d","e","f"],s=gM,c=0;c<4;c++)s+=a[15&(n=uae())]+a[n>>4&15]+a[n>>8&15]+a[n>>12&15]+a[n>>16&15]+a[n>>20&15]+a[n>>24&15]+a[n>>28&15];var u=a[8+(3&uae())|0];return Cw(s,0,8)+Cw(s,9,4)+"4"+Cw(s,13,3)+u+Cw(s,16,3)+Cw(s,19,12)}var EAi=aAi("plugin");function pCe(n){return EAi.get(n,"state",{},!0)}var ZYe,AAi="TelemetryPluginChain",XYe="_hasRun",eQe="_getTelCtx",tQe=0;function IAi(n,a,s){for(;n;){if(n[EYe]()===s)return n;n=n[IU]()}return gq([s],a.config||{},a)}function gCe(n,a,s,c){var u=null,m=[];a||(a=kU({},null,s[nL])),c!==null&&(u=c?IAi(n,s,c):n);var b={_next:k,ctx:{core:function(){return s},diagLog:function(){return YYe(s,a.cfg)},getCfg:function(){return a.cfg},getExtCfg:W,getConfig:ee,hasNext:function(){return!!u},getNext:function(){return u},setNext:function(de){u=de},iterate:oe,onComplete:_}};function _(de,se){for(var Re=[],ue=2;ue<arguments.length;ue++)Re[ue-2]=arguments[ue];de&&m[pM]({func:de,self:_c(se)?b.ctx:se,args:Re})}function k(){var de=u;if(u=de?de[IU]():null,!de){var se=m;se&&se[cE]>0&&(Ra(se,function(Re){try{Re.func.call(Re.self,Re.args)}catch(ue){yae(s[nL],2,73,"Unexpected Exception during onComplete - "+Gs(ue))}}),m=[])}return de}function N(de,se){var Re=null,ue=a.cfg;if(ue&&de){var Ne=ue[lae];!Ne&&se&&(Ne={}),ue[lae]=Ne,(Ne=a.ref(ue,lae))&&(!(Re=Ne[de])&&se&&(Re={}),Ne[de]=Re,Re=a.ref(Ne,de))}return Re}function W(de,se){var Re=N(de,!0);return se&&El(se,function(ue,Ne){if(ic(Re[ue])){var ze=a.cfg[ue];!ze&&ic(ze)||(Re[ue]=ze)}rCe(a,Re,ue,Ne)}),a[oae](Re,se)}function ee(de,se,Re){var ue;Re===void 0&&(Re=!1);var Ne=N(de,!1),ze=a.cfg;return!Ne||!Ne[se]&&ic(Ne[se])?!ze[se]&&ic(ze[se])||(ue=ze[se]):ue=Ne[se],ue||!ic(ue)?ue:Re}function oe(de){for(var se;se=b._next();){var Re=se[EYe]();Re&&de(Re)}}return b}function w$(n,a,s,c){var u=kU(a),m=gCe(n,u,s,c),b=m.ctx;function _(N){var W=m._next();return W&&W[I$](N,b),!W}function k(N,W){return N===void 0&&(N=null),Fo(N)&&(N=gq(N,u.cfg,s,W)),w$(N||b[IU](),u.cfg,s,W)}return b[aL]=_,b[nq]=k,b}function iQe(n,a,s){var c=kU(a.config),u=gCe(n,c,a,s),m=u.ctx;function b(k){var N=u._next();return N&&N[AYe](m,k),!N}function _(k,N){return k===void 0&&(k=null),Fo(k)&&(k=gq(k,c.cfg,a,N)),iQe(k||m[IU](),a,N)}return m[aL]=b,m[nq]=_,m}function nQe(n,a,s){var c=kU(a.config),u=gCe(n,c,a,s).ctx;function m(_){return u.iterate(function(k){js(k[rq])&&k[rq](u,_)})}function b(_,k){return _===void 0&&(_=null),Fo(_)&&(_=gq(_,c.cfg,a,k)),nQe(_||u[IU](),a,k)}return u[aL]=m,u[nq]=b,u}function gq(n,a,s,c){var u=null,m=!c;if(Fo(n)&&n[cE]>0){var b=null;Ra(n,function(_){if(m||c!==_||(m=!0),m&&_&&js(_[I$])){var k=wAi(_,a,s);u||(u=k),b&&b._setNext(k),b=k}})}return c&&!u?gq([c],a,s):u}function wAi(n,a,s){var c,u=null,m=js(n[I$]),b=js(n[eCe]),_={getPlugin:function(){return n},getNext:function(){return u},processTelemetry:W,unload:ee,update:oe,_id:c=n?n[CYe]+"-"+n[L0i]+"-"+tQe++:"Unknown-0-"+tQe++,_setNext:function(de){u=de}};function k(){var de;return n&&js(n[eQe])&&(de=n[eQe]()),de||(de=w$(_,a,s)),de}function N(de,se,Re,ue,Ne){var ze=!1,He=n?n[CYe]:AAi,be=de[XYe];return be||(be=de[XYe]={}),de.setNext(u),n&&hq(de[dE](),function(){return He+":"+Re},function(){be[c]=!0;try{var Ee=u?u._id:gM;Ee&&(be[Ee]=!1),ze=se(de)}catch(Qe){var Pe=!u||be[u._id];Pe&&(ze=!0),u&&Pe||yae(de[AU](),1,73,"Plugin ["+He+"] failed during "+Re+" - "+Gs(Qe)+", run flags: "+Gs(be))}},ue,Ne),ze}function W(de,se){function Re(ue){if(!n||!m)return!1;var Ne=pCe(n);return!Ne[EU]&&!Ne[D0i]&&(b&&n[eCe](u),n[I$](de,ue),!0)}N(se=se||k(),Re,"processTelemetry",function(){return{item:de}},!de.sync)||se[aL](de)}function ee(de,se){function Re(){var ue=!1;if(n){var Ne=pCe(n),ze=n[dE]||Ne[dE];!n||ze&&ze!==de.core()||Ne[EU]||(Ne[dE]=null,Ne[EU]=!0,Ne[_Ye]=!1,n[EU]&&n[EU](de,se)===!0&&(ue=!0))}return ue}N(de,Re,"unload",function(){},se[XTe])||de[aL](se)}function oe(de,se){function Re(){var ue=!1;if(n){var Ne=pCe(n),ze=n[dE]||Ne[dE];!n||ze&&ze!==de.core()||Ne[EU]||n[rq]&&n[rq](de,se)===!0&&(ue=!0)}return ue}N(de,Re,"update",function(){},!1)||de[aL](se)}return MN(_)}function kAi(){var n=[];function a(c){c&&n[pM](c)}function s(c,u){Ra(n,function(m){try{m(c,u)}catch(b){yae(c[AU](),2,73,"Unexpected error calling unload handler - "+Gs(b))}}),n=[]}return{add:a,run:s}}function RAi(){var n=[];function a(c){var u=n;n=[],Ra(u,function(m){try{(m.rm||m.remove).call(m)}catch(b){yae(c,2,73,"Unloading:"+Gs(b))}})}function s(c){c&&XR(n,c)}return{run:a,add:s}}var RU,KN="getPlugin",MAi=((ZYe={})[lae]={isVal:F0i,v:{}},ZYe),PAi=function(){function n(){var a,s,c,u,m,b=this;function _(W){W===void 0&&(W=null);var ee=W;if(!ee){var oe=s||w$(null,{},b[dE]);ee=c&&c[KN]?oe[nq](null,c[KN]):oe[nq](null,c)}return ee}function k(W,ee,oe){kU(W,MAi,YYe(ee)),!oe&&ee&&(oe=ee[w0i]()[IU]());var de=c;c&&c[KN]&&(de=c[KN]()),b[dE]=ee,s=w$(oe,W,ee,de)}function N(){a=!1,b[dE]=null,s=null,c=null,m=RAi(),u=kAi()}N(),Ec(n,b,function(W){W[A0i]=function(ee,oe,de,se){k(ee,oe,se),a=!0},W[EU]=function(ee,oe){var de,se=W[dE];if(se&&(!ee||se===ee[dE]())){var Re,ue=!1,Ne=ee||iQe(null,se,c&&c[KN]?c[KN]():c),ze=oe||((de={reason:0})[XTe]=!1,de);return W[IYe]&&W[IYe](Ne,ze,He)===!0?Re=!0:He(),Re}function He(){ue||(ue=!0,u.run(Ne,oe),m.run(Ne[AU]()),Re===!0&&Ne[aL](ze),N())}},W[rq]=function(ee,oe){var de=W[dE];if(de&&(!ee||de===ee[dE]())){var se,Re=!1,ue=ee||nQe(null,de,c&&c[KN]?c[KN]():c),Ne=oe||{reason:0};return W._doUpdate&&W._doUpdate(ue,Ne,ze)===!0?se=!0:ze(),se}function ze(){Re||(Re=!0,k(ue.getCfg(),ue.core(),ue[IU]()))}},DYe(W,"_addUnloadCb",function(){return u},"add"),DYe(W,"_addHook",function(){return m},"add"),Fc(W,"_unloadHooks",{g:function(){return m}})}),b[AU]=function(W){return _(W)[AU]()},b[_Ye]=function(){return a},b.setInitialized=function(W){a=W},b[eCe]=function(W){c=W},b[aL]=function(W,ee){ee?ee[aL](W):c&&js(c[I$])&&c[I$](W,null)},b._getTelCtx=_}return n.__ieDyn=1,n}(),DAi="",mq="timings",mCe="processTelemetryStart";function MU(n){if(n){var a=qV(n,"-");if(a>-1)return yie(n,a)}return DAi}(RU={})[0]=0,RU[2]=6,RU[1]=1,RU[3]=7,RU[4098]=6,RU[4097]=1,RU[4099]=7;var PU,k$,LAi=uGe;function OAi(n,a){var s=n;s[mq]=s[mq]||{},s[mq][mCe]=s[mq][mCe]||{},s[mq][mCe][a]=LAi()}function aQe(n){return n>0}function Sae(n){return HD(n)&&n>=1&&n<=2}(k$=PU||(PU={}))[k$.LocalStorage=1]="LocalStorage",k$[k$.SessionStorage=2]="SessionStorage",k$[k$.IndexedDb=3]="IndexedDb";var NAi="readwrite",fCe="result",fq="DBError: Unable to open database",rQe="Database is not open",xAi="DBError: Failed to Open Cursor",bae="DBError: Failed to delete the database",BAi="DBError: Database does not exist",FAi="DBError: Database upgrade required",UAi="DBError: Feature not supported",oQe=["indexedDB"],zAi=js,VAi=wf,$Ai=0;function HAi(){var n=PN()||{},a=null;if(n)try{for(var s=0;s<oQe.length;s++)if((a=n[oQe[s]])&&zAi(a.open))return a}catch{a=null}return a||null}function oL(n,a){Zu("QUnit")&&console&&console.log("  ["+U0i(new Date)+"]: IndexedDbHelper ["+n+"] "+a)}function uE(n,a,s){n&&n.warnToConsole("IndexedDbHelper ["+a+"] "+s)}function sQe(n,a,s,c){return function(u){s(new Error(a)),oL(n,"["+c+"] event rejected")}}var vCe=[];function vq(n,a){for(var s=null,c=0;c<vCe.length;c++)if((s=vCe[c]).name===n)return s;return s={name:n,sch:DSe(Sp,"IndexedDbHelper["+n+"]"),dbHdl:[],add:function(u){s.dbHdl.push(u),oL(n,"- dbOpened (add) -- hdls ["+s.dbHdl.length+"]")},remove:function(u){for(var m=s.dbHdl,b=0;b<m.length;b++)if(m[b]===u){m.splice(b,1);break}oL(n,"- dbClosed (remove) -- hdls ["+s.dbHdl.length+"]")},isOpen:function(){return s.dbHdl.length>0},openHdl:function(){return s.dbHdl.length>0?s.dbHdl[0]:null}},vCe.push(s),s}var jAi=function(){function n(a){var s=$Ai++,c=0;Ec(n,this,function(u){var m=HAi()||null;function b(W,ee,oe){var de=W.db,se=c++;oL(W.dbName,"["+s+":"+se+"] txn.open - "+ee+" -- "+oe);var Re=de.transaction(ee,NAi);return Re.onabort=function(){uE(a,W.dbName,"["+s+":"+se+"] txn.onabort - "+ee+" -- "+oe+" -- "+Gs(Re.error))},Re.onerror=function(){uE(a,W.dbName,"["+s+":"+se+"] txn.onerror - "+ee+" -- "+oe)},Re.oncomplete=function(){oL(W.dbName,"["+s+":"+se+"] txn.oncomplete - "+ee+" -- "+oe)},{db:W,store:Re.objectStore(ee),tx:Re,tbl:ee,openCursor:function(ue,Ne){return k(W,ee,ue,Ne)},newTransaction:function(ue){return _(W,ee,ue)}}}function _(W,ee,oe){if(!W||!W.db)return XD(new Error(rQe));try{var de=oe(b(W,ee,"openStore"));return $V(de)?de:agi(de)}catch(se){return XD(se)}}function k(W,ee,oe,de){if(!W||!W.db)return XD(new Error(rQe));var se=null;return oe&&VAi(oe)?se=new GAi(oe):oe&&oe.isMatch&&(se=oe),Sp(function(Re,ue){var Ne=[],ze=null,He=null;se&&se.keyRange&&(He=se.keyRange());var be=b(W,ee,"openCursor");(ze=He?be.store.openCursor(He):be.store.openCursor()).onerror=sQe(be.db.dbName,xAi,ue,"openCursor"),ze.onsuccess=function(Ee){var Pe=Ee.target[fCe];if(Pe){var Qe={store:be,cursor:Pe,continue:function(){Pe.continue()},done:function(){Re(Ne)}},Ze=Pe.value;if(!se||se.isMatch(Ze))if(de)try{switch(de(Qe,Ze,Ne)){case 2:Re(Ne);break;case 1:break;default:Qe.continue()}}catch(Xe){ue(Xe)}else Ne.push(Ze),Qe.continue();else Qe.continue()}else Re(Ne)}})}function N(W,ee,oe,de){return vq(W).sch.queue(oe,ee,de)}u.isAvailable=function(){return!!m},u.openDb=function(W,ee,oe,de){return N(W,"openDb",function(se){return Sp(function(Re,ue){var Ne=!1;function ze(Ze,Xe,bt,Ot,Yt){var pt={db:Xe,dbName:W,dbVersion:ee,ctx:null,isNew:Ot,txn:bt?bt.transaction:null};return Yt||(pt.openStore=function(Lt,xt){return _(pt,Lt,xt)},pt.openCursor=function(Lt,xt,yi){return k(pt,Lt,xt,yi)}),pt}function He(Ze,Xe){var bt=ze(null,Ze,Xe,!0,!0);if(de)Ne=!0,_w(de(bt),function(Ot){if(Ot.rejected)try{Xe.transaction&&Xe.transaction.abort()}finally{ue(Ot.reason)}else bt.txn||(bt.txn=Xe.transaction)});else try{Xe.transaction&&Xe.transaction.abort()}finally{ue(new Error(FAi))}}function be(Ze,Xe){var bt=vq(W);bt.add(Ze),Ze.onabort=function(pt){uE(a,W,"onabort -- closing the Db"),bt.remove(Ze)},Ze.onerror=function(pt){uE(a,W,"onerror -- closing the Db"),bt.remove(Ze)},Ze.onclose=function(pt){uE(a,W,"onclose -- closing the Db"),bt.remove(Ze)},Ze.onversionchange=function(pt){uE(a,W,"onversionchange -- force closing the Db"),Ze.close(),bt.remove(Ze)};var Ot=null,Yt=null;bt.dbHdl.length>0&&(Yt=bt.dbHdl[0]),Ot=ze(bt,Yt,Xe,Ne);try{tU(oe(Ot),Re,ue)}catch(pt){ue(pt)}}var Ee=vq(W);if(m==null)ue(new Error("No available storage factory"));else if(Ee.isOpen()){var Pe=ze(Ee,Ee.openHdl(),null,!1);tU(oe(Pe),Re,ue)}else{var Qe=m.open(W,ee);Qe.onblocked=function(Ze){uE(a,W,"Db Open Blocked event ["+se+"] - "+(Qe.error||"")),ue(new Error(fq))},Qe.onerror=function(Ze){uE(a,W,"Db Open Error event ["+se+"] - "+(Qe.error||"")),ue(new Error(fq))},Qe.onupgradeneeded=function(Ze){oL(W,"Db Open Create/Upgrade needed event ["+se+"]");try{var Xe=Ze.target[fCe];if(!Xe)return void ue(new Error(fq));He(Xe,Qe)}catch(bt){sQe(W,fq,ue,se)(bt)}},Qe.onsuccess=function(Ze){var Xe=Ze.target[fCe];Xe?be(Xe,Qe):ue(new Error(fq))}}})})},u.closeDb=function(W){N(W,"closeDb",function(ee){var oe=vq(W),de=oe.dbHdl,se=de.length;if(se>0){for(var Re=0;Re<se;Re++)de[Re].close();oe.dbHdl=[]}return 1}).catch(function(ee){})},u.deleteDb=function(W){return m!=null&&N(W,"deleteDb",function(ee){var oe=vq(W),de=oe.dbHdl,se=de.length;if(se>0){uE(a,W,"Db is open ["+se+"] force closing");for(var Re=0;Re<se;Re++)de[Re].close();oe.dbHdl=[]}return Sp(function(ue,Ne){setTimeout(function(){try{oL(W,"["+ee+"] starting");var ze=m.deleteDatabase(W);ze.onerror=function(He){uE(a,W,"["+ee+"] error!!"),Ne(new Error(bae))},ze.onblocked=function(He){uE(a,W,"["+ee+"] blocked!!"),Ne(new Error(bae))},ze.onupgradeneeded=function(He){uE(a,W,"["+ee+"] upgrade needed!!"),Ne(new Error(bae))},ze.onsuccess=function(He){oL(W,"["+ee+"] complete"),ue(!0)},oL(W,"["+ee+"] started")}catch(He){uE(a,W,"["+ee+"] threw - "+He),Ne(new Error(bae+" - "+He))}},0)})})},u.getDbDetails=function(W){return N(W,"getDbDetails",function(ee){return m!=null&&m.databases?Sp(function(oe,de){m.databases().then(function(se){for(var Re=0;Re<se.length;Re++)if(se[Re].name===W)return void oe(se[Re]);de(new Error(BAi))},de)}):XD(new Error(UAi))},2e3)}})}return n.__ieDyn=1,n}(),GAi=function(){function n(a){var s=[],c=null;Ec(n,this,function(u){u.keyRange=function(){return c},u.parseQuery=function(m){if(s=[],m)for(var b=m.split(";"),_=0;_<b.length;_++){var k=b[_],N=k.indexOf("=");if(N!==-1){var W=k.substring(0,N),ee=k.substring(N+1);W.indexOf("#")===0&&(W=W.substring(1),c||(c=IDBKeyRange.bound(ee,ee+"￿"))),u.startsWith(W,ee)}}},u.startsWith=function(m,b){s.push({name:m,value:b,type:0})},u.contains=function(m,b){s.push({name:m,value:b,type:1})},u.isMatch=function(m){if(!s||s.length===0)return!0;if(!m)return!1;for(var b=0;b<s.length;b++){var _=s[b],k=m[_.name];if(k){if(_.type===0){if(k.indexOf(_.value)!==0)return!1}else if(_.type===1&&k.indexOf(_.value)===-1)return!1}}return!0},a&&u.parseQuery(a)})}return n.__ieDyn=1,n}(),qAi=10,WAi=1,KAi=6e5,yCe=6048e5,JAi="Unknown",YAi=-1,R$="DBError: Unable to add event",QAi="DBError: Unable to update iKey",ZAi=1,sL="Evts",yq="iKey",XAi=Sae;function M$(){return new Date().getTime()}function eIi(n,a){return function(s){return a(new Error(n))}}function tIi(n){n.objectStoreNames.contains(sL)||n.createObjectStore(sL,{keyPath:"key"}).createIndex("EvntId","key",{unique:!1}),n.objectStoreNames.contains(yq)||n.createObjectStore(yq,{keyPath:"iKey"}).createIndex("iKey","iKey",{unique:!0})}function lQe(n){return n.openStore(yq,function(a){return Sp(function(s,c){var u={iKey:n.ctx.iKey,tm:M$()},m=a.store.put(u);m.onsuccess=function(b){s(m.result.toString())},m.onerror=function(b){c(new Error(R$))},m.onerror=eIi(QAi,c)})})}function cQe(n){for(var a=[],s=2;s>=1;s--)for(var c=0;c<n.length;c++){var u=n[c];u&&u.evt.persistence===s&&a.push(u.evt)}return a}function iIi(n,a){for(var s=0;s<n.length;s++)if(a.tm<n[s].tm)return void n.splice(s,0,a);n.push(a)}function nIi(n,a){for(var s=a.length,c=0;c<s;c++)if(n===a[c].id)return c;return-1}function aIi(n,a){var s=n.tm;return M$()-s>a}function Tae(n){return function(a){return n.continue()}}function SCe(n){var a=n.cursor.delete();return a.onerror=Tae(n),a.onsuccess=Tae(n),1}function rIi(n,a){return n.openCursor(sL,a,function(s,c,u){return u.push(c),0})}function dQe(n,a,s){return n.openCursor(sL,a,function(c,u,m){return s(u)?(m.push(u),SCe(c)):0})}function oIi(n){return Sp(function(a,s){var c=!1;n.openCursor(yq,null,function(u,m,b){var _=m.tm;return M$()-_<yCe?0:(c=!0,2)}).then(function(){if(c){var u={};dQe(n,null,function(m){if(!m||!m.evt||!m.evt.iKey)return!0;var b=m.tm;return M$()-b>yCe||(u[m.evt.iKey]=1,!1)}).then(function(){var m=[];n.openCursor(yq,null,function(b,_,k){var N=_.tm;return M$()-N<yCe||u[_.iKey]?0:(m.push(_),SCe(b))}).then(function(){a(m)},s)},s)}else a([])},s)})}function sIi(n,a){return n.openCursor(sL,"#key="+n.ctx.iKeyPrefix(),function(s,c){var u=c.key;if(u.indexOf(n.ctx.iKeyPrefix())===0&&u.indexOf(n.ctx.evtKeyPrefix())===-1&&aIi(c,a)){c.key=n.ctx.evtKeyPrefix()+c.id;var m=s.store.store.put(c);return m.onerror=Tae(s),m.onsuccess=function(b){try{SCe(s)}catch{s.continue()}},1}return 0})}function bCe(n,a){return Sp(function(s,c){oIi(n).then(function(){sIi(n,a).then(s,s)},c)})}function lIi(n,a){return Sp(function(s,c){var u=0,m=n.ctx.evtKeyPrefix();function b(){s(u)}function _(N,W){return Sp(function(ee){var oe=N.store.delete(W.key);oe.onsuccess=function(de){u++,ee()},oe.onerror=function(de){ee()}})}function k(N){N.length!==0?n.openStore(sL,function(W){for(var ee=[],oe=0;oe<N.length;oe++)ee.push(_(W,N[oe]));return ngi(ee).then(b,b)}):b()}n.openCursor(sL,"#key="+m,function(N,W,ee){return W.evt.persistence<=a&&W.key.indexOf(m)===0&&(iIi(ee,W),ee.length>qAi&&ee.splice(ee.length-1,1)),0}).then(k,function(){s(0)})})}var cIi=function(){function n(a,s){Ec(n,this,function(c){var u=null,m=null,b=JAi,_=null,k=null,N=null,W=YAi,ee=0,oe=KAi;function de(Re){function ue(ze){return Sp(function(He,be){tIi(ze.db),He()})}function Ne(ze){return Sp(function(He,be){var Ee={iKey:b,storageId:_,iKeyPrefix:function(){return k},evtKeyPrefix:function(){return N}};ze.ctx=Ee,tU(lQe(ze),function(){tU(Re(ze),He,be)},be)})}return u.openDb(m,ZAi,Ne,ue)}function se(Re,ue,Ne){return Sp(function(ze,He){function be(Qe,Ze){lIi(Re,Qe).then(function(Xe){Xe>0&&(ee-=Xe),Ze(Xe)},function(Xe){Ze(0)})}function Ee(Qe){ze(ue.evt)}function Pe(){Re.openStore(sL,function(Qe){var Ze=Qe.store.put(ue);Ze.onsuccess=function(Xe){Ne&&lQe(Re).then(Ee,Ee),ee++,ze(ue.evt)},Ze.onerror=function(Xe){function bt(Ot){Ot===0&&He(new Error(R$)),se(Re,ue,!1).then(function(Yt){ze(ue.evt)},function(){He(new Error(R$))})}Ne?be(1,function(Ot){Ot>0?bt(Ot):ue.evt.persistence>=2?be(2,function(Yt){bt(Yt)}):He(new Error(R$))}):He(new Error(R$))}})}W>0&&ee>=W?be(1,function(Qe){Qe===0?ue.evt.persistence>=2?be(2,function(Ze){Pe()}):He(new Error(R$)):Pe()}):Pe()})}c.id=a,c.initialize=function(Re){var ue=Re.itemCtx.diagLog();if(!(u=new jAi(ue)).isAvailable())return u=null,!1;var Ne=Re.itemCtx.getCfg(),ze=Re.storageConfig;b=Ne.instrumentationKey||b,_=c.id||Re.id||pq(),N=(k=b+"::")+_+"::",oe=ze.accessThresholdInMs||oe;var He=fae(ze,function(){W=ze.maxStorageItems;var be=ze.indexedDbName;m&&be!==m&&m&&_w(c.clear(),function(Ee){m=be,de(function(Pe){return Pe.isNew?[]:bCe(Pe,oe)}).then(function(Pe){},function(Pe){ue.warnToConsole("IndexedDbProvider failed to initialize - "+(Pe||"<unknown>")),u=null})}),m=be});return s&&s.add(He),de(function(be){return be.isNew?[]:bCe(be,oe)}).then(function(be){},function(be){ue.warnToConsole("IndexedDbProvider failed to initialize - "+(be||"<unknown>")),u=null}),!0},c._getDbgPlgTargets=function(){return[m]},c.supportsSyncRequests=function(){return!1},c.getAllEvents=function(){return u!=null&&u.isAvailable()?de(function(Re){return Sp(function(ue,Ne){rIi(Re,"#key="+Re.ctx.evtKeyPrefix()).then(function(ze){ee=ze.length,ue(cQe(ze))},Ne)})}):[]},c.addEvent=function(Re,ue,Ne){return u!=null&&u.isAvailable()?(ue.id=ue.id||pq(),XAi(ue.persistence)||(ue.persistence=1),de(function(ze){var He=Re||ue.id,be={key:ze.ctx.evtKeyPrefix()+He,id:He,evt:ue,tm:M$(),v:WAi};return se(ze,be,!0)})):ue},c.removeEvents=function(Re){if(u==null||!u.isAvailable())return[];var ue=[];return Sp(function(Ne,ze){de(function(He){return He.openCursor(sL,"#key="+He.ctx.iKey,function(be,Ee,Pe){if(nIi(Ee.id,Re)!==-1){var Qe=be.cursor.delete();return Qe.onerror=Tae(be),Qe.onsuccess=function(){ue.push(Ee.evt),be.continue()},1}return 0})}).then(function(He){ee-=ue.length,Ne(ue)},function(He){ee-=ue.length,Ne(ue)})})},c.clear=function(){return u!=null&&u.isAvailable()?Sp(function(Re,ue){de(function(Ne){return dQe(Ne,"#key="+Ne.ctx.evtKeyPrefix(),function(ze){return ze.key.indexOf(Ne.ctx.evtKeyPrefix())===0})}).then(function(Ne){ee=0,Re(cQe(Ne))},ue)}):[]},c.moveStaleEvents=function(){de(function(Re){return bCe(Re,oe)})},c.teardown=function(){u&&u.closeDb(m)}})}return n.__ieDyn=1,n}(),uQe=10,hQe="3",pQe="Version",dIi="AWTEvents",uIi=5e6;function hIi(n,a){var s=!1;return a instanceof DOMException&&(a.code!==22&&a.name!=="QuotaExceededError"&&a.code!==1014&&a.name!=="NS_ERROR_DOM_QUOTA_REACHED"||n&&n.length!==0&&(s=!0)),s}function pIi(n){var a=PN()||{},s=null;try{if(s=a[n]){var c="__storage_test__";s.setItem(c,c),s.removeItem(c)}}catch(u){hIi(s,u)||(s=null)}return s}function P$(n,a){if(n)for(var s=hC(n),c=0;c<s.length;c++){var u=s[c];if(!a(n[u],u))break}}function gIi(n){var a=!0;return P$(n,function(s,c){return s&&(a=!1),a}),a}function mIi(n,a){for(var s=1,c=0,u=function(){var b=[],_=a[s];if(P$(_,function(N,W){return b.push(W),++c<uQe}),c>0){for(var k=0;k<b.length;k++)delete _[b[k]];return{value:!0}}s++};s<=n&&c<uQe;){var m=u();if(typeof m=="object")return m.value}return c>0}var fIi=Sae,vIi=function(){function n(a,s,c){Ec(n,this,function(u){var m=null,b=dIi,_=null,k=hQe,N=null,W=null,ee=uIi,oe=6e5,de=null,se=null;function Re(be,Ee){return{key:be,db:Ee}}function ue(be,Ee){Ee===void 0&&(Ee=!0);var Pe=null;if(m){var Qe=m.getItem(be);if(Qe)try{Pe=JSON.parse(Qe)}catch{m.removeItem(be)}}return Ee&&!Pe&&(Pe={events:{1:{},2:{},3:{}},lastAccessTime:0}),Re(be,Pe)}function Ne(be,Ee){Ee===void 0&&(Ee=!0);var Pe=!0,Qe=be.db;if(Qe){Ee&&(Qe.lastAccessTime=new Date().getTime());for(var Ze=1;Ze<=2;Ze++)if(!gIi(Qe.events[Ze])){Pe=!1;break}}try{if(Pe)m&&m.removeItem(be.key);else{var Xe=JSON.stringify(Qe);if(Xe.length>ee)return!1;m&&m.setItem(be.key,Xe)}}catch{return!1}return!0}function ze(be){var Ee=[],Pe=ue(be,!1),Qe=Pe.db;if(Qe){var Ze=Qe.events;try{for(var Xe=1;Xe<=2;Xe++)P$(Ze[Xe],function(bt,Ot){return bt&&Ee.push(bt),!0})}catch{}m&&m.removeItem(Pe.key)}return Ee}function He(){if(m){for(var be=m.getItem(de),Ee=[],Pe=ue(se),Qe=!1,Ze=0;Ze<m.length;Ze++){var Xe=m.key(Ze);if(Xe.indexOf(b)===0&&Xe!==de){if(be!==hQe){Ee.push(Re(Xe,null));continue}var bt=ue(Xe,!1),Ot=bt.db;if(Ot){if(new Date().getTime()-Ot.lastAccessTime>oe){for(var Yt=1,pt=function(){var Lt=Ot.events[Yt],xt=Pe.db.events[Yt];P$(Lt,function(yi,Li){return(MU(yi.iKey)||yi.iKey)===W&&(xt[Li]=yi,delete Lt[Li]),!0}),Yt++};Yt<=2;)pt();Qe=!0,Ee.push(bt)}}else Ee.push(Re(Xe,null))}}for(Ze=0;Ze<Ee.length;Ze++)Ne(Ee[Ze],!1);Qe&&Ne(Pe),m.setItem(de,k)}}u.id=s,m=pIi(a)||null,u._getDbgPlgTargets=function(){return[b,ee]},u.initialize=function(be){if(!m)return!1;var Ee=be.storageConfig;_=u.id||be.id||pq(),N=be.itemCtx.getCfg().instrumentationKey,W=MU(N)||N,oe=Ee.accessThresholdInMs?Ee.accessThresholdInMs:oe;var Pe=fae(Ee,function(){ee=Ee.maxStorageSizeInBytes;var Qe=Ee.storageKey;b&&Qe!==b&&_w(u.clear(),function(Ze){se=(b=Qe)+"."+_,de=b+pQe,He()})});return c&&c.add(Pe),b=Ee.storageKey,se=b+"."+_,de=b+pQe,He(),!0},u.supportsSyncRequests=function(){return!0},u.getAllEvents=function(){try{var be=[],Ee=ue(se,!1).db;if(Ee)for(var Pe=Ee.events,Qe=2;Qe>=1;Qe--)P$(Pe[Qe],function(Ze){return Ze&&(MU(Ze.iKey)||Ze.iKey)===W&&be.push(Ze),!0});return be}catch(Ze){return XD(Ze)}},u.addEvent=function(be,Ee,Pe){try{var Qe=ue(se);Ee.id=Ee.id||pq(),fIi(Ee.persistence)||(Ee.persistence=1);for(var Ze=Ee.persistence,Xe=Ee.id,bt=Qe.db.events;;){if(bt[Ze][Xe]=Ee,Ne(Qe))return Ee;if(delete bt[Ze][Xe],!mIi(Ze,bt))return XD(new Error("Unable to free up event space"))}}catch(Ot){return XD(Ot)}},u.removeEvents=function(be){try{var Ee=ue(se,!1),Pe=Ee.db;if(Pe){var Qe=Pe.events;try{for(var Ze=0;Ze<be.length;++Ze){var Xe=be[Ze];delete Qe[Xe.persistence][Xe.id]}if(Ne(Ee))return be}catch{}be=ze(Ee.key)}return be}catch(bt){return XD(bt)}},u.clear=function(){try{var be=[],Ee=ue(se,!1),Pe=Ee.db;if(Pe){for(var Qe=Pe.events,Ze=function(bt){var Ot=Qe[bt];P$(Ot,function(Yt){return Yt&&(MU(Yt.iKey)||Yt.iKey)===W&&(delete Ot[Yt.id],be.push(Yt)),!0})},Xe=2;Xe>=1;Xe--)Ze(Xe);Ne(Ee)}return be}catch(bt){return XD(bt)}},u.teardown=function(){try{var be=ue(se,!1),Ee=be.db;Ee&&(Ee.lastAccessTime=0,Ne(be,!1))}catch{}},u.moveStaleEvents=function(){He()}})}return n.__ieDyn=1,n}(),yIi="4.3.1",SIi="LocalStorage",bIi=5,gQe=Sae,TIi=void 0,CIi="AppInsightEvents.1",_Ii=jD({maxStorageSizeInBytes:{isVal:aQe,v:5e6},storageKey:"AWTEvents",minPersistenceLevel:{isVal:gQe,v:1},providers:[PU.LocalStorage,PU.IndexedDb],indexedDbName:CIi,maxStorageItems:{isVal:aQe,v:TIi}}),EIi=function(n){function a(){var s=n.call(this)||this;return s.identifier=SIi,s.priority=1009,s.version=yIi,Ec(a,s,function(c,u){var m,b,_,k;function N(){m=!1,b=!1,_=null,k=[]}function W(be,Ee){_||(_=DSe(Sp,"LocalStorage")),_.queue(function(Pe){return Ee(Pe)},be).catch(function(Pe){})}function ee(be){hq(c.core,function(){return"LocalStorageChannel:_sendStoredEventsToNextPlugin"},function(){W("sendToNext",function(Ee){return _w(be.provider.getAllEvents(),function(Pe){for(var Qe=Pe.value||[],Ze=0;Ze<Qe.length;Ze++)try{var Xe=Qe[Ze];(MU(Xe.iKey)||Xe.iKey)===be.tenantId&&c.processNext(Xe,be.coreRootCtx.createNew())}catch{}})})},function(){return{iKeyConfig:be}})}function oe(be,Ee){hq(c.core,function(){return"LocalStorageChannel:_removeEvents"},function(){W("removeEvents",function(Pe){var Qe=[];if(Ra(Ee,function(Ze){(MU(Ze.iKey)||Ze.iKey)===be.tenantId&&Qe.push(Ze)}),Qe.length>0)return _w(be.provider.removeEvents(Qe),function(Ze){})})},function(){return{iKeyConfig:be,events:Ee}})}function de(be,Ee){return!(Ee.sync||Ee.persistence<be.minPersistenceCacheLevel)}function se(be){var Ee=new cIi(void 0,c._unloadHooks);return Ee.initialize(be)||(Ee=null),Ee}function Re(be,Ee){var Pe=new vIi(be,void 0,c._unloadHooks);return Pe.initialize(Ee)||(Pe=null),Pe}function ue(be){for(var Ee=be.storageConfig.providers,Pe=null,Qe=0;!Pe&&Qe<Ee.length&&Qe<bIi;)switch(Ee[Qe++]){case PU.LocalStorage:Pe=Re("localStorage",be);break;case PU.SessionStorage:Pe=Re("sessionStorage",be);break;case PU.IndexedDb:Pe=se(be)}return Pe}function Ne(be,Ee){if(be.length!==Ee.length)return!1;var Pe=!0;return Ra(be,function(Qe,Ze){if(Qe!==Ee[Ze])return Pe=!1,-1}),Pe}function ze(be,Ee,Pe,Qe){be&&(be.extensionConfig=be.extensionConfig||[]),!Qe&&Ee&&(Qe=Ee.getProcessTelContext().getNext());var Ze=null,Xe=c._getTelCtx().getNext();return Xe&&(Ze=Xe.getPlugin()),w$(Qe,be,Ee,Ze)}function He(be,Ee,Pe,Qe){var Ze=!1;if(Ra(k,function(xt){if(xt.iKey===be.instrumentationKey)return Ze=!0,-1}),!Ze){var Xe=null;c._addHook(fae(be,function(xt){var yi=w$(null,xt.cfg,Ee);Xe=yi.getExtCfg(c.identifier,_Ii);var Li=!1,cn=null,Ci=be.instrumentationKey;if(Ra(k,function(Ea){if(Ea.iKey===Ci)return Li=!0,cn=Ea,-1}),Li&&cn){var ji=Xe.providers,An=cn.preProviders;Ne(ji,An)||_w(Yt.clear(),function(Ea){if(!Ea.rejected)try{var Ln=k.indexOf(cn);Ln!==-1&&k.splice(Ln,1);var ga=ue(cn.providerContext);cn.provider=ga,cn.preProviders=ji.slice();var vs=cn.preListener;vs&&Ee.removeNotificationListener(vs);var ss={eventsSent:function(Ya){oe(cn,Ya)},eventsDiscarded:function(Ya,ir){oe(cn,Ya)}};cn.preListener=ss,k.push(cn),Ee.addNotificationListener(ss),ee(cn)}catch{}})}}));var bt=ze(be,Ee,Pe,Qe),Ot={itemCtx:bt,storageConfig:Xe,id:c.id};if(!wf(be.instrumentationKey))return;var Yt=ue(Ot),pt={iKey:be.instrumentationKey,tenantId:MU(be.instrumentationKey)||be.instrumentationKey,minPersistenceCacheLevel:1,coreRootCtx:bt,providerContext:Ot,provider:Yt,preProviders:Xe.providers.slice()};if(Yt){gQe(Xe.minPersistenceLevel||-1)&&(pt.minPersistenceCacheLevel=Xe.minPersistenceLevel);var Lt={eventsSent:function(xt){oe(pt,xt)},eventsDiscarded:function(xt,yi){oe(pt,xt)}};pt.preListener=Lt,k.push(pt),Ee.addNotificationListener(Lt),ee(pt)}else k.push(pt)}}N(),c.initialize=function(be,Ee,Pe,Qe){hq(Ee,function(){return"LocalStorageChannel.initialize"},function(){m||(u.initialize(be,Ee,Pe),u.setInitialized(!1),m=!0,_=DSe(Sp,"LocalStorage")),He(be,Ee,Pe,Qe)},function(){return{coreConfig:be,core:Ee,extensions:Pe,pluginChain:Qe}})},c.processTelemetry=function(be,Ee){var Pe=be;if(m&&!b){Ee=c._getTelCtx(Ee),OAi(be,c.identifier);var Qe=null;Ra(k,function(Xe){Xe.iKey===be.iKey&&(Qe=Xe)});var Ze=Qe?Qe.provider:null;if(Pe.sync||!Ze)return void c.processNext(Pe,Ee);Pe.id=Pe.id||pq(),Sae(Pe.persistence)||(Pe.persistence=1),de(Qe,Pe)&&W("processTelemetry",function(Xe){return Ze.addEvent(Pe.id,Pe,Ee)})}c.processNext(Pe,Ee)},c.pause=function(){b=!0},c.resume=function(){hq(c.core,function(){return"LocalStorageChannel:resume"},function(){b=!1,Ra(k,function(be){be.provider&&ee(be)})})},c._doTeardown=function(be,Ee){Ra(k,function(Pe){var Qe=Pe.provider;Qe&&Qe.teardown()}),N()},c.flush=function(be,Ee,Pe){},c._getDbgPlgTargets=function(){return[k]},c._sendStale=function(be){Ra(k,function(Ee){if(Ee&&Ee.iKey===be&&Ee.provider)return Ee.provider.moveStaleEvents(),ee(Ee),-1})}}),s}return VS(a,n),a.__ieDyn=1,a}(PAi),mQe="LocalStorage",fQe=class{constructor(n,a,s,c,u,m){this.logger=n,this.configProvider=a,this.clientInfo=s,this.contextProvider=c,this.accountCollectorURL=u,this.envOverride=m,this.manager=new Tyi,this.managerConfig=this.createConfigForManager(),this.currentTransmitProfile=ke.REPORTING_PROFILE.RT_PROFILE,this.initManager(),this.uiVersion=this.getUiVersion(),this.configProvider.on("configUpdated",()=>this.updateChannelConfig())}createLogger(n,a){return new AIi(n,this.manager,this.logger,this.configProvider,this.uiVersion,a,this.contextProvider,this.envOverride)}createConfigForManager(){return{channels:[],extensionConfig:{},propertyConfiguration:{populateBrowserInfo:!0,populateOperatingSystemInfo:!0},channelConfiguration:{eventsLimitInMem:this.configProvider.config.eventsLimitInMem,disableFetchKeepAlive:this.configProvider.config.oneDSDisableFetchKeepAlive,useSendBeacon:this.configProvider.config.oneDSUseSendBeacon},endpointUrl:this.accountCollectorURL,enableCompoundKey:this.configProvider.config.enableCompoundKey,disablePageUnloadEvents:this.configProvider.config.oneDSDisabledPageUnloadEvents}}getUiVersion(){const n=this.clientInfo.match(/^.*?\/(\d+\/)(.*?)\/.*$/);return n?n[1]+n[2]:this.clientInfo}updateChannelConfig(){this.configProvider.config.eventsLimitInMem!==this.managerConfig.channelConfiguration.eventsLimitInMem&&this.manager.getPostChannel().setEventQueueLimits(this.configProvider.config.eventsLimitInMem),this.setTransmitProfile()}initManager(){this.initLocalStorageChannel(),this.manager.create(this.managerConfig,[]),this.manager.getNotifyMgr().addNotificationListener({eventsDiscarded:(n,a)=>this.logDiscardedEvents(n,a),eventsSent:n=>this.logSentEvents(n)}),this.setTransmitProfile()}initLocalStorageChannel(){if(!this.configProvider.config.useLocalStorageForOneDs)return;const n=new EIi;this.managerConfig.channels.push([n]);const a={storageKey:"TsCalling",accessThresholdInMs:this.configProvider.config.oneDSLocalStorage.accessThresholdInMs??6e5};this.managerConfig.extensionConfig[mQe]=a}logDiscardedEvents(n,a){let s="discarded events:";n.forEach(c=>s=`${s+c.name};`),this.logger.info(`${s} reason:${a}`)}logSentEvents(n){let a=`sent events: ${n[0]?.data?.CorrelationId&&lw("value",n[0].data.CorrelationId)}:`;n.forEach(s=>{a=`${a+s.name};`}),this.logger.info(`${a}`)}setTransmitProfile(){this.configProvider.config.transmitProfileTimings.length&&this.manager.getPostChannel()._loadTransmitProfiles({[this.configProvider.config.transmitProfileName]:this.configProvider.config.transmitProfileTimings}),this.configProvider.config.transmitProfileName!==this.currentTransmitProfile&&this.manager.getPostChannel()._setTransmitProfile(this.configProvider.config.transmitProfileName),this.currentTransmitProfile=this.configProvider.config.transmitProfileName}},AIi=class{constructor(n,a,s,c,u,m,b,_){this.tenant=n,this.manager=a,this.logger=s,this.configProvider=c,this.uiVersion=u,this.eventLatency=m,this.contextProvider=b,this.envOverride=_,this.instanceConfig={extensions:[],extensionConfig:{}};const{oneDSLocalStorage:k,oneDSNotificationManager:N}=this.configProvider.config;N.blockEventsDiscardedNotifications&&this.blockEventsDiscarded(),N.blockNotificationsOnPageUnload&&this.blockNotificationListenersOnPageUnload(),k.sendStaleEvents&&this.sendStaleEvents()}sendEvent(n){this.setEnvPropertiesToEveryEvent();const a=n.props,s={};switch(this.logger.info(`preparing event for delivery: ${n.props?.CorrelationId??""}/${n.eventName}`),this.tenant){case"signaling":a.SkypeId&&(s.user_id={value:a.SkypeId,kind:10},s.Skype_InitiatingUser_Username={value:a.SkypeId,kind:10},s.SkypeId={value:a.SkypeId,kind:10},delete a.SkypeId),this.uiVersion&&(s.ui_version={value:this.uiVersion,kind:0});break;case"media":case"tlePlayer":this.uiVersion&&(s.uiVersion={value:this.uiVersion,kind:0});break;case"realtimeMedia":this.uiVersion&&(s["AppInfo.Version"]={value:this.uiVersion,kind:0})}for(const u of Object.keys(a)){const m=a[u];s[u]={value:m?.value??m,kind:m?.piiKind??0}}const c={name:n.eventName,data:s,latency:this.eventLatency,persistence:lfi.Normal,sync:this.configProvider.config.oneDSEventSendType};this.configProvider.config.smallCallTelemetry.enable&&c.name==="mdsc_webrtc_call_session"&&(c.sync=this.configProvider.config.smallCallTelemetry.eventSendType),this.logger.info(`about to send event ${JSON.stringify(T0i.omit(c,["LocalUser","TargetUser"]))}`),this.applicationInsights.track(c)}sendStaleEvents(){this.logger.info("preparing to send stalled telemetry events");const n=this.applicationInsights.getPlugin(mQe).plugin;n._sendStale&&n._sendStale(this.tenantToken)}get applicationInsights(){return this.manager.getInst(this.tenantToken)??this.manager.newInst(this.tenantToken,this.instanceConfig,[])}get tenantToken(){return this.configProvider.config.telemetryTenants[this.tenant]}blockNotificationListenersOnPageUnload(){let n=!1;const a=()=>{n=!0},s=()=>{n=!1};window.addEventListener("beforeunload",a),window.addEventListener("unload",a),window.addEventListener("pagehide",a),window.addEventListener("visibilitychange",()=>{document.visibilityState==="hidden"?a():s()}),this.applicationInsights.getNotifyMgr().listeners.forEach(c=>{const{eventsSent:u,eventsDiscarded:m}=c;u&&(c.eventsSent=b=>{n?this.logger.info("1DS eventSent was not raised due to page unload"):u(b)}),m&&(c.eventsDiscarded=(b,_)=>{n?this.logger.log("1DS eventsDiscarded was not raised due to page unload"):m(b,_)})})}blockEventsDiscarded(){this.applicationInsights.getNotifyMgr().listeners.forEach(n=>{n.eventsDiscarded=(a,s)=>{this.logger.log(`1DS eventsDiscarded with reason ${s} was not raised due to configuration`)}})}setEnvPropertiesToEveryEvent(){const n=this.contextProvider?.();if(!xc(this.ctx,n)&&(this.ctx=n,this.ctx))if(this.envOverride){for(const a of Object.keys(this.envOverride||{}))if(this.ctx[a]){const s=this.ctx[a].piiKind??0,c=jee(this.ctx[a].value);this.manager.getPropertyManager().setProperty(this.envOverride[a],{value:c,kind:s})}}else for(const a of Object.keys(this.ctx)){const s=this.ctx[a].piiKind??0,c=jee(this.ctx[a].value);this.manager.getPropertyManager().setProperty(a,{value:c,kind:s})}}},kw=class extends Error{constructor(n,a=1){super(n),this.callSupport=a}};function TCe(n){let a={};return n.telemetryLoggers?a=n.telemetryLoggers:n.telemetryService?.getGenericTelemetryLogger&&n.telemetryTenants?Object.keys(n.telemetryTenants).forEach(s=>a[s]=n.telemetryService.getGenericTelemetryLogger(n.telemetryTenants[s])):n.telemetryService&&(n.telemetryService.sendEvents||n.telemetryService.getCallingAdapter)&&(n.telemetryService.sendEvents&&(a.media={sendEvent(s){s.eventName&&(s.eventName=s.eventName.replace(/^(mdsc_)/,"")),n.telemetryService.sendEvents([s])}},a.tlePlayer={sendEvent(s){s.eventName&&(s.eventName=s.eventName.replace(/^(mdsc_)/,"")),n.telemetryService.sendEvents([s])}}),n.telemetryService?.sendRealTimeEvents&&(a.realtimeMedia={sendEvent(s){s.eventName&&(s.eventName=s.eventName.replace(/^(mdsc_)/,"")),n.telemetryService.sendRealTimeEvents([s])}}),n.telemetryService.getCallingAdapter&&(a.signaling={sendEvent(s){n.telemetryService.getCallingAdapter().sendEvent(s.eventName,s.props)}})),a}function IIi(n,a,s,c,u,m){const b={signaling:[],media:[],tlePlayer:[],realtimeMedia:[]};let _={signaling:{sendEvent:k=>b.signaling.push(k)},media:{sendEvent:k=>b.media.push(k)},tlePlayer:{sendEvent:k=>b.tlePlayer.push(k)},realtimeMedia:{sendEvent:k=>b.realtimeMedia.push(k)},gtcAudit:{sendEvent:k=>b.realtimeMedia.push(k)}};return a.getConfigReceivedOrTimeout().then(async()=>{let k=(await u)?.serviceUrls?.OneDsCollectorUrl;if(k=k??a.config.collectorUrl,k){const N=new fQe(n,a,s,c,k);_.signaling=N.createLogger("signaling",a.config.eventLatency),_.media=N.createLogger("media",a.config.eventLatency),_.tlePlayer=N.createLogger("tlePlayer",a.config.eventLatency),_.gtcAudit=N.createLogger("gtcAudit",Ebe.Immediate);const W=new fQe(n,a,s,c,k,{"UserInfo.Ring":"Ring","UserInfo.TenantId":"TenantId","AppInfo.ClientType":"client_type","UserInfo.ETag":"AppInfo.EcsEtag",appversion:"First/Second Client VDI Desktop Version",vdiMode:"First/Second Client VDI Mode",vdiConnectedState:"First/Second Client VDI Connected State",vdiShimVersion:"First/Second Client VDI Shim Version",vdiProvider:"First/Second Client VDI Provider Version"});_.realtimeMedia=W.createLogger("realtimeMedia",a.config.eventLatencyRealTime)}else _=TCe(m);for(const[N,W]of Object.entries(b))for(const ee of W)_[N].sendEvent(ee)}),_}var CCe=class RCe extends Qs{constructor(a,s){super(),this._config=a,this._ecsProvider=s,this.callRegistries=[],this._logger=new aN(this._config.logger).createChild("PluginlessStack"),this._platformManager=new vYe,this._waitForAccountConfiguration=new Pi,this.platformCallConstraintsProvider=new Bg(this._logger.createChild("PlatformConstraintsProvider"))}async initializeMediaAgent(a){if(this._mediaAgent)throw new kw("Media agent is already initialized");let s,c=null;if(!this._mediaAgentProvider)throw new kw("PluginlessStack initialize MediaAgent error, Media Stack not initialized",c);try{this._relayManagerProvider=new RG(a,this._signalingAgentProvider,this._ecsProvider,this._logger),s=await this._mediaAgentProvider.buildAgent(this._config.platformType,this._relayManagerProvider,this._midCallTelemetry)}catch(u){c=u.some(b=>b.reason==="incompatible_version")?2:1}if(!this._config.usePlatformSupportApi&&!this._config.callSettings?.useLwjForAllCalls){if(c)throw new kw("PluginlessStack initialization failed",c);{const u=new vYe().getPlatformSupportLevel(!0);if(u!==1&&u!==2)throw new kw("PluginlessStack initialization failed",1)}}s?(this._screenSharingManager=new g0i(s.getScreenSharingManager()),this._waitForAccountConfigurationTimeout=window.setTimeout(()=>{this._waitForAccountConfiguration.resolve(void 0),this._waitForAccountConfigurationTimeout=void 0},3e4),this._oneDsTelemetryLoggers=IIi(this._logger.createChild("OneDsLogger"),s.getConfigProvider(),a.clientInformation,this._config.telemetryContextProvider,this._waitForAccountConfiguration.promise,this._config),s.getConfigProvider().config.useOneDsLogger&&(this.signalingLoggerAdapter={sendEvent:(u,m)=>{const b={eventName:u,props:m};this._oneDsTelemetryLoggers.signaling.sendEvent(b)}}),this._mediaAgent=s,this._e911=new p0i(this._relayManagerProvider,this._mediaAgent.getConfigProvider(),this._logger.createChild("E911")),this._e911?.changed(()=>{this.event("e911InfoChanged").raise(this._e911?.info,this._e911?.areaContent)})):this._deviceManager=new fve}async initializeSignalingAgentProvider(a){this._trouterService=a.trouterService,this._signalingAgentProvider=b0i.build(a.signalingAgentConfig,this._ecsProvider,this._config.logger,this.signalingLoggerAdapter)}static async build(a,s,c){try{const u=new RCe({detectH264Support:a.mediaAgentFactoryConfig.detectH264Support,domOverrides:a.mediaAgentFactoryConfig.domOverrides,mediaSettings:a.mediaAgentFactoryConfig.settings,logger:a.logger,telemetryLoggers:a.telemetryLoggers,telemetryService:a.telemetryService,telemetryTenants:a.telemetryTenants,telemetryContextProvider:a.telemetryContextProvider,platformType:a.platformType,callSettings:a.callSettings,usePlatformSupportApi:a.usePlatformSupportApi,clientInformation:a.signalingAgentConfig.clientInformation,vdi3diagnostics:a.vdi3diagnostics},s);return u.initializeMediaProvider({detectH264Support:a.mediaAgentFactoryConfig.detectH264Support,domOverrides:a.mediaAgentFactoryConfig.domOverrides,mediaSettings:a.mediaAgentFactoryConfig.settings,logger:a.mediaAgentFactoryConfig.logger,safeLogger:a.mediaAgentFactoryConfig.safeLogger,webcvProvider:a.mediaAgentFactoryConfig.webcvProvider,wasmdnsProvider:a.mediaAgentFactoryConfig.wasmdnsProvider,wasmaecProvider:a.mediaAgentFactoryConfig.wasmaecProvider,wasmVqeProvider:a.mediaAgentFactoryConfig.wasmVqeProvider,createWasmWorkerCbs:a.mediaAgentFactoryConfig.createWasmWorkerCbs,encodedStreamsWorkerProvider:a.mediaAgentFactoryConfig.encodedStreamsWorkerProvider,clientInformation:a.signalingAgentConfig.clientInformation}),u.setMidCallTelemetry(c),u.initializeSignalingAgentProvider({signalingAgentConfig:a.signalingAgentConfig,trouterService:a.trouterService}),await u.initializeMediaAgent({httpRequestDispatcher:a.mediaAgentFactoryConfig.httpRequestDispatcher,tokenProvider:a.mediaAgentFactoryConfig.tokenProvider,configProvider:a.mediaAgentFactoryConfig.configProvider,appStateProvider:a.mediaAgentFactoryConfig.appStateProvider,clientInformation:a.signalingAgentConfig.clientInformation,trapTokenCredentialsProvider:a.mediaAgentFactoryConfig.trapTokenCredentialsProvider,relayManager:a.mediaAgentFactoryConfig.relayManager}),u}catch(u){throw u instanceof kw?u:new kw(`${u}`)}}static async buildBaseStack(a,s){const c=new RCe(a,s);return c.initializeMediaProvider({detectH264Support:a.detectH264Support,domOverrides:a.domOverrides,mediaSettings:a.mediaSettings,logger:a.logger,safeLogger:a.safeLogger,webcvProvider:a.webcvProvider,wasmdnsProvider:a.wasmdnsProvider,wasmaecProvider:a.wasmaecProvider,wasmVqeProvider:a.wasmVqeProvider,createWasmWorkerCbs:a.createWasmWorkerCbs,encodedStreamsWorkerProvider:a.encodedStreamsWorkerProvider,clientInformation:a.clientInformation}),c}async init(){}async dispose(a=hi()){const s=this._logger.createFnLogger("dispose",a);s.info("Dispose"),this._ecsProvider.dispose(),this._e911?.dispose();const c=m=>{s.warn("Failed:",m)},u=this.callRegistries.map(m=>m.dispose(a).catch(c));await Promise.all(u),await this._mediaAgentProvider.dispose(a),s.info("media agent is disposed"),this.callRegistries=[],s.info("call registries are disposed"),this._screenSharingManager&&(this._screenSharingManager.dispose(a),this._screenSharingManager=void 0,s.info("screensharing manager is disposed")),this._deviceManager=void 0,super.dispose()}getCallRegistry(){return this._logger.info("returning default callRegistry"),this.callRegistries[0]?this.callRegistries[0]:this._createCallRegistry()}async createCallRegistry(a,s=hi()){const c=a?wy(a.id):void 0,u=this._logger.createFnLogger(`createCallRegistry[identity=${c}]`,s),m=this.callRegistries.find(b=>b.identity===a.id);return m&&!m.isDisposing?(u.info(`callRegistry already exists for ${wy(a.id)}`),m):(m?.isDisposing&&await m.disposePromise,this._createCallRegistry(a))}createCompositor(a){throw new Error("Method not implemented.")}_createCallRegistry(a){if(!this._trouterService)throw new kw("Unable to create call registry, trouter service undefined");if(!this._mediaAgent)throw new kw("Unable to create call registry, media agent undefined");if(!this._signalingAgentProvider)throw new kw("Unable to create call registry, signaling agent undefined");const s=new oie(this._trouterService,this._signalingAgentProvider,this._mediaAgent,this._logger,TCe(this._config),this._ecsProvider,a,this._oneDsTelemetryLoggers,this._config.vdi3diagnostics);return s.on("disposed",()=>{this.callRegistries.splice(this.callRegistries.indexOf(s),1)}),s.on("accountConfigurationReceived",c=>{this._waitForAccountConfiguration.isPending&&(this._waitForAccountConfiguration.resolve(c),window.clearTimeout(this._waitForAccountConfigurationTimeout)),this._relayManagerProvider.getOrCreateRelayManager().setDefaultRelayConfig(c.relayConfig),this._relayManagerProvider.getOrCreateRelayManager().setClientSupportsGenericTokenApi(c.clientSupportsGenericTokenAPI)}),s.on("locationInfoSet",(c,u)=>{this._e911?.setClientInfo(c,u)}),this._relayManagerProvider.getOrCreateRelayManager(),this.callRegistries.push(s),s}initializeMediaProvider(a){const s=(0,oV.assign)({},a);this._mediaAgentProvider=new h0i(s,this._ecsProvider,this.platformCallConstraintsProvider),this._deviceManager=new B7e(this._mediaAgentProvider.getDeviceManager())}setMidCallTelemetry(a){this._midCallTelemetry=a}getDeviceManager(){return this._deviceManager}async getDeviceManagerAsync(){return this._deviceManager}createDeviceManager(a){return this._deviceManager}getScreenSharingManager(){return this._screenSharingManager}getSetup(){}getEcsProvider(){return this._ecsProvider}async getEcsProviderAsync(){return this._ecsProvider}getCallFeedback(){return null}getAiMdp(){return null}fireIntent(a,s){}getVersion(){return{build:wu(),ovb:UR()}}async getVersionAsync(){return{build:wu(),ovb:UR()}}getMediaStatus(){return null}getVideoCapabilityLimits(){return null}async setMediaConfig(a){this._mediaAgent.setMediaConfig(a)}async getE911Info(){return this._e911?.getInfo()}setPlatformCallConstraints(a){this.platformCallConstraintsProvider.setConstraints(a)}getPlatformSupportLevel(){return this._platformManager.getPlatformSupportLevel(!!this._mediaAgent)}async getPlatformSupportLevelAsync(){return this.getPlatformSupportLevel()}getLiveStreamClient(){const a=()=>TCe(this._config).tlePlayer;return new mve(this._ecsProvider.createEcsConfiguration(),this._logger.createChild("LiveStreamClient"),a)}createVoipCallCoordinator(){}async setLogFileName(a,s,c){throw new Error("not supported")}aggregateDiagnosticLogs(a){return Promise.reject("not supported")}submitBrbReport(a,s){return Promise.reject("not supported")}extendBrbFeedback(a,s){return Promise.reject("not supported")}async addOcclusion(a,s,c,u,m,b){}async removeOcclusion(a,s,c,u){}async flushLogs(){throw new Error("not supported")}getDebugDump(){return this._mediaAgent&&cG(JSON.stringify(this._mediaAgent.getDiagnosticsData()))}async getStageCapability(){throw new Error("not supported")}async getAiCameraCapability(){throw new Error("not supported")}createAiCameraManager(){throw new Error("not supported")}async disposeMediaAgent(a=hi()){if(!this._mediaAgent)throw new kw("_mediaAgent is not initialized");await this._mediaAgent?.dispose(a),this._mediaAgent=null}async updateSignalingAgentProviderConfig(a){if(!this._signalingAgentProvider)throw new kw("_signalingAgentProvider not initialized");this._trouterService=a.trouterService,this._signalingAgentProvider.getSignalingAgent().updateSignalingAgentConfig(a.signalingAgentConfig)}},wIi={build(n,a=!0){const s=n.telemetryContextProvider?.(),c=new GTe(s),u=new Mhi;return a&&Dhi(n,c,u),CCe.build(n,c,u)},buildBaseStack(n){const a=n.telemetryContextProvider?.(),s=new GTe(a);return CCe.buildBaseStack(n,s)},getVersion:()=>({build:wu(),ovb:UR()})},kIi=[{className:N7e,props:["callId","endpointId","participantId","callMode","spamRiskLevel","spamStirAttestation","groupId","threadId","messageId","backroomThreadId","lobbyThreadId","streamThreadId","callType","conversationType","calleeAlternateId","callerMri","acceptedElsewhereBy","state","terminatedReason","failureType","callEndDiagnosticsInfo","transferDiagnosticsInfo","capabilities","transferState","parkState","origin","isPreheatEnabled","publishedStates","participants","dominantSpeakerInfo","slowedDownActiveTalkerInfo","callStartedAt","callHeldAt","participantCounts","conversationStartTime","isAudioStreamConnected","isVideoOn","isScreenSharingOn","isIncomingOneOnOneVideoCall","localMediaStreams","mediaStreams","isMuted","isServerMuted","isSpeakerMuted","conversationId","isEmergency","isCast","isHuddleGroupCall","label","isHostless","endpoints","meetingDetails","meetingStates","role","meetingRole","advancedMeetingRole","meetingRoles","participantType","tenantId","transferorMri","transferorDisplayName","transferorType","consultativeCallId","callQueueInfo","incomingCallType","invitationData","customHeaderContext","clientTransferContext","onBehalfOfMri","onBehalfOfUserDisplayName","callPhoneLineType","forwardingDestinationType","optimalVideoCount","maxIncomingVideoCount","maxIncomingVbssCount","contentSharingSessions","screenSharingControl","ptzHandler","broadcastMeeting","broadcastMetadata","dataChannelAdapter","meetingData","meetingInfo","region","meetingGroupDetails","breakoutDetails","videoLayout","callLimits","redirectionProperties","fromApplicationType","maskedIdentityDetails","complianceRecordingContent","bannerContent","callQueueSupervisorContent","supervisorCallQueueMri","meetingLayoutDetails","compositionServiceDetails","joinAsStreamingUser","otpIdentity","enableCaptcha","groupKeyManagerMri","sendSignalLevel","displayNameSource","getIncomingRawAudioStream","getUnmixedAudioProvider","init","initAsync","setDeviceManager","forceUpdate","join","joinCallWithoutCallModality","start","startCallToVoicemail","startCallWithNudge","startWithMeetingData","joinWithMeetingData","subscribeWithMeetingData","startAndUnpark","unpark","joinPreheatedCall","park","updateMeetingRoles","acknowledge","accept","reject","admitParticipant","admit","addParticipant","nudgeParticipants","updateParticipantsProperties","callMeBack","removeParticipant","stop","cancelNudge","mute","unmute","muteParticipants","muteSpeaker","unmuteSpeaker","getSpeakerVolume","setSpeakerVolume","hold","unhold","updateEndpointMetadata","sendDtmfTone","setMaxVideoChannels","setMaxVbssChannels","startVideo","stopVideo","startAudio","stopAudio","startScreenSharing","changeCropRegion","stopScreenSharing","isRecordingLocally","startLocalRecording","stopLocalRecording","includeSystemAudioInLocalRecording","startDataChannel","stopDataChannel","sendUserEvents","shareSystemSound","startFaceStream","stopFaceStream","startInRoomFaceAtrribution","stopInRoomFaceAtrribution","startMultichannelAudioDevice","stopMultichannelAudioDevice","transferCall","callBlindTransfer","callSafeTransfer","transferCallToVoicemail","callConsultativeTransfer","consultativeTransferWithPickupCode","callRedirect","assimilate","merge","getServerHoldLocation","getJoinBlob","getTechnicalInformationJson","createContentSharingSession","setAudioUsageMode","setAudioMidcallConfig","setAudioMidcallConfigJson","setParticipantSpatialAudioPositions","reconnect","provideCallQualityFeedback","dumpVideoSourceImages","addGroupModality","addParticipants","addBroadcastModality","mergeWithPickupCode","publishState","publishStatesForEveryone","removeState","removeStatesForEveryone","updateMeetingSettings","updateMeetingGroups","updateMeetingLiveState","updateParticipantInterpretationState","joinMeetingGroup","leaveMeetingGroup","mergeParticipants","sendMessages","setMeetingLayout","updateMonitorSession","updateMeetingStates","showCQFInfo","isCqfRendered","provideCallQualityFeedbackEx","searchParticipants","getAllParticipants","getMediaTelemetry","getMediaSessionStats","getMediaSessionStatsAsync","getMediaLogs","setVideoMidcallConfigJson","pictureInPicture","setPlatformCallConstraints","setCallConstraints","switchInterpreterGroup","setLiveInterpretationAttributes","selectDevices","getSelectDevices","createStage","setAudioStreamConnectedAsync","setSpamRiskLevelAsync","setSpamStirAttestationAsync","setDominantSpeakerInfoAsync","setSlowedDownActiveTalkerInfoAsync","changed","on","once","changedAsync","onAsync","onceAsync"]},{className:oie,props:["calls","identity","setConfiguration","updateDisplayName","updateSkypeToken","updateToken","fireIntent","getSetup","getEcsConfig","dispose","createCallAsync","getCall","getCallState","debugInformation","setLocationInfo","createDownloader","getUnassembledLocalRecordingSessions","submitBrbReport","extendBrbFeedback","initialize","logout","init","uninit","login","createCall","createCallWithGroupId","createCallWithMeetingData","deleteCall","deleteCallAsync","enableWindowUninitEventHandler","disableWindowUninitEventHandler","enableWindowUninitEventHandlerAsync","disableWindowUninitEventHandlerAsync","changed","on","once","changedAsync","onAsync","onceAsync"]},{className:s7e,props:["id","displayName","role","tenantId","voiceLevel","isServerMuted","state","stateReason","streams","participantCapabilities","acceptedBy","endpoints","contentSharingRole","callEndDiagnosticsInfo","balanceUpdates","meetingRole","advancedMeetingRole","meetingRoles","participantType","otpIdentity","getSourceIdForMediaType","getDiagnosticData","getDiagnosticDataAsync","isIdentityMasked","nonMaskedId","nonMaskedDisplayName","nonMaskedObjectId","maskedIdSeqNumber","version","propertyBag","dispose","disposeAsync","changed","on","once","changedAsync","onAsync","onceAsync"]},{className:B7e,props:["getPermissionState","getPermissionStateAsync","isAudioOutputSelectionSupported","askDevicePermission","enumerateDevicesAsync","getPreferredCamera","selectDevices","getSelectedDevices","startPreview","createPreview","createPreviewRenderer","createScreenSharingPreviewRenderer","getDeviceNameAsync","getSpeakerDeviceDomIdAsync","setDeviceEffectsAsync","getDeviceEffectsCapabilityAsync","setBackgroundImageAsync","getImagePropertyAsync","transformImageAsync","sendMessageDeviceVideoEffectsAsync","sendMessageDeviceVideoExtensibilityAsync","setVideoCaptureConfigAsync","captureVideoFrameWithoutEffectsAsync","enableSignLanguageDetectionAsync","downloadAiModel","setAudioProcessingFlags","getSpeakerVolume","getSpeakerSystemVolume","setSpeakerVolume","setSpeakerSystemVolume","unmuteMicrophone","unmuteSpeaker","getNrgLevelsForDeviceTuner","getNrgLevelPollerForDeviceTuner","setAudioEffectsAsync","getAudioFeatureCapability","getMicrophoneVolume","setMicrophoneVolume","setDeviceTelemetryData","getSourceFormats","enableShellSharing","disableShellSharing","enableParticipantCameras","registerDerivedSource","unregisterDerivedSource","getMicrophoneGeometryArrayInfoAsync","startAudioLoopbackDevice","getRawDeviceMediaStream","setRawMediaStream","unsetRawMediaStream","createAudioRenderer","getPersonalizedNoiseSuppression","getRtcAudioManager","dispose","registerCompositeVideoDevice","unregisterCompositeVideoDevice","createAudioPlayer","mapBrowserDevices","setAudioProcessingFlagsAsync","selectDevicesAsync","getSelectedDevicesAsync","getAudioFeatureProviderName","changed","on","once","changedAsync","onAsync","onceAsync"]},{className:GTe,props:["setEcsConfig","setUserEcsServerUrl","getUserEcsServerUrl","setActiveUserForEcs","getEcsQueryParameters","ecsGetUserQueryParameters","shouldTriggerCQF"]},{className:T7e,props:["controlState","role","enableScreenSharingControl","setScreenSharingControlFeatureFlag","isScreenSharingControlEnabled","initControlForSharer","initControlForViewer","shutdownControlForSharer","shutdownControlForViewer","sendRemoteControlEvent","setRenderer","setPointerImage","setLocalPointerImage","setRemotePointerImage","startPointerMode","stopPointerMode","requestControl","acceptControlRequest","denyControlRequest","grantControl","terminateControl","changed","on","once","changedAsync","onAsync","onceAsync"]},{className:BD,props:["contentSharingState","contentSharingStatus","contentSharingTerminationReason","contentSharingIdentity","contentSharingGuid","startContentSharing","joinContentSharing","updateContentSharingSessionState","takeContentSharingControl","updateContentSharingParticipantStateToViewer","stopContentSharing","changed","on","once","changedAsync","onAsync","onceAsync"]},{className:u7e,props:["addHandler","removeHandler","updateNegotiationTag"]},{className:mye,props:["id","type","rank","label","mediaSourceId","dynamicVirtualParticipantId","deviceCapabilities","ordinal","getRawStream","start","stop","selectVideoTrack","setVideoStreamConfig","getDiagnosticData","getStats","isAvailable","isStreaming","participantId","endpointId","negotiationTag","isActive","dispose","disposeAsync","changed","on","once","changedAsync","onAsync","onceAsync"]},{className:Wte,props:["id","type","rank","label","mediaSourceId","dynamicVirtualParticipantId","deviceCapabilities","ordinal","getRawStream","start","stop","selectVideoTrack","setVideoStreamConfig","getDiagnosticData","getStats","isAvailable","isStreaming","participantId","endpointId","negotiationTag","isActive","dispose","disposeAsync","changed","on","once","changedAsync","onAsync","onceAsync"]},{className:CCe,props:["init","getCallRegistry","createCallRegistry","callRegistries","cancelOperation","getDeviceManager","createDeviceManager","getScreenSharingManager","getSetup","getEcsProvider","getCallFeedback","getAiMdp","getVersion","getMediaStatus","getVideoCapabilityLimits","setMediaConfig","fireIntent","getE911Info","getLocationInfo","setAllowPrivacySensitiveApis","getGeolocationCapabilityState","getLiveStreamClient","getUmsStream","createVoipCallCoordinator","setLogFileName","aggregateDiagnosticLogs","addOcclusion","removeOcclusion","extendBrbFeedback","getDebugDump","flushLogs","getStageCapability","getAiCameraCapability","createAiCameraManager","dispose","getVersionAsync","getDeviceManagerAsync","getEcsProviderAsync","changed","on","once","changedAsync","onAsync","onceAsync"].concat(["getPlatformSupportLevel","setPlatformCallConstraints","createCompositor","initializeMediaAgent","initializeSignalingAgentProvider","disposeMediaAgent","updateSignalingAgentProviderConfig","getPlatformSupportLevelAsync"])}];if(typeof nt.exports=="object"&&typeof et=="object"){var RIi=(n,a,s,c)=>{if(a&&typeof a=="object"||typeof a=="function")for(let u of Object.getOwnPropertyNames(a))Object.prototype.hasOwnProperty.call(n,u)||u===s||Object.defineProperty(n,u,{get:()=>a[u],enumerable:!(c=Object.getOwnPropertyDescriptor(a,u))||c.enumerable});return n};nt.exports=RIi(nt.exports,et)}return nt.exports},typeof M=="object"&&typeof V=="object"?V.exports=ie(Hv,dn):typeof M=="object"?M["skype-calling-pluginless"]=ie(Hv,dn):Y["skype-calling-pluginless"]=ie(Y["@skype/rt-js-bindings"],Y.lodash)}}),B=C({"../node_modules/axios/lib/helpers/bind.js"(M,V){V.exports=function(ie,ye){return function(){for(var Ue=new Array(arguments.length),et=0;et<Ue.length;et++)Ue[et]=arguments[et];return ie.apply(ye,Ue)}}}}),L=C({"../node_modules/axios/lib/utils.js"(M,V){var Y=B(),ie=Object.prototype.toString;function ye(mn){return ie.call(mn)==="[object Array]"}function _e(mn){return mn===void 0}function Ue(mn){return mn!==null&&!_e(mn)&&mn.constructor!==null&&!_e(mn.constructor)&&typeof mn.constructor.isBuffer=="function"&&mn.constructor.isBuffer(mn)}function et(mn){return ie.call(mn)==="[object ArrayBuffer]"}function nt(mn){return typeof FormData<"u"&&mn instanceof FormData}function lt(mn){return typeof ArrayBuffer<"u"&&ArrayBuffer.isView?ArrayBuffer.isView(mn):mn&&mn.buffer&&mn.buffer instanceof ArrayBuffer}function Ct(mn){return typeof mn=="string"}function zt(mn){return typeof mn=="number"}function li(mn){return mn!==null&&typeof mn=="object"}function ii(mn){return ie.call(mn)==="[object Date]"}function wi(mn){return ie.call(mn)==="[object File]"}function oi(mn){return ie.call(mn)==="[object Blob]"}function Gt(mn){return ie.call(mn)==="[object Function]"}function ui(mn){return li(mn)&&Gt(mn.pipe)}function $i(mn){return typeof URLSearchParams<"u"&&mn instanceof URLSearchParams}function In(mn){return mn.replace(/^\s*/,"").replace(/\s*$/,"")}function Kt(){return(typeof navigator>"u"||navigator.product!=="ReactNative"&&navigator.product!=="NativeScript"&&navigator.product!=="NS")&&typeof window<"u"&&typeof document<"u"}function ki(mn,Ir){if(mn!=null)if(typeof mn!="object"&&(mn=[mn]),ye(mn))for(var fn=0,Xn=mn.length;fn<Xn;fn++)Ir.call(null,mn[fn],fn,mn);else for(var mi in mn)Object.prototype.hasOwnProperty.call(mn,mi)&&Ir.call(null,mn[mi],mi,mn)}function sa(){var mn={};function Ir(mi,wn){typeof mn[wn]=="object"&&typeof mi=="object"?mn[wn]=sa(mn[wn],mi):mn[wn]=mi}for(var fn=0,Xn=arguments.length;fn<Xn;fn++)ki(arguments[fn],Ir);return mn}function $a(){var mn={};function Ir(mi,wn){typeof mn[wn]=="object"&&typeof mi=="object"?mn[wn]=$a(mn[wn],mi):mn[wn]=typeof mi=="object"?$a({},mi):mi}for(var fn=0,Xn=arguments.length;fn<Xn;fn++)ki(arguments[fn],Ir);return mn}function Mr(mn,Ir,fn){return ki(Ir,function(mi,wn){mn[wn]=fn&&typeof mi=="function"?Y(mi,fn):mi}),mn}V.exports={isArray:ye,isArrayBuffer:et,isBuffer:Ue,isFormData:nt,isArrayBufferView:lt,isString:Ct,isNumber:zt,isObject:li,isUndefined:_e,isDate:ii,isFile:wi,isBlob:oi,isFunction:Gt,isStream:ui,isURLSearchParams:$i,isStandardBrowserEnv:Kt,forEach:ki,merge:sa,deepMerge:$a,extend:Mr,trim:In}}}),z=C({"../node_modules/axios/lib/helpers/buildURL.js"(M,V){var Y=L();function ie(ye){return encodeURIComponent(ye).replace(/%40/gi,"@").replace(/%3A/gi,":").replace(/%24/g,"$").replace(/%2C/gi,",").replace(/%20/g,"+").replace(/%5B/gi,"[").replace(/%5D/gi,"]")}V.exports=function(_e,Ue,et){if(!Ue)return _e;var nt;if(et)nt=et(Ue);else if(Y.isURLSearchParams(Ue))nt=Ue.toString();else{var lt=[];Y.forEach(Ue,function(li,ii){li!=null&&(Y.isArray(li)?ii+="[]":li=[li],Y.forEach(li,function(oi){Y.isDate(oi)?oi=oi.toISOString():Y.isObject(oi)&&(oi=JSON.stringify(oi)),lt.push(ie(ii)+"="+ie(oi))}))}),nt=lt.join("&")}if(nt){var Ct=_e.indexOf("#");Ct!==-1&&(_e=_e.slice(0,Ct)),_e+=(_e.indexOf("?")===-1?"?":"&")+nt}return _e}}}),H=C({"../node_modules/axios/lib/core/InterceptorManager.js"(M,V){var Y=L();function ie(){this.handlers=[]}ie.prototype.use=function(_e,Ue){return this.handlers.push({fulfilled:_e,rejected:Ue}),this.handlers.length-1},ie.prototype.eject=function(_e){this.handlers[_e]&&(this.handlers[_e]=null)},ie.prototype.forEach=function(_e){Y.forEach(this.handlers,function(et){et!==null&&_e(et)})},V.exports=ie}}),j=C({"../node_modules/axios/lib/core/transformData.js"(M,V){var Y=L();V.exports=function(ye,_e,Ue){return Y.forEach(Ue,function(nt){ye=nt(ye,_e)}),ye}}}),J=C({"../node_modules/axios/lib/cancel/isCancel.js"(M,V){V.exports=function(ie){return!(!ie||!ie.__CANCEL__)}}}),Z=C({"../node_modules/axios/lib/helpers/normalizeHeaderName.js"(M,V){var Y=L();V.exports=function(ye,_e){Y.forEach(ye,function(et,nt){nt!==_e&&nt.toUpperCase()===_e.toUpperCase()&&(ye[_e]=et,delete ye[nt])})}}}),re=C({"../node_modules/axios/lib/core/enhanceError.js"(M,V){V.exports=function(ie,ye,_e,Ue,et){return ie.config=ye,_e&&(ie.code=_e),ie.request=Ue,ie.response=et,ie.isAxiosError=!0,ie.toJSON=function(){return{message:this.message,name:this.name,description:this.description,number:this.number,fileName:this.fileName,lineNumber:this.lineNumber,columnNumber:this.columnNumber,stack:this.stack,config:this.config,code:this.code}},ie}}}),ne=C({"../node_modules/axios/lib/core/createError.js"(M,V){var Y=re();V.exports=function(ye,_e,Ue,et,nt){var lt=new Error(ye);return Y(lt,_e,Ue,et,nt)}}}),le=C({"../node_modules/axios/lib/core/settle.js"(M,V){var Y=ne();V.exports=function(ye,_e,Ue){var et=Ue.config.validateStatus;!et||et(Ue.status)?ye(Ue):_e(Y("Request failed with status code "+Ue.status,Ue.config,null,Ue.request,Ue))}}}),he=C({"../node_modules/axios/lib/helpers/isAbsoluteURL.js"(M,V){V.exports=function(ie){return/^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(ie)}}}),Me=C({"../node_modules/axios/lib/helpers/combineURLs.js"(M,V){V.exports=function(ie,ye){return ye?ie.replace(/\/+$/,"")+"/"+ye.replace(/^\/+/,""):ie}}}),Le=C({"../node_modules/axios/lib/core/buildFullPath.js"(M,V){var Y=he(),ie=Me();V.exports=function(_e,Ue){return _e&&!Y(Ue)?ie(_e,Ue):Ue}}}),pe=C({"../node_modules/axios/lib/helpers/parseHeaders.js"(M,V){var Y=L(),ie=["age","authorization","content-length","content-type","etag","expires","from","host","if-modified-since","if-unmodified-since","last-modified","location","max-forwards","proxy-authorization","referer","retry-after","user-agent"];V.exports=function(_e){var Ue,et,nt,lt={};return _e&&Y.forEach(_e.split(`
`),function(zt){if(nt=zt.indexOf(":"),Ue=Y.trim(zt.substr(0,nt)).toLowerCase(),et=Y.trim(zt.substr(nt+1)),Ue){if(lt[Ue]&&ie.indexOf(Ue)>=0)return;lt[Ue]=Ue==="set-cookie"?(lt[Ue]?lt[Ue]:[]).concat([et]):lt[Ue]?lt[Ue]+", "+et:et}}),lt}}}),te=C({"../node_modules/axios/lib/helpers/isValidXss.js"(M,V){V.exports=function(ie){return/(\b)(on\w+)=|javascript|(<\s*)(\/*)script/gi.test(ie)}}}),Se=C({"../node_modules/axios/lib/helpers/isURLSameOrigin.js"(M,V){var Y=L(),ie=te();V.exports=Y.isStandardBrowserEnv()?function(){var _e,Ue=/(msie|trident)/i.test(navigator.userAgent),et=document.createElement("a");function nt(lt){var Ct=lt;if(ie(lt))throw new Error("URL contains XSS injection attempt");return Ue&&(et.setAttribute("href",Ct),Ct=et.href),et.setAttribute("href",Ct),{href:et.href,protocol:et.protocol?et.protocol.replace(/:$/,""):"",host:et.host,search:et.search?et.search.replace(/^\?/,""):"",hash:et.hash?et.hash.replace(/^#/,""):"",hostname:et.hostname,port:et.port,pathname:et.pathname.charAt(0)==="/"?et.pathname:"/"+et.pathname}}return _e=nt(window.location.href),function(Ct){var zt=Y.isString(Ct)?nt(Ct):Ct;return zt.protocol===_e.protocol&&zt.host===_e.host}}():function(){return function(){return!0}}()}}),ce=C({"../node_modules/axios/lib/helpers/cookies.js"(M,V){var Y=L();V.exports=Y.isStandardBrowserEnv()?function(){return{write:function(_e,Ue,et,nt,lt,Ct){var zt=[];zt.push(_e+"="+encodeURIComponent(Ue)),Y.isNumber(et)&&zt.push("expires="+new Date(et).toGMTString()),Y.isString(nt)&&zt.push("path="+nt),Y.isString(lt)&&zt.push("domain="+lt),Ct===!0&&zt.push("secure"),document.cookie=zt.join("; ")},read:function(_e){var Ue=document.cookie.match(new RegExp("(^|;\\s*)("+_e+")=([^;]*)"));return Ue?decodeURIComponent(Ue[3]):null},remove:function(_e){this.write(_e,"",Date.now()-864e5)}}}():function(){return{write:function(){},read:function(){return null},remove:function(){}}}()}}),X=C({"../node_modules/axios/lib/adapters/xhr.js"(M,V){var Y=L(),ie=le(),ye=z(),_e=Le(),Ue=pe(),et=Se(),nt=ne();V.exports=function(Ct){return new Promise(function(li,ii){var wi=Ct.data,oi=Ct.headers;Y.isFormData(wi)&&delete oi["Content-Type"];var Gt=new XMLHttpRequest;if(Ct.auth){var ui=Ct.auth.username||"",$i=Ct.auth.password||"";oi.Authorization="Basic "+btoa(ui+":"+$i)}var In=_e(Ct.baseURL,Ct.url);if(Gt.open(Ct.method.toUpperCase(),ye(In,Ct.params,Ct.paramsSerializer),!0),Gt.timeout=Ct.timeout,Gt.onreadystatechange=function(){if(Gt&&Gt.readyState===4&&(Gt.status!==0||Gt.responseURL&&Gt.responseURL.indexOf("file:")===0)){var $a="getAllResponseHeaders"in Gt?Ue(Gt.getAllResponseHeaders()):null,Mr={data:Ct.responseType&&Ct.responseType!=="text"?Gt.response:Gt.responseText,status:Gt.status,statusText:Gt.statusText,headers:$a,config:Ct,request:Gt};ie(li,ii,Mr),Gt=null}},Gt.onabort=function(){Gt&&(ii(nt("Request aborted",Ct,"ECONNABORTED",Gt)),Gt=null)},Gt.onerror=function(){ii(nt("Network Error",Ct,null,Gt)),Gt=null},Gt.ontimeout=function(){var $a="timeout of "+Ct.timeout+"ms exceeded";Ct.timeoutErrorMessage&&($a=Ct.timeoutErrorMessage),ii(nt($a,Ct,"ECONNABORTED",Gt)),Gt=null},Y.isStandardBrowserEnv()){var Kt=ce(),ki=(Ct.withCredentials||et(In))&&Ct.xsrfCookieName?Kt.read(Ct.xsrfCookieName):void 0;ki&&(oi[Ct.xsrfHeaderName]=ki)}if("setRequestHeader"in Gt&&Y.forEach(oi,function($a,Mr){wi===void 0&&Mr.toLowerCase()==="content-type"?delete oi[Mr]:Gt.setRequestHeader(Mr,$a)}),Y.isUndefined(Ct.withCredentials)||(Gt.withCredentials=!!Ct.withCredentials),Ct.responseType)try{Gt.responseType=Ct.responseType}catch(sa){if(Ct.responseType!=="json")throw sa}typeof Ct.onDownloadProgress=="function"&&Gt.addEventListener("progress",Ct.onDownloadProgress),typeof Ct.onUploadProgress=="function"&&Gt.upload&&Gt.upload.addEventListener("progress",Ct.onUploadProgress),Ct.cancelToken&&Ct.cancelToken.promise.then(function($a){Gt&&(Gt.abort(),ii($a),Gt=null)}),wi===void 0&&(wi=null),Gt.send(wi)})}}}),ve=C({"../node_modules/axios/lib/defaults.js"(M,V){var Y=L(),ie=Z(),ye={"Content-Type":"application/x-www-form-urlencoded"};function _e(nt,lt){!Y.isUndefined(nt)&&Y.isUndefined(nt["Content-Type"])&&(nt["Content-Type"]=lt)}function Ue(){var nt;return(typeof XMLHttpRequest<"u"||typeof process<"u"&&Object.prototype.toString.call(process)==="[object process]")&&(nt=X()),nt}var et={adapter:Ue(),transformRequest:[function(lt,Ct){return ie(Ct,"Accept"),ie(Ct,"Content-Type"),Y.isFormData(lt)||Y.isArrayBuffer(lt)||Y.isBuffer(lt)||Y.isStream(lt)||Y.isFile(lt)||Y.isBlob(lt)?lt:Y.isArrayBufferView(lt)?lt.buffer:Y.isURLSearchParams(lt)?(_e(Ct,"application/x-www-form-urlencoded;charset=utf-8"),lt.toString()):Y.isObject(lt)?(_e(Ct,"application/json;charset=utf-8"),JSON.stringify(lt)):lt}],transformResponse:[function(lt){if(typeof lt=="string")try{lt=JSON.parse(lt)}catch{}return lt}],timeout:0,xsrfCookieName:"XSRF-TOKEN",xsrfHeaderName:"X-XSRF-TOKEN",maxContentLength:-1,validateStatus:function(lt){return lt>=200&&lt<300},headers:{common:{Accept:"application/json, text/plain, */*"}}};Y.forEach(["delete","get","head"],function(lt){et.headers[lt]={}}),Y.forEach(["post","put","patch"],function(lt){et.headers[lt]=Y.merge(ye)}),V.exports=et}}),Te=C({"../node_modules/axios/lib/core/dispatchRequest.js"(M,V){var Y=L(),ie=j(),ye=J(),_e=ve();function Ue(et){et.cancelToken&&et.cancelToken.throwIfRequested()}V.exports=function(nt){return Ue(nt),nt.headers=nt.headers||{},nt.data=ie(nt.data,nt.headers,nt.transformRequest),nt.headers=Y.merge(nt.headers.common||{},nt.headers[nt.method]||{},nt.headers),Y.forEach(["delete","get","head","post","put","patch","common"],function(Ct){delete nt.headers[Ct]}),(nt.adapter||_e.adapter)(nt).then(function(Ct){return Ue(nt),Ct.data=ie(Ct.data,Ct.headers,nt.transformResponse),Ct},function(Ct){return ye(Ct)||(Ue(nt),Ct&&Ct.response&&(Ct.response.data=ie(Ct.response.data,Ct.response.headers,nt.transformResponse))),Promise.reject(Ct)})}}}),Be=C({"../node_modules/axios/lib/core/mergeConfig.js"(M,V){var Y=L();V.exports=function(ye,_e){_e=_e||{};var Ue={},et=["url","method","params","data"],nt=["headers","auth","proxy"],lt=["baseURL","url","transformRequest","transformResponse","paramsSerializer","timeout","withCredentials","adapter","responseType","xsrfCookieName","xsrfHeaderName","onUploadProgress","onDownloadProgress","maxContentLength","validateStatus","maxRedirects","httpAgent","httpsAgent","cancelToken","socketPath"];Y.forEach(et,function(ii){_e[ii]!==void 0&&(Ue[ii]=_e[ii])}),Y.forEach(nt,function(ii){Y.isObject(_e[ii])?Ue[ii]=Y.deepMerge(ye[ii],_e[ii]):_e[ii]!==void 0?Ue[ii]=_e[ii]:Y.isObject(ye[ii])?Ue[ii]=Y.deepMerge(ye[ii]):ye[ii]!==void 0&&(Ue[ii]=ye[ii])}),Y.forEach(lt,function(ii){_e[ii]!==void 0?Ue[ii]=_e[ii]:ye[ii]!==void 0&&(Ue[ii]=ye[ii])});var Ct=et.concat(nt).concat(lt),zt=Object.keys(_e).filter(function(ii){return Ct.indexOf(ii)===-1});return Y.forEach(zt,function(ii){_e[ii]!==void 0?Ue[ii]=_e[ii]:ye[ii]!==void 0&&(Ue[ii]=ye[ii])}),Ue}}}),qe=C({"../node_modules/axios/lib/core/Axios.js"(M,V){var Y=L(),ie=z(),ye=H(),_e=Te(),Ue=Be();function et(nt){this.defaults=nt,this.interceptors={request:new ye,response:new ye}}et.prototype.request=function(lt){typeof lt=="string"?(lt=arguments[1]||{}).url=arguments[0]:lt=lt||{},(lt=Ue(this.defaults,lt)).method?lt.method=lt.method.toLowerCase():this.defaults.method?lt.method=this.defaults.method.toLowerCase():lt.method="get";var Ct=[_e,void 0],zt=Promise.resolve(lt);for(this.interceptors.request.forEach(function(ii){Ct.unshift(ii.fulfilled,ii.rejected)}),this.interceptors.response.forEach(function(ii){Ct.push(ii.fulfilled,ii.rejected)});Ct.length;)zt=zt.then(Ct.shift(),Ct.shift());return zt},et.prototype.getUri=function(lt){return lt=Ue(this.defaults,lt),ie(lt.url,lt.params,lt.paramsSerializer).replace(/^\?/,"")},Y.forEach(["delete","get","head","options"],function(lt){et.prototype[lt]=function(Ct,zt){return this.request(Y.merge(zt||{},{method:lt,url:Ct}))}}),Y.forEach(["post","put","patch"],function(lt){et.prototype[lt]=function(Ct,zt,li){return this.request(Y.merge(li||{},{method:lt,url:Ct,data:zt}))}}),V.exports=et}}),Ge=C({"../node_modules/axios/lib/cancel/Cancel.js"(M,V){function Y(ie){this.message=ie}Y.prototype.toString=function(){return"Cancel"+(this.message?": "+this.message:"")},Y.prototype.__CANCEL__=!0,V.exports=Y}}),tt=C({"../node_modules/axios/lib/cancel/CancelToken.js"(M,V){var Y=Ge();function ie(ye){if(typeof ye!="function")throw new TypeError("executor must be a function.");var _e;this.promise=new Promise(function(nt){_e=nt});var Ue=this;ye(function(nt){Ue.reason||(Ue.reason=new Y(nt),_e(Ue.reason))})}ie.prototype.throwIfRequested=function(){if(this.reason)throw this.reason},ie.source=function(){var _e;return{token:new ie(function(et){_e=et}),cancel:_e}},V.exports=ie}}),ct=C({"../node_modules/axios/lib/helpers/spread.js"(M,V){V.exports=function(ie){return function(_e){return ie.apply(null,_e)}}}}),Mt=C({"../node_modules/axios/lib/axios.js"(M,V){var Y=L(),ie=B(),ye=qe(),_e=Be();function Ue(nt){var lt=new ye(nt),Ct=ie(ye.prototype.request,lt);return Y.extend(Ct,ye.prototype,lt),Y.extend(Ct,lt),Ct}var et=Ue(ve());et.Axios=ye,et.create=function(lt){return Ue(_e(et.defaults,lt))},et.Cancel=Ge(),et.CancelToken=tt(),et.isCancel=J(),et.all=function(lt){return Promise.all(lt)},et.spread=ct(),V.exports=et,V.exports.default=et}}),ht=C({"../node_modules/axios/index.js"(M,V){V.exports=Mt()}}),vt={};E(vt,{HttpRequestDispatcherImplementation:()=>oG,ShellTrouter:()=>V0,monitor:()=>OR,stackFactory:()=>Eee,tsCallingChannel:()=>Yz}),d.exports=D(vt);var Pt="transportConfig",ni=()=>{const M=new Array(36);for(let V=0;V<M.length;V++)M[V]=Math.floor(16*Math.random());return M[14]=4,M[19]=M[19]&=-5,M[19]=M[19]|=8,M[8]=M[13]=M[18]=M[23]="-",M.map(V=>V.toString(16)).join("")},Zt="useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict",it=(M=21)=>{let V="";const Y=crypto.getRandomValues(new Uint8Array(M));for(let ie=0;ie<M;ie++)V+=Zt[63&Y[ie]];return V},Ke=class{constructor(M,V){this.logger=M,this.transportConfig=V,this._state=3,this.listeners=new Map}get state(){return this._state}get config(){return this.transportConfig||{}}addEventListener(M,V){this.logger.log(`Event listener added, type: ${M}`);const Y=this.listeners.get(M)||new Set;Y.add(V),this.listeners.set(M,Y)}removeEventListener(M,V){this.logger.log(`Event listener removed, type: ${M}`),this.listeners.get(M)?.delete(V),this.listeners.get(M)?.size===0&&this.listeners.delete(M)}handleMessage(M){const V=JSON.parse(M),Y=V.type;this.listeners.get(Y)?.forEach(ie=>{ie(V)})}},ot=class extends Ke{constructor(M,V){super(M,V),this.updateTransportState()}get tsCallingChannel(){return navigator.mediaDevices?.tsCallingChannel}dispatchEvent(M){this.tsCallingChannel?this.tsCallingChannel.sendTsCallingMessage(JSON.stringify(M)):this.logger.error("tsCallingChannel is not available.")}updateTransportState(){this.tsCallingChannel?(clearInterval(this.stateCheckTimerId),this.initTsCallingChannel(),this.tsCallingChannel.addEventListener("messagerecv",this.handleEvent.bind(this)),this._state=1):this.stateCheckTimerId=setInterval(this.updateTransportState.bind(this),500)}handleEvent(M){M.detail?.message&&super.handleMessage(M.detail.message)}initTsCallingChannel(){if(this.config.tsCallingChannel?.connectionUrl){const M=new URL(this.config.tsCallingChannel.connectionUrl);M.searchParams.set(Pt,JSON.stringify(this.config)),this.logger.log(`connectionUrl: ${M}`),this.dispatchEvent({WebViewRemotingControlChannel:{url:M.toString()}})}else this.logger.warn("tsCallingLoaderUrl was not passed in config.")}},Ht=(M,V,Y={})=>new ot(V,Y),jt=dn;function Nt(M){return!!M&&typeof M.then=="function"}function Vt(M){if(!M)return`${M}`;if(M instanceof Map)return $t(M);const V=M.toString();return V.endsWith("[object Object]")?JSON.stringify(M):V}function $t(M){const V={};return M.forEach((Y,ie)=>{V[ie.toString()]=Y}),JSON.stringify(V)}function dt(M,V,Y=0){return M&&V!==void 0&&V>-1&&M.length>V&&M.splice(Y,M.length-V),M}function yt(M,V,Y,ie=0){dt(M,Y===0?0:Y-1,ie),Y!==0&&M.push(V)}var kt=M=>{try{return new TextEncoder().encode(M).length/1024}catch{return M.length/1024}},je=class{constructor(M){this.eventLogger=M,this.subscriptions=[]}subscribe(M){return new Ae(this.subscriptions,M)}dispose(M){this.subscriptions=[]}raiseEvents(M){this.subscriptions.slice().forEach(V=>{try{V.eventHandler!==void 0&&M(V.eventHandler)}catch(Y){this.eventLogger?.warn?.("Event handler exception caught!",Vt(Y))}})}},Ae=class{constructor(M,V){this.subscriptions=M,this.eventHandler=V,this.subscriptions.push(this)}dispose(){(0,jt.remove)(this.subscriptions,M=>M===this),this.eventHandler=void 0}},xe=class extends je{constructor(M){super(M)}changed(M,V){return this.subscribe({changed:{skipEventConfig:V,handler:M},on:void 0})}on(M,V){return this.subscribe({changed:void 0,on:{name:String(M),handler:this._toEventCallback(V)}})}once(M,V,Y){let ie;const ye=(..._e)=>{ie.dispose(Y),this._toEventCallback(V)(..._e)};return ie=this.on(M,this._fromEventCallback(ye)),ie}raiseChanged(M){this.raiseEvents(V=>{if(!V.changed)return;const{skipEventConfig:Y,handler:ie}=V.changed;!this.getShouldSkipChangedEvent(M,Y)&&ie()})}event(M){return{raise:this._fromEventCallback((...V)=>this._raiseEventImpl(String(M),...V))}}_raiseEventImpl(M,...V){this.raiseEvents(Y=>Y.on&&Y.on.name===M&&Y.on.handler(...V))}_toEventCallback(M){return M}_fromEventCallback(M){return M}getShouldSkipChangedEvent(M,V){return M?.skipDominantSpeakerUpdatesOnCall?!!V?.skipDominantSpeakerUpdatesOnCall:!!M?.skipParticipantsUpdatesOnCall&&!!V?.skipParticipantsUpdatesOnCall}async onAsync(M,V){return this.on(M,V)}async onceAsync(M,V,Y){return this.once(M,V,Y)}async changedAsync(M,V){return this.changed(M,V)}async disposeAsync(M){this.dispose(M)}},gt=class{constructor(){this.isPendingInt=!0,this.promiseInt=new Promise((M,V)=>{this.resolveInt=M,this.rejectInt=V})}get resolve(){return M=>{this.isPendingInt=!1,this.resolveInt(M),this.clearTimeout()}}get reject(){return M=>{this.isPendingInt=!1,this.rejectInt(M),this.clearTimeout()}}get promise(){return this.promiseInt}get isPending(){return this.isPendingInt}setTimeout(M,V=`deferred timed out after ${M}ms`){this.isPendingInt&&(this.timeoutId=setTimeout(()=>{this.reject(V)},M))}clearTimeout(){this.timeoutId&&clearTimeout(this.timeoutId)}};function Ye(M,V=`deferred timed out after ${M}ms`){const Y=new gt;return Y.setTimeout(M,V),Y}var Fe=class{constructor(){this.rttStat=[],this.transportEventStat=[],this.channel=new Map,this.historyLength=100}registerRtt(M){yt(this.rttStat,{rtt:M,timestamp:Date.now()},this.historyLength)}markEvent(M,V){yt(this.transportEventStat,{eventName:M,timestamp:Date.now(),payload:V},this.historyLength)}setLastPingReceived(){this.lastPingReceived=Date.now()}setLastPingSent(){this.lastPingSent=Date.now()}reportChannelAdded(M){this.channel.set(M,{channelId:M,createdAt:Date.now()})}reportChannelTerminated(M){const V=this.channel.get(M);V&&(V.terminatedAt=Date.now())}getStats(M){let V=this.rttStat,Y=this.transportEventStat;return M&&(V=this.rttStat.filter(ie=>ie.timestamp>=M),Y=this.transportEventStat.filter(ie=>ie.timestamp>=M)),{rttStat:V,transportEventStat:Y,lastPingReceived:this.lastPingReceived,lastPingSent:this.lastPingSent,channelStat:Array.from(this.channel.values())}}clear(){this.rttStat=[],this.transportEventStat=[]}},St=class{constructor(M){this.statManager=M}getReport(M){const{rttStat:V,transportEventStat:Y,lastPingSent:ie,lastPingReceived:ye,channelStat:_e}=this.statManager.getStats(M);return{Transport_rttStat:JSON.stringify(V),Transport_transportEventStat:JSON.stringify(Y),Transport_lastPingSent:ie,Transport_lastPingReceived:ye,Transport_channelStat:JSON.stringify(_e)}}},Wt={handshake:{timeout:3e4,retryCount:3},transportMonitor:{connectionTimeout:3e4,monitorInterval:1e3},telemetry:{eventsLimitInMem:200,tenantToken:"1cae5691997646c98b01d15beddae7a3-ce16e198-bc32-420f-ac64-42bb916111af-6865",onedsCollectorURL:"https://ic3.events.data.microsoft.com/OneCollector/1.0/",realTimeTelemetryInterval:3e4}},Ii={TIMEOUT:"Request timedout"},en=class{constructor(M,V,Y){this.transport=M,this.statManager=V,this.logger=Y,this.onConnectionCallbackPool=new Set,this.handShakeReqAck=new Map,this.CONNECTION_TIMEOUT=Wt.handshake.timeout,this.CONNECTION_RETRY_COUNT=Wt.handshake.retryCount,this.synEvetListener=async ie=>{if(this.onConnectionCallbackPool.has(ie.reqId))this.logger.log(`Callback for ${ie.reqId} already processed`);else{this.onConnectionCallbackPool.add(ie.reqId);try{await this.onSynCallback?.(ie)}catch(ye){this.logger.log("Callback errored.",ye)}finally{this.onConnectionCallbackPool.delete(ie.reqId)}}},this.ackEvetListener=ie=>{this.onAckCallback?.(ie)},this.transport.addEventListener("syn",this.synEvetListener),this.transport.addEventListener("ack",this.ackEvetListener)}async establish(M){const V=Date.now();this.statManager.markEvent("handShakeInitiated",M);const{resolve:Y,promise:ie}=Ye(this.CONNECTION_TIMEOUT,Ii.TIMEOUT),ye=ni();this.handShakeReqAck.set(ye,Y),this.transport.dispatchEvent({type:"syn",payload:M,reqId:ye});const _e=globalThis.setInterval(()=>{this.transport.dispatchEvent({type:"syn",payload:M,reqId:ye})},this.CONNECTION_TIMEOUT/this.CONNECTION_RETRY_COUNT);return this.onAckCallback=Ue=>{const et=Date.now();this.statManager.markEvent("handShakeSuccess",{duration:et-V}),this.handShakeReqAck.get(Ue.reqId)?.(),this.handShakeReqAck.delete(Ue.reqId)},this.establishPromise=ie.finally(()=>{globalThis.clearInterval(_e),this.establishPromise=void 0}),this.establishPromise}onConnection(M){const V=Date.now();this.onSynCallback=async Y=>{await M(Y.payload),this.transport.dispatchEvent({type:"ack",reqId:Y.reqId});const ie=Date.now();this.statManager.markEvent("handShakeSuccess",{duration:ie-V,handshakePayload:Y.payload})}}dispose(){this.transport.removeEventListener("syn",this.synEvetListener),this.transport.removeEventListener("ack",this.ackEvetListener),this.handShakeReqAck.clear(),this.onConnectionCallbackPool.clear()}},sn=class{constructor(M){this.logger=M}start(M,V){if(this.intervalWorker=new Qi(this.logger.createChild("WorkerBasedTimer")),!this.intervalWorker)throw new Error("Failed to initialize worker");this.intervalWorker.setInterval(M,V)}stop(){this.intervalWorker?.clearInterval(),this.intervalWorker?.disposeTimerWorker?.()}},Qi=class{constructor(M){this.logger=M,this.timerId=it(),this.workerMessageHandler=V=>{if(V.data.type==="ping")return this.onPing();this.logger.debug(`Msg from worker: ${JSON.stringify(V)}`)},this.workerErrorHandler=V=>{this.logger.error(`Error from worker: ${JSON.stringify(V)}`)},this.createWorker()}setInterval(M,V){this.logger.debug(`Starting id: ${this.timerId}`),this.callback=M,this.timeout=V,this.doWork?.postMessage({id:this.timerId,ms:this.timeout})}clearInterval(){this.logger.debug(`Stopping id: ${this.timerId}`),this.doWork?.postMessage({stop:!0,id:this.timerId})}disposeTimerWorker(){this.doWork?(this.callback=void 0,this.doWork.removeEventListener("message",this.workerMessageHandler),this.doWork.removeEventListener("error",this.workerErrorHandler),this.doWork.terminate(),this.doWork=void 0):this.logger.error("Worker is already terminated")}onPing(){this.doWork?.postMessage({id:this.timerId,ms:this.timeout}),this.callback?.()}createWorker(){this.logger.debug("Creating worker");try{const M=new Blob([`'use strict';
                        var internalId;
                        var externalId;
                        (function () {
                            onmessage = function (event) {
                                if (event.data.stop) {
                                    if (event.data.id === externalId) {
                                        clearTimeout(internalId);
                                    }
                                    postMessage({ type: 'clearTimeoutCompleted', id: externalId });
                                }else {
                                    clearTimeout(internalId);
                                    externalId = event.data.id;
                                    internalId = setTimeout(function () {
                                        postMessage({ type: 'ping', id: externalId });
                                    }, event.data.ms);
                                }
                            };
                        })();`],{type:"text/javascript"});this.doWork=new window.Worker(window.URL.createObjectURL(M)),this.doWork.addEventListener("message",this.workerMessageHandler),this.doWork.addEventListener("error",this.workerErrorHandler),this.logger.debug("Initialized")}catch(M){throw this.logger.debug(`Worker creation failed: ${JSON.stringify(M)}`),M}}},qt=class extends xe{constructor(M,V=Wt.transportMonitor.connectionTimeout,Y){super(),this.transport=M,this.transportTimeout=V,this.logger=Y,this.heartbeats=new Map,this.monitorInterval=Wt.transportMonitor.monitorInterval,this.scheduler=new sn(this.logger),this.start(),M.addEventListener("ping",ie=>{this.handleTransportPing(ie)}),M.addEventListener("pong",ie=>{this.handleTransportPong(ie)})}async waitForTransport(){if(this.transport.state===1)return Promise.resolve();const{resolve:M,promise:V}=Ye(this.transportTimeout,`Unable to establish transport in ${this.transportTimeout}s`),Y=globalThis.setInterval(()=>{this.transport.state===1&&M()},200);return V.finally(()=>{globalThis.clearInterval(Y)})}stop(){this.logger.log("Stopping transport health check"),this.heartbeats.clear(),globalThis.clearInterval(this.monitorIntervalId),this.scheduler.stop(),this.monitorIntervalId=void 0}start(){this.logger.log("Starting transport health check");const M=()=>{this.sendHeartbeat(),this.checkTransportState()};try{this.scheduler.start(M,this.monitorInterval)}catch(V){this.logger.error(V),this.logger.log("Fallback to setInterval"),this.monitorIntervalId=globalThis.setInterval(M,this.monitorInterval)}}sendHeartbeat(){const M=Math.random();this.heartbeats.set(M,Date.now()),this.transport.dispatchEvent({type:"ping",eventId:M})}handleTransportPing({eventId:M}){this.transport.dispatchEvent({type:"pong",eventId:M})}handleTransportPong({eventId:M}){this.heartbeats.get(M)!==void 0&&(this.heartbeats.delete(M),this.lastAckTime=Date.now())}checkTransportState(){this.lastAckTime&&Date.now()-this.lastAckTime>this.transportTimeout&&(this.stop(),this.event("connectionTerminated").raise())}},ri=class extends qt{constructor(M,V,Y=3e4,ie){super(V,Y,ie),this.statManager=M,this.statManager.markEvent("monitorInitialized")}async waitForTransport(){await super.waitForTransport(),this.statManager.markEvent("transportOpen")}stop(){super.stop(),this.statManager.markEvent("transportTerminated")}sendHeartbeat(){super.sendHeartbeat(),this.statManager.setLastPingSent()}handleTransportPong(M){const V=this.heartbeats.get(M.eventId);V!==void 0&&(super.handleTransportPong(M),this.statManager.registerRtt(Date.now()-V),this.statManager.setLastPingReceived())}},Ti=class{constructor(M){this.modifiers=M,this.hasModifier=this.modifiers.length>0}transform(M){if(!this.hasModifier)return[{chunk:M,index:0}];const V=this.modifiers.reduce((Y,ie)=>ie.modify(Y),M);return Array.isArray(V)?V.map((Y,ie)=>({chunk:Y,index:ie})):[{chunk:V,index:0}]}rebuild(M){if(!this.hasModifier)return M[0].chunk;const V=[];return M.forEach(({index:Y,chunk:ie})=>{V[Y]=ie}),this.modifiers.slice().reverse().reduce((Y,ie)=>ie.reconstruct(Y),V)}},rn=class{constructor(M,V){if(this.config=V,!(V.chunkSize&&V.chunkSize>0))throw new Error(`Invalid chunkSize given: ${V.chunkSize}`);M.warn(`chunkSize set to ${V.chunkSize} bytes`)}modify(M){const V=M.length,Y=this.config.chunkSize,ie=Math.ceil(V/Y),ye=[];for(let _e=0;_e<ie;_e++){const Ue=M.substring(_e*Y,(_e+1)*Y);ye.push(Ue)}return ye}reconstruct(M){return M.reduce((V,Y)=>V+Y,"")}},Hn=class{constructor(M,V){this.logger=M,this.config=V,this.reconstructionBuffers=new Map,this.receivedIndexes=new Map,this.messageTransformer=new Ti(this.config.chunkSize?[new rn(this.logger,this.config)]:[])}dispatchMessage(M,V){const Y=M.type,ie=ni(),ye=this.messageTransformer.transform(JSON.stringify(M)),_e=ye.length;ye.forEach(Ue=>V({type:Y,messageId:ie,totalChunks:_e,message:Ue}))}onMessageReceived(M){const V=M.messageId,Y=M.totalChunks;this.reconstructionBuffers.has(V)||(this.reconstructionBuffers.set(V,[]),this.receivedIndexes.set(V,new Set));const ie=this.reconstructionBuffers.get(V),ye=this.receivedIndexes.get(V);if(ye.has(M.message.index)||(ye.add(M.message.index),ie.push(M.message)),ie.filter(_e=>!!_e).length===Y){const _e=this.messageTransformer.rebuild(ie);return this.reconstructionBuffers.delete(V),this.receivedIndexes.delete(V),_e}return null}},ha=class extends Ke{constructor(M,V){super(V,M.config),this.transport=M,this.logger=V,this.handleTransportEvent=this.handleEvent.bind(this),this.messageTransformHandler=new Hn(V.createChild("MessageTransformHandler"),this.config.messageConfig||{})}dispatchEvent(M){this.messageTransformHandler.dispatchMessage(M,this.transport.dispatchEvent.bind(this.transport))}get state(){return this.transport.state}addEventListener(M,V){this.listeners.has(M)||this.transport.addEventListener(M,this.handleTransportEvent),super.addEventListener(M,V)}removeEventListener(M,V){super.removeEventListener(M,V),this.listeners.has(M)&&this.listeners.get(M)?.size!==0||this.transport.removeEventListener(M,this.handleTransportEvent)}handleEvent(M){const V=this.messageTransformHandler.onMessageReceived(M);V&&super.handleMessage(V)}dispose(){this.listeners.forEach((M,V)=>{M.forEach(Y=>this.transport.removeEventListener(V,Y))}),this.listeners.clear()}},hr=class extends Ke{constructor(M,V,Y){super(Y,V.config),this.channelId=M,this.transport=V,this.handleTransportEvent=this.handleEvent.bind(this)}get state(){return this.transport.state}dispatchEvent(M){this.transport.dispatchEvent({...M,$$channelId:this.channelId})}addEventListener(M,V){this.listeners.has(M)||this.transport.addEventListener(M,this.handleTransportEvent),super.addEventListener(M,V)}removeEventListener(M,V){super.removeEventListener(M,V),this.listeners.has(M)&&this.listeners.get(M)?.size!==0||this.transport.removeEventListener(M,this.handleTransportEvent)}handleEvent(M){if(M.$$channelId===this.channelId){delete M.$$channelId;const V=M.type;this.listeners.get(V)?.forEach(Y=>{Y(M)})}}dispose(){this.listeners.forEach((M,V)=>{this.transport.removeEventListener(V,this.handleTransportEvent)}),this.listeners.clear()}},yn=class extends xe{constructor(M,V){super(),this.transportExt=M,this.logger=V,this.statManager=new Fe,this.transportTelemetryProvider=new St(this.statManager),this.channels=new Map,this.transport=new ha(this.transportExt,this.logger),this.handShakeService=new en(this.transport,this.statManager,this.logger),this.transportHealthCheck=new ri(this.statManager,this.transport,this.transport.config?.transportConnectionTimeout,this.logger),this.transportHealthCheck.on("connectionTerminated",()=>{this.event("connectionTerminated").raise()})}get rpcTransport(){return this.transport}async initiateConnection(M){await this.handShakeService.establish(M),this.logger.log("connection established")}async onConnection(M){this.handShakeService.onConnection(M),this.logger.log("new connection callback set")}createChannel(M){const V=this.logger.createChild(`Channel:${M}`),Y=new hr(M,this.transport,V);return this.statManager.reportChannelAdded(M),new qt(Y,this.transport.config?.transportConnectionTimeout,V.createChild("ChannelHealthCheck")).on("connectionTerminated",()=>{this.statManager.reportChannelTerminated(M),this.logger.log(`Connection terminated, channelId: ${M}`),this.channels.delete(M),Y.dispose(),this.event("connectionTerminated").raise(M)}),this.channels.set(M,Y),Y}get telemetryProvider(){return this.transportTelemetryProvider}dispose(){this.transport.dispose(),this.handShakeService.dispose(),this.channels.forEach(M=>M.dispose()),this.logger.info("Dispose: Transport Manager")}},pr="function",Ho="object",Rr="undefined",La="prototype",us=Object,al=us[La];function Us(M,V){return M||V}function $r(M,V){return M[V]}var Zd,rc=void 0,Yl=null,ci="",Ai="function",pn="object",Bn="prototype",Pa="__proto__",qa="undefined",kr="constructor",Sa="Symbol",aa="_polyfill",ti="length",on="name",Fn="call",Or="toString",Co=Us(Object),za=$r(Co,Bn),Za=Us(String),ns=$r(Za,Bn),Uu=Us(Math),ml=Us(Array),Cu=$r(ml,Bn),Xd=$r(Cu,"slice");function Il(M,V){try{return{v:M.apply(this,V)}}catch(Y){return{e:Y}}}function Pp(M,V){var Y=Il(M);return Y.e?V:Y.v}function as(M){return function(V){return typeof V===M}}function td(M){var V="[object "+M+"]";return function(Y){return!(!Y||YA(Y)!==V)}}function YA(M){return za[Or].call(M)}function bl(M){return typeof M===qa||M===qa}function rl(M){return M===Yl||bl(M)}function db(M){return M===Yl||!Dp(M)}function Dp(M){return!!M||M!==rc}function Zf(M){return M===Yl||im(typeof M)}function im(M){return!Zd&&(Zd=["string","number","boolean",qa,"symbol","bigint"]),M!==pn&&Zd.indexOf(M)!==-1}var Ld=as("string"),Xo=as(Ai);function Qh(M){return!(!M&&rl(M))&&!!M&&typeof M===pn}var jo=$r(ml,"isArray"),ZE=td("Date"),Zh=as("number"),Kv=as("boolean"),iS=td("Error");function fl(M){return!!(M&&M.then&&Xo(M.then))}function i_(M){return!(!M||Pp(function(){return!(M&&0+M)},!M))}var ol=$r(Co,"getOwnPropertyDescriptor");function Xh(M,V){return!!M&&za.hasOwnProperty[Fn](M,V)}var ch=Us($r(Co,"hasOwn"),Do);function Do(M,V){return Xh(M,V)||!!ol(M,V)}function sl(M,V,Y){if(M&&Qh(M)){for(var ie in M)if(ch(M,ie)&&V[Fn](M,ie,M[ie])===-1)break}}var zu={e:"enumerable",c:"configurable",v:"value",w:"writable",g:"get",s:"set"};function jm(M){var V={};if(V[zu.c]=!0,V[zu.e]=!0,M.l){V.get=function(){return M.l.v};var Y=ol(M.l,"v");Y&&Y.set&&(V.set=function(ie){M.l.v=ie})}return sl(M,function(ie,ye){V[zu[ie]]=bl(ye)?V[zu[ie]]:ye}),V}var Od=$r(Co,"defineProperty"),nS=$r(Co,"defineProperties");function yo(M,V,Y){return Od(M,V,jm(Y))}function oc(M,V){var Y={};return sl(V,function(ie,ye){Y[ie]=jm(ye)}),nS(M,Y)}function ub(M,V,Y,ie,ye){var _e={};return sl(M,function(Ue,et){Go(_e,Ue,V?et:Ue),Go(_e,et,Ue)}),ie?ie(_e):_e}function Go(M,V,Y,ie){Od(M,V,{value:Y,enumerable:!0,writable:!1})}var So=Us(Za),Xf="[object Error]";function zs(M,V){var Y=ci,ie=za[Or][Fn](M);ie===Xf&&(M={stack:So(M.stack),message:So(M.message),name:So(M.name)});try{Y=(Y=JSON.stringify(M,Yl,V?typeof V=="number"?V:4:rc))&&Y.replace(/"(\w+)"\s*:\s{0,1}/g,"$1: ")||So(M)}catch(ye){Y=" - "+zs(ye,V)}return ie+": "+Y}function mg(M){throw new Error(M)}function fg(M){throw new TypeError(M)}var hb=$r(Co,"freeze");function n_(M){return M}function Lk(M){return M[Pa]||Yl}var Gm=$r(Co,"assign"),Os=$r(Co,"keys");function dh(M){return hb&&sl(M,function(V,Y){(jo(Y)||Qh(Y))&&dh(Y)}),bd(M)}var bd=Us(hb,n_),pb=Us($r(Co,"getPrototypeOf"),Lk);function bT(M){return ub(M,1,0,bd)}function uh(M){return ub(M,0,0,bd)}function TT(M){var V={};return sl(M,function(Y,ie){Go(V,Y,ie[1]),Go(V,ie[0],ie[1])}),bd(V)}function a_(M){return TT(M)}var gb,qm=uh({asyncIterator:0,hasInstance:1,isConcatSpreadable:2,iterator:3,match:4,matchAll:5,replace:6,search:7,species:8,split:9,toPrimitive:10,toStringTag:11,unscopables:12}),st="__tsUtils$gblCfg";function di(){var M;return typeof globalThis!==qa&&(M=globalThis),M||typeof self===qa||(M=self),M||typeof window===qa||(M=window),M||typeof i===qa||(M=i),M}function Gi(){if(!gb){var M=Il(di).v||{};gb=M[st]=M[st]||{}}return gb}var un=jn;function jn(M,V,Y){var ie=V&&V[M];return function(ye){var _e=ye&&ye[M]||ie;if(_e||Y){var Ue=arguments;return(_e||Y).apply(ye,_e?Xd[Fn](Ue,1):Ue)}fg('"'+So(M)+'" not defined for '+zs(ye))}}function no(M){return function(V){return V[M]}}var Oa=$r(Uu,"max"),Nr=un("slice",ns),go=un("substring",ns),_s=jn("substr",ns,_o);function _o(M,V,Y){return rl(M)&&fg("Invalid "+zs(M)),Y<0?ci:((V=V||0)<0&&(V=Oa(V+M[ti],0)),bl(Y)?Nr(M,V):Nr(M,V,V+Y))}function Ks(M,V){return go(M,0,V)}var Ko,Ql,hs,mb="_urid";function QA(){if(!Ko){var M=Gi();Ko=M.gblSym=M.gblSym||{k:{},s:{}}}return Ko}function Jv(M){var V={description:So(M),toString:function(){return Sa+"("+M+")"}};return V[aa]=!0,V}function XE(M){var V=QA();if(!ch(V.k,M)){var Y=Jv(M),ie=Os(V.s).length;Y[mb]=function(){return ie+"_"+Y[Or]()},V.k[M]=Y,V.s[Y[mb]()]=So(M)}return V.k[M]}function aS(M){var V;!Ql&&(Ql={});var Y=qm[M];return Y&&(V=Ql[Y]=Ql[Y]||Jv(Sa+"."+Y)),V}function nm(){hs=Gi()}function Ok(M){var V={};return!hs&&nm(),V.b=hs.lzy,Od(V,"v",{configurable:!0,get:function(){var Y=M();return hs.lzy||Od(V,"v",{value:Y}),V.b=hs.lzy,Y}}),V}function Wm(M){return Od({toJSON:function(){return M}},"v",{value:M})}var r_,e0="window";function CT(M,V){var Y;return function(){return!hs&&nm(),(!Y||hs.lzy)&&(Y=Wm(Il(M,V).v)),Y.v}}function _T(M){return!hs&&nm(),(!r_||M===!1||hs.lzy)&&(r_=Wm(Il(di).v||Yl)),r_.v}function Vu(M,V){var Y=r_&&V!==!1?r_.v:_T(V);return Y&&Y[M]?Y[M]:M===e0?ev():Yl}function Nk(){return!!hh()}var hh=CT(Vu,["document"]);function wP(){return!!ev()}var ev=CT(Vu,[e0]);function vg(){return!!Yv()}var fb,o_,ET,Yv=CT(Vu,["navigator"]),am=CT(function(){return!!Il(function(){return process&&(process.versions||{}).node}).v});function tv(){return fb=Wm(Il(Vu,[Sa]).v)}function $u(M){var V=(hs.lzy?0:fb)||tv();return V.v?V.v[M]:rc}function vb(){return!!kP()}function kP(){return!hs&&nm(),((hs.lzy?0:fb)||tv()).v}function rm(M,V){var Y=qm[M];!hs&&nm();var ie=(hs.lzy?0:fb)||tv();return ie.v?ie.v[Y||M]:aS(M)}function yb(M,V){!hs&&nm();var Y=(hs.lzy?0:fb)||tv();return Y.v?Y.v(M):Jv(M)}function s_(M){return!hs&&nm(),((o_=(hs.lzy?0:o_)||Wm(Il($u,["for"]).v)).v||XE)(M)}function t0(M){return!!M&&Xo(M.next)}function RP(M){return!db(M)&&Xo(M[rm(3)])}function iv(M,V,Y){if(M&&(t0(M)||(!ET&&(ET=Wm(rm(3))),M=M[ET.v]?M[ET.v]():null),t0(M))){var ie=rc,ye=rc;try{for(var _e=0;!(ye=M.next()).done&&V[Fn](Y||M,ye.value,_e,M)!==-1;)_e++}catch(Ue){ie={e:Ue},M.throw&&(ye=Yl,M.throw(ie))}finally{try{ye&&!ye.done&&M.return&&M.return(ye)}finally{if(ie)throw ie.e}}}}function rS(M,V,Y){return M.apply(V,Y)}function oS(M,V){return!bl(V)&&M&&(jo(V)?rS(M.push,M,V):t0(V)||RP(V)?iv(V,function(Y){M.push(Y)}):M.push(V)),M}function Va(M,V,Y){if(M)for(var ie=M[ti]>>>0,ye=0;ye<ie&&(!(ye in M)||V[Fn](M,M[ye],ye,M)!==-1);ye++);}var om=un("indexOf",Cu);function AT(M,V,Y){return(M&&M.slice||Xd).apply(M,Xd[Fn](arguments,1))}function Qv(M,V,Y){return om(M,V,Y)!==-1}var ZA,MP=jn("includes",Cu,Qv),ep=Us($r(Co,"create"),l_);function l_(M){if(!M)return{};var V=typeof M;function Y(){}return V!==pn&&V!==Ai&&fg("Prototype must be an Object or function: "+zs(M)),Y[Bn]=M,new Y}function PP(M,V){return(Co.setPrototypeOf||function(Y,ie){var ye;!ZA&&(ZA=Wm(((ye={})[Pa]=[],ye instanceof Array))),ZA.v?Y[Pa]=ie:sl(ie,function(_e,Ue){return Y[_e]=Ue})})(M,V)}function XA(M,V,Y){function ie(){this[kr]=V,Il(yo,[this,on,{v:M,c:!0,e:!1}])}return Il(yo,[V,on,{v:M,c:!0,e:!1}]),(V=PP(V,Y))[Bn]=Y===Yl?ep(Y):(ie[Bn]=Y[Bn],new ie),V}function c_(M,V){V&&(M[on]=V)}function Oi(M,V,Y){var ie=Error,ye=ie[Bn][on],_e=Error.captureStackTrace;return XA(M,function(){var Ue=this,et=arguments;try{Il(c_,[ie,M]);var nt=rS(ie,Ue,Xd[Fn](et))||Ue;if(nt!==Ue){var lt=pb(Ue);lt!==pb(nt)&&PP(nt,lt)}return _e&&_e(nt,Ue[kr]),V&&V(nt,et),nt}finally{Il(c_,[ie,ye])}},ie)}function gn(){return(Date.now||Tn)()}function Tn(){return new Date().getTime()}function Aa(M){return function(Y){return rl(Y)&&fg("strTrim called ["+zs(Y)+"]"),Y&&Y.replace&&(Y=Y.replace(M,ci)),Y}}var ko,vl,tp,eu=jn("trim",ns,Aa(/^\s+|(?=\s)\s+$/g));function Js(M){if(!M||typeof M!==pn)return!1;tp||(tp=!wP()||ev());var V=!1;if(M!==tp){vl||(ko=Function[Bn][Or],vl=ko[Fn](Co));try{var Y=pb(M);(V=!Y)||(Xh(Y,kr)&&(Y=Y[kr]),V=Y&&typeof Y===Ai&&ko[Fn](Y)===vl)}catch{}}return V}function xk(M){return M.value&&LP(M),!0}var WO=[IT,LP,i0,Vl];function tu(M,V,Y,ie){var ye;return Va(M,function(_e){if(_e.k===V)return ye=_e,-1}),ye||(ye={k:V,v:V},M.push(ye),ie(ye)),ye.v}function sS(M,V,Y,ie){var ye=Y.handler,_e=Y.path?ie?Y.path.concat(ie):Y.path:[],Ue={handler:Y.handler,src:Y.src,path:_e},et=typeof V,nt=!1,lt=!1;V&&et===pn?nt=Js(V):lt=V===Yl||im(et);var Ct={type:et,isPrim:lt,isPlain:nt,value:V,result:V,path:_e,origin:Y.src,copy:function(zt,li){return sS(M,zt,li?Ue:Y,li)},copyTo:function(zt,li){return DP(M,zt,li,Ue)}};return Ct.isPrim?ye&&ye[Fn](Y,Ct)?Ct.result:V:tu(M,V,_e,function(zt){yo(Ct,"result",{g:function(){return zt.v},s:function(wi){zt.v=wi}});for(var li=0,ii=ye;!(ii||(li<WO.length?WO[li++]:xk))[Fn](Y,Ct);)ii=Yl})}function DP(M,V,Y,ie){if(!rl(Y))for(var ye in Y)V[ye]=sS(M,Y[ye],ie,ye);return V}function Sb(M,V,Y){return DP([],M,V,{handler:Y,src:V,path:[]})}function Zv(M,V){return sS([],M,{handler:V,src:M})}function IT(M){var V=M.value;if(jo(V)){var Y=M.result=[];return Y.length=V.length,M.copyTo(Y,V),!0}return!1}function Vl(M){var V=M.value;return!!ZE(V)&&(M.result=new Date(V.getTime()),!0)}function i0(M){return M.type===Ai}function LP(M){var V=M.value;if(V&&M.isPlain){var Y=M.result={};return M.copyTo(Y,V),!0}return!1}function bb(M,V){return Va(V,function(Y){Sb(M,Y)}),M}function Bk(M,V,Y,ie,ye,_e,Ue){return bb(Zv(M)||{},Xd[Fn](arguments))}var eI=no(ti);function OP(){return gn()}var n0=jn("endsWith",ns,Xv);function Xv(M,V,Y){Ld(M)||fg("'"+zs(M)+"' is not a string");var ie=Ld(V)?V:So(V),ye=!bl(Y)&&Y<M[ti]?Y:M[ti];return go(M,ye-ie[ti],ye)===ie}var Km=un("indexOf",ns),Td=jn("startsWith",ns,a0);function a0(M,V,Y){Ld(M)||fg("'"+zs(M)+"' is not a string");var ie=Ld(V)?V:So(V),ye=Y>0?Y:0;return go(M,ye,ye+ie[ti])===ie}var d_="ref",tI="unref",u_="hasRef",NP="enabled";function r0(M,V,Y){var ie,ye=!0,_e=M?V(Yl):Yl;function Ue(){return ye=!1,_e&&_e[tI]&&_e[tI](),ie}function et(){_e&&Y(_e),_e=Yl}function nt(){return _e=V(_e),ye||Ue(),ie}function lt(Ct){!Ct&&_e&&et(),Ct&&!_e&&nt()}return(ie={cancel:et,refresh:nt})[u_]=function(){return _e&&_e[u_]?_e[u_]():ye},ie[d_]=function(){return ye=!0,_e&&_e[d_]&&_e[d_](),ie},ie[tI]=Ue,{h:ie=Od(ie,NP,{get:function(){return!!_e},set:lt}),dn:function(){_e=Yl}}}function ey(M,V,Y){var ie=jo(V),ye=ie?V.length:0,_e=(ye>0?V[0]:ie?rc:V)||setTimeout,Ue=(ye>1?V[1]:rc)||clearTimeout,et=Y[0];Y[0]=function(){nt.dn(),rS(et,rc,Xd[Fn](arguments))};var nt=r0(M,function(lt){if(lt){if(lt.refresh)return lt.refresh(),lt;rS(Ue,rc,[lt])}return rS(_e,rc,Y)},function(lt){rS(Ue,rc,[lt])});return nt.h}function nv(M,V){return ey(!0,rc,Xd[Fn](arguments))}function av(M,V,Y){return ey(!0,M,Xd[Fn](arguments,1))}function xP(M,V){return ey(!1,rc,Xd[Fn](arguments))}(_T()||{}).Symbol,(_T()||{}).Reflect;var lS,Fk="hasOwnProperty",iI=function(M,V){return(iI=us.setPrototypeOf||{__proto__:[]}instanceof Array&&function(Y,ie){Y.__proto__=ie}||function(Y,ie){for(var ye in ie)ie[Fk](ye)&&(Y[ye]=ie[ye])})(M,V)};function _u(M,V){function Y(){this.constructor=M}typeof V!==pr&&V!==null&&fg("Class extends value "+String(V)+" is not a constructor or null"),iI(M,V),M[La]=V===null?ep(V):(Y[La]=V[La],new Y)}function Uk(M,V){for(var Y=0,ie=V.length,ye=M.length;Y<ie;Y++,ye++)M[ye]=V[Y];return M}var wT="constructor",yg="prototype",wl="function",id="_dynInstFuncs",Eu="_isDynProxy",ty="_dynClass",KO="_dynCls$",h_="_dynInstChk",cS=h_,kT="_dfOpts",Jm="_unknown_",o0="__proto__",dS="_dyn"+o0,s0="__dynProto$Gbl",RT="_dynInstProto",uS="useBaseInst",Sg="setInstFuncs",p_=Object,iy=p_.getPrototypeOf,nI=p_.getOwnPropertyNames,aI=_T(),rI=aI[s0]||(aI[s0]={o:(lS={},lS[Sg]=!0,lS[uS]=!0,lS),n:1e3});function MT(M){return M&&(M===p_[yg]||M===Array[yg])}function rv(M){return MT(M)||M===Function[yg]}function ny(M){var V;if(M){if(iy)return iy(M);var Y=M[o0]||M[yg]||(M[wT]?M[wT][yg]:null);V=M[dS]||Y,Xh(M,dS)||(delete M[RT],V=M[dS]=M[RT]||M[dS],M[RT]=Y)}return V}function Tt(M,V){var Y=[];if(nI)Y=nI(M);else for(var ie in M)typeof ie=="string"&&Xh(M,ie)&&Y.push(ie);if(Y&&Y.length>0)for(var ye=0;ye<Y.length;ye++)V(Y[ye])}function ip(M,V,Y){return V!==wT&&typeof M[V]===wl&&(Y||Xh(M,V))&&V!==o0&&V!==yg}function PT(M){fg("DynamicProto: "+M)}function ph(M){var V=ep(null);return Tt(M,function(Y){!V[Y]&&ip(M,Y,!1)&&(V[Y]=M[Y])}),V}function Lo(M,V){for(var Y=M.length-1;Y>=0;Y--)if(M[Y]===V)return!0;return!1}function oI(M,V,Y,ie){function ye(nt,lt,Ct){var zt=lt[Ct];if(zt[Eu]&&ie){var li=nt[id]||{};li[cS]!==!1&&(zt=(li[lt[ty]]||{})[Ct]||zt)}return function(){return zt.apply(nt,arguments)}}var _e=ep(null);Tt(Y,function(nt){_e[nt]=ye(V,Y,nt)});for(var Ue=ny(M),et=[];Ue&&!rv(Ue)&&!Lo(et,Ue);)Tt(Ue,function(nt){!_e[nt]&&ip(Ue,nt,!iy)&&(_e[nt]=ye(V,Ue,nt))}),et.push(Ue),Ue=ny(Ue);return _e}function Tb(M,V,Y,ie){var ye=null;if(M&&Xh(Y,ty)){var _e=M[id]||ep(null);if((ye=(_e[Y[ty]]||ep(null))[V])||PT("Missing ["+V+"] "+wl),!ye[h_]&&_e[cS]!==!1){for(var Ue=!Xh(M,V),et=ny(M),nt=[];Ue&&et&&!rv(et)&&!Lo(nt,et);){var lt=et[V];if(lt){Ue=lt===ie;break}nt.push(et),et=ny(et)}try{Ue&&(M[V]=ye),ye[h_]=1}catch{_e[cS]=!1}}}return ye}function sI(M,V,Y){var ie=V[M];return ie===Y&&(ie=ny(V)[M]),typeof ie!==wl&&PT("["+M+"] is not a "+wl),ie}function ov(M,V,Y,ie,ye){function _e(nt,lt){var Ct=function(){return(Tb(this,lt,nt,Ct)||sI(lt,nt,Ct)).apply(this,arguments)};return Ct[Eu]=1,Ct}if(!MT(M)){var Ue=Y[id]=Y[id]||ep(null);if(!MT(Ue)){var et=Ue[V]=Ue[V]||ep(null);Ue[cS]!==!1&&(Ue[cS]=!!ye),MT(et)||Tt(Y,function(nt){ip(Y,nt,!1)&&Y[nt]!==ie[nt]&&(et[nt]=Y[nt],delete Y[nt],(!Xh(M,nt)||M[nt]&&!M[nt][Eu])&&(M[nt]=_e(M,nt)))})}}}function SF(M,V){if(iy){for(var Y=[],ie=ny(V);ie&&!rv(ie)&&!Lo(Y,ie);){if(ie===M)return!0;Y.push(ie),ie=ny(ie)}return!1}return!0}function Cb(M,V){return Xh(M,yg)?M.name||V||Jm:((M||{})[wT]||{}).name||V||Jm}function Ia(M,V,Y,ie){Xh(M,yg)||PT("theClass is an invalid class definition.");var ye=M[yg];SF(ye,V)||PT("["+Cb(M)+"] not in hierarchy of ["+Cb(V)+"]");var _e=null;Xh(ye,ty)?_e=ye[ty]:(_e=KO+Cb(M,"_")+"$"+rI.n,rI.n++,ye[ty]=_e);var Ue=Ia[kT],et=!!Ue[uS];et&&ie&&ie[uS]!==void 0&&(et=!!ie[uS]);var nt=ph(V);Y(V,oI(ye,V,nt,et));var lt=!!iy&&!!Ue[Sg];lt&&ie&&(lt=!!ie[Sg]),ov(ye,_e,V,nt,lt!==!1)}Ia[kT]=rI.o;var Ym,Nd=bT,Kr=a_,Mh=Nd({Unknown:0,NonRetryableStatus:1,InvalidEvent:2,SizeLimitExceeded:3,KillSwitch:4,QueueFull:5}),Qm="toLowerCase",fc="blkVal",ra="length",np="rdOnly",kl="notify",iu="warnToConsole",Ph="throwInternal",ap="setDf",Dc="watch",Hc="logger",ay="apply",$l="push",Dh="splice",bg="hdlr",Tg="cancel",hS="initialize",Lp="identifier",g_="removeNotificationListener",ry="addNotificationListener",Hu="isInitialized",sv="getNotifyMgr",lv="getPlugin",_b="pollInternalLogs",rp="name",vc="time",yc="processNext",sm="getProcessTelContext",Op="enabled",oy="stopPollingInternalLogs",nu="unload",m_="onComplete",sy="version",Np="loggingLevelConsole",ju="createNew",xd="teardown",Ac="messageId",au="message",Cg="isAsync",ly="diagLog",l0="_doTeardown",pS="update",Ic="getNext",Eb="setNextPlugin",ru="protocol",cv="userAgent",Zm="split",dv="nodeType",_g="replace",f_="logInternalMessage",xp="type",gS="handler",Ns="status",Na="getResponseHeader",lm="getAllResponseHeaders",Bp="isChildEvt",cy="data",mS="getCtx",uv="setCtx",Ab="complete",DT="urlString",Cd="sendPOST",cm="headers",Fp="timeout",zk="setRequestHeader",Vk="traceId",Up="spanId",Eg="traceFlags";function BP(M,V){Ym||(Ym=Oi("AggregationError",function(ie,ye){ye[ra]>1&&(ie.errors=ye[1])}));var Y=M;throw Va(V,function(ie,ye){Y+=`
`.concat(ye," > ").concat(zs(ie))}),new Ym(Y,V||[])}var lI="Promise",fS="rejected";function hv(M,V){return v_(M,function(Y){return V?V({status:"fulfilled",rejected:!1,value:Y}):Y},function(Y){return V?V({status:fS,rejected:!0,reason:Y}):Y})}function v_(M,V,Y,ie){var ye=M;try{if(fl(M))(V||Y)&&(ye=M.then(V,Y));else try{V&&(ye=V(M))}catch(_e){if(!Y)throw _e;ye=Y(_e)}}finally{}return ye}var cI,LT=["pending","resolving","resolved",fS],dI="dispatchEvent";function c0(M){var V;return M&&M.createEvent&&(V=M.createEvent("Event")),!!V&&V.initEvent}function dy(M,V,Y,ie){var ye=hh();!cI&&(cI=Wm(!!Il(c0,[ye]).v));var _e=cI.v?ye.createEvent("Event"):ie?new Event(V):{};if(Y&&Y(_e),cI.v&&_e.initEvent(V,!1,!0),_e&&M[dI])M[dI](_e);else{var Ue=M["on"+V];if(Ue)Ue(_e);else{var et=Vu("console");et&&(et.error||et.log)(V,zs(_e))}}}var vS,y_,yS,uI="unhandledRejection",S_=uI.toLowerCase(),$k=[],Hk=0,nd=10;function d0(M){return Xo(M)?M.toString():zs(M)}function b_(M,V,Y){var ie,ye,_e=AT(arguments,3),Ue=0,et=!1,nt=[],lt=Hk++,Ct=!1,zt=null;function li(Kt,ki){try{return $k.push(lt),Ct=!0,zt&&zt.cancel(),zt=null,M(function(sa,$a){nt.push(function(){try{var Mr=Ue===2?Kt:ki,mn=bl(Mr)?ie:Xo(Mr)?Mr(ie):Mr;fl(mn)?mn.then(sa,$a):Mr?sa(mn):Ue===3?$a(mn):sa(mn)}catch(Ir){$a(Ir)}}),et&&Gt()},_e)}finally{$k.pop()}}function ii(Kt){return li(void 0,Kt)}function wi(Kt){var ki=Kt,sa=Kt;return Xo(Kt)&&(ki=function($a){return Kt&&Kt(),$a},sa=function($a){throw Kt&&Kt(),$a}),li(ki,sa)}function oi(){return LT[Ue]}function Gt(){if(nt.length>0){var Kt=nt.slice();nt=[],Ct=!0,zt&&zt.cancel(),zt=null,V(Kt)}}function ui(Kt,ki){return function(sa){if(Ue===ki){if(Kt===2&&fl(sa))return Ue=1,void sa.then(ui(2,1),ui(3,1));Ue=Kt,et=!0,ie=sa,Gt(),Ct||Kt!==3||zt||(zt=nv($i,nd))}}}function $i(){if(!Ct)if(Ct=!0,am())process.emit(uI,ie,ye);else{var Kt=ev()||_T();!vS&&(vS=Wm(Il(Vu,[lI+"RejectionEvent"]).v)),dy(Kt,S_,function(ki){return yo(ki,"promise",{g:function(){return ye}}),ki.reason=ie,ki},!!vS.v)}}function In(){return"IPromise "+oi()+(et?" - "+d0(ie):"")}return Od(ye={then:li,catch:ii,finally:wi},"state",{get:oi}),vb()&&(ye[rm(11)]="IPromise"),ye.toString=In,function(){Xo(Y)||fg(lI+": executor is not a function - "+d0(Y));var ki=ui(3,0);try{Y.call(ye,ui(2,0),ki)}catch(sa){ki(sa)}}(),ye}function Jr(M){return function(V){var Y=AT(arguments,1);return M(function(ie,ye){try{var _e=[],Ue=1;iv(V,function(et,nt){et&&(Ue++,v_(et,function(lt){_e[nt]=lt,--Ue==0&&ie(_e)},ye))}),--Ue===0&&ie(_e)}catch(et){ye(et)}},Y)}}function ps(M){Va(M,function(V){try{V()}catch{}})}function nr(M){var V=Zh(M)?M:0;return function(Y){nv(function(){ps(Y)},V)}}function Sc(M,V){return b_(Sc,nr(V),M,V)}function Hl(M,V){!y_&&(y_=Wm(Il(Vu,[lI]).v||null));var Y=y_.v;if(!Y)return Sc(M);Xo(M)||fg(lI+": executor is not a function - "+zs(M));var ie=0;function ye(){return LT[ie]}var _e=new Y(function(Ue,et){function nt(Ct){ie=2,Ue(Ct)}function lt(Ct){ie=3,et(Ct)}M(nt,lt)});return Od(_e,"state",{get:ye}),_e}function Zl(M,V){return!yS&&(yS=Wm(Hl)),yS.v.call(this,M,V)}var gh=Jr(Zl),Xm=(rm(11),void 0),ll="",_d="channels",En="core",Vs="createPerfMgr",ao="disabled",dm="extensionConfig",op="extensions",Ys="processTelemetry",Xl="priority",um="eventsSent",ef="eventsDiscarded",tf="eventsSendRequest",uy="perfEvent",OT="offlineEventsStored",T_="offlineBatchSent",NT="offlineBatchDrop",Ib="getPerfMgr",nf="domain",u0="path",hy="Not dynamic - ",xT=/-([a-z])/g,hI=/([^\w\d_$])/g,BT=/^(\d+[\w\d_$])/;function FT(M){return!rl(M)}function h0(M){var V=M;return V&&Ld(V)&&(V=(V=(V=V[_g](xT,function(Y,ie){return ie.toUpperCase()}))[_g](hI,"_"))[_g](BT,function(Y,ie){return"_"+ie})),V}function Lh(M,V){return!(!M||!V)&&Km(M,V)!==-1}function C_(M){return M&&M.toISOString()||""}function __(M){return iS(M)?M[rp]:ll}function pv(M,V,Y,ie,ye){var _e=Y;return M&&((_e=M[V])===Y||ye&&!ye(_e)||ie&&!ie(Y)||(_e=Y,M[V]=_e)),_e}function pI(M,V,Y){var ie;return M?!(ie=M[V])&&rl(ie)&&(ie=bl(Y)?{}:Y,M[V]=ie):ie=bl(Y)?{}:Y,ie}function p0(M,V){var Y=null,ie=null;return Xo(M)?Y=M:ie=M,function(){var ye=arguments;if(Y&&(ie=Y()),ie)return ie[V][ay](ie,ye)}}function Gu(M,V,Y,ie,ye){M&&V&&Y&&ye!==!1&&(M[V]=p0(Y,ie))}function hm(M,V,Y,ie){return M&&V&&Qh(M)&&jo(Y)&&Va(Y,function(ye){Ld(ye)&&Gu(M,ye,V,ye,ie)}),M}function UT(M){return M&&Gm&&(M=us(Gm({},M))),M}function g0(M,V,Y,ie,ye,_e){var Ue=arguments,et=Ue[0]||{},nt=Ue[ra],lt=!1,Ct=1;for(nt>0&&Kv(et)&&(lt=et,et=Ue[Ct]||{},Ct++),Qh(et)||(et={});Ct<nt;Ct++){var zt=Ue[Ct],li=jo(zt),ii=Qh(zt);for(var wi in zt)if(li&&wi in zt||ii&&ch(zt,wi)){var oi=zt[wi],Gt=void 0;if(lt&&oi&&((Gt=jo(oi))||Js(oi))){var ui=et[wi];Gt?jo(ui)||(ui=[]):Js(ui)||(ui={}),oi=g0(lt,ui,oi)}oi!==void 0&&(et[wi]=oi)}}return et}function py(M){try{return M.responseText}catch{}return null}function SS(M,V){return M?"XDomainRequest,Response:"+py(M)||"":V}function wb(M,V){return M?"XMLHttpRequest,Status:"+M[Ns]+",Response:"+py(M)||M.response||"":V}function Ag(M,V){return V&&(Zh(V)?M=[V].concat(M):jo(V)&&(M=V.concat(M))),M}var JO="Microsoft_ApplicationInsights_BypassAjaxInstrumentation",bc="withCredentials",gv="timeout";function zT(M,V,Y,ie,ye,_e){function Ue(nt,lt,Ct){try{nt[lt]=Ct}catch{}}ye===void 0&&(ye=!1);var et=new XMLHttpRequest;return Ue(et,JO,ie),Y&&Ue(et,bc,Y),et.open(M,V,!ye),Y&&Ue(et,bc,Y),!ye&&_e&&Ue(et,gv,_e),et}function gI(M){var V={};return Ld(M)&&Va(eu(M)[Zm](/[\r\n]+/),function(Y){if(Y){var ie=Y.indexOf(": ");if(ie!==-1){var ye=eu(Y.substring(0,ie))[Qm](),_e=eu(Y.substring(ie+1));V[ye]=_e}else V[eu(Y)]=1}}),V}function E_(M,V,Y){if(!M[Y]&&V&&V[Na]){var ie=V[Na](Y);ie&&(M[Y]=eu(ie))}return M}var mv="kill-duration",m0="kill-duration-seconds",mI="time-delta-millis";function VT(M,V){var Y={};return M[lm]?Y=gI(M[lm]()):V&&(Y=E_(Y,M,mI),Y=E_(Y,M,mv),Y=E_(Y,M,m0)),Y}var f0="location",fI="console",v0="JSON",$T="crypto",y0="msCrypto",jk="ReactNative",S0="msie",YO="trident/",vI="XMLHttpRequest",af=null,Gk=null,rf=null,A_=null;function ou(M,V){var Y=!1;if(M){try{if(!(Y=V in M)){var ie=M[La];ie&&(Y=V in ie)}}catch{}if(!Y)try{Y=!bl(new M()[V])}catch{}}return Y}function qu(M){return typeof location===Ho&&location?location:Vu(f0)}function pm(){return typeof console!==Rr?console:Vu(fI)}function zp(){return!!(typeof JSON===Ho&&JSON||Vu(v0)!==null)}function Jo(){return zp()?JSON||Vu(v0):null}function I_(){return Vu($T)}function yI(){return Vu(y0)}function b0(){var M=Yv();return!(!M||!M.product)&&M.product===jk}function kb(){var M=Yv();if(M&&(M[cv]!==Gk||af===null)){var V=((Gk=M[cv])||ll)[Qm]();af=Lh(V,S0)||Lh(V,YO)}return af}function Yr(M){return A_!==null&&M!==!1||(A_=vg()&&!!Yv().sendBeacon),A_}function bS(M){var V=!1;try{V=!!Vu("fetch");var Y=Vu("Request");V&&M&&Y&&(V=ou(Y,"keepalive"))}catch{}return V}function qk(){return rf===null&&(rf=typeof XDomainRequest!==Rr)&&gy()&&(rf=rf&&!ou(Vu(vI),"withCredentials")),rf}function gy(){var M=!1;try{M=!!Vu(vI)}catch{}return M}var Wk=4294967296,fv=4294967295,SI=123456789,Au=987654321,FP=!1,T0=SI,mh=Au;function TS(M){M<0&&(M>>>=0),T0=SI+M&fv,mh=Au-M&fv,FP=!0}function of(){try{var M=2147483647&gn();TS((Math.random()*Wk^M)+M)}catch{}}function Vp(M){var V=0,Y=I_()||yI();return Y&&Y.getRandomValues&&(V=Y.getRandomValues(new Uint32Array(1))[0]&fv),V===0&&kb()&&(FP||of(),V=bI()&fv),V===0&&(V=Math.floor(Wk*Math.random()|0)),M||(V>>>=0),V}function bI(M){var V=((mh=36969*(65535&mh)+(mh>>16)&fv)<<16)+(65535&(T0=18e3*(65535&T0)+(T0>>16)&fv))>>>0&fv;return V>>>=0,V}function gm(M){M===void 0&&(M=22);for(var V="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",Y=Vp()>>>0,ie=0,ye=ll;ye[ra]<M;)ie++,ye+=V.charAt(63&Y),Y>>>=6,ie===5&&(Y=(Vp()<<2&4294967295|3&Y)>>>0,ie=0);return ye}var Tc="3.2.1",$p="."+gm(6),Kk=0;function C0(M){return M[dv]===1||M[dv]===9||!+M[dv]}function Wu(M,V){var Y=V[M.id];if(!Y){Y={};try{C0(V)&&yo(V,M.id,{e:!1,v:Y})}catch{}}return Y}function w_(M,V){return V===void 0&&(V=!1),h0(M+Kk+++(V?"."+Tc:ll)+$p)}function TI(M){var V={id:w_("_aiData-"+(M||ll)+"."+Tc),accept:function(Y){return C0(Y)},get:function(Y,ie,ye,_e){var Ue=Y[V.id];return Ue?Ue[h0(ie)]:(_e&&((Ue=Wu(V,Y))[h0(ie)]=ye),ye)},kill:function(Y,ie){if(Y&&Y[ie])try{delete Y[ie]}catch{}}};return V}function vv(M){return M&&Qh(M)&&(M.isVal||M.fb||ch(M,"v")||ch(M,"mrg")||ch(M,"ref")||M.set)}function Oh(M,V,Y){var ie,ye=Y.dfVal||Dp;if(V&&Y.fb){var _e=Y.fb;jo(_e)||(_e=[_e]);for(var Ue=0;Ue<_e[ra];Ue++){var et=_e[Ue],nt=V[et];if(ye(nt)?ie=nt:M&&(ye(nt=M.cfg[et])&&(ie=nt),M.set(M.cfg,So(et),nt)),ye(ie))break}}return!ye(ie)&&ye(Y.v)&&(ie=Y.v),ie}function Jk(M,V,Y){var ie,ye=Y;return Y&&vv(Y)&&(ye=Oh(M,V,Y)),ye&&(vv(ye)&&(ye=Jk(M,V,ye)),jo(ye)?(ie=[])[ra]=ye[ra]:Js(ye)&&(ie={}),ie&&(sl(ye,function(_e,Ue){Ue&&vv(Ue)&&(Ue=Jk(M,V,Ue)),ie[_e]=Ue}),ye=ie)),ye}function ar(M,V,Y,ie){var ye,_e,Ue,et,nt,lt,Ct,zt,li=ie;vv(li)?(ye=li.isVal,_e=li.set,lt=li[np],Ct=li[fc],et=li.mrg,!(nt=li.ref)&&bl(nt)&&(nt=!!et),Ue=Oh(M,V,li)):Ue=ie,Ct&&M[fc](V,Y);var ii=!0,wi=V[Y];!wi&&rl(wi)||(zt=wi,ii=!1,ye&&zt!==Ue&&!ye(zt)&&(zt=Ue,ii=!0),_e&&(ii=(zt=_e(zt,Ue,V))===Ue)),ii?zt=Ue&&Jk(M,V,Ue):(Js(zt)||jo(Ue))&&et&&Ue&&(Js(Ue)||jo(Ue))&&sl(Ue,function(oi,Gt){ar(M,zt,oi,Gt)}),M.set(V,Y,zt),nt&&M.ref(V,Y),lt&&M[np](V,Y)}var sf=s_("[[ai_dynCfg_1]]"),CI=s_("[[ai_blkDynCfg_1]]"),QO=s_("[[ai_frcDynCfg_1]]");function Yk(M){var V;return M&&(jo(M)?(V=[])[ra]=M[ra]:Js(M)&&(V={}),V)?(sl(M,function(Y,ie){V[Y]=Yk(ie)}),V):M}function k_(M){if(M){var V=M[sf]||M;if(V.cfg&&(V.cfg===M||V.cfg[sf]===V))return V}return null}function _I(M){if(M&&(Js(M)||jo(M)))try{M[CI]=!0}catch{}return M}function R_(M,V,Y){var ie=!1;return Y&&!M[V.blkVal]&&((ie=Y[QO])||Y[CI]||(ie=Js(Y)||jo(Y))),ie}function _0(M){fg("InvalidAccess:"+M)}var Rb=["push","pop","shift","unshift","splice"],Ig=function(M,V,Y,ie){M&&M[Ph](3,108,"".concat(Y," [").concat(V,"] failed - ")+zs(ie))};function my(M,V,Y){jo(V)&&Va(Rb,function(ie){var ye=V[ie];V[ie]=function(){for(var _e=[],Ue=0;Ue<arguments.length;Ue++)_e[Ue]=arguments[Ue];var et=ye[ay](this,_e);return fy(M,V,Y,"Patching"),et}})}function mm(M,V){var Y=ol(M,V);return Y&&Y.get}function Ed(M,V,Y,ie){var ye={n:Y,h:[],trk:function(lt){lt&&lt.fn&&(om(ye.h,lt)===-1&&ye.h[$l](lt),M.trk(lt,ye))},clr:function(lt){var Ct=om(ye.h,lt);Ct!==-1&&ye.h[Dh](Ct,1)}},_e=!0,Ue=!1;function et(){_e&&(Ue=Ue||R_(et,M,ie),ie&&!ie[sf]&&Ue&&(ie=fy(M,ie,Y,"Converting")),_e=!1);var lt=M.act;return lt&&ye.trk(lt),ie}function nt(lt){if(ie!==lt){et[M.ro]&&!M.upd&&_0("["+Y+"] is read-only:"+zs(V)),_e&&(Ue=Ue||R_(et,M,ie),_e=!1);var Ct=Ue&&et[M.rf];if(Ue)if(Ct){sl(ie,function(li){ie[li]=lt?lt[li]:Xm});try{sl(lt,function(li,ii){fh(M,ie,li,ii)}),lt=ie}catch(li){Ig((M.hdlr||{})[Hc],Y,"Assigning",li),Ue=!1}}else ie&&ie[sf]&&sl(ie,function(li){var ii=mm(ie,li);if(ii){var wi=ii[M.prop];wi&&wi.chng()}});if(lt!==ie){var zt=lt&&R_(et,M,lt);!Ct&&zt&&(lt=fy(M,lt,Y,"Converting")),ie=lt,Ue=zt}M.add(ye)}}et[M.prop]={chng:function(){M.add(ye)}},yo(V,ye.n,{g:et,s:nt})}function fh(M,V,Y,ie){if(V){var ye=mm(V,Y);ye&&ye[M.prop]?V[Y]=ie:Ed(M,V,Y,ie)}return V}function jc(M,V,Y,ie){if(V){var ye=mm(V,Y),_e=ye&&!!ye[M.prop],Ue=ie&&ie[0],et=ie&&ie[1],nt=ie&&ie[2];if(!_e){if(nt)try{_I(V)}catch(lt){Ig((M.hdlr||{})[Hc],Y,"Blocking",lt)}try{fh(M,V,Y,V[Y]),ye=mm(V,Y)}catch(lt){Ig((M.hdlr||{})[Hc],Y,"State",lt)}}Ue&&(ye[M.rf]=Ue),et&&(ye[M.ro]=et),nt&&(ye[M.blkVal]=!0)}return V}function fy(M,V,Y,ie){try{sl(V,function(ye,_e){fh(M,V,ye,_e)}),V[sf]||(Od(V,sf,{get:function(){return M[bg]}}),my(M,V,Y))}catch(ye){Ig((M.hdlr||{})[Hc],Y,ie,ye)}return V}var E0="[[ai_",Hp="]]";function UP(M){var V,Y,ie=yb(E0+"get"+M.uid+Hp),ye=yb(E0+"ro"+M.uid+Hp),_e=yb(E0+"rf"+M.uid+Hp),Ue=yb(E0+"blkVal"+M.uid+Hp),et=yb(E0+"dtl"+M.uid+Hp),nt=null,lt=null;function Ct(wi,oi){var Gt=Y.act;try{Y.act=wi,wi&&wi[et]&&(Va(wi[et],function($i){$i.clr(wi)}),wi[et]=[]),oi({cfg:M.cfg,set:M.set.bind(M),setDf:M[ap].bind(M),ref:M.ref.bind(M),rdOnly:M[np].bind(M)})}catch($i){var ui=M[Hc];throw ui&&ui[Ph](1,107,zs($i)),$i}finally{Y.act=Gt||null}}function zt(){if(nt){var wi=nt;nt=null,lt&&lt[Tg](),lt=null;var oi=[];if(Va(wi,function(Gt){if(Gt&&(Gt[et]&&(Va(Gt[et],function(ui){ui.clr(Gt)}),Gt[et]=null),Gt.fn))try{Ct(Gt,Gt.fn)}catch(ui){oi[$l](ui)}}),nt)try{zt()}catch(Gt){oi[$l](Gt)}oi[ra]>0&&BP("Watcher error(s): ",oi)}}function li(wi){if(wi&&wi.h[ra]>0){nt||(nt=[]),lt||(lt=nv(function(){lt=null,zt()},0));for(var oi=0;oi<wi.h[ra];oi++){var Gt=wi.h[oi];Gt&&om(nt,Gt)===-1&&nt[$l](Gt)}}}function ii(wi,oi){if(wi){var Gt=wi[et]=wi[et]||[];om(Gt,oi)===-1&&Gt[$l](oi)}}return(V={prop:ie,ro:ye,rf:_e})[fc]=Ue,V[bg]=M,V.add=li,V[kl]=zt,V.use=Ct,V.trk=ii,Y=V}function fm(M,V){var Y={fn:V,rm:function(){Y.fn=null,M=null,V=null}};return yo(Y,"toJSON",{v:function(){return"WatcherHandler"+(Y.fn?"":"[X]")}}),M.use(Y,V),Y}function bF(M,V,Y){var ie,ye=k_(V);if(ye)return ye;var _e,Ue=w_("dyncfg",!0),et=V&&Y!==!1?V:Yk(V);function nt(){_e[kl]()}function lt(ui,$i,In){try{ui=fh(_e,ui,$i,In)}catch(Kt){Ig(M,$i,"Setting value",Kt)}return ui[$i]}function Ct(ui){return fm(_e,ui)}function zt(ui,$i){_e.use(null,function(In){var Kt=_e.upd;try{bl($i)||(_e.upd=$i),ui(In)}finally{_e.upd=Kt}})}function li(ui,$i){var In;return jc(_e,ui,$i,(In={},In[0]=!0,In))[$i]}function ii(ui,$i){var In;return jc(_e,ui,$i,(In={},In[1]=!0,In))[$i]}function wi(ui,$i){var In;return jc(_e,ui,$i,(In={},In[2]=!0,In))[$i]}function oi(ui,$i){return $i&&sl($i,function(In,Kt){ar(Gt,ui,In,Kt)}),ui}var Gt=((ie={uid:null,cfg:et})[Hc]=M,ie[kl]=nt,ie.set=lt,ie[ap]=oi,ie[Dc]=Ct,ie.ref=li,ie[np]=ii,ie[fc]=wi,ie._block=zt,ie);return yo(Gt,"uid",{c:!1,e:!1,w:!1,v:Ue}),fy(_e=UP(Gt),et,"config","Creating"),Gt}function zP(M,V){M?(M[iu](V),M[Ph](2,108,V)):_0(V)}function jp(M,V,Y,ie){var ye=bF(Y,M||{},ie);return V&&ye[ap](ye.cfg,V),ye}function Bd(M,V,Y){var ie=M[sf]||M;return!ie.cfg||ie.cfg!==M&&ie.cfg[sf]!==ie?(zP(Y,hy+zs(M)),jp(M,null,Y)[Dc](V)):ie[Dc](V)}function M_(M,V){if(M&&M[nu])return M[nu](V)}function ZO(M,V,Y){var ie;return Y||(ie=Zl(function(ye){Y=ye})),M&&eI(M)>0?hv(M_(M[0],V),function(){ZO(AT(M,1),V,Y)}):Y(),ie}var HT=500,jT="Microsoft_ApplicationInsights_BypassAjaxInstrumentation";function Lc(M){return{mrg:!0,v:M}}function gs(M){return{isVal:Ld,v:So(ll)}}var Fd,ad,vh=[um,ef,tf,uy],Gp=null;function A0(M,V){return function(){var Y=arguments,ie=I0(V);if(ie){var ye=ie.listener;ye&&ye[M]&&ye[M][ay](ye,Y)}}}function su(){var M=Vu("Microsoft");return M&&(Gp=M.ApplicationInsights),Gp}function I0(M){var V=Gp;return V||M.disableDbgExt===!0||(V=Gp||su()),V?V.ChromeDbgExt:null}function CS(M){if(!Fd){Fd={};for(var V=0;V<vh[ra];V++)Fd[vh[V]]=A0(vh[V],M)}return Fd}var P_="warnToConsole",Qk="AI (Internal): ",EI="AI: ",vm="AITR_",ym={loggingLevelConsole:0,loggingLevelTelemetry:1,maxMessageLimit:25,enableDebug:!1},w0=((ad={})[0]=null,ad[1]="errorToConsole",ad[2]=P_,ad[3]="debugToConsole",ad);function Sm(M){return M?'"'+M[_g](/\"/g,ll)+'"':ll}function GT(M,V){var Y=pm();if(Y){var ie="log";Y[M]&&(ie=M),Xo(Y[ie])&&Y[ie](V)}}var _S=function(){function M(V,Y,ie,ye){ie===void 0&&(ie=!1);var _e=this;_e[Ac]=V,_e[au]=(ie?EI:Qk)+V;var Ue=ll;zp()&&(Ue=Jo().stringify(ye));var et=(Y?" message:"+Sm(Y):ll)+(ye?" props:"+Sm(Ue):ll);_e[au]+=et}return M.dataType="MessageData",M}();function ES(M,V){return(M||{})[Hc]||new AS(V)}var AI,wg,AS=function(){function M(V){this.identifier="DiagnosticLogger",this.queue=[];var Y,ie,ye,_e,Ue,et=0,nt={};Ia(M,this,function(lt){function Ct(wi,oi){if(!li()){var Gt=!0,ui=vm+oi[Ac];if(nt[ui]?Gt=!1:nt[ui]=!0,Gt&&(wi<=ie&&(lt.queue[$l](oi),et++,ii(wi===1?"error":"warn",oi)),et===ye)){var $i="Internal events throttle limit per PageView reached for this app.",In=new _S(23,$i,!1);lt.queue[$l](In),wi===1?lt.errorToConsole($i):lt[iu]($i)}}}function zt(wi){return Bd(jp(wi,ym,lt).cfg,function(oi){var Gt=oi.cfg;Y=Gt[Np],ie=Gt.loggingLevelTelemetry,ye=Gt.maxMessageLimit,_e=Gt.enableDebug})}function li(){return et>=ye}function ii(wi,oi){var Gt=I0(V||{});Gt&&Gt[ly]&&Gt[ly](wi,oi)}Ue=zt(V||{}),lt.consoleLoggingLevel=function(){return Y},lt[Ph]=function(wi,oi,Gt,ui,$i){$i===void 0&&($i=!1);var In=new _S(oi,Gt,$i,ui);if(_e)throw zs(In);var Kt=w0[wi]||P_;if(bl(In[au]))ii("throw"+(wi===1?"Critical":"Warning"),In);else{if($i){var ki=+In[Ac];!nt[ki]&&Y>=wi&&(lt[Kt](In[au]),nt[ki]=!0)}else Y>=wi&&lt[Kt](In[au]);Ct(wi,In)}},lt.debugToConsole=function(wi){GT("debug",wi),ii("warning",wi)},lt[iu]=function(wi){GT("warn",wi),ii("warning",wi)},lt.errorToConsole=function(wi){GT("error",wi),ii("error",wi)},lt.resetInternalMessageCount=function(){et=0,nt={}},lt[f_]=Ct,lt[nu]=function(wi){Ue&&Ue.rm(),Ue=null}})}return M.__ieDyn=1,M}();function vy(M){return M||new AS}function cl(M,V,Y,ie,ye,_e){_e===void 0&&(_e=!1),vy(M)[Ph](V,Y,ie,ye,_e)}function Mb(M,V){vy(M)[iu](V)}var rd,Iu="toGMTString",yy="toUTCString",sp="cookie",qp="expires",II="isCookieUseDisabled",D_="disableCookiesUsage",yv="_ckMgr",Zk=null,lf=null,Xk=null,eR={},IS={},VP=((AI={cookieCfg:Lc((wg={},wg[nf]={fb:"cookieDomain",dfVal:FT},wg.path={fb:"cookiePath",dfVal:FT},wg.enabled=Xm,wg.ignoreCookies=Xm,wg.blockedCookies=Xm,wg)),cookieDomain:Xm,cookiePath:Xm})[D_]=Xm,AI);function Sy(){!rd&&(rd=Ok(function(){return hh()}))}function XO(M,V){var Y=kI[yv]||IS[yv];return Y||(Y=kI[yv]=kI(M,V),IS[yv]=Y),Y}function wI(M){return!M||M.isEnabled()}function tR(M,V){return!!(V&&M&&jo(M.ignoreCookies))&&om(M.ignoreCookies,V)!==-1}function k0(M,V){return!!(V&&M&&jo(M.blockedCookies)&&om(M.blockedCookies,V)!==-1)||tR(M,V)}function $P(M,V){var Y=V[Op];if(rl(Y)){var ie=void 0;bl(M[II])||(ie=!M[II]),bl(M[D_])||(ie=!M[D_]),Y=ie}return Y}function HP(M,V){var Y;return M&&(Y=M.getCookieMgr()),Y||(Y=XO(V,(M||{})[Hc])),Y}function kI(M,V){var Y,ie,ye,_e,Ue,et,nt,lt,Ct;M=jp(M||IS,null,V).cfg,Ue=Bd(M,function(li){li[ap](li.cfg,VP),ie=li.ref(li.cfg,"cookieCfg"),ye=ie[u0]||"/",_e=ie[nf],et=$P(M,ie)!==!1,nt=ie.getCookie||t1,lt=ie.setCookie||od,Ct=ie.delCookie||od},V);var zt=((Y={isEnabled:function(){var li=$P(M,ie)!==!1&&et&&jP(V),ii=IS[yv];return li&&ii&&zt!==ii&&(li=wI(ii)),li},setEnabled:function(li){et=li!==!1,ie[Op]=li},set:function(li,ii,wi,oi,Gt){var ui=!1;if(wI(zt)&&!k0(ie,li)){var $i={},In=eu(ii||ll),Kt=Km(In,";");if(Kt!==-1&&(In=eu(Ks(ii,Kt)),$i=qT(go(ii,Kt+1))),pv($i,nf,oi||_e,i_,bl),!rl(wi)){var ki=kb();if(bl($i[qp])){var sa=gn()+1e3*wi;if(sa>0){var $a=new Date;$a.setTime(sa),pv($i,qp,e1($a,ki?Iu:yy)||e1($a,ki?Iu:yy)||ll,i_)}}ki||pv($i,"max-age",ll+wi,null,bl)}var Mr=qu();Mr&&Mr[ru]==="https:"&&(pv($i,"secure",null,null,bl),lf===null&&(lf=!i1((Yv()||{})[cv])),lf&&pv($i,"SameSite","None",null,bl)),pv($i,u0,Gt||ye,null,bl),lt(li,L_(In,$i)),ui=!0}return ui},get:function(li){var ii=ll;return wI(zt)&&!tR(ie,li)&&(ii=nt(li)),ii},del:function(li,ii){var wi=!1;return wI(zt)&&(wi=zt.purge(li,ii)),wi},purge:function(li,ii){var wi,oi=!1;if(jP(V)){var Gt=((wi={})[u0]=ii||"/",wi[qp]="Thu, 01 Jan 1970 00:00:01 GMT",wi);kb()||(Gt["max-age"]="0"),Ct(li,L_(ll,Gt)),oi=!0}return oi}})[nu]=function(li){Ue&&Ue.rm(),Ue=null},Y);return zt[yv]=zt,zt}function jP(M){if(Zk===null){Zk=!1,!rd&&Sy();try{var V=rd.v||{};Zk=V[sp]!==void 0}catch(Y){cl(M,2,68,"Cannot access document.cookie - "+__(Y),{exception:zs(Y)})}}return Zk}function qT(M){var V={};return M&&M[ra]&&Va(eu(M)[Zm](";"),function(Y){if(Y=eu(Y||ll)){var ie=Km(Y,"=");ie===-1?V[Y]=null:V[eu(Ks(Y,ie))]=eu(go(Y,ie+1))}}),V}function e1(M,V){return Xo(M[V])?M[V]():null}function L_(M,V){var Y=M||ll;return sl(V,function(ie,ye){Y+="; "+ie+(rl(ye)?ll:"="+ye)}),Y}function t1(M){var V=ll;if(!rd&&Sy(),rd.v){var Y=rd.v[sp]||ll;Xk!==Y&&(eR=qT(Y),Xk=Y),V=eu(eR[M]||ll)}return V}function od(M,V){!rd&&Sy(),rd.v&&(rd.v[sp]=M+"="+V)}function i1(M){return!!Ld(M)&&(!(!Lh(M,"CPU iPhone OS 12")&&!Lh(M,"iPad; CPU OS 12"))||!!(Lh(M,"Macintosh; Intel Mac OS X 10_14")&&Lh(M,"Version/")&&Lh(M,"Safari"))||!(!Lh(M,"Macintosh; Intel Mac OS X 10_14")||!n0(M,"AppleWebKit/605.1.15 (KHTML, like Gecko)"))||!(!Lh(M,"Chrome/5")&&!Lh(M,"Chrome/6"))||!(!Lh(M,"UnrealEngine")||Lh(M,"Chrome"))||!(!Lh(M,"UCBrowser/12")&&!Lh(M,"UCBrowser/11")))}var n1={perfEvtsSendAll:!1};function iR(M){M.h=null;var V=M.cb;M.cb=[],Va(V,function(Y){Il(Y.fn,[Y.arg])})}function Pb(M,V,Y,ie){Va(M,function(ye){ye&&ye[V]&&(Y?(Y.cb[$l]({fn:ie,arg:ye}),Y.h=Y.h||nv(iR,0,Y)):Il(ie,[ye]))})}var RI=function(){function M(V){var Y,ie;this.listeners=[];var ye=[],_e={h:null,cb:[]},Ue=jp(V,n1);ie=Ue[Dc](function(et){Y=!!et.cfg.perfEvtsSendAll}),Ia(M,this,function(et){yo(et,"listeners",{g:function(){return ye}}),et[ry]=function(nt){ye[$l](nt)},et[g_]=function(nt){for(var lt=om(ye,nt);lt>-1;)ye[Dh](lt,1),lt=om(ye,nt)},et[um]=function(nt){Pb(ye,um,_e,function(lt){lt[um](nt)})},et[ef]=function(nt,lt){Pb(ye,ef,_e,function(Ct){Ct[ef](nt,lt)})},et[tf]=function(nt,lt){Pb(ye,tf,lt?_e:null,function(Ct){Ct[tf](nt,lt)})},et[uy]=function(nt){nt&&(!Y&&nt[Bp]()||Pb(ye,uy,null,function(lt){nt[Cg]?nv(function(){return lt[uy](nt)},0):lt[uy](nt)}))},et[OT]=function(nt){nt&&nt[ra]&&Pb(ye,OT,_e,function(lt){lt[OT](nt)})},et[T_]=function(nt){nt&&nt[cy]&&Pb(ye,T_,_e,function(lt){lt[T_](nt)})},et[NT]=function(nt,lt){if(nt>0){var Ct=lt||0;Pb(ye,NT,_e,function(zt){zt[NT](nt,Ct)})}},et[nu]=function(nt){var lt,Ct=function(){ie&&ie.rm(),ie=null,ye=[],_e.h&&_e.h[Tg](),_e.h=null,_e.cb=[]};if(Pb(ye,"unload",null,function(zt){var li=zt[nu](nt);li&&(lt||(lt=[]),lt[$l](li))}),lt)return Zl(function(zt){return hv(gh(lt),function(){Ct(),zt()})});Ct()}})}return M.__ieDyn=1,M}(),O_="ctx",GP="ParentContextKey",Wp="ChildrenContextKey",qP=null,nR=function(){function M(V,Y,ie){var ye,_e=this;_e.start=gn(),_e[rp]=V,_e[Cg]=ie,_e[Bp]=function(){return!1},Xo(Y)&&yo(_e,"payload",{g:function(){return!ye&&Xo(Y)&&(ye=Y(),Y=null),ye}}),_e[mS]=function(Ue){return Ue?Ue===M[GP]||Ue===M[Wp]?_e[Ue]:(_e[O_]||{})[Ue]:null},_e[uv]=function(Ue,et){Ue&&(Ue===M[GP]?(_e[Ue]||(_e[Bp]=function(){return!0}),_e[Ue]=et):Ue===M[Wp]?_e[Ue]=et:(_e[O_]=_e[O_]||{})[Ue]=et)},_e[Ab]=function(){var Ue=0,et=_e[mS](M[Wp]);if(jo(et))for(var nt=0;nt<et[ra];nt++){var lt=et[nt];lt&&(Ue+=lt[vc])}_e[vc]=gn()-_e.start,_e.exTime=_e[vc]-Ue,_e[Ab]=function(){}}}return M.ParentContextKey="parent",M.ChildrenContextKey="childEvts",M}(),Db=function(){function M(V){this.ctx={},Ia(M,this,function(Y){Y.create=function(ie,ye,_e){return new nR(ie,ye,_e)},Y.fire=function(ie){ie&&(ie[Ab](),V&&Xo(V[uy])&&V[uy](ie))},Y[uv]=function(ie,ye){ie&&((Y[O_]=Y[O_]||{})[ie]=ye)},Y[mS]=function(ie){return(Y[O_]||{})[ie]}})}return M.__ieDyn=1,M}(),N_="CoreUtils.doPerf";function lu(M,V,Y,ie,ye){if(M){var _e=M;if(_e[Ib]&&(_e=_e[Ib]()),_e){var Ue=void 0,et=_e[mS](N_);try{if(Ue=_e.create(V(),ie,ye)){if(et&&Ue[uv]&&(Ue[uv](nR[GP],et),et[mS]&&et[uv])){var nt=et[mS](nR[Wp]);nt||(nt=[],et[uv](nR[Wp],nt)),nt[$l](Ue)}return _e[uv](N_,Ue),Y(Ue)}}catch(lt){Ue&&Ue[uv]&&Ue[uv]("exception",lt)}finally{Ue&&_e.fire(Ue),_e[uv](N_,et)}}}return Y()}function WT(){return qP}function aR(){var M=R0();return go(M,0,8)+"-"+go(M,8,12)+"-"+go(M,12,16)+"-"+go(M,16,20)+"-"+go(M,20)}function R0(){for(var M,V=["0","1","2","3","4","5","6","7","8","9","a","b","c","d","e","f"],Y=ll,ie=0;ie<4;ie++)Y+=V[15&(M=Vp())]+V[M>>4&15]+V[M>>8&15]+V[M>>12&15]+V[M>>16&15]+V[M>>20&15]+V[M>>24&15]+V[M>>28&15];var ye=V[8+(3&Vp())|0];return _s(Y,0,8)+_s(Y,9,4)+"4"+_s(Y,13,3)+ye+_s(Y,16,3)+_s(Y,19,12)}var a1="00000000000000000000000000000000",rR="0000000000000000";function r1(M,V,Y){return!(!M||M[ra]!==V||M===Y)&&!!M.match(/^[\da-f]*$/i)}function MI(M){return r1(M,32,a1)}function oR(M){return r1(M,16,rR)}var sR=TI("plugin");function wS(M){return sR.get(M,"state",{},!0)}function lR(M,V){for(var Y,ie=[],ye=null,_e=M[Ic]();_e;){var Ue=_e[lv]();if(Ue){ye&&ye[Eb]&&Ue[Ys]&&ye[Eb](Ue);var et=!!(Y=wS(Ue))[Hu];Ue[Hu]&&(et=Ue[Hu]()),et||ie[$l](Ue),ye=Ue,_e=_e[Ic]()}}Va(ie,function(nt){var lt=M[En]();nt[hS](M.getCfg(),lt,V,M[Ic]()),Y=wS(nt),nt[En]||Y[En]||(Y[En]=lt),Y[Hu]=!0,delete Y[xd]})}function M0(M){return M.sort(function(V,Y){var ie=0;if(Y){var ye=Y[Ys];V[Ys]?ie=ye?V[Xl]-Y[Xl]:1:ye&&(ie=-1)}else ie=V?1:-1;return ie})}function PI(M){var V={};return{getName:function(){return V[rp]},setName:function(Y){V[rp]=Y},getTraceId:function(){return V[Vk]},setTraceId:function(Y){MI(Y)&&(V[Vk]=Y)},getSpanId:function(){return V[Up]},setSpanId:function(Y){oR(Y)&&(V[Up]=Y)},getTraceFlags:function(){return V[Eg]},setTraceFlags:function(Y){V[Eg]=Y}}}var KT,WP="TelemetryPluginChain",DI="_hasRun",cR="_getTelCtx",LI=0;function o1(M,V,Y){for(;M;){if(M[lv]()===Y)return M;M=M[Ic]()}return JT([Y],V.config||{},V)}function KP(M,V,Y,ie){var ye=null,_e=[];V||(V=jp({},null,Y[Hc])),ie!==null&&(ye=ie?o1(M,Y,ie):M);var Ue={_next:nt,ctx:{core:function(){return Y},diagLog:function(){return ES(Y,V.cfg)},getCfg:function(){return V.cfg},getExtCfg:Ct,getConfig:zt,hasNext:function(){return!!ye},getNext:function(){return ye},setNext:function(ii){ye=ii},iterate:li,onComplete:et}};function et(ii,wi){for(var oi=[],Gt=2;Gt<arguments.length;Gt++)oi[Gt-2]=arguments[Gt];ii&&_e[$l]({func:ii,self:bl(wi)?Ue.ctx:wi,args:oi})}function nt(){var ii=ye;if(ye=ii?ii[Ic]():null,!ii){var wi=_e;wi&&wi[ra]>0&&(Va(wi,function(oi){try{oi.func.call(oi.self,oi.args)}catch(Gt){cl(Y[Hc],2,73,"Unexpected Exception during onComplete - "+zs(Gt))}}),_e=[])}return ii}function lt(ii,wi){var oi=null,Gt=V.cfg;if(Gt&&ii){var ui=Gt[dm];!ui&&wi&&(ui={}),Gt[dm]=ui,(ui=V.ref(Gt,dm))&&(!(oi=ui[ii])&&wi&&(oi={}),ui[ii]=oi,oi=V.ref(ui,ii))}return oi}function Ct(ii,wi){var oi=lt(ii,!0);return wi&&sl(wi,function(Gt,ui){if(rl(oi[Gt])){var $i=V.cfg[Gt];!$i&&rl($i)||(oi[Gt]=$i)}ar(V,oi,Gt,ui)}),V[ap](oi,wi)}function zt(ii,wi,oi){var Gt;oi===void 0&&(oi=!1);var ui=lt(ii,!1),$i=V.cfg;return!ui||!ui[wi]&&rl(ui[wi])?!$i[wi]&&rl($i[wi])||(Gt=$i[wi]):Gt=ui[wi],Gt||!rl(Gt)?Gt:oi}function li(ii){for(var wi;wi=Ue._next();){var oi=wi[lv]();oi&&ii(oi)}}return Ue}function by(M,V,Y,ie){var ye=jp(V),_e=KP(M,ye,Y,ie),Ue=_e.ctx;function et(lt){var Ct=_e._next();return Ct&&Ct[Ys](lt,Ue),!Ct}function nt(lt,Ct){return lt===void 0&&(lt=null),jo(lt)&&(lt=JT(lt,ye.cfg,Y,Ct)),by(lt||Ue[Ic](),ye.cfg,Y,Ct)}return Ue[yc]=et,Ue[ju]=nt,Ue}function dR(M,V,Y){var ie=jp(V.config),ye=KP(M,ie,V,Y),_e=ye.ctx;function Ue(nt){var lt=ye._next();return lt&&lt[nu](_e,nt),!lt}function et(nt,lt){return nt===void 0&&(nt=null),jo(nt)&&(nt=JT(nt,ie.cfg,V,lt)),dR(nt||_e[Ic](),V,lt)}return _e[yc]=Ue,_e[ju]=et,_e}function x_(M,V,Y){var ie=jp(V.config),ye=KP(M,ie,V,Y).ctx;function _e(et){return ye.iterate(function(nt){Xo(nt[pS])&&nt[pS](ye,et)})}function Ue(et,nt){return et===void 0&&(et=null),jo(et)&&(et=JT(et,ie.cfg,V,nt)),x_(et||ye[Ic](),V,nt)}return ye[yc]=_e,ye[ju]=Ue,ye}function JT(M,V,Y,ie){var ye=null,_e=!ie;if(jo(M)&&M[ra]>0){var Ue=null;Va(M,function(et){if(_e||ie!==et||(_e=!0),_e&&et&&Xo(et[Ys])){var nt=Ty(et,V,Y);ye||(ye=nt),Ue&&Ue._setNext(nt),Ue=nt}})}return ie&&!ye?JT([ie],V,Y):ye}function Ty(M,V,Y){var ie,ye=null,_e=Xo(M[Ys]),Ue=Xo(M[Eb]),et={getPlugin:function(){return M},getNext:function(){return ye},processTelemetry:Ct,unload:zt,update:li,_id:ie=M?M[Lp]+"-"+M[Xl]+"-"+LI++:"Unknown-0-"+LI++,_setNext:function(ii){ye=ii}};function nt(){var ii;return M&&Xo(M[cR])&&(ii=M[cR]()),ii||(ii=by(et,V,Y)),ii}function lt(ii,wi,oi,Gt,ui){var $i=!1,In=M?M[Lp]:WP,Kt=ii[DI];return Kt||(Kt=ii[DI]={}),ii.setNext(ye),M&&lu(ii[En](),function(){return In+":"+oi},function(){Kt[ie]=!0;try{var ki=ye?ye._id:ll;ki&&(Kt[ki]=!1),$i=wi(ii)}catch($a){var sa=!ye||Kt[ye._id];sa&&($i=!0),ye&&sa||cl(ii[ly](),1,73,"Plugin ["+In+"] failed during "+oi+" - "+zs($a)+", run flags: "+zs(Kt))}},Gt,ui),$i}function Ct(ii,wi){function oi(Gt){if(!M||!_e)return!1;var ui=wS(M);return!ui[xd]&&!ui[ao]&&(Ue&&M[Eb](ye),M[Ys](ii,Gt),!0)}lt(wi=wi||nt(),oi,"processTelemetry",function(){return{item:ii}},!ii.sync)||wi[yc](ii)}function zt(ii,wi){function oi(){var Gt=!1;if(M){var ui=wS(M),$i=M[En]||ui[En];!M||$i&&$i!==ii.core()||ui[xd]||(ui[En]=null,ui[xd]=!0,ui[Hu]=!1,M[xd]&&M[xd](ii,wi)===!0&&(Gt=!0))}return Gt}lt(ii,oi,"unload",function(){},wi[Cg])||ii[yc](wi)}function li(ii,wi){function oi(){var Gt=!1;if(M){var ui=wS(M),$i=M[En]||ui[En];!M||$i&&$i!==ii.core()||ui[xd]||M[pS]&&M[pS](ii,wi)===!0&&(Gt=!0)}return Gt}lt(ii,oi,"update",function(){},!1)||ii[yc](wi)}return bd(et)}function A(){var M=[];function V(ie){ie&&M[$l](ie)}function Y(ie,ye){Va(M,function(_e){try{_e(ie,ye)}catch(Ue){cl(ie[ly](),2,73,"Unexpected error calling unload handler - "+zs(Ue))}}),M=[]}return{add:V,run:Y}}function R(){var M=[];function V(ie){var ye=M;M=[],Va(ye,function(_e){try{(_e.rm||_e.remove).call(_e)}catch(Ue){cl(ie,2,73,"Unloading:"+zs(Ue))}})}function Y(ie){ie&&oS(M,ie)}return{run:V,add:Y}}var K="getPlugin",ae=((KT={})[dm]={isVal:FT,v:{}},KT),Ce=function(){function M(){var V,Y,ie,ye,_e,Ue=this;function et(Ct){Ct===void 0&&(Ct=null);var zt=Ct;if(!zt){var li=Y||by(null,{},Ue[En]);zt=ie&&ie[K]?li[ju](null,ie[K]):li[ju](null,ie)}return zt}function nt(Ct,zt,li){jp(Ct,ae,ES(zt)),!li&&zt&&(li=zt[sm]()[Ic]());var ii=ie;ie&&ie[K]&&(ii=ie[K]()),Ue[En]=zt,Y=by(li,Ct,zt,ii)}function lt(){V=!1,Ue[En]=null,Y=null,ie=null,_e=R(),ye=A()}lt(),Ia(M,Ue,function(Ct){Ct[hS]=function(zt,li,ii,wi){nt(zt,li,wi),V=!0},Ct[xd]=function(zt,li){var ii,wi=Ct[En];if(wi&&(!zt||wi===zt[En]())){var oi,Gt=!1,ui=zt||dR(null,wi,ie&&ie[K]?ie[K]():ie),$i=li||((ii={reason:0})[Cg]=!1,ii);return Ct[l0]&&Ct[l0](ui,$i,In)===!0?oi=!0:In(),oi}function In(){Gt||(Gt=!0,ye.run(ui,li),_e.run(ui[ly]()),oi===!0&&ui[yc]($i),lt())}},Ct[pS]=function(zt,li){var ii=Ct[En];if(ii&&(!zt||ii===zt[En]())){var wi,oi=!1,Gt=zt||x_(null,ii,ie&&ie[K]?ie[K]():ie),ui=li||{reason:0};return Ct._doUpdate&&Ct._doUpdate(Gt,ui,$i)===!0?wi=!0:$i(),wi}function $i(){oi||(oi=!0,nt(Gt.getCfg(),Gt.core(),Gt[Ic]()))}},Gu(Ct,"_addUnloadCb",function(){return ye},"add"),Gu(Ct,"_addHook",function(){return _e},"add"),yo(Ct,"_unloadHooks",{g:function(){return _e}})}),Ue[ly]=function(Ct){return et(Ct)[ly]()},Ue[Hu]=function(){return V},Ue.setInitialized=function(Ct){V=Ct},Ue[Eb]=function(Ct){ie=Ct},Ue[yc]=function(Ct,zt){zt?zt[yc](Ct):ie&&Xo(ie[Ys])&&ie[Ys](Ct,null)},Ue._getTelCtx=et}return M.__ieDyn=1,M}();function Ve(M,V,Y){var ie={id:V,fn:Y};return oS(M,ie),{remove:function(){Va(M,function(ye,_e){if(ye.id===ie.id)return M[Dh](_e,1),-1})}}}function mt(M,V,Y){for(var ie=!1,ye=M[ra],_e=0;_e<ye;++_e){var Ue=M[_e];if(Ue)try{if(Ue.fn[ay](null,[V])===!1){ie=!0;break}}catch(et){cl(Y,2,64,"Telemetry initializer failed: "+__(et),{exception:zs(et)},!0)}}return!ie}var Xt,Si=function(M){function V(){var Y,ie,ye=M.call(this)||this;function _e(){Y=0,ie=[]}return ye.identifier="TelemetryInitializerPlugin",ye.priority=199,_e(),Ia(V,ye,function(Ue,et){Ue.addTelemetryInitializer=function(nt){return Ve(ie,Y++,nt)},Ue[Ys]=function(nt,lt){mt(ie,nt,lt?lt[ly]():Ue[ly]())&&Ue[yc](nt,lt)},Ue[l0]=function(){_e()}}),ye}return _u(V,M),V.__ieDyn=1,V}(Ce),Zi="Plugins must provide initialize method",Kn="_notificationManager",Zn="SDK is still unloading...",Gn="SDK is not initialized",Ka=dh(((Xt={cookieCfg:{}})[op]={rdOnly:!0,ref:!0,v:[]},Xt[_d]={rdOnly:!0,ref:!0,v:[]},Xt[dm]={ref:!0,v:{}},Xt[Vs]=Xm,Xt.loggingLevelConsole=0,Xt.diagnosticLogInterval=Xm,Xt));function br(M,V){return new Db(V)}function Tr(M,V,Y){var ie,ye=[],_e=[],Ue={};return Va(Y,function(et){(rl(et)||rl(et[hS]))&&mg(Zi);var nt=et[Xl],lt=et[Lp];et&&nt&&(rl(Ue[nt])?Ue[nt]=lt:Mb(M,"Two extensions have same priority #"+nt+" - "+Ue[nt]+", "+lt)),!nt||nt<V?ye[$l](et):_e[$l](et)}),(ie={})[En]=ye,ie[_d]=_e,ie}function Ud(M,V){var Y=!1;return Va(V,function(ie){if(ie===M)return Y=!0,-1}),Y}function Vi(M,V,Y,ie){Y&&sl(Y,function(ye,_e){ie&&Js(_e)&&Js(V[ye])&&Vi(M,V[ye],_e,ie),ie&&Js(_e)&&Js(V[ye])?Vi(M,V[ye],_e,ie):M.set(V,ye,_e)})}function Mi(M,V){var Y=null,ie=-1;return Va(M,function(ye,_e){if(ye.w===V)return Y=ye,ie=_e,-1}),{i:ie,l:Y}}function Yi(M,V){var Y=Mi(M,V).l;return Y||(Y={w:V,rm:function(){var ie=Mi(M,V);ie.i!==-1&&M[Dh](ie.i,1)}},M[$l](Y)),Y}function Jn(M,V,Y){Va(V,function(ie){var ye=Bd(M,ie.w,Y);delete ie.w,ie.rm=function(){ye.rm()}})}function Cr(M,V,Y,ie){return V.add(M[Dc](function(ye){var _e=ye.cfg.disableDbgExt;_e===!0&&ie&&(Y[g_](ie),ie=null),Y&&!ie&&_e!==!0&&(ie=CS(ye.cfg),Y[ry](ie))})),ie}function lo(M){return yo({rm:function(){M.rm()}},"toJSON",{v:function(){return"aicore::onCfgChange<"+JSON.stringify(M)+">"}})}var ho=function(){function M(){var V,Y,ie,ye,_e,Ue,et,nt,lt,Ct,zt,li,ii,wi,oi,Gt,ui,$i,In,Kt,ki,sa,$a,Mr,mn,Ir,fn,Xn;Ia(M,this,function(mi){function wn(Sn){return Ir&&Ir[Op]||Xn||(Sn||ie&&ie.queue[ra]>0)&&(fn||(fn=!0,Ch(V[Dc](function(Ha){var cr=Ha.cfg.diagnosticLogInterval;cr&&cr>0||(cr=1e4);var ba=!1;Ir&&(ba=Ir[Op],Ir[Tg]()),(Ir=xP(sc,cr)).unref(),Ir[Op]=ba}))),Ir[Op]=!0),Ir}function wa(){var Sn={};Mr=[];var Ha=function(cr){cr&&Va(cr,function(ba){if(ba[Lp]&&ba[sy]&&!Sn[ba.identifier]){var Pr=ba[Lp]+"="+ba[sy];Mr[$l](Pr),Sn[ba.identifier]=ba}})};Ha(li),zt&&Va(zt,function(cr){Ha(cr)}),Ha(Ct)}function lr(){Y=!1,(V=jp({},Ka,mi[Hc])).cfg[Np]=1,yo(mi,"config",{g:function(){return V.cfg},s:function(Ha){mi.updateCfg(Ha,!1)}}),yo(mi,"pluginVersionStringArr",{g:function(){return Mr||wa(),Mr}}),yo(mi,"pluginVersionString",{g:function(){return mn||(Mr||wa(),mn=Mr.join(";")),mn||ll}}),yo(mi,"logger",{g:function(){return ie||(ie=new AS(V.cfg),V[Hc]=ie),ie},s:function(Ha){V[Hc]=Ha,ie!==Ha&&(M_(ie,!1),ie=Ha)}}),mi[Hc]=new AS(V.cfg),$a=[];var Sn=mi.config[op]||[];Sn.splice(0,Sn[ra]),oS(Sn,$a),wi=new Si,ye=[],M_(_e,!1),_e=null,Ue=null,et=null,M_(nt,!1),nt=null,lt=null,Ct=[],zt=null,li=null,ii=!1,oi=null,Gt=w_("AIBaseCore",!0),ui=A(),Kt=null,ki=null,$i=R(),sa=[],mn=null,Mr=null,Xn=!1,Ir=null,fn=!1}function ka(){var Sn=by(la(),V.cfg,mi);return Sn[m_](wn),Sn}function Ba(Sn){var Ha=Tr(mi[Hc],HT,Ct);lt=null,mn=null,Mr=null,li=M0(oS(li=(zt||[])[0]||[],Ha[_d]));var cr=oS(M0(Ha[En]),li);$a=bd(cr);var ba=mi.config[op]||[];ba.splice(0,ba[ra]),oS(ba,$a);var Pr=ka();li&&li[ra]>0&&lR(Pr[ju](li),cr),lR(Pr,cr),Sn&&xr(Sn)}function Qr(Sn){var Ha=null,cr=null,ba=[];return Va($a,function(Pr){if(Pr[Lp]===Sn&&Pr!==wi)return cr=Pr,-1;Pr.getChannel&&ba[$l](Pr)}),!cr&&ba[ra]>0&&Va(ba,function(Pr){if(!(cr=Pr.getChannel(Sn)))return-1}),cr&&(Ha={plugin:cr,setEnabled:function(Pr){wS(cr)[ao]=!Pr},isEnabled:function(){var Pr=wS(cr);return!Pr[xd]&&!Pr[ao]},remove:function(Pr,No){var Eo;Pr===void 0&&(Pr=!0);var Cl=[cr],sd=((Eo={reason:1})[Cg]=Pr,Eo);mr(Cl,sd,function(xh){xh&&Ba({reason:32,removed:Cl}),No&&No(xh)})}}),Ha}function la(){if(!lt){var Sn=($a||[]).slice();om(Sn,wi)===-1&&Sn[$l](wi),lt=JT(M0(Sn),V.cfg,mi)}return lt}function mr(Sn,Ha,cr){if(Sn&&Sn[ra]>0){var ba=dR(JT(Sn,V.cfg,mi),mi);ba[m_](function(){var Pr=!1,No=[];Va(Ct,function(Cl,sd){Ud(Cl,Sn)?Pr=!0:No[$l](Cl)}),Ct=No,mn=null,Mr=null;var Eo=[];zt&&(Va(zt,function(Cl,sd){var xh=[];Va(Cl,function(Cm){Ud(Cm,Sn)?Pr=!0:xh[$l](Cm)}),Eo[$l](xh)}),zt=Eo),cr&&cr(Pr),wn()}),ba[yc](Ha)}else cr(!1)}function sc(){if(ie&&ie.queue){var Sn=ie.queue.slice(0);ie.queue[ra]=0,Va(Sn,function(Ha){var cr,ba=((cr={})[rp]=oi||"InternalMessageId: "+Ha[Ac],cr.iKey=ki,cr[vc]=C_(new Date),cr.baseType=_S.dataType,cr.baseData={message:Ha[au]},cr);mi.track(ba)})}}function Rs(Sn,Ha,cr,ba){var Pr=1,No=!1,Eo=null;function Cl(){Pr--,No&&Pr===0&&(Eo&&Eo[Tg](),Eo=null,Ha&&Ha(No),Ha=null)}return ba=ba||5e3,li&&li[ra]>0&&ka()[ju](li).iterate(function(sd){if(sd.flush){Pr++;var xh=!1;sd.flush(Sn,function(){xh=!0,Cl()},cr)||xh||(Sn&&Eo==null?Eo=nv(function(){Eo=null,Cl()},ba):Cl())}}),No=!0,Cl(),!0}function Vd(){var Sn;Ch(V[Dc](function(Ha){if(Ha.cfg.enablePerfMgr){var cr=Ha.cfg[Vs];Sn!==cr&&(cr||(cr=br),pI(Ha.cfg,Vs,cr),Sn=cr,et=null),Ue||et||!Xo(cr)||(et=cr(mi,mi[sv]()))}else et=null,Sn=null}))}function xr(Sn){var Ha=x_(la(),mi);Ha[m_](wn),mi._updateHook&&mi._updateHook(Ha,Sn)===!0||Ha[yc](Sn)}function Ad(Sn){var Ha=mi[Hc];Ha?(cl(Ha,2,73,Sn),wn()):mg(Sn)}function OS(Sn){var Ha=mi[sv]();Ha&&Ha[ef]([Sn],2)}function Ch(Sn){$i.add(Sn)}lr(),mi._getDbgPlgTargets=function(){return[$a]},mi[Hu]=function(){return Y},mi[hS]=function(Sn,Ha,cr,ba){ii&&mg(Zn),mi[Hu]()&&mg("Core cannot be initialized more than once"),Sn=(V=jp(Sn,Ka,cr||mi[Hc],!1)).cfg,Ch(V[Dc](function(Eo){ki=Eo.cfg.instrumentationKey;var Cl=Eo.ref(Eo.cfg,dm);sl(Cl,function(sd){Eo.ref(Cl,sd)}),rl(ki)&&mg("Please provide instrumentation key")})),In=Cr(V,$i,(_e=ba)&&mi[sv](),In),Vd(),mi[Hc]=cr;var Pr=Sn[op];if((Ct=[])[$l].apply(Ct,Uk(Uk([],Ha,!1),Pr)),zt=Sn[_d],Ba(null),li&&li[ra]!==0||mg("No "+_d+" available"),zt&&zt[ra]>1){var No=mi[lv]("TeeChannelController");No&&No.plugin||cl(ie,1,28,"TeeChannel required")}Jn(Sn,sa,ie),sa=null,Y=!0,mi.releaseQueue(),mi[_b]()},mi.getChannels=function(){var Sn=[];return li&&Va(li,function(Ha){Sn[$l](Ha)}),bd(Sn)},mi.track=function(Sn){lu(mi[Ib](),function(){return"AppInsightsCore:track"},function(){Sn===null&&(OS(Sn),mg("Invalid telemetry item")),!Sn[rp]&&rl(Sn[rp])&&(OS(Sn),mg("telemetry name required")),Sn.iKey=Sn.iKey||ki,Sn[vc]=Sn[vc]||C_(new Date),Sn.ver=Sn.ver||"4.0",!ii&&mi[Hu]()?ka()[yc](Sn):ye[$l](Sn)},function(){return{item:Sn}},!Sn.sync)},mi[sm]=ka,mi[sv]=function(){return _e||(_e=new RI(V.cfg),mi[Kn]=_e),_e},mi[ry]=function(Sn){mi.getNotifyMgr()[ry](Sn)},mi[g_]=function(Sn){_e&&_e[g_](Sn)},mi.getCookieMgr=function(){return nt||(nt=kI(V.cfg,mi[Hc])),nt},mi.setCookieMgr=function(Sn){nt!==Sn&&(M_(nt,!1),nt=Sn)},mi[Ib]=function(){return Ue||et||WT()},mi.setPerfMgr=function(Sn){Ue=Sn},mi.eventCnt=function(){return ye[ra]},mi.releaseQueue=function(){if(Y&&ye[ra]>0){var Sn=ye;ye=[],Va(Sn,function(Ha){ka()[yc](Ha)})}},mi[_b]=function(Sn){return oi=Sn||null,Xn=!1,Ir&&Ir[Tg](),wn(!0)},mi[oy]=function(){Xn=!0,Ir&&Ir[Tg](),sc()},hm(mi,function(){return wi},["addTelemetryInitializer"]),mi[nu]=function(Sn,Ha,cr){var ba;Sn===void 0&&(Sn=!0),Y||mg(Gn),ii&&mg(Zn);var Pr,No=((ba={reason:50})[Cg]=Sn,ba.flushComplete=!1,ba);Sn&&!Ha&&(Pr=Zl(function(sd){Ha=sd}));var Eo=dR(la(),mi);function Cl(sd){No.flushComplete=sd,ii=!0,ui.run(Eo,No),mi[oy](),Eo[yc](No)}return Eo[m_](function(){$i.run(mi[Hc]),ZO([nt,_e,ie],Sn,function(){lr(),Ha&&Ha(No)})},mi),sc(),Rs(Sn,Cl,6,cr),Pr},mi[lv]=Qr,mi.addPlugin=function(Sn,Ha,cr,ba){if(!Sn)return ba&&ba(!1),void Ad(Zi);var Pr=Qr(Sn[Lp]);if(Pr&&!Ha)return ba&&ba(!1),void Ad("Plugin ["+Sn[Lp]+"] is already loaded!");var No={reason:16};function Eo(sd){Ct[$l](Sn),No.added=[Sn],Ba(No),ba&&ba(!0)}if(Pr){var Cl=[Pr.plugin];mr(Cl,{reason:2,isAsync:!!cr},function(sd){sd?(No.removed=Cl,No.reason|=32,Eo()):ba&&ba(!1)})}else Eo()},mi.updateCfg=function(Sn,Ha){var cr;if(Ha===void 0&&(Ha=!0),mi[Hu]()){cr={reason:1,cfg:V.cfg,oldCfg:Bk({},V.cfg),newConfig:Bk({},Sn),merge:Ha},Sn=cr.newConfig;var ba=V.cfg;Sn[op]=ba[op],Sn[_d]=ba[_d]}V._block(function(Pr){var No=Pr.cfg;Vi(Pr,No,Sn,Ha),Ha||sl(No,function(Eo){ch(Sn,Eo)||Pr.set(No,Eo,Xm)}),Pr[ap](No,Ka)},!0),V[kl](),cr&&xr(cr)},mi.evtNamespace=function(){return Gt},mi.flush=Rs,mi.getTraceCtx=function(Sn){return Kt||(Kt=PI()),Kt},mi.setTraceCtx=function(Sn){Kt=Sn||null},mi.addUnloadHook=Ch,Gu(mi,"addUnloadCb",function(){return ui},"add"),mi.onCfgChange=function(Sn){return lo(Y?Bd(V.cfg,Sn,mi[Hc]):Yi(sa,Sn))},mi.getWParam=function(){return Nk()||V.cfg.enableWParam?0:-1}})}return M.__ieDyn=1,M}(),Hr="",yh="&NoResponseBody=true",Tl="POST",YT=function(){function M(){var V,Y,ie,ye,_e,Ue,et,nt,lt,Ct,zt,li,ii,wi=0;Ia(M,this,function(oi,Gt){var ui=!0;function $i(mi,wn){sa(wn,200,{},mi)}function In(mi,wn){cl(ie,2,26,"Failed to send telemetry.",{message:mi}),sa(wn,400,{})}function Kt(mi){In("No endpoint url is provided for the batch",mi)}function ki(mi,wn){for(var wa,lr=0,ka=null,Ba=0;ka==null&&Ba<mi[ra];)lr=mi[Ba],nt||lr!==1?lr!==2||!bS(wn)||wn&&zt?lr!==3||!Yr()||(wn?Ct:lt)||(ka=Mr):ka=Ir:qk()?ka=fn:gy()&&(ka=mn),Ba++;return ka?((wa={_transport:lr,_isSync:wn})[Cd]=ka,wa):null}function sa(mi,wn,wa,lr){try{mi&&mi(wn,wa,lr)}catch{}}function $a(mi,wn){var wa=Yv(),lr=mi[DT];if(!lr)return Kt(wn),!0;lr=mi[DT]+(li?yh:Hr);var ka=mi[cy],Ba=ye?ka:new Blob([ka],{type:"text/plain;charset=UTF-8"});return wa.sendBeacon(lr,Ba)}function Mr(mi,wn,wa){var lr=mi[cy];try{if(lr)if($a(mi,wn))$i(Hr,wn);else{var ka=_e&&_e.beaconOnRetry;ka&&Xo(ka)?ka(mi,wn,$a):(et&&et[Cd](mi,wn,!0),cl(ie,2,40,". Failed to send telemetry with Beacon API, retried with normal sender."))}}catch(Ba){ye&&Mb(ie,"Failed to send telemetry using sendBeacon API. Ex:"+zs(Ba)),sa(wn,ye?0:400,{},Hr)}}function mn(mi,wn,wa){var lr,ka,Ba,Qr=mi[cm]||{};!wa&&V&&(lr=Zl(function(Rs,Vd){ka=Rs,Ba=Vd})),ye&&wa&&mi.disableXhrSync&&(wa=!1);var la=mi[DT];if(!la)return Kt(wn),void(ka&&ka(!1));var mr=zT(Tl,la,ui,!0,wa,mi[Fp]);function sc(Rs){var Vd=_e&&_e.xhrOnComplete;if(Vd&&Xo(Vd))Vd(Rs,wn,mi);else{var xr=py(Rs);sa(wn,Rs[Ns],VT(Rs,ye),xr)}}return ye||mr[zk]("Content-type","application/json"),Va(Os(Qr),function(Rs){mr[zk](Rs,Qr[Rs])}),mr.onreadystatechange=function(){ye||(sc(mr),mr.readyState===4&&ka&&ka(!0))},mr.onload=function(){ye&&sc(mr)},mr.onerror=function(Rs){sa(wn,ye?mr[Ns]:400,VT(mr,ye),ye?Hr:wb(mr)),Ba&&Ba(Rs)},mr.ontimeout=function(){sa(wn,ye?mr[Ns]:500,VT(mr,ye),ye?Hr:wb(mr)),ka&&ka(!1)},mr.send(mi[cy]),lr}function Ir(mi,wn,wa){var lr,ka,Ba,Qr,la=mi[DT],mr=mi[cy],sc=ye?mr:new Blob([mr],{type:"application/json"}),Rs=new Headers,Vd=mr[ra],xr=!1,Ad=!1,OS=mi[cm]||{},Ch=((lr={method:Tl,body:sc})[jT]=!0,lr);mi.headers&&Os(mi.headers)[ra]>0&&(Va(Os(OS),function(ba){Rs.append(ba,OS[ba])}),Ch[cm]=Rs),ui&&ye&&(Ch.credentials="include"),wa&&(Ch.keepalive=!0,wi+=Vd,ye?mi._sendReason===2&&(xr=!0,li&&(la+=yh)):xr=!0);var Sn=new Request(la,Ch);try{Sn[jT]=!0}catch{}if(!wa&&V&&(ka=Zl(function(ba,Pr){Ba=ba,Qr=Pr})),!la)return Kt(wn),void(Ba&&Ba(!1));function Ha(ba){sa(wn,ye?0:400,{},ye?Hr:ba)}function cr(ba,Pr,No){var Eo=ba[Ns],Cl=_e.fetchOnComplete;Cl&&Xo(Cl)?Cl(ba,wn,No||Hr,Pr):sa(wn,Eo,{},No||Hr)}try{hv(fetch(ye?la:Sn,ye?Ch:null),function(ba){if(wa&&(wi-=Vd,Vd=0),!Ad)if(Ad=!0,ba.rejected)Ha(ba.reason&&ba.reason[au]),Qr&&Qr(ba.reason);else{var Pr=ba.value;try{ye||Pr.ok?ye&&!Pr.body?(cr(Pr,null,Hr),Ba&&Ba(!0)):hv(Pr.text(),function(No){cr(Pr,mi,No.value),Ba&&Ba(!0)}):(Ha(Pr.statusText),Ba&&Ba(!1))}catch(No){Ha(zs(No)),Qr&&Qr(No)}}})}catch(ba){Ad||(Ha(zs(ba)),Qr&&Qr(ba))}return xr&&!Ad&&(Ad=!0,sa(wn,200,{}),Ba&&Ba(!0)),ye&&!Ad&&mi[Fp]>0&&ii&&ii.set(function(){Ad||(Ad=!0,sa(wn,500,{}),Ba&&Ba(!0))},mi[Fp]),ka}function fn(mi,wn,wa){var lr=ev(),ka=new XDomainRequest,Ba=mi[cy];ka.onload=function(){var Rs=py(ka),Vd=_e&&_e.xdrOnComplete;Vd&&Xo(Vd)?Vd(ka,wn,mi):sa(wn,200,{},Rs)},ka.onerror=function(){sa(wn,400,{},ye?Hr:SS(ka))},ka.ontimeout=function(){sa(wn,500,{})},ka.onprogress=function(){};var Qr=lr&&lr.location&&lr.location[ru]||"",la=mi[DT];if(la){if(!ye&&la.lastIndexOf(Qr,0)!==0){var mr="Cannot send XDomain request. The endpoint URL protocol doesn't match the hosting page protocol.";return cl(ie,2,40,". "+mr),void In(mr,wn)}var sc=ye?la:la[_g](/^(https?:)/,"");ka.open(Tl,sc),mi[Fp]&&(ka[Fp]=mi[Fp]),ka.send(Ba),ye&&wa?ii&&ii.set(function(){ka.send(Ba)},0):ka.send(Ba)}else Kt(wn)}function Xn(){wi=0,Y=!1,V=!1,ie=null,ye=null,_e=null,Ue=null,et=null,nt=!1,lt=!1,Ct=!1,zt=!1,li=!1,ii=null}Xn(),oi[hS]=function(mi,wn){ie=wn,Y&&cl(ie,1,28,"Sender is already initialized"),oi.SetConfig(mi),Y=!0},oi._getDbgPlgTargets=function(){return[Y,ye,Ue,V]},oi.SetConfig=function(mi){try{if(_e=mi.senderOnCompleteCallBack||{},Ue=!!mi.disableCredentials,ye=!!mi.isOneDs,V=!!mi.enableSendPromise,nt=!!mi.disableXhr,lt=!!mi.disableBeacon,Ct=!!mi.disableBeaconSync,ii=mi.timeWrapper,li=!!mi.addNoResponse,zt=!!mi.disableFetchKeepAlive,et={sendPOST:mn},ye||(ui=!1),Ue){var wn=qu();wn&&wn.protocol&&wn.protocol[Qm]()==="file:"&&(ui=!1)}return!0}catch{}return!1},oi.getSyncFetchPayload=function(){return wi},oi.getSenderInst=function(mi,wn){return mi&&mi[ra]?ki(mi,wn):null},oi.getFallbackInst=function(){return et},oi[l0]=function(mi,wn){Xn()}})}return M.__ieDyn=1,M}(),JP="on",Cy="attachEvent",J4="addEventListener",Y4="detachEvent",B_="removeEventListener",Yo="events",YP="visibilitychange",kg="pagehide",Ku="pageshow",Q4="unload",F_="beforeunload",Z4=w_("aiEvtPageHide"),OI=w_("aiEvtPageShow"),TF=/\.[\.]+/g,QP=/[\.]+$/,CF=1,uR=TI("events"),i7=/^([^.]*)(?:\.(.+)|)/;function Lb(M){return M&&M[_g]?M[_g](/^[\s\.]+|(?=[\s\.])[\.\s]+$/g,ll):M}function s1(M,V){var Y;if(V){var ie=ll;jo(V)?(ie=ll,Va(V,function(_e){(_e=Lb(_e))&&(_e[0]!=="."&&(_e="."+_e),ie+=_e)})):ie=Lb(V),ie&&(ie[0]!=="."&&(ie="."+ie),M=(M||ll)+ie)}var ye=i7.exec(M||ll)||[];return(Y={})[xp]=ye[1],Y.ns=(ye[2]||ll).replace(TF,".").replace(QP,ll)[Zm](".").sort().join("."),Y}function P0(M,V,Y){Y===void 0&&(Y=!0);var ie=uR.get(M,Yo,{},Y),ye=ie[V];return ye||(ye=ie[V]=[]),ye}function Oc(M,V,Y,ie){M&&V&&V[xp]&&(M[B_]?M[B_](V[xp],Y,ie):M[Y4]&&M[Y4](JP+V[xp],Y))}function cu(M,V,Y,ie){var ye=!1;return M&&V&&V[xp]&&Y&&(M[J4]?(M[J4](V[xp],Y,ie),ye=!0):M[Cy]&&(M[Cy](JP+V[xp],Y),ye=!0)),ye}function l1(M,V,Y,ie){for(var ye=V[ra];ye--;){var _e=V[ye];_e&&(Y.ns&&Y.ns!==_e.evtName.ns||ie&&!ie(_e)||(Oc(M,_e.evtName,_e[gS],_e.capture),V[Dh](ye,1)))}}function c1(M,V,Y){if(V[xp])l1(M,P0(M,V[xp]),V,Y);else{var ie=uR.get(M,Yo,{});sl(ie,function(ye,_e){l1(M,_e,V,Y)}),Os(ie)[ra]===0&&uR.kill(M,Yo)}}function hR(M,V){return V?s1("xx",jo(V)?[M].concat(V):[M,V]).ns[Zm]("."):M}function d1(M,V,Y,ie,ye){var _e;ye===void 0&&(ye=!1);var Ue=!1;if(M)try{var et=s1(V,ie);if((Ue=cu(M,et,Y,ye))&&uR.accept(M)){var nt=((_e={guid:CF++,evtName:et})[gS]=Y,_e.capture=ye,_e);P0(M,et.type)[$l](nt)}}catch{}return Ue}function u1(M,V,Y,ie,ye){if(ye===void 0&&(ye=!1),M)try{var _e=s1(V,ie),Ue=!1;c1(M,_e,function(et){return!((!_e.ns||Y)&&et[gS]!==Y)&&(Ue=!0,!0)}),Ue||Oc(M,_e,Y,ye)}catch{}}function X4(M,V,Y){var ie=!1,ye=ev();ye&&(ie=d1(ye,M,V,Y),ie=d1(ye.body,M,V,Y)||ie);var _e=hh();return _e&&(ie=d1(_e,M,V,Y)||ie),ie}function ez(M,V,Y){var ie=ev();ie&&(u1(ie,M,V,Y),u1(ie.body,M,V,Y));var ye=hh();ye&&u1(ye,M,V,Y)}function D0(M,V,Y,ie){var ye=!1;return V&&M&&M[ra]>0&&Va(M,function(_e){_e&&(Y&&om(Y,_e)!==-1||(ye=X4(_e,V,ie)||ye))}),ye}function kS(M,V,Y,ie){var ye=!1;return V&&M&&jo(M)&&!(ye=D0(M,V,Y,ie))&&Y&&Y[ra]>0&&(ye=D0(M,V,null,ie)),ye}function NI(M,V,Y){M&&jo(M)&&Va(M,function(ie){ie&&ez(ie,V,Y)})}function n7(M,V,Y){return kS([F_,Q4,kg],M,V,Y)}function tz(M,V){NI([F_,Q4,kg],M,V)}function U_(M,V,Y){function ie(Ue){var et=hh();M&&et&&et.visibilityState==="hidden"&&M(Ue)}var ye=hR(Z4,Y),_e=D0([kg],M,V,ye);return V&&om(V,YP)!==-1||(_e=D0([YP],ie,V,ye)||_e),!_e&&V&&(_e=U_(M,null,Y)),_e}function cf(M,V){var Y=hR(Z4,V);NI([kg],M,Y),NI([YP],null,Y)}function L0(M,V,Y){function ie(Ue){var et=hh();M&&et&&et.visibilityState==="visible"&&M(Ue)}var ye=hR(OI,Y),_e=D0([Ku],M,V,ye);return!(_e=D0([YP],ie,V,ye)||_e)&&V&&(_e=L0(M,null,Y)),_e}function a7(M,V){var Y=hR(OI,V);NI([Ku],M,Y),NI([YP],null,Y)}var z_,pR="",zd="https://browser.events.data.microsoft.com/OneCollector/1.0/",h1="version",xI="properties",Sv="initialize",Es="logger",_F="indexOf",Sh="timings",BI="pollInternalLogs",RS="value",jl="kind",O0="length",p1="processTelemetryStart",gR="1DS-Web-JS-4.2.1",iz=al.hasOwnProperty,r7=((z_={})[0]=0,z_[2]=6,z_[1]=1,z_[3]=7,z_[4098]=6,z_[4097]=1,z_[4099]=7,z_);function bh(M){return!(M===pR||rl(M))}function ZP(M){if(M){var V=Km(M,"-");if(V>-1)return Ks(M,V)}return pR}function g1(M){return!!(M&&Zh(M)&&M>=1&&M<=4)}function N0(M,V,Y){if(!V&&!bh(V)||typeof M!="string")return null;var ie=typeof V;if(ie==="string"||ie==="number"||ie==="boolean"||jo(V))V={value:V};else if(ie!=="object"||iz.call(V,"value")){if(rl(V[RS])||V[RS]===pR||!Ld(V[RS])&&!Zh(V[RS])&&!Kv(V[RS])&&!jo(V[RS]))return null}else V={value:Y?JSON.stringify(V):V};if(jo(V[RS])&&!f1(V[RS]))return null;if(!rl(V[jl])){if(jo(V[RS])||!m1(V[jl]))return null;V[RS]=V[RS].toString()}return V}function EF(M,V,Y){var ie=-1;if(!bl(M))if(V>0&&(V===32?ie=8192:V<=13&&(ie=V<<5)),XP(Y))ie===-1&&(ie=0),ie|=Y;else{var ye=r7[mR(M)]||-1;ie!==-1&&ye!==-1?ie|=ye:ye===6&&(ie=ye)}return ie}function _y(M,V,Y){var ie;return Y===void 0&&(Y=!0),M&&(ie=M.get(V),Y&&ie&&decodeURIComponent&&(ie=decodeURIComponent(ie))),ie||pR}function x0(M){M===void 0&&(M="D");var V=aR();return M==="B"?V="{"+V+"}":M==="P"?V="("+V+")":M==="N"&&(V=V.replace(/-/g,pR)),V}function FI(M,V,Y,ie,ye){var _e={},Ue=!1,et=0,nt=arguments[O0],lt=arguments;for(Kv(lt[0])&&(Ue=lt[0],et++);et<nt;et++)sl(lt[et],function(Ct,zt){Ue&&zt&&Qh(zt)?jo(zt)?(_e[Ct]=_e[Ct]||[],Va(zt,function(li,ii){li&&Qh(li)?_e[Ct][ii]=FI(!0,_e[Ct][ii],li):_e[Ct][ii]=li})):_e[Ct]=FI(!0,_e[Ct],zt):_e[Ct]=zt});return _e}var MS=OP;function m1(M){return M===0||M>0&&M<=13||M===32}function XP(M){return M>=0&&M<=9}function f1(M){return M[O0]>0}function UI(M,V){var Y=M;Y[Sh]=Y[Sh]||{},Y[Sh][p1]=Y[Sh][p1]||{},Y[Sh][p1][V]=MS()}function mR(M){var V=0;if(M!=null){var Y=typeof M;Y==="string"?V=1:Y==="number"?V=2:Y==="boolean"?V=3:Y===Ho&&(V=4,jo(M)?(V=4096,M[O0]>0&&(V|=mR(M[0]))):iz.call(M,"value")&&(V=8192|mR(M[RS])))}return V}function nz(){return!!Vu("chrome")}function eD(M){return M>0}var o7=dh({endpointUrl:zd,propertyStorageOverride:{isVal:Th}});function Th(M){return!M||M.getProperty&&M.setProperty||mg("Invalid property storage override passed."),!0}var Rg=function(M){function V(){var Y=M.call(this)||this;return Ia(V,Y,function(ie,ye){ie[Sv]=function(_e,Ue,et,nt){lu(ie,function(){return"AppInsightsCore.initialize"},function(){try{ye[Sv](jp(_e,o7,et||ie[Es],!1).cfg,Ue,et,nt)}catch(zt){var lt=ie[Es],Ct=zs(zt);Ct[_F]("channels")!==-1&&(Ct+=`
 - Channels must be provided through config.channels only!`),cl(lt,1,514,"SDK Initialization Failed - no telemetry will be sent: "+Ct)}},function(){return{config:_e,extensions:Ue,logger:et,notificationManager:nt}})},ie.track=function(_e){lu(ie,function(){return"AppInsightsCore.track"},function(){var Ue=_e;if(Ue){Ue[Sh]=Ue[Sh]||{},Ue[Sh].trackStart=MS(),g1(Ue.latency)||(Ue.latency=1);var et=Ue.ext=Ue.ext||{};et.sdk=et.sdk||{},et.sdk.ver=gR;var nt=Ue.baseData=Ue.baseData||{};nt[xI]=nt[xI]||{};var lt=nt[xI];lt[h1]=lt[h1]||ie.pluginVersionString||pR}ye.track(Ue)},function(){return{item:_e}},!_e.sync)},ie[BI]=function(_e){return ye[BI](_e||"InternalLog")}}),Y}return _u(V,M),V.__ieDyn=1,V}(ho),az=Nd({Normal:1,CostDeferred:2,RealTime:3,Immediate:4}),s7=Nd({Normal:1,Critical:2}),zI="REAL_TIME",rz="NEAR_REAL_TIME",l7="BEST_EFFORT",B0="",AF="drop",oz="send",sz="requeue",c7="rspFail",d7="oth",IF="no-cache, no-store",v1="application/x-json-stream",fR="cache-control",VI="content-type",wF="kill-tokens",kF="kill-duration",vR="time-delta-millis",$I="client-version",yR="client-id",RF="time-delta-to-apply-millis",y1="upload-time",MF="apikey",S1="AuthMsaDeviceTicket",b1="WebAuthToken",lz="AuthXToken",u7="NoResponseBody",tD="msfpc",iD="trace",SR="user",bR="allowRequestSending",TR="firstRequestSent",CR="shouldAddClockSkewHeaders",cz="getClockSkewHeaderValue",nD="setClockSkew",$s="length",HI="concat",QT="iKey",Kp="count",jI="events",df="push",_R="split",T1="splice",PF="toLowerCase",ER="hdrs",aD="useHdrs",rD="initialize",dz="setTimeoutOverride",C1="clearTimeoutOverride",h7="payloadPreprocessor",AR="overrideEndpointUrl",_1="avoidOptions",uz="disableEventTimings",p7="stringifyObjects",DF="enableCompoundKey",hz="disableXhrSync",oD="disableFetchKeepAlive",g7="addNoResponse",m7="excludeCsMetaData",pz="useSendBeacon",uf="alwaysUseXhrOverride",LF="unloadTransports",gz="serializeOfflineEvt",mz="getOfflineRequestDetails",sD="createPayload",OF="createOneDSPayload",E1="payloadBlob",ZT="headers",GI="_thePayload",fz="urlString",bv="batches",Ey="sendType",NF="addHeader",A1="canSendRequest",lD="sendQueuedRequests",I1="isCompletelyIdle",xF="setUnloading",BF="isTenantKilled",qI="sendSynchronousBatch",WI="_transport",w1="getWParam",vz="isBeacon",k1="timings",FF="isTeardown",UF="isSync",R1="data",f7="timeout",M1="_sendReason",yz="setKillSwitchTenants",Sz="_backOffTransmission",P1="identifier",v7="disableOptimizeObj",y7="ignoreMc1Ms0CookieProcessing",bz="eventsLimitInMem",Tz="autoFlushEventsLimit",zF="disableAutoBatchFlushLimit",S7="overrideInstrumentationKey",b7="disableTelemetry",VF="baseData",D1="sendAttempt",KI="latency",O="sync";function q(M){var V=(M.ext||{}).intweb;return V&&bh(V[tD])?V[tD]:null}function fe(M){for(var V=null,Y=0;V===null&&Y<M[$s];Y++)V=q(M[Y]);return V}var $e=function(){function M(V,Y){var ie=Y?[][HI](Y):[],ye=this,_e=fe(ie);ye[QT]=function(){return V},ye.Msfpc=function(){return _e||B0},ye[Kp]=function(){return ie[$s]},ye[jI]=function(){return ie},ye.addEvent=function(Ue){return!!Ue&&(ie[df](Ue),_e||(_e=q(Ue)),!0)},ye[_R]=function(Ue,et){var nt;if(Ue<ie[$s]){var lt=ie[$s]-Ue;rl(et)||(lt=et<lt?et:lt),nt=ie[T1](Ue,lt),_e=fe(ie)}return new M(V,nt)}}return M.create=function(V,Y){return new M(V,Y)},M}(),ut=function(){function M(){var V=!0,Y=!0,ie=!0,ye="use-collector-delta",_e=!1;Ia(M,this,function(Ue){Ue[bR]=function(){return V},Ue[TR]=function(){ie&&(ie=!1,_e||(V=!1))},Ue[CR]=function(){return Y},Ue[cz]=function(){return ye},Ue[nD]=function(et){_e||(et?(ye=et,Y=!0,_e=!0):Y=!1,V=!0)}})}return M.__ieDyn=1,M}(),Dt=1e3,si=function(){function M(){var V={};function Y(ie){var ye=[];return ie&&Va(ie,function(_e){ye[df](eu(_e))}),ye}Ia(M,this,function(ie){ie[yz]=function(ye,_e){if(ye&&_e)try{var Ue=Y(ye[_R](","));if(_e==="this-request-only")return Ue;for(var et=parseInt(_e,10)*Dt,nt=0;nt<Ue[$s];++nt)V[Ue[nt]]=gn()+et}catch{return[]}return[]},ie[BF]=function(ye){var _e=V,Ue=eu(ye);return _e[Ue]!==void 0&&_e[Ue]>gn()||(delete _e[Ue],!1)}})}return M.__ieDyn=1,M}(),Ei=.8,Ui=1.2,Nn=3e3,Pn=6e5;function Yn(M){return!(M>=300&&M<500&&M!=429||M==501||M==505)}function Wa(M){var V=0,Y=Nn*Ei,ie=Nn*Ui,ye=Math.floor(Math.random()*(ie-Y))+Y;return V=Math.pow(2,M)*ye,Math.min(V,Pn)}var _r,bo=20,Qo=3984588,Oo=65e3,ec=2e6,dl=Math.min(ec,Oo),Jp="metadata",Ay="f",V_=/\./,Ju=function(){function M(V,Y,ie,ye,_e,Ue){var et="data",nt="baseData",lt="ext",Ct=!!ye,zt=!0,li=Y,ii={},wi=!!Ue,oi=_e||EF;Ia(M,this,function(Gt){function ui(In,Kt){var ki=ii[In];return ki===void 0&&(In.length>=7&&(ki=Td(In,"ext.metadata")||Td(In,"ext.web")),ii[In]=ki),ki}function $i(In,Kt,ki,sa,$a,Mr,mn){sl(In,function(Ir,fn){var Xn=null;if(fn||bh(fn)){var mi=ki,wn=Ir,wa=$a,lr=Kt;if(Ct&&!sa&&V_.test(Ir)){var ka=Ir.split("."),Ba=ka.length;if(Ba>1){wa&&(wa=wa.slice());for(var Qr=0;Qr<Ba-1;Qr++){var la=ka[Qr];lr=lr[la]=lr[la]||{},mi+="."+la,wa&&wa.push(la)}wn=ka[Ba-1]}}if(Xn=!(sa&&ui(mi))&&li&&li.handleField(mi,wn)?li.value(mi,wn,fn,ie):N0(wn,fn,ie)){var mr=Xn.value;if(lr[wn]=mr,Mr&&Mr(wa,wn,Xn),typeof mr=="object"&&!jo(mr)){var sc=wa;sc&&(sc=sc.slice()).push(wn),$i(fn,mr,mi+"."+wn,sa,sc,Mr)}}}})}Gt.createPayload=function(In,Kt,ki,sa,$a,Mr){return{apiKeys:[],payloadBlob:B0,overflow:null,sizeExceed:[],failedEvts:[],batches:[],numEvents:0,retryCnt:In,isTeardown:Kt,isSync:ki,isBeacon:sa,sendType:Mr,sendReason:$a}},Gt.appendPayload=function(In,Kt,ki){var sa=In&&Kt&&!In.overflow;return sa&&lu(V,function(){return"Serializer:appendPayload"},function(){for(var $a=Kt.events(),Mr=In.payloadBlob,mn=In.numEvents,Ir=!1,fn=[],Xn=[],mi=In.isBeacon,wn=mi?Oo:Qo,wa=mi?dl:ec,lr=0,ka=0;lr<$a.length;){var Ba=$a[lr];if(Ba){if(mn>=ki){In.overflow=Kt.split(lr);break}var Qr=Gt.getEventBlob(Ba);if(Qr&&Qr.length<=wa){var la=Qr.length;if(Mr.length+la>wn){In.overflow=Kt.split(lr);break}Mr&&(Mr+=`
`),Mr+=Qr,++ka>bo&&(_s(Mr,0,1),ka=0),Ir=!0,mn++}else Qr?fn.push(Ba):Xn.push(Ba),$a.splice(lr,1),lr--}lr++}if(fn.length>0&&In.sizeExceed.push($e.create(Kt.iKey(),fn)),Xn.length>0&&In.failedEvts.push($e.create(Kt.iKey(),Xn)),Ir){In.batches.push(Kt),In.payloadBlob=Mr,In.numEvents=mn;var mr=Kt.iKey();om(In.apiKeys,mr)===-1&&In.apiKeys.push(mr)}},function(){return{payload:In,theBatch:{iKey:Kt.iKey(),evts:Kt.events()},max:ki}}),sa},Gt.getEventBlob=function(In){try{return lu(V,function(){return"Serializer.getEventBlob"},function(){var Kt={};Kt.name=In.name,Kt.time=In.time,Kt.ver=In.ver,Kt.iKey="o:"+ZP(In.iKey);var ki,sa={};wi||(ki=function(Ir,fn,Xn){hf(oi,sa,Ir,fn,Xn)});var $a=In[lt];$a&&(Kt[lt]=sa,sl($a,function(Ir,fn){$i(fn,sa[Ir]={},"ext."+Ir,!0,null,null,!0)}));var Mr=Kt[et]={};Mr.baseType=In.baseType;var mn=Mr[nt]={};return $i(In.baseData,mn,nt,!1,[nt],ki,zt),$i(In.data,Mr,et,!1,[],ki,zt),JSON.stringify(Kt)},function(){return{item:In}})}catch{return null}}})}return M.__ieDyn=1,M}();function hf(M,V,Y,ie,ye){if(ye&&V){var _e=M(ye.value,ye.kind,ye.propertyType);if(_e>-1){var Ue=V[Jp];Ue||(Ue=V[Jp]={f:{}});var et=Ue[Ay];if(et||(et=Ue[Ay]={}),Y)for(var nt=0;nt<Y.length;nt++){var lt=Y[nt];et[lt]||(et[lt]={f:{}});var Ct=et[lt][Ay];Ct||(Ct=et[lt][Ay]={}),et=Ct}et=et[ie]={},jo(ye.value)?et.a={t:_e}:et.t=_e}}}function Yp(M,V){return{set:function(Y,ie){for(var ye=[],_e=2;_e<arguments.length;_e++)ye[_e-2]=arguments[_e];return av([M,V],Y,ie,ye)}}}var $F="sendAttempt",Cz="&"+u7+"=true",JI="?cors=true&"+VI[PF]()+"="+v1,IR=((_r={})[1]=sz,_r[100]=sz,_r[200]="sent",_r[8004]=AF,_r[8003]=AF,_r),bm={},Tm={};function YI(M,V,Y){bm[M]=V,Y!==!1&&(Tm[V]=M)}function Tv(M,V){var Y=!1;if(M&&V){var ie=Os(M);if(ie&&ie[$s]>0)for(var ye=V[PF](),_e=0;_e<ie[$s];_e++){var Ue=ie[_e];if(Ue&&Xh(V,Ue)&&Ue[PF]()===ye){Y=!0;break}}}return Y}function PS(M,V,Y,ie){V&&Y&&Y[$s]>0&&(ie&&bm[V]?(M[ER][bm[V]]=Y,M[aD]=!0):M.url+="&"+V+"="+Y)}function F0(M,V,Y){for(var ie=0;ie<M[$s];ie++)if(M[ie].name===V)return void(M[ie].value=Y);M[df]({name:V,value:Y})}function T7(M,V){for(var Y=0;Y<M[$s];Y++)if(M[Y].name===V)return void M[T1](Y,1)}YI(S1,S1,!1),YI($I,$I),YI(yR,"Client-Id"),YI(MF,MF),YI(RF,RF),YI(y1,y1),YI(lz,lz);var L1=function(){function M(V,Y,ie,ye){var _e,Ue,et,nt,lt,Ct,zt,li,ii,wi,oi,Gt,ui,$i,In,Kt,ki,sa,$a,Mr,mn,Ir,fn,Xn,mi,wn,wa,lr,ka,Ba,Qr,la=!1;Ia(M,this,function(mr){Ad();var sc=!0;function Rs(Ni,ta){try{return Qr&&Qr.getSenderInst(Ni,ta)}catch{}return null}function Vd(){try{return{enableSendPromise:!1,isOneDs:!0,disableCredentials:!sc,disableXhr:!1,disableBeacon:!la,disableBeaconSync:!la,disableFetchKeepAlive:mn,timeWrapper:ka,addNoResponse:fn,senderOnCompleteCallBack:{xdrOnComplete:xr,fetchOnComplete:OS,xhrOnComplete:Ch,beaconOnRetry:Ha}}}catch{}return null}function xr(Ni,ta,Ta){var Er=py(Ni);Sn(ta,200,{},Er),cp(Er)}function Ad(){var Ni;_e=null,Ue=new si,et=!1,nt=new ut,la=!1,lt=0,Ct=null,zt=null,li=null,ii=null,wi=!0,oi=[],Gt={},ui=[],$i=null,In=!1,Kt=null,ki=!1,sa=!1,$a=Ni,Mr=Ni,mn=Ni,Ir=Ni,fn=Ni,Xn=[],mi=Ni,wn=Ni,wa=[],lr=!1,ka=Yp(),Ba=!1,Qr=null}function OS(Ni,ta,Ta,Er){var Ro=function(ms,zi,hn){Sn(ta,ms,zi,hn),cp(hn)},Ms={},Dr=Ni[ZT];Dr&&Dr.forEach(function(ms,zi){Ms[zi]=ms}),Ro(Ni.status,Ms,Ta||B0)}function Ch(Ni,ta,Ta){var Er=py(Ni);Sn(ta,Ni.status,VT(Ni,!0),Er),cp(Er)}function Sn(Ni,ta,Ta,Er){try{Ni(ta,Ta,Er)}catch(Ro){cl(zt,2,518,zs(Ro))}}function Ha(Ni,ta,Ta){var Er=200,Ro=Ni[GI],Ms=Ni[fz]+(fn?Cz:B0);try{var Dr=Yv();if(Ro){var ms=!!ii.getPlugin("LocalStorage"),zi=[],hn=[];Va(Ro[bv],function(Un){if(zi&&Un&&Un[Kp]()>0)for(var Fa=Un[jI](),rr=0;rr<Fa[$s];rr++){if(!Dr.sendBeacon(Ms,$i.getEventBlob(Fa[rr]))){zi[df](Un[_R](rr));break}hn[df](Un[rr])}else zi[df](Un[_R](0))}),hn[$s]>0&&(Ro.sentEvts=hn),ms||vf(zi,8003,Ro[Ey],!0)}else Er=0}catch(Un){Mb(zt,"Failed to send telemetry using sendBeacon API. Ex:"+zs(Un)),Er=0}finally{Sn(ta,Er,{},B0)}}function cr(Ni){return Ni===2||Ni===3}function ba(Ni){return ki&&cr(Ni)&&(Ni=2),Ni}function Pr(){return!et&&lt<Y}function No(){var Ni=ui;return ui=[],Ni}function Eo(Ni,ta,Ta){var Er=!1;return Ni&&Ni[$s]>0&&!et&&li[ta]&&$i&&(Er=ta!==0||Pr()&&(Ta>0||nt[bR]())),Er}function Cl(Ni){var ta={};return Ni&&Va(Ni,function(Ta,Er){ta[Er]={iKey:Ta[QT](),evts:Ta[jI]()}}),ta}function sd(Ni,ta,Ta,Er,Ro){if(Ni&&Ni[$s]!==0)if(et)vf(Ni,1,Er);else{Er=ba(Er);try{var Ms=Ni,Dr=Er!==0;lu(ii,function(){return"HttpManager:_sendBatches"},function(ms){ms&&(Ni=Ni.slice(0));for(var zi=[],hn=null,Un=MS(),Fa=li[Er]||(Dr?li[1]:li[0]),rr=Fa&&Fa[WI],ro=Ir&&(ki||cr(Er)||rr===3||Fa._isSync&&rr===2);Eo(Ni,Er,ta);){var hi=Ni.shift();hi&&hi[Kp]()>0&&(Ue.isTenantKilled(hi[QT]())?zi[df](hi):(hn=hn||$i[sD](ta,Ta,Dr,ro,Ro,Er),$i.appendPayload(hn,hi,V)?hn.overflow!==null&&(Ni=[hn.overflow][HI](Ni),hn.overflow=null,W_(hn,Un,MS(),Ro),Un=MS(),hn=null):(W_(hn,Un,MS(),Ro),Un=MS(),Ni=[hi][HI](Ni),hn=null)))}hn&&W_(hn,Un,MS(),Ro),Ni[$s]>0&&(ui=Ni[HI](ui)),vf(zi,8004,Er)},function(){return{batches:Cl(Ms),retryCount:ta,isTeardown:Ta,isSynchronous:Dr,sendReason:Ro,useSendBeacon:cr(Er),sendType:Er}},!Dr)}catch(ms){cl(zt,2,48,"Unexpected Exception sending batch: "+zs(ms))}}}function xh(Ni,ta){var Ta={url:_e,hdrs:{},useHdrs:!1};ta?(Ta[ER]=FI(Ta[ER],Gt),Ta.useHdrs=Os(Ta.hdrs)[$s]>0):sl(Gt,function(ms,zi){Tm[ms]?PS(Ta,Tm[ms],zi,!1):(Ta[ER][ms]=zi,Ta[aD]=!0)}),PS(Ta,yR,"NO_AUTH",ta),PS(Ta,$I,gR,ta);var Er=B0;Va(Ni.apiKeys,function(ms){Er[$s]>0&&(Er+=","),Er+=ms}),PS(Ta,MF,Er,ta),PS(Ta,y1,gn().toString(),ta);var Ro=nC(Ni);if(bh(Ro)&&(Ta.url+="&ext.intweb.msfpc="+Ro),nt[CR]()&&PS(Ta,RF,nt[cz](),ta),ii[w1]){var Ms=ii[w1]();Ms>=0&&(Ta.url+="&w="+Ms)}for(var Dr=0;Dr<oi[$s];Dr++)Ta.url+="&"+oi[Dr].name+"="+oi[Dr].value;return Ta}function Cm(Ni,ta,Ta){Ni[ta]=Ni[ta]||{},Ni[ta][Ct.identifier]=Ta}function W_(Ni,ta,Ta,Er){if(Ni&&Ni.payloadBlob&&Ni.payloadBlob[$s]>0){var Ro=!!mi,Ms=li[Ni.sendType];!cr(Ni[Ey])&&Ni[vz]&&Ni.sendReason===2&&(Ms=li[2]||li[3]||Ms);var Dr=sa;(Ni.isBeacon||Ms[WI]===3)&&(Dr=!1);var ms=xh(Ni,Dr);Dr=Dr||ms[aD];var zi=MS();lu(ii,function(){return"HttpManager:_doPayloadSend"},function(){for(var hn=0;hn<Ni.batches[$s];hn++)for(var Un=Ni[bv][hn][jI](),Fa=0;Fa<Un[$s];Fa++){var rr=Un[Fa];if(In){var ro=rr[k1]=rr[k1]||{};Cm(ro,"sendEventStart",zi),Cm(ro,"serializationStart",ta),Cm(ro,"serializationCompleted",Ta)}rr[$F]>0?rr[$F]++:rr[$F]=1}vf(Ni[bv],1e3+(Er||0),Ni[Ey],!0);var hi={data:Ni[E1],urlString:ms.url,headers:ms[ER],_thePayload:Ni,_sendReason:Er,timeout:$a,disableXhrSync:Mr,disableFetchKeepAlive:mn};Dr&&(Tv(hi[ZT],fR)||(hi[ZT][fR]=IF),Tv(hi[ZT],VI)||(hi[ZT][VI]=v1));var _h=null;Ms&&(_h=function(dp){nt[TR]();var yf=function(xb,_v){Zp(xb,_v,Ni,Er)},Lg=Ni[FF]||Ni[UF];try{Ms.sendPOST(dp,yf,Lg),wn&&wn(hi,dp,Lg,Ni[vz])}catch(xb){Mb(zt,"Unexpected exception sending payload. Ex:"+zs(xb)),Sn(yf,0,{})}}),lu(ii,function(){return"HttpManager:_doPayloadSend.sender"},function(){if(_h)if(Ni[Ey]===0&&lt++,Ro&&!Ni.isBeacon&&Ms[WI]!==3){var dp={data:hi[R1],urlString:hi[fz],headers:FI({},hi[ZT]),timeout:hi[f7],disableXhrSync:hi[hz],disableFetchKeepAlive:hi[oD]},yf=!1;lu(ii,function(){return"HttpManager:_doPayloadSend.sendHook"},function(){try{mi(dp,function(Lg){yf=!0,wi||Lg[GI]||(Lg[GI]=Lg[GI]||hi[GI],Lg[M1]=Lg[M1]||hi[M1]),_h(Lg)},Ni.isSync||Ni[FF])}catch{yf||_h(hi)}})}else _h(hi)})},function(){return{thePayload:Ni,serializationStart:ta,serializationCompleted:Ta,sendReason:Er}},Ni[UF])}Ni.sizeExceed&&Ni.sizeExceed[$s]>0&&vf(Ni.sizeExceed,8003,Ni[Ey]),Ni.failedEvts&&Ni.failedEvts[$s]>0&&vf(Ni.failedEvts,8002,Ni[Ey])}function NS(Ni,ta){In&&Va(Ni,function(Ta){Cm(Ta[k1]=Ta[k1]||{},"sendEventCompleted",ta)})}function Zp(Ni,ta,Ta,Er){var Ro=9e3,Ms=null,Dr=!1,ms=!1;try{var zi=!0;if(typeof Ni!==Rr){if(ta){nt[nD](ta[vR]);var hn=ta[kF]||ta["kill-duration-seconds"];Va(Ue[yz](ta[wF],hn),function(Fa){Va(Ta[bv],function(rr){if(rr[QT]()===Fa){Ms=Ms||[];var ro=rr[_R](0);Ta.numEvents-=ro[Kp](),Ms[df](ro)}})})}if(Ni==200||Ni==204)return void(Ro=200);(!Yn(Ni)||Ta.numEvents<=0)&&(zi=!1),Ro=9e3+Ni%1e3}if(zi){Ro=100;var Un=Ta.retryCnt;Ta[Ey]===0&&(Un<ie?(Dr=!0,Em(function(){Ta[Ey]===0&&lt--,sd(Ta[bv],Un+1,Ta[FF],ki?2:Ta[Ey],5)},ki,Wa(Un))):(ms=!0,ki&&(Ro=8001)))}}finally{Dr||(nt[nD](),iC(Ta,Ro,Er,ms)),vf(Ms,8004,Ta[Ey])}}function iC(Ni,ta,Ta,Er){try{Er&&Ct[Sz]();var Ro=Ni[bv];ta===200&&(Ro=Ni.sentEvts||Ni[bv],Er||Ni[UF]||Ct._clearBackOff(),_m(Ro)),vf(Ro,ta,Ni[Ey],!0)}finally{Ni[Ey]===0&&(lt--,Ta!==5&&mr.sendQueuedRequests(Ni[Ey],Ta))}}function _m(Ni){if(In){var ta=MS();Va(Ni,function(Ta){Ta&&Ta[Kp]()>0&&NS(Ta[jI](),ta)})}}function Em(Ni,ta,Ta){ta?Ni():ka.set(Ni,Ta)}function nC(Ni){for(var ta=0;ta<Ni.batches[$s];ta++){var Ta=Ni[bv][ta].Msfpc();if(Ta)return encodeURIComponent(Ta)}return B0}function cp(Ni){var ta=wa;try{for(var Ta=0;Ta<ta[$s];Ta++)try{ta[Ta](Ni)}catch(Ro){cl(zt,1,519,"Response handler failed: "+Ro)}if(Ni){var Er=JSON.parse(Ni);bh(Er.webResult)&&bh(Er.webResult[tD])&&Kt.set("MSFPC",Er.webResult[tD],31536e3)}}catch{}}function vf(Ni,ta,Ta,Er){if(Ni&&Ni[$s]>0&&ye){var Ro=ye[aC(ta)];if(Ro){var Ms=Ta!==0;lu(ii,function(){return"HttpManager:_sendBatchesNotification"},function(){Em(function(){try{Ro.call(ye,Ni,ta,Ms,Ta)}catch(Dr){cl(zt,1,74,"send request notification failed: "+Dr)}},Er||Ms,0)},function(){return{batches:Cl(Ni),reason:ta,isSync:Ms,sendSync:Er,sendType:Ta}},!Ms)}}}function aC(Ni){var ta=IR[Ni];return bh(ta)||(ta=d7,Ni>=9e3&&Ni<=9999?ta=c7:Ni>=8e3&&Ni<=8999?ta=AF:Ni>=1e3&&Ni<=1999&&(ta=oz)),ta}mr[rD]=function(Ni,ta,Ta){lr||(ii=ta,Kt=ta.getCookieMgr(),zt=(Ct=Ta).diagLog(),oS(Xn,Bd(Ni,function(Er){var Ro,Ms=Er.cfg,Dr=Er.cfg.extensionConfig[Ta.identifier];ka=Yp(Dr[dz],Dr[C1]),bh(Ms.anonCookieName)?F0(oi,"anoncknm",Ms.anonCookieName):T7(oi,"anoncknm"),mi=Dr[h7],wn=Dr.payloadListener;var ms=Dr.httpXHROverride,zi=Dr[AR]?Dr[AR]:Ms.endpointUrl;_e=zi+JI,sa=!!bl(Dr[_1])||!Dr[_1],In=!Dr[uz];var hn=Dr.valueSanitizer,Un=Dr[p7],Fa=!!Ms[DF];bl(Dr[DF])||(Fa=!!Dr[DF]),$a=Dr.xhrTimeout,Mr=!!Dr[hz],mn=!!Dr[oD],fn=Dr[g7]!==!1,Ba=!!Dr[m7],ta.getPlugin("LocalStorage")&&(mn=!0),la=!b0(),$i=new Ju(ii,hn,Un,Fa,EF,Ba),rl(Dr[pz])||(la=!!Dr[pz]);var rr=Vd();Qr?Qr.SetConfig(rr):(Qr=new YT)[rD](rr,zt);var ro=ms,hi=Dr[uf]?ms:null,_h=Dr[uf]?ms:null,dp=[3,2];if(!ms){wi=!1;var yf=[];b0()?(yf=[2,1],dp=[2,1,3]):yf=[1,2,3],(ms=Rs(yf=Ag(yf,Dr.transports),!1))||Mb(zt,"No available transport to send events"),ro=Rs(yf,!0)}hi||(hi=Rs(dp=Ag(dp,Dr[LF]),!0)),Ir=!wi&&(la&&Yr()||!mn&&bS(!0)),(Ro={})[0]=ms,Ro[1]=ro||Rs([1,2,3],!0),Ro[2]=hi||ro||Rs([1],!0),Ro[3]=_h||Rs([2,3],!0)||ro||Rs([1],!0),li=Ro})),lr=!0)},mr.addResponseHandler=function(Ni){return wa[df](Ni),{rm:function(){var ta=wa.indexOf(Ni);ta>=0&&wa[T1](ta,1)}}},mr[gz]=function(Ni){try{if($i)return $i.getEventBlob(Ni)}catch{}return B0},mr[mz]=function(){try{return xh($i&&$i[sD](0,!1,!1,!1,1,0),sa)}catch{}return null},mr[OF]=function(Ni,ta){try{var Ta=[];Va(Ni,function(ms){ta&&(ms=UT(ms));var zi=$e.create(ms[QT],[ms]);Ta[df](zi)});for(var Er=null;Ta[$s]>0&&$i;){var Ro=Ta.shift();Ro&&Ro[Kp]()>0&&(Er=Er||$i[sD](0,!1,!1,!1,1,0),$i.appendPayload(Er,Ro,V))}var Ms=xh(Er,sa),Dr={data:Er[E1],urlString:Ms.url,headers:Ms[ER],timeout:$a,disableXhrSync:Mr,disableFetchKeepAlive:mn};return sa&&(Tv(Dr[ZT],fR)||(Dr[ZT][fR]=IF),Tv(Dr[ZT],VI)||(Dr[ZT][VI]=v1)),Dr}catch{}return null},mr._getDbgPlgTargets=function(){return[li[0],Ue,$i,li]},mr[NF]=function(Ni,ta){Gt[Ni]=ta},mr.removeHeader=function(Ni){delete Gt[Ni]},mr[A1]=function(){return Pr()&&nt[bR]()},mr[lD]=function(Ni,ta){bl(Ni)&&(Ni=0),ki&&(Ni=ba(Ni),ta=2),Eo(ui,Ni,0)&&sd(No(),0,!1,Ni,ta||0)},mr[I1]=function(){return!et&&lt===0&&ui[$s]===0},mr[xF]=function(Ni){ki=Ni},mr.addBatch=function(Ni){if(Ni&&Ni[Kp]()>0){if(Ue.isTenantKilled(Ni[QT]()))return!1;ui[df](Ni)}return!0},mr.teardown=function(){ui[$s]>0&&sd(No(),0,!0,2,2),Va(Xn,function(Ni){Ni&&Ni.rm&&Ni.rm()}),Xn=[]},mr.pause=function(){et=!0},mr.resume=function(){et=!1,mr[lD](0,4)},mr[qI]=function(Ni,ta,Ta){Ni&&Ni[Kp]()>0&&(rl(ta)&&(ta=1),ki&&(ta=ba(ta),Ta=2),sd([Ni],0,!1,ta,Ta||0))}})}return M.__ieDyn=1,M}(),VX=.25,cD=500,_z=20,$_=6,HF=2,C7=4,_7=2,$X=1,O1=1e4,wR="eventsDiscarded",HX="",du=void 0,Ez=dh({eventsLimitInMem:{isVal:eD,v:O1},immediateEventLimit:{isVal:eD,v:500},autoFlushEventsLimit:{isVal:eD,v:0},disableAutoBatchFlushLimit:!1,httpXHROverride:{isVal:QI,v:du},overrideInstrumentationKey:du,overrideEndpointUrl:du,disableTelemetry:!1,ignoreMc1Ms0CookieProcessing:!1,setTimeoutOverride:du,clearTimeoutOverride:du,payloadPreprocessor:du,payloadListener:du,disableEventTimings:du,valueSanitizer:du,stringifyObjects:du,enableCompoundKey:du,disableOptimizeObj:!1,transports:du,unloadTransports:du,useSendBeacon:du,disableFetchKeepAlive:du,avoidOptions:!1,xhrTimeout:du,disableXhrSync:du,alwaysUseXhrOverride:!1,maxEventRetryAttempts:{isVal:Zh,v:$_},maxUnloadEventRetryAttempts:{isVal:Zh,v:HF},addNoResponse:du,excludeCsMetaData:du});function QI(M){return M&&M.sendPOST}var dD,E7=function(M){function V(){var Y,ie=M.call(this)||this;ie.identifier="PostChannel",ie.priority=1011,ie.version="4.2.1";var ye,_e,Ue,et,nt,lt,Ct,zt,li,ii,wi,oi,Gt,ui,$i,In,Kt,ki,sa,$a,Mr,mn,Ir,fn,Xn,mi=!1,wn=[],wa=!1,lr=0,ka=0,Ba={},Qr=zI;return Ia(V,ie,function(la,mr){function sc(){tz(null,ki),cf(null,ki),a7(null,ki)}function Rs(zi){var hn=zi[w1];zi[w1]=function(){var Un=0;return $a&&(Un|=2),Un|hn.call(zi)}}function Vd(zi){var hn=HX;return zi&&zi[$s]&&Va(zi,function(Un){hn&&(hn+=`
`),hn+=Un}),hn}function xr(zi){var hn=HX;try{Ch(zi),hn=zt[gz](zi)}catch{}return hn}function Ad(zi){(zi||ev().event).type!=="beforeunload"&&($i=!0,zt[xF]($i)),Cl(2,2)}function OS(zi){$i=!1,zt[xF]($i)}function Ch(zi){zi.ext&&zi.ext[iD]&&delete zi.ext[iD],zi.ext&&zi.ext[SR]&&zi.ext[SR].id&&delete zi.ext[SR].id,ui&&(zi.ext=UT(zi.ext),zi[VF]&&(zi[VF]=UT(zi[VF])),zi[R1]&&(zi[R1]=UT(zi[R1])))}function Sn(zi,hn){if(zi[D1]||(zi[D1]=0),zi[KI]||(zi[KI]=1),Ch(zi),zi[O]){if(lt||wa)zi[KI]=3,zi[O]=!1;else if(zt)return ui&&(zi=UT(zi)),void zt[qI]($e.create(zi[QT],[zi]),zi[O]===!0?1:zi[O],3)}var Un=zi[KI],Fa=ka,rr=Ue;Un===4&&(Fa=lr,rr=_e);var ro=!1;if(Fa<rr)ro=!W_(zi,hn);else{var hi=1,_h=_z;Un===4&&(hi=4,_h=1),ro=!0,NS(zi[QT],zi[KI],hi,_h)&&(ro=!W_(zi,hn))}ro&&Ni(wR,[zi],Mh.QueueFull)}function Ha(zi,hn,Un){var Fa=iC(zi,hn,Un);return zt[lD](hn,Un),Fa}function cr(){return ka>0}function ba(){if(oi>=0&&iC(oi,0,Gt)&&zt[lD](0,Gt),lr>0&&!nt&&!wa){var zi=Ba[Qr][2];zi>=0&&(nt=No(function(){nt=null,Ha(4,0,1),ba()},zi))}var hn=Ba[Qr][1];!et&&!ye&&hn>=0&&!wa&&(cr()?et=No(function(){et=null,Ha(Ct===0?3:1,0,1),Ct++,Ct%=2,ba()},hn):Ct=0)}function Pr(){Y=null,mi=!1,wn=[],ye=null,wa=!1,lr=0,_e=500,ka=0,Ue=O1,Ba={},Qr=zI,et=null,nt=null,lt=0,Ct=0,li={},ii=0,Ir=!1,wi=0,oi=-1,Gt=null,ui=!0,$i=!1,In=$_,Kt=HF,ki=null,fn=null,Xn=!1,sa=Yp(),zt=new L1(cD,_7,$X,{requeue:vf,send:Ta,sent:Er,drop:Ro,rspFail:Ms,oth:Dr}),cp(),sd(),ms()}function No(zi,hn){hn===0&&lt&&(hn=1);var Un=1e3;return lt&&(Un=Wa(lt-1)),sa.set(zi,hn*Un)}function Eo(){return et!==null&&(et.cancel(),et=null,Ct=0,!0)}function Cl(zi,hn){Eo(),ye&&(ye.cancel(),ye=null),wa||Ha(1,zi,hn)}function sd(){li[4]={batches:[],iKeyMap:{}},li[3]={batches:[],iKeyMap:{}},li[2]={batches:[],iKeyMap:{}},li[1]={batches:[],iKeyMap:{}}}function xh(zi,hn,Un){var Fa=li[hn];Fa||(Fa=li[hn=1]);var rr=Fa.iKeyMap[zi];return!rr&&Un&&(rr=$e.create(zi),Fa.batches[df](rr),Fa.iKeyMap[zi]=rr),rr}function Cm(zi,hn){zt[A1]()&&!lt&&(ii>0&&ka>ii&&(hn=!0),hn&&ye==null&&la.flush(zi,function(){},20))}function W_(zi,hn){ui&&(zi=UT(zi));var Un=zi[KI],Fa=xh(zi[QT],Un,!0);return!!Fa.addEvent(zi)&&(Un!==4?(ka++,hn&&zi[D1]===0&&Cm(!zi.sync,wi>0&&Fa[Kp]()>=wi)):lr++,!0)}function NS(zi,hn,Un,Fa){for(;Un<=hn;){var rr=xh(zi,hn,!0);if(rr&&rr[Kp]()>0){var ro=rr[_R](0,Fa),hi=ro[Kp]();if(hi>0)return Un===4?lr-=hi:ka-=hi,ta(wR,[ro],Mh.QueueFull),!0}Un++}return Zp(),!1}function Zp(){for(var zi=0,hn=0,Un=function(rr){var ro=li[rr];ro&&ro[bv]&&Va(ro[bv],function(hi){rr===4?zi+=hi[Kp]():hn+=hi[Kp]()})},Fa=1;Fa<=4;Fa++)Un(Fa);ka=hn,lr=zi}function iC(zi,hn,Un){var Fa=!1,rr=hn===0;return!rr||zt[A1]()?lu(la.core,function(){return"PostChannel._queueBatches"},function(){for(var ro=[],hi=4;hi>=zi;){var _h=li[hi];_h&&_h.batches&&_h.batches[$s]>0&&(Va(_h[bv],function(dp){zt.addBatch(dp)?Fa=Fa||dp&&dp[Kp]()>0:ro=ro[HI](dp[jI]()),hi===4?lr-=dp[Kp]():ka-=dp[Kp]()}),_h[bv]=[],_h.iKeyMap={}),hi--}ro[$s]>0&&Ni(wR,ro,Mh.KillSwitch),Fa&&oi>=zi&&(oi=-1,Gt=0)},function(){return{latency:zi,sendType:hn,sendReason:Un}},!rr):(oi=oi>=0?Math.min(oi,zi):zi,Gt=Math.max(Gt,Un)),Fa}function _m(zi,hn){Ha(1,0,hn),Zp(),Em(function(){zi&&zi(),wn[$s]>0?ye=No(function(){ye=null,_m(wn.shift(),hn)},0):(ye=null,ba())})}function Em(zi){zt[I1]()?zi():ye=No(function(){ye=null,Em(zi)},VX)}function nC(){Eo(),cp(),Qr=zI,ba()}function cp(){(Ba={})[zI]=[2,1,0],Ba[rz]=[6,3,0],Ba[l7]=[18,9,0]}function vf(zi,hn){var Un=[],Fa=In;$i&&(Fa=Kt),Va(zi,function(rr){rr&&rr[Kp]()>0&&Va(rr[jI](),function(ro){ro&&(ro[O]&&(ro[KI]=4,ro[O]=!1),ro[D1]<Fa?(UI(ro,la[P1]),Sn(ro,!1)):Un[df](ro))})}),Un[$s]>0&&Ni(wR,Un,Mh.NonRetryableStatus),$i&&Cl(2,2)}function aC(zi,hn){var Un=mn||{},Fa=Un[zi];if(Fa)try{Fa.apply(Un,hn)}catch(rr){cl(la.diagLog(),1,74,zi+" notification failed: "+rr)}}function Ni(zi,hn){for(var Un=[],Fa=2;Fa<arguments.length;Fa++)Un[Fa-2]=arguments[Fa];hn&&hn[$s]>0&&aC(zi,[hn][HI](Un))}function ta(zi,hn){for(var Un=[],Fa=2;Fa<arguments.length;Fa++)Un[Fa-2]=arguments[Fa];hn&&hn[$s]>0&&Va(hn,function(rr){rr&&rr[Kp]()>0&&aC(zi,[rr.events()][HI](Un))})}function Ta(zi,hn,Un){zi&&zi[$s]>0&&aC("eventsSendRequest",[hn>=1e3&&hn<=1999?hn-1e3:0,Un!==!0])}function Er(zi,hn){ta("eventsSent",zi,hn),ba()}function Ro(zi,hn){ta(wR,zi,hn>=8e3&&hn<=8999?hn-8e3:Mh.Unknown)}function Ms(zi){ta(wR,zi,Mh.NonRetryableStatus),ba()}function Dr(zi,hn){ta(wR,zi,Mh.Unknown),ba()}function ms(){wi=Mr?0:Math.max(cD*(_7+1),Ue/6)}Pr(),la._getDbgPlgTargets=function(){return[zt,Y]},la[rD]=function(zi,hn,Un){lu(hn,function(){return"PostChannel:initialize"},function(){mr[rD](zi,hn,Un),mn=hn.getNotifyMgr();try{ki=hR(w_(la[P1]),hn.evtNamespace&&hn.evtNamespace()),la._addHook(Bd(zi,function(Fa){var rr=Fa.cfg,ro=by(null,rr,hn);Y=ro.getExtCfg(la[P1],Ez),sa=Yp(Y[dz],Y[C1]),ui=!Y[v7]&&nz(),$a=Y[y7],Rs(hn),Ue=Y[bz],_e=Y.immediateEventLimit,ii=Y[Tz],In=Y.maxEventRetryAttempts,Kt=Y.maxUnloadEventRetryAttempts,Mr=Y[zF],ms(),fn=Y[S7],Xn=!!Y[b7],Ir&&sc();var hi=rr.disablePageUnloadEvents||[];Ir=n7(Ad,hi,ki),Ir=U_(Ad,hi,ki)||Ir,Ir=L0(OS,rr.disablePageShowEvents,ki)||Ir})),zt[rD](zi,la.core,la)}catch(Fa){throw la.setInitialized(!1),Fa}},function(){return{theConfig:zi,core:hn,extensions:Un}})},la.processTelemetry=function(zi,hn){UI(zi,la[P1]),hn=hn||la._getTelCtx(hn);var Un=zi;Xn||mi||(fn&&(Un[QT]=fn),Sn(Un,!0),$i?Cl(2,2):ba()),la.processNext(Un,hn)},la.getOfflineSupport=function(){try{var zi=zt&&zt[mz]();if(zt)return{getUrl:function(){return zi?zi.url:null},serialize:xr,batch:Vd,shouldProcess:function(hn){return!Xn},createPayload:function(hn){return null},createOneDSPayload:function(hn){if(zt[OF])return zt[OF](hn,ui)}}}catch{}return null},la._doTeardown=function(zi,hn){Cl(2,2),mi=!0,zt.teardown(),sc(),Pr()},la.setEventQueueLimits=function(zi,hn){Y[bz]=Ue=eD(zi)?zi:O1,Y[Tz]=ii=eD(hn)?hn:0,ms();var Un=ka>zi;if(!Un&&wi>0)for(var Fa=1;!Un&&Fa<=3;Fa++){var rr=li[Fa];rr&&rr[bv]&&Va(rr[bv],function(ro){ro&&ro[Kp]()>=wi&&(Un=!0)})}Cm(!0,Un)},la.pause=function(){Eo(),wa=!0,zt.pause()},la.resume=function(){wa=!1,zt.resume(),ba()},la._loadTransmitProfiles=function(zi){nC(),sl(zi,function(hn,Un){var Fa=Un[$s];if(Fa>=2){var rr=Fa>2?Un[2]:0;if(Un[T1](0,Fa-2),Un[1]<0&&(Un[0]=-1),Un[1]>0&&Un[0]>0){var ro=Un[0]/Un[1];Un[0]=Math.ceil(ro)*Un[1]}rr>=0&&Un[1]>=0&&rr>Un[1]&&(rr=Un[1]),Un[df](rr),Ba[hn]=Un}})},la.flush=function(zi,hn,Un){var Fa;if(zi===void 0&&(zi=!0),!wa)if(Un=Un||1,zi)hn||(Fa=Zl(function(ro){hn=ro})),ye==null?(Eo(),iC(1,0,Un),ye=No(function(){ye=null,_m(hn,Un)},0)):wn[df](hn);else{var rr=Eo();Ha(1,1,Un),hn&&hn(),rr&&ba()}return Fa},la.setMsaAuthTicket=function(zi){zt[NF](S1,zi)},la.setAuthPluginHeader=function(zi){zt[NF](b1,zi)},la.removeAuthPluginHeader=function(){zt.removeHeader(b1)},la.hasEvents=cr,la._setTransmitProfile=function(zi){Qr!==zi&&Ba[zi]!==void 0&&(Eo(),Qr=zi,ba())},hm(la,function(){return zt},["addResponseHandler"]),la[Sz]=function(){lt<C7&&(lt++,Eo(),ba())},la._clearBackOff=function(){lt&&(lt=0,Eo(),ba())}}),ie}return _u(V,M),V.__ieDyn=1,V}(Ce),A7="locale",I7="ver",jX="browser",kR="browserVer",N1="popSample",x1="eventFlags",B1="name",Az="serviceName",Nc=Kr({UserExt:[0,"user"],DeviceExt:[1,"device"],TraceExt:[2,"trace"],WebExt:[3,"web"],AppExt:[4,"app"],OSExt:[5,"os"],SdkExt:[6,"sdk"],IntWebExt:[7,"intweb"],UtcExt:[8,"utc"],LocExt:[9,"loc"],CloudExt:[10,"cloud"],DtExt:[11,"dt"]}),Yu=Kr({id:[0,"id"],ver:[1,I7],appName:[2,B1],locale:[3,A7],expId:[4,"expId"],env:[5,"env"]}),pf=Kr({domain:[0,"domain"],browser:[1,jX],browserVer:[2,kR],screenRes:[3,"screenRes"],userConsent:[4,"userConsent"],consentDetails:[5,"consentDetails"]}),Iy=Kr({locale:[0,A7],localId:[1,"localId"],id:[2,"id"]}),Ob=Kr({osName:[0,B1],ver:[1,I7]}),Kfe=Kr({ver:[0,I7],seq:[1,"seq"],installId:[2,"installId"],epoch:[3,"epoch"]}),Jfe=Kr({msfpc:[0,"msfpc"],anid:[1,"anid"],serviceName:[2,Az]}),Yfe=Kr({popSample:[0,N1],eventFlags:[1,x1]}),ZI=Kr({tz:[0,"tz"]}),GX=Kr({sessionId:[0,"sesId"]}),H_=Kr({localId:[0,"localId"],deviceClass:[1,"deviceClass"],make:[2,"make"],model:[3,"model"]}),U0=Kr({role:[0,"role"],roleInstance:[1,"roleInstance"],roleVer:[2,"roleVer"]}),Qfe=Kr({traceId:[0,"traceID"],traceName:[1,B1],parentId:[2,"parentID"]}),w7=Kr({traceId:[0,"traceId"],spanId:[1,"spanId"],traceFlags:[2,"traceFlags"]});function qX(){return dD===void 0&&(dD=!!RR(0)),dD}function WX(){return qX()?RR(0):null}function RR(M){var V,Y,ie=null;try{var ye=_T();if(!ye)return null;Y=new Date,(ie=M===0?ye.localStorage:ye.sessionStorage)&&Xo(ie.setItem)&&(ie.setItem(Y,Y),V=ie.getItem(Y)!==Y,ie.removeItem(Y),V&&(ie=null))}catch{ie=null}return ie}function gf(M,V,Y){var ie=WX();if(ie!==null)try{return ie.setItem(V,Y),!0}catch(ye){dD=!1,cl(M,1,504,"Browser failed write to local storage. "+ye)}return!1}function XT(M,V){var Y=WX();if(Y!==null)try{return Y.getItem(V)}catch(ie){dD=!1,cl(M,1,503,"Browser failed read of local storage. "+ie)}return null}function j_(){return this.getId()}function uD(M){this.setId(M)}var XI=function(){function M(){Ia(M,this,function(V){V.setId=function(Y){V.customId=Y},V.getId=function(){return Ld(V.customId)?V.customId:V.automaticId}})}return M._staticInit=void yo(M.prototype,"id",{g:j_,s:uD}),M}(),KX="ai_session",JX=function(){function M(V,Y,ie){var ye,_e,Ue,et=ES(V),nt=HP(V);Ia(M,this,function(lt){var Ct=Bd(Y,function(){Ue=Y,lt.config=Ue});function zt(){var Gt=nt.get(_e());if(Gt&&Xo(Gt.split))li(Gt);else{var ui=XT(et,_e());ui&&li(ui)}lt.automaticSession.getId()||ii()}function li(Gt){var ui=lt.automaticSession,$i=Gt.split("|");$i.length>0&&ui.setId($i[0]);try{if($i.length>1){var In=+$i[1];ui.acquisitionDate=+new Date(In),ui.acquisitionDate=ui.acquisitionDate>0?ui.acquisitionDate:0}if($i.length>2){var Kt=+$i[2];ui.renewalDate=+new Date(Kt),ui.renewalDate=ui.renewalDate>0?ui.renewalDate:0}}catch(ki){cl(et,1,510,"Error parsing ai_session cookie, session will be reset: "+ki)}ui.renewalDate===0&&cl(et,2,517,"AI session renewal date is 0, session will be reset.")}function ii(){var Gt=lt.automaticSession,ui=new Date().getTime(),$i=lt.config.sessionAsGuid;!bl($i)&&$i?Kv($i)?Gt.setId(x0()):Gt.setId(x0($i)):Gt.setId(gm(Ue.idLength||22)),Gt.acquisitionDate=ui,Gt.renewalDate=ui,wi(Gt.getId(),Gt.acquisitionDate,Gt.renewalDate),qX()||cl(et,2,505,"Browser does not support local storage. Session durations will be inaccurate.")}function wi(Gt,ui,$i){var In=ui+lt.config.sessionExpirationMs,Kt=$i+lt.config.sessionRenewalMs,ki=new Date,sa=[Gt,ui,$i];In<Kt?ki.setTime(In):ki.setTime(Kt);var $a=lt.config.cookieDomain||null;nt.set(_e(),sa.join("|")+";expires="+ki.toUTCString(),null,$a),ye=new Date().getTime()}function oi(Gt,ui,$i){gf(et,_e(),[Gt,ui,$i].join("|"))}ie&&ie.add(Ct),_e=function(){return lt.config.namePrefix?KX+lt.config.namePrefix:KX},lt.automaticSession=new XI,lt.update=function(){lt.automaticSession.getId()||zt();var Gt=lt.automaticSession,ui=lt.config,$i=new Date().getTime(),In=$i-Gt.acquisitionDate>ui.sessionExpirationMs,Kt=$i-Gt.renewalDate>ui.sessionRenewalMs;In||Kt?ii():(!ye||$i-ye>M.cookieUpdateInterval)&&(Gt.renewalDate=$i,wi(Gt.getId(),Gt.acquisitionDate,Gt.renewalDate))},lt.backup=function(){var Gt=lt.automaticSession;oi(Gt.getId(),Gt.acquisitionDate,Gt.renewalDate)}})}return M.cookieUpdateInterval=6e4,M}(),k7=["AX","EX","SF","CS","CF","CT","CU","DC","DF","H5","HL","WS","WP"];function YX(M,V){V===void 0&&(V=k7);var Y=null;if(M)for(var ie=M.split(","),ye=0;ye<ie.length;ye++)Zfe(ie[ye],V)&&(Y?Y+=","+ie[ye]:Y=ie[ye]);return Y}function Zfe(M,V){if(V===void 0&&(V=k7),!M||M.length<4)return!1;for(var Y=!1,ie=256,ye=M.substring(0,3).toString().toUpperCase(),_e=0;_e<V.length;_e++)if(V[_e]+":"===ye&&M.length<=ie){Y=!0;break}return Y}function QX(){return this.getExpId()}var R7=function(){function M(V,Y,ie){var ye,_e=null,Ue=k7.slice(0),et="Treatments",nt=null;Ia(M,this,function(lt){if(oi(V),Nk()){var Ct=hh().documentElement;Ct&&(lt.locale=Ct.lang)}function zt(Gt){var ui,$i={},In=hh();if(In){ui=In&&In.querySelectorAll("meta");for(var Kt=0;Kt<ui.length;Kt++){var ki=ui[Kt];ki.name&&ki.name.toLowerCase().indexOf(Gt)===0&&($i[ki.name.replace(Gt,"")]=ki.content)}}return $i}function li(Gt){Gt!==_e&&(_e=YX(Gt,Ue))}function ii(){return li(_y(ye,et)),_e}function wi(Gt){return li(Gt),_e}function oi(Gt){var ui=Bd(Gt,function(){ye=Y&&Y.getCookieMgr(),nt=Gt||{},lt.env=nt.env||zt("awa-").env});ie&&ie.add(ui)}lt.getExpId=function(){return nt.expId?wi(nt.expId):ii()}})}return M.validateAppExpId=YX,M._staticInit=void yo(M.prototype,"expId",{g:QX}),M}(),M7=function(){function M(){}return M}(),ZX=function(){function M(){}return M}();function XX(){return this.getMsfpc()}function P7(){return this.getAnid()}var D7=function(){function M(Y,ie,ye){var _e;Ia(M,this,function(Ue){function et(nt){var lt=Bd(nt,function(){_e=ie&&ie.getCookieMgr();var Ct=nt||{};Ct.serviceName&&(Ue.serviceName=Ct.serviceName)});ye&&ye.add(lt)}et(Y),Ue.getMsfpc=function(){return _y(_e,"MSFPC")},Ue.getAnid=function(){return _y(_e,"ANON").slice(0,34)}})}var V;return M._staticInit=(yo(V=M.prototype,"msfpc",{g:XX}),void yo(V,"anid",{g:P7})),M}(),L7=function(){function M(){var V=new Date().getTimezoneOffset(),Y=V%60,ie=(V-Y)/60,ye="+";ie>0&&(ye="-"),ie=Math.abs(ie),Y=Math.abs(Y),this.tz=ye+(ie<10?"0"+ie:ie.toString())+":"+(Y<10?"0"+Y:Y.toString())}return M}(),MR={WIN:/(windows|win32)/i,WINRT:/ arm;/i,WINPHONE:/windows\sphone\s\d+\.\d+/i,OSX:/(macintosh|mac os x)/i,IOS:/(ipad|iphone|ipod)(?=.*like mac os x)/i,LINUX:/(linux|joli|[kxln]?ubuntu|debian|[open]*suse|gentoo|arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk)/i,ANDROID:/android/i,CROS:/CrOS/i},eee={5.1:"XP","6.0":"Vista",6.1:"7",6.2:"8",6.3:"8.1","10.0":"10"},Xfe="([\\d,.]+)",tee="([\\d,_,.]+)",hD="Unknown",jF=[{r:MR.WINPHONE,os:"Windows Phone"},{r:MR.WINRT,os:"Windows RT"},{r:MR.WIN,os:"Windows"},{r:MR.IOS,os:"iOS"},{r:MR.ANDROID,os:"Android"},{r:MR.LINUX,os:"Linux"},{r:MR.CROS,os:"Chrome OS"},{s:"x11",os:"Unix"},{s:"blackberry",os:"BlackBerry"},{s:"symbian",os:"Symbian"},{s:"nokia",os:"Nokia"},{r:MR.OSX,os:"Mac OS X"}];function eve(M){for(var V=0;V<jF.length;V++){var Y=jF[V];if(Y.r&&M.match(Y.r)||Y.s&&M.indexOf(Y.s)!==-1)return Y.os}return hD}function iee(M,V){return V==="Windows"?pD(M,"Windows NT"):V==="Android"?pD(M,V):V==="Mac OS X"?nee(M):V==="iOS"?mf(M):hD}function pD(M,V){var Y=M.match(new RegExp(V+" "+Xfe));return Y?eee[Y[1]]?eee[Y[1]]:Y[1]:hD}function nee(M){var V=M.match(new RegExp("Mac OS X "+tee));if(V){var Y=V[1].replace(/_/g,".");if(Y){var ie=Iz(Y);return ie?Y.split(ie)[0]:Y}}return hD}function mf(M){var V=M.match(new RegExp("OS "+tee));if(V){var Y=V[1].replace(/_/g,".");if(Y){var ie=Iz(Y);return ie?Y.split(ie)[0]:Y}}return hD}function Iz(M){return M.indexOf(".")>-1?".":M.indexOf("_")>-1?"_":null}var aee=function(){function M(V,Y){var ie=this,ye=null,_e=null,Ue=null,et=null,nt=function(ii){Ue=ii},lt=function(ii){et=ii},Ct=function(){return Ue||ye},zt=function(){return et||_e},li=Bd(V,function(){if((V||{}).populateOperatingSystemInfo){var ii=Yv()||{},wi=V.userAgent||ii.userAgent||"",oi=(V.userAgentData||{}).platform||(ii.userAgentData||{}).platform;if(wi){var Gt=eve(wi.toLowerCase());ye=Gt,_e=iee(wi,Gt)}ye&&ye!==hD||!Ld(oi)||(ye=oi)}});Y&&Y.add(li),yo(ie,"name",{s:nt,g:Ct}),yo(ie,"ver",{s:lt,g:zt})}return M}(),O7="MicrosoftApplicationsTelemetryDeviceId";function tve(M,V,Y,ie){V?V.setProperty(Y,ie):M.set(Y,ie,31536e3)}function G_(M,V,Y){return V?V.getProperty(Y)||"":_y(M,Y)}var ive=function(){function M(V,Y,ie){var ye,_e=0;Ia(M,this,function(Ue){Ue.seq=_e,Ue.epoch=Vp(!1).toString(),Ue.getSequenceId=function(){return++_e};var et=Bd(V,function(nt){ye=Y&&Y.getCookieMgr();var lt=nt.cfg.propertyStorageOverride;if(ye.isEnabled()||lt){var Ct=G_(ye,lt,O7);Ct||(Ct=aR()),tve(ye,lt,O7,Ct),Ue.installId=Ct}else ye.purge(O7)});ie&&ie.add(et)})}return M.__ieDyn=1,M}(),gD=function(){function M(V,Y,ie,ye,_e){var Ue=this;Ue.traceId=Y||R0();var et=Bd(V,function(){var nt=V;if(nt.enableDistributedTracing&&!ie&&(ie=R0().substring(0,16)),Ue.parentId=Ue.parentId||ie,nt.enableApplicationInsightsTrace&&!ye){var lt=qu();lt&&lt.pathname&&(ye=lt.pathname)}Ue.name=Ue.name||ye});_e&&_e.add(et)}return M}(),F1="setLocalId";function GF(){return this.getLocalId()}function qF(M){this[F1](M)}var WF=function(){function M(V,Y,ie,ye){var _e,Ue,et;Ia(M,this,function(nt){if(zt(Y),typeof navigator<"u"){var lt=navigator;nt.locale=lt.userLanguage||lt.language}function Ct(){if(!_e.hashIdentifiers&&!_e.dropIdentifiers){var li=_y(et,"MUID");li&&(Ue="t:"+li)}return Ue}function zt(li){var ii=Bd(li,function(){if(et=ie&&ie.getCookieMgr(),_e=li,Ue=null,et&&et.isEnabled()&&(Ct(),_e.enableApplicationInsightsUser)){var wi=_y(et,M.userCookieName);if(wi){var oi=wi.split(M.cookieSeparator);oi.length>0&&(nt.id=oi[0])}if(!nt.id){nt.id=gm(V&&!bl(V.idLength)?V.idLength:22);var Gt=C_(new Date);nt.accountAcquisitionDate=Gt;var ui=[nt.id,Gt],$i=_e.cookieDomain?_e.cookieDomain:void 0;et.set(M.userCookieName,ui.join(M.cookieSeparator),31536e3,$i)}}});ye&&ye.add(ii)}nt.getLocalId=function(){return Ue||Ct()},nt[F1]=function(li){Ue=li}})}return M.cookieSeparator="|",M.userCookieName="ai_user",M._staticInit=void yo(M.prototype,"localId",{g:GF,s:qF}),M}(),KF=1048576,JF=2097152,mD=4194304,wz=function(){function M(V,Y){var ie=this;ie.popSample=100;var ye=Bd(V,function(){ie.eventFlags=0,V.hashIdentifiers&&(ie.eventFlags=ie.eventFlags|KF),V.dropIdentifiers&&(ie.eventFlags=ie.eventFlags|JF),V.scrubIpOnly&&(ie.eventFlags=ie.eventFlags|mD)});Y&&Y.add(ye)}return M}(),N7=["Required","Analytics","SocialMedia","Advertising"],U1="([\\d,.]+)",kz="Unknown",Rz="Edg/",YF=[{ua:"OPR/",b:"Opera"},{ua:"PhantomJS",b:"PhantomJS"},{ua:"Edge",b:"Edge"},{ua:Rz,b:"Edge"},{ua:"Electron",b:"Electron"},{ua:"Chrome",b:"Chrome"},{ua:"Trident",b:"MSIE"},{ua:"MSIE ",b:"MSIE"},{ua:"Firefox",b:"Firefox"},{ua:"Safari",b:"Safari"},{ua:"SkypeShell",b:"SkypeShell"}],QF=[{br:"Microsoft Edge",b:"Edge"},{br:"Google Chrome",b:"Chrome"},{br:"Opera",b:"Opera"}];function x7(M,V){return V.indexOf(M)>-1}function nve(M,V){for(var Y=0;Y<V.length;Y++)if(M==V[Y].brand)return V[Y].version;return null}function ZF(M){if(M){for(var V=0;V<YF.length;V++)if(x7(YF[V].ua,M))return YF[V].b}return kz}function Mz(M,V){return V==="MSIE"?Pz(M):ree(V,M)}function Pz(M){var V=M.match(new RegExp("MSIE "+U1));if(V)return V[1];var Y=M.match(new RegExp("rv:"+U1));return Y?Y[1]:void 0}function ree(M,V){M==="Safari"?M="Version":M==="Edge"&&x7(Rz,V)&&(M="Edg");var Y=V.match(new RegExp(M+"/"+U1));return Y||M==="Opera"&&(Y=V.match(new RegExp("OPR/"+U1)))?Y[1]:kz}function oee(){var M={h:0,w:0},V=ev();return V&&V.screen&&(M.h=screen.height,M.w=screen.width),M}function z1(){return this.getUserConsent()}var see=function(){function M(V,Y,ie){var ye=HP(Y),_e=V||{},Ue=null,et=null,nt=null,lt=null,Ct=null,zt=null,li=null;Ia(M,this,function(ii){Mr(V);var wi=qu();if(wi){var oi=wi.hostname;oi&&(ii.domain=wi.protocol==="file:"?"local":oi)}var Gt=oee();function ui(mn,Ir){if(jo(Ir))try{for(var fn=0;fn<QF.length;fn++){var Xn=nve(QF[fn].br,Ir);if(Xn)return Ct=QF[fn].b,void(zt=Xn)}}catch{}if(mn){var mi=ZF(mn);Ct=mi,zt=Mz(mn,mi)}}function $i(mn){nt=mn}function In(mn){lt=mn}function Kt(){return nt||Ct}function ki(){return lt||zt}ii.screenRes=Gt.w+"X"+Gt.h,ii.getUserConsent=function(){return _e.userConsented||!!_y(ye,_e.userConsentCookieName||"MSCC")},ii.getUserConsentDetails=function(){var mn=null;try{var Ir=_e.callback;if(Ir&&Ir.userConsentDetails){var fn=Ir.userConsentDetails();if(fn){mn=_e.disableConsentDetailsSanitize?fn:{};for(var Xn=0;Xn<N7.length;Xn++){var mi=N7[Xn];mn[mi]=fn[mi]||!1}}}return li!==null&&((mn=mn||{}).GPC_DataSharingOptIn=!!li),mn?JSON.stringify(mn):null}catch{}};var sa=function(){return li},$a=function(mn){li=Kv(mn)?mn:null,_e.gpcDataSharingOptIn=li};function Mr(mn){var Ir=Bd(mn,function(){if((_e=mn).populateBrowserInfo){var fn=_e.userAgent,Xn=(_e.userAgentData||{}).brands;if(fn!==Ue||Xn!==et){if(!fn||!Xn||Xn.length===0){var mi=Yv();mi&&(fn=fn||mi.userAgent||"",Xn=Xn||(mi.userAgentData||{}).brands)}ui(fn,Xn),Ue=fn,et=Xn}}li=Kv(_e.gpcDataSharingOptIn)?_e.gpcDataSharingOptIn:null});ie&&ie.add(Ir)}oc(ii,{userConsent:{g:ii.getUserConsent},browser:{s:$i,g:Kt},browserVer:{s:In,g:ki},gpcDataSharingOptIn:{g:sa,s:$a}})})}return M._staticInit=void yo(M.prototype,"userConsent",{g:z1}),M}();function Nb(M,V,Y,ie,ye){var _e=V.ext[Nc[M]];if(_e)try{sl(ie,function(Ue,et){if(Ld(et)||Zh(et)||Kv(et)){var nt=_e[Y[Ue]];!ye&&(nt||Ld(nt)||Zh(nt)||Kv(nt))&&(et=nt),_e[Y[Ue]]=et}})}catch{}return _e}var Dz,B7=function(){function M(V,Y,ie,ye){Ia(M,this,function(_e){_e.app=new R7(Y,ie,ye),_e.cloud=new M7,_e.user=new WF(V,Y,ie,ye),_e.os=new aee(Y,ye),_e.web=new see(Y,ie,ye);var Ue=new ive(V,ie,ye),et=new D7(Y,ie,ye),nt=new wz(Y,ye);_e.loc=new L7,_e.device=new ZX;var lt=new JX(ie,Y,ye);_e.session=new XI;var Ct=void 0,zt=F7(new gD(Y,Ct,Ct,Ct,ye),wi()),li=!(Y||{}).eventContainExtFields;function ii(){var oi=_e.session;if(oi&&Ld(oi.customId))return oi.customId;lt.update();var Gt=lt.automaticSession;if(Gt){var ui=Gt.getId();ui&&Ld(ui)&&(oi.automaticId=ui)}return oi.automaticId}function wi(){var oi=zt;return ie&&ie.getTraceCtx&&(oi=ie.getTraceCtx(!1)||zt),oi}_e.getTraceCtx=function(){return zt},_e.getSessionId=ii,_e.applyApplicationContext=function(oi){var Gt,ui=_e.app;Nb(4,oi,Yu,((Gt={})[0]=ui.id,Gt[1]=ui.ver,Gt[2]=ui.name,Gt[3]=ui.locale,Gt[4]=ui.getExpId(),Gt[5]=ui.env,Gt),li)},_e.applyUserContext=function(oi){var Gt,ui=_e.user;Nb(0,oi,Iy,((Gt={})[1]=ui.getLocalId(),Gt[0]=ui.locale,Gt[2]=ui.id,Gt),li)},_e.applyWebContext=function(oi){var Gt,ui=_e.web;Nb(3,oi,pf,((Gt={})[0]=ui.domain,Gt[1]=ui.browser,Gt[2]=ui.browserVer,Gt[3]=ui.screenRes,Gt[5]=ui.getUserConsentDetails(),Gt[4]=ui.getUserConsent(),Gt),li)},_e.applyOsContext=function(oi){var Gt,ui=_e.os;Nb(5,oi,Ob,((Gt={})[0]=ui.name,Gt[1]=ui.ver,Gt),li)},_e.applySdkContext=function(oi){var Gt;Nb(6,oi,Kfe,((Gt={})[2]=Ue.installId,Gt[1]=Ue.getSequenceId(),Gt[3]=Ue.epoch,Gt),li)},_e.applyIntWebContext=function(oi){var Gt;Nb(7,oi,Jfe,((Gt={})[0]=et.getMsfpc(),Gt[1]=et.getAnid(),Gt[2]=et.serviceName,Gt),li)},_e.applyUtcContext=function(oi){var Gt,ui=((Gt={})[0]=nt.popSample,Gt);nt.eventFlags>0&&(ui[1]=nt.eventFlags),Nb(8,oi,Yfe,ui,li)},_e.applyLocContext=function(oi){var Gt;Nb(9,oi,ZI,((Gt={})[0]=_e.loc.tz,Gt),li)},_e.applySessionContext=function(oi){var Gt;Nb(4,oi,GX,((Gt={})[0]=ii(),Gt),li)},_e.applyDeviceContext=function(oi){var Gt,ui=_e.device;Nb(1,oi,H_,((Gt={})[0]=ui.localId,Gt[2]=ui.make,Gt[3]=ui.model,Gt[1]=ui.deviceClass,Gt),li)},_e.applyCloudContext=function(oi){var Gt,ui=_e.cloud;Nb(10,oi,U0,((Gt={})[0]=ui.role,Gt[1]=ui.roleInstance,Gt[2]=ui.roleVer,Gt),li)},_e.applyAITraceContext=function(oi){var Gt;if(Y.enableApplicationInsightsTrace){var ui=wi();ui&&Nb(2,oi,Qfe,((Gt={})[0]=ui.getTraceId(),Gt[1]=ui.getName(),Gt[2]=ui.getSpanId(),Gt),!1)}},_e.applyDistributedTraceContext=function(oi){var Gt,ui=wi();if(ui){var $i=((Gt={})[0]=ui.getTraceId(),Gt[1]=ui.getSpanId(),Gt),In=ui.getTraceFlags();rl(In)||($i[2]=In),Nb(11,oi,w7,$i,!1)}}})}return M.__ieDyn=1,M}();function F7(M,V){var Y=M||{};return{getName:function(){return Y.name},setName:function(ie){V&&V.setName(ie),Y.name=ie},getTraceId:function(){return Y.traceId},setTraceId:function(ie){V&&V.setTraceId(ie),MI(ie)&&(Y.traceId=ie)},getSpanId:function(){return Y.parentId},setSpanId:function(ie){V&&V.setSpanId(ie),oR(ie)&&(Y.parentId=ie)},getTraceFlags:function(){return Y.traceFlags},setTraceFlags:function(ie){V&&V.setTraceFlags(ie),Y.traceFlags=ie}}}var Lz=[Nc[4],Nc[0],Nc[3],Nc[5],Nc[6],Nc[7],Nc[8],Nc[9],Nc[1],Nc[2],Nc[11],Nc[10]],V1=dh({populateBrowserInfo:!1,populateOperatingSystemInfo:!1,userAgent:gs(),userAgentData:Lc({brands:Dz,mobile:Dz,platform:Dz}),userConsentCookieName:gs(),userConsented:!1,serviceName:gs(),env:gs(),expId:gs(),sessionRenewalMs:18e5,sessionExpirationMs:864e5,sessionAsGuid:null,cookieDomain:gs(),namePrefix:gs(),enableApplicationInsightsTrace:!1,enableApplicationInsightsUser:!1,hashIdentifiers:!1,dropIdentifiers:!1,scrubIpOnly:!1,callback:Lc({userConsentDetails:null}),gpcDataSharingOptIn:Dz,idLength:22,enableDistributedTracing:!1,eventContainExtFields:!1}),U7=function(M){function V(){var Y,ie,ye,_e=M.call(this)||this;return _e.identifier="SystemPropertiesCollector",_e.priority=3,_e.version="4.2.1",Ia(V,_e,function(Ue,et){function nt(){Y=null,ie={}}function lt(zt){var li=Ue.identifier,ii=Ue.core;Ue._addHook(Bd(zt,function(){var wi=by(null,zt,ii);ye=wi.getExtCfg(li,V1)})),Y=new B7(zt,ye,ii,Ue._unloadHooks),ii&&ii.setTraceCtx&&ii.setTraceCtx(Y.getTraceCtx())}function Ct(zt,li){zt&&sl(zt,function(ii,wi){li[ii]||(li[ii]=wi)})}nt(),Ue.initialize=function(zt,li,ii){et.initialize(zt,li,ii),lt(zt)},Ue.processTelemetry=function(zt,li){UI(zt,Ue.identifier),li=Ue._getTelCtx(li);var ii=zt.ext=zt.ext?zt.ext:{};zt.data=zt.data?zt.data:{},Va(Lz,function(wi){ii[wi]=ii[wi]||{}}),Y&&(Y.applyUtcContext(zt),Y.applyApplicationContext(zt),Y.applyUserContext(zt),Y.applyWebContext(zt),Y.applyOsContext(zt),Y.applySdkContext(zt),Y.applyIntWebContext(zt),Y.applyLocContext(zt),Y.applySessionContext(zt),Y.applyDeviceContext(zt),ye.enableApplicationInsightsTrace&&Y.applyAITraceContext(zt),ye.enableDistributedTracing&&Y.applyDistributedTraceContext(zt),Y.applyCloudContext(zt)),Va(Os(ii),function(wi){Os(ii[wi]).length===0&&delete ii[wi]}),Ct(ie,zt.data),Ue.processNext(zt,li)},Ue.getPropertiesContext=function(){return Y},Ue.setProperty=function(zt,li){ie[zt]=li},Ue._doTeardown=function(zt,li){var ii=(zt||{}).core();if(ii&&ii.getTraceCtx&&Y){var wi=ii.getTraceCtx(!1);wi&&wi===Y.getTraceCtx()&&ii.setTraceCtx(null)}nt()},Ue._getDbgPlgTargets=function(){return[ye]}}),_e}return _u(V,M),V.__ieDyn=1,V}(Ce),q_=function(){function M(V){this._setOverride=function(Y,ie){V.setOverride(Y,ie)},this._getOverride=function(Y){return V.getOverride(Y)}}return M}(),Oz=function(M){function V(Y,ie,ye){var _e=M.call(this,Y)||this,Ue=_e;Ue.setId=function(nt){Ue._setOverride(Yu.id,nt)},Ue.getId=function(){return Ue._getOverride(Yu.id)},Ue.setVer=function(nt){Ue._setOverride(Yu.ver,nt)},Ue.getVer=function(){return Ue._getOverride(Yu.ver)},Ue.setName=function(nt){Ue._setOverride(Yu.appName,nt)},Ue.getName=function(){return Ue._getOverride(Yu.appName)},Ue.setLocale=function(nt){Ue._setOverride(Yu.locale,nt)},Ue.getLocale=function(){return Ue._getOverride(Yu.locale)},Ue.setEnv=function(nt){Ue._setOverride(Yu.env,nt)},Ue.getEnv=function(){return Ue._getOverride(Yu.env)},Ue.setExpId=function(nt){Ue._setOverride(Yu.expId,R7.validateAppExpId(nt))},Ue.getExpId=function(){return Ue._getOverride(Yu.expId)};var et=Bd(ie,function(){ie&&(bl(ie.env)||Ue.setEnv(ie.env),rl(ie.expId)||Ue.setExpId(ie.expId))});return ye&&ye.add(et),_e}return _u(V,M),V}(q_),lee=function(M){function V(Y){var ie=M.call(this,Y)||this,ye=ie;return ye.setRole=function(_e){ye._setOverride(U0.role,_e)},ye.getRole=function(){return ye._getOverride(U0.role)},ye.setRoleInstance=function(_e){ye._setOverride(U0.roleInstance,_e)},ye.getRoleInstance=function(){return ye._getOverride(U0.roleInstance)},ye.setRoleVer=function(_e){ye._setOverride(U0.roleVer,_e)},ye.getRoleVer=function(){return ye._getOverride(U0.roleVer)},ie}return _u(V,M),V}(q_),cee=function(M){function V(Y){var ie=M.call(this,Y)||this,ye=ie;return ye.setProperty=function(_e,Ue){ye._setOverride(_e,Ue)},ye.getProperty=function(_e){return ye._getOverride(_e)},ie}return _u(V,M),V}(q_),dee=function(M){function V(Y){var ie=M.call(this,Y)||this,ye=ie;return ye.setLocalId=function(_e){ye._setOverride(H_.localId,_e)},ye.getLocalId=function(){return ye._getOverride(H_.localId)},ye.setDeviceClass=function(_e){ye._setOverride(H_.deviceClass,_e)},ye.getDeviceClass=function(){return ye._getOverride(H_.deviceClass)},ye.setMake=function(_e){ye._setOverride(H_.make,_e)},ye.getMake=function(){return ye._getOverride(H_.make)},ye.setModel=function(_e){ye._setOverride(H_.model,_e)},ye.getModel=function(){return ye._getOverride(H_.model)},ie}return _u(V,M),V}(q_),z7=function(M){function V(Y){var ie=M.call(this,Y)||this,ye=ie;return ye.setTz=function(_e){ye._setOverride(ZI.tz,_e)},ye.getTz=function(){return ye._getOverride(ZI.tz)},ie}return _u(V,M),V}(q_),V7=function(M){function V(Y,ie,ye){var _e=M.call(this,Y)||this,Ue=_e,et=null;Ue.setOsName=function(lt){Ue._setOverride(Ob.osName,lt)},Ue.getOsName=function(){return Ue._getOverride(Ob.osName)},Ue.setVer=function(lt){Ue._setOverride(Ob.ver,lt)},Ue.getVer=function(){return Ue._getOverride(Ob.ver)};var nt=Bd(ie,function(){!et&&ie.userAgent&&ie.populateOperatingSystemInfo&&(et=new aee(ie,ye)),et&&(Ue.setOsName(et.name),Ue.setVer(et.ver))});return ye&&ye.add(nt),_e}return _u(V,M),V}(q_);function uee(M,V){if(M)for(var Y=0;Y<V.length;Y++){var ie=V[Y];rl(M[ie])&&(M[ie]={}),M=M[ie]}return M}function ave(M,V,Y){if(M&&V){var ie=V.split("."),ye=ie[ie.length-1];ie.length>1&&(M=uee(M,ie.slice(0,-1))),rl(Y)?bl(M[ye])||delete M[ye]:M[ye]=Y}}var PR,lp,fD=function(){function M(V){var Y=this,ie=[];Y.setOverride=function(ye,_e){ye&&ie.push({key:ye,value:_e})},Y.hasOverride=function(ye){var _e=!1;return Va(ie,function(Ue){Ue.key===ye&&(_e=!0)}),_e},Y.getOverride=function(ye){var _e;return Va(ie,function(Ue){Ue.key===ye&&(_e=Ue.value)}),_e},Y.applyOverrides=function(ye,_e){if(ie.length>0)try{var Ue=uee(ye,V);Va(ie,function(et){ave(Ue,et.key,et.value)})}catch{}}}return M}(),$7=function(M){function V(Y){var ie=M.call(this,Y)||this,ye=ie;return ye.setLocalId=function(_e){ye._setOverride(Iy.localId,_e)},ye.getLocalId=function(){return ye._getOverride(Iy.localId)},ye.setLocale=function(_e){ye._setOverride(Iy.locale,_e)},ye.getLocale=function(){return ye._getOverride(Iy.locale)},ye.setId=function(_e){ye._setOverride(Iy.id,_e)},ye.getId=function(){return ye._getOverride(Iy.id)},ie}return _u(V,M),V}(q_),rve=function(M){function V(Y,ie,ye){var _e=M.call(this,Y)||this,Ue=_e;Ue.setDomain=function(nt){Ue._setOverride(pf.domain,nt)},Ue.getDomain=function(){return Ue._getOverride(pf.domain)},Ue.setBrowser=function(nt){Ue._setOverride(pf.browser,nt)},Ue.getBrowser=function(){return Ue._getOverride(pf.browser)},Ue.setBrowserVer=function(nt){Ue._setOverride(pf.browserVer,nt)},Ue.getBrowserVer=function(){return Ue._getOverride(pf.browserVer)},Ue.setScreenRes=function(nt){Ue._setOverride(pf.screenRes,nt)},Ue.getScreenRes=function(){return Ue._getOverride(pf.screenRes)},Ue.setUserConsent=function(nt){Ue._setOverride(pf.userConsent,nt)},Ue.getUserContext=function(){return Ue._getOverride(pf.userConsent)};var et=Bd(ie,function(){ie&&(bl(ie.userConsented)||Ue.setUserConsent(ie.userConsented))});return ye&&ye.add(et),_e}return _u(V,M),V}(q_),DR="ext",ove="data",sve=function(){function M(V,Y,ie,ye){var _e=this,Ue={};function et(nt){for(var lt="",Ct=0;Ct<nt.length;Ct++)lt&&(lt+="_"),lt+=nt[Ct];return bl(Ue[lt])&&(Ue[lt]=new fD(nt)),lt?Ue[lt]:null}_e.data=new cee(et([ove])),_e.app=new Oz(et([DR,Nc.AppExt]),Y,ye),_e.user=new $7(et([DR,Nc.UserExt])),_e.os=new V7(et([DR,Nc.OSExt]),Y,ye),_e.web=new rve(et([DR,Nc.WebExt]),Y,ye),_e.device=new dee(et([DR,Nc.DeviceExt])),_e.loc=new z7(et([DR,Nc.LocExt])),_e.cloud=new lee(et([DR,Nc.CloudExt])),_e.applyOverrides=function(nt,lt){var Ct=Os(Ue);Ct&&Ct.length>0&&Va(Ct,function(zt){Ue[zt].applyOverrides(nt,lt)})}}return M}(),Qp=void 0,lve=dh({env:Qp,expId:Qp,populateOperatingSystemInfo:!1,userAgent:Qp,userAgentData:Lc({brands:Qp,mobile:Qp,platform:Qp}),userConsented:Qp}),vD="OverridePropertiesPlugin",hee=function(M){function V(){var Y=M.call(this)||this;Y.identifier=vD,Y.priority=4,Y.version="4.2.1";var ie=null;return Ia(V,Y,function(ye,_e){ye.initialize=function(Ue,et,nt){_e.initialize(Ue,et,nt),ye._baseInit(Ue,et,nt)},ye.processTelemetry=function(Ue,et){UI(Ue,Y.identifier),et=ye._getTelCtx(et);var nt=ye.getOverrideContext();nt&&nt.applyOverrides(Ue,et),ye.processNext(Ue,et)},ye._baseInit=function(Ue,et,nt){ie=new sve(Ue,Y._getTelCtx().getExtCfg(Y.identifier,lve),et,ye._unloadHooks)},ye.setProperty=function(Ue,et){ie&&ie.data.setProperty(Ue,et)},ye.getOverrideContext=function(){return ie}}),Y}return _u(V,M),V.__ieDyn=1,V}(Ce),Nz="_dropInst",xz=["channelConfiguration","propertyStorageOverride"];function H7(M){if(M&&jo(M.extensionConfig)){var V=M.extensionConfig,Y={};sl(V,function(ie,ye){Xo(ye)||Td(ie,"Symbol(")||(Y[ie]=ye)}),M.extensionConfig=Y}return M}function $1(M,V){if(V)for(var Y=Os(V),ie=0;ie<Y.length;ie++){var ye=Y[ie];ch(M,ye)||Td(ye,"Symbol(")||(M[ye]=V[ye])}}function XF(M,V,Y){var ie;return yo(M,V,{g:function(){return Zf(Y)?Y:(jo(Y)?(jo(ie)||(ie=[]),ie.length=Y.length):Qh(ie)||(ie={}),sl(Y,function(ye,_e){Td(ye,"Symbol(")||XF(ie,ye,_e)}),ie)}})}function Bz(M){return M.pause&&M.teardown&&M.flush}function Fz(M,V){var Y=null;if(V){V.endpointUrl&&(Y=V.endpointUrl);var ie=(V.extensionConfig||{})[M]||{};ie.overrideEndpointUrl&&(Y=ie.overrideEndpointUrl)}return Y}var j7=dh({cookieCfg:{},channelConfiguration:Lc({}),propertyConfiguration:Lc({}),extensions:{rdOnly:!0,ref:!0,v:[],blkVal:!0},channels:{rdOnly:!0,ref:!0,v:[],blkVal:!0},extensionConfig:Lc({}),createPerfMgr:lp,loggingLevelConsole:0}),ew=dh({propertyConfiguration:Lc({}),cookieCfg:Lc({}),extensions:{rdOnly:!0,ref:!0,v:[],blkVal:!0},channels:{rdOnly:!0,ref:!0,v:[],blkVal:!0},extensionConfig:Lc((PR={},PR[vD]=Lc({}),PR)),createPerfMgr:lp,loggingLevelConsole:0}),LR=function(M){function V(Y,ie){var ye=M.call(this)||this;return Ia(V,ye,function(_e,Ue){function et(Ct){var zt=[];return Ct&&Va(Ct,function(li){li.iKey===Y&&zt.push(li)}),zt}function nt(Ct){if(_e[Ct]&&_e.listeners)for(var zt=0;zt<_e.listeners.length;zt++){var li=_e.listeners[zt];if(li&&li[Ct])return!0}return!1}var lt={eventsSent:function(Ct){if(nt("eventsSent")){var zt=et(Ct);zt.length>0&&_e.eventsSent(zt)}},eventsDiscarded:function(Ct,zt){if(nt("eventsDiscarded")){var li=et(Ct);li.length>0&&_e.eventsDiscarded(li,zt)}},eventsSendRequest:function(Ct,zt){nt("eventsSendRequest")&&_e.eventsSendRequest(Ct,zt)},perfEvent:function(Ct){nt("perfEvent")&&_e.perfEvent(Ct)}};ie.addNotificationListener(lt)}),ye}return _u(V,M),V.__ieDyn=1,V}(RI),Uz=function(){function M(){var V,Y,ie,ye,_e,Ue,et,nt,lt,Ct,zt,li,ii,wi,oi=null,Gt=null;Ia(M,this,function(ui){function $i(){V=jp({},j7,null),Y=[],ie=null,ye=null,_e=[],Ue=[],et={},nt=null,lt=null,Ct=null,li=null,ii=null,wi=!1,V.cfg.loggingLevelConsole=1,zt=new AS(V.cfg),yo(ui,"sharedConfig",{g:function(){return wi&&sa(),V.cfg}})}function In(fn,Xn){var mi;if(Xn===void 0&&(Xn=null),fn){(Bz(fn)?Ue:_e).push(fn);var wn=fn.identifier,wa=V.cfg.extensionConfig;V.setDf(wa,((mi={})[wn]={ref:!0,v:Xn||{}},mi))}return fn}function Kt(){var fn=V.cfg,Xn=fn.channels,mi=new E7,wn=mi.identifier,wa=!1;lt=null,Ct=null,Va(Xn,function(lr){wa||Va(lr,function(ka){if(!Xo(ka)&&(In(ka),ka.identifier===wn))return lt=ka,wa=!0,-1})}),wa||(lt=In(mi,fn.channelConfiguration),Xn.length>0?oS(Xn[0],lt):fn.channels.push([lt]))}function ki(fn){var Xn=V.cfg;Y=[],nt=In(new U7,Xn.propertyConfiguration),Y.push(nt),Xn.extensions&&Va(Xn.extensions,function(mi){Xo(mi)||In(mi)}),fn&&Va(fn,function(mi){mi&&!Xo(mi)&&Y.push(In(mi))})}function sa(){ie||(wi||cl(ui.diagLog(),2,520,"The Shared Manager is not yet created, the returned shared instance will be overwritten"),V.cfg.instrumentationKey=V.cfg.instrumentationKey||"_not_defined_",ye=new RI,(ie=new zz(ui,ui.diagLog(),ye)).initialize(V.cfg,Y),ie.isInitialized()&&(oc((V=k_(ie.config)).cfg,{channelConfiguration:{g:function(){return V.cfg.extensionConfig[lt.identifier]}},propertyConfiguration:{g:function(){return V.cfg.extensionConfig[nt.identifier]}}}),lt&&(Ct=Fz(lt.identifier,V.cfg))),oi&&ie.setCookieMgr(oi))}function $a(fn,Xn){var mi=[],wn=V.cfg,wa={};if(sl(wn.extensionConfig,function(Ba,Qr){Ba===lt.identifier||Ba===nt.identifier||Td(Ba,"Symbol(")||(Ba!==vD?XF(wa,Ba,Qr):(wa[Ba]={},$1(wa[Ba],Qr)))}),Xn){Xn.extensions&&Xn.extensions.length>0&&(mi=oS(mi,Xn.extensions));var lr=Xn.extensionConfig;lr&&(ch(lr,lt.identifier)&&Os(lr).length>0&&cl(ui.diagLog(),2,511,"Instances cannot override the shared Post channel configuration, the shared will be used!"),$1(wa,lr))}var ka={instrumentationKey:fn,channels:Mr(Xn),extensions:mi,extensionConfig:wa};return $1(ka,Xn),ka}function Mr(fn){var Xn=V.cfg,mi=[[]];return Xn.channels&&Va(Xn.channels,function(wn,wa){Xo(wn)||(mi[wa]=mi[wa]||[],mi[wa]=mi[wa].concat(wn))}),fn&&fn.channels&&Va(fn.channels,function(wn,wa){Xo(wn)||(mi[wa]=mi[wa]||[],mi[wa]=mi[wa].concat(wn))}),mi}function mn(fn){var Xn=[];return Y&&Y.length>0&&(Xn=Xn.concat(Y)),fn&&fn.length>0&&(Xn=Xn.concat(fn)),Xn}function Ir(fn,Xn,mi,wn){var wa=et[fn];wa&&(wa.inst&&wa.inst.isInitialized()?wa.inst.unload(Xn,function(lr){mi&&mi(fn,lr)},wn):mi&&mi(fn,{reason:50,isAsync:Xn,flushComplete:!1}))}$i(),ui.diagLog=function(){return zt||(zt=new AS(V.cfg)),zt},ui.getCookieMgr=function(){return sa(),oi||ie.getCookieMgr()},ui.setCookieMgr=function(fn){oi=fn,ie&&ie.setCookieMgr(fn)},ui.getPerfMgr=function(){return ii||V&&V.cfg.enablePerfMgr&&(ii=Gt||new Db(ui.getNotifyMgr())),ii},ui.setPerfMgr=function(fn){Gt=fn,ii=fn},ui.create=function(fn,Xn){wi?cl(ui.diagLog(),2,514,"Shared Manager has already been initialized."):(V=jp(H7(fn?g0({},fn):{}),j7,null),ie=null,Kt(),ki(Xn),wi=!0)},ui.getInst=function(fn){return(et[fn]||{}).inst},ui.newInst=function(fn,Xn,mi){var wn=ui.getInst(fn);if(wn)return cl(ui.diagLog(),2,514,"Instance already exists for ["+fn+"]"),wn;if(sa(),ie.isInitialized()){var wa=$a(fn,Xn);if(lt){var lr=Fz(lt.identifier,wa);Ct&&lr&&Ct!==lr&&cl(ui.diagLog(),2,511,"The endpointUrl mismatch, shared Url ["+Ct+"] is different from configured ["+lr+"] shared will be used!")}var ka=new LR(fn,ye);if(wn=new zz(ui,ui.diagLog(),ka),et[fn]={iKey:fn,inst:wn,notifyMgr:ka},wn.setPerfMgr(ui.getPerfMgr()),wn.initialize(wa,mn(mi)),wn.isInitialized()){var Ba=wn.config;oc(Ba,{propertyConfiguration:{g:function(){return Ba.extensionConfig[vD]}}});try{delete Ba.endpointUrl,delete Ba.channelConfiguration,delete Ba.propertyStorageOverride}catch{cl(ui.diagLog(),2,108,"Failed to remove unused defaults!")}sl(V.cfg,function(Qr,la){ch(Ba,Qr)||Td(Qr,"Symbol(")||MP(xz,Qr)||XF(Ba,Qr,la)})}else cl(ui.diagLog(),2,520,"Failed to initialize new instance!"),wn=null,delete et[fn]}return wn},ui.getSharedPlugin=function(fn){sa();var Xn=null,mi=ie.getPlugin(fn);return mi&&(Xn=mi.plugin),Xn},ui.getPropertyManager=function(){return sa(),nt},ui.getPostChannel=function(){return sa(),lt},ui.getNotifyMgr=function(){return li||(li=new RI),li},ui.unload=function(fn,Xn,mi){var wn,wa=Os(et),lr=wa.length+1,ka={reason:50,isAsync:fn,flushComplete:!1};function Ba(Qr,la){--lr===0&&($i(),Xn&&Xn(la))}return fn&&!Xn&&(wn=Zl(function(Qr){Xn=Qr})),ie&&(Va(wa,function(Qr){Ir(Qr,fn,function(la,mr){Ba(la,mr)},mi)}),ie.isInitialized()&&(ie.unload(fn,function(Qr){Ba(null,ka=Qr)},mi),ie=null)),Ba(null,ka),wn},ui.addUnloadHook=function(fn){sa(),ie.addUnloadHook(fn)},ui.addSharedPlugin=function(fn,Xn,mi,wn){return sa(),ie.addPlugin(fn,Xn,mi,wn)},ui.updateCfg=function(fn,Xn){return sa(),ie.updateCfg(fn,Xn)},ui.evtNamespace=function(){return sa(),ie.evtNamespace()},ui.addUnloadCb=function(fn){sa(),ie.addUnloadCb(fn)},ui.onCfgChange=function(fn){return sa(),ie.onCfgChange(fn)},ui[Nz]=function(fn){fn&&et.iKey&&delete et[fn]}})}return M.__ieDyn=1,M}(),zz=function(M){function V(Y,ie,ye){var _e,Ue=M.call(this)||this,et=Y;return Ia(V,Ue,function(nt,lt){nt.getSharedPropertyManager=function(){return et.getPropertyManager()},nt.getSharedPostChannel=function(){return et.getPostChannel()},nt.getOverridePropertyManager=function(){return _e},nt.initialize=function(Ct,zt){lu(nt,function(){return"ApplicationInsights:initialize"},function(){var li=[_e=new hee];zt&&(li=li.concat(zt));var ii=Ct.propertyConfiguration||{};if(Ct.propertyConfiguration)try{delete Ct.propertyConfiguration}catch{Ct.propertyConfiguration={}}Ct.extensionConfig=Ct.extensionConfig||{},Ct.extensionConfig[_e.identifier]=ii,Ct=jp(Ct,ew,ie||nt.logger,!1).cfg;try{lt.initialize(Ct,li,ie,ye)}catch(wi){cl(nt.logger,1,514,"Failed to initialize SDK."+zs(wi))}},function(){return{config:Ct,extensions:zt}})},nt.unload=function(Ct,zt,li){return et[Nz]&&et[Nz]((nt.config||{}).instrumentationKey),lt.unload(Ct,zt,li)}}),Ue}return _u(V,M),V.__ieDyn=1,V}(Rg),pee=class{constructor(M=Wt.telemetry.tenantToken,V=Wt.telemetry.onedsCollectorURL,Y=Wt.telemetry.eventsLimitInMem){this.tenantToken=M,this.onedsCollectorURL=V,this.eventsLimitInMem=Y,this.DB_NAME="mdsc_vdi3_sessions",this.DB_NAME_REALTIME="mdsc_vdi3_sessions_realtime",this.DB_NAME_TERMINATED="mdsc_vdi3_sessions_terminated",this.manager=new Uz,this.initManager()}sendEvent(M,V){const Y=this.manager.getInst(this.tenantToken)??this.manager.newInst(this.tenantToken),ie={};for(const _e of Object.keys(M))ie[_e]={value:M[_e]};const ye={name:V||this.DB_NAME,data:ie,latency:az.Normal,persistence:s7.Normal};Y.track(ye)}sendRealTimeEvent(M){this.sendEvent(M,this.DB_NAME_REALTIME)}sendTerminatedTelemetrEvent(M){this.sendEvent(M,this.DB_NAME_TERMINATED)}initManager(){const M={propertyConfiguration:{populateBrowserInfo:!0,populateOperatingSystemInfo:!0},channelConfiguration:{eventsLimitInMem:this.eventsLimitInMem},endpointUrl:this.onedsCollectorURL,enableCompoundKey:!0};this.manager.create(M,[])}},Vz=class{constructor(M){this.logger=M,this.realTimeTelemetryStarted=!1,this.telemetryLogger=new pee,this.sessionStat=new Map,this.realTimeTelemetryInterval=Wt.telemetry.realTimeTelemetryInterval}setConfig(M,V,Y,ie){this.logger.log(`Setting telemetry config:
            tenantToken: ${M?"****":"undefined"},
            onedsCollectorURL: ${V}, 
            eventsLimitInMem: ${Y}, 
            realTimeTelemetryInterval: ${ie}`),this.realTimeTelemetryInterval=ie??this.realTimeTelemetryInterval,this.telemetryLogger=new pee(M,V,Y)}addSession(M){this.sessionStat.has(M.id)||this.sessionStat.set(M.id,M)}getSession(M){return this.sessionStat.get(M)}sendTelemetry(M){if(!this.sessionStat.has(M))return void this.logger.log(`Invalid session if ${M}`);const V=this.sessionStat.get(M);this.telemetryLogger.sendEvent(V.getReport())}startRealtimeTelemetry(){this.realTimeTelemetryStarted||(this.realTimeTelemetryStarted=!0,this.sendRealTimeTelemetry())}stopRealtimeTelemetry(){this.realTimeTelemetryStarted=!1}sendLastGatheredTelemetry(M){if(M){const V=this.sessionStat.get(M);V&&this.telemetryLogger.sendTerminatedTelemetrEvent(V.getReport())}else this.sessionStat.forEach(V=>{this.telemetryLogger.sendTerminatedTelemetrEvent(V.getReport())})}removeSession(M){this.sessionStat.delete(M)}clear(){this.sessionStat.clear()}sendRealTimeTelemetry(){this.realTimeTelemetryStarted&&(this.logger.info("Sending real time telemetry"),this.sessionStat.forEach(M=>{this.telemetryLogger.sendRealTimeEvent(M.getReportForRealTime())}),setTimeout(()=>{this.sendRealTimeTelemetry()},Wt.telemetry.realTimeTelemetryInterval))}},cve=class{constructor(M,V,Y,ie){this.id=M,this.logger=V,this.getRpcTelemetry=Y,this.getTransportTelemetry=ie,this.metricsMap=new Map,this.startTime=Date.now(),this.stacksCreatedAt=[],this.connectionTerminatedAt=void 0}startTimer(M){const V=this.metricsMap.get(M)??new gee(this.logger);V.start(),this.metricsMap.has(M)||this.metricsMap.set(M,V)}stopTimer(M){this.metricsMap.get(M)?.stop()}setTsCallingVersion(M){this.tsCallingVersion=M}addStack(){yt(this.stacksCreatedAt,Date.now(),10)}setConnectionTerminatedAt(){this.connectionTerminatedAt=Date.now()}},gee=class{constructor(M){this.logger=M}start(){if(this.endTime||this.startTime)throw new Error("Already used.");this.startTime=Date.now()}stop(){this.endTime&&this.logger.error("Already stopped."),this.endTime=Date.now()}getReport(){return{startTime:this.startTime,endTime:this.endTime,duration:this.endTime&&this.startTime&&this.endTime-this.startTime||void 0}}},$z=class{constructor(){this.onConnectionTerminatedCallbacks=new Set}onConnectionTerminated(M){this.onConnectionTerminatedCallbacks.add(M)}setChannel(M){this.channelId=M}addTransportManager(M){this.sessionInitializedAt=Date.now(),this.transportEvent?.dispose(),this.transportEvent=M.on("connectionTerminated",V=>{this.channelId&&V!==this.channelId||(this.lastSesstionTerminatedAt=Date.now(),this.onConnectionTerminatedCallbacks.forEach(Y=>Y()))})}getStat(){return{lastSesstionTerminatedAt:this.lastSesstionTerminatedAt,sessionInitializedAt:this.sessionInitializedAt}}},mee=class{constructor(M){this.remoteStackHealthCheck=M}onConnectionTerminated(M){this.remoteStackHealthCheck.onConnectionTerminated(M)}getStat(){return this.remoteStackHealthCheck.getStat()}},H1=new $z,OR=new mee(H1);function j1(M,V){return M.shellify(V)}var yD="$$marshalled",G1="$$ref",fee=(M,V)=>({[yD]:{type:M,properties:V}}),G7=M=>yD in M,q1=(M,V)=>!(typeof V!="object"||V===null||!G7(V))&&V[yD].type===M,q7=M=>M[yD].properties,vee=M=>({[G1]:M}),Hz=M=>typeof M=="object"&&M!==null&&G1 in M,yee=M=>M[G1],See=class{constructor(M){this.marshallers=M}pack(M){const V=this.findMarshaller(M);return V?fee(V.type,V.marshall(M)):M}unpack(M){const V=this.findUnmarshaller(M);return V?V.unmarshall(q7(M)):M}findMarshaller(M){return this.marshallers.find(V=>V.canMarshall(M))}findUnmarshaller(M){return this.marshallers.find(V=>V.canUnmarshall(M))}},bee=class{constructor(M,V,Y){this.logger=M,this.uniqueIdFactory=V,this.config=Y,this.finalizationRegistry=new FinalizationRegistry(ie=>{this.logger.info("Reference garbage collected",ie),this.refIdToRef.delete(ie)}),this.refIdToRef=new Map,this.refToRefId=this.config.disableWeakRefs?new Map:new WeakMap,this.shellRefs=new WeakSet}dispose(){this.refIdToRef.clear(),this.refToRefId instanceof Map&&this.refToRefId.clear()}getRefs(){return this.refIdToRef.entries()}saveRef(M,V=this.uniqueIdFactory.getNextRefId()){if(M!==void 0){if(this.hasByRef(M))return this.getRefId(M);try{return this.refIdToRef.set(V,new WeakRef(M)),this.refToRefId.set(M,V),this.finalizationRegistry.register(M,V),V}catch(Y){return void this.logger.error("Error when saving a reference",M,Y)}}}getRef(M){if(M!==void 0)return this.refIdToRef.get(M)?.deref()}getRefId(M){return this.refToRefId.get(M)}hasByRef(M){return this.refToRefId.has(M)}hasByRefId(M){return!!this.refIdToRef.has(M)&&this.getRef(M)!==void 0}removeByRefId(M){const V=this.refIdToRef.get(M)?.deref();this.refIdToRef.delete(M),V&&this.refToRefId.delete(V)}removeByRef(M){const V=this.refToRefId.get(M);this.refToRefId.delete(M),V&&this.refIdToRef.delete(V)}saveShellRef(M){this.shellRefs.add(M)}isShellByRef(M){return this.shellRefs.has(M)}isShellByRefId(M){const V=this.getRef(M);return V!==void 0&&this.shellRefs.has(V)}toReferenced(M){return this.hasByRef(M)?vee(this.getRefId(M)):M}fromReferenced(M){return Hz(M)?this.getRef(yee(M)):M}},e2=class{getNextExecutionId(){return it(8)}getNextRefId(){return it(10)}},eC={timeout:5e4},W7=class{constructor(M,V,Y){this.logger=M,this.uniqueIdFactory=V,this.pool=new Map,this.timeout=Y.timeout}setTimeout(M){this.logger.info(`timeout set to, ${M}`),this.timeout=M}create(){const M=this.uniqueIdFactory.getNextExecutionId(),{promise:V,resolve:Y,reject:ie}=Ye(this.timeout,JSON.stringify("timeout"));return this.pool.set(M,[Y,ie]),[M,V.finally(()=>{this.logger.debug(`removing execution ${M} from pool`),this.pool.delete(M)})]}getExecutionHandlers(M){const V=this.pool.get(M);if(!V)throw this.logger.error(`no execution with id ${M} is waiting for result.`),new Error(`no execution with id ${M} is waiting for result.`);return V}dispose(){this.pool.forEach(([,M])=>M(new Error("Transport closed"))),this.pool.clear()}},NR=class{canUnmarshall(M){return q1(this.type,M)}},W1=class extends NR{constructor(M,V){super(),this.logger=M,this.referenceManager=V}ensureRefSaved(M){this.referenceManager.hasByRef(M)||(this.logger.warn("Value not saved before marshalling, saving"),this.referenceManager.saveRef(M))}ensureRefExists(M){if(!this.referenceManager.hasByRefId(M.refId)){this.logger.info("Value does not exist, creating shell");const V=this.createShellRef(M);this.referenceManager.saveRef(V,M.refId),this.referenceManager.saveShellRef(V)}}},K7=class extends W1{marshall(M){return this.ensureRefSaved(M),{refId:this.referenceManager.getRefId(M),entries:this.marshallEntries(M)}}unmarshall(M){this.ensureRefExists(M);const V=this.referenceManager.getRef(M.refId);return this.unmarshallEntries(V,M.entries),V}},xR=class extends NR{constructor(){super(...arguments),this.type="error"}marshall(M){return{message:M.message,stack:M.stack,name:M.name,cause:M.cause}}unmarshall(M){const V=new Error(M.message);return V.stack=M.stack,V.name=M.name,V.cause=M.cause,V}canMarshall(M){return M instanceof Error}},K1=class extends K7{constructor(){super(...arguments),this.type="array"}canMarshall(M){return Array.isArray(M)}createShellRef(){return new Array}marshallEntries(M){return M.map((V,Y)=>[Y,this.referenceManager.toReferenced(V)])}unmarshallEntries(M,V){M.length=0;for(const[Y,ie]of V)M[Y]=this.referenceManager.fromReferenced(ie);return M}},dve=class extends W1{constructor(M,V,Y){super(M,V),this.execute=Y,this.type="function"}marshall(M){return this.ensureRefSaved(M),{refId:this.referenceManager.getRefId(M)}}unmarshall(M){return this.ensureRefExists(M),this.referenceManager.getRef(M.refId)}canMarshall(M){return typeof M=="function"}createShellRef(){const M=this.execute,V=function(...Y){return M(V,Y,this)};return V}},J1=(M,V,Y)=>{try{return M.value??M.get?.call(V)}catch(ie){return void Y?.warn("Failed to read property value",ie)}},DS=Object.getPrototypeOf({});function*Nh(M,V){let Y=M;const{allowedObjectNames:ie,deniedNames:ye,deniedValues:_e}=V,Ue=new Set(ye),et=lt=>Array.from(V.deniedInstances).some(Ct=>lt instanceof Ct),nt=Y?ie.get(Y)??ie.get(Y.constructor):void 0;do if(nt?.size!==0){for(const lt of Object.getOwnPropertyNames(Y)){if(Ue.has(lt)||nt&&!nt.has(lt))continue;const Ct=Object.getOwnPropertyDescriptor(Y,lt),zt=J1(Ct,M);et(zt)||_e.has(zt)||(Ue.add(lt),yield[lt,Ct])}Y=Reflect.getPrototypeOf(Y)}else Y=Reflect.getPrototypeOf(Y);while(Y&&Y!==DS)}var z0=class extends W1{constructor(M,V,Y){super(M,V),this.propertyCollectionConfig=Y,this.type="object"}marshall(M){this.ensureRefSaved(M);const V=this.referenceManager.getRefId(M),Y=Object.create(null);for(const[ie,ye]of Nh(M,this.propertyCollectionConfig))Y[ie]=this.referenceManager.toReferenced(J1(ye,M,this.logger));return{refId:V,properties:Y}}unmarshall(M){const{refId:V,properties:Y}=M;this.ensureRefExists(M);const ie=this.referenceManager.getRef(V);if(ie===void 0&&this.logger.warn("reference lost. refId=",V),Y===void 0)return this.logger.info("no properties to be applied. refId=",V),ie;for(const[ye,_e]of Nh(ie,this.propertyCollectionConfig)){const Ue=Y[ye];Ue!==void 0&&Hz(Ue)&&this.referenceManager.saveRef(_e.value,yee(Ue))}for(const[ye,_e]of Object.entries(Y))Reflect.defineProperty(ie,ye,{value:this.referenceManager.fromReferenced(_e),enumerable:!0,writable:!0,configurable:!0});return ie}canMarshall(M){return typeof M=="object"&&M!==null}createShellRef(){return{}}},Mg=class{constructor(M,V,Y,ie){this.logger=M,this.referenceManager=V,this.propertyCollectionConfig=Y,this.worldRootRef=ie}ingestRefs(M){const V=new Set(M);V.add(this.worldRootRef);for(const[,ye]of this.referenceManager.getRefs())this.referenceManager.isShellByRef(ye)||V.add(ye.deref());V.delete(void 0);const Y=Array.from(V);if(Y.length===0)return void this.logger.info("nothing to ingest");this.logger.info("ingesting references");const ie=new Set;for(;Y.length;){const ye=Y.pop();if(ye!==null&&!(typeof ye!="object"&&typeof ye!="function"||this.isNotAllowedByPropertyCollectionConfig(ye)||ie.has(ye)||(ie.add(ye),this.referenceManager.saveRef(ye),typeof ye=="function")))if(ye instanceof Map)for(const[_e,Ue]of ye.entries())Y.push(_e,Ue);else if(ye instanceof Set||Array.isArray(ye))Y.push(...ye.values());else for(const[,_e]of Nh(ye,this.propertyCollectionConfig)){const Ue=J1(_e,ye,this.logger);Ue&&Y.push(Ue)}}}isNotAllowedByPropertyCollectionConfig(M){if(this.propertyCollectionConfig.deniedValues.has(M))return!0;for(const V of this.propertyCollectionConfig.deniedInstances)if(M instanceof V)return!0;return!1}},ff=class{constructor(){this.requests=[],this.historyLength=100}registerStat(M){yt(this.requests,M,this.historyLength)}getStats(M){let V=this.requests;return M&&(V=this.requests.filter(({timestamp:Y})=>Y>=M)),{requests:V,avgRtt:this.getAverage(V,"rtt"),avgRequestSize:this.getAverage(V,"requestSize"),avgResponseSize:this.getAverage(V,"responseSize"),medianRtt:this.getMedian(V,"rtt"),medianRequestSize:this.getMedian(V,"requestSize"),medianResponseSize:this.getMedian(V,"responseSize")}}clear(){this.requests=[]}getMedian(M,V){const Y=M.map(Ue=>Ue[V]),ie=M.length;if(ie===0)return 0;const ye=[...Y].sort(),_e=Math.floor(ie/2);return ie%2==0?(ye[_e-1]+ye[_e])/2:ye[_e]}getAverage(M,V){return M.length===0?0:M.reduce((Y,ie)=>Y+ie[V],0)/M.length}},J7=class{constructor(M){this.rpcStatsManager=M}getReport(M){const{requests:V,avgRtt:Y,avgRequestSize:ie,avgResponseSize:ye,medianRtt:_e,medianRequestSize:Ue,medianResponseSize:et}=this.rpcStatsManager.getStats(M);return{RPC_requests:JSON.stringify(V),RPC_avgRtt:Y,RPC_avgRequestSize:ie,RPC_avgResponseSize:ye,RPC_medianRtt:_e,RPC_medianRequestSize:Ue,RPC_medianResponseSize:et}}},Y7=class{constructor(){this.failed=!1,this.steps=new Map,this.startTime=Date.now()}startStep(M){this.steps.set(M,{start:Date.now(),end:void 0})}endStep(M){const V=this.steps.get(M);if(!V)return;const Y=V.start;this.steps.set(M,{start:Y,end:Date.now()})}setRequestBody(M){this.requestBody=JSON.stringify(M)}setResponseBody(M){this.responseBody=JSON.stringify(M)}markFailed(){this.failed=!0}getStat(){return{timestamp:this.startTime,rtt:Date.now()-this.startTime,requestSize:kt(this.requestBody||""),responseSize:kt(this.responseBody||""),steps:Array.from(this.steps).map(([M,{start:V,end:Y}])=>({name:M,duration:Y?Y-V:void 0})),failed:this.failed}}},uve=()=>({type:"sync-state-request"}),gr=(M,V)=>({type:"sync-state",executionId:M,payload:{snapshot:V}}),t2=M=>({type:"sync-state-result",executionId:M}),Q7=class{constructor(M,V,Y,ie,ye){this.logger=M,this.transport=V,this.remoteExecutionStorage=Y,this.snapshotManager=ie,this.referenceExtractor=ye,this.synchronized=new gt,this.transport.addEventListener("sync-state",_e=>{this.handleSynchronizeState(_e)}),this.transport.addEventListener("sync-state-result",_e=>{this.handleSynchronizeStateResult(_e)}),this.transport.addEventListener("sync-state-request",_e=>{this.handleSynchronizeStateRequest(_e)})}async waitForSynchronization(){return this.logger.info("waiting for remote sync to be completed"),this.transport.dispatchEvent(uve()),this.synchronized.promise}async synchronize(M=[]){this.logger.info("writing remote state"),this.referenceExtractor.ingestRefs(M);const V=this.snapshotManager.create(),[Y,ie]=this.remoteExecutionStorage.create();this.transport.dispatchEvent(gr(Y,V)),this.logger.info(`Execution[${Y}]: waiting to be resolved`),await ie}handleSynchronizeState(M){this.logger.info("updating state from remote");const V=M.payload.snapshot;this.snapshotManager.apply(V),this.transport.dispatchEvent(t2(M.executionId)),this.synchronized.resolve()}handleSynchronizeStateResult(M){this.logger.info("remote state updated");const[V]=this.remoteExecutionStorage.getExecutionHandlers(M.executionId);V()}handleSynchronizeStateRequest(M){this.logger.info("received request to update remote"),this.synchronize()}},Y1=(M,V,Y,ie,ye,_e=!1)=>({type:"remote-execute-by-ref",executionId:M,queued:_e,payload:{target:V,args:ie,context:Y,snapshot:ye}}),SD=({executionId:M},V,Y)=>({type:"remote-execute-result",executionId:M,payload:{result:V,snapshot:Y}}),Gc=({executionId:M},V,Y)=>({type:"remote-execute-result",executionId:M,payload:{error:V instanceof Error?V.message:V,snapshot:Y}}),Pg=class{constructor(M,V,Y,ie,ye,_e,Ue,et){this.logger=M,this.transport=V,this.remoteExecutionStorage=Y,this.snapshotManager=ie,this.payloadManager=ye,this.referenceManager=_e,this.referenceExtractor=Ue,this.statManager=et,this.executionTelemetry=new Map,this.transport.addEventListener("remote-execute-by-ref",nt=>{this.handleExecuteByRefRequest(nt)}),this.transport.addEventListener("remote-execute-result",nt=>{this.handleExecuteResult(nt)})}async executeByRef(M,V,Y){const[ie,ye]=this.remoteExecutionStorage.create(),_e=new Y7;this.executionTelemetry.set(ie,_e),this.logger.info(`[${ie}]: start execution by reference`);const Ue=this.referenceManager.saveRef(M),et=this.referenceManager.saveRef(V),nt=this.referenceManager.saveRef(Y);this.logger.info(`[${ie}]: creating event: target[${Ue}]="${M.name}"; args=[${et}]; context[${nt}];`),_e.startStep("ReferenceUpdate"),this.referenceExtractor.ingestRefs([M,V,Y]),_e.endStep("ReferenceUpdate"),_e.startStep("SnapshotCreated");const lt=this.snapshotManager.create();_e.endStep("SnapshotCreated"),this.logger.info(`[${ie}]: snapshot created`);const Ct=Y1(ie,Ue,nt,et,lt);_e.setRequestBody(Ct),this.transport.dispatchEvent(Ct);try{this.logger.info(`[${ie}]: waiting to be resolved`),_e.startStep("RemoteExecution");const zt=await ye;if(_e.endStep("RemoteExecution"),this.logger.info(`[${ie}]: remote execution resolved`),zt===void 0)return void this.logger.info(`[${ie}]: skip unpacking, as response is undefined`);_e.startStep("ReponseUnpack");const li=this.payloadManager.unpack(zt);return _e.endStep("ReponseUnpack"),this.logger.info(`[${ie}]: response unpacked`),li}catch(zt){if(_e.markFailed(),zt instanceof Error)throw this.logger.error(`[${ie}]: internal error:`,zt),zt;_e.startStep("ReponseUnpack");const li=this.payloadManager.unpack(zt);throw _e.endStep("ReponseUnpack"),this.logger.error(`[${ie}]: remote error:`,li),li}finally{queueMicrotask(()=>{this.statManager.registerStat(_e.getStat()),this.executionTelemetry.delete(ie)})}}async handleExecuteByRefRequest(M){const V=M.executionId,{target:Y,args:ie,context:ye,snapshot:_e}=M.payload;try{this.logger.info(`[${V}]: local execute start`),this.snapshotManager.apply(_e);const Ue=this.referenceManager.getRef(Y);if(!Ue)throw this.logger.error(`[${V}]: unknown local target[${Y}]`),new Error("Unknown execution target");const et=this.referenceManager.getRef(ye),nt=this.referenceManager.getRef(ie)??[];this.logger.info(`[${V}]: executing on local target[${Y}]="${Ue.name}" with context[${ye}] and arguments[${ie}]`);const lt=await Reflect.apply(Ue,et,nt);this.logger.info(`[${V}]: local result:`,lt),this.referenceExtractor.ingestRefs([nt,et,lt]),this.transport.dispatchEvent(SD(M,this.payloadManager.pack(lt),this.snapshotManager.create()))}catch(Ue){this.logger.error(`[${V}]: local failed with error:`,Ue),this.referenceExtractor.ingestRefs([Ue]),this.transport.dispatchEvent(Gc(M,this.payloadManager.pack(Ue),this.snapshotManager.create()))}}handleExecuteResult(M){const{executionId:V,payload:Y}=M;this.executionTelemetry.get(V)?.setResponseBody(Y);const ie=M.payload.snapshot;this.logger.info(`[${V}]: handling execution result`),this.snapshotManager.apply(ie);const[ye,_e]=this.remoteExecutionStorage.getExecutionHandlers(V);"error"in Y?_e(Y.error):ye(Y.result)}},Dg=class extends K7{constructor(){super(...arguments),this.type="map"}canMarshall(M){return M instanceof Map}createShellRef(){return new Map}marshallEntries(M){return Array.from(M.entries()).map(([V,Y])=>[this.referenceManager.toReferenced(V),this.referenceManager.toReferenced(Y)])}unmarshallEntries(M,V){M.clear();for(const[Y,ie]of V)M.set(this.referenceManager.fromReferenced(Y),this.referenceManager.fromReferenced(ie));return M}},jz=class extends K7{constructor(){super(...arguments),this.type="set"}canMarshall(M){return M instanceof Set}createShellRef(){return new Set}marshallEntries(M){return Array.from(M.values()).map(V=>this.referenceManager.toReferenced(V))}unmarshallEntries(M,V){M.clear();for(const Y of V)M.add(this.referenceManager.fromReferenced(Y));return M}},i2=class{constructor(M,V,Y){this.logger=M,this.referenceManager=V,this.payloadManager=Y}getReferences(){const M=[];for(const[V,Y]of this.referenceManager.getRefs()){const ie=Y.deref();ie!==void 0?this.referenceManager.isShellByRef(ie)||M.push([V,this.payloadManager.pack(ie)]):this.logger.warn("Reference garbage collected. refId=",V)}return M}applyReferences(M){for(const[V,Y]of M)this.referenceManager.saveRef(this.payloadManager.unpack(Y),V);for(const[V,Y]of M)this.referenceManager.saveRef(this.payloadManager.unpack(Y),V)}},n2=class extends i2{constructor(M,V,Y){super(M,V,Y),this.lastSentReferences=[],this.lastRecvReferences=[]}create(){this.logger.info("creating snapshot");const M=this.getReferences();if(!this.lastSentReferences.length){this.logger.info("no previous snapshot available, creating full snapshot"),this.lastSentReferences=M;const ye={"+":M};return this.logger.info("delta snapshot ready"),this.logger.debug(JSON.stringify(ye)),ye}this.logger.info("previous snapshot available, creating delta snapshot");const V=new Map(this.lastSentReferences),Y=new Map(M),ie={"-":[],"+":[],"*":[]};for(const ye of new Set([...V.keys(),...Y.keys()]))this.referenceManager.isShellByRefId(ye)||(!V.has(ye)||Y.has(ye)?V.has(ye)||!Y.has(ye)?V.has(ye)&&Y.has(ye)&&JSON.stringify(V.get(ye))!==JSON.stringify(Y.get(ye))&&ie["*"].push([ye,Y.get(ye)]):ie["+"].push([ye,Y.get(ye)]):ie["-"].push(ye));return this.logger.info("delta snapshot ready"),this.logger.debug(JSON.stringify(ie)),this.lastSentReferences=M,ie}apply(M){this.logger.info("applying snapshot"),this.logger.debug(JSON.stringify(M)),this.lastRecvReferences.length?this.logger.info("previous snapshot available, applying delta to it"):this.logger.info("no previous snapshot available, delta should contain full snapshot");const V=new Map(this.lastRecvReferences);for(const Y of M["-"]??[])this.referenceManager.removeByRefId(Y),V.delete(Y);for(const[Y,ie]of M["+"]??[])V.set(Y,ie);for(const[Y,ie]of M["*"]??[])V.set(Y,ie);this.lastRecvReferences=Array.from(V.entries()),this.logger.info("delta snapshot ready"),this.logger.debug(JSON.stringify(this.lastRecvReferences)),this.applyReferences(this.lastRecvReferences)}},Tee=class extends NR{constructor(M,V){super(),this.type=M,this.value=V}marshall(M){}unmarshall(){return this.value}canMarshall(M){return M===this.value}},Cee=M=>M[Symbol.toStringTag]==="BigInt64Array"||M[Symbol.toStringTag]==="BigUint64Array",Dn=class Rae extends W1{constructor(){super(...arguments),this.type="typedArray"}marshall(V){return this.ensureRefSaved(V),{refId:this.referenceManager.getRefId(V),type:V[Symbol.toStringTag],values:Cee(V)?Array.from(V).map(Y=>Y.toString()):Array.from(V),byteOffset:V.byteOffset,bufferType:V.buffer[Symbol.toStringTag],bufferByteLength:V.buffer.byteLength}}unmarshall(V){this.ensureRefExists(V);const Y=this.referenceManager.getRef(V.refId),ie=Cee(Y)?BigInt:Number;for(const[ye,_e]of V.values.entries())Y[ye]=ie(_e);return Y}createShellRef(V){if(!Rae.TYPED_ARRAY_CONSTRUCTOR.has(V.type))throw new Error(`Unknown typed array type: ${V.type}`);const Y=Rae.TYPED_ARRAY_CONSTRUCTOR.get(V.type);return V.bufferType==="SharedArrayBuffer"&&this.logger.error("SharedArrayBuffers are mostly disabled, consider using ArrayBuffer instead"),new Y(new ArrayBuffer(V.bufferByteLength),V.byteOffset)}canMarshall(V){if(typeof V!="object"||V===null)return!1;if(Symbol.toStringTag in V){const Y=V[Symbol.toStringTag];return typeof Y=="string"&&Rae.TYPED_ARRAY_CONSTRUCTOR.has(Y)}return!1}};Dn.TYPED_ARRAY_CONSTRUCTOR=new Map([["Int8Array",Int8Array],["Uint8Array",Uint8Array],["Uint8ClampedArray",Uint8ClampedArray],["Int16Array",Int16Array],["Uint16Array",Uint16Array],["Int32Array",Int32Array],["Uint32Array",Uint32Array],["Float32Array",Float32Array],["Float64Array",Float64Array],["BigInt64Array",BigInt64Array],["BigUint64Array",BigUint64Array]]);var tC=Dn,BR={allowedObjectNames:new WeakMap,deniedNames:new Set(["constructor","prototype","arguments","caller"]),deniedValues:new Set([globalThis,document,null]),deniedInstances:new Set([Boolean,Number,String,Date,RegExp,EventTarget,HTMLElement])},Z7=class{constructor(M,V,Y,ie=new e2){this.transport=M,this.logger=V,this.config=Y,this.uniqueIdFactory=ie,this.statManager=new ff,this.rpcTelemetryProvider=new J7(this.statManager),this.propertyCollectionConfig={...BR,...this.config?.propertyCollectionConfig},this.referenceManager=new bee(this.logger.createChild("ReferenceManager"),this.uniqueIdFactory,{disableWeakRefs:this.config?.disableWeakRefs}),this.referenceExtractor=new Mg(this.logger.createChild("ReferenceExtractor"),this.referenceManager,this.propertyCollectionConfig,this.config?.worldRootRef),this.payloadManager=new See([new xR,new Tee("globalThis",globalThis),new Tee("document",document),new Dg(this.logger.createChild("MapMarshaller"),this.referenceManager),new jz(this.logger.createChild("SetMarshaller"),this.referenceManager),new K1(this.logger.createChild("ArrayMarshaller"),this.referenceManager),new tC(this.logger.createChild("TypedArrayMarshaller"),this.referenceManager),new dve(this.logger.createChild("FunctionMarshaller"),this.referenceManager,(ye,_e,Ue)=>this.executeByRef(ye,_e,Ue)),new z0(this.logger.createChild("ObjectMarshaller"),this.referenceManager,this.propertyCollectionConfig)]),this.snapshotManager=new n2(this.logger.createChild("SnapshotManager"),this.referenceManager,this.payloadManager),this.remoteExecutionStorage=new W7(this.logger.createChild("RemoteExecutionStorage"),this.uniqueIdFactory,{...eC,timeout:this.config?.remoteExecutionTimeout??eC.timeout}),this.remoteExecutionService=new Pg(this.logger.createChild("RemoteExecutionService"),this.transport,this.remoteExecutionStorage,this.snapshotManager,this.payloadManager,this.referenceManager,this.referenceExtractor,this.statManager),this.synchronizer=new Q7(this.logger.createChild("StateSynchronizer"),this.transport,this.remoteExecutionStorage,this.snapshotManager,this.referenceExtractor)}get telemetryProvider(){return this.rpcTelemetryProvider}waitForSynchronization(){return this.synchronizer.waitForSynchronization()}synchronize(...M){return this.synchronizer.synchronize(M)}setRequestTimeout(M){this.remoteExecutionStorage.setTimeout(M)}getPropertyCollectionConfig(){return this.propertyCollectionConfig}saveRef(M,V){return this.referenceManager.saveRef(V,M),V}shellify(M){if(typeof M=="object"){this.referenceManager.saveShellRef(M);for(const[V,Y]of Nh(M,this.getPropertyCollectionConfig()))typeof Y.value=="function"&&(Reflect.defineProperty(M,V,{value:new Proxy(Y.value,{apply:(ie,ye,_e)=>this.executeByRef(Reflect.get(M,V),_e,ye)})}),this.referenceManager.saveShellRef(Reflect.get(M,V))),Y.get;return M}if(typeof M=="function"){const V=new Proxy(M,{apply:(Y,ie,ye)=>this.executeByRef(V,ye,ie)});return V}throw new Error("Unsupported type")}async executeByRef(M,V,Y){return this.remoteExecutionService.executeByRef(M,V,Y)}dispose(){this.logger.info("Disposing RPCService"),this.remoteExecutionStorage.dispose(),this.referenceManager.dispose(),this.statManager.clear()}},wc=class extends cve{constructor(){super(...arguments),this.namespace="Shell"}getReport(){const M=this.metricsMap.get("TimeToEstablishConnection")?.getReport();return{NameSpace:this.namespace,SessionId:this.id,TsCallingVersion:this.tsCallingVersion,Session_StartTime:this.startTime,EstablishConnection_StartTime:M?.startTime,EstablishConnection_Duration:M?.duration,...this.getRpcTelemetry(),...this.getTransportTelemetry()}}getReportForRealTime(){return{NameSpace:this.namespace,...this.getRpcTelemetry(),...this.getTransportTelemetry()}}},xa=Hv,FR=dn,_ee=class xQe{constructor(V,Y,ie=""){this.ulLogComponent=V,this.ulSafeComponent=Y,this._getPrefix=(0,FR.isFunction)(ie)?ie:()=>ie,this.logComponent=xa.LogFactory.instance().component(this.ulLogComponent),xa.LogFactory.instance().declareComponentSafe(this.ulLogComponent,Y)}createChild(V){const Y=(0,FR.isFunction)(V)?V:()=>V;return new xQe(this.ulLogComponent,this.ulSafeComponent,()=>this._getPrefix()?`${this._getPrefix()}/${Y()}`:Y())}log(...V){this._apply(Y=>this.logComponent.debug2(null,Y),V)}debug(...V){this._apply(Y=>this.logComponent.debug4(null,Y),V)}info(...V){this._apply(Y=>this.logComponent.debug1(null,Y),V)}warn(...V){this._apply(Y=>this.logComponent.warn(null,Y),V)}error(...V){this._apply(Y=>this.logComponent.error(null,Y),V)}_apply(V,Y=[]){this._addPrefix(Y),V(Y.map(ie=>ie instanceof DOMException?ie.toString():ie).map(ie=>(0,FR.isObject)(ie)?JSON.stringify(ie):ie).join(", "))}_addPrefix(V){if(V&&V[0]){const Y=`${this._getPrefix()} ${V[0]}`;V[0]=Y}}};function Cv(){return"2025.07.01.32"}function X7(){return"1c7a031acaef8e0a65d66c2b89797f8a96375b44"}var bD=w(F()),Q1=class{constructor(){this.fallbackLogger=new _ee("RemoteStackFactory",!0),this.telemetry=new Vz(this.logger),this.healthCheck=H1}async build(M){return this.callingLogger??(this.callingLogger=M.logger.createChild("RemoteStackFactory")),this.remoteStackFactory??(this.remoteStackFactory=await this.getFactory(M.vdi3Config)),this.remoteStackFactory.build(this.getRemoteStackConfig(M))}async buildBaseStack(M){return this.callingLogger??(this.callingLogger=M.logger.createChild("RemoteStackFactory")),this.remoteStackFactory??(this.remoteStackFactory=await this.getFactory(M.vdi3Config)),this.remoteStackFactory.buildBaseStack(this.getRemoteBaseStackConfig(M))}getVersion(){return{build:Cv(),ovb:X7()}}async getFactory(M){const{transport:V,telemetryConfig:Y,pluginlessUrl:ie,cdnUrl:ye}=M;if(!V)throw new Error("transport is required for remote stack");const _e=ni(),Ue=this.logger.createChild(`Channel:${_e}`);this.transportManager??(this.transportManager=new yn(V,this.logger.createChild("TransportManager"))),this.healthCheck.addTransportManager(this.transportManager),this.transportManager.on("connectionTerminated",()=>{Ue.log("Connection terminated, disposing."),this.dispose()}),this.healthCheck.setChannel(_e),Y&&this.telemetry.setConfig(Y.tenantToken,Y.onedsCollectorURL,Y.eventsLimitInMem,Y.realTimeTelemetryInterval);const et=new wc(_e,Ue.createChild("Telemetry"),()=>this.rpcSession?.telemetryProvider.getReport(),()=>this.transportManager?.telemetryProvider.getReport());this.telemetry.addSession(et);const nt={tsCallingVersion:this.getVersion().build,channelId:_e,pluginlessUrl:ie,cdnUrl:ye,telemetryConfig:Y};Ue.log(`Initiating connection with payload: ${JSON.stringify(nt)}`),et.startTimer("TimeToEstablishConnection"),await this.transportManager.initiateConnection(nt),et.stopTimer("TimeToEstablishConnection");const lt=new Z7(this.transportManager.createChannel(_e),Ue.createChild("RPCService"),{remoteExecutionTimeout:V.config?.remoteExecutionTimeout,disableWeakRefs:!0});this.rpcSession=lt,M.shellTrouter&&lt.saveRef("shell-trouter",j1(lt,M.shellTrouter)),lt.saveRef("remote-telemetry-provider",{getReport:async zt=>({transport:this.transportManager.telemetryProvider.getReport(zt),rpc:lt.telemetryProvider.getReport(zt)})});const Ct=lt.saveRef("pluginless-stack",j1(lt,{build:zt=>{throw new Error("Should be executed rmotely")},buildBaseStack:zt=>{throw new Error("Should be executed rmotely")}}));return await lt.waitForSynchronization(),this.telemetry.sendTelemetry(_e),this.telemetry.startRealtimeTelemetry(),Ct}getRemoteStackConfig(M){const V=M.logger,{vdi3Config:{trouterSettings:Y},stackType:ie,...ye}=M;if(!Y)throw new Error("Trouter setting is required for remoteStack");const _e=(0,bD.default)(ye);this.removeHttpDispatcher(_e),this.removeLogger(_e),this.removeTrouterService(_e),this.sanitizeTelemetryConfig(_e.telemetryService,V),this.removeEffectConfigProvider(_e.mediaAgentFactoryConfig);const Ue={..._e,trouterSettings:Y};return V.log(`RemoteStackConfig: ${JSON.stringify(Ue)}`),Ue}getRemoteBaseStackConfig(M){const V=M.logger,{vdi3Config:Y,stackType:ie,...ye}=M,_e=(0,bD.default)(ye);return this.removeHttpDispatcher(_e),this.removeLogger(_e),this.sanitizeTelemetryConfig(_e.telemetryService,V),V.log(`baseStackConfig: ${JSON.stringify(_e)}`),_e}sanitizeTelemetryConfig(M,V){M.getCallingAdapter&&(delete M.getCallingAdapter,V.warn("getCallingAdapter not supported")),M.getGenericTelemetryLogger&&(delete M.getGenericTelemetryLogger,V.warn("getGenericTelemetryLogger not supported"))}removeLogger(M){delete M.logger;const V=M;delete V.signalingAgentConfig?.logger,delete V.mediaAgentFactoryConfig?.logger,delete V.mediaAgentFactoryConfig?.safeLogger,delete V.imageRendererConfig?.callingLogger}removeHttpDispatcher(M){delete M.imageRendererConfig?.httpRequestDispatcher;const V=M;delete V.signalingAgentConfig?.httpRequestDispatcher,delete V.mediaAgentFactoryConfig?.httpRequestDispatcher}removeTrouterService(M){delete M.trouterService,delete M.signalingAgentConfig.trouterServiceProvider}removeEffectConfigProvider(M){delete M.wasmVqeProvider,delete M.webcvProvider,delete M.createWasmWorkerCbs}dispose(){this.logger.info("Dispose: RemoteStackFactory, TransportManager and RPCSessions"),this.telemetry?.sendLastGatheredTelemetry(),this.telemetry?.stopRealtimeTelemetry(),this.telemetry?.clear(),this.rpcSession.dispose(),this.transportManager?.dispose(),this.remoteStackFactory=null,this.transportManager=null}get logger(){return this.callingLogger??this.fallbackLogger}},eG=w(x()),Eee=new class{constructor(){this.remotedPluginlessStackFactory=new Q1}async build(M){return this.getStackFactory(M.stackType).build(M)}async buildBaseStack(M){return this.getStackFactory(M.stackType).buildBaseStack(M)}getStackFactory(M){return M===1?this.remotedPluginlessStackFactory:eG.pluginlessStackFactory}getVersion(){return eG.pluginlessStackFactory.getVersion()}},V0=class{async state(){throw new Error("Should be executed remotely")}async onStateChanged(M){throw new Error("Should be executed remotely")}async offStateChanged(M){throw new Error("Should be executed remotely")}async getTrouterUrlAsync(){throw new Error("Should be executed remotely")}},LS=w(ht()),Aee=8;function Gz(){const M="abcdef0123456789",V=M.length;let Y="";for(let ie=0;ie<Aee;ie++)Y+=M.charAt(Math.floor(Math.random()*V));return Y}var qz=Hv,tG=["id"," orgid","username","phonenumber"];function Wz(M){return typeof M=="string"?qz.pii.Mri(M):qz.pii.Omit(M)}function Iee(M,V=["id"],Y={threadId:8}){if(!M||typeof M!="object")return M;try{let ie=iG(M);return ie=Z1(ie,V,Y),ie}catch{return{error:"failed to scrub object fields"}}}function F8e(M){try{const V={};return Object.keys(M).forEach(Y=>{const ie=Wz(Y);V[ie]=M[Y]}),V}catch{return{error:"failed to scrub mri keys"}}}function iG(M){if(!M||typeof M!="object")return M;const V=new Set,Y=JSON.stringify(M,(ie,ye)=>{if(typeof ye=="object"&&ye!==null){if(V.has(ye))return;V.add(ye)}return ye});return JSON.parse(Y)}function Z1(M,V,Y){if(!M||typeof M!="object")return M;const ie={...M};for(const[ye,_e]of Object.entries(M))Array.isArray(_e)?ie[ye]=_e.map(Ue=>Z1(Ue,V,Y)):typeof _e=="object"?ie[ye]=Z1(_e,V,Y):ye.toLowerCase()==="displayname"?ie[ye]="<redacted>":_e&&(V.includes(ye)||tG.includes(ye.toLowerCase())?ie[ye]=Wz(_e):Y[ye]&&typeof _e=="string"&&(ie[ye]=_e.toString().substring(0,Y[ye])));return ie}var a2=w(dn),wee=["response","responseText","responseURL","status","state","statusText","timeout","withCredentials","stack","message","name","error","piiSafe","phase","code","participantId","phrase","subCode","reason","conversationType","terminatedReason","terminatedReasonCode","terminatedReasonSubCode","errorMessage"],kee=M=>{try{return M.split(`
`)[0]}catch{return"invalid stack"}};function nG(M,V=!1){if(M==null)return"void";if(M instanceof Error||M instanceof String||M instanceof Number||M instanceof Boolean)return M.toString();try{return M.stack&&(M.stack=kee(M.stack)),(V?JSON.stringify(M):JSON.stringify(M,wee,4)).replace(/(\r\n\t|\n|\r\t|\s)/gm,"")}catch{return`failed to get error information:${M&&typeof M.toString=="function"&&M.toString()} ${M?.response&&JSON.stringify(M.response)}`}}function aG(M){try{return JSON.stringify(M,null,2)}catch{return`failed to stringify obj ${M}`}}function r2(M){try{let V=Iee(M,["id","groupCallInitiator","organizerId"]);return TD(V,"response.roster.participants"),TD(V,"response.additionalActionResponses.0.output.roster.participants"),TD(V,"response.muteUnmuteResponse"),V=a2.omit(V,["meetingChatProperties"]),V=Kz(V),V}catch{return"failed to return safe response"}}function rG(M){try{return Kz(Iee(M))}catch{return"failed to return safe request"}}function Kz(M){if(M?.config?.data){let V=M.config.data;V=JSON.parse(V),V=Iee(V),M.config.data=aG(V)}return aG(M)}function TD(M,V){M&&a2.get(M,V)&&a2.set(M,V,F8e(a2.get(M,V)))}var oG=class{constructor(M){M&&typeof M.createChild=="function"?this.logger=M.createChild("RequestDispatcher"):this.logger=new _ee("JS.TsCalling.RequestDispatcher",!1)}getRequestOptions(M,V,Y,ie,ye){return{headers:V||{},timeout:ie,payload:Y||null,responseType:ye}}getAsync(M,V){return this.sendRequest(M,V,"GET")}postAsync(M,V){return this.sendRequest(M,V,"POST")}putAsync(M,V){return this.sendRequest(M,V,"PUT")}removeAsync(M,V){return this.sendRequest(M,V,"DELETE")}async sendRequest(M,V={headers:{}},Y){return V.useFetch?this.sendFetchRequest(M,V,Y):this.sendAxiosRequest(M,V,Y)}async sendAxiosRequest(M,V={headers:{}},Y){const ie=this.logger.createChild(`[${V.causeId||Gz()}][AxiosRequest]`);ie.info(`sending, ${Y}-${M}`);const ye=Date.now();let _e;X1(V);try{const Ue=LS.default.request({url:M,method:Y,headers:V.headers,timeout:typeof V.timeout=="number"?V.timeout:45e3,data:V.payload||"",responseType:V.responseType||V.dataType||"json",withCredentials:Jz(V.withCredentials,!1),cancelToken:new LS.default.CancelToken(nt=>{_e=nt})});Nt(V.timeout)&&V.timeout.then(()=>{ie.info("Aborting pending request"),_e()},()=>{ie.info("Timeout promise rejected, ignoring")});const et=await Ue;return ie.info(`success, status=${et.status}`),{response:et.data,request:{status:et.status,statusText:et.statusText,headers:et.headers,responseURL:et.request.responseURL,readyState:et.request.readyState,response:et.request.response,responseText:et.request.responseType===""||et.request.responseType==="text"?et.request.responseText:"",withCredentials:et.request.withCredentials},duration:Date.now()-ye}}catch(Ue){throw ie.info("failed"),LS.default.isCancel(Ue)?(ie.info(`response=${r2(Ue.message)}`),{aborted:!0}):(Ue.response?ie.info(`response=${r2(Ue.response)}`):Ue.request?ie.info(`no response, request=${rG(Ue.request)}`):ie.info(`request not made, error=${nG(Ue)}`),Ue||new Error("Request failed"))}}async sendFetchRequest(M,V={headers:{}},Y){const ie=this.logger.createChild(`[${V.causeId||Gz()}][FetchRequest]`);ie.info(`sending, ${Y}-${M}`);const ye=Date.now(),_e=new AbortController;let Ue,et=null,nt=null;const lt=()=>{ie.info("Aborting pending request"),_e.abort()};X1(V);try{if(V.fetchUseKeepAlive&&V.payload?.toString().length>65e3&&ie.warn("Using fetch with keep alive with more than 64kib data"),ie.info(`${JSON.stringify(V.headers)}`),et=fetch(M,{method:Y,headers:V.headers,body:V.payload,credentials:V.withCredentials?"include":"same-origin",signal:_e.signal,keepalive:V.fetchUseKeepAlive}),Nt(V.timeout))V.timeout.then(()=>{lt()},()=>{ie.info("Timeout promise rejected, ignoring")});else if(V.timeout){const zt=setTimeout(()=>lt(),V.timeout);et=et.finally(()=>clearTimeout(zt))}nt=await et;try{Ue=await nt.json()}catch(zt){ie.info(`unable to parse response as json with error ${zt}`)}const Ct={response:Ue,request:{status:nt.status,statusText:nt.statusText,headers:Object.fromEntries(nt.headers.entries()),responseURL:nt.url,response:Ue,withCredentials:V.withCredentials},duration:Date.now()-ye};if(!nt.ok)throw ie.info(`failed response, status=${nt.status}`),Ct;return ie.info(`success, status=${nt.status}`),Ct}catch(Ct){throw ie.info(`failed error=${nG(Ct)}`),Ct.name==="AbortError"?{aborted:!0}:Ct||new Error("Request failed")}}};function Jz(M,V){return M!==void 0?M:V}function X1(M){M.headers=M.headers||{},M.headers["content-type"]||(M.headers["content-type"]=M.contentType||"application/json")}var Yz=(M,V)=>Ht("TsCallingChannel",V,M);if(typeof d.exports=="object"&&typeof l=="object"){var Qz=(M,V,Y,ie)=>{if(V&&typeof V=="object"||typeof V=="function")for(let ye of Object.getOwnPropertyNames(V))Object.prototype.hasOwnProperty.call(M,ye)||ye===Y||Object.defineProperty(M,ye,{get:()=>V[ye],enumerable:!(ie=Object.getOwnPropertyDescriptor(V,ye))||ie.enumerable});return M};d.exports=Qz(d.exports,l)}return d.exports})});class k3e{constructor(e,i,r){this.setConfigOrDefault=(d,h)=>{d&&Object.keys(d).forEach(p=>{d[p]!==void 0&&(h[p]=d[p])})},this._logger=e,this.sdkDiagnosticInformation=i,this._acsProxy=r;const o=wt().calling.applicationSettingsUrls;this._trouterSettings={version:`${T3()}/${E3()}`,productName:"AcsWeb",trouterServiceUrl:o.Public_TrouterServiceUrl,registrarServiceUrl:o.Public_RegistrarServiceUrl,maxRegistrationTimeInMs:36e5,pnhAppId:"AcsWeb",pnhTemplate:"AcsWeb_2.0",environment:"Prod",platform:U5e()},this._JsCsaConfig={languageCode:"en",emergencyCallCountry:"",autoResolveConflictedCall:!1,handleRosterFromCreateAndJoin:!0,conversationServiceUrl:r.proxyfyUrl(o.Public_ConversationServiceUrl),useInternalHttpDispatcher:!0,supportsHostlessGroupCalls:!0,doHostlessCalling:!0,shouldServiceSendCallEventMessages:!0,shouldServiceSendNGCUpgradeMessages:!0,supportsCompressedServicePayload:!0,handleNewOfferRequest:!0,handleMediaOfferFromPushNotification:!0,isWebRtcEnabled:!0,supportsSynchronousTrouterResponse:!0,autoJoinOnConflict:!0,brokerEnabledOutgoing:!0,brokerEnabledIncoming:!0,brokerExclusively:!1,brokerRequestBatching:!0,isGVCOutgoingEnabled:!0,isGVCJoiningEnabled:!0,enableTokenCache:!1},this._JamaSettingsMobile={webrtcCameraOpenFs:900,webrtcMultipartyMaxScalingFs:900,webrtcMaxScalingFs:900},this._JamaSettings={debug:!1,numVideoChannelsGvc:6,webcv:null,maxNumberOfPinnedVideos:2},this._MDNTrapSettings={Service:{url:r.proxyfyUrl(o.Public_MdnTrapServiceUrl),tokenUrl:r.proxyfyUrl(o.Public_MdnTrapServiceTokenUrl)},Relay:{Skype:{addresses:[],fqdns:[o.Public_MdnTrapRelaySkypeFqdns],tcpPort:443,udpPort:3478},Turn:{addresses:[],fqdns:[o.Public_MdnTrapRelayTurnFqdns],tcpPort:443,udpPort:3478,url:o.Public_MdnTrapRelayTurnUrl}},Http:{connectionTimeout:30,requestTimeout:60},Token:{earlyRefreshMinutes:1080,earlyRefreshPercentage:25}},this._TrouterJScriptClient={TelemetryEnabled:!1,ClientTelemetryEventEnabled:{trouter_js_client_connected:!1,trouter_js_client_disconnected:!1,trouter_js_client_error:!1,trouter_js_client_progress:!1,trouter_js_client_response:!1,trouter_js_client_check_connection:!1,trouter_js_client_registration:!1,trouter_js_client_unregistration:!1,logHealthCheckError:!1,logSendPingError:!1,numberOfStepsToMaintain:0,sendProgressTimeoutSecs:0}};const l=E3();l.includes("alpha")||l.includes("alpharc")||l.includes("beta")||l.includes("betarc")||(l.includes("stable")||l.includes("stablerc"))&&(this._JamaSettings.maxNumberOfPinnedVideos=1)}getTrouterTelemetryConfig(){return{enabled:this._TrouterJScriptClient.TelemetryEnabled,...this._TrouterJScriptClient.ClientTelemetryEventEnabled}}getJamaSettings(){const e=$A();let i=this._JamaSettings;return e.formFactor=="Mobile"&&(i={...i,...this._JamaSettingsMobile}),i}getClientInformation(){const e=wt().telemetry.reportSdkUaToService,i=wt().telemetry.reportEnvToService;return`ACSWeb(${T3()}/${E3()})`+(i?`/${pVt()}`:"")+(e?`/(${this.sdkDiagnosticInformation})`:"")}getJsCsaConfig(){return this._JsCsaConfig.useInternalHttpDispatcher=!(this._acsProxy.hasProxyUrl()||wt().telemetry.sendNetworkInfo),{...this._JsCsaConfig,clientInformation:this.getClientInformation()}}getMdnTrapSettings(){return this._MDNTrapSettings}getTrouterSettings(){return this._trouterSettings}setConfig(e,i){this._logger.info("Update ECS settings");const r=wt().calling.applicationSettingsUrls,o=wt().calling.applicationSettingsEudbUrls,l=e&&u6(e.identityType,e.region);if(e?.identityType==gT.Enterprise)l?(this._trouterSettings.trouterServiceUrl=o.Enterprise_TrouterServiceUrl_EUDB,this._trouterSettings.registrarServiceUrl=this._acsProxy.proxyfyUrl(o.Enterprise_RegistrarServiceUrl_EUDB)):(this._trouterSettings.trouterServiceUrl=r.Enterprise_TrouterServiceUrl,this._trouterSettings.registrarServiceUrl=this._acsProxy.proxyfyUrl(r.Enterprise_RegistrarServiceUrl));else switch(e?.cloudType){case pl.Public:l&&(this._trouterSettings.trouterServiceUrl=o.Public_TrouterServiceUrl_EUDB,this._trouterSettings.registrarServiceUrl=this._acsProxy.proxyfyUrl(o.Public_RegistrarServiceUrl_EUDB),this._JsCsaConfig.conversationServiceUrl=this._acsProxy.proxyfyUrl(o.Public_ConversationServiceUrl_EUDB),this._MDNTrapSettings.Service.url=this._acsProxy.proxyfyUrl(o.Public_MdnTrapServiceUrl_EUDB),this._MDNTrapSettings.Service.tokenUrl=this._acsProxy.proxyfyUrl(o.Public_MdnTrapServiceTokenUrl_EUDB),this._MDNTrapSettings.Relay.Skype.fqdns=[o.Public_MdnTrapRelaySkypeFqdns_EUDB],this._MDNTrapSettings.Relay.Turn.fqdns=[o.Public_MdnTrapRelayTurnFqdns_EUDB],this._MDNTrapSettings.Relay.Turn.url=o.Public_MdnTrapRelayTurnUrl_EUDB);break;case pl.GccHigh:this._trouterSettings.trouterServiceUrl=r.GccHigh_TrouterServiceUrl,this._trouterSettings.registrarServiceUrl=this._acsProxy.proxyfyUrl(r.GccHigh_RegistrarServiceUrl);break;case pl.Dod:this._trouterSettings.trouterServiceUrl=r.Dod_TrouterServiceUrl,this._trouterSettings.registrarServiceUrl=this._acsProxy.proxyfyUrl(r.Dod_RegistrarServiceUrl);break;case pl.AirGap08:this._trouterSettings.trouterServiceUrl=r.AirGap08_TrouterServiceUrl,this._trouterSettings.registrarServiceUrl=this._acsProxy.proxyfyUrl(r.AirGap08_RegistrarServiceUrl);break;case pl.AirGap09:this._trouterSettings.trouterServiceUrl=r.AirGap09_TrouterServiceUrl,this._trouterSettings.registrarServiceUrl=this._acsProxy.proxyfyUrl(r.AirGap09_RegistrarServiceUrl)}if(i)this.setConfigOrDefault(i?.SkypeCalling,this._JsCsaConfig),this.setConfigOrDefault(i?.MDN_TRAP,this._MDNTrapSettings),this.setConfigOrDefault(i?.SkypeWebMedia?.mediaAgent,this._JamaSettings),this.setConfigOrDefault(i?.TrouterJScriptClient,this._TrouterJScriptClient);else if(e?.identityType===gT.Enterprise)l?(this._JsCsaConfig.conversationServiceUrl=this._acsProxy.proxyfyUrl(o.Enterprise_ConversationServiceUrl_EUDB),this._MDNTrapSettings.Service.url=this._acsProxy.proxyfyUrl(o.Enterprise_MdnTrapServiceUrl_EUDB),this._MDNTrapSettings.Service.tokenUrl=this._acsProxy.proxyfyUrl(o.Enterprise_MdnTrapServiceTokenUrl_EUDB),this._MDNTrapSettings.Relay.Skype.fqdns=[o.Enterprise_MdnTrapRelaySkypeFqdns_EUDB],this._MDNTrapSettings.Relay.Turn.fqdns=[o.Enterprise_MdnTrapRelayTurnFqdns_EUDB],this._MDNTrapSettings.Relay.Turn.url=o.Enterprise_MdnTrapRelayTurnUrl_EUDB):(this._JsCsaConfig.conversationServiceUrl=this._acsProxy.proxyfyUrl(r.Enterprise_ConversationServiceUrl),this._MDNTrapSettings.Service.url=this._acsProxy.proxyfyUrl(r.Enterprise_MdnTrapServiceUrl),this._MDNTrapSettings.Service.tokenUrl=this._acsProxy.proxyfyUrl(r.Enterprise_MdnTrapServiceTokenUrl),this._MDNTrapSettings.Relay.Skype.fqdns=[r.Enterprise_MdnTrapRelaySkypeFqdns],this._MDNTrapSettings.Relay.Turn.fqdns=[r.Enterprise_MdnTrapRelayTurnFqdns],this._MDNTrapSettings.Relay.Turn.url=r.Enterprise_MdnTrapRelayTurnUrl);else switch(e?.cloudType){case pl.Public:l&&(this._trouterSettings.trouterServiceUrl=o.Public_TrouterServiceUrl_EUDB,this._trouterSettings.registrarServiceUrl=this._acsProxy.proxyfyUrl(o.Public_RegistrarServiceUrl_EUDB),this._JsCsaConfig.conversationServiceUrl=this._acsProxy.proxyfyUrl(o.Public_ConversationServiceUrl_EUDB),this._MDNTrapSettings.Service.url=this._acsProxy.proxyfyUrl(o.Public_MdnTrapServiceUrl_EUDB),this._MDNTrapSettings.Service.tokenUrl=this._acsProxy.proxyfyUrl(o.Public_MdnTrapServiceTokenUrl_EUDB),this._MDNTrapSettings.Relay.Skype.fqdns=[o.Public_MdnTrapRelaySkypeFqdns_EUDB],this._MDNTrapSettings.Relay.Turn.fqdns=[o.Public_MdnTrapRelayTurnFqdns_EUDB],this._MDNTrapSettings.Relay.Turn.url=o.Public_MdnTrapRelayTurnUrl_EUDB);break;case pl.GccHigh:this._JsCsaConfig.conversationServiceUrl=this._acsProxy.proxyfyUrl(r.GccHigh_ConversationServiceUrl),this._MDNTrapSettings.Service.url=this._acsProxy.proxyfyUrl(r.GccHigh_MdnTrapServiceUrl),this._MDNTrapSettings.Service.tokenUrl=this._acsProxy.proxyfyUrl(r.GccHigh_MdnTrapServiceTokenUrl),this._MDNTrapSettings.Relay.Skype.fqdns=[r.GccHigh_MdnTrapRelaySkypeFqdns],this._MDNTrapSettings.Relay.Turn.fqdns=[r.GccHigh_MdnTrapRelayTurnFqdns],this._MDNTrapSettings.Relay.Turn.url=r.GccHigh_MdnTrapRelayTurnUrl;break;case pl.Dod:this._JsCsaConfig.conversationServiceUrl=this._acsProxy.proxyfyUrl(r.Dod_ConversationServiceUrl),this._MDNTrapSettings.Service.url=this._acsProxy.proxyfyUrl(r.Dod_MdnTrapServiceUrl),this._MDNTrapSettings.Service.tokenUrl=this._acsProxy.proxyfyUrl(r.Dod_MdnTrapServiceTokenUrl),this._MDNTrapSettings.Relay.Skype.fqdns=[r.Dod_MdnTrapRelaySkypeFqdns],this._MDNTrapSettings.Relay.Turn.fqdns=[r.Dod_MdnTrapRelayTurnFqdns],this._MDNTrapSettings.Relay.Turn.url=r.Dod_MdnTrapRelayTurnUrl;break;case pl.AirGap08:this._JsCsaConfig.conversationServiceUrl=this._acsProxy.proxyfyUrl(r.AirGap08_ConversationServiceUrl);break;case pl.AirGap09:this._JsCsaConfig.conversationServiceUrl=this._acsProxy.proxyfyUrl(r.AirGap09_ConversationServiceUrl)}}assertConfigs(e){const i="SkypeCalling",r="MDN_TRAP",o="SkypeWebMedia",l="SkypeWebMedia.mediaAgent",d="TrouterJScriptClient";let h=[];if(e?.SkypeCalling||h.push(i),e?.MDN_TRAP||h.push(r),e?.SkypeWebMedia?e?.SkypeWebMedia?.mediaAgent||h.push(l):h.push(o),e?.TrouterJScriptClient||h.push(d),h.length>0){const p=new Oe({defaultError:we.CALL_STACK.FOUND_UNDEFINED_CONFIGS,defaultErrorMessageArgs:[h.join(", ")]});throw this._logger.error(p.message),p}}}var nHt=bs(function(t,e){var i;i=()=>{return r={659:(l,d)=>{Object.defineProperty(d,"__esModule",{value:!0}),d.Timespan=d.toJson=d.fetchWithTimeout=void 0,d.fetchWithTimeout=function(p,g){var f,y=new Promise(function(C,E){fetch(p).then(function(I){f!==void 0&&clearTimeout(f),C(I)}).catch(function(I){f!==void 0&&clearTimeout(f),E(I)})});if(g!==0){var T=new Promise(function(C,E){f=setTimeout(E,g,new Error("Fetch for '".concat(p.url,"' timed out")))});return Promise.race([y,T])}return y},d.toJson=function(p){try{return JSON.stringify(p)}catch{return"Unable to serialize object of type ".concat(typeof p)}};var h=function(){function p(){this.start=Date.now()}return Object.defineProperty(p.prototype,"duration",{get:function(){return Date.now()-this.start},enumerable:!1,configurable:!0}),Object.defineProperty(p.prototype,"startTime",{get:function(){return this.start},enumerable:!1,configurable:!0}),p.prototype.reset=function(){this.start=Date.now()},p}();d.Timespan=h},912:function(l,d,h){var p,g=this&&this.__extends||(p=function(F,x){return p=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(B,L){B.__proto__=L}||function(B,L){for(var z in L)Object.prototype.hasOwnProperty.call(L,z)&&(B[z]=L[z])},p(F,x)},function(F,x){if(typeof x!="function"&&x!==null)throw new TypeError("Class extends value "+String(x)+" is not a constructor or null");function B(){this.constructor=F}p(F,x),F.prototype=x===null?Object.create(x):(B.prototype=x.prototype,new B)}),f=this&&this.__assign||function(){return f=Object.assign||function(F){for(var x,B=1,L=arguments.length;B<L;B++)for(var z in x=arguments[B])Object.prototype.hasOwnProperty.call(x,z)&&(F[z]=x[z]);return F},f.apply(this,arguments)},y=this&&this.__awaiter||function(F,x,B,L){return new(B||(B=Promise))(function(z,H){function j(re){try{Z(L.next(re))}catch(ne){H(ne)}}function J(re){try{Z(L.throw(re))}catch(ne){H(ne)}}function Z(re){var ne;re.done?z(re.value):(ne=re.value,ne instanceof B?ne:new B(function(le){le(ne)})).then(j,J)}Z((L=L.apply(F,x||[])).next())})},T=this&&this.__generator||function(F,x){var B,L,z,H,j={label:0,sent:function(){if(1&z[0])throw z[1];return z[1]},trys:[],ops:[]};return H={next:J(0),throw:J(1),return:J(2)},typeof Symbol=="function"&&(H[Symbol.iterator]=function(){return this}),H;function J(Z){return function(re){return function(ne){if(B)throw new TypeError("Generator is already executing.");for(;H&&(H=0,ne[0]&&(j=0)),j;)try{if(B=1,L&&(z=2&ne[0]?L.return:ne[0]?L.throw||((z=L.return)&&z.call(L),0):L.next)&&!(z=z.call(L,ne[1])).done)return z;switch(L=0,z&&(ne=[2&ne[0],z.value]),ne[0]){case 0:case 1:z=ne;break;case 4:return j.label++,{value:ne[1],done:!1};case 5:j.label++,L=ne[1],ne=[0];continue;case 7:ne=j.ops.pop(),j.trys.pop();continue;default:if(!((z=(z=j.trys).length>0&&z[z.length-1])||ne[0]!==6&&ne[0]!==2)){j=0;continue}if(ne[0]===3&&(!z||ne[1]>z[0]&&ne[1]<z[3])){j.label=ne[1];break}if(ne[0]===6&&j.label<z[1]){j.label=z[1],z=ne;break}if(z&&j.label<z[2]){j.label=z[2],j.ops.push(ne);break}z[2]&&j.ops.pop(),j.trys.pop();continue}ne=x.call(F,j)}catch(le){ne=[6,le],L=0}finally{B=z=0}if(5&ne[0])throw ne[1];return{value:ne[0]?ne[1]:void 0,done:!0}}([Z,re])}}};Object.defineProperty(d,"__esModule",{value:!0}),d.createRegistrarClient=d.RegistrarClient=void 0;var C=h(659),E=["skype","aad","cae"],I=function(F){function x(B){var L=F.call(this,B)||this;return L.name="CancelationError",L}return g(x,F),x}(Error),w=function(){function F(x,B,L){this.logger=x,this.maxBackoffInMs=B,this.initialDelay=L,this.backoffCount=0,this.id=++F.idCounter}return F.prototype.delay=function(x){var B=this;if(this.timerHandle!==void 0)throw new Error("Retry sequence logical failure");if(this.backoffCount===-1)return new Promise(function(z,H){H(new I("Cancelled"))});var L=this.calculateNextBackoffMs();return this.backoffCount++,this.logger.info("[RegistrarClient] Backing off ".concat(x," for ").concat(L," milliseconds with ID ").concat(this.id)),new Promise(function(z,H){B.cancelFunc=H,B.timerHandle=setTimeout(function(){B.logger.info("[RegistrarClient] Back off for ".concat(x," with ID ").concat(B.id," complete")),B.timerHandle=void 0,z()},L)})},F.prototype.cancel=function(){this.timerHandle!==void 0&&(this.logger.debug("Resetting back off"),clearTimeout(this.timerHandle),this.cancelFunc!==void 0&&this.cancelFunc(new I("Cancelled"))),this.backoffCount=-1},F.prototype.calculateNextBackoffMs=function(){var x=1+.4*(Math.random()-.5),B=this.initialDelay*Math.pow(2,this.backoffCount)*x;return B=Math.round(B),Math.min(this.maxBackoffInMs,B)},F.idCounter=0,F}(),D=function(){function F(x,B,L){var z;this.logger=x,this.tokenProvider=B,this.options=L,this.DEFAULT_MAX_RETRIES_FOR_GET_TOKEN=15,this.DEFAULT_MAX_BACKOFF_TIME_IN_MS=3e5,this.backoffs={},this.maxBackOffTime=this.options.maxRetryDelayMs>0?this.options.maxRetryDelayMs:this.DEFAULT_MAX_BACKOFF_TIME_IN_MS,this.maxRetriesForGetToken=L.maxRetriesForGetToken===void 0||L.maxRetriesForGetToken===null?this.DEFAULT_MAX_RETRIES_FOR_GET_TOKEN:L.maxRetriesForGetToken,this.proxyUrlRewrite=(z=L.proxyUrlRewrite)!==null&&z!==void 0?z:function(H){return H}}return F.prototype.setTelemetryLogger=function(x){this.eventLogger=x},F.prototype.register=function(x,B){return y(this,void 0,void 0,function(){return T(this,function(L){switch(L.label){case 0:return[4,this.performRegistration(x,B,"pr_set_registration")];case 1:return L.sent(),this.cachedRegistrationParams=[x,B],[2]}})})},F.prototype.unregister=function(){return y(this,void 0,void 0,function(){var x;return T(this,function(B){switch(B.label){case 0:return this.logger.info("[RegistrarClient] sending unregister request"),x=new Request(this.proxyUrlRewrite("".concat(this.options.registrarUrl,"/").concat(this.options.registrationId)),{method:"DELETE",mode:"cors",headers:new Headers(f(f({},this.options.extraRegistrationHeaders),{accept:"application/json, text/javascript"}))}),[4,this.callRegistrar(x,"pr_delete_registration")];case 1:return B.sent(),[2]}})})},F.prototype.cancelPendingRequests=function(){var x=this;Object.keys(this.backoffs).forEach(function(B){x.backoffs[B].cancel()}),this.backoffs={}},F.prototype.resendRegistration=function(){return y(this,void 0,void 0,function(){return T(this,function(x){switch(x.label){case 0:if(!this.cachedRegistrationParams)throw new Error("Re-registration failed because there is no registration parameters cached");return[4,this.performRegistration(this.cachedRegistrationParams[0],this.cachedRegistrationParams[1],"pr_resend_registration")];case 1:return x.sent(),[2]}})})},F.prototype.performRegistration=function(x,B,L){return y(this,void 0,void 0,function(){var z,H;return T(this,function(j){switch(j.label){case 0:return this.logger.info("[RegistrarClient] Sending register request"),z={clientDescription:x,registrationId:this.options.registrationId,nodeId:"",transports:B},H=new Request(this.proxyUrlRewrite(this.options.registrarUrl),{method:"POST",mode:"cors",headers:new Headers(f(f({},this.options.extraRegistrationHeaders),{"content-type":"application/json",accept:"application/json, text/javascript"})),body:(0,C.toJson)(z)}),[4,this.callRegistrar(H,L)];case 1:return j.sent(),[2]}})})},F.prototype.startBackoff=function(){var x=new w(this.logger,this.maxBackOffTime,this.options.initialRetryDelayMs);return this.backoffs[x.id]=x,x},F.prototype.stopBackoff=function(x){x.cancel(),delete this.backoffs[x.id]},F.prototype.getToken=function(x){return y(this,void 0,void 0,function(){var B,L,z,H,j,J,Z;return T(this,function(re){switch(re.label){case 0:B=this.startBackoff(),L=0,re.label=1;case 1:return re.trys.push([1,3,,8]),this.logger.info("[RegistrarClient] Asking for a new token"),[4,this.tokenProvider({needFresh:!0,supportedTokenTypes:E,wwwAuthenticateHeader:x,purpose:"registrar"})];case 2:return z=re.sent(),this.stopBackoff(B),[2,z];case 3:H=re.sent(),re.label=4;case 4:return re.trys.push([4,6,,7]),L++,j=JSON.stringify(H),L>this.maxRetriesForGetToken?(J="[RegistrarClient] getToken retry limit hit. Will not retry now. Error: ".concat(j),this.logger.error(J),this.stopBackoff(B),[2,Promise.reject(J)]):(this.logger.warn("[RegistrarClient] Retrying for a new token. Retry Count: ".concat(L," Error: ").concat(j)),[4,B.delay("Fetching a new token")]);case 5:return re.sent(),[3,8];case 6:throw Z=re.sent(),this.stopBackoff(B),Z;case 7:return[3,8];case 8:return[3,1];case 9:return[2]}})})},F.prototype.callRegistrar=function(x,B){var L,z,H;return y(this,void 0,void 0,function(){var j,J,Z,re,ne,le,he,Me,Le,pe,te,Se,ce,X,ve,Te;return T(this,function(Be){switch(Be.label){case 0:return j=this.startBackoff(),[4,this.tokenProvider({needFresh:!1,supportedTokenTypes:E,wwwAuthenticateHeader:void 0,purpose:"registrar"})];case 1:J=Be.sent(),this.setTokenHeader(x,J),Z=new C.Timespan,re=0,Be.label=2;case 2:ne=void 0,Be.label=3;case 3:return Be.trys.push([3,10,15,16]),le=x.clone(),[4,(0,C.fetchWithTimeout)(le,this.options.requestTimeoutMs)];case 4:return(ne=Be.sent()).status!==401?[3,8]:++re>this.maxRetriesForGetToken?(he="[RegistrarClient] getSkypeToken retry limit hit. Will not retry now. Request '".concat(x.url,"' failed with ").concat(ne.status," ").concat(ne.statusText),this.logger.error(he),this.stopBackoff(j),[2,Promise.reject(he)]):(this.logger.warn("[RegistrarClient] Retry Count ".concat(re,". Request '").concat(x.url,"' failed with ").concat(ne.status," ").concat(ne.statusText)),Me=(z=(L=ne.headers)===null||L===void 0?void 0:L.get("www-authenticate"))!==null&&z!==void 0?z:void 0,Le=this.setTokenHeader,pe=[x],[4,this.getToken(Me)]);case 5:return Le.apply(this,pe.concat([Be.sent()])),re>1?[4,j.delay("Registrar call retry after 401")]:[3,7];case 6:Be.sent(),Be.label=7;case 7:return[3,22];case 8:if(ne.status>=500&&ne.status<600)throw new Error("Fetch for '".concat(x.url,"' failed with ").concat(ne.status," ").concat(ne.statusText));Be.label=9;case 9:return[3,16];case 10:te=Be.sent(),this.logger.error("[RegistrarClient] Request failed with ".concat(te)),Be.label=11;case 11:return Be.trys.push([11,13,,14]),[4,j.delay("Registrar call retry")];case 12:return Be.sent(),[3,22];case 13:throw Se=Be.sent(),this.logger.error("[RegistrarClient] Request cancelled"),this.stopBackoff(j),Se;case 14:return[3,16];case 15:return this.sendTelemetryEvent(B,x,ne,Z),[7];case 16:return this.stopBackoff(j),ne.ok?[2,ne]:[3,17];case 17:ce=void 0,Be.label=18;case 18:return Be.trys.push([18,20,,21]),ve=(X=JSON).stringify,[4,ne.json()];case 19:return ce=ve.apply(X,[Be.sent()]),[3,21];case 20:return Be.sent(),ce="no details",[3,21];case 21:throw Te="Fetch for '".concat(x.url,"' failed with ").concat(ne.status," ").concat(ne.statusText," (").concat(ce,", MS-CV: ").concat((H=ne.headers)===null||H===void 0?void 0:H.get("MS-CV"),")"),this.logger.error("[RegistrarClient] ".concat(Te)),new Error(Te);case 22:return[3,2];case 23:return[2]}})})},F.prototype.setTokenHeader=function(x,B){switch(x.headers.delete("X-Skypetoken"),x.headers.delete("Authorization"),x.headers.delete("X-MS-Migration"),B.tokenType.toLowerCase()){case"skype":x.headers.set("X-Skypetoken",B.token);break;case"aad":case"cae":x.headers.set("Authorization","Bearer ".concat(B.token));break;default:throw new Error("unsupported token type: ".concat(B.tokenType))}this.options.usingLegacyTokenApi===!1&&x.headers.set("X-MS-Migration","True")},F.prototype.sendTelemetryEvent=function(x,B,L,z){if(this.eventLogger!==void 0){var H={name:x,properties:{url:{value:B.url},result_code:{value:L!==void 0?L.status:0},begin_timestamp:{value:z.startTime},elapsed:{value:z.duration}}};this.eventLogger.logEvent(H)}},F}();d.RegistrarClient=D,d.createRegistrarClient=function(F,x,B){return new D(F,x,B)}}},o={},function l(d){var h=o[d];if(h!==void 0)return h.exports;var p=o[d]={exports:{}};return r[d].call(p.exports,p,p.exports,l),p.exports}(912);var r,o},t.exports=i()}),gZ=bs(function(t,e){var i;i=r=>(()=>{var o={983:(h,p,g)=>{(function(y,T){var C=y;C.version="0.9.6",C.protocol=1,C.transports=[],C.j=[],C.sockets={},C.connect=function(E,I){var w,D,F=C.util.parseUri(E);T&&T.location&&(F.protocol=F.protocol||T.location.protocol.slice(0,-1),F.host=F.host||(T.document?T.document.domain:T.location.hostname),F.port=F.port||T.location.port),w=C.util.uniqueUri(F);var x={host:F.host,secure:F.protocol=="https",port:F.port||(F.protocol=="https"?443:80),query:F.query||""};return C.util.merge(x,I),!x["force new connection"]&&C.sockets[w]||(D=new C.Socket(x)),!x["force new connection"]&&D&&(C.sockets[w]=D),D=D||C.sockets[w],x["skipped handshake data"]?D.of(""):D.of(F.path.length>1?F.path:"")}})((h=g.nmd(h)).exports,g.g===void 0?window:g.g);var f=h.exports;(function(y,T){var C=y.util={},E=/^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/,I=["source","protocol","authority","userInfo","user","password","host","port","relative","path","directory","file","query","anchor"];C.parseUri=function(D){for(var F=E.exec(D||""),x={},B=14;B--;)x[I[B]]=F[B]||"";return x},C.uniqueUri=function(D){var F=D.protocol,x=D.host,B=D.port;return"document"in T?(x=x||document.domain,B=B||(F=="https"&&document.location.protocol!=="https:"?443:document.location.port)):(x=x||"localhost",B||F!="https"||(B=443)),(F||"http")+"://"+x+":"+(B||80)},C.query=function(D,F){var x=C.chunkQuery(D||""),B=[];for(var L in C.merge(x,C.chunkQuery(F||"")),x)x.hasOwnProperty(L)&&B.push(L+"="+x[L]);return B.length?"?"+B.join("&"):""},C.chunkQuery=function(D){for(var F,x={},B=D.split("&"),L=0,z=B.length;L<z;++L)(F=B[L].split("="))[0]&&(x[F[0]]=F[1]);return x};var w=!1;C.load=function(D){if("document"in T&&document.readyState==="complete"||w)return D();C.on(T,"load",D,!1)},C.on=function(D,F,x,B){D.attachEvent?D.attachEvent("on"+F,x):D.addEventListener&&D.addEventListener(F,x,B)},C.request=function(D){if(D&&typeof XDomainRequest<"u")return new XDomainRequest;if(typeof XMLHttpRequest<"u"&&(!D||C.ua.hasCORS))return new XMLHttpRequest;if(!D)try{return new window[["Active"].concat("Object").join("X")]("Microsoft.XMLHTTP")}catch{}return null},typeof window<"u"&&C.load(function(){w=!0}),C.defer=function(D){if(!C.ua.webkit||typeof importScripts<"u")return D();C.load(function(){setTimeout(D,100)})},C.merge=function(D,F,x,B){var L,z=B||[],H=x===void 0?2:x;for(L in F)F.hasOwnProperty(L)&&C.indexOf(z,L)<0&&(typeof D[L]=="object"&&H?C.merge(D[L],F[L],H-1,z):(D[L]=F[L],z.push(F[L])));return D},C.mixin=function(D,F){C.merge(D.prototype,F.prototype)},C.inherit=function(D,F){function x(){}x.prototype=F.prototype,D.prototype=new x},C.isArray=Array.isArray||function(D){return Object.prototype.toString.call(D)==="[object Array]"},C.intersect=function(D,F){for(var x=[],B=D.length>F.length?D:F,L=D.length>F.length?F:D,z=0,H=L.length;z<H;z++)~C.indexOf(B,L[z])&&x.push(L[z]);return x},C.indexOf=function(D,F,x){var B=D.length;for(x=x<0?x+B<0?0:x+B:x||0;x<B&&D[x]!==F;x++);return B<=x?-1:x},C.toArray=function(D){for(var F=[],x=0,B=D.length;x<B;x++)F.push(D[x]);return F},C.ua={},C.ua.hasCORS=typeof XMLHttpRequest<"u"&&function(){try{var D=new XMLHttpRequest}catch{return!1}return D.withCredentials!=null}(),C.ua.webkit=typeof navigator<"u"&&/webkit/i.test(navigator.userAgent)})(f!==void 0?f:h.exports,g.g===void 0?window:g.g),function(y,T){function C(){}y.EventEmitter=C,C.prototype.on=function(E,I){return this.$events||(this.$events={}),this.$events[E]?T.util.isArray(this.$events[E])?this.$events[E].push(I):this.$events[E]=[this.$events[E],I]:this.$events[E]=I,this},C.prototype.addListener=C.prototype.on,C.prototype.once=function(E,I){var w=this;function D(){w.removeListener(E,D),I.apply(this,arguments)}return D.listener=I,this.on(E,D),this},C.prototype.removeListener=function(E,I){if(this.$events&&this.$events[E]){var w=this.$events[E];if(T.util.isArray(w)){for(var D=-1,F=0,x=w.length;F<x;F++)if(w[F]===I||w[F].listener&&w[F].listener===I){D=F;break}if(D<0)return this;w.splice(D,1),w.length||delete this.$events[E]}else(w===I||w.listener&&w.listener===I)&&delete this.$events[E]}return this},C.prototype.removeAllListeners=function(E){return this.$events&&this.$events[E]&&(this.$events[E]=null),this},C.prototype.listeners=function(E){return this.$events||(this.$events={}),this.$events[E]||(this.$events[E]=[]),T.util.isArray(this.$events[E])||(this.$events[E]=[this.$events[E]]),this.$events[E]},C.prototype.emit=function(E){if(!this.$events)return!1;var I=this.$events[E];if(!I)return!1;var w=Array.prototype.slice.call(arguments,1);if(typeof I=="function")I.apply(this,w);else{if(!T.util.isArray(I))return!1;for(var D=I.slice(),F=0,x=D.length;F<x;F++)D[F].apply(this,w)}return!0}}(f!==void 0?f:h.exports,f!==void 0?f:h.parent.exports),function(y,T){if(T&&T.parse)return y.JSON={parse:T.parse,stringify:T.stringify};throw new Error("JSON not available")}(f!==void 0?f:h.exports,typeof JSON<"u"?JSON:void 0),function(y,T){var C=y.parser={},E=C.packets=["disconnect","connect","heartbeat","message","json","event","ack","error","noop"],I=C.reasons=["transport not supported","client not handshaken","unauthorized"],w=C.advice=["reconnect"],D=T.JSON,F=T.util.indexOf;C.encodePacket=function(B){var L=F(E,B.type),z=B.id||"",H=B.endpoint||"",j=B.ack,J=null;switch(B.type){case"error":var Z=B.reason?F(I,B.reason):"",re=B.advice?F(w,B.advice):"";Z===""&&re===""||(J=Z+(re!==""?"+"+re:""));break;case"message":B.data!==""&&(J=B.data);break;case"event":var ne={name:B.name};B.args&&B.args.length&&(ne.args=B.args),J=D.stringify(ne);break;case"json":J=D.stringify(B.data);break;case"connect":B.qs&&(J=B.qs);break;case"ack":J=B.ackId+(B.args&&B.args.length?"+"+D.stringify(B.args):"")}var le=[L,z+(j=="data"?"+":""),H];return J!=null&&le.push(J),le.join(":")},C.encodePayload=function(B){var L="";if(B.length==1)return B[0];for(var z=0,H=B.length;z<H;z++)L+="�"+B[z].length+"�"+B[z];return L};var x=/([^:]+):([0-9]+)?(\+)?:([^:]+)?:?([\s\S]*)?/;C.decodePacket=function(B){if(!(H=B.match(x)))return{};var L=H[2]||"",z=(B=H[5]||"",{type:E[H[1]],endpoint:H[4]||""});switch(L&&(z.id=L,H[3]?z.ack="data":z.ack=!0),z.type){case"error":var H=B.split("+");z.reason=I[H[0]]||"",z.advice=w[H[1]]||"";break;case"message":z.data=B||"";break;case"event":try{var j=D.parse(B);z.name=j.name,z.args=j.args}catch{}z.args=z.args||[];break;case"json":try{z.data=D.parse(B)}catch{}break;case"connect":z.qs=B||"";break;case"ack":if((H=B.match(/^([0-9]+)(\+)?(.*)/))&&(z.ackId=H[1],z.args=[],H[3]))try{z.args=H[3]?D.parse(H[3]):[]}catch{}break;case"disconnect":z.reason=B}return z},C.decodePayload=function(B){if(B.charAt(0)=="�"){for(var L=[],z=1,H="";z<B.length;z++)B.charAt(z)=="�"?(L.push(C.decodePacket(B.substr(z+1).substr(0,H))),z+=Number(H)+1,H=""):H+=B.charAt(z);return L}return[C.decodePacket(B)]}}(f!==void 0?f:h.exports,f!==void 0?f:h.parent.exports),function(y,T){function C(E,I){this.socket=E,this.sessid=I,this.connectErrorCallback=void 0,this.isOpened=!1}y.Transport=C,T.util.mixin(C,T.EventEmitter),C.prototype.onData=function(E){if(this.clearCloseTimeout(),(this.socket.connected||this.socket.connecting||this.socket.reconnecting)&&this.setCloseTimeout(),E!==""){var I=T.parser.decodePayload(E);if(I&&I.length)for(var w=0,D=I.length;w<D;w++)this.onPacket(I[w])}return this},C.prototype.onPacket=function(E){return this.socket.setHeartbeatTimeout(),E.type=="heartbeat"?this.onHeartbeat():(E.type=="connect"&&E.endpoint==""&&this.onConnect(),E.type=="error"&&E.advice=="reconnect"&&(this.isOpened=!1),this.socket.onPacket(E),this)},C.prototype.setCloseTimeout=function(){if(!this.closeTimeout){var E=this;this.closeTimeout=setTimeout(function(){E.onDisconnect()},this.socket.closeTimeout)}},C.prototype.onDisconnect=function(){return this.close&&this.isOpened&&this.close(),this.clearTimeouts(),this.socket.onDisconnect(),this},C.prototype.onConnect=function(){return this.socket.onConnect(),this.connectErrorCallback=void 0,this},C.prototype.clearCloseTimeout=function(){this.closeTimeout&&(clearTimeout(this.closeTimeout),this.closeTimeout=null)},C.prototype.clearTimeouts=function(){this.clearCloseTimeout(),this.reopenTimeout&&clearTimeout(this.reopenTimeout)},C.prototype.packet=function(E){this.send(T.parser.encodePacket(E))},C.prototype.onHeartbeat=function(E){this.packet({type:"heartbeat"})},C.prototype.onOpen=function(){this.isOpened=!0,this.clearCloseTimeout(),this.socket.onOpen()},C.prototype.onClose=function(){this.isOpened=!1,this.socket.onClose(),this.onDisconnect()},C.prototype.prepareUrl=function(E){var I=this.socket.options;if(I["skipped handshake data"])return I.rewriteUrlForProxy(I["skipped handshake data"].websocketUrl+(E||""));var w=this.scheme()+"://"+I.host+":"+I.port+"/"+I.resource+"/"+T.protocol+"/"+this.name+"/"+this.sessid+(E||"");return I.rewriteUrlForProxy(w)},C.prototype.ready=function(E,I){I.call(this)},C.prototype.clearEventHandlers=function(){return this}}(f!==void 0?f:h.exports,f!==void 0?f:h.parent.exports),function(y,T,C){function E(w){if(this.options={port:80,secure:!1,document:"document"in C&&document,resource:"socket.io",transports:T.transports.slice(),"connect timeout":1e4,"try multiple transports":!0,reconnect:!0,"reconnection delay":500,"reconnection limit":1/0,"reopen delay":3e3,"max reconnection attempts":10,"sync disconnect on unload":!0,"auto connect":!0,"flash policy port":10843},T.util.merge(this.options,w),this.connected=!1,this.open=!1,this.connecting=!1,this.reconnecting=!1,this.namespaces={},this.buffer=[],this.doBuffer=!1,this.disconnected=!1,this.options["sync disconnect on unload"]&&(!this.isXDomain()||T.util.ua.hasCORS)){var D=this;T.util.on(C,"unload",function(){D.disconnectSync()},!1)}this.options["auto connect"]&&this.connect()}function I(){}y.Socket=E,T.util.mixin(E,T.EventEmitter),E.prototype.of=function(w){return this.namespaces[w]||(this.namespaces[w]=new T.SocketNamespace(this,w),w!==""&&this.namespaces[w].packet({type:"connect"})),this.namespaces[w]},E.prototype.publish=function(){var w;for(var D in this.emit.apply(this,arguments),this.namespaces)this.namespaces.hasOwnProperty(D)&&(w=this.of(D)).$emit.apply(w,arguments)},E.prototype.handshake=function(w){var D=this,F=this.options;if(!D.disconnected){var x=F.rewriteUrlForProxy(["http"+(F.secure?"s":"")+":/",F.host+":"+F.port,F.resource,T.protocol,T.util.query(this.options.query,"t="+ +new Date)].join("/"));if(this.isXDomain()&&!T.util.ua.hasCORS){var B=document.getElementsByTagName("script")[0],L=document.createElement("script");L.src=x+"&jsonp="+T.j.length,B.parentNode.insertBefore(L,B),T.j.push(function(J){j(J),L.parentNode.removeChild(L)})}else{var z=T.util.request();z.open("GET",x,!0);var H=this.options.requestHeaders;H!==void 0&&Object.keys(H).forEach(function(J){z.setRequestHeader(J,H[J])}),z.onreadystatechange=function(){z.readyState==4&&(z.onreadystatechange=I,z.status==200?j(z.responseText):!D.reconnecting&&D.onError(z.responseText))},z.send(null)}}function j(J){J instanceof Error?D.onError(J.message):w.apply(null,J.split(":"))}},E.prototype.getTransport=function(w){for(var D,F=w||this.transports,x=0;D=F[x];x++)if(T.Transport[D]&&T.Transport[D].check(this)&&(!this.isXDomain()||T.Transport[D].xdomainCheck()))return new T.Transport[D](this,this.sessionid);return null},E.prototype.connect=function(w){if(this.connecting||this.disconnected)return this;var D=this,F=function(B,L,z,H){function j(){if(!D.connected&&!D.disconnected)if(D.connecting=!1,clearTimeout(D.connectTimeoutTimer),D.options["try multiple transports"]){for(;D.remainingTransports.length>0&&D.remainingTransports.splice(0,1)[0]!=D.transport.name;);D.remainingTransports.length?J(D.remainingTransports):D.publish("connect_failed")}else D.publish("connect_failed")}function J(Z){if(D.transport&&(D.transport.clearTimeouts(),D.transport.clearEventHandlers()),D.transport=D.getTransport(Z),!D.transport||D.disconnected)return D.publish("connect_failed");D.transport.ready(D,function(){D.connecting=!0,D.publish("connecting",D.transport.name),D.transport.open(j),D.options["connect timeout"]&&(D.connectTimeoutTimer=setTimeout(function(){j()},D.options["connect timeout"]))})}D.sessionid=B,D.closeTimeout=1e3*z+2e3,D.heartbeatTimeout=1e3*L+2e3,D.transports=H?T.util.intersect(H.split(","),D.options.transports):D.options.transports,D.setHeartbeatTimeout(),D.remainingTransports=D.transports.slice(0),J(D.transports),D.once("connect",function(){clearTimeout(D.connectTimeoutTimer),w&&typeof w=="function"&&w()})};if(this.options["skipped handshake data"]){var x=this.options["skipped handshake data"];F("v4c-"+new Date().getTime(),x.timeout,x.timeout,"websocket")}else this.handshake(F);return this},E.prototype.setHeartbeatTimeout=function(){clearTimeout(this.heartbeatTimeoutTimer);var w=this;this.heartbeatTimeoutTimer=setTimeout(function(){w.transport.onClose()},this.heartbeatTimeout)},E.prototype.packet=function(w){return this.connected&&!this.doBuffer?this.transport.packet(w):this.buffer.push(w),this},E.prototype.setBuffer=function(w){this.doBuffer=w,!w&&this.connected&&this.buffer.length&&(this.transport.payload(this.buffer),this.buffer=[])},E.prototype.disconnect=function(){return(this.connected||this.connecting)&&(this.open&&this.of("").packet({type:"disconnect"}),this.onDisconnect("booted")),this.disconnected=!0,this},E.prototype.disconnectSync=function(){var w=T.util.request(),D=this.resource+"/"+T.protocol+"/"+this.sessionid;w.open("GET",D,!0),this.onDisconnect("booted")},E.prototype.isXDomain=function(){var w=C.location.port||(C.location.protocol=="https:"?443:80);return this.options.host!==C.location.hostname||this.options.port!=w},E.prototype.onConnect=function(){this.connected||(this.connected=!0,this.connecting=!1,this.doBuffer||this.setBuffer(!1),this.emit("connect"))},E.prototype.onOpen=function(){this.open=!0},E.prototype.onClose=function(){this.open=!1,clearTimeout(this.heartbeatTimeoutTimer)},E.prototype.onPacket=function(w){this.of(w.endpoint).onPacket(w)},E.prototype.onError=function(w){w&&w.advice&&w.advice==="reconnect"&&(this.connected||this.connecting)&&(this.disconnect(),this.options.reconnect&&this.reconnect()),this.publish("error",w&&w.reason?w.reason:w)},E.prototype.onDisconnect=function(w){var D=this.connected,F=this.connecting;this.connected=!1,this.connecting=!1,this.open=!1,(D||F)&&(this.transport.close(),this.transport.clearTimeouts(),D?(this.publish("disconnect",w),w!="booted"&&this.options.reconnect&&!this.reconnecting&&this.reconnect()):this.publish("close_during_connecting",w))},E.prototype.reconnect=function(){this.reconnecting=!0,this.reconnectionAttempts=0,this.reconnectionDelay=this.options["reconnection delay"];var w=this,D=this.options["max reconnection attempts"],F=this.options["try multiple transports"],x=this.options["reconnection limit"];function B(){if(w.connected){for(var z in w.namespaces)w.namespaces.hasOwnProperty(z)&&z!==""&&w.namespaces[z].packet({type:"connect"});w.publish("reconnect",w.transport.name,w.reconnectionAttempts)}clearTimeout(w.reconnectionTimer),w.removeListener("connect_failed",L),w.removeListener("connect",L),w.reconnecting=!1,delete w.reconnectionAttempts,delete w.reconnectionDelay,delete w.reconnectionTimer,delete w.redoTransports,w.options["try multiple transports"]=F}function L(){if(w.reconnecting)return w.connected?B():w.connecting&&w.reconnecting?w.reconnectionTimer=setTimeout(L,1e3):void(w.reconnectionAttempts++>=D?w.redoTransports?(w.publish("reconnect_failed"),B()):(w.on("connect_failed",L),w.options["try multiple transports"]=!0,w.transport=w.getTransport(),w.redoTransports=!0,w.connect()):(w.reconnectionDelay<x&&(w.reconnectionDelay*=2),w.connect(),w.publish("reconnecting",w.reconnectionDelay,w.reconnectionAttempts),w.reconnectionTimer=setTimeout(L,w.reconnectionDelay)))}this.options["try multiple transports"]=!1,this.reconnectionTimer=setTimeout(L,this.reconnectionDelay),this.on("connect",L)}}(f!==void 0?f:h.exports,f!==void 0?f:h.parent.exports,g.g===void 0?window:g.g),function(y,T){function C(I,w){this.socket=I,this.name=w||"",this.flags={},this.json=new E(this,"json"),this.ackPackets=0,this.acks={}}function E(I,w){this.namespace=I,this.name=w}y.SocketNamespace=C,T.util.mixin(C,T.EventEmitter),C.prototype.$emit=T.EventEmitter.prototype.emit,C.prototype.of=function(){return this.socket.of.apply(this.socket,arguments)},C.prototype.packet=function(I){return I.endpoint=this.name,this.socket.packet(I),this.flags={},this},C.prototype.send=function(I,w){var D={type:this.flags.json?"json":"message",data:I};return typeof w=="function"&&(D.id=++this.ackPackets,D.ack=!0,this.acks[D.id]=w),this.packet(D)},C.prototype.emit=function(I){var w=Array.prototype.slice.call(arguments,1),D=w[w.length-1],F={type:"event",name:I};return typeof D=="function"&&(F.id=++this.ackPackets,F.ack="data",this.acks[F.id]=D,w=w.slice(0,w.length-1)),F.args=w,this.packet(F)},C.prototype.disconnect=function(){return this.name===""?this.socket.disconnect():(this.packet({type:"disconnect"}),this.$emit("disconnect")),this},C.prototype.onPacket=function(I){var w=this;function D(){w.packet({type:"ack",args:T.util.toArray(arguments),ackId:I.id})}switch(I.type){case"connect":this.$emit("connect");break;case"disconnect":this.name===""?this.socket.onDisconnect(I.reason||"booted"):this.$emit("disconnect",I.reason||"");break;case"message":case"json":var F=["message",I.data];I.ack=="data"?F.push(D):I.ack&&this.packet({type:"ack",ackId:I.id}),this.$emit.apply(this,F);break;case"event":F=[I.name].concat(I.args),I.ack=="data"&&F.push(D),this.$emit.apply(this,F);break;case"ack":this.acks[I.ackId]&&(this.acks[I.ackId].apply(this,I.args),delete this.acks[I.ackId]);break;case"error":I.advice?this.socket.onError(I):I.reason=="unauthorized"?this.$emit("connect_failed",I.reason):this.$emit("error",I.reason)}},E.prototype.send=function(){this.namespace.flags[this.name]=!0,this.namespace.send.apply(this.namespace,arguments)},E.prototype.emit=function(){this.namespace.flags[this.name]=!0,this.namespace.emit.apply(this.namespace,arguments)}}(f!==void 0?f:h.exports,f!==void 0?f:h.parent.exports),function(y,T,C){function E(w){T.Transport.apply(this,arguments)}function I(){}y.websocket=E,T.util.inherit(E,T.Transport),E.prototype.name="websocket",E.prototype.open=function(w){var D,F=T.util.query(this.socket.options.query),x=this;return this.connectErrorCallback=w,D||(D=C.MozWebSocket||C.WebSocket),this.websocket=new D(this.prepareUrl(F)),this.websocket.onopen=function(){x.onOpen(),x.socket.setBuffer(!1)},this.websocket.onmessage=function(B){x.onData(B.data)},this.websocket.onclose=function(){x.onClose(),x.socket.setBuffer(!0)},this.websocket.onerror=function(B){x.onError(B)},this},E.prototype.send=function(w){return this.websocket.send(w),this},E.prototype.payload=function(w){for(var D=0,F=w.length;D<F;D++)this.packet(w[D]);return this},E.prototype.close=function(){return this.websocket.close(),this},E.prototype.onError=function(w){this.connectErrorCallback!==void 0&&(this.connectErrorCallback(),this.connectErrorCallback=void 0),this.socket.onError(w)},E.prototype.scheme=function(){return this.socket.options.secure?"wss":"ws"},E.check=function(){return"WebSocket"in C&&!("__addTask"in WebSocket)||"MozWebSocket"in C},E.xdomainCheck=function(){return!0},E.prototype.clearEventHandlers=function(){return this.websocket&&(this.websocket.onopen=this.websocket.onmessage=this.websocket.onclose=this.websocket.onerror=I),this},T.transports.push("websocket")}(f!==void 0?f.Transport:h.exports,f!==void 0?f:h.parent.exports,g.g===void 0?window:g.g),function(y,T,C){function E(w){w&&T.Transport.apply(this,arguments)}function I(){}y.XHR=E,T.util.inherit(E,T.Transport),E.prototype.open=function(){return this.socket.setBuffer(!1),this.onOpen(),this.get(),this.setCloseTimeout(),this},E.prototype.payload=function(w){for(var D=[],F=0,x=w.length;F<x;F++)D.push(T.parser.encodePacket(w[F]));this.send(T.parser.encodePayload(D))},E.prototype.send=function(w){return this.post(w),this},E.prototype.post=function(w){var D=this;this.socket.setBuffer(!0),this.sendXHR=this.request("POST"),C.XDomainRequest&&this.sendXHR instanceof XDomainRequest?this.sendXHR.onload=this.sendXHR.onerror=function(){this.onload=I,D.socket.setBuffer(!1)}:this.sendXHR.onreadystatechange=function(){this.readyState==4&&(this.onreadystatechange=I,this.status==200?(clearTimeout(this.ackTimeoutTimer),D.socket.setBuffer(!1)):D.onClose())},this.sendXHR.send(w),D.sendXHR.ackTimeoutTimer=setTimeout(function(){D.onClose()},D.socket.options.ackTimeoutMs)},E.prototype.close=function(){return this.onClose(),this},E.prototype.request=function(w){var D=T.util.request(this.socket.isXDomain()),F=T.util.query(this.socket.options.query,"t="+ +new Date);D.open(w||"GET",this.prepareUrl(F),!0);var x=this.socket.options.requestHeaders;if(x!==void 0&&Object.keys(x).forEach(function(B){D.setRequestHeader(B,x[B])}),w=="POST")try{D.setRequestHeader?D.setRequestHeader("Content-type","text/plain;charset=UTF-8"):D.contentType="text/plain"}catch{}return D},E.prototype.scheme=function(){return this.socket.options.secure?"https":"http"},E.check=function(w,D){try{var F=T.util.request(D),x=C.XDomainRequest&&F instanceof XDomainRequest,B=(w&&w.options&&w.options.secure?"https:":"http:")!=C.location.protocol;if(F&&(!x||!B))return!0}catch{}return!1},E.xdomainCheck=function(){return E.check(null,!0)},E.prototype.clearEventHandlers=function(){return this.sendXHR&&(this.sendXHR.onreadystatechange=this.sendXHR.onload=I),this}}(f!==void 0?f.Transport:h.exports,f!==void 0?f:h.parent.exports,g.g===void 0?window:g.g),function(y,T,C){function E(){T.Transport.XHR.apply(this,arguments)}function I(){}y["xhr-polling"]=E,T.util.inherit(E,T.Transport.XHR),T.util.merge(E,T.Transport.XHR),E.prototype.name="xhr-polling",E.prototype.open=function(w){return this.connectErrorCallback=w,T.Transport.XHR.prototype.open.call(this),!1},E.prototype.get=function(){if(this.isOpened){var w=this;this.xhr=this.request(),C.XDomainRequest&&this.xhr instanceof XDomainRequest?(this.xhr.onload=function(){w.connectErrorCallback=void 0,this.onload=I,this.onerror=I,w.onData(this.responseText),w.get()},this.xhr.onerror=function(){w.onClose(),w.connectErrorCallback!==void 0&&(w.connectErrorCallback(),w.connectErrorCallback=void 0)}):this.xhr.onreadystatechange=function(){this.readyState==4&&(this.onreadystatechange=I,this.status==200?(w.connectErrorCallback=void 0,w.onData(this.responseText),w.get()):(w.onClose(),w.connectErrorCallback!==void 0&&(w.connectErrorCallback(),w.connectErrorCallback=void 0)))},this.xhr.send(null)}},E.prototype.onClose=function(){if(T.Transport.XHR.prototype.onClose.call(this),this.xhr){this.xhr.onreadystatechange=this.xhr.onload=this.xhr.onerror=I;try{this.xhr.abort()}catch{}this.xhr=null}},E.prototype.ready=function(w,D){var F=this;T.util.defer(function(){D.call(F)})},E.prototype.clearEventHandlers=function(){return T.Transport.XHR.prototype.clearEventHandlers.call(this),this.xhr&&(this.xhr.onreadystatechange=this.xhr.onload=this.xhr.onerror=I),this},T.transports.push("xhr-polling")}(f!==void 0?f.Transport:h.exports,f!==void 0?f:h.parent.exports,g.g===void 0?window:g.g),p.io=f},659:function(h,p){var g=this&&this.__awaiter||function(C,E,I,w){return new(I||(I=Promise))(function(D,F){function x(z){try{L(w.next(z))}catch(H){F(H)}}function B(z){try{L(w.throw(z))}catch(H){F(H)}}function L(z){var H;z.done?D(z.value):(H=z.value,H instanceof I?H:new I(function(j){j(H)})).then(x,B)}L((w=w.apply(C,E||[])).next())})},f=this&&this.__generator||function(C,E){var I,w,D,F,x={label:0,sent:function(){if(1&D[0])throw D[1];return D[1]},trys:[],ops:[]};return F={next:B(0),throw:B(1),return:B(2)},typeof Symbol=="function"&&(F[Symbol.iterator]=function(){return this}),F;function B(L){return function(z){return function(H){if(I)throw new TypeError("Generator is already executing.");for(;F&&(F=0,H[0]&&(x=0)),x;)try{if(I=1,w&&(D=2&H[0]?w.return:H[0]?w.throw||((D=w.return)&&D.call(w),0):w.next)&&!(D=D.call(w,H[1])).done)return D;switch(w=0,D&&(H=[2&H[0],D.value]),H[0]){case 0:case 1:D=H;break;case 4:return x.label++,{value:H[1],done:!1};case 5:x.label++,w=H[1],H=[0];continue;case 7:H=x.ops.pop(),x.trys.pop();continue;default:if(!((D=(D=x.trys).length>0&&D[D.length-1])||H[0]!==6&&H[0]!==2)){x=0;continue}if(H[0]===3&&(!D||H[1]>D[0]&&H[1]<D[3])){x.label=H[1];break}if(H[0]===6&&x.label<D[1]){x.label=D[1],D=H;break}if(D&&x.label<D[2]){x.label=D[2],x.ops.push(H);break}D[2]&&x.ops.pop(),x.trys.pop();continue}H=E.call(C,x)}catch(j){H=[6,j],w=0}finally{I=D=0}if(5&H[0])throw H[1];return{value:H[0]?H[1]:void 0,done:!0}}([L,z])}}};Object.defineProperty(p,"__esModule",{value:!0}),p.Timespan=p.CorrelationVector=p.fetchWithTimeout=p.calculateExpireTsInSec=p.calculateTtlInSec=p.toJson=void 0,p.toJson=function(C){try{return JSON.stringify(C)}catch{return"Unable to serialize object of type ".concat(typeof C)}},p.calculateTtlInSec=function(C){var E=Math.round(new Date().getTime()/1e3);return C!==void 0&&C>E?C-E:0},p.calculateExpireTsInSec=function(C){return Math.round(new Date().getTime()/1e3)+C},p.fetchWithTimeout=function(C,E){return g(this,void 0,void 0,function(){var I,w,D;return f(this,function(F){return w=new Promise(function(x,B){fetch(C).then(function(L){clearTimeout(I),x(L)}).catch(function(L){clearTimeout(I),B(L)})}),E!==0?(D=new Promise(function(x,B){var L=new URL(C.url),z=new Error("".concat(C.method," ").concat(L.origin).concat(L.pathname," timed out"));I=setTimeout(B,E,z)}),[2,Promise.race([w,D])]):[2,w]})})};var y=function(){function C(E){this.base=E!==void 0?E:this.createCorrelationVectorBase(),this.extension=0}return C.extend=function(E){return new C(E)},C.prototype.increase=function(){this.extension++},C.prototype.value=function(){return"".concat(this.base,".").concat(this.extension)},C.prototype.createCorrelationVectorBase=function(){for(var E="",I=0;I<21;I++)E+="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0987654321/+".charAt(Math.floor(64*Math.random()));return E+"AQgw".charAt(Math.floor(4*Math.random()))},C}();p.CorrelationVector=y;var T=function(){function C(){this.start=Date.now()}return Object.defineProperty(C.prototype,"duration",{get:function(){return Date.now()-this.start},enumerable:!1,configurable:!0}),Object.defineProperty(C.prototype,"startTime",{get:function(){return this.start},enumerable:!1,configurable:!0}),C.prototype.reset=function(){this.start=Date.now()},C}();p.Timespan=T},396:(h,p,g)=>{Object.defineProperty(p,"__esModule",{value:!0}),p.ConnectionTracker=p.Properties=p.TrackerStep=p.ClientEventName=p.ResponseData=void 0;var f,y=g(659),T=g(509),C=g(642);p.ResponseData=function(F){this.id=F,this.status=200,this.headers={},this.body=""},function(F){F.Connected="trouter_js_client_connected",F.Disconnected="trouter_js_client_disconnected",F.Error="trouter_js_client_error",F.Progress="trouter_js_client_progress",F.Response="trouter_js_client_response",F.Request="trouter_js_client_request",F.CheckConnection="trouter_js_client_check_connection",F.Registration="trouter_js_client_registration",F.Unregistration="trouter_js_client_unregistration"}(f||(p.ClientEventName=f={}));var E=function(F,x,B,L,z){this.stepName=F,this.operation=x,this.delta=B,this.ts=L,this.error=z};p.TrackerStep=E,p.Properties=function(){};var I=function(){this.numberOfPingReplies=0,this.connectedTimestamp=0,this.isNewUrl=!1,this.transportType="",this.connectionNumber=0},w=function(){this.enabled=!1,this.numberOfStepsToMaintain=40,this.logHealthCheckError=!1,this.sendProgressTimeoutSecs=55,this.logSendPingError=!1,this.maxBackoffInMs=12e4,this.trouter_js_client_connected=!1,this.trouter_js_client_disconnected=!1,this.trouter_js_client_error=!1,this.trouter_js_client_progress=!1,this.trouter_js_client_response=!1,this.trouter_js_client_request=!1,this.trouter_js_client_registration=!1,this.trouter_js_client_unregistration=!1,this.trouter_js_client_check_connection=!0},D=function(){function F(x,B,L,z,H,j,J){this.clientId=B,this.clientInfo=L,this.getServerState=z,this.endpointId=H,this.clientCorrelationID=j,this.environment=J,this.logger=new C.Logger("ConnectionTracker",x),this.clientCorrelationID=j!==void 0?j:"",this.steps=[],this.connectionAttempt=0,this.totalStepCount=0,this.beginTimestamp=new y.Timespan,this.eventLogSettings=new w,this.connectedInfo=new I}return F.prototype.enable=function(x){this.eventLogSettings.enabled=!0,this.eventLogger=x},F.prototype.disable=function(){this.eventLogSettings.enabled=!1},F.prototype.sendProgress=function(x){this.steps.length>0&&this.sendTelemetry(f.Progress,x,this.steps)},F.prototype.cancelProgressTimer=function(){this.progressTimeout!==void 0&&(clearTimeout(this.progressTimeout),this.progressTimeout=void 0)},F.prototype.resetProgressSendTimer=function(){var x=this;this.cancelProgressTimer(),this.eventLogSettings.sendProgressTimeoutSecs!==void 0&&this.eventLogSettings.sendProgressTimeoutSecs>0&&(this.progressTimeout=setTimeout(function(){x.sendProgress({reason:"timeout",timeoutSecs:x.eventLogSettings.sendProgressTimeoutSecs})},1e3*this.eventLogSettings.sendProgressTimeoutSecs))},F.prototype.setConnectedInfo=function(x,B){this.connectedInfo.numberOfPingReplies=0,this.connectedInfo.connectedTimestamp=Date.now(),this.connectedInfo.isNewUrl=x,this.connectedInfo.transportType=B,++this.connectedInfo.connectionNumber},F.prototype.clearConnectedInfo=function(){this.connectedInfo.numberOfPingReplies=0,this.connectedInfo.connectedTimestamp=0,this.connectedInfo.isNewUrl=!0,this.connectedInfo.transportType=""},F.prototype.copyProperties=function(x,B){for(var L=0,z=Object.keys(B);L<z.length;L++){var H=z[L];B[H]!==void 0&&(x[H.replace(/-/g,"_")]={value:B[H]})}},F.prototype.increasePingResponseCount=function(){++this.connectedInfo.numberOfPingReplies},F.prototype.sendTelemetry=function(x,B,L){try{if(this.eventLogSettings.enabled===!0&&this.eventLogSettings[x]===!0&&this.eventLogger!==void 0){var z=this.getServerState(),H={name:x,properties:{connectionAttempt:{value:this.connectionAttempt},epid:{value:this.endpointId},clientCorrelationID:{value:this.clientCorrelationID},steps:{value:(0,y.toJson)(L)},clientID:{value:this.clientId},eventVersion:{value:3},environment:{value:this.environment},cv:{value:T.CLIENT_VERSION},ua:{value:this.clientInfo.ua},connectionId:{value:z.connectionId},connectedClientId:{value:z.connectedClientId},domId:{value:z.domId},url:{value:z.url},ttlInSecs:{value:z.getRemainingTtlInSec()},numberOfPingReplies:{value:this.connectedInfo.numberOfPingReplies},connectedTimestamp:{value:this.connectedInfo.connectedTimestamp},isNewUrl:{value:this.connectedInfo.isNewUrl},transportType:{value:this.connectedInfo.transportType},connectionNumber:{value:this.connectedInfo.connectionNumber}}};this.copyProperties(H.properties,B),this.eventLogger.logEvent(H)}}catch(j){this.logger.warn("error in sending event ".concat(x,": ").concat((0,y.toJson)(j)))}},F.prototype.createStep=function(x,B,L){return new E(x,B,this.beginTimestamp.duration,Date.now(),L)},F.prototype.addStep=function(x,B,L){if(this.eventLogSettings.enabled!==!1&&(this.steps.length===0&&this.beginTimestamp.reset(),this.steps.push(this.createStep(x,B,L)),++this.totalStepCount,this.eventLogSettings.numberOfStepsToMaintain!==void 0&&this.steps.length>this.eventLogSettings.numberOfStepsToMaintain)){var z=this.steps.slice(0);this.steps.length=0,this.sendTelemetry(f.Progress,{reason:"flush"},z)}},F.prototype.trackStart=function(x){this.addStep(x,"start")},F.prototype.trackEnd=function(x){this.addStep(x,"end")},F.prototype.trackError=function(x,B,L,z){L===void 0&&(L=!0),x==="health"&&this.eventLogSettings.logHealthCheckError!==!0||x==="ping"&&this.eventLogSettings.logSendPingError===!1||(z===void 0&&(z="error"),L===!0&&this.addStep(x,z,B),this.sendTelemetry(f.Error,{},[this.createStep(x,z,B)]))},F.prototype.trackProgress=function(x,B){this.addStep(x,B)},F.prototype.trackConnected=function(x,B){this.setConnectedInfo(x,B);var L=this.steps.slice(0),z=this.totalStepCount,H=this.beginTimestamp.duration;this.steps.length=0,this.totalStepCount=0,this.sendTelemetry(f.Connected,{stepCount:L.length,totalStepCount:z,connectionEstablishmentMs_Total:H},L),this.cancelProgressTimer()},F.prototype.getSessionLength=function(){return Date.now()-this.connectedInfo.connectedTimestamp},F.prototype.trackDisconnected=function(x){x.sessionLengthMS=this.getSessionLength(),this.sendTelemetry(f.Disconnected,x,[]),this.resetProgressSendTimer()},F.prototype.trackNewConnection=function(){++this.connectionAttempt},F.prototype.trackRequest=function(x,B){var L={};B!==void 0&&(L.hasError=!0,L.error=B);try{if(x){L.requestID=x.id,L.httpMethod=x.method,L.url=x.url,L.bodyLength=x.body.length,L.shortUrl=x.shortUrl,L.requestTimeStamp=x.startTS,L.correlationVector=x.correlationVector;for(var z=x.headers,H=0,j=Object.keys(z);H<j.length;H++){var J=j[H];L[J]=z[J]}}}catch(Z){L.hasError=!0,L.error="".concat(L.error," error creating request context ").concat((0,y.toJson)(Z))}this.sendTelemetry(f.Request,L,[])},F.prototype.trackResponse=function(x,B,L,z){var H={};z!==void 0&&(H.hasError=!0,H.error=z);try{if(H.responseTimestamp=L!==void 0?L.sentTS:Date.now(),x){H.requestID=x.id,H.httpMethod=x.method,H.shortUrl=x.shortUrl,H.correlationVector=x.correlationVector;for(var j=x.headers,J=0,Z=Object.keys(j);J<Z.length;J++){var re=Z[J];H[re]=j[re]}}L&&(H.latencyMS=B,H.responseCode=L.status,H.responseLength=L.body.length)}catch(ne){H.hasError=!0,H.error="".concat(H.error," error creating response context ").concat((0,y.toJson)(ne))}this.sendTelemetry(f.Response,H,[])},F.prototype.sendResponseError=function(x,B,L){this.trackResponse(B,void 0,L,x)},F.prototype.close=function(){this.sendProgress({reason:"closed"}),this.steps.length=0,this.cancelProgressTimer()},F.prototype.mergeSettings=function(x){if(x){this.eventLogSettings.numberOfStepsToMaintain=Math.min(40,Math.max(10,x.numberOfStepsToMaintain!==void 0?x.numberOfStepsToMaintain:0));var B=Math.min(3600,Math.max(55,x.sendProgressTimeoutSecs!==void 0?x.sendProgressTimeoutSecs:0));this.eventLogSettings.logHealthCheckError=x.logHealthCheckError,this.eventLogSettings.logSendPingError=x.logSendPingError;for(var L=0,z=Object.keys(f).map(function(j){return f[j]});L<z.length;L++){var H=z[L];x[H]!==void 0&&(this.eventLogSettings[H]=x[H])}this.eventLogSettings.sendProgressTimeoutSecs!==B&&(this.eventLogSettings.sendProgressTimeoutSecs=B,this.resetProgressSendTimer())}},F}();p.ConnectionTracker=D},509:(h,p)=>{Object.defineProperty(p,"__esModule",{value:!0}),p.USER_AUTHENTICATE_EVENT_NAME=p.SUPPORTED_TOKEN_TYPES=p.FAILED_MESSAGE_ACK=p.UNHANDLED_MESSAGE_ACK=p.HANDLED_MESSAGE_ACK=p.CLIENT_VERSION=p.constants=void 0,p.constants={TROUTER_INIT:"trouterinit",TROUTER_READY_EVENT:"trouterReadyEvent",TROUTER_READY_TIMEOUT:"trouterReadyTimeout",TROUTER_TOKEN_REQUEST:"trouterTokenRequest",TROUTER_TOKEN_GET_SUCCEEDED:"trouterTokenGetSucceeded",TROUTER_TOKEN_GET_FAILED:"trouterTokenGetFailed",TROUTER_RECONNECTING:"trouterReconnecting",RENEWAL:"renewal",NEW_CONNECTION:"newConnection",ENDPOINT_REGISTRATION_FAILED:"endpointRegistrationFailed"},p.CLIENT_VERSION="2025.07.01.25",p.HANDLED_MESSAGE_ACK=200,p.UNHANDLED_MESSAGE_ACK=404,p.FAILED_MESSAGE_ACK=500,p.SUPPORTED_TOKEN_TYPES=["skype","aad","cae"],p.USER_AUTHENTICATE_EVENT_NAME="user.authenticate"},764:(h,p)=>{Object.defineProperty(p,"__esModule",{value:!0}),p.DisconnectReason=void 0;var g=function(){function f(y,T,C){this.reason=y,this.claims=T,this.details=C}return f.fromRawReason=function(y,T){if(y===""||y==="dup")return new f(y);try{var C=JSON.parse(y);return typeof C!="object"||C.reason===void 0?(T?.error("invalid disconnect reason format"),new f("unknown",void 0,y)):new f(C.reason,C.claims,C.details)}catch{return new f("disconnect",void 0,y)}},f.fromSocketIoEventData=function(y,T){return typeof T=="string"?new f(y,void 0,T):void 0},f.prototype.toTelemetryString=function(){return this.reason==="socketerror"||this.reason==="reconnecterror"||this.reason==="disconnect"?this.details:this.reason},f}();p.DisconnectReason=g},107:(h,p)=>{Object.defineProperty(p,"__esModule",{value:!0}),p.ExponentialBackoff=void 0;var g=function(){function f(y,T,C){C===void 0&&(C={tolerance:2,minimumWaitMs:1e4}),this.logger=y,this.maxBackoffInMs=T,this.gapDetectionSettings=C,this.backoffId=0,this.backoffCount=0}return f.calculateNextBackoffMs=function(y,T){var C=1+.4*(Math.random()-.5),E=1e3*Math.pow(2,y)*C;return E=Math.round(E),Math.min(T,E)},f.prototype.setMaxBackoffMs=function(y){this.maxBackoffInMs=y},f.prototype.backoff=function(y,T){var C=this;if(this.timerHandle!==void 0&&(this.logger.debug("Clearing current back off"),clearTimeout(this.timerHandle),this.timerHandle=void 0),this.previousCompleteTime!==void 0){var E=Date.now()-this.previousCompleteTime;E>this.maxBackoffInMs*this.gapDetectionSettings.tolerance&&E>this.gapDetectionSettings.minimumWaitMs&&(this.logger.info("Back off for ".concat(y," with ID ").concat(this.backoffId," will be reset due to a lot of time having passed since the previous backoff (").concat(E," ms)")),this.backoffCount=0,this.previousCompleteTime=void 0)}var I=f.calculateNextBackoffMs(this.backoffCount,this.maxBackoffInMs);this.backoffId++,this.backoffCount++,this.logger.info("Backing off ".concat(y," for ").concat(I," milliseconds with ID ").concat(this.backoffId)),this.callback=function(D,F){(function(x,B,L){if(x===void 0||B===void 0)return!1;var z=Date.now()-x;return z>B*L.tolerance&&z>L.minimumWaitMs})(D,F,C.gapDetectionSettings)&&(C.logger.info("Back off for ".concat(y," with ID ").concat(C.backoffId," will be reset due to the wait (").concat(Date.now()-(D??0)," ms) being longer than expected (").concat(F," ms)")),C.backoffCount=0),C.logger.info("Back off for ".concat(y," with ID ").concat(C.backoffId," complete, invoking handler")),C.timerHandle=void 0,C.callback=void 0,C.previousCompleteTime=Date.now(),T()};var w=Date.now();this.timerHandle=setTimeout(function(){var D;return(D=C.callback)===null||D===void 0?void 0:D.call(C,w,I)},I)},f.prototype.reset=function(){this.timerHandle!==void 0&&(this.logger.debug("Resetting back off with ID ".concat(this.backoffId)),clearTimeout(this.timerHandle),this.timerHandle=void 0,this.callback=void 0),this.backoffCount=0},f.prototype.expediteIfPending=function(){if(this.backoffCount=0,this.timerHandle!==void 0){this.logger.debug("Expediting back off with ID ".concat(this.backoffId)),clearTimeout(this.timerHandle),this.timerHandle=void 0;var y=this.callback;this.callback=void 0,y&&y()}},f}();p.ExponentialBackoff=g},234:(h,p)=>{var g,f;Object.defineProperty(p,"__esModule",{value:!0}),p.TrouterState=p.UserActivityState=void 0,function(y){y[y.Unknown=0]="Unknown",y[y.Active=1]="Active",y[y.Inactive=2]="Inactive"}(g||(p.UserActivityState=g={})),function(y){y[y.Unknown=0]="Unknown",y[y.Connected=2]="Connected",y[y.Disconnected=3]="Disconnected",y[y.Switching=9]="Switching"}(f||(p.TrouterState=f={}))},423:(h,p,g)=>{Object.defineProperty(p,"__esModule",{value:!0}),p.TrouterManagerState=p.UserActivityEventReason=p.ServerState=void 0;var f,y,T=g(659),C=function(){function E(I,w,D,F,x,B){this.connectionId=I,this.connectedClientId=w,this.domId=D,this.url=F,this.c2cUrlBase=x,this.expirationTsSec=B}return E.prototype.getRemainingTtlInSec=function(){return(0,T.calculateTtlInSec)(this.expirationTsSec)},E}();p.ServerState=C,function(E){E[E.Unknown=0]="Unknown",E[E.Modified=1]="Modified",E[E.Snapshot=2]="Snapshot",E[E.Connected=3]="Connected"}(f||(p.UserActivityEventReason=f={})),function(E){E[E.Unknown=0]="Unknown",E[E.Connected=2]="Connected",E[E.Disconnected=3]="Disconnected",E[E.Switching=9]="Switching",E[E.TerminalError=10]="TerminalError"}(y||(p.TrouterManagerState=y={}))},642:(h,p)=>{Object.defineProperty(p,"__esModule",{value:!0}),p.Logger=void 0;var g=function(){function f(y,T){this.name=y,this.logger=T}return f.prototype.debug=function(y){this.logger.debug("[".concat(this.name,"] ").concat(y))},f.prototype.info=function(y){this.logger.info("[".concat(this.name,"] ").concat(y))},f.prototype.warn=function(y){this.logger.warn("[".concat(this.name,"] ").concat(y))},f.prototype.error=function(y){this.logger.error("[".concat(this.name,"] ").concat(y))},f}();p.Logger=g},619:(h,p,g)=>{Object.defineProperty(p,"__esModule",{value:!0}),p.MessageHandlerRegistry=void 0;var f=g(509),y=g(642),T=function(){function C(E){this.messageHandlers=[],this.logger=new y.Logger("MessageHandlers",E)}return C.prototype.register=function(E){if(this.messageHandlers.some(function(I){return I===E}))throw new Error("Registering the same handler twice is not allowed");this.messageHandlers.push(E)},C.prototype.clear=function(){this.logger.debug("Clearing message handlers"),this.messageHandlers=[]},C.prototype.active=function(){return this.messageHandlers.length>0},C.prototype.handleMessage=function(E){for(var I={resultCode:f.UNHANDLED_MESSAGE_ACK,isHandled:!1},w=0,D=this.messageHandlers;w<D.length;w++){var F=D[w],x=this.safeExecuteHandle(F,E);if(x!==void 0&&(x.isHandled===void 0||x.isHandled))return x.resultCode===void 0&&(x.resultCode=f.HANDLED_MESSAGE_ACK),x}return I},C.prototype.safeExecuteHandle=function(E,I){try{return E.handleMessage(I)}catch(w){return void this.logger.warn("Trouter message handler threw an exception: ".concat(w))}},C}();p.MessageHandlerRegistry=T},902:function(h,p){var g=this&&this.__assign||function(){return g=Object.assign||function(f){for(var y,T=1,C=arguments.length;T<C;T++)for(var E in y=arguments[T])Object.prototype.hasOwnProperty.call(y,E)&&(f[E]=y[E]);return f},g.apply(this,arguments)};Object.defineProperty(p,"__esModule",{value:!0}),p.redirectUrlIfPresent=p.ensureNumber=p.reconnectParamsWithoutUrls=p.adaptUrl=p.isV4ConnectEvent=p.usedProtocolAfterFallback=p.usedProtocol=void 0,p.usedProtocol=function(f,y){return f==="skype"&&(typeof(T=y?.scae)=="string"?T:typeof T=="number"?T.toString():void 0)!=="1"?"v4a":"v4c";var T},p.usedProtocolAfterFallback=function(f,y){return y?.kind==="v4c-websocket-failure"?"v4a":f},p.isV4ConnectEvent=function(f){return Object.prototype.hasOwnProperty.call(f,"connectparams")},p.adaptUrl=function(f,y){return y==="v4a"?f.replace(/\/v4\/c\b/,"/v4/a").replace("wss://","https://").replace("ws://","http://"):f.replace(/\/v4\/a\b/,"/v4/c").replace("https://","wss://").replace("http://","ws://")},p.reconnectParamsWithoutUrls=function(f){if(f!==void 0)return g(g({},f),{reconnectUrl:void 0,serviceUrl:void 0})},p.ensureNumber=function(f){return typeof f=="string"?parseInt(f,10):f},p.redirectUrlIfPresent=function(f){if(f?.kind==="redirect"&&f.host!==void 0){var y=f.host;return y.endsWith("/")&&(y=y.substring(0,y.length-1)),y.endsWith("/v4/c")||y.endsWith("/v4/a")||(y+="/v4/c"),y}}},235:function(h,p,g){var f=this&&this.__spreadArray||function(E,I,w){if(w||arguments.length===2)for(var D,F=0,x=I.length;F<x;F++)!D&&F in I||(D||(D=Array.prototype.slice.call(I,0,F)),D[F]=I[F]);return E.concat(D||Array.prototype.slice.call(I))};Object.defineProperty(p,"__esModule",{value:!0}),p.LoggingManagerConsumer=p.RegistrationEnforcer=void 0;var y=g(335),T=function(){function E(I,w,D){this.wrapped=I,this.shouldConnectionDependOnRegistration=w,this.shouldHoldBackEvents=D,this.isRegistered=!1,this.heldBackEvents=[]}return E.prototype.onDownstreamRequest=function(I,w,D){this.passIfRegisteredOrNotNeeded("onDownstreamRequest",I,w,D)},E.prototype.onConnected=function(I){this.passIfRegisteredOrNotNeeded("onConnected",I)},E.prototype.onRegistered=function(I){this.isRegistered=!0,this.wrapped.onRegistered(I),this.fireHeldBackEvents()},E.prototype.onUnregistered=function(I){var w=this.isRegistered;this.isRegistered=!1,this.wrapped.onUnregistered(I),w&&I.getState()===y.State.Connected&&this.shouldConnectionDependOnRegistration()&&I.forceReconnectDueToNoRegistration()},E.prototype.onReconnecting=function(I){this.wrapped.onReconnecting(I)},E.prototype.onReconnectIsRequired=function(I,w,D){this.wrapped.onReconnectIsRequired(I,w,D)},E.prototype.onDisconnected=function(I){this.isRegistered=!1,this.dropHeldBackEvents(),this.wrapped.onDisconnected(I)},E.prototype.onTerminalError=function(I){this.wrapped.onTerminalError(I)},E.prototype.onConnectionParametersUpdated=function(I){this.wrapped.onConnectionParametersUpdated(I)},E.prototype.onTrouterMessageLost=function(I){this.passIfRegisteredOrNotNeeded("onTrouterMessageLost",I)},E.prototype.onUserActivityStateAccepted=function(I){this.passIfRegisteredOrNotNeeded("onUserActivityStateAccepted",I)},E.prototype.onAudiencesSetResolved=function(I,w){this.passIfRegisteredOrNotNeeded("onAudiencesSetResolved",I,w)},E.prototype.getState=function(){return this.wrapped.getState()},E.prototype.holdBackEvent=function(I){for(var w=[],D=1;D<arguments.length;D++)w[D-1]=arguments[D];this.heldBackEvents.push({kind:I,args:w})},E.prototype.passIfRegisteredOrNotNeeded=function(I){for(var w,D=[],F=1;F<arguments.length;F++)D[F-1]=arguments[F];var x=this.shouldConnectionDependOnRegistration(),B=this.shouldHoldBackEvents();x&&B||this.fireHeldBackEvents(x?function(L){return L.kind!=="onConnected"}:void 0),this.isRegistered||!x||B===!1&&I!=="onConnected"?(w=this.wrapped)[I].apply(w,D):this.holdBackEvent.apply(this,f([I],D,!1))},E.prototype.fireHeldBackEvents=function(I){for(var w,D=0,F=this.heldBackEvents;D<F.length;D++){var x=F[D];(I===void 0||I(x))&&(w=this.wrapped)[x.kind].apply(w,x.args)}this.heldBackEvents=I===void 0?[]:this.heldBackEvents.filter(function(B){return!I(B)})},E.prototype.dropHeldBackEvents=function(){this.heldBackEvents=[]},E}();p.RegistrationEnforcer=T;var C=function(){function E(I,w,D,F){this.wrapped=I,this.prefix=w,this.logger=D,this.onEventAction=F}return E.prototype.onEvent=function(I,w){var D;this.onEventAction!==void 0?this.onEventAction(I,w):((D=this.logger)!==null&&D!==void 0?D:console).log("".concat(this.prefix," TracingEnforcer: ").concat(I,"(").concat(w,")"))},E.prototype.onDownstreamRequest=function(I,w,D){this.onEvent("onDownstreamRequest",JSON.stringify({request:w,response:D})),this.wrapped.onDownstreamRequest(I,w,D)},E.prototype.onConnected=function(I){this.onEvent("onConnected",I.getState().toString()),this.wrapped.onConnected(I)},E.prototype.onRegistered=function(I){this.onEvent("onRegistered",I.getState().toString()),this.wrapped.onRegistered(I)},E.prototype.onUnregistered=function(I){this.onEvent("onUnregistered",I.getState().toString()),this.wrapped.onUnregistered(I)},E.prototype.onReconnecting=function(I){this.onEvent("onReconnecting",I.getState().toString()),this.wrapped.onReconnecting(I)},E.prototype.onReconnectIsRequired=function(I,w,D){this.onEvent("onReconnectIsRequired",JSON.stringify({connection:I.getState().toString(),useConnectParamsFromCache:w,reason:D})),this.wrapped.onReconnectIsRequired(I,w,D)},E.prototype.onDisconnected=function(I){this.onEvent("onDisconnected",I.getState().toString()),this.wrapped.onDisconnected(I)},E.prototype.onTerminalError=function(I){this.onEvent("onTerminalError",JSON.stringify({connection:I})),this.wrapped.onTerminalError(I)},E.prototype.onConnectionParametersUpdated=function(I){this.onEvent("onConnectionParametersUpdated",JSON.stringify({connectParams:I})),this.wrapped.onConnectionParametersUpdated(I)},E.prototype.onTrouterMessageLost=function(I){this.onEvent("onTrouterMessageLost",JSON.stringify({flowTags:I})),this.wrapped.onTrouterMessageLost(I)},E.prototype.onUserActivityStateAccepted=function(I){this.onEvent("onUserActivityStateAccepted",JSON.stringify({cv:I})),this.wrapped.onUserActivityStateAccepted(I)},E.prototype.onAudiencesSetResolved=function(I,w){this.onEvent("onAudiencesSetResolved",JSON.stringify({audienceSubscriptionsResponse:I,cv:w})),this.wrapped.onAudiencesSetResolved(I,w)},E.prototype.getState=function(){return this.wrapped.getState()},E}();p.LoggingManagerConsumer=C},220:function(h,p){var g=this&&this.__awaiter||function(y,T,C,E){return new(C||(C=Promise))(function(I,w){function D(B){try{x(E.next(B))}catch(L){w(L)}}function F(B){try{x(E.throw(B))}catch(L){w(L)}}function x(B){var L;B.done?I(B.value):(L=B.value,L instanceof C?L:new C(function(z){z(L)})).then(D,F)}x((E=E.apply(y,T||[])).next())})},f=this&&this.__generator||function(y,T){var C,E,I,w,D={label:0,sent:function(){if(1&I[0])throw I[1];return I[1]},trys:[],ops:[]};return w={next:F(0),throw:F(1),return:F(2)},typeof Symbol=="function"&&(w[Symbol.iterator]=function(){return this}),w;function F(x){return function(B){return function(L){if(C)throw new TypeError("Generator is already executing.");for(;w&&(w=0,L[0]&&(D=0)),D;)try{if(C=1,E&&(I=2&L[0]?E.return:L[0]?E.throw||((I=E.return)&&I.call(E),0):E.next)&&!(I=I.call(E,L[1])).done)return I;switch(E=0,I&&(L=[2&L[0],I.value]),L[0]){case 0:case 1:I=L;break;case 4:return D.label++,{value:L[1],done:!1};case 5:D.label++,E=L[1],L=[0];continue;case 7:L=D.ops.pop(),D.trys.pop();continue;default:if(!((I=(I=D.trys).length>0&&I[I.length-1])||L[0]!==6&&L[0]!==2)){D=0;continue}if(L[0]===3&&(!I||L[1]>I[0]&&L[1]<I[3])){D.label=L[1];break}if(L[0]===6&&D.label<I[1]){D.label=I[1],I=L;break}if(I&&D.label<I[2]){D.label=I[2],D.ops.push(L);break}I[2]&&D.ops.pop(),D.trys.pop();continue}L=T.call(y,D)}catch(z){L=[6,z],E=0}finally{C=I=0}if(5&L[0])throw L[1];return{value:L[0]?L[1]:void 0,done:!0}}([x,B])}}};Object.defineProperty(p,"__esModule",{value:!0}),p.addCacheAsBackupTo=void 0,p.addCacheAsBackupTo=function(y){var T,C=this;return function(E){return g(C,void 0,void 0,function(){return f(this,function(I){return E&&(T=void 0),[2,new Promise(function(w,D){y(E).then(function(F){T=F,w(F)}).catch(function(F){T!==void 0&&T.length>0&&w(T),D(F)})})]})})}}},573:function(h,p,g){var f=this&&this.__assign||function(){return f=Object.assign||function(ce){for(var X,ve=1,Te=arguments.length;ve<Te;ve++)for(var Be in X=arguments[ve])Object.prototype.hasOwnProperty.call(X,Be)&&(ce[Be]=X[Be]);return ce},f.apply(this,arguments)},y=this&&this.__awaiter||function(ce,X,ve,Te){return new(ve||(ve=Promise))(function(Be,qe){function Ge(Mt){try{ct(Te.next(Mt))}catch(ht){qe(ht)}}function tt(Mt){try{ct(Te.throw(Mt))}catch(ht){qe(ht)}}function ct(Mt){var ht;Mt.done?Be(Mt.value):(ht=Mt.value,ht instanceof ve?ht:new ve(function(vt){vt(ht)})).then(Ge,tt)}ct((Te=Te.apply(ce,X||[])).next())})},T=this&&this.__generator||function(ce,X){var ve,Te,Be,qe,Ge={label:0,sent:function(){if(1&Be[0])throw Be[1];return Be[1]},trys:[],ops:[]};return qe={next:tt(0),throw:tt(1),return:tt(2)},typeof Symbol=="function"&&(qe[Symbol.iterator]=function(){return this}),qe;function tt(ct){return function(Mt){return function(ht){if(ve)throw new TypeError("Generator is already executing.");for(;qe&&(qe=0,ht[0]&&(Ge=0)),Ge;)try{if(ve=1,Te&&(Be=2&ht[0]?Te.return:ht[0]?Te.throw||((Be=Te.return)&&Be.call(Te),0):Te.next)&&!(Be=Be.call(Te,ht[1])).done)return Be;switch(Te=0,Be&&(ht=[2&ht[0],Be.value]),ht[0]){case 0:case 1:Be=ht;break;case 4:return Ge.label++,{value:ht[1],done:!1};case 5:Ge.label++,Te=ht[1],ht=[0];continue;case 7:ht=Ge.ops.pop(),Ge.trys.pop();continue;default:if(!((Be=(Be=Ge.trys).length>0&&Be[Be.length-1])||ht[0]!==6&&ht[0]!==2)){Ge=0;continue}if(ht[0]===3&&(!Be||ht[1]>Be[0]&&ht[1]<Be[3])){Ge.label=ht[1];break}if(ht[0]===6&&Ge.label<Be[1]){Ge.label=Be[1],Be=ht;break}if(Be&&Ge.label<Be[2]){Ge.label=Be[2],Ge.ops.push(ht);break}Be[2]&&Ge.ops.pop(),Ge.trys.pop();continue}ht=X.call(ce,Ge)}catch(vt){ht=[6,vt],Te=0}finally{ve=Be=0}if(5&ht[0])throw ht[1];return{value:ht[0]?ht[1]:void 0,done:!0}}([ct,Mt])}}};Object.defineProperty(p,"__esModule",{value:!0}),p.TrouterConnection=p.ReconnectReason=void 0;var C,E=g(673),I=g(659),w=g(396),D=g(509),F=g(764),x=g(107),B=g(234),L=g(423),z=g(642),H=g(902),j=g(335),J=g(983),Z=function(){this.cv=D.CLIENT_VERSION,this.ua="",this.hr="",this.v=""},re=function(){function ce(){this["force new connection"]=!0,this.reconnect=!1,this.query="",this.ackTimeoutMs=5e3}return ce.prototype.rewriteUrlForProxy=function(X){return X},ce}(),ne="MS-CV",le=function(){function ce(X,ve){this.logger=ve,this.cvCounter=0;var Te=JSON.parse(X);this.startTS=this.safeJsonNumber(Te,"startTS",0),this.url=this.safeJsonString(Te,"url",""),this.shortUrl=this.safeJsonString(Te,"shortUrl",""),this.body=this.safeJsonString(Te,"body",""),this.headers=this.safeJsonRecord(Te,"headers",{}),this.id=this.safeJsonNumber(Te,"id",-1),this.method=this.safeJsonString(Te,"method",""),this.replied=!1,this.timedout=!1,this.receivedCv=this.headers[ne],this.updateCvHeader()}return Object.defineProperty(ce.prototype,"correlationVector",{get:function(){return this.receivedCv?"".concat(this.receivedCv,".").concat(this.cvCounter):""},enumerable:!1,configurable:!0}),ce.prototype.on=function(X,ve){X==="data"?this.dataCallback=ve:X==="end"&&(typeof this.dataCallback=="function"&&this.dataCallback(this.body),ve())},ce.prototype.incrementCorrelationVector=function(){++this.cvCounter,this.updateCvHeader()},ce.prototype.updateCvHeader=function(){var X=this.correlationVector;X&&(this.headers[ne]=X)},ce.prototype.safeJsonNumber=function(X,ve,Te){var Be;if(X!=null&&Object.prototype.hasOwnProperty.call(X,ve)){var qe=X;if(typeof qe[ve]=="number")return qe[ve];if(typeof qe[ve]=="string")return parseFloat(qe[ve]);(Be=this.logger)===null||Be===void 0||Be.warn("unexpected type of '".concat(ve,"': ").concat(typeof qe[ve]))}return Te},ce.prototype.safeJsonString=function(X,ve,Te){var Be;if(X!=null&&Object.prototype.hasOwnProperty.call(X,ve)){var qe=X;if(typeof qe[ve]=="string")return qe[ve];(Be=this.logger)===null||Be===void 0||Be.warn("unexpected type of '".concat(ve,"': ").concat(typeof qe[ve]))}return Te},ce.prototype.safeJsonRecord=function(X,ve,Te){var Be;if(X!=null&&Object.prototype.hasOwnProperty.call(X,ve)){var qe=X;if(typeof qe[ve]=="object")return qe[ve];(Be=this.logger)===null||Be===void 0||Be.warn("unexpected type of '".concat(ve,"': ").concat(typeof qe[ve]))}return Te},ce}(),he=function(){function ce(X,ve,Te){this.request=X,this.responseData=ve,this.sendResponse=Te}return ce.prototype.writeHead=function(X,ve){this.responseData.status=X,this.responseData.headers=ve},ce.prototype.write=function(X){this.responseData.body+=X},ce.prototype.end=function(X){return X&&(this.responseData.body+=X),this.sendResponse(this.request,this.responseData)},ce}(),Me=function(ce){this.name=ce,this.args={},this.timeoutTimerId=0};(function(ce){ce[ce.Configuration=0]="Configuration",ce[ce.ServerInitiated=1]="ServerInitiated"})(C||(p.ReconnectReason=C={}));var Le=function(){function ce(X,ve,Te,Be,qe,Ge,tt,ct){var Mt,ht=this;this.options=ve,this.manager=Te,this.tokenProvider=Be,this.usingLegacyTokenApi=qe,this.protocolSelector=tt,this.audienceSubscriptionState=ct,this.WEBSOCKET_TRANSPORT_NAME="websocket",this.XHR_POLLING_TRANSPORT_NAME="xhr-polling",this.AUDIENCE_SUBSCRIPTION_RESULT_ERROR="Error",this.AUDIENCE_SUBSCRIPTION_RESULT_UNSUBSCRIBED="Unsubscribed",this.AUDIENCE_SUBSCRIPTION_RESULT_TIMEOUT="Timeout",this.AUDIENCE_SUBSCRIPTION_RESULT_BAD_REQUEST="BadRequest",this.AUDIENCE_SUBSCRIPTION_STATE_QUERY_PARAM_REGEX=/&audienceSubscriptionState=[^&]*|^audienceSubscriptionState=[^&]*&?/,this.USER_ACTIVITY_QUERY_PARAM_REGEX=/userActivity=[^&]*/,this.connectionId="",this.inIncallMode=!1,this.connectionAttempt=0,this.connectedClientId="",this.isNavigatorOnline=!0,this.onNavigatorOnlineStatusUpdateBound=this.onNavigatorOnlineStatusUpdate.bind(this),this.c2cUrlBase="",this.connectingErrorsInRow=0,this.connectivityCheckFailuresInARow=0,this.unauthorizedErrorCount=0,this.pendingSentEventTimers={},this.lastDisconnectReason="",this.UNKNOWN_TRANSPORT="unknown_transport",this.connectingErrorsThreshold=3,this.pendingAudienceSubscription=void 0,this.logger=new z.Logger("Connection",X),this.timeoutOptions=this.options.timeoutOptions,this.tokenBackoff=new x.ExponentialBackoff(this.logger,this.timeoutOptions.maxBackoffMs),this.clientID=Date.now(),typeof window<"u"&&window.location&&(this.domId=window.location.hostname);var vt=new Z;vt.cv=D.CLIENT_VERSION,vt.ua="",!((Mt=this.options)===null||Mt===void 0)&&Mt.clientInfo&&(vt.ua=this.safeString(this.options.clientInfo.ua),vt.v=this.safeString(this.options.clientInfo.v)),this.clientInfo=vt,this.connectionTracker=new w.ConnectionTracker(X,this.clientID,this.clientInfo,function(){return ht.getServerState()},this.options.endpointId,this.options.clientCorrelationID,this.options.environment),this.applyConnectionTrackerOptions(ve);var Pt=this.options.incallModeTimeoutMs>0;if(this.fsm=new j.TrouterFsm(X,this,Pt,this.protocolSelector),ve.registration){var ni={registrarUrl:ve.registration.registrarUrl,proxyUrlRewrite:ve.rewriteUrlForProxy,registrationId:ve.registration.registrationId,requestTimeoutMs:ve.timeoutOptions.fetchTimeoutMs,initialRetryDelayMs:1e3,maxRetryDelayMs:ve.timeoutOptions.maxBackoffMs,usingLegacyTokenApi:this.usingLegacyTokenApi,maxRetriesForGetToken:ve.retryLimitOnTokenFetch,extraRegistrationHeaders:ve.extraConnectionHeaders};this.registrarClient=(0,E.createRegistrarClient)(X,this.tokenProvider,ni)}this.userActivityState=Ge}return ce.prototype.start=function(X){this.logger.info("Starting"),this.reconnectParams=X,typeof window<"u"&&window.navigator&&window.addEventListener?(this.isNavigatorOnline=window.navigator.onLine,window.addEventListener("online",this.onNavigatorOnlineStatusUpdateBound),window.addEventListener("offline",this.onNavigatorOnlineStatusUpdateBound),this.logger.debug("Registered for browser online notifications - current state: ".concat(this.isNavigatorOnline))):this.isNavigatorOnline=!0,this.fsm.start()},ce.prototype.stop=function(X){this.logger.info("Stopping"),typeof window<"u"&&window.navigator&&(window.removeEventListener("online",this.onNavigatorOnlineStatusUpdateBound),window.removeEventListener("offline",this.onNavigatorOnlineStatusUpdateBound)),this.fsm.stop(X),this.connectionTracker.close()},ce.prototype.configure=function(X){var ve=this.options.trouterUrl!==X.trouterUrl;this.options=X,this.applyConnectionTrackerOptions(X),ve&&(this.logger.info("Configuration changed. Reconnection required."),this.fsm.onReconnectRequired(!1,C.Configuration))},ce.prototype.checkConnection=function(X){this.logger.info("checkConnection called with ".concat(X)),this.fsm.checkConnection(X),X&&this.connectionTracker.sendTelemetry(w.ClientEventName.CheckConnection,{disconnectDetected:X},[])},ce.prototype.disableRegistrationsAndAutoReconnect=function(){this.stopRegistrationTimer(),this.cancelPendingRegistrationRequests(),this.fsm.disableAutoReconnect()},ce.prototype.getServerState=function(){return new L.ServerState(this.connectionId,this.connectedClientId,this.domId?this.domId:"",this.allocateResult?this.allocateResult.surl:"",this.c2cUrlBase,this.connectionExpireTimestampInSecs)},ce.prototype.getState=function(){return this.fsm.getState()},ce.prototype.getToken=function(X,ve,Te,Be,qe){var Ge=this;qe===void 0&&(qe=0),this.logger.info("Getting token ".concat(ve?"with backoff":"without backoff"));var tt=function(){Ge.connectionTracker.trackStart("token");var ct={needFresh:!X,wwwAuthenticateHeader:Te,supportedTokenTypes:D.SUPPORTED_TOKEN_TYPES,purpose:"trouter"};Ge.logger.info("Requesting token: needFresh=".concat(ct.needFresh," ")+"types=[".concat(D.SUPPORTED_TOKEN_TYPES,"], ")+"wwwAuthenticateHeader is ".concat(ct.wwwAuthenticateHeader?"non empty":"empty")),Ge.tokenProvider(ct).then(function(Mt){Ge.logger.debug("".concat(Mt.tokenType," token is received")),Ge.connectionTracker.trackEnd("token"),Ge.fsm.onTokenReceived(Mt,Be,Ge.reconnectParams)}).catch(function(Mt){var ht=(0,I.toJson)(Mt.stack);if(Ge.logger.error("Getting token failed, will retry after timeout. Error: ".concat(ht)),Ge.connectionTracker.trackError("token",ht),!Ge.canRetryTokenFetchRequest(qe+Ge.unauthorizedErrorCount))return Ge.connectionTracker.trackError("token","getToken retry limit hit, reached terminal error state"),Ge.resetTokenBackoff(),void Ge.fsm.onTerminalError();Ge.getToken(X,!0,Te,Be,qe+1)})};ve?this.tokenBackoff.backoff("getting token",tt):(this.resetTokenBackoff(),tt())},ce.prototype.startConnectionTimer=function(){var X=this;this.stopConnectionTimer(),this.logger.debug("Starting connection timeout for ".concat(this.timeoutOptions.connectionTimeoutMs," ms")),this.connectionTimeoutId=setTimeout(function(){X.logger.info("Connection timeout is fired"),X.fsm.onConnectingTimeout()},this.timeoutOptions.connectionTimeoutMs)},ce.prototype.stopConnectionTimer=function(){this.connectionTimeoutId&&(this.logger.debug("Stopping connection timeout"),clearTimeout(this.connectionTimeoutId),this.connectionTimeoutId=void 0)},ce.prototype.startPingTimer=function(){var X=this;this.transportTypeName==="websocket"?(this.logger.debug("Starting ping timeout for ".concat(this.timeoutOptions.pingTimeoutMs," ms")),this.pingTimerId=setInterval(function(){X.logger.info("Ping interval fired"),X.fsm.onPingInterval()},this.timeoutOptions.pingTimeoutMs)):this.logger.debug("Not starting ping for transport ".concat(this.transportTypeName))},ce.prototype.stopPingTimer=function(){this.pingTimerId&&(this.logger.debug("Stopping ping timeout"),this.clearPingResponseTimer(),clearInterval(this.pingTimerId),this.pingTimerId=void 0)},ce.prototype.shouldSkipRegistration=function(){return this.options.registration===void 0},ce.prototype.hasCustomRegistrationTtl=function(){var X,ve;return((X=this.options.registration)===null||X===void 0?void 0:X.registrarTtlSec)!==void 0&&((ve=this.options.registration)===null||ve===void 0?void 0:ve.registrarTtlSec)!==0},ce.prototype.startRegistrationTimer=function(){var X=this;this.stopRegistrationTimer();var ve=this.getRegistrationTtl(),Te=ve[0],Be=ve[1];if(Te<=30||!Be)return this.logger.debug("Starting registration expiration timer (TTL ".concat(Te," sec)")),void(this.registrationTimerId=setTimeout(function(){X.registrationTimerId=void 0,X.logger.warn("Registration expired but the connection is still alive. Should never happen"),X.dispatchUnregistered()},1e3*Te));var qe=Te-30;this.logger.debug("Starting registration extension timer for ".concat(qe," sec")),this.registrationTimerId=setTimeout(function(){X.logger.info("Registration extension timer fired"),X.registrationTimerId=setTimeout(function(){X.registrationTimerId=void 0,X.logger.debug("Registration extension did not happen in time"),X.dispatchUnregistered()},3e4),X.fsm.onRegistrationNearExpiry()},1e3*qe)},ce.prototype.startRegistrationRetryTimer=function(){var X=this;this.stopRegistrationTimer(),this.registrationTimerId=setTimeout(function(){X.registrationTimerId=void 0,X.fsm.onRetryRegistration()},123e3)},ce.prototype.stopRegistrationTimer=function(){this.registrationTimerId&&(this.logger.debug("Stopping registration timeout"),clearTimeout(this.registrationTimerId),this.registrationTimerId=void 0)},ce.prototype.resendRegistration=function(){if(!this.registrarClient)throw new Error("Trouter Client not configured to handle registrations");return this.fsm.onResendRegistration(),Promise.resolve()},ce.prototype.buildSocketIoUrlParams=function(X,ve){if(!this.allocateResult)throw new Error("Allocate result is undefined in buildSocketIoUrlParams()");for(var Te={},Be=this.allocateResult.connectparams,qe=0,Ge=Object.keys(Be);qe<Ge.length;qe++){var tt=Ge[qe];if(Be[tt]!==void 0){var ct=Be[tt];typeof ct=="string"||typeof ct=="number"?Te[tt]=ct:this.logger.error("signatureData[".concat(tt,"] has unsupported type ").concat(typeof ct))}}return Te.v="v4",Te.tc=encodeURI((0,I.toJson)(this.clientInfo)),Te.timeout=this.timeoutOptions.pingTimeoutMs/1e3,Te.auth="true",this.options.endpointId&&(Te.epid=this.options.endpointId),X&&(Te.userActivity=encodeURIComponent((0,I.toJson)(X))),ve&&(Te.audienceSubscriptionState=encodeURIComponent((0,I.toJson)(ve))),this.appendConnectedClientIds(this.buildQuery(Te),!0)},ce.prototype.startSocketIo=function(X){var ve,Te;if(this.logger.debug("Starting socket io"),this.connectionTracker.trackStart("connectSocket"),!this.allocateResult)throw new Error("Allocate result is undefined in startSocketIo()");var Be=this.options.ioOptions?f({},this.options.ioOptions):new re,qe=this.userActivityState.state!==B.UserActivityState.Unknown?this.userActivityState.increaseCvAndGetEventObject():void 0,Ge=(ve=this.audienceSubscriptionState)===null||ve===void 0?void 0:ve.increaseCvAndGetEventObject();if(Be["force new connection"]=!0,Be.reconnect=!1,Be.rewriteUrlForProxy=this.options.rewriteUrlForProxy,Be.requestHeaders=f(f({},this.options.extraConnectionHeaders),pe(X,this.usingLegacyTokenApi)),Be.query=this.buildSocketIoUrlParams(qe,Ge),this.logger.info("connecting to ".concat(this.allocateResult.socketio)),this.stopSocketIo(),this.socket=((Te=this.options.io)!==null&&Te!==void 0?Te:J).connect(this.allocateResult.socketio,Be),this.socket===void 0)throw new Error("Can't create Socket.io object");this.attachSocketIoHandlers(this.socket,X,qe,Ge)},ce.prototype.stopSocketIo=function(){if(this.socket){this.logger.debug("clearing socket.io");try{for(var X=0,ve=["connecting","connect","connect_failed","close_during_connecting","disconnect","reconnect","reconnect_failed","reconnecting","error","message","trouter.connected","trouter.reconnect","trouter.message_loss"];X<ve.length;X++){var Te=ve[X];this.socket.removeAllListeners(Te)}this.socket.disconnect(),this.logger.debug("cleared socket"),this.socket=void 0}catch(Be){this.logger.error("exception in disconnecting previous socket. Error: ".concat(te(Be)))}}},ce.prototype.dispatchConnected=function(){this.logger.info("dispatching connected"),this.manager.onConnected(this)},ce.prototype.dispatchRegistered=function(){this.logger.info("dispatching registered"),this.manager.onRegistered(this)},ce.prototype.dispatchUnregistered=function(){this.logger.info("dispatching unregistered"),this.manager.onUnregistered(this)},ce.prototype.dispatchDownstreamRequest=function(X){var ve=this;this.logger.debug("dispatching downstream request");try{var Te=new he(X,new w.ResponseData(X.id),function(Be,qe){return ve.logger.debug("sending response to downstream"),ve.sendResponse(Be,qe)});this.manager.onDownstreamRequest(this,X,Te)}catch(Be){this.logger.error("exception in socket.on message. Error : ".concat(te(Be)))}},ce.prototype.dispatchReconnecting=function(){this.logger.info("dispatching reconnecting"),this.manager.onReconnecting(this)},ce.prototype.dispatchReconnectIsRequired=function(X,ve){this.logger.info("dispatching reconnect is required by server"),this.manager.onReconnectIsRequired(this,X,ve)},ce.prototype.dispatchDisconnected=function(){this.logger.info("dispatching disconnected"),this.manager.onDisconnected(this)},ce.prototype.dispatchTerminalError=function(){this.logger.info("dispatching terminal error"),this.manager.onTerminalError(this)},ce.prototype.dispatchTrouterMessageLost=function(X){this.logger.info("dispatching trouter message lost"),this.manager.onTrouterMessageLost(X)},ce.prototype.countDisconnectBeforeConnectionEstablishment=function(){this.logger.warn("counting disconnect before connection was fully established as a connection failure"),this.connectingErrorsInRow++,this.connectingErrorsInRow>=this.connectingErrorsThreshold&&this.resetReconnectParamsOnErrorThreshold()},ce.prototype.sendProcessedDroppedIndicators=function(X){var ve=this;try{this.logger.debug("emitting processed flow tags to the server");var Te=new Me("trouter.processed_message_loss");Te.args={droppedIndicators:X},this.sendDownstreamEvent(Te,function(){ve.logger.info("emitted processed flow tags to the server")})}catch(qe){var Be=te(qe);this.logger.error("unable to send processed message loss event. Error: ".concat(Be)),this.connectionTracker.trackError("trouter.processed_message_loss",Be,!1)}},ce.prototype.sendAllocateRequest=function(X){var ve=this;this.connectionAttempt++,this.connectionTracker.trackNewConnection();var Te,Be=this.options.trouterUrl,qe=this.reconnectParams,Ge=typeof qe?.se=="string"?parseInt(qe.se,10):typeof qe?.se=="number"?qe.se:void 0;Ge&&Ge<=Date.now()+36e5&&(this.logger.warn("Dropping expired cached connection parameters: ".concat(new Date(Ge))),this.reconnectParams=qe=void 0),qe&&qe.serviceUrl!==Be&&(this.logger.warn("Dropping cached connection parameters for a different environment (".concat(qe.serviceUrl,", now ").concat(Be,")")),this.reconnectParams=qe=void 0),qe?.reconnectUrl&&(Be=qe.reconnectUrl),Te=qe?f(f({},qe),{serviceUrl:void 0,reconnectUrl:void 0}):null,Be=(0,H.adaptUrl)(Be,"v4a"),Be=this.appendCorrelationIds(Be,!1);var tt=Be=this.appendEndpointId(Be,!1);Te&&(Be+="&".concat(this.buildQuery(Te)),Te.v||(Be+="&v=".concat("v4"))),Be=this.options.rewriteUrlForProxy(Be);var ct=new Request(Be,{method:"POST",mode:"cors",headers:new Headers(f(f({"Content-Type":"text/plain"},this.options.extraConnectionHeaders),pe(X,this.usingLegacyTokenApi)))});this.logger.info("sendAllocateRequest: POST ".concat(this.options.rewriteUrlForProxy(tt)," (connectparams redacted)}")),this.connectionTracker.trackStart("allocation");var Mt,ht=Date.now(),vt=-1,Pt=!1;(0,I.fetchWithTimeout)(ct,this.timeoutOptions.fetchTimeoutMs).then(function(ni){var Zt;if(vt=ni.status,!ni.ok)throw Mt=(Zt=ni.headers.get("www-authenticate"))!==null&&Zt!==void 0?Zt:void 0,Pt=ni.headers.get("x-trouter-skypetoken-deprecated")==="1",ve.logger.warn("Allocation request got response status ".concat(ni.status,", www-authenticate header was ").concat(Mt?"not empty":"empty")),new Error(ni.statusText);var it=ni.headers.get("content-type");if(!it||it!=="application/json"&&!it.startsWith("application/json;"))throw new Error("Content-type '".concat(it,"' is unexpected"));return ve.connectionTracker.trackEnd("allocation"),ni.json()}).then(function(ni){ve.unauthorizedErrorCount=0,ve.onAllocationResponse(ni,X)}).catch(function(ni){ve.connectingErrorsInRow++;var Zt="".concat(ni).concat(vt>=0?", status code ".concat(vt):"");if(ve.logger.error("".concat(ve.connectingErrorsInRow," failed connecting attempt(s) in a row. ").concat(Zt)),ve.connectionTracker.trackError("allocation",Zt),Pt){var it="Skypetoken deprecated response, not retrying any further";return ve.logger.error(it),ve.connectionTracker.trackError("allocation",it),void ve.fsm.onTerminalError()}if(vt===401&&ve.unauthorizedErrorCount++,!ve.canRetryTokenFetchRequest(ve.unauthorizedErrorCount))return it="getToken retry limit hit, reached terminal error state",ve.connectionTracker.trackError("allocation",it),void ve.fsm.onTerminalError();if(vt!==-1||ve.isNavigatorOnline){if(ve.reconnectParams&&ve.connectingErrorsInRow>=ve.connectingErrorsThreshold){if(vt>=400&&vt<=599)ve.resetReconnectParamsOnErrorThreshold();else if(ve.reconnectParams.reconnectUrl&&ve.connectingErrorsInRow%3==0){ve.logger.warn("".concat(ve.connectingErrorsInRow," connection attempts, testing nominal service URL"));var Ke=Math.min(ve.timeoutOptions.connectionTimeoutMs-(Date.now()-ht)-500,ve.timeoutOptions.fetchTimeoutMs);return void ve.testNominalUrlConnectivity(Ke).then(function(ot){ve.connectionTracker.trackProgress("nomcheck",ot?"ok":"failed"),ot?(ve.logger.warn("Nominal service URL is reachable, erasing cached reconnect URL"),ve.reconnectParams&&delete ve.reconnectParams.reconnectUrl):ve.logger.warn("Nominal service URL is not reachable either, keeping cached reconnect URL"),ve.fsm.onAllocationFailed(!1,void 0)},function(){ve.fsm.onAllocationFailed(!1,void 0)})}}}else ve.logger.info("Expected failure, the browser says it is not online at the moment");ve.fsm.onAllocationFailed(vt===401,Mt)})},ce.prototype.testNominalUrlConnectivity=function(X){var ve,Te=this;if(X<1e3)return this.logger.warn("There is no time left to reasonably perform the nominal service URL connectivity check (".concat(X," ms), falling back to assuming that the connectivity is fine")),Promise.resolve(!0);try{var Be=new URL(this.options.trouterUrl);Be.pathname=Be.pathname.replace(/\/v4\/.*/,"/"),Be.search="?"+this.buildQuery({check:Date.now(),cor_id:encodeURIComponent(this.options.clientCorrelationID),epid:encodeURIComponent(this.options.endpointId?this.options.endpointId:""),tc:encodeURIComponent((0,I.toJson)(this.clientInfo))}),ve=new Request(this.options.rewriteUrlForProxy(Be.toString()),{method:"GET",headers:{Accept:"text/plain"}})}catch(qe){return this.logger.warn("Nominal service URL connectivity test request could not be created (".concat(qe,"), falling back to assuming that the connectivity is fine")),Promise.resolve(!0)}return(0,I.fetchWithTimeout)(ve,X).then(function(qe){if(qe.status!==200)throw new Error("Not 200 OK: ".concat(qe.status," ").concat(qe.statusText));return qe.text()}).then(function(qe){if(qe!=="Trouter")throw new Error('Not "Trouter": '.concat(qe.substring(0,16)).concat(qe.length>16?"...":""));return!0}).catch(function(qe){return Te.logger.error("Nominal service URL connectivity test failed: ".concat(qe)),!1})},ce.prototype.sendPingRequest=function(){var X=this;if(this.socket&&this.pingResponseTimerId===void 0)try{this.logger.debug("emitting ping event");var ve=!1;this.socket.emit("ping",function(){ve!==!0&&X.onPingResponse()}),this.pingResponseTimerId=setTimeout(function(){X.logger.error("Ping response timeout is fired"),ve=!0,X.clearPingResponseTimer(),X.fsm.onPingResponseTimeout()},this.timeoutOptions.pongTimeoutMs)}catch(Be){var Te=te(Be);this.logger.error("unable to send ping. Error: ".concat(Te)),this.connectionTracker.trackError("ping",Te,!1)}},ce.prototype.connectV4c=function(X,ve){var Te,Be,qe,Ge,tt,ct;return y(this,void 0,void 0,function(){var Mt,ht,vt,Pt;return T(this,function(ni){switch(ni.label){case 0:return[4,this.performV4cInitialConnectivityCheck()];case 1:if(ni.sent()===!1)return[2];(Mt=this.options.ioOptions?f({},this.options.ioOptions):new re)["force new connection"]=!0,Mt.reconnect=!1,!((Te=this.reconnectParams)===null||Te===void 0)&&Te.serviceUrl&&(0,H.adaptUrl)(this.reconnectParams.serviceUrl,"v4c")!==(0,H.adaptUrl)(this.options.trouterUrl,"v4c")&&(this.logger.warn("Dropping cached connection parameters for a different environment (".concat(this.reconnectParams.serviceUrl,", now ").concat(this.options.trouterUrl,")")),this.reconnectParams=void 0),ht=(Ge=(Be=(0,H.redirectUrlIfPresent)(ve))!==null&&Be!==void 0?Be:ve?.kind!=="redirect-no-host"?(qe=this.reconnectParams)===null||qe===void 0?void 0:qe.reconnectUrl:void 0)!==null&&Ge!==void 0?Ge:this.options.trouterUrl,vt=(0,H.adaptUrl)(ht,"v4c"),Mt["skipped handshake data"]={timeout:70,websocketUrl:vt},Mt.query=this.buildV4cUrlParams(),Mt.rewriteUrlForProxy=this.options.rewriteUrlForProxy;try{if(this.stopSocketIo(),this.transportTypeName="websocket",this.socket=((tt=this.options.io)!==null&&tt!==void 0?tt:J).connect(this.options.trouterUrl,Mt),this.socket===void 0)throw new Error("failed to create Socket.io object");Pt=(ct=this.audienceSubscriptionState)===null||ct===void 0?void 0:ct.increaseCvAndGetEventObject(),this.attachSocketIoHandlers(this.socket,X,void 0,Pt)}catch(Zt){this.logger.error("".concat(Zt)),this.connectionTracker.trackError("v4c","".concat(Zt)),this.fsm.onV4cException()}return[2]}})})},ce.prototype.performV4cInitialConnectivityCheck=function(){return y(this,void 0,void 0,function(){return T(this,function(X){switch(X.label){case 0:return this.options.initialConnectivityCheck?(this.logger.info("checking connectivity to configured URL (go URL) before a connection attempt"),[4,this.testNominalUrlConnectivity(3e3)]):[2,!0];case 1:return X.sent()?(this.connectivityCheckFailuresInARow=0,[2,!0]):this.connectivityCheckFailuresInARow>=3?(this.connectivityCheckFailuresInARow=0,this.logger.error("three connectivity checks failed in a row, will attempt with the fallback protocol"),this.fsm.onV4cException(),[2,!1]):(this.logger.warn("connectivity check failed, will retry after backoff"),this.connectivityCheckFailuresInARow++,this.fsm.onV4cConnectivityCheckFailed(),[2,!1])}})})},ce.prototype.sendV4cAuthenticationEvent=function(X){var ve,Te={headers:f(f({},this.options.extraConnectionHeaders),pe(X,this.usingLegacyTokenApi)),connectparams:(0,H.reconnectParamsWithoutUrls)(this.reconnectParams)};(ve=this.socket)===null||ve===void 0||ve.emit(D.USER_AUTHENTICATE_EVENT_NAME,Te)},ce.prototype.setUserActivityState=function(X){var ve=X.state!==this.userActivityState.state;this.userActivityState=X,ve?(this.logger.info("Changing user activity state to '".concat(X.toEventJSON(),"'")),this.fsm.onSetNewUserActivityState()):(this.logger.debug("Not changing the same user activity state '".concat(X.toEventJSON(),"'")),this.manager.onUserActivityStateAccepted(X.correlationVector.value()))},ce.prototype.sendUserActivityState=function(X,ve){if(this.userActivityState.state!==B.UserActivityState.Unknown){if(this.options.updateUserActivityDuringConnectionAttempt&&this.socket){var Te=this.userActivityState.toEventObject(),Be=this.socket.socket.options.query;if(Be){var qe="userActivity=".concat(encodeURIComponent((0,I.toJson)(Te)));Be.search(this.USER_ACTIVITY_QUERY_PARAM_REGEX)==-1?this.socket.socket.options.query=Be.concat("&",qe):this.socket.socket.options.query=Be.replace(this.USER_ACTIVITY_QUERY_PARAM_REGEX,qe)}}this.transportTypeName==="websocket"&&ve?X===L.UserActivityEventReason.Connected?this.sendUserActivityStateMultiple(2):this.sendUserActivityStateMultiple(1):this.transportTypeName==="xhr-polling"&&X===L.UserActivityEventReason.Modified&&this.fsm.forceReconnect("user activity/force reconnect")}},ce.prototype.setAudienceSubscriptionsAsync=function(X,ve){var Te=this.audienceSubscriptionState;if(this.audienceSubscriptionState=X,this.transportTypeName===this.WEBSOCKET_TRANSPORT_NAME)return this.setAudienceSubscriptionsInternalAsync(X.increaseCvAndGetEventObject(),ve);if(this.transportTypeName===this.XHR_POLLING_TRANSPORT_NAME){var Be=this.setAudienceSubscriptionsLongpollInternalAsync(X.increaseCvAndGetEventObject(),ve,Te);return this.fsm.forceReconnect("set audience subscription force reconnect"),Be}throw new Error("set audience subscription executed on an unknown transport")},ce.prototype.setAudienceSubscriptionsUnsafeAsync=function(X){if(X)return this.transportTypeName===this.WEBSOCKET_TRANSPORT_NAME?this.setAudienceSubscriptionsInternalAsync(X,15e3):void 0},ce.prototype.setAudienceSubscriptionsInternalAsync=function(X,ve){return y(this,void 0,void 0,function(){var Te,Be,qe=this;return T(this,function(Ge){switch(Ge.label){case 0:return this.logger.info("[WebSocket] Audience subscription set requested."),(Te=new Me("audience.subscribe")).args=X,[4,new Promise(function(tt){var ct=!1,Mt=setTimeout(function(){return ct=!0,tt(qe.buildAudienceSubscriptionsTimeoutResponse(X))},ve);qe.sendDownstreamEvent(Te,function(ht,vt){ct||(clearTimeout(Mt),qe.logger.debug("[Websocket] Audience subscription response: ".concat(vt)),qe.pendingAudienceSubscription&&qe.onAudienceSubscriptionResult(vt),tt(vt))})})];case 1:return Be=Ge.sent(),this.manager.onAudiencesSetResolved(Be,X.cv),[2,Be]}})})},ce.prototype.setAudienceSubscriptionsLongpollInternalAsync=function(X,ve,Te){var Be;return y(this,void 0,void 0,function(){var qe,Ge,tt,ct,Mt,ht,vt=this;return T(this,function(Pt){switch(Pt.label){case 0:return this.logger.info("[XHR Polling] Audience subscription set requested."),this.pendingAudienceSubscription&&(this.logger.error("Racing audience subscriptions occured. This situation resolves into undefined scenario and/or nasal demons."),clearTimeout(this.pendingAudienceSubscription.timeoutId)),X.audiences.length===0?[2,this.handleAudienceUnsubscribeLongpoll(X.cv,Te)]:[4,new Promise(function(ni){var Zt=setTimeout(function(){return vt.pendingAudienceSubscription=void 0,ni(vt.buildAudienceSubscriptionsTimeoutResponse(X))},ve);vt.pendingAudienceSubscription={audienceSetResolve:ni,timeoutId:Zt}})];case 1:return qe=Pt.sent(),this.manager.getState()===B.TrouterState.Unknown||this.transportTypeName===this.WEBSOCKET_TRANSPORT_NAME?[2,qe]:((Ge=qe.responses[0])==null?void 0:Ge.result.audienceSubscriptionState)===this.AUDIENCE_SUBSCRIPTION_RESULT_BAD_REQUEST||((tt=qe.responses.find(function(ni){return ni.audienceId===X.audiences[0].id}))==null?void 0:tt.result.audienceSubscriptionState)===this.AUDIENCE_SUBSCRIPTION_RESULT_ERROR?(this.clearAudienceSubscriptionStateQueryParam(),this.manager.onAudiencesSetResolved(qe,X.cv),[2,qe]):(ct=((Be=Te?.audienceSubscriptionModel.audienceSubscriptions[0])===null||Be===void 0?void 0:Be.id)!==Ge?.audienceId,Te&&ct&&(Mt=this.mapToSyntheticAudienceSubscriptionResponses(Te.audienceSubscriptionModel.audienceSubscriptions,this.AUDIENCE_SUBSCRIPTION_RESULT_UNSUBSCRIBED,200),(ht=qe.responses).push.apply(ht,Mt)),this.manager.onAudiencesSetResolved(qe,X.cv),[2,qe])}})})},ce.prototype.clearAudienceSubscriptionStateQueryParam=function(){var X,ve,Te;!((Te=(ve=(X=this.socket)===null||X===void 0?void 0:X.socket)===null||ve===void 0?void 0:ve.options)===null||Te===void 0)&&Te.query&&(this.socket.socket.options.query=this.socket.socket.options.query.replace(this.AUDIENCE_SUBSCRIPTION_STATE_QUERY_PARAM_REGEX,""))},ce.prototype.handleAudienceUnsubscribeLongpoll=function(X,ve){var Te;this.audienceSubscriptionState=void 0;var Be={responses:[]};if(ve){var qe=this.mapToSyntheticAudienceSubscriptionResponses(ve.audienceSubscriptionModel.audienceSubscriptions,this.AUDIENCE_SUBSCRIPTION_RESULT_UNSUBSCRIBED,200);(Te=Be.responses).push.apply(Te,qe)}return this.manager.onAudiencesSetResolved(Be,X),Be},ce.prototype.buildAudienceSubscriptionsTimeoutResponse=function(X){return this.logger.error("Audience subscription attempt has timed out."),{responses:this.mapToSyntheticAudienceSubscriptionResponses(X.audiences,this.AUDIENCE_SUBSCRIPTION_RESULT_TIMEOUT)}},ce.prototype.mapToSyntheticAudienceSubscriptionResponses=function(X,ve,Te){return X.map(function(Be){return{audienceId:Be.id,result:{audienceSubscriptionState:ve,responseStatus:Te}}})},ce.prototype.expediteBackoff=function(){this.tokenBackoff.expediteIfPending()},ce.prototype.sendRegisterRequest=function(){var X=this;if(!this.options.registration||!this.registrarClient)throw new Error("Internal error - options.registration is undefined");if(!this.allocateResult)throw new Error("Allocate result is undefined in sendRegisterRequest()");this.logger.info("sending register request");var ve=new I.Timespan;this.connectionTracker.trackStart("registration");var Te=this.getRegistrationTtl()[0];this.registrarClient.register({appId:this.options.registration.pnhAppId,aesKey:"",languageId:"en-US",platform:this.options.registration.platform,templateKey:this.options.registration.pnhTemplateKey,platformUIVersion:this.options.registration.platformUIVersion,productContext:this.options.registration.productContext},{TROUTER:[{context:this.options.registration.context,path:this.allocateResult.surl,ttl:Te}]}).then(function(){X.logger.info("Register request successful"),X.connectionTracker.trackEnd("registration"),X.fsm.onRegistrationSucceeded(),X.connectionTracker.sendTelemetry(w.ClientEventName.Registration,{duration:ve.duration},[])}).catch(function(Be){X.logger.error("Register request failed. Error: ".concat(Be)),X.connectionTracker.trackError("registration",Se(Be)),X.fsm.onRegistrationFailed(),X.connectionTracker.sendTelemetry(w.ClientEventName.Registration,{duration:ve.duration},[])})},ce.prototype.sendUnregisterRequest=function(){var X=this;this.logger.info("sending unregister request");var ve=new I.Timespan;if(!this.options.registration||!this.registrarClient)throw new Error("Internal error - options.registration is undefined");this.connectionTracker.trackStart("unregistration"),this.registrarClient.unregister().then(function(){X.logger.info("Unregister request successful"),X.connectionTracker.trackEnd("unregistration"),X.fsm.onUnregistrationDone(),X.connectionTracker.sendTelemetry(w.ClientEventName.Unregistration,{duration:ve.duration},[])}).catch(function(Te){X.logger.error("Unregister request failed. Error: ".concat(Te)),X.connectionTracker.trackError("unregistration",Se(Te)),X.fsm.onUnregistrationDone(),X.connectionTracker.sendTelemetry(w.ClientEventName.Unregistration,{duration:ve.duration},[])})},ce.prototype.resetTokenBackoff=function(){this.tokenBackoff.reset()},ce.prototype.cancelPendingRegistrationRequests=function(){this.registrarClient&&this.registrarClient.cancelPendingRequests()},ce.prototype.clearSentEventTimers=function(){var X=Object.keys(this.pendingSentEventTimers);if(X.length>0){this.logger.debug("Clearing all pending downstream events related timers");for(var ve=0,Te=X;ve<Te.length;ve++){var Be=Te[ve];this.clearSentEventTimer(Number(Be))}}},ce.prototype.restartIncallModeTimer=function(){var X=this;this.clearIncallModeTimerId(),this.logger.debug("Restarting incall mode timer"),this.incallModeTimerId=setTimeout(function(){X.logger.info("Call mode timer fired"),X.fsm.onIncallModeTimer()},this.options.incallModeTimeoutMs)},ce.prototype.enterIncallMode=function(){this.logger.info("Entering incall mode"),this.timeoutOptions=this.options.incallTimeoutOptions,this.tokenBackoff.setMaxBackoffMs(this.timeoutOptions.maxBackoffMs),this.inIncallMode=!0},ce.prototype.exitIncallMode=function(){this.logger.info("Exiting incall mode"),this.clearIncallModeTimerId(),this.timeoutOptions=this.options.timeoutOptions,this.tokenBackoff.setMaxBackoffMs(this.timeoutOptions.maxBackoffMs),this.inIncallMode=!1},ce.prototype.isIncallMode=function(){return this.inIncallMode},ce.prototype.sendDisconnectTelemetryEvent=function(X){var ve={reason:X,serverClosed:!this.fsm.isActive()};this.connectionTracker.trackDisconnected(ve),this.connectionTracker.clearConnectedInfo()},ce.prototype.forceReconnectDueToNoRegistration=function(){this.fsm.forceReconnect("force reconnect due to no registration")},ce.prototype.resetReconnectParamsOnErrorThreshold=function(){this.logger.warn("".concat(this.connectingErrorsInRow," connection attempts, server-side failure: erasing cached connection parameters")),this.reconnectParams=void 0},ce.prototype.onSocketConnecting=function(X){this.logger.info("onSocketConnecting(".concat(X,")")),this.transportTypeName=X,this.connectionTracker.trackProgress("connecting",this.transportTypeName),this.fsm.onConnecting()},ce.prototype.onSocketConnect=function(X){this.logger.info("onSocketConnect"),this.fsm.onSocketConnect(X)},ce.prototype.onSocketConnectFailed=function(X){this.logger.error("onSocketConnectFailed"),this.connectionTracker.trackError("connect_failed",X,!0,this.transportTypeName?this.transportTypeName:this.UNKNOWN_TRANSPORT),this.fsm.onConnectingFailed()},ce.prototype.onSocketDisconnect=function(X){var ve=this.connectionTracker.getSessionLength()||0,Te=F.DisconnectReason.fromRawReason(X);this.logger.error("onSocketDisconnect, reason: ".concat(Te.reason)),Te.reason==="dup"&&this.lastDisconnectReason==="dup"&&ve<this.options.duplicateDisconnectThresholdMs&&(this.logger.warn("Socket was closed by server as Duplicate for the second time in a row "+"after ".concat(ve," ms which is below the threshold of ")+"".concat(this.options.duplicateDisconnectThresholdMs," ms. Resetting cached ")+"connection parameters and making a new allocation."),this.reconnectParams=void 0),this.lastDisconnectReason=Te.reason,this.fsm.onSocketDisconnect(Te),this.connectionExpireTimestampInSecs=void 0},ce.prototype.onSocketReconnect=function(){this.logger.error("onSocketReconnect"),this.fsm.onTrouterConnected()},ce.prototype.onSocketReconnectFailed=function(X){this.logger.error("onSocketReconnectFailed with '".concat(X,"'")),this.fsm.onSocketDisconnect(F.DisconnectReason.fromSocketIoEventData("reconnecterror",X))},ce.prototype.onSocketReconnecting=function(){this.logger.error("onSocketReconnecting")},ce.prototype.onSocketError=function(X){var ve;this.logger.error("onSocketError with '".concat((0,I.toJson)(X),"'")),this.fsm.isConnecting()&&(this.connectingErrorsInRow++,this.connectingErrorsInRow>=this.connectingErrorsThreshold&&this.resetReconnectParamsOnErrorThreshold()),this.connectionTracker.trackError("connectSocket",(ve=X)!=null&&typeof ve.toString=="function"?ve.toString():"[".concat(typeof ve,"]")),this.fsm.onSocketDisconnect(F.DisconnectReason.fromSocketIoEventData("socketerror",X))},ce.prototype.onSocketMessage=function(X){var ve,Te,Be=this;this.logger.debug("onSocketMessage");try{var qe=(ve=(Te=new le(X,this.logger)).headers)===null||ve===void 0?void 0:ve["X-Microsoft-Skype-Chain-ID"],Ge=qe?" Chain-Id ".concat(qe):"";this.logger.info("Received request N ".concat(Te.id).concat(Ge," CV ").concat(Te.correlationVector," to '").concat(Te.url,"'")),Te.startTS=Date.now(),Te.url&&this.urlPath&&Te.url.startsWith(this.urlPath)&&(Te.shortUrl=Te.url.substring(this.urlPath.length))}catch(ct){var tt=te(ct);return this.logger.error("unable to parse request. Error: ".concat(tt)),this.connectionTracker.trackRequest(void 0,tt),void this.connectionTracker.sendResponseError("unable to parse request, error: ".concat(ct))}Te.timeoutTimerId=setTimeout(function(){if(!Te.replied){Be.logger.error("Request ".concat(Te.id," timed out"));var ct=new w.ResponseData(Te.id);ct.status=504,ct.headers={"Trouter-Responder":"ClientLib"},Be.sendResponse(Te,ct),Te.timedout=!0}},this.timeoutOptions.requestTimeoutMs);try{this.connectionTracker.trackRequest(Te),this.fsm.onDownstreamRequest(Te)}catch(ct){this.logger.error("exception in socket.on message. Error: ".concat(te(ct))),this.connectionTracker.sendResponseError(Se(ct),Te,void 0)}},ce.prototype.onTrouterConnected=function(X,ve,Te){var Be,qe,Ge,tt,ct,Mt=this;if((0,H.isV4ConnectEvent)(X)){var ht=X;this.allocateResult=f(f({},ht),{ttl:X.ttl.toString()}),this.populateAndCacheReconnectParams(ht,ht.reconnectUrl),this.populateConnectionStateFields(ht)}else if(!this.allocateResult)return void this.logger.error("Invalid internal state - received onTrouterConnected while allocateResult is not set");this.connectingErrorsInRow=0,this.logger.info("onTrouterConnected: ".concat(this.allocateResult.surl)),this.options.updateUserActivityDuringConnectionAttempt?this.transportTypeName==="xhr-polling"&&(((Be=ve?.state)!==null&&Be!==void 0?Be:"unknown")!==this.userActivityState.getStateString()?(this.logger.info("XHR user activity changed during connection attempt, from '".concat((0,I.toJson)(ve),"' to '").concat(this.userActivityState.toEventJSON(),"', updating")),this.sendUserActivityStateIgnoreResponse()):ve&&this.manager.onUserActivityStateAccepted(ve.cv)):this.transportTypeName==="xhr-polling"&&ve&&this.manager.onUserActivityStateAccepted(ve.cv),!((tt=(Ge=(qe=this.socket)===null||qe===void 0?void 0:qe.socket)===null||Ge===void 0?void 0:Ge.options)===null||tt===void 0)&&tt.query&&(this.socket.socket.options.query+="&connected=true"),this.urlPath=this.allocateResult.surl.replace(/https?:\/\/([A-z0-9\:\$\-\_\.\+\!\*\"\(\)\,]*)\//,"/");var vt=this.connectedUrl!==this.allocateResult.surl;this.connectedUrl=this.allocateResult.surl,this.connectionExpireTimestampInSecs=(0,I.calculateExpireTsInSec)((0,H.ensureNumber)(X.ttl)),this.connectionTracker.trackEnd("connectSocket"),this.connectionTracker.trackConnected(vt,this.transportTypeName?this.transportTypeName:this.UNKNOWN_TRANSPORT),(ct=this.setAudienceSubscriptionsUnsafeAsync(Te))===null||ct===void 0||ct.catch(function(Pt){return Mt.logger.error("Re-subscribe to audiences has failed with ".concat(Pt))}),this.fsm.onTrouterConnected()},ce.prototype.onTrouterReconnect=function(X){var ve=X.target;this.logger.info("onTrouterReconnect target: ".concat(ve)),ve==="self"?this.fsm.onReconnectRequired(!0,C.ServerInitiated):this.fsm.onReconnectRequired(!1,C.ServerInitiated,X)},ce.prototype.onTrouterMessageLoss=function(X){this.logger.debug("onTrouterMessageLoss"),this.fsm.onTrouterMessageLost(X.droppedIndicators)},ce.prototype.onAudienceSubscriptionResult=function(X){this.logger.info("onAudienceSubscriptionResult"),this.pendingAudienceSubscription&&(clearTimeout(this.pendingAudienceSubscription.timeoutId),this.pendingAudienceSubscription.audienceSetResolve(X),this.pendingAudienceSubscription=void 0)},ce.prototype.buildV4cUrlParams=function(){var X={};return X.tc=encodeURI((0,I.toJson)(this.clientInfo)),X.timeout=Math.floor(this.timeoutOptions.pingTimeoutMs/1e3),this.options.endpointId&&(X.epid=this.options.endpointId),this.appendConnectedClientIds(this.buildQuery(X),!0)},ce.prototype.attachSocketIoHandlers=function(X,ve,Te,Be){var qe=this;X.on("connecting",function(Ge){qe.onSocketConnecting(Ge)}),X.on("connect",function(){qe.onSocketConnect(ve)}),X.on("connect_failed",function(Ge){qe.onSocketConnectFailed(Ge)}),X.on("close_during_connecting",function(Ge){qe.onSocketConnectFailed(Ge)}),X.on("disconnect",function(Ge){qe.onSocketDisconnect(Ge)}),X.on("reconnect",function(){qe.onSocketReconnect()}),X.on("reconnect_failed",function(Ge){qe.onSocketReconnectFailed(Ge)}),X.on("reconnecting",function(){qe.onSocketReconnecting()}),X.on("error",function(Ge){qe.onSocketError(Ge)}),X.on("message",function(Ge){qe.onSocketMessage(Ge)}),X.on("trouter.connected",function(Ge){qe.onTrouterConnected(Ge,Te,Be)}),X.on("trouter.reconnect",function(Ge){qe.onTrouterReconnect(Ge)}),X.on("trouter.message_loss",function(Ge){qe.onTrouterMessageLoss(Ge)}),X.on("audience.subscriptionresult",function(Ge,tt){qe.onAudienceSubscriptionResult(tt)})},ce.prototype.onNavigatorOnlineStatusUpdate=function(){var X=window.navigator.onLine;this.logger.debug("Browser online status update - new state: ".concat(X,", previously: ").concat(this.isNavigatorOnline)),X&&!this.isNavigatorOnline?(this.isNavigatorOnline=!0,this.tokenBackoff.expediteIfPending(),this.connectionTracker.trackProgress("browserNet","online")):!X&&this.isNavigatorOnline&&(this.isNavigatorOnline=!1,this.connectionTracker.trackProgress("browserNet","offline"))},ce.prototype.onAllocationResponse=function(X,ve){this.logger.info("Received allocation response ".concat(JSON.stringify(f(f({},X),{connectparams:void 0}))," (connectparams redacted)")),this.allocateResult=X,this.populateAndCacheReconnectParams(this.allocateResult,"".concat(this.allocateResult.socketio,"v4/a")),this.populateConnectionStateFields(this.allocateResult),this.fsm.onAllocationSucceed(ve)},ce.prototype.populateAndCacheReconnectParams=function(X,ve){this.reconnectParams=f({serviceUrl:this.options.trouterUrl,reconnectUrl:ve},X.connectparams),this.manager.onConnectionParametersUpdated(this.reconnectParams)},ce.prototype.populateConnectionStateFields=function(X){var ve,Te,Be=typeof X.ttl=="string"?parseInt(X.ttl,10):X.ttl;if(this.connectionExpireTimestampInSecs=(0,I.calculateExpireTsInSec)(Be),this.connectionId=(ve=X.id)!==null&&ve!==void 0?ve:"",this.connectedClientId=X.ccid,this.logger.debug("connected client id set {connectedClientId:".concat(this.connectedClientId,"}")),this.c2cUrlBase=(Te=X.curlb)!==null&&Te!==void 0?Te:"",this.c2cUrlBase===""){var qe=X.surl.indexOf("://");qe>=0&&(qe=X.surl.indexOf("/",qe+3))>=5&&X.surl.substr(qe-5,5)===":3443"&&(this.c2cUrlBase=X.surl.substr(0,qe-5))}},ce.prototype.onPingResponse=function(){this.logger.debug("onPingResponse"),this.connectionTracker.increasePingResponseCount(),this.clearPingResponseTimer(),this.fsm.onPingResponse()},ce.prototype.clearPingResponseTimer=function(){this.pingResponseTimerId!==void 0&&(clearTimeout(this.pingResponseTimerId),this.pingResponseTimerId=void 0)},ce.prototype.buildQuery=function(X){for(var ve=[],Te=0,Be=Object.keys(X);Te<Be.length;Te++){var qe=Be[Te];X[qe]!==void 0&&ve.push("".concat(qe,"=").concat(X[qe]))}return ve.join("&")},ce.prototype.appendConnectedClientIds=function(X,ve){var Te="";X.includes("ccid=")||(Te="ccid=".concat(this.connectedClientId,"&")),this.domId&&(Te+="dom=".concat(this.domId,"&")),Te.length>0&&(Te=Te.slice(0,-1));var Be=ve||X.includes("?")?"&":"?";return this.appendCorrelationIds(X+Be+Te,ve)},ce.prototype.appendEndpointId=function(X,ve){var Te=ve||X.includes("?")?"&":"?";return!X.includes("epid")&&this.options.endpointId?"".concat(X).concat(Te,"epid=").concat(this.options.endpointId):X},ce.prototype.appendCorrelationIds=function(X,ve){var Te=ve||X.includes("?")?"&":"?";return X.includes("cor_id")?X:"".concat(X).concat(Te,"cor_id=").concat(this.options.clientCorrelationID)+"&con_num=".concat(this.clientID,"_").concat(this.connectionAttempt)},ce.prototype.safeString=function(X){return typeof X=="string"?X:""},ce.prototype.sendResponse=function(X,ve){var Te,Be,qe;if(X.timedout)return this.logger.error("Request ".concat(X.id," already timed out")),1;if(X.replied)return this.logger.error("Response for request ".concat(X.id," already sent")),2;clearTimeout(X.timeoutTimerId),X.timeoutTimerId=void 0,X.replied=!0,ve.headers=(Te=ve.headers)!==null&&Te!==void 0?Te:{};var Ge=X.correlationVector;this.logger.info("Sending response N ".concat(X.id," CV ").concat(Ge," with status ").concat(ve.status)),Ge&&(ve.headers[ne]=Ge),!((Be=X.headers)===null||Be===void 0)&&Be["trouter-request"]&&(ve.headers["trouter-request"]=X.headers["trouter-request"]);var tt=Date.now()-X.startTS;if(ve.headers["trouter-client"]=(0,I.toJson)({cd:tt}),!((qe=X.headers)===null||qe===void 0)&&qe["trouter-is-broadcast"]&&(ve.headers["trouter-is-broadcast"]=X.headers["trouter-is-broadcast"]),!this.socket)return this.connectionTracker.sendResponseError("no socket",X,ve),4;try{return this.socket.send((0,I.toJson)(ve)),ve.sentTS=Date.now(),X.incrementCorrelationVector(),this.connectionTracker.trackResponse(X,tt,ve),this.transportTypeName==="websocket"&&this.sendPingRequest(),0}catch(Mt){var ct="unable to send data on response.end. Error: ".concat(te(Mt));return this.logger.error(ct),this.connectionTracker.sendResponseError(ct,X,ve),4}},ce.prototype.sendUserActivityStateMultiple=function(X){var ve=this,Te=new Me("user.activity"),Be=this.userActivityState.increaseCvAndGetEventObject();Te.args=Be,this.logger.debug("Sending user activity '".concat(this.userActivityState.toEventJSON(),"', remaining ").concat(X-1));var qe=!1;this.sendDownstreamEvent(Te,function(){if(qe!==!0&&(ve.logger.info("User activity state: ".concat(Be.state,", cv: ").concat(Be.cv," accepted")),ve.manager.onUserActivityStateAccepted(Be.cv),ve.clearSentEventTimer(Te.timeoutTimerId),X>1)){var Ge=setTimeout(function(){ve.clearSentEventTimer(Ge),ve.sendUserActivityStateMultiple(X-1)},ve.options.userActivitySecondResendDelayMs);ve.registerSentEventTimer(Ge,"user.activity/resend")}}),Te.timeoutTimerId=setTimeout(function(){ve.logger.error("Activity state response timeout is fired"),qe=!0,ve.fsm.onActivityStateResponseTimeout(),ve.clearSentEventTimer(Te.timeoutTimerId)},this.timeoutOptions.userActivityResponseTimeoutMs),this.registerSentEventTimer(Te.timeoutTimerId,"user.activity/response")},ce.prototype.sendUserActivityStateIgnoreResponse=function(){var X=new Me("user.activity"),ve=this.userActivityState.toEventObject();X.args=ve,this.socket&&(this.logger.info("Sending user activity after XHR connect, ".concat(ve.state,", cv: ").concat(ve.cv,", treating it as accepted")),this.socket.emit(X.name,X.args),this.manager.onUserActivityStateAccepted(ve.cv))},ce.prototype.sendDownstreamEvent=function(X,ve){this.logger.debug("Sending downstream event ".concat(X.name)),this.socket&&this.socket.emit(X.name,X.args,ve)},ce.prototype.registerSentEventTimer=function(X,ve){this.logger.debug("registering timer ".concat(X," -> ").concat(ve)),this.pendingSentEventTimers[X]=ve},ce.prototype.clearSentEventTimer=function(X){var ve=this.pendingSentEventTimers[X];this.logger.debug("clearing timer ".concat(X," -> ").concat(ve)),delete this.pendingSentEventTimers[X],clearTimeout(X)},ce.prototype.getRegistrationTtl=function(){var X,ve,Te=(0,I.calculateTtlInSec)(this.connectionExpireTimestampInSecs);if(this.logger.debug("Current connectionID will expire in ".concat(Te," seconds")),((X=this.options.registration)===null||X===void 0?void 0:X.registrarTtlSec)&&Te>0){var Be=this.options.registration.registrarTtlSec<Te;return[Math.min(this.options.registration.registrarTtlSec,Te),Be]}return!((ve=this.options.registration)===null||ve===void 0)&&ve.registrarTtlSec?[this.options.registration.registrarTtlSec,!1]:Te>0?[Te,!1]:[3600,!1]},ce.prototype.clearIncallModeTimerId=function(){this.incallModeTimerId!==void 0&&(this.logger.debug("Clearing in-call mode timer"),clearTimeout(this.incallModeTimerId),this.incallModeTimerId=void 0)},ce.prototype.applyConnectionTrackerOptions=function(X){try{X.eventLogger&&typeof X.eventLogger.logEvent=="function"?(this.connectionTracker.mergeSettings(X.telemetrySettings),this.connectionTracker.enable(X.eventLogger)):this.logger.warn("Trouter client event logging disabled due to invalid configuration.")}catch(ve){this.logger.warn("Trouter client event logging disabled. Error: ".concat(te(ve))),this.connectionTracker.disable()}},ce.prototype.canRetryTokenFetchRequest=function(X){var ve=this.options.retryLimitOnTokenFetch;return ve==null||X<ve||(this.logger.warn("Reached limit on maximum number of token fetch request. Current count: ".concat(X,", retry limit: ").concat(ve)),!1)},ce}();function pe(ce,X){var ve=X?void 0:{"X-MS-Migration":"True"};switch(ce.tokenType.toLowerCase()){case"skype":return f({"X-Skypetoken":ce.token},ve);case"aad":case"cae":return f({Authorization:"Bearer ".concat(ce.token)},ve);default:throw new Error("unsupported token type: ".concat(ce.tokenType))}}function te(ce){return typeof ce=="object"&&ce!==null&&ce.stack!==void 0?(0,I.toJson)(ce.stack):'"(no error.stack)"'}function Se(ce){return typeof ce=="object"&&ce!==null&&typeof ce.message=="string"?ce.message:"(no error.message)"}p.TrouterConnection=Le},335:(h,p,g)=>{Object.defineProperty(p,"__esModule",{value:!0}),p.TrouterFsm=p.State=void 0;var f,y,T=g(423),C=g(642),E=g(902);(function(w){w[w.Initial=0]="Initial",w[w.RetrievingToken=1]="RetrievingToken",w[w.Allocating=2]="Allocating",w[w.Handshaking=3]="Handshaking",w[w.Connecting=4]="Connecting",w[w.AnonymousConnecting=5]="AnonymousConnecting",w[w.WebsocketAuthenticating=6]="WebsocketAuthenticating",w[w.Connected=7]="Connected",w[w.Unregistering=8]="Unregistering",w[w.TerminalError=9]="TerminalError"})(f||(p.State=f={})),function(w){w[w.Initial=0]="Initial",w[w.Registering=1]="Registering",w[w.RegisteringButResendPending=2]="RegisteringButResendPending",w[w.Retrying=3]="Retrying",w[w.Registered=4]="Registered",w[w.RegistrationDisabled=5]="RegistrationDisabled"}(y||(y={}));var I=function(){function w(D,F,x,B){this.worker=F,this.incallModeEnabled=x,this.protocolSelector=B,this.state=f.Initial,this.autoReconnect=!0,this.logger=new C.Logger("ConnectionFsm",D),this.registrationState=y.Initial}return w.prototype.getState=function(){return this.state},w.prototype.isActive=function(){return this.state===f.Allocating||this.state===f.Connected||this.state===f.Handshaking||this.state===f.Connecting||this.state===f.RetrievingToken||this.state===f.AnonymousConnecting||this.state===f.WebsocketAuthenticating},w.prototype.isConnecting=function(){return this.state===f.Allocating||this.state===f.Handshaking||this.state===f.Connecting||this.state===f.AnonymousConnecting},w.prototype.start=function(){return this.state===f.Initial?(this.setState(f.RetrievingToken),this.worker.getToken(!0,!1,void 0),!0):(this.showIgnored("start"),!1)},w.prototype.stop=function(D,F){D&&(this.registrationState=y.Initial),this.worker.isIncallMode()&&this.worker.exitIncallMode(),this.worker.resetTokenBackoff(),this.worker.cancelPendingRegistrationRequests(),this.worker.stopConnectionTimer(),this.worker.stopPingTimer(),this.worker.clearSentEventTimers(),this.worker.stopRegistrationTimer(),this.worker.stopSocketIo(),this.state===f.Connected&&this.worker.sendDisconnectTelemetryEvent("connection stopped"),this.registrationState!==y.Registered&&this.registrationState!==y.Registering&&this.registrationState!==y.RegisteringButResendPending||this.state===f.Unregistering?F?(this.setState(f.TerminalError),this.worker.dispatchTerminalError()):(this.setState(f.Initial),this.worker.dispatchDisconnected()):(this.registrationState=y.Initial,this.setState(f.Unregistering),this.worker.sendUnregisterRequest())},w.prototype.onTokenReceived=function(D,F,x){this.state===f.RetrievingToken?(0,E.usedProtocolAfterFallback)(this.protocolSelector(D.tokenType,x),F)==="v4c"?(this.setState(f.AnonymousConnecting),this.worker.startConnectionTimer(),this.worker.connectV4c(D,F)):(this.setState(f.Allocating),this.worker.startConnectionTimer(),this.worker.sendAllocateRequest(D)):this.showIgnored("onTokenReceived")},w.prototype.checkConnection=function(D){D&&this.onPingInterval()},w.prototype.onAllocationSucceed=function(D){return this.state===f.Allocating&&this.registrationState===y.Registered&&this.worker.dispatchUnregistered(),this.state===f.Allocating?(this.setState(f.Handshaking),this.registrationState=y.Initial,this.worker.startSocketIo(D),!0):(this.showIgnored("onAllocationSucceed"),!1)},w.prototype.onAllocationFailed=function(D,F){this.state===f.Allocating?this.cleanUpAndInitiateReconnect({backoff:!0,allowCachedToken:!D,claimsChallenge:F}):this.showIgnored("onAllocationFailed")},w.prototype.onV4cConnectivityCheckFailed=function(){this.state===f.AnonymousConnecting?this.cleanUpAndInitiateReconnect({backoff:!0,allowCachedToken:!0}):this.showIgnored("onV4cConnectivityCheckFailed")},w.prototype.onV4cException=function(){this.state!==f.AnonymousConnecting&&this.state!==f.WebsocketAuthenticating||(this.logger.error("v4c exception, falling back to longpoll"),this.cleanUpAndInitiateReconnect({backoff:!0,allowCachedToken:!0,fallbackReason:{kind:"v4c-websocket-failure"}}))},w.prototype.onConnectingTimeout=function(){this.state===f.Allocating||this.state===f.Connecting||this.state===f.Handshaking||this.state===f.AnonymousConnecting||this.state===f.WebsocketAuthenticating?this.cleanUpAndInitiateReconnect({backoff:!1,allowCachedToken:!0}):this.showIgnored("onConnectingTimeout")},w.prototype.onConnecting=function(){this.state===f.Handshaking?this.setState(f.Connecting):this.showIgnored("onConnecting")},w.prototype.onSocketConnect=function(D){this.state===f.AnonymousConnecting?(this.setState(f.WebsocketAuthenticating),this.worker.sendV4cAuthenticationEvent(D)):this.showIgnored("onSocketConnect")},w.prototype.onConnectingFailed=function(){this.state===f.Connecting?this.onConnectingTimeout():this.state===f.Handshaking?(this.logger.error("Unexpected error in Socket.io - no valid transports"),this.onConnectingTimeout()):this.state===f.AnonymousConnecting||this.state===f.WebsocketAuthenticating?(this.logger.info("/v4/c falling back to longpoll"),this.cleanUpAndInitiateReconnect({backoff:!0,allowCachedToken:!0,fallbackReason:{kind:"v4c-websocket-failure"}})):this.showIgnored("onConnectingFailed")},w.prototype.onSocketDisconnect=function(D){this.state===f.Handshaking||this.state===f.Connected||this.state===f.WebsocketAuthenticating?(this.state===f.Connected&&this.worker.sendDisconnectTelemetryEvent(D?.toTelemetryString()),this.state===f.WebsocketAuthenticating&&this.worker.countDisconnectBeforeConnectionEstablishment(),D?.reason==="skypetoken-deprecated"?(this.logger.error("Skypetoken deprecated response, not retrying any further"),this.onTerminalError()):this.cleanUpAndInitiateReconnect({backoff:this.state!==f.Connected&&D?.reason!=="dup",allowCachedToken:D?.reason!=="unauthorized",claimsChallenge:D?.claims})):this.showIgnored("onSocketDisconnect")},w.prototype.onTrouterConnected=function(){this.state===f.Connecting||this.state===f.WebsocketAuthenticating?(this.setState(f.Connected),this.worker.resetTokenBackoff(),this.worker.stopConnectionTimer(),this.worker.sendUserActivityState(T.UserActivityEventReason.Connected,!0),this.worker.startPingTimer(),this.worker.dispatchConnected(),this.worker.shouldSkipRegistration()?(this.registrationState=y.RegistrationDisabled,this.worker.dispatchRegistered()):(this.registrationState=y.Registering,this.worker.sendRegisterRequest())):this.showIgnored("onTrouterConnected")},w.prototype.onReconnectRequired=function(D,F,x){this.state===f.AnonymousConnecting||this.state===f.WebsocketAuthenticating?x===void 0||x.target!=="host"||x.url===void 0||x.url===""?(this.logger.error("unexpected reconnect arguments: ".concat(x?.target," ").concat(x?.url,", reconnecting without cache")),this.cleanUpAndInitiateReconnect({backoff:!0,allowCachedToken:!0,fallbackReason:{kind:"redirect-no-host"}})):this.cleanUpAndInitiateReconnect({backoff:!0,allowCachedToken:!0,fallbackReason:{kind:"redirect",host:x.url}}):this.worker.dispatchReconnectIsRequired(D,F)},w.prototype.disableAutoReconnect=function(){this.autoReconnect=!1},w.prototype.onDownstreamRequest=function(D){this.state===f.Connected?(this.switchToIncallModeIfEnabled(),this.worker.dispatchDownstreamRequest(D)):this.showIgnored("onDownstreamRequest")},w.prototype.onTrouterMessageLost=function(D){this.state===f.Connected?this.worker.dispatchTrouterMessageLost(D):this.showIgnored("onTrouterMessageLost")},w.prototype.onPingInterval=function(){this.state===f.Connected?this.worker.sendPingRequest():this.showIgnored("onPingInterval")},w.prototype.onPingResponseTimeout=function(){this.onMissedResponse("onPingResponseTimeout")},w.prototype.onPingResponse=function(){this.state===f.Connected||this.showIgnored("onPingResponse")},w.prototype.onRegistrationFailed=function(){this.state===f.Connected&&this.registrationState===y.Registering?(this.worker.dispatchUnregistered(),this.registrationState=y.Retrying,this.worker.startRegistrationRetryTimer()):this.state===f.Connected&&this.registrationState===y.RegisteringButResendPending?(this.registrationState=y.Registering,this.worker.sendRegisterRequest()):this.showIgnored("onRegistrationFailed")},w.prototype.onRetryRegistration=function(){this.state===f.Connected&&this.registrationState===y.Retrying?(this.registrationState=y.Registering,this.worker.sendRegisterRequest()):this.showIgnored("onRetryRegistration")},w.prototype.onRegistrationSucceeded=function(){this.state===f.Connected&&this.registrationState===y.Registering?(this.registrationState=y.Registered,this.worker.dispatchRegistered(),this.worker.startRegistrationTimer()):this.state===f.Connected&&this.registrationState===y.RegisteringButResendPending?(this.registrationState=y.Registering,this.worker.sendRegisterRequest()):this.showIgnored("onRegistrationSucceeded")},w.prototype.onRegistrationNearExpiry=function(){this.state===f.Connected&&this.registrationState===y.Registered?(this.registrationState=y.Registering,this.worker.sendRegisterRequest()):this.showIgnored("onRegistrationNearExpiry")},w.prototype.onUnregistrationDone=function(){this.state===f.Unregistering?(this.setState(f.Initial),this.worker.dispatchUnregistered(),this.worker.dispatchDisconnected()):this.showIgnored("onUnregistrationDone")},w.prototype.onResendRegistration=function(){this.worker.dispatchUnregistered(),this.state===f.Connected&&this.registrationState===y.Registered?(this.registrationState=y.Registering,this.worker.stopRegistrationTimer(),this.worker.sendRegisterRequest()):this.state===f.Connected&&this.registrationState===y.Registering&&(this.registrationState=y.RegisteringButResendPending)},w.prototype.onIncallModeTimer=function(){this.worker.exitIncallMode(),this.state===f.Connected?(this.worker.stopPingTimer(),this.worker.startPingTimer()):this.showIgnored("onIncallModeTimer")},w.prototype.onSetNewUserActivityState=function(){this.worker.sendUserActivityState(T.UserActivityEventReason.Modified,this.state===f.Connected)},w.prototype.onActivityStateResponseTimeout=function(){this.onMissedResponse("onActivityStateResponseTimeout")},w.prototype.forceReconnect=function(D){this.state===f.Connected&&this.worker.sendDisconnectTelemetryEvent(D),this.worker.resetTokenBackoff(),this.cleanUpAndInitiateReconnect({backoff:!1,allowCachedToken:!0})},w.prototype.onTerminalError=function(){this.logger.error("Cannot proceed, reached terminal state. Switching from state '".concat(f[this.state],"' to ").concat(f[f.TerminalError])),this.stop(!0,!0),this.setState(f.TerminalError)},w.prototype.onMissedResponse=function(D){this.state===f.Connected?(this.worker.sendDisconnectTelemetryEvent(D),this.cleanUpAndInitiateReconnect({backoff:!1,allowCachedToken:!0})):this.showIgnored(D)},w.prototype.showIgnored=function(D){this.logger.debug("Ignoring event '".concat(D,"' in state '").concat(f[this.state],"'"))},w.prototype.setState=function(D){this.logger.info("Switching from state '".concat(f[this.state],"' to state '").concat(f[D],"'")),this.state!==D?this.state=D:this.logger.error("Attempt to switch to the current state '".concat(f[D],"'"))},w.prototype.switchToIncallModeIfEnabled=function(){this.incallModeEnabled&&(this.worker.isIncallMode()||(this.worker.enterIncallMode(),this.worker.stopPingTimer(),this.worker.startPingTimer()),this.worker.restartIncallModeTimer())},w.prototype.cleanUpAndInitiateReconnect=function(D){if(!this.autoReconnect)return this.logger.info("Automatic reconnect is disabled, stopping this connection"),void this.stop(!0);this.worker.cancelPendingRegistrationRequests(),this.worker.stopConnectionTimer(),this.worker.stopPingTimer(),this.worker.clearSentEventTimers(),this.worker.stopRegistrationTimer(),this.worker.stopSocketIo(),this.setState(f.RetrievingToken),this.worker.dispatchReconnecting(),this.worker.getToken(D.allowCachedToken,D.backoff,D.claimsChallenge,D.fallbackReason)},w}();p.TrouterFsm=I},634:function(h,p,g){var f=this&&this.__awaiter||function(j,J,Z,re){return new(Z||(Z=Promise))(function(ne,le){function he(pe){try{Le(re.next(pe))}catch(te){le(te)}}function Me(pe){try{Le(re.throw(pe))}catch(te){le(te)}}function Le(pe){var te;pe.done?ne(pe.value):(te=pe.value,te instanceof Z?te:new Z(function(Se){Se(te)})).then(he,Me)}Le((re=re.apply(j,J||[])).next())})},y=this&&this.__generator||function(j,J){var Z,re,ne,le,he={label:0,sent:function(){if(1&ne[0])throw ne[1];return ne[1]},trys:[],ops:[]};return le={next:Me(0),throw:Me(1),return:Me(2)},typeof Symbol=="function"&&(le[Symbol.iterator]=function(){return this}),le;function Me(Le){return function(pe){return function(te){if(Z)throw new TypeError("Generator is already executing.");for(;le&&(le=0,te[0]&&(he=0)),he;)try{if(Z=1,re&&(ne=2&te[0]?re.return:te[0]?re.throw||((ne=re.return)&&ne.call(re),0):re.next)&&!(ne=ne.call(re,te[1])).done)return ne;switch(re=0,ne&&(te=[2&te[0],ne.value]),te[0]){case 0:case 1:ne=te;break;case 4:return he.label++,{value:te[1],done:!1};case 5:he.label++,re=te[1],te=[0];continue;case 7:te=he.ops.pop(),he.trys.pop();continue;default:if(!((ne=(ne=he.trys).length>0&&ne[ne.length-1])||te[0]!==6&&te[0]!==2)){he=0;continue}if(te[0]===3&&(!ne||te[1]>ne[0]&&te[1]<ne[3])){he.label=te[1];break}if(te[0]===6&&he.label<ne[1]){he.label=ne[1],ne=te;break}if(ne&&he.label<ne[2]){he.label=ne[2],he.ops.push(te);break}ne[2]&&he.ops.pop(),he.trys.pop();continue}te=J.call(j,he)}catch(Se){te=[6,Se],re=0}finally{Z=ne=0}if(5&te[0])throw te[1];return{value:te[0]?te[1]:void 0,done:!0}}([Le,pe])}}};Object.defineProperty(p,"__esModule",{value:!0}),p.TrouterManager=p.AudienceSubscriptionState=p.UserActivityObject=void 0;var T=g(659),C=g(234),E=g(423),I=g(642),w=g(902),D=g(235),F=g(573),x=g(335),B=g(10),L=function(){function j(J,Z){this.state=J,this.correlationVector=Z!==void 0?Z:T.CorrelationVector.extend()}return j.prototype.getStateString=function(){switch(this.state){case C.UserActivityState.Active:return"active";case C.UserActivityState.Inactive:return"inactive";case C.UserActivityState.Unknown:return"unknown";default:return"undefined"}},j.prototype.increaseCvAndGetEventObject=function(){return this.correlationVector.increase(),this.toEventObject()},j.prototype.toEventObject=function(){return{state:this.getStateString(),cv:this.correlationVector.value()}},j.prototype.toEventJSON=function(){return(0,T.toJson)(this.toEventObject())},j}();p.UserActivityObject=L;var z=function(){function j(J,Z){Z===void 0&&(Z=T.CorrelationVector.extend()),this.audienceSubscriptionModel=J,this.correlationVector=Z}return j.prototype.increaseCvAndGetEventObject=function(){return this.correlationVector.increase(),this.toEventObject()},j.prototype.toEventObject=function(){return{audiences:this.audienceSubscriptionModel.audienceSubscriptions,cv:this.correlationVector.value()}},j.prototype.toEventJSON=function(){return(0,T.toJson)(this.toEventObject())},j}();p.AudienceSubscriptionState=z;var H=function(){function j(J,Z,re,ne,le,he){var Me=this;this.logFunc=J,this.options=Z,this.tokenProvider=re,this.usingLegacyTokenApi=ne,this.listener=le,this.tokenTypeProtocolSelector=function(Le,pe){return Me.options.forceV4aProtocol?"v4a":(0,w.usedProtocol)(Le,pe)},this.logger=new I.Logger("Manager",J),this.logger.info("Created TrouterManager with options ".concat((0,T.toJson)(this.options))),this.fsm=new B.TrouterManagerFsm(J,this),this.baseEndpointUrl="",this.processedMessageLoss={},this.userActivityObject=new L(C.UserActivityState.Unknown),this.protocolSelector=he??this.tokenTypeProtocolSelector.bind(this)}return j.prototype.start=function(){this.fsm.start()},j.prototype.stop=function(J){this.fsm.stop(J)},j.prototype.configure=function(J){this.options=J,this.firstConnection!==void 0&&this.firstConnection.configure(J),this.secondConnection!==void 0&&this.secondConnection.configure(J),this.logger.info("Reconfigured TrouterManager with options ".concat((0,T.toJson)(this.options)))},j.prototype.checkConnection=function(J){this.firstConnection!==void 0&&this.firstConnection.checkConnection(J),this.secondConnection!==void 0&&this.secondConnection.checkConnection(J)},j.prototype.resendRegistration=function(){return f(this,void 0,void 0,function(){return y(this,function(J){return this.secondConnection!==void 0?(this.logger.info("Resending registration on the second/new connection"),[2,this.secondConnection.resendRegistration()]):this.firstConnection!==void 0?(this.logger.info("Resending registration on the first/current connection"),[2,this.firstConnection.resendRegistration()]):(this.logger.info("No connection to resend registration on, will be done upon (re)connect"),[2])})})},j.prototype.getServerState=function(){if(this.firstConnection!==void 0)return this.firstConnection.getServerState()},j.prototype.getState=function(){return this.fsm.getState()},j.prototype.isInTerminalState=function(){return this.fsm.getInternalState()===E.TrouterManagerState.TerminalError},j.prototype.reportStateInfo=function(){var J=this.firstConnection?x.State[this.firstConnection.getState()]:"Unknown",Z=E.TrouterManagerState[this.fsm.getInternalState()];if(this.secondConnection){var re=x.State[this.secondConnection.getState()];return"Manager ".concat(Z,"; 1st ").concat(J,"; 2nd ").concat(re)}return"Manager ".concat(Z,"; Connection ").concat(J)},j.prototype.startFirstConnection=function(){var J=new F.TrouterConnection(this.logFunc,this.options,this.configuredTrouterManager(),this.tokenProvider,this.usingLegacyTokenApi,this.userActivityObject,this.protocolSelector,this.audienceSubscriptionState);this.firstConnection=J,this.getConnectionCache().then(function(Z){J.start(Z)}).catch(function(){})},j.prototype.startSecondConnection=function(J){var Z=new F.TrouterConnection(this.logFunc,this.options,this.configuredTrouterManager(),this.tokenProvider,this.usingLegacyTokenApi,this.userActivityObject,this.protocolSelector,this.audienceSubscriptionState);this.secondConnection=Z,this.firstConnection!==void 0&&this.firstConnection.disableRegistrationsAndAutoReconnect(),J?this.getConnectionCache().then(function(re){Z.start(re)}).catch(function(){}):Z.start()},j.prototype.stopFirstConnection=function(J){this.firstConnection!==void 0&&(this.storedFirstConnection=this.firstConnection,this.firstConnection.stop(J),this.firstConnection=void 0)},j.prototype.stopSecondConnection=function(J){this.secondConnection!==void 0&&(this.secondConnection.stop(J),this.secondConnection=void 0)},j.prototype.stopSecondConnectionDelayed=function(){if(this.secondConnection!==void 0){var J=this.secondConnection;this.secondConnection=void 0,this.logger.info("Closing an inactive connection in ".concat(Math.round(this.options.lingeringConnectionDelayMs/1e3),"s")),setTimeout(function(){J.stop(!0)},this.options.lingeringConnectionDelayMs)}},j.prototype.forceStopLingeringConnection=function(){this.storedFirstConnection&&(this.storedFirstConnection.stop(!1),this.storedFirstConnection=void 0)},j.prototype.switchConnections=function(){var J=this.firstConnection;this.firstConnection=this.secondConnection,this.secondConnection=J},j.prototype.doesSecondConnectionExist=function(){return this.secondConnection!==void 0},j.prototype.dispatchConnected=function(){if(this.firstConnection!==void 0){var J=this.firstConnection.getServerState(),Z=J.url.endsWith("/")?J.url.slice(0,-1):J.url,re={baseEndpointUrl:Z,newEndpointUrl:Z!==this.baseEndpointUrl,c2cUrlBase:J.c2cUrlBase,clientId:J.connectedClientId,connectionId:J.connectionId,connectionTtlSec:J.getRemainingTtlInSec()};this.baseEndpointUrl=Z,this.listener.onTrouterConnected(J.url,re)}},j.prototype.dispatchDisconnected=function(){this.listener.onTrouterDisconnected&&this.listener.onTrouterDisconnected()},j.prototype.dispatchTerminalError=function(){this.listener.onTrouterDisconnected&&this.listener.onTrouterDisconnected()},j.prototype.dispatchRegistrationState=function(J){this.options.registrationStateCallback&&this.options.registrationStateCallback(J)},j.prototype.expediteBackoffOnConnections=function(){var J;this.lastExpediteBackoffCallAt!==void 0&&Date.now()-this.lastExpediteBackoffCallAt<((J=this.options.expediteBackoffOnStartMinimumDelayMs)!==null&&J!==void 0?J:1e4)?this.logger.info("Expedite backoff due to start() too frequent, skipping"):(this.lastExpediteBackoffCallAt=Date.now(),this.firstConnection!==void 0&&this.firstConnection.expediteBackoff(),this.secondConnection!==void 0&&this.secondConnection.expediteBackoff())},j.prototype.onDownstreamRequest=function(J,Z,re){var ne={id:Z.id,method:Z.method,path:"/".concat(Z.shortUrl),body:Z.body,headers:Z.headers},le={id:Z.id,status:0,headers:{},body:"",send:function(){return le.status<=100||le.status>=999?3:(re.writeHead(le.status,le.headers),re.end(le.body))}};this.listener.onTrouterRequest(ne,le)},j.prototype.onConnected=function(J){this.fsm.onConnected(J===this.firstConnection)},j.prototype.onRegistered=function(J){this.fsm.onRegistered(J===this.firstConnection)},j.prototype.onUnregistered=function(J){this.fsm.onUnregistered(J===this.firstConnection||J===this.storedFirstConnection)},j.prototype.onReconnecting=function(J){this.fsm.onReconnecting(J===this.firstConnection)},j.prototype.onReconnectIsRequired=function(J,Z,re){this.fsm.onReconnectionRequired(J===this.firstConnection,Z,re)},j.prototype.onDisconnected=function(J){this.fsm.onDisconnected(J===this.firstConnection||J==this.storedFirstConnection),this.storedFirstConnection=void 0},j.prototype.onTerminalError=function(){this.fsm.onTerminalError(),this.storedFirstConnection=void 0},j.prototype.onUserActivityStateAccepted=function(J){this.listener.onTrouterUserActivityStateAccepted&&this.listener.onTrouterUserActivityStateAccepted(J)},j.prototype.onAudiencesSetResolved=function(J,Z){var re,ne;(ne=(re=this.listener).onAudiencesSetResolved)===null||ne===void 0||ne.call(re,J,Z)},j.prototype.onConnectionParametersUpdated=function(J){this.setConnectionCache(J)},j.prototype.setUserActivityState=function(J,Z){return this.userActivityObject=new L(J,T.CorrelationVector.extend(Z)),this.secondConnection!==void 0?(this.logger.info("Setting user activity ".concat(this.userActivityObject.toEventJSON()," on the second/new connection")),void this.secondConnection.setUserActivityState(this.userActivityObject)):this.firstConnection!==void 0?(this.logger.info("Setting user activity ".concat(this.userActivityObject.toEventJSON()," on the first/current connection")),void this.firstConnection.setUserActivityState(this.userActivityObject)):void 0},j.prototype.setAudienceSubscriptionsAsync=function(J,Z,re){if(this.audienceSubscriptionState=new z(J,T.CorrelationVector.extend(re)),this.secondConnection)return this.logger.info("Setting audience subscriptions ".concat(this.audienceSubscriptionState.toEventJSON()," on second/new connection")),this.secondConnection.setAudienceSubscriptionsAsync(this.audienceSubscriptionState,Z);if(this.firstConnection)return this.logger.info("Setting audience subscriptions ".concat(this.audienceSubscriptionState.toEventJSON()," on first/current connection")),this.firstConnection.setAudienceSubscriptionsAsync(this.audienceSubscriptionState,Z);throw new Error("No connection found")},j.prototype.onTrouterMessageLost=function(J){var Z=this;if(this.listener.onTrouterMessageLoss)if(J?.length){var re=J.filter(function(ne){return Z.processedMessageLoss["".concat(ne.tag,"-").concat(ne.etag)]!==void 0});if(re.length&&(this.logger.info("onTrouterMessageLoss - immediately acknowledging ".concat(re.length," seen dropped indicators")),this.sendProcessedDroppedIndicators(re),!(J=J.filter(function(ne){return Z.processedMessageLoss["".concat(ne.tag,"-").concat(ne.etag)]===void 0})).length))return void this.logger.info("onTrouterMessageLoss - all declared dropped indicators have been seen before");if(!this.listener.onTrouterMessageLoss(J.map(function(ne){return ne.tag})))return void this.logger.warn("onTrouterMessageLoss - some flow tag(s) have not been processed by listeners");J.forEach(function(ne){Z.processedMessageLoss["".concat(ne.tag,"-").concat(ne.etag)]=""}),this.sendProcessedDroppedIndicators(J)}else this.logger.warn("onTrouterMessageLoss - no flow tags have been provided")},j.prototype.getConnectionCache=function(){var J=this;return this.options.connectionCache?(this.logger.debug("Querying host's connection cache"),this.options.connectionCache.onGetTrouterConnectionCache().then(function(Z){var re=Z?JSON.parse(Z):void 0;return typeof re=="object"?re:void 0}).catch(function(Z){return J.logger.warn("Invalid connection cache content provided: ".concat(Z)),J.connectionCache})):Promise.resolve(this.connectionCache)},j.prototype.setConnectionCache=function(J){if(this.connectionCache=J,this.options.connectionCache)try{this.options.connectionCache.onSetTrouterConnectionCache(JSON.stringify(J))}catch(Z){this.logger.warn("Error setting external connection cache: ".concat(Z))}},j.prototype.sendProcessedDroppedIndicators=function(J){this.firstConnection===void 0?this.secondConnection===void 0||this.secondConnection.sendProcessedDroppedIndicators(J):this.firstConnection.sendProcessedDroppedIndicators(J)},j.prototype.configuredTrouterManager=function(){return new D.RegistrationEnforcer(this,this.options.connectionDependsOnRegistration,this.options.delayEventsUntilRegistered)},j}();p.TrouterManager=H},10:(h,p,g)=>{Object.defineProperty(p,"__esModule",{value:!0}),p.TrouterManagerFsm=void 0;var f=g(234),y=g(423),T=g(642),C=g(573),E=function(){function I(w,D){this.worker=D,this.state=y.TrouterManagerState.Unknown,this.logger=new T.Logger("ManagerFsm",w)}return I.prototype.start=function(){this.state===y.TrouterManagerState.Unknown?(this.setState(y.TrouterManagerState.Disconnected),this.worker.forceStopLingeringConnection(),this.worker.startFirstConnection()):(this.logger.info("start called in state '".concat(y.TrouterManagerState[this.state],"', expediting pending backoffs, if any")),this.worker.expediteBackoffOnConnections())},I.prototype.stop=function(w){this.state!==y.TrouterManagerState.Unknown?(this.setState(y.TrouterManagerState.Unknown),this.worker.stopFirstConnection(w===!0),this.worker.stopSecondConnection(w===!0)):this.showIgnored("stop")},I.prototype.getState=function(){switch(this.state){case y.TrouterManagerState.Unknown:case y.TrouterManagerState.Connected:case y.TrouterManagerState.Disconnected:case y.TrouterManagerState.Switching:return this.state;case y.TrouterManagerState.TerminalError:return f.TrouterState.Disconnected}},I.prototype.getInternalState=function(){return this.state},I.prototype.onConnected=function(w){this.state===y.TrouterManagerState.Disconnected&&w?this.worker.doesSecondConnectionExist()?this.setState(y.TrouterManagerState.Switching):(this.setState(y.TrouterManagerState.Connected),this.worker.dispatchConnected()):this.showIgnored("onConnected(".concat(w,")"))},I.prototype.onRegistered=function(w){this.state!==y.TrouterManagerState.Disconnected||w?this.state!==y.TrouterManagerState.Switching||w?this.state===y.TrouterManagerState.Disconnected&&w&&(this.setState(y.TrouterManagerState.Connected),this.worker.dispatchConnected()):(this.setState(y.TrouterManagerState.Connected),this.worker.switchConnections(),this.worker.stopSecondConnectionDelayed(),this.worker.dispatchConnected()):(this.setState(y.TrouterManagerState.Connected),this.worker.switchConnections(),this.worker.stopSecondConnection(!0),this.worker.dispatchConnected()),this.worker.dispatchRegistrationState(!0)},I.prototype.onUnregistered=function(w){w&&this.worker.dispatchRegistrationState(!1)},I.prototype.onReconnecting=function(w){this.state!==y.TrouterManagerState.Connected&&this.state!==y.TrouterManagerState.Switching||!w?this.showIgnored("onReconnecting(".concat(w,")")):(this.setState(y.TrouterManagerState.Disconnected),this.worker.dispatchDisconnected())},I.prototype.onReconnectionRequired=function(w,D,F){this.state===y.TrouterManagerState.Connected&&w?(this.setState(y.TrouterManagerState.Switching),this.worker.startSecondConnection(D)):this.state===y.TrouterManagerState.Disconnected&&w?this.worker.startSecondConnection(D):this.state===y.TrouterManagerState.Switching&&w&&F===C.ReconnectReason.Configuration?(this.logger.debug("onReconnectionRequired: switch requested while already in Switching state"),this.worker.stopSecondConnection(!0),this.worker.startSecondConnection(D)):this.showIgnored("onReconnectionRequired(".concat(w,")"))},I.prototype.onDisconnected=function(w){this.state==y.TrouterManagerState.Unknown&&w?this.worker.dispatchDisconnected():this.state==y.TrouterManagerState.Switching&&w?(this.worker.switchConnections(),this.worker.stopSecondConnection(!1),this.setState(y.TrouterManagerState.Disconnected),this.worker.dispatchDisconnected()):this.showIgnored("onDisconnected(".concat(w,")"))},I.prototype.onTerminalError=function(){this.setState(y.TrouterManagerState.TerminalError),this.worker.dispatchTerminalError()},I.prototype.showIgnored=function(w){this.logger.info("Ignoring event '".concat(w,"' in state '").concat(y.TrouterManagerState[this.state],"'"))},I.prototype.setState=function(w){this.logger.info("Switching from state '".concat(y.TrouterManagerState[this.state],"' to state '").concat(y.TrouterManagerState[w],"'")),this.state!==w?this.state=w:this.logger.error("Attempt to switch to the current state '".concat(y.TrouterManagerState[w],"'"))},I}();p.TrouterManagerFsm=E},616:(h,p,g)=>{Object.defineProperty(p,"__esModule",{value:!0}),p.TrouterUrlPromise=void 0;var f=g(642),y=function(){function T(C){this.logger=new f.Logger("UrlPromise",C)}return T.prototype.getPromise=function(){var C=this;return this.url!==void 0?(this.logger.debug("returning previously resolved url: ".concat(this.url)),Promise.resolve(this.url)):(this.pendingPromise===void 0?(this.logger.debug("creating and returning promise"),this.pendingPromise=new Promise(function(E,I){C.pendingPromiseResolveRef=E,C.pendingPromiseRejectRef=I})):this.logger.debug("returning existing promise"),this.pendingPromise)},T.prototype.resolveUrl=function(C){this.url=C,this.logger.debug("got url: ".concat(this.url));var E=this.pendingPromiseResolveRef;this.pendingPromise=void 0,this.pendingPromiseResolveRef=void 0,this.pendingPromiseRejectRef=void 0,E!==void 0&&(this.logger.debug("resolving promise"),E(C))},T.prototype.rejectUrl=function(C){this.logger.debug("aborting");var E=this.pendingPromiseRejectRef;this.url=void 0,this.pendingPromise=void 0,this.pendingPromiseResolveRef=void 0,this.pendingPromiseRejectRef=void 0,E!==void 0&&(this.logger.debug("rejecting promise"),E(C))},T.prototype.resetUrl=function(){this.logger.debug("resetting url"),this.url=void 0},T}();p.TrouterUrlPromise=y},882:function(h,p,g){var f=this&&this.__assign||function(){return f=Object.assign||function(H){for(var j,J=1,Z=arguments.length;J<Z;J++)for(var re in j=arguments[J])Object.prototype.hasOwnProperty.call(j,re)&&(H[re]=j[re]);return H},f.apply(this,arguments)},y=this&&this.__awaiter||function(H,j,J,Z){return new(J||(J=Promise))(function(re,ne){function le(Le){try{Me(Z.next(Le))}catch(pe){ne(pe)}}function he(Le){try{Me(Z.throw(Le))}catch(pe){ne(pe)}}function Me(Le){var pe;Le.done?re(Le.value):(pe=Le.value,pe instanceof J?pe:new J(function(te){te(pe)})).then(le,he)}Me((Z=Z.apply(H,j||[])).next())})},T=this&&this.__generator||function(H,j){var J,Z,re,ne,le={label:0,sent:function(){if(1&re[0])throw re[1];return re[1]},trys:[],ops:[]};return ne={next:he(0),throw:he(1),return:he(2)},typeof Symbol=="function"&&(ne[Symbol.iterator]=function(){return this}),ne;function he(Me){return function(Le){return function(pe){if(J)throw new TypeError("Generator is already executing.");for(;ne&&(ne=0,pe[0]&&(le=0)),le;)try{if(J=1,Z&&(re=2&pe[0]?Z.return:pe[0]?Z.throw||((re=Z.return)&&re.call(Z),0):Z.next)&&!(re=re.call(Z,pe[1])).done)return re;switch(Z=0,re&&(pe=[2&pe[0],re.value]),pe[0]){case 0:case 1:re=pe;break;case 4:return le.label++,{value:pe[1],done:!1};case 5:le.label++,Z=pe[1],pe=[0];continue;case 7:pe=le.ops.pop(),le.trys.pop();continue;default:if(!((re=(re=le.trys).length>0&&re[re.length-1])||pe[0]!==6&&pe[0]!==2)){le=0;continue}if(pe[0]===3&&(!re||pe[1]>re[0]&&pe[1]<re[3])){le.label=pe[1];break}if(pe[0]===6&&le.label<re[1]){le.label=re[1],re=pe;break}if(re&&le.label<re[2]){le.label=re[2],le.ops.push(pe);break}re[2]&&le.ops.pop(),le.trys.pop();continue}pe=j.call(H,le)}catch(te){pe=[6,te],Z=0}finally{J=re=0}if(5&pe[0])throw pe[1];return{value:pe[0]?pe[1]:void 0,done:!0}}([Me,Le])}}};Object.defineProperty(p,"__esModule",{value:!0}),p.replaceTrouterUrlBase=p.getTrouterServiceVersion=p.createTrouterService=p.TrouterService=p.UserActivityState=p.TrouterState=void 0;var C=g(509),E=g(234);Object.defineProperty(p,"TrouterState",{enumerable:!0,get:function(){return E.TrouterState}}),Object.defineProperty(p,"UserActivityState",{enumerable:!0,get:function(){return E.UserActivityState}});var I=g(642),w=g(619),D=g(220),F=g(634),x=g(616);function B(H,j){if(!j)return H;var J=f(f({},H),{enabled:j.TelemetryEnabled});return j.ClientTelemetryEventEnabled!==void 0&&(J=f(f({},J),j.ClientTelemetryEventEnabled)),J}function L(H,j,J){var Z,re,ne,le,he,Me,Le,pe,te,Se,ce,X,ve=function(Te){return H.proxyUrlRewrite?(j.info("Using rewritten URL for proxy"),H.proxyUrlRewrite(Te)):Te};return{clientInfo:{ua:H.trouterSettings.productName,v:H.trouterSettings.version},ioOptions:{ackTimeoutMs:5e3,rewriteUrlForProxy:ve},clientCorrelationID:H.trouterSettings.sessionId,environment:H.trouterSettings.environment,telemetrySettings:B(H.telemetryConfig.settings,J),eventLogger:H.telemetryConfig.eventLogger,endpointId:H.trouterSettings.registrationId,trouterUrl:J?.TrouterConnectionUrl||H.trouterSettings.trouterServiceUrl,registration:H.trouterSettings.registrarServiceUrl?{registrarUrl:H.trouterSettings.registrarServiceUrl,registrationId:(Z=H.trouterSettings.registrationId)!==null&&Z!==void 0?Z:"",pnhAppId:(re=H.trouterSettings.pnhAppId)!==null&&re!==void 0?re:"",platform:(ne=H.trouterSettings.platform)!==null&&ne!==void 0?ne:"",pnhTemplateKey:(le=H.trouterSettings.pnhTemplate)!==null&&le!==void 0?le:"",platformUIVersion:(he=H.trouterSettings.platformUIVersion)!==null&&he!==void 0?he:"",productContext:H.trouterSettings.pnhProductContext||void 0,context:(Me=H.trouterSettings.pnhContext)!==null&&Me!==void 0?Me:"",registrarTtlSec:((Le=H.trouterSettings.maxRegistrationTimeInMs)!==null&&Le!==void 0?Le:0)/1e3}:void 0,connectionDependsOnRegistration:H.trouterSettings.registrarServiceUrl===void 0?function(){return!1}:(pe=H.trouterSettings.connectionDependsOnRegistration)!==null&&pe!==void 0?pe:function(){return!1},delayEventsUntilRegistered:(te=H.trouterSettings.delayEventsUntilRegistered)!==null&&te!==void 0?te:function(){return!1},timeoutOptions:f({connectionTimeoutMs:H.trouterSettings.trouterConnectTimeoutInMs||3e4,fetchTimeoutMs:1e4,pingTimeoutMs:4e4,pongTimeoutMs:5e3,maxBackoffMs:H.trouterSettings.productName==="TeamsCDL"?3e5:3e4,requestTimeoutMs:5e3,userActivityResponseTimeoutMs:1e4},H.trouterSettings.timeoutOptions),incallTimeoutOptions:f({connectionTimeoutMs:1e4,fetchTimeoutMs:5e3,pingTimeoutMs:5e3,pongTimeoutMs:2e3,maxBackoffMs:H.trouterSettings.productName==="TeamsCDL"?3e5:1e4,requestTimeoutMs:5e3,userActivityResponseTimeoutMs:1e4},H.trouterSettings.incallTimeoutOptions),incallModeTimeoutMs:(Se=H.trouterSettings.incallModeTimeoutMs)!==null&&Se!==void 0?Se:0,lingeringConnectionDelayMs:6e4,userActivitySecondResendDelayMs:H.trouterSettings.userActivitySecondResendDelayMs||1e4,duplicateDisconnectThresholdMs:1e4,connectionCache:H.connectionCache,registrationStateCallback:H.registrationStateCallbackForAcsDoNotUse,rewriteUrlForProxy:ve,retryLimitOnTokenFetch:H.trouterSettings.retryLimitOnTokenFetch,extraConnectionHeaders:H.trouterSettings.extraConnectionHeaders,expediteBackoffOnStartMinimumDelayMs:1e4,updateUserActivityDuringConnectionAttempt:(ce=H.trouterSettings.updateUserActivityDuringConnectionAttempt)===null||ce===void 0||ce,initialConnectivityCheck:(X=H.trouterSettings.initialConnectivityCheck)===null||X===void 0||X,toJSON:function(){return f(f({},this),{connectionCache:this.connectionCache?{}:this.connectionCache})}}}var z=function(){function H(j){this.logProvider=j,this.stateChangedListeners=[],this.logger=new I.Logger("Trouter",j),this.trouterUrlPromise=new x.TrouterUrlPromise(j),this.messageHandlers=new w.MessageHandlerRegistry(j),this.listeners={},this.connectionInfo=null,this.logger.info("Created TrouterService version ".concat(C.CLIENT_VERSION))}return H.prototype.start=function(j){var J;if(this.logger.info("Start"),!j.skypeTokenProvider&&!j.authTokenProvider)throw new Error("no token provider has been configured, either skypeTokenProvider or authTokenProvider must be populated");j.skypeTokenProvider&&!j.trouterSettings.disableInternalSkypeTokenCache&&(j.skypeTokenProvider=(0,D.addCacheAsBackupTo)(j.skypeTokenProvider)),this.trouterCfg=j;var Z=L(j,this.logger,this.ecsCfg);j.internalEnableV4cProtocol===!1&&(Z.forceV4aProtocol=!0);var re=function(ne,le){var he,Me=this;return function(Le){return y(Me,void 0,void 0,function(){var pe,te,Se;return T(this,function(ce){switch(ce.label){case 0:pe=new Date,te=setInterval(function(){var X=Math.round((Date.now()-pe.getTime())/6e4);ne.warn("Note: Trouter auth token request promise from ".concat(pe.toISOString()," has not been resolved for ").concat(X," minutes. The client is blocked from operating properly"))},3e5),ce.label=1;case 1:return ce.trys.push([1,,3,4]),[4,le(Le)];case 2:return Se=ce.sent(),Le.needFresh&&Se.token===he&&ne.error("API violation: Trouter auth token provider got a request with needRefresh=true, but returned the same token as last time anyway. Please fix the host app"),he=Se.token,[2,Se];case 3:return clearInterval(te),[7];case 4:return[2]}})})}}(this.logger,(J=j.authTokenProvider)!==null&&J!==void 0?J:function(ne){var le=this;return function(he){return y(le,void 0,void 0,function(){var Me;return T(this,function(Le){switch(Le.label){case 0:return Me={},[4,ne(he.needFresh)];case 1:return[2,(Me.token=Le.sent(),Me.tokenType="skype",Me)]}})})}}(j.skypeTokenProvider));this.trouterServer===void 0&&(this.trouterServer=new F.TrouterManager(this.logProvider,Z,re,j.authTokenProvider===void 0,this)),this.pendingActivityState!==void 0&&(this.trouterServer.setUserActivityState(this.pendingActivityState[0],this.pendingActivityState[1]),this.pendingActivityState=void 0),this.trouterServer.start()},H.prototype.stop=function(j){this.logger.info("close connection"),this.trouterUrlPromise.rejectUrl(new Error("TrouterService is stopped")),this.trouterServer!==void 0&&this.trouterServer.stop(j)},H.prototype.setEcsConfig=function(j){return y(this,void 0,void 0,function(){var J=this;return T(this,function(Z){return[2,new Promise(function(re){if(J.ecsCfg=j.TrouterJScriptClient,J.logger.info("Setting ECS configuration to ".concat(JSON.stringify(J.ecsCfg))),J.trouterServer!==void 0&&J.trouterCfg!==void 0){var ne=L(J.trouterCfg,J.logger,J.ecsCfg);J.trouterServer.configure(ne)}re()})]})})},H.prototype.checkConnection=function(j){this.trouterServer!==void 0&&this.trouterServer.checkConnection(j!=null&&j)},H.prototype.resendRegistration=function(){return y(this,void 0,void 0,function(){return T(this,function(j){if(!this.trouterServer)throw new Error("resendRegistration called too early");return[2,this.trouterServer.resendRegistration()]})})},H.prototype.registerListener=function(j,J){return J===""||!J.startsWith("/")||J.includes("?")||J.includes("#")?(this.logger.error("Listener path '".concat(J,"' is not valid")),!1):this.listeners[J]?(this.logger.error("Another listener is already registered for path '".concat(J,"'")),!1):(this.listeners[J]=j,this.logger.debug("Listener for path '".concat(J,"' registered")),this.connectionInfo&&j.onTrouterConnected(this.connectionInfo.baseEndpointUrl+J,this.connectionInfo),!0)},H.prototype.unregisterListener=function(j){for(var J=[],Z=0,re=Object.keys(this.listeners);Z<re.length;Z++){var ne=re[Z];this.listeners[ne]===j&&J.push(ne)}if(J.length===0)return!1;for(var le=0,he=J;le<he.length;le++)ne=he[le],delete this.listeners[ne];return this.logger.debug("Listener for path(s) '".concat(J.join("', '"),"' unregistered")),!0},H.prototype.onTrouterConnected=function(j,J){this.logger.debug("Trouter is now connected");for(var Z=0,re=Object.keys(this.listeners);Z<re.length;Z++){var ne=re[Z];try{this.listeners[ne].onTrouterConnected(J.baseEndpointUrl+ne,J)}catch(le){this.logger.error("Listener '".concat(ne,"' threw an exception from onTrouterConnected(): ").concat(le))}}this.connectionInfo=J,this.trouterUrlPromise.resolveUrl(j),this.notifyStateChanged(E.TrouterState.Connected,{url:j,getRemainingTtlInSec:function(){return J.connectionTtlSec}})},H.prototype.onTrouterDisconnected=function(){this.logger.debug("Trouter is now disconnected"),this.connectionInfo=null;for(var j=0,J=Object.keys(this.listeners);j<J.length;j++){var Z=J[j],re=this.listeners[Z];if(re.onTrouterDisconnected)try{re.onTrouterDisconnected()}catch(ne){this.logger.error("Listener '".concat(Z,"' threw an exception from onTrouterDisconnected(): ").concat(ne))}}this.notifyStateChanged(E.TrouterState.Disconnected)},H.prototype.onTrouterRequest=function(j,J){for(var Z="",re=0,ne=Object.keys(this.listeners);re<ne.length;re++){var le=ne[re];j.path.startsWith(le)&&le.length>Z.length&&(Z=le)}if(Z==="")this.tryMessageHandlers(j,J)||(J.status=404,J.headers={"Trouter-Responder":"ClientLib"},J.send());else try{this.listeners[Z].onTrouterRequest(j,J)}catch(he){this.logger.error("Listener '".concat(Z,"' threw an exception from onTrouterRequest(): ").concat(he)),J.status=500,J.headers={"Trouter-Responder":"ClientLib"},J.send()}},H.prototype.onTrouterMessageLoss=function(j){this.logger.info("onTrouterMessageLoss called with tags [".concat(j,"]"));for(var J=!0,Z=0,re=Object.keys(this.listeners);Z<re.length;Z++){var ne=re[Z],le=this.listeners[ne];if(le.onTrouterMessageLoss)try{(J=le.onTrouterMessageLoss(j)&&J)===void 0&&(this.logger.error("Listener '".concat(ne,"' did not return a boolean value from onTrouterMessageLoss()")),J=!1)}catch(he){this.logger.error("Listener '".concat(ne,"' threw an exception from onTrouterMessageLoss(): ").concat(he)),J=!1}}return J},H.prototype.onTrouterUserActivityStateAccepted=function(j){this.logger.debug("onTrouterUserActivityStateAccepted cv: ".concat(j));for(var J=0,Z=Object.keys(this.listeners);J<Z.length;J++){var re=Z[J],ne=this.listeners[re];if(ne.onTrouterUserActivityStateAccepted)try{ne.onTrouterUserActivityStateAccepted(j)}catch(le){this.logger.error("Listener '".concat(re,"' threw an exception from onTrouterUserActivityStateAccepted(): ").concat(le))}}},H.prototype.onAudiencesSetResolved=function(j,J){this.logger.debug("onAudiencesSetResolved cv: ".concat(J));for(var Z=0,re=Object.keys(this.listeners);Z<re.length;Z++){var ne=re[Z],le=this.listeners[ne];if(le.onAudiencesSetResolved)try{le.onAudiencesSetResolved(j,J)}catch(he){this.logger.error("Listener '".concat(ne,"' threw an exception from onAudienceSubscribed(): ").concat(he))}}},H.prototype.setUserActivityState=function(j,J){if(j!==E.UserActivityState.Active&&j!==E.UserActivityState.Inactive)throw new Error("setUserActivityState called with unsupported value ".concat(j));this.logger.info("setUserActivityState called with value ".concat(E.UserActivityState[j])),this.trouterServer&&this.state()!==E.TrouterState.Unknown?this.trouterServer.setUserActivityState(j,J):(this.pendingActivityState=[j,J],this.logger.warn("setUserActivityState called before start() or after stop()"))},H.prototype.setAudienceSubscriptions=function(j,J){if(j.audienceSubscriptions.length>1)throw new Error("Only singular audience subscription is supported");if(this.trouterServer&&this.state()!==E.TrouterState.Unknown)return this.trouterServer.setAudienceSubscriptionsAsync(j,15e3,J);throw new Error("audience subscribe called before start() or after stop()")},H.prototype.state=function(){return this.trouterServer!==void 0?this.trouterServer.getState():E.TrouterState.Unknown},H.prototype.isInTerminalState=function(){return this.trouterServer!==void 0&&this.trouterServer.isInTerminalState()},H.prototype.reportStateInfo=function(){return this.trouterServer===void 0?"":this.trouterServer.reportStateInfo()},H.prototype.getServerState=function(){if(this.trouterServer!==void 0)return this.trouterServer.getServerState()},H.prototype.getTrouterUrlAsync=function(){return this.trouterServer!==void 0?this.trouterUrlPromise.getPromise():Promise.reject(new Error("TrouterService has not been started"))},H.prototype.onStateChanged=function(j){if(this.logger.info("onStateChanged called"),j===void 0)this.stateChangedListeners=this.stateChangedListeners.filter(function(Z){return Z.wrappedCallback===void 0});else{this.offStateChanged(j);var J=function(Z,re){j(Z,re?re.url:"")};J.wrappedCallback=j,this.stateChangedListeners.push(J)}},H.prototype.offStateChanged=function(j){this.logger.info("offStateChanged called");var J=this.stateChangedListeners.length;return this.stateChangedListeners=this.stateChangedListeners.filter(function(Z){return Z.wrappedCallback!==j}),J>this.stateChangedListeners.length},H.prototype.addCallback=function(j){this.logger.info("addListener called"),this.stateChangedListeners.indexOf(j,0)===-1&&j!==void 0&&this.stateChangedListeners.push(j)},H.prototype.removeCallback=function(j){this.logger.info("removeListener called");var J=this.stateChangedListeners.indexOf(j,0);return J>-1&&(this.stateChangedListeners.splice(J,1),!0)},H.prototype.registerMessageHandler=function(j){this.logger.info("registerMessageHandler is called"),this.messageHandlers.register(j)},H.prototype.clearMessageHandlers=function(){this.logger.info("clearMessageHandlers is called"),this.messageHandlers.clear()},H.prototype.notifyStateChanged=function(j,J){var Z=this;this.logger.info("notifyStateChanged called, will forward to ".concat(this.stateChangedListeners.length," listeners")),this.stateChangedListeners.forEach(function(re){try{re(j,J)}catch(ne){Z.logger.error("Error in callback ".concat(ne))}})},H.prototype.tryMessageHandlers=function(j,J){if(!this.messageHandlers.active())return!1;var Z,re=null;try{re=(Z=JSON.parse(j.body))&&(Z.evt||Z.eventId)||null}catch{}var ne={eventId:re,url:(this.connectionInfo?this.connectionInfo.baseEndpointUrl:"")+j.path,body:Z,rawBody:j.body,headers:j.headers},le=this.messageHandlers.handleMessage(ne);return!!le.isHandled&&(J.status=le.resultCode,le.responseHeaders&&(J.headers=le.responseHeaders),le.responseBody&&(J.body=le.responseBody),J.send(),!0)},H}();p.TrouterService=z,p.createTrouterService=function(H){return new z(H)},p.getTrouterServiceVersion=function(){return C.CLIENT_VERSION},p.replaceTrouterUrlBase=function(H,j){var J=H.indexOf("://");if(J>=0){var Z=H.indexOf("/",J+3);if(Z>=0)return j+H.substr(Z)}return""}},673:h=>{h.exports=r}},l={};function d(h){var p=l[h];if(p!==void 0)return p.exports;var g=l[h]={id:h,loaded:!1,exports:{}};return o[h].call(g.exports,g,g.exports,d),g.loaded=!0,g.exports}return d.g=function(){if(typeof globalThis=="object")return globalThis;try{return this||new Function("return this")()}catch{if(typeof window=="object")return window}}(),d.nmd=h=>(h.paths=[],h.children||(h.children=[]),h),d(882)})(),t.exports=i(nHt)});class aHt{constructor(e,i){this.logEvent=r=>{this._logger.debug(r),this._telemetryLogManager.sendEvent({name:r.name,tenant:YNt,properties:{...r.properties}})},this._logger=e.createChild("TelemetrySender"),this._telemetryLogManager=i}}function R3e(t){return{registrationId:ln(),registrarServiceUrl:t.getTrouterSettings().registrarServiceUrl,registrarTtlInSeconds:t.getTrouterSettings().registrarTtlInSeconds,maxRegistrationTimeInMs:t.getTrouterSettings().maxRegistrationTimeInMs,registrarRefreshTimeoutInMs:t.getTrouterSettings().registrarRefreshTimeoutInMs,pnhAppId:t.getTrouterSettings().pnhAppId,pnhTemplate:t.getTrouterSettings().pnhTemplate,platform:t.getTrouterSettings().platform,platformUIVersion:t.getTrouterSettings().version,trouterServiceUrl:t.getTrouterSettings().trouterServiceUrl,version:t.getTrouterSettings().version,trouterConnectTimeoutInMs:t.getTrouterSettings().trouterConnectTimeoutInMs,productName:t.getTrouterSettings().productName,sessionId:ln(),environment:t.getTrouterSettings().environment,timeoutOptions:t.getTrouterSettings().timeoutOptions}}class rHt{constructor(e,i,r,o,l){this._ecsProvider=i,this._tokenProvider=r,this._isRegistered=!1,this._registeredChangedListeners=[],this._logger=e.createChild("Trouter"),this._logger.info("init"),this._initialRegistrationCompleteDefer=ug(),this._telemetryLogManager=o,this._acsProxy=l}async start(e){let i;if(this._trouterService)throw this._logger.error("Trouterservice already initialized"),new Oe({defaultError:we.CALL_STACK.SIGNALING_SERVICE_ALREADY_INITIALIZED});{const r=new Promise(async(o,l)=>{try{if(this._logger.info("Trouterservice start"),this._trouterService=gZ.createTrouterService(this._logger),!this._trouterService)throw this._logger.error("Failed to create trouter service"),new Oe({defaultError:we.CALL_STACK.SIGNALING_SERVICE_CREATE_FAIL});this._options=this._getTrouterConfig(this._logger,this._tokenProvider),e&&(this._options.trouterSettings.environment=e.environment||"",this._options.trouterSettings.sessionId=e.sessionId);let d,h,p=+new Date;this._trouterService.start(this._options),this._trouterService.onStateChanged((f,y)=>{f===gZ.TrouterState.Connected&&(d=+new Date)}),await this._initialRegistrationCompleteDefer.promise;const g=+new Date;d=d??+new Date,h=d,o({trouterRequestCompletionTimeDeltaMs:Math.max(0,d-p),registrarRequestCompletionTimeDeltaMs:Math.max(0,g-h)})}catch(d){l(d)}});try{i=await cP(()=>r,Oxe)}catch(o){throw o.code===408?(this._logger.error("Signaling init timeout"),new Oe({defaultError:we.CALL_STACK.SIGNALING_SERVICE_CREATE_TIMEOUT,defaultErrorMessageArgs:[Oxe]})):(this._logger.error("Signaling init failed"),new Oe({defaultError:we.CALL_STACK.SIGNALING_INIT_FAIL}))}}return i}isRegistered(){return this._isRegistered}onRegisteredChanged(e){this._logger.info("TrouterService onRegisteredChanged"),this._registeredChangedListeners.push(e)}offRegisteredChanged(e){const i=this._registeredChangedListeners.indexOf(e);this._logger.info(`TrouterService offRegisteredChanged: ${i}`),i>-1&&this._registeredChangedListeners.splice(i,1)}stop(e){this._logger.info("Trouterservice stop"),this._trouterService?(this._trouterService.onStateChanged(void 0),this._trouterService.stop(e),this._trouterService=void 0):this._logger.error("Trouterservice not inited")}registerMessageHandler(e){this._logger.info("Trouterservice registerMessageHandler"),this._trouterService&&this._trouterService.registerMessageHandler(e)}clearMessageHandlers(){this._trouterService&&this._trouterService.clearMessageHandlers()}checkConnection(){this._trouterService&&this._trouterService.checkConnection()}state(){return this._logger.info("Trouterservice state"),this._trouterService?this._trouterService.state():gZ.TrouterState.Unknown}onStateChanged(e){this._logger.info("Trouterservice onStateChanged"),this._trouterService&&this._trouterService.onStateChanged(e)}offStateChanged(e){this._logger.info("Trouterservice offStateChanged"),this._trouterService&&this._trouterService.offStateChanged(e)}getTrouterUrlAsync(){return this._trouterService?(this._logger.info("getTrouterUrlAsync called"),this._trouterService.getTrouterUrlAsync()):Promise.reject("Trouterservice not started yet")}getTrouterSettings(){return this._options.trouterSettings}_getSettings(){return R3e(this._ecsProvider)}_createTrouterTelemetryConfig(e){return{eventLogger:new aHt(e.createChild("TrouterTelemetry"),this._telemetryLogManager),settings:{enabled:this._ecsProvider.getTrouterTelemetryConfig().enabled,logHealthCheckError:this._ecsProvider.getTrouterTelemetryConfig().logHealthCheckError,trouter_js_client_connected:this._ecsProvider.getTrouterTelemetryConfig().trouter_js_client_connected,trouter_js_client_disconnected:this._ecsProvider.getTrouterTelemetryConfig().trouter_js_client_disconnected,trouter_js_client_error:this._ecsProvider.getTrouterTelemetryConfig().trouter_js_client_error,trouter_js_client_progress:this._ecsProvider.getTrouterTelemetryConfig().trouter_js_client_progress,trouter_js_client_response:this._ecsProvider.getTrouterTelemetryConfig().trouter_js_client_response,numberOfStepsToMaintain:this._ecsProvider.getTrouterTelemetryConfig().numberOfStepsToMaintain,sendProgressTimeoutSecs:this._ecsProvider.getTrouterTelemetryConfig().sendProgressTimeoutSecs}}}_getTrouterConfig(e,i){return{trouterSettings:this._getSettings(),proxyUrlRewrite:this._acsProxy.hasProxyUrl()?r=>this._acsProxy.proxyfyUrl(r):void 0,skypeTokenProvider:i,telemetryConfig:this._createTrouterTelemetryConfig(e),registrationStateCallbackForAcsDoNotUse:r=>{this._logger.info(`TrouterService registrationStateCallbackForAcs: ${r}`),this._isRegistered=r,this._initialRegistrationCompleteDefer.isPending()&&this._isRegistered?this._initialRegistrationCompleteDefer.resolve():this._isRegistered?this._logger.info("Signaling service is currently registered"):this._logger.error("Signaling service is currently not registered. Unable to receive incoming calls"),this._onRegisteredChanged(r)}}}_onRegisteredChanged(e){this._logger.info(`TrouterService onRegisteredChanged: ${e}`),this._registeredChangedListeners.forEach(i=>{i(e)})}}class oHt{constructor(e){this._eventToTenantId={skypecosi_concore_web_csa_conversation_httprequest:MA,skypecosi_concore_web_ts_calling_in_call_session:MA,skypecosi_concore_web_ts_calling_call_setup_session:MA,skypecosi_concore_native_ts_calling_in_call_session:MA,skypecosi_concore_native_ts_calling_call_setup_session:MA,skypecosi_concore_web_pluginless_call_session:MA,skypecosi_concore_web_pluginless_modality_session:MA,skypecosi_concore_web_csa_conversation_callmodality:MA,skypecosi_concore_web_ts_calling_registry:MA,mdsc_webrtc_session:gO,mdsc_webrtc_session_initial:gO,live_events:xxe,mdsc_ortc_reports:gO,mdsc_ortc_reports_initial:gO,mdsc_rt_log:gO},this.getTenant=i=>this._eventToTenantId[i]?this._eventToTenantId[i]:"",this.getCallingAdapter=()=>({sendEvent:(i,r)=>{this._telemetryLogManager.sendEvent({tenant:this.getTenant(i),name:i,properties:r})}}),this.getGenericTelemetryLogger=i=>({sendEvent:r=>{this._telemetryLogManager.sendEvent({tenant:this.getTenant(r.eventName),name:r.eventName,properties:r.props})}}),this.getMediaAdapter=()=>({sendEvent:(i,r)=>{this._telemetryLogManager.sendEvent({tenant:this.getTenant(i),name:i,properties:r})}}),this.sendEvents=i=>(i.forEach(r=>{this._telemetryLogManager.sendEvent({tenant:this.getTenant(r.eventName),name:r.eventName,properties:r.props})}),Promise.resolve()),this._telemetryLogManager=e}}class sHt{constructor(){this._timedVideoEffectProviderPromise=sBe(UDe),this._timedModelConfigPromise=sBe(UDe)}get videoEffectProviderDeferredPromise(){return this._timedVideoEffectProviderPromise.deferredPromise}get modelConfigDeferredPromise(){return this._timedModelConfigPromise.deferredPromise}async getVideoEffectProvider(){return this._timedVideoEffectProviderPromise.timerStart(),this._timedVideoEffectProviderPromise.deferredPromise.promise}async getModelConfig(){return this._timedModelConfigPromise.deferredPromise.resolve({modelUrl:"",weightPathPrefix:""}),this._timedModelConfigPromise.deferredPromise.promise}}class lHt{constructor(e){this._encodedStreamsJsPath=e}async getWorkerUrl(){return this._encodedStreamsJsPath}}class M3e{constructor(e,i){i||typeof e.createChild!="function"?this.logger=e:this.logger=e.createChild("JS.TsCalling.RequestDispatcher"),this.proxy=i}getRequestOptions(e,i,r,o,l){return{headers:i||{},timeout:o,payload:r||null,responseType:l}}getAsync(e,i){return this.sendRequest(this.proxy?this.proxy.proxyfyUrl(e):e,i,"GET")}postAsync(e,i){return this.sendRequest(this.proxy?this.proxy.proxyfyUrl(e):e,i,"POST")}putAsync(e,i){return this.sendRequest(this.proxy?this.proxy.proxyfyUrl(e):e,i,"PUT")}removeAsync(e,i){return this.sendRequest(this.proxy?this.proxy.proxyfyUrl(e):e,i,"DELETE")}async sendRequest(e,i={headers:{}},r){const o=this.logger.createChild(`[${i.causeId||ln()}][Request]`);o.info(`sending, ${r}-${e}`);const l=Date.now();let d;i.headers=i.headers||{},i.headers["content-type"]||(i.headers["content-type"]=i.contentType||"application/json");let h={url:e,start:new Date(l).toISOString(),end:"",statusCode:0,deltaTimeInMs:0,causeId:""};const p=wt().telemetry.apiCauseIdHeader;try{const g=JB.request({url:e,method:r,headers:i.headers||{},timeout:typeof i.timeout=="number"?i.timeout:45e3,data:i.payload||"",responseType:i.responseType||i.dataType||"json",withCredentials:Ext(i.withCredentials,!1),cancelToken:new JB.CancelToken(y=>{d=y})});Axt(i.timeout)&&i.timeout.then(()=>{o.info("Aborting pending request"),d()},()=>{o.info("Timeout promise rejected, ignoring")});const f=await g;if(o.info(`success, status=${f.status}`),i.headers[p]){const y=i.headers[p].split("-")[0];wo.getRemoveCauseIdToNetworkInfo(y)&&(h={...h,end:new Date().toISOString(),statusCode:f.status,deltaTimeInMs:Date.now()-l,causeId:y},wo.setCauseIdToNetworkInfo(y,h))}return{response:f.data,request:f.request,duration:Date.now()-l}}catch(g){if(o.info("failed"),i.headers[p]){const f=i.headers[p].split("-")[0];wo.ifCauseIdExistsRemoveNetworkInfo(f)&&(h={...h,end:new Date().toISOString(),statusCode:g.code,deltaTimeInMs:Date.now()-l,causeId:f},wo.setCauseIdToNetworkInfo(f,h))}throw JB.isCancel(g)?(o.info(`response=${YY(g.message)}`),{aborted:!0}):(g.response?o.info(`response=${YY(g.response)}`):g.request?o.info(`no response, request=${YY(g.request)}`):o.info(`request not made, error=${YY(g)}`),g||new Error("Request failed"))}}}class cHt{constructor(){this._activeEffects=[],this.eventEmitter=new $c.EventEmitter}on(e,i){if(e!=="statusChanged")throw new Oe({defaultError:we.FEATURES.VIDEO_EFFECTS.EVENT_SUBSCRIBE,defaultErrorMessageArgs:[e]});this.eventEmitter.on(e,i)}off(e,i){if(e!=="statusChanged")throw new Oe({defaultError:we.FEATURES.VIDEO_EFFECTS.EVENT_UNSUBSCRIBE,defaultErrorMessageArgs:[e]});this.eventEmitter.off(e,i)}getActiveEffects(){return this._activeEffects}setActiveEffects(e){const i=this._activeEffects;this._activeEffects=e,this.eventEmitter.emit("statusChanged",i,this._activeEffects)}}class dHt{constructor(){this._activeEffects={echoCancellation:[],noiseSuppression:[],autoGainControl:[]},this.eventEmitter=new $c.EventEmitter}on(e,i){if(e!=="statusChanged")throw new Oe({defaultError:we.FEATURES.AUDIO_EFFECTS.EVENT_SUBSCRIBE,defaultErrorMessageArgs:[e]});this.eventEmitter.on(e,i)}off(e,i){if(e!=="statusChanged")throw new Oe({defaultError:we.FEATURES.AUDIO_EFFECTS.EVENT_UNSUBSCRIBE,defaultErrorMessageArgs:[e]});this.eventEmitter.off(e,i)}getActiveEffects(){return this._activeEffects}setActiveEffects(e,i){const r={...this._activeEffects};this._activeEffects={...e},this.eventEmitter.emit("statusChanged",r,this._activeEffects,i)}}class uHt{get providerValue(){return this._providerValue}set providerValue(e){this._providerValue=e}async getAudioEffectProvider(){return this.providerValue}}function hHt(){return!!navigator.mediaDevices?.tsCallingChannel}function pHt(t){const e=wt().vdi3;let i=e.cdnUrl;if(!i){const l=e.customTsVersion||vP.stackFactory.getVersion().build;if(l.includes("_"))throw new Oe({defaultError:we.FEATURES.VDI3.INVALID_CDN_URL});i=`${e.cdnBaseUrl}${l}/`}const r=new URL(e.loaderHtmlPath,i).toString(),o=new URL(e.pluginlessJsPath,i).toString();return{vdi3Config:{transport:vP.tsCallingChannel({transportConnectionTimeout:e.transportConnectionTimeoutInMs,remoteExecutionTimeout:e.remoteExecutionTimeoutInMs,messageConfig:{chunkSize:e.chunkSize},tsCallingChannel:{connectionUrl:r}},t),trouterSettings:{},pluginlessUrl:o,cdnUrl:i}}}const gHt={AcsCallingSDKWeb:{telemetry:{telemetryFlushTimeout:1e4},calling:{allowAccessRawMediaStream:!1,deviceSelectionTimeoutInMs:1e4}},SkypeWebMedia:{mediaAgent:{useOneDsLogger:!0}}};class mHt{constructor(){this._mapping=new WeakMap,this._eventEmitter=new $c}get(e){return this._mapping.get(e)?.deref()}create(e){const i=this._createProxy(e);if(i===void 0)throw new Error("The type is not supported for proxy");return this._mapping.set(e,new WeakRef(i)),i}replaceProxyToRaw(e){if(typeof e=="object"){if(Array.isArray(e))return e.map(i=>this.replaceProxyToRaw(i));if(xB in e)return e[xB]}return e}replaceRawToProxy(e,i){if(i===void 0&&(i=new Map),typeof e=="object"){if(e===null)return e;if(i.has(e))return i.get(e);if(xB in e)return e;if(Array.isArray(e)){const o=e.map(l=>this.replaceRawToProxy(l,i));return i.set(e,o),o}if(e instanceof Promise)return e.then(o=>this.replaceRawToProxy(o,i));if(e instanceof ArrayBuffer||e instanceof Uint8Array||e instanceof Date||e instanceof RegExp)return e;if(this.isSupportedType(e)){let o=this.get(e);return o===void 0&&(o=this.create(e)),i.set(e,o),o}if(eUe(e))return i.set(e,e),e;const r={};i.set(e,r);for(const[o,l]of Object.entries(e))r[o]=this.replaceRawToProxy(l,i);return r[xB]=e,r}return e}on(e,i){this._eventEmitter.on(e,i)}once(e,i){this._eventEmitter.once(e,i)}dispose(){this._eventEmitter.removeAllListeners()}}function c4(t,e,i,r={}){return new Proxy(t,{get:(o,l)=>{let d,h;if(l===xB)return t;if(l in e)d=e[l],h=e;else{if(!(l in t))return;d=t[l],h=t}const p=r[l]??{input:!0,output:!0};if(typeof d=="function"){if(!i.isRemoteStackActive()&&h===t)throw new Oe({defaultError:we.FEATURES.VDI3.REMOTE_STACK_TERMINATED});return new Proxy(d,{apply:(g,f,y)=>{const T=y.map(E=>typeof E=="function"?(...I)=>E.apply(null,i.replaceRawToProxy(I)):p.input?i.replaceProxyToRaw(E):E),C=Reflect.apply(g,h,T);return p.output?i.replaceRawToProxy(C):C}})}return p.output?i.replaceRawToProxy(d):d},has:(o,l)=>l===xB||l in e||l in t})}class d4{constructor(e,i){this._proxyReferenceManager=e,this._tsObject=i,this._eventEmitter=new $c,this._handles=new Map}_proxyCall(e,i){const r=this._tsObject[e];if(r!==void 0)return r.apply(this._tsObject,i)}get instance(){return this._tsObject}changed(e){const i="changed";let r=this._handles.get(i);if(r===void 0){const l=(...d)=>{this._eventEmitter.emit(i,...d)};r=this._proxyCall("changedAsync",[l]),this._handles.set(i,r)}const o=(...l)=>{e.apply(null,l)};return this._eventEmitter.on(i,o),{dispose:()=>{this._eventEmitter.off(i,o),this._eventEmitter.listenerCount(i)===0&&(r?.then(l=>l.disposeAsync?.()).catch(nh),this._handles.delete(i))}}}on(e,i){const r=`on_${e}`;let o=this._handles.get(r);if(o===void 0){const d=(...h)=>{this._eventEmitter.emit(r,...h)};o=this._proxyCall("onAsync",[e,d]),this._handles.set(r,o)}const l=(...d)=>{i.apply(null,d)};return this._eventEmitter.on(r,l),{dispose:()=>{this._eventEmitter.off(r,l),this._eventEmitter.listenerCount(r)===0&&(o?.then(d=>d.disposeAsync?.()).catch(nh),this._handles.delete(r))}}}once(e,i){const r=`once_${e}`;let o=this._handles.get(r);if(o===void 0){const d=(...h)=>{this._eventEmitter.emit(r,...h)};o=this._proxyCall("onceAsync",[e,d]),this._handles.set(r,o)}const l=(...d)=>{i.apply(null,d)};return this._eventEmitter.on(r,l),{dispose:()=>{this._eventEmitter.off(r,l),this._eventEmitter.listenerCount(r)===0&&(o?.then(d=>d.disposeAsync?.()).catch(nh),this._handles.delete(r))}}}async changedAsync(e){const i="changed";let r=this._handles.get(i);if(r===void 0){const l=(...d)=>{this._eventEmitter.emit(i,...d)};r=this._proxyCall("changedAsync",[l]),this._handles.set(i,r)}const o=(...l)=>{e.apply(null,l)};return this._eventEmitter.on(i,o),await r,{dispose:()=>{this._eventEmitter.off(i,o),this._eventEmitter.listenerCount(i)===0&&(r?.then(l=>l.disposeAsync?.()).catch(nh),this._handles.delete(i))}}}async onAsync(e,i){const r=`on_${e}`;let o=this._handles.get(r);if(o===void 0){const d=(...h)=>{this._eventEmitter.emit(r,...h)};o=this._proxyCall("onAsync",[e,d]),this._handles.set(r,o)}const l=(...d)=>{i.apply(null,d)};return this._eventEmitter.on(r,l),await o,{dispose:()=>{this._eventEmitter.off(r,l),this._eventEmitter.listenerCount(r)===0&&(o?.then(d=>d.disposeAsync?.()).catch(nh),this._handles.delete(r))}}}}class fHt extends d4{constructor(e,i){super(e,i),e.once("remoteStackTerminated",()=>{this._eventEmitter.emit("changed"),this._eventEmitter.emit("on_callStateChanged")})}get state(){return this._proxyReferenceManager.isRemoteStackActive()?this._tsObject.state:7}get callEndDiagnosticsInfo(){return this._proxyReferenceManager.isRemoteStackActive()||this._tsObject.state===7?this._tsObject.callEndDiagnosticsInfo:{callControllerCode:0,callControllerSubCode:4521,phrase:"call ended due to RDP disconnection",resultCategories:["ExpectedError"]}}get ptzHandler(){throw new Oe({defaultError:we.FEATURES.VDI3.PROPERTY_UNAVAILABLE})}get broadcastMeeting(){throw new Oe({defaultError:we.FEATURES.VDI3.PROPERTY_UNAVAILABLE})}get videoLayout(){throw new Oe({defaultError:we.FEATURES.VDI3.PROPERTY_UNAVAILABLE})}getIncomingRawAudioStream(e){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}getUnmixedAudioProvider(){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}init(e){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}setDeviceManager(e){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}forceUpdate(){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}startVideo(e,i){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}stopVideo(e,i){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}startScreenSharing(e,i,r,o){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}changeCropRegion(e){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}stopScreenSharing(e,i,r){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}callSafeTransfer(e,i,r){return r===void 0&&(r={disableForwardingAndUnanswered:!1}),this._tsObject.callSafeTransfer(e,i,r)}setPlatformCallConstraints(e){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}createStage(e){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}sendLastKnownStats(){this._proxyReferenceManager.isRemoteStackActive()&&this._tsObject.sendLastKnownStats().catch(e=>{})}}class vHt extends d4{constructor(e,i){super(e,i)}getSourceIdForMediaType(e){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}getDiagnosticData(){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}}class yHt extends d4{constructor(e,i){super(e,i)}getRawStream(e){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}start(e,i){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}stop(){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}selectVideoTrack(e){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}setVideoStreamConfig(e){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}getDiagnosticData(){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}getStats(){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}}class SHt extends d4{constructor(e,i){super(e,i),this._deletedCalls=[]}get calls(){return dn.difference(this._tsObject.calls,this._deletedCalls)}updateSkypeToken(e){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}getSetup(){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}getCall(e,i,r){return this._tsObject.calls.find(o=>o.callId===e)}createDownloader(e,i,r,o,l){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}createCall(e,i,r,o,l){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}createCallWithGroupId(e,i,r,o){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}createCallWithMeetingData(e,i,r,o){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}deleteCall(e,i,r){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}async deleteCallAsync(e,i,r){return this._proxyReferenceManager.isRemoteStackActive()?await this._tsObject.deleteCallAsync?.apply(this._tsObject,arguments)??!1:!(!e||!this._tsObject.calls.includes(e))&&(this._deletedCalls.push(e),this._eventEmitter.emit("on_callRemoved",e),!0)}enableWindowUninitEventHandler(){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}disableWindowUninitEventHandler(){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}}class bHt extends d4{constructor(e,i){super(e,i)}getPermissionState(e){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}selectDevices(e){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}getSelectedDevices(){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}createPreview(e,i,r,o){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}createPreviewRenderer(e,i,r){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}createScreenSharingPreviewRenderer(e,i,r){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}setBackgroundImageAsync(e,i,r){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}getImagePropertyAsync(e){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}transformImageAsync(e,i,r,o){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}sendMessageDeviceVideoEffectsAsync(e,i){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}sendMessageDeviceVideoExtensibilityAsync(e,i){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}setVideoCaptureConfigAsync(e,i){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}captureVideoFrameWithoutEffectsAsync(e,i,r){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}getRawDeviceMediaStream(e,i,r){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}setRawMediaStream(e,i,r){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}unsetRawMediaStream(e,i){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}createAudioRenderer(){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}getPersonalizedNoiseSuppression(){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}}class THt extends d4{constructor(e,i){super(e,i)}getPlatformSupportLevel(){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}setPlatformCallConstraints(e){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}createCompositor(e){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}getCallRegistry(){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}cancelOperation(e){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}getDeviceManager(){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}createDeviceManager(e){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}getScreenSharingManager(){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}getSetup(){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}getEcsProvider(){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}getCallFeedback(){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}getAiMdp(){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}getVersion(){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}getMediaStatus(){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}getVideoCapabilityLimits(){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}fireIntent(e,i){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}setAllowPrivacySensitiveApis(e){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}getLiveStreamClient(e){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}getUmsStream(e){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}createVoipCallCoordinator(){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}getDebugDump(){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}createAiCameraManager(){throw new Oe({defaultError:we.FEATURES.VDI3.METHOD_UNAVAILABLE})}}class u4 extends mHt{constructor(e){super(),this._logger=e.createChild("TsProxyReferenceManager"),this._mmrRdpConnectionManager=new W5e(this._logger),this._mmrRdpConnectionManager.on("stateChange",i=>{i=="disconnected"&&this._remoteStackTerminated()})}static create(e){const i=new u4(e);return this.proxyReferenceManagers.add(i),i}static notifyRemoteStackTermination(){this.proxyReferenceManagers.forEach(e=>{e._remoteStackTerminated()})}dispose(){this._mmrRdpConnectionManager.dispose(),u4.proxyReferenceManagers.delete(this),super.dispose()}_remoteStackTerminated(){this._isRemoteStackActive!==!1&&(this._logger.warn("remote stack is terminated"),this._isRemoteStackActive=!1,this._eventEmitter.emit("remoteStackTerminated"))}_createProxy(e){const i=X2e(e);if(i!==Vv.None){if(i===Vv.ICall)return c4(e,new fHt(this,e),this);if(i===Vv.ICallParticipant)return c4(e,new vHt(this,e),this);if(i===Vv.ICallParticipantStream)return c4(e,new yHt(this,e),this);if(i===Vv.ICallRegistry)return c4(e,new SHt(this,e),this);if(i===Vv.IPluginlessCallingStack)return c4(e,new THt(this,e),this);if(i===Vv.IDeviceManager)return c4(e,new bHt(this,e),this)}}isSupportedType(e){return X2e(e)!==Vv.None}isRemoteStackActive(){if(this._isRemoteStackActive===void 0){const e=vP.monitor.getStat();if(!e.sessionInitializedAt)return!1;e.lastSesstionTerminatedAt&&e.lastSesstionTerminatedAt>e.sessionInitializedAt?(this._isRemoteStackActive=!1,this._eventEmitter.emit("remoteStackTerminated")):this._isRemoteStackActive=!0}return this._isRemoteStackActive}}u4.proxyReferenceManagers=new Set,vP.monitor.onConnectionTerminated(()=>{u4.notifyRemoteStackTermination()});class CHt{constructor(){this._eventEmitter=new $c.EventEmitter,this._shellTrouter=new vP.ShellTrouter,this._state=gZ.TrouterState.Unknown,this._disposeAsync=[]}async initialize(){const e=(i,r)=>{this._state=i,this._eventEmitter.emit("stateChanged",i,r)};await this._shellTrouter.onStateChanged(e),this._disposeAsync.push(async()=>{await this._shellTrouter.offStateChanged(e)})}on(e,i){this._eventEmitter.on("stateChanged",i)}off(e,i){this._eventEmitter.off("stateChanged",i)}async dispose(){for(const e of this._disposeAsync)await e();this._eventEmitter.removeAllListeners()}state(){return this._state}get instance(){return this._shellTrouter}}var HE,_Ht=bs(function(t,e){Object.defineProperty(e,"__esModule",{value:!0});var i=function(){function r(){this._isAllowed=!1}return r.prototype.putBackgroundFetchAllowed=function(o){if(this._isAllowed=o,this.isBackgroundFetchAllowed()&&this._isAllowedDeferral){var l=this._isAllowedDeferral;this._isAllowedDeferral=void 0,l.resolve(void 0)}},r.prototype.isBackgroundFetchAllowed=function(){return this._isAllowed},r.prototype.waitForBackgroundFetchAllowed=function(){return this.isBackgroundFetchAllowed()?oh.Resolved():(this._isAllowedDeferral||(this._isAllowedDeferral=oh.Defer()),this._isAllowedDeferral.promise())},r}();e.default=i}),EHt=bs(function(t,e){Object.defineProperty(e,"__esModule",{value:!0});var i=function(){function r(){this._isActive=!1}return r.prototype.putAppActive=function(o){if(this._isActive=o,this.isAppActive()&&this._appActiveDeferral){var l=this._appActiveDeferral;this._appActiveDeferral=void 0,l.resolve(void 0)}},r.prototype.isAppActive=function(){return this._isActive},r.prototype.waitForAppActive=function(){return this.isAppActive()?oh.Resolved():(this._appActiveDeferral||(this._appActiveDeferral=oh.Defer()),this._appActiveDeferral.promise())},r}();e.default=i}),P3e=function(){function t(e,i){this._event=e,this._callback=i}return t.prototype.unsubscribe=function(){this._event.unsubscribe(this._callback)},t}(),AHt=function(){function t(e){e===void 0&&(e=!1);var i=this;this._allowStopPropagation=e,this.fire=function(){for(var r=[],o=0;o<arguments.length;o++)r[o]=arguments[o];for(var l=i._subscribers,d=l.length-1;d>=0;d--){var h=l[d].apply(null,r);if(i._allowStopPropagation&&h)return!0}return!1},this._subscribers=[]}return t.prototype.dispose=function(){this._subscribers=[]},t.prototype.subscribe=function(e){return this._subscribers=this._subscribers.concat(e),new P3e(this,e)},t.prototype.unsubscribe=function(e){this._subscribers=this._subscribers.filter(function(i){return i!==e})},t}(),IHt=Object.freeze({__proto__:null,SubscriptionToken:P3e,default:AHt}),Ik=bs(function(t,e){Object.defineProperty(e,"__esModule",{value:!0}),function(i){i[i.Default=0]="Default",i[i.User=1]="User"}(e.EcsConfigType||(e.EcsConfigType={}))}),pge=xDe(IHt),wHt=bs(function(t,e){Object.defineProperty(e,"__esModule",{value:!0});var i=function(){function r(o){this._config=o,this.configUpdated=new pge.default,this._cachedConfigs={}}return r.prototype.initialize=function(){return this.updateConfigsToFetch()},r.prototype.updateConfigsToFetch=function(){var o=this,l=this._config.getConfig(),d=l.databaseInterface,h=l.configsToFetch;if(!d)return oh.Resolved();for(var p=[],g=function(C){if(f._cachedConfigs[C])return"continue";p.push(d.getData(C).then(function(E){E&&(o._cachedConfigs[C]=E)}).catch(function(){return oh.Resolved()}))},f=this,y=0,T=h;y<T.length;y++)g(T[y]);return oh.all(p).then(function(){p.length>0&&o.configUpdated.fire()})},r.prototype.getEcsConfig=function(){return this._cachedConfigs[Ik.EcsConfigType.User]||this._cachedConfigs[Ik.EcsConfigType.Default]},r.prototype.getEcsConfigByType=function(o){return this._cachedConfigs[o]},r.prototype.putConfig=function(o){var l=this.getEcsConfig();this._cachedConfigs[o.configType]=o;var d=this.getEcsConfig();(d&&d.configType===o.configType||l&&d&&l.configType!==d.configType)&&this.configUpdated.fire();var h=this._config.getConfig().databaseInterface;return h?h.putData(o.configType,o):oh.Resolved()},r}();e.default=i}),kHt=bs(function(t,e){var i=fo&&fo.__assign||function(){return i=Object.assign||function(o){for(var l,d=1,h=arguments.length;d<h;d++)for(var p in l=arguments[d])Object.prototype.hasOwnProperty.call(l,p)&&(o[p]=l[p]);return o},i.apply(this,arguments)};Object.defineProperty(e,"__esModule",{value:!0});var r=function(){function o(){}return o.prototype.initialize=function(l){if(this._config)throw new Error("ECS Configuration already initialized");this._config=l},o.prototype.getConfig=function(){if(!this._config)throw new Error("ECS Configuration not yet initialized");return this._config},o.prototype.setConfigsToFetch=function(l){if(!this._config)throw new Error("ECS Configuration not yet initialized");this._config=i(i({},this._config),{configsToFetch:l})},o.prototype.setFetchTimeout=function(l){if(!this._config)throw new Error("ECS Configuration not yet initialized");this._config=i(i({},this._config),{fetchTimeout:l})},o}();e.default=r}),qh=bs(function(t,e){var i=fo&&fo.__assign||function(){return i=Object.assign||function(r){for(var o,l=1,d=arguments.length;l<d;l++)for(var h in o=arguments[l])Object.prototype.hasOwnProperty.call(o,h)&&(r[h]=o[h]);return r},i.apply(this,arguments)};Object.defineProperty(e,"__esModule",{value:!0}),e.assert=function(r,o){if(!r)throw new Error(o)},e.isObject=function(r){return r!==null&&typeof r=="object"},e.isString=function(r){return typeof r=="string"},e.attempt=function(r){for(var o=[],l=1;l<arguments.length;l++)o[l-1]=arguments[l];try{return r.apply(void 0,o)}catch(d){return new Error(d)}},e.remove=function(r,o){for(var l=r.length-1;l>=0;l--)r[l]===o&&r.splice(l,1)},e.clone=function(r){return Array.isArray(r)?r.map(e.clone):e.isObject(r)?Object.keys(r).reduce(function(o,l){var d;return i(i({},o),((d={})[l]=e.clone(r[l]),d))},{}):r}}),D3e=bs(function(t,e){Object.defineProperty(e,"__esModule",{value:!0}),e.DEFAULT_TIME_GROW_FACTOR=2.718281828459045,e.DEFAULT_TIME_JITTER=.11962656472;var i=function(){function r(o,l,d,h){d===void 0&&(d=e.DEFAULT_TIME_GROW_FACTOR),h===void 0&&(h=e.DEFAULT_TIME_JITTER),this._initialTime=o,this._maxTime=l,this._growFactor=d,this._jitterFactor=h,qh.assert(this._initialTime>0,"Initial delay must be positive"),qh.assert(this._maxTime>0,"Delay upper bound must be positive"),qh.assert(this._growFactor>=0,"Ratio must be non-negative"),qh.assert(this._jitterFactor>=0,"Jitter factor must be non-negative"),this.reset()}return r.prototype.reset=function(){this._incrementCount=0,this._currentTime=Math.round(this._initialTime*(1+Math.random()*this._jitterFactor))},r.prototype.getTime=function(){return this._currentTime},r.prototype.getIncrementCount=function(){return this._incrementCount},r.prototype.calculateNext=function(){var o=this._currentTime*this._growFactor;return o>this._maxTime&&(o=this._maxTime),this._jitterFactor<1e-5?this._currentTime=o:this._currentTime=Math.round(Math.random()*o*this._jitterFactor+o),this._currentTime<this._initialTime&&(this._currentTime=this._initialTime),this._currentTime>this._maxTime&&(this._currentTime=this._maxTime),this._incrementCount++,this._currentTime},r.prototype.getTimeAndCalculateNext=function(){var o=this.getTime();return this.calculateNext(),o},r}();e.ExponentialTime=i}),L3e=bs(function(t,e){var i,r,o,l=fo&&fo.__extends||(i=function(x,B){return i=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(L,z){L.__proto__=z}||function(L,z){for(var H in z)z.hasOwnProperty(H)&&(L[H]=z[H])},i(x,B)},function(x,B){function L(){this.constructor=x}i(x,B),x.prototype=B===null?Object.create(B):(L.prototype=B.prototype,new L)}),d=fo&&fo.__assign||function(){return d=Object.assign||function(x){for(var B,L=1,z=arguments.length;L<z;L++)for(var H in B=arguments[L])Object.prototype.hasOwnProperty.call(B,H)&&(x[H]=B[H]);return x},d.apply(this,arguments)};function h(x){return!!x&&x.indexOf("application/json")===0}function p(x){return!!x&&x.indexOf("application/x-www-form-urlencoded")===0}function g(x){return!!x&&x.indexOf("multipart/form-data")===0}function f(x,B){return B.canceled||!B.statusCode||B.statusCode>=400&&B.statusCode<600?o.DoNotRetry:o.RetryCountedWithBackoff}Object.defineProperty(e,"__esModule",{value:!0}),function(x){x[x.DontCare=0]="DontCare",x[x.Low=1]="Low",x[x.Normal=2]="Normal",x[x.High=3]="High",x[x.Critical=4]="Critical"}(r=e.WebRequestPriority||(e.WebRequestPriority={})),function(x){x[x.DoNotRetry=0]="DoNotRetry",x[x.RetryUncountedImmediately=1]="RetryUncountedImmediately",x[x.RetryUncountedWithBackoff=2]="RetryUncountedWithBackoff",x[x.RetryCountedWithBackoff=3]="RetryCountedWithBackoff",x[x.PauseUntilResumed=4]="PauseUntilResumed"}(o=e.ErrorHandlingType||(e.ErrorHandlingType={})),e.DefaultOptions={priority:r.Normal},e.SimpleWebRequestOptions={MaxSimultaneousRequests:5,HungRequestCleanupIntervalMs:1e4,setTimeout:function(x,B){return setTimeout(x,B)},clearTimeout:function(x){return clearTimeout(x)}},e.DefaultErrorHandler=f;var y,T=[],C=[],E=[],I=0,w=0,D=function(){function x(B,L,z,H,j){this._action=B,this._url=L,this.options=z,this._getHeaders=H,this._blockRequestUntil=j,this._aborted=!1,this._timedOut=!1,this._paused=!1,this._created=Date.now(),this._finishHandled=!1,this._retryExponentialTime=new D3e.ExponentialTime(1e3,3e5),this._options=d(d({},e.DefaultOptions),z)}return x.prototype.getPriority=function(){return this._options.priority||r.DontCare},x.checkQueueProcessing=function(){for(var B=function(){var L=T.shift();C.push(L),(L._blockRequestUntil&&L._blockRequestUntil()||oh.Resolved()).finally(function(){qh.remove(C,L)}).then(function(){E.length<e.SimpleWebRequestOptions.MaxSimultaneousRequests&&!L._aborted?(E.push(L),F._scheduleHungRequestCleanupIfNeeded(),L._fire()):L._enqueue()},function(z){L._respond("_blockRequestUntil rejected: "+z)})};T.length>0&&E.length<e.SimpleWebRequestOptions.MaxSimultaneousRequests;)B()},x._scheduleHungRequestCleanupIfNeeded=function(){E.length>0&&y===void 0?y=e.SimpleWebRequestOptions.setTimeout(this._hungRequestCleanupTimerCallback,e.SimpleWebRequestOptions.HungRequestCleanupIntervalMs):E.length===0&&y&&(e.SimpleWebRequestOptions.clearTimeout(y),y=void 0)},x.prototype._removeFromQueue=function(){qh.remove(E,this),qh.remove(T,this)},x.prototype._assertAndClean=function(B,L){B||(this._removeFromQueue(),console.error(L),qh.assert(B,L))},x.prototype._fire=function(){var B=this;this._xhr=new XMLHttpRequest,this._xhrRequestHeaders={};var L=qh.attempt(function(){B._xhr.open(B._action,B._url,!0)});if(L)this._respond(L.toString());else{if(this._options.timeout){var z=w;z!==3&&(this._assertAndClean(!this._requestTimeoutTimer,"Double-fired requestTimeoutTimer"),this._requestTimeoutTimer=e.SimpleWebRequestOptions.setTimeout(function(){B._requestTimeoutTimer=void 0,B._timedOut=!0,B.abort()},this._options.timeout)),(z===3||z<=1)&&(this._xhr.timeout=this._options.timeout,this._xhr.ontimeout=function(){w=3,z===3&&(B._timedOut=!0,B._aborted=!0,B._respond("TimedOut"))})}var H=I;H!==3?(H===0&&(I=1),this._xhr.onreadystatechange=function(){B._xhr&&(B._xhr.readyState!==3||!B._options.streamingDownloadProgress||B._aborted?B._xhr.readyState===4&&(H===0&&I===1&&e.SimpleWebRequestOptions.setTimeout(function(){I!==3&&(I=2)},1e4),B._respond()):B._options.streamingDownloadProgress(B._xhr.responseText))}):this._options.streamingDownloadProgress&&(this._xhr.onreadystatechange=function(){B._xhr&&B._xhr.readyState===3&&B._options.streamingDownloadProgress&&!B._aborted&&B._options.streamingDownloadProgress(B._xhr.responseText)}),H!==2&&(this._xhr.onload=function(){I=3,H===3&&B._respond()},this._xhr.onerror=function(){I=3,H===3&&B._respond()}),this._xhr.onabort=function(){B._aborted=!0,B._respond("Aborted")},this._xhr.upload&&this._options.onProgress&&(this._xhr.upload.onprogress=this._options.onProgress);var j=this._options.acceptType||"json",J=this._options.customResponseType||x._getResponseType(j),Z=qh.attempt(function(){B._xhr.responseType=J});if(Z&&J!=="json")throw Z;F._setRequestHeader(this._xhr,this._xhrRequestHeaders,"Accept",x.mapContentType(j)),this._xhr.withCredentials=!!this._options.withCredentials;var re=this.getRequestHeaders(),ne={};if(Object.keys(re).forEach(function(Me){var Le=re[Me],pe=Me.toLowerCase();pe!=="content-type"?pe!=="accept"?(B._assertAndClean(!ne[pe],"Setting duplicate header key: "+ne[pe]+" and "+Me),Le!=null?(ne[pe]=!0,F._setRequestHeader(B._xhr,B._xhrRequestHeaders,Me,Le)):console.warn('Tried to set header "'+Me+'" on request with "'+Le+'" value, header will be dropped')):B._assertAndClean(!1,"Don't set Accept with options.headers -- use it with the options.acceptType property"):B._assertAndClean(!1,"Don't set Content-Type with options.headers -- use it with the options.contentType property")}),this._options.sendData){var le=x.mapContentType(this._options.contentType||"json");F._setRequestHeader(this._xhr,this._xhrRequestHeaders,"Content-Type",le);var he=x.mapBody(this._options.sendData,le);this._xhr.send(he)}else this._xhr.send()}},x._setRequestHeader=function(B,L,z,H){B.setRequestHeader(z,H),L[z]=H},x.mapContentType=function(B){return B==="json"?"application/json":B==="form"?"application/x-www-form-urlencoded":B},x.mapBody=function(B,L){if(h(L)){if(!qh.isString(B))return JSON.stringify(B)}else if(p(L)){if(!qh.isString(B)&&qh.isObject(B)){var z=B;return Object.keys(z).map(function(J){return encodeURIComponent(J)+(z[J]?"="+encodeURIComponent(z[J].toString()):"")}).join("&")}}else if(g(L)){if(qh.isObject(B)){var H=new FormData,j=B;return Object.keys(j).forEach(function(J){return H.append(J,j[J])}),H}qh.assert(!1,"contentType multipart/form-data must include an object as sendData")}return B},x.prototype.setUrl=function(B){this._url=B},x.prototype.setHeader=function(B,L){this._options.augmentHeaders||(this._options.augmentHeaders={}),L?this._options.augmentHeaders[B]=L:delete this._options.augmentHeaders[B]},x.prototype.getRequestHeaders=function(){var B={};return!this._getHeaders||this._options.overrideGetHeaders||this._options.headers||(B=d(d({},B),this._getHeaders())),this._options.overrideGetHeaders&&(B=d(d({},B),this._options.overrideGetHeaders)),this._options.headers&&(B=d(d({},B),this._options.headers)),this._options.augmentHeaders&&(B=d(d({},B),this._options.augmentHeaders)),B},x.prototype.getOptions=function(){return qh.clone(this._options)},x.prototype.setPriority=function(B){this._options.priority!==B&&(this._options.priority=B,this._paused||this._xhr||(qh.remove(T,this),this._enqueue()))},x.prototype.resumeRetrying=function(){this._paused?(this._paused=!1,this._enqueue()):qh.assert(!1,"resumeRetrying() called but not paused!")},x.prototype._enqueue=function(){var B=this;if(!this._aborted&&!(E.indexOf(this)>=0||C.indexOf(this)>=0||T.indexOf(this)>=0)){var L=T.findIndex(function(z){return z.getPriority()===B.getPriority()&&z._created>B._created||z.getPriority()<B.getPriority()});L>-1?T.splice(L,0,this):T.push(this),x.checkQueueProcessing()}},x._getResponseType=function(B){return B==="blob"?"arraybuffer":B==="text/xml"||B==="application/xml"?"document":B==="text/plain"?"text":"json"},x._hungRequestCleanupTimerCallback=function(){y=void 0,E.filter(function(B){return!(!B._xhr||B._xhr.readyState!==4)&&(console.warn("SimpleWebRequests found a completed XHR that hasn't invoked it's callback functions, manually responding"),!0)}).forEach(function(B){B._respond()}),F._scheduleHungRequestCleanupIfNeeded()},x}();e.SimpleWebRequestBase=D;var F=function(x){function B(L,z,H,j,J){return x.call(this,L,z,H,j,J)||this}return l(B,x),B.prototype.abort=function(){this._aborted?qh.assert(!1,"Already aborted "+this._action+" request to "+this._url):(this._aborted=!0,this._retryTimer&&(e.SimpleWebRequestOptions.clearTimeout(this._retryTimer),this._retryTimer=void 0),this._requestTimeoutTimer&&(e.SimpleWebRequestOptions.clearTimeout(this._requestTimeoutTimer),this._requestTimeoutTimer=void 0),this._deferred?(this._respond("Aborted"),this._xhr&&this._xhr.abort()):qh.assert(!1,"Haven't even fired start() yet -- can't abort"))},B.prototype.start=function(){var L=this;return this._deferred?(qh.assert(!1,"WebRequest already started"),oh.Rejected("WebRequest already started")):(this._deferred=oh.Defer(),this._deferred.onCancel(function(){L.abort()}),this._enqueue(),this._deferred.promise())},B.prototype._respond=function(L){var z=this;if(!this._finishHandled){this._finishHandled=!0,this._removeFromQueue(),this._retryTimer&&(e.SimpleWebRequestOptions.clearTimeout(this._retryTimer),this._retryTimer=void 0),this._requestTimeoutTimer&&(e.SimpleWebRequestOptions.clearTimeout(this._requestTimeoutTimer),this._requestTimeoutTimer=void 0);var H,j=0;if(this._xhr)try{j=this._xhr.status,H=this._xhr.statusText||L}catch{}else H=L||"Browser Error - Possible CORS or Connectivity Issue";var J,Z,re={};if(this._xhr){if((this._xhr.getAllResponseHeaders()||"").split(/\r?\n/).forEach(function(Le){if(Le.length!==0){var pe=Le.indexOf(":");pe===-1?re[Le]="":re[Le.substr(0,pe).toLowerCase()]=Le.substr(pe+1).trim()}}),!re["content-type"]){var ne=this._xhr.getResponseHeader("content-type");ne&&(re["content-type"]=ne)}if(J=this._xhr.response,re["content-type"]&&h(re["content-type"])&&(!J||!qh.isObject(J))&&(this._xhr.responseType==="text"||this._xhr.responseType==="")&&this._xhr.responseText)try{J=JSON.parse(this._xhr.responseText)}catch(Le){Z=Le,console.warn("Failed to parse XHR JSON response")}}if(this._xhr&&this._xhr.readyState===4&&(j>=200&&j<300||j===304)){var le={url:this._xhr.responseURL||this._url,method:this._action,requestOptions:this._options,requestHeaders:this._xhrRequestHeaders||{},statusCode:j,statusText:H,headers:re,body:J,responseParsingException:Z};this._deferred.resolve(le)}else{var he={url:(this._xhr?this._xhr.responseURL:void 0)||this._url,method:this._action,requestOptions:this._options,requestHeaders:this._xhrRequestHeaders||{},statusCode:j,statusText:H,headers:re,body:J,canceled:this._aborted,timedOut:this._timedOut,responseParsingException:Z};this._options.augmentErrorResponse&&this._options.augmentErrorResponse(he);var Me=this._options.customErrorHandler?this._options.customErrorHandler(this,he):f(this,he);Me!==o.DoNotRetry&&(this._options.retries&&this._options.retries>0||Me===o.PauseUntilResumed||Me===o.RetryUncountedImmediately||Me===o.RetryUncountedWithBackoff)?(Me===o.RetryCountedWithBackoff&&this._options.retries--,this._requestTimeoutTimer&&(e.SimpleWebRequestOptions.clearTimeout(this._requestTimeoutTimer),this._requestTimeoutTimer=void 0),this._aborted=!1,this._timedOut=!1,this._finishHandled=!1,this._xhr&&(this._xhr.onabort=null,this._xhr.onerror=null,this._xhr.onload=null,this._xhr.onprogress=null,this._xhr.onreadystatechange=null,this._xhr.ontimeout=null,this._xhr=void 0,this._xhrRequestHeaders=void 0),Me===o.PauseUntilResumed?this._paused=!0:Me===o.RetryUncountedImmediately?this._enqueue():this._retryTimer=e.SimpleWebRequestOptions.setTimeout(function(){z._retryTimer=void 0,z._enqueue()},this._retryExponentialTime.getTimeAndCalculateNext())):this._deferred.reject(he)}D.checkQueueProcessing()}},B}(D);e.SimpleWebRequest=F}),RHt=bs(function(t,e){var i=fo&&fo.__assign||function(){return i=Object.assign||function(o){for(var l,d=1,h=arguments.length;d<h;d++)for(var p in l=arguments[d])Object.prototype.hasOwnProperty.call(l,p)&&(o[p]=l[p]);return o},i.apply(this,arguments)};Object.defineProperty(e,"__esModule",{value:!0});var r=function(){function o(l){this._defaultOptions={excludeEndpointUrl:!1,withCredentials:!1,retries:0},this._endpointUrl=l}return o.prototype._performApiCall=function(l,d,h,p){var g=this;p===void 0&&(p={});var f=i(i({},this._defaultOptions),p);h&&(f.sendData=h),f.eTag&&(f.augmentHeaders||(f.augmentHeaders={}),f.augmentHeaders["If-None-Match"]=f.eTag),f.contentType||(f.contentType=qh.isString(f.sendData)?"form":"json");var y=f.excludeEndpointUrl?l:this._endpointUrl+l;return new L3e.SimpleWebRequest(d,y,f,function(){return g._getHeaders(f)},function(){return g._blockRequestUntil(f)}).start().then(function(T){return g._processSuccessResponse(T),T})},o.prototype._getHeaders=function(l){return{}},o.prototype._blockRequestUntil=function(l){},o.prototype._processSuccessResponse=function(l){},o.prototype.performApiGet=function(l,d){return this.performApiGetDetailed(l,d).then(function(h){return h.body})},o.prototype.performApiGetDetailed=function(l,d){return this._performApiCall(l,"GET",void 0,d)},o.prototype.performApiPost=function(l,d,h){return this.performApiPostDetailed(l,d,h).then(function(p){return p.body})},o.prototype.performApiPostDetailed=function(l,d,h){return this._performApiCall(l,"POST",d,h)},o.prototype.performApiPatch=function(l,d,h){return this.performApiPatchDetailed(l,d,h).then(function(p){return p.body})},o.prototype.performApiPatchDetailed=function(l,d,h){return this._performApiCall(l,"PATCH",d,h)},o.prototype.performApiPut=function(l,d,h){return this.performApiPutDetailed(l,d,h).then(function(p){return p.body})},o.prototype.performApiPutDetailed=function(l,d,h){return this._performApiCall(l,"PUT",d,h)},o.prototype.performApiDelete=function(l,d,h){return this.performApiDeleteDetailed(l,d,h).then(function(p){return p.body})},o.prototype.performApiDeleteDetailed=function(l,d,h){return this._performApiCall(l,"DELETE",d,h)},o}();e.GenericRestClient=r}),O3e=bs(function(t,e){function i(r){for(var o in r)e.hasOwnProperty(o)||(e[o]=r[o])}Object.defineProperty(e,"__esModule",{value:!0}),i(D3e),i(RHt),i(L3e)}),MHt=bs(function(t,e){Object.defineProperty(e,"__esModule",{value:!0});var i=function(){function r(){}return r.prototype.getAttributes=function(){return{Source:"ecs_client"}},r}();e.TelemetryEventBase=i}),N3e=bs(function(t,e){var i,r=fo&&fo.__extends||(i=function(l,d){return i=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(h,p){h.__proto__=p}||function(h,p){for(var g in p)p.hasOwnProperty(g)&&(h[g]=p[g])},i(l,d)},function(l,d){function h(){this.constructor=l}i(l,d),l.prototype=d===null?Object.create(d):(h.prototype=d.prototype,new h)});Object.defineProperty(e,"__esModule",{value:!0});var o=function(l){function d(h,p,g,f,y,T,C,E,I,w,D,F,x,B,L,z,H){var j=l.call(this)||this;return j._responseTime=h,j._responseCode=p,j._fetchAttempts=g,j._hasValidToken=f,j._serverEndpoint=y,j._fetchDurationValid=T,j._cacheAvailable=C,j._responseSize=E,j._configAge=I,j._configExpired=w,j._fetchStart=D,j._fetchEnd=F,j._isUserConfig=x,j._etag=B,j._timedOut=L,j._responseParsingException=z,j._errorMessage=H,j}return r(d,l),d.prototype.getEventName=function(){return"ecs_tsclient_fetch_config"},d.prototype.getAttributes=function(){var h=l.prototype.getAttributes.call(this);return h.fetch_delay_ms=this._responseTime,h.fetch_response_code=this._responseCode,h.fetch_attempts=this._fetchAttempts,h.authenticated_user=this._hasValidToken,h.url=this._serverEndpoint,h.fetch_duration_valid=this._fetchDurationValid,h.cache_available=this._cacheAvailable,h.response_size=this._responseSize,h.config_age=this._configAge,h.config_expired=this._configExpired,h.fetch_start=this._fetchStart,h.fetch_end=this._fetchEnd,h.is_user_config=this._isUserConfig,this._etag&&(h.fetched_etag=this._etag),this._timedOut!==void 0&&(h.fetch_timed_out=this._timedOut),this._responseParsingException&&(h.fetch_response_parsing_error=this._responseParsingException.message),this._errorMessage&&(h.fetch_error_message=this._errorMessage),h},d}(MHt.TelemetryEventBase);e.EcsConfigFetchResponse=o}),PHt=bs(function(t,e){var i,r=fo&&fo.__extends||(i=function(C,E){return i=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(I,w){I.__proto__=w}||function(I,w){for(var D in w)w.hasOwnProperty(D)&&(I[D]=w[D])},i(C,E)},function(C,E){function I(){this.constructor=C}i(C,E),C.prototype=E===null?Object.create(E):(I.prototype=E.prototype,new I)}),o=fo&&fo.__assign||function(){return o=Object.assign||function(C){for(var E,I=1,w=arguments.length;I<w;I++)for(var D in E=arguments[I])Object.prototype.hasOwnProperty.call(E,D)&&(C[D]=E[D]);return C},o.apply(this,arguments)};Object.defineProperty(e,"__esModule",{value:!0});var l,d,h=1728e5,p=18e5,g=31536e6,f=3e4,y=function(C){function E(I,w,D,F,x,B,L,z){var H=C.call(this,I)||this;H._config=w,H._skypeTokenData=D,H._appActiveData=F,H._allowBackgroundFetchData=x,H._etag=B,H._getUserConfig=L;var j=H._config.getConfig();if(H._apiPath=j.clientTeam?"/config/v1/"+j.clientName+"/"+j.clientVersion+"/"+j.clientTeam:"/config/v1/"+j.clientName+"/"+j.clientVersion,z){var J=Object.keys(z).map(function(Z){return encodeURIComponent(Z)+"="+encodeURIComponent(z[Z].toString())});J&&(H._apiPath+="?"+J.join("&"))}return H}return r(E,C),E.prototype._blockRequestUntil=function(I){var w=this;if(this._getUserConfig&&!this._skypeTokenData.isSkypeTokenValid()&&console.log("ECS - Delaying User config fetch until we have a valid SkypeToken"),!this._appActiveData.isAppActive()&&!this._allowBackgroundFetchData.isBackgroundFetchAllowed()){var D=this._getUserConfig?"User config":"config";console.log("ECS - Delaying "+D+" fetch until the app is active (or background fetch is allowed)")}return oh.race([this._appActiveData.waitForAppActive(),this._allowBackgroundFetchData.waitForBackgroundFetchAllowed()]).then(function(){if(w._getUserConfig)return w._skypeTokenData.waitForValidSkypeToken()}).then(function(){d=Date.now()})},E.prototype._getHeaders=function(){var I={};return this._etag&&(I["If-None-Match"]=this._etag),this._getUserConfig&&(I.Authorization=this._skypeTokenData.getSkypeToken()),I},E.prototype.getConfig=function(){var I=this._config.getConfig().fetchTimeout;return I!==void 0&&(I<0?I=0:I>0&&I<f&&(I=f)),C.prototype.performApiGetDetailed.call(this,this._apiPath,{timeout:I})},E}(O3e.GenericRestClient),T=function(){function C(E,I,w,D,F){this._config=E,this._skypeTokenData=I,this._appActiveData=w,this._allowBackgroundFetchData=D,this._telemetryManager=F,this._ecsFailureBackoffTimer=new O3e.ExponentialTime(1e3,3e5),this._cacheMaxAgeRegex=/.*max-age=(\d+).*/gi,this._serverIndex=NaN}return C.prototype.getConfig=function(E,I,w){var D=this,F=this._config.getConfig().hosts;if((isNaN(this._serverIndex)||this._serverIndex>F.length-1)&&(this._serverIndex=Math.floor(Math.random()*F.length)),!F||!F.length)return oh.Rejected(new Error("no configuration service endpoint"));var x=oh.Defer(),B=0,L=function(){var z=E&&E.eTag?E.eTag:void 0,H=new y(F[D._serverIndex],D._config,D._skypeTokenData,D._appActiveData,D._allowBackgroundFetchData,z,I,w);B++,H.getConfig().then(function(j){var J=j.headers.etag,Z=j.headers.expires;j.body&&j.body.Headers&&(J||(J=j.body.Headers.ETag),Z||(Z=j.body.Headers.Expires));var re=D._calculateResponseTimeInfo(E);if(!J||!Z)return console.warn("ECS - Service returned an empty ETag or Expiration header: "+JSON.stringify(j)),oh.Rejected({timedOut:!1,responseParsingException:new Error("ECS Service returned empty ETag or Expiration header"),responseCode:j.statusCode});var ne,le=new Date(D._calculateExpirationDate(j.headers)).getTime();if(j.statusCode===304&&E)(ne=o({},E)).configType=I?Ik.EcsConfigType.User:Ik.EcsConfigType.Default,ne.eTag=J,ne.expiration=le,ne.cacheUpdateTime=re.lastResponseTime,ne.lastFetchTokenHash=D._skypeTokenData.getSkypeTokenHash(j.requestHeaders.Authorization);else{if(typeof j.body!="object")return console.warn("ECS - Service returned invalid response "+JSON.stringify(j)),oh.Rejected({timedOut:!1,responseParsingException:new Error("ECS Service returned invalid response body"),responseCode:j.statusCode});ne={config:j.body,configType:I?Ik.EcsConfigType.User:Ik.EcsConfigType.Default,eTag:J,expiration:le,cacheUpdateTime:d,lastFetchTokenHash:D._skypeTokenData.getSkypeTokenHash(j.requestHeaders.Authorization),appVersion:D._config.getConfig().clientVersion}}D._telemetryManager.sendTelemetryEvent(new N3e.EcsConfigFetchResponse(re.fetchDelayMs,j.statusCode,B,D._skypeTokenData.isSkypeTokenValid(),F[D._serverIndex],re.fetchDurationValid,!!z,JSON.stringify(j).length,re.cacheAge,!(E&&E.expiration-Date.now()>0),d,re.lastResponseTime,I,J)),D._ecsFailureBackoffTimer.reset(),x.resolve(ne)}).catch(function(j){var J={timedOut:j&&j.timedOut||!1,responseParseError:j&&j.responseParsingException,responseCode:j&&j.statusCode||0,message:D._getErrorMessage(j)};console.error("ECS - Service request failed to return a response (timedOut: "+J.timedOut+", responseParseError: "+J.responseParseError+")");var Z=D._calculateResponseTimeInfo(E);D._telemetryManager.sendTelemetryEvent(new N3e.EcsConfigFetchResponse(Z.fetchDelayMs,J.responseCode,B,D._skypeTokenData.isSkypeTokenValid(),F[D._serverIndex],Z.fetchDurationValid,!!z,0,Z.cacheAge,!(E&&E.expiration-Date.now()>0),d,Z.lastResponseTime,I,void 0,J.timedOut,J.responseParseError,J.message));var re=D._config.getConfig().fetchAttemptMax;re&&B>re||setTimeout(function(){L()},D._ecsFailureBackoffTimer.getTimeAndCalculateNext())})};return L(),x.promise()},C.prototype._calculateExpirationDate=function(E){var I=Date.now()+h;if(E.date&&E.expires){var w=new Date(E.date).getTime(),D=Date.now()-w,F=new Date(E.expires).getTime();return isNaN(F)?I:Math.min(I,F+D)}var x=this._cacheMaxAgeRegex.exec(E["cache-control"]);return this._cacheMaxAgeRegex.lastIndex=0,x&&x.length===2?Math.min(I,Date.now()+1e3*Number(x[1])):Date.now()+p},C.prototype._calculateResponseTimeInfo=function(E){var I=(l=Date.now())-d;return{lastResponseTime:l,fetchDelayMs:I,fetchDurationValid:!(I<0||I>g),cacheAge:E?l-E.cacheUpdateTime:0}},C.prototype._getErrorMessage=function(E){if(E)return typeof E=="string"?E:typeof E=="object"&&(E.statusText||E.message)?E.statusText||E.message:void 0},C}();e.default=T}),DHt=bs(function(t,e){Object.defineProperty(e,"__esModule",{value:!0});var i=function(){function r(o,l,d,h,p,g){var f=this;this._config=o,this._skypeTokenData=l,this._cache=d,this._isFetchingSettings={},this._pendingFetch={},this._pendingTimers={},this._subscriptionToken=null,this._paused=!1,this._fetchEcsSettingsIfNeeded=function(y){var T,C=f._config.getConfig(),E=f._cache.getEcsConfigByType(y);if(C.configsToFetch.indexOf(y)!==-1&&!f._isFetchingSettings[y])if(E||!f._pendingFetch[y]){var I=E?E.expiration-Date.now():-1;I<=0||E&&y===Ik.EcsConfigType.User&&f._skypeTokenData.isSkypeTokenValid()&&E.lastFetchTokenHash!==f._skypeTokenData.getSkypeTokenHash(f._skypeTokenData.getSkypeToken())?f._fetchSkypeEcsSettings(y):!((T=C.Killswitches)===null||T===void 0)&&T.isSkypeTokenDataLeakFixEnabled?(f._pendingTimers[y]>0&&clearTimeout(f._pendingTimers[y]),f._pendingTimers[y]=window.setTimeout(function(){return f._fetchEcsSettingsIfNeeded(y)},I)):window.setTimeout(function(){return f._fetchEcsSettingsIfNeeded(y)},I)}else f._fetchSkypeEcsSettings(y)},this._fetchSkypeEcsSettings=function(y,T){T===void 0&&(T=!1),f._isFetchingSettings[y]||f._paused&&!T?f._pendingFetch[y]=!0:(f._pendingFetch[y]=!1,f._isFetchingSettings[y]=!0,f._config.getConfig().getEcsParameters().catch(function(){return console.warn("ECS - Failed to fetch ECS fetching parameters"),{}}).then(function(C){return f._ecsClient.getConfig(f._cache.getEcsConfig(),y===Ik.EcsConfigType.User,C)}).then(function(C){console.log("ECS - Config fetch complete"),f._isFetchingSettings[y]=!1,f._cache.putConfig(C),f._fetchEcsSettingsIfNeeded(y)}))},this._ecsClient=new PHt.default(this._config,this._skypeTokenData,h,p,g)}return r.prototype.initialize=function(){var o=this;this.updateConfigsToFetch(),this._subscriptionToken=this._skypeTokenData.skypeTokenChanged.subscribe(function(){return o._fetchEcsSettingsIfNeeded(Ik.EcsConfigType.User)})},r.prototype.dispose=function(){var o,l,d=this._config.getConfig();if(!((o=d.Killswitches)===null||o===void 0)&&o.isSkypeTokenDataLeakFixEnabled){for(var h=0,p=d.configsToFetch;h<p.length;h++){var g=p[h];clearTimeout(this._pendingTimers[g]),this._pendingTimers[g]=0}(l=this._subscriptionToken)===null||l===void 0||l.unsubscribe(),this._subscriptionToken=null,this._skypeTokenData.skypeTokenChanged.dispose()}},r.prototype.updateConfigsToFetch=function(){for(var o=this._config.getConfig(),l=0,d=o.configsToFetch;l<d.length;l++)(g=d[l])in this._isFetchingSettings||(this._isFetchingSettings[g]=!1),g in this._isFetchingSettings||(this._pendingFetch[g]=!1);for(var h=0,p=o.configsToFetch;h<p.length;h++){var g=p[h],f=this._cache.getEcsConfigByType(g);!f||f.appVersion&&f.appVersion!==o.clientVersion?this._fetchSkypeEcsSettings(g,!0):this._fetchEcsSettingsIfNeeded(g)}},r.prototype.requestUpdate=function(){for(var o=0,l=this._config.getConfig().configsToFetch;o<l.length;o++){var d=l[o];this._fetchSkypeEcsSettings(d)}},r.prototype.pause=function(){this._paused=!0},r.prototype.resume=function(){this._paused=!1;for(var o=0,l=this._config.getConfig().configsToFetch;o<l.length;o++){var d=l[o];this._fetchEcsSettingsIfNeeded(d)}},r}();e.default=i}),LHt=bs(function(t,e){Object.defineProperty(e,"__esModule",{value:!0});var i=function(){function r(){this.skypeTokenChanged=new pge.default}return r.prototype.putSkypeTokenData=function(o){if(this._data=o,this.isSkypeTokenValid()&&this.skypeTokenChanged.fire(),this.isSkypeTokenValid()&&this._validSkypeTokenDeferral){var l=this._validSkypeTokenDeferral;this._validSkypeTokenDeferral=void 0,l.resolve(void 0)}},r.prototype.isSkypeTokenValid=function(){var o=this._data;return!!o&&!!o.skypeToken&&o.skypeTokenExpiration>Date.now()},r.prototype.getSkypeToken=function(){var o=this._data;if(!o||!o.skypeToken)throw new Error("No Skype Token provided");return o.skypeToken},r.prototype.getSkypeTokenHash=function(o){return o===void 0?0:o.split("").reduce(function(l,d){return(101*l+d.charCodeAt(0))%999727999},o.length)},r.prototype.waitForValidSkypeToken=function(){return this.isSkypeTokenValid()?oh.Resolved():(this._validSkypeTokenDeferral||(this._validSkypeTokenDeferral=oh.Defer()),this._validSkypeTokenDeferral.promise())},r}();e.default=i}),OHt=bs(function(t,e){Object.defineProperty(e,"__esModule",{value:!0});var i=function(){function r(o){this._cache=o,this.telemetryEventAdded=new pge.default}return r.prototype.sendTelemetryEvent=function(o){var l=o.getEventName(),d=o.getAttributes(),h=!1,p=this._cache.getEcsConfig();if(p){if(r._containsEcsClientTelemetryConfig(p.config)){var g=p.config.ECSCONFIG;g&&g.ecsClientTelemetry&&(h=!!g.ecsClientTelemetry[l])}}else console.warn("No previously cached ECS telemetry config exists - fallback to sending event"),h=!0;h&&this.telemetryEventAdded.fire(l,d)},r._containsEcsClientTelemetryConfig=function(o){return!!o&&!!o.ECSCONFIG&&!!o.ECSCONFIG.ecsClientTelemetry},r}();e.default=i}),mZ=bs(function(t,e){Object.defineProperty(e,"__esModule",{value:!0}),e.Models=Ik;var i=function(){function r(){this._allowBackgroundFetchData=new _Ht.default,this._appActiveData=new EHt.default,this._config=new kHt.default,this._cache=new wHt.default(this._config),this._skypeTokenData=new LHt.default,this._telemetryManager=new OHt.default(this._cache),this._scheduler=new DHt.default(this._config,this._skypeTokenData,this._cache,this._appActiveData,this._allowBackgroundFetchData,this._telemetryManager),this.telemetryEventAdded=this._telemetryManager.telemetryEventAdded,this.configUpdated=this._cache.configUpdated}return r.prototype.initialize=function(o){var l=this;return this._config.initialize(o),this._skypeTokenData.putSkypeTokenData(o.initialSkypeTokenData),this._appActiveData.putAppActive(o.initialAppActiveState),this._cache.initialize().then(function(){l._scheduler.initialize()})},r.prototype.dispose=function(){var o;!((o=this._config.getConfig().Killswitches)===null||o===void 0)&&o.isSkypeTokenDataLeakFixEnabled&&this._scheduler.dispose()},r.prototype.getConfig=function(){return this._cache.getEcsConfig()},r.prototype.getConfigType=function(){var o=this._cache.getEcsConfig();if(o)return o.configType},r.prototype.requestUpdate=function(){this._scheduler.requestUpdate()},r.prototype.pause=function(){this._scheduler.pause()},r.prototype.resume=function(){this._scheduler.resume()},r.prototype.setAllowBackgroundFetch=function(o){this._allowBackgroundFetchData.putBackgroundFetchAllowed(o)},r.prototype.useSkypeToken=function(o,l){this._skypeTokenData.putSkypeTokenData({skypeToken:o,skypeTokenExpiration:l})},r.prototype.setAppActive=function(o){this._appActiveData.putAppActive(o)},r.prototype.setConfigsToFetch=function(o){var l=this;return this._config.setConfigsToFetch(o),this._cache.updateConfigsToFetch().then(function(){l._scheduler.updateConfigsToFetch()})},r.prototype.setFetchTimeout=function(o){this._config.setFetchTimeout(o)},r}();e.default=i}),NHt=_kt(mZ);function x3e(t,e){const i={[pl.Public]:As.Public_EcsServer_Url,[pl.Dod]:As.Dod_EcsServer_Url,[pl.GccHigh]:As.GccHigh_EcsServer_Url,[pl.AirGap08]:As.AirGap08_EcsServer_Url,[pl.AirGap09]:As.AirGap09_EcsServer_Url};let r=As.Public_EcsServer_Url;return e&&(r=e.identityType===gT.Enterprise?As.Enterprise_Ecs_ServerUrl:i[e.cloudType]??As.Public_EcsServer_Url),t?.proxyfyUrl(r)??r}(function(t){t.Default="Default",t.User="User"})(HE||(HE={}));class xHt{constructor(e,i,r){this._acsProxy=i,this._sourceTag=r,this._throttlingTimeoutHandle=0,this._eventEmitter=new $c.EventEmitter,this._logger=e.createChild("EcsClient")}_resetThrottlingTimeout(){this._throttlingTimeoutHandle&&(window.clearTimeout(this._throttlingTimeoutHandle),this._throttlingTimeoutHandle=0)}_resetEcsClient(){this._ecsClient&&(this._ecsClient.configUpdated.dispose(),this._ecsClient=void 0)}async _fetchConfig(e){this._resetEcsClient(),this._resetThrottlingTimeout();const i=new NHt,r=ug();try{await i.initialize(e);let o=[],l=!1,d=0;i.configUpdated.subscribe(()=>{if(r.isPending())r.resolve();else{o.push(Date.now());const p=i.getConfig();if(p?.config){const y=p?.configType===mZ.Models.EcsConfigType.User?HE.User:HE.Default;this._cachedConfig=p,this._eventEmitter.emit("configUpdated",{config:p?.config,fetchType:y,sourceTag:this._sourceTag})}const g=wt().ecsClient.throttling;o.length>g.triggerCount&&(o=o.slice(o.length-g.triggerCount));const f=o[o.length-1]-o[0];l?(o.length<g.triggerCount||f>=g.coolDownDuration)&&(l=!1,d=0,o=[],this._resetThrottlingTimeout()):o.length===g.triggerCount&&f<g.triggerDuration&&(l=!0),l&&(d=d===0?g.startingDelay:Math.min(Math.ceil(d*g.delayFactor),g.maxDelay),i.pause(),this._throttlingTimeoutHandle=window.setTimeout(()=>{this._throttlingTimeoutHandle=0,i.resume()},d))}}),this._ecsClient=i,await cP(()=>r.promise,QNt);const h=i.getConfig();if(!h?.config)throw new Oe({defaultError:we.INTERNAL.ECS_CONFIG_EMPTY});return this._cachedConfig=h,h.config}catch(o){throw r.reject(o),this._logger.error(`${o}`),o}}async fetchDefaultConfig(e,i){const r=`${T3()}_${E3()}`,o={hosts:[x3e(this._acsProxy,i)],clientName:Rxe,clientVersion:r,configsToFetch:[mZ.Models.EcsConfigType.Default],getEcsParameters:()=>oh.Resolved(e),initialAppActiveState:!0};return this._fetchConfig(o)}async fetchUserConfig(e,i,r){const o=`${T3()}_${E3()}`,l=await r(),d=1e3*dBe(l).exp,h={hosts:[x3e(this._acsProxy,i)],clientName:Rxe,clientVersion:o,configsToFetch:[mZ.Models.EcsConfigType.User],getEcsParameters:()=>oh.Resolved(e),initialAppActiveState:!0,initialSkypeTokenData:{skypeToken:l,skypeTokenExpiration:d}};return this._fetchConfig(h)}get eTag(){return this._cachedConfig?.eTag??""}get sourceTag(){return this._sourceTag}on(e,i){this._eventEmitter.on(e,i)}off(e,i){this._eventEmitter.off(e,i)}dispose(){this._eventEmitter.removeAllListeners(),this._resetThrottlingTimeout(),this._resetEcsClient()}getConfigIds(e){return this._cachedConfig?.config?.ConfigIDs?.[e]}}class BHt{constructor(e){this._telemetryLogManager=e,this._seq=0}sendAttemptEvent(e,i,r){this._seq++,this._telemetryLogManager.sendEvent({name:vi.acs_calling_config_fetched_attempt,tenant:Wr,properties:{attemptTimestamp:e,ecsFetchType:i,correlationId:r,eventSeq:this._seq}})}sendSuccessEvent(e,i,r,o){const l=Date.now();this._seq++;const d=e!==void 0?l-e:0;this._telemetryLogManager.sendEvent({name:vi.acs_calling_config_fetched_success,tenant:Wr,properties:{...e!==void 0?{attemptTimestamp:e}:void 0,successTimestamp:l,deltaTimeInMs:d,ecsFetchType:i,correlationId:r,eventSeq:this._seq,ecsConfigIds_AcsCallingSDKWeb:o?.AcsCallingSDKWeb||"",ecsConfigIds_SkypeWebMedia:o?.SkypeWebMedia||""}})}sendFailureEvent(e,i,r,o){const l=Date.now();this._seq++;const d=e!==void 0?l-e:0,h=o.message,p=an(o);this._telemetryLogManager.sendEvent({name:vi.acs_calling_config_fetched_failure,tenant:Wr,properties:{...e!==void 0?{attemptTimestamp:e}:void 0,failureTimestamp:l,deltaTimeInMs:d,ecsFetchType:i,correlationId:r,eventSeq:this._seq,failureReason:h,additionalDetails:{...p}}})}}function B3e(t,...e){dn.merge(t,...e)}var l8=function(t,e,i,r){var o,l=arguments.length,d=l<3?e:r===null?r=Object.getOwnPropertyDescriptor(e,i):r;if(typeof Reflect=="object"&&typeof Reflect.decorate=="function")d=Reflect.decorate(t,e,i,r);else for(var h=t.length-1;h>=0;h--)(o=t[h])&&(d=(l<3?o(d):l>3?o(e,i,d):o(e,i))||d);return l>3&&d&&Object.defineProperty(e,i,d),d},YC=function(t,e){if(typeof Reflect=="object"&&typeof Reflect.metadata=="function")return Reflect.metadata(t,e)};class h4{constructor(e,i,r,o,l,d,h){if(this._disposed=!1,this._trouterStateChangedListenersRegistered=new Map,this.clientId=i,this.sdkDiagnosticInformation=o,this.logger=e.createChild("CallStack"),this._telemetryLogManager=r,this._acsProxy=l,this._acsCustomRelayManager=d,this._webcvProvider=new sHt,this._wasmvqeProvider=new uHt,location.protocol!=="https:"&&location.protocol!=="file:"&&location.hostname!=="localhost")throw new Oe({defaultError:we.CALL_STACK.BAD_PROTOCOL});this._telemetryService=new oHt(this._telemetryLogManager),this._ecsTelemetryLogger=new BHt(r),this._ecsProvider=new k3e(this.logger,this.sdkDiagnosticInformation,this._acsProxy),this._ecsClient=new xHt(this.logger,this._acsProxy,"EcsClient"),this._ecsClient.on("configUpdated",async p=>{try{await this.updateConfig(p.config,this.caConfigBag),this._ecsTelemetryLogger.sendSuccessEvent(void 0,p.fetchType,"",this.getEcsConfigIds());try{this._ecsProvider.assertConfigs(p.config)}catch(g){this._ecsTelemetryLogger.sendFailureEvent(void 0,p.fetchType,"",g)}}catch(g){const f=new Oe({defaultError:we.CALL_STACK.PARSE_CONFIG,originalError:g});this._ecsTelemetryLogger.sendFailureEvent(void 0,p.fetchType,"",f)}}),this._videoEffectsStatusManager=new cHt,this._audioEffectsStatusManager=new dHt,h!==void 0&&(this._encodedStreamsWorkerProvider=new lHt(h))}getClientId(){return this.clientId}getTrouterState(){const e=this._trouterService?.state()??this._shellTrouter?.state();return this.mapTsTrouterState(e)}getEcsConfigIds(){return{AcsCallingSDKWeb:this._ecsClient?.getConfigIds("AcsCallingSDKWeb")??"",SkypeWebMedia:this._ecsClient?.getConfigIds("SkypeWebMedia")??""}}isRegistered(){return this._trouterService?.isRegistered()??!1}onRegisteredChanged(e){this._trouterService?.onRegisteredChanged(e)}offRegisteredChanged(e){this._trouterService?.offRegisteredChanged(e)}onTrouterStateChanged(e){const i=(r,o)=>{e(this.mapTsTrouterState(r))};return this._trouterService?.onStateChanged(i),this._shellTrouter?.on("stateChanged",i),this._trouterStateChangedListenersRegistered.set(e,i),{listener:e,tsTrouterStateChangedListener:i}}offTrouterStateChanged(e){const i=this._trouterStateChangedListenersRegistered.get(e);if(i)return this._trouterService?.offStateChanged(i),this._shellTrouter?.off("stateChanged",i),this._trouterStateChangedListenersRegistered.delete(e),{listener:e,tsTrouterStateChangedListener:i}}mapTsTrouterState(e){let i="Uninitialized";if(e!==void 0)switch(e){case 0:i="Unknown";break;case 2:i="Connected";break;case 3:i="Disconnected";break;case 9:i="Switching"}return i}get webcvProvider(){return this._webcvProvider}get wasmvqeProvider(){return this._wasmvqeProvider}get videoEffectsStatusManager(){return this._videoEffectsStatusManager}get audioEffectsStatusManager(){return this._audioEffectsStatusManager}async createStackBase(e){if(this._createStackBaseWaitPromise)return this._createStackBaseWaitPromise;const i=new Promise(async(r,o)=>{try{const l=this._getBaseStackConfig();if(hHt()){this._shellTrouter=new CHt;const d=pHt(this.logger);d.vdi3Config&&(d.vdi3Config.shellTrouter=this._shellTrouter.instance),this._proxyReferenceManager=u4.create(this.logger);const h=await vP.stackFactory.buildBaseStack({stackType:1,...l,...d});this._tsStack=this._proxyReferenceManager.create(h)}else this._tsStack=await vP.stackFactory.buildBaseStack({stackType:0,...l});await this.initializeEcsBase(e),r(this._tsStack)}catch(l){o(l)}});try{this._createStackBaseWaitPromise=cP(()=>i,TNt);const r=await this._createStackBaseWaitPromise;return this.logger.log("Base stack init success"),r}catch(r){throw await this.dispose(),r.code===BDe?new Oe({defaultError:we.CALL_STACK.BASE_STACK_INIT_TIMEOUT}):new Oe({defaultError:we.CALL_STACK.BASE_STACK_INIT_FAILED,originalError:r})}}async initializeStackForUser(e,i){if(this.caConfigBag=i,this._initializeStackForUserWaitPromise)return this._initializeStackForUserWaitPromise;this._tsStack=await this.createStackBase(i),this._disposed=!1;const r=new Promise(async(h,p)=>{try{this._tsStack?(this._ecsProvider=new k3e(this.logger,this.sdkDiagnosticInformation,this._acsProxy),await this.initializeEcsBase(i),await this.initializeEcsForUser(i,e),rh.overrideDefaultLogDump(),$v(this._tsStack)||(wt().calling.doNotWaitForTrouter?this._initTrouter(e).catch(()=>{this.logger.warn(we.CALL_STACK.SIGNALING_UNINITIALIZED.message)}):await this._initTrouter(e)),this.logger.log("Signaling initialized successfully."),await o(e,this._tsStack),await l(e,this._tsStack),await d(this._tsStack),h(this._tsStack)):(this.logger.error("Base stack failed to create"),p(new Oe({defaultError:we.CALL_STACK.USER_STACK_NO_BASE_STACK})))}catch(g){p(g)}}),o=async(h,p)=>{try{if(await p.initializeMediaAgent({httpRequestDispatcher:this.getRequestDispatcher(),tokenProvider:h,relayManager:this.getCustomRelayManager(),configProvider:{getSkypeConfig:()=>Promise.resolve({}),getRelayConfig:()=>{const g=this._ecsProvider.getMdnTrapSettings();return Promise.resolve(g)}},appStateProvider:this._getAppStateProvider(),clientInformation:this._ecsProvider.getJsCsaConfig().clientInformation}),wt().calling.platformSupportValidation&&await p.getPlatformSupportLevelAsync()===0){const g=new Oe({defaultError:we.CALL_STACK.USER_STACK_MEDIA_INIT_FAILED_PLATFORM_NOT_SUPPORTED});throw this.logger.error(g.message),g}}catch(g){throw this.logger.error("Failed to  initialize media stack",g),new Oe({defaultError:we.CALL_STACK.USER_STACK_MEDIA_INIT_FAILED,originalError:g})}},l=async(h,p)=>{try{const g=$v(p),f={signalingAgentConfig:this._getSignalingConfig(h),...g?{trouterSettings:R3e(this._ecsProvider),trouterService:{}}:{trouterService:this._trouterService}};await p.initializeSignalingAgentProvider(f),g&&await this._shellTrouter?.initialize()}catch(g){throw this.logger.error("Failed to  initialize signaling agent",g),new Oe({defaultError:we.CALL_STACK.USER_STACK_SIGNALING_INIT_FAILED,originalError:g})}},d=async h=>{try{await h.init()}catch(p){throw this.logger.error("Failed to initialize calling stack",p),new Oe({defaultError:we.CALL_STACK.USER_STACK_INTERNAL_INIT_FAILED,originalError:p})}};try{this._initializeStackForUserWaitPromise=cP(()=>r,CNt);const h=await this._initializeStackForUserWaitPromise;return this.sendStackInitEvent(!0),this.logger.log("User stack init success"),h}catch(h){throw await this.dispose(),h.code===BDe?(this.sendStackInitEvent(!1,"User stack init timeout",h),new Oe({defaultError:we.CALL_STACK.USER_STACK_INIT_TIMEOUT})):!(h instanceof Oe)&&this.getTrouterState()==="Uninitialized"?new Oe({defaultError:we.CALL_STACK.SIGNALING_UNINITIALIZED,originalError:h}):(this.sendStackInitEvent(!1,"User stack init failed",h),new Oe({defaultError:we.CALL_STACK.USER_STACK_INIT_FAILED,originalError:h}))}}getRequestDispatcher(){return this._acsProxy.hasProxyUrl()?(this.logger.info("Using custom proxy for network requests (non media)"),new M3e(this.logger,this._acsProxy)):wt().telemetry.sendNetworkInfo?new M3e(this.logger):new vP.HttpRequestDispatcherImplementation(this.logger)}async updateTsConfig(e,i){this._ecsProvider.setConfig(i,e),Dxt(this._ecsProvider.getJamaSettings()),this._tsStack&&await(await this._tsStack.getEcsProviderAsync?.())?.setEcsConfig({ecsBlob:JSON.stringify(e),userIdentity:"",etag:this._ecsClient.eTag})}async updateConfig(e,i){e.Headers?.CountryCode&&this.updateEmergencyCallCountry(e?.Headers?.CountryCode);try{if($v(this._tsStack)){B3e(e,gHt);const r=e?.AcsCallingSDKWeb?.vdi3?.customEcsConfig;if(r)try{B3e(e,JSON.parse(r))}catch(o){this.logger.error(`Failed to parse customEcsConfig: ${o}`)}}Pxt(e),await this.updateTsConfig(e,i)}catch(r){throw this.logger.warn(`Unable to update ECS configuration ${r}`),new Oe({defaultError:we.CALL_STACK.PARSE_CONFIG,originalError:r})}}async initializeEcsBase(e){const i=Date.now(),r=ln();this._ecsTelemetryLogger.sendAttemptEvent(i,HE.Default,r);let o=we.CALL_STACK.FETCH_CONFIG;try{const l=await this._ecsClient.fetchDefaultConfig(this.getEcsQueryParameters(e),e);o=we.CALL_STACK.PARSE_CONFIG,await this.updateConfig(l,e),this._ecsTelemetryLogger.sendSuccessEvent(i,HE.Default,r,this.getEcsConfigIds());try{this._ecsProvider.assertConfigs(l)}catch(d){this._ecsTelemetryLogger.sendFailureEvent(i,HE.Default,r,d)}}catch(l){this.logger.warn("Failed to fetch base settings. Stack will initialize with default settings",l),this._ecsProvider.setConfig(e,void 0);const d=new Oe({defaultError:o,originalError:l});this._ecsTelemetryLogger.sendFailureEvent(i,HE.Default,r,d)}}async initializeEcsForUser(e,i){const r=Date.now(),o=ln();this._ecsTelemetryLogger.sendAttemptEvent(r,HE.User,o);let l=we.CALL_STACK.FETCH_CONFIG;try{const d=await this._ecsClient.fetchUserConfig(this.getEcsQueryParameters(e),e,i);l=we.CALL_STACK.PARSE_CONFIG,await this.updateConfig(d,e),this._ecsTelemetryLogger.sendSuccessEvent(r,HE.User,o,this.getEcsConfigIds());try{this._ecsProvider.assertConfigs(d)}catch(h){this._ecsTelemetryLogger.sendFailureEvent(r,HE.User,o,h)}}catch(d){this.logger.warn("Failed to fetch user settings.",d);const h=new Oe({defaultError:l,originalError:d});this._ecsTelemetryLogger.sendFailureEvent(r,HE.User,o,h)}}async getDeviceManager(){if(!this._createStackBaseWaitPromise)throw new Oe({defaultError:we.CALL_STACK.GET_DM});return(await this._createStackBaseWaitPromise).getDeviceManagerAsync()}async dispose(e){if(!this._disposed){if(this._disposed=!0,this._trouterService)try{this._trouterService.clearMessageHandlers(),this._trouterService.stop(e),this._trouterService=void 0}catch{this.logger.error("Failed to dispose signaling")}if(this._shellTrouter)try{await this._shellTrouter.dispose(),this._shellTrouter=void 0}catch{this.logger.error("Failed to dispose shellTrouter")}if(this._tsStack)try{await this._tsStack.dispose(),this._tsStack=void 0}catch{this.logger.error("Failed to dispose calling stack")}this._proxyReferenceManager?.dispose(),this._ecsClient.dispose(),this._createStackBaseWaitPromise=void 0,this._initializeStackForUserWaitPromise=void 0,this._tsStack=void 0,this.logger.info("Calling stack disposed")}}getEcsQueryParameters(e){const i={};try{i.CLRelease=vP.stackFactory.getVersion().build;const r=$A();i.BrowserName=r.name,i.BrowserEngine=r.engine,i.BrowserVersion=r.version,i.FormFactor=r.formFactor,i.IdentityType=gT.Consumer,i.Cloud=pl.Public,i.OSVer=`${mP()}-${z5e()}`,e&&(i.Cloud=e.cloudType,i.IdentityType=e.identityType);const o="_TS_BUILC_VERSION_".replace("C","D");i.CLRelease===o?i.CLRelease="9999.99":i.CLRelease.match(/^\d+\.\d+\.\d+\.\d+$/)||delete i.CLRelease}catch(r){throw this.logger.error(r),new Oe({defaultError:we.CALL_STACK.SET_STACK_PARAMS,originalError:r})}return i}updateEmergencyCallCountry(e){this.caConfigBag&&!this.caConfigBag.emergencyCountryCode&&!this.caConfigBag.IsUserEmergencyCountryCode&&e&&(this.caConfigBag.emergencyCountryCode=e)}async _initTrouter(e){let i=+new Date;try{this._trouterService=new rHt(this.logger,this._ecsProvider,l=>e(l),this._telemetryLogManager,this._acsProxy),i=+new Date;let r=await this._trouterService.start();const o=this._trouterService.getTrouterSettings();return void this.sendSignalingInitEvent(!0,+new Date-i,o.registrationId??"",o.sessionId,r.trouterRequestCompletionTimeDeltaMs,r.registrarRequestCompletionTimeDeltaMs)}catch(r){throw this.sendSignalingInitEvent(!1,+new Date-i,"","",void 0,void 0,r),r}}_getBaseStackConfig(){const e=this._getMediaProviderConfig(),i={clientInformation:this._ecsProvider.getClientInformation(),logger:this.logger,mediaSettings:e.mediaSettings,platformType:U5e(),callSettings:{useLwjForAllCalls:!1},usePlatformSupportApi:!0,telemetryTenants:{media:"mediaAgent",signaling:"signalingAgent",tlePlayer:uxt},telemetryService:this._telemetryService,webcvProvider:this._webcvProvider,wasmVqeProvider:this._wasmvqeProvider};return this._encodedStreamsWorkerProvider!==void 0&&(i.encodedStreamsWorkerProvider=this._encodedStreamsWorkerProvider),i}_getSignalingConfig(e){const i={...this._ecsProvider.getJsCsaConfig(),httpRequestDispatcher:this.getRequestDispatcher(),telemetryManager:this._telemetryService.getCallingAdapter(),logger:this.logger,skypeToken:()=>e(),trouterServiceProvider:this._trouterService,ecsEtag:this._ecsClient.eTag};return this.caConfigBag?.emergencyCountryCode&&(i.emergencyCallCountry=this.caConfigBag?.emergencyCountryCode),i}_getMediaProviderConfig(){return{logger:this.logger,mediaSettings:this._getMediaAgentConfig()}}_getMediaAgentConfig(){return{...this._ecsProvider.getJamaSettings(),useOneDsLogger:!0,collectorUrl:ck.Public,telemetryTenants:{signaling:MA,gtcAudit:MA,media:gO,realtimeMedia:JNt,tlePlayer:xxe}}}_getAppStateProvider(){return{isOnline:()=>!0}}sendStackInitEvent(e,i,r){try{let o,l;r&&(o=r.message,l=an(r)),this._telemetryLogManager.sendEvent({name:vi.acs_calling_stack_init,tenant:Wr,properties:{success:e,reason:i,failureReason:o||"unknown",additionalDetails:{...l}}})}catch{}}sendSignalingInitEvent(e,i,r,o,l,d,h){try{let p,g;h&&(p=h.message,g=an(h)),this._telemetryLogManager.sendEvent({name:vi.acs_calling_signaling_init,tenant:Wr,properties:{success:e,failureReason:p||"unknown",timestampInfo:{deltaTimeInMs:i,deltaTimeInMsTrouterRequest:l,deltaTimeInMsRegistrarRequest:d},additionalDetails:{...g,registrationId:r,sessionId:o}}})}catch{}}getCustomRelayManager(){if(this._tsCustomRelayManager=this._acsCustomRelayManager.getTsRelayManager(),this._tsCustomRelayManager&&wt().calling.enableCustomTurnUsage)return this.logger.info("Using custom relays for media traffic"),this._acsCustomRelayManager.customRelayManagerInUse=!0,this._tsCustomRelayManager}}l8([zv,YC("design:type",Object)],h4.prototype,"logger",void 0),l8([to(A3.CreateStackBase),YC("design:type",Function),YC("design:paramtypes",[Object]),YC("design:returntype",Promise)],h4.prototype,"createStackBase",null),l8([to(A3.InitializeStackForUser),YC("design:type",Function),YC("design:paramtypes",[Function,Object]),YC("design:returntype",Promise)],h4.prototype,"initializeStackForUser",null),l8([to(A3.GetDeviceManager),YC("design:type",Function),YC("design:paramtypes",[]),YC("design:returntype",Promise)],h4.prototype,"getDeviceManager",null),l8([to(A3.Dispose),YC("design:type",Function),YC("design:paramtypes",[Boolean]),YC("design:returntype",Promise)],h4.prototype,"dispose",null);class FHt{constructor(){this._eventEmitter=new $c.EventEmitter}notifyAll(e){this._eventEmitter.emit(e)}waitFor(e,i){return new Promise((r,o)=>{let l=0;const d=()=>{r(),clearTimeout(l)};this._eventEmitter.once(e,d),l=window.setTimeout(()=>{this._eventEmitter.off(e,d),o(new Error("timeout"))},i)})}}class UHt{constructor(){this._deviceIdMapping=new Map,this._deviceId=1,this._keywords=wt().telemetry.deviceChangedEvents.piiSafeWords}getDeviceId(e){let i=this._deviceIdMapping.get(e);return i!==void 0?i:(++this._deviceId,i=`${e.split(":")[0]??""}:${this._deviceId}`,this._deviceIdMapping.set(e,i),i)}scrubDeviceLabel(e){return zHt(e,this._keywords)}}function zHt(t,e){if(!t)return"";if(t.length<3)return t;const i=[],r=t.match(/\(([0-9a-zA-Z]+:[0-9a-zA-Z]+)\)/);r&&i.push(r[1]);try{if(!e?.length)return"no_keywords";{const o=new RegExp(`(${e.join("|")})`,"gi");let l=o.exec(t);for(;l;)i.push(l[1]),l=o.exec(t)}}catch(o){const l=d=>dn.isString(d)?d:d?.message??"";i.push(`Error: ${l(o)}`)}return i.length===0?"unknown":i.join(" ")}var xO=function(t,e,i,r){var o,l=arguments.length,d=l<3?e:r===null?r=Object.getOwnPropertyDescriptor(e,i):r;if(typeof Reflect=="object"&&typeof Reflect.decorate=="function")d=Reflect.decorate(t,e,i,r);else for(var h=t.length-1;h>=0;h--)(o=t[h])&&(d=(l<3?o(d):l>3?o(e,i,d):o(e,i))||d);return l>3&&d&&Object.defineProperty(e,i,d),d},Mp=function(t,e){if(typeof Reflect=="object"&&typeof Reflect.metadata=="function")return Reflect.metadata(t,e)};class yP{constructor(e,i,r){this._callStack=i,this._videoDevices=[],this._audioDevices=[],this._tsDeviceTypeToAudioDeviceType={2:"Microphone",3:"Speaker",4:"CompositeAudioDevice"},this.logger=e.createChild("DeviceManager"),this._telemetryLogManager=r,this._eventEmitter=new qf(this.logger),this._browserInfo=$A(),this._safariVideoPermissionState="unknown",this._combinedDevicePermission=new Map,this._deviceInfoMapper=new UHt,this._deviceSelectionNotifications=new FHt,this._permissionChangedTasks=Promise.resolve()}get telemetryLogManager(){return this._telemetryLogManager}getRawDeviceMediaStream(e){const i=ln(),r=+new Date;if(this.sendRawMediaEvent({eventName:vi.acs_calling_get_raw_device_media_stream,correlationId:i,kindOfEvent:"attempt",mediaType:e,timestampInfo:"",additionalDetails:""}),!this._tsDeviceManager?.getRawDeviceMediaStream){const l=new Oe({defaultError:we.DEVICE_MANAGER.GET_MEDIA_STREAM_TRACK});this.logger.error("Failed to get raw device stream track");const d=+new Date;throw this.sendRawMediaEvent({eventName:vi.acs_calling_get_raw_device_media_stream,correlationId:i,kindOfEvent:"failure",mediaType:e,timestampInfo:{deltaTimeInMs:d-r},additionalDetails:{failureReason:l.message||"",code:l.code,subCode:l.subCode,...an(l)}}),l}let o;try{o=this._tsDeviceManager?.getRawDeviceMediaStream(e);const l=+new Date;return this.sendRawMediaEvent({eventName:vi.acs_calling_get_raw_device_media_stream,correlationId:i,kindOfEvent:"success",mediaType:e,timestampInfo:{deltaTimeInMs:l-r},additionalDetails:""}),o}catch(l){const d=new Oe({defaultError:we.DEVICE_MANAGER.GET_MEDIA_STREAM_DEVICE_UNAVAILABLE,originalError:l});this.logger.error("Failed to get raw device stream track");const h=+new Date;throw this.sendRawMediaEvent({eventName:vi.acs_calling_get_raw_device_media_stream,correlationId:i,kindOfEvent:"failure",mediaType:e,timestampInfo:{deltaTimeInMs:h-r},additionalDetails:{failureReason:d.message||"",code:d.code,subCode:d.subCode,...an(d)}}),d}}getClientId(){return this._callStack.getClientId()}async getDeviceManager(){if(this._tsDeviceManager)return this._tsDeviceManager;const e=+new Date;try{this.sendGetDeviceManagerEvent({eventName:vi.acs_calling_get_device_manager,kindOfEvent:"attempt",timestampInfo:"",additionalDetails:""}),await this._callStack.createStackBase(),this._tsDeviceManager=await this._callStack.getDeviceManager();const i=await this.enumerateDevicesAsync();this.logger.info(`tsDevicesList:${JSON.stringify(i)}`),i.forEach(l=>{if(l.kind===1){const d=l;this._videoDevices.push(new hP(d.label,d.id,"UsbCamera",this))}else if(l.kind===2||l.kind===3){const d=l,h=new pP(d.label,d.id,d.isSystemDefault,this._tsDeviceTypeToAudioDeviceType[d.kind],this);this._audioDevices.push(h)}});const r=await this._tsDeviceManager.getSelectedDevicesAsync?.();if(r&&(this._selectedMicrophone=this._audioDevices.find(l=>l.id===r.microphone),this._selectedSpeaker=this._audioDevices.find(l=>l.id===r.speaker)),this._dmDevicesChangedSub=this._tsDeviceManager.on("devicesChanged",async()=>{try{await this.syncDeviceList(await this.enumerateDevicesAsync()),await this.checkForSelectedDevicesChanges()}catch(l){this.logger.warn(`Unable to handle devicesChanged, error=${l?.message}, code=${l?.code}`);const d=+new Date;this.sendGetDeviceManagerEvent({eventName:vi.acs_calling_get_device_manager,kindOfEvent:"failure",timestampInfo:{deltaTimeInMs:d-e},additionalDetails:{failureReason:l?.message,code:l?.code,...an(l),context:"devicesChanged"}})}}),wt().calling.devicePermissions.getCurrentState){const l=await this._tsDeviceManager?.getPermissionStateAsync?.("microphone",""),d=await this._tsDeviceManager?.getPermissionStateAsync?.("camera","");this._audioDevicePermission=aQ(l,this.logger),this._videoDevicePermission=aQ(d,this.logger)}this.logger.info("Initial permission state audio:",this._audioDevicePermission,"video:",this._videoDevicePermission),this._dmDevicesPermissionChangedSub=this._tsDeviceManager.on("onPermissionStateChanged",()=>{this._permissionChangedTasks=this._permissionChangedTasks.then(()=>this.permissionsChanged().catch(nh))});const o=+new Date;this.sendGetDeviceManagerEvent({eventName:vi.acs_calling_get_device_manager,kindOfEvent:"success",timestampInfo:{deltaTimeInMs:o-e},additionalDetails:""})}catch(i){const r=new Oe({defaultError:we.DEVICE_MANAGER.GET_DM,originalError:i});this.logger.error(r.message);const o=+new Date;this.sendGetDeviceManagerEvent({eventName:vi.acs_calling_get_device_manager,kindOfEvent:"failure",timestampInfo:{deltaTimeInMs:o-e},additionalDetails:{failureReason:r.message,code:r.code,...an(r)}})}return this._tsDeviceManager}on(e,i){if(e!=="videoDevicesUpdated"&&e!=="audioDevicesUpdated"&&e!=="selectedMicrophoneChanged"&&e!=="selectedSpeakerChanged")throw new Oe({defaultError:we.DEVICE_MANAGER.EVENT_SUBSCRIBE,defaultErrorMessageArgs:[e]});this._eventEmitter.on(e,i)}off(e,i){if(e!=="videoDevicesUpdated"&&e!=="audioDevicesUpdated"&&e!=="selectedMicrophoneChanged"&&e!=="selectedSpeakerChanged")throw new Oe({defaultError:we.DEVICE_MANAGER.EVENT_UNSUBSCRIBE,defaultErrorMessageArgs:[e]});this._eventEmitter.off(e,i)}getTsDeviceManager(){if(!this._tsDeviceManager)throw new Oe({defaultError:we.DEVICE_MANAGER.ACCESS_DM});return this._tsDeviceManager}getSafariPermissionState(){return this._browserInfo.engine==="Safari"?this._safariVideoPermissionState:"unknown"}getAcsResourceId(){return this._callStack?.caConfigBag?.acsResourceId}getAudioDevicePermission(){return this._audioDevicePermission}getVideoDevicePermission(){return this._videoDevicePermission}get callStackWebCvProvider(){return this._callStack.webcvProvider}get callStackWasmVqeProvider(){return this._callStack.wasmvqeProvider}get callStackVideoEffectsStatusManager(){return this._callStack.videoEffectsStatusManager}get callStackAudioEffectsStatusManager(){return this._callStack.audioEffectsStatusManager}get deviceInfoMapper(){return this._deviceInfoMapper}getEnvironmentInfoInternal(){return this._environmentInfo||(this._environmentInfo=H5e()),this._environmentInfo}getOSNameInternal(){return mP()}sendRawMediaEvent(e){try{this._telemetryLogManager.sendEvent({name:e.eventName,tenant:Wr,properties:e})}catch{this.logger.debug("Unable to send raw media telemetry")}}sendGetDeviceManagerEvent(e){try{this._telemetryLogManager.sendEvent({name:e.eventName,tenant:Wr,properties:e})}catch{this.logger.debug("Unable to send get_device_manager telemetry")}}async permissionsChanged(e,i){const r=this._audioDevicePermission,o=this._videoDevicePermission;let l,d;if(wt().calling.devicePermissions.getCurrentState){const h=await this._tsDeviceManager?.getPermissionStateAsync?.("microphone",""),p=await this._tsDeviceManager?.getPermissionStateAsync?.("camera","");l=aQ(h,this.logger),d=aQ(p,this.logger)}else l=r,d=o;this._audioDevicePermission=l||!!e?.audio,this._videoDevicePermission=d||!!e?.video,i&&(i.audio&&(this._audioDevicePermission=e?.audio??!1),i.video&&(this._videoDevicePermission=e?.video??!1)),r===this._audioDevicePermission&&o===this._videoDevicePermission||(this.logger.info(`permission state changed from audio: ${r}, video: ${o}
                          to audio: ${this._audioDevicePermission}, video: ${this._videoDevicePermission}`),this._telemetryLogManager.sendEvent({name:vi.acs_calling_device_permission_changed,tenant:Wr,properties:{previousAudioDevicePermission:this.nullHandler(r),previousVideoDevicePermission:this.nullHandler(o),newAudioDevicePermission:this.nullHandler(this._audioDevicePermission),newVideoDevicePermission:this.nullHandler(this._videoDevicePermission)}}))}async checkForSelectedDevicesChanges(){if(this.logger.info("checkForSelectedDevicesChanges"),this._tsDeviceManager){const e=await this._tsDeviceManager.getSelectedDevicesAsync?.();e&&(e.microphone!==this._selectedMicrophone?.id&&(this._selectedMicrophone=this._audioDevices.find(i=>i.id===e.microphone),this._eventEmitter.emit("selectedMicrophoneChanged"),e.microphone!==void 0&&this._deviceSelectionNotifications.notifyAll(e.microphone)),e.speaker!==this._selectedSpeaker?.id&&(this._selectedSpeaker=this._audioDevices.find(i=>i.id===e.speaker),this._eventEmitter.emit("selectedSpeakerChanged"),e.speaker!==void 0&&this._deviceSelectionNotifications.notifyAll(e.speaker)))}else this.logger.warn("DeviceManager is undefined, Unable to check selected devices")}isACSDeviceEqualToTSDevice(e,i){return e.id===i.id}async syncDeviceList(e){if(!this._tsDeviceManager)throw new Oe({defaultError:we.DEVICE_MANAGER.ACCESS_DM});this.logger.info("syncDeviceList"),e===void 0&&(e=await this.enumerateDevicesAsync());const i=[];let r=[];const o=[];let l=[];e.map(h=>{if(h.kind===1){const p=this._videoDevices.find(g=>this.isACSDeviceEqualToTSDevice(g,h));if(p)p.setName(h.label),p.setId(h.id),p.setDeviceType("UsbCamera");else{const g=new hP(h.label,h.id,"UsbCamera",this);i.push(g),this._videoDevices.push(g)}}else if(h.kind===2||h.kind===3){const p=this._audioDevices.find(g=>this.isACSDeviceEqualToTSDevice(g,h));if(p){const g=h;p.setName(g.label),p.setId(g.id),p.setIsSystemDefault(g.isSystemDefault),p.setDeviceType(this._tsDeviceTypeToAudioDeviceType[g.kind])}else{const g=new pP(h.label,h.id,h.isSystemDefault,this._tsDeviceTypeToAudioDeviceType[h.kind],this);o.push(g),this._audioDevices.push(g)}}});const d=h=>{const p=h.filter(g=>!e.find(f=>this.isACSDeviceEqualToTSDevice(g,f)));return p.map(g=>{h.splice(h.indexOf(g),1)}),p};r=d(this._videoDevices),l=d(this._audioDevices),(i.length>0||r.length>0)&&this._eventEmitter.emit("videoDevicesUpdated",{added:i,removed:r}),(o.length>0||l.length>0)&&this._eventEmitter.emit("audioDevicesUpdated",{added:o,removed:l})}async enumerateDevicesAsync(){if(!this._tsDeviceManager)throw new Oe({defaultError:we.DEVICE_MANAGER.ACCESS_DM});try{return await this._tsDeviceManager.enumerateDevicesAsync()}catch{throw new Oe({defaultError:we.DEVICE_MANAGER.DEVICE_ENUMERATING_FAIL})}}get isSpeakerSelectionAvailable(){if(!this._tsDeviceManager)throw new Oe({defaultError:we.DEVICE_MANAGER.ACCESS_DM});return this._tsDeviceManager.isAudioOutputSelectionSupported}get selectedMicrophone(){return this._selectedMicrophone}get selectedSpeaker(){return this._selectedSpeaker}async getCameras(){return await this.syncDeviceList(),this._videoDevices}async getMicrophones(){return await this.syncDeviceList(),this._audioDevices.filter(e=>e.deviceType==="Microphone")}async getSpeakers(){if(this.isSpeakerSelectionAvailable)return await this.syncDeviceList(),this._audioDevices.filter(e=>e.deviceType==="Speaker");throw new Oe({defaultError:we.DEVICE_MANAGER.SPEAKER_ENUMERATION_UNSUPPORTED})}async selectMicrophone(e){if(!this._tsDeviceManager)throw new Oe({defaultError:we.DEVICE_MANAGER.ACCESS_DM});if(!e||!e.id)throw new Oe({defaultError:we.DEVICE_MANAGER.INVALID_DEVICE});if(e.id==="microphone:")throw new Oe({defaultError:we.DEVICE_MANAGER.DEVICE_NOT_SELECTABLE});if(this.logger.info("selectMicrophone called"),this._selectedMicrophone?.id!==e.id){const i=wt().calling.deviceSelectionTimeoutInMs,r=this._deviceSelectionNotifications.waitFor(e.id,i),o="Microphone",l=this._deviceInfoMapper.getDeviceId(e.id),d=this._deviceInfoMapper.scrubDeviceLabel(e.name),h=ln(),p=(f,y,T)=>{this.sendDeviceSelectionEvent({eventName:vi.acs_calling_client_operations,operation:o4.deviceSelection,kindOfEvent:f,correlationId:h,timestampInfo:y!==void 0?{deltaTimeInMs:y}:{},additionalDetails:T!==void 0?{failureReason:T.message,code:T.code,...an(T)}:"",deviceSelection:{deviceId:l,deviceName:d,deviceType:o}})};p("attempt");const g=Date.now();try{await this._tsDeviceManager.selectDevicesAsync?.({microphone:e.id}),await r.catch(f=>{if(this._selectedMicrophone?.id!==e.id)throw f}),p("success",Date.now()-g)}catch(f){let y;throw y=new Oe(f?.message==="timeout"?{defaultError:we.DEVICE_MANAGER.SELECT_MICROPHONE_TIMEOUT}:{defaultError:we.DEVICE_MANAGER.SELECT_MICROPHONE_FAIL,originalError:f}),p("failure",Date.now()-g,y),y}}else this.logger.warn("microphoneDevice is already active")}async selectSpeaker(e){const i=this.logger.createFnLogger(hk.SelectSpeaker);if(!this._tsDeviceManager)throw new Oe({defaultError:we.DEVICE_MANAGER.ACCESS_DM});if(!this.isSpeakerSelectionAvailable)throw new Oe({defaultError:we.DEVICE_MANAGER.SPEAKER_SELECTION_UNSUPPORTED});if(!e||!e.id)throw new Oe({defaultError:we.DEVICE_MANAGER.INVALID_DEVICE});if(e.id==="speaker:")throw new Oe({defaultError:we.DEVICE_MANAGER.DEVICE_NOT_SELECTABLE});if(i.info("selectSpeaker called"),this._selectedSpeaker?.id!==e.id){const r=wt().calling.deviceSelectionTimeoutInMs,o=this._deviceSelectionNotifications.waitFor(e.id,r),l="Speaker",d=this._deviceInfoMapper.getDeviceId(e.id),h=this._deviceInfoMapper.scrubDeviceLabel(e.name),p=ln(),g=(y,T,C)=>{this.sendDeviceSelectionEvent({eventName:vi.acs_calling_client_operations,operation:o4.deviceSelection,kindOfEvent:y,correlationId:p,timestampInfo:T!==void 0?{deltaTimeInMs:T}:{},additionalDetails:C!==void 0?{failureReason:C.message,code:C.code,...an(C)}:"",deviceSelection:{deviceId:d,deviceName:h,deviceType:l}})};g("attempt");const f=Date.now();try{await this._tsDeviceManager.selectDevicesAsync?.({speaker:e.id}),await o.catch(y=>{if(this._selectedSpeaker?.id!==e.id)throw y}),g("success",Date.now()-f)}catch(y){let T;throw T=new Oe(y?.message==="timeout"?{defaultError:we.DEVICE_MANAGER.SELECT_SPEAKER_TIMEOUT}:{defaultError:we.DEVICE_MANAGER.SELECT_SPEAKER_FAIL,originalError:y}),g("failure",Date.now()-f,T),T}}else i.warn("device is already selected")}async askDevicePermission(e){const i={audio:!!e.audio,video:!!e.video};if(!e.audio&&!e.video)throw new Oe({defaultError:we.DEVICE_MANAGER.ONE_PERMISSION_ATLEAST});const r=this.getKeyForConstrains(i);let o=this._combinedDevicePermission.get(r);return o?this.logger.info(`askDevicePermission attempt: audio:${i.audio}, video:${i.video} on pending existing request ${pk(o)}`):(o=this.askDevicePermissionInternal(i),this._combinedDevicePermission.set(r,o),o.finally(()=>{this._combinedDevicePermission.delete(r)})),o}getKeyForConstrains(e){return Object.keys(e).filter(i=>e[i]).toString()}async askDevicePermissionInternal(e){this.logger.info(`askDevicePermission attempt: audio:${e.audio}, video:${e.video}`);const i=ln(),r=+new Date;this.sendAudioVideoPermissionEvent({eventName:vi.acs_calling_adp_attempt,correlationId:i,audioPermissionRequested:e.audio,videoPermissionRequested:e.video});try{if(!this._tsDeviceManager)throw new Oe({defaultError:we.DEVICE_MANAGER.ACCESS_DM});const o=[];if(wt().calling.devicePermissions.splitAskAudioVideo){this.logger.info("askDevicePermission, split permission check");const l=[];if(e.audio&&(this.logger.info("askDevicePermission, split permission audio"),l.push(this._tsDeviceManager.askDevicePermission({audio:e.audio,video:!1}))),e.video){const g=async f=>new Promise((y,T)=>{const C=async()=>{if(this.logger.info("askDevicePermission, split permission video"),!this._tsDeviceManager){const E="askDevicePermission, split permission video failed device manager not found";return this.logger.error(E),void T(E)}try{const E=await this._tsDeviceManager.askDevicePermission({audio:!1,video:e.video});y(E)}catch(E){T(E)}};f?window.setTimeout(C,f):C()});l.push(g(wt().calling.devicePermissions.timeoutInBetween))}const d=await Promise.allSettled(l);let h={audio:!1,video:!1};d.forEach(g=>{g.status==="fulfilled"&&g?.value&&(h={audio:h.audio||!!g?.value?.audio,video:h.video||!!g?.value?.video}),g.status==="rejected"&&g?.reason&&o.push(g.reason)});const p=this._permissionChangedTasks.then(()=>this.permissionsChanged(h,e));this._permissionChangedTasks=p,this._permissionChangedTasks.catch(nh),await p,this._safariVideoPermissionState=this._videoDevicePermission?"granted":"denied"}else{const l=await this._tsDeviceManager.askDevicePermission({audio:e.audio,video:e.video}),d=this._permissionChangedTasks.then(()=>this.permissionsChanged(l,e));this._permissionChangedTasks=d,this._permissionChangedTasks.catch(nh),await d}if(e?.audio&&!this._audioDevicePermission||e?.video&&!this._videoDevicePermission)this.sendAudioVideoPermissionEvent({eventName:vi.acs_calling_adp_failure,correlationId:i,audioPermissionRequested:e.audio,videoPermissionRequested:e.video,audioPermissionGranted:this._audioDevicePermission,videoPermissionGranted:this._videoDevicePermission},new Oe({defaultError:we.DEVICE_MANAGER.PERMISSION_NOT_GRANTED_OR_FAILED,defaultErrorMessageArgs:[pk(o)]}));else{const l=+new Date;this.sendAudioVideoPermissionEvent({eventName:vi.acs_calling_adp_success,correlationId:i,audioPermissionRequested:e.audio,videoPermissionRequested:e.video,audioPermissionGranted:this._audioDevicePermission,videoPermissionGranted:this._videoDevicePermission,deltaTimeInMs:l-r})}}catch(o){const l=new Oe({defaultError:we.DEVICE_MANAGER.ADP_FAIL,originalError:o}),d=+new Date;this.sendAudioVideoPermissionEvent({eventName:vi.acs_calling_adp_failure,correlationId:i,audioPermissionRequested:e.audio,videoPermissionRequested:e.video,audioPermissionGranted:this._audioDevicePermission,videoPermissionGranted:this._videoDevicePermission,deltaTimeInMs:d-r},l)}return{audio:!!this._audioDevicePermission,video:!!this._videoDevicePermission}}sendAudioVideoPermissionEvent(e,i){try{let r,o,l;i&&(r=typeof i?.message=="string"?i?.message:void 0,o=an(i)),e.deltaTimeInMs&&(l=e.deltaTimeInMs>25e3),this._telemetryLogManager.sendEvent({name:e.eventName,tenant:Wr,properties:{audioPermissionGranted:this.nullHandler(e.audioPermissionGranted),videoPermissionGranted:this.nullHandler(e.videoPermissionGranted),audioPermissionRequested:e.audioPermissionRequested,videoPermissionRequested:e.videoPermissionRequested,correlationId:e.correlationId||"",failureReason:r||"",deltaTimeInMs:e.deltaTimeInMs||"",deltaTimeGreaterThanJAMATimeout:this.nullHandler(l),additionalDetails:{...o}}})}catch{this.logger.debug("Unable to send audio video permission failure success telemtery")}}sendDeviceSelectionEvent(e){try{this._telemetryLogManager.sendEvent({name:e.eventName,tenant:Wr,properties:e})}catch{this.logger.debug("Unable to send device selection telemetry")}}nullHandler(e){return e===void 0?"":e}dispose(){this._dmDevicesChangedSub&&this._dmDevicesChangedSub.dispose(),this._dmDevicesPermissionChangedSub&&this._dmDevicesPermissionChangedSub.dispose(),this._dmDevicesPermissionChangedSub=void 0,this._dmDevicesChangedSub=void 0}}xO([zv,Mp("design:type",Object)],yP.prototype,"logger",void 0),xO([to(hk.GetDeviceManager),Mp("design:type",Function),Mp("design:paramtypes",[]),Mp("design:returntype",Promise)],yP.prototype,"getDeviceManager",null),xO([to(hk.GetCameras),Mp("design:type",Function),Mp("design:paramtypes",[]),Mp("design:returntype",Promise)],yP.prototype,"getCameras",null),xO([to(hk.GetMicrophones),Mp("design:type",Function),Mp("design:paramtypes",[]),Mp("design:returntype",Promise)],yP.prototype,"getMicrophones",null),xO([sg(hk.GetSpeakers),Mp("design:type",Function),Mp("design:paramtypes",[]),Mp("design:returntype",Promise)],yP.prototype,"getSpeakers",null),xO([to(hk.SelectMicrophone),Mp("design:type",Function),Mp("design:paramtypes",[Object]),Mp("design:returntype",Promise)],yP.prototype,"selectMicrophone",null),xO([to(hk.SelectSpeaker),Mp("design:type",Function),Mp("design:paramtypes",[Object]),Mp("design:returntype",Promise)],yP.prototype,"selectSpeaker",null),xO([to(hk.AskDevicePermission),Mp("design:type",Function),Mp("design:paramtypes",[Object]),Mp("design:returntype",Promise)],yP.prototype,"askDevicePermission",null);var VHt=function(t,e,i,r){var o,l=arguments.length,d=l<3?e:r===null?r=Object.getOwnPropertyDescriptor(e,i):r;if(typeof Reflect=="object"&&typeof Reflect.decorate=="function")d=Reflect.decorate(t,e,i,r);else for(var h=t.length-1;h>=0;h--)(o=t[h])&&(d=(l<3?o(d):l>3?o(e,i,d):o(e,i))||d);return l>3&&d&&Object.defineProperty(e,i,d),d},gge=function(t,e){if(typeof Reflect=="object"&&typeof Reflect.metadata=="function")return Reflect.metadata(t,e)};class F3e extends Zpe{get info(){return this._teamsCall.info}constructor(e){super(e,KK.TeamsIncomingCall),this._teamsCall=e}async accept(e){if(!_B(this._teamsCall.acsProxy,this._teamsCall.acsCustomRelayManager,!0))throw new Oe({defaultError:we.CALL_AGENT.PROXY_CUSTOM_TURN_FORBIDDEN});return await this._teamsCall.accept(e),this._teamsCall}}VHt([to(Ar.Accept),gge("design:type",Function),gge("design:paramtypes",[Object]),gge("design:returntype",Promise)],F3e.prototype,"accept",null);var p4=function(t,e,i,r){var o,l=arguments.length,d=l<3?e:r===null?r=Object.getOwnPropertyDescriptor(e,i):r;if(typeof Reflect=="object"&&typeof Reflect.decorate=="function")d=Reflect.decorate(t,e,i,r);else for(var h=t.length-1;h>=0;h--)(o=t[h])&&(d=(l<3?o(d):l>3?o(e,i,d):o(e,i))||d);return l>3&&d&&Object.defineProperty(e,i,d),d},Jf=function(t,e){if(typeof Reflect=="object"&&typeof Reflect.metadata=="function")return Reflect.metadata(t,e)};class wk extends Yg{get info(){return this._info}constructor(e,i,r,o){super(e,i,r,o,GL.TeamsCall),this._isEmergencyCall=!1,this._musicOnHoldEnabled=!1,this._hasFetchedPolicies=!1,this._info=this.callInfo,this._mtPolicyService=i.mtPolicyService}async startCallInternal(e,i,r,o,l,d,h){if(this._mtPolicyService&&this._mtPolicyService.isFetchUserPoliciesAndSettingsApplicable(!0,h)){this._mtPolicyService.userDialedNumber(Array.isArray(h)?h[0].phoneNumber:h.phoneNumber);let p="",g=!0;this._isEmergencyCall=!1;try{this.logger.info("Fetching Teams User policy from MiddleTier Service"),await this._mtPolicyService.fetchUserPoliciesFromAcsMiddleTier(this.tsCall.callId,this._callAgent.getUserMri())}catch(f){g=!1,this.logger.warn(`Fetching Teams user policy from ACS MiddleTier Service failed.
                    Error message = ${f?.message}, code = ${f?.code}, subcode = ${f?.subCode}.
                    Proceeding as normal pstn call`)}if(g){try{this.enforcePolicyAndLicenseRestrictions()}catch(f){return void this.handlePolicyAndLicenseRestrictionsFailure(f)}try{this.logger.info("Deriving emergency content from fetched policies and settings"),p=this._mtPolicyService.getEmergencyContent()}catch(f){this.logger.warn(`Error deriving emergency content from fetched policies and settings. 
                    Error message = ${f?.message}, code = ${f?.code}, subcode = ${f?.subCode}. Proceeding as normal pstn call`)}o&&(o.emergencyContent=p||"",o.isEmergency=p?.trim().length>0||!1,this._isEmergencyCall=o.isEmergency)}}if(h){let p=[];Array.isArray(h)?p=h:p.push(h),this._isEmergencyCall&&p.length==1&&(this.logger.info(`user dialed number (${p[0].phoneNumber}) resolved to actual emergency number (${this._mtPolicyService.getEmergencyNumber()} during startCall`),p[0]={phoneNumber:this._mtPolicyService.getEmergencyNumber()}),p.length>1&&await this.setupThreadIdWhenStartingGroupCall(p,e,o),p.forEach(g=>{this.tsCall.addParticipant(zr(g)).catch(()=>{this.logger.error("Failed to add participant during call start")})}),this.logger.info("Paticipant added during startCall")}return this._allowBreakoutRoomJoin=wt().calling.breakoutRooms.enabled&&this._mtPolicyService.isBreakoutRoomsAllowed()&&!!r,this._allowIPAudio=this._mtPolicyService.isIPAudioAllowed(),this._allowIPVideo=this._mtPolicyService.isIPVideoAllowed(),super.startCallInternal(e,i,r,o,l,d)}isEmergencyCallInProgress(){return this._isEmergencyCall}dispose(){super.dispose(),this._extensibleApi.dispose()}addParticipant(e,i){const r=+new Date,o=ln();this.sendParticipantAddedOrRemovedEvent({kindOfEvent:Je.attempt,participantAddedOrRemoved:"add",correlationId:o,timestampInfo:{attemptTimestamp:r},additionalDetails:{customContext:{userToUserPresent:!!i?.customContext?.userToUser,xHeadersPresent:!!i?.customContext?.xHeaders&&i?.customContext.xHeaders.length>0}}});try{Y3(Ar.AddParticipant,this.state),LA(e)}catch(h){const p=new Oe({defaultError:we.IDENTIFIER.PARSE_INVALID_IDENTIFIER,originalError:h});throw this.sendParticipantAddedOrRemovedEvent({kindOfEvent:Je.failure,participantAddedOrRemoved:"add",correlationId:o,timestampInfo:{deltaTimeInMs:r-+new Date},additionalDetails:{code:h.code,failureReason:h.message,...an(p)}}),p}if(!_B(this.acsProxy,this.acsCustomRelayManager,!0)){const h=new Oe({defaultError:we.CALL_AGENT.PROXY_CUSTOM_TURN_FORBIDDEN});throw this.sendParticipantAddedOrRemovedEvent({kindOfEvent:Je.failure,participantAddedOrRemoved:"add",correlationId:o,timestampInfo:{deltaTimeInMs:r-+new Date},additionalDetails:{code:h.code,failureReason:h.message,...an(h)}}),h}if(this._remoteParticipants.find(h=>zr(h.identifier)===zr(e))){const h=new Oe({defaultError:we.CALL.PARTICIPANT_ALREADY_IN_CALL,defaultErrorMessageArgs:[Ap(e).kind]});throw this.sendParticipantAddedOrRemovedEvent({kindOfEvent:Je.failure,participantAddedOrRemoved:"add",correlationId:o,timestampInfo:{deltaTimeInMs:r-+new Date},additionalDetails:{code:h.code,failureReason:h.message,...an(h)}}),h}if(this.tsCall.threadId&&Vxt(this.tsCall.threadId))try{if(this.IsTargetUserAllowed(e))throw new Oe({defaultError:we.CALL_AGENT.UNSUPPORTED_TARGET_TYPE})}catch(h){throw this.sendParticipantAddedOrRemovedEvent({kindOfEvent:Je.failure,participantAddedOrRemoved:"add",correlationId:o,timestampInfo:{deltaTimeInMs:r-+new Date},additionalDetails:{code:h.code,failureReason:h.message,...an(h)}}),this.logger.error(h),h}const l=this.getOrCreateRemoteParticipant(Sl(zr(e)));let d="";return this.GetOrCreateGroupChatThread(!!i?.threadId,e,i).then(h=>{h&&((i=i??{}).threadId=h,d=h,this._info.setThreadId(h)),this.addParticipantToTsCall(e,d,i,l,o,r)}).catch(h=>{throw this.sendParticipantAddedOrRemovedEvent({kindOfEvent:Je.failure,participantAddedOrRemoved:"add",correlationId:o,timestampInfo:{deltaTimeInMs:r-+new Date},additionalDetails:{code:h.code,failureReason:h.message,...an(h)}}),h}),l}async removeParticipant(e){const i=+new Date,r=ln();this.sendParticipantAddedOrRemovedEvent({kindOfEvent:Je.attempt,participantAddedOrRemoved:"remove",correlationId:r,timestampInfo:{attemptTimestamp:i}});try{Y3(Ar.RemoveParticipant,this.state),LA(e)}catch(l){const d=new Oe({defaultError:we.IDENTIFIER.PARSE_INVALID_IDENTIFIER,originalError:l});throw this.sendParticipantAddedOrRemovedEvent({kindOfEvent:Je.failure,participantAddedOrRemoved:"remove",correlationId:r,timestampInfo:{deltaTimeInMs:i-+new Date},additionalDetails:{code:l.code,failureReason:l.message,...an(d)}}),d}const o=this._remoteParticipants.find(l=>zr(l.identifier)===zr(e));if(!o){const l=new Oe({defaultError:we.CALL.PARTICIPANT_NOT_IN_CALL,originalError:[Ap(e).kind]});throw this.sendParticipantAddedOrRemovedEvent({kindOfEvent:Je.failure,participantAddedOrRemoved:"remove",correlationId:r,timestampInfo:{deltaTimeInMs:+new Date-i},additionalDetails:{code:l.code,subCode:l.subCode,failureReason:l.message,...an(l)}}),l}try{await this.tsCall.removeParticipant(zr(e)),this.sendParticipantAddedOrRemovedEvent({kindOfEvent:Je.success,participantAddedOrRemoved:"remove",correlationId:r,timestampInfo:{deltaTimeInMs:i-+new Date}})}catch(l){const{callEndReason:d}=U3(this,o.tsRemoteParticipant,l);o.callEndReason||o.setCallEndReason(d);const h=dP(d);throw this.sendParticipantAddedOrRemovedEvent({kindOfEvent:Je.failure,participantAddedOrRemoved:"remove",correlationId:r,timestampInfo:{deltaTimeInMs:i-+new Date},additionalDetails:{code:h?.callEndReason.code,subCode:h?.callEndReason.subCode,failureReason:h?.callEndReason.message,...h}}),new Oe({defaultError:{message:d.message,code:d.code,subCode:d.subCode||0,resultCategories:d.resultCategories},originalError:l})}}async mute(){super.mute()}async unmute(){super.unmute()}async hold(){if(this.tsCall.state===4)return void this.logger.info("Call already on hold");if(!wt().calling.musicOnHoldEnabled)return this.logger.warn("Music on Hold is not enabled"),super.hold();const e=+new Date,i=ln();if(this._causeId=fd(),this.sendCallOnHoldAndResumedEvent({eventName:vi.acs_calling_call_hold_and_resume,callId:this.id,localParticipantId:this.tsCall.participantId,correlationId:i,operation:Ar.Hold,kindOfEvent:Je.attempt,timestampInfo:{deltaTimeInMs:e},additionalDetails:{holdType:mT.MusicOnHold,isScreenSharingOnFlag:this.tsCall.isScreenSharingOn}}),!this._hasFetchedPolicies)try{this.logger.info("Fetching Teams Calling Policy from Azure Communication Services"),await this._mtPolicyService.fetchUserPoliciesFromAcsMiddleTier(this.tsCall.callId,this._callAgent.getUserMri(),{policyUrlSuffix:wt().MiddleTier.policyUrlSuffixV2,userPolicies:["TeamsCallingPolicy"]}),this._hasFetchedPolicies=!0,this._musicOnHoldEnabled=this._mtPolicyService.isMoHEnabled()}catch(r){this.logger.warn(`Fetching Teams Calling Policy from Azure Communication Services failed.
                    Error message = ${r?.message}, code = ${r?.code}, subcode = ${r?.subCode}.`)}return this._musicOnHoldEnabled?(wt().calling.turnOffScreenShareBeforeHold&&this.tsCall.isScreenSharingOn&&await this.tsCall.stopScreenSharing().then(()=>{this.logger.log("Successfully turned off screen sharing before hold")}).catch(()=>{this.logger.error("Failed to turn off screensharing before hold")}),await this.tsCall.hold(void 0,this._causeId,{isLocal:!0},1).then(async()=>{this.logger.info("Successfully detached devices as part of Hold"),await this.tsCall.park(3,this._causeId).then(()=>{const r=+new Date;this.sendCallOnHoldAndResumedEvent({eventName:vi.acs_calling_call_hold_and_resume,callId:this.id,localParticipantId:this.tsCall.participantId,correlationId:i,operation:Ar.Hold,kindOfEvent:Je.success,timestampInfo:{deltaTimeInMs:r-e},additionalDetails:{holdType:mT.MusicOnHold,isScreenSharingOnFlag:this.tsCall.isScreenSharingOn}}),this.logger.info("Successful park() as part of hold, Music on Hold completed successfully")})}).catch(()=>{const r=+new Date,o=new Oe({defaultError:we.CALL.HOLD_CALL});throw this.logger.warn(`Attempting to perform Music on Hold failed.
                    Error message = ${o.message}, code = ${o.code}, subcode = ${o.subCode}`),this.sendCallOnHoldAndResumedEvent({eventName:vi.acs_calling_call_hold_and_resume,callId:this.id,localParticipantId:this.tsCall.participantId,correlationId:i,operation:Ar.Hold,kindOfEvent:Je.failure,timestampInfo:{deltaTimeInMs:r-e},additionalDetails:{failureReason:o.message,code:o.code,subCode:o.subCode,holdType:mT.MusicOnHold,isScreenSharingOnFlag:this.tsCall.isScreenSharingOn,...an(o)}}),o})):(this.logger.info("Fetching  of Teams Calling Policy failed or Music on Hold Disabled, proceeding with standard hold"),super.hold())}async resume(){if(this._musicOnHoldEnabled){const e=+new Date,i=ln();return this.sendCallOnHoldAndResumedEvent({eventName:vi.acs_calling_call_hold_and_resume,callId:this.id,localParticipantId:this.tsCall.participantId,correlationId:i,operation:Ar.Resume,kindOfEvent:Je.attempt,timestampInfo:{deltaTimeInMs:e},additionalDetails:{holdType:mT.MusicOnHold,isScreenSharingOnFlag:this.tsCall.isScreenSharingOn}}),await this.tsCall.unpark(3,this._causeId).then(async()=>{this.logger.info("Successful unpark() as part of resume"),await this.tsCall.unhold(void 0,this._causeId).then(()=>{const r=+new Date;this.sendCallOnHoldAndResumedEvent({eventName:vi.acs_calling_call_hold_and_resume,callId:this.id,localParticipantId:this.tsCall.participantId,correlationId:i,operation:Ar.Resume,kindOfEvent:Je.success,timestampInfo:{deltaTimeInMs:r-e},additionalDetails:{holdType:mT.MusicOnHold,isScreenSharingOnFlag:this.tsCall.isScreenSharingOn}}),this.logger.info("Successful unhold() as part of resume, resume completed successfully")})}).catch(()=>{const r=+new Date,o=new Oe({defaultError:we.CALL.RESUME_CALL});throw this.logger.warn(`Attempting to perform resume from Music on Hold failed.
                    Error message = ${o.message}, code = ${o.code}, subcode = ${o.subCode}`),this.sendCallOnHoldAndResumedEvent({eventName:vi.acs_calling_call_hold_and_resume,callId:this.id,localParticipantId:this.tsCall.participantId,correlationId:i,operation:Ar.Resume,kindOfEvent:Je.failure,timestampInfo:{deltaTimeInMs:r-e},additionalDetails:{failureReason:o.message,code:o.code,subCode:o.subCode,holdType:mT.MusicOnHold,isScreenSharingOnFlag:this.tsCall.isScreenSharingOn,...an(o)}}),o})}return this.logger.info("Music on Hold Disabled, proceeding with standard resume"),super.resume()}validateAndSetThreadId(e,i){if(!i?.threadId){const r=new Oe({defaultError:we.CALL.CTE_ADDPARTICIPANT_NO_THREAD_ID});throw this.logger.error(`Error Message = ${r.message}, code = ${r.code}, subcode = ${r.subCode}`),r}return this.validateThreadIdFormat(i?.threadId),i?.threadId}validateThreadIdFormat(e){if(!e.startsWith("19")){const i=new Oe({defaultError:we.CALL.TEAMS_INVALID_THREAD_ID});throw this.logger.error(`Error Message = ${i.message}, code = ${i.code}, subcode = ${i.subCode}`),i}}enforcePolicyAndLicenseRestrictions(){const e=+new Date;if(!this._mtPolicyService.isEvEnabled()){const i=+new Date,r=new Oe({defaultError:we.CALL.CTE_VOICE_NOT_ENABLED});this.logger.error(`Error Message = ${r.message}, code = ${r.code}, subcode = ${r.subCode}`);const o=this._callAgent.getEcsConfigIds();throw this.sendCallStageEvent({eventName:vi.acs_calling_call_failed,correlationId:ln(),timestampInfo:{deltaTimeInMs:i-e},additionalPayload:{additionalProperties:{EmergencyCountryCode:this._callAgent._caConfigBag?.emergencyCountryCode||"",IsUserEmergencyCountryCode:this._callAgent._caConfigBag?.IsUserEmergencyCountryCode||!1,trouterState:this._callAgent.getTrouterState(),AcsCallingSDKWeb_ecsConfigId:o.AcsCallingSDKWeb,SkypeWebMedia_ecsConfigId:o.SkypeWebMedia},additionalDetails:{...an(r)}}},r,{code:r.code,subCode:r.subCode,phrase:r.message}),r}}handlePolicyAndLicenseRestrictionsFailure(e){this._callEndReason={message:"Unknown",code:e?.code,subCode:e?.subCode,resultCategories:e?.resultCategories},this._state="Disconnected",this._eventEmitter.emit("stateChanged"),this._callAgent.handleCallRemoved(this.tsCall)}async setupThreadIdWhenStartingGroupCall(e,i,r){if(i&&i.threadId&&(this.validateThreadIdFormat(i.threadId),this.logger.info("ThreadId is already provided in the options parameter: "+JSON.stringify(i))),i===void 0||!i.threadId){const o=[];e.forEach(l=>{o.push({id:zr(l)})});try{const l=await this._mtPolicyService.CreateChatThreadId(this.tsCall.callId,{createThreadIdSuffix:wt().MiddleTier.serverManagedThreadIdApiConfiguration.createThreadSuffix,participants:o});i||(i={}),i.threadId=l,l&&this._info.setThreadId(l),r&&l&&(r.threadId=l)}catch(l){const d="Failed to create thread Id for Teams group call ";if(!wt().MiddleTier.serverManagedThreadIdApiConfiguration.decoupleChatThreadFromCalls)throw new Oe({defaultError:we.CTE_MID_TIER_POLICY_SERVICE.CREATETHREAD_FAILED});this.logger.warn(d+l)}}}async GetOrCreateGroupChatThread(e,i,r){let o="";if(e)return this.logger.info("Customer provided threadId in options: "+JSON.stringify(r)),o=this.validateAndSetThreadId(i,r),Promise.resolve(o);if(!wt().MiddleTier.serverManagedThreadIdApiConfiguration.allowServerThreadCreation)throw new Oe({defaultError:we.CALL.CTE_ADDPARTICIPANT_NO_THREAD_ID});if(this._info.threadId!==null&&this._info.threadId!==void 0){o=this._info.threadId;const l=[];return l.push({id:zr(i)}),await this._mtPolicyService.AddParticipantsToThread(this.tsCall.callId,{threadId:o,addParticipantsSuffix:wt().MiddleTier.serverManagedThreadIdApiConfiguration.addParticipantSuffix,participants:l}).catch(d=>{this.logger.warn("Error when adding participants "+JSON.stringify(l)+" to thread. "+d)}),Promise.resolve(o)}{const l=[];return this._remoteParticipants.forEach(d=>{l.push({id:zr(d.identifier)})}),l.push({id:zr(i)}),await this._mtPolicyService.CreateChatThreadId(this.tsCall.callId,{createThreadIdSuffix:wt().MiddleTier.serverManagedThreadIdApiConfiguration.createThreadSuffix,participants:l}).then(d=>{o=d,this.logger.info("Add participant into 1on1 call to convert it into Teams group call. Create thread id: "+o)}).catch(d=>{const h="Error when adding participants "+zr(i)+" to thread to create a Teams group call. ";if(!wt().MiddleTier.serverManagedThreadIdApiConfiguration.decoupleChatThreadFromCalls)throw new Oe({defaultError:we.CTE_MID_TIER_POLICY_SERVICE.CREATETHREAD_FAILED});this.logger.warn(h+d)}),Promise.resolve(o)}}addParticipantToTsCall(e,i,r,o,l,d){this.tsCall.addParticipant(zr(e),{threadId:i,customHeaderContext:h6(r)}).then(()=>{this.sendParticipantAddedOrRemovedEvent({kindOfEvent:Je.success,participantAddedOrRemoved:"add",correlationId:l,timestampInfo:{deltaTimeInMs:d-+new Date}})}).catch(h=>{const{callEndReason:p}=U3(this,o.tsRemoteParticipant,h);o.callEndReason||o.setCallEndReason(p);const g=dP(p);this.sendParticipantAddedOrRemovedEvent({kindOfEvent:Je.failure,participantAddedOrRemoved:"add",correlationId:l,timestampInfo:{deltaTimeInMs:d-+new Date},additionalDetails:{code:g?.callEndReason.code,subCode:g?.callEndReason.subCode,failureReason:g?.callEndReason.message,...g}}),this._remoteParticipants.find(f=>zr(f.identifier)===zr(e))&&(this.deleteRemoteParticipant(o),this._eventEmitter.emit("remoteParticipantsUpdated",{added:[],removed:[o]}))})}IsTargetUserAllowed(e){return bDe(e)||Vf(e)||qw(e)}}p4([qL(Ar.AddParticipant),sg(Ar.AddParticipant),Jf("design:type",Function),Jf("design:paramtypes",[Object,Object]),Jf("design:returntype",Object)],wk.prototype,"addParticipant",null),p4([qL(Ar.RemoveParticipant),to(Ar.RemoveParticipant),Jf("design:type",Function),Jf("design:paramtypes",[Object]),Jf("design:returntype",Promise)],wk.prototype,"removeParticipant",null),p4([qL(Ar.Mute),Jf("design:type",Function),Jf("design:paramtypes",[]),Jf("design:returntype",Promise)],wk.prototype,"mute",null),p4([qL(Ar.Unmute),Jf("design:type",Function),Jf("design:paramtypes",[]),Jf("design:returntype",Promise)],wk.prototype,"unmute",null),p4([qL(Ar.Hold),to(Ar.Hold),Jf("design:type",Function),Jf("design:paramtypes",[]),Jf("design:returntype",Promise)],wk.prototype,"hold",null),p4([qL(Ar.Resume),to(Ar.Resume),Jf("design:type",Function),Jf("design:paramtypes",[]),Jf("design:returntype",Promise)],wk.prototype,"resume",null);var mge=function(t,e,i,r){var o,l=arguments.length,d=l<3?e:r===null?r=Object.getOwnPropertyDescriptor(e,i):r;if(typeof Reflect=="object"&&typeof Reflect.decorate=="function")d=Reflect.decorate(t,e,i,r);else for(var h=t.length-1;h>=0;h--)(o=t[h])&&(d=(l<3?o(d):l>3?o(e,i,d):o(e,i))||d);return l>3&&d&&Object.defineProperty(e,i,d),d},SP=function(t,e){if(typeof Reflect=="object"&&typeof Reflect.metadata=="function")return Reflect.metadata(t,e)};class jE extends s4{get calls(){return this._calls}constructor(e,i,r,o,l,d){super(e,i,o,l,r,zx.TeamsCallAgent,d),this._calls=[],this.handleCallAdded=h=>{if(!this._calls.find(p=>p.id===h.callId)){const p=h.on("callStateChanged",async()=>{if(h.state===1){const g=$v(h),f=h.callId;p.dispose();let y=new wk({callId:f,isIncoming:!0},this,h,this._telemetryLogManager);g&&(y=l4(y));const T=new F3e(y);this.handleCallState(y),g?await Promise.all(y.bindTsCall()):y.bindTsCall(),this._eventEmitter.emit("incomingCall",{incomingCall:T})}})}},this.handleCallRemoved=h=>{this.logger.info(`removing callId=${h.callId}`);const p=this._calls.find(g=>g.id===h.callId);if(p){if(p.isBreakoutRoomCall){const g=wt().calling.breakoutRooms.hangUpCallDelayInMilliSeconds;setTimeout(()=>{this.disposeCall(p)},g)}else this.disposeCall(p);this._eventEmitter.emit("callsUpdated",{added:[],removed:[p]}),this.logger.info("call removed")}},this.handleCallState=h=>{h.on("stateChanged",async()=>{try{h.state==="Disconnected"?this.tsStack?(await this._tsCallRegistry.deleteCallAsync?.(h.tsCall)||this.logger.info(`The call has been removed from registry, call id: ${h.id}`),h.stats.flushEvents(),this._telemetryLogManager.flushAllEvents(h.id).catch(()=>{this.logger.error("Failed to flush telemetry log manager events")})):this.logger.info("Unable to remove call from registry"):h.state==="Connecting"&&h.direction=="Incoming"&&(this.addToCallArray(h),this._eventEmitter.emit("callsUpdated",{added:[h],removed:[]}))}catch{this.logger.error("Failed to handle call state changed event")}})},this.logger=i}createNewCall(e,i){const r=new wk({callId:e},this,i,this._telemetryLogManager);return $v(i)?l4(r):r}addToCallArray(e){this._calls.push(e),this.trackCallEndTimeToStopTelemetry(this._calls)}addToCallAgentsMap(e){jE.teamsCallAgents.get(e?.identityMri)&&oP(we.CALL_AGENT.TEAMS_CALLAGENT_ALREADY_EXSISTS,this.logger),jE.teamsCallAgents.set(e?.identityMri,this)}removeFromCallAgentsMap(e){e?.identityMri&&jE.teamsCallAgents.get(e?.identityMri)===this&&jE.teamsCallAgents.delete(e?.identityMri)}disposeCall(e){const i=this._calls.indexOf(e);i!==-1&&this._calls.splice(i,1),e.dispose(),this.trackCallEndTimeToStopTelemetry(this._calls)}getMiddleTierServiceInstance(){return this.mtPolicyService}async setUserPoliciesOnAgentInitialization(){super.setUserPoliciesOnAgentInitialization();try{if(this.isCteUser()){const e=ln();this.logger.info(`ACS MiddleTier service called on Teams Call Agent initialization with call Id=${e}`),await this.mtPolicyService.fetchUserPoliciesFromAcsMiddleTier(e,this.getUserMri(),{policyUrlSuffix:wt().MiddleTier.policyUrlSuffixV2,userPolicies:["EmergencyPolicies","TeamsCallingPolicy","TeamsMeetingPolicy"],userProperties:["FeatureTypes","PoliciesMetadata","phoneNumber","sipUri","hostType","accountEnabled","useTeamsCalling","evEnabled","region","routingType","preferredDataLocation","featureTypes","displayName"]}),this._userPolicies=this.mtPolicyService.getUserPolicy(),this._userProperties=this.mtPolicyService.getUserProperties(),this.logger.info(`****User policy initialized to ${JSON.stringify(this._userPolicies)}`),this.logger.info(`****User properties initialized to ${JSON.stringify(this._userProperties)}`)}}catch(e){this.logger.warn(`Fetching Teams user policy and Properties from ACS MiddleTier Service failed.
            Error message = ${e?.message}, code = ${e?.code}, subcode = ${e?.subCode}.`)}}startCall(e,i){const r=ln(),o=+new Date,l={correlationId:r,timestampInfo:{attemptTimestamp:o}};this._telemetryLogManager.sendEvent({name:vi.acs_calling_call_attempt,tenant:Wr,properties:l},void 0,"attempt");try{let d;if(this.assertParticipants(e),Array.isArray(e)){if(d=i,e.length>1&&!wt().MiddleTier.serverManagedThreadIdApiConfiguration.allowServerThreadCreation&&!d?.threadId)throw new Oe({defaultError:we.CALL_AGENT.GROUPCALL_THREADID});if(e.length==1&&d?.threadId)throw new Oe({defaultError:we.CALL_AGENT.ONE_TO_ONE_THREADID})}else d=i;if(wt().calling.enableSmePassFakeConversation&&this.isAcsToTeamsInteropCall(e))throw new Oe({defaultError:we.CALL_AGENT.UNSUPPORTED_TARGET_TYPE});let h=d?.audioOptions?.muted;return h===void 0&&(h=!1),this.logger.info(`startCall with video=${!!d?.videoOptions},muted=${h}`),this.createCall({participants:e,startCallOptions:d},{correlationId:r,attemptTimestamp:o})}catch(d){let h,p;throw d instanceof Oe&&(h=typeof d?.message=="string"?d?.message:void 0,p={...an(d)}),this._telemetryLogManager.sendEvent({name:vi.acs_calling_call_failed,tenant:Wr,properties:{correlationId:r,timestampInfo:{deltaTimeInMs:+new Date-o},failureReason:h||"",additionalDetails:p||{}}},void 0,"failure"),d}finally{this._telemetryLogManager.deleteEventMapByCorrelationId(r)}}join(e,i){this.assertCallContext(e);const r=!!i?.audioOptions?.muted;return this.logger.info(`join with video=${!!i?.videoOptions},muted=${r}`),this.createCall({teamsCallContext:e,startCallOptions:i})}async dispose(){if(this._disposed)throw new Oe({defaultError:we.CALL_AGENT.CTE_ALREADY_DISPOSED});this._disposed=!0,this._abortController.abort(),this._extensibleApi.dispose(),this._parsedTokenCredential?.identityMri&&jE.teamsCallAgents.delete(this._parsedTokenCredential?.identityMri);try{const e=this._tokenFetchTries>this._maxNmberOfRetries;await this._callStack?.dispose(e)}catch{this.logger.error("Call Agent failed to dispose to Call Stack")}this.offTrouterStateChanged(this._trouterStateChangeCallback),this._callStack.offRegisteredChanged(this._registrarStateChangeCallback),delete this._callStack,this._telemetryLogManager.clearTelemetryLoggers(),this._eventEmitter.removeAllListeners(),this._internalEventEmitter.emit("disposed"),this._internalEventEmitter.removeAllListeners()}on(e,i){if(e!=="incomingCall"&&e!=="callsUpdated"&&e!=="connectionStateChanged")throw new Oe({defaultError:we.CALL_AGENT.EVENT_SUBSCRIBE,defaultErrorMessageArgs:[e]});this._eventEmitter.on(e,i)}off(e,i){if(e!=="incomingCall"&&e!=="callsUpdated"&&e!=="connectionStateChanged")throw new Oe({defaultError:we.CALL_AGENT.EVENT_UNSUBSCRIBE,defaultErrorMessageArgs:[e]});this._eventEmitter.off(e,i)}createCall(e,i){if(!this.tsStack)throw new Oe({defaultError:we.CALL_AGENT.STACK_NOT_INIT});let r,o,l,d=e?.teamsCallContext?.threadId,h=!1;const p=e?.teamsCallContext?.meetingLink,g=e?.teamsCallContext?.meetingId,f=e?.teamsCallContext?.passcode||"",y=!!e?.participants&&Array.isArray(e?.participants)&&e?.participants.length>1;if(this.isCteUser()&&y&&(d=(e?.startCallOptions).threadId),!_B(this.acsProxy,this.acsCustomRelayManager,!0))throw new Oe({defaultError:we.CALL_AGENT.PROXY_CUSTOM_TURN_FORBIDDEN});if(p)if(D5e(p))o=$pe(p);else{if(!L5e(p,this.logger))throw new Oe({defaultError:we.CALL_AGENT.INVALID_MEETING_LINK});if(O5e(p.trim().toLocaleLowerCase(),wt().calling.tfl.hosts))throw new Oe({defaultError:we.CALL_AGENT.UNSUPPORTED_TFL_MEETING_JOIN});h=!0}e?.teamsCallContext?.threadId&&e?.teamsCallContext?.organizerId&&e?.teamsCallContext?.tenantId&&(o={threadId:e?.teamsCallContext?.threadId,messageId:e?.teamsCallContext?.messageId?e?.teamsCallContext?.messageId.toString():"0",organizerId:e?.teamsCallContext?.organizerId,tenantId:e?.teamsCallContext?.tenantId}),o&&(l={meetingType:o.messageId==="0"?1:2,tenantId:o.tenantId,organizerId:o.organizerId,replyChainMessageId:o.messageId},d=o.threadId,r=o.messageId);const T=e?.startCallOptions?.onBehalfOfOptions,C=T?.userId;let E;if(C){if((e?.startCallOptions).customContext)throw new Oe({defaultError:we.FEATURES.ONE_PHONE_SYSTEM.CUSTOM_CONTEXT_NOT_SUPPORTED});if(xx(C))E=Bx(C);else{if(!HL(C))throw new Oe({defaultError:we.IDENTIFIER.INVALID_COMM_USER});if(!wt().calling.sharedLineAppearance.enabled)throw new Oe({defaultError:we.FEATURES.SHAREDLINE_APPEARANCE.DISABLED});if(!this.getUserPolicy()?.teamsCallingPolicy?.allowDelegation)throw new Oe({defaultError:we.FEATURES.SHAREDLINE_APPEARANCE.DISABLED_BY_CALLING_POLICY});E=Bx(C)}}const I={threadId:d||"",messageId:r||"",meetingInfo:l,mediaPeerType:2,onBehalfOf:E},w=$v(this._tsCallRegistry),D=fd(),F=ln(),x=ln();if(w){const B=l4();return(async()=>{let L;L=g?await this._tsCallRegistry.createCallAsync({callId:F,localParticipantId:x,causeId:D,type:"MeetingData",meetingData:{meetingCode:g,passcode:f,threadId:d}}):h?await this._tsCallRegistry.createCallAsync({callId:F,localParticipantId:x,causeId:D,type:"MeetingData",meetingData:{meetingUrl:p}}):await this._tsCallRegistry.createCallAsync({callId:F,localParticipantId:x,causeId:D,type:"ThreadId",threadId:d||"",messageId:r});const z=new wk({callId:F},this,L,this._telemetryLogManager);B.setTarget(z),this.addToCallArray(B),this.handleCallState(B);const H=ug();z.startCallInternal(e?.startCallOptions,!!g,e?.teamsCallContext,I,i,H,e?.participants).catch(nh),await Promise.all(z.bindTsCall()),await H.promise,this._eventEmitter.emit("callsUpdated",{added:[B],removed:[]})})().catch(L=>{}),B}{let B;B=g?this._tsCallRegistry.createCallWithMeetingData({meetingCode:g,passcode:f,threadId:d},F,x,D):h?this._tsCallRegistry.createCallWithMeetingData({meetingUrl:p},F,x,D):this._tsCallRegistry.createCall(d||"",F,x,r,D);const L=new wk({callId:F},this,B,this._telemetryLogManager);return this.addToCallArray(L),this.handleCallState(L),L.startCallInternal(e?.startCallOptions,!!g,e?.teamsCallContext,I,i,void 0,e?.participants).catch(nh),L.bindTsCall(),this._eventEmitter.emit("callsUpdated",{added:[L],removed:[]}),L}}assertParticipants(e){cBe(e,we.CALL_AGENT.USERIDS_MUST_BE_OBJECTS),lBe(e,we.CALL_AGENT.USERIDS_CANNOT_BE_NULL)}assertCallContext(e){if(!e||this.checkForAtLeastOneValidCallConfig(e)||this.checkForInvalidTeamsMeetingCoordinates(e))throw new Oe({defaultError:we.CALL_AGENT.INVALID_JOIN_LOCATOR})}checkForAtLeastOneValidCallConfig(e){return!e.threadId&&!e.meetingLink&&!e.meetingId}checkForInvalidTeamsMeetingCoordinates(e){return!e.threadId&&e.tenantId&&e.organizerId||e.threadId&&(e.organizerId&&!e.tenantId||!e.organizerId&&e.tenantId)}isAcsToTeamsInteropCall(e){let i=!1;return this.isCteUser()&&(Array.isArray(e)?e.length>=1&&e.find(r=>qw(r))&&(i=!0):qw(e)&&(i=!0)),i}}jE.teamsCallAgents=new Map,mge([sg(OA.StartCall),SP("design:type",Function),SP("design:paramtypes",[Object,Object]),SP("design:returntype",Object)],jE.prototype,"startCall",null),mge([sg(OA.Join),SP("design:type",Function),SP("design:paramtypes",[Object,Object]),SP("design:returntype",Object)],jE.prototype,"join",null),mge([to(OA.Dispose),SP("design:type",Function),SP("design:paramtypes",[]),SP("design:returntype",Promise)],jE.prototype,"dispose",null);class $Ht{constructor(){this._proxyInUse=!1;const e=zf("ACS-calling");this.logger=new rh(e,[()=>"AcsProxy"])}get proxyInUse(){return this._proxyInUse}set proxyInUse(e){this._proxyInUse=e}get proxyUrl(){return this._proxyUrl?.toString()||""}set proxyUrl(e){if(e.length<4)throw new Oe({defaultError:we.CALL_CLIENT.PROXY_SHORT_URL});e.slice(-1)!=="/"&&(e=e.concat("","/"));try{const i=new URL(e);if(i.protocol!=="https:"&&i.protocol!=="http:")throw new Oe({defaultError:we.CALL_CLIENT.PROXY_PROTOCOL});this._proxyUrl=i}catch(i){const r=new Oe({defaultError:we.CALL_CLIENT.SETUP_PROXY,defaultErrorMessageArgs:[e],originalError:i});throw this.logger.error(r.message),r}}hasProxyUrl(){return!!this._proxyUrl}proxyfyUrl(e){let i=e;if(!this._proxyUrl)return this.logger.info(`Proxy url not defined, return original ${fhe(i)}`),i;try{const r=new URL(i);i=`${`${r.protocol}//${this._proxyUrl.host}${this._proxyUrl.pathname}`}${r.host}${r.pathname}${r.search}`,this.logger.info(`Proxyfing url from ${fhe(r)} to ${fhe(i)}`)}catch(r){const o=`Failed proxyfy url with error: ${JSON.stringify(r)}, returning original`;this.logger.error(o)}return this._proxyInUse=!0,i}}class HHt{constructor(){this._hasCustomRelay=!1,this._customRelayManagerInUse=!1;const e=zf("ACS-calling");this._logger=new rh(e,[()=>"AcsCustomRelayManager"])}getRelayConfig(){return this._relayConfig}setRelayConfig(e){this._relayConfig={...e},this._logger.info("Custom relay config provided"),this._hasCustomRelay=!0,this._createTsRelayManager()}get hasRelayConfig(){return this._hasCustomRelay}get customRelayManagerInUse(){return this._customRelayManagerInUse}set customRelayManagerInUse(e){this._customRelayManagerInUse=e}getTsRelayManager(){return this._tsRelayManager}_createTsRelayManager(){if(!this._hasCustomRelay||!this._relayConfig||this._relayConfig.iceServers.length<1)return void this._logger.warn("No relay config provided. No op.");const e=[];this._relayConfig.iceServers.forEach(i=>{i.urls.forEach(r=>{const o=this._getIndividualRelay(r,i?.username,i?.credential);e.push(o)})}),this._tsRelayManager={initialize(){},queryRelaysAsync:i=>Promise.resolve(e)}}_getIndividualRelay(e,i,r){const l=[],d=[],h=[R6.turn,R6.turns,R6.stun],p=[vk.tcp,vk.tls,vk.udp];let g;try{g=new URL(e)}catch(w){throw new Oe({defaultError:we.CALL_CLIENT.RELAY_INFO,defaultErrorMessageArgs:[e],originalError:w})}const f=g.protocol.replace(":","");if(!h.includes(f))throw new Oe({defaultError:we.CALL_CLIENT.RELAY_UNRECOGNIZED_SCHEMA});let y,T="";try{T=g.href.replace(/((turn)s?|stun):/,"https:"),y=new URL(T)}catch(w){throw new Oe({defaultError:we.CALL_CLIENT.RELAY_INFO,defaultErrorMessageArgs:[T],originalError:w})}let C=y.searchParams.get("transport")??"";p.includes(C)||(this._logger.warn(`Unknown transport protocol detected for the provided turn, defaulting to ${vk.udp}`),C=vk.udp);let E=y.port===""?this._extractPortFromUrl(g):Number(y.port);E||(this._logger.warn("Could not read port from relay url, defaulting to 3478"),E=3478);let I=y.hostname;return Ixt(I)?l.push(I):d.push(I),{addresses:l,udpPort:C===vk.udp?E:void 0,tcpPort:C===vk.tcp?E:void 0,tlsPort:C===vk.tls?E:void 0,username:i??"",password:r??"",type:"turn",fqdns:d}}_extractPortFromUrl(e){const i=e.href.match(yxt)?.[0];return Number(i?.replace(":",""))}}var U3e,YB=function(t,e,i,r){var o,l=arguments.length,d=l<3?e:r===null?r=Object.getOwnPropertyDescriptor(e,i):r;if(typeof Reflect=="object"&&typeof Reflect.decorate=="function")d=Reflect.decorate(t,e,i,r);else for(var h=t.length-1;h>=0;h--)(o=t[h])&&(d=(l<3?o(d):l>3?o(e,i,d):o(e,i))||d);return l>3&&d&&Object.defineProperty(e,i,d),d},$m=function(t,e){if(typeof Reflect=="object"&&typeof Reflect.metadata=="function")return Reflect.metadata(t,e)};let jHt=1;class kk{get callAgent(){return this._callAgent}get teamsCallAgent(){return this._teamsCallAgent}get sdkDiagnosticInformation(){return this._sdkDiagnosticInformation}get telemetryLogManager(){return this._telemetryLogManager}setCallAgent(e){this._callAgent=e}setTeamsCallAgent(e){this._teamsCallAgent=e}on(e,i){this._eventEmitter.on(e,i)}off(e,i){this._eventEmitter.off(e,i)}constructor(e){this._customProxyAndTurnInformation={proxy:null,turn:null},this.sendTelemetry=()=>{try{if(wt().telemetry.telemetryBeforeUnload&&this._callAgent&&this._callAgent._calls)for(const l of this._callAgent._calls)l.tsCall.sendLastKnownStats()}catch(l){this.logger.debug("Error logging telemetry",l)}},this.handleVisibilityChange=()=>{document.visibilityState==="hidden"?(this.logger.debug("Visibility changed to hidden"),this.sendPageVisibilityInfoEvent("visibilityChange",!0),this.hangupCalls()):(this.logger.debug("Visibility changed to visible"),this.sendPageVisibilityInfoEvent("visibilityChange",!1))},this.handlePageShow=()=>{this.logger.debug("Page show"),this.sendPageVisibilityInfoEvent("pageShow",!0)},this.handlePageHide=()=>{this.logger.debug("Page hide"),this.sendPageVisibilityInfoEvent("pageHide",!1)},this.handleOrientationChange=()=>{this.logger.debug(`Orientation changed to ${screen.orientation.type}`),this.sendOrientationChangeEvent(screen.orientation.type)},this.getOrientationBasedOnWindowSize=()=>window.innerHeight>window.innerWidth?"portrait-primary":"landscape-primary",this.handleResize=()=>{const l=this.getOrientationBasedOnWindowSize();this._previousOrientation!==l&&(this._previousOrientation=l,this.sendOrientationChangeEvent(l))};const i=+new Date;this.clientId=ln();const r=e?.logger||zf("ACS-calling"),o=jHt++;if(this._acsProxy=new $Ht,this._acsCustomRelayManager=new HHt,e?.networkConfiguration){e.networkConfiguration.proxy?.url&&(this._customProxyAndTurnInformation.proxy={...e.networkConfiguration.proxy},this._acsProxy.proxyUrl=this._customProxyAndTurnInformation.proxy.url),e.networkConfiguration.turn&&(this._customProxyAndTurnInformation.turn={...e.networkConfiguration.turn},this._acsCustomRelayManager.setRelayConfig(this._customProxyAndTurnInformation.turn));const l=this.getTelemetryTag();e.diagnostics?e.diagnostics.tags?e.diagnostics.tags.push(l):e.diagnostics.tags=[l]:e.diagnostics={tags:[l]}}this.logger=new rh(r,[()=>`CallClient${o}[${this.clientId}]`]),this._eventEmitter=new qf(this.logger),this._sdkDiagnosticInformation=Bxt(uk(),this.logger,e),this.diagnosticOptions=e?.diagnostics,this.firstPartyOptions=e?.firstPartyOptions,this._telemetryLogManager=new ib(this.logger,this._sdkDiagnosticInformation,this._acsProxy,this._acsCustomRelayManager);try{this.sendCallClientInitEvent({eventName:vi.acs_calling_call_client_init,kindOfEvent:"attempt",timestampInfo:"",additionalDetails:""}),Object.defineProperty(globalThis,dhe,{value:o,writable:!0,enumerable:!1}),o===1&&Object.defineProperty(globalThis,che,{value:this._telemetryLogManager,writable:!1,enumerable:!1}),this.logger.info("created"),this._callStack=new h4(this.logger,this.clientId,this._telemetryLogManager,this._sdkDiagnosticInformation,this._acsProxy,this._acsCustomRelayManager,this.firstPartyOptions?.encodedStreamsJsPath),this._deviceManager=new yP(this.logger,this._callStack,this._telemetryLogManager),this._previousOrientation="",this.sendInitialOrientation(),window.addEventListener("beforeunload",this.sendTelemetry),window.addEventListener("visibilitychange",this.handleVisibilityChange,!1),window.addEventListener("pageshow",this.handlePageShow,!1),window.addEventListener("pagehide",this.handlePageHide,!1),screen.orientation?screen.orientation.addEventListener("change",this.handleOrientationChange):window.addEventListener("resize",this.handleResize,!1),this._extensibleApi=new M6(this.logger,{callClient:this},{callClient:this,telemetryLogManager:this._telemetryLogManager});const l=Hpe(IO.CallClientFeature);for(const d of l)d.activationOptions.activationEvent==="OnExtendedObjectConstructor"&&this.feature(d);this.sendCallClientInitEvent({eventName:vi.acs_calling_call_client_init,kindOfEvent:"success",timestampInfo:{deltaTimeInMs:+new Date-i},additionalDetails:""})}catch(l){const d=new Oe({defaultError:we.CALL_CLIENT.INIT_CALL_CLIENT,originalError:l});throw this.sendCallClientInitEvent({eventName:vi.acs_calling_call_client_init,kindOfEvent:"failure",timestampInfo:{deltaTimeInMs:+new Date-i},additionalDetails:{failureReason:d.message,code:d.code,subCode:d.subCode,...an(d)}}),d}}createInstance(e){return new kk(e)}get acsProxy(){return this._acsProxy}get acsCustomRelayManager(){return this._acsCustomRelayManager}getSDKVersion(){return uk()}feature(e){return this._extensibleApi.getApiObjectInstance(e.callClientApiCtor)}async createCallAgent(e,i){const{identityMri:r}=await R3(e);if(this._callAgent?._caConfigBag?.identityMri===r)return this._callAgent;if((this._callAgent||this._teamsCallAgent)&&oP(we.CALL_CLIENT.ONE_CALL_AGENT_PER_CALL_CLIENT,this.logger),this._callAgent=JC.callAgents.get(r),this._callAgent)return this._callAgent.onDisposed(()=>{this._callAgent=void 0}),this._eventEmitter.emit("callAgentCreated"),this._callAgent;this.validateEmergencyCountryCode(i);try{return this._callAgent=new JC(this,this.logger,this._callStack,this.clientId,this._telemetryLogManager,this._deviceManager,i),await this._callAgent.initialize(e,i),this._callAgent.onDisposed(()=>{this._callAgent=void 0}),this._eventEmitter.emit("callAgentCreated"),this._callAgent}catch(o){throw this._callAgent=void 0,new Oe({defaultError:we.CALL_CLIENT.CREATE_CALL_AGENT,originalError:o})}}async createTeamsCallAgent(e,i){const{identityMri:r}=await R3(e);if(this._teamsCallAgent?._caConfigBag?.identityMri===r)return this._teamsCallAgent;if((this._callAgent||this._teamsCallAgent)&&oP(we.CALL_CLIENT.ONE_CALL_AGENT_PER_CALL_CLIENT,this.logger),this._teamsCallAgent=jE.teamsCallAgents.get(r),this._teamsCallAgent)return this._teamsCallAgent.onDisposed(()=>{this._teamsCallAgent=void 0}),this._eventEmitter.emit("teamsCallAgentCreated"),this._teamsCallAgent;try{return this._teamsCallAgent=new jE(this,this.logger,this._callStack,this.clientId,this._telemetryLogManager,this._deviceManager),await this._teamsCallAgent.initialize(e,i),this._teamsCallAgent.onDisposed(()=>{this._teamsCallAgent=void 0}),this._eventEmitter.emit("teamsCallAgentCreated"),this._teamsCallAgent}catch(o){throw this._teamsCallAgent=void 0,new Oe({defaultError:we.CALL_CLIENT.CREATE_TEAMS_CALL_AGENT,originalError:o})}}async getDeviceManager(){return await this._deviceManager.getDeviceManager(),this._deviceManager}async getEnvironmentInfoInternal(){return this._environmentInfos||(await this._callStack.createStackBase(),this._environmentInfos=H5e()),this._environmentInfos}validateEmergencyCountryCode(e){e?.emergencyCallOptions?.countryCode&&e.emergencyCallOptions?.countryCode.length>ZNt&&oP(we.CALL_CLIENT.EMERGENCY_CODE_TOO_LONG,this.logger)}sendOrientationChangeEvent(e,i=!1){if(this._callAgent?._calls?.length)try{this._telemetryLogManager.sendEvent({name:vi.acs_calling_orientation_changed,tenant:Wr,properties:{orientation:e,isInitial:i}})}catch{this.logger.debug("Unable to send orientation change telemetry")}}sendInitialOrientation(){let e=screen.orientation&&screen.orientation.type;e||(e=this.getOrientationBasedOnWindowSize()),this.sendOrientationChangeEvent(e,!0)}sendCallClientInitEvent(e){try{this._telemetryLogManager.sendEvent({name:e.eventName,tenant:Wr,properties:e})}catch{this.logger.debug("Unable to send CallClient initialized telemetry event")}}hangupCalls(){try{$A().formFactor==="Mobile"&&wt().calling.hangUpCallOnPageHide&&this._callAgent?.calls.forEach(e=>e.hangUp())}catch(e){try{this.logger.error(`Unable to hangup call on page hide due to ${JSON.stringify(e)}`)}catch{this.logger.error("Unable to hangup call on page hide due to unknown error")}}}sendPageVisibilityInfoEvent(e,i){if(this._callAgent?._calls?.length)try{this._telemetryLogManager.sendEvent({name:vi.acs_calling_page_hidden,tenant:Wr,properties:{eventName:e,pageHidden:i}})}catch{this.logger.debug("Unable to send page hide telemetry")}}getTelemetryTag(){return this._customProxyAndTurnInformation.proxy&&this._customProxyAndTurnInformation.turn?aP.usedProxyAndNonMsftTurn:this._customProxyAndTurnInformation.proxy?aP.onlyUsedProxy:this._customProxyAndTurnInformation.turn?aP.onlyUsedNonMsftTurn:""}}YB([zv,$m("design:type",Object)],kk.prototype,"logger",void 0),YB([sg(yO.GetSDKVersion),$m("design:type",Function),$m("design:paramtypes",[]),$m("design:returntype",String)],kk.prototype,"getSDKVersion",null),YB([sg(yO.Feature),$m("design:type",Function),$m("design:paramtypes",[Object]),$m("design:returntype",typeof(U3e=typeof TFeature<"u"&&TFeature)=="function"?U3e:Object)],kk.prototype,"feature",null),YB([to(yO.CreateCallAgent),$m("design:type",Function),$m("design:paramtypes",[Object,Object]),$m("design:returntype",Promise)],kk.prototype,"createCallAgent",null),YB([to(yO.CreateTeamsCallAgent),$m("design:type",Function),$m("design:paramtypes",[Object,Object]),$m("design:returntype",Promise)],kk.prototype,"createTeamsCallAgent",null),YB([to(yO.GetDeviceManager),$m("design:type",Function),$m("design:paramtypes",[]),$m("design:returntype",Promise)],kk.prototype,"getDeviceManager",null),YB([to(yO.GetEnvironmentInfo),$m("design:type",Function),$m("design:paramtypes",[]),$m("design:returntype",Promise)],kk.prototype,"getEnvironmentInfoInternal",null);var z3e=function(t,e,i,r){function o(l){return l instanceof i?l:new i(function(d){d(l)})}return new(i||(i=Promise))(function(l,d){function h(f){try{g(r.next(f))}catch(y){d(y)}}function p(f){try{g(r.throw(f))}catch(y){d(y)}}function g(f){f.done?l(f.value):o(f.value).then(h,p)}g((r=r.apply(t,e||[])).next())})};const HA=t=>!!t&&!["None","Disconnected","Connecting","Ringing","EarlyMedia","Disconnecting"].includes(t),g4=t=>!!t&&["Connecting","Ringing","InLobby","EarlyMedia"].includes(t),c8=t=>{var e;return((e=t.unparentedViews[0])===null||e===void 0?void 0:e.view)!==void 0},V3e=t=>z3e(void 0,void 0,void 0,function*(){const e=t.getState().deviceManager.unparentedViews;for(const i of e)yield t.disposeView(void 0,void 0,i)}),fge=t=>t?GHt(e=>Object.values(t).map(i=>{const r=Ga(i.identifier);return e(r,i)})):[],GHt=WH((t,e)=>Vf(e.identifier)?Object.assign(Object.assign({},e),{displayName:e.identifier.phoneNumber}):e),qHt=t=>t.every(e=>!qw(e)),$3e=t=>Vf(t.identifier)&&t.state==="Connecting"?"Ringing":t.state,H3e=(t,e,i,r)=>{let o=t;return r&&i&&i==="Attendee"&&(e&&e==="Attendee"&&(o="{AttendeeRole}"),e&&(e==="Presenter"||e==="Co-organizer"||e==="Organizer")&&(o=`{AttendeeRole}(${t})`)),o},j3e=t=>z3e(void 0,void 0,void 0,function*(){const e=yield t?.getState().deviceManager.selectedCamera;if(e)return new kp(e)}),d8=(t,e)=>{if(!t.calls[e]){if(t.callsEnded[e])return;throw new Error(`Call Not Found: ${e}`)}return t.calls[e]},WHt=Xs([ckt,rce,B5,nj,ij,Ux],(t,e,i,r,o,l)=>{const d=i.deviceAccess?i.deviceAccess.audio:!0,h=r?.unmuteMic.isPresent===!1&&r?.unmuteMic.reason!=="NotInitialized"||o==="Consumer";return{disabled:!t||!d||h||l==="LocalHold",checked:t?!e:!1,microphones:i.microphones,speakers:i.speakers,selectedMicrophone:i.selectedMicrophone,selectedSpeaker:i.selectedSpeaker}}),KHt=Xs([RDe,B5,nj,ij,Ux],(t,e,i,r,o)=>{const l=c8(e),d=t?.find(g=>g.mediaStreamType==="Video"),h=e.deviceAccess?e.deviceAccess.video:!0,p=i?.turnVideoOn.isPresent===!1&&i?.turnVideoOn.reason!=="NotInitialized"||r==="Consumer";return{disabled:!e.selectedCamera||!h||!e.cameras.length||p||o==="LocalHold",checked:t!==void 0&&t.length>0?!!d:l,cameras:e.cameras,selectedCamera:e.selectedCamera}}),JHt=Xs([ice,Ux],(t,e)=>{var i;return{checked:!!t,disabled:e==="InLobby"?!0:(i=e==="Connecting")!==null&&i!==void 0?i:!1}}),YHt=Xs([nce,Ux],(t,e)=>({checked:!!t,disabled:e!=="Connected"})),QHt=Xs([ace,Ux,nj,ij],(t,e,i,r)=>{let o;return o=o||i?.shareScreen.isPresent===!1&&i?.shareScreen.reason!=="NotInitialized"||r==="Consumer"||r==="Attendee",o=o||["InLobby","Connecting","LocalHold"].includes(e??"None"),{checked:t,disabled:o}}),ZHt=Xs([B5],t=>({microphones:vge(t.microphones),speakers:vge(t.speakers),cameras:vge(t.cameras),selectedMicrophone:t.selectedMicrophone,selectedSpeaker:t.selectedSpeaker,selectedCamera:t.selectedCamera}));function vge(t){return t.filter(e=>e.name!=="")}const XHt=Xs([Ux],t=>({checked:t==="LocalHold"}));var G3e=Number.isNaN||function(e){return typeof e=="number"&&e!==e};function ejt(t,e){return!!(t===e||G3e(t)&&G3e(e))}function tjt(t,e){if(t.length!==e.length)return!1;for(var i=0;i<t.length;i++)if(!ejt(t[i],e[i]))return!1;return!0}function ob(t,e){e===void 0&&(e=tjt);var i,r=[],o,l=!1;function d(){for(var h=[],p=0;p<arguments.length;p++)h[p]=arguments[p];return l&&i===this&&e(h,r)||(o=t.apply(this,h),l=!0,i=this,r=h),o}return d}var Vo=function(t,e,i,r){function o(l){return l instanceof i?l:new i(function(d){d(l)})}return new(i||(i=Promise))(function(l,d){function h(f){try{g(r.next(f))}catch(y){d(y)}}function p(f){try{g(r.throw(f))}catch(y){d(y)}}function g(f){f.done?l(f.value):o(f.value).then(h,p)}g((r=r.apply(t,e||[])).next())})};const q3e=(t,e)=>!!t&&!!e&&t.source.id===e.source.id,W3e=ob((t,e,i,r)=>{const o=()=>Vo(void 0,void 0,void 0,function*(){yield V3e(t);const $t=i?.id;let dt=t.getState().deviceManager.selectedCamera;if(!dt){const kt=yield e?.getCameras();dt=kt&&kt.length>0?kt[0]:void 0,dt&&e?.selectCamera(dt)}if(!$t||!dt)return;const yt=new kp(dt);i&&!i.localVideoStreams.find(kt=>q3e(kt,yt))&&(yield i.startVideo(yt))}),l=$t=>Vo(void 0,void 0,void 0,function*(){i?.id&&i&&i.localVideoStreams.find(yt=>q3e(yt,$t))&&(yield i.stopVideo($t))}),d=$t=>Vo(void 0,void 0,void 0,function*(){const dt=c8(t.getState().deviceManager);if(i&&(HA(i.state)||g4(i.state))){const yt=i.localVideoStreams.find(je=>je.mediaStreamType==="Video"),kt=t.getState().deviceManager.unparentedViews;yt||kt.length>0?(kt&&(yield kt.forEach(je=>je.mediaStreamType==="Video"&&t.disposeView(void 0,void 0,je))),yt&&(yield l(yt))):yield o()}else{const yt=t.getState().deviceManager.selectedCamera;yt&&(dt?yield Z():yield t.createView(void 0,void 0,{source:yt,mediaStreamType:"Video"},$t))}}),h=$t=>Vo(void 0,void 0,void 0,function*(){if(e)return e.selectMicrophone($t)}),p=$t=>Vo(void 0,void 0,void 0,function*(){if(e)return e.selectSpeaker($t)}),g=($t,dt)=>Vo(void 0,void 0,void 0,function*(){if(e)if(i&&HA(i.state)){e.selectCamera($t);const yt=i.localVideoStreams.find(kt=>kt.mediaStreamType==="Video");yield yt?.switchSource($t),yield Promise.all([yt?.getMediaStream(),new Promise(kt=>setTimeout(kt,1e3))])}else{if(!c8(t.getState().deviceManager)){e.selectCamera($t);return}yield Z(),e.selectCamera($t),yield t.createView(void 0,void 0,{source:$t,mediaStreamType:"Video"},dt)}}),f=()=>Vo(void 0,void 0,void 0,function*(){var $t;return yield($t=i?.feature(Ma.RaiseHand))===null||$t===void 0?void 0:$t.raiseHand()}),y=()=>Vo(void 0,void 0,void 0,function*(){var $t;return yield($t=i?.feature(Ma.RaiseHand))===null||$t===void 0?void 0:$t.lowerHand()}),T=()=>Vo(void 0,void 0,void 0,function*(){const $t=i?.feature(Ma.RaiseHand),dt=t.getState().userId;$t?.getRaisedHands().find(kt=>Ga(kt.identifier)===Ga(dt))?yield $t?.lowerHand():yield $t?.raiseHand()}),C=$t=>Vo(void 0,void 0,void 0,function*(){var dt;$t==="like"||$t==="applause"||$t==="heart"||$t==="laugh"||$t==="surprised"?yield(dt=i?.feature(Ma.Reaction))===null||dt===void 0?void 0:dt.sendReaction({reactionType:$t}):console.warn(`Can not recognize ${$t} as meeting reaction`)}),E=()=>Vo(void 0,void 0,void 0,function*(){if(!i||!(HA(i.state)||g4(i.state)))throw new Error("Please invoke onToggleMicrophone after call is started");return i.isMuted?yield i.unmute():yield i.mute()}),I=()=>Vo(void 0,void 0,void 0,function*(){return yield i?.startScreenSharing()}),w=()=>Vo(void 0,void 0,void 0,function*(){return yield i?.stopScreenSharing()}),D=()=>Vo(void 0,void 0,void 0,function*(){return i?.isScreenSharingOn?yield w():yield I()}),F=$t=>Vo(void 0,void 0,void 0,function*(){return yield i?.hangUp({forEveryone:$t===!0})}),x=()=>Vo(void 0,void 0,void 0,function*(){return i?.state==="LocalHold"?yield i?.resume():yield i?.hold()}),B=(...$t)=>Vo(void 0,[...$t],void 0,function*(dt={scalingMode:"Crop",isMirrored:!0}){if(!i||i.localVideoStreams.length===0)return;const yt=t.getState().calls[i.id];if(!yt)return;const kt=yt.localVideoStreams.find(xe=>xe.mediaStreamType==="Video"),je=yt.localVideoStreams.find(xe=>xe.mediaStreamType==="ScreenSharing");let Ae;return kt&&!kt.view&&(Ae=yield t.createView(i.id,void 0,kt,dt)),je&&!je.view&&i.isScreenSharingOn&&(Ae=yield t.createView(i.id,void 0,je,{scalingMode:"Fit"})),Ae?.view?{view:Ae?.view}:void 0}),L=($t,...dt)=>Vo(void 0,[$t,...dt],void 0,function*(yt,kt={scalingMode:"Crop"}){if(!i)return;const je=d8(t.getState(),i.id);if(!je)return;const Ae=Object.values(je.remoteParticipants).find(Fe=>Ga(Fe.identifier)===yt);if(!Ae||!Ae.videoStreams)return;const xe=Object.values(Ae.videoStreams).findLast(Fe=>Fe.mediaStreamType==="Video"&&Fe.isAvailable)||Object.values(Ae.videoStreams).findLast(Fe=>Fe.mediaStreamType==="Video"),gt=Object.values(Ae.videoStreams).findLast(Fe=>Fe.mediaStreamType==="ScreenSharing"&&Fe.isAvailable)||Object.values(Ae.videoStreams).findLast(Fe=>Fe.mediaStreamType==="ScreenSharing");let Ye;return xe&&xe.isAvailable&&!xe.view&&(Ye=yield t.createView(i.id,Ae.identifier,xe,kt)),gt&&gt.isAvailable&&!gt.view&&(Ye=yield t.createView(i.id,Ae.identifier,gt,{scalingMode:"Fit"})),Ye?.view?{view:Ye?.view}:void 0}),z=$t=>Vo(void 0,void 0,void 0,function*(){if(!i)return;const dt=d8(t.getState(),i.id);if(!dt)return;const yt=Object.values(dt.remoteParticipants).find(Ae=>Ga(Ae.identifier)===$t);if(!yt||!yt.videoStreams)return;const kt=Object.values(yt.videoStreams).find(Ae=>Ae.mediaStreamType==="Video"),je=Object.values(yt.videoStreams).find(Ae=>Ae.mediaStreamType==="ScreenSharing");kt&&kt.view&&t.disposeView(i.id,yt.identifier,kt),je&&je.view&&t.disposeView(i.id,yt.identifier,je)}),H=$t=>Vo(void 0,void 0,void 0,function*(){if(!i)return;const dt=d8(t.getState(),i.id);if(!dt)return;const yt=Object.values(dt.remoteParticipants).find(je=>Ga(je.identifier)===$t);if(!yt||!yt.videoStreams)return;const kt=Object.values(yt.videoStreams).filter(je=>je.mediaStreamType==="Video");for(const je of kt)je.view&&t.disposeView(i.id,yt.identifier,je)}),j=$t=>Vo(void 0,void 0,void 0,function*(){if(!i)return;const dt=d8(t.getState(),i.id);if(!dt)return;const yt=Object.values(dt.remoteParticipants).find(je=>Ga(je.identifier)===$t);if(!yt||!yt.videoStreams)return;const kt=Object.values(yt.videoStreams).filter(je=>je.mediaStreamType==="ScreenSharing");for(const je of kt)je.view&&t.disposeView(i.id,yt.identifier,je)}),J=()=>Vo(void 0,void 0,void 0,function*(){if(!i)return;const $t=d8(t.getState(),i.id);if(!$t)return;const dt=$t?.localVideoStreams.find(yt=>yt.mediaStreamType==="ScreenSharing");dt&&dt.view&&t.disposeView(i.id,void 0,dt)}),Z=()=>Vo(void 0,void 0,void 0,function*(){const $t=i&&t.getState().calls[i.id],dt=$t?.localVideoStreams.find(yt=>yt.mediaStreamType==="Video");i&&$t&&dt&&t.disposeView(i.id,void 0,dt),yield V3e(t)}),re=$t=>Vo(void 0,void 0,void 0,function*(){return yield i?.sendDtmf($t)}),ne=()=>{throw new Error("Not implemented, cannot call a method from an abstract object")},le=()=>Vo(void 0,void 0,void 0,function*(){const $t=i?.localVideoStreams.find(dt=>dt.mediaStreamType==="Video")||e?.getUnparentedVideoStreams().find(dt=>dt.mediaStreamType==="Video");if($t){if(r?.onResolveVideoBackgroundEffectsDependency)return $t.feature(Ma.VideoEffects).stopEffects();throw new Error("Video background effects dependency not resolved")}}),he=$t=>Vo(void 0,void 0,void 0,function*(){var dt;const yt=i?.localVideoStreams.find(kt=>kt.mediaStreamType==="Video")||e?.getUnparentedVideoStreams().find(kt=>kt.mediaStreamType==="Video");if(yt){if(!r?.onResolveVideoBackgroundEffectsDependency)throw new Error("Video background effects dependency not resolved");const kt=r?.onResolveVideoBackgroundEffectsDependency&&((dt=yield r.onResolveVideoBackgroundEffectsDependency())===null||dt===void 0?void 0:dt.createBackgroundBlurEffect);return kt&&yt.feature(Ma.VideoEffects).startEffects(kt($t))}}),Me=$t=>Vo(void 0,void 0,void 0,function*(){var dt;const yt=i?.localVideoStreams.find(kt=>kt.mediaStreamType==="Video")||e?.getUnparentedVideoStreams().find(kt=>kt.mediaStreamType==="Video");if(yt){if(!r?.onResolveVideoBackgroundEffectsDependency)throw new Error("Video background effects dependency not resolved");const kt=r?.onResolveVideoBackgroundEffectsDependency&&((dt=yield r.onResolveVideoBackgroundEffectsDependency())===null||dt===void 0?void 0:dt.createBackgroundReplacementEffect);return kt&&yt.feature(Ma.VideoEffects).startEffects(kt($t))}}),Le=()=>Vo(void 0,void 0,void 0,function*(){var $t;const dt=r?.onResolveDeepNoiseSuppressionDependency&&(($t=yield r.onResolveDeepNoiseSuppressionDependency())===null||$t===void 0?void 0:$t.deepNoiseSuppressionEffect),yt=i?.localAudioStreams.find(kt=>kt.mediaStreamType==="Audio");if(yt&&dt&&dt.noiseSuppression){const kt=yt.feature(Ma.AudioEffects);if(yield kt.isSupported(dt.noiseSuppression))return yield kt.startEffects(dt);console.warn("Deep Noise Suppression is not supported on this platform.")}}),pe=()=>Vo(void 0,void 0,void 0,function*(){const $t=i?.localAudioStreams.find(dt=>dt.mediaStreamType==="Audio");if($t&&r?.onResolveDeepNoiseSuppressionDependency){const dt={noiseSuppression:!0};return yield $t.feature(Ma.AudioEffects).stopEffects(dt)}}),te=$t=>Vo(void 0,void 0,void 0,function*(){const dt=i?.feature(Ma.Captions).captions;yield dt?.startCaptions($t)}),Se=()=>Vo(void 0,void 0,void 0,function*(){const $t=i?.feature(Ma.Captions).captions;yield $t?.stopCaptions()}),ce=$t=>Vo(void 0,void 0,void 0,function*(){const dt=i?.feature(Ma.Captions).captions;yield dt?.setSpokenLanguage($t)}),X=$t=>Vo(void 0,void 0,void 0,function*(){yield(i?.feature(Ma.Captions).captions).setCaptionLanguage($t)}),ve=$t=>Vo(void 0,void 0,void 0,function*(){return yield i?.feature(Ma.CallSurvey).submitSurvey($t)}),Te=$t=>Vo(void 0,void 0,void 0,function*(){const dt=$t?.map(yt=>JS(yt));yield i?.feature(Ma.Spotlight).startSpotlight(dt)}),Be=$t=>Vo(void 0,void 0,void 0,function*(){const dt=$t?.map(yt=>JS(yt));yield i?.feature(Ma.Spotlight).stopSpotlight(dt)}),qe=()=>Vo(void 0,void 0,void 0,function*(){yield i?.feature(Ma.Spotlight).stopAllSpotlight()}),Ge=$t=>Vo(void 0,void 0,void 0,function*(){i?.remoteParticipants&&i?.remoteParticipants.forEach(dt=>Vo(void 0,void 0,void 0,function*(){Ga(dt.identifier)===$t&&(yield dt.mute())}))}),tt=()=>Vo(void 0,void 0,void 0,function*(){i?.muteAllRemoteParticipants()}),ct=i?.feature(Ma.Capabilities).capabilities.spotlightParticipant.isPresent,Mt=i?.feature(Ma.Capabilities).capabilities.removeParticipantsSpotlight.isPresent;return{onHangUp:F,onToggleHold:x,onSelectCamera:g,onSelectMicrophone:h,onSelectSpeaker:p,onStartScreenShare:I,onStopScreenShare:w,onToggleCamera:d,onToggleMicrophone:E,onToggleScreenShare:D,onCreateLocalStreamView:B,onCreateRemoteStreamView:L,onStartLocalVideo:o,onDisposeRemoteStreamView:z,onDisposeLocalStreamView:Z,onDisposeRemoteScreenShareStreamView:j,onDisposeLocalScreenShareStreamView:J,onDisposeRemoteVideoStreamView:H,onRaiseHand:f,onLowerHand:y,onToggleRaiseHand:T,onReactionClick:C,onAddParticipant:ne,onRemoveParticipant:ne,onStartCall:ne,onSendDtmfTone:re,onRemoveVideoBackgroundEffects:le,onBlurVideoBackground:he,onReplaceVideoBackground:Me,onStartNoiseSuppressionEffect:Le,onStopNoiseSuppressionEffect:pe,onStartCaptions:te,onStopCaptions:Se,onSetCaptionLanguage:X,onSetSpokenLanguage:ce,onSubmitSurvey:ve,onStartSpotlight:Te,onStopSpotlight:Be,onStopAllSpotlight:qe,onStartLocalSpotlight:ct?()=>Vo(void 0,void 0,void 0,function*(){yield i?.feature(Ma.Spotlight).startSpotlight()}):void 0,onStopLocalSpotlight:()=>Vo(void 0,void 0,void 0,function*(){yield i?.feature(Ma.Spotlight).stopSpotlight()}),onStartRemoteSpotlight:ct?$t=>Vo(void 0,void 0,void 0,function*(){const dt=$t?.map(yt=>JS(yt));yield i?.feature(Ma.Spotlight).startSpotlight(dt)}):void 0,onStopRemoteSpotlight:Mt?$t=>Vo(void 0,void 0,void 0,function*(){const dt=$t?.map(yt=>JS(yt));yield i?.feature(Ma.Spotlight).stopSpotlight(dt)}):void 0,onMuteParticipant:Ge,onMuteAllRemoteParticipants:tt,onAcceptCall:ne,onRejectCall:ne,onForbidAudio:$t=>Vo(void 0,void 0,void 0,function*(){const dt=$t?.map(yt=>JS(yt));yield i?.feature(Ma.MediaAccess).forbidAudio(dt)}),onPermitAudio:$t=>Vo(void 0,void 0,void 0,function*(){const dt=$t?.map(yt=>JS(yt));yield i?.feature(Ma.MediaAccess).permitAudio(dt)}),onForbidOthersAudio:()=>Vo(void 0,void 0,void 0,function*(){yield i?.feature(Ma.MediaAccess).forbidOthersAudio()}),onPermitOthersAudio:()=>Vo(void 0,void 0,void 0,function*(){yield i?.feature(Ma.MediaAccess).permitOthersAudio()}),onForbidVideo:$t=>Vo(void 0,void 0,void 0,function*(){const dt=$t?.map(yt=>JS(yt));yield i?.feature(Ma.MediaAccess).forbidVideo(dt)}),onPermitVideo:$t=>Vo(void 0,void 0,void 0,function*(){const dt=$t?.map(yt=>JS(yt));yield i?.feature(Ma.MediaAccess).permitVideo(dt)}),onForbidOthersVideo:()=>Vo(void 0,void 0,void 0,function*(){yield i?.feature(Ma.MediaAccess).forbidOthersVideo()}),onPermitOthersVideo:()=>Vo(void 0,void 0,void 0,function*(){yield i?.feature(Ma.MediaAccess).permitOthersVideo()})}});var fZ=function(t,e,i,r){function o(l){return l instanceof i?l:new i(function(d){d(l)})}return new(i||(i=Promise))(function(l,d){function h(f){try{g(r.next(f))}catch(y){d(y)}}function p(f){try{g(r.throw(f))}catch(y){d(y)}}function g(f){f.done?l(f.value):o(f.value).then(h,p)}g((r=r.apply(t,e||[])).next())})};const ijt=ob((...t)=>{const[e,i,r,o,l]=t,d=W3e(e,r,o,l);return Object.assign(Object.assign({},d),{onStartCall:(h,p)=>i?.startCall(h,p),onAddParticipant:(h,p)=>fZ(void 0,void 0,void 0,function*(){const g=JS(h);Vf(g)?o?.addParticipant(g,p):(qw(g)||HL(g))&&o?.addParticipant(g)}),onRemoveParticipant:h=>fZ(void 0,void 0,void 0,function*(){const p=JS(h);yield o?.removeParticipant(p)}),onAcceptCall:(h,p)=>fZ(void 0,void 0,void 0,function*(){const g=p?yield j3e(e):void 0,f=i?.incomingCalls.find(y=>y.id===h);f&&(yield f.accept(g?{videoOptions:{localVideoStreams:[g]}}:void 0))}),onRejectCall:h=>fZ(void 0,void 0,void 0,function*(){const p=i?.incomingCalls.find(g=>g.id===h);p&&(yield p.reject())})})});var yge=function(t,e,i,r){function o(l){return l instanceof i?l:new i(function(d){d(l)})}return new(i||(i=Promise))(function(l,d){function h(f){try{g(r.next(f))}catch(y){d(y)}}function p(f){try{g(r.throw(f))}catch(y){d(y)}}function g(f){f.done?l(f.value):o(f.value).then(h,p)}g((r=r.apply(t,e||[])).next())})};const njt=ob((t,e,i,r,o)=>Object.assign(Object.assign({},W3e(t,i,r,o)),{onStartCall:(l,d)=>{if(!qHt(l))throw new Error("CommunicationIdentifier in Teams call is not supported!");if(e)return ajt(e,l,d)},onRemoveParticipant:l=>yge(void 0,void 0,void 0,function*(){const d=JS(l);if(qw(d))throw new Error("CommunicationIdentifier in Teams call is not supported!");if(xx(d))throw new Error("Removing Microsoft Teams app identifier is not supported!");yield r?.removeParticipant(d)}),onAcceptCall:(l,d)=>yge(void 0,void 0,void 0,function*(){const h=d?yield j3e(t):void 0,p=e?.incomingCalls.find(g=>g.id===l);p&&(yield p.accept(h?{videoOptions:{localVideoStreams:[h]}}:void 0))}),onRejectCall:l=>yge(void 0,void 0,void 0,function*(){const d=e?.incomingCalls.find(h=>h.id===l);d&&(yield d.reject())})})),ajt=(t,e,i)=>{if(e.length!==1)throw new Error("Only one participant is supported in Teams call!");return t.startCall(e[0],i)},rjt=Xs([MDe,pkt,PDe,B5,Ux,DDe,Skt,Ckt],(t,e,i,r,o,l,d,h)=>{var p,g,f,y,T,C,E,I,w,D,F,x,B,L,z,H,j,J,Z;const re=[],ne=()=>l?.environment.browser==="safari",le=()=>l?.environment.platform==="mac";let he=!1;d&&d.length>0&&(he=!0),(((p=i?.network.latest.networkReceiveQuality)===null||p===void 0?void 0:p.value)===ah.Bad||((g=i?.network.latest.networkReceiveQuality)===null||g===void 0?void 0:g.value)===ah.Poor)&&(he?re.push({type:"teamsMeetingCallNetworkQualityLow"}):re.push({type:"callNetworkQualityLow"})),((f=i?.media.latest.noSpeakerDevicesEnumerated)===null||f===void 0?void 0:f.value)===!0&&re.push({type:"callNoSpeakerFound"}),((y=i?.media.latest.noMicrophoneDevicesEnumerated)===null||y===void 0?void 0:y.value)===!0&&re.push({type:"callNoMicrophoneFound"}),((T=r.deviceAccess)===null||T===void 0?void 0:T.audio)===!1&&ne()&&re.push({type:"callMicrophoneAccessDeniedSafari"}),((C=i?.media.latest.microphonePermissionDenied)===null||C===void 0?void 0:C.value)===!0&&le()?re.push({type:"callMacOsMicrophoneAccessDenied"}):(((E=r.deviceAccess)===null||E===void 0?void 0:E.audio)===!1&&!ne()||((I=i?.media.latest.microphonePermissionDenied)===null||I===void 0?void 0:I.value)===!0&&!le())&&re.push({type:"callMicrophoneAccessDenied"});const Me=i?.media.latest.microphoneMuteUnexpectedly||i?.media.latest.microphoneNotFunctioning;Me&&(Me.value===ah.Bad?re.push({type:"callMicrophoneMutedBySystem"}):Me.value===ah.Good&&re.push({type:"callMicrophoneUnmutedBySystem"}));const Le=i?.media.latest.cameraStoppedUnexpectedly;Le&&(Le.value===ah.Bad?re.push({type:"callVideoStoppedBySystem"}):Le.value===ah.Good&&re.push({type:"callVideoRecoveredBySystem"})),((w=r.deviceAccess)===null||w===void 0?void 0:w.video)===!1&&ne()?re.push({type:"callCameraAccessDeniedSafari"}):((D=r.deviceAccess)===null||D===void 0?void 0:D.video)===!1?re.push({type:"callCameraAccessDenied"}):((F=i?.media.latest.cameraFreeze)===null||F===void 0?void 0:F.value)===!0&&re.push({type:"cameraFrozenForRemoteParticipants"}),((x=i?.media.latest.cameraPermissionDenied)===null||x===void 0?void 0:x.value)===!0&&le()&&re.push({type:"callMacOsCameraAccessDenied"}),((B=i?.media.latest.screenshareRecordingDisabled)===null||B===void 0?void 0:B.value)===!0&&le()?re.push({type:"callMacOsScreenShareAccessDenied"}):((L=i?.media.latest.screenshareRecordingDisabled)===null||L===void 0?void 0:L.value)===!0&&re.push({type:"startScreenShareGeneric"}),GE(re,t,"Call.stopVideo","stopVideoGeneric"),GE(re,t,"Call.mute","muteGeneric"),GE(re,t,"Call.stopScreenSharing","stopScreenShareGeneric"),((z=t["Call.startVideo"])===null||z===void 0?void 0:z.message)==="Call.startVideo: Video operation failure SourceUnavailableError"?GE(re,t,"Call.startVideo","callCameraAlreadyInUse"):((H=t["Call.startVideo"])===null||H===void 0?void 0:H.message)==="Call.startVideo: Video operation failure permissionDeniedError"?GE(re,t,"Call.startVideo","callCameraAccessDenied"):GE(re,t,"Call.startVideo","startVideoGeneric"),GE(re,t,"Call.unmute","unmuteGeneric"),e&&!e.capabilityUnmuteMicAbsent&&!e.capabilityUnmuteMicPresent&&GE(re,t,"Call.mutedByOthers","mutedByRemoteParticipant"),GE(re,t,"VideoEffectsFeature.startEffects","unableToStartVideoEffect"),((j=t["CallAgent.join"])===null||j===void 0?void 0:j.message)==="CallAgent.join: Invalid meeting link"?GE(re,t,"CallAgent.join","failedToJoinCallInvalidMeetingLink"):GE(re,t,"CallAgent.join","failedToJoinCallGeneric"),!((J=t["Call.feature"])===null||J===void 0)&&J.message.match(/Call\.feature: startSpotlight failed\. \d+ is the max number of participants that can be Spotlighted/g)&&GE(re,t,"Call.feature","startSpotlightWhileMaxParticipantsAreSpotlighted");const pe=[];return!((Z=i?.media.latest.speakingWhileMicrophoneIsMuted)===null||Z===void 0)&&Z.value&&o==="Connected"&&pe.push({type:"speakingWhileMuted",timestamp:new Date(Date.now()),autoDismiss:!0,ariaLive:"off"}),e.assignedBreakoutRoomOpened&&pe.push({type:"assignedBreakoutRoomOpened",timestamp:e.assignedBreakoutRoomOpened.timestamp}),e.assignedBreakoutRoomOpenedPromptJoin&&h&&pe.push({type:"assignedBreakoutRoomOpenedPromptJoin",timestamp:e.assignedBreakoutRoomOpenedPromptJoin.timestamp,onClickPrimaryButton:()=>h.join()}),e.assignedBreakoutRoomChanged&&pe.push({type:"assignedBreakoutRoomChanged",timestamp:e.assignedBreakoutRoomChanged.timestamp}),e.assignedBreakoutRoomClosed&&pe.push({type:"assignedBreakoutRoomClosed",timestamp:e.assignedBreakoutRoomClosed.timestamp}),e.breakoutRoomJoined&&pe.push({type:"breakoutRoomJoined",timestamp:e.breakoutRoomJoined.timestamp}),e.breakoutRoomClosingSoon&&pe.push({type:"breakoutRoomClosingSoon",timestamp:e.breakoutRoomClosingSoon.timestamp}),e.capabilityTurnVideoOnPresent&&pe.push({type:"capabilityTurnVideoOnPresent",timestamp:e.capabilityTurnVideoOnPresent.timestamp}),e.capabilityTurnVideoOnAbsent&&pe.push({type:"capabilityTurnVideoOnAbsent",timestamp:e.capabilityTurnVideoOnAbsent.timestamp}),e.capabilityUnmuteMicPresent&&pe.push({type:"capabilityUnmuteMicPresent",timestamp:e.capabilityUnmuteMicPresent.timestamp}),e.capabilityUnmuteMicAbsent&&pe.push({type:"capabilityUnmuteMicAbsent",timestamp:e.capabilityUnmuteMicAbsent.timestamp}),{activeErrorMessages:re,activeNotifications:pe}}),GE=(t,e,i,r)=>{e[i]!==void 0&&t.push({type:r,timestamp:e[i].timestamp})},ojt=Xs([bkt,Tkt,B5],(t,e,i)=>{const r=t.map(l=>Object.assign(Object.assign({},l),{callerInfo:{displayName:l.callerInfo.displayName||"Unknown Caller"},videoAvailable:!(l.callerInfo.identifier&&Vf(l.callerInfo.identifier)||i?.cameras.length===0)})),o=e.map(l=>Object.assign(Object.assign({},l),{callerInfo:{displayName:l.callerInfo.displayName||"Unknown Caller"},videoAvailable:!(l.callerInfo.identifier&&Vf(l.callerInfo.identifier)||i?.cameras.length===0)}));return{activeIncomingCalls:r,removedIncomingCalls:o}}),sjt=Xs([lce,LDe,ODe],(t,e,i)=>({checked:t??!1,currentCaptionLanguage:e??"",currentSpokenLanguage:i??"en-us"})),ljt=Xs([vkt,LDe,ykt,ODe,lce],(t,e,i,r,o)=>({supportedCaptionLanguages:t??[],currentCaptionLanguage:e??"en",supportedSpokenLanguages:i??["en-us"],currentSpokenLanguage:r??"en-us",isCaptionsFeatureActive:o??!1})),cjt=Xs([mkt,lce,fkt,wDe,oce,sce],(t,e,i,r,o,l)=>{const d=t?.map((h,p)=>{const g=djt(h);let f;if(g===l)f=o;else if(r){const y=r[g];y&&(f=y.displayName)}return{id:(f??"Unnamed Participant")+p,displayName:f??"Unnamed Participant",captionText:h.captionText,userId:g,createdTimeStamp:h.timestamp}});return{captions:d??[],isCaptionsOn:e??!1,startCaptionsInProgress:i??!1}}),djt=t=>t.speaker.identifier?Ga(t.speaker.identifier):"";var u8=function(t,e,i,r){function o(l){return l instanceof i?l:new i(function(d){d(l)})}return new(i||(i=Promise))(function(l,d){function h(f){try{g(r.next(f))}catch(y){d(y)}}function p(f){try{g(r.throw(f))}catch(y){d(y)}}function g(f){f.done?l(f.value):o(f.value).then(h,p)}g((r=r.apply(t,e||[])).next())})};class ujt{constructor(e,i){this.setDeviceManager=()=>{this._context.setDeviceManagerIsSpeakerSelectionAvailable(this._deviceManager.isSpeakerSelectionAvailable),this._context.setDeviceManagerSelectedMicrophone(this._deviceManager.selectedMicrophone),this._context.setDeviceManagerSelectedSpeaker(this._deviceManager.selectedSpeaker)},this.subscribe=()=>{if(this._deviceManager.on("videoDevicesUpdated",this.videoDevicesUpdated),this._deviceManager.on("audioDevicesUpdated",this.audioDevicesUpdated),this._deviceManager.on("selectedMicrophoneChanged",this.selectedMicrophoneChanged),this._deviceManager.on("selectedSpeakerChanged",this.selectedSpeakerChanged),navigator.permissions){try{navigator.permissions.query({name:"camera"}).then(r=>{r.addEventListener("change",this.permissionsApiStateChangeHandler)})}catch(r){console.info("Could not subscribe to Permissions API Camera changed events, API is not supported by browser",r)}try{navigator.permissions.query({name:"microphone"}).then(r=>{r.addEventListener("change",this.permissionsApiStateChangeHandler)})}catch(r){console.info("Could not subscribe to Permissions API Microphone changed events, API is not supported by browser",r)}}},this.unsubscribe=()=>{if(this._deviceManager.off("videoDevicesUpdated",this.videoDevicesUpdated),this._deviceManager.off("audioDevicesUpdated",this.audioDevicesUpdated),this._deviceManager.off("selectedMicrophoneChanged",this.selectedMicrophoneChanged),this._deviceManager.off("selectedSpeakerChanged",this.selectedSpeakerChanged),navigator.permissions){try{navigator.permissions.query({name:"camera"}).then(r=>{r.removeEventListener("change",this.permissionsApiStateChangeHandler)})}catch(r){console.info("Could not Unsubscribe to Permissions API Camera changed events, API is not supported by browser",r)}try{navigator.permissions.query({name:"microphone"}).then(r=>{r.removeEventListener("change",this.permissionsApiStateChangeHandler)})}catch(r){console.info("Could not Unsubscribe to Permissions API Camera changed events, API is not supported by browser",r)}}},this.permissionsApiStateChangeHandler=()=>u8(this,void 0,void 0,function*(){yield this.updateDevicePermissionState()}),this.selectCamera=r=>{this._context.setDeviceManagerSelectedCamera(r)},this.videoDevicesUpdated=()=>u8(this,void 0,void 0,function*(){const r=(yield this._deviceManager.getCameras()).filter(o=>!!o.name);this._context.setDeviceManagerCameras(m4(r))}),this.audioDevicesUpdated=()=>u8(this,void 0,void 0,function*(){this._context.setDeviceManagerMicrophones(m4(yield this._deviceManager.getMicrophones())),this._deviceManager.isSpeakerSelectionAvailable&&this._context.setDeviceManagerSpeakers(m4(yield this._deviceManager.getSpeakers()))}),this.selectedMicrophoneChanged=()=>{this._context.setDeviceManagerSelectedMicrophone(this._deviceManager.selectedMicrophone)},this.selectedSpeakerChanged=()=>{this._context.setDeviceManagerSelectedSpeaker(this._deviceManager.selectedSpeaker)},this.updateDevicePermissionState=r=>u8(this,void 0,void 0,function*(){let o=!!r?.video,l=!!r?.audio;if(navigator.permissions)try{const[d,h]=yield Promise.all([navigator.permissions.query({name:"camera"}),navigator.permissions.query({name:"microphone"})]);o=d.state==="granted",l=h.state==="granted"}catch(d){console.info("Permissions API is not supported by browser",d)}this._context.setDeviceManagerDeviceAccess({video:o,audio:l}),this.setDeviceManager()}),this._deviceManager=e,this._context=i,this.setDeviceManager(),this.subscribe()}get(e,i){switch(i){case"getCameras":return this._context.withAsyncErrorTeedToState(()=>e.getCameras().then(r=>{const o=r.filter(l=>!!l.name);return this._context.setDeviceManagerCameras(m4(o)),o}),"DeviceManager.getCameras");case"getMicrophones":return this._context.withAsyncErrorTeedToState(()=>e.getMicrophones().then(r=>(this._context.setDeviceManagerMicrophones(m4(r)),r)),"DeviceManager.getMicrophones");case"getSpeakers":return this._context.withAsyncErrorTeedToState(()=>e.getSpeakers().then(r=>(this._context.setDeviceManagerSpeakers(m4(r)),r)),"DeviceManager.getSpeakers");case"selectMicrophone":return this._context.withAsyncErrorTeedToState((...r)=>e.selectMicrophone(...r).then(()=>{this._context.setDeviceManagerSelectedMicrophone(e.selectedMicrophone)}),"DeviceManager.selectMicrophone");case"selectSpeaker":return this._context.withAsyncErrorTeedToState((...r)=>e.selectSpeaker(...r).then(()=>{this._context.setDeviceManagerSelectedSpeaker(e.selectedSpeaker)}),"DeviceManager.selectSpeaker");case"askDevicePermission":return this._context.withAsyncErrorTeedToState((...r)=>e.askDevicePermission(...r).then(o=>u8(this,void 0,void 0,function*(){return yield this.updateDevicePermissionState(o),o})),"DeviceManager.askDevicePermission");default:return Reflect.get(e,i)}}}const m4=t=>{const e=new Set,i=[];return t.forEach(r=>{e.has(r.id)||(i.push(r),e.add(r.id))}),i},hjt=(t,e,i)=>{const r=new ujt(t,e);return Object.defineProperty(t,"unsubscribe",{configurable:!1,value:()=>r.unsubscribe()}),Object.defineProperty(t,"selectCamera",{configurable:!1,value:o=>r.selectCamera(o)}),Object.defineProperty(t,"getUnparentedVideoStreams",{configurable:!1,value:()=>i.getUnparentedRenderInfos()}),new Proxy(t,r)},Sge=t=>!t.kind||t.kind==="Call",h8=t=>!t.kind||t.kind==="CallAgent",bge=t=>t.kind==="TeamsCall",f4=t=>t.kind==="TeamsCallAgent",K3e=t=>t.kind==="TeamsIncomingCall",pjt=t=>"info"in t&&!!t.info.threadId;function v4(t){const e=t.feature(Ma.VideoEffects);return{source:t.source,mediaStreamType:t.mediaStreamType,view:void 0,videoEffects:J3e(e.activeEffects)}}function y4(t){return{id:t.id,mediaStreamType:t.mediaStreamType,isAvailable:t.isAvailable,isReceiving:t.isReceiving,view:void 0,streamSize:t.size}}function vZ(t){const e={};for(const i of t.videoStreams)e[i.id]=y4(i);return{identifier:t.identifier,displayName:t.displayName,state:t.state,callEndReason:t.callEndReason,videoStreams:e,isMuted:t.isMuted,isSpeaking:t.isSpeaking,raisedHand:void 0,role:t.role,spotlight:void 0,mediaAccess:void 0}}function gjt(t){const e={};t.remoteParticipants.forEach(o=>{e[Ga(o.identifier)]=vZ(o)});let i=!1;if(t.feature(Ma.Capabilities).capabilities&&t.feature(Ma.Capabilities).capabilities.viewAttendeeNames){const o=t.feature(Ma.Capabilities).capabilities.viewAttendeeNames;!o.isPresent&&o.reason==="MeetingRestricted"&&(i=!0)}let r;return"info"in t&&(r=t.info),{id:t.id,kind:Sge(t)?"Call":"TeamsCall",callerInfo:t.callerInfo,state:t.state,callEndReason:t.callEndReason,diagnostics:{network:{latest:{}},media:{latest:{}}},direction:t.direction,isMuted:t.isMuted,isScreenSharingOn:t.isScreenSharingOn,localVideoStreams:t.localVideoStreams.map(v4),remoteParticipants:e,remoteParticipantsEnded:{},recording:{isRecordingActive:!1},pptLive:{isActive:!1},raiseHand:{raisedHands:[]},localParticipantReaction:void 0,transcription:{isTranscriptionActive:!1},screenShareRemoteParticipant:void 0,startTime:new Date,endTime:void 0,role:t.role,captionsFeature:{captions:[],supportedSpokenLanguages:[],supportedCaptionLanguages:[],currentCaptionLanguage:"",currentSpokenLanguage:"",isCaptionsFeatureActive:!1,startCaptionsInProgress:!1,captionsKind:bge(t)?"TeamsCaptions":"Captions"},transfer:{acceptedTransfers:{}},optimalVideoCount:{maxRemoteVideoStreams:t.feature(Ma.OptimalVideoCount).optimalVideoCount},hideAttendeeNames:i,info:r,meetingConference:{conferencePhones:[]}}}function mjt(t){if(K3e(t)){const e=Object.assign(Object.assign({},t.info),{kind:t.kind});return{id:t.id,info:e,callerInfo:t.callerInfo,startTime:new Date,endTime:void 0}}else{const e=Object.assign(Object.assign({},t.info),{kind:t.kind});return{id:t.id,info:e,callerInfo:t.callerInfo,startTime:new Date,endTime:void 0}}}function Tge(t){return{scalingMode:t.scalingMode,isMirrored:t.isMirrored,target:t.target}}function fjt(t){return Object.assign({},t)}function vjt(t){return Object.assign({captionText:t.spokenText},t)}function J3e(t){return{activeEffects:t}}function Cge(t){return{raisedHandOrderPosition:t.order}}function yjt(t){return t?t.phoneNumbers.flatMap(e=>{var i,r,o,l;const d={conferenceId:t.phoneConferenceId,country:e.countryName,city:e.cityName,phoneNumber:"",isTollFree:!1},h=Object.assign({},d);h.phoneNumber=(r=(i=e.tollPhoneNumber)===null||i===void 0?void 0:i.phoneNumber)!==null&&r!==void 0?r:"",h.isTollFree=!1;const p=Object.assign({},d);return p.phoneNumber=(l=(o=e.tollFreePhoneNumber)===null||o===void 0?void 0:o.phoneNumber)!==null&&l!==void 0?l:"",p.isTollFree=!0,[h,p].filter(g=>g.phoneNumber)}):[]}var yZ={exports:{}},Y3e;function Sjt(){if(Y3e)return yZ.exports;Y3e=1;var t=typeof Reflect=="object"?Reflect:null,e=t&&typeof t.apply=="function"?t.apply:function(L,z,H){return Function.prototype.apply.call(L,z,H)},i;t&&typeof t.ownKeys=="function"?i=t.ownKeys:Object.getOwnPropertySymbols?i=function(L){return Object.getOwnPropertyNames(L).concat(Object.getOwnPropertySymbols(L))}:i=function(L){return Object.getOwnPropertyNames(L)};function r(B){console&&console.warn&&console.warn(B)}var o=Number.isNaN||function(L){return L!==L};function l(){l.init.call(this)}yZ.exports=l,yZ.exports.once=D,l.EventEmitter=l,l.prototype._events=void 0,l.prototype._eventsCount=0,l.prototype._maxListeners=void 0;var d=10;function h(B){if(typeof B!="function")throw new TypeError('The "listener" argument must be of type Function. Received type '+typeof B)}Object.defineProperty(l,"defaultMaxListeners",{enumerable:!0,get:function(){return d},set:function(B){if(typeof B!="number"||B<0||o(B))throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received '+B+".");d=B}}),l.init=function(){(this._events===void 0||this._events===Object.getPrototypeOf(this)._events)&&(this._events=Object.create(null),this._eventsCount=0),this._maxListeners=this._maxListeners||void 0},l.prototype.setMaxListeners=function(L){if(typeof L!="number"||L<0||o(L))throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received '+L+".");return this._maxListeners=L,this};function p(B){return B._maxListeners===void 0?l.defaultMaxListeners:B._maxListeners}l.prototype.getMaxListeners=function(){return p(this)},l.prototype.emit=function(L){for(var z=[],H=1;H<arguments.length;H++)z.push(arguments[H]);var j=L==="error",J=this._events;if(J!==void 0)j=j&&J.error===void 0;else if(!j)return!1;if(j){var Z;if(z.length>0&&(Z=z[0]),Z instanceof Error)throw Z;var re=new Error("Unhandled error."+(Z?" ("+Z.message+")":""));throw re.context=Z,re}var ne=J[L];if(ne===void 0)return!1;if(typeof ne=="function")e(ne,this,z);else for(var le=ne.length,he=E(ne,le),H=0;H<le;++H)e(he[H],this,z);return!0};function g(B,L,z,H){var j,J,Z;if(h(z),J=B._events,J===void 0?(J=B._events=Object.create(null),B._eventsCount=0):(J.newListener!==void 0&&(B.emit("newListener",L,z.listener?z.listener:z),J=B._events),Z=J[L]),Z===void 0)Z=J[L]=z,++B._eventsCount;else if(typeof Z=="function"?Z=J[L]=H?[z,Z]:[Z,z]:H?Z.unshift(z):Z.push(z),j=p(B),j>0&&Z.length>j&&!Z.warned){Z.warned=!0;var re=new Error("Possible EventEmitter memory leak detected. "+Z.length+" "+String(L)+" listeners added. Use emitter.setMaxListeners() to increase limit");re.name="MaxListenersExceededWarning",re.emitter=B,re.type=L,re.count=Z.length,r(re)}return B}l.prototype.addListener=function(L,z){return g(this,L,z,!1)},l.prototype.on=l.prototype.addListener,l.prototype.prependListener=function(L,z){return g(this,L,z,!0)};function f(){if(!this.fired)return this.target.removeListener(this.type,this.wrapFn),this.fired=!0,arguments.length===0?this.listener.call(this.target):this.listener.apply(this.target,arguments)}function y(B,L,z){var H={fired:!1,wrapFn:void 0,target:B,type:L,listener:z},j=f.bind(H);return j.listener=z,H.wrapFn=j,j}l.prototype.once=function(L,z){return h(z),this.on(L,y(this,L,z)),this},l.prototype.prependOnceListener=function(L,z){return h(z),this.prependListener(L,y(this,L,z)),this},l.prototype.removeListener=function(L,z){var H,j,J,Z,re;if(h(z),j=this._events,j===void 0)return this;if(H=j[L],H===void 0)return this;if(H===z||H.listener===z)--this._eventsCount===0?this._events=Object.create(null):(delete j[L],j.removeListener&&this.emit("removeListener",L,H.listener||z));else if(typeof H!="function"){for(J=-1,Z=H.length-1;Z>=0;Z--)if(H[Z]===z||H[Z].listener===z){re=H[Z].listener,J=Z;break}if(J<0)return this;J===0?H.shift():I(H,J),H.length===1&&(j[L]=H[0]),j.removeListener!==void 0&&this.emit("removeListener",L,re||z)}return this},l.prototype.off=l.prototype.removeListener,l.prototype.removeAllListeners=function(L){var z,H,j;if(H=this._events,H===void 0)return this;if(H.removeListener===void 0)return arguments.length===0?(this._events=Object.create(null),this._eventsCount=0):H[L]!==void 0&&(--this._eventsCount===0?this._events=Object.create(null):delete H[L]),this;if(arguments.length===0){var J=Object.keys(H),Z;for(j=0;j<J.length;++j)Z=J[j],Z!=="removeListener"&&this.removeAllListeners(Z);return this.removeAllListeners("removeListener"),this._events=Object.create(null),this._eventsCount=0,this}if(z=H[L],typeof z=="function")this.removeListener(L,z);else if(z!==void 0)for(j=z.length-1;j>=0;j--)this.removeListener(L,z[j]);return this};function T(B,L,z){var H=B._events;if(H===void 0)return[];var j=H[L];return j===void 0?[]:typeof j=="function"?z?[j.listener||j]:[j]:z?w(j):E(j,j.length)}l.prototype.listeners=function(L){return T(this,L,!0)},l.prototype.rawListeners=function(L){return T(this,L,!1)},l.listenerCount=function(B,L){return typeof B.listenerCount=="function"?B.listenerCount(L):C.call(B,L)},l.prototype.listenerCount=C;function C(B){var L=this._events;if(L!==void 0){var z=L[B];if(typeof z=="function")return 1;if(z!==void 0)return z.length}return 0}l.prototype.eventNames=function(){return this._eventsCount>0?i(this._events):[]};function E(B,L){for(var z=new Array(L),H=0;H<L;++H)z[H]=B[H];return z}function I(B,L){for(;L+1<B.length;L++)B[L]=B[L+1];B.pop()}function w(B){for(var L=new Array(B.length),z=0;z<L.length;++z)L[z]=B[z].listener||B[z];return L}function D(B,L){return new Promise(function(z,H){function j(Z){B.removeListener(L,J),H(Z)}function J(){typeof B.removeListener=="function"&&B.removeListener("error",j),z([].slice.call(arguments))}x(B,L,J,{once:!0}),L!=="error"&&F(B,j,{once:!0})})}function F(B,L,z){typeof B.on=="function"&&x(B,"error",L,z)}function x(B,L,z,H){if(typeof B.on=="function")H.once?B.once(L,z):B.on(L,z);else if(typeof B.addEventListener=="function")B.addEventListener(L,function j(J){H.once&&B.removeEventListener(L,j),z(J)});else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type '+typeof B)}return yZ.exports}var QB=Sjt(),_ge=Symbol.for("immer-nothing"),p8=Symbol.for("immer-draftable"),Sd=Symbol.for("immer-state"),Q3e=process.env.NODE_ENV!=="production"?[function(t){return`The plugin for '${t}' has not been loaded into Immer. To enable the plugin, import and call \`enable${t}()\` when initializing your application.`},function(t){return`produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '${t}'`},"This object has been frozen and should not be mutated",function(t){return"Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? "+t},"An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.","Immer forbids circular references","The first or second argument to `produce` must be a function","The third argument to `produce` must be a function or undefined","First argument to `createDraft` must be a plain object, an array, or an immerable object","First argument to `finishDraft` must be a draft returned by `createDraft`",function(t){return`'current' expects a draft, got: ${t}`},"Object.defineProperty() cannot be used on an Immer draft","Object.setPrototypeOf() cannot be used on an Immer draft","Immer only supports deleting array indices","Immer only supports setting array indices and the 'length' property",function(t){return`'original' expects a draft, got: ${t}`}]:[];function Qg(t,...e){if(process.env.NODE_ENV!=="production"){const i=Q3e[t],r=typeof i=="function"?i.apply(null,e):i;throw new Error(`[Immer] ${r}`)}throw new Error(`[Immer] minified error nr: ${t}. Full error at: https://bit.ly/3cXEKWf`)}var ZB=Object.getPrototypeOf;function XB(t){return!!t&&!!t[Sd]}function Rk(t){return t?Z3e(t)||Array.isArray(t)||!!t[p8]||!!t.constructor?.[p8]||m8(t)||f8(t):!1}var bjt=Object.prototype.constructor.toString();function Z3e(t){if(!t||typeof t!="object")return!1;const e=ZB(t);if(e===null)return!0;const i=Object.hasOwnProperty.call(e,"constructor")&&e.constructor;return i===Object?!0:typeof i=="function"&&Function.toString.call(i)===bjt}function S4(t,e){eF(t)===0?Reflect.ownKeys(t).forEach(i=>{e(i,t[i],t)}):t.forEach((i,r)=>e(r,i,t))}function eF(t){const e=t[Sd];return e?e.type_:Array.isArray(t)?1:m8(t)?2:f8(t)?3:0}function g8(t,e){return eF(t)===2?t.has(e):Object.prototype.hasOwnProperty.call(t,e)}function Ege(t,e){return eF(t)===2?t.get(e):t[e]}function X3e(t,e,i){const r=eF(t);r===2?t.set(e,i):r===3?t.add(i):t[e]=i}function Tjt(t,e){return t===e?t!==0||1/t===1/e:t!==t&&e!==e}function m8(t){return t instanceof Map}function f8(t){return t instanceof Set}function Yf(t){return t.copy_||t.base_}function Age(t,e){if(m8(t))return new Map(t);if(f8(t))return new Set(t);if(Array.isArray(t))return Array.prototype.slice.call(t);const i=Z3e(t);if(e===!0||e==="class_only"&&!i){const r=Object.getOwnPropertyDescriptors(t);delete r[Sd];let o=Reflect.ownKeys(r);for(let l=0;l<o.length;l++){const d=o[l],h=r[d];h.writable===!1&&(h.writable=!0,h.configurable=!0),(h.get||h.set)&&(r[d]={configurable:!0,writable:!0,enumerable:h.enumerable,value:t[d]})}return Object.create(ZB(t),r)}else{const r=ZB(t);if(r!==null&&i)return{...t};const o=Object.create(r);return Object.assign(o,t)}}function Ige(t,e=!1){return SZ(t)||XB(t)||!Rk(t)||(eF(t)>1&&(t.set=t.add=t.clear=t.delete=Cjt),Object.freeze(t),e&&Object.entries(t).forEach(([i,r])=>Ige(r,!0))),t}function Cjt(){Qg(2)}function SZ(t){return Object.isFrozen(t)}var wge={};function tF(t){const e=wge[t];return e||Qg(0,t),e}function e4e(t,e){wge[t]||(wge[t]=e)}var v8;function bZ(){return v8}function _jt(t,e){return{drafts_:[],parent_:t,immer_:e,canAutoFreeze_:!0,unfinalizedDrafts_:0}}function t4e(t,e){e&&(tF("Patches"),t.patches_=[],t.inversePatches_=[],t.patchListener_=e)}function kge(t){Rge(t),t.drafts_.forEach(Ejt),t.drafts_=null}function Rge(t){t===v8&&(v8=t.parent_)}function i4e(t){return v8=_jt(v8,t)}function Ejt(t){const e=t[Sd];e.type_===0||e.type_===1?e.revoke_():e.revoked_=!0}function n4e(t,e){e.unfinalizedDrafts_=e.drafts_.length;const i=e.drafts_[0];return t!==void 0&&t!==i?(i[Sd].modified_&&(kge(e),Qg(4)),Rk(t)&&(t=TZ(e,t),e.parent_||CZ(e,t)),e.patches_&&tF("Patches").generateReplacementPatches_(i[Sd].base_,t,e.patches_,e.inversePatches_)):t=TZ(e,i,[]),kge(e),e.patches_&&e.patchListener_(e.patches_,e.inversePatches_),t!==_ge?t:void 0}function TZ(t,e,i){if(SZ(e))return e;const r=e[Sd];if(!r)return S4(e,(o,l)=>a4e(t,r,e,o,l,i)),e;if(r.scope_!==t)return e;if(!r.modified_)return CZ(t,r.base_,!0),r.base_;if(!r.finalized_){r.finalized_=!0,r.scope_.unfinalizedDrafts_--;const o=r.copy_;let l=o,d=!1;r.type_===3&&(l=new Set(o),o.clear(),d=!0),S4(l,(h,p)=>a4e(t,r,o,h,p,i,d)),CZ(t,o,!1),i&&t.patches_&&tF("Patches").generatePatches_(r,i,t.patches_,t.inversePatches_)}return r.copy_}function a4e(t,e,i,r,o,l,d){if(process.env.NODE_ENV!=="production"&&o===i&&Qg(5),XB(o)){const h=l&&e&&e.type_!==3&&!g8(e.assigned_,r)?l.concat(r):void 0,p=TZ(t,o,h);if(X3e(i,r,p),XB(p))t.canAutoFreeze_=!1;else return}else d&&i.add(o);if(Rk(o)&&!SZ(o)){if(!t.immer_.autoFreeze_&&t.unfinalizedDrafts_<1)return;TZ(t,o),(!e||!e.scope_.parent_)&&typeof r!="symbol"&&Object.prototype.propertyIsEnumerable.call(i,r)&&CZ(t,o)}}function CZ(t,e,i=!1){!t.parent_&&t.immer_.autoFreeze_&&t.canAutoFreeze_&&Ige(e,i)}function Ajt(t,e){const i=Array.isArray(t),r={type_:i?1:0,scope_:e?e.scope_:bZ(),modified_:!1,finalized_:!1,assigned_:{},parent_:e,base_:t,draft_:null,copy_:null,revoke_:null,isManual_:!1};let o=r,l=Mge;i&&(o=[r],l=y8);const{revoke:d,proxy:h}=Proxy.revocable(o,l);return r.draft_=h,r.revoke_=d,h}var Mge={get(t,e){if(e===Sd)return t;const i=Yf(t);if(!g8(i,e))return Ijt(t,i,e);const r=i[e];return t.finalized_||!Rk(r)?r:r===Pge(t.base_,e)?(Dge(t),t.copy_[e]=S8(r,t)):r},has(t,e){return e in Yf(t)},ownKeys(t){return Reflect.ownKeys(Yf(t))},set(t,e,i){const r=r4e(Yf(t),e);if(r?.set)return r.set.call(t.draft_,i),!0;if(!t.modified_){const o=Pge(Yf(t),e),l=o?.[Sd];if(l&&l.base_===i)return t.copy_[e]=i,t.assigned_[e]=!1,!0;if(Tjt(i,o)&&(i!==void 0||g8(t.base_,e)))return!0;Dge(t),bP(t)}return t.copy_[e]===i&&(i!==void 0||e in t.copy_)||Number.isNaN(i)&&Number.isNaN(t.copy_[e])||(t.copy_[e]=i,t.assigned_[e]=!0),!0},deleteProperty(t,e){return Pge(t.base_,e)!==void 0||e in t.base_?(t.assigned_[e]=!1,Dge(t),bP(t)):delete t.assigned_[e],t.copy_&&delete t.copy_[e],!0},getOwnPropertyDescriptor(t,e){const i=Yf(t),r=Reflect.getOwnPropertyDescriptor(i,e);return r&&{writable:!0,configurable:t.type_!==1||e!=="length",enumerable:r.enumerable,value:i[e]}},defineProperty(){Qg(11)},getPrototypeOf(t){return ZB(t.base_)},setPrototypeOf(){Qg(12)}},y8={};S4(Mge,(t,e)=>{y8[t]=function(){return arguments[0]=arguments[0][0],e.apply(this,arguments)}}),y8.deleteProperty=function(t,e){return process.env.NODE_ENV!=="production"&&isNaN(parseInt(e))&&Qg(13),y8.set.call(this,t,e,void 0)},y8.set=function(t,e,i){return process.env.NODE_ENV!=="production"&&e!=="length"&&isNaN(parseInt(e))&&Qg(14),Mge.set.call(this,t[0],e,i,t[0])};function Pge(t,e){const i=t[Sd];return(i?Yf(i):t)[e]}function Ijt(t,e,i){const r=r4e(e,i);return r?"value"in r?r.value:r.get?.call(t.draft_):void 0}function r4e(t,e){if(!(e in t))return;let i=ZB(t);for(;i;){const r=Object.getOwnPropertyDescriptor(i,e);if(r)return r;i=ZB(i)}}function bP(t){t.modified_||(t.modified_=!0,t.parent_&&bP(t.parent_))}function Dge(t){t.copy_||(t.copy_=Age(t.base_,t.scope_.immer_.useStrictShallowCopy_))}var wjt=class{constructor(t){this.autoFreeze_=!0,this.useStrictShallowCopy_=!1,this.produce=(e,i,r)=>{if(typeof e=="function"&&typeof i!="function"){const l=i;i=e;const d=this;return function(p=l,...g){return d.produce(p,f=>i.call(this,f,...g))}}typeof i!="function"&&Qg(6),r!==void 0&&typeof r!="function"&&Qg(7);let o;if(Rk(e)){const l=i4e(this),d=S8(e,void 0);let h=!0;try{o=i(d),h=!1}finally{h?kge(l):Rge(l)}return t4e(l,r),n4e(o,l)}else if(!e||typeof e!="object"){if(o=i(e),o===void 0&&(o=e),o===_ge&&(o=void 0),this.autoFreeze_&&Ige(o,!0),r){const l=[],d=[];tF("Patches").generateReplacementPatches_(e,o,l,d),r(l,d)}return o}else Qg(1,e)},this.produceWithPatches=(e,i)=>{if(typeof e=="function")return(d,...h)=>this.produceWithPatches(d,p=>e(p,...h));let r,o;return[this.produce(e,i,(d,h)=>{r=d,o=h}),r,o]},typeof t?.autoFreeze=="boolean"&&this.setAutoFreeze(t.autoFreeze),typeof t?.useStrictShallowCopy=="boolean"&&this.setUseStrictShallowCopy(t.useStrictShallowCopy)}createDraft(t){Rk(t)||Qg(8),XB(t)&&(t=kjt(t));const e=i4e(this),i=S8(t,void 0);return i[Sd].isManual_=!0,Rge(e),i}finishDraft(t,e){const i=t&&t[Sd];(!i||!i.isManual_)&&Qg(9);const{scope_:r}=i;return t4e(r,e),n4e(void 0,r)}setAutoFreeze(t){this.autoFreeze_=t}setUseStrictShallowCopy(t){this.useStrictShallowCopy_=t}applyPatches(t,e){let i;for(i=e.length-1;i>=0;i--){const o=e[i];if(o.path.length===0&&o.op==="replace"){t=o.value;break}}i>-1&&(e=e.slice(i+1));const r=tF("Patches").applyPatches_;return XB(t)?r(t,e):this.produce(t,o=>r(o,e))}};function S8(t,e){const i=m8(t)?tF("MapSet").proxyMap_(t,e):f8(t)?tF("MapSet").proxySet_(t,e):Ajt(t,e);return(e?e.scope_:bZ()).drafts_.push(i),i}function kjt(t){return XB(t)||Qg(10,t),o4e(t)}function o4e(t){if(!Rk(t)||SZ(t))return t;const e=t[Sd];let i;if(e){if(!e.modified_)return e.base_;e.finalized_=!0,i=Age(t,e.scope_.immer_.useStrictShallowCopy_)}else i=Age(t,!0);return S4(i,(r,o)=>{X3e(i,r,o4e(o))}),e&&(e.finalized_=!1),i}function s4e(){process.env.NODE_ENV!=="production"&&Q3e.push('Sets cannot have "replace" patches.',function(T){return"Unsupported patch operation: "+T},function(T){return"Cannot apply patch, path doesn't resolve: "+T},"Patching reserved attributes like __proto__, prototype and constructor is not allowed");const e="replace",i="add",r="remove";function o(T,C,E,I){switch(T.type_){case 0:case 2:return d(T,C,E,I);case 1:return l(T,C,E,I);case 3:return h(T,C,E,I)}}function l(T,C,E,I){let{base_:w,assigned_:D}=T,F=T.copy_;F.length<w.length&&([w,F]=[F,w],[E,I]=[I,E]);for(let x=0;x<w.length;x++)if(D[x]&&F[x]!==w[x]){const B=C.concat([x]);E.push({op:e,path:B,value:y(F[x])}),I.push({op:e,path:B,value:y(w[x])})}for(let x=w.length;x<F.length;x++){const B=C.concat([x]);E.push({op:i,path:B,value:y(F[x])})}for(let x=F.length-1;w.length<=x;--x){const B=C.concat([x]);I.push({op:r,path:B})}}function d(T,C,E,I){const{base_:w,copy_:D}=T;S4(T.assigned_,(F,x)=>{const B=Ege(w,F),L=Ege(D,F),z=x?g8(w,F)?e:i:r;if(B===L&&z===e)return;const H=C.concat(F);E.push(z===r?{op:z,path:H}:{op:z,path:H,value:L}),I.push(z===i?{op:r,path:H}:z===r?{op:i,path:H,value:y(B)}:{op:e,path:H,value:y(B)})})}function h(T,C,E,I){let{base_:w,copy_:D}=T,F=0;w.forEach(x=>{if(!D.has(x)){const B=C.concat([F]);E.push({op:r,path:B,value:x}),I.unshift({op:i,path:B,value:x})}F++}),F=0,D.forEach(x=>{if(!w.has(x)){const B=C.concat([F]);E.push({op:i,path:B,value:x}),I.unshift({op:r,path:B,value:x})}F++})}function p(T,C,E,I){E.push({op:e,path:[],value:C===_ge?void 0:C}),I.push({op:e,path:[],value:T})}function g(T,C){return C.forEach(E=>{const{path:I,op:w}=E;let D=T;for(let L=0;L<I.length-1;L++){const z=eF(D);let H=I[L];typeof H!="string"&&typeof H!="number"&&(H=""+H),(z===0||z===1)&&(H==="__proto__"||H==="constructor")&&Qg(19),typeof D=="function"&&H==="prototype"&&Qg(19),D=Ege(D,H),typeof D!="object"&&Qg(18,I.join("/"))}const F=eF(D),x=f(E.value),B=I[I.length-1];switch(w){case e:switch(F){case 2:return D.set(B,x);case 3:Qg(16);default:return D[B]=x}case i:switch(F){case 1:return B==="-"?D.push(x):D.splice(B,0,x);case 2:return D.set(B,x);case 3:return D.add(x);default:return D[B]=x}case r:switch(F){case 1:return D.splice(B,1);case 2:return D.delete(B);case 3:return D.delete(E.value);default:return delete D[B]}default:Qg(17,w)}}),T}function f(T){if(!Rk(T))return T;if(Array.isArray(T))return T.map(f);if(m8(T))return new Map(Array.from(T.entries()).map(([E,I])=>[E,f(I)]));if(f8(T))return new Set(Array.from(T).map(f));const C=Object.create(ZB(T));for(const E in T)C[E]=f(T[E]);return g8(T,p8)&&(C[p8]=T[p8]),C}function y(T){return XB(T)?f(T):T}e4e("Patches",{applyPatches_:g,generatePatches_:o,generateReplacementPatches_:p})}function l4e(){class t extends Map{constructor(p,g){super(),this[Sd]={type_:2,parent_:g,scope_:g?g.scope_:bZ(),modified_:!1,finalized_:!1,copy_:void 0,assigned_:void 0,base_:p,draft_:this,isManual_:!1,revoked_:!1}}get size(){return Yf(this[Sd]).size}has(p){return Yf(this[Sd]).has(p)}set(p,g){const f=this[Sd];return d(f),(!Yf(f).has(p)||Yf(f).get(p)!==g)&&(i(f),bP(f),f.assigned_.set(p,!0),f.copy_.set(p,g),f.assigned_.set(p,!0)),this}delete(p){if(!this.has(p))return!1;const g=this[Sd];return d(g),i(g),bP(g),g.base_.has(p)?g.assigned_.set(p,!1):g.assigned_.delete(p),g.copy_.delete(p),!0}clear(){const p=this[Sd];d(p),Yf(p).size&&(i(p),bP(p),p.assigned_=new Map,S4(p.base_,g=>{p.assigned_.set(g,!1)}),p.copy_.clear())}forEach(p,g){const f=this[Sd];Yf(f).forEach((y,T,C)=>{p.call(g,this.get(T),T,this)})}get(p){const g=this[Sd];d(g);const f=Yf(g).get(p);if(g.finalized_||!Rk(f)||f!==g.base_.get(p))return f;const y=S8(f,g);return i(g),g.copy_.set(p,y),y}keys(){return Yf(this[Sd]).keys()}values(){const p=this.keys();return{[Symbol.iterator]:()=>this.values(),next:()=>{const g=p.next();return g.done?g:{done:!1,value:this.get(g.value)}}}}entries(){const p=this.keys();return{[Symbol.iterator]:()=>this.entries(),next:()=>{const g=p.next();if(g.done)return g;const f=this.get(g.value);return{done:!1,value:[g.value,f]}}}}[Symbol.iterator](){return this.entries()}}function e(h,p){return new t(h,p)}function i(h){h.copy_||(h.assigned_=new Map,h.copy_=new Map(h.base_))}class r extends Set{constructor(p,g){super(),this[Sd]={type_:3,parent_:g,scope_:g?g.scope_:bZ(),modified_:!1,finalized_:!1,copy_:void 0,base_:p,draft_:this,drafts_:new Map,revoked_:!1,isManual_:!1}}get size(){return Yf(this[Sd]).size}has(p){const g=this[Sd];return d(g),g.copy_?!!(g.copy_.has(p)||g.drafts_.has(p)&&g.copy_.has(g.drafts_.get(p))):g.base_.has(p)}add(p){const g=this[Sd];return d(g),this.has(p)||(l(g),bP(g),g.copy_.add(p)),this}delete(p){if(!this.has(p))return!1;const g=this[Sd];return d(g),l(g),bP(g),g.copy_.delete(p)||(g.drafts_.has(p)?g.copy_.delete(g.drafts_.get(p)):!1)}clear(){const p=this[Sd];d(p),Yf(p).size&&(l(p),bP(p),p.copy_.clear())}values(){const p=this[Sd];return d(p),l(p),p.copy_.values()}entries(){const p=this[Sd];return d(p),l(p),p.copy_.entries()}keys(){return this.values()}[Symbol.iterator](){return this.values()}forEach(p,g){const f=this.values();let y=f.next();for(;!y.done;)p.call(g,y.value,y.value,this),y=f.next()}}function o(h,p){return new r(h,p)}function l(h){h.copy_||(h.copy_=new Set,h.base_.forEach(p=>{if(Rk(p)){const g=S8(p,h);h.drafts_.set(p,g),h.copy_.add(g)}else h.copy_.add(p)}))}function d(h){h.revoked_&&Qg(3,JSON.stringify(Yf(h)))}e4e("MapSet",{proxyMap_:e,proxySet_:o})}var QC=new wjt,c4e=QC.produce;QC.produceWithPatches.bind(QC),QC.setAutoFreeze.bind(QC),QC.setUseStrictShallowCopy.bind(QC),QC.applyPatches.bind(QC),QC.createDraft.bind(QC),QC.finishDraft.bind(QC);class d4e extends Error{constructor(e,i,r){super(),this.target=e,this.innerError=i,"code"in i&&(this.code=i.code),"subCode"in i&&(this.subCode=i.subCode),this.timestamp=r??new Date(Date.now()),this.name="CallError",this.message=`${this.target}: ${this.innerError.message} code=${this.code} subCode=${this.subCode}`}}const Zg=zf("communication-react:calling-stateful");var Vr;(function(t){t.VIEW_RENDER_SUCCEED="VIEW_RENDER_SUCCEED",t.START_DISPOSE_STREAM="START_DISPOSE_STREAM",t.START_STREAM_RENDERING="START_STREAM_RENDERING",t.DISPOSING_RENDERER="DISPOSING_RENDERER",t.CREATING_VIEW="CREATING_VIEW",t.CREATE_STREAM_INVALID_PARAMS="CREATE_STREAM_INVALID_PARAMS",t.DISPOSE_STREAM_INVALID_PARAMS="DISPOSE_STREAM_INVALID_PARAMS",t.STREAM_ALREADY_RENDERED="STREAM_ALREADY_RENDERED",t.STREAM_ALREADY_DISPOSED="STREAM_ALREADY_DISPOSED",t.STREAM_STOPPING="STREAM_STOPPING",t.CREATED_STREAM_STOPPING="CREATED_STREAM_STOPPING",t.STREAM_RENDERING="STREAM_RENDERING",t.STREAM_NOT_FOUND="STREAM_NOT_FOUND",t.RENDER_INFO_NOT_FOUND="RENDER_INFO_NOT_FOUND",t.DISPOSE_INFO_NOT_FOUND="DISPOSE_INFO_NOT_FOUND",t.RENDERER_NOT_FOUND="RENDERER_NOT_FOUND",t.CREATE_STREAM_FAIL="CREATE_STREAM_FAIL"})(Vr||(Vr={}));class u4e{constructor(){this._callIdHistory=new Map}updateCallIdHistory(e,i){const r=this._callIdHistory.get(e);r!==void 0&&this.latestCallId(e)!==i&&console.trace(`${e} alredy exists and maps to ${r}, which is not the same as ${i}`),this._callIdHistory.delete(e),this._callIdHistory.set(i,e)}latestCallId(e){let i=e;for(;;){const r=this._callIdHistory.get(i);if(r===void 0)break;i=r}return i}}var Rjt=function(t,e,i,r){function o(l){return l instanceof i?l:new i(function(d){d(l)})}return new(i||(i=Promise))(function(l,d){function h(f){try{g(r.next(f))}catch(y){d(y)}}function p(f){try{g(r.throw(f))}catch(y){d(y)}}function g(f){f.done?l(f.value):o(f.value).then(h,p)}g((r=r.apply(t,e||[])).next())})};l4e(),s4e();const h4e=10,Mjt=4133;let Pjt=class{constructor(e,i=50){this._callIdHistory=new u4e,this._timeOutId={},this._latestCallIdOfNotification={},this.teeErrorToState=(r,o)=>{const l=Lge(o,r);this.setLatestError(o,l)},this._logger=zf("communication-react:calling-context"),this._state={calls:{},callsEnded:{},incomingCalls:{},incomingCallsEnded:{},deviceManager:{isSpeakerSelectionAvailable:!1,cameras:[],microphones:[],speakers:[],unparentedViews:[]},callAgent:void 0,userId:e,environmentInfo:void 0,latestErrors:{},latestNotifications:{}},this._emitter=new QB.EventEmitter,this._emitter.setMaxListeners(i),this._atomicId=0}getState(){return this._state}modifyState(e){const i=this._state;this._state=c4e(this._state,e,r=>{Vle()==="verbose"&&this._logger.info(`State change: ${HK(r)}`)}),this._state!==i&&this._emitter.emit("stateChanged",this._state)}onStateChange(e){this._emitter.on("stateChanged",e)}offStateChange(e){this._emitter.off("stateChanged",e)}clearCallRelatedState(){this.modifyState(e=>{e.calls={},e.incomingCalls={},e.callsEnded={},e.incomingCallsEnded={}})}setCallAgent(e){this.modifyState(i=>{i.callAgent=e})}setCall(e){this.modifyState(i=>{const r=this._callIdHistory.latestCallId(e.id),o=i.calls[r];o?(o.callerInfo=e.callerInfo,o.state=e.state,o.callEndReason=e.callEndReason,o.direction=e.direction,o.isMuted=e.isMuted,o.isScreenSharingOn=e.isScreenSharingOn,o.localVideoStreams=e.localVideoStreams,o.remoteParticipants=e.remoteParticipants,o.transcription.isTranscriptionActive=e.transcription.isTranscriptionActive,o.optimalVideoCount.maxRemoteVideoStreams=e.optimalVideoCount.maxRemoteVideoStreams,o.recording.isRecordingActive=e.recording.isRecordingActive,o.raiseHand.raisedHands=e.raiseHand.raisedHands,o.pptLive.isActive=e.pptLive.isActive,o.raiseHand.localParticipantRaisedHand=e.raiseHand.localParticipantRaisedHand,o.role=e.role,o.captionsFeature.currentSpokenLanguage=e.captionsFeature.currentSpokenLanguage,o.captionsFeature.currentCaptionLanguage=e.captionsFeature.currentCaptionLanguage,o.info=e.info,o.meetingConference=e.meetingConference):i.calls[r]=e}),this._state.incomingCalls[e.id]&&this.removeIncomingCall(e.id)}removeCall(e){this.modifyState(i=>{delete i.calls[this._callIdHistory.latestCallId(e)]})}setCallEnded(e,i){const r=this._callIdHistory.latestCallId(e);this.modifyState(o=>{const l=o.calls[r];if(l){for(l.endTime=new Date,l.callEndReason=i,delete o.calls[r];Object.keys(o.callsEnded).length>=h4e;){const d=p4e(o.callsEnded);d&&delete o.callsEnded[d]}o.callsEnded[r]=l}})}setCallState(e,i){this.modifyState(r=>{const o=r.calls[this._callIdHistory.latestCallId(e)];o&&(o.state=i)})}setCallId(e,i){this._callIdHistory.updateCallIdHistory(e,i),this.modifyState(r=>{const o=r.calls[i];o&&(o.id=e,delete r.calls[i],r.calls[e]=o),Object.keys(this._latestCallIdOfNotification).forEach(l=>{this._latestCallIdOfNotification[l]===i&&(this._latestCallIdOfNotification[l]=e)}),this._openBreakoutRoom===i&&(this._openBreakoutRoom=e)})}setEnvironmentInfo(e){this.modifyState(i=>{i.environmentInfo=e})}setCallIsScreenSharingOn(e,i){this.modifyState(r=>{const o=r.calls[this._callIdHistory.latestCallId(e)];o&&(o.isScreenSharingOn=i)})}setCallRemoteParticipants(e,i,r){this.modifyState(o=>{const l=o.calls[this._callIdHistory.latestCallId(e)];l&&(r.forEach(d=>{delete l.remoteParticipants[d]}),i.forEach(d=>{l.remoteParticipants[Ga(d.identifier)]=d}))})}setCallRemoteParticipantsEnded(e,i,r){this.modifyState(o=>{const l=o.calls[this._callIdHistory.latestCallId(e)];l&&(r.forEach(d=>{delete l.remoteParticipantsEnded[d]}),i.forEach(d=>{l.remoteParticipantsEnded[Ga(d.identifier)]=d}))})}setCallLocalVideoStream(e,i,r){this.modifyState(o=>{const l=o.calls[this._callIdHistory.latestCallId(e)];if(l){for(const d of r){const h=l.localVideoStreams.findIndex(p=>p.mediaStreamType===d.mediaStreamType);h>-1&&l.localVideoStreams.splice(h,1)}for(const d of i){const h=l.localVideoStreams.findIndex(p=>p.mediaStreamType===d.mediaStreamType);h>-1?l.localVideoStreams[h]=d:l.localVideoStreams.push(d)}}})}setCallLocalVideoStreamVideoEffects(e,i){this.modifyState(r=>{var o;const l=r.calls[this._callIdHistory.latestCallId(e)];if(l){const d=(o=l.localVideoStreams)===null||o===void 0?void 0:o.find(h=>h.mediaStreamType==="Video");d&&(d.videoEffects=i)}})}setCallIsMicrophoneMuted(e,i){this.modifyState(r=>{const o=r.calls[this._callIdHistory.latestCallId(e)];o&&(o.isMuted=i)})}setRole(e,i){this.modifyState(r=>{const o=r.calls[this._callIdHistory.latestCallId(e)];o&&(o.role=i)})}setCallDominantSpeakers(e,i){this.modifyState(r=>{const o=r.calls[this._callIdHistory.latestCallId(e)];o&&(o.dominantSpeakers=i)})}setCallRecordingActive(e,i){this.modifyState(r=>{const o=r.calls[this._callIdHistory.latestCallId(e)];o&&(o.recording.isRecordingActive=i)})}setCallPPTLiveActive(e,i){this.modifyState(r=>{const o=r.calls[this._callIdHistory.latestCallId(e)];o&&(o.pptLive.isActive=i)})}setCallParticipantPPTLive(e,i,r){this.modifyState(o=>{const l=o.calls[this._callIdHistory.latestCallId(e)];if(l&&i){const d=l.remoteParticipants[i];d&&(d.contentSharingStream=r,l.contentSharingRemoteParticipant=i)}})}setCallRaisedHands(e,i){this.modifyState(r=>{const o=r.calls[this._callIdHistory.latestCallId(e)];if(o){o.raiseHand.raisedHands=i.map(d=>Cge(d));const l=i.find(d=>Ga(d.identifier)===Ga(this._state.userId));l?o.raiseHand.localParticipantRaisedHand=Cge(l):o.raiseHand.localParticipantRaisedHand=void 0}})}setParticipantIsRaisedHand(e,i,r){this.modifyState(o=>{const l=o.calls[this._callIdHistory.latestCallId(e)];if(l){const d=l.remoteParticipants[i];d&&(d.raisedHand=r&&Cge(r))}})}setReceivedReactionFromParticipant(e,i,r){this.modifyState(o=>{const l=o.calls[this._callIdHistory.latestCallId(e)];if(!l)return;clearTimeout(this._timeOutId[i]);const d=l.remoteParticipants[i],h=r?{reactionMessage:r,receivedOn:new Date}:void 0;i===Ga(this._state.userId)?l.localParticipantReaction=h:d?d.reactionState=h:r!==null&&console.warn(`Participant ${i} not found in call ${e}. Cannot set reaction state.`),r&&(this._timeOutId[i]=setTimeout(()=>{Djt(this,e,i)},Mjt))})}setCallTranscriptionActive(e,i){this.modifyState(r=>{const o=r.calls[this._callIdHistory.latestCallId(e)];o&&(o.transcription.isTranscriptionActive=i)})}setCapabilities(e,i,r){this.modifyState(o=>{const l=o.calls[this._callIdHistory.latestCallId(e)];l&&(l.capabilitiesFeature={capabilities:i,latestCapabilitiesChangeInfo:r})})}setHideAttendeeNames(e,i){this.modifyState(r=>{const o=r.calls[this._callIdHistory.latestCallId(e)];if(i.oldValue.viewAttendeeNames!==i.newValue.viewAttendeeNames){const l=i.newValue.viewAttendeeNames;o&&l&&!l.isPresent&&l.reason==="MeetingRestricted"?o.hideAttendeeNames=!0:o&&(o.hideAttendeeNames=!1)}})}setSpotlight(e,i,r){this.modifyState(o=>{const l=o.calls[this._callIdHistory.latestCallId(e)];l&&(l.spotlight=Object.assign(Object.assign({},l.spotlight),{spotlightedParticipants:i,maxParticipantsToSpotlight:r}))})}setTeamsMeetingConference(e,i){this.modifyState(r=>{const o=r.calls[this._callIdHistory.latestCallId(e)];o&&(o.meetingConference={conferencePhones:yjt(i)})})}setParticipantSpotlighted(e,i){this.modifyState(r=>{const o=r.calls[this._callIdHistory.latestCallId(e)];if(o){const l=o.remoteParticipants[Ga(i.identifier)];l?l.spotlight={spotlightedOrderPosition:i.order}:o.spotlight&&Ga(r.userId)===Ga(i.identifier)&&(o.spotlight.localParticipantSpotlight={spotlightedOrderPosition:i.order})}})}setParticipantNotSpotlighted(e,i){this.modifyState(r=>{const o=r.calls[this._callIdHistory.latestCallId(e)];if(o){const l=o.remoteParticipants[Ga(i.identifier)];l?l.spotlight=void 0:o.spotlight&&Ga(r.userId)===Ga(i.identifier)&&(o.spotlight.localParticipantSpotlight=void 0)}})}setAssignedBreakoutRoom(e,i){this.modifyState(r=>{const o=r.calls[this._callIdHistory.latestCallId(e)];o&&(o.breakoutRooms=Object.assign(Object.assign({},o.breakoutRooms),{assignedBreakoutRoom:i}))})}setBreakoutRoomSettings(e,i){this.modifyState(r=>{const o=r.calls[this._callIdHistory.latestCallId(e)];o&&(o.breakoutRooms=Object.assign(Object.assign({},o.breakoutRooms),{breakoutRoomSettings:i}))})}setBreakoutRoomDisplayName(e,i){this.modifyState(r=>{const o=r.calls[this._callIdHistory.latestCallId(e)];o&&(o.breakoutRooms=Object.assign(Object.assign({},o.breakoutRooms),{breakoutRoomDisplayName:i}))})}setOpenBreakoutRoom(e){this._openBreakoutRoom=e}deleteOpenBreakoutRoom(){this._openBreakoutRoom=void 0}getOpenBreakoutRoom(){return this._openBreakoutRoom}setCallScreenShareParticipant(e,i){this.modifyState(r=>{const o=r.calls[this._callIdHistory.latestCallId(e)];o&&(o.screenShareRemoteParticipant=i)})}setLocalVideoStreamRendererView(e,i,r){this.modifyState(o=>{const l=o.calls[this._callIdHistory.latestCallId(e)];if(l){const d=l.localVideoStreams.find(h=>h.mediaStreamType===i);d&&(d.view=r)}})}setParticipantState(e,i,r){this.modifyState(o=>{const l=o.calls[this._callIdHistory.latestCallId(e)];if(l){const d=l.remoteParticipants[i];d&&(d.state=r)}})}setParticipantIsMuted(e,i,r){this.modifyState(o=>{const l=o.calls[this._callIdHistory.latestCallId(e)];if(l){const d=l.remoteParticipants[i];d&&(d.isMuted=r)}})}setOptimalVideoCount(e,i){this.modifyState(r=>{const o=r.calls[this._callIdHistory.latestCallId(e)];o&&(o.optimalVideoCount.maxRemoteVideoStreams=i)})}setParticipantRole(e,i,r){this.modifyState(o=>{const l=o.calls[this._callIdHistory.latestCallId(e)];if(l){const d=l.remoteParticipants[i];d&&(d.role=r)}})}setParticipantDisplayName(e,i,r){this.modifyState(o=>{const l=o.calls[this._callIdHistory.latestCallId(e)];if(l){const d=l.remoteParticipants[i];d&&(d.displayName=r)}})}setParticipantIsSpeaking(e,i,r){this.modifyState(o=>{const l=o.calls[this._callIdHistory.latestCallId(e)];if(l){const d=l.remoteParticipants[i];d&&(d.isSpeaking=r)}})}setParticipantVideoStream(e,i,r){this.modifyState(o=>{const l=o.calls[this._callIdHistory.latestCallId(e)];if(l){const d=l.remoteParticipants[i];if(d){const h=d.videoStreams[r.id];h?(h.isAvailable=r.isAvailable,h.isReceiving=r.isReceiving,h.mediaStreamType=r.mediaStreamType):d.videoStreams[r.id]=r}}})}setRemoteVideoStreamIsAvailable(e,i,r,o){this.modifyState(l=>{const d=l.calls[this._callIdHistory.latestCallId(e)];if(d){const h=d.remoteParticipants[i];if(h){const p=h.videoStreams[r];p&&(p.isAvailable=o)}}})}setRemoteVideoStreamIsReceiving(e,i,r,o){this.modifyState(l=>{const d=l.calls[this._callIdHistory.latestCallId(e)];if(d){const h=d.remoteParticipants[i];if(h){const p=h.videoStreams[r];p&&(p.isReceiving=o)}}})}setRemoteVideoStreamSize(e,i,r,o){this.modifyState(l=>{const d=l.calls[this._callIdHistory.latestCallId(e)];if(d){const h=d.remoteParticipants[i];if(h){const p=h.videoStreams[r];p&&(p.streamSize=o)}}})}setRemoteVideoStreams(e,i,r,o){this.modifyState(l=>{const d=l.calls[this._callIdHistory.latestCallId(e)];if(d){const h=d.remoteParticipants[i];if(h){for(const p of o)delete h.videoStreams[p];for(const p of r){const g=h.videoStreams[p.id];g?(g.mediaStreamType=p.mediaStreamType,g.isAvailable=p.isAvailable,g.isReceiving=p.isReceiving):h.videoStreams[p.id]=p}}}})}setRemoteVideoStreamRendererView(e,i,r,o){this.modifyState(l=>{const d=l.calls[this._callIdHistory.latestCallId(e)];if(d){const h=d.remoteParticipants[i];if(h){const p=h.videoStreams[r];p&&(p.view=o)}}})}setRemoteVideoStreamViewScalingMode(e,i,r,o){this.modifyState(l=>{const d=l.calls[this._callIdHistory.latestCallId(e)];if(d){const h=d.remoteParticipants[i];if(h){const p=h.videoStreams[r];p&&p.view&&(p.view.scalingMode=o)}}})}setIncomingCall(e){this.modifyState(i=>{const r=i.incomingCalls[e.id];r?r.callerInfo=e.callerInfo:i.incomingCalls[e.id]=e})}removeIncomingCall(e){this.modifyState(i=>{delete i.incomingCalls[e]})}setIncomingCallEnded(e,i){this.modifyState(r=>{const o=r.incomingCalls[e];if(o){for(o.endTime=new Date,o.callEndReason=i,delete r.incomingCalls[e];Object.keys(r.incomingCallsEnded).length>=h4e;){const l=p4e(r.incomingCallsEnded);l&&delete r.incomingCallsEnded[l]}r.incomingCallsEnded[e]=o}})}setDeviceManagerIsSpeakerSelectionAvailable(e){this.modifyState(i=>{i.deviceManager.isSpeakerSelectionAvailable=e})}setDeviceManagerSelectedMicrophone(e){this.modifyState(i=>{i.deviceManager.selectedMicrophone=e})}setDeviceManagerSelectedSpeaker(e){this.modifyState(i=>{i.deviceManager.selectedSpeaker=e})}setDeviceManagerSelectedCamera(e){this.modifyState(i=>{i.deviceManager.selectedCamera=e})}setDeviceManagerCameras(e){this.modifyState(i=>{e.length>0&&!e.some(r=>{var o;return r.id===((o=i.deviceManager.selectedCamera)===null||o===void 0?void 0:o.id)})&&(i.deviceManager.selectedCamera=e[0]),i.deviceManager.cameras=e})}setDeviceManagerMicrophones(e){this.modifyState(i=>{i.deviceManager.microphones=e})}setDeviceManagerSpeakers(e){this.modifyState(i=>{i.deviceManager.speakers=e})}setDeviceManagerDeviceAccess(e){this.modifyState(i=>{i.deviceManager.deviceAccess=e})}setDeviceManagerUnparentedView(e,i){this.modifyState(r=>{r.deviceManager.unparentedViews.push({source:e.source,mediaStreamType:e.mediaStreamType,view:i})})}deleteDeviceManagerUnparentedView(e){this.modifyState(i=>{const r=i.deviceManager.unparentedViews.findIndex(o=>o.mediaStreamType===e.mediaStreamType);r!==-1&&i.deviceManager.unparentedViews.splice(r,1)})}setDeviceManagerUnparentedViewVideoEffects(e,i){this.modifyState(r=>{const o=r.deviceManager.unparentedViews.find(l=>l.mediaStreamType===e.mediaStreamType);o&&(o.videoEffects=i)})}getAndIncrementAtomicId(){const e=this._atomicId;return this._atomicId++,e}processNewCaption(e,i){var r;if(i.lastUpdatedTimestamp=new Date,e.length===0)e.push(i);else if(((r=e[e.length-1])===null||r===void 0?void 0:r.resultType)==="Final")e.push(i);else{const o=e[e.length-1];o&&o.speaker.identifier&&i.speaker.identifier&&Ga(o.speaker.identifier)===Ga(i.speaker.identifier)?e[e.length-1]=i:o?.lastUpdatedTimestamp&&Date.now()-o.lastUpdatedTimestamp.getTime()>5e3&&(o.resultType="Final",e.push(i))}e.length>50&&e.shift()}addTeamsCaption(e,i){this.modifyState(r=>{var o;const l=r.calls[this._callIdHistory.latestCallId(e)];if(l){const d=l.captionsFeature.currentCaptionLanguage;(i.captionLanguage.toUpperCase()===d.toUpperCase()||d===""||d===void 0)&&this.processNewCaption((o=l?.captionsFeature.captions)!==null&&o!==void 0?o:[],fjt(i))}})}addCaption(e,i){this.modifyState(r=>{var o;const l=r.calls[this._callIdHistory.latestCallId(e)];l&&this.processNewCaption((o=l?.captionsFeature.captions)!==null&&o!==void 0?o:[],vjt(i))})}setCaptionsKind(e,i){this.modifyState(r=>{const o=r.calls[this._callIdHistory.latestCallId(e)];o&&(o.captionsFeature.captionsKind=i)})}clearCaptions(e){this.modifyState(i=>{const r=i.calls[this._callIdHistory.latestCallId(e)];r&&(r.captionsFeature.captions=r.captionsFeature.captions.filter(o=>"message"in o))})}setIsCaptionActive(e,i){this.modifyState(r=>{const o=r.calls[this._callIdHistory.latestCallId(e)];o&&(o.captionsFeature.isCaptionsFeatureActive=i)})}setStartCaptionsInProgress(e,i){this.modifyState(r=>{const o=r.calls[this._callIdHistory.latestCallId(e)];o&&(o.captionsFeature.startCaptionsInProgress=i)})}setSelectedSpokenLanguage(e,i){this.modifyState(r=>{const o=r.calls[this._callIdHistory.latestCallId(e)];o&&(o.captionsFeature.currentSpokenLanguage=i)})}setSelectedCaptionLanguage(e,i){this.modifyState(r=>{const o=r.calls[this._callIdHistory.latestCallId(e)];o&&(o.captionsFeature.currentCaptionLanguage=i)})}setAvailableCaptionLanguages(e,i){this.modifyState(r=>{const o=r.calls[this._callIdHistory.latestCallId(e)];o&&(o.captionsFeature.supportedCaptionLanguages=i)})}setAvailableSpokenLanguages(e,i){this.modifyState(r=>{const o=r.calls[this._callIdHistory.latestCallId(e)];o&&(o.captionsFeature.supportedSpokenLanguages=i)})}setAcceptedTransfer(e,i){this.modifyState(r=>{const o=r.calls[this._callIdHistory.latestCallId(e)];o&&(o.transfer.acceptedTransfers[i.callId]=i)})}withAsyncErrorTeedToState(e,i){return(...r)=>Rjt(this,void 0,void 0,function*(){try{return yield e(...r)}catch(o){const l=Lge(i,o);throw this.setLatestError(i,l),l}})}withErrorTeedToState(e,i){return(...r)=>{try{return Zg.info(`Calling stateful client target function called: ${i}`),e(...r)}catch(o){const l=Lge(i,o);throw this.setLatestError(i,l),l}}}setLatestError(e,i){this.modifyState(r=>{r.latestErrors[e]=i})}setLatestNotification(e,i){this._latestCallIdOfNotification[i.target]=e,this.modifyState(r=>{r.latestNotifications[i.target]=i})}deleteLatestNotification(e,i){const r=this._latestCallIdOfNotification[e];i&&r!==i||this.modifyState(o=>{delete o.latestNotifications[e]})}setMediaAccesses(e,i){this.modifyState(r=>{const o=r.calls[this._callIdHistory.latestCallId(e)];o&&i.forEach(l=>{const d=o.remoteParticipants[Ga(l.participant)];d&&(d.mediaAccess={isAudioPermitted:l.isAudioPermitted,isVideoPermitted:l.isVideoPermitted})})})}setMeetingMediaAccess(e,i){this.modifyState(r=>{const o=r.calls[this._callIdHistory.latestCallId(e)];o&&i&&(o.meetingMediaAccess={isAudioPermitted:i.isAudioPermitted,isVideoPermitted:i.isVideoPermitted})})}};const Lge=(t,e)=>e instanceof Error?new d4e(t,e):new d4e(t,new Error(e)),p4e=t=>{var e,i,r,o;const l=Object.entries(t),d=l[0];if(!d)return;let[h,p]=d;if(p.endTime===void 0)return h;for(const[g,f]of l.slice(1)){if(f.endTime===void 0)return g;((i=(e=f.endTime)===null||e===void 0?void 0:e.getTime())!==null&&i!==void 0?i:0)<((o=(r=p.endTime)===null||r===void 0?void 0:r.getTime())!==null&&o!==void 0?o:0)&&([h,p]=[g,f])}return h};function Djt(t,e,i){t.setReceivedReactionFromParticipant(e,i,null)}class g4e{constructor(e,i,r){this.subscribe=()=>{this._captions.on("CaptionsActiveChanged",this.isCaptionsActiveChanged),this._captions.on("CaptionsReceived",this.onCaptionsReceived),this._captions.on("CaptionLanguageChanged",this.isCaptionLanguageChanged),this._captions.on("SpokenLanguageChanged",this.isSpokenLanguageChanged)},this.unsubscribe=()=>{this._captions.off("CaptionsActiveChanged",this.isCaptionsActiveChanged),this._captions.off("CaptionsReceived",this.onCaptionsReceived),this._captions.off("CaptionLanguageChanged",this.isCaptionLanguageChanged),this._captions.off("SpokenLanguageChanged",this.isSpokenLanguageChanged)},this.onCaptionsReceived=o=>{this._context.addTeamsCaption(this._callIdRef.callId,o)},this.isCaptionsActiveChanged=()=>{this._context.setIsCaptionActive(this._callIdRef.callId,this._captions.isCaptionsFeatureActive)},this.isCaptionLanguageChanged=()=>{this._context.setSelectedCaptionLanguage(this._callIdRef.callId,this._captions.activeCaptionLanguage)},this.isSpokenLanguageChanged=()=>{this._context.setSelectedSpokenLanguage(this._callIdRef.callId,this._captions.activeSpokenLanguage)},this._callIdRef=e,this._context=i,this._captions=r,this._captions.isCaptionsFeatureActive&&this._context.setIsCaptionActive(this._callIdRef.callId,this._captions.isCaptionsFeatureActive),this._context.setAvailableSpokenLanguages(this._callIdRef.callId,this._captions.supportedSpokenLanguages),"supportedCaptionLanguages"in this._captions&&this._context.setAvailableCaptionLanguages(this._callIdRef.callId,this._captions.supportedCaptionLanguages),this._context.setSelectedSpokenLanguage(this._callIdRef.callId,this._captions.activeSpokenLanguage),this._context.setSelectedCaptionLanguage(this._callIdRef.callId,this._captions.activeCaptionLanguage),this.subscribe()}}class Ljt{constructor(e,i,r){this.subscribe=()=>{this._captions.on("CaptionsActiveChanged",this.isCaptionsActiveChanged),this._captions.on("SpokenLanguageChanged",this.isSpokenLanguageChanged),this._captions.on("CaptionsReceived",this.onCaptionsReceived)},this.unsubscribe=()=>{this._captions.off("CaptionsActiveChanged",this.isCaptionsActiveChanged),this._captions.off("SpokenLanguageChanged",this.isSpokenLanguageChanged),this._captions.off("CaptionsReceived",this.onCaptionsReceived)},this.onCaptionsReceived=o=>{this._context.addCaption(this._callIdRef.callId,o)},this.isCaptionsActiveChanged=()=>{this._context.setIsCaptionActive(this._callIdRef.callId,this._captions.isCaptionsFeatureActive)},this.isSpokenLanguageChanged=()=>{this._context.setSelectedSpokenLanguage(this._callIdRef.callId,this._captions.activeSpokenLanguage)},this._callIdRef=e,this._context=i,this._captions=r,this._captions.isCaptionsFeatureActive&&this._context.setIsCaptionActive(this._callIdRef.callId,this._captions.isCaptionsFeatureActive),this._context.setAvailableSpokenLanguages(this._callIdRef.callId,this._captions.supportedSpokenLanguages),this._context.setSelectedSpokenLanguage(this._callIdRef.callId,this._captions.activeSpokenLanguage),this.subscribe()}}class Ojt{constructor(e,i,r){this.subscribe=()=>{this._captions.on("CaptionsKindChanged",this.isCaptionsKindChanged)},this.unsubscribe=()=>{var o,l;this._captions.off("CaptionsKindChanged",this.isCaptionsKindChanged),(o=this._TeamsCaptionsSubscriber)===null||o===void 0||o.unsubscribe(),(l=this._CaptionsSubscriber)===null||l===void 0||l.unsubscribe()},this.isCaptionsKindChanged=()=>{var o;this._context.setCaptionsKind(this._callIdRef.callId,this._captions.captions.kind),this._captions.captions.kind==="TeamsCaptions"&&((o=this._CaptionsSubscriber)===null||o===void 0||o.unsubscribe(),this._TeamsCaptionsSubscriber=new g4e(this._callIdRef,this._context,this._captions.captions))},this._callIdRef=e,this._context=i,this._captions=r,this._context.setCaptionsKind(this._callIdRef.callId,this._captions.captions.kind),this._captions.captions.kind==="TeamsCaptions"?this._TeamsCaptionsSubscriber=new g4e(this._callIdRef,this._context,this._captions.captions):this._CaptionsSubscriber=new Ljt(this._callIdRef,this._context,this._captions.captions),this.subscribe()}}class m4e{constructor(e){this.subscribe=()=>{this._localVideoStreamEffectsAPI.on("effectsStarted",this.effectsStarted),this._localVideoStreamEffectsAPI.on("effectsStopped",this.effectsStopped),this._localVideoStreamEffectsAPI.on("effectsError",this.effectsError)},this.unsubscribe=()=>{this._localVideoStreamEffectsAPI.off("effectsStarted",this.effectsStarted),this._localVideoStreamEffectsAPI.off("effectsStopped",this.effectsStopped),this._localVideoStreamEffectsAPI.off("effectsError",this.effectsError)},this.effectsStarted=()=>{this.updateStatefulVideoEffects()},this.effectsStopped=()=>{this.updateStatefulVideoEffects()},this.effectsError=i=>{this.updateStatefulVideoEffects(),this._context.teeErrorToState(new Error(i.message),"VideoEffectsFeature.startEffects")},this.updateStatefulVideoEffects=()=>{const i=J3e(this._localVideoStreamEffectsAPI.activeEffects);this._parent==="unparented"?this._context.setDeviceManagerUnparentedViewVideoEffects(this._localVideoStream,i):this._context.setCallLocalVideoStreamVideoEffects(this._parent.callId,i)},this._parent=e.parent,this._context=e.context,this._localVideoStream=e.localVideoStream,this._localVideoStreamEffectsAPI=e.localVideoStreamEffectsAPI,this.subscribe()}}class Njt{constructor(e,i,r,o){this.subscribe=()=>{this._remoteVideoStream.on("isAvailableChanged",this.isAvailableChanged),this._remoteVideoStream.on("isReceivingChanged",this.isReceivingChanged),this._remoteVideoStream.on("sizeChanged",this.isSizeChanged),this.checkAndUpdateScreenShareState()},this.unsubscribe=()=>{this._remoteVideoStream.off("isAvailableChanged",this.isAvailableChanged),this._remoteVideoStream.off("isReceivingChanged",this.isReceivingChanged),this._remoteVideoStream.off("sizeChanged",this.isSizeChanged)},this.includesActiveScreenShareStream=l=>{for(const d of Object.values(l))if(d.mediaStreamType==="ScreenSharing"&&d.isAvailable)return!0;return!1},this.checkAndUpdateScreenShareState=()=>{var l,d,h;if(this._remoteVideoStream.mediaStreamType!=="ScreenSharing")return;if(this._remoteVideoStream.isAvailable){this._context.setCallScreenShareParticipant(this._callIdRef.callId,this._participantKey);return}const p=(l=this._context.getState().calls[this._callIdRef.callId])===null||l===void 0?void 0:l.screenShareRemoteParticipant;if(!p||p===this._participantKey){this._context.setCallScreenShareParticipant(this._callIdRef.callId,void 0);return}const g=(h=(d=this._context.getState().calls[this._callIdRef.callId])===null||d===void 0?void 0:d.remoteParticipants[p])===null||h===void 0?void 0:h.videoStreams;if(!g){this._context.setCallScreenShareParticipant(this._callIdRef.callId,void 0);return}if(!this.includesActiveScreenShareStream(g)){this._context.setCallScreenShareParticipant(this._callIdRef.callId,void 0);return}},this.isAvailableChanged=()=>{this._context.setRemoteVideoStreamIsAvailable(this._callIdRef.callId,this._participantKey,this._remoteVideoStream.id,this._remoteVideoStream.isAvailable),this.checkAndUpdateScreenShareState()},this.isReceivingChanged=()=>{this._context.setRemoteVideoStreamIsReceiving(this._callIdRef.callId,this._participantKey,this._remoteVideoStream.id,this._remoteVideoStream.isReceiving)},this.isSizeChanged=()=>{var l,d,h,p,g,f,y;if(((l=this._remoteVideoStream)===null||l===void 0?void 0:l.size.width)===0&&((d=this._remoteVideoStream)===null||d===void 0?void 0:d.size.height)===0)return;const T=(g=(p=(h=this._context.getState().calls[this._callIdRef.callId])===null||h===void 0?void 0:h.remoteParticipants[this._participantKey])===null||p===void 0?void 0:p.videoStreams[this._remoteVideoStream.id])===null||g===void 0?void 0:g.streamSize,C=T?T.width/T.height:void 0,E=((f=this._remoteVideoStream)===null||f===void 0?void 0:f.size.width)/((y=this._remoteVideoStream)===null||y===void 0?void 0:y.size.height);(!T||C!==E)&&this._context.setRemoteVideoStreamSize(this._callIdRef.callId,this._participantKey,this._remoteVideoStream.id,this._remoteVideoStream.size)},this._callIdRef=e,this._participantKey=i,this._remoteVideoStream=r,this._context=o,this.subscribe()}}function xjt(t,e){switch(t){case Vr.DISPOSE_STREAM_INVALID_PARAMS:$f(Zg,{name:Vr.DISPOSE_STREAM_INVALID_PARAMS,level:"warning",message:"Dispose View invalid combination of parameters.",data:{streamType:e.streamType}});return;case Vr.START_DISPOSE_STREAM:$f(Zg,{name:Vr.START_DISPOSE_STREAM,level:"info",message:"Start disposing stream.",data:e});return;case Vr.DISPOSE_INFO_NOT_FOUND:$f(Zg,{name:Vr.DISPOSE_INFO_NOT_FOUND,level:"error",message:"Cannot find render info when disposing stream.",data:e});return;case Vr.STREAM_STOPPING:$f(Zg,{name:Vr.STREAM_STOPPING,level:"info",message:"Stream is currently marked as stopping, will continue if is local preview",data:e});return;case Vr.DISPOSING_RENDERER:$f(Zg,{name:Vr.DISPOSING_RENDERER,level:"info",message:"Disposing view renderer.",data:e});return;case Vr.RENDERER_NOT_FOUND:$f(Zg,{name:Vr.RENDERER_NOT_FOUND,level:"error",message:"Cannot find renderer when disposing stream.",data:e});return;case Vr.STREAM_ALREADY_DISPOSED:$f(Zg,{name:Vr.STREAM_ALREADY_DISPOSED,level:"info",message:"Stream is already disposed.",data:e});return;default:return}}function Bjt(t,e,i){switch(t){case Vr.CREATE_STREAM_INVALID_PARAMS:$f(Zg,{name:Vr.CREATE_STREAM_INVALID_PARAMS,level:"warning",message:"Create View invalid combination of parameters.",data:{streamType:e.streamType}});return;case Vr.START_STREAM_RENDERING:$f(Zg,{name:Vr.START_STREAM_RENDERING,level:"info",message:"Start creating view for local video.",data:e});return;case Vr.STREAM_NOT_FOUND:$f(Zg,{name:Vr.STREAM_NOT_FOUND,level:"error",message:"Stream not found in state.",data:{callId:e.callId}});return;case Vr.STREAM_ALREADY_RENDERED:$f(Zg,{name:Vr.STREAM_ALREADY_RENDERED,level:"warning",message:"Stream is already rendered.",data:e});return;case Vr.STREAM_RENDERING:$f(Zg,{name:Vr.STREAM_RENDERING,level:"warning",message:"Stream is rendering.",data:e});return;case Vr.STREAM_STOPPING:$f(Zg,{name:Vr.STREAM_STOPPING,level:"warning",message:'Stream was marked as stopping by dispose view. Resetting state to "Rendering".',data:e});return;case Vr.CREATE_STREAM_FAIL:$f(Zg,{name:Vr.CREATE_STREAM_FAIL,level:"error",message:"Failed to create view.",data:{error:i,streamType:e.streamType,callId:e.callId}});return;case Vr.RENDER_INFO_NOT_FOUND:$f(Zg,{name:Vr.RENDER_INFO_NOT_FOUND,level:"error",message:"Cannot find render info after create the view. ",data:e});return;case Vr.CREATED_STREAM_STOPPING:$f(Zg,{name:Vr.CREATED_STREAM_STOPPING,level:"warning",message:"Render info status is stopping, dispose renderer.",data:e});return;case Vr.VIEW_RENDER_SUCCEED:$f(Zg,{name:Vr.VIEW_RENDER_SUCCEED,level:"info",message:"Successfully render the view.",data:e});return;case Vr.CREATING_VIEW:$f(Zg,{name:Vr.CREATING_VIEW,level:"info",message:"Start creating view for remote video.",data:e});return;default:return}}function Fu(t,e,i){e.streamEventType==="disposeViewLocal"||e.streamEventType==="disposeViewRemote"||e.streamEventType==="disposeViewUnparented"?xjt(t,e):(e.streamEventType==="createViewLocal"||e.streamEventType==="createViewRemote")&&Bjt(t,e,i)}var Oge=function(t,e,i,r){function o(l){return l instanceof i?l:new i(function(d){d(l)})}return new(i||(i=Promise))(function(l,d){function h(f){try{g(r.next(f))}catch(y){d(y)}}function p(f){try{g(r.throw(f))}catch(y){d(y)}}function g(f){f.done?l(f.value):o(f.value).then(h,p)}g((r=r.apply(t,e||[])).next())})};function Fjt(t,e,i,r,o,l){return Oge(this,void 0,void 0,function*(){let d;if(o)d="createViewRemote";else if(i)d="createViewLocal";else throw new Error("unparented createView not implemented yet here");const h=r?.mediaStreamType,p=r.mediaStreamType,g=r.id,f=d==="createViewRemote"&&o?typeof o=="string"?o:Ga(o):void 0,y={callId:i,participantKey:f,streamId:g??p,streamType:h,streamEventType:d};Fu(Vr.CREATING_VIEW,y);const T=d==="createViewRemote"&&f?e.getRemoteRenderInfoForParticipant(i,f,g):e.getLocalRenderInfo(i,p);if(!T){Fu(Vr.STREAM_NOT_FOUND,y);return}if(T.status==="Rendered"){Fu(Vr.STREAM_ALREADY_RENDERED,y);return}if(T.status==="Rendering"){Fu(Vr.STREAM_RENDERING,y);return}if(T.status==="Stopping"){d==="createViewRemote"&&f?(Fu(Vr.STREAM_STOPPING,y),e.setRemoteRenderInfo(i,f,g,T.stream,"Rendering",T.renderer)):d==="createViewLocal"&&(Fu(Vr.STREAM_STOPPING,y),e.setLocalRenderInfo(i,p,T.stream,"Rendering",T.renderer));return}const C=new KB(T.stream);d==="createViewRemote"&&f?e.setRemoteRenderInfo(i,f,g,T.stream,"Rendering",void 0):e.setLocalRenderInfo(i,p,T.stream,"Rendering",C);let E;try{E=yield C.createView(l)}catch(w){throw d==="createViewRemote"&&f?(Fu(Vr.CREATE_STREAM_FAIL,y),e.setRemoteRenderInfo(i,f,g,T.stream,"NotRendered",void 0)):d==="createViewLocal"&&(Fu(Vr.CREATE_STREAM_FAIL,y,w),e.setLocalRenderInfo(i,p,T.stream,"NotRendered",void 0)),w}const I=d==="createViewRemote"&&f?e.getRemoteRenderInfoForParticipant(i,f,g):e.getLocalRenderInfo(i,p);if(!I){Fu(Vr.RENDER_INFO_NOT_FOUND,y),C.dispose(),d==="createViewRemote"&&f?t.setRemoteVideoStreamRendererView(i,f,g,void 0):t.setLocalVideoStreamRendererView(i,p,void 0);return}if(I.status==="Stopping"){Fu(Vr.CREATED_STREAM_STOPPING,y),C.dispose(),d==="createViewRemote"&&f?(e.setRemoteRenderInfo(i,f,g,I.stream,"NotRendered",void 0),t.setRemoteVideoStreamRendererView(i,f,g,void 0)):d==="createViewLocal"&&(e.setLocalRenderInfo(i,p,I.stream,"NotRendered",void 0),t.setLocalVideoStreamRendererView(i,p,void 0));return}return d==="createViewRemote"&&f?(e.setRemoteRenderInfo(i,f,g,I.stream,"Rendered",C),t.setRemoteVideoStreamRendererView(i,f,g,Tge(E)),Fu(Vr.VIEW_RENDER_SUCCEED,y)):d==="createViewLocal"&&(e.setLocalRenderInfo(i,p,I.stream,"Rendered",C),t.setLocalVideoStreamRendererView(i,p,Tge(E)),Fu(Vr.VIEW_RENDER_SUCCEED,y)),{renderer:C,view:E}})}function Ujt(t,e,i,r){return Oge(this,void 0,void 0,function*(){const o=e.getUnparentedRenderInfo(i);if(o&&o.status==="Rendered"){console.warn("Unparented LocalVideoStream is already rendered");return}if(o&&o.status==="Rendering")return;if(o&&o.status==="Stopping"){console.warn("Unparented LocalVideoStream is in the middle of stopping");return}const l=new kp(i.source),d=new KB(l);e.setUnparentedRenderInfo(i,l,"Rendering",void 0);let h;try{h=yield d.createView(r)}catch(g){throw e.deleteUnparentedRenderInfo(i),g}const p=e.getUnparentedRenderInfo(i);if(!p){d.dispose(),t.deleteDeviceManagerUnparentedView(i);return}if(p.status==="Stopping"){e.deleteUnparentedRenderInfo(i),t.deleteDeviceManagerUnparentedView(i);return}return e.setUnparentedRenderInfo(i,l,"Rendered",d),e.subscribeToUnparentedViewVideoEffects(l,t),t.setDeviceManagerUnparentedView(i,Tge(h)),{renderer:d,view:h}})}function zjt(t,e,i,r,o){let l;o?l="disposeViewRemote":i?l="disposeViewLocal":l="disposeViewUnparented";const d=r.mediaStreamType,h=r.mediaStreamType,p=r.id,g=l==="disposeViewRemote"&&o?typeof o=="string"?o:Ga(o):void 0,f={callId:i,participantKey:g,streamId:p??h,streamType:d};Fu(Vr.START_DISPOSE_STREAM,f),l==="disposeViewRemote"&&g&&t.setRemoteVideoStreamRendererView(i,g,p,void 0);const y=l==="disposeViewRemote"&&g?e.getRemoteRenderInfoForParticipant(i,g,p):e.getLocalRenderInfo(i,h);if(!y){Fu(Vr.DISPOSE_INFO_NOT_FOUND,f);return}if(y.status==="NotRendered"){Fu(Vr.STREAM_ALREADY_DISPOSED,f);return}if(y.status==="Stopping"){Fu(Vr.STREAM_STOPPING,f);return}if(y.status==="Rendering"){Fu(Vr.STREAM_STOPPING,f),l==="disposeViewRemote"&&g?e.setRemoteRenderInfo(i,g,p,y.stream,"Stopping",void 0):e.setLocalRenderInfo(i,h,y.stream,"Stopping",y.renderer);return}y.renderer?(Fu(Vr.DISPOSING_RENDERER,f),y.renderer.dispose(),l==="disposeViewRemote"&&g?e.setRemoteRenderInfo(i,g,p,y.stream,"NotRendered",void 0):l==="disposeViewLocal"&&(e.setLocalRenderInfo(i,h,y.stream,"NotRendered",void 0),t.setLocalVideoStreamRendererView(i,h,void 0))):Fu(Vr.RENDERER_NOT_FOUND,f)}function Vjt(t,e,i){const o={streamType:i.mediaStreamType,streamEventType:"disposeViewUnparented"};Fu(Vr.START_DISPOSE_STREAM,o),t.deleteDeviceManagerUnparentedView(i);const l=e.getUnparentedRenderInfo(i);if(!l){Fu(Vr.DISPOSE_INFO_NOT_FOUND,o);return}l.status==="Rendering"?(Fu(Vr.STREAM_STOPPING,o),e.setUnparentedRenderInfo(i,l.stream,"Stopping",void 0)):e.deleteUnparentedRenderInfo(i),l.renderer?(Fu(Vr.DISPOSING_RENDERER,o),l.renderer.dispose()):Fu(Vr.RENDERER_NOT_FOUND,o)}function $jt(t,e,i,r,o,l){const d=o.mediaStreamType;return i?Fjt(t,e,i,o,r,l):!("id"in o)&&!i?t.withAsyncErrorTeedToState(()=>Oge(this,void 0,void 0,function*(){return yield Ujt(t,e,o,l)}),"Call.startVideo")():(Fu(Vr.CREATE_STREAM_INVALID_PARAMS,{streamType:d}),Promise.resolve(void 0))}function iF(t,e,i,r,o){const l=o.mediaStreamType;if(i)zjt(t,e,i,o,r);else if(!("id"in o)&&!i)t.withErrorTeedToState(()=>Vjt(t,e,o),"Call.stopVideo")();else{Fu(Vr.DISPOSE_STREAM_INVALID_PARAMS,{streamType:l});return}}function f4e(t,e,i){const r=e.getRemoteRenderInfoForCall(i);if(r)for(const[l,d]of r.entries())for(const[h,p]of d.entries())iF(t,e,i,l,y4(p.stream));const o=e.getLocalRenderInfosForCall(i);if(o)for(const l of o.values())l&&l.renderer&&iF(t,e,i,void 0,v4(l.stream))}function Hjt(t,e){const i=e.getCallIds();for(const r of i)f4e(t,e,r)}let jjt=class{constructor(e,i,r,o){this.subscribe=()=>{if(this._participant.on("stateChanged",this.stateChanged),this._participant.on("isMutedChanged",this.isMutedChanged),this._participant.on("displayNameChanged",this.displayNameChanged),this._participant.on("isSpeakingChanged",this.isSpeakingChanged),this._participant.on("videoStreamsUpdated",this.videoStreamsUpdated),this._participant.on("roleChanged",this.roleChanged),this._participant.videoStreams.length>0){for(const l of this._participant.videoStreams)this._internalContext.setRemoteRenderInfo(this._callIdRef.callId,this._participantKey,l.id,l,"NotRendered",void 0),this.addRemoteVideoStreamSubscriber(l);this._context.setRemoteVideoStreams(this._callIdRef.callId,this._participantKey,this._participant.videoStreams.map(y4),[])}},this.unsubscribe=()=>{if(this._participant.off("stateChanged",this.stateChanged),this._participant.off("isMutedChanged",this.isMutedChanged),this._participant.off("displayNameChanged",this.displayNameChanged),this._participant.off("isSpeakingChanged",this.isSpeakingChanged),this._participant.off("videoStreamsUpdated",this.videoStreamsUpdated),this._participant.off("roleChanged",this.roleChanged),this._participant.videoStreams.length>0)for(const l of this._participant.videoStreams)iF(this._context,this._internalContext,this._callIdRef.callId,this._participantKey,y4(l)),this._internalContext.deleteRemoteRenderInfo(this._callIdRef.callId,this._participantKey,l.id)},this.addRemoteVideoStreamSubscriber=l=>{var d;(d=this._remoteVideoStreamSubscribers.get(l.id))===null||d===void 0||d.unsubscribe(),this._remoteVideoStreamSubscribers.set(l.id,new Njt(this._callIdRef,this._participantKey,l,this._context))},this.stateChanged=()=>{this._context.setParticipantState(this._callIdRef.callId,this._participantKey,this._participant.state)},this.isMutedChanged=()=>{this._context.setParticipantIsMuted(this._callIdRef.callId,this._participantKey,this._participant.isMuted)},this.roleChanged=()=>{this._context.setParticipantRole(this._callIdRef.callId,this._participantKey,this._participant.role)},this.displayNameChanged=()=>{this._context.setParticipantDisplayName(this._callIdRef.callId,this._participantKey,this._participant.displayName||"")},this.isSpeakingChanged=()=>{this._context.setParticipantIsSpeaking(this._callIdRef.callId,this._participantKey,this._participant.isSpeaking)},this.videoStreamsUpdated=l=>{var d;for(const h of l.removed)(d=this._remoteVideoStreamSubscribers.get(h.id))===null||d===void 0||d.unsubscribe(),iF(this._context,this._internalContext,this._callIdRef.callId,this._participantKey,y4(h)),this._internalContext.deleteRemoteRenderInfo(this._callIdRef.callId,this._participantKey,h.id);for(const h of l.added)this._internalContext.setRemoteRenderInfo(this._callIdRef.callId,this._participantKey,h.id,h,"NotRendered",void 0),this.addRemoteVideoStreamSubscriber(h);this._context.setRemoteVideoStreams(this._callIdRef.callId,this._participantKey,l.added.map(y4),l.removed.map(h=>h.id))},this._callIdRef=e,this._participant=i,this._context=r,this._internalContext=o,this._participantKey=Ga(this._participant.identifier),this._remoteVideoStreamSubscribers=new Map,this.subscribe()}};class Gjt{constructor(e,i,r){this.subscribe=()=>{this._recording.on("isRecordingActiveChanged",this.isAvailableChanged)},this.unsubscribe=()=>{this._recording.off("isRecordingActiveChanged",this.isAvailableChanged)},this.isAvailableChanged=()=>{this._context.setCallRecordingActive(this._callIdRef.callId,this._recording.isRecordingActive)},this._callIdRef=e,this._context=i,this._recording=r,this._recording.isRecordingActive&&this._context.setCallRecordingActive(this._callIdRef.callId,this._recording.isRecordingActive),this.subscribe()}}var qjt=function(t,e,i,r){function o(l){return l instanceof i?l:new i(function(d){d(l)})}return new(i||(i=Promise))(function(l,d){function h(f){try{g(r.next(f))}catch(y){d(y)}}function p(f){try{g(r.throw(f))}catch(y){d(y)}}function g(f){f.done?l(f.value):o(f.value).then(h,p)}g((r=r.apply(t,e||[])).next())})};class Wjt{constructor(e,i,r){this.subscribe=()=>{this._pptLive.on("isActiveChanged",this.isAvailableChanged)},this.unsubscribe=()=>{this._pptLive.off("isActiveChanged",this.isAvailableChanged)},this.isAvailableChanged=()=>{this._context.setCallPPTLiveActive(this._callIdRef.callId,this._pptLive.isActive),this.checkAndUpdatePPTLiveParticipant()},this.checkAndUpdatePPTLiveParticipant=()=>qjt(this,void 0,void 0,function*(){this._pptLive.activePresenterId&&(this._pptLive.isActive?(this._call.isScreenSharingOn&&(yield this._call.stopScreenSharing()),this._context.setCallParticipantPPTLive(this._callIdRef.callId,Ga(this._pptLive.activePresenterId),this._pptLive.target)):this._context.setCallParticipantPPTLive(this._callIdRef.callId,Ga(this._pptLive.activePresenterId),void 0))}),this._callIdRef=e,this._context=i,this._pptLive=r.feature(Ma.PPTLive),this._call=r,this.subscribe()}}class Kjt{constructor(e,i,r){this.subscribe=()=>{this._transcription.on("isTranscriptionActiveChanged",this.isTranscriptionActiveChanged)},this.unsubscribe=()=>{this._transcription.off("isTranscriptionActiveChanged",this.isTranscriptionActiveChanged)},this.isTranscriptionActiveChanged=()=>{this._context.setCallTranscriptionActive(this._callIdRef.callId,this._transcription.isTranscriptionActive)},this._callIdRef=e,this._context=i,this._transcription=r,this._transcription.isTranscriptionActive&&this._context.setCallTranscriptionActive(this._callIdRef.callId,this._transcription.isTranscriptionActive),this.subscribe()}}class Jjt{constructor(e,i,r){this.unsubscribe=()=>{this._diagnostics.network.off("diagnosticChanged",this.networkDiagnosticsChanged.bind(this)),this._diagnostics.media.off("diagnosticChanged",this.mediaDiagnosticsChanged.bind(this))},this._callIdRef=e,this._context=i,this._diagnostics=r,this.setInitialDiagnostics(),this.subscribe()}setInitialDiagnostics(){const e=this._diagnostics.network.getLatest(),i=this._diagnostics.media.getLatest();Object.entries(e).length===0&&Object.entries(i).length===0||this._context.modifyState(r=>{const o=r.calls[this._callIdRef.callId];o!==void 0&&(o.diagnostics={network:{latest:e},media:{latest:i}})})}subscribe(){this._diagnostics.network.on("diagnosticChanged",this.networkDiagnosticsChanged.bind(this)),this._diagnostics.media.on("diagnosticChanged",this.mediaDiagnosticsChanged.bind(this))}networkDiagnosticsChanged(e){this._context.modifyState(i=>{var r;const o=i.calls[this._callIdRef.callId];if(o===void 0)return;const l=(r=o.diagnostics)===null||r===void 0?void 0:r.network.latest;l&&(l[e.diagnostic]=v4e(e))})}mediaDiagnosticsChanged(e){this._context.modifyState(i=>{var r;const o=i.calls[this._callIdRef.callId];if(o===void 0)return;const l=(r=o.diagnostics)===null||r===void 0?void 0:r.media.latest;l&&(l[e.diagnostic]=v4e(e))})}}const v4e=t=>({value:t.value,valueType:t.valueType});class Yjt{constructor(e,i,r){this.subscribe=()=>{this._raiseHand.on("raisedHandEvent",this.raisedHand),this._raiseHand.on("loweredHandEvent",this.loweredHand)},this.unsubscribe=()=>{this._raiseHand.off("raisedHandEvent",this.raisedHand),this._raiseHand.off("loweredHandEvent",this.loweredHand)},this.raisedHand=()=>{this._context.setCallRaisedHands(this._callIdRef.callId,this._raiseHand.getRaisedHands());for(const o of this._raiseHand.getRaisedHands())this._context.setParticipantIsRaisedHand(this._callIdRef.callId,Ga(o.identifier),o)},this.loweredHand=o=>{this.raisedHand(),this._context.setParticipantIsRaisedHand(this._callIdRef.callId,Ga(o.identifier),void 0)},this._callIdRef=e,this._context=i,this._raiseHand=r,this.subscribe()}}class Qjt{constructor(e){this.subscribe=()=>{this._localOptimalVideoCountFeature.on("optimalVideoCountChanged",this.optimalVideoCountChanged)},this.unsubscribe=()=>{this._localOptimalVideoCountFeature.off("optimalVideoCountChanged",this.optimalVideoCountChanged)},this.optimalVideoCountChanged=()=>{this.updateOptimalVideoCountState({maxRemoteVideoStreams:this._localOptimalVideoCountFeature.optimalVideoCount})},this.updateOptimalVideoCountState=i=>{this._context.setOptimalVideoCount(this._callIdRef.callId,i.maxRemoteVideoStreams)},this._callIdRef=e.callIdRef,this._context=e.context,this._localOptimalVideoCountFeature=e.localOptimalVideoCountFeature,this.subscribe()}}class Zjt{constructor(e,i,r){this._capabilitiesInitialized=!1,this.subscribe=()=>{this._capabilitiesFeature.on("capabilitiesChanged",this.capabilitiesChanged)},this.unsubscribe=()=>{this._capabilitiesFeature.off("capabilitiesChanged",this.capabilitiesChanged)},this.capabilitiesChanged=o=>{this._context.setCapabilities(this._callIdRef.callId,this._capabilitiesFeature.capabilities,o),o.oldValue.viewAttendeeNames!==o.newValue.viewAttendeeNames&&this._context.setHideAttendeeNames(this._callIdRef.callId,o),this.setUnmuteMicAndTurnVideoOnNotification(o),this._capabilitiesInitialized=!0},this.setUnmuteMicAndTurnVideoOnNotification=o=>{var l,d,h,p,g,f,y,T,C,E;((l=o.oldValue.turnVideoOn)===null||l===void 0?void 0:l.isPresent)!==((d=o.newValue.turnVideoOn)===null||d===void 0?void 0:d.isPresent)&&(((h=o.oldValue.turnVideoOn)===null||h===void 0?void 0:h.isPresent)===!1&&(!((p=o.newValue.turnVideoOn)===null||p===void 0)&&p.isPresent)&&this._capabilitiesInitialized&&(this._context.getState().latestNotifications.capabilityTurnVideoOnAbsent&&this._context.deleteLatestNotification("capabilityTurnVideoOnAbsent",this._callIdRef.callId),this._context.getState().latestNotifications.capabilityTurnVideoOnPresent||this._context.setLatestNotification(this._callIdRef.callId,{target:"capabilityTurnVideoOnPresent",timestamp:new Date(Date.now())})),((g=o.newValue.turnVideoOn)===null||g===void 0?void 0:g.isPresent)===!1&&(this._context.getState().latestNotifications.capabilityTurnVideoOnPresent&&this._context.deleteLatestNotification("capabilityTurnVideoOnPresent",this._callIdRef.callId),this._context.getState().latestNotifications.capabilityTurnVideoOnAbsent||this._context.setLatestNotification(this._callIdRef.callId,{target:"capabilityTurnVideoOnAbsent",timestamp:new Date(Date.now())}))),((f=o.oldValue.unmuteMic)===null||f===void 0?void 0:f.isPresent)!==((y=o.newValue.unmuteMic)===null||y===void 0?void 0:y.isPresent)&&(((T=o.oldValue.unmuteMic)===null||T===void 0?void 0:T.isPresent)===!1&&(!((C=o.newValue.unmuteMic)===null||C===void 0)&&C.isPresent)&&this._capabilitiesInitialized&&(this._context.getState().latestNotifications.capabilityUnmuteMicAbsent&&this._context.deleteLatestNotification("capabilityUnmuteMicAbsent",this._callIdRef.callId),this._context.getState().latestNotifications.capabilityUnmuteMicPresent||this._context.setLatestNotification(this._callIdRef.callId,{target:"capabilityUnmuteMicPresent",timestamp:new Date(Date.now())})),((E=o.newValue.unmuteMic)===null||E===void 0?void 0:E.isPresent)===!1&&(this._context.getState().latestNotifications.capabilityUnmuteMicPresent&&this._context.deleteLatestNotification("capabilityUnmuteMicPresent",this._callIdRef.callId),this._context.getState().latestNotifications.capabilityUnmuteMicAbsent||this._context.setLatestNotification(this._callIdRef.callId,{target:"capabilityUnmuteMicAbsent",timestamp:new Date(Date.now())})))},this._callIdRef=e,this._context=i,this._capabilitiesFeature=r,this.subscribe()}}class Xjt{constructor(e,i,r){this.subscribe=()=>{this._reaction.on("reaction",this.onReactionEvent)},this.unsubscribe=()=>{this._reaction.off("reaction",this.onReactionEvent)},this.onReactionEvent=o=>{this._context.setReceivedReactionFromParticipant(this._callIdRef.callId,o.identifier,o.reactionMessage)},this._callIdRef=e,this._context=i,this._reaction=r,this.subscribe()}}class e6t{constructor(e,i,r){this.subscribe=()=>{this._spotlightFeature.on("spotlightChanged",this.spotlightChanged)},this.unsubscribe=()=>{this._spotlightFeature.off("spotlightChanged",this.spotlightChanged)},this.spotlightChanged=o=>{this._context.setSpotlight(this._callIdRef.callId,this._spotlightFeature.getSpotlightedParticipants(),this._spotlightFeature.maxParticipantsToSpotlight);for(const l of o.added)this._context.setParticipantSpotlighted(this._callIdRef.callId,l);for(const l of o.removed)this._context.setParticipantNotSpotlighted(this._callIdRef.callId,l)},this._callIdRef=e,this._context=i,this._spotlightFeature=r,this.subscribe()}}const t6t=3e4;class i6t{constructor(e,i,r){this.unsubscribe=()=>{this._breakoutRoomsFeature.off("breakoutRoomsUpdated",this.onBreakoutRoomsUpdated),this._context.deleteLatestNotification("breakoutRoomJoined",this._callIdRef.callId),this._context.deleteLatestNotification("breakoutRoomClosingSoon",this._callIdRef.callId),clearTimeout(this._breakoutRoomClosingSoonTimeoutId)},this.onBreakoutRoomsUpdated=o=>{o.type==="assignedBreakoutRooms"?this.onAssignedBreakoutRoomUpdated(o.data):o.type==="join"?this.onBreakoutRoomsJoined(o.data):o.type==="breakoutRoomsSettings"&&o.data&&this.onBreakoutRoomSettingsUpdated(o.data)},this.onAssignedBreakoutRoomUpdated=o=>{var l,d,h,p;const g=this._context.getState().calls[this._callIdRef.callId],f=(l=g?.breakoutRooms)===null||l===void 0?void 0:l.assignedBreakoutRoom;if(g!==void 0){if(!o){!((d=f?.call)===null||d===void 0)&&d.id&&(this._context.deleteLatestNotification("breakoutRoomJoined",f.call.id),this._context.deleteLatestNotification("breakoutRoomClosingSoon",f.call.id),clearTimeout(this._breakoutRoomClosingSoonTimeoutId)),this._context.setAssignedBreakoutRoom(this._callIdRef.callId,o);return}if(o.state==="open"&&(!((h=g.breakoutRooms)===null||h===void 0)&&h.breakoutRoomDisplayName)&&g.breakoutRooms.breakoutRoomDisplayName!==o.displayName)this._context.setLatestNotification(this._callIdRef.callId,{target:"assignedBreakoutRoomChanged",timestamp:new Date(Date.now())});else if(o.state==="open"&&!(!((p=g?.breakoutRooms)===null||p===void 0)&&p.breakoutRoomSettings)&&this._context.getOpenBreakoutRoom()===void 0){const y=o.autoMoveParticipantToBreakoutRoom===!1?"assignedBreakoutRoomOpenedPromptJoin":"assignedBreakoutRoomOpened";this._context.setLatestNotification(this._callIdRef.callId,{target:y,timestamp:new Date(Date.now())})}else if(o.state==="closed"&&f?.state==="open")this._context.deleteLatestNotification("assignedBreakoutRoomOpened",this._callIdRef.callId),this._context.deleteLatestNotification("assignedBreakoutRoomOpenedPromptJoin",this._callIdRef.callId),this._context.deleteLatestNotification("assignedBreakoutRoomChanged",this._callIdRef.callId),this._context.deleteLatestNotification("breakoutRoomJoined",this._callIdRef.callId);else if(o.state==="closed"){this._context.deleteLatestNotification("assignedBreakoutRoomOpened",this._callIdRef.callId),this._context.deleteLatestNotification("assignedBreakoutRoomOpenedPromptJoin",this._callIdRef.callId),this._context.deleteLatestNotification("assignedBreakoutRoomChanged",this._callIdRef.callId),this._context.deleteLatestNotification("breakoutRoomJoined",this._callIdRef.callId),this._context.deleteLatestNotification("breakoutRoomClosingSoon",this._callIdRef.callId),clearTimeout(this._breakoutRoomClosingSoonTimeoutId);const y=this._context.getOpenBreakoutRoom();y&&this._context.getState().calls[y]&&this._context.setLatestNotification(this._callIdRef.callId,{target:"assignedBreakoutRoomClosed",timestamp:new Date(Date.now())}),this._context.deleteOpenBreakoutRoom()}this._context.setAssignedBreakoutRoom(this._callIdRef.callId,o)}},this.onBreakoutRoomsJoined=o=>{var l,d,h;this._context.deleteLatestNotification("assignedBreakoutRoomOpened",this._callIdRef.callId),this._context.deleteLatestNotification("assignedBreakoutRoomOpenedPromptJoin",this._callIdRef.callId),this._context.deleteLatestNotification("assignedBreakoutRoomChanged",this._callIdRef.callId),this._context.setLatestNotification(o.id,{target:"breakoutRoomJoined",timestamp:new Date(Date.now())}),this._context.setOpenBreakoutRoom(o.id);const p=(h=(d=(l=this._context.getState().calls[this._callIdRef.callId])===null||l===void 0?void 0:l.breakoutRooms)===null||d===void 0?void 0:d.assignedBreakoutRoom)===null||h===void 0?void 0:h.displayName;p&&this._context.setBreakoutRoomDisplayName(o.id,p)},this.onBreakoutRoomSettingsUpdated=o=>{if(typeof o.roomEndTime=="string"&&!Number.isNaN(Date.parse(o.roomEndTime))){const l=new Date(Date.now()),h=new Date(o.roomEndTime).getTime()-l.getTime(),p=Math.max(h-t6t,0);this._breakoutRoomClosingSoonTimeoutId||(this._breakoutRoomClosingSoonTimeoutId=setTimeout(()=>this._context.setLatestNotification(this._callIdRef.callId,{target:"breakoutRoomClosingSoon",timestamp:l}),p))}this._context.setBreakoutRoomSettings(this._callIdRef.callId,o)},this._callIdRef=e,this._context=i,this._breakoutRoomsFeature=r,this.subscribe()}subscribe(){this._breakoutRoomsFeature.on("breakoutRoomsUpdated",this.onBreakoutRoomsUpdated)}}class n6t{constructor(e,i,r){this.subscribe=()=>{this._mediaAccessCallFeature.on("mediaAccessChanged",this.mediaAccessChanged),this._mediaAccessCallFeature.on("meetingMediaAccessChanged",this.meetingMediaAccessChanged)},this.unsubscribe=()=>{this._mediaAccessCallFeature.off("mediaAccessChanged",this.mediaAccessChanged),this._mediaAccessCallFeature.off("meetingMediaAccessChanged",this.meetingMediaAccessChanged)},this.mediaAccessChanged=d=>this._context.setMediaAccesses(this._callIdRef.callId,d.mediaAccesses),this.meetingMediaAccessChanged=d=>this._context.setMeetingMediaAccess(this._callIdRef.callId,d.meetingMediaAccess),this._callIdRef=e,this._context=i,this._mediaAccessCallFeature=r;const o=this._mediaAccessCallFeature.getAllOthersMediaAccess(),l=this._mediaAccessCallFeature.getMeetingMediaAccess();this._context.setMediaAccesses(this._callIdRef.callId,o),this._context.setMeetingMediaAccess(this._callIdRef.callId,l),this.subscribe()}}class a6t{constructor(e,i,r){this._safeSubscribeInitCaptionSubscriber=()=>{this._safeSubscribe(this.initCaptionSubscriber)},this._safeSubscribeInitTeamsMeetingConference=()=>{this._safeSubscribe(this.initTeamsMeetingConference)},this.subscribe=()=>{this._call.on("stateChanged",this.stateChanged),this._call.on("stateChanged",this._safeSubscribeInitCaptionSubscriber),this._call.on("stateChanged",this._safeSubscribeInitTeamsMeetingConference),this._call.on("idChanged",this.idChanged),this._call.on("isScreenSharingOnChanged",this.isScreenSharingOnChanged),this._call.on("remoteParticipantsUpdated",this.remoteParticipantsUpdated),this._call.on("localVideoStreamsUpdated",this.localVideoStreamsUpdated),this._call.on("isMutedChanged",this.isMuteChanged),this._call.on("roleChanged",this.callRoleChangedHandler),this._call.feature(Ma.DominantSpeakers).on("dominantSpeakersChanged",this.dominantSpeakersChanged),this._call.on("mutedByOthers",this.mutedByOthersHandler);for(const o of this._call.localVideoStreams)this._internalContext.setLocalRenderInfo(this._callIdRef.callId,o.mediaStreamType,o,"NotRendered",void 0);this._call.remoteParticipants.length>0&&(this._call.remoteParticipants.forEach(o=>{this.addParticipantListener(o)}),this._context.setCallRemoteParticipants(this._callIdRef.callId,this._call.remoteParticipants.map(vZ),[]))},this.unsubscribe=()=>{var o,l,d;this._call.off("stateChanged",this.stateChanged),this._call.off("stateChanged",this._safeSubscribeInitCaptionSubscriber),this._call.off("stateChanged",this._safeSubscribeInitTeamsMeetingConference),this._call.off("idChanged",this.idChanged),this._call.off("isScreenSharingOnChanged",this.isScreenSharingOnChanged),this._call.off("remoteParticipantsUpdated",this.remoteParticipantsUpdated),this._call.off("localVideoStreamsUpdated",this.localVideoStreamsUpdated),this._call.off("isMutedChanged",this.isMuteChanged),this._call.off("roleChanged",this.callRoleChangedHandler),this._call.off("mutedByOthers",this.mutedByOthersHandler),this._participantSubscribers.forEach(h=>{h.unsubscribe()}),this._participantSubscribers.clear();for(const h of this._call.localVideoStreams){const p=h.mediaStreamType;iF(this._context,this._internalContext,this._callIdRef.callId,void 0,v4(h)),this._internalContext.deleteLocalRenderInfo(this._callIdRef.callId,p)}this._diagnosticsSubscriber.unsubscribe(),this._recordingSubscriber.unsubscribe(),this._transcriptionSubscriber.unsubscribe(),this._optimalVideoCountSubscriber.unsubscribe(),this._pptLiveSubscriber.unsubscribe(),(o=this._CaptionsFeatureSubscriber)===null||o===void 0||o.unsubscribe(),(l=this._raiseHandSubscriber)===null||l===void 0||l.unsubscribe(),this._capabilitiesSubscriber.unsubscribe(),(d=this._reactionSubscriber)===null||d===void 0||d.unsubscribe(),this._spotlightSubscriber.unsubscribe(),this._breakoutRoomsSubscriber.unsubscribe(),this._mediaAccessSubscriber.unsubscribe()},this.stateChanged=()=>{this._context.setCallState(this._callIdRef.callId,this._call.state)},this.initCaptionSubscriber=()=>{this._call.state==="Connected"&&!this._CaptionsFeatureSubscriber&&(this._CaptionsFeatureSubscriber=new Ojt(this._callIdRef,this._context,this._call.feature(Ma.Captions)),this._call.off("stateChanged",this._safeSubscribeInitCaptionSubscriber))},this.initTeamsMeetingConference=()=>{this._call.state==="Connected"&&pjt(this._call)&&(this._call.feature(Ma.TeamsMeetingAudioConferencing).getTeamsMeetingAudioConferencingDetails().then(o=>{this._context.setTeamsMeetingConference(this._callIdRef.callId,o)}),this._call.off("stateChanged",this._safeSubscribeInitTeamsMeetingConference))},this.idChanged=()=>{this._internalContext.setCallId(this._call.id,this._callIdRef.callId),this._context.setCallId(this._call.id,this._callIdRef.callId),this._callIdRef.callId=this._call.id},this.isScreenSharingOnChanged=()=>{this._context.setCallIsScreenSharingOn(this._callIdRef.callId,this._call.isScreenSharingOn)},this.isMuteChanged=()=>{this._context.setCallIsMicrophoneMuted(this._callIdRef.callId,this._call.isMuted)},this.callRoleChangedHandler=()=>{this._context.setRole(this._callIdRef.callId,this._call.role)},this.mutedByOthersHandler=()=>{this._context.teeErrorToState({name:"mutedByOthers",message:"Muted by another participant"},"Call.mutedByOthers")},this.remoteParticipantsUpdated=o=>{o.added.forEach(l=>{this.addParticipantListener(l)}),o.removed.forEach(l=>{this.removeParticipantListener(l)}),this._context.setCallRemoteParticipantsEnded(this._callIdRef.callId,o.removed.map(vZ),o.added.map(l=>Ga(l.identifier))),this._context.setCallRemoteParticipants(this._callIdRef.callId,o.added.map(vZ),o.removed.map(l=>Ga(l.identifier)))},this.localVideoStreamsUpdated=o=>{var l,d;for(const h of o.added){const p=h.mediaStreamType;this._internalContext.setLocalRenderInfo(this._callIdRef.callId,p,h,"NotRendered",void 0),(l=this._localVideoStreamVideoEffectsSubscribers.get(p))===null||l===void 0||l.unsubscribe(),this._localVideoStreamVideoEffectsSubscribers.set(p,new m4e({parent:this._callIdRef,context:this._context,localVideoStream:h,localVideoStreamEffectsAPI:h.feature(Ma.VideoEffects)}))}for(const h of o.removed){const p=h.mediaStreamType;(d=this._localVideoStreamVideoEffectsSubscribers.get(p))===null||d===void 0||d.unsubscribe(),iF(this._context,this._internalContext,this._callIdRef.callId,void 0,v4(h)),this._internalContext.deleteLocalRenderInfo(this._callIdRef.callId,p)}this._context.setCallLocalVideoStream(this._callIdRef.callId,o.added.map(v4),o.removed.map(v4))},this.dominantSpeakersChanged=()=>{const o=this._call.feature(Ma.DominantSpeakers).dominantSpeakers;this._context.setCallDominantSpeakers(this._callIdRef.callId,o)},this._call=e,this._callIdRef={callId:e.id},this._context=i,this._internalContext=r,this._diagnosticsSubscriber=new Jjt(this._callIdRef,this._context,this._call.feature(Ma.UserFacingDiagnostics)),this._participantSubscribers=new Map,this._recordingSubscriber=new Gjt(this._callIdRef,this._context,this._call.feature(Ma.Recording)),this._pptLiveSubscriber=new Wjt(this._callIdRef,this._context,this._call),this._transcriptionSubscriber=new Kjt(this._callIdRef,this._context,this._call.feature(Ma.Transcription)),this._raiseHandSubscriber=new Yjt(this._callIdRef,this._context,this._call.feature(Ma.RaiseHand)),this._reactionSubscriber=new Xjt(this._callIdRef,this._context,this._call.feature(Ma.Reaction)),this._optimalVideoCountSubscriber=new Qjt({callIdRef:this._callIdRef,context:this._context,localOptimalVideoCountFeature:this._call.feature(Ma.OptimalVideoCount)}),this._localVideoStreamVideoEffectsSubscribers=new Map,this._capabilitiesSubscriber=new Zjt(this._callIdRef,this._context,this._call.feature(Ma.Capabilities)),this._spotlightSubscriber=new e6t(this._callIdRef,this._context,this._call.feature(Ma.Spotlight)),this._context.deleteLatestNotification("assignedBreakoutRoomClosed"),this._breakoutRoomsSubscriber=new i6t(this._callIdRef,this._context,this._call.feature(Ma.BreakoutRooms)),this._mediaAccessSubscriber=new n6t(this._callIdRef,this._context,this._call.feature(Ma.MediaAccess)),this.subscribe()}_safeSubscribe(e){try{e()}catch(i){this._context.teeErrorToState(i,"Call.on")}}addParticipantListener(e){var i;const r=Ga(e.identifier);(i=this._participantSubscribers.get(r))===null||i===void 0||i.unsubscribe(),this._participantSubscribers.set(r,new jjt(this._callIdRef,e,this._context,this._internalContext))}removeParticipantListener(e){const i=Ga(e.identifier),r=this._participantSubscribers.get(i);r&&(r.unsubscribe(),this._participantSubscribers.delete(i))}}class r6t{constructor(e,i){this.subscribe=()=>{this._incomingCall.on("callEnded",this.callEnded)},this.unsubscribe=()=>{this._incomingCall.off("callEnded",this.callEnded)},this.callEnded=r=>{this._setIncomingCallEnded(this._incomingCall.id,r.callEndReason)},this._incomingCall=e,this._setIncomingCallEnded=i,this.subscribe()}}var y4e=function(t,e,i,r){function o(l){return l instanceof i?l:new i(function(d){d(l)})}return new(i||(i=Promise))(function(l,d){function h(f){try{g(r.next(f))}catch(y){d(y)}}function p(f){try{g(r.throw(f))}catch(y){d(y)}}function g(f){f.done?l(f.value):o(f.value).then(h,p)}g((r=r.apply(t,e||[])).next())})};class o6t{constructor(e){this._context=e}get(e,i){switch(i){case"accept":return this._context.withAsyncErrorTeedToState(function(...r){return y4e(this,void 0,void 0,function*(){return yield e.accept(...r)})},"IncomingCall.accept");case"reject":return this._context.withAsyncErrorTeedToState(function(...r){return y4e(this,void 0,void 0,function*(){return yield e.reject(...r)})},"IncomingCall.reject");default:return Reflect.get(e,i)}}}const s6t=(t,e)=>{const i=new o6t(e);return new Proxy(t,i)};var S4e=function(t,e,i,r){function o(l){return l instanceof i?l:new i(function(d){d(l)})}return new(i||(i=Promise))(function(l,d){function h(f){try{g(r.next(f))}catch(y){d(y)}}function p(f){try{g(r.throw(f))}catch(y){d(y)}}function g(f){f.done?l(f.value):o(f.value).then(h,p)}g((r=r.apply(t,e||[])).next())})};class l6t{constructor(e){this._context=e}get(e,i){switch(i){case"accept":return this._context.withAsyncErrorTeedToState(function(...r){return S4e(this,void 0,void 0,function*(){return yield e.accept(...r)})},"IncomingCall.accept");case"reject":return this._context.withAsyncErrorTeedToState(function(...r){return S4e(this,void 0,void 0,function*(){return yield e.reject(...r)})},"IncomingCall.reject");default:return Reflect.get(e,i)}}}const c6t=(t,e)=>{const i=new l6t(e);return new Proxy(t,i)};var d6t=function(t,e,i,r){function o(l){return l instanceof i?l:new i(function(d){d(l)})}return new(i||(i=Promise))(function(l,d){function h(f){try{g(r.next(f))}catch(y){d(y)}}function p(f){try{g(r.throw(f))}catch(y){d(y)}}function g(f){f.done?l(f.value):o(f.value).then(h,p)}g((r=r.apply(t,e||[])).next())})};class b4e{constructor(e,i){this.unregisterSubscriber=()=>{for(const[r,o]of this._callSubscribers.entries())o.unsubscribe();this._callSubscribers.clear();for(const[r,o]of this._incomingCallSubscribers.entries())o.unsubscribe();this._incomingCallSubscribers.clear(),this._incomingCalls.clear();for(const[r,o]of this._declarativeCalls.entries())o.unsubscribe();this._declarativeCalls.clear()},this.callsUpdated=r=>{const o=[];for(const d of r.added){const h=this.addCall(d);o.push(h)}const l=[];for(const d of r.removed){f4e(this._context,this._internalContext,d.id);const h=this._callSubscribers.get(d);h&&(h.unsubscribe(),this._callSubscribers.delete(d)),this._context.setCallEnded(d.id,d.callEndReason);const p=this._declarativeCalls.get(d);p?(p.unsubscribe(),l.push(p),this._declarativeCalls.delete(d)):l.push(this.callDeclaratify(d,this._context))}for(const d of this._externalCallsUpdatedListeners)d({added:o,removed:l})},this.setIncomingCallEnded=(r,o)=>{const l=this._incomingCallSubscribers.get(r);l&&(l.unsubscribe(),this._incomingCallSubscribers.delete(r)),this._incomingCalls.delete(r),this._context.setIncomingCallEnded(r,o)},this.incomingCall=({incomingCall:r})=>{this._incomingCallSubscribers.has(r.id)||this._incomingCallSubscribers.set(r.id,new r6t(r,this.setIncomingCallEnded)),K3e(r)?this._incomingCalls.set(r.id,c6t(r,this._context)):this._incomingCalls.set(r.id,s6t(r,this._context)),this._context.setIncomingCall(mjt(r))},this.addCall=r=>{var o;return(o=this._callSubscribers.get(r))===null||o===void 0||o.unsubscribe(),this._context.setCall(gjt(r)),this._callSubscribers.set(r,new a6t(r,this._context,this._internalContext)),this.getOrCreateDeclarativeCall(r)},this.getOrCreateDeclarativeCall=r=>{const o=this._declarativeCalls.get(r);if(o)return o;const l=this.callDeclaratify(r,this._context);return this._declarativeCalls.set(r,l),l},this._context=e,this._internalContext=i,this._callSubscribers=new Map,this._incomingCallSubscribers=new Map,this._incomingCalls=new Map,this._declarativeCalls=new Map,this._externalCallsUpdatedListeners=new Set}getCommon(e,i){switch(i){case"startCall":return this._context.withErrorTeedToState((...r)=>{const o=this.startCall(e,r);return this.addCall(o),this.getOrCreateDeclarativeCall(o)},"CallAgent.startCall");case"join":return this._context.withErrorTeedToState((...r)=>{const o=this.joinCall(e,r);return this.addCall(o),this.getOrCreateDeclarativeCall(o)},"CallAgent.join");case"calls":return Array.from(this._declarativeCalls.values());case"on":return(...r)=>{if(r[0]==="callsUpdated"){const d=r[1];this._externalCallsUpdatedListeners.add(d)}else this.agentSubscribe(e,r)};case"off":return(...r)=>{if(r[0]==="callsUpdated"){const d=r[1];this._externalCallsUpdatedListeners.delete(d)}else this.agentUnsubscribe(e,r)};case"dispose":{const r=()=>d6t(this,void 0,void 0,function*(){return yield e.dispose(),Promise.resolve()});return()=>r().then(()=>{this.unsubscribe()})}case"incomingCalls":return Array.from(this._incomingCalls.values());default:return Reflect.get(e,i)}}}const T4e=(t,e)=>{Hjt(t,e),t.clearCallRelatedState(),e.clearCallRelatedState()};var jv=function(t,e,i,r){function o(l){return l instanceof i?l:new i(function(d){d(l)})}return new(i||(i=Promise))(function(l,d){function h(f){try{g(r.next(f))}catch(y){d(y)}}function p(f){try{g(r.throw(f))}catch(y){d(y)}}function g(f){f.done?l(f.value):o(f.value).then(h,p)}g((r=r.apply(t,e||[])).next())})};class C4e{constructor(e){this._context=e}unsubscribe(){}getContext(){return this._context}get(e,i){switch(i){case"mute":return this._context.withAsyncErrorTeedToState(function(...r){return jv(this,void 0,void 0,function*(){return yield e.mute(...r)})},"Call.mute");case"unmute":return this._context.withAsyncErrorTeedToState(function(...r){return jv(this,void 0,void 0,function*(){return yield e.unmute(...r)})},"Call.unmute");case"startVideo":return this._context.withAsyncErrorTeedToState(function(...r){return jv(this,void 0,void 0,function*(){return yield e.startVideo(...r)})},"Call.startVideo");case"stopVideo":return this._context.withAsyncErrorTeedToState(function(...r){return jv(this,void 0,void 0,function*(){return yield e.stopVideo(...r)})},"Call.stopVideo");case"startScreenSharing":return this._context.withAsyncErrorTeedToState(function(...r){return jv(this,void 0,void 0,function*(){return yield e.startScreenSharing(...r)})},"Call.startScreenSharing");case"stopScreenSharing":return this._context.withAsyncErrorTeedToState(function(...r){return jv(this,void 0,void 0,function*(){return yield e.stopScreenSharing(...r)})},"Call.stopScreenSharing");case"hold":return this._context.withAsyncErrorTeedToState(function(...r){return jv(this,void 0,void 0,function*(){return yield e.hold(...r)})},"Call.hold");case"resume":return this._context.withAsyncErrorTeedToState(function(...r){return jv(this,void 0,void 0,function*(){return yield e.resume(...r)})},"Call.resume");case"feature":return this._context.withErrorTeedToState((...r)=>{if(r[0]===Ma.Captions){const o=e.feature(Ma.Captions);let l;return o.captions.kind==="Captions"?(l=new h6t(this._context,e),{captions:new Proxy(o.captions,l),on:(...d)=>{if(d[0]==="CaptionsKindChanged"){const p=d[1],g=()=>{p()};return o.on("CaptionsKindChanged",g)}},off:(...d)=>{if(d[0]==="CaptionsKindChanged")return o.off("CaptionsKindChanged",d[1])}}):(l=new u6t(this._context,e),{captions:new Proxy(o.captions,l)})}if(r[0]===Ma.Transfer){const o=e.feature(Ma.Transfer),l=new g6t(this._context,e);return new Proxy(o,l)}if(r[0]===Ma.Spotlight){const o=e.feature(Ma.Spotlight),l=new p6t(this._context);return new Proxy(o,l)}return e.feature(...r)},"Call.feature");default:return Reflect.get(e,i)}}}class u6t{constructor(e,i){this._context=e,this._call=i}get(e,i){switch(i){case"startCaptions":return this._context.withAsyncErrorTeedToState((...r)=>jv(this,void 0,void 0,function*(){var o,l;this._context.setStartCaptionsInProgress(this._call.id,!0);try{const d=yield e.startCaptions(...r);return this._context.setSelectedSpokenLanguage(this._call.id,(l=(o=r[0])===null||o===void 0?void 0:o.spokenLanguage)!==null&&l!==void 0?l:"en-us"),d}catch(d){throw this._context.setStartCaptionsInProgress(this._call.id,!1),d}}),"Call.feature");case"stopCaptions":return this._context.withAsyncErrorTeedToState((...r)=>jv(this,void 0,void 0,function*(){const o=yield e.stopCaptions(...r);return this._context.setIsCaptionActive(this._call.id,!1),this._context.setStartCaptionsInProgress(this._call.id,!1),this._context.clearCaptions(this._call.id),o}),"Call.feature");case"setSpokenLanguage":return this._context.withAsyncErrorTeedToState((...r)=>jv(this,void 0,void 0,function*(){const o=yield e.setSpokenLanguage(...r);return this._context.setSelectedSpokenLanguage(this._call.id,r[0]),o}),"Call.feature");case"setCaptionLanguage":return this._context.withAsyncErrorTeedToState((...r)=>jv(this,void 0,void 0,function*(){const o=yield e.setCaptionLanguage(...r);return this._context.setSelectedCaptionLanguage(this._call.id,r[0]),o}),"Call.feature");default:return Reflect.get(e,i)}}}class h6t{constructor(e,i){this._context=e,this._call=i}get(e,i){switch(i){case"startCaptions":return this._context.withAsyncErrorTeedToState((...r)=>jv(this,void 0,void 0,function*(){var o,l;this._context.setStartCaptionsInProgress(this._call.id,!0);try{const d=yield e.startCaptions(...r);return this._context.setSelectedSpokenLanguage(this._call.id,(l=(o=r[0])===null||o===void 0?void 0:o.spokenLanguage)!==null&&l!==void 0?l:"en-us"),d}catch(d){throw this._context.setStartCaptionsInProgress(this._call.id,!1),d}}),"Call.feature");case"stopCaptions":return this._context.withAsyncErrorTeedToState((...r)=>jv(this,void 0,void 0,function*(){const o=yield e.stopCaptions(...r);return this._context.setIsCaptionActive(this._call.id,!1),this._context.setStartCaptionsInProgress(this._call.id,!1),this._context.clearCaptions(this._call.id),o}),"Call.feature");case"setSpokenLanguage":return this._context.withAsyncErrorTeedToState((...r)=>jv(this,void 0,void 0,function*(){const o=yield e.setSpokenLanguage(...r);return this._context.setSelectedSpokenLanguage(this._call.id,r[0]),o}),"Call.feature");default:return Reflect.get(e,i)}}}class p6t{constructor(e){this._context=e}get(e,i){switch(i){case"startSpotlight":return this._context.withAsyncErrorTeedToState((...r)=>jv(this,void 0,void 0,function*(){return yield e.startSpotlight(...r)}),"Call.feature");case"stopSpotlight":return this._context.withAsyncErrorTeedToState((...r)=>jv(this,void 0,void 0,function*(){return yield e.stopSpotlight(...r)}),"Call.feature");default:return Reflect.get(e,i)}}}class g6t{constructor(e,i){this._context=e,this._call=i}get(e,i){switch(i){case"on":return(...r)=>{if(r[0]==="transferAccepted"){const l=r[1],d=h=>{this._context.setAcceptedTransfer(this._call.id,{callId:h.targetCall.id,timestamp:new Date}),l(h)};return e.on("transferAccepted",d)}};default:return Reflect.get(e,i)}}}var m6t=function(t,e,i,r){function o(l){return l instanceof i?l:new i(function(d){d(l)})}return new(i||(i=Promise))(function(l,d){function h(f){try{g(r.next(f))}catch(y){d(y)}}function p(f){try{g(r.throw(f))}catch(y){d(y)}}function g(f){f.done?l(f.value):o(f.value).then(h,p)}g((r=r.apply(t,e||[])).next())})};class f6t extends C4e{get(e,i){switch(i){case"addParticipant":return this.getContext().withAsyncErrorTeedToState(function(...r){return m6t(this,void 0,void 0,function*(){return yield e.addParticipant(...r)})},"Call.addParticipant");default:return super.get(e,i)}}}const v6t=(t,e)=>{const i=new f6t(e);return Object.defineProperty(t,"unsubscribe",{configurable:!1,value:()=>i.unsubscribe()}),new Proxy(t,i)};class y6t extends b4e{constructor(e,i,r){super(i,r),this.subscribe=()=>{this._callAgent.on("callsUpdated",this.callsUpdated),this._callAgent.on("incomingCall",this.incomingCall);for(const o of this._callAgent.calls)this.addCall(o)},this.unsubscribe=()=>{this._callAgent.off("callsUpdated",this.callsUpdated),this._callAgent.off("incomingCall",this.incomingCall),this.unregisterSubscriber()},this._callAgent=e,this.subscribe()}callDeclaratify(e,i){if(Sge(e))return v6t(e,i);throw new Error("Not reachable code, DeclarativeCallAgent.callDeclaratify must be called with an ACS call.")}startCall(e,i){if(h8(e))return e.startCall(...i);throw Error("Unreachable code, DeclarativeCallAgent.startCall must be called with an ACS callAgent.")}joinCall(e,i){if(h8(e))return e.join(...i);throw Error("Unreachable code, DeclarativeCallAgent.joinCall must be called with an ACS callAgent.")}agentSubscribe(e,i){if(h8(e))return e.on(...i);throw Error("Unreachable code, DeclarativeCallAgent.agentSubscribe must be called with an ACS callAgent.")}agentUnsubscribe(e,i){if(h8(e))return e.off(...i);throw Error("Unreachable code, DeclarativeCallAgent.agentUnsubscribe must be called with an ACS callAgent.")}get(e,i){return super.getCommon(e,i)}}const S6t=(t,e,i)=>(T4e(e,i),new Proxy(t,new y6t(t,e,i)));class b6t{constructor(){this._remoteRenderInfos=new Map,this._localRenderInfos=new Map,this._unparentedRenderInfos=new Map,this._callIdHistory=new u4e,this._unparentedViewVideoEffectsSubscriber=new Map}setCallId(e,i){this._callIdHistory.updateCallIdHistory(e,i);const r=this._remoteRenderInfos.get(i);r&&(this._remoteRenderInfos.delete(i),this._remoteRenderInfos.set(e,r));const o=this._localRenderInfos.get(i);o&&(this._localRenderInfos.delete(i),this._localRenderInfos.set(e,o))}getCallIds(){return this._remoteRenderInfos.keys()}getRemoteRenderInfoForCall(e){return this._remoteRenderInfos.get(this._callIdHistory.latestCallId(e))}getRemoteRenderInfoForParticipant(e,i,r){const o=this._remoteRenderInfos.get(this._callIdHistory.latestCallId(e));if(!o)return;const l=o.get(i);if(l)return l.get(r)}setRemoteRenderInfo(e,i,r,o,l,d){let h=this._remoteRenderInfos.get(this._callIdHistory.latestCallId(e));h||(h=new Map,this._remoteRenderInfos.set(this._callIdHistory.latestCallId(e),h));let p=h.get(i);p||(p=new Map,h.set(i,p)),p.set(r,{stream:o,status:l,renderer:d})}deleteRemoteRenderInfo(e,i,r){const o=this._remoteRenderInfos.get(this._callIdHistory.latestCallId(e));if(!o)return;const l=o.get(i);l&&l.delete(r)}setLocalRenderInfo(e,i,r,o,l){let d=this._localRenderInfos.get(this._callIdHistory.latestCallId(e));d||(d=new Map,this._localRenderInfos.set(this._callIdHistory.latestCallId(e),d)),d.set(i,{stream:r,status:o,renderer:l})}getLocalRenderInfosForCall(e){return this._localRenderInfos.get(this._callIdHistory.latestCallId(e))}getLocalRenderInfo(e,i){const r=this._localRenderInfos.get(this._callIdHistory.latestCallId(e));if(r)return r.get(i)}deleteLocalRenderInfo(e,i){const r=this._localRenderInfos.get(this._callIdHistory.latestCallId(e));r&&r.delete(i)}getUnparentedRenderInfo(e){return this._unparentedRenderInfos.get(e.mediaStreamType)}getUnparentedRenderInfos(){return[...this._unparentedRenderInfos].map(([,e])=>e.stream)}setUnparentedRenderInfo(e,i,r,o){this._unparentedRenderInfos.set(e.mediaStreamType,{stream:i,status:r,renderer:o})}deleteUnparentedRenderInfo(e){var i;(i=this._unparentedViewVideoEffectsSubscriber.get(e.mediaStreamType))===null||i===void 0||i.unsubscribe(),this._unparentedRenderInfos.delete(e.mediaStreamType)}subscribeToUnparentedViewVideoEffects(e,i){var r;(r=this._unparentedViewVideoEffectsSubscriber.get(e.mediaStreamType))===null||r===void 0||r.unsubscribe(),this._unparentedViewVideoEffectsSubscriber.set(e.mediaStreamType,new m4e({parent:"unparented",context:i,localVideoStream:e,localVideoStreamEffectsAPI:e.feature(Ma.VideoEffects)}))}clearCallRelatedState(){this._remoteRenderInfos.clear(),this._localRenderInfos.clear()}}class T6t extends C4e{get(e,i){return super.get(e,i)}}const C6t=(t,e)=>{const i=new T6t(e);return i.unsubscribe(),Object.defineProperty(t,"unsubscribe",{configurable:!1,value:()=>i.unsubscribe()}),new Proxy(t,i)};class _6t extends b4e{constructor(e,i,r){super(i,r),this.subscribe=()=>{this._callAgent.on("callsUpdated",this.callsUpdated),this._callAgent.on("incomingCall",this.incomingCall);for(const o of this._callAgent.calls)this.addCall(o)},this.unsubscribe=()=>{this._callAgent.off("callsUpdated",this.callsUpdated),this._callAgent.off("incomingCall",this.incomingCall),this.unregisterSubscriber()},this._callAgent=e,this.subscribe()}callDeclaratify(e,i){if(bge(e))return C6t(e,i);throw new Error("Not reachable code, DeclarativeTeamsCallAgent.callDeclaratify must be called with an TeamsCall.")}startCall(e,i){if(f4(e))return e.startCall(...i);throw new Error("Not reachable code, DeclarativeTeamsCallAgent.startCall must be called with an TeamsCallAgent.")}joinCall(e,i){if(f4(e))return e.join(...i);throw new Error("Not reachable code, DeclarativeTeamsCallAgent.joinCall must be called with an TeamsCallAgent.")}agentSubscribe(e,i){if(f4(e)){e.on(...i);return}throw new Error("Not reachable code, DeclarativeTeamsCallAgent.agentSubscribe must be called with an TeamsCallAgent.")}agentUnsubscribe(e,i){if(f4(e)){e.off(...i);return}throw new Error("Not reachable code, DeclarativeTeamsCallAgent.agentUnsubscribe must be called with an TeamsCallAgent.")}get(e,i){return super.getCommon(e,i)}}const E6t=(t,e,i)=>(T4e(e,i),new Proxy(t,new _6t(t,e,i)));var A6t=function(t,e,i,r){function o(l){return l instanceof i?l:new i(function(d){d(l)})}return new(i||(i=Promise))(function(l,d){function h(f){try{g(r.next(f))}catch(y){d(y)}}function p(f){try{g(r.throw(f))}catch(y){d(y)}}function g(f){f.done?l(f.value):o(f.value).then(h,p)}g((r=r.apply(t,e||[])).next())})};class I6t{constructor(e,i,r,o){this._context=e,this._callId=i,this._participantId=r,this._streamId=o}get(e,i){switch(i){case"updateScalingMode":return(...r)=>A6t(this,void 0,void 0,function*(){yield e.updateScalingMode(...r),this._context.setRemoteVideoStreamViewScalingMode(this._callId,this._participantId,this._streamId,r[0])});default:return Reflect.get(e,i)}}}const w6t=(t,e,i,r,o)=>{const l=new I6t(e,i,r,o);return new Proxy(t,l)};var b8=function(t,e,i,r){function o(l){return l instanceof i?l:new i(function(d){d(l)})}return new(i||(i=Promise))(function(l,d){function h(f){try{g(r.next(f))}catch(y){d(y)}}function p(f){try{g(r.throw(f))}catch(y){d(y)}}function g(f){f.done?l(f.value):o(f.value).then(h,p)}g((r=r.apply(t,e||[])).next())})};class k6t{constructor(e,i){this._context=e,this._internalContext=i}get(e,i){switch(i){case"createCallAgent":return this._context.withAsyncErrorTeedToState((...r)=>b8(this,void 0,void 0,function*(){const o=yield e.createCallAgent(...r);return this._callAgent=S6t(o,this._context,this._internalContext),this._context.setCallAgent({displayName:this._callAgent.displayName}),this._callAgent}),"CallClient.createCallAgent");case"createTeamsCallAgent":return this._context.withAsyncErrorTeedToState((...r)=>b8(this,void 0,void 0,function*(){const o=yield e.createTeamsCallAgent(...r);return this._callAgent=E6t(o,this._context,this._internalContext),this._context.setCallAgent({displayName:void 0}),this._callAgent}),"CallClient.createTeamsCallAgent");case"getDeviceManager":return this._context.withAsyncErrorTeedToState(()=>b8(this,void 0,void 0,function*(){const r=yield e.getDeviceManager();if(this._sdkDeviceManager){if(this._sdkDeviceManager===r)return this._deviceManager;throw new Error("Multiple DeviceManager not supported. This means a incompatible version of communication-calling is used OR calling declarative was not properly updated to communication-calling version.")}else this._sdkDeviceManager=r;return this._deviceManager=hjt(r,this._context,this._internalContext),this._deviceManager}),"CallClient.getDeviceManager");case"feature":return this._context.withErrorTeedToState((...r)=>{if(r[0]===Ma.DebugInfo){const o=e.feature(Ma.DebugInfo);return Object.assign(Object.assign({},o),{getEnvironmentInfo:()=>b8(this,void 0,void 0,function*(){const l=yield o.getEnvironmentInfo();return this._context.setEnvironmentInfo(l),l})})}return Reflect.get(e,i)},"CallClient.feature");default:return Reflect.get(e,i)}}}const _4e=(t,e,i="StatefulComponents")=>(Zg.info(`Creating calling stateful client using library version: ${$K(i)}`),R6t(new kk(M6t(i,void 0)),new Pjt(Ap(t.userId),void 0),new b6t)),R6t=(t,e,i)=>{Object.defineProperty(t,"getState",{configurable:!1,value:()=>e.getState()}),Object.defineProperty(t,"onStateChange",{configurable:!1,value:o=>e.onStateChange(o)}),Object.defineProperty(t,"offStateChange",{configurable:!1,value:o=>e.offStateChange(o)}),Object.defineProperty(t,"createView",{configurable:!1,value:(o,l,d,h)=>b8(void 0,void 0,void 0,function*(){const p=l?Ap(l):void 0,g=yield $jt(e,i,o,p,d,h);if("id"in d&&o&&l&&g){const f=Ga(l);g.view=w6t(g.view,e,o,f,d.id)}return g})}),Object.defineProperty(t,"disposeView",{configurable:!1,value:(o,l,d)=>{const h=l?Ap(l):void 0;iF(e,i,o,h,d)}});const r=new Proxy(t,new k6t(e,i));return r.feature(Ma.DebugInfo).getEnvironmentInfo(),r},M6t=(t,e)=>{var i,r;const o=(r=(i=void 0)===null||i===void 0?void 0:i.tags)!==null&&r!==void 0?r:[];return o.push($K(t)),Object.assign(Object.assign({},e),{diagnostics:Object.assign(Object.assign({},void 0),{tags:o})})},P6t=It({minHeight:"2.125rem",flexFlow:"column-reverse"}),D6t=It({fontWeight:400,width:"100%",alignSelf:"center",wordBreak:"break-word"}),E4e={participantItem:{isMeText:"(you)",menuTitle:"More Options",removeButtonLabel:"Remove",sharingIconLabel:"Sharing",mutedIconLabel:"Muted",handRaisedIconLabel:"Hand raised - Position {position}",displayNamePlaceholder:"Unnamed participant",participantStateRinging:"Calling...",participantStateHold:"On hold",participantItemAriaLabel:"{displayName}, {handRaisedState}, {mutedState}, {micDisabledState}, {cameraDisabledState}, {sharingState}, {connectionState}",participantItemWithMoreOptionsAriaLabel:"{displayName}, {handRaisedState}, {mutedState}, {micDisabledState}, {cameraDisabledState}, {sharingState}, {connectionState}, More Options",attendeeRole:"Attendee",micDisabledIconLabel:"Micophone disabled",cameraDisabledIconLabel:"Camera disabled"},ParticipantList:{overflowParticipantCount:"+{overflowCount} more"},typingIndicator:{singleUser:"{user} is typing ...",multipleUsers:"{users} are typing ...",multipleUsersAbbreviateOne:"{users} and 1 other are typing ...",multipleUsersAbbreviateMany:"{users} and {numOthers} others are typing ...",delimiter:", "},sendBox:{placeholderText:"Enter a message",textTooLong:"Your message length is over the maximum limit.",sendButtonAriaLabel:"Send message",attachmentUploadsPendingError:"File is uploading, please wait.",removeAttachment:"Remove file",uploading:"Uploading",uploadCompleted:"Upload completed",attachmentMoreMenu:"More Options"},richTextSendBox:{placeholderText:"Enter a message",textTooLong:"Your message length is over the maximum limit.",sendButtonAriaLabel:"Send message",attachmentUploadsPendingError:"File is uploading, please wait.",imageUploadsPendingError:"Image is uploading, please wait.",removeAttachment:"Remove file",uploading:"Uploading",uploadCompleted:"Upload completed",richTextBoldTooltip:"Bold",richTextItalicTooltip:"Italic",richTextUnderlineTooltip:"Underline",richTextBulletListTooltip:"Bulleted list",richTextNumberListTooltip:"Numbered list",richTextIncreaseIndentTooltip:"Increase indent",richTextDecreaseIndentTooltip:"Decrease indent",richTextInsertTableTooltip:"Insert table",richTextFormatButtonTooltip:"Format",richTextInsertRowOrColumnMenu:"Insert",richTextInsertTableMenuTitle:"Insert {column} x {row} table",richTextInsertRowAboveMenu:"Insert above",richTextInsertRowBelowMenu:"Insert below",richTextInsertColumnLeftMenu:"Insert left",richTextInsertColumnRightMenu:"Insert right",richTextDeleteRowOrColumnMenu:"Delete",richTextDeleteColumnMenu:"Delete column",richTextDeleteRowMenu:"Delete row",richTextDeleteTableMenu:"Delete table",richTextToolbarAriaLabel:"Message Formatting Toolbar",richTextToolbarMoreButtonAriaLabel:"More options",attachmentMoreMenu:"More Options",richTextNewBulletedListItemAnnouncement:"Bullet, new line",richTextNewNumberedListItemAnnouncement:"{0}, new line",richTextBulletedListAppliedAnnouncement:"Bulleted list applied",richTextNumberedListAppliedAnnouncement:"Numbered list applied"},realTimeTextModal:{realTimeTextModalAriaLabel:"Turn on RTT Modal",realTimeTextModalTitle:"Turn on RTT?",realTimeTextModalText:"Real-time text (RTT) will be turned on for everyone in the meeting.",realTimeTextConfirmButtonLabel:"Turn on",realTimeTextCancelButtonLabel:"Cancel",realTimeTextCloseModalButtonAriaLabel:"Close RTT Modal"},captionsBanner:{captionsBannerSpinnerText:"Starting captions...",realTimeTextInputBoxDefaultText:"Type message in real time",realTimeTextInputErrorMessage:"Message can not exceed 2000 characters",realTimeTextBannerTitle:"RTT",realTimeTextBannerContent:"RTT (real-time text) is enabled for all participants for the entire duration of the meeting.",realTimeTextBannerLinkLabel:"Learn more",captionsOnlyContainerTitle:"Captions",realTimeTextOnlyContainerTitle:"Real-Time Text",captionsAndRealTimeTextContainerTitle:"Captions and Real-Time Text",expandButtonAriaLabel:"Expand",minimizeButtonAriaLabel:"Collapse"},mentionPopover:{mentionPopoverHeader:"Suggestions"},imageOverlay:{downloadButtonLabel:"Download",dismissButtonAriaLabel:"Close",overlayVisibleMessage:"Image Details Overlay"},messageStatusIndicator:{deliveredAriaLabel:"Message sent",deliveredTooltipText:"Sent",seenAriaLabel:"Message seen by others",seenTooltipText:"Seen",readByTooltipText:"Read by {messageThreadReadCount} of {remoteParticipantsCount}",sendingAriaLabel:"Message sending",sendingTooltipText:"Sending",failedToSendAriaLabel:"Message failed to send",failedToSendTooltipText:"Failed to send"},endCallButton:{label:"Leave",tooltipContent:"Leave call",leaveOption:"Leave",endCallOption:"End call for everyone"},cameraButton:{onLabel:"Camera",offLabel:"Camera",tooltipDisabledContent:"Camera is disabled",tooltipOnContent:"Turn off camera",tooltipOffContent:"Turn on camera",tooltipVideoLoadingContent:"Video is loading",cameraMenuTitle:"Camera",cameraMenuTooltip:"Choose camera",cameraButtonSplitRoleDescription:"Split button",onSplitButtonAriaLabel:"Turn off camera",offSplitButtonAriaLabel:"Turn on camera",cameraActionTurnedOnAnnouncement:"Your camera has been turned on",cameraActionTurnedOffAnnouncement:"Your camera has been turned off",onSplitButtonPrimaryActionCamera:"Turn off camera",offSplitButtonPrimaryActionCamera:"Turn on camera",cameraPrimaryActionSplitButtonTitle:"Use camera",videoEffectsMenuItemTitle:"Effects",cameraButtonAriaDescription:"camera options"},microphoneButton:{onLabel:"Mic",offLabel:"Mic",tooltipDisabledContent:"Microphone is disabled",tooltipOnContent:"Mute microphone",tooltipOffContent:"Unmute microphone",microphoneMenuTitle:"Microphone",microphoneMenuTooltip:"Choose microphone",speakerMenuTitle:"Speaker",speakerMenuTooltip:"Choose speaker",microphoneButtonSplitRoleDescription:"Split button",onSplitButtonAriaLabel:"Mute mic",offSplitButtonAriaLabel:"Unmute mic",microphoneActionTurnedOnAnnouncement:"Your microphone has been turned on",microphoneActionTurnedOffAnnouncement:"Your microphone has been turned off",offSplitButtonMicrophonePrimaryAction:"Unmute mic",onSplitButtonMicrophonePrimaryAction:"Mute mic",microphonePrimaryActionSplitButtonTitle:"Use microphone",microphoneAriaDescription:"Audio options",deepNoiseSuppressionTitle:"Noise suppression",deepNoiseSuppressionOnAnnouncement:"Deep noise suppression has been turned on",deepNoiseSuppressionOffAnnouncement:"Deep noise suppression has been turned off"},devicesButton:{label:"Devices",tooltipContent:"Manage devices",cameraMenuTitle:"Camera",cameraMenuTooltip:"Choose camera",audioDeviceMenuTitle:"Audio Device",audioDeviceMenuTooltip:"Choose audio device",microphoneMenuTitle:"Microphone",microphoneMenuTooltip:"Choose microphone",speakerMenuTitle:"Speaker",speakerMenuTooltip:"Choose speaker"},participantsButton:{label:"People",ariaLabel:"People",tooltipContent:"Show participants",menuHeader:"In this call",participantsListButtonLabel:"{numParticipants} people",muteAllButtonLabel:"Mute all",copyInviteLinkButtonLabel:"Copy invite link",copyInviteLinkActionedAriaLabel:"Invite link copied"},screenShareButton:{onLabel:"Stop presenting",offLabel:"Present",tooltipDisabledContent:"Presenting is disabled",tooltipOnContent:"Presenting your screen",tooltipOffContent:"Present your screen"},raiseHandButton:{offLabel:"Raise",onLabel:"Lower",tooltipDisabledContent:"Raise Hand action is disabled",tooltipOnContent:"Lower Hand",tooltipOffContent:"Raise Hand"},reactionButton:{label:"React",ariaLabel:"React",tooltipDisabledContent:"Reaction action is disabled",tooltipContent:"Send a reaction",likeReactionTooltipContent:"Like",heartReactionTooltipContent:"Love",laughReactionTooltipContent:"Laugh",applauseReactionTooltipContent:"Applause",surprisedReactionTooltipContent:"Surprised"},realTimeText:{isTypingText:"RTT typing"},captionsSettingsModal:{captionsSettingsModalTitle:"Captions Settings",captionsSettingsSpokenLanguageDropdownLabel:"Spoken language",captionsSettingsCaptionLanguageDropdownLabel:"Captions language",captionsSettingsSpokenLanguageDropdownInfoText:"Language that everyone on this call is speaking.",captionsSettingsCaptionLanguageDropdownInfoText:"Captions will appear in this langugage.",captionsSettingsConfirmButtonLabel:"Confirm",captionsSettingsCancelButtonLabel:"Cancel",captionsSettingsModalAriaLabel:"Captions Setting Modal",captionsSettingsCloseModalButtonAriaLabel:"Close Captions Setting"},spokenLanguages:{"ar-ae":"Arabic - U.A.E.","ar-sa":"Arabic - Saudi Arabia","da-dk":"Danish","de-de":"German - Germany","en-au":"English - Australia","en-ca":"English - Canada","en-gb":"English - United Kingdom","en-in":"English - India","en-nz":"English - New Zealand","en-us":"English - United States","es-es":"Spanish - Spain (Modern Sort)","es-mx":"Spanish - Mexico","fi-fi":"Finnish","fr-ca":"French - Canada","fr-fr":"French - France","hi-in":"Hindi","it-it":"Italian - Italy","ja-jp":"Japanese","ko-kr":"Korean","nb-no":"Norwegian (Bokmål)","nl-be":"Dutch - Belgium","nl-nl":"Dutch - Netherlands","pl-pl":"Polish","pt-br":"Portuguese - Brazil","ru-ru":"Russian","sv-se":"Swedish","zh-cn":"Chinese - People's Republic of China","zh-hk":"Chinese - Hong Kong SAR","cs-cz":"Czech","pt-pt":"Portuguese - Portugal","tr-tr":"Turkish","vi-vn":"Vietnamese","th-th":"Thai","he-il":"Hebrew","cy-gb":"Welsh","uk-ua":"Ukrainian","el-gr":"Greek","hu-hu":"Hungarian","ro-ro":"Romanian","sk-sk":"Slovak","zh-tw":"Chinese - Taiwan"},captionLanguages:{ar:"Arabic",da:"Danish",de:"German",en:"English",es:"Spanish",fi:"Finnish","fr-ca":"French - Canada",fr:"French - France",hi:"Hindi",it:"Italian",ja:"Japanese",ko:"Korean",nb:"Norwegian (Bokmål)",nl:"Dutch",pl:"Polish",pt:"Portuguese - Brazil",ru:"Russian",sv:"Swedish","zh-Hans":"Chinese (Simplified)","zh-Hant":"Chinese (Traditional)",cs:"Czech","pt-pt":"Portuguese - Portugal",tr:"Turkish",vi:"Vietnamese",th:"Thai",he:"Hebrew",cy:"Welsh",uk:"Ukrainian",el:"Greek",hu:"Hungarian",ro:"Romanian",sk:"Slovak"},startCaptionsButton:{onLabel:"Turn on captions",offLabel:"Turn off captions",tooltipOnContent:"Turn off captions",tooltipOffContent:"Turn on captions"},startRealTimeTextButton:{label:"Turn on RTT for this call",tooltipOffContent:"Turn on RTT for this call"},messageThread:{yesterday:"Yesterday",sunday:"Sunday",monday:"Monday",tuesday:"Tuesday",wednesday:"Wednesday",thursday:"Thursday",friday:"Friday",saturday:"Saturday",participantJoined:"joined the chat.",participantLeft:"left the chat.",editMessage:"Edit",removeMessage:"Delete",resendMessage:"Try sending again",failToSendTag:"Failed to send",editedTag:"Edited",liveAuthorIntro:"Message from {author}",editedMessageLiveAuthorIntro:"Edited message from {author}",editedMessageLocalUserLiveAuthorIntro:"Edited message",messageContentAriaText:"{status} {author} said {message}",messageContentMineAriaText:"{status} You said {message}",editBoxTextLimit:"Your message is over the limit of {limitNumber} characters",editBoxPlaceholderText:"Edit your message",newMessagesIndicator:"New messages",noDisplayNameSub:"No name",editBoxCancelButton:"Cancel",editBoxSubmitButton:"Done",messageReadCount:"Read by {messageReadByCount} of {remoteParticipantsCount}",actionMenuMoreOptions:"More Options",downloadAttachment:"Download file",openAttachment:"Open file",blockedWarningText:"This message was deleted due to organizational policy.",blockedWarningLinkText:"Details",attachmentCardGroupMessage:"The message has {attachmentCount} attachment",messageDeletedAnnouncementAriaLabel:"The message is deleted",richTextBoldTooltip:"Bold",richTextItalicTooltip:"Italic",richTextUnderlineTooltip:"Underline",richTextBulletListTooltip:"Bulleted list",richTextNumberListTooltip:"Numbered list",richTextIncreaseIndentTooltip:"Increase indent",richTextDecreaseIndentTooltip:"Decrease indent",richTextInsertTableTooltip:"Insert table",richTextFormatButtonTooltip:"Format",richTextInsertRowOrColumnMenu:"Insert",richTextInsertTableMenuTitle:"Insert {column} x {row} table",richTextInsertRowAboveMenu:"Insert above",richTextInsertRowBelowMenu:"Insert below",richTextInsertColumnLeftMenu:"Insert left",richTextInsertColumnRightMenu:"Insert right",richTextDeleteRowOrColumnMenu:"Delete",richTextDeleteColumnMenu:"Delete column",richTextDeleteRowMenu:"Delete row",richTextDeleteTableMenu:"Delete table",richTextToolbarMoreButtonAriaLabel:"More options",attachmentUploadsPendingError:"File is uploading, please wait.",imageUploadsPendingError:"Image is uploading, please wait.",richTextNewBulletedListItemAnnouncement:"Bullet, new line",richTextNewNumberedListItemAnnouncement:"{0}, new line",richTextBulletedListAppliedAnnouncement:"Bulleted list applied",richTextNumberedListAppliedAnnouncement:"Numbered list applied"},errorBar:{unableToReachChatService:"You are offline",accessDenied:"Unable to access chat services - please check the user credentials provided",userNotInChatThread:"You are no longer in this chat thread",sendMessageNotInChatThread:"Failed to send message because you are no longer in this chat thread",sendMessageGeneric:"Failed to send message",callingNetworkFailure:"Troubling connecting call - you seem to be offline",startVideoGeneric:"Failed to start video",stopVideoGeneric:"Failed to stop video",muteGeneric:"Failed to mute microphone",unmuteGeneric:"Failed to unmute microphone",speakingWhileMuted:"Your microphone is muted",startScreenShareGeneric:"There was an issue starting screen share.",stopScreenShareGeneric:"Failed to stop screen sharing",callNetworkQualityLow:"Network quality is low.",teamsMeetingCallNetworkQualityLow:"Network quality is low.",callNoSpeakerFound:"No speakers or headphones found. Connect an audio device to hear the call.",callNoMicrophoneFound:"No microphones found. Connect an audio input device.",callMicrophoneAccessDenied:"Unable to access microphone. Click the lock in the address bar to grant permission to this webpage.",callMicrophoneAccessDeniedSafari:"Unable to access microphone. Refresh the page to allow permissions, or check this browser’s settings and verify permissions are enabled for this website.",callMicrophoneMutedBySystem:"You are muted by your system.",callMicrophoneUnmutedBySystem:"Your microphone recovered and you were unmuted by your system.",callMacOsMicrophoneAccessDenied:"Unable to access microphone. Grant microphone permission in your macOS privacy settings.",callLocalVideoFreeze:"Network bandwidth is poor. Your video may appear paused for others on the call.",callCameraAccessDenied:"Unable to access camera. Click the lock in the address bar to grant permission to this webpage.",callCameraAccessDeniedSafari:"Unable to access camera. Refresh the page to allow permissions, or check this browser’s settings and verify permissions are enabled for this website.",callCameraAlreadyInUse:"Unable to access camera. It may already be in use by another application.",callVideoStoppedBySystem:"Your video has been stopped by your system.",callVideoRecoveredBySystem:"Your video has resumed.",callMacOsCameraAccessDenied:"MacOS is blocking access to your camera. Update your privacy settings to allow this browser to access your camera.",callMacOsScreenShareAccessDenied:"MacOS is blocking screen sharing. Update your privacy settings to allow this browser to record your screen.",dismissButtonAriaLabel:"Close",failedToJoinCallGeneric:"Failed to join call.",failedToJoinCallInvalidMeetingLink:"Unable to join Meeting. Invalid Link.",cameraFrozenForRemoteParticipants:"Users in the call are having issues seeing your video. Please check your devices and network.",unableToStartVideoEffect:"Unable to apply video effect.",startSpotlightWhileMaxParticipantsAreSpotlighted:"Cannot start spotlight on participant(s) because the maximum number of participants are already spotlighted.",mutedByRemoteParticipant:"You were muted by another participant."},notificationStack:{callingNetworkFailure:{title:"Troubling connecting call",message:"You seem to be offline. Please check your network connection and try again.",dismissButtonAriaLabel:"Close"},startVideoGeneric:{title:"Failed to start video.",dismissButtonAriaLabel:"Close"},stopVideoGeneric:{title:"Failed to stop video.",dismissButtonAriaLabel:"Close"},muteGeneric:{title:"Failed to mute microphone.",dismissButtonAriaLabel:"Close"},unmuteGeneric:{title:"Failed to unmute microphone.",dismissButtonAriaLabel:"Close"},speakingWhileMuted:{title:"You're muted.",dismissButtonAriaLabel:"Close"},startScreenShareGeneric:{title:"There was an issue starting screen share.",dismissButtonAriaLabel:"Close"},stopScreenShareGeneric:{title:"Failed to stop screen sharing.",dismissButtonAriaLabel:"Close"},callNetworkQualityLow:{title:"Network quality is low.",dismissButtonAriaLabel:"Close"},teamsMeetingCallNetworkQualityLow:{title:"Network quality is low.",dismissButtonAriaLabel:"Close",message:"Join this call from your phone for better sound. You can continue viewing the meeting on this device.",primaryButtonLabel:"Join by Phone"},callNoSpeakerFound:{title:"No speakers or headphones found",message:"Connect an audio device to hear the call.",dismissButtonAriaLabel:"Close"},callNoMicrophoneFound:{title:"No microphones found",message:"Connect an audio input device.",dismissButtonAriaLabel:"Close"},callMicrophoneAccessDenied:{title:"Unable to access microphone",message:"Click the lock in the address bar to grant permission to this webpage.",dismissButtonAriaLabel:"Close"},callMicrophoneAccessDeniedSafari:{title:"Unable to access microphone",message:"Refresh the page to allow permissions, or check this browser’s settings and verify permissions are enabled for this website.",dismissButtonAriaLabel:"Close"},callMicrophoneMutedBySystem:{title:"You are muted by your system.",dismissButtonAriaLabel:"Close"},callMicrophoneUnmutedBySystem:{title:"Your microphone recovered and you were unmuted by your system.",dismissButtonAriaLabel:"Close"},callMacOsMicrophoneAccessDenied:{title:"Unable to access microphone",message:"Grant microphone permission in your macOS privacy settings.",dismissButtonAriaLabel:"Close"},callLocalVideoFreeze:{title:"Network bandwidth is poor",message:"Your video may appear paused for others on the call.",dismissButtonAriaLabel:"Close"},callCameraAccessDenied:{title:"Unable to access camera",message:"Click the lock in the address bar to grant permission to this webpage.",dismissButtonAriaLabel:"Close"},callCameraAccessDeniedSafari:{title:"Unable to access camera",message:"Refresh the page to allow permissions, or check this browser’s settings and verify permissions are enabled for this website.",dismissButtonAriaLabel:"Close"},callCameraAlreadyInUse:{title:"Unable to access camera",message:"It may already be in use by another application.",dismissButtonAriaLabel:"Close"},callVideoStoppedBySystem:{title:"Your video has been stopped by your system.",dismissButtonAriaLabel:"Close"},callVideoRecoveredBySystem:{title:"Your video has resumed.",dismissButtonAriaLabel:"Close"},callMacOsCameraAccessDenied:{title:"MacOS is blocking access to your camera",message:"Update your privacy settings to allow this browser to access your camera.",dismissButtonAriaLabel:"Close"},callMacOsScreenShareAccessDenied:{title:"MacOS is blocking screen sharing",message:"Update your privacy settings to allow this browser to record your screen.",dismissButtonAriaLabel:"Close"},failedToJoinCallGeneric:{title:"Failed to join call.",dismissButtonAriaLabel:"Close"},failedToJoinCallInvalidMeetingLink:{title:"Unable to join Meeting. Invalid Link.",dismissButtonAriaLabel:"Close"},cameraFrozenForRemoteParticipants:{title:"Users in the call are having issues seeing your video",message:"Please check your devices and network.",dismissButtonAriaLabel:"Close"},unableToStartVideoEffect:{title:"Unable to apply video effect.",dismissButtonAriaLabel:"Close"},startSpotlightWhileMaxParticipantsAreSpotlighted:{title:"Cannot start spotlight on participant(s)",message:"The maximum number of participants are already spotlighted.",dismissButtonAriaLabel:"Close"},mutedByRemoteParticipant:{title:"You were muted by another participant.",dismissButtonAriaLabel:"Close"},recordingStarted:{title:"Recording has started.",message:"By joining, you are giving consent for this meeting to be transcribed.",dismissButtonAriaLabel:"Close"},transcriptionStarted:{title:"Transcription has started.",message:"By joining, you are giving consent for this meeting to be transcribed.",dismissButtonAriaLabel:"Close"},recordingStopped:{title:"Recording is being saved.",message:"Recording has stopped.",dismissButtonAriaLabel:"Close"},transcriptionStopped:{title:"Transcription is being saved.",message:"Transcription has stopped.",dismissButtonAriaLabel:"Close"},recordingAndTranscriptionStarted:{title:"Recording and transcription have started.",message:"By joining, you are giving consent for this meeting to be transcribed.",dismissButtonAriaLabel:"Close"},recordingAndTranscriptionStopped:{title:"Recording and transcription are being saved.",message:"Recording and transcription have stopped.",dismissButtonAriaLabel:"Close"},recordingStoppedStillTranscribing:{title:"Recording has stopped.",message:"You are now only transcribing this meeting.",dismissButtonAriaLabel:"Close"},transcriptionStoppedStillRecording:{title:"Transcription has stopped.",message:"You are now only recording this meeting.",dismissButtonAriaLabel:"Close"},assignedBreakoutRoomOpened:{title:"We'll move you to your assigned room in 5 seconds.",dismissButtonAriaLabel:"Close"},assignedBreakoutRoomChanged:{title:"Your breakout room has changed",message:"We'll move you to your assigned room in 5 seconds.",dismissButtonAriaLabel:"Close"},assignedBreakoutRoomClosed:{title:"Your breakout room has closed",message:"We'll move you back to your meeting in 5 seconds.",dismissButtonAriaLabel:"Close"},assignedBreakoutRoomOpenedPromptJoin:{title:"Join breakout room?",message:"You've been assigned to a breakout room.",dismissButtonAriaLabel:"Close",primaryButtonLabel:"Join room",secondaryButtonLabel:"Later"},breakoutRoomJoined:{title:"You have joined a breakout room.",dismissButtonAriaLabel:"Close"},breakoutRoomClosingSoon:{title:"Room time limit about to expire.",message:"This room will close in 30 seconds",dismissButtonAriaLabel:"Close"},capabilityTurnVideoOnPresent:{title:"Your camera has been enabled",message:"Turn it on if you'd like to share video.",dismissButtonAriaLabel:"Close"},capabilityTurnVideoOnAbsent:{title:"Your camera has been disabled",message:"You can no longer share video.",dismissButtonAriaLabel:"Close"},capabilityUnmuteMicPresent:{title:"Your mic has been enabled",message:"Unmute if you'd like to speak.",dismissButtonAriaLabel:"Close"},capabilityUnmuteMicAbsent:{title:"Your mic has been disabled",message:"You can no longer unmute.",dismissButtonAriaLabel:"Close"},togetherModeStarted:{title:"Togethermode has started",dismissButtonAriaLabel:"Close"},togetherModeEnded:{title:"Togethermode has ended",dismissButtonAriaLabel:"Close"}},videoGallery:{screenIsBeingSharedMessage:"You are sharing your screen",screenShareLoadingMessage:"Loading {participant}'s screen",localScreenShareLoadingMessage:"Loading your screen",localVideoLabel:"You",localVideoCameraSwitcherLabel:"Switch camera",localVideoMovementLabel:"Movable Local Video Tile",localVideoMovementAriaLabel:"Movable Local Video Tile",localVideoSelectedDescription:"{cameraName} selected",displayNamePlaceholder:"Unnamed participant",fitRemoteParticipantToFrame:"Fit to frame",fillRemoteParticipantFrame:"Fill frame",pinParticipantForMe:"Pin for me",pinParticipantForMeLimitReached:"Pin (limit reached)",unpinParticipantForMe:"Unpin",pinParticipantMenuItemAriaLabel:"Pin {participantName}",unpinParticipantMenuItemAriaLabel:"Unpin {participantName}",pinnedParticipantAnnouncementAriaLabel:"Pinned {participantName}",unpinnedParticipantAnnouncementAriaLabel:"Unpinned {participantName}",startSpotlightVideoTileMenuLabel:"Spotlight for everyone",addSpotlightVideoTileMenuLabel:"Add spotlight",spotlightLimitReachedMenuTitle:"Spotlight limit reached",stopSpotlightVideoTileMenuLabel:"Stop spotlighting",stopSpotlightOnSelfVideoTileMenuLabel:"Exit spotlight",attendeeRole:"Attendee",muteParticipantMenuItemLabel:"Mute",waitingScreenText:"Waiting for others to join",forbidAudio:"Disable mic",permitAudio:"Allow mic",forbidAudioTileMenuLabel:"Disable mic",permitAudioTileMenuLabel:"Allow mic",forbidVideo:"Disable camera",permitVideo:"Allow camera",forbidVideoTileMenuLabel:"Disable camera",permitVideoTileMenuLabel:"Allow camera"},dialpad:{placeholderText:"Enter phone number",deleteButtonAriaLabel:"Delete"},holdButton:{onLabel:"Resume",offLabel:"Hold",tooltipOnContent:"Resume call",tooltipOffContent:"Hold call"},videoTile:{participantStateRinging:"Calling...",participantReconnecting:"Reconnecting...",participantStateHold:"On hold",moreOptionsButtonAriaLabel:"More Options {displayName} {isMuted} {micDisabledState} {cameraDisabledState} {isHandRaised} {state} {isSpeaking}",moreOptionsParticipantMutedStateMutedAriaLabel:"muted",moreOptionsParticipantMutedStateUnmutedAriaLabel:"unmuted",moreOptionsParticipantHandRaisedAriaLabel:"Hand raised",moreOptionsParticipantIsSpeakingAriaLabel:"Speaking",moreOptionsParticipantMicDisabledAriaLabel:"Microphone disabled",moreOptionsParticipantCameraDisabledAriaLabel:"Camera disabled"},CameraAndMicrophoneSitePermissionsRequest:{primaryText:"Allow {appName} to use your camera and microphone",secondaryText:"This is so participants can see and hear you.",linkText:"Need help? Get troubleshooting help",primaryButtonText:"Continue without camera and microphone",ariaLabel:"Allow camera and microphone access"},CameraSitePermissionsRequest:{primaryText:"Allow {appName} to use your camera",secondaryText:"This is so participants can see you.",linkText:"Need help? Get troubleshooting help",primaryButtonText:"Continue without camera",ariaLabel:"Allow camera access"},MicrophoneSitePermissionsRequest:{primaryText:"Allow {appName} to use your microphone",secondaryText:"This is so participants can hear you.",linkText:"Need help? Get troubleshooting help",primaryButtonText:"Continue without microphone",ariaLabel:"Allow microphone access"},CameraAndMicrophoneSitePermissionsCheck:{primaryText:"Checking for camera and microphone access",secondaryText:"Allow access if prompted. This is so participants can see and hear you.",linkText:"Need help? Get troubleshooting help",primaryButtonText:"Continue without camera and microphone",ariaLabel:"Checking for camera and microphone access. Allow access if prompted."},CameraSitePermissionsCheck:{primaryText:"Checking for camera access",secondaryText:"Allow access if prompted. This is so participants can see you.",linkText:"Need help? Get troubleshooting help",primaryButtonText:"Continue without camera",ariaLabel:"Checking for camera access. Allow access if prompted."},MicrophoneSitePermissionsCheck:{primaryText:"Checking for microphone access",secondaryText:"Allow access if prompted. This is so participants can hear you.",linkText:"Need help? Get troubleshooting help",primaryButtonText:"Continue without microphone",ariaLabel:"Checking for microphone access. Allow access if prompted."},CameraAndMicrophoneSitePermissionsDenied:{primaryText:"Unable to access camera and microphone",secondaryText:"Click the lock icon in the address bar to grant microphone permissions to this webpage. A page refresh may be required.",primaryButtonText:"Continue without camera and microphone",linkText:"Need help? Get troubleshooting help"},CameraAndMicrophoneSitePermissionsDeniedSafari:{primaryText:"Unable to access camera and microphone",secondaryText:"Refresh the page to allow permissions, or check this browser’s settings and verify permissions are enabled for this website.",primaryButtonText:"Continue without camera and microphone",linkText:"Need help? Get troubleshooting help"},CameraSitePermissionsDenied:{primaryText:"Unable to access camera",secondaryText:"Click the lock icon in the address bar to grant camera permissions to this webpage. A page refresh may be required.",primaryButtonText:"Continue without camera",linkText:"Need help? Get troubleshooting help"},MicrophoneSitePermissionsDenied:{primaryText:"Unable to access microphone",secondaryText:"Click the lock icon in the address bar to grant microphone permissions to this webpage. A page refresh may be required.",primaryButtonText:"Continue without microphone",linkText:"Need help? Get troubleshooting help"},CameraSitePermissionsDeniedSafari:{primaryText:"Unable to access camera",secondaryText:"Refresh the page to allow permissions, or check this browser’s settings and verify permissions are enabled for this website.",primaryButtonText:"Continue without camera",linkText:"Need help? Get troubleshooting help"},MicrophoneSitePermissionsDeniedSafari:{primaryText:"Unable to access microphone",secondaryText:"Refresh the page to allow permissions, or check this browser’s settings and verify permissions are enabled for this website.",primaryButtonText:"Continue without microphone",linkText:"Need help? Get troubleshooting help"},UnsupportedBrowser:{primaryText:"Browser not supported",secondaryText:"Please join this call using a compatible browser.",moreHelpLinkText:"See compatibility requirements"},UnsupportedBrowserVersion:{primaryText:"Browser update needed",secondaryText:"To ensure the best call possible, please update your browser and then try joining the call again.",moreHelpLinkText:"See compatibility requirements",continueAnywayButtonText:"Start call without updating"},UnsupportedOperatingSystem:{primaryText:"Operating system not supported",secondaryText:"Please join this call using a device with a compatible operating system.",moreHelpLinkText:"See compatibility requirements"},BrowserPermissionDenied:{primaryText:"Can't use your camera or microphone",secondaryText:"Your browser might not have access to your camera or microphone. To fix this, open System Preferences.",primaryButtonText:"Try again",linkText:"Need help? Get troubleshooting help"},BrowserPermissionDeniedIOS:{primaryText:"Allow microphone access to continue",secondaryText:"So other participants can hear you.",primaryButtonText:"Try again",imageAltText:"Microphone and camera device permission location for iOS",linkText:"Need help? Get troubleshooting help",step1Text:"Go to the Settings app",step2Text:"Scroll down to settings for this browser",step3Text:"Turn on Microphone (Camera optional)",step4Text:"Try joining the call again",step1DigitText:"1",step2DigitText:"2",step3DigitText:"3",step4DigitText:"4"},verticalGallery:{leftNavButtonAriaLabel:"previous page {current} of {total}",rightNavButtonAriaLabel:"next page {current} of {total}"},meetingConferencePhoneInfo:{meetingConferencePhoneInfoModalTitle:"Join call from your phone",meetingConferencePhoneInfoModalDialIn:"Dial number",meetingConferencePhoneInfoModalMeetingId:"Enter meeting ID",meetingConferencePhoneInfoModalWait:"Wait to be admitted by organizer",meetingConferencePhoneInfoModalNoPhoneAvailable:"No phone available",meetingConferencePhoneInfoModalTollGeoData:"{country}, {city}",meetingConferencePhoneInfoModalTollFree:"(Toll-free)",meetingConferencePhoneInfoModalToll:"(Toll)"},IncomingCallNotification:{incomingCallNotificationPlaceholderId:"Unknown User",incomingCallNotificationPlaceholderAlert:"{callerName} is calling",incomingCallNoticicationAcceptWithAudioAriaLabel:"Accept with audio",incomingCallNoticicationAcceptWithVideoAriaLabel:"Accept with video",incomingCallNoticicationRejectAriaLabel:"Reject",incomingCallNotificationAcceptButtonLabel:"Accept",incomingCallNotificationRejectButtonLabel:"Decline",incomingCallNotificationAccceptWithVideoButtonLabel:"Accept with Video",incomingCallNotificationDismissButtonAriaLabel:"Dismiss"}},A4e={strings:E4e},I4e=$.createContext(A4e),L6t=t=>{const{locale:e,children:i}=t;return U.createElement(I4e.Provider,{value:e},i)},Kl=()=>$.useContext(I4e),O6t={sendboxTextField:"sendbox-textfield",participantButtonPeopleMenuItem:"participant-button-people-menu-item",participantItemMenuButton:"participant-item-menu-button",participantList:"participant-list",participantListPeopleButton:"participant-list-people-button",participantListRemoveParticipantButton:"participant-list-remove-participant-button",messageContent:"message-content",messageTimestamp:"message-timestamp",typingIndicator:"typing-indicator",videoGallery:"video-gallery",videoTile:"video-tile",overflowGalleryLeftNavButton:"overflow-gallery-left-nav-button",overflowGalleryRightNavButton:"overflow-gallery-right-nav-button",verticalGalleryVideoTile:"vertical-gallery-video-tile",horizontalGalleryVideoTile:"horizontal-gallery-video-tile",verticalGalleryPageCounter:"vertical-gallery-page-counter"},N6t=$.createContext(O6t),qE=()=>$.useContext(N6t),x6t=35,B6t=(t,e,i,r)=>{const o=[];return t.forEach((l,d)=>{let h=l.displayName;h&&h.length>50&&(h=h.substring(0,50)+"..."),o.push(i?i(l):U.createElement(ja,{className:It(r),key:`user-${d}`},h)),o.push(U.createElement(ja,{key:`comma-${d}`},`${e}`))}),o.pop(),U.createElement(U.Fragment,null,o)},F6t=(t,e)=>{const i=[];return t.forEach(r=>{r.displayName&&i.push(r.displayName)}),i.join(e)},U6t=(t,e,i,r)=>{let o={},l="";return i===1?(l=t.singleUser,o={user:e}):i>1&&r===0?(l=t.multipleUsers,o={users:e}):i>1&&r===1?(l=t.multipleUsersAbbreviateOne,o={users:e}):i>1&&r>1&&(l=t.multipleUsersAbbreviateMany,o={users:e,numOthers:U.createElement(U.Fragment,null,r)}),$6t(l,o)},z6t=(t,e,i,r)=>{if(i===1)return t.singleUser.replace("{user}",e);if(i>1&&r===0)return t.multipleUsers.replace("{users}",e);if(i>1&&r===1)return t.multipleUsersAbbreviateOne.replace("{users}",e);if(i>1&&r>1)return t.multipleUsersAbbreviateMany.replace("{users}",e).replace("{numOthers}",`${r}`)},V6t=(t,e,i,r)=>{const o=[];let l=0;const d=qE();for(const y of t){if(!y.displayName)continue;let T=y.displayName.length;if(o.length>0&&(T+=e.delimiter.length),l+T<=x6t||o.length===0)o.push(y),l+=T;else break}const h=B6t(o,e.delimiter,i,r?.typingUserDisplayName),p=t.length-o.length,g=U6t(e,h,t.length,p),f=z6t(e,F6t(o,e.delimiter),t.length,p);return U.createElement("div",{"data-ui-id":d.typingIndicator,className:It(D6t,r?.typingString),key:"typingStringKey",role:"status","aria-label":f},g)},Nge=t=>{const{typingUsers:e,onRenderUser:i,styles:r}=t,{strings:o}=Kl(),l=e.filter(h=>h.displayName!==void 0),d=V6t(l,Object.assign(Object.assign({},o.typingIndicator),t.strings),i,r);return U.createElement(Et,{className:It(P6t,r?.root)},d)},$6t=(t,e)=>{if(!t)return[];if(!e)return[];const i=[],o=RegExp(/{(\w+)}/g);let l=o.exec(t),d=0;for(;l!==null;)d!==l.index&&i.push(U.createElement(ja,{key:i.length},t.substring(d,l.index))),i.push(U.createElement(ja,{key:i.length},e[l[0].substring(1,l[0].length-1)])),d=o.lastIndex,l=o.exec(t);return i.push(U.createElement(ja,{key:i.length},t.substring(d))),i},H6t=(t,e)=>{var i;const r=new Date(Date.now());for(const l of t)if(l.type===e.type)return l.dismissedAt=r,l.activeSince=e.timestamp,Array.from(t);const o=(i=e.timestamp)!==null&&i!==void 0?i:r;return[...t,{type:e.type,dismissedAt:r>o?r:o,activeSince:e.timestamp}]},j6t=(t,e)=>{const i=new Map;for(const o of t)i.set(o.type,o);const r=o=>o.activeSince===void 0&&i.get(o.type)===void 0;return e.some(o=>r(o))?e.filter(o=>!r(o)):e},G6t=(t,e)=>{var i;const r=new Date(Date.now());for(const l of t)if(l.type===e.type)return l.dismissedAt=r,l.activeSince=e.timestamp,Array.from(t);const o=(i=e.timestamp)!==null&&i!==void 0?i:r;return[...t,{type:e.type,dismissedAt:r>o?r:o,activeSince:e.timestamp}]},q6t=(t,e)=>{const i=new Map;for(const o of t)i.set(o.type,o);const r=o=>o.activeSince===void 0&&i.get(o.type)===void 0;return e.some(o=>r(o))?e.filter(o=>!r(o)):e},W6t=(t,e,i)=>{const r=new Map;for(const o of e)r.set(o.type,o);return t.filter(o=>{if(i&&o.timestamp&&i>o.timestamp)return!1;const l=r.get(o.type);return l?o.timestamp?o.timestamp>l.dismissedAt:!1:!0})},K6t=(t,e,i)=>{const r=new Map;for(const o of e)r.set(o.type,o);return t.filter(o=>{if(i&&o.timestamp&&i>o.timestamp)return!1;const l=r.get(o.type);return l?o.timestamp?o.timestamp>l.dismissedAt:!1:!0})},J6t=t=>{switch(t){case"callNetworkQualityLow":case"callNoSpeakerFound":case"callNoMicrophoneFound":case"callMicrophoneAccessDenied":case"callMicrophoneAccessDeniedSafari":case"callMicrophoneMutedBySystem":case"callMicrophoneUnmutedBySystem":case"callMacOsMicrophoneAccessDenied":case"callLocalVideoFreeze":case"callCameraAccessDenied":case"callCameraAccessDeniedSafari":case"callCameraAlreadyInUse":case"callVideoStoppedBySystem":case"callVideoRecoveredBySystem":case"callMacOsCameraAccessDenied":case"callMacOsScreenShareAccessDenied":case"startScreenShareGeneric":case"cameraFrozenForRemoteParticipants":return qo.warning;default:return qo.error}},Y6t=t=>{const e=Q6t[t];return e?{iconName:e}:void 0},Q6t={callNetworkQualityLow:"ErrorBarCallNetworkQualityLow",callNoSpeakerFound:"ErrorBarCallNoSpeakerFound",callNoMicrophoneFound:"ErrorBarCallNoMicrophoneFound",callMicrophoneAccessDenied:"ErrorBarCallMicrophoneAccessDenied",callMicrophoneAccessDeniedSafari:"ErrorBarCallMicrophoneAccessDenied",callMicrophoneMutedBySystem:"ErrorBarCallMicrophoneMutedBySystem",callMicrophoneUnmutedBySystem:"ErrorBarCallMicrophoneUnmutedBySystem",callMacOsMicrophoneAccessDenied:"ErrorBarCallMacOsMicrophoneAccessDenied",callLocalVideoFreeze:"ErrorBarCallLocalVideoFreeze",callCameraAccessDenied:"ErrorBarCallCameraAccessDenied",callCameraAccessDeniedSafari:"ErrorBarCallCameraAccessDenied",callCameraAlreadyInUse:"ErrorBarCallCameraAlreadyInUse",callVideoStoppedBySystem:"ErrorBarCallVideoStoppedBySystem",callVideoRecoveredBySystem:"ErrorBarCallVideoRecoveredBySystem",callMacOsCameraAccessDenied:"ErrorBarCallMacOsCameraAccessDenied"},Z6t=t=>{const e=X6t[t];return e?{iconName:e}:void 0},X6t={callNetworkQualityLow:"ErrorBarCallNetworkQualityLow",teamsMeetingCallNetworkQualityLow:"ErrorBarCallNetworkQualityLow",callNoSpeakerFound:"ErrorBarCallNoSpeakerFound",callNoMicrophoneFound:"ErrorBarCallNoMicrophoneFound",callMicrophoneAccessDenied:"ErrorBarCallMicrophoneAccessDenied",callMicrophoneAccessDeniedSafari:"ErrorBarCallMicrophoneAccessDenied",callMicrophoneMutedBySystem:"ErrorBarCallMicrophoneMutedBySystem",callMicrophoneUnmutedBySystem:"ErrorBarCallMicrophoneUnmutedBySystem",callMacOsMicrophoneAccessDenied:"ErrorBarCallMacOsMicrophoneAccessDenied",callLocalVideoFreeze:"ErrorBarCallLocalVideoFreeze",callCameraAccessDenied:"ErrorBarCallCameraAccessDenied",callCameraAccessDeniedSafari:"ErrorBarCallCameraAccessDenied",callCameraAlreadyInUse:"ErrorBarCallCameraAlreadyInUse",callVideoStoppedBySystem:"ErrorBarCallVideoStoppedBySystem",callVideoRecoveredBySystem:"ErrorBarCallVideoRecoveredBySystem",callMacOsCameraAccessDenied:"ErrorBarCallMacOsCameraAccessDenied",mutedByRemoteParticipant:"ErrorBarMutedByRemoteParticipant",speakingWhileMuted:"ErrorBarCallMicrophoneMutedBySystem",recordingStarted:"NotificationBarRecording",transcriptionStarted:"NotificationBarRecording",recordingStopped:"NotificationBarRecording",transcriptionStopped:"NotificationBarRecording",recordingAndTranscriptionStarted:"NotificationBarRecording",recordingAndTranscriptionStopped:"NotificationBarRecording",recordingStoppedStillTranscribing:"NotificationBarRecording",transcriptionStoppedStillRecording:"NotificationBarRecording",assignedBreakoutRoomOpened:"NotificationBarBreakoutRoomOpened",assignedBreakoutRoomOpenedPromptJoin:"NotificationBarBreakoutRoomPromptJoin",assignedBreakoutRoomChanged:"NotificationBarBreakoutRoomChanged",assignedBreakoutRoomClosed:"NotificationBarBreakoutRoomClosed",breakoutRoomJoined:"NotificationBarBreakoutRoomJoined",breakoutRoomClosingSoon:"NotificationBarBreakoutRoomClosingSoon",capabilityTurnVideoOnPresent:"ControlButtonCameraOff",capabilityTurnVideoOnAbsent:"ControlButtonCameraProhibited",capabilityUnmuteMicPresent:"ControlButtonMicOff",capabilityUnmuteMicAbsent:"ControlButtonMicProhibited"};function e8t(t,e){const i=[];let r=[];for(const o of t)r.push(o),r.length===e&&(i.push(r),r=[]);return r.length>0&&i.push(r),i}const _Z="en-us",w4e=229,t8t=t=>(t.isComposing||t.keyCode===w4e||t.which===w4e)&&t.key==="Enter",i8t=(t,e,i,r,o,l,d,h)=>{const p=e?l?.moreOptionsParticipantMutedStateMutedAriaLabel:l?.moreOptionsParticipantMutedStateUnmutedAriaLabel,g=i?l?.moreOptionsParticipantHandRaisedAriaLabel:void 0,f=o?l?.moreOptionsParticipantIsSpeakingAriaLabel:void 0,y=d?l?.moreOptionsParticipantMicDisabledAriaLabel:void 0,T=h?l?.moreOptionsParticipantCameraDisabledAriaLabel:void 0;return l?.moreOptionsButtonAriaLabel?Jd(l?.moreOptionsButtonAriaLabel,{displayName:t??" ",isMuted:p??" ",isHandRaised:g??" ",state:r??" ",isSpeaking:f??" ",micDisabledState:y??" ",cameraDisabledState:T??" "}):""},jA=t=>{var e;const i=Kl().strings.errorBar,r=(e=t.strings)!==null&&e!==void 0?e:i,o=!t.onDismissError,l=$.useRef(new Date(Date.now())),[d,h]=$.useState([]);$.useEffect(()=>{o&&h(j6t(t.activeErrorMessages,d))},[t.activeErrorMessages,d,o]);const p=W6t(t.activeErrorMessages,d,t.ignorePremountErrors?l.current:void 0);return U.createElement(Et,{"data-ui-id":"notifications-stack"},p.map(g=>U.createElement(CW,Object.assign({},t,{styles:{innerText:{alignSelf:"center"},icon:{height:0},content:{lineHeight:"inherit"},dismissal:{height:"2rem",paddingBottom:"0.8rem"}},key:g.type,messageBarType:J6t(g.type),messageBarIconProps:Y6t(g.type),onDismiss:()=>{var f;return o?h(H6t(d,g)):(f=t.onDismissError)===null||f===void 0?void 0:f.call(t,g)},dismissButtonAriaLabel:`${r[g.type]}, ${r.dismissButtonAriaLabel}`,dismissIconProps:{iconName:"ErrorBarClear"}}),r[g.type])))},n8t=It({width:"100%",height:"100%",display:"grid",gridGap:"0.5rem"}),xge=t=>{const{children:e,styles:i}=t,r=U.Children.count(e),[o,l]=$.useState(0),[d,h]=$.useState(0),p=$.useRef(null),g=$.useRef(new ResizeObserver(T=>{if(!T[0])return;const{width:C,height:E}=T[0].contentRect;l(C),h(E)}));$.useEffect(()=>{p.current&&g.current.observe(p.current);const T=g.current;return()=>T.disconnect()},[g,p]);const f=$.useMemo(()=>r8t(r,o,d),[r,o,d]),y=$.useMemo(()=>o8t(r,f),[r,f]);return U.createElement("div",{ref:p,className:It(n8t,y,i?.root),"data-ui-id":"grid-layout"},e)},k4e=16/9,R4e=8/9,a8t=(t,e,i)=>Math.abs(i-t)<Math.abs(i-e),r8t=(t,e,i)=>{if(t<=0)return{fillDirection:"horizontal",rows:0,columns:0};if(e<=0||i<=0)return{fillDirection:"horizontal",rows:Math.ceil(Math.sqrt(t)),columns:Math.ceil(Math.sqrt(t))};const r=e/i;let o=Math.floor(Math.sqrt(k4e/r*t))||1;o=Math.min(o,t);let l=Math.ceil(t/o),d="horizontal";for(;o<t;){if(o/l*r<R4e){o+=1,l=Math.ceil(t/o);continue}if(t<o*l){const h=t>=o+(l-1)*(o-1),p=t>=l+(o-1)*(l-1);if(!h&&!p){o+=1,l=Math.ceil(t/o);continue}else if(h){if(!p){d="vertical";break}}else break;const g=o/(l-1)*r,f=(o-1)/l*r;f>=R4e&&a8t(f,g,k4e)&&(d="vertical")}break}return{fillDirection:d,rows:o,columns:l}},o8t=(t,e)=>{const i=e.fillDirection==="horizontal",r=i?e.rows:e.columns,o=Math.ceil(t/r),l=Math.floor(t/r),d=(e.rows*e.columns-t)*l,h=o*l,p=i?{gridTemplateColumns:`repeat(${h}, minmax(0, 1fr))`,gridTemplateRows:`repeat(${r}, minmax(0, 1fr))`,gridAutoFlow:"row"}:{gridTemplateColumns:`repeat(${r}, minmax(0, 1fr))`,gridTemplateRows:`repeat(${h}, minmax(0, 1fr))`,gridAutoFlow:"column"},g=i?{"> *":{gridColumn:`auto / span ${h/o}`}}:{"> *":{gridRow:`auto / span ${h/o}`}},f=d?{[`> *:nth-last-child(-n + ${d})`]:i?{gridColumn:`auto / span ${h/l}`}:{gridRow:`auto / span ${h/l}`}}:{};return It(p,g,f)},s8t=It({margin:"0.25rem",overflow:"hidden",":not(:first-child)":{marginTop:"0.25rem"}}),l8t=It({height:"2.25rem",width:"2.25rem"}),c8t=t=>{const{theme:e,isSendBoxButtonDisabled:i,customSendIconStyle:r,defaultTextColor:o=e.palette.neutralTertiary}=t;return It(M4e,{color:i?o:e.palette.themePrimary},r)},M4e={width:"1.25rem",height:"1.25rem",margin:"auto"};It({margin:"0 0.25rem 0.25rem 0.25rem",overflow:"auto"}),Lv({clearBackground:{backgroundColor:"transparent"}}),It({width:"100%",padding:"0.50rem"});const P4e=.0625,b4=.125,d8t=t=>It(u8t(Object.assign(Object.assign({},t),{defaultBorderColor:t.theme.palette.neutralSecondary}))),u8t=t=>{const{theme:e,hasErrorMessage:i,disabled:r,defaultBorderColor:o}=t,l=i?e.semanticColors.errorText:o,d=i?e.semanticColors.errorText:e.palette.themePrimary,h=r?0:P4e,p=r?0:b4;return{borderRadius:e.effects.roundedCorner4,border:`${h}rem solid ${l}`,margin:`${b4-h}rem`,":hover, :active, :focus, :focus-within":{border:`${p}rem solid ${d}`,margin:`${b4-p}rem`}}},EZ={palette:{themePrimary:"#0078d4",themeLighterAlt:"#eff6fc",themeLighter:"#deecf9",themeLight:"#c7e0f4",themeTertiary:"#71afe5",themeSecondary:"#2b88d8",themeDarkAlt:"#106ebe",themeDark:"#59b0f7",themeDarker:"#004578",neutralLighterAlt:"#faf9f8",neutralLighter:"#f3f2f1",neutralLight:"#edebe9",neutralQuaternaryAlt:"#e1dfdd",neutralQuaternary:"#d0d0d0",neutralTertiaryAlt:"#c8c6c4",neutralTertiary:"#a19f9d",neutralSecondary:"#605e5c",neutralPrimaryAlt:"#3b3a39",neutralPrimary:"#323130",neutralDark:"#201f1e",black:"#000000",white:"#ffffff",whiteTranslucent40:"rgba(255, 255, 255, 0.4)"},callingPalette:{callRed:"#a42e43",callRedDark:"#8b2c3d",callRedDarker:"#772a38",iconWhite:"#ffffff",raiseHandGold:"#eaa300",videoTileLabelBackgroundLight:"rgba(255,255,255,0.8)"},semanticColors:{errorText:"#a80000"}},T8=Object.assign(Object.assign({},rx(Object.assign(Object.assign({},{palette:{themePrimary:"#2899f5",themeLighterAlt:"#02060a",themeLighter:"#061827",themeLight:"#0c2e49",themeTertiary:"#185b93",themeSecondary:"#2286d7",themeDarkAlt:"#3ca2f6",themeDark:"#59b0f7",themeDarker:"#84c5f9",neutralLighterAlt:"#302e2d",neutralLighter:"#383735",neutralLight:"#464443",neutralQuaternaryAlt:"#4e4d4b",neutralQuaternary:"#4d4b49",neutralTertiaryAlt:"#72706e",neutralTertiary:"#c8c8c8",neutralSecondary:"#d0d0d0",neutralPrimaryAlt:"#dadada",neutralPrimary:"#ffffff",neutralDark:"#f4f4f4",black:"#f8f8f8",white:"#252423",whiteTranslucent40:"rgba(0, 0, 0, 0.4)"},semanticColors:{errorText:"#f1707b"}}),{isInverted:!0}))),{callingPalette:{callRed:"#c4314b",callRedDark:"#a42e43",callRedDarker:"#8b2c3d",iconWhite:"#ffffff",raiseHandGold:"#eaa300",videoTileLabelBackgroundLight:"rgba(37,36,35,0.8)"}}),h8t=It({height:"100%",width:"100%","*":{boxSizing:"border-box"},"*:before":{boxSizing:"border-box"},"*:after":{boxSizing:"border-box"},"[hidden]":{display:"none!important"}}),D4e=Object.assign({},q$(gEe(),EZ)),L4e=$.createContext(D4e),O4e=t=>{const{fluentTheme:e,rtl:i,children:r,rootStyle:o}=t,l=$.useMemo(()=>{const d=q$(D4e,e);return q$(d,{rtl:i})},[e,i]);return U.createElement(L4e.Provider,{value:l},U.createElement(oAe,{theme:l,className:h8t,style:o},r))},Cs=()=>$.useContext(L4e),N4e=()=>U.createElement(hRe,{style:{height:"1rem",width:"1rem"}}),p8t=()=>U.createElement("div",{className:It({transform:"scale(0.9)"})},U.createElement(GSt,null)),x4e=()=>Cs().rtl?U.createElement(Zke,null):U.createElement(Qke,null),B4e=()=>Cs().rtl?U.createElement(Qke,null):U.createElement(Zke,null),g8t=()=>U.createElement(tRe,null),m8t=()=>U.createElement(iRe,null),f8t={ChatMessageOptions:U.createElement(p8t,null),ControlButtonCameraOff:U.createElement(Dse,null),ControlButtonCameraOn:U.createElement(zH,null),ControlButtonEndCall:U.createElement(Ase,null),ControlButtonMicOff:U.createElement(Rse,null),ControlButtonMicOn:U.createElement(lK,null),ControlButtonOptions:U.createElement(cbt,null),ControlButtonParticipants:U.createElement(WSt,null),ControlButtonParticipantsContextualMenuItem:U.createElement(Mse,null),ControlButtonScreenShareStart:U.createElement(sRe,null),ControlButtonScreenShareStop:U.createElement(ubt,null),ControlButtonRaiseHand:U.createElement(g8t,null),ControlButtonLowerHand:U.createElement(m8t,null),ControlButtonMicProhibited:U.createElement(rRe,null),ControlButtonMicProhibitedSmall:U.createElement(cK,null),ControlButtonCameraProhibited:U.createElement(uRe,null),ControlButtonCameraProhibitedSmall:U.createElement(A5,null),RaiseHandContextualMenuItem:U.createElement(tRe,null),LowerHandContextualMenuItem:U.createElement(iRe,null),ReactionButtonIcon:U.createElement(xSt,null),OpenAttachment:U.createElement(qSt,null),EditBoxCancel:U.createElement(OSt,null),EditBoxSubmit:U.createElement(_St,null),ErrorBarCallCameraAccessDenied:U.createElement(A5,null),ErrorBarCallCameraAlreadyInUse:U.createElement(A5,null),ErrorBarCallLocalVideoFreeze:U.createElement(N4e,null),ErrorBarCallMacOsCameraAccessDenied:U.createElement(A5,null),ErrorBarCallMacOsMicrophoneAccessDenied:U.createElement(cK,null),ErrorBarCallMicrophoneAccessDenied:U.createElement(cK,null),ErrorBarCallMicrophoneMutedBySystem:U.createElement(nRe,null),ErrorBarCallMicrophoneUnmutedBySystem:U.createElement(HSt,null),ErrorBarCallNetworkQualityLow:U.createElement(N4e,null),ErrorBarCallNoMicrophoneFound:U.createElement(cK,null),ErrorBarCallNoSpeakerFound:U.createElement(hbt,null),ErrorBarClear:U.createElement(LSt,null),ErrorBarCallVideoRecoveredBySystem:U.createElement(bbt,null),ErrorBarCallVideoStoppedBySystem:U.createElement(A5,null),ErrorBarMutedByRemoteParticipant:U.createElement(nRe,null),NotificationBarRecording:U.createElement(abt,null),NotificationBarBreakoutRoomOpened:U.createElement(wse,null),NotificationBarBreakoutRoomPromptJoin:U.createElement(wse,null),NotificationBarBreakoutRoomChanged:U.createElement(wse,null),NotificationBarBreakoutRoomJoined:U.createElement(MSt,null),NotificationBarBreakoutRoomClosingSoon:U.createElement(eRe,null),NotificationBarBreakoutRoomClosed:U.createElement(eRe,null),HorizontalGalleryLeftButton:U.createElement(x4e,null),HorizontalGalleryRightButton:U.createElement(B4e,null),MessageDelivered:U.createElement(Yke,null),MessageEdit:U.createElement(NSt,null),MessageFailed:U.createElement(FSt,null),MessageRemove:U.createElement(DSt,null),MessageResend:U.createElement(dSt,null),MessageSeen:U.createElement(zSt,null),MessageSending:U.createElement(Xke,null),OptionsCamera:U.createElement(cRe,null),OptionsMic:U.createElement(kse,null),OptionsSpeaker:U.createElement(Pse,null),ParticipantItemMicOff:U.createElement(aRe,null),ParticipantItemOptions:U.createElement(U.Fragment,null),ParticipantItemOptionsHovered:U.createElement(dK,null),ParticipantItemScreenShareStart:U.createElement(sRe,null),ParticipantItemSpotlighted:U.createElement(Lse,null),HoldCallContextualMenuItem:U.createElement(vSt,null),HoldCallButton:U.createElement(fSt,null),ResumeCall:U.createElement(nbt,null),SendBoxSend:U.createElement(lbt,null),SendBoxSendHovered:U.createElement(sbt,null),VideoTileMicOff:U.createElement(jSt,null),VideoTileCameraOff:U.createElement(A5,null),DialpadBackspace:U.createElement(uSt,null),VideoTilePinned:U.createElement(XSt,null),ParticipantItemPinned:U.createElement(ebt,null),VideoTileMoreOptions:U.createElement(dK,null),VideoTileScaleFit:U.createElement(obt,null),VideoTileScaleFill:U.createElement(rbt,null),PinParticipant:U.createElement(tbt,null),UnpinParticipant:U.createElement(ibt,null),SplitButtonPrimaryActionCameraOn:U.createElement(zH,null),SplitButtonPrimaryActionCameraOff:U.createElement(Dse,null),SplitButtonPrimaryActionMicUnmuted:U.createElement(lK,null),SplitButtonPrimaryActionMicMuted:U.createElement(Rse,null),VerticalGalleryLeftButton:U.createElement(x4e,null),VerticalGalleryRightButton:U.createElement(B4e,null),ControlButtonVideoEffectsOption:U.createElement(dRe,null),ConfigurationScreenVideoEffectsButton:U.createElement(Tbt,null),CaptionsIcon:U.createElement(kSt,null),CaptionsOffIcon:U.createElement(RSt,null),CaptionsSettingsIcon:U.createElement(dbt,null),ChangeSpokenLanguageIcon:U.createElement(ZSt,null),ChangeCaptionLanguageIcon:U.createElement(Sbt,null),ContextMenuCameraIcon:U.createElement(cRe,null),ContextMenuMicIcon:U.createElement(kse,null),ContextMenuSpeakerIcon:U.createElement(Pse,null),ContextMenuRemoveParticipant:U.createElement(YSt,null),SurveyStarIcon:U.createElement(fbt,null),SurveyStarIconFilled:U.createElement(mbt,null),StartSpotlightContextualMenuItem:U.createElement(Lse,null),StopSpotlightContextualMenuItem:U.createElement(Ose,null),VideoTileSpotlighted:U.createElement(Lse,{style:{height:"16px",width:"16px"}}),ContextualMenuMicMutedIcon:U.createElement(aRe,null),IncomingCallNotificationRejectIcon:U.createElement(Ase,null),IncomingCallNotificationAcceptIcon:U.createElement(pSt,null),IncomingCallNotificationAcceptWithVideoIcon:U.createElement(zH,null)},v8t=It({padding:"0"}),y8t=It({overflow:"auto",minHeight:"2.25rem",maxHeight:"8.25rem",outline:"red 5px",fontWeight:xs.regular,fontSize:"0.875rem",width:"100%",height:"2.25rem",lineHeight:"1.5rem","::-webkit-input-placeholder":{fontSize:"0.875rem"},"::-moz-placeholder":{fontSize:"0.875rem"},":-moz-placeholder":{fontSize:"0.875rem"}}),S8t={alignSelf:"center",position:"relative",width:"100%"},b8t={root:{width:"100%",minHeight:"0",fontSize:"8.25rem"},wrapper:{},fieldGroup:{outline:"none",border:"none",height:"auto",minHeight:"0",":after":{border:"none"}},field:{borderRadius:"0.25rem"}},F4e=t=>{const{styles:e,id:i,"data-ui-id":r,textValue:o,onChange:l,textFieldRef:d,placeholderText:h,onKeyDown:p,onEnterKeyDown:g,supportNewline:f,inputClassName:y,errorMessage:T,disabled:C,children:E}=t,I=It(v8t,e?.root),w=It(y8t,y),D=It(S8t,e?.textFieldContainer),F=Ds(b8t,{fieldGroup:e?.textField,errorMessage:e?.systemMessage,suffix:{backgroundColor:"transparent",padding:"0 0"}}),x=$.useCallback(z=>{t8t(z.nativeEvent)||(z.key==="Enter"&&(z.shiftKey===!1||!f)&&(z.preventDefault(),g&&g()),p&&p(z))},[g,p,f]),B=()=>U.createElement(U.Fragment,null,E),L=()=>{const z={autoFocus:t.autoFocus==="sendBoxTextField",multiline:!0,autoAdjustHeight:!0,multiple:!1,resizable:!1,componentRef:d,id:i,inputClassName:w,placeholder:h,autoComplete:"off",styles:F,disabled:C,errorMessage:T,onRenderSuffix:t.children?B:void 0};return U.createElement("div",{style:z.errorMessage?{padding:"0 0 5px 5px"}:void 0},U.createElement(Bre,Object.assign({},z,{"data-ui-id":r,value:o,onChange:l,onKeyDown:x,onFocus:H=>{H.currentTarget.value="",H.currentTarget.value=o}})))};return U.createElement(Et,{className:I},U.createElement("div",{className:D},L()))},BO=t=>{const e=U4e(t.palette.black),i=U4e(t.palette.white);return Number.isNaN(e)||Number.isNaN(i)?!1:e>i},U4e=t=>{if(!/^#[0-9A-Fa-f]{6}$/i.test(t))return NaN;const e=parseInt(t.substring(1,3),16),i=parseInt(t.substring(3,5),16),r=parseInt(t.substring(5,7),16);return(e+i+r)/3},T8t=It({color:"grey",margin:"auto",width:"1.0625rem",height:"1.0625rem",backgroundColor:"transparent","&:hover":{backgroundColor:"transparent"}}),C8t=It({display:"flex"}),_8t=It({pointerEvents:"none"}),Bge=t=>{const{onRenderIcon:e,onClick:i,ariaLabel:r,className:o,id:l,tooltipContent:d,"data-testId":h,disabled:p,ariaExpanded:g}=t,[f,y]=$.useState(!1),T=It(T8t,o),C=hc(),I={gapSpace:0,styles:{root:{padding:0},calloutMain:{padding:"0.5rem"}},backgroundColor:BO(C)?C.palette.neutralLighter:""};return U.createElement(AC,{hostClassName:C8t,content:d,calloutProps:Object.assign({},I)},U.createElement(zy,{className:T,ariaLabel:r,onClick:i,id:l,onMouseEnter:()=>{y(!0)},onMouseLeave:()=>{y(!1)},onRenderIcon:()=>U.createElement(Et,{className:_8t},e(f)),"data-testid":h,"aria-expanded":g,disabled:p,allowDisabledFocus:!0}))},AZ=8e3,E8t=/^\s*$/,z4e=t=>t>AZ,V4e=t=>E8t.test(t)?"":t,A8t=({hasContent:t,hasError:e,disabled:i})=>!t||e||i,Fge=t=>{const{disabled:e,systemMessage:i,supportNewline:r,onSendMessage:o,onTyping:l,onRenderIcon:d,onRenderSystemMessage:h,styles:p,autoFocus:g}=t,f=Cs(),y=Kl().strings.sendBox,T=Object.assign(Object.assign({},y),t.strings),C=qE(),[E,I]=$.useState(""),[w,D]=$.useState(!1),F=U.useRef(null),x=()=>{var ne;if(e||w)return;const le=E;V4e(le).length>0&&(o&&o(le),I(""),(ne=F.current)===null||ne===void 0||ne.focus())},B=ne=>{ne!==void 0&&(D(z4e(ne.length)),I(ne))},L=w?T.textTooLong:void 0,z=i??L,H=$.useMemo(()=>A8t({hasContent:V4e(E).length>0,hasError:!!z,disabled:!!e}),[e,z,E]),j=$.useMemo(()=>It(l8t,p?.sendMessageIconContainer),[p?.sendMessageIconContainer]),J=$.useMemo(()=>Ds(p),[p]),Z=$.useMemo(()=>c8t({theme:f,isSendBoxButtonDisabled:H,customSendIconStyle:p?.sendMessageIcon}),[f,H,p?.sendMessageIcon]),re=$.useCallback(ne=>d?d(ne):U.createElement(Fr,{iconName:ne&&E?"SendBoxSendHovered":"SendBoxSend",className:Z}),[Z,d,E]);return U.createElement(Et,{className:It(s8t,{overflow:"visible"})},U.createElement(Et,{className:d8t({theme:f,hasErrorMessage:!!z,disabled:!!e})},U.createElement(F4e,{autoFocus:g,"data-ui-id":C.sendboxTextField,disabled:e,errorMessage:h?h(z):z,textFieldRef:F,id:"sendbox",placeholderText:T.placeholderText,textValue:E,onChange:(ne,le)=>B(le),onKeyDown:ne=>{ne.key==="Enter"&&(ne.shiftKey===!1||!r)||l?.()},onEnterKeyDown:()=>{x()},styles:J,supportNewline:r,maxLength:AZ},U.createElement(Bge,{onRenderIcon:re,onClick:ne=>{w||x(),ne.stopPropagation()},id:"sendIconWrapper",className:j,ariaLabel:y.sendButtonAriaLabel,tooltipContent:y.sendButtonAriaLabel,disabled:H}))))},$4e={iconName:"Cancel"},H4e={iconName:"Download"},I8t=t=>{var e;return{root:{background:(e=t.semanticColors)===null||e===void 0?void 0:e.bodyBackground}}},w8t={boxShadow:"none",background:"transparent",display:"flex",width:"100%",height:"100%",maxWidth:"100%",maxHeight:"100%"},k8t={overflowY:"hidden",display:"flex",maxWidth:"100%",maxHeight:"100%",flexDirection:"column",flexWrap:"nowrap"},R8t={background:"transparent",display:"flex",flexDirection:"column"},M8t={fontSize:"inherit",margin:"0",width:"100%",minHeight:"3.5rem",flexDirection:"row",justifyContent:"space-between",padding:"0.25rem 0.75rem"},P8t={flexDirection:"row",justifyContent:"start",alignContent:"center",alignItems:"center"},D8t=t=>{var e;return{paddingLeft:"0.5rem",color:(e=t.palette)===null||e===void 0?void 0:e.black,fontFamily:"inherit",fontSize:"0.875rem",fontStyle:"normal",fontWeight:"600",lineHeight:"1.25rem"}},L8t={flexDirection:"row",justifyContent:"start",flexWrap:"wrap",alignContent:"center",alignItems:"center"},O8t={marginRight:"0.5em",fontSize:"0.875rem"},N8t={display:"flex",alignItems:"center",justifyContent:"center",width:"100%",height:"100%",overflow:"hidden",padding:"1rem 2rem 3rem 2rem","@media (max-width: 25rem) or (max-height: 25rem)":{padding:"0rem 1rem 2rem 1rem"}},x8t={objectFit:"contain",maxHeight:"100%",maxWidth:"100%"},B8t=t=>{var e;return{color:(e=t.palette)===null||e===void 0?void 0:e.black}},F8t=t=>{var e,i,r;return{color:(e=t.palette)===null||e===void 0?void 0:e.black,":hover":{color:(i=t.palette)===null||i===void 0?void 0:i.black},":active":{color:(r=t.palette)===null||r===void 0?void 0:r.black}}},U8t={margin:"0 0.5rem",height:"32px",borderWidth:"1px",fontSize:"0.875rem",fontWeight:600,padding:"0.38rem 0.75rem",borderRadius:"4px",whiteSpace:"nowrap","@media (max-width: 25rem)":{display:"none"}},z8t=t=>{var e,i,r;return{marginRight:"0.5rem",whiteSpace:"nowrap",color:(e=t.palette)===null||e===void 0?void 0:e.black,":hover":{color:(i=t.palette)===null||i===void 0?void 0:i.black},":active":{color:(r=t.palette)===null||r===void 0?void 0:r.black},"@media (min-width: 25rem)":{display:"none"}}},GA=t=>{const{announcementString:e,ariaLive:i}=t;return U.createElement(Et,{"aria-label":e,"aria-live":i,role:"status","aria-atomic":!0,styles:V8t})},V8t={root:{position:"absolute",width:"1px",height:"1px",padding:0,margin:"-1px",overflow:"hidden",clip:"rect(0,0,0,0)",whiteSpace:"nowrap",border:0}},$8t=t=>{const{isOpen:e,imageSrc:i,title:r,titleIcon:o,altText:l,onDownloadButtonClicked:d,onDismiss:h}=t,p=Kl().strings.imageOverlay,[g,f]=$.useState(!0),y=$.useMemo(()=>Object.assign(Object.assign({},T8),{semanticColors:Object.assign(Object.assign({},T8.semanticColors),{bodyBackground:"rgba(0, 0, 0, 0.85)"})}),[]),T=g?x8t:B8t(y),C=()=>U.createElement(Et,{className:It(M8t),role:"heading","aria-label":r||"Image","aria-level":2},U.createElement(Et,{className:It(P8t)},o,U.createElement(Et.Item,{className:It(D8t(y))},r)),U.createElement(Et,{className:It(L8t)},d&&U.createElement(th,{className:It(U8t),text:p.downloadButtonLabel,onClick:()=>d&&d(i),onRenderIcon:()=>U.createElement(Fr,{iconName:H4e.iconName,className:It(O8t)}),"aria-live":"polite","aria-label":p.downloadButtonLabel,disabled:i===""}),d&&U.createElement(zy,{iconProps:H4e,className:It(z8t(y)),onClick:()=>d&&d(i),"aria-label":p.downloadButtonLabel,"aria-live":"polite",disabled:i===""}),U.createElement(zy,{iconProps:$4e,className:It(F8t(y)),onClick:h,"aria-label":p.dismissButtonAriaLabel,"aria-live":"polite"}))),E=()=>U.createElement(Et,{className:It(N8t),onClick:()=>t.onDismiss()},i&&U.createElement("img",{src:i,className:It(T),alt:l||"image","aria-label":"image-overlay-main-image","data-ui-id":"image-overlay-main-image","aria-live":"polite",onError:()=>{f(!1)},onClick:I=>I.stopPropagation(),onDoubleClick:I=>{I.persist()}}));return U.createElement(o5,{titleAriaId:r,isOpen:e,onDismiss:h,overlay:{styles:Object.assign({},I8t(y))},styles:{main:w8t,scrollableContent:k8t},isDarkOverlay:!0},U.createElement(GA,{ariaLive:"polite",announcementString:p.overlayVisibleMessage}),U.createElement(O4e,{fluentTheme:y,rootStyle:R8t},C(),E()))},IZ=1,H8t=It({marginRight:"-0.06rem",fontSize:"1.06rem"}),j4e=It({fontSize:`${IZ}rem`,width:`${IZ}rem`,height:`${IZ}rem`}),G4e=U.createContext({announceAssertive:q4e,announcePolite:q4e});function q4e(){console.warn("Announcement failed, LiveAnnouncer context is missing")}let wZ;const j8t=new Uint8Array(16);function G8t(){if(!wZ&&(wZ=typeof crypto<"u"&&crypto.getRandomValues&&crypto.getRandomValues.bind(crypto),!wZ))throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");return wZ(j8t)}const Gv=[];for(let t=0;t<256;++t)Gv.push((t+256).toString(16).slice(1));function q8t(t,e=0){return Gv[t[e+0]]+Gv[t[e+1]]+Gv[t[e+2]]+Gv[t[e+3]]+"-"+Gv[t[e+4]]+Gv[t[e+5]]+"-"+Gv[t[e+6]]+Gv[t[e+7]]+"-"+Gv[t[e+8]]+Gv[t[e+9]]+"-"+Gv[t[e+10]]+Gv[t[e+11]]+Gv[t[e+12]]+Gv[t[e+13]]+Gv[t[e+14]]+Gv[t[e+15]]}let W4e,Uge,zge=0,Vge=0;function kZ(t,e,i){let r=0;const o=new Array(16);t=t||{};let l=t.node||W4e,d=t.clockseq!==void 0?t.clockseq:Uge;if(l==null||d==null){const T=t.random||(t.rng||G8t)();l==null&&(l=W4e=[T[0]|1,T[1],T[2],T[3],T[4],T[5]]),d==null&&(d=Uge=(T[6]<<8|T[7])&16383)}let h=t.msecs!==void 0?t.msecs:Date.now(),p=t.nsecs!==void 0?t.nsecs:Vge+1;const g=h-zge+(p-Vge)/1e4;if(g<0&&t.clockseq===void 0&&(d=d+1&16383),(g<0||h>zge)&&t.nsecs===void 0&&(p=0),p>=1e4)throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");zge=h,Vge=p,Uge=d,h+=122192928e5;const f=((h&268435455)*1e4+p)%4294967296;o[r++]=f>>>24&255,o[r++]=f>>>16&255,o[r++]=f>>>8&255,o[r++]=f&255;const y=h/4294967296*1e4&268435455;o[r++]=y>>>8&255,o[r++]=y&255,o[r++]=y>>>24&15|16,o[r++]=y>>>16&255,o[r++]=d>>>8|128,o[r++]=d&255;for(let T=0;T<6;++T)o[r+T]=l[T];return e||q8t(o)}const W8t=t=>{const{message:e,ariaLive:i,clearOnUnmount:r,announceAssertive:o,announcePolite:l}=t,d=$.useCallback(()=>{i==="assertive"?o(e||"",kZ()):i==="polite"&&l(e||"",kZ())},[o,l,i,e]);return $.useEffect(()=>(d(),()=>{r&&(o("",kZ()),l("",kZ()))}),[e,r,d,o,l]),null},$ge=t=>U.createElement(G4e.Consumer,null,e=>U.createElement(W8t,Object.assign({},e,t))),K8t=t=>{const{shouldAnnounce:e,iconName:i,iconClassName:r,ariaLabel:o}=t;return U.createElement(U.Fragment,null,o&&e&&U.createElement($ge,{message:o,ariaLive:"polite"}),U.createElement("div",null,U.createElement(Fr,{role:"status","aria-live":e?"polite":"off","data-ui-id":"chat-composite-message-status-icon","aria-label":o,iconName:i,className:r})))},J8t=t=>{const{status:e,styles:i,remoteParticipantsCount:r,onToggleToolTip:o,readCount:l,shouldAnnounce:d}=t,h=Kl().strings.messageStatusIndicator,[p,g]=$.useState(!1),f=Object.assign(Object.assign({},h),t.strings),y=Cs(),C={gapSpace:0,styles:{root:{padding:0},calloutMain:{padding:"0.5rem"}},backgroundColor:BO(y)?y.palette.neutralLighter:""};switch(e){case"failed":return U.createElement(AC,{content:f.failedToSendTooltipText,"data-ui-id":"chat-composite-message-tooltip",calloutProps:Object.assign({},C),styles:RZ},U.createElement(MZ,{shouldAnnounce:d,iconName:"MessageFailed",iconClassName:It(H8t,{color:BO(y)?y.semanticColors.errorText:y.palette.redDark},i?.root),ariaLabel:f.failedToSendAriaLabel}));case"sending":return U.createElement(AC,{content:f.sendingTooltipText,"data-ui-id":"chat-composite-message-tooltip",calloutProps:Object.assign({},C),styles:RZ},U.createElement(MZ,{shouldAnnounce:d,iconName:"MessageSending",iconClassName:It(j4e,{color:y.palette.themePrimary},i?.root),ariaLabel:f.sendingAriaLabel}));case"seen":return U.createElement(AC,{calloutProps:Object.assign({},C),"data-ui-id":"chat-composite-message-tooltip",styles:RZ,content:l===0||r&&r<=1||!l||!r||f.readByTooltipText===void 0?f.seenTooltipText:Jd(f.readByTooltipText,{messageThreadReadCount:`${l}`,remoteParticipantsCount:`${r}`}),onTooltipToggle:()=>{o&&(o(!p),g(!p))}},U.createElement(MZ,{shouldAnnounce:d,iconName:"MessageSeen",iconClassName:It({color:y.palette.themePrimary},i?.root),ariaLabel:f.seenAriaLabel}));case"delivered":return U.createElement(AC,{calloutProps:Object.assign({},C),content:f.deliveredTooltipText,"data-ui-id":"chat-composite-message-tooltip",styles:RZ},U.createElement(MZ,{shouldAnnounce:d,iconName:"MessageDelivered",iconClassName:It(j4e,{color:y.palette.themePrimary},i?.root),ariaLabel:f.deliveredAriaLabel}));default:return U.createElement(U.Fragment,null)}},RZ={root:{display:"inline-block"}},MZ=U.memo(t=>U.createElement(K8t,Object.assign({},t))),Y8t=()=>NH({axis:"vertical",memorizeCurrent:!0,unstable_hasDefault:!0}),Q8t=(t,e)=>{const i=Y8t();return{components:{root:"div"},root:Bl(_p("div",{ref:e,...i,...t}),{elementType:"div"})}};function K4e(t,e){const{elementType:i,renderFunction:r,props:o}=Zoe(t);return r?(e.length>0&&(o.children=$.createElement($.Fragment,{},...e)),$.createElement($.Fragment,{},r(i,o))):$.createElement(i,o,...e)}function Wh(t,e,...i){return kH(e)?K4e(zwe(t,e),i):kH(t)?K4e(t,i):$.createElement(t,e,...i)}const Z8t=t=>(Pd(t),Wh(t.root,null)),X8t={root:"fui-Chat"},e7t=Lv({base:{display:"flex",flexDirection:"column",listStyleType:"none",width:"100%",...Wo.overflow("hidden")},comfy:{paddingLeft:"16px",maxWidth:"1056px",...Wo.margin("auto")}}),t7t=t=>{const e=e7t();return t.root.className=ea(X8t.root,e.base,e.comfy,t.root.className),t},J4e=$.forwardRef((t,e)=>{const i=Q8t(t,e);return t7t(i),Z8t(i)});J4e.displayName="Chat";const Y4e=t=>{switch(t){case"important":return $.createElement(nSt,null);case"urgent":return $.createElement(Gyt,null);case"mention":return $.createElement(rSt,null);case"mentionEveryone":return $.createElement(oSt,null);default:return null}},Q4e=t=>{const e=$.useRef(()=>{throw new Error("Cannot call an event handler while rendering")});return fA(()=>{e.current=t},[t]),$.useCallback((...i)=>{const r=e.current;return r(...i)},[e])};function Z4e(t,e){return(...i)=>{t?.(...i),e?.(...i)}}const X4e=t=>{const e=jRe(l=>l.setOpen),i=jRe(l=>l.triggerRef),r=l=>{e(l,!0)},o=l=>{e(l,!1)};t.body.onMouseEnter=Q4e(Z4e(t.body.onMouseEnter,r)),t.body.onMouseLeave=Q4e(Z4e(t.body.onMouseLeave,o)),t.body.ref=kC(t.body.ref,i)},i7t=(t,e)=>{const{attached:i,author:r,avatar:o,body:l,decoration:d,decorationIcon:h,decorationLabel:p,details:g,persistentTimestamp:f,reactions:y,root:T,showAnimation:C,timestamp:E}=t,I=RH({primarySlotTagName:"div",props:t,excludedPropNames:["tabIndex"]}),w=mse({tabBehavior:"limited-trap-focus"}),D={attached:i,decoration:d,persistentTimestamp:f,showAnimation:C,body:Bl(l,{defaultProps:{ref:e,...w,...I.primary,tabIndex:0},elementType:"div"}),root:Bl(T,{defaultProps:I.root,elementType:"div"}),author:Ss(r,{elementType:"div"}),avatar:i&&i!=="top"?void 0:Ss(o,{elementType:"div"}),decorationIcon:Ss(h,{elementType:"div",defaultProps:{children:Y4e(d)},renderByDefault:!!d}),decorationLabel:Ss(p,{elementType:"div"}),details:Ss(g,{elementType:"div"}),reactions:Ss(y,{elementType:"div"}),timestamp:Ss(E,{elementType:"span"}),components:{author:"div",avatar:"div",body:"div",decorationIcon:"div",decorationLabel:"div",details:"div",reactions:"div",root:"div",timestamp:"span"}};return X4e(D),D},n7t=t=>(Pd(t),Wh(t.root,null,t.avatar&&Wh(t.avatar,null),Wh(t.body,null,Wh("div",{className:t.nameLineClassName},t.author&&Wh(t.author,null),t.timestamp&&Wh(t.timestamp,null),t.details&&Wh(t.details,null)),t.decorationLabel&&Wh(t.decorationLabel,null),t.body.children,t.decorationIcon&&Wh(t.decorationIcon,null),t.reactions&&Wh(t.reactions,null)))),eze={position:"relative",...Eyt(),fontFamily:cs.fontFamilyBase,fontWeight:cs.fontWeightRegular,fontSize:cs.fontSizeBase300,lineHeight:cs.lineHeightBase300,color:cs.colorNeutralForeground1,wordBreak:"break-word"},tze={clip:"rect(0px, 0px, 0px, 0px)",height:"1px",...Wo.margin("-1px"),...Wo.overflow("hidden"),...Wo.padding("0px"),width:"1px",position:"absolute"},a7t={color:cs.colorPaletteRedForeground3},ize={position:"relative",height:"0px",display:"flex"},nze={animationIterationCount:"1",animationDuration:"4s",animationTimingFunction:"ease-out",animationName:{from:{backgroundColor:cs.colorPaletteMarigoldBackground1,boxShadow:`inset 0 0 0 0.1rem ${cs.colorPaletteDarkOrangeBorderActive}`},to:{boxShadow:"inset 0 0 0 0.1rem transparent"}}},aze=Lv({default:{color:cs.colorPaletteRedForeground3},mention:{color:cs.colorPaletteDarkOrangeForeground3},mentionContrast:{color:cs.colorBrandForegroundLink}}),TP={root:"fui-ChatMessage",author:"fui-ChatMessage__author",avatar:"fui-ChatMessage__avatar",body:"fui-ChatMessage__body",decorationIcon:"fui-ChatMessage__decorationIcon",decorationLabel:"fui-ChatMessage__decorationLabel",details:"fui-ChatMessage__details",reactions:"fui-ChatMessage__reactions",timestamp:"fui-ChatMessage__timestamp"},r7t=Lv({container:{display:"flex",columnGap:"8px",paddingTop:"16px"},attachedContainer:{paddingTop:"2px"},avatarLessContainer:{marginLeft:"40px"},avatar:{minWidth:"32px"}}),o7t=Lv({base:{...eze,...Wo.borderRadius("4px"),...Wo.padding("8px","16px","16px","16px"),maxWidth:"calc(100% - 100px)",backgroundColor:cs.colorNeutralBackground3},hasReactions:{marginBottom:"12px"},hasDecorationIcon:{...Wo.borderLeft("3px","solid",cs.colorPaletteRedForeground3)},nameLineWrapper:{display:"flex",columnGap:"12px",fontSize:"12px",lineHeight:"16px",color:cs.colorNeutralForeground3,alignItems:"center"},details:{display:"flex",columnGap:"6px",alignItems:"center"},decorationLabel:{fontWeight:700,fontSize:"12px",lineHeight:"16px",textTransform:"uppercase"},reactions:{...ize,paddingRight:"20px"},decorationIcon:{color:"white",backgroundColor:cs.colorPaletteRedForeground3,height:"24px",width:"24px",...Wo.borderRadius("50%"),display:"flex",justifyContent:"center",alignItems:"center",fontSize:"20px",transform:"translateX(50%)",position:"absolute",top:"4px",right:"0px"},screenReaderContainer:tze,animation:nze}),s7t=t=>{const e=r7t();t.root.className=ea(TP.root,e.container,t.attached&&t.attached!=="top"&&e.attachedContainer,!t.avatar&&e.avatarLessContainer,t.root.className),t.avatar&&(t.avatar.className=ea(TP.avatar,e.avatar,t.avatar.className));const i=o7t();t.body&&(t.body.className=ea(TP.body,i.base,t.reactions&&i.hasReactions,t.decorationIcon&&i.hasDecorationIcon,t.showAnimation&&i.animation,t.body.className)),t.author&&(t.author.className=ea(TP.author,t.attached&&t.attached!=="top"&&i.screenReaderContainer,t.author.className)),t.timestamp&&(t.timestamp.className=ea(TP.timestamp,t.attached&&t.attached!=="top"&&i.screenReaderContainer,t.timestamp.className)),t.details&&(t.details.className=ea(TP.details,i.details,t.details.className));const r=aze();return t.decorationLabel&&(t.decorationLabel.className=ea(TP.decorationLabel,i.decorationLabel,t.decoration&&r.default,t.decoration==="mention"&&r.mention,t.decorationLabel.className)),t.decorationIcon&&(t.decorationIcon.className=ea(TP.decorationIcon,i.decorationIcon,t.decorationIcon.className)),t.reactions&&(t.reactions.className=ea(TP.reactions,i.reactions,t.reactions.className)),t.nameLineClassName=i.nameLineWrapper,t},Hge=$.forwardRef((t,e)=>{const i=i7t(t,e);return s7t(i),n7t(i)});Hge.displayName="ChatMessage";const l7t=t=>(Pd(t),Wh(t.root,null,Wh(t.body,null,Wh("div",{className:t.nameLineClassName},t.author&&Wh(t.author,null),t.timestamp&&Wh(t.timestamp,null),t.details&&!t.statusMessage&&Wh(t.details,null),t.statusMessage&&Wh(t.statusMessage,null)),t.decorationLabel&&Wh(t.decorationLabel,null),t.body.children,t.decorationIcon&&Wh(t.decorationIcon,null),t.reactions&&Wh(t.reactions,null)),t.statusIcon&&Wh(t.statusIcon,null),t.actions&&Wh(t.actions,null))),c7t=(t,e)=>{const{actions:i,attached:r,author:o,body:l,decoration:d,decorationIcon:h,decorationLabel:p,details:g,reactions:f,root:y,showAnimation:T,status:C,statusIcon:E,statusMessage:I,timestamp:w}=t,D=RH({primarySlotTagName:"div",props:t,excludedPropNames:["tabIndex"]}),F=mse({tabBehavior:"limited-trap-focus"}),x={attached:r,decoration:d,showAnimation:T,status:C,body:Bl(l,{defaultProps:{ref:e,...F,...D.primary,tabIndex:0},elementType:"div"}),root:Bl(y,{defaultProps:D.root,elementType:"div"}),actions:Ss(i,{elementType:"div"}),author:Ss(o,{elementType:"div"}),decorationIcon:Ss(h,{elementType:"div",defaultProps:{children:Y4e(d)},renderByDefault:!!d}),decorationLabel:Ss(p,{elementType:"div"}),details:Ss(g,{elementType:"div"}),reactions:Ss(f,{elementType:"div"}),statusIcon:Ss(E,{elementType:"div",defaultProps:{children:d7t(C)},renderByDefault:!!C}),statusMessage:Ss(I,{elementType:"div"}),timestamp:Ss(w,{elementType:"span"}),components:{actions:"div",author:"div",body:"div",decorationIcon:"div",decorationLabel:"div",details:"div",reactions:"div",root:"div",statusIcon:"div",statusMessage:"div",timestamp:"span"}};return X4e(x),x},d7t=t=>{switch(t){case"sending":return $.createElement(Xke,null);case"received":return $.createElement(Yke,null);case"read":return $.createElement(USt,null);case"failed":return $.createElement(Ebt,null);case"blocked":return $.createElement(VSt,null);case"scheduled":return $.createElement(ISt,null)}},u7t=Lv({container:{alignSelf:"end",marginLeft:"50px",columnGap:"8px",display:"grid",gridTemplateAreas:`
      "body    status"
      "actions .     "
    `,gridTemplateColumns:"auto 16px",paddingTop:"16px"},attachedContainer:{paddingTop:"2px"},statusIcon:{gridColumnStart:"status",gridColumnEnd:"status",gridRowStart:"status",gridRowEnd:"status",alignSelf:"end",color:cs.colorBrandForeground1},statusIconFailed:a7t,actions:{gridColumnStart:"actions",gridColumnEnd:"actions",gridRowStart:"actions",gridRowEnd:"actions",justifySelf:"end"}}),h7t=Lv({base:{...eze,gridColumnStart:"body",gridColumnEnd:"body",gridRowStart:"body",gridRowEnd:"body",flexShrink:0,...Wo.borderRadius("4px"),...Wo.padding("8px","16px","16px","16px"),backgroundColor:cs.colorBrandBackground2,justifySelf:"end"},hasReactions:{marginBottom:"12px"},hasDecorationIcon:{...Wo.borderLeft("3px","solid",cs.colorPaletteRedForeground3)},details:{display:"flex",columnGap:"6px",alignItems:"center"},statusMessage:{color:cs.colorPaletteRedForeground3},decorationLabel:{fontWeight:700,fontSize:"12px",lineHeight:"16px",textTransform:"uppercase"},reactions:{...ize,paddingLeft:"20px",right:"0px",justifyContent:"end"},decorationIcon:{color:"white",backgroundColor:cs.colorPaletteRedForeground3,height:"24px",width:"24px",...Wo.borderRadius("50%"),display:"flex",justifyContent:"center",alignItems:"center",fontSize:"20px",transform:"translateX(50%)",position:"absolute",top:"4px",right:"0px"},nameLineWrapper:{display:"flex",columnGap:"12px",fontSize:"12px",lineHeight:"16px",color:cs.colorNeutralForeground3,alignItems:"center"},screenReaderContainer:tze,animation:nze}),qA={root:"fui-ChatMyMessage",actions:"fui-ChatMyMessage__actions",author:"fui-ChatMyMessage__author",body:"fui-ChatMyMessage__body",decorationIcon:"fui-ChatMyMessage__decorationIcon",decorationLabel:"fui-ChatMyMessage__decorationLabel",details:"fui-ChatMyMessage__details",reactions:"fui-ChatMyMessage__reactions",statusIcon:"fui-ChatMyMessage__statusIcon",statusMessage:"fui-ChatMyMessage__statusMessage",timestamp:"fui-ChatMyMessage__timestamp"},p7t=t=>{const e=u7t();t.root.className=ea(qA.root,e.container,t.attached&&t.attached!=="top"&&e.attachedContainer,t.root.className);const i=h7t();t.body&&(t.body.className=ea(qA.body,i.base,t.reactions&&i.hasReactions,t.decorationIcon&&i.hasDecorationIcon,t.showAnimation&&i.animation,t.body.className)),t.timestamp&&(t.timestamp.className=ea(qA.timestamp,t.attached&&t.attached!=="top"&&i.screenReaderContainer,t.timestamp.className)),t.details&&(t.details.className=ea(qA.details,i.details,t.details.className)),t.statusMessage&&(t.statusMessage.className=ea(qA.statusMessage,i.statusMessage,t.statusMessage.className));const r=aze();return t.decorationLabel&&(t.decorationLabel.className=ea(qA.decorationLabel,i.decorationLabel,t.decoration&&r.default,t.decorationLabel.className)),t.decorationIcon&&(t.decorationIcon.className=ea(qA.decorationIcon,i.decorationIcon,t.decorationIcon.className)),t.reactions&&(t.reactions.className=ea(qA.reactions,i.reactions,t.reactions.className)),t.author&&(t.author.className=ea(qA.author,i.screenReaderContainer,t.author.className)),t.statusIcon&&(t.statusIcon.className=ea(qA.statusIcon,e.statusIcon,(t.status==="failed"||t.status==="blocked")&&e.statusIconFailed,t.statusIcon.className)),t.actions&&(t.actions.className=ea(qA.actions,e.actions,t.actions.className)),t.nameLineClassName=i.nameLineWrapper,t},PZ=$.forwardRef((t,e)=>{const i=c7t(t,e);return p7t(i),l7t(i)});PZ.displayName="ChatMyMessage";const T4=12,DZ=2,g7t=Lv({root:{"& div[role=toolbar]":Object.assign({},Wo.padding(0))},dynamicWidth:{minWidth:`${T4}rem`},staticWidth:{width:`${T4}rem`},fileIcon:{marginLeft:_n(4),flexShrink:0},content:{"> div":{overflow:"hidden",textOverflow:"ellipsis"}},title:{overflow:"hidden",whiteSpace:"nowrap",textOverflow:"ellipsis"},actions:{flexShrink:0}}),m7t=It({width:"100%",textOverflow:"ellipsis",whiteSpace:"nowrap",overflowX:"clip"}),f7t=.05,v7t="data:image/svg+xml,%3Csvg width='3rem' height='3rem' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg' fill='currentColor'%3E%3Cpath d='M2.85 2.15a.5.5 0 1 0-.7.7l1.4 1.41A2.99 2.99 0 0 0 3 6v8a3 3 0 0 0 3 3h8c.65 0 1.25-.2 1.74-.55l1.4 1.4a.5.5 0 0 0 .71-.7l-15-15Zm6.56 7.97a1.5 1.5 0 0 0-.46.31l-4.67 4.59A2 2 0 0 1 4 14V6a2 2 0 0 1 .28-1.02l5.13 5.14ZM6 16a2 2 0 0 1-1.01-.27l4.66-4.58c.2-.2.5-.2.7 0l4.66 4.58A2 2 0 0 1 14 16H6ZM16 6v7.88l.9.9A3 3 0 0 0 17 14V6a3 3 0 0 0-3-3H6a3 3 0 0 0-.78.1l.9.9H14a2 2 0 0 1 2 2Zm-2 1.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Zm-1 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z' fill='currentColor' /%3E%3C/svg%3E",C8=6.25,jge=2,y7t=2.5,rze=.125,oze=2,sze=.925,S7t=1,b7t=2,T7t=2,C7t="ChatMyMessage__actions",_7t=It({height:"100%",width:"100%",maxHeight:"100%",overflow:"auto",position:"relative",alignSelf:"center"}),E7t=It({height:"100%",width:"100%",position:"relative"}),A7t=It({width:`${IZ}rem`}),I7t=Lv({root:Object.assign(Object.assign(Object.assign({maxWidth:"100%",paddingTop:"0.8rem",paddingBottom:"0.5rem",paddingRight:"0.6rem",paddingLeft:"0.6rem"},Wo.border("none")),Wo.overflow("auto")),{height:"100%","& a:link":{color:cs.colorBrandForegroundLink},"& a:visited":{color:cs.colorBrandForegroundLinkHover},"& a:hover":{color:cs.colorBrandForegroundLinkHover}})}),lze=Lv({rootCommon:{},rootMessage:Object.assign(Object.assign(Object.assign({},Wo.padding("0")),Wo.margin("0")),{maxWidth:"100%",minWidth:`${C8}rem`}),rootMyMessage:Object.assign(Object.assign({gridTemplateColumns:"auto fit-content(0)",gridTemplateAreas:`
        "body status"
      `,columnGap:"0",gridGap:"0"},Wo.padding("0")),{marginTop:"0",marginRight:"0",marginBottom:"0",marginLeft:"50px",width:"calc(100% - 50px)"}),bodyCommon:Object.assign(Object.assign({},Wo.padding("0")),{marginRight:"0",marginBottom:"0",backgroundColor:"transparent",maxWidth:"100%",minWidth:`${C8}rem`}),bodyMyMessage:{width:"100%",marginTop:"0"},bodyWithoutAvatar:{marginLeft:`${y7t}rem`,marginTop:"0"},bodyHiddenAvatar:{marginLeft:0,marginTop:0},bodyWithAvatar:{marginLeft:"0",marginTop:"0.75rem"},avatarNoOverlap:{width:`calc(100% - ${jge+oze+rze}rem)`},avatarOverlap:{width:`calc(100% - ${jge+oze-sze}rem)`}}),cze=Lv({root:{gridTemplateColumns:"auto",gridTemplateAreas:`
        "body"
      `,gridGap:"0",paddingTop:"0",marginLeft:"0"},body:Object.assign(Object.assign({paddingBottom:"10px",marginTop:"1rem",maxWidth:"100%",minWidth:`${C8}rem`,marginLeft:"0rem"},Wo.border("1px","solid","transparent")),{"&:hover .ChatMyMessage__actions":{visibility:"visible"},"&:focus .ChatMyMessage__actions":{visibility:"visible"},"& msft-mention":{color:cs.colorStatusWarningBackground3,fontWeight:600},"& img":{maxWidth:"100%",height:"auto"}}),bodyAttached:{marginTop:"0.125rem"},menu:Object.assign(Object.assign({boxShadow:cs.shadow4,backgroundColor:cs.colorNeutralBackground1,position:"absolute",top:"-19px",right:"0"},Wo.borderRadius(cs.borderRadiusMedium)),{zIndex:2,lineHeight:cs.lineHeightBase100,visibility:"hidden","&:hover, &:focus":{cursor:"pointer",visibility:"visible"}}),menuHidden:{visibility:"hidden"},menuVisible:{visibility:"visible"},multipleAttachmentsInViewing:{width:"100%",maxWidth:`${(T4+DZ)*2}rem`},multipleAttachmentsInEditing:{width:"100%",float:"right"}}),w7t=It({position:"absolute",zIndex:T7t,bottom:0,right:"1.5rem"}),k7t=Lv({root:{paddingTop:"0"},body:Object.assign(Object.assign({maxWidth:"100%",minWidth:`${C8}rem`,marginRight:"0rem",paddingBottom:"10px",zIndex:S7t},Wo.border("1px","solid","transparent")),{"& > div:first-of-type":{flexWrap:"wrap"},"& msft-mention":{color:cs.colorStatusWarningBackground3,fontWeight:cs.fontWeightSemibold},"& img":{maxWidth:"100% !important",height:"auto !important"},"& video":{maxWidth:"100% !important",height:"auto !important"},"& p":Object.assign({},Wo.marginBlock("0.125rem")),"& blockquote":Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({backgroundColor:cs.colorBrandBackgroundInverted,clear:"left",minHeight:"2.25rem",width:"fit-content",marginTop:"7px",marginRight:"0px",marginLeft:"0px",marginBottom:"7px",paddingTop:"7px",paddingRight:"15px",paddingLeft:"15px",paddingBottom:"7px"},Wo.border("solid")),Wo.borderRadius("4px")),Wo.borderWidth("1px")),Wo.borderColor(cs.colorNeutralStroke1Selected)),{borderLeftWidth:"4px"}),"& code":{whiteSpace:"pre-wrap"}}),bodyWithoutAvatar:{marginTop:"0.125rem"},bodyWithAvatar:{marginTop:"0.375rem"},avatarNoOverlap:{marginLeft:`${-2.5+rze}rem`},avatarOverlap:{marginLeft:`${-2.5-sze}rem`},multipleAttachments:{width:`${(T4+DZ)*2}rem`}}),dze=Lv({body:{"& table":{backgroundColor:cs.colorBrandBackgroundInverted,borderCollapse:"collapse",tableLayout:"auto",width:"100%","& tr":Object.assign(Object.assign({},Wo.border("1px","solid",`${cs.colorNeutralStrokeAccessible}`)),{"& td":Object.assign(Object.assign({},Wo.border("1px","solid",`${cs.colorNeutralStrokeAccessible}`)),{wordBreak:"normal",paddingTop:"0px",paddingRight:"5px"})})}},bodyWithPlaceholderImage:{'& img[src=""]':{backgroundColor:cs.colorNeutralBackground1Selected,fontSize:"0",position:"relative",clipPath:"inset(0.3px)",display:"flex"},'& img[src=""]:after':{backgroundColor:cs.colorNeutralBackground1Selected,content:'url("data:image/gif;base64,R0lGODlhAQABAAAAACw=")',backgroundSize:"center",position:"absolute",width:"100%",height:"100%",top:"0",left:"0",display:"block"},"& .broken-image-wrapper":Object.assign(Object.assign({width:"12rem",height:"12rem",marginTop:"0.75rem",display:"flex",justifyContent:"center",alignItems:"center"},Wo.outline("1px","solid",cs.colorNeutralForegroundDisabled)),{backgroundColor:cs.colorNeutralBackground2}),"& .broken-image-wrapper:after":{content:"''",maskImage:`url("${v7t}");`,width:"3rem",height:"3rem",backgroundColor:`${cs.colorNeutralForeground2}`}},failed:{backgroundColor:"rgba(168, 0, 0, 0.2)"},blocked:Object.assign(Object.assign({maxWidth:"100%",minWidth:`${C8}rem`,marginRight:"0rem",color:cs.colorNeutralForeground2},Wo.border("1px","solid","transparent")),{"& i":{paddingTop:"0.25rem"},"& p":Object.assign(Object.assign({},Wo.marginBlock("0.125rem")),{paddingRight:"0.75rem",fontStyle:"italic"}),"& a":Object.assign(Object.assign(Object.assign({},Wo.marginBlock("0.125rem")),{fontStyle:"normal",color:cs.colorBrandForegroundLink}),Wo.textDecoration("none"))})}),uze={paddingTop:"1.65rem",width:`${jge}rem`,position:"relative",float:"left",display:"block",visibility:"visible",zIndex:b7t},R7t=Object.assign(Object.assign({},uze),{visibility:"hidden",height:0}),M7t=It({float:"right",width:"fit-content"}),P7t={textContainer:{display:"contents"}};It({border:"none",minHeight:"1.5rem","&:hover":{background:"none"},"&:active":{background:"none"}});const D7t=It({marginRight:"0.5em"});It({width:"1.25rem",height:"1.25rem"});const L7t=It({whiteSpace:"pre-wrap"}),O7t=t=>new Promise(function(e){setTimeout(e,t)}),nF=t=>{const[e,i]=$.useState(void 0),r=$.useRef(new ResizeObserver(o=>{if(!o[0])return;const{width:l}=o[0].contentRect;Number.isNaN(l)?i(0):i(l)}));return $.useEffect(()=>{t.current&&r.current.observe(t.current);const o=r.current;return()=>{o.disconnect()}},[t,r]),e},_8=t=>{const[e,i]=$.useState(void 0),r=$.useRef(new ResizeObserver(o=>{if(!o[0])return;const{height:l}=o[0].contentRect;Number.isNaN(l)?i(0):i(l)}));return $.useEffect(()=>{t.current&&r.current.observe(t.current);const o=r.current;return()=>{o.disconnect()}},[t,r]),e},N7t=30,x7t=23.75,E8=t=>t<=cT(N7t),Gge=t=>t<=cT(x7t),hze=(t,e)=>Object.entries(e).filter(([i,r])=>r.lastReadMessage>=t.messageId).filter(([i,r])=>r.displayName&&r.displayName!=="").map(([i,r])=>({id:i,displayName:r.displayName})),Mk={8:"#141414",18:"#2e2e2e",20:"#333333",22:"#383838",24:"#3d3d3d",92:"#ebebeb",94:"#f0f0f0",96:"#f5f5f5",98:"#fafafa"},ZC={5:"rgba(255, 255, 255, 0.05)",10:"rgba(255, 255, 255, 0.1)",20:"rgba(255, 255, 255, 0.2)",40:"rgba(255, 255, 255, 0.4)",50:"rgba(255, 255, 255, 0.5)",80:"rgba(255, 255, 255, 0.8)"},FO={5:"rgba(0, 0, 0, 0.05)",10:"rgba(0, 0, 0, 0.1)",20:"rgba(0, 0, 0, 0.2)",30:"rgba(0, 0, 0, 0.3)",40:"rgba(0, 0, 0, 0.4)",50:"rgba(0, 0, 0, 0.5)"},B7t={50:"rgba(26, 26, 26, 0.5)"},F7t={70:"rgba(31, 31, 31, 0.7)"},U7t=(t,e)=>({colorNeutralForeground1:t.neutralPrimary,colorNeutralForeground1Hover:t.neutralPrimary,colorNeutralForeground1Pressed:t.neutralPrimary,colorNeutralForeground1Selected:t.neutralPrimary,colorNeutralForeground2:t.neutralSecondary,colorNeutralForeground2Hover:t.neutralPrimary,colorNeutralForeground2Pressed:t.neutralPrimary,colorNeutralForeground2Selected:t.neutralPrimary,colorNeutralForeground2BrandHover:t.themePrimary,colorNeutralForeground2BrandPressed:t.themeDarkAlt,colorNeutralForeground2BrandSelected:t.themePrimary,colorNeutralForeground3:t.neutralTertiary,colorNeutralForeground3Hover:t.neutralSecondary,colorNeutralForeground3Pressed:t.neutralSecondary,colorNeutralForeground3Selected:t.neutralSecondary,colorNeutralForeground3BrandHover:t.themePrimary,colorNeutralForeground3BrandPressed:t.themeDarkAlt,colorNeutralForeground3BrandSelected:t.themePrimary,colorNeutralForeground4:t.neutralQuaternary,colorNeutralForegroundDisabled:t.neutralTertiaryAlt,colorNeutralForegroundInvertedDisabled:ZC[40],colorBrandForegroundLink:t.themeDarkAlt,colorBrandForegroundLinkHover:t.themeDark,colorBrandForegroundLinkPressed:t.themeDarker,colorBrandForegroundLinkSelected:t.themeDarkAlt,colorNeutralForeground2Link:t.neutralSecondary,colorNeutralForeground2LinkHover:t.neutralPrimary,colorNeutralForeground2LinkPressed:t.neutralPrimary,colorNeutralForeground2LinkSelected:t.neutralPrimary,colorCompoundBrandForeground1:t.themePrimary,colorCompoundBrandForeground1Hover:t.themeDarkAlt,colorCompoundBrandForeground1Pressed:t.themeDark,colorBrandForeground1:t.themePrimary,colorBrandForeground2:t.themeDarkAlt,colorBrandForeground2Hover:t.themeDarkAlt,colorBrandForeground2Pressed:t.themeDarkAlt,colorNeutralForeground1Static:t.neutralPrimary,colorNeutralForegroundInverted:t.white,colorNeutralForegroundInvertedHover:t.white,colorNeutralForegroundInvertedPressed:t.white,colorNeutralForegroundInvertedSelected:t.white,colorNeutralForegroundOnBrand:t.white,colorNeutralForegroundStaticInverted:t.white,colorNeutralForegroundInvertedLink:t.white,colorNeutralForegroundInvertedLinkHover:t.white,colorNeutralForegroundInvertedLinkPressed:t.white,colorNeutralForegroundInvertedLinkSelected:t.white,colorNeutralForegroundInverted2:t.white,colorBrandForegroundInverted:t.themeSecondary,colorBrandForegroundInvertedHover:t.themeTertiary,colorBrandForegroundInvertedPressed:t.themeSecondary,colorBrandForegroundOnLight:t.themePrimary,colorBrandForegroundOnLightHover:t.themeDarkAlt,colorBrandForegroundOnLightPressed:t.themeDark,colorBrandForegroundOnLightSelected:t.themeDark,colorNeutralBackground1:t.white,colorNeutralBackground1Hover:t.neutralLighter,colorNeutralBackground1Pressed:t.neutralQuaternaryAlt,colorNeutralBackground1Selected:t.neutralLight,colorNeutralBackground2:t.neutralLighterAlt,colorNeutralBackground2Hover:t.neutralLighter,colorNeutralBackground2Pressed:t.neutralQuaternaryAlt,colorNeutralBackground2Selected:t.neutralLight,colorNeutralBackground3:t.neutralLighter,colorNeutralBackground3Hover:t.neutralLight,colorNeutralBackground3Pressed:t.neutralQuaternary,colorNeutralBackground3Selected:t.neutralQuaternaryAlt,colorNeutralBackground4:t.neutralLighter,colorNeutralBackground4Hover:t.neutralLighterAlt,colorNeutralBackground4Pressed:t.neutralLighter,colorNeutralBackground4Selected:t.white,colorNeutralBackground5:t.neutralLight,colorNeutralBackground5Hover:t.neutralLighter,colorNeutralBackground5Pressed:t.neutralLighter,colorNeutralBackground5Selected:t.neutralLighterAlt,colorNeutralBackground6:t.neutralLight,colorNeutralBackgroundStatic:Mk[20],colorNeutralBackgroundInverted:t.neutralSecondary,colorNeutralBackgroundAlpha:e?B7t[50]:ZC[50],colorNeutralBackgroundAlpha2:e?F7t[70]:ZC[80],colorSubtleBackground:"transparent",colorSubtleBackgroundHover:t.neutralLighter,colorSubtleBackgroundPressed:t.neutralQuaternaryAlt,colorSubtleBackgroundSelected:t.neutralLight,colorSubtleBackgroundLightAlphaHover:e?ZC[10]:ZC[80],colorSubtleBackgroundLightAlphaPressed:e?ZC[5]:ZC[50],colorSubtleBackgroundLightAlphaSelected:"transparent",colorSubtleBackgroundInverted:"transparent",colorSubtleBackgroundInvertedHover:FO[10],colorSubtleBackgroundInvertedPressed:FO[30],colorSubtleBackgroundInvertedSelected:FO[20],colorTransparentBackground:"transparent",colorTransparentBackgroundHover:"transparent",colorTransparentBackgroundPressed:"transparent",colorTransparentBackgroundSelected:"transparent",colorNeutralBackgroundDisabled:t.neutralLighter,colorNeutralBackgroundInvertedDisabled:ZC[10],colorNeutralStencil1:t.neutralLight,colorNeutralStencil2:t.neutralLighterAlt,colorNeutralStencil1Alpha:e?ZC[10]:FO[10],colorNeutralStencil2Alpha:e?ZC[5]:FO[5],colorBackgroundOverlay:FO[40],colorScrollbarOverlay:FO[50],colorBrandBackground:t.themePrimary,colorBrandBackgroundHover:t.themeDarkAlt,colorBrandBackgroundPressed:t.themeDarker,colorBrandBackgroundSelected:t.themeDark,colorCompoundBrandBackground:t.themePrimary,colorCompoundBrandBackgroundHover:t.themeDarkAlt,colorCompoundBrandBackgroundPressed:t.themeDark,colorBrandBackgroundStatic:t.themePrimary,colorBrandBackground2:t.themeLighterAlt,colorBrandBackground2Hover:t.themeLighterAlt,colorBrandBackground2Pressed:t.themeLighterAlt,colorBrandBackground3Static:t.themeDark,colorBrandBackground4Static:t.themeDarker,colorBrandBackgroundInverted:t.white,colorBrandBackgroundInvertedHover:t.themeLighterAlt,colorBrandBackgroundInvertedPressed:t.themeLight,colorBrandBackgroundInvertedSelected:t.themeLighter,colorNeutralCardBackground:e?Mk[20]:Mk[98],colorNeutralCardBackgroundHover:e?Mk[24]:t.white,colorNeutralCardBackgroundPressed:e?Mk[18]:Mk[96],colorNeutralCardBackgroundSelected:e?Mk[22]:Mk[92],colorNeutralCardBackgroundDisabled:e?Mk[8]:Mk[94],colorNeutralStrokeAccessible:t.neutralSecondary,colorNeutralStrokeAccessibleHover:t.neutralSecondary,colorNeutralStrokeAccessiblePressed:t.neutralSecondary,colorNeutralStrokeAccessibleSelected:t.themePrimary,colorNeutralStroke1:t.neutralQuaternary,colorNeutralStroke1Hover:t.neutralTertiaryAlt,colorNeutralStroke1Pressed:t.neutralTertiaryAlt,colorNeutralStroke1Selected:t.neutralTertiaryAlt,colorNeutralStroke2:t.neutralQuaternaryAlt,colorNeutralStroke3:t.neutralLighter,colorNeutralStrokeSubtle:t.neutralQuaternaryAlt,colorNeutralStrokeOnBrand:t.white,colorNeutralStrokeOnBrand2:t.white,colorNeutralStrokeOnBrand2Hover:t.white,colorNeutralStrokeOnBrand2Pressed:t.white,colorNeutralStrokeOnBrand2Selected:t.white,colorBrandStroke1:t.themePrimary,colorBrandStroke2:t.themeLight,colorBrandStroke2Hover:t.themeLight,colorBrandStroke2Pressed:t.themeLight,colorBrandStroke2Contrast:t.themeLight,colorCompoundBrandStroke:t.themePrimary,colorCompoundBrandStrokeHover:t.themeDarkAlt,colorCompoundBrandStrokePressed:t.themeDark,colorNeutralStrokeDisabled:t.neutralQuaternaryAlt,colorNeutralStrokeInvertedDisabled:ZC[40],colorTransparentStroke:"transparent",colorTransparentStrokeInteractive:"transparent",colorTransparentStrokeDisabled:"transparent",colorNeutralStrokeAlpha:e?ZC[10]:FO[5],colorNeutralStrokeAlpha2:ZC[20],colorStrokeFocus1:t.white,colorStrokeFocus2:t.black,colorNeutralShadowAmbient:"rgba(0,0,0,0.12)",colorNeutralShadowKey:"rgba(0,0,0,0.14)",colorNeutralShadowAmbientLighter:"rgba(0,0,0,0.06)",colorNeutralShadowKeyLighter:"rgba(0,0,0,0.07)",colorNeutralShadowAmbientDarker:"rgba(0,0,0,0.20)",colorNeutralShadowKeyDarker:"rgba(0,0,0,0.24)",colorBrandShadowAmbient:"rgba(0,0,0,0.30)",colorBrandShadowKey:"rgba(0,0,0,0.25)"}),z7t=t=>({shadow4:t.elevation4,shadow8:t.elevation8,shadow16:t.elevation16,shadow64:t.elevation64}),V7t=t=>({borderRadiusSmall:t.roundedCorner2,borderRadiusMedium:t.roundedCorner4,borderRadiusLarge:t.roundedCorner6}),$7t=(t,e)=>Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({},zke),U7t(t.palette,t.isInverted)),z7t(t.effects)),V7t(t.effects)),{colorBrandBackground2:t.palette.themeLight,colorBrandBackground2Hover:t.palette.themeLight,colorBrandBackground2Pressed:t.palette.themeLight,colorStatusWarningBackground3:"#D83B01",errorText:t.semanticColors.errorText,colorNeutralStroke1Selected:t.palette.neutralQuaternary,colorNeutralForeground2:t.palette.neutralSecondary,colorBrandForegroundLinkHover:t.palette.themeDarker,colorNeutralBackground1Selected:t.palette.neutralQuaternaryAlt}),H7t=Lv({body:Object.assign(Object.assign(Object.assign(Object.assign({height:"100%"},Wo.margin(0)),Wo.overflow("hidden")),Wo.padding(0)),{width:"100%"})}),pze=t=>{const{v8Theme:e,children:i,className:r}=t,o=$7t(e),l=e.rtl?"rtl":"ltr";return U.createElement(Swe,{dir:l},U.createElement(j7t,{theme:o,dir:l,className:r},i))},j7t=t=>{const e=H7t();return U.createElement(E5,Object.assign({},t,{className:ea(t.className,e.body),applyStylesToPortals:!1}))},G7t={border:0,clip:"rect(0 0 0 0)",height:"1px",margin:"-1px",overflow:"hidden",whiteSpace:"nowrap",padding:0,width:"1px",position:"absolute"},LZ=t=>U.createElement("div",{style:G7t,role:"log","aria-live":t.ariaLive},t.message?t.message:""),ST={message:"",id:""},q7t=t=>{var e,i;const r=(e=t.assertive)!==null&&e!==void 0?e:ST,o=U.useRef(ST),[l,d]=U.useState(ST),[h,p]=U.useState(ST),g=U.useRef(!1);$.useEffect(()=>{(o.current.message!==r?.message||o.current.id!==r?.id)&&(d(g.current?ST:r),p(g.current?r:ST),o.current=r,g.current=!g.current)},[r]);const f=(i=t.polite)!==null&&i!==void 0?i:ST,y=U.useRef(ST),[T,C]=U.useState(ST),[E,I]=U.useState(ST),w=U.useRef(!1);return $.useEffect(()=>{(y.current.message!==f?.message||y.current.id!==f?.id)&&(C(w.current?ST:f),I(w.current?f:ST),y.current=f,w.current=!w.current)},[f]),U.createElement("div",null,U.createElement(LZ,{ariaLive:"assertive",message:l.message}),U.createElement(LZ,{ariaLive:"assertive",message:h.message}),U.createElement(LZ,{ariaLive:"polite",message:T.message}),U.createElement(LZ,{ariaLive:"polite",message:E.message}))},W7t=t=>{const[e,i]=U.useState(ST),[r,o]=U.useState(ST),l=$.useCallback((p,g)=>{i({message:p,id:g})},[]),d=$.useCallback((p,g)=>{o({message:p,id:g})},[]),h=$.useMemo(()=>({announcePolite:l,announceAssertive:d}),[d,l]);return U.createElement(G4e.Provider,{value:h},t.children,U.createElement(q7t,{assertive:r,polite:e}))};function C4(t){const e={};if(!(t==null||typeof t=="boolean"||typeof t=="string")){if(typeof t=="object")for(const i in t)if(typeof t[i]=="string"){const r="MS";if(i.startsWith(r)){const o=i.substring(0,r.length).toLowerCase+i.substring(r.length);e[o]=t[i]}else e[i]=t[i]}else e[i]=C4(t[i]);return e}}const K7t=It({marginInlineEnd:"0.688rem"}),gze=t=>{const{iconName:e,content:i}=t,r=U.createElement(_M,{iconName:e,className:It(K7t)}),[o,l]=$.useState("");return $.useEffect(()=>{setTimeout(()=>{l(i)})},[i]),U.createElement(U.Fragment,null,U.createElement($ge,{message:o,ariaLive:"polite",clearOnUnmount:!0}),U.createElement(Et,{horizontal:!0,className:It(t?.containerStyle),role:"status","aria-label":i,tabIndex:0},r,U.createElement(ja,{style:{wordBreak:"break-word"},variant:"small"},i)))},mze=t=>{var e;const i=t.message;switch(i.messageType){case"system":switch(i.systemMessageType){case"content":return U.createElement(gze,{iconName:i.iconName?i.iconName:"",content:(e=i.content)!==null&&e!==void 0?e:"",containerStyle:t?.messageContainerStyle});case"participantAdded":case"participantRemoved":return U.createElement(J7t,{message:i,style:t.messageContainerStyle,defaultName:t.strings.noDisplayNameSub})}}return U.createElement(U.Fragment,null)},J7t=({message:t,style:e,defaultName:i})=>{const{strings:r}=Kl(),o=Y7t(t.participants,i),l=t.systemMessageType==="participantAdded"?r.messageThread.participantJoined:r.messageThread.participantLeft;return o!==""?U.createElement(gze,{iconName:t.iconName?t.iconName:"",content:`${o} ${l}`,containerStyle:e}):U.createElement(U.Fragment,null)},Y7t=(t,e)=>t.map(i=>`${!i.displayName||i.displayName===""?e:i.displayName}`).join(", "),OZ=3,Q7t="var(--errorText)",Z7t=(t,e)=>({root:{margin:_n(3),color:e?t.palette.black:t.palette.neutralPrimary,strokeWidth:_n(e?.5:0),stroke:t.palette.black,":hover, :focus":{color:t.palette.black,strokeWidth:_n(.5)}}}),qge=t=>It({color:t.palette.neutralSecondary,fontWeight:xs.regular,fontSize:"0.75rem"}),X7t=It({fontWeight:xs.semibold,fontSize:"0.75rem"}),fze=t=>It({color:t.palette.neutralPrimaryAlt,fontWeight:xs.regular,fontSize:"0.75rem"}),eGt=t=>It({fontWeight:xs.semibold,color:t.palette.neutralSecondary}),vze=t=>It({fontWeight:xs.regular,color:t.semanticColors.errorText,fontSize:t.fonts.smallPlus.fontSize,lineHeight:"1rem"}),tGt=It({marginBottom:"0.5rem"}),iGt=It({alignSelf:"end"}),nGt=It({padding:"0 0.5rem",marginTop:"-0.25rem"}),aGt=It({minWidth:"8.5rem",height:"max-content",cursor:"pointer",overflow:"hidden","-webkit-tap-highlight-color":"transparent"}),rGt=Lv({body:Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({},Wo.padding(0)),{backgroundColor:"transparent",boxSizing:"border-box"}),Wo.border(`${P4e}rem`,"solid")),Wo.borderRadius(cs.borderRadiusMedium)),Wo.margin("21px","1px","1px","1px")),{width:`calc(100% - ${b4}rem)`,"&:hover, &:active, &:focus, &:focus-within":Object.assign(Object.assign(Object.assign({},Wo.borderWidth(`${b4}rem`)),Wo.margin("20px",0,0,0)),{width:"100%"})}),bodyAttached:{marginBottom:"1px",marginTop:"3px",width:`calc(100% - ${b4}rem)`,"&:hover, &:active, &:focus, &:focus-within":{marginTop:"2px",marginBottom:0}},bodyError:Object.assign({},Wo.borderColor(Q7t)),bodyDefault:Object.assign(Object.assign({},Wo.borderColor(cs.colorNeutralStrokeAccessible)),{"&:hover, &:active, &:focus, &:focus-within":Object.assign({},Wo.borderColor(cs.colorCompoundBrandStroke))})});Lv({body:Object.assign(Object.assign(Object.assign(Object.assign({},Wo.padding(0)),{backgroundColor:"transparent"}),Wo.margin("1.25rem",0,0,0)),{width:"100%"}),bodyAttached:{marginTop:"0.125rem",marginBottom:0}});const A8={root:{height:`${OZ}rem`,lineHeight:`${OZ}rem`,maxHeight:"unset"},linkContent:{height:`${OZ}rem`,lineHeight:`${OZ}rem`,maxHeight:"unset"},icon:{maxHeight:"unset"}},Wge={root:{height:"calc(100% - 8px)",width:"1.25rem"}},oGt={root:{height:"unset",lineHeight:"100%",width:"1.25rem"}},sGt=t=>{var e,i;const r=hc(),o=(e=t.messageReadBy)===null||e===void 0?void 0:e.length,l=[...(i=t.messageReadBy)!==null&&i!==void 0?i:[]].sort((p,g)=>p.displayName.localeCompare(g.displayName)),d=l?.map(p=>{const g={hidePersonaDetails:!0,size:Io.size24,text:p.displayName,showOverflowTooltip:!1,styles:{root:{margin:"0.25rem"}}},{onRenderAvatar:f}=t;return{"data-ui-id":"chat-composite-message-contextual-menu-read-name-list-item",key:p.displayName,text:p.displayName,itemProps:{styles:t.increaseFlyoutItemSize?A8:void 0},onRenderIcon:()=>{var y;if(f){const T=f((y=p.id)!==null&&y!==void 0?y:"",g);if(T)return T}return U.createElement(ux,Object.assign({},g))},iconProps:{styles:Wge}}}),h=$.useMemo(()=>{const p=[{key:"Edit","data-testid":"chat-composite-message-contextual-menu-edit-action",text:t.strings.editMessage,itemProps:{styles:t.increaseFlyoutItemSize?A8:void 0},iconProps:{iconName:"MessageEdit",styles:Wge},onClick:t.onEditClick},{key:"Remove","data-testid":"chat-composite-message-contextual-menu-remove-action",text:t.strings.removeMessage,itemProps:{styles:t.increaseFlyoutItemSize?A8:void 0},iconProps:{iconName:"MessageRemove",styles:Wge},onClick:t.onRemoveClick}];return t.remoteParticipantsCount&&o!==void 0&&t.remoteParticipantsCount>=2&&t.remoteParticipantsCount<19&&t.showMessageStatus&&t.strings.messageReadCount&&t.messageStatus!=="failed"?p.push({key:"Read Count","data-ui-id":"chat-composite-message-contextual-menu-read-info",text:Jd(t.strings.messageReadCount,{messageReadByCount:`${o}`,remoteParticipantsCount:`${t.remoteParticipantsCount}`}),itemProps:{styles:Ds({linkContent:{color:o>0?r.palette.neutralPrimary:r.palette.neutralTertiary},root:{borderTop:`1px solid ${r.palette.neutralLighter}`}},t.increaseFlyoutItemSize?A8:void 0)},calloutProps:NZ,subMenuProps:{items:d??[],calloutProps:NZ,styles:Ds({root:{maxWidth:_n(320),span:{overflow:"hidden",textOverflow:"ellipsis"}}})},iconProps:{iconName:"MessageSeen",styles:{root:{color:o>0?r.palette.themeDarkAlt:r.palette.neutralTertiary}}},submenuIconProps:{iconName:"HorizontalGalleryRightButton",styles:oGt},disabled:o<=0}):t.messageStatus==="failed"&&t.strings.resendMessage&&p.push({key:"Resend",text:t.strings.resendMessage,itemProps:{styles:Ds({linkContent:{color:r.palette.neutralPrimary},root:{borderTop:`1px solid ${r.palette.neutralLighter}`}},t.increaseFlyoutItemSize?A8:void 0)},calloutProps:NZ,iconProps:{iconName:"MessageResend",styles:{root:{color:r.palette.themeDarkAlt}}},onClick:t.onResendClick}),p},[t.strings.editMessage,t.strings.removeMessage,t.strings.messageReadCount,t.strings.resendMessage,t.messageStatus,t.increaseFlyoutItemSize,t.onEditClick,t.onRemoveClick,t.onResendClick,t.remoteParticipantsCount,t.showMessageStatus,o,r.palette.neutralPrimary,r.palette.neutralTertiary,r.palette.neutralLighter,r.palette.themeDarkAlt,d]);return U.createElement(hx,{alignTargetEdge:!0,gapSpace:2,isBeakVisible:!1,items:h,hidden:t.hidden,target:t.target,onDismiss:t.onDismiss,directionalHint:hd.topRightEdge,className:aGt,calloutProps:lGt})},NZ={preventDismissOnEvent:t=>t.type==="resize"},lGt=Object.assign(Object.assign({},NZ),{styles:{root:{marginRight:"3px"}}}),cGt=t=>{const{ariaLabel:e,enabled:i,theme:r,menuExpanded:o}=t,l=i||o;return{children:U.createElement("div",{tabIndex:l?0:void 0,key:"menuButton","data-testid":"chat-composite-message-action-icon",ref:t.menuButtonRef,onClick:l?()=>t.onActionButtonClick():void 0,style:{margin:l?"1px":0,minHeight:l?void 0:"30px"},role:"button","aria-label":l?e:void 0,"aria-haspopup":l,"aria-expanded":o,onKeyDown:h=>{l&&(h.key==="Enter"||h.key===" ")&&t.onActionButtonClick()}},l?U.createElement(Fr,{iconName:"ChatMessageOptions","aria-label":e,styles:Z7t(r,o)}):void 0)}};var I8={},_4={},xZ={},aF={},rF={},Kge={},yze;function Sze(){return yze||(yze=1,function(t){Object.defineProperty(t,"__esModule",{value:!0}),t.Doctype=t.CDATA=t.Tag=t.Style=t.Script=t.Comment=t.Directive=t.Text=t.Root=t.isTag=t.ElementType=void 0;var e;(function(r){r.Root="root",r.Text="text",r.Directive="directive",r.Comment="comment",r.Script="script",r.Style="style",r.Tag="tag",r.CDATA="cdata",r.Doctype="doctype"})(e=t.ElementType||(t.ElementType={}));function i(r){return r.type===e.Tag||r.type===e.Script||r.type===e.Style}t.isTag=i,t.Root=e.Root,t.Text=e.Text,t.Directive=e.Directive,t.Comment=e.Comment,t.Script=e.Script,t.Style=e.Style,t.Tag=e.Tag,t.CDATA=e.CDATA,t.Doctype=e.Doctype}(Kge)),Kge}var gl={},bze;function Tze(){if(bze)return gl;bze=1;var t=gl&&gl.__extends||function(){var L=function(z,H){return L=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(j,J){j.__proto__=J}||function(j,J){for(var Z in J)Object.prototype.hasOwnProperty.call(J,Z)&&(j[Z]=J[Z])},L(z,H)};return function(z,H){if(typeof H!="function"&&H!==null)throw new TypeError("Class extends value "+String(H)+" is not a constructor or null");L(z,H);function j(){this.constructor=z}z.prototype=H===null?Object.create(H):(j.prototype=H.prototype,new j)}}(),e=gl&&gl.__assign||function(){return e=Object.assign||function(L){for(var z,H=1,j=arguments.length;H<j;H++){z=arguments[H];for(var J in z)Object.prototype.hasOwnProperty.call(z,J)&&(L[J]=z[J])}return L},e.apply(this,arguments)};Object.defineProperty(gl,"__esModule",{value:!0}),gl.cloneNode=gl.hasChildren=gl.isDocument=gl.isDirective=gl.isComment=gl.isText=gl.isCDATA=gl.isTag=gl.Element=gl.Document=gl.CDATA=gl.NodeWithChildren=gl.ProcessingInstruction=gl.Comment=gl.Text=gl.DataNode=gl.Node=void 0;var i=Sze(),r=function(){function L(){this.parent=null,this.prev=null,this.next=null,this.startIndex=null,this.endIndex=null}return Object.defineProperty(L.prototype,"parentNode",{get:function(){return this.parent},set:function(z){this.parent=z},enumerable:!1,configurable:!0}),Object.defineProperty(L.prototype,"previousSibling",{get:function(){return this.prev},set:function(z){this.prev=z},enumerable:!1,configurable:!0}),Object.defineProperty(L.prototype,"nextSibling",{get:function(){return this.next},set:function(z){this.next=z},enumerable:!1,configurable:!0}),L.prototype.cloneNode=function(z){return z===void 0&&(z=!1),x(this,z)},L}();gl.Node=r;var o=function(L){t(z,L);function z(H){var j=L.call(this)||this;return j.data=H,j}return Object.defineProperty(z.prototype,"nodeValue",{get:function(){return this.data},set:function(H){this.data=H},enumerable:!1,configurable:!0}),z}(r);gl.DataNode=o;var l=function(L){t(z,L);function z(){var H=L!==null&&L.apply(this,arguments)||this;return H.type=i.ElementType.Text,H}return Object.defineProperty(z.prototype,"nodeType",{get:function(){return 3},enumerable:!1,configurable:!0}),z}(o);gl.Text=l;var d=function(L){t(z,L);function z(){var H=L!==null&&L.apply(this,arguments)||this;return H.type=i.ElementType.Comment,H}return Object.defineProperty(z.prototype,"nodeType",{get:function(){return 8},enumerable:!1,configurable:!0}),z}(o);gl.Comment=d;var h=function(L){t(z,L);function z(H,j){var J=L.call(this,j)||this;return J.name=H,J.type=i.ElementType.Directive,J}return Object.defineProperty(z.prototype,"nodeType",{get:function(){return 1},enumerable:!1,configurable:!0}),z}(o);gl.ProcessingInstruction=h;var p=function(L){t(z,L);function z(H){var j=L.call(this)||this;return j.children=H,j}return Object.defineProperty(z.prototype,"firstChild",{get:function(){var H;return(H=this.children[0])!==null&&H!==void 0?H:null},enumerable:!1,configurable:!0}),Object.defineProperty(z.prototype,"lastChild",{get:function(){return this.children.length>0?this.children[this.children.length-1]:null},enumerable:!1,configurable:!0}),Object.defineProperty(z.prototype,"childNodes",{get:function(){return this.children},set:function(H){this.children=H},enumerable:!1,configurable:!0}),z}(r);gl.NodeWithChildren=p;var g=function(L){t(z,L);function z(){var H=L!==null&&L.apply(this,arguments)||this;return H.type=i.ElementType.CDATA,H}return Object.defineProperty(z.prototype,"nodeType",{get:function(){return 4},enumerable:!1,configurable:!0}),z}(p);gl.CDATA=g;var f=function(L){t(z,L);function z(){var H=L!==null&&L.apply(this,arguments)||this;return H.type=i.ElementType.Root,H}return Object.defineProperty(z.prototype,"nodeType",{get:function(){return 9},enumerable:!1,configurable:!0}),z}(p);gl.Document=f;var y=function(L){t(z,L);function z(H,j,J,Z){J===void 0&&(J=[]),Z===void 0&&(Z=H==="script"?i.ElementType.Script:H==="style"?i.ElementType.Style:i.ElementType.Tag);var re=L.call(this,J)||this;return re.name=H,re.attribs=j,re.type=Z,re}return Object.defineProperty(z.prototype,"nodeType",{get:function(){return 1},enumerable:!1,configurable:!0}),Object.defineProperty(z.prototype,"tagName",{get:function(){return this.name},set:function(H){this.name=H},enumerable:!1,configurable:!0}),Object.defineProperty(z.prototype,"attributes",{get:function(){var H=this;return Object.keys(this.attribs).map(function(j){var J,Z;return{name:j,value:H.attribs[j],namespace:(J=H["x-attribsNamespace"])===null||J===void 0?void 0:J[j],prefix:(Z=H["x-attribsPrefix"])===null||Z===void 0?void 0:Z[j]}})},enumerable:!1,configurable:!0}),z}(p);gl.Element=y;function T(L){return(0,i.isTag)(L)}gl.isTag=T;function C(L){return L.type===i.ElementType.CDATA}gl.isCDATA=C;function E(L){return L.type===i.ElementType.Text}gl.isText=E;function I(L){return L.type===i.ElementType.Comment}gl.isComment=I;function w(L){return L.type===i.ElementType.Directive}gl.isDirective=w;function D(L){return L.type===i.ElementType.Root}gl.isDocument=D;function F(L){return Object.prototype.hasOwnProperty.call(L,"children")}gl.hasChildren=F;function x(L,z){z===void 0&&(z=!1);var H;if(E(L))H=new l(L.data);else if(I(L))H=new d(L.data);else if(T(L)){var j=z?B(L.children):[],J=new y(L.name,e({},L.attribs),j);j.forEach(function(le){return le.parent=J}),L.namespace!=null&&(J.namespace=L.namespace),L["x-attribsNamespace"]&&(J["x-attribsNamespace"]=e({},L["x-attribsNamespace"])),L["x-attribsPrefix"]&&(J["x-attribsPrefix"]=e({},L["x-attribsPrefix"])),H=J}else if(C(L)){var j=z?B(L.children):[],Z=new g(j);j.forEach(function(he){return he.parent=Z}),H=Z}else if(D(L)){var j=z?B(L.children):[],re=new f(j);j.forEach(function(he){return he.parent=re}),L["x-mode"]&&(re["x-mode"]=L["x-mode"]),H=re}else if(w(L)){var ne=new h(L.name,L.data);L["x-name"]!=null&&(ne["x-name"]=L["x-name"],ne["x-publicId"]=L["x-publicId"],ne["x-systemId"]=L["x-systemId"]),H=ne}else throw new Error("Not implemented yet: ".concat(L.type));return H.startIndex=L.startIndex,H.endIndex=L.endIndex,L.sourceCodeLocation!=null&&(H.sourceCodeLocation=L.sourceCodeLocation),H}gl.cloneNode=x;function B(L){for(var z=L.map(function(j){return x(j,!0)}),H=1;H<z.length;H++)z[H].prev=z[H-1],z[H-1].next=z[H];return z}return gl}var Cze;function _ze(){return Cze||(Cze=1,function(t){var e=rF&&rF.__createBinding||(Object.create?function(h,p,g,f){f===void 0&&(f=g);var y=Object.getOwnPropertyDescriptor(p,g);(!y||("get"in y?!p.__esModule:y.writable||y.configurable))&&(y={enumerable:!0,get:function(){return p[g]}}),Object.defineProperty(h,f,y)}:function(h,p,g,f){f===void 0&&(f=g),h[f]=p[g]}),i=rF&&rF.__exportStar||function(h,p){for(var g in h)g!=="default"&&!Object.prototype.hasOwnProperty.call(p,g)&&e(p,h,g)};Object.defineProperty(t,"__esModule",{value:!0}),t.DomHandler=void 0;var r=Sze(),o=Tze();i(Tze(),t);var l={withStartIndices:!1,withEndIndices:!1,xmlMode:!1},d=function(){function h(p,g,f){this.dom=[],this.root=new o.Document(this.dom),this.done=!1,this.tagStack=[this.root],this.lastNode=null,this.parser=null,typeof g=="function"&&(f=g,g=l),typeof p=="object"&&(g=p,p=void 0),this.callback=p??null,this.options=g??l,this.elementCB=f??null}return h.prototype.onparserinit=function(p){this.parser=p},h.prototype.onreset=function(){this.dom=[],this.root=new o.Document(this.dom),this.done=!1,this.tagStack=[this.root],this.lastNode=null,this.parser=null},h.prototype.onend=function(){this.done||(this.done=!0,this.parser=null,this.handleCallback(null))},h.prototype.onerror=function(p){this.handleCallback(p)},h.prototype.onclosetag=function(){this.lastNode=null;var p=this.tagStack.pop();this.options.withEndIndices&&(p.endIndex=this.parser.endIndex),this.elementCB&&this.elementCB(p)},h.prototype.onopentag=function(p,g){var f=this.options.xmlMode?r.ElementType.Tag:void 0,y=new o.Element(p,g,void 0,f);this.addNode(y),this.tagStack.push(y)},h.prototype.ontext=function(p){var g=this.lastNode;if(g&&g.type===r.ElementType.Text)g.data+=p,this.options.withEndIndices&&(g.endIndex=this.parser.endIndex);else{var f=new o.Text(p);this.addNode(f),this.lastNode=f}},h.prototype.oncomment=function(p){if(this.lastNode&&this.lastNode.type===r.ElementType.Comment){this.lastNode.data+=p;return}var g=new o.Comment(p);this.addNode(g),this.lastNode=g},h.prototype.oncommentend=function(){this.lastNode=null},h.prototype.oncdatastart=function(){var p=new o.Text(""),g=new o.CDATA([p]);this.addNode(g),p.parent=g,this.lastNode=p},h.prototype.oncdataend=function(){this.lastNode=null},h.prototype.onprocessinginstruction=function(p,g){var f=new o.ProcessingInstruction(p,g);this.addNode(f)},h.prototype.handleCallback=function(p){if(typeof this.callback=="function")this.callback(p,this.dom);else if(p)throw p},h.prototype.addNode=function(p){var g=this.tagStack[this.tagStack.length-1],f=g.children[g.children.length-1];this.options.withStartIndices&&(p.startIndex=this.parser.startIndex),this.options.withEndIndices&&(p.endIndex=this.parser.endIndex),g.children.push(p),f&&(p.prev=f,f.next=p),p.parent=g,this.lastNode=null},h}();t.DomHandler=d,t.default=d}(rF)),rF}var Jge={},Eze;function dGt(){return Eze||(Eze=1,function(t){Object.defineProperty(t,"__esModule",{value:!0}),t.CARRIAGE_RETURN_PLACEHOLDER_REGEX=t.CARRIAGE_RETURN_PLACEHOLDER=t.CARRIAGE_RETURN_REGEX=t.CARRIAGE_RETURN=t.CASE_SENSITIVE_TAG_NAMES_MAP=t.CASE_SENSITIVE_TAG_NAMES=void 0,t.CASE_SENSITIVE_TAG_NAMES=["animateMotion","animateTransform","clipPath","feBlend","feColorMatrix","feComponentTransfer","feComposite","feConvolveMatrix","feDiffuseLighting","feDisplacementMap","feDropShadow","feFlood","feFuncA","feFuncB","feFuncG","feFuncR","feGaussianBlur","feImage","feMerge","feMergeNode","feMorphology","feOffset","fePointLight","feSpecularLighting","feSpotLight","feTile","feTurbulence","foreignObject","linearGradient","radialGradient","textPath"],t.CASE_SENSITIVE_TAG_NAMES_MAP=t.CASE_SENSITIVE_TAG_NAMES.reduce(function(e,i){return e[i.toLowerCase()]=i,e},{}),t.CARRIAGE_RETURN="\r",t.CARRIAGE_RETURN_REGEX=new RegExp(t.CARRIAGE_RETURN,"g"),t.CARRIAGE_RETURN_PLACEHOLDER="__HTML_DOM_PARSER_CARRIAGE_RETURN_PLACEHOLDER_".concat(Date.now(),"__"),t.CARRIAGE_RETURN_PLACEHOLDER_REGEX=new RegExp(t.CARRIAGE_RETURN_PLACEHOLDER,"g")}(Jge)),Jge}var Aze;function Ize(){if(Aze)return aF;Aze=1,Object.defineProperty(aF,"__esModule",{value:!0}),aF.formatAttributes=r,aF.escapeSpecialCharacters=l,aF.revertEscapedCharacters=d,aF.formatDOM=h;var t=_ze(),e=dGt();function i(p){return e.CASE_SENSITIVE_TAG_NAMES_MAP[p]}function r(p){for(var g={},f=0,y=p.length;f<y;f++){var T=p[f];g[T.name]=T.value}return g}function o(p){p=p.toLowerCase();var g=i(p);return g||p}function l(p){return p.replace(e.CARRIAGE_RETURN_REGEX,e.CARRIAGE_RETURN_PLACEHOLDER)}function d(p){return p.replace(e.CARRIAGE_RETURN_PLACEHOLDER_REGEX,e.CARRIAGE_RETURN)}function h(p,g,f){g===void 0&&(g=null);for(var y=[],T,C=0,E=p.length;C<E;C++){var I=p[C];switch(I.nodeType){case 1:{var w=o(I.nodeName);T=new t.Element(w,r(I.attributes)),T.children=h(w==="template"?I.content.childNodes:I.childNodes,T);break}case 3:T=new t.Text(d(I.nodeValue));break;case 8:T=new t.Comment(I.nodeValue);break;default:continue}var D=y[C-1]||null;D&&(D.next=T),T.parent=g,T.prev=D,T.next=null,y.push(T)}return f&&(T=new t.ProcessingInstruction(f.substring(0,f.indexOf(" ")).toLowerCase(),f),T.next=y[0]||null,T.parent=g,y.unshift(T),y[1]&&(y[1].prev=y[0])),y}return aF}var wze;function uGt(){if(wze)return xZ;wze=1,Object.defineProperty(xZ,"__esModule",{value:!0}),xZ.default=I;var t=Ize(),e="html",i="head",r="body",o=/<([a-zA-Z]+[0-9]?)/,l=/<head[^]*>/i,d=/<body[^]*>/i,h=function(w,D){throw new Error("This browser does not support `document.implementation.createHTMLDocument`")},p=function(w,D){throw new Error("This browser does not support `DOMParser.prototype.parseFromString`")},g=typeof window=="object"&&window.DOMParser;if(typeof g=="function"){var f=new g,y="text/html";p=function(w,D){return D&&(w="<".concat(D,">").concat(w,"</").concat(D,">")),f.parseFromString(w,y)},h=p}if(typeof document=="object"&&document.implementation){var T=document.implementation.createHTMLDocument();h=function(w,D){if(D){var F=T.documentElement.querySelector(D);return F&&(F.innerHTML=w),T}return T.documentElement.innerHTML=w,T}}var C=typeof document=="object"&&document.createElement("template"),E;C&&C.content&&(E=function(w){return C.innerHTML=w,C.content.childNodes});function I(w){var D,F;w=(0,t.escapeSpecialCharacters)(w);var x=w.match(o),B=x&&x[1]?x[1].toLowerCase():"";switch(B){case e:{var L=p(w);if(!l.test(w)){var z=L.querySelector(i);(D=z?.parentNode)===null||D===void 0||D.removeChild(z)}if(!d.test(w)){var z=L.querySelector(r);(F=z?.parentNode)===null||F===void 0||F.removeChild(z)}return L.querySelectorAll(e)}case i:case r:{var H=h(w).querySelectorAll(B);return d.test(w)&&l.test(w)?H[0].parentNode.childNodes:H}default:{if(E)return E(w);var z=h(w,r).querySelector(r);return z.childNodes}}}return xZ}var kze;function hGt(){if(kze)return _4;kze=1;var t=_4&&_4.__importDefault||function(l){return l&&l.__esModule?l:{default:l}};Object.defineProperty(_4,"__esModule",{value:!0}),_4.default=o;var e=t(uGt()),i=Ize(),r=/<(![a-zA-Z\s]+)>/;function o(l){if(typeof l!="string")throw new TypeError("First argument must be a string");if(!l)return[];var d=l.match(r),h=d?d[1]:void 0;return(0,i.formatDOM)((0,e.default)(l),null,h)}return _4}var BZ={},WE={},w8={},Rze;function pGt(){if(Rze)return w8;Rze=1;var t=0;w8.SAME=t;var e=1;return w8.CAMELCASE=e,w8.possibleStandardNames={accept:0,acceptCharset:1,"accept-charset":"acceptCharset",accessKey:1,action:0,allowFullScreen:1,alt:0,as:0,async:0,autoCapitalize:1,autoComplete:1,autoCorrect:1,autoFocus:1,autoPlay:1,autoSave:1,capture:0,cellPadding:1,cellSpacing:1,challenge:0,charSet:1,checked:0,children:0,cite:0,class:"className",classID:1,className:1,cols:0,colSpan:1,content:0,contentEditable:1,contextMenu:1,controls:0,controlsList:1,coords:0,crossOrigin:1,dangerouslySetInnerHTML:1,data:0,dateTime:1,default:0,defaultChecked:1,defaultValue:1,defer:0,dir:0,disabled:0,disablePictureInPicture:1,disableRemotePlayback:1,download:0,draggable:0,encType:1,enterKeyHint:1,for:"htmlFor",form:0,formMethod:1,formAction:1,formEncType:1,formNoValidate:1,formTarget:1,frameBorder:1,headers:0,height:0,hidden:0,high:0,href:0,hrefLang:1,htmlFor:1,httpEquiv:1,"http-equiv":"httpEquiv",icon:0,id:0,innerHTML:1,inputMode:1,integrity:0,is:0,itemID:1,itemProp:1,itemRef:1,itemScope:1,itemType:1,keyParams:1,keyType:1,kind:0,label:0,lang:0,list:0,loop:0,low:0,manifest:0,marginWidth:1,marginHeight:1,max:0,maxLength:1,media:0,mediaGroup:1,method:0,min:0,minLength:1,multiple:0,muted:0,name:0,noModule:1,nonce:0,noValidate:1,open:0,optimum:0,pattern:0,placeholder:0,playsInline:1,poster:0,preload:0,profile:0,radioGroup:1,readOnly:1,referrerPolicy:1,rel:0,required:0,reversed:0,role:0,rows:0,rowSpan:1,sandbox:0,scope:0,scoped:0,scrolling:0,seamless:0,selected:0,shape:0,size:0,sizes:0,span:0,spellCheck:1,src:0,srcDoc:1,srcLang:1,srcSet:1,start:0,step:0,style:0,summary:0,tabIndex:1,target:0,title:0,type:0,useMap:1,value:0,width:0,wmode:0,wrap:0,about:0,accentHeight:1,"accent-height":"accentHeight",accumulate:0,additive:0,alignmentBaseline:1,"alignment-baseline":"alignmentBaseline",allowReorder:1,alphabetic:0,amplitude:0,arabicForm:1,"arabic-form":"arabicForm",ascent:0,attributeName:1,attributeType:1,autoReverse:1,azimuth:0,baseFrequency:1,baselineShift:1,"baseline-shift":"baselineShift",baseProfile:1,bbox:0,begin:0,bias:0,by:0,calcMode:1,capHeight:1,"cap-height":"capHeight",clip:0,clipPath:1,"clip-path":"clipPath",clipPathUnits:1,clipRule:1,"clip-rule":"clipRule",color:0,colorInterpolation:1,"color-interpolation":"colorInterpolation",colorInterpolationFilters:1,"color-interpolation-filters":"colorInterpolationFilters",colorProfile:1,"color-profile":"colorProfile",colorRendering:1,"color-rendering":"colorRendering",contentScriptType:1,contentStyleType:1,cursor:0,cx:0,cy:0,d:0,datatype:0,decelerate:0,descent:0,diffuseConstant:1,direction:0,display:0,divisor:0,dominantBaseline:1,"dominant-baseline":"dominantBaseline",dur:0,dx:0,dy:0,edgeMode:1,elevation:0,enableBackground:1,"enable-background":"enableBackground",end:0,exponent:0,externalResourcesRequired:1,fill:0,fillOpacity:1,"fill-opacity":"fillOpacity",fillRule:1,"fill-rule":"fillRule",filter:0,filterRes:1,filterUnits:1,floodOpacity:1,"flood-opacity":"floodOpacity",floodColor:1,"flood-color":"floodColor",focusable:0,fontFamily:1,"font-family":"fontFamily",fontSize:1,"font-size":"fontSize",fontSizeAdjust:1,"font-size-adjust":"fontSizeAdjust",fontStretch:1,"font-stretch":"fontStretch",fontStyle:1,"font-style":"fontStyle",fontVariant:1,"font-variant":"fontVariant",fontWeight:1,"font-weight":"fontWeight",format:0,from:0,fx:0,fy:0,g1:0,g2:0,glyphName:1,"glyph-name":"glyphName",glyphOrientationHorizontal:1,"glyph-orientation-horizontal":"glyphOrientationHorizontal",glyphOrientationVertical:1,"glyph-orientation-vertical":"glyphOrientationVertical",glyphRef:1,gradientTransform:1,gradientUnits:1,hanging:0,horizAdvX:1,"horiz-adv-x":"horizAdvX",horizOriginX:1,"horiz-origin-x":"horizOriginX",ideographic:0,imageRendering:1,"image-rendering":"imageRendering",in2:0,in:0,inlist:0,intercept:0,k1:0,k2:0,k3:0,k4:0,k:0,kernelMatrix:1,kernelUnitLength:1,kerning:0,keyPoints:1,keySplines:1,keyTimes:1,lengthAdjust:1,letterSpacing:1,"letter-spacing":"letterSpacing",lightingColor:1,"lighting-color":"lightingColor",limitingConeAngle:1,local:0,markerEnd:1,"marker-end":"markerEnd",markerHeight:1,markerMid:1,"marker-mid":"markerMid",markerStart:1,"marker-start":"markerStart",markerUnits:1,markerWidth:1,mask:0,maskContentUnits:1,maskUnits:1,mathematical:0,mode:0,numOctaves:1,offset:0,opacity:0,operator:0,order:0,orient:0,orientation:0,origin:0,overflow:0,overlinePosition:1,"overline-position":"overlinePosition",overlineThickness:1,"overline-thickness":"overlineThickness",paintOrder:1,"paint-order":"paintOrder",panose1:0,"panose-1":"panose1",pathLength:1,patternContentUnits:1,patternTransform:1,patternUnits:1,pointerEvents:1,"pointer-events":"pointerEvents",points:0,pointsAtX:1,pointsAtY:1,pointsAtZ:1,prefix:0,preserveAlpha:1,preserveAspectRatio:1,primitiveUnits:1,property:0,r:0,radius:0,refX:1,refY:1,renderingIntent:1,"rendering-intent":"renderingIntent",repeatCount:1,repeatDur:1,requiredExtensions:1,requiredFeatures:1,resource:0,restart:0,result:0,results:0,rotate:0,rx:0,ry:0,scale:0,security:0,seed:0,shapeRendering:1,"shape-rendering":"shapeRendering",slope:0,spacing:0,specularConstant:1,specularExponent:1,speed:0,spreadMethod:1,startOffset:1,stdDeviation:1,stemh:0,stemv:0,stitchTiles:1,stopColor:1,"stop-color":"stopColor",stopOpacity:1,"stop-opacity":"stopOpacity",strikethroughPosition:1,"strikethrough-position":"strikethroughPosition",strikethroughThickness:1,"strikethrough-thickness":"strikethroughThickness",string:0,stroke:0,strokeDasharray:1,"stroke-dasharray":"strokeDasharray",strokeDashoffset:1,"stroke-dashoffset":"strokeDashoffset",strokeLinecap:1,"stroke-linecap":"strokeLinecap",strokeLinejoin:1,"stroke-linejoin":"strokeLinejoin",strokeMiterlimit:1,"stroke-miterlimit":"strokeMiterlimit",strokeWidth:1,"stroke-width":"strokeWidth",strokeOpacity:1,"stroke-opacity":"strokeOpacity",suppressContentEditableWarning:1,suppressHydrationWarning:1,surfaceScale:1,systemLanguage:1,tableValues:1,targetX:1,targetY:1,textAnchor:1,"text-anchor":"textAnchor",textDecoration:1,"text-decoration":"textDecoration",textLength:1,textRendering:1,"text-rendering":"textRendering",to:0,transform:0,typeof:0,u1:0,u2:0,underlinePosition:1,"underline-position":"underlinePosition",underlineThickness:1,"underline-thickness":"underlineThickness",unicode:0,unicodeBidi:1,"unicode-bidi":"unicodeBidi",unicodeRange:1,"unicode-range":"unicodeRange",unitsPerEm:1,"units-per-em":"unitsPerEm",unselectable:0,vAlphabetic:1,"v-alphabetic":"vAlphabetic",values:0,vectorEffect:1,"vector-effect":"vectorEffect",version:0,vertAdvY:1,"vert-adv-y":"vertAdvY",vertOriginX:1,"vert-origin-x":"vertOriginX",vertOriginY:1,"vert-origin-y":"vertOriginY",vHanging:1,"v-hanging":"vHanging",vIdeographic:1,"v-ideographic":"vIdeographic",viewBox:1,viewTarget:1,visibility:0,vMathematical:1,"v-mathematical":"vMathematical",vocab:0,widths:0,wordSpacing:1,"word-spacing":"wordSpacing",writingMode:1,"writing-mode":"writingMode",x1:0,x2:0,x:0,xChannelSelector:1,xHeight:1,"x-height":"xHeight",xlinkActuate:1,"xlink:actuate":"xlinkActuate",xlinkArcrole:1,"xlink:arcrole":"xlinkArcrole",xlinkHref:1,"xlink:href":"xlinkHref",xlinkRole:1,"xlink:role":"xlinkRole",xlinkShow:1,"xlink:show":"xlinkShow",xlinkTitle:1,"xlink:title":"xlinkTitle",xlinkType:1,"xlink:type":"xlinkType",xmlBase:1,"xml:base":"xmlBase",xmlLang:1,"xml:lang":"xmlLang",xmlns:0,"xml:space":"xmlSpace",xmlnsXlink:1,"xmlns:xlink":"xmlnsXlink",xmlSpace:1,y1:0,y2:0,y:0,yChannelSelector:1,z:0,zoomAndPan:1},w8}var Mze;function gGt(){if(Mze)return WE;Mze=1;const t=0,e=1,i=2,r=3,o=4,l=5,d=6;function h(L){return g.hasOwnProperty(L)?g[L]:null}function p(L,z,H,j,J,Z,re){this.acceptsBooleans=z===i||z===r||z===o,this.attributeName=j,this.attributeNamespace=J,this.mustUseProperty=H,this.propertyName=L,this.type=z,this.sanitizeURL=Z,this.removeEmptyString=re}const g={};["children","dangerouslySetInnerHTML","defaultValue","defaultChecked","innerHTML","suppressContentEditableWarning","suppressHydrationWarning","style"].forEach(L=>{g[L]=new p(L,t,!1,L,null,!1,!1)}),[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(([L,z])=>{g[L]=new p(L,e,!1,z,null,!1,!1)}),["contentEditable","draggable","spellCheck","value"].forEach(L=>{g[L]=new p(L,i,!1,L.toLowerCase(),null,!1,!1)}),["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(L=>{g[L]=new p(L,i,!1,L,null,!1,!1)}),["allowFullScreen","async","autoFocus","autoPlay","controls","default","defer","disabled","disablePictureInPicture","disableRemotePlayback","formNoValidate","hidden","loop","noModule","noValidate","open","playsInline","readOnly","required","reversed","scoped","seamless","itemScope"].forEach(L=>{g[L]=new p(L,r,!1,L.toLowerCase(),null,!1,!1)}),["checked","multiple","muted","selected"].forEach(L=>{g[L]=new p(L,r,!0,L,null,!1,!1)}),["capture","download"].forEach(L=>{g[L]=new p(L,o,!1,L,null,!1,!1)}),["cols","rows","size","span"].forEach(L=>{g[L]=new p(L,d,!1,L,null,!1,!1)}),["rowSpan","start"].forEach(L=>{g[L]=new p(L,l,!1,L.toLowerCase(),null,!1,!1)});const y=/[\-\:]([a-z])/g,T=L=>L[1].toUpperCase();["accent-height","alignment-baseline","arabic-form","baseline-shift","cap-height","clip-path","clip-rule","color-interpolation","color-interpolation-filters","color-profile","color-rendering","dominant-baseline","enable-background","fill-opacity","fill-rule","flood-color","flood-opacity","font-family","font-size","font-size-adjust","font-stretch","font-style","font-variant","font-weight","glyph-name","glyph-orientation-horizontal","glyph-orientation-vertical","horiz-adv-x","horiz-origin-x","image-rendering","letter-spacing","lighting-color","marker-end","marker-mid","marker-start","overline-position","overline-thickness","paint-order","panose-1","pointer-events","rendering-intent","shape-rendering","stop-color","stop-opacity","strikethrough-position","strikethrough-thickness","stroke-dasharray","stroke-dashoffset","stroke-linecap","stroke-linejoin","stroke-miterlimit","stroke-opacity","stroke-width","text-anchor","text-decoration","text-rendering","underline-position","underline-thickness","unicode-bidi","unicode-range","units-per-em","v-alphabetic","v-hanging","v-ideographic","v-mathematical","vector-effect","vert-adv-y","vert-origin-x","vert-origin-y","word-spacing","writing-mode","xmlns:xlink","x-height"].forEach(L=>{const z=L.replace(y,T);g[z]=new p(z,e,!1,L,null,!1,!1)}),["xlink:actuate","xlink:arcrole","xlink:role","xlink:show","xlink:title","xlink:type"].forEach(L=>{const z=L.replace(y,T);g[z]=new p(z,e,!1,L,"http://www.w3.org/1999/xlink",!1,!1)}),["xml:base","xml:lang","xml:space"].forEach(L=>{const z=L.replace(y,T);g[z]=new p(z,e,!1,L,"http://www.w3.org/XML/1998/namespace",!1,!1)}),["tabIndex","crossOrigin"].forEach(L=>{g[L]=new p(L,e,!1,L.toLowerCase(),null,!1,!1)});const C="xlinkHref";g[C]=new p("xlinkHref",e,!1,"xlink:href","http://www.w3.org/1999/xlink",!0,!1),["src","href","action","formAction"].forEach(L=>{g[L]=new p(L,e,!1,L.toLowerCase(),null,!0,!0)});const{CAMELCASE:E,SAME:I,possibleStandardNames:w}=pGt(),F=":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD"+"\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040",x=RegExp.prototype.test.bind(new RegExp("^(data|aria)-["+F+"]*$")),B=Object.keys(w).reduce((L,z)=>{const H=w[z];return H===I?L[z]=z:H===E?L[z.toLowerCase()]=z:L[z]=H,L},{});return WE.BOOLEAN=r,WE.BOOLEANISH_STRING=i,WE.NUMERIC=l,WE.OVERLOADED_BOOLEAN=o,WE.POSITIVE_NUMERIC=d,WE.RESERVED=t,WE.STRING=e,WE.getPropertyInfo=h,WE.isCustomAttribute=x,WE.possibleStandardNames=B,WE}var k8={},E4={},Yge,Pze;function mGt(){if(Pze)return Yge;Pze=1;var t=/\/\*[^*]*\*+([^/*][^*]*\*+)*\//g,e=/\n/g,i=/^\s*/,r=/^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/,o=/^:\s*/,l=/^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/,d=/^[;\s]*/,h=/^\s+|\s+$/g,p=`
`,g="/",f="*",y="",T="comment",C="declaration";Yge=function(I,w){if(typeof I!="string")throw new TypeError("First argument must be a string");if(!I)return[];w=w||{};var D=1,F=1;function x(le){var he=le.match(e);he&&(D+=he.length);var Me=le.lastIndexOf(p);F=~Me?le.length-Me:F+le.length}function B(){var le={line:D,column:F};return function(he){return he.position=new L(le),j(),he}}function L(le){this.start=le,this.end={line:D,column:F},this.source=w.source}L.prototype.content=I;function z(le){var he=new Error(w.source+":"+D+":"+F+": "+le);if(he.reason=le,he.filename=w.source,he.line=D,he.column=F,he.source=I,!w.silent)throw he}function H(le){var he=le.exec(I);if(he){var Me=he[0];return x(Me),I=I.slice(Me.length),he}}function j(){H(i)}function J(le){var he;for(le=le||[];he=Z();)he!==!1&&le.push(he);return le}function Z(){var le=B();if(!(g!=I.charAt(0)||f!=I.charAt(1))){for(var he=2;y!=I.charAt(he)&&(f!=I.charAt(he)||g!=I.charAt(he+1));)++he;if(he+=2,y===I.charAt(he-1))return z("End of comment missing");var Me=I.slice(2,he-2);return F+=2,x(Me),I=I.slice(he),F+=2,le({type:T,comment:Me})}}function re(){var le=B(),he=H(r);if(he){if(Z(),!H(o))return z("property missing ':'");var Me=H(l),Le=le({type:C,property:E(he[0].replace(t,y)),value:Me?E(Me[0].replace(t,y)):y});return H(d),Le}}function ne(){var le=[];J(le);for(var he;he=re();)he!==!1&&(le.push(he),J(le));return le}return j(),ne()};function E(I){return I?I.replace(h,y):y}return Yge}var Dze;function fGt(){if(Dze)return E4;Dze=1;var t=E4&&E4.__importDefault||function(r){return r&&r.__esModule?r:{default:r}};Object.defineProperty(E4,"__esModule",{value:!0}),E4.default=i;var e=t(mGt());function i(r,o){var l=null;if(!r||typeof r!="string")return l;var d=(0,e.default)(r),h=typeof o=="function";return d.forEach(function(p){if(p.type==="declaration"){var g=p.property,f=p.value;h?o(g,f,p):f&&(l=l||{},l[g]=f)}}),l}return E4}var R8={},Lze;function vGt(){if(Lze)return R8;Lze=1,Object.defineProperty(R8,"__esModule",{value:!0}),R8.camelCase=void 0;var t=/^--[a-zA-Z0-9_-]+$/,e=/-([a-z])/g,i=/^[^-]+$/,r=/^-(webkit|moz|ms|o|khtml)-/,o=/^-(ms)-/,l=function(g){return!g||i.test(g)||t.test(g)},d=function(g,f){return f.toUpperCase()},h=function(g,f){return"".concat(f,"-")},p=function(g,f){return f===void 0&&(f={}),l(g)?g:(g=g.toLowerCase(),f.reactCompat?g=g.replace(o,h):g=g.replace(r,h),g.replace(e,d))};return R8.camelCase=p,R8}var M8,Oze;function yGt(){if(Oze)return M8;Oze=1;var t=M8&&M8.__importDefault||function(o){return o&&o.__esModule?o:{default:o}},e=t(fGt()),i=vGt();function r(o,l){var d={};return!o||typeof o!="string"||(0,e.default)(o,function(h,p){h&&p&&(d[(0,i.camelCase)(h,l)]=p)}),d}return r.default=r,M8=r,M8}var Nze;function xze(){return Nze||(Nze=1,function(t){var e=k8&&k8.__importDefault||function(f){return f&&f.__esModule?f:{default:f}};Object.defineProperty(t,"__esModule",{value:!0}),t.returnFirstArg=t.canTextBeChildOfNode=t.ELEMENTS_WITH_NO_TEXT_CHILDREN=t.PRESERVE_CUSTOM_ATTRIBUTES=void 0,t.isCustomComponent=l,t.setStyleProp=h;var i=fM(),r=e(yGt()),o=new Set(["annotation-xml","color-profile","font-face","font-face-src","font-face-uri","font-face-format","font-face-name","missing-glyph"]);function l(f,y){return f.includes("-")?!o.has(f):!!(y&&typeof y.is=="string")}var d={reactCompat:!0};function h(f,y){if(typeof f=="string"){if(!f.trim()){y.style={};return}try{y.style=(0,r.default)(f,d)}catch{y.style={}}}}t.PRESERVE_CUSTOM_ATTRIBUTES=Number(i.version.split(".")[0])>=16,t.ELEMENTS_WITH_NO_TEXT_CHILDREN=new Set(["tr","tbody","thead","tfoot","colgroup","table","head","html","frameset"]);var p=function(f){return!t.ELEMENTS_WITH_NO_TEXT_CHILDREN.has(f.name)};t.canTextBeChildOfNode=p;var g=function(f){return f};t.returnFirstArg=g}(k8)),k8}var Bze;function Fze(){if(Bze)return BZ;Bze=1,Object.defineProperty(BZ,"__esModule",{value:!0}),BZ.default=l;var t=gGt(),e=xze(),i=["checked","value"],r=["input","select","textarea"],o={reset:!0,submit:!0};function l(h,p){h===void 0&&(h={});var g={},f=!!(h.type&&o[h.type]);for(var y in h){var T=h[y];if((0,t.isCustomAttribute)(y)){g[y]=T;continue}var C=y.toLowerCase(),E=d(C);if(E){var I=(0,t.getPropertyInfo)(E);switch(i.includes(E)&&r.includes(p)&&!f&&(E=d("default"+C)),g[E]=T,I&&I.type){case t.BOOLEAN:g[E]=!0;break;case t.OVERLOADED_BOOLEAN:T===""&&(g[E]=!0);break}continue}e.PRESERVE_CUSTOM_ATTRIBUTES&&(g[y]=T)}return(0,e.setStyleProp)(h.style,g),g}function d(h){return t.possibleStandardNames[h]}return BZ}var A4={},Uze;function SGt(){if(Uze)return A4;Uze=1;var t=A4&&A4.__importDefault||function(h){return h&&h.__esModule?h:{default:h}};Object.defineProperty(A4,"__esModule",{value:!0}),A4.default=l;var e=fM(),i=t(Fze()),r=xze(),o={cloneElement:e.cloneElement,createElement:e.createElement,isValidElement:e.isValidElement};function l(h,p){p===void 0&&(p={});for(var g=[],f=typeof p.replace=="function",y=p.transform||r.returnFirstArg,T=p.library||o,C=T.cloneElement,E=T.createElement,I=T.isValidElement,w=h.length,D=0;D<w;D++){var F=h[D];if(f){var x=p.replace(F,D);if(I(x)){w>1&&(x=C(x,{key:x.key||D})),g.push(y(x,F,D));continue}}if(F.type==="text"){var B=!F.data.trim().length;if(B&&F.parent&&!(0,r.canTextBeChildOfNode)(F.parent)||p.trim&&B)continue;g.push(y(F.data,F,D));continue}var L=F,z={};d(L)?((0,r.setStyleProp)(L.attribs.style,L.attribs),z=L.attribs):L.attribs&&(z=(0,i.default)(L.attribs,L.name));var H=void 0;switch(F.type){case"script":case"style":F.children[0]&&(z.dangerouslySetInnerHTML={__html:F.children[0].data});break;case"tag":F.name==="textarea"&&F.children[0]?z.defaultValue=F.children[0].data:F.children&&F.children.length&&(H=l(F.children,p));break;default:continue}w>1&&(z.key=D),g.push(y(E(F.name,z,H),F,D))}return g.length===1?g[0]:g}function d(h){return r.PRESERVE_CUSTOM_ATTRIBUTES&&h.type==="tag"&&(0,r.isCustomComponent)(h.name,h.attribs)}return A4}var zze;function bGt(){return zze||(zze=1,function(t){var e=I8&&I8.__importDefault||function(p){return p&&p.__esModule?p:{default:p}};Object.defineProperty(t,"__esModule",{value:!0}),t.htmlToDOM=t.domToReact=t.attributesToProps=t.Text=t.ProcessingInstruction=t.Element=t.Comment=void 0,t.default=h;var i=e(hGt());t.htmlToDOM=i.default;var r=e(Fze());t.attributesToProps=r.default;var o=e(SGt());t.domToReact=o.default;var l=_ze();Object.defineProperty(t,"Comment",{enumerable:!0,get:function(){return l.Comment}}),Object.defineProperty(t,"Element",{enumerable:!0,get:function(){return l.Element}}),Object.defineProperty(t,"ProcessingInstruction",{enumerable:!0,get:function(){return l.ProcessingInstruction}}),Object.defineProperty(t,"Text",{enumerable:!0,get:function(){return l.Text}});var d={lowerCaseAttributeNames:!1};function h(p,g){if(typeof p!="string")throw new TypeError("First argument must be a string");return p?(0,o.default)((0,i.default)(p,g?.htmlparser2||d),g):[]}}(I8)),I8}var Qge=bGt();const Vze=cL(Qge),TGt=Vze.default||Vze;var FZ={},UZ={},zZ={},$ze;function CGt(){if($ze)return zZ;$ze=1,Object.defineProperty(zZ,"__esModule",{value:!0});var t=fM(),e=i(t);function i(r){if(r&&r.__esModule)return r;var o={};if(r!=null)for(var l in r)Object.prototype.hasOwnProperty.call(r,l)&&(o[l]=r[l]);return o.default=r,o}return zZ.default=function(r,o,l){return e.createElement("a",{href:r,key:l},o)},zZ}var VZ={},Hze;function _Gt(){return Hze||(Hze=1,Object.defineProperty(VZ,"__esModule",{value:!0}),VZ.default=function(t){return t}),VZ}var $Z={},Zge,jze;function EGt(){return jze||(jze=1,Zge=/[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/),Zge}var Xge,Gze;function AGt(){return Gze||(Gze=1,Xge=/[\0-\x1F\x7F-\x9F]/),Xge}var eme,qze;function IGt(){return qze||(qze=1,eme=/[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/),eme}var tme,Wze;function wGt(){return Wze||(Wze=1,tme=/[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4E\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDF55-\uDF59]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDC3B\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/),tme}var ime,Kze;function kGt(){return Kze||(Kze=1,ime=function(t){var e={};e.src_Any=EGt().source,e.src_Cc=AGt().source,e.src_Z=IGt().source,e.src_P=wGt().source,e.src_ZPCc=[e.src_Z,e.src_P,e.src_Cc].join("|"),e.src_ZCc=[e.src_Z,e.src_Cc].join("|");var i="[><｜]";return e.src_pseudo_letter="(?:(?!"+i+"|"+e.src_ZPCc+")"+e.src_Any+")",e.src_ip4="(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)",e.src_auth="(?:(?:(?!"+e.src_ZCc+"|[@/\\[\\]()]).)+@)?",e.src_port="(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?",e.src_host_terminator="(?=$|"+i+"|"+e.src_ZPCc+")(?!-|_|:\\d|\\.-|\\.(?!$|"+e.src_ZPCc+"))",e.src_path="(?:[/?#](?:(?!"+e.src_ZCc+"|"+i+`|[()[\\]{}.,"'?!\\-]).|\\[(?:(?!`+e.src_ZCc+"|\\]).)*\\]|\\((?:(?!"+e.src_ZCc+"|[)]).)*\\)|\\{(?:(?!"+e.src_ZCc+'|[}]).)*\\}|\\"(?:(?!'+e.src_ZCc+`|["]).)+\\"|\\'(?:(?!`+e.src_ZCc+"|[']).)+\\'|\\'(?="+e.src_pseudo_letter+"|[-]).|\\.{2,4}[a-zA-Z0-9%/]|\\.(?!"+e.src_ZCc+"|[.]).|"+(t&&t["---"]?"\\-(?!--(?:[^-]|$))(?:-*)|":"\\-+|")+"\\,(?!"+e.src_ZCc+").|\\!(?!"+e.src_ZCc+"|[!]).|\\?(?!"+e.src_ZCc+"|[?]).)+|\\/)?",e.src_email_name='[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*',e.src_xn="xn--[a-z0-9\\-]{1,59}",e.src_domain_root="(?:"+e.src_xn+"|"+e.src_pseudo_letter+"{1,63})",e.src_domain="(?:"+e.src_xn+"|(?:"+e.src_pseudo_letter+")|(?:"+e.src_pseudo_letter+"(?:-|"+e.src_pseudo_letter+"){0,61}"+e.src_pseudo_letter+"))",e.src_host="(?:(?:(?:(?:"+e.src_domain+")\\.)*"+e.src_domain+"))",e.tpl_host_fuzzy="(?:"+e.src_ip4+"|(?:(?:(?:"+e.src_domain+")\\.)+(?:%TLDS%)))",e.tpl_host_no_ip_fuzzy="(?:(?:(?:"+e.src_domain+")\\.)+(?:%TLDS%))",e.src_host_strict=e.src_host+e.src_host_terminator,e.tpl_host_fuzzy_strict=e.tpl_host_fuzzy+e.src_host_terminator,e.src_host_port_strict=e.src_host+e.src_port+e.src_host_terminator,e.tpl_host_port_fuzzy_strict=e.tpl_host_fuzzy+e.src_port+e.src_host_terminator,e.tpl_host_port_no_ip_fuzzy_strict=e.tpl_host_no_ip_fuzzy+e.src_port+e.src_host_terminator,e.tpl_host_fuzzy_test="localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:"+e.src_ZPCc+"|>|$))",e.tpl_email_fuzzy="(^|"+i+'|"|\\(|'+e.src_ZCc+")("+e.src_email_name+"@"+e.tpl_host_fuzzy_strict+")",e.tpl_link_fuzzy="(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|"+e.src_ZPCc+"))((?![$+<=>^`|｜])"+e.tpl_host_port_fuzzy_strict+e.src_path+")",e.tpl_link_no_ip_fuzzy="(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|"+e.src_ZPCc+"))((?![$+<=>^`|｜])"+e.tpl_host_port_no_ip_fuzzy_strict+e.src_path+")",e}),ime}var nme,Jze;function RGt(){if(Jze)return nme;Jze=1;function t(x){var B=Array.prototype.slice.call(arguments,1);return B.forEach(function(L){L&&Object.keys(L).forEach(function(z){x[z]=L[z]})}),x}function e(x){return Object.prototype.toString.call(x)}function i(x){return e(x)==="[object String]"}function r(x){return e(x)==="[object Object]"}function o(x){return e(x)==="[object RegExp]"}function l(x){return e(x)==="[object Function]"}function d(x){return x.replace(/[.?*+^$[\]\\(){}|-]/g,"\\$&")}var h={fuzzyLink:!0,fuzzyEmail:!0,fuzzyIP:!1};function p(x){return Object.keys(x||{}).reduce(function(B,L){return B||h.hasOwnProperty(L)},!1)}var g={"http:":{validate:function(x,B,L){var z=x.slice(B);return L.re.http||(L.re.http=new RegExp("^\\/\\/"+L.re.src_auth+L.re.src_host_port_strict+L.re.src_path,"i")),L.re.http.test(z)?z.match(L.re.http)[0].length:0}},"https:":"http:","ftp:":"http:","//":{validate:function(x,B,L){var z=x.slice(B);return L.re.no_http||(L.re.no_http=new RegExp("^"+L.re.src_auth+"(?:localhost|(?:(?:"+L.re.src_domain+")\\.)+"+L.re.src_domain_root+")"+L.re.src_port+L.re.src_host_terminator+L.re.src_path,"i")),L.re.no_http.test(z)?B>=3&&x[B-3]===":"||B>=3&&x[B-3]==="/"?0:z.match(L.re.no_http)[0].length:0}},"mailto:":{validate:function(x,B,L){var z=x.slice(B);return L.re.mailto||(L.re.mailto=new RegExp("^"+L.re.src_email_name+"@"+L.re.src_host_strict,"i")),L.re.mailto.test(z)?z.match(L.re.mailto)[0].length:0}}},f="a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]",y="biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф".split("|");function T(x){x.__index__=-1,x.__text_cache__=""}function C(x){return function(B,L){var z=B.slice(L);return x.test(z)?z.match(x)[0].length:0}}function E(){return function(x,B){B.normalize(x)}}function I(x){var B=x.re=kGt()(x.__opts__),L=x.__tlds__.slice();x.onCompile(),x.__tlds_replaced__||L.push(f),L.push(B.src_xn),B.src_tlds=L.join("|");function z(Z){return Z.replace("%TLDS%",B.src_tlds)}B.email_fuzzy=RegExp(z(B.tpl_email_fuzzy),"i"),B.link_fuzzy=RegExp(z(B.tpl_link_fuzzy),"i"),B.link_no_ip_fuzzy=RegExp(z(B.tpl_link_no_ip_fuzzy),"i"),B.host_fuzzy_test=RegExp(z(B.tpl_host_fuzzy_test),"i");var H=[];x.__compiled__={};function j(Z,re){throw new Error('(LinkifyIt) Invalid schema "'+Z+'": '+re)}Object.keys(x.__schemas__).forEach(function(Z){var re=x.__schemas__[Z];if(re!==null){var ne={validate:null,link:null};if(x.__compiled__[Z]=ne,r(re)){o(re.validate)?ne.validate=C(re.validate):l(re.validate)?ne.validate=re.validate:j(Z,re),l(re.normalize)?ne.normalize=re.normalize:re.normalize?j(Z,re):ne.normalize=E();return}if(i(re)){H.push(Z);return}j(Z,re)}}),H.forEach(function(Z){x.__compiled__[x.__schemas__[Z]]&&(x.__compiled__[Z].validate=x.__compiled__[x.__schemas__[Z]].validate,x.__compiled__[Z].normalize=x.__compiled__[x.__schemas__[Z]].normalize)}),x.__compiled__[""]={validate:null,normalize:E()};var J=Object.keys(x.__compiled__).filter(function(Z){return Z.length>0&&x.__compiled__[Z]}).map(d).join("|");x.re.schema_test=RegExp("(^|(?!_)(?:[><｜]|"+B.src_ZPCc+"))("+J+")","i"),x.re.schema_search=RegExp("(^|(?!_)(?:[><｜]|"+B.src_ZPCc+"))("+J+")","ig"),x.re.pretest=RegExp("("+x.re.schema_test.source+")|("+x.re.host_fuzzy_test.source+")|@","i"),T(x)}function w(x,B){var L=x.__index__,z=x.__last_index__,H=x.__text_cache__.slice(L,z);this.schema=x.__schema__.toLowerCase(),this.index=L+B,this.lastIndex=z+B,this.raw=H,this.text=H,this.url=H}function D(x,B){var L=new w(x,B);return x.__compiled__[L.schema].normalize(L,x),L}function F(x,B){if(!(this instanceof F))return new F(x,B);B||p(x)&&(B=x,x={}),this.__opts__=t({},h,B),this.__index__=-1,this.__last_index__=-1,this.__schema__="",this.__text_cache__="",this.__schemas__=t({},g,x),this.__compiled__={},this.__tlds__=y,this.__tlds_replaced__=!1,this.re={},I(this)}return F.prototype.add=function(B,L){return this.__schemas__[B]=L,I(this),this},F.prototype.set=function(B){return this.__opts__=t(this.__opts__,B),this},F.prototype.test=function(B){if(this.__text_cache__=B,this.__index__=-1,!B.length)return!1;var L,z,H,j,J,Z,re,ne,le;if(this.re.schema_test.test(B)){for(re=this.re.schema_search,re.lastIndex=0;(L=re.exec(B))!==null;)if(j=this.testSchemaAt(B,L[2],re.lastIndex),j){this.__schema__=L[2],this.__index__=L.index+L[1].length,this.__last_index__=L.index+L[0].length+j;break}}return this.__opts__.fuzzyLink&&this.__compiled__["http:"]&&(ne=B.search(this.re.host_fuzzy_test),ne>=0&&(this.__index__<0||ne<this.__index__)&&(z=B.match(this.__opts__.fuzzyIP?this.re.link_fuzzy:this.re.link_no_ip_fuzzy))!==null&&(J=z.index+z[1].length,(this.__index__<0||J<this.__index__)&&(this.__schema__="",this.__index__=J,this.__last_index__=z.index+z[0].length))),this.__opts__.fuzzyEmail&&this.__compiled__["mailto:"]&&(le=B.indexOf("@"),le>=0&&(H=B.match(this.re.email_fuzzy))!==null&&(J=H.index+H[1].length,Z=H.index+H[0].length,(this.__index__<0||J<this.__index__||J===this.__index__&&Z>this.__last_index__)&&(this.__schema__="mailto:",this.__index__=J,this.__last_index__=Z))),this.__index__>=0},F.prototype.pretest=function(B){return this.re.pretest.test(B)},F.prototype.testSchemaAt=function(B,L,z){return this.__compiled__[L.toLowerCase()]?this.__compiled__[L.toLowerCase()].validate(B,z,this):0},F.prototype.match=function(B){var L=0,z=[];this.__index__>=0&&this.__text_cache__===B&&(z.push(D(this,L)),L=this.__last_index__);for(var H=L?B.slice(L):B;this.test(H);)z.push(D(this,L)),H=H.slice(this.__last_index__),L+=this.__last_index__;return z.length?z:null},F.prototype.tlds=function(B,L){return B=Array.isArray(B)?B:[B],L?(this.__tlds__=this.__tlds__.concat(B).sort().filter(function(z,H,j){return z!==j[H-1]}).reverse(),I(this),this):(this.__tlds__=B.slice(),this.__tlds_replaced__=!0,I(this),this)},F.prototype.normalize=function(B){B.schema||(B.url="http://"+B.url),B.schema==="mailto:"&&!/^mailto:/i.test(B.url)&&(B.url="mailto:"+B.url)},F.prototype.onCompile=function(){},nme=F,nme}const MGt=JSON.parse('["aaa","aarp","abb","abbott","abbvie","abc","able","abogado","abudhabi","ac","academy","accenture","accountant","accountants","aco","actor","ad","ads","adult","ae","aeg","aero","aetna","af","afl","africa","ag","agakhan","agency","ai","aig","airbus","airforce","airtel","akdn","al","alibaba","alipay","allfinanz","allstate","ally","alsace","alstom","am","amazon","americanexpress","americanfamily","amex","amfam","amica","amsterdam","analytics","android","anquan","anz","ao","aol","apartments","app","apple","aq","aquarelle","ar","arab","aramco","archi","army","arpa","art","arte","as","asda","asia","associates","at","athleta","attorney","au","auction","audi","audible","audio","auspost","author","auto","autos","aw","aws","ax","axa","az","azure","ba","baby","baidu","banamex","band","bank","bar","barcelona","barclaycard","barclays","barefoot","bargains","baseball","basketball","bauhaus","bayern","bb","bbc","bbt","bbva","bcg","bcn","bd","be","beats","beauty","beer","berlin","best","bestbuy","bet","bf","bg","bh","bharti","bi","bible","bid","bike","bing","bingo","bio","biz","bj","black","blackfriday","blockbuster","blog","bloomberg","blue","bm","bms","bmw","bn","bnpparibas","bo","boats","boehringer","bofa","bom","bond","boo","book","booking","bosch","bostik","boston","bot","boutique","box","br","bradesco","bridgestone","broadway","broker","brother","brussels","bs","bt","build","builders","business","buy","buzz","bv","bw","by","bz","bzh","ca","cab","cafe","cal","call","calvinklein","cam","camera","camp","canon","capetown","capital","capitalone","car","caravan","cards","care","career","careers","cars","casa","case","cash","casino","cat","catering","catholic","cba","cbn","cbre","cc","cd","center","ceo","cern","cf","cfa","cfd","cg","ch","chanel","channel","charity","chase","chat","cheap","chintai","christmas","chrome","church","ci","cipriani","circle","cisco","citadel","citi","citic","city","ck","cl","claims","cleaning","click","clinic","clinique","clothing","cloud","club","clubmed","cm","cn","co","coach","codes","coffee","college","cologne","com","commbank","community","company","compare","computer","comsec","condos","construction","consulting","contact","contractors","cooking","cool","coop","corsica","country","coupon","coupons","courses","cpa","cr","credit","creditcard","creditunion","cricket","crown","crs","cruise","cruises","cu","cuisinella","cv","cw","cx","cy","cymru","cyou","cz","dad","dance","data","date","dating","datsun","day","dclk","dds","de","deal","dealer","deals","degree","delivery","dell","deloitte","delta","democrat","dental","dentist","desi","design","dev","dhl","diamonds","diet","digital","direct","directory","discount","discover","dish","diy","dj","dk","dm","dnp","do","docs","doctor","dog","domains","dot","download","drive","dtv","dubai","dunlop","dupont","durban","dvag","dvr","dz","earth","eat","ec","eco","edeka","edu","education","ee","eg","email","emerck","energy","engineer","engineering","enterprises","epson","equipment","er","ericsson","erni","es","esq","estate","et","eu","eurovision","eus","events","exchange","expert","exposed","express","extraspace","fage","fail","fairwinds","faith","family","fan","fans","farm","farmers","fashion","fast","fedex","feedback","ferrari","ferrero","fi","fidelity","fido","film","final","finance","financial","fire","firestone","firmdale","fish","fishing","fit","fitness","fj","fk","flickr","flights","flir","florist","flowers","fly","fm","fo","foo","food","football","ford","forex","forsale","forum","foundation","fox","fr","free","fresenius","frl","frogans","frontier","ftr","fujitsu","fun","fund","furniture","futbol","fyi","ga","gal","gallery","gallo","gallup","game","games","gap","garden","gay","gb","gbiz","gd","gdn","ge","gea","gent","genting","george","gf","gg","ggee","gh","gi","gift","gifts","gives","giving","gl","glass","gle","global","globo","gm","gmail","gmbh","gmo","gmx","gn","godaddy","gold","goldpoint","golf","goo","goodyear","goog","google","gop","got","gov","gp","gq","gr","grainger","graphics","gratis","green","gripe","grocery","group","gs","gt","gu","gucci","guge","guide","guitars","guru","gw","gy","hair","hamburg","hangout","haus","hbo","hdfc","hdfcbank","health","healthcare","help","helsinki","here","hermes","hiphop","hisamitsu","hitachi","hiv","hk","hkt","hm","hn","hockey","holdings","holiday","homedepot","homegoods","homes","homesense","honda","horse","hospital","host","hosting","hot","hotels","hotmail","house","how","hr","hsbc","ht","hu","hughes","hyatt","hyundai","ibm","icbc","ice","icu","id","ie","ieee","ifm","ikano","il","im","imamat","imdb","immo","immobilien","in","inc","industries","infiniti","info","ing","ink","institute","insurance","insure","int","international","intuit","investments","io","ipiranga","iq","ir","irish","is","ismaili","ist","istanbul","it","itau","itv","jaguar","java","jcb","je","jeep","jetzt","jewelry","jio","jll","jm","jmp","jnj","jo","jobs","joburg","jot","joy","jp","jpmorgan","jprs","juegos","juniper","kaufen","kddi","ke","kerryhotels","kerryproperties","kfh","kg","kh","ki","kia","kids","kim","kindle","kitchen","kiwi","km","kn","koeln","komatsu","kosher","kp","kpmg","kpn","kr","krd","kred","kuokgroup","kw","ky","kyoto","kz","la","lacaixa","lamborghini","lamer","land","landrover","lanxess","lasalle","lat","latino","latrobe","law","lawyer","lb","lc","lds","lease","leclerc","lefrak","legal","lego","lexus","lgbt","li","lidl","life","lifeinsurance","lifestyle","lighting","like","lilly","limited","limo","lincoln","link","live","living","lk","llc","llp","loan","loans","locker","locus","lol","london","lotte","lotto","love","lpl","lplfinancial","lr","ls","lt","ltd","ltda","lu","lundbeck","luxe","luxury","lv","ly","ma","madrid","maif","maison","makeup","man","management","mango","map","market","marketing","markets","marriott","marshalls","mattel","mba","mc","mckinsey","md","me","med","media","meet","melbourne","meme","memorial","men","menu","merckmsd","mg","mh","miami","microsoft","mil","mini","mint","mit","mitsubishi","mk","ml","mlb","mls","mm","mma","mn","mo","mobi","mobile","moda","moe","moi","mom","monash","money","monster","mormon","mortgage","moscow","moto","motorcycles","mov","movie","mp","mq","mr","ms","msd","mt","mtn","mtr","mu","museum","music","mv","mw","mx","my","mz","na","nab","nagoya","name","navy","nba","nc","ne","nec","net","netbank","netflix","network","neustar","new","news","next","nextdirect","nexus","nf","nfl","ng","ngo","nhk","ni","nico","nike","nikon","ninja","nissan","nissay","nl","no","nokia","norton","now","nowruz","nowtv","np","nr","nra","nrw","ntt","nu","nyc","nz","obi","observer","office","okinawa","olayan","olayangroup","ollo","om","omega","one","ong","onl","online","ooo","open","oracle","orange","org","organic","origins","osaka","otsuka","ott","ovh","pa","page","panasonic","paris","pars","partners","parts","party","pay","pccw","pe","pet","pf","pfizer","pg","ph","pharmacy","phd","philips","phone","photo","photography","photos","physio","pics","pictet","pictures","pid","pin","ping","pink","pioneer","pizza","pk","pl","place","play","playstation","plumbing","plus","pm","pn","pnc","pohl","poker","politie","porn","post","pr","pramerica","praxi","press","prime","pro","prod","productions","prof","progressive","promo","properties","property","protection","pru","prudential","ps","pt","pub","pw","pwc","py","qa","qpon","quebec","quest","racing","radio","re","read","realestate","realtor","realty","recipes","red","redstone","redumbrella","rehab","reise","reisen","reit","reliance","ren","rent","rentals","repair","report","republican","rest","restaurant","review","reviews","rexroth","rich","richardli","ricoh","ril","rio","rip","ro","rocks","rodeo","rogers","room","rs","rsvp","ru","rugby","ruhr","run","rw","rwe","ryukyu","sa","saarland","safe","safety","sakura","sale","salon","samsclub","samsung","sandvik","sandvikcoromant","sanofi","sap","sarl","sas","save","saxo","sb","sbi","sbs","sc","scb","schaeffler","schmidt","scholarships","school","schule","schwarz","science","scot","sd","se","search","seat","secure","security","seek","select","sener","services","seven","sew","sex","sexy","sfr","sg","sh","shangrila","sharp","shell","shia","shiksha","shoes","shop","shopping","shouji","show","si","silk","sina","singles","site","sj","sk","ski","skin","sky","skype","sl","sling","sm","smart","smile","sn","sncf","so","soccer","social","softbank","software","sohu","solar","solutions","song","sony","soy","spa","space","sport","spot","sr","srl","ss","st","stada","staples","star","statebank","statefarm","stc","stcgroup","stockholm","storage","store","stream","studio","study","style","su","sucks","supplies","supply","support","surf","surgery","suzuki","sv","swatch","swiss","sx","sy","sydney","systems","sz","tab","taipei","talk","taobao","target","tatamotors","tatar","tattoo","tax","taxi","tc","tci","td","tdk","team","tech","technology","tel","temasek","tennis","teva","tf","tg","th","thd","theater","theatre","tiaa","tickets","tienda","tips","tires","tirol","tj","tjmaxx","tjx","tk","tkmaxx","tl","tm","tmall","tn","to","today","tokyo","tools","top","toray","toshiba","total","tours","town","toyota","toys","tr","trade","trading","training","travel","travelers","travelersinsurance","trust","trv","tt","tube","tui","tunes","tushu","tv","tvs","tw","tz","ua","ubank","ubs","ug","uk","unicom","university","uno","uol","ups","us","uy","uz","va","vacations","vana","vanguard","vc","ve","vegas","ventures","verisign","vermögensberater","vermögensberatung","versicherung","vet","vg","vi","viajes","video","vig","viking","villas","vin","vip","virgin","visa","vision","viva","vivo","vlaanderen","vn","vodka","volvo","vote","voting","voto","voyage","vu","wales","walmart","walter","wang","wanggou","watch","watches","weather","weatherchannel","webcam","weber","website","wed","wedding","weibo","weir","wf","whoswho","wien","wiki","williamhill","win","windows","wine","winners","wme","wolterskluwer","woodside","work","works","world","wow","ws","wtc","wtf","xbox","xerox","xihuan","xin","xxx","xyz","yachts","yahoo","yamaxun","yandex","ye","yodobashi","yoga","yokohama","you","youtube","yt","yun","za","zappos","zara","zero","zip","zm","zone","zuerich","zw","ελ","ευ","бг","бел","дети","ею","католик","ком","мкд","мон","москва","онлайн","орг","рус","рф","сайт","срб","укр","қаз","հայ","ישראל","קום","ابوظبي","ارامكو","الاردن","البحرين","الجزائر","السعودية","العليان","المغرب","امارات","ایران","بارت","بازار","بيتك","بھارت","تونس","سودان","سورية","شبكة","عراق","عرب","عمان","فلسطين","قطر","كاثوليك","كوم","مصر","مليسيا","موريتانيا","موقع","همراه","پاکستان","ڀارت","कॉम","नेट","भारत","भारतम्","भारोत","संगठन","বাংলা","ভারত","ভাৰত","ਭਾਰਤ","ભારત","ଭାରତ","இந்தியா","இலங்கை","சிங்கப்பூர்","భారత్","ಭಾರತ","ഭാരതം","ලංකා","คอม","ไทย","ລາວ","გე","みんな","アマゾン","クラウド","グーグル","コム","ストア","セール","ファッション","ポイント","世界","中信","中国","中國","中文网","亚马逊","企业","佛山","信息","健康","八卦","公司","公益","台湾","台灣","商城","商店","商标","嘉里","嘉里大酒店","在线","大拿","天主教","娱乐","家電","广东","微博","慈善","我爱你","手机","招聘","政务","政府","新加坡","新闻","时尚","書籍","机构","淡马锡","游戏","澳門","点看","移动","组织机构","网址","网店","网站","网络","联通","谷歌","购物","通販","集团","電訊盈科","飞利浦","食品","餐厅","香格里拉","香港","닷넷","닷컴","삼성","한국"]');var Yze;function PGt(){if(Yze)return $Z;Yze=1,Object.defineProperty($Z,"__esModule",{value:!0});var t=RGt(),e=o(t),i=MGt,r=o(i);function o(d){return d&&d.__esModule?d:{default:d}}var l=new e.default;return l.tlds(r.default),$Z.default=function(d){return l.match(d)},$Z}var HZ={},Qze;function DGt(){return Qze||(Qze=1,Object.defineProperty(HZ,"__esModule",{value:!0}),HZ.default=function(t){return t}),HZ}var Zze;function LGt(){if(Zze)return UZ;Zze=1,Object.defineProperty(UZ,"__esModule",{value:!0});var t=function(){function D(F,x){for(var B=0;B<x.length;B++){var L=x[B];L.enumerable=L.enumerable||!1,L.configurable=!0,"value"in L&&(L.writable=!0),Object.defineProperty(F,L.key,L)}}return function(F,x,B){return x&&D(F.prototype,x),B&&D(F,B),F}}(),e=fM(),i=T(e),r=CGt(),o=y(r),l=_Gt(),d=y(l),h=PGt(),p=y(h),g=DGt(),f=y(g);function y(D){return D&&D.__esModule?D:{default:D}}function T(D){if(D&&D.__esModule)return D;var F={};if(D!=null)for(var x in D)Object.prototype.hasOwnProperty.call(D,x)&&(F[x]=D[x]);return F.default=D,F}function C(D,F){if(!(D instanceof F))throw new TypeError("Cannot call a class as a function")}function E(D,F){if(!D)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return F&&(typeof F=="object"||typeof F=="function")?F:D}function I(D,F){if(typeof F!="function"&&F!==null)throw new TypeError("Super expression must either be null or a function, not "+typeof F);D.prototype=Object.create(F&&F.prototype,{constructor:{value:D,enumerable:!1,writable:!0,configurable:!0}}),F&&(Object.setPrototypeOf?Object.setPrototypeOf(D,F):D.__proto__=F)}var w=function(D){I(F,D);function F(){return C(this,F),E(this,(F.__proto__||Object.getPrototypeOf(F)).apply(this,arguments))}return t(F,[{key:"parseString",value:function(B){var L=this;if(B==="")return B;var z=this.props.matchDecorator(B);if(!z)return B;var H=[],j=0;return z.forEach(function(J,Z){J.index>j&&H.push(B.substring(j,J.index));var re=L.props.hrefDecorator(J.url),ne=L.props.textDecorator(J.text),le=L.props.componentDecorator(re,ne,Z);H.push(le),j=J.lastIndex}),B.length>j&&H.push(B.substring(j)),H.length===1?H[0]:H}},{key:"parse",value:function(B){var L=this,z=arguments.length>1&&arguments[1]!==void 0?arguments[1]:0;return typeof B=="string"?this.parseString(B):i.isValidElement(B)&&B.type!=="a"&&B.type!=="button"?i.cloneElement(B,{key:z},this.parse(B.props.children)):Array.isArray(B)?B.map(function(H,j){return L.parse(H,j)}):B}},{key:"render",value:function(){return i.createElement(i.Fragment,null,this.parse(this.props.children))}}]),F}(i.Component);return w.defaultProps={componentDecorator:o.default,hrefDecorator:d.default,matchDecorator:p.default,textDecorator:f.default},UZ.default=w,UZ}var Xze;function OGt(){if(Xze)return FZ;Xze=1,Object.defineProperty(FZ,"__esModule",{value:!0});var t=LGt(),e=i(t);function i(r){return r&&r.__esModule?r:{default:r}}return FZ.default=e.default,FZ}var NGt=OGt();const xGt=cL(NGt);/*! @license DOMPurify 3.2.5 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.2.5/LICENSE */const{entries:eVe,setPrototypeOf:tVe,isFrozen:BGt,getPrototypeOf:FGt,getOwnPropertyDescriptor:UGt}=Object;let{freeze:sb,seal:KE,create:iVe}=Object,{apply:ame,construct:rme}=typeof Reflect<"u"&&Reflect;sb||(sb=function(e){return e}),KE||(KE=function(e){return e}),ame||(ame=function(e,i,r){return e.apply(i,r)}),rme||(rme=function(e,i){return new e(...i)});const jZ=cb(Array.prototype.forEach),zGt=cb(Array.prototype.lastIndexOf),nVe=cb(Array.prototype.pop),P8=cb(Array.prototype.push),VGt=cb(Array.prototype.splice),GZ=cb(String.prototype.toLowerCase),ome=cb(String.prototype.toString),aVe=cb(String.prototype.match),D8=cb(String.prototype.replace),$Gt=cb(String.prototype.indexOf),HGt=cb(String.prototype.trim),WA=cb(Object.prototype.hasOwnProperty),lb=cb(RegExp.prototype.test),L8=jGt(TypeError);function cb(t){return function(e){e instanceof RegExp&&(e.lastIndex=0);for(var i=arguments.length,r=new Array(i>1?i-1:0),o=1;o<i;o++)r[o-1]=arguments[o];return ame(t,e,r)}}function jGt(t){return function(){for(var e=arguments.length,i=new Array(e),r=0;r<e;r++)i[r]=arguments[r];return rme(t,i)}}function Jl(t,e){let i=arguments.length>2&&arguments[2]!==void 0?arguments[2]:GZ;tVe&&tVe(t,null);let r=e.length;for(;r--;){let o=e[r];if(typeof o=="string"){const l=i(o);l!==o&&(BGt(e)||(e[r]=l),o=l)}t[o]=!0}return t}function GGt(t){for(let e=0;e<t.length;e++)WA(t,e)||(t[e]=null);return t}function oF(t){const e=iVe(null);for(const[i,r]of eVe(t))WA(t,i)&&(Array.isArray(r)?e[i]=GGt(r):r&&typeof r=="object"&&r.constructor===Object?e[i]=oF(r):e[i]=r);return e}function O8(t,e){for(;t!==null;){const r=UGt(t,e);if(r){if(r.get)return cb(r.get);if(typeof r.value=="function")return cb(r.value)}t=FGt(t)}function i(){return null}return i}const rVe=sb(["a","abbr","acronym","address","area","article","aside","audio","b","bdi","bdo","big","blink","blockquote","body","br","button","canvas","caption","center","cite","code","col","colgroup","content","data","datalist","dd","decorator","del","details","dfn","dialog","dir","div","dl","dt","element","em","fieldset","figcaption","figure","font","footer","form","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","i","img","input","ins","kbd","label","legend","li","main","map","mark","marquee","menu","menuitem","meter","nav","nobr","ol","optgroup","option","output","p","picture","pre","progress","q","rp","rt","ruby","s","samp","section","select","shadow","small","source","spacer","span","strike","strong","style","sub","summary","sup","table","tbody","td","template","textarea","tfoot","th","thead","time","tr","track","tt","u","ul","var","video","wbr"]),sme=sb(["svg","a","altglyph","altglyphdef","altglyphitem","animatecolor","animatemotion","animatetransform","circle","clippath","defs","desc","ellipse","filter","font","g","glyph","glyphref","hkern","image","line","lineargradient","marker","mask","metadata","mpath","path","pattern","polygon","polyline","radialgradient","rect","stop","style","switch","symbol","text","textpath","title","tref","tspan","view","vkern"]),lme=sb(["feBlend","feColorMatrix","feComponentTransfer","feComposite","feConvolveMatrix","feDiffuseLighting","feDisplacementMap","feDistantLight","feDropShadow","feFlood","feFuncA","feFuncB","feFuncG","feFuncR","feGaussianBlur","feImage","feMerge","feMergeNode","feMorphology","feOffset","fePointLight","feSpecularLighting","feSpotLight","feTile","feTurbulence"]),qGt=sb(["animate","color-profile","cursor","discard","font-face","font-face-format","font-face-name","font-face-src","font-face-uri","foreignobject","hatch","hatchpath","mesh","meshgradient","meshpatch","meshrow","missing-glyph","script","set","solidcolor","unknown","use"]),cme=sb(["math","menclose","merror","mfenced","mfrac","mglyph","mi","mlabeledtr","mmultiscripts","mn","mo","mover","mpadded","mphantom","mroot","mrow","ms","mspace","msqrt","mstyle","msub","msup","msubsup","mtable","mtd","mtext","mtr","munder","munderover","mprescripts"]),WGt=sb(["maction","maligngroup","malignmark","mlongdiv","mscarries","mscarry","msgroup","mstack","msline","msrow","semantics","annotation","annotation-xml","mprescripts","none"]),oVe=sb(["#text"]),sVe=sb(["accept","action","align","alt","autocapitalize","autocomplete","autopictureinpicture","autoplay","background","bgcolor","border","capture","cellpadding","cellspacing","checked","cite","class","clear","color","cols","colspan","controls","controlslist","coords","crossorigin","datetime","decoding","default","dir","disabled","disablepictureinpicture","disableremoteplayback","download","draggable","enctype","enterkeyhint","face","for","headers","height","hidden","high","href","hreflang","id","inputmode","integrity","ismap","kind","label","lang","list","loading","loop","low","max","maxlength","media","method","min","minlength","multiple","muted","name","nonce","noshade","novalidate","nowrap","open","optimum","pattern","placeholder","playsinline","popover","popovertarget","popovertargetaction","poster","preload","pubdate","radiogroup","readonly","rel","required","rev","reversed","role","rows","rowspan","spellcheck","scope","selected","shape","size","sizes","span","srclang","start","src","srcset","step","style","summary","tabindex","title","translate","type","usemap","valign","value","width","wrap","xmlns","slot"]),dme=sb(["accent-height","accumulate","additive","alignment-baseline","amplitude","ascent","attributename","attributetype","azimuth","basefrequency","baseline-shift","begin","bias","by","class","clip","clippathunits","clip-path","clip-rule","color","color-interpolation","color-interpolation-filters","color-profile","color-rendering","cx","cy","d","dx","dy","diffuseconstant","direction","display","divisor","dur","edgemode","elevation","end","exponent","fill","fill-opacity","fill-rule","filter","filterunits","flood-color","flood-opacity","font-family","font-size","font-size-adjust","font-stretch","font-style","font-variant","font-weight","fx","fy","g1","g2","glyph-name","glyphref","gradientunits","gradienttransform","height","href","id","image-rendering","in","in2","intercept","k","k1","k2","k3","k4","kerning","keypoints","keysplines","keytimes","lang","lengthadjust","letter-spacing","kernelmatrix","kernelunitlength","lighting-color","local","marker-end","marker-mid","marker-start","markerheight","markerunits","markerwidth","maskcontentunits","maskunits","max","mask","media","method","mode","min","name","numoctaves","offset","operator","opacity","order","orient","orientation","origin","overflow","paint-order","path","pathlength","patterncontentunits","patterntransform","patternunits","points","preservealpha","preserveaspectratio","primitiveunits","r","rx","ry","radius","refx","refy","repeatcount","repeatdur","restart","result","rotate","scale","seed","shape-rendering","slope","specularconstant","specularexponent","spreadmethod","startoffset","stddeviation","stitchtiles","stop-color","stop-opacity","stroke-dasharray","stroke-dashoffset","stroke-linecap","stroke-linejoin","stroke-miterlimit","stroke-opacity","stroke","stroke-width","style","surfacescale","systemlanguage","tabindex","tablevalues","targetx","targety","transform","transform-origin","text-anchor","text-decoration","text-rendering","textlength","type","u1","u2","unicode","values","viewbox","visibility","version","vert-adv-y","vert-origin-x","vert-origin-y","width","word-spacing","wrap","writing-mode","xchannelselector","ychannelselector","x","x1","x2","xmlns","y","y1","y2","z","zoomandpan"]),lVe=sb(["accent","accentunder","align","bevelled","close","columnsalign","columnlines","columnspan","denomalign","depth","dir","display","displaystyle","encoding","fence","frame","height","href","id","largeop","length","linethickness","lspace","lquote","mathbackground","mathcolor","mathsize","mathvariant","maxsize","minsize","movablelimits","notation","numalign","open","rowalign","rowlines","rowspacing","rowspan","rspace","rquote","scriptlevel","scriptminsize","scriptsizemultiplier","selection","separator","separators","stretchy","subscriptshift","supscriptshift","symmetric","voffset","width","xmlns"]),qZ=sb(["xlink:href","xml:id","xlink:title","xml:space","xmlns:xlink"]),KGt=KE(/\{\{[\w\W]*|[\w\W]*\}\}/gm),JGt=KE(/<%[\w\W]*|[\w\W]*%>/gm),YGt=KE(/\$\{[\w\W]*/gm),QGt=KE(/^data-[\-\w.\u00B7-\uFFFF]+$/),ZGt=KE(/^aria-[\-\w]+$/),cVe=KE(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i),XGt=KE(/^(?:\w+script|data):/i),e9t=KE(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g),dVe=KE(/^html$/i),t9t=KE(/^[a-z][.\w]*(-[.\w]+)+$/i);var uVe=Object.freeze({__proto__:null,ARIA_ATTR:ZGt,ATTR_WHITESPACE:e9t,CUSTOM_ELEMENT:t9t,DATA_ATTR:QGt,DOCTYPE_NAME:dVe,ERB_EXPR:JGt,IS_ALLOWED_URI:cVe,IS_SCRIPT_OR_DATA:XGt,MUSTACHE_EXPR:KGt,TMPLIT_EXPR:YGt});const N8={element:1,text:3,progressingInstruction:7,comment:8,document:9},i9t=function(){return typeof window>"u"?null:window},n9t=function(e,i){if(typeof e!="object"||typeof e.createPolicy!="function")return null;let r=null;const o="data-tt-policy-suffix";i&&i.hasAttribute(o)&&(r=i.getAttribute(o));const l="dompurify"+(r?"#"+r:"");try{return e.createPolicy(l,{createHTML(d){return d},createScriptURL(d){return d}})}catch{return console.warn("TrustedTypes policy "+l+" could not be created."),null}},hVe=function(){return{afterSanitizeAttributes:[],afterSanitizeElements:[],afterSanitizeShadowDOM:[],beforeSanitizeAttributes:[],beforeSanitizeElements:[],beforeSanitizeShadowDOM:[],uponSanitizeAttribute:[],uponSanitizeElement:[],uponSanitizeShadowNode:[]}};function pVe(){let t=arguments.length>0&&arguments[0]!==void 0?arguments[0]:i9t();const e=aa=>pVe(aa);if(e.version="3.2.5",e.removed=[],!t||!t.document||t.document.nodeType!==N8.document||!t.Element)return e.isSupported=!1,e;let{document:i}=t;const r=i,o=r.currentScript,{DocumentFragment:l,HTMLTemplateElement:d,Node:h,Element:p,NodeFilter:g,NamedNodeMap:f=t.NamedNodeMap||t.MozNamedAttrMap,HTMLFormElement:y,DOMParser:T,trustedTypes:C}=t,E=p.prototype,I=O8(E,"cloneNode"),w=O8(E,"remove"),D=O8(E,"nextSibling"),F=O8(E,"childNodes"),x=O8(E,"parentNode");if(typeof d=="function"){const aa=i.createElement("template");aa.content&&aa.content.ownerDocument&&(i=aa.content.ownerDocument)}let B,L="";const{implementation:z,createNodeIterator:H,createDocumentFragment:j,getElementsByTagName:J}=i,{importNode:Z}=r;let re=hVe();e.isSupported=typeof eVe=="function"&&typeof x=="function"&&z&&z.createHTMLDocument!==void 0;const{MUSTACHE_EXPR:ne,ERB_EXPR:le,TMPLIT_EXPR:he,DATA_ATTR:Me,ARIA_ATTR:Le,IS_SCRIPT_OR_DATA:pe,ATTR_WHITESPACE:te,CUSTOM_ELEMENT:Se}=uVe;let{IS_ALLOWED_URI:ce}=uVe,X=null;const ve=Jl({},[...rVe,...sme,...lme,...cme,...oVe]);let Te=null;const Be=Jl({},[...sVe,...dme,...lVe,...qZ]);let qe=Object.seal(iVe(null,{tagNameCheck:{writable:!0,configurable:!1,enumerable:!0,value:null},attributeNameCheck:{writable:!0,configurable:!1,enumerable:!0,value:null},allowCustomizedBuiltInElements:{writable:!0,configurable:!1,enumerable:!0,value:!1}})),Ge=null,tt=null,ct=!0,Mt=!0,ht=!1,vt=!0,Pt=!1,ni=!0,Zt=!1,it=!1,Ke=!1,ot=!1,Ht=!1,jt=!1,Nt=!0,Vt=!1;const $t="user-content-";let dt=!0,yt=!1,kt={},je=null;const Ae=Jl({},["annotation-xml","audio","colgroup","desc","foreignobject","head","iframe","math","mi","mn","mo","ms","mtext","noembed","noframes","noscript","plaintext","script","style","svg","template","thead","title","video","xmp"]);let xe=null;const gt=Jl({},["audio","video","img","source","image","track"]);let Ye=null;const Fe=Jl({},["alt","class","for","id","label","name","pattern","placeholder","role","summary","title","value","style","xmlns"]),St="http://www.w3.org/1998/Math/MathML",Wt="http://www.w3.org/2000/svg",Ii="http://www.w3.org/1999/xhtml";let en=Ii,sn=!1,Qi=null;const qt=Jl({},[St,Wt,Ii],ome);let ri=Jl({},["mi","mo","mn","ms","mtext"]),Ti=Jl({},["annotation-xml"]);const rn=Jl({},["title","style","font","a","script"]);let Hn=null;const ha=["application/xhtml+xml","text/html"],hr="text/html";let yn=null,pr=null;const Ho=i.createElement("form"),Rr=function(ti){return ti instanceof RegExp||ti instanceof Function},La=function(){let ti=arguments.length>0&&arguments[0]!==void 0?arguments[0]:{};if(!(pr&&pr===ti)){if((!ti||typeof ti!="object")&&(ti={}),ti=oF(ti),Hn=ha.indexOf(ti.PARSER_MEDIA_TYPE)===-1?hr:ti.PARSER_MEDIA_TYPE,yn=Hn==="application/xhtml+xml"?ome:GZ,X=WA(ti,"ALLOWED_TAGS")?Jl({},ti.ALLOWED_TAGS,yn):ve,Te=WA(ti,"ALLOWED_ATTR")?Jl({},ti.ALLOWED_ATTR,yn):Be,Qi=WA(ti,"ALLOWED_NAMESPACES")?Jl({},ti.ALLOWED_NAMESPACES,ome):qt,Ye=WA(ti,"ADD_URI_SAFE_ATTR")?Jl(oF(Fe),ti.ADD_URI_SAFE_ATTR,yn):Fe,xe=WA(ti,"ADD_DATA_URI_TAGS")?Jl(oF(gt),ti.ADD_DATA_URI_TAGS,yn):gt,je=WA(ti,"FORBID_CONTENTS")?Jl({},ti.FORBID_CONTENTS,yn):Ae,Ge=WA(ti,"FORBID_TAGS")?Jl({},ti.FORBID_TAGS,yn):{},tt=WA(ti,"FORBID_ATTR")?Jl({},ti.FORBID_ATTR,yn):{},kt=WA(ti,"USE_PROFILES")?ti.USE_PROFILES:!1,ct=ti.ALLOW_ARIA_ATTR!==!1,Mt=ti.ALLOW_DATA_ATTR!==!1,ht=ti.ALLOW_UNKNOWN_PROTOCOLS||!1,vt=ti.ALLOW_SELF_CLOSE_IN_ATTR!==!1,Pt=ti.SAFE_FOR_TEMPLATES||!1,ni=ti.SAFE_FOR_XML!==!1,Zt=ti.WHOLE_DOCUMENT||!1,ot=ti.RETURN_DOM||!1,Ht=ti.RETURN_DOM_FRAGMENT||!1,jt=ti.RETURN_TRUSTED_TYPE||!1,Ke=ti.FORCE_BODY||!1,Nt=ti.SANITIZE_DOM!==!1,Vt=ti.SANITIZE_NAMED_PROPS||!1,dt=ti.KEEP_CONTENT!==!1,yt=ti.IN_PLACE||!1,ce=ti.ALLOWED_URI_REGEXP||cVe,en=ti.NAMESPACE||Ii,ri=ti.MATHML_TEXT_INTEGRATION_POINTS||ri,Ti=ti.HTML_INTEGRATION_POINTS||Ti,qe=ti.CUSTOM_ELEMENT_HANDLING||{},ti.CUSTOM_ELEMENT_HANDLING&&Rr(ti.CUSTOM_ELEMENT_HANDLING.tagNameCheck)&&(qe.tagNameCheck=ti.CUSTOM_ELEMENT_HANDLING.tagNameCheck),ti.CUSTOM_ELEMENT_HANDLING&&Rr(ti.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)&&(qe.attributeNameCheck=ti.CUSTOM_ELEMENT_HANDLING.attributeNameCheck),ti.CUSTOM_ELEMENT_HANDLING&&typeof ti.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements=="boolean"&&(qe.allowCustomizedBuiltInElements=ti.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements),Pt&&(Mt=!1),Ht&&(ot=!0),kt&&(X=Jl({},oVe),Te=[],kt.html===!0&&(Jl(X,rVe),Jl(Te,sVe)),kt.svg===!0&&(Jl(X,sme),Jl(Te,dme),Jl(Te,qZ)),kt.svgFilters===!0&&(Jl(X,lme),Jl(Te,dme),Jl(Te,qZ)),kt.mathMl===!0&&(Jl(X,cme),Jl(Te,lVe),Jl(Te,qZ))),ti.ADD_TAGS&&(X===ve&&(X=oF(X)),Jl(X,ti.ADD_TAGS,yn)),ti.ADD_ATTR&&(Te===Be&&(Te=oF(Te)),Jl(Te,ti.ADD_ATTR,yn)),ti.ADD_URI_SAFE_ATTR&&Jl(Ye,ti.ADD_URI_SAFE_ATTR,yn),ti.FORBID_CONTENTS&&(je===Ae&&(je=oF(je)),Jl(je,ti.FORBID_CONTENTS,yn)),dt&&(X["#text"]=!0),Zt&&Jl(X,["html","head","body"]),X.table&&(Jl(X,["tbody"]),delete Ge.tbody),ti.TRUSTED_TYPES_POLICY){if(typeof ti.TRUSTED_TYPES_POLICY.createHTML!="function")throw L8('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');if(typeof ti.TRUSTED_TYPES_POLICY.createScriptURL!="function")throw L8('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');B=ti.TRUSTED_TYPES_POLICY,L=B.createHTML("")}else B===void 0&&(B=n9t(C,o)),B!==null&&typeof L=="string"&&(L=B.createHTML(""));sb&&sb(ti),pr=ti}},us=Jl({},[...sme,...lme,...qGt]),al=Jl({},[...cme,...WGt]),Us=function(ti){let on=x(ti);(!on||!on.tagName)&&(on={namespaceURI:en,tagName:"template"});const Fn=GZ(ti.tagName),Or=GZ(on.tagName);return Qi[ti.namespaceURI]?ti.namespaceURI===Wt?on.namespaceURI===Ii?Fn==="svg":on.namespaceURI===St?Fn==="svg"&&(Or==="annotation-xml"||ri[Or]):!!us[Fn]:ti.namespaceURI===St?on.namespaceURI===Ii?Fn==="math":on.namespaceURI===Wt?Fn==="math"&&Ti[Or]:!!al[Fn]:ti.namespaceURI===Ii?on.namespaceURI===Wt&&!Ti[Or]||on.namespaceURI===St&&!ri[Or]?!1:!al[Fn]&&(rn[Fn]||!us[Fn]):!!(Hn==="application/xhtml+xml"&&Qi[ti.namespaceURI]):!1},$r=function(ti){P8(e.removed,{element:ti});try{x(ti).removeChild(ti)}catch{w(ti)}},Zd=function(ti,on){try{P8(e.removed,{attribute:on.getAttributeNode(ti),from:on})}catch{P8(e.removed,{attribute:null,from:on})}if(on.removeAttribute(ti),ti==="is")if(ot||Ht)try{$r(on)}catch{}else try{on.setAttribute(ti,"")}catch{}},rc=function(ti){let on=null,Fn=null;if(Ke)ti="<remove></remove>"+ti;else{const za=aVe(ti,/^[\r\n\t ]+/);Fn=za&&za[0]}Hn==="application/xhtml+xml"&&en===Ii&&(ti='<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>'+ti+"</body></html>");const Or=B?B.createHTML(ti):ti;if(en===Ii)try{on=new T().parseFromString(Or,Hn)}catch{}if(!on||!on.documentElement){on=z.createDocument(en,"template",null);try{on.documentElement.innerHTML=sn?L:Or}catch{}}const Co=on.body||on.documentElement;return ti&&Fn&&Co.insertBefore(i.createTextNode(Fn),Co.childNodes[0]||null),en===Ii?J.call(on,Zt?"html":"body")[0]:Zt?on.documentElement:Co},Yl=function(ti){return H.call(ti.ownerDocument||ti,ti,g.SHOW_ELEMENT|g.SHOW_COMMENT|g.SHOW_TEXT|g.SHOW_PROCESSING_INSTRUCTION|g.SHOW_CDATA_SECTION,null)},ci=function(ti){return ti instanceof y&&(typeof ti.nodeName!="string"||typeof ti.textContent!="string"||typeof ti.removeChild!="function"||!(ti.attributes instanceof f)||typeof ti.removeAttribute!="function"||typeof ti.setAttribute!="function"||typeof ti.namespaceURI!="string"||typeof ti.insertBefore!="function"||typeof ti.hasChildNodes!="function")},Ai=function(ti){return typeof h=="function"&&ti instanceof h};function pn(aa,ti,on){jZ(aa,Fn=>{Fn.call(e,ti,on,pr)})}const Bn=function(ti){let on=null;if(pn(re.beforeSanitizeElements,ti,null),ci(ti))return $r(ti),!0;const Fn=yn(ti.nodeName);if(pn(re.uponSanitizeElement,ti,{tagName:Fn,allowedTags:X}),ti.hasChildNodes()&&!Ai(ti.firstElementChild)&&lb(/<[/\w!]/g,ti.innerHTML)&&lb(/<[/\w!]/g,ti.textContent)||ti.nodeType===N8.progressingInstruction||ni&&ti.nodeType===N8.comment&&lb(/<[/\w]/g,ti.data))return $r(ti),!0;if(!X[Fn]||Ge[Fn]){if(!Ge[Fn]&&qa(Fn)&&(qe.tagNameCheck instanceof RegExp&&lb(qe.tagNameCheck,Fn)||qe.tagNameCheck instanceof Function&&qe.tagNameCheck(Fn)))return!1;if(dt&&!je[Fn]){const Or=x(ti)||ti.parentNode,Co=F(ti)||ti.childNodes;if(Co&&Or){const za=Co.length;for(let Za=za-1;Za>=0;--Za){const ns=I(Co[Za],!0);ns.__removalCount=(ti.__removalCount||0)+1,Or.insertBefore(ns,D(ti))}}}return $r(ti),!0}return ti instanceof p&&!Us(ti)||(Fn==="noscript"||Fn==="noembed"||Fn==="noframes")&&lb(/<\/no(script|embed|frames)/i,ti.innerHTML)?($r(ti),!0):(Pt&&ti.nodeType===N8.text&&(on=ti.textContent,jZ([ne,le,he],Or=>{on=D8(on,Or," ")}),ti.textContent!==on&&(P8(e.removed,{element:ti.cloneNode()}),ti.textContent=on)),pn(re.afterSanitizeElements,ti,null),!1)},Pa=function(ti,on,Fn){if(Nt&&(on==="id"||on==="name")&&(Fn in i||Fn in Ho))return!1;if(!(Mt&&!tt[on]&&lb(Me,on))){if(!(ct&&lb(Le,on))){if(!Te[on]||tt[on]){if(!(qa(ti)&&(qe.tagNameCheck instanceof RegExp&&lb(qe.tagNameCheck,ti)||qe.tagNameCheck instanceof Function&&qe.tagNameCheck(ti))&&(qe.attributeNameCheck instanceof RegExp&&lb(qe.attributeNameCheck,on)||qe.attributeNameCheck instanceof Function&&qe.attributeNameCheck(on))||on==="is"&&qe.allowCustomizedBuiltInElements&&(qe.tagNameCheck instanceof RegExp&&lb(qe.tagNameCheck,Fn)||qe.tagNameCheck instanceof Function&&qe.tagNameCheck(Fn))))return!1}else if(!Ye[on]){if(!lb(ce,D8(Fn,te,""))){if(!((on==="src"||on==="xlink:href"||on==="href")&&ti!=="script"&&$Gt(Fn,"data:")===0&&xe[ti])){if(!(ht&&!lb(pe,D8(Fn,te,"")))){if(Fn)return!1}}}}}}return!0},qa=function(ti){return ti!=="annotation-xml"&&aVe(ti,Se)},kr=function(ti){pn(re.beforeSanitizeAttributes,ti,null);const{attributes:on}=ti;if(!on||ci(ti))return;const Fn={attrName:"",attrValue:"",keepAttr:!0,allowedAttributes:Te,forceKeepAttr:void 0};let Or=on.length;for(;Or--;){const Co=on[Or],{name:za,namespaceURI:Za,value:ns}=Co,Uu=yn(za);let ml=za==="value"?ns:HGt(ns);if(Fn.attrName=Uu,Fn.attrValue=ml,Fn.keepAttr=!0,Fn.forceKeepAttr=void 0,pn(re.uponSanitizeAttribute,ti,Fn),ml=Fn.attrValue,Vt&&(Uu==="id"||Uu==="name")&&(Zd(za,ti),ml=$t+ml),ni&&lb(/((--!?|])>)|<\/(style|title)/i,ml)){Zd(za,ti);continue}if(Fn.forceKeepAttr||(Zd(za,ti),!Fn.keepAttr))continue;if(!vt&&lb(/\/>/i,ml)){Zd(za,ti);continue}Pt&&jZ([ne,le,he],Xd=>{ml=D8(ml,Xd," ")});const Cu=yn(ti.nodeName);if(Pa(Cu,Uu,ml)){if(B&&typeof C=="object"&&typeof C.getAttributeType=="function"&&!Za)switch(C.getAttributeType(Cu,Uu)){case"TrustedHTML":{ml=B.createHTML(ml);break}case"TrustedScriptURL":{ml=B.createScriptURL(ml);break}}try{Za?ti.setAttributeNS(Za,za,ml):ti.setAttribute(za,ml),ci(ti)?$r(ti):nVe(e.removed)}catch{}}}pn(re.afterSanitizeAttributes,ti,null)},Sa=function aa(ti){let on=null;const Fn=Yl(ti);for(pn(re.beforeSanitizeShadowDOM,ti,null);on=Fn.nextNode();)pn(re.uponSanitizeShadowNode,on,null),Bn(on),kr(on),on.content instanceof l&&aa(on.content);pn(re.afterSanitizeShadowDOM,ti,null)};return e.sanitize=function(aa){let ti=arguments.length>1&&arguments[1]!==void 0?arguments[1]:{},on=null,Fn=null,Or=null,Co=null;if(sn=!aa,sn&&(aa="<!-->"),typeof aa!="string"&&!Ai(aa))if(typeof aa.toString=="function"){if(aa=aa.toString(),typeof aa!="string")throw L8("dirty is not a string, aborting")}else throw L8("toString is not a function");if(!e.isSupported)return aa;if(it||La(ti),e.removed=[],typeof aa=="string"&&(yt=!1),yt){if(aa.nodeName){const ns=yn(aa.nodeName);if(!X[ns]||Ge[ns])throw L8("root node is forbidden and cannot be sanitized in-place")}}else if(aa instanceof h)on=rc("<!---->"),Fn=on.ownerDocument.importNode(aa,!0),Fn.nodeType===N8.element&&Fn.nodeName==="BODY"||Fn.nodeName==="HTML"?on=Fn:on.appendChild(Fn);else{if(!ot&&!Pt&&!Zt&&aa.indexOf("<")===-1)return B&&jt?B.createHTML(aa):aa;if(on=rc(aa),!on)return ot?null:jt?L:""}on&&Ke&&$r(on.firstChild);const za=Yl(yt?aa:on);for(;Or=za.nextNode();)Bn(Or),kr(Or),Or.content instanceof l&&Sa(Or.content);if(yt)return aa;if(ot){if(Ht)for(Co=j.call(on.ownerDocument);on.firstChild;)Co.appendChild(on.firstChild);else Co=on;return(Te.shadowroot||Te.shadowrootmode)&&(Co=Z.call(r,Co,!0)),Co}let Za=Zt?on.outerHTML:on.innerHTML;return Zt&&X["!doctype"]&&on.ownerDocument&&on.ownerDocument.doctype&&on.ownerDocument.doctype.name&&lb(dVe,on.ownerDocument.doctype.name)&&(Za="<!DOCTYPE "+on.ownerDocument.doctype.name+`>
`+Za),Pt&&jZ([ne,le,he],ns=>{Za=D8(Za,ns," ")}),B&&jt?B.createHTML(Za):Za},e.setConfig=function(){let aa=arguments.length>0&&arguments[0]!==void 0?arguments[0]:{};La(aa),it=!0},e.clearConfig=function(){pr=null,it=!1},e.isValidAttribute=function(aa,ti,on){pr||La({});const Fn=yn(aa),Or=yn(ti);return Pa(Fn,Or,on)},e.addHook=function(aa,ti){typeof ti=="function"&&P8(re[aa],ti)},e.removeHook=function(aa,ti){if(ti!==void 0){const on=zGt(re[aa],ti);return on===-1?void 0:VGt(re[aa],on,1)[0]}return nVe(re[aa])},e.removeHooks=function(aa){re[aa]=[]},e.removeAllHooks=function(){re=hVe()},e}var gVe=pVe();const a9t=t=>{switch(t.message.contentType){case"text":return r9t(t);case"html":return fVe(t);case"richtext/html":return fVe(t);default:return console.warn("unknown message content type"),U.createElement(U.Fragment,null)}},mVe=t=>U.createElement("div",{"data-ui-status":t.message.status,role:"text","aria-label":t.ariaLabel,className:t.className},U.createElement($ge,{message:t.liveMessage,ariaLive:"polite"}),t.content),fVe=t=>U.createElement(mVe,{message:t.message,liveMessage:yVe(t),ariaLabel:SVe(t),content:l9t(t)}),r9t=t=>U.createElement(mVe,{message:t.message,liveMessage:yVe(t),ariaLabel:SVe(t),className:L7t,content:U.createElement(xGt,{componentDecorator:(e,i,r)=>U.createElement(uW,{target:"_blank",href:e,key:r},i)},t.message.content)}),vVe=t=>{var e;if(t.message.content||t.message.attachments){const i=gVe.sanitize((e=t.message.content)!==null&&e!==void 0?e:"",{ALLOWED_TAGS:["img"],RETURN_DOM_FRAGMENT:!0});if(i.childNodes.forEach(o=>{if(o.nodeName.toLowerCase()!=="img")return;const l=document.createElement("div");l.innerHTML="image ",i.replaceChild(l,o)}),t.message.attachments&&t.message.attachments.length>0){const o=o9t(t),l=document.createElement("div");l.innerHTML=`${o}`,i.appendChild(l)}let r=gVe.sanitize(i,{ALLOWED_TAGS:[]});return r=c9t(r),r}return""},yVe=t=>{const e=vVe(t);if(t.message.editedOn){const i=Jd(t.strings.editedMessageLiveAuthorIntro,{author:`${t.message.senderDisplayName}`});return`${t.message.mine?t.strings.editedMessageLocalUserLiveAuthorIntro:i} ${e}`}else{const i=Jd(t.strings.liveAuthorIntro,{author:`${t.message.senderDisplayName}`});return`${t.message.mine?"":i} ${e} `}},SVe=t=>{var e,i;const r=vVe(t);return t.message.mine?Jd(t.strings.messageContentMineAriaText,{status:(e=t.message.status)!==null&&e!==void 0?e:"",message:r}):Jd(t.strings.messageContentAriaText,{status:(i=t.message.status)!==null&&i!==void 0?i:"",author:`${t.message.senderDisplayName}`,message:r})},o9t=t=>{const e=t.message.attachments;return s9t(e??[],t.strings.attachmentCardGroupMessage)},s9t=(t,e)=>t.length===0?"":Jd(e,{attachmentCount:`${t.length}`}),bVe=t=>U.createElement("img",Object.assign({key:t.imageAttributes.id,tabIndex:0,"data-ui-id":t.imageAttributes.id},t.imageAttributes)),l9t=t=>{var e;const i={transform(r,o){var l;if(o instanceof Qge.Element&&o.attribs){if(o.name&&o.name==="img"&&o.attribs&&o.attribs.id){o.attribs.name&&(o.attribs["aria-label"]=o.attribs.name);const d=Qge.attributesToProps(o.attribs),h={messageId:t.message.messageId,imageAttributes:d};return!((l=t.inlineImageOptions)===null||l===void 0)&&l.onRenderInlineImage?t.inlineImageOptions.onRenderInlineImage(h,bVe):bVe(h)}if(o.name==="a"&&U.isValidElement(r))return U.cloneElement(r,{target:"_blank",rel:"noreferrer noopener"})}return r}};return U.createElement(U.Fragment,null,TGt((e=t.message.content)!==null&&e!==void 0?e:"",i))},c9t=t=>{const e=/&(nbsp|amp|quot|lt|gt);/g,i={nbsp:" ",amp:"&",quot:'"',lt:"<",gt:">"};return t.replace(e,function(r,o){var l;return(l=i[o])!==null&&l!==void 0?l:r}).replace(/&#(\d+);/gi,function(r,o){const l=parseInt(o,10);return String.fromCharCode(l)})};var ume={accdb:{extensions:["accdb","mdb"]},archive:{extensions:["7z","ace","arc","arj","dmg","gz","iso","lzh","pkg","rar","sit","tgz","tar","z"]},album:{},audio:{extensions:["aif","aiff","aac","alac","amr","ape","au","awb","dct","dss","dvf","flac","gsm","m4a","m4p","mid","mmf","mp3","oga","ra","rm","wav","wma","wv"]},calendar:{extensions:["ical","icalendar","ics","ifb","vcs"]},classifier:{extensions:["classifier"]},clipchamp:{extensions:["clipchamp"]},cliptemplate:{extensions:["cliptemplate"]},code:{extensions:["abap","ada","adp","ahk","as","as3","asc","ascx","asm","asp","awk","bash","bash_login","bash_logout","bash_profile","bashrc","bat","bib","bsh","build","builder","c","cbl","c++","capfile","cc","cfc","cfm","cfml","cl","clj","cls","cmake","cmd","coffee","config","cpp","cpt","cpy","cs","cshtml","cson","csproj","css","ctp","cxx","d","ddl","di","disco","dml","dtd","dtml","el","emakefile","erb","erl","f","f90","f95","fs","fsi","fsscript","fsx","gemfile","gemspec","gitconfig","go","groovy","gvy","h","h++","haml","handlebars","hbs","hcp","hh","hpp","hrl","hs","htc","hxx","idl","iim","inc","inf","ini","inl","ipp","irbrc","jade","jav","java","js","json","jsp","jsproj","jsx","l","less","lhs","lisp","log","lst","ltx","lua","m","mak","make","manifest","master","md","markdn","markdown","mdown","mkdn","ml","mli","mll","mly","mm","mud","nfo","opml","osascript","p","pas","patch","php","php2","php3","php4","php5","phtml","pl","pm","pod","pp","profile","ps1","ps1xml","psd1","psm1","pss","pt","py","pyw","r","rake","rb","rbx","rc","rdf","re","reg","rest","resw","resx","rhtml","rjs","rprofile","rpy","rss","rst","ruby","rxml","s","sass","scala","scm","sconscript","sconstruct","script","scss","sgml","sh","shtml","sml","svn-base","swift","sql","sty","tcl","tex","textile","tld","tli","tmpl","tpl","vb","vi","vim","vmg","webpart","wsp","wsdl","xhtml","xoml","xsd","xslt","yaml","yaws","yml","zsh"]},contact:{extensions:["vcf"]},copilot:{extensions:["copilot"]},csv:{extensions:["csv"]},designer:{extensions:["design"]},desktopfolder:{},docset:{},documentsfolder:{},docx:{extensions:["doc","docm","docx","docb"]},dotx:{extensions:["dot","dotm","dotx"]},email:{extensions:["eml","msg","oft","ost","pst"]},exe:{extensions:["application","appref-ms","apk","app","appx","exe","ipa","msi","xap"]},favoritesfolder:{},folder:{},font:{extensions:["ttf","otf","woff"]},form:{},genericfile:{},html:{extensions:["htm","html","mht","mhtml"]},ipynb:{extensions:["nnb","ipynb"]},link:{extensions:["lnk","link","url","website","webloc"]},linkedfolder:{},listform:{},listitem:{},loop:{extensions:["fluid","loop","note"]},loopworkspace:{},officescript:{extensions:["osts"]},splist:{},mcworld:{extensions:["mcworld"]},mctemplate:{extensions:["mctemplate"]},model:{extensions:["3ds","3mf","blend","cool","dae","df","dwfx","dwg","dxf","fbx","glb","gltf","holo","layer","layout","max","mtl","obj","off","ply","skp","stp","stl","t","thl","x"]},mpp:{extensions:["mpp"]},mpt:{extensions:["mpt"]},multiple:{},one:{extensions:["one","onepart"]},onetoc:{extensions:["ms-one-stub","onetoc","onetoc2","onepkg"]},pbiapp:{},pdf:{extensions:["pdf"]},photo:{extensions:["arw","bmp","cr2","crw","dic","dicm","dcm","dcm30","dcr","dds","dib","dng","erf","gif","heic","heif","ico","jfi","jfif","jif","jpe","jpeg","jpg","jxr","kdc","mrw","nef","orf","pct","pict","png","pns","psb","psd","raw","tga","tif","tiff","wdp"]},photo360:{},picturesfolder:{},planner:{},portfolio:{},potx:{extensions:["pot","potm","potx"]},powerbi:{extensions:["pbids","pbix"]},ppsx:{extensions:["pps","ppsm","ppsx"]},pptx:{extensions:["ppt","pptm","pptx","sldx","sldm"]},presentation:{extensions:["odp","gslides","key"]},pub:{extensions:["pub"]},spo:{extensions:["aspx"]},sponews:{},spreadsheet:{extensions:["odc","ods","gsheet","numbers","tsv"]},rtf:{extensions:["epub","gdoc","odt","rtf","wri","pages"]},sharedfolder:{},playlist:{},sway:{},sysfile:{extensions:["bak","bin","cab","cache","cat","cer","class","dat","db","dbg","dl_","dll","ithmb","jar","kb","ldt","lrprev","pkpass","ppa","ppam","pdb","rom","thm","thmx","vsl","xla","xlam","xlb","xll"]},todoitem:{},txt:{extensions:["dif","diff","readme","out","plist","properties","text","txt"]},vaultclosed:{},vaultopen:{},vector:{extensions:["ai","ait","cvs","dgn","gdraw","pd","emf","eps","fig","ind","indd","indl","indt","indb","ps","svg","svgz","wmf","oxps","xps","xd","sketch"]},video:{extensions:["3g2","3gp","3gp2","3gpp","asf","avi","dvr-ms","flv","m1v","m4v","mkv","mod","mov","mm4p","mp2","mp2v","mp4","mp4v","mpa","mpe","mpeg","mpg","mpv","mpv2","mts","ogg","qt","swf","ts","vob","webm","wlmp","wm","wmv","wmx"]},video360:{},vsdx:{extensions:["vdx","vsd","vsdm","vsdx","vsw","vdw"]},vssx:{extensions:["vss","vssm","vssx"]},vstx:{extensions:["vst","vstm","vstx","vsx"]},whiteboard:{extensions:["whiteboard","wbtx"]},xlsx:{extensions:["xlc","xls","xlsb","xlsm","xlsx","xlw"]},xltx:{extensions:["xlt","xltm","xltx"]},xml:{extensions:["xaml","xml","xsl"]},xsn:{extensions:["xsn"]},zip:{extensions:["zip"]}},Kh;(function(t){t[t.docset=1]="docset",t[t.folder=2]="folder",t[t.genericFile=3]="genericFile",t[t.listItem=4]="listItem",t[t.sharedFolder=5]="sharedFolder",t[t.multiple=6]="multiple",t[t.stream=7]="stream",t[t.news=8]="news",t[t.desktopFolder=9]="desktopFolder",t[t.documentsFolder=10]="documentsFolder",t[t.picturesFolder=11]="picturesFolder",t[t.linkedFolder=12]="linkedFolder",t[t.list=13]="list",t[t.form=14]="form",t[t.sway=15]="sway",t[t.playlist=16]="playlist",t[t.loopworkspace=17]="loopworkspace",t[t.planner=18]="planner",t[t.todoItem=19]="todoItem",t[t.portfolio=20]="portfolio",t[t.album=21]="album",t[t.listForm=22]="listForm"})(Kh||(Kh={}));var WZ,TVe="genericfile",d9t="folder",u9t="sharedfolder",h9t="docset",p9t="listitem",g9t="splist",m9t="multiple",f9t="sponews",v9t="video",y9t="desktopfolder",S9t="documentsfolder",b9t="picturesfolder",T9t="linkedfolder",C9t="form",_9t="sway",E9t="playlist",A9t="loopworkspace",I9t="todoitem",w9t="planner",k9t="portfolio",R9t="album",M9t="listform";function P9t(t){var e,i=t.extension,r=t.type,o=t.size,l=t.imageFileType;e=D9t(i,r);var d=o,h=L9t(d,l);return{iconName:e+h,"aria-label":i}}function D9t(t,e){var i;if(t){if(!WZ){WZ={};for(var r in ume)if(ume.hasOwnProperty(r)){var o=ume[r].extensions;if(o)for(var l=0;l<o.length;l++)WZ[o[l]]=r}}return t=t.replace(".","").toLowerCase(),WZ[t]||TVe}else if(e)switch(e){case Kh.docset:i=h9t;break;case Kh.folder:i=d9t;break;case Kh.listItem:i=p9t;break;case Kh.sharedFolder:i=u9t;break;case Kh.stream:i=v9t;break;case Kh.multiple:i=m9t;break;case Kh.news:i=f9t;break;case Kh.desktopFolder:i=y9t;break;case Kh.documentsFolder:i=S9t;break;case Kh.picturesFolder:i=b9t;break;case Kh.linkedFolder:i=T9t;break;case Kh.list:i=g9t;break;case Kh.form:i=C9t;break;case Kh.sway:i=_9t;break;case Kh.playlist:i=E9t;break;case Kh.loopworkspace:i=A9t;break;case Kh.planner:i=w9t;break;case Kh.todoItem:i=I9t;break;case Kh.portfolio:i=k9t;break;case Kh.album:i=R9t;break;case Kh.listForm:i=M9t;break}return i||TVe}function L9t(t,e,i){i??(i=window);var r=i.devicePixelRatio,o="";return r>1&&r<=1.5&&(o="_1.5x"),t+o+"_"+e}const CVe=()=>({removeAttachment:"",uploadCompleted:"",uploading:"",attachmentMoreMenu:""});var O9t=function(t,e,i,r){function o(l){return l instanceof i?l:new i(function(d){d(l)})}return new(i||(i=Promise))(function(l,d){function h(f){try{g(r.next(f))}catch(y){d(y)}}function p(f){try{g(r.throw(f))}catch(y){d(y)}}function g(f){f.done?l(f.value):o(f.value).then(h,p)}g((r=r.apply(t,e||[])).next())})};const N9t=t=>{var e,i,r,o,l;const{attachment:d,menuActions:h,onActionHandlerFailed:p,selfResizing:g}=t,f=g7t(),y=$.useMemo(()=>"progress"in d?d.progress:void 0,[d]),T=$.useMemo(()=>y!==void 0&&y>=0&&y<1,[y]),[C,E]=$.useState(void 0),I=CVe(),w=(i=(e=t.strings)===null||e===void 0?void 0:e.uploading)!==null&&i!==void 0?i:I.uploading,D=(o=(r=t.strings)===null||r===void 0?void 0:r.uploadCompleted)!==null&&o!==void 0?o:I.uploadCompleted;$.useEffect(()=>{E(T?`${w} ${d.name}`:y===1?`${d.name} ${D}`:void 0)},[y,T,d.name,w,D]);const F=$.useMemo(()=>{const B=/(?:\.([^.]+))?$/.exec(d.name);return B&&B[1]?B[1]:""},[d]);return U.createElement("div",{"data-is-focusable":!0},U.createElement(ule,{className:ea(f.root,g?f.dynamicWidth:f.staticWidth),size:"small",role:"listitem",appearance:"filled-alternative","aria-label":d.name,"data-testid":"attachment-card"},U.createElement(GA,{announcementString:C,ariaLive:"polite"}),U.createElement(NMe,{className:f.content,image:{className:f.fileIcon,children:U.createElement(Fr,{"data-ui-id":"attachmenttype-icon",iconName:P9t({extension:F,size:24,imageFileType:"svg"}).iconName})},header:{id:"attachment-"+d.id,children:U.createElement(AC,{content:d.name,calloutProps:{gapSpace:0,target:"#attachment-"+d.id},hostClassName:m7t},U.createElement(ole,{className:f.title,"aria-label":d.name},d.name))},action:{className:f.actions,children:x9t(h,Object.assign(Object.assign({},d),{url:(l=d.url)!==null&&l!==void 0?l:""}),p)}})),T?U.createElement(OMe,null,U.createElement(sle,{thickness:"medium",value:Math.max(y??0,f7t),shape:"rounded"})):U.createElement(U.Fragment,null," "))},x9t=(t,e,i)=>{const r=CVe();return t[0]?t.length===1?U.createElement(AC,{content:t[0].name},U.createElement(lle,{"aria-label":t[0].name,role:"button",icon:t[0].icon,onClick:()=>{var o;try{(o=t[0])===null||o===void 0||o.onClick(e)}catch(l){i?.(l.message)}}})):U.createElement(MMe,null,U.createElement(lMe,null,U.createElement(AC,{content:r.attachmentMoreMenu},U.createElement(nle,null,U.createElement(lle,{"aria-label":r.attachmentMoreMenu,role:"button",icon:U.createElement(Fr,{iconName:"AttachmentMoreMenu"})}))),U.createElement(mMe,null,U.createElement(gMe,null,t.map((o,l)=>U.createElement(pMe,{"aria-label":o.name,key:l,icon:o.icon,onClick:()=>O9t(void 0,void 0,void 0,function*(){try{yield o.onClick(e)}catch(d){i?.(d.message)}})},o.name)))))):U.createElement(U.Fragment,null)},B9t=Lv({root:{marginTop:"0.25rem"},singleAttachment:{width:`${T4}rem`},multipleAttachments:{width:"100%"}}),F9t=It({"& > *":{margin:`${_n(DZ)}`},"& > *:not(:first-child)":{marginLeft:`${_n(DZ)}`}}),U9t=It({display:"grid",gridTemplateColumns:`repeat(auto-fit, minmax(${T4}rem, 1fr))`}),z9t=It({display:"flex",flexWrap:"wrap"}),V9t=It({opacity:"0.5",userSelect:"none",pointerEvents:"none"});var KZ;(function(t){t.Grid="grid",t.Flex="flex"})(KZ||(KZ={}));const $9t=t=>{const{children:e,ariaLabel:i,attachmentGroupLayout:r,disabled:o}=t;return e?U.createElement(Et,{horizontal:!0,className:It(o&&V9t,F9t,r===KZ.Grid?U9t:z9t),"aria-label":i,role:"list"},e):U.createElement(U.Fragment,null)},H9t=t=>{const{attachments:e,message:i}=t,r=Kl().strings.messageThread,o=B9t(),l=$.useCallback((h,p,g,f)=>{const y=j9t(p,g);try{const T=f?.(h,g);return T&&T.length>0?T:y}catch{return y}},[]),d=$.useMemo(()=>{var h,p;return((p=(h=t.attachments)===null||h===void 0?void 0:h.length)!==null&&p!==void 0?p:0)>1},[t.attachments]);return!e||e.length===0||!e?U.createElement(U.Fragment,null):U.createElement("div",{className:ea(o.root,d?o.multipleAttachments:o.singleAttachment),"data-ui-id":"attachment-download-card-group"},U.createElement($9t,{attachmentGroupLayout:KZ.Grid},e&&e.map(h=>U.createElement(N9t,{attachment:h,key:h.id,menuActions:l(h,r,i,t.actionsForAttachment),onActionHandlerFailed:t.onActionHandlerFailed,selfResizing:d}))))},j9t=(t,e)=>{let i=t.openAttachment;return Jwt(e?.senderId)?[{name:i,icon:U.createElement(Fr,{iconName:"OpenAttachment"}),onClick:_Ve}]:[Object.assign(Object.assign({},G9t),{name:i})]},_Ve=t=>new Promise(e=>{window.open(t.url,"_blank","noopener,noreferrer"),e()}),G9t={name:"Download",icon:U.createElement(Fr,{iconName:"DownloadAttachment","data-ui-id":"attachment-download-card-download-icon"}),onClick:_Ve},I4=t=>t.toLocaleTimeString([],{hour:"numeric",minute:"2-digit"}),EVe=t=>t.toLocaleDateString(),q9t=(t,e,i)=>{const r=new Date(e.getFullYear(),e.getMonth(),e.getDate());if(t>r)return I4(t);const o=new Date(e.getFullYear(),e.getMonth(),e.getDate()-1);if(t>o)return i.yesterday+" "+I4(t);const l=e.getDay();if(l===0)return EVe(t)+" "+I4(t);const d=new Date(e.getFullYear(),e.getMonth(),e.getDate()-l);return t>d?W9t(t.getDay(),i)+" "+I4(t):EVe(t)+" "+I4(t)},W9t=(t,e)=>{switch(t){case 0:return e.sunday;case 1:return e.monday;case 2:return e.tuesday;case 3:return e.wednesday;case 4:return e.thursday;case 5:return e.friday;case 6:return e.saturday;default:throw new Error(`Invalid day [${t}] passed`)}},AVe=t=>t==="top"||t===!1?"top":"center";function IVe(t,e,i,r,o,l){return U.createElement("div",{className:"ui-chat__message__content"},U.createElement(a9t,{message:t,strings:e,inlineImageOptions:r}),o?o(t):K9t(t,e,l))}const K9t=(t,e,i)=>{var r;const o="attachments"in t?t.attachments:void 0;return((r=o?.length)!==null&&r!==void 0?r:0)>0?U.createElement(H9t,{message:t,attachments:o,actionsForAttachment:i,strings:{openAttachment:e.openAttachment,attachmentCardGroupMessage:e.attachmentCardGroupMessage}}):U.createElement(U.Fragment,null)},wVe=(t,e,i)=>e?q9t(t,new Date,i):I4(t),kVe=(t,e,i)=>"",RVe=(t,e,i)=>{const r="editedOn"in t?t.editedOn:void 0;if(t.messageType==="chat"&&r)return U.createElement("div",{className:eGt(e)},i)},MVe=t=>{t&&(t.removeAttribute("tabindex"),t.removeAttribute("data-tabster"))},J9t=t=>{var e;const i=qE(),r=Cs(),o=Kl(),{userId:l,message:d,onRemoveClick:h,onResendClick:p,disableEditing:g,showDate:f,messageContainerStyle:y,strings:T,onEditClick:C,remoteParticipantsCount:E=0,onRenderAvatar:I,showMessageStatus:w,messageStatus:D,inlineImageOptions:F,onDisplayDateTimeString:x,onRenderAttachmentDownloads:B,actionsForAttachment:L,shouldFocusFluentMessageBody:z}=t,H=$.useMemo(()=>{const ct=d.createdOn?wVe(d.createdOn,f,T):void 0;return(d.createdOn?kVe(d.createdOn):"")||ct},[o,d.createdOn,x,f,T]),[j,J]=$.useState(!1),[Z,re]=U.useState(!1),ne=$.useRef(null),le=$.useRef(null),[he,Me]=$.useState(void 0),Le=!g&&d.status!=="sending"&&!!d.mine,[pe,te]=$.useState([]),Se=cGt({ariaLabel:(e=T.actionMenuMoreOptions)!==null&&e!==void 0?e:"",enabled:Le,menuButtonRef:le,menuExpanded:he===le,onActionButtonClick:()=>{d.messageType==="chat"&&(t.onActionButtonClick(d,te),Me(le))},theme:r});$.useEffect(()=>{z&&setTimeout(()=>{var ct;(ct=ne.current)===null||ct===void 0||ct.focus()})},[z]);const ce=$.useCallback(()=>{Me(void 0)},[Me]),X=$.useCallback(()=>D==="failed"?U.createElement("div",{className:vze(r)},T.failToSendTag):RVe(d,r,T.editedTag),[d,D,T.editedTag,T.failToSendTag,r]),ve=cze(),Te=dze(),Be=d.attached===!0?"center":d.attached==="bottom"?"bottom":"top",qe=$.useCallback(()=>U.createElement("div",{className:ea(C7t,ve.menu,Z||he?.current?ve.menuVisible:ve.menuHidden)},Se?.children),[Se?.children,he,ve.menu,ve.menuHidden,ve.menuVisible,Z]),Ge=$.useCallback(()=>U.createElement("div",null,IVe(d,T,l,F,B,L),qe()),[L,qe,F,d,B,T,l]);return U.createElement(U.Fragment,null,U.createElement("div",{key:t.message.messageId},U.createElement(PZ,{attached:Be,key:t.message.messageId,body:{className:ea(Te.body,ve.body,t.message.status==="failed"?Te.failed:void 0,Be!=="top"?ve.bodyAttached:void 0,It(y)),style:Object.assign({},C4(y)),ref:ne},root:{className:ve.root,onBlur:ct=>{if(he?.current)return;const Mt=ct.currentTarget.contains(ct.relatedTarget);re(Mt)},onFocus:()=>{re(!0)}},"data-testid":"chat-composite-message",author:U.createElement(ja,{className:qge(r)},d.senderDisplayName),timestamp:U.createElement(ja,{className:t.message.status==="failed"?fze(r):qge(r),"data-testid":i.messageTimestamp},H),details:X(),onTouchStart:()=>J(!0),onPointerDown:()=>J(!1),onKeyDown:()=>J(!1),onClick:()=>{j&&(Me(ne),d.messageType==="chat"&&t.onActionButtonClick(d,te))}},Ge())),Le&&U.createElement(sGt,{hidden:!he,target:he,increaseFlyoutItemSize:j,onDismiss:ce,onEditClick:C,onRemoveClick:h,onResendClick:p,strings:T,messageReadBy:pe,messageStatus:D??"failed",remoteParticipantsCount:E,onRenderAvatar:I,showMessageStatus:w}))},Y9t=U.memo(J9t),Q9t=It({marginTop:"0.0875rem",marginBottom:"0.0875rem"}),PVe=It({margin:"0",width:"2.125rem",height:"2.125rem",padding:"0.375rem 0 0 0"}),Z9t=It({margin:"auto","&:hover svg":{stroke:"currentColor"}});It(M4e,{"&:hover svg":{stroke:"currentColor"}});const X9t={root:{minWidth:"6.25rem",maxWidth:"100%"}},eqt=t=>U.createElement(Fr,{iconName:"EditBoxCancel",className:t}),tqt=t=>U.createElement(Fr,{iconName:"EditBoxSubmit",className:t});function iqt(t){return t.trim().length===0}function nqt(t){return iqt(t)?"too short":z4e(t.length)?"too long":"OK"}const aqt=t=>{const{onCancel:e,onSubmit:i,strings:r,message:o}=t,[l,d]=$.useState(o.content||""),h=U.useRef(null),p=Cs(),g=nqt(l),f=g==="OK",y=rGt(),T=cze();$.useEffect(()=>{var L;(L=h.current)===null||L===void 0||L.focus()},[]);const C=(L,z)=>{d(z??"")},E=g==="too long"?Jd(r.editBoxTextLimit,{limitNumber:`${AZ}`}):void 0,I=$.useCallback(L=>{const z=L?p.palette.accent:p.palette.neutralSecondary;return It(Z9t,{color:z})},[p.palette.accent,p.palette.neutralSecondary]),w=$.useCallback(L=>eqt(I(L)),[I]),D=$.useCallback(L=>tqt(I(L)),[I]),F=$.useMemo(()=>Ds(X9t,{textField:{borderColor:p.palette.themePrimary}}),[p.palette.themePrimary]),x=()=>U.createElement(U.Fragment,null,U.createElement(F4e,{"data-ui-id":"edit-box",textFieldRef:h,inputClassName:Q9t,placeholderText:r.editBoxPlaceholderText,textValue:l,onChange:C,onKeyDown:L=>{(L.key==="ArrowUp"||L.key==="ArrowDown")&&L.stopPropagation()},onEnterKeyDown:()=>{f&&i(l)},supportNewline:!1,maxLength:AZ,errorMessage:E,styles:F}),U.createElement(Et,{horizontal:!0,horizontalAlign:"end",className:nGt,tokens:{childrenGap:"0.25rem"}},o.failureReason&&U.createElement(Et.Item,{grow:!0,align:"stretch",className:iGt},U.createElement("div",{className:It(vze(p),tGt)},o.failureReason)),U.createElement(Et.Item,{align:"end"},U.createElement(Bge,{className:PVe,ariaLabel:r.editBoxCancelButton,tooltipContent:r.editBoxCancelButton,onRenderIcon:w,onClick:()=>{e&&e(o.messageId)},id:"dismissIconWrapper","data-testId":"chat-message-edit-box-cancel-button"})),U.createElement(Et.Item,{align:"end"},U.createElement(Bge,{className:PVe,ariaLabel:r.editBoxSubmitButton,tooltipContent:r.editBoxSubmitButton,onRenderIcon:D,onClick:L=>{f&&i(l),L.stopPropagation()},id:"submitIconWrapper","data-testId":"chat-message-edit-box-submit-button"})))),B=o.attached===!0?"center":o.attached==="bottom"?"bottom":"top";return U.createElement(PZ,{attached:B,root:{className:ea(T.root)},body:{className:ea(y.body,o.failureReason!==void 0?y.bodyError:y.bodyDefault,B!=="top"?y.bodyAttached:void 0)}},x())},rqt=t=>$.useMemo(()=>U.createElement(aqt,Object.assign({},t)),[t]);var oqt=function(t,e,i,r){function o(l){return l instanceof i?l:new i(function(d){d(l)})}return new(i||(i=Promise))(function(l,d){function h(f){try{g(r.next(f))}catch(y){d(y)}}function p(f){try{g(r.throw(f))}catch(y){d(y)}}function g(f){f.done?l(f.value):o(f.value).then(h,p)}g((r=r.apply(t,e||[])).next())})};const sqt=t=>{const{onDeleteMessage:e,onSendMessage:i,message:r,onCancelEditMessage:o,onUpdateMessage:l}=t,[d,h]=$.useState(!1),[p,g]=$.useState(!1),f=$.useCallback(()=>{h(!0),g(!1)},[]),y="clientMessageId"in r?r.clientMessageId:void 0,T="content"in r?r.content:void 0,C=$.useCallback(()=>{e&&r.messageId?e(r.messageId):e&&r.messageType==="chat"&&y&&e(y)},[e,r.messageId,r.messageType,y]),E=$.useCallback(()=>{e&&y&&e(y),i&&i(T??"")},[r,e,y,i,T]),I=$.useCallback(function(D){return oqt(this,void 0,void 0,function*(){yield l?.(r.messageId,D),h(!1),g(!0)})},[r,l]),w=$.useCallback(D=>{o?.(D),h(!1),g(!0)},[o]);return d&&r.messageType==="chat"?U.createElement(rqt,{message:r,strings:t.strings,onSubmit:I,onCancel:w}):U.createElement(Y9t,Object.assign({},t,{onRemoveClick:C,onEditClick:f,onResendClick:E,onRenderAvatar:t.onRenderAvatar,strings:t.strings,inlineImageOptions:t.inlineImageOptions,shouldFocusFluentMessageBody:p}))},lqt=t=>{const{message:e,styles:i,shouldOverlapAvatarAndMessage:r,onRenderMessage:o,onRenderAvatar:l,showMessageStatus:d,onRenderMessageStatus:h,participantCount:p,readCount:g,onActionButtonClick:f,inlineImageOptions:y,userId:T,defaultStatusRenderer:C,statusToRender:E,actionsForAttachment:I,onRenderAttachmentDownloads:w}=t,D=lze(),F=$.useCallback(Z=>Z.message.messageType==="chat"?U.createElement(sqt,Object.assign({},Z,{onRenderAttachmentDownloads:w,strings:Z.strings,message:Z.message,userId:T,remoteParticipantsCount:p?p-1:0,shouldOverlapAvatarAndMessage:r,onRenderAvatar:l,showMessageStatus:d,messageStatus:Z.message.status,onActionButtonClick:f,inlineImageOptions:y,actionsForAttachment:I})):U.createElement(U.Fragment,null),[f,l,p,r,d,T,y,w,I,new Date().toDateString()]),x=$.useCallback(Z=>o===void 0?F(Object.assign({},Z)):o(Z,F),[F,o]),B=$.useCallback((Z,re,ne,le,he)=>ne&&E?Z?Z({status:e.status}):re(e,le??0,he??0,e.status):U.createElement("div",{className:It(A7t)}),[e,E]),L=$.useMemo(()=>AVe(e.attached),[e.attached]),z=$.useMemo(()=>({className:ea(D.rootMyMessage,D.rootCommon,It(i?.myChatItemMessageContainer)),style:i?.myChatItemMessageContainer!==void 0?C4(i?.myChatItemMessageContainer):{},role:"none"}),[D.rootCommon,D.rootMyMessage,i?.myChatItemMessageContainer]),H=$.useCallback(Z=>{MVe(Z)},[]),j=$.useMemo(()=>({className:ea(D.bodyCommon,D.bodyMyMessage),ref:H}),[D.bodyCommon,D.bodyMyMessage,H]),J=$.useMemo(()=>{var Z;return U.createElement("div",{className:It({paddingLeft:"0.25rem"},i?.messageStatusContainer?i.messageStatusContainer((Z=e.mine)!==null&&Z!==void 0?Z:!1):"")},e.status?B(h,C,d,p,g):void 0)},[C,e.mine,e.status,B,h,p,g,d,i]);return U.createElement(PZ,{attached:L,root:z,body:j,statusIcon:J},x(Object.assign({},t)))},cqt=t=>{const e=qE(),i=Cs(),r=Kl(),{userId:o,message:l,showDate:d,messageContainerStyle:h,strings:p,onRenderAttachmentDownloads:g,inlineImageOptions:f,shouldOverlapAvatarAndMessage:y,actionsForAttachment:T,onDisplayDateTimeString:C}=t,E=$.useMemo(()=>{const z=l.createdOn?wVe(l.createdOn,d,p):void 0;return(l.createdOn?kVe(l.createdOn):"")||z},[r,l.createdOn,C,d,p]),I=$.useCallback(()=>RVe(l,i,p.editedTag),[p.editedTag,i,l]),w=$.useCallback(()=>IVe(l,p,o,f,g,T),[T,f,l,g,p,o]),D=dze(),F=k7t(),x=ea(D.body,F.body,D.bodyWithPlaceholderImage,t.message.status==="failed"?D.failed:void 0,y?F.avatarOverlap:F.avatarNoOverlap,l.attached==="top"||l.attached===!1?F.bodyWithAvatar:F.bodyWithoutAvatar,It(h)),B=l.attached===!0?"center":l.attached==="bottom"?"bottom":"top";return U.createElement(U.Fragment,null,U.createElement("div",{key:t.message.messageId},U.createElement(Hge,{attached:B,key:t.message.messageId,root:{className:F.root},author:U.createElement(ja,{className:X7t},l.senderDisplayName),body:{className:x,style:Object.assign({},C4(h))},"data-testid":"chat-composite-message",timestamp:U.createElement(ja,{className:t.message.status==="failed"?fze(i):qge(i),"data-testid":e.messageTimestamp},E),details:I()},w())))},dqt=U.memo(cqt),uqt=t=>{const{message:e,styles:i,shouldOverlapAvatarAndMessage:r,onRenderMessage:o,onRenderAvatar:l,inlineImageOptions:d,actionsForAttachment:h,userId:p,onRenderAttachmentDownloads:g}=t,f=lze(),y=$.useCallback(x=>x.message.messageType==="chat"?U.createElement(dqt,Object.assign({},x,{onRenderAttachmentDownloads:g,strings:x.strings,message:x.message,userId:p,shouldOverlapAvatarAndMessage:r,inlineImageOptions:d,actionsForAttachment:h})):U.createElement(U.Fragment,null),[g,p,r,d,h]),T=$.useCallback(x=>o===void 0?y(Object.assign({},x)):o(x,y),[y,o]),C=$.useMemo(()=>e.attached==="top"||e.attached===!1,[e.attached]),E=$.useMemo(()=>AVe(e.attached),[e.attached]),I=$.useMemo(()=>({className:ea(f.rootMessage,f.rootCommon)}),[f.rootCommon,f.rootMessage]),w=$.useMemo(()=>{const x=C?uze:R7t,B={hidePersonaDetails:!0,size:Io.size32,text:e.senderDisplayName,showOverflowTooltip:!1};let L;if(l){const z=l?.(e.senderId,B);if(z)L=z;else return}return U.createElement("div",{className:It(x)},L||U.createElement(ux,Object.assign({},B)))},[e.senderDisplayName,e.senderId,l,C]),D=$.useCallback(x=>{MVe(x)},[]),F=$.useMemo(()=>({ref:D,className:ea(f.bodyCommon,C?f.bodyWithAvatar:w?f.bodyWithoutAvatar:f.bodyHiddenAvatar,r?f.avatarOverlap:f.avatarNoOverlap,It(i?.chatItemMessageContainer)),style:i?.chatItemMessageContainer!==void 0?C4(i?.chatItemMessageContainer):{}}),[D,f.bodyCommon,f.bodyWithoutAvatar,f.bodyHiddenAvatar,f.bodyWithAvatar,f.avatarOverlap,f.avatarNoOverlap,C,w,r,i?.chatItemMessageContainer]);return U.createElement(Hge,{attached:E,root:I,body:F,avatar:w},T(Object.assign({},t)))},hqt=t=>{var e;const{message:i,styles:r,onRenderMessage:o,key:l}=t,d=$.useMemo(()=>({paddingTop:"0.5rem"}),[]),h=$.useMemo(()=>({paddingTop:"1rem",paddingBottom:"0.25rem"}),[]);switch(i.messageType){case"chat":{const p=i.status==="failed"&&(e=r?.failedMyChatMessageContainer)!==null&&e!==void 0?e:r?.myChatMessageContainer,g=r?.chatMessageContainer,f=i.mine?p:g;return pqt(Object.assign(Object.assign({},t),{message:i,messageContainerStyle:f}))}case"system":{const p=r?.systemMessageContainer,g=o===void 0?U.createElement(mze,Object.assign({},t)):o(Object.assign(Object.assign({},t),{messageContainerStyle:p}),f=>U.createElement(mze,Object.assign({},f)));return U.createElement("div",{key:l,style:d},g)}default:{const p=o===void 0?U.createElement(U.Fragment,null):o(Object.assign({},t));return U.createElement("div",{key:l,style:h},p)}}},pqt=t=>t.message.mine===!0?U.createElement(lqt,Object.assign({},t)):U.createElement(uqt,Object.assign({},t));var hme=function(t,e,i,r){function o(l){return l instanceof i?l:new i(function(d){d(l)})}return new(i||(i=Promise))(function(l,d){function h(f){try{g(r.next(f))}catch(y){d(y)}}function p(f){try{g(r.throw(f))}catch(y){d(y)}}function g(f){f.done?l(f.value):o(f.value).then(h,p)}g((r=r.apply(t,e||[])).next())})};const DVe=(t,e)=>t.messageId===e.messageId&&t.content===e.content&&t.contentType===e.contentType&&JSON.stringify(t.createdOn)===JSON.stringify(e.createdOn)&&t.senderId===e.senderId&&t.senderDisplayName===e.senderDisplayName&&JSON.stringify(t.editedOn)===JSON.stringify(e.editedOn),LVe=t=>{for(let e=t.length-1;e>=0;e--){const i=t[e];if(i?.messageType==="chat"&&i.createdOn)return i}},gqt=(t,e,i)=>i===void 0?!1:(e===void 0||!DVe(i,e))&&i.senderId!==t,mqt=(t,e,i)=>i===void 0?!1:(e===void 0||!DVe(i,e))&&i.senderId===t,fqt=t=>{const{text:e,onClick:i}=t;return U.createElement(SE,{className:M7t,styles:P7t,text:e,onClick:i,onRenderIcon:()=>U.createElement(Fr,{iconName:"Down",className:D7t})})},vqt=WH((t,e,i,r,o,l,d,h,p,g,f,y,T)=>{let C=t.messageId,E;if(t.messageType==="chat"){if((!t.messageId||t.messageId==="")&&"clientMessageId"in t&&(C=t.clientMessageId),i&&t.mine)switch(t.messageId){case f:{E="seen";break}case y:{E="sending";break}case T:{E="delivered";break}}t.mine&&t.status==="failed"&&(E="failed")}return{key:C??"id_"+o,statusToRender:E,message:t,strings:r,showDate:e,onUpdateMessage:l,onCancelEditMessage:d,onDeleteMessage:h,onSendMessage:p,disableEditing:g,showMessageStatus:i}}),pme=(t,e)=>{for(let i=t.length-1;i>=0;i--){const r=t[i];if(r?.messageType==="chat"&&r.status===e&&r.mine)return r.messageId}},yqt=t=>{for(let e=t.length-1;e>=0;e--){const i=t[e];if(i?.messageType==="chat"&&i.mine)return i}},gme=t=>{var e;const i=Cs(),r=$.useMemo(()=>U.createElement(pze,{v8Theme:i},U.createElement(Sqt,Object.assign({},t))),[i,t]);return U.createElement("div",{className:It(_7t,(e=t.styles)===null||e===void 0?void 0:e.root)},r)},Sqt=t=>{var e;const{messages:i,userId:r,participantCount:o,readReceiptsBySenderId:l,styles:d,disableJumpToNewMessageButton:h=!1,showMessageDate:p=!1,showMessageStatus:g=!1,numberOfChatMessagesToReload:f=5,onMessageSeen:y,onRenderMessageStatus:T,onRenderAvatar:C,onLoadPreviousChatMessages:E,onRenderJumpToNewMessageButton:I,onRenderMessage:w,onUpdateMessage:D,onCancelEditMessage:F,onDeleteMessage:x,onSendMessage:B,inlineImageOptions:L}=t,[z,H]=$.useState(!1),[j,J]=$.useState(!0),[Z,re]=$.useState(0),[ne,le]=$.useState(void 0),[he,Me]=$.useState(void 0),[Le,pe]=$.useState(!1),[te,Se]=$.useState(void 0),[ce,X]=$.useState(void 0),[ve,Te]=$.useState(void 0),[Be,qe]=$.useState(void 0),Ge=Kl().strings.messageThread,tt=$.useMemo(()=>Object.assign(Object.assign({},Ge),t.strings),[Ge,t.strings]),[ct,Mt]=$.useState([]),[ht,vt]=$.useState(void 0),Pt=$.useRef([]),[ni,Zt]=$.useState(void 0),it=$.useCallback(yn=>hme(void 0,void 0,void 0,function*(){if(x)try{Zt(void 0),vt(yn),sn.current="deleted",yield x(yn)}catch(pr){console.log("onDeleteMessage failed: messageId",yn,"error",pr)}}),[x]),Ke=$.useRef(!1);$.useEffect(()=>{E&&(Ke.current=!1)},[E]);const ot=$.useRef(-1),Ht=$.useRef(-1),jt=$.useRef(""),Nt=$.useRef(null),Vt=$.useRef(!1);$.useEffect(()=>{ht===void 0?Zt(void 0):Pt.current.find(yn=>yn.messageId===ht)?ct.find(yn=>yn.messageId===ht)?Zt(void 0):Zt(tt.messageDeletedAnnouncementAriaLabel):Zt(void 0),Pt.current=ct},[ht,ct,tt.messageDeletedAnnouncementAriaLabel]);const $t=$.useRef(ct),dt=yn=>{$t.current=yn,Mt(yn)},yt=$.useRef(j),kt=yn=>{yt.current=yn,J(yn)},je=$.useRef(z),Ae=yn=>{je.current=yn,H(yn)},xe=$.useRef(null),gt=nF(xe),Ye=gt?E8(gt):!1,Fe=(e=xe.current)===null||e===void 0?void 0:e.clientHeight,St=$.useCallback(()=>hme(void 0,void 0,void 0,function*(){if(!yt.current||!document.hasFocus()||!$t.current||$t.current.length===0||!g)return;const yn=$t.current.filter(Ho=>Ho.messageType==="chat"&&!Ho.mine&&!!Ho.messageId);if(yn.length===0)return;const pr=yn[yn.length-1];try{y&&pr&&pr.messageId&&pr.messageId!==jt.current&&(yield y(pr.messageId),jt.current=pr.messageId)}catch(Ho){console.log("onMessageSeen Error",pr,Ho)}}),[g,y]),Wt=$.useCallback(()=>{Nt.current&&(Nt.current.scrollTop=Nt.current.scrollHeight),pe(!1),kt(!0),St()},[St]),Ii=$.useCallback(()=>{if(!Nt.current)return;const yn=Math.ceil(Nt.current.scrollTop)>=Nt.current.scrollHeight-Nt.current.clientHeight;yn&&(St(),yt.current||Wt()),kt(yn)},[Wt,St]),en=$.useCallback(()=>hme(void 0,void 0,void 0,function*(){if(!Vt.current&&E){Vt.current=!0;try{for(;!Ke.current&&Nt.current&&Nt.current.scrollTop<=500;)Ke.current=yield E(f),yield O7t(200)}finally{Vt.current=!1}}}),[f,E]);$.useEffect(()=>{Nt.current&&(ot.current=Nt.current.scrollTop,Ht.current=Nt.current.scrollHeight)},[i]),$.useEffect(()=>{Nt.current&&(Nt.current.scrollTop=Nt.current.scrollHeight-(Ht.current-ot.current))},[ct]),$.useEffect(()=>{en()},[en]),$.useEffect(()=>(window&&window.addEventListener("click",St),window&&window.addEventListener("focus",St),()=>{window&&window.removeEventListener("click",St),window&&window.removeEventListener("focus",St)}),[St]),$.useEffect(()=>{const yn=Nt.current;return yn?.addEventListener("scroll",Ii),yn?.addEventListener("scroll",en),()=>{yn?.removeEventListener("scroll",Ii),yn?.removeEventListener("scroll",en)}},[en,Ii]),$.useEffect(()=>{if(Fe===void 0){re(Z+1);return}yt.current&&Wt()},[Fe,Z,Wt,z]),$.useEffect(()=>{var yn;const pr=(yn=yqt(i))===null||yn===void 0?void 0:yn.status;pr!==void 0&&(sn.current==="deleted"&&pr==="sending"||sn.current!=="deleted")&&(sn.current=pr)},[i]),$.useEffect(()=>{le(LVe($t.current)),Me(LVe(i)),dt(i),!je.current&&Ae(!0),X(pme(i,"delivered")),Se(pme(i,"seen")),Te(pme(i,"sending"))},[i]),$.useEffect(()=>{gqt(r,ne,he)&&!yt.current?pe(!0):(mqt(r,ne,he)||yt.current)&&Wt()},[ct]);const sn=$.useRef(void 0),Qi=$.useRef(o),qt=$.useRef(l);Qi.current=o,qt.current=l;const ri=$.useCallback((yn,pr)=>{Qi.current&&Qi.current-1>1&&qt.current&&pr(hze(yn,qt.current))},[]),Ti=$.useCallback((yn,pr,Ho,Rr)=>{const La=sn.current!=="deleted",us=al=>{al&&qt.current?qe(hze(yn,qt.current).length):qe(void 0)};return U.createElement(J8t,{status:Rr,readCount:Ho,onToggleToolTip:us,remoteParticipantsCount:pr?pr-1:0,shouldAnnounce:La})},[]),rn=Cs(),Hn=$.useMemo(()=>vqt(yn=>ct.map((pr,Ho)=>yn(pr,p,g,tt,Ho,D,F,it,B,t.disableEditing,ce,te,ve))),[ce,te,ve,ct,F,it,B,D,t.disableEditing,p,g,tt]),ha=I7t(),hr=NH({axis:"vertical",memorizeCurrent:!1});return U.createElement("div",{className:It(E7t),ref:xe},Le&&!h&&U.createElement("div",{className:It(w7t,d?.newMessageButtonContainer)},I?I({text:tt.newMessagesIndicator,onClick:Wt}):U.createElement(fqt,{text:tt.newMessagesIndicator,onClick:Wt})),U.createElement(W7t,null,U.createElement(pze,{v8Theme:rn},U.createElement(J4e,Object.assign({className:ea(ha.root,It(d?.chatContainer)),ref:Nt,style:Object.assign({},C4(d?.chatContainer))},hr),ht&&U.createElement(GA,{key:ht,announcementString:ni,ariaLive:"polite"}),Hn.map(yn=>U.createElement(bqt,Object.assign({},yn,{userId:r,key:yn.key,styles:d,shouldOverlapAvatarAndMessage:Ye,strings:tt,onRenderAvatar:C,onRenderMessage:w,onRenderMessageStatus:T,defaultStatusRenderer:Ti,onActionButtonClick:ri,readCount:Be,participantCount:o,inlineImageOptions:L})))))))},bqt=U.memo(t=>U.createElement(hqt,Object.assign({},t))),Tqt=()=>It({position:"relative",display:"contents"}),Cqt=()=>It({position:"absolute",top:"50%",bottom:"0",left:"50%",right:"0",transform:"translate(-50%, -50%)"}),_qt={root:{height:"100%"},circle:{maxHeight:"5rem",height:"50%",width:"unset",aspectRatio:"1 / 1",borderWidth:"0.25em"}},OVe=t=>It({position:"relative",height:"100%",width:"100%",background:"transparent",display:"flex","& video":{borderRadius:t.effects.roundedCorner4}}),Eqt=t=>It(OVe(t),{transform:"rotateY(180deg)","& video:picture-in-picture":{transform:"rotateY(180deg)"}}),w4=t=>{const e=$.useRef(null),i=Cs(),{isMirrored:r,videoStreamElement:o,styles:l,loadingState:d="none"}=t,[h,p]=$.useState(!1);return $.useEffect(()=>{const g=e.current;if(g)return g.innerHTML="",p(!1),o&&(o.addEventListener("enterpictureinpicture",()=>{p(!0)}),o.addEventListener("leavepictureinpicture",()=>{p(!1)}),g.appendChild(o)),()=>{g.innerHTML="",p(!1)}},[o]),U.createElement("div",{className:Tqt()},U.createElement("div",{"data-ui-id":"stream-media-container",className:It(r&&h?Eqt(i):OVe(i),l?.root),ref:e}),d==="loading"&&U.createElement("div",{className:Cqt()},U.createElement(gx,{"data-ui-id":"stream-media-loading-spinner",styles:_qt})))},NVe="ms-acs-participant-item-menu-icon",Aqt=(t,e)=>({paddingTop:"0.25rem",paddingBottom:"0.25rem",display:"flex",maxWidth:"100%",minWidth:"8rem",cursor:t.clickable?"pointer":"default",alignItems:"center",":focus-visible":{[` .${NVe}`]:{display:"flex"},outline:`0.1rem solid ${e.palette.themePrimary}`}}),Iqt={display:"none"},wqt={width:"auto"},kqt={maxWidth:"5rem",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",lineHeight:"normal",marginLeft:"0.5rem",marginRight:0},Rqt={display:"flex",alignItems:"center",height:"100%",paddingTop:"0.2rem"},Mqt=It([NVe,{display:"flex",lineHeight:0,alignItems:"center"}]),Pqt={paddingRight:"0.5rem"},Dqt=t=>{var e,i,r;const{userId:o,displayName:l,onRenderAvatar:d,menuItems:h,onRenderIcon:p,presence:g,styles:f,me:y,onClick:T,showParticipantOverflowTooltip:C}=t,[E,I]=$.useState(!1),[w,D]=$.useState(!0),F=$.useRef(null),x=Cs(),B=Kl().strings.participantItem,L=qE(),z=yu(),H=yu(),j=!!(h&&h?.length>0),J=Object.assign(Object.assign({},B),t.strings),Z=xVe(t,J),re=!Z&&(E||!w)&&j,ne=l?.trim()||"",le={text:y?ne:l?.trim()||J.displayNamePlaceholder,size:Io.size32,presence:g,initialsTextColor:"white",showOverflowTooltip:C,showUnknownPersonaCoin:!y&&(!l?.trim()||l===J.displayNamePlaceholder)},he=d?d(o??"",le):U.createElement(ux,Object.assign({className:It({lineHeight:"1.15rem"},f?.avatar)},le)),Me=$.useMemo(()=>It(Pqt,{color:x.palette.neutralSecondary},f?.me),[x.palette.neutralSecondary,f?.me]),Le=$.useMemo(()=>It({background:x.palette.neutralLighterAlt},f?.menu),[x.palette.neutralLighterAlt,f?.menu]),pe=$.useMemo(()=>It(Rqt,{color:x.palette.neutralSecondary,marginLeft:"auto"},f?.iconContainer),[x.palette.neutralSecondary,f?.iconContainer]),te=()=>{I(!1),D(!0)},Se=$.useMemo(()=>U.createElement(Et,{horizontal:!0,horizontalAlign:"end",className:It(wqt,{color:x.palette.neutralPrimary}),title:J.menuTitle,"aria-controls":H,"data-ui-id":L.participantItemMenuButton},U.createElement(Fr,{iconName:"ParticipantItemOptionsHovered",className:It(Mqt,re?{}:Iqt)})),[x.palette.neutralPrimary,J.menuTitle,H,L.participantItemMenuButton,re]);return U.createElement("div",{ref:F,role:"menuitem",id:z,"aria-label":(i=j?(e=t.strings)===null||e===void 0?void 0:e.participantItemWithMoreOptionsAriaLabel:void 0)!==null&&i!==void 0?i:(r=t.strings)===null||r===void 0?void 0:r.participantItemAriaLabel,"aria-labelledby":`${t.ariaLabelledBy} ${z}`,"aria-expanded":!w,"aria-disabled":!(j||t.onClick),"aria-haspopup":j?!0:void 0,"aria-controls":H,"data-is-focusable":j,"data-ui-id":"participant-item",className:It(Aqt({clickable:j},x),f?.root),onMouseEnter:()=>I(!0),onMouseLeave:()=>I(!1),onClick:()=>{Z||(I(!0),D(!1),T?.(t)),w||te()},onKeyDown:ce=>{(ce.key==="Enter"||ce.key===" ")&&D(!1)},tabIndex:j?0:void 0},U.createElement(Et,{horizontal:!0,className:It({flexGrow:1,maxWidth:"100%",alignItems:"center"})},he,y&&U.createElement(ja,{className:Me},J.isMeText),U.createElement(Et,{horizontal:!0,className:It(pe)},!re&&p&&p(t),!y&&Z?U.createElement(ja,{"data-ui-id":"participant-item-state-string",className:It(kqt)},Z):U.createElement(U.Fragment,null,j&&U.createElement(U.Fragment,null,Se,U.createElement(hx,{id:H,items:h,hidden:w,target:F,onItemClick:te,onDismiss:te,directionalHint:hd.bottomRightEdge,className:Le,calloutProps:{preventDismissOnEvent:YS}}))))))},xVe=(t,e)=>t.participantState==="EarlyMedia"||t.participantState==="Ringing"?e?.participantStateRinging:t.participantState==="Hold"?e?.participantStateHold:void 0,BVe=()=>U.createElement("svg",{width:"20",height:"20",viewBox:"0 0 20 20",fill:"none",xmlns:"http://www.w3.org/2000/svg"},U.createElement("defs",null,U.createElement("radialGradient",{id:"paint0_radial_10246_159312",cx:"0",cy:"0",r:"1",gradientUnits:"userSpaceOnUse",gradientTransform:"translate(16.6796 10.8658) rotate(161.935) scale(13.4702 20.3408)"},U.createElement("stop",{offset:"0.817521",stopColor:"#E99329",stopOpacity:"0"}),U.createElement("stop",{offset:"0.961397",stopColor:"#E99329"})),U.createElement("radialGradient",{id:"paint1_radial_10246_159312",cx:"0",cy:"0",r:"1",gradientUnits:"userSpaceOnUse",gradientTransform:"translate(11.7464 4.86265) rotate(103.662) scale(15.5522 10.8511)"},U.createElement("stop",{offset:"0.750766",stopColor:"#F88456",stopOpacity:"0"}),U.createElement("stop",{offset:"1",stopColor:"#F88456"})),U.createElement("radialGradient",{id:"paint2_radial_10246_159312",cx:"0",cy:"0",r:"1",gradientUnits:"userSpaceOnUse",gradientTransform:"translate(10.8862 4.86067) rotate(98.3094) scale(14.3189 9.99881)"},U.createElement("stop",{offset:"0.937186",stopColor:"#F27A74",stopOpacity:"0"}),U.createElement("stop",{offset:"1",stopColor:"#F27A74"})),U.createElement("radialGradient",{id:"paint3_radial_10246_159312",cx:"0",cy:"0",r:"1",gradientUnits:"userSpaceOnUse",gradientTransform:"translate(17.3363 11.238) rotate(-144.906) scale(1.08553 4.6268)"},U.createElement("stop",{offset:"0.0636767",stopColor:"#EAB170"}),U.createElement("stop",{offset:"1",stopColor:"#F6B44B",stopOpacity:"0"})),U.createElement("radialGradient",{id:"paint4_radial_10246_159312",cx:"0",cy:"0",r:"1",gradientUnits:"userSpaceOnUse",gradientTransform:"translate(17.1484 8.75) rotate(129.452) scale(4.85649 1.57945)"},U.createElement("stop",{stopColor:"#FFC748"}),U.createElement("stop",{offset:"1",stopColor:"#FFC64A",stopOpacity:"0"})),U.createElement("radialGradient",{id:"paint5_radial_10246_159312",cx:"0",cy:"0",r:"1",gradientUnits:"userSpaceOnUse",gradientTransform:"translate(17.6953 8.75) rotate(135) scale(1.1601 1.07723)"},U.createElement("stop",{stopColor:"#FFE964"}),U.createElement("stop",{offset:"1",stopColor:"#FFE65F",stopOpacity:"0"})),U.createElement("radialGradient",{id:"paint6_radial_10246_159312",cx:"0",cy:"0",r:"1",gradientUnits:"userSpaceOnUse",gradientTransform:"translate(15.7422 8.47656) rotate(128.853) scale(3.61154 0.774997)"},U.createElement("stop",{offset:"0.251132",stopColor:"#EDB019"}),U.createElement("stop",{offset:"1",stopColor:"#EEB018",stopOpacity:"0"})),U.createElement("radialGradient",{id:"paint7_radial_10246_159312",cx:"0",cy:"0",r:"1",gradientUnits:"userSpaceOnUse",gradientTransform:"translate(15.6055 8.04687) rotate(125.92) scale(3.06292 0.505665)"},U.createElement("stop",{offset:"0.0171863",stopColor:"#D29E4C"}),U.createElement("stop",{offset:"1",stopColor:"#DAA23E",stopOpacity:"0"})),U.createElement("radialGradient",{id:"paint8_radial_10246_159312",cx:"0",cy:"0",r:"1",gradientUnits:"userSpaceOnUse",gradientTransform:"translate(14.2578 9.47266) rotate(-56.3099) scale(1.05631 0.227513)"},U.createElement("stop",{offset:"0.297381",stopColor:"#FFD260"}),U.createElement("stop",{offset:"1",stopColor:"#FFD361",stopOpacity:"0"})),U.createElement("radialGradient",{id:"paint9_radial_10246_159312",cx:"0",cy:"0",r:"1",gradientUnits:"userSpaceOnUse",gradientTransform:"translate(12.4609 9.62891) rotate(107.216) scale(1.45176 3.15212)"},U.createElement("stop",{offset:"0.251132",stopColor:"#FFCF48"}),U.createElement("stop",{offset:"1",stopColor:"#FFD04B",stopOpacity:"0"})),U.createElement("radialGradient",{id:"paint10_radial_10246_159312",cx:"0",cy:"0",r:"1",gradientUnits:"userSpaceOnUse",gradientTransform:"translate(12.3242 9.02344) rotate(144.638) scale(0.742444 1.38192)"},U.createElement("stop",{offset:"0.420068",stopColor:"#F2AA23"}),U.createElement("stop",{offset:"1",stopColor:"#F2AA23",stopOpacity:"0"})),U.createElement("linearGradient",{id:"paint11_linear_10246_159312",x1:"5.72266",y1:"10.9399",x2:"5.07979",y2:"9.68081",gradientUnits:"userSpaceOnUse"},U.createElement("stop",{offset:"0.376446",stopColor:"#FFC23E"}),U.createElement("stop",{offset:"1",stopColor:"#FFC23E",stopOpacity:"0"})),U.createElement("radialGradient",{id:"paint12_radial_10246_159312",cx:"0",cy:"0",r:"1",gradientUnits:"userSpaceOnUse",gradientTransform:"translate(3.32031 8.28125) rotate(85.0032) scale(7.17571 2.51091)"},U.createElement("stop",{stopColor:"#E6943A"}),U.createElement("stop",{offset:"1",stopColor:"#E7943A",stopOpacity:"0"})),U.createElement("radialGradient",{id:"paint13_radial_10246_159312",cx:"0",cy:"0",r:"1",gradientUnits:"userSpaceOnUse",gradientTransform:"translate(5.46875 6.17188) rotate(87.0391) scale(6.80596 1.61557)"},U.createElement("stop",{stopColor:"#FFCF50"}),U.createElement("stop",{offset:"0.741378",stopColor:"#FFB847"}),U.createElement("stop",{offset:"1",stopColor:"#FFB848",stopOpacity:"0"})),U.createElement("radialGradient",{id:"paint14_radial_10246_159312",cx:"0",cy:"0",r:"1",gradientUnits:"userSpaceOnUse",gradientTransform:"translate(6.69922 6.95312) rotate(85.2393) scale(4.00062 0.583904)"},U.createElement("stop",{stopColor:"#E79F08"}),U.createElement("stop",{offset:"1",stopColor:"#E79F08",stopOpacity:"0"})),U.createElement("radialGradient",{id:"paint15_radial_10246_159312",cx:"0",cy:"0",r:"1",gradientUnits:"userSpaceOnUse",gradientTransform:"translate(5.82031 7.76306) rotate(83.1071) scale(3.90579 0.814298)"},U.createElement("stop",{stopColor:"#FFD14D"}),U.createElement("stop",{offset:"1",stopColor:"#FFD04E",stopOpacity:"0"})),U.createElement("radialGradient",{id:"paint16_radial_10246_159312",cx:"0",cy:"0",r:"1",gradientUnits:"userSpaceOnUse",gradientTransform:"translate(6.69922 9.17969) rotate(136.548) scale(1.53355 0.783563)"},U.createElement("stop",{offset:"0.426346",stopColor:"#FFD260"}),U.createElement("stop",{offset:"1",stopColor:"#FFD361",stopOpacity:"0"})),U.createElement("radialGradient",{id:"paint17_radial_10246_159312",cx:"0",cy:"0",r:"1",gradientUnits:"userSpaceOnUse",gradientTransform:"translate(5.46875 5.48828) rotate(80.3401) scale(0.931172 0.709009)"},U.createElement("stop",{stopColor:"#FFDA62"}),U.createElement("stop",{offset:"1",stopColor:"#FFDA60",stopOpacity:"0"})),U.createElement("linearGradient",{id:"paint18_linear_10246_159312",x1:"6.05957",y1:"7.05618",x2:"7.26562",y2:"7.03125",gradientUnits:"userSpaceOnUse"},U.createElement("stop",{stopColor:"#DE890D"}),U.createElement("stop",{offset:"1",stopColor:"#F9B23D"})),U.createElement("linearGradient",{id:"paint19_linear_10246_159312",x1:"11.7919",y1:"10.3872",x2:"11.5711",y2:"7.83625",gradientUnits:"userSpaceOnUse"},U.createElement("stop",{offset:"0.405208",stopColor:"#FFC23E"}),U.createElement("stop",{offset:"1",stopColor:"#FFC23E",stopOpacity:"0"})),U.createElement("radialGradient",{id:"paint20_radial_10246_159312",cx:"0",cy:"0",r:"1",gradientUnits:"userSpaceOnUse",gradientTransform:"translate(9.90363 2.31009) rotate(56.3221) scale(2.85335 11.4486)"},U.createElement("stop",{stopColor:"#E1AE3F"}),U.createElement("stop",{offset:"1",stopColor:"#E8AD3C",stopOpacity:"0"})),U.createElement("radialGradient",{id:"paint21_radial_10246_159312",cx:"0",cy:"0",r:"1",gradientUnits:"userSpaceOnUse",gradientTransform:"translate(8.35938 5.19531) rotate(86.2538) scale(6.57655 1.44733)"},U.createElement("stop",{stopColor:"#FFCE4C"}),U.createElement("stop",{offset:"0.621882",stopColor:"#FFBA49"}),U.createElement("stop",{offset:"1",stopColor:"#FEB848",stopOpacity:"0"})),U.createElement("linearGradient",{id:"paint22_linear_10246_159312",x1:"8.0957",y1:"9.0918",x2:"7.91992",y2:"7.06055",gradientUnits:"userSpaceOnUse"},U.createElement("stop",{offset:"0.168836",stopColor:"#FFC23E"}),U.createElement("stop",{offset:"1",stopColor:"#FFC23E",stopOpacity:"0"})),U.createElement("radialGradient",{id:"paint23_radial_10246_159312",cx:"0",cy:"0",r:"1",gradientUnits:"userSpaceOnUse",gradientTransform:"translate(5.82031 5.97656) rotate(78.518) scale(5.10211 0.93429)"},U.createElement("stop",{offset:"0.425088",stopColor:"#BD6606"}),U.createElement("stop",{offset:"1",stopColor:"#C77122",stopOpacity:"0"})),U.createElement("radialGradient",{id:"paint24_radial_10246_159312",cx:"0",cy:"0",r:"1",gradientUnits:"userSpaceOnUse",gradientTransform:"translate(8.24219 5.89844) rotate(83.5653) scale(5.22825 0.629818)"},U.createElement("stop",{stopColor:"#FFCB4F"}),U.createElement("stop",{offset:"1",stopColor:"#FFCD4C",stopOpacity:"0"})),U.createElement("radialGradient",{id:"paint25_radial_10246_159312",cx:"0",cy:"0",r:"1",gradientUnits:"userSpaceOnUse",gradientTransform:"translate(9.29687 8.20313) rotate(154.799) scale(1.46784 0.851345)"},U.createElement("stop",{offset:"0.426346",stopColor:"#FFD260"}),U.createElement("stop",{offset:"1",stopColor:"#FFD361",stopOpacity:"0"})),U.createElement("radialGradient",{id:"paint26_radial_10246_159312",cx:"0",cy:"0",r:"1",gradientUnits:"userSpaceOnUse",gradientTransform:"translate(9.33594 4.98047) rotate(88.915) scale(5.15717 0.762321)"},U.createElement("stop",{offset:"0.342657",stopColor:"#E29E07"}),U.createElement("stop",{offset:"1",stopColor:"#DF9906",stopOpacity:"0"})),U.createElement("linearGradient",{id:"paint27_linear_10246_159312",x1:"9.14062",y1:"6.25",x2:"8.80978",y2:"6.26984",gradientUnits:"userSpaceOnUse"},U.createElement("stop",{stopColor:"#B76001"}),U.createElement("stop",{offset:"0.647059",stopColor:"#E59714",stopOpacity:"0"})),U.createElement("radialGradient",{id:"paint28_radial_10246_159312",cx:"0",cy:"0",r:"1",gradientUnits:"userSpaceOnUse",gradientTransform:"translate(8.125 3.51562) rotate(86.1859) scale(1.17448 1.07205)"},U.createElement("stop",{stopColor:"#FFDA62"}),U.createElement("stop",{offset:"1",stopColor:"#FFDA60",stopOpacity:"0"})),U.createElement("linearGradient",{id:"paint29_linear_10246_159312",x1:"9.0625",y1:"5.68143",x2:"10.5816",y2:"5.72531",gradientUnits:"userSpaceOnUse"},U.createElement("stop",{stopColor:"#D5850A"}),U.createElement("stop",{offset:"1",stopColor:"#F9B343",stopOpacity:"0"})),U.createElement("linearGradient",{id:"paint30_linear_10246_159312",x1:"9.0625",y1:"5.68143",x2:"9.55093",y2:"5.6712",gradientUnits:"userSpaceOnUse"},U.createElement("stop",{stopColor:"#B76001"}),U.createElement("stop",{offset:"1",stopColor:"#E59714",stopOpacity:"0"})),U.createElement("radialGradient",{id:"paint31_radial_10246_159312",cx:"0",cy:"0",r:"1",gradientUnits:"userSpaceOnUse",gradientTransform:"translate(11.3014 4.55861) rotate(90) scale(5.01272 0.983716)"},U.createElement("stop",{stopColor:"#FFCB45"}),U.createElement("stop",{offset:"1",stopColor:"#FFC44A",stopOpacity:"0"})),U.createElement("linearGradient",{id:"paint32_linear_10246_159312",x1:"10.0391",y1:"8.40332",x2:"10.0195",y2:"7.2461",gradientUnits:"userSpaceOnUse"},U.createElement("stop",{offset:"0.210964",stopColor:"#FFC23E"}),U.createElement("stop",{offset:"0.80669",stopColor:"#FFC23E",stopOpacity:"0"})),U.createElement("radialGradient",{id:"paint33_radial_10246_159312",cx:"0",cy:"0",r:"1",gradientUnits:"userSpaceOnUse",gradientTransform:"translate(11.7188 8.04687) rotate(166.996) scale(1.16638 0.888873)"},U.createElement("stop",{offset:"0.426346",stopColor:"#FFCA5B"}),U.createElement("stop",{offset:"1",stopColor:"#FFCF60",stopOpacity:"0"})),U.createElement("radialGradient",{id:"paint34_radial_10246_159312",cx:"0",cy:"0",r:"1",gradientUnits:"userSpaceOnUse",gradientTransform:"translate(11.9922 4.76563) rotate(92.1409) scale(4.18261 0.38546)"},U.createElement("stop",{offset:"0.342657",stopColor:"#E29E07"}),U.createElement("stop",{offset:"1",stopColor:"#DF9906",stopOpacity:"0"})),U.createElement("radialGradient",{id:"paint35_radial_10246_159312",cx:"0",cy:"0",r:"1",gradientUnits:"userSpaceOnUse",gradientTransform:"translate(10.9766 4.51172) rotate(90) scale(9.27734 1.28906)"},U.createElement("stop",{stopColor:"#FFCE4C"}),U.createElement("stop",{offset:"0.621882",stopColor:"#FFBA49"}),U.createElement("stop",{offset:"1",stopColor:"#FEB848",stopOpacity:"0"})),U.createElement("linearGradient",{id:"paint36_linear_10246_159312",x1:"12.3828",y1:"5.9375",x2:"11.6797",y2:"5.93971",gradientUnits:"userSpaceOnUse"},U.createElement("stop",{stopColor:"#E59714"}),U.createElement("stop",{offset:"1",stopColor:"#E59714",stopOpacity:"0"})),U.createElement("linearGradient",{id:"paint37_linear_10246_159312",x1:"10.0195",y1:"8.82935",x2:"10.2318",y2:"8.00715",gradientUnits:"userSpaceOnUse"},U.createElement("stop",{stopColor:"#FFC23E"}),U.createElement("stop",{offset:"1",stopColor:"#FFC23E",stopOpacity:"0"})),U.createElement("radialGradient",{id:"paint38_radial_10246_159312",cx:"0",cy:"0",r:"1",gradientUnits:"userSpaceOnUse",gradientTransform:"translate(12.2847 7.66848) rotate(-113.448) scale(6.85723 7.32906)"},U.createElement("stop",{offset:"0.869582",stopColor:"#D8A13D",stopOpacity:"0"}),U.createElement("stop",{offset:"1",stopColor:"#D8A13D"})),U.createElement("radialGradient",{id:"paint39_radial_10246_159312",cx:"0",cy:"0",r:"1",gradientUnits:"userSpaceOnUse",gradientTransform:"translate(11.2891 1.91406) rotate(93.0128) scale(1.48643 1.29895)"},U.createElement("stop",{stopColor:"#FFE763"}),U.createElement("stop",{offset:"1",stopColor:"#FFE55D",stopOpacity:"0"})),U.createElement("radialGradient",{id:"paint40_radial_10246_159312",cx:"0",cy:"0",r:"1",gradientUnits:"userSpaceOnUse",gradientTransform:"translate(11.8164 8.53516) rotate(168.022) scale(1.41758 0.903842)"},U.createElement("stop",{offset:"0.426346",stopColor:"#FFD260"}),U.createElement("stop",{offset:"1",stopColor:"#FFD361",stopOpacity:"0"})),U.createElement("radialGradient",{id:"paint41_radial_10246_159312",cx:"0",cy:"0",r:"1",gradientUnits:"userSpaceOnUse",gradientTransform:"translate(13.4766 5.89844) rotate(92.6574) scale(9.26778 2.30713)"},U.createElement("stop",{stopColor:"#FFCE4C"}),U.createElement("stop",{offset:"0.431711",stopColor:"#FFBA49"}),U.createElement("stop",{offset:"1",stopColor:"#FEB848",stopOpacity:"0"})),U.createElement("linearGradient",{id:"paint42_linear_10246_159312",x1:"11.5863",y1:"6.2696",x2:"13.5726",y2:"6.42645",gradientUnits:"userSpaceOnUse"},U.createElement("stop",{offset:"0.0662431",stopColor:"#E08F13"}),U.createElement("stop",{offset:"0.602743",stopColor:"#E7981B",stopOpacity:"0"})),U.createElement("linearGradient",{id:"paint43_linear_10246_159312",x1:"11.5863",y1:"6.2696",x2:"13.259",y2:"6.33379",gradientUnits:"userSpaceOnUse"},U.createElement("stop",{offset:"0.0662431",stopColor:"#C2681D"}),U.createElement("stop",{offset:"0.602743",stopColor:"#E69717",stopOpacity:"0"})),U.createElement("radialGradient",{id:"paint44_radial_10246_159312",cx:"0",cy:"0",r:"1",gradientUnits:"userSpaceOnUse",gradientTransform:"translate(14.9907 8.54439) rotate(-115.482) scale(6.44971 7.3339)"},U.createElement("stop",{offset:"0.869582",stopColor:"#D8A13D",stopOpacity:"0"}),U.createElement("stop",{offset:"1",stopColor:"#D8A13D"})),U.createElement("radialGradient",{id:"paint45_radial_10246_159312",cx:"0",cy:"0",r:"1",gradientUnits:"userSpaceOnUse",gradientTransform:"translate(14.0625 5.66406) rotate(91.8841) scale(5.94071 1.40501)"},U.createElement("stop",{stopColor:"#FFDC3F"}),U.createElement("stop",{offset:"1",stopColor:"#FFDA3C",stopOpacity:"0"})),U.createElement("radialGradient",{id:"paint46_radial_10246_159312",cx:"0",cy:"0",r:"1",gradientUnits:"userSpaceOnUse",gradientTransform:"translate(14.1016 3.51563) rotate(99.1412) scale(1.27667 1.12346)"},U.createElement("stop",{stopColor:"#FFE966"}),U.createElement("stop",{offset:"1",stopColor:"#FFE966",stopOpacity:"0"})),U.createElement("radialGradient",{id:"paint47_radial_10246_159312",cx:"0",cy:"0",r:"1",gradientUnits:"userSpaceOnUse",gradientTransform:"translate(11.7139 8.84766) rotate(124.509) scale(0.853264 2.02461)"},U.createElement("stop",{offset:"0.251132",stopColor:"#F0A623"}),U.createElement("stop",{offset:"1",stopColor:"#F2AA23",stopOpacity:"0"})),U.createElement("linearGradient",{id:"paint48_linear_10246_159312",x1:"13.877",y1:"10.0293",x2:"13.5547",y2:"9.05273",gradientUnits:"userSpaceOnUse"},U.createElement("stop",{offset:"0.0912498",stopColor:"#FFCD47"}),U.createElement("stop",{offset:"1",stopColor:"#FFCD52",stopOpacity:"0"})),U.createElement("radialGradient",{id:"paint49_radial_10246_159312",cx:"0",cy:"0",r:"1",gradientUnits:"userSpaceOnUse",gradientTransform:"translate(14.8059 9.14063) rotate(99.1613) scale(2.21576 0.860587)"},U.createElement("stop",{offset:"0.251132",stopColor:"#D69211"}),U.createElement("stop",{offset:"1",stopColor:"#DAA23E",stopOpacity:"0"}))),U.createElement("path",{d:"M10.4435 1.23817C11.6481 1.06813 12.2265 2.26542 12.08 3.30216C12.3425 2.83259 12.7902 2.56116 13.3593 2.57808C14.1793 2.60246 14.83 3.32606 14.8046 4.15738L14.5986 9.26659L15.4927 8.14205C16.0297 7.46657 17.0049 7.3596 17.6721 7.90298C18.3408 8.44763 18.4466 9.43906 17.9083 10.1161L17.5242 10.5991L17.5205 10.6047C17.1674 11.0632 16.4446 12.0018 15.5377 13.5195C15.2451 13.9644 14.991 14.4396 14.7373 14.9139C14.3755 15.5904 14.0146 16.2651 13.5446 16.8478C12.6103 18.0157 11.2012 18.7207 9.41406 18.7207C7.46969 18.7207 5.96858 17.7407 5.06836 16.2598C4.39645 15.1544 4.09135 13.756 4.01367 12.3535C3.90459 10.384 3.64472 8.30425 3.52479 6.33789C3.46522 5.36133 4.03401 4.62819 4.82415 4.58984C5.43983 4.55997 5.83432 4.75144 6.11318 5.06836C6.11318 5.06836 6.05957 4.77051 6.05957 4.15738C6.05957 3.54425 6.58827 2.73728 7.41201 2.67578C8.7206 2.57808 8.93545 3.65234 9.0624 4.15738C9.08953 3.10816 8.83779 1.46464 10.4435 1.23817Z",fill:"#FFC23E"}),U.createElement("path",{d:"M10.4435 1.23817C11.6481 1.06813 12.2265 2.26542 12.08 3.30216C12.3425 2.83259 12.7902 2.56116 13.3593 2.57808C14.1793 2.60246 14.83 3.32606 14.8046 4.15738L14.5986 9.26659L15.4927 8.14205C16.0297 7.46657 17.0049 7.3596 17.6721 7.90298C18.3408 8.44763 18.4466 9.43906 17.9083 10.1161L17.5242 10.5991L17.5205 10.6047C17.1674 11.0632 16.4446 12.0018 15.5377 13.5195C15.2451 13.9644 14.991 14.4396 14.7373 14.9139C14.3755 15.5904 14.0146 16.2651 13.5446 16.8478C12.6103 18.0157 11.2012 18.7207 9.41406 18.7207C7.46969 18.7207 5.96858 17.7407 5.06836 16.2598C4.39645 15.1544 4.09135 13.756 4.01367 12.3535C3.90459 10.384 3.64472 8.30425 3.52479 6.33789C3.46522 5.36133 4.03401 4.62819 4.82415 4.58984C5.43983 4.55997 5.83432 4.75144 6.11318 5.06836C6.11318 5.06836 6.05957 4.77051 6.05957 4.15738C6.05957 3.54425 6.58827 2.73728 7.41201 2.67578C8.7206 2.57808 8.93545 3.65234 9.0624 4.15738C9.08953 3.10816 8.83779 1.46464 10.4435 1.23817Z",fill:"url(#paint0_radial_10246_159312)"}),U.createElement("path",{d:"M10.4435 1.23817C11.6481 1.06813 12.2265 2.26542 12.08 3.30216C12.3425 2.83259 12.7902 2.56116 13.3593 2.57808C14.1793 2.60246 14.83 3.32606 14.8046 4.15738L14.5986 9.26659L15.4927 8.14205C16.0297 7.46657 17.0049 7.3596 17.6721 7.90298C18.3408 8.44763 18.4466 9.43906 17.9083 10.1161L17.5242 10.5991L17.5205 10.6047C17.1674 11.0632 16.4446 12.0018 15.5377 13.5195C15.2451 13.9644 14.991 14.4396 14.7373 14.9139C14.3755 15.5904 14.0146 16.2651 13.5446 16.8478C12.6103 18.0157 11.2012 18.7207 9.41406 18.7207C7.46969 18.7207 5.96858 17.7407 5.06836 16.2598C4.39645 15.1544 4.09135 13.756 4.01367 12.3535C3.90459 10.384 3.64472 8.30425 3.52479 6.33789C3.46522 5.36133 4.03401 4.62819 4.82415 4.58984C5.43983 4.55997 5.83432 4.75144 6.11318 5.06836C6.11318 5.06836 6.05957 4.77051 6.05957 4.15738C6.05957 3.54425 6.58827 2.73728 7.41201 2.67578C8.7206 2.57808 8.93545 3.65234 9.0624 4.15738C9.08953 3.10816 8.83779 1.46464 10.4435 1.23817Z",fill:"url(#paint1_radial_10246_159312)"}),U.createElement("path",{d:"M10.4435 1.23817C11.6481 1.06813 12.2265 2.26542 12.08 3.30216C12.3425 2.83259 12.7902 2.56116 13.3593 2.57808C14.1793 2.60246 14.83 3.32606 14.8046 4.15738L14.5986 9.26659L15.4927 8.14205C16.0297 7.46657 17.0049 7.3596 17.6721 7.90298C18.3408 8.44763 18.4466 9.43906 17.9083 10.1161L17.5242 10.5991L17.5205 10.6047C17.1674 11.0632 16.4446 12.0018 15.5377 13.5195C15.2451 13.9644 14.991 14.4396 14.7373 14.9139C14.3755 15.5904 14.0146 16.2651 13.5446 16.8478C12.6103 18.0157 11.2012 18.7207 9.41406 18.7207C7.46969 18.7207 5.96858 17.7407 5.06836 16.2598C4.39645 15.1544 4.09135 13.756 4.01367 12.3535C3.90459 10.384 3.64472 8.30425 3.52479 6.33789C3.46522 5.36133 4.03401 4.62819 4.82415 4.58984C5.43983 4.55997 5.83432 4.75144 6.11318 5.06836C6.11318 5.06836 6.05957 4.77051 6.05957 4.15738C6.05957 3.54425 6.58827 2.73728 7.41201 2.67578C8.7206 2.57808 8.93545 3.65234 9.0624 4.15738C9.08953 3.10816 8.83779 1.46464 10.4435 1.23817Z",fill:"url(#paint2_radial_10246_159312)"}),U.createElement("path",{d:"M10.4435 1.23817C11.6481 1.06813 12.2265 2.26542 12.08 3.30216C12.3425 2.83259 12.7902 2.56116 13.3593 2.57808C14.1793 2.60246 14.83 3.32606 14.8046 4.15738L14.5986 9.26659L15.4927 8.14205C16.0297 7.46657 17.0049 7.3596 17.6721 7.90298C18.3408 8.44763 18.4466 9.43906 17.9083 10.1161L17.5242 10.5991L17.5205 10.6047C17.1674 11.0632 16.4446 12.0018 15.5377 13.5195C15.2451 13.9644 14.991 14.4396 14.7373 14.9139C14.3755 15.5904 14.0146 16.2651 13.5446 16.8478C12.6103 18.0157 11.2012 18.7207 9.41406 18.7207C7.46969 18.7207 5.96858 17.7407 5.06836 16.2598C4.39645 15.1544 4.09135 13.756 4.01367 12.3535C3.90459 10.384 3.64472 8.30425 3.52479 6.33789C3.46522 5.36133 4.03401 4.62819 4.82415 4.58984C5.43983 4.55997 5.83432 4.75144 6.11318 5.06836C6.11318 5.06836 6.05957 4.77051 6.05957 4.15738C6.05957 3.54425 6.58827 2.73728 7.41201 2.67578C8.7206 2.57808 8.93545 3.65234 9.0624 4.15738C9.08953 3.10816 8.83779 1.46464 10.4435 1.23817Z",fill:"url(#paint3_radial_10246_159312)"}),U.createElement("path",{d:"M10.4435 1.23817C11.6481 1.06813 12.2265 2.26542 12.08 3.30216C12.3425 2.83259 12.7902 2.56116 13.3593 2.57808C14.1793 2.60246 14.83 3.32606 14.8046 4.15738L14.5986 9.26659L15.4927 8.14205C16.0297 7.46657 17.0049 7.3596 17.6721 7.90298C18.3408 8.44763 18.4466 9.43906 17.9083 10.1161L17.5242 10.5991L17.5205 10.6047C17.1674 11.0632 16.4446 12.0018 15.5377 13.5195C15.2451 13.9644 14.991 14.4396 14.7373 14.9139C14.3755 15.5904 14.0146 16.2651 13.5446 16.8478C12.6103 18.0157 11.2012 18.7207 9.41406 18.7207C7.46969 18.7207 5.96858 17.7407 5.06836 16.2598C4.39645 15.1544 4.09135 13.756 4.01367 12.3535C3.90459 10.384 3.64472 8.30425 3.52479 6.33789C3.46522 5.36133 4.03401 4.62819 4.82415 4.58984C5.43983 4.55997 5.83432 4.75144 6.11318 5.06836C6.11318 5.06836 6.05957 4.77051 6.05957 4.15738C6.05957 3.54425 6.58827 2.73728 7.41201 2.67578C8.7206 2.57808 8.93545 3.65234 9.0624 4.15738C9.08953 3.10816 8.83779 1.46464 10.4435 1.23817Z",fill:"url(#paint4_radial_10246_159312)"}),U.createElement("path",{d:"M10.4435 1.23817C11.6481 1.06813 12.2265 2.26542 12.08 3.30216C12.3425 2.83259 12.7902 2.56116 13.3593 2.57808C14.1793 2.60246 14.83 3.32606 14.8046 4.15738L14.5986 9.26659L15.4927 8.14205C16.0297 7.46657 17.0049 7.3596 17.6721 7.90298C18.3408 8.44763 18.4466 9.43906 17.9083 10.1161L17.5242 10.5991L17.5205 10.6047C17.1674 11.0632 16.4446 12.0018 15.5377 13.5195C15.2451 13.9644 14.991 14.4396 14.7373 14.9139C14.3755 15.5904 14.0146 16.2651 13.5446 16.8478C12.6103 18.0157 11.2012 18.7207 9.41406 18.7207C7.46969 18.7207 5.96858 17.7407 5.06836 16.2598C4.39645 15.1544 4.09135 13.756 4.01367 12.3535C3.90459 10.384 3.64472 8.30425 3.52479 6.33789C3.46522 5.36133 4.03401 4.62819 4.82415 4.58984C5.43983 4.55997 5.83432 4.75144 6.11318 5.06836C6.11318 5.06836 6.05957 4.77051 6.05957 4.15738C6.05957 3.54425 6.58827 2.73728 7.41201 2.67578C8.7206 2.57808 8.93545 3.65234 9.0624 4.15738C9.08953 3.10816 8.83779 1.46464 10.4435 1.23817Z",fill:"url(#paint5_radial_10246_159312)"}),U.createElement("path",{d:"M10.4435 1.23817C11.6481 1.06813 12.2265 2.26542 12.08 3.30216C12.3425 2.83259 12.7902 2.56116 13.3593 2.57808C14.1793 2.60246 14.83 3.32606 14.8046 4.15738L14.5986 9.26659L15.4927 8.14205C16.0297 7.46657 17.0049 7.3596 17.6721 7.90298C18.3408 8.44763 18.4466 9.43906 17.9083 10.1161L17.5242 10.5991L17.5205 10.6047C17.1674 11.0632 16.4446 12.0018 15.5377 13.5195C15.2451 13.9644 14.991 14.4396 14.7373 14.9139C14.3755 15.5904 14.0146 16.2651 13.5446 16.8478C12.6103 18.0157 11.2012 18.7207 9.41406 18.7207C7.46969 18.7207 5.96858 17.7407 5.06836 16.2598C4.39645 15.1544 4.09135 13.756 4.01367 12.3535C3.90459 10.384 3.64472 8.30425 3.52479 6.33789C3.46522 5.36133 4.03401 4.62819 4.82415 4.58984C5.43983 4.55997 5.83432 4.75144 6.11318 5.06836C6.11318 5.06836 6.05957 4.77051 6.05957 4.15738C6.05957 3.54425 6.58827 2.73728 7.41201 2.67578C8.7206 2.57808 8.93545 3.65234 9.0624 4.15738C9.08953 3.10816 8.83779 1.46464 10.4435 1.23817Z",fill:"url(#paint6_radial_10246_159312)"}),U.createElement("path",{d:"M10.4435 1.23817C11.6481 1.06813 12.2265 2.26542 12.08 3.30216C12.3425 2.83259 12.7902 2.56116 13.3593 2.57808C14.1793 2.60246 14.83 3.32606 14.8046 4.15738L14.5986 9.26659L15.4927 8.14205C16.0297 7.46657 17.0049 7.3596 17.6721 7.90298C18.3408 8.44763 18.4466 9.43906 17.9083 10.1161L17.5242 10.5991L17.5205 10.6047C17.1674 11.0632 16.4446 12.0018 15.5377 13.5195C15.2451 13.9644 14.991 14.4396 14.7373 14.9139C14.3755 15.5904 14.0146 16.2651 13.5446 16.8478C12.6103 18.0157 11.2012 18.7207 9.41406 18.7207C7.46969 18.7207 5.96858 17.7407 5.06836 16.2598C4.39645 15.1544 4.09135 13.756 4.01367 12.3535C3.90459 10.384 3.64472 8.30425 3.52479 6.33789C3.46522 5.36133 4.03401 4.62819 4.82415 4.58984C5.43983 4.55997 5.83432 4.75144 6.11318 5.06836C6.11318 5.06836 6.05957 4.77051 6.05957 4.15738C6.05957 3.54425 6.58827 2.73728 7.41201 2.67578C8.7206 2.57808 8.93545 3.65234 9.0624 4.15738C9.08953 3.10816 8.83779 1.46464 10.4435 1.23817Z",fill:"url(#paint7_radial_10246_159312)"}),U.createElement("path",{d:"M10.4435 1.23817C11.6481 1.06813 12.2265 2.26542 12.08 3.30216C12.3425 2.83259 12.7902 2.56116 13.3593 2.57808C14.1793 2.60246 14.83 3.32606 14.8046 4.15738L14.5986 9.26659L15.4927 8.14205C16.0297 7.46657 17.0049 7.3596 17.6721 7.90298C18.3408 8.44763 18.4466 9.43906 17.9083 10.1161L17.5242 10.5991L17.5205 10.6047C17.1674 11.0632 16.4446 12.0018 15.5377 13.5195C15.2451 13.9644 14.991 14.4396 14.7373 14.9139C14.3755 15.5904 14.0146 16.2651 13.5446 16.8478C12.6103 18.0157 11.2012 18.7207 9.41406 18.7207C7.46969 18.7207 5.96858 17.7407 5.06836 16.2598C4.39645 15.1544 4.09135 13.756 4.01367 12.3535C3.90459 10.384 3.64472 8.30425 3.52479 6.33789C3.46522 5.36133 4.03401 4.62819 4.82415 4.58984C5.43983 4.55997 5.83432 4.75144 6.11318 5.06836C6.11318 5.06836 6.05957 4.77051 6.05957 4.15738C6.05957 3.54425 6.58827 2.73728 7.41201 2.67578C8.7206 2.57808 8.93545 3.65234 9.0624 4.15738C9.08953 3.10816 8.83779 1.46464 10.4435 1.23817Z",fill:"url(#paint8_radial_10246_159312)"}),U.createElement("path",{d:"M10.4435 1.23817C11.6481 1.06813 12.2265 2.26542 12.08 3.30216C12.3425 2.83259 12.7902 2.56116 13.3593 2.57808C14.1793 2.60246 14.83 3.32606 14.8046 4.15738L14.5986 9.26659L15.4927 8.14205C16.0297 7.46657 17.0049 7.3596 17.6721 7.90298C18.3408 8.44763 18.4466 9.43906 17.9083 10.1161L17.5242 10.5991L17.5205 10.6047C17.1674 11.0632 16.4446 12.0018 15.5377 13.5195C15.2451 13.9644 14.991 14.4396 14.7373 14.9139C14.3755 15.5904 14.0146 16.2651 13.5446 16.8478C12.6103 18.0157 11.2012 18.7207 9.41406 18.7207C7.46969 18.7207 5.96858 17.7407 5.06836 16.2598C4.39645 15.1544 4.09135 13.756 4.01367 12.3535C3.90459 10.384 3.64472 8.30425 3.52479 6.33789C3.46522 5.36133 4.03401 4.62819 4.82415 4.58984C5.43983 4.55997 5.83432 4.75144 6.11318 5.06836C6.11318 5.06836 6.05957 4.77051 6.05957 4.15738C6.05957 3.54425 6.58827 2.73728 7.41201 2.67578C8.7206 2.57808 8.93545 3.65234 9.0624 4.15738C9.08953 3.10816 8.83779 1.46464 10.4435 1.23817Z",fill:"url(#paint9_radial_10246_159312)"}),U.createElement("path",{d:"M10.4435 1.23817C11.6481 1.06813 12.2265 2.26542 12.08 3.30216C12.3425 2.83259 12.7902 2.56116 13.3593 2.57808C14.1793 2.60246 14.83 3.32606 14.8046 4.15738L14.5986 9.26659L15.4927 8.14205C16.0297 7.46657 17.0049 7.3596 17.6721 7.90298C18.3408 8.44763 18.4466 9.43906 17.9083 10.1161L17.5242 10.5991L17.5205 10.6047C17.1674 11.0632 16.4446 12.0018 15.5377 13.5195C15.2451 13.9644 14.991 14.4396 14.7373 14.9139C14.3755 15.5904 14.0146 16.2651 13.5446 16.8478C12.6103 18.0157 11.2012 18.7207 9.41406 18.7207C7.46969 18.7207 5.96858 17.7407 5.06836 16.2598C4.39645 15.1544 4.09135 13.756 4.01367 12.3535C3.90459 10.384 3.64472 8.30425 3.52479 6.33789C3.46522 5.36133 4.03401 4.62819 4.82415 4.58984C5.43983 4.55997 5.83432 4.75144 6.11318 5.06836C6.11318 5.06836 6.05957 4.77051 6.05957 4.15738C6.05957 3.54425 6.58827 2.73728 7.41201 2.67578C8.7206 2.57808 8.93545 3.65234 9.0624 4.15738C9.08953 3.10816 8.83779 1.46464 10.4435 1.23817Z",fill:"url(#paint10_radial_10246_159312)"}),U.createElement("path",{d:"M3.52479 6.33728C3.46522 5.36072 4.03401 4.62758 4.82415 4.58924C5.43983 4.55936 5.83432 4.75084 6.11318 5.06775C6.20599 5.20142 6.40332 5.6084 6.4502 6.16699C6.49707 6.72559 6.63574 8.10547 6.69922 8.72559C6.66584 9.373 6.06222 10.7221 3.91477 10.9394C3.78945 9.4056 3.61634 7.8384 3.52479 6.33728Z",fill:"#FFC23E"}),U.createElement("path",{d:"M3.52479 6.33728C3.46522 5.36072 4.03401 4.62758 4.82415 4.58924C5.43983 4.55936 5.83432 4.75084 6.11318 5.06775C6.20599 5.20142 6.40332 5.6084 6.4502 6.16699C6.49707 6.72559 6.63574 8.10547 6.69922 8.72559C6.66584 9.373 6.06222 10.7221 3.91477 10.9394C3.78945 9.4056 3.61634 7.8384 3.52479 6.33728Z",fill:"url(#paint11_linear_10246_159312)"}),U.createElement("path",{d:"M3.52479 6.33728C3.46522 5.36072 4.03401 4.62758 4.82415 4.58924C5.43983 4.55936 5.83432 4.75084 6.11318 5.06775C6.20599 5.20142 6.40332 5.6084 6.4502 6.16699C6.49707 6.72559 6.63574 8.10547 6.69922 8.72559C6.66584 9.373 6.06222 10.7221 3.91477 10.9394C3.78945 9.4056 3.61634 7.8384 3.52479 6.33728Z",fill:"url(#paint12_radial_10246_159312)"}),U.createElement("path",{d:"M3.52479 6.33728C3.46522 5.36072 4.03401 4.62758 4.82415 4.58924C5.43983 4.55936 5.83432 4.75084 6.11318 5.06775C6.20599 5.20142 6.40332 5.6084 6.4502 6.16699C6.49707 6.72559 6.63574 8.10547 6.69922 8.72559C6.66584 9.373 6.06222 10.7221 3.91477 10.9394C3.78945 9.4056 3.61634 7.8384 3.52479 6.33728Z",fill:"url(#paint13_radial_10246_159312)"}),U.createElement("path",{d:"M3.52479 6.33728C3.46522 5.36072 4.03401 4.62758 4.82415 4.58924C5.43983 4.55936 5.83432 4.75084 6.11318 5.06775C6.20599 5.20142 6.40332 5.6084 6.4502 6.16699C6.49707 6.72559 6.63574 8.10547 6.69922 8.72559C6.66584 9.373 6.06222 10.7221 3.91477 10.9394C3.78945 9.4056 3.61634 7.8384 3.52479 6.33728Z",fill:"url(#paint14_radial_10246_159312)"}),U.createElement("path",{d:"M3.52479 6.33728C3.46522 5.36072 4.03401 4.62758 4.82415 4.58924C5.43983 4.55936 5.83432 4.75084 6.11318 5.06775C6.20599 5.20142 6.40332 5.6084 6.4502 6.16699C6.49707 6.72559 6.63574 8.10547 6.69922 8.72559C6.66584 9.373 6.06222 10.7221 3.91477 10.9394C3.78945 9.4056 3.61634 7.8384 3.52479 6.33728Z",fill:"url(#paint15_radial_10246_159312)"}),U.createElement("path",{d:"M3.52479 6.33728C3.46522 5.36072 4.03401 4.62758 4.82415 4.58924C5.43983 4.55936 5.83432 4.75084 6.11318 5.06775C6.20599 5.20142 6.40332 5.6084 6.4502 6.16699C6.49707 6.72559 6.63574 8.10547 6.69922 8.72559C6.66584 9.373 6.06222 10.7221 3.91477 10.9394C3.78945 9.4056 3.61634 7.8384 3.52479 6.33728Z",fill:"url(#paint16_radial_10246_159312)"}),U.createElement("path",{d:"M3.52479 6.33728C3.46522 5.36072 4.03401 4.62758 4.82415 4.58924C5.43983 4.55936 5.83432 4.75084 6.11318 5.06775C6.20599 5.20142 6.40332 5.6084 6.4502 6.16699C6.49707 6.72559 6.63574 8.10547 6.69922 8.72559C6.66584 9.373 6.06222 10.7221 3.91477 10.9394C3.78945 9.4056 3.61634 7.8384 3.52479 6.33728Z",fill:"url(#paint17_radial_10246_159312)"}),U.createElement("path",{d:"M6.11318 5.0685C6.11318 5.0685 6.05957 4.77065 6.05957 4.15752C6.05957 3.54439 6.58827 2.73742 7.41201 2.67592C8.7206 2.57821 8.93545 3.65248 9.0624 4.15752L9.19922 7.71484C9.08203 8.04036 8.67578 8.74219 7.98828 8.94531C7.30078 9.14844 6.82943 8.86068 6.67969 8.69141C6.60156 7.89062 6.4375 6.20312 6.40625 5.85938C6.375 5.51562 6.19785 5.18889 6.11318 5.0685Z",fill:"#FFC23E"}),U.createElement("path",{d:"M6.11318 5.0685C6.11318 5.0685 6.05957 4.77065 6.05957 4.15752C6.05957 3.54439 6.58827 2.73742 7.41201 2.67592C8.7206 2.57821 8.93545 3.65248 9.0624 4.15752L9.19922 7.71484C9.08203 8.04036 8.67578 8.74219 7.98828 8.94531C7.30078 9.14844 6.82943 8.86068 6.67969 8.69141C6.60156 7.89062 6.4375 6.20312 6.40625 5.85938C6.375 5.51562 6.19785 5.18889 6.11318 5.0685Z",fill:"url(#paint18_linear_10246_159312)"}),U.createElement("path",{d:"M6.11318 5.0685C6.11318 5.0685 6.05957 4.77065 6.05957 4.15752C6.05957 3.54439 6.58827 2.73742 7.41201 2.67592C8.7206 2.57821 8.93545 3.65248 9.0624 4.15752L9.19922 7.71484C9.08203 8.04036 8.67578 8.74219 7.98828 8.94531C7.30078 9.14844 6.82943 8.86068 6.67969 8.69141C6.60156 7.89062 6.4375 6.20312 6.40625 5.85938C6.375 5.51562 6.19785 5.18889 6.11318 5.0685Z",fill:"url(#paint19_linear_10246_159312)"}),U.createElement("path",{d:"M6.11318 5.0685C6.11318 5.0685 6.05957 4.77065 6.05957 4.15752C6.05957 3.54439 6.58827 2.73742 7.41201 2.67592C8.7206 2.57821 8.93545 3.65248 9.0624 4.15752L9.19922 7.71484C9.08203 8.04036 8.67578 8.74219 7.98828 8.94531C7.30078 9.14844 6.82943 8.86068 6.67969 8.69141C6.60156 7.89062 6.4375 6.20312 6.40625 5.85938C6.375 5.51562 6.19785 5.18889 6.11318 5.0685Z",fill:"url(#paint20_radial_10246_159312)"}),U.createElement("path",{d:"M6.11318 5.0685C6.11318 5.0685 6.05957 4.77065 6.05957 4.15752C6.05957 3.54439 6.58827 2.73742 7.41201 2.67592C8.7206 2.57821 8.93545 3.65248 9.0624 4.15752L9.19922 7.71484C9.08203 8.04036 8.67578 8.74219 7.98828 8.94531C7.30078 9.14844 6.82943 8.86068 6.67969 8.69141C6.60156 7.89062 6.4375 6.20312 6.40625 5.85938C6.375 5.51562 6.19785 5.18889 6.11318 5.0685Z",fill:"url(#paint21_radial_10246_159312)"}),U.createElement("path",{d:"M6.11318 5.0685C6.11318 5.0685 6.05957 4.77065 6.05957 4.15752C6.05957 3.54439 6.58827 2.73742 7.41201 2.67592C8.7206 2.57821 8.93545 3.65248 9.0624 4.15752L9.19922 7.71484C9.08203 8.04036 8.67578 8.74219 7.98828 8.94531C7.30078 9.14844 6.82943 8.86068 6.67969 8.69141C6.60156 7.89062 6.4375 6.20312 6.40625 5.85938C6.375 5.51562 6.19785 5.18889 6.11318 5.0685Z",fill:"url(#paint22_linear_10246_159312)"}),U.createElement("path",{d:"M6.11318 5.0685C6.11318 5.0685 6.05957 4.77065 6.05957 4.15752C6.05957 3.54439 6.58827 2.73742 7.41201 2.67592C8.7206 2.57821 8.93545 3.65248 9.0624 4.15752L9.19922 7.71484C9.08203 8.04036 8.67578 8.74219 7.98828 8.94531C7.30078 9.14844 6.82943 8.86068 6.67969 8.69141C6.60156 7.89062 6.4375 6.20312 6.40625 5.85938C6.375 5.51562 6.19785 5.18889 6.11318 5.0685Z",fill:"url(#paint23_radial_10246_159312)"}),U.createElement("path",{d:"M6.11318 5.0685C6.11318 5.0685 6.05957 4.77065 6.05957 4.15752C6.05957 3.54439 6.58827 2.73742 7.41201 2.67592C8.7206 2.57821 8.93545 3.65248 9.0624 4.15752L9.19922 7.71484C9.08203 8.04036 8.67578 8.74219 7.98828 8.94531C7.30078 9.14844 6.82943 8.86068 6.67969 8.69141C6.60156 7.89062 6.4375 6.20312 6.40625 5.85938C6.375 5.51562 6.19785 5.18889 6.11318 5.0685Z",fill:"url(#paint24_radial_10246_159312)"}),U.createElement("path",{d:"M6.11318 5.0685C6.11318 5.0685 6.05957 4.77065 6.05957 4.15752C6.05957 3.54439 6.58827 2.73742 7.41201 2.67592C8.7206 2.57821 8.93545 3.65248 9.0624 4.15752L9.19922 7.71484C9.08203 8.04036 8.67578 8.74219 7.98828 8.94531C7.30078 9.14844 6.82943 8.86068 6.67969 8.69141C6.60156 7.89062 6.4375 6.20312 6.40625 5.85938C6.375 5.51562 6.19785 5.18889 6.11318 5.0685Z",fill:"url(#paint25_radial_10246_159312)"}),U.createElement("path",{d:"M6.11318 5.0685C6.11318 5.0685 6.05957 4.77065 6.05957 4.15752C6.05957 3.54439 6.58827 2.73742 7.41201 2.67592C8.7206 2.57821 8.93545 3.65248 9.0624 4.15752L9.19922 7.71484C9.08203 8.04036 8.67578 8.74219 7.98828 8.94531C7.30078 9.14844 6.82943 8.86068 6.67969 8.69141C6.60156 7.89062 6.4375 6.20312 6.40625 5.85938C6.375 5.51562 6.19785 5.18889 6.11318 5.0685Z",fill:"url(#paint26_radial_10246_159312)"}),U.createElement("path",{d:"M6.11318 5.0685C6.11318 5.0685 6.05957 4.77065 6.05957 4.15752C6.05957 3.54439 6.58827 2.73742 7.41201 2.67592C8.7206 2.57821 8.93545 3.65248 9.0624 4.15752L9.19922 7.71484C9.08203 8.04036 8.67578 8.74219 7.98828 8.94531C7.30078 9.14844 6.82943 8.86068 6.67969 8.69141C6.60156 7.89062 6.4375 6.20312 6.40625 5.85938C6.375 5.51562 6.19785 5.18889 6.11318 5.0685Z",fill:"url(#paint27_linear_10246_159312)"}),U.createElement("path",{d:"M6.11318 5.0685C6.11318 5.0685 6.05957 4.77065 6.05957 4.15752C6.05957 3.54439 6.58827 2.73742 7.41201 2.67592C8.7206 2.57821 8.93545 3.65248 9.0624 4.15752L9.19922 7.71484C9.08203 8.04036 8.67578 8.74219 7.98828 8.94531C7.30078 9.14844 6.82943 8.86068 6.67969 8.69141C6.60156 7.89062 6.4375 6.20312 6.40625 5.85938C6.375 5.51562 6.19785 5.18889 6.11318 5.0685Z",fill:"url(#paint28_radial_10246_159312)"}),U.createElement("path",{d:"M10.4437 1.23817C11.6483 1.06813 12.2267 2.26542 12.0802 3.30216C11.9943 3.45951 11.9337 3.79649 11.9141 3.94531L11.6992 8.10547C10.8008 9.25781 9.53125 8.96484 9.17969 7.71484L9.0626 4.15738C9.08973 3.10816 8.83799 1.46464 10.4437 1.23817Z",fill:"#FFC23E"}),U.createElement("path",{d:"M10.4437 1.23817C11.6483 1.06813 12.2267 2.26542 12.0802 3.30216C11.9943 3.45951 11.9337 3.79649 11.9141 3.94531L11.6992 8.10547C10.8008 9.25781 9.53125 8.96484 9.17969 7.71484L9.0626 4.15738C9.08973 3.10816 8.83799 1.46464 10.4437 1.23817Z",fill:"url(#paint29_linear_10246_159312)"}),U.createElement("path",{d:"M10.4437 1.23817C11.6483 1.06813 12.2267 2.26542 12.0802 3.30216C11.9943 3.45951 11.9337 3.79649 11.9141 3.94531L11.6992 8.10547C10.8008 9.25781 9.53125 8.96484 9.17969 7.71484L9.0626 4.15738C9.08973 3.10816 8.83799 1.46464 10.4437 1.23817Z",fill:"url(#paint30_linear_10246_159312)"}),U.createElement("path",{d:"M10.4437 1.23817C11.6483 1.06813 12.2267 2.26542 12.0802 3.30216C11.9943 3.45951 11.9337 3.79649 11.9141 3.94531L11.6992 8.10547C10.8008 9.25781 9.53125 8.96484 9.17969 7.71484L9.0626 4.15738C9.08973 3.10816 8.83799 1.46464 10.4437 1.23817Z",fill:"url(#paint31_radial_10246_159312)"}),U.createElement("path",{d:"M10.4437 1.23817C11.6483 1.06813 12.2267 2.26542 12.0802 3.30216C11.9943 3.45951 11.9337 3.79649 11.9141 3.94531L11.6992 8.10547C10.8008 9.25781 9.53125 8.96484 9.17969 7.71484L9.0626 4.15738C9.08973 3.10816 8.83799 1.46464 10.4437 1.23817Z",fill:"url(#paint32_linear_10246_159312)"}),U.createElement("path",{d:"M10.4437 1.23817C11.6483 1.06813 12.2267 2.26542 12.0802 3.30216C11.9943 3.45951 11.9337 3.79649 11.9141 3.94531L11.6992 8.10547C10.8008 9.25781 9.53125 8.96484 9.17969 7.71484L9.0626 4.15738C9.08973 3.10816 8.83799 1.46464 10.4437 1.23817Z",fill:"url(#paint33_radial_10246_159312)"}),U.createElement("path",{d:"M10.4437 1.23817C11.6483 1.06813 12.2267 2.26542 12.0802 3.30216C11.9943 3.45951 11.9337 3.79649 11.9141 3.94531L11.6992 8.10547C10.8008 9.25781 9.53125 8.96484 9.17969 7.71484L9.0626 4.15738C9.08973 3.10816 8.83799 1.46464 10.4437 1.23817Z",fill:"url(#paint34_radial_10246_159312)"}),U.createElement("path",{d:"M10.4437 1.23817C11.6483 1.06813 12.2267 2.26542 12.0802 3.30216C11.9943 3.45951 11.9337 3.79649 11.9141 3.94531L11.6992 8.10547C10.8008 9.25781 9.53125 8.96484 9.17969 7.71484L9.0626 4.15738C9.08973 3.10816 8.83799 1.46464 10.4437 1.23817Z",fill:"url(#paint35_radial_10246_159312)"}),U.createElement("path",{d:"M10.4437 1.23817C11.6483 1.06813 12.2267 2.26542 12.0802 3.30216C11.9943 3.45951 11.9337 3.79649 11.9141 3.94531L11.6992 8.10547C10.8008 9.25781 9.53125 8.96484 9.17969 7.71484L9.0626 4.15738C9.08973 3.10816 8.83799 1.46464 10.4437 1.23817Z",fill:"url(#paint36_linear_10246_159312)"}),U.createElement("path",{d:"M10.4437 1.23817C11.6483 1.06813 12.2267 2.26542 12.0802 3.30216C11.9943 3.45951 11.9337 3.79649 11.9141 3.94531L11.6992 8.10547C10.8008 9.25781 9.53125 8.96484 9.17969 7.71484L9.0626 4.15738C9.08973 3.10816 8.83799 1.46464 10.4437 1.23817Z",fill:"url(#paint37_linear_10246_159312)"}),U.createElement("path",{d:"M10.4437 1.23817C11.6483 1.06813 12.2267 2.26542 12.0802 3.30216C11.9943 3.45951 11.9337 3.79649 11.9141 3.94531L11.6992 8.10547C10.8008 9.25781 9.53125 8.96484 9.17969 7.71484L9.0626 4.15738C9.08973 3.10816 8.83799 1.46464 10.4437 1.23817Z",fill:"url(#paint38_radial_10246_159312)"}),U.createElement("path",{d:"M10.4437 1.23817C11.6483 1.06813 12.2267 2.26542 12.0802 3.30216C11.9943 3.45951 11.9337 3.79649 11.9141 3.94531L11.6992 8.10547C10.8008 9.25781 9.53125 8.96484 9.17969 7.71484L9.0626 4.15738C9.08973 3.10816 8.83799 1.46464 10.4437 1.23817Z",fill:"url(#paint39_radial_10246_159312)"}),U.createElement("path",{d:"M10.4437 1.23817C11.6483 1.06813 12.2267 2.26542 12.0802 3.30216C11.9943 3.45951 11.9337 3.79649 11.9141 3.94531L11.6992 8.10547C10.8008 9.25781 9.53125 8.96484 9.17969 7.71484L9.0626 4.15738C9.08973 3.10816 8.83799 1.46464 10.4437 1.23817Z",fill:"url(#paint40_radial_10246_159312)"}),U.createElement("path",{d:"M11.8994 4.15737C11.9482 2.8956 12.7903 2.56181 13.3594 2.57873C14.1794 2.60311 14.8301 3.32672 14.8047 4.15803L14.5987 8.92578C14.5501 9.1505 14.207 9.94531 13.2227 9.96094C12.2383 9.97656 11.8066 8.711 11.7139 8.07626L11.8994 4.15737Z",fill:"#FFC23E"}),U.createElement("path",{d:"M11.8994 4.15737C11.9482 2.8956 12.7903 2.56181 13.3594 2.57873C14.1794 2.60311 14.8301 3.32672 14.8047 4.15803L14.5987 8.92578C14.5501 9.1505 14.207 9.94531 13.2227 9.96094C12.2383 9.97656 11.8066 8.711 11.7139 8.07626L11.8994 4.15737Z",fill:"url(#paint41_radial_10246_159312)"}),U.createElement("path",{d:"M11.8994 4.15737C11.9482 2.8956 12.7903 2.56181 13.3594 2.57873C14.1794 2.60311 14.8301 3.32672 14.8047 4.15803L14.5987 8.92578C14.5501 9.1505 14.207 9.94531 13.2227 9.96094C12.2383 9.97656 11.8066 8.711 11.7139 8.07626L11.8994 4.15737Z",fill:"url(#paint42_linear_10246_159312)"}),U.createElement("path",{d:"M11.8994 4.15737C11.9482 2.8956 12.7903 2.56181 13.3594 2.57873C14.1794 2.60311 14.8301 3.32672 14.8047 4.15803L14.5987 8.92578C14.5501 9.1505 14.207 9.94531 13.2227 9.96094C12.2383 9.97656 11.8066 8.711 11.7139 8.07626L11.8994 4.15737Z",fill:"url(#paint43_linear_10246_159312)"}),U.createElement("path",{d:"M11.8994 4.15737C11.9482 2.8956 12.7903 2.56181 13.3594 2.57873C14.1794 2.60311 14.8301 3.32672 14.8047 4.15803L14.5987 8.92578C14.5501 9.1505 14.207 9.94531 13.2227 9.96094C12.2383 9.97656 11.8066 8.711 11.7139 8.07626L11.8994 4.15737Z",fill:"url(#paint44_radial_10246_159312)"}),U.createElement("path",{d:"M11.8994 4.15737C11.9482 2.8956 12.7903 2.56181 13.3594 2.57873C14.1794 2.60311 14.8301 3.32672 14.8047 4.15803L14.5987 8.92578C14.5501 9.1505 14.207 9.94531 13.2227 9.96094C12.2383 9.97656 11.8066 8.711 11.7139 8.07626L11.8994 4.15737Z",fill:"url(#paint45_radial_10246_159312)"}),U.createElement("path",{d:"M11.8994 4.15737C11.9482 2.8956 12.7903 2.56181 13.3594 2.57873C14.1794 2.60311 14.8301 3.32672 14.8047 4.15803L14.5987 8.92578C14.5501 9.1505 14.207 9.94531 13.2227 9.96094C12.2383 9.97656 11.8066 8.711 11.7139 8.07626L11.8994 4.15737Z",fill:"url(#paint46_radial_10246_159312)"}),U.createElement("path",{d:"M11.8994 4.15737C11.9482 2.8956 12.7903 2.56181 13.3594 2.57873C14.1794 2.60311 14.8301 3.32672 14.8047 4.15803L14.5987 8.92578C14.5501 9.1505 14.207 9.94531 13.2227 9.96094C12.2383 9.97656 11.8066 8.711 11.7139 8.07626L11.8994 4.15737Z",fill:"url(#paint47_radial_10246_159312)"}),U.createElement("path",{d:"M11.8994 4.15737C11.9482 2.8956 12.7903 2.56181 13.3594 2.57873C14.1794 2.60311 14.8301 3.32672 14.8047 4.15803L14.5987 8.92578C14.5501 9.1505 14.207 9.94531 13.2227 9.96094C12.2383 9.97656 11.8066 8.711 11.7139 8.07626L11.8994 4.15737Z",fill:"url(#paint48_linear_10246_159312)"}),U.createElement("path",{d:"M11.8994 4.15737C11.9482 2.8956 12.7903 2.56181 13.3594 2.57873C14.1794 2.60311 14.8301 3.32672 14.8047 4.15803L14.5987 8.92578C14.5501 9.1505 14.207 9.94531 13.2227 9.96094C12.2383 9.97656 11.8066 8.711 11.7139 8.07626L11.8994 4.15737Z",fill:"url(#paint49_radial_10246_159312)"})),Lqt=It({height:"100%",padding:"0.125rem"}),Oqt={root:{paddingLeft:"1rem",paddingRight:"1rem",":focus-visible":{margin:"0.125rem"}}},k4=It({display:"flex",lineHeight:0,alignItems:"center"}),Nqt=(t,e,i,r,o,l,d,h,p,g,f)=>{var y,T,C,E,I,w,D,F,x,B,L,z,H,j;const J=t;let Z;J&&(Z=IC.none);const re=o&&o(t),le=(Ge=>Ge&&e.attendeeRole?Jd(Ge,{AttendeeRole:e.attendeeRole}):Ge)(t.displayName),he=g.callingPalette,Me=f&&f?.includes(t.userId),Le=J?.isScreenSharing,pe=J?.isMuted,te=J?.raisedHand,Se=J?.mediaAccess?J.mediaAccess.isAudioPermitted:!0,ce=J?.mediaAccess?J.mediaAccess.isVideoPermitted:!0,ve=Le||pe||te||Me||!Se||!ce?()=>{var Ge,tt;return U.createElement(Et,{horizontal:!0,tokens:{childrenGap:"0.5rem"}},J.raisedHand&&U.createElement(Et,{horizontal:!0,tokens:{childrenGap:"0.2rem"},style:{alignItems:"center",padding:"0.1rem 0.2rem",backgroundColor:g?.palette.neutralLighter,borderRadius:"0.3rem"}},J.raisedHand.raisedHandOrderPosition&&U.createElement(Et.Item,null,U.createElement(ja,null,(Ge=J.raisedHand)===null||Ge===void 0?void 0:Ge.raisedHandOrderPosition)),U.createElement(Et.Item,null,U.createElement(BVe,null))),J.isScreenSharing&&U.createElement(Fr,{iconName:"ParticipantItemScreenShareStart",className:k4,ariaLabel:e.sharingIconLabel}),J.spotlight&&U.createElement(Fr,{iconName:"ParticipantItemSpotlighted",className:k4}),Me&&U.createElement(Fr,{iconName:"ParticipantItemPinned",className:k4}),J.mediaAccess&&!J.mediaAccess.isVideoPermitted?U.createElement(Fr,{iconName:"ControlButtonCameraProhibited",className:k4,ariaLabel:e.mutedIconLabel}):void 0,J.mediaAccess&&!(!((tt=J.mediaAccess)===null||tt===void 0)&&tt.isAudioPermitted)?U.createElement(Fr,{iconName:"ControlButtonMicProhibited",className:k4,ariaLabel:e.mutedIconLabel}):void 0,(!J.mediaAccess||J.mediaAccess.isAudioPermitted)&&J.isMuted?U.createElement(Fr,{iconName:"ParticipantItemMicOff",className:k4,ariaLabel:e.mutedIconLabel}):void 0)}:()=>null,Te=J?.raisedHand&&r?(Ge,tt,ct)=>r(Ge,Object.assign(Object.assign({},tt),{styles:{root:{border:he.raiseHandGold}}}),ct):r,Be=(y=re&&re.length>0?e?.participantItemWithMoreOptionsAriaLabel:void 0)!==null&&y!==void 0?y:e?.participantItemAriaLabel,qe=Jd(Be??"",{displayName:le??"",connectionState:(T=xVe(J,e))!==null&&T!==void 0?T:"",mutedState:(C=J.isMuted?e?.mutedIconLabel:void 0)!==null&&C!==void 0?C:"",micDisabledState:(I=((E=J.mediaAccess)===null||E===void 0?void 0:E.isAudioPermitted)===!1?e?.micDisabledIconLabel:void 0)!==null&&I!==void 0?I:"",cameraDisabledState:(D=((w=J.mediaAccess)===null||w===void 0?void 0:w.isVideoPermitted)===!1?e?.cameraDisabledIconLabel:void 0)!==null&&D!==void 0?D:"",sharingState:(F=J.isScreenSharing?e?.sharingIconLabel:void 0)!==null&&F!==void 0?F:"",handRaisedState:(j=!((x=J.raisedHand)===null||x===void 0)&&x.raisedHandOrderPosition?Jd((B=e?.handRaisedIconLabel)!==null&&B!==void 0?B:"",{position:(H=(z=(L=J.raisedHand)===null||L===void 0?void 0:L.raisedHandOrderPosition)===null||z===void 0?void 0:z.toString())!==null&&H!==void 0?H:""}):void 0)!==null&&j!==void 0?j:""});return U.createElement(Dqt,{styles:l,key:t.userId,userId:t.userId,displayName:le,me:i?t.userId===i:!1,menuItems:re,presence:Z,onRenderIcon:ve,onRenderAvatar:Te,onClick:d?()=>d?.(t):void 0,showParticipantOverflowTooltip:h,participantState:J.state,ariaLabelledBy:p,strings:{participantItemAriaLabel:qe}})},xqt=t=>{const e=function(i){return"raisedHand"in i};return t.sort((i,r)=>{if(!e(i)||!e(r))return 0;const o=i,l=r;return o.raisedHand&&l.raisedHand?o.raisedHand.raisedHandOrderPosition-l.raisedHand.raisedHandOrderPosition:o.raisedHand?-1:l.raisedHand?1:0}),t},Bqt=(t,e,i)=>{if(!e||!i)return[...t];const r=t.map(l=>l.userId).indexOf(i);if(r===-1)return[...t];const o=[...t];return o.splice(r,1),o},x8=t=>{var e,i,r,o;const{excludeMe:l=!1,myUserId:d,participants:h,onRemoveParticipant:p,onRenderAvatar:g,onRenderParticipant:f,onFetchParticipantMenuItems:y,showParticipantOverflowTooltip:T,participantAriaLabelledBy:C,pinnedParticipants:E}=t,I=Cs(),w=qE(),D=Kl().strings.participantItem,F=$.useMemo(()=>f?h:Bqt(h,l,d),[h,l,d,f]);xqt(F);const x=$.useCallback(L=>{var z,H;let j=[];const J=L.isRemovable;return L.userId!==d&&p&&J&&j.push({key:"remove",text:D.removeButtonLabel,onClick:()=>p(L.userId),itemProps:{styles:(H=(z=t.styles)===null||z===void 0?void 0:z.participantItemStyles)===null||H===void 0?void 0:H.participantSubMenuItemsStyles},iconProps:{iconName:"ContextMenuRemoveParticipant",styles:{root:{lineHeight:0}}},"data-ui-id":w.participantListRemoveParticipantButton}),y&&(j=y(L.userId,d,j)),j},[w.participantListRemoveParticipantButton,d,y,p,(i=(e=t.styles)===null||e===void 0?void 0:e.participantItemStyles)===null||i===void 0?void 0:i.participantSubMenuItemsStyles,D.removeButtonLabel]),B=$.useMemo(()=>{var L;return $U(Oqt,(L=t.styles)===null||L===void 0?void 0:L.participantItemStyles)},[(r=t.styles)===null||r===void 0?void 0:r.participantItemStyles]);return U.createElement(Et,{"data-ui-id":w.participantList,className:It(Lqt,(o=t.styles)===null||o===void 0?void 0:o.root),role:"menu"},F.map(L=>f?f(L):Nqt(L,D,d,g,x,B,t.onParticipantClick,T,C,I,E)))},FVe=(t,e)=>{(t.key==="Enter"||t.key===" ")&&e(t)},UVe=t=>{var e;const i=Cs(),r=d=>t.onItemClick&&t.onItemClick(d,t.itemKey),o=d=>r&&FVe(d,r),l=t.secondaryIconProps?U.createElement(mme,Object.assign({},t.secondaryIconProps)):t.subMenuProps?U.createElement(mme,{iconName:"ChevronRight"}):void 0;return U.createElement(hA,{shouldFocusOnMount:t.shouldFocusOnMount},U.createElement(Et,{tabIndex:0,role:"menuitem",horizontal:!0,className:It(Uqt(i.palette.neutralLight,i.fonts.small),t.disabled?zqt(i.palette.neutralQuaternaryAlt):void 0,(e=t.styles)===null||e===void 0?void 0:e.root),onKeyPress:t.disabled?void 0:o,onClick:t.disabled?void 0:r,tokens:Fqt,id:t.id,"aria-label":t.ariaLabel},t.iconProps&&U.createElement(Et.Item,{role:"presentation",styles:t.disabled?{root:{color:i.palette.neutralTertiaryAlt}}:void 0},U.createElement(mme,Object.assign({},t.iconProps))),U.createElement(Et.Item,{styles:zVe,grow:!0},U.createElement(ja,{styles:t.disabled?{root:{color:i.palette.neutralTertiaryAlt}}:void 0},t.text)),t.secondaryText&&U.createElement(Et.Item,{styles:zVe,className:It($qt)},U.createElement(ja,{styles:{root:{color:t.disabled?i.palette.neutralTertiaryAlt:i.palette.neutralSecondary}}},t.secondaryText)),t.secondaryComponent&&U.createElement(Et.Item,null,t.secondaryComponent),l&&U.createElement(Et.Item,null,l)))},mme=t=>U.createElement(_M,Object.assign({className:It(Vqt)},t)),Fqt={childrenGap:"0.5rem"},Uqt=(t,e)=>Object.assign(Object.assign({},e),{height:"3rem",lineHeight:"3rem",padding:"0rem 0.75rem",cursor:"pointer",":hover, :focus":{background:t}}),zqt=t=>({pointerEvents:"none",background:t,":hover, :focus":{background:t}}),zVe={root:{overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}},Vqt={display:"flex",alignItems:"center",height:"100%"," span":{display:"flex",alignItems:"center",height:"100%"}},$qt={maxWidth:"50%"},Hqt=t=>{var e;const i=hc(),r=i.palette.white,o=i.effects.roundedCorner4,l=It(jqt(r,o),(e=t.styles)===null||e===void 0?void 0:e.root);return U.createElement(Et,{className:l},t.heading&&U.createElement(Et,{className:It(Gqt)},U.createElement(ja,{className:It(qqt(i))},t.heading)),t.children)},jqt=(t,e)=>Object.assign({background:t,borderTopRightRadius:e,borderTopLeftRadius:e},gre.slideUpIn10),Gqt={textAlign:"center",width:"100%",padding:"0.5rem"},qqt=t=>({color:t.palette.neutralSecondary,fontSize:t.fonts.smallPlus.fontSize,lineHeight:"1rem",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}),Wqt=t=>U.createElement(Et,{className:It(Kqt,t.styles),grow:!0,onClick:()=>t.onDismiss()}),Kqt={root:{height:"100%"}},VVe=t=>{var e,i,r,o;const l=t.disableMaxHeight?It($Ve,(e=t.styles)===null||e===void 0?void 0:e.root):It($Ve,Jqt,(i=t.styles)===null||i===void 0?void 0:i.root),d=Rw(Yqt,(r=t.styles)===null||r===void 0?void 0:r.drawerContentContainer);return U.createElement(Et,{className:l},U.createElement(Wqt,{styles:(o=t.styles)===null||o===void 0?void 0:o.lightDismissRoot,onDismiss:t.onLightDismiss}),U.createElement(Nw,{onKeyDown:h=>{(h.key==="Escape"||h.key==="Esc")&&t.onLightDismiss&&t.onLightDismiss()},isClickableOutsideFocusTrap:!0},U.createElement(Hqt,{styles:d,heading:t.heading},t.children)))},$Ve={width:"100%",height:"100%",background:"rgba(0,0,0,0.4)"},Jqt={"> div:nth-child(2)":{maxHeight:"75%",overflow:"auto"}},Yqt={root:{height:"auto"}},fme=t=>t.onRendererContent===void 0,sF=t=>{var e,i;const[r,o]=$.useState([]),l=$.useMemo(()=>{var f;let y=t.items;for(const T of r)y=(f=y?.find(C=>fme(C)&&C.itemKey===T))===null||f===void 0?void 0:f.subMenuProps;return y},[t.items,r]),d=$.useCallback((f,y,T)=>{var C;f.subMenuProps&&o([...r,f.itemKey]),(C=f.onItemClick)===null||C===void 0||C.call(f,y,T)},[r]),h=Cs().effects.roundedCorner4,p=l?.[0]&&((e=l[0])===null||e===void 0?void 0:e.styles),g=$.useMemo(()=>$U(p??{},{root:{borderTopRightRadius:h,borderTopLeftRadius:h}}),[p,h]);return U.createElement(VVe,{disableMaxHeight:t.disableMaxHeight,styles:(i=t.styles)===null||i===void 0?void 0:i.drawerSurfaceStyles,onLightDismiss:t.onLightDismiss,heading:t.heading,"data-ui-id":"drawer-menu"},U.createElement(Et,{styles:t.styles,role:"menu","data-ui-id":"drawer-menu"},l?.slice(0,1).map(f=>{var y;return fme(f)?U.createElement(UVe,Object.assign({},f,{key:`${f.itemKey}0`,shouldFocusOnMount:f.itemKey!=="reactions",styles:g,onItemClick:f.itemKey==="reactions"?void 0:(T,C)=>{d(f,T,C)}})):(y=f.onRendererContent)===null||y===void 0?void 0:y.call(f)}),l?.slice(1).map((f,y)=>{var T;return fme(f)?U.createElement(UVe,Object.assign({},f,{key:`${f.itemKey}${y+1}`,onItemClick:(C,E)=>{d(f,C,E)}})):(T=f.onRendererContent)===null||T===void 0?void 0:T.call(f)})))},HVe=ql(()=>Pm({from:{backgroundPosition:"0px 8568px"},to:{backgroundPosition:"0px 0px"}})),Qqt=(t,e)=>{const i=`url(${t})`,r=e??51;return{display:"flex",flexDirection:"column",height:"100%",width:"100%",backgroundImage:i,justifyContent:"center",alignItems:"center",backgroundSize:"2.75rem 133.875rem",transition:"opacity 2s",minWidth:"2.75rem",backgroundColor:"transparent",transform:"scale(0.6)",":hover":{transform:"scale(0.8)",animationName:HVe(),animationDuration:"8.12s",animationTimingFunction:`steps(${r})`,animationIterationCount:"infinite",backgroundColor:"transparent"},":active":{backgroundColor:"transparent"}}},Zqt=()=>({root:{display:"flex",flexDirection:"column",height:"100%",width:"2.75rem"}}),Xqt=()=>({display:"flex",justifyContent:"space-between",alignItems:"center",flexDirection:"row",width:"100%",height:"2.625rem"}),eWt=(t,e)=>({display:"flex",flexDirection:"column",height:"100%",width:"2.75rem",backgroundImage:`url(${t})`,animationName:HVe(),animationDuration:"8.12s",animationTimingFunction:"steps(102)",animationPlayState:e,animationIterationCount:"infinite",justifyContent:"center",alignItems:"center",backgroundPosition:"center",backgroundSize:"2.75rem 133.875rem",transition:"opacity 2s",backgroundColor:"transparent",transform:"scale(0.8)"}),tWt=t=>({rootChecked:{background:t.palette.themePrimary,color:t.palette.white},rootCheckedHovered:{background:t.palette.themePrimary,color:t.palette.white},labelChecked:{color:t.palette.white}}),iWt={root:{border:"none",height:"2.75rem",width:"2.75rem"}},nWt={container:{},root:{},beak:{},beakCurtain:{},calloutMain:{display:"flex",justifyContent:"center",alignItems:"center",flexDirection:"row",width:"13.75rem",height:"2.625rem",":hover > :not(:hover)":{opacity:"0.5"}}},aWt=t=>{var e,i,r,o,l;const d=Cs(),h=t.reactionResources,p=new Map([["like",(e=h?.likeReaction)===null||e===void 0?void 0:e.url],["heart",(i=h?.heartReaction)===null||i===void 0?void 0:i.url],["laugh",(r=h?.laughReaction)===null||r===void 0?void 0:r.url],["applause",(o=h?.applauseReaction)===null||o===void 0?void 0:o.url],["surprised",(l=h?.surprisedReaction)===null||l===void 0?void 0:l.url]]),g=["like","heart","laugh","applause","surprised"],f=Cs().effects.roundedCorner4,y={root:{borderTopRightRadius:f,borderTopLeftRadius:f,marginTop:"12px"}};return U.createElement(Et,{"data-ui-id":"reaction-mobile-drawer-menu-item",id:"reaction",role:"menuitem",horizontal:!0,className:It(rWt(d.palette.neutralLight,d.fonts.small),t.disabled?oWt(d.palette.neutralQuaternaryAlt):void 0,y.root)},U.createElement("div",{style:Xqt()},g.map((T,C)=>{const E=p.get(T.toString());return U.createElement(zy,{key:C,onClick:()=>{var I;(I=t.onReactionClick)===null||I===void 0||I.call(t,T)},style:eWt(E||"","running")})})))},rWt=(t,e)=>Object.assign(Object.assign({},e),{height:"3rem",lineHeight:"3rem",padding:"0rem 0.75rem",cursor:"pointer",":hover, :focus":{background:t}}),oWt=t=>({pointerEvents:"none",background:t,":hover, :focus":{background:t}}),sWt={height:"100%",width:"100%",position:"relative"},jVe={root:{position:"absolute",top:0,left:0,width:"100%",height:"100%",zIndex:2}},lWt=zf("communication-react:calling-component"),GVe=t=>{const{isMirrored:e,isScreenSharingOn:i,isStreamAvailable:r,onCreateStreamView:o,onDisposeStreamView:l,renderElementExists:d,scalingMode:h,streamId:p,isVideoPermitted:g}=t,[f,y]=$.useState();return $.useEffect(()=>{var T;return g!==!1&&r&&!d&&((T=o?.({isMirrored:e,scalingMode:h}))===null||T===void 0||T.then(C=>{C&&y(C)})),()=>{d?i||l?.():lWt.warning("Stream view element does not exist when disposing stream view")}},[e,i,r,o,l,d,h,p,g]),$.useEffect(()=>()=>{i||l?.()},[i,l]),f},cWt=t=>{const{onCreateLocalStreamView:e,onDisposeLocalStreamView:i}=t,r=$.useMemo(()=>l=>e?.(l),[e]),o=$.useMemo(()=>()=>{i?.()},[i]);return GVe(Object.assign(Object.assign({},t),{onCreateStreamView:r,onDisposeStreamView:o}))},dWt=t=>{const{remoteParticipantId:e,onCreateRemoteStreamView:i,onDisposeRemoteStreamView:r}=t,o=$.useMemo(()=>d=>i?.(e,d),[i,e]),l=$.useMemo(()=>()=>{r?.(e)},[r,e]);return GVe(Object.assign(Object.assign({},t),{onCreateStreamView:o,onDisposeStreamView:l}))},qVe=t=>{var e;const{participant:i,view:r,strings:o,isPinned:l,onPinParticipant:d,onUnpinParticipant:h,onUpdateScalingMode:p,disablePinMenuItem:g,toggleAnnouncerString:f,spotlightedParticipantUserIds:y=[],isSpotlighted:T,onStartSpotlight:C,onStopSpotlight:E,maxParticipantsToSpotlight:I,myUserId:w,onMuteParticipant:D,onForbidAudio:F,onPermitAudio:x,onForbidVideo:B,onPermitVideo:L}=t,z=$.useMemo(()=>{var j;return(j=t.participant.videoStream)===null||j===void 0?void 0:j.scalingMode},[(e=t.participant.videoStream)===null||e===void 0?void 0:e.scalingMode]);return $.useMemo(()=>{var j,J;const Z=[];if(D&&o?.muteParticipantMenuItemLabel&&Z.push({key:"mute",text:o?.muteParticipantMenuItemLabel,iconProps:{iconName:"ContextualMenuMicMutedIcon",styles:{root:{lineHeight:0}}},onClick:()=>D(i.userId),"data-ui-id":"video-tile-mute-participant",ariaLabel:o?.muteParticipantMenuItemLabel,disabled:i.isMuted}),i.canAudioBeForbidden&&i.mediaAccess&&!i.mediaAccess.isAudioPermitted&&x&&Z.push({key:"permitAudio",text:o?.permitAudioTileMenuLabel,iconProps:{iconName:"ControlButtonMicOn",styles:{root:{lineHeight:0}}},onClick:()=>x([i.userId]),"data-ui-id":"video-tile-permit-audio",ariaLabel:o?.permitAudioTileMenuLabel}),i.canAudioBeForbidden&&(!((j=i.mediaAccess)===null||j===void 0)&&j.isAudioPermitted)&&F&&Z.push({key:"forbidAudio",text:o?.forbidAudioTileMenuLabel,iconProps:{iconName:"ControlButtonMicProhibited",styles:{root:{lineHeight:0}}},onClick:()=>F([i.userId]),"data-ui-id":"video-tile-forbid-audio",ariaLabel:o?.forbidAudioTileMenuLabel}),i.canVideoBeForbidden&&i.mediaAccess&&!i.mediaAccess.isVideoPermitted&&L&&Z.push({key:"permitVideo",text:o?.permitVideoTileMenuLabel,iconProps:{iconName:"ControlButtonCameraOn",styles:{root:{lineHeight:0}}},onClick:()=>L([i.userId]),"data-ui-id":"video-tile-permit-video",ariaLabel:o?.permitVideoTileMenuLabel}),i.canVideoBeForbidden&&(!((J=i.mediaAccess)===null||J===void 0)&&J.isVideoPermitted)&&B&&Z.push({key:"forbidVideo",text:o?.forbidVideoTileMenuLabel,iconProps:{iconName:"ControlButtonCameraProhibited",styles:{root:{lineHeight:0}}},onClick:()=>B([i.userId]),"data-ui-id":"video-tile-forbid-video",ariaLabel:o?.forbidVideoTileMenuLabel}),l!==void 0){if(l&&h&&o?.unpinParticipantForMe){let re;f&&o.unpinParticipantMenuItemAriaLabel&&i.displayName&&(re=Jd(o?.unpinParticipantMenuItemAriaLabel,{participantName:i.displayName})),Z.push({key:"unpin",text:o.unpinParticipantForMe,iconProps:{iconName:"UnpinParticipant",styles:{root:{lineHeight:"1rem",textAlign:"center"}}},onClick:()=>{h(i.userId),re&&f?.(re)},"data-ui-id":"video-tile-unpin-participant-button",ariaLabel:re})}if(!l&&d&&o?.pinParticipantForMe){let re;f&&o.pinnedParticipantAnnouncementAriaLabel&&i.displayName&&(re=Jd(o?.pinnedParticipantAnnouncementAriaLabel,{participantName:i.displayName})),Z.push({key:"pin",text:g?o.pinParticipantForMeLimitReached:o.pinParticipantForMe,iconProps:{iconName:"PinParticipant",styles:{root:{lineHeight:"1rem",textAlign:"center"}}},onClick:()=>{d(i.userId),re&&f?.(re)},"data-ui-id":"video-tile-pin-participant-button",disabled:g||T,ariaLabel:o.pinParticipantForMe})}}if(T){const re=w===i.userId?o?.stopSpotlightOnSelfVideoTileMenuLabel:o?.stopSpotlightVideoTileMenuLabel;E&&i.userId&&o?.stopSpotlightVideoTileMenuLabel&&Z.push({key:"stopSpotlight",text:re,iconProps:{iconName:"StopSpotlightContextualMenuItem",styles:{root:{lineHeight:0}}},onClick:()=>E([i.userId]),ariaLabel:o.stopSpotlightVideoTileMenuLabel})}else{const re=y&&y.length>0?o?.addSpotlightVideoTileMenuLabel:o?.startSpotlightVideoTileMenuLabel,ne=I?y.length>=I:!1;C&&i.userId&&re&&Z.push({key:"startSpotlight",text:re,iconProps:{iconName:"StartSpotlightContextualMenuItem",styles:{root:{lineHeight:0}}},onClick:()=>C([i.userId]),ariaLabel:re,disabled:ne,title:ne?o?.spotlightLimitReachedMenuTitle:void 0})}if(z&&(z==="Crop"&&o?.fitRemoteParticipantToFrame?Z.push({key:"fitRemoteParticipantToFrame",text:o.fitRemoteParticipantToFrame,iconProps:{iconName:"VideoTileScaleFit",styles:{root:{lineHeight:"1rem",textAlign:"center"}}},onClick:()=>{p?.(i.userId,"Fit"),r?.updateScalingMode("Fit")},"data-ui-id":"video-tile-fit-to-frame",ariaLabel:o.fitRemoteParticipantToFrame}):z==="Fit"&&o?.fillRemoteParticipantFrame&&Z.push({key:"fillRemoteParticipantFrame",text:o.fillRemoteParticipantFrame,iconProps:{iconName:"VideoTileScaleFill",styles:{root:{lineHeight:"1rem",textAlign:"center"}}},onClick:()=>{p?.(i.userId,"Crop"),r?.updateScalingMode("Crop")},"data-ui-id":"video-tile-fill-frame",ariaLabel:o.fillRemoteParticipantFrame})),Z.length!==0)return{items:Z,styles:{},calloutProps:{preventDismissOnEvent:YS},shouldFocusOnContainer:!1}},[D,o,i.isMuted,i.userId,i.displayName,l,T,z,h,d,f,g,w,E,y,I,C,p,r,i.canAudioBeForbidden,i.canVideoBeForbidden,i.mediaAccess,x,F,L,B])},WVe=44,KVe=51,vme=4133,uWt=128,hWt=(t,e,i)=>{const r=i.toISOString();return t+e+r},JVe=t=>t.getTime(),pWt={position:"relative",height:"100%",width:"100%"},gWt=t=>({"@media (forced-colors: active)":{border:`0.125rem solid ${t.palette.black}`}}),R4={position:"absolute",top:"0",left:"0",width:"100%",height:"100%",minWidth:"100%",minHeight:"100%",objectPosition:"center",objectFit:"cover",zIndex:0},mWt={width:"100%",height:"100%",zIndex:5},fWt=It({position:"absolute",bottom:"0",left:"0",padding:"0.5rem",width:"100%"}),YVe=It({backgroundColor:"inherit",boxShadow:"none",textAlign:"left",overflow:"hidden",whiteSpace:"nowrap",alignItems:"center",padding:"0.15rem",maxWidth:"100%"}),vWt={padding:"0.1rem",fontSize:"0.75rem",fontWeight:600,color:"inherit",overflow:"hidden",textOverflow:"ellipsis",maxWidth:"100%"},yWt={padding:"0.125rem"},B8={margin:"auto 0.2rem",alignItems:"center","& svg":{display:"block",color:"inherit"}},SWt=t=>({minWidth:"max-content",color:t.palette.black,fontSize:"0.75rem",lineHeight:"normal",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",padding:"0.1rem"}),bWt=t=>({root:{zIndex:1,top:"-0.125rem",height:"100%",padding:"0rem"},rootHovered:{background:"none"},rootPressed:{background:"none"},icon:{color:t.palette.neutralPrimary},iconExpanded:{background:"none",color:t.palette.themePrimary}}),TWt=(t,e)=>It({alignItems:"center",padding:"0.2rem 0.3rem",backgroundColor:t.palette.white,opacity:.9,borderRadius:"1rem",margin:"0.5rem",width:"fit-content",position:"absolute",top:0,height:"fit-content"},e&&CWt),CWt={marginLeft:"auto",marginRight:"auto",left:0,right:0,bottom:0},_Wt=ql((t,e)=>Pm({from:{backgroundPosition:"0px 0px"},to:{backgroundPosition:`0px ${e*-t}px`}})),EWt=t=>{var e;const i=`url(${t.spriteImageUrl})`,r=(e=t.frameCount)!==null&&e!==void 0?e:0,o=t.rawFrameSize;return It({height:`${o}px`,width:`${o}px`,overflow:"hidden",animationName:_Wt(o,r),backgroundImage:i,animationDuration:`${vme/1e3}s`,animationTimingFunction:`steps(${r})`,animationPlayState:"running",animationIterationCount:"infinite",transform:`scale(${t.emojiSize/o})`,transformOrigin:"top left"})},QVe=(t,e)=>({circle:{width:"2rem",height:"2rem"},label:{fontSize:"1rem",color:e?BO(t)?t.palette.black:t.palette.white:t.palette.themeDarkAlt}}),AWt=()=>({display:"flex",justifyContent:"center",alignItems:"center",backgroundColor:"rgba(0, 0, 0, 0.3)"}),IWt=()=>({display:"flex",justifyContent:"center",alignItems:"center"}),wWt={marginLeft:"0.2rem"};function ZVe(t){const{onClick:e,onLongPress:i,touchEventsOnly:r=!1}=t,o=$.useRef(),[l,d]=$.useState(!1),[h,p]=$.useState(!1);$.useEffect(()=>(o.current&&clearTimeout(o.current),()=>{o.current&&clearTimeout(o.current)}),[e,i,r]);const g=$.useCallback(()=>{d(!1),o.current=setTimeout(()=>{d(!0),i()},500)},[i]),f=$.useCallback(()=>{r||!e||l||e()},[l,e,r]),y=$.useCallback(()=>{r||h&&(p(!1),g())},[h,g,r]),T=$.useCallback(()=>{r||(p(!0),o.current&&clearTimeout(o.current))},[r]),C=$.useCallback(()=>{r||g()},[g,r]),E=$.useCallback(()=>{r||o.current&&clearTimeout(o.current)},[r]),I=$.useCallback(()=>{g()},[g]),w=$.useCallback(()=>{!l&&e&&e(),o.current&&clearTimeout(o.current)},[e,l]),D=$.useCallback(()=>{o.current&&clearTimeout(o.current)},[]);return $.useMemo(()=>({onClick:f,onMouseDown:C,onMouseUp:E,onTouchStart:I,onTouchEnd:w,onKeyDown:y,onKeyUp:T,onTouchMove:D}),[f,y,T,C,E,w,I,D])}const kWt=100,RWt=32,XVe=t=>{const{text:e,noVideoAvailableAriaLabel:i,coinSize:r,hidePersonaDetails:o}=t;return U.createElement(Et,{className:It({position:"absolute",height:"100%",width:"100%"})},U.createElement(Et,{styles:e$e},r&&U.createElement(ux,{coinSize:r,hidePersonaDetails:o,text:e??"",initialsTextColor:"white","aria-label":i??"",showOverflowTooltip:!1})))},e$e={root:{margin:"auto",maxHeight:"100%"}},MWt={iconName:void 0,style:{display:"none"}},PWt={directionalHint:hd.topLeftEdge,isBeakVisible:!1,styles:{container:{maxWidth:"8rem"}}},DWt=t=>{const e=Kl().strings.videoTile,i=Cs(),{contextualMenu:r,canShowContextMenuButton:o,participantDisplayName:l,participantHandRaised:d,participantIsSpeaking:h,participantState:p,participantIsMuted:g,isMicDisabled:f,isCameraDisabled:y}=t,[T,C]=$.useState("");if($.useEffect(()=>{C(i8t(l,g,d,p,h,e,f,y))},[l,d,g,h,p,e,f,y]),!r)return U.createElement(U.Fragment,null);const E=o?"VideoTileMoreOptions":void 0;return U.createElement(zy,{"data-ui-id":"video-tile-more-options-button",ariaLabel:T,styles:bWt(i),menuIconProps:MWt,menuProps:Object.assign(Object.assign({},PWt),r),iconProps:{iconName:E}})},UO=t=>{const{children:e,displayName:i,initialsName:r,isMirrored:o,isMuted:l,isSpotlighted:d,isPinned:h,onRenderPlaceholder:p,renderElement:g,overlay:f,showLabel:y=!0,showMuteIndicator:T=!0,styles:C,userId:E,noVideoAvailableAriaLabel:I,isSpeaking:w,raisedHand:D,personaMinSize:F=RWt,personaMaxSize:x=kWt,contextualMenu:B,mediaAccess:L}=t,[z,H]=$.useState(!1),[j,J]=$.useState(!1),[Z,re]=$.useState(1),ne=$.useRef(null),le=Kl(),he=Cs(),Me=he.callingPalette,Le=!!g,pe=$.useRef(new ResizeObserver(vt=>{if(!vt[0])return;const{width:Pt,height:ni}=vt[0].contentRect,Zt=Math.min(Pt,ni)/3;Zt!==Z&&re(Math.max(Math.min(Zt,x),F))}));$.useLayoutEffect(()=>{ne.current&&pe.current.observe(ne.current);const vt=pe.current;return()=>vt.disconnect()},[ne]),$.useEffect(()=>{var vt;if(!((vt=ne.current)===null||vt===void 0)&&vt.id)return;let Pt;return ne.current&&(Pt=new MutationObserver(ni=>{for(const Zt of ni)if(Zt.type==="childList"){const it=document.querySelector("iframe");it&&(it.getAttribute("tabIndex")||it.setAttribute("tabIndex","-1"))}}),Pt.observe(ne.current,{childList:!0,subtree:!0})),()=>{Pt?.disconnect()}},[i,g]);const te=$.useMemo(()=>({onLongPress:()=>{var vt;(vt=t.onLongTouch)===null||vt===void 0||vt.call(t)},touchEventsOnly:!0}),[t.onLongTouch]),Se=ZVe(te),ce=$.useMemo(()=>({onMouseEnter:()=>H(!0),onMouseLeave:()=>H(!1),onFocus:()=>J(!0),onBlur:()=>J(!1)}),[]),X={userId:E,text:r??i,noVideoAvailableAriaLabel:I,coinSize:Z,styles:e$e,hidePersonaDetails:!0},ve=It(YVe,{borderRadius:he.effects.roundedCorner4,backgroundColor:Me.videoTileLabelBackgroundLight}),Te=$.useMemo(()=>It(Le||t.alwaysShowLabelBackground?ve:YVe,C?.displayNameContainer),[Le,ve,C?.displayNameContainer,t.alwaysShowLabelBackground]),Be=qE(),qe=y&&(i||T&&l),Ge=OWt(t,le),tt=z||j;let ct="";ct=Me.raiseHandGold;const Mt=$.useMemo(()=>qe||Ge?LWt(T,l,L):void 0,[qe,l,L,Ge,T]),ht=Mt||d||h;return U.createElement(Et,Object.assign({"data-ui-id":Be.videoTile,className:It(pWt,{background:he.palette.neutralLighter,borderRadius:he.effects.roundedCorner4},w||D?{"&::after":{content:"''",position:"absolute",border:`0.25rem solid ${w?he.palette.themePrimary:ct}`,borderRadius:he.effects.roundedCorner4,width:"100%",height:"100%",pointerEvents:"none"}}:{},gWt(he),C?.root)},Se),U.createElement("div",Object.assign({ref:ne,style:{width:"100%",height:"100%"}},ce,{"data-is-focusable":!0}),Le?U.createElement(Et,{className:It(R4,o&&{transform:"scaleX(-1)"},C?.videoContainer)},g):U.createElement(Et,{className:It(R4,{opacity:Ge||t.participantState==="Idle"?.4:1})},p?p(E??"",X,XVe):U.createElement(XVe,Object.assign({},X))),f,(qe||Ge)&&U.createElement(Et,{horizontal:!0,className:fWt,tokens:NWt},U.createElement(Et,{horizontal:!0,className:Te},qe&&U.createElement(ja,{className:It(vWt),title:i,style:{color:Ge?he.palette.neutralSecondary:"inherit"},"data-ui-id":"video-tile-display-name"},i),Ge&&U.createElement(ja,{className:It(SWt(he))},xWt(Ge,!!qe)),ht&&U.createElement(Et,{horizontal:!0,className:It(wWt)},Mt,d&&U.createElement(Et,{className:It(B8)},U.createElement(Fr,{iconName:"VideoTileSpotlighted"})),h&&U.createElement(Et,{className:It(B8)},U.createElement(Fr,{iconName:"VideoTilePinned",className:It(yWt)}))),U.createElement(DWt,{contextualMenu:B,participantDisplayName:i,participantHandRaised:!!D,participantIsMuted:l,participantState:Ge,participantIsSpeaking:w,canShowContextMenuButton:tt,isMicDisabled:L?.isAudioPermitted===!1,isCameraDisabled:L?.isVideoPermitted===!1}))),e&&U.createElement(Et,{className:It(mWt,C?.overlayContainer)},e),D&&U.createElement(Et,{horizontal:!0,tokens:{childrenGap:"0.2rem"},className:TWt(he,!qe)},U.createElement(Et.Item,null,U.createElement(ja,null,D.raisedHandOrderPosition)),U.createElement(Et.Item,null,U.createElement(BVe,null)))))},LWt=(t,e,i)=>{const r=i&&!i?.isVideoPermitted?U.createElement(Et,{className:It(B8)},U.createElement(Fr,{iconName:"ControlButtonCameraProhibitedSmall"})):void 0,o=(!i||i.isAudioPermitted)&&t&&e?U.createElement(Et,{className:It(B8)},U.createElement(Fr,{iconName:"VideoTileMicOff"})):void 0,l=i&&!i?.isAudioPermitted&&t?U.createElement(Et,{className:It(B8)},U.createElement(Fr,{iconName:"ControlButtonMicProhibitedSmall"})):void 0;if(r||o||l)return U.createElement(U.Fragment,null,r,o,l)},OWt=(t,e)=>{const i=Object.assign(Object.assign({},e.strings.videoTile),t.strings);return t.participantState==="EarlyMedia"||t.participantState==="Ringing"?i?.participantStateRinging:t.participantState==="Hold"?i?.participantStateHold:void 0},NWt={childrenGap:"none"},xWt=(t,e)=>e?`(${t})`:t,t$e=t=>{const{participants:e,dominantSpeakers:i=[],currentParticipants:r=[],maxDominantSpeakers:o}=t;if(e.length<=o)return e;const l=BWt(e),d=i.filter(T=>!!l[T]).slice(0,o),h=r.map(T=>T.userId).slice(0,o),p=d.filter(T=>!h.includes(T));for(let T=0;T<o;T++){const C=h[T];if(C===void 0||!d.includes(C)){const E=p.shift();if(!E)break;h[T]=E}}let g=h.map(T=>l[T]).filter(T=>T!==void 0);const f=new Set(h),y=e.filter(T=>!f.has(T.userId));return g=g.concat(y),g},BWt=t=>{const e={};return t.forEach(i=>e[i.userId]=i),e},FWt=6,UWt=4,i$e=9,zWt=t=>{const{remoteParticipants:e=[],dominantSpeakers:i=[],maxGridParticipants:r=UWt,maxOverflowGalleryDominantSpeakers:o=FWt,layout:l,previousGridParticipants:d=[],previousOverflowParticipants:h=[]}=t,p=e.filter(x=>x.state==="Connecting"||x.state==="Ringing"),g=new Set(p.map(x=>x.userId)),f=e.filter(x=>!g.has(x.userId)),y=VWt(f),T=e.filter(x=>{var B;return(B=x.videoStream)===null||B===void 0?void 0:B.isAvailable}),C=l==="floatingLocalVideo"&&T.length>0?T:y;let E=t$e({participants:C,dominantSpeakers:i,currentParticipants:d,maxDominantSpeakers:r}).slice(0,r);l==="speaker"&&(i?.[0]?E=E.filter(x=>x.userId===i[0]):E=E.slice(1));const I=new Set(E.map(x=>x.userId)),w=t$e({participants:y.filter(x=>!I.has(x.userId)),dominantSpeakers:i,currentParticipants:h,maxDominantSpeakers:o});let D=E,F=w;if(F.length===0){const x=r-D.length,B=p.slice(0,x),L=p.slice(x);D=D.concat(B),F=L}else F=F.concat(p);return{gridParticipants:D,overflowGalleryParticipants:F}},yme=t=>{var e,i;const r=(e=t.spotlightedParticipantUserIds)!==null&&e!==void 0?e:[],o=(i=t.pinnedParticipantUserIds)!==null&&i!==void 0?i:[],l=new Set(r.concat(o)),d=[...l].map(T=>t.remoteParticipants.find(C=>C.userId===T)).filter(T=>T!==void 0),h=t.remoteParticipants.filter(T=>!l.has(T.userId)),p=$.useRef([]),g=$.useRef([]),f=Object.assign(Object.assign({},t),{maxGridParticipants:d.length>0||t.isScreenShareActive?0:t.maxGridParticipants,remoteParticipants:h,previousGridParticipants:p.current,previousOverflowParticipants:g.current}),y=zWt(f);return p.current=y.gridParticipants,g.current=y.overflowGalleryParticipants,d.length>0?{gridParticipants:t.isScreenShareActive?[]:d,overflowGalleryParticipants:t.isScreenShareActive?d.concat(y.overflowGalleryParticipants):y.overflowGalleryParticipants}:y},VWt=t=>{const e=[],i=[];return t.forEach(o=>{var l;!((l=o.videoStream)===null||l===void 0)&&l.isAvailable?e.push(o):i.push(o)}),e.concat(i)},Sme=(t,e,i,r,o,l)=>{const d=l??[];let h=i;const p=t.filter(E=>{var I;return(I=E?.videoStream)===null||I===void 0?void 0:I.isAvailable}),g=d.filter(E=>p.find(I=>I?.userId===E)).slice(0,h);h=h-g.length;const f=t.map(E=>{var I;return e(E,g.includes(E.userId)||((I=E.videoStream)===null||I===void 0?void 0:I.isAvailable)&&h-- >0)}),y=r.map(E=>o.at(E)).filter(E=>{var I;return(I=E?.videoStream)===null||I===void 0?void 0:I.isAvailable}),T=d.filter(E=>y.find(I=>I?.userId===E)).slice(0,h);h=h-T.length;const C=o.map(E=>{var I;return e(E,T.includes(E.userId)||((I=E.videoStream)===null||I===void 0?void 0:I.isAvailable)&&h-- >0)});return{gridTiles:f,overflowGalleryTiles:C}},n$e=(t,e)=>{var i,r,o,l,d;switch(t){case"like":return(i=e.likeReaction)===null||i===void 0?void 0:i.url;case"heart":return(r=e.heartReaction)===null||r===void 0?void 0:r.url;case"laugh":return(o=e.laughReaction)===null||o===void 0?void 0:o.url;case"applause":return(l=e.applauseReaction)===null||l===void 0?void 0:l.url;case"surprised":return(d=e.surprisedReaction)===null||d===void 0?void 0:d.url}},a$e=(t,e)=>{var i,r,o,l,d,h,p,g,f,y;switch(t){case"like":return(r=(i=e.likeReaction)===null||i===void 0?void 0:i.frameCount)!==null&&r!==void 0?r:0;case"heart":return(l=(o=e.heartReaction)===null||o===void 0?void 0:o.frameCount)!==null&&l!==void 0?l:0;case"laugh":return(h=(d=e.laughReaction)===null||d===void 0?void 0:d.frameCount)!==null&&h!==void 0?h:0;case"applause":return(g=(p=e.applauseReaction)===null||p===void 0?void 0:p.frameCount)!==null&&g!==void 0?g:0;case"surprised":return(y=(f=e.surprisedReaction)===null||f===void 0?void 0:f.frameCount)!==null&&y!==void 0?y:0;default:return 0}},$Wt=U.memo(t=>{const{reaction:e,reactionResources:i,emojiSize:r=WVe}=t,[o,l]=$.useState(!1),d=e!==void 0&&i!==void 0?n$e(e?.reactionType,i):void 0,h=e!==void 0&&i!==void 0?a$e(e?.reactionType,i):void 0,p=Date.now(),g=e?JVe(e.receivedOn):void 0,f=(g?p-g<vme:!1)&&d!==void 0;$.useEffect(()=>{if(!(!d||d.length===0))return fetch(`${d}`).then(C=>{l(C.ok)}).catch(C=>console.warn(`Sprite image for animation rendering failed with warning: ${C}`)),()=>l(!1)},[d]);const y=d??void 0,T=$.useCallback(()=>EWt({spriteImageUrl:y??"",emojiSize:r,frameCount:h??KVe,rawFrameSize:uWt}),[y,r,h]);return U.createElement(Et,{className:It(R4,{display:"flex",justifyContent:"center",alignItems:"center",backgroundColor:f?"rgba(0, 0, 0, 0.5)":"transparent",borderRadius:"0.25rem"})},U.createElement("div",{style:{height:"33.33%"}}),f&&o&&U.createElement("div",{style:{minHeight:`${r}px`,height:`${r}px`,width:`${r}px`}},U.createElement("div",{className:T()})))});function HWt(t,e,i=!0){const r=i?e:0,o=t===0?0:t%2*2-1;if(o===0)return r;const l=qWt(t);return r+o*l*e}const jWt={bottom:"0",height:"50%",pointerEvents:"none",position:"absolute",width:"100%"};function GWt(t){return{position:"absolute",left:`${t}px`}}function qWt(t){switch(t){case 1:case 2:return .3;case 3:case 4:return .6;case 5:case 6:return .9;case 7:case 8:return .75;case 9:case 18:return .375;case 10:case 23:return .525;case 11:case 16:return .15;case 12:case 15:return .225;case 13:case 14:return .075;case 17:case 24:return .45;case 19:case 20:return .675;case 21:case 22:return .825;default:return 0}}const WWt={sizeScale:.9,heightMaxScale:.7*.95,opacityMax:.9};function r$e(){return WWt}const KWt=ql((t,e)=>Pm({"0%":{transform:`translateY(${t}px)`},"100%":{transform:`translateY(${e}px)`}})),JWt=(t,e)=>({animationName:KWt(t,e),animationFillMode:"forwards",animationDuration:"4.133s",animationTimingFunction:"cubic-bezier(0, 0.83, 0.19, 1.09)"}),YWt=ql(t=>Pm({"0%":{opacity:0},"31.2%":{opacity:t},"67.2%":{opacity:t},"100%":{opacity:0,display:"none",visibility:"hidden"}})),QWt=t=>({animationName:YWt(t),animationFillMode:"forwards",animationDuration:"4.133s"}),ZWt=ql((t,e)=>Pm({from:{backgroundPosition:"0px 0px"},to:{backgroundPosition:`0px -${t*e}px`}})),XWt=(t,e,i)=>({height:`${e}px`,width:`${e}px`,backgroundImage:`url(${i})`,backgroundRepeat:"no-repeat",animationName:ZWt(t,e),animationDuration:`${t/24}s`,animationFillMode:"forwards",animationIterationCount:"infinite",animationTimingFunction:`steps(${t})`,backgroundSize:`${e}px ${t*e}px`,transform:`scale(${e}/128)`}),eKt=50,tKt=5,iKt=55,nKt=U.memo(t=>{const{reactionResources:e,localParticipant:i,remoteParticipants:r,hostDivHeight:o,hostDivWidth:l}=t,[d,h]=$.useState([]),p=$.useRef({}),g=$.useRef({like:0,heart:0,laugh:0,applause:0,surprised:0}),f=$.useRef(new Array(iKt).fill(!1)),y=$.useMemo(()=>{var z;return(z=r?.map(H=>H.reaction).filter(H=>!!H))!==null&&z!==void 0?z:[]},[r]),T=()=>f.current.findIndex(z=>z===!1),C=$.useCallback((z,H)=>{var j,J;const Z=hWt(H,z.reactionType,z.receivedOn);if(((j=p.current[H])===null||j===void 0?void 0:j.id)===Z)return;if(((J=g.current[z.reactionType])!==null&&J!==void 0?J:0)>=eKt/tKt){p.current[H]={id:Z,status:"ignored"};return}g.current[z.reactionType]+=1,p.current[H]={id:Z,status:"animating"};const le=T();f.current[le]=!0,h([...d,{reaction:z,id:Z,reactionMovementIndex:le,styleBucket:r$e()}])},[g,d]),E=(z,H,j)=>{h(d.filter(J=>J.id!==H)),f.current[j]=!1,g.current[z]-=1,Object.entries(p.current).forEach(([J,Z])=>{const re=p.current[J];Z.id===H&&re&&(re.status="completedAnimating")})};$.useEffect(()=>{i?.reaction&&C(i.reaction,i.userId)},[i,C]),$.useEffect(()=>{r?.map(z=>{z?.reaction&&C(z.reaction,z.userId)})},[y,r,C]);const I=(z,H,j)=>{const J=Date.now()-JVe(z.receivedOn)<vme;return J||E(z?.reactionType,H,j),J},w=()=>r$e(),D=()=>WVe*w().sizeScale,F=o??0,x=(l??0)-D(),B=z=>HWt(z,x/2,!0),L=z=>GWt(B(z));return U.createElement(Et,{className:It(R4,{display:"flex",justifyContent:"center",alignItems:"center",backgroundColor:"transparent"})},d.map(z=>{var H;return U.createElement("div",{key:z.id,style:jWt},U.createElement("div",{className:"reaction-item"},I(z.reaction,z.id,z.reactionMovementIndex)&&U.createElement("div",{style:JWt(F/2,F/2*(1-z.styleBucket.heightMaxScale))},U.createElement("div",{onAnimationEnd:()=>{E(z.reaction.reactionType,z.id,z.reactionMovementIndex)},style:QWt(z.styleBucket.opacityMax)},U.createElement("div",{style:L(z.reactionMovementIndex)},U.createElement("div",{style:XWt(KVe,D(),(H=n$e(z?.reaction.reactionType,e))!==null&&H!==void 0?H:"")}))))))}))}),aKt=70,rKt=32,oKt=3,bme=t=>{const{overlayMode:e,reaction:i,reactionResources:r,localParticipant:o,remoteParticipants:l}=t,[d,h]=$.useState(0),[p,g]=$.useState(0),[f,y]=$.useState(0),T=$.useRef(null),C=$.useRef(new ResizeObserver(E=>{var I;const w=(I=E.at(0))===null||I===void 0?void 0:I.contentRect,D=w!==void 0?w.width:0,F=w!==void 0?w.height:0,x=Math.min(D,F)/oKt;x!==d&&h(Math.max(Math.min(x,aKt),rKt)),F!==p&&g(F),D!==f&&y(D)}));return $.useLayoutEffect(()=>{T.current&&C.current.observe(T.current);const E=C.current;return()=>E.disconnect()},[T]),e==="grid-tiles"?U.createElement("div",{ref:T,style:{width:"100%",height:"100%",pointerEvents:"none"}},U.createElement($Wt,{emojiSize:d,reaction:i,reactionResources:r})):t.overlayMode==="screen-share"||t.overlayMode==="content-share"?U.createElement("div",{ref:T,style:{width:"100%",height:"100%",pointerEvents:"none"}},U.createElement(nKt,{hostDivHeight:p,hostDivWidth:f,reactionResources:r,localParticipant:o,remoteParticipants:l})):(t.overlayMode==="together-mode",U.createElement(U.Fragment,null))},Tme=U.memo(t=>{var e,i;const{isAvailable:r,isReceiving:o=!0,isScreenSharingOn:l,onCreateRemoteStreamView:d,onDisposeRemoteStreamView:h,remoteVideoViewOptions:p,renderElement:g,userId:f,onRenderAvatar:y,showMuteIndicator:T,remoteParticipant:C,participantState:E,menuKind:I,isPinned:w,onPinParticipant:D,onUnpinParticipant:F,spotlightedParticipantUserIds:x,isSpotlighted:B,onStartSpotlight:L,onStopSpotlight:z,maxParticipantsToSpotlight:H,onMuteParticipant:j,onUpdateScalingMode:J,disablePinMenuItem:Z,toggleAnnouncerString:re,strings:ne,reactionResources:le,streamId:he,onForbidAudio:Me,onPermitAudio:Le,onForbidVideo:pe,onPermitVideo:te}=t,Se=$.useMemo(()=>({isMirrored:p?.isMirrored,isScreenSharingOn:l,isStreamAvailable:r,isStreamReceiving:o,onCreateRemoteStreamView:d,onDisposeRemoteStreamView:h,remoteParticipantId:f,renderElementExists:!!g,scalingMode:p?.scalingMode,streamId:he,isVideoPermitted:C.mediaAccess?C.mediaAccess.isVideoPermitted:!0}),[r,o,l,d,h,p?.isMirrored,p?.scalingMode,g,f,he,C.mediaAccess]),ce=dWt(Se),X=qVe({participant:C,view:ce?.view,strings:Object.assign({},t.strings),isPinned:w,onPinParticipant:D,onUnpinParticipant:F,onUpdateScalingMode:J,disablePinMenuItem:Z,toggleAnnouncerString:re,spotlightedParticipantUserIds:x,isSpotlighted:B,onStartSpotlight:L,onStopSpotlight:z,maxParticipantsToSpotlight:H,onMuteParticipant:j,onForbidAudio:Me,onPermitAudio:Le,onForbidVideo:pe,onPermitVideo:te}),ve=$.useMemo(()=>I!=="contextual"||!X?{}:{contextualMenu:X},[X,I]),Te=r&&o===!1&&E!=="Disconnected",Be=E==="Reconnecting",[qe,Ge]=U.useState([]),tt=$.useMemo(()=>{if(!((!g||!g.childElementCount)&&!Be))return U.createElement(w4,{videoStreamElement:g??null,loadingState:Te?"loading":Be?"reconnecting":"none"})},[Be,g,Te]),ct=$.useCallback(Zt=>{Zt.key==="Enter"&&Ge(o$e(X,()=>Ge([])))},[Ge,X]),Mt=(e=t.strings)===null||e===void 0?void 0:e.attendeeRole,vt=((Zt,it)=>Zt&&it?Jd(Zt,{AttendeeRole:it}):Zt)(C.displayName?C.displayName:ne.displayNamePlaceholder,Mt),Pt=()=>C.displayName&&Mt?Jd(C.displayName,{AttendeeRole:Mt}):C.displayName,ni=le&&U.createElement(bme,{overlayMode:"grid-tiles",reaction:C.reaction,reactionResources:le});return U.createElement(Et,{tabIndex:I==="drawer"?0:void 0,onKeyDown:I==="drawer"?ct:void 0,style:sWt},U.createElement(UO,Object.assign({key:f,userId:f,initialsName:(i=Pt())!==null&&i!==void 0?i:"",renderElement:tt,displayName:vt,onRenderPlaceholder:y,isMuted:C.isMuted,raisedHand:C.raisedHand,isSpeaking:C.isSpeaking,showMuteIndicator:T,personaMinSize:t.personaMinSize,showLabel:t.showLabel,alwaysShowLabelBackground:t.alwaysShowLabelBackground,participantState:E},ve,{isPinned:t.isPinned,onLongTouch:t.onLongTouch?t.onLongTouch:()=>Ge(o$e(X,()=>Ge([]))),isSpotlighted:B,overlay:ni,mediaAccess:C.mediaAccess})),qe.length>0&&U.createElement(QU,{hostId:t.drawerMenuHostId},U.createElement(Et,{styles:jVe},U.createElement(sF,{onLightDismiss:()=>Ge([]),items:qe,heading:vt}))))}),o$e=(t,e)=>t?t.items.map(i=>({itemKey:i.key,text:i.text,iconProps:i.iconProps,disabled:i.disabled,onItemClick:()=>{var r;(r=i.onClick)===null||r===void 0||r.call(i),e?.()}})):[],sKt=It({height:"100%",width:"100%"}),lKt={label:{maxWidth:"10rem",overflow:"hidden",textOverflow:"ellipsis"}},cKt=U.memo(t=>{const{userId:e,displayName:i,isMuted:r,renderElement:o,onCreateRemoteStreamView:l,onDisposeRemoteStreamView:d,isReceiving:h,participantVideoScalingMode:p,reactionResources:g,localParticipant:f,remoteParticipants:y}=t,T=Kl();o||l&&l(e,p),$.useEffect(()=>()=>{d&&d(e)},[d,e]);const C=i?Jd(T.strings.videoGallery.screenShareLoadingMessage,{participant:i}):"";return U.createElement(UO,{displayName:i,isMuted:r,renderElement:o?U.createElement(w4,{videoStreamElement:o,loadingState:h===!1?"loading":"none"}):void 0,onRenderPlaceholder:()=>U.createElement(s$e,{loadingMessage:C}),overlay:g&&U.createElement(bme,{reactionResources:g,localParticipant:f,remoteParticipants:y,overlayMode:"screen-share"})})}),s$e=t=>U.createElement(Et,{verticalAlign:"center",className:sKt},U.createElement(gx,{styles:lKt,label:t.loadingMessage,size:bE.xSmall,"aria-live":"assertive"})),dKt=It({width:"100%",height:"100%"}),uKt=t=>It({backgroundColor:"inherit",padding:"1rem",maxWidth:"95%",borderRadius:t.effects.roundedCorner4,color:t.palette.neutralSecondary}),hKt=It({height:"2rem",lineHeight:0}),pKt=t=>It({transform:"scale(2.5)",color:t.palette.neutralTertiary}),gKt=It({fontSize:"1rem",color:"inherit"}),mKt=U.memo(t=>{const{localParticipant:e,renderElement:i,isAvailable:r,onCreateLocalStreamView:o,onDisposeLocalScreenShareStreamView:l,localScreenShareView:d="stream"}=t,h=Kl(),p=Cs();if(!i&&d==="stream"&&o&&o(),$.useEffect(()=>()=>{l&&l()},[l]),!e||!e.isScreenSharingOn)return null;const g=U.createElement(Et,{horizontalAlign:"center",verticalAlign:"center",className:dKt},U.createElement(Et,{horizontalAlign:"center",verticalAlign:"center",className:uKt(p),tokens:{childrenGap:"1rem"}},U.createElement(Et,{horizontal:!0,verticalAlign:"center",className:hKt},U.createElement(Fr,{iconName:"ControlButtonScreenShareStart",className:pKt(p)})),U.createElement(ja,{className:gKt,"aria-live":"polite"},h.strings.videoGallery.screenIsBeingSharedMessage))),f=e?.displayName?e?.displayName:h.strings.videoGallery.displayNamePlaceholder,y=h.strings.videoGallery.localScreenShareLoadingMessage;return d==="placeholderMessage"?U.createElement(UO,{displayName:f,isMuted:e?.isMuted,onRenderPlaceholder:()=>U.createElement(U.Fragment,null)},g):U.createElement(UO,{displayName:f,isMuted:e?.isMuted,renderElement:i?U.createElement(w4,{videoStreamElement:i,loadingState:r===!1?"loading":"none"}):void 0,onRenderPlaceholder:()=>U.createElement(s$e,{loadingMessage:y}),mediaAccess:e.mediaAccess})}),fKt=It({position:"relative",width:"100%",height:"100%"}),vKt=(t,e)=>({root:{position:"absolute",width:_n(e==="large"?40:32),height:_n(e==="large"?40:32),right:"0rem",top:"0rem",color:"#FFFFFF",zIndex:2,background:"rgba(0,0,0,0.4)",borderRadius:t.effects.roundedCorner2},rootFocused:{color:"#FFFFFF",background:"rgba(0,0,0,0.4)"},rootDisabled:{position:"absolute"},icon:{paddingLeft:_n(3),paddingRight:_n(3),margin:0},flexContainer:{paddingBottom:_n(8),height:"unset"}}),yKt={root:{width:"100%",height:"100%"}};var SKt=function(t,e,i,r){function o(l){return l instanceof i?l:new i(function(d){d(l)})}return new(i||(i=Promise))(function(l,d){function h(f){try{g(r.next(f))}catch(y){d(y)}}function p(f){try{g(r.throw(f))}catch(y){d(y)}}function g(f){f.done?l(f.value):o(f.value).then(h,p)}g((r=r.apply(t,e||[])).next())})};const l$e=t=>{const{cameras:e,selectedCamera:i,onSelectCamera:r,label:o,ariaDescription:l,size:d}=t,h=hc(),[p,g]=$.useState(!1),f=$.useCallback(C=>SKt(void 0,void 0,void 0,function*(){if(r){g(!0);try{yield r(C)}finally{g(!1)}}}),[r]),y=!!p,T=Kl().strings.cameraButton.tooltipVideoLoadingContent;return U.createElement(zy,{"data-ui-id":"local-camera-switcher-button",styles:vKt(h,d),disabled:y,iconProps:{iconName:"LocalCameraSwitch"},ariaLabel:o,ariaDescription:y?T:l,"aria-live":"polite",onClick:()=>{if(e&&e.length>1&&i!==void 0){const C=e.findIndex(I=>i.id===I.id),E=e[(C+1)%e.length];if(!E)throw new Error("Camera not found");f(E)}}})},Cme=U.memo(t=>{const{isAvailable:e,isMuted:i,onCreateLocalStreamView:r,onDisposeLocalStreamView:o,localVideoViewOptions:l,renderElement:d,userId:h,showLabel:p,alwaysShowLabelBackground:g,displayName:f,initialsName:y,onRenderAvatar:T,showMuteIndicator:C,styles:E,showCameraSwitcherInLocalPreview:I,localVideoCameraCycleButtonProps:w,localVideoCameraSwitcherLabel:D,localVideoSelectedDescription:F,raisedHand:x,reaction:B,isSpotlighted:L,spotlightedParticipantUserIds:z,onStartSpotlight:H,onStopSpotlight:j,maxParticipantsToSpotlight:J,menuKind:Z,strings:re,reactionResources:ne,isScreenSharingOn:le,mediaAccess:he}=t,Me=Cs(),Le=$.useMemo(()=>({isMirrored:l?.isMirrored,isStreamAvailable:e,onCreateLocalStreamView:r,onDisposeLocalStreamView:o,renderElementExists:!!d,scalingMode:l?.scalingMode,isVideoPermitted:he?he.isVideoPermitted:!0}),[e,l?.isMirrored,l?.scalingMode,r,o,d,he]);cWt(Le);const pe=qVe({participant:{userId:h??""},strings:Object.assign({},re),spotlightedParticipantUserIds:z,isSpotlighted:L,onStartSpotlight:H,onStopSpotlight:j,maxParticipantsToSpotlight:J,myUserId:h}),te=$.useMemo(()=>Z!=="contextual"||!pe?{}:{contextualMenu:pe},[pe,Z]),Se=$.useMemo(()=>L?Ds({root:{outline:`0.25rem solid ${Me.palette.neutralTertiaryAlt}`,outlineOffset:"-0.25rem"}},E):E,[L,Me.palette.neutralTertiaryAlt,E]),[ce,X]=U.useState([]),ve=$.useCallback(Ge=>{Ge.key==="Enter"&&X(c$e(pe,()=>X([])))},[X,pe]),Te=$.useMemo(()=>{if(!(!d||!d.childElementCount))return U.createElement(U.Fragment,null,U.createElement(bKt,{showCameraSwitcherInLocalPreview:I??!1,localVideoCameraCycleButtonProps:w,localVideoCameraSwitcherLabel:D,localVideoSelectedDescription:F}),U.createElement(w4,{videoStreamElement:d,isMirrored:!0}),t.participantsCount===1&&!le&&U.createElement(Et,{className:It(R4,AWt())},U.createElement(gx,{label:re?.waitingScreenText,ariaLive:"assertive",role:"alert",labelPosition:"bottom",styles:QVe(Me,!0)})))},[w,D,F,d,I,t.participantsCount,re?.waitingScreenText,Me,le]),Be=$.useMemo(()=>ne!==void 0?U.createElement(bme,{overlayMode:"grid-tiles",reaction:B,reactionResources:ne}):void 0,[B,ne]),qe=$.useCallback(()=>U.createElement(Et,{className:It(R4,IWt())},U.createElement(gx,{label:re?.waitingScreenText,ariaLive:"assertive",labelPosition:"bottom",role:"alert",styles:QVe(Me,!1)})),[re?.waitingScreenText,Me]);return U.createElement(Et,{"data-ui-id":"local-video-tile",className:It({width:"100%",height:"100%"}),onKeyDown:Z==="drawer"?ve:void 0},U.createElement(UO,Object.assign({key:h??"local-video-tile",userId:h,renderElement:Te,showLabel:p,alwaysShowLabelBackground:g,displayName:f,initialsName:y,styles:Se,onRenderPlaceholder:t.participantsCount===1&&!le?qe:T,isMuted:i,showMuteIndicator:C,personaMinSize:t.personaMinSize,raisedHand:x,isSpotlighted:L},te,{onLongTouch:()=>X(c$e(pe,()=>X([]))),overlay:Be,mediaAccess:he}),ce.length>0&&U.createElement(QU,{hostId:t.drawerMenuHostId},U.createElement(Et,{styles:jVe},U.createElement(sF,{onLightDismiss:()=>X([]),items:ce})))))}),bKt=t=>{const{showCameraSwitcherInLocalPreview:e,localVideoCameraCycleButtonProps:i,localVideoCameraSwitcherLabel:r,localVideoSelectedDescription:o}=t,l=i?.selectedCamera&&o&&Jd(o,{cameraName:i.selectedCamera.name});return U.createElement(Et,{horizontalAlign:"end"},e&&i?.cameras!==void 0&&i?.selectedCamera!==void 0&&i?.onSelectCamera!==void 0&&U.createElement(l$e,{cameras:i.cameras,selectedCamera:i.selectedCamera,onSelectCamera:i.onSelectCamera,label:r,ariaDescription:l}))},c$e=(t,e)=>t?t.items.map(i=>({itemKey:i.key,text:i.text,iconProps:i.iconProps,disabled:i.disabled,onItemClick:()=>{var r;(r=i.onClick)===null||r===void 0||r.call(i),e?.()}})):[],TKt={root:{position:"relative",height:"100%",width:"100%",padding:"0.5rem"}},JZ={childrenGap:"0.5rem"},YZ=1.75,CKt=t=>({background:"none",padding:0,height:"auto",minWidth:`${YZ}rem`,maxWidth:`${YZ}rem`,border:`1px solid ${t.palette.neutralLight}`,borderRadius:t.effects.roundedCorner4}),QZ=.5,_Kt={height:"100%",width:"100%",gap:`${QZ}rem`},EKt={height:"100%",width:"100%",gap:`${QZ}rem`};function d$e(t,e){const i=[];if(e<=0)return i;for(let r=0;r<t.length;r+=e)i.push(t.slice(r,r+e));return i}const AKt=5,IKt=t=>{var e;const{children:i,childrenPerPage:r=AKt,styles:o,onFetchTilesToRender:l}=t,d=qE(),[h,p]=$.useState(0),g=U.Children.count(i),f=Math.ceil(g/r)-1,y=$.useMemo(()=>d$e([...Array(g).keys()],r),[g,r]);$.useEffect(()=>{var x;l&&y&&l((x=y[h])!==null&&x!==void 0?x:[])},[y,l,h]);const C=h*r<g-1?h:f,E=$.useMemo(()=>{const x=y?.[C];return x?x.map(B=>U.Children.toArray(i)[B]):[]},[y,C,i]),I=g>r,w=h===0,D=h===f,F=$.useMemo(()=>({root:o?.children}),[o?.children]);return r<=0?U.createElement(U.Fragment,null):U.createElement(Et,{horizontal:!0,className:It(_Kt,(e=t.styles)===null||e===void 0?void 0:e.root)},I&&U.createElement(u$e,{key:"previous-nav-button",icon:U.createElement(Fr,{iconName:"HorizontalGalleryLeftButton"}),styles:o?.previousButton,onClick:()=>p(Math.max(0,Math.min(f,h-1))),disabled:w,identifier:d.overflowGalleryLeftNavButton}),U.createElement(Et,{horizontal:!0,className:It(EKt)},E.map((x,B)=>U.createElement(Et.Item,{styles:F,key:B,"data-ui-id":d.horizontalGalleryVideoTile},x))),I&&U.createElement(u$e,{key:"next-nav-button",icon:U.createElement(Fr,{iconName:"HorizontalGalleryRightButton"}),styles:o?.nextButton,onClick:()=>p(Math.min(f,h+1)),disabled:D,identifier:d.overflowGalleryRightNavButton}))},u$e=t=>{const e=Cs();return U.createElement(th,{className:It(CKt(e),t.styles),onClick:t.onClick,disabled:t.disabled,"data-ui-id":t.identifier},t.icon)};It({position:"relative",width:"100%",height:"100%"});const CP={width:3.625,height:6.5},F8={width:13.75,height:7.5},_me={width:9,height:5.063},Eme={width:11,height:6.25},Ame=2,ZZ=(t,e,i,r)=>({width:i?`${e.width}rem`:"",height:i?`${e.height}rem`:"",minWidth:i?"":`${e.width}rem`,minHeight:i?"":`${e.height}rem`,position:"absolute",bottom:r!=="horizontalTop"?`${Ime}rem`:"unset",top:r==="horizontalTop"?`${Ime}rem`:"unset",borderRadius:t.effects.roundedCorner4,overflow:"hidden",right:`${Ime}rem`}),wKt=(t,e)=>Ds(ZZ(t,e),{root:{boxShadow:t.effects.elevation8}}),kKt=(t,e)=>Ds({main:It(ZZ(t,e),{bottom:`${M4}rem`,right:`${M4}rem`})},{main:{boxShadow:t.effects.elevation8,":focus-within":{boxShadow:t.effects.elevation16,border:`${_n(2)} solid ${t.palette.neutralPrimary}`}}},{root:{pointerEvents:"none"}},MKt),M4=1,Ime=.5,RKt={root:{position:"absolute",zIndex:Ame,height:"100%",width:"100%"}},MKt={keyboardMoveIconContainer:{zIndex:Ame+1}},PKt=(t,e)=>({minHeight:e?`${lF.height}rem`:`${P4.height}rem`,width:t?e?`calc(100% - ${CP.width}rem)`:`calc(100% - ${F8.width}rem)`:"100%",paddingRight:"0.5rem"}),DKt=t=>({children:t?h$e:LKt}),lF={height:6.5,width:6.5},P4={height:7.5,minWidth:7.5,maxWidth:13.43},h$e={minHeight:`${lF.height}rem`,minWidth:`${lF.width}rem`,maxHeight:`${lF.height}rem`,maxWidth:`${lF.width}rem`},LKt={minHeight:`${P4.height}rem`,minWidth:`${P4.minWidth}rem`,maxHeight:`${P4.height}rem`,maxWidth:`${P4.maxWidth}rem`,width:"100%",height:"100%"},cF={minHeight:5.625,maxHeight:9,width:9},D4={minHeight:6.75,maxHeight:11,width:11},OKt=(t,e,i)=>e&&i?{width:`${cF.width}rem`,height:t?`calc(100% - ${CP.height}rem)`:"100%",paddingBottom:"0.5rem"}:!e&&i?{width:`${cF.width}rem`,height:t?`calc(100% - ${_me.height}rem)`:"100%",paddingBottom:"0.5rem"}:{width:`${D4.width}rem`,height:t?`calc(100% - ${Eme.height}rem)`:"100%",paddingBottom:"0.5rem"},NKt={minHeight:`${cF.minHeight}rem`,minWidth:`${cF.width}rem`,maxHeight:`${cF.maxHeight}rem`,maxWidth:`${cF.width}rem`,width:"100%",height:"100%"},xKt={minHeight:`${D4.minHeight}rem`,minWidth:`${D4.width}rem`,maxHeight:`${D4.maxHeight}rem`,maxWidth:`${D4.width}rem`,width:"100%",height:"100%"},BKt=t=>t?{children:NKt}:{children:xKt},FKt=t=>{const{numberOfChildren:e,containerWidth:i,buttonWidthRem:r,gapWidthRem:o}=t,l=cT(P4.minWidth),d=cT(o),h=Math.floor((i+d)/(l+d));if(e<=h)return h;const p=cT(r),g=i-2*p-2*d;return Math.max(Math.floor((g+d)/(l+d)),1)},UKt=t=>{const{numberOfChildren:e,containerHeight:i,gapHeightRem:r,controlBarHeight:o,isShort:l}=t,d=cT(l?cF.minHeight:D4.minHeight),h=cT(r),p=cT(o),g=Math.floor((i+h)/(d+h));if(e<=g)return g;const f=i-p-2*h;return Math.max(Math.floor((f+h)/(d+h)),1)},zKt=t=>{const{gapWidthRem:e,buttonWidthRem:i=0,onFetchTilesToRender:r,onChildrenPerPageChange:o}=t,l=$.useRef(null),d=nF(l),h=l.current?parseFloat(getComputedStyle(l.current).paddingLeft):0,p=l.current?parseFloat(getComputedStyle(l.current).paddingRight):0;let g=Math.max((d??0)-h-p,0);Number.isNaN(g)&&(g=0);const f=FKt({numberOfChildren:U.Children.count(t.children),containerWidth:g,gapWidthRem:e,buttonWidthRem:i});return o?.(f),U.createElement("div",{"data-ui-id":"responsive-horizontal-gallery",ref:l,className:It(t.containerStyles)},U.createElement(IKt,{childrenPerPage:f,styles:t.horizontalGalleryStyles,onFetchTilesToRender:r},t.children))},wme=.5,VKt=t=>({width:"100%",height:`calc(100% - ${t+wme}rem)`,gap:`${wme}rem`}),$Kt={height:"100%",width:"inherit",gap:`${wme}rem`,position:"relative"},HKt={height:"2rem",width:"100%",position:"absolute",bottom:"0"},p$e=t=>({background:"none",padding:0,height:"auto",borderRadius:t.effects.roundedCorner4,border:"none",minWidth:"2rem"}),jKt={lineHeight:"2rem",width:"100%",textAlign:"center"},g$e={root:{lineHeight:"0"}},GKt=t=>{const{children:e,styles:i,childrenPerPage:r,onFetchTilesToRender:o}=t,[l,d]=$.useState(1),[h,p]=$.useState({previous:!0,next:!0}),g=qE(),f=U.Children.count(e),y=Math.ceil(f/r),T=$.useMemo(()=>d$e([...Array(f).keys()],r),[f,r]);$.useEffect(()=>{var L;o&&T&&o((L=T[l-1])!==null&&L!==void 0?L:[])},[T,o,l]);const E=(l-1)*r<f-1?l:y,I=$.useMemo(()=>{var L;if(T[0]!==void 0)return(L=T[E-1])===null||L===void 0?void 0:L.map(z=>U.Children.toArray(e)[z])},[T,E,e]),w=f>r,D=()=>{d(l-1)},F=()=>{d(l+1)};l>y&&y>0&&d(y),$.useEffect(()=>{l>1&&l<y&&w?p({previous:!1,next:!1}):l===1&&w?p({previous:!0,next:!1}):l===y&&w&&p({previous:!1,next:!0})},[l,f,y,w]);const x=$.useMemo(()=>({root:VKt(2)}),[]),B=$.useMemo(()=>({root:i?.children}),[i?.children]);return r<=0?U.createElement(U.Fragment,null):U.createElement(Et,{className:It($Kt,i?.root)},U.createElement(Et,{styles:x},I?.map((L,z)=>U.createElement(Et.Item,{key:z,styles:B,"data-ui-id":g.verticalGalleryVideoTile},L))),w&&U.createElement(qKt,{buttonsDisabled:h,onPreviousButtonClick:D,onNextButtonClick:F,totalPages:y,currentPage:l}))},qKt=t=>{const{onNextButtonClick:e,onPreviousButtonClick:i,buttonsDisabled:r,currentPage:o,totalPages:l,styles:d}=t,h=Cs(),p=qE(),g=Kl().strings.verticalGallery,f=$.useMemo(()=>It(HKt,d?.root),[d?.root]),y=$.useMemo(()=>It(p$e(h),d?.previousButton),[d?.previousButton,h]),T=$.useMemo(()=>It(jKt,d?.counter),[d?.counter]),C=$.useMemo(()=>It(p$e(h),d?.nextButton),[d?.nextButton,h]),E={childrenGap:"0.5rem"},I=g.leftNavButtonAriaLabel?Jd(g.leftNavButtonAriaLabel,{current:`${o}`,total:`${l}`}):void 0,w=g.rightNavButtonAriaLabel?Jd(g.rightNavButtonAriaLabel,{current:`${o}`,total:`${l}`}):void 0;return U.createElement(Et,{horizontalAlign:"center",tokens:E,horizontal:!0,className:f},U.createElement(th,{className:y,onClick:i,disabled:r?.previous,ariaLabel:I,"data-ui-id":p.overflowGalleryLeftNavButton},U.createElement(Fr,{iconName:"VerticalGalleryLeftButton",styles:g$e})),U.createElement(ja,{"data-ui-id":p.verticalGalleryPageCounter,className:T},`${o} / ${l}`),U.createElement(th,{className:C,onClick:e,disabled:r?.next,ariaLabel:w,"data-ui-id":p.overflowGalleryRightNavButton},U.createElement(Fr,{iconName:"VerticalGalleryRightButton",styles:g$e})))},WKt=t=>{var e;const{children:i,containerStyles:r,verticalGalleryStyles:o,gapHeightRem:l,controlBarHeightRem:d,isShort:h,onFetchTilesToRender:p,onChildrenPerPageChange:g}=t,f=$.useRef(null),y=_8(f),T=f.current?parseFloat(getComputedStyle(f.current).paddingTop):0,C=f.current?parseFloat(getComputedStyle(f.current).paddingBottom):0;let E=Math.max((y??0)-T-C,0);Number.isNaN(E)&&(E=0);const I=UKt({numberOfChildren:(e=U.Children.count(i))!==null&&e!==void 0?e:0,containerHeight:E,gapHeightRem:l,controlBarHeight:d??2,isShort:h??!1});return g?.(I),U.createElement("div",{"data-ui-id":"responsive-vertical-gallery",ref:f,className:It(r)},U.createElement(GKt,{childrenPerPage:I,styles:o,onFetchTilesToRender:p},i))};var KKt=typeof window<"u"?$.useLayoutEffect:$.useEffect;function JKt(t,e){var i={},r=i.decayRate,o=r===void 0?.95:r,l=i.safeDisplacement,d=l===void 0?10:l,h=i.applyRubberBandEffect,p=h===void 0?!1:h,g=i.activeMouseButton,f=g===void 0?"Left":g,y=i.isMounted,T=y===void 0?!0:y,C=$.useRef({isMouseDown:!1,isDraggingX:!1,isDraggingY:!1,initialMouseX:0,initialMouseY:0,lastMouseX:0,lastMouseY:0,scrollSpeedX:0,scrollSpeedY:0,lastScrollX:0,lastScrollY:0}),E=!1,I=!1,w=0,D=0,F,x,B,L,z=1/60*1e3;KKt(function(){T&&(E=window.getComputedStyle(t.current).overflowX==="scroll",I=window.getComputedStyle(t.current).overflowY==="scroll",w=t.current.scrollWidth-t.current.clientWidth,D=t.current.scrollHeight-t.current.clientHeight,F=window.getComputedStyle(t.current).cursor,x=[],B=[],L=[],t.current.childNodes.forEach(function(ce){x.push(window.getComputedStyle(ce).cursor),B.push(window.getComputedStyle(ce).transform==="none"?"":window.getComputedStyle(ce).transform),L.push(window.getComputedStyle(ce).transition==="none"?"":window.getComputedStyle(ce).transition)}))},[T]);var H=function(){var X=C.current.scrollSpeedX*z,ve=C.current.scrollSpeedY*z,Te=t.current.scrollLeft+X,Be=t.current.scrollTop+ve;t.current.scrollLeft=Te,t.current.scrollTop=Be,C.current.lastScrollX=Te,C.current.lastScrollY=Be},j=function(X){var ve=X.clientX-C.current.initialMouseX,Te=X.clientY-C.current.initialMouseY,Be=t.current,qe=Be.clientWidth,Ge=Be.clientHeight,tt=0,ct=0;E&&I?(tt=.3*qe*Math.sign(ve)*Math.log10(1+.5*Math.abs(ve)/qe),ct=.3*Ge*Math.sign(Te)*Math.log10(1+.5*Math.abs(Te)/Ge)):E?tt=.3*qe*Math.sign(ve)*Math.log10(1+.5*Math.abs(ve)/qe):I&&(ct=.3*Ge*Math.sign(Te)*Math.log10(1+.5*Math.abs(Te)/Ge)),t.current.childNodes.forEach(function(Mt){Mt.style.transform="translate3d("+tt+"px, "+ct+"px, 0px)",Mt.style.transition="transform 0ms"})},J=function(){t.current.childNodes.forEach(function(X,ve){X.style.transform=B[ve],X.style.transition=L[ve]})},Z,re,ne,le=function(){var X=.05;if(re=setInterval(function(){var Te=C.current.scrollSpeedX,Be=Te*o;C.current.scrollSpeedX=Be;var qe=t.current.scrollLeft<=0,Ge=t.current.scrollLeft>=w,tt=qe||Ge;H(),(Math.abs(Be)<X||C.current.isMouseDown||tt)&&(C.current.scrollSpeedX=0,clearInterval(re))},z),ne=setInterval(function(){var Te=C.current.scrollSpeedY,Be=Te*o;C.current.scrollSpeedY=Be;var qe=t.current.scrollTop<=0,Ge=t.current.scrollTop>=D,tt=qe||Ge;H(),(Math.abs(Be)<X||C.current.isMouseDown||tt)&&(C.current.scrollSpeedY=0,clearInterval(ne))},z),C.current.isDraggingX=!1,C.current.isDraggingY=!1,p){var ve=250;t.current.childNodes.forEach(function(Te){Te.style.transform="translate3d(0px, 0px, 0px)",Te.style.transition="transform "+ve+"ms"}),Z=setTimeout(J,ve)}},he=function(X){X.preventDefault(),X.stopImmediatePropagation()},Me=function(X){return f==="Left"&&X===1||f==="Middle"&&X===4||f==="Right"&&X===2},Le=function(X){var ve=Me(X.buttons);ve&&(C.current.isMouseDown=!0,C.current.lastMouseX=X.clientX,C.current.lastMouseY=X.clientY,C.current.initialMouseX=X.clientX,C.current.initialMouseY=X.clientY)},pe=function(X){var ve=C.current.isDraggingX||C.current.isDraggingY,Te=C.current.initialMouseX-X.clientX,Be=C.current.initialMouseY-X.clientY,qe=Math.abs(Te)>d||Math.abs(Be)>d,Ge=ve&&qe;Ge?t.current.childNodes.forEach(function(tt){tt.addEventListener("click",he)}):t.current.childNodes.forEach(function(tt){tt.removeEventListener("click",he)}),C.current.isMouseDown=!1,C.current.lastMouseX=0,C.current.lastMouseY=0,t.current.style.cursor=F,t.current.childNodes.forEach(function(tt,ct){tt.style.cursor=x[ct]}),Ge&&le()},te=function(X){if(C.current.isMouseDown){X.preventDefault();var ve=C.current.lastMouseX-X.clientX;C.current.lastMouseX=X.clientX,C.current.scrollSpeedX=ve/z,C.current.isDraggingX=!0;var Te=C.current.lastMouseY-X.clientY;C.current.lastMouseY=X.clientY,C.current.scrollSpeedY=Te/z,C.current.isDraggingY=!0,t.current.style.cursor="grabbing",t.current.childNodes.forEach(function(Mt){Mt.style.cursor="grabbing"});var Be=t.current.scrollLeft<=0&&E,qe=t.current.scrollLeft>=w&&E,Ge=t.current.scrollTop<=0&&I,tt=t.current.scrollTop>=D&&I,ct=Be||qe||Ge||tt;ct&&p&&j(X),H()}},Se=function(){w=t.current.scrollWidth-t.current.clientWidth,D=t.current.scrollHeight-t.current.clientHeight};return $.useEffect(function(){return T&&(window.addEventListener("mouseup",pe),window.addEventListener("mousemove",te),window.addEventListener("resize",Se)),function(){window.removeEventListener("mouseup",pe),window.removeEventListener("mousemove",te),window.removeEventListener("resize",Se),clearInterval(re),clearInterval(ne),clearTimeout(Z)}},[T]),{events:{onMouseDown:Le}}}const YKt={root:{width:"100%",minHeight:`${lF.height}rem`,paddingRight:"0.5rem","> *":h$e}},QKt={display:"flex",minHeight:`${lF.height}rem`,overflow:"scroll","-ms-overflow-style":"none","scrollbar-width":"none","::-webkit-scrollbar":{display:"none"}},ZKt=t=>{const{horizontalGalleryElements:e,onFetchTilesToRender:i,containerStyles:r}=t;$.useEffect(()=>{const d=[...Array(e?.length).keys()];i&&d&&i(d??[])},[i,e?.length]);const o=$.useRef(),{events:l}=JKt(o);return U.createElement("div",Object.assign({ref:o},l,{className:It(QKt,r)}),U.createElement(Et,{"data-ui-id":"scrollable-horizontal-gallery",horizontal:!0,styles:YKt,tokens:{childrenGap:"0.5rem"}},e))},kme=t=>{const{shouldFloatLocalVideo:e=!1,onFetchTilesToRender:i,isNarrow:r=!1,isShort:o=!1,overflowGalleryElements:l,horizontalGalleryStyles:d,overflowGalleryPosition:h="horizontalBottom",verticalGalleryStyles:p,onChildrenPerPageChange:g,parentWidth:f}=t,y=$.useMemo(()=>h==="verticalRight"?OKt(e,r,o):PKt(e,r),[e,o,r,h]),T=$.useMemo(()=>h==="verticalRight"?Ds(BKt(o),p):Ds(DKt(r),d),[r,o,d,h,p]),C=$.useMemo(()=>{if(r&&f)return{width:e?`${EDe(f)-CP.width-1}rem`:`${EDe(f)-1}rem`}},[r,f,e]);return h==="verticalRight"?U.createElement(WKt,{key:"responsive-vertical-gallery",containerStyles:y,verticalGalleryStyles:T,controlBarHeightRem:YZ,gapHeightRem:QZ,isShort:o,onFetchTilesToRender:i,onChildrenPerPageChange:g},l||[U.createElement(U.Fragment,null)]):r?(g?.(3),U.createElement(ZKt,{horizontalGalleryElements:l||[U.createElement(U.Fragment,null)],onFetchTilesToRender:i,key:"scrollable-horizontal-gallery",containerStyles:C})):U.createElement(zKt,{key:"responsive-horizontal-gallery",containerStyles:y,onFetchTilesToRender:i,horizontalGalleryStyles:T,buttonWidthRem:YZ,gapWidthRem:QZ,onChildrenPerPageChange:g},l||[U.createElement(U.Fragment,null)])},XKt=t=>{const{remoteParticipants:e=[],localParticipant:i,dominantSpeakers:r,localVideoComponent:o,screenShareComponent:l,onRenderRemoteParticipant:d,styles:h,maxRemoteVideoStreams:p,parentWidth:g,parentHeight:f,pinnedParticipantUserIds:y=[],overflowGalleryPosition:T="horizontalBottom",spotlightedParticipantUserIds:C=[]}=t,E=g?E8(g):!1,I=f?Gge(f):!1,w=$.useRef(4),D=e.filter(J=>{var Z;return(Z=J.videoStream)===null||Z===void 0?void 0:Z.isAvailable}).length>0,{gridParticipants:F,overflowGalleryParticipants:x}=yme({remoteParticipants:e,localParticipant:i,dominantSpeakers:r,maxGridParticipants:D?p:i$e,isScreenShareActive:!!l,maxOverflowGalleryDominantSpeakers:l?w.current-(y.length+1)%w.current:w.current,pinnedParticipantUserIds:y,layout:"default",spotlightedParticipantUserIds:C}),[B,L]=$.useState([]);let{gridTiles:z,overflowGalleryTiles:H}=Sme(F,d,p,B,x,r);o&&(l||C.length>0?H=[o].concat(H):z=[o].concat(z));const j=$.useMemo(()=>H.length===0?null:U.createElement(kme,{isNarrow:E,isShort:I,shouldFloatLocalVideo:!1,overflowGalleryElements:H,horizontalGalleryStyles:h?.horizontalGallery,verticalGalleryStyles:h?.verticalGallery,overflowGalleryPosition:T,onFetchTilesToRender:L,onChildrenPerPageChange:J=>{w.current=J},parentWidth:g}),[E,I,H,h?.horizontalGallery,T,L,h?.verticalGallery,g]);return U.createElement(Et,{horizontal:T==="verticalRight",styles:TKt,tokens:JZ},t.overflowGalleryPosition==="horizontalTop"?j:U.createElement(U.Fragment,null),l||U.createElement(xge,{key:"grid-layout",styles:h?.gridLayout},z),eJt(j,t.overflowGalleryPosition))},eJt=(t,e)=>e!=="horizontalTop"?t:U.createElement(U.Fragment,null),m$e=SL.durationValue2,L4={x:0,y:0},tJt={isOpen:!1,isDarkOverlay:!0,className:"",containerClassName:"",enableAriaHiddenSiblings:!0},iJt=fu(),nJt=t=>{let e=10;return t.shiftKey?t.ctrlKey||(e=50):t.ctrlKey&&(e=1),e},aJt=(t,e)=>{$.useImperativeHandle(t.componentRef,()=>({focus(){e.current&&e.current.focus()}}),[e])},f$e=$.forwardRef((t,e)=>{var i;const r=Lw(tJt,t),{allowTouchBodyScroll:o,className:l,children:d,containerClassName:h,scrollableContentClassName:p,elementToFocusOnDismiss:g,firstFocusableSelector:f,forceFocusInsideTrap:y,ignoreExternalFocusing:T,isBlocking:C,isAlert:E,isClickableOutsideFocusTrap:I,isDarkOverlay:w,onDismiss:D,layerProps:F,overlay:x,isOpen:B,titleAriaId:L,styles:z,subtitleAriaId:H,theme:j,topOffsetFixed:J,responsiveMode:Z,onLayerDidMount:re,isModeless:ne,dragOptions:le,onDismissed:he,minDragPosition:Me,maxDragPosition:Le,dataUiId:pe,keyEventElement:te=window}=r,Se=$.useRef(null),ce=$.useRef(null),X=$.useRef(null),ve=Ff(Se,e),Te=hW(ve),Be=yu("ModalFocusTrapZone"),{setTimeout:qe,clearTimeout:Ge}=AEe(),[tt,ct]=$.useState(B),[Mt,ht]=$.useState(B),[vt,Pt]=$.useState(L4),[ni,Zt]=$.useState(),[it,{setTrue:Ke,setFalse:ot}]=Tre(!1),[Ht,jt]=$.useState(0),Nt=$.useCallback(()=>jt(qt=>qt+1),[]),Vt=oT(()=>({onModalCloseTimer:0,allowTouchBodyScroll:o,scrollableContent:null,lastSetCoordinates:L4,events:new pE({})})),{keepInBounds:$t}=le||{},dt=E??(C&&!ne),yt=F===void 0?"":F.className,kt=iJt(z,{theme:j,className:l,containerClassName:h,scrollableContentClassName:p,isOpen:B,isVisible:Mt,hasBeenOpened:Vt.hasBeenOpened,modalRectangleTop:ni,topOffsetFixed:J,isModeless:ne,layerClassName:yt,windowInnerHeight:window?.innerHeight,isDefaultDragHandle:le&&!le.dragHandleSelector}),je=Object.assign(Object.assign({eventBubblingEnabled:!1},F),{onLayerDidMount:F&&F.onLayerDidMount?F.onLayerDidMount:re,insertFirst:ne,className:kt.layer}),Ae=$.useCallback(qt=>{qt?Vt.allowTouchBodyScroll?Kae(qt,Vt.events):Wae(qt,Vt.events):Vt.events.off(Vt.scrollableContent),Vt.scrollableContent=qt},[Vt]),xe=()=>{const qt=X.current,ri=qt?.getBoundingClientRect();ri&&(J&&Zt(ri.top),$t&&(Vt.minPosition=Me??{x:-ri.left,y:-ri.top},Vt.maxPosition=Le??{x:ri.left,y:ri.top},Pt({x:gt("x",vt.x),y:gt("y",vt.y)})))},gt=$.useCallback((qt,ri)=>{const{minPosition:Ti,maxPosition:rn}=Vt;return $t&&Ti&&rn&&(ri=Math.max(Ti[qt],ri),ri=Math.min(rn[qt],ri)),ri},[$t,Vt]),Ye=()=>{var qt;Vt.lastSetCoordinates=L4,ot(),Vt.isInKeyboardMoveMode=!1,ct(!1),Pt(L4),(qt=Vt.disposeOnKeyUp)===null||qt===void 0||qt.call(Vt),he?.()},Fe=$.useCallback(()=>{ot(),Vt.isInKeyboardMoveMode=!1},[Vt,ot]),St=$.useCallback((qt,ri)=>{Pt(Ti=>({x:gt("x",Ti.x+ri.delta.x),y:gt("y",Ti.y+ri.delta.y)}))},[gt]),Wt=$.useCallback(()=>{ce.current&&ce.current.focus()},[]),Ii=()=>{const qt=ri=>{const Ti=ri;if(Ti.altKey&&Ti.ctrlKey&&Ti.keyCode===fa.space){Ti.preventDefault(),Ti.stopPropagation();return}const rn=Ti.altKey||Ti.keyCode===fa.escape;if(it&&rn&&ot(),Vt.isInKeyboardMoveMode&&(Ti.keyCode===fa.escape||Ti.keyCode===fa.enter)&&(Vt.isInKeyboardMoveMode=!1,Nt(),Ti.preventDefault(),Ti.stopPropagation()),Vt.isInKeyboardMoveMode){let Hn=!0;const ha=nJt(Ti);switch(Ti.keyCode){case fa.escape:Pt(Vt.lastSetCoordinates);case fa.enter:{Vt.lastSetCoordinates=L4;break}case fa.up:{Pt(hr=>({x:hr.x,y:gt("y",hr.y-ha)}));break}case fa.down:{Pt(hr=>({x:hr.x,y:gt("y",hr.y+ha)}));break}case fa.left:{Pt(hr=>({x:gt("x",hr.x-ha),y:hr.y}));break}case fa.right:{Pt(hr=>({x:gt("x",hr.x+ha),y:hr.y}));break}default:Hn=!1}Hn&&(Ti.preventDefault(),Ti.stopPropagation())}};Vt.lastSetCoordinates=vt,ot(),Vt.isInKeyboardMoveMode=!0,te.addEventListener("keydown",qt,!0),Vt.disposeOnKeyDown=()=>{te.removeEventListener("keydown",qt,!0),Vt.disposeOnKeyDown=void 0}},en=()=>{var qt;Vt.lastSetCoordinates=L4,Vt.isInKeyboardMoveMode=!1,(qt=Vt.disposeOnKeyDown)===null||qt===void 0||qt.call(Vt)},sn=()=>{const qt=ri=>{const Ti=ri;Ti.altKey&&Ti.ctrlKey&&Ti.keyCode===fa.space&&xy(Vt.scrollableContent,Ti.target)&&(Ke(),Ti.preventDefault(),Ti.stopPropagation())};Vt.disposeOnKeyUp||(te.addEventListener("keyup",qt,!0),Vt.disposeOnKeyUp=()=>{te.removeEventListener("keyup",qt,!0),Vt.disposeOnKeyUp=void 0})};$.useEffect(()=>{Ge(Vt.onModalCloseTimer),B&&(requestAnimationFrame(()=>qe(xe,0)),ct(!0),le&&sn(),Vt.hasBeenOpened=!0,ht(!0)),!B&&tt&&(Vt.onModalCloseTimer=qe(Ye,parseFloat(m$e)*1e3),ht(!1))},[tt,B,Me,Le]),aW(()=>{Vt.events.dispose()}),aJt(r,ce);const Qi=$.createElement(Nw,Object.assign({disabled:!0,id:Be,ref:X,componentRef:ce,className:kt.main,elementToFocusOnDismiss:g,isClickableOutsideFocusTrap:ne||I||!C,ignoreExternalFocusing:T,forceFocusInsideTrap:y&&!ne,firstFocusableSelector:f,focusPreviouslyFocusedInnerElement:!0,onBlur:Vt.isInKeyboardMoveMode?en:void 0,"data-ui-id":pe},(i=r.focusTrapZoneProps)!==null&&i!==void 0?i:{}),le&&Vt.isInKeyboardMoveMode&&$.createElement("div",{className:kt.keyboardMoveIconContainer},le.keyboardMoveIconProps?$.createElement(Fr,Object.assign({},le.keyboardMoveIconProps)):$.createElement(Fr,{iconName:"move",className:kt.keyboardMoveIcon})),$.createElement("div",{ref:Ae,className:kt.scrollableContent,"data-is-scrollable":!0},le&&it&&$.createElement(le.menu,{items:[{key:"move",text:le.moveMenuItemText,onClick:Ii},{key:"close",text:le.closeMenuItemText,onClick:Ye}],onDismiss:ot,alignTargetEdge:!0,coverTarget:!0,directionalHint:hd.topLeftEdge,directionalHintFixed:!0,shouldFocusOnMount:!0,target:Vt.scrollableContent}),d));return tt&&Te>=(Z||EL.small)&&$.createElement(QU,Object.assign({ref:ve},je),$.createElement(eH,{role:dt?"alertdialog":"dialog",ariaLabelledBy:L,ariaDescribedBy:H,shouldRestoreFocus:!T,"aria-modal":!ne},$.createElement("div",{className:kt.root,role:ne?void 0:"document"},!ne&&$.createElement(Ure,Object.assign({"aria-hidden":!0,isDarkThemed:w,onClick:C?void 0:D,allowTouchBodyScroll:o},x)),le?$.createElement(oJt,{handleSelector:le.dragHandleSelector||`#${Be}`,preventDragSelector:"button",onStart:Fe,onDragChange:St,onStop:Wt,position:vt},Qi):Qi)))||null});f$e.displayName="ModalBase";const rJt=ql((t,e)=>({root:It(t,e&&{touchAction:"none",selectors:{"& *":{userSelect:"none"}}})})),U8={touch:{start:"touchstart",move:"touchmove",stop:"touchend"},mouse:{start:"mousedown",move:"mousemove",stop:"mouseup"}};class oJt extends $.Component{constructor(e){super(e),this._currentEventType=U8.mouse,this._events=[],this._onMouseDown=i=>{const r=$.Children.only(this.props.children).props.onMouseDown;return r&&r(i),this._currentEventType=U8.mouse,this._onDragStart(i)},this._onMouseUp=i=>{const r=$.Children.only(this.props.children).props.onMouseUp;return r&&r(i),this._currentEventType=U8.mouse,this._onDragStop(i)},this._onTouchStart=i=>{const r=$.Children.only(this.props.children).props.onTouchStart;return r&&r(i),this._currentEventType=U8.touch,this._onDragStart(i)},this._onTouchEnd=i=>{const r=$.Children.only(this.props.children).props.onTouchEnd;r&&r(i),this._currentEventType=U8.touch,this._onDragStop(i)},this._onDragStart=i=>{if(typeof i.button=="number"&&i.button!==0)return!1;if(this.props.handleSelector&&!this._matchesSelector(i.target,this.props.handleSelector)||this.props.preventDragSelector&&this._matchesSelector(i.target,this.props.preventDragSelector))return;this._touchId=this._getTouchId(i);const r=this._getControlPosition(i);if(r===void 0)return;const o=this._createDragDataFromPosition(r);this.props.onStart&&this.props.onStart(i,o),this.setState({isDragging:!0,lastPosition:r}),this._events=[hE(document.body,this._currentEventType.move,this._onDrag,!0),hE(document.body,this._currentEventType.stop,this._onDragStop,!0)]},this._onDrag=i=>{i.type==="touchmove"&&i.preventDefault();const r=this._getControlPosition(i);if(!r)return;const o=this._createUpdatedDragData(this._createDragDataFromPosition(r)),l=o.position;this.props.onDragChange&&this.props.onDragChange(i,o),this.setState({position:l,lastPosition:r})},this._onDragStop=i=>{if(!this.state.isDragging)return;const r=this._getControlPosition(i);if(!r)return;const o=this._createDragDataFromPosition(r);this.setState({isDragging:!1,lastPosition:void 0}),this.props.onStop&&this.props.onStop(i,o),this.props.position&&this.setState({position:this.props.position}),this._events.forEach(l=>l())},this.state={isDragging:!1,position:this.props.position||{x:0,y:0},lastPosition:void 0}}componentDidUpdate(e){this.props.position&&(!e.position||this.props.position!==e.position)&&this.setState({position:this.props.position})}componentWillUnmount(){this._events.forEach(e=>e())}render(){const e=$.Children.only(this.props.children),{props:i}=e,{position:r}=this.props,{position:o,isDragging:l}=this.state;let d=o.x,h=o.y;return r&&!l&&(d=r.x,h=r.y),$.cloneElement(e,{style:Object.assign(Object.assign({},i.style),{transform:`translate(${d}px, ${h}px)`}),className:rJt(i.className,this.state.isDragging).root,onMouseDown:this._onMouseDown,onMouseUp:this._onMouseUp,onTouchStart:this._onTouchStart,onTouchEnd:this._onTouchEnd})}_getControlPosition(e){const i=this._getActiveTouch(e);if(this._touchId!==void 0&&!i)return;const r=i||e;return{x:r.clientX,y:r.clientY}}_getActiveTouch(e){return e.targetTouches&&this._findTouchInTouchList(e.targetTouches)||e.changedTouches&&this._findTouchInTouchList(e.changedTouches)}_getTouchId(e){const i=e.targetTouches&&e.targetTouches[0]||e.changedTouches&&e.changedTouches[0];if(i)return i.identifier}_matchesSelector(e,i){if(!e||e===document.body)return!1;const r=e.matches||e.webkitMatchesSelector||e.msMatchesSelector;return r?r.call(e,i)||this._matchesSelector(e.parentElement,i):!1}_findTouchInTouchList(e){var i;if(this._touchId!==void 0){for(let r=0;r<e.length;r++)if(((i=e[r])===null||i===void 0?void 0:i.identifier)===this._touchId)return e[r]}}_createDragDataFromPosition(e){const{lastPosition:i}=this.state;return i===void 0?{delta:{x:0,y:0},lastPosition:e,position:e}:{delta:{x:e.x-i.x,y:e.y-i.y},lastPosition:i,position:e}}_createUpdatedDragData(e){const{position:i}=this.state;return{position:{x:i.x+e.delta.x,y:i.y+e.delta.y},delta:e.delta,lastPosition:i}}}const sJt={root:"ms-Modal",main:"ms-Dialog-main",scrollableContent:"ms-Modal-scrollableContent",isOpen:"is-open",layer:"ms-Modal-Layer"},Rme=vu(f$e,t=>{const{className:e,containerClassName:i,scrollableContentClassName:r,isOpen:o,isVisible:l,hasBeenOpened:d,modalRectangleTop:h,theme:p,topOffsetFixed:g,isModeless:f,layerClassName:y,isDefaultDragHandle:T,windowInnerHeight:C}=t,{palette:E,effects:I,fonts:w}=p,D=eh(sJt,p);return{root:[D.root,w.medium,{backgroundColor:"transparent",position:f?"absolute":"fixed",height:"100%",width:"100%",display:"flex",alignItems:"center",justifyContent:"center",opacity:0,pointerEvents:"none",transition:`opacity ${m$e}`},g&&typeof h=="number"&&d&&{alignItems:"flex-start"},o&&D.isOpen,l&&{opacity:1,pointerEvents:"auto"},e],main:[D.main,{boxShadow:I.elevation64,borderRadius:I.roundedCorner2,backgroundColor:E.white,boxSizing:"border-box",position:"relative",textAlign:"left",outline:"3px solid transparent",maxHeight:"calc(100% - 32px)",maxWidth:"calc(100% - 32px)",minHeight:"176px",minWidth:"288px",overflowY:"auto",zIndex:f?ox.Layer:void 0},g&&typeof h=="number"&&d&&{top:h},T&&{cursor:"move"},i],scrollableContent:[D.scrollableContent,{overflowY:"auto",flexGrow:1,maxHeight:"100vh",selectors:{"@supports (-webkit-overflow-scrolling: touch)":{maxHeight:C}}},r],layer:f&&[y,D.layer,{position:"static",width:"unset",height:"unset"}],keyboardMoveIconContainer:{position:"absolute",display:"flex",justifyContent:"center",width:"100%",padding:"3px 0px"},keyboardMoveIcon:{fontSize:w.xLargePlus.fontSize,width:"24px"}}},void 0,{scope:"Modal",fields:["theme","styles","enableAriaHiddenSiblings"]});Rme.displayName="Modal";const lJt={moveMenuItemText:"Move",closeMenuItemText:"Close",menu:hx,keepInBounds:!0},cJt={x:cT(M4),y:cT(M4)},dJt=t=>{var e;const{localVideoComponent:i,layerHostId:r,localVideoSizeRem:o,parentWidth:l,parentHeight:d}=t,h=Cs(),p=Kl().strings.videoGallery,g=$.useMemo(()=>l&&d?{x:-l+cT(o.width)+cT(M4),y:-d+cT(o.height)+cT(M4)}:void 0,[d,l,o.width,o.height]),f=$.useMemo(()=>kKt(h,o),[h,o]),y=$.useMemo(()=>({hostId:r}),[r]);return U.createElement(Rme,{isOpen:!0,isModeless:!0,dragOptions:lJt,styles:f,layerProps:y,maxDragPosition:cJt,minDragPosition:g,dataUiId:"floating-local-video-host"},U.createElement(Et,{"aria-label":(e=p.localVideoMovementAriaLabel)!==null&&e!==void 0?e:p.localVideoMovementLabel,tabIndex:0,role:"dialog",style:{pointerEvents:"auto"}},i))},Mme={root:{position:"relative",height:"100%",width:"100%"}},Pme={root:{position:"relative",height:"100%",width:"100%",padding:"0.5rem"}},Dme={position:"absolute",left:0,top:0,width:"100%",height:"100%",overflow:"hidden",pointerEvents:"none"},uJt=t=>{const{remoteParticipants:e=[],dominantSpeakers:i,localVideoComponent:r,screenShareComponent:o,onRenderRemoteParticipant:l,styles:d,maxRemoteVideoStreams:h,showCameraSwitcherInLocalPreview:p,parentWidth:g,parentHeight:f,overflowGalleryPosition:y="horizontalBottom",pinnedParticipantUserIds:T=[],localVideoTileSize:C,spotlightedParticipantUserIds:E}=t,I=Cs(),w=g?E8(g):!1,D=f?Gge(f):!1,F=$.useRef(4),x=e.filter(Me=>{var Le;return(Le=Me.videoStream)===null||Le===void 0?void 0:Le.isAvailable}).length>0,{gridParticipants:B,overflowGalleryParticipants:L}=yme({remoteParticipants:e,dominantSpeakers:i,maxGridParticipants:x?h:i$e,isScreenShareActive:!!o,maxOverflowGalleryDominantSpeakers:o?F.current-T.length%F.current:F.current,pinnedParticipantUserIds:T,layout:"floatingLocalVideo",spotlightedParticipantUserIds:E}),[z,H]=$.useState([]),{gridTiles:j,overflowGalleryTiles:J}=Sme(B,l,h,z,L,i),Z=e.length>0;!Z&&r&&j.push(r);const re=yu("layerhost"),ne=$.useMemo(()=>w||C==="9:16"?CP:(J.length>0||o)&&y==="verticalRight"?w?CP:D?_me:Eme:(J.length>0||o)&&y==="horizontalBottom"?C==="16:9"||!w?F8:CP:F8,[J.length,w,o,D,y,C]),le=r&&Z||o&&r?p?U.createElement(Et,{className:It(wKt(I,ne),{boxShadow:I.effects.elevation8,zIndex:Ame})},r):J.length>0||o?U.createElement(Et,{className:It(ZZ(I,ne,!!o,y))},r):U.createElement(dJt,{localVideoComponent:r,layerHostId:re,localVideoSizeRem:ne,parentWidth:g,parentHeight:f}):void 0,he=$.useMemo(()=>J.length===0&&!o?null:U.createElement(kme,{isShort:D,onFetchTilesToRender:H,isNarrow:w,shouldFloatLocalVideo:!!r,overflowGalleryElements:J,horizontalGalleryStyles:d?.horizontalGallery,verticalGalleryStyles:d?.verticalGallery,overflowGalleryPosition:y,onChildrenPerPageChange:Me=>{F.current=Me},parentWidth:g}),[w,D,o,J,d?.horizontalGallery,y,H,d?.verticalGallery,g,r]);return U.createElement(Et,{styles:Mme},U.createElement(Et,{horizontal:y==="verticalRight",styles:Pme,tokens:JZ},t.overflowGalleryPosition==="horizontalTop"?he:U.createElement(U.Fragment,null),o||U.createElement(xge,{key:"grid-layout",styles:d?.gridLayout},j),hJt(he,t.overflowGalleryPosition)),U.createElement(tH,{id:re,className:It(Dme)}),le)},hJt=(t,e)=>e!=="horizontalTop"?t:U.createElement(U.Fragment,null),pJt=t=>{const{remoteParticipants:e=[],dominantSpeakers:i,localVideoComponent:r,screenShareComponent:o,onRenderRemoteParticipant:l,styles:d,maxRemoteVideoStreams:h,parentWidth:p,parentHeight:g,overflowGalleryPosition:f="horizontalBottom",pinnedParticipantUserIds:y=[],localVideoTileSize:T}=t,C=hc(),E=p?E8(p):!1,I=g?Gge(g):!1,w=$.useRef(4),{gridParticipants:D,overflowGalleryParticipants:F}=yme({remoteParticipants:e,dominantSpeakers:i,maxGridParticipants:h,isScreenShareActive:!!o,maxOverflowGalleryDominantSpeakers:o?w.current-y.length%w.current:w.current,pinnedParticipantUserIds:y,layout:"speaker"}),[x,B]=$.useState([]),{gridTiles:L,overflowGalleryTiles:z}=Sme(D,l,h,x,F,i);!(e.length>0)&&r&&L.push(r);const j=yu("layerhost"),J=$.useMemo(()=>E||T==="9:16"?CP:(z.length>0||o)&&f==="verticalRight"?E?CP:I?_me:Eme:(z.length>0||o)&&f==="horizontalBottom"?T==="16:9"||!E?F8:CP:F8,[z.length,E,o,I,f,T]),Z=r||o&&r?U.createElement(Et,{className:It(ZZ(C,J,!!o,f))},r):void 0,re=$.useMemo(()=>z.length===0&&!o?null:U.createElement(kme,{isShort:I,onFetchTilesToRender:B,isNarrow:E,shouldFloatLocalVideo:!!r,overflowGalleryElements:z,horizontalGalleryStyles:d?.horizontalGallery,verticalGalleryStyles:d?.verticalGallery,overflowGalleryPosition:f,onChildrenPerPageChange:ne=>{w.current=ne},parentWidth:p}),[E,I,o,z,d?.horizontalGallery,f,B,d?.verticalGallery,p,r]);return U.createElement(Et,{styles:Mme},U.createElement(Et,{horizontal:f==="verticalRight",styles:Pme,tokens:JZ},t.overflowGalleryPosition==="horizontalTop"?re:U.createElement(U.Fragment,null),o||U.createElement(xge,{key:"grid-layout",styles:d?.gridLayout},L),gJt(re,t.overflowGalleryPosition)),U.createElement(tH,{id:j,className:It(Dme)}),Z)},gJt=(t,e)=>e!=="horizontalTop"?t:U.createElement(U.Fragment,null),mJt=t=>{const{screenShareComponent:e}=t,i=yu("layerhost");return U.createElement(Et,{styles:Mme},U.createElement(tH,{id:i,className:It(Dme)}),U.createElement(Et,{styles:Pme,tokens:JZ},e||U.createElement(U.Fragment,null)))},fJt=4,vJt={"-webkit-user-select":"none","-webkit-touch-callout":"none","-moz-user-select":"none","-ms-user-select":"none","user-select":"none"},yJt={kind:"contextual"},v$e=4,XZ=t=>{var e,i,r,o;const{localParticipant:l,remoteParticipants:d=[],localVideoViewOptions:h,remoteVideoViewOptions:p,dominantSpeakers:g,onRenderLocalVideoTile:f,onRenderRemoteVideoTile:y,onCreateLocalStreamView:T,onDisposeLocalStreamView:C,onCreateRemoteStreamView:E,onDisposeRemoteScreenShareStreamView:I,onDisposeLocalScreenShareStreamView:w,onDisposeRemoteVideoStreamView:D,styles:F,layout:x,onRenderAvatar:B,showMuteIndicator:L,maxRemoteVideoStreams:z=fJt,showCameraSwitcherInLocalPreview:H,localVideoCameraCycleButtonProps:j,onPinParticipant:J,onUnpinParticipant:Z,remoteVideoTileMenu:re=yJt,overflowGalleryPosition:ne="horizontalBottom",localVideoTileSize:le="followDeviceOrientation",spotlightedParticipants:he,onStartLocalSpotlight:Me,onStartRemoteSpotlight:Le,onStopLocalSpotlight:pe,onStopRemoteSpotlight:te,maxParticipantsToSpotlight:Se,reactionResources:ce,videoTilesOptions:X,onMuteParticipant:ve,onForbidAudio:Te,onPermitAudio:Be,onForbidVideo:qe,onPermitVideo:Ge,localScreenShareView:tt}=t,ct=qE(),Mt=Cs(),ht=Kl().strings.videoGallery,vt=$.useMemo(()=>Object.assign(Object.assign({},ht),t.strings),[ht,t.strings]),Pt=re&&re.kind==="drawer"?re.hostId:void 0,ni=yu("drawerMenuHost",Pt),Zt=(x==="floatingLocalVideo"||x==="speaker")&&d.length>0,it=$.useRef(null),Ke=nF(it),ot=_8(it),Ht=Ke?E8(Ke):!1,[jt,Nt]=U.useState([]),[Vt,$t]=U.useState({}),dt=$.useCallback((ri,Ti)=>{$t(rn=>Object.assign(Object.assign({},rn),{[ri]:{scalingMode:Ti,isMirrored:p?.isMirrored}}))},[p?.isMirrored]);$.useEffect(()=>{var ri;(ri=t.pinnedParticipants)===null||ri===void 0||ri.forEach(Ti=>{var rn;!((rn=t.remoteParticipants)===null||rn===void 0)&&rn.find(Hn=>Hn.userId===Ti)||console.warn("Invalid pinned participant UserId :"+Ti)})},[t.pinnedParticipants,t.remoteParticipants]);const yt=$.useMemo(()=>{var ri;return(ri=t.pinnedParticipants)!==null&&ri!==void 0?ri:jt.filter(Ti=>d.find(rn=>rn.userId===Ti))},[t.pinnedParticipants,jt,d]),kt=!(Zt&&Ht||le==="9:16")||x==="default",je=$.useMemo(()=>{var ri,Ti;if(le==="hidden")return;if(f)return f(l);const rn=!!l.spotlight,Hn=Ds(Zt?RKt:{},{root:{borderRadius:Mt.effects.roundedCorner4}},F?.localVideo),ha=l.displayName?l.displayName:"",hr=()=>x==="default"?vt.localVideoLabel:Ht?"":vt.localVideoLabel;return U.createElement(Et,{styles:yKt,key:"local-video-tile-key"},U.createElement(Cme,{alwaysShowLabelBackground:X?.alwaysShowLabelBackground,userId:l.userId,onCreateLocalStreamView:T,onDisposeLocalStreamView:C,isAvailable:(ri=l?.videoStream)===null||ri===void 0?void 0:ri.isAvailable,isMuted:l.isMuted,renderElement:(Ti=l?.videoStream)===null||Ti===void 0?void 0:Ti.renderElement,displayName:hr(),initialsName:ha,localVideoViewOptions:h,onRenderAvatar:B,showLabel:kt,showMuteIndicator:L,showCameraSwitcherInLocalPreview:H,localVideoCameraCycleButtonProps:j,localVideoCameraSwitcherLabel:vt.localVideoCameraSwitcherLabel,localVideoSelectedDescription:vt.localVideoSelectedDescription,styles:Hn,raisedHand:l.raisedHand,reaction:l.reaction,spotlightedParticipantUserIds:he,isSpotlighted:rn,onStartSpotlight:Me,onStopSpotlight:pe,maxParticipantsToSpotlight:Se,menuKind:re?re.kind==="drawer"?"drawer":"contextual":void 0,drawerMenuHostId:ni,strings:vt,reactionResources:ce,participantsCount:d.length+1,isScreenSharingOn:l.isScreenSharingOn,mediaAccess:l.mediaAccess}))},[Ht,l,j,h,T,C,B,f,Zt,H,L,F?.localVideo,Mt.effects.roundedCorner4,le,x,kt,he,Me,pe,Se,re,vt,ni,ce,X,d.length]),Ae=$.useCallback(ri=>{yt.length>=v$e||(yt.includes(ri)||Nt(yt.concat(ri)),J?.(ri))},[yt,Nt,J]),xe=$.useCallback(ri=>{Nt(jt.filter(Ti=>Ti!==ri)),Z?.(ri)},[jt,Nt,Z]),[gt,Ye]=U.useState(""),Fe=$.useCallback(ri=>{Ye(ri),setTimeout(()=>{Ye("")},3e3)},[Ye]),St=$.useCallback((ri,Ti)=>{const rn=ri.videoStream,Hn=rn?Vt[ri.userId]:void 0;let ha=yt?.includes(ri.userId);const hr=!!ri.spotlight;ha=hr?!1:ha;const yn=()=>{var pr,Ho;return Hn||(rn?.streamSize&&((pr=rn.streamSize)===null||pr===void 0?void 0:pr.height)>((Ho=rn.streamSize)===null||Ho===void 0?void 0:Ho.width)?{scalingMode:"Fit",isMirrored:p?.isMirrored}:p)};return U.createElement(Tme,{alwaysShowLabelBackground:X?.alwaysShowLabelBackground,streamId:rn?.id,key:ri.userId,userId:ri.userId,remoteParticipant:ri,onCreateRemoteStreamView:Ti?E:void 0,onDisposeRemoteStreamView:Ti?D:void 0,isAvailable:Ti?rn?.isAvailable:!1,isReceiving:Ti?rn?.isReceiving:!1,renderElement:Ti?rn?.renderElement:void 0,remoteVideoViewOptions:yn(),onRenderAvatar:B,showMuteIndicator:L,strings:vt,participantState:ri.state,menuKind:ri.userId===l.userId?void 0:re?re.kind==="drawer"?"drawer":"contextual":void 0,drawerMenuHostId:ni,onPinParticipant:Ae,onUnpinParticipant:xe,onUpdateScalingMode:dt,isPinned:ha,disablePinMenuItem:yt.length>=v$e,toggleAnnouncerString:Fe,spotlightedParticipantUserIds:he,isSpotlighted:hr,onStartSpotlight:Le,onStopSpotlight:te,maxParticipantsToSpotlight:Se,reactionResources:ce,onMuteParticipant:ve,onForbidAudio:Te,onPermitAudio:Be,onForbidVideo:qe,onPermitVideo:Ge})},[Vt,yt,X?.alwaysShowLabelBackground,E,D,B,L,vt,l.userId,re,ni,Ae,xe,dt,Fe,he,Le,te,Se,ce,ve,Te,Be,qe,Ge,p]),Wt=d.find(ri=>{var Ti;return(Ti=ri.screenShareStream)===null||Ti===void 0?void 0:Ti.isAvailable}),Ii=U.createElement(mKt,{localParticipant:l,renderElement:(e=l.screenShareStream)===null||e===void 0?void 0:e.renderElement,isAvailable:(i=l.screenShareStream)===null||i===void 0?void 0:i.isAvailable,onCreateLocalStreamView:T,onDisposeLocalScreenShareStreamView:w,localScreenShareView:tt}),en=Wt&&U.createElement(cKt,Object.assign({},Wt,{renderElement:(r=Wt.screenShareStream)===null||r===void 0?void 0:r.renderElement,onCreateRemoteStreamView:E,onDisposeRemoteStreamView:I,isReceiving:(o=Wt.screenShareStream)===null||o===void 0?void 0:o.isReceiving,participantVideoScalingMode:Vt[Wt.userId],localParticipant:l,remoteParticipants:d,reactionResources:ce})),sn=en||(l.isScreenSharingOn?Ii:void 0),Qi=$.useMemo(()=>({remoteParticipants:d,localParticipant:l,screenShareComponent:sn,showCameraSwitcherInLocalPreview:H,maxRemoteVideoStreams:z,dominantSpeakers:g,styles:F,onRenderRemoteParticipant:y??St,localVideoComponent:je,parentWidth:Ke,parentHeight:ot,pinnedParticipantUserIds:yt,overflowGalleryPosition:ne,localVideoTileSize:le,spotlightedParticipantUserIds:he}),[d,l,sn,H,z,g,F,je,Ke,ot,y,St,yt,ne,le,he]),qt=$.useMemo(()=>Wt&&x==="focusedContent"?U.createElement(mJt,Object.assign({},Qi)):x==="floatingLocalVideo"?U.createElement(uJt,Object.assign({},Qi)):x==="speaker"?U.createElement(pJt,Object.assign({},Qi)):U.createElement(XKt,Object.assign({},Qi)),[x,Qi,sn,Wt]);return U.createElement("div",{id:Pt?void 0:ni,"data-ui-id":ct.videoGallery,ref:it,className:It(fKt,F?.root,vJt)},qt,U.createElement(GA,{announcementString:gt,ariaLive:"polite"}))},SJt={horizontal:{flexFlow:"row nowrap"},vertical:{flexFlow:"column nowrap",width:"fit-content",maxWidth:"8rem"},dockedTop:{flexFlow:"row nowrap",justifyContent:"center",overflow:"hidden",position:"absolute",top:0,left:0,width:"100%",minWidth:"fit-content"},dockedBottom:{flexFlow:"row nowrap",justifyContent:"center",overflow:"hidden",position:"absolute",bottom:0,left:0,width:"100%",minWidth:"fit-content"},dockedLeft:{justifyContent:"center",overflow:"hidden",position:"absolute",top:0,left:0,height:"100%"},dockedRight:{justifyContent:"center",overflow:"hidden",position:"absolute",top:0,right:0,height:"100%"},floatingTop:{flexFlow:"row nowrap",justifyContent:"center",overflow:"hidden",position:"absolute",top:"1rem",left:"50%",transform:"translateX(-50%)",minWidth:"fit-content",zIndex:10},floatingBottom:{flexFlow:"row nowrap",justifyContent:"center",overflow:"hidden",position:"absolute",bottom:"1rem",left:"50%",transform:"translateX(-50%)",minWidth:"fit-content",zIndex:10},floatingLeft:{flexFlow:"column nowrap",justifyContent:"center",overflow:"hidden",position:"absolute",top:"50%",left:"1rem",transform:"translateY(-50%)",zIndex:10},floatingRight:{flexFlow:"column nowrap",justifyContent:"center",overflow:"hidden",position:"absolute",top:"50%",right:"1rem",transform:"translateY(-50%)",zIndex:10}},bJt={root:{background:"none",border:"none",borderRadius:0,minHeight:"3.5rem",minWidth:"3.5rem",width:"100%",maxWidth:"8rem",svg:{verticalAlign:"text-top"}},splitButtonMenuButton:{border:"none"},flexContainer:{display:"unset"},label:{fontSize:"0.625rem",fontWeight:"400",lineHeight:"1rem",cursor:"pointer",display:"block",margin:"0rem 0.25rem",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}},TJt={title:{background:"initial",paddingLeft:".5rem",fontWeight:600,fontSize:".75rem"}},CJt={icon:{lineHeight:0},checkmarkIcon:{lineHeight:0}},_Jt={root:{display:"inline-block"}},EJt=t=>{const e=hc(),r={gapSpace:4,styles:{root:{padding:0},calloutMain:{padding:"0.5rem"},beakCurtain:{marginBottom:"-1rem",backgroundColor:"transparent"}},backgroundColor:BO(e)?e.palette.neutralLighter:""};return U.createElement(AC,Object.assign({},t,{"data-ui-id":t.id,calloutProps:Object.assign(Object.assign({},r),t.calloutProps),styles:Rw(_Jt,t.styles)}),t.children)},AJt=t=>t?.checked?t?.onRenderOnIcon?t?.onRenderOnIcon():null:t?.onRenderOffIcon?t?.onRenderOffIcon():null,Jy=t=>{var e,i,r,o,l,d,h,p,g,f,y,T,C,E,I,w,D;const F=Ds(bJt,(e=t.styles)!==null&&e!==void 0?e:{}),x=(o=(i=t?.text)!==null&&i!==void 0?i:(r=t?.strings)===null||r===void 0?void 0:r.label)!==null&&o!==void 0?o:t?.checked?(l=t?.strings)===null||l===void 0?void 0:l.onLabel:(d=t?.strings)===null||d===void 0?void 0:d.offLabel,B=(p=(h=t?.strings)===null||h===void 0?void 0:h.tooltipContent)!==null&&p!==void 0?p:t?.disabled?(g=t?.strings)===null||g===void 0?void 0:g.tooltipDisabledContent:t?.checked?(f=t?.strings)===null||f===void 0?void 0:f.tooltipOnContent:(y=t?.strings)===null||y===void 0?void 0:y.tooltipOffContent,L=((T=t.tooltipId)!==null&&T!==void 0?T:t.labelKey)?t.labelKey+"-tooltip":void 0;return U.createElement(EJt,{hidden:t.disableTooltip,content:B,id:L},U.createElement(th,Object.assign({},t,{styles:F,onRenderText:t.showLabel&&t.onRenderText?t.onRenderText:void 0,onRenderIcon:(C=t.onRenderIcon)!==null&&C!==void 0?C:AJt,ariaLabel:(w=(I=(E=t.splitButtonAriaLabel)!==null&&E!==void 0?E:t.ariaLabel)!==null&&I!==void 0?I:x)!==null&&w!==void 0?w:B,allowDisabledFocus:(D=t.allowDisabledFocus)!==null&&D!==void 0?D:!0,"aria-describedby":L,menuTriggerKeyCode:fa.down,text:void 0}),t.showLabel?x:U.createElement(U.Fragment,null)))},Hm=t=>{const{iconName:e,disabled:i}=t,r=Cs();return U.createElement(Fr,{iconName:e,className:It({svg:{fill:i?r.palette.neutralTertiary:r.palette.neutralPrimaryAlt,"@media (forced-colors: active) and (prefers-color-scheme: dark)":{fill:i?r.palette.neutralPrimaryAlt:r.palette.neutralTertiary}}})})},IJt={scalingMode:"Crop",isMirrored:!0},eX=(t,e,i,r=!0,o=!0)=>{var l,d;const{microphones:h,speakers:p,cameras:g,selectedMicrophone:f,selectedSpeaker:y,selectedCamera:T,onSelectCamera:C,onSelectMicrophone:E,onSelectSpeaker:I}=t,w={items:[],styles:t.styles,calloutProps:{styles:{root:{maxWidth:"95%"}},preventDismissOnEvent:YS}},D=$U(CJt,(d=(l=t.styles)===null||l===void 0?void 0:l.menuItemStyles)!==null&&d!==void 0?d:{});if(g&&T&&C&&r&&(w.items.push({key:"cameras",itemType:Cp.Section,sectionProps:{title:e.cameraMenuTitle,items:[{key:"sectionCamera",title:e.cameraMenuTooltip,subMenuProps:{calloutProps:{preventDismissOnEvent:YS},items:g.map(F=>({key:F.id,text:F.name,title:F.name,iconProps:{iconName:"ContextMenuCameraIcon",styles:{root:{lineHeight:0}}},itemProps:{styles:D},canCheck:!0,isChecked:F.id===T?.id,onClick:()=>{F.id!==T?.id&&C(F,IJt)}}))},text:T.name}]}}),i&&w.items.push(i)),h&&f&&E&&o){const F=p&&p.length>0,x=F?"sectionMicrophone":"sectionAudioDevice",B=F?e.microphoneMenuTooltip:e.audioDeviceMenuTooltip;w.items.push({key:"microphones",itemType:Cp.Section,sectionProps:{title:e.microphoneMenuTitle,items:[{key:x,title:B,subMenuProps:{calloutProps:{preventDismissOnEvent:YS},items:h.map(L=>({key:L.id,text:L.name,title:L.name,itemProps:{styles:D},iconProps:{iconName:"ContextMenuMicIcon",styles:{root:{lineHeight:0}}},canCheck:!0,isChecked:L.id===f?.id,onClick:()=>{L.id!==f?.id&&E(L)}}))},text:f.name}]}})}if(p&&y&&I&&w.items.push({key:"speakers",itemType:Cp.Section,sectionProps:{title:e.speakerMenuTitle,items:[{key:"sectionSpeaker",subMenuProps:{calloutProps:{preventDismissOnEvent:YS},items:p.map(F=>({key:F.id,text:F.name,title:F.name,itemProps:{styles:D},iconProps:{iconName:"ContextMenuSpeakerIcon",styles:{root:{lineHeight:0}}},canCheck:!0,isChecked:F.id===y?.id,onClick:()=>{F.id!==y?.id&&I(F)}}))},text:y.name}]}}),h&&f&&E&&o&&i&&w.items.push(i),w.items.length!==0)return w},dF=t=>{var e,i,r;const{onRenderIcon:o}=t,l=Kl().strings.devicesButton,d=Object.assign(Object.assign({},l),t.strings),h=(e=t.menuProps)!==null&&e!==void 0?e:eX(Object.assign(Object.assign({},t),{styles:(i=t.styles)===null||i===void 0?void 0:i.menuStyles}),d),p=()=>U.createElement(Hm,{disabled:t.disabled,iconName:"ControlButtonOptions"});return U.createElement(Jy,Object.assign({},t,{menuProps:h,menuIconProps:{hidden:!0},onRenderIcon:o??p,strings:d,labelKey:(r=t.labelKey)!==null&&r!==void 0?r:"devicesButtonLabel"}))};var y$e=function(t,e,i,r){function o(l){return l instanceof i?l:new i(function(d){d(l)})}return new(i||(i=Promise))(function(l,d){function h(f){try{g(r.next(f))}catch(y){d(y)}}function p(f){try{g(r.throw(f))}catch(y){d(y)}}function g(f){f.done?l(f.value):o(f.value).then(h,p)}g((r=r.apply(t,e||[])).next())})};const wJt={scalingMode:"Crop",isMirrored:!0},O4=t=>{var e,i,r,o,l,d,h,p;const{localVideoViewOptions:g,onToggleCamera:f,onSelectCamera:y}=t,[T,C]=$.useState(!1),E=Kl().strings.cameraButton,I=Object.assign(Object.assign({},E),t.strings),[w,D]=$.useState(void 0),[F,x]=$.useState(!1),B=t.disabled||T,L=()=>U.createElement(Hm,{disabled:B,iconName:"ControlButtonCameraOn"}),z=()=>U.createElement(Hm,{disabled:B,iconName:"ControlButtonCameraOff"});T&&I.tooltipVideoLoadingContent&&(I.tooltipDisabledContent=I.tooltipVideoLoadingContent);const H=t.checked,j=T&&!H,J=((e=t.ariaLabel)!==null&&e!==void 0?e:j)?I.tooltipVideoLoadingContent:void 0,Z=j?I.tooltipVideoLoadingContent:H?I.onSplitButtonAriaLabel:I.offSplitButtonAriaLabel,re=$.useCallback(Se=>{D(Se?I.cameraActionTurnedOnAnnouncement:I.cameraActionTurnedOffAnnouncement)},[I.cameraActionTurnedOffAnnouncement,I.cameraActionTurnedOnAnnouncement]),ne=$.useCallback(()=>{H||D(I.tooltipVideoLoadingContent)},[D,H,I.tooltipVideoLoadingContent]),le=$.useCallback(()=>y$e(void 0,void 0,void 0,function*(){if(f){C(!0);try{yield f(g??wJt),re(!H)}finally{C(!1)}}}),[H,g,f,re]),he=$.useCallback(()=>{ne(),le()},[ne,le]),Me=$.useCallback(Se=>y$e(void 0,void 0,void 0,function*(){if(y){C(!0);try{yield y(Se)}finally{C(!1)}}}),[y]),Le=[];t.onClickVideoEffects&&Le.push({key:"effects","data-ui-id":"camera-split-button-video-effects",text:I.videoEffectsMenuItemTitle,iconProps:{iconName:"ControlButtonVideoEffectsOption",styles:{root:{lineHeight:0}}},onClick:()=>{t.onClickVideoEffects&&t.onClickVideoEffects(!0)}}),Le.push({key:"cameraPrimaryAction",text:t.checked?I.onSplitButtonPrimaryActionCamera:I.offSplitButtonPrimaryActionCamera,onClick:()=>{le()},iconProps:{iconName:t.checked?"SplitButtonPrimaryActionCameraOn":"SplitButtonPrimaryActionCameraOff",styles:{root:{lineHeight:0}}}});const pe={key:"primaryAction",title:"toggle camera",itemType:Cp.Section,sectionProps:{topDivider:!0,items:Le}},te=$.useMemo(()=>Object.assign(Object.assign({},t.splitButtonMenuProps),{className:"camera-split-button"}),[t.splitButtonMenuProps]);return U.createElement(U.Fragment,null,F&&U.createElement(GA,{announcementString:w,ariaLive:"polite"}),U.createElement(Jy,Object.assign({},t,{disabled:B,onClick:f?he:t.onClick,onRenderOnIcon:(i=t.onRenderOnIcon)!==null&&i!==void 0?i:L,onRenderOffIcon:(r=t.onRenderOffIcon)!==null&&r!==void 0?r:z,strings:I,labelKey:(o=t.labelKey)!==null&&o!==void 0?o:"cameraButtonLabel",menuProps:(l=t.menuProps)!==null&&l!==void 0?l:t.enableDeviceSelectionMenu?eX(Object.assign(Object.assign({},t),{onSelectCamera:Me,styles:(d=t.styles)===null||d===void 0?void 0:d.menuStyles}),I,pe):void 0,menuIconProps:((h=t.menuIconProps)!==null&&h!==void 0?h:!t.enableDeviceSelectionMenu)?{hidden:!0}:void 0,split:(p=t.split)!==null&&p!==void 0?p:t.enableDeviceSelectionMenu,"aria-description":I.cameraButtonAriaDescription,"aria-roledescription":t.enableDeviceSelectionMenu?I.cameraButtonSplitRoleDescription:void 0,ariaLabel:J,splitButtonAriaLabel:t.enableDeviceSelectionMenu?Z:void 0,splitButtonMenuProps:te,onFocus:()=>x(!0),onBlur:()=>x(!1)})))},kJt={position:"relative",height:"100%",width:"100%"},Lme=t=>{const{styles:e,layout:i}=t,r=Cs(),o=$.useMemo(()=>{const l=SJt[i??"horizontal"],d={background:BO(r)&&i?.startsWith("floating")?r.palette.neutralQuaternaryAlt:r.palette.white},h=i?.startsWith("floating")?{boxShadow:r.effects.elevation16,borderRadius:r.effects.roundedCorner6}:{},p=r.rtl&&(i==="floatingTop"||i==="floatingBottom")?{transform:"translateX(50%)"}:{};return It(l,d,h,p,e?.root)},[i,e?.root,r]);return U.createElement("div",{className:It(kJt)},U.createElement(Et,{className:o},t.children))},RJt=It({width:4}),Ome=t=>{var e,i;const{styles:r,enableEndCallMenu:o,onHangUp:l}=t,d=Kl().strings.endCallButton,h=Object.assign(Object.assign({},d),t.strings),p=Cs(),g=BO(p),f=Ds(g?MJt:PJt,o?DJt:{},r??{}),y=$.useCallback(()=>U.createElement(U.Fragment,null,U.createElement(Fr,{iconName:"ControlButtonEndCall"}),o&&U.createElement("span",{className:RJt})),[o]),T={items:[{key:"endForSelf",text:d.leaveOption,title:d.leaveOption,onClick:()=>{l&&l(!1)}},{key:"endForEveryone",text:d.endCallOption,title:d.endCallOption,onClick:()=>{l&&l(!0)}}],styles:t.styles,calloutProps:{styles:{root:{maxWidth:"95%"}},preventDismissOnEvent:YS}};return U.createElement(U.Fragment,null,U.createElement(Jy,Object.assign({},t,{menuProps:o?T:t.menuProps,onClick:l?()=>l():t.onClick,styles:f,onRenderIcon:(e=t.onRenderIcon)!==null&&e!==void 0?e:y,strings:h,labelKey:(i=t.labelKey)!==null&&i!==void 0?i:"endCallButtonLabel"})))},S$e=t=>{var e;return{regular:{color:t.callingPalette.iconWhite,background:t.callingPalette.callRed,"@media (forced-colors: active)":{forcedColorAdjust:"auto",border:`1px ${(e=t.palette)===null||e===void 0?void 0:e.neutralQuaternaryAlt} solid`}," i":{color:t.callingPalette.iconWhite},":focus::after":{outlineColor:`${t.callingPalette.iconWhite} !important`}},pressed:{color:t.callingPalette.iconWhite,background:t.callingPalette.callRedDarker,border:"none"," i":{color:t.callingPalette.iconWhite},"@media (forced-colors: active)":{forcedColorAdjust:"auto"}},hovered:{color:t.callingPalette.iconWhite,background:t.callingPalette.callRedDark,border:"none"," i":{color:t.callingPalette.iconWhite},"@media (forced-colors: active)":{forcedColorAdjust:"auto"}}}},uF=S$e(T8),zO=S$e(EZ),MJt={root:uF.regular,rootHovered:uF.hovered,rootPressed:uF.pressed,label:{color:T8.callingPalette.iconWhite},splitButtonMenuButton:Object.assign(Object.assign({},uF.regular),{borderTop:"none",borderRight:"none",borderBottom:"none","&:hover":uF.hovered}),splitButtonMenuButtonChecked:uF.hovered,splitButtonMenuButtonExpanded:uF.pressed},PJt={root:zO.regular,rootHovered:zO.hovered,rootPressed:zO.pressed,splitButtonMenuButton:Object.assign(Object.assign({},zO.regular),{borderTop:"none",borderRight:"none",borderBottom:"none","&:hover":zO.hovered}),splitButtonMenuButtonChecked:zO.hovered,splitButtonMenuButtonExpanded:zO.pressed,splitButtonMenuFocused:zO.pressed,label:{color:EZ.callingPalette.iconWhite}},DJt={root:{padding:"0 0.75rem"}};var b$e=function(t,e,i,r){function o(l){return l instanceof i?l:new i(function(d){d(l)})}return new(i||(i=Promise))(function(l,d){function h(f){try{g(r.next(f))}catch(y){d(y)}}function p(f){try{g(r.throw(f))}catch(y){d(y)}}function g(f){f.done?l(f.value):o(f.value).then(h,p)}g((r=r.apply(t,e||[])).next())})};const tX=t=>{var e,i,r,o,l,d,h,p,g,f,y,T;const{onToggleMicrophone:C}=t,E=Kl().strings.microphoneButton,I=Object.assign(Object.assign({},E),t.strings),[w,D]=$.useState(void 0),[F,x]=$.useState(!1),B=(e=t.split)!==null&&e!==void 0?e:t.enableDeviceSelectionMenu,L=t.primaryDisabled||(B&&!(!((i=t.microphones)===null||i===void 0)&&i.length)?!0:void 0),z=t.disabled||B&&!(!((r=t.microphones)===null||r===void 0)&&r.length)&&!(!((o=t.speakers)===null||o===void 0)&&o.length)||!B&&t.microphones&&((l=t.microphones)===null||l===void 0?void 0:l.length)===0,H=()=>U.createElement(Hm,{disabled:z,iconName:"ControlButtonMicOn"}),j=()=>U.createElement(Hm,{disabled:z,iconName:"ControlButtonMicOff"}),J=t.checked,Z=J?I.onSplitButtonAriaLabel:I.offSplitButtonAriaLabel,re=$.useCallback(Le=>{D(Le?I.microphoneActionTurnedOnAnnouncement:I.microphoneActionTurnedOffAnnouncement)},[I.microphoneActionTurnedOffAnnouncement,I.microphoneActionTurnedOnAnnouncement]),ne=$.useCallback(()=>b$e(void 0,void 0,void 0,function*(){if(C)try{yield C(),re(!J)}finally{}}),[J,C,re]),le={root:{margin:"4px",padding:"0px 12px",flexFlow:"row-reverse",justifyContent:"space-between"},label:{fontWeight:400}},he=[];t.showNoiseSuppressionButton&&he.push({key:"microphoneDNSToggle",onRender:()=>U.createElement(Et,{onClick:()=>b$e(void 0,void 0,void 0,function*(){var Le;yield(Le=t.onClickNoiseSuppression)===null||Le===void 0?void 0:Le.call(t),D(t.isDeepNoiseSuppressionOn?I.deepNoiseSuppressionOnAnnouncement:I.deepNoiseSuppressionOffAnnouncement)})},U.createElement(tAe,{label:I.deepNoiseSuppressionTitle,checked:t.isDeepNoiseSuppressionOn,inlineLabel:!0,styles:le}))}),he.push({key:"microphonePrimaryAction",text:t.checked?I.onSplitButtonMicrophonePrimaryAction:I.offSplitButtonMicrophonePrimaryAction,onClick:()=>{ne()},iconProps:{iconName:t.checked?"SplitButtonPrimaryActionMicUnmuted":"SplitButtonPrimaryActionMicMuted",styles:{root:{lineHeight:0}}}});const Me={key:"primaryAction",title:"toggle mic",itemType:Cp.Section,sectionProps:{topDivider:!0,items:he}};return U.createElement(U.Fragment,null,F&&U.createElement(GA,{announcementString:w,ariaLive:"polite"}),U.createElement(Jy,Object.assign({},t,{onClick:t.onToggleMicrophone?ne:t.onClick,onRenderOnIcon:(d=t.onRenderOnIcon)!==null&&d!==void 0?d:H,onRenderOffIcon:(h=t.onRenderOffIcon)!==null&&h!==void 0?h:j,strings:I,labelKey:(p=t.labelKey)!==null&&p!==void 0?p:"microphoneButtonLabel",menuProps:(g=t.menuProps)!==null&&g!==void 0?g:t.enableDeviceSelectionMenu?eX(Object.assign(Object.assign({},t),{styles:(f=t.styles)===null||f===void 0?void 0:f.menuStyles}),I,Me):void 0,menuIconProps:((y=t.menuIconProps)!==null&&y!==void 0?y:!t.enableDeviceSelectionMenu)?{hidden:!0}:void 0,split:(T=t.split)!==null&&T!==void 0?T:t.enableDeviceSelectionMenu,"aria-roledescription":t.enableDeviceSelectionMenu?I.microphoneButtonSplitRoleDescription:void 0,"aria-description":I.microphoneAriaDescription,splitButtonAriaLabel:t.enableDeviceSelectionMenu?Z:void 0,disabled:z,primaryDisabled:L,onFocus:()=>x(!0),onBlur:()=>x(!1)})))};var Nme,T$e;function LJt(){return T$e||(T$e=1,Nme=function(){var t=document.getSelection();if(!t.rangeCount)return function(){};for(var e=document.activeElement,i=[],r=0;r<t.rangeCount;r++)i.push(t.getRangeAt(r));switch(e.tagName.toUpperCase()){case"INPUT":case"TEXTAREA":e.blur();break;default:e=null;break}return t.removeAllRanges(),function(){t.type==="Caret"&&t.removeAllRanges(),t.rangeCount||i.forEach(function(o){t.addRange(o)}),e&&e.focus()}}),Nme}var xme,C$e;function OJt(){if(C$e)return xme;C$e=1;var t=LJt(),e={"text/plain":"Text","text/html":"Url",default:"Text"},i="Copy to clipboard: #{key}, Enter";function r(l){var d=(/mac os x/i.test(navigator.userAgent)?"⌘":"Ctrl")+"+C";return l.replace(/#{\s*key\s*}/g,d)}function o(l,d){var h,p,g,f,y,T,C=!1;d||(d={}),h=d.debug||!1;try{g=t(),f=document.createRange(),y=document.getSelection(),T=document.createElement("span"),T.textContent=l,T.ariaHidden="true",T.style.all="unset",T.style.position="fixed",T.style.top=0,T.style.clip="rect(0, 0, 0, 0)",T.style.whiteSpace="pre",T.style.webkitUserSelect="text",T.style.MozUserSelect="text",T.style.msUserSelect="text",T.style.userSelect="text",T.addEventListener("copy",function(I){if(I.stopPropagation(),d.format)if(I.preventDefault(),typeof I.clipboardData>"u"){h&&console.warn("unable to use e.clipboardData"),h&&console.warn("trying IE specific stuff"),window.clipboardData.clearData();var w=e[d.format]||e.default;window.clipboardData.setData(w,l)}else I.clipboardData.clearData(),I.clipboardData.setData(d.format,l);d.onCopy&&(I.preventDefault(),d.onCopy(I.clipboardData))}),document.body.appendChild(T),f.selectNodeContents(T),y.addRange(f);var E=document.execCommand("copy");if(!E)throw new Error("copy command was unsuccessful");C=!0}catch(I){h&&console.error("unable to copy using execCommand: ",I),h&&console.warn("trying IE specific stuff");try{window.clipboardData.setData(d.format||"text",l),d.onCopy&&d.onCopy(window.clipboardData),C=!0}catch(w){h&&console.error("unable to copy using clipboardData: ",w),h&&console.error("falling back to prompt"),p=r("message"in d?d.message:i),window.prompt(p,l)}}finally{y&&(typeof y.removeRange=="function"?y.removeRange(f):y.removeAllRanges()),T&&document.body.removeChild(T),g()}return C}return xme=o,xme}var NJt=OJt();const _$e=cL(NJt),Bme=t=>{var e,i,r,o;const{callInvitationURL:l,styles:d,onMuteAll:h,onRenderIcon:p,onRenderParticipantList:g,participants:f,myUserId:y,excludeMe:T,onRenderParticipant:C,onRenderAvatar:E,onRemoveParticipant:I,onFetchParticipantMenuItems:w,showParticipantOverflowTooltip:D}=t,F=t.disabled,[x,B]=$.useState(""),L=()=>U.createElement(Hm,{disabled:F,iconName:"ControlButtonParticipants"}),z=qE(),H=$.useCallback(()=>{h&&h()},[h]),j=$.useCallback(()=>{var Le;return U.createElement(x8,{participants:f,myUserId:y,excludeMe:T,onRenderParticipant:C,onRenderAvatar:E,onRemoveParticipant:I,onFetchParticipantMenuItems:w,styles:(Le=d?.menuStyles)===null||Le===void 0?void 0:Le.participantListStyles,showParticipantOverflowTooltip:D})},[T,y,I,E,C,f,(e=d?.menuStyles)===null||e===void 0?void 0:e.participantListStyles,w,D]),J=$.useCallback(()=>l?_$e(l):!1,[l]),Z=Kl().strings.participantsButton,re=$.useMemo(()=>Object.assign(Object.assign({},Z),t.strings),[Z,t.strings]),ne=f.length,le=$.useCallback(()=>{B(re.copyInviteLinkActionedAriaLabel),setTimeout(()=>{B("")},3e3)},[re.copyInviteLinkActionedAriaLabel]),he=$.useCallback(()=>{var Le;const pe=[];return ne>0&&(pe.push({key:"participantListMenuItemKey",onRender:g??j}),pe.push({key:"participantsDivider1",itemType:Cp.Divider}),h&&pe.push({key:"muteAllKey",text:re.muteAllButtonLabel,title:re.muteAllButtonLabel,styles:(Le=d?.menuStyles)===null||Le===void 0?void 0:Le.menuItemStyles,iconProps:{iconName:"MicOff2"},onClick:H})),pe},[ne,g,j,h,re.muteAllButtonLabel,(i=d?.menuStyles)===null||i===void 0?void 0:i.menuItemStyles,H]),Me=$.useMemo(()=>{var Le,pe;const te={title:re.menuHeader,ariaLabel:re.menuHeader,styles:$U(TJt,d?.menuStyles),items:[],calloutProps:{preventDismissOnEvent:YS}};if(ne>0){let ce=f.map(X=>X.userId).length;T&&(ce-=1),te.items.push({key:"participantCountKey",name:Jd(re.participantsListButtonLabel,{numParticipants:`${ce}`}),itemProps:{styles:(Le=d?.menuStyles)===null||Le===void 0?void 0:Le.menuItemStyles},iconProps:{iconName:"People"},subMenuProps:{items:he(),calloutProps:{styles:{root:{maxWidth:"100%"}},style:{maxHeight:"20rem"},preventDismissOnEvent:YS}},"data-ui-id":z.participantButtonPeopleMenuItem})}return l&&te.items.push({key:"InviteLinkKey",name:re.copyInviteLinkButtonLabel,title:re.copyInviteLinkButtonLabel,itemProps:{styles:(pe=d?.menuStyles)===null||pe===void 0?void 0:pe.menuItemStyles},iconProps:{iconName:"Link"},onClick:()=>{J(),le()}}),te},[re.menuHeader,re.participantsListButtonLabel,re.copyInviteLinkButtonLabel,d?.menuStyles,ne,l,f,T,z.participantButtonPeopleMenuItem,he,J,le]);return U.createElement(U.Fragment,null,U.createElement(GA,{announcementString:x,ariaLive:"polite"}),U.createElement(Jy,Object.assign({},t,{disabled:F,menuProps:(r=t.menuProps)!==null&&r!==void 0?r:Me,menuIconProps:{hidden:!0},onRenderIcon:p??L,strings:re,"aria-label":re.ariaLabel,labelKey:(o=t.labelKey)!==null&&o!==void 0?o:"participantsButtonLabel"})))},Fme=t=>{var e,i,r,o;const l=Kl().strings.screenShareButton,d=Object.assign(Object.assign({},l),t.strings),h=hc(),p=xJt(h),g=()=>U.createElement(Hm,{disabled:t.disabled,iconName:"ControlButtonScreenShareStop"}),f=()=>U.createElement(Hm,{disabled:t.disabled,iconName:"ControlButtonScreenShareStart"});return U.createElement(Jy,Object.assign({},t,{styles:Rw(p,t.styles),onClick:(e=t.onToggleScreenShare)!==null&&e!==void 0?e:t.onClick,onRenderOnIcon:(i=t.onRenderOnIcon)!==null&&i!==void 0?i:g,onRenderOffIcon:(r=t.onRenderOffIcon)!==null&&r!==void 0?r:f,strings:d,labelKey:(o=t.labelKey)!==null&&o!==void 0?o:"screenShareButtonLabel",disabled:t.disabled}))},xJt=t=>({rootChecked:{background:t.semanticColors.primaryButtonBackground,color:t.semanticColors.primaryButtonText,":focus::after":{outlineColor:`${TM.white} !important`},"@media (forced-colors: active)":{border:"1px solid",borderColor:t.palette.black}},rootCheckedHovered:{background:t.semanticColors.primaryButtonBackgroundHovered,color:t.semanticColors.primaryButtonTextHovered,":focus::after":{outlineColor:`${TM.white} !important`},"@media (forced-colors: active)":{border:"1px solid",borderColor:t.palette.black}},rootCheckedPressed:{background:t.semanticColors.primaryButtonBackgroundPressed,color:t.semanticColors.primaryButtonTextPressed},labelChecked:{color:t.semanticColors.primaryButtonText}}),z8=t=>{var e,i,r,o;const l=Kl().strings.raiseHandButton,d=Object.assign(Object.assign({},l),t.strings),h=hc(),p=BJt(h),g=()=>U.createElement(Hm,{disabled:t.disabled,iconName:"ControlButtonRaiseHand"}),f=()=>U.createElement(Hm,{disabled:t.disabled,iconName:"ControlButtonLowerHand"});return U.createElement(Jy,Object.assign({},t,{styles:Ds(p,t.styles),onClick:(e=t.onToggleRaiseHand)!==null&&e!==void 0?e:t.onClick,onRenderOnIcon:(i=t.onRenderOnIcon)!==null&&i!==void 0?i:f,onRenderOffIcon:(r=t.onRenderOffIcon)!==null&&r!==void 0?r:g,strings:d,labelKey:(o=t.labelKey)!==null&&o!==void 0?o:"raiseHandButtonLabel","aria-label":t.checked?d.onLabel:d.offLabel,"aria-description":t.checked?d.tooltipOnContent:d.tooltipOffContent,disabled:t.disabled}))},BJt=t=>({rootChecked:{background:t.palette.themePrimary,color:TM.white,":focus::after":{outlineColor:`${TM.white}`}},rootCheckedHovered:{background:t.palette.themePrimary,color:TM.white,":focus::after":{outlineColor:`${TM.white}`}},labelChecked:{color:TM.white}}),Ume=t=>{var e,i,r,o,l,d,h;const p=Kl().strings.reactionButton,g=Object.assign(Object.assign({},p),t.strings),f=hc(),y=tWt(f),T=()=>U.createElement(Hm,{disabled:t.disabled,iconName:"ReactionButtonIcon"}),C=["like","heart","applause","laugh","surprised"],E=new Map([["like",g.likeReactionTooltipContent],["heart",g.heartReactionTooltipContent],["applause",g.applauseReactionTooltipContent],["laugh",g.laughReactionTooltipContent],["surprised",g.surprisedReactionTooltipContent]]),I=new Map([["like",(e=t.reactionResources.likeReaction)===null||e===void 0?void 0:e.url],["heart",(i=t.reactionResources.heartReaction)===null||i===void 0?void 0:i.url],["applause",(r=t.reactionResources.applauseReaction)===null||r===void 0?void 0:r.url],["laugh",(o=t.reactionResources.laughReaction)===null||o===void 0?void 0:o.url],["surprised",(l=t.reactionResources.surprisedReaction)===null||l===void 0?void 0:l.url]]),D={styles:{root:{padding:0},calloutMain:{padding:"0.5rem"}},backgroundColor:BO(f)?f.palette.neutralLighter:""},F=$.useRef(null),x=$.useRef(null),[B,L]=$.useState(!1);return U.createElement(Et,null,B&&U.createElement(ZU,{"data-ui-id":"reaction-sub-menu",isBeakVisible:!1,styles:nWt,target:F.current,onDismiss:()=>{var z;(z=x.current)===null||z===void 0||z.focus(),L(!1)}},U.createElement(hA,{shouldFocusOnMount:!0,style:{height:"100%"}},U.createElement(Et,{horizontal:!0,style:{height:"inherit"}},C.map((z,H)=>{const j=I.get(z),J=t.reactionResources!==void 0?a$e(z,t.reactionResources):0,Z=It(Qqt(j||"",J));return U.createElement(AC,{key:H,"data-ui-id":H,hidden:t.disableTooltip,content:E.get(z),styles:Zqt(),calloutProps:Object.assign({},D)},U.createElement(th,{role:"menuitem",key:H,onClick:()=>{var re;t.onReactionClick(z),(re=x.current)===null||re===void 0||re.focus(),L(!1)},className:Z,styles:iWt,"aria-label":E.get(z)}))})))),U.createElement("div",{ref:F},U.createElement(Jy,Object.assign({},t,{componentRef:x,styles:Ds(y,t.styles),onClick:()=>L(!B),onRenderIcon:(d=t.onRenderIcon)!==null&&d!==void 0?d:T,strings:g,split:!0,labelKey:(h=t.labelKey)!==null&&h!==void 0?h:"reactionButtonLabel",onRenderMenuIcon:()=>U.createElement("div",null),disabled:t.disabled,ariaLabel:g.ariaLabel}))))},FJt=t=>{const e=Cs().effects.elevation8;return U.createElement(E$e,{styles:zJt(t.orientation,e)},t.children)},UJt=t=>U.createElement(E$e,{styles:VJt(t.orientation)},t.children),E$e=t=>U.createElement(Et,{styles:t.styles},t.children),zJt=ql((t,e)=>({root:{borderRadius:"0.25rem",height:t==="landscape"?"5.5rem":"8rem",width:t==="landscape"?"8rem":"5.5rem",boxShadow:e,overflow:"hidden"}})),VJt=ql(t=>({root:{borderRadius:"0.25rem",height:t==="landscape"?"1.625rem":"2rem",width:t==="landscape"?"2rem":"1.625rem",overflow:"hidden"}})),$Jt=t=>U.createElement(HJt,{onClick:t.onClick,primaryView:U.createElement(FJt,Object.assign({},t.primaryTile)),secondaryView:t.secondaryTile&&U.createElement(UJt,Object.assign({},t.secondaryTile)),ariaLabel:t.strings.rootAriaLabel}),HJt=t=>{const e=i=>t.onClick&&FVe(i,t.onClick);return U.createElement("aside",{style:jJt,onClick:t.onClick,onKeyPress:e,"aria-label":t.ariaLabel,tabIndex:t.onClick?0:-1,"data-ui-id":"picture-in-picture-in-picture-root"},t.primaryView,U.createElement("div",{style:GJt},t.secondaryView))},jJt={display:"flex",width:"min-content",position:"relative",cursor:"pointer"},GJt={position:"absolute",bottom:"0.125rem",right:"0.125rem"},qJt=t=>({maxWidth:"16rem",textAlign:"center",background:`${t.palette.white}`,borderRadius:"0.75rem",margin:"auto"}),WJt=t=>({root:{background:"none",fontWeight:600,fontSize:`${_n(20)}`,border:"none",borderRadius:0,width:"3rem",height:"3rem",padding:`${_n(16)}, ${_n(5)}, ${_n(16)}, ${_n(5)}`,minWidth:0,minHeight:0}}),KJt=t=>({fontSize:"1.25rem",fontWeight:t.fonts.medium.fontWeight,color:`${t.palette.themePrimary}`}),JJt=(t,e)=>({field:{padding:0,textAlign:"center",fontSize:`${_n(18)}`,fontWeight:400,width:`${e?"10rem":"12rem"}`,height:"3rem",borderRadius:"0.5rem",position:"relative",overflowX:"hidden",textOverflow:"clip"},root:{backgroundColor:`${t.palette.neutralLighter}`,marginBottom:"0.625rem",height:"3rem",borderRadius:"0.5rem"},fieldGroup:{border:"none",borderRadius:"0.5rem",width:"12rem",height:"3rem",backgroundColor:`${t.palette.neutralLighter}`,":after":{borderRadius:"0.5rem"}},errorMessage:{color:t.semanticColors.errorText},suffix:{padding:0,position:"absolute",right:"0.25rem",top:"0.55rem",transform:"scale(1.15)",background:"unset"}}),YJt=t=>({fontSize:"0.625rem",color:`${t.palette.neutralSecondary}`,fontWeight:400,margin:"0.125rem",minHeight:"0.75rem"}),QJt=t=>({root:{color:`${t.palette.black}`,padding:0,background:"transparent"},icon:{height:"auto",background:"transparent","> span":{display:"flex"}}}),V8=(t,e)=>{if(!t)return t;e&&t[0]==="1"&&t.length===11&&(t=`+${t}`);let i="";t[0]==="1"?(i="1 ",t=t.slice(1,t.length)):t[0]==="+"&&(i=t.slice(0,2)+" ",t=t.slice(2,t.length));const r=t.length;return r<4||r>10?i.replace(" ","")+t:r<7?`${i}(${t.slice(0,3)}) ${t.slice(3)}`:`${i}(${t.slice(0,3)}) ${t.slice(3,6)}-${t.slice(6,t.length)}`};class ZJt{constructor(e,i,r){this.isPlaying=!1,this.play=()=>{if(this.isPlaying)return;const o=this.context.createGain();o.gain.value=.1,o.connect(this.context.destination),this.oscillatorNode1=this.context.createOscillator(),this.oscillatorNode1.frequency.value=this.frequency1,this.oscillatorNode1.connect(o),this.oscillatorNode2=this.context.createOscillator(),this.oscillatorNode2.frequency.value=this.frequency2,this.oscillatorNode2.connect(o),this.oscillatorNode1.start(),this.oscillatorNode2.start(),this.isPlaying=!0},this.stop=()=>{this.oscillatorNode1&&this.oscillatorNode2&&(this.oscillatorNode1.stop(),this.oscillatorNode2.stop(),this.oscillatorNode1.disconnect(),this.oscillatorNode2.disconnect(),this.isPlaying=!1)},this.context=e,this.frequency1=i,this.frequency2=r}}const A$e={1:{f1:697,f2:1209},2:{f1:697,f2:1336},3:{f1:697,f2:1477},4:{f1:770,f2:1209},5:{f1:770,f2:1336},6:{f1:770,f2:1477},7:{f1:852,f2:1209},8:{f1:852,f2:1336},9:{f1:852,f2:1477},"*":{f1:941,f2:1209},0:{f1:941,f2:1336},"#":{f1:941,f2:1477}};var I$e=function(t,e,i,r){function o(l){return l instanceof i?l:new i(function(d){d(l)})}return new(i||(i=Promise))(function(l,d){function h(f){try{g(r.next(f))}catch(y){d(y)}}function p(f){try{g(r.throw(f))}catch(y){d(y)}}function g(f){f.done?l(f.value):o(f.value).then(h,p)}g((r=r.apply(t,e||[])).next())})};const XJt=[[{digit:"1"},{digit:"2",letter:"ABC"},{digit:"3",letter:"DEF"}],[{digit:"4",letter:"GHI"},{digit:"5",letter:"JKL"},{digit:"6",letter:"MNO"}],[{digit:"7",letter:"PQRS"},{digit:"8",letter:"TUV"},{digit:"9",letter:"WXYZ"}],[{digit:"*"},{digit:"0",letter:"+"},{digit:"#"}]],w$e=["Num1","Num2","Num3","Num4","Num5","Num6","Num7","Num8","Num9","Star","Num0","Pound"],eYt=t=>{var e,i,r,o;const l=hc(),{digit:d,index:h,onClick:p,onLongPress:g,longPressTrigger:f,dtmfToneAudioContext:y,disableDtmfPlayback:T}=t,[C,E]=$.useState(!1),I=$.useRef(new ZJt(y,A$e[d].f1,A$e[d].f2)),w=U.useMemo(()=>({onClick:()=>I$e(void 0,void 0,void 0,function*(){p(d,h)}),onLongPress:()=>I$e(void 0,void 0,void 0,function*(){g(d,h)}),touchEventsOnly:f==="touch"}),[d,h,f,p,g]),D=ZVe(w);return U.createElement(th,Object.assign({"data-test-id":`dialpad-button-${t.index}`,styles:Ds(WJt(),(e=t.styles)===null||e===void 0?void 0:e.button)},D,{onKeyDown:F=>{if((F.key==="Enter"||F.key===" ")&&!C){T||I.current.play(),D.onKeyDown(),E(!0);return}if(F.key==="Tab"||F.key==="ArrowLeft"||F.key==="ArrowRight"||F.key==="ArrowUp"||F.key==="ArrowDown"){I.current.stop();return}D.onKeyDown()},onKeyUp:F=>{(F.key==="Enter"||F.key===" ")&&C&&(I.current.stop(),D.onKeyUp(),E(!1)),D.onKeyUp()},onMouseDown:()=>{T||I.current.play(),D.onMouseDown()},onMouseUp:()=>{I.current.stop(),D.onMouseUp()},onMouseLeave:()=>{I.current.stop()},onTouchStart:()=>{T||I.current.play(),D.onTouchStart()},onTouchEnd:()=>{I.current.stop(),D.onTouchEnd()}}),U.createElement(Et,null,U.createElement(ja,{className:It(KJt(l),(i=t.styles)===null||i===void 0?void 0:i.digit)},t.digit),U.createElement(ja,{className:It(YJt(l),(r=t.styles)===null||r===void 0?void 0:r.letter)},(o=t.letter)!==null&&o!==void 0?o:" ")))},tYt=t=>{var e,i;const r=hc(),{onSendDtmfTone:o,onClickDialpadButton:l,textFieldValue:d,onChange:h,showDeleteButton:p=!0,longPressTrigger:g="mouseAndTouch",disableDtmfPlayback:f,dialpadMode:y="dialer",dtmfAudioContext:T}=t,C=$.useRef(T||new AudioContext),[E,I]=$.useState(d??""),w=$.useRef(E);$.useEffect(()=>{w.current!==E&&h?.(E),w.current=E},[w,E,h]),$.useEffect(()=>{x(d??"")},[d]);const D=(L,z)=>{x(E+L);const H=w$e[z];o&&H&&o(H),l&&l(L,z)},F=(L,z)=>{x(L==="0"&&z===10?E+"+":E+L);const H=w$e[z];o&&H&&o(H),l&&l(L,z)},x=L=>{const z=iYt(L);I(z)},B=()=>{const L=E.substring(0,E.length-1);x(L)};return U.createElement(Et,{className:It(qJt(r),(e=t.styles)===null||e===void 0?void 0:e.root),"data-test-id":"dialpadContainer","data-ui-id":"dialpadContainer",horizontalAlign:"center"},y==="dialer"&&U.createElement(Bre,{styles:Ds(JJt(r,E!==""),(i=t.styles)===null||i===void 0?void 0:i.textField),value:d||V8(E),onChange:L=>{x(L.target.value)},onClick:L=>{L.preventDefault()},placeholder:t.strings.placeholderText,"data-test-id":"dialpad-input",onRenderSuffix:()=>{var L;return U.createElement(U.Fragment,null,p&&E.length!==0&&U.createElement(zy,{ariaLabel:t.strings.deleteButtonAriaLabel,onClick:B,styles:Ds(QJt(r),(L=t.styles)===null||L===void 0?void 0:L.deleteIcon),iconProps:{iconName:"DialpadBackspace"}}))}}),U.createElement(hA,null,XJt.map((L,z)=>U.createElement(Et,{horizontal:!0,key:`row_${z}`,horizontalAlign:"stretch",tokens:{childrenGap:"1rem"}},L.map((H,j)=>U.createElement(eYt,{key:`button_${j}`,index:j+z*L.length,digit:H.digit,letter:H.letter,styles:t.styles,onClick:D,onLongPress:F,longPressTrigger:g,dtmfToneAudioContext:C.current,disableDtmfPlayback:f}))))))},zme=t=>{const e=Kl().strings.dialpad,i=Object.assign(Object.assign({},e),t.strings);return U.createElement(tYt,Object.assign({strings:i},t))},iYt=t=>t.replace(/[^\d*#+]/g,""),nYt=t=>It({fontWeight:600,fontSize:_n(16),lineHeight:_n(20),color:t.palette.neutralPrimary,paddingTop:_n(24)}),aYt=t=>It({fontWeight:400,fontSize:_n(12),lineHeight:_n(12),color:t.palette.themePrimary,marginBottom:_n(8),marginTop:_n(8),textAlign:"center"}),rYt=t=>({root:{textAlign:"center",height:"auto",marginTop:_n(8)},ratingStarIsLarge:{height:"auto",padding:0},ratingStar:{transform:"scale(1.4)",margin:_n(6),height:"auto"},ratingStarFront:{color:t.palette.themePrimary}}),oYt=It({paddingBottom:_n(6)}),sYt=t=>{const{onStarRatingSelected:e,selectedIcon:i,unselectedIcon:r,strings:o}=t,[l,d]=$.useState(0),[h,p]=$.useState(""),g=hc(),f=$.useCallback((y,T)=>{if(T){switch(d(T),T){case 1:p(o?.starSurveyOneStarText);break;case 2:p(o?.starSurveyTwoStarText);break;case 3:p(o?.starSurveyThreeStarText);break;case 4:p(o?.starSurveyFourStarText);break;case 5:p(o?.starSurveyFiveStarText);break}e?.(T)}},[o?.starSurveyOneStarText,o?.starSurveyTwoStarText,o?.starSurveyThreeStarText,o?.starSurveyFourStarText,o?.starSurveyFiveStarText,e]);return U.createElement(Et,{verticalAlign:"center"},U.createElement(Et,{className:oYt},U.createElement(ja,{className:nYt(g)},o?.starSurveyHelperText)),U.createElement(rst,{max:5,size:hH.Large,defaultRating:0,allowZeroStars:!0,rating:l,onChange:f,styles:rYt(g),icon:i??"SurveyStarIconFilled",unselectedIcon:r??"SurveyStarIcon",ariaLabelFormat:o?.starRatingAriaLabel}),U.createElement(ja,{className:aYt(g)},h))},lYt=t=>It({fontWeight:600,fontSize:_n(16),lineHeight:_n(20),color:t.palette.neutralPrimary,marginTop:_n(8),marginBottom:_n(4)}),cYt=t=>It({fontWeight:400,fontSize:_n(12),lineHeight:_n(16),marginTop:_n(4),color:t.palette.neutralSecondary}),dYt=It({padding:_n(8),paddingLeft:0}),uYt={root:{paddingBottom:_n(8),width:"100%"},label:{width:"100%"}},hYt=It({width:"100%",marginLeft:_n(4),input:{padding:0}}),pYt=t=>{const{callIssuesToTag:e,categoryHeadings:i,onConfirm:r,strings:o,showFreeFormTextField:l}=t,[d,h]=$.useState({}),[p,g]=$.useState({}),[f,y]=$.useState({}),[T,C]=$.useState([]),E=$.useMemo(()=>{const F={overallRating:[],audioRating:[],videoRating:[],screenshareRating:[]};return Fx(e).forEach(x=>{Fx(e[x]).map(B=>{const L=B?.charAt(0).toUpperCase()+B?.slice(1),z=e[x];F[x]?F[x].push({message:z[B],issue:L}):F[x]=[{message:z[B],issue:L}]})}),F},[e]),I=U.useCallback((F,x,B)=>{x?B?h(L=>{const z=L?.[F];return z&&z.issues?z.issues=[z.issues,B]:L[F]={issues:[B]},L}):(C([...T,F]),y(L=>(L[F]=p[F],L))):B?h(L=>{var z,H;const j=(H=(z=L[F])===null||z===void 0?void 0:z.issues)===null||H===void 0?void 0:H.filter(J=>J!==B);return Object.assign(Object.assign({},L),{[F]:Object.assign(Object.assign({},L[F]||{}),{issues:j})})}):(C(T.filter(L=>L!==F)),y(L=>(delete L[F],L)))},[p,T]),w=hc(),D=$.useCallback(F=>U.createElement(Bre,{key:F,className:hYt,underlined:!0,placeholder:o?.tagsSurveyTextFieldDefaultText,onChange:(x,B)=>{B&&(C([...T,F]),g(L=>(L[F]=B,L)),y(L=>(L[F]=B,L)))}}),[o?.tagsSurveyTextFieldDefaultText,T]);return $.useEffect(()=>{r&&r(d,f)},[d,f,r]),U.createElement(U.Fragment,null,U.createElement(Et,{verticalAlign:"center"},U.createElement(ja,{className:lYt(w)},o?.tagsSurveyQuestion)),U.createElement(Yot,null,Fx(E).map((F,x)=>U.createElement(z0e,{key:`key-${x}`,headerText:i[F],headerButtonProps:{"data-order":x,"data-title":F},alwaysRender:!0},E[F].map((B,L)=>U.createElement(Nre,{className:dYt,key:`checkBox_${L}`,label:B.message,onChange:(z,H)=>I(F,H??!1,B.issue)})),l&&U.createElement(Nre,{checked:T.includes(F),styles:uYt,onChange:(B,L)=>I(F,L??!1),onRenderLabel:()=>D(F)})))),U.createElement(ja,{className:cYt(w)},o?.tagsSurveyHelperText))},$8=t=>{const{onToggleHold:e,strings:i}=t,r=()=>U.createElement(Hm,{disabled:t.disabled,iconName:"HoldCallButton"}),o=()=>U.createElement(Hm,{disabled:t.disabled,iconName:"ResumeCall"});return U.createElement(Jy,Object.assign({},t,{strings:i,onClick:e??t.onClick,onRenderOnIcon:o,onRenderOffIcon:r}))},k$e="3.375rem",R$e="4.83rem",gYt="3.373rem",mYt="4.85rem",fYt={root:{visibility:"hidden",height:k$e,width:R$e,border:"2px"}},vYt=t=>{const e="1px",i="2px";return{root:{background:t.disabled?t.theme.palette.neutralQuaternaryAlt:void 0,backgroundImage:t.backgroundImage?`url(${t.backgroundImage})`:void 0,backgroundPosition:"center",backgroundSize:"cover",borderRadius:"0.25rem",color:t.theme.palette.neutralPrimary,cursor:t.disabled?"default":"pointer",height:k$e,width:R$e,outlineOffset:"-1px",outline:t.isSelected?`${i} solid ${t.theme.palette.themePrimary}`:`${e} solid ${t.theme.palette.neutralQuaternaryAlt}`,":hover":{boxSizing:"border-box",width:mYt,height:gYt,outlineOffset:"-1px",outline:t.disabled&&!t.isSelected?`${e} solid ${t.theme.palette.neutralQuaternaryAlt}`:`${i} solid ${t.theme.palette.themePrimary}`},padding:"0.5rem"}}},M$e=t=>{var e,i,r,o,l,d,h,p,g;const f=hc(),y=(e=t.isSelected)!==null&&e!==void 0?e:!1,T=(i=t.disabled)!==null&&i!==void 0?i:!1,C=(r=t.backgroundProps)===null||r===void 0?void 0:r.url,E=It({height:"1.25rem"},(o=t.styles)===null||o===void 0?void 0:o.iconContainer),I=It({height:"1.25rem",maxWidth:"4.5rem",overflow:"hidden"},(l=t.styles)===null||l===void 0?void 0:l.textContainer),w=$.useCallback(()=>vYt({theme:f,isSelected:y,disabled:T,backgroundImage:C}),[C,T,y,f]);return U.createElement(AC,Object.assign({},t.tooltipProps),U.createElement(Et,{key:t.itemKey,className:It((d=t.styles)===null||d===void 0?void 0:d.root),verticalAlign:"center",horizontalAlign:"center","data-ui-id":"video-effects-item"},U.createElement(th,{styles:w(),onClick:T?void 0:()=>{var D;return(D=t.onSelect)===null||D===void 0?void 0:D.call(t,t.itemKey)},componentRef:t.componentRef,ariaLabel:(g=(h=t.ariaLabel)!==null&&h!==void 0?h:`${t.title}, ${(p=t.tooltipProps)===null||p===void 0?void 0:p.content}`)!==null&&g!==void 0?g:t.itemKey,"aria-disabled":t.disabled,role:"radio","aria-checked":y},U.createElement(Et,{horizontalAlign:"center",className:It({width:"100%"})},t.iconProps&&U.createElement(Et.Item,{className:E},U.createElement(Fr,Object.assign({},t.iconProps))),t.title&&U.createElement(Et.Item,{className:I},U.createElement(ja,{variant:"small",styles:{root:{whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}},t.title))))))},yYt=t=>{var e,i,r,o,l;const[d,h]=U.useState(t.defaultSelectedEffectKey);CM({name:"VideoBackgroundEffectsPicker",props:t,controlledUsage:{onChangeProp:"onChange",valueProp:"selectedEffectKey",defaultValueProp:"defaultSelectedEffectKey"}});const p=(e=t.selectedEffectKey)!==null&&e!==void 0?e:d,g=I=>{var w;h(I),(w=t.onChange)===null||w===void 0||w.call(t,I)},f=t.options.map(I=>Object.assign({isSelected:I.itemKey===p,onSelect:()=>g(I.itemKey)},I)),y=(i=t.itemsPerRow)!==null&&i!==void 0?i:3,T=y==="wrap"?[f]:e8t(f,y),C=y==="wrap"?0:y-((o=(r=T[T.length-1])===null||r===void 0?void 0:r.length)!==null&&o!==void 0?o:0),E=yu("effects-radio-label");return U.createElement(hA,null,U.createElement(Et,{tokens:{childrenGap:"0.5rem"},role:"radiogroup","aria-labelledby":E},U.createElement(px,{id:E,className:It((l=t.styles)===null||l===void 0?void 0:l.label)},t.label),T.map((I,w)=>{var D;return U.createElement(Et,{className:It((D=t.styles)===null||D===void 0?void 0:D.rowRoot),wrap:t.itemsPerRow==="wrap",horizontal:!0,key:w,tokens:{childrenGap:"0.5rem"},"data-ui-id":"video-effects-picker-row"},I.map((F,x)=>x===0&&w===0?U.createElement(M$e,Object.assign({},F,{itemKey:F.itemKey,key:F.itemKey,componentRef:t.componentRef})):U.createElement(M$e,Object.assign({},F,{itemKey:F.itemKey,key:F.itemKey}))),C>0&&w===T.length-1&&Array.from({length:C}).map((F,x)=>U.createElement(Et,{key:x,styles:fYt,"data-ui-id":"video-effects-hidden-item"})))})))},SYt=It({marginRight:_n(8)}),bYt=It({fontWeight:400,fontSize:_n(12),lineHeight:_n(16)}),TYt=It({fontWeight:400,fontSize:_n(16),lineHeight:_n(22),width:"100%"}),CYt=It({height:"100%",margin:0,overflow:"auto",padding:0,overflowX:"hidden"}),_Yt=It({marginTop:_n(6),marginBottom:_n(6),textAlign:"unset",overflowAnchor:"auto"}),P$e={listStyleType:"none",padding:0,margin:0},EYt=(t,e)=>It(Object.assign(Object.assign({},P$e),{overflowX:"hidden",height:t==="compact"?"4.5rem":"8.75rem",overflowY:"auto"})),AYt=t=>It(Object.assign(Object.assign({},P$e),{overflowX:"hidden",overflowY:"auto",height:"100%",width:"100%",position:"absolute",backgroundColor:t.palette.white,left:0})),IYt=t=>({root:{height:t==="compact"?"4.5rem":"8.75rem"}}),wYt=t=>({root:{height:"100%",width:"100%",position:"absolute",left:0,backgroundColor:t.palette.white}}),kYt=It({width:"100%",paddingInlineEnd:_n(4)}),RYt=It({overflow:"hidden",textOverflow:"ellipsis"}),MYt=t=>{const{displayName:e,userId:i,captionText:r,onRenderAvatar:o}=t,l={hidePersonaDetails:!0,size:Io.size32,text:e,showOverflowTooltip:!1,imageShouldStartVisible:!0,initialsTextColor:"white",styles:{root:{margin:"0.25rem"}}},d=o?o(i??"",l):U.createElement(ux,Object.assign({},l));return U.createElement(Et,{horizontal:!0,verticalAlign:"start",horizontalAlign:"start"},U.createElement(Et.Item,{className:SYt},d),U.createElement(Et,{verticalAlign:"start",className:kYt},U.createElement(Et.Item,{className:RYt},U.createElement(ja,{className:bYt},e)),U.createElement(Et.Item,{className:TYt,dir:"auto"},r)))},PYt=20,Vme=t=>{const{captions:e,isCaptionsOn:i,startCaptionsInProgress:r,onRenderAvatar:o,formFactor:l="default",captionsOptions:d}=t,h=Kl().strings.captionsBanner,p=Object.assign(Object.assign({},h),t.strings),g=$.useRef(null),[f,y]=$.useState(!0),T=hc(),C=()=>{g.current&&(g.current.scrollTop=g.current.scrollHeight)},E=$.useCallback(()=>{if(!g.current)return;const w=Math.ceil(g.current.scrollTop)>=g.current.scrollHeight-g.current.clientHeight-PYt;y(w)},[]);$.useEffect(()=>{const w=g.current;return w?.addEventListener("scroll",E),()=>{w?.removeEventListener("scroll",E)}},[E,i]),$.useEffect(()=>{f&&C()},[e,f]);const I=()=>U.createElement(U.Fragment,null,e.map(w=>U.createElement("li",{key:w.id,className:_Yt,"data-is-focusable":!0},U.createElement(MYt,Object.assign({},w,{onRenderAvatar:o})))));return U.createElement(U.Fragment,null,(r||i)&&U.createElement(hA,{shouldFocusOnMount:!0,className:CYt,"data-ui-id":"captions-banner"},i&&U.createElement("ul",{ref:g,className:d?.height==="full"?AYt(T):EYt(l),"data-ui-id":"captions-banner-inner"},I()),!i&&U.createElement(Et,{verticalAlign:"center",styles:d?.height==="full"?wYt(T):IYt(l),"data-is-focusable":!0},U.createElement(gx,{label:p?.captionsBannerSpinnerText,ariaLive:"assertive",labelPosition:"right"}))))};var DYt=function(t,e,i,r){function o(l){return l instanceof i?l:new i(function(d){d(l)})}return new(i||(i=Promise))(function(l,d){function h(f){try{g(r.next(f))}catch(y){d(y)}}function p(f){try{g(r.throw(f))}catch(y){d(y)}}function g(f){f.done?l(f.value):o(f.value).then(h,p)}g((r=r.apply(t,e||[])).next())})};const iX=t=>{const{onStartCaptions:e,onStopCaptions:i,onSetSpokenLanguage:r,currentSpokenLanguage:o}=t,l=Kl().strings.startCaptionsButton,d=Object.assign(Object.assign({},l),t.strings),h=()=>U.createElement(Hm,{disabled:t.disabled,iconName:"CaptionsIcon"}),p=()=>U.createElement(Hm,{disabled:t.disabled,iconName:"CaptionsOffIcon"}),g=$.useMemo(()=>({spokenLanguage:o===""?_Z:o}),[o]),[f,y]=$.useState(!1),T=$.useCallback(()=>DYt(void 0,void 0,void 0,function*(){t.checked?i():yield e(g)}),[t.checked,e,i,g]);return $.useEffect(()=>{t.checked&&!f&&(r(g.spokenLanguage),y(!0))},[t.checked,r,g.spokenLanguage,f]),U.createElement(Jy,Object.assign({},t,{strings:d,onClick:T??t.onClick,onRenderOnIcon:h,onRenderOffIcon:p}))},LYt=t=>({main:{borderRadius:t.effects.roundedCorner6,padding:_n(24),width:_n(440),height:"fit-content",overflowY:"auto"}}),OYt=It({fontWeight:600,fontSize:_n(20),lineHeight:_n(28)}),NYt=It({paddingBottom:_n(20)}),xYt=It({paddingTop:_n(16)}),D$e=t=>It({fontWeight:400,fontSize:_n(12),lineHeight:_n(16),color:t.palette.neutralSecondary,paddingBottom:_n(24)}),BYt=It({paddingTop:_n(16)}),L$e=t=>({root:{borderRadius:_n(2),margin:_n(8)},rootHovered:{backgroundColor:t.palette.themePrimary,borderColor:t.palette.themePrimary,color:t.palette.white},rootFocused:{backgroundColor:t.palette.themePrimary,borderColor:t.palette.themePrimary,color:t.palette.white},rootPressed:{backgroundColor:t.palette.themePrimary,borderColor:t.palette.themePrimary,color:t.palette.white}}),O$e={callout:{height:_n(300),overflow:"auto"},dropdownOptionText:{textWrap:"auto",overflow:"unset"}},nX={"ar-ae":"ar","ar-sa":"ar","da-dk":"da","de-de":"de","en-au":"en","en-ca":"en","en-gb":"en","en-in":"en","en-nz":"en","en-us":"en","es-es":"es","es-mx":"es","fi-fi":"fi","fr-ca":"fr-ca","fr-fr":"fr","hi-in":"hi","it-it":"it","ja-jp":"ja","ko-kr":"ko","nb-no":"nb","nl-be":"nl","nl-nl":"nl","pl-pl":"pl","pt-br":"pt","ru-ru":"ru","sv-se":"sv","zh-cn":"zh-Hans","zh-hk":"zh-Hant","cs-cz":"cs","pt-pt":"pt-pt","tr-tr":"tr","vi-vn":"vi","th-th":"th","he-il":"he","cy-gb":"cy","uk-ua":"uk","el-gr":"el","hu-hu":"hu","ro-ro":"ro","sk-sk":"sk","zh-tw":"zh-Hant"};var FYt=function(t,e,i,r){function o(l){return l instanceof i?l:new i(function(d){d(l)})}return new(i||(i=Promise))(function(l,d){function h(f){try{g(r.next(f))}catch(y){d(y)}}function p(f){try{g(r.throw(f))}catch(y){d(y)}}function g(f){f.done?l(f.value):o(f.value).then(h,p)}g((r=r.apply(t,e||[])).next())})};const aX=t=>{const{supportedSpokenLanguages:e,supportedCaptionLanguages:i,currentSpokenLanguage:r,currentCaptionLanguage:o,isCaptionsFeatureActive:l,showModal:d,onSetSpokenLanguage:h,onSetCaptionLanguage:p,onDismissCaptionsSettings:g,onStartCaptions:f,changeCaptionLanguage:y=!1}=t,T=hc(),C=Kl().strings.captionsSettingsModal,E=Kl().strings.spokenLanguages,I=Kl().strings.captionLanguages,w=Object.assign(Object.assign({},C),t.strings),D=$.useMemo(()=>Object.assign(Object.assign({},E),t.spokenLanguageStrings),[E,t.spokenLanguageStrings]),F=$.useMemo(()=>Object.assign(Object.assign({},I),t.captionLanguageStrings),[I,t.captionLanguageStrings]),[x,B]=$.useState(!1),[L,z]=$.useState({key:r||_Z,text:r||_Z}),[H,j]=$.useState({key:o||nX[L.key],text:o||nX[L.key]});$.useEffect(()=>{l&&!x&&(h(L.key),B(!0))},[l,h,L.key,x]);const J=$.useCallback(()=>{g&&g()},[g]),Z=$.useCallback(()=>FYt(void 0,void 0,void 0,function*(){const ce=L.key,X=H.key;l?(h(ce),y&&p&&p(X)):yield f({spokenLanguage:ce}),J()}),[J,l,h,p,f,L.key,H.key,y]),re=$.useMemo(()=>e.map(ce=>({key:ce,text:D?D[ce]:ce})),[e,D]),ne=$.useMemo(()=>i?.map(ce=>({key:ce,text:F?F[ce]:ce})),[i,F]),le=$.useMemo(()=>[...re].sort((X,ve)=>X.text>ve.text?1:-1),[re]),he=$.useMemo(()=>[...ne??[]].sort((X,ve)=>X.text>ve.text?1:-1),[ne]),Me=(ce,X)=>{X&&z(X)},Le=(ce,X)=>{X&&j(X)},pe=$.useMemo(()=>({preventDismissOnEvent:YS}),[]),te=$.useCallback(()=>{const ce=r??_Z,X=o??nX[ce];return U.createElement(Et,null,U.createElement(s5,{label:w?.captionsSettingsSpokenLanguageDropdownLabel,selectedKey:L?L.key:void 0,onChange:(ve,Te)=>Me(ve,Te),calloutProps:pe,placeholder:ce,options:le,styles:O$e}),U.createElement(ja,{className:D$e(T)},w?.captionsSettingsSpokenLanguageDropdownInfoText),y&&U.createElement(U.Fragment,null,U.createElement(s5,{label:w?.captionsSettingsCaptionLanguageDropdownLabel,selectedKey:H?H.key:void 0,onChange:(ve,Te)=>Le(ve,Te),calloutProps:pe,placeholder:X,options:he,styles:O$e}),U.createElement(ja,{className:D$e(T)},w?.captionsSettingsCaptionLanguageDropdownInfoText)))},[pe,r,o,le,he,H,L,w?.captionsSettingsSpokenLanguageDropdownInfoText,w?.captionsSettingsCaptionLanguageDropdownLabel,w?.captionsSettingsSpokenLanguageDropdownLabel,w?.captionsSettingsCaptionLanguageDropdownInfoText,T,y]),Se=$.useMemo(()=>LYt(T),[T]);return U.createElement(U.Fragment,null,U.createElement(o5,{titleAriaId:w?.captionsSettingsModalAriaLabel,isOpen:d,onDismiss:J,isBlocking:!0,styles:Se},U.createElement(Et,{horizontal:!0,horizontalAlign:"space-between",verticalAlign:"center",className:NYt},U.createElement(ja,{className:OYt},w?.captionsSettingsModalTitle),U.createElement(zy,{iconProps:{iconName:"Cancel"},ariaLabel:w?.captionsSettingsCloseModalButtonAriaLabel,onClick:J,style:{color:T.palette.black}})),U.createElement(Et,{className:xYt},te()),U.createElement(Et,{horizontal:!0,horizontalAlign:"end",className:BYt},U.createElement(SE,{styles:L$e(T),onClick:Z},U.createElement("span",null,w?.captionsSettingsConfirmButtonLabel)),U.createElement(th,{onClick:J,styles:L$e(T)},U.createElement("span",null,w?.captionsSettingsCancelButtonLabel)))))},UYt=t=>({main:{borderRadius:t.effects.roundedCorner6,padding:_n(24),width:_n(600),height:"fit-content",overflow:"hidden"}}),zYt=It({fontWeight:600,fontSize:_n(20),lineHeight:_n(28)}),VYt=It({paddingBottom:_n(30)}),rX=It({fontSize:_n(14),lineHeight:_n(40)}),$me=It({fontSize:_n(14),lineHeight:_n(40),fontWeight:xs.semibold}),Hme=t=>It({background:`${t.palette.themeLighter}`,height:_n(36),width:_n(36),marginRight:_n(12),borderRadius:_n(18)}),N$e=It({marginBottom:_n(20)}),x$e=It({textAlign:"right"}),jme=t=>It({padding:_n(8),color:`${t.palette.themePrimary}`,zIndex:2}),B$e=t=>It({background:`${t.palette.themeLighter}`,width:_n(2),position:"relative",left:_n(19),top:_n(20),zIndex:1}),$Yt=t=>{var e;const{conferencePhoneInfoList:i,showModal:r,onDismissMeetingPhoneInfoSettings:o}=t,l=hc(),d=Kl().strings.meetingConferencePhoneInfo,h=$.useCallback(()=>{o&&o()},[o]),p=$.useMemo(()=>UYt(l),[l]);return U.createElement(U.Fragment,null,U.createElement(o5,{titleAriaId:d?.meetingConferencePhoneInfoModalTitle,isOpen:r,onDismiss:h,isBlocking:!0,styles:p},U.createElement(Et,{horizontal:!0,horizontalAlign:"space-between",verticalAlign:"center",className:VYt},U.createElement(ja,{role:"heading","aria-level":2,className:zYt},d?.meetingConferencePhoneInfoModalTitle),U.createElement(zy,{iconProps:{iconName:"Cancel"},ariaLabel:d?.meetingConferencePhoneInfoModalTitle,onClick:h,style:{color:l.palette.black}})),i.length===0&&U.createElement(Et,{horizontal:!0},U.createElement(ja,{className:rX},d?.meetingConferencePhoneInfoModalNoPhoneAvailable)),i.length>0&&U.createElement(Et,null,U.createElement(Et,{horizontal:!0,horizontalAlign:"space-between",className:N$e},U.createElement(Et.Item,{style:{display:"flex"}},U.createElement(Et,{horizontal:!0,className:x$e},U.createElement(Et,{className:B$e(l)}),U.createElement(Et.Item,{className:Hme(l)},U.createElement(Et,{verticalAlign:"center",horizontalAlign:"center"},U.createElement(Fr,{iconName:"JoinByPhoneDialStepIcon",className:jme(l)}))),U.createElement(Et.Item,null,U.createElement(ja,{className:rX},d?.meetingConferencePhoneInfoModalDialIn)))),U.createElement(Et.Item,{className:x$e},i.map((g,f)=>U.createElement(Et.Item,{key:f},U.createElement(ja,{className:$me},V8(g.phoneNumber,!0)," ",g.isTollFree?d.meetingConferencePhoneInfoModalTollFree:d.meetingConferencePhoneInfoModalToll),U.createElement("br",null),U.createElement(ja,{className:$me}," ",Gme(g,d)))))),U.createElement(Et,{horizontal:!0,horizontalAlign:"space-between",verticalAlign:"center",className:N$e},U.createElement(Et.Item,{style:{display:"flex"}},U.createElement(Et,{horizontal:!0},U.createElement(Et,{className:B$e(l)}),U.createElement(Et.Item,{className:Hme(l)},U.createElement(Et,{verticalAlign:"center",horizontalAlign:"center"},U.createElement(Fr,{iconName:"JoinByPhoneConferenceIdIcon",className:jme(l)}))),U.createElement(Et.Item,null,U.createElement(ja,{className:rX},d?.meetingConferencePhoneInfoModalMeetingId)))),U.createElement(ja,{className:$me},HYt((e=i[0])===null||e===void 0?void 0:e.conferenceId))),U.createElement(Et,{horizontal:!0,horizontalAlign:"space-between",verticalAlign:"center"},U.createElement(Et,{horizontal:!0},U.createElement(Et.Item,{className:Hme(l),style:{marginLeft:_n(2)}},U.createElement(Fr,{iconName:"JoinByPhoneWaitToBeAdmittedIcon",className:jme(l)})),U.createElement(Et.Item,null,U.createElement(ja,{className:rX},d?.meetingConferencePhoneInfoModalWait)))))))},F$e=t=>`tel:+${t.phoneNumber},,${t.conferenceId}#`,Gme=(t,e)=>{const i=t.country&&t.city?e?.meetingConferencePhoneInfoModalTollGeoData:"";return i?.replace("{country}",t.country||"").replace("{city}",t.city||"").trim()||""},HYt=t=>t?t?.length!==9?t:[t.slice(0,3),t.slice(3,6),t.slice(6,9)].join(" ")+"#":"",jYt=t=>({root:{fontWeight:400,fontSize:_n(14),lineHeight:_n(16),color:t.palette.neutralSecondary,marginTop:"0.25rem"}}),GYt=()=>({root:{fontWeight:400,fontSize:_n(14),lineHeight:_n(16),alignSelf:"center"}}),qYt=t=>({root:{boxShadow:t.effects.elevation8,width:"20rem",padding:"0.75rem",borderRadius:"0.25rem",position:"relative",backgroundColor:t.palette.white}}),WYt=t=>It({boxShadow:t.effects.elevation8,width:"19.5rem",borderRadius:"0.25rem",marginTop:"-0.65rem",height:"1rem"}),KYt=()=>({root:{fontSize:"1.25rem",alignSelf:"center",marginRight:"0.5rem",svg:{width:"1.25rem",height:"1.25rem"}}}),JYt=t=>({root:{color:t.palette.themePrimary,fontWeight:"600",paddingLeft:"0.25rem"}}),YYt=t=>{var e,i,r,o,l,d,h,p,g,f,y,T,C,E,I,w;const D=t.notificationStrings,F=hc(),[x,B]=$.useState(!0),{ariaLive:L="assertive",role:z="alert"}=t;return t.autoDismiss&&(setTimeout(()=>{B(!1)},5e3),!x)?(t.onDismiss&&t.onDismiss(),U.createElement(U.Fragment,null)):U.createElement(Et,{horizontalAlign:"center","aria-live":L,role:z},U.createElement(Et,{"data-ui-id":"notification-bar",styles:(i=(e=t.styles)===null||e===void 0?void 0:e.root)!==null&&i!==void 0?i:qYt(F)},U.createElement(Et,{horizontal:!0,horizontalAlign:"space-between"},U.createElement(Et,{horizontal:!0},U.createElement(Fr,Object.assign({styles:(o=(r=t.styles)===null||r===void 0?void 0:r.icon)!==null&&o!==void 0?o:KYt(),iconName:(d=(l=t.notificationIconProps)===null||l===void 0?void 0:l.iconName)!==null&&d!==void 0?d:"ErrorBadge"},t.notificationIconProps)),U.createElement(ja,{styles:(p=(h=t.styles)===null||h===void 0?void 0:h.title)!==null&&p!==void 0?p:GYt()},D?.title)),t.onDismiss&&U.createElement(zy,{iconProps:$4e,ariaLabel:D?.dismissButtonAriaLabel,"aria-live":"polite",onClick:t.onDismiss})),U.createElement("span",null,U.createElement(ja,{styles:(f=(g=t.styles)===null||g===void 0?void 0:g.content)!==null&&f!==void 0?f:jYt(F)}," ",D?.message),t.onClickLink&&D?.linkLabel&&U.createElement(uW,{styles:(T=(y=t.styles)===null||y===void 0?void 0:y.link)!==null&&T!==void 0?T:JYt(F),onClick:t.onClickLink},D?.linkLabel)),U.createElement(Et,{horizontal:!0,horizontalAlign:"space-evenly"},D?.secondaryButtonLabel&&U.createElement(th,{onClick:t.onClickSecondaryButton,styles:(E=(C=t.styles)===null||C===void 0?void 0:C.secondaryButton)!==null&&E!==void 0?E:{root:{marginTop:"1rem"}}},D?.secondaryButtonLabel),D?.primaryButtonLabel&&U.createElement(SE,{onClick:t.onClickPrimaryButton,styles:(w=(I=t.styles)===null||I===void 0?void 0:I.primaryButton)!==null&&w!==void 0?w:{root:{marginTop:"1rem"}}},D?.primaryButtonLabel))),t.showStackedEffect&&U.createElement(Et,{className:WYt(F)}))},H8=t=>{var e,i;const r=Kl().strings.notificationStack,o=(e=t.strings)!==null&&e!==void 0?e:r,l=(i=t.maxNotificationsToShow)!==null&&i!==void 0?i:2,d=!t.onDismissNotification,h=$.useRef(new Date(Date.now())),[p,g]=$.useState([]);$.useEffect(()=>{d&&g(q6t(t.activeNotifications,p))},[t.activeNotifications,p,d]);const f=K6t(t.activeNotifications,p,t.ignorePremountNotifications?h.current:void 0);return U.createElement(Et,{"data-ui-id":"notifications-stack",style:{width:"fit-content"}},f.map((y,T)=>{if(T<l){const C=()=>{var E;d?g(G6t(p,y)):(E=t.onDismissNotification)===null||E===void 0||E.call(t,y),y.onDismiss&&y.onDismiss()};return y.type==="assignedBreakoutRoomOpenedPromptJoin"&&(y.onClickSecondaryButton=y.onClickSecondaryButton?y.onClickSecondaryButton:()=>C()),U.createElement("div",{key:T,style:{marginBottom:`${T===l-1?0:"0.25rem"}`}},U.createElement(YYt,{notificationStrings:o?o[y.type]:void 0,notificationIconProps:Z6t(y.type),onClickPrimaryButton:()=>{var E;return(E=y.onClickPrimaryButton)===null||E===void 0?void 0:E.call(y)},onClickSecondaryButton:()=>{var E;return(E=y.onClickSecondaryButton)===null||E===void 0?void 0:E.call(y)},onDismiss:C,showStackedEffect:T===l-1&&f.length>l,autoDismiss:y.autoDismiss,ariaLive:y.ariaLive}))}else return U.createElement(U.Fragment,null)}))},QYt=t=>{var e,i,r,o,l,d,h,p;const{callerName:g,alertText:f,avatarImage:y,onAcceptWithAudio:T,onAcceptWithVideo:C,onReject:E,onDismiss:I,personaSize:w,styles:D,strings:F,acceptOptions:x}=t,B=hc(),L=Kl().strings.IncomingCallNotification,z=L.incomingCallNotificationPlaceholderAlert&&g?Jd(L.incomingCallNotificationPlaceholderAlert,{callerName:g}):g,H=x.showAcceptWithVideo?{items:[{key:"audio",text:(e=F?.incomingCallNotificationAcceptButtonLabel)!==null&&e!==void 0?e:L.incomingCallNotificationAcceptButtonLabel,onClick:()=>T()},{key:"video",text:(i=F?.incomingCallNotificationAccceptWithVideoButtonLabel)!==null&&i!==void 0?i:L.incomingCallNotificationAccceptWithVideoButtonLabel,onClick:()=>C()}]}:void 0;return U.createElement(Et,{tokens:{childrenGap:"0.5rem"},verticalAlign:"center",styles:D?.root?D.root:ZYt(B)},U.createElement(Et,{horizontal:!0,verticalAlign:"center",tokens:{childrenGap:w?"0.5rem":"0rem"}},U.createElement(Et,{horizontalAlign:"start",styles:D?.avatarContainer?D.avatarContainer:XYt},U.createElement(ux,{imageUrl:y,text:g,size:Io.size24,coinSize:w,hidePersonaDetails:!0,"aria-label":g})),U.createElement(Et,{grow:!0,horizontalAlign:"center",style:{alignItems:"flex-start",fontFamily:"Segoe UI"}},U.createElement(ja,{tabIndex:0,"aria-live":"assertive","aria-label":f??z},(r=f??F?.incomingCallNotificationPlaceholderAlert)!==null&&r!==void 0?r:z)),U.createElement(zy,{ariaLabel:(o=F?.incomingCallNotificationDismissButtonAriaLabel)!==null&&o!==void 0?o:L.incomingCallNotificationDismissButtonAriaLabel,iconProps:{iconName:"cancel"},onClick:I,styles:eQt(B)})),U.createElement(Et,{horizontal:!0,horizontalAlign:"center",tokens:{childrenGap:"0.5rem"}},U.createElement(SE,{styles:D?.acceptButton?D.acceptButton:tQt(B),onClick:()=>T(),iconProps:{iconName:"IncomingCallNotificationAcceptIcon",style:{lineHeight:"1rem"}},ariaLabel:(l=F?.incomingCallNoticicationAcceptWithAudioAriaLabel)!==null&&l!==void 0?l:L.incomingCallNoticicationAcceptWithAudioAriaLabel,menuProps:H},(d=F?.incomingCallNotificationAcceptButtonLabel)!==null&&d!==void 0?d:L.incomingCallNotificationAcceptButtonLabel),U.createElement(th,{styles:D?.rejectButton?D.rejectButton:iQt(B),onClick:()=>E(),iconProps:{iconName:"IncomingCallNotificationRejectIcon"},ariaLabel:(h=F?.incomingCallNoticicationRejectAriaLabel)!==null&&h!==void 0?h:L.incomingCallNoticicationRejectAriaLabel},(p=F?.incomingCallNotificationRejectButtonLabel)!==null&&p!==void 0?p:L.incomingCallNotificationRejectButtonLabel)))},ZYt=t=>({root:{width:"20rem",background:t.palette.white,opacity:.95,borderRadius:"0.5rem",boxShadow:t.effects.elevation8,padding:"1rem"}}),XYt={root:{marginRight:"0.5rem"}},eQt=t=>({root:{color:t.palette.neutralPrimary,width:"1rem",height:"1rem"},rootHovered:{color:t.palette.neutralDark}}),tQt=t=>({root:{color:t.palette.white,border:"none",borderRadius:t.effects.roundedCorner4,width:"100%",maxWidth:"8.875rem"},rootHovered:{color:t.palette.white},icon:{height:"1.25rem"}}),iQt=t=>({root:{borderRadius:t.effects.roundedCorner4,maxWidth:"8.875rem",width:"100%"},icon:{height:"1.25rem"}}),nQt=t=>{const{activeIncomingCalls:e,removedIncomingCalls:i,onAcceptCall:r,onRejectCall:o,styles:l,strings:d,tabIndex:h}=t;return U.createElement(Et,{tokens:{childrenGap:"0.25rem"},role:"group",tabIndex:h},e.filter(p=>!i.some(g=>g.id===p.id)).map(p=>U.createElement(QYt,{key:p.id,callerName:p.callerInfo.displayName,onAcceptWithAudio:()=>r(p.id),onAcceptWithVideo:()=>r(p.id,!0),onReject:()=>o(p.id),onDismiss:()=>o(p.id),styles:l,strings:d,acceptOptions:{showAcceptWithVideo:p.videoAvailable}})))},Jh=t=>{const e=Object.assign({},E4e);return Fx(t).forEach(i=>{e[i]=Object.assign(Object.assign({},e[i]),t[i])}),e},aQt={strings:Jh({participantItem:{isMeText:"(you)",menuTitle:"More Options",removeButtonLabel:"Remove",sharingIconLabel:"Sharing",mutedIconLabel:"Muted",handRaisedIconLabel:"Hand raised - Position {position}",displayNamePlaceholder:"Unnamed participant",participantStateRinging:"Calling...",participantStateHold:"On hold",participantItemAriaLabel:"{displayName}, {handRaisedState}, {mutedState}, {micDisabledState}, {cameraDisabledState}, {sharingState}, {connectionState}",participantItemWithMoreOptionsAriaLabel:"{displayName}, {handRaisedState}, {mutedState}, {micDisabledState}, {cameraDisabledState}, {sharingState}, {connectionState}, More Options",attendeeRole:"Attendee",micDisabledIconLabel:"Micophone disabled",cameraDisabledIconLabel:"Camera disabled"},ParticipantList:{overflowParticipantCount:"+{overflowCount} more"},typingIndicator:{singleUser:"{user} is typing ...",multipleUsers:"{users} are typing ...",multipleUsersAbbreviateOne:"{users} and 1 other are typing ...",multipleUsersAbbreviateMany:"{users} and {numOthers} others are typing ...",delimiter:", "},sendBox:{placeholderText:"Enter a message",textTooLong:"Your message length is over the maximum limit.",sendButtonAriaLabel:"Send message",attachmentUploadsPendingError:"File is uploading, please wait.",removeAttachment:"Remove file",uploading:"Uploading",uploadCompleted:"Upload completed",attachmentMoreMenu:"More Options"},richTextSendBox:{placeholderText:"Enter a message",textTooLong:"Your message length is over the maximum limit.",sendButtonAriaLabel:"Send message",attachmentUploadsPendingError:"File is uploading, please wait.",imageUploadsPendingError:"Image is uploading, please wait.",removeAttachment:"Remove file",uploading:"Uploading",uploadCompleted:"Upload completed",richTextBoldTooltip:"Bold",richTextItalicTooltip:"Italic",richTextUnderlineTooltip:"Underline",richTextBulletListTooltip:"Bulleted list",richTextNumberListTooltip:"Numbered list",richTextIncreaseIndentTooltip:"Increase indent",richTextDecreaseIndentTooltip:"Decrease indent",richTextInsertTableTooltip:"Insert table",richTextFormatButtonTooltip:"Format",richTextInsertRowOrColumnMenu:"Insert",richTextInsertTableMenuTitle:"Insert {column} x {row} table",richTextInsertRowAboveMenu:"Insert above",richTextInsertRowBelowMenu:"Insert below",richTextInsertColumnLeftMenu:"Insert left",richTextInsertColumnRightMenu:"Insert right",richTextDeleteRowOrColumnMenu:"Delete",richTextDeleteColumnMenu:"Delete column",richTextDeleteRowMenu:"Delete row",richTextDeleteTableMenu:"Delete table",richTextToolbarAriaLabel:"Message Formatting Toolbar",richTextToolbarMoreButtonAriaLabel:"More options",attachmentMoreMenu:"More Options",richTextNewBulletedListItemAnnouncement:"Bullet, new line",richTextNewNumberedListItemAnnouncement:"{0}, new line",richTextBulletedListAppliedAnnouncement:"Bulleted list applied",richTextNumberedListAppliedAnnouncement:"Numbered list applied"},realTimeTextModal:{realTimeTextModalAriaLabel:"Turn on RTT Modal",realTimeTextModalTitle:"Turn on RTT?",realTimeTextModalText:"Real-time text (RTT) will be turned on for everyone in the meeting.",realTimeTextConfirmButtonLabel:"Turn on",realTimeTextCancelButtonLabel:"Cancel",realTimeTextCloseModalButtonAriaLabel:"Close RTT Modal"},captionsBanner:{captionsBannerSpinnerText:"Starting captions...",realTimeTextInputBoxDefaultText:"Type message in real time",realTimeTextInputErrorMessage:"Message cannot exceed 2000 characters",realTimeTextBannerTitle:"RTT",realTimeTextBannerContent:"RTT (real-time text) is enabled for all participants for the entire duration of the meeting.",realTimeTextBannerLinkLabel:"Learn more",captionsOnlyContainerTitle:"Captions",realTimeTextOnlyContainerTitle:"Real-Time Text",captionsAndRealTimeTextContainerTitle:"Captions and Real-Time Text",expandButtonAriaLabel:"Expand",minimizeButtonAriaLabel:"Collapse"},mentionPopover:{mentionPopoverHeader:"Suggestions"},imageOverlay:{downloadButtonLabel:"Download",dismissButtonAriaLabel:"Close",overlayVisibleMessage:"Image Details Overlay"},messageStatusIndicator:{deliveredAriaLabel:"Message sent",deliveredTooltipText:"Sent",seenAriaLabel:"Message seen by others",seenTooltipText:"Seen",readByTooltipText:"Read by {messageThreadReadCount} of {remoteParticipantsCount}",sendingAriaLabel:"Message sending",sendingTooltipText:"Sending",failedToSendAriaLabel:"Message failed to send",failedToSendTooltipText:"Failed to send"},endCallButton:{label:"Leave",tooltipContent:"Leave call",leaveOption:"Leave",endCallOption:"End call for everyone"},cameraButton:{onLabel:"Camera",offLabel:"Camera",tooltipDisabledContent:"Camera is disabled",tooltipOnContent:"Turn off camera",tooltipOffContent:"Turn on camera",tooltipVideoLoadingContent:"Video is loading",cameraMenuTitle:"Camera",cameraMenuTooltip:"Choose camera",cameraButtonSplitRoleDescription:"Split button",onSplitButtonAriaLabel:"Turn off camera",offSplitButtonAriaLabel:"Turn on camera",cameraActionTurnedOnAnnouncement:"Your camera has been turned on",cameraActionTurnedOffAnnouncement:"Your camera has been turned off",onSplitButtonPrimaryActionCamera:"Turn off camera",offSplitButtonPrimaryActionCamera:"Turn on camera",cameraPrimaryActionSplitButtonTitle:"Use camera",videoEffectsMenuItemTitle:"Effects",cameraButtonAriaDescription:"camera options"},microphoneButton:{onLabel:"Mic",offLabel:"Mic",tooltipDisabledContent:"Microphone is disabled",tooltipOnContent:"Mute microphone",tooltipOffContent:"Unmute microphone",microphoneMenuTitle:"Microphone",microphoneMenuTooltip:"Choose microphone",speakerMenuTitle:"Speaker",speakerMenuTooltip:"Choose speaker",microphoneButtonSplitRoleDescription:"Split button",onSplitButtonAriaLabel:"Mute mic",offSplitButtonAriaLabel:"Unmute mic",microphoneActionTurnedOnAnnouncement:"Your microphone has been turned on",microphoneActionTurnedOffAnnouncement:"Your microphone has been turned off",offSplitButtonMicrophonePrimaryAction:"Unmute mic",onSplitButtonMicrophonePrimaryAction:"Mute mic",microphonePrimaryActionSplitButtonTitle:"Use microphone",microphoneAriaDescription:"Audio options",deepNoiseSuppressionTitle:"Noise suppression",deepNoiseSuppressionOnAnnouncement:"Deep noise suppression has been turned on",deepNoiseSuppressionOffAnnouncement:"Deep noise suppression has been turned off"},devicesButton:{label:"Devices",tooltipContent:"Manage devices",cameraMenuTitle:"Camera",cameraMenuTooltip:"Choose camera",audioDeviceMenuTitle:"Audio Device",audioDeviceMenuTooltip:"Choose audio device",microphoneMenuTitle:"Microphone",microphoneMenuTooltip:"Choose microphone",speakerMenuTitle:"Speaker",speakerMenuTooltip:"Choose speaker"},participantsButton:{label:"People",ariaLabel:"People",tooltipContent:"Show participants",menuHeader:"In this call",participantsListButtonLabel:"{numParticipants} people",muteAllButtonLabel:"Mute all",copyInviteLinkButtonLabel:"Copy invite link",copyInviteLinkActionedAriaLabel:"Invite link copied"},screenShareButton:{onLabel:"Stop presenting",offLabel:"Present",tooltipDisabledContent:"Presenting is disabled",tooltipOnContent:"Presenting your screen",tooltipOffContent:"Present your screen"},raiseHandButton:{offLabel:"Raise",onLabel:"Lower",tooltipDisabledContent:"Raise Hand action is disabled",tooltipOnContent:"Lower Hand",tooltipOffContent:"Raise Hand"},reactionButton:{label:"React",ariaLabel:"React",tooltipDisabledContent:"Reaction action is disabled",tooltipContent:"Send a reaction",likeReactionTooltipContent:"Like",heartReactionTooltipContent:"Love",laughReactionTooltipContent:"Laugh",applauseReactionTooltipContent:"Applause",surprisedReactionTooltipContent:"Surprised"},realTimeText:{isTypingText:"RTT typing"},captionsSettingsModal:{captionsSettingsModalTitle:"Captions Settings",captionsSettingsSpokenLanguageDropdownLabel:"Spoken language",captionsSettingsCaptionLanguageDropdownLabel:"Captions language",captionsSettingsSpokenLanguageDropdownInfoText:"Language that everyone on this call is speaking.",captionsSettingsCaptionLanguageDropdownInfoText:"Captions will appear in this langugage.",captionsSettingsConfirmButtonLabel:"Confirm",captionsSettingsCancelButtonLabel:"Cancel",captionsSettingsModalAriaLabel:"Captions Setting Modal",captionsSettingsCloseModalButtonAriaLabel:"Close Captions Setting"},spokenLanguages:{"ar-ae":"Arabic - U.A.E.","ar-sa":"Arabic - Saudi Arabia","da-dk":"Danish","de-de":"German - Germany","en-au":"English - Australia","en-ca":"English - Canada","en-gb":"English - United Kingdom","en-in":"English - India","en-nz":"English - New Zealand","en-us":"English - United States","es-es":"Spanish - Spain (Modern Sort)","es-mx":"Spanish - Mexico","fi-fi":"Finnish","fr-ca":"French - Canada","fr-fr":"French - France","hi-in":"Hindi","it-it":"Italian - Italy","ja-jp":"Japanese","ko-kr":"Korean","nb-no":"Norwegian (Bokmål)","nl-be":"Dutch - Belgium","nl-nl":"Dutch - Netherlands","pl-pl":"Polish","pt-br":"Portuguese - Brazil","ru-ru":"Russian","sv-se":"Swedish","zh-cn":"Chinese - People's Republic of China","zh-hk":"Chinese - Hong Kong SAR","cs-cz":"Czech","pt-pt":"Portuguese - Portugal","tr-tr":"Turkish","vi-vn":"Vietnamese","th-th":"Thai","he-il":"Hebrew","cy-gb":"Welsh","uk-ua":"Ukrainian","el-gr":"Greek","hu-hu":"Hungarian","ro-ro":"Romanian","sk-sk":"Slovak","zh-tw":"Chinese - Taiwan"},captionLanguages:{ar:"Arabic",da:"Danish",de:"German",en:"English",es:"Spanish",fi:"Finnish","fr-ca":"French - Canada",fr:"French - France",hi:"Hindi",it:"Italian",ja:"Japanese",ko:"Korean",nb:"Norwegian (Bokmål)",nl:"Dutch",pl:"Polish",pt:"Portuguese - Brazil",ru:"Russian",sv:"Swedish","zh-Hans":"Chinese (Simplified)","zh-Hant":"Chinese (Traditional)",cs:"Czech","pt-pt":"Portuguese - Portugal",tr:"Turkish",vi:"Vietnamese",th:"Thai",he:"Hebrew",cy:"Welsh",uk:"Ukrainian",el:"Greek",hu:"Hungarian",ro:"Romanian",sk:"Slovak"},startCaptionsButton:{onLabel:"Turn on captions",offLabel:"Turn off captions",tooltipOnContent:"Turn off captions",tooltipOffContent:"Turn on captions"},startRealTimeTextButton:{label:"Turn on RTT for this call",tooltipOffContent:"Turn on RTT for this call"},messageThread:{yesterday:"Yesterday",sunday:"Sunday",monday:"Monday",tuesday:"Tuesday",wednesday:"Wednesday",thursday:"Thursday",friday:"Friday",saturday:"Saturday",participantJoined:"joined the chat.",participantLeft:"left the chat.",editMessage:"Edit",removeMessage:"Delete",resendMessage:"Try sending again",failToSendTag:"Failed to send",editedTag:"Edited",liveAuthorIntro:"Message from {author}",editedMessageLiveAuthorIntro:"Edited message from {author}",editedMessageLocalUserLiveAuthorIntro:"Edited message",messageContentAriaText:"{status} {author} said {message}",messageContentMineAriaText:"{status} You said {message}",editBoxTextLimit:"Your message is over the limit of {limitNumber} characters",editBoxPlaceholderText:"Edit your message",newMessagesIndicator:"New messages",noDisplayNameSub:"No name",editBoxCancelButton:"Cancel",editBoxSubmitButton:"Done",messageReadCount:"Read by {messageReadByCount} of {remoteParticipantsCount}",actionMenuMoreOptions:"More Options",downloadAttachment:"Download file",openAttachment:"Open file",blockedWarningText:"This message was deleted due to organisational policy.",blockedWarningLinkText:"Details",attachmentCardGroupMessage:"The message has {attachmentCount} attachment",messageDeletedAnnouncementAriaLabel:"The message is deleted",richTextBoldTooltip:"Bold",richTextItalicTooltip:"Italic",richTextUnderlineTooltip:"Underline",richTextBulletListTooltip:"Bulleted list",richTextNumberListTooltip:"Numbered list",richTextIncreaseIndentTooltip:"Increase indent",richTextDecreaseIndentTooltip:"Decrease indent",richTextInsertTableTooltip:"Insert table",richTextFormatButtonTooltip:"Format",richTextInsertRowOrColumnMenu:"Insert",richTextInsertTableMenuTitle:"Insert {column} x {row} table",richTextInsertRowAboveMenu:"Insert above",richTextInsertRowBelowMenu:"Insert below",richTextInsertColumnLeftMenu:"Insert left",richTextInsertColumnRightMenu:"Insert right",richTextDeleteRowOrColumnMenu:"Delete",richTextDeleteColumnMenu:"Delete column",richTextDeleteRowMenu:"Delete row",richTextDeleteTableMenu:"Delete table",richTextToolbarMoreButtonAriaLabel:"More options",attachmentUploadsPendingError:"File is uploading, please wait.",imageUploadsPendingError:"Image is uploading, please wait.",richTextNewBulletedListItemAnnouncement:"Bullet, new line",richTextNewNumberedListItemAnnouncement:"{0}, new line",richTextBulletedListAppliedAnnouncement:"Bulleted list applied",richTextNumberedListAppliedAnnouncement:"Numbered list applied"},errorBar:{unableToReachChatService:"You are offline",accessDenied:"Unable to access chat services - please check the user credentials provided",userNotInChatThread:"You are no longer in this chat thread",sendMessageNotInChatThread:"Failed to send message because you are no longer in this chat thread",sendMessageGeneric:"Failed to send message",callingNetworkFailure:"Troubling connecting call - you seem to be offline",startVideoGeneric:"Failed to start video",stopVideoGeneric:"Failed to stop video",muteGeneric:"Failed to mute microphone",unmuteGeneric:"Failed to unmute microphone",speakingWhileMuted:"Your microphone is muted",startScreenShareGeneric:"There was an issue starting screen share.",stopScreenShareGeneric:"Failed to stop screen sharing",callNetworkQualityLow:"Network quality is low.",teamsMeetingCallNetworkQualityLow:"Network quality is low.",callNoSpeakerFound:"No speakers or headphones found. Connect an audio device to hear the call.",callNoMicrophoneFound:"No microphones found. Connect an audio input device.",callMicrophoneAccessDenied:"Unable to access microphone. Click the lock in the address bar to grant permission to this webpage.",callMicrophoneAccessDeniedSafari:"Unable to access microphone. Refresh the page to allow permissions, or check this browser’s settings and verify permissions are enabled for this website.",callMicrophoneMutedBySystem:"You are muted by your system.",callMicrophoneUnmutedBySystem:"Your microphone recovered and you were unmuted by your system.",callMacOsMicrophoneAccessDenied:"Unable to access microphone. Grant microphone permission in your macOS privacy settings.",callLocalVideoFreeze:"Network bandwidth is poor. Your video may appear paused for others on the call.",callCameraAccessDenied:"Unable to access camera. Click the lock in the address bar to grant permission to this webpage.",callCameraAccessDeniedSafari:"Unable to access camera. Refresh the page to allow permissions, or check this browser’s settings and verify permissions are enabled for this website.",callCameraAlreadyInUse:"Unable to access camera. It may already be in use by another application.",callVideoStoppedBySystem:"Your video has been stopped by your system.",callVideoRecoveredBySystem:"Your video has resumed.",callMacOsCameraAccessDenied:"MacOS is blocking access to your camera. Update your privacy settings to allow this browser to access your camera.",callMacOsScreenShareAccessDenied:"MacOS is blocking screen sharing. Update your privacy settings to allow this browser to record your screen.",dismissButtonAriaLabel:"Close",failedToJoinCallGeneric:"Failed to join call.",failedToJoinCallInvalidMeetingLink:"Unable to join Meeting. Invalid Link.",cameraFrozenForRemoteParticipants:"Users in the call are having issues seeing your video. Please check your devices and network.",unableToStartVideoEffect:"Unable to apply video effect.",startSpotlightWhileMaxParticipantsAreSpotlighted:"Cannot start spotlight on participant(s) because the maximum number of participants are already spotlighted.",mutedByRemoteParticipant:"You were muted by another participant."},notificationStack:{callingNetworkFailure:{title:"Troubling connecting call",message:"You seem to be offline. Please check your network connection and try again.",dismissButtonAriaLabel:"Close"},startVideoGeneric:{title:"Failed to start video.",dismissButtonAriaLabel:"Close"},stopVideoGeneric:{title:"Failed to stop video.",dismissButtonAriaLabel:"Close"},muteGeneric:{title:"Failed to mute microphone.",dismissButtonAriaLabel:"Close"},unmuteGeneric:{title:"Failed to unmute microphone.",dismissButtonAriaLabel:"Close"},speakingWhileMuted:{title:"You're muted.",dismissButtonAriaLabel:"Close"},startScreenShareGeneric:{title:"There was an issue starting screen share.",dismissButtonAriaLabel:"Close"},stopScreenShareGeneric:{title:"Failed to stop screen sharing.",dismissButtonAriaLabel:"Close"},callNetworkQualityLow:{title:"Network quality is low.",dismissButtonAriaLabel:"Close"},teamsMeetingCallNetworkQualityLow:{title:"Network quality is low.",dismissButtonAriaLabel:"Close",message:"Join this call from your phone for better sound. You can continue viewing the meeting on this device.",primaryButtonLabel:"Join by Phone"},callNoSpeakerFound:{title:"No speakers or headphones found",message:"Connect an audio device to hear the call.",dismissButtonAriaLabel:"Close"},callNoMicrophoneFound:{title:"No microphones found",message:"Connect an audio input device.",dismissButtonAriaLabel:"Close"},callMicrophoneAccessDenied:{title:"Unable to access microphone",message:"Click the lock in the address bar to grant permission to this webpage.",dismissButtonAriaLabel:"Close"},callMicrophoneAccessDeniedSafari:{title:"Unable to access microphone",message:"Refresh the page to allow permissions, or check this browser’s settings and verify permissions are enabled for this website.",dismissButtonAriaLabel:"Close"},callMicrophoneMutedBySystem:{title:"You are muted by your system.",dismissButtonAriaLabel:"Close"},callMicrophoneUnmutedBySystem:{title:"Your microphone recovered and you were unmuted by your system.",dismissButtonAriaLabel:"Close"},callMacOsMicrophoneAccessDenied:{title:"Unable to access microphone",message:"Grant microphone permission in your macOS privacy settings.",dismissButtonAriaLabel:"Close"},callLocalVideoFreeze:{title:"Network bandwidth is poor",message:"Your video may appear paused for others on the call.",dismissButtonAriaLabel:"Close"},callCameraAccessDenied:{title:"Unable to access camera",message:"Click the lock in the address bar to grant permission to this webpage.",dismissButtonAriaLabel:"Close"},callCameraAccessDeniedSafari:{title:"Unable to access camera",message:"Refresh the page to allow permissions, or check this browser’s settings and verify permissions are enabled for this website.",dismissButtonAriaLabel:"Close"},callCameraAlreadyInUse:{title:"Unable to access camera",message:"It may already be in use by another application.",dismissButtonAriaLabel:"Close"},callVideoStoppedBySystem:{title:"Your video has been stopped by your system.",dismissButtonAriaLabel:"Close"},callVideoRecoveredBySystem:{title:"Your video has resumed.",dismissButtonAriaLabel:"Close"},callMacOsCameraAccessDenied:{title:"MacOS is blocking access to your camera",message:"Update your privacy settings to allow this browser to access your camera.",dismissButtonAriaLabel:"Close"},callMacOsScreenShareAccessDenied:{title:"MacOS is blocking screen sharing",message:"Update your privacy settings to allow this browser to record your screen.",dismissButtonAriaLabel:"Close"},failedToJoinCallGeneric:{title:"Failed to join call.",dismissButtonAriaLabel:"Close"},failedToJoinCallInvalidMeetingLink:{title:"Unable to join Meeting. Invalid Link.",dismissButtonAriaLabel:"Close"},cameraFrozenForRemoteParticipants:{title:"Users in the call are having issues seeing your video",message:"Please check your devices and network.",dismissButtonAriaLabel:"Close"},unableToStartVideoEffect:{title:"Unable to apply video effect.",dismissButtonAriaLabel:"Close"},startSpotlightWhileMaxParticipantsAreSpotlighted:{title:"Cannot start spotlight on participant(s)",message:"The maximum number of participants are already spotlighted.",dismissButtonAriaLabel:"Close"},mutedByRemoteParticipant:{title:"You were muted by another participant.",dismissButtonAriaLabel:"Close"},recordingStarted:{title:"Recording has started.",message:"By joining, you are giving consent for this meeting to be transcribed.",dismissButtonAriaLabel:"Close"},transcriptionStarted:{title:"Transcription has started.",message:"By joining, you are giving consent for this meeting to be transcribed.",dismissButtonAriaLabel:"Close"},recordingStopped:{title:"Recording is being saved.",message:"Recording has stopped.",dismissButtonAriaLabel:"Close"},transcriptionStopped:{title:"Transcription is being saved.",message:"Transcription has stopped.",dismissButtonAriaLabel:"Close"},recordingAndTranscriptionStarted:{title:"Recording and transcription have started.",message:"By joining, you are giving consent for this meeting to be transcribed.",dismissButtonAriaLabel:"Close"},recordingAndTranscriptionStopped:{title:"Recording and transcription are being saved.",message:"Recording and transcription have stopped.",dismissButtonAriaLabel:"Close"},recordingStoppedStillTranscribing:{title:"Recording has stopped.",message:"You are now only transcribing this meeting.",dismissButtonAriaLabel:"Close"},transcriptionStoppedStillRecording:{title:"Transcription has stopped.",message:"You are now only recording this meeting.",dismissButtonAriaLabel:"Close"},assignedBreakoutRoomOpened:{title:"We'll move you to your assigned room in 5 seconds.",dismissButtonAriaLabel:"Close"},assignedBreakoutRoomChanged:{title:"Your breakout room has changed",message:"We'll move you to your assigned room in 5 seconds.",dismissButtonAriaLabel:"Close"},assignedBreakoutRoomClosed:{title:"Your breakout room has closed",message:"We'll move you back to your meeting in 5 seconds.",dismissButtonAriaLabel:"Close"},assignedBreakoutRoomOpenedPromptJoin:{title:"Join breakout room?",message:"You've been assigned to a breakout room.",dismissButtonAriaLabel:"Close",primaryButtonLabel:"Join room",secondaryButtonLabel:"Later"},breakoutRoomJoined:{title:"You have joined a breakout room.",dismissButtonAriaLabel:"Close"},breakoutRoomClosingSoon:{title:"Room time limit about to expire.",message:"This room will close in 30 seconds",dismissButtonAriaLabel:"Close"},capabilityTurnVideoOnPresent:{title:"Your camera has been enabled",message:"Turn it on if you'd like to share video.",dismissButtonAriaLabel:"Close"},capabilityTurnVideoOnAbsent:{title:"Your camera has been disabled",message:"You can no longer share video.",dismissButtonAriaLabel:"Close"},capabilityUnmuteMicPresent:{title:"Your mic has been enabled",message:"Unmute if you'd like to speak.",dismissButtonAriaLabel:"Close"},capabilityUnmuteMicAbsent:{title:"Your mic has been disabled",message:"You can no longer unmute.",dismissButtonAriaLabel:"Close"},togetherModeStarted:{title:"Togethermode has started",dismissButtonAriaLabel:"Close"},togetherModeEnded:{title:"Togethermode has ended",dismissButtonAriaLabel:"Close"}},videoGallery:{screenIsBeingSharedMessage:"You are sharing your screen",screenShareLoadingMessage:"Loading {participant}'s screen",localScreenShareLoadingMessage:"Loading your screen",localVideoLabel:"You",localVideoCameraSwitcherLabel:"Switch camera",localVideoMovementLabel:"Movable Local Video Tile",localVideoMovementAriaLabel:"Movable Local Video Tile",localVideoSelectedDescription:"{cameraName} selected",displayNamePlaceholder:"Unnamed participant",fitRemoteParticipantToFrame:"Fit to frame",fillRemoteParticipantFrame:"Fill frame",pinParticipantForMe:"Pin for me",pinParticipantForMeLimitReached:"Pin (limit reached)",unpinParticipantForMe:"Unpin",pinParticipantMenuItemAriaLabel:"Pin {participantName}",unpinParticipantMenuItemAriaLabel:"Unpin {participantName}",pinnedParticipantAnnouncementAriaLabel:"Pinned {participantName}",unpinnedParticipantAnnouncementAriaLabel:"Unpinned {participantName}",startSpotlightVideoTileMenuLabel:"Spotlight for everyone",addSpotlightVideoTileMenuLabel:"Add spotlight",spotlightLimitReachedMenuTitle:"Spotlight limit reached",stopSpotlightVideoTileMenuLabel:"Stop spotlighting",stopSpotlightOnSelfVideoTileMenuLabel:"Exit spotlight",attendeeRole:"Attendee",muteParticipantMenuItemLabel:"Mute",waitingScreenText:"Waiting for others to join",forbidAudio:"Disable mic",permitAudio:"Allow mic",forbidAudioTileMenuLabel:"Disable mic",permitAudioTileMenuLabel:"Allow mic",forbidVideo:"Disable camera",permitVideo:"Allow camera",forbidVideoTileMenuLabel:"Disable camera",permitVideoTileMenuLabel:"Allow camera"},dialpad:{placeholderText:"Enter phone number",deleteButtonAriaLabel:"Delete"},holdButton:{onLabel:"Resume",offLabel:"Hold",tooltipOnContent:"Resume call",tooltipOffContent:"Hold call"},videoTile:{participantStateRinging:"Calling...",participantReconnecting:"Reconnecting...",participantStateHold:"On hold",moreOptionsButtonAriaLabel:"More Options {displayName} {isMuted} {micDisabledState} {cameraDisabledState} {isHandRaised} {state} {isSpeaking}",moreOptionsParticipantMutedStateMutedAriaLabel:"muted",moreOptionsParticipantMutedStateUnmutedAriaLabel:"unmuted",moreOptionsParticipantHandRaisedAriaLabel:"Hand raised",moreOptionsParticipantIsSpeakingAriaLabel:"Speaking",moreOptionsParticipantMicDisabledAriaLabel:"Microphone disabled",moreOptionsParticipantCameraDisabledAriaLabel:"Camera disabled"},CameraAndMicrophoneSitePermissionsRequest:{primaryText:"Allow {appName} to use your camera and microphone",secondaryText:"This is so participants can see and hear you.",linkText:"Need help? Get troubleshooting help",primaryButtonText:"Continue without camera and microphone",ariaLabel:"Allow camera and microphone access"},CameraSitePermissionsRequest:{primaryText:"Allow {appName} to use your camera",secondaryText:"This is so participants can see you.",linkText:"Need help? Get troubleshooting help",primaryButtonText:"Continue without camera",ariaLabel:"Allow camera access"},MicrophoneSitePermissionsRequest:{primaryText:"Allow {appName} to use your microphone",secondaryText:"This is so participants can hear you.",linkText:"Need help? Get troubleshooting help",primaryButtonText:"Continue without microphone",ariaLabel:"Allow microphone access"},CameraAndMicrophoneSitePermissionsCheck:{primaryText:"Checking for camera and microphone access",secondaryText:"Allow access if prompted. This is so participants can see and hear you.",linkText:"Need help? Get troubleshooting help",primaryButtonText:"Continue without camera and microphone",ariaLabel:"Checking for camera and microphone access. Allow access if prompted."},CameraSitePermissionsCheck:{primaryText:"Checking for camera access",secondaryText:"Allow access if prompted. This is so participants can see you.",linkText:"Need help? Get troubleshooting help",primaryButtonText:"Continue without camera",ariaLabel:"Checking for camera access. Allow access if prompted."},MicrophoneSitePermissionsCheck:{primaryText:"Checking for microphone access",secondaryText:"Allow access if prompted. This is so participants can hear you.",linkText:"Need help? Get troubleshooting help",primaryButtonText:"Continue without microphone",ariaLabel:"Checking for microphone access. Allow access if prompted."},CameraAndMicrophoneSitePermissionsDenied:{primaryText:"Unable to access camera and microphone",secondaryText:"Click the lock icon in the address bar to grant microphone permissions to this webpage. A page refresh may be required.",primaryButtonText:"Continue without camera and microphone",linkText:"Need help? Get troubleshooting help"},CameraAndMicrophoneSitePermissionsDeniedSafari:{primaryText:"Unable to access camera and microphone",secondaryText:"Refresh the page to allow permissions, or check this browser’s settings and verify permissions are enabled for this website.",primaryButtonText:"Continue without camera and microphone",linkText:"Need help? Get troubleshooting help"},CameraSitePermissionsDenied:{primaryText:"Unable to access camera",secondaryText:"Click the lock icon in the address bar to grant camera permissions to this webpage. A page refresh may be required.",primaryButtonText:"Continue without camera",linkText:"Need help? Get troubleshooting help"},MicrophoneSitePermissionsDenied:{primaryText:"Unable to access microphone",secondaryText:"Click the lock icon in the address bar to grant microphone permissions to this webpage. A page refresh may be required.",primaryButtonText:"Continue without microphone",linkText:"Need help? Get troubleshooting help"},CameraSitePermissionsDeniedSafari:{primaryText:"Unable to access camera",secondaryText:"Refresh the page to allow permissions, or check this browser’s settings and verify permissions are enabled for this website.",primaryButtonText:"Continue without camera",linkText:"Need help? Get troubleshooting help"},MicrophoneSitePermissionsDeniedSafari:{primaryText:"Unable to access microphone",secondaryText:"Refresh the page to allow permissions, or check this browser’s settings and verify permissions are enabled for this website.",primaryButtonText:"Continue without microphone",linkText:"Need help? Get troubleshooting help"},UnsupportedBrowser:{primaryText:"Browser not supported",secondaryText:"Please join this call using a compatible browser.",moreHelpLinkText:"See compatibility requirements"},UnsupportedBrowserVersion:{primaryText:"Browser update needed",secondaryText:"To ensure the best call possible, please update your browser and then try joining the call again.",moreHelpLinkText:"See compatibility requirements",continueAnywayButtonText:"Start call without updating"},UnsupportedOperatingSystem:{primaryText:"Operating system not supported",secondaryText:"Please join this call using a device with a compatible operating system.",moreHelpLinkText:"See compatibility requirements"},BrowserPermissionDenied:{primaryText:"Can't use your camera or microphone",secondaryText:"Your browser might not have access to your camera or microphone. To fix this, open System Preferences.",primaryButtonText:"Try again",linkText:"Need help? Get troubleshooting help"},BrowserPermissionDeniedIOS:{primaryText:"Allow microphone access to continue",secondaryText:"So other participants can hear you.",primaryButtonText:"Try again",imageAltText:"Microphone and camera device permission location for iOS",linkText:"Need help? Get troubleshooting help",step1Text:"Go to the Settings app",step2Text:"Scroll down to settings for this browser",step3Text:"Turn on Microphone (Camera optional)",step4Text:"Try joining the call again",step1DigitText:"1",step2DigitText:"2",step3DigitText:"3",step4DigitText:"4"},verticalGallery:{leftNavButtonAriaLabel:"previous page {current} of {total}",rightNavButtonAriaLabel:"next page {current} of {total}"},meetingConferencePhoneInfo:{meetingConferencePhoneInfoModalTitle:"Join call from your phone",meetingConferencePhoneInfoModalDialIn:"Dial number",meetingConferencePhoneInfoModalMeetingId:"Enter meeting ID",meetingConferencePhoneInfoModalWait:"Wait to be admitted by organiser",meetingConferencePhoneInfoModalNoPhoneAvailable:"No phone available",meetingConferencePhoneInfoModalTollGeoData:"{country}, {city}",meetingConferencePhoneInfoModalTollFree:"(Toll-free)",meetingConferencePhoneInfoModalToll:"(Toll)"},IncomingCallNotification:{incomingCallNotificationPlaceholderId:"Unknown User",incomingCallNotificationPlaceholderAlert:"{callerName} is calling",incomingCallNoticicationAcceptWithAudioAriaLabel:"Accept with audio",incomingCallNoticicationAcceptWithVideoAriaLabel:"Accept with video",incomingCallNoticicationRejectAriaLabel:"Reject",incomingCallNotificationAcceptButtonLabel:"Accept",incomingCallNotificationRejectButtonLabel:"Decline",incomingCallNotificationAccceptWithVideoButtonLabel:"Accept with Video",incomingCallNotificationDismissButtonAriaLabel:"Dismiss"}})},rQt={strings:Jh({participantItem:{isMeText:"(أنت)",menuTitle:"المزيد من الخيارات",removeButtonLabel:"إزالة",sharingIconLabel:"جارٍ المشاركة",mutedIconLabel:"تم كتم الصوت",handRaisedIconLabel:"يد مرفوعة - الموضع {position}",displayNamePlaceholder:"مشارك غير مسمى",participantStateRinging:"يتم الآن الاتصال...",participantStateHold:"قيد الانتظار",participantItemAriaLabel:"{displayName}, {handRaisedState}, {mutedState}, {micDisabledState}, {cameraDisabledState}, {sharingState}, {connectionState}",participantItemWithMoreOptionsAriaLabel:"{displayName}، {handRaisedState}، {mutedState}، {micDisabledState}، {cameraDisabledState}، {sharingState}، {connectionState}، خيارات إضافية",attendeeRole:"الحضور",micDisabledIconLabel:"تم تعطيل الميكروفون",cameraDisabledIconLabel:"تم تعطيل الكاميرا"},ParticipantList:{overflowParticipantCount:"+{overflowCount} من الأشخاص الإضافيين"},typingIndicator:{singleUser:"{user} يكتب",multipleUsers:"يكتب {users} الآن...",multipleUsersAbbreviateOne:"جارٍ الكتابة بواسطة {users} وشخص آخر",multipleUsersAbbreviateMany:"{users} وآخرون {numOthers} يكتبون ...",delimiter:"و "},sendBox:{placeholderText:"أدخل رسالة",textTooLong:"تجاوز طول الرسالة الحد الأقصى.",sendButtonAriaLabel:"إرسال رسالة",attachmentUploadsPendingError:"يتم الآن تحميل الملف، الرجاء الانتظار.",removeAttachment:"إزالة الملف",uploading:"جارٍ التحميل",uploadCompleted:"اكتمل التحميل",attachmentMoreMenu:"خيارات إضافية"},richTextSendBox:{placeholderText:"أدخل رسالة",textTooLong:"تجاوز طول الرسالة الحد الأقصى.",sendButtonAriaLabel:"إرسال رسالة",attachmentUploadsPendingError:"يتم الآن تحميل الملف، الرجاء الانتظار.",imageUploadsPendingError:"يتم الآن تحميل الصورة، الرجاء الانتظار.",removeAttachment:"إزالة الملف",uploading:"يتم الآن التحميل",uploadCompleted:"اكتمل التحميل",richTextBoldTooltip:"غامق",richTextItalicTooltip:"مائل",richTextUnderlineTooltip:"مسطّر",richTextBulletListTooltip:"قائمة ذات تعداد نقطي",richTextNumberListTooltip:"قائمة مرقّمة",richTextIncreaseIndentTooltip:"زيادة المسافة البادئة",richTextDecreaseIndentTooltip:"إنقاص المسافة البادئة",richTextInsertTableTooltip:"إدراج جدول",richTextFormatButtonTooltip:"تنسيق",richTextInsertRowOrColumnMenu:"إدراج",richTextInsertTableMenuTitle:"إدراج جدول بـ {column} x {row}",richTextInsertRowAboveMenu:"إدراج أعلاه",richTextInsertRowBelowMenu:"إدراج أدناه",richTextInsertColumnLeftMenu:"إدراج يساراً",richTextInsertColumnRightMenu:"إدراج يميناً",richTextDeleteRowOrColumnMenu:"حذف",richTextDeleteColumnMenu:"حذف العمود",richTextDeleteRowMenu:"حذف الصف",richTextDeleteTableMenu:"حذف الجدول",richTextToolbarAriaLabel:"شريط أدوات تنسيق الرسائل",richTextToolbarMoreButtonAriaLabel:"خيارات إضافية",attachmentMoreMenu:"خيارات إضافية",richTextNewBulletedListItemAnnouncement:"رمز نقطي، سطر جديد",richTextNewNumberedListItemAnnouncement:"{0}، سطر جديد",richTextBulletedListAppliedAnnouncement:"تم تطبيق قائمة نقطية",richTextNumberedListAppliedAnnouncement:"تطبيق قائمة ذات تعداد رقمي"},realTimeTextModal:{realTimeTextModalAriaLabel:"تشغيل مربع حوار عرض الكتابة في الوقت الحقيقي (RTT) المشروط",realTimeTextModalTitle:"هل تريد تشغيل عرض الكتابة في الوقت الحقيقي؟",realTimeTextModalText:"سيتم تشغيل النص في الوقت الحقيقي (RTT) لكل شخص في الاجتماع.",realTimeTextConfirmButtonLabel:"تشغيل",realTimeTextCancelButtonLabel:"إلغاء الأمر",realTimeTextCloseModalButtonAriaLabel:"إغلاق مربع حوار عرض الكتابة في الوقت الحقيقي (RTT) المشروط"},captionsBanner:{captionsBannerSpinnerText:"يتم الآن بدء التسميات التوضيحية...",realTimeTextInputBoxDefaultText:"اكتب رسالة في الوقت الحقيقي",realTimeTextInputErrorMessage:"لا يمكن أن تتجاوز الرسالة 2000 حرف",realTimeTextBannerTitle:"عرض الكتابة في الوقت الحقيقي (RTT)",realTimeTextBannerContent:"تم تمكين RTT (نص الوقت الحقيقي) لجميع المشاركين طوال مدة الاجتماع.",realTimeTextBannerLinkLabel:"تعرّف على المزيد",captionsOnlyContainerTitle:"نص الكلام",realTimeTextOnlyContainerTitle:"نص حقيقي",captionsAndRealTimeTextContainerTitle:"التسميات التوضيحية والنص في الوقت الحقيقي",expandButtonAriaLabel:"توسيع",minimizeButtonAriaLabel:"طي"},mentionPopover:{mentionPopoverHeader:"الاقتراحات"},imageOverlay:{downloadButtonLabel:"تنزيل",dismissButtonAriaLabel:"إغلاق",overlayVisibleMessage:"تراكب تفاصيل الصور"},messageStatusIndicator:{deliveredAriaLabel:"تم إرسال الرسالة",deliveredTooltipText:"تم الإرسال",seenAriaLabel:"تمت مشاهدة الرسالة من قِبل الآخرين.",seenTooltipText:"تمت المشاهدة",readByTooltipText:"تمت القراءة بواسطة {messageThreadReadCount} من {remoteParticipantsCount}",sendingAriaLabel:"إرسال الرسالة",sendingTooltipText:"جاري الإرسال",failedToSendAriaLabel:"فشل إرسال الرسالة",failedToSendTooltipText:"فشل الإرسال"},endCallButton:{label:"مغادرة",tooltipContent:"مغادرة المكالمة",leaveOption:"مغادرة",endCallOption:"إنهاء المكالمة لدى الجميع"},cameraButton:{onLabel:"الكاميرا",offLabel:"الكاميرا",tooltipDisabledContent:"الكاميرا مُعطلة",tooltipOnContent:"إيقاف تشغيل الكاميرا",tooltipOffContent:"تشغيل الكاميرا",tooltipVideoLoadingContent:"جار تحميل الفيديو",cameraMenuTitle:"الكاميرا",cameraMenuTooltip:"اختيار الكاميرا",cameraButtonSplitRoleDescription:"زر الانقسام",onSplitButtonAriaLabel:"إيقاف تشغيل الكاميرا",offSplitButtonAriaLabel:"تشغيل الكاميرا",cameraActionTurnedOnAnnouncement:"تم تشغيل كاميراتك",cameraActionTurnedOffAnnouncement:"تم إيقاف تشغيل كاميراتك",onSplitButtonPrimaryActionCamera:"إيقاف تشغيل الكاميرا",offSplitButtonPrimaryActionCamera:"تشغيل الكاميرا",cameraPrimaryActionSplitButtonTitle:"استخدام الكاميرا",videoEffectsMenuItemTitle:"التأثيرات",cameraButtonAriaDescription:"خيارات الكاميرا"},microphoneButton:{onLabel:"الميكروفون",offLabel:"الميكروفون",tooltipDisabledContent:"تم تعطيل الميكروفون",tooltipOnContent:"كتم صوت الميكروفون",tooltipOffContent:"إلغاء كتم صوت الميكروفون",microphoneMenuTitle:"الميكروفون",microphoneMenuTooltip:"اختيار الميكروفون",speakerMenuTitle:"مكبر الصوت",speakerMenuTooltip:"اختيار مكبر صوت",microphoneButtonSplitRoleDescription:"زر الانقسام",onSplitButtonAriaLabel:"كتم الميكروفون",offSplitButtonAriaLabel:"إلغاء كتم الميكروفون",microphoneActionTurnedOnAnnouncement:"تم تشغيل الميكروفون",microphoneActionTurnedOffAnnouncement:"تم إيقاف الميكروفون",offSplitButtonMicrophonePrimaryAction:"إلغاء كتم الميكروفون",onSplitButtonMicrophonePrimaryAction:"كتم الميكروفون",microphonePrimaryActionSplitButtonTitle:"استخدام الميكروفون",microphoneAriaDescription:"خيارات الصوت",deepNoiseSuppressionTitle:"منع الضوضاء",deepNoiseSuppressionOnAnnouncement:"تم تشغيل منع الضوضاء العميقة",deepNoiseSuppressionOffAnnouncement:"تم إيقاف تشغيل منع الضوضاء العميقة"},devicesButton:{label:"الأجهزة",tooltipContent:"إدارة الأجهزة",cameraMenuTitle:"الكاميرا",cameraMenuTooltip:"اختيار الكاميرا",audioDeviceMenuTitle:"جهاز صوت",audioDeviceMenuTooltip:"إلغاء كتم صوت الجهاز",microphoneMenuTitle:"الميكروفون",microphoneMenuTooltip:"اختيار الميكروفون",speakerMenuTitle:"مكبر الصوت",speakerMenuTooltip:"اختيار مكبر صوت"},participantsButton:{label:"الأشخاص",ariaLabel:"الأشخاص",tooltipContent:"إظهار المشاركين",menuHeader:"في هذه المكالمة",participantsListButtonLabel:"{numParticipants} من الأشخاص",muteAllButtonLabel:"كتم صوت الجميع",copyInviteLinkButtonLabel:"نسخ ارتباط دعوة",copyInviteLinkActionedAriaLabel:"تم نسخ ارتباط الدعوة"},screenShareButton:{onLabel:"إيقاف التقديم",offLabel:"تقديم",tooltipDisabledContent:"تم تعطيل التقديم",tooltipOnContent:"تقديم العرض على شاشتك.",tooltipOffContent:"عرض الشاشة"},raiseHandButton:{offLabel:"رفع",onLabel:"خفض",tooltipDisabledContent:"تم تعطيل إجراء رفع اليد",tooltipOnContent:"خفض يد",tooltipOffContent:"رفع يد"},reactionButton:{label:"تفاعل",ariaLabel:"تفاعل",tooltipDisabledContent:"تم تعطيل إجراء التفاعل",tooltipContent:"إرسال تفاعل",likeReactionTooltipContent:"إعجاب",heartReactionTooltipContent:"حب",laughReactionTooltipContent:"ضحك",applauseReactionTooltipContent:"تصفيق",surprisedReactionTooltipContent:"مندهش"},realTimeText:{isTypingText:"عرض الكتابة في الوقت الحقيقي (RTT) قيد الكتابة"},captionsSettingsModal:{captionsSettingsModalTitle:"إعدادات التسميات التوضيحية",captionsSettingsSpokenLanguageDropdownLabel:"اللغة المنطوقة",captionsSettingsCaptionLanguageDropdownLabel:"لغة التسميات التوضيحية",captionsSettingsSpokenLanguageDropdownInfoText:"اللغة التي يتحدث بها كل شخص في هذه المكالمة.",captionsSettingsCaptionLanguageDropdownInfoText:"ستظهر التسميات التوضيحية بهذه اللغة.",captionsSettingsConfirmButtonLabel:"تأكيد",captionsSettingsCancelButtonLabel:"إلغاء الأمر",captionsSettingsModalAriaLabel:"مربع حوار مشروط لإعدادات نص الكلام",captionsSettingsCloseModalButtonAriaLabel:"إغلاق إعداد نص الكلام"},spokenLanguages:{"ar-ae":"العربية - الإمارات العربية المتحدة","ar-sa":"العربية - السعودية","da-dk":"الدانمركية","de-de":"الألمانية - ألمانيا","en-au":"الإنجليزية - أستراليا","en-ca":"الإنجليزية - كندا","en-gb":"الإنجليزية - المملكة المتحدة","en-in":"الإنجليزية - الهند","en-nz":"الإنجليزية - نيوزيلندا","en-us":"الإنجليزية - الولايات المتحدة","es-es":"الإسبانية - إسبانيا (فرز حديث)","es-mx":"الإسبانية - المكسيك","fi-fi":"الفنلندية","fr-ca":"الفرنسية - كندا","fr-fr":"الفرنسية - فرنسا","hi-in":"الهندية","it-it":"الإيطالية - إيطاليا","ja-jp":"اليابانية","ko-kr":"الكورية","nb-no":"النرويجية (بوكمال)","nl-be":"الهولندية - بلجيكا","nl-nl":"الهولندية - هولندا","pl-pl":"البولندية","pt-br":"البرتغالية - البرازيل","ru-ru":"الروسية","sv-se":"السويدية","zh-cn":"الصينية - جمهورية الصين الشعبية","zh-hk":"الصينية - منطقة هونغ كونغ الإدارية الخاصة","cs-cz":"التشيكية","pt-pt":"البرتغالية - البرتغال","tr-tr":"التركية","vi-vn":"الفيتنامية","th-th":"التايلاندية","he-il":"العبرية","cy-gb":"الويلزية","uk-ua":"الأوكرانية","el-gr":"اليونانية","hu-hu":"الهنغارية","ro-ro":"الرومانية","sk-sk":"السلوفاكية","zh-tw":"الصينية - تايوان"},captionLanguages:{ar:"العربية",da:"الدانمركية",de:"الألمانية",en:"الإنجليزية",es:"الإسبانية",fi:"الفنلندية","fr-ca":"الفرنسية - كندا",fr:"الفرنسية - فرنسا",hi:"الهندية",it:"الإيطالية",ja:"اليابانية",ko:"الكورية",nb:"النرويجية (بوكمال)",nl:"الهولندية",pl:"البولندية",pt:"البرتغالية - البرازيل",ru:"الروسية",sv:"السويدية","zh-Hans":"الصينية (المبسطة)","zh-Hant":"الصينية (التقليدية)",cs:"التشيكية","pt-pt":"البرتغالية - البرتغال",tr:"التركية",vi:"الفيتنامية",th:"التايلاندية",he:"العبرية",cy:"الويلزية",uk:"الأوكرانية",el:"اليونانية",hu:"الهنغارية",ro:"الرومانية",sk:"السلوفاكية"},startCaptionsButton:{onLabel:"تمكين نص الكلام",offLabel:"تعطيل نص الكلام",tooltipOnContent:"تعطيل نص الكلام",tooltipOffContent:"تمكين نص الكلام"},startRealTimeTextButton:{label:"تشغيل RTT لهذه المكالمة",tooltipOffContent:"تشغيل RTT لهذه المكالمة"},messageThread:{yesterday:"أمس",sunday:"الأحد",monday:"الاثنين",tuesday:"الثلاثاء",wednesday:"الأربعاء",thursday:"الخميس",friday:"الجمعة",saturday:"السبت",participantJoined:"انضم إلى المحادثة.",participantLeft:"قام بمغادرة الدردشة.",editMessage:"تحرير",removeMessage:"حذف",resendMessage:"محاولة الإرسال مرة أخرى",failToSendTag:"فشل الإرسال",editedTag:"تم التحرير",liveAuthorIntro:"رسالة من {author}",editedMessageLiveAuthorIntro:"تم تحرير الرسالة من {author}",editedMessageLocalUserLiveAuthorIntro:"رسالة محررة",messageContentAriaText:"{status} {author} قال {message}",messageContentMineAriaText:"{status} أنت قولت {message}",editBoxTextLimit:"تجاوزت رسالتك الحد الأقصى لعدد الأحرف {limitNumber}",editBoxPlaceholderText:"تحرير رسالتك",newMessagesIndicator:"رسائل جديدة",noDisplayNameSub:"لا يوجد اسم",editBoxCancelButton:"إلغاء الأمر",editBoxSubmitButton:"تم",messageReadCount:"تمت القراءة بواسطة {messageReadByCount} من {remoteParticipantsCount}",actionMenuMoreOptions:"المزيد من الخيارات",downloadAttachment:"تنزيل ملف",openAttachment:"فتح ملف",blockedWarningText:"تم حذف هذه الرسالة بسبب نهج تنظيمي.",blockedWarningLinkText:"تفاصيل",attachmentCardGroupMessage:"تحتوي الرسالة على مرفق {attachmentCount}",messageDeletedAnnouncementAriaLabel:"تم حذف الرسالة",richTextBoldTooltip:"غامق",richTextItalicTooltip:"مائل",richTextUnderlineTooltip:"تسطير",richTextBulletListTooltip:"قائمة ذات تعداد نقطي",richTextNumberListTooltip:"قائمة مرقّمة",richTextIncreaseIndentTooltip:"زيادة المسافة البادئة",richTextDecreaseIndentTooltip:"إنقاص المسافة البادئة",richTextInsertTableTooltip:"إدراج جدول",richTextFormatButtonTooltip:"تنسيق",richTextInsertRowOrColumnMenu:"إدراج",richTextInsertTableMenuTitle:"إدراج جدول بـ {column} x {row}",richTextInsertRowAboveMenu:"إدراج أعلاه",richTextInsertRowBelowMenu:"إدراج أدناه",richTextInsertColumnLeftMenu:"إدراج يساراً",richTextInsertColumnRightMenu:"إدراج يميناً",richTextDeleteRowOrColumnMenu:"حذف",richTextDeleteColumnMenu:"حذف العمود",richTextDeleteRowMenu:"حذف الصف",richTextDeleteTableMenu:"حذف الجدول",richTextToolbarMoreButtonAriaLabel:"خيارات إضافية",attachmentUploadsPendingError:"يتم الآن تحميل الملف، الرجاء الانتظار.",imageUploadsPendingError:"يتم الآن تحميل الصورة، الرجاء الانتظار.",richTextNewBulletedListItemAnnouncement:"رمز نقطي، سطر جديد",richTextNewNumberedListItemAnnouncement:"{0}، سطر جديد",richTextBulletedListAppliedAnnouncement:"تم تطبيق قائمة نقطية",richTextNumberedListAppliedAnnouncement:"تطبيق قائمة ذات تعداد رقمي"},errorBar:{unableToReachChatService:"أنت غير متصل",accessDenied:"يتعذر الوصول إلى خدمات الدردشة - الرجاء التحقق من بيانات اعتماد المستخدم المقدمة",userNotInChatThread:"لم تعد مضمناً في هذا ترابط الدردشة هذا",sendMessageNotInChatThread:"فشل إرسال الرسالة لأنك لم تعد في مؤشر ترابط الدردشة هذا",sendMessageGeneric:"فشل إرسال الرسالة",callingNetworkFailure:"مكالمة مزعجة - يبدو أنك غير متصل",startVideoGeneric:"فشل بدء الفيديو",stopVideoGeneric:"فشل إيقاف الفيديو",muteGeneric:"فشل كتم صوت الميكروفون",unmuteGeneric:"فشل إلغاء كتم صوت الميكروفون",speakingWhileMuted:"تم كتم صوت الميكروفون",startScreenShareGeneric:"حدثت مشكلة أثناء بدء مشاركة الشاشة.",stopScreenShareGeneric:"فشل إيقاف مشاركة الشاشة",callNetworkQualityLow:"جودة الشبكة مقبولة.",teamsMeetingCallNetworkQualityLow:"جودة الشبكة منخفضة.",callNoSpeakerFound:"لم يتم العثور على سماعات أو سماعات رأس. قم بتوصيل جهاز صوت لسماع المكالمة.",callNoMicrophoneFound:"لم يتم العثور على ميكروفونات. قم بتوصيل جهاز إدخال صوت.",callMicrophoneAccessDenied:"يتعذر الوصول إلى الميكروفون. انقر فوق التأمين في شريط العناوين لمنح الإذن لصفحة ويب هذه.",callMicrophoneAccessDeniedSafari:"يتعذر الوصول إلى الميكروفون. قم بتحديث الصفحة للسماح بالأذونات، أو تحقق من إعدادات هذا المستعرض وتحقق من تمكين الأذونات لموقع الويب هذا.",callMicrophoneMutedBySystem:"تم كتم صوتك بواسطة النظام.",callMicrophoneUnmutedBySystem:"تم استرداد الميكروفون وتم إلغاء كتم صوتك من قبل النظام.",callMacOsMicrophoneAccessDenied:"يتعذر الوصول إلى الميكروفون. امنح الميكروفون إذنا في إعدادات خصوصية macOS.",callLocalVideoFreeze:"النطاق الترددي للشبكة ضعيف. قد يظهر الفيديو متوقفا مؤقتا للآخرين في المكالمة.",callCameraAccessDenied:"يتعذر الوصول إلى الكاميرا. انقر فوق التأمين في شريط العناوين لمنح الإذن لصفحة ويب هذه.",callCameraAccessDeniedSafari:"يتعذر الوصول إلى الكاميرا. قم بتحديث الصفحة للسماح بالأذونات، أو تحقق من إعدادات هذا المستعرض وتحقق من تمكين الأذونات لموقع الويب هذا.",callCameraAlreadyInUse:"يتعذر الوصول إلى الكاميرا. قد يكون قيد الاستخدام بالفعل بواسطة تطبيق آخر.",callVideoStoppedBySystem:"تم إيقاف الفيديو الخاص بك من قبل النظام.",callVideoRecoveredBySystem:"تم استئناف الفيديو الخاص بك.",callMacOsCameraAccessDenied:"يقوم MacOS بحظر الوصول إلى الكاميرا الخاصة بك. قم بتحديث إعدادات الخصوصية للسماح لهذا المستعرض بالوصول إلى الكاميرا.",callMacOsScreenShareAccessDenied:"يقوم MacOS بحظر مشاركة الشاشة. قم بتحديث إعدادات الخصوصية للسماح لهذا المستعرض بتسجيل الشاشة.",dismissButtonAriaLabel:"إغلاق",failedToJoinCallGeneric:"فشل في الانضمام إلى المكالمة.",failedToJoinCallInvalidMeetingLink:"تعذر الانضمام إلى الاجتماع. ارتباط غير صالح.",cameraFrozenForRemoteParticipants:"يواجه المستخدمون في المكالمة مشكلات في رؤية الفيديو الخاص بك. الرجاء التحقق من أجهزتك وشبكتك.",unableToStartVideoEffect:"يتعذر تطبيق تأثير الفيديو.",startSpotlightWhileMaxParticipantsAreSpotlighted:"لا يمكن بدء تسليط الضوء على المشاركين (المشاركين) لأنه تم بالفعل تسليط الضوء على الحد الأقصى لعدد المشاركين.",mutedByRemoteParticipant:"تم كتم صوتك من قبل مشارك آخر."},notificationStack:{callingNetworkFailure:{title:"مكالمة مزعجة",message:"يبدو أنك غير متصل. الرجاء التحقق من اتصال الشبكة والمحاولة مرة أخرى.",dismissButtonAriaLabel:"إغلاق"},startVideoGeneric:{title:"فشل بدء الفيديو.",dismissButtonAriaLabel:"إغلاق"},stopVideoGeneric:{title:"فشل إيقاف الفيديو.",dismissButtonAriaLabel:"إغلاق"},muteGeneric:{title:"فشل كتم صوت الميكروفون.",dismissButtonAriaLabel:"إغلاق"},unmuteGeneric:{title:"فشل إلغاء كتم صوت الميكروفون.",dismissButtonAriaLabel:"إغلاق"},speakingWhileMuted:{title:"تم كتم صوتك.",dismissButtonAriaLabel:"إغلاق"},startScreenShareGeneric:{title:"حدثت مشكلة أثناء بدء مشاركة الشاشة.",dismissButtonAriaLabel:"إغلاق"},stopScreenShareGeneric:{title:"فشل إيقاف مشاركة الشاشة",dismissButtonAriaLabel:"إغلاق"},callNetworkQualityLow:{title:"جودة الشبكة مقبولة.",dismissButtonAriaLabel:"إغلاق"},teamsMeetingCallNetworkQualityLow:{title:"جودة الشبكة منخفضة.",dismissButtonAriaLabel:"إغلاق",message:"انضم إلى هذه المكالمة من هاتفك للحصول على صوت أفضل. يمكنك متابعة عرض الاجتماع على هذا الجهاز.",primaryButtonLabel:"انضمام عبر الهاتف"},callNoSpeakerFound:{title:"لم يتم العثور على سماعات أو سماعات رأس",message:"قم بتوصيل جهاز صوت لسماع المكالمة.",dismissButtonAriaLabel:"إغلاق"},callNoMicrophoneFound:{title:"لم يتم العثور على ميكروفونات",message:"قم بتوصيل جهاز إدخال صوت.",dismissButtonAriaLabel:"إغلاق"},callMicrophoneAccessDenied:{title:"يتعذر الوصول إلى الميكروفون",message:"انقر فوق التأمين في شريط العناوين لمنح الإذن لصفحة ويب هذه.",dismissButtonAriaLabel:"إغلاق"},callMicrophoneAccessDeniedSafari:{title:"يتعذر الوصول إلى الميكروفون",message:"قم بتحديث الصفحة للسماح بالأذونات، أو تحقق من إعدادات هذا المستعرض وتحقق من تمكين الأذونات لموقع الويب هذا.",dismissButtonAriaLabel:"إغلاق"},callMicrophoneMutedBySystem:{title:"تم كتم صوتك بواسطة النظام.",dismissButtonAriaLabel:"إغلاق"},callMicrophoneUnmutedBySystem:{title:"تم استرداد الميكروفون وتم إلغاء كتم صوتك من قبل النظام.",dismissButtonAriaLabel:"إغلاق"},callMacOsMicrophoneAccessDenied:{title:"يتعذر الوصول إلى الميكروفون",message:"امنح الميكروفون إذنا في إعدادات خصوصية macOS.",dismissButtonAriaLabel:"إغلاق"},callLocalVideoFreeze:{title:"النطاق الترددي للشبكة ضعيف.",message:"قد يظهر الفيديو متوقفا مؤقتا للآخرين في المكالمة.",dismissButtonAriaLabel:"إغلاق"},callCameraAccessDenied:{title:"تعذر الوصول إلى الكاميرا",message:"انقر فوق التأمين في شريط العناوين لمنح الإذن لصفحة ويب هذه.",dismissButtonAriaLabel:"إغلاق"},callCameraAccessDeniedSafari:{title:"تعذر الوصول إلى الكاميرا",message:"قم بتحديث الصفحة للسماح بالأذونات، أو تحقق من إعدادات هذا المستعرض وتحقق من تمكين الأذونات لموقع الويب هذا.",dismissButtonAriaLabel:"إغلاق"},callCameraAlreadyInUse:{title:"تعذر الوصول إلى الكاميرا",message:"قد يكون قيد الاستخدام بالفعل بواسطة تطبيق آخر.",dismissButtonAriaLabel:"إغلاق"},callVideoStoppedBySystem:{title:"تم إيقاف الفيديو الخاص بك من قبل النظام.",dismissButtonAriaLabel:"إغلاق"},callVideoRecoveredBySystem:{title:"تم استئناف الفيديو الخاص بك.",dismissButtonAriaLabel:"إغلاق"},callMacOsCameraAccessDenied:{title:"يقوم MacOS بحظر الوصول إلى الكاميرا",message:"قم بتحديث إعدادات الخصوصية للسماح لهذا المستعرض بالوصول إلى الكاميرا.",dismissButtonAriaLabel:"إغلاق"},callMacOsScreenShareAccessDenied:{title:"يقوم MacOS بحظر مشاركة الشاشة",message:"قم بتحديث إعدادات الخصوصية للسماح لهذا المستعرض بتسجيل الشاشة.",dismissButtonAriaLabel:"إغلاق"},failedToJoinCallGeneric:{title:"فشل الانضمام إلى المكالمة.",dismissButtonAriaLabel:"إغلاق"},failedToJoinCallInvalidMeetingLink:{title:"تعذر الانضمام إلى الاجتماع. ارتباط غير صالح.",dismissButtonAriaLabel:"إغلاق"},cameraFrozenForRemoteParticipants:{title:"يواجه المستخدمون في المكالمة مشكلات في رؤية الفيديو الخاص بك.",message:"الرجاء التحقق من أجهزتك وشبكتك.",dismissButtonAriaLabel:"إغلاق"},unableToStartVideoEffect:{title:"يتعذر تطبيق تأثير الفيديو.",dismissButtonAriaLabel:"إغلاق"},startSpotlightWhileMaxParticipantsAreSpotlighted:{title:"يتعذر بدء تسليط ضوء على المشاركين.",message:"يتم تسليط الضوء على الحد الأقصى لعدد المشاركين بالفعل.",dismissButtonAriaLabel:"إغلاق"},mutedByRemoteParticipant:{title:"تم كتم صوتك من قبل مشارك آخر.",dismissButtonAriaLabel:"إغلاق"},recordingStarted:{title:"بدأ التسجيل.",message:"من خلال الانضمام، فأنت توافق على كتابة هذا الاجتماع.",dismissButtonAriaLabel:"إغلاق"},transcriptionStarted:{title:"بدأت كتابة الحديث.",message:"من خلال الانضمام، فأنت توافق على كتابة هذا الاجتماع.",dismissButtonAriaLabel:"إغلاق"},recordingStopped:{title:"يتم الآن حفظ التسجيل.",message:"لقد توقف التسجيل.",dismissButtonAriaLabel:"إغلاق"},transcriptionStopped:{title:"يتم الآن حفظ كتابة الحديث.",message:"توقفت كتابة الحديث.",dismissButtonAriaLabel:"إغلاق"},recordingAndTranscriptionStarted:{title:"بدء التسجيل والنسخ. ",message:"من خلال الانضمام، فأنت توافق على كتابة هذا الاجتماع.",dismissButtonAriaLabel:"إغلاق"},recordingAndTranscriptionStopped:{title:"يتم حفظ التسجيل وكتابة الحديث.",message:"التسجيل وكتابة الحديث متوقفان.",dismissButtonAriaLabel:"إغلاق"},recordingStoppedStillTranscribing:{title:"لقد توقف التسجيل.",message:"أنت الآن تقوم فقط بكتابة الحديث لهذا الاجتماع.",dismissButtonAriaLabel:"إغلاق"},transcriptionStoppedStillRecording:{title:"توقفت كتابة الحديث.",message:"أنت الآن تسجل هذا الاجتماع فقط.",dismissButtonAriaLabel:"إغلاق"},assignedBreakoutRoomOpened:{title:"سننقلك إلى الغرفة المعينة خلال 5 ثوان.",dismissButtonAriaLabel:"إغلاق"},assignedBreakoutRoomChanged:{title:"تم تغيير الغرفة الفرعية الخاصة بك",message:"سننقلك إلى الغرفة المعينة خلال 5 ثوان.",dismissButtonAriaLabel:"إغلاق"},assignedBreakoutRoomClosed:{title:"تم إغلاق الغرفة الفرعية الخاصة بك",message:"سنعيدك إلى اجتماعك خلال 5 ثوان.",dismissButtonAriaLabel:"إغلاق"},assignedBreakoutRoomOpenedPromptJoin:{title:"هل تريد الانضمام إلى الغرفة الفرعية؟",message:"تم تعيينك إلى غرفة اجتماع فرعية.",dismissButtonAriaLabel:"إغلاق",primaryButtonLabel:"الانضمام إلى الغرفة",secondaryButtonLabel:"لاحقاً"},breakoutRoomJoined:{title:"لقد قمت بالانضمام إلى غرفة الاجتماع فرعية.",dismissButtonAriaLabel:"‏إغلاق"},breakoutRoomClosingSoon:{title:"أوشكت صلاحية الحد الزمني للغرفة على الانتهاء.",message:"سيتم إغلاق هذه الغرفة في غضون 30 ثانية.",dismissButtonAriaLabel:"‏إغلاق"},capabilityTurnVideoOnPresent:{title:"تم تمكين الكاميرا لديك",message:"قم بتشغيلها إذا كنت ترغب في مشاركة الفيديو.",dismissButtonAriaLabel:"إغلاق"},capabilityTurnVideoOnAbsent:{title:"تم تعطيل الكاميرا",message:"لم يعد بإمكانك مشاركة الفيديو.",dismissButtonAriaLabel:"إغلاق"},capabilityUnmuteMicPresent:{title:"تم تمكين الميكروفون لديك",message:"قم بإلغاء كتم الصوت إذا أردت التحدث.",dismissButtonAriaLabel:"إغلاق"},capabilityUnmuteMicAbsent:{title:"تم تعطيل الميكروفون",message:"لم يعد بإمكانك إلغاء كتم الصوت.",dismissButtonAriaLabel:"إغلاق"},togetherModeStarted:{title:"تم بدء وضع التجميع",dismissButtonAriaLabel:"إغلاق"},togetherModeEnded:{title:"تم إنهاء وضع التجميع",dismissButtonAriaLabel:"إغلاق"}},videoGallery:{screenIsBeingSharedMessage:"أنت تشارك شاشتك",screenShareLoadingMessage:"يتم الآن تحميل شاشة {participant}",localScreenShareLoadingMessage:"تحميل الشاشة",localVideoLabel:"أنت",localVideoCameraSwitcherLabel:"تبديل الكاميرا",localVideoMovementLabel:"لوحة فيديو محلية قابلة للنقل",localVideoMovementAriaLabel:"لوحة فيديو محلية قابلة للنقل",localVideoSelectedDescription:"تم تحديد {cameraName}",displayNamePlaceholder:"مشارك غير مسمى",fitRemoteParticipantToFrame:"الملاءمة داخل إطار",fillRemoteParticipantFrame:"تعبئة الإطار",pinParticipantForMe:"تثبيت نيابة عني",pinParticipantForMeLimitReached:"تثبيت (تم بلوغ الحد الأقصى)",unpinParticipantForMe:"إلغاء التثبيت",pinParticipantMenuItemAriaLabel:"تثبيت {participantName}",unpinParticipantMenuItemAriaLabel:"إزالة تثبيت {participantName}",pinnedParticipantAnnouncementAriaLabel:"تم تثبيت {participantName}",unpinnedParticipantAnnouncementAriaLabel:"تم إلغاء تثبيت {participantName}",startSpotlightVideoTileMenuLabel:"تسليط الضوء لدى الجميع",addSpotlightVideoTileMenuLabel:"إضافة تسليط ضوء",spotlightLimitReachedMenuTitle:"تم الوصول إلى الحد الأقصى لتسليط الضوء",stopSpotlightVideoTileMenuLabel:"التوقف عن تسليط الضوء",stopSpotlightOnSelfVideoTileMenuLabel:"الخروج من وضع تسليط الضوء",attendeeRole:"الحضور",muteParticipantMenuItemLabel:"كتم الصوت",waitingScreenText:"في انتظار انضمام الآخرين",forbidAudio:"تعطيل الميكروفون",permitAudio:"السماح بالميكروفون",forbidAudioTileMenuLabel:"تعطيل الميكروفون",permitAudioTileMenuLabel:"السماح بالميكروفون",forbidVideo:"تعطيل الكاميرا",permitVideo:"السماح بالكاميرا",forbidVideoTileMenuLabel:"تعطيل الكاميرا",permitVideoTileMenuLabel:"السماح بالكاميرا"},dialpad:{placeholderText:"أدخل رقم الهاتف",deleteButtonAriaLabel:"حذف"},holdButton:{onLabel:"استئناف",offLabel:"انتظار",tooltipOnContent:"استئناف المكالمة",tooltipOffContent:"تعليق المكالمة"},videoTile:{participantStateRinging:"يتم الآن الاتصال...",participantReconnecting:"يتم الآن إعادة الاتصال...",participantStateHold:"قيد الانتظار",moreOptionsButtonAriaLabel:"خيارات إضافية {displayName} {isMuted} {micDisabledState} {cameraDisabledState} {isHandRaised} {state} {isSpeaking}",moreOptionsParticipantMutedStateMutedAriaLabel:"مكتوم الصوت",moreOptionsParticipantMutedStateUnmutedAriaLabel:"غير مكتوم الصوت",moreOptionsParticipantHandRaisedAriaLabel:"يد مرفوعة",moreOptionsParticipantIsSpeakingAriaLabel:"يتحدث",moreOptionsParticipantMicDisabledAriaLabel:"تم تعطيل الميكروفون",moreOptionsParticipantCameraDisabledAriaLabel:"تم تعطيل الكاميرا"},CameraAndMicrophoneSitePermissionsRequest:{primaryText:"السماح {appName} باستخدام الكاميرا والميكروفون لديك",secondaryText:"هذا حتى يتمكن المشاركون من مشاهدتك والاستماع إليك.",linkText:"هل تحتاج إلى مساعدة؟ الحصول على تعليمات استكشاف الأخطاء وإصلاحها",primaryButtonText:"المتابعة بدون الكاميرا والميكروفون",ariaLabel:"السماح بالوصول إلى الكاميرا والميكروفون"},CameraSitePermissionsRequest:{primaryText:"السماح {appName} باستخدام الكاميرا",secondaryText:"هذا حتى يتمكن المشاركون من مشاهدتك والاستماع إليك.",linkText:"هل تحتاج إلى مساعدة؟ الحصول على تعليمات استكشاف الأخطاء وإصلاحها",primaryButtonText:"المتابعة دون كاميرا",ariaLabel:"السماح بالوصول إلى الكاميرا"},MicrophoneSitePermissionsRequest:{primaryText:"السماح {appName} باستخدام الميكروفون",secondaryText:"هذا حتى يتمكن المشاركون من الاستماع إليك.",linkText:"هل تحتاج إلى مساعدة؟ الحصول على تعليمات استكشاف الأخطاء وإصلاحها",primaryButtonText:"المتابعة دون ميكروفون",ariaLabel:"السماح بالوصول إلى الميكروفون"},CameraAndMicrophoneSitePermissionsCheck:{primaryText:"التحقق من الوصول إلى الكاميرا والميكروفون",secondaryText:"السماح بالوصول إذا طُلب منك ذلك. هذا حتى يتمكن المشاركون من رؤيتك والاستماع إليك.",linkText:"هل تحتاج إلى مساعدة؟ الحصول على تعليمات استكشاف الأخطاء وإصلاحها",primaryButtonText:"المتابعة بدون الكاميرا والميكروفون",ariaLabel:"التحقق من الوصول إلى الكاميرا والميكروفون. السماح بالوصول إذا طُلب منك ذلك."},CameraSitePermissionsCheck:{primaryText:"التحقق من الوصول إلى الكاميرا",secondaryText:"السماح بالوصول إذا طُلب منك ذلك. هذا حتى يتمكن المشاركون من رؤيتك.",linkText:"هل تحتاج إلى مساعدة؟ الحصول على تعليمات استكشاف الأخطاء وإصلاحها",primaryButtonText:"المتابعة بدون كاميرا",ariaLabel:"التحقق من الوصول إلى الكاميرا. السماح بالوصول إذا طُلب منك ذلك."},MicrophoneSitePermissionsCheck:{primaryText:"التحقق من الوصول إلى الميكروفون",secondaryText:"السماح بالوصول إذا طُلب منك ذلك. هذا حتى يتمكن المشاركون من الاستماع إليك.",linkText:"هل تحتاج إلى مساعدة؟ الحصول على تعليمات استكشاف الأخطاء وإصلاحها",primaryButtonText:"المتابعة بدون ميكروفون",ariaLabel:"التحقق من الوصول إلى الميكروفون. السماح بالوصول إذا طُلب منك ذلك."},CameraAndMicrophoneSitePermissionsDenied:{primaryText:"يتعذر الوصول إلى الكاميرا والميكروفون",secondaryText:"انقر فوق أيقونة التأمين في شريط العناوين لمنح أذونات الميكروفون لصفحة الويب هذه. قد يكون تحديث الصفحة مطلوبا.",primaryButtonText:"المتابعة دون الكاميرا والميكروفون",linkText:"هل تحتاج إلى مساعدة؟ الحصول على تعليمات استكشاف الأخطاء وإصلاحها"},CameraAndMicrophoneSitePermissionsDeniedSafari:{primaryText:"يتعذر الوصول إلى الكاميرا والميكروفون",secondaryText:"قم بتحديث الصفحة للسماح بالأذونات، أو تحقق من إعدادات هذا المستعرض وتحقق من تمكين الأذونات لموقع الويب هذا.",primaryButtonText:"المتابعة دون الكاميرا والميكروفون",linkText:"هل تحتاج إلى مساعدة؟ الحصول على تعليمات استكشاف الأخطاء وإصلاحها"},CameraSitePermissionsDenied:{primaryText:"تعذر الوصول إلى الكاميرا",secondaryText:"انقر فوق أيقونة التأمين في شريط العناوين لمنح أذونات الكاميرا لصفحة ويب هذه. قد يكون تحديث الصفحة مطلوبا.",primaryButtonText:"المتابعة دون كاميرا",linkText:"هل تحتاج إلى مساعدة؟ الحصول على تعليمات استكشاف الأخطاء وإصلاحها"},MicrophoneSitePermissionsDenied:{primaryText:"يتعذر الوصول إلى الميكروفون",secondaryText:"انقر فوق أيقونة التأمين في شريط العناوين لمنح أذونات الميكروفون لصفحة الويب هذه. قد يكون تحديث الصفحة مطلوبا.",primaryButtonText:"المتابعة بدون ميكروفون",linkText:"هل تحتاج إلى مساعدة؟ الحصول على تعليمات استكشاف الأخطاء وإصلاحها"},CameraSitePermissionsDeniedSafari:{primaryText:"تعذر الوصول إلى الكاميرا",secondaryText:"قم بتحديث الصفحة للسماح بالأذونات، أو تحقق من إعدادات هذا المستعرض وتحقق من تمكين الأذونات لموقع الويب هذا.",primaryButtonText:"المتابعة دون كاميرا",linkText:"هل تحتاج إلى مساعدة؟ الحصول على تعليمات استكشاف الأخطاء وإصلاحها"},MicrophoneSitePermissionsDeniedSafari:{primaryText:"يتعذر الوصول إلى الميكروفون",secondaryText:"قم بتحديث الصفحة للسماح بالأذونات، أو تحقق من إعدادات هذا المستعرض وتحقق من تمكين الأذونات لموقع الويب هذا.",primaryButtonText:"المتابعة دون ميكروفون",linkText:"هل تحتاج إلى مساعدة؟ الحصول على تعليمات استكشاف الأخطاء وإصلاحها"},UnsupportedBrowser:{primaryText:"المتصفح غير مدعوم",secondaryText:"الرجاء الانضمام إلى هذه المكالمة باستخدام مستعرض متوافق.",moreHelpLinkText:"الاطلاع على متطلبات التوافق"},UnsupportedBrowserVersion:{primaryText:"يلزم تحديث المستعرض",secondaryText:"لضمان أفضل مكالمة ممكنة، الرجاء تحديث المستعرض الخاص بك ثم محاولة الانضمام إلى المكالمة مرة أخرى.",moreHelpLinkText:"الاطلاع على متطلبات التوافق",continueAnywayButtonText:"بدء المكالمة دون تحديث"},UnsupportedOperatingSystem:{primaryText:"نظام التشغيل غير معتمد",secondaryText:"الرجاء الانضمام إلى هذه المكالمة باستخدام جهاز بنظام تشغيل متوافق.",moreHelpLinkText:"الاطلاع على متطلبات التوافق"},BrowserPermissionDenied:{primaryText:"يتعذر استخدام الكاميرا أو الميكروفون",secondaryText:'قد لا يكون لدى المستعرض إمكانية الوصول إلى الكاميرا أو الميكروفون لديك. لحل هذه المشكلة، افتح "تفضيلات النظام".',primaryButtonText:"حاول مرة أخرى",linkText:"هل تحتاج إلى مساعدة؟ الحصول على تعليمات استكشاف الأخطاء وإصلاحها"},BrowserPermissionDeniedIOS:{primaryText:"السماح بالوصول إلى الميكروفون للمتابعة",secondaryText:"حتى يتمكن المشاركون الآخرون من سماعك.",primaryButtonText:"حاول مرة أخرى",imageAltText:"موقع إذن جهاز الكاميرا والميكروفون لـ iOS",linkText:"هل تحتاج إلى مساعدة؟ الحصول على تعليمات استكشاف الأخطاء وإصلاحها",step1Text:"انتقل إلى تطبيق الإعدادات",step2Text:"التمرير لأسفل للوصول إلى إعدادات هذا المستعرض",step3Text:"تشغيل الميكروفون (الكاميرا اختيارية)",step4Text:"حاول الانضمام إلى المكالمة مرة أخرى",step1DigitText:"1",step2DigitText:"2",step3DigitText:"3",step4DigitText:"4"},verticalGallery:{leftNavButtonAriaLabel:"الصفحة السابقة {current} من {total}",rightNavButtonAriaLabel:"الصفحة التالية {current} من {total}"},meetingConferencePhoneInfo:{meetingConferencePhoneInfoModalTitle:"الانضمام إلى مكالمة من هاتفك",meetingConferencePhoneInfoModalDialIn:"رقم الاتصال",meetingConferencePhoneInfoModalMeetingId:"أدخل معرف الاجتماع",meetingConferencePhoneInfoModalWait:"انتظر حتى يتم القبول من قبل المنظم",meetingConferencePhoneInfoModalNoPhoneAvailable:"لا يتوفر هاتف",meetingConferencePhoneInfoModalTollGeoData:"{country}، {city}",meetingConferencePhoneInfoModalTollFree:"(رقم مجاني)",meetingConferencePhoneInfoModalToll:"(الرقم غير المجاني)"},IncomingCallNotification:{incomingCallNotificationPlaceholderId:"مستخدم غير معروف",incomingCallNotificationPlaceholderAlert:"{callerName} يتصل",incomingCallNoticicationAcceptWithAudioAriaLabel:"قبول مع الصوت",incomingCallNoticicationAcceptWithVideoAriaLabel:"قبول مع الفيديو",incomingCallNoticicationRejectAriaLabel:"رفض",incomingCallNotificationAcceptButtonLabel:"قبول",incomingCallNotificationRejectButtonLabel:"رفض",incomingCallNotificationAccceptWithVideoButtonLabel:"قبول مع الفيديو",incomingCallNotificationDismissButtonAriaLabel:"تجاهل"}})},oQt={strings:Jh({participantItem:{isMeText:"(vy)",menuTitle:"Další možnosti",removeButtonLabel:"Odebrat",sharingIconLabel:"Sdílení",mutedIconLabel:"Ztlumeno",handRaisedIconLabel:"Zvednutá ruka – pozice {position}",displayNamePlaceholder:"Nepojmenovaný účastník",participantStateRinging:"Volání…",participantStateHold:"Pozastavený hovor",participantItemAriaLabel:"{displayName}, {handRaisedState}, {mutedState}, {micDisabledState}, {cameraDisabledState}, {sharingState}, {connectionState}",participantItemWithMoreOptionsAriaLabel:"{displayName}, {handRaisedState}, {mutedState}, {micDisabledState}, {cameraDisabledState}, {sharingState}, {connectionState}, Další možnosti",attendeeRole:"Účastník",micDisabledIconLabel:"Mikrofon zakázán",cameraDisabledIconLabel:"Kamera zakázána"},ParticipantList:{overflowParticipantCount:"+{overflowCount} další(ch)"},typingIndicator:{singleUser:"{user} píše...",multipleUsers:"{users} píší...",multipleUsersAbbreviateOne:"{users} a 1 další píší...",multipleUsersAbbreviateMany:"{users} a {numOthers} ostatní píší...",delimiter:", "},sendBox:{placeholderText:"Zadejte zprávu",textTooLong:"Délka vaší zprávy překračuje maximální limit.",sendButtonAriaLabel:"Poslat zprávu",attachmentUploadsPendingError:"Soubor se nahrává, počkejte prosím.",removeAttachment:"Odebrat soubor",uploading:"Nahrávání",uploadCompleted:"Nahrávání se dokončilo",attachmentMoreMenu:"Další možnosti"},richTextSendBox:{placeholderText:"Zadejte zprávu",textTooLong:"Délka vaší zprávy překračuje maximální limit.",sendButtonAriaLabel:"Poslat zprávu",attachmentUploadsPendingError:"Soubor se nahrává, počkejte prosím.",imageUploadsPendingError:"Obrázek se nahrává, počkejte prosím.",removeAttachment:"Odebrat soubor",uploading:"Nahrávání",uploadCompleted:"Nahrávání se dokončilo",richTextBoldTooltip:"Tučné",richTextItalicTooltip:"Kurzíva",richTextUnderlineTooltip:"Podtržení",richTextBulletListTooltip:"Seznam s odrážkami",richTextNumberListTooltip:"Číslovaný seznam",richTextIncreaseIndentTooltip:"Zvětšit odsazení",richTextDecreaseIndentTooltip:"Zmenšit odsazení",richTextInsertTableTooltip:"Vložit tabulku",richTextFormatButtonTooltip:"Formát",richTextInsertRowOrColumnMenu:"Vložit",richTextInsertTableMenuTitle:"Vložit {column} x {row} tabulka",richTextInsertRowAboveMenu:"Vložit nad",richTextInsertRowBelowMenu:"Vložit pod",richTextInsertColumnLeftMenu:"Vložit vlevo",richTextInsertColumnRightMenu:"Vložit vpravo",richTextDeleteRowOrColumnMenu:"Odstranit",richTextDeleteColumnMenu:"Odstranit sloupec",richTextDeleteRowMenu:"Odstranit řádek",richTextDeleteTableMenu:"Odstranit tabulku",richTextToolbarAriaLabel:"Panel nástrojů Formátování zpráv",richTextToolbarMoreButtonAriaLabel:"Další možnosti",attachmentMoreMenu:"Další možnosti",richTextNewBulletedListItemAnnouncement:"Odrážka, nový řádek",richTextNewNumberedListItemAnnouncement:"{0}, nový řádek",richTextBulletedListAppliedAnnouncement:"Byl použit seznam s odrážkami",richTextNumberedListAppliedAnnouncement:"Použil se číslovaný seznam."},realTimeTextModal:{realTimeTextModalAriaLabel:"Zapnout modální okno psaní v reálném čase",realTimeTextModalTitle:"Zapnout psaní v reálném čase?",realTimeTextModalText:"Text v reálném čase (RTT) se zapne pro všechny účastníky schůzky.",realTimeTextConfirmButtonLabel:"Zapnout",realTimeTextCancelButtonLabel:"Zrušit",realTimeTextCloseModalButtonAriaLabel:"Zavřít modální okno psaní v reálném čase"},captionsBanner:{captionsBannerSpinnerText:"Spouští se titulky...",realTimeTextInputBoxDefaultText:"Napište zprávu v reálném čase",realTimeTextInputErrorMessage:"Zpráva nesmí být delší než 2000 znaků",realTimeTextBannerTitle:"RTT",realTimeTextBannerContent:"RTT (psaní v reálném čase) je povolené pro všechny účastníky po celou dobu trvání schůzky.",realTimeTextBannerLinkLabel:"Další informace",captionsOnlyContainerTitle:"Titulky",realTimeTextOnlyContainerTitle:"Text v reálném čase",captionsAndRealTimeTextContainerTitle:"Titulky a text v reálném čase",expandButtonAriaLabel:"Rozbalit",minimizeButtonAriaLabel:"Sbalit"},mentionPopover:{mentionPopoverHeader:"Návrhy"},imageOverlay:{downloadButtonLabel:"Stáhnout",dismissButtonAriaLabel:"Zavřít",overlayVisibleMessage:"Překrytí podrobností obrázku"},messageStatusIndicator:{deliveredAriaLabel:"Zpráva byla odeslána",deliveredTooltipText:"Odesláno",seenAriaLabel:"Zpráva zobrazena příjemci",seenTooltipText:"Zobrazeno",readByTooltipText:"Přečetl(a) {messageThreadReadCount} z {remoteParticipantsCount}",sendingAriaLabel:"Odesílání zprávy",sendingTooltipText:"Odesílání",failedToSendAriaLabel:"Zprávu se nepodařilo odeslat",failedToSendTooltipText:"Odeslání se nezdařilo"},endCallButton:{label:"Opustit",tooltipContent:"Opustit hovor",leaveOption:"Odejít",endCallOption:"Ukončit hovor pro všechny"},cameraButton:{onLabel:"Kamera",offLabel:"Kamera",tooltipDisabledContent:"Kamera je zakázaná",tooltipOnContent:"Vypnout kameru",tooltipOffContent:"Zapnout kameru",tooltipVideoLoadingContent:"Video se načítá",cameraMenuTitle:"Kamera",cameraMenuTooltip:"Zvolit kameru",cameraButtonSplitRoleDescription:"Tlačítko rozdělení",onSplitButtonAriaLabel:"Vypnout kameru",offSplitButtonAriaLabel:"Zapnout kameru",cameraActionTurnedOnAnnouncement:"Vaše kamera je zapnutá",cameraActionTurnedOffAnnouncement:"Vaše kamera je vypnutá",onSplitButtonPrimaryActionCamera:"Vypnout kameru",offSplitButtonPrimaryActionCamera:"Zapnout kameru",cameraPrimaryActionSplitButtonTitle:"Použít kameru",videoEffectsMenuItemTitle:"Efekty",cameraButtonAriaDescription:"možnosti kamery"},microphoneButton:{onLabel:"Mikrofon",offLabel:"Mikrofon",tooltipDisabledContent:"Mikrofon je zakázaný",tooltipOnContent:"Ztlumit mikrofon",tooltipOffContent:"Zrušit ztlumení mikrofonu",microphoneMenuTitle:"Mikrofon",microphoneMenuTooltip:"Zvolit mikrofon",speakerMenuTitle:"Reproduktor",speakerMenuTooltip:"Zvolit reproduktor",microphoneButtonSplitRoleDescription:"Tlačítko rozdělení",onSplitButtonAriaLabel:"Ztlumit mikrofon",offSplitButtonAriaLabel:"Zrušit ztlumení mikrofonu",microphoneActionTurnedOnAnnouncement:"Váš mikrofon je zapnutý",microphoneActionTurnedOffAnnouncement:"Váš mikrofon je vypnutý",offSplitButtonMicrophonePrimaryAction:"Zrušit ztlumení mikrofonu",onSplitButtonMicrophonePrimaryAction:"Ztlumit mikrofon",microphonePrimaryActionSplitButtonTitle:"Použít mikrofon",microphoneAriaDescription:"Možnosti zvuku",deepNoiseSuppressionTitle:"Potlačení šumu",deepNoiseSuppressionOnAnnouncement:"Potlačení hlubokého šumu je zapnuté",deepNoiseSuppressionOffAnnouncement:"Potlačení hlubokého šumu je vypnuté"},devicesButton:{label:"Zařízení",tooltipContent:"Spravovat zařízení",cameraMenuTitle:"Kamera",cameraMenuTooltip:"Zvolit kameru",audioDeviceMenuTitle:"Zvukové zařízení",audioDeviceMenuTooltip:"Zvolit zvukové zařízení",microphoneMenuTitle:"Mikrofon",microphoneMenuTooltip:"Zvolit mikrofon",speakerMenuTitle:"Reproduktor",speakerMenuTooltip:"Zvolit reproduktor"},participantsButton:{label:"Lidé",ariaLabel:"Lidé",tooltipContent:"Zobrazit účastníky",menuHeader:"V tomto hovoru",participantsListButtonLabel:"Počet lidí: {numParticipants}",muteAllButtonLabel:"Ztlumit všechny",copyInviteLinkButtonLabel:"Kopírovat odkaz pro pozvání",copyInviteLinkActionedAriaLabel:"Odkaz pozvánky se zkopíroval"},screenShareButton:{onLabel:"Zastavit prezentaci",offLabel:"Prezentovat",tooltipDisabledContent:"Sdílení je zakázáno",tooltipOnContent:"Sdílí se vaše obrazovka",tooltipOffContent:"Sdílet obrazovku"},raiseHandButton:{offLabel:"Zvednout",onLabel:"Dolů",tooltipDisabledContent:"Akce Zvednout ruku je zakázaná",tooltipOnContent:"Dát ruku dolů",tooltipOffContent:"Zvednout ruku"},reactionButton:{label:"Reagovat",ariaLabel:"Reagovat",tooltipDisabledContent:"Akce reakce je zakázaná",tooltipContent:"Odeslání reakce",likeReactionTooltipContent:"To se mi líbí",heartReactionTooltipContent:"Láska",laughReactionTooltipContent:"Smích",applauseReactionTooltipContent:"Aplaus",surprisedReactionTooltipContent:"Překvapení"},realTimeText:{isTypingText:"Probíhá psaní v reálném čase"},captionsSettingsModal:{captionsSettingsModalTitle:"Nastavení titulků",captionsSettingsSpokenLanguageDropdownLabel:"Mluvený jazyk",captionsSettingsCaptionLanguageDropdownLabel:"Jazyk titulků",captionsSettingsSpokenLanguageDropdownInfoText:"Jazyk, kterým mluví všichni účastníci tohoto hovoru.",captionsSettingsCaptionLanguageDropdownInfoText:"Titulky se zobrazí v tomto jazyce. ",captionsSettingsConfirmButtonLabel:"Potvrdit",captionsSettingsCancelButtonLabel:"Zrušit",captionsSettingsModalAriaLabel:"Modální nastavení titulků",captionsSettingsCloseModalButtonAriaLabel:"Nastavení titulků"},spokenLanguages:{"ar-ae":"Arabština - Spojené arabské emiráty","ar-sa":"Arabština - Saúdská Arábie","da-dk":"Dánština","de-de":"Němčina - Německo","en-au":"Angličtina - Austrálie","en-ca":"Angličtina - Kanada","en-gb":"Angličtina - Spojené království","en-in":"Angličtina - Indie","en-nz":"Angličtina - Nový Zéland","en-us":"Angličtina - Spojené státy americké","es-es":"Španělština - Španělsko (Modern Sort)","es-mx":"Španělština - Mexiko","fi-fi":"Finština","fr-ca":"Francouzština - Kanada","fr-fr":"Francouzština - Francie","hi-in":"Hindština","it-it":"Italština - Itálie","ja-jp":"Japonština","ko-kr":"Korejština","nb-no":"Norština (Bokmål)","nl-be":"Holandština – Belgie","nl-nl":"Holandština - Nizozemsko","pl-pl":"Polština","pt-br":"Portugalština – Brazílie","ru-ru":"Ruština","sv-se":"Švédština","zh-cn":"Čínština – Čínská lidová republika","zh-hk":"Čínština – Hong Kong SAR","cs-cz":"Čeština","pt-pt":"Portugalština – Portugalsko","tr-tr":"Turečtina","vi-vn":"Vietnamština","th-th":"Thajština","he-il":"Hebrejština","cy-gb":"Velština","uk-ua":"Ukrajinština","el-gr":"Řečtina","hu-hu":"Maďarština","ro-ro":"Rumunština","sk-sk":"Slovenština","zh-tw":"Čínština – Tchaj-wan"},captionLanguages:{ar:"Arabština",da:"Dánština",de:"Němčina",en:"Angličtina",es:"Španělština",fi:"Finština","fr-ca":"Francouzština - Kanada",fr:"Francouzština - Francie",hi:"Hindština",it:"Italština",ja:"Japonština",ko:"Korejština",nb:"Norština (Bokmål)",nl:"Nizozemština",pl:"Polština",pt:"Portugalština – Brazílie",ru:"Ruština",sv:"Švédština","zh-Hans":"Čínština (zjednodušená)","zh-Hant":"Čínština (tradiční)",cs:"Čeština","pt-pt":"Portugalština – Portugalsko",tr:"Turečtina",vi:"Vietnamština",th:"Thajština",he:"Hebrejština",cy:"Velština",uk:"Ukrajinština",el:"Řečtina",hu:"Maďarština",ro:"Rumunština",sk:"Slovenština"},startCaptionsButton:{onLabel:"Zapnout titulky",offLabel:"Vypnout titulky",tooltipOnContent:"Vypnout titulky",tooltipOffContent:"Zapnout titulky"},startRealTimeTextButton:{label:"Zapnout RTT pro tento hovor",tooltipOffContent:"Zapnout RTT pro tento hovor"},messageThread:{yesterday:"Včera",sunday:"Neděle",monday:"Pondělí",tuesday:"Úterý",wednesday:"Středa",thursday:"Čtvrtek",friday:"Pátek",saturday:"Sobota",participantJoined:"se připojil(a) k chatu.",participantLeft:"opustil(a) chat.",editMessage:"Upravit",removeMessage:"Odstranit",resendMessage:"Zkusit odeslat znovu",failToSendTag:"Odeslání se nezdařilo",editedTag:"Upraveno",liveAuthorIntro:"Zpráva od {author}",editedMessageLiveAuthorIntro:"Upravená zpráva od {author}",editedMessageLocalUserLiveAuthorIntro:"Upravená zpráva",messageContentAriaText:"{status} {author} řekl(a) {message}",messageContentMineAriaText:"{status} Řekli jste {message}.",editBoxTextLimit:"Vaše zpráva překročila limit {limitNumber} znaků.",editBoxPlaceholderText:"Upravit zprávu",newMessagesIndicator:"Nové zprávy",noDisplayNameSub:"Bez jména",editBoxCancelButton:"Zrušit",editBoxSubmitButton:"Hotovo",messageReadCount:"Přečetl(a) {messageReadByCount} z {remoteParticipantsCount}",actionMenuMoreOptions:"Další možnosti",downloadAttachment:"Stáhnout soubor",openAttachment:"Otevřít soubor",blockedWarningText:"Tato zpráva se odstranila kvůli zásadám organizace.",blockedWarningLinkText:"Podrobnosti",attachmentCardGroupMessage:"Zpráva obsahuje {attachmentCount} přílohu",messageDeletedAnnouncementAriaLabel:"Zpráva se odstranila.",richTextBoldTooltip:"Tučné",richTextItalicTooltip:"Kurzíva",richTextUnderlineTooltip:"Podtržení",richTextBulletListTooltip:"Seznam s odrážkami",richTextNumberListTooltip:"Číslovaný seznam",richTextIncreaseIndentTooltip:"Zvětšit odsazení",richTextDecreaseIndentTooltip:"Zmenšit odsazení",richTextInsertTableTooltip:"Vložit tabulku",richTextFormatButtonTooltip:"Formát",richTextInsertRowOrColumnMenu:"Vložit",richTextInsertTableMenuTitle:"Vložit {column} x {row} tabulka",richTextInsertRowAboveMenu:"Vložit nad",richTextInsertRowBelowMenu:"Vložit pod",richTextInsertColumnLeftMenu:"Vložit vlevo",richTextInsertColumnRightMenu:"Vložit vpravo",richTextDeleteRowOrColumnMenu:"Odstranit",richTextDeleteColumnMenu:"Odstranit sloupec",richTextDeleteRowMenu:"Odstranit řádek",richTextDeleteTableMenu:"Odstranit tabulku",richTextToolbarMoreButtonAriaLabel:"Další možnosti",attachmentUploadsPendingError:"Soubor se nahrává, počkejte prosím.",imageUploadsPendingError:"Obrázek se nahrává, počkejte prosím.",richTextNewBulletedListItemAnnouncement:"Odrážka, nový řádek",richTextNewNumberedListItemAnnouncement:"{0}, nový řádek",richTextBulletedListAppliedAnnouncement:"Použil se seznam s odrážkami",richTextNumberedListAppliedAnnouncement:"Použil se číslovaný seznam"},errorBar:{unableToReachChatService:"Jste offline",accessDenied:"Nepovedlo se získat přístup ke službám chatu. Zkontrolujte prosím zadané přihlašovací údaje uživatele.",userNotInChatThread:"Už nejste v tomto vlákně chatu",sendMessageNotInChatThread:"Zprávu se nepovedlo poslat, protože už nejste v tomto vláknu chatu.",sendMessageGeneric:"Zprávu se nepovedlo odeslat",callingNetworkFailure:"Máte problémy s připojením hovoru – vypadá to, že jste offline",startVideoGeneric:"Video se nepovedlo spustit",stopVideoGeneric:"Video se nepovedlo zastavit",muteGeneric:"Nepovedlo se ztlumit mikrofon",unmuteGeneric:"Nepovedlo se zrušit ztlumení mikrofonu",speakingWhileMuted:"Váš mikrofon je ztlumený",startScreenShareGeneric:"Při spouštění sdílení obrazovky došlo k problému.",stopScreenShareGeneric:"Nepovedlo se zastavit sdílení obrazovky",callNetworkQualityLow:"Kvalita sítě je nízká.",teamsMeetingCallNetworkQualityLow:"Kvalita sítě je nízká.",callNoSpeakerFound:"Nenašly se žádné reproduktory ani sluchátka. Připojte zvukové zařízení, abyste slyšeli hovor.",callNoMicrophoneFound:"Nenašly se žádné mikrofony. Připojte vstupní zvukové zařízení.",callMicrophoneAccessDenied:"Nepovedlo se získat přístup k mikrofonu. Kliknutím na zámek na panelu Adresa udělte oprávnění k této webové stránce.",callMicrophoneAccessDeniedSafari:"Nepovedlo se získat přístup k mikrofonu. Aktualizujte stránku, abyste povolili oprávnění, nebo zkontrolujte nastavení tohoto prohlížeče a ověřte, jestli jsou pro tento web povolená oprávnění.",callMicrophoneMutedBySystem:"Systém vás ztlumil.",callMicrophoneUnmutedBySystem:"Váš mikrofon se obnovil a systém vám zrušil ztlumení.",callMacOsMicrophoneAccessDenied:"Nepovedlo se získat přístup k mikrofonu. Udělte v nastavení ochrany osobních údajů pro macOS oprávnění k mikrofonu.",callLocalVideoFreeze:"Šířka pásma sítě je nekvalitní. Vaše video se může zobrazovat jako pozastavené pro ostatní účastníky hovoru.",callCameraAccessDenied:"Nepovedlo se získat přístup ke kameře. Kliknutím na zámek na panelu Adresa udělte oprávnění k této webové stránce.",callCameraAccessDeniedSafari:"Nejde získat přístup ke kameře. Aktualizujte stránku, abyste povolili oprávnění, nebo zkontrolujte nastavení tohoto prohlížeče a ověřte, jestli jsou pro tento web povolená oprávnění.",callCameraAlreadyInUse:"Nejde získat přístup ke kameře. Je možné, že ji už používá jiná aplikace.",callVideoStoppedBySystem:"Vaše video bylo zastaveno systémem.",callVideoRecoveredBySystem:"Vaše video se obnovilo.",callMacOsCameraAccessDenied:"MacOS blokuje přístup k vaší kameře. Aktualizujte si nastavení ochrany osobních údajů, aby tento prohlížeč měl přístup k vaší kameře.",callMacOsScreenShareAccessDenied:"MacOS blokuje sdílení obrazovky. Aktualizujte nastavení ochrany osobních údajů, aby tento prohlížeč mohl nahrávat vaši obrazovku.",dismissButtonAriaLabel:"Zavřít",failedToJoinCallGeneric:"K hovoru se nepovedlo připojit.",failedToJoinCallInvalidMeetingLink:"Ke schůzce se nelze připojit. Neplatný odkaz.",cameraFrozenForRemoteParticipants:"Uživatelé v hovoru mají problémy s zobrazením vašeho videa. Zkontrolujte prosím svá zařízení a síť.",unableToStartVideoEffect:"Nelze použít efekt videa.",startSpotlightWhileMaxParticipantsAreSpotlighted:"Nelze zahájit vytváření hlavního výběru účastníků, protože je již v hlavním výběru maximální počet účastníků.",mutedByRemoteParticipant:"Byli jste ztlumení jiným účastníkem."},notificationStack:{callingNetworkFailure:{title:"Při připojování hovoru došlo k potížím",message:"Zdá se, že jste offline. Zkontrolujte si prosím síťové připojení a zkuste to znovu.",dismissButtonAriaLabel:"Zavřít"},startVideoGeneric:{title:"Video se nepovedlo spustit.",dismissButtonAriaLabel:"Zavřít"},stopVideoGeneric:{title:"Video se nepovedlo zastavit.",dismissButtonAriaLabel:"Zavřít"},muteGeneric:{title:"Nepovedlo se ztlumit mikrofon.",dismissButtonAriaLabel:"Zavřít"},unmuteGeneric:{title:"Nepovedlo se zrušit ztlumení mikrofonu.",dismissButtonAriaLabel:"Zavřít"},speakingWhileMuted:{title:"Jste ztlumení.",dismissButtonAriaLabel:"Zavřít"},startScreenShareGeneric:{title:"Při spouštění sdílení obrazovky došlo k problému.",dismissButtonAriaLabel:"Zavřít"},stopScreenShareGeneric:{title:"Nepovedlo se zastavit sdílení obrazovky.",dismissButtonAriaLabel:"Zavřít"},callNetworkQualityLow:{title:"Kvalita sítě je nízká.",dismissButtonAriaLabel:"Zavřít"},teamsMeetingCallNetworkQualityLow:{title:"Kvalita sítě je nízká.",dismissButtonAriaLabel:"Zavřít",message:"Připojte se k tomuto hovoru ze svého telefonu, abyste získali lepší zvuk. Můžete pokračovat v prohlížení schůzky na tomto zařízení.",primaryButtonLabel:"Připojit telefonem"},callNoSpeakerFound:{title:"Nenašly se žádné reproduktory ani sluchátka",message:"Připojte zvukové zařízení, abyste slyšeli hovor.",dismissButtonAriaLabel:"Zavřít"},callNoMicrophoneFound:{title:"Nenašly se žádné mikrofony",message:"Připojte vstupní zvukové zařízení.",dismissButtonAriaLabel:"Zavřít"},callMicrophoneAccessDenied:{title:"Nepovedlo se získat přístup k mikrofonu",message:"Kliknutím na zámek na panelu Adresa udělte oprávnění k této webové stránce.",dismissButtonAriaLabel:"Zavřít"},callMicrophoneAccessDeniedSafari:{title:"Nepovedlo se získat přístup k mikrofonu",message:"Aktualizujte stránku, abyste povolili oprávnění, nebo zkontrolujte nastavení tohoto prohlížeče a ověřte, jestli jsou pro tento web povolená oprávnění.",dismissButtonAriaLabel:"Zavřít"},callMicrophoneMutedBySystem:{title:"Systém vás ztlumil.",dismissButtonAriaLabel:"Zavřít"},callMicrophoneUnmutedBySystem:{title:"Váš mikrofon se obnovil a systém vám zrušil ztlumení.",dismissButtonAriaLabel:"Zavřít"},callMacOsMicrophoneAccessDenied:{title:"Nepovedlo se získat přístup k mikrofonu",message:"Udělte v nastavení ochrany osobních údajů pro macOS oprávnění k mikrofonu.",dismissButtonAriaLabel:"Zavřít"},callLocalVideoFreeze:{title:"Šířka pásma sítě je nekvalitní",message:"Vaše video se může zobrazovat jako pozastavené pro ostatní účastníky hovoru.",dismissButtonAriaLabel:"Zavřít"},callCameraAccessDenied:{title:"Nejde získat přístup ke kameře",message:"Kliknutím na zámek na panelu Adresa udělte oprávnění k této webové stránce.",dismissButtonAriaLabel:"Zavřít"},callCameraAccessDeniedSafari:{title:"Nejde získat přístup ke kameře",message:"Aktualizujte stránku, abyste povolili oprávnění, nebo zkontrolujte nastavení tohoto prohlížeče a ověřte, jestli jsou pro tento web povolená oprávnění.",dismissButtonAriaLabel:"Zavřít"},callCameraAlreadyInUse:{title:"Nejde získat přístup ke kameře",message:"Je možné, že ji už používá jiná aplikace.",dismissButtonAriaLabel:"Zavřít"},callVideoStoppedBySystem:{title:"Vaše video bylo zastaveno systémem.",dismissButtonAriaLabel:"Zavřít"},callVideoRecoveredBySystem:{title:"Vaše video se obnovilo.",dismissButtonAriaLabel:"Zavřít"},callMacOsCameraAccessDenied:{title:"MacOS blokuje přístup k vaší kameře",message:"Aktualizujte si nastavení ochrany osobních údajů, aby tento prohlížeč měl přístup k vaší kameře.",dismissButtonAriaLabel:"Zavřít"},callMacOsScreenShareAccessDenied:{title:"MacOS blokuje sdílení obrazovky",message:"Aktualizujte nastavení ochrany osobních údajů, aby tento prohlížeč mohl nahrávat vaši obrazovku.",dismissButtonAriaLabel:"Zavřít"},failedToJoinCallGeneric:{title:"K hovoru se nepovedlo připojit.",dismissButtonAriaLabel:"Zavřít"},failedToJoinCallInvalidMeetingLink:{title:"Ke schůzce se nelze připojit. Neplatný odkaz.",dismissButtonAriaLabel:"Zavřít"},cameraFrozenForRemoteParticipants:{title:"Uživatelé v hovoru mají problémy s zobrazením vašeho videa",message:"Zkontrolujte prosím svá zařízení a síť.",dismissButtonAriaLabel:"Zavřít"},unableToStartVideoEffect:{title:"Nelze použít efekt videa.",dismissButtonAriaLabel:"Zavřít"},startSpotlightWhileMaxParticipantsAreSpotlighted:{title:"Nelze spustit hlavní výběr u účastník(a/ů).",message:"Maximální počet účastníků je už vybraný.",dismissButtonAriaLabel:"Zavřít"},mutedByRemoteParticipant:{title:"Byli jste ztlumení jiným účastníkem.",dismissButtonAriaLabel:"Zavřít"},recordingStarted:{title:"Nahrávání se spustilo.",message:"Připojením vyjadřujete souhlas s přepisem této schůzky.",dismissButtonAriaLabel:"Zavřít"},transcriptionStarted:{title:"Přepis se spustil.",message:"Připojením vyjadřujete souhlas s přepisem této schůzky.",dismissButtonAriaLabel:"Zavřít"},recordingStopped:{title:"Probíhá ukládání záznamu.",message:"Nahrávání se zastavilo.",dismissButtonAriaLabel:"Zavřít"},transcriptionStopped:{title:"Přepis se ukládá.",message:"Přepis se zastavil.",dismissButtonAriaLabel:"Zavřít"},recordingAndTranscriptionStarted:{title:"Spustilo se nahrávání a přepis.",message:"Připojením vyjadřujete souhlas s přepisem této schůzky.",dismissButtonAriaLabel:"Zavřít"},recordingAndTranscriptionStopped:{title:"Záznam a přepis se ukládají.",message:"Nahrávání a přepis se zastavily.",dismissButtonAriaLabel:"Zavřít"},recordingStoppedStillTranscribing:{title:"Nahrávání se zastavilo.",message:"Nyní tuto schůzku pouze přepisujete.",dismissButtonAriaLabel:"Zavřít"},transcriptionStoppedStillRecording:{title:"Přepis se zastavil.",message:"Nyní tuto schůzku pouze nahráváte.",dismissButtonAriaLabel:"Zavřít"},assignedBreakoutRoomOpened:{title:"Za 5 sekund vás přesuneme do přiřazené místnosti.",dismissButtonAriaLabel:"Zavřít"},assignedBreakoutRoomChanged:{title:"Vaše skupinová místnost se změnila",message:"Za 5 sekund vás přesuneme do přiřazené místnosti.",dismissButtonAriaLabel:"Zavřít"},assignedBreakoutRoomClosed:{title:"Vaše skupinová místnost byla uzavřena",message:"Za 5 sekund vás přesuneme zpět na schůzku.",dismissButtonAriaLabel:"Zavřít"},assignedBreakoutRoomOpenedPromptJoin:{title:"Připojit se ke skupinové místnosti?",message:"Byli jste přiřazeni ke skupinové místnosti.",dismissButtonAriaLabel:"Zavřít",primaryButtonLabel:"Připojit se k místnosti",secondaryButtonLabel:"Později"},breakoutRoomJoined:{title:"Připojili jste se ke skupinové místnosti.",dismissButtonAriaLabel:"Zavřít"},breakoutRoomClosingSoon:{title:"Časový limit místnosti brzy vyprší.",message:"Tato místnost se zavře během 30 sekund.",dismissButtonAriaLabel:"Zavřít"},capabilityTurnVideoOnPresent:{title:"Vaše kamera je zapnutá",message:"Pokud byste chtěli sdílet video, zapněte tuto funkci.",dismissButtonAriaLabel:"Zavřít"},capabilityTurnVideoOnAbsent:{title:"Vaše kamera byla vypnuta",message:"Už nemůžete sdílet video.",dismissButtonAriaLabel:"Zavřít"},capabilityUnmuteMicPresent:{title:"Váš mikrofon je zapnutý.",message:"Zrušte ztlumení, pokud chcete mluvit.",dismissButtonAriaLabel:"Zavřít"},capabilityUnmuteMicAbsent:{title:"Váš mikrofon je vypnutý.",message:"Už nemůžete zrušit ztlumení.",dismissButtonAriaLabel:"Zavřít"},togetherModeStarted:{title:"Režim Togethermode byl spuštěn",dismissButtonAriaLabel:"Zavřít"},togetherModeEnded:{title:"Režim Togethermode skončil",dismissButtonAriaLabel:"Zavřít"}},videoGallery:{screenIsBeingSharedMessage:"Sdílíte obrazovku",screenShareLoadingMessage:"Načítání obrazovky {participant}",localScreenShareLoadingMessage:"Načítá se obrazovka",localVideoLabel:"Vy",localVideoCameraSwitcherLabel:"Přepnout kameru",localVideoMovementLabel:"Dlaždice s místním videem s možností přesunutí",localVideoMovementAriaLabel:"Dlaždice s místním videem s možností přesunutí",localVideoSelectedDescription:"{cameraName} vybráno",displayNamePlaceholder:"Nepojmenovaný účastník",fitRemoteParticipantToFrame:"Přizpůsobit rámečku",fillRemoteParticipantFrame:"Vyplnit rámeček",pinParticipantForMe:"Připnout pro mě",pinParticipantForMeLimitReached:"Připnout (dosáhlo se limitu)",unpinParticipantForMe:"Odepnout",pinParticipantMenuItemAriaLabel:"Připnout {participantName}",unpinParticipantMenuItemAriaLabel:"Odepnout {participantName}",pinnedParticipantAnnouncementAriaLabel:"Připnutý účastník {participantName}",unpinnedParticipantAnnouncementAriaLabel:"{participantName} odepnut",startSpotlightVideoTileMenuLabel:"Přidat do hlavního výběru všem",addSpotlightVideoTileMenuLabel:"Přidat do hlavního výběru",spotlightLimitReachedMenuTitle:"Dosáhlo se limitu hlavního výběru",stopSpotlightVideoTileMenuLabel:"Zastavit přidávání do hlavního výběru",stopSpotlightOnSelfVideoTileMenuLabel:"Ukončit hlavní výběr",attendeeRole:"Účastník",muteParticipantMenuItemLabel:"Ztlumit",waitingScreenText:"Čeká se na připojení ostatních",forbidAudio:"Vypnout mikrofon",permitAudio:"Povolit mikrofon",forbidAudioTileMenuLabel:"Vypnout mikrofon",permitAudioTileMenuLabel:"Povolit mikrofon",forbidVideo:"Zakázat kameru",permitVideo:"Povolit kameru",forbidVideoTileMenuLabel:"Zakázat kameru",permitVideoTileMenuLabel:"Povolit kameru"},dialpad:{placeholderText:"Zadejte telefonní číslo",deleteButtonAriaLabel:"Odstranit"},holdButton:{onLabel:"Pokračovat",offLabel:"Pozastavit",tooltipOnContent:"Pokračovat v hovoru",tooltipOffContent:"Pozastavit hovor"},videoTile:{participantStateRinging:"Volání…",participantReconnecting:"Obnovuje se připojení...",participantStateHold:"Pozastavený hovor",moreOptionsButtonAriaLabel:"Další možnosti {displayName} {isMuted} {micDisabledState} {cameraDisabledState} {isHandRaised} {state} {isSpeaking}",moreOptionsParticipantMutedStateMutedAriaLabel:"ztlumeno",moreOptionsParticipantMutedStateUnmutedAriaLabel:"ztlumení zrušeno",moreOptionsParticipantHandRaisedAriaLabel:"Zvednutá ruka",moreOptionsParticipantIsSpeakingAriaLabel:"Mluví",moreOptionsParticipantMicDisabledAriaLabel:"Mikrofon zakázán",moreOptionsParticipantCameraDisabledAriaLabel:"Kamera zakázána"},CameraAndMicrophoneSitePermissionsRequest:{primaryText:"Povolit aplikaci {appName} používat kameru a mikrofon",secondaryText:"Toto je proto, aby vás účastníci viděli a slyšeli.",linkText:"Potřebujete pomoc? Získat nápovědu k řešení potíží",primaryButtonText:"Pokračovat bez kamery a mikrofonu",ariaLabel:"Povolit přístup ke kameře a mikrofonu"},CameraSitePermissionsRequest:{primaryText:"Povolit aplikaci {appName} používat vaši kameru",secondaryText:"Toto je proto, aby vás účastníci viděli.",linkText:"Potřebujete pomoc? Získat nápovědu k řešení potíží",primaryButtonText:"Pokračovat bez kamery",ariaLabel:"Povolit přístup ke kameře"},MicrophoneSitePermissionsRequest:{primaryText:"Povolit aplikaci {appName} používat váš mikrofon",secondaryText:"To je proto, aby vás účastníci mohli slyšet.",linkText:"Potřebujete pomoc? Získat nápovědu k řešení potíží",primaryButtonText:"Pokračovat bez mikrofonu",ariaLabel:"Povolte přístup k mikrofonu"},CameraAndMicrophoneSitePermissionsCheck:{primaryText:"Kontrola přístupu ke kameře a mikrofonu",secondaryText:"Pokud se zobrazí výzva, povolte přístup. To je proto, aby vás účastníci slyšeli a viděli.",linkText:"Potřebujete pomoc? Získat nápovědu k řešení potíží",primaryButtonText:"Pokračovat bez kamery a mikrofonu",ariaLabel:"Kontroluje se přístup k mikrofonu a kameře. Povolit přístup, pokud se zobrazí výzva."},CameraSitePermissionsCheck:{primaryText:"Kontroluje se přístup ke kameře",secondaryText:"Pokud se zobrazí výzva, povolte přístup. To je proto, aby vás účastníci viděli.",linkText:"Potřebujete pomoc? Získat nápovědu k řešení potíží",primaryButtonText:"Pokračovat bez kamery",ariaLabel:"Kontroluje se přístup ke kameře. Povolit přístup, pokud se zobrazí výzva."},MicrophoneSitePermissionsCheck:{primaryText:"Kontroluje se přístup k mikrofonu",secondaryText:"Pokud se zobrazí výzva, povolte přístup. To je proto, aby vás účastníci slyšeli.",linkText:"Potřebujete pomoc? Získat nápovědu k řešení potíží",primaryButtonText:"Pokračovat bez mikrofonu",ariaLabel:"Kontroluje se přístup k mikrofonu. Povolit přístup, pokud se zobrazí výzva."},CameraAndMicrophoneSitePermissionsDenied:{primaryText:"Nejde získat přístup ke kameře a mikrofonu",secondaryText:"Kliknutím na ikonu zámku na panelu Adresa udělte mikrofonu oprávnění k této webové stránce. Může být vyžadována aktualizace stránky.",primaryButtonText:"Pokračovat bez kamery a mikrofonu",linkText:"Potřebujete pomoc? Získat nápovědu k řešení potíží"},CameraAndMicrophoneSitePermissionsDeniedSafari:{primaryText:"Nejde získat přístup ke kameře a mikrofonu.",secondaryText:"Aktualizujte stránku, abyste povolili oprávnění, nebo zkontrolujte nastavení tohoto prohlížeče a ověřte, jestli jsou pro tento web povolená oprávnění.",primaryButtonText:"Pokračovat bez kamery a mikrofonu",linkText:"Potřebujete pomoc? Získat nápovědu k řešení potíží"},CameraSitePermissionsDenied:{primaryText:"Nejde získat přístup ke kameře",secondaryText:"Kliknutím na ikonu zámku na panelu Adresa udělte kameře oprávnění k této webové stránce. Může být vyžadována aktualizace stránky.",primaryButtonText:"Pokračovat bez kamery",linkText:"Potřebujete pomoc? Získat nápovědu k řešení potíží"},MicrophoneSitePermissionsDenied:{primaryText:"Nepovedlo se získat přístup k mikrofonu",secondaryText:"Kliknutím na ikonu zámku na panelu Adresa udělte mikrofonu oprávnění k této webové stránce. Může být vyžadována aktualizace stránky.",primaryButtonText:"Pokračovat bez mikrofonu",linkText:"Potřebujete pomoc? Získat nápovědu k řešení potíží"},CameraSitePermissionsDeniedSafari:{primaryText:"Nejde získat přístup ke kameře",secondaryText:"Aktualizujte stránku, abyste povolili oprávnění, nebo zkontrolujte nastavení tohoto prohlížeče a ověřte, jestli jsou pro tento web povolená oprávnění.",primaryButtonText:"Pokračovat bez kamery",linkText:"Potřebujete pomoc? Získat nápovědu k řešení potíží"},MicrophoneSitePermissionsDeniedSafari:{primaryText:"Nepovedlo se získat přístup k mikrofonu",secondaryText:"Aktualizujte stránku, abyste povolili oprávnění, nebo zkontrolujte nastavení tohoto prohlížeče a ověřte, jestli jsou pro tento web povolená oprávnění.",primaryButtonText:"Pokračovat bez mikrofonu",linkText:"Potřebujete pomoc? Získat nápovědu k řešení potíží"},UnsupportedBrowser:{primaryText:"Prohlížeč není podporovaný",secondaryText:"Připojte se k tomuto hovoru pomocí kompatibilního prohlížeče.",moreHelpLinkText:"Zobrazit požadavky na kompatibilitu"},UnsupportedBrowserVersion:{primaryText:"Je nutné aktualizovat prohlížeč",secondaryText:"Abyste zajistili nejlepší možný hovor, aktualizujte si prosím prohlížeč a zkuste se k hovoru připojit znovu.",moreHelpLinkText:"Zobrazit požadavky na kompatibilitu",continueAnywayButtonText:"Zahájit hovor bez aktualizace"},UnsupportedOperatingSystem:{primaryText:"Nepodporovaný operační systém",secondaryText:"Připojte se k tomuto hovoru pomocí zařízení s kompatibilním operačním systémem.",moreHelpLinkText:"Zobrazit požadavky na kompatibilitu"},BrowserPermissionDenied:{primaryText:"Kameru nebo mikrofon nejde použít",secondaryText:"Váš prohlížeč možná nemá přístup ke kameře nebo mikrofonu. Tento problém vyřešíte tak, že otevřete Předvolby systému.",primaryButtonText:"Zkusit znovu",linkText:"Potřebujete pomoc? Získat nápovědu k řešení potíží"},BrowserPermissionDeniedIOS:{primaryText:"Povolit přístup k mikrofonu, aby bylo možné pokračovat",secondaryText:"Aby vás ostatní účastníci slyšeli.",primaryButtonText:"Zkusit znovu",imageAltText:"Umístění oprávnění mikrofonu a kamery pro iOS",linkText:"Potřebujete pomoc? Získat nápovědu k řešení potíží",step1Text:"Přejít do aplikace Nastavení",step2Text:"Přesuňte se dolů k nastavení tohoto prohlížeče",step3Text:"Zapnout mikrofon (kamera je volitelná)",step4Text:"Zkuste se připojit k hovoru znovu",step1DigitText:"1",step2DigitText:"2",step3DigitText:"3",step4DigitText:"4"},verticalGallery:{leftNavButtonAriaLabel:"předchozí stránka {current} z(e) {total}",rightNavButtonAriaLabel:"další stránka {current} z(e) {total}"},meetingConferencePhoneInfo:{meetingConferencePhoneInfoModalTitle:"Připojit se k hovoru z vašeho telefonu",meetingConferencePhoneInfoModalDialIn:"Vytočit číslo",meetingConferencePhoneInfoModalMeetingId:"Zadejte ID schůzky",meetingConferencePhoneInfoModalWait:"Počkejte na přijetí organizátorem",meetingConferencePhoneInfoModalNoPhoneAvailable:"Není k dispozici žádný telefon.",meetingConferencePhoneInfoModalTollGeoData:"{country}, {city}",meetingConferencePhoneInfoModalTollFree:"(Bezplatné)",meetingConferencePhoneInfoModalToll:"(Placené)"},IncomingCallNotification:{incomingCallNotificationPlaceholderId:"Neznámý uživatel",incomingCallNotificationPlaceholderAlert:"Volá {callerName}",incomingCallNoticicationAcceptWithAudioAriaLabel:"Přijmout se zvukem",incomingCallNoticicationAcceptWithVideoAriaLabel:"Přijmout s videem",incomingCallNoticicationRejectAriaLabel:"Odmítnout",incomingCallNotificationAcceptButtonLabel:"Přijmout",incomingCallNotificationRejectButtonLabel:"Odmítnout",incomingCallNotificationAccceptWithVideoButtonLabel:"Přijmout s videem",incomingCallNotificationDismissButtonAriaLabel:"Zavřít"}})},sQt={strings:Jh({participantItem:{isMeText:"(chi)",menuTitle:"Mwy o Ddewisiadau",removeButtonLabel:"Tynnu",sharingIconLabel:"Rhannu",mutedIconLabel:"Wedi tewi",handRaisedIconLabel:"Llaw wedi'i chodi - Lleoliad {position}",displayNamePlaceholder:"Cyfranogwr dienw",participantStateRinging:"Wrthi'n galw...",participantStateHold:"Galwad yn aros",participantItemAriaLabel:"{displayName}, {handRaisedState}, {mutedState}, {micDisabledState}, {cameraDisabledState}, {sharingState}, {connectionState}",participantItemWithMoreOptionsAriaLabel:"{displayName}, {handRaisedState}, {mutedState}, {micDisabledState}, {cameraDisabledState}, {sharingState}, {connectionState}, Mwy o Ddewisiadau",attendeeRole:"Mynychwr",micDisabledIconLabel:"Meicroffon wedi'i analluogi",cameraDisabledIconLabel:"Camera wedi'i analluogi"},ParticipantList:{overflowParticipantCount:"+{overflowCount} arall"},typingIndicator:{singleUser:"Mae {user} yn teipio ...",multipleUsers:"Mae {users} yn teipio ...",multipleUsersAbbreviateOne:"Mae {users} ac 1 arall yn teipio ...",multipleUsersAbbreviateMany:"Mae {users} a {numOthers} arall yn teipio ...",delimiter:", "},sendBox:{placeholderText:"Rhowch neges",textTooLong:"Mae hyd eich neges yn fwy na'r terfyn uchaf.",sendButtonAriaLabel:"Anfon neges",attachmentUploadsPendingError:"Wrthi'n llwytho'r ffeil i fyny, arhoswch funud.",removeAttachment:"Tynnu’r ffeil",uploading:"Wrthi'n llwytho i fyny",uploadCompleted:"Wedi gorffen llwytho i fyny",attachmentMoreMenu:"Mwy o Ddewisiadau"},richTextSendBox:{placeholderText:"Rhowch neges",textTooLong:"Mae hyd eich neges yn fwy na'r terfyn uchaf.",sendButtonAriaLabel:"Anfon neges",attachmentUploadsPendingError:"Wrthi'n lanlwytho'r ffeil, arhoswch funud.",imageUploadsPendingError:"Wrthi'n lanlwytho'r ddelwedd, arhoswch funud.",removeAttachment:"Tynnu'r ffeil",uploading:"Wrthi'n lanlwytho",uploadCompleted:"Wedi gorffen lanlwytho",richTextBoldTooltip:"Trwm",richTextItalicTooltip:"Italig",richTextUnderlineTooltip:"Tanlinellu",richTextBulletListTooltip:"Rhestr bwledi",richTextNumberListTooltip:"Rhestr wedi’i rhifo",richTextIncreaseIndentTooltip:"Cynyddu'r mewnoliad",richTextDecreaseIndentTooltip:"Lleihau'r mewnoliad",richTextInsertTableTooltip:"Mewnosod tabl",richTextFormatButtonTooltip:"Fformat",richTextInsertRowOrColumnMenu:"Mewnosod",richTextInsertTableMenuTitle:"Mewnosod tabl {row} x {column}",richTextInsertRowAboveMenu:"Mewnosod uwchben",richTextInsertRowBelowMenu:"Mewnosod isod",richTextInsertColumnLeftMenu:"Mewnosod i'r chwith",richTextInsertColumnRightMenu:"Mewnosod i'r dde",richTextDeleteRowOrColumnMenu:"Dileu",richTextDeleteColumnMenu:"Dileu'r golofn",richTextDeleteRowMenu:"Dileu'r rhes",richTextDeleteTableMenu:"Dileu'r tabl",richTextToolbarAriaLabel:"Bar Offer Fformatio Negeseuon",richTextToolbarMoreButtonAriaLabel:"Mwy o ddewisiadau",attachmentMoreMenu:"Mwy o Ddewisiadau",richTextNewBulletedListItemAnnouncement:"Bwled, llinell newydd",richTextNewNumberedListItemAnnouncement:"{0}, llinell newydd",richTextBulletedListAppliedAnnouncement:"Wedi defnyddio'r rhestr bwledi",richTextNumberedListAppliedAnnouncement:"Wedi defnyddio rhestr wedi'i rhifo"},realTimeTextModal:{realTimeTextModalAriaLabel:"Rhoi Moddol RTT ar waith",realTimeTextModalTitle:"Rhoi RTT ar waith?",realTimeTextModalText:"Bydd teipio mewn amser real (RTT) yn cael ei alluogi ar gyfer pawb yn y cyfarfod.",realTimeTextConfirmButtonLabel:"Rhoi ar waith",realTimeTextCancelButtonLabel:"Canslo",realTimeTextCloseModalButtonAriaLabel:"Cau'r Moddol RTT"},captionsBanner:{captionsBannerSpinnerText:"Wrthi'n dechrau'r capsiynau...",realTimeTextInputBoxDefaultText:"Teipiwch neges mewn amser go iawn",realTimeTextInputErrorMessage:"All y neges ddim bod yn fwy na 2000 o nodau",realTimeTextBannerTitle:"RTT",realTimeTextBannerContent:"Mae RTT (testun amser real) wedi'i alluogi ar gyfer yr holl gyfranogwyr ar gyfer cyfnod cyfan y cyfarfod.",realTimeTextBannerLinkLabel:"Dysgu mwy",captionsOnlyContainerTitle:"Capsiynau",realTimeTextOnlyContainerTitle:"Testun Amser Real",captionsAndRealTimeTextContainerTitle:"Capsiynau a Thestun Amser Real",expandButtonAriaLabel:"Ehangu",minimizeButtonAriaLabel:"Crebachu"},mentionPopover:{mentionPopoverHeader:"Awgrymiadau"},imageOverlay:{downloadButtonLabel:"Lawrlwytho",dismissButtonAriaLabel:"Cau",overlayVisibleMessage:"Troshaen Manylion Delwedd"},messageStatusIndicator:{deliveredAriaLabel:"Wedi anfon y neges",deliveredTooltipText:"Anfonwyd",seenAriaLabel:"Neges wedi ei gweld gan bobl eraill",seenTooltipText:"Gwelwyd",readByTooltipText:"Wedi'i darllen gan {messageThreadReadCount} o {remoteParticipantsCount}",sendingAriaLabel:"Wrthi'n anfon y neges",sendingTooltipText:"Wrthi'n anfon",failedToSendAriaLabel:"Wedi methu anfon y neges",failedToSendTooltipText:"Wedi methu anfon"},endCallButton:{label:"Gadael",tooltipContent:"Gadael yr alwad",leaveOption:"Gadael",endCallOption:"Dod â'r alwad i ben ar gyfer pawb"},cameraButton:{onLabel:"Camera",offLabel:"Camera",tooltipDisabledContent:"Mae’r camera wedi'i analluogi",tooltipOnContent:"Diffodd y camera",tooltipOffContent:"Rhoi'r camera ar waith",tooltipVideoLoadingContent:"Wrthi'n llwytho'r fideo",cameraMenuTitle:"Camera",cameraMenuTooltip:"Dewis camera",cameraButtonSplitRoleDescription:"Botwm Hollti",onSplitButtonAriaLabel:"Diffodd y camera",offSplitButtonAriaLabel:"Rhoi'r camera ar waith",cameraActionTurnedOnAnnouncement:"Mae eich camera wedi'i roi ar waith",cameraActionTurnedOffAnnouncement:"Mae eich camera wedi'i ddiffodd",onSplitButtonPrimaryActionCamera:"Diffodd y camera",offSplitButtonPrimaryActionCamera:"Rhoi'r camera ar waith",cameraPrimaryActionSplitButtonTitle:"Defnyddio camera",videoEffectsMenuItemTitle:"Effeithiau",cameraButtonAriaDescription:"dewisiadau camera"},microphoneButton:{onLabel:"Meicroffon",offLabel:"Meicroffon",tooltipDisabledContent:"Mae'r meicroffon wedi'i analluogi",tooltipOnContent:"Tewi’r meicroffon",tooltipOffContent:"Dad-dewi’r meicroffon",microphoneMenuTitle:"Meicroffon",microphoneMenuTooltip:"Dewis meicroffon",speakerMenuTitle:"Seinydd",speakerMenuTooltip:"Dewis seinydd",microphoneButtonSplitRoleDescription:"Botwm Hollti",onSplitButtonAriaLabel:"Tewi'r meic",offSplitButtonAriaLabel:"Dad-dewi'r meic",microphoneActionTurnedOnAnnouncement:"Mae eich meicroffon wedi'i roi ar waith",microphoneActionTurnedOffAnnouncement:"Mae eich meicroffon wedi'i ddiffodd",offSplitButtonMicrophonePrimaryAction:"Dad-dewi’r meic",onSplitButtonMicrophonePrimaryAction:"Tewi'r meic",microphonePrimaryActionSplitButtonTitle:"Defnyddio'r meicroffon",microphoneAriaDescription:"Dewisiadau sain",deepNoiseSuppressionTitle:"Atal sŵn",deepNoiseSuppressionOnAnnouncement:"Mae atal sŵn dwfn wedi'i roi ar waith",deepNoiseSuppressionOffAnnouncement:"Mae atal sŵn dwfn wedi'i ddiffodd"},devicesButton:{label:"Dyfeisiau",tooltipContent:"Rheoli dyfeisiau",cameraMenuTitle:"Camera",cameraMenuTooltip:"Dewis camera",audioDeviceMenuTitle:"Dyfais Sain",audioDeviceMenuTooltip:"Dewis dyfais sain",microphoneMenuTitle:"Meicroffon",microphoneMenuTooltip:"Dewis meicroffon",speakerMenuTitle:"Siaradwr",speakerMenuTooltip:"Dewis seinydd"},participantsButton:{label:"Pobl",ariaLabel:"Pobl",tooltipContent:"Dangos cyfranogwyr",menuHeader:"Yn yr alwad hon",participantsListButtonLabel:"{numParticipants} o bobl",muteAllButtonLabel:"Tewi’r cyfan",copyInviteLinkButtonLabel:"Copïo dolen y gwahoddiad",copyInviteLinkActionedAriaLabel:"Wedi copïo dolen y gwahoddiad"},screenShareButton:{onLabel:"Stopio cyflwyno",offLabel:"Presennol",tooltipDisabledContent:"Mae cyflwyno wedi'i analluogi",tooltipOnContent:"Wrthi'n cyflwyno eich sgrin",tooltipOffContent:"Cyflwyno eich sgrin"},raiseHandButton:{offLabel:"Codi",onLabel:"Gostwng",tooltipDisabledContent:"Mae'r weithred Codi Llaw wedi'i hanalluogi",tooltipOnContent:"Gostwng Llaw",tooltipOffContent:"Codi Llaw"},reactionButton:{label:"Ymateb",ariaLabel:"Ymateb",tooltipDisabledContent:"Mae'r weithred ymateb wedi'i hanalluogi",tooltipContent:"Anfon ymateb",likeReactionTooltipContent:"Hoffi",heartReactionTooltipContent:"Caru",laughReactionTooltipContent:"Chwerthin",applauseReactionTooltipContent:"Curo Dwylo",surprisedReactionTooltipContent:"Wedi synnu"},realTimeText:{isTypingText:"Teipio RTT"},captionsSettingsModal:{captionsSettingsModalTitle:"Gosodiadau Capsiynau",captionsSettingsSpokenLanguageDropdownLabel:"Iaith lafar",captionsSettingsCaptionLanguageDropdownLabel:"Iaith capsiynau",captionsSettingsSpokenLanguageDropdownInfoText:"Yr iaith y mae pawb yn yr alwad hon yn ei siarad.",captionsSettingsCaptionLanguageDropdownInfoText:"Bydd capsiynau'n ymddangos yn yr iaith hon.",captionsSettingsConfirmButtonLabel:"Cadarnhau",captionsSettingsCancelButtonLabel:"Canslo",captionsSettingsModalAriaLabel:"Moddol Gosodiad Capsiynau",captionsSettingsCloseModalButtonAriaLabel:"Cau Gosodiad Capsiynau"},spokenLanguages:{"ar-ae":"Arabeg - E.A.U.","ar-sa":"Arabeg - Saudi Arabia","da-dk":"Daneg","de-de":"Almaeneg - Yr Almaen","en-au":"Saesneg - Awstralia","en-ca":"Saesneg - Canada","en-gb":"Saesneg - Y Deyrnas Unedig","en-in":"Saesneg - India","en-nz":"Saesneg - Seland Newydd","en-us":"Saesneg - Unol Daleithiau America","es-es":"Sbaeneg - Sbaen (Modern)","es-mx":"Sbaeneg - Mecsico","fi-fi":"Ffinneg","fr-ca":"Ffrangeg - Canada","fr-fr":"Ffrangeg - Ffrainc","hi-in":"Hindi","it-it":"Eidaleg - Yr Eidal","ja-jp":"Japaneeg","ko-kr":"Coreeg","nb-no":"Norwyeg (Bokmål)","nl-be":"Iseldireg - Gwlad Belg","nl-nl":"Iseldireg - Yr Iseldiroedd","pl-pl":"Pwyleg","pt-br":"Portiwgaleg - Brasil","ru-ru":"Rwseg","sv-se":"Swedeg","zh-cn":"Tsieinëeg - Gweriniaeth y Bobl Tsieina","zh-hk":"Tsieinëeg - Hong Kong SAR","cs-cz":"Tsieceg","pt-pt":"Portiwgaleg - Portiwgal","tr-tr":"Tyrceg","vi-vn":"Fietnameg","th-th":"Thai","he-il":"Hebraeg","cy-gb":"Cymraeg","uk-ua":"Wcreineg","el-gr":"Groeg","hu-hu":"Hwngareg","ro-ro":"Rwmaneg","sk-sk":"Slofaceg","zh-tw":"Tsieinëeg - Taiwan"},captionLanguages:{ar:"Arabeg",da:"Daneg",de:"Almaeneg",en:"Saesneg",es:"Sbaeneg",fi:"Ffinneg","fr-ca":"Ffrangeg - Canada",fr:"Ffrangeg - Ffrainc",hi:"Hindi",it:"Eidaleg",ja:"Japaneeg",ko:"Coreeg",nb:"Norwyeg (Bokmål)",nl:"Iseldireg",pl:"Pwyleg",pt:"Portiwgaleg - Brasil",ru:"Rwseg",sv:"Swedeg","zh-Hans":"Tsieinëeg (Syml)","zh-Hant":"Tsieinëeg (Traddodiadol)",cs:"Tsieceg","pt-pt":"Portiwgaleg - Portiwgal",tr:"Tyrceg",vi:"Fietnameg",th:"Thai",he:"Hebraeg",cy:"Cymraeg",uk:"Wcreineg",el:"Groeg",hu:"Hwngareg",ro:"Rwmaneg",sk:"Slofaceg"},startCaptionsButton:{onLabel:"Galluogi capsiynau",offLabel:"Analluogi capsiynau",tooltipOnContent:"Analluogi capsiynau",tooltipOffContent:"Galluogi capsiynau"},startRealTimeTextButton:{label:"Rhoi RTT ar waith ar gyfer yr alwad hon",tooltipOffContent:"Rhoi RTT ar waith ar gyfer yr alwad hon"},messageThread:{yesterday:"Ddoe",sunday:"Dydd Sul",monday:"Dydd Llun",tuesday:"Dydd Mawrth",wednesday:"Dydd Mercher",thursday:"Dydd Iau",friday:"Dydd Gwener",saturday:"Dydd Sadwrn",participantJoined:"wedi ymuno â'r sgwrs.",participantLeft:"wedi gadael y sgwrs.",editMessage:"Golygu",removeMessage:"Dileu",resendMessage:"Rhowch gynnig arall ar anfon",failToSendTag:"Wedi methu â'i hanfon",editedTag:"Golygwyd",liveAuthorIntro:"Neges gan {author}",editedMessageLiveAuthorIntro:"Neges wedi'i golygu gan {author}",editedMessageLocalUserLiveAuthorIntro:"Neges wedi’i golygu",messageContentAriaText:"{status} Dywedodd {author} {message}",messageContentMineAriaText:"{status} Dywedoch chi {message}",editBoxTextLimit:"Mae eich neges dros y terfyn o {limitNumber} nodau",editBoxPlaceholderText:"Golygu eich neges",newMessagesIndicator:"Negeseuon newydd",noDisplayNameSub:"Dim enw",editBoxCancelButton:"Canslo",editBoxSubmitButton:"Wedi gorffen",messageReadCount:"Wedi'i darllen gan {messageReadByCount} o {remoteParticipantsCount}",actionMenuMoreOptions:"Mwy o Ddewisiadau",downloadAttachment:"Llwytho'r ffeil i lawr",openAttachment:"Agor ffeil",blockedWarningText:"Mae'r neges hon wedi'i dileu oherwydd polisi sefydliadol.",blockedWarningLinkText:"Manylion",attachmentCardGroupMessage:"Mae gan y neges {attachmentCount} atodiad",messageDeletedAnnouncementAriaLabel:"Mae'r neges wedi cael ei dileu",richTextBoldTooltip:"Trwm",richTextItalicTooltip:"Italig",richTextUnderlineTooltip:"Tanlinellu",richTextBulletListTooltip:"Rhestr bwledi",richTextNumberListTooltip:"Rhestr wedi'i rhifo",richTextIncreaseIndentTooltip:"Cynyddu’r mewnoliad",richTextDecreaseIndentTooltip:"Lleihau’r mewnoliad",richTextInsertTableTooltip:"Mewnosod tabl",richTextFormatButtonTooltip:"Fformat",richTextInsertRowOrColumnMenu:"Mewnosod",richTextInsertTableMenuTitle:"Mewnosod tabl {row} x {column}",richTextInsertRowAboveMenu:"Mewnosod uwchben",richTextInsertRowBelowMenu:"Mewnosod isod",richTextInsertColumnLeftMenu:"Mewnosod i'r chwith",richTextInsertColumnRightMenu:"Mewnosod i'r dde",richTextDeleteRowOrColumnMenu:"Dileu",richTextDeleteColumnMenu:"Dileu'r golofn",richTextDeleteRowMenu:"Dileu'r rhes",richTextDeleteTableMenu:"Dileu'r tabl",richTextToolbarMoreButtonAriaLabel:"Mwy o ddewisiadau",attachmentUploadsPendingError:"Wrthi'n lanlwytho'r ffeil, arhoswch funud.",imageUploadsPendingError:"Wrthi'n lanlwytho'r ddelwedd, arhoswch funud.",richTextNewBulletedListItemAnnouncement:"Bwled, llinell newydd",richTextNewNumberedListItemAnnouncement:"{0}, llinell newydd",richTextBulletedListAppliedAnnouncement:"Wedi defnyddio'r rhestr bwledi",richTextNumberedListAppliedAnnouncement:"Wedi defnyddio rhestr wedi'i rhifo"},errorBar:{unableToReachChatService:"Rydych chi all-lein",accessDenied:"Does dim modd cael gafael ar wasanaethau sgwrsio - gwiriwch fanylion adnabod y defnyddiwr a roddwyd",userNotInChatThread:"Nid ydych yn yr edefyn sgwrsio hwn mwyach",sendMessageNotInChatThread:"Wedi methu anfon neges oherwydd dydych chi ddim yn y trywydd sgwrsio hwn mwyach",sendMessageGeneric:"Wedi methu anfon neges",callingNetworkFailure:"problem wrth gysylltu galwad - mae’n ymddangos eich bod all-lein",startVideoGeneric:"Wedi methu cychwyn y fideo",stopVideoGeneric:"Wedi methu stopio'r fideo",muteGeneric:"Wedi methu tewi'r meicroffon",unmuteGeneric:"Wedi methu dad-dewi'r meicroffon",speakingWhileMuted:"Mae eich meicroffon wedi tewi",startScreenShareGeneric:"Roedd problem wrth ddechrau rhannu sgrin.",stopScreenShareGeneric:"Wedi methu rhoi'r gorau i rannu sgrin",callNetworkQualityLow:"Mae ansawdd y rhwydwaith yn isel.",teamsMeetingCallNetworkQualityLow:"Mae ansawdd y rhwydwaith yn isel.",callNoSpeakerFound:"Heb ddod o hyd i seinyddion na clustffonau. Cysylltu dyfais sain i glywed yr alwad.",callNoMicrophoneFound:"Heb ganfod meicroffonau. Cysylltu dyfais mewnbwn sain.",callMicrophoneAccessDenied:"Does dim modd cael mynediad at y meicroffon. Cliciwch y clo yn y bar cyfeiriad i roi caniatâd i'r dudalen we hon.",callMicrophoneAccessDeniedSafari:"Nid oes modd cael mynediad at y meicroffon. Adnewyddwch y dudalen i ganiatáu hawliau, neu gwiriwch osodiadau'r porwr hwn a dilysu hawliau wedi'u galluogi ar gyfer y wefan hon.",callMicrophoneMutedBySystem:"Rydych chi wedi'ch tewi gan eich system.",callMicrophoneUnmutedBySystem:"Mae eich meicroffon wedi'i adfer a chawsoch chi eich dad-dewi gan eich system.",callMacOsMicrophoneAccessDenied:"Does dim modd cael mynediad at y meicroffon. Rhoi caniatâd meicroffon yn eich gosodiadau preifatrwydd macOS.",callLocalVideoFreeze:"Mae lled band y rhwydwaith yn wael. Efallai y bydd eich fideo wedi'i oedi ar gyfer eraill ar yr alwad.",callCameraAccessDenied:"Does dim modd cael mynediad at y camera. Cliciwch y clo yn y bar cyfeiriad i roi caniatâd i'r dudalen we hon.",callCameraAccessDeniedSafari:"Nid oes modd cael mynediad at y camera. Adnewyddwch y dudalen i ganiatáu hawliau, neu gwiriwch osodiadau'r porwr hwn a dilysu hawliau wedi'u galluogi ar gyfer y wefan hon.",callCameraAlreadyInUse:"Nid oes modd cael mynediad at y camera. Mae'n bosib bod rhaglen arall yn ei ddefnyddio'n barod.",callVideoStoppedBySystem:"Mae eich fideo wedi cael ei stopio gan eich system.",callVideoRecoveredBySystem:"Mae eich fideo wedi ailddechrau.",callMacOsCameraAccessDenied:"Mae MacOS yn rhwystro mynediad at eich camera. Diweddarwch eich gosodiadau preifatrwydd i ganiatáu i'r porwr hwn gael mynediad at eich camera.",callMacOsScreenShareAccessDenied:"Mae MacOS yn rhwystro rhannu sgrin. Diweddarwch eich gosodiadau preifatrwydd i ganiatáu i'r porwr hwn recordio eich sgrin.",dismissButtonAriaLabel:"Cau",failedToJoinCallGeneric:"Wedi methu ag ymuno â'r alwad.",failedToJoinCallInvalidMeetingLink:"Does dim modd ymuno â'r Cyfarfod. Dolen Annilys.",cameraFrozenForRemoteParticipants:"Mae defnyddwyr yn yr alwad yn cael trafferth gweld eich fideo. Tarwch olwg ar eich dyfeisiau a'ch rhwydwaith.",unableToStartVideoEffect:"Nid oes modd defnyddio'r effaith fideo.",startSpotlightWhileMaxParticipantsAreSpotlighted:"Nid oes modd dechrau sbotolau ar gyfranogwr/cyfranogwyr oherwydd bod y nifer fwyaf o gyfranogwyr a ganiateir eisoes wedi'u hamlygu.",mutedByRemoteParticipant:"Rydych chi wedi cael eich tewi gan gyfranogwr arall."},notificationStack:{callingNetworkFailure:{title:"Mae problem wrth gysylltu'r alwad",message:"Mae’n ymddangos eich bod chi all-lein. Gwnewch yn siŵr eich bod chi wedi cysylltu â'r rhwydwaith a rhoi cynnig arall arni.",dismissButtonAriaLabel:"Cau"},startVideoGeneric:{title:"Wedi methu â dechrau'r fideo.",dismissButtonAriaLabel:"Cau"},stopVideoGeneric:{title:"Wedi methu â stopio'r fideo.",dismissButtonAriaLabel:"Cau"},muteGeneric:{title:"Wedi methu â thewi'r meicroffon.",dismissButtonAriaLabel:"Cau"},unmuteGeneric:{title:"Wedi methu â dad-dewi'r meicroffon.",dismissButtonAriaLabel:"Cau"},speakingWhileMuted:{title:"Rydych chi wedi'ch tewi.",dismissButtonAriaLabel:"Cau"},startScreenShareGeneric:{title:"Roedd problem wrth ddechrau rhannu sgrin.",dismissButtonAriaLabel:"Cau"},stopScreenShareGeneric:{title:"Wedi methu â stopio rhannu sgrin.",dismissButtonAriaLabel:"Cau"},callNetworkQualityLow:{title:"Mae ansawdd y rhwydwaith yn isel.",dismissButtonAriaLabel:"Cau"},teamsMeetingCallNetworkQualityLow:{title:"Mae ansawdd y rhwydwaith yn isel.",dismissButtonAriaLabel:"Cau",message:"Ymuno â'r alwad hon o'ch ffôn i gael sain gwell. Gallwch barhau i weld y cyfarfod ar y ddyfais hon.",primaryButtonLabel:"Ymuno dros y Ffôn"},callNoSpeakerFound:{title:"Heb ganfod seinyddion na chlustffonau",message:"Cysylltu dyfais sain i glywed yr alwad.",dismissButtonAriaLabel:"Cau"},callNoMicrophoneFound:{title:"Heb ganfod meicroffonau",message:"Cysylltwch ddyfais mewnbynnu sain.",dismissButtonAriaLabel:"Cau"},callMicrophoneAccessDenied:{title:"Does dim modd cael mynediad i'r meicroffon",message:"Cliciwch y clo yn y bar cyfeiriad i roi caniatâd i'r dudalen we hon.",dismissButtonAriaLabel:"Cau"},callMicrophoneAccessDeniedSafari:{title:"Does dim modd cael mynediad i'r meicroffon",message:"Adnewyddwch y dudalen i ganiatáu caniatâd, neu gwiriwch osodiadau'r porwr hwn a dilysu bod y caniatâd wedi'u galluogi ar gyfer y wefan hon.",dismissButtonAriaLabel:"Cau"},callMicrophoneMutedBySystem:{title:"Rydych chi wedi cael eich tewi gan eich system.",dismissButtonAriaLabel:"Cau"},callMicrophoneUnmutedBySystem:{title:"Mae eich meicroffon wedi'i adfer a chawsoch chi eich dad-dewi gan eich system.",dismissButtonAriaLabel:"Cau"},callMacOsMicrophoneAccessDenied:{title:"Does dim modd cael mynediad i'r meicroffon",message:"Rhoi caniatâd meicroffon yn eich gosodiadau preifatrwydd macOS.",dismissButtonAriaLabel:"Cau"},callLocalVideoFreeze:{title:"Mae lled band y rhwydwaith yn wael",message:"Efallai y bydd eich fideo wedi'i oedi ar gyfer eraill ar yr alwad.",dismissButtonAriaLabel:"Cau"},callCameraAccessDenied:{title:"Does dim modd cael mynediad i'r camera",message:"Cliciwch y clo yn y bar cyfeiriad i roi caniatâd i'r dudalen we hon.",dismissButtonAriaLabel:"Cau"},callCameraAccessDeniedSafari:{title:"Does dim modd cael mynediad i'r camera",message:"Adnewyddwch y dudalen i ganiatáu caniatâd, neu gwiriwch osodiadau'r porwr hwn a dilysu bod y caniatâd wedi'u galluogi ar gyfer y wefan hon.",dismissButtonAriaLabel:"Cau"},callCameraAlreadyInUse:{title:"Does dim modd cael mynediad i'r camera",message:"Mae'n bosib bod rhaglen arall yn ei ddefnyddio'n barod.",dismissButtonAriaLabel:"Cau"},callVideoStoppedBySystem:{title:"Mae eich fideo wedi cael ei stopio gan eich system.",dismissButtonAriaLabel:"Cau"},callVideoRecoveredBySystem:{title:"Mae eich fideo wedi ailddechrau.",dismissButtonAriaLabel:"Cau"},callMacOsCameraAccessDenied:{title:"Mae MacOS yn rhwystro mynediad i'ch camera",message:"Diweddarwch eich gosodiadau preifatrwydd i ganiatáu i'r porwr hwn gael mynediad at eich camera.",dismissButtonAriaLabel:"Cau"},callMacOsScreenShareAccessDenied:{title:"Mae MacOS yn rhwystro rhannu sgrin",message:"Diweddarwch eich gosodiadau preifatrwydd i ganiatáu i'r porwr hwn recordio eich sgrin.",dismissButtonAriaLabel:"Cau"},failedToJoinCallGeneric:{title:"Wedi methu ag ymuno â'r alwad.",dismissButtonAriaLabel:"Cau"},failedToJoinCallInvalidMeetingLink:{title:"Does dim modd ymuno â'r Cyfarfod. Dolen Annilys.",dismissButtonAriaLabel:"Cau"},cameraFrozenForRemoteParticipants:{title:"Mae defnyddwyr yn yr alwad yn cael trafferth gweld eich fideo",message:"Gwiriwch eich dyfeisiau a'ch rhwydwaith.",dismissButtonAriaLabel:"Cau"},unableToStartVideoEffect:{title:"Does dim modd defnyddio'r effaith fideo.",dismissButtonAriaLabel:"Cau"},startSpotlightWhileMaxParticipantsAreSpotlighted:{title:"Nid oes modd dechrau'r sbotolau ar y cyfranogwr/cyfranogwyr",message:"Mae'r sbotolau eisoes ar y nifer fwyaf o gyfranogwyr.",dismissButtonAriaLabel:"Cau"},mutedByRemoteParticipant:{title:"Rydych chi wedi cael eich tewi gan gyfranogwr arall.",dismissButtonAriaLabel:"Cau"},recordingStarted:{title:"Wedi dechrau recordio.",message:"Drwy ymuno, rydych yn cydsynio i drawsgrifio'r cyfarfod hwn.",dismissButtonAriaLabel:"Cau"},transcriptionStarted:{title:"Wedi dechrau trawsgrifio.",message:"Drwy ymuno, rydych yn cydsynio i drawsgrifio'r cyfarfod hwn.",dismissButtonAriaLabel:"Cau"},recordingStopped:{title:"Mae recordiad yn cael ei gadw.",message:"Wedi stopio recordio.",dismissButtonAriaLabel:"Cau"},transcriptionStopped:{title:"Mae trawsgrifiad yn cael ei gadw.",message:"Wedi stopio trawsgrifio.",dismissButtonAriaLabel:"Cau"},recordingAndTranscriptionStarted:{title:"Wedi dechrau recordio a thrawsgrifio.",message:"Drwy ymuno, rydych yn cydsynio i drawsgrifio'r cyfarfod hwn.",dismissButtonAriaLabel:"Cau"},recordingAndTranscriptionStopped:{title:"Mae recordiad a thrawsgrifiad yn cael eu cadw.",message:"Wedi stopio recordio a thrawsgrifio.",dismissButtonAriaLabel:"Cau"},recordingStoppedStillTranscribing:{title:"Wedi stopio recordio.",message:"Rydych yn awr yn trawsgrifio'r cyfarfod hwn yn unig.",dismissButtonAriaLabel:"Cau"},transcriptionStoppedStillRecording:{title:"Wedi stopio trawsgrifio.",message:"Rydych chi dim ond yn recordio'r cyfarfod hwn bellach.",dismissButtonAriaLabel:"Cau"},assignedBreakoutRoomOpened:{title:"Byddwn yn eich symud i'ch ystafell wedi'i neilltuo mewn 5 eiliad.",dismissButtonAriaLabel:"Cau"},assignedBreakoutRoomChanged:{title:"Mae ystafell eich cyfarfod ymylol wedi newid",message:"Byddwn yn eich symud i'ch ystafell wedi'i neilltuo mewn 5 eiliad.",dismissButtonAriaLabel:"Cau"},assignedBreakoutRoomClosed:{title:"Mae eich cyfarfod ymylol wedi cau",message:"Byddwn yn eich symud yn ôl i'ch cyfarfod mewn 5 eiliad.",dismissButtonAriaLabel:"Cau"},assignedBreakoutRoomOpenedPromptJoin:{title:"Ymuno â chyfarfod ymylol?",message:"Rydych chi wedi cael eich neilltuo i gyfarfod ymylol.",dismissButtonAriaLabel:"Cau",primaryButtonLabel:"Ymuno â’r ystafell",secondaryButtonLabel:"Yn nes ymlaen"},breakoutRoomJoined:{title:"Rydych chi wedi ymuno â chyfarfod ymylol.",dismissButtonAriaLabel:"Cau"},breakoutRoomClosingSoon:{title:"Mae terfyn amser yr ystafell ar fin dod i ben.",message:"Bydd yr ystafell hon yn cau mewn 30 eiliad",dismissButtonAriaLabel:"Cau"},capabilityTurnVideoOnPresent:{title:"Mae eich camera wedi cael ei alluogi",message:"Rhowch eich camera ar waith os hoffech chi rannu fideo",dismissButtonAriaLabel:"Cau"},capabilityTurnVideoOnAbsent:{title:"Mae eich camera wedi cael ei analluogi",message:"Does dim modd i chi rannu fideo bellach",dismissButtonAriaLabel:"Cau"},capabilityUnmuteMicPresent:{title:"Mae eich meic wedi cael ei alluogi",message:"Dad-dewch y meicroffon os hoffech chi siarad.",dismissButtonAriaLabel:"Cau"},capabilityUnmuteMicAbsent:{title:"Mae eich meic wedi cael ei analluogi",message:"Does dim modd i chi ddad-dewi bellach.",dismissButtonAriaLabel:"Cau"},togetherModeStarted:{title:"Mae Togethermode wedi dechrau",dismissButtonAriaLabel:"Cau"},togetherModeEnded:{title:"Mae Togethermode wedi dod i ben",dismissButtonAriaLabel:"Cau"}},videoGallery:{screenIsBeingSharedMessage:"Rydych chi'n rhannu eich sgrin",screenShareLoadingMessage:"Wrthi'n llwytho sgrin {participant}",localScreenShareLoadingMessage:"Wrthi'n llwytho eich sgrin",localVideoLabel:"Chi",localVideoCameraSwitcherLabel:"Newid camera",localVideoMovementLabel:"Teilsen Fideo Lleol Symudol",localVideoMovementAriaLabel:"Teilsen Fideo Lleol Symudol",localVideoSelectedDescription:"Wedi dewis {cameraName}",displayNamePlaceholder:"Cyfranogwr dienw",fitRemoteParticipantToFrame:"Ffitio i'r ffrâm",fillRemoteParticipantFrame:"Llenwi'r ffrâm",pinParticipantForMe:"Pinio ar fy nghyfer i",pinParticipantForMeLimitReached:"Pinio (wedi cyrraedd y terfyn)",unpinParticipantForMe:"Dadbinio",pinParticipantMenuItemAriaLabel:"Pinio {participantName}",unpinParticipantMenuItemAriaLabel:"Dadbinio {participantName}",pinnedParticipantAnnouncementAriaLabel:"Wedi pinio {participantName}",unpinnedParticipantAnnouncementAriaLabel:"Wedi dadbinio {participantName}",startSpotlightVideoTileMenuLabel:"Sbotolau i bawb",addSpotlightVideoTileMenuLabel:"Ychwanegu sbotolau",spotlightLimitReachedMenuTitle:"Wedi cyrraedd y terfyn sbotolau",stopSpotlightVideoTileMenuLabel:"Diffodd y sbotolau",stopSpotlightOnSelfVideoTileMenuLabel:"Gadael y sbotolau",attendeeRole:"Mynychwr",muteParticipantMenuItemLabel:"Tewi",waitingScreenText:"Yn aros i bobl eraill ymuno",forbidAudio:"Analluogi meic",permitAudio:"Caniatáu meic",forbidAudioTileMenuLabel:"Analluogi meic",permitAudioTileMenuLabel:"Caniatáu meic",forbidVideo:"Analluogi camera",permitVideo:"Caniatáu camera",forbidVideoTileMenuLabel:"Analluogi camera",permitVideoTileMenuLabel:"Caniatáu camera"},dialpad:{placeholderText:"Rhowch rif ffôn",deleteButtonAriaLabel:"Dileu"},holdButton:{onLabel:"Parhau",offLabel:"Rhoi i aros",tooltipOnContent:"Parhau â'r alwad",tooltipOffContent:"Rhoi'r alwad i Aros"},videoTile:{participantStateRinging:"Wrthi'n galw...",participantReconnecting:"Wrthi'n ailgysylltu...",participantStateHold:"Galwad yn aros",moreOptionsButtonAriaLabel:"Mwy o Ddewisiadau {displayName} {isMuted} {micDisabledState} {cameraDisabledState} {isHandRaised} {state} {isSpeaking}",moreOptionsParticipantMutedStateMutedAriaLabel:"wedi tewi",moreOptionsParticipantMutedStateUnmutedAriaLabel:"wedi dad-dewi",moreOptionsParticipantHandRaisedAriaLabel:"Llaw wedi’i chodi",moreOptionsParticipantIsSpeakingAriaLabel:"Siarad",moreOptionsParticipantMicDisabledAriaLabel:"Meicroffon wedi'i analluogi",moreOptionsParticipantCameraDisabledAriaLabel:"Camera wedi'i analluogi"},CameraAndMicrophoneSitePermissionsRequest:{primaryText:"Caniatáu i {appName} ddefnyddio eich camera a'ch meicroffon",secondaryText:"Mae hyn er mwyn i gyfranogwyr allu eich gweld a'ch clywed chi.",linkText:"Angen cymorth? Cael cymorth i ddatrys problemau",primaryButtonText:"Bwrw ymlaen heb y camera a'r meicroffon",ariaLabel:"Caniatáu mynediad i'r camera a'r meicroffon"},CameraSitePermissionsRequest:{primaryText:"Caniatáu i {appName} ddefnyddio eich camera",secondaryText:"Mae hyn er mwyn i gyfranogwyr allu eich gweld chi.",linkText:"Angen help? Cael cymorth i ddatrys problemau",primaryButtonText:"Bwrw ymlaen heb y camera",ariaLabel:"Caniatáu mynediad i'r camera"},MicrophoneSitePermissionsRequest:{primaryText:"Caniatáu i {appName} ddefnyddio eich meicroffon",secondaryText:"Mae hyn er mwyn i gyfranogwyr allu eich clywed chi.",linkText:"Angen cymorth? Cael cymorth i ddatrys problemau",primaryButtonText:"Bwrw ymlaen heb feicroffon",ariaLabel:"Caniatáu mynediad i'r meicroffon"},CameraAndMicrophoneSitePermissionsCheck:{primaryText:"Wrthi'n chwilio am fynediad i'r camera a'r meicroffon",secondaryText:"Caniatáu mynediad os gofynnir i chi wneud hynny. Mae hyn er mwyn i gyfranogwyr allu eich gweld a'ch clywed chi.",linkText:"Angen help? Cael cymorth i ddatrys problemau",primaryButtonText:"Bwrw ymlaen heb y camera a'r meicroffon",ariaLabel:"Wrthi'n chwilio am fynediad i'r camera a'r meicroffon. Caniatáu mynediad os gofynnir i chi wneud hynny."},CameraSitePermissionsCheck:{primaryText:"Wrthi'n chwilio am fynediad i'r camera",secondaryText:"Caniatáu mynediad os gofynnir i chi wneud hynny. Mae hyn er mwyn i gyfranogwyr eich gweld.",linkText:"Angen cymorth? Cael cymorth i ddatrys problemau",primaryButtonText:"Bwrw ymlaen heb y camera",ariaLabel:"Wrthi'n chwilio am fynediad i'r camera. Caniatáu mynediad os gofynnir i chi wneud hynny."},MicrophoneSitePermissionsCheck:{primaryText:"Wrthi'n chwilio am fynediad i’r meicroffon",secondaryText:"Caniatáu mynediad os gofynnir i chi wneud hynny. Mae hyn fel y gall cyfranogwyr eich clywed.",linkText:"Angen cymorth? Cael cymorth i ddatrys problemau",primaryButtonText:"Bwrw ymlaen heb feicroffon",ariaLabel:"Wrthi'n chwilio am fynediad i'r meicroffon. Caniatáu mynediad os gofynnir i chi wneud hynny."},CameraAndMicrophoneSitePermissionsDenied:{primaryText:"Nid oes modd cael mynediad at y camera a'r meicroffon",secondaryText:"Cliciwch yr eicon clo yn y bar cyfeiriad i roi hawliau i'r meicroffon i'r dudalen we hon. Efallai bydd angen adnewyddu tudalen.",primaryButtonText:"Bwrw ymlaen heb y camera a'r meicroffon",linkText:"Angen help? Cael cymorth i ddatrys problemau"},CameraAndMicrophoneSitePermissionsDeniedSafari:{primaryText:"Does dim modd cael mynediad i'r camera a'r meicroffon",secondaryText:"Adnewyddwch y dudalen i ganiatáu hawliau, neu gwiriwch osodiadau'r porwr hwn a dilysu hawliau wedi'u galluogi ar gyfer y wefan hon.",primaryButtonText:"Bwrw ymlaen heb y camera a'r meicroffon",linkText:"Angen cymorth? Cael cymorth i ddatrys problemau"},CameraSitePermissionsDenied:{primaryText:"Nid oes modd cael mynediad at y camera",secondaryText:"Cliciwch ar yr eicon clo yn y bar cyfeiriad i roi caniatâd camera i'r dudalen we hon. Efallai y bydd angen adnewyddu'r dudalen.",primaryButtonText:"Bwrw ymlaen heb y camera",linkText:"Angen help? Cael cymorth i ddatrys problemau"},MicrophoneSitePermissionsDenied:{primaryText:"Does dim modd cael mynediad i'r meicroffon",secondaryText:"Cliciwch yr eicon clo yn y bar cyfeiriad i roi hawliau i'r meicroffon i'r dudalen we hon. Efallai bydd angen adnewyddu tudalen.",primaryButtonText:"Bwrw ymlaen heb feicroffon",linkText:"Angen help? Cael cymorth i ddatrys problemau"},CameraSitePermissionsDeniedSafari:{primaryText:"Does dim modd cael mynediad i'r camera",secondaryText:"Adnewyddwch y dudalen i ganiatáu hawliau, neu gwiriwch osodiadau'r porwr hwn a dilysu hawliau wedi'u galluogi ar gyfer y wefan hon.",primaryButtonText:"Bwrw ymlaen heb y camera",linkText:"Angen help? Cael cymorth i ddatrys problemau"},MicrophoneSitePermissionsDeniedSafari:{primaryText:"Nid oes modd cael mynediad at y meicroffon",secondaryText:"Adnewyddwch y dudalen i ganiatáu hawliau, neu gwiriwch osodiadau'r porwr hwn a dilysu hawliau wedi'u galluogi ar gyfer y wefan hon.",primaryButtonText:"Bwrw ymlaen heb feicroffon",linkText:"Angen cymorth? Cael cymorth i ddatrys problemau"},UnsupportedBrowser:{primaryText:"Does dim modd delio â'r porwr",secondaryText:"Ymunwch â'r alwad hon gan ddefnyddio porwr cydnaws.",moreHelpLinkText:"Gweld gofynion cydnawsedd"},UnsupportedBrowserVersion:{primaryText:"Mae angen diweddaru'r porwr",secondaryText:"Er mwyn sicrhau’r alwad orau posibl, diweddarwch eich porwr a rhoi cynnig arall ar ymuno â'r alwad.",moreHelpLinkText:"Gweld gofynion cydnawsedd",continueAnywayButtonText:"Dechrau galwad heb ddiweddaru"},UnsupportedOperatingSystem:{primaryText:"Ni chefnogir system gweithredu",secondaryText:"Ymunwch â'r alwad hon gan ddefnyddio dyfais sydd â system weithredu gydnaws.",moreHelpLinkText:"Gweld gofynion cydnawsedd"},BrowserPermissionDenied:{primaryText:"Does dim modd defnyddio eich camera neu feicroffon",secondaryText:"Efallai nad oes gan eich porwr fynediad i'ch camera neu'ch meicroffon. I drwsio hyn, agorwch Dewisiadau'r System.",primaryButtonText:"Rhowch gynnig arall arni",linkText:"Angen help? Cael cymorth i ddatrys problemau"},BrowserPermissionDeniedIOS:{primaryText:"Caniatewch fynediad i'r meicroffon i barhau",secondaryText:"Er mwyn i gyfranogwyr allu eich clywed chi.",primaryButtonText:"Rhowch gynnig arall arni",imageAltText:"Lleoliad caniatâd meicroffon a dyfais camera ar gyfer iOS",linkText:"Angen help? Cael cymorth i ddatrys problemau",step1Text:"Ewch i'r ap Gosodiadau.",step2Text:"Sgroliwch i lawr i'r gosodiadau ar gyfer y porwr hwn",step3Text:"Rhowch y Meicroffon ar waith (Camera'n ddewisol)",step4Text:"Rhowch gynnig arall ar ymuno â'r alwad",step1DigitText:"1",step2DigitText:"2",step3DigitText:"3",step4DigitText:"4"},verticalGallery:{leftNavButtonAriaLabel:"tudalen flaenorol {current} o {total}",rightNavButtonAriaLabel:"tudalen nesaf {current} o {total}"},meetingConferencePhoneInfo:{meetingConferencePhoneInfoModalTitle:"Ymuno â galwad o'ch ffôn",meetingConferencePhoneInfoModalDialIn:"Deialu rhif",meetingConferencePhoneInfoModalMeetingId:"Rhowch ID y cyfarfod",meetingConferencePhoneInfoModalWait:"Aros i'r trefnydd roi mynediad",meetingConferencePhoneInfoModalNoPhoneAvailable:"Dim ffôn ar gael",meetingConferencePhoneInfoModalTollGeoData:"{country}, {city}",meetingConferencePhoneInfoModalTollFree:"(Di-doll)",meetingConferencePhoneInfoModalToll:"(Toll)"},IncomingCallNotification:{incomingCallNotificationPlaceholderId:"Defnyddiwr Anhysbys",incomingCallNotificationPlaceholderAlert:"{callerName} yn galw",incomingCallNoticicationAcceptWithAudioAriaLabel:"Derbyn gyda sain",incomingCallNoticicationAcceptWithVideoAriaLabel:"Derbyn gyda fideo",incomingCallNoticicationRejectAriaLabel:"Gwrthod",incomingCallNotificationAcceptButtonLabel:"Derbyn",incomingCallNotificationRejectButtonLabel:"Gwrthod",incomingCallNotificationAccceptWithVideoButtonLabel:"Derbyn gyda Fideo",incomingCallNotificationDismissButtonAriaLabel:"Diystyru"}})},lQt={strings:Jh({participantItem:{isMeText:"(Sie)",menuTitle:"Weitere Optionen",removeButtonLabel:"Entfernen",sharingIconLabel:"Teilen",mutedIconLabel:"Stumm geschaltet",handRaisedIconLabel:"Hand erhoben – Position {position}",displayNamePlaceholder:"Teilnehmer ohne Namen",participantStateRinging:"Anrufen...",participantStateHold:"In der Warteschleife",participantItemAriaLabel:"{displayName}, {handRaisedState}, {mutedState}, {micDisabledState}, {cameraDisabledState}, {sharingState}, {connectionState}",participantItemWithMoreOptionsAriaLabel:"{displayName}, {handRaisedState}, {mutedState}, {micDisabledState}, {cameraDisabledState}, {sharingState}, {connectionState}, weitere Optionen",attendeeRole:"Teilnehmer",micDisabledIconLabel:"Micophone deaktiviert",cameraDisabledIconLabel:"Kamera deaktiviert"},ParticipantList:{overflowParticipantCount:"+{overflowCount} weitere"},typingIndicator:{singleUser:"{user} schreibt ...",multipleUsers:"{users} schreiben ...",multipleUsersAbbreviateOne:"{users} und 1 andere Person schreiben ...",multipleUsersAbbreviateMany:"{users} und {numOthers} andere schreiben ...",delimiter:", "},sendBox:{placeholderText:"Nachricht eingeben",textTooLong:"Ihre Nachrichtenlänge überschreitet den maximalen Grenzwert.",sendButtonAriaLabel:"Nachricht senden",attachmentUploadsPendingError:"Datei wird hochgeladen, bitte warten.",removeAttachment:"Datei entfernen",uploading:"Hochladen",uploadCompleted:"Upload abgeschlossen",attachmentMoreMenu:"Mehr Optionen"},richTextSendBox:{placeholderText:"Nachricht eingeben",textTooLong:"Ihre Nachrichtenlänge überschreitet den maximalen Grenzwert.",sendButtonAriaLabel:"Nachricht senden",attachmentUploadsPendingError:"Datei wird hochgeladen, bitte warten.",imageUploadsPendingError:"Bild wird hochgeladen, bitte warten.",removeAttachment:"Datei entfernen",uploading:"Wird hochgeladen",uploadCompleted:"Upload abgeschlossen",richTextBoldTooltip:"Fett",richTextItalicTooltip:"Kursiv",richTextUnderlineTooltip:"Unterstreichen",richTextBulletListTooltip:"Aufzählungsliste",richTextNumberListTooltip:"Nummerierte Liste",richTextIncreaseIndentTooltip:"Einzug vergrößern",richTextDecreaseIndentTooltip:"Einzug verringern",richTextInsertTableTooltip:"Tabelle einfügen",richTextFormatButtonTooltip:"Formatieren",richTextInsertRowOrColumnMenu:"Einfügen",richTextInsertTableMenuTitle:"{column} x {row} Tabelle einfügen",richTextInsertRowAboveMenu:"Oben einfügen",richTextInsertRowBelowMenu:"Darunter einfügen",richTextInsertColumnLeftMenu:"Links einfügen",richTextInsertColumnRightMenu:"Rechts einfügen",richTextDeleteRowOrColumnMenu:"Löschen",richTextDeleteColumnMenu:"Spalte löschen",richTextDeleteRowMenu:"Zeile löschen",richTextDeleteTableMenu:"Tabelle löschen",richTextToolbarAriaLabel:"Symbolleiste für die Nachrichtenformatierung",richTextToolbarMoreButtonAriaLabel:"Weitere Optionen",attachmentMoreMenu:"Mehr Optionen",richTextNewBulletedListItemAnnouncement:"Aufzählungszeichen, neue Zeile",richTextNewNumberedListItemAnnouncement:"{0}, neue Zeile",richTextBulletedListAppliedAnnouncement:"Aufzählung angewendet",richTextNumberedListAppliedAnnouncement:'"Nummerierte Liste" angewendet.'},realTimeTextModal:{realTimeTextModalAriaLabel:"RTT Modal aktivieren",realTimeTextModalTitle:"RTT aktivieren?",realTimeTextModalText:"Echtzeittext (RTT) wird für alle Teilnehmer der Besprechung aktiviert.",realTimeTextConfirmButtonLabel:"Aktivieren",realTimeTextCancelButtonLabel:"Abbrechen",realTimeTextCloseModalButtonAriaLabel:"RTT Modal schließen"},captionsBanner:{captionsBannerSpinnerText:"Untertitel werden gestartet...",realTimeTextInputBoxDefaultText:"Nachricht in Echtzeit eingeben",realTimeTextInputErrorMessage:"Die Nachricht darf 2000 Zeichen nicht überschreiten.",realTimeTextBannerTitle:"RTT",realTimeTextBannerContent:"RTT (Echtzeittext) ist für alle Teilnehmer für die gesamte Dauer der Besprechung aktiviert.",realTimeTextBannerLinkLabel:"Weitere Informationen",captionsOnlyContainerTitle:"Untertitel",realTimeTextOnlyContainerTitle:"Echtzeittext",captionsAndRealTimeTextContainerTitle:"Untertitel und Echtzeittext",expandButtonAriaLabel:"Erweitern",minimizeButtonAriaLabel:"Reduzieren"},mentionPopover:{mentionPopoverHeader:"Vorschläge"},imageOverlay:{downloadButtonLabel:"Herunterladen",dismissButtonAriaLabel:"Schließen",overlayVisibleMessage:"Bilddetailsüberlagerung"},messageStatusIndicator:{deliveredAriaLabel:"Nachricht gesendet",deliveredTooltipText:"Gesendet",seenAriaLabel:"Nachricht von anderen gesehen",seenTooltipText:"Gesehen",readByTooltipText:"Gelesen von {messageThreadReadCount} von {remoteParticipantsCount}",sendingAriaLabel:"Nachricht wird gesendet",sendingTooltipText:"Wird gesendet",failedToSendAriaLabel:"Nachricht konnte nicht gesendet werden",failedToSendTooltipText:"Fehler beim Senden"},endCallButton:{label:"Verlassen",tooltipContent:"Anruf verlassen",leaveOption:"Beenden",endCallOption:"Anruf für alle beenden"},cameraButton:{onLabel:"Kamera",offLabel:"Kamera",tooltipDisabledContent:"Kamera ist deaktiviert",tooltipOnContent:"Kamera ausschalten",tooltipOffContent:"Kamera einschalten",tooltipVideoLoadingContent:"Video wird geladen",cameraMenuTitle:"Kamera",cameraMenuTooltip:"Kamera auswählen",cameraButtonSplitRoleDescription:"Unterteilte Schaltfläche",onSplitButtonAriaLabel:"Kamera ausschalten",offSplitButtonAriaLabel:"Kamera einschalten",cameraActionTurnedOnAnnouncement:"Ihre Kamera wurde eingeschaltet.",cameraActionTurnedOffAnnouncement:"Ihre Kamera wurde ausgeschaltet.",onSplitButtonPrimaryActionCamera:"Kamera ausschalten",offSplitButtonPrimaryActionCamera:"Kamera einschalten",cameraPrimaryActionSplitButtonTitle:"Kamera verwenden",videoEffectsMenuItemTitle:"Effekte",cameraButtonAriaDescription:"Kameraoptionen"},microphoneButton:{onLabel:"Mikrofon",offLabel:"Mikrofon",tooltipDisabledContent:"Mikrofon ist deaktiviert",tooltipOnContent:"Mikrofon stummschalten",tooltipOffContent:"Mikrofonstummschaltung aufheben",microphoneMenuTitle:"Mikrofon",microphoneMenuTooltip:"Mikrofon auswählen",speakerMenuTitle:"Lautsprecher",speakerMenuTooltip:"Lautsprecher auswählen",microphoneButtonSplitRoleDescription:"Unterteilte Schaltfläche",onSplitButtonAriaLabel:"Mikrofon stummschalten",offSplitButtonAriaLabel:"Stummschaltung des Mikrofons aufheben",microphoneActionTurnedOnAnnouncement:"Ihr Mikrofon wurde eingeschaltet.",microphoneActionTurnedOffAnnouncement:"Ihr Mikrofon wurde ausgeschaltet.",offSplitButtonMicrophonePrimaryAction:"Stummschaltung des Mikrofons aufheben",onSplitButtonMicrophonePrimaryAction:"Mikrofon stummschalten",microphonePrimaryActionSplitButtonTitle:"Mikrofon verwenden",microphoneAriaDescription:"Audiooptionen",deepNoiseSuppressionTitle:"Rauschunterdrückung",deepNoiseSuppressionOnAnnouncement:"Die Unterdrückung tiefer Geräusche wurde aktiviert.",deepNoiseSuppressionOffAnnouncement:"Die Unterdrückung tiefer Geräusche wurde deaktiviert."},devicesButton:{label:"Geräte",tooltipContent:"Geräte verwalten",cameraMenuTitle:"Kamera",cameraMenuTooltip:"Kamera auswählen",audioDeviceMenuTitle:"Audiogerät",audioDeviceMenuTooltip:"Audiogerät auswählen",microphoneMenuTitle:"Mikrofon",microphoneMenuTooltip:"Mikrofon auswählen",speakerMenuTitle:"Lautsprecher",speakerMenuTooltip:"Lautsprecher auswählen"},participantsButton:{label:"Personen",ariaLabel:"Personen",tooltipContent:"Teilnehmende anzeigen",menuHeader:"In diesem Anruf",participantsListButtonLabel:"{numParticipants} Personen",muteAllButtonLabel:"Alle stumm schalten",copyInviteLinkButtonLabel:"Einladungslink kopieren",copyInviteLinkActionedAriaLabel:"Einladungslink kopiert"},screenShareButton:{onLabel:"Präsentation beenden",offLabel:"Präsentieren",tooltipDisabledContent:"Präsentieren ist deaktiviert",tooltipOnContent:"Ihr Bildschirm wird präsentiert",tooltipOffContent:"Präsentieren Sie Ihren Bildschirm"},raiseHandButton:{offLabel:"Heben",onLabel:"Senken",tooltipDisabledContent:"Aktion „Hand heben“ ist deaktiviert",tooltipOnContent:"Hand senken",tooltipOffContent:"Hand heben"},reactionButton:{label:"Reagieren",ariaLabel:"Reagieren",tooltipDisabledContent:"Reaktionsaktion ist deaktiviert",tooltipContent:"Reaktion senden",likeReactionTooltipContent:"Gefällt mir",heartReactionTooltipContent:"Liebe",laughReactionTooltipContent:"Lachen",applauseReactionTooltipContent:"Applaus",surprisedReactionTooltipContent:"Überrascht"},realTimeText:{isTypingText:"RTT-Eingabe"},captionsSettingsModal:{captionsSettingsModalTitle:"Einstellungen für Untertitel",captionsSettingsSpokenLanguageDropdownLabel:"Gesprochene Sprache",captionsSettingsCaptionLanguageDropdownLabel:"Sprache der Untertitel",captionsSettingsSpokenLanguageDropdownInfoText:"Sprache, die jeder in diesem Anruf spricht.",captionsSettingsCaptionLanguageDropdownInfoText:"Untertitel werden in dieser Sprache angezeigt.",captionsSettingsConfirmButtonLabel:"Bestätigen",captionsSettingsCancelButtonLabel:"Abbrechen",captionsSettingsModalAriaLabel:"Untertiteleinstellung modal",captionsSettingsCloseModalButtonAriaLabel:"Einstellung „Untertitel“ schließen"},spokenLanguages:{"ar-ae":"Arabisch – Vereinigte Arabische Emirate","ar-sa":"Arabisch – Saudi-Arabien","da-dk":"Dänisch","de-de":"Deutsch – Deutschland","en-au":"Englisch – Australien","en-ca":"Englisch – Kanada","en-gb":"Englisch – Vereinigtes Königreich","en-in":"Englisch – Indien","en-nz":"Englisch – Neuseeland","en-us":"Englisch – USA","es-es":"Spanisch – Spanien (Moderne Sortierung)","es-mx":"Spanisch – Mexiko","fi-fi":"Finnisch","fr-ca":"Französisch (Kanada)","fr-fr":"Französisch (Frankreich)","hi-in":"Hindi","it-it":"Italienisch – Italien","ja-jp":"Japanisch","ko-kr":"Koreanisch","nb-no":"Norwegisch (Bokmål)","nl-be":"Niederländisch – Belgien","nl-nl":"Niederländisch – Niederlande","pl-pl":"Polnisch","pt-br":"Portugiesisch (Brasilien)","ru-ru":"Russisch","sv-se":"Schwedisch","zh-cn":"Chinesisch – Volksrepublik China","zh-hk":"Chinesisch – Hongkong (SAR)","cs-cz":"Tschechisch","pt-pt":"Portugiesisch (Portugal)","tr-tr":"Türkisch","vi-vn":"Vietnamesisch","th-th":"Thailändisch","he-il":"Hebräisch","cy-gb":"Walisisch","uk-ua":"Ukrainisch","el-gr":"Griechisch","hu-hu":"Ungarisch","ro-ro":"Rumänisch","sk-sk":"Slowakisch","zh-tw":"Chinesisch – Taiwan"},captionLanguages:{ar:"Arabisch",da:"Dänisch",de:"Deutsch",en:"Englisch",es:"Spanisch",fi:"Finnisch","fr-ca":"Französisch (Kanada)",fr:"Französisch (Frankreich)",hi:"Hindi",it:"Italienisch",ja:"Japanisch",ko:"Koreanisch",nb:"Norwegisch (Bokmål)",nl:"Niederländisch",pl:"Polnisch",pt:"Portugiesisch (Brasilien)",ru:"Russisch",sv:"Schwedisch","zh-Hans":"Chinesisch (vereinfacht)","zh-Hant":"Chinesisch (traditionell)",cs:"Tschechisch","pt-pt":"Portugiesisch (Portugal)",tr:"Türkisch",vi:"Vietnamesisch",th:"Thailändisch",he:"Hebräisch",cy:"Walisisch",uk:"Ukrainisch",el:"Griechisch",hu:"Ungarisch",ro:"Rumänisch",sk:"Slowakisch"},startCaptionsButton:{onLabel:"Beschriftungen aktivieren",offLabel:"Untertitel deaktivieren",tooltipOnContent:"Untertitel deaktivieren",tooltipOffContent:"Beschriftungen aktivieren"},startRealTimeTextButton:{label:"RTT für diesen Anruf aktivieren",tooltipOffContent:"RTT für diesen Anruf aktivieren"},messageThread:{yesterday:"Gestern",sunday:"Sonntag",monday:"Montag",tuesday:"Dienstag",wednesday:"Mittwoch",thursday:"Donnerstag",friday:"Freitag",saturday:"Samstag",participantJoined:"ist dem Chat beigetreten.",participantLeft:"hat den Chat verlassen.",editMessage:"Bearbeiten",removeMessage:"Löschen",resendMessage:"Erneut senden",failToSendTag:"Fehler beim Senden",editedTag:"Bearbeitet",liveAuthorIntro:"Nachricht von {author}",editedMessageLiveAuthorIntro:"Nachricht von {author} bearbeitet",editedMessageLocalUserLiveAuthorIntro:"Nachricht bearbeitet",messageContentAriaText:"{status} {author} hat {message} gesagt",messageContentMineAriaText:"{status} Sie haben {message} gesagt",editBoxTextLimit:"Ihre Nachricht überschreitet das Limit von {limitNumber} Zeichen.",editBoxPlaceholderText:"Bearbeiten Sie Ihre Nachricht",newMessagesIndicator:"Neue Nachrichten",noDisplayNameSub:"Kein Name",editBoxCancelButton:"Abbrechen",editBoxSubmitButton:"Fertig",messageReadCount:"Gelesen von {messageReadByCount} von {remoteParticipantsCount}",actionMenuMoreOptions:"Weitere Optionen",downloadAttachment:"Datei herunterladen",openAttachment:"Datei öffnen",blockedWarningText:"Diese Nachricht wurde aufgrund einer Organisationsrichtlinie gelöscht.",blockedWarningLinkText:"Details",attachmentCardGroupMessage:"Die Nachricht enthält {attachmentCount} Anlage.",messageDeletedAnnouncementAriaLabel:"Die Nachricht wurde gelöscht",richTextBoldTooltip:"Fett",richTextItalicTooltip:"Kursiv",richTextUnderlineTooltip:"Unterstreichen",richTextBulletListTooltip:"Aufzählungsliste",richTextNumberListTooltip:"Nummerierte Liste",richTextIncreaseIndentTooltip:"Einzug vergrößern",richTextDecreaseIndentTooltip:"Einzug verringern",richTextInsertTableTooltip:"Tabelle einfügen",richTextFormatButtonTooltip:"Formatieren",richTextInsertRowOrColumnMenu:"Einfügen",richTextInsertTableMenuTitle:"{column} x {row} Tabelle einfügen",richTextInsertRowAboveMenu:"Oben einfügen",richTextInsertRowBelowMenu:"Unten einfügen",richTextInsertColumnLeftMenu:"Links einfügen",richTextInsertColumnRightMenu:"Rechts einfügen",richTextDeleteRowOrColumnMenu:"Löschen",richTextDeleteColumnMenu:"Spalte löschen",richTextDeleteRowMenu:"Zeile löschen",richTextDeleteTableMenu:"Tabelle löschen",richTextToolbarMoreButtonAriaLabel:"Weitere Optionen",attachmentUploadsPendingError:"Datei wird hochgeladen, bitte warten.",imageUploadsPendingError:"Bild wird hochgeladen, bitte warten.",richTextNewBulletedListItemAnnouncement:"Aufzählungszeichen, neue Zeile",richTextNewNumberedListItemAnnouncement:"{0}, neue Zeile",richTextBulletedListAppliedAnnouncement:"Aufzählung angewendet",richTextNumberedListAppliedAnnouncement:'"Nummerierte Liste" angewendet.'},errorBar:{unableToReachChatService:"Sie sind offline.",accessDenied:"Auf die Chatdienste kann nicht zugegriffen werden. Überprüfen Sie die angegebenen Benutzeranmeldeinformationen.",userNotInChatThread:"Sie sind nicht mehr in diesem Chatthread vertreten.",sendMessageNotInChatThread:"Fehler beim Senden der Nachricht, weil Sie sich nicht mehr in diesem Chatthread befinden.",sendMessageGeneric:"Fehler beim Senden der Nachricht",callingNetworkFailure:"Problematische Anrufverbindung – Sie scheinen offline zu sein",startVideoGeneric:"Video konnte nicht gestartet werden",stopVideoGeneric:"Video konnte nicht beendet werden",muteGeneric:"Mikrofon konnte nicht stummgeschaltet werden",unmuteGeneric:"Stummschaltung des Mikrofons konnte nicht beendet werden",speakingWhileMuted:"Ihr Mikrofon ist stummgeschaltet",startScreenShareGeneric:"Beim Starten der Bildschirmfreigabe ist ein Problem aufgetreten.",stopScreenShareGeneric:"Bildschirmfreigabe konnte nicht beendet werden",callNetworkQualityLow:"Die Netzwerkqualität ist niedrig.",teamsMeetingCallNetworkQualityLow:"Die Netzwerkqualität ist niedrig.",callNoSpeakerFound:"Keine Lautsprecher oder Kopfhörer gefunden. Schließen Sie ein Audiogerät an, um den Anruf zu hören.",callNoMicrophoneFound:"Es wurden keine Mikrofone gefunden. Schließen Sie ein Audioeingabegerät an.",callMicrophoneAccessDenied:"Auf das Mikrofon kann nicht zugegriffen werden. Klicken Sie auf die Sperre in der Adressleiste, um dieser Webseite Berechtigungen zu erteilen.",callMicrophoneAccessDeniedSafari:"Auf das Mikrofon kann nicht zugegriffen werden. Aktualisieren Sie die Seite, um Berechtigungen zuzulassen, oder überprüfen Sie die Einstellungen dieses Browsers, und stellen Sie sicher, dass die Berechtigungen für diese Website aktiviert sind.",callMicrophoneMutedBySystem:"Sie werden von Ihrem System stummgeschaltet.",callMicrophoneUnmutedBySystem:"Ihr Mikrofon wurde wiederhergestellt, und Ihr System hat die Stummschaltung aufgehoben.",callMacOsMicrophoneAccessDenied:"Auf das Mikrofon kann nicht zugegriffen werden. Erteilen Sie die Mikrofonberechtigung in Ihren macOS-Datenschutzeinstellungen.",callLocalVideoFreeze:"Die Netzwerkbandbreite ist schlecht. Ihr Video wird möglicherweise für andere Personen während des Anrufs angehalten angezeigt.",callCameraAccessDenied:"Auf die Kamera kann nicht zugegriffen werden. Klicken Sie auf die Sperre in der Adressleiste, um dieser Webseite Berechtigungen zu erteilen.",callCameraAccessDeniedSafari:"Auf die Kamera kann nicht zugegriffen werden. Aktualisieren Sie die Seite, um Berechtigungen zuzulassen, oder überprüfen Sie die Einstellungen dieses Browsers, und stellen Sie sicher, dass die Berechtigungen für diese Website aktiviert sind.",callCameraAlreadyInUse:"Auf die Kamera kann nicht zugegriffen werden. Sie wird möglicherweise bereits von einer anderen Anwendung verwendet.",callVideoStoppedBySystem:"Ihr Video wurde von Ihrem System beendet.",callVideoRecoveredBySystem:"Ihr Video wurde fortgesetzt.",callMacOsCameraAccessDenied:"MacOS blockiert den Zugriff auf Ihre Kamera. Aktualisieren Sie Ihre Datenschutzeinstellungen, damit dieser Browser auf Ihre Kamera zugreifen kann.",callMacOsScreenShareAccessDenied:"MacOS blockiert die Bildschirmfreigabe. Aktualisieren Sie Ihre Datenschutzeinstellungen, damit dieser Browser Ihren Bildschirm aufzeichnen kann.",dismissButtonAriaLabel:"Schließen",failedToJoinCallGeneric:"Fehler bei der Teilnahme am Anruf.",failedToJoinCallInvalidMeetingLink:"Teilnahme an Besprechung nicht möglich. Ungültiger Link.",cameraFrozenForRemoteParticipants:"Benutzer im Anruf haben Probleme, Ihr Video zu sehen. Überprüfen Sie Ihre Geräte und Ihr Netzwerk.",unableToStartVideoEffect:"Videoeffekt kann nicht angewendet werden.",startSpotlightWhileMaxParticipantsAreSpotlighted:"Das Spotlight für Teilnehmende kann nicht gestartet werden, da die maximale Anzahl von Teilnehmenden bereits im Spotlight ist.",mutedByRemoteParticipant:"Sie wurden von einem anderen Teilnehmer stummgeschaltet."},notificationStack:{callingNetworkFailure:{title:"Problem beim Verbindungsaufbau",message:"Sie scheinen offline zu sein. Überprüfen Sie Ihre Netzwerkverbindung, und versuchen Sie es noch mal.",dismissButtonAriaLabel:"Schließen"},startVideoGeneric:{title:"Fehler beim Starten des Videos.",dismissButtonAriaLabel:"Schließen"},stopVideoGeneric:{title:"Fehler beim Beenden des Videos.",dismissButtonAriaLabel:"Schließen"},muteGeneric:{title:"Fehler beim Stummschalten des Mikrofons.",dismissButtonAriaLabel:"Schließen"},unmuteGeneric:{title:"Fehler beim Aufheben der Stummschaltung des Mikrofons.",dismissButtonAriaLabel:"Schließen"},speakingWhileMuted:{title:"Sie sind stummgeschaltet.",dismissButtonAriaLabel:"Schließen"},startScreenShareGeneric:{title:"Beim Starten der Bildschirmfreigabe ist ein Problem aufgetreten.",dismissButtonAriaLabel:"Schließen"},stopScreenShareGeneric:{title:"Fehler beim Beenden der Bildschirmfreigabe.",dismissButtonAriaLabel:"Schließen"},callNetworkQualityLow:{title:"Die Netzwerkqualität ist niedrig.",dismissButtonAriaLabel:"Schließen"},teamsMeetingCallNetworkQualityLow:{title:"Die Netzwerkqualität ist niedrig.",dismissButtonAriaLabel:"Schließen",message:"Nehmen Sie von Ihrem Telefon aus an diesem Anruf teil, um den Sound zu verbessern. Sie können die Besprechung auf diesem Gerät weiterhin anzeigen.",primaryButtonLabel:"Per Telefon teilnehmen"},callNoSpeakerFound:{title:"Keine Lautsprecher oder Kopfhörer gefunden",message:"Schließen Sie ein Audiogerät an, um den Anruf zu hören.",dismissButtonAriaLabel:"Schließen"},callNoMicrophoneFound:{title:"Keine Mikrofone gefunden",message:"Schließen Sie ein Audioeingabegerät an.",dismissButtonAriaLabel:"Schließen"},callMicrophoneAccessDenied:{title:"Zugriff auf Mikrofon nicht möglich",message:"Klicken Sie auf die Sperre in der Adressleiste, um dieser Webseite Berechtigungen zu erteilen.",dismissButtonAriaLabel:"Schließen"},callMicrophoneAccessDeniedSafari:{title:"Zugriff auf Mikrofon nicht möglich",message:"Aktualisieren Sie die Seite, um Berechtigungen zuzulassen, oder überprüfen Sie die Einstellungen dieses Browsers und stellen Sie sicher, dass die Berechtigungen für diese Website aktiviert sind.",dismissButtonAriaLabel:"Schließen"},callMicrophoneMutedBySystem:{title:"Sie werden von Ihrem System stummgeschaltet.",dismissButtonAriaLabel:"Schließen"},callMicrophoneUnmutedBySystem:{title:"Ihr Mikrofon wurde wiederhergestellt, und Ihr System hat die Stummschaltung aufgehoben.",dismissButtonAriaLabel:"Schließen"},callMacOsMicrophoneAccessDenied:{title:"Zugriff auf Mikrofon nicht möglich",message:"Erteilen Sie die Mikrofonberechtigung in Ihren macOS-Datenschutzeinstellungen.",dismissButtonAriaLabel:"Schließen"},callLocalVideoFreeze:{title:"Netzwerkbandbreite ist gering.",message:"Ihr Video wird möglicherweise für andere Teilnehmer des Anrufs angehalten angezeigt.",dismissButtonAriaLabel:"Schließen"},callCameraAccessDenied:{title:"Zugriff auf Kamera nicht möglich",message:"Klicken Sie auf die Sperre in der Adressleiste, um dieser Webseite Berechtigungen zu erteilen.",dismissButtonAriaLabel:"Schließen"},callCameraAccessDeniedSafari:{title:"Zugriff auf Kamera nicht möglich",message:"Aktualisieren Sie die Seite, um Berechtigungen zuzulassen, oder überprüfen Sie die Einstellungen dieses Browsers und stellen Sie sicher, dass die Berechtigungen für diese Website aktiviert sind.",dismissButtonAriaLabel:"Schließen"},callCameraAlreadyInUse:{title:"Zugriff auf Kamera nicht möglich",message:"Sie wird möglicherweise bereits von einer anderen Anwendung verwendet.",dismissButtonAriaLabel:"Schließen"},callVideoStoppedBySystem:{title:"Ihr Video wurde von Ihrem System beendet.",dismissButtonAriaLabel:"Schließen"},callVideoRecoveredBySystem:{title:"Ihr Video wurde fortgesetzt.",dismissButtonAriaLabel:"Schließen"},callMacOsCameraAccessDenied:{title:"MacOS blockiert den Zugriff auf Ihre Kamera.",message:"Aktualisieren Sie Ihre Datenschutzeinstellungen, damit dieser Browser auf Ihre Kamera zugreifen kann.",dismissButtonAriaLabel:"Schließen"},callMacOsScreenShareAccessDenied:{title:"MacOS blockiert die Bildschirmfreigabe.",message:"Aktualisieren Sie Ihre Datenschutzeinstellungen, damit dieser Browser Ihren Bildschirm aufzeichnen kann.",dismissButtonAriaLabel:"Schließen"},failedToJoinCallGeneric:{title:"Fehler bei der Teilnahme am Anruf.",dismissButtonAriaLabel:"Schließen"},failedToJoinCallInvalidMeetingLink:{title:"Teilnahme an Besprechung nicht möglich. Ungültiger Link.",dismissButtonAriaLabel:"Schließen"},cameraFrozenForRemoteParticipants:{title:"Benutzer im Anruf haben Probleme beim Anzeigen Ihres Videos.",message:"Überprüfen Sie Ihre Geräte und Ihr Netzwerk.",dismissButtonAriaLabel:"Schließen"},unableToStartVideoEffect:{title:"Videoeffekt kann nicht angewendet werden.",dismissButtonAriaLabel:"Schließen"},startSpotlightWhileMaxParticipantsAreSpotlighted:{title:"Spotlight auf Teilnehmer kann nicht gestartet werden.",message:"Die maximale Anzahl von Teilnehmern wird bereits hervorgehoben.",dismissButtonAriaLabel:"Schließen"},mutedByRemoteParticipant:{title:"Sie wurden von einem anderen Teilnehmer stummgeschaltet.",dismissButtonAriaLabel:"Schließen"},recordingStarted:{title:"Die Aufzeichnung wurde gestartet.",message:"Durch Ihre Teilnahme stimmen Sie zu, dass diese Besprechung transkribiert wird.",dismissButtonAriaLabel:"Schließen"},transcriptionStarted:{title:"Die Transkription wurde gestartet.",message:"Durch Ihre Teilnahme stimmen Sie zu, dass diese Besprechung transkribiert wird.",dismissButtonAriaLabel:"Schließen"},recordingStopped:{title:"Aufzeichnung wird gespeichert.",message:"Aufzeichnung wurde beendet.",dismissButtonAriaLabel:"Schließen"},transcriptionStopped:{title:"Die Transkription wird gespeichert.",message:"Die Transkription wurde beendet.",dismissButtonAriaLabel:"Schließen"},recordingAndTranscriptionStarted:{title:"Die Aufzeichnung und Transkription haben begonnen.",message:"Durch Ihre Teilnahme stimmen Sie zu, dass diese Besprechung transkribiert wird.",dismissButtonAriaLabel:"Schließen"},recordingAndTranscriptionStopped:{title:"Aufzeichnung und Transkription werden gespeichert.",message:"Die Aufzeichnung und Transkription wurden beendet.",dismissButtonAriaLabel:"Schließen"},recordingStoppedStillTranscribing:{title:"Aufzeichnung wurde beendet.",message:"Sie transkribieren diese Besprechung jetzt nur noch.",dismissButtonAriaLabel:"Schließen"},transcriptionStoppedStillRecording:{title:"Die Transkription wurde beendet.",message:"Sie zeichnen nun nur diese Besprechung auf.",dismissButtonAriaLabel:"Schließen"},assignedBreakoutRoomOpened:{title:"Wir verschieben Sie in 5 Sekunden zu Ihrem zugewiesenen Raum.",dismissButtonAriaLabel:"Schließen"},assignedBreakoutRoomChanged:{title:"Ihr Gruppenraum hat sich geändert.",message:"Wir verschieben Sie in 5 Sekunden zu Ihrem zugewiesenen Raum.",dismissButtonAriaLabel:"Schließen"},assignedBreakoutRoomClosed:{title:"Ihr Gruppenraum wurde geschlossen.",message:"Wir bringen Sie in 5 Sekunden zurück zu Ihrer Besprechung.",dismissButtonAriaLabel:"Schließen"},assignedBreakoutRoomOpenedPromptJoin:{title:"Gruppenraum betreten?",message:"Sie wurden einem Gruppenraum zugewiesen.",dismissButtonAriaLabel:"Schließen",primaryButtonLabel:"Raum betreten",secondaryButtonLabel:"Später"},breakoutRoomJoined:{title:"Sie sind einem Gruppenraum beigetreten.",dismissButtonAriaLabel:"Schließen"},breakoutRoomClosingSoon:{title:"Das Raumzeitlimit läuft bald ab.",message:"Dieser Raum wird in 30 Sekunden geschlossen.",dismissButtonAriaLabel:"Schließen"},capabilityTurnVideoOnPresent:{title:"Ihre Kamera wurde aktiviert",message:"Aktivieren Sie diese, wenn Sie Video freigeben möchten.",dismissButtonAriaLabel:"Schließen"},capabilityTurnVideoOnAbsent:{title:"Ihre Kamera wurde deaktiviert.",message:"Sie können kein Video mehr freigeben.",dismissButtonAriaLabel:"Schließen"},capabilityUnmuteMicPresent:{title:"Ihr Mikrofon wurde aktiviert",message:"Wenn Sie sprechen möchten, heben Sie die Stummschaltung auf.",dismissButtonAriaLabel:"Schließen"},capabilityUnmuteMicAbsent:{title:"Ihr Mikro wurde deaktiviert",message:"Sie können die Stummschaltung nicht mehr aufheben.",dismissButtonAriaLabel:"Schließen"},togetherModeStarted:{title:"Der Togethermode wurde gestartet",dismissButtonAriaLabel:"Schließen"},togetherModeEnded:{title:"Der Togethermode wurde beendet",dismissButtonAriaLabel:"Schließen"}},videoGallery:{screenIsBeingSharedMessage:"Sie teilen Ihren Bildschirm",screenShareLoadingMessage:"Der Bildschirm von {participant} wird geladen",localScreenShareLoadingMessage:"Ihr Bildschirm wird geladen.",localVideoLabel:"Sie",localVideoCameraSwitcherLabel:"Kamera wechseln",localVideoMovementLabel:"Verschiebbare lokale Videokachel",localVideoMovementAriaLabel:"Verschiebbare lokale Videokachel",localVideoSelectedDescription:"{cameraName} ausgewählt",displayNamePlaceholder:"Teilnehmer ohne Namen",fitRemoteParticipantToFrame:"An Rahmen anpassen",fillRemoteParticipantFrame:"Rahmen ausfüllen",pinParticipantForMe:"Für mich anheften",pinParticipantForMeLimitReached:"Anheften (Limit erreicht)",unpinParticipantForMe:"Lösen",pinParticipantMenuItemAriaLabel:"{participantName} anheften",unpinParticipantMenuItemAriaLabel:"{participantName} lösen",pinnedParticipantAnnouncementAriaLabel:"{participantName} angeheftet",unpinnedParticipantAnnouncementAriaLabel:"{participantName} gelöst",startSpotlightVideoTileMenuLabel:"Spotlight für alle",addSpotlightVideoTileMenuLabel:"Spotlight hinzufügen",spotlightLimitReachedMenuTitle:"Spotlight-Limit erreicht",stopSpotlightVideoTileMenuLabel:"Spotlight beenden",stopSpotlightOnSelfVideoTileMenuLabel:"Spotlight beenden",attendeeRole:"Teilnehmer",muteParticipantMenuItemLabel:"Stummschalten",waitingScreenText:"Warten auf andere Teilnehmer",forbidAudio:"Mikro deaktivieren",permitAudio:"Mikrofon zulassen",forbidAudioTileMenuLabel:"Mikro deaktivieren",permitAudioTileMenuLabel:"Mikrofon zulassen",forbidVideo:"Kamera deaktivieren",permitVideo:"Kamera zulassen",forbidVideoTileMenuLabel:"Kamera deaktivieren",permitVideoTileMenuLabel:"Kamera zulassen"},dialpad:{placeholderText:"Telefonnummer eingeben",deleteButtonAriaLabel:"Löschen"},holdButton:{onLabel:"Fortsetzen",offLabel:"Halten",tooltipOnContent:"Anruf fortsetzen",tooltipOffContent:"Anruf halten"},videoTile:{participantStateRinging:"Anrufen...",participantReconnecting:"Verbindung wird wiederhergestellt...",participantStateHold:"In der Warteschleife",moreOptionsButtonAriaLabel:"Weitere Optionen {displayName} {isMuted} {micDisabledState} {cameraDisabledState} {isHandRaised} {state} {isSpeaking}",moreOptionsParticipantMutedStateMutedAriaLabel:"stummgeschaltet",moreOptionsParticipantMutedStateUnmutedAriaLabel:"Stummschaltung aufgehoben",moreOptionsParticipantHandRaisedAriaLabel:"Hand erhoben",moreOptionsParticipantIsSpeakingAriaLabel:"Sprechen",moreOptionsParticipantMicDisabledAriaLabel:"Mikrofon deaktiviert",moreOptionsParticipantCameraDisabledAriaLabel:"Kamera deaktiviert"},CameraAndMicrophoneSitePermissionsRequest:{primaryText:"Zulassen, dass {appName} Ihre Kamera und Ihr Mikrofon verwendet",secondaryText:"So können die Teilnehmer Sie sehen und hören.",linkText:"Benötigen Sie Hilfe? Hilfe zur Problembehandlung",primaryButtonText:"Ohne Kamera und Mikrofon fortfahren",ariaLabel:"Zugriff auf Kamera und Mikrofon zulassen"},CameraSitePermissionsRequest:{primaryText:"{appName} die Verwendung Ihrer Kamera erlauben",secondaryText:"So können die Teilnehmer Sie sehen.",linkText:"Benötigen Sie Hilfe? Hilfe zur Problembehandlung",primaryButtonText:"Ohne Kamera fortfahren",ariaLabel:"Kamerazugriff zulassen"},MicrophoneSitePermissionsRequest:{primaryText:"{appName} die Verwendung Ihres Mikrofons erlauben",secondaryText:"So können die Teilnehmer Sie hören.",linkText:"Benötigen Sie Hilfe? Hilfe zur Problembehandlung",primaryButtonText:"Ohne Mikrofon fortfahren",ariaLabel:"Mikrofonzugriff zulassen"},CameraAndMicrophoneSitePermissionsCheck:{primaryText:"Überprüfen des Kamera- und Mikrofonzugriffs",secondaryText:"Zugriff bei Aufforderung zulassen. Dies ist so, dass Teilnehmer Sie sehen und hören können.",linkText:"Benötigen Sie Hilfe? Hilfe zur Problembehandlung",primaryButtonText:"Ohne Kamera und Mikrofon fortfahren",ariaLabel:"Überprüfen des Kamera- und Mikrofonzugriffs. Erlauben Sie den Zugriff, wenn Sie aufgefordert werden."},CameraSitePermissionsCheck:{primaryText:"Überprüfung des Kamerazugriffs",secondaryText:"Zugriff bei Aufforderung zulassen. Dies ist so, dass Teilnehmer Sie sehen können.",linkText:"Benötigen Sie Hilfe? Hilfe zur Problembehandlung",primaryButtonText:"Ohne Kamera fortfahren",ariaLabel:"Überprüfen des Kamerazugriffs. Erlauben Sie den Zugriff, wenn Sie aufgefordert werden."},MicrophoneSitePermissionsCheck:{primaryText:"Überprüfen des Mikrofonzugriffs",secondaryText:"Zugriff bei Aufforderung zulassen. Dies ist so, dass Teilnehmer Sie hören können.",linkText:"Benötigen Sie Hilfe? Hilfe zur Problembehandlung",primaryButtonText:"Ohne Mikrofon fortfahren",ariaLabel:"Der Mikrofonzugriff wird überprüft. Erlauben Sie den Zugriff, wenn Sie aufgefordert werden."},CameraAndMicrophoneSitePermissionsDenied:{primaryText:"Auf Kamera und Mikrofon kann nicht zugegriffen werden",secondaryText:"Klicken Sie auf das Schlosssymbol in der Adressleiste, um dieser Webseite Mikrofonberechtigungen zu erteilen. Möglicherweise ist eine Seitenaktualisierung erforderlich.",primaryButtonText:"Ohne Kamera und Mikrofon fortfahren",linkText:"Benötigen Sie Hilfe? Hilfe zur Problembehandlung"},CameraAndMicrophoneSitePermissionsDeniedSafari:{primaryText:"Auf Kamera und Mikrofon kann nicht zugegriffen werden",secondaryText:"Aktualisieren Sie die Seite, um Berechtigungen zuzulassen, oder überprüfen Sie die Einstellungen dieses Browsers und stellen Sie sicher, dass die Berechtigungen für diese Website aktiviert sind.",primaryButtonText:"Ohne Kamera und Mikrofon fortfahren",linkText:"Benötigen Sie Hilfe? Hilfe zur Problembehandlung"},CameraSitePermissionsDenied:{primaryText:"Auf die Kamera kann nicht zugegriffen werden",secondaryText:"Klicken Sie auf das Schlosssymbol in der Adressleiste, um dieser Webseite Kameraberechtigungen zu erteilen. Möglicherweise ist eine Seitenaktualisierung erforderlich.",primaryButtonText:"Ohne Kamera fortfahren",linkText:"Benötigen Sie Hilfe? Hilfe zur Problembehandlung"},MicrophoneSitePermissionsDenied:{primaryText:"Auf das Mikrofon kann nicht zugegriffen werden",secondaryText:"Klicken Sie auf das Schlosssymbol in der Adressleiste, um dieser Webseite Mikrofonberechtigungen zu erteilen. Möglicherweise ist eine Seitenaktualisierung erforderlich.",primaryButtonText:"Ohne Mikrofon fortfahren",linkText:"Benötigen Sie Hilfe? Hilfe zur Problembehandlung"},CameraSitePermissionsDeniedSafari:{primaryText:"Auf die Kamera kann nicht zugegriffen werden",secondaryText:"Aktualisieren Sie die Seite, um Berechtigungen zuzulassen, oder überprüfen Sie die Einstellungen dieses Browsers und stellen Sie sicher, dass die Berechtigungen für diese Website aktiviert sind.",primaryButtonText:"Ohne Kamera fortfahren",linkText:"Benötigen Sie Hilfe? Hilfe zur Problembehandlung"},MicrophoneSitePermissionsDeniedSafari:{primaryText:"Auf das Mikrofon kann nicht zugegriffen werden",secondaryText:"Aktualisieren Sie die Seite, um Berechtigungen zuzulassen, oder überprüfen Sie die Einstellungen dieses Browsers und stellen Sie sicher, dass die Berechtigungen für diese Website aktiviert sind.",primaryButtonText:"Ohne Mikrofon fortfahren",linkText:"Benötigen Sie Hilfe? Hilfe zur Problembehandlung"},UnsupportedBrowser:{primaryText:"Der Browser wird nicht unterstützt.",secondaryText:"Bitte nehmen Sie über einen kompatiblen Browser an diesem Anruf teil.",moreHelpLinkText:"Kompatibilitätsanforderungen anzeigen"},UnsupportedBrowserVersion:{primaryText:"Browserupdate erforderlich",secondaryText:"Um einen optimalen Anruf zu gewährleisten, aktualisieren Sie Ihren Browser, und versuchen Sie dann erneut, an dem Anruf teilzunehmen.",moreHelpLinkText:"Kompatibilitätsanforderungen anzeigen",continueAnywayButtonText:"Anruf ohne Aktualisierung starten"},UnsupportedOperatingSystem:{primaryText:"Das Betriebssystem wird nicht unterstützt.",secondaryText:"Nehmen Sie an diesem Anruf teil, indem Sie ein Gerät mit einem kompatiblen Betriebssystem verwenden.",moreHelpLinkText:"Kompatibilitätsanforderungen anzeigen"},BrowserPermissionDenied:{primaryText:"Kamera oder Mikrofon kann nicht verwendet werden",secondaryText:"Ihr Browser hat möglicherweise keinen Zugriff auf Ihre Kamera oder Ihr Mikrofon. Öffnen Sie die Systemeinstellungen, um dieses Problem zu beheben.",primaryButtonText:"Erneut versuchen",linkText:"Benötigen Sie Hilfe? Hilfe zur Problembehandlung"},BrowserPermissionDeniedIOS:{primaryText:"Mikrofonzugriff zulassen, um fortzufahren",secondaryText:"Damit andere Teilnehmer Sie hören können.",primaryButtonText:"Erneut versuchen",imageAltText:"Berechtigungsspeicherort für Mikrofon- und Kamerageräte für iOS",linkText:"Benötigen Sie Hilfe? Hilfe zur Problembehandlung",step1Text:"Zur Einstellungs-App wechseln",step2Text:"Scrollen Sie nach unten zu den Einstellungen dieses Browsers",step3Text:"Mikrofon einschalten (Kamera optional)",step4Text:"Versuchen Sie erneut, dem Anruf beizutreten",step1DigitText:"1",step2DigitText:"2",step3DigitText:"3",step4DigitText:"4"},verticalGallery:{leftNavButtonAriaLabel:"vorherige Seite {current} von {total}",rightNavButtonAriaLabel:"nächste Seite {current} von {total}"},meetingConferencePhoneInfo:{meetingConferencePhoneInfoModalTitle:"Von Ihrem Telefon aus an Anruf teilnehmen",meetingConferencePhoneInfoModalDialIn:"Nummer wählen",meetingConferencePhoneInfoModalMeetingId:"Besprechungs-ID eingeben",meetingConferencePhoneInfoModalWait:"Warten Sie, bis sie vom Organisator zugelassen werden.",meetingConferencePhoneInfoModalNoPhoneAvailable:"Kein Telefon verfügbar",meetingConferencePhoneInfoModalTollGeoData:"{country}, {city}",meetingConferencePhoneInfoModalTollFree:"(Gebührenfrei)",meetingConferencePhoneInfoModalToll:"(Gebührenpflichtig)"},IncomingCallNotification:{incomingCallNotificationPlaceholderId:"Unbekannter Benutzer",incomingCallNotificationPlaceholderAlert:"{callerName} ruft an",incomingCallNoticicationAcceptWithAudioAriaLabel:"Mit Audio annehmen",incomingCallNoticicationAcceptWithVideoAriaLabel:"Mit Video annehmen",incomingCallNoticicationRejectAriaLabel:"Ablehnen",incomingCallNotificationAcceptButtonLabel:"Akzeptieren",incomingCallNotificationRejectButtonLabel:"Ablehnen",incomingCallNotificationAccceptWithVideoButtonLabel:"Mit Video annehmen",incomingCallNotificationDismissButtonAriaLabel:"Verwerfen"}})},cQt={strings:Jh({participantItem:{isMeText:"(tú)",menuTitle:"Más opciones",removeButtonLabel:"Quitar",sharingIconLabel:"Compartiendo",mutedIconLabel:"Silenciado",handRaisedIconLabel:"Mano levantada: posición {position}",displayNamePlaceholder:"Participante sin nombre",participantStateRinging:"Llamando...",participantStateHold:"En espera",participantItemAriaLabel:"{displayName}, {handRaisedState}, {mutedState}, {micDisabledState}, {cameraDisabledState}, {sharingState}, {connectionState}",participantItemWithMoreOptionsAriaLabel:"{displayName}, {handRaisedState}, {mutedState}, {micDisabledState}, {cameraDisabledState}, {sharingState}, {connectionState}, Más opciones",attendeeRole:"Asistente",micDisabledIconLabel:"Micophone deshabilitado",cameraDisabledIconLabel:"Cámara deshabilitada"},ParticipantList:{overflowParticipantCount:"+{overflowCount} más"},typingIndicator:{singleUser:"{user} está escribiendo...",multipleUsers:"{users} están escribiendo...",multipleUsersAbbreviateOne:"{users} y 1 usuario más están escribiendo...",multipleUsersAbbreviateMany:"{users} y {numOthers} usuarios más están escribiendo...",delimiter:", "},sendBox:{placeholderText:"Escribir un mensaje",textTooLong:"La longitud del mensaje supera el límite máximo.",sendButtonAriaLabel:"Enviar mensaje",attachmentUploadsPendingError:"El archivo se está cargando. Espere.",removeAttachment:"Quitar archivo",uploading:"Cargando",uploadCompleted:"Carga completada",attachmentMoreMenu:"Más opciones"},richTextSendBox:{placeholderText:"Escribir un mensaje",textTooLong:"La longitud del mensaje supera el límite máximo.",sendButtonAriaLabel:"Enviar mensaje",attachmentUploadsPendingError:"El archivo se está cargando. Espere.",imageUploadsPendingError:"La imagen se está cargando. Espere.",removeAttachment:"Quitar archivo",uploading:"Cargando",uploadCompleted:"Carga completada",richTextBoldTooltip:"Negrita",richTextItalicTooltip:"Cursiva",richTextUnderlineTooltip:"Subrayado",richTextBulletListTooltip:"Lista con viñetas",richTextNumberListTooltip:"Lista numerada",richTextIncreaseIndentTooltip:"Aumentar sangría",richTextDecreaseIndentTooltip:"Reducir sangría",richTextInsertTableTooltip:"Insertar tabla",richTextFormatButtonTooltip:"Formato",richTextInsertRowOrColumnMenu:"Insertar",richTextInsertTableMenuTitle:"Insertar {column} x {row} tabla",richTextInsertRowAboveMenu:"Insertar arriba",richTextInsertRowBelowMenu:"Insertar debajo",richTextInsertColumnLeftMenu:"Insertar a la izquierda",richTextInsertColumnRightMenu:"Insertar a la derecha",richTextDeleteRowOrColumnMenu:"Eliminar",richTextDeleteColumnMenu:"Eliminar columna",richTextDeleteRowMenu:"Eliminar fila",richTextDeleteTableMenu:"Eliminar tabla",richTextToolbarAriaLabel:"Barra de herramientas de formato de mensaje",richTextToolbarMoreButtonAriaLabel:"Más opciones",attachmentMoreMenu:"Más opciones",richTextNewBulletedListItemAnnouncement:"Viñeta, nueva línea",richTextNewNumberedListItemAnnouncement:"{0}, nueva línea",richTextBulletedListAppliedAnnouncement:"Lista con viñetas aplicada",richTextNumberedListAppliedAnnouncement:"Lista numerada aplicada"},realTimeTextModal:{realTimeTextModalAriaLabel:"Activar modal RTT",realTimeTextModalTitle:"¿Activar RTT?",realTimeTextModalText:"Se activará el texto en tiempo real (RTT) para todos los participantes de la reunión.",realTimeTextConfirmButtonLabel:"Activar",realTimeTextCancelButtonLabel:"Cancelar",realTimeTextCloseModalButtonAriaLabel:"Cerrar modal RTT"},captionsBanner:{captionsBannerSpinnerText:"Iniciando subtítulos...",realTimeTextInputBoxDefaultText:"Escribir un mensaje en tiempo real",realTimeTextInputErrorMessage:"El mensaje no puede exceder los 2000 caracteres",realTimeTextBannerTitle:"RTT",realTimeTextBannerContent:"RtT (texto en tiempo real) está habilitado para todos los participantes durante toda la reunión.",realTimeTextBannerLinkLabel:"Más información",captionsOnlyContainerTitle:"Subtítulos",realTimeTextOnlyContainerTitle:"Texto en tiempo real",captionsAndRealTimeTextContainerTitle:"Subtítulos y texto en tiempo real",expandButtonAriaLabel:"Expandir",minimizeButtonAriaLabel:"Contraer"},mentionPopover:{mentionPopoverHeader:"Sugerencias"},imageOverlay:{downloadButtonLabel:"Descargar",dismissButtonAriaLabel:"Cerrar",overlayVisibleMessage:"Superposición de detalles de imagen"},messageStatusIndicator:{deliveredAriaLabel:"Mensaje enviado",deliveredTooltipText:"Enviado",seenAriaLabel:"Mensaje visto por otros usuarios",seenTooltipText:"Visto",readByTooltipText:"Leído por {messageThreadReadCount} de {remoteParticipantsCount}",sendingAriaLabel:"Envío de mensajes",sendingTooltipText:"Enviando",failedToSendAriaLabel:"Error al enviar el mensaje",failedToSendTooltipText:"Error al enviar"},endCallButton:{label:"Baja",tooltipContent:"Abandonar llamada",leaveOption:"Salir",endCallOption:"Finalizar la llamada para todos"},cameraButton:{onLabel:"Cámara",offLabel:"Cámara",tooltipDisabledContent:"La cámara está deshabilitada",tooltipOnContent:"Desconectar la cámara",tooltipOffContent:"Activar la cámara",tooltipVideoLoadingContent:"El vídeo se está cargando",cameraMenuTitle:"Cámara",cameraMenuTooltip:"Elegir cámara",cameraButtonSplitRoleDescription:"Botón de expansión",onSplitButtonAriaLabel:"Desconectar la cámara",offSplitButtonAriaLabel:"Activar la cámara",cameraActionTurnedOnAnnouncement:"La cámara se ha activado",cameraActionTurnedOffAnnouncement:"La cámara se ha desactivado",onSplitButtonPrimaryActionCamera:"Desconectar la cámara",offSplitButtonPrimaryActionCamera:"Activar la cámara",cameraPrimaryActionSplitButtonTitle:"Usar cámara",videoEffectsMenuItemTitle:"Efectos",cameraButtonAriaDescription:"opciones de cámara"},microphoneButton:{onLabel:"Micro",offLabel:"Micro",tooltipDisabledContent:"Micrófono deshabilitado",tooltipOnContent:"Silenciar micrófono",tooltipOffContent:"Reactivar micrófono",microphoneMenuTitle:"Micrófono",microphoneMenuTooltip:"Elegir micrófono",speakerMenuTitle:"Altavoz",speakerMenuTooltip:"Elegir altavoz",microphoneButtonSplitRoleDescription:"Botón de expansión",onSplitButtonAriaLabel:"Desactivar audio del micrófono",offSplitButtonAriaLabel:"Reactivar audio del micrófono",microphoneActionTurnedOnAnnouncement:"El micrófono se ha activado",microphoneActionTurnedOffAnnouncement:"El micrófono se ha desactivado",offSplitButtonMicrophonePrimaryAction:"Reactivar audio del micrófono",onSplitButtonMicrophonePrimaryAction:"Desactivar audio del micrófono",microphonePrimaryActionSplitButtonTitle:"Usar micrófono",microphoneAriaDescription:"Opciones de audio",deepNoiseSuppressionTitle:"Supresión de ruido",deepNoiseSuppressionOnAnnouncement:"Se ha activado la supresión profunda de ruido",deepNoiseSuppressionOffAnnouncement:"Se ha desactivado la supresión profunda de ruido"},devicesButton:{label:"Dispositivos",tooltipContent:"Administrar dispositivos",cameraMenuTitle:"Cámara",cameraMenuTooltip:"Elegir cámara",audioDeviceMenuTitle:"Dispositivo de audio",audioDeviceMenuTooltip:"Elegir dispositivo de audio",microphoneMenuTitle:"Micrófono",microphoneMenuTooltip:"Elegir micrófono",speakerMenuTitle:"Altavoz",speakerMenuTooltip:"Elegir altavoz"},participantsButton:{label:"Contactos",ariaLabel:"Personas",tooltipContent:"Mostrar participantes",menuHeader:"En esta llamada",participantsListButtonLabel:"{numParticipants} personas",muteAllButtonLabel:"Silenciar a todos",copyInviteLinkButtonLabel:"Copiar vínculo de invitación",copyInviteLinkActionedAriaLabel:"Vínculo de invitación copiado"},screenShareButton:{onLabel:"Dejar de presentar",offLabel:"Presentar",tooltipDisabledContent:"La presentación está deshabilitada",tooltipOnContent:"Presentando su pantalla",tooltipOffContent:"Presentar la pantalla"},raiseHandButton:{offLabel:"Participar",onLabel:"Bajar",tooltipDisabledContent:"La acción Levantar la mano está deshabilitada",tooltipOnContent:"Bajar la mano",tooltipOffContent:"Levantar la mano"},reactionButton:{label:"Reaccionar",ariaLabel:"Reaccionar",tooltipDisabledContent:"La acción de reacción está deshabilitada",tooltipContent:"Enviar una reacción",likeReactionTooltipContent:"Me gusta",heartReactionTooltipContent:"Amor",laughReactionTooltipContent:"Risa",applauseReactionTooltipContent:"Aplauso",surprisedReactionTooltipContent:"Sorprendido"},realTimeText:{isTypingText:"Escritura en tiempo real"},captionsSettingsModal:{captionsSettingsModalTitle:"Configuración de subtítulos",captionsSettingsSpokenLanguageDropdownLabel:"Idioma hablado",captionsSettingsCaptionLanguageDropdownLabel:"Idioma de subtítulos",captionsSettingsSpokenLanguageDropdownInfoText:"Idioma en el que están hablando todos los usuarios de esta llamada.",captionsSettingsCaptionLanguageDropdownInfoText:"Los subtítulos aparecerán en este idioma.",captionsSettingsConfirmButtonLabel:"Confirmar",captionsSettingsCancelButtonLabel:"Cancelar",captionsSettingsModalAriaLabel:"Configuración modal de subtítulos",captionsSettingsCloseModalButtonAriaLabel:"Cerrar configuración de subtítulos"},spokenLanguages:{"ar-ae":"Árabe - Emiratos Árabes Unidos","ar-sa":"Árabe (Arabia Saudí)","da-dk":"Danés","de-de":"Alemán (Alemania)","en-au":"Inglés (Australia)","en-ca":"Inglés (Canadá)","en-gb":"Inglés (Reino Unido)","en-in":"Inglés (India)","en-nz":"Inglés (Nueva Zelanda)","en-us":"Inglés (Estados Unidos)","es-es":"Español - España (alfabetización internacional)","es-mx":"Español (México)","fi-fi":"Finés","fr-ca":"Francés (Canadá)","fr-fr":"Francés (Francia)","hi-in":"Hindi","it-it":"Italiano (Italia)","ja-jp":"Japonés","ko-kr":"Coreano","nb-no":"Noruego (Bokmål)","nl-be":"Neerlandés (Bélgica)","nl-nl":"Neerlandés (Países Bajos)","pl-pl":"Polaco","pt-br":"Portugués (Brasil)","ru-ru":"Ruso","sv-se":"Sueco","zh-cn":"Chino - República Popular China","zh-hk":"Chino (RAE de Hong Kong)","cs-cz":"Checo","pt-pt":"Portugués (Portugal)","tr-tr":"Turco","vi-vn":"Vietnamita","th-th":"Tailandés","he-il":"Hebreo","cy-gb":"Galés","uk-ua":"Ucraniano","el-gr":"Griego","hu-hu":"Húngaro","ro-ro":"Rumano","sk-sk":"Eslovaco","zh-tw":"Chino (Taiwán)"},captionLanguages:{ar:"Árabe",da:"Danés",de:"Alemán",en:"Inglés",es:"Español",fi:"Finés","fr-ca":"Francés (Canadá)",fr:"Francés (Francia)",hi:"Hindi",it:"Italiano",ja:"Japonés",ko:"Coreano",nb:"Noruego (Bokmål)",nl:"Neerlandés",pl:"Polaco",pt:"Portugués (Brasil)",ru:"Ruso",sv:"Sueco","zh-Hans":"Chino (simplificado)","zh-Hant":"Chino (tradicional)",cs:"Checo","pt-pt":"Portugués (Portugal)",tr:"Turco",vi:"Vietnamita",th:"Tailandés",he:"Hebreo",cy:"Galés",uk:"Ucraniano",el:"Griego",hu:"Húngaro",ro:"Rumano",sk:"Eslovaco"},startCaptionsButton:{onLabel:"Activar subtítulos",offLabel:"Desactivar subtítulos",tooltipOnContent:"Desactivar subtítulos",tooltipOffContent:"Activar subtítulos"},startRealTimeTextButton:{label:"Activar RTT para esta llamada",tooltipOffContent:"Activar RTT para esta llamada"},messageThread:{yesterday:"Ayer",sunday:"Domingo",monday:"Lunes",tuesday:"Martes",wednesday:"Miércoles",thursday:"Jueves",friday:"Viernes",saturday:"Sábado",participantJoined:"se unió al chat.",participantLeft:"abandonó el chat.",editMessage:"Editar",removeMessage:"Eliminar",resendMessage:"Intente enviar de nuevo",failToSendTag:"Error al enviar",editedTag:"Editado",liveAuthorIntro:"Mensaje de {author}",editedMessageLiveAuthorIntro:"Mensaje editado de {author}",editedMessageLocalUserLiveAuthorIntro:"Mensaje editado",messageContentAriaText:"{status} {author} dijo {message}",messageContentMineAriaText:"{status} Usted dijo {message}",editBoxTextLimit:"El mensaje supera el límite de {limitNumber} caracteres",editBoxPlaceholderText:"Editar el mensaje",newMessagesIndicator:"Mensajes nuevos",noDisplayNameSub:"Sin nombre",editBoxCancelButton:"Cancelar",editBoxSubmitButton:"Listo",messageReadCount:"Leído por {messageReadByCount} de {remoteParticipantsCount}",actionMenuMoreOptions:"Más opciones",downloadAttachment:"Descargar archivo",openAttachment:"Abrir archivo",blockedWarningText:"Este mensaje se eliminó debido a la directiva de la organización.",blockedWarningLinkText:"Detalles",attachmentCardGroupMessage:"El mensaje tiene {attachmentCount} archivo adjunto",messageDeletedAnnouncementAriaLabel:"El mensaje se ha eliminado",richTextBoldTooltip:"Negrita",richTextItalicTooltip:"Cursiva",richTextUnderlineTooltip:"Subrayado",richTextBulletListTooltip:"Lista con viñetas",richTextNumberListTooltip:"Lista numerada",richTextIncreaseIndentTooltip:"Aumentar sangría",richTextDecreaseIndentTooltip:"Reducir sangría",richTextInsertTableTooltip:"Insertar tabla",richTextFormatButtonTooltip:"Formato",richTextInsertRowOrColumnMenu:"Insertar",richTextInsertTableMenuTitle:"Insertar {column} x {row} tabla",richTextInsertRowAboveMenu:"Insertar arriba",richTextInsertRowBelowMenu:"Insertar debajo",richTextInsertColumnLeftMenu:"Insertar a la izquierda",richTextInsertColumnRightMenu:"Insertar a la derecha",richTextDeleteRowOrColumnMenu:"Eliminar",richTextDeleteColumnMenu:"Eliminar columna",richTextDeleteRowMenu:"Eliminar fila",richTextDeleteTableMenu:"Eliminar tabla",richTextToolbarMoreButtonAriaLabel:"Más opciones",attachmentUploadsPendingError:"El archivo se está cargando. Espere.",imageUploadsPendingError:"La imagen se está cargando. Espere.",richTextNewBulletedListItemAnnouncement:"Viñeta, nueva línea",richTextNewNumberedListItemAnnouncement:"{0}, nueva línea",richTextBulletedListAppliedAnnouncement:"Lista con viñetas aplicada",richTextNumberedListAppliedAnnouncement:"Lista numerada aplicada"},errorBar:{unableToReachChatService:"Sin conexión",accessDenied:"No se puede acceder a los servicios de chat. Compruebe las credenciales de usuario proporcionadas.",userNotInChatThread:"Ya no está en este hilo de chat",sendMessageNotInChatThread:"No se pudo enviar el mensaje porque ya no está en este hilo de chat",sendMessageGeneric:"Error al enviar el mensaje",callingNetworkFailure:"Problema al conectar la llamada; parece que no hay conexión",startVideoGeneric:"No se pudo iniciar el vídeo",stopVideoGeneric:"No se pudo detener el vídeo",muteGeneric:"No se pudo silenciar el micrófono",unmuteGeneric:"No se pudo reactivar el micrófono",speakingWhileMuted:"El micrófono está desactivado",startScreenShareGeneric:"Hubo un problema al iniciar la pantalla compartida.",stopScreenShareGeneric:"No se pudo detener la pantalla compartida",callNetworkQualityLow:"La calidad de la red es baja.",teamsMeetingCallNetworkQualityLow:"La calidad de la red es baja.",callNoSpeakerFound:"No se encontraron altavoces ni auriculares. Conecta un dispositivo de audio para escuchar la llamada.",callNoMicrophoneFound:"No se encontraron micrófonos. Conecta un dispositivo de entrada de audio.",callMicrophoneAccessDenied:"No se puede acceder al micrófono. Haga clic en el bloqueo de la barra de direcciones para conceder permiso a esta página web.",callMicrophoneAccessDeniedSafari:"No se puede acceder al micrófono. Actualice la página para permitir permisos o compruebe la configuración de este explorador y compruebe que los permisos estén habilitados para este sitio web.",callMicrophoneMutedBySystem:"Su sistema ha silenciado su audio.",callMicrophoneUnmutedBySystem:"Su micrófono se ha recuperado y el sistema ha activado el audio.",callMacOsMicrophoneAccessDenied:"No se puede acceder al micrófono. Conceda permiso al micrófono en la configuración de privacidad de macOS.",callLocalVideoFreeze:"El ancho de banda de red es deficiente. Es posible que el vídeo aparezca pausado para otros usuarios en la llamada.",callCameraAccessDenied:"No se puede acceder a la cámara. Haga clic en el bloqueo de la barra de direcciones para conceder permiso a esta página web.",callCameraAccessDeniedSafari:"No se puede acceder a la cámara. Actualice la página para permitir permisos o compruebe la configuración de este explorador y compruebe que los permisos estén habilitados para este sitio web.",callCameraAlreadyInUse:"No se puede acceder a la cámara. Puede que ya la esté usando otra aplicación.",callVideoStoppedBySystem:"El sistema ha detenido el vídeo.",callVideoRecoveredBySystem:"El vídeo se ha reanudado.",callMacOsCameraAccessDenied:"MacOS está bloqueando el acceso a la cámara. Actualiza la configuración de privacidad para permitir que este explorador acceda a la cámara.",callMacOsScreenShareAccessDenied:"MacOS está bloqueando el uso compartido de la pantalla. Actualice la configuración de privacidad para permitir que este explorador grabe la pantalla.",dismissButtonAriaLabel:"Cerrar",failedToJoinCallGeneric:"No se pudo unir a la llamada.",failedToJoinCallInvalidMeetingLink:"No se puede unir a la reunión. Vínculo no válido.",cameraFrozenForRemoteParticipants:"Los usuarios de la llamada tienen problemas para ver el vídeo. Compruebe los dispositivos y la red.",unableToStartVideoEffect:"No se puede aplicar el efecto de vídeo.",startSpotlightWhileMaxParticipantsAreSpotlighted:"No se puede iniciar el primer plano en los participantes porque el número máximo de participantes ya está puesto en primer plano.",mutedByRemoteParticipant:"Otro participante lo ha silenciado."},notificationStack:{callingNetworkFailure:{title:"Llamada de conexión perturbadora",message:"Parece que estás desconectado. Compruebe la conexión de red e inténtelo de nuevo.",dismissButtonAriaLabel:"Cerrar"},startVideoGeneric:{title:"No se pudo iniciar el vídeo.",dismissButtonAriaLabel:"Cerrar"},stopVideoGeneric:{title:"No se pudo detener el vídeo.",dismissButtonAriaLabel:"Cerrar"},muteGeneric:{title:"No se pudo silenciar el micrófono.",dismissButtonAriaLabel:"Cerrar"},unmuteGeneric:{title:"No se pudo reactivar el micrófono.",dismissButtonAriaLabel:"Cerrar"},speakingWhileMuted:{title:"Estás silenciado.",dismissButtonAriaLabel:"Cerrar"},startScreenShareGeneric:{title:"Hubo un problema al iniciar la pantalla compartida.",dismissButtonAriaLabel:"Cerrar"},stopScreenShareGeneric:{title:"No se pudo detener la pantalla compartida.",dismissButtonAriaLabel:"Cerrar"},callNetworkQualityLow:{title:"La calidad de la red es baja.",dismissButtonAriaLabel:"Cerrar"},teamsMeetingCallNetworkQualityLow:{title:"La calidad de la red es baja.",dismissButtonAriaLabel:"Cerrar",message:"Únete a esta llamada desde el teléfono para obtener un mejor sonido. Puede seguir viendo la reunión en este dispositivo.",primaryButtonLabel:"Unirse por Teléfono"},callNoSpeakerFound:{title:"No se encontraron altavoces ni auriculares",message:"Conecta un dispositivo de audio para escuchar la llamada.",dismissButtonAriaLabel:"Cerrar"},callNoMicrophoneFound:{title:"No se han encontrado micrófonos",message:"Conecta un dispositivo de entrada de audio.",dismissButtonAriaLabel:"Cerrar"},callMicrophoneAccessDenied:{title:"No se puede acceder al micrófono",message:"Haga clic en el bloqueo de la barra de direcciones para conceder permiso a esta página web.",dismissButtonAriaLabel:"Cerrar"},callMicrophoneAccessDeniedSafari:{title:"No se puede acceder al micrófono",message:"Actualice la página para permitir permisos o compruebe la configuración de este explorador y compruebe que los permisos estén habilitados para este sitio web.",dismissButtonAriaLabel:"Cerrar"},callMicrophoneMutedBySystem:{title:"Su sistema ha silenciado su audio.",dismissButtonAriaLabel:"Cerrar"},callMicrophoneUnmutedBySystem:{title:"Su micrófono se ha recuperado y el sistema ha activado el audio.",dismissButtonAriaLabel:"Cerrar"},callMacOsMicrophoneAccessDenied:{title:"No se puede acceder al micrófono",message:"Conceda permiso al micrófono en la configuración de privacidad de macOS.",dismissButtonAriaLabel:"Cerrar"},callLocalVideoFreeze:{title:"El ancho de banda de red es deficiente",message:"Es posible que el vídeo aparezca pausado para otros usuarios en la llamada.",dismissButtonAriaLabel:"Cerrar"},callCameraAccessDenied:{title:"No se puede acceder a la cámara",message:"Haga clic en el bloqueo de la barra de direcciones para conceder permiso a esta página web.",dismissButtonAriaLabel:"Cerrar"},callCameraAccessDeniedSafari:{title:"No se puede acceder a la cámara",message:"Actualice la página para permitir permisos o compruebe la configuración de este explorador y compruebe que los permisos estén habilitados para este sitio web.",dismissButtonAriaLabel:"Cerrar"},callCameraAlreadyInUse:{title:"No se puede acceder a la cámara",message:"Puede que ya la esté usando otra aplicación.",dismissButtonAriaLabel:"Cerrar"},callVideoStoppedBySystem:{title:"El sistema ha detenido el vídeo.",dismissButtonAriaLabel:"Cerrar"},callVideoRecoveredBySystem:{title:"El vídeo se ha reanudado.",dismissButtonAriaLabel:"Cerrar"},callMacOsCameraAccessDenied:{title:"MacOS está bloqueando el acceso a la cámara",message:"Actualiza la configuración de privacidad para permitir que este explorador acceda a la cámara.",dismissButtonAriaLabel:"Cerrar"},callMacOsScreenShareAccessDenied:{title:"MacOS está bloqueando la pantalla compartida",message:"Actualice la configuración de privacidad para permitir que este explorador grabe la pantalla.",dismissButtonAriaLabel:"Cerrar"},failedToJoinCallGeneric:{title:"No se pudo unir a la llamada.",dismissButtonAriaLabel:"Cerrar"},failedToJoinCallInvalidMeetingLink:{title:"No se puede unir a la reunión. Vínculo no válido.",dismissButtonAriaLabel:"Cerrar"},cameraFrozenForRemoteParticipants:{title:"Los usuarios de la llamada tienen problemas para ver el vídeo",message:"Compruebe los dispositivos y la red.",dismissButtonAriaLabel:"Cerrar"},unableToStartVideoEffect:{title:"No se puede aplicar el efecto de vídeo.",dismissButtonAriaLabel:"Cerrar"},startSpotlightWhileMaxParticipantsAreSpotlighted:{title:"No se puede poner primer plano a los participantes",message:"Ya está puesto en primer plano el número máximo de participantes.",dismissButtonAriaLabel:"Cerrar"},mutedByRemoteParticipant:{title:"Otro participante lo ha silenciado.",dismissButtonAriaLabel:"Cerrar"},recordingStarted:{title:"La grabación se ha iniciado.",message:"Al unirse, da su consentimiento para que se transcriba esta reunión.",dismissButtonAriaLabel:"Cerrar"},transcriptionStarted:{title:"La transcripción se ha iniciado.",message:"Al unirse, da su consentimiento para que se transcriba esta reunión.",dismissButtonAriaLabel:"Cerrar"},recordingStopped:{title:"La grabación se está guardando.",message:"La grabación se ha detenido.",dismissButtonAriaLabel:"Cerrar"},transcriptionStopped:{title:"Se está guardando la transcripción.",message:"La transcripción se ha detenido.",dismissButtonAriaLabel:"Cerrar"},recordingAndTranscriptionStarted:{title:"Se han iniciado la grabación y la transcripción.",message:"Al unirse, da su consentimiento para que se transcriba esta reunión.",dismissButtonAriaLabel:"Cerrar"},recordingAndTranscriptionStopped:{title:"Se están guardando la grabación y la transcripción.",message:"Se han detenido la grabación y la transcripción.",dismissButtonAriaLabel:"Cerrar"},recordingStoppedStillTranscribing:{title:"La grabación se ha detenido.",message:"Solo está transcribiendo esta reunión.",dismissButtonAriaLabel:"Cerrar"},transcriptionStoppedStillRecording:{title:"La transcripción se ha detenido.",message:"Solo está grabando esta reunión.",dismissButtonAriaLabel:"Cerrar"},assignedBreakoutRoomOpened:{title:"Le moveremos a la sala asignada en 5 segundos.",dismissButtonAriaLabel:"Cerrar"},assignedBreakoutRoomChanged:{title:"La sala para sesión de subgrupo ha cambiado",message:"Le moveremos a la sala asignada en 5 segundos.",dismissButtonAriaLabel:"Cerrar"},assignedBreakoutRoomClosed:{title:"La sala para sesión de subgrupo se ha cerrado",message:"Volveremos a la reunión en 5 segundos.",dismissButtonAriaLabel:"Cerrar"},assignedBreakoutRoomOpenedPromptJoin:{title:"¿Quiere unirse a la sala para sesión de subgrupo?",message:"Se le ha asignado a una sala para sesión de subgrupo.",dismissButtonAriaLabel:"Cerrar",primaryButtonLabel:"Unirse a la sala",secondaryButtonLabel:"Más tarde"},breakoutRoomJoined:{title:"Se ha unido a una sala para sesión de subgrupo.",dismissButtonAriaLabel:"Cerrar"},breakoutRoomClosingSoon:{title:"Límite de tiempo de sala a punto de expirar.",message:"Esta sala se cerrará en 30 segundos",dismissButtonAriaLabel:"Cerrar"},capabilityTurnVideoOnPresent:{title:"La cámara se ha habilitado",message:"Active esta opción si quiere compartir vídeo.",dismissButtonAriaLabel:"Cerrar"},capabilityTurnVideoOnAbsent:{title:"Se deshabilitó la cámara",message:"Ya no puede compartir vídeo.",dismissButtonAriaLabel:"Cerrar"},capabilityUnmuteMicPresent:{title:"El micrófono se ha habilitado",message:"Reactive el audio si quiere hablar.",dismissButtonAriaLabel:"Cerrar"},capabilityUnmuteMicAbsent:{title:"El micro se ha deshabilitado.",message:"Ya no puede activar el audio.",dismissButtonAriaLabel:"Cerrar"},togetherModeStarted:{title:"El modo de colaboración se ha iniciado",dismissButtonAriaLabel:"Cerrar"},togetherModeEnded:{title:"El modo de colaboración ha finalizado",dismissButtonAriaLabel:"Cerrar"}},videoGallery:{screenIsBeingSharedMessage:"Está compartiendo su pantalla",screenShareLoadingMessage:"Cargando la pantalla de {participant}",localScreenShareLoadingMessage:"Cargando la pantalla",localVideoLabel:"Tú",localVideoCameraSwitcherLabel:"Cambiar de cámara",localVideoMovementLabel:"Mosaico de vídeo local movible",localVideoMovementAriaLabel:"Mosaico de vídeo local movible",localVideoSelectedDescription:"{cameraName} seleccionada",displayNamePlaceholder:"Participante sin nombre",fitRemoteParticipantToFrame:"Ajustar al marco",fillRemoteParticipantFrame:"Marco de relleno",pinParticipantForMe:"Anclar para mí",pinParticipantForMeLimitReached:"Pin (límite alcanzado)",unpinParticipantForMe:"Desanclar",pinParticipantMenuItemAriaLabel:"Anclar {participantName}",unpinParticipantMenuItemAriaLabel:"Desanclar {participantName}",pinnedParticipantAnnouncementAriaLabel:"{participantName} anclado",unpinnedParticipantAnnouncementAriaLabel:"{participantName} desanclado",startSpotlightVideoTileMenuLabel:"Poner en primer plano para todos",addSpotlightVideoTileMenuLabel:"Agregar primer plano",spotlightLimitReachedMenuTitle:"Se alcanzó el límite de primer plano",stopSpotlightVideoTileMenuLabel:"Dejar de poner en primer plano",stopSpotlightOnSelfVideoTileMenuLabel:"Primer plano",attendeeRole:"Asistente",muteParticipantMenuItemLabel:"Silenciar",waitingScreenText:"Esperando a que se unan otros usuarios",forbidAudio:"Deshabilitar micrófono",permitAudio:"Permitir micrófono",forbidAudioTileMenuLabel:"Deshabilitar micrófono",permitAudioTileMenuLabel:"Permitir micrófono",forbidVideo:"Deshabilitar cámara",permitVideo:"Permitir cámara",forbidVideoTileMenuLabel:"Deshabilitar cámara",permitVideoTileMenuLabel:"Permitir cámara"},dialpad:{placeholderText:"Introduzca el número de teléfono",deleteButtonAriaLabel:"Eliminar"},holdButton:{onLabel:"Reanudar",offLabel:"En espera",tooltipOnContent:"Reanudar llamada",tooltipOffContent:"Poner llamada en espera"},videoTile:{participantStateRinging:"Llamando...",participantReconnecting:"Reconectando...",participantStateHold:"En espera",moreOptionsButtonAriaLabel:"Más opciones {displayName} {isMuted} {micDisabledState} {cameraDisabledState} {isHandRaised} {state} {isSpeaking}",moreOptionsParticipantMutedStateMutedAriaLabel:"audio desactivado",moreOptionsParticipantMutedStateUnmutedAriaLabel:"se reactivaron las notificaciones",moreOptionsParticipantHandRaisedAriaLabel:"Mano levantada",moreOptionsParticipantIsSpeakingAriaLabel:"Hablando",moreOptionsParticipantMicDisabledAriaLabel:"Micrófono deshabilitado",moreOptionsParticipantCameraDisabledAriaLabel:"Cámara deshabilitada"},CameraAndMicrophoneSitePermissionsRequest:{primaryText:"Permitir que {appName} usen la cámara y el micrófono",secondaryText:"Esto es para que los participantes puedan verle y oírle.",linkText:"¿Necesitas ayuda? Obtén ayuda para la solución de problemas",primaryButtonText:"Continuar sin cámara ni micrófono",ariaLabel:"Permitir el acceso a la cámara y al micrófono"},CameraSitePermissionsRequest:{primaryText:"Permitir que {appName} use la cámara",secondaryText:"Esto sirve para que los participantes puedan verle.",linkText:"¿Necesitas ayuda? Obtén ayuda para la solución de problemas",primaryButtonText:"Continuar sin cámara",ariaLabel:"Permitir el acceso a la cámara"},MicrophoneSitePermissionsRequest:{primaryText:"Permitir que {appName} use el micrófono",secondaryText:"Esto sirve para que los participantes puedan oírle.",linkText:"¿Necesitas ayuda? Obtén ayuda para la solución de problemas",primaryButtonText:"Continuar sin micrófono",ariaLabel:"Permitir el acceso al micrófono"},CameraAndMicrophoneSitePermissionsCheck:{primaryText:"Comprobando el acceso a la cámara y al micrófono",secondaryText:"Permitir el acceso si se le solicita. Esto es para que los participantes puedan verle y oírle.",linkText:"¿Necesitas ayuda? Obtén ayuda para la solución de problemas",primaryButtonText:"Continuar sin cámara ni micrófono",ariaLabel:"Comprobando el acceso a la cámara y al micrófono. Permitir el acceso si se le solicita."},CameraSitePermissionsCheck:{primaryText:"Comprobando el acceso a la cámara",secondaryText:"Permitir el acceso si se le solicita. Esto es para que los participantes puedan verlo.",linkText:"¿Necesitas ayuda? Obtén ayuda para la solución de problemas",primaryButtonText:"Continuar sin cámara",ariaLabel:"Comprobando el acceso a la cámara. Permitir el acceso si se le solicita."},MicrophoneSitePermissionsCheck:{primaryText:"Comprobando el acceso al micrófono",secondaryText:"Permitir el acceso si se le solicita. Esto es para que los participantes puedan oírle.",linkText:"¿Necesitas ayuda? Obtén ayuda para la solución de problemas",primaryButtonText:"Continuar sin micrófono",ariaLabel:"Comprobando el acceso al micrófono. Permitir el acceso si se le solicita."},CameraAndMicrophoneSitePermissionsDenied:{primaryText:"No se puede permitir el acceso a la cámara ni al micrófono.",secondaryText:"Haga clic en el icono de bloqueo de la barra de direcciones para conceder permisos de micrófono a esta página web. Es posible que sea necesario actualizar la página.",primaryButtonText:"Continuar sin cámara ni micrófono",linkText:"¿Necesitas ayuda? Obtén ayuda para la solución de problemas"},CameraAndMicrophoneSitePermissionsDeniedSafari:{primaryText:"No se puede permitir el acceso a la cámara ni al micrófono.",secondaryText:"Actualice la página para permitir permisos o compruebe la configuración de este explorador y compruebe que los permisos estén habilitados para este sitio web.",primaryButtonText:"Continuar sin cámara ni micrófono",linkText:"¿Necesitas ayuda? Obtén ayuda para la solución de problemas"},CameraSitePermissionsDenied:{primaryText:"No se puede acceder a la cámara",secondaryText:"Haga clic en el icono de bloqueo de la barra de direcciones para conceder permisos de cámara a esta página web. Es posible que sea necesario actualizar la página.",primaryButtonText:"Continuar sin cámara",linkText:"¿Necesitas ayuda? Obtén ayuda para la solución de problemas"},MicrophoneSitePermissionsDenied:{primaryText:"No se puede acceder al micrófono.",secondaryText:"Haga clic en el icono de bloqueo de la barra de direcciones para conceder permisos de micrófono a esta página web. Es posible que sea necesario actualizar la página.",primaryButtonText:"Continuar sin micrófono",linkText:"¿Necesitas ayuda? Obtén ayuda para la solución de problemas"},CameraSitePermissionsDeniedSafari:{primaryText:"No se puede acceder a la cámara.",secondaryText:"Actualice la página para permitir permisos o compruebe la configuración de este explorador y compruebe que los permisos estén habilitados para este sitio web.",primaryButtonText:"Continuar sin cámara",linkText:"¿Necesitas ayuda? Obtén ayuda para la solución de problemas"},MicrophoneSitePermissionsDeniedSafari:{primaryText:"No se puede acceder al micrófono",secondaryText:"Actualice la página para permitir permisos o compruebe la configuración de este explorador y compruebe que los permisos estén habilitados para este sitio web.",primaryButtonText:"Continuar sin micrófono",linkText:"¿Necesitas ayuda? Obtén ayuda para la solución de problemas"},UnsupportedBrowser:{primaryText:"Explorador no compatible",secondaryText:"Únase a esta llamada con un explorador compatible.",moreHelpLinkText:"Ver los requisitos de compatibilidad"},UnsupportedBrowserVersion:{primaryText:"Es necesario actualizar el explorador",secondaryText:"Para garantizar la mejor llamada posible, actualice el explorador e intente unirse de nuevo a la llamada.",moreHelpLinkText:"Ver los requisitos de compatibilidad",continueAnywayButtonText:"Iniciar llamada sin actualizar"},UnsupportedOperatingSystem:{primaryText:"Sistema operativo no compatible",secondaryText:"Únase a esta llamada con un dispositivo con un sistema operativo compatible.",moreHelpLinkText:"Ver los requisitos de compatibilidad"},BrowserPermissionDenied:{primaryText:"No se puede usar la cámara o el micrófono",secondaryText:"Es posible que el explorador no tenga acceso a la cámara o al micrófono. Para solucionar este problema, abra Preferencias del sistema.",primaryButtonText:"Intentar de nuevo",linkText:"¿Necesitas ayuda? Obtén ayuda para la solución de problemas"},BrowserPermissionDeniedIOS:{primaryText:"Permite el acceso al micrófono para continuar",secondaryText:"Para que otros participantes puedan oírte.",primaryButtonText:"Intentar de nuevo",imageAltText:"Ubicación de permisos del dispositivo de micrófono y cámara para iOS",linkText:"¿Necesitas ayuda? Obtén ayuda para la solución de problemas",step1Text:"Ve a la aplicación de Configuración",step2Text:"Desplázate hacia abajo hasta la configuración de este explorador",step3Text:"Activar micrófono (cámara opcional)",step4Text:"Intenta unirte de nuevo a la llamada",step1DigitText:"1",step2DigitText:"2",step3DigitText:"3",step4DigitText:"4"},verticalGallery:{leftNavButtonAriaLabel:"página anterior {current} de {total}",rightNavButtonAriaLabel:"página siguiente {current} de {total}"},meetingConferencePhoneInfo:{meetingConferencePhoneInfoModalTitle:"Unirse a la llamada desde el teléfono",meetingConferencePhoneInfoModalDialIn:"Marcar número",meetingConferencePhoneInfoModalMeetingId:"Escribir el id. de reunión",meetingConferencePhoneInfoModalWait:"Esperar a ser admitido por el organizador",meetingConferencePhoneInfoModalNoPhoneAvailable:"No hay teléfono disponible",meetingConferencePhoneInfoModalTollGeoData:"{country}, {city}",meetingConferencePhoneInfoModalTollFree:"(Número gratuito)",meetingConferencePhoneInfoModalToll:"(Número de pago)"},IncomingCallNotification:{incomingCallNotificationPlaceholderId:"Usuario desconocido",incomingCallNotificationPlaceholderAlert:"{callerName} está llamando",incomingCallNoticicationAcceptWithAudioAriaLabel:"Aceptar con audio",incomingCallNoticicationAcceptWithVideoAriaLabel:"Aceptar con vídeo",incomingCallNoticicationRejectAriaLabel:"Rechazar",incomingCallNotificationAcceptButtonLabel:"Aceptar",incomingCallNotificationRejectButtonLabel:"Rechazar",incomingCallNotificationAccceptWithVideoButtonLabel:"Aceptar con vídeo",incomingCallNotificationDismissButtonAriaLabel:"Descartar"}})},dQt={strings:Jh({participantItem:{isMeText:"(tú)",menuTitle:"Más opciones",removeButtonLabel:"Quitar",sharingIconLabel:"Compartiendo",mutedIconLabel:"Silenciado",handRaisedIconLabel:"Mano levantada: posición {position}",displayNamePlaceholder:"Participante sin nombre",participantStateRinging:"Llamando...",participantStateHold:"En espera",participantItemAriaLabel:"{displayName}, {handRaisedState}, {mutedState}, {micDisabledState}, {cameraDisabledState}, {sharingState}, {connectionState}",participantItemWithMoreOptionsAriaLabel:"{displayName}, {handRaisedState}, {mutedState}, {micDisabledState}, {cameraDisabledState}, {sharingState}, {connectionState}, Más opciones",attendeeRole:"Asistente",micDisabledIconLabel:"Micrófono deshabilitado",cameraDisabledIconLabel:"Cámara deshabilitada"},ParticipantList:{overflowParticipantCount:"+{overflowCount} más"},typingIndicator:{singleUser:"{user} está escribiendo...",multipleUsers:"{users} están escribiendo...",multipleUsersAbbreviateOne:"{users} y 1 usuario más están escribiendo...",multipleUsersAbbreviateMany:"{users} y {numOthers} usuarios más están escribiendo...",delimiter:", "},sendBox:{placeholderText:"Escribir un mensaje",textTooLong:"La longitud del mensaje supera el límite máximo.",sendButtonAriaLabel:"Enviar mensaje",attachmentUploadsPendingError:"El archivo se está cargando. Espera.",removeAttachment:"Quitar archivo",uploading:"Cargando",uploadCompleted:"Carga completada",attachmentMoreMenu:"Más opciones"},richTextSendBox:{placeholderText:"Escribir un mensaje",textTooLong:"La longitud del mensaje supera el límite máximo.",sendButtonAriaLabel:"Enviar mensaje",attachmentUploadsPendingError:"El archivo se está cargando. Espera.",imageUploadsPendingError:"La imagen se está cargando. Espera.",removeAttachment:"Quitar archivo",uploading:"Cargando",uploadCompleted:"Carga completada",richTextBoldTooltip:"Negrita",richTextItalicTooltip:"Cursiva",richTextUnderlineTooltip:"Subrayado",richTextBulletListTooltip:"Lista con viñetas",richTextNumberListTooltip:"Lista numerada",richTextIncreaseIndentTooltip:"Aumentar sangría",richTextDecreaseIndentTooltip:"Reducir sangría",richTextInsertTableTooltip:"Insertar tabla",richTextFormatButtonTooltip:"Formato",richTextInsertRowOrColumnMenu:"Insertar",richTextInsertTableMenuTitle:"Insertar tabla de {column} x {row}",richTextInsertRowAboveMenu:"Insertar arriba",richTextInsertRowBelowMenu:"Insertar debajo",richTextInsertColumnLeftMenu:"Insertar a la izquierda",richTextInsertColumnRightMenu:"Insertar a la derecha",richTextDeleteRowOrColumnMenu:"Eliminar",richTextDeleteColumnMenu:"Eliminar columna",richTextDeleteRowMenu:"Eliminar fila",richTextDeleteTableMenu:"Eliminar tabla",richTextToolbarAriaLabel:"Barra de herramientas de formato de mensaje",richTextToolbarMoreButtonAriaLabel:"Más opciones",attachmentMoreMenu:"Más opciones",richTextNewBulletedListItemAnnouncement:"Viñeta, nueva línea",richTextNewNumberedListItemAnnouncement:"{0}, nueva línea",richTextBulletedListAppliedAnnouncement:"Lista con viñetas aplicada",richTextNumberedListAppliedAnnouncement:"Lista numerada aplicada"},realTimeTextModal:{realTimeTextModalAriaLabel:"Activar modal RTT",realTimeTextModalTitle:"¿Activar RTT?",realTimeTextModalText:"Se activará el texto en tiempo real (RTT) para todos los participantes de la reunión.",realTimeTextConfirmButtonLabel:"Activar",realTimeTextCancelButtonLabel:"Cancelar",realTimeTextCloseModalButtonAriaLabel:"Cerrar modal RTT"},captionsBanner:{captionsBannerSpinnerText:"Iniciando subtítulos...",realTimeTextInputBoxDefaultText:"Escribir un mensaje en tiempo real",realTimeTextInputErrorMessage:"El mensaje no puede exceder los 2000 caracteres",realTimeTextBannerTitle:"RTT",realTimeTextBannerContent:"RtT (texto en tiempo real) está habilitado para todos los participantes durante toda la reunión.",realTimeTextBannerLinkLabel:"Más información",captionsOnlyContainerTitle:"Subtítulos",realTimeTextOnlyContainerTitle:"Texto en tiempo real",captionsAndRealTimeTextContainerTitle:"Subtítulos y texto en tiempo real",expandButtonAriaLabel:"Expandir",minimizeButtonAriaLabel:"Contraer"},mentionPopover:{mentionPopoverHeader:"Sugerencias"},imageOverlay:{downloadButtonLabel:"Descargar",dismissButtonAriaLabel:"Cerrar",overlayVisibleMessage:"Superposición de detalles de imagen"},messageStatusIndicator:{deliveredAriaLabel:"Mensaje enviado",deliveredTooltipText:"Enviado",seenAriaLabel:"Mensaje visto por otros usuarios",seenTooltipText:"Visto",readByTooltipText:"Leído por {messageThreadReadCount} de {remoteParticipantsCount}",sendingAriaLabel:"Envío de mensajes",sendingTooltipText:"Enviando",failedToSendAriaLabel:"Error al enviar el mensaje",failedToSendTooltipText:"Error al enviar"},endCallButton:{label:"Salir",tooltipContent:"Abandonar llamada",leaveOption:"Salir",endCallOption:"Finalizar la llamada para todos"},cameraButton:{onLabel:"Cámara",offLabel:"Cámara",tooltipDisabledContent:"La cámara está deshabilitada",tooltipOnContent:"Desactivar la cámara",tooltipOffContent:"Activar la cámara",tooltipVideoLoadingContent:"El vídeo se está cargando",cameraMenuTitle:"Cámara",cameraMenuTooltip:"Elegir cámara",cameraButtonSplitRoleDescription:"Botón de expansión",onSplitButtonAriaLabel:"Desactivar la cámara",offSplitButtonAriaLabel:"Activar la cámara",cameraActionTurnedOnAnnouncement:"La cámara se ha activado",cameraActionTurnedOffAnnouncement:"La cámara se ha desactivado",onSplitButtonPrimaryActionCamera:"Desactivar la cámara",offSplitButtonPrimaryActionCamera:"Activar la cámara",cameraPrimaryActionSplitButtonTitle:"Usar cámara",videoEffectsMenuItemTitle:"Efectos",cameraButtonAriaDescription:"opciones de cámara"},microphoneButton:{onLabel:"Micro",offLabel:"Micro",tooltipDisabledContent:"Micrófono deshabilitado",tooltipOnContent:"Silenciar micrófono",tooltipOffContent:"Reactivar micrófono",microphoneMenuTitle:"Micrófono",microphoneMenuTooltip:"Elegir micrófono",speakerMenuTitle:"Altavoz",speakerMenuTooltip:"Elegir altavoz",microphoneButtonSplitRoleDescription:"Botón de expansión",onSplitButtonAriaLabel:"Desactivar audio del micrófono",offSplitButtonAriaLabel:"Reactivar audio del micrófono",microphoneActionTurnedOnAnnouncement:"El micrófono se ha activado",microphoneActionTurnedOffAnnouncement:"El micrófono se ha desactivado",offSplitButtonMicrophonePrimaryAction:"Reactivar audio del micrófono",onSplitButtonMicrophonePrimaryAction:"Desactivar audio del micrófono",microphonePrimaryActionSplitButtonTitle:"Usar micrófono",microphoneAriaDescription:"Opciones de audio",deepNoiseSuppressionTitle:"Supresión de ruido",deepNoiseSuppressionOnAnnouncement:"Se ha activado la supresión profunda de ruido",deepNoiseSuppressionOffAnnouncement:"Se ha desactivado la supresión profunda de ruido"},devicesButton:{label:"Dispositivos",tooltipContent:"Administrar dispositivos",cameraMenuTitle:"Cámara",cameraMenuTooltip:"Elegir cámara",audioDeviceMenuTitle:"Dispositivo de audio",audioDeviceMenuTooltip:"Elige un dispositivo de audio",microphoneMenuTitle:"Micrófono",microphoneMenuTooltip:"Elegir micrófono",speakerMenuTitle:"Altavoz",speakerMenuTooltip:"Elegir altavoz"},participantsButton:{label:"Contactos",ariaLabel:"Personas",tooltipContent:"Mostrar participantes",menuHeader:"En esta llamada",participantsListButtonLabel:"{numParticipants} personas",muteAllButtonLabel:"Silenciar a todos",copyInviteLinkButtonLabel:"Copiar vínculo de invitación",copyInviteLinkActionedAriaLabel:"Vínculo de invitación copiado"},screenShareButton:{onLabel:"Dejar de presentar",offLabel:"Presentar",tooltipDisabledContent:"La presentación está deshabilitada",tooltipOnContent:"Presentando tu pantalla",tooltipOffContent:"Presentar tu pantalla"},raiseHandButton:{offLabel:"Levantar",onLabel:"Bajar",tooltipDisabledContent:"La acción Levantar la mano está deshabilitada",tooltipOnContent:"Bajar la mano",tooltipOffContent:"Levantar la mano"},reactionButton:{label:"Reaccionar",ariaLabel:"Reaccionar",tooltipDisabledContent:"La acción de reacción está deshabilitada",tooltipContent:"Enviar una reacción",likeReactionTooltipContent:"Me gusta",heartReactionTooltipContent:"Amor",laughReactionTooltipContent:"Risa",applauseReactionTooltipContent:"Aplauso",surprisedReactionTooltipContent:"Sorprendido"},realTimeText:{isTypingText:"Escritura en tiempo real"},captionsSettingsModal:{captionsSettingsModalTitle:"Configuración de subtítulos",captionsSettingsSpokenLanguageDropdownLabel:"Idioma hablado",captionsSettingsCaptionLanguageDropdownLabel:"Idioma de subtítulos",captionsSettingsSpokenLanguageDropdownInfoText:"Idioma en el que están hablando todos los usuarios de esta llamada.",captionsSettingsCaptionLanguageDropdownInfoText:"Los subtítulos aparecerán en este idioma.",captionsSettingsConfirmButtonLabel:"Confirmar",captionsSettingsCancelButtonLabel:"Cancelar",captionsSettingsModalAriaLabel:"Configuración modal de subtítulos",captionsSettingsCloseModalButtonAriaLabel:"Cerrar configuración de subtítulos"},spokenLanguages:{"ar-ae":"Árabe - Emiratos Árabes Unidos","ar-sa":"Árabe (Arabia Saudí)","da-dk":"Danés","de-de":"Alemán (Alemania)","en-au":"Inglés (Australia)","en-ca":"Inglés (Canadá)","en-gb":"Inglés (Reino Unido)","en-in":"Inglés (India)","en-nz":"Inglés (Nueva Zelanda)","en-us":"Inglés (Estados Unidos)","es-es":"Español - España (alfabetización internacional)","es-mx":"Español (México)","fi-fi":"Finés","fr-ca":"Francés (Canadá)","fr-fr":"Francés (Francia)","hi-in":"Hindi","it-it":"Italiano (Italia)","ja-jp":"Japonés","ko-kr":"Coreano","nb-no":"Noruego (Bokmål)","nl-be":"Neerlandés (Bélgica)","nl-nl":"Neerlandés (Países Bajos)","pl-pl":"Polaco","pt-br":"Portugués (Brasil)","ru-ru":"Ruso","sv-se":"Sueco","zh-cn":"Chino - República Popular China","zh-hk":"Chino (RAE de Hong Kong)","cs-cz":"Checo","pt-pt":"Portugués (Portugal)","tr-tr":"Turco","vi-vn":"Vietnamita","th-th":"Tailandés","he-il":"Hebreo","cy-gb":"Galés","uk-ua":"Ucraniano","el-gr":"Griego","hu-hu":"Húngaro","ro-ro":"Rumano","sk-sk":"Eslovaco","zh-tw":"Chino (Taiwán)"},captionLanguages:{ar:"Árabe",da:"Danés",de:"Alemán",en:"Inglés",es:"Español",fi:"Finés","fr-ca":"Francés (Canadá)",fr:"Francés (Francia)",hi:"Hindi",it:"Italiano",ja:"Japonés",ko:"Coreano",nb:"Noruego (Bokmål)",nl:"Neerlandés",pl:"Polaco",pt:"Portugués (Brasil)",ru:"Ruso",sv:"Sueco","zh-Hans":"Chino (simplificado)","zh-Hant":"Chino (tradicional)",cs:"Checo","pt-pt":"Portugués (Portugal)",tr:"Turco",vi:"Vietnamita",th:"Tailandés",he:"Hebreo",cy:"Galés",uk:"Ucraniano",el:"Griego",hu:"Húngaro",ro:"Rumano",sk:"Eslovaco"},startCaptionsButton:{onLabel:"Activar subtítulos",offLabel:"Desactivar subtítulos",tooltipOnContent:"Desactivar subtítulos",tooltipOffContent:"Activar subtítulos"},startRealTimeTextButton:{label:"Activar RTT para esta llamada",tooltipOffContent:"Activar RTT para esta llamada"},messageThread:{yesterday:"Ayer",sunday:"Domingo",monday:"Lunes",tuesday:"Martes",wednesday:"Miércoles",thursday:"Jueves",friday:"Viernes",saturday:"Sábado",participantJoined:"se unió al chat.",participantLeft:"abandonó el chat.",editMessage:"Editar",removeMessage:"Eliminar",resendMessage:"Intenta enviar de nuevo",failToSendTag:"Error al enviar",editedTag:"Editado",liveAuthorIntro:"Mensaje de {author}",editedMessageLiveAuthorIntro:"Mensaje editado de {author}",editedMessageLocalUserLiveAuthorIntro:"Mensaje editado",messageContentAriaText:"{status} {author} dijo {message}",messageContentMineAriaText:"{status} Tú dijiste {message}",editBoxTextLimit:"Tu mensaje supera el límite de {limitNumber} caracteres",editBoxPlaceholderText:"Editar el mensaje",newMessagesIndicator:"Mensajes nuevos",noDisplayNameSub:"Sin nombre",editBoxCancelButton:"Cancelar",editBoxSubmitButton:"Listo",messageReadCount:"Leído por {messageReadByCount} de {remoteParticipantsCount}",actionMenuMoreOptions:"Más opciones",downloadAttachment:"Descargar archivo",openAttachment:"Abrir archivo",blockedWarningText:"Este mensaje se eliminó debido a la directiva de la organización.",blockedWarningLinkText:"Detalles",attachmentCardGroupMessage:"El mensaje tiene {attachmentCount} archivo adjunto",messageDeletedAnnouncementAriaLabel:"El mensaje se eliminó",richTextBoldTooltip:"Negrita",richTextItalicTooltip:"Cursiva",richTextUnderlineTooltip:"Subrayado",richTextBulletListTooltip:"Lista con viñetas",richTextNumberListTooltip:"Lista numerada",richTextIncreaseIndentTooltip:"Aumentar sangría",richTextDecreaseIndentTooltip:"Reducir sangría",richTextInsertTableTooltip:"Insertar tabla",richTextFormatButtonTooltip:"Formato",richTextInsertRowOrColumnMenu:"Insertar",richTextInsertTableMenuTitle:"Insertar tabla de {column} x {row}",richTextInsertRowAboveMenu:"Insertar arriba",richTextInsertRowBelowMenu:"Insertar debajo",richTextInsertColumnLeftMenu:"Insertar a la izquierda",richTextInsertColumnRightMenu:"Insertar a la derecha",richTextDeleteRowOrColumnMenu:"Eliminar",richTextDeleteColumnMenu:"Eliminar columna",richTextDeleteRowMenu:"Eliminar fila",richTextDeleteTableMenu:"Eliminar tabla",richTextToolbarMoreButtonAriaLabel:"Más opciones",attachmentUploadsPendingError:"El archivo se está cargando. Espera.",imageUploadsPendingError:"La imagen se está cargando. Espera.",richTextNewBulletedListItemAnnouncement:"Viñeta, nueva línea",richTextNewNumberedListItemAnnouncement:"{0}, nueva línea",richTextBulletedListAppliedAnnouncement:"Lista con viñetas aplicada",richTextNumberedListAppliedAnnouncement:"Lista numerada aplicada"},errorBar:{unableToReachChatService:"Estás sin conexión",accessDenied:"No se puede acceder a los servicios de chat. Comprueba las credenciales de usuario proporcionadas.",userNotInChatThread:"Ya no estás en este hilo de chat",sendMessageNotInChatThread:"No se pudo enviar el mensaje porque ya no estás en este hilo de chat",sendMessageGeneric:"Error al enviar el mensaje",callingNetworkFailure:"Problema al conectar la llamada: parece que no hay conexión",startVideoGeneric:"No se pudo iniciar el video",stopVideoGeneric:"No se pudo detener el video",muteGeneric:"No se pudo silenciar el micrófono",unmuteGeneric:"No se pudo reactivar el micrófono",speakingWhileMuted:"El micrófono está desactivado",startScreenShareGeneric:"Hubo un problema al iniciar la pantalla compartida.",stopScreenShareGeneric:"No se pudo detener la pantalla compartida",callNetworkQualityLow:"La calidad de la red es baja.",teamsMeetingCallNetworkQualityLow:"La calidad de la red es baja.",callNoSpeakerFound:"No se encontraron altavoces ni auriculares. Conecta un dispositivo de audio para escuchar la llamada.",callNoMicrophoneFound:"No se encontraron micrófonos. Conecta un dispositivo de entrada de audio.",callMicrophoneAccessDenied:"No se puede acceder al micrófono. Haz clic en el candado de la barra de direcciones para conceder permiso a esta página web.",callMicrophoneAccessDeniedSafari:"No se puede acceder al micrófono. Actualiza la página para habilitar permisos o comprueba la configuración de este navegador y que los permisos estén habilitados para este sitio web.",callMicrophoneMutedBySystem:"Tu sistema ha silenciado el audio.",callMicrophoneUnmutedBySystem:"Tu micrófono se ha recuperado y el sistema ha activado el audio.",callMacOsMicrophoneAccessDenied:"No se puede acceder al micrófono. Concede permiso al micrófono en la configuración de privacidad de macOS.",callLocalVideoFreeze:"El ancho de banda de red es deficiente. Es posible que el video aparezca pausado para otros usuarios en la llamada.",callCameraAccessDenied:"No se puede acceder a la cámara. Haz clic en el candado de la barra de direcciones para conceder permiso a esta página web.",callCameraAccessDeniedSafari:"No se puede acceder a la cámara. Actualiza la página para habilitar permisos o comprueba la configuración de este navegador y que los permisos estén habilitados para este sitio web.",callCameraAlreadyInUse:"No se puede acceder a la cámara. Puede que ya la esté usando otra aplicación.",callVideoStoppedBySystem:"El sistema ha detenido el video.",callVideoRecoveredBySystem:"El video se ha reanudado.",callMacOsCameraAccessDenied:"MacOS está bloqueando el acceso a la cámara. Actualiza la configuración de privacidad para permitir que este navegador acceda a la cámara.",callMacOsScreenShareAccessDenied:"MacOS está bloqueando el uso compartido de la pantalla. Actualiza la configuración de privacidad para permitir que este navegador grabe la pantalla.",dismissButtonAriaLabel:"Cerrar",failedToJoinCallGeneric:"No es posible unirse a la llamada.",failedToJoinCallInvalidMeetingLink:"No es posible unirse a la reunión. Vínculo no válido.",cameraFrozenForRemoteParticipants:"Los usuarios de la llamada tienen problemas para ver el video. Comprueba los dispositivos y la red.",unableToStartVideoEffect:"No se puede aplicar el efecto de video.",startSpotlightWhileMaxParticipantsAreSpotlighted:"No se puede iniciar el primer plano en los participantes porque el número máximo de participantes ya está puesto en primer plano.",mutedByRemoteParticipant:"Otro participante te ha silenciado."},notificationStack:{callingNetworkFailure:{title:"Problema al conectar la llamada",message:"Parece que estás desconectado. Comprueba la conexión de red e inténtalo de nuevo.",dismissButtonAriaLabel:"Cerrar"},startVideoGeneric:{title:"No se pudo iniciar el video.",dismissButtonAriaLabel:"Cerrar"},stopVideoGeneric:{title:"No se pudo detener el video.",dismissButtonAriaLabel:"Cerrar"},muteGeneric:{title:"No se pudo silenciar el micrófono.",dismissButtonAriaLabel:"Cerrar"},unmuteGeneric:{title:"No se pudo reactivar el micrófono.",dismissButtonAriaLabel:"Cerrar"},speakingWhileMuted:{title:"El audio está desactivado.",dismissButtonAriaLabel:"Cerrar"},startScreenShareGeneric:{title:"Hubo un problema al iniciar la pantalla compartida.",dismissButtonAriaLabel:"Cerrar"},stopScreenShareGeneric:{title:"No se pudo detener la pantalla compartida.",dismissButtonAriaLabel:"Cerrar"},callNetworkQualityLow:{title:"La calidad de la red es baja.",dismissButtonAriaLabel:"Cerrar"},teamsMeetingCallNetworkQualityLow:{title:"La calidad de la red es baja.",dismissButtonAriaLabel:"Cerrar",message:"Únete a esta llamada desde el teléfono para obtener un mejor sonido. Puedes seguir viendo la reunión en este dispositivo.",primaryButtonLabel:"Unirse por Teléfono"},callNoSpeakerFound:{title:"No se encontraron altavoces ni auriculares",message:"Conecta un dispositivo de audio para escuchar la llamada.",dismissButtonAriaLabel:"Cerrar"},callNoMicrophoneFound:{title:"No se han encontrado micrófonos",message:"Conecta un dispositivo de entrada de audio.",dismissButtonAriaLabel:"Cerrar"},callMicrophoneAccessDenied:{title:"No se puede acceder al micrófono.",message:"Haz clic en el candado de la barra de direcciones para conceder permiso a esta página web.",dismissButtonAriaLabel:"Cerrar"},callMicrophoneAccessDeniedSafari:{title:"No se puede acceder al micrófono.",message:"Actualiza la página para habilitar permisos o comprueba la configuración de este navegador y que los permisos estén habilitados para este sitio web.",dismissButtonAriaLabel:"Cerrar"},callMicrophoneMutedBySystem:{title:"Tu sistema ha silenciado el audio.",dismissButtonAriaLabel:"Cerrar"},callMicrophoneUnmutedBySystem:{title:"Tu micrófono se ha recuperado y el sistema ha activado el audio.",dismissButtonAriaLabel:"Cerrar"},callMacOsMicrophoneAccessDenied:{title:"No se puede acceder al micrófono.",message:"Concede permiso al micrófono en la configuración de privacidad de macOS.",dismissButtonAriaLabel:"Cerrar"},callLocalVideoFreeze:{title:"El ancho de banda de red es deficiente",message:"Es posible que el video aparezca pausado para otros usuarios en la llamada.",dismissButtonAriaLabel:"Cerrar"},callCameraAccessDenied:{title:"No se puede acceder a la cámara",message:"Haz clic en el candado de la barra de direcciones para conceder permiso a esta página web.",dismissButtonAriaLabel:"Cerrar"},callCameraAccessDeniedSafari:{title:"No se puede acceder a la cámara",message:"Actualiza la página para habilitar permisos o comprueba la configuración de este navegador y que los permisos estén habilitados para este sitio web.",dismissButtonAriaLabel:"Cerrar"},callCameraAlreadyInUse:{title:"No se puede acceder a la cámara",message:"Puede que ya la esté usando otra aplicación.",dismissButtonAriaLabel:"Cerrar"},callVideoStoppedBySystem:{title:"El sistema ha detenido el video.",dismissButtonAriaLabel:"Cerrar"},callVideoRecoveredBySystem:{title:"El video se ha reanudado.",dismissButtonAriaLabel:"Cerrar"},callMacOsCameraAccessDenied:{title:"MacOS está bloqueando el acceso a la cámara",message:"Actualiza la configuración de privacidad para permitir que este navegador acceda a la cámara.",dismissButtonAriaLabel:"Cerrar"},callMacOsScreenShareAccessDenied:{title:"MacOS está bloqueando la pantalla compartida",message:"Actualiza la configuración de privacidad para permitir que este navegador grabe la pantalla.",dismissButtonAriaLabel:"Cerrar"},failedToJoinCallGeneric:{title:"No es posible unirse a la llamada.",dismissButtonAriaLabel:"Cerrar"},failedToJoinCallInvalidMeetingLink:{title:"No es posible unirse a la reunión. Vínculo no válido.",dismissButtonAriaLabel:"Cerrar"},cameraFrozenForRemoteParticipants:{title:"Los usuarios de la llamada tienen problemas para ver el video",message:"Comprueba los dispositivos y la red.",dismissButtonAriaLabel:"Cerrar"},unableToStartVideoEffect:{title:"No se puede aplicar el efecto de video.",dismissButtonAriaLabel:"Cerrar"},startSpotlightWhileMaxParticipantsAreSpotlighted:{title:"No se puede poner primer plano a los participantes",message:"Ya está puesto en primer plano el número máximo de participantes.",dismissButtonAriaLabel:"Cerrar"},mutedByRemoteParticipant:{title:"Otro participante te ha silenciado.",dismissButtonAriaLabel:"Cerrar"},recordingStarted:{title:"La grabación se ha iniciado.",message:"Al unirte, das tu consentimiento para que se transcriba esta reunión.",dismissButtonAriaLabel:"Cerrar"},transcriptionStarted:{title:"La transcripción se ha iniciado.",message:"Al unirte, das tu consentimiento para que se transcriba esta reunión.",dismissButtonAriaLabel:"Cerrar"},recordingStopped:{title:"Se está guardando la grabación.",message:"La grabación se ha detenido.",dismissButtonAriaLabel:"Cerrar"},transcriptionStopped:{title:"Se está guardando la transcripción.",message:"La transcripción se ha detenido.",dismissButtonAriaLabel:"Cerrar"},recordingAndTranscriptionStarted:{title:"Se han iniciado la grabación y la transcripción.",message:"Al unirte, das tu consentimiento para que se transcriba esta reunión.",dismissButtonAriaLabel:"Cerrar"},recordingAndTranscriptionStopped:{title:"Se están guardando la grabación y la transcripción.",message:"Se han detenido la grabación y la transcripción.",dismissButtonAriaLabel:"Cerrar"},recordingStoppedStillTranscribing:{title:"La grabación se ha detenido.",message:"Solo estás transcribiendo esta reunión.",dismissButtonAriaLabel:"Cerrar"},transcriptionStoppedStillRecording:{title:"La transcripción se ha detenido.",message:"Solo estás grabando esta reunión.",dismissButtonAriaLabel:"Cerrar"},assignedBreakoutRoomOpened:{title:"Te moveremos a la sala asignada en 5 segundos.",dismissButtonAriaLabel:"Cerrar"},assignedBreakoutRoomChanged:{title:"La sala para sesión de subgrupo cambió",message:"Te moveremos a la sala asignada en 5 segundos.",dismissButtonAriaLabel:"Cerrar"},assignedBreakoutRoomClosed:{title:"La sala para sesión de subgrupo se cerró",message:"Volveremos a la reunión en 5 segundos.",dismissButtonAriaLabel:"Cerrar"},assignedBreakoutRoomOpenedPromptJoin:{title:"¿Quieres unirte a la sala para sesión de subgrupo?",message:"Se te ha asignado a una sala para sesión de subgrupo.",dismissButtonAriaLabel:"Cerrar",primaryButtonLabel:"Unirse a la sala",secondaryButtonLabel:"Más tarde"},breakoutRoomJoined:{title:"Te has unido a una sala para sesión de subgrupo.",dismissButtonAriaLabel:"Cerrar"},breakoutRoomClosingSoon:{title:"El límite de tiempo de sala está por expirar.",message:"Esta sala se cerrará en 30 segundos",dismissButtonAriaLabel:"Cerrar"},capabilityTurnVideoOnPresent:{title:"La cámara se habilitó",message:"Activa esta opción si quieres compartir video.",dismissButtonAriaLabel:"Cerrar"},capabilityTurnVideoOnAbsent:{title:"Se deshabilitó la cámara",message:"Ya no puedes compartir video.",dismissButtonAriaLabel:"Cerrar"},capabilityUnmuteMicPresent:{title:"El micrófono se habilitó",message:"Reactiva el audio si quieres hablar.",dismissButtonAriaLabel:"Cerrar"},capabilityUnmuteMicAbsent:{title:"El micro se deshabilitó",message:"Ya no puedes activar el audio.",dismissButtonAriaLabel:"Cerrar"},togetherModeStarted:{title:"El modo de colaboración inició",dismissButtonAriaLabel:"Cerrar"},togetherModeEnded:{title:"El modo de colaboración finalizó",dismissButtonAriaLabel:"Cerrar"}},videoGallery:{screenIsBeingSharedMessage:"Estás compartiendo tu pantalla",screenShareLoadingMessage:"Cargando la pantalla de {participant}",localScreenShareLoadingMessage:"Cargando la pantalla",localVideoLabel:"Tú",localVideoCameraSwitcherLabel:"Cambiar de cámara",localVideoMovementLabel:"Mosaico de video local móvil",localVideoMovementAriaLabel:"Mosaico de video local móvil",localVideoSelectedDescription:"{cameraName} seleccionada",displayNamePlaceholder:"Participante sin nombre",fitRemoteParticipantToFrame:"Ajustar al marco",fillRemoteParticipantFrame:"Marco de relleno",pinParticipantForMe:"Anclar para mí",pinParticipantForMeLimitReached:"Pin (límite alcanzado)",unpinParticipantForMe:"Desanclar",pinParticipantMenuItemAriaLabel:"Anclar {participantName}",unpinParticipantMenuItemAriaLabel:"Desanclar {participantName}",pinnedParticipantAnnouncementAriaLabel:"{participantName} anclado",unpinnedParticipantAnnouncementAriaLabel:"{participantName} desanclado",startSpotlightVideoTileMenuLabel:"Poner en primer plano para todos",addSpotlightVideoTileMenuLabel:"Agregar primer plano",spotlightLimitReachedMenuTitle:"Se alcanzó el límite de primer plano",stopSpotlightVideoTileMenuLabel:"Dejar de poner en primer plano",stopSpotlightOnSelfVideoTileMenuLabel:"Salir de primer plano",attendeeRole:"Asistente",muteParticipantMenuItemLabel:"Silenciar",waitingScreenText:"Esperando a que se unan otros usuarios",forbidAudio:"Deshabilitar micrófono",permitAudio:"Permitir micrófono",forbidAudioTileMenuLabel:"Deshabilitar micrófono",permitAudioTileMenuLabel:"Permitir micrófono",forbidVideo:"Deshabilitar cámara",permitVideo:"Permitir cámara",forbidVideoTileMenuLabel:"Deshabilitar cámara",permitVideoTileMenuLabel:"Permitir cámara"},dialpad:{placeholderText:"Escribir un número de teléfono",deleteButtonAriaLabel:"Eliminar"},holdButton:{onLabel:"Reanudar",offLabel:"En espera",tooltipOnContent:"Reanudar llamada",tooltipOffContent:"Poner llamada en espera"},videoTile:{participantStateRinging:"Llamando...",participantReconnecting:"Reconectando...",participantStateHold:"En espera",moreOptionsButtonAriaLabel:"Más opciones {displayName} {isMuted} {micDisabledState} {cameraDisabledState} {isHandRaised} {state} {isSpeaking}",moreOptionsParticipantMutedStateMutedAriaLabel:"audio desactivado",moreOptionsParticipantMutedStateUnmutedAriaLabel:"se reactivaron las notificaciones",moreOptionsParticipantHandRaisedAriaLabel:"Mano levantada",moreOptionsParticipantIsSpeakingAriaLabel:"Hablando",moreOptionsParticipantMicDisabledAriaLabel:"Micrófono deshabilitado",moreOptionsParticipantCameraDisabledAriaLabel:"Cámara deshabilitada"},CameraAndMicrophoneSitePermissionsRequest:{primaryText:"Permitir que {appName} usen la cámara y el micrófono",secondaryText:"Esto es para que los participantes puedan verte y oírte.",linkText:"¿Necesitas ayuda? Obtén ayuda para la solución de problemas",primaryButtonText:"Continuar sin cámara ni micrófono",ariaLabel:"Permitir el acceso a la cámara y al micrófono"},CameraSitePermissionsRequest:{primaryText:"Permitir que {appName} use la cámara",secondaryText:"Esto es para que los participantes puedan verte.",linkText:"¿Necesitas ayuda? Obtén ayuda para la solución de problemas",primaryButtonText:"Continuar sin cámara",ariaLabel:"Permitir el acceso a la cámara"},MicrophoneSitePermissionsRequest:{primaryText:"Permitir que {appName} use el micrófono",secondaryText:"Esto es para que los participantes puedan oírte.",linkText:"¿Necesitas ayuda? Obtén ayuda para la solución de problemas",primaryButtonText:"Continuar sin micrófono",ariaLabel:"Permitir el acceso al micrófono"},CameraAndMicrophoneSitePermissionsCheck:{primaryText:"Comprobando el acceso a la cámara y al micrófono",secondaryText:"Permite el acceso si se solicita. Esto es para que los participantes puedan verte y oírte.",linkText:"¿Necesitas ayuda? Obtén ayuda para la solución de problemas",primaryButtonText:"Continuar sin cámara ni micrófono",ariaLabel:"Comprobando el acceso a la cámara y al micrófono. Permite el acceso si se solicita."},CameraSitePermissionsCheck:{primaryText:"Comprobando el acceso a la cámara",secondaryText:"Permite el acceso si se solicita. Esto es para que los participantes puedan verte.",linkText:"¿Necesitas ayuda? Obtén ayuda para la solución de problemas",primaryButtonText:"Continuar sin cámara",ariaLabel:"Comprobando el acceso a la cámara. Permite el acceso si se solicita."},MicrophoneSitePermissionsCheck:{primaryText:"Comprobando el acceso al micrófono",secondaryText:"Permite el acceso si se solicita. Esto es para que los participantes puedan oírte.",linkText:"¿Necesitas ayuda? Obtén ayuda para la solución de problemas",primaryButtonText:"Continuar sin micrófono",ariaLabel:"Comprobando el acceso al micrófono. Permite el acceso si se solicita."},CameraAndMicrophoneSitePermissionsDenied:{primaryText:"No se puede permitir el acceso a la cámara ni al micrófono.",secondaryText:"Haz clic en el ícono de bloqueo de la barra de direcciones para conceder permisos de micrófono a esta página web. Es posible que sea necesario actualizar la página.",primaryButtonText:"Continuar sin cámara ni micrófono",linkText:"¿Necesitas ayuda? Obtén ayuda para la solución de problemas"},CameraAndMicrophoneSitePermissionsDeniedSafari:{primaryText:"No se puede permitir el acceso a la cámara ni al micrófono.",secondaryText:"Actualiza la página para habilitar permisos o comprueba la configuración de este navegador y que los permisos estén habilitados para este sitio web.",primaryButtonText:"Continuar sin cámara ni micrófono",linkText:"¿Necesitas ayuda? Obtén ayuda para la solución de problemas"},CameraSitePermissionsDenied:{primaryText:"No se puede acceder a la cámara",secondaryText:"Haz clic en el ícono de bloqueo de la barra de direcciones para conceder permisos de cámara a esta página web. Es posible que sea necesario actualizar la página.",primaryButtonText:"Continuar sin cámara",linkText:"¿Necesitas ayuda? Obtén ayuda para la solución de problemas"},MicrophoneSitePermissionsDenied:{primaryText:"No se puede acceder al micrófono.",secondaryText:"Haz clic en el ícono de bloqueo de la barra de direcciones para conceder permisos de micrófono a esta página web. Es posible que sea necesario actualizar la página.",primaryButtonText:"Continuar sin micrófono",linkText:"¿Necesitas ayuda? Obtén ayuda para la solución de problemas"},CameraSitePermissionsDeniedSafari:{primaryText:"No se puede acceder a la cámara",secondaryText:"Actualiza la página para habilitar permisos o comprueba la configuración de este navegador y que los permisos estén habilitados para este sitio web.",primaryButtonText:"Continuar sin cámara",linkText:"¿Necesitas ayuda? Obtén ayuda para la solución de problemas"},MicrophoneSitePermissionsDeniedSafari:{primaryText:"No se puede acceder al micrófono.",secondaryText:"Actualiza la página para habilitar permisos o comprueba la configuración de este navegador y que los permisos estén habilitados para este sitio web.",primaryButtonText:"Continuar sin micrófono",linkText:"¿Necesitas ayuda? Obtén ayuda para la solución de problemas"},UnsupportedBrowser:{primaryText:"Navegador no compatible",secondaryText:"Únete a esta llamada con un navegador compatible.",moreHelpLinkText:"Ver los requisitos de compatibilidad"},UnsupportedBrowserVersion:{primaryText:"Es necesario actualizar el navegador",secondaryText:"Para garantizar la mejor llamada posible, actualiza el navegador e intenta unirte de nuevo a la llamada.",moreHelpLinkText:"Ver los requisitos de compatibilidad",continueAnywayButtonText:"Iniciar llamada sin actualizar"},UnsupportedOperatingSystem:{primaryText:"Sistema operativo no compatible",secondaryText:"Únete a esta llamada desde un dispositivo con un sistema operativo compatible.",moreHelpLinkText:"Ver los requisitos de compatibilidad"},BrowserPermissionDenied:{primaryText:"No se puede usar la cámara o el micrófono",secondaryText:"Es posible que el navegador no tenga acceso a la cámara o al micrófono. Para solucionar este problema, abre Preferencias del sistema.",primaryButtonText:"Intentar de nuevo",linkText:"¿Necesitas ayuda? Obtén ayuda para la solución de problemas"},BrowserPermissionDeniedIOS:{primaryText:"Permite el acceso al micrófono para continuar",secondaryText:"Para que otros participantes puedan oírte.",primaryButtonText:"Intentar de nuevo",imageAltText:"Ubicación de permisos del dispositivo de micrófono y cámara para iOS",linkText:"¿Necesitas ayuda? Obtén ayuda para la solución de problemas",step1Text:"Ve a la aplicación de Configuración",step2Text:"Desplázate hacia abajo hasta la configuración de este navegador",step3Text:"Activar micrófono (cámara opcional)",step4Text:"Intenta unirte de nuevo a la llamada",step1DigitText:"1",step2DigitText:"2",step3DigitText:"3",step4DigitText:"4"},verticalGallery:{leftNavButtonAriaLabel:"página anterior {current} de {total}",rightNavButtonAriaLabel:"página siguiente {current} de {total}"},meetingConferencePhoneInfo:{meetingConferencePhoneInfoModalTitle:"Unirse a la llamada desde el teléfono",meetingConferencePhoneInfoModalDialIn:"Marcar número",meetingConferencePhoneInfoModalMeetingId:"Escribir el id. de reunión",meetingConferencePhoneInfoModalWait:"Espera a ser admitido por el organizador",meetingConferencePhoneInfoModalNoPhoneAvailable:"No hay teléfono disponible",meetingConferencePhoneInfoModalTollGeoData:"{country}, {city}",meetingConferencePhoneInfoModalTollFree:"(Número gratuito)",meetingConferencePhoneInfoModalToll:"(Número de pago)"},IncomingCallNotification:{incomingCallNotificationPlaceholderId:"Usuario desconocido",incomingCallNotificationPlaceholderAlert:"{callerName} está llamando",incomingCallNoticicationAcceptWithAudioAriaLabel:"Aceptar con audio",incomingCallNoticicationAcceptWithVideoAriaLabel:"Aceptar con video",incomingCallNoticicationRejectAriaLabel:"Rechazar",incomingCallNotificationAcceptButtonLabel:"Aceptar",incomingCallNotificationRejectButtonLabel:"Rechazar",incomingCallNotificationAccceptWithVideoButtonLabel:"Aceptar con vídeo",incomingCallNotificationDismissButtonAriaLabel:"Descartar"}})},uQt={strings:Jh({participantItem:{isMeText:"(sinä)",menuTitle:"Lisää vaihtoehtoja",removeButtonLabel:"Poista",sharingIconLabel:"Jakaminen",mutedIconLabel:"Mykistetty",handRaisedIconLabel:"Käsi ylhäällä – paikka {position}",displayNamePlaceholder:"Nimetön osallistuja",participantStateRinging:"Soitetaan...",participantStateHold:"Pidossa",participantItemAriaLabel:"{displayName}, {handRaisedState}, {mutedState}, {micDisabledState}, {cameraDisabledState}, {sharingState}, {connectionState}",participantItemWithMoreOptionsAriaLabel:"{displayName}, {handRaisedState}, {mutedState}, {micDisabledState}, {cameraDisabledState}, {sharingState}, {connectionState}, lisää asetuksia",attendeeRole:"Osallistuja",micDisabledIconLabel:"Mikrofoni poistettu käytöstä",cameraDisabledIconLabel:"Kamera poistettu käytöstä"},ParticipantList:{overflowParticipantCount:"+{overflowCount} lisää"},typingIndicator:{singleUser:"{user} käyttäjä kirjoittaa parhaillaan...",multipleUsers:"{users} käyttäjää kirjoittaa parhaillaan...",multipleUsersAbbreviateOne:"{users} ja yksi muu käyttäjä kirjoittaa parhaillaan...",multipleUsersAbbreviateMany:"{users} ja {numOthers} muuta käyttäjää kirjoittaa parhaillaan...",delimiter:", "},sendBox:{placeholderText:"Kirjoita viesti",textTooLong:"Viestin pituus ylittää enimmäispituuden.",sendButtonAriaLabel:"Lähetä viesti",attachmentUploadsPendingError:"Ladataan palvelimeen... Odota hetki.",removeAttachment:"Poista tiedosto",uploading:"Ladataan palvelimeen",uploadCompleted:"Ladattu palvelimeen",attachmentMoreMenu:"Lisää asetuksia"},richTextSendBox:{placeholderText:"Kirjoita viesti",textTooLong:"Viestin pituus ylittää enimmäispituuden.",sendButtonAriaLabel:"Lähetä viesti",attachmentUploadsPendingError:"Ladataan palvelimeen... Odota hetki.",imageUploadsPendingError:"Kuvaa ladataan palvelimeen, odota.",removeAttachment:"Poista tiedosto",uploading:"Ladataan",uploadCompleted:"Lataus valmis",richTextBoldTooltip:"Lihavointi",richTextItalicTooltip:"Kursivointi",richTextUnderlineTooltip:"Alleviivaa",richTextBulletListTooltip:"Luettelomerkeillä varustettu luettelo",richTextNumberListTooltip:"Numeroitu luettelo",richTextIncreaseIndentTooltip:"Suurenna sisennystä",richTextDecreaseIndentTooltip:"Pienennä sisennystä",richTextInsertTableTooltip:"Lisää taulukko",richTextFormatButtonTooltip:"Muoto",richTextInsertRowOrColumnMenu:"Lisää",richTextInsertTableMenuTitle:"Lisää {row}x{column}-kokoinen taulukko",richTextInsertRowAboveMenu:"Lisää yläpuolelle",richTextInsertRowBelowMenu:"Lisää alapuolelle",richTextInsertColumnLeftMenu:"Lisää vasemmalle",richTextInsertColumnRightMenu:"Lisää oikealle",richTextDeleteRowOrColumnMenu:"Poista",richTextDeleteColumnMenu:"Poista sarake",richTextDeleteRowMenu:"Poista rivi",richTextDeleteTableMenu:"Poista taulukko",richTextToolbarAriaLabel:"Viestin muotoilun työkalurivi",richTextToolbarMoreButtonAriaLabel:"Lisää asetuksia",attachmentMoreMenu:"Lisää asetuksia",richTextNewBulletedListItemAnnouncement:"Luettelomerkki, uusi rivi",richTextNewNumberedListItemAnnouncement:"{0}, uusi rivi",richTextBulletedListAppliedAnnouncement:"Luettelomerkeillä varustettu luettelo käytössä",richTextNumberedListAppliedAnnouncement:"Numeroitu luettelo käytössä"},realTimeTextModal:{realTimeTextModalAriaLabel:"Ota modaalinen RTT-valintaikkuna käyttöön",realTimeTextModalTitle:"Otetaanko RTT käyttöön?",realTimeTextModalText:"Reaaliaikainen teksti (RTT) otetaan käyttöön kaikille kokouksen osallistuville.",realTimeTextConfirmButtonLabel:"Ota käyttöön",realTimeTextCancelButtonLabel:"Peruuta",realTimeTextCloseModalButtonAriaLabel:"Sulje modaalinen RTT-valintaikkuna"},captionsBanner:{captionsBannerSpinnerText:"Aloitetaan tekstitystä...",realTimeTextInputBoxDefaultText:"Kirjoita viesti reaaliaikaisesti",realTimeTextInputErrorMessage:"Viestissä voi olla enintään 2 000 merkkiä",realTimeTextBannerTitle:"Reaaliaikainen kirjoitus",realTimeTextBannerContent:"RTT (reaaliaikainen teksti) on käytössä kaikille osallistujille koko kokouksen keston ajan.",realTimeTextBannerLinkLabel:"Lue lisää",captionsOnlyContainerTitle:"Tekstitykset",realTimeTextOnlyContainerTitle:"Reaaliaikainen teksti",captionsAndRealTimeTextContainerTitle:"Tekstitykset ja reaaliaikainen teksti",expandButtonAriaLabel:"Laajenna",minimizeButtonAriaLabel:"Kutista"},mentionPopover:{mentionPopoverHeader:"Ehdotuksia"},imageOverlay:{downloadButtonLabel:"Lataa",dismissButtonAriaLabel:"Sulje",overlayVisibleMessage:"Kuvan tietojen peittokuva"},messageStatusIndicator:{deliveredAriaLabel:"Viesti on lähetetty",deliveredTooltipText:"Lähetetty",seenAriaLabel:"Muut ovat nähneet viestin",seenTooltipText:"Nähty",readByTooltipText:"{messageThreadReadCount}/{remoteParticipantsCount} osallistujaa on lukenut viestin",sendingAriaLabel:"Viestiä lähetetään",sendingTooltipText:"Lähetetään",failedToSendAriaLabel:"Viestin lähettäminen epäonnistui",failedToSendTooltipText:"Lähettäminen epäonnistui"},endCallButton:{label:"Poistu",tooltipContent:"Poistu puhelusta",leaveOption:"Poistu",endCallOption:"Lopeta kaikkien puhelu"},cameraButton:{onLabel:"Kamera",offLabel:"Kamera",tooltipDisabledContent:"Kamera on poissa käytöstä",tooltipOnContent:"Poista kamera käytöstä",tooltipOffContent:"Käynnistä kamera",tooltipVideoLoadingContent:"Videota ladataan",cameraMenuTitle:"Kamera",cameraMenuTooltip:"Valitse kamera",cameraButtonSplitRoleDescription:"Jaettu painike",onSplitButtonAriaLabel:"Poista kamera käytöstä",offSplitButtonAriaLabel:"Ota kamera käyttöön",cameraActionTurnedOnAnnouncement:"Kamerasi on otettu käyttöön",cameraActionTurnedOffAnnouncement:"Kamerasi on poistettu käytöstä",onSplitButtonPrimaryActionCamera:"Poista kamera käytöstä",offSplitButtonPrimaryActionCamera:"Käynnistä kamera",cameraPrimaryActionSplitButtonTitle:"Käytä kameraa",videoEffectsMenuItemTitle:"Tehosteet",cameraButtonAriaDescription:"kamera-asetukset"},microphoneButton:{onLabel:"Mikrofoni",offLabel:"Mikrofoni",tooltipDisabledContent:"Mikrofoni on poissa käytöstä",tooltipOnContent:"Mykistä mikrofoni",tooltipOffContent:"Poista mikrofonin mykistys",microphoneMenuTitle:"Mikrofoni",microphoneMenuTooltip:"Valitse mikrofoni",speakerMenuTitle:"Kaiutin",speakerMenuTooltip:"Valitse kaiutin",microphoneButtonSplitRoleDescription:"Jaettu painike",onSplitButtonAriaLabel:"Mykistä mikrofoni",offSplitButtonAriaLabel:"Poista mikrofonin mykistys",microphoneActionTurnedOnAnnouncement:"Mikrofonisi on otettu käyttöön",microphoneActionTurnedOffAnnouncement:"Mikrofonisi on poistettu käytöstä",offSplitButtonMicrophonePrimaryAction:"Poista mikrofonin mykistys",onSplitButtonMicrophonePrimaryAction:"Mykistä mikrofoni",microphonePrimaryActionSplitButtonTitle:"Käytä mikrofonia",microphoneAriaDescription:"Ääniasetukset",deepNoiseSuppressionTitle:"Melunvaimennus",deepNoiseSuppressionOnAnnouncement:"Syvä melunvaimennus on otettu käyttöön",deepNoiseSuppressionOffAnnouncement:"Syvä melunvaimennus on poistettu käytöstä"},devicesButton:{label:"Laitteet",tooltipContent:"Hallitse laitteita",cameraMenuTitle:"Kamera",cameraMenuTooltip:"Valitse kamera",audioDeviceMenuTitle:"Äänilaite",audioDeviceMenuTooltip:"Valitse äänilaite",microphoneMenuTitle:"Mikrofoni",microphoneMenuTooltip:"Valitse mikrofoni",speakerMenuTitle:"Kaiutin",speakerMenuTooltip:"Valitse kaiutin"},participantsButton:{label:"Ihmiset",ariaLabel:"Henkilöt",tooltipContent:"Näytä osallistujat",menuHeader:"Tässä puhelussa",participantsListButtonLabel:"{numParticipants} henkilöä",muteAllButtonLabel:"Mykistä kaikki",copyInviteLinkButtonLabel:"Kopioi kutsulinkki",copyInviteLinkActionedAriaLabel:"Kutsulinkki kopioitu"},screenShareButton:{onLabel:"Lopeta esitys",offLabel:"Esitä",tooltipDisabledContent:"Näytön jakaminen on poissa käytöstä",tooltipOnContent:"Näyttösi näytetään muille osallistujille",tooltipOffContent:"Näytä oma näyttösi"},raiseHandButton:{offLabel:"Nosta",onLabel:"Laske",tooltipDisabledContent:"Nosta käsi -toiminto on poistettu käytöstä",tooltipOnContent:"Laske käsi",tooltipOffContent:"Nosta käsi"},reactionButton:{label:"Reagoi",ariaLabel:"Reagoi",tooltipDisabledContent:"Reaktiotoiminto on poistettu käytöstä",tooltipContent:"Lähetä reaktio",likeReactionTooltipContent:"Tykkää",heartReactionTooltipContent:"Ihastu",laughReactionTooltipContent:"Naura",applauseReactionTooltipContent:"Suosionosoitus",surprisedReactionTooltipContent:"Yllättynyt"},realTimeText:{isTypingText:"RTT-kirjoitus"},captionsSettingsModal:{captionsSettingsModalTitle:"Tekstitysasetukset",captionsSettingsSpokenLanguageDropdownLabel:"Puhuttu kieli",captionsSettingsCaptionLanguageDropdownLabel:"Tekstitysten kieli",captionsSettingsSpokenLanguageDropdownInfoText:"Kieli, jota kaikki tähän puheluun osallistuvat puhuvat.",captionsSettingsCaptionLanguageDropdownInfoText:"Tekstitys näkyy tällä kielellä.",captionsSettingsConfirmButtonLabel:"Vahvista",captionsSettingsCancelButtonLabel:"Peruuta",captionsSettingsModalAriaLabel:"Tekstitysasetus, modaalinen valintaikkuna",captionsSettingsCloseModalButtonAriaLabel:"Sulje tekstitysasetus"},spokenLanguages:{"ar-ae":"arabia – Arabiemiirikunnat","ar-sa":"arabia – Saudi-Arabia","da-dk":"tanska","de-de":"saksa – Saksa","en-au":"englanti – Australia","en-ca":"englanti – Kanada","en-gb":"englanti – Yhdistynyt kuningaskunta","en-in":"englanti – Intia","en-nz":"englanti – Uusi-Seelanti","en-us":"englanti – Yhdysvallat","es-es":"espanja – Espanja (nykykieli)","es-mx":"espanja – Meksiko","fi-fi":"suomi","fr-ca":"ranska – Kanada","fr-fr":"ranska – Ranska","hi-in":"hindi","it-it":"italia – Italia","ja-jp":"japani","ko-kr":"korea","nb-no":"norja (bokmål)","nl-be":"hollanti – Belgia","nl-nl":"hollanti – Alankomaat","pl-pl":"puola","pt-br":"portugali (Brasilia)","ru-ru":"venäjä","sv-se":"ruotsi","zh-cn":"kiina – Kiinan kansantasavalta","zh-hk":"kiina – Hongkong, erityishallintoalue","cs-cz":"tšekki","pt-pt":"portugali – Portugali","tr-tr":"turkki","vi-vn":"vietnam","th-th":"thai","he-il":"heprea","cy-gb":"kymri","uk-ua":"ukraina","el-gr":"kreikka","hu-hu":"unkari","ro-ro":"romania","sk-sk":"slovakki","zh-tw":"kiina – Taiwan"},captionLanguages:{ar:"arabia",da:"tanska",de:"saksa",en:"englanti",es:"espanja",fi:"suomi","fr-ca":"ranska – Kanada",fr:"ranska – Ranska",hi:"hindi",it:"italia",ja:"japani",ko:"korea",nb:"norja (bokmål)",nl:"hollanti",pl:"puola",pt:"portugali (Brasilia)",ru:"venäjä",sv:"ruotsi","zh-Hans":"kiina (yksinkertaistettu)","zh-Hant":"kiina (perinteinen)",cs:"tšekki","pt-pt":"portugali – Portugali",tr:"turkki",vi:"vietnam",th:"thai",he:"heprea",cy:"kymri",uk:"ukraina",el:"kreikka",hu:"unkari",ro:"romania",sk:"slovakki"},startCaptionsButton:{onLabel:"Ota tekstitykset käyttöön",offLabel:"Poista tekstitykset käytöstä",tooltipOnContent:"Poista tekstitykset käytöstä",tooltipOffContent:"Ota tekstitykset käyttöön"},startRealTimeTextButton:{label:"Ota reaaliaikainen kirjoitus käyttöön tässä puhelussa",tooltipOffContent:"Ota reaaliaikainen kirjoitus käyttöön tässä puhelussa"},messageThread:{yesterday:"eilen",sunday:"sunnuntaina",monday:"maanantaina",tuesday:"tiistaina",wednesday:"keskiviikkona",thursday:"torstaina",friday:"perjantaina",saturday:"lauantaina",participantJoined:"liittyi keskusteluun.",participantLeft:"poistui keskustelusta.",editMessage:"Muokkaa",removeMessage:"Poista",resendMessage:"Yritä lähettää viesti uudelleen",failToSendTag:"Lähettäminen epäonnistui",editedTag:"Muokattu",liveAuthorIntro:"Viesti lähettäjältä {author}",editedMessageLiveAuthorIntro:"Muokattu viesti lähettäjältä {author}",editedMessageLocalUserLiveAuthorIntro:"Muokattu viesti",messageContentAriaText:"{status} {author} sanoi {message}",messageContentMineAriaText:"{status} Sanoit {message}",editBoxTextLimit:"Viesti ylittää {limitNumber} merkin rajan",editBoxPlaceholderText:"Muokkaa viestiäsi",newMessagesIndicator:"Uudet viestit",noDisplayNameSub:"Ei nimeä",editBoxCancelButton:"Peruuta",editBoxSubmitButton:"Valmis",messageReadCount:"{messageReadByCount}/{remoteParticipantsCount} osallistujaa on lukenut viestin",actionMenuMoreOptions:"Lisää vaihtoehtoja",downloadAttachment:"Lataa tiedosto",openAttachment:"Avaa tiedosto",blockedWarningText:"Tämä viesti poistettiin organisaation käytännön vuoksi.",blockedWarningLinkText:"Lisätiedot",attachmentCardGroupMessage:"Viestissä on {attachmentCount} liitettä",messageDeletedAnnouncementAriaLabel:"Viesti on poistettu",richTextBoldTooltip:"Lihavoi",richTextItalicTooltip:"Kursivointi",richTextUnderlineTooltip:"Alleviivaus",richTextBulletListTooltip:"Luettelomerkeillä varustettu luettelo",richTextNumberListTooltip:"Numeroitu luettelo",richTextIncreaseIndentTooltip:"Suurenna sisennystä",richTextDecreaseIndentTooltip:"Pienennä sisennystä",richTextInsertTableTooltip:"Lisää taulukko",richTextFormatButtonTooltip:"Muoto",richTextInsertRowOrColumnMenu:"Lisää",richTextInsertTableMenuTitle:"Lisää {row}x{column}-kokoinen taulukko",richTextInsertRowAboveMenu:"Lisää yläpuolelle",richTextInsertRowBelowMenu:"Lisää alapuolelle",richTextInsertColumnLeftMenu:"Lisää vasemmalle",richTextInsertColumnRightMenu:"Lisää oikealle",richTextDeleteRowOrColumnMenu:"Poista",richTextDeleteColumnMenu:"Poista sarake",richTextDeleteRowMenu:"Poista rivi",richTextDeleteTableMenu:"Poista taulukko",richTextToolbarMoreButtonAriaLabel:"Lisää asetuksia",attachmentUploadsPendingError:"Ladataan palvelimeen... Odota hetki.",imageUploadsPendingError:"Kuvaa ladataan palvelimeen, odota.",richTextNewBulletedListItemAnnouncement:"Luettelomerkki, uusi rivi",richTextNewNumberedListItemAnnouncement:"{0}, uusi rivi",richTextBulletedListAppliedAnnouncement:"Luettelomerkeillä varustettu luettelo käytössä",richTextNumberedListAppliedAnnouncement:"Numeroitu luettelo käytössä"},errorBar:{unableToReachChatService:"Olet offline-tilassa",accessDenied:"Keskustelupalveluihin ei saada yhteyttä – tarkista annetut käyttäjän tunnistetiedot",userNotInChatThread:"Et ole enää mukana tässä keskusteluketjussa",sendMessageNotInChatThread:"Viestin lähettäminen epäonnistui, koska et ole enää tässä keskusteluketjussa",sendMessageGeneric:"Viestin lähettäminen epäonnistui",callingNetworkFailure:"Puhelun yhdistämisessä on ongelma. Vaikutat olevan offline-tilassa",startVideoGeneric:"Videon käynnistäminen epäonnistui",stopVideoGeneric:"Videon pysäyttäminen epäonnistui",muteGeneric:"Mikrofonin mykistäminen epäonnistui",unmuteGeneric:"Mikrofonin mykistyksen poistaminen epäonnistui",speakingWhileMuted:"Mikrofonisi on mykistetty",startScreenShareGeneric:"Näytön jakamisen aloittamisessa ilmeni ongelma.",stopScreenShareGeneric:"Näytön jakamisen lopettaminen epäonnistui",callNetworkQualityLow:"Verkkoyhteyden laatu on huono.",teamsMeetingCallNetworkQualityLow:"Verkkoyhteyden laatu on huono.",callNoSpeakerFound:"Kaiuttimia tai kuulokkeita ei löytynyt. Yhdistä äänilaite voidaksesi kuulla puhelun.",callNoMicrophoneFound:"Mikrofoneja ei löytynyt. Yhdistä äänitulolaite.",callMicrophoneAccessDenied:"Mikrofonia ei voi käyttää. Myönnä käyttöoikeus tälle verkkosivulle napsauttamalla osoiterivin lukitusta.",callMicrophoneAccessDeniedSafari:"Mikrofonia ei voi käyttää. Salli käyttöoikeudet päivittämällä sivu tai tarkista tämän selaimen asetukset ja varmista, että käyttöoikeudet on otettu käyttöön tässä sivustossa.",callMicrophoneMutedBySystem:"Järjestelmäasetuksen perusteella sinut on mykistetty.",callMicrophoneUnmutedBySystem:"Mikrofonisi palautui käyttöön ja järjestelmä on poistanut sen mykistyksen.",callMacOsMicrophoneAccessDenied:"Mikrofonia ei voi käyttää. Salli mikrofonin käyttö macOS:in tietosuoja-asetuksissa.",callLocalVideoFreeze:"Verkon kaistanleveys on heikko. Videokuvasi saattaa näkyä keskeytettynä puhelun muille osallistujille.",callCameraAccessDenied:"Kameraa ei voi käyttää. Myönnä käyttöoikeus tälle verkkosivulle napsauttamalla osoiterivin lukitusta.",callCameraAccessDeniedSafari:"Kameraa ei voi käyttää. Salli käyttöoikeudet päivittämällä sivu tai tarkista tämän selaimen asetukset ja varmista, että käyttöoikeudet on otettu käyttöön tässä sivustossa.",callCameraAlreadyInUse:"Kameraa ei voi käyttää. Toinen sovellus saattaa jo käyttää sitä.",callVideoStoppedBySystem:"Järjestelmä on pysäyttänyt videosi.",callVideoRecoveredBySystem:"Videosi näytetään jälleen.",callMacOsCameraAccessDenied:"MacOS estää kameran käytön. Päivitä tietosuoja-asetukset, jotta selain voi käyttää kameraasi.",callMacOsScreenShareAccessDenied:"MacOS estää näytön jakamisen. Päivitä tietosuoja-asetukset, jotta selain voi tallentaa, mitä näytölläsi tapahtuu.",dismissButtonAriaLabel:"Sulje",failedToJoinCallGeneric:"Puheluun liittyminen epäonnistui.",failedToJoinCallInvalidMeetingLink:"Kokoukseen liittyminen ei onnistu. Linkki on virheellinen.",cameraFrozenForRemoteParticipants:"Puhelun käyttäjillä on videokuvan näkymiseen liittyviä ongelmia. Tarkista laitteesi ja verkkosi.",unableToStartVideoEffect:"Videotehosteen käyttäminen ei onnistu.",startSpotlightWhileMaxParticipantsAreSpotlighted:"Osallistujien korostusta ei voi aloittaa, koska enimmäismäärä osallistujia on jo valokeilassa.",mutedByRemoteParticipant:"Toinen osallistuja mykisti sinut."},notificationStack:{callingNetworkFailure:{title:"Ongelma puhelun yhdistämisessä",message:"Olet ilmeisesti offline-tilassa. Tarkista verkkoyhteys ja yritä uudelleen.",dismissButtonAriaLabel:"Sulje"},startVideoGeneric:{title:"Videon käynnistäminen epäonnistui.",dismissButtonAriaLabel:"Sulje"},stopVideoGeneric:{title:"Videon pysäyttäminen epäonnistui.",dismissButtonAriaLabel:"Sulje"},muteGeneric:{title:"Mikrofonin mykistäminen epäonnistui.",dismissButtonAriaLabel:"Sulje"},unmuteGeneric:{title:"Mikrofonin mykistyksen poistaminen epäonnistui.",dismissButtonAriaLabel:"Sulje"},speakingWhileMuted:{title:"Ääni on mykistetty.",dismissButtonAriaLabel:"Sulje"},startScreenShareGeneric:{title:"Näytön jakamisen aloittamisessa ilmeni ongelma.",dismissButtonAriaLabel:"Sulje"},stopScreenShareGeneric:{title:"Näytön jakamisen lopettaminen epäonnistui.",dismissButtonAriaLabel:"Sulje"},callNetworkQualityLow:{title:"Verkkoyhteyden laatu on huono.",dismissButtonAriaLabel:"Sulje"},teamsMeetingCallNetworkQualityLow:{title:"Verkkoyhteyden laatu on huono.",dismissButtonAriaLabel:"Sulje",message:"Liity tähän puheluun puhelimestasi, jotta ääni on parempi. Voit jatkaa kokouksen tarkastelua tällä laitteella.",primaryButtonLabel:"Liity puhelimella"},callNoSpeakerFound:{title:"Kaiuttimia tai kuulokkeita ei löytynyt.",message:"Yhdistä äänilaite voidaksesi kuulla puhelun.",dismissButtonAriaLabel:"Sulje"},callNoMicrophoneFound:{title:"Mikrofoneja ei löytynyt",message:"Yhdistä äänensyöttölaite.",dismissButtonAriaLabel:"Sulje"},callMicrophoneAccessDenied:{title:"Mikrofonia ei voi käyttää",message:"Myönnä käyttöoikeus tälle verkkosivulle napsauttamalla osoiterivillä olevaa lukkoa.",dismissButtonAriaLabel:"Sulje"},callMicrophoneAccessDeniedSafari:{title:"Mikrofonia ei voi käyttää",message:"Salli käyttöoikeudet päivittämällä sivu tai tarkista tämän selaimen asetukset ja varmista, että käyttöoikeudet on otettu käyttöön tässä sivustossa.",dismissButtonAriaLabel:"Sulje"},callMicrophoneMutedBySystem:{title:"Järjestelmäasetuksen perusteella sinut on mykistetty.",dismissButtonAriaLabel:"Sulje"},callMicrophoneUnmutedBySystem:{title:"Mikrofonisi palautui käyttöön ja järjestelmä on poistanut sen mykistyksen.",dismissButtonAriaLabel:"Sulje"},callMacOsMicrophoneAccessDenied:{title:"Mikrofonia ei voi käyttää",message:"Myönnä mikrofonin käyttöoikeus macOS:n tietosuoja-asetuksissa.",dismissButtonAriaLabel:"Sulje"},callLocalVideoFreeze:{title:"Verkon kaistanleveys on heikko",message:"Videokuvasi saattaa näkyä keskeytettynä puhelun muille osallistujille.",dismissButtonAriaLabel:"Sulje"},callCameraAccessDenied:{title:"Kameraa ei voi käyttää",message:"Myönnä käyttöoikeus tälle verkkosivulle napsauttamalla osoiterivillä olevaa lukkoa.",dismissButtonAriaLabel:"Sulje"},callCameraAccessDeniedSafari:{title:"Kameraa ei voi käyttää",message:"Salli käyttöoikeudet päivittämällä sivu tai tarkista tämän selaimen asetukset ja varmista, että käyttöoikeudet on otettu käyttöön tässä sivustossa.",dismissButtonAriaLabel:"Sulje"},callCameraAlreadyInUse:{title:"Kameraa ei voi käyttää",message:"Toinen sovellus saattaa jo käyttää sitä.",dismissButtonAriaLabel:"Sulje"},callVideoStoppedBySystem:{title:"Järjestelmä on pysäyttänyt videosi.",dismissButtonAriaLabel:"Sulje"},callVideoRecoveredBySystem:{title:"Videosi näytetään jälleen.",dismissButtonAriaLabel:"Sulje"},callMacOsCameraAccessDenied:{title:"MacOS estää kameran käytön",message:"Päivitä tietosuoja-asetukset, jotta selain voi käyttää kameraasi.",dismissButtonAriaLabel:"Sulje"},callMacOsScreenShareAccessDenied:{title:"MacOS estää näytön jakamisen",message:"Päivitä tietosuoja-asetukset, jotta selain voi tallentaa, mitä näytölläsi tapahtuu.",dismissButtonAriaLabel:"Sulje"},failedToJoinCallGeneric:{title:"Puheluun liittyminen epäonnistui.",dismissButtonAriaLabel:"Sulje"},failedToJoinCallInvalidMeetingLink:{title:"Kokoukseen liittyminen ei onnistu. Linkki on virheellinen.",dismissButtonAriaLabel:"Sulje"},cameraFrozenForRemoteParticipants:{title:"Puhelun muilla osallistujilla on videokuvasi näkymiseen liittyviä ongelmia",message:"Tarkista laitteesi ja verkkosi.",dismissButtonAriaLabel:"Sulje"},unableToStartVideoEffect:{title:"Videotehosteen käyttäminen ei onnistu.",dismissButtonAriaLabel:"Sulje"},startSpotlightWhileMaxParticipantsAreSpotlighted:{title:"Osallistujien valokeilaa ei voi aloittaa",message:"Enimmäismäärä osallistujia on jo valokeilassa.",dismissButtonAriaLabel:"Sulje"},mutedByRemoteParticipant:{title:"Toinen osallistuja mykisti sinut.",dismissButtonAriaLabel:"Sulje"},recordingStarted:{title:"Tallennus on aloitettu.",message:"Liittymällä annat suostumuksesi kokouksen litteroimiseen.",dismissButtonAriaLabel:"Sulje"},transcriptionStarted:{title:"Transkriptio on aloitettu.",message:"Liittymällä annat suostumuksesi kokouksen litteroimiseen.",dismissButtonAriaLabel:"Sulje"},recordingStopped:{title:"Tallennetta tallennetaan.",message:"Tallennus on pysäytetty.",dismissButtonAriaLabel:"Sulje"},transcriptionStopped:{title:"Transkriptiota tallennetaan.",message:"Transkriptio on pysäytetty.",dismissButtonAriaLabel:"Sulje"},recordingAndTranscriptionStarted:{title:"Tallentaminen ja litterointi on aloitettu.",message:"Liittymällä annat suostumuksesi kokouksen litteroimiseen.",dismissButtonAriaLabel:"Sulje"},recordingAndTranscriptionStopped:{title:"Tallennusta ja transkriptiota tallennetaan.",message:"Tallentaminen ja transkriptio on pysäytetty.",dismissButtonAriaLabel:"Sulje"},recordingStoppedStillTranscribing:{title:"Tallennus on pysäytetty.",message:"Transkriptiota ollaan luomassa vain tästä kokouksesta.",dismissButtonAriaLabel:"Sulje"},transcriptionStoppedStillRecording:{title:"Transkriptio on pysäytetty.",message:"Tallennetta ollaan luomassa vain tästä kokouksesta.",dismissButtonAriaLabel:"Sulje"},assignedBreakoutRoomOpened:{title:"Siirrämme sinut määritettyihin huoneeseesi 5 sekunnin kuluttua.",dismissButtonAriaLabel:"Sulje"},assignedBreakoutRoomChanged:{title:"Pienryhmätilasi on muuttunut",message:"Siirrämme sinut määritettyihin huoneeseesi 5 sekunnin kuluttua.",dismissButtonAriaLabel:"Sulje"},assignedBreakoutRoomClosed:{title:"Pienryhmätilasi on suljettu",message:"Siirrämme sinut takaisin kokoukseen 5 sekunnin kuluttua.",dismissButtonAriaLabel:"Sulje"},assignedBreakoutRoomOpenedPromptJoin:{title:"Liitytäänkö pienryhmätilaan?",message:"Sinut on määritetty pienryhmätilaan.",dismissButtonAriaLabel:"Sulje",primaryButtonLabel:"Liity tilaan",secondaryButtonLabel:"Myöhemmin"},breakoutRoomJoined:{title:"Olet liittynyt pienryhmätilaan.",dismissButtonAriaLabel:"Sulje"},breakoutRoomClosingSoon:{title:"Pienryhmätilan aikaraja on täyttymässä.",message:"Tämä huone suljetaan 30 sekunnin kuluttua",dismissButtonAriaLabel:"Sulje"},capabilityTurnVideoOnPresent:{title:"Kamera on otettu käyttöön",message:"Ota se käyttöön, jos haluat jakaa videokuvaa.",dismissButtonAriaLabel:"Sulje"},capabilityTurnVideoOnAbsent:{title:"Kamerasi on pois käytöstä",message:"Et voi enää jakaa videokuvaa.",dismissButtonAriaLabel:"Sulje"},capabilityUnmuteMicPresent:{title:"Mikrofoni on otettu käyttöön",message:"Poista mikrofonin mykistys, jos haluat puhua.",dismissButtonAriaLabel:"Sulje"},capabilityUnmuteMicAbsent:{title:"Mikrofonisi on poissa käytöstä",message:"Et voi enää poistaa mykistystä.",dismissButtonAriaLabel:"Sulje"},togetherModeStarted:{title:"Yhdessä-tila on alkanut",dismissButtonAriaLabel:"Sulje"},togetherModeEnded:{title:"Yhdessä-tila on päättynyt",dismissButtonAriaLabel:"Sulje"}},videoGallery:{screenIsBeingSharedMessage:"Näyttösi jaetaan parhaillaan",screenShareLoadingMessage:"Ladataan käyttäjän {participant} näyttöä",localScreenShareLoadingMessage:"Ladataan näyttöä",localVideoLabel:"Sinä",localVideoCameraSwitcherLabel:"Vaihda kameraa",localVideoMovementLabel:"Siirrettävä paikallisen videon ruutu",localVideoMovementAriaLabel:"Siirrettävä paikallisen videon ruutu",localVideoSelectedDescription:"{cameraName} on valittu",displayNamePlaceholder:"Nimetön osallistuja",fitRemoteParticipantToFrame:"Sovita kehykseen",fillRemoteParticipantFrame:"Täytä kehys",pinParticipantForMe:"Kiinnitä minulle",pinParticipantForMeLimitReached:"Kiinnitys (enimmäisraja saavutettu)",unpinParticipantForMe:"Poista kiinnitys",pinParticipantMenuItemAriaLabel:"Kiinnitä {participantName}",unpinParticipantMenuItemAriaLabel:"Poista henkilön {participantName} kiinnitys",pinnedParticipantAnnouncementAriaLabel:"Kiinnitetty {participantName}",unpinnedParticipantAnnouncementAriaLabel:"Poistettu henkilön {participantName} kiinnitys",startSpotlightVideoTileMenuLabel:"Lisää valokeilaan kaikille",addSpotlightVideoTileMenuLabel:"Lisää valokeilaan",spotlightLimitReachedMenuTitle:"Spotlight-raja saavutettu",stopSpotlightVideoTileMenuLabel:"Poista valokeilasta",stopSpotlightOnSelfVideoTileMenuLabel:"Valokeila",attendeeRole:"Osallistuja",muteParticipantMenuItemLabel:"Mykistä",waitingScreenText:"Odotetaan että muut liittyvät",forbidAudio:"Poista mikrofoni käytöstä",permitAudio:"Salli mikrofoni",forbidAudioTileMenuLabel:"Poista mikrofoni käytöstä",permitAudioTileMenuLabel:"Salli mikrofoni",forbidVideo:"Poista kamera käytöstä",permitVideo:"Salli kamera",forbidVideoTileMenuLabel:"Poista kamera käytöstä",permitVideoTileMenuLabel:"Salli kamera"},dialpad:{placeholderText:"Anna puhelinnumero",deleteButtonAriaLabel:"Poista"},holdButton:{onLabel:"Jatka",offLabel:"Pito",tooltipOnContent:"Jatka puhelua",tooltipOffContent:"Aseta puhelu pitoon"},videoTile:{participantStateRinging:"Soitetaan...",participantReconnecting:"Yhdistetään uudelleen...",participantStateHold:"Pidossa",moreOptionsButtonAriaLabel:"Lisää {displayName} {isMuted} {micDisabledState} {cameraDisabledState} {isHandRaised} {state} {isSpeaking}",moreOptionsParticipantMutedStateMutedAriaLabel:"vaimennettu",moreOptionsParticipantMutedStateUnmutedAriaLabel:"vaimennus poistettu",moreOptionsParticipantHandRaisedAriaLabel:"Käsi nostettuna",moreOptionsParticipantIsSpeakingAriaLabel:"Puhuminen",moreOptionsParticipantMicDisabledAriaLabel:"Mikrofoni poistettu käytöstä",moreOptionsParticipantCameraDisabledAriaLabel:"Kamera poistettu käytöstä"},CameraAndMicrophoneSitePermissionsRequest:{primaryText:"Salli {appName} käyttää kameraa ja mikrofonia",secondaryText:"Näin osallistujat voivat nähdä ja kuulla sinua.",linkText:"Tarvitsetko apua? Hae vianmääritysohjeita",primaryButtonText:"Jatka ilman kameraa ja mikrofonia",ariaLabel:"Salli kameran ja mikrofonin käyttö"},CameraSitePermissionsRequest:{primaryText:"Salli sovelluksen {appName} käyttää kameraasi",secondaryText:"Tätä tarvitaan, jotta muut osallistujat näkevät sinut.",linkText:"Tarvitsetko apua? Hae vianmääritysohjeita",primaryButtonText:"Jatka ilman kameraa",ariaLabel:"Salli kameran käyttö"},MicrophoneSitePermissionsRequest:{primaryText:"Salli sovelluksen {appName} käyttää mikrofoniasi",secondaryText:"Tätä tarvitaan, jotta muut osallistujat kuulevat sinut.",linkText:"Tarvitsetko apua? Hae vianmääritysohjeita",primaryButtonText:"Jatka ilman mikrofonia",ariaLabel:"Salli mikrofonin käyttö"},CameraAndMicrophoneSitePermissionsCheck:{primaryText:"Tarkistetaan kameran ja mikrofonin käyttöoikeutta",secondaryText:"Salli käyttö, jos niin kehotetaan tekemään. Näin osallistujat voivat nähdä ja kuulla sinua.",linkText:"Tarvitsetko apua? Hae vianmääritysohjeita",primaryButtonText:"Jatka ilman kameraa ja mikrofonia",ariaLabel:"Tarkistetaan kameran ja mikrofonin käyttöoikeutta. Salli käyttö pyydettäessä."},CameraSitePermissionsCheck:{primaryText:"Tarkistetaan kameran käyttöoikeutta",secondaryText:"Salli käyttö, jos niin kehotetaan tekemään. Osallistujat näkevät sinut tässä.",linkText:"Tarvitsetko apua? Hae vianmääritysohjeita",primaryButtonText:"Jatka ilman kameraa",ariaLabel:"Tarkistetaan kameran käyttöoikeutta. Salli käyttö pyydettäessä."},MicrophoneSitePermissionsCheck:{primaryText:"Tarkistetaan mikrofonin käyttöoikeutta",secondaryText:"Salli käyttö pyydettäessä. Tätä tarvitaan, jotta muut osallistujat kuulevat sinut.",linkText:"Tarvitsetko apua? Hae vianmääritysohjeita",primaryButtonText:"Jatka ilman mikrofonia",ariaLabel:"Tarkistetaan mikrofonin käyttöoikeutta. Salli käyttö pyydettäessä."},CameraAndMicrophoneSitePermissionsDenied:{primaryText:"Kameraa ja mikrofonia ei voi käyttää",secondaryText:"Myönnä mikrofonin käyttöoikeudet tälle verkkosivulle napsauttamalla osoiterivin lukkokuvaketta. Sivun päivitys saattaa olla pakollinen.",primaryButtonText:"Jatka ilman kameraa ja mikrofonia",linkText:"Tarvitsetko apua? Hae vianmääritysohjeita"},CameraAndMicrophoneSitePermissionsDeniedSafari:{primaryText:"Kameraa ja mikrofonia ei voi käyttää",secondaryText:"Salli käyttöoikeudet päivittämällä sivu tai tarkista tämän selaimen asetukset ja varmista, että käyttöoikeudet on otettu käyttöön tässä sivustossa.",primaryButtonText:"Jatka ilman kameraa ja mikrofonia",linkText:"Tarvitsetko apua? Hae vianmääritysohjeita"},CameraSitePermissionsDenied:{primaryText:"Kameraa ei voi käyttää",secondaryText:"Myönnä kameran käyttöoikeudet tälle verkkosivulle napsauttamalla osoiterivin lukkokuvaketta. Sivun päivitys saattaa olla pakollinen.",primaryButtonText:"Jatka ilman kameraa",linkText:"Tarvitsetko apua? Hae vianmääritysohjeita"},MicrophoneSitePermissionsDenied:{primaryText:"Mikrofonia ei voi käyttää",secondaryText:"Myönnä mikrofonin käyttöoikeudet tälle verkkosivulle napsauttamalla osoiterivin lukkokuvaketta. Sivun päivitys saattaa olla pakollinen.",primaryButtonText:"Jatka ilman mikrofonia",linkText:"Tarvitsetko apua? Hae vianmääritysohjeita"},CameraSitePermissionsDeniedSafari:{primaryText:"Kameraa ei voi käyttää",secondaryText:"Salli käyttöoikeudet päivittämällä sivu tai tarkista tämän selaimen asetukset ja varmista, että käyttöoikeudet on otettu käyttöön tässä sivustossa.",primaryButtonText:"Jatka ilman kameraa",linkText:"Tarvitsetko apua? Hae vianmääritysohjeita"},MicrophoneSitePermissionsDeniedSafari:{primaryText:"Mikrofonia ei voi käyttää",secondaryText:"Salli käyttöoikeudet päivittämällä sivu tai tarkista tämän selaimen asetukset ja varmista, että käyttöoikeudet on otettu käyttöön tässä sivustossa.",primaryButtonText:"Jatka ilman mikrofonia",linkText:"Tarvitsetko apua? Hae vianmääritysohjeita"},UnsupportedBrowser:{primaryText:"Selainta ei tueta",secondaryText:"Liity tähän puheluun käyttämällä yhteensopivaa selainta.",moreHelpLinkText:"Näytä yhteensopivuusvaatimukset"},UnsupportedBrowserVersion:{primaryText:"Selain on päivitettävä",secondaryText:"Jotta puhelu olisi paras mahdollinen, päivitä selain ja yritä liittyä puheluun uudelleen.",moreHelpLinkText:"Näytä yhteensopivuusvaatimukset",continueAnywayButtonText:"Aloita puhelu päivittämättä"},UnsupportedOperatingSystem:{primaryText:"Käyttöjärjestelmää ei tueta",secondaryText:"Liity tähän puheluun käyttämällä laitetta, jossa on yhteensopiva käyttöjärjestelmä.",moreHelpLinkText:"Näytä yhteensopivuusvaatimukset"},BrowserPermissionDenied:{primaryText:"Kamerasi tai mikrofonisi käyttäminen ei onnistu",secondaryText:"Selaimesi ei ehkä voi käyttää kameraasi tai mikrofoniasi. Voit korjata tämän avaamalla Järjestelmäasetukset.",primaryButtonText:"Yritä uudelleen",linkText:"Tarvitsetko apua? Hae vianmääritysohjeita"},BrowserPermissionDeniedIOS:{primaryText:"Jatka sallimalla mikrofonin käyttö",secondaryText:"Tarvitaan, jotta muut osallistujat kuulevat sinut.",primaryButtonText:"Yritä uudelleen",imageAltText:"Kohta, josta mikrofonin ja kameran käyttöoikeus löytyy iOS:issa",linkText:"Tarvitsetko apua? Hae vianmääritysohjeita",step1Text:"Siirry asetussovellukseen.",step2Text:"Vieritä alaspäin tämän selaimen asetuksiin",step3Text:"Ota mikrofoni käyttöön (kameran käyttö on valinnaista)",step4Text:"Yritä liittyä puheluun uudelleen",step1DigitText:"1",step2DigitText:"2",step3DigitText:"3",step4DigitText:"4"},verticalGallery:{leftNavButtonAriaLabel:"edellinen sivu {current}/{total}",rightNavButtonAriaLabel:"seuraava sivu {current}/{total}"},meetingConferencePhoneInfo:{meetingConferencePhoneInfoModalTitle:"Liity puheluun puhelimestasi",meetingConferencePhoneInfoModalDialIn:"Valitse numero",meetingConferencePhoneInfoModalMeetingId:"Anna kokoustunnus",meetingConferencePhoneInfoModalWait:"Odota, että järjestäjä ottaa sinut vastaan",meetingConferencePhoneInfoModalNoPhoneAvailable:"Puhelinta ei ole käytettävissä",meetingConferencePhoneInfoModalTollGeoData:"{country}, {city}",meetingConferencePhoneInfoModalTollFree:"(Maksuton)",meetingConferencePhoneInfoModalToll:"(Maksullinen)"},IncomingCallNotification:{incomingCallNotificationPlaceholderId:"Tuntematon käyttäjä",incomingCallNotificationPlaceholderAlert:"{callerName} soittaa",incomingCallNoticicationAcceptWithAudioAriaLabel:"Vastaa äänipuhelulla",incomingCallNoticicationAcceptWithVideoAriaLabel:"Vastaa videopuhelulla",incomingCallNoticicationRejectAriaLabel:"Hylkää",incomingCallNotificationAcceptButtonLabel:"Hyväksy",incomingCallNotificationRejectButtonLabel:"Hylkää",incomingCallNotificationAccceptWithVideoButtonLabel:"Vastaa videopuhelulla",incomingCallNotificationDismissButtonAriaLabel:"Hylkää"}})},hQt={strings:Jh({participantItem:{isMeText:"(vous)",menuTitle:"Plus d’options",removeButtonLabel:"Supprimer",sharingIconLabel:"Partage",mutedIconLabel:"Muet activé",handRaisedIconLabel:"Main levée – Position {position}",displayNamePlaceholder:"Participant sans nom",participantStateRinging:"Appel en cours...",participantStateHold:"En attente",participantItemAriaLabel:"{displayName}, {handRaisedState}, {mutedState}, {micDisabledState}, {cameraDisabledState}, {sharingState}, {connectionState}",participantItemWithMoreOptionsAriaLabel:"{displayName}, {handRaisedState}, {mutedState}, {micDisabledState}, {cameraDisabledState}, {sharingState}, {connectionState}, autres options",attendeeRole:"Participant",micDisabledIconLabel:"Microphone désactivé",cameraDisabledIconLabel:"Caméra désactivée"},ParticipantList:{overflowParticipantCount:"+{overflowCount} plus"},typingIndicator:{singleUser:"{user} en train d’écrire...",multipleUsers:"{users} sont en train d'écrire...",multipleUsersAbbreviateOne:"{users} et 1 autre en train d'écrire...",multipleUsersAbbreviateMany:"{users} et {numOthers} autres en train d’écrire...",delimiter:", "},sendBox:{placeholderText:"Saisir un message",textTooLong:"La longueur de votre message dépasse la limite maximale.",sendButtonAriaLabel:"Envoyer un message",attachmentUploadsPendingError:"Chargement du fichier en cours, veuillez patienter.",removeAttachment:"Supprimer le fichier",uploading:"Chargement",uploadCompleted:"Téléchargement terminé",attachmentMoreMenu:"Plus d’options"},richTextSendBox:{placeholderText:"Saisir un message",textTooLong:"La longueur de votre message dépasse la limite maximale.",sendButtonAriaLabel:"Envoyer un message",attachmentUploadsPendingError:"Chargement du fichier en cours, veuillez patienter.",imageUploadsPendingError:"Chargement de l’image en cours, veuillez patienter.",removeAttachment:"Supprimer un fichier",uploading:"Téléchargement",uploadCompleted:"Chargement terminé",richTextBoldTooltip:"Gras",richTextItalicTooltip:"Italique",richTextUnderlineTooltip:"Souligner",richTextBulletListTooltip:"Liste à puces",richTextNumberListTooltip:"Liste numérotée",richTextIncreaseIndentTooltip:"Augmenter le retrait",richTextDecreaseIndentTooltip:"Réduire le retrait",richTextInsertTableTooltip:"Insérer un tableau",richTextFormatButtonTooltip:"Format",richTextInsertRowOrColumnMenu:"Insérer",richTextInsertTableMenuTitle:"Insérer une table {column} x {row}",richTextInsertRowAboveMenu:"Insérer au-dessus",richTextInsertRowBelowMenu:"Insérer l’élément ci-dessous",richTextInsertColumnLeftMenu:"Insérer à gauche",richTextInsertColumnRightMenu:"Insérer à droite",richTextDeleteRowOrColumnMenu:"Supprimer",richTextDeleteColumnMenu:"Supprimer la colonne",richTextDeleteRowMenu:"Supprimer une ligne",richTextDeleteTableMenu:"Supprimer le tableau",richTextToolbarAriaLabel:"Barre d'outils de formatage des messages",richTextToolbarMoreButtonAriaLabel:"Autres options",attachmentMoreMenu:"Plus d’options",richTextNewBulletedListItemAnnouncement:"Puce, nouvelle ligne",richTextNewNumberedListItemAnnouncement:"{0}, nouvelle ligne",richTextBulletedListAppliedAnnouncement:"Liste à puces appliquée",richTextNumberedListAppliedAnnouncement:"Liste numérotée appliquée"},realTimeTextModal:{realTimeTextModalAriaLabel:"Activer la boîte de dialogue modale RTT",realTimeTextModalTitle:"Activation de la RTT ?",realTimeTextModalText:"Le texte en temps réel (RTT) sera activé pour tous les participants à la réunion.",realTimeTextConfirmButtonLabel:"Activer",realTimeTextCancelButtonLabel:"Annuler",realTimeTextCloseModalButtonAriaLabel:"Fermer la boîte de dialogue modale RTT"},captionsBanner:{captionsBannerSpinnerText:"Démarrage des légendes...",realTimeTextInputBoxDefaultText:"Tapez votre message en temps réel",realTimeTextInputErrorMessage:"Le message ne peut pas dépasser 2 000 caractères",realTimeTextBannerTitle:"RTT",realTimeTextBannerContent:"RTT (texte en temps réel) est activé pour tous les participants pendant toute la durée de la réunion.",realTimeTextBannerLinkLabel:"En savoir plus",captionsOnlyContainerTitle:"Sous-titres",realTimeTextOnlyContainerTitle:"Texte en temps réel",captionsAndRealTimeTextContainerTitle:"Légendes et texte en temps réel",expandButtonAriaLabel:"Développer",minimizeButtonAriaLabel:"Réduire"},mentionPopover:{mentionPopoverHeader:"Suggestions"},imageOverlay:{downloadButtonLabel:"Télécharger",dismissButtonAriaLabel:"Fermer",overlayVisibleMessage:"Superposition des détails de l’image"},messageStatusIndicator:{deliveredAriaLabel:"Message envoyé",deliveredTooltipText:"Envoyé",seenAriaLabel:"Message vu par d’autres personnes",seenTooltipText:"Vu",readByTooltipText:"Lu par {messageThreadReadCount} participants sur {remoteParticipantsCount}",sendingAriaLabel:"Envoi du message",sendingTooltipText:"Envoi",failedToSendAriaLabel:"Échec d'envoi du message",failedToSendTooltipText:"Échec de l'envoi"},endCallButton:{label:"Quitter",tooltipContent:"Quitter l'appel",leaveOption:"Partir",endCallOption:"Terminer l'appel pour tous"},cameraButton:{onLabel:"Caméra",offLabel:"Caméra",tooltipDisabledContent:"La caméra est désactivée.",tooltipOnContent:"Désactiver la caméra",tooltipOffContent:"Activer la caméra",tooltipVideoLoadingContent:"Chargement de la vidéo",cameraMenuTitle:"Caméra",cameraMenuTooltip:"Choisissez l'appareil photo",cameraButtonSplitRoleDescription:"Bouton partagé",onSplitButtonAriaLabel:"Désactiver la caméra",offSplitButtonAriaLabel:"Activer la caméra",cameraActionTurnedOnAnnouncement:"Votre caméra a été activée",cameraActionTurnedOffAnnouncement:"Votre caméra a été désactivée",onSplitButtonPrimaryActionCamera:"Désactiver l’appareil photo",offSplitButtonPrimaryActionCamera:"Activer la caméra",cameraPrimaryActionSplitButtonTitle:"Utiliser l’appareil photo",videoEffectsMenuItemTitle:"Effets",cameraButtonAriaDescription:"options de la caméra"},microphoneButton:{onLabel:"Microphone",offLabel:"Microphone",tooltipDisabledContent:"Le microphone est désactivé.",tooltipOnContent:"Désactiver le micro",tooltipOffContent:"Activer le micro",microphoneMenuTitle:"Microphone",microphoneMenuTooltip:"Choisissez le micro",speakerMenuTitle:"Haut-parleur",speakerMenuTooltip:"Choisissez le haut-parleur",microphoneButtonSplitRoleDescription:"Bouton partagé",onSplitButtonAriaLabel:"Désactiver le micro",offSplitButtonAriaLabel:"Réactiver le micro",microphoneActionTurnedOnAnnouncement:"Votre micro a été activé",microphoneActionTurnedOffAnnouncement:"Votre micro a été désactivé",offSplitButtonMicrophonePrimaryAction:"Réactiver le micro",onSplitButtonMicrophonePrimaryAction:"Désactiver le micro",microphonePrimaryActionSplitButtonTitle:"Utiliser le microphone",microphoneAriaDescription:"Options audio",deepNoiseSuppressionTitle:"Suppression du bruit",deepNoiseSuppressionOnAnnouncement:"La suppression du bruit profond a été activée",deepNoiseSuppressionOffAnnouncement:"La suppression du bruit profond a été désactivée"},devicesButton:{label:"Appareils",tooltipContent:"Gérer les appareils",cameraMenuTitle:"Appareil photo",cameraMenuTooltip:"Choisissez l'appareil photo",audioDeviceMenuTitle:"Périphérique audio",audioDeviceMenuTooltip:"Choisissez un périphérique audio",microphoneMenuTitle:"Microphone",microphoneMenuTooltip:"Choisissez le micro",speakerMenuTitle:"Haut-parleur",speakerMenuTooltip:"Choisissez le haut-parleur"},participantsButton:{label:"Personnes",ariaLabel:"Contacts",tooltipContent:"Afficher les participants",menuHeader:"Pendant cet appel",participantsListButtonLabel:"{numParticipants} contacts",muteAllButtonLabel:"Désactiver tous les micros",copyInviteLinkButtonLabel:"Copier le lien d'invitation",copyInviteLinkActionedAriaLabel:"Le lien d’invitation a été copié."},screenShareButton:{onLabel:"Arrêter la présentation",offLabel:"Présenter",tooltipDisabledContent:"La présentation est désactivée.",tooltipOnContent:"Présentation de votre écran",tooltipOffContent:"Présenter votre écran"},raiseHandButton:{offLabel:"Augmenter",onLabel:"Inférieur",tooltipDisabledContent:"L'action lever la main est désactivée",tooltipOnContent:"Baisser la main",tooltipOffContent:"Lever les mains"},reactionButton:{label:"Réagir",ariaLabel:"Réagir",tooltipDisabledContent:"L’action de réaction est désactivée",tooltipContent:"Envoyer une réaction",likeReactionTooltipContent:"J’aime",heartReactionTooltipContent:"Aimer",laughReactionTooltipContent:"Rire",applauseReactionTooltipContent:"Acclamation",surprisedReactionTooltipContent:"Surpris"},realTimeText:{isTypingText:"Saisie RTT"},captionsSettingsModal:{captionsSettingsModalTitle:"Paramètres des sous-titres",captionsSettingsSpokenLanguageDropdownLabel:"Langue parlée",captionsSettingsCaptionLanguageDropdownLabel:"Langue des sous-titres",captionsSettingsSpokenLanguageDropdownInfoText:"Langue parlée par tous les participants à cet appel.",captionsSettingsCaptionLanguageDropdownInfoText:"Les sous-titres apparaîtront dans cette langue.",captionsSettingsConfirmButtonLabel:"Confirmer",captionsSettingsCancelButtonLabel:"Annuler",captionsSettingsModalAriaLabel:"Paramétrage des légendes Modal",captionsSettingsCloseModalButtonAriaLabel:"Paramètres de fermeture des sous-titres"},spokenLanguages:{"ar-ae":"Arabe – E.A.U.","ar-sa":"Arabe – Arabie saoudite","da-dk":"Danois","de-de":"Allemand – Allemagne","en-au":"Anglais – Australie","en-ca":"Anglais – Canada","en-gb":"Anglais – Royaume-Uni","en-in":"Anglais – Inde","en-nz":"Anglais – Nouvelle-Zélande","en-us":"Anglais – États-Unis","es-es":"Espagnol – Espagne (tri moderne)","es-mx":"Espagnol – Mexique","fi-fi":"Finnois","fr-ca":"Français – Canada","fr-fr":"Français – France","hi-in":"Hindi","it-it":"Italien – Italie","ja-jp":"Japonais","ko-kr":"Coréen","nb-no":"Norvégien (Bokmål)","nl-be":"Néerlandais – Belgique","nl-nl":"Néerlandais – Pays-Bas","pl-pl":"Polonais","pt-br":"Portugais – Brésil","ru-ru":"Russe","sv-se":"Suédois","zh-cn":"Chinois – République populaire de Chine","zh-hk":"Chinois – Hong Kong SAR","cs-cz":"Tchèque","pt-pt":"Portugais – Portugal","tr-tr":"Turc","vi-vn":"Vietnamien","th-th":"Thaï","he-il":"Hébreu","cy-gb":"Gallois","uk-ua":"Ukrainien","el-gr":"Grec","hu-hu":"Hongrois","ro-ro":"Roumain","sk-sk":"Slovaque","zh-tw":"Chinois – Taiwan"},captionLanguages:{ar:"Arabe",da:"Danois",de:"Allemand",en:"Anglais",es:"Espagnol",fi:"Finnois","fr-ca":"Français – Canada",fr:"Français – France",hi:"Hindi",it:"Italien",ja:"Japonais",ko:"Coréen",nb:"Norvégien (Bokmål)",nl:"Néerlandais",pl:"Polonais",pt:"Portugais – Brésil",ru:"Russe",sv:"Suédois","zh-Hans":"Chinois (simplifié)","zh-Hant":"Chinois (traditionnel)",cs:"Tchèque","pt-pt":"Portugais – Portugal",tr:"Turc",vi:"Vietnamien",th:"Thaï",he:"Hébreu",cy:"Gallois",uk:"Ukrainien",el:"Grec",hu:"Hongrois",ro:"Roumain",sk:"Slovaque"},startCaptionsButton:{onLabel:"Activer les sous-titres",offLabel:"Désactiver les sous-titres",tooltipOnContent:"Désactiver les sous-titres",tooltipOffContent:"Activer les sous-titres"},startRealTimeTextButton:{label:"Activer RTT pour cet appel",tooltipOffContent:"Activer RTT pour cet appel"},messageThread:{yesterday:"Hier",sunday:"Dimanche",monday:"Lundi",tuesday:"Mardi",wednesday:"Mercredi",thursday:"Jeudi",friday:"Vendredi",saturday:"Samedi",participantJoined:"a rejoint la conversation.",participantLeft:"a quitté le conversation.",editMessage:"Modifier",removeMessage:"Supprimer",resendMessage:"Réessayer l'envoi",failToSendTag:"Échec de l'envoi",editedTag:"Modifié",liveAuthorIntro:"Message de {author}",editedMessageLiveAuthorIntro:"Message modifié de {author}",editedMessageLocalUserLiveAuthorIntro:"Message modifié",messageContentAriaText:"{status} {author} a dit {message}.",messageContentMineAriaText:"{status} Vous avez dit {message}.",editBoxTextLimit:"Votre message dépasse la limite de {limitNumber} caractères",editBoxPlaceholderText:"Modifier votre message",newMessagesIndicator:"Nouveaux messages",noDisplayNameSub:"Sans nom",editBoxCancelButton:"Annuler",editBoxSubmitButton:"Terminé",messageReadCount:"Lu par {messageReadByCount} participants sur {remoteParticipantsCount}",actionMenuMoreOptions:"Plus d’options",downloadAttachment:"Télécharger un fichier",openAttachment:"Ouvrir le fichier",blockedWarningText:"Ce message a été supprimé en raison d’une stratégie de l’organisation.",blockedWarningLinkText:"Détails",attachmentCardGroupMessage:"Le message a {attachmentCount} pièce jointe",messageDeletedAnnouncementAriaLabel:"Le message est supprimé",richTextBoldTooltip:"Gras",richTextItalicTooltip:"Italique",richTextUnderlineTooltip:"Souligner",richTextBulletListTooltip:"Liste à puces",richTextNumberListTooltip:"Liste numérotée",richTextIncreaseIndentTooltip:"Augmenter le retrait",richTextDecreaseIndentTooltip:"Réduire le retrait",richTextInsertTableTooltip:"Insérer un tableau",richTextFormatButtonTooltip:"Format",richTextInsertRowOrColumnMenu:"Insérer",richTextInsertTableMenuTitle:"Insérer une table {column} x {row}",richTextInsertRowAboveMenu:"Insérer au-dessus",richTextInsertRowBelowMenu:"Insérer l’élément ci-dessous",richTextInsertColumnLeftMenu:"Insérer à gauche",richTextInsertColumnRightMenu:"Insérer à droite",richTextDeleteRowOrColumnMenu:"Supprimer",richTextDeleteColumnMenu:"Supprimer la colonne",richTextDeleteRowMenu:"Supprimer une ligne",richTextDeleteTableMenu:"Supprimer le tableau",richTextToolbarMoreButtonAriaLabel:"Autres options",attachmentUploadsPendingError:"Chargement du fichier en cours, veuillez patienter.",imageUploadsPendingError:"Chargement de l’image en cours, veuillez patienter.",richTextNewBulletedListItemAnnouncement:"Puce, nouvelle ligne",richTextNewNumberedListItemAnnouncement:"{0}, nouvelle ligne",richTextBulletedListAppliedAnnouncement:"Liste à puces appliquée",richTextNumberedListAppliedAnnouncement:"Liste numérotée appliquée"},errorBar:{unableToReachChatService:"Vous êtes hors connexion",accessDenied:"Impossible d’accéder aux services de conversation. Vérifiez les informations d’identification de l’utilisateur fournies",userNotInChatThread:"Vous n’est plus dans ce thread de conversation",sendMessageNotInChatThread:"Échec de l’envoi du message car vous n’êtes plus dans ce thread de conversation",sendMessageGeneric:"Échec de l’envoi du message",callingNetworkFailure:"Perturbation de l’appel de connexion : vous semblez être hors connexion",startVideoGeneric:"Échec du démarrage de la vidéo",stopVideoGeneric:"Échec de l’arrêt de la vidéo",muteGeneric:"Échec de la désactivation du son du microphone",unmuteGeneric:"Échec de l’activation du son du microphone",speakingWhileMuted:"Votre micro est désactivé",startScreenShareGeneric:"Un problème est survenu durant le démarrage du partage d’écran.",stopScreenShareGeneric:"Échec de l’arrêt du partage d’écran",callNetworkQualityLow:"La qualité de réseau est faible.",teamsMeetingCallNetworkQualityLow:"La qualité de réseau est faible.",callNoSpeakerFound:"Aucun haut-parleur ou casque n’a été trouvé. Connectez un périphérique audio pour entendre l’appel.",callNoMicrophoneFound:"Aucun micro n’a été trouvé. Connectez un périphérique d’entrée audio.",callMicrophoneAccessDenied:"Impossible d’accéder au microphone. Cliquez sur le verrou dans la barre d’adresses pour accorder l’autorisation à cette page Web.",callMicrophoneAccessDeniedSafari:"Impossible d’accéder au microphone. Actualisez la page pour autoriser les autorisations, ou vérifiez les paramètres de ce navigateur et vérifiez que les autorisations sont activées pour ce site web.",callMicrophoneMutedBySystem:"Votre micro est désactivé par votre système.",callMicrophoneUnmutedBySystem:"Votre micro a été récupéré et la son a été activé par votre système.",callMacOsMicrophoneAccessDenied:"Impossible d’accéder au microphone. Accordez l’autorisation de microphone dans vos paramètres de confidentialité macOS.",callLocalVideoFreeze:"La bande passante réseau est médiocre. Votre vidéo peut apparaître suspendue pour les autres participants à l’appel.",callCameraAccessDenied:"Impossible d’accéder à la caméra. Cliquez sur le verrou dans la barre d’adresses pour accorder l’autorisation à cette page Web.",callCameraAccessDeniedSafari:"Impossible d’accéder à la caméra. Actualisez la page pour autoriser les autorisations, ou vérifiez les paramètres de ce navigateur et vérifiez que les autorisations sont activées pour ce site web.",callCameraAlreadyInUse:"Impossible d’accéder à la caméra. Il est peut-être déjà utilisé par une autre application.",callVideoStoppedBySystem:"Votre vidéo a été arrêtée par votre système.",callVideoRecoveredBySystem:"Votre vidéo a repris.",callMacOsCameraAccessDenied:"MacOS bloque l’accès à votre caméra. Mettez à jour vos paramètres de confidentialité pour autoriser ce navigateur à accéder à votre caméra.",callMacOsScreenShareAccessDenied:"MacOS bloque le partage d’écran. Mettez à jour vos paramètres de confidentialité pour permettre à ce navigateur d’enregistrer votre écran.",dismissButtonAriaLabel:"Fermer",failedToJoinCallGeneric:"Nous n’avons pas pu rejoindre l’appel.",failedToJoinCallInvalidMeetingLink:"Impossible de rejoindre la réunion. Lien non valide.",cameraFrozenForRemoteParticipants:"Les utilisateurs de l’appel rencontrent des problèmes pour voir votre vidéo. Vérifiez vos appareils et votre réseau.",unableToStartVideoEffect:"Impossible d’appliquer l’effet vidéo.",startSpotlightWhileMaxParticipantsAreSpotlighted:"Impossible de lancer la mise en lumière sur le(s) participant(s), car le nombre maximum de participants est déjà mis en lumière.",mutedByRemoteParticipant:"Votre micro a été désactivé par un autre participant."},notificationStack:{callingNetworkFailure:{title:"Appel de connexion en cours",message:"Vous semblez être hors connexion. Vérifiez votre connexion réseau et réessayez.",dismissButtonAriaLabel:"Fermer"},startVideoGeneric:{title:"Échec du démarrage de la vidéo.",dismissButtonAriaLabel:"Fermer"},stopVideoGeneric:{title:"Échec de l’arrêt de la vidéo.",dismissButtonAriaLabel:"Fermer"},muteGeneric:{title:"Impossible de désactiver le micro.",dismissButtonAriaLabel:"Fermer"},unmuteGeneric:{title:"Échec de l’activation du micro.",dismissButtonAriaLabel:"Fermer"},speakingWhileMuted:{title:"Le son de votre micro est désactivé.",dismissButtonAriaLabel:"Fermer"},startScreenShareGeneric:{title:"Un problème est survenu durant le démarrage du partage d’écran.",dismissButtonAriaLabel:"Fermer"},stopScreenShareGeneric:{title:"Échec de l’arrêt du partage d’écran.",dismissButtonAriaLabel:"Fermer"},callNetworkQualityLow:{title:"La qualité de réseau est faible.",dismissButtonAriaLabel:"Fermer"},teamsMeetingCallNetworkQualityLow:{title:"La qualité de réseau est faible.",dismissButtonAriaLabel:"Fermer",message:"Rejoignez cet appel à partir de votre téléphone pour obtenir un meilleur son. Vous pouvez continuer à afficher la réunion sur cet appareil.",primaryButtonLabel:"Participer par téléphone"},callNoSpeakerFound:{title:"Haut-parleurs ou casque introuvables",message:"Connectez un périphérique audio pour entendre l’appel.",dismissButtonAriaLabel:"Fermer"},callNoMicrophoneFound:{title:"Aucun microphone trouvé",message:"Connectez un périphérique d’entrée audio.",dismissButtonAriaLabel:"Fermer"},callMicrophoneAccessDenied:{title:"Impossible d’accéder au microphone",message:"Cliquez sur le verrou dans la barre d’adresses pour accorder l’autorisation à cette page Web.",dismissButtonAriaLabel:"Fermer"},callMicrophoneAccessDeniedSafari:{title:"Impossible d’accéder au microphone",message:"Actualisez la page pour autoriser les autorisations, ou vérifiez les paramètres de ce navigateur et vérifiez que les autorisations sont activées pour ce site web.",dismissButtonAriaLabel:"Fermer"},callMicrophoneMutedBySystem:{title:"Votre micro est désactivé par votre système.",dismissButtonAriaLabel:"Fermer"},callMicrophoneUnmutedBySystem:{title:"Votre micro a été récupéré et la son a été activé par votre système.",dismissButtonAriaLabel:"Fermer"},callMacOsMicrophoneAccessDenied:{title:"Impossible d’accéder au microphone",message:"Accordez l’autorisation de microphone dans vos paramètres de confidentialité macOS.",dismissButtonAriaLabel:"Fermer"},callLocalVideoFreeze:{title:"La bande passante réseau est médiocre",message:"Votre vidéo peut apparaître suspendue pour d’autres participants à l’appel.",dismissButtonAriaLabel:"Fermer"},callCameraAccessDenied:{title:"Impossible d’accéder à la caméra",message:"Cliquez sur le verrou dans la barre d’adresses pour accorder l’autorisation à cette page Web.",dismissButtonAriaLabel:"Fermer"},callCameraAccessDeniedSafari:{title:"Impossible d’accéder à la caméra",message:"Actualisez la page pour autoriser les autorisations, ou vérifiez les paramètres de ce navigateur et vérifiez que les autorisations sont activées pour ce site web.",dismissButtonAriaLabel:"Fermer"},callCameraAlreadyInUse:{title:"Impossible d’accéder à la caméra",message:"Il est peut-être déjà utilisé par une autre application.",dismissButtonAriaLabel:"Fermer"},callVideoStoppedBySystem:{title:"Votre vidéo a été arrêtée par votre système.",dismissButtonAriaLabel:"Fermer"},callVideoRecoveredBySystem:{title:"Votre vidéo a repris.",dismissButtonAriaLabel:"Fermer"},callMacOsCameraAccessDenied:{title:"MacOS bloque l’accès à votre caméra",message:"Mettez à jour vos paramètres de confidentialité pour autoriser ce navigateur à accéder à votre caméra.",dismissButtonAriaLabel:"Fermer"},callMacOsScreenShareAccessDenied:{title:"MacOS bloque le partage d’écran",message:"Mettez à jour vos paramètres de confidentialité pour permettre à ce navigateur d’enregistrer votre écran.",dismissButtonAriaLabel:"Fermer"},failedToJoinCallGeneric:{title:"Nous n’avons pas pu rejoindre l’appel.",dismissButtonAriaLabel:"Fermer"},failedToJoinCallInvalidMeetingLink:{title:"Impossible de rejoindre la réunion. Lien non valide.",dismissButtonAriaLabel:"Fermer"},cameraFrozenForRemoteParticipants:{title:"Les utilisateurs de l’appel rencontrent des problèmes pour voir votre vidéo",message:"Vérifiez vos appareils et votre réseau.",dismissButtonAriaLabel:"Fermer"},unableToStartVideoEffect:{title:"Impossible d’appliquer l’effet vidéo.",dismissButtonAriaLabel:"Fermer"},startSpotlightWhileMaxParticipantsAreSpotlighted:{title:"Impossible de mettre en évidence le ou les participants",message:"Le nombre maximum de participants est déjà connu.",dismissButtonAriaLabel:"Fermer"},mutedByRemoteParticipant:{title:"Votre micro a été désactivé par un autre participant.",dismissButtonAriaLabel:"Fermer"},recordingStarted:{title:"L'enregistrement a démarré.",message:"En participant, vous autorisez la transcription de cette réunion.",dismissButtonAriaLabel:"Fermer"},transcriptionStarted:{title:"La transcription a démarré.",message:"En participant, vous autorisez la transcription de cette réunion.",dismissButtonAriaLabel:"Fermer"},recordingStopped:{title:"Enregistrement en cours de sauvegarde.",message:"L’enregistrement s’est arrêté.",dismissButtonAriaLabel:"Fermer"},transcriptionStopped:{title:"La transcription est en cours d’enregistrement.",message:"Arrêt de la transcription.",dismissButtonAriaLabel:"Fermer"},recordingAndTranscriptionStarted:{title:"Démarrage de l’enregistrement et de la transcription.",message:"En participant, vous autorisez la transcription de cette réunion.",dismissButtonAriaLabel:"Fermer"},recordingAndTranscriptionStopped:{title:"Sauvegarde en cours de l’enregistrement et de la transcription.",message:"L’enregistrement et la transcription ont pris fin.",dismissButtonAriaLabel:"Fermer"},recordingStoppedStillTranscribing:{title:"L’enregistrement s’est arrêté.",message:"À présent, vous ne transcrivez que cette réunion.",dismissButtonAriaLabel:"Fermer"},transcriptionStoppedStillRecording:{title:"Arrêt de la transcription.",message:"Vous n’enregistrez désormais que cette réunion.",dismissButtonAriaLabel:"Fermer"},assignedBreakoutRoomOpened:{title:"Nous allons vous déplacer vers la salle affectée dans 5 secondes.",dismissButtonAriaLabel:"Fermer"},assignedBreakoutRoomChanged:{title:"Votre salle pour petit groupe a changé",message:"Nous allons vous déplacer vers la salle affectée dans 5 secondes.",dismissButtonAriaLabel:"Fermer"},assignedBreakoutRoomClosed:{title:"Votre salle pour petit groupe s’est fermée",message:"Nous vous redéverrons à votre réunion dans 5 secondes.",dismissButtonAriaLabel:"Fermer"},assignedBreakoutRoomOpenedPromptJoin:{title:"Rejoindre la salle de réunion ?",message:"Vous avez reçu une invitation à rejoindre une salle pour petit groupe.",dismissButtonAriaLabel:"Fermer",primaryButtonLabel:"Rejoindre une salle",secondaryButtonLabel:"Plus tard"},breakoutRoomJoined:{title:"Vous avez rejoint une salle pour petit groupe.",dismissButtonAriaLabel:"Proche"},breakoutRoomClosingSoon:{title:"Limite de temps de la salle sur le point d’expirer.",message:"Cette salle se fermera dans 30 secondes.",dismissButtonAriaLabel:"Proche"},capabilityTurnVideoOnPresent:{title:"Votre caméra a été activée",message:"Activez-la si vous souhaitez partager une vidéo.",dismissButtonAriaLabel:"Fermer"},capabilityTurnVideoOnAbsent:{title:"Votre caméra est désactivée",message:"Vous ne pouvez plus partager de vidéo.",dismissButtonAriaLabel:"Fermer"},capabilityUnmuteMicPresent:{title:"Votre micro a été activé",message:"Activer le son si vous voulez parler.",dismissButtonAriaLabel:"Fermer"},capabilityUnmuteMicAbsent:{title:"Votre microphone est désactivé",message:"Vous ne pouvez plus activer le son.",dismissButtonAriaLabel:"Fermer"},togetherModeStarted:{title:"Togethermode a démarré",dismissButtonAriaLabel:"Fermez"},togetherModeEnded:{title:"Togethermode est terminé",dismissButtonAriaLabel:"Fermez"}},videoGallery:{screenIsBeingSharedMessage:"Vous partagez votre écran.",screenShareLoadingMessage:"Chargement de l’écran de {participant}",localScreenShareLoadingMessage:"Chargement de votre écran",localVideoLabel:"Vous",localVideoCameraSwitcherLabel:"Changer de caméra",localVideoMovementLabel:"Vignette de vidéo locale déplaçable",localVideoMovementAriaLabel:"Mosaïque de vidéo locale déplaçable",localVideoSelectedDescription:"{cameraName} sélectionnée",displayNamePlaceholder:"Participant sans nom",fitRemoteParticipantToFrame:"Ajuster à l'image",fillRemoteParticipantFrame:"Remplir l'image",pinParticipantForMe:"Épingler pour moi",pinParticipantForMeLimitReached:"Épingler (limite atteinte)",unpinParticipantForMe:"Détacher",pinParticipantMenuItemAriaLabel:"Épingler {participantName}",unpinParticipantMenuItemAriaLabel:"Détacher {participantName}",pinnedParticipantAnnouncementAriaLabel:"{participantName} a été épinglé",unpinnedParticipantAnnouncementAriaLabel:"{participantName} a été détaché",startSpotlightVideoTileMenuLabel:"Mettre en évidence pour tout le monde",addSpotlightVideoTileMenuLabel:"Ajouter la mise en évidence",spotlightLimitReachedMenuTitle:"Limite Spotlight atteinte",stopSpotlightVideoTileMenuLabel:"Arrêter la mise en évidence",stopSpotlightOnSelfVideoTileMenuLabel:"Quitter la mise en évidence",attendeeRole:"Participant(e)",muteParticipantMenuItemLabel:"Désactiver le micro / muet",waitingScreenText:"En attente des autres participants",forbidAudio:"Désactiver le microphone",permitAudio:"Autoriser le micro",forbidAudioTileMenuLabel:"Désactiver le microphone",permitAudioTileMenuLabel:"Autoriser le micro",forbidVideo:"Désactiver la caméra",permitVideo:"Autoriser la caméra",forbidVideoTileMenuLabel:"Désactiver la caméra",permitVideoTileMenuLabel:"Autoriser la caméra"},dialpad:{placeholderText:"Entrer un numéro de téléphone",deleteButtonAriaLabel:"Supprimer"},holdButton:{onLabel:"Reprendre",offLabel:"Mettre en attente",tooltipOnContent:"Reprendre l’appel",tooltipOffContent:"Mettre l’appel en attente"},videoTile:{participantStateRinging:"Appel en cours...",participantReconnecting:"Reconnexion...",participantStateHold:"En attente",moreOptionsButtonAriaLabel:"Autres options {displayName} {isMuted} {micDisabledState} {cameraDisabledState} {isHandRaised} {state} {isSpeaking}",moreOptionsParticipantMutedStateMutedAriaLabel:"son désactivé",moreOptionsParticipantMutedStateUnmutedAriaLabel:"désactivé",moreOptionsParticipantHandRaisedAriaLabel:"Main levée",moreOptionsParticipantIsSpeakingAriaLabel:"Parler",moreOptionsParticipantMicDisabledAriaLabel:"Microphone désactivé",moreOptionsParticipantCameraDisabledAriaLabel:"Caméra désactivée"},CameraAndMicrophoneSitePermissionsRequest:{primaryText:"Autoriser {appName} à utiliser votre caméra et votre microphone",secondaryText:"Cela permet aux participants de vous voir et de vous entendre.",linkText:"Besoin d’aide ? Obtenir de l’aide sur la résolution des problèmes",primaryButtonText:"Continuer sans caméra ni micro",ariaLabel:"Autoriser l'accès à la caméra et au microphone"},CameraSitePermissionsRequest:{primaryText:"Autoriser {appName} à utiliser votre caméra",secondaryText:"Cela permet aux participants de vous voir.",linkText:"Besoin d’aide ? Obtenir de l’aide sur la résolution des problèmes",primaryButtonText:"Continuer sans caméra",ariaLabel:"Autoriser l’accès à la caméra"},MicrophoneSitePermissionsRequest:{primaryText:"Autoriser {appName} à utiliser votre micro",secondaryText:"Cela permet aux participants de vous écouter.",linkText:"Besoin d’aide ? Obtenir de l’aide sur la résolution des problèmes",primaryButtonText:"Continuer sans microphone",ariaLabel:"Autoriser l’accès au micro"},CameraAndMicrophoneSitePermissionsCheck:{primaryText:"Vérification de l’accès à la caméra et au microphone",secondaryText:"Autorisez l’accès si vous y êtes invité. Cela permet aux participants de vous voir et de vous entendre.",linkText:"Besoin d’aide ? Obtenir de l’aide sur la résolution des problèmes",primaryButtonText:"Continuer sans caméra ni micro",ariaLabel:"Vérification de l’accès à la caméra et au microphone. Autorisez l’accès si vous y êtes invité."},CameraSitePermissionsCheck:{primaryText:"Vérification de l’accès à la caméra",secondaryText:"Autorisez l’accès si vous y êtes invité. Cela permet aux participants de vous voir.",linkText:"Besoin d’aide ? Obtenir de l’aide sur la résolution des problèmes",primaryButtonText:"Continuer sans appareil photo",ariaLabel:"Vérification de l’accès à la caméra. Autorisez l’accès si vous y êtes invité."},MicrophoneSitePermissionsCheck:{primaryText:"Vérification de l’accès au microphone",secondaryText:"Autorisez l’accès si vous y êtes invité. Cela permet aux participants de vous entendre.",linkText:"Besoin d’aide ? Obtenir de l’aide sur la résolution des problèmes",primaryButtonText:"Continuer sans microphone",ariaLabel:"Vérification de l’accès au microphone. Autorisez l’accès si vous y êtes invité."},CameraAndMicrophoneSitePermissionsDenied:{primaryText:"Nous n’avons pas pu accéder au micro et à la caméra.",secondaryText:"Cliquez sur l’icône de verrouillage dans la barre d’adresses pour accorder des autorisations de microphone à cette page Web. Une actualisation de page peut être nécessaire.",primaryButtonText:"Continuer sans caméra ni microphone",linkText:"Besoin d’aide ? Obtenir de l’aide sur la résolution des problèmes"},CameraAndMicrophoneSitePermissionsDeniedSafari:{primaryText:"Nous n’avons pas pu accéder au micro et à la caméra.",secondaryText:"Actualisez la page pour autoriser les autorisations, ou vérifiez les paramètres de ce navigateur et vérifiez que les autorisations sont activées pour ce site web.",primaryButtonText:"Continuer sans caméra ni microphone",linkText:"Besoin d’aide ? Obtenir de l’aide sur la résolution des problèmes"},CameraSitePermissionsDenied:{primaryText:"Impossible d’accéder à la caméra",secondaryText:"Cliquez sur l’icône de verrouillage dans la barre d’adresses pour accorder des autorisations d’appareil photo à cette page Web. Une actualisation de page peut être nécessaire.",primaryButtonText:"Continuer sans caméra",linkText:"Besoin d’aide ? Obtenir de l’aide sur la résolution des problèmes"},MicrophoneSitePermissionsDenied:{primaryText:"Nous n’avons pas pu accéder au micro.",secondaryText:"Cliquez sur l’icône de verrouillage dans la barre d’adresses pour accorder des autorisations de microphone à cette page Web. Une actualisation de page peut être nécessaire.",primaryButtonText:"Continuer sans microphone",linkText:"Besoin d’aide ? Obtenir de l’aide sur la résolution des problèmes"},CameraSitePermissionsDeniedSafari:{primaryText:"Nous n’avons pas pu accéder à la caméra.",secondaryText:"Actualisez la page pour autoriser les autorisations, ou vérifiez les paramètres de ce navigateur et vérifiez que les autorisations sont activées pour ce site web.",primaryButtonText:"Continuer sans appareil photo",linkText:"Besoin d’aide ? Obtenir de l’aide sur la résolution des problèmes"},MicrophoneSitePermissionsDeniedSafari:{primaryText:"Impossible d’accéder au microphone",secondaryText:"Actualisez la page pour autoriser les autorisations, ou vérifiez les paramètres de ce navigateur et vérifiez que les autorisations sont activées pour ce site web.",primaryButtonText:"Continuer sans microphone",linkText:"Besoin d’aide ? Obtenir de l’aide sur la résolution des problèmes"},UnsupportedBrowser:{primaryText:"Navigateur non pris en charge",secondaryText:"Rejoignez cet appel à l’aide d’un navigateur compatible.",moreHelpLinkText:"Voir les exigences de compatibilité"},UnsupportedBrowserVersion:{primaryText:"Mise à jour du navigateur nécessaire",secondaryText:"Pour garantir le meilleur appel possible, mettez à jour votre navigateur, puis réessayez de rejoindre l’appel.",moreHelpLinkText:"Voir les exigences de compatibilité",continueAnywayButtonText:"Démarrer l’appel sans mettre à jour"},UnsupportedOperatingSystem:{primaryText:"Système d'exploitation non pris en charge",secondaryText:"Rejoignez cet appel à l’aide d’un appareil avec un système d’exploitation compatible.",moreHelpLinkText:"Voir les exigences de compatibilité"},BrowserPermissionDenied:{primaryText:"Impossible d’utiliser votre caméra ou votre micro",secondaryText:"Votre navigateur n’a peut-être pas accès à votre caméra ou à votre micro. Pour résoudre ce problème, ouvrez Préférences système.",primaryButtonText:"Réessayer",linkText:"Besoin d’aide ? Obtenir de l’aide sur la résolution des problèmes"},BrowserPermissionDeniedIOS:{primaryText:"Autoriser l’accès au microphone pour continuer",secondaryText:"Ainsi, les autres participants peuvent vous entendre.",primaryButtonText:"Réessayer",imageAltText:"Emplacement des autorisations pour le microphone et la caméra pour iOS",linkText:"Besoin d’aide ? Obtenir de l’aide sur la résolution des problèmes",step1Text:"Accéder à l’application Paramètres",step2Text:"Faites défiler vers le bas pour accéder aux paramètres de ce navigateur",step3Text:"Activer le microphone (caméra facultative)",step4Text:"Réessayez de rejoindre l’appel",step1DigitText:"1",step2DigitText:"2",step3DigitText:"3",step4DigitText:"4"},verticalGallery:{leftNavButtonAriaLabel:"page précédente {current} de {total}",rightNavButtonAriaLabel:"page suivante{current} de {total}"},meetingConferencePhoneInfo:{meetingConferencePhoneInfoModalTitle:"Rejoindre l’appel à partir de votre téléphone",meetingConferencePhoneInfoModalDialIn:"Composer le numéro",meetingConferencePhoneInfoModalMeetingId:"Entrer l’ID de réunion",meetingConferencePhoneInfoModalWait:"Attendez d’être admis par l’organisateur",meetingConferencePhoneInfoModalNoPhoneAvailable:"Aucun téléphone disponible",meetingConferencePhoneInfoModalTollGeoData:"{country}, {city}",meetingConferencePhoneInfoModalTollFree:"(numéro gratuit)",meetingConferencePhoneInfoModalToll:"(numéro payant)"},IncomingCallNotification:{incomingCallNotificationPlaceholderId:"Utilisateur inconnu",incomingCallNotificationPlaceholderAlert:"{callerName} appelle",incomingCallNoticicationAcceptWithAudioAriaLabel:"Accepter avec l'audio",incomingCallNoticicationAcceptWithVideoAriaLabel:"Accepter avec la vidéo",incomingCallNoticicationRejectAriaLabel:"Rejeter",incomingCallNotificationAcceptButtonLabel:"Accepter",incomingCallNotificationRejectButtonLabel:"Refuser",incomingCallNotificationAccceptWithVideoButtonLabel:"Accepter avec une vidéo",incomingCallNotificationDismissButtonAriaLabel:"Ignorer"}})},pQt={strings:Jh({participantItem:{isMeText:"(vous)",menuTitle:"Plus d’options",removeButtonLabel:"Supprimer",sharingIconLabel:"Partage",mutedIconLabel:"Muet activé",handRaisedIconLabel:"Main levée – Position {position}",displayNamePlaceholder:"Participant sans nom",participantStateRinging:"Appel en cours...",participantStateHold:"En attente",participantItemAriaLabel:"{displayName}, {handRaisedState}, {mutedState}, {micDisabledState}, {cameraDisabledState}, {sharingState}, {connectionState}",participantItemWithMoreOptionsAriaLabel:"Plus d’options {displayName}, {handRaisedState}, {mutedState}, {micDisabledState}, {cameraDisabledState}, {sharingState}, {connectionState}",attendeeRole:"Participant(e)",micDisabledIconLabel:"Microphone désactivé",cameraDisabledIconLabel:"Caméra désactivée"},ParticipantList:{overflowParticipantCount:"+{overflowCount} plus"},typingIndicator:{singleUser:"{user} en train d’écrire...",multipleUsers:"{users} sont en train d'écrire...",multipleUsersAbbreviateOne:"{users} et 1 autre en train d'écrire...",multipleUsersAbbreviateMany:"{users} et {numOthers} autres en train d’écrire...",delimiter:", "},sendBox:{placeholderText:"Saisir un message",textTooLong:"La longueur de votre message dépasse la limite maximale.",sendButtonAriaLabel:"Envoyer un message",attachmentUploadsPendingError:"Chargement du fichier en cours, veuillez patienter.",removeAttachment:"Supprimer un fichier",uploading:"Chargement",uploadCompleted:"Téléchargement terminé",attachmentMoreMenu:"Plus d’options"},richTextSendBox:{placeholderText:"Saisir un message",textTooLong:"La longueur de votre message dépasse la limite maximale.",sendButtonAriaLabel:"Envoyer un message",attachmentUploadsPendingError:"Chargement du fichier en cours, veuillez patienter.",imageUploadsPendingError:"Chargement de l’image en cours, veuillez patienter.",removeAttachment:"Supprimer un fichier",uploading:"Chargement",uploadCompleted:"Téléchargement terminé",richTextBoldTooltip:"Gras",richTextItalicTooltip:"Italique",richTextUnderlineTooltip:"Souligner",richTextBulletListTooltip:"Liste à puces",richTextNumberListTooltip:"Liste numérotée",richTextIncreaseIndentTooltip:"Augmenter le retrait",richTextDecreaseIndentTooltip:"Réduire le retrait",richTextInsertTableTooltip:"Insérer un tableau",richTextFormatButtonTooltip:"Format",richTextInsertRowOrColumnMenu:"Insérer",richTextInsertTableMenuTitle:"Insérer une table {column} x {row}",richTextInsertRowAboveMenu:"Insérer au-dessus",richTextInsertRowBelowMenu:"Insérer l’élément ci-dessous",richTextInsertColumnLeftMenu:"Insérer à gauche",richTextInsertColumnRightMenu:"Insérer à droite",richTextDeleteRowOrColumnMenu:"Supprimer",richTextDeleteColumnMenu:"Supprimer la colonne",richTextDeleteRowMenu:"Supprimer une ligne",richTextDeleteTableMenu:"Supprimer le tableau",richTextToolbarAriaLabel:"Barre d’outils de formatage des messages",richTextToolbarMoreButtonAriaLabel:"Autres options",attachmentMoreMenu:"Plus d’options",richTextNewBulletedListItemAnnouncement:"Puce, nouvelle ligne",richTextNewNumberedListItemAnnouncement:"{0}, nouvelle ligne",richTextBulletedListAppliedAnnouncement:"Liste à puces appliquée",richTextNumberedListAppliedAnnouncement:"Liste numérotée appliquée"},realTimeTextModal:{realTimeTextModalAriaLabel:"Activer la boîte de dialogue modale RTT",realTimeTextModalTitle:"Activation de la RTT?",realTimeTextModalText:"Le texte en temps réel (RTT) sera activé pour tous les participants à la réunion.",realTimeTextConfirmButtonLabel:"Activer",realTimeTextCancelButtonLabel:"Annuler",realTimeTextCloseModalButtonAriaLabel:"Fermer la boîte de dialogue modale RTT"},captionsBanner:{captionsBannerSpinnerText:"Démarrage des légendes...",realTimeTextInputBoxDefaultText:"Inscrivez votre message en temps réel",realTimeTextInputErrorMessage:"Le message ne peut pas dépasser 2000 caractères",realTimeTextBannerTitle:"RTT",realTimeTextBannerContent:"RTT (texte en temps réel) est activé pour tous les participants pendant toute la durée de la réunion.",realTimeTextBannerLinkLabel:"En savoir plus",captionsOnlyContainerTitle:"Sous-titres en direct",realTimeTextOnlyContainerTitle:"Texte en temps réel",captionsAndRealTimeTextContainerTitle:"Sous-titres en direct et texte en temps réel",expandButtonAriaLabel:"Étendre",minimizeButtonAriaLabel:"Réduire"},mentionPopover:{mentionPopoverHeader:"Suggestions"},imageOverlay:{downloadButtonLabel:"Télécharger",dismissButtonAriaLabel:"Fermer",overlayVisibleMessage:"Superposition des détails de l’image"},messageStatusIndicator:{deliveredAriaLabel:"Message envoyé",deliveredTooltipText:"Envoyé",seenAriaLabel:"Message vu par d’autres personnes",seenTooltipText:"Vu",readByTooltipText:"Lu par {messageThreadReadCount} participants sur {remoteParticipantsCount}",sendingAriaLabel:"Envoi du message",sendingTooltipText:"Envoi",failedToSendAriaLabel:"Échec d'envoi du message",failedToSendTooltipText:"Échec de l'envoi"},endCallButton:{label:"Quitter",tooltipContent:"Quitter l'appel",leaveOption:"Quitter",endCallOption:"Terminer l'appel pour tous"},cameraButton:{onLabel:"Caméra",offLabel:"Caméra",tooltipDisabledContent:"La caméra est désactivée.",tooltipOnContent:"Désactiver la caméra",tooltipOffContent:"Activer la caméra",tooltipVideoLoadingContent:"Chargement de la vidéo",cameraMenuTitle:"Caméra",cameraMenuTooltip:"Choisissez la caméra.",cameraButtonSplitRoleDescription:"Bouton partagé",onSplitButtonAriaLabel:"Désactiver la caméra",offSplitButtonAriaLabel:"Activer la caméra",cameraActionTurnedOnAnnouncement:"Votre caméra a été activée.",cameraActionTurnedOffAnnouncement:"Votre caméra a été désactivée.",onSplitButtonPrimaryActionCamera:"Désactiver la caméra",offSplitButtonPrimaryActionCamera:"Activer la caméra",cameraPrimaryActionSplitButtonTitle:"Utiliser la caméra",videoEffectsMenuItemTitle:"Effets",cameraButtonAriaDescription:"options de la caméra"},microphoneButton:{onLabel:"Microphone",offLabel:"Microphone",tooltipDisabledContent:"Le microphone est désactivé.",tooltipOnContent:"Désactiver le micro",tooltipOffContent:"Activer le micro",microphoneMenuTitle:"Microphone",microphoneMenuTooltip:"Choisissez le micro.",speakerMenuTitle:"Haut-parleur",speakerMenuTooltip:"Choisissez le haut-parleur.",microphoneButtonSplitRoleDescription:"Bouton partagé",onSplitButtonAriaLabel:"Désactiver le micro",offSplitButtonAriaLabel:"Réactiver le micro",microphoneActionTurnedOnAnnouncement:"Votre micro a été activé.",microphoneActionTurnedOffAnnouncement:"Votre micro a été désactivé.",offSplitButtonMicrophonePrimaryAction:"Réactiver le micro",onSplitButtonMicrophonePrimaryAction:"Désactiver le micro",microphonePrimaryActionSplitButtonTitle:"Utiliser le microphone",microphoneAriaDescription:"Options audio",deepNoiseSuppressionTitle:"Suppression du bruit",deepNoiseSuppressionOnAnnouncement:"La suppression du bruit profond a été activée.",deepNoiseSuppressionOffAnnouncement:"La suppression du bruit profond a été désactivée."},devicesButton:{label:"Périphériques",tooltipContent:"Gérer les périphériques",cameraMenuTitle:"Caméra",cameraMenuTooltip:"Choisissez la caméra.",audioDeviceMenuTitle:"Appareil audio",audioDeviceMenuTooltip:"Choisissez un périphérique appareil audio.",microphoneMenuTitle:"Microphone",microphoneMenuTooltip:"Choisissez le micro.",speakerMenuTitle:"Haut-parleur",speakerMenuTooltip:"Choisissez le haut-parleur."},participantsButton:{label:"Personnes",ariaLabel:"Contacts",tooltipContent:"Afficher les participants",menuHeader:"Pendant cet appel",participantsListButtonLabel:"{numParticipants} contacts",muteAllButtonLabel:"Désactiver tous les micros",copyInviteLinkButtonLabel:"Copier le lien d'invitation",copyInviteLinkActionedAriaLabel:"Le lien d’invitation a été copié."},screenShareButton:{onLabel:"Arrêter la présentation",offLabel:"Présenter",tooltipDisabledContent:"La présentation est désactivée.",tooltipOnContent:"Présentation de votre écran",tooltipOffContent:"Présenter votre écran"},raiseHandButton:{offLabel:"Augmenter",onLabel:"Inférieur",tooltipDisabledContent:"L'action lever la main est désactivée.",tooltipOnContent:"Baisser la main",tooltipOffContent:"Lever les mains"},reactionButton:{label:"Réagir",ariaLabel:"Réagir",tooltipDisabledContent:"L’action de réaction est désactivée.",tooltipContent:"Envoyer une réaction",likeReactionTooltipContent:"J’aime",heartReactionTooltipContent:"Aimer",laughReactionTooltipContent:"Rire",applauseReactionTooltipContent:"Acclamation",surprisedReactionTooltipContent:"Surpris"},realTimeText:{isTypingText:"Saisie RTT"},captionsSettingsModal:{captionsSettingsModalTitle:"Paramètres des sous-titres",captionsSettingsSpokenLanguageDropdownLabel:"Langue parlée",captionsSettingsCaptionLanguageDropdownLabel:"Langue des sous-titres",captionsSettingsSpokenLanguageDropdownInfoText:"Langue parlée par tous les participants à cet appel.",captionsSettingsCaptionLanguageDropdownInfoText:"Les sous-titres apparaîtront dans cette langue.",captionsSettingsConfirmButtonLabel:"Confirmer",captionsSettingsCancelButtonLabel:"Annuler",captionsSettingsModalAriaLabel:"Paramétrage des légendes Modal",captionsSettingsCloseModalButtonAriaLabel:"Paramètres de fermeture des sous-titres"},spokenLanguages:{"ar-ae":"Arabe – E.A.U.","ar-sa":"Arabe – Arabie saoudite","da-dk":"Danois","de-de":"Allemand – Allemagne","en-au":"Anglais – Australie","en-ca":"Anglais – Canada","en-gb":"Anglais – Royaume-Uni","en-in":"Anglais – Inde","en-nz":"Anglais – Nouvelle-Zélande","en-us":"Anglais – États-Unis","es-es":"Espagnol – Espagne (tri moderne)","es-mx":"Espagnol – Mexique","fi-fi":"Finnois","fr-ca":"Français – Canada","fr-fr":"Français – France","hi-in":"Hindi","it-it":"Italien – Italie","ja-jp":"Japonais","ko-kr":"Coréen","nb-no":"Norvégien (Bokmål)","nl-be":"Néerlandais – Belgique","nl-nl":"Néerlandais – Pays-Bas","pl-pl":"Polonais","pt-br":"Portugais – Brésil","ru-ru":"Russe","sv-se":"Suédois","zh-cn":"Chinois – République populaire de Chine","zh-hk":"Chinois – Hong Kong SAR","cs-cz":"Tchèque","pt-pt":"Portugais – Portugal","tr-tr":"Turc","vi-vn":"Vietnamien","th-th":"Thaï","he-il":"Hébreu","cy-gb":"Gallois","uk-ua":"Ukrainien","el-gr":"Grec","hu-hu":"Hongrois","ro-ro":"Roumain","sk-sk":"Slovaque","zh-tw":"Chinois – Taiwan"},captionLanguages:{ar:"Arabe",da:"Danois",de:"Allemand",en:"Anglais",es:"Espagnol",fi:"Finnois","fr-ca":"Français – Canada",fr:"Français – France",hi:"Hindi",it:"Italien",ja:"Japonais",ko:"Coréen",nb:"Norvégien (Bokmål)",nl:"Néerlandais",pl:"Polonais",pt:"Portugais – Brésil",ru:"Russe",sv:"Suédois","zh-Hans":"Chinois (simplifié)","zh-Hant":"Chinois (traditionnel)",cs:"Tchèque","pt-pt":"Portugais – Portugal",tr:"Turc",vi:"Vietnamien",th:"Thaï",he:"Hébreu",cy:"Gallois",uk:"Ukrainien",el:"Grec",hu:"Hongrois",ro:"Roumain",sk:"Slovaque"},startCaptionsButton:{onLabel:"Activer les sous-titres",offLabel:"Désactiver les sous-titres",tooltipOnContent:"Désactiver les sous-titres",tooltipOffContent:"Activer les sous-titres"},startRealTimeTextButton:{label:"Activer RTT pour cet appel",tooltipOffContent:"Activer RTT pour cet appel"},messageThread:{yesterday:"Hier",sunday:"Dimanche",monday:"Lundi",tuesday:"Mardi",wednesday:"Mercredi",thursday:"Jeudi",friday:"Vendredi",saturday:"Samedi",participantJoined:"a rejoint le clavardage.",participantLeft:"a quitté le clavardage.",editMessage:"Modifier",removeMessage:"Supprimer",resendMessage:"Réessayer l'envoi",failToSendTag:"Échec de l'envoi",editedTag:"Modifié",liveAuthorIntro:"Message de {author}",editedMessageLiveAuthorIntro:"Message de {author} modifié",editedMessageLocalUserLiveAuthorIntro:"Message modifié",messageContentAriaText:"{status} {author} a dit {message}.",messageContentMineAriaText:"{status} Vous avez dit {message}.",editBoxTextLimit:"Votre message dépasse la limite de {limitNumber} caractères.",editBoxPlaceholderText:"Modifier votre message",newMessagesIndicator:"Nouveaux messages",noDisplayNameSub:"Sans nom",editBoxCancelButton:"Annuler",editBoxSubmitButton:"Terminé",messageReadCount:"Lu par {messageReadByCount} participants sur {remoteParticipantsCount}",actionMenuMoreOptions:"Plus d’options",downloadAttachment:"Télécharger un fichier",openAttachment:"Ouvrir le fichier",blockedWarningText:"Ce message a été supprimé en raison d’une stratégie de l’organisation.",blockedWarningLinkText:"Détails",attachmentCardGroupMessage:"Le message a {attachmentCount} pièce jointe.",messageDeletedAnnouncementAriaLabel:"Le message est supprimé.",richTextBoldTooltip:"Gras",richTextItalicTooltip:"Italique",richTextUnderlineTooltip:"Souligner",richTextBulletListTooltip:"Liste à puces",richTextNumberListTooltip:"Liste numérotée",richTextIncreaseIndentTooltip:"Augmenter le retrait",richTextDecreaseIndentTooltip:"Réduire le retrait",richTextInsertTableTooltip:"Insérer un tableau",richTextFormatButtonTooltip:"Format",richTextInsertRowOrColumnMenu:"Insérer",richTextInsertTableMenuTitle:"Insérer une table {column} x {row}",richTextInsertRowAboveMenu:"Insérer au-dessus",richTextInsertRowBelowMenu:"Insérer l’élément ci-dessous",richTextInsertColumnLeftMenu:"Insérer à gauche",richTextInsertColumnRightMenu:"Insérer à droite",richTextDeleteRowOrColumnMenu:"Supprimer",richTextDeleteColumnMenu:"Supprimer la colonne",richTextDeleteRowMenu:"Supprimer une ligne",richTextDeleteTableMenu:"Supprimer le tableau",richTextToolbarMoreButtonAriaLabel:"Autres options",attachmentUploadsPendingError:"Chargement du fichier en cours, veuillez patienter.",imageUploadsPendingError:"Chargement de l’image en cours, veuillez patienter.",richTextNewBulletedListItemAnnouncement:"Puce, nouvelle ligne",richTextNewNumberedListItemAnnouncement:"{0}, nouvelle ligne",richTextBulletedListAppliedAnnouncement:"Liste à puces appliquée",richTextNumberedListAppliedAnnouncement:"Liste numérotée appliquée"},errorBar:{unableToReachChatService:"Vous êtes hors connexion.",accessDenied:"Impossible d’accéder aux services de clavardage. Vérifiez les informations d’identification de l’utilisateur(-trice) fournies.",userNotInChatThread:"Vous n’êtes plus dans ce fil de clavardage.",sendMessageNotInChatThread:"Échec de l’envoi du message, car vous n’êtes plus dans ce fil de clavardage.",sendMessageGeneric:"Échec de l’envoi du message",callingNetworkFailure:"Perturbation de l’appel de connexion : vous semblez être hors connexion.",startVideoGeneric:"Échec du démarrage de la vidéo",stopVideoGeneric:"Échec de l’arrêt de la vidéo",muteGeneric:"Échec de la désactivation du son du microphone",unmuteGeneric:"Échec de l’activation du son du microphone",speakingWhileMuted:"Votre micro est désactivé.",startScreenShareGeneric:"Désolé, un problème est survenu durant le démarrage du partage d’écran.",stopScreenShareGeneric:"Échec de l’arrêt du partage d’écran",callNetworkQualityLow:"La qualité de réseau est faible.",teamsMeetingCallNetworkQualityLow:"La qualité de réseau est faible.",callNoSpeakerFound:"Aucun haut-parleur ou casque n’a été trouvé. Connectez un périphérique audio pour entendre l’appel.",callNoMicrophoneFound:"Aucun micro n’a été trouvé. Connectez un périphérique d’entrée audio.",callMicrophoneAccessDenied:"Impossible d’accéder au microphone. Cliquez sur le verrou dans la barre d’adresses pour accorder l’autorisation à cette page Web.",callMicrophoneAccessDeniedSafari:"Impossible d’accéder au microphone. Actualisez la page pour autoriser les autorisations, ou vérifiez les paramètres de ce navigateur et vérifiez que les autorisations sont activées pour ce site web.",callMicrophoneMutedBySystem:"Votre micro est désactivé par votre système.",callMicrophoneUnmutedBySystem:"Votre micro a été récupéré et la son a été activé par votre système.",callMacOsMicrophoneAccessDenied:"Impossible d’accéder au microphone. Accordez l’autorisation de microphone dans vos paramètres de confidentialité macOS.",callLocalVideoFreeze:"La bande passante réseau est médiocre. Votre vidéo peut apparaître suspendue pour les autres participants à l’appel.",callCameraAccessDenied:"Impossible d’accéder à la caméra. Cliquez sur le verrou dans la barre d’adresses pour accorder l’autorisation à cette page Web.",callCameraAccessDeniedSafari:"Impossible d’accéder à la caméra. Actualisez la page pour autoriser les autorisations, ou vérifiez les paramètres de ce navigateur et vérifiez que les autorisations sont activées pour ce site Web.",callCameraAlreadyInUse:"Impossible d’accéder à la caméra. Il est peut-être déjà utilisé par une autre application.",callVideoStoppedBySystem:"Votre vidéo a été arrêtée par votre système.",callVideoRecoveredBySystem:"Votre vidéo a repris.",callMacOsCameraAccessDenied:"MacOS bloque l’accès à votre caméra. Mettez à jour vos paramètres de confidentialité pour autoriser ce navigateur à accéder à votre caméra.",callMacOsScreenShareAccessDenied:"MacOS bloque le partage d’écran. Mettez à jour vos paramètres de confidentialité pour permettre à ce navigateur d’enregistrer votre écran.",dismissButtonAriaLabel:"Fermer",failedToJoinCallGeneric:"Désolé, nous n’avons pas pu rejoindre l’appel.",failedToJoinCallInvalidMeetingLink:"Impossible de rejoindre la réunion. Lien non valide.",cameraFrozenForRemoteParticipants:"Les utilisateurs de l’appel rencontrent des problèmes pour voir votre vidéo. Vérifiez vos périphériques et votre réseau.",unableToStartVideoEffect:"Impossible d’appliquer l’effet vidéo.",startSpotlightWhileMaxParticipantsAreSpotlighted:"Impossible de lancer la mise en évidence sur le(s) participant(s), car le nombre maximum de participants est déjà mis en évidence.",mutedByRemoteParticipant:"Votre micro a été désactivé par un(e) autre participant(e)."},notificationStack:{callingNetworkFailure:{title:"Appel de connexion en cours",message:"Vous semblez être hors connexion. Veuillez vérifier votre connexion réseau et réessayer.",dismissButtonAriaLabel:"Fermer"},startVideoGeneric:{title:"Échec du démarrage de la vidéo.",dismissButtonAriaLabel:"Fermer"},stopVideoGeneric:{title:"Échec de l’arrêt de la vidéo.",dismissButtonAriaLabel:"Fermer"},muteGeneric:{title:"Impossible de désactiver le son.",dismissButtonAriaLabel:"Fermer"},unmuteGeneric:{title:"Échec de l’activation du micro.",dismissButtonAriaLabel:"Fermer"},speakingWhileMuted:{title:"Le son de votre micro est désactivé.",dismissButtonAriaLabel:"Fermer"},startScreenShareGeneric:{title:"Désolé, un problème est survenu durant le démarrage du partage d’écran.",dismissButtonAriaLabel:"Fermer"},stopScreenShareGeneric:{title:"Échec de l’arrêt du partage d’écran.",dismissButtonAriaLabel:"Fermer"},callNetworkQualityLow:{title:"La qualité de réseau est faible.",dismissButtonAriaLabel:"Fermer"},teamsMeetingCallNetworkQualityLow:{title:"La qualité de réseau est faible.",dismissButtonAriaLabel:"Fermer",message:"Rejoignez cet appel à partir de votre téléphone pour obtenir un meilleur son. Vous pouvez continuer à afficher la réunion sur ce périphérique.",primaryButtonLabel:"Participer par téléphone"},callNoSpeakerFound:{title:"Haut-parleurs ou casque introuvables",message:"Connectez un appareil audio pour entendre l’appel.",dismissButtonAriaLabel:"Fermer"},callNoMicrophoneFound:{title:"Aucun microphone trouvé",message:"Connectez un périphérique d’entrée audio.",dismissButtonAriaLabel:"Fermer"},callMicrophoneAccessDenied:{title:"Désolé, nous n’avons pas pu accéder au micro.",message:"Cliquez sur le verrou dans la barre d’adresses pour accorder l’autorisation à cette page Web.",dismissButtonAriaLabel:"Fermer"},callMicrophoneAccessDeniedSafari:{title:"Désolé, nous n’avons pas pu accéder au micro.",message:"Actualisez la page pour autoriser les autorisations, ou vérifiez les paramètres de ce navigateur et vérifiez que les autorisations sont activées pour ce site Web.",dismissButtonAriaLabel:"Fermer"},callMicrophoneMutedBySystem:{title:"Votre micro est désactivé par votre système.",dismissButtonAriaLabel:"Fermer"},callMicrophoneUnmutedBySystem:{title:"Votre micro a été récupéré et la son a été activé par votre système.",dismissButtonAriaLabel:"Fermer"},callMacOsMicrophoneAccessDenied:{title:"Désolé, nous n’avons pas pu accéder au micro.",message:"Accordez l’autorisation de microphone dans vos paramètres de confidentialité macOS.",dismissButtonAriaLabel:"Fermer"},callLocalVideoFreeze:{title:"La bande passante réseau est médiocre.",message:"Votre vidéo peut apparaître suspendue pour d’autres participants à l’appel.",dismissButtonAriaLabel:"Fermer"},callCameraAccessDenied:{title:"Désolé, nous n’avons pas pu accéder à la caméra.",message:"Cliquez sur le verrou dans la barre d’adresses pour accorder l’autorisation à cette page Web.",dismissButtonAriaLabel:"Fermer"},callCameraAccessDeniedSafari:{title:"Désolé, nous n’avons pas pu accéder à la caméra.",message:"Actualisez la page pour autoriser les autorisations, ou vérifiez les paramètres de ce navigateur et vérifiez que les autorisations sont activées pour ce site Web.",dismissButtonAriaLabel:"Fermer"},callCameraAlreadyInUse:{title:"Désolé, nous n’avons pas pu accéder à la caméra.",message:"Il est peut-être déjà utilisé par une autre application.",dismissButtonAriaLabel:"Fermer"},callVideoStoppedBySystem:{title:"Votre vidéo a été arrêtée par votre système.",dismissButtonAriaLabel:"Fermer"},callVideoRecoveredBySystem:{title:"Votre vidéo a repris.",dismissButtonAriaLabel:"Fermer"},callMacOsCameraAccessDenied:{title:"MacOS bloque l’accès à votre caméra.",message:"Mettez à jour vos paramètres de confidentialité pour autoriser ce navigateur à accéder à votre caméra.",dismissButtonAriaLabel:"Fermer"},callMacOsScreenShareAccessDenied:{title:"MacOS bloque le partage d’écran",message:"Mettez à jour vos paramètres de confidentialité pour permettre à ce navigateur d’enregistrer votre écran.",dismissButtonAriaLabel:"Fermer"},failedToJoinCallGeneric:{title:"Désolé, nous n’avons pas pu rejoindre l’appel.",dismissButtonAriaLabel:"Fermer"},failedToJoinCallInvalidMeetingLink:{title:"Impossible de rejoindre la réunion. Lien non valide.",dismissButtonAriaLabel:"Fermer"},cameraFrozenForRemoteParticipants:{title:"Les utilisateurs de l’appel rencontrent des problèmes pour voir votre vidéo.",message:"Vérifiez vos périphériques et votre réseau.",dismissButtonAriaLabel:"Fermer"},unableToStartVideoEffect:{title:"Impossible d’appliquer l’effet vidéo.",dismissButtonAriaLabel:"Fermer"},startSpotlightWhileMaxParticipantsAreSpotlighted:{title:"Impossible de mettre en évidence le ou les participants",message:"Le nombre maximum de participants est déjà mis en évidence.",dismissButtonAriaLabel:"Fermer"},mutedByRemoteParticipant:{title:"Votre micro a été désactivé par un(e) autre participant(e).",dismissButtonAriaLabel:"Fermer"},recordingStarted:{title:"L'enregistrement a démarré.",message:"En participant, vous autorisez la transcription de cette réunion.",dismissButtonAriaLabel:"Fermer"},transcriptionStarted:{title:"La transcription a démarré.",message:"En participant, vous autorisez la transcription de cette réunion.",dismissButtonAriaLabel:"Fermer"},recordingStopped:{title:"Enregistrement en cours de sauvegarde.",message:"L’enregistrement s’est arrêté.",dismissButtonAriaLabel:"Fermer"},transcriptionStopped:{title:"La transcription est en cours d’enregistrement.",message:"Arrêt de la transcription.",dismissButtonAriaLabel:"Fermer"},recordingAndTranscriptionStarted:{title:"Démarrage de l’enregistrement et de la transcription.",message:"En participant, vous autorisez la transcription de cette réunion.",dismissButtonAriaLabel:"Fermer"},recordingAndTranscriptionStopped:{title:"Sauvegarde en cours de l’enregistrement et de la transcription.",message:"L’enregistrement et la transcription ont pris fin.",dismissButtonAriaLabel:"Fermer"},recordingStoppedStillTranscribing:{title:"L’enregistrement s’est arrêté.",message:"À présent, vous ne transcrivez que cette réunion.",dismissButtonAriaLabel:"Fermer"},transcriptionStoppedStillRecording:{title:"Arrêt de la transcription.",message:"Vous n’enregistrez désormais que cette réunion.",dismissButtonAriaLabel:"Fermer"},assignedBreakoutRoomOpened:{title:"Nous allons vous déplacer vers la salle affectée dans 5 secondes.",dismissButtonAriaLabel:"Fermer"},assignedBreakoutRoomChanged:{title:"Votre salle pour petit groupe a changé.",message:"Nous allons vous déplacer vers la salle affectée dans 5 secondes.",dismissButtonAriaLabel:"Fermer"},assignedBreakoutRoomClosed:{title:"Votre salle pour petit groupe s’est fermée",message:"Nous vous redirigerons vers votre réunion dans 5 secondes.",dismissButtonAriaLabel:"Fermer"},assignedBreakoutRoomOpenedPromptJoin:{title:"Voulez-vous rejoindre cette salle pour petit groupe?",message:"Vous avez reçu une invitation à rejoindre une salle pour petit groupe.",dismissButtonAriaLabel:"Fermer",primaryButtonLabel:"Rejoindre une salle",secondaryButtonLabel:"Plus tard"},breakoutRoomJoined:{title:"Vous avez rejoint une salle pour petit groupe.",dismissButtonAriaLabel:"Fermer"},breakoutRoomClosingSoon:{title:"Limite de temps de la salle sur le point d’expirer.",message:"Cette salle se fermera dans 30 secondes.",dismissButtonAriaLabel:"Fermer"},capabilityTurnVideoOnPresent:{title:"Votre caméra a été activée",message:"Activez-la si vous souhaitez partager une vidéo.",dismissButtonAriaLabel:"Fermer"},capabilityTurnVideoOnAbsent:{title:"Votre caméra est désactivée",message:"Vous ne pouvez plus partager de vidéo.",dismissButtonAriaLabel:"Fermer"},capabilityUnmuteMicPresent:{title:"Votre microphone a été activé",message:"Activer le son si vous voulez parler.",dismissButtonAriaLabel:"Fermer"},capabilityUnmuteMicAbsent:{title:"Votre microphone est désactivé",message:"Vous ne pouvez plus activer le son.",dismissButtonAriaLabel:"Fermer"},togetherModeStarted:{title:"Togethermode a démarré",dismissButtonAriaLabel:"Fermez"},togetherModeEnded:{title:"Togethermode est terminé",dismissButtonAriaLabel:"Fermez"}},videoGallery:{screenIsBeingSharedMessage:"Vous partagez votre écran.",screenShareLoadingMessage:"Chargement de l’écran de {participant}",localScreenShareLoadingMessage:"Chargement de votre écran",localVideoLabel:"Vous",localVideoCameraSwitcherLabel:"Changer de caméra",localVideoMovementLabel:"Vignette de vidéo locale déplaçable",localVideoMovementAriaLabel:"Vignette de vidéo locale déplaçable",localVideoSelectedDescription:"{cameraName} sélectionnée",displayNamePlaceholder:"Participant(e) sans nom",fitRemoteParticipantToFrame:"Ajuster à l'image",fillRemoteParticipantFrame:"Remplir l'image",pinParticipantForMe:"Épingler pour moi",pinParticipantForMeLimitReached:"Épingler (limite atteinte)",unpinParticipantForMe:"Détacher",pinParticipantMenuItemAriaLabel:"Épingler {participantName}",unpinParticipantMenuItemAriaLabel:"Détacher {participantName}",pinnedParticipantAnnouncementAriaLabel:"{participantName} a été épinglé.",unpinnedParticipantAnnouncementAriaLabel:"{participantName} a été détaché.",startSpotlightVideoTileMenuLabel:"Mettre en évidence pour tout le monde",addSpotlightVideoTileMenuLabel:"Ajouter la mise en évidence",spotlightLimitReachedMenuTitle:"Limite de mise en évidence atteinte",stopSpotlightVideoTileMenuLabel:"Arrêter la mise en évidence",stopSpotlightOnSelfVideoTileMenuLabel:"Quitter la mise en évidence",attendeeRole:"Participant(e)",muteParticipantMenuItemLabel:"Désactiver le micro/muet",waitingScreenText:"En attente des autres participants",forbidAudio:"Désactiver le micro",permitAudio:"Autoriser le micro",forbidAudioTileMenuLabel:"Désactiver le micro",permitAudioTileMenuLabel:"Autoriser le micro",forbidVideo:"Désactiver la caméra",permitVideo:"Autoriser la caméra",forbidVideoTileMenuLabel:"Désactiver la caméra",permitVideoTileMenuLabel:"Autoriser la caméra"},dialpad:{placeholderText:"Entrer un numéro de téléphone",deleteButtonAriaLabel:"Supprimer"},holdButton:{onLabel:"Reprendre",offLabel:"Mettre en attente",tooltipOnContent:"Reprendre l’appel",tooltipOffContent:"Mettre l’appel en attente"},videoTile:{participantStateRinging:"Appel en cours...",participantReconnecting:"Reconnexion...",participantStateHold:"En attente",moreOptionsButtonAriaLabel:"Plus d’options {displayName} {isMuted} {micDisabledState} {cameraDisabledState} {isHandRaised} {state} {isSpeaking}",moreOptionsParticipantMutedStateMutedAriaLabel:"son désactivé",moreOptionsParticipantMutedStateUnmutedAriaLabel:"son réactivé",moreOptionsParticipantHandRaisedAriaLabel:"Main levée",moreOptionsParticipantIsSpeakingAriaLabel:"Parler",moreOptionsParticipantMicDisabledAriaLabel:"Microphone désactivé",moreOptionsParticipantCameraDisabledAriaLabel:"Caméra désactivée"},CameraAndMicrophoneSitePermissionsRequest:{primaryText:"Autoriser {appName} à utiliser votre caméra et votre microphone",secondaryText:"Cela permet aux participants de vous voir et de vous entendre.",linkText:"Avez-vous besoin d’aide? Obtenir de l’aide sur la résolution des problèmes",primaryButtonText:"Continuer sans caméra ni micro",ariaLabel:"Autoriser l'accès à la caméra et au microphone"},CameraSitePermissionsRequest:{primaryText:"Autoriser {appName} à utiliser votre caméra",secondaryText:"Cela permet aux participants de vous voir.",linkText:"Avez-vous besoin d’aide? Obtenir de l’aide sur la résolution des problèmes",primaryButtonText:"Continuer sans caméra",ariaLabel:"Autoriser l’accès à la caméra"},MicrophoneSitePermissionsRequest:{primaryText:"Autoriser {appName} à utiliser votre micro",secondaryText:"Cela permet aux participants de vous écouter.",linkText:"Avez-vous besoin d’aide? Obtenir de l’aide sur la résolution des problèmes",primaryButtonText:"Continuer sans microphone",ariaLabel:"Autoriser l’accès au micro"},CameraAndMicrophoneSitePermissionsCheck:{primaryText:"Vérification de l’accès à la caméra et au microphone",secondaryText:"Autorisez l’accès si vous y êtes invité(e). Cela permet aux participants de vous voir et de vous entendre.",linkText:"Avez-vous besoin d’aide? Obtenir de l’aide sur la résolution des problèmes",primaryButtonText:"Continuer sans caméra ni micro",ariaLabel:"Vérification de l’accès à la caméra et au microphone. Autorisez l’accès si vous y êtes invité(e)."},CameraSitePermissionsCheck:{primaryText:"Vérification de l’accès à la caméra",secondaryText:"Autorisez l’accès si vous y êtes invité. Cela permet aux participants de vous voir.",linkText:"Avez-vous besoin d’aide? Obtenir de l’aide sur la résolution des problèmes",primaryButtonText:"Continuer sans caméra",ariaLabel:"Vérification de l’accès à la caméra. Autorisez l’accès si vous y êtes invité(e)."},MicrophoneSitePermissionsCheck:{primaryText:"Vérification de l’accès au microphone",secondaryText:"Autorisez l’accès si vous y êtes invité. Cela permet aux participants de vous entendre.",linkText:"Avez-vous besoin d’aide? Obtenir de l’aide sur la résolution des problèmes",primaryButtonText:"Continuer sans microphone",ariaLabel:"Vérification de l’accès au microphone. Autorisez l’accès si vous y êtes invité(e)."},CameraAndMicrophoneSitePermissionsDenied:{primaryText:"Désolé, nous n’avons pas pu accéder au micro et à la caméra.",secondaryText:"Cliquez sur l’icône de verrouillage dans la barre d’adresses pour accorder des autorisations de microphone à cette page Web. Une actualisation de page peut être nécessaire.",primaryButtonText:"Continuer sans caméra ni micro",linkText:"Avez-vous besoin d’aide? Obtenir de l’aide sur la résolution des problèmes"},CameraAndMicrophoneSitePermissionsDeniedSafari:{primaryText:"Désolé, nous n’avons pas pu accéder au micro et à la caméra.",secondaryText:"Actualisez la page pour autoriser les autorisations, ou vérifiez les paramètres de ce navigateur et vérifiez que les autorisations sont activées pour ce site Web.",primaryButtonText:"Continuer sans caméra ni micro",linkText:"Avez-vous besoin d’aide? Obtenir de l’aide sur la résolution des problèmes"},CameraSitePermissionsDenied:{primaryText:"Désolé, nous n’avons pas pu accéder à la caméra.",secondaryText:"Cliquez sur l’icône de verrouillage dans la barre d’adresses pour accorder des autorisations de caméra à cette page Web. Une actualisation de page peut être nécessaire.",primaryButtonText:"Continuer sans caméra",linkText:"Avez-vous besoin d’aide? Obtenir de l’aide sur la résolution des problèmes"},MicrophoneSitePermissionsDenied:{primaryText:"Désolé, nous n’avons pas pu accéder au micro.",secondaryText:"Cliquez sur l’icône de verrouillage dans la barre d’adresses pour accorder des autorisations de microphone à cette page Web. Une actualisation de page peut être nécessaire.",primaryButtonText:"Continuer sans microphone",linkText:"Avez-vous besoin d’aide? Obtenir de l’aide sur la résolution des problèmes"},CameraSitePermissionsDeniedSafari:{primaryText:"Désolé, nous n’avons pas pu accéder à la caméra.",secondaryText:"Actualisez la page pour autoriser les autorisations, ou vérifiez les paramètres de ce navigateur et vérifiez que les autorisations sont activées pour ce site Web.",primaryButtonText:"Continuer sans caméra",linkText:"Avez-vous besoin d’aide? Obtenir de l’aide sur la résolution des problèmes"},MicrophoneSitePermissionsDeniedSafari:{primaryText:"Désolé, nous n’avons pas pu accéder au micro.",secondaryText:"Actualisez la page pour autoriser les autorisations, ou vérifiez les paramètres de ce navigateur et vérifiez que les autorisations sont activées pour ce site Web.",primaryButtonText:"Continuer sans microphone",linkText:"Avez-vous besoin d’aide? Obtenir de l’aide sur la résolution des problèmes"},UnsupportedBrowser:{primaryText:"Navigateur non pris en charge",secondaryText:"Rejoignez cet appel à l’aide d’un navigateur compatible.",moreHelpLinkText:"Voir les exigences de compatibilité"},UnsupportedBrowserVersion:{primaryText:"Mise à jour du navigateur nécessaire",secondaryText:"Pour garantir le meilleur appel possible, veuillez mettre à jour votre navigateur, puis réessayer de rejoindre l’appel.",moreHelpLinkText:"Voir les exigences de compatibilité",continueAnywayButtonText:"Démarrer l’appel sans mettre à jour"},UnsupportedOperatingSystem:{primaryText:"Système d'exploitation non pris en charge",secondaryText:"Rejoignez cet appel à l’aide d’un périphérique avec un système d’exploitation compatible.",moreHelpLinkText:"Voir les exigences de compatibilité"},BrowserPermissionDenied:{primaryText:"Impossible d’utiliser votre caméra ou votre micro",secondaryText:"Votre navigateur n’a peut-être pas accès à votre caméra ou à votre micro. Pour résoudre ce problème, ouvrez Préférences système.",primaryButtonText:"Réessayer",linkText:"Avez-vous besoin d’aide? Obtenir de l’aide sur la résolution des problèmes"},BrowserPermissionDeniedIOS:{primaryText:"Autorisez l’accès au microphone pour continuer.",secondaryText:"Ainsi, les autres participants peuvent vous entendre.",primaryButtonText:"Réessayer",imageAltText:"Emplacement des autorisations pour le microphone et la caméra pour iOS",linkText:"Avez-vous besoin d’aide? Obtenir de l’aide sur la résolution des problèmes",step1Text:"Accéder à l’application Paramètres",step2Text:"Faites défiler vers le bas pour accéder aux paramètres de ce navigateur.",step3Text:"Activez le microphone (caméra facultative).",step4Text:"Réessayez de rejoindre l’appel.",step1DigitText:"1",step2DigitText:"2",step3DigitText:"3",step4DigitText:"4"},verticalGallery:{leftNavButtonAriaLabel:"page précédente {current} de {total}",rightNavButtonAriaLabel:"page suivante{current} de {total}"},meetingConferencePhoneInfo:{meetingConferencePhoneInfoModalTitle:"Rejoindre l’appel à partir de votre téléphone",meetingConferencePhoneInfoModalDialIn:"Composer le numéro",meetingConferencePhoneInfoModalMeetingId:"Entrer l’ID de réunion",meetingConferencePhoneInfoModalWait:"Attendez d’être admis par l’organisateur(-trice).",meetingConferencePhoneInfoModalNoPhoneAvailable:"Aucun téléphone disponible",meetingConferencePhoneInfoModalTollGeoData:"{country}, {city}",meetingConferencePhoneInfoModalTollFree:"(numéro gratuit)",meetingConferencePhoneInfoModalToll:"(numéro payant)"},IncomingCallNotification:{incomingCallNotificationPlaceholderId:"Utilisateur(-trice) inconnu(e)",incomingCallNotificationPlaceholderAlert:"{callerName} appelle",incomingCallNoticicationAcceptWithAudioAriaLabel:"Accepter avec l'audio",incomingCallNoticicationAcceptWithVideoAriaLabel:"Accepter avec la vidéo",incomingCallNoticicationRejectAriaLabel:"Rejeter",incomingCallNotificationAcceptButtonLabel:"Accepter",incomingCallNotificationRejectButtonLabel:"Refuser",incomingCallNotificationAccceptWithVideoButtonLabel:"Accepter avec une vidéo",incomingCallNotificationDismissButtonAriaLabel:"Ignorer"}})},gQt={strings:Jh({participantItem:{isMeText:"(אתה)",menuTitle:"אפשרויות נוספות",removeButtonLabel:"הסר",sharingIconLabel:"משתף",mutedIconLabel:"מושתק",handRaisedIconLabel:"יד מורמת - מיקום {position}",displayNamePlaceholder:"משתתף ללא שם",participantStateRinging:"מתקשר...",participantStateHold:"בהמתנה",participantItemAriaLabel:"{displayName}, {handRaisedState}, {mutedState}, {micDisabledState}, {cameraDisabledState}, {sharingState}, {connectionState}",participantItemWithMoreOptionsAriaLabel:"{displayName}, {handRaisedState}, {mutedState}, {micDisabledState}, {cameraDisabledState}, {sharingState}, {connectionState}, אפשרויות נוספות",attendeeRole:"משתתף",micDisabledIconLabel:"המיקרופון לא זמין",cameraDisabledIconLabel:"המצלמה לא זמינה"},ParticipantList:{overflowParticipantCount:"+{overflowCount} נוספים"},typingIndicator:{singleUser:"{user} מקליד...",multipleUsers:"{users} מקלידים...",multipleUsersAbbreviateOne:"{users} ומשתמש אחד נוסף מקלידים...",multipleUsersAbbreviateMany:"{users} ו{numOthers} אחרים מקלידים...",delimiter:", "},sendBox:{placeholderText:"הזן הודעה",textTooLong:"אורך ההודעה שלך חורג מהמגבלה המרבית.",sendButtonAriaLabel:"שלח הודעה",attachmentUploadsPendingError:"הקובץ בהעלאה, נא המתן.",removeAttachment:"הסרת קובץ",uploading:"מעלה",uploadCompleted:"ההעלאה הושלמה",attachmentMoreMenu:"אפשרויות נוספות"},richTextSendBox:{placeholderText:"הזן הודעה",textTooLong:"אורך ההודעה שלך חורג מהמגבלה המרבית.",sendButtonAriaLabel:"שלח הודעה",attachmentUploadsPendingError:"הקובץ בהעלאה, נא המתן.",imageUploadsPendingError:"התמונה בהעלאה, נא המתן.",removeAttachment:"הסר קובץ",uploading:"מעלה",uploadCompleted:"ההעלאה הושלמה",richTextBoldTooltip:"מודגש",richTextItalicTooltip:"נטוי",richTextUnderlineTooltip:"קו תחתון",richTextBulletListTooltip:"רשימה עם תבליטים",richTextNumberListTooltip:"רשימה ממוספרת",richTextIncreaseIndentTooltip:"הגדל כניסה",richTextDecreaseIndentTooltip:"הקטן כניסה",richTextInsertTableTooltip:"הוסף טבלה",richTextFormatButtonTooltip:"תבנית",richTextInsertRowOrColumnMenu:"הוסף",richTextInsertTableMenuTitle:"הוסף טבלה {column} x‏ {row}",richTextInsertRowAboveMenu:"הוסף מעל",richTextInsertRowBelowMenu:"הוסף מתחת",richTextInsertColumnLeftMenu:"הוסף משמאל",richTextInsertColumnRightMenu:"הוסף מימין",richTextDeleteRowOrColumnMenu:"מחק",richTextDeleteColumnMenu:"מחק עמודה",richTextDeleteRowMenu:"מחק שורה",richTextDeleteTableMenu:"מחק טבלה",richTextToolbarAriaLabel:"סרגל כלים של עיצוב הודעה",richTextToolbarMoreButtonAriaLabel:"אפשרויות נוספות",attachmentMoreMenu:"אפשרויות נוספות",richTextNewBulletedListItemAnnouncement:"תבליט, שורה חדשה",richTextNewNumberedListItemAnnouncement:"{0}, שורה חדשה",richTextBulletedListAppliedAnnouncement:"הוחלה רשימה עם תבליטים",richTextNumberedListAppliedAnnouncement:"רשימה ממוספרת הוחלה"},realTimeTextModal:{realTimeTextModalAriaLabel:"הפעל תיבת דו-שיח מודאלית של RTT",realTimeTextModalTitle:"להפעיל RTT?",realTimeTextModalText:"טקסט בזמן אמת (RTT) יופעל עבור כל האנשים בפגישה.",realTimeTextConfirmButtonLabel:"הפעל",realTimeTextCancelButtonLabel:"ביטול",realTimeTextCloseModalButtonAriaLabel:"סגור תיבת דו-שיח מודאלית של RTT"},captionsBanner:{captionsBannerSpinnerText:"מאתחל כתוביות...",realTimeTextInputBoxDefaultText:"הקלד הודעה בזמן אמת",realTimeTextInputErrorMessage:"ההודעה אינה יכולה לחרוג מ- 2,000 תווים",realTimeTextBannerTitle:"RTT",realTimeTextBannerContent:"RTT (טקסט בזמן אמת) זמין עבור כל המשתתפים למשך הזמן כולו של הפגישה.",realTimeTextBannerLinkLabel:"מידע נוסף",captionsOnlyContainerTitle:"כתוביות",realTimeTextOnlyContainerTitle:"טקסט בזמן אמת",captionsAndRealTimeTextContainerTitle:"כתוביות וטקסט בזמן אמת",expandButtonAriaLabel:"הרחב",minimizeButtonAriaLabel:"כווץ"},mentionPopover:{mentionPopoverHeader:"הצעות"},imageOverlay:{downloadButtonLabel:"הורד",dismissButtonAriaLabel:"סגור",overlayVisibleMessage:"שכבת-על של פרטי תמונה"},messageStatusIndicator:{deliveredAriaLabel:"ההודעה נשלחה",deliveredTooltipText:"‏‏נשלח",seenAriaLabel:"הודעה שנראתה על-ידי אחרים",seenTooltipText:"נראה",readByTooltipText:"נקרא על-ידי {messageThreadReadCount} מתוך {remoteParticipantsCount}",sendingAriaLabel:"שליחת הודעה",sendingTooltipText:"שולח",failedToSendAriaLabel:"שליחת ההודעה נכשלה",failedToSendTooltipText:"השליחה נכשלה"},endCallButton:{label:"עזוב",tooltipContent:"עזוב את השיחה",leaveOption:"צא",endCallOption:"סיים את השיחה לכולם"},cameraButton:{onLabel:"מצלמה",offLabel:"מצלמה",tooltipDisabledContent:"המצלמה אינה זמינה",tooltipOnContent:"כבה מצלמה",tooltipOffContent:"הפעל מצלמה",tooltipVideoLoadingContent:"הווידאו נטען",cameraMenuTitle:"מצלמה",cameraMenuTooltip:"בחר מצלמה",cameraButtonSplitRoleDescription:"לחצן פיצול",onSplitButtonAriaLabel:"כבה מצלמה",offSplitButtonAriaLabel:"הפעל את המצלמה",cameraActionTurnedOnAnnouncement:"המצלמה שלך הופעלה",cameraActionTurnedOffAnnouncement:"המצלמה שלך כבויה",onSplitButtonPrimaryActionCamera:"כבה מצלמה",offSplitButtonPrimaryActionCamera:"הפעל את המצלמה",cameraPrimaryActionSplitButtonTitle:"השתמש במצלמה",videoEffectsMenuItemTitle:"אפקטים",cameraButtonAriaDescription:"אפשרויות מצלמה"},microphoneButton:{onLabel:"מיקרופון",offLabel:"מיקרופון",tooltipDisabledContent:"המיקרופון אינו זמין",tooltipOnContent:"השתק מיקרופון",tooltipOffContent:"בטל השתקה של מיקרופון",microphoneMenuTitle:"מיקרופון",microphoneMenuTooltip:"בחר מיקרופון",speakerMenuTitle:"רמקול",speakerMenuTooltip:"בחר רמקול",microphoneButtonSplitRoleDescription:"לחצן פיצול",onSplitButtonAriaLabel:"השתק את המיקרופון",offSplitButtonAriaLabel:"בטל את השתקת המיקרופון",microphoneActionTurnedOnAnnouncement:"המיקרופון שלך הופעל",microphoneActionTurnedOffAnnouncement:"המיקרופון שלך כובה",offSplitButtonMicrophonePrimaryAction:"בטל את השתקת המיקרופון",onSplitButtonMicrophonePrimaryAction:"השתק את המיקרופון",microphonePrimaryActionSplitButtonTitle:"השתמש במיקרופון",microphoneAriaDescription:"אפשרויות שמע",deepNoiseSuppressionTitle:"העלמת רעש",deepNoiseSuppressionOnAnnouncement:"דיכוי רעשים עמוקים הופעל",deepNoiseSuppressionOffAnnouncement:"דיכוי רעשים עמוקים בוטל"},devicesButton:{label:"מכשירים",tooltipContent:"נהל מכשירים",cameraMenuTitle:"מצלמה",cameraMenuTooltip:"בחר מצלמה",audioDeviceMenuTitle:"התקן שמע",audioDeviceMenuTooltip:"בחר התקן שמע",microphoneMenuTitle:"מיקרופון",microphoneMenuTooltip:"בחר מיקרופון",speakerMenuTitle:"רמקול",speakerMenuTooltip:"בחר רמקול"},participantsButton:{label:"אנשים",ariaLabel:"אנשים",tooltipContent:"הצג משתתפים",menuHeader:"בשיחה זו",participantsListButtonLabel:"{numParticipants} אנשים",muteAllButtonLabel:"השתק הכל",copyInviteLinkButtonLabel:"העתק קישור הזמנה",copyInviteLinkActionedAriaLabel:"קישור ההזמנה הועתק"},screenShareButton:{onLabel:"הפסק להציג",offLabel:"נוכח",tooltipDisabledContent:"הצגה אינה זמינה",tooltipOnContent:"מציג את המסך שלך",tooltipOffContent:"הצג את המסך שלך"},raiseHandButton:{offLabel:"הרם",onLabel:"הורד",tooltipDisabledContent:"פעולת הרמת יד אינה זמינה",tooltipOnContent:"הורד יד",tooltipOffContent:"הרם יד"},reactionButton:{label:"תגובה",ariaLabel:"תגובה",tooltipDisabledContent:"פעולת התגובה אינה זמינה",tooltipContent:"שלח תגובה",likeReactionTooltipContent:"אהבתי",heartReactionTooltipContent:"אהבה",laughReactionTooltipContent:"צחוק",applauseReactionTooltipContent:"תשואות",surprisedReactionTooltipContent:"מופתע"},realTimeText:{isTypingText:"הקלדת RTT"},captionsSettingsModal:{captionsSettingsModalTitle:"הגדרות כתוביות",captionsSettingsSpokenLanguageDropdownLabel:"שפה מדוברת",captionsSettingsCaptionLanguageDropdownLabel:"שפת כתוביות",captionsSettingsSpokenLanguageDropdownInfoText:"השפה שבה כולם בשיחה הזו מדברים.",captionsSettingsCaptionLanguageDropdownInfoText:"הכתוביות יופיעו בשפה זו.",captionsSettingsConfirmButtonLabel:"אישור",captionsSettingsCancelButtonLabel:"ביטול",captionsSettingsModalAriaLabel:"מודאל הגדרת כתוביות",captionsSettingsCloseModalButtonAriaLabel:"סגור הגדרת כתוביות"},spokenLanguages:{"ar-ae":"ערבית - איחוד האמירויות","ar-sa":"ערבית - ערב הסעודית","da-dk":"דנית","de-de":"גרמנית - גרמניה","en-au":"אנגלית - אוסטרליה","en-ca":"אנגלית - קנדה","en-gb":"אנגלית - בריטניה","en-in":"אנגלית - הודו","en-nz":"אנגלית - ניו זילנד","en-us":"אנגלית - ארצות הברית","es-es":"ספרדית - ספרד (ספרדית מודרנית)","es-mx":"ספרדית - מקסיקו","fi-fi":"פינית","fr-ca":"צרפתית - קנדה","fr-fr":"צרפתית - צרפת","hi-in":"הינדי","it-it":"איטלקית - איטליה","ja-jp":"יפנית","ko-kr":"קוריאנית","nb-no":"נורווגית (Bokmål)","nl-be":"הולנדית - בלגיה","nl-nl":"הולנדית - הולנד","pl-pl":"פולנית","pt-br":"פורטוגזית - ברזיל","ru-ru":"רוסית","sv-se":"שוודית","zh-cn":"סינית - הרפובליקה העממית של סין","zh-hk":"סינית - הונג קונג","cs-cz":"צ'כית","pt-pt":"פורטוגזית - פורטוגל","tr-tr":"טורקית","vi-vn":"וייטנאמית","th-th":"תאית","he-il":"עברית","cy-gb":"וולשית","uk-ua":"אוקראינית","el-gr":"יוונית","hu-hu":"הונגרית","ro-ro":"רומנית","sk-sk":"סלובקית","zh-tw":"סינית - טייוואן"},captionLanguages:{ar:"ערבית",da:"דנית",de:"גרמנית",en:"אנגלית",es:"ספרדית",fi:"פינית","fr-ca":"צרפתית - קנדה",fr:"צרפתית - צרפת",hi:"הינדי",it:"איטלקית",ja:"יפנית",ko:"קוריאנית",nb:"נורווגית (Bokmål)",nl:"הולנדית",pl:"פולנית",pt:"פורטוגזית - ברזיל",ru:"רוסית",sv:"שוודית","zh-Hans":"סינית (פשוטה)","zh-Hant":"סינית (מסורתית)",cs:"צ'כית","pt-pt":"פורטוגזית - פורטוגל",tr:"טורקית",vi:"וייטנאמית",th:"תאית",he:"עברית",cy:"וולשית",uk:"אוקראינית",el:"יוונית",hu:"הונגרית",ro:"רומנית",sk:"סלובקית"},startCaptionsButton:{onLabel:"הפעל כתוביות",offLabel:"כבה כתוביות",tooltipOnContent:"כבה כתוביות",tooltipOffContent:"הפעל כתוביות"},startRealTimeTextButton:{label:"הפעל RTT עבור שיחה זו",tooltipOffContent:"הפעל RTT עבור שיחה זו"},messageThread:{yesterday:"אתמול",sunday:"יום ראשון",monday:"יום שני",tuesday:"שלישי",wednesday:"יום רביעי",thursday:"יום חמישי",friday:"יום שישי",saturday:"יום שבת",participantJoined:"הצטרף לצ'אט.",participantLeft:"עזב את הצ'אט.",editMessage:"ערוך",removeMessage:"מחק",resendMessage:"נסה לשלוח שוב",failToSendTag:"השליחה נכשלה",editedTag:"נערך",liveAuthorIntro:"הודעה מאת {author}",editedMessageLiveAuthorIntro:"הודעה ערוכה מ- {author}",editedMessageLocalUserLiveAuthorIntro:"הודעה ערוכה",messageContentAriaText:"{status} {author} אמר {message}",messageContentMineAriaText:"{status} אמרת {message}",editBoxTextLimit:"ההודעה שלך נמצאת מעבר למגבלה של {limitNumber} תווים",editBoxPlaceholderText:"ערוך את ההודעה שלך",newMessagesIndicator:"הודעות חדשות",noDisplayNameSub:"ללא שם",editBoxCancelButton:"בטל",editBoxSubmitButton:"בוצע",messageReadCount:"נקרא על-ידי {messageReadByCount} מתוך {remoteParticipantsCount}",actionMenuMoreOptions:"אפשרויות נוספות",downloadAttachment:"הורד קובץ",openAttachment:"פתח קובץ",blockedWarningText:"הודעה זו נמחקה עקב מדיניות ארגונית.",blockedWarningLinkText:"פרטים",attachmentCardGroupMessage:"ההודעה כוללת {attachmentCount} קבצים מצורפים.",messageDeletedAnnouncementAriaLabel:"ההודעה נמחקת",richTextBoldTooltip:"מודגש",richTextItalicTooltip:"הטיה",richTextUnderlineTooltip:"קו תחתון",richTextBulletListTooltip:"רשימה עם תבליטים",richTextNumberListTooltip:"רשימה ממוספרת",richTextIncreaseIndentTooltip:"הגדל כניסה",richTextDecreaseIndentTooltip:"הקטן כניסה",richTextInsertTableTooltip:"הוסף טבלה",richTextFormatButtonTooltip:"תבנית",richTextInsertRowOrColumnMenu:"הוסף",richTextInsertTableMenuTitle:"הוסף טבלה {column} x‏ {row}",richTextInsertRowAboveMenu:"הוסף מעל",richTextInsertRowBelowMenu:"הוסף מתחת",richTextInsertColumnLeftMenu:"הוסף משמאל",richTextInsertColumnRightMenu:"הוסף מימין",richTextDeleteRowOrColumnMenu:"מחק",richTextDeleteColumnMenu:"מחק עמודה",richTextDeleteRowMenu:"מחק שורה",richTextDeleteTableMenu:"מחק טבלה",richTextToolbarMoreButtonAriaLabel:"אפשרויות נוספות",attachmentUploadsPendingError:"הקובץ בהעלאה, נא המתן.",imageUploadsPendingError:"התמונה בהעלאה, נא המתן.",richTextNewBulletedListItemAnnouncement:"תבליט, שורה חדשה",richTextNewNumberedListItemAnnouncement:"{0}, שורה חדשה",richTextBulletedListAppliedAnnouncement:"הוחלה רשימה עם תבליטים",richTextNumberedListAppliedAnnouncement:"רשימה ממוספרת הוחלה"},errorBar:{unableToReachChatService:"אתה נמצא במצב לא מקוון",accessDenied:"לא ניתן לגשת אל שירותי צ'אט - בדוק את אישורי המשתמש שסופקו",userNotInChatThread:"אינך נמצא עוד בהליך משנה זה של צ'אט",sendMessageNotInChatThread:"שליחת ההודעה נכשלה מכיוון שאתה כבר לא נמצא בהליך משנה זה של צ'אט",sendMessageGeneric:"שליחת ההודעה נכשלה",callingNetworkFailure:"ממתקשה בחיבור השיחה - נראה שאתה לא מקוון",startVideoGeneric:"הפעלת סרטון הווידאו נכשלה",stopVideoGeneric:"הפסקת הווידאו נכשלה",muteGeneric:"השתקת המיקרופון נכשלה",unmuteGeneric:"ביטול השתקת המיקרופון נכשל",speakingWhileMuted:"המיקרופון שלך מושתק",startScreenShareGeneric:"הייתה בעיה בהפעלת שיתוף מסך.",stopScreenShareGeneric:"הפסקת שיתוף המסכים נכשלה",callNetworkQualityLow:"איכות הרשת נמוכה.",teamsMeetingCallNetworkQualityLow:"איכות הרשת נמוכה.",callNoSpeakerFound:"לא נמצאו רמקולים או אוזניות. חבר התקן שמע כדי לשמוע את השיחה.",callNoMicrophoneFound:"לא נמצאו מיקרופונים. חבר התקן קלט שמע.",callMicrophoneAccessDenied:"לא ניתן לגשת למיקרופון. לחץ על הנעילה בשורת הכתובת כדי להעניק הרשאה לדף אינטרנט זה.",callMicrophoneAccessDeniedSafari:"לא ניתן לגשת למיקרופון. רענן את הדף כדי לאפשר הרשאות, או בדוק את ההגדרות של דפדפן זה וודא שהרשאות זמינות עבור אתר אינטרנט זה.",callMicrophoneMutedBySystem:"אתה מושתק על-ידי המערכת שלך.",callMicrophoneUnmutedBySystem:"המיקרופון שלך התאושש והמערכת שלך ביטלה את ההשתקה.",callMacOsMicrophoneAccessDenied:"לא ניתן לגשת למיקרופון. הענק הרשאת מיקרופון בהגדרות הפרטיות של macOS.",callLocalVideoFreeze:"רוחב הפס של הרשת גרוע. ייתכן שהווידאו שלך יופיע מושהה עבור אחרים בשיחה.",callCameraAccessDenied:"לא ניתן לגשת למצלמה. לחץ על הנעילה בשורת הכתובת כדי להעניק הרשאה לדף אינטרנט זה.",callCameraAccessDeniedSafari:"לא ניתן לגשת למצלמה. רענן את הדף כדי לאפשר הרשאות, או בדוק את ההגדרות של דפדפן זה וודא שהרשאות זמינות עבור אתר אינטרנט זה.",callCameraAlreadyInUse:"לא ניתן לגשת למצלמה. ייתכן שהוא כבר נמצא בשימוש על-ידי יישום אחר.",callVideoStoppedBySystem:"הווידאו שלך הופסק על-ידי המערכת.",callVideoRecoveredBySystem:"הווידאו שלך התחדש.",callMacOsCameraAccessDenied:"MacOS חוסם את הגישה למצלמה שלך. עדכן את הגדרות הפרטיות שלך כדי לאפשר לדפדפן זה לגשת למצלמה שלך.",callMacOsScreenShareAccessDenied:"MacOS חוסם שיתוף מסכים. עדכן את הגדרות הפרטיות שלך כדי לאפשר לדפדפן זה להקליט את המסך שלך.",dismissButtonAriaLabel:"סגור",failedToJoinCallGeneric:"הצטרפות לשיחה נכשלה.",failedToJoinCallInvalidMeetingLink:"לא ניתן להצטרף לפגישה. קישור לא חוקי.",cameraFrozenForRemoteParticipants:"משתמשים בשיחה נתקלים בבעיות בהצגת הווידאו שלך. בדוק את המכשירים ואת הרשת שלך.",unableToStartVideoEffect:"לא ניתן להחיל אפקט וידאו.",startSpotlightWhileMaxParticipantsAreSpotlighted:"אין אפשרות להפעיל זרקור על משתתפים מכיוון שכבר יש זרקורים על המספר המרבי של משתתפים.",mutedByRemoteParticipant:"השתקת משתתף אחר."},notificationStack:{callingNetworkFailure:{title:"בעיה בחיבור השיחה",message:"נראה שאתה במצב לא מקוון. בדוק את חיבור הרשת שלך ונסה שוב.",dismissButtonAriaLabel:"סגור"},startVideoGeneric:{title:"הפעלת סרטון הווידאו נכשלה.",dismissButtonAriaLabel:"סגור"},stopVideoGeneric:{title:"הפסקת הווידאו נכשלה.",dismissButtonAriaLabel:"סגור"},muteGeneric:{title:"השתקת המיקרופון נכשלה.",dismissButtonAriaLabel:"סגור"},unmuteGeneric:{title:"ביטול השתקת המיקרופון נכשל.",dismissButtonAriaLabel:"סגור"},speakingWhileMuted:{title:"אתה מושתק.",dismissButtonAriaLabel:"סגור"},startScreenShareGeneric:{title:"הייתה בעיה בהפעלת שיתוף מסך.",dismissButtonAriaLabel:"סגור"},stopScreenShareGeneric:{title:"הפסקת שיתוף המסכים נכשלה.",dismissButtonAriaLabel:"סגור"},callNetworkQualityLow:{title:"איכות הרשת נמוכה.",dismissButtonAriaLabel:"סגור"},teamsMeetingCallNetworkQualityLow:{title:"איכות הרשת נמוכה.",dismissButtonAriaLabel:"סגור",message:"הצטרף לשיחה זו מהטלפון שלך לקבלת צליל טוב יותר. באפשרותך להמשיך להציג את הפגישה במכשיר זה.",primaryButtonLabel:"הצטרף בטלפון"},callNoSpeakerFound:{title:"לא נמצאו רמקולים או אוזניות",message:"חבר התקן שמע כדי לשמוע את השיחה.",dismissButtonAriaLabel:"סגור"},callNoMicrophoneFound:{title:"לא נמצאו מיקרופונים",message:"חבר התקן קלט שמע.",dismissButtonAriaLabel:"סגור"},callMicrophoneAccessDenied:{title:"לא ניתן לגשת למיקרופון",message:"לחץ על הנעילה בשורת הכתובת כדי להעניק הרשאה לדף אינטרנט זה.",dismissButtonAriaLabel:"סגור"},callMicrophoneAccessDeniedSafari:{title:"לא ניתן לגשת למיקרופון",message:"רענן את הדף כדי לאפשר הרשאות, או בדוק את ההגדרות של דפדפן זה וודא שהרשאות זמינות עבור אתר אינטרנט זה.",dismissButtonAriaLabel:"סגור"},callMicrophoneMutedBySystem:{title:"אתה מושתק על-ידי המערכת שלך.",dismissButtonAriaLabel:"סגור"},callMicrophoneUnmutedBySystem:{title:"המיקרופון שלך התאושש והמערכת שלך ביטלה את ההשתקה.",dismissButtonAriaLabel:"סגור"},callMacOsMicrophoneAccessDenied:{title:"לא ניתן לגשת למיקרופון",message:"הענק הרשאת מיקרופון בהגדרות הפרטיות של macOS.",dismissButtonAriaLabel:"סגור"},callLocalVideoFreeze:{title:"רוחב הפס של הרשת גרוע",message:"ייתכן שהווידאו שלך יופיע מושהה עבור אנשים אחרים בשיחה.",dismissButtonAriaLabel:"סגור"},callCameraAccessDenied:{title:"לא ניתן לגשת למצלמה",message:"לחץ על הנעילה בשורת הכתובת כדי להעניק הרשאה לדף אינטרנט זה.",dismissButtonAriaLabel:"סגור"},callCameraAccessDeniedSafari:{title:"לא ניתן לגשת למצלמה",message:"רענן את הדף כדי לאפשר הרשאות, או בדוק את ההגדרות של דפדפן זה וודא שהרשאות זמינות עבור אתר אינטרנט זה.",dismissButtonAriaLabel:"סגור"},callCameraAlreadyInUse:{title:"לא ניתן לגשת למצלמה",message:"ייתכן שהוא כבר נמצא בשימוש על-ידי יישום אחר.",dismissButtonAriaLabel:"סגור"},callVideoStoppedBySystem:{title:"הווידאו שלך הופסק על-ידי המערכת.",dismissButtonAriaLabel:"סגור"},callVideoRecoveredBySystem:{title:"הווידאו שלך התחדש.",dismissButtonAriaLabel:"סגור"},callMacOsCameraAccessDenied:{title:"MacOS חוסם את הגישה למצלמה שלך",message:"עדכן את הגדרות הפרטיות שלך כדי לאפשר לדפדפן זה לגשת למצלמה שלך.",dismissButtonAriaLabel:"סגור"},callMacOsScreenShareAccessDenied:{title:"MacOS חוסם שיתוף מסכים",message:"עדכן את הגדרות הפרטיות שלך כדי לאפשר לדפדפן זה להקליט את המסך שלך.",dismissButtonAriaLabel:"סגור"},failedToJoinCallGeneric:{title:"הצטרפות לשיחה נכשלה.",dismissButtonAriaLabel:"סגור"},failedToJoinCallInvalidMeetingLink:{title:"לא ניתן להצטרף לפגישה. קישור לא חוקי.",dismissButtonAriaLabel:"סגור"},cameraFrozenForRemoteParticipants:{title:"משתמשים בשיחה נתקלים בבעיות בהצגת הווידאו שלך",message:"בדוק את המכשירים ואת הרשת שלך.",dismissButtonAriaLabel:"סגור"},unableToStartVideoEffect:{title:"לא ניתן להחיל אפקט וידאו.",dismissButtonAriaLabel:"סגור"},startSpotlightWhileMaxParticipantsAreSpotlighted:{title:"אין אפשרות להפעיל זרקור על משתתפים",message:"מספר המשתתפים המרבי כבר מודגש.",dismissButtonAriaLabel:"סגור"},mutedByRemoteParticipant:{title:"השתקת משתתף אחר.",dismissButtonAriaLabel:"סגור"},recordingStarted:{title:"ההקלטה התחילה.",message:"על-ידי הצטרפות, אתה נותן הסכמה לתעתק פגישה זו.",dismissButtonAriaLabel:"סגור"},transcriptionStarted:{title:"התמלול התחיל.",message:"על-ידי הצטרפות, אתה נותן הסכמה לתעתק פגישה זו.",dismissButtonAriaLabel:"סגור"},recordingStopped:{title:"ההקלטה נשמרת.",message:"ההקלטה הופסקה.",dismissButtonAriaLabel:"סגור"},transcriptionStopped:{title:"מתבצע תהליך שמירה של התמליל.",message:"התמלול הופסק.",dismissButtonAriaLabel:"סגור"},recordingAndTranscriptionStarted:{title:"הקלטה ותמלול התחילו.",message:"על-ידי הצטרפות, אתה נותן הסכמה לתעתק פגישה זו.",dismissButtonAriaLabel:"סגור"},recordingAndTranscriptionStopped:{title:"ההקלטה והתמלול בתהליך שמירה.",message:"ההקלטה והתמלול הופסקו.",dismissButtonAriaLabel:"סגור"},recordingStoppedStillTranscribing:{title:"ההקלטה הופסקה.",message:"אתה רק מתעתק את הפגישה כעת.",dismissButtonAriaLabel:"סגור"},transcriptionStoppedStillRecording:{title:"התמלול הופסק.",message:"אתה כעת רק מקליט את הפגישה.",dismissButtonAriaLabel:"סגור"},assignedBreakoutRoomOpened:{title:"נעביר אותך לחדר שהוקצה לך תוך 5 שניות.",dismissButtonAriaLabel:"סגור"},assignedBreakoutRoomChanged:{title:"פיצול החדרים שלך השתנה",message:"נעביר אותך לחדר שהוקצה לך תוך 5 שניות.",dismissButtonAriaLabel:"סגור"},assignedBreakoutRoomClosed:{title:"פיצול החדרים שלך נסגר",message:"נעביר אותך בחזרה לפגישה שלך בעוד 5 שניות.",dismissButtonAriaLabel:"סגור"},assignedBreakoutRoomOpenedPromptJoin:{title:"להצטרף לפיצול חדרים?",message:"הוקצית לפיצול חדר.",dismissButtonAriaLabel:"סגור",primaryButtonLabel:"הצטרף לחדר",secondaryButtonLabel:"מאוחר יותר"},breakoutRoomJoined:{title:"הצטרפת לפיצול חדרים.",dismissButtonAriaLabel:"סגור"},breakoutRoomClosingSoon:{title:"תוקף מגבלת זמן החדר עומד לפוג.",message:"חדר זה ייסגר בעוד 30 שניות",dismissButtonAriaLabel:"סגור"},capabilityTurnVideoOnPresent:{title:"המצלמה שלך הפכה לזמינה",message:"הפעל אותה אם ברצונך לשתף וידאו.",dismissButtonAriaLabel:"סגור"},capabilityTurnVideoOnAbsent:{title:"המצלמה שלך הושבתה",message:"לא תוכל עוד לשתף וידאו.",dismissButtonAriaLabel:"סגור"},capabilityUnmuteMicPresent:{title:"המיקרופון שלך הפך לזמין",message:"בטל את ההשתקה אם אתה מעוניין לדבר.",dismissButtonAriaLabel:"סגור"},capabilityUnmuteMicAbsent:{title:"המיקרופון שלך הפך ללא זמין",message:"לא תוכל עוד לבטל השתקה.",dismissButtonAriaLabel:"סגור"},togetherModeStarted:{title:"Togethermode התחיל",dismissButtonAriaLabel:"סגור"},togetherModeEnded:{title:"Togethermode הסתיים",dismissButtonAriaLabel:"סגור"}},videoGallery:{screenIsBeingSharedMessage:"אתה משתף את המסך שלך",screenShareLoadingMessage:"טוען את המסך של {participant}",localScreenShareLoadingMessage:"טוען את המסך שלך",localVideoLabel:"אתה",localVideoCameraSwitcherLabel:"החלף מצלמה",localVideoMovementLabel:"אריח וידאו מקומי נשלף",localVideoMovementAriaLabel:"אריח וידאו מקומי נשלף",localVideoSelectedDescription:"{cameraName} נבחר",displayNamePlaceholder:"משתתף ללא שם",fitRemoteParticipantToFrame:"התאם למסגרת",fillRemoteParticipantFrame:"מלא את המסגרת",pinParticipantForMe:"הצמד עבורי",pinParticipantForMeLimitReached:"הצמדה (הגעת למגבלה)",unpinParticipantForMe:"בטל הצמדה",pinParticipantMenuItemAriaLabel:"הצמד את {participantName}",unpinParticipantMenuItemAriaLabel:"בטל את הצמדת {participantName}",pinnedParticipantAnnouncementAriaLabel:"{participantName} הוצמד",unpinnedParticipantAnnouncementAriaLabel:"הצמדת {participantName} בוטלה",startSpotlightVideoTileMenuLabel:"הצבת זרקור עבור כולם",addSpotlightVideoTileMenuLabel:"הוסף זרקור",spotlightLimitReachedMenuTitle:"הגעת למגבלת הזרקורים",stopSpotlightVideoTileMenuLabel:"הפסק להציב זרקור",stopSpotlightOnSelfVideoTileMenuLabel:"צא מזרקור",attendeeRole:"משתתף",muteParticipantMenuItemLabel:"השתק",waitingScreenText:"מחכה שאחרים יצטרפו",forbidAudio:"הפוך את המיקרופון ללא זמין",permitAudio:"אפשר שימוש במיקרופון",forbidAudioTileMenuLabel:"הפוך את המיקרופון ללא זמין",permitAudioTileMenuLabel:"אפשר שימוש במיקרופון",forbidVideo:"הפוך את המצלמה ללא זמינה",permitVideo:"אפשר שימוש במצלמה",forbidVideoTileMenuLabel:"הפוך את המצלמה ללא זמינה",permitVideoTileMenuLabel:"אפשר שימוש במצלמה"},dialpad:{placeholderText:"הזן מספר טלפון",deleteButtonAriaLabel:"מחק"},holdButton:{onLabel:"המשך",offLabel:"החזק",tooltipOnContent:"חדש שיחה",tooltipOffContent:"השהה שיחה"},videoTile:{participantStateRinging:"מתקשר...",participantReconnecting:"מתחבר מחדש...",participantStateHold:"בהמתנה",moreOptionsButtonAriaLabel:"אפשרויות נוספות {displayName} {isMuted} {micDisabledState} {cameraDisabledState} {isHandRaised} {state} {isSpeaking}",moreOptionsParticipantMutedStateMutedAriaLabel:"מושתק",moreOptionsParticipantMutedStateUnmutedAriaLabel:"לא מושתק",moreOptionsParticipantHandRaisedAriaLabel:"‫כף יד מורמת",moreOptionsParticipantIsSpeakingAriaLabel:"מדבר",moreOptionsParticipantMicDisabledAriaLabel:"המיקרופון לא זמין",moreOptionsParticipantCameraDisabledAriaLabel:"המצלמה לא זמינה"},CameraAndMicrophoneSitePermissionsRequest:{primaryText:"אפשר {appName} להשתמש במצלמה ובמיקרופון שלך",secondaryText:"זה כדי שהמשתתפים יוכלו לראות ולשמוע אותך.",linkText:"זקוק לעזרה? קבל עזרה עבור פתרון בעיות",primaryButtonText:"המשך ללא מצלמה ומיקרופון",ariaLabel:"אפשר גישה למצלמה ולמיקרופון"},CameraSitePermissionsRequest:{primaryText:"אפשר {appName} להשתמש במצלמה שלך",secondaryText:"זה כדי שהמשתתפים יוכלו לראות אותך.",linkText:"זקוק לעזרה? קבל עזרה עבור פתרון בעיות",primaryButtonText:"המשך ללא מצלמה",ariaLabel:"אפשר גישה למצלמה"},MicrophoneSitePermissionsRequest:{primaryText:"אפשר {appName} להשתמש במיקרופון שלך",secondaryText:"זה כדי שהמשתתפים יוכלו לשמוע אותך.",linkText:"זקוק לעזרה? קבל עזרה עבור פתרון בעיות",primaryButtonText:"המשך ללא מיקרופון",ariaLabel:"אפשר גישה למיקרופון"},CameraAndMicrophoneSitePermissionsCheck:{primaryText:"בודק אם קיימת גישה למצלמה ולמיקרופון",secondaryText:"אפשר גישה אם תתבקש לעשות זאת. זה כדי שהמשתתפים יוכלו לראות ולשמוע אותך.",linkText:"זקוק לעזרה? קבל עזרה עבור פתרון בעיות",primaryButtonText:"המשך ללא מצלמה ומיקרופון",ariaLabel:"בודק אם קיימת גישה למצלמה ולמיקרופון. אפשר גישה אם תתבקש לעשות זאת."},CameraSitePermissionsCheck:{primaryText:"בודק אם קיימת גישה למצלמה",secondaryText:"אפשר גישה אם תתבקש לעשות זאת. זה כדי שהמשתתפים יוכלו לראות אותך.",linkText:"זקוק לעזרה? קבל עזרה עבור פתרון בעיות",primaryButtonText:"המשך ללא מצלמה",ariaLabel:"בודק אם קיימת גישה למצלמה. אפשר גישה אם תתבקש לעשות זאת."},MicrophoneSitePermissionsCheck:{primaryText:"בודק אם קיימת גישה למיקרופון",secondaryText:"אפשר גישה אם תתבקש לעשות זאת. זה כדי שהמשתתפים יוכלו לשמוע אותך.",linkText:"זקוק לעזרה? קבל עזרה עבור פתרון בעיות",primaryButtonText:"המשך ללא מיקרופון",ariaLabel:"בודק אם קיימת גישה למיקרופון. אפשר גישה אם תתבקש לעשות זאת."},CameraAndMicrophoneSitePermissionsDenied:{primaryText:"לא ניתן לגשת למצלמה ולמיקרופון",secondaryText:"לחץ על סמל המנעול בשורת הכתובת כדי להעניק הרשאות מיקרופון לדף אינטרנט זה. ייתכן שיידרש רענון דף.",primaryButtonText:"המשך ללא מצלמה ומיקרופון",linkText:"זקוק לעזרה? קבל עזרה עבור פתרון בעיות"},CameraAndMicrophoneSitePermissionsDeniedSafari:{primaryText:"לא ניתן לגשת למצלמה ולמיקרופון",secondaryText:"רענן את הדף כדי לאפשר הרשאות, או בדוק את ההגדרות של דפדפן זה וודא שהרשאות זמינות עבור אתר אינטרנט זה.",primaryButtonText:"המשך ללא מצלמה ומיקרופון",linkText:"זקוק לעזרה? קבל עזרה עבור פתרון בעיות"},CameraSitePermissionsDenied:{primaryText:"לא ניתן לגשת למצלמה",secondaryText:"לחץ על סמל המנעול בשורת הכתובת כדי להעניק הרשאות מצלמה לדף אינטרנט זה. ייתכן שיידרש רענון דף.",primaryButtonText:"המשך ללא מצלמה",linkText:"זקוק לעזרה? קבל עזרה עבור פתרון בעיות"},MicrophoneSitePermissionsDenied:{primaryText:"לא ניתן לגשת למיקרופון",secondaryText:"לחץ על סמל המנעול בשורת הכתובת כדי להעניק הרשאות מיקרופון לדף אינטרנט זה. ייתכן שיידרש רענון דף.",primaryButtonText:"המשך ללא מיקרופון",linkText:"זקוק לעזרה? קבל עזרה עבור פתרון בעיות"},CameraSitePermissionsDeniedSafari:{primaryText:"לא ניתן לגשת למצלמה",secondaryText:"רענן את הדף כדי לאפשר הרשאות, או בדוק את ההגדרות של דפדפן זה וודא שהרשאות זמינות עבור אתר אינטרנט זה.",primaryButtonText:"המשך ללא מצלמה",linkText:"זקוק לעזרה? קבל עזרה עבור פתרון בעיות"},MicrophoneSitePermissionsDeniedSafari:{primaryText:"לא ניתן לגשת למיקרופון",secondaryText:"רענן את הדף כדי לאפשר הרשאות, או בדוק את ההגדרות של דפדפן זה וודא שהרשאות זמינות עבור אתר אינטרנט זה.",primaryButtonText:"המשך ללא מיקרופון",linkText:"זקוק לעזרה? קבל עזרה עבור פתרון בעיות"},UnsupportedBrowser:{primaryText:"הדפדפן אינו נתמך",secondaryText:"הצטרף לשיחה זו באמצעות דפדפן תואם.",moreHelpLinkText:"ראה דרישות תאימות"},UnsupportedBrowserVersion:{primaryText:"‏‏נדרש עדכון דפדפן",secondaryText:"כדי להבטיח את השיחה הטובה ביותר האפשרית, עדכן את הדפדפן ולאחר מכן נסה להצטרף שוב לשיחה.",moreHelpLinkText:"ראה דרישות תאימות",continueAnywayButtonText:"התחל שיחה מבלי לעדכן"},UnsupportedOperatingSystem:{primaryText:"מערכת ההפעלה אינה נתמכת",secondaryText:"הצטרף לשיחה זו באמצעות התקן עם מערכת הפעלה תואמת.",moreHelpLinkText:"ראה דרישות תאימות"},BrowserPermissionDenied:{primaryText:"לא ניתן להשתמש במצלמה או במיקרופון שלך",secondaryText:"ייתכן שלדפדפן שלך אין גישה למצלמה או למיקרופון שלך. כדי לפתור בעיה זו, פתח את 'העדפות מערכת'.",primaryButtonText:"נסה שוב",linkText:"זקוק לעזרה? קבל עזרה עבור פתרון בעיות"},BrowserPermissionDeniedIOS:{primaryText:"אפשר גישה למיקרופון כדי להמשיך",secondaryText:"כך שמשתתפים אחרים יוכלו לשמוע אותך.",primaryButtonText:"נסה שוב",imageAltText:"מיקום הרשאה של מיקרופון והתקן מצלמה עבור iOS",linkText:"זקוק לעזרה? קבל עזרה עבור פתרון בעיות",step1Text:"עבור אל האפליקציה 'הגדרות'",step2Text:"גלול למטה להגדרות עבור דפדפן זה",step3Text:"הפעל מיקרופון (מצלמה אופציונלית)",step4Text:"נסה להצטרף שוב לשיחה",step1DigitText:"1",step2DigitText:"2",step3DigitText:"3",step4DigitText:"4"},verticalGallery:{leftNavButtonAriaLabel:"העמוד הקודם {current} מתוך {total}",rightNavButtonAriaLabel:"העמוד הבא {current} מתוך {total}"},meetingConferencePhoneInfo:{meetingConferencePhoneInfoModalTitle:"הצטרף לשיחה מהטלפון שלך",meetingConferencePhoneInfoModalDialIn:"חייג למספר",meetingConferencePhoneInfoModalMeetingId:"הזן מזהה פגישה",meetingConferencePhoneInfoModalWait:"המתן עד שהמארגן יכניס אותך",meetingConferencePhoneInfoModalNoPhoneAvailable:"אין טלפון זמין",meetingConferencePhoneInfoModalTollGeoData:"{country}, {city}",meetingConferencePhoneInfoModalTollFree:"(שיחת חינם)",meetingConferencePhoneInfoModalToll:"(בתשלום)"},IncomingCallNotification:{incomingCallNotificationPlaceholderId:"משתמש לא ידוע",incomingCallNotificationPlaceholderAlert:"{callerName} מתקשר",incomingCallNoticicationAcceptWithAudioAriaLabel:"קבל עם שמע",incomingCallNoticicationAcceptWithVideoAriaLabel:"קבל עם וידאו",incomingCallNoticicationRejectAriaLabel:"דחה",incomingCallNotificationAcceptButtonLabel:"קבל",incomingCallNotificationRejectButtonLabel:"דחה",incomingCallNotificationAccceptWithVideoButtonLabel:"קבל עם וידאו",incomingCallNotificationDismissButtonAriaLabel:"בטל"}})},mQt={strings:Jh({participantItem:{isMeText:"(tu)",menuTitle:"Altre opzioni",removeButtonLabel:"Rimuovi",sharingIconLabel:"Condivisione",mutedIconLabel:"Disattivato",handRaisedIconLabel:"Mano alzata - Posizione {position}",displayNamePlaceholder:"Partecipante senza nome",participantStateRinging:"Chiamata in corso...",participantStateHold:"Per l'attesa",participantItemAriaLabel:"{displayName}, {handRaisedState}, {mutedState}, {micDisabledState}, {cameraDisabledState}, {sharingState}, {connectionState}",participantItemWithMoreOptionsAriaLabel:"{displayName}, {handRaisedState}, {mutedState}, {micDisabledState}, {cameraDisabledState}, {sharingState}, {connectionState}, altre opzioni",attendeeRole:"Partecipante",micDisabledIconLabel:"Microfono disabilitato",cameraDisabledIconLabel:"Fotocamera disabilitata"},ParticipantList:{overflowParticipantCount:"+{overflowCount} altro"},typingIndicator:{singleUser:"{user} sta scrivendo ...",multipleUsers:"{users} stanno scrivendo ...",multipleUsersAbbreviateOne:"{users} e 1 altro stanno scrivendo ...",multipleUsersAbbreviateMany:"{users} e {numOthers} altri stanno scrivendo ...",delimiter:", "},sendBox:{placeholderText:"Immetti un messaggio",textTooLong:"La lunghezza del messaggio supera il limite massimo.",sendButtonAriaLabel:"Invio messaggio",attachmentUploadsPendingError:"È in corso il caricamento del file, attendere.",removeAttachment:"Rimuovi file",uploading:"Caricamento in corso",uploadCompleted:"Caricamento completato",attachmentMoreMenu:"Altre opzioni"},richTextSendBox:{placeholderText:"Immetti un messaggio",textTooLong:"La lunghezza del messaggio supera il limite massimo.",sendButtonAriaLabel:"Invia messaggio",attachmentUploadsPendingError:"È in corso il caricamento del file, attendere.",imageUploadsPendingError:"È in corso il caricamento dell'immagine, attendere.",removeAttachment:"Rimuovi file",uploading:"Caricamento",uploadCompleted:"Caricamento completato",richTextBoldTooltip:"Grassetto",richTextItalicTooltip:"Corsivo",richTextUnderlineTooltip:"Sottolineato",richTextBulletListTooltip:"Elenco puntato",richTextNumberListTooltip:"Elenco numerato",richTextIncreaseIndentTooltip:"Aumenta rientro",richTextDecreaseIndentTooltip:"Riduci rientro",richTextInsertTableTooltip:"Inserisci tabella",richTextFormatButtonTooltip:"Formato",richTextInsertRowOrColumnMenu:"Inserisci",richTextInsertTableMenuTitle:"Inserisci tabella {column} x {row}",richTextInsertRowAboveMenu:"Inserisci sopra",richTextInsertRowBelowMenu:"Inserisci sotto",richTextInsertColumnLeftMenu:"Inserisci a sinistra",richTextInsertColumnRightMenu:"Inserisci a destra",richTextDeleteRowOrColumnMenu:"Elimina",richTextDeleteColumnMenu:"Elimina colonna",richTextDeleteRowMenu:"Elimina riga",richTextDeleteTableMenu:"Elimina tabella",richTextToolbarAriaLabel:"Barra degli strumenti Formattazione messaggi",richTextToolbarMoreButtonAriaLabel:"Altre opzioni",attachmentMoreMenu:"Altre opzioni",richTextNewBulletedListItemAnnouncement:"Punto elenco, nuova riga",richTextNewNumberedListItemAnnouncement:"{0}, nuova riga",richTextBulletedListAppliedAnnouncement:"Elenco puntato applicato",richTextNumberedListAppliedAnnouncement:"Elenco numerato applicato"},realTimeTextModal:{realTimeTextModalAriaLabel:"Abilita finestra modale scrittura in tempo reale",realTimeTextModalTitle:"Abilitare la scrittura in tempo reale?",realTimeTextModalText:"Il testo in tempo reale verrà attivato per tutti gli utenti della riunione.",realTimeTextConfirmButtonLabel:"Abilita",realTimeTextCancelButtonLabel:"Annulla",realTimeTextCloseModalButtonAriaLabel:"Chiudi finestra modale scrittura in tempo reale"},captionsBanner:{captionsBannerSpinnerText:"Avvio dei sottotitoli in corso...",realTimeTextInputBoxDefaultText:"Digita messaggio in tempo reale",realTimeTextInputErrorMessage:"Il messaggio non può superare i 2000 caratteri",realTimeTextBannerTitle:"Scrittura in tempo reale",realTimeTextBannerContent:"RTT (testo in tempo reale) è abilitato per tutti i partecipanti per l'intera durata della riunione.",realTimeTextBannerLinkLabel:"Scopri di più",captionsOnlyContainerTitle:"Sottotitoli",realTimeTextOnlyContainerTitle:"Testo in tempo reale",captionsAndRealTimeTextContainerTitle:"Sottotitoli e testo in tempo reale",expandButtonAriaLabel:"Espandi",minimizeButtonAriaLabel:"Comprimi"},mentionPopover:{mentionPopoverHeader:"Suggerimenti"},imageOverlay:{downloadButtonLabel:"Scarica",dismissButtonAriaLabel:"Chiudi",overlayVisibleMessage:"Sovrapposizione dettagli immagine"},messageStatusIndicator:{deliveredAriaLabel:"Il messaggio è stato inviato",deliveredTooltipText:"Inviato",seenAriaLabel:"Messaggio visualizzato da altri utenti",seenTooltipText:"Visualizzato",readByTooltipText:"Letto da {messageThreadReadCount} di {remoteParticipantsCount}",sendingAriaLabel:"Invio del messaggio",sendingTooltipText:"Invio in corso",failedToSendAriaLabel:"Invio messaggio non riuscito",failedToSendTooltipText:"Invio non riuscito"},endCallButton:{label:"Permesso",tooltipContent:"Abbandona chiamata",leaveOption:"Abbandona",endCallOption:"Termina chiamata per tutti"},cameraButton:{onLabel:"Fotocamera",offLabel:"Fotocamera",tooltipDisabledContent:"La videocamera è disabilitata",tooltipOnContent:"Spegni la videocamera",tooltipOffContent:"Accendi la videocamera",tooltipVideoLoadingContent:"Il video è in corso di caricamento",cameraMenuTitle:"Fotocamera",cameraMenuTooltip:"Scegli fotocamera",cameraButtonSplitRoleDescription:"Pulsante di menu combinato",onSplitButtonAriaLabel:"Disabilita la videocamera",offSplitButtonAriaLabel:"Accendi la videocamera",cameraActionTurnedOnAnnouncement:"La videocamera è stata attivata",cameraActionTurnedOffAnnouncement:"La videocamera è stata disattivata",onSplitButtonPrimaryActionCamera:"Spegni la videocamera",offSplitButtonPrimaryActionCamera:"Accendi la videocamera",cameraPrimaryActionSplitButtonTitle:"Usa la fotocamera",videoEffectsMenuItemTitle:"Effetti",cameraButtonAriaDescription:"opzioni videocamera"},microphoneButton:{onLabel:"Microfono",offLabel:"Microfono",tooltipDisabledContent:"Il microfono è disabilitato",tooltipOnContent:"Disattiva microfono",tooltipOffContent:"Riattiva microfono",microphoneMenuTitle:"Microfono",microphoneMenuTooltip:"Scegli microfono",speakerMenuTitle:"Altoparlante",speakerMenuTooltip:"Scegli altoparlante",microphoneButtonSplitRoleDescription:"Pulsante di menu combinato",onSplitButtonAriaLabel:"Disattiva microfono",offSplitButtonAriaLabel:"Riattiva microfono",microphoneActionTurnedOnAnnouncement:"Il microfono è stato attivato",microphoneActionTurnedOffAnnouncement:"Il microfono è stato disattivato",offSplitButtonMicrophonePrimaryAction:"Riattiva microfono",onSplitButtonMicrophonePrimaryAction:"Disattiva microfono",microphonePrimaryActionSplitButtonTitle:"Usa il microfono",microphoneAriaDescription:"Opzioni audio",deepNoiseSuppressionTitle:"Eliminazione del rumore",deepNoiseSuppressionOnAnnouncement:"L'eliminazione del rumore profondo è stata attivata",deepNoiseSuppressionOffAnnouncement:"L'eliminazione del rumore profondo è stata disattivata"},devicesButton:{label:"Dispositivi",tooltipContent:"Gestisci dispositivi",cameraMenuTitle:"Fotocamera",cameraMenuTooltip:"Scegli fotocamera",audioDeviceMenuTitle:"Dispositivo audio",audioDeviceMenuTooltip:"Scegli dispositivo audio",microphoneMenuTitle:"Microfono",microphoneMenuTooltip:"Scegli microfono",speakerMenuTitle:"Altoparlante",speakerMenuTooltip:"Scegli altoparlante"},participantsButton:{label:"Persone",ariaLabel:"Persone",tooltipContent:"Mostra partecipanti",menuHeader:"In questa chiamata",participantsListButtonLabel:"{numParticipants} persone",muteAllButtonLabel:"Disattiva l'audio di tutti",copyInviteLinkButtonLabel:"Copia il collegamento dell’invito",copyInviteLinkActionedAriaLabel:"Collegamento di invito copiato"},screenShareButton:{onLabel:"Interrompi presentazione",offLabel:"Presentazione",tooltipDisabledContent:"La presentazione è disabilitata.",tooltipOnContent:"Presentazione dello schermo",tooltipOffContent:"Presenta lo schermo"},raiseHandButton:{offLabel:"Alza",onLabel:"Abbassa",tooltipDisabledContent:"L'azione Alza la mano è disabilitata",tooltipOnContent:"Abbassa la mano",tooltipOffContent:"Alza la mano"},reactionButton:{label:"Reagisci",ariaLabel:"Reagisci",tooltipDisabledContent:"L'azione di reazione è disabilitata",tooltipContent:"Invia una reazione",likeReactionTooltipContent:"Mi piace",heartReactionTooltipContent:"Amore",laughReactionTooltipContent:"Risata",applauseReactionTooltipContent:"Applauso",surprisedReactionTooltipContent:"Sorpresa"},realTimeText:{isTypingText:"Digitazione scrittura in tempo reale"},captionsSettingsModal:{captionsSettingsModalTitle:"Impostazioni sottotitoli",captionsSettingsSpokenLanguageDropdownLabel:"Lingua parlata",captionsSettingsCaptionLanguageDropdownLabel:"Lingua dei sottotitoli",captionsSettingsSpokenLanguageDropdownInfoText:"La lingua che parlano tutti i partecipanti a questa chiamata.",captionsSettingsCaptionLanguageDropdownInfoText:"I sottotitoli verranno visualizzati in questa lingua.",captionsSettingsConfirmButtonLabel:"Conferma",captionsSettingsCancelButtonLabel:"Annulla",captionsSettingsModalAriaLabel:"Finestra modale impostazioni sottotitoli",captionsSettingsCloseModalButtonAriaLabel:"Chiudi impostazione sottotitoli"},spokenLanguages:{"ar-ae":"Arabo - Emirati Arabi Uniti","ar-sa":"Arabo - Arabia Saudita","da-dk":"Danese","de-de":"Tedesco - Germania","en-au":"Inglese - Australia","en-ca":"Inglese - Canada","en-gb":"Inglese - Regno Unito","en-in":"Inglese - India","en-nz":"Inglese - Nuova Zelanda","en-us":"Inglese - Stati Uniti","es-es":"Spagnolo - Spagna (ordinamento moderno)","es-mx":"Spagnolo - Messico","fi-fi":"Finlandese","fr-ca":"Francese - Canada","fr-fr":"Francese - Francia","hi-in":"Hindi","it-it":"Italiano - Italia","ja-jp":"Giapponese","ko-kr":"Coreano","nb-no":"Norvegese (Bokmål)","nl-be":"Olandese - Belgio","nl-nl":"Olandese - Paesi Bassi","pl-pl":"Polacco","pt-br":"Portoghese - Brasile","ru-ru":"Russo","sv-se":"Svedese","zh-cn":"Cinese - Repubblica popolare cinese","zh-hk":"Cinese - RAS di Hong Kong","cs-cz":"Ceco","pt-pt":"Portoghese - Portogallo","tr-tr":"Turco","vi-vn":"Vietnamita","th-th":"Thailandese","he-il":"Ebraico","cy-gb":"Gallese","uk-ua":"Ucraino","el-gr":"Greco","hu-hu":"Ungherese","ro-ro":"Rumeno","sk-sk":"Slovacco","zh-tw":"Cinese - Taiwan"},captionLanguages:{ar:"Arabo",da:"Danese",de:"Tedesco",en:"Inglese",es:"Spagnolo",fi:"Finlandese","fr-ca":"Francese - Canada",fr:"Francese - Francia",hi:"Hindi",it:"Italiano",ja:"Giapponese",ko:"Coreano",nb:"Norvegese (Bokmål)",nl:"Olandese",pl:"Polacco",pt:"Portoghese - Brasile",ru:"Russo",sv:"Svedese","zh-Hans":"Cinese (semplificato)","zh-Hant":"Cinese (tradizionale)",cs:"Ceco","pt-pt":"Portoghese - Portogallo",tr:"Turco",vi:"Vietnamita",th:"Thailandese",he:"Ebraico",cy:"Gallese",uk:"Ucraino",el:"Greco",hu:"Ungherese",ro:"Rumeno",sk:"Slovacco"},startCaptionsButton:{onLabel:"Abilita sottotitoli",offLabel:"Disabilita sottotitoli",tooltipOnContent:"Disabilita sottotitoli",tooltipOffContent:"Abilita sottotitoli"},startRealTimeTextButton:{label:"Attiva la scrittura in tempo reale per questa chiamata",tooltipOffContent:"Attiva la scrittura in tempo reale per questa chiamata"},messageThread:{yesterday:"Ieri",sunday:"Domenica",monday:"Lunedì",tuesday:"Martedì",wednesday:"Mercoledì",thursday:"Giovedì",friday:"Venerdì",saturday:"Sabato",participantJoined:"si è unito alla chat.",participantLeft:"ha abbandonato la chat.",editMessage:"Modifica",removeMessage:"Elimina",resendMessage:"Riprova a inviare",failToSendTag:"Invio non riuscito",editedTag:"Modificato",liveAuthorIntro:"Messaggio da {author}",editedMessageLiveAuthorIntro:"Messaggio modificato da {author}",editedMessageLocalUserLiveAuthorIntro:"Messaggio modificato",messageContentAriaText:"{status} {author} ha detto {message}",messageContentMineAriaText:"{status} Hai detto {message}",editBoxTextLimit:"Il messaggio ha superato il limite di caratteri {limitNumber}",editBoxPlaceholderText:"Modifica il messaggio",newMessagesIndicator:"Nuovi messaggi",noDisplayNameSub:"Nessun nome",editBoxCancelButton:"Annulla",editBoxSubmitButton:"Fatto",messageReadCount:"Letto da {messageReadByCount} di {remoteParticipantsCount}",actionMenuMoreOptions:"Altre opzioni",downloadAttachment:"Scarica file",openAttachment:"Apri file",blockedWarningText:"Questo messaggio è stato eliminato a causa dei criteri dell'organizzazione.",blockedWarningLinkText:"Dettagli",attachmentCardGroupMessage:"Il messaggio ha allegati: {attachmentCount}.",messageDeletedAnnouncementAriaLabel:"Il messaggio è stato eliminato",richTextBoldTooltip:"Grassetto",richTextItalicTooltip:"Corsivo",richTextUnderlineTooltip:"Sottolineato",richTextBulletListTooltip:"Elenco puntato",richTextNumberListTooltip:"Elenco numerato",richTextIncreaseIndentTooltip:"Aumenta rientro",richTextDecreaseIndentTooltip:"Riduci rientro",richTextInsertTableTooltip:"Inserisci tabella",richTextFormatButtonTooltip:"Formato",richTextInsertRowOrColumnMenu:"Inserisci",richTextInsertTableMenuTitle:"Inserisci tabella {column} x {row}",richTextInsertRowAboveMenu:"Inserisci sopra",richTextInsertRowBelowMenu:"Inserisci sotto",richTextInsertColumnLeftMenu:"Inserisci a sinistra",richTextInsertColumnRightMenu:"Inserisci a destra",richTextDeleteRowOrColumnMenu:"Elimina",richTextDeleteColumnMenu:"Elimina colonna",richTextDeleteRowMenu:"Elimina riga",richTextDeleteTableMenu:"Elimina tabella",richTextToolbarMoreButtonAriaLabel:"Altre opzioni",attachmentUploadsPendingError:"È in corso il caricamento del file, attendere.",imageUploadsPendingError:"È in corso il caricamento dell'immagine, attendere.",richTextNewBulletedListItemAnnouncement:"Punto elenco, nuova riga",richTextNewNumberedListItemAnnouncement:"{0}, nuova riga",richTextBulletedListAppliedAnnouncement:"Elenco puntato applicato",richTextNumberedListAppliedAnnouncement:"Elenco numerato applicato"},errorBar:{unableToReachChatService:"Sei offline",accessDenied:"Non è possibile accedere ai servizi di chat. Controllare le credenziali utente specificate",userNotInChatThread:"Non fai più parte di questo thread di chat",sendMessageNotInChatThread:"Non è stato possibile inviare il messaggio perché non sei più in questo thread di chat",sendMessageGeneric:"Impossibile inviare il messaggio",callingNetworkFailure:"Problema di connessione della chiamata: sembra che tu sia offline",startVideoGeneric:"Non è stato possibile avviare il video",stopVideoGeneric:"Non è stato possibile arrestare il video",muteGeneric:"Non è stato possibile disattivare l'audio del microfono",unmuteGeneric:"Non è stato possibile riattivare l'audio del microfono",speakingWhileMuted:"Il microfono è disattivato",startScreenShareGeneric:"Si è verificato un problema durante l'avvio della condivisione dello schermo.",stopScreenShareGeneric:"Non è stato possibile arrestare la condivisione dello schermo",callNetworkQualityLow:"La qualità della rete è bassa.",teamsMeetingCallNetworkQualityLow:"La qualità della rete è bassa.",callNoSpeakerFound:"Non sono stati trovati altoparlanti o cuffie. Connetti un dispositivo audio per ascoltare la chiamata.",callNoMicrophoneFound:"Nessun microfono trovato. Connetti un dispositivo di input audio.",callMicrophoneAccessDenied:"Impossibile accedere al microfono. Fare clic sul blocco nella barra degli indirizzi per concedere l'autorizzazione a questa pagina Web.",callMicrophoneAccessDeniedSafari:"Impossibile accedere al microfono. Aggiornare la pagina per consentire le autorizzazioni oppure controllare le impostazioni del browser e verificare che le autorizzazioni siano abilitate per questo sito Web.",callMicrophoneMutedBySystem:"Il sistema disattiva l'audio.",callMicrophoneUnmutedBySystem:"Il microfono è stato ripristinato e il sistema ha riattivato l'audio.",callMacOsMicrophoneAccessDenied:"Impossibile accedere al microfono. Concedi l'autorizzazione al microfono nelle impostazioni di privacy di macOS.",callLocalVideoFreeze:"Larghezza di banda di rete insufficiente. Il video potrebbe essere sospeso per gli altri partecipanti alla chiamata.",callCameraAccessDenied:"Non è possibile accedere alla fotocamera. Fare clic sul blocco nella barra degli indirizzi per concedere l'autorizzazione a questa pagina Web.",callCameraAccessDeniedSafari:"Non è possibile accedere alla fotocamera. Aggiornare la pagina per consentire le autorizzazioni oppure controllare le impostazioni del browser e verificare che le autorizzazioni siano abilitate per questo sito Web.",callCameraAlreadyInUse:"Non è possibile accedere alla fotocamera. Potrebbe essere già in uso da un'altra applicazione.",callVideoStoppedBySystem:"Il video è stato arrestato dal sistema.",callVideoRecoveredBySystem:"Il video è ripreso.",callMacOsCameraAccessDenied:"MacOS sta bloccando l'accesso alla fotocamera. Aggiorna le impostazioni di privacy per consentire a questo browser di accedere alla fotocamera.",callMacOsScreenShareAccessDenied:"MacOS sta bloccando la condivisione dello schermo. Aggiorna le impostazioni di privacy per consentire a questo browser di registrare lo schermo.",dismissButtonAriaLabel:"Chiudi",failedToJoinCallGeneric:"Non è stato possibile partecipare alla chiamata.",failedToJoinCallInvalidMeetingLink:"Impossibile partecipare alla riunione. Collegamento non valido.",cameraFrozenForRemoteParticipants:"Gli utenti della chiamata hanno problemi a visualizzare il video. Controllare i dispositivi e la rete.",unableToStartVideoEffect:"Non è possibile applicare l'effetto video.",startSpotlightWhileMaxParticipantsAreSpotlighted:"Non è possibile avviare i contenuti in evidenza sui partecipanti perché il numero massimo di partecipanti è già in evidenza.",mutedByRemoteParticipant:"L'audio è stato disattivato da un altro partecipante."},notificationStack:{callingNetworkFailure:{title:"Problema di connessione della chiamata",message:"Sembra che tu sia offline. Controllare la connessione di rete e riprovare.",dismissButtonAriaLabel:"Chiudi"},startVideoGeneric:{title:"Non è stato possibile avviare il video.",dismissButtonAriaLabel:"Chiudi"},stopVideoGeneric:{title:"Non è stato possibile arrestare il video.",dismissButtonAriaLabel:"Chiudi"},muteGeneric:{title:"Non è stato possibile disattivare l'audio del microfono.",dismissButtonAriaLabel:"Chiudi"},unmuteGeneric:{title:"Non è stato possibile riattivare l'audio del microfono.",dismissButtonAriaLabel:"Chiudi"},speakingWhileMuted:{title:"L'audio è disattivato.",dismissButtonAriaLabel:"Chiudi"},startScreenShareGeneric:{title:"Si è verificato un problema durante l'avvio della condivisione dello schermo.",dismissButtonAriaLabel:"Chiudi"},stopScreenShareGeneric:{title:"Non è stato possibile arrestare la condivisione dello schermo.",dismissButtonAriaLabel:"Chiudi"},callNetworkQualityLow:{title:"La qualità della rete è bassa.",dismissButtonAriaLabel:"Chiudi"},teamsMeetingCallNetworkQualityLow:{title:"La qualità della rete è bassa.",dismissButtonAriaLabel:"Chiudi",message:"Partecipa a questa chiamata dal telefono per un suono migliore. Puoi continuare a visualizzare la riunione su questo dispositivo.",primaryButtonLabel:"Partecipa tramite telefono"},callNoSpeakerFound:{title:"Non sono stati trovati altoparlanti o cuffie",message:"Connetti un dispositivo audio per ascoltare la chiamata.",dismissButtonAriaLabel:"Chiudi"},callNoMicrophoneFound:{title:"Nessun microfono trovato",message:"Connetti un dispositivo di input audio.",dismissButtonAriaLabel:"Chiudi"},callMicrophoneAccessDenied:{title:"Impossibile accedere al microfono",message:"Fare clic sul blocco nella barra degli indirizzi per concedere l'autorizzazione a questa pagina Web.",dismissButtonAriaLabel:"Chiudi"},callMicrophoneAccessDeniedSafari:{title:"Impossibile accedere al microfono",message:"Aggiornare la pagina per consentire le autorizzazioni oppure controllare le impostazioni del browser e verificare che le autorizzazioni siano abilitate per questo sito Web.",dismissButtonAriaLabel:"Chiudi"},callMicrophoneMutedBySystem:{title:"Il sistema disattiva l'audio.",dismissButtonAriaLabel:"Chiudi"},callMicrophoneUnmutedBySystem:{title:"Il microfono è stato ripristinato e il sistema ha riattivato l'audio.",dismissButtonAriaLabel:"Chiudi"},callMacOsMicrophoneAccessDenied:{title:"Impossibile accedere al microfono",message:"Concedi l'autorizzazione al microfono nelle impostazioni di privacy di macOS.",dismissButtonAriaLabel:"Chiudi"},callLocalVideoFreeze:{title:"Larghezza di banda di rete insufficiente",message:"Il video potrebbe essere sospeso per gli altri partecipanti alla chiamata.",dismissButtonAriaLabel:"Chiudi"},callCameraAccessDenied:{title:"Impossibile accedere alla fotocamera",message:"Fare clic sul blocco nella barra degli indirizzi per concedere l'autorizzazione a questa pagina Web.",dismissButtonAriaLabel:"Chiudi"},callCameraAccessDeniedSafari:{title:"Impossibile accedere alla fotocamera",message:"Aggiornare la pagina per consentire le autorizzazioni oppure controllare le impostazioni del browser e verificare che le autorizzazioni siano abilitate per questo sito Web.",dismissButtonAriaLabel:"Chiudi"},callCameraAlreadyInUse:{title:"Impossibile accedere alla fotocamera",message:"Potrebbe essere già in uso da un'altra applicazione.",dismissButtonAriaLabel:"Chiudi"},callVideoStoppedBySystem:{title:"Il video è stato arrestato dal sistema.",dismissButtonAriaLabel:"Chiudi"},callVideoRecoveredBySystem:{title:"Il video è ripreso.",dismissButtonAriaLabel:"Chiudi"},callMacOsCameraAccessDenied:{title:"MacOS blocca l'accesso alla fotocamera",message:"Aggiorna le impostazioni di privacy per consentire a questo browser di accedere alla fotocamera.",dismissButtonAriaLabel:"Chiudi"},callMacOsScreenShareAccessDenied:{title:"MacOS sta bloccando la condivisione dello schermo",message:"Aggiorna le impostazioni di privacy per consentire a questo browser di registrare lo schermo.",dismissButtonAriaLabel:"Chiudi"},failedToJoinCallGeneric:{title:"Non è stato possibile partecipare alla chiamata.",dismissButtonAriaLabel:"Chiudi"},failedToJoinCallInvalidMeetingLink:{title:"Impossibile partecipare alla riunione. Collegamento non valido.",dismissButtonAriaLabel:"Chiudi"},cameraFrozenForRemoteParticipants:{title:"Gli utenti della chiamata hanno problemi a visualizzare il video",message:"Controllare i dispositivi e la rete.",dismissButtonAriaLabel:"Chiudi"},unableToStartVideoEffect:{title:"Non è possibile applicare l'effetto video.",dismissButtonAriaLabel:"Chiudi"},startSpotlightWhileMaxParticipantsAreSpotlighted:{title:"Impossibile avviare i contenuti in evidenza sui partecipanti",message:"Il numero massimo di partecipanti è già stato indicato.",dismissButtonAriaLabel:"Chiudi"},mutedByRemoteParticipant:{title:"L'audio è stato disattivato da un altro partecipante.",dismissButtonAriaLabel:"Chiudi"},recordingStarted:{title:"La registrazione è stata avviata.",message:"Partecipando, fornisci il consenso per la trascrizione di questa riunione.",dismissButtonAriaLabel:"Chiudi"},transcriptionStarted:{title:"La trascrizione è stata avviata.",message:"Partecipando, fornisci il consenso per la trascrizione di questa riunione.",dismissButtonAriaLabel:"Chiudi"},recordingStopped:{title:"È in corso il salvataggio della registrazione.",message:"La registrazione è stata arrestata.",dismissButtonAriaLabel:"Chiudi"},transcriptionStopped:{title:"È in corso il salvataggio della trascrizione.",message:"La trascrizione è stata arrestata.",dismissButtonAriaLabel:"Chiudi"},recordingAndTranscriptionStarted:{title:"Registrazione e trascrizione avviate.",message:"Partecipando, fornisci il consenso per la trascrizione di questa riunione.",dismissButtonAriaLabel:"Chiudi"},recordingAndTranscriptionStopped:{title:"È in corso il salvataggio della registrazione e della trascrizione.",message:"Registrazione e trascrizione interrotte.",dismissButtonAriaLabel:"Chiudi"},recordingStoppedStillTranscribing:{title:"La registrazione è stata arrestata.",message:"È in corso la trascrizione solo di questa riunione.",dismissButtonAriaLabel:"Chiudi"},transcriptionStoppedStillRecording:{title:"La trascrizione è stata arrestata.",message:"È in corso la registrazione solo di questa riunione.",dismissButtonAriaLabel:"Chiudi"},assignedBreakoutRoomOpened:{title:"Verrai spostato nella stanza assegnata tra 5 secondi.",dismissButtonAriaLabel:"Chiudi"},assignedBreakoutRoomChanged:{title:"La stanza di lavoro è cambiata",message:"Verrai spostato nella stanza assegnata tra 5 secondi.",dismissButtonAriaLabel:"Chiudi"},assignedBreakoutRoomClosed:{title:"Il gruppo di lavoro è chiuso",message:"Ti reinsegneremo alla riunione tra 5 secondi.",dismissButtonAriaLabel:"Chiudi"},assignedBreakoutRoomOpenedPromptJoin:{title:"Vuoi partecipare alla stanza di lavoro?",message:"Ti è stata assegnata una stanza di lavoro.",dismissButtonAriaLabel:"Chiudi",primaryButtonLabel:"Accedi alla stanza",secondaryButtonLabel:"Più tardi"},breakoutRoomJoined:{title:"Sei stato aggiunto alla stanza di lavoro.",dismissButtonAriaLabel:"Chiudi"},breakoutRoomClosingSoon:{title:"Il limite di tempo della stanza di lavoro sta per scadere.",message:"Questa stanza verrà chiusa tra 30 secondi",dismissButtonAriaLabel:"Chiudi"},capabilityTurnVideoOnPresent:{title:"La videocamera è stata abilitata",message:"Attiva se vuoi condividere il video.",dismissButtonAriaLabel:"Chiudi"},capabilityTurnVideoOnAbsent:{title:"La videocamera è stata disabilitata",message:"Non puoi più condividere il video.",dismissButtonAriaLabel:"Chiudi"},capabilityUnmuteMicPresent:{title:"Il microfono è stato abilitato",message:"Se vuoi parlare, puoi riattivare l'audio.",dismissButtonAriaLabel:"Chiudi"},capabilityUnmuteMicAbsent:{title:"Il tuo microfono è stato disattivato.",message:"Non puoi più riattivare l'audio.",dismissButtonAriaLabel:"Chiudi"},togetherModeStarted:{title:"Togethermode è stato avviato",dismissButtonAriaLabel:"Chiudi"},togetherModeEnded:{title:"Togethermode è terminato",dismissButtonAriaLabel:"Chiudi"}},videoGallery:{screenIsBeingSharedMessage:"Stai condividendo lo schermo",screenShareLoadingMessage:"Caricamento dello schermo di {participant}",localScreenShareLoadingMessage:"Caricamento della schermata in corso...",localVideoLabel:"Tu",localVideoCameraSwitcherLabel:"Cambia videocamera",localVideoMovementLabel:"Riquadro video locale mobile",localVideoMovementAriaLabel:"Riquadro video locale mobile",localVideoSelectedDescription:"{cameraName} selezionata",displayNamePlaceholder:"Partecipante senza nome",fitRemoteParticipantToFrame:"Adatta all'inquadratura",fillRemoteParticipantFrame:"Riempi l'inquadratura",pinParticipantForMe:"Aggiungi per me",pinParticipantForMeLimitReached:"Segnaposto (limite raggiunto)",unpinParticipantForMe:"Rimuovi",pinParticipantMenuItemAriaLabel:"Aggiungi {participantName}",unpinParticipantMenuItemAriaLabel:"Rimuovi {participantName}",pinnedParticipantAnnouncementAriaLabel:"{participantName} aggiunto",unpinnedParticipantAnnouncementAriaLabel:"{participantName} sbloccato",startSpotlightVideoTileMenuLabel:"Metti in evidenza per tutti",addSpotlightVideoTileMenuLabel:"Metti in evidenza",spotlightLimitReachedMenuTitle:"È stato raggiunto il limite di contenuti in evidenza",stopSpotlightVideoTileMenuLabel:"Interrompi la posizione in evidenza",stopSpotlightOnSelfVideoTileMenuLabel:"Chiudi visualizzazione in evidenza",attendeeRole:"Partecipante",muteParticipantMenuItemLabel:"Disattiva audio",waitingScreenText:"In attesa di altri partecipanti",forbidAudio:"Disabilita microfono",permitAudio:"Consenti microfono",forbidAudioTileMenuLabel:"Disabilita microfono",permitAudioTileMenuLabel:"Consenti microfono",forbidVideo:"Disabilita videocamera",permitVideo:"Consenti videocamera",forbidVideoTileMenuLabel:"Disabilita videocamera",permitVideoTileMenuLabel:"Consenti videocamera"},dialpad:{placeholderText:"Inserisci numero di telefono",deleteButtonAriaLabel:"Elimina"},holdButton:{onLabel:"Riprendi",offLabel:"Mantenere",tooltipOnContent:"Riprendi chiamata",tooltipOffContent:"Metti in attesa chiamata"},videoTile:{participantStateRinging:"Chiamata in corso...",participantReconnecting:"Riconnessione in corso...",participantStateHold:"Per l'attesa",moreOptionsButtonAriaLabel:"Altre opzioni {displayName} {isMuted} {micDisabledState} {cameraDisabledState} {isHandRaised} {state} {isSpeaking}",moreOptionsParticipantMutedStateMutedAriaLabel:"audio disattivato",moreOptionsParticipantMutedStateUnmutedAriaLabel:"audio riattivato",moreOptionsParticipantHandRaisedAriaLabel:"Mano alzata",moreOptionsParticipantIsSpeakingAriaLabel:"Impegnato in una conversazione",moreOptionsParticipantMicDisabledAriaLabel:"Microfono disabilitato",moreOptionsParticipantCameraDisabledAriaLabel:"Fotocamera disabilitata"},CameraAndMicrophoneSitePermissionsRequest:{primaryText:"Consenti a {appName} di usare la fotocamera e il microfono",secondaryText:"In questo modo i partecipanti possono vederti e sentirti.",linkText:"Serve aiuto? Guida alla risoluzione dei problemi",primaryButtonText:"Continua senza fotocamera e microfono",ariaLabel:"Consenti l'accesso alla fotocamera e al microfono"},CameraSitePermissionsRequest:{primaryText:"Consenti a {appName} di usare la fotocamera",secondaryText:"In questo modo i partecipanti possono vederti.",linkText:"Serve aiuto? Guida alla risoluzione dei problemi",primaryButtonText:"Continua senza fotocamera",ariaLabel:"Consenti l'accesso alla fotocamera"},MicrophoneSitePermissionsRequest:{primaryText:"Consenti a {appName} di usare il microfono",secondaryText:"In questo modo i partecipanti possono sentirti.",linkText:"Serve aiuto? Guida alla risoluzione dei problemi",primaryButtonText:"Continua senza microfono",ariaLabel:"Consenti l'accesso al microfono"},CameraAndMicrophoneSitePermissionsCheck:{primaryText:"Verifica dell'accesso alla fotocamera e al microfono",secondaryText:"Consenti l'accesso se richiesto. In questo modo i partecipanti possono vederti e sentirti.",linkText:"Serve aiuto? Guida alla risoluzione dei problemi",primaryButtonText:"Continua senza fotocamera e microfono",ariaLabel:"Verifica dell'accesso alla fotocamera e al microfono. Consenti l'accesso se richiesto."},CameraSitePermissionsCheck:{primaryText:"Verifica dell'accesso alla fotocamera",secondaryText:"Consenti l'accesso se richiesto. In questo modo i partecipanti possono vederti.",linkText:"Serve aiuto? Guida alla risoluzione dei problemi",primaryButtonText:"Continua senza fotocamera",ariaLabel:"Verifica dell'accesso alla fotocamera. Consenti l'accesso se richiesto."},MicrophoneSitePermissionsCheck:{primaryText:"Verifica dell'accesso al microfono",secondaryText:"Consenti l'accesso se richiesto. In questo modo i partecipanti possono sentirti.",linkText:"Serve aiuto? Guida alla risoluzione dei problemi",primaryButtonText:"Continua senza microfono",ariaLabel:"Verifica dell'accesso al microfono. Consenti l'accesso se richiesto."},CameraAndMicrophoneSitePermissionsDenied:{primaryText:"Non è possibile accedere alla fotocamera e al microfono",secondaryText:"Fare clic sull'icona di blocco nella barra degli indirizzi per concedere le autorizzazioni del microfono a questa pagina Web. Potrebbe essere necessario un aggiornamento della pagina.",primaryButtonText:"Continua senza fotocamera e microfono",linkText:"Serve aiuto? Guida alla risoluzione dei problemi"},CameraAndMicrophoneSitePermissionsDeniedSafari:{primaryText:"Non è possibile accedere alla fotocamera e al microfono",secondaryText:"Aggiornare la pagina per consentire le autorizzazioni oppure controllare le impostazioni del browser e verificare che le autorizzazioni siano abilitate per questo sito Web.",primaryButtonText:"Continua senza fotocamera e microfono",linkText:"Serve aiuto? Guida alla risoluzione dei problemi"},CameraSitePermissionsDenied:{primaryText:"Impossibile accedere alla videocamera",secondaryText:"Fare clic sull'icona di blocco nella barra degli indirizzi per concedere le autorizzazioni della fotocamera a questa pagina Web. Potrebbe essere necessario un aggiornamento della pagina.",primaryButtonText:"Continua senza fotocamera",linkText:"Serve aiuto? Guida alla risoluzione dei problemi"},MicrophoneSitePermissionsDenied:{primaryText:"Impossibile accedere al microfono",secondaryText:"Fare clic sull'icona di blocco nella barra degli indirizzi per concedere le autorizzazioni del microfono a questa pagina Web. Potrebbe essere necessario un aggiornamento della pagina.",primaryButtonText:"Continua senza microfono",linkText:"Serve aiuto? Guida alla risoluzione dei problemi"},CameraSitePermissionsDeniedSafari:{primaryText:"Impossibile accedere alla videocamera",secondaryText:"Aggiornare la pagina per consentire le autorizzazioni oppure controllare le impostazioni del browser e verificare che le autorizzazioni siano abilitate per questo sito Web.",primaryButtonText:"Continua senza fotocamera",linkText:"Serve aiuto? Guida alla risoluzione dei problemi"},MicrophoneSitePermissionsDeniedSafari:{primaryText:"Impossibile accedere al microfono",secondaryText:"Aggiornare la pagina per consentire le autorizzazioni oppure controllare le impostazioni del browser e verificare che le autorizzazioni siano abilitate per questo sito Web.",primaryButtonText:"Continua senza microfono",linkText:"Serve aiuto? Guida alla risoluzione dei problemi"},UnsupportedBrowser:{primaryText:"Browser non supportato",secondaryText:"Partecipa alla chiamata utilizzando un browser compatibile.",moreHelpLinkText:"Visualizza i requisiti di compatibilità"},UnsupportedBrowserVersion:{primaryText:"Aggiornamento del browser necessario",secondaryText:"Per garantire la migliore chiamata possibile, aggiorna il browser e riprova a partecipare alla chiamata.",moreHelpLinkText:"Visualizza i requisiti di compatibilità",continueAnywayButtonText:"Avvia chiamata senza aggiornamento"},UnsupportedOperatingSystem:{primaryText:"Sistemi operativi non supportati",secondaryText:"Partecipa alla chiamata utilizzando un dispositivo con un sistema operativo compatibile.",moreHelpLinkText:"Visualizza i requisiti di compatibilità"},BrowserPermissionDenied:{primaryText:"Non è possibile usare la fotocamera o il microfono",secondaryText:"Il browser potrebbe non avere accesso alla fotocamera o al microfono. Per risolvere il problema, aprire Preferenze di sistema.",primaryButtonText:"Riprova",linkText:"Serve aiuto? Guida alla risoluzione dei problemi"},BrowserPermissionDeniedIOS:{primaryText:"Consenti l'accesso al microfono per continuare",secondaryText:"Così gli altri partecipanti possono sentirti.",primaryButtonText:"Riprova",imageAltText:"Posizione dell'autorizzazione del microfono e della fotocamera per iOS",linkText:"Serve aiuto? Guida alla risoluzione dei problemi",step1Text:"Vai alle impostazioni dell'app",step2Text:"Scorri verso il basso fino alle impostazioni per questo browser",step3Text:"Attiva microfono (fotocamera facoltativa)",step4Text:"Prova a partecipare di nuovo alla chiamata",step1DigitText:"1",step2DigitText:"2",step3DigitText:"3",step4DigitText:"4"},verticalGallery:{leftNavButtonAriaLabel:"pagina precedente {current} di {total}",rightNavButtonAriaLabel:"pagina successiva {current} di {total}"},meetingConferencePhoneInfo:{meetingConferencePhoneInfoModalTitle:"Partecipa alla chiamata dal tuo telefono",meetingConferencePhoneInfoModalDialIn:"Componi il numero",meetingConferencePhoneInfoModalMeetingId:"Immetti l'ID riunione",meetingConferencePhoneInfoModalWait:"Attendi l'ammissione da parte dell'organizzatore",meetingConferencePhoneInfoModalNoPhoneAvailable:"Nessun telefono disponibile",meetingConferencePhoneInfoModalTollGeoData:"{country}, {city}",meetingConferencePhoneInfoModalTollFree:"(Numero verde)",meetingConferencePhoneInfoModalToll:"(Numero a tariffa)"},IncomingCallNotification:{incomingCallNotificationPlaceholderId:"Utente sconosciuto",incomingCallNotificationPlaceholderAlert:"{callerName} sta chiamando",incomingCallNoticicationAcceptWithAudioAriaLabel:"Accetta con audio",incomingCallNoticicationAcceptWithVideoAriaLabel:"Accetta con video",incomingCallNoticicationRejectAriaLabel:"Rifiuta",incomingCallNotificationAcceptButtonLabel:"Accetta",incomingCallNotificationRejectButtonLabel:"Rifiuta",incomingCallNotificationAccceptWithVideoButtonLabel:"Accetta con video",incomingCallNotificationDismissButtonAriaLabel:"Ignora"}})},fQt={strings:Jh({participantItem:{isMeText:"(自分)",menuTitle:"その他のオプション",removeButtonLabel:"削除",sharingIconLabel:"共有",mutedIconLabel:"ミュート状態",handRaisedIconLabel:"挙手 - 位置 {position}",displayNamePlaceholder:"名前のない参加者",participantStateRinging:"呼び出し中...",participantStateHold:"保留中",participantItemAriaLabel:"{displayName}、{handRaisedState}、{mutedState}、{micDisabledState}、{cameraDisabledState}、{sharingState}、{connectionState}",participantItemWithMoreOptionsAriaLabel:"{displayName}、{handRaisedState}、{mutedState}、{micDisabledState}、{cameraDisabledState}、{sharingState}、{connectionState}、その他のオプション",attendeeRole:"出席者",micDisabledIconLabel:"マイクが無効になっています",cameraDisabledIconLabel:"カメラが無効になっています"},ParticipantList:{overflowParticipantCount:"その他 {overflowCount} 個"},typingIndicator:{singleUser:"{user} さんが入力しています...",multipleUsers:"{users} さんが入力しています...",multipleUsersAbbreviateOne:"{users} さんとその他 1 人が入力しています...",multipleUsersAbbreviateMany:"{users} さんと他 {numOthers} 人が入力しています...",delimiter:","},sendBox:{placeholderText:"メッセージを入力",textTooLong:"メッセージの長さが上限を超えています。",sendButtonAriaLabel:"メッセージの送信",attachmentUploadsPendingError:"ファイルをアップロードしています。お待ちください。",removeAttachment:"ファイルの削除",uploading:"アップロード中",uploadCompleted:"アップロードが完了しました",attachmentMoreMenu:"その他のオプション"},richTextSendBox:{placeholderText:"メッセージを入力してください",textTooLong:"メッセージの長さが上限を超えています。",sendButtonAriaLabel:"メッセージの送信",attachmentUploadsPendingError:"ファイルをアップロードしています。お待ちください。",imageUploadsPendingError:"画像をアップロードしています。お待ちください。",removeAttachment:"ファイルを削除します",uploading:"アップロード中",uploadCompleted:"アップロード完了",richTextBoldTooltip:"太字",richTextItalicTooltip:"斜体",richTextUnderlineTooltip:"下線",richTextBulletListTooltip:"箇条書き",richTextNumberListTooltip:"番号付きリスト",richTextIncreaseIndentTooltip:"インデントを増やします",richTextDecreaseIndentTooltip:"インデントを減らします",richTextInsertTableTooltip:"表を挿入します",richTextFormatButtonTooltip:"形式",richTextInsertRowOrColumnMenu:"挿入",richTextInsertTableMenuTitle:"{column} x {row} の表を挿入する",richTextInsertRowAboveMenu:"上に挿入",richTextInsertRowBelowMenu:"下に挿入",richTextInsertColumnLeftMenu:"左に挿入",richTextInsertColumnRightMenu:"右に挿入",richTextDeleteRowOrColumnMenu:"削除",richTextDeleteColumnMenu:"列の削除",richTextDeleteRowMenu:"行の削除",richTextDeleteTableMenu:"表の削除",richTextToolbarAriaLabel:"メッセージの書式設定ツール バー",richTextToolbarMoreButtonAriaLabel:"その他のオプション",attachmentMoreMenu:"その他のオプション",richTextNewBulletedListItemAnnouncement:"行頭文字、改行",richTextNewNumberedListItemAnnouncement:"{0}、改行",richTextBulletedListAppliedAnnouncement:"箇条書きが適用されました",richTextNumberedListAppliedAnnouncement:"番号付きリストが適用されました"},realTimeTextModal:{realTimeTextModalAriaLabel:"RTT モーダルを有効にする",realTimeTextModalTitle:"RTT を有効にしますか?",realTimeTextModalText:"会議の全員に対してリアルタイム テキスト (RTT) が有効になります。",realTimeTextConfirmButtonLabel:"有効にする",realTimeTextCancelButtonLabel:"キャンセル",realTimeTextCloseModalButtonAriaLabel:"RTT モーダルを閉じる"},captionsBanner:{captionsBannerSpinnerText:"キャプションを開始しています...",realTimeTextInputBoxDefaultText:"リアルタイムにメッセージを入力",realTimeTextInputErrorMessage:"メッセージは 2,000 文字以下にする必要があります",realTimeTextBannerTitle:"RTT",realTimeTextBannerContent:"RTT (リアルタイム テキスト) は、会議の全期間のすべての参加者に対して有効になっています。",realTimeTextBannerLinkLabel:"詳細情報",captionsOnlyContainerTitle:"キャプション",realTimeTextOnlyContainerTitle:"リアルタイム テキスト",captionsAndRealTimeTextContainerTitle:"キャプションとリアルタイム テキスト",expandButtonAriaLabel:"展開",minimizeButtonAriaLabel:"折りたたむ"},mentionPopover:{mentionPopoverHeader:"候補"},imageOverlay:{downloadButtonLabel:"ダウンロード",dismissButtonAriaLabel:"閉じる",overlayVisibleMessage:"画像の詳細のオーバーレイ"},messageStatusIndicator:{deliveredAriaLabel:"メッセージを送信しました",deliveredTooltipText:"送信しました",seenAriaLabel:"他のユーザーが表示したメッセージ",seenTooltipText:"既読",readByTooltipText:"{remoteParticipantsCount} の {messageThreadReadCount} による読み取り",sendingAriaLabel:"メッセージを送信しています",sendingTooltipText:"送信中",failedToSendAriaLabel:"メッセージの送信に失敗しました",failedToSendTooltipText:"送信できませんでした"},endCallButton:{label:"退出",tooltipContent:"通話を終了",leaveOption:"退出",endCallOption:"全員の通話を終了"},cameraButton:{onLabel:"カメラ",offLabel:"カメラ",tooltipDisabledContent:"カメラが無効になっています",tooltipOnContent:"カメラをオフ",tooltipOffContent:"カメラをオンにする",tooltipVideoLoadingContent:"ビデオの読み込み中です",cameraMenuTitle:"カメラ",cameraMenuTooltip:"カメラを選択する",cameraButtonSplitRoleDescription:"分割ボタン",onSplitButtonAriaLabel:"カメラをオフにする",offSplitButtonAriaLabel:"カメラをオンにする",cameraActionTurnedOnAnnouncement:"カメラがオンになっています",cameraActionTurnedOffAnnouncement:"カメラがオフになっています",onSplitButtonPrimaryActionCamera:"カメラをオフにする",offSplitButtonPrimaryActionCamera:"カメラをオンにする",cameraPrimaryActionSplitButtonTitle:"カメラを使用する",videoEffectsMenuItemTitle:"効果",cameraButtonAriaDescription:"カメラのオプション"},microphoneButton:{onLabel:"マイク",offLabel:"マイク",tooltipDisabledContent:"マイクが無効になっています",tooltipOnContent:"マイクをミュートにする",tooltipOffContent:"マイクのミュートを解除する",microphoneMenuTitle:"マイク",microphoneMenuTooltip:"マイクを選択する",speakerMenuTitle:"スピーカー",speakerMenuTooltip:"スピーカーを選択する",microphoneButtonSplitRoleDescription:"分割ボタン",onSplitButtonAriaLabel:"マイクをミュートする",offSplitButtonAriaLabel:"マイクのミュートを解除する",microphoneActionTurnedOnAnnouncement:"マイクがオンになっています",microphoneActionTurnedOffAnnouncement:"マイクがオフになっています",offSplitButtonMicrophonePrimaryAction:"マイクのミュートを解除する",onSplitButtonMicrophonePrimaryAction:"マイクをミュートする",microphonePrimaryActionSplitButtonTitle:"マイクを使用する",microphoneAriaDescription:"オーディオのオプション",deepNoiseSuppressionTitle:"ノイズ抑制",deepNoiseSuppressionOnAnnouncement:"ディープ ノイズ抑制がオンになっています",deepNoiseSuppressionOffAnnouncement:"ディープ ノイズ抑制がオフになっています"},devicesButton:{label:"デバイス",tooltipContent:"デバイスの管理",cameraMenuTitle:"カメラ",cameraMenuTooltip:"カメラを選択する",audioDeviceMenuTitle:"オーディオ デバイス",audioDeviceMenuTooltip:"オーディオ デバイスを選択する",microphoneMenuTitle:"マイク",microphoneMenuTooltip:"マイクを選択する",speakerMenuTitle:"スピーカー",speakerMenuTooltip:"スピーカーを選択する"},participantsButton:{label:"ユーザー",ariaLabel:"連絡先",tooltipContent:"参加者を表示",menuHeader:"この通話で",participantsListButtonLabel:"{numParticipants} 人",muteAllButtonLabel:"全員をミュート",copyInviteLinkButtonLabel:"招待用のリンクをコピー",copyInviteLinkActionedAriaLabel:"招待用のリンクがコピーされました"},screenShareButton:{onLabel:"プレゼンテーションの停止",offLabel:"提示",tooltipDisabledContent:"プレゼンテーションは無効です",tooltipOnContent:"画面の表示",tooltipOffContent:"画面のプレゼンテーション"},raiseHandButton:{offLabel:"手を挙げる",onLabel:"低い",tooltipDisabledContent:"手を挙げる操作が無効になっています",tooltipOnContent:"手を下げる",tooltipOffContent:"手を挙げる"},reactionButton:{label:"リアクションする",ariaLabel:"リアクションする",tooltipDisabledContent:"リアクション操作が無効になっています",tooltipContent:"リアクションを送信します",likeReactionTooltipContent:"いいね!",heartReactionTooltipContent:"大好き",laughReactionTooltipContent:"笑い",applauseReactionTooltipContent:"喝采",surprisedReactionTooltipContent:"驚いた"},realTimeText:{isTypingText:"RTT 入力"},captionsSettingsModal:{captionsSettingsModalTitle:"ライブ キャプションの設定",captionsSettingsSpokenLanguageDropdownLabel:"音声言語",captionsSettingsCaptionLanguageDropdownLabel:"ライブ キャプションの言語",captionsSettingsSpokenLanguageDropdownInfoText:"この通話の全員が話す言語。",captionsSettingsCaptionLanguageDropdownInfoText:"ライブ キャプションはこの言語で表示されます。",captionsSettingsConfirmButtonLabel:"確認する",captionsSettingsCancelButtonLabel:"キャンセル",captionsSettingsModalAriaLabel:"ライブ キャプション設定モーダル",captionsSettingsCloseModalButtonAriaLabel:"ライブ キャプション設定を閉じる"},spokenLanguages:{"ar-ae":"アラビア語 - U.A.E.","ar-sa":"アラビア語 - サウジアラビア","da-dk":"デンマーク語","de-de":"ドイツ語 - ドイツ","en-au":"英語 - オーストラリア","en-ca":"英語 - カナダ","en-gb":"英語 - イギリス","en-in":"英語 - インド","en-nz":"英語 - ニュージーランド","en-us":"英語 - 米国","es-es":"スペイン語 - スペイン (モダン)","es-mx":"スペイン語 - メキシコ","fi-fi":"フィンランド語","fr-ca":"フランス語 - カナダ","fr-fr":"フランス語 - フランス","hi-in":"ヒンディー語","it-it":"イタリア語 - イタリア","ja-jp":"日本語","ko-kr":"韓国語","nb-no":"ノルウェー語 (ブークモール)","nl-be":"オランダ語 - ベルギー","nl-nl":"オランダ語 - オランダ","pl-pl":"ポーランド語","pt-br":"ポルトガル語 - ブラジル","ru-ru":"ロシア語","sv-se":"スウェーデン語","zh-cn":"中国語 - 中国","zh-hk":"中国語 - 香港特別行政区","cs-cz":"チェコ語","pt-pt":"ポルトガル語 - ポルトガル","tr-tr":"トルコ語","vi-vn":"ベトナム語","th-th":"タイ語","he-il":"ヘブライ語","cy-gb":"ウェールズ語","uk-ua":"ウクライナ語","el-gr":"ギリシャ語","hu-hu":"ハンガリー語","ro-ro":"ルーマニア語","sk-sk":"スロバキア語","zh-tw":"中国語 - 台湾"},captionLanguages:{ar:"アラビア語",da:"デンマーク語",de:"ドイツ語",en:"英語",es:"スペイン語",fi:"フィンランド語","fr-ca":"フランス語 - カナダ",fr:"フランス語 - フランス",hi:"ヒンディー語",it:"イタリア語",ja:"日本語",ko:"韓国語",nb:"ノルウェー語 (ブークモール)",nl:"オランダ語",pl:"ポーランド語",pt:"ポルトガル語 - ブラジル",ru:"ロシア語",sv:"スウェーデン語","zh-Hans":"中国語 (簡体字)","zh-Hant":"中国語 (繁体字)",cs:"チェコ語","pt-pt":"ポルトガル語 - ポルトガル",tr:"トルコ語",vi:"ベトナム語",th:"タイ語",he:"ヘブライ語",cy:"ウェールズ語",uk:"ウクライナ語",el:"ギリシャ語",hu:"ハンガリー語",ro:"ルーマニア語",sk:"スロバキア語"},startCaptionsButton:{onLabel:"ライブ キャプションをオンにする",offLabel:"キャプションをオフにする",tooltipOnContent:"キャプションをオフにする",tooltipOffContent:"ライブ キャプションをオンにする"},startRealTimeTextButton:{label:"この呼び出しの RTT を有効にする",tooltipOffContent:"この呼び出しの RTT を有効にする"},messageThread:{yesterday:"昨日",sunday:"日曜日",monday:"月曜日",tuesday:"火曜日",wednesday:"水曜日",thursday:"木曜日",friday:"金曜日",saturday:"土曜日",participantJoined:"チャットに参加しました。",participantLeft:"チャットから退出しました。",editMessage:"編集",removeMessage:"削除",resendMessage:"もう一度送信",failToSendTag:"送信できませんでした",editedTag:"編集済み",liveAuthorIntro:"{author} からのメッセージ",editedMessageLiveAuthorIntro:"{author} さんからのメッセージを編集しました",editedMessageLocalUserLiveAuthorIntro:"メッセージを編集しました",messageContentAriaText:"{status} {author} さんが {message} と言いました",messageContentMineAriaText:"{status} あなたが {message} と言いました",editBoxTextLimit:"メッセージが{limitNumber}文字の制限を超えています",editBoxPlaceholderText:"メッセージを編集する",newMessagesIndicator:"新しいメッセージ",noDisplayNameSub:"名前がありません",editBoxCancelButton:"取り消し",editBoxSubmitButton:"完了",messageReadCount:"{remoteParticipantsCount} の {messageReadByCount} による読み取り",actionMenuMoreOptions:"その他のオプション",downloadAttachment:"ファイルをダウンロード",openAttachment:"ファイルを開く",blockedWarningText:"組織のポリシーにより、このメッセージは削除されました。",blockedWarningLinkText:"詳細",attachmentCardGroupMessage:"メッセージに添付ファイルが {attachmentCount} 個あります",messageDeletedAnnouncementAriaLabel:"メッセージが削除されます",richTextBoldTooltip:"太字",richTextItalicTooltip:"斜体",richTextUnderlineTooltip:"下線",richTextBulletListTooltip:"箇条書き",richTextNumberListTooltip:"番号付きリスト",richTextIncreaseIndentTooltip:"インデントを増やす",richTextDecreaseIndentTooltip:"インデントを減らす",richTextInsertTableTooltip:"表の挿入",richTextFormatButtonTooltip:"書式設定します",richTextInsertRowOrColumnMenu:"挿入",richTextInsertTableMenuTitle:"{column} x {row} の表を挿入する",richTextInsertRowAboveMenu:"上に挿入",richTextInsertRowBelowMenu:"下に挿入",richTextInsertColumnLeftMenu:"左に挿入",richTextInsertColumnRightMenu:"右に挿入",richTextDeleteRowOrColumnMenu:"削除",richTextDeleteColumnMenu:"列の削除",richTextDeleteRowMenu:"行の削除",richTextDeleteTableMenu:"テーブルの削除",richTextToolbarMoreButtonAriaLabel:"その他のオプション",attachmentUploadsPendingError:"ファイルをアップロードしています。お待ちください。",imageUploadsPendingError:"画像をアップロードしています。お待ちください。",richTextNewBulletedListItemAnnouncement:"行頭文字、改行",richTextNewNumberedListItemAnnouncement:"{0}、改行",richTextBulletedListAppliedAnnouncement:"箇条書きが適用されました",richTextNumberedListAppliedAnnouncement:"番号付きリストが適用されました"},errorBar:{unableToReachChatService:"オフラインです",accessDenied:"チャット サービスにアクセスできません- 指定されたユーザー資格情報をご確認ください",userNotInChatThread:"このチャット スレッドにはもう参加していません",sendMessageNotInChatThread:"このチャット スレッドに参加していないため、メッセージを送信できませんでした",sendMessageGeneric:"メッセージを送信できませんでした。",callingNetworkFailure:"通話の接続中に問題が発生しました。オフラインのようです。",startVideoGeneric:"ビデオを開始できませんでした",stopVideoGeneric:"ビデオを停止できませんでした",muteGeneric:"マイクをミュートできませんでした",unmuteGeneric:"マイクのミュートを解除できませんでした",speakingWhileMuted:"マイクがミュートになっています",startScreenShareGeneric:"画面共有の開始中に問題が発生しました。",stopScreenShareGeneric:"画面の共有を停止できませんでした",callNetworkQualityLow:"ネットワークの品質が低くなっています。",teamsMeetingCallNetworkQualityLow:"ネットワークの品質が低くなっています。",callNoSpeakerFound:"スピーカーまたはヘッドフォンが見つかりません。音声デバイスを接続して通話を聞きます。",callNoMicrophoneFound:"マイクが見つかりません。オーディオ入力デバイスを接続します。",callMicrophoneAccessDenied:"マイクにアクセスできません。アドレス バーのロックをクリックして、この Web ページにアクセス許可を付与します。",callMicrophoneAccessDeniedSafari:"マイクにアクセスできません。ページを更新してアクセス許可を可能にするか、このブラウザーの設定を確認し、この Web サイトのアクセス許可が有効になっていることを確認してください。",callMicrophoneMutedBySystem:"システムによってミュートになっています。",callMicrophoneUnmutedBySystem:"マイクが回復し、システムによってミュートが解除されました。",callMacOsMicrophoneAccessDenied:"マイクにアクセスできません。macOS のプライバシー設定でマイクへのアクセス許可を付与します。",callLocalVideoFreeze:"ネットワーク帯域幅が不十分です。通話中に他のユーザーのビデオが一時停止している可能性があります。",callCameraAccessDenied:"カメラにアクセスできません。アドレス バーのロックをクリックして、この Web ページにアクセス許可を付与します。",callCameraAccessDeniedSafari:"カメラにアクセスできません。ページを更新してアクセス許可を可能にするか、このブラウザーの設定を確認し、この Web サイトのアクセス許可が有効になっていることを確認してください。",callCameraAlreadyInUse:"カメラにアクセスできません。別のアプリケーションによって既に使用されている可能性があります。",callVideoStoppedBySystem:"ビデオはシステムによって停止されました。",callVideoRecoveredBySystem:"ビデオが再開されました。",callMacOsCameraAccessDenied:"MacOS がカメラへのアクセスをブロックしています。プライバシー設定を更新して、このブラウザーがカメラにアクセスできるようにします。",callMacOsScreenShareAccessDenied:"MacOS は画面の共有をブロックしています。プライバシー設定を更新して、このブラウザーで画面を録画できるようにします。",dismissButtonAriaLabel:"閉じる",failedToJoinCallGeneric:"通話に参加できませんでした",failedToJoinCallInvalidMeetingLink:"会議に参加できません。リンクが無効です。",cameraFrozenForRemoteParticipants:"通話のユーザーにビデオの表示で問題が発生しています。デバイスとネットワークを確認してください。",unableToStartVideoEffect:"ビデオ効果を適用できません。",startSpotlightWhileMaxParticipantsAreSpotlighted:"最大数の参加者に既にスポットライトが設定されているため、参加者にスポットライトを開始できません。",mutedByRemoteParticipant:"他の参加者によってミュートにされました。"},notificationStack:{callingNetworkFailure:{title:"通話の接続に問題があります",message:"オフラインのようです。ネットワーク接続を確認して、もう一度お試しください。",dismissButtonAriaLabel:"閉じる"},startVideoGeneric:{title:"ビデオを開始できませんでした。",dismissButtonAriaLabel:"閉じる"},stopVideoGeneric:{title:"ビデオを停止できませんでした。",dismissButtonAriaLabel:"閉じる"},muteGeneric:{title:"マイクをミュートできませんでした。",dismissButtonAriaLabel:"閉じる"},unmuteGeneric:{title:"マイクのミュートを解除できませんでした。",dismissButtonAriaLabel:"閉じる"},speakingWhileMuted:{title:"ミュートにしています。",dismissButtonAriaLabel:"閉じる"},startScreenShareGeneric:{title:"画面共有の開始中に問題が発生しました。",dismissButtonAriaLabel:"閉じる"},stopScreenShareGeneric:{title:"画面の共有を停止できませんでした。",dismissButtonAriaLabel:"閉じる"},callNetworkQualityLow:{title:"ネットワークの品質が低くなっています。",dismissButtonAriaLabel:"閉じる"},teamsMeetingCallNetworkQualityLow:{title:"ネットワークの品質が低くなっています。",dismissButtonAriaLabel:"閉じる",message:"サウンドを向上させるには、電話からこの通話に参加してください。このデバイスで引き続き会議を表示できます。",primaryButtonLabel:"電話で参加"},callNoSpeakerFound:{title:"スピーカーまたはヘッドフォンが見つかりません",message:"音声デバイスを接続して通話を聞いてください。",dismissButtonAriaLabel:"閉じる"},callNoMicrophoneFound:{title:"マイクが見つかりません",message:"オーディオ入力デバイスを接続します。",dismissButtonAriaLabel:"閉じる"},callMicrophoneAccessDenied:{title:"マイクにアクセスできません",message:"アドレス バーのロックをクリックして、この Web ページにアクセス許可を付与します。",dismissButtonAriaLabel:"閉じる"},callMicrophoneAccessDeniedSafari:{title:"マイクにアクセスできません",message:"ページを更新してアクセス許可を可能にするか、このブラウザーの設定を確認し、この Web サイトのアクセス許可が有効になっていることを確認してください。",dismissButtonAriaLabel:"閉じる"},callMicrophoneMutedBySystem:{title:"システムによってミュートになっています。",dismissButtonAriaLabel:"閉じる"},callMicrophoneUnmutedBySystem:{title:"マイクが回復し、システムによってミュートが解除されました。",dismissButtonAriaLabel:"閉じる"},callMacOsMicrophoneAccessDenied:{title:"マイクにアクセスできません",message:"macOS のプライバシー設定でマイクへのアクセス許可を付与します。",dismissButtonAriaLabel:"閉じる"},callLocalVideoFreeze:{title:"ネットワーク帯域幅が貧弱です",message:"通話中に他のユーザーのビデオが一時停止している可能性があります。",dismissButtonAriaLabel:"閉じる"},callCameraAccessDenied:{title:"カメラにアクセスできません",message:"アドレス バーのロックをクリックして、この Web ページにアクセス許可を付与します。",dismissButtonAriaLabel:"閉じる"},callCameraAccessDeniedSafari:{title:"カメラにアクセスできません",message:"ページを更新してアクセス許可を可能にするか、このブラウザーの設定を確認し、この Web サイトのアクセス許可が有効になっていることを確認してください。",dismissButtonAriaLabel:"閉じる"},callCameraAlreadyInUse:{title:"カメラにアクセスできません",message:"別のアプリケーションによって既に使用されている可能性があります。",dismissButtonAriaLabel:"閉じる"},callVideoStoppedBySystem:{title:"ビデオはシステムによって停止されました。",dismissButtonAriaLabel:"閉じる"},callVideoRecoveredBySystem:{title:"ビデオが再開されました。",dismissButtonAriaLabel:"閉じる"},callMacOsCameraAccessDenied:{title:"MacOS がカメラへのアクセスをブロックしています",message:"プライバシー設定を更新して、このブラウザーがカメラにアクセスできるようにします。",dismissButtonAriaLabel:"閉じる"},callMacOsScreenShareAccessDenied:{title:"MacOS で画面共有がブロックされています",message:"プライバシー設定を更新して、このブラウザーで画面を録画できるようにします。",dismissButtonAriaLabel:"閉じる"},failedToJoinCallGeneric:{title:"通話に参加できませんでした。",dismissButtonAriaLabel:"閉じる"},failedToJoinCallInvalidMeetingLink:{title:"会議に参加できません。リンクが無効です。",dismissButtonAriaLabel:"閉じる"},cameraFrozenForRemoteParticipants:{title:"通話中のユーザーにビデオの表示で問題が発生しています",message:"デバイスとネットワークをチェックしてください。",dismissButtonAriaLabel:"閉じる"},unableToStartVideoEffect:{title:"ビデオ効果を適用できません。",dismissButtonAriaLabel:"閉じる"},startSpotlightWhileMaxParticipantsAreSpotlighted:{title:"参加者にスポットライトを開始できません",message:"参加者の最大数は既にスポットライトが設定されています。",dismissButtonAriaLabel:"閉じる"},mutedByRemoteParticipant:{title:"他の参加者によってミュートにされました。",dismissButtonAriaLabel:"閉じる"},recordingStarted:{title:"レコーディングが開始しました。",message:"参加すると、この会議のトランスクリプトの作成に同意したことになります。",dismissButtonAriaLabel:"閉じる"},transcriptionStarted:{title:"文字起こしが開始しました。",message:"参加すると、この会議のトランスクリプトの作成に同意したことになります。",dismissButtonAriaLabel:"閉じる"},recordingStopped:{title:"レコーディングを保存しています。",message:"レコーディングが停止しました。",dismissButtonAriaLabel:"閉じる"},transcriptionStopped:{title:"文字起こしを保存しています。",message:"文字起こしが停止しました。",dismissButtonAriaLabel:"閉じる"},recordingAndTranscriptionStarted:{title:"レコーディングとトランスクリプトが開始されました。",message:"参加すると、この会議のトランスクリプトの作成に同意したことになります。",dismissButtonAriaLabel:"閉じる"},recordingAndTranscriptionStopped:{title:"レコーディングとトランスクリプトを保存されました。",message:"レコーディングとトランスクリプトを停止しました。",dismissButtonAriaLabel:"閉じる"},recordingStoppedStillTranscribing:{title:"レコーディングが停止しました。",message:"この会議のトランスクリプトを作成しています。",dismissButtonAriaLabel:"閉じる"},transcriptionStoppedStillRecording:{title:"文字起こしが停止しました。",message:"今はこの会議の録画のみを行っています。",dismissButtonAriaLabel:"閉じる"},assignedBreakoutRoomOpened:{title:"5 秒後に、割り当てられた会議室に移動します。",dismissButtonAriaLabel:"閉じる"},assignedBreakoutRoomChanged:{title:"ブレークアウト ルームが変更されました",message:"5 秒後に、割り当てられた会議室に移動します。",dismissButtonAriaLabel:"閉じる"},assignedBreakoutRoomClosed:{title:"ブレークアウト ルームが終了しました",message:"5 秒後に会議に戻ります。",dismissButtonAriaLabel:"閉じる"},assignedBreakoutRoomOpenedPromptJoin:{title:"ブレークアウト ルームに参加しますか?",message:"ブレークアウト ルームに割り当てられました。",dismissButtonAriaLabel:"閉じる",primaryButtonLabel:"ルームに参加",secondaryButtonLabel:"後で"},breakoutRoomJoined:{title:"ブレークアウト ルームに参加しました。",dismissButtonAriaLabel:"閉じる"},breakoutRoomClosingSoon:{title:"ルームの時間制限がもうすぐ切れます。",message:"このルームは 30 秒後に終了します",dismissButtonAriaLabel:"閉じる"},capabilityTurnVideoOnPresent:{title:"カメラが有効になっています",message:"ビデオを共有したい場合はオンにしてください。",dismissButtonAriaLabel:"閉じる"},capabilityTurnVideoOnAbsent:{title:"カメラが無効になっています",message:"ビデオを共有できなくなりました。",dismissButtonAriaLabel:"閉じる"},capabilityUnmuteMicPresent:{title:"マイクが有効になりました",message:"音声機能を使用する場合は、ミュートを解除します。",dismissButtonAriaLabel:"閉じる"},capabilityUnmuteMicAbsent:{title:"マイクが無効になっています",message:"ミュートを解除できなくなりました。",dismissButtonAriaLabel:"閉じる"},togetherModeStarted:{title:"Togethermode が開始しました",dismissButtonAriaLabel:"閉じる"},togetherModeEnded:{title:"Togethermode が終了しました",dismissButtonAriaLabel:"閉じる"}},videoGallery:{screenIsBeingSharedMessage:"画面を共有しています",screenShareLoadingMessage:"{participant} の画面を読み込んでいます",localScreenShareLoadingMessage:"画面を読み込んでいます",localVideoLabel:"自分",localVideoCameraSwitcherLabel:"カメラを切り替え",localVideoMovementLabel:"移動可能なローカル ビデオ タイル",localVideoMovementAriaLabel:"移動可能なローカル ビデオ タイル",localVideoSelectedDescription:"{cameraName} が選択されました。",displayNamePlaceholder:"名前のない参加者",fitRemoteParticipantToFrame:"フレームに収める",fillRemoteParticipantFrame:"トリミングする",pinParticipantForMe:"自分用にピン留め",pinParticipantForMeLimitReached:"ピン留め (上限に達しました)",unpinParticipantForMe:"ピンを外す",pinParticipantMenuItemAriaLabel:"{participantName} さんをピン留めする",unpinParticipantMenuItemAriaLabel:"{participantName} さんのピンを外す",pinnedParticipantAnnouncementAriaLabel:"{participantName} さんをピン留めしました",unpinnedParticipantAnnouncementAriaLabel:"{participantName} さんのピンを外しました",startSpotlightVideoTileMenuLabel:"全員にスポットライトを設定",addSpotlightVideoTileMenuLabel:"スポットライトを追加",spotlightLimitReachedMenuTitle:"スポットライトの上限に達しました",stopSpotlightVideoTileMenuLabel:"スポットライトの設定を解除",stopSpotlightOnSelfVideoTileMenuLabel:"スポットライトを終了",attendeeRole:"出席者",muteParticipantMenuItemLabel:"ミュート",waitingScreenText:"他のユーザーの参加を待っています",forbidAudio:"マイクを無効にする",permitAudio:"マイクを許可する",forbidAudioTileMenuLabel:"マイクを無効にする",permitAudioTileMenuLabel:"マイクを許可する",forbidVideo:"カメラを無効にする",permitVideo:"カメラを許可する",forbidVideoTileMenuLabel:"カメラを無効にする",permitVideoTileMenuLabel:"カメラを許可する"},dialpad:{placeholderText:"電話番号を入力してください",deleteButtonAriaLabel:"削除"},holdButton:{onLabel:"再開",offLabel:"保留",tooltipOnContent:"通話の再開",tooltipOffContent:"通話の保留"},videoTile:{participantStateRinging:"呼び出し中...",participantReconnecting:"再接続中...",participantStateHold:"保留中",moreOptionsButtonAriaLabel:"その他のオプションの {displayName} {isMuted} {micDisabledState} {cameraDisabledState} {isHandRaised} {state} {isSpeaking}",moreOptionsParticipantMutedStateMutedAriaLabel:"ミュート中",moreOptionsParticipantMutedStateUnmutedAriaLabel:"ミュート解除",moreOptionsParticipantHandRaisedAriaLabel:"挙手しました",moreOptionsParticipantIsSpeakingAriaLabel:"話し中",moreOptionsParticipantMicDisabledAriaLabel:"マイクが無効になっています",moreOptionsParticipantCameraDisabledAriaLabel:"カメラが無効になっています"},CameraAndMicrophoneSitePermissionsRequest:{primaryText:"{appName}にカメラとマイクの使用を許可する",secondaryText:"これは、参加者があなたのことを見たり聞いたりできるようにするものです。",linkText:"ヘルプが必要ですか? トラブルシューティングのヘルプを表示",primaryButtonText:"カメラとマイクなしで続行する",ariaLabel:"カメラとマイクへのアクセスが許可する"},CameraSitePermissionsRequest:{primaryText:"{appName} にカメラの使用を許可する",secondaryText:"これは、参加者に表示されるようにするためです。",linkText:"ヘルプが必要ですか? トラブルシューティングのヘルプを表示",primaryButtonText:"カメラなしで続行",ariaLabel:"カメラへのアクセスを許可"},MicrophoneSitePermissionsRequest:{primaryText:"{appName} にマイクの使用を許可する",secondaryText:"これは、参加者に聞こえるようにするためです。",linkText:"ヘルプが必要ですか? トラブルシューティングのヘルプを表示",primaryButtonText:"マイクなしで続行",ariaLabel:"マイクへのアクセスを許可する"},CameraAndMicrophoneSitePermissionsCheck:{primaryText:"カメラとマイクへのアクセスを確認しています",secondaryText:"プロンプトが表示されたら、アクセスを許可します。これは、参加者があなたを見たり聞いたりできるようにするためです。",linkText:"ヘルプが必要ですか? トラブルシューティングのヘルプを表示",primaryButtonText:"カメラとマイクなしで続行する",ariaLabel:"カメラとマイクへのアクセスを確認しています。プロンプトが表示されたら、アクセスを許可します。"},CameraSitePermissionsCheck:{primaryText:"カメラへのアクセスを確認しています",secondaryText:"プロンプトが表示されたら、アクセスを許可します。これは、参加者があなたを見ることができるようにするためです。",linkText:"ヘルプが必要ですか? トラブルシューティングのヘルプを表示",primaryButtonText:"カメラなしで続行する",ariaLabel:"カメラへのアクセスを確認しています。プロンプトが表示されたら、アクセスを許可します。"},MicrophoneSitePermissionsCheck:{primaryText:"マイクへのアクセスを確認しています",secondaryText:"プロンプトが表示されたら、アクセスを許可します。これは、参加者があなたの声を聞くことができるようにするためです。",linkText:"ヘルプが必要ですか? トラブルシューティングのヘルプを表示",primaryButtonText:"マイクなしで続行する",ariaLabel:"マイクへのアクセスを確認しています。プロンプトが表示されたら、アクセスを許可します。"},CameraAndMicrophoneSitePermissionsDenied:{primaryText:"カメラとマイクにアクセスできません",secondaryText:"アドレス バーのロック アイコンをクリックして、この Web ページにマイクのアクセス許可を付与します。ページの更新が必要な可能性があります。",primaryButtonText:"カメラとマイクなしで続行",linkText:"ヘルプが必要ですか? トラブルシューティングのヘルプを表示"},CameraAndMicrophoneSitePermissionsDeniedSafari:{primaryText:"カメラとマイクにアクセスできません",secondaryText:"ページを更新してアクセス許可を可能にするか、このブラウザーの設定を確認し、この Web サイトのアクセス許可が有効になっていることを確認してください。",primaryButtonText:"カメラとマイクなしで続行",linkText:"ヘルプが必要ですか? トラブルシューティングのヘルプを表示"},CameraSitePermissionsDenied:{primaryText:"カメラにアクセスできません",secondaryText:"アドレス バーのロック アイコンをクリックして、この Web ページにカメラのアクセス許可を付与します。ページの更新が必要な可能性があります。",primaryButtonText:"カメラなしで続行",linkText:"ヘルプが必要ですか? トラブルシューティングのヘルプを表示"},MicrophoneSitePermissionsDenied:{primaryText:"マイクにアクセスできません",secondaryText:"アドレス バーのロック アイコンをクリックして、この Web ページにマイクのアクセス許可を付与します。ページの更新が必要な可能性があります。",primaryButtonText:"マイクなしで続行する",linkText:"ヘルプが必要ですか? トラブルシューティングのヘルプを表示"},CameraSitePermissionsDeniedSafari:{primaryText:"カメラにアクセスできません",secondaryText:"ページを更新してアクセス許可を可能にするか、このブラウザーの設定を確認し、この Web サイトのアクセス許可が有効になっていることを確認してください。",primaryButtonText:"カメラなしで続行する",linkText:"ヘルプが必要ですか? トラブルシューティングのヘルプを表示"},MicrophoneSitePermissionsDeniedSafari:{primaryText:"マイクにアクセスできません",secondaryText:"ページを更新してアクセス許可を可能にするか、このブラウザーの設定を確認し、この Web サイトのアクセス許可が有効になっていることを確認してください。",primaryButtonText:"マイクなしで続行",linkText:"ヘルプが必要ですか? トラブルシューティングのヘルプを表示"},UnsupportedBrowser:{primaryText:"サポートされていないブラウザーです",secondaryText:"互換性のあるブラウザーを使用して、この通話に参加してください。",moreHelpLinkText:"互換性要件を確認する"},UnsupportedBrowserVersion:{primaryText:"ブラウザーの更新が必要です",secondaryText:"可能な限り最善の通話を行うために、ブラウザーを更新してから、もう一度通話に参加してみてください。",moreHelpLinkText:"互換性要件を確認する",continueAnywayButtonText:"更新せずに通話を開始する"},UnsupportedOperatingSystem:{primaryText:"オペレーティング システムがサポートされていません",secondaryText:"互換性のあるオペレーティング システムのデバイスを使用して、この通話に参加してください。",moreHelpLinkText:"互換性要件を確認する"},BrowserPermissionDenied:{primaryText:"カメラまたはマイクを使用できません",secondaryText:"お使いのブラウザーはカメラまたはマイクにアクセスできない可能性があります。この問題を解決するには、[システム環境設定] を開きます。",primaryButtonText:"再試行",linkText:"ヘルプが必要ですか? トラブルシューティングのヘルプを表示"},BrowserPermissionDeniedIOS:{primaryText:"マイクへのアクセスを許可して続行する",secondaryText:"そのため、他の参加者はあなたの声を聞くことができます。",primaryButtonText:"再試行",imageAltText:"iOS のマイクとカメラ デバイスのアクセス許可の場所",linkText:"ヘルプが必要ですか? トラブルシューティングのヘルプを表示",step1Text:"設定アプリに移動します。",step2Text:"このブラウザーの設定まで下にスクロール",step3Text:"マイクをオンにする (カメラはオプション)",step4Text:"もう一度通話に参加してみてください",step1DigitText:"1",step2DigitText:"2",step3DigitText:"3",step4DigitText:"4"},verticalGallery:{leftNavButtonAriaLabel:"前のページ {current}/{total}",rightNavButtonAriaLabel:"次のページ {current}/{total}"},meetingConferencePhoneInfo:{meetingConferencePhoneInfoModalTitle:"電話から通話に参加",meetingConferencePhoneInfoModalDialIn:"ダイヤル番号",meetingConferencePhoneInfoModalMeetingId:"会議 ID の入力",meetingConferencePhoneInfoModalWait:"開催者に許可されるのを待つ",meetingConferencePhoneInfoModalNoPhoneAvailable:"利用可能な電話がありません",meetingConferencePhoneInfoModalTollGeoData:"{country}、{city}",meetingConferencePhoneInfoModalTollFree:"(無料電話番号)",meetingConferencePhoneInfoModalToll:"(有料電話番号)"},IncomingCallNotification:{incomingCallNotificationPlaceholderId:"不明なユーザー",incomingCallNotificationPlaceholderAlert:"{callerName} が呼び出しています",incomingCallNoticicationAcceptWithAudioAriaLabel:"オーディオで承諾する",incomingCallNoticicationAcceptWithVideoAriaLabel:"ビデオで承諾する",incomingCallNoticicationRejectAriaLabel:"拒否する",incomingCallNotificationAcceptButtonLabel:"承諾",incomingCallNotificationRejectButtonLabel:"拒否",incomingCallNotificationAccceptWithVideoButtonLabel:"ビデオで受ける",incomingCallNotificationDismissButtonAriaLabel:"閉じる"}})},vQt={strings:Jh({participantItem:{isMeText:"(나)",menuTitle:"추가 옵션",removeButtonLabel:"제거",sharingIconLabel:"공유 중",mutedIconLabel:"음소거됨",handRaisedIconLabel:"손들기 - 위치 {position}",displayNamePlaceholder:"명명되지 않은 참가자",participantStateRinging:"전화 거는 중...",participantStateHold:"대기 중",participantItemAriaLabel:"{displayName}, {handRaisedState}, {mutedState}, {micDisabledState}, {cameraDisabledState}, {sharingState}, {connectionState}",participantItemWithMoreOptionsAriaLabel:"{displayName}, {handRaisedState}, {mutedState}, {micDisabledState}, {cameraDisabledState}, {sharingState}, {connectionState}, 기타 옵션",attendeeRole:"참석자",micDisabledIconLabel:"마이크를 사용할 수 없음",cameraDisabledIconLabel:"카메라 사용 안 함"},ParticipantList:{overflowParticipantCount:"+{overflowCount}개 더 보기"},typingIndicator:{singleUser:"{user} 님이 입력 중...",multipleUsers:"{users} 님이 입력하는 중...",multipleUsersAbbreviateOne:"{users} 님 외 1명이 입력 중...",multipleUsersAbbreviateMany:"{users} 님 외 {numOthers} 님이 입력하는 중...",delimiter:"닫는 렌즈형 흰색 괄호"},sendBox:{placeholderText:"메시지를 입력하세요",textTooLong:"메시지 길이가 최대 제한을 초과했습니다.",sendButtonAriaLabel:"메시지 보내기",attachmentUploadsPendingError:"파일을 업로드하는 중입니다. 잠시만 기다려 주세요.",removeAttachment:"파일 제거",uploading:"업로드 중",uploadCompleted:"업로드 완료",attachmentMoreMenu:"옵션 더 보기"},richTextSendBox:{placeholderText:"메시지 입력",textTooLong:"메시지 길이가 최대 제한을 초과했습니다.",sendButtonAriaLabel:"메시지 보내기",attachmentUploadsPendingError:"파일을 업로드하는 중입니다. 잠시만 기다려 주세요.",imageUploadsPendingError:"이미지를 업로드하는 중입니다. 잠시만 기다려 주세요.",removeAttachment:"파일 제거",uploading:"업로드 중",uploadCompleted:"업로드 완료",richTextBoldTooltip:"굵게",richTextItalicTooltip:"기울임꼴",richTextUnderlineTooltip:"밑줄",richTextBulletListTooltip:"글머리 기호 목록",richTextNumberListTooltip:"번호 매기기 목록",richTextIncreaseIndentTooltip:"들여쓰기",richTextDecreaseIndentTooltip:"내어쓰기",richTextInsertTableTooltip:"표 삽입",richTextFormatButtonTooltip:"형식",richTextInsertRowOrColumnMenu:"삽입",richTextInsertTableMenuTitle:"{column} x {row} 표 삽입",richTextInsertRowAboveMenu:"위에 삽입",richTextInsertRowBelowMenu:"아래에 삽입",richTextInsertColumnLeftMenu:"왼쪽에 삽입",richTextInsertColumnRightMenu:"오른쪽에 삽입",richTextDeleteRowOrColumnMenu:"삭제",richTextDeleteColumnMenu:"열 삭제",richTextDeleteRowMenu:"행 삭제",richTextDeleteTableMenu:"표 삭제",richTextToolbarAriaLabel:"메시지 서식 도구 모음",richTextToolbarMoreButtonAriaLabel:"옵션 더 보기",attachmentMoreMenu:"옵션 더 보기",richTextNewBulletedListItemAnnouncement:"글머리 기호, 새 줄",richTextNewNumberedListItemAnnouncement:"{0}, 새 줄",richTextBulletedListAppliedAnnouncement:"글머리 기호 목록 적용됨",richTextNumberedListAppliedAnnouncement:"번호 매기기 목록 적용됨"},realTimeTextModal:{realTimeTextModalAriaLabel:"실시간 입력 모달 활성화",realTimeTextModalTitle:"실시간 입력을 활성화하시겠습니까?",realTimeTextModalText:"모임의 모든 사용자에 대해 RTT(실시간 텍스트)가 켜집니다.",realTimeTextConfirmButtonLabel:"활성화",realTimeTextCancelButtonLabel:"취소",realTimeTextCloseModalButtonAriaLabel:"실시간 입력 모달 닫기"},captionsBanner:{captionsBannerSpinnerText:"캡션 시작 중...",realTimeTextInputBoxDefaultText:"실시간으로 메시지 입력",realTimeTextInputErrorMessage:"메시지는 2000자를 초과할 수 없음",realTimeTextBannerTitle:"실시간 입력",realTimeTextBannerContent:"전체 모임 기간 동안 모든 참가자에 대해 RTT(실시간 텍스트)를 사용할 수 있습니다.",realTimeTextBannerLinkLabel:"자세히 알아보기",captionsOnlyContainerTitle:"캡션",realTimeTextOnlyContainerTitle:"실시간 텍스트",captionsAndRealTimeTextContainerTitle:"캡션 및 실시간 텍스트",expandButtonAriaLabel:"펼치기",minimizeButtonAriaLabel:"접기"},mentionPopover:{mentionPopoverHeader:"제안"},imageOverlay:{downloadButtonLabel:"다운로드",dismissButtonAriaLabel:"닫기",overlayVisibleMessage:"이미지 세부 정보 오버레이"},messageStatusIndicator:{deliveredAriaLabel:"메시지를 보냄",deliveredTooltipText:"보냄",seenAriaLabel:"다른 사용자가 본 메시지",seenTooltipText:"표시됨",readByTooltipText:"{messageThreadReadCount}/{remoteParticipantsCount}명이 읽음",sendingAriaLabel:"메시지를 보내는 중",sendingTooltipText:"보내는 중",failedToSendAriaLabel:"메시지를 보내지 못함",failedToSendTooltipText:"보내기 실패"},endCallButton:{label:"휴가",tooltipContent:"통화에서 나가기",leaveOption:"나가기",endCallOption:"모든 사람의 통화 종료"},cameraButton:{onLabel:"카메라",offLabel:"카메라",tooltipDisabledContent:"카메라가 비활성화되었습니다",tooltipOnContent:"카메라 끄기",tooltipOffContent:"카메라 켜기",tooltipVideoLoadingContent:"비디오를 로드하는 중입니다.",cameraMenuTitle:"카메라",cameraMenuTooltip:"카메라 선택",cameraButtonSplitRoleDescription:"분할 단추",onSplitButtonAriaLabel:"카메라 끄기",offSplitButtonAriaLabel:"카메라 켜기",cameraActionTurnedOnAnnouncement:"카메라가 켜져 있습니다.",cameraActionTurnedOffAnnouncement:"카메라가 꺼져 있습니다.",onSplitButtonPrimaryActionCamera:"카메라 끄기",offSplitButtonPrimaryActionCamera:"카메라 켜기",cameraPrimaryActionSplitButtonTitle:"카메라 사용",videoEffectsMenuItemTitle:"효과",cameraButtonAriaDescription:"카메라 옵션"},microphoneButton:{onLabel:"마이크",offLabel:"마이크",tooltipDisabledContent:"마이크가 비활성화되었습니다",tooltipOnContent:"마이크 음소거",tooltipOffContent:"마이크 음소거 해제",microphoneMenuTitle:"마이크",microphoneMenuTooltip:"마이크 선택",speakerMenuTitle:"발언자",speakerMenuTooltip:"스피커 선택",microphoneButtonSplitRoleDescription:"분할 단추",onSplitButtonAriaLabel:"마이크 음소거",offSplitButtonAriaLabel:"마이크 음소거 해제",microphoneActionTurnedOnAnnouncement:"마이크가 켜져 있습니다.",microphoneActionTurnedOffAnnouncement:"마이크가 꺼져 있습니다.",offSplitButtonMicrophonePrimaryAction:"마이크 음소거 해제",onSplitButtonMicrophonePrimaryAction:"마이크 음소거",microphonePrimaryActionSplitButtonTitle:"마이크 사용",microphoneAriaDescription:"오디오 옵션",deepNoiseSuppressionTitle:"노이즈 억제",deepNoiseSuppressionOnAnnouncement:"심층 노이즈 억제가 켜졌습니다.",deepNoiseSuppressionOffAnnouncement:"심층 노이즈 억제가 꺼졌습니다."},devicesButton:{label:"장치",tooltipContent:"장치 관리",cameraMenuTitle:"카메라",cameraMenuTooltip:"카메라 선택",audioDeviceMenuTitle:"오디오 장치",audioDeviceMenuTooltip:"오디오 장치 선택",microphoneMenuTitle:"마이크",microphoneMenuTooltip:"마이크 선택",speakerMenuTitle:"발언자",speakerMenuTooltip:"스피커 선택"},participantsButton:{label:"사용자",ariaLabel:"사용자",tooltipContent:"참가자 표시",menuHeader:"이 통화에서",participantsListButtonLabel:"{numParticipants}명",muteAllButtonLabel:"모두 음소거",copyInviteLinkButtonLabel:"초대 링크 복사",copyInviteLinkActionedAriaLabel:"초대 링크를 복사함"},screenShareButton:{onLabel:"프레젠테이션 중지",offLabel:"프레젠테이션",tooltipDisabledContent:"프레젠테이션 사용 안 함",tooltipOnContent:"화면을 프레젠테이션하는 중",tooltipOffContent:"화면 프레젠테이션"},raiseHandButton:{offLabel:"손 들기",onLabel:"낮추기",tooltipDisabledContent:"손 올리기 작업이 비활성화되었습니다.",tooltipOnContent:"손 내리기",tooltipOffContent:"손 들기"},reactionButton:{label:"반응",ariaLabel:"반응",tooltipDisabledContent:"반응 동작을 사용할 수 없습니다.",tooltipContent:"반응 보내기",likeReactionTooltipContent:"좋아요",heartReactionTooltipContent:"사랑",laughReactionTooltipContent:"크게 웃는 표정",applauseReactionTooltipContent:"박수",surprisedReactionTooltipContent:"놀란 표정"},realTimeText:{isTypingText:"실시간 입력 입력 중"},captionsSettingsModal:{captionsSettingsModalTitle:"캡션 설정",captionsSettingsSpokenLanguageDropdownLabel:"음성 언어",captionsSettingsCaptionLanguageDropdownLabel:"캡션 언어",captionsSettingsSpokenLanguageDropdownInfoText:"이 통화의 모든 사람이 말하는 언어입니다.",captionsSettingsCaptionLanguageDropdownInfoText:"캡션이 이 언어로 표시됩니다.",captionsSettingsConfirmButtonLabel:"확인",captionsSettingsCancelButtonLabel:"취소",captionsSettingsModalAriaLabel:"캡션 설정 모달",captionsSettingsCloseModalButtonAriaLabel:"캡션 설정 닫기"},spokenLanguages:{"ar-ae":"아랍어 - 아랍에미리트","ar-sa":"아라비아어 - 사우디 아라비아","da-dk":"덴마크어","de-de":"독일어 - 독일","en-au":"영어 - 오스트레일리아","en-ca":"영어 - 캐나다","en-gb":"영어 - 영국","en-in":"영어 - 인도","en-nz":"영어 - 뉴질랜드","en-us":"영어 - 미국","es-es":"스페인어 - 스페인(현대 정렬)","es-mx":"스페인어 - 멕시코","fi-fi":"핀란드어","fr-ca":"프랑스어 - 캐나다","fr-fr":"프랑스어 - 프랑스","hi-in":"힌디어","it-it":"이탈리아어 - 이탈리아","ja-jp":"일본어","ko-kr":"한국어","nb-no":"노르웨이어(보크몰)","nl-be":"네덜란드어 - 벨기에","nl-nl":"네덜란드어 - 네덜란드","pl-pl":"폴란드어","pt-br":"포르투갈어 - 브라질","ru-ru":"러시아어","sv-se":"스웨덴어","zh-cn":"중국어 - 중국","zh-hk":"중국어 - 홍콩 특별 행정구","cs-cz":"체코어","pt-pt":"포르투갈어 - 포르투갈","tr-tr":"터키어","vi-vn":"베트남어","th-th":"태국어","he-il":"히브리어","cy-gb":"웨일스어","uk-ua":"우크라이나어","el-gr":"그리스어","hu-hu":"헝가리어","ro-ro":"루마니아어","sk-sk":"슬로바키아어","zh-tw":"중국어 - 대만"},captionLanguages:{ar:"아랍어",da:"덴마크어",de:"독일어",en:"영어",es:"스페인어",fi:"핀란드어","fr-ca":"프랑스어 - 캐나다",fr:"프랑스어 - 프랑스",hi:"힌디어",it:"이탈리아어",ja:"일본어",ko:"한국어",nb:"노르웨이어(보크몰)",nl:"네덜란드어",pl:"폴란드어",pt:"포르투갈어 - 브라질",ru:"러시아어",sv:"스웨덴어","zh-Hans":"중국어(간체)","zh-Hant":"중국어(번체)",cs:"체코어","pt-pt":"포르투갈어 - 포르투갈",tr:"터키어",vi:"베트남어",th:"태국어",he:"히브리어",cy:"웨일스어",uk:"우크라이나어",el:"그리스어",hu:"헝가리어",ro:"루마니아어",sk:"슬로바키아어"},startCaptionsButton:{onLabel:"캡션 켜기",offLabel:"캡션 끄기",tooltipOnContent:"캡션 끄기",tooltipOffContent:"캡션 켜기"},startRealTimeTextButton:{label:"이 통화에 대한 RTT 켜기",tooltipOffContent:"이 통화에 대한 RTT 켜기"},messageThread:{yesterday:"어제",sunday:"일요일",monday:"월요일",tuesday:"화요일",wednesday:"수요일",thursday:"목요일",friday:"금요일",saturday:"토요일",participantJoined:"채팅에 참여했습니다.",participantLeft:"이 채팅을 나갔습니다.",editMessage:"편집",removeMessage:"삭제",resendMessage:"전송 다시 시도",failToSendTag:"보내기 실패",editedTag:"편집됨",liveAuthorIntro:"{author}의 메시지",editedMessageLiveAuthorIntro:"{author}의 편집한 메시지",editedMessageLocalUserLiveAuthorIntro:"편집한 메시지",messageContentAriaText:"{status} {author} 님의 메시지: {message}",messageContentMineAriaText:"{status} 내 메시지: {message}",editBoxTextLimit:"메시지가 {limitNumber} 문자 제한을 초과했습니다.",editBoxPlaceholderText:"메시지 편집",newMessagesIndicator:"새 메시지",noDisplayNameSub:"이름 없음",editBoxCancelButton:"취소",editBoxSubmitButton:"완료",messageReadCount:"{messageReadByCount}/{remoteParticipantsCount}명이 읽음",actionMenuMoreOptions:"추가 옵션",downloadAttachment:"파일 다운로드",openAttachment:"파일 열기",blockedWarningText:"조직 정책으로 인해 이 메시지가 삭제되었습니다.",blockedWarningLinkText:"세부 정보",attachmentCardGroupMessage:"메시지에 {attachmentCount}개의 첨부 파일이 있습니다.",messageDeletedAnnouncementAriaLabel:"메시지가 삭제되었습니다.",richTextBoldTooltip:"굵게",richTextItalicTooltip:"기울임꼴",richTextUnderlineTooltip:"밑줄",richTextBulletListTooltip:"글머리 기호 목록",richTextNumberListTooltip:"번호 매기기 목록",richTextIncreaseIndentTooltip:"들여쓰기",richTextDecreaseIndentTooltip:"내어쓰기",richTextInsertTableTooltip:"표 삽입",richTextFormatButtonTooltip:"형식",richTextInsertRowOrColumnMenu:"삽입",richTextInsertTableMenuTitle:"{column} x {row} 표 삽입",richTextInsertRowAboveMenu:"위에 삽입",richTextInsertRowBelowMenu:"아래에 삽입",richTextInsertColumnLeftMenu:"왼쪽에 삽입",richTextInsertColumnRightMenu:"오른쪽에 삽입",richTextDeleteRowOrColumnMenu:"삭제",richTextDeleteColumnMenu:"열 삭제",richTextDeleteRowMenu:"행 삭제",richTextDeleteTableMenu:"표 삭제",richTextToolbarMoreButtonAriaLabel:"옵션 더 보기",attachmentUploadsPendingError:"파일을 업로드하는 중입니다. 잠시만 기다려 주세요.",imageUploadsPendingError:"이미지를 업로드하는 중입니다. 잠시만 기다려 주세요.",richTextNewBulletedListItemAnnouncement:"글머리 기호, 새 줄",richTextNewNumberedListItemAnnouncement:"{0}, 새 줄",richTextBulletedListAppliedAnnouncement:"글머리 기호 목록 적용됨",richTextNumberedListAppliedAnnouncement:"번호 매기기 목록 적용됨"},errorBar:{unableToReachChatService:"오프라인 상태입니다.",accessDenied:"채팅 서비스에 액세스할 수 없습니다. 제공된 사용자 자격 증명을 확인하세요.",userNotInChatThread:"이 채팅 스레드에 더 이상 없습니다.",sendMessageNotInChatThread:"이 채팅 스레드에 더 이상 존재하지 않으므로 메시지를 보내지 못했습니다.",sendMessageGeneric:"메시지를 보내지 못했습니다",callingNetworkFailure:"통화 연결 중 - 오프라인 상태인 것 같습니다.",startVideoGeneric:"비디오를 시작하지 못함",stopVideoGeneric:"비디오를 중지하지 못함",muteGeneric:"마이크를 음소거하지 못함",unmuteGeneric:"마이크 음소거를 해제하지 못함",speakingWhileMuted:"마이크가 음소거됨",startScreenShareGeneric:"화면 공유를 시작하는 동안 문제가 발생했습니다.",stopScreenShareGeneric:"화면 공유를 중지하지 못함",callNetworkQualityLow:"네트워크 품질이 낮습니다.",teamsMeetingCallNetworkQualityLow:"네트워크 품질이 낮습니다.",callNoSpeakerFound:"스피커 또는 헤드폰을 찾을 수 없습니다. 오디오 장치를 연결하여 통화를 들을 수 있습니다.",callNoMicrophoneFound:"마이크를 찾을 수 없습니다. 오디오 입력 장치를 연결합니다.",callMicrophoneAccessDenied:"마이크에 액세스할 수 없습니다. 주소 표시줄에서 잠금을 클릭하여 이 웹 페이지에 권한을 부여합니다.",callMicrophoneAccessDeniedSafari:"마이크에 액세스할 수 없습니다. 사용 권한을 허용하려면 페이지를 새로 고치거나 이 브라우저의 설정을 확인하고 이 웹 사이트에 사용 권한이 설정되어 있는지 확인하세요.",callMicrophoneMutedBySystem:"시스템에 의해 음소거되었습니다.",callMicrophoneUnmutedBySystem:"마이크가 복구되었으며 시스템에서 음소거를 해제했습니다.",callMacOsMicrophoneAccessDenied:"마이크에 액세스할 수 없습니다. macOS 개인 정보 설정에서 마이크 권한을 부여합니다.",callLocalVideoFreeze:"네트워크 대역폭이 불량합니다. 통화 중에 다른 사람에 대해 비디오가 일시 중지된 것 같습니다.",callCameraAccessDenied:"카메라에 액세스할 수 없습니다. 주소 표시줄에서 잠금을 클릭하여 이 웹 페이지에 권한을 부여합니다.",callCameraAccessDeniedSafari:"카메라에 액세스할 수 없습니다. 사용 권한을 허용하려면 페이지를 새로 고치거나 이 브라우저의 설정을 확인하고 이 웹 사이트에 사용 권한이 설정되어 있는지 확인하세요.",callCameraAlreadyInUse:"카메라에 액세스할 수 없습니다. 다른 응용 프로그램에서 이미 사용 중일 수 있습니다.",callVideoStoppedBySystem:"시스템에 의해 비디오가 중지되었습니다.",callVideoRecoveredBySystem:"비디오가 다시 시작되었습니다.",callMacOsCameraAccessDenied:"MacOS에서 카메라에 대한 액세스를 차단하고 있습니다. 이 브라우저에서 카메라에 액세스할 수 있도록 개인 정보 설정을 업데이트합니다.",callMacOsScreenShareAccessDenied:"MacOS에서 화면 공유를 차단하고 있습니다. 이 브라우저에서 화면을 녹화할 수 있도록 개인 정보 설정을 업데이트합니다.",dismissButtonAriaLabel:"닫기",failedToJoinCallGeneric:"통화에 참가하지 못했습니다.",failedToJoinCallInvalidMeetingLink:"모임에 참가할 수 없습니다. 잘못된 링크입니다.",cameraFrozenForRemoteParticipants:"통화 중인 사용자에게 영상이 표시되는 데 문제가 있습니다. 장치와 네트워크를 확인하세요.",unableToStartVideoEffect:"비디오 효과를 적용할 수 없습니다.",startSpotlightWhileMaxParticipantsAreSpotlighted:"최대 참가자 수가 이미 스포트라이트되었으므로 참가자에서 스포트라이트를 시작할 수 없습니다.",mutedByRemoteParticipant:"다른 참가자가 나를 음소거했습니다."},notificationStack:{callingNetworkFailure:{title:"통화 연결 문제 발생",message:"오프라인 상태인 것 같습니다. 네트워크 연결을 확인하고 다시 시도하세요.",dismissButtonAriaLabel:"닫기"},startVideoGeneric:{title:"비디오를 시작하지 못했습니다.",dismissButtonAriaLabel:"닫기"},stopVideoGeneric:{title:"비디오를 중지하지 못했습니다.",dismissButtonAriaLabel:"닫기"},muteGeneric:{title:"마이크를 음소거하지 못했습니다.",dismissButtonAriaLabel:"닫기"},unmuteGeneric:{title:"마이크의 음소거를 해제하지 못했습니다.",dismissButtonAriaLabel:"닫기"},speakingWhileMuted:{title:"음소거했습니다.",dismissButtonAriaLabel:"닫기"},startScreenShareGeneric:{title:"화면 공유를 시작하는 동안 문제가 발생했습니다.",dismissButtonAriaLabel:"닫기"},stopScreenShareGeneric:{title:"화면 공유를 중지하지 못했습니다.",dismissButtonAriaLabel:"닫기"},callNetworkQualityLow:{title:"네트워크 품질이 낮습니다.",dismissButtonAriaLabel:"닫기"},teamsMeetingCallNetworkQualityLow:{title:"네트워크 품질이 낮습니다.",dismissButtonAriaLabel:"닫기",message:"더 나은 사운드를 위해 휴대폰에서 이 통화에 참여하세요. 이 장치에서 모임을 계속 볼 수 있습니다.",primaryButtonLabel:"전화로 참가"},callNoSpeakerFound:{title:"스피커 또는 헤드폰을 찾을 수 없음",message:"오디오 장치를 연결하여 통화를 들을 수 있습니다.",dismissButtonAriaLabel:"닫기"},callNoMicrophoneFound:{title:"마이크를 찾을 수 없습니다.",message:"오디오 입력 장치를 연결합니다.",dismissButtonAriaLabel:"닫기"},callMicrophoneAccessDenied:{title:"마이크에 액세스할 수 없음",message:"주소 표시줄에서 잠금을 클릭하여 이 웹 페이지에 권한을 부여합니다.",dismissButtonAriaLabel:"닫기"},callMicrophoneAccessDeniedSafari:{title:"마이크에 액세스할 수 없음",message:"사용 권한을 허용하려면 페이지를 새로 고치거나 이 브라우저의 설정을 확인하고 이 웹 사이트에 사용 권한이 설정되어 있는지 확인하세요.",dismissButtonAriaLabel:"닫기"},callMicrophoneMutedBySystem:{title:"시스템에 의해 음소거되었습니다.",dismissButtonAriaLabel:"닫기"},callMicrophoneUnmutedBySystem:{title:"마이크가 복구되었으며 시스템에서 음소거를 해제했습니다.",dismissButtonAriaLabel:"닫기"},callMacOsMicrophoneAccessDenied:{title:"마이크에 액세스할 수 없음",message:"macOS 개인 정보 설정에서 마이크 권한을 부여합니다.",dismissButtonAriaLabel:"닫기"},callLocalVideoFreeze:{title:"네트워크 대역폭이 나쁨",message:"통화 중에 다른 사람에 대해 비디오가 일시 중지된 것 같습니다.",dismissButtonAriaLabel:"닫기"},callCameraAccessDenied:{title:"카메라에 액세스할 수 없음",message:"주소 표시줄에서 잠금을 클릭하여 이 웹 페이지에 권한을 부여합니다.",dismissButtonAriaLabel:"닫기"},callCameraAccessDeniedSafari:{title:"카메라에 액세스할 수 없음",message:"사용 권한을 허용하려면 페이지를 새로 고치거나 이 브라우저의 설정을 확인하고 이 웹 사이트에 사용 권한이 설정되어 있는지 확인하세요.",dismissButtonAriaLabel:"닫기"},callCameraAlreadyInUse:{title:"카메라에 액세스할 수 없음",message:"다른 응용 프로그램에서 이미 사용 중일 수 있습니다.",dismissButtonAriaLabel:"닫기"},callVideoStoppedBySystem:{title:"시스템에 의해 비디오가 중지되었습니다.",dismissButtonAriaLabel:"닫기"},callVideoRecoveredBySystem:{title:"비디오를 다시 시작했습니다.",dismissButtonAriaLabel:"닫기"},callMacOsCameraAccessDenied:{title:"MacOS가 카메라에 대한 액세스를 차단하고 있습니다.",message:"이 브라우저에서 카메라에 액세스할 수 있도록 개인 정보 설정을 업데이트합니다.",dismissButtonAriaLabel:"닫기"},callMacOsScreenShareAccessDenied:{title:"MacOS에서 화면 공유를 차단하고 있습니다.",message:"이 브라우저에서 화면을 녹화할 수 있도록 개인 정보 설정을 업데이트합니다.",dismissButtonAriaLabel:"닫기"},failedToJoinCallGeneric:{title:"통화에 참가하지 못했습니다.",dismissButtonAriaLabel:"닫기"},failedToJoinCallInvalidMeetingLink:{title:"모임에 참가할 수 없습니다. 잘못된 링크입니다.",dismissButtonAriaLabel:"닫기"},cameraFrozenForRemoteParticipants:{title:"통화 중인 사용자에게 영상이 표시되는 데 문제가 있습니다.",message:"장치 및 네트워크를 확인하세요.",dismissButtonAriaLabel:"닫기"},unableToStartVideoEffect:{title:"비디오 효과를 적용할 수 없습니다.",dismissButtonAriaLabel:"닫기"},startSpotlightWhileMaxParticipantsAreSpotlighted:{title:"참가자에 대한 스포트라이트를 시작할 수 없음",message:"최대 참가자 수가 이미 스포트라이트되었습니다.",dismissButtonAriaLabel:"닫기"},mutedByRemoteParticipant:{title:"다른 참가자가 나를 음소거했습니다.",dismissButtonAriaLabel:"닫기"},recordingStarted:{title:"녹음/녹화가 시작되었습니다.",message:"참가하면 이 모임이 전사되는 것에 동의하게 됩니다.",dismissButtonAriaLabel:"닫기"},transcriptionStarted:{title:"전사를 시작했습니다.",message:"참가하면 이 모임이 전사되는 것에 동의하게 됩니다.",dismissButtonAriaLabel:"닫기"},recordingStopped:{title:"녹음/녹화를 저장하는 중입니다.",message:"녹음/녹화를 중단했습니다.",dismissButtonAriaLabel:"닫기"},transcriptionStopped:{title:"대화 기록을 저장하는 중입니다.",message:"대화 내용 기록을 중단했습니다.",dismissButtonAriaLabel:"닫기"},recordingAndTranscriptionStarted:{title:"녹음/녹화와 전사를 시작했습니다.",message:"참가하면 이 모임이 전사되는 것에 동의하게 됩니다.",dismissButtonAriaLabel:"닫기"},recordingAndTranscriptionStopped:{title:"녹음/녹화와 전사를 저장하는 중입니다.",message:"녹음/녹화와 전사를 중단했습니다.",dismissButtonAriaLabel:"닫기"},recordingStoppedStillTranscribing:{title:"녹음/녹화를 중단했습니다.",message:"이제 이 모임의 전사만 진행합니다.",dismissButtonAriaLabel:"닫기"},transcriptionStoppedStillRecording:{title:"대화 내용 기록을 중단했습니다.",message:"이제 이 모임의 녹음/녹화만 진행합니다.",dismissButtonAriaLabel:"닫기"},assignedBreakoutRoomOpened:{title:"5초 후에 할당된 채팅방으로 이동합니다.",dismissButtonAriaLabel:"닫기"},assignedBreakoutRoomChanged:{title:"소규모 회의실이 변경되었습니다.",message:"5초 후에 할당된 채팅방으로 이동합니다.",dismissButtonAriaLabel:"닫기"},assignedBreakoutRoomClosed:{title:"소규모 회의실 종료됨",message:"5초 후에 모임으로 돌아갑니다.",dismissButtonAriaLabel:"닫기"},assignedBreakoutRoomOpenedPromptJoin:{title:"소규모 회의실에 참가하시겠어요?",message:"사용자가 소규모 회의실에 배정되었습니다.",dismissButtonAriaLabel:"닫기",primaryButtonLabel:"소회의실 참가",secondaryButtonLabel:"나중에"},breakoutRoomJoined:{title:"소회의실에 참가했습니다.",dismissButtonAriaLabel:"닫기"},breakoutRoomClosingSoon:{title:"소회의실 시간 제한이 곧 만료됩니다.",message:"이 소회의실은 30초 후에 닫힙니다.",dismissButtonAriaLabel:"닫기"},capabilityTurnVideoOnPresent:{title:"카메라가 사용하도록 설정되었습니다",message:"비디오를 공유하고자 하는 경우 이 기능을 켜세요.",dismissButtonAriaLabel:"닫기"},capabilityTurnVideoOnAbsent:{title:"카메라를 사용하지 않습니다",message:"더 이상 비디오를 공유할 수 없습니다.",dismissButtonAriaLabel:"닫기"},capabilityUnmuteMicPresent:{title:"마이크를 사용하도록 설정했습니다",message:"말하기를 원하는 경우 음소거를 해제하세요.",dismissButtonAriaLabel:"닫기"},capabilityUnmuteMicAbsent:{title:"마이크를 사용할 수 없습니다.",message:"더 이상 음소거 해제할 수 없음",dismissButtonAriaLabel:"닫기"},togetherModeStarted:{title:"Togethermode가 시작되었습니다.",dismissButtonAriaLabel:"닫기"},togetherModeEnded:{title:"Togethermode가 종료되었습니다.",dismissButtonAriaLabel:"닫기"}},videoGallery:{screenIsBeingSharedMessage:"화면을 공유 중입니다.",screenShareLoadingMessage:"{participant} 님의 화면 로드 중",localScreenShareLoadingMessage:"화면 로드 중",localVideoLabel:"나",localVideoCameraSwitcherLabel:"카메라 전환",localVideoMovementLabel:"이동 가능한 로컬 비디오 타일",localVideoMovementAriaLabel:"이동 가능한 로컬 비디오 타일",localVideoSelectedDescription:"{cameraName} 선택함",displayNamePlaceholder:"명명되지 않은 참가자",fitRemoteParticipantToFrame:"프레임에 맞춤",fillRemoteParticipantFrame:"프레임 채우기",pinParticipantForMe:"고정",pinParticipantForMeLimitReached:"핀 제한에 도달함",unpinParticipantForMe:"고정 해제",pinParticipantMenuItemAriaLabel:"{participantName} 고정",unpinParticipantMenuItemAriaLabel:"{participantName} 고정 해제",pinnedParticipantAnnouncementAriaLabel:"{participantName} 고정함",unpinnedParticipantAnnouncementAriaLabel:"{participantName} 고정 해제함",startSpotlightVideoTileMenuLabel:"모두를 위한 스포트라이트",addSpotlightVideoTileMenuLabel:"스포트라이트 추가",spotlightLimitReachedMenuTitle:"스포트라이트 한도 도달",stopSpotlightVideoTileMenuLabel:"스포트라이트 중지",stopSpotlightOnSelfVideoTileMenuLabel:"스포트라이트 종료",attendeeRole:"참석자",muteParticipantMenuItemLabel:"음소거",waitingScreenText:"다른 사용자의 참여를 기다리는 중",forbidAudio:"마이크 비활성화",permitAudio:"마이크 허용",forbidAudioTileMenuLabel:"마이크 비활성화",permitAudioTileMenuLabel:"마이크 허용",forbidVideo:"카메라 비활성화",permitVideo:"카메라 허용",forbidVideoTileMenuLabel:"카메라 비활성화",permitVideoTileMenuLabel:"카메라 허용"},dialpad:{placeholderText:"전화 번호를 입력하세요.",deleteButtonAriaLabel:"삭제"},holdButton:{onLabel:"계속",offLabel:"보류",tooltipOnContent:"통화 계속하기",tooltipOffContent:"통화 대기"},videoTile:{participantStateRinging:"전화 거는 중...",participantReconnecting:"다시 연결하는 중...",participantStateHold:"대기 중",moreOptionsButtonAriaLabel:"기타 옵션 {displayName} {isMuted} {micDisabledState} {cameraDisabledState} {isHandRaised} {state} {isSpeaking}",moreOptionsParticipantMutedStateMutedAriaLabel:"음소거됨",moreOptionsParticipantMutedStateUnmutedAriaLabel:"음소거 해제됨",moreOptionsParticipantHandRaisedAriaLabel:"손 들기",moreOptionsParticipantIsSpeakingAriaLabel:"말하기",moreOptionsParticipantMicDisabledAriaLabel:"마이크를 사용할 수 없음",moreOptionsParticipantCameraDisabledAriaLabel:"카메라 사용 안 함"},CameraAndMicrophoneSitePermissionsRequest:{primaryText:"{appName} 님이 카메라와 마이크를 사용하도록 허용",secondaryText:"참가자가 사용자를 보고 들을 수 있도록 합니다.",linkText:"도움이 필요하신가요? 문제 해결 도움말 보기",primaryButtonText:"카메라 및 마이크 없이 계속",ariaLabel:"카메라 및 마이크 액세스 허용"},CameraSitePermissionsRequest:{primaryText:"{appName}에서 카메라를 사용하도록 허용",secondaryText:"참가자가 나를 볼 수 있도록 합니다.",linkText:"도움이 필요하신가요? 문제 해결 도움말 보기",primaryButtonText:"카메라 없이 계속",ariaLabel:"카메라 액세스 허용"},MicrophoneSitePermissionsRequest:{primaryText:"{appName}에서 마이크를 사용하도록 허용",secondaryText:"참가자가 내 목소리를 들을 수 있도록 합니다.",linkText:"도움이 필요하신가요? 문제 해결 도움말 보기",primaryButtonText:"마이크 없이 계속",ariaLabel:"마이크 액세스 허용"},CameraAndMicrophoneSitePermissionsCheck:{primaryText:"카메라 및 마이크 액세스 확인 중",secondaryText:"메시지가 표시되면 액세스를 허용합니다. 참가자가 사용자를 보고 들을 수 있도록 합니다.",linkText:"도움이 필요하신가요? 문제 해결 도움말 보기",primaryButtonText:"카메라 및 마이크 없이 계속",ariaLabel:"카메라 및 마이크 액세스를 확인하는 중입니다. 메시지가 표시되면 액세스를 허용하세요."},CameraSitePermissionsCheck:{primaryText:"카메라 액세스 확인 중",secondaryText:"메시지가 표시되면 액세스를 허용합니다. 참가자가 사용자를 볼 수 있도록 합니다.",linkText:"도움이 필요하신가요? 문제 해결 도움말 보기",primaryButtonText:"카메라 없이 계속",ariaLabel:"카메라 액세스를 확인하는 중입니다. 메시지가 표시되면 액세스를 허용하세요."},MicrophoneSitePermissionsCheck:{primaryText:"마이크 액세스 확인 중",secondaryText:"메시지가 표시되면 액세스를 허용합니다. 참가자가 들을 수 있도록 합니다.",linkText:"도움이 필요하신가요? 문제 해결 도움말 보기",primaryButtonText:"마이크 없이 계속",ariaLabel:"마이크 액세스를 확인하는 중입니다. 메시지가 표시되면 액세스를 허용하세요."},CameraAndMicrophoneSitePermissionsDenied:{primaryText:"카메라 및 마이크에 액세스할 수 없음",secondaryText:"주소 표시줄에서 잠금 아이콘을 클릭하여 이 웹 페이지에 마이크 권한을 부여합니다. 페이지를 새로 고쳐야 할 수 있습니다.",primaryButtonText:"카메라 및 마이크 없이 계속",linkText:"도움이 필요하신가요? 문제 해결 도움말 보기"},CameraAndMicrophoneSitePermissionsDeniedSafari:{primaryText:"카메라 및 마이크에 액세스할 수 없음",secondaryText:"사용 권한을 허용하려면 페이지를 새로 고치거나 이 브라우저의 설정을 확인하고 이 웹 사이트에 사용 권한이 설정되어 있는지 확인하세요.",primaryButtonText:"카메라 및 마이크 없이 계속",linkText:"도움이 필요하신가요? 문제 해결 도움말 보기"},CameraSitePermissionsDenied:{primaryText:"카메라에 액세스할 수 없음",secondaryText:"주소 표시줄에서 잠금 아이콘을 클릭하여 이 웹 페이지에 카메라 권한을 부여합니다. 페이지를 새로 고쳐야 할 수 있습니다.",primaryButtonText:"카메라 없이 계속",linkText:"도움이 필요하신가요? 문제 해결 도움말 보기"},MicrophoneSitePermissionsDenied:{primaryText:"마이크에 액세스할 수 없음",secondaryText:"주소 표시줄에서 잠금 아이콘을 클릭하여 이 웹 페이지에 마이크 권한을 부여합니다. 페이지를 새로 고쳐야 할 수 있습니다.",primaryButtonText:"마이크 없이 계속",linkText:"도움이 필요하신가요? 문제 해결 도움말 보기"},CameraSitePermissionsDeniedSafari:{primaryText:"카메라에 액세스할 수 없음",secondaryText:"사용 권한을 허용하려면 페이지를 새로 고치거나 이 브라우저의 설정을 확인하고 이 웹 사이트에 사용 권한이 설정되어 있는지 확인하세요.",primaryButtonText:"카메라 없이 계속",linkText:"도움이 필요하신가요? 문제 해결 도움말 보기"},MicrophoneSitePermissionsDeniedSafari:{primaryText:"마이크에 액세스할 수 없음",secondaryText:"사용 권한을 허용하려면 페이지를 새로 고치거나 이 브라우저의 설정을 확인하고 이 웹 사이트에 사용 권한이 설정되어 있는지 확인하세요.",primaryButtonText:"마이크 없이 계속",linkText:"도움이 필요하신가요? 문제 해결 도움말 보기"},UnsupportedBrowser:{primaryText:"지원되지 않는 브라우저",secondaryText:"호환되는 브라우저를 사용하여 이 통화에 참여하세요.",moreHelpLinkText:"호환성 요구 사항 보기"},UnsupportedBrowserVersion:{primaryText:"브라우저 업데이트 필요",secondaryText:"최상의 통화를 하려면 브라우저를 업데이트한 다음 통화에 다시 참가해 보세요.",moreHelpLinkText:"호환성 요구 사항 보기",continueAnywayButtonText:"업데이트하지 않고 통화 시작"},UnsupportedOperatingSystem:{primaryText:"지원되지 않는 운영 체제",secondaryText:"호환되는 운영 체제가 있는 장치를 사용하여 이 통화에 참여하세요.",moreHelpLinkText:"호환성 요구 사항 보기"},BrowserPermissionDenied:{primaryText:"카메라 또는 마이크를 사용할 수 없음",secondaryText:"브라우저에서 카메라 또는 마이크에 액세스할 수 없을 수 있습니다. 이 문제를 해결하려면 시스템 기본 설정을 엽니다.",primaryButtonText:"다시 시도",linkText:"도움이 필요하신가요? 문제 해결 도움말 보기"},BrowserPermissionDeniedIOS:{primaryText:"계속하려면 마이크 액세스 허용",secondaryText:"따라서 다른 참가자가 여러분의 의견을 들을 수 있습니다.",primaryButtonText:"다시 시도",imageAltText:"iOS용 마이크 및 카메라 장치 권한 위치",linkText:"도움이 필요하신가요? 문제 해결 도움말 보기",step1Text:"설정 앱으로 이동합니다.",step2Text:"이 브라우저의 설정에 Scroll down",step3Text:"마이크 켜기(카메라 선택 사항)",step4Text:"통화에 다시 참가해 보세요.",step1DigitText:"1",step2DigitText:"2",step3DigitText:"3",step4DigitText:"4"},verticalGallery:{leftNavButtonAriaLabel:"이전 페이지 {current}/{total}",rightNavButtonAriaLabel:"다음 페이지 {current}/{total}"},meetingConferencePhoneInfo:{meetingConferencePhoneInfoModalTitle:"내 전화에서 통화 참가",meetingConferencePhoneInfoModalDialIn:"전화 걸기",meetingConferencePhoneInfoModalMeetingId:"모임 ID 입력",meetingConferencePhoneInfoModalWait:"이끌이가 허가할 때까지 기다리세요.",meetingConferencePhoneInfoModalNoPhoneAvailable:"사용할 수 있는 전화 없음",meetingConferencePhoneInfoModalTollGeoData:"{country}, {city}",meetingConferencePhoneInfoModalTollFree:"(무료)",meetingConferencePhoneInfoModalToll:"(유료)"},IncomingCallNotification:{incomingCallNotificationPlaceholderId:"알 수 없는 사용자",incomingCallNotificationPlaceholderAlert:"{callerName}이(가) 호출 중입니다.",incomingCallNoticicationAcceptWithAudioAriaLabel:"오디오 수락",incomingCallNoticicationAcceptWithVideoAriaLabel:"비디오 수락",incomingCallNoticicationRejectAriaLabel:"거부",incomingCallNotificationAcceptButtonLabel:"수락",incomingCallNotificationRejectButtonLabel:"거절",incomingCallNotificationAccceptWithVideoButtonLabel:"영상 수락",incomingCallNotificationDismissButtonAriaLabel:"해제"}})},yQt={strings:Jh({participantItem:{isMeText:"(deg)",menuTitle:"Flere alternativer",removeButtonLabel:"Fjern",sharingIconLabel:"Deling",mutedIconLabel:"Dempet",handRaisedIconLabel:"Hevet hånd – posisjon {position}",displayNamePlaceholder:"Deltaker uten navn",participantStateRinging:"Ringer ...",participantStateHold:"På vent",participantItemAriaLabel:"{displayName}, {handRaisedState}, {mutedState}, {micDisabledState}, {cameraDisabledState}, {sharingState}, {connectionState}",participantItemWithMoreOptionsAriaLabel:"{displayName}, {handRaisedState}, {mutedState}, {micDisabledState}, {cameraDisabledState}, {sharingState}, {connectionState}, flere alternativer",attendeeRole:"Deltaker",micDisabledIconLabel:"Mikrofon deaktivert",cameraDisabledIconLabel:"Kamera deaktivert"},ParticipantList:{overflowParticipantCount:"+{overflowCount} flere"},typingIndicator:{singleUser:"{user} skriver ...",multipleUsers:"{users} skriver ...",multipleUsersAbbreviateOne:"{users} og 1 annen skriver ...",multipleUsersAbbreviateMany:"{users} og {numOthers} andre skriver ...",delimiter:", "},sendBox:{placeholderText:"Skriv en melding",textTooLong:"Meldingslengden er over maksimumsgrensen.",sendButtonAriaLabel:"Send melding",attachmentUploadsPendingError:"Filen lastes opp. Vent litt.",removeAttachment:"Fjern fil",uploading:"Laster opp",uploadCompleted:"Opplasting fullført",attachmentMoreMenu:"Flere alternativer"},richTextSendBox:{placeholderText:"Skriv en melding",textTooLong:"Meldingslengden er over maksimumsgrensen.",sendButtonAriaLabel:"Send melding",attachmentUploadsPendingError:"Filen lastes opp. Vent litt.",imageUploadsPendingError:"Bildet lastes opp. Vent litt.",removeAttachment:"Fjern fil",uploading:"Laster opp",uploadCompleted:"Opplasting fullført",richTextBoldTooltip:"Fet",richTextItalicTooltip:"Kursiv",richTextUnderlineTooltip:"Understreking",richTextBulletListTooltip:"Punktliste",richTextNumberListTooltip:"Nummerert liste",richTextIncreaseIndentTooltip:"Øk innrykk",richTextDecreaseIndentTooltip:"Reduser innrykk",richTextInsertTableTooltip:"Sett inn tabell",richTextFormatButtonTooltip:"Format",richTextInsertRowOrColumnMenu:"Sett inn",richTextInsertTableMenuTitle:"Sett inn {column} x {row}-tabell",richTextInsertRowAboveMenu:"Sett inn ovenfor",richTextInsertRowBelowMenu:"Sett inn nedenfor",richTextInsertColumnLeftMenu:"Sett inn til venstre",richTextInsertColumnRightMenu:"Sett inn til høyre",richTextDeleteRowOrColumnMenu:"Slett",richTextDeleteColumnMenu:"Slett kolonne",richTextDeleteRowMenu:"Slett rad",richTextDeleteTableMenu:"Slett tabell",richTextToolbarAriaLabel:"Verktøylinje for meldingsformatering",richTextToolbarMoreButtonAriaLabel:"Flere alternativer",attachmentMoreMenu:"Flere alternativer",richTextNewBulletedListItemAnnouncement:"Punkt, ny linje",richTextNewNumberedListItemAnnouncement:"{0}, ny linje",richTextBulletedListAppliedAnnouncement:"Punktliste er brukt",richTextNumberedListAppliedAnnouncement:"Nummerert liste brukes"},realTimeTextModal:{realTimeTextModalAriaLabel:"Aktiver sperrende dialogboks for skriving i sanntid",realTimeTextModalTitle:"Aktiver skriving i sanntid?",realTimeTextModalText:"Sanntidstekst (RTT) aktiveres for alle i møtet.",realTimeTextConfirmButtonLabel:"Aktiver",realTimeTextCancelButtonLabel:"Avbryt",realTimeTextCloseModalButtonAriaLabel:"Lukk sperrende dialogboks for skriving i sanntid"},captionsBanner:{captionsBannerSpinnerText:"Starter teksting ...",realTimeTextInputBoxDefaultText:"Skriv inn meldingen i sanntid",realTimeTextInputErrorMessage:"Meldingen kan ikke overskride 2000 tegn",realTimeTextBannerTitle:"Skriving i sanntid",realTimeTextBannerContent:"RTT (sanntidstekst) er aktivert for alle deltakere hele varigheten for møtet.",realTimeTextBannerLinkLabel:"Mer informasjon",captionsOnlyContainerTitle:"Undertekster",realTimeTextOnlyContainerTitle:"Tekst i sanntid",captionsAndRealTimeTextContainerTitle:"Teksting og sanntidstekst",expandButtonAriaLabel:"Utvid",minimizeButtonAriaLabel:"Skjul"},mentionPopover:{mentionPopoverHeader:"Forslag"},imageOverlay:{downloadButtonLabel:"Last ned",dismissButtonAriaLabel:"Lukk",overlayVisibleMessage:"Detaljoverlegg for bilde"},messageStatusIndicator:{deliveredAriaLabel:"Melding sendt",deliveredTooltipText:"Sendt",seenAriaLabel:"Melding sett av andre",seenTooltipText:"Sett",readByTooltipText:"Lest av {messageThreadReadCount} av {remoteParticipantsCount}",sendingAriaLabel:"Sending av melding",sendingTooltipText:"Sender",failedToSendAriaLabel:"Melding ikke sendt",failedToSendTooltipText:"Kan ikke sende"},endCallButton:{label:"Forlat",tooltipContent:"Forlat samtale",leaveOption:"Forlat",endCallOption:"Avslutt samtale for alle"},cameraButton:{onLabel:"Kamera",offLabel:"Kamera",tooltipDisabledContent:"Kameraet er deaktivert",tooltipOnContent:"Slå av kamera",tooltipOffContent:"Slå på kamera",tooltipVideoLoadingContent:"Videoen lastes inn",cameraMenuTitle:"Kamera",cameraMenuTooltip:"Velg kamera",cameraButtonSplitRoleDescription:"Rullegardinknapp",onSplitButtonAriaLabel:"Slå av kamera",offSplitButtonAriaLabel:"Slå på kamera",cameraActionTurnedOnAnnouncement:"Kameraet er slått på",cameraActionTurnedOffAnnouncement:"Kameraet er slått av.",onSplitButtonPrimaryActionCamera:"Slå av kamera",offSplitButtonPrimaryActionCamera:"Slå på kamera",cameraPrimaryActionSplitButtonTitle:"Bruk kamera",videoEffectsMenuItemTitle:"Effekter",cameraButtonAriaDescription:"kameraalternativer"},microphoneButton:{onLabel:"Mikrofon",offLabel:"Mikrofon",tooltipDisabledContent:"Mikrofonen er deaktivert",tooltipOnContent:"Demp mikrofon",tooltipOffContent:"Opphev demping av mikrofon",microphoneMenuTitle:"Mikrofon",microphoneMenuTooltip:"Velg mikrofon",speakerMenuTitle:"Høyttaler",speakerMenuTooltip:"Velg høyttaler",microphoneButtonSplitRoleDescription:"Rullegardinknapp",onSplitButtonAriaLabel:"Demp mikrofon",offSplitButtonAriaLabel:"Opphev demping av mikrofon",microphoneActionTurnedOnAnnouncement:"Mikrofonen er slått på",microphoneActionTurnedOffAnnouncement:"Mikrofonen er slått av",offSplitButtonMicrophonePrimaryAction:"Opphev demping av mikrofon",onSplitButtonMicrophonePrimaryAction:"Demp mikrofon",microphonePrimaryActionSplitButtonTitle:"Bruk mikrofon",microphoneAriaDescription:"Lydalternativer",deepNoiseSuppressionTitle:"Støydemping",deepNoiseSuppressionOnAnnouncement:"Dyp støydemping er aktivert",deepNoiseSuppressionOffAnnouncement:"Dyp støydemping er deaktivert"},devicesButton:{label:"Enheter",tooltipContent:"Administrer enheter",cameraMenuTitle:"Kamera",cameraMenuTooltip:"Velg kamera",audioDeviceMenuTitle:"Lydenhet",audioDeviceMenuTooltip:"Velg lydenhet",microphoneMenuTitle:"Mikrofon",microphoneMenuTooltip:"Velg mikrofon",speakerMenuTitle:"Høyttaler",speakerMenuTooltip:"Velg høyttaler"},participantsButton:{label:"Personer",ariaLabel:"Personer",tooltipContent:"Vis deltakere",menuHeader:"I denne samtalen",participantsListButtonLabel:"{numParticipants} personer",muteAllButtonLabel:"Demp alle",copyInviteLinkButtonLabel:"Kopier invitasjonskobling",copyInviteLinkActionedAriaLabel:"Invitasjonskobling er kopiert"},screenShareButton:{onLabel:"Stopp presentasjon",offLabel:"Presenter",tooltipDisabledContent:"Presentasjon er deaktivert",tooltipOnContent:"Presenterer skjermen din",tooltipOffContent:"Presenter skjermen din"},raiseHandButton:{offLabel:"Rekk opp",onLabel:"Ta ned",tooltipDisabledContent:"Rekk opp hånden-handlingen er deaktivert",tooltipOnContent:"Ta ned hånden",tooltipOffContent:"Rekke opp hånden"},reactionButton:{label:"Reager",ariaLabel:"Reager",tooltipDisabledContent:"Reaksjonshandling er deaktivert",tooltipContent:"Send en reaksjon",likeReactionTooltipContent:"Liker",heartReactionTooltipContent:"Kjærlighet",laughReactionTooltipContent:"Latter",applauseReactionTooltipContent:"Applaus",surprisedReactionTooltipContent:"Overrasket"},realTimeText:{isTypingText:"Skriving i sanntid"},captionsSettingsModal:{captionsSettingsModalTitle:"Undertekstinnstillinger",captionsSettingsSpokenLanguageDropdownLabel:"Talespråk",captionsSettingsCaptionLanguageDropdownLabel:"Undertekstspråk",captionsSettingsSpokenLanguageDropdownInfoText:"Språket som alle i denne samtalen snakker.",captionsSettingsCaptionLanguageDropdownInfoText:"Undertekster vises på dette språket.",captionsSettingsConfirmButtonLabel:"Bekreft",captionsSettingsCancelButtonLabel:"Avbryt",captionsSettingsModalAriaLabel:"Sperre for innstillinger for undertekster",captionsSettingsCloseModalButtonAriaLabel:"Lukk innstilling for undertekster"},spokenLanguages:{"ar-ae":"Arabisk – De forente arabiske emirater","ar-sa":"Arabisk – Saudi-Arabia","da-dk":"Dansk","de-de":"Tysk – Tyskland","en-au":"Engelsk – Australia","en-ca":"Engelsk – Canada","en-gb":"Engelsk – Storbritannia","en-in":"Engelsk – India","en-nz":"Engelsk – New Zealand","en-us":"Engelsk – USA","es-es":"Spansk – Spania (moderne)","es-mx":"Spansk – Mexico","fi-fi":"Finsk","fr-ca":"Fransk – Canada","fr-fr":"Fransk – Frankrike","hi-in":"Hindi","it-it":"Italiensk – Italia","ja-jp":"Japansk","ko-kr":"Koreansk","nb-no":"Norsk (bokmål)","nl-be":"Nederlandsk – Belgia","nl-nl":"Nederlandsk – Nederland","pl-pl":"Polsk","pt-br":"Portugisisk – Brasil","ru-ru":"Russisk","sv-se":"Svensk","zh-cn":"Kinesisk – Folkerepublikken Kina","zh-hk":"Kinesisk – Hongkong SAR","cs-cz":"Tsjekkisk","pt-pt":"Portugisisk – Portugal","tr-tr":"Tyrkisk","vi-vn":"Vietnamesisk","th-th":"Thai","he-il":"Hebraisk","cy-gb":"Walisisk","uk-ua":"Ukrainsk","el-gr":"Gresk","hu-hu":"Ungarsk","ro-ro":"Rumensk","sk-sk":"Slovakisk","zh-tw":"Kinesisk – Taiwan"},captionLanguages:{ar:"Arabisk",da:"Dansk",de:"Tysk",en:"Engelsk",es:"Spansk",fi:"Finsk","fr-ca":"Fransk – Canada",fr:"Fransk – Frankrike",hi:"Hindi",it:"Italiensk",ja:"Japansk",ko:"Koreansk",nb:"Norsk (bokmål)",nl:"Nederlandsk",pl:"Polsk",pt:"Portugisisk – Brasil",ru:"Russisk",sv:"Svensk","zh-Hans":"Kinesisk (forenklet)","zh-Hant":"Kinesisk (tradisjonell)",cs:"Tsjekkisk","pt-pt":"Portugisisk – Portugal",tr:"Tyrkisk",vi:"Vietnamesisk",th:"Thai",he:"Hebraisk",cy:"Walisisk",uk:"Ukrainsk",el:"Gresk",hu:"Ungarsk",ro:"Rumensk",sk:"Slovakisk"},startCaptionsButton:{onLabel:"Slå på undertekster",offLabel:"Deaktiver undertekster",tooltipOnContent:"Deaktiver undertekster",tooltipOffContent:"Slå på undertekster"},startRealTimeTextButton:{label:"Aktiver RTT for denne samtalen",tooltipOffContent:"Aktiver RTT for denne samtalen"},messageThread:{yesterday:"I går",sunday:"Søndag",monday:"Mandag",tuesday:"Tirsdag",wednesday:"Onsdag",thursday:"Torsdag",friday:"Fredag",saturday:"Lørdag",participantJoined:"ble med i chatten.",participantLeft:"forlot chatten.",editMessage:"Rediger",removeMessage:"Slett",resendMessage:"Prøv å sende på nytt",failToSendTag:"Kan ikke sende",editedTag:"Redigert",liveAuthorIntro:"Melding fra {author}",editedMessageLiveAuthorIntro:"Redigert melding fra {author}",editedMessageLocalUserLiveAuthorIntro:"Redigert melding",messageContentAriaText:"{status} {author} sa {message}",messageContentMineAriaText:"{status} Du sa {message}",editBoxTextLimit:"Meldingen er over grensen på {limitNumber} tegn",editBoxPlaceholderText:"Rediger meldingen",newMessagesIndicator:"Nye meldinger",noDisplayNameSub:"Uten navn",editBoxCancelButton:"Avbryt",editBoxSubmitButton:"Fullført",messageReadCount:"Lest av {messageReadByCount} av {remoteParticipantsCount}",actionMenuMoreOptions:"Flere alternativer",downloadAttachment:"Last ned fil",openAttachment:"Åpne fil",blockedWarningText:"Denne meldingen ble slettet på grunn av en organisasjonspolicy.",blockedWarningLinkText:"Detaljer",attachmentCardGroupMessage:"Meldingen har {attachmentCount} vedlegg",messageDeletedAnnouncementAriaLabel:"Meldingen er slettet",richTextBoldTooltip:"Fet",richTextItalicTooltip:"Kursiv",richTextUnderlineTooltip:"Understreking",richTextBulletListTooltip:"Punktliste",richTextNumberListTooltip:"Nummerert liste",richTextIncreaseIndentTooltip:"Øk innrykk",richTextDecreaseIndentTooltip:"Reduser innrykk",richTextInsertTableTooltip:"Sett inn tabell",richTextFormatButtonTooltip:"Format",richTextInsertRowOrColumnMenu:"Sett inn",richTextInsertTableMenuTitle:"Sett inn {column} x {row}-tabell",richTextInsertRowAboveMenu:"Sett inn ovenfor",richTextInsertRowBelowMenu:"Sett inn nedenfor",richTextInsertColumnLeftMenu:"Sett inn til venstre",richTextInsertColumnRightMenu:"Sett inn til høyre",richTextDeleteRowOrColumnMenu:"Slett",richTextDeleteColumnMenu:"Slett kolonne",richTextDeleteRowMenu:"Slett rad",richTextDeleteTableMenu:"Slett tabell",richTextToolbarMoreButtonAriaLabel:"Flere alternativer",attachmentUploadsPendingError:"Filen lastes opp. Vent litt.",imageUploadsPendingError:"Bildet lastes opp. Vent litt.",richTextNewBulletedListItemAnnouncement:"Punkt, ny linje",richTextNewNumberedListItemAnnouncement:"{0}, ny linje",richTextBulletedListAppliedAnnouncement:"Punktliste er brukt",richTextNumberedListAppliedAnnouncement:"Nummerert liste brukes"},errorBar:{unableToReachChatService:"Du er frakoblet",accessDenied:"Får ikke tilgang til chattjenester. Kontroller brukerlegitimasjonen som er angitt",userNotInChatThread:"Du er ikke lenger i denne chattetråden",sendMessageNotInChatThread:"Kan ikke sende meldingen fordi du ikke lenger er i denne chattetråden",sendMessageGeneric:"Kan ikke sende meldingen",callingNetworkFailure:"Problemer med å koble til samtalen – du ser ut til å være frakoblet",startVideoGeneric:"Kan ikke starte video",stopVideoGeneric:"Kan ikke stoppe video",muteGeneric:"Kan ikke dempe mikrofonen",unmuteGeneric:"Kan ikke oppheve demping av mikrofon",speakingWhileMuted:"Mikrofonen er dempet",startScreenShareGeneric:"Det oppstod et problem under start av skjermdeling.",stopScreenShareGeneric:"Kan ikke stoppe skjermdeling",callNetworkQualityLow:"Nettverkskvaliteten er lav.",teamsMeetingCallNetworkQualityLow:"Nettverkskvaliteten er lav.",callNoSpeakerFound:"Finner ingen høyttalere eller hodetelefoner. Koble til en lydenhet for å høre samtalen.",callNoMicrophoneFound:"Finner ingen mikrofoner. Koble til en lydinndataenhet.",callMicrophoneAccessDenied:"Får ikke tilgang til mikrofonen. Klikk låsen i adresselinjen for å gi tillatelse til denne nettsiden.",callMicrophoneAccessDeniedSafari:"Får ikke tilgang til mikrofonen. Oppdater siden for å tillate tillatelser, eller kontroller innstillingene for denne nettleseren og kontroller at tillatelser er aktivert for dette nettstedet.",callMicrophoneMutedBySystem:"Du er dempet av systemet.",callMicrophoneUnmutedBySystem:"Mikrofonen ble gjenopprettet, og dempingen ble opphevet av systemet.",callMacOsMicrophoneAccessDenied:"Får ikke tilgang til mikrofonen. Gi mikrofontillatelse i personverninnstillingene for macOS.",callLocalVideoFreeze:"Nettverksbåndbredden er dårlig. Videoen kan være midlertidig stanset for andre i samtalen.",callCameraAccessDenied:"Får ikke tilgang til kameraet. Klikk låsen i adresselinjen for å gi tillatelse til denne nettsiden.",callCameraAccessDeniedSafari:"Får ikke tilgang til kameraet. Oppdater siden for å tillate tillatelser, eller kontroller innstillingene for denne nettleseren og kontroller at tillatelser er aktivert for dette nettstedet.",callCameraAlreadyInUse:"Får ikke tilgang til kameraet. Det kan allerede være i bruk av et annet program.",callVideoStoppedBySystem:"Videoen er stoppet av systemet.",callVideoRecoveredBySystem:"Videoen er gjenopptatt.",callMacOsCameraAccessDenied:"MacOS blokkerer tilgang til kameraet. Oppdater personverninnstillingene for å gi denne nettleseren tilgang til kameraet.",callMacOsScreenShareAccessDenied:"MacOS blokkerer skjermdeling. Oppdater personverninnstillingene for å tillate at denne nettleseren registrerer skjermen.",dismissButtonAriaLabel:"Lukk",failedToJoinCallGeneric:"Kan ikke bli med i samtalen.",failedToJoinCallInvalidMeetingLink:"Kan ikke bli med i møtet. Ugyldig kobling.",cameraFrozenForRemoteParticipants:"Brukere i samtalen har problemer med å se videoen. Kontroller enhetene og nettverket.",unableToStartVideoEffect:"Kan ikke bruke videoeffekt.",startSpotlightWhileMaxParticipantsAreSpotlighted:"Kan ikke starte rampelys på deltaker(e) fordi maksimalt antall deltakere allerede er satt i rampelyset.",mutedByRemoteParticipant:"Du har blitt dempet av en annen deltaker."},notificationStack:{callingNetworkFailure:{title:"Problemer med å koble til samtalen",message:"Du ser ut til å være frakoblet. Kontroller nettverkstilkoblingen, og prøv på nytt.",dismissButtonAriaLabel:"Lukk"},startVideoGeneric:{title:"Kan ikke starte video.",dismissButtonAriaLabel:"Lukk"},stopVideoGeneric:{title:"Kan ikke stoppe video.",dismissButtonAriaLabel:"Lukk"},muteGeneric:{title:"Kan ikke dempe mikrofonen.",dismissButtonAriaLabel:"Lukk"},unmuteGeneric:{title:"Kan ikke oppheve demping av mikrofon.",dismissButtonAriaLabel:"Lukk"},speakingWhileMuted:{title:"Du er dempet.",dismissButtonAriaLabel:"Lukk"},startScreenShareGeneric:{title:"Det oppstod et problem under start av skjermdeling.",dismissButtonAriaLabel:"Lukk"},stopScreenShareGeneric:{title:"Kan ikke stoppe skjermdeling.",dismissButtonAriaLabel:"Lukk"},callNetworkQualityLow:{title:"Nettverkskvaliteten er lav.",dismissButtonAriaLabel:"Lukk"},teamsMeetingCallNetworkQualityLow:{title:"Nettverkskvaliteten er lav.",dismissButtonAriaLabel:"Lukk",message:"Bli med i denne samtalen fra telefonen for bedre lyd. Du kan fortsette å vise møtet på denne enheten.",primaryButtonLabel:"Bli med via telefon"},callNoSpeakerFound:{title:"Finner ingen høyttalere eller hodetelefoner",message:"Koble til en lydenhet for å høre samtalen.",dismissButtonAriaLabel:"Lukk"},callNoMicrophoneFound:{title:"Finner ingen mikrofoner",message:"Koble til en lydinndataenhet.",dismissButtonAriaLabel:"Lukk"},callMicrophoneAccessDenied:{title:"Får ikke tilgang til mikrofonen",message:"Klikk låsen i adresselinjen for å gi tillatelse til denne nettsiden.",dismissButtonAriaLabel:"Lukk"},callMicrophoneAccessDeniedSafari:{title:"Får ikke tilgang til mikrofonen",message:"Oppdater siden for å tillate tillatelser, eller kontroller innstillingene for denne nettleseren, og kontroller at tillatelser er aktivert for dette nettstedet.",dismissButtonAriaLabel:"Lukk"},callMicrophoneMutedBySystem:{title:"Du er dempet av systemet.",dismissButtonAriaLabel:"Lukk"},callMicrophoneUnmutedBySystem:{title:"Mikrofonen ble gjenopprettet, og dempingen ble opphevet av systemet.",dismissButtonAriaLabel:"Lukk"},callMacOsMicrophoneAccessDenied:{title:"Får ikke tilgang til mikrofonen",message:"Gi mikrofontillatelse i personverninnstillingene for macOS.",dismissButtonAriaLabel:"Lukk"},callLocalVideoFreeze:{title:"Nettverksbåndbredden er dårlig",message:"Videoen kan være midlertidig stanset for andre i samtalen.",dismissButtonAriaLabel:"Lukk"},callCameraAccessDenied:{title:"Får ikke tilgang til kamera",message:"Klikk låsen i adresselinjen for å gi tillatelse til denne nettsiden.",dismissButtonAriaLabel:"Lukk"},callCameraAccessDeniedSafari:{title:"Får ikke tilgang til kamera",message:"Oppdater siden for å tillate tillatelser, eller kontroller innstillingene for denne nettleseren, og kontroller at tillatelser er aktivert for dette nettstedet.",dismissButtonAriaLabel:"Lukk"},callCameraAlreadyInUse:{title:"Får ikke tilgang til kamera",message:"Det kan allerede være i bruk av et annet program.",dismissButtonAriaLabel:"Lukk"},callVideoStoppedBySystem:{title:"Videoen er stoppet av systemet.",dismissButtonAriaLabel:"Lukk"},callVideoRecoveredBySystem:{title:"Videoen er gjenopptatt.",dismissButtonAriaLabel:"Lukk"},callMacOsCameraAccessDenied:{title:"MacOS blokkerer tilgang til kameraet",message:"Oppdater personverninnstillingene for å gi denne nettleseren tilgang til kameraet.",dismissButtonAriaLabel:"Lukk"},callMacOsScreenShareAccessDenied:{title:"MacOS blokkerer skjermdeling",message:"Oppdater personverninnstillingene for å tillate at denne nettleseren registrerer skjermen.",dismissButtonAriaLabel:"Lukk"},failedToJoinCallGeneric:{title:"Kan ikke bli med i samtalen.",dismissButtonAriaLabel:"Lukk"},failedToJoinCallInvalidMeetingLink:{title:"Kan ikke bli med i møtet. Ugyldig kobling.",dismissButtonAriaLabel:"Lukk"},cameraFrozenForRemoteParticipants:{title:"Brukere i samtalen har problemer med å se videoen",message:"Kontroller enhetene og nettverket.",dismissButtonAriaLabel:"Lukk"},unableToStartVideoEffect:{title:"Kan ikke bruke videoeffekt.",dismissButtonAriaLabel:"Lukk"},startSpotlightWhileMaxParticipantsAreSpotlighted:{title:"Kan ikke begynne å sette deltaker(e) i rampelyset",message:"Maksimalt antall deltakere er allerede satt i rampelyset.",dismissButtonAriaLabel:"Lukk"},mutedByRemoteParticipant:{title:"Du har blitt dempet av en annen deltaker.",dismissButtonAriaLabel:"Lukk"},recordingStarted:{title:"Innspilling er startet.",message:"Ved å bli med gir du samtykke til at dette møtet kan transkriberes.",dismissButtonAriaLabel:"Lukk"},transcriptionStarted:{title:"Transkripsjon er startet.",message:"Ved å bli med gir du samtykke til at dette møtet kan transkriberes.",dismissButtonAriaLabel:"Lukk"},recordingStopped:{title:"Opptaket blir lagret.",message:"Innspillingen har stoppet.",dismissButtonAriaLabel:"Lukk"},transcriptionStopped:{title:"Transkripsjonen blir lagret.",message:"Transkripsjon har stoppet.",dismissButtonAriaLabel:"Lukk"},recordingAndTranscriptionStarted:{title:"Opptak og transkripsjon har startet.",message:"Ved å bli med gir du samtykke til at dette møtet kan transkriberes.",dismissButtonAriaLabel:"Lukk"},recordingAndTranscriptionStopped:{title:"Opptak og transkripsjon lagres.",message:"Opptak og transkripsjon har stoppet.",dismissButtonAriaLabel:"Lukk"},recordingStoppedStillTranscribing:{title:"Innspillingen har stoppet.",message:"Du transkriberer nå bare dette møtet.",dismissButtonAriaLabel:"Lukk"},transcriptionStoppedStillRecording:{title:"Transkripsjon har stoppet.",message:"Du tar nå bare opp dette møtet.",dismissButtonAriaLabel:"Lukk"},assignedBreakoutRoomOpened:{title:"Vi flytter deg til det tilordnede rommet om fem sekunder.",dismissButtonAriaLabel:"Lukk"},assignedBreakoutRoomChanged:{title:"Grupperommet er endret",message:"Vi flytter deg til det tilordnede rommet om fem sekunder.",dismissButtonAriaLabel:"Lukk"},assignedBreakoutRoomClosed:{title:"Grupperommet ditt er lukket",message:"Vi flytter deg tilbake til møtet om fem sekunder.",dismissButtonAriaLabel:"Lukk"},assignedBreakoutRoomOpenedPromptJoin:{title:"Bli med i grupperommet?",message:"Du har blitt tilordnet et grupperom.",dismissButtonAriaLabel:"Lukk",primaryButtonLabel:"Bli med i rom",secondaryButtonLabel:"Senere"},breakoutRoomJoined:{title:"Du har blitt med i et grupperom.",dismissButtonAriaLabel:"Lukk"},breakoutRoomClosingSoon:{title:"Romtidsgrensen er i ferd med å utløpe.",message:"Dette rommet blir lukket om 30 sekunder",dismissButtonAriaLabel:"Lukk"},capabilityTurnVideoOnPresent:{title:"Kameraet er aktivert",message:"Slå den på hvis du vil dele video.",dismissButtonAriaLabel:"Lukk"},capabilityTurnVideoOnAbsent:{title:"Kameraet ditt er deaktivert",message:"Du kan ikke lenger dele video.",dismissButtonAriaLabel:"Lukk"},capabilityUnmuteMicPresent:{title:"Mikrofonen er aktivert",message:"Slå på lyden for å snakke.",dismissButtonAriaLabel:"Lukk"},capabilityUnmuteMicAbsent:{title:"Mikrofonen er deaktivert",message:"Du kan ikke lenger oppheve dempingen.",dismissButtonAriaLabel:"Lukk"},togetherModeStarted:{title:"Sammenmodus er startet",dismissButtonAriaLabel:"Lukk"},togetherModeEnded:{title:"Sammenmodus er avsluttet",dismissButtonAriaLabel:"Lukk"}},videoGallery:{screenIsBeingSharedMessage:"Du deler skjermen",screenShareLoadingMessage:"Laster inn skjermen til {participant}",localScreenShareLoadingMessage:"Laster inn skjermen",localVideoLabel:"Du",localVideoCameraSwitcherLabel:"Bytt kamera",localVideoMovementLabel:"Flyttbar lokal videoflis",localVideoMovementAriaLabel:"Flyttbar lokal videoflis",localVideoSelectedDescription:"{cameraName} valgt",displayNamePlaceholder:"Deltaker uten navn",fitRemoteParticipantToFrame:"Tilpass til ramme",fillRemoteParticipantFrame:"Fyll ramme",pinParticipantForMe:"Fest for meg",pinParticipantForMeLimitReached:"Pin-kode (grense nådd)",unpinParticipantForMe:"Løsne",pinParticipantMenuItemAriaLabel:"Fest {participantName}",unpinParticipantMenuItemAriaLabel:"Løsne {participantName}",pinnedParticipantAnnouncementAriaLabel:"Festet {participantName}",unpinnedParticipantAnnouncementAriaLabel:"Løsnet {participantName}",startSpotlightVideoTileMenuLabel:"Sett i rampelyset for alle",addSpotlightVideoTileMenuLabel:"Legg til rampelys",spotlightLimitReachedMenuTitle:"Rampelys-grensen er nådd",stopSpotlightVideoTileMenuLabel:"Fjern fra rampelyset",stopSpotlightOnSelfVideoTileMenuLabel:"Rampelys av",attendeeRole:"Deltaker",muteParticipantMenuItemLabel:"Demp",waitingScreenText:"Venter på at andre skal bli med",forbidAudio:"Deaktivere mikrofon",permitAudio:"Tillat mikrofon",forbidAudioTileMenuLabel:"Deaktivere mikrofon",permitAudioTileMenuLabel:"Tillat mikrofon",forbidVideo:"Deaktivere kamera",permitVideo:"Tillat kamera",forbidVideoTileMenuLabel:"Deaktivere kamera",permitVideoTileMenuLabel:"Tillat kamera"},dialpad:{placeholderText:"Skriv inn telefonnummeret",deleteButtonAriaLabel:"Slett"},holdButton:{onLabel:"Fortsett",offLabel:"Vent",tooltipOnContent:"Fortsett samtale",tooltipOffContent:"Sett samtalen på vent"},videoTile:{participantStateRinging:"Ringer ...",participantReconnecting:"Kobler til på nytt ...",participantStateHold:"På vent",moreOptionsButtonAriaLabel:"Flere alternativer {displayName} {isMuted} {micDisabledState} {cameraDisabledState} {isHandRaised} {state} {isSpeaking}",moreOptionsParticipantMutedStateMutedAriaLabel:"varsler er deaktivert",moreOptionsParticipantMutedStateUnmutedAriaLabel:"opphevet demping",moreOptionsParticipantHandRaisedAriaLabel:"Hånd rakt opp",moreOptionsParticipantIsSpeakingAriaLabel:"Snakke",moreOptionsParticipantMicDisabledAriaLabel:"Mikrofon deaktivert",moreOptionsParticipantCameraDisabledAriaLabel:"Kamera deaktivert"},CameraAndMicrophoneSitePermissionsRequest:{primaryText:"Tillat {appName} å bruke kameraet og mikrofonen",secondaryText:"Dette er for at deltakerne skal kunne se og høre deg.",linkText:"Trenger du hjelp? Få hjelp til feilsøking",primaryButtonText:"Fortsett uten kamera og mikrofon",ariaLabel:"Gi tilgang til kamera og mikrofon"},CameraSitePermissionsRequest:{primaryText:"Tillat at {appName} bruker kameraet",secondaryText:"Dette er for at deltakerne skal kunne se deg.",linkText:"Trenger du hjelp? Få hjelp til feilsøking",primaryButtonText:"Fortsett uten kamera",ariaLabel:"Gi kameratilgang"},MicrophoneSitePermissionsRequest:{primaryText:"Tillat at {appName} bruker mikrofonen",secondaryText:"Dette er for at deltakerne skal kunne høre deg.",linkText:"Trenger du hjelp? Få hjelp til feilsøking",primaryButtonText:"Fortsett uten mikrofon",ariaLabel:"Tillat mikrofontilgang"},CameraAndMicrophoneSitePermissionsCheck:{primaryText:"Ser etter tilgang til kamera og mikrofon",secondaryText:"Gi tilgang hvis du blir bedt om det. Dette er slik at deltakerne kan se og høre deg.",linkText:"Trenger du hjelp? Få hjelp til feilsøking",primaryButtonText:"Fortsett uten kamera og mikrofon",ariaLabel:"Ser etter tilgang til kamera og mikrofon. Gi tilgang hvis du blir bedt om det."},CameraSitePermissionsCheck:{primaryText:"Ser etter kameratilgang",secondaryText:"Gi tilgang hvis du blir bedt om det. Dette er slik at deltakerne kan se deg.",linkText:"Trenger du hjelp? Få hjelp til feilsøking",primaryButtonText:"Fortsett uten kamera",ariaLabel:"Ser etter kameratilgang. Gi tilgang hvis du blir bedt om det."},MicrophoneSitePermissionsCheck:{primaryText:"Ser etter mikrofontilgang",secondaryText:"Gi tilgang hvis du blir bedt om det. Dette er slik at deltakerne kan høre deg.",linkText:"Trenger du hjelp? Få hjelp til feilsøking",primaryButtonText:"Fortsett uten mikrofon",ariaLabel:"Ser etter mikrofontilgang. Gi tilgang hvis du blir bedt om det."},CameraAndMicrophoneSitePermissionsDenied:{primaryText:"Får ikke tilgang til kamera og mikrofon",secondaryText:"Klikk på låseikonet i adresselinjen for å gi mikrofontillatelser til denne nettsiden. En sideoppdatering kan være nødvendig.",primaryButtonText:"Fortsett uten kamera og mikrofon",linkText:"Trenger du hjelp? Få hjelp til feilsøking"},CameraAndMicrophoneSitePermissionsDeniedSafari:{primaryText:"Får ikke tilgang til kamera og mikrofon",secondaryText:"Oppdater siden for å tillate tillatelser, eller kontroller innstillingene for denne nettleseren og kontroller at tillatelser er aktivert for dette nettstedet.",primaryButtonText:"Fortsett uten kamera og mikrofon",linkText:"Trenger du hjelp? Få hjelp til feilsøking"},CameraSitePermissionsDenied:{primaryText:"Får ikke tilgang til kamera",secondaryText:"Klikk på låseikonet på adresselinjen for å gi kameratillatelser til denne nettsiden. En sideoppdatering kan være nødvendig.",primaryButtonText:"Fortsett uten kamera",linkText:"Trenger du hjelp? Få hjelp til feilsøking"},MicrophoneSitePermissionsDenied:{primaryText:"Får ikke tilgang til mikrofonen",secondaryText:"Klikk på låseikonet i adresselinjen for å gi mikrofontillatelser til denne nettsiden. En sideoppdatering kan være nødvendig.",primaryButtonText:"Fortsett uten mikrofon",linkText:"Trenger du hjelp? Få hjelp til feilsøking"},CameraSitePermissionsDeniedSafari:{primaryText:"Får ikke tilgang til kamera",secondaryText:"Oppdater siden for å tillate tillatelser, eller kontroller innstillingene for denne nettleseren og kontroller at tillatelser er aktivert for dette nettstedet.",primaryButtonText:"Fortsett uten kamera",linkText:"Trenger du hjelp? Få hjelp til feilsøking"},MicrophoneSitePermissionsDeniedSafari:{primaryText:"Får ikke tilgang til mikrofonen",secondaryText:"Oppdater siden for å tillate tillatelser, eller kontroller innstillingene for denne nettleseren og kontroller at tillatelser er aktivert for dette nettstedet.",primaryButtonText:"Fortsett uten mikrofon",linkText:"Trenger du hjelp? Få hjelp til feilsøking"},UnsupportedBrowser:{primaryText:"Nettleseren støttes ikke",secondaryText:"Bli med i denne samtalen ved hjelp av en kompatibel nettleser.",moreHelpLinkText:"Se kompatibilitetskrav"},UnsupportedBrowserVersion:{primaryText:"Nettleseroppdatering kreves",secondaryText:"Hvis du vil sikre best mulig samtale, må du oppdatere nettleseren og deretter prøve å bli med i samtalen på nytt.",moreHelpLinkText:"Se kompatibilitetskrav",continueAnywayButtonText:"Start anrop uten å oppdatere"},UnsupportedOperatingSystem:{primaryText:"Operativsystem støttes ikke",secondaryText:"Bli med i denne samtalen ved hjelp av en enhet med et kompatibelt operativsystem.",moreHelpLinkText:"Se kompatibilitetskrav"},BrowserPermissionDenied:{primaryText:"Kan ikke bruke kameraet eller mikrofonen",secondaryText:"Nettleseren har kanskje ikke tilgang til kameraet eller mikrofonen. Åpne Systemvalg for å løse dette problemet.",primaryButtonText:"Prøv på nytt",linkText:"Trenger du hjelp? Få hjelp til feilsøking"},BrowserPermissionDeniedIOS:{primaryText:"Gi mikrofontilgang for å fortsette",secondaryText:"Slik at andre deltakere kan høre deg.",primaryButtonText:"Prøv på nytt",imageAltText:"Plassering av mikrofon- og kameraenhetstillatelse for iOS",linkText:"Trenger du hjelp? Få hjelp til feilsøking",step1Text:"Gå til Innstillinger-appen",step2Text:"Rull ned til innstillinger for denne nettleseren",step3Text:"Slå på mikrofon (kamera valgfritt)",step4Text:"Prøv å bli med i samtalen på nytt",step1DigitText:"1",step2DigitText:"2",step3DigitText:"3",step4DigitText:"4"},verticalGallery:{leftNavButtonAriaLabel:"forrige side {current} av {total}",rightNavButtonAriaLabel:"neste side {current} av {total}"},meetingConferencePhoneInfo:{meetingConferencePhoneInfoModalTitle:"Bli med i samtalen fra telefonen",meetingConferencePhoneInfoModalDialIn:"Slå nummer",meetingConferencePhoneInfoModalMeetingId:"Skriv inn møte-ID",meetingConferencePhoneInfoModalWait:"Vent på å bli godtatt inn av arrangøren",meetingConferencePhoneInfoModalNoPhoneAvailable:"Ingen telefon tilgjengelig",meetingConferencePhoneInfoModalTollGeoData:"{city}, {country}",meetingConferencePhoneInfoModalTollFree:"(gratis)",meetingConferencePhoneInfoModalToll:"(nummer med avgift)"},IncomingCallNotification:{incomingCallNotificationPlaceholderId:"Ukjent bruker",incomingCallNotificationPlaceholderAlert:"{callerName} ringer",incomingCallNoticicationAcceptWithAudioAriaLabel:"Godta med lyd",incomingCallNoticicationAcceptWithVideoAriaLabel:"Godta med video",incomingCallNoticicationRejectAriaLabel:"Avvis",incomingCallNotificationAcceptButtonLabel:"Godta",incomingCallNotificationRejectButtonLabel:"Avslå",incomingCallNotificationAccceptWithVideoButtonLabel:"Svar med video",incomingCallNotificationDismissButtonAriaLabel:"Lukk"}})},SQt={strings:Jh({participantItem:{isMeText:"(jij)",menuTitle:"Meer opties",removeButtonLabel:"Verwijderen",sharingIconLabel:"Delen",mutedIconLabel:"Gedempt",handRaisedIconLabel:"Opgestoken hand - Positie {position}",displayNamePlaceholder:"Naamloze deelnemer",participantStateRinging:"Bellen...",participantStateHold:"In de wacht",participantItemAriaLabel:"{displayName}, {handRaisedState}, {mutedState}, {micDisabledState}, {cameraDisabledState}, {sharingState}, {connectionState}",participantItemWithMoreOptionsAriaLabel:"{displayName}, {handRaisedState}, {mutedState}, {micDisabledState}, {cameraDisabledState}, {sharingState}, {connectionState}, meer opties",attendeeRole:"Genodigde",micDisabledIconLabel:"Microfoon uitgeschakeld",cameraDisabledIconLabel:"Camera uitgeschakeld"},ParticipantList:{overflowParticipantCount:"+{overflowCount} meer"},typingIndicator:{singleUser:"{user} typt ...",multipleUsers:"{users} typen ...",multipleUsersAbbreviateOne:"{users} en 1 andere persoon typen ...",multipleUsersAbbreviateMany:"{users} en {numOthers} anderen typen ...",delimiter:", "},sendBox:{placeholderText:"Een bericht invoeren",textTooLong:"De lengte van uw bericht overschrijdt de maximumlimiet.",sendButtonAriaLabel:"Bericht verzenden",attachmentUploadsPendingError:"Bestand wordt geüpload, even geduld.",removeAttachment:"Bestand verwijderen",uploading:"Uploaden",uploadCompleted:"Upload voltooid",attachmentMoreMenu:"Meer opties"},richTextSendBox:{placeholderText:"Een bericht invoeren",textTooLong:"De lengte van uw bericht overschrijdt de maximumlimiet.",sendButtonAriaLabel:"Bericht verzenden",attachmentUploadsPendingError:"Bestand wordt geüpload, even geduld.",imageUploadsPendingError:"Afbeelding wordt geüpload, even geduld.",removeAttachment:"Bestand verwijderen",uploading:"Uploaden",uploadCompleted:"Upload voltooid",richTextBoldTooltip:"Vet",richTextItalicTooltip:"Cursief",richTextUnderlineTooltip:"Onderstrepen",richTextBulletListTooltip:"Lijst met opsommingstekens",richTextNumberListTooltip:"Genummerde lijst",richTextIncreaseIndentTooltip:"Inspringing vergroten",richTextDecreaseIndentTooltip:"Inspringing verkleinen",richTextInsertTableTooltip:"Tabel invoegen",richTextFormatButtonTooltip:"Indeling",richTextInsertRowOrColumnMenu:"Invoegen",richTextInsertTableMenuTitle:"{column} x {row} tabel invoegen",richTextInsertRowAboveMenu:"Hierboven invoegen",richTextInsertRowBelowMenu:"Hieronder invoegen",richTextInsertColumnLeftMenu:"Links invoegen",richTextInsertColumnRightMenu:"Rechts invoegen",richTextDeleteRowOrColumnMenu:"Verwijderen",richTextDeleteColumnMenu:"Kolom verwijderen",richTextDeleteRowMenu:"Rij verwijderen",richTextDeleteTableMenu:"Tabel verwijderen",richTextToolbarAriaLabel:"Werkbalk Berichtopmaak",richTextToolbarMoreButtonAriaLabel:"Meer opties",attachmentMoreMenu:"Meer opties",richTextNewBulletedListItemAnnouncement:"Opsommingsteken, nieuwe regel",richTextNewNumberedListItemAnnouncement:"{0}, nieuwe regel",richTextBulletedListAppliedAnnouncement:"Lijst met opsommingstekens toegepast",richTextNumberedListAppliedAnnouncement:"Genummerde lijst is toegepast"},realTimeTextModal:{realTimeTextModalAriaLabel:"RTT Modal inschakelen",realTimeTextModalTitle:"RTT inschakelen?",realTimeTextModalText:"Tekst in realtime (RTT) wordt ingeschakeld voor iedereen in de vergadering.",realTimeTextConfirmButtonLabel:"Inschakelen",realTimeTextCancelButtonLabel:"Annuleren",realTimeTextCloseModalButtonAriaLabel:"RTT Modaal sluiten"},captionsBanner:{captionsBannerSpinnerText:"Ondertitels starten...",realTimeTextInputBoxDefaultText:"Bericht in realtime typen",realTimeTextInputErrorMessage:"Het bericht mag niet langer zijn dan 2000 tekens",realTimeTextBannerTitle:"RTT",realTimeTextBannerContent:"RTT (realtime-tekst) is ingeschakeld voor alle deelnemers gedurende de hele duur van de vergadering.",realTimeTextBannerLinkLabel:"Meer informatie",captionsOnlyContainerTitle:"Ondertitels",realTimeTextOnlyContainerTitle:"Real-time tekst",captionsAndRealTimeTextContainerTitle:"Ondertitels en realtime tekst",expandButtonAriaLabel:"Uitvouwen",minimizeButtonAriaLabel:"Samenvouwen"},mentionPopover:{mentionPopoverHeader:"Suggesties"},imageOverlay:{downloadButtonLabel:"Downloaden",dismissButtonAriaLabel:"Sluiten",overlayVisibleMessage:"Overlay voor details afbeelding"},messageStatusIndicator:{deliveredAriaLabel:"Bericht verzonden",deliveredTooltipText:"Verzonden",seenAriaLabel:"Bericht gezien door anderen",seenTooltipText:"Gezien",readByTooltipText:"Gelezen door {messageThreadReadCount} van {remoteParticipantsCount}",sendingAriaLabel:"Bericht verzenden",sendingTooltipText:"Verzenden",failedToSendAriaLabel:"Het bericht is niet verzonden",failedToSendTooltipText:"Kan niet verzenden"},endCallButton:{label:"Verlaten",tooltipContent:"Gesprek verlaten",leaveOption:"Verlaten",endCallOption:"Oproep beëindigen voor iedereen"},cameraButton:{onLabel:"Camera",offLabel:"Camera",tooltipDisabledContent:"Camera is uitgeschakeld",tooltipOnContent:"Camera uitschakelen",tooltipOffContent:"Camera inschakelen",tooltipVideoLoadingContent:"Video wordt geladen",cameraMenuTitle:"Camera",cameraMenuTooltip:"Camera kiezen",cameraButtonSplitRoleDescription:"Knop Splitsen",onSplitButtonAriaLabel:"Camera uitschakelen",offSplitButtonAriaLabel:"Camera inschakelen",cameraActionTurnedOnAnnouncement:"Uw camera is ingeschakeld",cameraActionTurnedOffAnnouncement:"Uw camera is uitgeschakeld",onSplitButtonPrimaryActionCamera:"Camera uitschakelen",offSplitButtonPrimaryActionCamera:"Camera inschakelen",cameraPrimaryActionSplitButtonTitle:"Camera gebruiken",videoEffectsMenuItemTitle:"Effecten",cameraButtonAriaDescription:"camera-opties"},microphoneButton:{onLabel:"Microfoon",offLabel:"Microfoon",tooltipDisabledContent:"Microfoon is uitgeschakeld",tooltipOnContent:"Microfoon uitschakelen",tooltipOffContent:"Microfoon inschakelen",microphoneMenuTitle:"Microfoon",microphoneMenuTooltip:"Microfoon kiezen",speakerMenuTitle:"Luidspreker",speakerMenuTooltip:"Luidspreker kiezen",microphoneButtonSplitRoleDescription:"Knop Splitsen",onSplitButtonAriaLabel:"Microfoon dempen",offSplitButtonAriaLabel:"Dempen opheffen voor microfoon",microphoneActionTurnedOnAnnouncement:"Uw microfoon is ingeschakeld",microphoneActionTurnedOffAnnouncement:"Uw microfoon is uitgeschakeld",offSplitButtonMicrophonePrimaryAction:"Dempen opheffen voor microfoon",onSplitButtonMicrophonePrimaryAction:"Microfoon dempen",microphonePrimaryActionSplitButtonTitle:"Microfoon gebruiken",microphoneAriaDescription:"Audio-opties",deepNoiseSuppressionTitle:"Ruisonderdrukking",deepNoiseSuppressionOnAnnouncement:"Diepe ruisonderdrukking is ingeschakeld",deepNoiseSuppressionOffAnnouncement:"Diepe ruisonderdrukking is uitgeschakeld"},devicesButton:{label:"Apparaten",tooltipContent:"Apparaten beheren",cameraMenuTitle:"Camera",cameraMenuTooltip:"Camera kiezen",audioDeviceMenuTitle:"Audioapparaat",audioDeviceMenuTooltip:"Audioapparaat kiezen",microphoneMenuTitle:"Microfoon",microphoneMenuTooltip:"Microfoon kiezen",speakerMenuTitle:"Spreker",speakerMenuTooltip:"Luidspreker kiezen"},participantsButton:{label:"Personen",ariaLabel:"Personen",tooltipContent:"Deelnemers weergeven",menuHeader:"In dit gesprek",participantsListButtonLabel:"{numParticipants} personen",muteAllButtonLabel:"Alles dempen",copyInviteLinkButtonLabel:"Uitnodigingskoppeling kopiëren",copyInviteLinkActionedAriaLabel:"Uitnodigingskoppeling gekopieerd"},screenShareButton:{onLabel:"Presenteren stoppen",offLabel:"Presenteren",tooltipDisabledContent:"Presenteren is uitgeschakeld",tooltipOnContent:"Uw scherm presenteren",tooltipOffContent:"Uw scherm presenteren"},raiseHandButton:{offLabel:"Opsteken",onLabel:"Laten zakken",tooltipDisabledContent:"Actie Hand opsteken is uitgeschakeld",tooltipOnContent:"Hand laten zakken",tooltipOffContent:"Hand opsteken"},reactionButton:{label:"Reageren",ariaLabel:"Reageren",tooltipDisabledContent:"Reactieactie is uitgeschakeld",tooltipContent:"Verzend een reactie",likeReactionTooltipContent:"Vind ik leuk",heartReactionTooltipContent:"Hartje",laughReactionTooltipContent:"Lachen",applauseReactionTooltipContent:"Applaus",surprisedReactionTooltipContent:"Verrast"},realTimeText:{isTypingText:"RTT typen"},captionsSettingsModal:{captionsSettingsModalTitle:"Instellingen voor ondertitels",captionsSettingsSpokenLanguageDropdownLabel:"Gesproken taal",captionsSettingsCaptionLanguageDropdownLabel:"Taal van ondertitels",captionsSettingsSpokenLanguageDropdownInfoText:"Taal die iedereen in dit gesprek spreekt.",captionsSettingsCaptionLanguageDropdownInfoText:"Bijschriften worden weergegeven in deze taal.",captionsSettingsConfirmButtonLabel:"Bevestigen",captionsSettingsCancelButtonLabel:"Annuleren",captionsSettingsModalAriaLabel:"Bijschriften instellen modaal",captionsSettingsCloseModalButtonAriaLabel:"Instelling voor ondertiteling sluiten"},spokenLanguages:{"ar-ae":"Arabisch - Verenigde Arabische Emiraten","ar-sa":"Arabisch - Saudi-Arabië","da-dk":"Deens","de-de":"Duits - Duitsland","en-au":"Engels - Australië","en-ca":"Engels - Canada","en-gb":"Engels - Verenigd Koninkrijk","en-in":"Engels - India","en-nz":"Engels - Nieuw-Zeeland","en-us":"Engels - Verenigde Staten","es-es":"Spaans - Spanje (modern)","es-mx":"Spaans - Mexico","fi-fi":"Fins","fr-ca":"Frans - Canada","fr-fr":"Frans - Frankrijk","hi-in":"Hindi","it-it":"Italiaans - Italië","ja-jp":"Japans","ko-kr":"Koreaans","nb-no":"Noors (Bokmål)","nl-be":"Nederlands - België","nl-nl":"Nederlands - Nederland","pl-pl":"Pools","pt-br":"Portugees - Brazilië","ru-ru":"Russisch","sv-se":"Zweeds","zh-cn":"Chinees (Volksrepubliek China)","zh-hk":"Chinees - Hongkong SAR","cs-cz":"Tsjechisch","pt-pt":"Portugees - Portugal","tr-tr":"Turks","vi-vn":"Vietnamees","th-th":"Thai","he-il":"Hebreeuws","cy-gb":"Welsh","uk-ua":"Oekraïens","el-gr":"Grieks","hu-hu":"Hongaars","ro-ro":"Roemeens","sk-sk":"Slowaaks","zh-tw":"Chinees - Taiwan"},captionLanguages:{ar:"Arabisch",da:"Deens",de:"Duits",en:"Engels",es:"Spaans",fi:"Fins","fr-ca":"Frans - Canada",fr:"Frans - Frankrijk",hi:"Hindi",it:"Italiaans",ja:"Japans",ko:"Koreaans",nb:"Noors (Bokmål)",nl:"Nederlands",pl:"Pools",pt:"Portugees - Brazilië",ru:"Russisch",sv:"Zweeds","zh-Hans":"Chinees (vereenvoudigd)","zh-Hant":"Chinees (traditioneel)",cs:"Tsjechisch","pt-pt":"Portugees - Portugal",tr:"Turks",vi:"Vietnamees",th:"Thai",he:"Hebreeuws",cy:"Welsh",uk:"Oekraïens",el:"Grieks",hu:"Hongaars",ro:"Roemeens",sk:"Slowaaks"},startCaptionsButton:{onLabel:"Bijschriften inschakelen",offLabel:"Ondertitels uitschakelen",tooltipOnContent:"Ondertitels uitschakelen",tooltipOffContent:"Bijschriften inschakelen"},startRealTimeTextButton:{label:"RTT inschakelen voor dit gesprek",tooltipOffContent:"RTT inschakelen voor dit gesprek"},messageThread:{yesterday:"Gisteren",sunday:"Zondag",monday:"Maandag",tuesday:"Dinsdag",wednesday:"Woensdag",thursday:"Donderdag",friday:"Vrijdag",saturday:"Zaterdag",participantJoined:"neemt nu deel aan de chat.",participantLeft:"heeft de chat verlaten.",editMessage:"Bewerken",removeMessage:"Verwijderen",resendMessage:"Probeer opnieuw te verzenden",failToSendTag:"Verzenden mislukt",editedTag:"Bewerkt",liveAuthorIntro:"Bericht van {author}",editedMessageLiveAuthorIntro:"Bewerkt bericht van {author}",editedMessageLocalUserLiveAuthorIntro:"Bewerkt bericht",messageContentAriaText:"{status} {author} zei {message}",messageContentMineAriaText:"{status} U zei {message}",editBoxTextLimit:"Uw bericht heeft de limiet van {limitNumber} tekens overschreden",editBoxPlaceholderText:"Uw bericht bewerken",newMessagesIndicator:"Nieuwe berichten",noDisplayNameSub:"Geen naam",editBoxCancelButton:"Annuleren",editBoxSubmitButton:"Gereed",messageReadCount:"Gelezen door {messageReadByCount} van {remoteParticipantsCount}",actionMenuMoreOptions:"Meer opties",downloadAttachment:"Bestand downloaden",openAttachment:"Bestand openen",blockedWarningText:"Dit bericht is verwijderd vanwege organisatiebeleid.",blockedWarningLinkText:"Details",attachmentCardGroupMessage:"Het bericht heeft {attachmentCount} bijlage",messageDeletedAnnouncementAriaLabel:"Het bericht is verwijderd",richTextBoldTooltip:"Vet",richTextItalicTooltip:"Cursief",richTextUnderlineTooltip:"Onderstrepen",richTextBulletListTooltip:"Lijst met opsommingstekens",richTextNumberListTooltip:"Genummerde lijst",richTextIncreaseIndentTooltip:"Inspringing vergroten",richTextDecreaseIndentTooltip:"Inspringing verkleinen",richTextInsertTableTooltip:"Tabel invoegen",richTextFormatButtonTooltip:"Indeling",richTextInsertRowOrColumnMenu:"Invoegen",richTextInsertTableMenuTitle:"{column} x {row} tabel invoegen",richTextInsertRowAboveMenu:"Hierboven invoegen",richTextInsertRowBelowMenu:"Hieronder invoegen",richTextInsertColumnLeftMenu:"Links invoegen",richTextInsertColumnRightMenu:"Rechts invoegen",richTextDeleteRowOrColumnMenu:"Verwijderen",richTextDeleteColumnMenu:"Kolom verwijderen",richTextDeleteRowMenu:"Rij verwijderen",richTextDeleteTableMenu:"Tabel verwijderen",richTextToolbarMoreButtonAriaLabel:"Meer opties",attachmentUploadsPendingError:"Bestand wordt geüpload, even geduld.",imageUploadsPendingError:"Afbeelding wordt geüpload, even geduld.",richTextNewBulletedListItemAnnouncement:"Opsommingsteken, nieuwe regel",richTextNewNumberedListItemAnnouncement:"{0}, nieuwe regel",richTextBulletedListAppliedAnnouncement:"Lijst met opsommingstekens toegepast",richTextNumberedListAppliedAnnouncement:"Genummerde lijst is toegepast"},errorBar:{unableToReachChatService:"U bent offline",accessDenied:"Kan geen toegang krijgen tot chatservices. Controleer de opgegeven gebruikersreferenties",userNotInChatThread:"U bent niet meer aanwezig in deze chatthread",sendMessageNotInChatThread:"Verzenden van bericht is mislukt omdat u zich niet meer in deze chatthread bevindt",sendMessageGeneric:"Kan bericht niet verzenden",callingNetworkFailure:"Er zijn problemen met het verbinden van een gesprek - Het lijkt erop dat u offline bent",startVideoGeneric:"Kan video niet starten",stopVideoGeneric:"Kan video niet stoppen",muteGeneric:"Kan microfoon niet dempen",unmuteGeneric:"Kan dempen van microfoon niet opheffen",speakingWhileMuted:"De microfoon is gedempt",startScreenShareGeneric:"Er is een probleem opgetreden bij het starten van scherm delen.",stopScreenShareGeneric:"Kan scherm delen niet stoppen",callNetworkQualityLow:"De netwerkkwaliteit is laag.",teamsMeetingCallNetworkQualityLow:"De netwerkkwaliteit is laag.",callNoSpeakerFound:"Geen luidsprekers of hoofdtelefoon gevonden. Sluit een audioapparaat aan om het gesprek te beluisteren.",callNoMicrophoneFound:"Geen microfoons gevonden. Sluit een audio-invoerapparaat aan.",callMicrophoneAccessDenied:"Kan geen toegang krijgen tot de microfoon. Klik op de vergrendeling in de adresbalk om toestemming te verlenen aan deze webpagina.",callMicrophoneAccessDeniedSafari:"Kan geen toegang krijgen tot de microfoon. Vernieuw de pagina om machtigingen toe te staan of controleer de instellingen van deze browser en controleer of machtigingen zijn ingeschakeld voor deze website.",callMicrophoneMutedBySystem:"U bent gedempt door jouw systeem.",callMicrophoneUnmutedBySystem:"De microfoon is hersteld en het dempen van de microfoon is door het systeem opgeheven.",callMacOsMicrophoneAccessDenied:"Kan geen toegang krijgen tot de microfoon. Verleen microfoonmachtiging in de privacyinstellingen voor macOS.",callLocalVideoFreeze:"De netwerkbandbreedte is slecht. Je video wordt mogelijk onderbroken weergegeven voor anderen in het gesprek.",callCameraAccessDenied:"Kan geen toegang krijgen tot de camera. Klik op de vergrendeling in de adresbalk om toestemming te verlenen aan deze webpagina.",callCameraAccessDeniedSafari:"Kan geen toegang krijgen tot de camera. Vernieuw de pagina om machtigingen toe te staan of controleer de instellingen van deze browser en controleer of machtigingen zijn ingeschakeld voor deze website.",callCameraAlreadyInUse:"Kan geen toegang krijgen tot de camera. Het wordt mogelijk al gebruikt door een andere toepassing.",callVideoStoppedBySystem:"Uw video is gestopt door uw systeem.",callVideoRecoveredBySystem:"Uw video is hervat.",callMacOsCameraAccessDenied:"MacOS blokkeert de toegang tot jouw camera. Werk je privacyinstellingen bij, zodat deze browser toegang heeft tot jouw camera.",callMacOsScreenShareAccessDenied:"MacOS blokkeert scherm delen. Werk je privacyinstellingen bij, zodat deze browser jouw scherm kan opnemen.",dismissButtonAriaLabel:"Sluiten",failedToJoinCallGeneric:"Deelnemen aan gesprek mislukt.",failedToJoinCallInvalidMeetingLink:"Kan niet deelnemen aan vergadering. Ongeldige koppeling.",cameraFrozenForRemoteParticipants:"Gebruikers in het gesprek ondervinden problemen bij het zien van uw video. Controleer uw apparaten en netwerk.",unableToStartVideoEffect:"Kan video-effect niet toepassen.",startSpotlightWhileMaxParticipantsAreSpotlighted:"Kan de deelnemer(s) niet in de spotlight plaatsen omdat het maximum aantal deelnemers in de spotlight is bereikt.",mutedByRemoteParticipant:"U bent gedempt door een andere deelnemer."},notificationStack:{callingNetworkFailure:{title:"Er is geen verbinding gemaakt met het gesprek",message:"U lijkt offline te zijn. Controleer de netwerkverbinding en probeer het opnieuw.",dismissButtonAriaLabel:"Sluiten"},startVideoGeneric:{title:"De video is niet gestart.",dismissButtonAriaLabel:"Sluiten"},stopVideoGeneric:{title:"De video is niet gestopt.",dismissButtonAriaLabel:"Sluiten"},muteGeneric:{title:"De microfoon is niet gedempt.",dismissButtonAriaLabel:"Sluiten"},unmuteGeneric:{title:"Het dempen van de microfoon is niet opgeheven.",dismissButtonAriaLabel:"Sluiten"},speakingWhileMuted:{title:"Uw microfoon is gedempt.",dismissButtonAriaLabel:"Sluiten"},startScreenShareGeneric:{title:"Er is een probleem opgetreden bij het starten van scherm delen.",dismissButtonAriaLabel:"Sluiten"},stopScreenShareGeneric:{title:"Kan scherm delen niet stoppen.",dismissButtonAriaLabel:"Sluiten"},callNetworkQualityLow:{title:"De netwerkkwaliteit is laag.",dismissButtonAriaLabel:"Sluiten"},teamsMeetingCallNetworkQualityLow:{title:"De netwerkkwaliteit is laag.",dismissButtonAriaLabel:"Sluiten",message:"Neem deel aan dit gesprek vanaf uw telefoon voor een beter geluid. U kunt doorgaan met het weergeven van de vergadering op dit apparaat.",primaryButtonLabel:"Deelnemen via telefoon"},callNoSpeakerFound:{title:"Geen luidsprekers of hoofdtelefoon gevonden",message:"Sluit een audioapparaat aan om het gesprek te beluisteren.",dismissButtonAriaLabel:"Sluiten"},callNoMicrophoneFound:{title:"Geen microfoons gevonden",message:"Sluit een audio-invoerapparaat aan.",dismissButtonAriaLabel:"Sluiten"},callMicrophoneAccessDenied:{title:"Geen toegang tot microfoon",message:"Klik op de vergrendeling in de adresbalk om toestemming te verlenen aan deze webpagina.",dismissButtonAriaLabel:"Sluiten"},callMicrophoneAccessDeniedSafari:{title:"Geen toegang tot microfoon",message:"Vernieuw de pagina om machtigingen toe te staan of controleer de instellingen van deze browser en controleer of machtigingen zijn ingeschakeld voor deze website.",dismissButtonAriaLabel:"Sluiten"},callMicrophoneMutedBySystem:{title:"U bent gedempt door jouw systeem.",dismissButtonAriaLabel:"Sluiten"},callMicrophoneUnmutedBySystem:{title:"De microfoon is hersteld en het dempen van de microfoon is door het systeem opgeheven.",dismissButtonAriaLabel:"Sluiten"},callMacOsMicrophoneAccessDenied:{title:"Geen toegang tot microfoon",message:"Verleen microfoonmachtiging in de privacyinstellingen voor macOS.",dismissButtonAriaLabel:"Sluiten"},callLocalVideoFreeze:{title:"De netwerkbandbreedte is slecht",message:"Uw video wordt mogelijk onderbroken weergegeven voor anderen in het gesprek.",dismissButtonAriaLabel:"Sluiten"},callCameraAccessDenied:{title:"Geen toegang tot camera",message:"Klik op de vergrendeling in de adresbalk om toestemming te verlenen aan deze webpagina.",dismissButtonAriaLabel:"Sluiten"},callCameraAccessDeniedSafari:{title:"Geen toegang tot camera",message:"Vernieuw de pagina om machtigingen toe te staan of controleer de instellingen van deze browser en controleer of machtigingen zijn ingeschakeld voor deze website.",dismissButtonAriaLabel:"Sluiten"},callCameraAlreadyInUse:{title:"Geen toegang tot camera",message:"Het wordt mogelijk al gebruikt door een andere toepassing.",dismissButtonAriaLabel:"Sluiten"},callVideoStoppedBySystem:{title:"Uw video is gestopt door uw systeem.",dismissButtonAriaLabel:"Sluiten"},callVideoRecoveredBySystem:{title:"Uw video is hervat.",dismissButtonAriaLabel:"Sluiten"},callMacOsCameraAccessDenied:{title:"MacOS blokkeert de toegang tot uw camera",message:"Werk uw privacyinstellingen bij zodat deze browser toegang heeft tot uw camera.",dismissButtonAriaLabel:"Sluiten"},callMacOsScreenShareAccessDenied:{title:"Scherm delen wordt geblokkeerd door macOS",message:"Werk uw privacyinstellingen bij zodat deze browser uw scherm kan opnemen.",dismissButtonAriaLabel:"Sluiten"},failedToJoinCallGeneric:{title:"Deelnemen aan gesprek mislukt.",dismissButtonAriaLabel:"Sluiten"},failedToJoinCallInvalidMeetingLink:{title:"Kan niet deelnemen aan vergadering. Ongeldige koppeling.",dismissButtonAriaLabel:"Sluiten"},cameraFrozenForRemoteParticipants:{title:"Gebruikers in het gesprek ondervinden problemen bij het zien van uw video",message:"Controleer uw apparaten en netwerk.",dismissButtonAriaLabel:"Sluiten"},unableToStartVideoEffect:{title:"Kan video-effect niet toepassen.",dismissButtonAriaLabel:"Sluiten"},startSpotlightWhileMaxParticipantsAreSpotlighted:{title:"Kan spotlight niet starten op deelnemer(s)",message:"Het maximum aantal deelnemers is al gespotlight.",dismissButtonAriaLabel:"Sluiten"},mutedByRemoteParticipant:{title:"U bent gedempt door een andere deelnemer.",dismissButtonAriaLabel:"Sluiten"},recordingStarted:{title:"Opname is gestart.",message:"Door deel te nemen, geeft u toestemming voor het transcriberen van deze vergadering.",dismissButtonAriaLabel:"Sluiten"},transcriptionStarted:{title:"Transcriptie is gestart.",message:"Door deel te nemen, geeft u toestemming voor het transcriberen van deze vergadering.",dismissButtonAriaLabel:"Sluiten"},recordingStopped:{title:"De opname wordt opgeslagen.",message:"Opname is gestopt.",dismissButtonAriaLabel:"Sluiten"},transcriptionStopped:{title:"Transcriptie wordt opgeslagen.",message:"Transcriptie is gestopt.",dismissButtonAriaLabel:"Sluiten"},recordingAndTranscriptionStarted:{title:"Opname en transcriptie zijn gestart.",message:"Door deel te nemen, geeft u toestemming voor het transcriberen van deze vergadering.",dismissButtonAriaLabel:"Sluiten"},recordingAndTranscriptionStopped:{title:"Opname en transcriptie worden opgeslagen.",message:"Opname en transcriptie zijn gestopt.",dismissButtonAriaLabel:"Sluiten"},recordingStoppedStillTranscribing:{title:"Opname is gestopt.",message:"U bent nu alleen deze vergadering aan het transcriberen.",dismissButtonAriaLabel:"Sluiten"},transcriptionStoppedStillRecording:{title:"Transcriptie is gestopt.",message:"U bent nu alleen deze vergadering aan het opnemen.",dismissButtonAriaLabel:"Sluiten"},assignedBreakoutRoomOpened:{title:"U wordt over 5 seconden naar de toegewezen ruimte verplaatst.",dismissButtonAriaLabel:"Sluiten"},assignedBreakoutRoomChanged:{title:"Uw aparte vergaderruimte is gewijzigd",message:"U wordt over 5 seconden naar de toegewezen ruimte verplaatst.",dismissButtonAriaLabel:"Sluiten"},assignedBreakoutRoomClosed:{title:"Je aparte vergaderruimte is gesloten",message:"U wordt over 5 seconden terug naar de vergadering verplaatst.",dismissButtonAriaLabel:"Sluiten"},assignedBreakoutRoomOpenedPromptJoin:{title:"Deelnemen aan aparte vergaderruimte?",message:"U bent toegewezen aan een aparte vergaderruimte.",dismissButtonAriaLabel:"Sluiten",primaryButtonLabel:"Naar vergaderruimte",secondaryButtonLabel:"Later"},breakoutRoomJoined:{title:"U heeft deelgenomen aan een vergaderruimte.",dismissButtonAriaLabel:"Sluiten"},breakoutRoomClosingSoon:{title:"De tijdslimiet voor de ruimte verloopt binnenkort.",message:"Deze ruimte wordt in 30 seconden gesloten.",dismissButtonAriaLabel:"Sluiten"},capabilityTurnVideoOnPresent:{title:"Uw camera is ingeschakeld",message:"Schakel deze in als u video wilt delen.",dismissButtonAriaLabel:"Sluiten"},capabilityTurnVideoOnAbsent:{title:"Uw camera is uitgeschakeld",message:"U kunt geen video meer delen.",dismissButtonAriaLabel:"Sluiten"},capabilityUnmuteMicPresent:{title:"Uw microfoon is ingeschakeld",message:"Dempen opheffen als u wilt spreken.",dismissButtonAriaLabel:"Sluiten"},capabilityUnmuteMicAbsent:{title:"Uw microfoon is uitgeschakeld",message:"U kunt het dempen niet meer opheffen.",dismissButtonAriaLabel:"Sluiten"},togetherModeStarted:{title:"Togethermode is gestart",dismissButtonAriaLabel:"Sluiten"},togetherModeEnded:{title:"Togethermode is beëindigd",dismissButtonAriaLabel:"Sluiten"}},videoGallery:{screenIsBeingSharedMessage:"U deelt uw scherm",screenShareLoadingMessage:"Scherm van {participant} laden",localScreenShareLoadingMessage:"Uw scherm laden",localVideoLabel:"U",localVideoCameraSwitcherLabel:"Camera wisselen",localVideoMovementLabel:"Tegel voor verwisselbare lokale video",localVideoMovementAriaLabel:"Tegel voor verwisselbare lokale video",localVideoSelectedDescription:"{cameraName} geselecteerd",displayNamePlaceholder:"Naamloze deelnemer",fitRemoteParticipantToFrame:"Aanpassen aan frame",fillRemoteParticipantFrame:"Frame vullen",pinParticipantForMe:"Voor mij vastmaken",pinParticipantForMeLimitReached:"Pin (limiet bereikt)",unpinParticipantForMe:"Losmaken",pinParticipantMenuItemAriaLabel:"{participantName} vastmaken",unpinParticipantMenuItemAriaLabel:"{participantName} losmaken",pinnedParticipantAnnouncementAriaLabel:"{participantName} vastgemaakt",unpinnedParticipantAnnouncementAriaLabel:"{participantName} losgemaakt",startSpotlightVideoTileMenuLabel:"Spotlight voor iedereen",addSpotlightVideoTileMenuLabel:"Spotlight toevoegen",spotlightLimitReachedMenuTitle:"Spotlightlimiet bereikt",stopSpotlightVideoTileMenuLabel:"Spotlighten stoppen",stopSpotlightOnSelfVideoTileMenuLabel:"Spotlight afsluiten",attendeeRole:"Genodigde",muteParticipantMenuItemLabel:"Dempen",waitingScreenText:"Wachten tot anderen deelnemen",forbidAudio:"Microfoon uitschakelen",permitAudio:"Microfoon toestaan",forbidAudioTileMenuLabel:"Microfoon uitschakelen",permitAudioTileMenuLabel:"Microfoon toestaan",forbidVideo:"Camera uitschakelen",permitVideo:"Camera toestaan",forbidVideoTileMenuLabel:"Camera uitschakelen",permitVideoTileMenuLabel:"Camera toestaan"},dialpad:{placeholderText:"Telefoonnummer invoeren",deleteButtonAriaLabel:"Verwijderen"},holdButton:{onLabel:"Hervatten",offLabel:"Pauze",tooltipOnContent:"Gesprek hervatten",tooltipOffContent:"Gesprek in wachtrij plaatsen"},videoTile:{participantStateRinging:"Bellen...",participantReconnecting:"Opnieuw verbinding maken...",participantStateHold:"In de wacht",moreOptionsButtonAriaLabel:"Meer opties {displayName} {isMuted} {micDisabledState} {cameraDisabledState} {isHandRaised} {state} {isSpeaking}",moreOptionsParticipantMutedStateMutedAriaLabel:"gedempt",moreOptionsParticipantMutedStateUnmutedAriaLabel:"niet gedempt",moreOptionsParticipantHandRaisedAriaLabel:"Opgestoken hand",moreOptionsParticipantIsSpeakingAriaLabel:"Spreken",moreOptionsParticipantMicDisabledAriaLabel:"Microfoon uitgeschakeld",moreOptionsParticipantCameraDisabledAriaLabel:"Camera uitgeschakeld"},CameraAndMicrophoneSitePermissionsRequest:{primaryText:"Toestaan dat {appName} uw camera en microfoon gebruikt",secondaryText:"Dit is zodat deelnemers u kunnen zien en horen.",linkText:"Hulp nodig? Hulp bij probleemoplossing",primaryButtonText:"Doorgaan zonder camera en microfoon",ariaLabel:"Toegang tot camera en microfoon toestaan"},CameraSitePermissionsRequest:{primaryText:"{appName} toestaan om uw camera te gebruiken",secondaryText:"Dit is zodat deelnemers u kunnen zien.",linkText:"Hulp nodig? Hulp bij probleemoplossing",primaryButtonText:"Doorgaan zonder camera",ariaLabel:"Cameratoegang toestaan"},MicrophoneSitePermissionsRequest:{primaryText:"{appName} toestaan om uw microfoon te gebruiken",secondaryText:"Dit is zodat deelnemers u kunnen horen.",linkText:"Hulp nodig? Hulp bij probleemoplossing",primaryButtonText:"Doorgaan zonder microfoon",ariaLabel:"Microfoontoegang toestaan"},CameraAndMicrophoneSitePermissionsCheck:{primaryText:"Controleren op toegang tot camera en microfoon",secondaryText:"Toegang toestaan als hierom wordt gevraagd. Dit is zodat deelnemers u kunnen zien en horen.",linkText:"Hulp nodig? Hulp bij probleemoplossing",primaryButtonText:"Doorgaan zonder camera en microfoon",ariaLabel:"Controleren op toegang tot camera en microfoon. Toegang toestaan als hierom wordt gevraagd."},CameraSitePermissionsCheck:{primaryText:"Controleren op cameratoegang",secondaryText:"Toegang toestaan als hierom wordt gevraagd. Dit is zodat deelnemers u kunnen zien.",linkText:"Hulp nodig? Hulp bij probleemoplossing",primaryButtonText:"Doorgaan zonder camera",ariaLabel:"Controleren op cameratoegang. Toegang toestaan als hierom wordt gevraagd."},MicrophoneSitePermissionsCheck:{primaryText:"Controleren op toegang tot microfoon",secondaryText:"Toegang toestaan als hierom wordt gevraagd. Dit is zodat deelnemers u kunnen horen.",linkText:"Hulp nodig? Hulp bij probleemoplossing",primaryButtonText:"Doorgaan zonder microfoon",ariaLabel:"Controleren op toegang tot microfoon. Toegang toestaan als hierom wordt gevraagd."},CameraAndMicrophoneSitePermissionsDenied:{primaryText:"Geen toegang tot camera en microfoon",secondaryText:"Klik op het vergrendelingspictogram op de adresbalk om microfoonmachtigingen toe te kennen aan deze webpagina. Mogelijk is een paginavernieuwing vereist.",primaryButtonText:"Doorgaan zonder camera en microfoon",linkText:"Hulp nodig? Hulp bij probleemoplossing"},CameraAndMicrophoneSitePermissionsDeniedSafari:{primaryText:"Geen toegang tot camera en microfoon",secondaryText:"Vernieuw de pagina om machtigingen toe te staan of controleer de instellingen van deze browser en controleer of machtigingen zijn ingeschakeld voor deze website.",primaryButtonText:"Doorgaan zonder camera en microfoon",linkText:"Hulp nodig? Hulp bij probleemoplossing"},CameraSitePermissionsDenied:{primaryText:"Geen toegang tot camera",secondaryText:"Klik op het vergrendelingspictogram op de adresbalk om cameramachtigingen toe te kennen aan deze webpagina. Mogelijk is een paginavernieuwing vereist.",primaryButtonText:"Doorgaan zonder camera",linkText:"Hulp nodig? Hulp bij probleemoplossing"},MicrophoneSitePermissionsDenied:{primaryText:"Geen toegang tot microfoon",secondaryText:"Klik op het vergrendelingspictogram op de adresbalk om microfoonmachtigingen toe te kennen aan deze webpagina. Mogelijk is een paginavernieuwing vereist.",primaryButtonText:"Doorgaan zonder microfoon",linkText:"Hulp nodig? Hulp bij probleemoplossing"},CameraSitePermissionsDeniedSafari:{primaryText:"Geen toegang tot camera",secondaryText:"Vernieuw de pagina om machtigingen toe te staan of controleer de instellingen van deze browser en controleer of machtigingen zijn ingeschakeld voor deze website.",primaryButtonText:"Doorgaan zonder camera",linkText:"Hulp nodig? Hulp bij probleemoplossing"},MicrophoneSitePermissionsDeniedSafari:{primaryText:"Geen toegang tot microfoon",secondaryText:"Vernieuw de pagina om machtigingen toe te staan of controleer de instellingen van deze browser en controleer of machtigingen zijn ingeschakeld voor deze website.",primaryButtonText:"Doorgaan zonder microfoon",linkText:"Hulp nodig? Hulp bij probleemoplossing"},UnsupportedBrowser:{primaryText:"Browser wordt niet ondersteund",secondaryText:"Neem deel aan dit gesprek via een compatibele browser.",moreHelpLinkText:"Compatibiliteitsvereisten bekijken"},UnsupportedBrowserVersion:{primaryText:"Browserupdate vereist",secondaryText:"Werk uw browser bij en probeer opnieuw deel te nemen aan het gesprek om ervoor te zorgen dat u het beste kunt bellen.",moreHelpLinkText:"Compatibiliteitsvereisten bekijken",continueAnywayButtonText:"Oproep starten zonder bij te werken"},UnsupportedOperatingSystem:{primaryText:"Besturingssysteem niet ondersteund",secondaryText:"Neem deel aan dit gesprek via een apparaat met een compatibel besturingssysteem.",moreHelpLinkText:"Compatibiliteitsvereisten bekijken"},BrowserPermissionDenied:{primaryText:"Kan uw camera of microfoon niet gebruiken",secondaryText:"Uw browser heeft mogelijk geen toegang tot uw camera of microfoon. Open Systeemvoorkeuren om dit op te lossen.",primaryButtonText:"Opnieuw proberen",linkText:"Hulp nodig? Hulp bij probleemoplossing"},BrowserPermissionDeniedIOS:{primaryText:"Microfoontoegang toestaan om door te gaan",secondaryText:"Zodat andere deelnemers u kunnen horen.",primaryButtonText:"Opnieuw proberen",imageAltText:"Machtigingslocatie voor microfoon en cameraapparaat voor iOS",linkText:"Hulp nodig? Hulp bij probleemoplossing",step1Text:"Ga naar de app Instellingen",step2Text:"Schuif omlaag naar instellingen voor deze browser",step3Text:"Microfoon inschakelen (camera optioneel)",step4Text:"Probeer opnieuw deel te nemen aan het gesprek",step1DigitText:"1",step2DigitText:"2",step3DigitText:"3",step4DigitText:"4"},verticalGallery:{leftNavButtonAriaLabel:"vorige pagina {current} van {total}",rightNavButtonAriaLabel:"volgende pagina {current} van {total}"},meetingConferencePhoneInfo:{meetingConferencePhoneInfoModalTitle:"Deelnemen aan gesprek vanaf uw telefoon",meetingConferencePhoneInfoModalDialIn:"Kiesnummer",meetingConferencePhoneInfoModalMeetingId:"Vergadering-id invoeren",meetingConferencePhoneInfoModalWait:"Wachten om toegelaten te worden door organisator",meetingConferencePhoneInfoModalNoPhoneAvailable:"Geen telefoon beschikbaar",meetingConferencePhoneInfoModalTollGeoData:"{country}, {city}",meetingConferencePhoneInfoModalTollFree:"(Gratis)",meetingConferencePhoneInfoModalToll:"(niet-gratis)"},IncomingCallNotification:{incomingCallNotificationPlaceholderId:"Onbekende gebruiker",incomingCallNotificationPlaceholderAlert:"{callerName} belt",incomingCallNoticicationAcceptWithAudioAriaLabel:"Accepteren met geluid",incomingCallNoticicationAcceptWithVideoAriaLabel:"Accepteren met video",incomingCallNoticicationRejectAriaLabel:"Weigeren",incomingCallNotificationAcceptButtonLabel:"Accepteren",incomingCallNotificationRejectButtonLabel:"Weigeren",incomingCallNotificationAccceptWithVideoButtonLabel:"Accepteren met video",incomingCallNotificationDismissButtonAriaLabel:"Sluiten"}})},bQt={strings:Jh({participantItem:{isMeText:"(Ty)",menuTitle:"Więcej opcji",removeButtonLabel:"Usuń",sharingIconLabel:"Udostępnianie",mutedIconLabel:"Wyciszono",handRaisedIconLabel:"Podniesiona ręka — położenie {position}",displayNamePlaceholder:"Uczestnik bez nazwy",participantStateRinging:"Trwa łączenie…",participantStateHold:"Zawieszony",participantItemAriaLabel:"{displayName}, {handRaisedState}, {mutedState}, {micDisabledState}, {cameraDisabledState}, {sharingState}, {connectionState}",participantItemWithMoreOptionsAriaLabel:"{displayName}, {handRaisedState}, {mutedState}, {micDisabledState}, {cameraDisabledState}, {sharingState}, {connectionState}, więcej opcji",attendeeRole:"Uczestnik",micDisabledIconLabel:"Mikrofon jest wyłączony",cameraDisabledIconLabel:"Kamera wyłączona"},ParticipantList:{overflowParticipantCount:"+{overflowCount} więcej"},typingIndicator:{singleUser:"Użytkownik {user} pisze...",multipleUsers:"{users} piszą...",multipleUsersAbbreviateOne:"{users} i 1 inny użytkownik piszą...",multipleUsersAbbreviateMany:"{users} i {numOthers} innych użytkowników piszą...",delimiter:", "},sendBox:{placeholderText:"Wprowadź wiadomość",textTooLong:"Długość wiadomości przekracza maksymalny limit.",sendButtonAriaLabel:"Wyślij wiadomość",attachmentUploadsPendingError:"Trwa przekazywanie pliku. Czekaj.",removeAttachment:"Usuń plik",uploading:"Przekazywanie",uploadCompleted:"Zakończono przekazywanie",attachmentMoreMenu:"Więcej opcji"},richTextSendBox:{placeholderText:"Wprowadź wiadomość",textTooLong:"Długość wiadomości przekracza maksymalny limit.",sendButtonAriaLabel:"Wyślij wiadomość",attachmentUploadsPendingError:"Trwa przekazywanie pliku. Czekaj.",imageUploadsPendingError:"Trwa przekazywanie obrazu. Czekaj.",removeAttachment:"Usuwanie pliku",uploading:"Przekazywanie",uploadCompleted:"Zakończono przekazywanie",richTextBoldTooltip:"Pogrubienie",richTextItalicTooltip:"Kursywa",richTextUnderlineTooltip:"Podkreślenie",richTextBulletListTooltip:"Lista punktowana",richTextNumberListTooltip:"Lista numerowana",richTextIncreaseIndentTooltip:"Zwiększ wcięcie",richTextDecreaseIndentTooltip:"Zmniejsz wcięcie",richTextInsertTableTooltip:"Wstaw tabelę",richTextFormatButtonTooltip:"Formatowanie",richTextInsertRowOrColumnMenu:"Wstaw",richTextInsertTableMenuTitle:"Wstaw tabelę {column} x {row}",richTextInsertRowAboveMenu:"Wstaw powyżej",richTextInsertRowBelowMenu:"Wstaw poniżej",richTextInsertColumnLeftMenu:"Wstaw z lewej",richTextInsertColumnRightMenu:"Wstaw z prawej",richTextDeleteRowOrColumnMenu:"Usuń",richTextDeleteColumnMenu:"Usuń kolumnę",richTextDeleteRowMenu:"Usuń wiersz",richTextDeleteTableMenu:"Usuń tabelę",richTextToolbarAriaLabel:"Pasek narzędzi formatowania wiadomości",richTextToolbarMoreButtonAriaLabel:"Więcej opcji",attachmentMoreMenu:"Więcej opcji",richTextNewBulletedListItemAnnouncement:"Punktor, nowy wiersz",richTextNewNumberedListItemAnnouncement:"{0}, nowy wiersz",richTextBulletedListAppliedAnnouncement:"Zastosowano listę punktowaną",richTextNumberedListAppliedAnnouncement:"Zastosowano listę numerowaną"},realTimeTextModal:{realTimeTextModalAriaLabel:"Włącz modalne okno dialogowe pisania w czasie rzeczywistym",realTimeTextModalTitle:"Włączyć pisanie w czasie rzeczywistym?",realTimeTextModalText:"Tekst w czasie rzeczywistym zostanie włączony dla wszystkich uczestników spotkania.",realTimeTextConfirmButtonLabel:"Włącz",realTimeTextCancelButtonLabel:"Anuluj",realTimeTextCloseModalButtonAriaLabel:"Zamknij modalne okno dialogowe pisania w czasie rzeczywistym"},captionsBanner:{captionsBannerSpinnerText:"Trwa uruchamianie napisów...",realTimeTextInputBoxDefaultText:"Pisz wiadomości w czasie rzeczywistym",realTimeTextInputErrorMessage:"Wiadomość nie może przekraczać 2000 znaków",realTimeTextBannerTitle:"Pisanie w czasie rzeczywistym",realTimeTextBannerContent:"Funkcja RTT (tekst w czasie rzeczywistym) jest włączona dla wszystkich uczestników przez cały czas trwania spotkania.",realTimeTextBannerLinkLabel:"Dowiedz się więcej",captionsOnlyContainerTitle:"Napisy",realTimeTextOnlyContainerTitle:"Pisanie w czasie rzeczywistym",captionsAndRealTimeTextContainerTitle:"Napisy i pisanie w czasie rzeczywistym",expandButtonAriaLabel:"Rozwiń",minimizeButtonAriaLabel:"Zwiń"},mentionPopover:{mentionPopoverHeader:"Sugestie"},imageOverlay:{downloadButtonLabel:"Pobierz",dismissButtonAriaLabel:"Zamknij",overlayVisibleMessage:"Nakładka szczegółów obrazu"},messageStatusIndicator:{deliveredAriaLabel:"Wiadomość została wysłana",deliveredTooltipText:"Wysłano",seenAriaLabel:"Wiadomość widziana przez inne osoby",seenTooltipText:"Wyświetlono",readByTooltipText:"Przeczytane przez {messageThreadReadCount} z {remoteParticipantsCount}",sendingAriaLabel:"Wysyłanie wiadomości",sendingTooltipText:"Wysyłanie",failedToSendAriaLabel:"Nie udało się wysłać wiadomości",failedToSendTooltipText:"Nie udało się wysłać"},endCallButton:{label:"Wyjdź",tooltipContent:"Opuść rozmowę",leaveOption:"Opuść",endCallOption:"Zakończ rozmowę dla wszystkich użytkowników"},cameraButton:{onLabel:"Kamera",offLabel:"Kamera",tooltipDisabledContent:"Kamera jest wyłączona",tooltipOnContent:"Wyłącz kamerę",tooltipOffContent:"Włącz kamerę",tooltipVideoLoadingContent:"Ładowanie wideo w toku",cameraMenuTitle:"Kamera",cameraMenuTooltip:"Wybierz kamerę",cameraButtonSplitRoleDescription:"Przycisk podziału",onSplitButtonAriaLabel:"Wyłącz kamerę",offSplitButtonAriaLabel:"Włącz kamerę",cameraActionTurnedOnAnnouncement:"Kamera została włączona",cameraActionTurnedOffAnnouncement:"Kamera została wyłączona",onSplitButtonPrimaryActionCamera:"Wyłącz kamerę",offSplitButtonPrimaryActionCamera:"Włącz kamerę",cameraPrimaryActionSplitButtonTitle:"Użyj kamery",videoEffectsMenuItemTitle:"Efekty",cameraButtonAriaDescription:"opcje kamery"},microphoneButton:{onLabel:"Mikrofon",offLabel:"Mikrofon",tooltipDisabledContent:"Mikrofon jest wyłączony",tooltipOnContent:"Wycisz mikrofon",tooltipOffContent:"Wyłącz wyciszenie mikrofonu",microphoneMenuTitle:"Mikrofon",microphoneMenuTooltip:"Wybierz mikrofon",speakerMenuTitle:"Głośnik",speakerMenuTooltip:"Wybierz głośnik",microphoneButtonSplitRoleDescription:"Przycisk podziału",onSplitButtonAriaLabel:"Wycisz mikrofon",offSplitButtonAriaLabel:"Wyłącz wyciszenie mikrofonu",microphoneActionTurnedOnAnnouncement:"Mikrofon został włączony",microphoneActionTurnedOffAnnouncement:"Mikrofon został wyłączony",offSplitButtonMicrophonePrimaryAction:"Wyłącz wyciszenie mikrofonu",onSplitButtonMicrophonePrimaryAction:"Wycisz mikrofon",microphonePrimaryActionSplitButtonTitle:"Użyj mikrofonu",microphoneAriaDescription:"Opcje dźwięku",deepNoiseSuppressionTitle:"Tłumienie szumu",deepNoiseSuppressionOnAnnouncement:"Głębokie tłumienie szumów zostało włączone",deepNoiseSuppressionOffAnnouncement:"Głębokie tłumienie szumów zostało wyłączone"},devicesButton:{label:"Urządzenia",tooltipContent:"Zarządzaj urządzeniami",cameraMenuTitle:"Kamera",cameraMenuTooltip:"Wybierz kamerę",audioDeviceMenuTitle:"Urządzenie audio",audioDeviceMenuTooltip:"Wybierz urządzenie audio",microphoneMenuTitle:"Mikrofon",microphoneMenuTooltip:"Wybierz mikrofon",speakerMenuTitle:"Głośnik",speakerMenuTooltip:"Wybierz głośnik"},participantsButton:{label:"Osoby",ariaLabel:"Osoby",tooltipContent:"Pokaż uczestników",menuHeader:"W tej rozmowie",participantsListButtonLabel:"Liczba osób: {numParticipants}",muteAllButtonLabel:"Wycisz wszystkich",copyInviteLinkButtonLabel:"Kopiuj link do zaproszenia",copyInviteLinkActionedAriaLabel:"Skopiowano link do zaproszenia"},screenShareButton:{onLabel:"Zakończ prezentację",offLabel:"Obecne",tooltipDisabledContent:"Prezentowanie jest wyłączone",tooltipOnContent:"Prezentowanie ekranu",tooltipOffContent:"Prezentuj swój ekran"},raiseHandButton:{offLabel:"Podnieś",onLabel:"Opuść",tooltipDisabledContent:"Akcja Podnieś rękę jest wyłączona",tooltipOnContent:"Opuść rękę",tooltipOffContent:"Podnieś rękę"},reactionButton:{label:"Zareaguj",ariaLabel:"Zareaguj",tooltipDisabledContent:"Akcja reakcji jest wyłączona",tooltipContent:"Wyślij reakcję",likeReactionTooltipContent:"Lubię",heartReactionTooltipContent:"Miłość",laughReactionTooltipContent:"Śmiech",applauseReactionTooltipContent:"Aplauz",surprisedReactionTooltipContent:"Niespodzianka"},realTimeText:{isTypingText:"Pisanie w czasie rzeczywistym"},captionsSettingsModal:{captionsSettingsModalTitle:"Ustawienia napisów",captionsSettingsSpokenLanguageDropdownLabel:"Język mówiony",captionsSettingsCaptionLanguageDropdownLabel:"Język napisów",captionsSettingsSpokenLanguageDropdownInfoText:"Język, w którym mówią wszyscy uczestnicy tej rozmowy.",captionsSettingsCaptionLanguageDropdownInfoText:"Napisy będą wyświetlane w tym języku.",captionsSettingsConfirmButtonLabel:"Potwierdź",captionsSettingsCancelButtonLabel:"Anuluj",captionsSettingsModalAriaLabel:"Modalne ustawianie podpisów",captionsSettingsCloseModalButtonAriaLabel:"Ustawienie podpisów"},spokenLanguages:{"ar-ae":"arabski — Zjednoczone Emiraty Arabskie","ar-sa":"arabski — Arabia Saudyjska","da-dk":"duński","de-de":"niemiecki — Niemcy","en-au":"angielski — Australia","en-ca":"angielski — Kanada","en-gb":"angielski — Zjednoczone Królestwo","en-in":"angielski — Indie","en-nz":"angielski — Nowa Zelandia","en-us":"angielski — Stany Zjednoczone","es-es":"hiszpański — Hiszpania (nowoczesny)","es-mx":"hiszpański — Meksyk","fi-fi":"fiński","fr-ca":"francuski — Kanada","fr-fr":"francuski — Francja","hi-in":"hindi","it-it":"włoski — Włochy","ja-jp":"japoński","ko-kr":"koreański","nb-no":"norweski (Bokmål)","nl-be":"niderlandzki — Belgia","nl-nl":"niderlandzki — Holandia","pl-pl":"polski","pt-br":"portugalski — Brazylia","ru-ru":"rosyjski","sv-se":"szwedzki","zh-cn":"chiński (Chińska Republika Ludowa)","zh-hk":"chiński — Hongkong SAR","cs-cz":"czeski","pt-pt":"portugalski — Portugalia","tr-tr":"turecki","vi-vn":"wietnamski","th-th":"tajski","he-il":"hebrajski","cy-gb":"walijski","uk-ua":"ukraiński","el-gr":"grecki","hu-hu":"węgierski","ro-ro":"rumuński","sk-sk":"słowacki","zh-tw":"chiński — Tajwan"},captionLanguages:{ar:"arabski",da:"duński",de:"niemiecki",en:"angielski",es:"hiszpański",fi:"fiński","fr-ca":"francuski — Kanada",fr:"francuski — Francja",hi:"hindi",it:"włoski",ja:"japoński",ko:"koreański",nb:"norweski (Bokmål)",nl:"holenderski",pl:"polski",pt:"portugalski — Brazylia",ru:"rosyjski",sv:"szwedzki","zh-Hans":"chiński (uproszczony)","zh-Hant":"chiński (tradycyjny)",cs:"czeski","pt-pt":"portugalski — Portugalia",tr:"turecki",vi:"wietnamski",th:"tajski",he:"hebrajski",cy:"walijski",uk:"ukraiński",el:"grecki",hu:"węgierski",ro:"rumuński",sk:"słowacki"},startCaptionsButton:{onLabel:"Włącz podpisy",offLabel:"Wyłącz podpisy",tooltipOnContent:"Wyłącz podpisy",tooltipOffContent:"Włącz podpisy"},startRealTimeTextButton:{label:"Włącz funkcję Pisanie w czasie rzeczywistym dla tego połączenia",tooltipOffContent:"Włącz funkcję Pisanie w czasie rzeczywistym dla tego połączenia"},messageThread:{yesterday:"Wczoraj",sunday:"Niedziela",monday:"Poniedziałek",tuesday:"Wtorek",wednesday:"Środa",thursday:"Czwartek",friday:"Piątek",saturday:"Sobota",participantJoined:"dołączył do czatu.",participantLeft:"opuścił czat.",editMessage:"Edytuj",removeMessage:"Usuń",resendMessage:"Spróbuj wysłać ponownie",failToSendTag:"Nie udało się wysłać",editedTag:"Edytowane",liveAuthorIntro:"Wiadomość od użytkownika {author}",editedMessageLiveAuthorIntro:"Edytowano wiadomość od użytkownika {author}",editedMessageLocalUserLiveAuthorIntro:"Edytowano wiadomość",messageContentAriaText:"{status} Użytkownik {author} powiedział: {message}",messageContentMineAriaText:"{status} Twoja wypowiedź: {message}",editBoxTextLimit:"Twoja wiadomość przekracza limit {limitNumber} znaków",editBoxPlaceholderText:"Edytuj wiadomość",newMessagesIndicator:"Nowe wiadomości",noDisplayNameSub:"Bez nazwy",editBoxCancelButton:"Anuluj",editBoxSubmitButton:"Gotowe",messageReadCount:"Przeczytane przez {messageReadByCount} z {remoteParticipantsCount}",actionMenuMoreOptions:"Więcej opcji",downloadAttachment:"Pobierz plik",openAttachment:"Otwórz plik",blockedWarningText:"Ta wiadomość została usunięta ze względu na zasady organizacyjne.",blockedWarningLinkText:"Szczegóły",attachmentCardGroupMessage:"Wiadomość ma {attachmentCount} załącznik",messageDeletedAnnouncementAriaLabel:"Wiadomość została usunięta",richTextBoldTooltip:"Pogrubienie",richTextItalicTooltip:"Kursywa",richTextUnderlineTooltip:"Podkreślenie",richTextBulletListTooltip:"Lista punktowana",richTextNumberListTooltip:"Lista numerowana",richTextIncreaseIndentTooltip:"Zwiększ wcięcie",richTextDecreaseIndentTooltip:"Zmniejsz wcięcie",richTextInsertTableTooltip:"Wstaw tabelę",richTextFormatButtonTooltip:"Formatowanie",richTextInsertRowOrColumnMenu:"Wstaw",richTextInsertTableMenuTitle:"Wstaw tabelę {column} x {row}",richTextInsertRowAboveMenu:"Wstaw powyżej",richTextInsertRowBelowMenu:"Wstaw poniżej",richTextInsertColumnLeftMenu:"Wstaw z lewej",richTextInsertColumnRightMenu:"Wstaw z prawej",richTextDeleteRowOrColumnMenu:"Usuń",richTextDeleteColumnMenu:"Usuń kolumnę",richTextDeleteRowMenu:"Usuń wiersz",richTextDeleteTableMenu:"Usuń tabelę",richTextToolbarMoreButtonAriaLabel:"Więcej opcji",attachmentUploadsPendingError:"Trwa przekazywanie pliku. Czekaj.",imageUploadsPendingError:"Trwa przekazywanie obrazu. Czekaj.",richTextNewBulletedListItemAnnouncement:"Punktor, nowy wiersz",richTextNewNumberedListItemAnnouncement:"{0}, nowy wiersz",richTextBulletedListAppliedAnnouncement:"Zastosowano listę punktowaną",richTextNumberedListAppliedAnnouncement:"Zastosowano listę numerowaną"},errorBar:{unableToReachChatService:"Jesteś w trybie offline",accessDenied:"Nie można uzyskać dostępu do usług czatu — sprawdź podane poświadczenia użytkownika",userNotInChatThread:"Nie jesteś już w tym wątku czatu",sendMessageNotInChatThread:"Nie można wysłać wiadomości, ponieważ nie jesteś już w tym wątku czatu",sendMessageGeneric:"Nie udało się wysłać wiadomości",callingNetworkFailure:"Problem z nawiązaniem połączenia — wygląda na to, że jesteś w trybie offline",startVideoGeneric:"Nie można uruchomić wideo",stopVideoGeneric:"Nie można zatrzymać wideo",muteGeneric:"Nie można wyciszyć mikrofonu",unmuteGeneric:"Nie można wyłączyć wyciszenia mikrofonu",speakingWhileMuted:"Mikrofon jest wyciszony",startScreenShareGeneric:"Wystąpił problem podczas uruchamiania udostępniania ekranu.",stopScreenShareGeneric:"Nie można zatrzymać udostępniania ekranu",callNetworkQualityLow:"Niska jakość sieci.",teamsMeetingCallNetworkQualityLow:"Niska jakość sieci.",callNoSpeakerFound:"Nie znaleziono głośników ani słuchawek. Podłącz urządzenie audio, aby słyszeć rozmowę.",callNoMicrophoneFound:"Nie znaleziono mikrofonów. Podłącz urządzenie wejściowe audio.",callMicrophoneAccessDenied:"Nie można uzyskać dostępu do mikrofonu. Kliknij blokadę na pasku adresu, aby udzielić uprawnienia do tej strony sieci Web.",callMicrophoneAccessDeniedSafari:"Nie można uzyskać dostępu do mikrofonu. Odśwież stronę, aby zezwolić na uprawnienia, lub sprawdź ustawienia tej przeglądarki i sprawdź, czy uprawnienia są włączone dla tej witryny internetowej.",callMicrophoneMutedBySystem:"System wyciszył Cię.",callMicrophoneUnmutedBySystem:"Mikrofon został odzyskany i system wyłączył wyciszenie.",callMacOsMicrophoneAccessDenied:"Nie można uzyskać dostępu do mikrofonu. Udziel uprawnienia do mikrofonu w ustawieniach prywatności systemu macOS.",callLocalVideoFreeze:"Przepustowość sieci jest słaba. Twoje wideo może być wstrzymane dla innych osób podczas rozmowy.",callCameraAccessDenied:"Nie można uzyskać dostępu do kamery. Kliknij blokadę na pasku adresu, aby udzielić uprawnienia do tej strony sieci Web.",callCameraAccessDeniedSafari:"Nie można uzyskać dostępu do kamery. Odśwież stronę, aby zezwolić na uprawnienia, lub sprawdź ustawienia tej przeglądarki i sprawdź, czy uprawnienia są włączone dla tej witryny internetowej.",callCameraAlreadyInUse:"Nie można uzyskać dostępu do kamery. Być może jest już używany przez inną aplikację.",callVideoStoppedBySystem:"Wideo zostało zatrzymane przez system.",callVideoRecoveredBySystem:"Wideo zostało wznowione.",callMacOsCameraAccessDenied:"System MacOS blokuje dostęp do kamery. Zaktualizuj ustawienia prywatności, aby zezwolić tej przeglądarce na dostęp do kamery.",callMacOsScreenShareAccessDenied:"System MacOS blokuje udostępnianie ekranu. Zaktualizuj ustawienia prywatności, aby zezwolić tej przeglądarce na rejestrowanie ekranu.",dismissButtonAriaLabel:"Zamknij",failedToJoinCallGeneric:"Nie można dołączyć do rozmowy.",failedToJoinCallInvalidMeetingLink:"Nie można dołączyć do spotkania. Nieprawidłowy link.",cameraFrozenForRemoteParticipants:"Użytkownicy w trakcie rozmowy mają problemy z wyświetleniem Twojego wideo. Sprawdź urządzenia i sieć.",unableToStartVideoEffect:"Nie można zastosować efektu wideo.",startSpotlightWhileMaxParticipantsAreSpotlighted:"Nie można rozpocząć wyróżnienia uczestników, ponieważ maksymalna liczba uczestników jest już wyróżniona.",mutedByRemoteParticipant:"Inny uczestnik wyciszył Cię."},notificationStack:{callingNetworkFailure:{title:"Problem z nawiązaniem połączenia",message:"Wygląda na to, że jesteś w trybie offline. Sprawdź połączenie sieciowe i spróbuj ponownie.",dismissButtonAriaLabel:"Zamknij"},startVideoGeneric:{title:"Nie można uruchomić wideo.",dismissButtonAriaLabel:"Zamknij"},stopVideoGeneric:{title:"Nie można zatrzymać wideo.",dismissButtonAriaLabel:"Zamknij"},muteGeneric:{title:"Nie można wyciszyć mikrofonu.",dismissButtonAriaLabel:"Zamknij"},unmuteGeneric:{title:"Nie można wyłączyć wyciszenia mikrofonu.",dismissButtonAriaLabel:"Zamknij"},speakingWhileMuted:{title:"Wyciszenie jest włączone.",dismissButtonAriaLabel:"Zamknij"},startScreenShareGeneric:{title:"Wystąpił problem podczas uruchamiania udostępniania ekranu.",dismissButtonAriaLabel:"Zamknij"},stopScreenShareGeneric:{title:"Nie można zatrzymać udostępniania ekranu.",dismissButtonAriaLabel:"Zamknij"},callNetworkQualityLow:{title:"Niska jakość sieci.",dismissButtonAriaLabel:"Zamknij"},teamsMeetingCallNetworkQualityLow:{title:"Niska jakość sieci.",dismissButtonAriaLabel:"Zamknij",message:"Dołącz do tej rozmowy z telefonu, aby uzyskać lepszy dźwięk. Możesz kontynuować wyświetlanie spotkania na tym urządzeniu.",primaryButtonLabel:"Dołącz przez telefon"},callNoSpeakerFound:{title:"Nie odnaleziono głośników ani słuchawek",message:"Podłącz urządzenie audio, aby usłyszeć rozmowę.",dismissButtonAriaLabel:"Zamknij"},callNoMicrophoneFound:{title:"Nie znaleziono mikrofonów",message:"Podłącz urządzenie wejściowe dźwięku.",dismissButtonAriaLabel:"Zamknij"},callMicrophoneAccessDenied:{title:"Brak dostępu do mikrofonu",message:"Kliknij blokadę na pasku adresu, aby udzielić uprawnienia do tej strony sieci Web.",dismissButtonAriaLabel:"Zamknij"},callMicrophoneAccessDeniedSafari:{title:"Brak dostępu do mikrofonu",message:"Odśwież stronę, aby zezwolić na uprawnienia, lub sprawdź ustawienia tej przeglądarki i sprawdź, czy uprawnienia są włączone dla tej witryny internetowej.",dismissButtonAriaLabel:"Zamknij"},callMicrophoneMutedBySystem:{title:"System wyciszył Cię.",dismissButtonAriaLabel:"Zamknij"},callMicrophoneUnmutedBySystem:{title:"Mikrofon został odzyskany i system wyłączył wyciszenie.",dismissButtonAriaLabel:"Zamknij"},callMacOsMicrophoneAccessDenied:{title:"Brak dostępu do mikrofonu",message:"Udziel uprawnienia do mikrofonu w ustawieniach prywatności systemu macOS.",dismissButtonAriaLabel:"Zamknij"},callLocalVideoFreeze:{title:"Przepustowość sieci jest słaba",message:"Twoje wideo może być wstrzymane dla innych osób podczas rozmowy.",dismissButtonAriaLabel:"Zamknij"},callCameraAccessDenied:{title:"Brak dostępu do kamery",message:"Kliknij blokadę na pasku adresu, aby udzielić uprawnienia do tej strony sieci Web.",dismissButtonAriaLabel:"Zamknij"},callCameraAccessDeniedSafari:{title:"Brak dostępu do kamery",message:"Odśwież stronę, aby zezwolić na uprawnienia, lub sprawdź ustawienia tej przeglądarki i sprawdź, czy uprawnienia są włączone dla tej witryny internetowej.",dismissButtonAriaLabel:"Zamknij"},callCameraAlreadyInUse:{title:"Brak dostępu do kamery",message:"Być może jest już używany przez inną aplikację.",dismissButtonAriaLabel:"Zamknij"},callVideoStoppedBySystem:{title:"Wideo zostało zatrzymane przez system.",dismissButtonAriaLabel:"Zamknij"},callVideoRecoveredBySystem:{title:"Wideo zostało wznowione.",dismissButtonAriaLabel:"Zamknij"},callMacOsCameraAccessDenied:{title:"System MacOS blokuje dostęp do kamery",message:"Zaktualizuj ustawienia prywatności, aby zezwolić tej przeglądarce na dostęp do kamery.",dismissButtonAriaLabel:"Zamknij"},callMacOsScreenShareAccessDenied:{title:"System MacOS blokuje udostępnianie ekranu",message:"Zaktualizuj ustawienia prywatności, aby zezwolić tej przeglądarce na rejestrowanie ekranu.",dismissButtonAriaLabel:"Zamknij"},failedToJoinCallGeneric:{title:"Nie można dołączyć do rozmowy.",dismissButtonAriaLabel:"Zamknij"},failedToJoinCallInvalidMeetingLink:{title:"Nie można dołączyć do spotkania. Nieprawidłowy link.",dismissButtonAriaLabel:"Zamknij"},cameraFrozenForRemoteParticipants:{title:"Użytkownicy w trakcie rozmowy mają problemy z wyświetleniem Twojego wideo",message:"Sprawdź urządzenia i sieć.",dismissButtonAriaLabel:"Zamknij"},unableToStartVideoEffect:{title:"Nie można zastosować efektu wideo.",dismissButtonAriaLabel:"Zamknij"},startSpotlightWhileMaxParticipantsAreSpotlighted:{title:"Nie można rozpocząć wyróżniania uczestników",message:"Maksymalna liczba uczestników jest już wyróżniona.",dismissButtonAriaLabel:"Zamknij"},mutedByRemoteParticipant:{title:"Inny uczestnik wyciszył Cię.",dismissButtonAriaLabel:"Zamknij"},recordingStarted:{title:"Rozpoczęto nagrywanie.",message:"Dołączając, wyrażasz zgodę na transkrypcję tego spotkania.",dismissButtonAriaLabel:"Zamknij"},transcriptionStarted:{title:"Rozpoczęto transkrypcję.",message:"Dołączając, wyrażasz zgodę na transkrypcję tego spotkania.",dismissButtonAriaLabel:"Zamknij"},recordingStopped:{title:"Trwa zapisywanie nagrania.",message:"Zatrzymano nagrywanie.",dismissButtonAriaLabel:"Zamknij"},transcriptionStopped:{title:"Trwa zapisywanie transkrypcji.",message:"Zakończono transkrypcję.",dismissButtonAriaLabel:"Zamknij"},recordingAndTranscriptionStarted:{title:"Rozpoczęto nagrywanie i transkrypcję.",message:"Dołączając, wyrażasz zgodę na transkrypcję tego spotkania.",dismissButtonAriaLabel:"Zamknij"},recordingAndTranscriptionStopped:{title:"Trwa zapisywanie nagrania i transkrypcji.",message:"Zatrzymano nagrywanie i transkrypcję.",dismissButtonAriaLabel:"Zamknij"},recordingStoppedStillTranscribing:{title:"Zatrzymano nagrywanie.",message:"W tej chwili tylko Ty transkrybujesz to spotkanie.",dismissButtonAriaLabel:"Zamknij"},transcriptionStoppedStillRecording:{title:"Zakończono transkrypcję.",message:"W tej chwili tylko Ty nagrywasz to spotkanie.",dismissButtonAriaLabel:"Zamknij"},assignedBreakoutRoomOpened:{title:"Przeniesiemy Cię do przypisanego pokoju w ciągu 5 sekund.",dismissButtonAriaLabel:"Zamknij"},assignedBreakoutRoomChanged:{title:"Twój osobny pokój został zmieniony",message:"Przeniesiemy Cię do przypisanego pokoju w ciągu 5 sekund.",dismissButtonAriaLabel:"Zamknij"},assignedBreakoutRoomClosed:{title:"Osobny pokój został zamknięty",message:"Przeniesiemy Cię z powrotem do spotkania za 5 sekund.",dismissButtonAriaLabel:"Zamknij"},assignedBreakoutRoomOpenedPromptJoin:{title:"Dołączyć do osobnego pokoju?",message:"Przypisano Cię do osobnego pokoju.",dismissButtonAriaLabel:"Zamknij",primaryButtonLabel:"Dołącz do pokoju",secondaryButtonLabel:"Później"},breakoutRoomJoined:{title:"Dołączono do osobnego pokoju.",dismissButtonAriaLabel:"Zamknij"},breakoutRoomClosingSoon:{title:"Limit czasu pokoju wkrótce wygaśnie.",message:"Ten pokój zostanie zamknięty za 30 sekund",dismissButtonAriaLabel:"Zamknij"},capabilityTurnVideoOnPresent:{title:"Twoja kamera została włączona",message:"Włącz to, jeśli chcesz udostępnić wideo.",dismissButtonAriaLabel:"Zamknij"},capabilityTurnVideoOnAbsent:{title:"Twoja kamera została wyłączona",message:"Nie można już udostępniać wideo.",dismissButtonAriaLabel:"Zamknij"},capabilityUnmuteMicPresent:{title:"Twój mikrofon został włączony",message:"Wyłącz wyciszenie, jeśli chcesz przemawiać.",dismissButtonAriaLabel:"Zamknij"},capabilityUnmuteMicAbsent:{title:"Twój mikrofon został wyłączony",message:"Nie możesz już wyłączać wyciszenia.",dismissButtonAriaLabel:"Zamknij"},togetherModeStarted:{title:"Tryb Togethermode został uruchomiony",dismissButtonAriaLabel:"Zamknij"},togetherModeEnded:{title:"Tryb Togethermode został zakończony",dismissButtonAriaLabel:"Zamknij"}},videoGallery:{screenIsBeingSharedMessage:"Udostępniasz ekran",screenShareLoadingMessage:"Ładowanie ekranu uczestnika {participant}",localScreenShareLoadingMessage:"Ładowanie ekranu",localVideoLabel:"Ty",localVideoCameraSwitcherLabel:"Przełącz kamerę",localVideoMovementLabel:"Ruchomy lokalny kafelek wideo",localVideoMovementAriaLabel:"Ruchomy lokalny kafelek wideo",localVideoSelectedDescription:"Wybrano kamerę {cameraName}",displayNamePlaceholder:"Uczestnik bez nazwy",fitRemoteParticipantToFrame:"Dopasuj do ramki",fillRemoteParticipantFrame:"Wypełnij ramkę",pinParticipantForMe:"Przypnij dla mnie",pinParticipantForMeLimitReached:"Przypięcie (osiągnięto limit)",unpinParticipantForMe:"Odepnij",pinParticipantMenuItemAriaLabel:"Przypnij uczestnika {participantName}",unpinParticipantMenuItemAriaLabel:"Odepnij uczestnika {participantName}",pinnedParticipantAnnouncementAriaLabel:"Przypięty uczestnik {participantName}",unpinnedParticipantAnnouncementAriaLabel:"Odpięty uczestnik {participantName}",startSpotlightVideoTileMenuLabel:"Wyróżnij dla wszystkich",addSpotlightVideoTileMenuLabel:"Dodaj wyróżnienie",spotlightLimitReachedMenuTitle:"Osiągnięto limit wyróżnienia",stopSpotlightVideoTileMenuLabel:"Zatrzymaj wyróżnianie",stopSpotlightOnSelfVideoTileMenuLabel:"Zakończ wyróżnienie",attendeeRole:"Uczestnik",muteParticipantMenuItemLabel:"Wycisz",waitingScreenText:"Oczekiwanie na dołączenie innych osób",forbidAudio:"Wyłącz mikrofon",permitAudio:"Zezwalaj na mikrofon",forbidAudioTileMenuLabel:"Wyłącz mikrofon",permitAudioTileMenuLabel:"Zezwalaj na mikrofon",forbidVideo:"Wyłącz kamerę",permitVideo:"Zezwalaj na kamerę",forbidVideoTileMenuLabel:"Wyłącz kamerę",permitVideoTileMenuLabel:"Zezwalaj na kamerę"},dialpad:{placeholderText:"Wprowadź numer telefonu",deleteButtonAriaLabel:"Usuń"},holdButton:{onLabel:"Wznów",offLabel:"Zawieś",tooltipOnContent:"Wznów połączenie",tooltipOffContent:"Zawieś połączenie"},videoTile:{participantStateRinging:"Trwa łączenie…",participantReconnecting:"Trwa ponowne łączenie...",participantStateHold:"Zawieszony",moreOptionsButtonAriaLabel:"Więcej opcji {displayName} {isMuted} {micDisabledState} {cameraDisabledState} {isHandRaised} {state} {isSpeaking}",moreOptionsParticipantMutedStateMutedAriaLabel:"wyciszony",moreOptionsParticipantMutedStateUnmutedAriaLabel:"wyciszenie wyłączone",moreOptionsParticipantHandRaisedAriaLabel:"Podniesiona ręka",moreOptionsParticipantIsSpeakingAriaLabel:"Mówi",moreOptionsParticipantMicDisabledAriaLabel:"Mikrofon jest wyłączony",moreOptionsParticipantCameraDisabledAriaLabel:"Kamera wyłączona"},CameraAndMicrophoneSitePermissionsRequest:{primaryText:"Zezwalaj {appName} na używanie kamery i mikrofonu",secondaryText:"Dzięki temu uczestnicy będą mogli Cię zobaczyć i usłyszeć.",linkText:"Potrzebujesz pomocy? Uzyskaj pomoc dotyczącą rozwiązywania problemów",primaryButtonText:"Kontynuuj bez kamery i mikrofonu",ariaLabel:"Zezwalaj na dostęp do kamery i mikrofonu"},CameraSitePermissionsRequest:{primaryText:"Zezwalaj aplikacji {appName} na korzystanie z kamery",secondaryText:"Dzięki temu uczestnicy będą mogli Cię zobaczyć.",linkText:"Potrzebujesz pomocy? Uzyskaj pomoc dotyczącą rozwiązywania problemów",primaryButtonText:"Kontynuuj bez kamery",ariaLabel:"Zezwalaj na dostęp do kamery"},MicrophoneSitePermissionsRequest:{primaryText:"Zezwalaj aplikacji {appName} na używanie mikrofonu",secondaryText:"Dzięki temu uczestnicy będą mogli Cię usłyszeć.",linkText:"Potrzebujesz pomocy? Uzyskaj pomoc dotyczącą rozwiązywania problemów",primaryButtonText:"Kontynuuj bez mikrofonu",ariaLabel:"Zezwalaj na dostęp do mikrofonu"},CameraAndMicrophoneSitePermissionsCheck:{primaryText:"Sprawdzanie dostępu do kamery i mikrofonu",secondaryText:"Zezwalaj na dostęp, jeśli zostanie wyświetlony monit. Dzięki temu uczestnicy będą mogli Cię zobaczyć i usłyszeć.",linkText:"Potrzebujesz pomocy? Uzyskaj pomoc dotyczącą rozwiązywania problemów",primaryButtonText:"Kontynuuj bez kamery i mikrofonu",ariaLabel:"Sprawdzanie dostępu do kamery i mikrofonu. Zezwalaj na dostęp, jeśli zostanie wyświetlony monit."},CameraSitePermissionsCheck:{primaryText:"Sprawdzanie dostępu do kamery",secondaryText:"Zezwalaj na dostęp, jeśli zostanie wyświetlony monit. Dzięki temu uczestnicy będą mogli Cię zobaczyć.",linkText:"Potrzebujesz pomocy? Uzyskaj pomoc dotyczącą rozwiązywania problemów",primaryButtonText:"Kontynuuj bez kamery",ariaLabel:"Sprawdzanie dostępu do kamery. Zezwalaj na dostęp, jeśli zostanie wyświetlony monit."},MicrophoneSitePermissionsCheck:{primaryText:"Sprawdzanie dostępu do mikrofonu",secondaryText:"Zezwalaj na dostęp, jeśli zostanie wyświetlony monit. Dzięki temu uczestnicy będą mogli Cię usłyszeć.",linkText:"Potrzebujesz pomocy? Uzyskaj pomoc dotyczącą rozwiązywania problemów",primaryButtonText:"Kontynuuj bez mikrofonu",ariaLabel:"Sprawdzanie dostępu do mikrofonu. Zezwalaj na dostęp, jeśli zostanie wyświetlony monit."},CameraAndMicrophoneSitePermissionsDenied:{primaryText:"Brak dostępu do kamery i mikrofonu",secondaryText:"Kliknij ikonę blokady na pasku adresu, aby udzielić uprawnień mikrofonu do tej strony sieci Web. Odświeżenie strony może być wymagane.",primaryButtonText:"Kontynuuj bez kamery i mikrofonu",linkText:"Potrzebujesz pomocy? Uzyskaj pomoc dotyczącą rozwiązywania problemów"},CameraAndMicrophoneSitePermissionsDeniedSafari:{primaryText:"Brak dostępu do kamery i mikrofonu",secondaryText:"Odśwież stronę, aby zezwolić na uprawnienia, lub sprawdź ustawienia tej przeglądarki i sprawdź, czy uprawnienia są włączone dla tej witryny internetowej.",primaryButtonText:"Kontynuuj bez kamery i mikrofonu",linkText:"Potrzebujesz pomocy? Uzyskaj pomoc dotyczącą rozwiązywania problemów"},CameraSitePermissionsDenied:{primaryText:"Brak dostępu do kamery",secondaryText:"Kliknij ikonę blokady na pasku adresu, aby udzielić uprawnień kamery do tej strony sieci Web. Odświeżenie strony może być wymagane.",primaryButtonText:"Kontynuuj bez kamery",linkText:"Potrzebujesz pomocy? Uzyskaj pomoc dotyczącą rozwiązywania problemów"},MicrophoneSitePermissionsDenied:{primaryText:"Brak dostępu do mikrofonu",secondaryText:"Kliknij ikonę blokady na pasku adresu, aby udzielić uprawnień mikrofonu do tej strony sieci Web. Odświeżenie strony może być wymagane.",primaryButtonText:"Kontynuuj bez mikrofonu",linkText:"Potrzebujesz pomocy? Uzyskaj pomoc dotyczącą rozwiązywania problemów"},CameraSitePermissionsDeniedSafari:{primaryText:"Brak dostępu do kamery",secondaryText:"Odśwież stronę, aby zezwolić na uprawnienia, lub sprawdź ustawienia tej przeglądarki i sprawdź, czy uprawnienia są włączone dla tej witryny internetowej.",primaryButtonText:"Kontynuuj bez kamery",linkText:"Potrzebujesz pomocy? Uzyskaj pomoc dotyczącą rozwiązywania problemów"},MicrophoneSitePermissionsDeniedSafari:{primaryText:"Brak dostępu do mikrofonu",secondaryText:"Odśwież stronę, aby zezwolić na uprawnienia, lub sprawdź ustawienia tej przeglądarki i sprawdź, czy uprawnienia są włączone dla tej witryny internetowej.",primaryButtonText:"Kontynuuj bez mikrofonu",linkText:"Potrzebujesz pomocy? Uzyskaj pomoc dotyczącą rozwiązywania problemów"},UnsupportedBrowser:{primaryText:"Nieobsługiwana przeglądarka",secondaryText:"Dołącz do tej rozmowy przy użyciu zgodnej przeglądarki.",moreHelpLinkText:"Zobacz wymagania dotyczące zgodności"},UnsupportedBrowserVersion:{primaryText:"Wymagana aktualizacja przeglądarki",secondaryText:"Aby zapewnić najlepszą możliwą rozmowę, zaktualizuj przeglądarkę, a następnie spróbuj ponownie dołączyć do rozmowy.",moreHelpLinkText:"Zobacz wymagania dotyczące zgodności",continueAnywayButtonText:"Rozpocznij rozmowę bez aktualizowania"},UnsupportedOperatingSystem:{primaryText:"System operacyjny nie jest obsługiwany",secondaryText:"Dołącz do tej rozmowy przy użyciu urządzenia ze zgodnym systemem operacyjnym.",moreHelpLinkText:"Zobacz wymagania dotyczące zgodności"},BrowserPermissionDenied:{primaryText:"Nie można użyć kamery lub mikrofonu",secondaryText:"Twoja przeglądarka może nie mieć dostępu do kamery lub mikrofonu. Aby rozwiązać ten problem, otwórz okno Preferencje systemowe.",primaryButtonText:"Spróbuj ponownie",linkText:"Potrzebujesz pomocy? Uzyskaj pomoc dotyczącą rozwiązywania problemów"},BrowserPermissionDeniedIOS:{primaryText:"Zezwalaj na dostęp do mikrofonu, aby kontynuować",secondaryText:"Inni uczestnicy będą mogli Cię usłyszeć.",primaryButtonText:"Spróbuj ponownie",imageAltText:"Lokalizacja uprawnień urządzenia z mikrofonem i kamerą dla systemu iOS",linkText:"Potrzebujesz pomocy? Uzyskaj pomoc dotyczącą rozwiązywania problemów",step1Text:"Przejdź do aplikacji Ustawienia",step2Text:"Przewiń w dół do ustawień dla tej przeglądarki",step3Text:"Włącz mikrofon (opcjonalnie kamerę)",step4Text:"Spróbuj ponownie dołączyć do rozmowy",step1DigitText:"1",step2DigitText:"2",step3DigitText:"3",step4DigitText:"4"},verticalGallery:{leftNavButtonAriaLabel:"poprzednia strona {current} z {total}",rightNavButtonAriaLabel:"następna strona {current} z {total}"},meetingConferencePhoneInfo:{meetingConferencePhoneInfoModalTitle:"Dołącz do połączenia z Twojego telefonu",meetingConferencePhoneInfoModalDialIn:"Wybierz numer",meetingConferencePhoneInfoModalMeetingId:"Wprowadź identyfikator spotkania",meetingConferencePhoneInfoModalWait:"Zaczekaj na wpuszczenie przez organizatora",meetingConferencePhoneInfoModalNoPhoneAvailable:"Brak dostępnego telefonu",meetingConferencePhoneInfoModalTollGeoData:"{country}, {city}",meetingConferencePhoneInfoModalTollFree:"(Bezpłatny)",meetingConferencePhoneInfoModalToll:"(Płatny)"},IncomingCallNotification:{incomingCallNotificationPlaceholderId:"Nieznany użytkownik",incomingCallNotificationPlaceholderAlert:"{callerName} dzwoni",incomingCallNoticicationAcceptWithAudioAriaLabel:"Zaakceptuj z dźwiękiem",incomingCallNoticicationAcceptWithVideoAriaLabel:"Zaakceptuj z wideo",incomingCallNoticicationRejectAriaLabel:"Odrzuć",incomingCallNotificationAcceptButtonLabel:"Akceptuj",incomingCallNotificationRejectButtonLabel:"Odrzuć",incomingCallNotificationAccceptWithVideoButtonLabel:"Odbierz jako połączenie wideo",incomingCallNotificationDismissButtonAriaLabel:"Odrzuć"}})},TQt={strings:Jh({participantItem:{isMeText:"(você)",menuTitle:"Mais opções",removeButtonLabel:"Remover",sharingIconLabel:"Compartilhamento",mutedIconLabel:"Silenciado",handRaisedIconLabel:"Mão levantada - Posição {position}",displayNamePlaceholder:"Participante sem nome",participantStateRinging:"Chamando...",participantStateHold:"Em espera",participantItemAriaLabel:"{displayName}, {handRaisedState}, {mutedState}, {micDisabledState}, {cameraDisabledState}, {sharingState}, {connectionState}",participantItemWithMoreOptionsAriaLabel:"{displayName}, {handRaisedState}, {mutedState}, {micDisabledState}, {cameraDisabledState}, {sharingState}, {connectionState}, Mais Opções",attendeeRole:"Participante",micDisabledIconLabel:"Microfone desabilitado",cameraDisabledIconLabel:"Câmera desabilitada"},ParticipantList:{overflowParticipantCount:"+{overflowCount} mais"},typingIndicator:{singleUser:"{user} está digitando ...",multipleUsers:"{users} estão digitando ...",multipleUsersAbbreviateOne:"{users} e 1 outro estão digitando...",multipleUsersAbbreviateMany:"{users} e {numOthers} outros estão digitando ...",delimiter:", "},sendBox:{placeholderText:"Inserir uma mensagem",textTooLong:"O comprimento da mensagem está acima do limite máximo.",sendButtonAriaLabel:"Enviar mensagem",attachmentUploadsPendingError:"O arquivo está sendo carregado, aguarde.",removeAttachment:"Remover arquivo",uploading:"Carregando",uploadCompleted:"Carregamento concluído",attachmentMoreMenu:"Mais Opções"},richTextSendBox:{placeholderText:"Inserir uma mensagem",textTooLong:"O comprimento da mensagem está acima do limite máximo.",sendButtonAriaLabel:"Enviar mensagem",attachmentUploadsPendingError:"O arquivo está sendo carregado, aguarde.",imageUploadsPendingError:"A imagem está sendo carregada, aguarde.",removeAttachment:"Remover arquivo",uploading:"Carregando",uploadCompleted:"Carregamento concluído",richTextBoldTooltip:"Negrito",richTextItalicTooltip:"Itálico",richTextUnderlineTooltip:"Sublinhar",richTextBulletListTooltip:"Lista com marcadores",richTextNumberListTooltip:"Lista numerada",richTextIncreaseIndentTooltip:"Aumentar recuo",richTextDecreaseIndentTooltip:"Diminuir recuo",richTextInsertTableTooltip:"Inserir tabela",richTextFormatButtonTooltip:"Formato",richTextInsertRowOrColumnMenu:"Inserir",richTextInsertTableMenuTitle:"Inserir tabela {column} x {row}",richTextInsertRowAboveMenu:"Inserir acima",richTextInsertRowBelowMenu:"Inserir abaixo",richTextInsertColumnLeftMenu:"Inserir à esquerda",richTextInsertColumnRightMenu:"Inserir à direita",richTextDeleteRowOrColumnMenu:"Excluir",richTextDeleteColumnMenu:"Excluir coluna",richTextDeleteRowMenu:"Excluir linha",richTextDeleteTableMenu:"Excluir tabela",richTextToolbarAriaLabel:"Barra de Ferramentas de Formatação de Mensagens",richTextToolbarMoreButtonAriaLabel:"Mais opções",attachmentMoreMenu:"Mais Opções",richTextNewBulletedListItemAnnouncement:"Com marcadores, nova linha",richTextNewNumberedListItemAnnouncement:"{0}, Nova linha",richTextBulletedListAppliedAnnouncement:"Lista com marcadores aplicada",richTextNumberedListAppliedAnnouncement:"Lista numerada aplicada"},realTimeTextModal:{realTimeTextModalAriaLabel:"Ativar Modal RTT",realTimeTextModalTitle:"Ativar a RTT?",realTimeTextModalText:"O texto em tempo real (RTT) será ativado para todos na reunião.",realTimeTextConfirmButtonLabel:"Ativar",realTimeTextCancelButtonLabel:"Cancelar",realTimeTextCloseModalButtonAriaLabel:"Fechar Modal RTT"},captionsBanner:{captionsBannerSpinnerText:"Iniciando legendas...",realTimeTextInputBoxDefaultText:"Digitar mensagem em tempo real",realTimeTextInputErrorMessage:"A mensagem não pode ter mais de 2000 caracteres",realTimeTextBannerTitle:"RTT",realTimeTextBannerContent:"O RTT (texto em tempo real) está habilitado para todos os participantes durante toda a reunião.",realTimeTextBannerLinkLabel:"Saiba mais",captionsOnlyContainerTitle:"Legendas",realTimeTextOnlyContainerTitle:"Texto em Tempo Real",captionsAndRealTimeTextContainerTitle:"Legendas e Texto em Tempo Real",expandButtonAriaLabel:"Expandir",minimizeButtonAriaLabel:"Recolher"},mentionPopover:{mentionPopoverHeader:"Sugestões"},imageOverlay:{downloadButtonLabel:"Baixar",dismissButtonAriaLabel:"Fechar",overlayVisibleMessage:"Sobreposição de Detalhes da Imagem"},messageStatusIndicator:{deliveredAriaLabel:"Mensagem enviada",deliveredTooltipText:"Enviado",seenAriaLabel:"Mensagem vista por outras pessoas",seenTooltipText:"Visto",readByTooltipText:"Lido por {messageThreadReadCount} de {remoteParticipantsCount}",sendingAriaLabel:"Envio de mensagem",sendingTooltipText:"Enviando",failedToSendAriaLabel:"Falha ao enviar mensagem",failedToSendTooltipText:"Falha ao enviar"},endCallButton:{label:"Sair",tooltipContent:"Sair da chamada",leaveOption:"Sair",endCallOption:"Encerrar chamada para todos"},cameraButton:{onLabel:"Câmera",offLabel:"Câmera",tooltipDisabledContent:"A câmera está desabilitada",tooltipOnContent:"Desabilitar a câmera",tooltipOffContent:"Ligar a câmera",tooltipVideoLoadingContent:"O vídeo está carregando",cameraMenuTitle:"Câmera",cameraMenuTooltip:"Escolher câmera",cameraButtonSplitRoleDescription:"Botão de divisão",onSplitButtonAriaLabel:"Desligar a câmera",offSplitButtonAriaLabel:"Ligar a câmera",cameraActionTurnedOnAnnouncement:"A câmera foi ligada",cameraActionTurnedOffAnnouncement:"A câmera foi desligada",onSplitButtonPrimaryActionCamera:"Desligar a câmera",offSplitButtonPrimaryActionCamera:"Ligar a câmera",cameraPrimaryActionSplitButtonTitle:"Usar câmera",videoEffectsMenuItemTitle:"Efeitos",cameraButtonAriaDescription:"opções de câmera"},microphoneButton:{onLabel:"Microfone",offLabel:"Microfone",tooltipDisabledContent:"O microfone está desabilitado",tooltipOnContent:"Ativar mudo do microfone",tooltipOffContent:"Desativar mudo do microfone",microphoneMenuTitle:"Microfone",microphoneMenuTooltip:"Escolher microfone",speakerMenuTitle:"Alto-falante",speakerMenuTooltip:"Escolher alto-falante",microphoneButtonSplitRoleDescription:"Botão de divisão",onSplitButtonAriaLabel:"Ativar mudo do microfone",offSplitButtonAriaLabel:"Desativar mudo do microfone",microphoneActionTurnedOnAnnouncement:"O microfone foi ligado",microphoneActionTurnedOffAnnouncement:"O microfone foi desligado",offSplitButtonMicrophonePrimaryAction:"Desativar mudo do microfone",onSplitButtonMicrophonePrimaryAction:"Ativar mudo do microfone",microphonePrimaryActionSplitButtonTitle:"Usar o microfone",microphoneAriaDescription:"Opções de áudio",deepNoiseSuppressionTitle:"Supressão de ruído",deepNoiseSuppressionOnAnnouncement:"A supressão de ruído profundo foi ativada",deepNoiseSuppressionOffAnnouncement:"A supressão de ruído profundo foi desativada"},devicesButton:{label:"Dispositivos",tooltipContent:"Gerenciar dispositivos",cameraMenuTitle:"Câmera",cameraMenuTooltip:"Escolher câmera",audioDeviceMenuTitle:"Dispositivo de Áudio",audioDeviceMenuTooltip:"Escolher dispositivo de áudio",microphoneMenuTitle:"Microfone",microphoneMenuTooltip:"Escolher microfone",speakerMenuTitle:"Alto-falante",speakerMenuTooltip:"Escolher alto-falante"},participantsButton:{label:"Pessoas",ariaLabel:"Pessoas",tooltipContent:"Mostrar participantes",menuHeader:"Nesta chamada",participantsListButtonLabel:"{numParticipants} pessoas",muteAllButtonLabel:"Silenciar todos",copyInviteLinkButtonLabel:"Copiar o link de convite",copyInviteLinkActionedAriaLabel:"Link de convite copiado"},screenShareButton:{onLabel:"Interromper apresentação",offLabel:"Apresentação",tooltipDisabledContent:"A apresentação está desabilitada.",tooltipOnContent:"Apresentando sua tela",tooltipOffContent:"Apresentar sua tela"},raiseHandButton:{offLabel:"Levantar",onLabel:"Baixar",tooltipDisabledContent:"A ação Levantar a Mão está desabilitada",tooltipOnContent:"Baixar a Mão",tooltipOffContent:"Levantar a Mão"},reactionButton:{label:"Reagir",ariaLabel:"Reagir",tooltipDisabledContent:"A ação de reação está desabilitada",tooltipContent:"Enviar uma reação",likeReactionTooltipContent:"Curtir",heartReactionTooltipContent:"Amor",laughReactionTooltipContent:"Gargalhada",applauseReactionTooltipContent:"Aplausos",surprisedReactionTooltipContent:"Surpreso"},realTimeText:{isTypingText:"Digitação RTT"},captionsSettingsModal:{captionsSettingsModalTitle:"Configurações de Legendas",captionsSettingsSpokenLanguageDropdownLabel:"Idioma falado",captionsSettingsCaptionLanguageDropdownLabel:"Idioma das legendas",captionsSettingsSpokenLanguageDropdownInfoText:"Idioma que todos nesta chamada estão falando.",captionsSettingsCaptionLanguageDropdownInfoText:"As legendas serão exibidas neste idioma.",captionsSettingsConfirmButtonLabel:"Confirmar",captionsSettingsCancelButtonLabel:"Cancelar",captionsSettingsModalAriaLabel:"Modal de Configuração de Legendas",captionsSettingsCloseModalButtonAriaLabel:"Fechar Configuração de Legendas"},spokenLanguages:{"ar-ae":"Árabe - Emirados Árabes Unidos","ar-sa":"Árabe – Arábia Saudita","da-dk":"Dinamarquês","de-de":"Alemão – Alemanha","en-au":"Inglês – Austrália","en-ca":"Inglês – Canadá","en-gb":"Inglês – Reino Unido","en-in":"Inglês – Índia","en-nz":"Inglês – Nova Zelândia","en-us":"Inglês – Estados Unidos","es-es":"Espanhol - Espanha (Moderno)","es-mx":"Espanhol – México","fi-fi":"Finlandês","fr-ca":"Francês – Canadá","fr-fr":"Francês – França","hi-in":"Híndi","it-it":"Italiano – Itália","ja-jp":"Japonês","ko-kr":"Coreano","nb-no":"Norueguês (Bokmål)","nl-be":"Holandês – Bélgica","nl-nl":"Holandês – Países Baixos","pl-pl":"Polonês","pt-br":"Português – Brasil","ru-ru":"Russo","sv-se":"Sueco","zh-cn":"Chinês - República Popular da China","zh-hk":"Chinês - RAE de Hong Kong","cs-cz":"Tcheco","pt-pt":"Português – Portugal","tr-tr":"Turco","vi-vn":"Vietnamita","th-th":"Tailandês","he-il":"Hebraico","cy-gb":"Galês","uk-ua":"Ucraniano","el-gr":"Grego","hu-hu":"Húngaro","ro-ro":"Romeno","sk-sk":"Eslovaco","zh-tw":"Chinês – Taiwan"},captionLanguages:{ar:"Árabe",da:"Dinamarquês",de:"Alemão",en:"Inglês",es:"Espanhol",fi:"Finlandês","fr-ca":"Francês – Canadá",fr:"Francês – França",hi:"Híndi",it:"Italiano",ja:"Japonês",ko:"Coreano",nb:"Norueguês (Bokmål)",nl:"Holandês",pl:"Polonês",pt:"Português – Brasil",ru:"Russo",sv:"Sueco","zh-Hans":"Chinês (Simplificado)","zh-Hant":"Chinês (Tradicional)",cs:"Tcheco","pt-pt":"Português – Portugal",tr:"Turco",vi:"Vietnamita",th:"Tailandês",he:"Hebraico",cy:"Galês",uk:"Ucraniano",el:"Grego",hu:"Húngaro",ro:"Romeno",sk:"Eslovaco"},startCaptionsButton:{onLabel:"Ativar legendas",offLabel:"Desativar legendas",tooltipOnContent:"Desativar legendas",tooltipOffContent:"Ativar legendas"},startRealTimeTextButton:{label:"Habilitar a RTT para esta chamada",tooltipOffContent:"Habilitar a RTT para esta chamada"},messageThread:{yesterday:"Ontem",sunday:"Domingo",monday:"Segunda",tuesday:"Terça-feira",wednesday:"Quarta-feira",thursday:"quinta-feira",friday:"Sexta-feira",saturday:"Sábado",participantJoined:"ingressou no chat.",participantLeft:"saiu do chat.",editMessage:"Editar",removeMessage:"Excluir",resendMessage:"Tente enviar novamente",failToSendTag:"Falha ao enviar",editedTag:"Editado",liveAuthorIntro:"Mensagem de {author}",editedMessageLiveAuthorIntro:"Mensagem editada de {author}",editedMessageLocalUserLiveAuthorIntro:"Mensagem editada",messageContentAriaText:"{status} {author} disse {message}",messageContentMineAriaText:"{status} Você disse {message}",editBoxTextLimit:"Sua mensagem está acima do limite de {limitNumber} caracteres",editBoxPlaceholderText:"Edite sua mensagem",newMessagesIndicator:"Novas mensagens",noDisplayNameSub:"Sem nome",editBoxCancelButton:"Cancelar",editBoxSubmitButton:"Concluído",messageReadCount:"Lido por {messageReadByCount} de {remoteParticipantsCount}",actionMenuMoreOptions:"Mais opções",downloadAttachment:"Baixar arquivo",openAttachment:"Abrir arquivo",blockedWarningText:"Esta mensagem foi excluída devido à política organizacional.",blockedWarningLinkText:"Detalhes",attachmentCardGroupMessage:"A mensagem tem {attachmentCount} anexo",messageDeletedAnnouncementAriaLabel:"A mensagem foi excluída",richTextBoldTooltip:"Negrito",richTextItalicTooltip:"Itálico",richTextUnderlineTooltip:"Sublinhado",richTextBulletListTooltip:"Lista com marcadores",richTextNumberListTooltip:"Lista numerada",richTextIncreaseIndentTooltip:"Aumentar recuo",richTextDecreaseIndentTooltip:"Diminuir recuo",richTextInsertTableTooltip:"Inserir tabela",richTextFormatButtonTooltip:"Formato",richTextInsertRowOrColumnMenu:"Inserir",richTextInsertTableMenuTitle:"Inserir tabela {column} x {row}",richTextInsertRowAboveMenu:"Inserir acima",richTextInsertRowBelowMenu:"Inserir abaixo",richTextInsertColumnLeftMenu:"Inserir à esquerda",richTextInsertColumnRightMenu:"Inserir à direita",richTextDeleteRowOrColumnMenu:"Excluir",richTextDeleteColumnMenu:"Excluir coluna",richTextDeleteRowMenu:"Excluir linha",richTextDeleteTableMenu:"Excluir tabela",richTextToolbarMoreButtonAriaLabel:"Mais opções",attachmentUploadsPendingError:"O arquivo está sendo carregado, aguarde.",imageUploadsPendingError:"A imagem está sendo carregada, aguarde.",richTextNewBulletedListItemAnnouncement:"Com marcadores, nova linha",richTextNewNumberedListItemAnnouncement:"{0}, Nova linha",richTextBulletedListAppliedAnnouncement:"Lista com marcadores aplicada",richTextNumberedListAppliedAnnouncement:"Lista numerada aplicada"},errorBar:{unableToReachChatService:"Você está offline",accessDenied:"Não é possível acessar os serviços de chat - verifique as credenciais do usuário fornecidas",userNotInChatThread:"Você não está mais neste tópico de chat",sendMessageNotInChatThread:"Falha ao enviar mensagem porque você não está mais neste thread de chat",sendMessageGeneric:"Falha ao enviar mensagem",callingNetworkFailure:"Chamada de conexão desabilitar - parece que você está offline",startVideoGeneric:"Falha ao iniciar o vídeo",stopVideoGeneric:"Falha ao interromper o vídeo",muteGeneric:"Falha ao ativar mudo do microfone",unmuteGeneric:"Falha ao desativar mudo do microfone",speakingWhileMuted:"O microfone está com o mudo ativado",startScreenShareGeneric:"Ocorreu um problema ao iniciar o compartilhamento de tela.",stopScreenShareGeneric:"Falha ao interromper o compartilhamento de tela",callNetworkQualityLow:"A qualidade da rede é baixa.",teamsMeetingCallNetworkQualityLow:"A qualidade da rede é baixa.",callNoSpeakerFound:"Nenhum alto-falante ou fone de ouvido encontrado. Conecte um dispositivo de áudio para ouvir a chamada.",callNoMicrophoneFound:"Nenhum microfone encontrado. Conecte um dispositivo de entrada de áudio.",callMicrophoneAccessDenied:"Não é possível acessar o microfone. Clique no bloqueio na barra de endereços para conceder permissão a esta página da Web.",callMicrophoneAccessDeniedSafari:"Não é possível acessar o microfone. Atualize a página para permitir permissões ou verifique as configurações deste navegador e verifique se as permissões estão habilitadas para este site.",callMicrophoneMutedBySystem:"Você está com as notificações desativada pelo sistema.",callMicrophoneUnmutedBySystem:"Seu microfone se recuperou e você foi desativado pelo sistema.",callMacOsMicrophoneAccessDenied:"Não é possível acessar o microfone. Conceda permissão ao microfone nas configurações de privacidade do macOS.",callLocalVideoFreeze:"A largura de banda da rede é ruim. Seu vídeo pode aparecer em pausa para outras pessoas na chamada.",callCameraAccessDenied:"Não é possível acessar a câmera. Clique no bloqueio na barra de endereços para conceder permissão a esta página da Web.",callCameraAccessDeniedSafari:"Não é possível acessar a câmera. Atualize a página para permitir permissões ou verifique as configurações deste navegador e verifique se as permissões estão habilitadas para este site.",callCameraAlreadyInUse:"Não é possível acessar a câmera. Talvez ele já esteja em uso por outro aplicativo.",callVideoStoppedBySystem:"Seu vídeo foi interrompido pelo sistema.",callVideoRecoveredBySystem:"Seu vídeo foi retomado.",callMacOsCameraAccessDenied:"O MacOS está bloqueando o acesso à sua câmera. Atualize suas configurações de privacidade para permitir que este navegador acesse sua câmera.",callMacOsScreenShareAccessDenied:"O MacOS está bloqueando o compartilhamento de tela. Atualize suas configurações de privacidade para permitir que este navegador grave sua tela.",dismissButtonAriaLabel:"Fechar",failedToJoinCallGeneric:"Ocorreu um erro ao ingressar na chamada.",failedToJoinCallInvalidMeetingLink:"Não é possível ingressar na Reunião. Link Inválido.",cameraFrozenForRemoteParticipants:"Os usuários na chamada estão enfrentando problemas para ver seu vídeo. Verifique seus dispositivos e a rede.",unableToStartVideoEffect:"Não é possível aplicar o efeito de vídeo.",startSpotlightWhileMaxParticipantsAreSpotlighted:"Não é possível iniciar o destaque nos participantes porque o número máximo de participantes já está em destaque.",mutedByRemoteParticipant:"Você foi silenciado por outro participante."},notificationStack:{callingNetworkFailure:{title:"Chamada de conexão com problema",message:"Parece que você está offline. Verifique sua conexão de rede e tente novamente.",dismissButtonAriaLabel:"Fechar"},startVideoGeneric:{title:"Falha ao iniciar o vídeo.",dismissButtonAriaLabel:"Fechar"},stopVideoGeneric:{title:"Falha ao interromper o vídeo.",dismissButtonAriaLabel:"Fechar"},muteGeneric:{title:"Falha ao ativar mudo do microfone.",dismissButtonAriaLabel:"Fechar"},unmuteGeneric:{title:"Falha ao desativar mudo do microfone.",dismissButtonAriaLabel:"Fechar"},speakingWhileMuted:{title:"Você está com o mudo ativado.",dismissButtonAriaLabel:"Fechar"},startScreenShareGeneric:{title:"Ocorreu um problema ao iniciar o compartilhamento de tela.",dismissButtonAriaLabel:"Fechar"},stopScreenShareGeneric:{title:"Falha ao interromper o compartilhamento de tela.",dismissButtonAriaLabel:"Fechar"},callNetworkQualityLow:{title:"A qualidade da rede é baixa.",dismissButtonAriaLabel:"Fechar"},teamsMeetingCallNetworkQualityLow:{title:"A qualidade da rede é baixa.",dismissButtonAriaLabel:"Fechar",message:"Ingresse nesta chamada do seu telefone para melhorar o som. Você pode continuar exibindo a reunião neste dispositivo.",primaryButtonLabel:"Ingressar por Telefone"},callNoSpeakerFound:{title:"Nenhum alto-falante ou fone de ouvido encontrado",message:"Conecte um dispositivo de áudio para ouvir a chamada.",dismissButtonAriaLabel:"Fechar"},callNoMicrophoneFound:{title:"Nenhum microfone encontrado",message:"Conecte um dispositivo de entrada de áudio.",dismissButtonAriaLabel:"Fechar"},callMicrophoneAccessDenied:{title:"Não é possível acessar o microfone",message:"Clique no bloqueio na barra de endereços para conceder permissão a esta página da Web.",dismissButtonAriaLabel:"Fechar"},callMicrophoneAccessDeniedSafari:{title:"Não é possível acessar o microfone",message:"Atualize a página para permitir permissões ou verifique as configurações deste navegador e verifique se as permissões estão habilitadas para este site.",dismissButtonAriaLabel:"Fechar"},callMicrophoneMutedBySystem:{title:"Você está com as notificações desativada pelo sistema.",dismissButtonAriaLabel:"Fechar"},callMicrophoneUnmutedBySystem:{title:"Seu microfone se recuperou e você foi desativado pelo sistema.",dismissButtonAriaLabel:"Fechar"},callMacOsMicrophoneAccessDenied:{title:"Não é possível acessar o microfone",message:"Conceda permissão ao microfone nas configurações de privacidade do macOS.",dismissButtonAriaLabel:"Fechar"},callLocalVideoFreeze:{title:"A largura de banda da rede é insatisfatória",message:"Seu vídeo pode aparecer em pausa para outras pessoas na chamada.",dismissButtonAriaLabel:"Fechar"},callCameraAccessDenied:{title:"Não é possível acessar a câmera",message:"Clique no bloqueio na barra de endereços para conceder permissão a esta página da Web.",dismissButtonAriaLabel:"Fechar"},callCameraAccessDeniedSafari:{title:"Não é possível acessar a câmera",message:"Atualize a página para permitir permissões ou verifique as configurações deste navegador e verifique se as permissões estão habilitadas para este site.",dismissButtonAriaLabel:"Fechar"},callCameraAlreadyInUse:{title:"Não é possível acessar a câmera",message:"Talvez ele já esteja em uso por outro aplicativo.",dismissButtonAriaLabel:"Fechar"},callVideoStoppedBySystem:{title:"Seu vídeo foi interrompido pelo sistema.",dismissButtonAriaLabel:"Fechar"},callVideoRecoveredBySystem:{title:"Seu vídeo foi retomado.",dismissButtonAriaLabel:"Fechar"},callMacOsCameraAccessDenied:{title:"O MacOS está bloqueando o acesso à sua câmera",message:"Atualize suas configurações de privacidade para permitir que este navegador acesse sua câmera.",dismissButtonAriaLabel:"Fechar"},callMacOsScreenShareAccessDenied:{title:"O MacOS está bloqueando o compartilhamento de tela",message:"Atualize suas configurações de privacidade para permitir que este navegador grave sua tela.",dismissButtonAriaLabel:"Fechar"},failedToJoinCallGeneric:{title:"Falha ao ingressar na chamada.",dismissButtonAriaLabel:"Fechar"},failedToJoinCallInvalidMeetingLink:{title:"Não é possível ingressar na Reunião. Link Inválido.",dismissButtonAriaLabel:"Fechar"},cameraFrozenForRemoteParticipants:{title:"Os usuários na chamada estão enfrentando problemas para ver seu vídeo",message:"Verifique seus dispositivos e rede.",dismissButtonAriaLabel:"Fechar"},unableToStartVideoEffect:{title:"Não é possível aplicar o efeito de vídeo.",dismissButtonAriaLabel:"Fechar"},startSpotlightWhileMaxParticipantsAreSpotlighted:{title:"Não é possível iniciar o destaque nos participantes",message:"O número máximo de participantes já está em destaque.",dismissButtonAriaLabel:"Fechar"},mutedByRemoteParticipant:{title:"Você foi silenciado por outro participante.",dismissButtonAriaLabel:"Fechar"},recordingStarted:{title:"A gravação foi iniciada.",message:"Ao ingressar, você está dando consentimento para que esta reunião seja transcrita.",dismissButtonAriaLabel:"Fechar"},transcriptionStarted:{title:"A transcrição foi iniciada.",message:"Ao ingressar, você está dando consentimento para que esta reunião seja transcrita.",dismissButtonAriaLabel:"Fechar"},recordingStopped:{title:"A gravação está sendo salva.",message:"A gravação foi interrompida.",dismissButtonAriaLabel:"Fechar"},transcriptionStopped:{title:"A transcrição está sendo salva.",message:"A transcrição foi interrompida.",dismissButtonAriaLabel:"Fechar"},recordingAndTranscriptionStarted:{title:"A gravação e a transcrição foram iniciadas.",message:"Ao ingressar, você está dando consentimento para que esta reunião seja transcrita.",dismissButtonAriaLabel:"Fechar"},recordingAndTranscriptionStopped:{title:"A gravação e a transcrição estão sendo salvas.",message:"A gravação e a transcrição foram interrompidas.",dismissButtonAriaLabel:"Fechar"},recordingStoppedStillTranscribing:{title:"A gravação foi interrompida.",message:"Você agora está apenas transcrevendo esta reunião.",dismissButtonAriaLabel:"Fechar"},transcriptionStoppedStillRecording:{title:"A transcrição foi interrompida.",message:"Você agora está apenas gravando esta reunião.",dismissButtonAriaLabel:"Fechar"},assignedBreakoutRoomOpened:{title:"Vamos movê-lo para a sala atribuída em 5 segundos.",dismissButtonAriaLabel:"Fechar"},assignedBreakoutRoomChanged:{title:"Sua sala para sessão de grupo foi alterada",message:"Vamos movê-lo para a sala atribuída em 5 segundos.",dismissButtonAriaLabel:"Fechar"},assignedBreakoutRoomClosed:{title:"Sua sala para sessão de grupo foi fechada",message:"Vamos movê-lo de volta para a reunião em 5 segundos.",dismissButtonAriaLabel:"Fechar"},assignedBreakoutRoomOpenedPromptJoin:{title:"Ingressar na sala para sessão de grupo?",message:"Você foi atribuído a uma sala para sessão de grupo.",dismissButtonAriaLabel:"Fechar",primaryButtonLabel:"Ingressar na sala",secondaryButtonLabel:"Mais tarde"},breakoutRoomJoined:{title:"Você ingressou nem uma sala para sessão de grupo.",dismissButtonAriaLabel:"Fechar"},breakoutRoomClosingSoon:{title:"Limite de tempo de sala prestes a expirar.",message:"Esta sala será fechada em 30 segundos",dismissButtonAriaLabel:"Fechar"},capabilityTurnVideoOnPresent:{title:"Sua câmera foi habilitada",message:"Ativar se quiser compartilhar um vídeo.",dismissButtonAriaLabel:"Fechar"},capabilityTurnVideoOnAbsent:{title:"Sua câmera foi desabilitada",message:"Você não pode mais compartilhar vídeo.",dismissButtonAriaLabel:"Fechar"},capabilityUnmuteMicPresent:{title:"Seu microfone foi habilitado",message:"Desative mudo se quiser falar.",dismissButtonAriaLabel:"Fechar"},capabilityUnmuteMicAbsent:{title:"O microfone foi desabilitado",message:"Você não pode mais ativar o som.",dismissButtonAriaLabel:"Fechar"},togetherModeStarted:{title:"O modo Togethermode foi iniciado",dismissButtonAriaLabel:"Fechar"},togetherModeEnded:{title:"O modo Togethermode foi encerrado",dismissButtonAriaLabel:"Fechar"}},videoGallery:{screenIsBeingSharedMessage:"Você está compartilhando sua tela",screenShareLoadingMessage:"Carregando a tela do {participant}",localScreenShareLoadingMessage:"Carregando sua tela",localVideoLabel:"Você",localVideoCameraSwitcherLabel:"Alternar câmera",localVideoMovementLabel:"Bloco de Vídeo Local Removível",localVideoMovementAriaLabel:"Bloco de Vídeo Local Removível",localVideoSelectedDescription:"{cameraName} selecionado",displayNamePlaceholder:"Participante sem nome",fitRemoteParticipantToFrame:"Ajustar ao quadro",fillRemoteParticipantFrame:"Preencher quadro",pinParticipantForMe:"Fixar para mim",pinParticipantForMeLimitReached:"PIN (limite alcançado)",unpinParticipantForMe:"Desafixar",pinParticipantMenuItemAriaLabel:"Fixar {participantName}",unpinParticipantMenuItemAriaLabel:"Desafixar {participantName}",pinnedParticipantAnnouncementAriaLabel:"Fixado {participantName}",unpinnedParticipantAnnouncementAriaLabel:"Desafixado {participantName}",startSpotlightVideoTileMenuLabel:"Destacar para todos",addSpotlightVideoTileMenuLabel:"Adicionar destaque",spotlightLimitReachedMenuTitle:"Limite de destaque atingido",stopSpotlightVideoTileMenuLabel:"Parar de destacar",stopSpotlightOnSelfVideoTileMenuLabel:"Sair de destaque",attendeeRole:"Participante",muteParticipantMenuItemLabel:"Ativar mudo",waitingScreenText:"Aguardando o ingresso de outros participantes",forbidAudio:"Desabilitar microfone",permitAudio:"Permitir microfone",forbidAudioTileMenuLabel:"Desabilitar microfone",permitAudioTileMenuLabel:"Permitir microfone",forbidVideo:"Desabilitar câmera",permitVideo:"Permitir câmera",forbidVideoTileMenuLabel:"Desabilitar câmera",permitVideoTileMenuLabel:"Permitir câmera"},dialpad:{placeholderText:"Inserir o número do telefone",deleteButtonAriaLabel:"Excluir"},holdButton:{onLabel:"Retomar",offLabel:"Retenção",tooltipOnContent:"Retomar chamada",tooltipOffContent:"Manter chamada em espera"},videoTile:{participantStateRinging:"Chamando...",participantReconnecting:"Reconectando...",participantStateHold:"Em espera",moreOptionsButtonAriaLabel:"Mais Opções {displayName} {isMuted} {micDisabledState} {cameraDisabledState} {isHandRaised} {state} {isSpeaking}",moreOptionsParticipantMutedStateMutedAriaLabel:"silenciado",moreOptionsParticipantMutedStateUnmutedAriaLabel:"mudo desativado",moreOptionsParticipantHandRaisedAriaLabel:"Mão levantada",moreOptionsParticipantIsSpeakingAriaLabel:"Falando",moreOptionsParticipantMicDisabledAriaLabel:"Microfone desabilitado",moreOptionsParticipantCameraDisabledAriaLabel:"Câmera desabilitada"},CameraAndMicrophoneSitePermissionsRequest:{primaryText:"Permitir {appName} usar a câmera e o microfone",secondaryText:"Isso é para que os participantes possam ver e ouvir você.",linkText:"Preciso de ajuda? Obtenha ajuda para solução de problemas",primaryButtonText:"Continuar sem câmera e microfone",ariaLabel:"Permitir acesso à câmera e ao microfone"},CameraSitePermissionsRequest:{primaryText:"Permitir que {appName} use a câmera",secondaryText:"Isso é para que os participantes possam ver você.",linkText:"Preciso de ajuda? Obtenha ajuda para solução de problemas",primaryButtonText:"Continuar sem a câmera",ariaLabel:"Permitir acesso à câmera"},MicrophoneSitePermissionsRequest:{primaryText:"Permitir que {appName} use o microfone",secondaryText:"Isso é para que os participantes possam ouvir você.",linkText:"Preciso de ajuda? Obtenha ajuda para solução de problemas",primaryButtonText:"Continuar sem o microfone",ariaLabel:"Permitir acesso ao microfone"},CameraAndMicrophoneSitePermissionsCheck:{primaryText:"Verificando o acesso à câmera e ao microfone",secondaryText:"Permitir acesso, se solicitado. Isso é para que os participantes possam ver e ouvir você.",linkText:"Preciso de ajuda? Obtenha ajuda para solução de problemas",primaryButtonText:"Continuar sem câmera e microfone",ariaLabel:"Verificando o acesso à câmera e ao microfone. Permitir o acesso se solicitado."},CameraSitePermissionsCheck:{primaryText:"Verificando o acesso à câmera",secondaryText:"Permitir acesso, se solicitado. Isso é para que os participantes possam ver você.",linkText:"Preciso de ajuda? Obtenha ajuda para solução de problemas",primaryButtonText:"Continuar sem câmera",ariaLabel:"Verificando o acesso à câmera. Permitir o acesso se solicitado."},MicrophoneSitePermissionsCheck:{primaryText:"Verificando o acesso ao microfone",secondaryText:"Permitir acesso, se solicitado. Isso é para que os participantes possam ouvir você.",linkText:"Preciso de ajuda? Obtenha ajuda para solução de problemas",primaryButtonText:"Continuar sem microfone",ariaLabel:"Verificando acesso ao microfone. Permitir o acesso se solicitado."},CameraAndMicrophoneSitePermissionsDenied:{primaryText:"Não é possível acessar a câmera e o microfone",secondaryText:"Clique no ícone de bloqueio na barra de endereços para conceder permissões de microfone a esta página da Web. Uma atualização de página pode ser necessária.",primaryButtonText:"Continuar sem câmera e microfone",linkText:"Preciso de ajuda? Obtenha ajuda para solução de problemas"},CameraAndMicrophoneSitePermissionsDeniedSafari:{primaryText:"Não é possível acessar a câmera e o microfone",secondaryText:"Atualize a página para permitir permissões ou verifique as configurações deste navegador e verifique se as permissões estão habilitadas para este site.",primaryButtonText:"Continuar sem câmera e microfone",linkText:"Preciso de ajuda? Obtenha ajuda para solução de problemas"},CameraSitePermissionsDenied:{primaryText:"Não é possível acessar a câmera",secondaryText:"Clique no ícone de bloqueio na barra de endereços para conceder permissões de câmera a esta página da Web. Uma atualização de página pode ser necessária.",primaryButtonText:"Continuar sem a câmera",linkText:"Preciso de ajuda? Obtenha ajuda para solução de problemas"},MicrophoneSitePermissionsDenied:{primaryText:"Não é possível acessar o microfone",secondaryText:"Clique no ícone de bloqueio na barra de endereços para conceder permissões de microfone a esta página da Web. Uma atualização de página pode ser necessária.",primaryButtonText:"Continuar sem microfone",linkText:"Preciso de ajuda? Obtenha ajuda para solução de problemas"},CameraSitePermissionsDeniedSafari:{primaryText:"Não é possível acessar a câmera",secondaryText:"Atualize a página para permitir permissões ou verifique as configurações deste navegador e verifique se as permissões estão habilitadas para este site.",primaryButtonText:"Continuar sem câmera",linkText:"Preciso de ajuda? Obtenha ajuda para solução de problemas"},MicrophoneSitePermissionsDeniedSafari:{primaryText:"Não é possível acessar o microfone",secondaryText:"Atualize a página para permitir permissões ou verifique as configurações deste navegador e verifique se as permissões estão habilitadas para este site.",primaryButtonText:"Continuar sem o microfone",linkText:"Preciso de ajuda? Obtenha ajuda para solução de problemas"},UnsupportedBrowser:{primaryText:"Navegador sem suporte",secondaryText:"Ingresse nesta chamada usando um navegador compatível.",moreHelpLinkText:"Consulte os requisitos de compatibilidade"},UnsupportedBrowserVersion:{primaryText:"Atualização do navegador necessária",secondaryText:"Para garantir a melhor chamada possível, atualize o navegador e tente ingressar na chamada novamente.",moreHelpLinkText:"Consulte os requisitos de compatibilidade",continueAnywayButtonText:"Iniciar chamada sem atualizar"},UnsupportedOperatingSystem:{primaryText:"Sistema operacional sem suporte",secondaryText:"Ingresse nesta chamada usando um dispositivo com um sistema operacional compatível.",moreHelpLinkText:"Consulte os requisitos de compatibilidade"},BrowserPermissionDenied:{primaryText:"Não é possível usar sua câmera ou microfone",secondaryText:"Seu navegador pode não ter acesso à câmera ou ao microfone. Para corrigir isso, abra as Preferências do Sistema.",primaryButtonText:"Tentar novamente",linkText:"Preciso de ajuda? Obtenha ajuda para solução de problemas"},BrowserPermissionDeniedIOS:{primaryText:"Permitir acesso ao microfone para continuar",secondaryText:"Para que outros participantes possam ouvi-lo.",primaryButtonText:"Tentar novamente",imageAltText:"Localização da permissão do microfone e do dispositivo da câmera para iOS",linkText:"Preciso de ajuda? Obtenha ajuda para solução de problemas",step1Text:"Acessar o aplicativo Configurações",step2Text:"Rolar para baixo até as configurações deste navegador",step3Text:"Ligar o microfone (Câmera opcional)",step4Text:"Tentar ingressar na chamada novamente",step1DigitText:"1",step2DigitText:"2",step3DigitText:"3",step4DigitText:"4"},verticalGallery:{leftNavButtonAriaLabel:"página anterior {current} de {total}",rightNavButtonAriaLabel:"próxima página {current} de {total}"},meetingConferencePhoneInfo:{meetingConferencePhoneInfoModalTitle:"Participar da chamada pelo seu telefone",meetingConferencePhoneInfoModalDialIn:"Número de discagem",meetingConferencePhoneInfoModalMeetingId:"Inserir a ID da reunião",meetingConferencePhoneInfoModalWait:"Aguarde para ser aceito pelo organizador",meetingConferencePhoneInfoModalNoPhoneAvailable:"Nenhum telefone disponível",meetingConferencePhoneInfoModalTollGeoData:"{country}, {city}",meetingConferencePhoneInfoModalTollFree:"(Chamada gratuita)",meetingConferencePhoneInfoModalToll:"(Chamada tarifada)"},IncomingCallNotification:{incomingCallNotificationPlaceholderId:"Usuário Desconhecido",incomingCallNotificationPlaceholderAlert:"Chamada de {callerName}",incomingCallNoticicationAcceptWithAudioAriaLabel:"Aceitar com áudio",incomingCallNoticicationAcceptWithVideoAriaLabel:"Aceitar com vídeo",incomingCallNoticicationRejectAriaLabel:"Rejeitar",incomingCallNotificationAcceptButtonLabel:"Aceitar",incomingCallNotificationRejectButtonLabel:"Recusar",incomingCallNotificationAccceptWithVideoButtonLabel:"Aceitar com Vídeo",incomingCallNotificationDismissButtonAriaLabel:"Ignorar"}})},CQt={strings:Jh({participantItem:{isMeText:"(Вы)",menuTitle:"Дополнительные параметры",removeButtonLabel:"Удалить",sharingIconLabel:"Общий доступ",mutedIconLabel:"Микрофон отключен",handRaisedIconLabel:"Поднята рука — позиция {position}",displayNamePlaceholder:"Участник без имени",participantStateRinging:"Выполняется вызов...",participantStateHold:"На удержании",participantItemAriaLabel:"{displayName}, {handRaisedState}, {mutedState}, {micDisabledState}, {cameraDisabledState}, {sharingState}, {connectionState}",participantItemWithMoreOptionsAriaLabel:"{displayName}, {handRaisedState}, {mutedState}, {micDisabledState}, {cameraDisabledState}, {sharingState}, {connectionState}, дополнительные параметры",attendeeRole:"Участник",micDisabledIconLabel:"Микрофон отключен",cameraDisabledIconLabel:"Камера отключена"},ParticipantList:{overflowParticipantCount:"и еще {overflowCount}"},typingIndicator:{singleUser:"{user} вводит текст...",multipleUsers:"{users} вводят текст...",multipleUsersAbbreviateOne:"{users} и еще 1 вводят текст...",multipleUsersAbbreviateMany:"{users} и еще {numOthers} вводят текст...",delimiter:"; "},sendBox:{placeholderText:"Введите сообщение",textTooLong:"Длина сообщения превышает максимально допустимую.",sendButtonAriaLabel:"Отправить сообщение",attachmentUploadsPendingError:"Выполняется отправка файла. Подождите.",removeAttachment:"Удалить файл",uploading:"Отправка",uploadCompleted:"Отправка завершена",attachmentMoreMenu:"Дополнительные параметры"},richTextSendBox:{placeholderText:"Введите сообщение",textTooLong:"Длина сообщения превышает максимально допустимую.",sendButtonAriaLabel:"Отправить сообщение",attachmentUploadsPendingError:"Выполняется отправка файла. Подождите.",imageUploadsPendingError:"Выполняется отправка изображения. Подождите.",removeAttachment:"Удалить файл",uploading:"Отправка",uploadCompleted:"Отправка завершена",richTextBoldTooltip:"Полужирный",richTextItalicTooltip:"Курсив",richTextUnderlineTooltip:"Подчеркнуть",richTextBulletListTooltip:"Маркированный список",richTextNumberListTooltip:"Нумерованный список",richTextIncreaseIndentTooltip:"Увеличить отступ",richTextDecreaseIndentTooltip:"Уменьшить отступ",richTextInsertTableTooltip:"Вставить таблицу",richTextFormatButtonTooltip:"Формат",richTextInsertRowOrColumnMenu:"Вставить",richTextInsertTableMenuTitle:"Вставить таблицу {column} x {row}",richTextInsertRowAboveMenu:"Вставить сверху",richTextInsertRowBelowMenu:"Вставить снизу",richTextInsertColumnLeftMenu:"Вставить слева",richTextInsertColumnRightMenu:"Вставить справа",richTextDeleteRowOrColumnMenu:"Удалить",richTextDeleteColumnMenu:"Удалить столбец",richTextDeleteRowMenu:"Удалить строку",richTextDeleteTableMenu:"Удалить таблицу",richTextToolbarAriaLabel:"Панель инструментов форматирования сообщения",richTextToolbarMoreButtonAriaLabel:"Дополнительные параметры",attachmentMoreMenu:"Дополнительные параметры",richTextNewBulletedListItemAnnouncement:"Маркер, новая строка",richTextNewNumberedListItemAnnouncement:"{0}, новая строка",richTextBulletedListAppliedAnnouncement:"Применен маркированный список",richTextNumberedListAppliedAnnouncement:"Применен нумерованный список"},realTimeTextModal:{realTimeTextModalAriaLabel:"Модальное окно включения ввода в режиме реального времени",realTimeTextModalTitle:"Включить ввод в режиме реального времени?",realTimeTextModalText:"Текст в режиме реального времени (RTT) будет включен для всех участников собрания.",realTimeTextConfirmButtonLabel:"Включить",realTimeTextCancelButtonLabel:"Отмена",realTimeTextCloseModalButtonAriaLabel:"Закрыть модальное окно ввода в режиме реального времени"},captionsBanner:{captionsBannerSpinnerText:"Запуск субтитров...",realTimeTextInputBoxDefaultText:"Введите сообщение в режиме реального времени",realTimeTextInputErrorMessage:"Длина сообщения не может превышать 2000 символов",realTimeTextBannerTitle:"Ввод в режиме реального времени",realTimeTextBannerContent:"Ввод в режиме реального времени включен для всех участников в течение всего собрания.",realTimeTextBannerLinkLabel:"Подробнее",captionsOnlyContainerTitle:"Субтитры",realTimeTextOnlyContainerTitle:"Текст в режиме реального времени",captionsAndRealTimeTextContainerTitle:"Субтитры и текст в реальном времени",expandButtonAriaLabel:"Развернуть",minimizeButtonAriaLabel:"Свернуть"},mentionPopover:{mentionPopoverHeader:"Рекомендации"},imageOverlay:{downloadButtonLabel:"Скачать",dismissButtonAriaLabel:"Закрыть",overlayVisibleMessage:"Наложение сведений об изображении"},messageStatusIndicator:{deliveredAriaLabel:"Сообщение отправлено",deliveredTooltipText:"Отправлено",seenAriaLabel:"Сообщение просмотрено другими пользователями",seenTooltipText:"Просмотрено",readByTooltipText:"Прочитали: {messageThreadReadCount} из {remoteParticipantsCount}",sendingAriaLabel:"Отправка сообщения",sendingTooltipText:"Отправка",failedToSendAriaLabel:"Не удалось отправить сообщение",failedToSendTooltipText:"Не удалось отправить"},endCallButton:{label:"Выйти",tooltipContent:"Покинуть вызов",leaveOption:"Выйти",endCallOption:"Завершить звонок для всех"},cameraButton:{onLabel:"Камера",offLabel:"Камера",tooltipDisabledContent:"Камера отключена",tooltipOnContent:"Выключить камеру",tooltipOffContent:"Включить камеру",tooltipVideoLoadingContent:"Видео загружается",cameraMenuTitle:"Камера",cameraMenuTooltip:"Выбрать камеру",cameraButtonSplitRoleDescription:"Разворачивающаяся кнопка",onSplitButtonAriaLabel:"Отключить камеру",offSplitButtonAriaLabel:"Включить камеру",cameraActionTurnedOnAnnouncement:"Камера включена",cameraActionTurnedOffAnnouncement:"Камера отключена",onSplitButtonPrimaryActionCamera:"Выключить камеру",offSplitButtonPrimaryActionCamera:"Включить камеру",cameraPrimaryActionSplitButtonTitle:"Использовать камеру",videoEffectsMenuItemTitle:"Эффекты",cameraButtonAriaDescription:"параметры камеры"},microphoneButton:{onLabel:"Микрофон",offLabel:"Микрофон",tooltipDisabledContent:"Микрофон отключен",tooltipOnContent:"Отключить микрофон",tooltipOffContent:"Включить микрофон",microphoneMenuTitle:"Микрофон",microphoneMenuTooltip:"Выбрать микрофон",speakerMenuTitle:"Динамик",speakerMenuTooltip:"Выбрать динамик",microphoneButtonSplitRoleDescription:"Разворачивающаяся кнопка",onSplitButtonAriaLabel:"Отключить микрофон",offSplitButtonAriaLabel:"Включить микрофон",microphoneActionTurnedOnAnnouncement:"Ваш микрофон включен",microphoneActionTurnedOffAnnouncement:"Ваш микрофон отключен",offSplitButtonMicrophonePrimaryAction:"Включить микрофон",onSplitButtonMicrophonePrimaryAction:"Отключить микрофон",microphonePrimaryActionSplitButtonTitle:"Использовать микрофон",microphoneAriaDescription:"Параметры звука",deepNoiseSuppressionTitle:"Подавление шума",deepNoiseSuppressionOnAnnouncement:"Глубокое подавление шума включено",deepNoiseSuppressionOffAnnouncement:"Глубокое подавление шума отключено"},devicesButton:{label:"Устройства",tooltipContent:"Управление устройствами",cameraMenuTitle:"Камера",cameraMenuTooltip:"Выбрать камеру",audioDeviceMenuTitle:"Звуковое устройство",audioDeviceMenuTooltip:"Выбрать звуковое устройство",microphoneMenuTitle:"Микрофон",microphoneMenuTooltip:"Выбрать микрофон",speakerMenuTitle:"Динамик",speakerMenuTooltip:"Выбрать динамик"},participantsButton:{label:"Люди",ariaLabel:"Люди",tooltipContent:"Показать участников",menuHeader:"В этом звонке",participantsListButtonLabel:"Пользователей: {numParticipants}",muteAllButtonLabel:"Отключить все микрофоны",copyInviteLinkButtonLabel:"Копировать ссылку с приглашением",copyInviteLinkActionedAriaLabel:"Ссылка на приглашение скопирована"},screenShareButton:{onLabel:"Остановить демонстрацию",offLabel:"Демонстрировать",tooltipDisabledContent:"Демонстрация отключена",tooltipOnContent:"Демонстрация экрана",tooltipOffContent:"Демонстрировать экран"},raiseHandButton:{offLabel:"Поднять руку",onLabel:"Опустить",tooltipDisabledContent:'Действие "Поднять руку" отключено',tooltipOnContent:"Опустить руку",tooltipOffContent:"Поднять руку"},reactionButton:{label:"Отреагировать",ariaLabel:"Отреагировать",tooltipDisabledContent:"Действие реакции отключено",tooltipContent:"Отправка реакции",likeReactionTooltipContent:"Нравится",heartReactionTooltipContent:"Люблю",laughReactionTooltipContent:"Смеюсь",applauseReactionTooltipContent:"Аплодисменты",surprisedReactionTooltipContent:"Удивляюсь"},realTimeText:{isTypingText:"Ввод в режиме реального времени"},captionsSettingsModal:{captionsSettingsModalTitle:"Параметры субтитров",captionsSettingsSpokenLanguageDropdownLabel:"Язык речи",captionsSettingsCaptionLanguageDropdownLabel:"Язык субтитров",captionsSettingsSpokenLanguageDropdownInfoText:"Язык, на котором говорят все участники звонка.",captionsSettingsCaptionLanguageDropdownInfoText:"Субтитры будут отображаться на этом языке.",captionsSettingsConfirmButtonLabel:"Подтвердить",captionsSettingsCancelButtonLabel:"Отмена",captionsSettingsModalAriaLabel:"Модальное окно параметров субтитров",captionsSettingsCloseModalButtonAriaLabel:"Закрыть параметры субтитров"},spokenLanguages:{"ar-ae":"Арабский (ОАЭ)","ar-sa":"Арабский (Саудовская Аравия)","da-dk":"Датский","de-de":"Немецкий (Германия)","en-au":"Английский (Австралия)","en-ca":"Английский (Канада)","en-gb":"Английский (Соединенное Королевство)","en-in":"Английский (Индия)","en-nz":"Английский (Новая Зеландия)","en-us":"Английский (США)","es-es":"Испанский (Испания), современная сортировка","es-mx":"Испанский (Мексика)","fi-fi":"Финский","fr-ca":"Французский (Канада)","fr-fr":"Французский (Франция)","hi-in":"Хинди","it-it":"Итальянский (Италия)","ja-jp":"Японский","ko-kr":"Корейский","nb-no":"Норвежский (букмол)","nl-be":"Нидерландский (Бельгия)","nl-nl":"Нидерландский (Нидерланды)","pl-pl":"Польский","pt-br":"Португальский (Бразилия)","ru-ru":"Русский","sv-se":"Шведский","zh-cn":"Китайский (Китайская Народная Республика)","zh-hk":"Китайский (Гонконг, САР)","cs-cz":"Чешский","pt-pt":"Португальский (Португалия)","tr-tr":"Турецкий","vi-vn":"Вьетнамский","th-th":"Тайский","he-il":"Иврит","cy-gb":"Валлийский","uk-ua":"Украинский","el-gr":"Греческий","hu-hu":"Венгерский","ro-ro":"Румынский","sk-sk":"Словацкий","zh-tw":"Китайский (Тайвань)"},captionLanguages:{ar:"Арабский",da:"Датский",de:"Немецкий",en:"Английский",es:"Испанский",fi:"Финский","fr-ca":"Французский (Канада)",fr:"Французский (Франция)",hi:"Хинди",it:"Итальянский",ja:"Японский",ko:"Корейский",nb:"Норвежский (букмол)",nl:"Голландский",pl:"Польский",pt:"Португальский (Бразилия)",ru:"Русский",sv:"Шведский","zh-Hans":"Китайский (упрощенное письмо)","zh-Hant":"Китайский, традиционное письмо",cs:"Чешский","pt-pt":"Португальский (Португалия)",tr:"Турецкий",vi:"Вьетнамский",th:"Тайский",he:"Иврит",cy:"Валлийский",uk:"Украинский",el:"Греческий",hu:"Венгерский",ro:"Румынский",sk:"Словацкий"},startCaptionsButton:{onLabel:"Включить автоматические субтитры",offLabel:"Отключить автоматические субтитры",tooltipOnContent:"Отключить автоматические субтитры",tooltipOffContent:"Включить автоматические субтитры"},startRealTimeTextButton:{label:"Включить ввод в режиме реального времени для этого звонка",tooltipOffContent:"Включить ввод в режиме реального времени для этого звонка"},messageThread:{yesterday:"Вчера",sunday:"Воскресенье",monday:"Понедельник",tuesday:"Вторник",wednesday:"Среда",thursday:"Четверг",friday:"Пятница",saturday:"Суббота",participantJoined:"присоединился к чату.",participantLeft:"покинул чат.",editMessage:"Изменить",removeMessage:"Удалить",resendMessage:"Отправьте еще раз",failToSendTag:"Не удалось отправить",editedTag:"Изменено",liveAuthorIntro:"Сообщение от пользователя {author}",editedMessageLiveAuthorIntro:"Отредактированное сообщение от пользователя {author}",editedMessageLocalUserLiveAuthorIntro:"Отредактированное сообщение",messageContentAriaText:"{status} {author} говорит: {message}",messageContentMineAriaText:"{status} Вы сказали: {message}",editBoxTextLimit:"Превышено предельное число символов в {limitNumber} сообщении",editBoxPlaceholderText:"Отредактируйте сообщение",newMessagesIndicator:"Новые сообщения",noDisplayNameSub:"Без имени",editBoxCancelButton:"Отмена",editBoxSubmitButton:"Готово",messageReadCount:"Прочитали: {messageReadByCount} из {remoteParticipantsCount}",actionMenuMoreOptions:"Дополнительные параметры",downloadAttachment:"Скачать файл",openAttachment:"Открыть файл",blockedWarningText:"Это сообщение было удалено политикой организации.",blockedWarningLinkText:"Сведения",attachmentCardGroupMessage:"Сообщение содержит {attachmentCount} вложение",messageDeletedAnnouncementAriaLabel:"Сообщение удалено",richTextBoldTooltip:"Полужирный",richTextItalicTooltip:"Курсив",richTextUnderlineTooltip:"Подчеркнутый",richTextBulletListTooltip:"Маркированный список",richTextNumberListTooltip:"Нумерованный список",richTextIncreaseIndentTooltip:"Увеличить отступ",richTextDecreaseIndentTooltip:"Уменьшить отступ",richTextInsertTableTooltip:"Вставить таблицу",richTextFormatButtonTooltip:"Форматирование",richTextInsertRowOrColumnMenu:"Вставить",richTextInsertTableMenuTitle:"Вставить таблицу {column} x {row}",richTextInsertRowAboveMenu:"Вставить сверху",richTextInsertRowBelowMenu:"Вставить снизу",richTextInsertColumnLeftMenu:"Вставить слева",richTextInsertColumnRightMenu:"Вставить справа",richTextDeleteRowOrColumnMenu:"Удалить",richTextDeleteColumnMenu:"Удалить столбец",richTextDeleteRowMenu:"Удалить строку",richTextDeleteTableMenu:"Удалить таблицу",richTextToolbarMoreButtonAriaLabel:"Дополнительные параметры",attachmentUploadsPendingError:"Выполняется отправка файла. Подождите.",imageUploadsPendingError:"Выполняется отправка изображения. Подождите.",richTextNewBulletedListItemAnnouncement:"Маркер, новая строка",richTextNewNumberedListItemAnnouncement:"{0}, новая строка",richTextBulletedListAppliedAnnouncement:"Применен маркированный список",richTextNumberedListAppliedAnnouncement:"Применен нумерованный список"},errorBar:{unableToReachChatService:"Вы не в сети",accessDenied:"Не удалось получить доступ к службам чата. Проверьте предоставленные учетные данные пользователя",userNotInChatThread:"Вы больше не находитесь в цепочке этого чата",sendMessageNotInChatThread:"Не удалось отправить сообщение, так как вы больше не находитесь в цепочке этого чата",sendMessageGeneric:"Не удалось отправить сообщение",callingNetworkFailure:"Тревожное подключение вызова — кажется, вы не в сети",startVideoGeneric:"Не удалось запустить видео",stopVideoGeneric:"Не удалось остановить видео",muteGeneric:"Не удалось отключить микрофон",unmuteGeneric:"Не удалось включить микрофон",speakingWhileMuted:"Микрофон отключен",startScreenShareGeneric:"Возникла проблема с запуском демонстрации экрана.",stopScreenShareGeneric:"Не удалось остановить демонстрацию экрана",callNetworkQualityLow:"Качество работы сети: низкое.",teamsMeetingCallNetworkQualityLow:"Качество работы сети: низкое.",callNoSpeakerFound:"Динамики и наушники не найдены. Подключите звуковое устройство, чтобы услышать звонок.",callNoMicrophoneFound:"Микрофоны не найдены. Подключение звукового устройства ввода.",callMicrophoneAccessDenied:"Не удается получить доступ к микрофону. Щелкните блокировку в адресной строке, чтобы предоставить разрешение на эту веб-страницу.",callMicrophoneAccessDeniedSafari:"Не удается получить доступ к микрофону. Обновите страницу, чтобы разрешить разрешения, или проверьте параметры браузера и убедитесь, что для этого веб-сайта включены разрешения.",callMicrophoneMutedBySystem:"Система отключила ваш микрофон.",callMicrophoneUnmutedBySystem:"Микрофон восстановлен, и система включила ваш звук.",callMacOsMicrophoneAccessDenied:"Не удается получить доступ к микрофону. Предоставьте разрешение на доступ к микрофону в параметрах конфиденциальности macOS.",callLocalVideoFreeze:"Низкая пропускная способность сети. Ваше видео может отображаться как приостановленное для других участников вызова.",callCameraAccessDenied:"Не удается получить доступ к камере. Щелкните блокировку в адресной строке, чтобы предоставить разрешение на эту веб-страницу.",callCameraAccessDeniedSafari:"Не удается получить доступ к камере. Обновите страницу, чтобы разрешить разрешения, или проверьте параметры браузера и убедитесь, что для этого веб-сайта включены разрешения.",callCameraAlreadyInUse:"Не удается получить доступ к камере. Возможно, оно уже используется другим приложением.",callVideoStoppedBySystem:"Воспроизведение видео остановлено системой.",callVideoRecoveredBySystem:"Воспроизведение видео возобновлено.",callMacOsCameraAccessDenied:"MacOS блокирует доступ к камере. Обновите параметры конфиденциальности, чтобы разрешить этому браузеру доступ к камере.",callMacOsScreenShareAccessDenied:"MacOS блокирует демонстрацию экрана. Обновите параметры конфиденциальности, чтобы разрешить этому браузеру записывать ваш экран.",dismissButtonAriaLabel:"Закрыть",failedToJoinCallGeneric:"Не удалось присоединиться к звонку.",failedToJoinCallInvalidMeetingLink:"Не удалось присоединиться к собранию. Недопустимая ссылка.",cameraFrozenForRemoteParticipants:"У участников звонка возникают проблемы с просмотром вашего видео. Проверьте свои устройства и сеть.",unableToStartVideoEffect:"Не удалось применить эффект видео.",startSpotlightWhileMaxParticipantsAreSpotlighted:"Не удается запустить закрепление участников, так как достигнуто предельное число закрепленных участников.",mutedByRemoteParticipant:"Ваш микрофон отключен другим участником."},notificationStack:{callingNetworkFailure:{title:"Проблемы с подключением к телефону",message:"Похоже, вы не в сети. Проверьте сетевое подключение и повторите попытку.",dismissButtonAriaLabel:"Закрыть"},startVideoGeneric:{title:"Не удалось запустить видео.",dismissButtonAriaLabel:"Закрыть"},stopVideoGeneric:{title:"Не удалось остановить видео.",dismissButtonAriaLabel:"Закрыть"},muteGeneric:{title:"Не удалось отключить микрофон.",dismissButtonAriaLabel:"Закрыть"},unmuteGeneric:{title:"Не удалось включить микрофон.",dismissButtonAriaLabel:"Закрыть"},speakingWhileMuted:{title:"Ваш микрофон отключен.",dismissButtonAriaLabel:"Закрыть"},startScreenShareGeneric:{title:"Возникла проблема с запуском демонстрации экрана.",dismissButtonAriaLabel:"Закрыть"},stopScreenShareGeneric:{title:"Не удалось остановить демонстрацию экрана.",dismissButtonAriaLabel:"Закрыть"},callNetworkQualityLow:{title:"Качество работы сети: низкое.",dismissButtonAriaLabel:"Закрыть"},teamsMeetingCallNetworkQualityLow:{title:"Качество работы сети: низкое.",dismissButtonAriaLabel:"Закрыть",message:"Присоединяйтесь к звонку с телефона, чтобы улучшить звук. Вы можете продолжить просмотр собрания на этом устройстве.",primaryButtonLabel:"Присоединиться по телефону"},callNoSpeakerFound:{title:"Динамики и наушники не найдены",message:"Подключите звуковое устройство, чтобы прослушать звонок.",dismissButtonAriaLabel:"Закрыть"},callNoMicrophoneFound:{title:"Микрофоны не найдены",message:"Подключите устройство ввода звука.",dismissButtonAriaLabel:"Закрыть"},callMicrophoneAccessDenied:{title:"Не удается получить доступ к микрофону",message:"Щелкните блокировку в адресной строке, чтобы предоставить разрешение на доступ к этой веб-странице.",dismissButtonAriaLabel:"Закрыть"},callMicrophoneAccessDeniedSafari:{title:"Не удается получить доступ к микрофону",message:"Обновите страницу, чтобы предоставить разрешения, или проверьте параметры браузера и включите разрешения для этого веб-сайта.",dismissButtonAriaLabel:"Закрыть"},callMicrophoneMutedBySystem:{title:"Система отключила ваш микрофон.",dismissButtonAriaLabel:"Закрыть"},callMicrophoneUnmutedBySystem:{title:"Микрофон восстановлен, и система включила ваш звук.",dismissButtonAriaLabel:"Закрыть"},callMacOsMicrophoneAccessDenied:{title:"Не удается получить доступ к микрофону",message:"Предоставьте разрешение на доступ к микрофону в параметрах конфиденциальности macOS.",dismissButtonAriaLabel:"Закрыть"},callLocalVideoFreeze:{title:"Низкая пропускная способность сети",message:"Ваше видео может отображаться как приостановленное для других участников звонка.",dismissButtonAriaLabel:"Закрыть"},callCameraAccessDenied:{title:"Не удается получить доступ к камере",message:"Щелкните блокировку в адресной строке, чтобы предоставить разрешение на доступ к этой веб-странице.",dismissButtonAriaLabel:"Закрыть"},callCameraAccessDeniedSafari:{title:"Не удается получить доступ к камере",message:"Обновите страницу, чтобы предоставить разрешения, или проверьте параметры браузера и включите разрешения для этого веб-сайта.",dismissButtonAriaLabel:"Закрыть"},callCameraAlreadyInUse:{title:"Не удается получить доступ к камере",message:"Возможно, оно уже используется другим приложением.",dismissButtonAriaLabel:"Закрыть"},callVideoStoppedBySystem:{title:"Воспроизведение видео остановлено системой.",dismissButtonAriaLabel:"Закрыть"},callVideoRecoveredBySystem:{title:"Воспроизведение видео возобновлено.",dismissButtonAriaLabel:"Закрыть"},callMacOsCameraAccessDenied:{title:"MacOS блокирует доступ к камере",message:"Обновите параметры конфиденциальности, чтобы разрешить этому браузеру доступ к камере.",dismissButtonAriaLabel:"Закрыть"},callMacOsScreenShareAccessDenied:{title:"MacOS блокирует совместное использование экрана",message:"Обновите параметры конфиденциальности, чтобы разрешить этому браузеру записывать ваш экран.",dismissButtonAriaLabel:"Закрыть"},failedToJoinCallGeneric:{title:"Не удалось присоединиться к вызову.",dismissButtonAriaLabel:"Закрыть"},failedToJoinCallInvalidMeetingLink:{title:"Не удалось присоединиться к собранию. Недопустимая ссылка.",dismissButtonAriaLabel:"Закрыть"},cameraFrozenForRemoteParticipants:{title:"У пользователей звонка возникли проблемы с просмотром видео",message:"Проверьте свои устройства и сеть.",dismissButtonAriaLabel:"Закрыть"},unableToStartVideoEffect:{title:"Не удалось применить эффект видео.",dismissButtonAriaLabel:"Закрыть"},startSpotlightWhileMaxParticipantsAreSpotlighted:{title:"Не удается запустить интересное для участников",message:"Максимальное число участников уже в фокусе.",dismissButtonAriaLabel:"Закрыть"},mutedByRemoteParticipant:{title:"Микрофон отключен другим участником.",dismissButtonAriaLabel:"Закрыть"},recordingStarted:{title:"Запись начата.",message:"Присоединяясь, вы даете согласие на транскрибирование этого собрания.",dismissButtonAriaLabel:"Закрыть"},transcriptionStarted:{title:"Транскрибирование запущено.",message:"Присоединяясь, вы даете согласие на транскрибирование этого собрания.",dismissButtonAriaLabel:"Закрыть"},recordingStopped:{title:"Сохранение записи.",message:"Запись прекращена.",dismissButtonAriaLabel:"Закрыть"},transcriptionStopped:{title:"Сохранение транскрибирования.",message:"Транскрибирование остановлено.",dismissButtonAriaLabel:"Закрыть"},recordingAndTranscriptionStarted:{title:"Начата запись и транскрибирование.",message:"Присоединяясь, вы даете согласие на транскрибирование этого собрания.",dismissButtonAriaLabel:"Закрыть"},recordingAndTranscriptionStopped:{title:"Сохранение записи и транскрибирования.",message:"Запись и транскрибирование остановлены.",dismissButtonAriaLabel:"Закрыть"},recordingStoppedStillTranscribing:{title:"Запись прекращена.",message:"Сейчас для этого собрания ведется только транскрибирование.",dismissButtonAriaLabel:"Закрыть"},transcriptionStoppedStillRecording:{title:"Транскрибирование остановлено.",message:"Сейчас для этого собрания ведется только запись.",dismissButtonAriaLabel:"Закрыть"},assignedBreakoutRoomOpened:{title:"Мы переместим вас в назначенную комнату через 5 секунд.",dismissButtonAriaLabel:"Закрыть"},assignedBreakoutRoomChanged:{title:"Переговорная комната изменилась",message:"Мы переместим вас в назначенную комнату через 5 секунд.",dismissButtonAriaLabel:"Закрыть"},assignedBreakoutRoomClosed:{title:"Ваша переговорная комната закрыта",message:"Мы перенастроим вас обратно на собрание через 5 секунд.",dismissButtonAriaLabel:"Закрыть"},assignedBreakoutRoomOpenedPromptJoin:{title:"Присоединиться к переговорной комнате?",message:"Вам назначена переговорная комната.",dismissButtonAriaLabel:"Закрыть",primaryButtonLabel:"Присоединиться к комнате",secondaryButtonLabel:"Позже"},breakoutRoomJoined:{title:"Вы присоединились к переговорной комнате.",dismissButtonAriaLabel:"Закрыть"},breakoutRoomClosingSoon:{title:"Скоро будет достигнуто ограничение времени для комнаты.",message:"Эта комната будет закрыта через 30 секунд",dismissButtonAriaLabel:"Закрыть"},capabilityTurnVideoOnPresent:{title:"Камера включена",message:"Включите этот параметр, если хотите демонстрировать видео.",dismissButtonAriaLabel:"Закрыть"},capabilityTurnVideoOnAbsent:{title:"Ваша камера отключена",message:"Вы больше не можете демонстрировать видео.",dismissButtonAriaLabel:"Закрыть"},capabilityUnmuteMicPresent:{title:"Ваш микрофон включен",message:"Включите микрофон, если хотите что-то сказать.",dismissButtonAriaLabel:"Закрыть"},capabilityUnmuteMicAbsent:{title:"Ваш микрофон отключен",message:"Вы больше не можете включать звук.",dismissButtonAriaLabel:"Закрыть"},togetherModeStarted:{title:'Режим "Вместе" запущен',dismissButtonAriaLabel:"Закрыть"},togetherModeEnded:{title:'Режим "Вместе" завершен',dismissButtonAriaLabel:"Закрыть"}},videoGallery:{screenIsBeingSharedMessage:"Вы демонстрируете свой экран",screenShareLoadingMessage:"Загрузка экрана пользователя {participant}",localScreenShareLoadingMessage:"Загрузка экрана",localVideoLabel:"Вы",localVideoCameraSwitcherLabel:"Переключить камеру",localVideoMovementLabel:"Перемещаемая локальная плитка видео",localVideoMovementAriaLabel:"Перемещаемая локальная плитка видео",localVideoSelectedDescription:"Выбрана камера {cameraName}",displayNamePlaceholder:"Участник без имени",fitRemoteParticipantToFrame:"Вписать в кадр",fillRemoteParticipantFrame:"Заполнить кадр",pinParticipantForMe:"Закрепить для меня",pinParticipantForMeLimitReached:"Закрепить (достигнуто ограничение)",unpinParticipantForMe:"Открепить",pinParticipantMenuItemAriaLabel:"Закрепить участника {participantName}",unpinParticipantMenuItemAriaLabel:"Открепить участника {participantName}",pinnedParticipantAnnouncementAriaLabel:"Участник {participantName} закреплен",unpinnedParticipantAnnouncementAriaLabel:"Участник {participantName} откреплен",startSpotlightVideoTileMenuLabel:"Закрепить видео для всех",addSpotlightVideoTileMenuLabel:"Добавить закрепление",spotlightLimitReachedMenuTitle:"Достигнуто предельное число закреплений",stopSpotlightVideoTileMenuLabel:"Не закреплять",stopSpotlightOnSelfVideoTileMenuLabel:"Открепить",attendeeRole:"Участник",muteParticipantMenuItemLabel:"Отключить микрофон",waitingScreenText:"Ожидание присоединения других участников",forbidAudio:"Отключить микрофон",permitAudio:"Разрешить использовать микрофон",forbidAudioTileMenuLabel:"Отключить микрофон",permitAudioTileMenuLabel:"Разрешить использовать микрофон",forbidVideo:"Выключить камеру",permitVideo:"Разрешить использовать камеру",forbidVideoTileMenuLabel:"Выключить камеру",permitVideoTileMenuLabel:"Разрешить использовать камеру"},dialpad:{placeholderText:"Введите номер телефона",deleteButtonAriaLabel:"Удалить"},holdButton:{onLabel:"Возобновить",offLabel:"Удержать",tooltipOnContent:"Возобновить звонок",tooltipOffContent:"Поставить звонок на удержание"},videoTile:{participantStateRinging:"Выполняется вызов...",participantReconnecting:"Повторное подключение...",participantStateHold:"На удержании",moreOptionsButtonAriaLabel:"Дополнительные параметры {displayName} {isMuted} {micDisabledState} {cameraDisabledState} {isHandRaised} {state} {isSpeaking}",moreOptionsParticipantMutedStateMutedAriaLabel:"звук отключен",moreOptionsParticipantMutedStateUnmutedAriaLabel:"звук включен",moreOptionsParticipantHandRaisedAriaLabel:"Поднята рука",moreOptionsParticipantIsSpeakingAriaLabel:"Говорит",moreOptionsParticipantMicDisabledAriaLabel:"Микрофон отключен",moreOptionsParticipantCameraDisabledAriaLabel:"Камера отключена"},CameraAndMicrophoneSitePermissionsRequest:{primaryText:"Разрешить {appName} использовать камеру и микрофон",secondaryText:"Это необходимо для того, чтобы участники могли видеть и слышать вас.",linkText:"Нужна помощь? Получите справку по устранению неполадок",primaryButtonText:"Продолжить без камеры и микрофона",ariaLabel:"Разрешить доступ к камере и микрофону"},CameraSitePermissionsRequest:{primaryText:"Разрешите приложению {appName} использовать камеру",secondaryText:"Это необходимо для того, чтобы участники могли вас видеть.",linkText:"Нужна помощь? Получите справку по устранению неполадок",primaryButtonText:"Продолжить без камеры",ariaLabel:"Разрешить доступ к камере"},MicrophoneSitePermissionsRequest:{primaryText:"Разрешите приложению {appName} использовать микрофон",secondaryText:"Это делается для того, чтобы участники могли вас слышать.",linkText:"Нужна помощь? Получите справку по устранению неполадок",primaryButtonText:"Продолжить без микрофона",ariaLabel:"Разрешить доступ к микрофону"},CameraAndMicrophoneSitePermissionsCheck:{primaryText:"Проверка доступа к камере и микрофону",secondaryText:"Разрешить доступ при запросе. Это делается для того, чтобы участники могли вас видеть и слышать.",linkText:"Нужна помощь? Получите справку по устранению неполадок",primaryButtonText:"Продолжить без камеры и микрофона",ariaLabel:"Проверка доступа к камере и микрофону. Разрешить доступ при запросе."},CameraSitePermissionsCheck:{primaryText:"Проверка доступа к камере",secondaryText:"Разрешить доступ при запросе. Это необходимо для того, чтобы участники могли вас видеть.",linkText:"Нужна помощь? Получите справку по устранению неполадок",primaryButtonText:"Продолжить без камеры",ariaLabel:"Проверка доступа к камере. Разрешить доступ при запросе."},MicrophoneSitePermissionsCheck:{primaryText:"Проверка доступа к микрофону",secondaryText:"Разрешить доступ при запросе. Это делается для того, чтобы участники могли вас слышать.",linkText:"Нужна помощь? Получите справку по устранению неполадок",primaryButtonText:"Продолжить без микрофона",ariaLabel:"Проверка доступа к микрофону. Разрешить доступ при запросе."},CameraAndMicrophoneSitePermissionsDenied:{primaryText:"Не удается получить доступ к камере и микрофону",secondaryText:"Щелкните значок блокировки в адресной строке, чтобы предоставить разрешение на доступ к микрофону для этой веб-страницы. Может потребоваться обновление страницы.",primaryButtonText:"Продолжить без камеры и микрофона",linkText:"Нужна помощь? Получите справку по устранению неполадок"},CameraAndMicrophoneSitePermissionsDeniedSafari:{primaryText:"Не удается получить доступ к камере и микрофону",secondaryText:"Обновите страницу, чтобы предоставить разрешения, или проверьте параметры браузера и включите разрешения для этого веб-сайта.",primaryButtonText:"Продолжить без камеры и микрофона",linkText:"Нужна помощь? Получите справку по устранению неполадок"},CameraSitePermissionsDenied:{primaryText:"Не удается получить доступ к камере",secondaryText:"Щелкните значок блокировки в адресной строке, чтобы предоставить разрешения камеры для этой веб-страницы. Может потребоваться обновить страницу.",primaryButtonText:"Продолжить без камеры",linkText:"Нужна помощь? Получите справку по устранению неполадок"},MicrophoneSitePermissionsDenied:{primaryText:"Не удается получить доступ к микрофону",secondaryText:"Щелкните значок блокировки в адресной строке, чтобы предоставить разрешение на доступ к микрофону для этой веб-страницы. Может потребоваться обновление страницы.",primaryButtonText:"Продолжить без микрофона",linkText:"Нужна помощь? Получите справку по устранению неполадок"},CameraSitePermissionsDeniedSafari:{primaryText:"Не удается получить доступ к камере",secondaryText:"Обновите страницу, чтобы предоставить разрешения, или проверьте параметры браузера и включите разрешения для этого веб-сайта.",primaryButtonText:"Продолжить без камеры",linkText:"Нужна помощь? Получите справку по устранению неполадок"},MicrophoneSitePermissionsDeniedSafari:{primaryText:"Не удается получить доступ к микрофону",secondaryText:"Обновите страницу, чтобы предоставить разрешения, или проверьте параметры браузера и включите разрешения для этого веб-сайта.",primaryButtonText:"Продолжить без микрофона",linkText:"Нужна помощь? Получите справку по устранению неполадок"},UnsupportedBrowser:{primaryText:"Браузер не поддерживается",secondaryText:"Присоединитесь к этому вызову с помощью совместимого браузера.",moreHelpLinkText:"См. требования к совместимости"},UnsupportedBrowserVersion:{primaryText:"Необходимо обновление браузера",secondaryText:"Чтобы обеспечить наилучший возможный звонок, обновите браузер и попробуйте присоединиться к звонку еще раз.",moreHelpLinkText:"См. требования к совместимости",continueAnywayButtonText:"Начать звонок без обновления"},UnsupportedOperatingSystem:{primaryText:"Операционная система не поддерживается",secondaryText:"Присоединитесь к этому вызову, используя устройство с совместимой операционной системой.",moreHelpLinkText:"См. требования к совместимости"},BrowserPermissionDenied:{primaryText:"Не удается использовать камеру или микрофон",secondaryText:"Возможно, у вашего браузера нет доступа к камере или микрофону. Чтобы устранить эту проблему, откройте параметры системы.",primaryButtonText:"Повторить попытку",linkText:"Нужна помощь? Получите справку по устранению неполадок"},BrowserPermissionDeniedIOS:{primaryText:"Разрешите доступ к микрофону, чтобы продолжить",secondaryText:"Таким образом, другие участники могут вас слышать.",primaryButtonText:"Повторить попытку",imageAltText:"Разрешение на доступ к микрофону и камере для iOS",linkText:"Нужна помощь? Получите справку по устранению неполадок",step1Text:'Перейдите в приложение "Параметры"',step2Text:"Прокрутите страницу вниз до параметров этого браузера",step3Text:"Включите микрофон (камера необязательна)",step4Text:"Попробуйте присоединиться к вызову еще раз",step1DigitText:"1",step2DigitText:"2",step3DigitText:"3",step4DigitText:"4"},verticalGallery:{leftNavButtonAriaLabel:"предыдущая страница {current} из {total}",rightNavButtonAriaLabel:"следующая страница {current} из {total}"},meetingConferencePhoneInfo:{meetingConferencePhoneInfoModalTitle:"Присоединиться к вызову с телефона",meetingConferencePhoneInfoModalDialIn:"Набрать номер",meetingConferencePhoneInfoModalMeetingId:"Введите идентификатор собрания",meetingConferencePhoneInfoModalWait:"Подождите, пока организатор допустит вас",meetingConferencePhoneInfoModalNoPhoneAvailable:"Нет доступных телефонов",meetingConferencePhoneInfoModalTollGeoData:"{country}, {city}",meetingConferencePhoneInfoModalTollFree:"(бесплатный)",meetingConferencePhoneInfoModalToll:"(платный)"},IncomingCallNotification:{incomingCallNotificationPlaceholderId:"Неизвестный пользователь",incomingCallNotificationPlaceholderAlert:"{callerName} звонит",incomingCallNoticicationAcceptWithAudioAriaLabel:"Ответить голосом",incomingCallNoticicationAcceptWithVideoAriaLabel:"Принять видеозвонок",incomingCallNoticicationRejectAriaLabel:"Отклонить",incomingCallNotificationAcceptButtonLabel:"Принять",incomingCallNotificationRejectButtonLabel:"Отклонить",incomingCallNotificationAccceptWithVideoButtonLabel:"Ответить с видео",incomingCallNotificationDismissButtonAriaLabel:"Закрыть"}})},_Qt={strings:Jh({participantItem:{isMeText:"(du)",menuTitle:"Fler alternativ",removeButtonLabel:"Ta bort",sharingIconLabel:"Delar",mutedIconLabel:"Ljudet är avstängt",handRaisedIconLabel:"Upphöjt hand – position {position}",displayNamePlaceholder:"Namnlös deltagare",participantStateRinging:"Ringer...",participantStateHold:"Parkerat",participantItemAriaLabel:"{displayName}, {handRaisedState}, {mutedState}, {micDisabledState}, {cameraDisabledState}, {sharingState}, {connectionState}",participantItemWithMoreOptionsAriaLabel:"{displayName}, {handRaisedState}, {mutedState}, {micDisabledState}, {cameraDisabledState}, {sharingState}, {connectionState}, fler alternativ",attendeeRole:"Deltagare",micDisabledIconLabel:"Mikrofonen är inaktiverad",cameraDisabledIconLabel:"Kameran är inaktiverad"},ParticipantList:{overflowParticipantCount:"+{overflowCount} till"},typingIndicator:{singleUser:"{user} skriver...",multipleUsers:"{users} skriver...",multipleUsersAbbreviateOne:"{users} och 1 annan skriver...",multipleUsersAbbreviateMany:"{users} och {numOthers} andra skriver...",delimiter:", "},sendBox:{placeholderText:"Skriv ett meddelande",textTooLong:"Meddelandelängden överskrider maxgränsen.",sendButtonAriaLabel:"Skicka meddelande",attachmentUploadsPendingError:"Filen laddas upp. Vänta.",removeAttachment:"Ta bort fil",uploading:"Laddar upp",uploadCompleted:"Uppladdningen har slutförts",attachmentMoreMenu:"Fler alternativ"},richTextSendBox:{placeholderText:"Skriv ett meddelande",textTooLong:"Meddelandelängden överskrider maxgränsen.",sendButtonAriaLabel:"Skicka meddelande",attachmentUploadsPendingError:"Filen laddas upp. Vänta.",imageUploadsPendingError:"Bilden laddas upp. Vänta.",removeAttachment:"Ta bort filen",uploading:"Laddar upp",uploadCompleted:"Uppladdningen har slutförts",richTextBoldTooltip:"Fet",richTextItalicTooltip:"Kursiv",richTextUnderlineTooltip:"Understruken",richTextBulletListTooltip:"Punktlista",richTextNumberListTooltip:"Numrerad lista",richTextIncreaseIndentTooltip:"Öka indrag",richTextDecreaseIndentTooltip:"Minska indrag",richTextInsertTableTooltip:"Infoga tabell",richTextFormatButtonTooltip:"Format",richTextInsertRowOrColumnMenu:"Infoga",richTextInsertTableMenuTitle:"Infoga tabell på {column} x {row}",richTextInsertRowAboveMenu:"Infoga ovan",richTextInsertRowBelowMenu:"Infoga nedanför",richTextInsertColumnLeftMenu:"Infoga till vänster",richTextInsertColumnRightMenu:"Infoga till höger",richTextDeleteRowOrColumnMenu:"Ta bort",richTextDeleteColumnMenu:"Ta bort kolumn",richTextDeleteRowMenu:"Ta bort rad",richTextDeleteTableMenu:"Ta bort tabell",richTextToolbarAriaLabel:"Verktygsfältet Meddelandeformatering",richTextToolbarMoreButtonAriaLabel:"Fler alternativ",attachmentMoreMenu:"Fler alternativ",richTextNewBulletedListItemAnnouncement:"Punkt, ny rad",richTextNewNumberedListItemAnnouncement:"{0}, ny rad",richTextBulletedListAppliedAnnouncement:"Punktlista tillämpad",richTextNumberedListAppliedAnnouncement:"Numrerad tillämpad"},realTimeTextModal:{realTimeTextModalAriaLabel:"Aktivera RTT-modal",realTimeTextModalTitle:"Aktivera RTT?",realTimeTextModalText:"Realtidstext (RTT) aktiveras för alla i mötet.",realTimeTextConfirmButtonLabel:"Aktivera",realTimeTextCancelButtonLabel:"Avbryt",realTimeTextCloseModalButtonAriaLabel:"Stäng RTT-modal"},captionsBanner:{captionsBannerSpinnerText:"Startar undertexter ...",realTimeTextInputBoxDefaultText:"Skriv meddelande i realtid",realTimeTextInputErrorMessage:"Meddelandet får inte överstiga 2 000 tecken",realTimeTextBannerTitle:"RTT",realTimeTextBannerContent:"RTT (realtidstext) är aktiverat för alla deltagare under hela mötets varaktighet.",realTimeTextBannerLinkLabel:"Mer information",captionsOnlyContainerTitle:"Undertext",realTimeTextOnlyContainerTitle:"Text i realtid",captionsAndRealTimeTextContainerTitle:"Undertexter och text i realtid",expandButtonAriaLabel:"Visa",minimizeButtonAriaLabel:"Dölj"},mentionPopover:{mentionPopoverHeader:"Förslag"},imageOverlay:{downloadButtonLabel:"Ladda ner",dismissButtonAriaLabel:"Stäng",overlayVisibleMessage:"Bilddetaljöverlägg"},messageStatusIndicator:{deliveredAriaLabel:"Meddelandet har skickats",deliveredTooltipText:"Skickat",seenAriaLabel:"Meddelande som andra ser",seenTooltipText:"Sett",readByTooltipText:"Läst av {messageThreadReadCount} av {remoteParticipantsCount}",sendingAriaLabel:"Meddelandet skickas",sendingTooltipText:"Skickar",failedToSendAriaLabel:"Meddelandet skickades inte",failedToSendTooltipText:"Inte skickat"},endCallButton:{label:"Lämna",tooltipContent:"Lämna samtal",leaveOption:"Lämna",endCallOption:"Avsluta samtal för alla"},cameraButton:{onLabel:"Kamera",offLabel:"Kamera",tooltipDisabledContent:"Kameran är inaktiverad",tooltipOnContent:"Stäng av kameran",tooltipOffContent:"Aktivera kameran",tooltipVideoLoadingContent:"Videon läses in",cameraMenuTitle:"Kamera",cameraMenuTooltip:"Välj kamera",cameraButtonSplitRoleDescription:"Delningsknapp",onSplitButtonAriaLabel:"Stäng av kameran",offSplitButtonAriaLabel:"Aktivera kameran",cameraActionTurnedOnAnnouncement:"Kameran har aktiverats",cameraActionTurnedOffAnnouncement:"Kameran har stängts av",onSplitButtonPrimaryActionCamera:"Stäng av kameran",offSplitButtonPrimaryActionCamera:"Aktivera kameran",cameraPrimaryActionSplitButtonTitle:"Använd kamera",videoEffectsMenuItemTitle:"Effekter",cameraButtonAriaDescription:"kameraalternativ"},microphoneButton:{onLabel:"Mikrofon",offLabel:"Mikrofon",tooltipDisabledContent:"Mikrofonen är inaktiverad",tooltipOnContent:"Stäng av mikrofonen",tooltipOffContent:"Slå på mikrofonen",microphoneMenuTitle:"Mikrofon",microphoneMenuTooltip:"Välj mikrofon",speakerMenuTitle:"Högtalare",speakerMenuTooltip:"Välj högtalare",microphoneButtonSplitRoleDescription:"Delningsknapp",onSplitButtonAriaLabel:"Inaktivera mikrofonen",offSplitButtonAriaLabel:"Slå på mikrofonen",microphoneActionTurnedOnAnnouncement:"Mikrofonen har aktiverats",microphoneActionTurnedOffAnnouncement:"Mikrofonen har inaktiverats",offSplitButtonMicrophonePrimaryAction:"Slå på mikrofonen",onSplitButtonMicrophonePrimaryAction:"Inaktivera mikrofonen",microphonePrimaryActionSplitButtonTitle:"Använd mikrofon",microphoneAriaDescription:"Ljudalternativ",deepNoiseSuppressionTitle:"Ljuddämpning",deepNoiseSuppressionOnAnnouncement:"Djup brusreducering har aktiverats",deepNoiseSuppressionOffAnnouncement:"Djup brusreducering har inaktiverats"},devicesButton:{label:"Enheter",tooltipContent:"Hantera enheter",cameraMenuTitle:"Kamera",cameraMenuTooltip:"Välj kamera",audioDeviceMenuTitle:"Ljudenhet",audioDeviceMenuTooltip:"Välj ljudenhet",microphoneMenuTitle:"Mikrofon",microphoneMenuTooltip:"Välj mikrofon",speakerMenuTitle:"Högtalare",speakerMenuTooltip:"Välj högtalare"},participantsButton:{label:"Personer",ariaLabel:"Kontakter",tooltipContent:"Visa deltagare",menuHeader:"I det här samtalet",participantsListButtonLabel:"{numParticipants} personer",muteAllButtonLabel:"Ljud av för alla",copyInviteLinkButtonLabel:"Kopiera inbjudningslänk",copyInviteLinkActionedAriaLabel:"Inbjudningslänken har kopierats"},screenShareButton:{onLabel:"Sluta presentera",offLabel:"Present",tooltipDisabledContent:"Presentationen är inaktiverad",tooltipOnContent:"Visar din skärm",tooltipOffContent:"Dela skärmen"},raiseHandButton:{offLabel:"Hand",onLabel:"Lägre",tooltipDisabledContent:"Åtgärden Räck upp hand är inaktiverad",tooltipOnContent:"Ta ned handen",tooltipOffContent:"Räck upp handen"},reactionButton:{label:"Reagera",ariaLabel:"Reagera",tooltipDisabledContent:"Reaktionsåtgärden är inaktiverad",tooltipContent:"Skicka en reaktion",likeReactionTooltipContent:"Gilla",heartReactionTooltipContent:"Kärlek",laughReactionTooltipContent:"Skrattar",applauseReactionTooltipContent:"Applåd",surprisedReactionTooltipContent:"Förvånad"},realTimeText:{isTypingText:"RTT-inmatning"},captionsSettingsModal:{captionsSettingsModalTitle:"Inställningar för undertexter",captionsSettingsSpokenLanguageDropdownLabel:"Talat språk",captionsSettingsCaptionLanguageDropdownLabel:"Språk för undertexter",captionsSettingsSpokenLanguageDropdownInfoText:"Språk som alla i det här samtalet talar.",captionsSettingsCaptionLanguageDropdownInfoText:"Undertexter visas på det här språket.",captionsSettingsConfirmButtonLabel:"Bekräfta",captionsSettingsCancelButtonLabel:"Avbryt",captionsSettingsModalAriaLabel:"Modalt fönster för inställning av undertexter",captionsSettingsCloseModalButtonAriaLabel:"Stäng inställningar för undertexter"},spokenLanguages:{"ar-ae":"Arabiska – Förenade Arabemiraten","ar-sa":"Arabiska – Saudiarabien","da-dk":"Danska","de-de":"Tyska – Tyskland","en-au":"Engelska – Australien","en-ca":"Engelska – Kanada","en-gb":"Engelska – Storbritannien","en-in":"Engelska – Indien","en-nz":"Engelska – Nya Zeeland","en-us":"Engelska – USA","es-es":"Spanska – Spanien (modern sortering)","es-mx":"Spanska – Mexiko","fi-fi":"Finska","fr-ca":"Franska – Kanada","fr-fr":"Franska – Frankrike","hi-in":"Hindi","it-it":"Italienska – Italien","ja-jp":"Japanska","ko-kr":"Koreanska","nb-no":"Norska (Bokmål)","nl-be":"Nederländska – Belgien","nl-nl":"Nederländska -–Nederländerna","pl-pl":"Polska","pt-br":"Portugisiska – Brasilien","ru-ru":"Ryska","sv-se":"Svenska","zh-cn":"Kinesiska (Kina),","zh-hk":"Kinesiska – Hongkong SAR","cs-cz":"Tjeckiska","pt-pt":"Portugisiska – Portugal","tr-tr":"Turkiska","vi-vn":"Vietnamesiska","th-th":"Thailändska","he-il":"Hebreiska","cy-gb":"Walesiska","uk-ua":"Ukrainska","el-gr":"Grekiska","hu-hu":"Ungerska","ro-ro":"Rumänska","sk-sk":"Slovakiska","zh-tw":"Kinesiska – Taiwan"},captionLanguages:{ar:"Arabiska",da:"Danska",de:"Tyska",en:"Engelska",es:"Spanska",fi:"Finska","fr-ca":"Franska – Kanada",fr:"Franska – Frankrike",hi:"Hindi",it:"Italienska",ja:"Japanska",ko:"Koreanska",nb:"Norska (Bokmål)",nl:"Nederländska",pl:"Polska",pt:"Portugisiska – Brasilien",ru:"Ryska",sv:"Svenska","zh-Hans":"Kinesiska (förenklad)","zh-Hant":"Kinesiska (traditionell)",cs:"Tjeckiska","pt-pt":"Portugisiska – Portugal",tr:"Turkiska",vi:"Vietnamesiska",th:"Thailändska",he:"Hebreiska",cy:"Walesiska",uk:"Ukrainska",el:"Grekiska",hu:"Ungerska",ro:"Rumänska",sk:"Slovakiska"},startCaptionsButton:{onLabel:"Aktivera undertexter",offLabel:"Stäng av undertexter",tooltipOnContent:"Stäng av undertexter",tooltipOffContent:"Aktivera undertexter"},startRealTimeTextButton:{label:"Aktivera RTT för det här samtalet",tooltipOffContent:"Aktivera RTT för det här samtalet"},messageThread:{yesterday:"I går",sunday:"Söndag",monday:"Måndag",tuesday:"Tisdag",wednesday:"Onsdag",thursday:"Torsdag",friday:"Fredag",saturday:"Lördag",participantJoined:"gick med i chatten.",participantLeft:"lämnade chatten.",editMessage:"Redigera",removeMessage:"Ta bort",resendMessage:"Försök skicka igen",failToSendTag:"Inte skickat",editedTag:"Redigerad",liveAuthorIntro:"Meddelande från {author}",editedMessageLiveAuthorIntro:"Redigerat meddelande från {author}",editedMessageLocalUserLiveAuthorIntro:"Redigerat meddelande",messageContentAriaText:"{status} {author} sa {message}",messageContentMineAriaText:"{status} Du sa {message}",editBoxTextLimit:"Meddelandet överskrider gränsen på {limitNumber} tecken",editBoxPlaceholderText:"Redigera meddelandet",newMessagesIndicator:"Nya meddelanden",noDisplayNameSub:"Inget namn",editBoxCancelButton:"Avbryt",editBoxSubmitButton:"Klar",messageReadCount:"Läst av {messageReadByCount} av {remoteParticipantsCount}",actionMenuMoreOptions:"Fler alternativ",downloadAttachment:"Ladda ner fil",openAttachment:"Öppna fil",blockedWarningText:"Det här meddelandet har tagits bort på grund av en organisationsprincip.",blockedWarningLinkText:"Information",attachmentCardGroupMessage:"Meddelandet har {attachmentCount} bifogade filer.",messageDeletedAnnouncementAriaLabel:"Meddelandet har tagits bort",richTextBoldTooltip:"Fet",richTextItalicTooltip:"Kursiv",richTextUnderlineTooltip:"Understryka",richTextBulletListTooltip:"Punktlista",richTextNumberListTooltip:"Numrerad lista",richTextIncreaseIndentTooltip:"Öka indrag",richTextDecreaseIndentTooltip:"Minska indrag",richTextInsertTableTooltip:"Infoga tabell",richTextFormatButtonTooltip:"Format",richTextInsertRowOrColumnMenu:"Infoga",richTextInsertTableMenuTitle:"Infoga tabell på {column} x {row}",richTextInsertRowAboveMenu:"Infoga ovan",richTextInsertRowBelowMenu:"Infoga nedanför",richTextInsertColumnLeftMenu:"Infoga till vänster",richTextInsertColumnRightMenu:"Infoga till höger",richTextDeleteRowOrColumnMenu:"Radera",richTextDeleteColumnMenu:"Ta bort kolumn",richTextDeleteRowMenu:"Ta bort rad",richTextDeleteTableMenu:"Ta bort tabell",richTextToolbarMoreButtonAriaLabel:"Fler alternativ",attachmentUploadsPendingError:"Filen laddas upp. Vänta.",imageUploadsPendingError:"Bilden laddas upp. Vänta.",richTextNewBulletedListItemAnnouncement:"Punkt, ny rad",richTextNewNumberedListItemAnnouncement:"{0}, ny rad",richTextBulletedListAppliedAnnouncement:"Punktlista tillämpad",richTextNumberedListAppliedAnnouncement:"Numrerad tillämpad"},errorBar:{unableToReachChatService:"Du är offline",accessDenied:"Det går inte att komma åt chatttjänster – kontrollera de angivna autentiseringsuppgifterna",userNotInChatThread:"Du är inte längre i den här chatttråden",sendMessageNotInChatThread:"Det gick inte att skicka meddelandet eftersom du inte längre är i den här chatttråden",sendMessageGeneric:"Meddelandet inte skickat",callingNetworkFailure:"Störande anslutningssamtal – du verkar vara offline",startVideoGeneric:"Det gick inte att starta videon",stopVideoGeneric:"Det gick inte att stoppa videon",muteGeneric:"Det gick inte att stänga av mikrofonen",unmuteGeneric:"Det gick inte att slå på mikrofonen",speakingWhileMuted:"Mikrofonens ljud har stängts av",startScreenShareGeneric:"Det uppstod ett problem när skärmdelningen skulle startas.",stopScreenShareGeneric:"Det gick inte att stoppa skärmdelning",callNetworkQualityLow:"Nätverkskvaliteten är låg.",teamsMeetingCallNetworkQualityLow:"Nätverkskvaliteten är låg.",callNoSpeakerFound:"Inga högtalare eller hörlurar hittades. Anslut en ljudenhet för att höra samtalet.",callNoMicrophoneFound:"Inga mikrofoner hittades. Anslut en ljudinmatningsenhet.",callMicrophoneAccessDenied:"Det går inte att komma åt mikrofonen. Klicka på låset i adressfältet om du vill bevilja behörighet till den här webbsidan.",callMicrophoneAccessDeniedSafari:"Det går inte att komma åt mikrofonen. Uppdatera sidan om du vill tillåta behörigheter, eller kontrollera webbläsarens inställningar och kontrollera att behörigheter är aktiverade för den här webbplatsen.",callMicrophoneMutedBySystem:"Du är avstängt av systemet.",callMicrophoneUnmutedBySystem:"Mikrofonen har återställts och datorn har slagit på ljudet.",callMacOsMicrophoneAccessDenied:"Det går inte att komma åt mikrofonen. Bevilja mikrofonbehörighet i dina sekretessinställningar för macOS.",callLocalVideoFreeze:"Nätverksbandbredden är dålig. Din video kan visas pausad för andra i samtalet.",callCameraAccessDenied:"Det går inte att komma åt kameran. Klicka på låset i adressfältet om du vill bevilja behörighet till den här webbsidan.",callCameraAccessDeniedSafari:"Det går inte att komma åt kameran. Uppdatera sidan om du vill tillåta behörigheter, eller kontrollera webbläsarens inställningar och kontrollera att behörigheter är aktiverade för den här webbplatsen.",callCameraAlreadyInUse:"Det går inte att komma åt kameran. Den kanske redan används av ett annat program.",callVideoStoppedBySystem:"Din video har stoppats av systemet.",callVideoRecoveredBySystem:"Videon har återupptagits.",callMacOsCameraAccessDenied:"MacOS blockerar åtkomsten till kameran. Uppdatera dina sekretessinställningar så att den här webbläsaren får åtkomst till kameran.",callMacOsScreenShareAccessDenied:"MacOS blockerar skärmdelning. Uppdatera dina sekretessinställningar så att den här webbläsaren kan spela in din skärm.",dismissButtonAriaLabel:"Stäng",failedToJoinCallGeneric:"Det gick inte att ansluta till samtalet.",failedToJoinCallInvalidMeetingLink:"Det går inte att ansluta till mötet. Ogiltig länk.",cameraFrozenForRemoteParticipants:"Användare i samtalet har problem med att se din video. Kontrollera dina enheter och nätverk.",unableToStartVideoEffect:"Det går inte att tillämpa videoeffekten.",startSpotlightWhileMaxParticipantsAreSpotlighted:"Det går inte att starta spotlight på deltagare eftersom det maximala antalet deltagare redan är uppmärksammat.",mutedByRemoteParticipant:"Du har stängts av av en annan deltagare."},notificationStack:{callingNetworkFailure:{title:"Störande anslutningssamtal",message:"Du verkar vara offline. Kontrollera nätverksanslutningen och försök igen.",dismissButtonAriaLabel:"Stäng"},startVideoGeneric:{title:"Det gick inte att starta videon.",dismissButtonAriaLabel:"Stäng"},stopVideoGeneric:{title:"Det gick inte att stoppa videon.",dismissButtonAriaLabel:"Stäng"},muteGeneric:{title:"Det gick inte att stänga av mikrofonen.",dismissButtonAriaLabel:"Stäng"},unmuteGeneric:{title:"Det gick inte att slå på mikrofonen.",dismissButtonAriaLabel:"Stäng"},speakingWhileMuted:{title:"Din mikrofon har stängts av.",dismissButtonAriaLabel:"Stäng"},startScreenShareGeneric:{title:"Det uppstod ett problem när skärmdelningen skulle startas.",dismissButtonAriaLabel:"Stäng"},stopScreenShareGeneric:{title:"Det gick inte att stoppa skärmdelningen.",dismissButtonAriaLabel:"Stäng"},callNetworkQualityLow:{title:"Nätverkskvaliteten är låg.",dismissButtonAriaLabel:"Stäng"},teamsMeetingCallNetworkQualityLow:{title:"Nätverkskvaliteten är låg.",dismissButtonAriaLabel:"Stäng",message:"Anslut till det här samtalet från din telefon för bättre ljud. Du kan fortsätta att visa mötet på den här enheten.",primaryButtonLabel:"Anslut via telefon"},callNoSpeakerFound:{title:"Inga högtalare eller hörlurar hittades",message:"Anslut en ljudenhet för att höra samtalet.",dismissButtonAriaLabel:"Stäng"},callNoMicrophoneFound:{title:"Inga mikrofoner hittades",message:"Anslut en ljudinmatningsenhet.",dismissButtonAriaLabel:"Stäng"},callMicrophoneAccessDenied:{title:"Det går inte att komma åt mikrofonen",message:"Klicka på låset i adressfältet om du vill bevilja behörighet till den här webbsidan.",dismissButtonAriaLabel:"Stäng"},callMicrophoneAccessDeniedSafari:{title:"Det går inte att komma åt mikrofonen",message:"Uppdatera sidan om du vill tillåta behörigheter, eller kontrollera webbläsarens inställningar och kontrollera att behörigheter är aktiverade för den här webbplatsen.",dismissButtonAriaLabel:"Stäng"},callMicrophoneMutedBySystem:{title:"Du är avstängt av systemet.",dismissButtonAriaLabel:"Stäng"},callMicrophoneUnmutedBySystem:{title:"Mikrofonen har återställts och datorn har slagit på ljudet.",dismissButtonAriaLabel:"Stäng"},callMacOsMicrophoneAccessDenied:{title:"Det går inte att komma åt mikrofonen",message:"Bevilja mikrofonbehörighet i dina macOS-sekretessinställningar.",dismissButtonAriaLabel:"Stäng"},callLocalVideoFreeze:{title:"Nätverksbandbredden är dålig",message:"Din video kan visas pausad för andra i samtalet.",dismissButtonAriaLabel:"Stäng"},callCameraAccessDenied:{title:"Det går inte att komma åt kameran",message:"Klicka på låset i adressfältet om du vill bevilja behörighet till den här webbsidan.",dismissButtonAriaLabel:"Stäng"},callCameraAccessDeniedSafari:{title:"Det går inte att komma åt kameran",message:"Uppdatera sidan om du vill tillåta behörigheter, eller kontrollera webbläsarens inställningar och kontrollera att behörigheter är aktiverade för den här webbplatsen.",dismissButtonAriaLabel:"Stäng"},callCameraAlreadyInUse:{title:"Det går inte att komma åt kameran",message:"Den kanske redan används av ett annat program.",dismissButtonAriaLabel:"Stäng"},callVideoStoppedBySystem:{title:"Din video har stoppats av systemet.",dismissButtonAriaLabel:"Stäng"},callVideoRecoveredBySystem:{title:"Videon har återupptagits.",dismissButtonAriaLabel:"Stäng"},callMacOsCameraAccessDenied:{title:"MacOS blockerar åtkomsten till kameran",message:"Uppdatera dina sekretessinställningar så att den här webbläsaren får åtkomst till kameran.",dismissButtonAriaLabel:"Stäng"},callMacOsScreenShareAccessDenied:{title:"MacOS blockerar skärmdelning",message:"Uppdatera dina sekretessinställningar så att den här webbläsaren kan spela in din skärm.",dismissButtonAriaLabel:"Stäng"},failedToJoinCallGeneric:{title:"Det gick inte att ansluta till samtalet.",dismissButtonAriaLabel:"Stäng"},failedToJoinCallInvalidMeetingLink:{title:"Det går inte att ansluta till mötet. Ogiltig länk.",dismissButtonAriaLabel:"Stäng"},cameraFrozenForRemoteParticipants:{title:"Användare i samtalet har problem med att se din video",message:"Kontrollera dina enheter och nätverk.",dismissButtonAriaLabel:"Stäng"},unableToStartVideoEffect:{title:"Det går inte att tillämpa videoeffekten.",dismissButtonAriaLabel:"Stäng"},startSpotlightWhileMaxParticipantsAreSpotlighted:{title:"Det går inte att starta spotlight på deltagare",message:"Det maximala antalet deltagare är redan uppmärksammat.",dismissButtonAriaLabel:"Stäng"},mutedByRemoteParticipant:{title:"Du har stängts av av en annan deltagare.",dismissButtonAriaLabel:"Stäng"},recordingStarted:{title:"Inspelningen har startat.",message:"Genom att ansluta ger du ditt medgivande för att det här mötet ska transkriberas.",dismissButtonAriaLabel:"Stäng"},transcriptionStarted:{title:"Transkriptionen har startat.",message:"Genom att ansluta ger du ditt medgivande för att det här mötet ska transkriberas.",dismissButtonAriaLabel:"Stäng"},recordingStopped:{title:"Inspelningen sparas.",message:"Inspelningen har stoppats.",dismissButtonAriaLabel:"Stäng"},transcriptionStopped:{title:"Transkriptionen sparas.",message:"Transkriptionen har avslutats.",dismissButtonAriaLabel:"Stäng"},recordingAndTranscriptionStarted:{title:"Inspelning och transkription har startats.",message:"Genom att ansluta ger du ditt medgivande för att det här mötet ska transkriberas.",dismissButtonAriaLabel:"Stäng"},recordingAndTranscriptionStopped:{title:"Inspelning och transkription sparas.",message:"Inspelning och transkription har avslutats.",dismissButtonAriaLabel:"Stäng"},recordingStoppedStillTranscribing:{title:"Inspelningen har stoppats.",message:"Nu transkriberar du bara det här mötet.",dismissButtonAriaLabel:"Stäng"},transcriptionStoppedStillRecording:{title:"Transkriptionen har avslutats.",message:"Du spelar nu bara in det här mötet.",dismissButtonAriaLabel:"Stäng"},assignedBreakoutRoomOpened:{title:"Du flyttas till det tilldelade rummet om 5 sekunder.",dismissButtonAriaLabel:"Stäng"},assignedBreakoutRoomChanged:{title:"Ditt grupprum har ändrats",message:"Du flyttas till det tilldelade rummet om 5 sekunder.",dismissButtonAriaLabel:"Stäng"},assignedBreakoutRoomClosed:{title:"Grupprummet har stängts",message:"Du flyttas tillbaka till mötet om 5 sekunder.",dismissButtonAriaLabel:"Stäng"},assignedBreakoutRoomOpenedPromptJoin:{title:"Vill du ansluta till grupprummet?",message:"Du har tilldelats till ett separat rum.",dismissButtonAriaLabel:"Stäng",primaryButtonLabel:"Anslut till rummet",secondaryButtonLabel:"Senare"},breakoutRoomJoined:{title:"Du har gått med i ett grupprum.",dismissButtonAriaLabel:"Stäng"},breakoutRoomClosingSoon:{title:"Tidsgränsen för rummet upphör snart att gälla.",message:"Det här rummet stängs om 30 sekunder",dismissButtonAriaLabel:"Stäng"},capabilityTurnVideoOnPresent:{title:"Kameran har aktiverats",message:"Aktivera om du vill dela video.",dismissButtonAriaLabel:"Stäng"},capabilityTurnVideoOnAbsent:{title:"Kameran har inaktiverats",message:"Du kan inte längre dela video.",dismissButtonAriaLabel:"Stäng"},capabilityUnmuteMicPresent:{title:"Mikrofonen har aktiverats",message:"Slå på ljudet om du vill prata.",dismissButtonAriaLabel:"Stäng"},capabilityUnmuteMicAbsent:{title:"Mikrofonen har inaktiverats",message:"Du kan inte längre slå på ljudet.",dismissButtonAriaLabel:"Stäng"},togetherModeStarted:{title:"Tillsammans-läge har startats",dismissButtonAriaLabel:"Stäng"},togetherModeEnded:{title:"Tillsammans-läge har avslutats",dismissButtonAriaLabel:"Stäng"}},videoGallery:{screenIsBeingSharedMessage:"Du delar din skärm",screenShareLoadingMessage:"Läser in {participant}s skärm",localScreenShareLoadingMessage:"Läser in skärmen",localVideoLabel:"Du",localVideoCameraSwitcherLabel:"Växla kamera",localVideoMovementLabel:"Flyttbar lokal videopanel",localVideoMovementAriaLabel:"Flyttbar lokal videopanel",localVideoSelectedDescription:"{cameraName} har valts",displayNamePlaceholder:"Namnlös deltagare",fitRemoteParticipantToFrame:"Anpassa till ruta",fillRemoteParticipantFrame:"Fyll ruta",pinParticipantForMe:"Fäst åt mig",pinParticipantForMeLimitReached:"Fäst (gränsen har nåtts)",unpinParticipantForMe:"Ta bort",pinParticipantMenuItemAriaLabel:"Fäst {participantName}",unpinParticipantMenuItemAriaLabel:"Ta bort {participantName}",pinnedParticipantAnnouncementAriaLabel:"Fäst {participantName}",unpinnedParticipantAnnouncementAriaLabel:"Borttagen {participantName}",startSpotlightVideoTileMenuLabel:"Uppmärksamma för alla",addSpotlightVideoTileMenuLabel:"Lägg till uppmärksammande",spotlightLimitReachedMenuTitle:"Spotlight-gränsen har nåtts",stopSpotlightVideoTileMenuLabel:"Sluta uppmärksamma",stopSpotlightOnSelfVideoTileMenuLabel:"Spotlight",attendeeRole:"Deltagare",muteParticipantMenuItemLabel:"Stäng av ljudet",waitingScreenText:"Väntar på att andra ska ansluta",forbidAudio:"Inaktivera mikrofon",permitAudio:"Tillåt mikrofon",forbidAudioTileMenuLabel:"Inaktivera mikrofon",permitAudioTileMenuLabel:"Tillåt mikrofon",forbidVideo:"Inaktivera kameran",permitVideo:"Tillåt kamera",forbidVideoTileMenuLabel:"Inaktivera kameran",permitVideoTileMenuLabel:"Tillåt kamera"},dialpad:{placeholderText:"Ange telefonnummer",deleteButtonAriaLabel:"Ta bort"},holdButton:{onLabel:"Återuppta",offLabel:"Bevarande",tooltipOnContent:"Återuppta samtal",tooltipOffContent:"Parkera samtal"},videoTile:{participantStateRinging:"Ringer...",participantReconnecting:"Ansluter igen...",participantStateHold:"Parkerat",moreOptionsButtonAriaLabel:"Fler alternativ {displayName} {isMuted} {micDisabledState} {cameraDisabledState} {isHandRaised} {state} {isSpeaking}",moreOptionsParticipantMutedStateMutedAriaLabel:"ljud av",moreOptionsParticipantMutedStateUnmutedAriaLabel:"ljud på",moreOptionsParticipantHandRaisedAriaLabel:"Uppräckt hand",moreOptionsParticipantIsSpeakingAriaLabel:"Talar",moreOptionsParticipantMicDisabledAriaLabel:"Mikrofonen är inaktiverad",moreOptionsParticipantCameraDisabledAriaLabel:"Kameran är inaktiverad"},CameraAndMicrophoneSitePermissionsRequest:{primaryText:"Tillåt {appName} använda kameran och mikrofonen",secondaryText:"Det här är så att deltagarna kan se och höra dig.",linkText:"Behöver du hjälp? Få hjälp med felsökning",primaryButtonText:"Fortsätt utan kamera och mikrofon",ariaLabel:"Tillåt kamera- och mikrofonåtkomst"},CameraSitePermissionsRequest:{primaryText:"Tillåt {appName} att använda kameran",secondaryText:"Det här är så att deltagarna kan se dig.",linkText:"Behöver du hjälp? Få hjälp med felsökning",primaryButtonText:"Fortsätt utan kamera",ariaLabel:"Tillåt kameraåtkomst"},MicrophoneSitePermissionsRequest:{primaryText:"Tillåt {appName} att använda mikrofonen",secondaryText:"Det här är så att deltagarna kan höra dig.",linkText:"Behöver du hjälp? Få hjälp med felsökning",primaryButtonText:"Fortsätt utan mikrofon",ariaLabel:"Tillåt mikrofonåtkomst"},CameraAndMicrophoneSitePermissionsCheck:{primaryText:"Söker efter åtkomst till kameran och mikrofonen",secondaryText:"Tillåt åtkomst om du uppmanas till det. Det här är så att deltagarna kan se och höra dig.",linkText:"Behöver du hjälp? Få hjälp med felsökning",primaryButtonText:"Fortsätt utan kamera och mikrofon",ariaLabel:"Söker efter åtkomst till kameran och mikrofonen. Tillåt åtkomst om du uppmanas att göra det."},CameraSitePermissionsCheck:{primaryText:"Söker efter kameraåtkomst",secondaryText:"Tillåt åtkomst om du uppmanas att göra det. Det här är så att deltagarna kan se dig.",linkText:"Behöver du hjälp? Få hjälp med felsökning",primaryButtonText:"Fortsätt utan kamera",ariaLabel:"Söker efter kameraåtkomst. Tillåt åtkomst om du uppmanas att göra det."},MicrophoneSitePermissionsCheck:{primaryText:"Söker efter mikrofonåtkomst",secondaryText:"Tillåt åtkomst om du uppmanas till det. Det här är så att deltagarna kan höra dig.",linkText:"Behöver du hjälp? Få hjälp med felsökning",primaryButtonText:"Fortsätt utan mikrofon",ariaLabel:"Söker efter mikrofonåtkomst. Tillåt åtkomst om du uppmanas att göra det."},CameraAndMicrophoneSitePermissionsDenied:{primaryText:"Det går inte att komma åt kameran och mikrofonen",secondaryText:"Klicka på låsikonen i adressfältet om du vill bevilja mikrofonbehörighet till den här webbsidan. Det kan krävas en siduppdatering.",primaryButtonText:"Fortsätt utan kamera och mikrofon",linkText:"Behöver du hjälp? Få hjälp med felsökning"},CameraAndMicrophoneSitePermissionsDeniedSafari:{primaryText:"Det går inte att komma åt kameran och mikrofonen",secondaryText:"Uppdatera sidan om du vill tillåta behörigheter, eller kontrollera webbläsarens inställningar och kontrollera att behörigheter är aktiverade för den här webbplatsen.",primaryButtonText:"Fortsätt utan kamera och mikrofon",linkText:"Behöver du hjälp? Få hjälp med felsökning"},CameraSitePermissionsDenied:{primaryText:"Det går inte att komma åt kameran",secondaryText:"Klicka på låsikonen i adressfältet om du vill bevilja kamerabehörigheter till den här webbsidan. Det kan krävas en siduppdatering.",primaryButtonText:"Fortsätt utan kamera",linkText:"Behöver du hjälp? Få hjälp med felsökning"},MicrophoneSitePermissionsDenied:{primaryText:"Det går inte att komma åt mikrofonen",secondaryText:"Klicka på låsikonen i adressfältet om du vill bevilja mikrofonbehörighet till den här webbsidan. Det kan krävas en siduppdatering.",primaryButtonText:"Fortsätt utan mikrofon",linkText:"Behöver du hjälp? Få hjälp med felsökning"},CameraSitePermissionsDeniedSafari:{primaryText:"Det går inte att komma åt kameran",secondaryText:"Uppdatera sidan om du vill tillåta behörigheter, eller kontrollera webbläsarens inställningar och kontrollera att behörigheter är aktiverade för den här webbplatsen.",primaryButtonText:"Fortsätt utan kamera",linkText:"Behöver du hjälp? Få hjälp med felsökning"},MicrophoneSitePermissionsDeniedSafari:{primaryText:"Det går inte att komma åt mikrofonen",secondaryText:"Uppdatera sidan om du vill tillåta behörigheter, eller kontrollera webbläsarens inställningar och kontrollera att behörigheter är aktiverade för den här webbplatsen.",primaryButtonText:"Fortsätt utan mikrofon",linkText:"Behöver du hjälp? Få hjälp med felsökning"},UnsupportedBrowser:{primaryText:"Webbläsaren stöds inte",secondaryText:"Anslut till samtalet med en kompatibel webbläsare.",moreHelpLinkText:"Se kompatibilitetskrav"},UnsupportedBrowserVersion:{primaryText:"Uppdatering av webbläsare krävs",secondaryText:"Uppdatera webbläsaren och försök sedan ansluta till samtalet igen för att säkerställa bästa möjliga samtal.",moreHelpLinkText:"Se kompatibilitetskrav",continueAnywayButtonText:"Starta samtal utan att uppdatera"},UnsupportedOperatingSystem:{primaryText:"Operativsystemet stöds inte",secondaryText:"Anslut till det här samtalet med en enhet med ett kompatibelt operativsystem.",moreHelpLinkText:"Se kompatibilitetskrav"},BrowserPermissionDenied:{primaryText:"Det går inte att använda kameran eller mikrofonen",secondaryText:"Din webbläsare kanske inte har åtkomst till din kamera eller mikrofon. Åtgärda detta genom att öppna Systeminställningar.",primaryButtonText:"Försök igen",linkText:"Behöver du hjälp? Få hjälp med felsökning"},BrowserPermissionDeniedIOS:{primaryText:"Tillåt mikrofonåtkomst för att fortsätta",secondaryText:"Så att andra deltagare kan höra dig.",primaryButtonText:"Försök igen",imageAltText:"Behörighetsplats för mikrofon och kameraenhet för iOS",linkText:"Behöver du hjälp? Få hjälp med felsökning",step1Text:"Gå till appen Inställningar",step2Text:"Rulla ned till inställningarna för den här webbläsaren",step3Text:"Aktivera mikrofon (kamera valfritt)",step4Text:"Försök ansluta till samtalet igen",step1DigitText:"1",step2DigitText:"2",step3DigitText:"3",step4DigitText:"4"},verticalGallery:{leftNavButtonAriaLabel:"föregående sida {current} av {total}",rightNavButtonAriaLabel:"nästa sida {current} av {total}"},meetingConferencePhoneInfo:{meetingConferencePhoneInfoModalTitle:"Anslut till samtal från din telefon",meetingConferencePhoneInfoModalDialIn:"Slå nummer",meetingConferencePhoneInfoModalMeetingId:"Ange mötes-ID",meetingConferencePhoneInfoModalWait:"Vänta på att få tillträde av organisatören",meetingConferencePhoneInfoModalNoPhoneAvailable:"Ingen telefon är tillgänglig",meetingConferencePhoneInfoModalTollGeoData:"{country}, {city}",meetingConferencePhoneInfoModalTollFree:"(Avgiftsfritt)",meetingConferencePhoneInfoModalToll:"(Avgiftsbelagt)"},IncomingCallNotification:{incomingCallNotificationPlaceholderId:"Okänd användare",incomingCallNotificationPlaceholderAlert:"{callerName} ringer",incomingCallNoticicationAcceptWithAudioAriaLabel:"Acceptera med ljud",incomingCallNoticicationAcceptWithVideoAriaLabel:"Acceptera med video",incomingCallNoticicationRejectAriaLabel:"Avvisa",incomingCallNotificationAcceptButtonLabel:"Acceptera",incomingCallNotificationRejectButtonLabel:"Avböj",incomingCallNotificationAccceptWithVideoButtonLabel:"Acceptera med video",incomingCallNotificationDismissButtonAriaLabel:"Stäng"}})},EQt={strings:Jh({participantItem:{isMeText:"(siz)",menuTitle:"Diğer Seçenekler",removeButtonLabel:"Kaldır",sharingIconLabel:"Paylaşım",mutedIconLabel:"Ses kapatıldı",handRaisedIconLabel:"El kaldırdı - Konum {position}",displayNamePlaceholder:"Adsız katılımcı",participantStateRinging:"Arıyor...",participantStateHold:"Beklemede",participantItemAriaLabel:"{displayName}, {handRaisedState}, {mutedState}, {micDisabledState}, {cameraDisabledState}, {sharingState}, {connectionState}",participantItemWithMoreOptionsAriaLabel:"{displayName}, {handRaisedState}, {mutedState}, {micDisabledState}, {cameraDisabledState}, {sharingState}, {connectionState}, Diğer Seçenekler",attendeeRole:"Katılımcı",micDisabledIconLabel:"Mikrofon devre dışı",cameraDisabledIconLabel:"Kamera devre dışı"},ParticipantList:{overflowParticipantCount:"{overflowCount} tane daha"},typingIndicator:{singleUser:"{user} yazıyor...",multipleUsers:"{users} yazıyor ...",multipleUsersAbbreviateOne:"{users} ve 1 kişi daha yazıyor...",multipleUsersAbbreviateMany:"{users} ve {numOthers} kişi daha yazıyor...",delimiter:", "},sendBox:{placeholderText:"Bir mesaj girin",textTooLong:"İletinizin uzunluğu üst sınırı aşıyor.",sendButtonAriaLabel:"İleti gönder",attachmentUploadsPendingError:"Karşıya yükleniyor... Lütfen bekleyin.",removeAttachment:"Dosyayı kaldır",uploading:"Karşıya yükleniyor",uploadCompleted:"Karşıya yükleme tamamlandı",attachmentMoreMenu:"Diğer Seçenekler"},richTextSendBox:{placeholderText:"Bir mesaj girin",textTooLong:"İletinizin uzunluğu üst sınırı aşıyor.",sendButtonAriaLabel:"Mesaj gönder",attachmentUploadsPendingError:"Karşıya yükleniyor... Lütfen bekleyin.",imageUploadsPendingError:"Karşıya yükleniyor... Lütfen bekleyin.",removeAttachment:"Dosyayı kaldır",uploading:"Yükleniyor",uploadCompleted:"Karşıya yükleme tamamlandı",richTextBoldTooltip:"Kalın",richTextItalicTooltip:"İtalik",richTextUnderlineTooltip:"Altı çizili",richTextBulletListTooltip:"Madde işaretli liste",richTextNumberListTooltip:"Numaralandırılmış liste",richTextIncreaseIndentTooltip:"Girintiyi artır",richTextDecreaseIndentTooltip:"Girintiyi azalt",richTextInsertTableTooltip:"Tablo ekle",richTextFormatButtonTooltip:"Biçim",richTextInsertRowOrColumnMenu:"Ekle",richTextInsertTableMenuTitle:"{column} x {row} tablosunu ekleme",richTextInsertRowAboveMenu:"Üste ekle",richTextInsertRowBelowMenu:"Aşağıya ekle",richTextInsertColumnLeftMenu:"Sola ekle",richTextInsertColumnRightMenu:"Sağa ekle",richTextDeleteRowOrColumnMenu:"Sil",richTextDeleteColumnMenu:"Sütunu sil",richTextDeleteRowMenu:"Satırı sil",richTextDeleteTableMenu:"Tabloyu sil",richTextToolbarAriaLabel:"İleti Biçimlendirme Araç Çubuğu",richTextToolbarMoreButtonAriaLabel:"Diğer seçenekler",attachmentMoreMenu:"Diğer Seçenekler",richTextNewBulletedListItemAnnouncement:"Madde işareti, yeni satır",richTextNewNumberedListItemAnnouncement:"{0}, yeni satır",richTextBulletedListAppliedAnnouncement:"Madde işaretli liste uygulandı",richTextNumberedListAppliedAnnouncement:"Numaralandırılmış liste uygulandı"},realTimeTextModal:{realTimeTextModalAriaLabel:"RTT Kalıcı İletişim Kutusunu Aç",realTimeTextModalTitle:"RTT açılsın mı?",realTimeTextModalText:"Gerçek zamanlı metin (RTT) toplantıdaki herkes için açılır.",realTimeTextConfirmButtonLabel:"Aç",realTimeTextCancelButtonLabel:"İptal",realTimeTextCloseModalButtonAriaLabel:"RTT Kalıcı İletişim Kutusunu Kapat"},captionsBanner:{captionsBannerSpinnerText:"Alt yazılar başlatılıyor...",realTimeTextInputBoxDefaultText:"İletiyi gerçek zamanlı yazın",realTimeTextInputErrorMessage:"İleti 2000 karakteri geçemez",realTimeTextBannerTitle:"RTT",realTimeTextBannerContent:"RTT (gerçek zamanlı metin) toplantı süresi boyunca tüm katılımcılar için etkindir.",realTimeTextBannerLinkLabel:"Daha fazla bilgi edinin",captionsOnlyContainerTitle:"Alt yazılar",realTimeTextOnlyContainerTitle:"Gerçek Zamanlı Metin",captionsAndRealTimeTextContainerTitle:"Altyazılar ve Gerçek Zamanlı Metin",expandButtonAriaLabel:"Genişlet",minimizeButtonAriaLabel:"Daralt"},mentionPopover:{mentionPopoverHeader:"Öneriler"},imageOverlay:{downloadButtonLabel:"İndir",dismissButtonAriaLabel:"Kapat",overlayVisibleMessage:"Resim Ayrıntıları Katmanı"},messageStatusIndicator:{deliveredAriaLabel:"İleti gönderildi",deliveredTooltipText:"Gönderilen",seenAriaLabel:"İleti başkaları tarafından görüldü",seenTooltipText:"Görüldü",readByTooltipText:"{messageThreadReadCount} / {remoteParticipantsCount} katılımcı tarafından okundu",sendingAriaLabel:"İleti gönderiliyor",sendingTooltipText:"Gönderiliyor",failedToSendAriaLabel:"İleti gönderilemedi",failedToSendTooltipText:"Gönderilemedi"},endCallButton:{label:"Ayrıl",tooltipContent:"Aramadan ayrıl",leaveOption:"Ayrıl",endCallOption:"Aramayı herkes için sonlandır"},cameraButton:{onLabel:"Kamera",offLabel:"Kamera",tooltipDisabledContent:"Kamera devre dışı",tooltipOnContent:"Kamerayı kapat",tooltipOffContent:"Kamerayı aç",tooltipVideoLoadingContent:"Video yükleniyor",cameraMenuTitle:"Kamera",cameraMenuTooltip:"Kamera seç",cameraButtonSplitRoleDescription:"Bölünmüş düğme",onSplitButtonAriaLabel:"Kamerayı kapat",offSplitButtonAriaLabel:"Kamerayı aç",cameraActionTurnedOnAnnouncement:"Kameranız açıldı",cameraActionTurnedOffAnnouncement:"Kameranız kapatıldı",onSplitButtonPrimaryActionCamera:"Kamerayı kapat",offSplitButtonPrimaryActionCamera:"Kamerayı aç",cameraPrimaryActionSplitButtonTitle:"Kamerayı kullan",videoEffectsMenuItemTitle:"Efektler",cameraButtonAriaDescription:"kamera seçenekleri"},microphoneButton:{onLabel:"Mikrofon",offLabel:"Mikrofon",tooltipDisabledContent:"Mikrofon devre dışı",tooltipOnContent:"Mikrofonun sesini kapat",tooltipOffContent:"Mikrofonun sesini aç",microphoneMenuTitle:"Mikrofon",microphoneMenuTooltip:"Mikrofon seç",speakerMenuTitle:"Hoparlör",speakerMenuTooltip:"Hoparlör seç",microphoneButtonSplitRoleDescription:"Bölünmüş düğme",onSplitButtonAriaLabel:"Mikrofonu sessize al",offSplitButtonAriaLabel:"Mikrofonun sesini aç",microphoneActionTurnedOnAnnouncement:"Mikrofonunuz açıldı",microphoneActionTurnedOffAnnouncement:"Mikrofonunuz kapatıldı",offSplitButtonMicrophonePrimaryAction:"Mikrofonun sesini aç",onSplitButtonMicrophonePrimaryAction:"Mikrofonu sessize al",microphonePrimaryActionSplitButtonTitle:"Mikrofonu kullan",microphoneAriaDescription:"Ses seçenekleri",deepNoiseSuppressionTitle:"Gürültü engelleme",deepNoiseSuppressionOnAnnouncement:"Derin gürültü önleme açıldı",deepNoiseSuppressionOffAnnouncement:"Derin gürültü önleme kapatıldı"},devicesButton:{label:"Cihazlar",tooltipContent:"Cihazları yönet",cameraMenuTitle:"Kamera",cameraMenuTooltip:"Kamera seç",audioDeviceMenuTitle:"Ses Cihazı",audioDeviceMenuTooltip:"Ses cihazı seç",microphoneMenuTitle:"Mikrofon",microphoneMenuTooltip:"Mikrofon seç",speakerMenuTitle:"Hoparlör",speakerMenuTooltip:"Hoparlör seç"},participantsButton:{label:"Kişiler",ariaLabel:"Kişiler",tooltipContent:"Katılımcıları göster",menuHeader:"Bu aramada",participantsListButtonLabel:"{numParticipants} kişiler",muteAllButtonLabel:"Tümünün sesini kapat",copyInviteLinkButtonLabel:"Davet bağlantısını kopyala",copyInviteLinkActionedAriaLabel:"Davet bağlantısı kopyalandı"},screenShareButton:{onLabel:"Sunumu Durdur",offLabel:"Sun",tooltipDisabledContent:"Sunu devre dışı bırakıldı.",tooltipOnContent:"Ekranınızı sunuluyor",tooltipOffContent:"Ekranınızı sunun"},raiseHandButton:{offLabel:"Kaldır",onLabel:"İndir",tooltipDisabledContent:"El Kaldırma eylemi devre dışı bırakıldı",tooltipOnContent:"Eli İndirme",tooltipOffContent:"El Kaldırma"},reactionButton:{label:"Tepki ver",ariaLabel:"Tepki Ver",tooltipDisabledContent:"Tepki eylemi devre dışı bırakıldı",tooltipContent:"Tepki gönder",likeReactionTooltipContent:"Beğen",heartReactionTooltipContent:"Aşk",laughReactionTooltipContent:"Kahkaha",applauseReactionTooltipContent:"Alkış",surprisedReactionTooltipContent:"Şaşırmış"},realTimeText:{isTypingText:"RTT yazma"},captionsSettingsModal:{captionsSettingsModalTitle:"Açıklamalı Alt Yazı Ayarları",captionsSettingsSpokenLanguageDropdownLabel:"Konuşma dili",captionsSettingsCaptionLanguageDropdownLabel:"Açıklamalı alt yazı dili",captionsSettingsSpokenLanguageDropdownInfoText:"Bu çağrıdaki herkesin konuşma dili.",captionsSettingsCaptionLanguageDropdownInfoText:"Açıklamalı alt yazılar bu dilde görünür.",captionsSettingsConfirmButtonLabel:"Onayla",captionsSettingsCancelButtonLabel:"İptal",captionsSettingsModalAriaLabel:"Alt Yazı Ayarı Kalıcı İletişim Kutusu",captionsSettingsCloseModalButtonAriaLabel:"Alt Yazı Ayarını Kapat"},spokenLanguages:{"ar-ae":"Arapça - BAE","ar-sa":"Arapça - Suudi Arabistan","da-dk":"Danca","de-de":"Almanca - Almanya","en-au":"İngilizce - Avustralya","en-ca":"İngilizce - Kanada","en-gb":"İngilizce - Birleşik Krallık","en-in":"İngilizce - Hindistan","en-nz":"İngilizce - Yeni Zelanda","en-us":"İngilizce - Birleşik Devletler","es-es":"İspanyolca - İspanya (Modern)","es-mx":"İspanyolca - Meksika","fi-fi":"Fince","fr-ca":"Fransızca - Kanada","fr-fr":"Fransızca - Fransa","hi-in":"Hintçe","it-it":"İtalyanca - İtalya","ja-jp":"Japonca","ko-kr":"Korece","nb-no":"Norveççe (Bokmål)","nl-be":"Hollanda dili - Belçika","nl-nl":"Felemenkçe - Hollanda","pl-pl":"Lehçe","pt-br":"Portekizce - Brezilya","ru-ru":"Rusça","sv-se":"İsveççe","zh-cn":"Çince - Çin Halk Cumhuriyeti","zh-hk":"Çince - Hong Kong ÖİB","cs-cz":"Çekçe","pt-pt":"Portekizce - Portekiz","tr-tr":"Türkçe","vi-vn":"Vietnamca","th-th":"Tayca","he-il":"İbranice","cy-gb":"Galce","uk-ua":"Ukraynaca","el-gr":"Yunanca","hu-hu":"Macarca","ro-ro":"Rumence","sk-sk":"Slovakça","zh-tw":"Çince - Tayvan"},captionLanguages:{ar:"Arapça",da:"Danca",de:"Almanca",en:"İngilizce",es:"İspanyolca",fi:"Fince","fr-ca":"Fransızca - Kanada",fr:"Fransızca - Fransa",hi:"Hintçe",it:"İtalyanca",ja:"Japonca",ko:"Korece",nb:"Norveççe (Bokmål)",nl:"Felemenkçe",pl:"Lehçe",pt:"Portekizce - Brezilya",ru:"Rusça",sv:"İsveççe","zh-Hans":"Çince (Basitleştirilmiş)","zh-Hant":"Çince (Geleneksel)",cs:"Çekçe","pt-pt":"Portekizce - Portekiz",tr:"Türkçe",vi:"Vietnamca",th:"Tayca",he:"İbranice",cy:"Galce",uk:"Ukraynaca",el:"Yunanca",hu:"Macarca",ro:"Rumence",sk:"Slovakça"},startCaptionsButton:{onLabel:"Alt yazıları aç",offLabel:"Alt yazıları kapat",tooltipOnContent:"Alt yazıları kapat",tooltipOffContent:"Alt yazıları aç"},startRealTimeTextButton:{label:"Bu arama için RTT'yi aç",tooltipOffContent:"Bu arama için RTT'yi aç"},messageThread:{yesterday:"Dün",sunday:"Pazar",monday:"Pazartesi",tuesday:"Salı",wednesday:"Çarşamba",thursday:"Perşembe",friday:"Cuma",saturday:"Cumartesi",participantJoined:"sohbete katıldı.",participantLeft:"sohbetten ayrıldı.",editMessage:"Düzenle",removeMessage:"Sil",resendMessage:"Yeniden göndermeyi deneyin",failToSendTag:"Gönderilemedi",editedTag:"Düzenlendi",liveAuthorIntro:"{author} tarafından gönderilen ileti",editedMessageLiveAuthorIntro:"{author} tarafından düzenlenen ileti",editedMessageLocalUserLiveAuthorIntro:"Düzenlenmiş ileti",messageContentAriaText:"{status} {author} şunu dedi: {message}",messageContentMineAriaText:"{status} {message} dediniz",editBoxTextLimit:"İletiniz en fazla {limitNumber} aşıyor",editBoxPlaceholderText:"İletinizi düzenleyin",newMessagesIndicator:"Yeni iletiler",noDisplayNameSub:"Ad yok",editBoxCancelButton:"İptal",editBoxSubmitButton:"Bitti",messageReadCount:"{messageReadByCount} / {remoteParticipantsCount} katılımcı tarafından okundu",actionMenuMoreOptions:"Diğer Seçenekler",downloadAttachment:"Dosyayı indir",openAttachment:"Dosyayı aç",blockedWarningText:"Bu ileti kuruluş ilkesi nedeniyle silindi.",blockedWarningLinkText:"Ayrıntılar",attachmentCardGroupMessage:"İletinin {attachmentCount} eki var",messageDeletedAnnouncementAriaLabel:"İleti silindi",richTextBoldTooltip:"Kalın",richTextItalicTooltip:"İtalik",richTextUnderlineTooltip:"Altını Çiz",richTextBulletListTooltip:"Madde işaretli liste",richTextNumberListTooltip:"Numaralandırılmış liste",richTextIncreaseIndentTooltip:"Girintiyi artır",richTextDecreaseIndentTooltip:"Girintiyi azalt",richTextInsertTableTooltip:"Tablo ekle",richTextFormatButtonTooltip:"Biçim",richTextInsertRowOrColumnMenu:"Ekle",richTextInsertTableMenuTitle:"{column} x {row} tablosunu ekleme",richTextInsertRowAboveMenu:"Üste ekle",richTextInsertRowBelowMenu:"Aşağıya ekle",richTextInsertColumnLeftMenu:"Sola ekle",richTextInsertColumnRightMenu:"Sağa ekle",richTextDeleteRowOrColumnMenu:"Sil",richTextDeleteColumnMenu:"Sütunu sil",richTextDeleteRowMenu:"Satırı sil",richTextDeleteTableMenu:"Tabloyu sil",richTextToolbarMoreButtonAriaLabel:"Diğer seçenekler",attachmentUploadsPendingError:"Karşıya yükleniyor... Lütfen bekleyin.",imageUploadsPendingError:"Karşıya yükleniyor... Lütfen bekleyin.",richTextNewBulletedListItemAnnouncement:"Madde işareti, yeni satır",richTextNewNumberedListItemAnnouncement:"{0}, yeni satır",richTextBulletedListAppliedAnnouncement:"Madde işaretli liste uygulandı",richTextNumberedListAppliedAnnouncement:"Numaralandırılmış liste uygulandı"},errorBar:{unableToReachChatService:"Çevrimdışısınız",accessDenied:"Sohbet hizmetlerine erişilemedi. Lütfen sağlanan kullanıcı kimlik bilgilerini denetleyin",userNotInChatThread:"Artık bu sohbet yazışması içinde değilsiniz",sendMessageNotInChatThread:"Artık bu sohbet yazışması içinde olmadığınız için ileti gönderilemedi",sendMessageGeneric:"İleti gönderilemedi",callingNetworkFailure:"Arama bağlanırken sorun oluştu; çevrimdışı görünüyorsunuz",startVideoGeneric:"Video başlatılamadı",stopVideoGeneric:"Video durdurulamadı",muteGeneric:"Mikrofonun sesi kapatılamadı",unmuteGeneric:"Mikrofonun sesi açılamadı",speakingWhileMuted:"Mikrofonunuzun sesi kapalı",startScreenShareGeneric:"Ekran paylaşımı başlatılırken bir sorun oluştu.",stopScreenShareGeneric:"Ekran paylaşımı durdurulamadı",callNetworkQualityLow:"Ağ kalitesi düşük.",teamsMeetingCallNetworkQualityLow:"Ağ kalitesi düşük.",callNoSpeakerFound:"Hoparlör veya kulaklık bulunamadı. Aramayı dinlemek için bir ses aygıtı bağlayın.",callNoMicrophoneFound:"Mikrofon bulunamadı. Ses giriş cihazı bağlan.",callMicrophoneAccessDenied:"Mikrofona erişemiyor. Bu web sayfası için izin vermek için adres çubuğundaki kilidi tıklatın.",callMicrophoneAccessDeniedSafari:"Mikrofona erişemiyor. İzin vermek için sayfayı yenileyin veya bu tarayıcının ayarlarını denetleyin ve bu web sitesi için izinlerin etkinleştirildiğinden emin olun.",callMicrophoneMutedBySystem:"Sisteminiz tarafından sessize alındınız.",callMicrophoneUnmutedBySystem:"Mikrofonunuz kurtarıldı ve sisteminiz tarafından sesiniz açıldı.",callMacOsMicrophoneAccessDenied:"Mikrofona erişilemiyor. macOS gizlilik ayarlarınızda mikrofon izni verin.",callLocalVideoFreeze:"Ağ bant genişliği düşük. Görüntülü aramada başkaları için duraklatılmış görünüyor olabilir.",callCameraAccessDenied:"Kameraya erişemiyor. Bu web sayfası için izin vermek için adres çubuğundaki kilidi tıklatın.",callCameraAccessDeniedSafari:"Kameraya erişemiyor. İzin vermek için sayfayı yenileyin veya bu tarayıcının ayarlarını denetleyin ve bu web sitesi için izinlerin etkinleştirildiğinden emin olun.",callCameraAlreadyInUse:"Kameraya erişemiyor. Başka bir uygulama tarafından zaten kullanılıyor olabilir.",callVideoStoppedBySystem:"Videonuz sisteminiz tarafından durduruldu.",callVideoRecoveredBySystem:"Videonuz devam ediyor.",callMacOsCameraAccessDenied:"MacOS kameranıza erişimi engelliyor. Bu tarayıcının kameranıza erişmesine izin vermek için gizlilik ayarlarınızı güncelleştirin.",callMacOsScreenShareAccessDenied:"MacOS ekran paylaşımını engelliyor. Bu tarayıcının ekranınızı kaydetmesini izin vermek için gizlilik ayarlarınızı güncelleştirin.",dismissButtonAriaLabel:"Kapat",failedToJoinCallGeneric:"Aramaya katılınamadı.",failedToJoinCallInvalidMeetingLink:"Toplantıya katılınamıyor. Geçersiz Bağlantı.",cameraFrozenForRemoteParticipants:"Aramadaki kullanıcılar videonuzu görmekte sorun yaşıyor. Lütfen cihazlarınızı ve ağlarınızı kontrol edin.",unableToStartVideoEffect:"Video efekti uygulanamıyor.",startSpotlightWhileMaxParticipantsAreSpotlighted:"Öne çıkarılan katılımcı sayısı zaten üst sınırı geçtiğinden katılımcılarda öne çıkarma özelliği başlatılamıyor.",mutedByRemoteParticipant:"Başka bir katılımcı tarafından sessize alındınız."},notificationStack:{callingNetworkFailure:{title:"Arama bağlanırken sorun oluştu",message:"Çevrimdışı görünüyorsunuz. Lütfen ağ bağlantınızı denetleyin ve yeniden deneyin.",dismissButtonAriaLabel:"Kapat"},startVideoGeneric:{title:"Video başlatılamadı.",dismissButtonAriaLabel:"Kapat"},stopVideoGeneric:{title:"Video durdurulamadı.",dismissButtonAriaLabel:"Kapat"},muteGeneric:{title:"Mikrofonun sesi kapatılamadı.",dismissButtonAriaLabel:"Kapat"},unmuteGeneric:{title:"Mikrofonun sesi açılamadı.",dismissButtonAriaLabel:"Kapat"},speakingWhileMuted:{title:"Sesiniz kapatıldı.",dismissButtonAriaLabel:"Kapat"},startScreenShareGeneric:{title:"Ekran paylaşımı başlatılırken bir sorun oluştu.",dismissButtonAriaLabel:"Kapat"},stopScreenShareGeneric:{title:"Ekran paylaşımı durdurulamadı.",dismissButtonAriaLabel:"Kapat"},callNetworkQualityLow:{title:"Ağ kalitesi düşük.",dismissButtonAriaLabel:"Kapat"},teamsMeetingCallNetworkQualityLow:{title:"Ağ kalitesi düşük.",dismissButtonAriaLabel:"Kapat",message:"Daha iyi ses için telefonunuzdan bu aramaya katılın. Bu cihazda toplantıyı görüntülemeye devam edin.",primaryButtonLabel:"Telefonla Katıl"},callNoSpeakerFound:{title:"Hoparlör veya kulaklık yok",message:"Aramayı dinlemek için bir ses aygıtı bağlayın.",dismissButtonAriaLabel:"Kapat"},callNoMicrophoneFound:{title:"Mikrofon bulunamadı",message:"Ses giriş cihazı bağlayın.",dismissButtonAriaLabel:"Kapat"},callMicrophoneAccessDenied:{title:"Mikrofona erişilemiyor",message:"Bu web sayfası için izin vermek için adres çubuğundaki kilidi tıklatın.",dismissButtonAriaLabel:"Kapat"},callMicrophoneAccessDeniedSafari:{title:"Mikrofona erişilemiyor",message:"İzin vermek için sayfayı yenileyin veya bu tarayıcının ayarlarını denetleyin ve bu web sitesi için izinlerin etkinleştirildiğinden emin olun.",dismissButtonAriaLabel:"Kapat"},callMicrophoneMutedBySystem:{title:"Sisteminiz tarafından sessize alındınız.",dismissButtonAriaLabel:"Kapat"},callMicrophoneUnmutedBySystem:{title:"Mikrofonunuz kurtarıldı ve sisteminiz tarafından sesiniz açıldı.",dismissButtonAriaLabel:"Kapat"},callMacOsMicrophoneAccessDenied:{title:"Mikrofona erişilemiyor",message:"macOS gizlilik ayarlarınıza mikrofon izni verin.",dismissButtonAriaLabel:"Kapat"},callLocalVideoFreeze:{title:"Ağ bant genişliği düşük",message:"Görüntülü aramada başkaları için duraklatılmış görünüyor olabilir.",dismissButtonAriaLabel:"Kapat"},callCameraAccessDenied:{title:"Kameraya erişilemiyor",message:"Bu web sayfası için izin vermek için adres çubuğundaki kilidi tıklatın.",dismissButtonAriaLabel:"Kapat"},callCameraAccessDeniedSafari:{title:"Kameraya erişilemiyor",message:"İzin vermek için sayfayı yenileyin veya bu tarayıcının ayarlarını denetleyin ve bu web sitesi için izinlerin etkinleştirildiğinden emin olun.",dismissButtonAriaLabel:"Kapat"},callCameraAlreadyInUse:{title:"Kameraya erişilemiyor",message:"Başka bir uygulama tarafından zaten kullanılıyor olabilir.",dismissButtonAriaLabel:"Kapat"},callVideoStoppedBySystem:{title:"Videonuz sisteminiz tarafından durduruldu.",dismissButtonAriaLabel:"Kapat"},callVideoRecoveredBySystem:{title:"Videonuz devam ediyor.",dismissButtonAriaLabel:"Kapat"},callMacOsCameraAccessDenied:{title:"MacOS kameranıza erişimi engelliyor",message:"Bu tarayıcının kameranıza erişmesine izin vermek için gizlilik ayarlarınızı güncelleştirin.",dismissButtonAriaLabel:"Kapat"},callMacOsScreenShareAccessDenied:{title:"MacOS ekran paylaşımını engelliyor",message:"Bu tarayıcının ekranınızı kaydetmesini izin vermek için gizlilik ayarlarınızı güncelleştirin.",dismissButtonAriaLabel:"Kapat"},failedToJoinCallGeneric:{title:"Aramaya katılınamadı.",dismissButtonAriaLabel:"Kapat"},failedToJoinCallInvalidMeetingLink:{title:"Toplantıya katılınamıyor. Geçersiz Bağlantı.",dismissButtonAriaLabel:"Kapat"},cameraFrozenForRemoteParticipants:{title:"Aramadaki kullanıcılar videonuzu görmekte sorun yaşıyor",message:"Lütfen cihazlarınızı ve ağlarınızı kontrol edin.",dismissButtonAriaLabel:"Kapat"},unableToStartVideoEffect:{title:"Video efekti uygulanamıyor.",dismissButtonAriaLabel:"Kapat"},startSpotlightWhileMaxParticipantsAreSpotlighted:{title:"Katılımcılarda öne çıkarma özelliği başlatılamıyor",message:"Maksimum katılımcı sayısı zaten öne çıkarıldı.",dismissButtonAriaLabel:"Kapat"},mutedByRemoteParticipant:{title:"Başka bir katılımcı tarafından sessize alındınız.",dismissButtonAriaLabel:"Kapat"},recordingStarted:{title:"Kayıt başladı.",message:"Katılarak bu toplantının dökümünün çıkarılmasına onay verirsiniz.",dismissButtonAriaLabel:"Kapat"},transcriptionStarted:{title:"Döküm başlatıldı.",message:"Katılarak bu toplantının dökümünün çıkarılmasına onay verirsiniz.",dismissButtonAriaLabel:"Kapat"},recordingStopped:{title:"Kayıt kaydediliyor.",message:"Kayıt durduruldu.",dismissButtonAriaLabel:"Kapat"},transcriptionStopped:{title:"Döküm kaydediliyor.",message:"Döküm durduruldu.",dismissButtonAriaLabel:"Kapat"},recordingAndTranscriptionStarted:{title:"Kayıt ve döküm başlatıldı.",message:"Katılarak bu toplantının dökümünün çıkarılmasına onay verirsiniz.",dismissButtonAriaLabel:"Kapat"},recordingAndTranscriptionStopped:{title:"Kayıt ve döküm kaydediliyor.",message:"Kayıt ve döküm durduruldu.",dismissButtonAriaLabel:"Kapat"},recordingStoppedStillTranscribing:{title:"Kayıt durduruldu.",message:"Şu anda yalnızca bu toplantının dökümünü oluşturuyorsunuz.",dismissButtonAriaLabel:"Kapat"},transcriptionStoppedStillRecording:{title:"Döküm durduruldu.",message:"Şu anda yalnızca bu toplantıyı kaydediyorsunuz.",dismissButtonAriaLabel:"Kapat"},assignedBreakoutRoomOpened:{title:"Sizi 5 saniye içinde atanan odanıza taşıyacağız.",dismissButtonAriaLabel:"Kapat"},assignedBreakoutRoomChanged:{title:"Tartışma odanız değişti",message:"Sizi 5 saniye içinde atanan odanıza taşıyacağız.",dismissButtonAriaLabel:"Kapat"},assignedBreakoutRoomClosed:{title:"Tartışma odanız kapatıldı",message:"5 saniye içinde toplantınıza geri taşınacak.",dismissButtonAriaLabel:"Kapat"},assignedBreakoutRoomOpenedPromptJoin:{title:"Tartışma odasına katılmak ister misiniz?",message:"Bir tartışma odasına atandınız.",dismissButtonAriaLabel:"Kapat",primaryButtonLabel:"Odaya katıl",secondaryButtonLabel:"Daha sonra"},breakoutRoomJoined:{title:"Tartışma odasına katıldınız.",dismissButtonAriaLabel:"Kapat"},breakoutRoomClosingSoon:{title:"Oda süre sınırı sona ermek üzere.",message:"Bu oda 30 sn. içinde kapanacak",dismissButtonAriaLabel:"Kapat"},capabilityTurnVideoOnPresent:{title:"Kameranız etkinleştirildi",message:"Video paylaşmak istiyorsanız bu öğeyi açın.",dismissButtonAriaLabel:"Kapat"},capabilityTurnVideoOnAbsent:{title:"Kameranız devre dışı bırakıldı",message:"Artık video paylaşamazsınız.",dismissButtonAriaLabel:"Kapat"},capabilityUnmuteMicPresent:{title:"Mikrofonunuz etkinleştirildi",message:"Konuşmak isterseniz sesi açın.",dismissButtonAriaLabel:"Kapat"},capabilityUnmuteMicAbsent:{title:"Mikrofonunuz devre dışı bırakıldı",message:"Artık sesi açamazsınız.",dismissButtonAriaLabel:"Kapat"},togetherModeStarted:{title:"Togethermode başlatıldı",dismissButtonAriaLabel:"Kapat"},togetherModeEnded:{title:"Togethermode sona erdi",dismissButtonAriaLabel:"Kapat"}},videoGallery:{screenIsBeingSharedMessage:"Ekranınızı paylaşıyorsunuz.",screenShareLoadingMessage:"{participant} adlı katılımcının ekranını yükleme",localScreenShareLoadingMessage:"Ekranınız yükleniyor",localVideoLabel:"Siz",localVideoCameraSwitcherLabel:"Kamerayı değiştir",localVideoMovementLabel:"Taşınabilir Yerel Video Kutucuğu",localVideoMovementAriaLabel:"Taşınabilir Yerel Video Kutucuğu",localVideoSelectedDescription:"{cameraName} seçildi",displayNamePlaceholder:"Adsız katılımcı",fitRemoteParticipantToFrame:"Çerçeveye sığdır",fillRemoteParticipantFrame:"Çerçeveyi doldur",pinParticipantForMe:"Benim için sabitle",pinParticipantForMeLimitReached:"Sabitleme (sınıra ulaşıldı)",unpinParticipantForMe:"Sabitlemeyi kaldır",pinParticipantMenuItemAriaLabel:"{participantName} adlı katılımcıyı sabitle",unpinParticipantMenuItemAriaLabel:"{participantName} adlı katılımcının sabitlemesini kaldır",pinnedParticipantAnnouncementAriaLabel:"{participantName} adlı katılımcı sabitlendi",unpinnedParticipantAnnouncementAriaLabel:"{participantName} adlı katılımcının sabitlemesi kaldırıldı",startSpotlightVideoTileMenuLabel:"Herkes için öne çıkar",addSpotlightVideoTileMenuLabel:"Öne çıkarma ekle",spotlightLimitReachedMenuTitle:"Öne çıkarma sınırına ulaşıldı",stopSpotlightVideoTileMenuLabel:"Öne çıkarmayı durdur",stopSpotlightOnSelfVideoTileMenuLabel:"Öne çıkarmadan çık",attendeeRole:"Katılımcı",muteParticipantMenuItemLabel:"Sesi kapat",waitingScreenText:"Diğerlerinin katılması bekleniyor",forbidAudio:"Mikrofonu devre dışı bırak",permitAudio:"Mikrofona izin ver",forbidAudioTileMenuLabel:"Mikrofonu devre dışı bırak",permitAudioTileMenuLabel:"Mikrofona izin ver",forbidVideo:"Kamerayı devre dışı bırak",permitVideo:"Kameraya izin ver",forbidVideoTileMenuLabel:"Kamerayı devre dışı bırak",permitVideoTileMenuLabel:"Kameraya izin ver"},dialpad:{placeholderText:"Telefon numarası gir",deleteButtonAriaLabel:"Sil"},holdButton:{onLabel:"Devam et",offLabel:"Beklet",tooltipOnContent:"Görüşmeye devam etme",tooltipOffContent:"Aramayı bekletme"},videoTile:{participantStateRinging:"Aranıyor...",participantReconnecting:"Yeniden bağlanıyor...",participantStateHold:"Beklemede",moreOptionsButtonAriaLabel:"Diğer Seçenekler {displayName} {isMuted} {micDisabledState} {cameraDisabledState} {isHandRaised} {state} {isSpeaking}",moreOptionsParticipantMutedStateMutedAriaLabel:"sesi kapalı",moreOptionsParticipantMutedStateUnmutedAriaLabel:"sesi açık",moreOptionsParticipantHandRaisedAriaLabel:"El kaldırdı",moreOptionsParticipantIsSpeakingAriaLabel:"Konuşuyor",moreOptionsParticipantMicDisabledAriaLabel:"Mikrofon devre dışı",moreOptionsParticipantCameraDisabledAriaLabel:"Kamera devre dışı"},CameraAndMicrophoneSitePermissionsRequest:{primaryText:"{appName} uygulamasının kameranızı ve mikrofonunuzu kullanmasına izin verin",secondaryText:"Bu, katılımcıların sizi görebilmesi ve duyabilmesi içindir.",linkText:"Yardıma mı ihtiyacınız var? Sorun giderme yardımı alın",primaryButtonText:"Kamera ve mikrofon olmadan devam et",ariaLabel:"Kamera ve mikrofon erişimine izin ver"},CameraSitePermissionsRequest:{primaryText:"{appName} uygulamasının kameranızı kullanmasına izin verin",secondaryText:"Bu, katılımcıların sizi görebilmesi içindir.",linkText:"Yardıma mı ihtiyacınız var? Sorun giderme yardımı alın",primaryButtonText:"Kamera olmadan devam et",ariaLabel:"Kamera erişimine izin ver"},MicrophoneSitePermissionsRequest:{primaryText:"{appName} uygulamasının mikrofonunuzu kullanmasına izin verin",secondaryText:"Bu, katılımcıların sizi duyabilmesi içindir.",linkText:"Yardıma mı ihtiyacınız var? Sorun giderme yardımı alın",primaryButtonText:"Mikrofon olmadan devam et",ariaLabel:"Mikrofon erişimine izin ver"},CameraAndMicrophoneSitePermissionsCheck:{primaryText:"Kamera ve mikrofon erişimi denetleniyor",secondaryText:"İstenirse erişime izin verin. Bu, katılımcıların sizi görebilmesi ve duyabilmesi içindir.",linkText:"Yardıma mı ihtiyacınız var? Sorun giderme yardımı alın",primaryButtonText:"Kamera ve mikrofon olmadan devam et",ariaLabel:"Kamera ve mikrofon erişimi denetleniyor. İstenirse erişime izin verin."},CameraSitePermissionsCheck:{primaryText:"Kamera erişimi denetleniyor",secondaryText:"İstenirse erişime izin verin. Bu, katılımcıların sizi görebilmesi içindir.",linkText:"Yardıma mı ihtiyacınız var? Sorun giderme yardımı alın",primaryButtonText:"Kamera olmadan devam et",ariaLabel:"Kamera erişimi denetleniyor. İstenirse erişime izin verin."},MicrophoneSitePermissionsCheck:{primaryText:"Mikrofon erişimi denetleniyor",secondaryText:"İstenirse erişime izin verin. Bu, katılımcıların sizi duyabilmesi içindir.",linkText:"Yardıma mı ihtiyacınız var? Sorun giderme yardımı alın",primaryButtonText:"Mikrofon olmadan devam et",ariaLabel:"Mikrofon erişimi denetleniyor. İstenirse erişime izin verin."},CameraAndMicrophoneSitePermissionsDenied:{primaryText:"Kamera ve mikrofona erişemiyor",secondaryText:"Bu web sayfası için mikrofon izinleri vermek için adres çubuğundaki kilit simgesine tıklayın. Sayfa yenilemesi gerekebilir.",primaryButtonText:"Kamera ve mikrofon olmadan devam et",linkText:"Yardıma mı ihtiyacınız var? Sorun giderme yardımı alın"},CameraAndMicrophoneSitePermissionsDeniedSafari:{primaryText:"Kamera ve mikrofona erişemiyor",secondaryText:"İzin vermek için sayfayı yenileyin veya bu tarayıcının ayarlarını denetleyin ve bu web sitesi için izinlerin etkinleştirildiğinden emin olun.",primaryButtonText:"Kamera ve mikrofon olmadan devam et",linkText:"Yardıma mı ihtiyacınız var? Sorun giderme yardımı alın"},CameraSitePermissionsDenied:{primaryText:"Kameraya erişilemiyor",secondaryText:"Bu web sayfasında kamera izinleri vermek için adres çubuğundaki kilit simgesine tıklayın. Sayfa yenilemesi gerekebilir.",primaryButtonText:"Kamera olmadan devam et",linkText:"Yardıma mı ihtiyacınız var? Sorun giderme yardımı alın"},MicrophoneSitePermissionsDenied:{primaryText:"Mikrofona erişilemiyor",secondaryText:"Bu web sayfası için mikrofon izinleri vermek için adres çubuğundaki kilit simgesine tıklayın. Sayfa yenilemesi gerekebilir.",primaryButtonText:"Mikrofon olmadan devam et",linkText:"Yardıma mı ihtiyacınız var? Sorun giderme yardımı alın"},CameraSitePermissionsDeniedSafari:{primaryText:"Kameraya erişilemiyor",secondaryText:"İzin vermek için sayfayı yenileyin veya bu tarayıcının ayarlarını denetleyin ve bu web sitesi için izinlerin etkinleştirildiğinden emin olun.",primaryButtonText:"Kamera olmadan devam et",linkText:"Yardıma mı ihtiyacınız var? Sorun giderme yardımı alın"},MicrophoneSitePermissionsDeniedSafari:{primaryText:"Mikrofona erişilemiyor",secondaryText:"İzin vermek için sayfayı yenileyin veya bu tarayıcının ayarlarını denetleyin ve bu web sitesi için izinlerin etkinleştirildiğinden emin olun.",primaryButtonText:"Mikrofon olmadan devam et",linkText:"Yardıma mı ihtiyacınız var? Sorun giderme yardımı alın"},UnsupportedBrowser:{primaryText:"Tarayıcı desteklenmiyor",secondaryText:"Lütfen uyumlu bir tarayıcı kullanarak bu aramaya katılın.",moreHelpLinkText:"Uyumluluk gereksinimlerini görüntüleyin"},UnsupportedBrowserVersion:{primaryText:"Tarayıcı güncelleştirmesi gerekiyor",secondaryText:"Mümkün olan en iyi arama deneyimi için lütfen tarayıcınızı güncelleştirin ve aramaya yeniden katılmayı deneyin.",moreHelpLinkText:"Uyumluluk gereksinimlerini görüntüleyin",continueAnywayButtonText:"Güncelleştirmeden arama başlat"},UnsupportedOperatingSystem:{primaryText:"İşletim sistemi desteklenmiyor",secondaryText:"Lütfen uyumlu bir işletim sistemine sahip bir cihaz kullanarak bu çağrıya katılın.",moreHelpLinkText:"Uyumluluk gereksinimlerini görüntüleyin"},BrowserPermissionDenied:{primaryText:"Kameranızı veya mikrofonunuzu kullanamazsınız",secondaryText:"Tarayıcınızın kameranıza veya mikrofonunuza erişimi olmayabilir. Bunu düzeltmek için Sistem Tercihleri'ni açın.",primaryButtonText:"Yeniden dene",linkText:"Yardıma mı ihtiyacınız var? Sorun giderme yardımı alın"},BrowserPermissionDeniedIOS:{primaryText:"Devam etmek için mikrofon erişimine izin ver",secondaryText:"Böylece diğer katılımcılar sizi duyabilir.",primaryButtonText:"Yeniden dene",imageAltText:"iOS için mikrofon ve kamera cihazı izin konumu",linkText:"Yardıma mı ihtiyacınız var? Sorun giderme yardımı alın",step1Text:"Ayarlar uygulamasına gidin",step2Text:"Bu tarayıcının ayarlarına ilerleyin",step3Text:"Mikrofonu Aç (İsteğe bağlı kamera)",step4Text:"Aramaya tekrar katılmayı deneyin",step1DigitText:"1",step2DigitText:"2",step3DigitText:"3",step4DigitText:"4"},verticalGallery:{leftNavButtonAriaLabel:"önceki sayfa {current}/{total}",rightNavButtonAriaLabel:"sonraki sayfa {current}/{total}"},meetingConferencePhoneInfo:{meetingConferencePhoneInfoModalTitle:"Telefonunuzdan aramaya katılın",meetingConferencePhoneInfoModalDialIn:"Numarayı çevirin",meetingConferencePhoneInfoModalMeetingId:"Toplantı kimliğini girin",meetingConferencePhoneInfoModalWait:"Düzenleyici tarafından kabul etmek için bekleyin",meetingConferencePhoneInfoModalNoPhoneAvailable:"Kullanılabilir telefon yok",meetingConferencePhoneInfoModalTollGeoData:"{country}, {city}",meetingConferencePhoneInfoModalTollFree:"(Ücretsiz)",meetingConferencePhoneInfoModalToll:"(Ücretli)"},IncomingCallNotification:{incomingCallNotificationPlaceholderId:"Bilinmeyen Kullanıcı",incomingCallNotificationPlaceholderAlert:"{callerName} arıyor",incomingCallNoticicationAcceptWithAudioAriaLabel:"Sesli kabul et",incomingCallNoticicationAcceptWithVideoAriaLabel:"Görüntülü kabul et",incomingCallNoticicationRejectAriaLabel:"Reddet",incomingCallNotificationAcceptButtonLabel:"Kabul et",incomingCallNotificationRejectButtonLabel:"Reddet",incomingCallNotificationAccceptWithVideoButtonLabel:"Görüntülü Kabul Et",incomingCallNotificationDismissButtonAriaLabel:"Kapat"}})},AQt={strings:Jh({participantItem:{isMeText:"(我)",menuTitle:"更多选项",removeButtonLabel:"删除",sharingIconLabel:"共享",mutedIconLabel:"已静音",handRaisedIconLabel:"已举手 - 位置 {position}",displayNamePlaceholder:"未命名的参与者",participantStateRinging:"正在呼叫...",participantStateHold:"保留",participantItemAriaLabel:"{displayName}, {handRaisedState}, {mutedState}, {micDisabledState}, {cameraDisabledState}, {sharingState}, {connectionState}",participantItemWithMoreOptionsAriaLabel:"{displayName}、{handRaisedState}、{mutedState}、{micDisabledState}、{cameraDisabledState}、{sharingState}、{connectionState}、更多选项",attendeeRole:"与会者",micDisabledIconLabel:"麦克风已禁用",cameraDisabledIconLabel:"相机已禁用"},ParticipantList:{overflowParticipantCount:"和另外 {overflowCount} 人"},typingIndicator:{singleUser:"{user} 正在键入...",multipleUsers:"{users} 正在键入...",multipleUsersAbbreviateOne:"{users} 和另外 1 人正在键入...",multipleUsersAbbreviateMany:"{users} 和其他 {numOthers} 人正在键入...",delimiter:"、 "},sendBox:{placeholderText:"输入消息",textTooLong:"你的消息长度超过了最大限制。",sendButtonAriaLabel:"发送消息",attachmentUploadsPendingError:"正在上传文件，请稍候。",removeAttachment:"删除文件",uploading:"正在上传",uploadCompleted:"已完成上传",attachmentMoreMenu:"更多选项"},richTextSendBox:{placeholderText:"输入消息",textTooLong:"你的消息长度超过了最大限制。",sendButtonAriaLabel:"发送信息",attachmentUploadsPendingError:"正在上传文件，请稍候。",imageUploadsPendingError:"正在上传图像，请稍候。",removeAttachment:"删除文件",uploading:"正在上传",uploadCompleted:"已完成上传",richTextBoldTooltip:"粗体",richTextItalicTooltip:"斜体",richTextUnderlineTooltip:"下划线",richTextBulletListTooltip:"项目符号列表",richTextNumberListTooltip:"编号列表",richTextIncreaseIndentTooltip:"增加缩进量",richTextDecreaseIndentTooltip:"减少缩进量",richTextInsertTableTooltip:"插入表格",richTextFormatButtonTooltip:"格式",richTextInsertRowOrColumnMenu:"插入",richTextInsertTableMenuTitle:"插入 {column} x {row} 表",richTextInsertRowAboveMenu:"在上方插入",richTextInsertRowBelowMenu:"在下方插入",richTextInsertColumnLeftMenu:"在左侧插入",richTextInsertColumnRightMenu:"在右侧插入",richTextDeleteRowOrColumnMenu:"删除",richTextDeleteColumnMenu:"删除列",richTextDeleteRowMenu:"删除行",richTextDeleteTableMenu:"删除表格",richTextToolbarAriaLabel:"消息格式设置工具栏",richTextToolbarMoreButtonAriaLabel:"更多选项",attachmentMoreMenu:"更多选项",richTextNewBulletedListItemAnnouncement:"项目符号，新行",richTextNewNumberedListItemAnnouncement:"{0}，新行",richTextBulletedListAppliedAnnouncement:"已应用项目符号列表",richTextNumberedListAppliedAnnouncement:"已应用编号列表"},realTimeTextModal:{realTimeTextModalAriaLabel:"打开 RTT 模式",realTimeTextModalTitle:"是否启用 RTT?",realTimeTextModalText:"将为会议中的每个人启用实时文本 (RTT)。",realTimeTextConfirmButtonLabel:"启用",realTimeTextCancelButtonLabel:"取消",realTimeTextCloseModalButtonAriaLabel:"关闭 RTT 模式"},captionsBanner:{captionsBannerSpinnerText:"正在启动字幕...",realTimeTextInputBoxDefaultText:"实时键入消息",realTimeTextInputErrorMessage:"消息不能超过 2000 个字符",realTimeTextBannerTitle:"RTT",realTimeTextBannerContent:"RTT (在会议的整个持续时间内为所有参与者启用实时文本)。",realTimeTextBannerLinkLabel:"了解详情",captionsOnlyContainerTitle:"字幕",realTimeTextOnlyContainerTitle:"实时文本",captionsAndRealTimeTextContainerTitle:"字幕和实时文本",expandButtonAriaLabel:"展开",minimizeButtonAriaLabel:"折叠"},mentionPopover:{mentionPopoverHeader:"建议"},imageOverlay:{downloadButtonLabel:"下载",dismissButtonAriaLabel:"关闭",overlayVisibleMessage:"图像详细信息覆盖"},messageStatusIndicator:{deliveredAriaLabel:"已发送消息",deliveredTooltipText:"已发送",seenAriaLabel:"其他人已查看消息",seenTooltipText:"已查看",readByTooltipText:"{messageThreadReadCount}/{remoteParticipantsCount} 人已读",sendingAriaLabel:"消息发送",sendingTooltipText:"正在发送",failedToSendAriaLabel:"消息发送失败",failedToSendTooltipText:"发送失败"},endCallButton:{label:"退出",tooltipContent:"离开通话",leaveOption:"退出",endCallOption:"结束所有人的通话"},cameraButton:{onLabel:"相机",offLabel:"相机",tooltipDisabledContent:"已禁用照相机",tooltipOnContent:"关闭摄像头",tooltipOffContent:"打开摄像头",tooltipVideoLoadingContent:"正在加载视频",cameraMenuTitle:"相机",cameraMenuTooltip:"选择“相机”",cameraButtonSplitRoleDescription:"拆分按钮",onSplitButtonAriaLabel:"关闭摄像头",offSplitButtonAriaLabel:"打开摄像头",cameraActionTurnedOnAnnouncement:"你的相机已打开",cameraActionTurnedOffAnnouncement:"你的相机已关闭",onSplitButtonPrimaryActionCamera:"关闭摄像头",offSplitButtonPrimaryActionCamera:"打开摄像头",cameraPrimaryActionSplitButtonTitle:"使用照相机",videoEffectsMenuItemTitle:"效果",cameraButtonAriaDescription:"摄像头选项"},microphoneButton:{onLabel:"麦克风",offLabel:"麦克风",tooltipDisabledContent:"已禁用麦克风",tooltipOnContent:"将麦克风静音",tooltipOffContent:"取消麦克风静音",microphoneMenuTitle:"麦克风",microphoneMenuTooltip:"选择“麦克风”",speakerMenuTitle:"扬声器",speakerMenuTooltip:"选择“扬声器”",microphoneButtonSplitRoleDescription:"拆分按钮",onSplitButtonAriaLabel:"将麦克风静音",offSplitButtonAriaLabel:"取消麦克风静音",microphoneActionTurnedOnAnnouncement:"你的麦克风已打开",microphoneActionTurnedOffAnnouncement:"你的麦克风已关闭",offSplitButtonMicrophonePrimaryAction:"取消麦克风静音",onSplitButtonMicrophonePrimaryAction:"将麦克风静音",microphonePrimaryActionSplitButtonTitle:"使用麦克风",microphoneAriaDescription:"音频选项",deepNoiseSuppressionTitle:"噪音抑制",deepNoiseSuppressionOnAnnouncement:"深层噪音抑制已打开",deepNoiseSuppressionOffAnnouncement:"深层噪音抑制已关闭"},devicesButton:{label:"设备",tooltipContent:"管理设备",cameraMenuTitle:"相机",cameraMenuTooltip:"选择“相机”",audioDeviceMenuTitle:"音频设备",audioDeviceMenuTooltip:"选择音频设备",microphoneMenuTitle:"麦克风",microphoneMenuTooltip:"选择“麦克风”",speakerMenuTitle:"免提",speakerMenuTooltip:"选择“扬声器”"},participantsButton:{label:"人员",ariaLabel:"人脉",tooltipContent:"显示参与者",menuHeader:"在此通话中",participantsListButtonLabel:"{numParticipants} 人",muteAllButtonLabel:"全部静音",copyInviteLinkButtonLabel:"复制邀请链接",copyInviteLinkActionedAriaLabel:"已复制邀请链接"},screenShareButton:{onLabel:"停止演示",offLabel:"演示",tooltipDisabledContent:"已禁用演示。",tooltipOnContent:"演示屏幕",tooltipOffContent:"演示您的屏幕"},raiseHandButton:{offLabel:"举手",onLabel:"放下",tooltipDisabledContent:"举手操作已禁用",tooltipOnContent:"手放下",tooltipOffContent:"举手"},reactionButton:{label:"回应",ariaLabel:"回应",tooltipDisabledContent:"已禁用表情符号操作",tooltipContent:"发送表情符号",likeReactionTooltipContent:"点赞",heartReactionTooltipContent:"喜欢",laughReactionTooltipContent:"大笑",applauseReactionTooltipContent:"鼓掌",surprisedReactionTooltipContent:"惊讶"},realTimeText:{isTypingText:"RTT 键入"},captionsSettingsModal:{captionsSettingsModalTitle:"字幕设置",captionsSettingsSpokenLanguageDropdownLabel:"口语",captionsSettingsCaptionLanguageDropdownLabel:"辅助字幕语言",captionsSettingsSpokenLanguageDropdownInfoText:"此通话中的每个人都在讲的语言。",captionsSettingsCaptionLanguageDropdownInfoText:"字幕将以此语言显示。",captionsSettingsConfirmButtonLabel:"确认",captionsSettingsCancelButtonLabel:"取消",captionsSettingsModalAriaLabel:"字幕设置模式",captionsSettingsCloseModalButtonAriaLabel:"关闭字幕设置"},spokenLanguages:{"ar-ae":"阿拉伯语 - 阿拉伯联合酋长国","ar-sa":"阿拉伯语 - 沙特阿拉伯","da-dk":"丹麦语","de-de":"德语 - 德国","en-au":"英语 - 澳大利亚","en-ca":"英语 - 加拿大","en-gb":"英语 - 英国","en-in":"英语 - 印度","en-nz":"英语 - 新西兰","en-us":"英语 - 美国","es-es":"西班牙语 - 西班牙(现代风格)","es-mx":"西班牙语 - 墨西哥","fi-fi":"芬兰语","fr-ca":"法语 - 加拿大","fr-fr":"法语 - 法国","hi-in":"印地语","it-it":"意大利语–意大利","ja-jp":"日语","ko-kr":"韩语","nb-no":"挪威语(博克马尔语)","nl-be":"荷兰语 - 比利时","nl-nl":"荷兰语 - 荷兰","pl-pl":"波兰语","pt-br":"葡萄牙语 - 巴西","ru-ru":"俄语","sv-se":"瑞典语","zh-cn":"中文 - 中华人民共和国","zh-hk":"中文 - 香港特别行政区","cs-cz":"捷克语","pt-pt":"葡萄牙语 - 葡萄牙","tr-tr":"土耳其语","vi-vn":"越南语","th-th":"泰语","he-il":"希伯来语","cy-gb":"威尔士语","uk-ua":"乌克兰语","el-gr":"希腊语","hu-hu":"匈牙利语","ro-ro":"罗马尼亚语","sk-sk":"斯洛伐克","zh-tw":"中文 – 台湾"},captionLanguages:{ar:"阿拉伯语",da:"丹麦语",de:"德语",en:"英语",es:"西班牙语",fi:"芬兰语","fr-ca":"法语 - 加拿大",fr:"法语 - 法国",hi:"印地语",it:"意大利语",ja:"日语",ko:"韩语",nb:"挪威语(博克马尔语)",nl:"荷兰语",pl:"波兰语",pt:"葡萄牙语 - 巴西",ru:"俄语",sv:"瑞典语","zh-Hans":"简体中文","zh-Hant":"中文(繁体)",cs:"捷克语","pt-pt":"葡萄牙语 - 葡萄牙",tr:"土耳其语",vi:"越南语",th:"泰语",he:"希伯来语",cy:"威尔士语",uk:"乌克兰语",el:"希腊语",hu:"匈牙利语",ro:"罗马尼亚语",sk:"斯洛伐克"},startCaptionsButton:{onLabel:"开启字幕",offLabel:"关闭辅助字幕",tooltipOnContent:"关闭辅助字幕",tooltipOffContent:"开启字幕"},startRealTimeTextButton:{label:"为此通话启用 RTT",tooltipOffContent:"为此通话启用 RTT"},messageThread:{yesterday:"昨天",sunday:"星期日",monday:"星期一",tuesday:"星期二",wednesday:"星期三",thursday:"星期四",friday:"星期五",saturday:"星期六",participantJoined:"已加入聊天。",participantLeft:"已退出聊天。",editMessage:"编辑",removeMessage:"删除",resendMessage:"尝试再次发送",failToSendTag:"发送失败",editedTag:"已编辑",liveAuthorIntro:"来自 {author} 的消息",editedMessageLiveAuthorIntro:"已编辑来自 {author} 的消息",editedMessageLocalUserLiveAuthorIntro:"编辑的消息",messageContentAriaText:"{status}{author} 说 {message}",messageContentMineAriaText:"{status}你说了 {message}",editBoxTextLimit:"你的消息超过了{limitNumber}个字符的限制",editBoxPlaceholderText:"编辑消息",newMessagesIndicator:"新消息",noDisplayNameSub:"无名称",editBoxCancelButton:"取消",editBoxSubmitButton:"完成",messageReadCount:"{messageReadByCount}/{remoteParticipantsCount} 人已读",actionMenuMoreOptions:"更多选项",downloadAttachment:"下载文件",openAttachment:"打开文件",blockedWarningText:"由于组织策略，此消息已被删除。",blockedWarningLinkText:"详细信息",attachmentCardGroupMessage:"该消息包含 {attachmentCount} 个附件",messageDeletedAnnouncementAriaLabel:"消息已删除",richTextBoldTooltip:"粗体",richTextItalicTooltip:"斜体",richTextUnderlineTooltip:"下划线",richTextBulletListTooltip:"项目符号列表",richTextNumberListTooltip:"编号列表",richTextIncreaseIndentTooltip:"增加缩进量",richTextDecreaseIndentTooltip:"减少缩进量",richTextInsertTableTooltip:"插入表格",richTextFormatButtonTooltip:"格式",richTextInsertRowOrColumnMenu:"插入",richTextInsertTableMenuTitle:"插入 {column} x {row} 表",richTextInsertRowAboveMenu:"在上方插入",richTextInsertRowBelowMenu:"在下方插入",richTextInsertColumnLeftMenu:"在左侧插入",richTextInsertColumnRightMenu:"在右侧插入",richTextDeleteRowOrColumnMenu:"删除",richTextDeleteColumnMenu:"删除列",richTextDeleteRowMenu:"删除行",richTextDeleteTableMenu:"删除表格",richTextToolbarMoreButtonAriaLabel:"更多选项",attachmentUploadsPendingError:"正在上传文件，请稍候。",imageUploadsPendingError:"正在上传图像，请稍候。",richTextNewBulletedListItemAnnouncement:"项目符号，新行",richTextNewNumberedListItemAnnouncement:"{0}，新行",richTextBulletedListAppliedAnnouncement:"已应用项目符号列表",richTextNumberedListAppliedAnnouncement:"已应用编号列表"},errorBar:{unableToReachChatService:"你已脱机",accessDenied:"无法访问聊天服务 - 请检查提供的用户凭据",userNotInChatThread:"你不再处于此聊天会话中",sendMessageNotInChatThread:"无法发送消息，因为你不再在此聊天会话中",sendMessageGeneric:"未能发送消息",callingNetworkFailure:"正在连接呼叫 - 你似乎处于脱机状态",startVideoGeneric:"无法启动视频",stopVideoGeneric:"无法停止视频",muteGeneric:"无法静音麦克风",unmuteGeneric:"无法取消麦克风静音",speakingWhileMuted:"你的麦克风已静音",startScreenShareGeneric:"启动屏幕共享时出现问题。",stopScreenShareGeneric:"无法停止屏幕共享",callNetworkQualityLow:"网络质量低。",teamsMeetingCallNetworkQualityLow:"网络质量低。",callNoSpeakerFound:"找不到扬声器或耳机。连接音频设备以收听呼叫。",callNoMicrophoneFound:"找不到麦克风。连接音频输入设备。",callMicrophoneAccessDenied:"无法访问麦克风。单击地址栏中的锁定以授予对此网页的权限。",callMicrophoneAccessDeniedSafari:"无法访问麦克风。刷新页面以允许权限，或检查此浏览器的设置并验证是否为此网站启用了权限。",callMicrophoneMutedBySystem:"系统已将你设为静音。",callMicrophoneUnmutedBySystem:"你的麦克风已恢复，系统已取消静音。",callMacOsMicrophoneAccessDenied:"无法访问麦克风。在 macOS 隐私设置中授予麦克风权限。",callLocalVideoFreeze:"网络带宽较差。你的视频在会议中的其他人看来可能会卡顿。",callCameraAccessDenied:"无法访问照相机。单击地址栏中的锁定以授予对此网页的权限。",callCameraAccessDeniedSafari:"无法访问照相机。刷新页面以允许权限，或检查此浏览器的设置并验证是否为此网站启用了权限。",callCameraAlreadyInUse:"无法访问照相机。它可能已被其他应用程序使用。",callVideoStoppedBySystem:"你的系统已停止你的视频。",callVideoRecoveredBySystem:"你的视频已恢复。",callMacOsCameraAccessDenied:"MacOS 正在阻止访问你的相机。更新你的隐私设置以允许此浏览器访问你的相机。",callMacOsScreenShareAccessDenied:"MacOS 正在阻止屏幕共享。更新你的隐私设置以允许此浏览器录制你的屏幕。",dismissButtonAriaLabel:"关闭",failedToJoinCallGeneric:"未能加入通话。",failedToJoinCallInvalidMeetingLink:"无法加入会议。无效的链接。",cameraFrozenForRemoteParticipants:"通话中的用户在查看视频时遇到问题。请检查你的设备和网络。",unableToStartVideoEffect:"无法应用视频效果。",startSpotlightWhileMaxParticipantsAreSpotlighted:"无法聚焦参与者，因为聚焦的参与者人数已达到上限。",mutedByRemoteParticipant:"另一个参与者已将你静音。"},notificationStack:{callingNetworkFailure:{title:"连接通话时遇到问题",message:"你似乎处于脱机状态。请检查网络连接，然后重试。",dismissButtonAriaLabel:"关闭"},startVideoGeneric:{title:"无法启动视频。",dismissButtonAriaLabel:"关闭"},stopVideoGeneric:{title:"无法停止视频。",dismissButtonAriaLabel:"关闭"},muteGeneric:{title:"无法将麦克风静音。",dismissButtonAriaLabel:"关闭"},unmuteGeneric:{title:"无法取消麦克风静音。",dismissButtonAriaLabel:"关闭"},speakingWhileMuted:{title:"你已静音。",dismissButtonAriaLabel:"关闭"},startScreenShareGeneric:{title:"启动屏幕共享时出现问题。",dismissButtonAriaLabel:"关闭"},stopScreenShareGeneric:{title:"无法停止屏幕共享。",dismissButtonAriaLabel:"关闭"},callNetworkQualityLow:{title:"网络质量低。",dismissButtonAriaLabel:"关闭"},teamsMeetingCallNetworkQualityLow:{title:"网络质量低。",dismissButtonAriaLabel:"关闭",message:"从你的手机加入此通话以获得更好的声音。你可以继续在此设备上查看会议。",primaryButtonLabel:"通过电话加入"},callNoSpeakerFound:{title:"找不到扬声器或耳机",message:"连接音频设备以收听呼叫。",dismissButtonAriaLabel:"关闭"},callNoMicrophoneFound:{title:"未找到麦克风",message:"连接音频输入设备。",dismissButtonAriaLabel:"关闭"},callMicrophoneAccessDenied:{title:"无法访问麦克风",message:"单击地址栏中的锁定以授予对此网页的权限。",dismissButtonAriaLabel:"关闭"},callMicrophoneAccessDeniedSafari:{title:"无法访问麦克风",message:"刷新页面以允许权限，或检查此浏览器的设置并验证是否为此网站启用了权限。",dismissButtonAriaLabel:"关闭"},callMicrophoneMutedBySystem:{title:"系统已将你设为静音。",dismissButtonAriaLabel:"关闭"},callMicrophoneUnmutedBySystem:{title:"你的麦克风已恢复，系统已取消静音。",dismissButtonAriaLabel:"关闭"},callMacOsMicrophoneAccessDenied:{title:"无法访问麦克风",message:"在 macOS 隐私设置中授予麦克风权限。",dismissButtonAriaLabel:"关闭"},callLocalVideoFreeze:{title:"网络带宽较差",message:"您的视频可能会对通话中的其他人暂停。",dismissButtonAriaLabel:"关闭"},callCameraAccessDenied:{title:"无法访问摄像头",message:"单击地址栏中的锁定以授予对此网页的权限。",dismissButtonAriaLabel:"关闭"},callCameraAccessDeniedSafari:{title:"无法访问摄像头",message:"刷新页面以允许权限，或检查此浏览器的设置并验证是否为此网站启用了权限。",dismissButtonAriaLabel:"关闭"},callCameraAlreadyInUse:{title:"无法访问摄像头",message:"它可能已被其他应用程序使用。",dismissButtonAriaLabel:"关闭"},callVideoStoppedBySystem:{title:"你的系统已停止你的视频。",dismissButtonAriaLabel:"关闭"},callVideoRecoveredBySystem:{title:"你的视频已恢复。",dismissButtonAriaLabel:"关闭"},callMacOsCameraAccessDenied:{title:"MacOS 正在阻止对摄像头的访问",message:"更新你的隐私设置以允许此浏览器访问你的相机。",dismissButtonAriaLabel:"关闭"},callMacOsScreenShareAccessDenied:{title:"MacOS 正在阻止屏幕共享",message:"更新你的隐私设置以允许此浏览器录制你的屏幕。",dismissButtonAriaLabel:"关闭"},failedToJoinCallGeneric:{title:"无法加入通话。",dismissButtonAriaLabel:"关闭"},failedToJoinCallInvalidMeetingLink:{title:"无法加入会议。无效的链接。",dismissButtonAriaLabel:"关闭"},cameraFrozenForRemoteParticipants:{title:"通话中的用户在查看视频时遇到问题",message:"请检查你的设备和网络。",dismissButtonAriaLabel:"关闭"},unableToStartVideoEffect:{title:"无法应用视频效果。",dismissButtonAriaLabel:"关闭"},startSpotlightWhileMaxParticipantsAreSpotlighted:{title:"无法在参与者上启动聚焦",message:"已聚焦的最大参与者数。",dismissButtonAriaLabel:"关闭"},mutedByRemoteParticipant:{title:"另一个参与者已将你静音。",dismissButtonAriaLabel:"关闭"},recordingStarted:{title:"已开始录制。",message:"加入即表示你同意转录此会议。",dismissButtonAriaLabel:"关闭"},transcriptionStarted:{title:"听录已开始。",message:"加入即表示你同意转录此会议。",dismissButtonAriaLabel:"关闭"},recordingStopped:{title:"正在保存录制内容。",message:"录制已停止。",dismissButtonAriaLabel:"关闭"},transcriptionStopped:{title:"正在保存听录。",message:"听录已停止。",dismissButtonAriaLabel:"关闭"},recordingAndTranscriptionStarted:{title:"录制和听录已开始。",message:"加入即表示你同意转录此会议。",dismissButtonAriaLabel:"关闭"},recordingAndTranscriptionStopped:{title:"正在保存录制和听录。",message:"录制和听录已停止。",dismissButtonAriaLabel:"关闭"},recordingStoppedStillTranscribing:{title:"录制已停止。",message:"现在仅听录此会议。",dismissButtonAriaLabel:"关闭"},transcriptionStoppedStillRecording:{title:"听录已停止。",message:"现在仅录制此会议。",dismissButtonAriaLabel:"关闭"},assignedBreakoutRoomOpened:{title:"我们将在 5 秒后将你移动到你分配的聊天室。",dismissButtonAriaLabel:"关闭"},assignedBreakoutRoomChanged:{title:"你的分组讨论室已更改",message:"我们将在 5 秒后将你移动到你分配的聊天室。",dismissButtonAriaLabel:"关闭"},assignedBreakoutRoomClosed:{title:"你的分组讨论室已关闭",message:"我们将在 5 秒后将你移回会议。",dismissButtonAriaLabel:"关闭"},assignedBreakoutRoomOpenedPromptJoin:{title:"要加入分组讨论室吗?",message:"已将你分配到一间分组讨论室。",dismissButtonAriaLabel:"关闭",primaryButtonLabel:"加入分组讨论室",secondaryButtonLabel:"以后再说"},breakoutRoomJoined:{title:"你已加入分组讨论室。",dismissButtonAriaLabel:"关闭"},breakoutRoomClosingSoon:{title:"分组讨论室时间限制即将过期。",message:"此分组讨论室将在 30 秒内关闭",dismissButtonAriaLabel:"关闭"},capabilityTurnVideoOnPresent:{title:"已启用你的摄像头",message:"如果想要共享视频，请将其打开。",dismissButtonAriaLabel:"关闭"},capabilityTurnVideoOnAbsent:{title:"你的摄像头已被禁用",message:"你无法再共享视频。",dismissButtonAriaLabel:"关闭"},capabilityUnmuteMicPresent:{title:"已启用麦克风",message:"你想说话时，请取消静音。",dismissButtonAriaLabel:"关闭"},capabilityUnmuteMicAbsent:{title:"已禁用麦克风",message:"你无法再取消静音。",dismissButtonAriaLabel:"关闭"},togetherModeStarted:{title:"Togethermode 已启动",dismissButtonAriaLabel:"关闭"},togetherModeEnded:{title:"Togethermode 已结束",dismissButtonAriaLabel:"关闭"}},videoGallery:{screenIsBeingSharedMessage:"你正在共享你的屏幕",screenShareLoadingMessage:"正在加载 {participant} 的屏幕",localScreenShareLoadingMessage:"正在加载屏幕",localVideoLabel:"你",localVideoCameraSwitcherLabel:"切换相机",localVideoMovementLabel:"可移动本地小窗视频",localVideoMovementAriaLabel:"可移动本地小窗视频",localVideoSelectedDescription:"已选择 {cameraName}",displayNamePlaceholder:"未命名的参与者",fitRemoteParticipantToFrame:"适应帧大小",fillRemoteParticipantFrame:"填充帧",pinParticipantForMe:"为我固定",pinParticipantForMeLimitReached:"固定(已达到上限)",unpinParticipantForMe:"取消固定",pinParticipantMenuItemAriaLabel:"固定 {participantName}",unpinParticipantMenuItemAriaLabel:"取消固定 {participantName}",pinnedParticipantAnnouncementAriaLabel:"已固定 {participantName}",unpinnedParticipantAnnouncementAriaLabel:"已取消固定 {participantName}",startSpotlightVideoTileMenuLabel:"对所有人聚焦",addSpotlightVideoTileMenuLabel:"添加聚焦",spotlightLimitReachedMenuTitle:"已达到聚焦限制",stopSpotlightVideoTileMenuLabel:"停止聚焦",stopSpotlightOnSelfVideoTileMenuLabel:"退出聚焦",attendeeRole:"与会者",muteParticipantMenuItemLabel:"静音",waitingScreenText:"正在等待其他人加入",forbidAudio:"禁用麦克风",permitAudio:"允许使用麦克风",forbidAudioTileMenuLabel:"禁用麦克风",permitAudioTileMenuLabel:"允许使用麦克风",forbidVideo:"禁用摄像头",permitVideo:"允许使用摄像头",forbidVideoTileMenuLabel:"禁用摄像头",permitVideoTileMenuLabel:"允许使用摄像头"},dialpad:{placeholderText:"输入电话号码",deleteButtonAriaLabel:"删除"},holdButton:{onLabel:"恢复",offLabel:"支持",tooltipOnContent:"继续呼叫",tooltipOffContent:"保持呼叫"},videoTile:{participantStateRinging:"正在呼叫...",participantReconnecting:"正在重新连接...",participantStateHold:"保留",moreOptionsButtonAriaLabel:"更多选项 {displayName} {isMuted} {micDisabledState} {cameraDisabledState} {isHandRaised} {state} {isSpeaking}",moreOptionsParticipantMutedStateMutedAriaLabel:"已静音",moreOptionsParticipantMutedStateUnmutedAriaLabel:"已取消静音",moreOptionsParticipantHandRaisedAriaLabel:"已举手",moreOptionsParticipantIsSpeakingAriaLabel:"讲话",moreOptionsParticipantMicDisabledAriaLabel:"麦克风已禁用",moreOptionsParticipantCameraDisabledAriaLabel:"相机已禁用"},CameraAndMicrophoneSitePermissionsRequest:{primaryText:"允许{appName}使用你的相机和麦克风",secondaryText:"这样参与者就可以看到并听到你的声音。",linkText:"需要帮助? 获取疑难解答帮助",primaryButtonText:"不使用相机和麦克风继续",ariaLabel:"允许相机和麦克风访问权限"},CameraSitePermissionsRequest:{primaryText:"允许 {appName} 使用你的相机",secondaryText:"这样参与者就可以看到你了。",linkText:"需要帮助? 获取疑难解答帮助",primaryButtonText:"不使用摄像头继续",ariaLabel:"允许相机访问权限"},MicrophoneSitePermissionsRequest:{primaryText:"允许 {appName} 使用你的麦克风",secondaryText:"这样参与者就可以听到你的声音。",linkText:"需要帮助? 获取疑难解答帮助",primaryButtonText:"不使用麦克风继续",ariaLabel:"允许麦克风访问权限"},CameraAndMicrophoneSitePermissionsCheck:{primaryText:"检查摄像头和麦克风访问权限",secondaryText:"如果出现提示，请允许访问。这样参与者就可以看到并听到你的声音。",linkText:"需要帮助? 获取疑难解答帮助",primaryButtonText:"不使用相机和麦克风继续",ariaLabel:"正在检查摄像头和麦克风访问权限。如果出现提示，请允许访问。"},CameraSitePermissionsCheck:{primaryText:"检查摄像头访问权限",secondaryText:"如果出现提示，请允许访问。这样参与者就可以看到你了。",linkText:"需要帮助? 获取疑难解答帮助",primaryButtonText:"不使用相机继续",ariaLabel:"正在检查摄像头访问权限。如果出现提示，请允许访问。"},MicrophoneSitePermissionsCheck:{primaryText:"正在检查麦克风访问权限",secondaryText:"如果出现提示，请允许访问。这样参与者就可以听到你的声音。",linkText:"需要帮助? 获取疑难解答帮助",primaryButtonText:"不使用麦克风继续",ariaLabel:"正在检查麦克风访问权限。如果出现提示，请允许访问。"},CameraAndMicrophoneSitePermissionsDenied:{primaryText:"无法访问相机和麦克风",secondaryText:"单击地址栏中的锁图标以向此网页授予麦克风权限。可能需要页面刷新。",primaryButtonText:"不使用摄像头和麦克风继续",linkText:"需要帮助? 获取疑难解答帮助"},CameraAndMicrophoneSitePermissionsDeniedSafari:{primaryText:"无法访问相机和麦克风",secondaryText:"刷新页面以允许权限，或检查此浏览器的设置并验证是否为此网站启用了权限。",primaryButtonText:"不使用摄像头和麦克风继续",linkText:"需要帮助? 获取疑难解答帮助"},CameraSitePermissionsDenied:{primaryText:"无法访问摄像头",secondaryText:"单击地址栏中的锁图标以向此网页授予相机权限。可能需要页面刷新。",primaryButtonText:"不使用摄像头继续",linkText:"需要帮助? 获取疑难解答帮助"},MicrophoneSitePermissionsDenied:{primaryText:"无法访问麦克风",secondaryText:"单击地址栏中的锁图标以向此网页授予麦克风权限。可能需要页面刷新。",primaryButtonText:"不使用麦克风继续",linkText:"需要帮助? 获取疑难解答帮助"},CameraSitePermissionsDeniedSafari:{primaryText:"无法访问相机",secondaryText:"刷新页面以允许权限，或检查此浏览器的设置并验证是否为此网站启用了权限。",primaryButtonText:"不使用相机继续",linkText:"需要帮助? 获取疑难解答帮助"},MicrophoneSitePermissionsDeniedSafari:{primaryText:"无法访问麦克风",secondaryText:"刷新页面以允许权限，或检查此浏览器的设置并验证是否为此网站启用了权限。",primaryButtonText:"不使用麦克风继续",linkText:"需要帮助? 获取疑难解答帮助"},UnsupportedBrowser:{primaryText:"浏览器不受支持",secondaryText:"请使用兼容的浏览器加入此通话。",moreHelpLinkText:"查看兼容性要求"},UnsupportedBrowserVersion:{primaryText:"需要浏览器更新",secondaryText:"为确保通话达到最佳效果，请更新浏览器，然后再次尝试加入呼叫。",moreHelpLinkText:"查看兼容性要求",continueAnywayButtonText:"在不更新的情况下启动呼叫"},UnsupportedOperatingSystem:{primaryText:"不支持操作系统",secondaryText:"请使用具有兼容的操作系统的设备加入此通话。",moreHelpLinkText:"查看兼容性要求"},BrowserPermissionDenied:{primaryText:"无法使用摄像头或麦克风",secondaryText:"你的浏览器可能无法访问你的相机或麦克风。若要解决此问题，请打开“系统首选项”。",primaryButtonText:"重试",linkText:"需要帮助? 获取疑难解答帮助"},BrowserPermissionDeniedIOS:{primaryText:"允许麦克风访问以继续",secondaryText:"这样其他参与者就可以听到你的声音。",primaryButtonText:"重试",imageAltText:"iOS 的麦克风和摄像头设备权限位置",linkText:"需要帮助? 获取疑难解答帮助",step1Text:"转到设置应用",step2Text:"向下滚动到此浏览器的设置",step3Text:"打开麦克风(摄像头可选)",step4Text:"再次尝试加入通话",step1DigitText:"1",step2DigitText:"2",step3DigitText:"3",step4DigitText:"4"},verticalGallery:{leftNavButtonAriaLabel:"上一页 {current} (共 {total} 页)",rightNavButtonAriaLabel:"下一页 {current} (共 {total} 页)"},meetingConferencePhoneInfo:{meetingConferencePhoneInfoModalTitle:"从手机加入呼叫",meetingConferencePhoneInfoModalDialIn:"拨号号码",meetingConferencePhoneInfoModalMeetingId:"输入会议 ID",meetingConferencePhoneInfoModalWait:"等待组织者接受",meetingConferencePhoneInfoModalNoPhoneAvailable:"没有可用的电话",meetingConferencePhoneInfoModalTollGeoData:"{country}，{city}",meetingConferencePhoneInfoModalTollFree:"(免费电话)",meetingConferencePhoneInfoModalToll:"(收费电话)"},IncomingCallNotification:{incomingCallNotificationPlaceholderId:"未知用户",incomingCallNotificationPlaceholderAlert:"{callerName} 正在通话",incomingCallNoticicationAcceptWithAudioAriaLabel:"语音接听",incomingCallNoticicationAcceptWithVideoAriaLabel:"视频接听",incomingCallNoticicationRejectAriaLabel:"拒绝",incomingCallNotificationAcceptButtonLabel:"接受",incomingCallNotificationRejectButtonLabel:"拒绝",incomingCallNotificationAccceptWithVideoButtonLabel:"使用视频接受",incomingCallNotificationDismissButtonAriaLabel:"关闭"}})},IQt={strings:Jh({participantItem:{isMeText:"(您)",menuTitle:"更多選項",removeButtonLabel:"移除",sharingIconLabel:"分享",mutedIconLabel:"已靜音",handRaisedIconLabel:"舉手- 位置 {position}",displayNamePlaceholder:"未命名的參與者",participantStateRinging:"撥號中...",participantStateHold:"電話保留",participantItemAriaLabel:"{displayName}, {handRaisedState}, {mutedState}, {micDisabledState}, {cameraDisabledState}, {sharingState}, {connectionState}",participantItemWithMoreOptionsAriaLabel:"{displayName}、{handRaisedState}、{mutedState}、{micDisabledState}、{cameraDisabledState}、{sharingState}、{connectionState}、其他選項",attendeeRole:"出席者",micDisabledIconLabel:"已停用麥克風",cameraDisabledIconLabel:"已停用相機"},ParticipantList:{overflowParticipantCount:"多出 {overflowCount} 個"},typingIndicator:{singleUser:"{user} 正在輸入...",multipleUsers:"{users} 正在輸入...",multipleUsersAbbreviateOne:"{users} 和其他 1 人正在輸入...",multipleUsersAbbreviateMany:"{users} 和其他 {numOthers} 人正在輸入...",delimiter:"， "},sendBox:{placeholderText:"輸入訊息",textTooLong:"您的訊息長度超過上限。",sendButtonAriaLabel:"傳送訊息",attachmentUploadsPendingError:"正在上傳檔案，請稍候。",removeAttachment:"移除檔案",uploading:"正在上傳",uploadCompleted:"上傳完成",attachmentMoreMenu:"其他選項"},richTextSendBox:{placeholderText:"輸入訊息",textTooLong:"您的訊息長度超過上限。",sendButtonAriaLabel:"傳送訊息",attachmentUploadsPendingError:"正在上傳檔案，請稍候。",imageUploadsPendingError:"正在上傳影像，請稍候。",removeAttachment:"移除檔案",uploading:"正在上傳",uploadCompleted:"上傳完成",richTextBoldTooltip:"粗體",richTextItalicTooltip:"斜體",richTextUnderlineTooltip:"底線",richTextBulletListTooltip:"項目符號清單",richTextNumberListTooltip:"編號清單",richTextIncreaseIndentTooltip:"增加縮排",richTextDecreaseIndentTooltip:"減少縮排",richTextInsertTableTooltip:"插入表格",richTextFormatButtonTooltip:"格式",richTextInsertRowOrColumnMenu:"插入",richTextInsertTableMenuTitle:"插入 {column} x {row} 表格",richTextInsertRowAboveMenu:"在上方插入",richTextInsertRowBelowMenu:"在下方插入",richTextInsertColumnLeftMenu:"於左方插入",richTextInsertColumnRightMenu:"於右方插入",richTextDeleteRowOrColumnMenu:"刪除",richTextDeleteColumnMenu:"刪除欄",richTextDeleteRowMenu:"刪除列",richTextDeleteTableMenu:"刪除表格",richTextToolbarAriaLabel:"訊息格式設定工具列",richTextToolbarMoreButtonAriaLabel:"其他選項",attachmentMoreMenu:"其他選項",richTextNewBulletedListItemAnnouncement:"項目符號，新行",richTextNewNumberedListItemAnnouncement:"{0}，新行",richTextBulletedListAppliedAnnouncement:"已套用項目符號清單",richTextNumberedListAppliedAnnouncement:"已套用編號清單"},realTimeTextModal:{realTimeTextModalAriaLabel:"開啟 RTT 強制回應",realTimeTextModalTitle:"開啟 RTT?",realTimeTextModalText:"將為會議中的每個人開啟即時文字 (RTT)。",realTimeTextConfirmButtonLabel:"開啟",realTimeTextCancelButtonLabel:"取消",realTimeTextCloseModalButtonAriaLabel:"關閉 RTT 強制回應"},captionsBanner:{captionsBannerSpinnerText:"正在啟動輔助字幕...",realTimeTextInputBoxDefaultText:"即時輸入訊息",realTimeTextInputErrorMessage:"訊息不得超過 2000 個字元",realTimeTextBannerTitle:"即時輸入",realTimeTextBannerContent:"已為整個會議期間的所有參與者啟用 RTT (即時文字)。",realTimeTextBannerLinkLabel:"深入了解",captionsOnlyContainerTitle:"輔助字幕",realTimeTextOnlyContainerTitle:"即時文字",captionsAndRealTimeTextContainerTitle:"輔助字幕與即時文字",expandButtonAriaLabel:"展開",minimizeButtonAriaLabel:"摺疊"},mentionPopover:{mentionPopoverHeader:"建議"},imageOverlay:{downloadButtonLabel:"下載",dismissButtonAriaLabel:"關閉",overlayVisibleMessage:"影像詳細資料覆疊"},messageStatusIndicator:{deliveredAriaLabel:"訊息已傳送",deliveredTooltipText:"已傳送",seenAriaLabel:"其他人已看到訊息",seenTooltipText:"已讀",readByTooltipText:"讀取者為 {messageThreadReadCount} / {remoteParticipantsCount}",sendingAriaLabel:"正在傳送訊息",sendingTooltipText:"正在傳送",failedToSendAriaLabel:"無法傳送訊息",failedToSendTooltipText:"無法傳送"},endCallButton:{label:"離開",tooltipContent:"離開通話",leaveOption:"離開",endCallOption:"結束所有通話"},cameraButton:{onLabel:"相機",offLabel:"相機",tooltipDisabledContent:"相機已停用",tooltipOnContent:"關閉攝影機",tooltipOffContent:"開啟相機",tooltipVideoLoadingContent:"正在載入影片",cameraMenuTitle:"相機",cameraMenuTooltip:"選擇攝影機",cameraButtonSplitRoleDescription:"[分割] 按鈕",onSplitButtonAriaLabel:"關閉攝影機",offSplitButtonAriaLabel:"開啟相機",cameraActionTurnedOnAnnouncement:"您的相機已開啟",cameraActionTurnedOffAnnouncement:"您的相機已關閉",onSplitButtonPrimaryActionCamera:"關閉攝影機",offSplitButtonPrimaryActionCamera:"開啟相機",cameraPrimaryActionSplitButtonTitle:"使用相機",videoEffectsMenuItemTitle:"效果",cameraButtonAriaDescription:"攝影機選項"},microphoneButton:{onLabel:"麥克風",offLabel:"麥克風",tooltipDisabledContent:"麥克風已停用",tooltipOnContent:"將麥克風設為靜音",tooltipOffContent:"取消麥克風靜音",microphoneMenuTitle:"麥克風",microphoneMenuTooltip:"選擇麥克風",speakerMenuTitle:"揚聲器",speakerMenuTooltip:"選擇喇叭",microphoneButtonSplitRoleDescription:"[分割] 按鈕",onSplitButtonAriaLabel:"將麥克風靜音",offSplitButtonAriaLabel:"取消麥克風靜音",microphoneActionTurnedOnAnnouncement:"您的麥克風已開啟",microphoneActionTurnedOffAnnouncement:"您的麥克風已關閉",offSplitButtonMicrophonePrimaryAction:"取消麥克風靜音",onSplitButtonMicrophonePrimaryAction:"將麥克風靜音",microphonePrimaryActionSplitButtonTitle:"使用麥克風",microphoneAriaDescription:"音訊選項",deepNoiseSuppressionTitle:"噪音抑制",deepNoiseSuppressionOnAnnouncement:"深噪音抑制已開啟",deepNoiseSuppressionOffAnnouncement:"深噪音抑制已關閉"},devicesButton:{label:"裝置",tooltipContent:"管理裝置",cameraMenuTitle:"攝影機",cameraMenuTooltip:"選擇攝影機",audioDeviceMenuTitle:"音訊裝置",audioDeviceMenuTooltip:"選擇音訊裝置",microphoneMenuTitle:"麥克風",microphoneMenuTooltip:"選擇麥克風",speakerMenuTitle:"演講者",speakerMenuTooltip:"選擇喇叭"},participantsButton:{label:"人員",ariaLabel:"人員",tooltipContent:"顯示參與者",menuHeader:"在此通話中",participantsListButtonLabel:"{numParticipants} 人員",muteAllButtonLabel:"將所有人設為靜音",copyInviteLinkButtonLabel:"複製邀請連結",copyInviteLinkActionedAriaLabel:"已複製邀請連結"},screenShareButton:{onLabel:"停止簡報",offLabel:"分享",tooltipDisabledContent:"簡報已停用",tooltipOnContent:"展示您的螢幕",tooltipOffContent:"展示您的螢幕"},raiseHandButton:{offLabel:"舉手",onLabel:"較低",tooltipDisabledContent:"舉手動作已停用",tooltipOnContent:"把手放下",tooltipOffContent:"舉手"},reactionButton:{label:"傳送表情符號",ariaLabel:"傳送表情符號",tooltipDisabledContent:"已停用表情符號動作",tooltipContent:"傳送表情符號",likeReactionTooltipContent:"按讚",heartReactionTooltipContent:"喜歡",laughReactionTooltipContent:"大笑",applauseReactionTooltipContent:"鼓掌",surprisedReactionTooltipContent:"驚訝"},realTimeText:{isTypingText:"RTT 輸入"},captionsSettingsModal:{captionsSettingsModalTitle:"字幕設定",captionsSettingsSpokenLanguageDropdownLabel:"口語語言",captionsSettingsCaptionLanguageDropdownLabel:"字幕語言",captionsSettingsSpokenLanguageDropdownInfoText:"此通話中的每個人在說的語言。",captionsSettingsCaptionLanguageDropdownInfoText:"字幕將以此語言顯示。",captionsSettingsConfirmButtonLabel:"確認",captionsSettingsCancelButtonLabel:"取消",captionsSettingsModalAriaLabel:"字幕設定模式",captionsSettingsCloseModalButtonAriaLabel:"關閉字幕設定"},spokenLanguages:{"ar-ae":"阿拉伯文 - 阿拉伯聯合大公國","ar-sa":"阿拉伯文 - 沙烏地阿拉伯","da-dk":"丹麥文","de-de":"德文 - 德國","en-au":"英文 - 澳大利亞","en-ca":"英文 - 加拿大","en-gb":"英文 - 英國","en-in":"英文 - 印度","en-nz":"英文 - 紐西蘭","en-us":"英文 - 美國","es-es":"西班牙文 - 西班牙 (現代排序)","es-mx":"西班牙文 - 墨西哥","fi-fi":"芬蘭文","fr-ca":"法文 - 加拿大","fr-fr":"法文 - 法國","hi-in":"印度文","it-it":"義大利文 - 義大利","ja-jp":"日文","ko-kr":"韓文","nb-no":"挪威文 (巴克摩)","nl-be":"荷蘭文 - 比利時","nl-nl":"荷蘭文 - 荷蘭","pl-pl":"波蘭文","pt-br":"葡萄牙文 - 巴西","ru-ru":"俄文","sv-se":"瑞典文","zh-cn":"中文 - 中華人民共和國","zh-hk":"中文 - 香港特別行政區","cs-cz":"捷克文","pt-pt":"葡萄牙文 - 葡萄牙","tr-tr":"土耳其文","vi-vn":"越南文","th-th":"泰文","he-il":"希伯來文","cy-gb":"威爾斯文","uk-ua":"烏克蘭文","el-gr":"希臘文","hu-hu":"匈牙利文","ro-ro":"羅馬尼亞文","sk-sk":"斯洛伐克文","zh-tw":"中文 - 台灣"},captionLanguages:{ar:"阿拉伯文",da:"丹麥文",de:"德文",en:"英文",es:"西班牙文",fi:"芬蘭文","fr-ca":"法文 - 加拿大",fr:"法文 - 法國",hi:"印度文",it:"義大利文",ja:"日文",ko:"韓文",nb:"挪威文 (巴克摩)",nl:"荷蘭文",pl:"波蘭文",pt:"葡萄牙文 - 巴西",ru:"俄文",sv:"瑞典文","zh-Hans":"中文 (簡體)","zh-Hant":"中文 (繁體)",cs:"捷克文","pt-pt":"葡萄牙文 - 葡萄牙",tr:"土耳其文",vi:"越南文",th:"泰文",he:"希伯來文",cy:"威爾斯文",uk:"烏克蘭文",el:"希臘文",hu:"匈牙利文",ro:"羅馬尼亞文",sk:"斯洛伐克文"},startCaptionsButton:{onLabel:"開啟字幕",offLabel:"關閉字幕",tooltipOnContent:"關閉字幕",tooltipOffContent:"開啟字幕"},startRealTimeTextButton:{label:"開啟此通話的即時輸入",tooltipOffContent:"開啟此通話的即時輸入"},messageThread:{yesterday:"昨天",sunday:"星期日",monday:"星期一",tuesday:"星期二",wednesday:"星期三",thursday:"星期四",friday:"星期五",saturday:"星期六",participantJoined:"已加入聊天。",participantLeft:"已離開聊天。",editMessage:"編輯",removeMessage:"刪除",resendMessage:"請嘗試再次傳送",failToSendTag:"無法傳送",editedTag:"已編輯",liveAuthorIntro:"來自 {author} 的訊息",editedMessageLiveAuthorIntro:"已編輯來自 {author} 的訊息",editedMessageLocalUserLiveAuthorIntro:"已編輯訊息",messageContentAriaText:"{status} {author} 說 {message}",messageContentMineAriaText:"{status} 您說 {message}",editBoxTextLimit:"您的訊息超過 {limitNumber} 個字元的限制",editBoxPlaceholderText:"編輯您的訊息",newMessagesIndicator:"新訊息",noDisplayNameSub:"沒有名稱",editBoxCancelButton:"取消",editBoxSubmitButton:"完成",messageReadCount:"讀取者為 {messageReadByCount} / {remoteParticipantsCount}",actionMenuMoreOptions:"更多選項",downloadAttachment:"下載檔案",openAttachment:"開啟檔案",blockedWarningText:"由於組織原則，已刪除此訊息。",blockedWarningLinkText:"詳細資料",attachmentCardGroupMessage:"這則訊息有 {attachmentCount} 個附件",messageDeletedAnnouncementAriaLabel:"訊息已刪除",richTextBoldTooltip:"粗體",richTextItalicTooltip:"斜體",richTextUnderlineTooltip:"底線",richTextBulletListTooltip:"項目符號清單",richTextNumberListTooltip:"編號清單",richTextIncreaseIndentTooltip:"增加縮排",richTextDecreaseIndentTooltip:"減少縮排",richTextInsertTableTooltip:"插入表格",richTextFormatButtonTooltip:"格式",richTextInsertRowOrColumnMenu:"插入",richTextInsertTableMenuTitle:"插入 {column} x {row} 表格",richTextInsertRowAboveMenu:"在上方插入",richTextInsertRowBelowMenu:"在下方插入",richTextInsertColumnLeftMenu:"於左方插入",richTextInsertColumnRightMenu:"於右方插入",richTextDeleteRowOrColumnMenu:"刪除",richTextDeleteColumnMenu:"刪除欄",richTextDeleteRowMenu:"刪除列",richTextDeleteTableMenu:"刪除表格",richTextToolbarMoreButtonAriaLabel:"其他選項",attachmentUploadsPendingError:"正在上傳檔案，請稍候。",imageUploadsPendingError:"正在上傳影像，請稍候。",richTextNewBulletedListItemAnnouncement:"項目符號，新行",richTextNewNumberedListItemAnnouncement:"{0}，新行",richTextBulletedListAppliedAnnouncement:"已套用項目符號清單",richTextNumberedListAppliedAnnouncement:"已套用編號清單"},errorBar:{unableToReachChatService:"您處於離線狀態",accessDenied:"無法存取聊天服務 - 請檢查提供的使用者認證",userNotInChatThread:"您已不在此聊天對話中",sendMessageNotInChatThread:"無法傳送訊息，因為您已不在此聊天對話中",sendMessageGeneric:"無法傳送訊息",callingNetworkFailure:"連線通話發生錯誤 - 您似乎已離線",startVideoGeneric:"無法啟動影片",stopVideoGeneric:"無法停止影片",muteGeneric:"無法將麥克風設為靜音",unmuteGeneric:"無法將麥克風取消靜音",speakingWhileMuted:"您的麥克風已設為靜音",startScreenShareGeneric:"啟動畫面分享時發生問題。",stopScreenShareGeneric:"無法停止螢幕畫面分享",callNetworkQualityLow:"您的網路品質不佳。",teamsMeetingCallNetworkQualityLow:"網路品質不佳。",callNoSpeakerFound:"找不到喇叭或耳機。請連接音訊裝置以聆聽通話。",callNoMicrophoneFound:"找不到麥克風。請連接音訊輸入裝置。",callMicrophoneAccessDenied:"無法存取麥克風。按一下網址列中的鎖定以授與此網頁的許可權。",callMicrophoneAccessDeniedSafari:"無法存取麥克風。重新整理頁面以允許許可權，或檢查此瀏覽器的設定，並確認已啟用此網站的許可權。",callMicrophoneMutedBySystem:"系統已將您設為靜音。",callMicrophoneUnmutedBySystem:"您的麥克風已復原，系統已取消您的靜音。",callMacOsMicrophoneAccessDenied:"無法存取麥克風。請在您的 MacOS 隱私權設定中授與麥克風權限。",callLocalVideoFreeze:"網路頻寬不佳。通話中的其他人可能會暫停您的視訊。",callCameraAccessDenied:"無法存取相機。按一下網址列中的鎖定以授與此網頁的許可權。",callCameraAccessDeniedSafari:"無法存取相機。重新整理頁面以允許許可權，或檢查此瀏覽器的設定，並確認已啟用此網站的許可權。",callCameraAlreadyInUse:"無法存取相機。其他應用程式可能已在使用它。",callVideoStoppedBySystem:"您的影片已遭系統停止。",callVideoRecoveredBySystem:"您的影片已繼續。",callMacOsCameraAccessDenied:"MacOS 已封鎖您的相機存取權限。請更新您的隱私權設定，允許此瀏覽器存取您的相機。",callMacOsScreenShareAccessDenied:"MacOS 正在封鎖螢幕畫面分享。更新您的隱私權設定，以允許此瀏覽器錄製您的螢幕。",dismissButtonAriaLabel:"關閉",failedToJoinCallGeneric:"無法加入通話。",failedToJoinCallInvalidMeetingLink:"無法加入會議。連結無效。",cameraFrozenForRemoteParticipants:"通話中的使用者在觀看您的視訊時發生問題。請檢查您的裝置和網路。",unableToStartVideoEffect:"無法套用視訊效果。",startSpotlightWhileMaxParticipantsAreSpotlighted:"無法啟動參與者的焦點，因為參與者人數已達焦點上限。",mutedByRemoteParticipant:"另一位參與者已將您設為靜音。"},notificationStack:{callingNetworkFailure:{title:"接通電話時發生問題",message:"您似乎已離線。請檢查您的網路連線，然後再試一次。",dismissButtonAriaLabel:"關閉"},startVideoGeneric:{title:"無法啟動影片。",dismissButtonAriaLabel:"關閉"},stopVideoGeneric:{title:"無法停止影片。",dismissButtonAriaLabel:"關閉"},muteGeneric:{title:"無法將麥克風設為靜音。",dismissButtonAriaLabel:"關閉"},unmuteGeneric:{title:"無法將麥克風取消靜音。",dismissButtonAriaLabel:"關閉"},speakingWhileMuted:{title:"已將您設為靜音。",dismissButtonAriaLabel:"關閉"},startScreenShareGeneric:{title:"啟動畫面分享時發生問題。",dismissButtonAriaLabel:"關閉"},stopScreenShareGeneric:{title:"無法停止螢幕畫面分享。",dismissButtonAriaLabel:"關閉"},callNetworkQualityLow:{title:"網路品質不佳。",dismissButtonAriaLabel:"關閉"},teamsMeetingCallNetworkQualityLow:{title:"網路品質不佳。",dismissButtonAriaLabel:"關閉",message:"從您的手機加入此通話以獲得更佳的音效。您可以繼續在此裝置上檢視會議。",primaryButtonLabel:"使用電話加入"},callNoSpeakerFound:{title:"找不到喇叭或耳機",message:"連接音訊裝置以聆聽通話。",dismissButtonAriaLabel:"關閉"},callNoMicrophoneFound:{title:"找不到麥克風",message:"請連結音訊輸入裝置。",dismissButtonAriaLabel:"關閉"},callMicrophoneAccessDenied:{title:"無法存取麥克風",message:"按兩下網址列中的鎖定以授與此網頁的許可權。",dismissButtonAriaLabel:"關閉"},callMicrophoneAccessDeniedSafari:{title:"無法存取麥克風",message:"重新整理頁面以允許許可權，或檢查此瀏覽器的設定，並確認已啟用此網站的權限。",dismissButtonAriaLabel:"關閉"},callMicrophoneMutedBySystem:{title:"系統已將您設為靜音。",dismissButtonAriaLabel:"關閉"},callMicrophoneUnmutedBySystem:{title:"您的麥克風已復原，系統已取消您的靜音。",dismissButtonAriaLabel:"關閉"},callMacOsMicrophoneAccessDenied:{title:"無法存取麥克風",message:"在您的macOS隱私權設定中授與麥克風許可權。",dismissButtonAriaLabel:"關閉"},callLocalVideoFreeze:{title:"網路頻寬不佳",message:"通話中的其他人可能會暫停您的視訊。",dismissButtonAriaLabel:"關閉"},callCameraAccessDenied:{title:"無法存取相機",message:"按兩下網址列中的鎖定以授與此網頁的許可權。",dismissButtonAriaLabel:"關閉"},callCameraAccessDeniedSafari:{title:"無法存取相機",message:"重新整理頁面以允許許可權，或檢查此瀏覽器的設定，並確認已啟用此網站的權限。",dismissButtonAriaLabel:"關閉"},callCameraAlreadyInUse:{title:"無法存取相機",message:"其他應用程式可能已在使用它。",dismissButtonAriaLabel:"關閉"},callVideoStoppedBySystem:{title:"您的影片已遭系統停止。",dismissButtonAriaLabel:"關閉"},callVideoRecoveredBySystem:{title:"您的影片已恢復播放。",dismissButtonAriaLabel:"關閉"},callMacOsCameraAccessDenied:{title:"MacOS 禁止存取您的相機",message:"更新您的隱私權設定，以允許此瀏覽器存取您的相機。",dismissButtonAriaLabel:"關閉"},callMacOsScreenShareAccessDenied:{title:"MacOS 正在封鎖螢幕畫面分享",message:"更新您的隱私權設定，以允許此瀏覽器錄製您的螢幕。",dismissButtonAriaLabel:"關閉"},failedToJoinCallGeneric:{title:"無法加入通話。",dismissButtonAriaLabel:"關閉"},failedToJoinCallInvalidMeetingLink:{title:"無法加入會議。連結無效。",dismissButtonAriaLabel:"關閉"},cameraFrozenForRemoteParticipants:{title:"通話中的用戶在觀看您的視訊時發生問題",message:"請檢查您的裝置和網路。",dismissButtonAriaLabel:"關閉"},unableToStartVideoEffect:{title:"無法套用視訊效果。",dismissButtonAriaLabel:"關閉"},startSpotlightWhileMaxParticipantsAreSpotlighted:{title:"無法在參與者上啟動焦點",message:"參與者人數上限已成為焦點。",dismissButtonAriaLabel:"關閉"},mutedByRemoteParticipant:{title:"另一位參與者已將您設為靜音。",dismissButtonAriaLabel:"關閉"},recordingStarted:{title:"錄製已啟動。",message:"一旦加入，即表示您同意轉譯此會議。",dismissButtonAriaLabel:"關閉"},transcriptionStarted:{title:"已開始轉錄。",message:"一旦加入，即表示您同意轉譯此會議。",dismissButtonAriaLabel:"關閉"},recordingStopped:{title:"正在儲存錄製內容。",message:"已停止錄製。",dismissButtonAriaLabel:"關閉"},transcriptionStopped:{title:"正在儲存轉錄。",message:"已停止轉錄。",dismissButtonAriaLabel:"關閉"},recordingAndTranscriptionStarted:{title:"已開始錄製並進行轉錄。",message:"一旦加入，即表示您同意轉譯此會議。",dismissButtonAriaLabel:"關閉"},recordingAndTranscriptionStopped:{title:"正在儲存錄製和轉錄。",message:"已停止錄製與轉錄。",dismissButtonAriaLabel:"關閉"},recordingStoppedStillTranscribing:{title:"已停止錄製。",message:"您現在只會轉錄此會議。",dismissButtonAriaLabel:"關閉"},transcriptionStoppedStillRecording:{title:"已停止轉錄。",message:"您現在只會錄製此會議。",dismissButtonAriaLabel:"關閉"},assignedBreakoutRoomOpened:{title:"我們將在 5 秒內將您移至指派的會議室。",dismissButtonAriaLabel:"關閉"},assignedBreakoutRoomChanged:{title:"您的分組討論區已變更",message:"我們將在 5 秒內將您移至指派的會議室。",dismissButtonAriaLabel:"關閉"},assignedBreakoutRoomClosed:{title:"您的分組討論區已關閉",message:"我們會在 5 秒後將您移回會議。",dismissButtonAriaLabel:"關閉"},assignedBreakoutRoomOpenedPromptJoin:{title:"加入分組討論區?",message:"系統已指派分組討論區給您。",dismissButtonAriaLabel:"關閉",primaryButtonLabel:"加入會議室",secondaryButtonLabel:"稍後"},breakoutRoomJoined:{title:"您已加入分組討論區。",dismissButtonAriaLabel:"關閉"},breakoutRoomClosingSoon:{title:"會議室時間限制即將到期。",message:"此會議室將在 30 秒鐘內關閉。",dismissButtonAriaLabel:"關閉"},capabilityTurnVideoOnPresent:{title:"已啟用您的鏡頭",message:"如果您想要分享視訊，請將它開啟。",dismissButtonAriaLabel:"關閉"},capabilityTurnVideoOnAbsent:{title:"已停用您的相機",message:"您無法再分享視訊。",dismissButtonAriaLabel:"關閉"},capabilityUnmuteMicPresent:{title:"已啟用您的麥克風",message:"如果您想要說話請取消靜音。",dismissButtonAriaLabel:"關閉"},capabilityUnmuteMicAbsent:{title:"您的麥克風已停用",message:"您無法再取消靜音。",dismissButtonAriaLabel:"關閉"},togetherModeStarted:{title:"[在一起模式] 已啟動",dismissButtonAriaLabel:"關閉"},togetherModeEnded:{title:"[在一起模式] 已結束",dismissButtonAriaLabel:"關閉"}},videoGallery:{screenIsBeingSharedMessage:"您現在正在分享螢幕畫面。",screenShareLoadingMessage:"正在載入 {participant} 的螢幕畫面",localScreenShareLoadingMessage:"正在載入您的畫面",localVideoLabel:"您",localVideoCameraSwitcherLabel:"切換相機",localVideoMovementLabel:"可移動本機視訊磚",localVideoMovementAriaLabel:"可移動的區域影片標題",localVideoSelectedDescription:"已選取 {cameraName}",displayNamePlaceholder:"未命名的參與者",fitRemoteParticipantToFrame:"調整成畫面大小",fillRemoteParticipantFrame:"填滿畫面",pinParticipantForMe:"為我釘選",pinParticipantForMeLimitReached:"釘選 (已達到限制)",unpinParticipantForMe:"取消釘選",pinParticipantMenuItemAriaLabel:"釘選 {participantName}",unpinParticipantMenuItemAriaLabel:"取消釘選 {participantName}",pinnedParticipantAnnouncementAriaLabel:"已釘選 {participantName}",unpinnedParticipantAnnouncementAriaLabel:"已取消釘選 {participantName}",startSpotlightVideoTileMenuLabel:"設為每個人的焦點",addSpotlightVideoTileMenuLabel:"新增焦點",spotlightLimitReachedMenuTitle:"已達焦點限制",stopSpotlightVideoTileMenuLabel:"停止聚焦",stopSpotlightOnSelfVideoTileMenuLabel:"結束聚焦",attendeeRole:"出席者",muteParticipantMenuItemLabel:"靜音",waitingScreenText:"正在等待其他人加入",forbidAudio:"停用麥克風",permitAudio:"允許麥克風",forbidAudioTileMenuLabel:"停用麥克風",permitAudioTileMenuLabel:"允許麥克風",forbidVideo:"停用相機",permitVideo:"允許相機",forbidVideoTileMenuLabel:"停用相機",permitVideoTileMenuLabel:"允許相機"},dialpad:{placeholderText:"輸入電話號碼",deleteButtonAriaLabel:"刪除"},holdButton:{onLabel:"繼續",offLabel:"保留",tooltipOnContent:"繼續通話",tooltipOffContent:"保留通話"},videoTile:{participantStateRinging:"撥號中...",participantReconnecting:"正在重新連線...",participantStateHold:"電話保留",moreOptionsButtonAriaLabel:"其他選項 {displayName} {isMuted} {micDisabledState} {cameraDisabledState} {isHandRaised} {state} {isSpeaking}",moreOptionsParticipantMutedStateMutedAriaLabel:"已靜音",moreOptionsParticipantMutedStateUnmutedAriaLabel:"已取消靜音",moreOptionsParticipantHandRaisedAriaLabel:"已舉手",moreOptionsParticipantIsSpeakingAriaLabel:"說話",moreOptionsParticipantMicDisabledAriaLabel:"已停用麥克風",moreOptionsParticipantCameraDisabledAriaLabel:"已停用相機"},CameraAndMicrophoneSitePermissionsRequest:{primaryText:"允許 {appName} 使用您的相機和麥克風",secondaryText:"這樣參與者才能看到您並聽到您的聲音。",linkText:"需要協助嗎? 取得疑難排解說明",primaryButtonText:"在沒有相機和麥克風的情況下繼續",ariaLabel:"允許相機和麥克風存取"},CameraSitePermissionsRequest:{primaryText:"允許 {appName} 使用您的相機",secondaryText:"這樣參與者才能看到您。",linkText:"需要協助嗎? 取得疑難排解說明",primaryButtonText:"繼續但不使用相機",ariaLabel:"允許存取相機"},MicrophoneSitePermissionsRequest:{primaryText:"允許 {appName} 使用您的麥克風",secondaryText:"這樣參與者才能聽到您的聲音。",linkText:"需要協助嗎? 取得疑難排解說明",primaryButtonText:"在沒有麥克風的情況下繼續",ariaLabel:"允許麥克風存取"},CameraAndMicrophoneSitePermissionsCheck:{primaryText:"正在檢查相機和麥克風存取",secondaryText:"如果系統提示，則允許存取。這樣參與者才能看到您並聽到您的聲音。",linkText:"需要協助嗎? 取得疑難排解說明",primaryButtonText:"在沒有相機和麥克風的情況下繼續",ariaLabel:"正在檢查相機和麥克風存取。如果系統提示，則允許存取。"},CameraSitePermissionsCheck:{primaryText:"正在檢查相機存取",secondaryText:"如果系統提示，則允許存取。這樣參與者才能看到您。",linkText:"需要協助嗎? 取得疑難排解說明",primaryButtonText:"在沒有相機的情況下繼續",ariaLabel:"正在檢查相機存取。如果系統提示，則允許存取。"},MicrophoneSitePermissionsCheck:{primaryText:"正在檢查麥克風存取",secondaryText:"如果系統提示，則允許存取。這樣參與者才能聽到您的聲音。",linkText:"需要協助嗎? 取得疑難排解說明",primaryButtonText:"在沒有麥克風的情況下繼續",ariaLabel:"正在檢查麥克風存取。如果系統提示，則允許存取。"},CameraAndMicrophoneSitePermissionsDenied:{primaryText:"無法存取攝影機和麥克風",secondaryText:"按一下網址列中的鎖定圖示，以授與此網頁的麥克風許可權。可能需要重新整理頁面。",primaryButtonText:"在沒有相機和麥克風的情況下繼續",linkText:"需要協助嗎? 取得疑難排解說明"},CameraAndMicrophoneSitePermissionsDeniedSafari:{primaryText:"無法存取攝影機和麥克風",secondaryText:"重新整理頁面以允許許可權，或檢查此瀏覽器的設定，並確認已啟用此網站的權限。",primaryButtonText:"在沒有相機和麥克風的情況下繼續",linkText:"需要協助嗎? 取得疑難排解說明"},CameraSitePermissionsDenied:{primaryText:"無法存取相機",secondaryText:"按一下網址列中的鎖定圖示，以授與此網頁的相機許可權。可能需要重新整理頁面。",primaryButtonText:"在沒有相機的情況下繼續",linkText:"需要協助嗎? 取得疑難排解說明"},MicrophoneSitePermissionsDenied:{primaryText:"無法存取麥克風",secondaryText:"按一下網址列中的鎖定圖示，以授與此網頁的麥克風許可權。可能需要重新整理頁面。",primaryButtonText:"在沒有麥克風的情況下繼續",linkText:"需要協助嗎? 取得疑難排解說明"},CameraSitePermissionsDeniedSafari:{primaryText:"無法存取攝影機",secondaryText:"重新整理頁面以允許許可權，或檢查此瀏覽器的設定，並確認已啟用此網站的權限。",primaryButtonText:"在沒有相機的情況下繼續",linkText:"需要協助嗎? 取得疑難排解說明"},MicrophoneSitePermissionsDeniedSafari:{primaryText:"無法存取麥克風",secondaryText:"重新整理頁面以允許許可權，或檢查此瀏覽器的設定，並確認已啟用此網站的權限。",primaryButtonText:"繼續但不使用麥克風",linkText:"需要協助嗎? 取得疑難排解說明"},UnsupportedBrowser:{primaryText:"不支援瀏覽器",secondaryText:"請使用相容的瀏覽器加入此通話。",moreHelpLinkText:"查看相容性需求"},UnsupportedBrowserVersion:{primaryText:"需要更新瀏覽器",secondaryText:"為確保通話品質最佳，請更新瀏覽器，然後再次嘗試加入通話。",moreHelpLinkText:"查看相容性需求",continueAnywayButtonText:"不更新即開始通話"},UnsupportedOperatingSystem:{primaryText:"不支援作業系統",secondaryText:"請使用具有相容作業系統的裝置加入此通話。",moreHelpLinkText:"查看相容性需求"},BrowserPermissionDenied:{primaryText:"無法使用您的相機或麥克風",secondaryText:"您的瀏覽器可能無法存取您的相機或麥克風。若要修正此問題，請開啟 [系統喜好設定]。",primaryButtonText:"重試",linkText:"需要協助嗎? 取得疑難排解說明"},BrowserPermissionDeniedIOS:{primaryText:"允許存取麥克風以繼續",secondaryText:"讓其他參與者可聽到您的聲音。",primaryButtonText:"重試",imageAltText:"iOS 的麥克風和相機裝置權限位置",linkText:"需要協助嗎? 取得疑難排解說明",step1Text:"移至 [設定] 應用程式",step2Text:"向下捲動到此瀏覽器的設定",step3Text:"開啟麥克風 (相機選用)",step4Text:"再次嘗試加入通話",step1DigitText:"1",step2DigitText:"2",step3DigitText:"3",step4DigitText:"4"},verticalGallery:{leftNavButtonAriaLabel:"上一頁 (第 {current} 頁，共 {total} 頁)",rightNavButtonAriaLabel:"下一頁 (第 {current} 頁，共 {total} 頁)"},meetingConferencePhoneInfo:{meetingConferencePhoneInfoModalTitle:"從您的電話加入通話",meetingConferencePhoneInfoModalDialIn:"撥號號碼",meetingConferencePhoneInfoModalMeetingId:"輸入會議識別碼",meetingConferencePhoneInfoModalWait:"等候召集人獲准進入",meetingConferencePhoneInfoModalNoPhoneAvailable:"沒有可用的電話",meetingConferencePhoneInfoModalTollGeoData:"{country}, {city}",meetingConferencePhoneInfoModalTollFree:"(免付費電話)",meetingConferencePhoneInfoModalToll:"(付費)"},IncomingCallNotification:{incomingCallNotificationPlaceholderId:"未知的使用者",incomingCallNotificationPlaceholderAlert:"{callerName} 正在通話",incomingCallNoticicationAcceptWithAudioAriaLabel:"接受音訊",incomingCallNoticicationAcceptWithVideoAriaLabel:"接受視訊",incomingCallNoticicationRejectAriaLabel:"拒絕",incomingCallNotificationAcceptButtonLabel:"接受",incomingCallNotificationRejectButtonLabel:"拒絕",incomingCallNotificationAccceptWithVideoButtonLabel:"接受並開啟視訊",incomingCallNotificationDismissButtonAriaLabel:"關閉"}})},U$e=t=>t.isSpeaking&&!t.isMuted,wQt=(t,e,i,r,o,l,d,h,p,g,f)=>{const y=tj(t);return{userId:t,displayName:e,state:i,isMuted:r,isScreenSharing:o,isSpeaking:l,raisedHand:d,isRemovable:(Ap(y).kind==="communicationUser"||Ap(y).kind==="phoneNumber")&&h,reaction:p,spotlight:g,mediaAccess:f}},kQt=WH((t,e,i,r,o,l,d,h,p,g,f)=>wQt(t,e,i,r,o,l,d,h,p,g,f)),oX=ob(t=>t&&t.reactionMessage?{reactionType:t.reactionMessage.reactionType,receivedOn:t.receivedOn}:void 0),z$e=ob((t,e)=>{const i=t?.find(r=>Ga(r.identifier)===e);return i?{spotlightedOrderPosition:i.order}:void 0}),V$e=t=>{var e;return(e=t?.speakersList)===null||e===void 0?void 0:e.map(Ga)},$$e=(t,e,i)=>t?RQt(r=>Object.values(t).filter(o=>!["InLobby","Idle","Connecting","Disconnected"].includes(o.state)||Vf(o.identifier)).map(o=>{const l=$3e(o),d=H3e(o.displayName,i,o.role,e),h=oX(o.reactionState),p=o.spotlight;return r(Ga(o.identifier),o.isMuted,U$e(o),o.videoStreams,l,d,o.raisedHand,o.contentSharingStream,h,p,o.mediaAccess,o.role)})):[],RQt=WH((t,e,i,r,o,l,d,h,p,g,f,y,T)=>H$e(t,e,i,r,o,l,d,h,p,g,T,f,y)),H$e=(t,e,i,r,o,l,d,h,p,g,f,y,T)=>{const C=Object.values(r);let E,I;const w=Object.values(C).findLast(F=>F.mediaStreamType==="Video"&&F.isAvailable)||Object.values(C).findLast(F=>F.mediaStreamType==="Video"),D=Object.values(C).findLast(F=>F.mediaStreamType==="ScreenSharing"&&F.isAvailable)||Object.values(C).findLast(F=>F.mediaStreamType==="ScreenSharing");return w&&(E=j$e(w)),D&&(I=j$e(D)),h&&(I=MQt(h)),{userId:t,displayName:l,isMuted:e,isSpeaking:i,videoStream:E,screenShareStream:I,isScreenSharingOn:I!==void 0&&I.isAvailable,state:o,raisedHand:d,reaction:p,spotlight:g,mediaAccess:y,canAudioBeForbidden:T==="Attendee",canVideoBeForbidden:T==="Attendee"}},j$e=t=>{var e,i,r;return{id:t.id,isAvailable:t.isAvailable,isReceiving:t.isReceiving,isMirrored:(e=t.view)===null||e===void 0?void 0:e.isMirrored,renderElement:(i=t.view)===null||i===void 0?void 0:i.target,scalingMode:(r=t.view)===null||r===void 0?void 0:r.scalingMode,streamSize:t.streamSize}},MQt=t=>({isAvailable:!!t,isReceiving:!0,isMirrored:!1,renderElement:t}),PQt=ob((t,e,i,r,o,l,d,h,p,g,f)=>{var y,T,C;return{userId:t,displayName:e??"",isMuted:i,isScreenSharingOn:r,videoStream:{isAvailable:!!o,isMirrored:(y=o?.view)===null||y===void 0?void 0:y.isMirrored,renderElement:(T=o?.view)===null||T===void 0?void 0:T.target},screenShareStream:{isAvailable:!!l,renderElement:(C=l?.view)===null||C===void 0?void 0:C.target},role:d,raisedHand:h,reaction:p,spotlight:g,capabilities:f,mediaAccess:{isAudioPermitted:f?.unmuteMic?f.unmuteMic.isPresent:!0,isVideoPermitted:f?.turnVideoOn?f.turnVideoOn.isPresent:!0}}}),DQt=ob(t=>t?.map(e=>Ga(e.identifier)));ob(t=>{var e,i,r,o,l,d;return{mainVideoStream:{id:(e=t?.mainVideoStream)===null||e===void 0?void 0:e.id,isReceiving:(i=t?.mainVideoStream)===null||i===void 0?void 0:i.isReceiving,isAvailable:(r=t?.mainVideoStream)===null||r===void 0?void 0:r.isAvailable,renderElement:(l=(o=t?.mainVideoStream)===null||o===void 0?void 0:o.view)===null||l===void 0?void 0:l.target,streamSize:(d=t?.mainVideoStream)===null||d===void 0?void 0:d.streamSize}}});const G$e=Xs([wDe],t=>{{const e=Object.assign({},t);return Object.keys(e).forEach(i=>{var r;((r=e[i])===null||r===void 0?void 0:r.role)==="Consumer"&&delete e[i]}),e}}),LQt=Xs([hkt,G$e,RDe,rce,ace,oce,sce,dkt,ukt,ij,ice,IDe,nce,kDe,nj],(t,e,i,r,o,l,d,h,p,g,f,y,T,C,E)=>{const I=t&&e?e[t]:void 0,w=i?.find(z=>z.mediaStreamType==="Video"),D=i?.find(z=>z.mediaStreamType==="ScreenSharing"),F=V$e(h);F?.forEach((z,H)=>H);const x=[],B=oX(T),L=DQt(C?.spotlightedParticipants);return{screenShareParticipant:I?H$e(Ga(I.identifier),I.isMuted,U$e(I),I.videoStreams,I.state,I.displayName,I.raisedHand,I.contentSharingStream,void 0,I.spotlight,void 0,I.mediaAccess,g):void 0,localParticipant:PQt(d,l,r,o,w,D,g,f,B,C?.localParticipantSpotlight,E),remoteParticipants:$$e(fge(e?Object.values(e):x),y,g),dominantSpeakers:F,maxRemoteVideoStreams:p,spotlightedParticipants:L,maxParticipantsToSpotlight:C?.maxParticipantsToSpotlight}}),OQt=(t,e,i,r,o)=>kQt(d=>t.filter(h=>!xx(h.identifier)).filter(h=>!["InLobby","Idle","Connecting","Disconnected"].includes(h.state)||Vf(h.identifier)).map(h=>{const p=Object.values(h.videoStreams).some(C=>C.mediaStreamType==="ScreenSharing"&&C.isAvailable),g=$3e(h),f=H3e(h.displayName,r,h.role,i),y=oX(h.reactionState),T=z$e(o,Ga(h.identifier));return d(Ga(h.identifier),f,g,h.isMuted,p,h.isSpeaking,h.raisedHand,e,y,T,h.mediaAccess)}).sort((h,p)=>{var g,f;const y=((g=h.displayName)===null||g===void 0?void 0:g.toLowerCase())||"",T=((f=p.displayName)===null||f===void 0?void 0:f.toLowerCase())||"";return y<T?-1:y>T?1:0})),q$e=Xs([sce,oce,G$e,ace,rce,ice,ij,gkt,IDe,nce,kDe,nj],(t,e,i,r,o,l,d,h,p,g,f,y)=>{const T=NQt(d),C=i?OQt(fge(Object.values(i)),T,p,d,f?.spotlightedParticipants):[];return C.push({userId:t,displayName:e,isScreenSharing:r,isMuted:o,raisedHand:l,state:"Connected",isRemovable:!1,reaction:oX(g),spotlight:z$e(f?.spotlightedParticipants,t),mediaAccess:{isAudioPermitted:y?.unmuteMic?y.unmuteMic.isPresent:!0,isVideoPermitted:y?.turnVideoOn?y.turnVideoOn.isPresent:!0}}),{participants:C,myUserId:t}}),NQt=t=>t==="Presenter"||t==="Unknown"||t===void 0,xQt=Xs([q$e],t=>t),BQt=Xs([MDe,PDe,B5,DDe],(t,e,i,r)=>{var o,l,d,h,p,g,f,y,T,C,E,I,w,D,F,x,B,L;const z=[],H=()=>r?.environment.browser==="safari",j=()=>r?.environment.platform==="mac";(((o=e?.network.latest.networkReceiveQuality)===null||o===void 0?void 0:o.value)===ah.Bad||((l=e?.network.latest.networkReceiveQuality)===null||l===void 0?void 0:l.value)===ah.Poor)&&z.push({type:"callNetworkQualityLow"}),((d=e?.media.latest.noSpeakerDevicesEnumerated)===null||d===void 0?void 0:d.value)===!0&&z.push({type:"callNoSpeakerFound"}),((h=e?.media.latest.noMicrophoneDevicesEnumerated)===null||h===void 0?void 0:h.value)===!0&&z.push({type:"callNoMicrophoneFound"}),((p=i.deviceAccess)===null||p===void 0?void 0:p.audio)===!1&&H()&&z.push({type:"callMicrophoneAccessDeniedSafari"}),((g=e?.media.latest.microphonePermissionDenied)===null||g===void 0?void 0:g.value)===!0&&j()?z.push({type:"callMacOsMicrophoneAccessDenied"}):(((f=i.deviceAccess)===null||f===void 0?void 0:f.audio)===!1&&!H()||((y=e?.media.latest.microphonePermissionDenied)===null||y===void 0?void 0:y.value)===!0&&!j())&&z.push({type:"callMicrophoneAccessDenied"});const J=e?.media.latest.microphoneMuteUnexpectedly||e?.media.latest.microphoneNotFunctioning;J&&(J.value===ah.Bad?z.push({type:"callMicrophoneMutedBySystem"}):J.value===ah.Good&&z.push({type:"callMicrophoneUnmutedBySystem"}));const Z=e?.media.latest.cameraStoppedUnexpectedly;return Z&&(Z.value===ah.Bad?z.push({type:"callVideoStoppedBySystem"}):Z.value===ah.Good&&z.push({type:"callVideoRecoveredBySystem"})),((T=i.deviceAccess)===null||T===void 0?void 0:T.video)===!1&&H()?z.push({type:"callCameraAccessDeniedSafari"}):((C=i.deviceAccess)===null||C===void 0?void 0:C.video)===!1?z.push({type:"callCameraAccessDenied"}):((E=e?.media.latest.cameraFreeze)===null||E===void 0?void 0:E.value)===!0&&z.push({type:"cameraFrozenForRemoteParticipants"}),((I=e?.media.latest.cameraPermissionDenied)===null||I===void 0?void 0:I.value)===!0&&j()&&z.push({type:"callMacOsCameraAccessDenied"}),((w=e?.media.latest.screenshareRecordingDisabled)===null||w===void 0?void 0:w.value)===!0&&j()?z.push({type:"callMacOsScreenShareAccessDenied"}):((D=e?.media.latest.screenshareRecordingDisabled)===null||D===void 0?void 0:D.value)===!0&&z.push({type:"startScreenShareGeneric"}),JE(z,t,"Call.stopVideo","stopVideoGeneric"),JE(z,t,"Call.mute","muteGeneric"),JE(z,t,"Call.stopScreenSharing","stopScreenShareGeneric"),((F=t["Call.startVideo"])===null||F===void 0?void 0:F.message)==="Call.startVideo: Video operation failure SourceUnavailableError"?JE(z,t,"Call.startVideo","callCameraAlreadyInUse"):((x=t["Call.startVideo"])===null||x===void 0?void 0:x.message)==="Call.startVideo: Video operation failure permissionDeniedError"?JE(z,t,"Call.startVideo","callCameraAccessDenied"):JE(z,t,"Call.startVideo","startVideoGeneric"),JE(z,t,"Call.unmute","unmuteGeneric"),JE(z,t,"Call.mutedByOthers","mutedByRemoteParticipant"),JE(z,t,"VideoEffectsFeature.startEffects","unableToStartVideoEffect"),((B=t["CallAgent.join"])===null||B===void 0?void 0:B.message)==="CallAgent.join: Invalid meeting link"?JE(z,t,"CallAgent.join","failedToJoinCallInvalidMeetingLink"):JE(z,t,"CallAgent.join","failedToJoinCallGeneric"),!((L=t["Call.feature"])===null||L===void 0)&&L.message.match(/Call\.feature: startSpotlight failed\. \d+ is the max number of participants that can be Spotlighted/g)&&JE(z,t,"Call.feature","startSpotlightWhileMaxParticipantsAreSpotlighted"),z.splice(FQt),{activeErrorMessages:z}}),JE=(t,e,i,r)=>{e[i]!==void 0&&t.push({type:r,timestamp:e[i].timestamp})},FQt=3,W$e=()=>({}),K$e=t=>UQt(t),UQt=t=>{if(t===zme)return W$e;switch(t){case XZ:return LQt;case tX:return WHt;case O4:return KHt;case Fme:return QHt;case dF:return ZHt;case x8:return q$e;case Bme:return xQt;case Ome:return W$e;case jA:return BQt;case z8:return JHt;case Ume:return YHt;case H8:return rjt;case $8:return XHt;case nQt:return ojt;case Vme:return cjt;case aX:return ljt;case iX:return sjt}};var VO=function(t,e,i,r){function o(l){return l instanceof i?l:new i(function(d){d(l)})}return new(i||(i=Promise))(function(l,d){function h(f){try{g(r.next(f))}catch(y){d(y)}}function p(f){try{g(r.throw(f))}catch(y){d(y)}}function g(f){f.done?l(f.value):o(f.value).then(h,p)}g((r=r.apply(t,e||[])).next())})};const zQt=ob((t,e)=>{let i,r;return{onSendMessage:function(o,l){return VO(this,void 0,void 0,function*(){const d={content:o,senderDisplayName:t.getState().displayName};yield e.sendMessage(d,l)})},onUpdateMessage:function(o,l){return VO(this,void 0,void 0,function*(){const d={content:l};yield e.updateMessage(o,d)})},onDeleteMessage:o=>VO(void 0,void 0,void 0,function*(){yield e.deleteMessage(o)}),onMessageSeen:o=>VO(void 0,void 0,void 0,function*(){yield e.sendReadReceipt({chatMessageId:o})}),onTyping:()=>VO(void 0,void 0,void 0,function*(){yield e.sendTypingNotification()}),onRemoveParticipant:o=>VO(void 0,void 0,void 0,function*(){yield e.removeParticipant(tj(o))}),updateThreadTopicName:o=>VO(void 0,void 0,void 0,function*(){yield e.updateTopic(o)}),onLoadPreviousChatMessages:o=>VO(void 0,void 0,void 0,function*(){var l,d,h;i===void 0&&(i=e.listMessages({maxPageSize:50})),r===void 0&&(r=e.listReadReceipts());let p=o,g=!1,f=Number.MAX_SAFE_INTEGER;for(;p>=1;){const T=yield i.next();if(!((l=T?.value)===null||l===void 0)&&l.id&&parseInt(T.value.id)<f&&(f=parseInt(T.value.id)),!((d=T.value)===null||d===void 0)&&d.type&&T.value.type==="text"&&p--,T.done){g=!0;break}}let y=yield r.next();for(;!y.done&&parseInt((h=y?.value)===null||h===void 0?void 0:h.chatMessageId)>=f;)y=yield r.next();return g})}}),VQt=$.createContext(void 0),sX=t=>Ga(t.userId),J$e=t=>t.displayName,$Qt=(t,e)=>{var i;return e.threadId&&((i=t.threads[e.threadId])===null||i===void 0?void 0:i.chatMessages)||{}},qme=(t,e)=>{var i;return e.threadId&&((i=t.threads[e.threadId])===null||i===void 0?void 0:i.participants)||{}},HQt=(t,e)=>{var i;return(i=t.threads[e?.threadId])===null||i===void 0?void 0:i.readReceipts},jQt=(t,e)=>{var i;const r=(i=t.threads[e.threadId])===null||i===void 0?void 0:i.participants;return!!r&&Object.values(r).length>20},GQt=(t,e)=>{var i;return e.threadId&&((i=t.threads[e.threadId])===null||i===void 0?void 0:i.latestReadTime)||new Date(0)},qQt=(t,e)=>{var i;return e.threadId&&((i=t.threads[e.threadId])===null||i===void 0?void 0:i.typingIndicators)||[]},WQt=t=>t.latestErrors,KQt=Xs([sX,J$e],(t,e)=>({displayName:e,userId:t})),JQt=8e3,YQt=20,QQt=1e3*60,$O={text:"text",html:"html",richtextHtml:"richtext/html",participantAdded:"participantAdded",participantRemoved:"participantRemoved"},ZQt=(t,e)=>{const i=new Date(t.createdOn).getTime(),r=new Date(e.createdOn).getTime(),o=t.messageId&&e.messageId?Number.parseInt(t.messageId)-Number.parseInt(e.messageId):0;return i-r===0?o:i-r},XQt=t=>{t.sort(ZQt),t.forEach((e,i,r)=>{var o,l;if(e.messageType==="chat"){let d=!1;const h=i>0?r[i-1]:void 0,p=i===r.length-1?void 0:r[i+1],g=h?.messageType==="chat"?h.senderId:void 0,f=p?.messageType==="chat"?p.senderId:void 0,y=new Date((o=e?.createdOn)!==null&&o!==void 0?o:"").getTime()-new Date((l=h?.createdOn)!==null&&l!==void 0?l:"").getTime(),T=Math.round(y/QQt);g!==e.senderId?d=e.senderId===f?"top":!1:T&&T>=5?d=!1:d=e.senderId===f?!0:"bottom",e.attached=d}})},eZt=WH((t,e,i,r,o)=>{const l=e.type.toLowerCase();return l===$O.text||l===$O.richtextHtml||l===$O.html?cZt(e,i,r,o):dZt(e)}),tZt=t=>{const e=t.fileSharingMetadata;if(!e)return[];try{return JSON.parse(e)}catch(i){return console.error(i),[]}},iZt=t=>{const e=[];return t.forEach(i=>{var r;i.attachmentType==="file"&&e.push({id:i.id,name:(r=i.name)!==null&&r!==void 0?r:"",url:nZt(i)})}),{attachments:e}},nZt=t=>t.previewUrl?t.previewUrl:t.url||"",aZt=t=>{var e,i,r,o;let l=(e=t.content)===null||e===void 0?void 0:e.message;if(!((i=t.content)===null||i===void 0)&&i.attachments&&((r=t.content)===null||r===void 0?void 0:r.attachments.length)>0&&X$e(t.type).includes("html")){const d=(o=t.content)===null||o===void 0?void 0:o.attachments;if(l){const p=new DOMParser().parseFromString(l??"","text/html");p.querySelectorAll("img").forEach(g=>{var f,y,T;const C=(f=d.find(E=>E.id===g.id))===null||f===void 0?void 0:f.previewUrl;if(C){const E=(y=t.resourceCache)===null||y===void 0?void 0:y[C],I=Y$e(E);if(I===void 0){const w=eHe(g);(T=g.parentElement)===null||T===void 0||T.replaceChild(w,g)}else g.setAttribute("src",I);sZt(g)}}),l=p.body.innerHTML}const h=d.filter(p=>{var g,f;return p.attachmentType==="image"&&p.previewUrl!==void 0&&!(!((f=(g=t.content)===null||g===void 0?void 0:g.message)===null||f===void 0)&&f.includes(p.id))}).map(p=>rZt(t,p)).join("");if(h)return(l??"")+h}return l},rZt=(t,e)=>{var i;if(e.previewUrl!==void 0){const r=oZt(e.name),o=(i=t.resourceCache)===null||i===void 0?void 0:i[e.previewUrl],l=Y$e(o);return l===void 0?`\r
<p>${eHe().outerHTML}</p>`:`\r
<p><img alt="image" src="${l}" itemscope="${r}" id="${e.id}"></p>`}return""},Y$e=t=>t?!t.error&&t.sourceUrl?t.sourceUrl:void 0:"",oZt=t=>{if(t===void 0)return"";const e=t.lastIndexOf(".");return e===void 0||e<0?"":t.substring(e+1)},sZt=t=>{if(t){const e=t.width,i=t.height;t.style.aspectRatio=`${e}/${i}`}},lZt=t=>{var e,i;let r=[];if(t.metadata&&(r=r.concat(tZt(t.metadata))),!((e=t.content)===null||e===void 0)&&e.attachments){const o=iZt((i=t.content)===null||i===void 0?void 0:i.attachments);r=r.concat(o.attachments)}return{attachments:r.length>0?r:void 0}},cZt=(t,e,i,r)=>{const o=t.sender!==void 0?Ga(t.sender):e,{attachments:l}=lZt(t);return{messageType:"chat",createdOn:t.createdOn,content:aZt(t),contentType:X$e(t.type),status:!r&&t.status==="delivered"&&i?"seen":t.status,senderDisplayName:t.senderDisplayName,senderId:o,messageId:t.id,clientMessageId:t.clientMessageId,editedOn:t.editedOn,deletedOn:t.deletedOn,mine:o===e,metadata:t.metadata,attachments:l}},dZt=t=>{var e,i,r,o,l;const d=t.type;return d==="participantAdded"||d==="participantRemoved"?{messageType:"system",systemMessageType:d,createdOn:t.createdOn,participants:(r=(i=(e=t.content)===null||e===void 0?void 0:e.participants)===null||i===void 0?void 0:i.filter(h=>h.displayName&&h.displayName!=="").map(h=>({userId:Ga(h.id),displayName:h.displayName})))!==null&&r!==void 0?r:[],messageId:t.id,iconName:d==="participantAdded"?"PeopleAdd":"PeopleBlock"}:{messageType:"system",systemMessageType:"topicUpdated",createdOn:t.createdOn,topic:(l=(o=t.content)===null||o===void 0?void 0:o.topic)!==null&&l!==void 0?l:"",messageId:t.id,iconName:"Edit"}},Q$e=t=>{var e;return!!(!((e=t.content)===null||e===void 0)&&e.participants)&&t.content.participants.some(i=>!!i.displayName)},Z$e=()=>Xs([sX,$Qt,GQt,jQt,HQt,qme],(t,e,i,r,o=[],l)=>{const h=Object.values(l).find(f=>"microsoftTeamsUserId"in f.id)!==void 0?void 0:Object.values(l).filter(f=>f.displayName&&f.displayName!=="").length,p={};o.filter(f=>f.sender&&Ga(f.sender)!==t).forEach(f=>{var y,T;p[Ga(f.sender)]={lastReadMessage:f.chatMessageId,displayName:(T=(y=l[Ga(f.sender)])===null||y===void 0?void 0:y.displayName)!==null&&T!==void 0?T:""}});const g=eZt(f=>Object.values(e).filter(y=>y.type.toLowerCase()===$O.text||y.type.toLowerCase()===$O.richtextHtml||y.type.toLowerCase()===$O.html||y.type===$O.participantAdded&&Q$e(y)||y.type===$O.participantRemoved&&Q$e(y)||y.clientMessageId!==void 0).filter(uZt).map(y=>{var T;return f((T=y.id)!==null&&T!==void 0?T:y.clientMessageId,y,t,y.createdOn<=i,r)}));return XQt(g),{userId:t,showMessageStatus:!0,messages:g,participantCount:h,readReceiptsBySenderId:p}}),X$e=t=>{const e=t.toLowerCase();return e==="text"||e==="html"||e==="richtext/html"?e:"unknown"},eHe=t=>{var e;const i=document.createElement("div");return Array.from((e=t?.attributes)!==null&&e!==void 0?e:[]).forEach(r=>{var o;i.setAttribute(r.nodeName,(o=r.nodeValue)!==null&&o!==void 0?o:"")}),i.setAttribute("class","broken-image-wrapper"),i.setAttribute("data-ui-id","broken-image-icon"),i},uZt=t=>{var e,i,r,o;return t.deletedOn?!1:!((e=t.metadata)===null||e===void 0)&&e.fileSharingMetadata||!((r=(i=t.content)===null||i===void 0?void 0:i.attachments)===null||r===void 0)&&r.length?!0:!!(t.content&&((o=t.content)===null||o===void 0?void 0:o.message)!=="")};Z$e();const hZt=(t,e)=>{const i=[],r=new Set,o=new Date(Date.now()-JQt),l=t.toReversed();for(const d of l)Ga(d.sender)!==e&&(d.receivedOn<o||r.has(Ga(d.sender))||(r.add(Ga(d.sender)),i.push(d)));return i},pZt=(t,e)=>t.map(i=>{var r;return{userId:Ga(i.sender),displayName:(r=e[Ga(i.sender)])===null||r===void 0?void 0:r.displayName}}),gZt=Xs([qQt,qme,sX],(t,e,i)=>{if(Object.values(e).length>=YQt)return{typingUsers:[]};const r=hZt(t,i);return{typingUsers:pZt(r,e)}}),mZt=t=>t.map(e=>({userId:Ga(e.id),displayName:e.displayName,isRemovable:Ap(e.id).kind==="communicationUser"})),fZt=t=>t.find(e=>e.displayName===void 0),vZt=Xs([sX,qme,J$e],(t,e,i)=>{let r=mZt(Object.values(e));const o=fZt(r);return o?.userId===t?o.displayName=i:r=r.filter(l=>l.displayName),{myUserId:t,participants:r}}),yZt=Xs([WQt],t=>{var e;const i=[];let r=!1;{const l=TZt(t);l!==void 0&&i.push(l)}{const l=CZt(t);l!==void 0&&i.push(l)}const o=t["ChatThreadClient.sendMessage"];{const l=_Zt(t);l!==void 0&&(o!==void 0?(i.push({type:"sendMessageNotInChatThread",timestamp:o.timestamp>((e=l.timestamp)!==null&&e!==void 0?e:0)?o.timestamp:l.timestamp}),r=!0):i.push(l))}return!r&&o!==void 0&&i.push({type:"sendMessageGeneric",timestamp:o.timestamp}),i.splice(SZt),{activeErrorMessages:i}}),SZt=3,bZt=["ChatThreadClient.getProperties","ChatThreadClient.listMessages","ChatThreadClient.listParticipants","ChatThreadClient.sendMessage","ChatThreadClient.sendTypingNotification"],TZt=t=>Wme(t,"unableToReachChatService",e=>!!e&&!!e.innerError&&"code"in e.innerError&&e.innerError.code==="REQUEST_SEND_ERROR"),CZt=t=>Wme(t,"accessDenied",e=>!!e&&!!e.innerError&&"statusCode"in e.innerError&&e.innerError.statusCode===401),_Zt=t=>Wme(t,"userNotInChatThread",e=>!e||!e.innerError||AZt(e)?!1:[400,403,404].some(i=>"statusCode"in e.innerError&&e.innerError.statusCode===i)),EZt="28:",AZt=t=>"statusCode"in t.innerError&&t.innerError.statusCode===400&&t.innerError.message.includes(`Identifier format is not supported (${EZt}`),Wme=(t,e,i)=>{const r=[];for(const o of bZt){const l=t[o];i(l)&&r.push({type:e,timestamp:l.timestamp})}if(r.length!==0)return r.sort((o,l)=>{var d,h,p,g;return((h=(d=o.timestamp)===null||d===void 0?void 0:d.getTime())!==null&&h!==void 0?h:0)-((g=(p=l.timestamp)===null||p===void 0?void 0:p.getTime())!==null&&g!==void 0?g:0)}),r[r.length-1]},IZt=t=>wZt(t),tHe={},wZt=t=>{const e=()=>{var i,r;const o=(r=(i=$.useContext(VQt))===null||i===void 0?void 0:i.threadId)!==null&&r!==void 0?r:"default-id-when-not-in-provider";let l=tHe[o];return l||(l=Z$e(),tHe[o]=l),l};switch(t){case Fge:return KQt;case gme:return e();case Nge:return gZt;case x8:return vZt;case jA:return yZt}};var Kme={exports:{}},lX,kZt=new Uint8Array(16);function iHe(){if(!lX&&(lX=typeof crypto<"u"&&crypto.getRandomValues&&crypto.getRandomValues.bind(crypto)||typeof msCrypto<"u"&&typeof msCrypto.getRandomValues=="function"&&msCrypto.getRandomValues.bind(msCrypto),!lX))throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");return lX(kZt)}const RZt=/^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;function cX(t){return typeof t=="string"&&RZt.test(t)}for(var qv=[],Jme=0;Jme<256;++Jme)qv.push((Jme+256).toString(16).substr(1));function dX(t){var e=arguments.length>1&&arguments[1]!==void 0?arguments[1]:0,i=(qv[t[e+0]]+qv[t[e+1]]+qv[t[e+2]]+qv[t[e+3]]+"-"+qv[t[e+4]]+qv[t[e+5]]+"-"+qv[t[e+6]]+qv[t[e+7]]+"-"+qv[t[e+8]]+qv[t[e+9]]+"-"+qv[t[e+10]]+qv[t[e+11]]+qv[t[e+12]]+qv[t[e+13]]+qv[t[e+14]]+qv[t[e+15]]).toLowerCase();if(!cX(i))throw TypeError("Stringified UUID is invalid");return i}var nHe,Yme,Qme=0,Zme=0;function MZt(t,e,i){var r=e&&i||0,o=e||new Array(16);t=t||{};var l=t.node||nHe,d=t.clockseq!==void 0?t.clockseq:Yme;if(l==null||d==null){var h=t.random||(t.rng||iHe)();l==null&&(l=nHe=[h[0]|1,h[1],h[2],h[3],h[4],h[5]]),d==null&&(d=Yme=(h[6]<<8|h[7])&16383)}var p=t.msecs!==void 0?t.msecs:Date.now(),g=t.nsecs!==void 0?t.nsecs:Zme+1,f=p-Qme+(g-Zme)/1e4;if(f<0&&t.clockseq===void 0&&(d=d+1&16383),(f<0||p>Qme)&&t.nsecs===void 0&&(g=0),g>=1e4)throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");Qme=p,Zme=g,Yme=d,p+=122192928e5;var y=((p&268435455)*1e4+g)%4294967296;o[r++]=y>>>24&255,o[r++]=y>>>16&255,o[r++]=y>>>8&255,o[r++]=y&255;var T=p/4294967296*1e4&268435455;o[r++]=T>>>8&255,o[r++]=T&255,o[r++]=T>>>24&15|16,o[r++]=T>>>16&255,o[r++]=d>>>8|128,o[r++]=d&255;for(var C=0;C<6;++C)o[r+C]=l[C];return e||dX(o)}function aHe(t){if(!cX(t))throw TypeError("Invalid UUID");var e,i=new Uint8Array(16);return i[0]=(e=parseInt(t.slice(0,8),16))>>>24,i[1]=e>>>16&255,i[2]=e>>>8&255,i[3]=e&255,i[4]=(e=parseInt(t.slice(9,13),16))>>>8,i[5]=e&255,i[6]=(e=parseInt(t.slice(14,18),16))>>>8,i[7]=e&255,i[8]=(e=parseInt(t.slice(19,23),16))>>>8,i[9]=e&255,i[10]=(e=parseInt(t.slice(24,36),16))/1099511627776&255,i[11]=e/4294967296&255,i[12]=e>>>24&255,i[13]=e>>>16&255,i[14]=e>>>8&255,i[15]=e&255,i}function PZt(t){t=unescape(encodeURIComponent(t));for(var e=[],i=0;i<t.length;++i)e.push(t.charCodeAt(i));return e}var DZt="6ba7b810-9dad-11d1-80b4-00c04fd430c8",LZt="6ba7b811-9dad-11d1-80b4-00c04fd430c8";function rHe(t,e,i){function r(o,l,d,h){if(typeof o=="string"&&(o=PZt(o)),typeof l=="string"&&(l=aHe(l)),l.length!==16)throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");var p=new Uint8Array(16+o.length);if(p.set(l),p.set(o,l.length),p=i(p),p[6]=p[6]&15|e,p[8]=p[8]&63|128,d){h=h||0;for(var g=0;g<16;++g)d[h+g]=p[g];return d}return dX(p)}try{r.name=t}catch{}return r.DNS=DZt,r.URL=LZt,r}function OZt(t){if(typeof t=="string"){var e=unescape(encodeURIComponent(t));t=new Uint8Array(e.length);for(var i=0;i<e.length;++i)t[i]=e.charCodeAt(i)}return NZt(xZt(BZt(t),t.length*8))}function NZt(t){for(var e=[],i=t.length*32,r="0123456789abcdef",o=0;o<i;o+=8){var l=t[o>>5]>>>o%32&255,d=parseInt(r.charAt(l>>>4&15)+r.charAt(l&15),16);e.push(d)}return e}function oHe(t){return(t+64>>>9<<4)+14+1}function xZt(t,e){t[e>>5]|=128<<e%32,t[oHe(e)-1]=e;for(var i=1732584193,r=-271733879,o=-1732584194,l=271733878,d=0;d<t.length;d+=16){var h=i,p=r,g=o,f=l;i=Yy(i,r,o,l,t[d],7,-680876936),l=Yy(l,i,r,o,t[d+1],12,-389564586),o=Yy(o,l,i,r,t[d+2],17,606105819),r=Yy(r,o,l,i,t[d+3],22,-1044525330),i=Yy(i,r,o,l,t[d+4],7,-176418897),l=Yy(l,i,r,o,t[d+5],12,1200080426),o=Yy(o,l,i,r,t[d+6],17,-1473231341),r=Yy(r,o,l,i,t[d+7],22,-45705983),i=Yy(i,r,o,l,t[d+8],7,1770035416),l=Yy(l,i,r,o,t[d+9],12,-1958414417),o=Yy(o,l,i,r,t[d+10],17,-42063),r=Yy(r,o,l,i,t[d+11],22,-1990404162),i=Yy(i,r,o,l,t[d+12],7,1804603682),l=Yy(l,i,r,o,t[d+13],12,-40341101),o=Yy(o,l,i,r,t[d+14],17,-1502002290),r=Yy(r,o,l,i,t[d+15],22,1236535329),i=Qy(i,r,o,l,t[d+1],5,-165796510),l=Qy(l,i,r,o,t[d+6],9,-1069501632),o=Qy(o,l,i,r,t[d+11],14,643717713),r=Qy(r,o,l,i,t[d],20,-373897302),i=Qy(i,r,o,l,t[d+5],5,-701558691),l=Qy(l,i,r,o,t[d+10],9,38016083),o=Qy(o,l,i,r,t[d+15],14,-660478335),r=Qy(r,o,l,i,t[d+4],20,-405537848),i=Qy(i,r,o,l,t[d+9],5,568446438),l=Qy(l,i,r,o,t[d+14],9,-1019803690),o=Qy(o,l,i,r,t[d+3],14,-187363961),r=Qy(r,o,l,i,t[d+8],20,1163531501),i=Qy(i,r,o,l,t[d+13],5,-1444681467),l=Qy(l,i,r,o,t[d+2],9,-51403784),o=Qy(o,l,i,r,t[d+7],14,1735328473),r=Qy(r,o,l,i,t[d+12],20,-1926607734),i=Zy(i,r,o,l,t[d+5],4,-378558),l=Zy(l,i,r,o,t[d+8],11,-2022574463),o=Zy(o,l,i,r,t[d+11],16,1839030562),r=Zy(r,o,l,i,t[d+14],23,-35309556),i=Zy(i,r,o,l,t[d+1],4,-1530992060),l=Zy(l,i,r,o,t[d+4],11,1272893353),o=Zy(o,l,i,r,t[d+7],16,-155497632),r=Zy(r,o,l,i,t[d+10],23,-1094730640),i=Zy(i,r,o,l,t[d+13],4,681279174),l=Zy(l,i,r,o,t[d],11,-358537222),o=Zy(o,l,i,r,t[d+3],16,-722521979),r=Zy(r,o,l,i,t[d+6],23,76029189),i=Zy(i,r,o,l,t[d+9],4,-640364487),l=Zy(l,i,r,o,t[d+12],11,-421815835),o=Zy(o,l,i,r,t[d+15],16,530742520),r=Zy(r,o,l,i,t[d+2],23,-995338651),i=Xy(i,r,o,l,t[d],6,-198630844),l=Xy(l,i,r,o,t[d+7],10,1126891415),o=Xy(o,l,i,r,t[d+14],15,-1416354905),r=Xy(r,o,l,i,t[d+5],21,-57434055),i=Xy(i,r,o,l,t[d+12],6,1700485571),l=Xy(l,i,r,o,t[d+3],10,-1894986606),o=Xy(o,l,i,r,t[d+10],15,-1051523),r=Xy(r,o,l,i,t[d+1],21,-2054922799),i=Xy(i,r,o,l,t[d+8],6,1873313359),l=Xy(l,i,r,o,t[d+15],10,-30611744),o=Xy(o,l,i,r,t[d+6],15,-1560198380),r=Xy(r,o,l,i,t[d+13],21,1309151649),i=Xy(i,r,o,l,t[d+4],6,-145523070),l=Xy(l,i,r,o,t[d+11],10,-1120210379),o=Xy(o,l,i,r,t[d+2],15,718787259),r=Xy(r,o,l,i,t[d+9],21,-343485551),i=HO(i,h),r=HO(r,p),o=HO(o,g),l=HO(l,f)}return[i,r,o,l]}function BZt(t){if(t.length===0)return[];for(var e=t.length*8,i=new Uint32Array(oHe(e)),r=0;r<e;r+=8)i[r>>5]|=(t[r/8]&255)<<r%32;return i}function HO(t,e){var i=(t&65535)+(e&65535),r=(t>>16)+(e>>16)+(i>>16);return r<<16|i&65535}function FZt(t,e){return t<<e|t>>>32-e}function uX(t,e,i,r,o,l){return HO(FZt(HO(HO(e,t),HO(r,l)),o),i)}function Yy(t,e,i,r,o,l,d){return uX(e&i|~e&r,t,e,o,l,d)}function Qy(t,e,i,r,o,l,d){return uX(e&r|i&~r,t,e,o,l,d)}function Zy(t,e,i,r,o,l,d){return uX(e^i^r,t,e,o,l,d)}function Xy(t,e,i,r,o,l,d){return uX(i^(e|~r),t,e,o,l,d)}var UZt=rHe("v3",48,OZt);function sHe(t,e,i){t=t||{};var r=t.random||(t.rng||iHe)();if(r[6]=r[6]&15|64,r[8]=r[8]&63|128,e){i=i||0;for(var o=0;o<16;++o)e[i+o]=r[o];return e}return dX(r)}function zZt(t,e,i,r){switch(t){case 0:return e&i^~e&r;case 1:return e^i^r;case 2:return e&i^e&r^i&r;case 3:return e^i^r}}function Xme(t,e){return t<<e|t>>>32-e}function VZt(t){var e=[1518500249,1859775393,2400959708,3395469782],i=[1732584193,4023233417,2562383102,271733878,3285377520];if(typeof t=="string"){var r=unescape(encodeURIComponent(t));t=[];for(var o=0;o<r.length;++o)t.push(r.charCodeAt(o))}else Array.isArray(t)||(t=Array.prototype.slice.call(t));t.push(128);for(var l=t.length/4+2,d=Math.ceil(l/16),h=new Array(d),p=0;p<d;++p){for(var g=new Uint32Array(16),f=0;f<16;++f)g[f]=t[p*64+f*4]<<24|t[p*64+f*4+1]<<16|t[p*64+f*4+2]<<8|t[p*64+f*4+3];h[p]=g}h[d-1][14]=(t.length-1)*8/Math.pow(2,32),h[d-1][14]=Math.floor(h[d-1][14]),h[d-1][15]=(t.length-1)*8&4294967295;for(var y=0;y<d;++y){for(var T=new Uint32Array(80),C=0;C<16;++C)T[C]=h[y][C];for(var E=16;E<80;++E)T[E]=Xme(T[E-3]^T[E-8]^T[E-14]^T[E-16],1);for(var I=i[0],w=i[1],D=i[2],F=i[3],x=i[4],B=0;B<80;++B){var L=Math.floor(B/20),z=Xme(I,5)+zZt(L,w,D,F)+x+e[L]+T[B]>>>0;x=F,F=D,D=Xme(w,30)>>>0,w=I,I=z}i[0]=i[0]+I>>>0,i[1]=i[1]+w>>>0,i[2]=i[2]+D>>>0,i[3]=i[3]+F>>>0,i[4]=i[4]+x>>>0}return[i[0]>>24&255,i[0]>>16&255,i[0]>>8&255,i[0]&255,i[1]>>24&255,i[1]>>16&255,i[1]>>8&255,i[1]&255,i[2]>>24&255,i[2]>>16&255,i[2]>>8&255,i[2]&255,i[3]>>24&255,i[3]>>16&255,i[3]>>8&255,i[3]&255,i[4]>>24&255,i[4]>>16&255,i[4]>>8&255,i[4]&255]}var $Zt=rHe("v5",80,VZt);const HZt="00000000-0000-0000-0000-000000000000";function jZt(t){if(!cX(t))throw TypeError("Invalid UUID");return parseInt(t.substr(14,1),16)}const GZt=_q(Object.freeze(Object.defineProperty({__proto__:null,NIL:HZt,parse:aHe,stringify:dX,v1:MZt,v3:UZt,v4:sHe,v5:$Zt,validate:cX,version:jZt},Symbol.toStringTag,{value:"Module"}))),qZt=_q(bIt);function lHe(t){let e="";for(let i=0;i<t.length;i++)e+=String.fromCharCode(t[i]);return btoa(e)}function cHe(t){const e=atob(t),i=new Uint8Array(e.length);for(let r=0;r<e.length;r++)i[r]=e.charCodeAt(r);return i}function WZt(t){return atob(t)}const Qf="$",N4="_";function KZt(t,e){return e!=="Composite"&&e!=="Dictionary"&&(typeof t=="string"||typeof t=="number"||typeof t=="boolean"||e?.match(/^(Date|DateTime|DateTimeRfc1123|UnixTime|ByteArray|Base64Url)$/i)!==null||t===void 0||t===null)}const JZt=/^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;function YZt(t){return JZt.test(t)}const QZt=/^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/i;function ZZt(t){return QZt.test(t)}function XZt(t){const e=Object.assign(Object.assign({},t.headers),t.body);return t.hasNullableType&&Object.getOwnPropertyNames(e).length===0?t.shouldWrapBody?{body:null}:null:t.shouldWrapBody?Object.assign(Object.assign({},t.headers),{body:t.body}):e}function dHe(t,e){var i,r;const o=t.parsedHeaders;if(t.request.method==="HEAD")return Object.assign(Object.assign({},o),{body:t.parsedBody});const l=e&&e.bodyMapper,d=!!l?.nullable,h=l?.type.name;if(h==="Stream")return Object.assign(Object.assign({},o),{blobBody:t.blobBody,readableStreamBody:t.readableStreamBody});const p=h==="Composite"&&l.type.modelProperties||{},g=Object.keys(p).some(f=>p[f].serializedName==="");if(h==="Sequence"||g){const f=(i=t.parsedBody)!==null&&i!==void 0?i:[];for(const y of Object.keys(p))p[y].serializedName&&(f[y]=(r=t.parsedBody)===null||r===void 0?void 0:r[y]);if(o)for(const y of Object.keys(o))f[y]=o[y];return d&&!t.parsedBody&&!o&&Object.getOwnPropertyNames(p).length===0?null:f}return XZt({body:t.parsedBody,headers:o,hasNullableType:d,shouldWrapBody:KZt(t.parsedBody,h)})}class eXt{constructor(e={},i=!1){this.modelMappers=e,this.isXML=i}validateConstraints(e,i,r){const o=(l,d)=>{throw new Error(`"${r}" with value "${i}" should satisfy the constraint "${l}": ${d}.`)};if(e.constraints&&i!==void 0&&i!==null){const{ExclusiveMaximum:l,ExclusiveMinimum:d,InclusiveMaximum:h,InclusiveMinimum:p,MaxItems:g,MaxLength:f,MinItems:y,MinLength:T,MultipleOf:C,Pattern:E,UniqueItems:I}=e.constraints;if(l!==void 0&&i>=l&&o("ExclusiveMaximum",l),d!==void 0&&i<=d&&o("ExclusiveMinimum",d),h!==void 0&&i>h&&o("InclusiveMaximum",h),p!==void 0&&i<p&&o("InclusiveMinimum",p),g!==void 0&&i.length>g&&o("MaxItems",g),f!==void 0&&i.length>f&&o("MaxLength",f),y!==void 0&&i.length<y&&o("MinItems",y),T!==void 0&&i.length<T&&o("MinLength",T),C!==void 0&&i%C!==0&&o("MultipleOf",C),E){const w=typeof E=="string"?new RegExp(E):E;(typeof i!="string"||i.match(w)===null)&&o("Pattern",E)}I&&i.some((w,D,F)=>F.indexOf(w)!==D)&&o("UniqueItems",I)}}serialize(e,i,r,o={xml:{}}){var l,d,h;const p={xml:{rootName:(l=o.xml.rootName)!==null&&l!==void 0?l:"",includeRoot:(d=o.xml.includeRoot)!==null&&d!==void 0?d:!1,xmlCharKey:(h=o.xml.xmlCharKey)!==null&&h!==void 0?h:N4}};let g={};const f=e.type.name;r||(r=e.serializedName),f.match(/^Sequence$/i)!==null&&(g=[]),e.isConstant&&(i=e.defaultValue);const{required:y,nullable:T}=e;if(y&&T&&i===void 0)throw new Error(`${r} cannot be undefined.`);if(y&&!T&&i==null)throw new Error(`${r} cannot be null or undefined.`);if(!y&&T===!1&&i===null)throw new Error(`${r} cannot be null.`);return i==null||f.match(/^any$/i)!==null?g=i:f.match(/^(Number|String|Boolean|Object|Stream|Uuid)$/i)!==null?g=oXt(f,r,i):f.match(/^Enum$/i)!==null?g=sXt(r,e.type.allowedValues,i):f.match(/^(Date|DateTime|TimeSpan|DateTimeRfc1123|UnixTime)$/i)!==null?g=dXt(f,i,r):f.match(/^ByteArray$/i)!==null?g=lXt(r,i):f.match(/^Base64Url$/i)!==null?g=cXt(r,i):f.match(/^Sequence$/i)!==null?g=uXt(this,e,i,r,!!this.isXML,p):f.match(/^Dictionary$/i)!==null?g=hXt(this,e,i,r,!!this.isXML,p):f.match(/^Composite$/i)!==null&&(g=gXt(this,e,i,r,!!this.isXML,p)),g}deserialize(e,i,r,o={xml:{}}){var l,d,h,p;const g={xml:{rootName:(l=o.xml.rootName)!==null&&l!==void 0?l:"",includeRoot:(d=o.xml.includeRoot)!==null&&d!==void 0?d:!1,xmlCharKey:(h=o.xml.xmlCharKey)!==null&&h!==void 0?h:N4},ignoreUnknownProperties:(p=o.ignoreUnknownProperties)!==null&&p!==void 0?p:!1};if(i==null)return this.isXML&&e.type.name==="Sequence"&&!e.xmlIsWrapped&&(i=[]),e.defaultValue!==void 0&&(i=e.defaultValue),i;let f;const y=e.type.name;if(r||(r=e.serializedName),y.match(/^Composite$/i)!==null)f=fXt(this,e,i,r,g);else{if(this.isXML){const T=g.xml.xmlCharKey;i[Qf]!==void 0&&i[T]!==void 0&&(i=i[T])}y.match(/^Number$/i)!==null?(f=parseFloat(i),isNaN(f)&&(f=i)):y.match(/^Boolean$/i)!==null?i==="true"?f=!0:i==="false"?f=!1:f=i:y.match(/^(String|Enum|Object|Stream|Uuid|TimeSpan|any)$/i)!==null?f=i:y.match(/^(Date|DateTime|DateTimeRfc1123)$/i)!==null?f=new Date(i):y.match(/^UnixTime$/i)!==null?f=rXt(i):y.match(/^ByteArray$/i)!==null?f=cHe(i):y.match(/^Base64Url$/i)!==null?f=nXt(i):y.match(/^Sequence$/i)!==null?f=yXt(this,e,i,r,g):y.match(/^Dictionary$/i)!==null&&(f=vXt(this,e,i,r,g))}return e.isConstant&&(f=e.defaultValue),f}}function efe(t={},e=!1){return new eXt(t,e)}function tXt(t,e){let i=t.length;for(;i-1>=0&&t[i-1]===e;)--i;return t.substr(0,i)}function iXt(t){if(!t)return;if(!(t instanceof Uint8Array))throw new Error("Please provide an input of type Uint8Array for converting to Base64Url.");const e=lHe(t);return tXt(e,"=").replace(/\+/g,"-").replace(/\//g,"_")}function nXt(t){if(t){if(t&&typeof t.valueOf()!="string")throw new Error("Please provide an input of type string for converting to Uint8Array");return t=t.replace(/-/g,"+").replace(/_/g,"/"),cHe(t)}}function tfe(t){const e=[];let i="";if(t){const r=t.split(".");for(const o of r)o.charAt(o.length-1)==="\\"?i+=o.substr(0,o.length-1)+".":(i+=o,e.push(i),i="")}return e}function aXt(t){if(t)return typeof t.valueOf()=="string"&&(t=new Date(t)),Math.floor(t.getTime()/1e3)}function rXt(t){if(t)return new Date(t*1e3)}function oXt(t,e,i){if(i!=null){if(t.match(/^Number$/i)!==null){if(typeof i!="number")throw new Error(`${e} with value ${i} must be of type number.`)}else if(t.match(/^String$/i)!==null){if(typeof i.valueOf()!="string")throw new Error(`${e} with value "${i}" must be of type string.`)}else if(t.match(/^Uuid$/i)!==null){if(!(typeof i.valueOf()=="string"&&ZZt(i)))throw new Error(`${e} with value "${i}" must be of type string and a valid uuid.`)}else if(t.match(/^Boolean$/i)!==null){if(typeof i!="boolean")throw new Error(`${e} with value ${i} must be of type boolean.`)}else if(t.match(/^Stream$/i)!==null){const r=typeof i;if(r!=="string"&&typeof i.pipe!="function"&&typeof i.tee!="function"&&!(i instanceof ArrayBuffer)&&!ArrayBuffer.isView(i)&&!((typeof Blob=="function"||typeof Blob=="object")&&i instanceof Blob)&&r!=="function")throw new Error(`${e} must be a string, Blob, ArrayBuffer, ArrayBufferView, ReadableStream, or () => ReadableStream.`)}}return i}function sXt(t,e,i){if(!e)throw new Error(`Please provide a set of allowedValues to validate ${t} as an Enum Type.`);if(!e.some(o=>typeof o.valueOf()=="string"?o.toLowerCase()===i.toLowerCase():o===i))throw new Error(`${i} is not a valid value for ${t}. The valid values are: ${JSON.stringify(e)}.`);return i}function lXt(t,e){if(e!=null){if(!(e instanceof Uint8Array))throw new Error(`${t} must be of type Uint8Array.`);e=lHe(e)}return e}function cXt(t,e){if(e!=null){if(!(e instanceof Uint8Array))throw new Error(`${t} must be of type Uint8Array.`);e=iXt(e)}return e}function dXt(t,e,i){if(e!=null){if(t.match(/^Date$/i)!==null){if(!(e instanceof Date||typeof e.valueOf()=="string"&&!isNaN(Date.parse(e))))throw new Error(`${i} must be an instanceof Date or a string in ISO8601 format.`);e=e instanceof Date?e.toISOString().substring(0,10):new Date(e).toISOString().substring(0,10)}else if(t.match(/^DateTime$/i)!==null){if(!(e instanceof Date||typeof e.valueOf()=="string"&&!isNaN(Date.parse(e))))throw new Error(`${i} must be an instanceof Date or a string in ISO8601 format.`);e=e instanceof Date?e.toISOString():new Date(e).toISOString()}else if(t.match(/^DateTimeRfc1123$/i)!==null){if(!(e instanceof Date||typeof e.valueOf()=="string"&&!isNaN(Date.parse(e))))throw new Error(`${i} must be an instanceof Date or a string in RFC-1123 format.`);e=e instanceof Date?e.toUTCString():new Date(e).toUTCString()}else if(t.match(/^UnixTime$/i)!==null){if(!(e instanceof Date||typeof e.valueOf()=="string"&&!isNaN(Date.parse(e))))throw new Error(`${i} must be an instanceof Date or a string in RFC-1123/ISO8601 format for it to be serialized in UnixTime/Epoch format.`);e=aXt(e)}else if(t.match(/^TimeSpan$/i)!==null&&!YZt(e))throw new Error(`${i} must be a string in ISO 8601 format. Instead was "${e}".`)}return e}function uXt(t,e,i,r,o,l){var d;if(!Array.isArray(i))throw new Error(`${r} must be of type Array.`);let h=e.type.element;if(!h||typeof h!="object")throw new Error(`element" metadata for an Array must be defined in the mapper and it must of type "object" in ${r}.`);h.type.name==="Composite"&&h.type.className&&(h=(d=t.modelMappers[h.type.className])!==null&&d!==void 0?d:h);const p=[];for(let g=0;g<i.length;g++){const f=t.serialize(h,i[g],r,l);if(o&&h.xmlNamespace){const y=h.xmlNamespacePrefix?`xmlns:${h.xmlNamespacePrefix}`:"xmlns";h.type.name==="Composite"?(p[g]=Object.assign({},f),p[g][Qf]={[y]:h.xmlNamespace}):(p[g]={},p[g][l.xml.xmlCharKey]=f,p[g][Qf]={[y]:h.xmlNamespace})}else p[g]=f}return p}function hXt(t,e,i,r,o,l){if(typeof i!="object")throw new Error(`${r} must be of type object.`);const d=e.type.value;if(!d||typeof d!="object")throw new Error(`"value" metadata for a Dictionary must be defined in the mapper and it must of type "object" in ${r}.`);const h={};for(const p of Object.keys(i)){const g=t.serialize(d,i[p],r,l);h[p]=pHe(d,g,o,l)}if(o&&e.xmlNamespace){const p=e.xmlNamespacePrefix?`xmlns:${e.xmlNamespacePrefix}`:"xmlns",g=h;return g[Qf]={[p]:e.xmlNamespace},g}return h}function pXt(t,e,i){const r=e.type.additionalProperties;if(!r&&e.type.className){const o=uHe(t,e,i);return o?.type.additionalProperties}return r}function uHe(t,e,i){const r=e.type.className;if(!r)throw new Error(`Class name for model "${i}" is not provided in the mapper "${JSON.stringify(e,void 0,2)}".`);return t.modelMappers[r]}function hHe(t,e,i){let r=e.type.modelProperties;if(!r){const o=uHe(t,e,i);if(!o)throw new Error(`mapper() cannot be null or undefined for model "${e.type.className}".`);if(r=o?.type.modelProperties,!r)throw new Error(`modelProperties cannot be null or undefined in the mapper "${JSON.stringify(o)}" of type "${e.type.className}" for object "${i}".`)}return r}function gXt(t,e,i,r,o,l){if(hX(t,e)&&(e=gHe(t,e,i,"clientName")),i!=null){const d={},h=hHe(t,e,r);for(const g of Object.keys(h)){const f=h[g];if(f.readOnly)continue;let y,T=d;if(t.isXML)f.xmlIsWrapped?y=f.xmlName:y=f.xmlElementName||f.xmlName;else{const C=tfe(f.serializedName);y=C.pop();for(const E of C){const I=T[E];I==null&&(i[g]!==void 0&&i[g]!==null||f.defaultValue!==void 0)&&(T[E]={}),T=T[E]}}if(T!=null){if(o&&e.xmlNamespace){const D=e.xmlNamespacePrefix?`xmlns:${e.xmlNamespacePrefix}`:"xmlns";T[Qf]=Object.assign(Object.assign({},T[Qf]),{[D]:e.xmlNamespace})}const C=f.serializedName!==""?r+"."+f.serializedName:r;let E=i[g];const I=hX(t,e);I&&I.clientName===g&&E==null&&(E=e.serializedName);const w=t.serialize(f,E,C,l);if(w!==void 0&&y!==void 0&&y!==null){const D=pHe(f,w,o,l);o&&f.xmlIsAttribute?(T[Qf]=T[Qf]||{},T[Qf][y]=w):o&&f.xmlIsWrapped?T[y]={[f.xmlElementName]:D}:T[y]=D}}}const p=pXt(t,e,r);if(p){const g=Object.keys(h);for(const f in i)g.every(T=>T!==f)&&(d[f]=t.serialize(p,i[f],r+'["'+f+'"]',l))}return d}return i}function pHe(t,e,i,r){if(!i||!t.xmlNamespace)return e;const l={[t.xmlNamespacePrefix?`xmlns:${t.xmlNamespacePrefix}`:"xmlns"]:t.xmlNamespace};if(["Composite"].includes(t.type.name)){if(e[Qf])return e;{const h=Object.assign({},e);return h[Qf]=l,h}}const d={};return d[r.xml.xmlCharKey]=e,d[Qf]=l,d}function mXt(t,e){return[Qf,e.xml.xmlCharKey].includes(t)}function fXt(t,e,i,r,o){var l,d;const h=(l=o.xml.xmlCharKey)!==null&&l!==void 0?l:N4;hX(t,e)&&(e=gHe(t,e,i,"serializedName"));const p=hHe(t,e,r);let g={};const f=[];for(const T of Object.keys(p)){const C=p[T],E=tfe(p[T].serializedName);f.push(E[0]);const{serializedName:I,xmlName:w,xmlElementName:D}=C;let F=r;I!==""&&I!==void 0&&(F=r+"."+I);const x=C.headerCollectionPrefix;if(x){const B={};for(const L of Object.keys(i))L.startsWith(x)&&(B[L.substring(x.length)]=t.deserialize(C.type.value,i[L],F,o)),f.push(L);g[T]=B}else if(t.isXML)if(C.xmlIsAttribute&&i[Qf])g[T]=t.deserialize(C,i[Qf][w],F,o);else if(C.xmlIsMsText)i[h]!==void 0?g[T]=i[h]:typeof i=="string"&&(g[T]=i);else{const B=D||w||I;if(C.xmlIsWrapped){const L=i[w],z=(d=L?.[D])!==null&&d!==void 0?d:[];g[T]=t.deserialize(C,z,F,o),f.push(w)}else{const L=i[B];g[T]=t.deserialize(C,L,F,o),f.push(B)}}else{let B,L=i,z=0;for(const J of E){if(!L)break;z++,L=L[J]}L===null&&z<E.length&&(L=void 0),B=L;const H=e.type.polymorphicDiscriminator;H&&T===H.clientName&&B==null&&(B=e.serializedName);let j;if(Array.isArray(i[T])&&p[T].serializedName===""){B=i[T];const J=t.deserialize(C,B,F,o);for(const[Z,re]of Object.entries(g))Object.prototype.hasOwnProperty.call(J,Z)||(J[Z]=re);g=J}else(B!==void 0||C.defaultValue!==void 0)&&(j=t.deserialize(C,B,F,o),g[T]=j)}}const y=e.type.additionalProperties;if(y){const T=C=>{for(const E in p)if(tfe(p[E].serializedName)[0]===C)return!1;return!0};for(const C in i)T(C)&&(g[C]=t.deserialize(y,i[C],r+'["'+C+'"]',o))}else if(i&&!o.ignoreUnknownProperties)for(const T of Object.keys(i))g[T]===void 0&&!f.includes(T)&&!mXt(T,o)&&(g[T]=i[T]);return g}function vXt(t,e,i,r,o){const l=e.type.value;if(!l||typeof l!="object")throw new Error(`"value" metadata for a Dictionary must be defined in the mapper and it must of type "object" in ${r}`);if(i){const d={};for(const h of Object.keys(i))d[h]=t.deserialize(l,i[h],r,o);return d}return i}function yXt(t,e,i,r,o){var l;let d=e.type.element;if(!d||typeof d!="object")throw new Error(`element" metadata for an Array must be defined in the mapper and it must of type "object" in ${r}`);if(i){Array.isArray(i)||(i=[i]),d.type.name==="Composite"&&d.type.className&&(d=(l=t.modelMappers[d.type.className])!==null&&l!==void 0?l:d);const h=[];for(let p=0;p<i.length;p++)h[p]=t.deserialize(d,i[p],`${r}[${p}]`,o);return h}return i}function SXt(t,e,i){const r=[i];for(;r.length;){const o=r.shift(),l=e===o?e:o+"."+e;if(Object.prototype.hasOwnProperty.call(t,l))return t[l];for(const[d,h]of Object.entries(t))d.startsWith(o+".")&&h.type.uberParent===o&&h.type.className&&r.push(h.type.className)}}function gHe(t,e,i,r){var o;const l=hX(t,e);if(l){let d=l[r];if(d){r==="serializedName"&&(d=d.replace(/\\/gi,""));const h=i[d],p=(o=e.type.uberParent)!==null&&o!==void 0?o:e.type.className;if(typeof h=="string"&&p){const g=SXt(t.modelMappers.discriminators,h,p);g&&(e=g)}}}return e}function hX(t,e){return e.type.polymorphicDiscriminator||mHe(t,e.type.uberParent)||mHe(t,e.type.className)}function mHe(t,e){return e&&t.modelMappers[e]&&t.modelMappers[e].type.polymorphicDiscriminator}const hF={Base64Url:"Base64Url",Boolean:"Boolean",ByteArray:"ByteArray",Composite:"Composite",Date:"Date",DateTime:"DateTime",DateTimeRfc1123:"DateTimeRfc1123",Dictionary:"Dictionary",Enum:"Enum",Number:"Number",Object:"Object",Sequence:"Sequence",String:"String",Stream:"Stream",TimeSpan:"TimeSpan",UnixTime:"UnixTime"},fHe={operationRequestMap:new WeakMap};function x4(t,e,i){let r=e.parameterPath;const o=e.mapper;let l;if(typeof r=="string"&&(r=[r]),Array.isArray(r)){if(r.length>0)if(o.isConstant)l=o.defaultValue;else{let d=vHe(t,r);!d.propertyFound&&i&&(d=vHe(i,r));let h=!1;d.propertyFound||(h=o.required||r[0]==="options"&&r.length===2),l=h?o.defaultValue:d.propertyValue}}else{o.required&&(l={});for(const d in r){const h=o.type.modelProperties[d],p=r[d],g=x4(t,{parameterPath:p,mapper:h},i);g!==void 0&&(l||(l={}),l[d]=g)}}return l}function vHe(t,e){const i={propertyFound:!1};let r=0;for(;r<e.length;++r){const o=e[r];if(t&&o in t)t=t[o];else break}return r===e.length&&(i.propertyValue=t,i.propertyFound=!0),i}const yHe=Symbol.for("@azure/core-client original request");function bXt(t){return yHe in t}function B4(t){if(bXt(t))return B4(t[yHe]);let e=fHe.operationRequestMap.get(t);return e||(e={},fHe.operationRequestMap.set(t,e)),e}const TXt=["application/json","text/json"],CXt=["application/xml","application/atom+xml"],SHe="deserializationPolicy";function bHe(t={}){var e,i,r,o,l,d,h;const p=(i=(e=t.expectedContentTypes)===null||e===void 0?void 0:e.json)!==null&&i!==void 0?i:TXt,g=(o=(r=t.expectedContentTypes)===null||r===void 0?void 0:r.xml)!==null&&o!==void 0?o:CXt,f=t.parseXML,y=t.serializerOptions,T={xml:{rootName:(l=y?.xml.rootName)!==null&&l!==void 0?l:"",includeRoot:(d=y?.xml.includeRoot)!==null&&d!==void 0?d:!1,xmlCharKey:(h=y?.xml.xmlCharKey)!==null&&h!==void 0?h:N4}};return{name:SHe,async sendRequest(C,E){const I=await E(C);return AXt(p,g,I,T,f)}}}function _Xt(t){let e;const i=t.request,r=B4(i),o=r?.operationSpec;return o&&(r?.operationResponseGetter?e=r?.operationResponseGetter(o,t):e=o.responses[t.status]),e}function EXt(t){const e=t.request,i=B4(e),r=i?.shouldDeserialize;let o;return r===void 0?o=!0:typeof r=="boolean"?o=r:o=r(t),o}async function AXt(t,e,i,r,o){const l=await kXt(t,e,i,r,o);if(!EXt(l))return l;const d=B4(l.request),h=d?.operationSpec;if(!h||!h.responses)return l;const p=_Xt(l),{error:g,shouldReturnResponse:f}=wXt(l,h,p,r);if(g)throw g;if(f)return l;if(p){if(p.bodyMapper){let y=l.parsedBody;h.isXML&&p.bodyMapper.type.name===hF.Sequence&&(y=typeof y=="object"?y[p.bodyMapper.xmlElementName]:[]);try{l.parsedBody=h.serializer.deserialize(p.bodyMapper,y,"operationRes.parsedBody",r)}catch(T){throw new EE(`Error ${T} occurred in deserializing the responseBody - ${l.bodyAsText}`,{statusCode:l.status,request:l.request,response:l})}}else h.httpMethod==="HEAD"&&(l.parsedBody=i.status>=200&&i.status<300);p.headersMapper&&(l.parsedHeaders=h.serializer.deserialize(p.headersMapper,l.headers.toJSON(),"operationRes.parsedHeaders",{xml:{},ignoreUnknownProperties:!0}))}return l}function IXt(t){const e=Object.keys(t.responses);return e.length===0||e.length===1&&e[0]==="default"}function wXt(t,e,i,r){var o,l,d,h,p;const g=200<=t.status&&t.status<300;if(IXt(e)?g:!!i)if(i){if(!i.isError)return{error:null,shouldReturnResponse:!1}}else return{error:null,shouldReturnResponse:!1};const y=i??e.responses.default,T=!((o=t.request.streamResponseStatusCodes)===null||o===void 0)&&o.has(t.status)?`Unexpected status code: ${t.status}`:t.bodyAsText,C=new EE(T,{statusCode:t.status,request:t.request,response:t});if(!y&&!(!((d=(l=t.parsedBody)===null||l===void 0?void 0:l.error)===null||d===void 0)&&d.code&&(!((p=(h=t.parsedBody)===null||h===void 0?void 0:h.error)===null||p===void 0)&&p.message)))throw C;const E=y?.bodyMapper,I=y?.headersMapper;try{if(t.parsedBody){const w=t.parsedBody;let D;if(E){let x=w;if(e.isXML&&E.type.name===hF.Sequence){x=[];const B=E.xmlElementName;typeof w=="object"&&B&&(x=w[B])}D=e.serializer.deserialize(E,x,"error.response.parsedBody",r)}const F=w.error||D||w;C.code=F.code,F.message&&(C.message=F.message),E&&(C.response.parsedBody=D)}t.headers&&I&&(C.response.parsedHeaders=e.serializer.deserialize(I,t.headers.toJSON(),"operationRes.parsedHeaders"))}catch(w){C.message=`Error "${w.message}" occurred in deserializing the responseBody - "${t.bodyAsText}" for the default response.`}return{error:C,shouldReturnResponse:!1}}async function kXt(t,e,i,r,o){var l;if(!(!((l=i.request.streamResponseStatusCodes)===null||l===void 0)&&l.has(i.status))&&i.bodyAsText){const d=i.bodyAsText,h=i.headers.get("Content-Type")||"",p=h?h.split(";").map(g=>g.toLowerCase()):[];try{if(p.length===0||p.some(g=>t.indexOf(g)!==-1))return i.parsedBody=JSON.parse(d),i;if(p.some(g=>e.indexOf(g)!==-1)){if(!o)throw new Error("Parsing XML not supported.");const g=await o(d,r.xml);return i.parsedBody=g,i}}catch(g){const f=`Error "${g}" occurred while parsing the response body - ${i.bodyAsText}.`,y=g.code||EE.PARSE_ERROR;throw new EE(f,{code:y,statusCode:i.status,request:i.request,response:i})}}return i}function RXt(t){const e=new Set;for(const i in t.responses){const r=t.responses[i];r.bodyMapper&&r.bodyMapper.type.name===hF.Stream&&e.add(Number(i))}return e}function jO(t){const{parameterPath:e,mapper:i}=t;let r;return typeof e=="string"?r=e:Array.isArray(e)?r=e.join("."):r=i.serializedName,r}const THe="serializationPolicy";function CHe(t={}){const e=t.stringifyXML;return{name:THe,async sendRequest(i,r){const o=B4(i),l=o?.operationSpec,d=o?.operationArguments;return l&&d&&(MXt(i,d,l),PXt(i,d,l,e)),r(i)}}}function MXt(t,e,i){var r,o;if(i.headerParameters)for(const d of i.headerParameters){let h=x4(e,d);if(h!=null||d.mapper.required){h=i.serializer.serialize(d.mapper,h,jO(d));const p=d.mapper.headerCollectionPrefix;if(p)for(const g of Object.keys(h))t.headers.set(p+g,h[g]);else t.headers.set(d.mapper.serializedName||jO(d),h)}}const l=(o=(r=e.options)===null||r===void 0?void 0:r.requestOptions)===null||o===void 0?void 0:o.customHeaders;if(l)for(const d of Object.keys(l))t.headers.set(d,l[d])}function PXt(t,e,i,r=function(){throw new Error("XML serialization unsupported!")}){var o,l,d,h,p;const g=(o=e.options)===null||o===void 0?void 0:o.serializerOptions,f={xml:{rootName:(l=g?.xml.rootName)!==null&&l!==void 0?l:"",includeRoot:(d=g?.xml.includeRoot)!==null&&d!==void 0?d:!1,xmlCharKey:(h=g?.xml.xmlCharKey)!==null&&h!==void 0?h:N4}},y=f.xml.xmlCharKey;if(i.requestBody&&i.requestBody.mapper){t.body=x4(e,i.requestBody);const T=i.requestBody.mapper,{required:C,serializedName:E,xmlName:I,xmlElementName:w,xmlNamespace:D,xmlNamespacePrefix:F,nullable:x}=T,B=T.type.name;try{if(t.body!==void 0&&t.body!==null||x&&t.body===null||C){const L=jO(i.requestBody);t.body=i.serializer.serialize(T,t.body,L,f);const z=B===hF.Stream;if(i.isXML){const H=F?`xmlns:${F}`:"xmlns",j=DXt(D,H,B,t.body,f);B===hF.Sequence?t.body=r(LXt(j,w||I||E,H,D),{rootName:I||E,xmlCharKey:y}):z||(t.body=r(j,{rootName:I||E,xmlCharKey:y}))}else{if(B===hF.String&&(!((p=i.contentType)===null||p===void 0)&&p.match("text/plain")||i.mediaType==="text"))return;z||(t.body=JSON.stringify(t.body))}}}catch(L){throw new Error(`Error "${L.message}" occurred in serializing the payload - ${JSON.stringify(E,void 0,"  ")}.`)}}else if(i.formDataParameters&&i.formDataParameters.length>0){t.formData={};for(const T of i.formDataParameters){const C=x4(e,T);if(C!=null){const E=T.mapper.serializedName||jO(T);t.formData[E]=i.serializer.serialize(T.mapper,C,jO(T),f)}}}}function DXt(t,e,i,r,o){if(t&&!["Composite","Sequence","Dictionary"].includes(i)){const l={};return l[o.xml.xmlCharKey]=r,l[Qf]={[e]:t},l}return r}function LXt(t,e,i,r){if(Array.isArray(t)||(t=[t]),!i||!r)return{[e]:t};const o={[e]:t};return o[Qf]={[i]:r},o}function _He(t={}){const e=sDe(t??{});return t.credentialOptions&&e.addPolicy(Qle({credential:t.credentialOptions.credential,scopes:t.credentialOptions.credentialScopes})),e.addPolicy(CHe(t.serializationOptions),{phase:"Serialize"}),e.addPolicy(bHe(t.deserializationOptions),{phase:"Deserialize"}),e}let ife;function OXt(){return ife||(ife=cDe()),ife}const NXt={CSV:",",SSV:" ",Multi:"Multi",TSV:"	",Pipes:"|"};function xXt(t,e,i,r){const o=BXt(e,i,r);let l=!1,d=EHe(t,o);if(e.path){let g=EHe(e.path,o);e.path==="/{nextLink}"&&g.startsWith("/")&&(g=g.substring(1)),FXt(g)?(d=g,l=!0):d=UXt(d,g)}const{queryParams:h,sequenceParams:p}=zXt(e,i,r);return d=$Xt(d,h,p,l),d}function EHe(t,e){let i=t;for(const[r,o]of e)i=i.split(r).join(o);return i}function BXt(t,e,i){var r;const o=new Map;if(!((r=t.urlParameters)===null||r===void 0)&&r.length)for(const l of t.urlParameters){let d=x4(e,l,i);const h=jO(l);d=t.serializer.serialize(l.mapper,d,h),l.skipEncoding||(d=encodeURIComponent(d)),o.set(`{${l.mapper.serializedName||h}}`,d)}return o}function FXt(t){return t.includes("://")}function UXt(t,e){if(!e)return t;const i=new URL(t);let r=i.pathname;r.endsWith("/")||(r=`${r}/`),e.startsWith("/")&&(e=e.substring(1));const o=e.indexOf("?");if(o!==-1){const l=e.substring(0,o),d=e.substring(o+1);r=r+l,d&&(i.search=i.search?`${i.search}&${d}`:d)}else r=r+e;return i.pathname=r,i.toString()}function zXt(t,e,i){var r;const o=new Map,l=new Set;if(!((r=t.queryParameters)===null||r===void 0)&&r.length)for(const d of t.queryParameters){d.mapper.type.name==="Sequence"&&d.mapper.serializedName&&l.add(d.mapper.serializedName);let h=x4(e,d,i);if(h!=null||d.mapper.required){h=t.serializer.serialize(d.mapper,h,jO(d));const p=d.collectionFormat?NXt[d.collectionFormat]:"";if(Array.isArray(h)&&(h=h.map(g=>g??"")),d.collectionFormat==="Multi"&&h.length===0)continue;Array.isArray(h)&&(d.collectionFormat==="SSV"||d.collectionFormat==="TSV")&&(h=h.join(p)),d.skipEncoding||(Array.isArray(h)?h=h.map(g=>encodeURIComponent(g)):h=encodeURIComponent(h)),Array.isArray(h)&&(d.collectionFormat==="CSV"||d.collectionFormat==="Pipes")&&(h=h.join(p)),o.set(d.mapper.serializedName||jO(d),h)}}return{queryParams:o,sequenceParams:l}}function VXt(t){const e=new Map;if(!t||t[0]!=="?")return e;t=t.slice(1);const i=t.split("&");for(const r of i){const[o,l]=r.split("=",2),d=e.get(o);d?Array.isArray(d)?d.push(l):e.set(o,[d,l]):e.set(o,l)}return e}function $Xt(t,e,i,r=!1){if(e.size===0)return t;const o=new URL(t),l=VXt(o.search);for(const[h,p]of e){const g=l.get(h);if(Array.isArray(g))if(Array.isArray(p)){g.push(...p);const f=new Set(g);l.set(h,Array.from(f))}else g.push(p);else g?(Array.isArray(p)?p.unshift(g):i.has(h)&&l.set(h,[g,p]),r||l.set(h,p)):l.set(h,p)}const d=[];for(const[h,p]of l)if(typeof p=="string")d.push(`${h}=${p}`);else if(Array.isArray(p))for(const g of p)d.push(`${h}=${g}`);else d.push(`${h}=${p}`);return o.search=d.length?`?${d.join("&")}`:"",o.toString()}const AHe=zf("core-client");class IHe{constructor(e={}){var i,r;if(this._requestContentType=e.requestContentType,this._endpoint=(i=e.endpoint)!==null&&i!==void 0?i:e.baseUri,e.baseUri&&AHe.warning("The baseUri option for SDK Clients has been deprecated, please use endpoint instead."),this._allowInsecureConnection=e.allowInsecureConnection,this._httpClient=e.httpClient||OXt(),this.pipeline=e.pipeline||HXt(e),!((r=e.additionalPolicies)===null||r===void 0)&&r.length)for(const{policy:o,position:l}of e.additionalPolicies){const d=l==="perRetry"?"Sign":void 0;this.pipeline.addPolicy(o,{afterPhase:d})}}async sendRequest(e){return this.pipeline.sendRequest(this._httpClient,e)}async sendOperationRequest(e,i){const r=i.baseUrl||this._endpoint;if(!r)throw new Error("If operationSpec.baseUrl is not specified, then the ServiceClient must have a endpoint string property that contains the base URL to use.");const o=xXt(r,i,e,this),l=dDe({url:o});l.method=i.httpMethod;const d=B4(l);d.operationSpec=i,d.operationArguments=e;const h=i.contentType||this._requestContentType;h&&i.requestBody&&l.headers.set("Content-Type",h);const p=e.options;if(p){const g=p.requestOptions;g&&(g.timeout&&(l.timeout=g.timeout),g.onUploadProgress&&(l.onUploadProgress=g.onUploadProgress),g.onDownloadProgress&&(l.onDownloadProgress=g.onDownloadProgress),g.shouldDeserialize!==void 0&&(d.shouldDeserialize=g.shouldDeserialize),g.allowInsecureConnection&&(l.allowInsecureConnection=!0)),p.abortSignal&&(l.abortSignal=p.abortSignal),p.tracingOptions&&(l.tracingOptions=p.tracingOptions)}this._allowInsecureConnection&&(l.allowInsecureConnection=!0),l.streamResponseStatusCodes===void 0&&(l.streamResponseStatusCodes=RXt(i));try{const g=await this.sendRequest(l),f=dHe(g,i.responses[g.status]);return p?.onResponse&&p.onResponse(g,f),f}catch(g){if(typeof g=="object"&&g?.response){const f=g.response,y=dHe(f,i.responses[g.statusCode]||i.responses.default);g.details=y,p?.onResponse&&p.onResponse(f,y,g)}throw g}}}function HXt(t){const e=jXt(t),i=t.credential&&e?{credentialScopes:e,credential:t.credential}:void 0;return _He(Object.assign(Object.assign({},t),{credentialOptions:i}))}function jXt(t){if(t.credentialScopes)return t.credentialScopes;if(t.endpoint)return`${t.endpoint}/.default`;if(t.baseUri)return`${t.baseUri}/.default`;if(t.credential&&!t.credentialScopes)throw new Error("When using credentials, the ServiceClientOptions must contain either a endpoint or a credentialScopes. Unable to create a bearerTokenAuthenticationPolicy")}function GXt(t){return`, ${t.trim()}`.split(", Bearer ").filter(i=>i).map(i=>`${i.trim()}, `.split('", ').filter(l=>l).map(l=>(([d,h])=>({[d]:h}))(l.trim().split('="'))).reduce((l,d)=>Object.assign(Object.assign({},l),d),{}))}async function qXt(t){var e;const{scopes:i,response:r}=t,o=t.logger||AHe,l=r.headers.get("WWW-Authenticate");if(!l)return o.info("The WWW-Authenticate header was missing. Failed to perform the Continuous Access Evaluation authentication flow."),!1;const h=(GXt(l)||[]).find(g=>g.claims);if(!h)return o.info('The WWW-Authenticate header was missing the necessary "claims" to perform the Continuous Access Evaluation authentication flow.'),!1;const p=await t.getAccessToken(h.scope?[h.scope]:i,{claims:WZt(h.claims)});return p?(t.request.headers.set("Authorization",`${(e=p.tokenType)!==null&&e!==void 0?e:"Bearer"} ${p.token}`),!0):!1}const wHe={DefaultScope:"/.default",HeaderConstants:{AUTHORIZATION:"authorization"}};function WXt(t){return/^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/.test(t)}const KXt=async t=>{var e;const i=XXt(t.request),r=QXt(t.response);if(r){const o=ZXt(r),l=YXt(t,o),d=JXt(o);if(!d)return!1;const h=await t.getAccessToken(l,Object.assign(Object.assign({},i),{tenantId:d}));return h?(t.request.headers.set(wHe.HeaderConstants.AUTHORIZATION,`${(e=h.tokenType)!==null&&e!==void 0?e:"Bearer"} ${h.token}`),!0):!1}return!1};function JXt(t){const r=new URL(t.authorization_uri).pathname.split("/")[1];if(r&&WXt(r))return r}function YXt(t,e){if(!e.resource_id)return t.scopes;const i=new URL(e.resource_id);i.pathname=wHe.DefaultScope;let r=i.toString();return r==="https://disk.azure.com/.default"&&(r="https://disk.azure.com//.default"),[r]}function QXt(t){const e=t.headers.get("WWW-Authenticate");if(t.status===401&&e)return e}function ZXt(t){return`${t.slice(7).trim()} `.split(" ").filter(o=>o).map(o=>(([l,d])=>({[l]:d}))(o.trim().split("="))).reduce((o,l)=>Object.assign(Object.assign({},o),l),{})}function XXt(t){return{abortSignal:t.abortSignal,requestOptions:{timeout:t.timeout},tracingOptions:t.tracingOptions}}const eei=_q(Object.freeze(Object.defineProperty({__proto__:null,MapperTypeNames:hF,ServiceClient:IHe,XML_ATTRKEY:Qf,XML_CHARKEY:N4,authorizeRequestOnClaimChallenge:qXt,authorizeRequestOnTenantChallenge:KXt,createClientPipeline:_He,createSerializer:efe,deserializationPolicy:bHe,deserializationPolicyName:SHe,serializationPolicy:CHe,serializationPolicyName:THe},Symbol.toStringTag,{value:"Module"}))),tei=_q(Gwt);var kHe;function iei(){return kHe||(kHe=1,function(t){function e(F){return F&&typeof F=="object"&&"default"in F?F.default:F}var i=e(GZt),r=e(qZt),o=e(eei),l=e(tei),d=typeof globalThis<"u"?globalThis:typeof window<"u"?window:typeof MCe<"u"?MCe:typeof self<"u"?self:{};function h(F){return F&&F.__esModule&&Object.prototype.hasOwnProperty.call(F,"default")?F.default:F}function p(F,x){return x={exports:{}},F(x,x.exports),x.exports}var g=p(function(F,x){(function(B,L){F.exports=L()})(d,function(){return function(B){function L(H){if(z[H])return z[H].exports;var j=z[H]={i:H,l:!1,exports:{}};return B[H].call(j.exports,j,j.exports,L),j.l=!0,j.exports}var z={};return L.m=B,L.c=z,L.i=function(H){return H},L.d=function(H,j,J){L.o(H,j)||Object.defineProperty(H,j,{configurable:!1,enumerable:!0,get:J})},L.n=function(H){var j=H&&H.__esModule?function(){return H.default}:function(){return H};return L.d(j,"a",j),j},L.o=function(H,j){return Object.prototype.hasOwnProperty.call(H,j)},L.p="",L(L.s=1)}([function(B,L,z){function H(Z,re){var ne,le=new Promise(function(Me,Le){fetch(Z).then(function(pe){ne!==void 0&&clearTimeout(ne),Me(pe)}).catch(function(pe){ne!==void 0&&clearTimeout(ne),Le(pe)})});if(re!==0){var he=new Promise(function(Me,Le){ne=setTimeout(Le,re,new Error("Fetch for '".concat(Z.url,"' timed out")))});return Promise.race([le,he])}return le}function j(Z){try{return JSON.stringify(Z)}catch{return"Unable to serialize object of type ".concat(typeof Z)}}Object.defineProperty(L,"__esModule",{value:!0}),L.Timespan=L.toJson=L.fetchWithTimeout=void 0,L.fetchWithTimeout=H,L.toJson=j;var J=function(){function Z(){this.start=Date.now()}return Object.defineProperty(Z.prototype,"duration",{get:function(){return Date.now()-this.start},enumerable:!1,configurable:!0}),Object.defineProperty(Z.prototype,"startTime",{get:function(){return this.start},enumerable:!1,configurable:!0}),Z.prototype.reset=function(){this.start=Date.now()},Z}();L.Timespan=J},function(B,L,z){function H(pe,te,Se){return new Le(pe,te,Se)}var j=this&&this.__extends||function(){var pe=function(te,Se){return(pe=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(ce,X){ce.__proto__=X}||function(ce,X){for(var ve in X)Object.prototype.hasOwnProperty.call(X,ve)&&(ce[ve]=X[ve])})(te,Se)};return function(te,Se){function ce(){this.constructor=te}if(typeof Se!="function"&&Se!==null)throw new TypeError("Class extends value "+String(Se)+" is not a constructor or null");pe(te,Se),te.prototype=Se===null?Object.create(Se):(ce.prototype=Se.prototype,new ce)}}(),J=this&&this.__assign||function(){return J=Object.assign||function(pe){for(var te,Se=1,ce=arguments.length;Se<ce;Se++){te=arguments[Se];for(var X in te)Object.prototype.hasOwnProperty.call(te,X)&&(pe[X]=te[X])}return pe},J.apply(this,arguments)},Z=this&&this.__awaiter||function(pe,te,Se,ce){function X(ve){return ve instanceof Se?ve:new Se(function(Te){Te(ve)})}return new(Se||(Se=Promise))(function(ve,Te){function Be(tt){try{Ge(ce.next(tt))}catch(ct){Te(ct)}}function qe(tt){try{Ge(ce.throw(tt))}catch(ct){Te(ct)}}function Ge(tt){tt.done?ve(tt.value):X(tt.value).then(Be,qe)}Ge((ce=ce.apply(pe,te||[])).next())})},re=this&&this.__generator||function(pe,te){function Se(Ge){return function(tt){return ce([Ge,tt])}}function ce(Ge){if(X)throw new TypeError("Generator is already executing.");for(;Be&&(Be=0,Ge[0]&&(qe=0)),qe;)try{if(X=1,ve&&(Te=2&Ge[0]?ve.return:Ge[0]?ve.throw||((Te=ve.return)&&Te.call(ve),0):ve.next)&&!(Te=Te.call(ve,Ge[1])).done)return Te;switch(ve=0,Te&&(Ge=[2&Ge[0],Te.value]),Ge[0]){case 0:case 1:Te=Ge;break;case 4:return qe.label++,{value:Ge[1],done:!1};case 5:qe.label++,ve=Ge[1],Ge=[0];continue;case 7:Ge=qe.ops.pop(),qe.trys.pop();continue;default:if(Te=qe.trys,!(Te=Te.length>0&&Te[Te.length-1])&&(Ge[0]===6||Ge[0]===2)){qe=0;continue}if(Ge[0]===3&&(!Te||Ge[1]>Te[0]&&Ge[1]<Te[3])){qe.label=Ge[1];break}if(Ge[0]===6&&qe.label<Te[1]){qe.label=Te[1],Te=Ge;break}if(Te&&qe.label<Te[2]){qe.label=Te[2],qe.ops.push(Ge);break}Te[2]&&qe.ops.pop(),qe.trys.pop();continue}Ge=te.call(pe,qe)}catch(tt){Ge=[6,tt],ve=0}finally{X=Te=0}if(5&Ge[0])throw Ge[1];return{value:Ge[0]?Ge[1]:void 0,done:!0}}var X,ve,Te,Be,qe={label:0,sent:function(){if(1&Te[0])throw Te[1];return Te[1]},trys:[],ops:[]};return Be={next:Se(0),throw:Se(1),return:Se(2)},typeof Symbol=="function"&&(Be[Symbol.iterator]=function(){return this}),Be};Object.defineProperty(L,"__esModule",{value:!0}),L.createRegistrarClient=L.RegistrarClient=void 0;var ne=z(0),le=["skype","aad","cae"],he=function(pe){function te(Se){var ce=pe.call(this,Se)||this;return ce.name="CancelationError",ce}return j(te,pe),te}(Error),Me=function(){function pe(te,Se,ce){this.logger=te,this.maxBackoffInMs=Se,this.initialDelay=ce,this.backoffCount=0,this.id=++pe.idCounter}return pe.prototype.delay=function(te){var Se=this;if(this.timerHandle!==void 0)throw new Error("Retry sequence logical failure");if(this.backoffCount===-1)return new Promise(function(X,ve){ve(new he("Cancelled"))});var ce=this.calculateNextBackoffMs();return this.backoffCount++,this.logger.info("[RegistrarClient] Backing off ".concat(te," for ").concat(ce," milliseconds with ID ").concat(this.id)),new Promise(function(X,ve){Se.cancelFunc=ve,Se.timerHandle=setTimeout(function(){Se.logger.info("[RegistrarClient] Back off for ".concat(te," with ID ").concat(Se.id," complete")),Se.timerHandle=void 0,X()},ce)})},pe.prototype.cancel=function(){this.timerHandle!==void 0&&(this.logger.debug("Resetting back off"),clearTimeout(this.timerHandle),this.cancelFunc!==void 0&&this.cancelFunc(new he("Cancelled"))),this.backoffCount=-1},pe.prototype.calculateNextBackoffMs=function(){var te=1+.4*(Math.random()-.5),Se=this.initialDelay*Math.pow(2,this.backoffCount)*te;return Se=Math.round(Se),Math.min(this.maxBackoffInMs,Se)},pe.idCounter=0,pe}(),Le=function(){function pe(te,Se,ce){var X;this.logger=te,this.tokenProvider=Se,this.options=ce,this.DEFAULT_MAX_RETRIES_FOR_GET_TOKEN=15,this.DEFAULT_MAX_BACKOFF_TIME_IN_MS=3e5,this.backoffs={},this.maxBackOffTime=this.options.maxRetryDelayMs>0?this.options.maxRetryDelayMs:this.DEFAULT_MAX_BACKOFF_TIME_IN_MS,this.maxRetriesForGetToken=ce.maxRetriesForGetToken===void 0||ce.maxRetriesForGetToken===null?this.DEFAULT_MAX_RETRIES_FOR_GET_TOKEN:ce.maxRetriesForGetToken,this.proxyUrlRewrite=(X=ce.proxyUrlRewrite)!==null&&X!==void 0?X:function(ve){return ve}}return pe.prototype.setTelemetryLogger=function(te){this.eventLogger=te},pe.prototype.register=function(te,Se){return Z(this,void 0,void 0,function(){return re(this,function(ce){switch(ce.label){case 0:return[4,this.performRegistration(te,Se,"pr_set_registration")];case 1:return ce.sent(),this.cachedRegistrationParams=[te,Se],[2]}})})},pe.prototype.unregister=function(){return Z(this,void 0,void 0,function(){var te;return re(this,function(Se){switch(Se.label){case 0:return this.logger.info("[RegistrarClient] sending unregister request"),te=new Request(this.proxyUrlRewrite("".concat(this.options.registrarUrl,"/").concat(this.options.registrationId)),{method:"DELETE",mode:"cors",headers:new Headers(J(J({},this.options.extraRegistrationHeaders),{accept:"application/json, text/javascript"}))}),[4,this.callRegistrar(te,"pr_delete_registration")];case 1:return Se.sent(),[2]}})})},pe.prototype.cancelPendingRequests=function(){var te=this;Object.keys(this.backoffs).forEach(function(Se){te.backoffs[Se].cancel()}),this.backoffs={}},pe.prototype.resendRegistration=function(){return Z(this,void 0,void 0,function(){return re(this,function(te){switch(te.label){case 0:if(!this.cachedRegistrationParams)throw new Error("Re-registration failed because there is no registration parameters cached");return[4,this.performRegistration(this.cachedRegistrationParams[0],this.cachedRegistrationParams[1],"pr_resend_registration")];case 1:return te.sent(),[2]}})})},pe.prototype.performRegistration=function(te,Se,ce){return Z(this,void 0,void 0,function(){var X,ve;return re(this,function(Te){switch(Te.label){case 0:return this.logger.info("[RegistrarClient] Sending register request"),X={clientDescription:te,registrationId:this.options.registrationId,nodeId:"",transports:Se},ve=new Request(this.proxyUrlRewrite(this.options.registrarUrl),{method:"POST",mode:"cors",headers:new Headers(J(J({},this.options.extraRegistrationHeaders),{"content-type":"application/json",accept:"application/json, text/javascript"})),body:(0,ne.toJson)(X)}),[4,this.callRegistrar(ve,ce)];case 1:return Te.sent(),[2]}})})},pe.prototype.startBackoff=function(){var te=new Me(this.logger,this.maxBackOffTime,this.options.initialRetryDelayMs);return this.backoffs[te.id]=te,te},pe.prototype.stopBackoff=function(te){te.cancel(),delete this.backoffs[te.id]},pe.prototype.getToken=function(te){return Z(this,void 0,void 0,function(){var Se,ce,X,ve,Te,Be,qe;return re(this,function(Ge){switch(Ge.label){case 0:Se=this.startBackoff(),ce=0,Ge.label=1;case 1:return Ge.trys.push([1,3,,8]),this.logger.info("[RegistrarClient] Asking for a new token"),[4,this.tokenProvider({needFresh:!0,supportedTokenTypes:le,wwwAuthenticateHeader:te,purpose:"registrar"})];case 2:return X=Ge.sent(),this.stopBackoff(Se),[2,X];case 3:ve=Ge.sent(),Ge.label=4;case 4:return Ge.trys.push([4,6,,7]),ce++,Te=JSON.stringify(ve),ce>this.maxRetriesForGetToken?(Be="[RegistrarClient] getToken retry limit hit. Will not retry now. Error: ".concat(Te),this.logger.error(Be),this.stopBackoff(Se),[2,Promise.reject(Be)]):(this.logger.warn("[RegistrarClient] Retrying for a new token. Retry Count: ".concat(ce," Error: ").concat(Te)),[4,Se.delay("Fetching a new token")]);case 5:return Ge.sent(),[3,8];case 6:throw qe=Ge.sent(),this.stopBackoff(Se),qe;case 7:return[3,8];case 8:return[3,1];case 9:return[2]}})})},pe.prototype.callRegistrar=function(te,Se){var ce,X,ve;return Z(this,void 0,void 0,function(){var Te,Be,qe,Ge,tt,ct,Mt,ht,vt,Pt,ni,Zt,it,Ke,ot,Ht;return re(this,function(jt){switch(jt.label){case 0:return Te=this.startBackoff(),[4,this.tokenProvider({needFresh:!1,supportedTokenTypes:le,wwwAuthenticateHeader:void 0,purpose:"registrar"})];case 1:Be=jt.sent(),this.setTokenHeader(te,Be),qe=new ne.Timespan,Ge=0,jt.label=2;case 2:tt=void 0,jt.label=3;case 3:return jt.trys.push([3,10,15,16]),ct=te.clone(),[4,(0,ne.fetchWithTimeout)(ct,this.options.requestTimeoutMs)];case 4:return tt=jt.sent(),tt.status!==401?[3,8]:++Ge>this.maxRetriesForGetToken?(Mt="[RegistrarClient] getSkypeToken retry limit hit. Will not retry now. Request '".concat(te.url,"' failed with ").concat(tt.status," ").concat(tt.statusText),this.logger.error(Mt),this.stopBackoff(Te),[2,Promise.reject(Mt)]):(this.logger.warn("[RegistrarClient] Retry Count ".concat(Ge,". Request '").concat(te.url,"' failed with ").concat(tt.status," ").concat(tt.statusText)),ht=(X=(ce=tt.headers)===null||ce===void 0?void 0:ce.get("www-authenticate"))!==null&&X!==void 0?X:void 0,vt=this.setTokenHeader,Pt=[te],[4,this.getToken(ht)]);case 5:return vt.apply(this,Pt.concat([jt.sent()])),Ge>1?[4,Te.delay("Registrar call retry after 401")]:[3,7];case 6:jt.sent(),jt.label=7;case 7:return[3,22];case 8:if(tt.status>=500&&tt.status<600)throw new Error("Fetch for '".concat(te.url,"' failed with ").concat(tt.status," ").concat(tt.statusText));jt.label=9;case 9:return[3,16];case 10:ni=jt.sent(),this.logger.error("[RegistrarClient] Request failed with ".concat(ni)),jt.label=11;case 11:return jt.trys.push([11,13,,14]),[4,Te.delay("Registrar call retry")];case 12:return jt.sent(),[3,22];case 13:throw Zt=jt.sent(),this.logger.error("[RegistrarClient] Request cancelled"),this.stopBackoff(Te),Zt;case 14:return[3,16];case 15:return this.sendTelemetryEvent(Se,te,tt,qe),[7];case 16:return this.stopBackoff(Te),tt.ok?[2,tt]:[3,17];case 17:it=void 0,jt.label=18;case 18:return jt.trys.push([18,20,,21]),ot=(Ke=JSON).stringify,[4,tt.json()];case 19:return it=ot.apply(Ke,[jt.sent()]),[3,21];case 20:return jt.sent(),it="no details",[3,21];case 21:throw Ht="Fetch for '".concat(te.url,"' failed with ").concat(tt.status," ").concat(tt.statusText," (").concat(it,", MS-CV: ").concat((ve=tt.headers)===null||ve===void 0?void 0:ve.get("MS-CV"),")"),this.logger.error("[RegistrarClient] ".concat(Ht)),new Error(Ht);case 22:return[3,2];case 23:return[2]}})})},pe.prototype.setTokenHeader=function(te,Se){switch(te.headers.delete("X-Skypetoken"),te.headers.delete("Authorization"),te.headers.delete("X-MS-Migration"),Se.tokenType.toLowerCase()){case"skype":te.headers.set("X-Skypetoken",Se.token);break;case"aad":case"cae":te.headers.set("Authorization","Bearer ".concat(Se.token));break;default:throw new Error("unsupported token type: ".concat(Se.tokenType))}this.options.usingLegacyTokenApi===!1&&te.headers.set("X-MS-Migration","True")},pe.prototype.sendTelemetryEvent=function(te,Se,ce,X){if(this.eventLogger!==void 0){var ve={name:te,properties:{url:{value:Se.url},result_code:{value:ce!==void 0?ce.status:0},begin_timestamp:{value:X.startTime},elapsed:{value:X.duration}}};this.eventLogger.logEvent(ve)}},pe}();L.RegistrarClient=Le,L.createRegistrarClient=H}])})});h(g);var f=p(function(F,x){(function(B,L){F.exports=L(g)})(d,function(B){return function(L){function z(j){if(H[j])return H[j].exports;var J=H[j]={i:j,l:!1,exports:{}};return L[j].call(J.exports,J,J.exports,z),J.l=!0,J.exports}var H={};return z.m=L,z.c=H,z.i=function(j){return j},z.d=function(j,J,Z){z.o(j,J)||Object.defineProperty(j,J,{configurable:!1,enumerable:!0,get:Z})},z.n=function(j){var J=j&&j.__esModule?function(){return j.default}:function(){return j};return z.d(J,"a",J),J},z.o=function(j,J){return Object.prototype.hasOwnProperty.call(j,J)},z.p="",z(z.s=20)}([function(L,z,H){Object.defineProperty(z,"__esModule",{value:!0}),z.Logger=void 0;var j=function(){function J(Z,re){this.name=Z,this.logger=re}return J.prototype.debug=function(Z){this.logger.debug("[".concat(this.name,"] ").concat(Z))},J.prototype.info=function(Z){this.logger.info("[".concat(this.name,"] ").concat(Z))},J.prototype.warn=function(Z){this.logger.warn("[".concat(this.name,"] ").concat(Z))},J.prototype.error=function(Z){this.logger.error("[".concat(this.name,"] ").concat(Z))},J}();z.Logger=j},function(L,z,H){Object.defineProperty(z,"__esModule",{value:!0}),z.USER_AUTHENTICATE_EVENT_NAME=z.SUPPORTED_TOKEN_TYPES=z.FAILED_MESSAGE_ACK=z.UNHANDLED_MESSAGE_ACK=z.HANDLED_MESSAGE_ACK=z.CLIENT_VERSION=z.constants=void 0,z.constants={TROUTER_INIT:"trouterinit",TROUTER_READY_EVENT:"trouterReadyEvent",TROUTER_READY_TIMEOUT:"trouterReadyTimeout",TROUTER_TOKEN_REQUEST:"trouterTokenRequest",TROUTER_TOKEN_GET_SUCCEEDED:"trouterTokenGetSucceeded",TROUTER_TOKEN_GET_FAILED:"trouterTokenGetFailed",TROUTER_RECONNECTING:"trouterReconnecting",RENEWAL:"renewal",NEW_CONNECTION:"newConnection",ENDPOINT_REGISTRATION_FAILED:"endpointRegistrationFailed"},z.CLIENT_VERSION="2024.14.01.55",z.HANDLED_MESSAGE_ACK=200,z.UNHANDLED_MESSAGE_ACK=404,z.FAILED_MESSAGE_ACK=500,z.SUPPORTED_TOKEN_TYPES=["skype","aad","cae"],z.USER_AUTHENTICATE_EVENT_NAME="user.authenticate"},function(L,z,H){Object.defineProperty(z,"__esModule",{value:!0}),z.TrouterState=z.UserActivityState=void 0;var j;(function(Z){Z[Z.Unknown=0]="Unknown",Z[Z.Active=1]="Active",Z[Z.Inactive=2]="Inactive"})(j||(z.UserActivityState=j={}));var J;(function(Z){Z[Z.Unknown=0]="Unknown",Z[Z.Connected=2]="Connected",Z[Z.Disconnected=3]="Disconnected",Z[Z.Switching=9]="Switching"})(J||(z.TrouterState=J={}))},function(L,z,H){function j(Le){try{return JSON.stringify(Le)}catch{return"Unable to serialize object of type ".concat(typeof Le)}}function J(Le){var pe=Math.round(new Date().getTime()/1e3);return Le!==void 0&&Le>pe?Le-pe:0}function Z(Le){return Math.round(new Date().getTime()/1e3)+Le}function re(Le,pe){return ne(this,void 0,void 0,function(){var te,Se,ce;return le(this,function(X){return Se=new Promise(function(ve,Te){fetch(Le).then(function(Be){clearTimeout(te),ve(Be)}).catch(function(Be){clearTimeout(te),Te(Be)})}),pe!==0?(ce=new Promise(function(ve,Te){var Be=new URL(Le.url),qe=new Error("".concat(Le.method," ").concat(Be.origin).concat(Be.pathname," timed out"));te=setTimeout(Te,pe,qe)}),[2,Promise.race([Se,ce])]):[2,Se]})})}var ne=this&&this.__awaiter||function(Le,pe,te,Se){function ce(X){return X instanceof te?X:new te(function(ve){ve(X)})}return new(te||(te=Promise))(function(X,ve){function Te(Ge){try{qe(Se.next(Ge))}catch(tt){ve(tt)}}function Be(Ge){try{qe(Se.throw(Ge))}catch(tt){ve(tt)}}function qe(Ge){Ge.done?X(Ge.value):ce(Ge.value).then(Te,Be)}qe((Se=Se.apply(Le,pe||[])).next())})},le=this&&this.__generator||function(Le,pe){function te(qe){return function(Ge){return Se([qe,Ge])}}function Se(qe){if(ce)throw new TypeError("Generator is already executing.");for(;Te&&(Te=0,qe[0]&&(Be=0)),Be;)try{if(ce=1,X&&(ve=2&qe[0]?X.return:qe[0]?X.throw||((ve=X.return)&&ve.call(X),0):X.next)&&!(ve=ve.call(X,qe[1])).done)return ve;switch(X=0,ve&&(qe=[2&qe[0],ve.value]),qe[0]){case 0:case 1:ve=qe;break;case 4:return Be.label++,{value:qe[1],done:!1};case 5:Be.label++,X=qe[1],qe=[0];continue;case 7:qe=Be.ops.pop(),Be.trys.pop();continue;default:if(ve=Be.trys,!(ve=ve.length>0&&ve[ve.length-1])&&(qe[0]===6||qe[0]===2)){Be=0;continue}if(qe[0]===3&&(!ve||qe[1]>ve[0]&&qe[1]<ve[3])){Be.label=qe[1];break}if(qe[0]===6&&Be.label<ve[1]){Be.label=ve[1],ve=qe;break}if(ve&&Be.label<ve[2]){Be.label=ve[2],Be.ops.push(qe);break}ve[2]&&Be.ops.pop(),Be.trys.pop();continue}qe=pe.call(Le,Be)}catch(Ge){qe=[6,Ge],X=0}finally{ce=ve=0}if(5&qe[0])throw qe[1];return{value:qe[0]?qe[1]:void 0,done:!0}}var ce,X,ve,Te,Be={label:0,sent:function(){if(1&ve[0])throw ve[1];return ve[1]},trys:[],ops:[]};return Te={next:te(0),throw:te(1),return:te(2)},typeof Symbol=="function"&&(Te[Symbol.iterator]=function(){return this}),Te};Object.defineProperty(z,"__esModule",{value:!0}),z.Timespan=z.CorrelationVector=z.fetchWithTimeout=z.calculateExpireTsInSec=z.calculateTtlInSec=z.toJson=void 0,z.toJson=j,z.calculateTtlInSec=J,z.calculateExpireTsInSec=Z,z.fetchWithTimeout=re;var he=function(){function Le(pe){this.base=pe!==void 0?pe:this.createCorrelationVectorBase(),this.extension=0}return Le.extend=function(pe){return new Le(pe)},Le.prototype.increase=function(){this.extension++},Le.prototype.value=function(){return"".concat(this.base,".").concat(this.extension)},Le.prototype.createCorrelationVectorBase=function(){for(var pe="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0987654321/+",te="AQgw",Se="",ce=0;ce<21;ce++)Se+=pe.charAt(Math.floor(Math.random()*pe.length));return Se+=te.charAt(Math.floor(Math.random()*te.length))},Le}();z.CorrelationVector=he;var Me=function(){function Le(){this.start=Date.now()}return Object.defineProperty(Le.prototype,"duration",{get:function(){return Date.now()-this.start},enumerable:!1,configurable:!0}),Object.defineProperty(Le.prototype,"startTime",{get:function(){return this.start},enumerable:!1,configurable:!0}),Le.prototype.reset=function(){this.start=Date.now()},Le}();z.Timespan=Me},function(L,z,H){Object.defineProperty(z,"__esModule",{value:!0}),z.TrouterManagerState=z.UserActivityEventReason=z.ServerState=void 0;var j=H(3),J=function(){function ne(le,he,Me,Le,pe,te,Se){this.connectionId=le,this.connectedClientId=he,this.domId=Me,this.unsecureUrl=Le,this.url=pe,this.c2cUrlBase=te,this.expirationTsSec=Se}return ne.prototype.getRemainingTtlInSec=function(){return(0,j.calculateTtlInSec)(this.expirationTsSec)},ne}();z.ServerState=J;var Z;(function(ne){ne[ne.Unknown=0]="Unknown",ne[ne.Modified=1]="Modified",ne[ne.Snapshot=2]="Snapshot",ne[ne.Connected=3]="Connected"})(Z||(z.UserActivityEventReason=Z={}));var re;(function(ne){ne[ne.Unknown=0]="Unknown",ne[ne.Connected=2]="Connected",ne[ne.Disconnected=3]="Disconnected",ne[ne.Switching=9]="Switching",ne[ne.TerminalError=10]="TerminalError"})(re||(z.TrouterManagerState=re={}))},function(L,z,H){function j(pe,te){return pe==="skype"&&J(te?.scae)!=="1"?"v4a":"v4c"}function J(pe){return typeof pe=="string"?pe:typeof pe=="number"?pe.toString():void 0}function Z(pe,te){return te?.kind==="v4c-websocket-failure"?"v4a":pe}function re(pe){return Object.prototype.hasOwnProperty.call(pe,"connectparams")}function ne(pe,te){return te==="v4a"?pe.replace(/\/v4\/c\b/,"/v4/a").replace("wss://","https://").replace("ws://","http://"):pe.replace(/\/v4\/a\b/,"/v4/c").replace("https://","wss://").replace("http://","ws://")}function le(pe){if(pe!==void 0)return Le(Le({},pe),{reconnectUrl:void 0,serviceUrl:void 0})}function he(pe){return typeof pe=="string"?parseInt(pe,10):pe}function Me(pe){if(pe?.kind==="redirect"&&pe.host!==void 0){var te=pe.host;return te.endsWith("/")&&(te=te.substring(0,te.length-1)),te.endsWith("/v4/c")||te.endsWith("/v4/a")||(te+="/v4/c"),te}}var Le=this&&this.__assign||function(){return Le=Object.assign||function(pe){for(var te,Se=1,ce=arguments.length;Se<ce;Se++){te=arguments[Se];for(var X in te)Object.prototype.hasOwnProperty.call(te,X)&&(pe[X]=te[X])}return pe},Le.apply(this,arguments)};Object.defineProperty(z,"__esModule",{value:!0}),z.redirectUrlIfPresent=z.ensureNumber=z.reconnectParamsWithoutUrls=z.adaptUrl=z.isV4ConnectEvent=z.usedProtocolAfterFallback=z.usedProtocol=void 0,z.usedProtocol=j,z.usedProtocolAfterFallback=Z,z.isV4ConnectEvent=re,z.adaptUrl=ne,z.reconnectParamsWithoutUrls=le,z.ensureNumber=he,z.redirectUrlIfPresent=Me},function(L,z,H){Object.defineProperty(z,"__esModule",{value:!0}),z.TrouterFsm=z.State=void 0;var j,J=H(4),Z=H(0),re=H(5);(function(he){he[he.Initial=0]="Initial",he[he.RetrievingToken=1]="RetrievingToken",he[he.Allocating=2]="Allocating",he[he.Handshaking=3]="Handshaking",he[he.Connecting=4]="Connecting",he[he.AnonymousConnecting=5]="AnonymousConnecting",he[he.WebsocketAuthenticating=6]="WebsocketAuthenticating",he[he.Connected=7]="Connected",he[he.Unregistering=8]="Unregistering",he[he.TerminalError=9]="TerminalError"})(j||(z.State=j={}));var ne;(function(he){he[he.Initial=0]="Initial",he[he.Registering=1]="Registering",he[he.RegisteringButResendPending=2]="RegisteringButResendPending",he[he.Retrying=3]="Retrying",he[he.Registered=4]="Registered",he[he.RegistrationDisabled=5]="RegistrationDisabled"})(ne||(ne={}));var le=function(){function he(Me,Le,pe,te){this.worker=Le,this.incallModeEnabled=pe,this.protocolSelector=te,this.state=j.Initial,this.autoReconnect=!0,this.logger=new Z.Logger("ConnectionFsm",Me),this.registrationState=ne.Initial}return he.prototype.getState=function(){return this.state},he.prototype.isActive=function(){return this.state===j.Allocating||this.state===j.Connected||this.state===j.Handshaking||this.state===j.Connecting||this.state===j.RetrievingToken||this.state===j.AnonymousConnecting||this.state===j.WebsocketAuthenticating},he.prototype.isConnecting=function(){return this.state===j.Allocating||this.state===j.Handshaking||this.state===j.Connecting||this.state===j.AnonymousConnecting},he.prototype.start=function(){return this.state===j.Initial?(this.setState(j.RetrievingToken),this.worker.getToken(!0,!1,void 0),!0):(this.showIgnored("start"),!1)},he.prototype.stop=function(Me,Le){Me&&(this.registrationState=ne.Initial),this.worker.isIncallMode()&&this.worker.exitIncallMode(),this.worker.resetTokenBackoff(),this.worker.cancelPendingRegistrationRequests(),this.worker.stopConnectionTimer(),this.worker.stopPingTimer(),this.worker.clearSentEventTimers(),this.worker.stopRegistrationTimer(),this.worker.stopSocketIo(),this.state===j.Connected&&this.worker.sendDisconnectTelemetryEvent("connection stopped"),this.registrationState!==ne.Registered&&this.registrationState!==ne.Registering&&this.registrationState!==ne.RegisteringButResendPending||this.state===j.Unregistering?Le?(this.setState(j.TerminalError),this.worker.dispatchTerminalError()):(this.setState(j.Initial),this.worker.dispatchDisconnected()):(this.registrationState=ne.Initial,this.setState(j.Unregistering),this.worker.sendUnregisterRequest())},he.prototype.onTokenReceived=function(Me,Le,pe){this.state===j.RetrievingToken?(0,re.usedProtocolAfterFallback)(this.protocolSelector(Me.tokenType,pe),Le)==="v4c"?(this.setState(j.AnonymousConnecting),this.worker.startConnectionTimer(),this.worker.connectV4c(Me,Le)):(this.setState(j.Allocating),this.worker.startConnectionTimer(),this.worker.sendAllocateRequest(Me)):this.showIgnored("onTokenReceived")},he.prototype.checkConnection=function(Me){Me&&this.onPingInterval()},he.prototype.onAllocationSucceed=function(Me){return this.state===j.Allocating&&this.registrationState===ne.Registered&&this.worker.dispatchUnregistered(),this.state===j.Allocating?(this.setState(j.Handshaking),this.registrationState=ne.Initial,this.worker.startSocketIo(Me),!0):(this.showIgnored("onAllocationSucceed"),!1)},he.prototype.onAllocationFailed=function(Me,Le){this.state===j.Allocating?this.cleanUpAndInitiateReconnect({backoff:!0,allowCachedToken:!Me,claimsChallenge:Le}):this.showIgnored("onAllocationFailed")},he.prototype.onV4cException=function(){this.state!==j.AnonymousConnecting&&this.state!==j.WebsocketAuthenticating||(this.logger.error("v4c exception, falling back to longpoll"),this.cleanUpAndInitiateReconnect({backoff:!0,allowCachedToken:!0,fallbackReason:{kind:"v4c-websocket-failure"}}))},he.prototype.onConnectingTimeout=function(){this.state===j.Allocating||this.state===j.Connecting||this.state===j.Handshaking||this.state===j.AnonymousConnecting||this.state===j.WebsocketAuthenticating?this.cleanUpAndInitiateReconnect({backoff:!1,allowCachedToken:!0}):this.showIgnored("onConnectingTimeout")},he.prototype.onConnecting=function(){this.state===j.Handshaking?this.setState(j.Connecting):this.showIgnored("onConnecting")},he.prototype.onSocketConnect=function(Me){this.state===j.AnonymousConnecting?(this.setState(j.WebsocketAuthenticating),this.worker.sendV4cAuthenticationEvent(Me)):this.showIgnored("onSocketConnect")},he.prototype.onConnectingFailed=function(){this.state===j.Connecting?this.onConnectingTimeout():this.state===j.Handshaking?(this.logger.error("Unexpected error in Socket.io - no valid transports"),this.onConnectingTimeout()):this.state===j.AnonymousConnecting||this.state===j.WebsocketAuthenticating?(this.logger.info("/v4/c falling back to longpoll"),this.cleanUpAndInitiateReconnect({backoff:!0,allowCachedToken:!0,fallbackReason:{kind:"v4c-websocket-failure"}})):this.showIgnored("onConnectingFailed")},he.prototype.onSocketDisconnect=function(Me){this.state===j.Handshaking||this.state===j.Connected||this.state===j.WebsocketAuthenticating?(this.state===j.Connected&&this.worker.sendDisconnectTelemetryEvent(Me?.toTelemetryString()),this.state===j.WebsocketAuthenticating&&this.worker.countDisconnectBeforeConnectionEstablishment(),Me?.reason==="skypetoken-deprecated"?(this.logger.error("Skypetoken deprecated response, not retrying any further"),this.onTerminalError()):this.cleanUpAndInitiateReconnect({backoff:this.state!==j.Connected&&Me?.reason!=="dup",allowCachedToken:Me?.reason!=="unauthorized",claimsChallenge:Me?.claims})):this.showIgnored("onSocketDisconnect")},he.prototype.onTrouterConnected=function(){this.state===j.Connecting||this.state===j.WebsocketAuthenticating?(this.setState(j.Connected),this.worker.resetTokenBackoff(),this.worker.stopConnectionTimer(),this.worker.sendUserActivityState(J.UserActivityEventReason.Connected,!0),this.worker.startPingTimer(),this.worker.dispatchConnected(),this.worker.shouldSkipRegistration()?(this.registrationState=ne.RegistrationDisabled,this.worker.dispatchRegistered()):(this.registrationState=ne.Registering,this.worker.sendRegisterRequest())):this.showIgnored("onTrouterConnected")},he.prototype.onReconnectRequired=function(Me,Le,pe){this.state===j.AnonymousConnecting||this.state===j.WebsocketAuthenticating?pe===void 0||pe.target!=="host"||pe.url===void 0||pe.url===""?(this.logger.error("unexpected reconnect arguments: ".concat(pe?.target," ").concat(pe?.url,", reconnecting without cache")),this.cleanUpAndInitiateReconnect({backoff:!0,allowCachedToken:!0,fallbackReason:{kind:"redirect-no-host"}})):this.cleanUpAndInitiateReconnect({backoff:!0,allowCachedToken:!0,fallbackReason:{kind:"redirect",host:pe.url}}):this.worker.dispatchReconnectIsRequired(Me,Le)},he.prototype.disableAutoReconnect=function(){this.autoReconnect=!1},he.prototype.onDownstreamRequest=function(Me){this.state===j.Connected?(this.switchToIncallModeIfEnabled(),this.worker.dispatchDownstreamRequest(Me)):this.showIgnored("onDownstreamRequest")},he.prototype.onTrouterMessageLost=function(Me){this.state===j.Connected?this.worker.dispatchTrouterMessageLost(Me):this.showIgnored("onTrouterMessageLost")},he.prototype.onPingInterval=function(){this.state===j.Connected?this.worker.sendPingRequest():this.showIgnored("onPingInterval")},he.prototype.onPingResponseTimeout=function(){this.onMissedResponse("onPingResponseTimeout")},he.prototype.onPingResponse=function(){this.state===j.Connected||this.showIgnored("onPingResponse")},he.prototype.onRegistrationFailed=function(){this.state===j.Connected&&this.registrationState===ne.Registering?(this.worker.dispatchUnregistered(),this.registrationState=ne.Retrying,this.worker.startRegistrationRetryTimer()):this.state===j.Connected&&this.registrationState===ne.RegisteringButResendPending?(this.registrationState=ne.Registering,this.worker.sendRegisterRequest()):this.showIgnored("onRegistrationFailed")},he.prototype.onRetryRegistration=function(){this.state===j.Connected&&this.registrationState===ne.Retrying?(this.registrationState=ne.Registering,this.worker.sendRegisterRequest()):this.showIgnored("onRetryRegistration")},he.prototype.onRegistrationSucceeded=function(){this.state===j.Connected&&this.registrationState===ne.Registering?(this.registrationState=ne.Registered,this.worker.dispatchRegistered(),this.worker.startRegistrationTimer()):this.state===j.Connected&&this.registrationState===ne.RegisteringButResendPending?(this.registrationState=ne.Registering,this.worker.sendRegisterRequest()):this.showIgnored("onRegistrationSucceeded")},he.prototype.onRegistrationNearExpiry=function(){this.state===j.Connected&&this.registrationState===ne.Registered?(this.registrationState=ne.Registering,this.worker.sendRegisterRequest()):this.showIgnored("onRegistrationNearExpiry")},he.prototype.onUnregistrationDone=function(){this.state===j.Unregistering?(this.setState(j.Initial),this.worker.dispatchUnregistered(),this.worker.dispatchDisconnected()):this.showIgnored("onUnregistrationDone")},he.prototype.onResendRegistration=function(){this.worker.dispatchUnregistered(),this.state===j.Connected&&this.registrationState===ne.Registered?(this.registrationState=ne.Registering,this.worker.stopRegistrationTimer(),this.worker.sendRegisterRequest()):this.state===j.Connected&&this.registrationState===ne.Registering&&(this.registrationState=ne.RegisteringButResendPending)},he.prototype.onIncallModeTimer=function(){this.worker.exitIncallMode(),this.state===j.Connected?(this.worker.stopPingTimer(),this.worker.startPingTimer()):this.showIgnored("onIncallModeTimer")},he.prototype.onSetNewUserActivityState=function(){this.worker.sendUserActivityState(J.UserActivityEventReason.Modified,this.state===j.Connected)},he.prototype.onActivityStateResponseTimeout=function(){this.onMissedResponse("onActivityStateResponseTimeout")},he.prototype.forceReconnect=function(Me){this.state===j.Connected&&this.worker.sendDisconnectTelemetryEvent(Me),this.worker.resetTokenBackoff(),this.cleanUpAndInitiateReconnect({backoff:!1,allowCachedToken:!0})},he.prototype.onTerminalError=function(){this.logger.error("Cannot proceed, reached terminal state. Switching from state '".concat(j[this.state],"' to ").concat(j[j.TerminalError])),this.stop(!0,!0),this.setState(j.TerminalError)},he.prototype.onMissedResponse=function(Me){this.state===j.Connected?(this.worker.sendDisconnectTelemetryEvent(Me),this.cleanUpAndInitiateReconnect({backoff:!1,allowCachedToken:!0})):this.showIgnored(Me)},he.prototype.showIgnored=function(Me){this.logger.debug("Ignoring event '".concat(Me,"' in state '").concat(j[this.state],"'"))},he.prototype.setState=function(Me){if(this.logger.info("Switching from state '".concat(j[this.state],"' to state '").concat(j[Me],"'")),this.state===Me)return void this.logger.error("Attempt to switch to the current state '".concat(j[Me],"'"));this.state=Me},he.prototype.switchToIncallModeIfEnabled=function(){this.incallModeEnabled&&(this.worker.isIncallMode()||(this.worker.enterIncallMode(),this.worker.stopPingTimer(),this.worker.startPingTimer()),this.worker.restartIncallModeTimer())},he.prototype.cleanUpAndInitiateReconnect=function(Me){if(!this.autoReconnect)return this.logger.info("Automatic reconnect is disabled, stopping this connection"),void this.stop(!0);this.worker.cancelPendingRegistrationRequests(),this.worker.stopConnectionTimer(),this.worker.stopPingTimer(),this.worker.clearSentEventTimers(),this.worker.stopRegistrationTimer(),this.worker.stopSocketIo(),this.setState(j.RetrievingToken),this.worker.dispatchReconnecting(),this.worker.getToken(Me.allowCachedToken,Me.backoff,Me.claimsChallenge,Me.fallbackReason)},he}();z.TrouterFsm=le},function(L,z,H){function j(it,Ke){var ot=Ke?void 0:{"X-MS-Migration":"True"};switch(it.tokenType.toLowerCase()){case"skype":return ne({"X-Skypetoken":it.token},ot);case"aad":case"cae":return ne({Authorization:"Bearer ".concat(it.token)},ot);default:throw new Error("unsupported token type: ".concat(it.tokenType))}}function J(it){return it!=null&&typeof it.toString=="function"?it.toString():"[".concat(typeof it,"]")}function Z(it){return typeof it=="object"&&it!==null&&it.stack!==void 0?(0,pe.toJson)(it.stack):'"(no error.stack)"'}function re(it){return typeof it=="object"&&it!==null&&typeof it.message=="string"?it.message:"(no error.message)"}var ne=this&&this.__assign||function(){return ne=Object.assign||function(it){for(var Ke,ot=1,Ht=arguments.length;ot<Ht;ot++){Ke=arguments[ot];for(var jt in Ke)Object.prototype.hasOwnProperty.call(Ke,jt)&&(it[jt]=Ke[jt])}return it},ne.apply(this,arguments)},le=this&&this.__awaiter||function(it,Ke,ot,Ht){function jt(Nt){return Nt instanceof ot?Nt:new ot(function(Vt){Vt(Nt)})}return new(ot||(ot=Promise))(function(Nt,Vt){function $t(kt){try{yt(Ht.next(kt))}catch(je){Vt(je)}}function dt(kt){try{yt(Ht.throw(kt))}catch(je){Vt(je)}}function yt(kt){kt.done?Nt(kt.value):jt(kt.value).then($t,dt)}yt((Ht=Ht.apply(it,Ke||[])).next())})},he=this&&this.__generator||function(it,Ke){function ot(yt){return function(kt){return Ht([yt,kt])}}function Ht(yt){if(jt)throw new TypeError("Generator is already executing.");for(;$t&&($t=0,yt[0]&&(dt=0)),dt;)try{if(jt=1,Nt&&(Vt=2&yt[0]?Nt.return:yt[0]?Nt.throw||((Vt=Nt.return)&&Vt.call(Nt),0):Nt.next)&&!(Vt=Vt.call(Nt,yt[1])).done)return Vt;switch(Nt=0,Vt&&(yt=[2&yt[0],Vt.value]),yt[0]){case 0:case 1:Vt=yt;break;case 4:return dt.label++,{value:yt[1],done:!1};case 5:dt.label++,Nt=yt[1],yt=[0];continue;case 7:yt=dt.ops.pop(),dt.trys.pop();continue;default:if(Vt=dt.trys,!(Vt=Vt.length>0&&Vt[Vt.length-1])&&(yt[0]===6||yt[0]===2)){dt=0;continue}if(yt[0]===3&&(!Vt||yt[1]>Vt[0]&&yt[1]<Vt[3])){dt.label=yt[1];break}if(yt[0]===6&&dt.label<Vt[1]){dt.label=Vt[1],Vt=yt;break}if(Vt&&dt.label<Vt[2]){dt.label=Vt[2],dt.ops.push(yt);break}Vt[2]&&dt.ops.pop(),dt.trys.pop();continue}yt=Ke.call(it,dt)}catch(kt){yt=[6,kt],Nt=0}finally{jt=Vt=0}if(5&yt[0])throw yt[1];return{value:yt[0]?yt[1]:void 0,done:!0}}var jt,Nt,Vt,$t,dt={label:0,sent:function(){if(1&Vt[0])throw Vt[1];return Vt[1]},trys:[],ops:[]};return $t={next:ot(0),throw:ot(1),return:ot(2)},typeof Symbol=="function"&&($t[Symbol.iterator]=function(){return this}),$t};Object.defineProperty(z,"__esModule",{value:!0}),z.TrouterConnection=z.ReconnectReason=void 0;var Me,Le=H(21),pe=H(3),te=H(15),Se=H(1),ce=H(16),X=H(17),ve=H(2),Te=H(4),Be=H(0),qe=H(5),Ge=H(6),tt=H(12),ct=function(){function it(){this.cv=Se.CLIENT_VERSION,this.ua="",this.hr="",this.v=""}return it}(),Mt=function(){function it(){this["force new connection"]=!0,this.reconnect=!1,this.query="",this.ackTimeoutMs=5e3}return it.prototype.rewriteUrlForProxy=function(Ke){return Ke},it}(),ht="MS-CV",vt=function(){function it(Ke,ot){this.logger=ot,this.cvCounter=0;var Ht=JSON.parse(Ke);this.startTS=this.safeJsonNumber(Ht,"startTS",0),this.url=this.safeJsonString(Ht,"url",""),this.shortUrl=this.safeJsonString(Ht,"shortUrl",""),this.body=this.safeJsonString(Ht,"body",""),this.headers=this.safeJsonRecord(Ht,"headers",{}),this.id=this.safeJsonNumber(Ht,"id",-1),this.method=this.safeJsonString(Ht,"method",""),this.replied=!1,this.timedout=!1,this.receivedCv=this.headers[ht],this.updateCvHeader()}return Object.defineProperty(it.prototype,"correlationVector",{get:function(){return this.receivedCv?"".concat(this.receivedCv,".").concat(this.cvCounter):""},enumerable:!1,configurable:!0}),it.prototype.on=function(Ke,ot){Ke==="data"?this.dataCallback=ot:Ke==="end"&&(typeof this.dataCallback=="function"&&this.dataCallback(this.body),ot())},it.prototype.incrementCorrelationVector=function(){++this.cvCounter,this.updateCvHeader()},it.prototype.updateCvHeader=function(){var Ke=this.correlationVector;Ke&&(this.headers[ht]=Ke)},it.prototype.safeJsonNumber=function(Ke,ot,Ht){var jt;if(Ke!=null&&Object.prototype.hasOwnProperty.call(Ke,ot)){var Nt=Ke;if(typeof Nt[ot]=="number")return Nt[ot];if(typeof Nt[ot]=="string")return parseFloat(Nt[ot]);(jt=this.logger)===null||jt===void 0||jt.warn("unexpected type of '".concat(ot,"': ").concat(typeof Nt[ot]))}return Ht},it.prototype.safeJsonString=function(Ke,ot,Ht){var jt;if(Ke!=null&&Object.prototype.hasOwnProperty.call(Ke,ot)){var Nt=Ke;if(typeof Nt[ot]=="string")return Nt[ot];(jt=this.logger)===null||jt===void 0||jt.warn("unexpected type of '".concat(ot,"': ").concat(typeof Nt[ot]))}return Ht},it.prototype.safeJsonRecord=function(Ke,ot,Ht){var jt;if(Ke!=null&&Object.prototype.hasOwnProperty.call(Ke,ot)){var Nt=Ke;if(typeof Nt[ot]=="object")return Nt[ot];(jt=this.logger)===null||jt===void 0||jt.warn("unexpected type of '".concat(ot,"': ").concat(typeof Nt[ot]))}return Ht},it}(),Pt=function(){function it(Ke,ot,Ht){this.request=Ke,this.responseData=ot,this.sendResponse=Ht}return it.prototype.writeHead=function(Ke,ot){this.responseData.status=Ke,this.responseData.headers=ot},it.prototype.write=function(Ke){this.responseData.body+=Ke},it.prototype.end=function(Ke){return Ke&&(this.responseData.body+=Ke),this.sendResponse(this.request,this.responseData)},it}(),ni=function(){function it(Ke){this.name=Ke,this.args={},this.timeoutTimerId=0}return it}();(function(it){it[it.Configuration=0]="Configuration",it[it.ServerInitiated=1]="ServerInitiated"})(Me||(z.ReconnectReason=Me={}));var Zt=function(){function it(Ke,ot,Ht,jt,Nt,Vt,$t,dt){var yt,kt=this;this.options=ot,this.manager=Ht,this.tokenProvider=jt,this.usingLegacyTokenApi=Nt,this.protocolSelector=$t,this.audienceSubscriptionState=dt,this.WEBSOCKET_TRANSPORT_NAME="websocket",this.XHR_POLLING_TRANSPORT_NAME="xhr-polling",this.AUDIENCE_SUBSCRIPTION_RESULT_ERROR="Error",this.AUDIENCE_SUBSCRIPTION_RESULT_UNSUBSCRIBED="Unsubscribed",this.AUDIENCE_SUBSCRIPTION_RESULT_TIMEOUT="Timeout",this.AUDIENCE_SUBSCRIPTION_RESULT_BAD_REQUEST="BadRequest",this.AUDIENCE_SUBSCRIPTION_STATE_QUERY_PARAM_REGEX=/&audienceSubscriptionState=[^&]*|^audienceSubscriptionState=[^&]*&?/,this.connectionId="",this.inIncallMode=!1,this.connectionAttempt=0,this.connectedClientId="",this.isNavigatorOnline=!0,this.onNavigatorOnlineStatusUpdateBound=this.onNavigatorOnlineStatusUpdate.bind(this),this.c2cUrlBase="",this.connectingErrorsInRow=0,this.unauthorizedErrorCount=0,this.pendingSentEventTimers={},this.lastDisconnectReason="",this.UNKNOWN_TRANSPORT="unknown_transport",this.connectingErrorsThreshold=3,this.pendingAudienceSubscription=void 0,this.logger=new Be.Logger("Connection",Ke),this.timeoutOptions=this.options.timeoutOptions,this.tokenBackoff=new X.ExponentialBackoff(this.logger,this.timeoutOptions.maxBackoffMs),this.clientID=Date.now(),typeof window<"u"&&window.location&&(this.domId=window.location.hostname);var je=new ct;je.cv=Se.CLIENT_VERSION,je.ua="",!((yt=this.options)===null||yt===void 0)&&yt.clientInfo&&(je.ua=this.safeString(this.options.clientInfo.ua),je.v=this.safeString(this.options.clientInfo.v)),this.clientInfo=je,this.connectionTracker=new te.ConnectionTracker(Ke,this.clientID,this.clientInfo,function(){return kt.getServerState()},this.options.endpointId,this.options.clientCorrelationID,this.options.environment),this.applyConnectionTrackerOptions(ot);var Ae=this.options.incallModeTimeoutMs>0;if(this.fsm=new Ge.TrouterFsm(Ke,this,Ae,this.protocolSelector),ot.registration){var xe={registrarUrl:ot.registration.registrarUrl,proxyUrlRewrite:ot.rewriteUrlForProxy,registrationId:ot.registration.registrationId,requestTimeoutMs:ot.timeoutOptions.fetchTimeoutMs,initialRetryDelayMs:1e3,maxRetryDelayMs:ot.timeoutOptions.maxBackoffMs,usingLegacyTokenApi:this.usingLegacyTokenApi,maxRetriesForGetToken:ot.retryLimitOnTokenFetch,extraRegistrationHeaders:ot.extraConnectionHeaders};this.registrarClient=(0,Le.createRegistrarClient)(Ke,this.tokenProvider,xe)}this.userActivityState=Vt}return it.prototype.start=function(Ke){this.logger.info("Starting"),this.reconnectParams=Ke,typeof window<"u"&&window.navigator&&window.addEventListener?(this.isNavigatorOnline=window.navigator.onLine,window.addEventListener("online",this.onNavigatorOnlineStatusUpdateBound),window.addEventListener("offline",this.onNavigatorOnlineStatusUpdateBound),this.logger.debug("Registered for browser online notifications - current state: ".concat(this.isNavigatorOnline))):this.isNavigatorOnline=!0,this.fsm.start()},it.prototype.stop=function(Ke){this.logger.info("Stopping"),typeof window<"u"&&window.navigator&&(window.removeEventListener("online",this.onNavigatorOnlineStatusUpdateBound),window.removeEventListener("offline",this.onNavigatorOnlineStatusUpdateBound)),this.fsm.stop(Ke),this.connectionTracker.close()},it.prototype.configure=function(Ke){var ot=this.options.trouterUrl!==Ke.trouterUrl;this.options=Ke,this.applyConnectionTrackerOptions(Ke),ot&&(this.logger.info("Configuration changed. Reconnection required."),this.fsm.onReconnectRequired(!1,Me.Configuration))},it.prototype.checkConnection=function(Ke){this.logger.info("checkConnection called with ".concat(Ke)),this.fsm.checkConnection(Ke),Ke&&this.connectionTracker.sendTelemetry(te.ClientEventName.CheckConnection,{disconnectDetected:Ke},[])},it.prototype.disableRegistrationsAndAutoReconnect=function(){this.stopRegistrationTimer(),this.cancelPendingRegistrationRequests(),this.fsm.disableAutoReconnect()},it.prototype.getServerState=function(){return new Te.ServerState(this.connectionId,this.connectedClientId,this.domId?this.domId:"",this.allocateResult?this.allocateResult.url:"",this.allocateResult?this.allocateResult.surl:"",this.c2cUrlBase,this.connectionExpireTimestampInSecs)},it.prototype.getState=function(){return this.fsm.getState()},it.prototype.getToken=function(Ke,ot,Ht,jt,Nt){var Vt=this;Nt===void 0&&(Nt=0),this.logger.info("Getting token ".concat(ot?"with backoff":"without backoff"));var $t=function(){Vt.connectionTracker.trackStart("token");var dt={needFresh:!Ke,wwwAuthenticateHeader:Ht,supportedTokenTypes:Se.SUPPORTED_TOKEN_TYPES,purpose:"trouter"};Vt.logger.info("Requesting token: needFresh=".concat(dt.needFresh," ")+"types=[".concat(Se.SUPPORTED_TOKEN_TYPES,"], ")+"wwwAuthenticateHeader is ".concat(dt.wwwAuthenticateHeader?"non empty":"empty")),Vt.tokenProvider(dt).then(function(yt){Vt.logger.debug("".concat(yt.tokenType," token is received")),Vt.connectionTracker.trackEnd("token"),Vt.fsm.onTokenReceived(yt,jt,Vt.reconnectParams)}).catch(function(yt){var kt=(0,pe.toJson)(yt.stack);if(Vt.logger.error("Getting token failed, will retry after timeout. Error: ".concat(kt)),Vt.connectionTracker.trackError("token",kt),!Vt.canRetryTokenFetchRequest(Nt+Vt.unauthorizedErrorCount))return Vt.connectionTracker.trackError("token","getToken retry limit hit, reached terminal error state"),Vt.resetTokenBackoff(),void Vt.fsm.onTerminalError();Vt.getToken(Ke,!0,Ht,jt,Nt+1)})};ot?this.tokenBackoff.backoff("getting token",$t):(this.resetTokenBackoff(),$t())},it.prototype.startConnectionTimer=function(){var Ke=this;this.stopConnectionTimer(),this.logger.debug("Starting connection timeout for ".concat(this.timeoutOptions.connectionTimeoutMs," ms")),this.connectionTimeoutId=setTimeout(function(){Ke.logger.info("Connection timeout is fired"),Ke.fsm.onConnectingTimeout()},this.timeoutOptions.connectionTimeoutMs)},it.prototype.stopConnectionTimer=function(){this.connectionTimeoutId&&(this.logger.debug("Stopping connection timeout"),clearTimeout(this.connectionTimeoutId),this.connectionTimeoutId=void 0)},it.prototype.startPingTimer=function(){var Ke=this;this.transportTypeName==="websocket"?(this.logger.debug("Starting ping timeout for ".concat(this.timeoutOptions.pingTimeoutMs," ms")),this.pingTimerId=setInterval(function(){Ke.logger.info("Ping interval fired"),Ke.fsm.onPingInterval()},this.timeoutOptions.pingTimeoutMs)):this.logger.debug("Not starting ping for transport ".concat(this.transportTypeName))},it.prototype.stopPingTimer=function(){this.pingTimerId&&(this.logger.debug("Stopping ping timeout"),this.clearPingResponseTimer(),clearInterval(this.pingTimerId),this.pingTimerId=void 0)},it.prototype.shouldSkipRegistration=function(){return this.options.registration===void 0},it.prototype.hasCustomRegistrationTtl=function(){var Ke,ot;return((Ke=this.options.registration)===null||Ke===void 0?void 0:Ke.registrarTtlSec)!==void 0&&((ot=this.options.registration)===null||ot===void 0?void 0:ot.registrarTtlSec)!==0},it.prototype.startRegistrationTimer=function(){var Ke=this;this.stopRegistrationTimer();var ot=this.getRegistrationTtl(),Ht=ot[0],jt=ot[1];if(Ht<=30||!jt)return this.logger.debug("Starting registration expiration timer (TTL ".concat(Ht," sec)")),void(this.registrationTimerId=setTimeout(function(){Ke.registrationTimerId=void 0,Ke.logger.warn("Registration expired but the connection is still alive. Should never happen"),Ke.dispatchUnregistered()},1e3*Ht));var Nt=Ht-30;this.logger.debug("Starting registration extension timer for ".concat(Nt," sec")),this.registrationTimerId=setTimeout(function(){Ke.logger.info("Registration extension timer fired"),Ke.registrationTimerId=setTimeout(function(){Ke.registrationTimerId=void 0,Ke.logger.debug("Registration extension did not happen in time"),Ke.dispatchUnregistered()},3e4),Ke.fsm.onRegistrationNearExpiry()},1e3*Nt)},it.prototype.startRegistrationRetryTimer=function(){var Ke=this;this.stopRegistrationTimer(),this.registrationTimerId=setTimeout(function(){Ke.registrationTimerId=void 0,Ke.fsm.onRetryRegistration()},123e3)},it.prototype.stopRegistrationTimer=function(){this.registrationTimerId&&(this.logger.debug("Stopping registration timeout"),clearTimeout(this.registrationTimerId),this.registrationTimerId=void 0)},it.prototype.resendRegistration=function(){if(!this.registrarClient)throw new Error("Trouter Client not configured to handle registrations");return this.fsm.onResendRegistration(),Promise.resolve()},it.prototype.buildSocketIoUrlParams=function(Ke,ot){if(!this.allocateResult)throw new Error("Allocate result is undefined in buildSocketIoUrlParams()");for(var Ht={},jt=this.allocateResult.connectparams,Nt=0,Vt=Object.keys(jt);Nt<Vt.length;Nt++){var $t=Vt[Nt];if(jt[$t]!==void 0){var dt=jt[$t];typeof dt=="string"||typeof dt=="number"?Ht[$t]=dt:this.logger.error("signatureData[".concat($t,"] has unsupported type ").concat(typeof dt))}}return Ht.v="v4",Ht.tc=encodeURI((0,pe.toJson)(this.clientInfo)),Ht.timeout=this.timeoutOptions.pingTimeoutMs/1e3,Ht.auth="true",this.options.endpointId&&(Ht.epid=this.options.endpointId),Ke&&(Ht.userActivity=encodeURI((0,pe.toJson)(Ke))),ot&&(Ht.audienceSubscriptionState=encodeURIComponent((0,pe.toJson)(ot))),this.appendConnectedClientIds(this.buildQuery(Ht),!0)},it.prototype.startSocketIo=function(Ke){var ot,Ht;if(this.logger.debug("Starting socket io"),this.connectionTracker.trackStart("connectSocket"),!this.allocateResult)throw new Error("Allocate result is undefined in startSocketIo()");var jt=this.options.ioOptions?ne({},this.options.ioOptions):new Mt,Nt=this.userActivityState.state!==ve.UserActivityState.Unknown?this.userActivityState.increaseCvAndGetEventObject():void 0,Vt=(ot=this.audienceSubscriptionState)===null||ot===void 0?void 0:ot.increaseCvAndGetEventObject();if(jt["force new connection"]=!0,jt.reconnect=!1,jt.rewriteUrlForProxy=this.options.rewriteUrlForProxy,jt.requestHeaders=ne(ne({},this.options.extraConnectionHeaders),j(Ke,this.usingLegacyTokenApi)),jt.query=this.buildSocketIoUrlParams(Nt,Vt),this.logger.info("connecting to ".concat(this.allocateResult.socketio,"?").concat(jt.query)),this.stopSocketIo(),this.socket=((Ht=this.options.io)!==null&&Ht!==void 0?Ht:tt).connect(this.allocateResult.socketio,jt),this.socket===void 0)throw new Error("Can't create Socket.io object");this.attachSocketIoHandlers(this.socket,Ke,Nt,Vt)},it.prototype.stopSocketIo=function(){if(this.socket){this.logger.debug("clearing socket.io");try{for(var Ke=0,ot=["connecting","connect","connect_failed","close_during_connecting","disconnect","reconnect","reconnect_failed","reconnecting","error","message","trouter.connected","trouter.reconnect","trouter.message_loss"];Ke<ot.length;Ke++){var Ht=ot[Ke];this.socket.removeAllListeners(Ht)}this.socket.disconnect(),this.logger.debug("cleared socket"),this.socket=void 0}catch(jt){this.logger.error("exception in disconnecting previous socket. Error: ".concat(Z(jt)))}}},it.prototype.dispatchConnected=function(){this.logger.info("dispatching connected"),this.manager.onConnected(this)},it.prototype.dispatchRegistered=function(){this.logger.info("dispatching registered"),this.manager.onRegistered(this)},it.prototype.dispatchUnregistered=function(){this.logger.info("dispatching unregistered"),this.manager.onUnregistered(this)},it.prototype.dispatchDownstreamRequest=function(Ke){var ot=this;this.logger.debug("dispatching downstream request");try{var Ht=new Pt(Ke,new te.ResponseData(Ke.id),function(jt,Nt){return ot.logger.debug("sending response to downstream"),ot.sendResponse(jt,Nt)});this.manager.onDownstreamRequest(this,Ke,Ht)}catch(jt){this.logger.error("exception in socket.on message. Error : ".concat(Z(jt)))}},it.prototype.dispatchReconnecting=function(){this.logger.info("dispatching reconnecting"),this.manager.onReconnecting(this)},it.prototype.dispatchReconnectIsRequired=function(Ke,ot){this.logger.info("dispatching reconnect is required by server"),this.manager.onReconnectIsRequired(this,Ke,ot)},it.prototype.dispatchDisconnected=function(){this.logger.info("dispatching disconnected"),this.manager.onDisconnected(this)},it.prototype.dispatchTerminalError=function(){this.logger.info("dispatching terminal error"),this.manager.onTerminalError(this)},it.prototype.dispatchTrouterMessageLost=function(Ke){this.logger.info("dispatching trouter message lost"),this.manager.onTrouterMessageLost(Ke)},it.prototype.countDisconnectBeforeConnectionEstablishment=function(){this.logger.warn("counting disconnect before connection was fully established as a connection failure"),++this.connectingErrorsInRow>=this.connectingErrorsThreshold&&this.resetReconnectParamsOnErrorThreshold()},it.prototype.sendProcessedDroppedIndicators=function(Ke){var ot=this;try{this.logger.debug("emitting processed flow tags to the server");var Ht=new ni("trouter.processed_message_loss");Ht.args={droppedIndicators:Ke},this.sendDownstreamEvent(Ht,function(){ot.logger.info("emitted processed flow tags to the server")})}catch(Nt){var jt=Z(Nt);this.logger.error("unable to send processed message loss event. Error: ".concat(jt)),this.connectionTracker.trackError("trouter.processed_message_loss",jt,!1)}},it.prototype.sendAllocateRequest=function(Ke){var ot=this;this.connectionAttempt++,this.connectionTracker.trackNewConnection();var Ht,jt=this.options.trouterUrl,Nt=this.reconnectParams,Vt=typeof Nt?.se=="string"?parseInt(Nt.se,10):typeof Nt?.se=="number"?Nt.se:void 0;Vt&&Vt<=Date.now()+36e5&&(this.logger.warn("Dropping expired cached connection parameters: ".concat(new Date(Vt))),this.reconnectParams=Nt=void 0),Nt&&Nt.serviceUrl!==jt&&(this.logger.warn("Dropping cached connection parameters for a different environment (".concat(Nt.serviceUrl,", now ").concat(jt,")")),this.reconnectParams=Nt=void 0),Nt?.reconnectUrl&&(jt=Nt.reconnectUrl),Ht=Nt?ne(ne({},Nt),{serviceUrl:void 0,reconnectUrl:void 0}):null,jt=(0,qe.adaptUrl)(jt,"v4a"),jt=this.appendCorrelationIds(jt,!1),jt=this.appendEndpointId(jt,!1),Ht&&(jt+="&".concat(this.buildQuery(Ht)),Ht.v||(jt+="&v=".concat("v4"))),jt=this.options.rewriteUrlForProxy(jt);var $t=new Request(jt,{method:"POST",mode:"cors",headers:new Headers(ne(ne({"Content-Type":"text/plain"},this.options.extraConnectionHeaders),j(Ke,this.usingLegacyTokenApi)))});this.logger.info("sendAllocateRequest: POST ".concat(jt)),this.connectionTracker.trackStart("allocation");var dt,yt=Date.now(),kt=-1,je=!1;(0,pe.fetchWithTimeout)($t,this.timeoutOptions.fetchTimeoutMs).then(function(Ae){var xe;if(kt=Ae.status,!Ae.ok)throw dt=(xe=Ae.headers.get("www-authenticate"))!==null&&xe!==void 0?xe:void 0,je=Ae.headers.get("x-trouter-skypetoken-deprecated")==="1",ot.logger.warn("Allocation request got response status ".concat(Ae.status,", www-authenticate header was ").concat(dt?"not empty":"empty")),new Error(Ae.statusText);var gt=Ae.headers.get("content-type");if(!gt||gt!=="application/json"&&!gt.startsWith("application/json;"))throw new Error("Content-type '".concat(gt,"' is unexpected"));return ot.connectionTracker.trackEnd("allocation"),Ae.json()}).then(function(Ae){ot.unauthorizedErrorCount=0,ot.onAllocationResponse(Ae,Ke)}).catch(function(Ae){ot.connectingErrorsInRow++;var xe="".concat(Ae).concat(kt>=0?", status code ".concat(kt):"");if(ot.logger.error("".concat(ot.connectingErrorsInRow," failed connecting attempt(s) in a row. ").concat(xe)),ot.connectionTracker.trackError("allocation",xe),je){var gt="Skypetoken deprecated response, not retrying any further";return ot.logger.error(gt),ot.connectionTracker.trackError("allocation",gt),void ot.fsm.onTerminalError()}if(kt===401&&ot.unauthorizedErrorCount++,!ot.canRetryTokenFetchRequest(ot.unauthorizedErrorCount)){var gt="getToken retry limit hit, reached terminal error state";return ot.connectionTracker.trackError("allocation",gt),void ot.fsm.onTerminalError()}if(kt!==-1||ot.isNavigatorOnline){if(ot.reconnectParams&&ot.connectingErrorsInRow>=ot.connectingErrorsThreshold){if(kt>=400&&kt<=599)ot.resetReconnectParamsOnErrorThreshold();else if(ot.reconnectParams.reconnectUrl&&ot.connectingErrorsInRow%3==0){ot.logger.warn("".concat(ot.connectingErrorsInRow," connection attempts, testing nominal service URL"));var Ye=Math.min(ot.timeoutOptions.connectionTimeoutMs-(Date.now()-yt)-500,ot.timeoutOptions.fetchTimeoutMs);return void ot.testNominalUrlConnectivity(Ye).then(function(Fe){ot.connectionTracker.trackProgress("nomcheck",Fe?"ok":"failed"),Fe?(ot.logger.warn("Nominal service URL is reachable, erasing cached reconnect URL"),ot.reconnectParams&&delete ot.reconnectParams.reconnectUrl):ot.logger.warn("Nominal service URL is not reachable either, keeping cached reconnect URL"),ot.fsm.onAllocationFailed(!1,void 0)},function(){ot.fsm.onAllocationFailed(!1,void 0)})}}}else ot.logger.info("Expected failure, the browser says it is not online at the moment");ot.fsm.onAllocationFailed(kt===401,dt)})},it.prototype.testNominalUrlConnectivity=function(Ke){var ot=this;if(Ke<1e3)return this.logger.warn("There is no time left to reasonably perform the nominal service URL connectivity check (".concat(Ke," ms), falling back to assuming that the connectivity is fine")),Promise.resolve(!0);var Ht;try{var jt=new URL(this.options.trouterUrl);jt.pathname="/",jt.search="?"+this.buildQuery({check:Date.now(),cor_id:encodeURIComponent(this.options.clientCorrelationID),epid:encodeURIComponent(this.options.endpointId?this.options.endpointId:""),tc:encodeURIComponent((0,pe.toJson)(this.clientInfo))}),Ht=new Request(this.options.rewriteUrlForProxy(jt.toString()),{method:"GET",headers:{Accept:"text/plain"}})}catch(Nt){return this.logger.warn("Nominal service URL connectivity test request could not be created (".concat(Nt,"), falling back to assuming that the connectivity is fine")),Promise.resolve(!0)}return(0,pe.fetchWithTimeout)(Ht,Ke).then(function(Nt){if(Nt.status!==200)throw new Error("Not 200 OK: ".concat(Nt.status," ").concat(Nt.statusText));return Nt.text()}).then(function(Nt){if(Nt!=="Trouter")throw new Error('Not "Trouter": '.concat(Nt.substring(0,16)).concat(Nt.length>16?"...":""));return!0}).catch(function(Nt){return ot.logger.error("Nominal service URL connectivity test failed: ".concat(Nt)),!1})},it.prototype.sendPingRequest=function(){var Ke=this;if(this.socket&&this.pingResponseTimerId===void 0)try{this.logger.debug("emitting ping event");var ot=!1;this.socket.emit("ping",function(){ot!==!0&&Ke.onPingResponse()}),this.pingResponseTimerId=setTimeout(function(){Ke.logger.error("Ping response timeout is fired"),ot=!0,Ke.clearPingResponseTimer(),Ke.fsm.onPingResponseTimeout()},this.timeoutOptions.pongTimeoutMs)}catch(jt){var Ht=Z(jt);this.logger.error("unable to send ping. Error: ".concat(Ht)),this.connectionTracker.trackError("ping",Ht,!1)}},it.prototype.connectV4c=function(Ke,ot){var Ht,jt,Nt,Vt,$t,dt,yt=this.options.ioOptions?ne({},this.options.ioOptions):new Mt;yt["force new connection"]=!0,yt.reconnect=!1,!((Ht=this.reconnectParams)===null||Ht===void 0)&&Ht.serviceUrl&&(0,qe.adaptUrl)(this.reconnectParams.serviceUrl,"v4c")!==(0,qe.adaptUrl)(this.options.trouterUrl,"v4c")&&(this.logger.warn("Dropping cached connection parameters for a different environment (".concat(this.reconnectParams.serviceUrl,", now ").concat(this.options.trouterUrl,")")),this.reconnectParams=void 0);var kt=(Vt=(jt=(0,qe.redirectUrlIfPresent)(ot))!==null&&jt!==void 0?jt:ot?.kind!=="redirect-no-host"?(Nt=this.reconnectParams)===null||Nt===void 0?void 0:Nt.reconnectUrl:void 0)!==null&&Vt!==void 0?Vt:this.options.trouterUrl,je=(0,qe.adaptUrl)(kt,"v4c");yt["skipped handshake data"]={timeout:70,websocketUrl:je},yt.query=this.buildV4cUrlParams(),yt.rewriteUrlForProxy=this.options.rewriteUrlForProxy;try{if(this.stopSocketIo(),this.transportTypeName="websocket",this.socket=(($t=this.options.io)!==null&&$t!==void 0?$t:tt).connect(this.options.trouterUrl,yt),this.socket===void 0)throw new Error("failed to create Socket.io object");var Ae=(dt=this.audienceSubscriptionState)===null||dt===void 0?void 0:dt.increaseCvAndGetEventObject();this.attachSocketIoHandlers(this.socket,Ke,void 0,Ae)}catch(xe){this.logger.error("".concat(xe)),this.connectionTracker.trackError("v4c","".concat(xe)),this.fsm.onV4cException()}},it.prototype.sendV4cAuthenticationEvent=function(Ke){var ot,Ht={headers:ne(ne({},this.options.extraConnectionHeaders),j(Ke,this.usingLegacyTokenApi)),connectparams:(0,qe.reconnectParamsWithoutUrls)(this.reconnectParams)};(ot=this.socket)===null||ot===void 0||ot.emit(Se.USER_AUTHENTICATE_EVENT_NAME,Ht)},it.prototype.setUserActivityState=function(Ke){var ot=Ke.state!==this.userActivityState.state;this.userActivityState=Ke,ot?(this.logger.info("Changing user activity state to '".concat(Ke.toEventJSON(),"'")),this.fsm.onSetNewUserActivityState()):(this.logger.debug("Not changing the same user activity state '".concat(Ke.toEventJSON(),"'")),this.manager.onUserActivityStateAccepted(Ke.correlationVector.value()))},it.prototype.sendUserActivityState=function(Ke,ot){this.userActivityState.state!==ve.UserActivityState.Unknown&&(this.transportTypeName==="websocket"&&ot?Ke===Te.UserActivityEventReason.Connected?this.sendUserActivityStateMultiple(2):this.sendUserActivityStateMultiple(1):this.transportTypeName==="xhr-polling"&&Ke===Te.UserActivityEventReason.Modified&&this.fsm.forceReconnect("user activity/force reconnect"))},it.prototype.setAudienceSubscriptionsAsync=function(Ke,ot){var Ht=this.audienceSubscriptionState;if(this.audienceSubscriptionState=Ke,this.transportTypeName===this.WEBSOCKET_TRANSPORT_NAME)return this.setAudienceSubscriptionsInternalAsync(Ke.increaseCvAndGetEventObject(),ot);if(this.transportTypeName===this.XHR_POLLING_TRANSPORT_NAME){var jt=this.setAudienceSubscriptionsLongpollInternalAsync(Ke.increaseCvAndGetEventObject(),ot,Ht);return this.fsm.forceReconnect("set audience subscription force reconnect"),jt}throw new Error("set audience subscription executed on an unknown transport")},it.prototype.setAudienceSubscriptionsUnsafeAsync=function(Ke){if(Ke)return this.transportTypeName===this.WEBSOCKET_TRANSPORT_NAME?this.setAudienceSubscriptionsInternalAsync(Ke,15e3):void 0},it.prototype.setAudienceSubscriptionsInternalAsync=function(Ke,ot){return le(this,void 0,void 0,function(){var Ht,jt,Nt=this;return he(this,function(Vt){switch(Vt.label){case 0:return this.logger.info("[WebSocket] Audience subscription set requested."),Ht=new ni("audience.subscribe"),Ht.args=Ke,[4,new Promise(function($t){var dt=!1,yt=setTimeout(function(){return dt=!0,$t(Nt.buildAudienceSubscriptionsTimeoutResponse(Ke))},ot);Nt.sendDownstreamEvent(Ht,function(kt,je){dt||(clearTimeout(yt),Nt.logger.debug("[Websocket] Audience subscription response: ".concat(je)),Nt.pendingAudienceSubscription&&Nt.onAudienceSubscriptionResult(je),$t(je))})})];case 1:return jt=Vt.sent(),this.manager.onAudiencesSetResolved(jt,Ke.cv),[2,jt]}})})},it.prototype.setAudienceSubscriptionsLongpollInternalAsync=function(Ke,ot,Ht){var jt;return le(this,void 0,void 0,function(){var Nt,Vt,$t,dt,yt,kt,je=this;return he(this,function(Ae){switch(Ae.label){case 0:return this.logger.info("[XHR Polling] Audience subscription set requested."),this.pendingAudienceSubscription&&(this.logger.error("Racing audience subscriptions occured. This situation resolves into undefined scenario and/or nasal demons."),clearTimeout(this.pendingAudienceSubscription.timeoutId)),Ke.audiences.length===0?[2,this.handleAudienceUnsubscribeLongpoll(Ke.cv,Ht)]:[4,new Promise(function(xe){var gt=setTimeout(function(){return je.pendingAudienceSubscription=void 0,xe(je.buildAudienceSubscriptionsTimeoutResponse(Ke))},ot);je.pendingAudienceSubscription={audienceSetResolve:xe,timeoutId:gt}})];case 1:return Nt=Ae.sent(),this.manager.getState()===ve.TrouterState.Unknown||this.transportTypeName===this.WEBSOCKET_TRANSPORT_NAME?[2,Nt]:(Vt=Nt.responses[0],Vt?.result.audienceSubscriptionState===this.AUDIENCE_SUBSCRIPTION_RESULT_BAD_REQUEST?(this.clearAudienceSubscriptionStateQueryParam(),this.manager.onAudiencesSetResolved(Nt,Ke.cv),[2,Nt]):($t=Nt.responses.find(function(xe){return xe.audienceId===Ke.audiences[0].id}),$t?.result.audienceSubscriptionState===this.AUDIENCE_SUBSCRIPTION_RESULT_ERROR?(this.clearAudienceSubscriptionStateQueryParam(),this.manager.onAudiencesSetResolved(Nt,Ke.cv),[2,Nt]):(dt=((jt=Ht?.audienceSubscriptionModel.audienceSubscriptions[0])===null||jt===void 0?void 0:jt.id)!==Vt?.audienceId,Ht&&dt&&(yt=this.mapToSyntheticAudienceSubscriptionResponses(Ht.audienceSubscriptionModel.audienceSubscriptions,this.AUDIENCE_SUBSCRIPTION_RESULT_UNSUBSCRIBED,200),(kt=Nt.responses).push.apply(kt,yt)),this.manager.onAudiencesSetResolved(Nt,Ke.cv),[2,Nt])))}})})},it.prototype.clearAudienceSubscriptionStateQueryParam=function(){var Ke,ot,Ht;!((Ht=(ot=(Ke=this.socket)===null||Ke===void 0?void 0:Ke.socket)===null||ot===void 0?void 0:ot.options)===null||Ht===void 0)&&Ht.query&&(this.socket.socket.options.query=this.socket.socket.options.query.replace(this.AUDIENCE_SUBSCRIPTION_STATE_QUERY_PARAM_REGEX,""))},it.prototype.handleAudienceUnsubscribeLongpoll=function(Ke,ot){var Ht;this.audienceSubscriptionState=void 0;var jt={responses:[]};if(ot){var Nt=this.mapToSyntheticAudienceSubscriptionResponses(ot.audienceSubscriptionModel.audienceSubscriptions,this.AUDIENCE_SUBSCRIPTION_RESULT_UNSUBSCRIBED,200);(Ht=jt.responses).push.apply(Ht,Nt)}return this.manager.onAudiencesSetResolved(jt,Ke),jt},it.prototype.buildAudienceSubscriptionsTimeoutResponse=function(Ke){return this.logger.error("Audience subscription attempt has timed out."),{responses:this.mapToSyntheticAudienceSubscriptionResponses(Ke.audiences,this.AUDIENCE_SUBSCRIPTION_RESULT_TIMEOUT)}},it.prototype.mapToSyntheticAudienceSubscriptionResponses=function(Ke,ot,Ht){return Ke.map(function(jt){return{audienceId:jt.id,result:{audienceSubscriptionState:ot,responseStatus:Ht}}})},it.prototype.expediteBackoff=function(){this.tokenBackoff.expediteIfPending()},it.prototype.sendRegisterRequest=function(){var Ke=this;if(!this.options.registration||!this.registrarClient)throw new Error("Internal error - options.registration is undefined");if(!this.allocateResult)throw new Error("Allocate result is undefined in sendRegisterRequest()");this.logger.info("sending register request");var ot=new pe.Timespan;this.connectionTracker.trackStart("registration");var Ht=this.getRegistrationTtl()[0];this.registrarClient.register({appId:this.options.registration.pnhAppId,aesKey:"",languageId:"en-US",platform:this.options.registration.platform,templateKey:this.options.registration.pnhTemplateKey,platformUIVersion:this.options.registration.platformUIVersion,productContext:this.options.registration.productContext},{TROUTER:[{context:this.options.registration.context,path:this.allocateResult.surl,ttl:Ht}]}).then(function(){Ke.logger.info("Register request successful"),Ke.connectionTracker.trackEnd("registration"),Ke.fsm.onRegistrationSucceeded(),Ke.connectionTracker.sendTelemetry(te.ClientEventName.Registration,{duration:ot.duration},[])}).catch(function(jt){Ke.logger.error("Register request failed. Error: ".concat(jt)),Ke.connectionTracker.trackError("registration",re(jt)),Ke.fsm.onRegistrationFailed(),Ke.connectionTracker.sendTelemetry(te.ClientEventName.Registration,{duration:ot.duration},[])})},it.prototype.sendUnregisterRequest=function(){var Ke=this;this.logger.info("sending unregister request");var ot=new pe.Timespan;if(!this.options.registration||!this.registrarClient)throw new Error("Internal error - options.registration is undefined");this.connectionTracker.trackStart("unregistration"),this.registrarClient.unregister().then(function(){Ke.logger.info("Unregister request successful"),Ke.connectionTracker.trackEnd("unregistration"),Ke.fsm.onUnregistrationDone(),Ke.connectionTracker.sendTelemetry(te.ClientEventName.Unregistration,{duration:ot.duration},[])}).catch(function(Ht){Ke.logger.error("Unregister request failed. Error: ".concat(Ht)),Ke.connectionTracker.trackError("unregistration",re(Ht)),Ke.fsm.onUnregistrationDone(),Ke.connectionTracker.sendTelemetry(te.ClientEventName.Unregistration,{duration:ot.duration},[])})},it.prototype.resetTokenBackoff=function(){this.tokenBackoff.reset()},it.prototype.cancelPendingRegistrationRequests=function(){this.registrarClient&&this.registrarClient.cancelPendingRequests()},it.prototype.clearSentEventTimers=function(){var Ke=Object.keys(this.pendingSentEventTimers);if(Ke.length>0){this.logger.debug("Clearing all pending downstream events related timers");for(var ot=0,Ht=Ke;ot<Ht.length;ot++){var jt=Ht[ot];this.clearSentEventTimer(Number(jt))}}},it.prototype.restartIncallModeTimer=function(){var Ke=this;this.clearIncallModeTimerId(),this.logger.debug("Restarting incall mode timer"),this.incallModeTimerId=setTimeout(function(){Ke.logger.info("Call mode timer fired"),Ke.fsm.onIncallModeTimer()},this.options.incallModeTimeoutMs)},it.prototype.enterIncallMode=function(){this.logger.info("Entering incall mode"),this.timeoutOptions=this.options.incallTimeoutOptions,this.tokenBackoff.setMaxBackoffMs(this.timeoutOptions.maxBackoffMs),this.inIncallMode=!0},it.prototype.exitIncallMode=function(){this.logger.info("Exiting incall mode"),this.clearIncallModeTimerId(),this.timeoutOptions=this.options.timeoutOptions,this.tokenBackoff.setMaxBackoffMs(this.timeoutOptions.maxBackoffMs),this.inIncallMode=!1},it.prototype.isIncallMode=function(){return this.inIncallMode},it.prototype.sendDisconnectTelemetryEvent=function(Ke){var ot={reason:Ke,serverClosed:!this.fsm.isActive()};this.connectionTracker.trackDisconnected(ot),this.connectionTracker.clearConnectedInfo()},it.prototype.forceReconnectDueToNoRegistration=function(){this.fsm.forceReconnect("force reconnect due to no registration")},it.prototype.resetReconnectParamsOnErrorThreshold=function(){this.logger.warn("".concat(this.connectingErrorsInRow," connection attempts, server-side failure: erasing cached connection parameters")),this.reconnectParams=void 0},it.prototype.onSocketConnecting=function(Ke){this.logger.info("onSocketConnecting(".concat(Ke,")")),this.transportTypeName=Ke,this.connectionTracker.trackProgress("connecting",this.transportTypeName),this.fsm.onConnecting()},it.prototype.onSocketConnect=function(Ke){this.logger.info("onSocketConnect"),this.fsm.onSocketConnect(Ke)},it.prototype.onSocketConnectFailed=function(Ke){this.logger.error("onSocketConnectFailed"),this.connectionTracker.trackError("connect_failed",Ke,!0,this.transportTypeName?this.transportTypeName:this.UNKNOWN_TRANSPORT),this.fsm.onConnectingFailed()},it.prototype.onSocketDisconnect=function(Ke){var ot=this.connectionTracker.getSessionLength()||0,Ht=ce.DisconnectReason.fromRawReason(Ke);this.logger.error("onSocketDisconnect, reason: ".concat(Ht.reason)),Ht.reason==="dup"&&this.lastDisconnectReason==="dup"&&ot<this.options.duplicateDisconnectThresholdMs&&(this.logger.warn("Socket was closed by server as Duplicate for the second time in a row "+"after ".concat(ot," ms which is below the threshold of ")+"".concat(this.options.duplicateDisconnectThresholdMs," ms. Resetting cached ")+"connection parameters and making a new allocation."),this.reconnectParams=void 0),this.lastDisconnectReason=Ht.reason,this.fsm.onSocketDisconnect(Ht),this.connectionExpireTimestampInSecs=void 0},it.prototype.onSocketReconnect=function(){this.logger.error("onSocketReconnect"),this.fsm.onTrouterConnected()},it.prototype.onSocketReconnectFailed=function(Ke){this.logger.error("onSocketReconnectFailed with '".concat(Ke,"'")),this.fsm.onSocketDisconnect(ce.DisconnectReason.fromSocketIoEventData("reconnecterror",Ke))},it.prototype.onSocketReconnecting=function(){this.logger.error("onSocketReconnecting")},it.prototype.onSocketError=function(Ke){this.logger.error("onSocketError with '".concat((0,pe.toJson)(Ke),"'")),this.fsm.isConnecting()&&++this.connectingErrorsInRow>=this.connectingErrorsThreshold&&this.resetReconnectParamsOnErrorThreshold(),this.connectionTracker.trackError("connectSocket",J(Ke)),this.fsm.onSocketDisconnect(ce.DisconnectReason.fromSocketIoEventData("socketerror",Ke))},it.prototype.onSocketMessage=function(Ke){var ot,Ht=this;this.logger.debug("onSocketMessage");var jt;try{jt=new vt(Ke,this.logger);var Nt=(ot=jt.headers)===null||ot===void 0?void 0:ot["X-Microsoft-Skype-Chain-ID"],Vt=Nt?" Chain-Id ".concat(Nt):"";this.logger.info("Received request N ".concat(jt.id).concat(Vt," CV ").concat(jt.correlationVector," to '").concat(jt.url,"'")),jt.startTS=Date.now(),jt.url&&this.urlPath&&jt.url.startsWith(this.urlPath)&&(jt.shortUrl=jt.url.substring(this.urlPath.length))}catch(dt){var $t=Z(dt);return this.logger.error("unable to parse request. Error: ".concat($t)),this.connectionTracker.trackRequest(void 0,$t),void this.connectionTracker.sendResponseError("unable to parse request, error: ".concat(dt))}jt.timeoutTimerId=setTimeout(function(){if(!jt.replied){Ht.logger.error("Request ".concat(jt.id," timed out"));var dt=new te.ResponseData(jt.id);dt.status=504,dt.headers={"Trouter-Responder":"ClientLib"},Ht.sendResponse(jt,dt),jt.timedout=!0}},this.timeoutOptions.requestTimeoutMs);try{this.connectionTracker.trackRequest(jt),this.fsm.onDownstreamRequest(jt)}catch(dt){this.logger.error("exception in socket.on message. Error: ".concat(Z(dt))),this.connectionTracker.sendResponseError(re(dt),jt,void 0)}},it.prototype.onTrouterConnected=function(Ke,ot,Ht){var jt,Nt,Vt,$t,dt=this;if((0,qe.isV4ConnectEvent)(Ke)){var yt=Ke;this.allocateResult=ne(ne({},yt),{ttl:Ke.ttl.toString()}),this.populateAndCacheReconnectParams(yt,yt.reconnectUrl),this.populateConnectionStateFields(yt)}else if(!this.allocateResult)return void this.logger.error("Invalid internal state - received onTrouterConnected while allocateResult is not set");this.connectingErrorsInRow=0,this.logger.info("onTrouterConnected: ".concat(this.allocateResult.url)),this.transportTypeName==="xhr-polling"&&ot&&this.manager.onUserActivityStateAccepted(ot.cv),!((Vt=(Nt=(jt=this.socket)===null||jt===void 0?void 0:jt.socket)===null||Nt===void 0?void 0:Nt.options)===null||Vt===void 0)&&Vt.query&&(this.socket.socket.options.query+="&connected=true"),this.urlPath=this.allocateResult.url.replace(/https?:\/\/([A-z0-9\:\$\-\_\.\+\!\*\"\(\)\,]*)\//,"/");var kt=this.connectedUrl!==this.allocateResult.url;this.connectedUrl=this.allocateResult.url,this.connectionExpireTimestampInSecs=(0,pe.calculateExpireTsInSec)((0,qe.ensureNumber)(Ke.ttl)),this.connectionTracker.trackEnd("connectSocket"),this.connectionTracker.trackConnected(kt,this.transportTypeName?this.transportTypeName:this.UNKNOWN_TRANSPORT),($t=this.setAudienceSubscriptionsUnsafeAsync(Ht))===null||$t===void 0||$t.catch(function(je){return dt.logger.error("Re-subscribe to audiences has failed with ".concat(je))}),this.fsm.onTrouterConnected()},it.prototype.onTrouterReconnect=function(Ke){var ot=Ke.target;this.logger.info("onTrouterReconnect target: ".concat(ot)),ot==="self"?this.fsm.onReconnectRequired(!0,Me.ServerInitiated):this.fsm.onReconnectRequired(!1,Me.ServerInitiated,Ke)},it.prototype.onTrouterMessageLoss=function(Ke){this.logger.debug("onTrouterMessageLoss"),this.fsm.onTrouterMessageLost(Ke.droppedIndicators)},it.prototype.onAudienceSubscriptionResult=function(Ke){this.logger.info("onAudienceSubscriptionResult"),this.pendingAudienceSubscription&&(clearTimeout(this.pendingAudienceSubscription.timeoutId),this.pendingAudienceSubscription.audienceSetResolve(Ke),this.pendingAudienceSubscription=void 0)},it.prototype.buildV4cUrlParams=function(){var Ke={};return Ke.tc=encodeURI((0,pe.toJson)(this.clientInfo)),Ke.timeout=Math.floor(this.timeoutOptions.pingTimeoutMs/1e3),this.options.endpointId&&(Ke.epid=this.options.endpointId),this.appendConnectedClientIds(this.buildQuery(Ke),!0)},it.prototype.attachSocketIoHandlers=function(Ke,ot,Ht,jt){var Nt=this;Ke.on("connecting",function(Vt){Nt.onSocketConnecting(Vt)}),Ke.on("connect",function(){Nt.onSocketConnect(ot)}),Ke.on("connect_failed",function(Vt){Nt.onSocketConnectFailed(Vt)}),Ke.on("close_during_connecting",function(Vt){Nt.onSocketConnectFailed(Vt)}),Ke.on("disconnect",function(Vt){Nt.onSocketDisconnect(Vt)}),Ke.on("reconnect",function(){Nt.onSocketReconnect()}),Ke.on("reconnect_failed",function(Vt){Nt.onSocketReconnectFailed(Vt)}),Ke.on("reconnecting",function(){Nt.onSocketReconnecting()}),Ke.on("error",function(Vt){Nt.onSocketError(Vt)}),Ke.on("message",function(Vt){Nt.onSocketMessage(Vt)}),Ke.on("trouter.connected",function(Vt){Nt.onTrouterConnected(Vt,Ht,jt)}),Ke.on("trouter.reconnect",function(Vt){Nt.onTrouterReconnect(Vt)}),Ke.on("trouter.message_loss",function(Vt){Nt.onTrouterMessageLoss(Vt)}),Ke.on("audience.subscriptionresult",function(Vt,$t){Nt.onAudienceSubscriptionResult($t)})},it.prototype.onNavigatorOnlineStatusUpdate=function(){var Ke=window.navigator.onLine;this.logger.debug("Browser online status update - new state: ".concat(Ke,", previously: ").concat(this.isNavigatorOnline)),Ke&&!this.isNavigatorOnline?(this.isNavigatorOnline=!0,this.tokenBackoff.expediteIfPending(),this.connectionTracker.trackProgress("browserNet","online")):!Ke&&this.isNavigatorOnline&&(this.isNavigatorOnline=!1,this.connectionTracker.trackProgress("browserNet","offline"))},it.prototype.onAllocationResponse=function(Ke,ot){this.logger.info("Received allocation response ".concat(JSON.stringify(Ke))),this.allocateResult=Ke,this.populateAndCacheReconnectParams(this.allocateResult,"".concat(this.allocateResult.socketio,"v4/a")),this.populateConnectionStateFields(this.allocateResult),this.fsm.onAllocationSucceed(ot)},it.prototype.populateAndCacheReconnectParams=function(Ke,ot){this.reconnectParams=ne({serviceUrl:this.options.trouterUrl,reconnectUrl:ot},Ke.connectparams),this.manager.onConnectionParametersUpdated(this.reconnectParams)},it.prototype.populateConnectionStateFields=function(Ke){var ot,Ht,jt=typeof Ke.ttl=="string"?parseInt(Ke.ttl,10):Ke.ttl;if(this.connectionExpireTimestampInSecs=(0,pe.calculateExpireTsInSec)(jt),this.connectionId=(ot=Ke.id)!==null&&ot!==void 0?ot:"",this.connectedClientId=Ke.ccid,this.logger.debug("connected client id set {connectedClientId:".concat(this.connectedClientId,"}")),this.c2cUrlBase=(Ht=Ke.curlb)!==null&&Ht!==void 0?Ht:"",this.c2cUrlBase===""){var Nt=Ke.surl.indexOf("://");Nt>=0&&(Nt=Ke.surl.indexOf("/",Nt+3))>=5&&Ke.surl.substr(Nt-5,5)===":3443"&&(this.c2cUrlBase=Ke.surl.substr(0,Nt-5))}},it.prototype.onPingResponse=function(){this.logger.debug("onPingResponse"),this.connectionTracker.increasePingResponseCount(),this.clearPingResponseTimer(),this.fsm.onPingResponse()},it.prototype.clearPingResponseTimer=function(){this.pingResponseTimerId!==void 0&&(clearTimeout(this.pingResponseTimerId),this.pingResponseTimerId=void 0)},it.prototype.buildQuery=function(Ke){for(var ot=[],Ht=0,jt=Object.keys(Ke);Ht<jt.length;Ht++){var Nt=jt[Ht];Ke[Nt]!==void 0&&ot.push("".concat(Nt,"=").concat(Ke[Nt]))}return ot.join("&")},it.prototype.appendConnectedClientIds=function(Ke,ot){var Ht="";Ke.includes("ccid=")||(Ht="ccid=".concat(this.connectedClientId,"&")),this.domId&&(Ht+="dom=".concat(this.domId,"&")),Ht.length>0&&(Ht=Ht.slice(0,-1));var jt=ot||Ke.includes("?")?"&":"?";return this.appendCorrelationIds(Ke+jt+Ht,ot)},it.prototype.appendEndpointId=function(Ke,ot){var Ht=ot||Ke.includes("?")?"&":"?";return!Ke.includes("epid")&&this.options.endpointId?"".concat(Ke).concat(Ht,"epid=").concat(this.options.endpointId):Ke},it.prototype.appendCorrelationIds=function(Ke,ot){var Ht=ot||Ke.includes("?")?"&":"?";return Ke.includes("cor_id")?Ke:"".concat(Ke).concat(Ht,"cor_id=").concat(this.options.clientCorrelationID)+"&con_num=".concat(this.clientID,"_").concat(this.connectionAttempt)},it.prototype.safeString=function(Ke){return typeof Ke=="string"?Ke:""},it.prototype.sendResponse=function(Ke,ot){var Ht,jt,Nt;if(Ke.timedout)return this.logger.error("Request ".concat(Ke.id," already timed out")),1;if(Ke.replied)return this.logger.error("Response for request ".concat(Ke.id," already sent")),2;clearTimeout(Ke.timeoutTimerId),Ke.timeoutTimerId=void 0,Ke.replied=!0,ot.headers=(Ht=ot.headers)!==null&&Ht!==void 0?Ht:{};var Vt=Ke.correlationVector;this.logger.info("Sending response N ".concat(Ke.id," CV ").concat(Vt," with status ").concat(ot.status)),Vt&&(ot.headers[ht]=Vt),!((jt=Ke.headers)===null||jt===void 0)&&jt["trouter-request"]&&(ot.headers["trouter-request"]=Ke.headers["trouter-request"]);var $t=Date.now()-Ke.startTS;if(ot.headers["trouter-client"]=(0,pe.toJson)({cd:$t}),!((Nt=Ke.headers)===null||Nt===void 0)&&Nt["trouter-is-broadcast"]&&(ot.headers["trouter-is-broadcast"]=Ke.headers["trouter-is-broadcast"]),this.logger.debug("response: ".concat((0,pe.toJson)(ot))),!this.socket)return this.connectionTracker.sendResponseError("no socket",Ke,ot),4;try{return this.socket.send((0,pe.toJson)(ot)),ot.sentTS=Date.now(),Ke.incrementCorrelationVector(),this.connectionTracker.trackResponse(Ke,$t,ot),this.transportTypeName==="websocket"&&this.sendPingRequest(),0}catch(yt){var dt="unable to send data on response.end. Error: ".concat(Z(yt));return this.logger.error(dt),this.connectionTracker.sendResponseError(dt,Ke,ot),4}},it.prototype.sendUserActivityStateMultiple=function(Ke){var ot=this,Ht=new ni("user.activity"),jt=this.userActivityState.increaseCvAndGetEventObject();Ht.args=jt,this.logger.debug("Sending user activity '".concat(this.userActivityState.toEventJSON(),"', remaining ").concat(Ke-1));var Nt=!1;this.sendDownstreamEvent(Ht,function(){if(Nt!==!0&&(ot.logger.info("User activity state: ".concat(jt.state,", cv: ").concat(jt.cv," accepted")),ot.manager.onUserActivityStateAccepted(jt.cv),ot.clearSentEventTimer(Ht.timeoutTimerId),Ke>1)){var Vt=setTimeout(function(){ot.clearSentEventTimer(Vt),ot.sendUserActivityStateMultiple(Ke-1)},ot.options.userActivitySecondResendDelayMs);ot.registerSentEventTimer(Vt,"user.activity/resend")}}),Ht.timeoutTimerId=setTimeout(function(){ot.logger.error("Activity state response timeout is fired"),Nt=!0,ot.fsm.onActivityStateResponseTimeout(),ot.clearSentEventTimer(Ht.timeoutTimerId)},this.timeoutOptions.userActivityResponseTimeoutMs),this.registerSentEventTimer(Ht.timeoutTimerId,"user.activity/response")},it.prototype.sendDownstreamEvent=function(Ke,ot){this.logger.debug("Sending downstream event ".concat(Ke.name)),this.socket&&this.socket.emit(Ke.name,Ke.args,ot)},it.prototype.registerSentEventTimer=function(Ke,ot){this.logger.debug("registering timer ".concat(Ke," -> ").concat(ot)),this.pendingSentEventTimers[Ke]=ot},it.prototype.clearSentEventTimer=function(Ke){var ot=this.pendingSentEventTimers[Ke];this.logger.debug("clearing timer ".concat(Ke," -> ").concat(ot)),delete this.pendingSentEventTimers[Ke],clearTimeout(Ke)},it.prototype.getRegistrationTtl=function(){var Ke,ot,Ht=(0,pe.calculateTtlInSec)(this.connectionExpireTimestampInSecs);if(this.logger.debug("Current connectionID will expire in ".concat(Ht," seconds")),((Ke=this.options.registration)===null||Ke===void 0?void 0:Ke.registrarTtlSec)&&Ht>0){var jt=this.options.registration.registrarTtlSec<Ht;return[Math.min(this.options.registration.registrarTtlSec,Ht),jt]}return!((ot=this.options.registration)===null||ot===void 0)&&ot.registrarTtlSec?[this.options.registration.registrarTtlSec,!1]:Ht>0?[Ht,!1]:[3600,!1]},it.prototype.clearIncallModeTimerId=function(){this.incallModeTimerId!==void 0&&(this.logger.debug("Clearing in-call mode timer"),clearTimeout(this.incallModeTimerId),this.incallModeTimerId=void 0)},it.prototype.applyConnectionTrackerOptions=function(Ke){try{Ke.eventLogger&&typeof Ke.eventLogger.logEvent=="function"?(this.connectionTracker.mergeSettings(Ke.telemetrySettings),this.connectionTracker.enable(Ke.eventLogger)):this.logger.warn("Trouter client event logging disabled due to invalid configuration.")}catch(ot){this.logger.warn("Trouter client event logging disabled. Error: ".concat(Z(ot))),this.connectionTracker.disable()}},it.prototype.canRetryTokenFetchRequest=function(Ke){var ot=this.options.retryLimitOnTokenFetch;return ot==null||Ke<ot||(this.logger.warn("Reached limit on maximum number of token fetch request. Current count: ".concat(Ke,", retry limit: ").concat(ot)),!1)},it}();z.TrouterConnection=Zt},function(L,z,H){Object.defineProperty(z,"__esModule",{value:!0}),z.MessageHandlerRegistry=void 0;var j=H(1),J=H(0),Z=function(){function re(ne){this.messageHandlers=[],this.logger=new J.Logger("MessageHandlers",ne)}return re.prototype.register=function(ne){if(this.messageHandlers.some(function(le){return le===ne}))throw new Error("Registering the same handler twice is not allowed");this.messageHandlers.push(ne)},re.prototype.clear=function(){this.logger.debug("Clearing message handlers"),this.messageHandlers=[]},re.prototype.active=function(){return this.messageHandlers.length>0},re.prototype.handleMessage=function(ne){for(var le={resultCode:j.UNHANDLED_MESSAGE_ACK,isHandled:!1},he=0,Me=this.messageHandlers;he<Me.length;he++){var Le=Me[he],pe=this.safeExecuteHandle(Le,ne);if(pe!==void 0&&(pe.isHandled===void 0||pe.isHandled))return pe.resultCode===void 0&&(pe.resultCode=j.HANDLED_MESSAGE_ACK),pe}return le},re.prototype.safeExecuteHandle=function(ne,le){try{return ne.handleMessage(le)}catch(he){return void this.logger.warn("Trouter message handler threw an exception: ".concat(he))}},re}();z.MessageHandlerRegistry=Z},function(L,z,H){function j(re){var ne,le=this;return function(he){return J(le,void 0,void 0,function(){return Z(this,function(Me){return he&&(ne=void 0),[2,new Promise(function(Le,pe){re(he).then(function(te){ne=te,Le(te)}).catch(function(te){ne!==void 0&&ne.length>0&&Le(ne),pe(te)})})]})})}}var J=this&&this.__awaiter||function(re,ne,le,he){function Me(Le){return Le instanceof le?Le:new le(function(pe){pe(Le)})}return new(le||(le=Promise))(function(Le,pe){function te(X){try{ce(he.next(X))}catch(ve){pe(ve)}}function Se(X){try{ce(he.throw(X))}catch(ve){pe(ve)}}function ce(X){X.done?Le(X.value):Me(X.value).then(te,Se)}ce((he=he.apply(re,ne||[])).next())})},Z=this&&this.__generator||function(re,ne){function le(ce){return function(X){return he([ce,X])}}function he(ce){if(Me)throw new TypeError("Generator is already executing.");for(;te&&(te=0,ce[0]&&(Se=0)),Se;)try{if(Me=1,Le&&(pe=2&ce[0]?Le.return:ce[0]?Le.throw||((pe=Le.return)&&pe.call(Le),0):Le.next)&&!(pe=pe.call(Le,ce[1])).done)return pe;switch(Le=0,pe&&(ce=[2&ce[0],pe.value]),ce[0]){case 0:case 1:pe=ce;break;case 4:return Se.label++,{value:ce[1],done:!1};case 5:Se.label++,Le=ce[1],ce=[0];continue;case 7:ce=Se.ops.pop(),Se.trys.pop();continue;default:if(pe=Se.trys,!(pe=pe.length>0&&pe[pe.length-1])&&(ce[0]===6||ce[0]===2)){Se=0;continue}if(ce[0]===3&&(!pe||ce[1]>pe[0]&&ce[1]<pe[3])){Se.label=ce[1];break}if(ce[0]===6&&Se.label<pe[1]){Se.label=pe[1],pe=ce;break}if(pe&&Se.label<pe[2]){Se.label=pe[2],Se.ops.push(ce);break}pe[2]&&Se.ops.pop(),Se.trys.pop();continue}ce=ne.call(re,Se)}catch(X){ce=[6,X],Le=0}finally{Me=pe=0}if(5&ce[0])throw ce[1];return{value:ce[0]?ce[1]:void 0,done:!0}}var Me,Le,pe,te,Se={label:0,sent:function(){if(1&pe[0])throw pe[1];return pe[1]},trys:[],ops:[]};return te={next:le(0),throw:le(1),return:le(2)},typeof Symbol=="function"&&(te[Symbol.iterator]=function(){return this}),te};Object.defineProperty(z,"__esModule",{value:!0}),z.addCacheAsBackupTo=void 0,z.addCacheAsBackupTo=j},function(L,z,H){var j=this&&this.__awaiter||function(ve,Te,Be,qe){function Ge(tt){return tt instanceof Be?tt:new Be(function(ct){ct(tt)})}return new(Be||(Be=Promise))(function(tt,ct){function Mt(Pt){try{vt(qe.next(Pt))}catch(ni){ct(ni)}}function ht(Pt){try{vt(qe.throw(Pt))}catch(ni){ct(ni)}}function vt(Pt){Pt.done?tt(Pt.value):Ge(Pt.value).then(Mt,ht)}vt((qe=qe.apply(ve,Te||[])).next())})},J=this&&this.__generator||function(ve,Te){function Be(vt){return function(Pt){return qe([vt,Pt])}}function qe(vt){if(Ge)throw new TypeError("Generator is already executing.");for(;Mt&&(Mt=0,vt[0]&&(ht=0)),ht;)try{if(Ge=1,tt&&(ct=2&vt[0]?tt.return:vt[0]?tt.throw||((ct=tt.return)&&ct.call(tt),0):tt.next)&&!(ct=ct.call(tt,vt[1])).done)return ct;switch(tt=0,ct&&(vt=[2&vt[0],ct.value]),vt[0]){case 0:case 1:ct=vt;break;case 4:return ht.label++,{value:vt[1],done:!1};case 5:ht.label++,tt=vt[1],vt=[0];continue;case 7:vt=ht.ops.pop(),ht.trys.pop();continue;default:if(ct=ht.trys,!(ct=ct.length>0&&ct[ct.length-1])&&(vt[0]===6||vt[0]===2)){ht=0;continue}if(vt[0]===3&&(!ct||vt[1]>ct[0]&&vt[1]<ct[3])){ht.label=vt[1];break}if(vt[0]===6&&ht.label<ct[1]){ht.label=ct[1],ct=vt;break}if(ct&&ht.label<ct[2]){ht.label=ct[2],ht.ops.push(vt);break}ct[2]&&ht.ops.pop(),ht.trys.pop();continue}vt=Te.call(ve,ht)}catch(Pt){vt=[6,Pt],tt=0}finally{Ge=ct=0}if(5&vt[0])throw vt[1];return{value:vt[0]?vt[1]:void 0,done:!0}}var Ge,tt,ct,Mt,ht={label:0,sent:function(){if(1&ct[0])throw ct[1];return ct[1]},trys:[],ops:[]};return Mt={next:Be(0),throw:Be(1),return:Be(2)},typeof Symbol=="function"&&(Mt[Symbol.iterator]=function(){return this}),Mt};Object.defineProperty(z,"__esModule",{value:!0}),z.TrouterManager=z.AudienceSubscriptionState=z.UserActivityObject=void 0;var Z=H(3),re=H(2),ne=H(4),le=H(0),he=H(5),Me=H(18),Le=H(7),pe=H(6),te=H(19),Se=function(){function ve(Te,Be){this.state=Te,this.correlationVector=Be!==void 0?Be:Z.CorrelationVector.extend()}return ve.prototype.getStateString=function(){switch(this.state){case re.UserActivityState.Active:return"active";case re.UserActivityState.Inactive:return"inactive";case re.UserActivityState.Unknown:return"unknown";default:return"undefined"}},ve.prototype.increaseCvAndGetEventObject=function(){return this.correlationVector.increase(),this.toEventObject()},ve.prototype.toEventObject=function(){return{state:this.getStateString(),cv:this.correlationVector.value()}},ve.prototype.toEventJSON=function(){return(0,Z.toJson)(this.toEventObject())},ve}();z.UserActivityObject=Se;var ce=function(){function ve(Te,Be){Be===void 0&&(Be=Z.CorrelationVector.extend()),this.audienceSubscriptionModel=Te,this.correlationVector=Be}return ve.prototype.increaseCvAndGetEventObject=function(){return this.correlationVector.increase(),this.toEventObject()},ve.prototype.toEventObject=function(){return{audiences:this.audienceSubscriptionModel.audienceSubscriptions,cv:this.correlationVector.value()}},ve.prototype.toEventJSON=function(){return(0,Z.toJson)(this.toEventObject())},ve}();z.AudienceSubscriptionState=ce;var X=function(){function ve(Te,Be,qe,Ge,tt,ct){var Mt=this;this.logFunc=Te,this.options=Be,this.tokenProvider=qe,this.usingLegacyTokenApi=Ge,this.listener=tt,this.tokenTypeProtocolSelector=function(ht,vt){return Mt.options.forceV4aProtocol?"v4a":(0,he.usedProtocol)(ht,vt)},this.logger=new le.Logger("Manager",Te),this.logger.info("Created TrouterManager with options ".concat((0,Z.toJson)(this.options))),this.fsm=new te.TrouterManagerFsm(Te,this),this.baseEndpointUrl="",this.processedMessageLoss={},this.userActivityObject=new Se(re.UserActivityState.Unknown),this.protocolSelector=ct??this.tokenTypeProtocolSelector.bind(this)}return ve.prototype.start=function(){this.fsm.start()},ve.prototype.stop=function(Te){this.fsm.stop(Te)},ve.prototype.configure=function(Te){this.options=Te,this.firstConnection!==void 0&&this.firstConnection.configure(Te),this.secondConnection!==void 0&&this.secondConnection.configure(Te),this.logger.info("Reconfigured TrouterManager with options ".concat((0,Z.toJson)(this.options)))},ve.prototype.checkConnection=function(Te){this.firstConnection!==void 0&&this.firstConnection.checkConnection(Te),this.secondConnection!==void 0&&this.secondConnection.checkConnection(Te)},ve.prototype.resendRegistration=function(){return j(this,void 0,void 0,function(){return J(this,function(Te){return this.secondConnection!==void 0?(this.logger.info("Resending registration on the second/new connection"),[2,this.secondConnection.resendRegistration()]):this.firstConnection!==void 0?(this.logger.info("Resending registration on the first/current connection"),[2,this.firstConnection.resendRegistration()]):(this.logger.info("No connection to resend registration on, will be done upon (re)connect"),[2])})})},ve.prototype.getServerState=function(){if(this.firstConnection!==void 0)return this.firstConnection.getServerState()},ve.prototype.getState=function(){return this.fsm.getState()},ve.prototype.isInTerminalState=function(){return this.fsm.getInternalState()===ne.TrouterManagerState.TerminalError},ve.prototype.reportStateInfo=function(){var Te=this.firstConnection?pe.State[this.firstConnection.getState()]:"Unknown",Be=ne.TrouterManagerState[this.fsm.getInternalState()];if(this.secondConnection){var qe=pe.State[this.secondConnection.getState()];return"Manager ".concat(Be,"; 1st ").concat(Te,"; 2nd ").concat(qe)}return"Manager ".concat(Be,"; Connection ").concat(Te)},ve.prototype.startFirstConnection=function(){var Te=new Le.TrouterConnection(this.logFunc,this.options,this.configuredTrouterManager(),this.tokenProvider,this.usingLegacyTokenApi,this.userActivityObject,this.protocolSelector,this.audienceSubscriptionState);this.firstConnection=Te,this.getConnectionCache().then(function(Be){Te.start(Be)}).catch(function(){})},ve.prototype.startSecondConnection=function(Te){var Be=new Le.TrouterConnection(this.logFunc,this.options,this.configuredTrouterManager(),this.tokenProvider,this.usingLegacyTokenApi,this.userActivityObject,this.protocolSelector,this.audienceSubscriptionState);this.secondConnection=Be,this.firstConnection!==void 0&&this.firstConnection.disableRegistrationsAndAutoReconnect(),Te?this.getConnectionCache().then(function(qe){Be.start(qe)}).catch(function(){}):Be.start()},ve.prototype.stopFirstConnection=function(Te){this.firstConnection!==void 0&&(this.storedFirstConnection=this.firstConnection,this.firstConnection.stop(Te),this.firstConnection=void 0)},ve.prototype.stopSecondConnection=function(Te){this.secondConnection!==void 0&&(this.secondConnection.stop(Te),this.secondConnection=void 0)},ve.prototype.stopSecondConnectionDelayed=function(){if(this.secondConnection!==void 0){var Te=this.secondConnection;this.secondConnection=void 0,this.logger.info("Closing an inactive connection in ".concat(Math.round(this.options.lingeringConnectionDelayMs/1e3),"s")),setTimeout(function(){Te.stop(!0)},this.options.lingeringConnectionDelayMs)}},ve.prototype.forceStopLingeringConnection=function(){this.storedFirstConnection&&(this.storedFirstConnection.stop(!1),this.storedFirstConnection=void 0)},ve.prototype.switchConnections=function(){var Te=this.firstConnection;this.firstConnection=this.secondConnection,this.secondConnection=Te},ve.prototype.doesSecondConnectionExist=function(){return this.secondConnection!==void 0},ve.prototype.dispatchConnected=function(){if(this.firstConnection!==void 0){var Te=this.firstConnection.getServerState(),Be=Te.url.endsWith("/")?Te.url.slice(0,-1):Te.url,qe={baseEndpointUrl:Be,newEndpointUrl:Be!==this.baseEndpointUrl,c2cUrlBase:Te.c2cUrlBase,clientId:Te.connectedClientId,connectionId:Te.connectionId,connectionTtlSec:Te.getRemainingTtlInSec()};this.baseEndpointUrl=Be,this.listener.onTrouterConnected(Te.url,qe)}},ve.prototype.dispatchDisconnected=function(){this.listener.onTrouterDisconnected&&this.listener.onTrouterDisconnected()},ve.prototype.dispatchTerminalError=function(){this.listener.onTrouterDisconnected&&this.listener.onTrouterDisconnected()},ve.prototype.dispatchRegistrationState=function(Te){this.options.registrationStateCallback&&this.options.registrationStateCallback(Te)},ve.prototype.expediteBackoffOnConnections=function(){var Te;if(this.lastExpediteBackoffCallAt!==void 0&&Date.now()-this.lastExpediteBackoffCallAt<((Te=this.options.expediteBackoffOnStartMinimumDelayMs)!==null&&Te!==void 0?Te:1e4))return void this.logger.info("Expedite backoff due to start() too frequent, skipping");this.lastExpediteBackoffCallAt=Date.now(),this.firstConnection!==void 0&&this.firstConnection.expediteBackoff(),this.secondConnection!==void 0&&this.secondConnection.expediteBackoff()},ve.prototype.onDownstreamRequest=function(Te,Be,qe){var Ge={id:Be.id,method:Be.method,path:"/".concat(Be.shortUrl),body:Be.body,headers:Be.headers},tt={id:Be.id,status:0,headers:{},body:"",send:function(){return tt.status<=100||tt.status>=999?3:(qe.writeHead(tt.status,tt.headers),qe.end(tt.body))}};this.listener.onTrouterRequest(Ge,tt)},ve.prototype.onConnected=function(Te){this.fsm.onConnected(Te===this.firstConnection)},ve.prototype.onRegistered=function(Te){this.fsm.onRegistered(Te===this.firstConnection)},ve.prototype.onUnregistered=function(Te){this.fsm.onUnregistered(Te===this.firstConnection||Te===this.storedFirstConnection)},ve.prototype.onReconnecting=function(Te){this.fsm.onReconnecting(Te===this.firstConnection)},ve.prototype.onReconnectIsRequired=function(Te,Be,qe){this.fsm.onReconnectionRequired(Te===this.firstConnection,Be,qe)},ve.prototype.onDisconnected=function(Te){this.fsm.onDisconnected(Te===this.firstConnection||Te==this.storedFirstConnection),this.storedFirstConnection=void 0},ve.prototype.onTerminalError=function(){this.fsm.onTerminalError(),this.storedFirstConnection=void 0},ve.prototype.onUserActivityStateAccepted=function(Te){this.listener.onTrouterUserActivityStateAccepted&&this.listener.onTrouterUserActivityStateAccepted(Te)},ve.prototype.onAudiencesSetResolved=function(Te,Be){var qe,Ge;(Ge=(qe=this.listener).onAudiencesSetResolved)===null||Ge===void 0||Ge.call(qe,Te,Be)},ve.prototype.onConnectionParametersUpdated=function(Te){this.setConnectionCache(Te)},ve.prototype.setUserActivityState=function(Te,Be){return this.userActivityObject=new Se(Te,Z.CorrelationVector.extend(Be)),this.secondConnection!==void 0?(this.logger.info("Setting user activity ".concat(this.userActivityObject.toEventJSON()," on the second/new connection")),void this.secondConnection.setUserActivityState(this.userActivityObject)):this.firstConnection!==void 0?(this.logger.info("Setting user activity ".concat(this.userActivityObject.toEventJSON()," on the first/current connection")),void this.firstConnection.setUserActivityState(this.userActivityObject)):void 0},ve.prototype.setAudienceSubscriptionsAsync=function(Te,Be,qe){if(this.audienceSubscriptionState=new ce(Te,Z.CorrelationVector.extend(qe)),this.secondConnection)return this.logger.info("Setting audience subscriptions ".concat(this.audienceSubscriptionState.toEventJSON()," on second/new connection")),this.secondConnection.setAudienceSubscriptionsAsync(this.audienceSubscriptionState,Be);if(this.firstConnection)return this.logger.info("Setting audience subscriptions ".concat(this.audienceSubscriptionState.toEventJSON()," on first/current connection")),this.firstConnection.setAudienceSubscriptionsAsync(this.audienceSubscriptionState,Be);throw new Error("No connection found")},ve.prototype.onTrouterMessageLost=function(Te){var Be=this;if(this.listener.onTrouterMessageLoss)if(Te?.length){var qe=Te.filter(function(tt){return Be.processedMessageLoss["".concat(tt.tag,"-").concat(tt.etag)]!==void 0});if(qe.length&&(this.logger.info("onTrouterMessageLoss - immediately acknowledging ".concat(qe.length," seen dropped indicators")),this.sendProcessedDroppedIndicators(qe),Te=Te.filter(function(tt){return Be.processedMessageLoss["".concat(tt.tag,"-").concat(tt.etag)]===void 0}),!Te.length))return void this.logger.info("onTrouterMessageLoss - all declared dropped indicators have been seen before");var Ge=this.listener.onTrouterMessageLoss(Te.map(function(tt){return tt.tag}));if(!Ge)return void this.logger.warn("onTrouterMessageLoss - some flow tag(s) have not been processed by listeners");Te.forEach(function(tt){Be.processedMessageLoss["".concat(tt.tag,"-").concat(tt.etag)]=""}),this.sendProcessedDroppedIndicators(Te)}else this.logger.warn("onTrouterMessageLoss - no flow tags have been provided")},ve.prototype.getConnectionCache=function(){var Te=this;return this.options.connectionCache?(this.logger.debug("Querying host's connection cache"),this.options.connectionCache.onGetTrouterConnectionCache().then(function(Be){var qe=Be?JSON.parse(Be):void 0;return typeof qe=="object"?qe:void 0}).catch(function(Be){return Te.logger.warn("Invalid connection cache content provided: ".concat(Be)),Te.connectionCache})):Promise.resolve(this.connectionCache)},ve.prototype.setConnectionCache=function(Te){if(this.connectionCache=Te,this.options.connectionCache)try{this.options.connectionCache.onSetTrouterConnectionCache(JSON.stringify(Te))}catch(Be){this.logger.warn("Error setting external connection cache: ".concat(Be))}},ve.prototype.sendProcessedDroppedIndicators=function(Te){return this.firstConnection!==void 0?void this.firstConnection.sendProcessedDroppedIndicators(Te):this.secondConnection!==void 0?void this.secondConnection.sendProcessedDroppedIndicators(Te):void 0},ve.prototype.configuredTrouterManager=function(){return new Me.RegistrationEnforcer(this,this.options.connectionDependsOnRegistration,this.options.delayEventsUntilRegistered)},ve}();z.TrouterManager=X},function(L,z,H){Object.defineProperty(z,"__esModule",{value:!0}),z.TrouterUrlPromise=void 0;var j=H(0),J=function(){function Z(re){this.logger=new j.Logger("UrlPromise",re)}return Z.prototype.getPromise=function(){var re=this;return this.url!==void 0?(this.logger.debug("returning previously resolved url: ".concat(this.url)),Promise.resolve(this.url)):(this.pendingPromise===void 0?(this.logger.debug("creating and returning promise"),this.pendingPromise=new Promise(function(ne,le){re.pendingPromiseResolveRef=ne,re.pendingPromiseRejectRef=le})):this.logger.debug("returning existing promise"),this.pendingPromise)},Z.prototype.resolveUrl=function(re){this.url=re,this.logger.debug("got url: ".concat(this.url));var ne=this.pendingPromiseResolveRef;this.pendingPromise=void 0,this.pendingPromiseResolveRef=void 0,this.pendingPromiseRejectRef=void 0,ne!==void 0&&(this.logger.debug("resolving promise"),ne(re))},Z.prototype.rejectUrl=function(re){this.logger.debug("aborting");var ne=this.pendingPromiseRejectRef;this.url=void 0,this.pendingPromise=void 0,this.pendingPromiseResolveRef=void 0,this.pendingPromiseRejectRef=void 0,ne!==void 0&&(this.logger.debug("rejecting promise"),ne(re))},Z.prototype.resetUrl=function(){this.logger.debug("resetting url"),this.url=void 0},Z}();z.TrouterUrlPromise=J},function(L,z,H){(function(j,J){(function(re,ne){var le=re;le.version="0.9.6",le.protocol=1,le.transports=[],le.j=[],le.sockets={},le.connect=function(he,Me){var Le,pe,te=le.util.parseUri(he);ne&&ne.location&&(te.protocol=te.protocol||ne.location.protocol.slice(0,-1),te.host=te.host||(ne.document?ne.document.domain:ne.location.hostname),te.port=te.port||ne.location.port),Le=le.util.uniqueUri(te);var Se={host:te.host,secure:te.protocol=="https",port:te.port||(te.protocol=="https"?443:80),query:te.query||""};return le.util.merge(Se,Me),!Se["force new connection"]&&le.sockets[Le]||(pe=new le.Socket(Se)),!Se["force new connection"]&&pe&&(le.sockets[Le]=pe),pe=pe||le.sockets[Le],Se["skipped handshake data"]?pe.of(""):pe.of(te.path.length>1?te.path:"")}})(J.exports,j===void 0?window:j);var Z=J.exports;(function(re,ne){var le=re.util={},he=/^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/,Me=["source","protocol","authority","userInfo","user","password","host","port","relative","path","directory","file","query","anchor"];le.parseUri=function(pe){for(var te=he.exec(pe||""),Se={},ce=14;ce--;)Se[Me[ce]]=te[ce]||"";return Se},le.uniqueUri=function(pe){var te=pe.protocol,Se=pe.host,ce=pe.port;return"document"in ne?(Se=Se||document.domain,ce=ce||(te=="https"&&document.location.protocol!=="https:"?443:document.location.port)):(Se=Se||"localhost",ce||te!="https"||(ce=443)),(te||"http")+"://"+Se+":"+(ce||80)},le.query=function(pe,te){var Se=le.chunkQuery(pe||""),ce=[];le.merge(Se,le.chunkQuery(te||""));for(var X in Se)Se.hasOwnProperty(X)&&ce.push(X+"="+Se[X]);return ce.length?"?"+ce.join("&"):""},le.chunkQuery=function(pe){for(var te,Se={},ce=pe.split("&"),X=0,ve=ce.length;X<ve;++X)te=ce[X].split("="),te[0]&&(Se[te[0]]=te[1]);return Se};var Le=!1;le.load=function(pe){if("document"in ne&&document.readyState==="complete"||Le)return pe();le.on(ne,"load",pe,!1)},le.on=function(pe,te,Se,ce){pe.attachEvent?pe.attachEvent("on"+te,Se):pe.addEventListener&&pe.addEventListener(te,Se,ce)},le.request=function(pe){if(pe&&typeof XDomainRequest<"u")return new XDomainRequest;if(typeof XMLHttpRequest<"u"&&(!pe||le.ua.hasCORS))return new XMLHttpRequest;if(!pe)try{return new window[["Active"].concat("Object").join("X")]("Microsoft.XMLHTTP")}catch{}return null},typeof window<"u"&&le.load(function(){Le=!0}),le.defer=function(pe){if(!le.ua.webkit||typeof importScripts<"u")return pe();le.load(function(){setTimeout(pe,100)})},le.merge=function(pe,te,Se,ce){var X,ve=ce||[],Te=Se===void 0?2:Se;for(X in te)te.hasOwnProperty(X)&&le.indexOf(ve,X)<0&&(typeof pe[X]=="object"&&Te?le.merge(pe[X],te[X],Te-1,ve):(pe[X]=te[X],ve.push(te[X])));return pe},le.mixin=function(pe,te){le.merge(pe.prototype,te.prototype)},le.inherit=function(pe,te){function Se(){}Se.prototype=te.prototype,pe.prototype=new Se},le.isArray=Array.isArray||function(pe){return Object.prototype.toString.call(pe)==="[object Array]"},le.intersect=function(pe,te){for(var Se=[],ce=pe.length>te.length?pe:te,X=pe.length>te.length?te:pe,ve=0,Te=X.length;ve<Te;ve++)~le.indexOf(ce,X[ve])&&Se.push(X[ve]);return Se},le.indexOf=function(pe,te,Se){for(var ce=pe.length,Se=Se<0?Se+ce<0?0:Se+ce:Se||0;Se<ce&&pe[Se]!==te;Se++);return ce<=Se?-1:Se},le.toArray=function(pe){for(var te=[],Se=0,ce=pe.length;Se<ce;Se++)te.push(pe[Se]);return te},le.ua={},le.ua.hasCORS=typeof XMLHttpRequest<"u"&&function(){try{var pe=new XMLHttpRequest}catch{return!1}return pe.withCredentials!=null}(),le.ua.webkit=typeof navigator<"u"&&/webkit/i.test(navigator.userAgent)})(Z!==void 0?Z:J.exports,j===void 0?window:j),function(re,ne){function le(){}re.EventEmitter=le,le.prototype.on=function(he,Me){return this.$events||(this.$events={}),this.$events[he]?ne.util.isArray(this.$events[he])?this.$events[he].push(Me):this.$events[he]=[this.$events[he],Me]:this.$events[he]=Me,this},le.prototype.addListener=le.prototype.on,le.prototype.once=function(he,Me){function Le(){pe.removeListener(he,Le),Me.apply(this,arguments)}var pe=this;return Le.listener=Me,this.on(he,Le),this},le.prototype.removeListener=function(he,Me){if(this.$events&&this.$events[he]){var Le=this.$events[he];if(ne.util.isArray(Le)){for(var pe=-1,te=0,Se=Le.length;te<Se;te++)if(Le[te]===Me||Le[te].listener&&Le[te].listener===Me){pe=te;break}if(pe<0)return this;Le.splice(pe,1),Le.length||delete this.$events[he]}else(Le===Me||Le.listener&&Le.listener===Me)&&delete this.$events[he]}return this},le.prototype.removeAllListeners=function(he){return this.$events&&this.$events[he]&&(this.$events[he]=null),this},le.prototype.listeners=function(he){return this.$events||(this.$events={}),this.$events[he]||(this.$events[he]=[]),ne.util.isArray(this.$events[he])||(this.$events[he]=[this.$events[he]]),this.$events[he]},le.prototype.emit=function(he){if(!this.$events)return!1;var Me=this.$events[he];if(!Me)return!1;var Le=Array.prototype.slice.call(arguments,1);if(typeof Me=="function")Me.apply(this,Le);else{if(!ne.util.isArray(Me))return!1;for(var pe=Me.slice(),te=0,Se=pe.length;te<Se;te++)pe[te].apply(this,Le)}return!0}}(Z!==void 0?Z:J.exports,Z!==void 0?Z:J.parent.exports),function(re,ne){if(ne&&ne.parse)return re.JSON={parse:ne.parse,stringify:ne.stringify};throw new Error("JSON not available")}(Z!==void 0?Z:J.exports,typeof JSON<"u"?JSON:void 0),function(re,ne){var le=re.parser={},he=le.packets=["disconnect","connect","heartbeat","message","json","event","ack","error","noop"],Me=le.reasons=["transport not supported","client not handshaken","unauthorized"],Le=le.advice=["reconnect"],pe=ne.JSON,te=ne.util.indexOf;le.encodePacket=function(ce){var X=te(he,ce.type),ve=ce.id||"",Te=ce.endpoint||"",Be=ce.ack,qe=null;switch(ce.type){case"error":var Ge=ce.reason?te(Me,ce.reason):"",tt=ce.advice?te(Le,ce.advice):"";Ge===""&&tt===""||(qe=Ge+(tt!==""?"+"+tt:""));break;case"message":ce.data!==""&&(qe=ce.data);break;case"event":var ct={name:ce.name};ce.args&&ce.args.length&&(ct.args=ce.args),qe=pe.stringify(ct);break;case"json":qe=pe.stringify(ce.data);break;case"connect":ce.qs&&(qe=ce.qs);break;case"ack":qe=ce.ackId+(ce.args&&ce.args.length?"+"+pe.stringify(ce.args):"")}var Mt=[X,ve+(Be=="data"?"+":""),Te];return qe!=null&&Mt.push(qe),Mt.join(":")},le.encodePayload=function(ce){var X="";if(ce.length==1)return ce[0];for(var ve=0,Te=ce.length;ve<Te;ve++)X+="�"+ce[ve].length+"�"+ce[ve];return X};var Se=/([^:]+):([0-9]+)?(\+)?:([^:]+)?:?([\s\S]*)?/;le.decodePacket=function(Te){var X=Te.match(Se);if(!X)return{};var ve=X[2]||"",Te=X[5]||"",Be={type:he[X[1]],endpoint:X[4]||""};switch(ve&&(Be.id=ve,X[3]?Be.ack="data":Be.ack=!0),Be.type){case"error":var X=Te.split("+");Be.reason=Me[X[0]]||"",Be.advice=Le[X[1]]||"";break;case"message":Be.data=Te||"";break;case"event":try{var qe=pe.parse(Te);Be.name=qe.name,Be.args=qe.args}catch{}Be.args=Be.args||[];break;case"json":try{Be.data=pe.parse(Te)}catch{}break;case"connect":Be.qs=Te||"";break;case"ack":var X=Te.match(/^([0-9]+)(\+)?(.*)/);if(X&&(Be.ackId=X[1],Be.args=[],X[3]))try{Be.args=X[3]?pe.parse(X[3]):[]}catch{}break;case"disconnect":Be.reason=Te}return Be},le.decodePayload=function(ce){if(ce.charAt(0)=="�"){for(var X=[],ve=1,Te="";ve<ce.length;ve++)ce.charAt(ve)=="�"?(X.push(le.decodePacket(ce.substr(ve+1).substr(0,Te))),ve+=Number(Te)+1,Te=""):Te+=ce.charAt(ve);return X}return[le.decodePacket(ce)]}}(Z!==void 0?Z:J.exports,Z!==void 0?Z:J.parent.exports),function(re,ne){function le(he,Me){this.socket=he,this.sessid=Me,this.connectErrorCallback=void 0,this.isOpened=!1}re.Transport=le,ne.util.mixin(le,ne.EventEmitter),le.prototype.onData=function(he){if(this.clearCloseTimeout(),(this.socket.connected||this.socket.connecting||this.socket.reconnecting)&&this.setCloseTimeout(),he!==""){var Me=ne.parser.decodePayload(he);if(Me&&Me.length)for(var Le=0,pe=Me.length;Le<pe;Le++)this.onPacket(Me[Le])}return this},le.prototype.onPacket=function(he){return this.socket.setHeartbeatTimeout(),he.type=="heartbeat"?this.onHeartbeat():(he.type=="connect"&&he.endpoint==""&&this.onConnect(),he.type=="error"&&he.advice=="reconnect"&&(this.isOpened=!1),this.socket.onPacket(he),this)},le.prototype.setCloseTimeout=function(){if(!this.closeTimeout){var he=this;this.closeTimeout=setTimeout(function(){he.onDisconnect()},this.socket.closeTimeout)}},le.prototype.onDisconnect=function(){return this.close&&this.isOpened&&this.close(),this.clearTimeouts(),this.socket.onDisconnect(),this},le.prototype.onConnect=function(){return this.socket.onConnect(),this.connectErrorCallback=void 0,this},le.prototype.clearCloseTimeout=function(){this.closeTimeout&&(clearTimeout(this.closeTimeout),this.closeTimeout=null)},le.prototype.clearTimeouts=function(){this.clearCloseTimeout(),this.reopenTimeout&&clearTimeout(this.reopenTimeout)},le.prototype.packet=function(he){this.send(ne.parser.encodePacket(he))},le.prototype.onHeartbeat=function(he){this.packet({type:"heartbeat"})},le.prototype.onOpen=function(){this.isOpened=!0,this.clearCloseTimeout(),this.socket.onOpen()},le.prototype.onClose=function(){this.isOpened=!1,this.socket.onClose(),this.onDisconnect()},le.prototype.prepareUrl=function(he){var Me=this.socket.options;if(Me["skipped handshake data"])return Me.rewriteUrlForProxy(Me["skipped handshake data"].websocketUrl+(he||""));var Le=this.scheme()+"://"+Me.host+":"+Me.port+"/"+Me.resource+"/"+ne.protocol+"/"+this.name+"/"+this.sessid+(he||"");return Me.rewriteUrlForProxy(Le)},le.prototype.ready=function(he,Me){Me.call(this)},le.prototype.clearEventHandlers=function(){return this}}(Z!==void 0?Z:J.exports,Z!==void 0?Z:J.parent.exports),function(re,ne,le){function he(Le){if(this.options={port:80,secure:!1,document:"document"in le&&document,resource:"socket.io",transports:ne.transports.slice(),"connect timeout":1e4,"try multiple transports":!0,reconnect:!0,"reconnection delay":500,"reconnection limit":1/0,"reopen delay":3e3,"max reconnection attempts":10,"sync disconnect on unload":!0,"auto connect":!0,"flash policy port":10843},ne.util.merge(this.options,Le),this.connected=!1,this.open=!1,this.connecting=!1,this.reconnecting=!1,this.namespaces={},this.buffer=[],this.doBuffer=!1,this.disconnected=!1,this.options["sync disconnect on unload"]&&(!this.isXDomain()||ne.util.ua.hasCORS)){var pe=this;ne.util.on(le,"unload",function(){pe.disconnectSync()},!1)}this.options["auto connect"]&&this.connect()}function Me(){}re.Socket=he,ne.util.mixin(he,ne.EventEmitter),he.prototype.of=function(Le){return this.namespaces[Le]||(this.namespaces[Le]=new ne.SocketNamespace(this,Le),Le!==""&&this.namespaces[Le].packet({type:"connect"})),this.namespaces[Le]},he.prototype.publish=function(){this.emit.apply(this,arguments);var Le;for(var pe in this.namespaces)this.namespaces.hasOwnProperty(pe)&&(Le=this.of(pe),Le.$emit.apply(Le,arguments))},he.prototype.handshake=function(Le){function pe(qe){qe instanceof Error?te.onError(qe.message):Le.apply(null,qe.split(":"))}var te=this,Se=this.options;if(!te.disconnected){var ce=Se.rewriteUrlForProxy(["http"+(Se.secure?"s":"")+":/",Se.host+":"+Se.port,Se.resource,ne.protocol,ne.util.query(this.options.query,"t="+ +new Date)].join("/"));if(this.isXDomain()&&!ne.util.ua.hasCORS){var X=document.getElementsByTagName("script")[0],ve=document.createElement("script");ve.src=ce+"&jsonp="+ne.j.length,X.parentNode.insertBefore(ve,X),ne.j.push(function(qe){pe(qe),ve.parentNode.removeChild(ve)})}else{var Te=ne.util.request();Te.open("GET",ce,!0);var Be=this.options.requestHeaders;Be!==void 0&&Object.keys(Be).forEach(function(qe){Te.setRequestHeader(qe,Be[qe])}),Te.onreadystatechange=function(){Te.readyState==4&&(Te.onreadystatechange=Me,Te.status==200?pe(Te.responseText):!te.reconnecting&&te.onError(Te.responseText))},Te.send(null)}}},he.prototype.getTransport=function(Le){for(var pe,te=Le||this.transports,Se=0;pe=te[Se];Se++)if(ne.Transport[pe]&&ne.Transport[pe].check(this)&&(!this.isXDomain()||ne.Transport[pe].xdomainCheck()))return new ne.Transport[pe](this,this.sessionid);return null},he.prototype.connect=function(Le){if(this.connecting||this.disconnected)return this;var pe=this,te=function(ce,X,ve,Te){function Be(){if(!pe.connected&&!pe.disconnected)if(pe.connecting=!1,clearTimeout(pe.connectTimeoutTimer),pe.options["try multiple transports"]){for(;pe.remainingTransports.length>0&&pe.remainingTransports.splice(0,1)[0]!=pe.transport.name;);pe.remainingTransports.length?qe(pe.remainingTransports):pe.publish("connect_failed")}else pe.publish("connect_failed")}function qe(Ge){if(pe.transport&&(pe.transport.clearTimeouts(),pe.transport.clearEventHandlers()),pe.transport=pe.getTransport(Ge),!pe.transport||pe.disconnected)return pe.publish("connect_failed");pe.transport.ready(pe,function(){pe.connecting=!0,pe.publish("connecting",pe.transport.name),pe.transport.open(Be),pe.options["connect timeout"]&&(pe.connectTimeoutTimer=setTimeout(function(){Be()},pe.options["connect timeout"]))})}pe.sessionid=ce,pe.closeTimeout=1e3*ve+2e3,pe.heartbeatTimeout=1e3*X+2e3,pe.transports=Te?ne.util.intersect(Te.split(","),pe.options.transports):pe.options.transports,pe.setHeartbeatTimeout(),pe.remainingTransports=pe.transports.slice(0),qe(pe.transports),pe.once("connect",function(){clearTimeout(pe.connectTimeoutTimer),Le&&typeof Le=="function"&&Le()})};if(this.options["skipped handshake data"]){var Se=this.options["skipped handshake data"];te("v4c-"+new Date().getTime(),Se.timeout,Se.timeout,"websocket")}else this.handshake(te);return this},he.prototype.setHeartbeatTimeout=function(){clearTimeout(this.heartbeatTimeoutTimer);var Le=this;this.heartbeatTimeoutTimer=setTimeout(function(){Le.transport.onClose()},this.heartbeatTimeout)},he.prototype.packet=function(Le){return this.connected&&!this.doBuffer?this.transport.packet(Le):this.buffer.push(Le),this},he.prototype.setBuffer=function(Le){this.doBuffer=Le,!Le&&this.connected&&this.buffer.length&&(this.transport.payload(this.buffer),this.buffer=[])},he.prototype.disconnect=function(){return(this.connected||this.connecting)&&(this.open&&this.of("").packet({type:"disconnect"}),this.onDisconnect("booted")),this.disconnected=!0,this},he.prototype.disconnectSync=function(){var Le=ne.util.request(),pe=this.resource+"/"+ne.protocol+"/"+this.sessionid;Le.open("GET",pe,!0),this.onDisconnect("booted")},he.prototype.isXDomain=function(){var Le=le.location.port||(le.location.protocol=="https:"?443:80);return this.options.host!==le.location.hostname||this.options.port!=Le},he.prototype.onConnect=function(){this.connected||(this.connected=!0,this.connecting=!1,this.doBuffer||this.setBuffer(!1),this.emit("connect"))},he.prototype.onOpen=function(){this.open=!0},he.prototype.onClose=function(){this.open=!1,clearTimeout(this.heartbeatTimeoutTimer)},he.prototype.onPacket=function(Le){this.of(Le.endpoint).onPacket(Le)},he.prototype.onError=function(Le){Le&&Le.advice&&Le.advice==="reconnect"&&(this.connected||this.connecting)&&(this.disconnect(),this.options.reconnect&&this.reconnect()),this.publish("error",Le&&Le.reason?Le.reason:Le)},he.prototype.onDisconnect=function(Le){var pe=this.connected,te=this.connecting;this.connected=!1,this.connecting=!1,this.open=!1,(pe||te)&&(this.transport.close(),this.transport.clearTimeouts(),pe?(this.publish("disconnect",Le),Le!="booted"&&this.options.reconnect&&!this.reconnecting&&this.reconnect()):this.publish("close_during_connecting",Le))},he.prototype.reconnect=function(){function Le(){if(te.connected){for(var ve in te.namespaces)te.namespaces.hasOwnProperty(ve)&&ve!==""&&te.namespaces[ve].packet({type:"connect"});te.publish("reconnect",te.transport.name,te.reconnectionAttempts)}clearTimeout(te.reconnectionTimer),te.removeListener("connect_failed",pe),te.removeListener("connect",pe),te.reconnecting=!1,delete te.reconnectionAttempts,delete te.reconnectionDelay,delete te.reconnectionTimer,delete te.redoTransports,te.options["try multiple transports"]=ce}function pe(){if(te.reconnecting)return te.connected?Le():te.connecting&&te.reconnecting?te.reconnectionTimer=setTimeout(pe,1e3):void(te.reconnectionAttempts++>=Se?te.redoTransports?(te.publish("reconnect_failed"),Le()):(te.on("connect_failed",pe),te.options["try multiple transports"]=!0,te.transport=te.getTransport(),te.redoTransports=!0,te.connect()):(te.reconnectionDelay<X&&(te.reconnectionDelay*=2),te.connect(),te.publish("reconnecting",te.reconnectionDelay,te.reconnectionAttempts),te.reconnectionTimer=setTimeout(pe,te.reconnectionDelay)))}this.reconnecting=!0,this.reconnectionAttempts=0,this.reconnectionDelay=this.options["reconnection delay"];var te=this,Se=this.options["max reconnection attempts"],ce=this.options["try multiple transports"],X=this.options["reconnection limit"];this.options["try multiple transports"]=!1,this.reconnectionTimer=setTimeout(pe,this.reconnectionDelay),this.on("connect",pe)}}(Z!==void 0?Z:J.exports,Z!==void 0?Z:J.parent.exports,j===void 0?window:j),function(re,ne){function le(Me,Le){this.socket=Me,this.name=Le||"",this.flags={},this.json=new he(this,"json"),this.ackPackets=0,this.acks={}}function he(Me,Le){this.namespace=Me,this.name=Le}re.SocketNamespace=le,ne.util.mixin(le,ne.EventEmitter),le.prototype.$emit=ne.EventEmitter.prototype.emit,le.prototype.of=function(){return this.socket.of.apply(this.socket,arguments)},le.prototype.packet=function(Me){return Me.endpoint=this.name,this.socket.packet(Me),this.flags={},this},le.prototype.send=function(Me,Le){var pe={type:this.flags.json?"json":"message",data:Me};return typeof Le=="function"&&(pe.id=++this.ackPackets,pe.ack=!0,this.acks[pe.id]=Le),this.packet(pe)},le.prototype.emit=function(Me){var Le=Array.prototype.slice.call(arguments,1),pe=Le[Le.length-1],te={type:"event",name:Me};return typeof pe=="function"&&(te.id=++this.ackPackets,te.ack="data",this.acks[te.id]=pe,Le=Le.slice(0,Le.length-1)),te.args=Le,this.packet(te)},le.prototype.disconnect=function(){return this.name===""?this.socket.disconnect():(this.packet({type:"disconnect"}),this.$emit("disconnect")),this},le.prototype.onPacket=function(Me){function Le(){pe.packet({type:"ack",args:ne.util.toArray(arguments),ackId:Me.id})}var pe=this;switch(Me.type){case"connect":this.$emit("connect");break;case"disconnect":this.name===""?this.socket.onDisconnect(Me.reason||"booted"):this.$emit("disconnect",Me.reason||"");break;case"message":case"json":var te=["message",Me.data];Me.ack=="data"?te.push(Le):Me.ack&&this.packet({type:"ack",ackId:Me.id}),this.$emit.apply(this,te);break;case"event":var te=[Me.name].concat(Me.args);Me.ack=="data"&&te.push(Le),this.$emit.apply(this,te);break;case"ack":this.acks[Me.ackId]&&(this.acks[Me.ackId].apply(this,Me.args),delete this.acks[Me.ackId]);break;case"error":Me.advice?this.socket.onError(Me):Me.reason=="unauthorized"?this.$emit("connect_failed",Me.reason):this.$emit("error",Me.reason)}},he.prototype.send=function(){this.namespace.flags[this.name]=!0,this.namespace.send.apply(this.namespace,arguments)},he.prototype.emit=function(){this.namespace.flags[this.name]=!0,this.namespace.emit.apply(this.namespace,arguments)}}(Z!==void 0?Z:J.exports,Z!==void 0?Z:J.parent.exports),function(re,ne,le){function he(Le){ne.Transport.apply(this,arguments)}function Me(){}re.websocket=he,ne.util.inherit(he,ne.Transport),he.prototype.name="websocket",he.prototype.open=function(Le){var pe,te=ne.util.query(this.socket.options.query),Se=this;return this.connectErrorCallback=Le,pe||(pe=le.MozWebSocket||le.WebSocket),this.websocket=new pe(this.prepareUrl(te)),this.websocket.onopen=function(){Se.onOpen(),Se.socket.setBuffer(!1)},this.websocket.onmessage=function(ce){Se.onData(ce.data)},this.websocket.onclose=function(){Se.onClose(),Se.socket.setBuffer(!0)},this.websocket.onerror=function(ce){Se.onError(ce)},this},he.prototype.send=function(Le){return this.websocket.send(Le),this},he.prototype.payload=function(Le){for(var pe=0,te=Le.length;pe<te;pe++)this.packet(Le[pe]);return this},he.prototype.close=function(){return this.websocket.close(),this},he.prototype.onError=function(Le){this.connectErrorCallback!==void 0&&(this.connectErrorCallback(),this.connectErrorCallback=void 0),this.socket.onError(Le)},he.prototype.scheme=function(){return this.socket.options.secure?"wss":"ws"},he.check=function(){return"WebSocket"in le&&!("__addTask"in WebSocket)||"MozWebSocket"in le},he.xdomainCheck=function(){return!0},he.prototype.clearEventHandlers=function(){return this.websocket&&(this.websocket.onopen=this.websocket.onmessage=this.websocket.onclose=this.websocket.onerror=Me),this},ne.transports.push("websocket")}(Z!==void 0?Z.Transport:J.exports,Z!==void 0?Z:J.parent.exports,j===void 0?window:j),function(re,ne,le){function he(Le){Le&&ne.Transport.apply(this,arguments)}function Me(){}re.XHR=he,ne.util.inherit(he,ne.Transport),he.prototype.open=function(){return this.socket.setBuffer(!1),this.onOpen(),this.get(),this.setCloseTimeout(),this},he.prototype.payload=function(Le){for(var pe=[],te=0,Se=Le.length;te<Se;te++)pe.push(ne.parser.encodePacket(Le[te]));this.send(ne.parser.encodePayload(pe))},he.prototype.send=function(Le){return this.post(Le),this},he.prototype.post=function(Le){function pe(){this.readyState==4&&(this.onreadystatechange=Me,this.status==200?(clearTimeout(this.ackTimeoutTimer),Se.socket.setBuffer(!1)):Se.onClose())}function te(){this.onload=Me,Se.socket.setBuffer(!1)}var Se=this;this.socket.setBuffer(!0),this.sendXHR=this.request("POST"),le.XDomainRequest&&this.sendXHR instanceof XDomainRequest?this.sendXHR.onload=this.sendXHR.onerror=te:this.sendXHR.onreadystatechange=pe,this.sendXHR.send(Le),Se.sendXHR.ackTimeoutTimer=setTimeout(function(){Se.onClose()},Se.socket.options.ackTimeoutMs)},he.prototype.close=function(){return this.onClose(),this},he.prototype.request=function(Le){var pe=ne.util.request(this.socket.isXDomain()),te=ne.util.query(this.socket.options.query,"t="+ +new Date);pe.open(Le||"GET",this.prepareUrl(te),!0);var Se=this.socket.options.requestHeaders;if(Se!==void 0&&Object.keys(Se).forEach(function(ce){pe.setRequestHeader(ce,Se[ce])}),Le=="POST")try{pe.setRequestHeader?pe.setRequestHeader("Content-type","text/plain;charset=UTF-8"):pe.contentType="text/plain"}catch{}return pe},he.prototype.scheme=function(){return this.socket.options.secure?"https":"http"},he.check=function(Le,pe){try{var te=ne.util.request(pe),Se=le.XDomainRequest&&te instanceof XDomainRequest,ce=Le&&Le.options&&Le.options.secure?"https:":"http:",X=ce!=le.location.protocol;if(te&&(!Se||!X))return!0}catch{}return!1},he.xdomainCheck=function(){return he.check(null,!0)},he.prototype.clearEventHandlers=function(){return this.sendXHR&&(this.sendXHR.onreadystatechange=this.sendXHR.onload=Me),this}}(Z!==void 0?Z.Transport:J.exports,Z!==void 0?Z:J.parent.exports,j===void 0?window:j),function(re,ne,le){function he(){ne.Transport.XHR.apply(this,arguments)}function Me(){}re["xhr-polling"]=he,ne.util.inherit(he,ne.Transport.XHR),ne.util.merge(he,ne.Transport.XHR),he.prototype.name="xhr-polling",he.prototype.open=function(Le){var pe=this;return pe.connectErrorCallback=Le,ne.Transport.XHR.prototype.open.call(pe),!1},he.prototype.get=function(){function Le(){this.readyState==4&&(this.onreadystatechange=Me,this.status==200?(Se.connectErrorCallback=void 0,Se.onData(this.responseText),Se.get()):(Se.onClose(),Se.connectErrorCallback!==void 0&&(Se.connectErrorCallback(),Se.connectErrorCallback=void 0)))}function pe(){Se.connectErrorCallback=void 0,this.onload=Me,this.onerror=Me,Se.onData(this.responseText),Se.get()}function te(){Se.onClose(),Se.connectErrorCallback!==void 0&&(Se.connectErrorCallback(),Se.connectErrorCallback=void 0)}if(this.isOpened){var Se=this;this.xhr=this.request(),le.XDomainRequest&&this.xhr instanceof XDomainRequest?(this.xhr.onload=pe,this.xhr.onerror=te):this.xhr.onreadystatechange=Le,this.xhr.send(null)}},he.prototype.onClose=function(){if(ne.Transport.XHR.prototype.onClose.call(this),this.xhr){this.xhr.onreadystatechange=this.xhr.onload=this.xhr.onerror=Me;try{this.xhr.abort()}catch{}this.xhr=null}},he.prototype.ready=function(Le,pe){var te=this;ne.util.defer(function(){pe.call(te)})},he.prototype.clearEventHandlers=function(){return ne.Transport.XHR.prototype.clearEventHandlers.call(this),this.xhr&&(this.xhr.onreadystatechange=this.xhr.onload=this.xhr.onerror=Me),this},ne.transports.push("xhr-polling")}(Z!==void 0?Z.Transport:J.exports,Z!==void 0?Z:J.parent.exports,j===void 0?window:j),z.io=Z}).call(z,H(13),H(14)(L))},function(L,z){var H;H=function(){return this}();try{H=H||Function("return this")()||(0,eval)("this")}catch{typeof window=="object"&&(H=window)}L.exports=H},function(L,z){L.exports=function(H){return H.webpackPolyfill||(H.deprecate=function(){},H.paths=[],H.children||(H.children=[]),Object.defineProperty(H,"loaded",{enumerable:!0,get:function(){return H.l}}),Object.defineProperty(H,"id",{enumerable:!0,get:function(){return H.i}}),H.webpackPolyfill=1),H}},function(L,z,H){Object.defineProperty(z,"__esModule",{value:!0}),z.ConnectionTracker=z.Properties=z.TrackerStep=z.ClientEventName=z.ResponseData=void 0;var j=H(3),J=H(1),Z=H(0),re=function(){function te(Se){this.id=Se,this.status=200,this.headers={},this.body=""}return te}();z.ResponseData=re;var ne;(function(te){te.Connected="trouter_js_client_connected",te.Disconnected="trouter_js_client_disconnected",te.Error="trouter_js_client_error",te.Progress="trouter_js_client_progress",te.Response="trouter_js_client_response",te.Request="trouter_js_client_request",te.CheckConnection="trouter_js_client_check_connection",te.Registration="trouter_js_client_registration",te.Unregistration="trouter_js_client_unregistration"})(ne||(z.ClientEventName=ne={}));var le=function(){function te(Se,ce,X,ve,Te){this.stepName=Se,this.operation=ce,this.delta=X,this.ts=ve,this.error=Te}return te}();z.TrackerStep=le;var he=function(){function te(){}return te}();z.Properties=he;var Me=function(){function te(){this.numberOfPingReplies=0,this.connectedTimestamp=0,this.isNewUrl=!1,this.transportType="",this.connectionNumber=0}return te}(),Le=function(){function te(){this.enabled=!1,this.numberOfStepsToMaintain=40,this.logHealthCheckError=!1,this.sendProgressTimeoutSecs=55,this.logSendPingError=!1,this.maxBackoffInMs=12e4,this.trouter_js_client_connected=!1,this.trouter_js_client_disconnected=!1,this.trouter_js_client_error=!1,this.trouter_js_client_progress=!1,this.trouter_js_client_response=!1,this.trouter_js_client_request=!1,this.trouter_js_client_registration=!1,this.trouter_js_client_unregistration=!1,this.trouter_js_client_check_connection=!0}return te}(),pe=function(){function te(Se,ce,X,ve,Te,Be,qe){this.clientId=ce,this.clientInfo=X,this.getServerState=ve,this.endpointId=Te,this.clientCorrelationID=Be,this.environment=qe,this.logger=new Z.Logger("ConnectionTracker",Se),this.clientCorrelationID=Be!==void 0?Be:"",this.steps=[],this.connectionAttempt=0,this.totalStepCount=0,this.beginTimestamp=new j.Timespan,this.eventLogSettings=new Le,this.connectedInfo=new Me}return te.prototype.enable=function(Se){this.eventLogSettings.enabled=!0,this.eventLogger=Se},te.prototype.disable=function(){this.eventLogSettings.enabled=!1},te.prototype.sendProgress=function(Se){this.steps.length>0&&this.sendTelemetry(ne.Progress,Se,this.steps)},te.prototype.cancelProgressTimer=function(){this.progressTimeout!==void 0&&(clearTimeout(this.progressTimeout),this.progressTimeout=void 0)},te.prototype.resetProgressSendTimer=function(){var Se=this;this.cancelProgressTimer(),this.eventLogSettings.sendProgressTimeoutSecs!==void 0&&this.eventLogSettings.sendProgressTimeoutSecs>0&&(this.progressTimeout=setTimeout(function(){Se.sendProgress({reason:"timeout",timeoutSecs:Se.eventLogSettings.sendProgressTimeoutSecs})},1e3*this.eventLogSettings.sendProgressTimeoutSecs))},te.prototype.setConnectedInfo=function(Se,ce){this.connectedInfo.numberOfPingReplies=0,this.connectedInfo.connectedTimestamp=Date.now(),this.connectedInfo.isNewUrl=Se,this.connectedInfo.transportType=ce,++this.connectedInfo.connectionNumber},te.prototype.clearConnectedInfo=function(){this.connectedInfo.numberOfPingReplies=0,this.connectedInfo.connectedTimestamp=0,this.connectedInfo.isNewUrl=!0,this.connectedInfo.transportType=""},te.prototype.copyProperties=function(Se,ce){for(var X=0,ve=Object.keys(ce);X<ve.length;X++){var Te=ve[X];ce[Te]!==void 0&&(Se[Te.replace(/-/g,"_")]={value:ce[Te]})}},te.prototype.increasePingResponseCount=function(){++this.connectedInfo.numberOfPingReplies},te.prototype.sendTelemetry=function(Se,ce,X){try{if(this.eventLogSettings.enabled===!0&&this.eventLogSettings[Se]===!0&&this.eventLogger!==void 0){var ve=this.getServerState(),Te={name:Se,properties:{connectionAttempt:{value:this.connectionAttempt},epid:{value:this.endpointId},clientCorrelationID:{value:this.clientCorrelationID},steps:{value:(0,j.toJson)(X)},clientID:{value:this.clientId},eventVersion:{value:3},environment:{value:this.environment},cv:{value:J.CLIENT_VERSION},ua:{value:this.clientInfo.ua},connectionId:{value:ve.connectionId},connectedClientId:{value:ve.connectedClientId},domId:{value:ve.domId},url:{value:ve.unsecureUrl},surl:{value:ve.url},ttlInSecs:{value:ve.getRemainingTtlInSec()},numberOfPingReplies:{value:this.connectedInfo.numberOfPingReplies},connectedTimestamp:{value:this.connectedInfo.connectedTimestamp},isNewUrl:{value:this.connectedInfo.isNewUrl},transportType:{value:this.connectedInfo.transportType},connectionNumber:{value:this.connectedInfo.connectionNumber}}};this.copyProperties(Te.properties,ce),this.eventLogger.logEvent(Te)}}catch(Be){this.logger.warn("error in sending event ".concat(Se,": ").concat((0,j.toJson)(Be)))}},te.prototype.createStep=function(Se,ce,X){return new le(Se,ce,this.beginTimestamp.duration,Date.now(),X)},te.prototype.addStep=function(Se,ce,X){if(this.eventLogSettings.enabled!==!1&&(this.steps.length===0&&this.beginTimestamp.reset(),this.steps.push(this.createStep(Se,ce,X)),++this.totalStepCount,this.eventLogSettings.numberOfStepsToMaintain!==void 0&&this.steps.length>this.eventLogSettings.numberOfStepsToMaintain)){var ve=this.steps.slice(0);this.steps.length=0,this.sendTelemetry(ne.Progress,{reason:"flush"},ve)}},te.prototype.trackStart=function(Se){this.addStep(Se,"start")},te.prototype.trackEnd=function(Se){this.addStep(Se,"end")},te.prototype.trackError=function(Se,ce,X,ve){X===void 0&&(X=!0),Se==="health"&&this.eventLogSettings.logHealthCheckError!==!0||Se==="ping"&&this.eventLogSettings.logSendPingError===!1||(ve===void 0&&(ve="error"),X===!0&&this.addStep(Se,ve,ce),this.sendTelemetry(ne.Error,{},[this.createStep(Se,ve,ce)]))},te.prototype.trackProgress=function(Se,ce){this.addStep(Se,ce)},te.prototype.trackConnected=function(Se,ce){this.setConnectedInfo(Se,ce);var X=this.steps.slice(0),ve=this.totalStepCount,Te=this.beginTimestamp.duration;this.steps.length=0,this.totalStepCount=0,this.sendTelemetry(ne.Connected,{stepCount:X.length,totalStepCount:ve,connectionEstablishmentMs_Total:Te},X),this.cancelProgressTimer()},te.prototype.getSessionLength=function(){return Date.now()-this.connectedInfo.connectedTimestamp},te.prototype.trackDisconnected=function(Se){Se.sessionLengthMS=this.getSessionLength(),this.sendTelemetry(ne.Disconnected,Se,[]),this.resetProgressSendTimer()},te.prototype.trackNewConnection=function(){++this.connectionAttempt},te.prototype.trackRequest=function(Se,ce){var X={};ce!==void 0&&(X.hasError=!0,X.error=ce);try{if(Se){X.requestID=Se.id,X.httpMethod=Se.method,X.url=Se.url,X.bodyLength=Se.body.length,X.shortUrl=Se.shortUrl,X.requestTimeStamp=Se.startTS,X.correlationVector=Se.correlationVector;for(var ve=Se.headers,Te=0,Be=Object.keys(ve);Te<Be.length;Te++){var qe=Be[Te];X[qe]=ve[qe]}}}catch(Ge){X.hasError=!0,X.error="".concat(X.error," error creating request context ").concat((0,j.toJson)(Ge))}this.sendTelemetry(ne.Request,X,[])},te.prototype.trackResponse=function(Se,ce,X,ve){var Te={};ve!==void 0&&(Te.hasError=!0,Te.error=ve);try{if(Te.responseTimestamp=X!==void 0?X.sentTS:Date.now(),Se){Te.requestID=Se.id,Te.httpMethod=Se.method,Te.shortUrl=Se.shortUrl,Te.correlationVector=Se.correlationVector;for(var Be=Se.headers,qe=0,Ge=Object.keys(Be);qe<Ge.length;qe++){var tt=Ge[qe];Te[tt]=Be[tt]}}X&&(Te.latencyMS=ce,Te.responseCode=X.status,Te.responseLength=X.body.length)}catch(ct){Te.hasError=!0,Te.error="".concat(Te.error," error creating response context ").concat((0,j.toJson)(ct))}this.sendTelemetry(ne.Response,Te,[])},te.prototype.sendResponseError=function(Se,ce,X){this.trackResponse(ce,void 0,X,Se)},te.prototype.close=function(){this.sendProgress({reason:"closed"}),this.steps.length=0,this.cancelProgressTimer()},te.prototype.mergeSettings=function(Se){if(Se){this.eventLogSettings.numberOfStepsToMaintain=Math.min(40,Math.max(10,Se.numberOfStepsToMaintain!==void 0?Se.numberOfStepsToMaintain:0));var ce=Math.min(3600,Math.max(55,Se.sendProgressTimeoutSecs!==void 0?Se.sendProgressTimeoutSecs:0));this.eventLogSettings.logHealthCheckError=Se.logHealthCheckError,this.eventLogSettings.logSendPingError=Se.logSendPingError;for(var X=0,ve=Object.keys(ne).map(function(Be){return ne[Be]});X<ve.length;X++){var Te=ve[X];Se[Te]!==void 0&&(this.eventLogSettings[Te]=Se[Te])}this.eventLogSettings.sendProgressTimeoutSecs!==ce&&(this.eventLogSettings.sendProgressTimeoutSecs=ce,this.resetProgressSendTimer())}},te}();z.ConnectionTracker=pe},function(L,z,H){Object.defineProperty(z,"__esModule",{value:!0}),z.DisconnectReason=void 0;var j=function(){function J(Z,re,ne){this.reason=Z,this.claims=re,this.details=ne}return J.fromRawReason=function(Z,re){if(Z===""||Z==="dup")return new J(Z);try{var ne=JSON.parse(Z);return typeof ne!="object"||ne.reason===void 0?(re?.error("invalid disconnect reason format"),new J("unknown",void 0,Z)):new J(ne.reason,ne.claims,ne.details)}catch{return new J("disconnect",void 0,Z)}},J.fromSocketIoEventData=function(Z,re){return typeof re=="string"?new J(Z,void 0,re):void 0},J.prototype.toTelemetryString=function(){return this.reason==="socketerror"||this.reason==="reconnecterror"||this.reason==="disconnect"?this.details:this.reason},J}();z.DisconnectReason=j},function(L,z,H){function j(Z,re,ne){if(Z===void 0||re===void 0)return!1;var le=Date.now()-Z;return le>re*ne.tolerance&&le>ne.minimumWaitMs}Object.defineProperty(z,"__esModule",{value:!0}),z.ExponentialBackoff=void 0;var J=function(){function Z(re,ne,le){le===void 0&&(le={tolerance:2,minimumWaitMs:1e4}),this.logger=re,this.maxBackoffInMs=ne,this.gapDetectionSettings=le,this.backoffId=0,this.backoffCount=0}return Z.calculateNextBackoffMs=function(re,ne){var le=1+.4*(Math.random()-.5),he=1e3*Math.pow(2,re)*le;return he=Math.round(he),Math.min(ne,he)},Z.prototype.setMaxBackoffMs=function(re){this.maxBackoffInMs=re},Z.prototype.backoff=function(re,ne){var le=this;if(this.timerHandle!==void 0&&(this.logger.debug("Clearing current back off"),clearTimeout(this.timerHandle),this.timerHandle=void 0),this.previousCompleteTime!==void 0){var he=Date.now()-this.previousCompleteTime;he>this.maxBackoffInMs*this.gapDetectionSettings.tolerance&&he>this.gapDetectionSettings.minimumWaitMs&&(this.logger.info("Back off for ".concat(re," with ID ").concat(this.backoffId," will be reset due to a lot of time having passed since the previous backoff (").concat(he," ms)")),this.backoffCount=0,this.previousCompleteTime=void 0)}var Me=Z.calculateNextBackoffMs(this.backoffCount,this.maxBackoffInMs);this.backoffId++,this.backoffCount++,this.logger.info("Backing off ".concat(re," for ").concat(Me," milliseconds with ID ").concat(this.backoffId)),this.callback=function(pe,te){j(pe,te,le.gapDetectionSettings)&&(le.logger.info("Back off for ".concat(re," with ID ").concat(le.backoffId," will be reset due to the wait (").concat(Date.now()-(pe??0)," ms) being longer than expected (").concat(te," ms)")),le.backoffCount=0),le.logger.info("Back off for ".concat(re," with ID ").concat(le.backoffId," complete, invoking handler")),le.timerHandle=void 0,le.callback=void 0,le.previousCompleteTime=Date.now(),ne()};var Le=Date.now();this.timerHandle=setTimeout(function(){var pe;return(pe=le.callback)===null||pe===void 0?void 0:pe.call(le,Le,Me)},Me)},Z.prototype.reset=function(){this.timerHandle!==void 0&&(this.logger.debug("Resetting back off with ID ".concat(this.backoffId)),clearTimeout(this.timerHandle),this.timerHandle=void 0,this.callback=void 0),this.backoffCount=0},Z.prototype.expediteIfPending=function(){if(this.backoffCount=0,this.timerHandle!==void 0){this.logger.debug("Expediting back off with ID ".concat(this.backoffId)),clearTimeout(this.timerHandle),this.timerHandle=void 0;var re=this.callback;this.callback=void 0,re&&re()}},Z}();z.ExponentialBackoff=J},function(L,z,H){var j=this&&this.__spreadArray||function(ne,le,he){if(he||arguments.length===2)for(var Me,Le=0,pe=le.length;Le<pe;Le++)!Me&&Le in le||(Me||(Me=Array.prototype.slice.call(le,0,Le)),Me[Le]=le[Le]);return ne.concat(Me||Array.prototype.slice.call(le))};Object.defineProperty(z,"__esModule",{value:!0}),z.LoggingManagerConsumer=z.RegistrationEnforcer=void 0;var J=H(6),Z=function(){function ne(le,he,Me){this.wrapped=le,this.shouldConnectionDependOnRegistration=he,this.shouldHoldBackEvents=Me,this.isRegistered=!1,this.heldBackEvents=[]}return ne.prototype.onDownstreamRequest=function(le,he,Me){this.passIfRegisteredOrNotNeeded("onDownstreamRequest",le,he,Me)},ne.prototype.onConnected=function(le){this.passIfRegisteredOrNotNeeded("onConnected",le)},ne.prototype.onRegistered=function(le){this.isRegistered=!0,this.wrapped.onRegistered(le),this.fireHeldBackEvents()},ne.prototype.onUnregistered=function(le){this.isRegistered=!1,this.wrapped.onUnregistered(le),le.getState()===J.State.Connected&&this.shouldConnectionDependOnRegistration()&&le.forceReconnectDueToNoRegistration()},ne.prototype.onReconnecting=function(le){this.wrapped.onReconnecting(le)},ne.prototype.onReconnectIsRequired=function(le,he,Me){this.wrapped.onReconnectIsRequired(le,he,Me)},ne.prototype.onDisconnected=function(le){this.isRegistered=!1,this.dropHeldBackEvents(),this.wrapped.onDisconnected(le)},ne.prototype.onTerminalError=function(le){this.wrapped.onTerminalError(le)},ne.prototype.onConnectionParametersUpdated=function(le){this.wrapped.onConnectionParametersUpdated(le)},ne.prototype.onTrouterMessageLost=function(le){this.passIfRegisteredOrNotNeeded("onTrouterMessageLost",le)},ne.prototype.onUserActivityStateAccepted=function(le){this.passIfRegisteredOrNotNeeded("onUserActivityStateAccepted",le)},ne.prototype.onAudiencesSetResolved=function(le,he){this.passIfRegisteredOrNotNeeded("onAudiencesSetResolved",le,he)},ne.prototype.getState=function(){return this.wrapped.getState()},ne.prototype.holdBackEvent=function(le){for(var he=[],Me=1;Me<arguments.length;Me++)he[Me-1]=arguments[Me];this.heldBackEvents.push({kind:le,args:he})},ne.prototype.passIfRegisteredOrNotNeeded=function(le){for(var he,Me=[],Le=1;Le<arguments.length;Le++)Me[Le-1]=arguments[Le];var pe=this.shouldConnectionDependOnRegistration(),te=this.shouldHoldBackEvents();pe&&te||this.fireHeldBackEvents(pe?function(Se){return Se.kind!=="onConnected"}:void 0),this.isRegistered||!pe||te===!1&&le!=="onConnected"?(he=this.wrapped)[le].apply(he,Me):this.holdBackEvent.apply(this,j([le],Me,!1))},ne.prototype.fireHeldBackEvents=function(le){for(var he,Me=0,Le=this.heldBackEvents;Me<Le.length;Me++){var pe=Le[Me];(le===void 0||le(pe))&&(he=this.wrapped)[pe.kind].apply(he,pe.args)}this.heldBackEvents=le===void 0?[]:this.heldBackEvents.filter(function(te){return!le(te)})},ne.prototype.dropHeldBackEvents=function(){this.heldBackEvents=[]},ne}();z.RegistrationEnforcer=Z;var re=function(){function ne(le,he,Me,Le){this.wrapped=le,this.prefix=he,this.logger=Me,this.onEventAction=Le}return ne.prototype.onEvent=function(le,he){var Me;this.onEventAction!==void 0?this.onEventAction(le,he):((Me=this.logger)!==null&&Me!==void 0?Me:console).log("".concat(this.prefix," TracingEnforcer: ").concat(le,"(").concat(he,")"))},ne.prototype.onDownstreamRequest=function(le,he,Me){this.onEvent("onDownstreamRequest",JSON.stringify({request:he,response:Me})),this.wrapped.onDownstreamRequest(le,he,Me)},ne.prototype.onConnected=function(le){this.onEvent("onConnected",le.getState().toString()),this.wrapped.onConnected(le)},ne.prototype.onRegistered=function(le){this.onEvent("onRegistered",le.getState().toString()),this.wrapped.onRegistered(le)},ne.prototype.onUnregistered=function(le){this.onEvent("onUnregistered",le.getState().toString()),this.wrapped.onUnregistered(le)},ne.prototype.onReconnecting=function(le){this.onEvent("onReconnecting",le.getState().toString()),this.wrapped.onReconnecting(le)},ne.prototype.onReconnectIsRequired=function(le,he,Me){this.onEvent("onReconnectIsRequired",JSON.stringify({connection:le.getState().toString(),useConnectParamsFromCache:he,reason:Me})),this.wrapped.onReconnectIsRequired(le,he,Me)},ne.prototype.onDisconnected=function(le){this.onEvent("onDisconnected",le.getState().toString()),this.wrapped.onDisconnected(le)},ne.prototype.onTerminalError=function(le){this.onEvent("onTerminalError",JSON.stringify({connection:le})),this.wrapped.onTerminalError(le)},ne.prototype.onConnectionParametersUpdated=function(le){this.onEvent("onConnectionParametersUpdated",JSON.stringify({connectParams:le})),this.wrapped.onConnectionParametersUpdated(le)},ne.prototype.onTrouterMessageLost=function(le){this.onEvent("onTrouterMessageLost",JSON.stringify({flowTags:le})),this.wrapped.onTrouterMessageLost(le)},ne.prototype.onUserActivityStateAccepted=function(le){this.onEvent("onUserActivityStateAccepted",JSON.stringify({cv:le})),this.wrapped.onUserActivityStateAccepted(le)},ne.prototype.onAudiencesSetResolved=function(le,he){this.onEvent("onAudiencesSetResolved",JSON.stringify({audienceSubscriptionsResponse:le,cv:he})),this.wrapped.onAudiencesSetResolved(le,he)},ne.prototype.getState=function(){return this.wrapped.getState()},ne}();z.LoggingManagerConsumer=re},function(L,z,H){Object.defineProperty(z,"__esModule",{value:!0}),z.TrouterManagerFsm=void 0;var j=H(2),J=H(4),Z=H(0),re=H(7),ne=function(){function le(he,Me){this.worker=Me,this.state=J.TrouterManagerState.Unknown,this.logger=new Z.Logger("ManagerFsm",he)}return le.prototype.start=function(){this.state===J.TrouterManagerState.Unknown?(this.setState(J.TrouterManagerState.Disconnected),this.worker.forceStopLingeringConnection(),this.worker.startFirstConnection()):(this.logger.info("start called in state '".concat(J.TrouterManagerState[this.state],"', expediting pending backoffs, if any")),this.worker.expediteBackoffOnConnections())},le.prototype.stop=function(he){this.state!==J.TrouterManagerState.Unknown?(this.setState(J.TrouterManagerState.Unknown),this.worker.stopFirstConnection(he===!0),this.worker.stopSecondConnection(he===!0)):this.showIgnored("stop")},le.prototype.getState=function(){switch(this.state){case J.TrouterManagerState.Unknown:case J.TrouterManagerState.Connected:case J.TrouterManagerState.Disconnected:case J.TrouterManagerState.Switching:return this.state;case J.TrouterManagerState.TerminalError:return j.TrouterState.Disconnected}},le.prototype.getInternalState=function(){return this.state},le.prototype.onConnected=function(he){this.state===J.TrouterManagerState.Disconnected&&he?this.worker.doesSecondConnectionExist()?this.setState(J.TrouterManagerState.Switching):(this.setState(J.TrouterManagerState.Connected),this.worker.dispatchConnected()):this.showIgnored("onConnected(".concat(he,")"))},le.prototype.onRegistered=function(he){this.state!==J.TrouterManagerState.Disconnected||he?this.state!==J.TrouterManagerState.Switching||he?this.state===J.TrouterManagerState.Disconnected&&he&&(this.setState(J.TrouterManagerState.Connected),this.worker.dispatchConnected()):(this.setState(J.TrouterManagerState.Connected),this.worker.switchConnections(),this.worker.stopSecondConnectionDelayed(),this.worker.dispatchConnected()):(this.setState(J.TrouterManagerState.Connected),this.worker.switchConnections(),this.worker.stopSecondConnection(!0),this.worker.dispatchConnected()),this.worker.dispatchRegistrationState(!0)},le.prototype.onUnregistered=function(he){he&&this.worker.dispatchRegistrationState(!1)},le.prototype.onReconnecting=function(he){this.state!==J.TrouterManagerState.Connected&&this.state!==J.TrouterManagerState.Switching||!he?this.showIgnored("onReconnecting(".concat(he,")")):(this.setState(J.TrouterManagerState.Disconnected),this.worker.dispatchDisconnected())},le.prototype.onReconnectionRequired=function(he,Me,Le){this.state===J.TrouterManagerState.Connected&&he?(this.setState(J.TrouterManagerState.Switching),this.worker.startSecondConnection(Me)):this.state===J.TrouterManagerState.Disconnected&&he?this.worker.startSecondConnection(Me):this.state===J.TrouterManagerState.Switching&&he&&Le===re.ReconnectReason.Configuration?(this.logger.debug("onReconnectionRequired: switch requested while already in Switching state"),this.worker.stopSecondConnection(!0),this.worker.startSecondConnection(Me)):this.showIgnored("onReconnectionRequired(".concat(he,")"))},le.prototype.onDisconnected=function(he){this.state==J.TrouterManagerState.Unknown&&he?this.worker.dispatchDisconnected():this.state==J.TrouterManagerState.Switching&&he?(this.worker.switchConnections(),this.worker.stopSecondConnection(!1),this.setState(J.TrouterManagerState.Disconnected),this.worker.dispatchDisconnected()):this.showIgnored("onDisconnected(".concat(he,")"))},le.prototype.onTerminalError=function(){this.setState(J.TrouterManagerState.TerminalError),this.worker.dispatchTerminalError()},le.prototype.showIgnored=function(he){this.logger.info("Ignoring event '".concat(he,"' in state '").concat(J.TrouterManagerState[this.state],"'"))},le.prototype.setState=function(he){if(this.logger.info("Switching from state '".concat(J.TrouterManagerState[this.state],"' to state '").concat(J.TrouterManagerState[he],"'")),this.state===he)return void this.logger.error("Attempt to switch to the current state '".concat(J.TrouterManagerState[he],"'"));this.state=he},le}();z.TrouterManagerFsm=ne},function(L,z,H){function j(Ge,tt){if(!tt)return Ge;var ct=Me(Me({},Ge),{enabled:tt.TelemetryEnabled});return tt.ClientTelemetryEventEnabled!==void 0&&(ct=Me(Me({},ct),tt.ClientTelemetryEventEnabled)),ct}function J(Ge,tt,ct){var Mt,ht,vt,Pt,ni,Zt,it,Ke,ot,Ht,jt=function(Nt){return Ge.proxyUrlRewrite?(tt.info("Using rewritten URL for proxy"),Ge.proxyUrlRewrite(Nt)):Nt};return{clientInfo:{ua:Ge.trouterSettings.productName,v:Ge.trouterSettings.version},ioOptions:{ackTimeoutMs:5e3,rewriteUrlForProxy:jt},clientCorrelationID:Ge.trouterSettings.sessionId,environment:Ge.trouterSettings.environment,telemetrySettings:j(Ge.telemetryConfig.settings,ct),eventLogger:Ge.telemetryConfig.eventLogger,endpointId:Ge.trouterSettings.registrationId,trouterUrl:ct?.TrouterConnectionUrl||Ge.trouterSettings.trouterServiceUrl,registration:Ge.trouterSettings.registrarServiceUrl?{registrarUrl:Ge.trouterSettings.registrarServiceUrl,registrationId:(Mt=Ge.trouterSettings.registrationId)!==null&&Mt!==void 0?Mt:"",pnhAppId:(ht=Ge.trouterSettings.pnhAppId)!==null&&ht!==void 0?ht:"",platform:(vt=Ge.trouterSettings.platform)!==null&&vt!==void 0?vt:"",pnhTemplateKey:(Pt=Ge.trouterSettings.pnhTemplate)!==null&&Pt!==void 0?Pt:"",platformUIVersion:(ni=Ge.trouterSettings.platformUIVersion)!==null&&ni!==void 0?ni:"",productContext:Ge.trouterSettings.pnhProductContext||void 0,context:(Zt=Ge.trouterSettings.pnhContext)!==null&&Zt!==void 0?Zt:"",registrarTtlSec:((it=Ge.trouterSettings.maxRegistrationTimeInMs)!==null&&it!==void 0?it:0)/1e3}:void 0,connectionDependsOnRegistration:Ge.trouterSettings.registrarServiceUrl===void 0?function(){return!1}:(Ke=Ge.trouterSettings.connectionDependsOnRegistration)!==null&&Ke!==void 0?Ke:function(){return!1},delayEventsUntilRegistered:(ot=Ge.trouterSettings.delayEventsUntilRegistered)!==null&&ot!==void 0?ot:function(){return!1},timeoutOptions:Me({connectionTimeoutMs:Ge.trouterSettings.trouterConnectTimeoutInMs||3e4,fetchTimeoutMs:1e4,pingTimeoutMs:4e4,pongTimeoutMs:5e3,maxBackoffMs:Ge.trouterSettings.productName==="TeamsCDL"?3e5:3e4,requestTimeoutMs:5e3,userActivityResponseTimeoutMs:1e4},Ge.trouterSettings.timeoutOptions),incallTimeoutOptions:Me({connectionTimeoutMs:1e4,fetchTimeoutMs:5e3,pingTimeoutMs:5e3,pongTimeoutMs:2e3,maxBackoffMs:Ge.trouterSettings.productName==="TeamsCDL"?3e5:1e4,requestTimeoutMs:5e3,userActivityResponseTimeoutMs:1e4},Ge.trouterSettings.incallTimeoutOptions),incallModeTimeoutMs:(Ht=Ge.trouterSettings.incallModeTimeoutMs)!==null&&Ht!==void 0?Ht:0,lingeringConnectionDelayMs:6e4,userActivitySecondResendDelayMs:Ge.trouterSettings.userActivitySecondResendDelayMs||1e4,duplicateDisconnectThresholdMs:1e4,connectionCache:Ge.connectionCache,registrationStateCallback:Ge.registrationStateCallbackForAcsDoNotUse,rewriteUrlForProxy:jt,retryLimitOnTokenFetch:Ge.trouterSettings.retryLimitOnTokenFetch,extraConnectionHeaders:Ge.trouterSettings.extraConnectionHeaders,expediteBackoffOnStartMinimumDelayMs:1e4,toJSON:function(){return Me(Me({},this),{connectionCache:this.connectionCache?{}:this.connectionCache})}}}function Z(Ge){return new qe(Ge)}function re(){return te.CLIENT_VERSION}function ne(Ge,tt){var ct=Ge.indexOf("://");if(ct>=0){var Mt=Ge.indexOf("/",ct+3);if(Mt>=0)return tt+Ge.substr(Mt)}return""}function le(Ge){var tt=this;return function(ct){return Le(tt,void 0,void 0,function(){var Mt;return pe(this,function(ht){switch(ht.label){case 0:return Mt={},[4,Ge(ct.needFresh)];case 1:return[2,(Mt.token=ht.sent(),Mt.tokenType="skype",Mt)]}})})}}function he(Ge,tt){var ct,Mt=this;return function(ht){return Le(Mt,void 0,void 0,function(){var vt,Pt,ni;return pe(this,function(Zt){switch(Zt.label){case 0:vt=new Date,Pt=setInterval(function(){var it=Math.round((Date.now()-vt.getTime())/6e4);Ge.warn("Note: Trouter auth token request promise from ".concat(vt.toISOString()," has not been resolved for ").concat(it," minutes. The client is blocked from operating properly"))},3e5),Zt.label=1;case 1:return Zt.trys.push([1,,3,4]),[4,tt(ht)];case 2:return ni=Zt.sent(),ht.needFresh&&ni.token===ct&&Ge.error("API violation: Trouter auth token provider got a request with needRefresh=true, but returned the same token as last time anyway. Please fix the host app"),ct=ni.token,[2,ni];case 3:return clearInterval(Pt),[7];case 4:return[2]}})})}}var Me=this&&this.__assign||function(){return Me=Object.assign||function(Ge){for(var tt,ct=1,Mt=arguments.length;ct<Mt;ct++){tt=arguments[ct];for(var ht in tt)Object.prototype.hasOwnProperty.call(tt,ht)&&(Ge[ht]=tt[ht])}return Ge},Me.apply(this,arguments)},Le=this&&this.__awaiter||function(Ge,tt,ct,Mt){function ht(vt){return vt instanceof ct?vt:new ct(function(Pt){Pt(vt)})}return new(ct||(ct=Promise))(function(vt,Pt){function ni(Ke){try{it(Mt.next(Ke))}catch(ot){Pt(ot)}}function Zt(Ke){try{it(Mt.throw(Ke))}catch(ot){Pt(ot)}}function it(Ke){Ke.done?vt(Ke.value):ht(Ke.value).then(ni,Zt)}it((Mt=Mt.apply(Ge,tt||[])).next())})},pe=this&&this.__generator||function(Ge,tt){function ct(it){return function(Ke){return Mt([it,Ke])}}function Mt(it){if(ht)throw new TypeError("Generator is already executing.");for(;ni&&(ni=0,it[0]&&(Zt=0)),Zt;)try{if(ht=1,vt&&(Pt=2&it[0]?vt.return:it[0]?vt.throw||((Pt=vt.return)&&Pt.call(vt),0):vt.next)&&!(Pt=Pt.call(vt,it[1])).done)return Pt;switch(vt=0,Pt&&(it=[2&it[0],Pt.value]),it[0]){case 0:case 1:Pt=it;break;case 4:return Zt.label++,{value:it[1],done:!1};case 5:Zt.label++,vt=it[1],it=[0];continue;case 7:it=Zt.ops.pop(),Zt.trys.pop();continue;default:if(Pt=Zt.trys,!(Pt=Pt.length>0&&Pt[Pt.length-1])&&(it[0]===6||it[0]===2)){Zt=0;continue}if(it[0]===3&&(!Pt||it[1]>Pt[0]&&it[1]<Pt[3])){Zt.label=it[1];break}if(it[0]===6&&Zt.label<Pt[1]){Zt.label=Pt[1],Pt=it;break}if(Pt&&Zt.label<Pt[2]){Zt.label=Pt[2],Zt.ops.push(it);break}Pt[2]&&Zt.ops.pop(),Zt.trys.pop();continue}it=tt.call(Ge,Zt)}catch(Ke){it=[6,Ke],vt=0}finally{ht=Pt=0}if(5&it[0])throw it[1];return{value:it[0]?it[1]:void 0,done:!0}}var ht,vt,Pt,ni,Zt={label:0,sent:function(){if(1&Pt[0])throw Pt[1];return Pt[1]},trys:[],ops:[]};return ni={next:ct(0),throw:ct(1),return:ct(2)},typeof Symbol=="function"&&(ni[Symbol.iterator]=function(){return this}),ni};Object.defineProperty(z,"__esModule",{value:!0}),z.replaceTrouterUrlBase=z.getTrouterServiceVersion=z.createTrouterService=z.TrouterService=z.UserActivityState=z.TrouterState=void 0;var te=H(1),Se=H(2);Object.defineProperty(z,"TrouterState",{enumerable:!0,get:function(){return Se.TrouterState}}),Object.defineProperty(z,"UserActivityState",{enumerable:!0,get:function(){return Se.UserActivityState}});var ce=H(0),X=H(8),ve=H(9),Te=H(10),Be=H(11),qe=function(){function Ge(tt){this.logProvider=tt,this.stateChangedListeners=[],this.logger=new ce.Logger("Trouter",tt),this.trouterUrlPromise=new Be.TrouterUrlPromise(tt),this.messageHandlers=new X.MessageHandlerRegistry(tt),this.listeners={},this.connectionInfo=null,this.logger.info("Created TrouterService version ".concat(te.CLIENT_VERSION))}return Ge.prototype.start=function(tt){var ct;if(this.logger.info("Start"),!tt.skypeTokenProvider&&!tt.authTokenProvider)throw new Error("no token provider has been configured, either skypeTokenProvider or authTokenProvider must be populated");tt.skypeTokenProvider&&!tt.trouterSettings.disableInternalSkypeTokenCache&&(tt.skypeTokenProvider=(0,ve.addCacheAsBackupTo)(tt.skypeTokenProvider)),this.trouterCfg=tt;var Mt=J(tt,this.logger,this.ecsCfg);tt.internalEnableV4cProtocol===!1&&(Mt.forceV4aProtocol=!0);var ht=he(this.logger,(ct=tt.authTokenProvider)!==null&&ct!==void 0?ct:le(tt.skypeTokenProvider));this.trouterServer===void 0&&(this.trouterServer=new Te.TrouterManager(this.logProvider,Mt,ht,tt.authTokenProvider===void 0,this)),this.pendingActivityState!==void 0&&(this.trouterServer.setUserActivityState(this.pendingActivityState[0],this.pendingActivityState[1]),this.pendingActivityState=void 0),this.trouterServer.start()},Ge.prototype.stop=function(tt){this.logger.info("close connection"),this.trouterUrlPromise.rejectUrl(new Error("TrouterService is stopped")),this.trouterServer!==void 0&&this.trouterServer.stop(tt)},Ge.prototype.setEcsConfig=function(tt){return Le(this,void 0,void 0,function(){var ct=this;return pe(this,function(Mt){return[2,new Promise(function(ht){if(ct.ecsCfg=tt.TrouterJScriptClient,ct.logger.info("Setting ECS configuration to ".concat(JSON.stringify(ct.ecsCfg))),ct.trouterServer!==void 0&&ct.trouterCfg!==void 0){var vt=J(ct.trouterCfg,ct.logger,ct.ecsCfg);ct.trouterServer.configure(vt)}ht()})]})})},Ge.prototype.checkConnection=function(tt){this.trouterServer!==void 0&&this.trouterServer.checkConnection(tt!=null&&tt)},Ge.prototype.resendRegistration=function(){return Le(this,void 0,void 0,function(){return pe(this,function(tt){if(!this.trouterServer)throw new Error("resendRegistration called too early");return[2,this.trouterServer.resendRegistration()]})})},Ge.prototype.registerListener=function(tt,ct){return ct===""||!ct.startsWith("/")||ct.includes("?")||ct.includes("#")?(this.logger.error("Listener path '".concat(ct,"' is not valid")),!1):this.listeners[ct]?(this.logger.error("Another listener is already registered for path '".concat(ct,"'")),!1):(this.listeners[ct]=tt,this.logger.debug("Listener for path '".concat(ct,"' registered")),this.connectionInfo&&tt.onTrouterConnected(this.connectionInfo.baseEndpointUrl+ct,this.connectionInfo),!0)},Ge.prototype.unregisterListener=function(tt){for(var ct=[],Mt=0,ht=Object.keys(this.listeners);Mt<ht.length;Mt++){var vt=ht[Mt];this.listeners[vt]===tt&&ct.push(vt)}if(ct.length===0)return!1;for(var Pt=0,ni=ct;Pt<ni.length;Pt++){var vt=ni[Pt];delete this.listeners[vt]}return this.logger.debug("Listener for path(s) '".concat(ct.join("', '"),"' unregistered")),!0},Ge.prototype.onTrouterConnected=function(tt,ct){this.logger.debug("Trouter is now connected");for(var Mt=0,ht=Object.keys(this.listeners);Mt<ht.length;Mt++){var vt=ht[Mt];try{this.listeners[vt].onTrouterConnected(ct.baseEndpointUrl+vt,ct)}catch(Pt){this.logger.error("Listener '".concat(vt,"' threw an exception from onTrouterConnected(): ").concat(Pt))}}this.connectionInfo=ct,this.trouterUrlPromise.resolveUrl(tt),this.notifyStateChanged(Se.TrouterState.Connected,{url:tt,getRemainingTtlInSec:function(){return ct.connectionTtlSec}})},Ge.prototype.onTrouterDisconnected=function(){this.logger.debug("Trouter is now disconnected"),this.connectionInfo=null;for(var tt=0,ct=Object.keys(this.listeners);tt<ct.length;tt++){var Mt=ct[tt],ht=this.listeners[Mt];if(ht.onTrouterDisconnected)try{ht.onTrouterDisconnected()}catch(vt){this.logger.error("Listener '".concat(Mt,"' threw an exception from onTrouterDisconnected(): ").concat(vt))}}this.notifyStateChanged(Se.TrouterState.Disconnected)},Ge.prototype.onTrouterRequest=function(tt,ct){for(var Mt="",ht=0,vt=Object.keys(this.listeners);ht<vt.length;ht++){var Pt=vt[ht];tt.path.startsWith(Pt)&&Pt.length>Mt.length&&(Mt=Pt)}if(Mt==="")this.tryMessageHandlers(tt,ct)||(ct.status=404,ct.headers={"Trouter-Responder":"ClientLib"},ct.send());else try{this.listeners[Mt].onTrouterRequest(tt,ct)}catch(ni){this.logger.error("Listener '".concat(Mt,"' threw an exception from onTrouterRequest(): ").concat(ni)),ct.status=500,ct.headers={"Trouter-Responder":"ClientLib"},ct.send()}},Ge.prototype.onTrouterMessageLoss=function(tt){this.logger.info("onTrouterMessageLoss called with tags [".concat(tt,"]"));for(var ct=!0,Mt=0,ht=Object.keys(this.listeners);Mt<ht.length;Mt++){var vt=ht[Mt],Pt=this.listeners[vt];if(Pt.onTrouterMessageLoss)try{ct=Pt.onTrouterMessageLoss(tt)&&ct,ct===void 0&&(this.logger.error("Listener '".concat(vt,"' did not return a boolean value from onTrouterMessageLoss()")),ct=!1)}catch(ni){this.logger.error("Listener '".concat(vt,"' threw an exception from onTrouterMessageLoss(): ").concat(ni)),ct=!1}}return ct},Ge.prototype.onTrouterUserActivityStateAccepted=function(tt){this.logger.debug("onTrouterUserActivityStateAccepted cv: ".concat(tt));for(var ct=0,Mt=Object.keys(this.listeners);ct<Mt.length;ct++){var ht=Mt[ct],vt=this.listeners[ht];if(vt.onTrouterUserActivityStateAccepted)try{vt.onTrouterUserActivityStateAccepted(tt)}catch(Pt){this.logger.error("Listener '".concat(ht,"' threw an exception from onTrouterUserActivityStateAccepted(): ").concat(Pt))}}},Ge.prototype.onAudiencesSetResolved=function(tt,ct){this.logger.debug("onAudiencesSetResolved cv: ".concat(ct));for(var Mt=0,ht=Object.keys(this.listeners);Mt<ht.length;Mt++){var vt=ht[Mt],Pt=this.listeners[vt];if(Pt.onAudiencesSetResolved)try{Pt.onAudiencesSetResolved(tt,ct)}catch(ni){this.logger.error("Listener '".concat(vt,"' threw an exception from onAudienceSubscribed(): ").concat(ni))}}},Ge.prototype.setUserActivityState=function(tt,ct){if(tt!==Se.UserActivityState.Active&&tt!==Se.UserActivityState.Inactive)throw new Error("setUserActivityState called with unsupported value ".concat(tt));this.logger.info("setUserActivityState called with value ".concat(Se.UserActivityState[tt])),this.trouterServer&&this.state()!==Se.TrouterState.Unknown?this.trouterServer.setUserActivityState(tt,ct):(this.pendingActivityState=[tt,ct],this.logger.warn("setUserActivityState called before start() or after stop()"))},Ge.prototype.setAudienceSubscriptions=function(tt,ct){if(tt.audienceSubscriptions.length>1)throw new Error("Only singular audience subscription is supported");if(this.trouterServer&&this.state()!==Se.TrouterState.Unknown)return this.trouterServer.setAudienceSubscriptionsAsync(tt,15e3,ct);throw new Error("audience subscribe called before start() or after stop()")},Ge.prototype.state=function(){return this.trouterServer!==void 0?this.trouterServer.getState():Se.TrouterState.Unknown},Ge.prototype.isInTerminalState=function(){return this.trouterServer!==void 0&&this.trouterServer.isInTerminalState()},Ge.prototype.reportStateInfo=function(){return this.trouterServer===void 0?"":this.trouterServer.reportStateInfo()},Ge.prototype.getServerState=function(){if(this.trouterServer!==void 0)return this.trouterServer.getServerState()},Ge.prototype.getTrouterUrlAsync=function(){return this.trouterServer!==void 0?this.trouterUrlPromise.getPromise():Promise.reject(new Error("TrouterService has not been started"))},Ge.prototype.onStateChanged=function(tt){if(this.logger.info("onStateChanged called"),tt===void 0)this.stateChangedListeners=this.stateChangedListeners.filter(function(Mt){return Mt.wrappedCallback===void 0});else{this.offStateChanged(tt);var ct=function(Mt,ht){tt(Mt,ht?ht.url:"")};ct.wrappedCallback=tt,this.stateChangedListeners.push(ct)}},Ge.prototype.offStateChanged=function(tt){this.logger.info("offStateChanged called");var ct=this.stateChangedListeners.length;return this.stateChangedListeners=this.stateChangedListeners.filter(function(Mt){return Mt.wrappedCallback!==tt}),ct>this.stateChangedListeners.length},Ge.prototype.addCallback=function(tt){this.logger.info("addListener called"),this.stateChangedListeners.indexOf(tt,0)===-1&&tt!==void 0&&this.stateChangedListeners.push(tt)},Ge.prototype.removeCallback=function(tt){this.logger.info("removeListener called");var ct=this.stateChangedListeners.indexOf(tt,0);return ct>-1&&(this.stateChangedListeners.splice(ct,1),!0)},Ge.prototype.registerMessageHandler=function(tt){this.logger.info("registerMessageHandler is called"),this.messageHandlers.register(tt)},Ge.prototype.clearMessageHandlers=function(){this.logger.info("clearMessageHandlers is called"),this.messageHandlers.clear()},Ge.prototype.notifyStateChanged=function(tt,ct){var Mt=this;this.logger.info("notifyStateChanged called, will forward to ".concat(this.stateChangedListeners.length," listeners")),this.stateChangedListeners.forEach(function(ht){try{ht(tt,ct)}catch(vt){Mt.logger.error("Error in callback ".concat(vt))}})},Ge.prototype.tryMessageHandlers=function(tt,ct){if(!this.messageHandlers.active())return!1;var Mt,ht=null;try{Mt=JSON.parse(tt.body),ht=Mt&&(Mt.evt||Mt.eventId)||null}catch{}var vt={eventId:ht,url:(this.connectionInfo?this.connectionInfo.baseEndpointUrl:"")+tt.path,body:Mt,rawBody:tt.body,headers:tt.headers},Pt=this.messageHandlers.handleMessage(vt);return!!Pt.isHandled&&(ct.status=Pt.resultCode,Pt.responseHeaders&&(ct.headers=Pt.responseHeaders),Pt.responseBody&&(ct.body=Pt.responseBody),ct.send(),!0)},Ge}();z.TrouterService=qe,z.createTrouterService=Z,z.getTrouterServiceVersion=re,z.replaceTrouterUrlBase=ne},function(L,z){L.exports=B}])})});h(f);var y=p(function(F,x){Object.defineProperty(x,"__esModule",{value:!0}),x.PACKAGE_VERSION=x.CONFIG_API_VERSION=x.EudbCountries=x.CloudPrefix=x.CloudType=x.MAX_NUMBER_OF_TOKEN_FETCH_RETRIES=void 0,x.MAX_NUMBER_OF_TOKEN_FETCH_RETRIES=3;var B;(function(z){z.Public="Public",z.GccHigh="GCC High",z.Dod="DoD"})(B||(x.CloudType=B={}));var L;(function(z){z.OrgId="orgid",z.Acs="acs",z.Spool="spool",z.GccHigh="gcch",z.GccHighAcs="gcch-acs",z.Dod="dod",z.DodAcs="dod-acs"})(L||(x.CloudPrefix=L={})),x.EudbCountries=["europe","france","germany","norway","switzerland","sweden"],x.CONFIG_API_VERSION="2024-09-01",x.PACKAGE_VERSION="1.0.0-beta.29"});h(y),y.PACKAGE_VERSION,y.CONFIG_API_VERSION,y.EudbCountries,y.CloudPrefix,y.CloudType,y.MAX_NUMBER_OF_TOKEN_FETCH_RETRIES;var T=p(function(F,x){var B=d&&d.__awaiter||function(ht,vt,Pt,ni){function Zt(it){return it instanceof Pt?it:new Pt(function(Ke){Ke(it)})}return new(Pt||(Pt=Promise))(function(it,Ke){function ot(Nt){try{jt(ni.next(Nt))}catch(Vt){Ke(Vt)}}function Ht(Nt){try{jt(ni.throw(Nt))}catch(Vt){Ke(Vt)}}function jt(Nt){Nt.done?it(Nt.value):Zt(Nt.value).then(ot,Ht)}jt((ni=ni.apply(ht,vt||[])).next())})};Object.defineProperty(x,"__esModule",{value:!0}),x.isEudbLocation=x.parseTokenCredential=x.base64decode=x.toTelemetrySender=x.toLogProvider=x.toMessageHandler=void 0,x.generateUuid=tt;const L=new Map([["chatMessageReceived",200],["typingIndicatorReceived",245],["readReceiptReceived",246],["chatMessageEdited",247],["chatMessageDeleted",248],["chatThreadCreated",257],["chatThreadPropertiesUpdated",258],["chatThreadDeleted",259],["participantsAdded",260],["participantsRemoved",261]]),z="8:orgid:",H="8:dod:",j="8:gcch:",J="8:teamsvisitor:",Z="4:",re="8:acs:",ne="8:gcch-acs:",le="8:dod-acs:",he="8:spool:",Me=(ht,vt,Pt,ni)=>{const Zt=L.get(ht);return{handleMessage(it){let Ke=null;if(it?.rawBody&&(Ke=JSON.parse(it.rawBody)),Ke===null||Ke.eventId!==Zt)return;const ot=Le(ht,Ke,Pt,ni);if(ot!==null)return vt(ot),{isHandled:!0,resultCode:200}}}};x.toMessageHandler=Me;const Le=(ht,vt,Pt,ni)=>{if(ht==="chatMessageReceived"){const Zt=vt;return{threadId:Zt.groupId,sender:Se(Zt.senderId),senderDisplayName:Zt.senderDisplayName,recipient:Se(Zt.recipientMri),id:Zt.messageId,createdOn:new Date(Zt.originalArrivalTime),version:Zt.version,type:Zt.messageType,message:Zt.messageBody,metadata:ce(Zt.acsChatMessageMetadata)||{},attachments:Te(ce(Zt.attachments)||[],Pt,ni)}}if(ht==="chatMessageEdited"){const Zt=vt;return{threadId:Zt.groupId,sender:Se(Zt.senderId),senderDisplayName:Zt.senderDisplayName,recipient:Se(Zt.recipientMri),id:Zt.messageId,createdOn:new Date(Zt.originalArrivalTime),version:Zt.version,message:Zt.messageBody,editedOn:new Date(Zt.edittime),type:Zt.messageType,metadata:ce(Zt.acsChatMessageMetadata)||{},attachments:Te(ce(Zt.attachments)||[],Pt,ni)}}if(ht==="chatMessageDeleted"){const Zt=vt;return{threadId:Zt.groupId,sender:Se(Zt.senderId),senderDisplayName:Zt.senderDisplayName,recipient:Se(Zt.recipientMri),id:Zt.messageId,createdOn:new Date(Zt.originalArrivalTime),version:Zt.version,deletedOn:new Date(Zt.deletetime),type:Zt.messageType}}if(ht==="typingIndicatorReceived"){const Zt=vt;return{threadId:Zt.groupId,sender:Se(Zt.senderId),senderDisplayName:Zt.senderDisplayName,recipient:Se(Zt.recipientMri),version:Zt.version,receivedOn:new Date(Zt.originalArrivalTime)}}if(ht==="readReceiptReceived"){const Zt=vt,Ke=JSON.parse(Zt.messageBody).consumptionhorizon.split(";");return{threadId:Zt.groupId,sender:Se(Zt.senderId),senderDisplayName:"",recipient:Se(Zt.recipientMri),chatMessageId:Zt.messageId,readOn:new Date(+Ke[1])}}if(ht==="chatThreadCreated"){const Zt=vt,it=JSON.parse(unescape(Zt.createdBy)),Ke=JSON.parse(unescape(Zt.members)),ot=JSON.parse(unescape(Zt.properties)),Ht={id:Se(it.participantId),displayName:it.displayName},jt=Ke.map(Vt=>({id:Se(Vt.participantId),displayName:Vt.displayName}));return{threadId:Zt.threadId,createdOn:new Date(Zt.createTime),createdBy:Ht,version:Zt.version,participants:jt,properties:ot}}if(ht==="chatThreadPropertiesUpdated"){const Zt=vt,it=JSON.parse(unescape(Zt.editedBy)),Ke=JSON.parse(unescape(Zt.properties)),ot={id:Se(it.participantId),displayName:it.displayName};return{threadId:Zt.threadId,updatedOn:new Date(Zt.editTime),updatedBy:ot,version:Zt.version,properties:Ke}}if(ht==="chatThreadDeleted"){const Zt=vt,it=JSON.parse(unescape(Zt.deletedBy)),Ke={id:Se(it.participantId),displayName:it.displayName};return{threadId:Zt.threadId,deletedOn:new Date(Zt.deleteTime),deletedBy:Ke,version:Zt.version}}if(ht==="participantsAdded"){const Zt=vt,it=JSON.parse(unescape(Zt.addedBy)),Ke=JSON.parse(unescape(Zt.participantsAdded)),ot={id:Se(it.participantId),displayName:it.displayName},Ht=Ke.map(Nt=>({id:Se(Nt.participantId),displayName:Nt.displayName,shareHistoryTime:new Date(Nt.shareHistoryTime)}));return{threadId:Zt.threadId,addedOn:new Date(Zt.time),addedBy:ot,version:Zt.version,participantsAdded:Ht}}if(ht==="participantsRemoved"){const Zt=vt,it=JSON.parse(unescape(Zt.removedBy)),Ke=JSON.parse(unescape(Zt.participantsRemoved)),ot={id:Se(it.participantId),displayName:it.displayName},Ht=Ke.map(Nt=>({id:Se(Nt.participantId),displayName:Nt.displayName,shareHistoryTime:new Date(Nt.shareHistoryTime)}));return{threadId:Zt.threadId,removedOn:new Date(Zt.time),removedBy:ot,version:Zt.version,participantsRemoved:Ht}}return null},pe=ht=>({log:(...vt)=>ht.info(vt),warn:(...vt)=>ht.warning(vt),error:(...vt)=>ht.error(vt),debug:(...vt)=>ht.verbose(vt),info:(...vt)=>ht.verbose(vt)});x.toLogProvider=pe;const te=ht=>({logEvent:vt=>ht.info(vt)});x.toTelemetrySender=te;const Se=ht=>ht.startsWith(z)?{kind:"microsoftTeamsUser",rawId:ht,microsoftTeamsUserId:ht.substring(z.length),isAnonymous:!1,cloud:"public"}:ht.startsWith(H)?{kind:"microsoftTeamsUser",rawId:ht,microsoftTeamsUserId:ht.substring(H.length),isAnonymous:!1,cloud:"dod"}:ht.startsWith(j)?{kind:"microsoftTeamsUser",rawId:ht,microsoftTeamsUserId:ht.substring(j.length),isAnonymous:!1,cloud:"gcch"}:ht.startsWith(J)?{kind:"microsoftTeamsUser",rawId:ht,microsoftTeamsUserId:ht.substring(J.length),isAnonymous:!0}:ht.startsWith(Z)?{kind:"phoneNumber",rawId:ht,phoneNumber:ht.substring(Z.length)}:ht.startsWith(re)||ht.startsWith(ne)||ht.startsWith(le)||ht.startsWith(he)?{kind:"communicationUser",communicationUserId:ht}:{kind:"unknown",id:ht},ce=ht=>{if(!(ht==null||ht===""||ht==="null"||ht==="{}"||ht==="[]"))return JSON.parse(ht)},X=(ht,vt,Pt)=>{let ni;try{ni=new URL(ht),(ni.protocol==="http:"||ni.protocol==="https:")&&(ni=new URL(ni.pathname,vt))}catch{try{ni=new URL(ht,vt)}catch{return ht}}return ni.searchParams.set("api-version",Pt),ni.toString()},ve=ht=>{let vt;try{vt=new URL(ht)}catch{return!1}return vt.protocol==="http:"||vt.protocol==="https:"},Te=(ht,vt,Pt)=>(vt==null||vt===""||!ve(vt)||ht.filter(ni=>ni.attachmentType.toLowerCase()==="image".toLowerCase()).map(ni=>{ni.previewUrl&&(ni.previewUrl=X(ni.previewUrl,vt,Pt)),ni.url&&(ni.url=X(ni.url,vt,Pt))}),ht),Be=ht=>r.isNodeLike?Buffer.from(ht,"base64").toString():atob(ht);x.base64decode=Be;const qe=ht=>{let[,vt]=ht?.split(".");if(vt===void 0)throw new Error("Invalid token");return vt=vt.replace(/-/g,"+").replace(/_/g,"/"),JSON.parse(decodeURIComponent(escape((0,x.base64decode)(vt))))},Ge=ht=>B(void 0,void 0,void 0,function*(){const vt=yield ht.getToken(),Pt=vt?.token,ni=qe(Pt),Zt=ni.skypeid,it=ni.resourceId,Ke=Mt(Zt),ot=ni.resourceLocation||"";return{jwtToken:Pt,acsResourceId:it,identityMri:Zt,cloudType:Ke,resourceLocation:ot}});x.parseTokenCredential=Ge;function tt(){return(0,i.v4)()}const ct=ht=>!!ht&&!!y.EudbCountries.find(vt=>vt===ht);x.isEudbLocation=ct;function Mt(ht){switch(ht.substring(0,ht.indexOf(":"))){case y.CloudPrefix.OrgId:case y.CloudPrefix.Acs:case y.CloudPrefix.Spool:return y.CloudType.Public;case y.CloudPrefix.GccHigh:case y.CloudPrefix.GccHighAcs:return y.CloudType.GccHigh;case y.CloudPrefix.Dod:case y.CloudPrefix.DodAcs:return y.CloudType.Dod;default:return y.CloudType.Public}}});h(T),T.isEudbLocation,T.parseTokenCredential,T.base64decode,T.toTelemetrySender,T.toLogProvider,T.toMessageHandler,T.generateUuid;var C=p(function(F,x){var B=d&&d.__createBinding||(Object.create?function(re,ne,le,he){he===void 0&&(he=le);var Me=Object.getOwnPropertyDescriptor(ne,le);(!Me||("get"in Me?!ne.__esModule:Me.writable||Me.configurable))&&(Me={enumerable:!0,get:function(){return ne[le]}}),Object.defineProperty(re,he,Me)}:function(re,ne,le,he){he===void 0&&(he=le),re[he]=ne[le]}),L=d&&d.__setModuleDefault||(Object.create?function(re,ne){Object.defineProperty(re,"default",{enumerable:!0,value:ne})}:function(re,ne){re.default=ne}),z=d&&d.__importStar||function(re){if(re&&re.__esModule)return re;var ne={};if(re!=null)for(var le in re)le!=="default"&&Object.prototype.hasOwnProperty.call(re,le)&&B(ne,re,le);return L(ne,re),ne},H=d&&d.__awaiter||function(re,ne,le,he){function Me(Le){return Le instanceof le?Le:new le(function(pe){pe(Le)})}return new(le||(le=Promise))(function(Le,pe){function te(X){try{ce(he.next(X))}catch(ve){pe(ve)}}function Se(X){try{ce(he.throw(X))}catch(ve){pe(ve)}}function ce(X){X.done?Le(X.value):Me(X.value).then(te,Se)}ce((he=he.apply(re,ne||[])).next())})};Object.defineProperty(x,"__esModule",{value:!0}),x.RealTimeNotificationConfiguration=x.TrouterConfigClient=void 0;const j=z(o);class J extends j.ServiceClient{constructor(ne,le){le||(le={});const he=`azsdk-js-communication-signaling/${y.PACKAGE_VERSION}`,Me=le.userAgentOptions&&le.userAgentOptions.userAgentPrefix?`${le.userAgentOptions.userAgentPrefix} ${he}`:`${he}`,Le=Object.assign(Object.assign({},le),{userAgentOptions:{userAgentPrefix:Me},additionalPolicies:le.additionalPolicies});super(Le),this.apiVersion=y.CONFIG_API_VERSION,this.endpoint=ne,this.httpClient=(0,l.createDefaultHttpClient)()}fetchServiceUrls(ne){return H(this,void 0,void 0,function*(){try{const le=(yield ne.getToken()).token,he=(0,l.createPipelineRequest)({url:`${this.endpoint}/chat/config/realTimeNotifications?api-version=${this.apiVersion}`,method:"GET",headers:(0,l.createHttpHeaders)({Authorization:`Bearer ${le}`})}),Me=yield this.pipeline.sendRequest(this.httpClient,he);if(Me.status!==200||!Me.bodyAsText)throw new Error(`Failed to fetch service URLs. Status: ${Me.status}, Body: ${Me.bodyAsText||"No response body"}`);const Le=JSON.parse(Me.bodyAsText);if(!Le.trouterServiceUrl||!Le.registrarServiceUrl||!Le.cloudType)throw new Error("One or more required fields are missing in the response data");return new Z(Le.trouterServiceUrl,Le.registrarServiceUrl,Le.cloudType)}catch(le){throw new Error(`Error fetching real-time notification configuration from Chat Gateway: ${le.message}`)}})}}x.TrouterConfigClient=J;class Z{constructor(ne,le,he){this.trouterServiceUrl=ne,this.registrarServiceUrl=le,this.cloudType=he}}x.RealTimeNotificationConfiguration=Z});h(C),C.RealTimeNotificationConfiguration,C.TrouterConfigClient;var E=p(function(F,x){var B=d&&d.__awaiter||function(H,j,J,Z){function re(ne){return ne instanceof J?ne:new J(function(le){le(ne)})}return new(J||(J=Promise))(function(ne,le){function he(pe){try{Le(Z.next(pe))}catch(te){le(te)}}function Me(pe){try{Le(Z.throw(pe))}catch(te){le(te)}}function Le(pe){pe.done?ne(pe.value):re(pe.value).then(he,Me)}Le((Z=Z.apply(H,j||[])).next())})};Object.defineProperty(x,"__esModule",{value:!0}),x.defaultTelemetrySettings=x.createSettings=void 0;const L={version:"1.0.0",registrationId:"",sessionId:"",pnhAppId:"AcsWeb",pnhTemplate:"AcsWeb_Chat_1.8",platform:"SPOOL",platformUIVersion:"0.0.0",environment:"",productName:"acs-chat-web",trouterServiceUrl:"",registrarServiceUrl:"",registrarRefreshTimeoutInMs:35e4,timeoutOptions:{connectionTimeoutMs:2e4,fetchTimeoutMs:1e4,pingTimeoutMs:4e4,pongTimeoutMs:5e3,maxBackoffMs:5e4,requestTimeoutMs:5e3},maxRegistrationTimeInMs:72e5},z=(H,j)=>B(void 0,void 0,void 0,function*(){var J;const Z=j?.resourceEndpoint;if(Z===void 0)throw new Error("'endpoint' cannot be null");const re=Object.assign({},L);re.registrationId=(0,T.generateUuid)(),re.sessionId=(0,T.generateUuid)();const le=yield new C.TrouterConfigClient(Z,j).fetchServiceUrls(H);return re.trouterServiceUrl=`${le.trouterServiceUrl}/v4/a`,re.registrarServiceUrl=`${le.registrarServiceUrl}/v3/registrations`,le.cloudType==="int"&&(re.pnhAppId="cns-e2e-test",re.pnhTemplate="cns-e2e-test:1.8"),re.maxRegistrationTimeInMs=(J=j?.registrationTimeInMs)!==null&&J!==void 0?J:L.maxRegistrationTimeInMs,re});x.createSettings=z,x.defaultTelemetrySettings={enabled:!1}});h(E),E.defaultTelemetrySettings,E.createSettings;var I=p(function(F,x){var B=d&&d.__awaiter||function(H,j,J,Z){function re(ne){return ne instanceof J?ne:new J(function(le){le(ne)})}return new(J||(J=Promise))(function(ne,le){function he(pe){try{Le(Z.next(pe))}catch(te){le(te)}}function Me(pe){try{Le(Z.throw(pe))}catch(te){le(te)}}function Le(pe){pe.done?ne(pe.value):re(pe.value).then(he,Me)}Le((Z=Z.apply(H,j||[])).next())})};Object.defineProperty(x,"__esModule",{value:!0}),x.CommunicationSignalingClient=x.ConnectionState=void 0;var L;(function(H){H[H.Unknown=0]="Unknown",H[H.Connected=2]="Connected",H[H.Disconnected=3]="Disconnected",H[H.Switching=9]="Switching"})(L||(x.ConnectionState=L={}));class z{constructor(j,J,Z){this.credential=j,this.logger=J,this.options=Z,this.stateChangedListener=null,this.tokenFetchRetries=0,this.trouter=(0,f.createTrouterService)((0,T.toLogProvider)(J))}start(){return B(this,void 0,void 0,function*(){var j,J;if(this.resourceEndpoint=(j=this.options)===null||j===void 0?void 0:j.resourceEndpoint,this.resourceEndpoint===void 0)throw new Error("'endpoint' cannot be null");this.gatewayApiVersion=((J=this.options)===null||J===void 0?void 0:J.gatewayApiVersion)||"2024-03-07",this.config===void 0&&(this.config={trouterSettings:yield(0,E.createSettings)(this.credential,this.options),skypeTokenProvider:Z=>B(this,void 0,void 0,function*(){if(Z){if(this.tokenFetchRetries+=1,this.tokenFetchRetries>y.MAX_NUMBER_OF_TOKEN_FETCH_RETRIES)throw yield this.stop(!0),new Error(`Access token is expired and failed to fetch a valid one after ${y.MAX_NUMBER_OF_TOKEN_FETCH_RETRIES} retries`)}else this.tokenFetchRetries=0;return Promise.resolve((yield this.credential.getToken()).token)}),telemetryConfig:{eventLogger:(0,T.toTelemetrySender)(this.logger),settings:E.defaultTelemetrySettings}}),this.trouter.start(this.config),this.trouter.setUserActivityState(f.UserActivityState.Active)})}stop(j){return B(this,void 0,void 0,function*(){this.trouter.offStateChanged(this.stateChangedListener),this.trouter.clearMessageHandlers(),this.trouter.stop(j??this.tokenFetchRetries>y.MAX_NUMBER_OF_TOKEN_FETCH_RETRIES)})}on(j,J){if(j==="connectionChanged"){this.trouter.offStateChanged(this.stateChangedListener),this.stateChangedListener=(Z,re)=>J(Z),this.trouter.onStateChanged(this.stateChangedListener);return}this.trouter.registerMessageHandler((0,T.toMessageHandler)(j,J,this.resourceEndpoint,this.gatewayApiVersion))}}x.CommunicationSignalingClient=z});h(I),I.CommunicationSignalingClient,I.ConnectionState;var w=p(function(F,x){var B=d&&d.__createBinding||(Object.create?function(z,H,j,J){J===void 0&&(J=j);var Z=Object.getOwnPropertyDescriptor(H,j);(!Z||("get"in Z?!H.__esModule:Z.writable||Z.configurable))&&(Z={enumerable:!0,get:function(){return H[j]}}),Object.defineProperty(z,J,Z)}:function(z,H,j,J){J===void 0&&(J=j),z[J]=H[j]}),L=d&&d.__exportStar||function(z,H){for(var j in z)j!=="default"&&!Object.prototype.hasOwnProperty.call(H,j)&&B(H,z,j)};Object.defineProperty(x,"__esModule",{value:!0}),L(I,x)}),D=h(w);t.exports=D}(Kme)),Kme.exports}var nfe=iei();const nei=t=>{const{participants:e,idempotencyToken:i}=t,r=Mm(t,["participants","idempotencyToken"]);return Object.assign({repeatabilityRequestId:i},r)},RHe=t=>{const{id:e}=t,i=Mm(t,["id"]);return Object.assign(Object.assign({},i),{communicationIdentifier:TDe(e)})},aei=t=>{var e;return{participants:(e=t.participants)===null||e===void 0?void 0:e.map(i=>RHe(i))}},afe=t=>{const{communicationIdentifier:e}=t,i=Mm(t,["communicationIdentifier"]);return Object.assign(Object.assign({},i),{id:ej(e)})},rei=t=>{const{participants:e,initiatorCommunicationIdentifier:i}=t,r=Mm(t,["participants","initiatorCommunicationIdentifier"]);let o=Object.assign({},r);if(i){const l=ej(i);o=Object.assign(Object.assign({},o),{initiator:l})}return e&&(o=Object.assign(Object.assign({},o),{participants:e?.map(l=>afe(l))})),o},rfe=t=>{const{content:e,senderCommunicationIdentifier:i}=t,r=Mm(t,["content","senderCommunicationIdentifier"]);let o=Object.assign({},r);if(e&&(o=Object.assign(Object.assign({},o),{content:rei(e)})),i){const l=ej(i);o=Object.assign(Object.assign({},o),{sender:l})}return o},MHe=t=>{const{createdByCommunicationIdentifier:e}=t,i=Mm(t,["createdByCommunicationIdentifier"]);return e?Object.assign(Object.assign({},i),{createdBy:ej(e)}):Object.assign({},i)},oei=t=>{const{chatThread:e}=t,i=Mm(t,["chatThread"]);return e?Object.assign(Object.assign({},i),{chatThread:MHe(e)}):Object.assign({},i)},PHe=t=>{const{senderCommunicationIdentifier:e}=t,i=Mm(t,["senderCommunicationIdentifier"]);return Object.assign(Object.assign({},i),{sender:ej(e)})},ac=aDe({namespace:"Azure.Communication",packageName:"@azure/communication-chat",packageVersion:"1.5.4"}),ofe={type:{name:"Composite",className:"ChatMessageReadReceiptsCollection",modelProperties:{value:{serializedName:"value",required:!0,type:{name:"Sequence",element:{type:{name:"Composite",className:"ChatMessageReadReceipt"}}}},nextLink:{serializedName:"nextLink",readOnly:!0,type:{name:"String"}}}}},sei={type:{name:"Composite",className:"ChatMessageReadReceipt",modelProperties:{senderCommunicationIdentifier:{serializedName:"senderCommunicationIdentifier",type:{name:"Composite",className:"CommunicationIdentifierModel"}},chatMessageId:{serializedName:"chatMessageId",required:!0,type:{name:"String"}},readOn:{serializedName:"readOn",required:!0,type:{name:"DateTime"}}}}},DHe={type:{name:"Composite",className:"CommunicationIdentifierModel",modelProperties:{kind:{serializedName:"kind",type:{name:"String"}},rawId:{serializedName:"rawId",type:{name:"String"}},communicationUser:{serializedName:"communicationUser",type:{name:"Composite",className:"CommunicationUserIdentifierModel"}},phoneNumber:{serializedName:"phoneNumber",type:{name:"Composite",className:"PhoneNumberIdentifierModel"}},microsoftTeamsUser:{serializedName:"microsoftTeamsUser",type:{name:"Composite",className:"MicrosoftTeamsUserIdentifierModel"}},microsoftTeamsApp:{serializedName:"microsoftTeamsApp",type:{name:"Composite",className:"MicrosoftTeamsAppIdentifierModel"}}}}},lei={type:{name:"Composite",className:"CommunicationUserIdentifierModel",modelProperties:{id:{serializedName:"id",required:!0,type:{name:"String"}}}}},cei={type:{name:"Composite",className:"PhoneNumberIdentifierModel",modelProperties:{value:{serializedName:"value",required:!0,type:{name:"String"}}}}},dei={type:{name:"Composite",className:"MicrosoftTeamsUserIdentifierModel",modelProperties:{userId:{serializedName:"userId",required:!0,type:{name:"String"}},isAnonymous:{serializedName:"isAnonymous",type:{name:"Boolean"}},cloud:{serializedName:"cloud",type:{name:"String"}}}}},uei={type:{name:"Composite",className:"MicrosoftTeamsAppIdentifierModel",modelProperties:{appId:{serializedName:"appId",required:!0,type:{name:"String"}},cloud:{serializedName:"cloud",type:{name:"String"}}}}},Ua={type:{name:"Composite",className:"CommunicationErrorResponse",modelProperties:{error:{serializedName:"error",type:{name:"Composite",className:"ChatError"}}}}},hei={type:{name:"Composite",className:"ChatError",modelProperties:{code:{serializedName:"code",required:!0,type:{name:"String"}},message:{serializedName:"message",required:!0,type:{name:"String"}},target:{serializedName:"target",readOnly:!0,type:{name:"String"}},details:{serializedName:"details",readOnly:!0,type:{name:"Sequence",element:{type:{name:"Composite",className:"ChatError"}}}},innerError:{serializedName:"innererror",type:{name:"Composite",className:"ChatError"}}}}},LHe={type:{name:"Composite",className:"SendReadReceiptRequest",modelProperties:{chatMessageId:{serializedName:"chatMessageId",required:!0,type:{name:"String"}}}}},OHe={type:{name:"Composite",className:"SendChatMessageRequest",modelProperties:{content:{serializedName:"content",required:!0,type:{name:"String"}},senderDisplayName:{serializedName:"senderDisplayName",type:{name:"String"}},type:{serializedName:"type",type:{name:"Enum",allowedValues:["text","html","topicUpdated","participantAdded","participantRemoved"]}},metadata:{serializedName:"metadata",type:{name:"Dictionary",value:{type:{name:"String"}}}}}}},NHe={type:{name:"Composite",className:"SendChatMessageResult",modelProperties:{id:{serializedName:"id",required:!0,type:{name:"String"}}}}},sfe={type:{name:"Composite",className:"ChatMessagesCollection",modelProperties:{value:{serializedName:"value",required:!0,type:{name:"Sequence",element:{type:{name:"Composite",className:"ChatMessage"}}}},nextLink:{serializedName:"nextLink",readOnly:!0,type:{name:"String"}}}}},xHe={type:{name:"Composite",className:"ChatMessage",modelProperties:{id:{serializedName:"id",required:!0,type:{name:"String"}},type:{serializedName:"type",required:!0,type:{name:"Enum",allowedValues:["text","html","topicUpdated","participantAdded","participantRemoved"]}},sequenceId:{serializedName:"sequenceId",required:!0,type:{name:"String"}},version:{serializedName:"version",required:!0,type:{name:"String"}},content:{serializedName:"content",type:{name:"Composite",className:"ChatMessageContent"}},senderDisplayName:{serializedName:"senderDisplayName",type:{name:"String"}},createdOn:{serializedName:"createdOn",required:!0,type:{name:"DateTime"}},senderCommunicationIdentifier:{serializedName:"senderCommunicationIdentifier",type:{name:"Composite",className:"CommunicationIdentifierModel"}},deletedOn:{serializedName:"deletedOn",type:{name:"DateTime"}},editedOn:{serializedName:"editedOn",type:{name:"DateTime"}},metadata:{serializedName:"metadata",type:{name:"Dictionary",value:{type:{name:"String"}}}}}}},pei={type:{name:"Composite",className:"ChatMessageContent",modelProperties:{message:{serializedName:"message",type:{name:"String"}},topic:{serializedName:"topic",type:{name:"String"}},participants:{serializedName:"participants",type:{name:"Sequence",element:{type:{name:"Composite",className:"ChatParticipant"}}}},attachments:{serializedName:"attachments",type:{name:"Sequence",element:{type:{name:"Composite",className:"ChatAttachment"}}}},initiatorCommunicationIdentifier:{serializedName:"initiatorCommunicationIdentifier",type:{name:"Composite",className:"CommunicationIdentifierModel"}}}}},gei={type:{name:"Composite",className:"ChatParticipant",modelProperties:{communicationIdentifier:{serializedName:"communicationIdentifier",type:{name:"Composite",className:"CommunicationIdentifierModel"}},displayName:{serializedName:"displayName",type:{name:"String"}},shareHistoryTime:{serializedName:"shareHistoryTime",type:{name:"DateTime"}}}}},mei={type:{name:"Composite",className:"ChatAttachment",modelProperties:{id:{serializedName:"id",required:!0,type:{name:"String"}},attachmentType:{serializedName:"attachmentType",required:!0,type:{name:"Enum",allowedValues:["image","file"]}},name:{serializedName:"name",type:{name:"String"}},url:{serializedName:"url",type:{name:"String"}},previewUrl:{serializedName:"previewUrl",type:{name:"String"}}}}},BHe={type:{name:"Composite",className:"UpdateChatMessageRequest",modelProperties:{content:{serializedName:"content",type:{name:"String"}},metadata:{serializedName:"metadata",type:{name:"Dictionary",value:{type:{name:"String"}}}}}}},lfe={type:{name:"Composite",className:"ChatParticipantsCollection",modelProperties:{value:{serializedName:"value",required:!0,type:{name:"Sequence",element:{type:{name:"Composite",className:"ChatParticipant"}}}},nextLink:{serializedName:"nextLink",readOnly:!0,type:{name:"String"}}}}},FHe={type:{name:"Composite",className:"AddChatParticipantsRequest",modelProperties:{participants:{serializedName:"participants",required:!0,type:{name:"Sequence",element:{type:{name:"Composite",className:"ChatParticipant"}}}}}}},UHe={type:{name:"Composite",className:"AddChatParticipantsResult",modelProperties:{invalidParticipants:{serializedName:"invalidParticipants",readOnly:!0,type:{name:"Sequence",element:{type:{name:"Composite",className:"ChatError"}}}}}}},zHe={type:{name:"Composite",className:"CreateChatThreadRequest",modelProperties:{topic:{serializedName:"topic",required:!0,type:{name:"String"}},participants:{serializedName:"participants",type:{name:"Sequence",element:{type:{name:"Composite",className:"ChatParticipant"}}}}}}},VHe={type:{name:"Composite",className:"CreateChatThreadResult",modelProperties:{chatThread:{serializedName:"chatThread",type:{name:"Composite",className:"ChatThreadProperties"}},invalidParticipants:{serializedName:"invalidParticipants",readOnly:!0,type:{name:"Sequence",element:{type:{name:"Composite",className:"ChatError"}}}}}}},$He={type:{name:"Composite",className:"ChatThreadProperties",modelProperties:{id:{serializedName:"id",required:!0,type:{name:"String"}},topic:{serializedName:"topic",required:!0,type:{name:"String"}},createdOn:{serializedName:"createdOn",required:!0,type:{name:"DateTime"}},createdByCommunicationIdentifier:{serializedName:"createdByCommunicationIdentifier",type:{name:"Composite",className:"CommunicationIdentifierModel"}},deletedOn:{serializedName:"deletedOn",type:{name:"DateTime"}}}}},cfe={type:{name:"Composite",className:"ChatThreadsItemCollection",modelProperties:{value:{serializedName:"value",required:!0,type:{name:"Sequence",element:{type:{name:"Composite",className:"ChatThreadItem"}}}},nextLink:{serializedName:"nextLink",readOnly:!0,type:{name:"String"}}}}},fei={type:{name:"Composite",className:"ChatThreadItem",modelProperties:{id:{serializedName:"id",required:!0,type:{name:"String"}},topic:{serializedName:"topic",required:!0,type:{name:"String"}},deletedOn:{serializedName:"deletedOn",type:{name:"DateTime"}},lastMessageReceivedOn:{serializedName:"lastMessageReceivedOn",readOnly:!0,type:{name:"DateTime"}}}}},HHe={type:{name:"Composite",className:"UpdateChatThreadRequest",modelProperties:{topic:{serializedName:"topic",type:{name:"String"}}}}},jHe={type:{name:"Composite",className:"SendTypingNotificationRequest",modelProperties:{senderDisplayName:{serializedName:"senderDisplayName",type:{name:"String"}}}}},GHe=Object.freeze(Object.defineProperty({__proto__:null,AddChatParticipantsRequest:FHe,AddChatParticipantsResult:UHe,ChatAttachment:mei,ChatError:hei,ChatMessage:xHe,ChatMessageContent:pei,ChatMessageReadReceipt:sei,ChatMessageReadReceiptsCollection:ofe,ChatMessagesCollection:sfe,ChatParticipant:gei,ChatParticipantsCollection:lfe,ChatThreadItem:fei,ChatThreadProperties:$He,ChatThreadsItemCollection:cfe,CommunicationErrorResponse:Ua,CommunicationIdentifierModel:DHe,CommunicationUserIdentifierModel:lei,CreateChatThreadRequest:zHe,CreateChatThreadResult:VHe,MicrosoftTeamsAppIdentifierModel:uei,MicrosoftTeamsUserIdentifierModel:dei,PhoneNumberIdentifierModel:cei,SendChatMessageRequest:OHe,SendChatMessageResult:NHe,SendReadReceiptRequest:LHe,SendTypingNotificationRequest:jHe,UpdateChatMessageRequest:BHe,UpdateChatThreadRequest:HHe},Symbol.toStringTag,{value:"Module"})),Xg={parameterPath:"accept",mapper:{defaultValue:"application/json",isConstant:!0,serializedName:"Accept",type:{name:"String"}}},em={parameterPath:"endpoint",mapper:{serializedName:"endpoint",required:!0,type:{name:"String"}},skipEncoding:!0},Wv={parameterPath:"chatThreadId",mapper:{serializedName:"chatThreadId",required:!0,type:{name:"String"}}},pX={parameterPath:["options","maxPageSize"],mapper:{serializedName:"maxPageSize",type:{name:"Number"}}},qHe={parameterPath:["options","skip"],mapper:{serializedName:"skip",type:{name:"Number"}}},eS={parameterPath:"apiVersion",mapper:{defaultValue:"2024-03-07",isConstant:!0,serializedName:"api-version",type:{name:"String"}}},F4={parameterPath:["options","contentType"],mapper:{defaultValue:"application/json",isConstant:!0,serializedName:"Content-Type",type:{name:"String"}}},vei={parameterPath:"sendReadReceiptRequest",mapper:LHe},yei={parameterPath:"sendChatMessageRequest",mapper:OHe},WHe={parameterPath:["options","startTime"],mapper:{serializedName:"startTime",type:{name:"DateTime"}}},dfe={parameterPath:"chatMessageId",mapper:{serializedName:"chatMessageId",required:!0,type:{name:"String"}}},KHe={parameterPath:["options","contentType"],mapper:{defaultValue:"application/merge-patch+json",isConstant:!0,serializedName:"Content-Type",type:{name:"String"}}},Sei={parameterPath:"updateChatMessageRequest",mapper:BHe},bei={parameterPath:"participantCommunicationIdentifier",mapper:DHe},Tei={parameterPath:"addChatParticipantsRequest",mapper:FHe},Cei={parameterPath:"updateChatThreadRequest",mapper:HHe},_ei={parameterPath:["options","sendTypingNotificationRequest"],mapper:jHe},gX={parameterPath:"nextLink",mapper:{serializedName:"nextLink",required:!0,type:{name:"String"}},skipEncoding:!0},Eei={parameterPath:"createChatThreadRequest",mapper:zHe},Aei={parameterPath:["options","repeatabilityRequestId"],mapper:{serializedName:"repeatability-request-id",type:{name:"String"}}};class Iei{constructor(e){this.client=e}async listChatReadReceipts(e,i){return ac.withSpan("ChatApiClient.listChatReadReceipts",i??{},async r=>this.client.sendOperationRequest({chatThreadId:e,options:r},wei))}async sendChatReadReceipt(e,i,r){return ac.withSpan("ChatApiClient.sendChatReadReceipt",r??{},async o=>this.client.sendOperationRequest({chatThreadId:e,sendReadReceiptRequest:i,options:o},kei))}async sendChatMessage(e,i,r){return ac.withSpan("ChatApiClient.sendChatMessage",r??{},async o=>this.client.sendOperationRequest({chatThreadId:e,sendChatMessageRequest:i,options:o},Rei))}async listChatMessages(e,i){return ac.withSpan("ChatApiClient.listChatMessages",i??{},async r=>this.client.sendOperationRequest({chatThreadId:e,options:r},Mei))}async getChatMessage(e,i,r){return ac.withSpan("ChatApiClient.getChatMessage",r??{},async o=>this.client.sendOperationRequest({chatThreadId:e,chatMessageId:i,options:o},Pei))}async updateChatMessage(e,i,r,o){return ac.withSpan("ChatApiClient.updateChatMessage",o??{},async l=>this.client.sendOperationRequest({chatThreadId:e,chatMessageId:i,updateChatMessageRequest:r,options:l},Dei))}async deleteChatMessage(e,i,r){return ac.withSpan("ChatApiClient.deleteChatMessage",r??{},async o=>this.client.sendOperationRequest({chatThreadId:e,chatMessageId:i,options:o},Lei))}async listChatParticipants(e,i){return ac.withSpan("ChatApiClient.listChatParticipants",i??{},async r=>this.client.sendOperationRequest({chatThreadId:e,options:r},Oei))}async removeChatParticipant(e,i,r){return ac.withSpan("ChatApiClient.removeChatParticipant",r??{},async o=>this.client.sendOperationRequest({chatThreadId:e,participantCommunicationIdentifier:i,options:o},Nei))}async addChatParticipants(e,i,r){return ac.withSpan("ChatApiClient.addChatParticipants",r??{},async o=>this.client.sendOperationRequest({chatThreadId:e,addChatParticipantsRequest:i,options:o},xei))}async updateChatThreadProperties(e,i,r){return ac.withSpan("ChatApiClient.updateChatThreadProperties",r??{},async o=>this.client.sendOperationRequest({chatThreadId:e,updateChatThreadRequest:i,options:o},Bei))}async getChatThreadProperties(e,i){return ac.withSpan("ChatApiClient.getChatThreadProperties",i??{},async r=>this.client.sendOperationRequest({chatThreadId:e,options:r},Fei))}async sendTypingNotification(e,i){return ac.withSpan("ChatApiClient.sendTypingNotification",i??{},async r=>this.client.sendOperationRequest({chatThreadId:e,options:r},Uei))}async listChatReadReceiptsNext(e,i,r){return ac.withSpan("ChatApiClient.listChatReadReceiptsNext",r??{},async o=>this.client.sendOperationRequest({chatThreadId:e,nextLink:i,options:o},zei))}async listChatMessagesNext(e,i,r){return ac.withSpan("ChatApiClient.listChatMessagesNext",r??{},async o=>this.client.sendOperationRequest({chatThreadId:e,nextLink:i,options:o},Vei))}async listChatParticipantsNext(e,i,r){return ac.withSpan("ChatApiClient.listChatParticipantsNext",r??{},async o=>this.client.sendOperationRequest({chatThreadId:e,nextLink:i,options:o},$ei))}}const tS=efe(GHe,!1),wei={path:"/chat/threads/{chatThreadId}/readReceipts",httpMethod:"GET",responses:{200:{bodyMapper:ofe},401:{bodyMapper:Ua,isError:!0},403:{bodyMapper:Ua,isError:!0},429:{bodyMapper:Ua,isError:!0},503:{bodyMapper:Ua,isError:!0}},queryParameters:[pX,qHe,eS],urlParameters:[em,Wv],headerParameters:[Xg],serializer:tS},kei={path:"/chat/threads/{chatThreadId}/readReceipts",httpMethod:"POST",responses:{200:{},401:{bodyMapper:Ua,isError:!0},403:{bodyMapper:Ua,isError:!0},429:{bodyMapper:Ua,isError:!0},503:{bodyMapper:Ua,isError:!0}},requestBody:vei,queryParameters:[eS],urlParameters:[em,Wv],headerParameters:[Xg,F4],mediaType:"json",serializer:tS},Rei={path:"/chat/threads/{chatThreadId}/messages",httpMethod:"POST",responses:{201:{bodyMapper:NHe},401:{bodyMapper:Ua,isError:!0},403:{bodyMapper:Ua,isError:!0},429:{bodyMapper:Ua,isError:!0},503:{bodyMapper:Ua,isError:!0}},requestBody:yei,queryParameters:[eS],urlParameters:[em,Wv],headerParameters:[Xg,F4],mediaType:"json",serializer:tS},Mei={path:"/chat/threads/{chatThreadId}/messages",httpMethod:"GET",responses:{200:{bodyMapper:sfe},401:{bodyMapper:Ua,isError:!0},403:{bodyMapper:Ua,isError:!0},429:{bodyMapper:Ua,isError:!0},503:{bodyMapper:Ua,isError:!0}},queryParameters:[pX,eS,WHe],urlParameters:[em,Wv],headerParameters:[Xg],serializer:tS},Pei={path:"/chat/threads/{chatThreadId}/messages/{chatMessageId}",httpMethod:"GET",responses:{200:{bodyMapper:xHe},401:{bodyMapper:Ua,isError:!0},403:{bodyMapper:Ua,isError:!0},429:{bodyMapper:Ua,isError:!0},503:{bodyMapper:Ua,isError:!0}},queryParameters:[eS],urlParameters:[em,Wv,dfe],headerParameters:[Xg],serializer:tS},Dei={path:"/chat/threads/{chatThreadId}/messages/{chatMessageId}",httpMethod:"PATCH",responses:{204:{},401:{bodyMapper:Ua,isError:!0},403:{bodyMapper:Ua,isError:!0},429:{bodyMapper:Ua,isError:!0},503:{bodyMapper:Ua,isError:!0}},requestBody:Sei,queryParameters:[eS],urlParameters:[em,Wv,dfe],headerParameters:[Xg,KHe],mediaType:"json",serializer:tS},Lei={path:"/chat/threads/{chatThreadId}/messages/{chatMessageId}",httpMethod:"DELETE",responses:{204:{},401:{bodyMapper:Ua,isError:!0},403:{bodyMapper:Ua,isError:!0},429:{bodyMapper:Ua,isError:!0},503:{bodyMapper:Ua,isError:!0}},queryParameters:[eS],urlParameters:[em,Wv,dfe],headerParameters:[Xg],serializer:tS},Oei={path:"/chat/threads/{chatThreadId}/participants",httpMethod:"GET",responses:{200:{bodyMapper:lfe},401:{bodyMapper:Ua,isError:!0},403:{bodyMapper:Ua,isError:!0},429:{bodyMapper:Ua,isError:!0},503:{bodyMapper:Ua,isError:!0}},queryParameters:[pX,qHe,eS],urlParameters:[em,Wv],headerParameters:[Xg],serializer:tS},Nei={path:"/chat/threads/{chatThreadId}/participants/:remove",httpMethod:"POST",responses:{204:{},401:{bodyMapper:Ua,isError:!0},403:{bodyMapper:Ua,isError:!0},429:{bodyMapper:Ua,isError:!0},503:{bodyMapper:Ua,isError:!0}},requestBody:bei,queryParameters:[eS],urlParameters:[em,Wv],headerParameters:[Xg,F4],mediaType:"json",serializer:tS},xei={path:"/chat/threads/{chatThreadId}/participants/:add",httpMethod:"POST",responses:{201:{bodyMapper:UHe},401:{bodyMapper:Ua,isError:!0},403:{bodyMapper:Ua,isError:!0},429:{bodyMapper:Ua,isError:!0},503:{bodyMapper:Ua,isError:!0}},requestBody:Tei,queryParameters:[eS],urlParameters:[em,Wv],headerParameters:[Xg,F4],mediaType:"json",serializer:tS},Bei={path:"/chat/threads/{chatThreadId}",httpMethod:"PATCH",responses:{204:{},401:{bodyMapper:Ua,isError:!0},403:{bodyMapper:Ua,isError:!0},429:{bodyMapper:Ua,isError:!0},503:{bodyMapper:Ua,isError:!0}},requestBody:Cei,queryParameters:[eS],urlParameters:[em,Wv],headerParameters:[Xg,KHe],mediaType:"json",serializer:tS},Fei={path:"/chat/threads/{chatThreadId}",httpMethod:"GET",responses:{200:{bodyMapper:$He},401:{bodyMapper:Ua,isError:!0},403:{bodyMapper:Ua,isError:!0},429:{bodyMapper:Ua,isError:!0},503:{bodyMapper:Ua,isError:!0}},queryParameters:[eS],urlParameters:[em,Wv],headerParameters:[Xg],serializer:tS},Uei={path:"/chat/threads/{chatThreadId}/typing",httpMethod:"POST",responses:{200:{},401:{bodyMapper:Ua,isError:!0},403:{bodyMapper:Ua,isError:!0},429:{bodyMapper:Ua,isError:!0},503:{bodyMapper:Ua,isError:!0}},requestBody:_ei,queryParameters:[eS],urlParameters:[em,Wv],headerParameters:[Xg,F4],mediaType:"json",serializer:tS},zei={path:"{nextLink}",httpMethod:"GET",responses:{200:{bodyMapper:ofe},401:{bodyMapper:Ua,isError:!0},403:{bodyMapper:Ua,isError:!0},429:{bodyMapper:Ua,isError:!0},503:{bodyMapper:Ua,isError:!0}},urlParameters:[em,Wv,gX],headerParameters:[Xg],serializer:tS},Vei={path:"{nextLink}",httpMethod:"GET",responses:{200:{bodyMapper:sfe},401:{bodyMapper:Ua,isError:!0},403:{bodyMapper:Ua,isError:!0},429:{bodyMapper:Ua,isError:!0},503:{bodyMapper:Ua,isError:!0}},urlParameters:[em,Wv,gX],headerParameters:[Xg],serializer:tS},$ei={path:"{nextLink}",httpMethod:"GET",responses:{200:{bodyMapper:lfe},401:{bodyMapper:Ua,isError:!0},403:{bodyMapper:Ua,isError:!0},429:{bodyMapper:Ua,isError:!0},503:{bodyMapper:Ua,isError:!0}},urlParameters:[em,Wv,gX],headerParameters:[Xg],serializer:tS};class Hei{constructor(e){this.client=e}async createChatThread(e,i){return ac.withSpan("ChatApiClient.createChatThread",i??{},async r=>this.client.sendOperationRequest({createChatThreadRequest:e,options:r},jei))}async listChatThreads(e){return ac.withSpan("ChatApiClient.listChatThreads",e??{},async i=>this.client.sendOperationRequest({options:i},Gei))}async deleteChatThread(e,i){return ac.withSpan("ChatApiClient.deleteChatThread",i??{},async r=>this.client.sendOperationRequest({chatThreadId:e,options:r},qei))}async listChatThreadsNext(e,i){return ac.withSpan("ChatApiClient.listChatThreadsNext",i??{},async r=>this.client.sendOperationRequest({nextLink:e,options:r},Wei))}}const mX=efe(GHe,!1),jei={path:"/chat/threads",httpMethod:"POST",responses:{201:{bodyMapper:VHe},401:{bodyMapper:Ua,isError:!0},403:{bodyMapper:Ua,isError:!0},429:{bodyMapper:Ua,isError:!0},503:{bodyMapper:Ua,isError:!0}},requestBody:Eei,queryParameters:[eS],urlParameters:[em],headerParameters:[Xg,F4,Aei],mediaType:"json",serializer:mX},Gei={path:"/chat/threads",httpMethod:"GET",responses:{200:{bodyMapper:cfe},401:{bodyMapper:Ua,isError:!0},403:{bodyMapper:Ua,isError:!0},429:{bodyMapper:Ua,isError:!0},503:{bodyMapper:Ua,isError:!0}},queryParameters:[pX,eS,WHe],urlParameters:[em],headerParameters:[Xg],serializer:mX},qei={path:"/chat/threads/{chatThreadId}",httpMethod:"DELETE",responses:{204:{},401:{bodyMapper:Ua,isError:!0},403:{bodyMapper:Ua,isError:!0},429:{bodyMapper:Ua,isError:!0},503:{bodyMapper:Ua,isError:!0}},queryParameters:[eS],urlParameters:[em,Wv],headerParameters:[Xg],serializer:mX},Wei={path:"{nextLink}",httpMethod:"GET",responses:{200:{bodyMapper:cfe},401:{bodyMapper:Ua,isError:!0},403:{bodyMapper:Ua,isError:!0},429:{bodyMapper:Ua,isError:!0},503:{bodyMapper:Ua,isError:!0}},urlParameters:[em,gX],headerParameters:[Xg],serializer:mX};class JHe extends IHe{constructor(e,i){var r,o;if(e===void 0)throw new Error("'endpoint' cannot be null");i||(i={});const l={requestContentType:"application/json; charset=utf-8"},d="azsdk-js-communication-chat/1.5.4",h=i.userAgentOptions&&i.userAgentOptions.userAgentPrefix?`${i.userAgentOptions.userAgentPrefix} ${d}`:`${d}`,p=Object.assign(Object.assign(Object.assign({},l),i),{userAgentOptions:{userAgentPrefix:h},endpoint:(o=(r=i.endpoint)!==null&&r!==void 0?r:i.baseUri)!==null&&o!==void 0?o:"{endpoint}"});super(p),this.endpoint=e,this.apiVersion=i.apiVersion||"2024-03-07",this.chatThread=new Iei(this),this.chat=new Hei(this),this.addCustomApiVersionPolicy(i.apiVersion)}addCustomApiVersionPolicy(e){if(!e)return;const i={name:"CustomApiVersionPolicy",async sendRequest(r,o){const l=r.url.split("?");if(l.length>1){const d=l[1].split("&").map(h=>h.indexOf("api-version")>-1?"api-version="+e:h);r.url=l[0]+"?"+d.join("&")}return o(r)}};this.pipeline.addPolicy(i)}}const j8=zf("communication-chat"),YHe=t=>Qle({credential:{getToken:(i,r)=>t.getToken({abortSignal:r?.abortSignal})},scopes:[]}),Kei=8e3;class Jei{constructor(e,i,r,o={}){this.endpoint=e,this.timeOfLastTypingRequest=void 0,this.threadId=i,this.tokenCredential=r;const l=Object.assign(Object.assign({},o),{loggingOptions:{logger:j8.info}});this.client=new JHe(this.endpoint,Object.assign({endpoint:this.endpoint},l));const d=YHe(this.tokenCredential);this.client.pipeline.addPolicy(d)}getProperties(e={}){return ac.withSpan("ChatClient-GetProperties",e,async i=>{const r=await this.client.chatThread.getChatThreadProperties(this.threadId,i);return MHe(r)})}updateTopic(e,i={}){return ac.withSpan("ChatThreadClient-UpdateTopic",i,async r=>{await this.client.chatThread.updateChatThreadProperties(this.threadId,{topic:e},r)})}sendMessage(e,i={}){return ac.withSpan("ChatThreadClient-SendMessage",i,async r=>(this.timeOfLastTypingRequest=void 0,await this.client.chatThread.sendChatMessage(this.threadId,Object.assign(Object.assign({},e),i),r)))}getMessage(e,i={}){return ac.withSpan("ChatThreadClient-GetMessage",i,async r=>{const o=await this.client.chatThread.getChatMessage(this.threadId,e,r);return rfe(o)})}listMessagesPage(e){return dL(this,arguments,function*(r,o={}){if(!r.continuationToken){const l=yield Uc(this.client.chatThread.listChatMessages(this.threadId,o));r.continuationToken=l.nextLink,l.value&&(yield yield Uc(l.value.map(rfe,this)))}for(;r.continuationToken;){const l=yield Uc(this.client.chatThread.listChatMessagesNext(this.threadId,r.continuationToken,o));if(r.continuationToken=l.nextLink,l.value)yield yield Uc(l.value.map(rfe,this));else break}})}listMessagesAll(e){return dL(this,arguments,function*(){var r,o,l,d;try{for(var h=!0,p=uL(this.listMessagesPage({},e)),g;g=yield Uc(p.next()),r=g.done,!r;h=!0)d=g.value,h=!1,yield Uc(yield*Pq(uL(d)))}catch(f){o={error:f}}finally{try{!h&&!r&&(l=p.return)&&(yield Uc(l.call(p)))}finally{if(o)throw o.error}}})}listMessages(e={}){const{span:i,updatedOptions:r}=ac.startSpan("ChatThreadClient-ListMessages",e);try{const o=this.listMessagesAll(r);return{next(){return o.next()},[Symbol.asyncIterator](){return this},byPage:(l={})=>this.listMessagesPage(l,r)}}catch(o){throw i.setStatus({status:"error",error:o}),o}finally{i.end()}}deleteMessage(e,i={}){return ac.withSpan("ChatThreadClient-DeleteMessage",i,async r=>{await this.client.chatThread.deleteChatMessage(this.threadId,e,r)})}async updateMessage(e,i={}){return ac.withSpan("ChatThreadClient-UpdateMessage",i,async r=>{await this.client.chatThread.updateChatMessage(this.threadId,e,i,r)})}async addParticipants(e,i={}){return ac.withSpan("ChatThreadClient-AddParticipants",i,async r=>await this.client.chatThread.addChatParticipants(this.threadId,aei(e),r))}listParticipantsPage(e){return dL(this,arguments,function*(r,o={}){if(!r.continuationToken){const l=yield Uc(this.client.chatThread.listChatParticipants(this.threadId,o));r.continuationToken=l.nextLink,l.value&&(yield yield Uc(l.value.map(afe,this)))}for(;r.continuationToken;){const l=yield Uc(this.client.chatThread.listChatParticipantsNext(this.threadId,r.continuationToken,o));if(r.continuationToken=l.nextLink,l.value)yield yield Uc(l.value.map(afe,this));else break}})}listParticipantsAll(e){return dL(this,arguments,function*(){var r,o,l,d;try{for(var h=!0,p=uL(this.listParticipantsPage({},e)),g;g=yield Uc(p.next()),r=g.done,!r;h=!0)d=g.value,h=!1,yield Uc(yield*Pq(uL(d)))}catch(f){o={error:f}}finally{try{!h&&!r&&(l=p.return)&&(yield Uc(l.call(p)))}finally{if(o)throw o.error}}})}listParticipants(e={}){const{span:i,updatedOptions:r}=ac.startSpan("ChatThreadClient-ListParticipants",e);try{const o=this.listParticipantsAll(r);return{next(){return o.next()},[Symbol.asyncIterator](){return this},byPage:(l={})=>this.listParticipantsPage(l,r)}}catch(o){throw i.setStatus({status:"error",error:o}),o}finally{i.end()}}async removeParticipant(e,i={}){return ac.withSpan("ChatThreadClient-RemoveParticipant",i,async r=>{await this.client.chatThread.removeChatParticipant(this.threadId,TDe(e),r)})}async sendTypingNotification(e={}){return ac.withSpan("ChatThreadClient-SendTypingNotification",e,async i=>{const r=new Date,{senderDisplayName:o}=i,l=Mm(i,["senderDisplayName"]);return this.canPostTypingNotification(r)?(this.timeOfLastTypingRequest=r,await this.client.chatThread.sendTypingNotification(this.threadId,Object.assign({sendTypingNotificationRequest:{senderDisplayName:o}},l)),!0):(j8.info(`Typing Notification NOT Send. [thread_id=${this.threadId}]`),!1)})}async sendReadReceipt(e,i={}){return ac.withSpan("ChatThreadClient-SendReadReceipt",i,async r=>{await this.client.chatThread.sendChatReadReceipt(this.threadId,e,r)})}listReadReceiptsPage(e){return dL(this,arguments,function*(r,o={}){if(!r.continuationToken){const l=yield Uc(this.client.chatThread.listChatReadReceipts(this.threadId,o));r.continuationToken=l.nextLink,l.value&&(yield yield Uc(l.value.map(PHe,this)))}for(;r.continuationToken;){const l=yield Uc(this.client.chatThread.listChatReadReceiptsNext(this.threadId,r.continuationToken,o));if(r.continuationToken=l.nextLink,l.value)yield yield Uc(l.value.map(PHe,this));else break}})}listReadReceiptsAll(e){return dL(this,arguments,function*(){var r,o,l,d;try{for(var h=!0,p=uL(this.listReadReceiptsPage({},e)),g;g=yield Uc(p.next()),r=g.done,!r;h=!0)d=g.value,h=!1,yield Uc(yield*Pq(uL(d)))}catch(f){o={error:f}}finally{try{!h&&!r&&(l=p.return)&&(yield Uc(l.call(p)))}finally{if(o)throw o.error}}})}listReadReceipts(e={}){const{span:i,updatedOptions:r}=ac.startSpan("ChatThreadClient-ListChatReadReceipts",e);try{const o=this.listReadReceiptsAll(r);return{next(){return o.next()},[Symbol.asyncIterator](){return this},byPage:(l={})=>this.listReadReceiptsPage(l,r)}}catch(o){throw i.setStatus({status:"error",error:o}),o}finally{i.end()}}canPostTypingNotification(e){return this.timeOfLastTypingRequest&&e.getTime()-this.timeOfLastTypingRequest.getTime()<Kei?(j8.info(`Typing interval check failed. [last_request=${this.timeOfLastTypingRequest}]`),!1):!0}}function Yei(){return sHe()}const Qei=(t,e,i)=>{var r,o,l,d;return new nfe.CommunicationSignalingClient(t,e,{resourceEndpoint:(r=i?.resourceEndpoint)!==null&&r!==void 0?r:void 0,gatewayApiVersion:(o=i?.gatewayApiVersion)!==null&&o!==void 0?o:void 0,additionalPolicies:(l=i?.additionalPolicies)!==null&&l!==void 0?l:void 0,userAgentOptions:(d=i?.userAgentOptions)!==null&&d!==void 0?d:void 0})};class Zei{constructor(e,i,r={}){this.endpoint=e,this.signalingClient=void 0,this.emitter=new QB.EventEmitter,this.isRealtimeNotificationsStarted=!1,this.tokenCredential=i;const o=Object.assign(Object.assign({},r),{loggingOptions:{logger:j8.info}});this.client=new JHe(this.endpoint,Object.assign({endpoint:this.endpoint},o));const l=YHe(this.tokenCredential);this.client.pipeline.addPolicy(l),this.clientOptions=Object.assign({},r),this.clientOptions.signalingClientOptions=Object.assign(Object.assign({},this.clientOptions.signalingClientOptions),{resourceEndpoint:this.endpoint,gatewayApiVersion:this.client.apiVersion}),this.signalingClient=Qei(i,j8,this.clientOptions.signalingClientOptions)}getChatThreadClient(e){return new Jei(this.endpoint,e,this.tokenCredential,this.clientOptions)}async createChatThread(e,i={}){return ac.withSpan("ChatClient-CreateChatThread",i,async r=>{var o,l;r.idempotencyToken=(o=r.idempotencyToken)!==null&&o!==void 0?o:Yei();const d=nei(r),h=await this.client.chat.createChatThread({topic:e.topic,participants:(l=i.participants)===null||l===void 0?void 0:l.map(p=>RHe(p))},d);return oei(h)})}listChatThreadsPage(e){return dL(this,arguments,function*(r,o={}){if(!r.continuationToken){const l=yield Uc(this.client.chat.listChatThreads(o));r.continuationToken=l.nextLink,l.value&&(yield yield Uc(l.value))}for(;r.continuationToken;){const l=yield Uc(this.client.chat.listChatThreadsNext(r.continuationToken,o));if(r.continuationToken=l.nextLink,l.value)yield yield Uc(l.value);else break}})}listChatThreadsAll(e){return dL(this,arguments,function*(){var r,o,l,d;try{for(var h=!0,p=uL(this.listChatThreadsPage({},e)),g;g=yield Uc(p.next()),r=g.done,!r;h=!0)d=g.value,h=!1,yield Uc(yield*Pq(uL(d)))}catch(f){o={error:f}}finally{try{!h&&!r&&(l=p.return)&&(yield Uc(l.call(p)))}finally{if(o)throw o.error}}})}listChatThreads(e={}){const{span:i,updatedOptions:r}=ac.startSpan("ChatClient-ListChatThreads",e);try{const o=this.listChatThreadsAll(r);return{next(){return o.next()},[Symbol.asyncIterator](){return this},byPage:(l={})=>this.listChatThreadsPage(l,r)}}catch(o){throw i.setStatus({error:o,status:"error"}),o}finally{i.end()}}async deleteChatThread(e,i={}){return ac.withSpan("ChatClient-DeleteChatThread",i,async r=>{await this.client.chat.deleteChatThread(e,r)})}async startRealtimeNotifications(){if(this.signalingClient===void 0)throw new Error("Realtime notifications are not supported in node js.");this.isRealtimeNotificationsStarted||(this.isRealtimeNotificationsStarted=!0,await this.signalingClient.start(),this.subscribeToSignalingEvents())}async stopRealtimeNotifications(){if(this.signalingClient===void 0)throw new Error("Realtime notifications are not supported in node js.");this.isRealtimeNotificationsStarted=!1,await this.signalingClient.stop(),this.emitter.removeAllListeners()}on(e,i){if(this.signalingClient===void 0)throw new Error("Realtime notifications are only supported in the browser.");if(!this.isRealtimeNotificationsStarted&&e!=="realTimeNotificationConnected"&&e!=="realTimeNotificationDisconnected")throw new Error("You must call startRealtimeNotifications before you can subscribe to events.");this.emitter.on(e,i)}off(e,i){if(this.signalingClient===void 0)throw new Error("Realtime notifications are only supported in the browser.");this.emitter.removeListener(e,i)}subscribeToSignalingEvents(){if(this.signalingClient===void 0)throw new Error("Realtime notifications are only supported in the browser.");this.signalingClient.on("connectionChanged",e=>{e===nfe.ConnectionState.Connected?this.emitter.emit("realTimeNotificationConnected"):e===nfe.ConnectionState.Disconnected&&this.emitter.emit("realTimeNotificationDisconnected")}),this.signalingClient.on("chatMessageReceived",e=>{this.emitter.emit("chatMessageReceived",e)}),this.signalingClient.on("chatMessageEdited",e=>{this.emitter.emit("chatMessageEdited",e)}),this.signalingClient.on("chatMessageDeleted",e=>{this.emitter.emit("chatMessageDeleted",e)}),this.signalingClient.on("typingIndicatorReceived",e=>{this.emitter.emit("typingIndicatorReceived",e)}),this.signalingClient.on("readReceiptReceived",e=>{this.emitter.emit("readReceiptReceived",e)}),this.signalingClient.on("chatThreadCreated",e=>{this.emitter.emit("chatThreadCreated",e)}),this.signalingClient.on("chatThreadDeleted",e=>{this.emitter.emit("chatThreadDeleted",e)}),this.signalingClient.on("chatThreadPropertiesUpdated",e=>{this.emitter.emit("chatThreadPropertiesUpdated",e)}),this.signalingClient.on("participantsAdded",e=>{this.emitter.emit("participantsAdded",e)}),this.signalingClient.on("participantsRemoved",e=>{this.emitter.emit("participantsRemoved",e)})}}class QHe extends Error{constructor(e,i,r){super(),this.target=e,this.innerError=i,this.timestamp=r??new Date(Date.now()),this.name="ChatError",this.message=`${this.target}: ${this.innerError.message}`}}const Xei={TYPING_INDICATOR_MAINTAIN_TIME:8*1e3},ZHe=zf("communication-react:chat-stateful");var pF=function(t,e,i,r){function o(l){return l instanceof i?l:new i(function(d){d(l)})}return new(i||(i=Promise))(function(l,d){function h(f){try{g(r.next(f))}catch(y){d(y)}}function p(f){try{g(r.throw(f))}catch(y){d(y)}}function g(f){f.done?l(f.value):o(f.value).then(h,p)}g((r=r.apply(t,e||[])).next())})};class XHe{constructor(e,i){this._messagesNeedingResourceRetrieval=[],this.isActive=!1,this._requestsToCancel={},this._context=e,this._credential=i.credential,this._endpoint=i.endpoint}containsMessageWithSameAttachments(e){var i,r,o;let l=!1;const d=(i=e.content)===null||i===void 0?void 0:i.attachments;if(d)for(const h of this._messagesNeedingResourceRetrieval){const p=(o=(r=h.content)===null||r===void 0?void 0:r.attachments)!==null&&o!==void 0?o:[];if(l=d.every((g,f)=>g===p[f]),l)break}return l}addMessage(e){const i=Object.assign({},e);this._messagesNeedingResourceRetrieval.push(i)}startQueue(e,i,r){return pF(this,void 0,void 0,function*(){if(!this.isActive)for(;this._messagesNeedingResourceRetrieval.length>0;){this.isActive=!0;let o=this._messagesNeedingResourceRetrieval.shift();if(!o){this.isActive=!1;continue}if(r){const l=r.singleUrl;o=yield this.downloadSingleUrl(o,l,i)}else o=yield this.downloadAllPreviewUrls(o,i);this._context.setChatMessage(e,o),this.isActive=!1}})}cancelAllRequests(){for(const e of Object.values(this._requestsToCancel))e.abortController.abort();this._requestsToCancel={}}cancelRequest(e){var i;this._requestsToCancel[e]&&((i=this._requestsToCancel[e])===null||i===void 0||i.abortController.abort(),delete this._requestsToCancel[e])}downloadSingleUrl(e,i,r){return pF(this,void 0,void 0,function*(){const o={sourceUrl:""};try{const l=new AbortController,d=yield this.downloadResource(r,i,l);o.sourceUrl=d}catch(l){o.error=l,delete this._requestsToCancel[i]}return e=Object.assign(Object.assign({},e),{resourceCache:Object.assign(Object.assign({},e.resourceCache),{[i]:o})}),e})}downloadAllPreviewUrls(e,i){return pF(this,void 0,void 0,function*(){var r;const o=(r=e.content)===null||r===void 0?void 0:r.attachments;if(e.type==="html"&&o){e.resourceCache===void 0&&(e.resourceCache={});for(const l of o)if(l.previewUrl&&l.attachmentType==="image"){const d={sourceUrl:""};try{const h=new AbortController,p=yield this.downloadResource(i,l.previewUrl,h);d.sourceUrl=p}catch(h){d.error=h,delete this._requestsToCancel[l.previewUrl]}e.resourceCache[l.previewUrl]=d}}return e})}downloadResource(e,i,r){return pF(this,void 0,void 0,function*(){this._requestsToCancel[i]={src:i,abortController:r};const o=yield e(i,{credential:this._credential,endpoint:this._endpoint},{abortController:r});return delete this._requestsToCancel[i],o})}}const eje=(t,e,i)=>pF(void 0,void 0,void 0,function*(){function r(f,y,T){return pF(this,void 0,void 0,function*(){const C=new Headers;return C.append("Authorization",`Bearer ${y}`),yield o(f,{timeout:T.timeout,headers:C,abortController:T.abortController})})}function o(f,y){return pF(this,void 0,void 0,function*(){const{timeout:T=3e4,abortController:C}=y,E=setTimeout(()=>{C.abort()},T),I=yield fetch(f,Object.assign(Object.assign({},y),{signal:C.signal}));return clearTimeout(E),I})}const l=new URL(t),d=new URL(e.endpoint);let h="";l.hostname===d.hostname&&l.protocol==="https:"&&(h=(yield e.credential.getToken()).token);const p=yield r(t,h,i);if(p.status>=400)throw new Error(`Failed to fetch image source. Status code: ${p.status}`);const g=yield p.blob();return URL.createObjectURL(g)});var tje=function(t,e,i,r){function o(l){return l instanceof i?l:new i(function(d){d(l)})}return new(i||(i=Promise))(function(l,d){function h(f){try{g(r.next(f))}catch(y){d(y)}}function p(f){try{g(r.throw(f))}catch(y){d(y)}}function g(f){f.done?l(f.value):o(f.value).then(h,p)}g((r=r.apply(t,e||[])).next())})};l4e(),s4e();let eti=class{constructor(e,i,r){this._state={userId:{id:""},displayName:"",threads:{},latestErrors:{}},this._batchMode=!1,this.typingIndicatorInterval=void 0,this._inlineImageQueue=void 0,this._fullsizeImageQueue=void 0,this._logger=zf("communication-react:chat-context"),this._emitter=new QB.EventEmitter,i&&(this._inlineImageQueue=new XHe(this,{credential:i,endpoint:r??""}),this._fullsizeImageQueue=new XHe(this,{credential:i,endpoint:r??""})),e&&this._emitter.setMaxListeners(e)}getState(){return this._state}modifyState(e){const i=this._state;this._state=c4e(this._state,e,r=>{Vle()==="verbose"&&this._logger.info(`State change: ${HK(r)}`)}),!this._batchMode&&this._state!==i&&this._emitter.emit("stateChanged",this._state)}dispose(){this.modifyState(e=>{var i,r;(i=this._inlineImageQueue)===null||i===void 0||i.cancelAllRequests(),(r=this._fullsizeImageQueue)===null||r===void 0||r.cancelAllRequests(),Object.values(e.threads).forEach(o=>{Object.values(o.chatMessages).forEach(l=>{const d=l.resourceCache;d&&Object.values(d).forEach(h=>{h.sourceUrl&&URL.revokeObjectURL(h.sourceUrl)}),l.resourceCache=void 0})})})}downloadResourceToCache(e,i,r){return tje(this,void 0,void 0,function*(){var o;let l=(o=this.getState().threads[e])===null||o===void 0?void 0:o.chatMessages[i];l&&this._fullsizeImageQueue&&(l.resourceCache||(l=Object.assign(Object.assign({},l),{resourceCache:{}})),this._fullsizeImageQueue.addMessage(l),yield this._fullsizeImageQueue.startQueue(e,eje,{singleUrl:r}))})}removeResourceFromCache(e,i,r){this.modifyState(o=>{var l,d,h;const p=(l=o.threads[e])===null||l===void 0?void 0:l.chatMessages[i];if(p&&this._fullsizeImageQueue&&this._fullsizeImageQueue.containsMessageWithSameAttachments(p)?(d=this._fullsizeImageQueue)===null||d===void 0||d.cancelRequest(r):p&&this._inlineImageQueue&&this._inlineImageQueue.containsMessageWithSameAttachments(p)&&((h=this._inlineImageQueue)===null||h===void 0||h.cancelRequest(r)),p&&p.resourceCache&&p.resourceCache[r]){const g=p.resourceCache[r];g?.sourceUrl&&URL.revokeObjectURL(g.sourceUrl),delete p.resourceCache[r]}})}setThread(e,i){this.modifyState(r=>{r.threads[e]=i})}createThread(e,i){this.modifyState(r=>{r.threads[e]={chatMessages:{},threadId:e,properties:i,participants:{},readReceipts:[],typingIndicators:[],latestReadTime:new Date(0)}})}updateChatConfig(e,i){this.modifyState(r=>{r.displayName=i,r.userId=e})}createThreadIfNotExist(e,i){return Object.prototype.hasOwnProperty.call(this.getState().threads,e)?!1:(this.createThread(e,i),!0)}updateThread(e,i){this.modifyState(r=>{const o=r.threads[e];o&&(o.properties=i)})}updateThreadTopic(e,i){this.modifyState(r=>{if(i===void 0)return;const o=r.threads[e];o&&!o.properties?o.properties={topic:i}:o&&o.properties&&(o.properties.topic=i)})}deleteThread(e){this.modifyState(i=>{i.threads[e]&&delete i.threads[e]})}setChatMessages(e,i){this.modifyState(r=>{const o=r.threads[e];o&&(o.chatMessages=i);const l=r.threads[e];if(l)for(const d of Object.values(i))this.filterTypingIndicatorForUser(l,d.sender)})}updateChatMessageContent(e,i,r){this.modifyState(o=>{var l;const d=(l=o.threads[e])===null||l===void 0?void 0:l.chatMessages[i];d&&(d.content||(d.content={}),d.content.message=r)})}deleteLocalMessage(e,i){let r=!1;return this.modifyState(o=>{var l;const d=(l=o.threads[e])===null||l===void 0?void 0:l.chatMessages,h=d?d[i]:void 0;d&&h&&h.clientMessageId&&(delete d[h.clientMessageId],r=!0)}),r}deleteMessage(e,i){this.modifyState(r=>{var o;const l=(o=r.threads[e])===null||o===void 0?void 0:o.chatMessages;l&&delete l[i]})}setParticipant(e,i){this.modifyState(r=>{var o;const l=(o=r.threads[e])===null||o===void 0?void 0:o.participants;l&&(l[Ga(i.id)]=i)})}setParticipants(e,i){this.modifyState(r=>{var o;const l=(o=r.threads[e])===null||o===void 0?void 0:o.participants;if(l)for(const d of i)l[Ga(d.id)]=d})}deleteParticipants(e,i){this.modifyState(r=>{var o;const l=(o=r.threads[e])===null||o===void 0?void 0:o.participants;l&&i.forEach(d=>{delete l[Ga(d)]})})}deleteParticipant(e,i){this.modifyState(r=>{var o;const l=(o=r.threads[e])===null||o===void 0?void 0:o.participants;l&&delete l[Ga(i)]})}addReadReceipt(e,i){this.modifyState(r=>{const o=r.threads[e],l=o?.readReceipts;o&&l&&(i.sender!==this.getState().userId&&o.latestReadTime<i.readOn&&(o.latestReadTime=i.readOn),l.push(i))})}startTypingIndicatorCleanUp(){this.typingIndicatorInterval||(this.typingIndicatorInterval=window.setInterval(()=>{let e=!1;this.modifyState(i=>{for(const r of Object.values(i.threads)){const o=r.typingIndicators.filter(l=>Date.now()-l.receivedOn.getTime()<Xei.TYPING_INDICATOR_MAINTAIN_TIME);r.typingIndicators.length!==o.length&&(r.typingIndicators=o),r.typingIndicators.length>0&&(e=!0)}}),!e&&this.typingIndicatorInterval&&(window.clearInterval(this.typingIndicatorInterval),this.typingIndicatorInterval=void 0)},1e3))}addTypingIndicator(e,i){this.modifyState(r=>{const o=r.threads[e];o&&o.typingIndicators.push(i)}),this.startTypingIndicatorCleanUp()}setChatMessage(e,i){this.parseAttachments(e,i);const{id:r,clientMessageId:o}=i;(r||o)&&this.modifyState(l=>{var d;const h=(d=l.threads[e])===null||d===void 0?void 0:d.chatMessages,p=h&&o&&h[o],g=!r||p?o:r;h&&g&&(h[g]=i);const f=l.threads[e];f&&this.filterTypingIndicatorForUser(f,i.sender)})}parseAttachments(e,i){var r;const o=(r=i.content)===null||r===void 0?void 0:r.attachments;i.type==="html"&&o&&o.length>0&&this._inlineImageQueue&&!this._inlineImageQueue.containsMessageWithSameAttachments(i)&&i.resourceCache===void 0&&(this._inlineImageQueue.addMessage(i),this._inlineImageQueue.startQueue(e,eje))}withAsyncErrorTeedToState(e,i){return(...r)=>tje(this,void 0,void 0,function*(){try{return yield e(...r)}catch(o){const l=ije(i,o);throw this.setLatestError(i,l),l}})}withErrorTeedToState(e,i){return(...r)=>{try{return ZHe.info(`Chat stateful client target function called: ${i}`),e(...r)}catch(o){const l=ije(i,o);throw this.setLatestError(i,l),l}}}setLatestError(e,i){this.modifyState(r=>{r.latestErrors[e]=i})}filterTypingIndicatorForUser(e,i){if(!i)return;const r=e.typingIndicators,o=Ga(i),l=r.filter(d=>Ga(d.sender)!==o);l.length!==r.length&&(e.typingIndicators=l)}batch(e){if(this._batchMode)throw new Error("batch() called from within another batch()");this._batchMode=!0;const i=this._state;try{e(),this._state!==i&&this._emitter.emit("stateChanged",this._state)}catch(r){throw this._state=i,Vle()==="verbose"&&this._logger.warning(`State rollback to: ${HK(i)}`),r}finally{this._batchMode=!1}}onStateChange(e){this._emitter.on("stateChanged",e)}offStateChange(e){this._emitter.off("stateChanged",e)}};const ije=(t,e)=>e instanceof Error?new QHe(t,e):new QHe(t,new Error(`${e}`)),fX=(t,e="delivered",i)=>Object.assign(Object.assign({},t),{clientMessageId:i,status:e});var tti=function(t,e,i,r){function o(l){return l instanceof i?l:new i(function(d){d(l)})}return new(i||(i=Promise))(function(l,d){function h(f){try{g(r.next(f))}catch(y){d(y)}}function p(f){try{g(r.throw(f))}catch(y){d(y)}}function g(f){f.done?l(f.value):o(f.value).then(h,p)}g((r=r.apply(t,e||[])).next())})},iti=function(t){if(!Symbol.asyncIterator)throw new TypeError("Symbol.asyncIterator is not defined.");var e=t[Symbol.asyncIterator],i;return e?e.call(t):(t=typeof __values=="function"?__values(t):t[Symbol.iterator](),i={},r("next"),r("throw"),r("return"),i[Symbol.asyncIterator]=function(){return this},i);function r(l){i[l]=t[l]&&function(d){return new Promise(function(h,p){d=t[l](d),o(h,p,d.done,d.value)})}}function o(l,d,h,p){Promise.resolve(p).then(function(g){l({value:g,done:h})},d)}};const nti=10*1e3;class ati{constructor(e,i){this.convertEventToChatMessage=r=>fX({id:r.id,version:r.version,content:{message:r.message,attachments:r.attachments},type:this.convertEventType(r.type),sender:r.sender,senderDisplayName:r.senderDisplayName,sequenceId:"",createdOn:new Date(r.createdOn),editedOn:"editedOn"in r?r.editedOn:void 0,metadata:r.metadata}),this.convertEventType=r=>{const o=r.toLowerCase();return o==="richtext/html"||o==="html"?"html":"text"},this.onChatMessageReceived=r=>{var o;const l=r.type.toLowerCase();if(l!=="text"&&l!=="richtext/html"&&l!=="html")return;const d=this.convertEventToChatMessage(r),h=(o=this.chatContext.getState().threads[r.threadId])===null||o===void 0?void 0:o.chatMessages[r.id];h&&(d.sequenceId=h.sequenceId),this.chatContext.batch(()=>{this.chatContext.createThreadIfNotExist(r.threadId),this.chatContext.setChatMessage(r.threadId,d)})},this.onChatMessageDeleted=r=>{this.chatContext.deleteMessage(r.threadId,r.id)},this.onChatMessageEdited=r=>{const o=this.convertEventToChatMessage(r);this.chatContext.setChatMessage(r.threadId,fX(o))},this.onParticipantsAdded=r=>{const o=r.participantsAdded.map(l=>Object.assign(Object.assign({},l),{shareHistoryTime:l.shareHistoryTime?new Date(l.shareHistoryTime):void 0}));this.chatContext.batch(()=>{this.chatContext.createThreadIfNotExist(r.threadId),this.chatContext.setParticipants(r.threadId,o)}),this.fetchLastParticipantMessage(r.threadId,"participantAdded")},this.fetchLastParticipantMessage=(r,o)=>tti(this,void 0,void 0,function*(){var l,d,h,p;try{for(var g=!0,f=iti(this.chatClient.getChatThreadClient(r).listMessages({startTime:new Date(Date.now()-nti)})),y;y=yield f.next(),l=y.done,!l;g=!0){p=y.value,g=!1;const T=p;T.type===o&&this.chatContext.setChatMessage(r,Object.assign(Object.assign({},T),{status:"delivered"}))}}catch(T){d={error:T}}finally{try{!g&&!l&&(h=f.return)&&(yield h.call(f))}finally{if(d)throw d.error}}}),this.onParticipantsRemoved=r=>{const o=r.participantsRemoved.map(h=>h.id);this.chatContext.deleteParticipants(r.threadId,o);const l=Ga(this.chatContext.getState().userId);o.find(h=>Ga(h)===l)||this.fetchLastParticipantMessage(r.threadId,"participantRemoved")},this.onReadReceiptReceived=r=>{const o=Object.assign(Object.assign({},r),{sender:r.sender,readOn:new Date(r.readOn)});this.chatContext.batch(()=>{this.chatContext.createThreadIfNotExist(r.threadId),this.chatContext.addReadReceipt(r.threadId,o)})},this.onTypingIndicatorReceived=r=>{this.chatContext.batch(()=>{this.chatContext.createThreadIfNotExist(r.threadId),this.chatContext.addTypingIndicator(r.threadId,r)})},this.onChatThreadCreated=r=>{const o={topic:r.properties.topic};this.chatContext.createThreadIfNotExist(r.threadId,o)||this.chatContext.updateThread(r.threadId,o)},this.onChatThreadDeleted=r=>{this.chatContext.deleteThread(r.threadId)},this.onChatThreadPropertiesUpdated=r=>{this.chatContext.updateThread(r.threadId,{topic:r.properties.topic})},this.subscribe=()=>{this.chatClient.on("chatMessageReceived",this.onChatMessageReceived),this.chatClient.on("chatMessageDeleted",this.onChatMessageDeleted),this.chatClient.on("chatMessageEdited",this.onChatMessageEdited),this.chatClient.on("participantsAdded",this.onParticipantsAdded),this.chatClient.on("participantsRemoved",this.onParticipantsRemoved),this.chatClient.on("readReceiptReceived",this.onReadReceiptReceived),this.chatClient.on("typingIndicatorReceived",this.onTypingIndicatorReceived),this.chatClient.on("chatThreadCreated",this.onChatThreadCreated),this.chatClient.on("chatThreadDeleted",this.onChatThreadDeleted),this.chatClient.on("chatThreadPropertiesUpdated",this.onChatThreadPropertiesUpdated)},this.unsubscribe=()=>{this.chatClient.off("chatMessageReceived",this.onChatMessageReceived),this.chatClient.off("chatMessageDeleted",this.onChatMessageDeleted),this.chatClient.off("chatMessageEdited",this.onChatMessageEdited),this.chatClient.off("participantsAdded",this.onParticipantsAdded),this.chatClient.off("participantsRemoved",this.onParticipantsRemoved),this.chatClient.off("readReceiptReceived",this.onReadReceiptReceived),this.chatClient.off("typingIndicatorReceived",this.onTypingIndicatorReceived),this.chatClient.off("chatThreadCreated",this.onChatThreadCreated),this.chatClient.off("chatThreadDeleted",this.onChatThreadDeleted),this.chatClient.off("chatThreadPropertiesUpdated",this.onChatThreadPropertiesUpdated)},this.chatClient=e,this.chatContext=i,this.subscribe()}}let rti=(t=21)=>crypto.getRandomValues(new Uint8Array(t)).reduce((e,i)=>(i&=63,i<36?e+=i.toString(36):i<62?e+=(i-26).toString(36).toUpperCase():i>62?e+="-":e+="_",e),"");var nje=function(t,e,i,r){function o(l){return l instanceof i?l:new i(function(d){d(l)})}return new(i||(i=Promise))(function(l,d){function h(f){try{g(r.next(f))}catch(y){d(y)}}function p(f){try{g(r.throw(f))}catch(y){d(y)}}function g(f){f.done?l(f.value):o(f.value).then(h,p)}g((r=r.apply(t,e||[])).next())})};const vX=(t,e,i)=>(...r)=>{const o=t(...r);return{next(){return nje(this,void 0,void 0,function*(){const l=yield o.next();return!l.done&&l.value&&i(l.value,e),l})},[Symbol.asyncIterator](){return this},byPage:(l={})=>{const d=o.byPage(l);return{next(){return nje(this,void 0,void 0,function*(){const h=yield d.next(),p=h.value;return!h.done&&h.value&&e.batch(()=>{for(const g of p)i(g,e)}),h})},[Symbol.asyncIterator](){return this}}}}},yX=(t,e,i)=>(...r)=>{const o=t(...r);return{next:e.withAsyncErrorTeedToState(o.next.bind(o),i),[Symbol.asyncIterator](){return this},byPage:(l={})=>{const d=o.byPage(l);return{next:e.withAsyncErrorTeedToState(d.next.bind(d),i),[Symbol.asyncIterator](){return this}}}}},oti=(t,e)=>{const i=(r,o)=>{o.setChatMessage(t.threadId,fX(r))};return vX(yX(e.withErrorTeedToState(t.listMessages.bind(t),"ChatThreadClient.listMessages"),e,"ChatThreadClient.listMessages"),e,i)},sti=(t,e)=>{const i=(r,o)=>{o.addReadReceipt(t.threadId,Object.assign({},r))};return vX(yX(e.withErrorTeedToState(t.listReadReceipts.bind(t),"ChatThreadClient.listReadReceipts"),e,"ChatThreadClient.listReadReceipts"),e,i)},lti=(t,e)=>{const i=(r,o)=>{o.setParticipant(t.threadId,r)};return vX(yX(e.withErrorTeedToState(t.listParticipants.bind(t),"ChatThreadClient.listParticipants"),e,"ChatThreadClient.listParticipants"),e,i)};var _P=function(t,e,i,r){function o(l){return l instanceof i?l:new i(function(d){d(l)})}return new(i||(i=Promise))(function(l,d){function h(f){try{g(r.next(f))}catch(y){d(y)}}function p(f){try{g(r.throw(f))}catch(y){d(y)}}function g(f){f.done?l(f.value):o(f.value).then(h,p)}g((r=r.apply(t,e||[])).next())})};class cti{constructor(e){this._context=e}get(e,i){switch(i){case"listMessages":return oti(e,this._context);case"getMessage":return this._context.withAsyncErrorTeedToState((...r)=>_P(this,void 0,void 0,function*(){const o=yield e.getMessage(...r);return this._context.setChatMessage(e.threadId,fX(o)),o}),"ChatThreadClient.getMessage");case"sendMessage":return this._context.withAsyncErrorTeedToState((...r)=>_P(this,void 0,void 0,function*(){var o;const[l,d]=r,{content:h}=l,p=rti(),g={content:{message:h},clientMessageId:p,id:"",type:(o=d?.type)!==null&&o!==void 0?o:"text",sequenceId:"",version:"",createdOn:new Date,status:"sending",senderDisplayName:this._context.getState().displayName,sender:this._context.getState().userId,metadata:d?.metadata};this._context.setChatMessage(e.threadId,g);let f;try{f=yield e.sendMessage(...r)}catch(y){throw this._context.setChatMessage(e.threadId,Object.assign(Object.assign({},g),{status:"failed"})),y}return f?.id&&this._context.batch(()=>{f&&(this._context.setChatMessage(e.threadId,Object.assign(Object.assign({},g),{clientMessageId:void 0,status:"delivered",id:f.id})),this._context.deleteLocalMessage(e.threadId,p))}),f}),"ChatThreadClient.sendMessage");case"addParticipants":return this._context.withAsyncErrorTeedToState((...r)=>_P(this,void 0,void 0,function*(){const o=yield e.addParticipants(...r),[l]=r,d=l.participants;return this._context.setParticipants(e.threadId,d),o}),"ChatThreadClient.addParticipants");case"deleteMessage":return this._context.withAsyncErrorTeedToState((...r)=>_P(this,void 0,void 0,function*(){const[o]=r;if(this._context.deleteLocalMessage(e.threadId,o))return{};const l=yield e.deleteMessage(...r);return this._context.deleteMessage(e.threadId,o),l}),"ChatThreadClient.deleteMessage");case"listParticipants":return lti(e,this._context);case"listReadReceipts":return sti(e,this._context);case"sendTypingNotification":return this._context.withAsyncErrorTeedToState((...r)=>_P(this,void 0,void 0,function*(){return yield e.sendTypingNotification(...r)}),"ChatThreadClient.sendTypingNotification");case"removeParticipant":return this._context.withAsyncErrorTeedToState((...r)=>_P(this,void 0,void 0,function*(){const o=yield e.removeParticipant(...r),[l]=r;return this._context.deleteParticipant(e.threadId,Ap(l)),o}),"ChatThreadClient.removeParticipant");case"updateMessage":return this._context.withAsyncErrorTeedToState((...r)=>_P(this,void 0,void 0,function*(){const o=yield e.updateMessage(...r),[l,d]=r;return this._context.updateChatMessageContent(e.threadId,l,d?.content),o}),"ChatThreadClient.updateMessage");case"updateTopic":return this._context.withAsyncErrorTeedToState((...r)=>_P(this,void 0,void 0,function*(){const o=yield e.updateTopic(...r),[l]=r;return this._context.updateThreadTopic(e.threadId,l),o}),"ChatThreadClient.updateTopic");case"getProperties":return this._context.withAsyncErrorTeedToState((...r)=>_P(this,void 0,void 0,function*(){const o=yield e.getProperties(...r);return this._context.updateThread(e.threadId,o),o}),"ChatThreadClient.getProperties");default:return Reflect.get(e,i)}}}const dti=(t,e)=>(e.createThreadIfNotExist(t.threadId),new Proxy(t,new cti(e))),uti=(t,e)=>{const i=(r,o)=>{const l={topic:r.topic};o.createThreadIfNotExist(r.id,l)||o.updateThread(r.id,l)};return vX(yX(e.withErrorTeedToState(t.listChatThreads.bind(t),"ChatClient.listChatThreads"),e,"ChatClient.listChatThreads"),e,i)};var SX=function(t,e,i,r){function o(l){return l instanceof i?l:new i(function(d){d(l)})}return new(i||(i=Promise))(function(l,d){function h(f){try{g(r.next(f))}catch(y){d(y)}}function p(f){try{g(r.throw(f))}catch(y){d(y)}}function g(f){f.done?l(f.value):o(f.value).then(h,p)}g((r=r.apply(t,e||[])).next())})};const hti={get:function(t,e,i){if(e==="context")return Reflect.get(t,e);const r=i.context;switch(e){case"createChatThread":return r.withAsyncErrorTeedToState(function(...o){return SX(this,void 0,void 0,function*(){const l=yield t.createChatThread(...o),d=l.chatThread;if(d){const[h]=o;r.createThread(d.id,{topic:h.topic})}return l})},"ChatClient.createChatThread");case"deleteChatThread":return r.withAsyncErrorTeedToState(function(...o){return SX(this,void 0,void 0,function*(){const l=yield t.deleteChatThread(...o);return r.deleteThread(o[0]),l})},"ChatClient.deleteChatThread");case"listChatThreads":return uti(t,r);case"getChatThreadClient":return function(...o){const l=t.getChatThreadClient(...o);return dti(l,r)};case"startRealtimeNotifications":return r.withAsyncErrorTeedToState(function(...o){return SX(this,void 0,void 0,function*(){const l=yield t.startRealtimeNotifications(...o);return i.eventSubscriber||(i.eventSubscriber=new ati(t,r)),l})},"ChatClient.startRealtimeNotifications");case"stopRealtimeNotifications":return r.withAsyncErrorTeedToState(function(...o){return SX(this,void 0,void 0,function*(){const l=yield t.stopRealtimeNotifications(...o);return i.eventSubscriber&&(i.eventSubscriber.unsubscribe(),i.eventSubscriber=void 0),l})},"ChatClient.stopRealtimeNotifications");default:return Reflect.get(t,e)}}},pti=(t,e,i="StatefulComponents")=>{ZHe.info(`Creating chat stateful client using library version: ${$K(i)}`);const r=Object.assign(Object.assign({},e),{chatClientOptions:Object.assign(Object.assign({},void 0),{userAgentOptions:{userAgentPrefix:$K(i)}})});return gti(new Zei(t.endpoint,t.credential,r.chatClientOptions),t,r)},gti=(t,e,i)=>{const r=new eti(i?.maxStateChangeListeners,e.credential,e.endpoint);let o;r.updateChatConfig(Ap(e.userId),e.displayName);const l=new Proxy(t,hti);return Object.defineProperty(l,"context",{configurable:!1,get:()=>r}),Object.defineProperty(l,"eventSubscriber",{configurable:!1,get:()=>o,set:d=>{o=d}}),Object.defineProperty(l,"dispose",{configurable:!1,value:()=>r?.dispose()}),Object.defineProperty(l,"downloadResourceToCache",{configurable:!1,value:(d,h,p)=>r?.downloadResourceToCache(d,h,p)}),Object.defineProperty(l,"removeResourceFromCache",{configurable:!1,value:(d,h,p)=>r?.removeResourceFromCache(d,h,p)}),Object.defineProperty(l,"getState",{configurable:!1,value:()=>r?.getState()}),Object.defineProperty(l,"onStateChange",{configurable:!1,value:d=>r?.onStateChange(d)}),Object.defineProperty(l,"offStateChange",{configurable:!1,value:d=>r?.offStateChange(d)}),l},aje=17.5;var sh=function(t,e,i,r){function o(l){return l instanceof i?l:new i(function(d){d(l)})}return new(i||(i=Promise))(function(l,d){function h(f){try{g(r.next(f))}catch(y){d(y)}}function p(f){try{g(r.throw(f))}catch(y){d(y)}}function g(f){f.done?l(f.value):o(f.value).then(h,p)}g((r=r.apply(t,e||[])).next())})},mti=function(t){if(!Symbol.asyncIterator)throw new TypeError("Symbol.asyncIterator is not defined.");var e=t[Symbol.asyncIterator],i;return e?e.call(t):(t=typeof __values=="function"?__values(t):t[Symbol.iterator](),i={},r("next"),r("throw"),r("return"),i[Symbol.asyncIterator]=function(){return this},i);function r(l){i[l]=t[l]&&function(d){return new Promise(function(h,p){d=t[l](d),o(h,p,d.done,d.value)})}}function o(l,d,h,p){Promise.resolve(p).then(function(g){l({value:g,done:h})},d)}};class fti{constructor(e,i){this.emitter=new QB.EventEmitter;const r=e.threads[i];if(this.threadId=i,!r)throw"Cannot find threadId, please initialize thread before use!";this.state={userId:e.userId,displayName:e.displayName,thread:r,latestErrors:e.latestErrors}}onStateChange(e){this.emitter.on("stateChanged",e)}offStateChange(e){this.emitter.off("stateChanged",e)}setState(e){this.state=e,this.emitter.emit("stateChanged",this.state)}getState(){return this.state}setError(e){this.setState(Object.assign(Object.assign({},this.state),{error:e}))}updateClientState(e){const i=e.threads[this.threadId];if(!i)throw"Cannot find threadId, please make sure thread state is still in Stateful ChatClient.";let r={userId:e.userId,displayName:e.displayName,thread:i,latestErrors:e.latestErrors};this.setState(r)}}class vti{constructor(e,i){this.emitter=new QB.EventEmitter,this.bindAllPublicMethods(),this.chatClient=e,this.chatThreadClient=i,this.context=new fti(e.getState(),i.threadId);const r=o=>{if(!this){e.offStateChange(r);return}this.context.updateClientState(o)};this.handlers=zQt(e,i),this.chatClient.onStateChange(r),this.subscribeAllEvents()}bindAllPublicMethods(){this.onStateChange=this.onStateChange.bind(this),this.offStateChange=this.offStateChange.bind(this),this.getState=this.getState.bind(this),this.dispose=this.dispose.bind(this),this.fetchInitialData=this.fetchInitialData.bind(this),this.sendMessage=this.sendMessage.bind(this),this.sendReadReceipt=this.sendReadReceipt.bind(this),this.sendTypingIndicator=this.sendTypingIndicator.bind(this),this.updateMessage=this.updateMessage.bind(this),this.deleteMessage=this.deleteMessage.bind(this),this.removeParticipant=this.removeParticipant.bind(this),this.setTopic=this.setTopic.bind(this),this.loadPreviousChatMessages=this.loadPreviousChatMessages.bind(this),this.on=this.on.bind(this),this.off=this.off.bind(this),this.downloadResourceToCache=this.downloadResourceToCache.bind(this),this.removeResourceFromCache=this.removeResourceFromCache.bind(this)}dispose(){this.unsubscribeAllEvents(),this.chatClient.dispose()}fetchInitialData(){return sh(this,void 0,void 0,function*(){yield this.asyncTeeErrorToEventEmitter(()=>sh(this,void 0,void 0,function*(){var e,i,r,o;yield this.chatThreadClient.getProperties();try{for(var l=!0,d=mti(this.chatThreadClient.listParticipants().byPage({maxPageSize:100})),h;h=yield d.next(),e=h.done,!e;l=!0){o=h.value,l=!1;const p=o}}catch(p){i={error:p}}finally{try{!l&&!e&&(r=d.return)&&(yield r.call(d))}finally{if(i)throw i.error}}}))})}getState(){return this.context.getState()}onStateChange(e){this.context.onStateChange(e)}offStateChange(e){this.context.offStateChange(e)}sendMessage(e,i){return sh(this,void 0,void 0,function*(){yield this.asyncTeeErrorToEventEmitter(()=>sh(this,void 0,void 0,function*(){return yield this.handlers.onSendMessage(e,i)}))})}sendReadReceipt(e){return sh(this,void 0,void 0,function*(){yield this.asyncTeeErrorToEventEmitter(()=>sh(this,void 0,void 0,function*(){yield this.handlers.onMessageSeen(e)}))})}sendTypingIndicator(){return sh(this,void 0,void 0,function*(){yield this.asyncTeeErrorToEventEmitter(()=>sh(this,void 0,void 0,function*(){yield this.handlers.onTyping()}))})}removeParticipant(e){return sh(this,void 0,void 0,function*(){yield this.asyncTeeErrorToEventEmitter(()=>sh(this,void 0,void 0,function*(){yield this.handlers.onRemoveParticipant(e)}))})}setTopic(e){return sh(this,void 0,void 0,function*(){yield this.asyncTeeErrorToEventEmitter(()=>sh(this,void 0,void 0,function*(){yield this.handlers.updateThreadTopicName(e)}))})}loadPreviousChatMessages(e){return sh(this,void 0,void 0,function*(){return yield this.asyncTeeErrorToEventEmitter(()=>sh(this,void 0,void 0,function*(){return yield this.handlers.onLoadPreviousChatMessages(e)}))})}updateMessage(e,i,r){return sh(this,void 0,void 0,function*(){return yield this.asyncTeeErrorToEventEmitter(()=>sh(this,void 0,void 0,function*(){return yield this.handlers.onUpdateMessage(e,i)}))})}deleteMessage(e){return sh(this,void 0,void 0,function*(){return yield this.asyncTeeErrorToEventEmitter(()=>sh(this,void 0,void 0,function*(){return yield this.handlers.onDeleteMessage(e)}))})}downloadResourceToCache(e){return sh(this,void 0,void 0,function*(){this.chatClient.downloadResourceToCache(e.threadId,e.messageId,e.resourceUrl)})}removeResourceFromCache(e){this.chatClient.removeResourceFromCache(e.threadId,e.messageId,e.resourceUrl)}messageReceivedListener(e){if(!(e.threadId===this.chatThreadClient.threadId))return;const r=ufe(e);this.emitter.emit("messageReceived",{message:r});const o=Ga(this.chatClient.getState().userId);r?.sender&&Ga(r.sender)===o&&this.emitter.emit("messageSent",{message:r})}messageEditedListener(e){if(!(e.threadId===this.chatThreadClient.threadId))return;const r=ufe(e);this.emitter.emit("messageEdited",{message:r})}messageDeletedListener(e){if(!(e.threadId===this.chatThreadClient.threadId))return;const r=ufe(e);this.emitter.emit("messageDeleted",{message:r})}messageReadListener({chatMessageId:e,recipient:i}){const r=this.getState().thread.chatMessages[e];r&&this.emitter.emit("messageRead",{message:r,readBy:i})}participantsAddedListener({addedBy:e,participantsAdded:i}){this.emitter.emit("participantsAdded",{addedBy:e,participantsAdded:i})}participantsRemovedListener({removedBy:e,participantsRemoved:i}){this.emitter.emit("participantsRemoved",{removedBy:e,participantsRemoved:i})}chatThreadPropertiesUpdatedListener(e){this.emitter.emit("topicChanged",{topic:e.properties.topic})}subscribeAllEvents(){this.chatClient.on("chatThreadPropertiesUpdated",this.chatThreadPropertiesUpdatedListener.bind(this)),this.chatClient.on("participantsAdded",this.participantsAddedListener.bind(this)),this.chatClient.on("participantsRemoved",this.participantsRemovedListener.bind(this)),this.chatClient.on("chatMessageReceived",this.messageReceivedListener.bind(this)),this.chatClient.on("chatMessageEdited",this.messageEditedListener.bind(this)),this.chatClient.on("chatMessageDeleted",this.messageDeletedListener.bind(this)),this.chatClient.on("readReceiptReceived",this.messageReadListener.bind(this)),this.chatClient.on("participantsRemoved",this.participantsRemovedListener.bind(this))}unsubscribeAllEvents(){this.chatClient.off("chatThreadPropertiesUpdated",this.chatThreadPropertiesUpdatedListener.bind(this)),this.chatClient.off("participantsAdded",this.participantsAddedListener.bind(this)),this.chatClient.off("participantsRemoved",this.participantsRemovedListener.bind(this)),this.chatClient.off("chatMessageReceived",this.messageReceivedListener.bind(this)),this.chatClient.off("chatMessageEdited",this.messageEditedListener.bind(this)),this.chatClient.off("chatMessageDeleted",this.messageDeletedListener.bind(this)),this.chatClient.off("readReceiptReceived",this.messageReadListener.bind(this)),this.chatClient.off("participantsRemoved",this.participantsRemovedListener.bind(this))}on(e,i){this.emitter.on(e,i)}off(e,i){this.emitter.off(e,i)}asyncTeeErrorToEventEmitter(e){return sh(this,void 0,void 0,function*(){try{return yield e()}catch(i){throw Eti(i)&&this.emitter.emit("error",i),i}})}}const ufe=t=>({id:t.id,version:t.version,content:rje(t)?void 0:{message:t.message},type:Sti(t.type),sender:t.sender,senderDisplayName:t.senderDisplayName,sequenceId:"",createdOn:new Date(t.createdOn),editedOn:yti(t)?t.editedOn:void 0,deletedOn:rje(t)?t.deletedOn:void 0}),yti=t=>"editedOn"in t,rje=t=>"deletedOn"in t,Sti=t=>{const e=t.toLowerCase();return e==="richtext/html"||e==="html"?"html":"text"},bti=t=>sh(void 0,[t],void 0,function*({endpoint:e,userId:i,displayName:r,credential:o,threadId:l}){return Tti(e,i,r,o,l)}),Tti=(t,e,i,r,o,...l)=>sh(void 0,[t,e,i,r,o,...l],void 0,function*(d,h,p,g,f,y="Chat"){if(!CDe(h))throw new Error("Provided userId is invalid. Please provide valid identifier object.");const T=pti({userId:h,displayName:p,endpoint:d,credential:g},void 0,y),C=yield T.getChatThreadClient(f);return yield T.startRealtimeNotifications(),yield _ti(T,C)}),Cti=(t,e,i)=>{const{credential:r,displayName:o,endpoint:l,threadId:d,userId:h}=t,[p,g]=$.useState(void 0),f=$.useRef(void 0),y=$.useRef(!1),T=$.useRef(void 0),C=$.useRef(void 0);return T.current=e,C.current=i,$.useEffect(()=>{!r||!o||!l||!d||!h||sh(void 0,void 0,void 0,function*(){if(f.current&&(C.current&&(yield C.current(f.current)),f.current.dispose(),f.current=void 0),y.current){console.warn("Adapter is already being created, please see storybook for more information: https://azure.github.io/communication-ui-library/?path=/story/troubleshooting--page");return}y.current=!0;let E=yield bti({credential:r,displayName:o,endpoint:l,threadId:d,userId:h});T.current&&(E=yield T.current(E)),f.current=E,y.current=!1,g(E)})},[f,T,C,r,o,l,d,h]),$.useEffect(()=>()=>{sh(void 0,void 0,void 0,function*(){f.current&&(C.current&&(yield C.current(f.current)),f.current.dispose(),f.current=void 0)})},[]),p};function _ti(t,e){return sh(this,void 0,void 0,function*(){return new vti(t,e)})}const Eti=t=>"target"in t&&t.target!==void 0&&"innerError"in t&&t.innerError!==void 0,oje={call:JSON.parse(`{"cameraLabel":"Camera","noCamerasLabel":"No cameras found","cameraPermissionDenied":"Your browser is blocking access to your camera","cameraTurnedOff":"Your camera is turned off","chatButtonLabel":"Chat","close":"Close","complianceBannerNowOnlyRecording":"You are now only recording this meeting.","complianceBannerNowOnlyTranscription":"You are now only transcribing this meeting.","complianceBannerRecordingAndTranscriptionSaved":"Recording and transcription are being saved.","complianceBannerRecordingAndTranscriptionStarted":"Recording and transcription have started.","complianceBannerRecordingAndTranscriptionStopped":"Recording and transcription have stopped.","complianceBannerRecordingSaving":"Recording is being saved.","complianceBannerRecordingStarted":"Recording has started.","complianceBannerRecordingStopped":"Recording has stopped.","complianceBannerTranscriptionStarted":"Transcription has started.","complianceBannerTranscriptionConsent":"By joining, you are giving consent for this meeting to be transcribed.","complianceBannerTranscriptionSaving":"Transcription is being saved.","complianceBannerTranscriptionStopped":"Transcription has stopped.","configurationPageTitle":"Start a call","copyInviteLinkButtonLabel":"Copy invite link","copyInviteLinkButtonActionedLabel":"Link copied","copyInviteLinkActionedAriaLabel":"Invite link copied","defaultPlaceHolder":"Select an option","dismissSidePaneButtonLabel":"Close","videoEffectsPaneTitle":"Effects","videoEffectsPaneBackgroundSelectionTitle":"Background","videoEffectsPaneAriaLabel":"Video effects pane","configurationPageCameraIsLoadingLabel":"Video is loading...","configurationPageVideoEffectsButtonLabel":"Effects","unableToStartVideoEffect":"Unable to apply video effect.","blurBackgroundEffectButtonLabel":"Blur","blurBackgroundTooltip":"Blur Background","removeBackgroundEffectButtonLabel":"None","removeBackgroundTooltip":"Remove Background","cameraOffBackgroundEffectWarningText":"Your camera is off. Turn on camera to see video effect.","failedToJoinCallDueToNoNetworkMoreDetails":"Call was disconnected due to a network issue. Check your connection and join again.","failedToJoinCallDueToNoNetworkTitle":"Call disconnected","failedToJoinTeamsMeetingReasonAccessDeniedMoreDetails":"You were not granted entry in the call. If this was a mistake, re-join the call.","failedToJoinTeamsMeetingReasonAccessDeniedTitle":"Dismissed from lobby","learnMore":"Learn more","leavingCallTitle":"Leaving...","leftCallMoreDetails":"If this was a mistake, re-join the call.","leftCallTitle":"You left the call","lobbyScreenConnectingToCallTitle":"Joining call","lobbyScreenWaitingToBeAdmittedTitle":"Waiting to be admitted","microphonePermissionDenied":"Your browser is blocking access to your microphone","microphoneToggleInLobbyNotAllowed":"Cannot mute or unmute while in lobby.","mutedMessage":"You're muted","networkReconnectMoreDetails":"Looks like something went wrong. We're trying to get back into the call.","networkReconnectTitle":"Hold on","notInvitedToRoomDetails":"You are not able to join this room because you do not have an invite.","notInvitedToRoomTitle":"Not invited to room","peopleButtonLabel":"People","selectedPeopleButtonLabel":"People Button Selected","peoplePaneTitle":"People","peoplePaneMoreButtonAriaLabel":"More","peopleButtonTooltipOpen":"Show participants","peopleButtonTooltipClose":"Hide participants","peoplePaneSubTitle":"In this call {numberOfPeople}","privacyPolicy":"Privacy policy","rejoinCallButtonLabel":"Re-join call","removedFromCallMoreDetails":"Another participant removed you from the call.","removedFromCallTitle":"You were removed","removeMenuLabel":"Remove","startSpotlightMenuLabel":"Spotlight for everyone","addSpotlightMenuLabel":"Add spotlight","stopSpotlightMenuLabel":"Stop spotlighting","stopSpotlightOnSelfMenuLabel":"Exit spotlight","spotlightLimitReachedMenuTitle":"Spotlight limit reached","stopAllSpotlightMenuLabel":"Stop all spotlights","returnToCallButtonAriaDescription":"Return to Call","returnToCallButtonAriaLabel":"Back","roomNotFoundDetails":"The room ID provided could not be found.","roomNotFoundTitle":"Room not found","roomNotValidDetails":"This room is not valid at this current time.","roomNotValidTitle":"Room not valid","inviteToRoomRemovedDetails":"Your invite to join this room was removed.","inviteToRoomRemovedTitle":"Invite to room removed","soundLabel":"Sound","noMicrophonesLabel":"No microphones found","noSpeakersLabel":"No speakers found","startCallButtonLabel":"Start call","openDialpadButtonLabel":"Dial phone number","peoplePaneAddPeopleButtonLabel":"Add People","dialpadStartCallButtonLabel":"Call","dialpadModalTitle":"Dial Phone Number","dialpadModalAriaLabel":"Dialpad","dialpadCloseModalButtonAriaLabel":"Close dialpad","moreButtonCallingLabel":"More","resumeCallButtonLabel":"Resume","resumingCallButtonLabel":"Resuming...","resumeCallButtonAriaLabel":"Resume call","resumingCallButtonAriaLabel":"Resume call","holdScreenLabel":"You're on hold","openDtmfDialpadLabel":"Show dialpad","dtmfDialpadPlaceholderText":"Enter number","outboundCallingNoticeString":"Calling...","participantJoinedNoticeString":"{displayName} joined","twoParticipantJoinedNoticeString":"{displayName1} and {displayName2} have joined","threeParticipantJoinedNoticeString":"{displayName1}, {displayName2} and {displayName3} have joined","participantLeftNoticeString":"{displayName} left","twoParticipantLeftNoticeString":"{displayName1} and {displayName2} have left","threeParticipantLeftNoticeString":"{displayName1}, {displayName2} and {displayName3} have left","unnamedParticipantString":"unnamed participant","manyUnnamedParticipantsJoined":"unnamed participant and {numOfParticipants} other participants joined","manyUnnamedParticipantsLeft":"unnamed participant and {numOfParticipants} other participants left","manyParticipantsJoined":"{displayName1}, {displayName2}, {displayName3} and {numOfParticipants} other participants joined","manyParticipantsLeft":"{displayName1}, {displayName2}, {displayName3} and {numOfParticipants} other participants left","liveCaptionsLabel":"Live captions","captionsSettingsLabel":"Caption settings","startCaptionsButtonOnLabel":"Turn on captions","startCaptionsButtonOffLabel":"Turn off captions","startCaptionsButtonTooltipOnContent":"Turn off captions","startCaptionsButtonTooltipOffContent":"Turn on captions","captionsSettingsModalTitle":"Captions Settings","captionsSettingsSpokenLanguageDropdownLabel":"Spoken language","captionsSettingsCaptionLanguageDropdownLabel":"Captions language","captionsSettingsSpokenLanguageDropdownInfoText":"Language that everyone on this call is speaking.","captionsSettingsCaptionLanguageDropdownInfoText":"Captions will appear in this language.","captionsSettingsConfirmButtonLabel":"Confirm","captionsSettingsCancelButtonLabel":"Cancel","captionsSettingsModalAriaLabel":"Captions Setting Modal","captionsSettingsCloseModalButtonAriaLabel":"Close Captions Setting","captionsBannerMoreButtonCallingLabel":"Captions Settings More Options","captionsBannerMoreButtonTooltip":"More options","realTimeTextLabel":"Real-time text (RTT)","startRealTimeTextLabel":"Turn on RTT for this call","disabledStartRealTimeTextLabel":"RTT is currently turned on, it cannot be turned off","dismissModalAriaLabel":"Local and remote picture and picture, press enter to return to call","callRejectedTitle":"The call could not be completed","callRejectedMoreDetails":"The person you are trying to reach is unavailable. Please try again later.","callTimeoutTitle":"The call could not be completed","callTimeoutDetails":"The person you are trying to reach is unavailable. Please try again later.","callTimeoutBotTitle":"The call could not be completed","callTimeoutBotDetails":"The service that you are trying to reach is unavailable. Please try again later.","dtmfDialerButtonLabel":"Dialpad","dtmfDialerButtonTooltipOn":"Show dialpad","dtmfDialerButtonTooltipOff":"Hide dialpad","dtmfDialerMoreButtonLabelOn":"Show dialpad","dtmfDialerMoreButtonLabelOff":"Hide dialpad","phoneCallMoreButtonLabel":"Phone Call","spokenLanguageStrings":{"ar-ae":"Arabic - U.A.E.","ar-sa":"Arabic - Saudi Arabia","da-dk":"Danish","de-de":"German - Germany","en-au":"English - Australia","en-ca":"English - Canada","en-gb":"English - United Kingdom","en-in":"English - India","en-nz":"English - New Zealand","en-us":"English - United States","es-es":"Spanish - Spain (Modern Sort)","es-mx":"Spanish - Mexico","fi-fi":"Finnish","fr-ca":"French - Canada","fr-fr":"French - France","hi-in":"Hindi","it-it":"Italian - Italy","ja-jp":"Japanese","ko-kr":"Korean","nb-no":"Norwegian (Bokmål)","nl-be":"Dutch - Belgium","nl-nl":"Dutch - Netherlands","pl-pl":"Polish","pt-br":"Portuguese - Brazil","ru-ru":"Russian","sv-se":"Swedish","zh-cn":"Chinese - People's Republic of China","zh-hk":"Chinese - Hong Kong SAR","cs-cz":"Czech","pt-pt":"Portuguese - Portugal","tr-tr":"Turkish","vi-vn":"Vietnamese","th-th":"Thai","he-il":"Hebrew","cy-gb":"Welsh","uk-ua":"Ukrainian","el-gr":"Greek","hu-hu":"Hungarian","ro-ro":"Romanian","sk-sk":"Slovak","zh-tw":"Chinese - Taiwan"},"captionLanguageStrings":{"ar":"Arabic","da":"Danish","de":"German","en":"English","es":"Spanish","fi":"Finnish","fr-ca":"French - Canada","fr":"French - France","hi":"Hindi","it":"Italian","ja":"Japanese","ko":"Korean","nb":"Norwegian (Bokmål)","nl":"Dutch","pl":"Polish","pt":"Portuguese - Brazil","ru":"Russian","sv":"Swedish","zh-Hans":"Chinese (Simplified)","zh-Hant":"Chinese (Traditional)","cs":"Czech","pt-pt":"Portuguese - Portugal","tr":"Turkish","vi":"Vietnamese","th":"Thai","he":"Hebrew","cy":"Welsh","uk":"Ukrainian","el":"Greek","hu":"Hungarian","ro":"Romanian","sk":"Slovak"},"captionsBannerSpinnerText":"Starting captions...","realTimeTextInputBoxDefaultText":"Type message in real-time","realTimeTextInputErrorMessage":"Message can not exceed 2000 characters","realTimeTextBannerTitle":"RTT","realTimeTextBannerContent":"RTT (real-time text) is enabled for all participants for the entire duration of the meeting.","realTimeTextBannerLinkLabel":"Learn more","realTimeTextModalAriaLabel":"Turn on RTT Modal","realTimeTextModalTitle":"Turn on RTT?","realTimeTextModalText":"Real-time text (RTT) will be turned on for everyone in the meeting.","realTimeTextConfirmButtonLabel":"Turn on","realTimeTextCancelButtonLabel":"Cancel","realTimeTextCloseModalButtonAriaLabel":"Close RTT Modal","captionsOnlyContainerTitle":"Captions","realTimeTextOnlyContainerTitle":"Real-Time Text","captionsAndRealTimeTextContainerTitle":"Captions and Real-Time Text","expandButtonAriaLabel":"Expand","minimizeButtonAriaLabel":"Collapse","transferPageTransferorText":"Transferring...","transferPageTransferTargetText":"Connecting...","transferPageUnknownTransferorDisplayName":"Unknown","transferPageUnknownTransferTargetDisplayName":"Unknown","transferPageNoticeString":"You are being transferred","participantCouldNotBeReachedTitle":"Target participant is currently not available","participantCouldNotBeReachedMoreDetails":"Please contact participant when they are available","permissionToReachTargetParticipantNotAllowedTitle":"Permission to reach target participant is not allowed","permissionToReachTargetParticipantNotAllowedMoreDetails":"Please check that the target participant is in the same tenant","unableToResolveTenantTitle":"Unable to resolve tenant id for the target participant","unableToResolveTenantMoreDetails":"Please check the participant id is entered correctly","participantIdIsMalformedTitle":"Participant id is not in the correct format","participantIdIsMalformedMoreDetails":"Please check that the participant id is in the correct format","moreButtonGalleryControlLabel":"View","moreButtonGalleryPositionToggleLabel":"Move gallery to top","moreButtonGallerySpeakerLayoutLabel":"Speaker","moreButtonGalleryFloatingLocalLayoutLabel":"Dynamic","moreButtonGalleryDefaultLayoutLabel":"Gallery view","moreButtonGalleryFocusedContentLayoutLabel":"Focus on content","moreButtonLargeGalleryDefaultLayoutLabel":"Large Gallery","moreButtonTogetherModeLayoutLabel":"Together mode","capabilityChangedNotification":{"turnVideoOn":{"lostDueToMeetingOption":"Your camera has been disabled. You can no longer share video.","grantedDueToMeetingOption":"Your camera has been enabled. Turn it on if you'd like to share video."},"unmuteMic":{"lostDueToMeetingOption":"Your mic has been disabled. You can no longer unmute.","grantedDueToMeetingOption":"Your mic has been enabled. Unmute if you'd like to speak."},"shareScreen":{"lostDueToRoleChangeToAttendee":"Your role has been changed. Some actions, like sharing content, won't be available to you.","grantedDueToRoleChangeToPresenter":"You're a presenter. You can share content and facilitate the meeting."},"hideAttendeeNames":{"hideAttendeeNameAttendee":"Your name is hidden from other attendees. Organizers and presenters can see your real name.","hideAttendeeNamePresenter":"Attendee names are hidden. Only organizers and presenters can see names to protect attendee privacy."}},"surveyTitle":"Help us improve","starSurveyHelperText":"How was the quality of the call?","starSurveyOneStarText":"The quality was bad.","starSurveyTwoStarText":"The quality was poor.","starSurveyThreeStarText":"The quality was good.","starSurveyFourStarText":"The quality was great.","starSurveyFiveStarText":"The quality was excellent.","surveyConfirmButtonLabel":"Send Feedback","starRatingAriaLabel":"Select {0} of {1} stars","surveySkipButtonLabel":"Skip","tagsSurveyQuestion":"What could have been better?","tagsSurveyTextFieldDefaultText":"Other, please specify","tagsSurveyHelperText":"Check any issues you experienced","endOfSurveyText":"Thank you for your feedback!","surveyIssues":{"overallRating":{"callCannotJoin":"I could not join call","callCannotInvite":"I could not invite others into the call","hadToRejoin":"I had to rejoin the call","callEndedUnexpectedly":"Call ended for me unexpectedly","otherIssues":"I was having other issues with the call"},"audioRating":{"noLocalAudio":"The other side could not hear any sound","noRemoteAudio":"I could not hear any sound","echo":"I heard echos on the call","audioNoise":"I heard noise on the call","lowVolume":"Volume was low","audioStoppedUnexpectedly":"Audio stopped unexpectedly","distortedSpeech":"Audio was distorted","audioInterruption":"Audio was interrupted","otherIssues":"I was having other audio issues in this call"},"videoRating":{"noVideoReceived":"I could not see any video","noVideoSent":"Others could not see me","lowQuality":"Video quality was low","freezes":"Video frozen","stoppedUnexpectedly":"Video stopped unexpectedly","darkVideoReceived":"I can only see dark screens when others turn on their camera","audioVideoOutOfSync":"Audio and Video was out of sync","otherIssues":"I was having other video issues in this call"},"screenshareRating":{"noContentLocal":"Other people could not see my screenshare","noContentRemote":"I could not see other people's screenshare","cannotPresent":"I could not present my screen","lowQuality":"Screen share quality was low","freezes":"Screen share frozen","stoppedUnexpectedly":"Screen share stopped unexpectedly","largeDelay":"Screen share has a large delay","otherIssues":"I was having other screen share issues in this call"}},"surveyIssuesHeadingStrings":{"overallRating":"Overall","audioRating":"Audio","videoRating":"Video","screenshareRating":"Presenting"},"spotlightPrompt":{"startSpotlightHeading":"Spotlight for everyone?","startSpotlightText":"You'll highlight this video for everyone in the meeting.","startSpotlightOnSelfText":"You'll highlight your video for everyone in the meeting.","startSpotlightConfirmButtonLabel":"Spotlight for everyone","startSpotlightCancelButtonLabel":"Cancel","stopSpotlightHeading":"Stop spotlighting this video?","stopSpotlightOnSelfHeading":"Exit spotlight?","stopAllSpotlightHeading":"Stop spotlighting all videos?","stopSpotlightText":"This video will no longer be highlighted for everyone in the meeting.","stopSpotlightOnSelfText":"Your video will no longer be highlighted for everyone in the meeting.","stopAllSpotlightText":"The videos will no longer be highlighted for everyone in the meeting.","stopSpotlightConfirmButtonLabel":"Stop spotlighting","stopSpotlightOnSelfConfirmButtonLabel":"Exit spotlight","stopSpotlightCancelButtonLabel":"Cancel","closeSpotlightPromptButtonLabel":"Close"},"exitSpotlightButtonLabel":"Exit spotlight","exitSpotlightButtonTooltip":"Exit spotlight","leaveConfirmButtonLabel":"Leave","endCallConfirmButtonLabel":"End call","hangUpCancelButtonLabel":"Cancel","leaveConfirmDialogTitle":"Leave the call?","leaveConfirmDialogContent":"Are you sure you want to leave the call?","endCallConfirmDialogTitle":"End the call?","endCallConfirmDialogContent":"You'll end the call for everyone.","invalidMeetingIdentifier":"Invalid meeting ID or passcode","pinParticipantMenuLabel":"Pin for me","pinParticipantLimitReachedMenuLabel":"Pin (limit reached)","unpinParticipantMenuLabel":"Unpin","pinParticipantMenuItemAriaLabel":"Pin for me","unpinParticipantMenuItemAriaLabel":"Unpin","muteAllMenuLabel":"Mute all","muteAllDialogTitle":"Mute everyone?","muteAllDialogContent":"This will mute everyone in the meeting but you.","muteAllConfirmButtonLabel":"Mute all","muteAllCancelButtonLabel":"Cancel","joinBreakoutRoomButtonLabel":"Join breakout room","returnFromBreakoutRoomButtonLabel":"Leave room","leaveBreakoutRoomAndMeetingButtonLabel":"Leave meeting","breakoutRoomJoinedNotificationTitle":"You've joined Breakout room '{roomName}'","joinBreakoutRoomBannerTitle":"Breakout room '{roomName}' is open","joinBreakoutRoomBannerButtonLabel":"Join","returnFromBreakoutRoomBannerTitle":"Return to main meeting","returnFromBreakoutRoomBannerButtonLabel":"Rejoin","forbidAudioMenuLabel":"Disable mic","permitAudioMenuLabel":"Allow mic","forbidOthersAudioDialogTitle":"Disable mic for attendees?","forbidOthersAudioDialogContent":"Attendees won’t be able to unmute themselves. The organizer and presenters can let people unmute as needed.","forbidOthersAudioConfirmButtonLabel":"Disable mics","forbidOthersAudioCancelButtonLabel":"Cancel","permitOthersAudioDialogTitle":"Allow mic for attendees?","permitOthersAudioDialogContent":"Everyone in the meeting will be able to unmute themselves.","permitOthersAudioConfirmButtonLabel":"Allow mics","permitOthersAudioCancelButtonLabel":"Cancel","forbidOthersAudioMenuLabel":"Disable mic for attendees","permitOthersAudioMenuLabel":"Allow mic for attendees","forbidVideoMenuLabel":"Disable camera","permitVideoMenuLabel":"Allow camera","forbidOthersVideoDialogTitle":"Disable camera for attendees?","forbidOthersVideoDialogContent":"Attendees won’t be able to turn on video themselves. The organizer and presenters can let people turn on camera as needed.","forbidOthersVideoConfirmButtonLabel":"Disable cameras","forbidOthersVideoCancelButtonLabel":"Cancel","permitOthersVideoDialogTitle":"Allow camera for attendees?","permitOthersVideoDialogContent":"Everyone in the meeting will be able to turn on video themselves.","permitOthersVideoConfirmButtonLabel":"Allow cameras","permitOthersVideoCancelButtonLabel":"Cancel","forbidOthersVideoMenuLabel":"Disable camera for attendees","permitOthersVideoMenuLabel":"Allow camera for attendees"}`),chat:{chatListHeader:"In this chat",uploadAttachment:"Upload Attachment",uploadImageDataNotProvided:"Image data is not provided.",uploadImageIsTooLarge:"Image is too large. Choose one that's less than {maxImageSize} MB.",uploadImageExtensionIsNotAllowed:"Uploading .{imageExtension} image is not allowed.",uploadImageFailed:"Unable to upload image. Please try again later."},callWithChat:{chatButtonLabel:"Chat",chatButtonNewMessageNotificationLabel:"New Message",chatButtonTooltipClosedWithMessageCount:"Show chat ({unreadMessagesCount} unread)",chatButtonTooltipClose:"Hide chat",chatButtonTooltipOpen:"Show chat",chatPaneTitle:"Chat",copyInviteLinkButtonLabel:"Copy invite link",copyInviteLinkButtonActionedLabel:"Link copied",copyInviteLinkActionedAriaLabel:"Invite link copied",dismissSidePaneButtonLabel:"Close",moreDrawerAudioDeviceMenuTitle:"Audio Device",moreDrawerButtonLabel:"More options",moreDrawerButtonTooltip:"More options",moreDrawerMicrophoneMenuTitle:"Microphone",moreDrawerSpeakerMenuTitle:"Speaker",moreDrawerCaptionsMenuTitle:"Live captions",moreDrawerSpokenLanguageMenuTitle:"Spoken language",moreDrawerCaptionLanguageMenuTitle:"Caption language",moreDrawerGalleryOptionsMenuTitle:"Gallery options",peopleButtonLabel:"People",selectedPeopleButtonLabel:"People Button Selected",peopleButtonTooltipOpen:"Show participants",peopleButtonTooltipClose:"Hide participants",peopleButtonTooltipOpenAriaLabel:"People button, Show participants",peopleButtonTooltipCloseAriaLabel:"People button, Hide participants",peoplePaneSubTitle:"In this call",peoplePaneTitle:"People",pictureInPictureTileAriaLabel:"Video Feeds. Click to return to call screen.",removeMenuLabel:"Remove",openDialpadButtonLabel:"Dial phone number",returnToCallButtonAriaDescription:"Return to Call",returnToCallButtonAriaLabel:"Back",peoplePaneAddPeopleButtonLabel:"Add People",dialpadStartCallButtonLabel:"Call",dialpadModalTitle:"Dial Phone Number",dialpadModalAriaLabel:"Dialpad",dialpadCloseModalButtonAriaLabel:"Close dialpad",openDtmfDialpadLabel:"Show dialpad",dtmfDialpadPlaceholderText:"Enter number",breakoutRoomChatPaneTitle:"Breakout Room Chat",chatContentSpinnerLabel:"Loading chat"}},sje={component:A4e,strings:oje},lje=$.createContext(sje),Ati=t=>{const{locale:e,children:i}=t;return U.createElement(lje.Provider,{value:e},U.createElement(L6t,{locale:e.component},i))},ks=()=>$.useContext(lje),cje=()=>U.createElement(gx,{size:bE.large}),Iti={ChevronLeft:void 0,Link:void 0,LobbyScreenConnectingToCall:U.createElement(cje,null),LobbyScreenWaitingToBeAdmitted:U.createElement(cje,null),LocalDeviceSettingsCamera:U.createElement(zH,null),LocalDeviceSettingsMic:U.createElement(lK,null),LocalDeviceSettingsSpeaker:U.createElement(lRe,null),LocalPreviewPlaceholder:U.createElement(Dse,null),LocalCameraSwitch:U.createElement(ySt,null),ControlBarChatButtonActive:U.createElement(SSt,null),ControlBarChatButtonInactive:U.createElement(bSt,null),ControlButtonCameraProhibited:U.createElement(uRe,null),ControlButtonMicProhibited:U.createElement(rRe,null),ControlButtonExitSpotlight:U.createElement(Ose,null),ControlBarPeopleButton:U.createElement(Mse,null),MoreDrawerMicrophones:U.createElement(kse,null),MoreDrawerPeople:U.createElement(Mse,null),MoreDrawerSpeakers:U.createElement(Pse,null),MoreDrawerSelectedMicrophone:U.createElement(lK,null),MoreDrawerSelectedSpeaker:U.createElement(lRe,null),Muted:U.createElement(Rse,null),NetworkReconnectIcon:U.createElement(mSt,null),NoticePageAccessDeniedTeamsMeeting:U.createElement(JSt,null),NoticePageJoinCallFailedDueToNoNetwork:U.createElement(hRe,null),NoticePageLeftCall:U.createElement(Ase,null),NoticePageRemovedFromCall:U.createElement(kx,null),NoticePageNotInvitedToRoom:U.createElement(kx,null),NoticePageRoomNotFound:U.createElement(kx,null),NoticePageRoomNotValid:U.createElement(kx,null),NoticePageCallRejected:U.createElement(kx,null),NoticePageCallTimeout:U.createElement(kx,null),PeoplePaneAddPerson:U.createElement(KSt,null),PeoplePaneOpenDialpad:U.createElement(Ise,null),DialpadStartCall:U.createElement(gSt,null),NoticePageInviteToRoomRemoved:U.createElement(kx,null),BlurVideoBackground:U.createElement(dRe,null),RemoveVideoBackgroundEffect:U.createElement(Cbt,null),GalleryOptions:U.createElement($St,null),OverflowGalleryTop:U.createElement(Abt,null),SpeakerGalleryLayout:U.createElement(QSt,null),DefaultGalleryLayout:U.createElement(ybt,null),FloatingLocalVideoGalleryLayout:U.createElement(hSt,null),FocusedContentGalleryLayout:U.createElement(PSt,null),LargeGalleryLayout:U.createElement(vbt,null),DefaultCustomButton:U.createElement(ASt,null),DtmfDialpadButton:U.createElement(Ise,null),PhoneNumberButton:U.createElement(oRe,null),JoinByPhoneDialStepIcon:U.createElement(oRe,null),JoinByPhoneConferenceIdIcon:U.createElement(Ise,null),JoinByPhoneWaitToBeAdmittedIcon:U.createElement(wSt,null),PeoplePaneMoreButton:U.createElement(dK,null),StopAllSpotlightMenuButton:U.createElement(Ose,null)},wti=Object.assign(Object.assign({},f8t),Iti),YE=t=>U.createElement(_M,Object.assign({},t)),gF=t=>U.createElement(_M,Object.assign({},t)),kti={position:"fixed",zIndex:1e6,inset:"0px",visibility:"hidden"},Rti=t=>{const{audioContext:e,children:i}=t,[r,o]=$.useState(void 0);return $.useEffect(()=>{o(e)},[e]),uje()?U.createElement(U.Fragment,null,i):U.createElement(dje.Provider,{value:r},t.children)},dje=$.createContext(void 0),uje=()=>$.useContext(dje),hje=t=>{const{fluentTheme:e,rtl:i,locale:r}=t,o=yu("composite-global-hostId");if(Mti())return U.createElement(U.Fragment,null,t.children);const d={};Object.entries(wti).forEach(([f,y])=>{y&&(d[f]=y)}),qg({icons:Object.assign(Object.assign({},d),t.icons)});const h=new AudioContext,p=U.createElement(O4e,{fluentTheme:e,rtl:i},t.formFactor==="mobile"&&U.createElement("meta",{name:"viewport",content:"width=device-width"}),U.createElement(M_e,{scopedSettings:{Layer:{hostId:o}}},U.createElement(Rti,{audioContext:h},U.createElement(Pti,null,t.children))),U.createElement(tH,{id:o,className:It(kti)})),g=r?Ati({locale:r,children:p}):p;return U.createElement(pje.Provider,{value:!0},g)},pje=$.createContext(!1),Mti=()=>$.useContext(pje),Pti=t=>{const{children:e}=t,i=hc(),r=It({background:i.semanticColors.bodyBackground,height:"100%",width:"100%",position:"relative"});return U.createElement(Et,{className:r},e)},gje=$.createContext(void 0),Dti=t=>{const{adapter:e}=t;return U.createElement(gje.Provider,{value:e},t.children)},hfe=()=>{const t=$.useContext(gje);if(!t)throw"Cannot find adapter please initialize before usage.";return t},mje=41.25,Lti=13,Oti=1,Nti=It({height:"100%",width:"100%",minHeight:`${Lti}rem`,minWidth:`${aje}rem`}),xti=It({height:"100%",width:"100%",overflow:"hidden"}),Bti=It({height:"100%",width:"100%",overflow:"auto",position:"relative"}),Fti=It({height:"100%",width:"100%",overflow:"visible",zIndex:Oti}),Uti=It({width:"100%",paddingLeft:"1.5rem",paddingRight:"1.5rem","@media screen and (max-width: 25rem)":{paddingLeft:"5%",paddingRight:"5%"},borderBottom:"0.063rem solid #DDDDDD"}),zti=It({fontSize:"1.1rem",lineHeight:"2.5rem",fontWeight:600,marginRight:"0.125rem",textOverflow:"ellipsis",overflowY:"hidden"}),Vti=ql(t=>({root:{maxWidth:`${mje}rem`},chatContainer:{background:t}})),$ti={padding:"0rem 0.25rem"},Hti={maxWidth:`${mje}rem`,width:"100%",alignSelf:"center"};var jti=function(t,e,i,r){function o(l){return l instanceof i?l:new i(function(d){d(l)})}return new(i||(i=Promise))(function(l,d){function h(f){try{g(r.next(f))}catch(y){d(y)}}function p(f){try{g(r.throw(f))}catch(y){d(y)}}function g(f){f.done?l(f.value):o(f.value).then(h,p)}g((r=r.apply(t,e||[])).next())})};const U4=t=>{var e,i,r,o,l,d,h,p;const{userId:g,dataProvider:f,text:y,imageUrl:T,imageInitials:C,initialsColor:E,initialsTextColor:I,showOverflowTooltip:w}=t,[D,F]=$.useState();$.useEffect(()=>{jti(void 0,void 0,void 0,function*(){if(f&&g){const B=yield f(g);Gti(D,B)&&F(B)}})},[D,f,g]);let x="";return t.allowActiveBorder&&(x=It({border:"solid 2px",borderColor:"transparent",borderRadius:"50%",padding:"2px",boxSizing:"content-box",margin:"-4px"}),It(x,t.styles)),U.createElement(ux,Object.assign({},t,{className:x,text:(e=D?.text)!==null&&e!==void 0?e:y,imageUrl:(i=D?.imageUrl)!==null&&i!==void 0?i:T,imageInitials:(r=D?.imageInitials)!==null&&r!==void 0?r:C,initialsColor:(o=D?.initialsColor)!==null&&o!==void 0?o:E,initialsTextColor:(d=(l=D?.initialsTextColor)!==null&&l!==void 0?l:I)!==null&&d!==void 0?d:"white",showOverflowTooltip:w??!1,showUnknownPersonaCoin:(p=(h=D?.showUnknownPersonaCoin)!==null&&h!==void 0?h:t.showUnknownPersonaCoin)!==null&&p!==void 0?p:!1}))},Gti=(t,e)=>t?.text!==e?.text||t?.imageUrl!==e?.imageUrl||t?.initialsColor!==e?.initialsColor||t?.imageInitials!==e?.imageInitials||t?.initialsTextColor!==e?.initialsTextColor,qti=t=>U.createElement(Et,{className:Uti,horizontal:!0},U.createElement(Et.Item,{align:"center"},U.createElement("div",{className:zti},t.topic))),Wti=Xs([(t,e)=>{var i,r;return((r=(i=t.threads[e.threadId])===null||i===void 0?void 0:i.properties)===null||r===void 0?void 0:r.topic)||""}],t=>({topic:t})),fje=(t,e)=>vje(t,Yti,e),vje=(t,e,i)=>{const r=hfe(),o=$.useRef(!1);$.useEffect(()=>(o.current=!0,()=>{o.current=!1}));const l=r.getState().thread.threadId,d=$.useMemo(()=>({threadId:l}),[l]),[h,p]=$.useState(t(e(r.getState()),d)),g=$.useRef(h);return g.current=h,$.useEffect(()=>{const f=y=>{if(!o.current)return;const T=t(e(y),d);g.current!==T&&p(T)};return r.onStateChange(f),()=>{r.offStateChange(f)}},[e,r,t,i,d]),h},Kti=ob((t,e,i,r)=>({userId:t,displayName:e,threads:i,latestErrors:r})),Jti=ob(t=>({[t.threadId]:t})),Yti=t=>Kti(t.userId,t.displayName,Jti(t.thread),t.latestErrors),Qti=t=>Zti(hfe()),Zti=ob(t=>({onSendMessage:(e,i)=>t.sendMessage(e,i),onLoadPreviousChatMessages:t.loadPreviousChatMessages,onMessageSeen:t.sendReadReceipt,onTyping:t.sendTypingIndicator,onRemoveParticipant:t.removeParticipant,updateThreadTopicName:t.setTopic,onUpdateMessage:function(e,i){return t.updateMessage(e,i)},onDeleteMessage:t.deleteMessage})),bX=t=>{const e=IZt(t);if(!e)throw new Error("Can't find the selector for component, please check supported component list");return Object.assign(Object.assign({},fje(e)),Qti())};Object.assign(Object.assign({},{root:{height:"100%",padding:"0.5rem 0.25rem",width:"21.5rem"}}),{display:"none"});const Xti={root:{lineHeight:"1.5rem",fontSize:"1.125rem",padding:"0.75rem 0.75rem 0.75rem 0.25rem",fontWeight:"600"}},eii={root:{margin:"0 0.25rem"}},tii={root:{flexDirection:"column",display:"flex"}},iii={root:{flexBasis:"0",flexGrow:"1",overflowY:"auto"}},yje={root:{flexGrow:"1",flexBasis:"0",maxWidth:"100%",position:"relative"}},Sje={root:{position:"absolute",height:"100%",width:"100%"}},bje={childrenGap:"0.5rem"},nii={childrenGap:"0.5rem"},aii=It({height:"100%"}),rii=It({height:"100%",overflowY:"auto",overflowX:"hidden"}),oii={root:{padding:"0rem"},participantItemStyles:{root:{padding:"0.5rem"}}},sii={root:{padding:"0rem"},participantItemStyles:{root:{padding:"0.5rem 1rem"}}},lii={padding:"0.5rem",textOverflow:"ellipsis",overflow:"hidden",whiteSpace:"nowrap"},cii=t=>({root:{height:"100%",minWidth:"1.5rem",padding:"0.5rem 0.25rem",marginRight:"0.25rem",border:"none",background:"none"},rootHovered:{background:"none"},rootPressed:{background:"none"},rootFocused:{background:"none"},icon:{color:t.palette.neutralSecondary,display:"flex",alignItems:"center"}}),dii=t=>$.useMemo(()=>U.createElement(uii,Object.assign({},t)),[t]),uii=t=>{const e=bX(Fge);return U.createElement(Fge,Object.assign({},e,t))},pfe=(t,e)=>vje(t,i=>i,e),hii=t=>t.userId,pii=t=>t.thread.threadId,gii=t=>t.thread.chatMessages;var gfe=function(t,e,i,r){function o(l){return l instanceof i?l:new i(function(d){d(l)})}return new(i||(i=Promise))(function(l,d){function h(f){try{g(r.next(f))}catch(y){d(y)}}function p(f){try{g(r.throw(f))}catch(y){d(y)}}function g(f){f.done?l(f.value):o(f.value).then(h,p)}g((r=r.apply(t,e||[])).next())})};const mii=t=>{const{onFetchAvatarPersonaData:e,onRenderMessage:i,onRenderTypingIndicator:r,options:o,styles:l,formFactor:d}=t,h=5,[p,g]=$.useState(),[f,y]=$.useState(!1),T=hfe(),C=Cs();$.useEffect(()=>{gfe(void 0,void 0,void 0,function*(){yield T.fetchInitialData(),yield T.loadPreviousChatMessages(h)})},[T]);const E=bX(gme),I=bX(Nge),w=fje(Wti),D=bX(jA),F=U.useRef(p);F.current=p;const x=pfe(gii);$.useEffect(()=>{var te;if(F.current===void 0)return;const Se=x[F.current.messageId];if(Se===void 0)return;const ce=(te=Se.resourceCache)===null||te===void 0?void 0:te[F.current.imageUrl];if(F.current.imageSrc===""&&ce){const X=B(ce);if(X===void 0||X===""||F.current.imageSrc===X)return;g(Object.assign(Object.assign({},F.current),{imageSrc:X}))}},[x]);const B=te=>{let Se="";return te.error||!te.sourceUrl?Se="blob://":Se=te.sourceUrl,Se},L=$.useCallback((te,Se)=>U.createElement(U4,Object.assign({userId:te,hidePersonaDetails:!0},Se,{dataProvider:e})),[e]),z=$.useMemo(()=>Object.assign({},Vti(C.semanticColors.bodyBackground),l?.messageThread),[l?.messageThread,C.semanticColors.bodyBackground]),H=$.useMemo(()=>Object.assign({},l?.typingIndicator),[l?.typingIndicator]),j=$.useMemo(()=>Object.assign({},l?.sendBox),[l?.sendBox]),J=pfe(hii),Z=Ga(J),re=pfe(pii),ne=$.useCallback((te,Se)=>{var ce,X,ve;const Te=x[Se],Be=(X=(ce=Te?.content)===null||ce===void 0?void 0:ce.attachments)===null||X===void 0?void 0:X.filter(vt=>vt.attachmentType==="image"&&vt.id===te),qe=Be?.[0];if(!qe)return;let Ge="";if(qe.url){const vt=(ve=Te?.resourceCache)===null||ve===void 0?void 0:ve[qe.url];vt?Ge=B(vt):T.downloadResourceToCache({threadId:re,messageId:Se,resourceUrl:qe.url})}const tt={text:Te?.senderDisplayName,size:Io.size32,showOverflowTooltip:!1,imageAlt:Te?.senderDisplayName},ct=Te?.sender!==void 0?Ga(Te.sender):Z,Mt=L&&L(ct,tt),ht={title:Te?.senderDisplayName||"",titleIcon:Mt,attachmentId:qe.id,imageSrc:Ge,messageId:Se,imageUrl:qe.url||""};y(!0),g(ht)},[T,x,L,Z,re]),le=$.useCallback((te,Se)=>{var ce,X,ve;const Te=x[te.messageId],Be=(X=(ce=Te?.content)===null||ce===void 0?void 0:ce.attachments)===null||X===void 0?void 0:X.find(tt=>tt.id===te.imageAttributes.id);if(Be===void 0)return Se(te);let qe=te.imageAttributes.src===""?"none":"auto";const Ge=Te?.resourceCache;return Ge&&Be.previewUrl&&Ge[Be.previewUrl]&&(!((ve=Ge[Be.previewUrl])===null||ve===void 0)&&ve.error)&&(qe="none"),U.createElement("span",{key:te.imageAttributes.id,onClick:()=>ne(te.imageAttributes.id||"",te.messageId),tabIndex:0,role:"button",onKeyDown:tt=>{tt.key==="Enter"&&ne(te.imageAttributes.id||"",te.messageId)},style:{cursor:"pointer",pointerEvents:qe}},Se(te))},[x,ne]),he=$.useMemo(()=>({onRenderInlineImage:le}),[le]),Me=$.useCallback(te=>{if(te!=="")if(Wq())window.open(te,"_blank");else{const Se=document.createElement("a");Se.href=te,Se.download=p?.attachmentId||"",Se.rel="noopener noreferrer",Se.target="_blank",document.body.appendChild(Se),Se.click(),document.body.removeChild(Se)}},[p?.attachmentId]),Le=$.useCallback(function(te){return gfe(this,void 0,void 0,function*(){yield T.sendMessage(te,{})})},[T]),pe=$.useCallback(function(te,Se){return gfe(this,void 0,void 0,function*(){yield E.onUpdateMessage(te,Se)})},[E]);return U.createElement(Et,{className:xti,grow:!0},o?.topic!==!1&&U.createElement(qti,Object.assign({},w)),U.createElement(Et,{className:Bti,tokens:nii,horizontal:!0,grow:!0},U.createElement(Et,{className:Fti,grow:!0},o?.errorBar!==!1&&U.createElement(jA,Object.assign({},D)),U.createElement(gme,Object.assign({},E,{onUpdateMessage:pe,onRenderAvatar:L,onRenderMessage:i,inlineImageOptions:he,numberOfChatMessagesToReload:h,styles:z})),U.createElement(Et,{className:It(Hti)},U.createElement("div",{className:It($ti)},r?r(I.typingUsers):U.createElement(Nge,Object.assign({},I,{styles:H}))),U.createElement(Et,{horizontal:d==="mobile"},d==="mobile",U.createElement(Et,{grow:!0},U.createElement(dii,{styles:j,autoFocus:o?.autoFocus,onSendMessage:Le})),d!=="mobile")))),p&&U.createElement($8t,Object.assign({},p,{isOpen:f,onDismiss:()=>{g(void 0),y(!1),T.removeResourceFromCache({threadId:re,messageId:p.messageId,resourceUrl:p.imageUrl})},onDownloadButtonClicked:Me})))},fii=t=>{const{adapter:e,options:i,onFetchAvatarPersonaData:r,onRenderTypingIndicator:o,onRenderMessage:l,onFetchParticipantMenuItems:d}=t;return U.createElement("div",{className:Nti},U.createElement(hje,Object.assign({},t),U.createElement(Dti,{adapter:e},U.createElement(mii,{options:i,onFetchAvatarPersonaData:r,onRenderTypingIndicator:o,onRenderMessage:l,onFetchParticipantMenuItems:d}))))},Tje=$.createContext(void 0),mfe=t=>{const{adapter:e}=t;return U.createElement(Tje.Provider,{value:e},t.children)},QE=()=>{const t=$.useContext(Tje);if(!t)throw"Cannot find adapter please initialize before usage.";return t},Cje=(t,e)=>_je(t,Sii,e),_je=(t,e,i)=>{var r;const o=QE(),l=$.useRef(!1);$.useEffect(()=>(l.current=!0,()=>{l.current=!1}));const d=(r=o.getState().call)===null||r===void 0?void 0:r.id,h=$.useMemo(()=>({callId:d}),[d]),[p,g]=$.useState(t(e(o.getState()),h)),f=$.useRef(p);return f.current=p,$.useEffect(()=>{const y=T=>{if(!l.current)return;const C=t(e(T),h);f.current!==C&&g(C)};return o.onStateChange(y),()=>{o.offStateChange(y)}},[e,o,t,i,h]),p},vii=ob((t,e,i,r,o,l,d,h)=>({userId:t,incomingCalls:{},incomingCallsEnded:{},callsEnded:{},deviceManager:e,callAgent:{displayName:l},calls:i,latestErrors:r,latestNotifications:o??{},alternateCallerId:d,environmentInfo:h})),yii=ob(t=>t?{[t.id]:t}:{}),Sii=t=>vii(t.userId,t.devices,yii(t.call),t.latestErrors,t.latestNotifications,t.displayName,t.alternateCallerId,t.environmentInfo),ffe=(t,e)=>t.filter(r=>{const o=e[r.type];return!o||!o.lastDismissedAt||o.lastDismissedAt<o.mostRecentlyActive}),vfe=(t,e)=>{var i,r;const o={};for(const l of e){const d=t[l.type];o[l.type]={mostRecentlyActive:(r=(i=l.timestamp)!==null&&i!==void 0?i:d?.mostRecentlyActive)!==null&&r!==void 0?r:new Date(Date.now()),lastDismissedAt:d?.lastDismissedAt}}return o},yfe=(t,e)=>{const i=new Date(Date.now()),r=e[t];return Object.assign(Object.assign({},e),{[t]:Object.assign(Object.assign({},r||{}),{lastDismissedAt:i})})},bii=["accessDeniedTeamsMeeting","joinCallFailedDueToNoNetwork","leftCall","removedFromCall"],Tii=5854,Eje=56e4,Cii=[5e3,5300,Eje],_ii=603,Eii=5751,Aje=5732,Ije=5829,wje=5828,kje=5317,Aii=10004,Iii=487,wii=486,kii=10321,Sfe=t=>t.call?!!t.call.localVideoStreams.find(i=>i.mediaStreamType==="Video"):t.devices.selectedCamera?c8(t.devices):!1,TX=t=>{if(t===!1)return!1;const e=t===!0?{}:t||{};return e.displayType="compact",e.screenShareButton!==!0&&(e.screenShareButton=!1),e};var KA;(function(t){t[t.LEFT_CALL=0]="LEFT_CALL",t[t.ACCESS_DENIED=1]="ACCESS_DENIED",t[t.REMOVED_FROM_CALL=2]="REMOVED_FROM_CALL",t[t.BAD_REQUEST=3]="BAD_REQUEST"})(KA||(KA={}));const Rii=t=>{var e,i,r,o;const l=Array.from(Object.values(t.remoteParticipantsEnded));if(l[0]&&Vf(l[0].identifier)&&((e=t.callEndReason)===null||e===void 0?void 0:e.subCode)!==Eje)return KA.LEFT_CALL;if(!((i=t.callEndReason)===null||i===void 0)&&i.subCode&&t.callEndReason.subCode===Tii)return KA.ACCESS_DENIED;if(!((r=t.callEndReason)===null||r===void 0)&&r.subCode&&Cii.includes(t.callEndReason.subCode))return KA.REMOVED_FROM_CALL;if(((o=t.callEndReason)===null||o===void 0?void 0:o.code)===400)return KA.BAD_REQUEST;if(t.callEndReason)return KA.LEFT_CALL;throw new Error("No matching call end reason")},Rje=(t,e)=>{var i,r,o,l,d,h,p;let g=t.strings.call.leftCallTitle,f=t.strings.call.leftCallMoreDetails,y=!1,T="NoticePageLeftCall";switch((i=e?.callEndReason)===null||i===void 0?void 0:i.subCode){case Aje:t.strings.call.roomNotFoundTitle&&(g=t.strings.call.roomNotFoundTitle,f=t.strings.call.roomNotFoundDetails,y=!0,T="NoticePageRoomNotFound");break;case Ije:t.strings.call.roomNotValidTitle&&(g=t.strings.call.roomNotValidTitle,f=t.strings.call.roomNotValidDetails,y=!0,T="NoticePageRoomNotValid");break;case wje:t.strings.call.notInvitedToRoomTitle&&(g=t.strings.call.notInvitedToRoomTitle,f=t.strings.call.notInvitedToRoomDetails,y=!0,T="NoticePageNotInvitedToRoom");break;case kje:t.strings.call.inviteToRoomRemovedTitle&&(g=t.strings.call.inviteToRoomRemovedTitle,f=t.strings.call.inviteToRoomRemovedDetails,y=!0,T="NoticePageInviteToRoomRemoved");break;case Aii:((r=e?.callEndReason)===null||r===void 0?void 0:r.code)===Iii&&t.strings.call.callTimeoutTitle&&(g=t.strings.call.callTimeoutTitle,f=t.strings.call.callTimeoutDetails,y=!0,T="NoticePageCallTimeout");break;case kii:((o=e?.callEndReason)===null||o===void 0?void 0:o.code)===wii&&t.strings.call.callTimeoutBotTitle&&(g=t.strings.call.callTimeoutBotTitle,f=t.strings.call.callTimeoutBotDetails,y=!0,T="NoticePageCallTimeout");break}switch((l=e?.callEndReason)===null||l===void 0?void 0:l.code){case _ii:t.strings.call.callRejectedTitle&&(g=t.strings.call.callRejectedTitle,f=t.strings.call.callRejectedMoreDetails,y=!0,T="NoticePageCallRejected");break}switch((d=e?.callEndReason)===null||d===void 0?void 0:d.subCode){case 10037:t.strings.call.participantCouldNotBeReachedTitle&&(g=t.strings.call.participantCouldNotBeReachedTitle,f=t.strings.call.participantCouldNotBeReachedMoreDetails,y=!0);break;case 10124:t.strings.call.permissionToReachTargetParticipantNotAllowedTitle&&(g=t.strings.call.permissionToReachTargetParticipantNotAllowedTitle,f=t.strings.call.permissionToReachTargetParticipantNotAllowedMoreDetails,y=!0);break;case 10119:t.strings.call.unableToResolveTenantTitle&&(g=t.strings.call.unableToResolveTenantTitle,f=t.strings.call.unableToResolveTenantMoreDetails,y=!0);break;case 10044:t.strings.call.participantIdIsMalformedTitle&&(g=t.strings.call.participantIdIsMalformedTitle,f=t.strings.call.participantIdIsMalformedMoreDetails,y=!0);break}switch((h=e?.callEndReason)===null||h===void 0?void 0:h.subCode){case Eii:t.strings.call.callRejectedTitle&&(g=t.strings.call.callRejectedTitle,f=t.strings.call.invalidMeetingIdentifier,y=!0);break}switch((p=e?.callEndReason)===null||p===void 0?void 0:p.code){case 400:t.strings.call.callRejectedTitle&&(g=t.strings.call.callRejectedTitle,y=!0);break}return{title:g,moreDetails:f,disableStartCallButton:y,iconName:T}},Mii=(t,e,i,r,o)=>{if(i!==void 0)return"transferring";if(r)return"returningFromBreakoutRoom";if(t)return g4(t?.state)?"lobby":t?.state==="LocalHold"?"hold":t?.state==="Disconnecting"?"leaving":HA(t?.state)?"call":"configuration";if(e)switch(Rii(e)){case KA.ACCESS_DENIED:return"accessDeniedTeamsMeeting";case KA.REMOVED_FROM_CALL:return"removedFromCall";case KA.BAD_REQUEST:return"badRequest";case KA.LEFT_CALL:return e.diagnostics.network.latest.noNetwork?"joinCallFailedDueToNoNetwork":"leftCall"}return"configuration"},Mje=t=>bii.includes(t),Pje=(t,e)=>{var i;if(t===!1)return!1;let r=(i=t instanceof Object?Object.assign({},t):t)!==null&&i!==void 0?i:{};return r===!0||r===void 0?r=e.reduce((o,l)=>(o[l]={disabled:!0},o),{}):e.forEach(o=>{r[o]!==!1&&(r[o]={disabled:!0})}),r},tm=t=>t===void 0||typeof t=="boolean"?!1:t.disabled,CX=t=>t?.environment.browser.toLowerCase()==="safari",Pii=t=>{let e,i={};const r={};return o=>{var l,d,h,p;if(((l=o.call)===null||l===void 0?void 0:l.remoteParticipants)!==e){i={};const g=Object.entries(((d=o.call)===null||d===void 0?void 0:d.remoteParticipants)||{});for(const[f,y]of g){const T=t(f,y);if(T===void 0){i[f]=y;continue}((h=r[f])===null||h===void 0?void 0:h.originalRef)!==y&&(r[f]={newParticipant:T,originalRef:y});const C=r[f];if(!C)throw new Error("Participant modifier encountered an unhandled exception.");i[f]=C.newParticipant}e=(p=o.call)===null||p===void 0?void 0:p.remoteParticipants}return Object.assign(Object.assign({},o),{call:o.call?Object.assign(Object.assign({},o.call),{remoteParticipants:i}):void 0})}},Dii=(t,e)=>t?.effectName==="blur"?e.createBackgroundBlurEffect():t?.effectName==="replacement"?e.createBackgroundReplacementEffect({backgroundImageUrl:t.backgroundImageUrl}):void 0,bfe=t=>t.devices.selectedCamera||t.devices.cameras[0],Tfe=t=>!!Array.isArray(t),Lii=(t,e)=>t==="on"&&e==="on"?"recordingAndTranscriptionStarted":t==="on"&&e==="off"?"recordingStarted":t==="off"&&e==="on"?"transcriptionStarted":t==="on"&&e==="stopped"?"transcriptionStoppedStillRecording":t==="stopped"&&e==="on"?"recordingStoppedStillTranscribing":t==="off"&&e==="stopped"?"transcriptionStopped":t==="stopped"&&e==="off"?"recordingStopped":t==="stopped"&&e==="stopped"?"recordingAndTranscriptionStopped":"noState";function Dje(t,e){return e?"on":t==="on"?"stopped":t}const Oii=2e3;function Nii(t,e){const i=t.callRecordState!==e.current.latestBooleanState.callRecordState||t.callTranscribeState!==e.current.latestBooleanState.callTranscribeState;i&&(e.current={latestBooleanState:t,latestStringState:{callRecordState:Dje(e.current.latestStringState.callRecordState,t.callRecordState),callTranscribeState:Dje(e.current.latestStringState.callTranscribeState,t.callTranscribeState)},lastUpdated:Date.now()}),i&&e.current.latestStringState.callRecordState==="stopped"&&e.current.latestStringState.callTranscribeState==="stopped"&&Date.now()-e.current.lastUpdated>Oii&&(e.current.latestStringState.callRecordState="off",e.current.latestStringState.callTranscribeState="off");const r=Lii(e.current.latestStringState.callRecordState,e.current.latestStringState.callTranscribeState);if(r!=="noState")return{type:r,timestamp:new Date(Date.now())}}const qn=(t,e)=>_je(t,i=>i,e),xii=t=>t.displayName,Bii=t=>t.endedCall,G8=t=>{var e,i;return(i=(e=t.call)===null||e===void 0?void 0:e.state)!==null&&i!==void 0?i:"None"},q8=t=>t.devices,Fii=t=>{var e,i;return(i=(e=t.call)===null||e===void 0?void 0:e.isScreenSharingOn)!==null&&i!==void 0?i:!1},Uii=t=>{var e;return(e=t.call)===null||e===void 0?void 0:e.raiseHand.localParticipantRaisedHand},z4=t=>{var e,i;return(i=(e=t.call)===null||e===void 0?void 0:e.capabilitiesFeature)===null||i===void 0?void 0:i.capabilities},Lje=t=>t.devices.microphones,zii=t=>t.devices.cameras,XC=t=>{var e;return(e=t.call)===null||e===void 0?void 0:e.role},Oje=t=>t.page,Vii=t=>t.acceptedTransferCallState,Nje=t=>t.isLocalPreviewMicrophoneEnabled,xje=t=>{var e;return(e=t.call)===null||e===void 0?void 0:e.localVideoStreams},$ii=t=>{var e;return!!(!((e=t.call)===null||e===void 0)&&e.transcription.isTranscriptionActive)},Hii=t=>{var e;return!!(!((e=t.call)===null||e===void 0)&&e.recording.isRecordingActive)},Bje=t=>{var e;return(e=t.call)===null||e===void 0?void 0:e.diagnostics},jii=t=>{var e;return(e=t.call)===null||e===void 0?void 0:e.dominantSpeakers},GO=t=>{var e;return(e=t.call)===null||e===void 0?void 0:e.remoteParticipants},_X=t=>t.environmentInfo,Gii=t=>t.selectedVideoBackgroundEffect,qii=t=>{var e;return(e=t.call)===null||e===void 0?void 0:e.captionsFeature.isCaptionsFeatureActive},Fje=t=>t.isTeamsCall,EX=t=>t.isTeamsMeeting,AX=t=>{var e,i;return(i=(e=t.call)===null||e===void 0?void 0:e.meetingConference)===null||i===void 0?void 0:i.conferencePhones},Wii=t=>{var e,i;return(i=(e=t.call)===null||e===void 0?void 0:e.capabilitiesFeature)===null||i===void 0?void 0:i.latestCapabilitiesChangeInfo},V4=t=>t.targetCallees,Kii=t=>{var e;return(e=t.call)===null||e===void 0?void 0:e.startTime},Jii=t=>{var e,i;return(i=(e=t.call)===null||e===void 0?void 0:e.spotlight)===null||i===void 0?void 0:i.spotlightedParticipants},Uje=t=>{var e,i;return(i=(e=t.call)===null||e===void 0?void 0:e.breakoutRooms)===null||i===void 0?void 0:i.assignedBreakoutRoom},zje=t=>{var e,i;return(i=(e=t.call)===null||e===void 0?void 0:e.breakoutRooms)===null||i===void 0?void 0:i.breakoutRoomSettings},Yii=t=>{var e,i;return(i=(e=t.call)===null||e===void 0?void 0:e.breakoutRooms)===null||i===void 0?void 0:i.breakoutRoomDisplayName},Qii=t=>t.latestNotifications,Vje=t=>t.onResolveVideoEffectDependency,Zii=t=>t.onResolveDeepNoiseSuppressionDependency,Xii=t=>t.deepNoiseSuppressionOnByDefault,eni=t=>t.hideDeepNoiseSuppressionButton,Cfe=t=>t.reactions,$je=t=>t.alternateCallerId,W8=t=>t.isRoomsCall,tni=t=>t.videoBackgroundImages,ini=t=>{var e;return(e=t.call)===null||e===void 0?void 0:e.meetingMediaAccess};var $o=function(t,e,i,r){function o(l){return l instanceof i?l:new i(function(d){d(l)})}return new(i||(i=Promise))(function(l,d){function h(f){try{g(r.next(f))}catch(y){d(y)}}function p(f){try{g(r.throw(f))}catch(y){d(y)}}function g(f){f.done?l(f.value):o(f.value).then(h,p)}g((r=r.apply(t,e||[])).next())})};const JA=t=>{const e=QE(),i=qn(z4);return nni(e,i)},nni=ob((t,e)=>{var i,r,o,l,d,h,p,g;return{onCreateLocalStreamView:f=>$o(void 0,void 0,void 0,function*(){return yield t.createStreamView(void 0,f)}),onCreateRemoteStreamView:(f,y)=>$o(void 0,void 0,void 0,function*(){return yield t.createStreamView(f,y)}),onHangUp:f=>$o(void 0,void 0,void 0,function*(){yield t.leaveCall(f)}),onToggleHold:()=>$o(void 0,void 0,void 0,function*(){var f;return((f=t.getState().call)===null||f===void 0?void 0:f.state)==="LocalHold"?yield t.resumeCall():yield t.holdCall()}),onAddParticipant:(f,y)=>$o(void 0,void 0,void 0,function*(){if("communicationUserId"in f)return yield t.addParticipant(f);if("phoneNumber"in f)return yield t.addParticipant(f,y)}),onSendDtmfTone:f=>$o(void 0,void 0,void 0,function*(){yield t.sendDtmfTone(f)}),onRemoveParticipant:f=>$o(void 0,void 0,void 0,function*(){typeof f=="string"?yield t.removeParticipant(f):yield t.removeParticipant(JS(f))}),onRaiseHand:()=>$o(void 0,void 0,void 0,function*(){yield t.raiseHand()}),onLowerHand:()=>$o(void 0,void 0,void 0,function*(){yield t.lowerHand()}),onToggleRaiseHand:()=>$o(void 0,void 0,void 0,function*(){var f;!((f=t.getState().call)===null||f===void 0)&&f.raiseHand.localParticipantRaisedHand?yield t.lowerHand():yield t.raiseHand()}),onReactionClick:f=>$o(void 0,void 0,void 0,function*(){yield t.onReactionClick(f)}),onSelectCamera:(f,y)=>$o(void 0,void 0,void 0,function*(){yield t.setCamera(f,y)}),onSelectMicrophone:f=>$o(void 0,void 0,void 0,function*(){yield t.setMicrophone(f)}),onSelectSpeaker:f=>$o(void 0,void 0,void 0,function*(){yield t.setSpeaker(f)}),onStartCall:(f,y)=>{const T=f.map(C=>Ga(C));return t.startCall(T,y)},onStartScreenShare:()=>$o(void 0,void 0,void 0,function*(){yield t.startScreenShare()}),onStopScreenShare:()=>$o(void 0,void 0,void 0,function*(){yield t.stopScreenShare()}),onToggleCamera:f=>$o(void 0,void 0,void 0,function*(){Sfe(t.getState())?yield t.stopCamera():yield t.startCamera(f)}),onToggleMicrophone:()=>$o(void 0,void 0,void 0,function*(){var f;return!((f=t.getState().call)===null||f===void 0)&&f.isMuted?yield t.unmute():yield t.mute()}),onToggleScreenShare:()=>$o(void 0,void 0,void 0,function*(){var f;return!((f=t.getState().call)===null||f===void 0)&&f.isScreenSharingOn?yield t.stopScreenShare():yield t.startScreenShare()}),onStartLocalVideo:()=>$o(void 0,void 0,void 0,function*(){if(t.getState().call)return t.startCamera()}),onDisposeLocalStreamView:()=>$o(void 0,void 0,void 0,function*(){return t.disposeLocalVideoStreamView()}),onDisposeRemoteStreamView:f=>$o(void 0,void 0,void 0,function*(){return t.disposeStreamView(f)}),onDisposeRemoteScreenShareStreamView:f=>$o(void 0,void 0,void 0,function*(){return t.disposeScreenShareStreamView(f)}),onDisposeLocalScreenShareStreamView:()=>$o(void 0,void 0,void 0,function*(){return t.disposeScreenShareStreamView("")}),onDisposeRemoteVideoStreamView:f=>$o(void 0,void 0,void 0,function*(){return t.disposeRemoteVideoStreamView(f)}),onRemoveVideoBackgroundEffects:()=>$o(void 0,void 0,void 0,function*(){return yield t.stopVideoBackgroundEffects()}),onBlurVideoBackground:f=>$o(void 0,void 0,void 0,function*(){const y=Object.assign({effectName:"blur"},f);return yield t.startVideoBackgroundEffect(y)}),onReplaceVideoBackground:f=>$o(void 0,void 0,void 0,function*(){const y=Object.assign({effectName:"replacement"},f);return yield t.startVideoBackgroundEffect(y)}),onStartNoiseSuppressionEffect:()=>$o(void 0,void 0,void 0,function*(){return yield t.startNoiseSuppressionEffect()}),onStopNoiseSuppressionEffect:()=>$o(void 0,void 0,void 0,function*(){return yield t.stopNoiseSuppressionEffect()}),onStartCaptions:f=>$o(void 0,void 0,void 0,function*(){yield t.startCaptions(f)}),onStopCaptions:()=>$o(void 0,void 0,void 0,function*(){yield t.stopCaptions()}),onSetSpokenLanguage:f=>$o(void 0,void 0,void 0,function*(){yield t.setSpokenLanguage(f)}),onSetCaptionLanguage:f=>$o(void 0,void 0,void 0,function*(){yield t.setCaptionLanguage(f)}),onSubmitSurvey:f=>$o(void 0,void 0,void 0,function*(){return yield t.submitSurvey(f)}),onStartSpotlight:f=>$o(void 0,void 0,void 0,function*(){yield t.startSpotlight(f)}),onStopSpotlight:f=>$o(void 0,void 0,void 0,function*(){yield t.stopSpotlight(f)}),onStopAllSpotlight:()=>$o(void 0,void 0,void 0,function*(){yield t.stopAllSpotlight()}),onStartLocalSpotlight:e?.spotlightParticipant.isPresent?()=>$o(void 0,void 0,void 0,function*(){yield t.startSpotlight()}):void 0,onStopLocalSpotlight:()=>$o(void 0,void 0,void 0,function*(){yield t.stopSpotlight()}),onStartRemoteSpotlight:e?.spotlightParticipant.isPresent?f=>$o(void 0,void 0,void 0,function*(){yield t.startSpotlight(f)}):void 0,onStopRemoteSpotlight:e?.removeParticipantsSpotlight.isPresent?f=>$o(void 0,void 0,void 0,function*(){yield t.stopSpotlight(f)}):void 0,onMuteParticipant:f=>$o(void 0,void 0,void 0,function*(){yield t.muteParticipant(f)}),onMuteAllRemoteParticipants:()=>$o(void 0,void 0,void 0,function*(){yield t.muteAllRemoteParticipants()}),onForbidAudio:!((i=e?.forbidOthersAudio)===null||i===void 0)&&i.isPresent?f=>$o(void 0,void 0,void 0,function*(){yield t.forbidAudio(f)}):void 0,onPermitAudio:!((r=e?.forbidOthersAudio)===null||r===void 0)&&r.isPresent?f=>$o(void 0,void 0,void 0,function*(){yield t.permitAudio(f)}):void 0,onForbidOthersAudio:!((o=e?.forbidOthersAudio)===null||o===void 0)&&o.isPresent?()=>$o(void 0,void 0,void 0,function*(){yield t.forbidOthersAudio()}):void 0,onPermitOthersAudio:!((l=e?.forbidOthersAudio)===null||l===void 0)&&l.isPresent?()=>$o(void 0,void 0,void 0,function*(){yield t.permitOthersAudio()}):void 0,onForbidVideo:!((d=e?.forbidOthersVideo)===null||d===void 0)&&d.isPresent?f=>$o(void 0,void 0,void 0,function*(){yield t.forbidVideo(f)}):void 0,onPermitVideo:!((h=e?.forbidOthersVideo)===null||h===void 0)&&h.isPresent?f=>$o(void 0,void 0,void 0,function*(){yield t.permitVideo(f)}):void 0,onForbidOthersVideo:!((p=e?.forbidOthersVideo)===null||p===void 0)&&p.isPresent?()=>$o(void 0,void 0,void 0,function*(){yield t.forbidOthersVideo()}):void 0,onPermitOthersVideo:!((g=e?.forbidOthersVideo)===null||g===void 0)&&g.isPresent?()=>$o(void 0,void 0,void 0,function*(){yield t.permitOthersVideo()}):void 0}}),mc=t=>{const e=K$e(t);if(!e)throw new Error("Can't find the selector for component, please check supported component list");return Object.assign(Object.assign({},Cje(e)),JA())},Hje=t=>{const e=mc(aX),i=ks().strings.call,r={captionsSettingsModalTitle:i.captionsSettingsModalTitle,captionsSettingsSpokenLanguageDropdownLabel:i.captionsSettingsSpokenLanguageDropdownLabel,captionsSettingsCaptionLanguageDropdownLabel:i.captionsSettingsCaptionLanguageDropdownLabel,captionsSettingsSpokenLanguageDropdownInfoText:i.captionsSettingsSpokenLanguageDropdownInfoText,captionsSettingsCaptionLanguageDropdownInfoText:i.captionsSettingsCaptionLanguageDropdownInfoText,captionsSettingsConfirmButtonLabel:i.captionsSettingsConfirmButtonLabel,captionsSettingsCancelButtonLabel:i.captionsSettingsCancelButtonLabel,captionsSettingsModalAriaLabel:i.captionsSettingsModalAriaLabel,captionsSettingsCloseModalButtonAriaLabel:i.captionsSettingsCloseModalButtonAriaLabel},o=i.spokenLanguageStrings,l=i.captionLanguageStrings;return U.createElement(aX,Object.assign({},e,{strings:r,spokenLanguageStrings:o,captionLanguageStrings:l,showModal:t.showCaptionsSettingsModal,onDismissCaptionsSettings:t.onDismissCaptionsSettings,changeCaptionLanguage:t.changeCaptionLanguage}))},K8=3,ani={root:{border:"0.125rem",borderRadius:2,width:"6.5625rem"},flexContainer:{flexFlow:"row"}},rni={root:{border:"0",borderRadius:"0.5rem"},flexContainer:{flexFlow:"row"}},lh={root:{height:`${K8}rem`,lineHeight:`${K8}rem`,maxHeight:"unset",overflow:"hidden"},linkContent:{height:`${K8}rem`,lineHeight:`${K8}rem`,maxHeight:"unset"},icon:{maxHeight:"unset",textAlign:"center"},checkmarkIcon:{lineHeight:"2rem"}},oni={menuStyles:{menuItemStyles:lh,participantListStyles:{participantItemStyles:{root:{height:`${K8}rem`},participantSubMenuItemsStyles:lh}}}},sni={menuStyles:{menuItemStyles:lh}},jje={label:{minWidth:"1.25rem"}},mF=(...t)=>{let e=jje;return t.forEach(i=>{e=Ds(e,i)}),e},Gje=()=>U.createElement(dK,{key:"chatOnIconKey",primaryFill:"currentColor"}),IX=t=>U.createElement(Jy,Object.assign({},t,{labelKey:"optionsButtonLabelKey",showLabel:t.showLabel,onRenderOnIcon:Gje,onRenderOffIcon:Gje,onClick:t.onClick,"data-ui-id":t["data-ui-id"]}));var qje=function(t,e,i,r){function o(l){return l instanceof i?l:new i(function(d){d(l)})}return new(i||(i=Promise))(function(l,d){function h(f){try{g(r.next(f))}catch(y){d(y)}}function p(f){try{g(r.throw(f))}catch(y){d(y)}}function g(f){f.done?l(f.value):o(f.value).then(h,p)}g((r=r.apply(t,e||[])).next())})};const lni=t=>{const e=ks(),i=mc(iX),r=$.useMemo(()=>({label:e.strings.call.captionsBannerMoreButtonCallingLabel,tooltipOffContent:e.strings.call.captionsBannerMoreButtonTooltip}),[e]),o=[],l=$.useCallback(()=>qje(void 0,void 0,void 0,function*(){yield i.onStartCaptions({spokenLanguage:i.currentSpokenLanguage})}),[i]),d=$.useCallback(()=>qje(void 0,void 0,void 0,function*(){yield i.onStopCaptions()}),[i]);return o.push({key:"ToggleCaptionsKey",text:i.checked?e.strings.call.startCaptionsButtonTooltipOnContent:e.strings.call.startCaptionsButtonTooltipOffContent,onClick:()=>{i.checked?d():i.currentSpokenLanguage!==""?l():t.onCaptionsSettingsClick&&t.onCaptionsSettingsClick()},iconProps:{iconName:i.checked?"CaptionsOffIcon":"CaptionsIcon",styles:{root:{lineHeight:0}}},itemProps:{styles:lh}}),t.onCaptionsSettingsClick&&o.push({key:"openCaptionsSettingsKey",id:"common-call-composite-captions-settings-button",text:e.strings.call.captionsSettingsLabel,onClick:t.onCaptionsSettingsClick,iconProps:{iconName:"CaptionsSettingsIcon",styles:{root:{lineHeight:0}}},itemProps:{styles:lh},disabled:!i.checked}),U.createElement(IX,Object.assign({},t,{"data-ui-id":"captions-banner-more-button",strings:r,menuIconProps:{hidden:!0},menuProps:{items:o,calloutProps:{preventDismissOnEvent:YS}}}))},cni="95%",dni=t=>{var e;const i=mc(Vme),[r,o]=$.useState(!1),l=()=>{o(!0)},d=()=>{o(!1)},h=It(((e=t.captionsOptions)===null||e===void 0?void 0:e.height)==="full"?It({position:"absolute",height:"100%",width:"100%"}):{position:"relative"}),p=It({position:"absolute",right:0,top:0}),g=ks().strings.call,f={captionsBannerSpinnerText:g.captionsBannerSpinnerText},y=$.useCallback((w,D)=>U.createElement(U4,Object.assign({userId:w},D,{dataProvider:t.onFetchAvatarPersonaData})),[t.onFetchAvatarPersonaData]),{innerWidth:T}=window,[C,E]=$.useState(T);$.useEffect(()=>{function w(){E(window.innerWidth)}return window.addEventListener("resize",w),()=>window.removeEventListener("resize",w)},[]);const I=C>620?"35rem":"80%";return U.createElement(U.Fragment,null,r&&U.createElement(Hje,{showCaptionsSettingsModal:r,onDismissCaptionsSettings:d,changeCaptionLanguage:t.useTeamsCaptions}),U.createElement("div",{className:h,role:"region","aria-label":g.liveCaptionsLabel},U.createElement(Et,{horizontalAlign:"center"},U.createElement(Et.Item,{style:{width:t.isMobile?cni:I}},U.createElement(Vme,Object.assign({captionsOptions:t.captionsOptions,onRenderAvatar:y,formFactor:t.isMobile?"compact":"default",strings:f},i)))),!t.isMobile&&i.isCaptionsOn&&U.createElement("div",{className:p},U.createElement(lni,{onCaptionsSettingsClick:l}))))},uni={position:"relative",width:"100%",height:"100%"},hni=30,Wje=t=>{var e;const i=mc(O4),r=$.useMemo(()=>{var h;return mF((h=t.styles)!==null&&h!==void 0?h:{})},[t.styles]),o=qn(W8),l=qn(XC),d=(e=qn(z4))===null||e===void 0?void 0:e.turnVideoOn;return U.createElement(O4,Object.assign({"data-ui-id":"call-composite-camera-button"},i,{showLabel:t.displayType!=="compact",styles:r,enableDeviceSelectionMenu:t.splitButtonsForDeviceSelection,disableTooltip:t.disableTooltip,disabled:i.disabled||t.disabled||!!(o&&l==="Unknown"),onRenderOffIcon:d&&!d.isPresent?()=>U.createElement(Hm,{disabled:!0,iconName:"ControlButtonCameraProhibited"}):void 0,onClickVideoEffects:t.onClickVideoEffects,componentRef:t.componentRef}))},pni=t=>{var e;const i=mc(dF),r=(e=qn(XC))!==null&&e!==void 0?e:"Unknown",o=$.useMemo(()=>Object.assign(Object.assign({},i),{microphones:r==="Consumer"?[]:i.microphones,cameras:r==="Consumer"?[]:i.cameras}),[i,r]),l=$.useMemo(()=>{var g;return mF(t.increaseFlyoutItemSize?sni:{},(g=t.styles)!==null&&g!==void 0?g:{})},[t.increaseFlyoutItemSize,t.styles]),d=ks(),h=r==="Consumer",p=()=>U.createElement(Hm,{disabled:t.disabled,iconName:"OptionsSpeaker"});return U.createElement(dF,Object.assign({persistMenu:!0},o,{showLabel:t.displayType!=="compact",styles:l,"data-ui-id":"calling-composite-devices-button",disabled:t.disabled,strings:gni(r,d),onRenderIcon:h?p:void 0}))},gni=(t,e)=>{if(t==="Consumer")return{label:e.component.strings.microphoneButton.speakerMenuTitle}},fF=t=>{var e;const i=Cs(),r=Ds(fni,(e=t.styles)!==null&&e!==void 0?e:{});return U.createElement(o5,{styles:r,isOpen:t.isOpen,onDismiss:t.onDismiss,isBlocking:!1},U.createElement(Et,{className:It({position:"relative"})},U.createElement(ja,{className:It({fontWeight:600,fontSize:"1.25rem"})},t.heading),U.createElement(zy,{styles:mni(i),iconProps:{iconName:"Cancel"},onClick:t.onCancel,ariaLabel:t.closeButtonLabel})),U.createElement(Et,{verticalAlign:"center",className:It({minHeight:"6rem"})},U.createElement(ja,{className:It({fontSize:"0.875rem"})},t.text)),U.createElement(Et,{horizontal:!0,horizontalAlign:"end",tokens:{childrenGap:"0.5rem"}},U.createElement(SE,{styles:Kje,text:t.confirmButtonLabel,onClick:t.onConfirm}),U.createElement(th,{styles:Kje,text:t.cancelButtonLabel,onClick:t.onCancel})))},mni=t=>({root:{position:"absolute",top:0,right:0,color:t.palette.neutralPrimary},rootHovered:{color:t.palette.neutralDark}}),fni={main:{padding:"1.5rem ",maxWidth:"30rem"}},Kje={label:{fontSize:"0.875rem"}};var vni=function(t,e,i,r){function o(l){return l instanceof i?l:new i(function(d){d(l)})}return new(i||(i=Promise))(function(l,d){function h(f){try{g(r.next(f))}catch(y){d(y)}}function p(f){try{g(r.throw(f))}catch(y){d(y)}}function g(f){f.done?l(f.value):o(f.value).then(h,p)}g((r=r.apply(t,e||[])).next())})};const Jje=t=>{var e;const i=t.displayType==="compact",r=mc(Ome),o=ks().strings,l=$.useMemo(()=>({confirmButtonLabel:o.call.endCallConfirmButtonLabel,heading:o.call.endCallConfirmDialogTitle,text:o.call.leaveConfirmDialogContent,closeButtonLabel:o.call.close}),[o.call.endCallConfirmButtonLabel,o.call.endCallConfirmDialogTitle,o.call.leaveConfirmDialogContent,o.call.close]),d=$.useMemo(()=>({confirmButtonLabel:o.call.leaveConfirmButtonLabel,heading:o.call.leaveConfirmDialogTitle,text:o.call.leaveConfirmDialogContent,closeButtonLabel:o.call.close}),[o.call.leaveConfirmButtonLabel,o.call.leaveConfirmDialogContent,o.call.leaveConfirmDialogTitle,o.call.close]),[h,p]=$.useState(d),{onHangUp:g}=r,[f,y]=U.useState(!1),T=$.useCallback(()=>{y(!f)},[f]),C=$.useCallback(F=>{g&&g(F),T()},[g,T]),E=$.useCallback(F=>vni(void 0,void 0,void 0,function*(){if(t.mobileView||F===!1){g();return}p(F?l:d),T()}),[l,d,g,t.mobileView,T]),I=$.useMemo(()=>{var F;return Ds(i?rni:ani,(F=t.styles)!==null&&F!==void 0?F:{})},[i,t.styles]),w=!!t.returnFromBreakoutRoom,D={items:[{key:"returnToMainMeeting",text:o.call.returnFromBreakoutRoomButtonLabel,title:o.call.returnFromBreakoutRoomButtonLabel,onClick:()=>{var F;(F=t.returnFromBreakoutRoom)===null||F===void 0||F.call(t)}},{key:"leaveRoomAndMainMeeting",text:o.call.leaveBreakoutRoomAndMeetingButtonLabel,title:o.call.leaveBreakoutRoomAndMeetingButtonLabel,onClick:()=>g()}],styles:t.styles};return U.createElement(Et,null,U.createElement(Ome,Object.assign({"data-ui-id":"call-composite-hangup-button"},r,{onHangUp:t.disableEndCallModal?g:E,styles:I,showLabel:!i,enableEndCallMenu:(e=t.enableEndCallMenu)!==null&&e!==void 0?e:!1,menuProps:w?D:void 0})),U.createElement(fF,Object.assign({},h,{styles:{main:{minWidth:"22.5rem",padding:"1.5rem"}},cancelButtonLabel:o.call.hangUpCancelButtonLabel,onConfirm:()=>C(t.enableEndCallMenu),isOpen:f,onCancel:T})))},Yje=t=>{var e;const i=mc(tX),r=qn(G8),o=qn(Nje),l=qn(W8),d=qn(XC),h=(e=qn(z4))===null||e===void 0?void 0:e.unmuteMic;r==="Connecting"&&(i.checked=o);const p=$.useMemo(()=>{var g;return mF((g=t.styles)!==null&&g!==void 0?g:{})},[t.styles]);return U.createElement(tX,Object.assign({"data-ui-id":"call-composite-microphone-button"},i,{isDeepNoiseSuppressionOn:t.isDeepNoiseSuppressionOn,onClickNoiseSuppression:t.onClickNoiseSuppression,showNoiseSuppressionButton:t.showNoiseSuppressionButton,showLabel:t.displayType!=="compact",disableTooltip:t.disableTooltip,styles:p,enableDeviceSelectionMenu:t.splitButtonsForDeviceSelection,disabled:i.disabled||t.disabled||!!(l&&d==="Unknown"),onRenderOffIcon:h&&!h.isPresent?()=>U.createElement(Hm,{disabled:!0,iconName:"ControlButtonMicProhibited"}):void 0}))},yni=t=>{const e=mc(Bme),i=$.useMemo(()=>{var r;return mF(t.increaseFlyoutItemSize?oni:{},(r=t.styles)!==null&&r!==void 0?r:{})},[t.increaseFlyoutItemSize,t.styles]);return U.createElement(Bme,Object.assign({"data-ui-id":"call-composite-participants-button"},e,{showLabel:t.displayType!=="compact",callInvitationURL:t.callInvitationURL,onFetchParticipantMenuItems:t.onFetchParticipantMenuItems,disabled:Sni(t.option)||t.disabled,styles:i,showParticipantOverflowTooltip:!t.isMobile}))},Sni=t=>t===void 0||t===!0||t===!1?!1:t.disabled,Qje=t=>{const e=mc(Fme),i=$.useMemo(()=>{var d;return mF((d=t.styles)!==null&&d!==void 0?d:{})},[t.styles]),r=qn(W8),o=qn(XC),l=()=>{var d;return(d=e?.disabled)!==null&&d!==void 0?d:bni(t.option)};return U.createElement(Fme,Object.assign({"data-ui-id":"call-composite-screenshare-button"},e,{showLabel:t.displayType!=="compact",disabled:l()||t.disabled||!!(r&&o==="Unknown"),styles:i}))},bni=t=>t===void 0||t===!0||t===!1?!1:t.disabled,Zje=()=>U.createElement(YE,{iconName:"ControlButtonParticipants"}),Tni=t=>{const{strings:e,onRenderOnIcon:i,onRenderOffIcon:r,onClick:o}=t,l=Cs(),d=$.useMemo(()=>{var h;return Ds({rootChecked:{background:l.palette.neutralLight}},(h=t.styles)!==null&&h!==void 0?h:{},jje)},[t.styles,l.palette.neutralLight]);return U.createElement(Jy,Object.assign({},t,{"data-ui-id":"call-composite-participants-button",strings:e,labelKey:"peopleButtonLabelKey",onRenderOnIcon:i??Zje,onRenderOffIcon:r??Zje,onClick:o,styles:d}))},Xje={paddingTop:"0.25rem",paddingBottom:"0.25rem"},_fe=1,Efe=_fe+1,wX=Math.max(Efe,_fe)+1,Cni=wX+1,e6e=It(Xje,{zIndex:Efe}),t6e={width:"100%",position:"relative",minHeight:"13rem"},_ni=It(Object.assign(Object.assign({},t6e),{minWidth:"30rem"})),Eni=It(Object.assign(Object.assign({},t6e),{minWidth:"17.5rem"})),Ani=t=>({root:{zIndex:_fe,width:"100%",background:t}}),Ini={root:{height:"100%",width:"100%"}},wni={root:{width:"100%",position:"absolute",top:0,left:0,padding:"1rem",zIndex:wX,pointerEvents:"none"}},kX={root:{zIndex:wX,pointerEvents:"auto"}},i6e={root:{zIndex:wX,pointerEvents:"auto",marginBottom:"0.5rem"}},kni=t=>({root:{width:"100%",height:"100%",flexDirection:t?"unset":"column"}}),n6e=t=>{const e=mc(z8),i=qn(G8),r=$.useMemo(()=>{var l;return mF((l=t.styles)!==null&&l!==void 0?l:{})},[t.styles]);let o=Rni(t.option);return g4(i)&&(o=!0),U.createElement(z8,Object.assign({"data-ui-id":"call-composite-raisehand-button"},e,{showLabel:t.displayType!=="compact",disabled:o||t.disabled,styles:r}))},Rni=t=>t===void 0||t===!0||t===!1?!1:t.disabled,Pk={MAX_PRIMARY_DESKTOP_CUSTOM_BUTTONS:3,MAX_PRIMARY_MOBILE_CUSTOM_BUTTONS:1,MAX_SECONDARY_DESKTOP_CUSTOM_BUTTONS:2},a6e=(t,e)=>{const i=t?.map(r=>r({displayType:e}));return{primary:Afe("primary",i),secondary:Afe("secondary",i),overflow:Afe("overflow",i)}},Afe=(t,e)=>e?e.filter(i=>i.placement===t).map((i,r)=>o=>{var l,d,h,p,g,f,y,T,C,E;return"onRenderButton"in i?i.onRenderButton(o):U.createElement(Jy,{ariaDescription:(d=(l=i.strings)===null||l===void 0?void 0:l.ariaDescription)!==null&&d!==void 0?d:o.ariaDescription,ariaLabel:(f=(p=(h=i.strings)===null||h===void 0?void 0:h.ariaLabel)!==null&&p!==void 0?p:(g=i.strings)===null||g===void 0?void 0:g.tooltipContent)!==null&&f!==void 0?f:o.ariaLabel,disabled:(y=i.disabled)!==null&&y!==void 0?y:o.disabled,id:(T=i.id)!==null&&T!==void 0?T:o.id,key:`${i.placement}_${r}`,onClick:(C=i.onItemClick)!==null&&C!==void 0?C:o.onClick,onRenderIcon:()=>{var I,w,D;return U.createElement(Fr,{iconName:(D=(I=i.iconName)!==null&&I!==void 0?I:(w=o.iconProps)===null||w===void 0?void 0:w.iconName)!==null&&D!==void 0?D:"DefaultCustomButton"})},showLabel:(E=i.showLabel)!==null&&E!==void 0?E:o.showLabel,styles:Rw(o.styles),strings:i.strings})}):[],$4=(t,e)=>e?e.filter(i=>i.placement===t).map((i,r)=>{var o,l;return Object.assign(Object.assign({},i),{disabled:i.disabled,iconProps:{iconName:(o=i.iconName)!==null&&o!==void 0?o:"DefaultCustomButton",styles:{root:{lineHeight:0}}},id:i.id,itemKey:`${i.placement}_${r}`,onItemClick:i.onItemClick,text:(l=i.strings)===null||l===void 0?void 0:l.label})}):[],Mni=(t,e)=>{const i=t?.map(r=>r({displayType:e}));return{primary:$4("primary",i),secondary:$4("secondary",i),overflow:$4("overflow",i)}},r6e=(t,e)=>{const i=t?.map(r=>r({displayType:e}));return{primary:$4("primary",i).map(RX),secondary:$4("secondary",i).map(RX),overflow:$4("overflow",i).map(RX)}},RX=t=>Object.assign(Object.assign({},t),{key:t.itemKey,onClick:t.onItemClick?e=>{var i;(i=t.onItemClick)===null||i===void 0||i.call(t,e)}:void 0,subMenuProps:t.subMenuProps?{items:t.subMenuProps.map(RX)}:void 0}),J8=t=>{let e;return e=t?.onFetchCustomButtonProps,e},o6e=t=>{const e=mc(Ume),i=$.useMemo(()=>{var o;return mF((o=t.styles)!==null&&o!==void 0?o:{})},[t.styles]),r=Pni(t.option)||e.disabled;return U.createElement(Ume,Object.assign({"data-ui-id":"call-composite-reaction-button"},e,{showLabel:t.displayType!=="compact",disabled:r||t.disabled,styles:i,disableTooltip:t.disableTooltip,persistMenu:!0,reactionResources:t.reactionResource}))},Pni=t=>t===void 0||t===!0||t===!1?!1:t.disabled,s6e=Xs([z4],t=>({capabilities:t})),Y8=Xs([G8,Fii],(t,e)=>({callStatus:t,isScreenShareOn:e}));var l6e=function(t,e,i,r){function o(l){return l instanceof i?l:new i(function(d){d(l)})}return new(i||(i=Promise))(function(l,d){function h(f){try{g(r.next(f))}catch(y){d(y)}}function p(f){try{g(r.throw(f))}catch(y){d(y)}}function g(f){f.done?l(f.value):o(f.value).then(h,p)}g((r=r.apply(t,e||[])).next())})};const Dni=ql(t=>({root:{background:t}})),Lni=(t,e)=>{if(e===!1)return{};const i=e===!0||e===void 0?{}:e;return t&&(i.screenShareButton=!1),i},Oni=t=>{var e;const i=$.useMemo(()=>Lni(!!t.isMobile,t.options),[t.isMobile,t.options]),r=ks(),[o,l]=$.useState(!1),d=QE(),h=$.useCallback(()=>l6e(void 0,void 0,void 0,function*(){yield d.startNoiseSuppressionEffect()}),[d]),p=qn(Zii),g=qn(Xii);$.useEffect(()=>{p&&g&&(h(),l(!0))},[p,g,h]);const f=qn(_X),y=CX(f),T=qn(eni),C=!!(p&&!T&&!y),E=$.useCallback(()=>l6e(void 0,void 0,void 0,function*(){o?(yield d.stopNoiseSuppressionEffect(),l(!1)):(yield d.startNoiseSuppressionEffect(),l(!0))}),[d,o]),I=$.useMemo(()=>({label:r.strings.call.peopleButtonLabel,tooltipOffContent:r.strings.call.peopleButtonTooltipOpen,tooltipOnContent:r.strings.call.peopleButtonTooltipClose}),[r]),w=$.useMemo(()=>({label:r.strings.call.moreButtonCallingLabel,tooltipOffContent:r.strings.callWithChat.moreDrawerButtonTooltip}),[r]),D=mc($8),F=mc(z8),x=qn(s6e),L=qn(Y8).callStatus!=="Connected"||!x?.capabilities||x.capabilities.useReactions.isPresent,z=mc(dF);let H=0;const j=e_(i?.screenShareButton);j&&H++;const J=e_(i?.microphoneButton);J&&H++;const Z=e_(i?.cameraButton);Z&&H++,e_(i?.endCallButton)&&H++;const re=e_(i?.participantsButton)&&!t.isMobile;re&&H++;const ne=e_(i?.reactionButton)&&L&&!t.isMobile;ne&&H++;const le=qn(W8),he=()=>{const Ge=[];return t.isMobile&&t.onPeopleButtonClicked&&e_(i?.participantsButton)&&Ge.push({key:"peopleButtonKey",text:r.component.strings.participantsButton.label,onClick:()=>{t.onPeopleButtonClicked&&t.onPeopleButtonClicked()},iconProps:{iconName:"ControlButtonParticipantsContextualMenuItem",styles:{root:{lineHeight:0}}},itemProps:{styles:lh},disabled:tm(i?.participantsButton),"data-ui-id":"call-composite-more-menu-people-button"}),le||Ge.push({key:"holdButtonKey",text:r.component.strings.holdButton.tooltipOffContent,onClick:()=>{D.onToggleHold()},iconProps:{iconName:"HoldCallContextualMenuItem",styles:{root:{lineHeight:0}}},itemProps:{styles:lh},disabled:tm(i?.holdButton),"data-ui-id":"hold-button"}),Ge},Me=$.useMemo(()=>r6e(J8(typeof i=="object"?i:void 0),typeof i=="object"?i.displayType:void 0),[i]),Le=he();let pe=e_(i?.moreButton)&&Le.length>0;pe&&H++;const te=$.useMemo(()=>a6e(J8(i),i?.displayType),[i]);H+=U.Children.count(te.primary)+U.Children.count(te.secondary);let Se=e_(i?.devicesButton);Se&&(!t.isMobile||H<5)?H++:(Se=!1,pe=e_(i?.moreButton));const ce=qn(Cfe);let ve=e_(i?.raiseHandButton);const Te=qn(XC),Be=le&&Te&&["Consumer","Unknown"].includes(Te);if(ve&&(!t.isMobile||H<5)?H++:(!pe&&e_(i?.moreButton)&&(pe=!0,Se=!1),ve=!1),!Se){const Ge=eX(z,r.component.strings.devicesButton);Le.push({key:"devicesButtonKey",text:r.component.strings.devicesButton.label,iconProps:{iconName:"ControlButtonOptions",styles:{root:{lineHeight:0}}},subMenuProps:Ge,"data-ui-id":"call-composite-more-menu-devices-button"})}!ve&&!Be&&Le.push({key:"raiseHandButtonKey",text:F.checked?r.component.strings.raiseHandButton.onLabel:r.component.strings.raiseHandButton.offLabel,onClick:()=>{F.onToggleRaiseHand&&F.onToggleRaiseHand()},iconProps:{iconName:"RaiseHandContextualMenuItem",styles:{root:{lineHeight:0}}},itemProps:{styles:lh},disabled:tm(i?.raiseHandButton),"data-ui-id":"call-composite-more-menu-raise-hand-button"}),Me.primary&&Me.primary.slice(t.isMobile?Pk.MAX_PRIMARY_MOBILE_CUSTOM_BUTTONS:Pk.MAX_PRIMARY_DESKTOP_CUSTOM_BUTTONS).forEach(Ge=>{Le.push(Object.assign({itemProps:{styles:lh}},Ge))}),Me.secondary&&Me.secondary.forEach(Ge=>{Le.push(Object.assign({itemProps:{styles:lh}},Ge))}),Me.overflow&&Me.overflow.forEach(Ge=>{Le.push(Object.assign({itemProps:{styles:lh}},Ge))});const qe=hc();return t.options===!1?U.createElement(U.Fragment,null):U.createElement(Et,{horizontalAlign:"center",className:e6e},U.createElement(Et.Item,null,U.createElement(Lme,{layout:t.displayVertical?"vertical":"horizontal",styles:Dni(qe.semanticColors.bodyBackground)},J&&U.createElement(Yje,{displayType:i?.displayType,disabled:tm(i?.microphoneButton),onClickNoiseSuppression:E,isDeepNoiseSuppressionOn:o,showNoiseSuppressionButton:C}),Z&&U.createElement(Wje,{displayType:i?.displayType,disabled:tm(i?.cameraButton)}),ne&&ce&&U.createElement(o6e,{displayType:i?.displayType,reactionResource:ce}),ve&&!Be&&U.createElement(n6e,{displayType:i?.displayType}),j&&U.createElement(Qje,{option:i?.screenShareButton,displayType:i?.displayType,disabled:tm(i?.screenShareButton)}),re&&U.createElement(yni,{option:i?.participantsButton,callInvitationURL:t.callInvitationURL,onFetchParticipantMenuItems:t.onFetchParticipantMenuItems,displayType:i?.displayType,increaseFlyoutItemSize:t.increaseFlyoutItemSize,isMobile:t.isMobile,disabled:tm(i?.participantsButton)})&&U.createElement(Tni,{checked:t.peopleButtonChecked,ariaLabel:I?.label,showLabel:i?.displayType!=="compact",onClick:t.onPeopleButtonClicked,"data-ui-id":"call-composite-people-button",strings:I,disabled:tm(i?.participantsButton),disableTooltip:t.isMobile}),Se&&U.createElement(pni,{displayType:i?.displayType,increaseFlyoutItemSize:t.increaseFlyoutItemSize,disabled:tm(i?.devicesButton)}),(e=te.primary)===null||e===void 0?void 0:e.slice(0,t.isMobile?Pk.MAX_PRIMARY_MOBILE_CUSTOM_BUTTONS:Pk.MAX_PRIMARY_DESKTOP_CUSTOM_BUTTONS).map((Ge,tt)=>U.createElement(Ge,{key:`primary-custom-button-${tt}`,showLabel:i?.displayType!=="compact",disableTooltip:t.isMobile})),pe&&U.createElement(IX,{disableTooltip:t.isMobile,"data-ui-id":"common-call-composite-more-button",strings:w,menuIconProps:{hidden:!0},menuProps:{items:Le},showLabel:i?.displayType!=="compact"}),e_(i?.endCallButton)&&U.createElement(Jje,{displayType:i?.displayType}))))},e_=t=>t!==!1,c6e=()=>U.createElement(YE,{iconName:"ControlBarPeopleButton"}),Nni=t=>{const{strings:e,onRenderOnIcon:i,onRenderOffIcon:r,onClick:o,peoplePaneDismissButtonRef:l,chatButtonPresent:d}=t,h=Cs(),p=$.useMemo(()=>{var y;return Ds({rootChecked:{background:h.palette.neutralLight}},(y=t.styles)!==null&&y!==void 0?y:{})},[t.styles,h.palette.neutralLight]),g=$.useCallback(y=>{y.key==="Tab"&&!y.shiftKey&&l?.current&&!d&&(l.current.focus(),y.preventDefault())},[l,d]),f=$.useCallback(y=>{var T;o?.(y),d&&((T=l?.current)===null||T===void 0||T.focus(),y.preventDefault())},[d,o,l]);return U.createElement(Jy,Object.assign({},t,{strings:e,labelKey:"peopleButtonLabelKey",onRenderOnIcon:i??c6e,onRenderOffIcon:r??c6e,onClick:f,onKeyDown:g,styles:p}))},d6e=()=>ks().strings.callWithChat,xni=Xs([xje],t=>{var e,i;return{isVideoStreamOn:!!(!((i=(e=t?.find(r=>r.mediaStreamType==="Video"))===null||e===void 0?void 0:e.view)===null||i===void 0)&&i.target)}}),Ife=Xs([GO],t=>Object.values(t??{}).filter(i=>i.state==="Connected")),Bni=()=>{const t=ks().strings.call,e=$.useMemo(()=>({participantJoinedNoticeString:t.participantJoinedNoticeString,twoParticipantJoinedNoticeString:t.twoParticipantJoinedNoticeString,threeParticipantJoinedNoticeString:t.threeParticipantJoinedNoticeString,participantLeftNoticeString:t.participantLeftNoticeString,twoParticipantLeftNoticeString:t.twoParticipantLeftNoticeString,threeParticipantLeftNoticeString:t.threeParticipantLeftNoticeString,unnamedParticipantString:t.unnamedParticipantString,manyParticipantsJoined:t.manyParticipantsJoined,manyParticipantsLeft:t.manyParticipantsLeft,manyUnnamedParticipantsJoined:t.manyUnnamedParticipantsJoined,manyUnnamedParticipantsLeft:t.manyUnnamedParticipantsLeft}),[t]),[i,r]=$.useState(""),o=qn(Ife),l=$.useRef(o),d=h=>{r(h)};return $.useMemo(()=>{const h=o.map(y=>Ga(y.identifier)),p=l.current.map(y=>Ga(y.identifier)),g=o.filter(y=>!p.includes(Ga(y.identifier))),f=l.current.filter(y=>!h.includes(Ga(y.identifier)));g.length>0&&d(u6e("joined",g,e)),f.length>0&&d(u6e("left",f,e)),l.current=o},[o,e]),i},u6e=(t,e,i)=>{var r,o,l,d,h,p,g,f,y,T,C,E,I,w,D,F,x,B;if(e.length===0)return"";const L=e.filter(J=>!J.displayName),H=e.filter(J=>J.displayName).concat(L);if(H.filter(J=>J.displayName).length===0&&H.length>1)return Jd(t==="joined"?i.manyUnnamedParticipantsJoined:i.manyUnnamedParticipantsLeft,{numOfParticipants:(H.length-1).toString()});switch(H.length){case 1:return Jd(t==="joined"?i.participantJoinedNoticeString:i.participantLeftNoticeString,{displayName:(o=(r=H[0])===null||r===void 0?void 0:r.displayName)!==null&&o!==void 0?o:i.unnamedParticipantString});case 2:return Jd(t==="joined"?i.twoParticipantJoinedNoticeString:i.twoParticipantLeftNoticeString,{displayName1:(d=(l=H[0])===null||l===void 0?void 0:l.displayName)!==null&&d!==void 0?d:i.unnamedParticipantString,displayName2:(p=(h=H[1])===null||h===void 0?void 0:h.displayName)!==null&&p!==void 0?p:i.unnamedParticipantString});case 3:return Jd(t==="joined"?i.threeParticipantJoinedNoticeString:i.threeParticipantLeftNoticeString,{displayName1:(f=(g=H[0])===null||g===void 0?void 0:g.displayName)!==null&&f!==void 0?f:i.unnamedParticipantString,displayName2:(T=(y=H[1])===null||y===void 0?void 0:y.displayName)!==null&&T!==void 0?T:i.unnamedParticipantString,displayName3:(E=(C=H[2])===null||C===void 0?void 0:C.displayName)!==null&&E!==void 0?E:i.unnamedParticipantString})}const j=H.length-3;return Jd(t==="joined"?i.manyParticipantsJoined:i.manyParticipantsLeft,{displayName1:(w=(I=H[0])===null||I===void 0?void 0:I.displayName)!==null&&w!==void 0?w:i.unnamedParticipantString,displayName2:(F=(D=H[1])===null||D===void 0?void 0:D.displayName)!==null&&F!==void 0?F:i.unnamedParticipantString,displayName3:(B=(x=H[2])===null||x===void 0?void 0:x.displayName)!==null&&B!==void 0?B:i.unnamedParticipantString,numOfParticipants:j.toString()})},wfe=(t,e,i)=>{let r=!1;if(typeof i=="object"&&"dialerBehavior"in i){const l=i.dialerBehavior&&i.dialerBehavior==="alwaysHide",d=i.dialerBehavior==="alwaysShow";if(r=i.dialerBehavior==="autoShow",d)return!0;if(l)return!1}let o=!1;return(r||i===void 0||i===!1)&&(t?.forEach(l=>{(xx(l)||Vf(l))&&(o=!0)}),e&&e.forEach(l=>{"phoneNumber"in l.identifier||"teamsAppId"in l.identifier||(o=!1)})),o};var Fni=function(t,e,i,r){function o(l){return l instanceof i?l:new i(function(d){d(l)})}return new(i||(i=Promise))(function(l,d){function h(f){try{g(r.next(f))}catch(y){d(y)}}function p(f){try{g(r.throw(f))}catch(y){d(y)}}function g(f){f.done?l(f.value):o(f.value).then(h,p)}g((r=r.apply(t,e||[])).next())})};const Uni=t=>{var e,i,r,o,l;const d=ks(),h=mc($8),p=mc(iX),g=$.useCallback(()=>Fni(void 0,void 0,void 0,function*(){yield p.onStartCaptions({spokenLanguage:p.currentSpokenLanguage})}),[p]),[f,y]=$.useState(!1),[T,C]=$.useState((e=t.userSetGalleryLayout)!==null&&e!==void 0?e:"floatingLocalVideo"),E=qn(V4),I=wfe(E),w=qn(EX),D=qn(AX),[F,x]=$.useState((i=t.dtmfDialerPresent)!==null&&i!==void 0?i:!1),B=$.useMemo(()=>({label:d.strings.call.moreButtonCallingLabel,tooltipOffContent:d.strings.callWithChat.moreDrawerButtonTooltip}),[d]),L=[],z={root:{height:"unset",lineHeight:"100%",width:"1.25rem"}};if((t.callControls===!0||((r=t.callControls)===null||r===void 0?void 0:r.holdButton)!==!1)&&L.push({key:"holdButtonKey",text:d.component.strings.holdButton.tooltipOffContent,onClick:()=>{h.onToggleHold()},iconProps:{iconName:"HoldCallContextualMenuItem",styles:{root:{lineHeight:0}}},itemProps:{styles:lh},disabled:t.disableButtonsForHoldScreen}),t.isCaptionsSupported){const Z=[];L.push({key:"liveCaptionsKey",id:"common-call-composite-captions-button",text:d.strings.call.liveCaptionsLabel,iconProps:{iconName:"CaptionsIcon",styles:{root:{lineHeight:0}}},itemProps:{styles:lh},disabled:t.disableButtonsForHoldScreen,subMenuProps:{id:"captions-contextual-menu",items:Z,calloutProps:{preventDismissOnEvent:YS}},submenuIconProps:{iconName:"HorizontalGalleryRightButton",styles:z}}),Z.push({key:"ToggleCaptionsKey",id:"common-call-composite-captions-toggle-button",text:p.checked?d.strings.call.startCaptionsButtonTooltipOnContent:d.strings.call.startCaptionsButtonTooltipOffContent,onClick:()=>{p.checked?p.onStopCaptions():p.currentSpokenLanguage!==""?g():t.onCaptionsSettingsClick&&t.onCaptionsSettingsClick()},iconProps:{iconName:p.checked?"CaptionsOffIcon":"CaptionsIcon",styles:{root:{lineHeight:0}}},itemProps:{styles:lh},disabled:t.disableButtonsForHoldScreen}),t.onCaptionsSettingsClick&&Z.push({key:"openCaptionsSettingsKey",id:"common-call-composite-captions-settings-button",text:d.strings.call.captionsSettingsLabel,onClick:t.onCaptionsSettingsClick,iconProps:{iconName:"CaptionsSettingsIcon",styles:{root:{lineHeight:0}}},itemProps:{styles:lh},disabled:t.disableButtonsForHoldScreen||!p.checked})}const H={key:"dtmfDialerScreenKey",itemProps:{styles:lh},text:F?d.strings.call.dtmfDialerMoreButtonLabelOff:d.strings.call.dtmfDialerMoreButtonLabelOn,onClick:()=>{t.onSetDialpadPage&&t.onSetDialpadPage(),x(!F)},iconProps:{iconName:"DtmfDialpadButton",styles:{root:{lineHeight:0}}}};t.onSetDialpadPage&&I&&(t.callControls===!0||((o=t.callControls)===null||o===void 0?void 0:o.dtmfDialerButton)!==!1)&&L.push(H);const j={key:"phoneCallKey",itemProps:{styles:lh},text:d.strings.call.phoneCallMoreButtonLabel,onClick:()=>{t.onMeetingPhoneInfoClick&&t.onMeetingPhoneInfoClick()},iconProps:{iconName:"PhoneNumberButton",styles:{root:{lineHeight:0}}}};if(t.teamsMeetingPhoneCallEnable&&w&&D&&L.push(j),t.onUserSetOverflowGalleryPositionChange){const Z={key:"overflowGalleryPositionKey",iconProps:{iconName:"GalleryOptions",styles:{root:{lineHeight:0}}},itemProps:{styles:lh},submenuIconProps:{styles:z},text:d.strings.call.moreButtonGalleryControlLabel,disabled:t.disableButtonsForHoldScreen,subMenuProps:{items:[{key:"dynamicSelectionKey",text:d.strings.call.moreButtonGalleryFloatingLocalLayoutLabel,canCheck:!0,itemProps:{styles:lh},isChecked:t.userSetGalleryLayout==="floatingLocalVideo",onClick:()=>{t.onUserSetGalleryLayout&&t.onUserSetGalleryLayout("floatingLocalVideo"),y(!1)},iconProps:{iconName:"FloatingLocalVideoGalleryLayout",styles:{root:{lineHeight:0}}}},{key:"speakerSelectionKey",text:d.strings.call.moreButtonGallerySpeakerLayoutLabel,canCheck:!0,itemProps:{styles:lh},isChecked:t.userSetGalleryLayout==="speaker",onClick:()=>{t.onUserSetGalleryLayout&&t.onUserSetGalleryLayout("speaker"),y(!1)},iconProps:{iconName:"SpeakerGalleryLayout",styles:{root:{lineHeight:0}}}},{key:"focusedContentSelectionKey",text:d.strings.call.moreButtonGalleryFocusedContentLayoutLabel,canCheck:!0,itemProps:{styles:lh},isChecked:f,onClick:()=>{var re;f===!1?(C((re=t.userSetGalleryLayout)!==null&&re!==void 0?re:"floatingLocalVideo"),t.onUserSetGalleryLayout&&t.onUserSetGalleryLayout("focusedContent"),y(!0)):(t.onUserSetGalleryLayout&&t.onUserSetGalleryLayout(T),y(!1))},iconProps:{iconName:"FocusedContentGalleryLayout",styles:{root:{lineHeight:0}}}}],calloutProps:{preventDismissOnEvent:YS}}};(t.callControls===!0||((l=t.callControls)===null||l===void 0?void 0:l.galleryControlsButton)!==!1)&&L.push(Z)}const J=$.useMemo(()=>r6e(J8(typeof t.callControls=="object"?t.callControls:void 0),typeof t.callControls=="object"?t.callControls.displayType:void 0),[t.callControls]);return J.primary.slice(Pk.MAX_PRIMARY_DESKTOP_CUSTOM_BUTTONS).forEach(Z=>{L.push(Object.assign({itemProps:{styles:lh}},Z))}),J.secondary.slice(Pk.MAX_SECONDARY_DESKTOP_CUSTOM_BUTTONS).forEach(Z=>{L.push(Object.assign({itemProps:{styles:lh}},Z))}),J.overflow.forEach(Z=>{L.push(Object.assign({itemProps:{styles:lh}},Z))}),U.createElement(IX,Object.assign({},t,{"data-ui-id":"common-call-composite-more-button",strings:B,menuIconProps:{hidden:!0},menuProps:{shouldFocusOnContainer:!1,items:L,calloutProps:{preventDismissOnEvent:YS}}}))},h6e=()=>U.createElement(YE,{iconName:"DtmfDialpadButton"}),zni=t=>{const{strings:e,onRenderOnIcon:i,onRenderOffIcon:r,onClick:o,displayType:l}=t,d=hc(),h=ks(),p={label:h.strings.call.dtmfDialerButtonLabel,tooltipOnContent:h.strings.call.dtmfDialerButtonTooltipOn,tooltipOffContent:h.strings.call.dtmfDialerButtonTooltipOff},g=$.useMemo(()=>{var f;return Ds({rootChecked:{background:d.palette.neutralLight}},(f=t.styles)!==null&&f!==void 0?f:{})},[t.styles,d.palette.neutralLight]);return U.createElement(Jy,Object.assign({},t,{strings:e||p,showLabel:l!=="compact",labelKey:"dtmfDialpadButtonLabelKey",onRenderOnIcon:i??h6e,onRenderOffIcon:r??h6e,onClick:o,styles:g}))},Vni=t=>U.createElement(Jy,Object.assign({"data-ui-id":"call-composite-exit-spotlight-button",labelKey:"exitSpotlightButtonLabelKey",showLabel:t.displayType!=="compact",onRenderIcon:()=>U.createElement(Hm,{iconName:"ControlButtonExitSpotlight"}),onClick:t.onClick},t)),EP={rightPositionPx:16,bottomPositionPx:64,widthPx:88,heightPx:128},$ni=t=>({modal:{main:Object.assign(Object.assign({borderRadius:t.effects.roundedCorner4,boxShadow:t.effects.elevation8,zIndex:2},t.rtl?{left:_n(EP.rightPositionPx)}:{right:_n(EP.rightPositionPx)}),{bottom:_n(EP.bottomPositionPx)})}}),p6e={root:{position:"absolute",width:"100%",height:"100%",pointerEvents:"none",":focus-within":{outline:"1px solid #00000000"}}},Hni=Ds(p6e,{root:{display:"none"}}),jni={main:{minWidth:"min-content",minHeight:"min-content",position:"absolute",overflow:"hidden",pointerEvents:"auto",touchAction:"none"},root:{width:"100%",height:"100%",pointerEvents:"none",":focus-within":{outline:"3px solid #00000000",outlineOffset:"-3px"}}},Gni={display:"flex",position:"absolute",left:0,top:0,width:"100%",height:"100%",overflow:"hidden",zIndex:"100000",pointerEvents:"none"},MX=t=>t!==null&&typeof t=="boolean",qni=(t,e)=>{const i=$.useRef(document.getElementById(t)),r=nF(i),o=_8(i),l=$.useMemo(()=>r===void 0||o===void 0?void 0:{x:EP.rightPositionPx-r+EP.widthPx,y:-1*o+EP.heightPx+EP.bottomPositionPx},[o,r,e]),d=$.useMemo(()=>r===void 0?void 0:{x:EP.rightPositionPx,y:EP.bottomPositionPx},[r,e]);return{minDragPosition:l,maxDragPosition:d}},g6e=t=>Math.floor(m6e(t)/60),m6e=t=>Math.floor(t/1e3),Wni=t=>Math.floor(g6e(t)/60),f6e=t=>{const e=Wni(t),i=("0"+g6e(t)%60).slice(-2),r=("0"+m6e(t)%60).slice(-2);return`${e>0?e+":":""}${i}:${r}`},Kni=t=>{const{timeStampInfo:e}=t,i=new Date(e).getTime(),r=hc(),[o,l]=$.useState(0),d=f6e(o);return U.useEffect(()=>{const h=setInterval(()=>{l(Math.max(i-Date.now(),0))},10);return()=>{clearInterval(h)}},[i]),U.createElement(Et,{horizontal:!0,className:Jni(r),tokens:{childrenGap:"0.5rem"}},U.createElement(_M,{iconName:"Clock",className:Yni}),U.createElement(ja,{styles:Qni},d))},Jni=t=>It({backgroundColor:t.palette.neutralLight,display:"flex",alignItems:"center",borderColor:t.palette.neutralQuaternaryAlt,borderWidth:"0.0625rem",borderRadius:"0.25rem",padding:"0.5rem"}),Yni=It({fontSize:18}),Qni={root:{color:"inherit",fontWeight:400,fontSize:_n(14),lineHeight:_n(20),margin:"auto"}};var kfe=function(t,e,i,r){function o(l){return l instanceof i?l:new i(function(d){d(l)})}return new(i||(i=Promise))(function(l,d){function h(f){try{g(r.next(f))}catch(y){d(y)}}function p(f){try{g(r.throw(f))}catch(y){d(y)}}function g(f){f.done?l(f.value):o(f.value).then(h,p)}g((r=r.apply(t,e||[])).next())})};const Zni=(t,e)=>{if(e===!1)return!1;const i=e===!0||e===void 0?{}:e;return t&&(i.displayType="compact",i.screenShareButton=!1),i},Xni=t=>{var e,i,r,o,l,d,h,p,g,f,y,T,C;const E=hc(),I=E.rtl,w=$.useRef(null),D=$.useRef(null),F=$.useRef(null),[x,B]=$.useState(0),[L,z]=$.useState(0),[H,j]=$.useState(0),[J,Z]=$.useState(0),[re,ne]=$.useState(!1),le=d6e(),he=Zni(t.mobileView,t.callControls),[Me,Le]=$.useState(!1),pe=(e=qn(qt=>{var ri,Ti;return(Ti=(ri=qt.call)===null||ri===void 0?void 0:ri.capabilitiesFeature)===null||Ti===void 0?void 0:Ti.capabilities.hangUpForEveryOne.isPresent}))!==null&&e!==void 0?e:!0,te=qn(Fje),Se=qn(Uje),ce=qn(zje),X=$.useCallback(()=>{B(w.current?w.current.offsetWidth:0),z(D.current?D.current.offsetWidth:0),j(F.current?F.current.offsetWidth:0)},[]);$.useEffect(()=>{B(w.current?w.current.offsetWidth:0),z(D.current?D.current.offsetWidth:0),j(F.current?F.current.offsetWidth:0)},[]),$.useEffect(()=>(window.addEventListener("resize",X),()=>window.removeEventListener("resize",X)),[X]),$.useEffect(()=>{Z((H-x)/2+x+L)},[x,L,H]),$.useEffect(()=>{ne(J>H)},[J,H]);const ve=$.useCallback(()=>{Le(!0)},[]),Te=$.useCallback(()=>{Le(!1)},[]),Be=$.useMemo(()=>({label:le.peopleButtonLabel,selectedLabel:le.selectedPeopleButtonLabel,tooltipOpenAriaLabel:le.peopleButtonTooltipOpenAriaLabel,tooltipCloseAriaLabel:le.peopleButtonTooltipCloseAriaLabel,tooltipOffContent:le.peopleButtonTooltipOpen,tooltipOnContent:le.peopleButtonTooltipClose}),[le]),qe=$.useMemo(()=>({label:le.moreDrawerButtonLabel,tooltipContent:le.moreDrawerButtonTooltip}),[le]),Ge=ks().strings.call,tt=$.useMemo(()=>({label:Ge.exitSpotlightButtonLabel,tooltipContent:Ge.exitSpotlightButtonTooltip}),[Ge]),[ct,Mt]=$.useState(!1),ht=$.useCallback(()=>kfe(void 0,void 0,void 0,function*(){yield t.callAdapter.startNoiseSuppressionEffect()}),[t.callAdapter]),vt=qn(_X),Pt=CX(vt);$.useEffect(()=>{t.callAdapter.getState().onResolveDeepNoiseSuppressionDependency&&t.callAdapter.getState().deepNoiseSuppressionOnByDefault&&(ht(),Mt(!0))},[t.callAdapter,ht]);const ni=!!(t.callAdapter.getState().onResolveDeepNoiseSuppressionDependency&&!t.callAdapter.getState().hideDeepNoiseSuppressionButton&&!Pt),Zt=$.useCallback(()=>kfe(void 0,void 0,void 0,function*(){ct?(yield t.callAdapter.stopNoiseSuppressionEffect(),Mt(!1)):(yield t.callAdapter.startNoiseSuppressionEffect(),Mt(!0))}),[t.callAdapter,ct]),it=$.useMemo(()=>{const qt=t.mobileView?{}:eai;return Rw(qt,{root:{background:E.semanticColors.bodyBackground}})},[t.mobileView,E.semanticColors.bodyBackground]),Ke=$.useMemo(()=>t.mobileView?void 0:nai(E),[t.mobileView,E]),ot=$.useMemo(()=>t.mobileView?void 0:Rfe(E),[t.mobileView,E]),Ht=$.useMemo(()=>t.mobileView?void 0:aai(E),[t.mobileView,E]),jt=$.useMemo(()=>!t.mobileView&&!re?I?iai:tai:{},[t.mobileView,I,re]),Nt=$.useMemo(()=>!t.mobileView&&!re?{position:"relative",minHeight:"4.5rem",width:"100%",display:"flex",alignItems:"center",paddingLeft:"1rem"}:{},[t.mobileView,re]),Vt=$.useMemo(()=>a6e(J8(he!==!1?he:void 0),he!==!1?he?.displayType:void 0),[he]),$t=qn(s6e),dt=qn(Y8),yt=dt.callStatus!=="Connected"||!$t?.capabilities||$t.capabilities.useReactions.isPresent,kt=ce&&ce.disableReturnToMainMeeting===!1,je=$.useCallback(()=>t.callAdapter.returnFromBreakoutRoom(),[t.callAdapter]);if(he===!1)return U.createElement(U.Fragment,null);const Ae=t_(he.peopleButton)||t_(he.chatButton)||Vt.secondary!==void 0,xe=t_(he?.screenShareButton),gt=t_(he?.microphoneButton),Ye=t_(he?.cameraButton),Fe=he?.exitSpotlightButton!==!1,St=t.isCaptionsSupported&&t_(he.captionsButton),Wt=t_(he?.teamsMeetingPhoneCallButton),Ii=t_(he?.moreButton)&&(t_(he?.holdButton)||St||t.onUserSetGalleryLayout),en=(i=t.callAdapter.getState().call)===null||i===void 0?void 0:i.role,sn=t.callAdapter.getState().isRoomsCall&&en&&["Consumer","Unknown"].includes(en),Qi=t.callAdapter.getState().reactions;return U.createElement("div",{ref:F},U.createElement(mfe,{adapter:t.callAdapter},Me&&U.createElement(Hje,{showCaptionsSettingsModal:Me,onDismissCaptionsSettings:Te,changeCaptionLanguage:t.isCaptionsOn&&t.useTeamsCaptions}),t.teamsMeetingConferenceModalPresent&&U.createElement($Yt,{conferencePhoneInfoList:(l=(o=(r=t.callAdapter.getState().call)===null||r===void 0?void 0:r.meetingConference)===null||o===void 0?void 0:o.conferencePhones)!==null&&l!==void 0?l:[],showModal:t.teamsMeetingConferenceModalPresent,onDismissMeetingPhoneInfoSettings:t.onToggleTeamsMeetingConferenceModal})),U.createElement(Et,{horizontal:!0,reversed:!t.mobileView&&!re,horizontalAlign:"space-between",className:It(e6e,Xje,Nt)},U.createElement(Et.Item,{grow:!0,className:It(jt)},U.createElement(mfe,{adapter:t.callAdapter},U.createElement(Et,{horizontalAlign:"center"},U.createElement(Et.Item,null,U.createElement("div",{ref:w},U.createElement(Lme,{layout:t.displayVertical?"vertical":"horizontal",styles:it},!t.mobileView&&Se&&Se.state==="open"&&!ce&&U.createElement(SE,{text:Ge.joinBreakoutRoomButtonLabel,onClick:()=>kfe(void 0,void 0,void 0,function*(){Se.join()}),styles:ot}),gt&&U.createElement(Yje,{displayType:he.displayType,styles:ot,splitButtonsForDeviceSelection:!t.mobileView,disabled:t.disableButtonsForHoldScreen||tm(he.microphoneButton),disableTooltip:t.mobileView,onClickNoiseSuppression:Zt,isDeepNoiseSuppressionOn:ct,showNoiseSuppressionButton:ni}),Ye&&U.createElement(Wje,{displayType:he.displayType,styles:ot,splitButtonsForDeviceSelection:!t.mobileView,disabled:t.disableButtonsForHoldScreen||tm(he.cameraButton),onClickVideoEffects:t.onClickVideoEffects,componentRef:t.cameraButtonRef,disableTooltip:t.mobileView}),!t.mobileView&&yt&&t_(he.reactionButton)&&Qi&&U.createElement(o6e,{displayType:he.displayType,styles:ot,disabled:t.disableButtonsForHoldScreen,reactionResource:Qi}),!t.mobileView&&t_(he.raiseHandButton)&&!sn&&U.createElement(n6e,{displayType:he.displayType,styles:ot,disabled:t.disableButtonsForHoldScreen||tm(he.microphoneButton)}),rai(he)&&t.onSetDialpadPage!==void 0&&U.createElement(zni,{styles:ot,displayType:he.displayType,onClick:()=>{t.onSetDialpadPage!==void 0&&t.onSetDialpadPage()}}),Fe&&t.onStopLocalSpotlight&&U.createElement(Vni,{displayType:he.displayType,onClick:t.onStopLocalSpotlight,styles:ot,strings:tt}),xe&&U.createElement(Qje,{option:he.screenShareButton,displayType:he.displayType,styles:Ke,disabled:t.disableButtonsForHoldScreen||tm(he.screenShareButton)}),(d=Vt.primary)===null||d===void 0?void 0:d.slice(0,t.mobileView?Pk.MAX_PRIMARY_MOBILE_CUSTOM_BUTTONS:Pk.MAX_PRIMARY_DESKTOP_CUSTOM_BUTTONS).map((qt,ri)=>U.createElement(qt,{key:`primary-custom-button-${ri}`,styles:ot,showLabel:he.displayType!=="compact",disableTooltip:t.mobileView})),t.mobileView&&U.createElement(IX,{"data-ui-id":"common-call-composite-more-button",strings:qe,onClick:t.onMoreButtonClicked,disabled:t.disableButtonsForLobbyPage,disableTooltip:t.mobileView}),!t.mobileView&&Ii&&U.createElement(Uni,{disableButtonsForHoldScreen:t.disableButtonsForHoldScreen,styles:ot,onClickShowDialpad:t.onClickShowDialpad,callControls:t.callControls,isCaptionsSupported:St,onCaptionsSettingsClick:ve,onUserSetOverflowGalleryPositionChange:t.onUserSetOverflowGalleryPositionChange,onUserSetGalleryLayout:t.onUserSetGalleryLayout,userSetGalleryLayout:t.userSetGalleryLayout,dtmfDialerPresent:t.dtmfDialerPresent,onSetDialpadPage:t.onSetDialpadPage,teamsMeetingPhoneCallEnable:Wt,onMeetingPhoneInfoClick:t.onToggleTeamsMeetingConferenceModal}),U.createElement(Jje,{displayType:"compact",mobileView:t.mobileView,styles:Ht,enableEndCallMenu:!MX(t.callControls)&&!MX((h=t.callControls)===null||h===void 0?void 0:h.endCallButton)&&!t.mobileView&&pe&&!te&&((g=(p=t.callControls)===null||p===void 0?void 0:p.endCallButton)===null||g===void 0?void 0:g.hangUpForEveryone)==="endCallOptions"&&dt.callStatus==="Connected"&&!kt,disableEndCallModal:!MX(t.callControls)&&!MX((f=t.callControls)===null||f===void 0?void 0:f.endCallButton)&&((T=(y=t.callControls)===null||y===void 0?void 0:y.endCallButton)===null||T===void 0?void 0:T.disableEndCallModal),returnFromBreakoutRoom:kt?je:void 0}))))))),!t.mobileView&&Ae&&U.createElement(Et.Item,null,U.createElement("div",{ref:D},U.createElement(Et,{horizontal:!0,className:t.mobileView?void 0:It(v6e)},t_(he?.peopleButton)&&U.createElement(Nni,{checked:t.peopleButtonChecked,ariaLabel:Be.label,showLabel:he.displayType!=="compact",onClick:t.onPeopleButtonClicked,"data-ui-id":"common-call-composite-people-button",disabled:t.disableButtonsForLobbyPage||t.disableButtonsForHoldScreen||tm(he.peopleButton),strings:Be,styles:ot,componentRef:t.peopleButtonRef,chatButtonPresent:t_(he.chatButton),peoplePaneDismissButtonRef:t.sidePaneDismissButtonRef}),(C=Vt.secondary)===null||C===void 0?void 0:C.slice(0,Pk.MAX_SECONDARY_DESKTOP_CUSTOM_BUTTONS).map((qt,ri)=>U.createElement(qt,{key:`secondary-custom-button-${ri}`,styles:ot,showLabel:he.displayType!=="compact"}))))),ce?.roomEndTime&&!t.mobileView&&!re&&U.createElement(Et.Item,null,U.createElement(Kni,{timeStampInfo:ce?.roomEndTime.toString()}))))},v6e={padding:"0.75rem",columnGap:"0.5rem"},eai={root:v6e},tai={position:"absolute",left:"50%",transform:"translate(-50%, 0)"},iai={position:"absolute",right:"50%",transform:"translate(-50%, 0)"},Rfe=t=>({root:{border:`solid 1px ${t.palette.neutralQuaternaryAlt}`,borderRadius:t.effects.roundedCorner4,minHeight:"2.5rem",maxWidth:"12rem"},flexContainer:{display:"flex",flexFlow:"row nowrap"},textContainer:{display:"inline",maxWidth:"100%"},label:{fontSize:t.fonts.medium.fontSize,marginLeft:"0.625rem",lineHeight:"1.5rem",display:"block",textOverflow:"ellipsis",whiteSpace:"nowrap",overflow:"hidden"},splitButtonMenuButton:{border:`solid 1px ${t.palette.neutralQuaternaryAlt}`,borderTopRightRadius:t.effects.roundedCorner4,borderBottomRightRadius:t.effects.roundedCorner4,borderTopLeftRadius:"0",borderBottomLeftRadius:"0"},splitButtonMenuButtonChecked:{background:"none"}}),nai=t=>{const e={border:"none",background:t.palette.themePrimary,color:t.palette.white,"* > svg":{fill:t.palette.white},"@media (forced-colors: active)":{border:"1px solid",borderColor:t.palette.black}},i={rootChecked:e,rootCheckedHovered:e};return Ds(Rfe(t),i)},aai=t=>{const e={root:{border:"none"},rootFocused:{"@media (forced-colors: active)":{background:"highlight",color:"highlightText",borderColor:t.palette.black,borderRadius:"unset",outline:`3px solid ${t.palette.black}`}},icon:{"@media (forced-colors: active)":{":focused":{color:t.palette.white}}}};return Ds(Rfe(t),e)},t_=t=>t!==!1,rai=t=>t.moreButton===!1&&t.dtmfDialerButton!==!1,y6e=t=>({root:{overflow:"auto"},drawerSurfaceStyles:{drawerContentContainer:{root:{span:{fontWeight:400,fontSize:_n(14),lineHeight:_n(22),color:t.palette.neutralDark}}}}}),oai=t=>{var e;const i=Cs(),r=$.useCallback(d=>{t.selectLanguage(d)},[t]),o=$.useMemo(()=>{var d;return Fx((d=t.supportedLanguageStrings)!==null&&d!==void 0?d:[]).map(h=>({itemKey:h,text:t.supportedLanguageStrings?t.supportedLanguageStrings[h]:h,onItemClick:()=>r(h),secondaryIconProps:t.currentLanguage===h?{iconName:"Accept"}:void 0}))},[t.currentLanguage,t.supportedLanguageStrings,r]),l=$.useMemo(()=>[...o].sort((h,p)=>h.text&&p.text&&h.text>p.text?1:-1),[o]);return U.createElement(sF,{heading:(e=t.strings)===null||e===void 0?void 0:e.menuTitle,items:l??[],onLightDismiss:()=>{t.setCurrentLanguage(t.currentLanguage),t.onLightDismiss()},styles:y6e(i)})},sai=(t,e)=>e?{root:{margin:0},pill:{backgroundColor:`${t.palette.themePrimary} !important`},thumb:{backgroundColor:`${t.palette.white} !important`}}:{root:{margin:0}},lai=t=>{var e;const i=Cs(),r=$.useCallback(d=>{t.selectLanguage(d)},[t]),o=$.useMemo(()=>{var d;return Fx((d=t.supportedLanguageStrings)!==null&&d!==void 0?d:[]).map(h=>({itemKey:h,text:t.supportedLanguageStrings?t.supportedLanguageStrings[h]:h,onItemClick:()=>r(h),secondaryIconProps:t.currentLanguage===h?{iconName:"Accept"}:void 0}))},[t.currentLanguage,t.supportedLanguageStrings,r]),l=$.useMemo(()=>[...o].sort((h,p)=>h.text&&p.text&&h.text>p.text?1:-1),[o]);return U.createElement(sF,{heading:(e=t.strings)===null||e===void 0?void 0:e.menuTitle,items:l??[],onLightDismiss:()=>{t.setCurrentLanguage(t.currentLanguage),t.onLightDismiss()},styles:y6e(i)})};var S6e=function(t,e,i,r){function o(l){return l instanceof i?l:new i(function(d){d(l)})}return new(i||(i=Promise))(function(l,d){function h(f){try{g(r.next(f))}catch(y){d(y)}}function p(f){try{g(r.throw(f))}catch(y){d(y)}}function g(f){f.done?l(f.value):o(f.value).then(h,p)}g((r=r.apply(t,e||[])).next())})};const cai=t=>t===!1?!1:t===!0||t===void 0?{}:t,dai=t=>{var e,i,r,o,l;const d=hc(),h=QE(),p=[],{speakers:g,onSelectSpeaker:f,onLightDismiss:y}=t,T=ks(),C=mc($8),E=qn(V4),I=qn(Ife),w=wfe(E,I,t.dtmfDialerOptions),[D,F]=$.useState((e=t.dtmfDialerPresent)!==null&&e!==void 0?e:!1),x=mc(z8),B=EX(h.getState()),L=$.useCallback((ht,vt)=>{const Pt=g?.find(ni=>ni.id===vt);Pt&&f(Pt),y()},[g,f,y]),z=cai(t.callControls),H=t.isCaptionsSupported&&z!==!1&&vF(z.captionsButton);t.reactionResources!==void 0&&p.push({itemKey:"reactions",onRendererContent:()=>U.createElement(aWt,{onReactionClick:ht=>S6e(void 0,void 0,void 0,function*(){var vt;(vt=t.onReactionClick)===null||vt===void 0||vt.call(t,ht),y()}),reactionResources:t.reactionResources})}),t.speakers&&t.speakers.length>0&&p.push({itemKey:"speakers",disabled:t.disableButtonsForHoldScreen,text:t.strings.speakerMenuTitle,iconProps:{iconName:"MoreDrawerSpeakers"},subMenuProps:t.speakers.map(ht=>({itemKey:ht.id,iconProps:{iconName:PX(ht,t.selectedSpeaker)?"MoreDrawerSelectedSpeaker":"MoreDrawerSpeakers"},text:ht.name,onItemClick:L,secondaryIconProps:PX(ht,t.selectedSpeaker)?{iconName:"Accept"}:void 0})),secondaryText:(i=t.selectedSpeaker)===null||i===void 0?void 0:i.name});const{microphones:j,onSelectMicrophone:J}=t,Z=$.useCallback((ht,vt)=>{const Pt=j?.find(ni=>ni.id===vt);Pt&&J(Pt),y()},[j,J,y]);if(t.microphones&&t.microphones.length>0){const ht=t.speakers&&t.speakers.length>0,vt=ht?"microphones":"audioDevices",Pt=ht?t.strings.microphoneMenuTitle:t.strings.audioDeviceMenuTitle,ni=ht?"MoreDrawerMicrophones":"MoreDrawerSpeakers",Zt=ht?"MoreDrawerSelectedMicrophone":"MoreDrawerSelectedSpeaker";p.push({itemKey:vt,disabled:t.disableButtonsForHoldScreen,text:Pt,iconProps:{iconName:ni},subMenuProps:t.microphones.map(it=>({itemKey:it.id,iconProps:{iconName:PX(it,t.selectedMicrophone)?Zt:ni},text:it.name,onItemClick:Z,secondaryIconProps:PX(it,t.selectedMicrophone)?{iconName:"Accept"}:void 0,disabled:z!==!1?tm(z.microphoneButton):void 0})),secondaryText:(r=t.selectedMicrophone)===null||r===void 0?void 0:r.name})}const re={itemKey:"dtmfDialerScreenKey",text:D?T.strings.call.dtmfDialerMoreButtonLabelOff:T.strings.call.dtmfDialerMoreButtonLabelOn,onItemClick:()=>{t.onSetDialpadPage&&t.onSetDialpadPage(),F(!D),y()},iconProps:{iconName:"DtmfDialpadButton",styles:{root:{lineHeight:0}}}};t.onSetDialpadPage&&w&&z!==!1&&vF(z.dtmfDialerButton)&&p.push(re);const ne={itemKey:"galleryPositionKey",iconProps:{iconName:"GalleryOptions",styles:{root:{lineHeight:0}}},disabled:t.disableButtonsForHoldScreen,text:T.strings.call.moreButtonGalleryControlLabel,subMenuProps:[{itemKey:"dynamicSelectionKey",text:T.strings.call.moreButtonGalleryFloatingLocalLayoutLabel,onItemClick:()=>{t.onUserSetGalleryLayout&&t.onUserSetGalleryLayout("floatingLocalVideo"),y()},iconProps:{iconName:"FloatingLocalVideoGalleryLayout",styles:{root:{lineHeight:0}}},secondaryIconProps:t.userSetGalleryLayout==="floatingLocalVideo"?{iconName:"Accept"}:void 0},{itemKey:"focusedContentSelectionKey",text:T.strings.call.moreButtonGalleryFocusedContentLayoutLabel,onItemClick:()=>{t.onUserSetGalleryLayout&&t.onUserSetGalleryLayout("focusedContent"),y()},iconProps:{iconName:"FocusedContentGalleryLayout",styles:{root:{lineHeight:0}}},secondaryIconProps:t.userSetGalleryLayout==="focusedContent"?{iconName:"Accept"}:void 0}]};z!==!1&&vF(z?.galleryControlsButton)&&p.push(ne),z!==!1&&vF(z?.peopleButton)&&p.push({itemKey:"people",id:"call-composite-drawer-people-button",text:t.strings.peopleButtonLabel,iconProps:{iconName:"MoreDrawerPeople"},onItemClick:t.onPeopleButtonClicked,disabled:tm(z.peopleButton)||t.disableButtonsForHoldScreen}),z!==!1&&vF(z?.holdButton)&&p.push({itemKey:"holdButtonKey",disabled:t.disableButtonsForHoldScreen||tm(z.holdButton),text:T.component.strings.holdButton.tooltipOffContent,onItemClick:()=>{C.onToggleHold(),y()},iconProps:{iconName:"HoldCallContextualMenuItem",styles:{root:{lineHeight:0}}}});const le=(o=h.getState().call)===null||o===void 0?void 0:o.role,he=h.getState().isRoomsCall&&le&&["Consumer","Unknown"].includes(le);if(z!==!1&&vF(z?.raiseHandButton)&&!he){const ht=x.checked?"LowerHandContextualMenuItem":"RaiseHandContextualMenuItem";p.push({itemKey:"raiseHandButtonKey",disabled:t.disableButtonsForHoldScreen||tm(z.raiseHandButton),text:x.checked?T.component.strings.raiseHandButton.onLabel:T.component.strings.raiseHandButton.offLabel,onItemClick:()=>{x.onToggleRaiseHand&&x.onToggleRaiseHand(),y()},iconProps:{iconName:ht,styles:{root:{lineHeight:0}}}})}const Me=AX(h.getState());z!==!1&&vF(z?.teamsMeetingPhoneCallButton)&&B&&Me&&p.push({itemKey:"phoneCallInfoKey",disabled:tm(z.teamsMeetingPhoneCallButton),text:T.strings.call.phoneCallMoreButtonLabel,onItemClick:()=>{var ht;(ht=t.onClickMeetingPhoneInfo)===null||ht===void 0||ht.call(t),y()},iconProps:{iconName:"PhoneNumberButton",styles:{root:{lineHeight:0}}}});const Le=ks().strings.call.spokenLanguageStrings,pe=ks().strings.call.captionLanguageStrings,te=mc(aX),Se=mc(iX),[ce,X]=$.useState(!1),[ve,Te]=$.useState(!1),[Be,qe]=$.useState(te.currentSpokenLanguage&&te.currentSpokenLanguage!==""?te.currentSpokenLanguage:"en-us"),[Ge,tt]=$.useState((l=te.currentCaptionLanguage)!==null&&l!==void 0?l:nX[Be]),ct=$.useCallback(()=>S6e(void 0,void 0,void 0,function*(){te.isCaptionsFeatureActive?Se.onStopCaptions():yield Se.onStartCaptions({spokenLanguage:Be})}),[te.isCaptionsFeatureActive,Se,Be]);if(H){const ht=[],vt=Le?Le[Be]:Be;if(p.push({itemKey:"captions",id:"common-call-composite-captions-button",disabled:t.disableButtonsForHoldScreen,text:t.strings.captionsMenuTitle,iconProps:{iconName:"CaptionsIcon"},subMenuProps:ht}),ht.push({itemKey:"ToggleCaptionsKey",text:te.isCaptionsFeatureActive?T.strings.call.startCaptionsButtonTooltipOnContent:T.strings.call.startCaptionsButtonTooltipOffContent,iconProps:{iconName:te.isCaptionsFeatureActive?"CaptionsOffIcon":"CaptionsIcon",styles:{root:{lineHeight:0}}},onItemClick:ct,disabled:t.disableButtonsForHoldScreen,secondaryComponent:U.createElement(Et,{verticalFill:!0,verticalAlign:"center"},U.createElement(tAe,{id:"common-call-composite-captions-toggle-button",checked:te.isCaptionsFeatureActive,styles:sai(d,te.isCaptionsFeatureActive),onChange:ct}))}),ht.push({itemKey:"ChangeSpokenLanguage",text:t.strings.spokenLanguageMenuTitle,id:"common-call-composite-captions-spoken-settings-button",secondaryText:vt,iconProps:{iconName:"ChangeSpokenLanguageIcon",styles:{root:{lineHeight:0}}},disabled:t.disableButtonsForHoldScreen||!te.isCaptionsFeatureActive,onItemClick:()=>{X(!0)},secondaryIconProps:{iconName:"ChevronRight",styles:{root:{lineHeight:0}}}}),t.useTeamsCaptions){const Pt=pe?pe[Ge]:Ge;ht.push({itemKey:"ChangeCaptionLanguage",text:t.strings.captionLanguageMenuTitle,id:"common-call-composite-captions-subtitle-settings-button",secondaryText:Pt,iconProps:{iconName:"ChangeCaptionLanguageIcon",styles:{root:{lineHeight:0}}},disabled:t.disableButtonsForHoldScreen||!te.isCaptionsFeatureActive,onItemClick:()=>{Te(!0)},secondaryIconProps:{iconName:"ChevronRight",styles:{root:{lineHeight:0}}}})}}const Mt=$.useMemo(()=>Mni(J8(z!==!1?z:void 0),z!==!1?z?.displayType:void 0),[z]);return Mt.primary.slice(Pk.MAX_PRIMARY_MOBILE_CUSTOM_BUTTONS).forEach(ht=>{p.push(ht)}),Mt.secondary.forEach(ht=>{p.push(ht)}),Mt.overflow.forEach(ht=>{p.push(ht)}),U.createElement(U.Fragment,null,ce&&H&&U.createElement(lai,{onLightDismiss:t.onLightDismiss,selectLanguage:qe,setCurrentLanguage:te.onSetSpokenLanguage,currentLanguage:Be,strings:{menuTitle:t.strings.spokenLanguageMenuTitle},supportedLanguageStrings:Le}),ve&&H&&U.createElement(oai,{onLightDismiss:t.onLightDismiss,selectLanguage:tt,setCurrentLanguage:te.onSetCaptionLanguage,currentLanguage:Ge,strings:{menuTitle:t.strings.captionLanguageMenuTitle},supportedLanguageStrings:pe}),!ce&&!ve&&U.createElement(sF,{items:p,onLightDismiss:t.onLightDismiss}))},PX=(t,e)=>!!e&&t.id===e.id,vF=t=>t!==!1,uai=Xs([q8],t=>({microphones:t.microphones,speakers:t.speakers,selectedMicrophone:t.selectedMicrophone,selectedSpeaker:t.selectedSpeaker})),hai=t=>{const e=d6e(),i=$.useMemo(()=>({peopleButtonLabel:e.peopleButtonLabel,audioDeviceMenuTitle:e.moreDrawerAudioDeviceMenuTitle,microphoneMenuTitle:e.moreDrawerMicrophoneMenuTitle,speakerMenuTitle:e.moreDrawerSpeakerMenuTitle,captionsMenuTitle:e.moreDrawerCaptionsMenuTitle,spokenLanguageMenuTitle:e.moreDrawerSpokenLanguageMenuTitle,captionLanguageMenuTitle:e.moreDrawerCaptionLanguageMenuTitle,galleryOptionsMenuTitle:e.moreDrawerGalleryOptionsMenuTitle}),[e]),r=qn(uai),o=JA();return U.createElement(dai,Object.assign({},t,r,o,{strings:i}))},pai=1,b6e={height:"100%",width:"100%"},gai=It(Object.assign(Object.assign({},b6e),{minWidth:"20rem",minHeight:"16rem"})),mai=It(Object.assign(Object.assign({},b6e),{minWidth:"17.5rem",minHeight:"13rem"})),DX=(t=pai)=>({root:{position:"absolute",top:0,left:0,width:"100%",height:"100%",zIndex:t}}),fai=t=>({background:t.neutralLighterAlt}),T6e=.25;Ds({root:{width:"100%",height:"100%"}},{root:{display:"none"}});const C6e={root:{height:"3rem"}},Mfe={root:{border:"none",minWidth:"2.5rem",maxWidth:"2.875rem",height:"100%",background:"none",padding:"0 1rem"},rootChecked:{background:"none"},rootCheckedHovered:{background:"none"}},_6e=Ds(Mfe,{root:{visibility:"hidden"}}),E6e={root:{border:"none",borderBottom:"0.125rem solid transparent",width:"8rem",height:"100%",background:"none",padding:"0"},rootChecked:{background:"none"},rootCheckedHovered:{background:"none"},flexContainer:{flexFlow:"column",display:"contents"},label:{fontSize:"1rem",fontWeight:100,lineHeight:"2rem",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"},labelChecked:{fontWeight:600}},A6e={root:{display:"none"}},vai=(t,e)=>({root:{height:"auto",width:"100%",padding:`0.5rem ${T6e}rem`,maxWidth:t??"21.5rem",minWidth:e??`${aje+T6e*2}rem`}}),Pfe={root:{width:"100%",height:"100%"}},yai={childrenGap:"0.5rem"},Sai=t=>It({"@media (forced-colors: active)":{border:`0.125rem solid ${t.palette.black}`,borderRadius:t.effects.roundedCorner4,margin:"0.5rem 0.25rem 0.5rem 0rem"}}),I6e=$.createContext({}),bai=t=>U.createElement(I6e.Provider,{value:t},t.children),Dfe=()=>$.useContext(I6e),w6e=()=>{const{sidePaneRenderer:t,overrideSidePane:e}=Dfe();return!!(t||e?.isActive)},Q8=t=>{const e=w6e(),{sidePaneRenderer:i}=Dfe();return e&&i?.id===t},Tai=t=>{const{onClose:e,onChatButtonClicked:i,onPeopleButtonClicked:r,activeTab:o}=t,l=Cs(),d=ks().strings.call,h=i&&r,p=$.useMemo(()=>Ds(E6e,{root:{width:"100%"},label:{fontSize:l.fonts.medium.fontSize,fontWeight:l.fonts.medium.fontWeight}},h?{rootChecked:{borderBottom:`0.125rem solid ${l.palette.themePrimary}`}}:{}),[l,h]);return U.createElement(Et,{horizontal:!0,grow:!0,styles:C6e},U.createElement(th,{ariaLabel:d.returnToCallButtonAriaLabel,ariaDescription:d.returnToCallButtonAriaDescription,onClick:e,styles:Mfe,onRenderIcon:()=>U.createElement(gF,{iconName:"ChevronLeft"}),autoFocus:!0}),U.createElement(Et.Item,{grow:!0,role:"tablist"},U.createElement(hA,{direction:Lm.horizontal,className:It(Pfe.root)},U.createElement(Et,{horizontal:!0,styles:Pfe},U.createElement(Et.Item,{grow:!0},i&&U.createElement(th,{onClick:i,styles:p,checked:o==="chat","aria-selected":o==="chat",role:"tab",disabled:t.disableChatButton},d.chatButtonLabel)),U.createElement(Et.Item,{grow:!0},r&&U.createElement(th,{onClick:r,styles:p,checked:o==="people","aria-selected":o==="people",role:"tab",disabled:t.disablePeopleButton},d.peopleButtonLabel))))),U.createElement(th,{styles:_6e,onRenderIcon:()=>U.createElement(gF,{iconName:"ChevronLeft"})}))},k6e=t=>{var e;const{sidePaneRenderer:i,overrideSidePane:r}=Dfe(),l=r?.renderer.contentRenderer&&r.persistRenderingWhenClosed&&!r.isActive&&!i,d=$.useMemo(()=>vai(t.maxWidth,t.minWidth),[t.maxWidth,t.minWidth]),h=l?A6e:t.mobileView?Pfe:d,p=(e=r?.isActive?r.renderer.headerRenderer:i?.headerRenderer)!==null&&e!==void 0?e:R6e,g=r?.isActive?r.renderer.id:void 0,{updateSidePaneRenderer:f}=t,y=$.useCallback(()=>{f(void 0)},[f]),T=$.useMemo(()=>{var D;return U.createElement(Tai,{onClose:g==="chat"?(D=t.onChatButtonClicked)!==null&&D!==void 0?D:Lfe:y,activeTab:i?.id==="people"?"people":"chat",disablePeopleButton:t.disablePeopleButton,disableChatButton:t.disableChatButton,onPeopleButtonClicked:i?.id==="people"?Lfe:t.onPeopleButtonClicked,onChatButtonClicked:g==="chat"?Lfe:t.onChatButtonClicked})},[g,t.onChatButtonClicked,t.onPeopleButtonClicked,t.disablePeopleButton,t.disableChatButton,i?.id,y]),C=t.mobileView&&(g==="chat"||i?.id==="people")?T:p(),E=r?.isActive?void 0:i?.contentRenderer,I=r?.isActive||r?.persistRenderingWhenClosed?r.renderer.contentRenderer:void 0,w=Cs();return!E&&!I?U.createElement(R6e,null):U.createElement(Et,{"aria-label":t.ariaLabel,"data-is-focusable":!!t.ariaLabel,role:t.ariaLabel?"navigation":void 0,tabIndex:t.ariaLabel?0:void 0,verticalFill:!0,grow:!0,styles:h,"aria-modal":!0,"data-ui-id":"SidePane",tokens:t.mobileView||!t.showAddPeopleButton&&i?.id==="people"?{}:yai,className:Sai(w)},C,U.createElement(Et.Item,{verticalFill:!0,grow:!0,styles:tii},U.createElement(Et,{verticalFill:!0,styles:iii},E&&U.createElement(Et.Item,{verticalFill:!0,styles:yje},U.createElement(Et,{styles:Sje},E?.())),I&&U.createElement(Et.Item,{verticalFill:!0,styles:!r?.isActive&&r?.persistRenderingWhenClosed?A6e:yje},U.createElement(Et,{styles:Sje},I?.())))))},Lfe=()=>{},R6e=()=>U.createElement(U.Fragment,null),Ofe=t=>{const e=Cs(),i=$.useMemo(()=>({root:{minWidth:"1.5rem",padding:"0.5rem 0.25rem",marginRight:"0.25rem",backgroundColor:e.semanticColors.bodyBackground,"@media (forced-colors: active)":{border:`0.1rem solid ${e.palette.neutralSecondary}`,borderRadius:e.effects.roundedCorner4}},icon:{color:e.palette.neutralSecondary},iconHovered:{color:e.palette.neutralSecondary},iconPressed:{color:e.palette.neutralSecondary}}),[e.palette.neutralSecondary,e.semanticColors.bodyBackground,e.effects.roundedCorner4]),r=$.useCallback(o=>{var l,d;o.key==="Tab"&&o.shiftKey&&!t.chatButtonPresent&&((d=(l=t.paneOpenerButton)===null||l===void 0?void 0:l.current)===null||d===void 0||d.focus(),o.preventDefault())},[t.chatButtonPresent,t.paneOpenerButton]);return t.mobileView?U.createElement(Cai,Object.assign({},t)):U.createElement(Et,{horizontal:!0,horizontalAlign:"space-between",styles:eii,verticalAlign:"center"},U.createElement(Et.Item,{role:"heading",styles:Xti,"aria-label":t.headingText,"aria-level":2},t.headingText),U.createElement(Et.Item,null,U.createElement(crt,{ariaLabel:t.dismissSidePaneButtonAriaLabel,styles:i,iconProps:{iconName:"cancel"},onClick:()=>{var o,l;t.onClose(),(l=(o=t.paneOpenerButton)===null||o===void 0?void 0:o.current)===null||l===void 0||l.focus()},onKeyDown:r,componentRef:t.dismissButtonComponentRef})))},Cai=t=>{const{headingText:e,dismissSidePaneButtonAriaLabel:i,dismissSidePaneButtonAriaDescription:r,onClose:o}=t,l=Cs(),d=$.useMemo(()=>Ds(E6e,{root:{width:"100%"},label:{fontSize:l.fonts.medium.fontSize,fontWeight:l.fonts.medium.fontWeight}}),[l]);return U.createElement(Et,{horizontal:!0,grow:!0,styles:C6e},U.createElement(th,{ariaLabel:i,ariaDescription:r,onClick:o,styles:Mfe,onRenderIcon:()=>U.createElement(gF,{iconName:"ChevronLeft"}),autoFocus:!0}),U.createElement(Et.Item,{grow:!0},U.createElement(th,{checked:!0,styles:d},e)),U.createElement(th,{styles:_6e,ariaHidden:!0,onRenderIcon:()=>U.createElement(gF,{iconName:"ChevronLeft"})}))},_ai=t=>{const{onFetchAvatarPersonaData:e,onFetchParticipantMenuItems:i,title:r,participantListProps:o,headingMoreButtonAriaLabel:l,onClickHeadingMoreButton:d,headingMoreButtonMenuProps:h,pinnedParticipants:p}=t,g=yu(),f=hc(),y=bp("text-tooltip"),T=$.useMemo(()=>({root:{h2:{color:f.palette.neutralSecondary,margin:t.isMobile?"0.5rem 1rem":"0.5rem",fontSize:f.fonts.smallPlus.fontSize,fontWeight:"normal"}}}),[f.palette.neutralSecondary,f.fonts.smallPlus.fontSize,t.isMobile]);return U.createElement(Et,{className:aii},U.createElement(Et,{horizontal:!0,horizontalAlign:"space-between",verticalAlign:"center"},U.createElement(Et.Item,{grow:!0,styles:T,"aria-label":r,id:g},U.createElement("h2",null,Eai(r??""))),(d||h?.items&&h.items.length>0)&&U.createElement(Et.Item,null,U.createElement(th,{"data-ui-id":"people-pane-header-more-button",ariaLabel:l,styles:cii(f),iconProps:{iconName:"PeoplePaneMoreButton"},onClick:d?()=>d():void 0,menuProps:t.onClickHeadingMoreButton?void 0:t.headingMoreButtonMenuProps,onRenderMenuIcon:()=>null}))),U.createElement(Et,{className:rii},U.createElement(x8,Object.assign({},o,{pinnedParticipants:p,styles:t.isMobile?sii:oii,onRenderAvatar:(C,E)=>U.createElement(U.Fragment,null,U.createElement(U4,Object.assign({"data-ui-id":"chat-composite-participant-custom-avatar",userId:C},E,{hidePersonaDetails:!!E?.text,dataProvider:e,allowActiveBorder:!0})),E?.text&&U.createElement("div",{style:lii},U.createElement(AC,{content:E?.text,id:y,overflowMode:e5.Parent},U.createElement(ja,{nowrap:!1,"aria-labelledby":y},E?.text)))),onFetchParticipantMenuItems:i,showParticipantOverflowTooltip:!t.isMobile,participantAriaLabelledBy:g}))))},Eai=(t,e)=>Jd(t,{numberOfPeople:" "}),Aai={root:{position:"relative",maxHeight:"100%",overflow:"hidden"}},Iai={root:{overflowY:"scroll"}},wai={root:{width:"100%",padding:"0.5rem 1rem"}},kai={root:{marginLeft:"0.5rem",marginRight:"0.5rem"}},Rai={root:{height:"2.5rem",width:"100%"},textContainer:{display:"contents"}},Mai=(t,e)=>({root:{minHeight:t?"3rem":"2.5rem",borderRadius:t?e.effects.roundedCorner6:e.effects.roundedCorner4}}),Nfe=(t,e)=>({itemKey:t.key,onItemClick:()=>{var i;(i=t.onClick)===null||i===void 0||i.call(t),e()},iconProps:t.iconProps,text:t.text,disabled:t.disabled}),Pai=(t,e)=>({root:{minHeight:e?"3rem":"2.5rem",borderRadius:e?t.effects.roundedCorner6:t.effects.roundedCorner4,width:"100%"},textContainer:{display:"contents"}}),Dai=t=>({root:{borderRadius:t.effects.roundedCorner6}}),M6e={lineHeight:"0",width:"1.125rem"},Lai=t=>({main:{borderRadius:t.effects.roundedCorner6,padding:"1rem"}}),Oai=(t,e)=>({root:{padding:0,marginLeft:0,marginRight:0,maxWidth:"100%"},textField:{root:{borderBottom:`1px solid ${e.palette.neutralTertiaryAlt}`},field:{backgroundColor:e.palette.white,fontSize:e.fonts.large.fontSize,padding:"0 0.5rem",textAlign:t?"center":"left",":active":{padding:"0 0.5rem"}}},deleteIcon:{root:{backgroundColor:e.palette.white}},digit:{color:e.palette.themeDarkAlt}}),Nai=t=>({root:{fontWeight:t.fonts.medium.fontWeight,fontSize:t.fonts.medium.fontSize,width:"100%",height:"2.5rem",borderRadius:3,padding:"0.625rem"},textContainer:{display:"contents"}}),P6e=t=>{const{strings:e,isMobile:i,showDialpad:r,onDismissDialpad:o,onAddParticipant:l,alternateCallerId:d}=t,[h,p]=$.useState(""),g=hc(),f=()=>{p(""),o()},y=()=>{if(l){const w={phoneNumber:"+"+h.replace(/\D/g,"").replaceAll(" ","")};l(w,{alternateCallerId:{phoneNumber:d}}),f()}},T=$.useMemo(()=>Lai(g),[g]),C=$.useMemo(()=>Oai(i,g),[g,i]),E=$.useMemo(()=>Nai(g),[g]),I=()=>U.createElement(U.Fragment,null,U.createElement(zme,{styles:C,onChange:p,longPressTrigger:i?"touch":"mouseAndTouch"}),U.createElement(SE,{text:e.dialpadStartCallButtonLabel,onRenderIcon:()=>U.createElement(gF,{iconName:"DialpadStartCall"}),onClick:y,styles:E,disabled:h===""}));return i?U.createElement(Et,{"data-ui-id":"call-with-chat-composite-dialpad"},r&&U.createElement(Et,{styles:DX()},U.createElement(VVe,{onLightDismiss:f,disableMaxHeight:!0},U.createElement(Et,{style:{padding:"1rem"}},I())))):U.createElement(U.Fragment,null,U.createElement(o5,{titleAriaId:e.dialpadModalAriaLabel,isOpen:r,onDismiss:f,isBlocking:!0,styles:T,"data-ui-id":"call-with-chat-composite-dialpad"},U.createElement(Et,{horizontal:!0,horizontalAlign:"space-between",verticalAlign:"center"},U.createElement(ja,null,e.dialpadModalTitle),U.createElement(zy,{iconProps:{iconName:"Cancel"},ariaLabel:e.dialpadCloseModalButtonAriaLabel,onClick:f,style:{color:g.palette.black}})),U.createElement(Et,{style:{overflow:"hidden"}},I())))},D6e=t=>U.createElement(ZU,{styles:xai,target:`#${t.targetId}`,directionalHint:hd.topCenter,beakWidth:Fai,gapSpace:Uai,doNotLayer:t.doNotLayer},U.createElement(Et,{horizontal:!0,styles:Bai,tokens:{childrenGap:"0.375rem"}},U.createElement(_M,{iconName:"Checkmark",className:zai}),U.createElement(ja,null,t.text))),xai={root:{padding:"0.375rem 0.75rem 0.375rem 0.5rem",borderRadius:"0.25rem"},beakCurtain:{borderRadius:"0.25rem"},container:{zIndex:0}},Bai={root:{display:"flex",alignItems:"center"}},Fai=8,Uai=2,zai=It({fontSize:18}),L6e=t=>{var e,i;const r=hc(),{inviteLink:o,strings:l,mobileView:d,onAddParticipant:h,alternateCallerId:p,onCopyInviteLink:g,inviteLinkCopiedRecently:f}=t,[y,T]=$.useState(!1),[C,E]=$.useState(),I=$.useMemo(()=>Dai(r),[r]),w=$.useMemo(()=>Pai(r,d),[d,r]),D=$.useMemo(()=>{const H={styles:I,items:[],useTargetWidth:!0,calloutProps:{preventDismissOnEvent:YS},onMenuOpened(j){E(void 0)}};return o&&H.items.push({key:"InviteLinkKey",text:l.copyInviteLinkButtonLabel,itemProps:{styles:w},iconProps:{iconName:"Link",style:M6e},onClick:()=>{E(l.copyInviteLinkActionedAriaLabel),_$e(o),g?.()}}),p&&H.items.push({key:"DialpadKey",text:l.openDialpadButtonLabel,itemProps:{styles:w},iconProps:{iconName:"PeoplePaneOpenDialpad",style:M6e},onClick:()=>T(!0),"data-ui-id":"call-dial-phone-number-button"}),H},[I,o,p,l.copyInviteLinkButtonLabel,l.copyInviteLinkActionedAriaLabel,l.openDialpadButtonLabel,w,g]),F=()=>{T(!1)},[x,B]=$.useState([]),L=$.useMemo(()=>()=>{const H=D.items.map(j=>Nfe(j,()=>B([])));B(H)},[D,B]),z=yu("callout-button");return d?U.createElement(Et,null,U.createElement(GA,{ariaLive:"assertive",announcementString:C}),D.items.length>0&&U.createElement(Et.Item,{styles:wai},U.createElement(SE,{autoFocus:!0,id:z,onClick:L,styles:w,onRenderIcon:()=>U.createElement(gF,{iconName:"PeoplePaneAddPerson"}),text:l.peoplePaneAddPeopleButtonLabel,"data-ui-id":"call-add-people-button"}),f&&U.createElement(D6e,{targetId:z,text:(e=l.copyInviteLinkButtonActionedLabel)!==null&&e!==void 0?e:"",doNotLayer:!0})),x.length>0&&U.createElement(Et,{styles:DX(),"data-ui-id":"call-add-people-dropdown"},U.createElement(sF,{disableMaxHeight:!0,onLightDismiss:()=>B([]),items:x})),p&&U.createElement(P6e,{isMobile:!0,strings:l,showDialpad:y,onDismissDialpad:F,onAddParticipant:h,alternateCallerId:p})):U.createElement(U.Fragment,null,U.createElement(Et,null,U.createElement(GA,{ariaLive:"assertive",announcementString:C}),p&&U.createElement(P6e,{isMobile:!1,strings:l,showDialpad:y,onDismissDialpad:F,onAddParticipant:h,alternateCallerId:p}),D.items.length>0&&U.createElement(Et,{styles:kai},U.createElement(th,{id:z,onRenderIcon:()=>U.createElement(gF,{iconName:"PeoplePaneAddPerson"}),text:l.peoplePaneAddPeopleButtonLabel,menuProps:D,styles:w,"data-ui-id":"call-add-people-button"}),f&&U.createElement(D6e,{targetId:z,text:(i=l.copyInviteLinkButtonActionedLabel)!==null&&i!==void 0?i:""}))))},O6e=t=>{const{inviteLink:e,mobileView:i,strings:r,participantList:o}=t,l=hc(),[d,h]=$.useState("");$.useMemo(()=>Ds(Rai,Mai(i,l)),[i,l]),$.useCallback(()=>{h(r.copyInviteLinkActionedAriaLabel),setTimeout(()=>{h("")},3e3)},[r.copyInviteLinkActionedAriaLabel]);const p=$.useRef(void 0),[g,f]=$.useState(!1),y=$.useCallback(()=>{f(!0),p.current=Date.now(),setTimeout(()=>{p.current&&Date.now()-p.current>=2e3&&f(!1)},2e3)},[f,p]);return yu("callout-button"),i?U.createElement(L6e,{strings:Object.assign({},r),mobileView:i,inviteLink:e,onAddParticipant:t.onAddParticipant,alternateCallerId:t.alternateCallerId,onCopyInviteLink:y,inviteLinkCopiedRecently:g}):U.createElement(Et,{tokens:bje,"data-ui-id":"people-pane-content",verticalFill:!0},U.createElement(L6e,{strings:r,mobileView:i,inviteLink:e,onAddParticipant:t.onAddParticipant,alternateCallerId:t.alternateCallerId,onCopyInviteLink:y,inviteLinkCopiedRecently:g}),U.createElement(Et.Item,{grow:!0,styles:{root:{overflowY:"hidden"}}},o))};var xfe=function(t,e,i,r){function o(l){return l instanceof i?l:new i(function(d){d(l)})}return new(i||(i=Promise))(function(l,d){function h(f){try{g(r.next(f))}catch(y){d(y)}}function p(f){try{g(r.throw(f))}catch(y){d(y)}}function g(f){f.done?l(f.value):o(f.value).then(h,p)}g((r=r.apply(t,e||[])).next())})};const Vai=t=>{const{inviteLink:e,onFetchParticipantMenuItems:i,setDrawerMenuItems:r,setParticipantActioned:o,participantListHeadingMoreButtonProps:l}=t,d=QE(),h=ks(),g=h.strings.call,f=$.useCallback(F=>xfe(void 0,void 0,void 0,function*(){yield d.removeParticipant(F)}),[d]),y=$.useCallback((F,x)=>xfe(void 0,void 0,void 0,function*(){yield d.addParticipant(F,x)}),[d]),T=mc(x8),C=Hai(t.role),E=$.useMemo(()=>F=>{if(F){o?.(F.userId);let x=$ai(F,g,C&&F.isRemovable?T.onRemoveParticipant:void 0,T.myUserId);i&&(x=i(F.userId,T.myUserId,x));const B=x.map(L=>Nfe(L,()=>r([])));r(B)}},[g,T.onRemoveParticipant,T.myUserId,C,i,r,o]),I=$.useMemo(()=>{const F=l?.items.map(x=>Nfe(x,()=>r([])));return F&&F.length>0?()=>r(F):void 0},[l?.items,r]),w=$.useMemo(()=>{const F=x=>xfe(void 0,void 0,void 0,function*(){return f(x)});return Object.assign(Object.assign({},T),{onRemoveParticipant:t.mobileView?void 0:F,onParticipantClick:t.mobileView?E:void 0})},[T,t.mobileView,E,f]),D=U.createElement(_ai,{isMobile:t.mobileView,participantListProps:w,onFetchAvatarPersonaData:t.onFetchAvatarPersonaData,onFetchParticipantMenuItems:t.mobileView?void 0:i,title:g.peoplePaneSubTitle,headingMoreButtonAriaLabel:h.strings.call.peoplePaneMoreButtonAriaLabel,onClickHeadingMoreButton:t.mobileView?I:void 0,headingMoreButtonMenuProps:t.participantListHeadingMoreButtonProps,pinnedParticipants:t.pinnedParticipants});return t.mobileView?U.createElement(Et,{verticalFill:!0,styles:Aai,tokens:bje,"data-ui-id":"people-pane-content"},U.createElement(Et.Item,{grow:!0,styles:Iai},D),U.createElement(O6e,{inviteLink:e,mobileView:t.mobileView,participantList:D,strings:g,onAddParticipant:y,alternateCallerId:t.alternateCallerId})):U.createElement(O6e,{inviteLink:e,mobileView:t.mobileView,participantList:D,strings:g,onAddParticipant:y,alternateCallerId:t.alternateCallerId})},$ai=(t,e,i,r)=>{const o=[];return i&&t?.userId!==r&&o.push({key:"remove",text:e.removeMenuLabel,role:"menuitem",onClick:()=>{t?.userId&&i?.(t?.userId)},iconProps:{iconName:"ContextMenuRemoveParticipant",styles:{root:{lineHeight:0}}},"data-ui-id":"participant-list-remove-participant-button"}),o},Hai=t=>t==="Presenter"||t==="Unknown"||t===void 0,N6e="people",jai=t=>{const{updateSidePaneRenderer:e,inviteLink:i,onFetchAvatarPersonaData:r,onFetchParticipantMenuItems:o,setDrawerMenuItems:l,mobileView:d,peopleButtonRef:h,setParticipantActioned:p,spotlightedParticipantUserIds:g,onStartLocalSpotlight:f,onStopLocalSpotlight:y,onStartRemoteSpotlight:T,onStopRemoteSpotlight:C,onStopAllSpotlight:E,maxParticipantsToSpotlight:I,onMuteParticipant:w,pinnedParticipants:D,onPinParticipant:F,onUnpinParticipant:x,disablePinMenuItem:B,onMuteAllRemoteParticipants:L,onForbidAudio:z,onPermitAudio:H,onForbidOthersAudio:j,onPermitOthersAudio:J,onForbidVideo:Z,onPermitVideo:re,onForbidOthersVideo:ne,onPermitOthersVideo:le,meetingMediaAccess:he,sidePaneDismissButtonRef:Me,chatButtonPresent:Le}=t,pe=$.useCallback(()=>{var kt;e(void 0),(kt=h?.current)===null||kt===void 0||kt.focus()},[h,e]),te=ks().strings.call,Se=qn(GO),[ce,X]=$.useState(!1),ve=$.useMemo(()=>({confirmButtonLabel:te.muteAllConfirmButtonLabel,heading:te.muteAllDialogTitle,text:te.muteAllDialogContent,cancelButtonLabel:te.muteAllCancelButtonLabel}),[te.muteAllConfirmButtonLabel,te.muteAllDialogTitle,te.muteAllDialogContent,te.muteAllCancelButtonLabel]),Te=$.useCallback(()=>{L&&L(),X(!1)},[L,X]),[Be,qe]=$.useState(!1),[Ge,tt]=$.useState(!1),[ct,Mt]=$.useState(!1),[ht,vt]=$.useState(!1),Pt=$.useCallback(()=>{j&&j(),qe(!1)},[j,qe]),ni=$.useCallback(()=>{J&&J(),tt(!1)},[J,tt]),Zt=$.useCallback(()=>{ne&&ne(),Mt(!1)},[ne,Mt]),it=$.useCallback(()=>{le&&le(),vt(!1)},[le,vt]),Ke=$.useMemo(()=>{const kt=[];if(L&&Se){let gt=!0;if(Se){for(const Ye of Object.values(Se))if(!Ye.isMuted){gt=!1;break}}kt.push({"data-ui-id":"people-pane-mute-all-remote-participants",key:"muteAllRemoteParticipants",text:te.muteAllMenuLabel,iconProps:{iconName:"ContextualMenuMicMutedIcon",styles:{root:{lineHeight:0}}},onClick:()=>{X(!0)},ariaLabel:te.muteAllMenuLabel,disabled:gt})}let je=!1;if(Se){for(const gt of Object.values(Se))if(gt.role&&gt.role==="Attendee"){je=!0;break}}const Ae=he?he.isAudioPermitted:!0,xe=he?he.isVideoPermitted:!0;return j&&Se&&je&&Ae&&kt.push({"data-ui-id":"people-pane-forbid-all-attendees-audio",key:"forbidOthersAudio",text:te.forbidOthersAudioMenuLabel,iconProps:{iconName:"ControlButtonMicProhibited",styles:{root:{lineHeight:0}}},onClick:()=>{qe(!0)},ariaLabel:te.forbidOthersAudioMenuLabel,disabled:!je}),J&&Se&&je&&!Ae&&kt.push({"data-ui-id":"people-pane-permit-all-attendees-audio",key:"permitOthersAudio",text:te.permitOthersAudioMenuLabel,iconProps:{iconName:"ControlButtonMicOn",styles:{root:{lineHeight:0}}},onClick:()=>{tt(!0)},ariaLabel:te.permitOthersAudioMenuLabel,disabled:!je}),ne&&Se&&je&&xe&&kt.push({"data-ui-id":"people-pane-forbid-all-attendees-video",key:"forbidOthersVideo",text:te.forbidOthersVideoMenuLabel,iconProps:{iconName:"ControlButtonCameraProhibitedSmall",styles:{root:{lineHeight:0}}},onClick:()=>{Mt(!0)},ariaLabel:te.forbidOthersVideoMenuLabel,disabled:!je}),le&&Se&&je&&!xe&&kt.push({"data-ui-id":"people-pane-permit-all-attendees-video",key:"permitOthersVideo",text:te.permitOthersVideoMenuLabel,iconProps:{iconName:"ControlButtonCameraOn",styles:{root:{lineHeight:0}}},onClick:()=>{vt(!0)},ariaLabel:te.permitOthersVideoMenuLabel,disabled:!je}),E&&g&&g.length>0&&kt.push({key:"stopAllSpotlightKey",text:te.stopAllSpotlightMenuLabel,iconProps:{iconName:"StopAllSpotlightMenuButton",styles:{root:{lineHeight:0}}},onClick:()=>{E()},ariaLabel:te.stopAllSpotlightMenuLabel}),{items:kt}},[L,Se,he,j,J,ne,le,E,g,te.muteAllMenuLabel,te.forbidOthersAudioMenuLabel,te.permitOthersAudioMenuLabel,te.forbidOthersVideoMenuLabel,te.permitOthersVideoMenuLabel,te.stopAllSpotlightMenuLabel]),ot=$.useCallback(()=>U.createElement(Ofe,{onClose:pe,paneOpenerButton:h,headingText:te.peoplePaneTitle,dismissSidePaneButtonAriaLabel:te.dismissSidePaneButtonLabel,mobileView:d??!1,dismissButtonComponentRef:Me,chatButtonPresent:Le}),[pe,h,te.peoplePaneTitle,te.dismissSidePaneButtonLabel,d,Me,Le]),Ht=$.useCallback((kt,je,Ae)=>{var xe,gt;let Ye=D?.includes(kt);const Fe=[],St=g?.includes(kt),Wt=je===kt;if(Ye=St?!1:Ye,w&&!Wt&&Se&&Se[kt]){const en=Se[kt],sn=!!en?.isMuted;Fe.push({key:"mute",text:"Mute",role:"menuitem",iconProps:{iconName:"ContextualMenuMicMutedIcon",styles:{root:{lineHeight:0}}},onClick:()=>{w(kt)},"data-ui-id":"participant-item-mute-participant",ariaLabel:"Mute",disabled:sn})}const Ii=Se?.[kt];if(Ii?.mediaAccess&&!Ii.mediaAccess.isAudioPermitted&&Ii?.role==="Attendee"&&H&&Fe.push({key:"permit-audio",text:te.permitAudioMenuLabel,role:"menuitem",iconProps:{iconName:"ControlButtonMicOn",styles:{root:{lineHeight:"1rem",textAlign:"center"}}},onClick:()=>{H([kt])},"data-ui-id":"participant-item-permit-microphone-button",ariaLabel:te.permitAudioMenuLabel}),!((xe=Ii?.mediaAccess)===null||xe===void 0)&&xe.isAudioPermitted&&Ii?.role==="Attendee"&&z&&Fe.push({key:"forbid-audio",text:te.forbidAudioMenuLabel,role:"menuitem",iconProps:{iconName:"ControlButtonMicProhibited",styles:{root:{lineHeight:"1rem",textAlign:"center"}}},onClick:()=>{z([kt])},"data-ui-id":"participant-item-forbid-microphone-button",ariaLabel:te.forbidAudioMenuLabel}),Ii?.mediaAccess&&!Ii.mediaAccess.isVideoPermitted&&Ii?.role==="Attendee"&&re&&Fe.push({key:"permit-video",text:te.permitVideoMenuLabel,role:"menuitem",iconProps:{iconName:"ControlButtonCameraOn",styles:{root:{lineHeight:"1rem",textAlign:"center"}}},onClick:()=>{re([kt])},"data-ui-id":"participant-item-permit-camera-button",ariaLabel:te.permitVideoMenuLabel}),!((gt=Ii?.mediaAccess)===null||gt===void 0)&&gt.isVideoPermitted&&Ii?.role==="Attendee"&&Z&&Fe.push({key:"forbid-video",text:te.forbidVideoMenuLabel,role:"menuitem",iconProps:{iconName:"ControlButtonCameraProhibitedSmall",styles:{root:{lineHeight:"1rem",textAlign:"center"}}},onClick:()=>{Z([kt])},"data-ui-id":"participant-item-forbid-camera-button",ariaLabel:te.forbidVideoMenuLabel}),St){const en=Wt?te.stopSpotlightOnSelfMenuLabel:te.stopSpotlightMenuLabel,sn=Wt?y:C?()=>{C([kt])}:void 0;sn&&en&&Fe.push({key:"stop-spotlight",text:en,role:"menuitem",onClick:sn,iconProps:{iconName:"StopSpotlightContextualMenuItem",styles:{root:{lineHeight:0}}},ariaLabel:en})}else{const en=g&&g.length>0?te.addSpotlightMenuLabel:te.startSpotlightMenuLabel,sn=I&&g?g.length>=I:!1,Qi=Wt?f:T?()=>{T([kt])}:void 0;Qi&&en&&Fe.push({key:"start-spotlight",text:en,role:"menuitem",onClick:Qi,iconProps:{iconName:"StartSpotlightContextualMenuItem",styles:{root:{lineHeight:0}}},ariaLabel:en,disabled:sn,title:sn?te.spotlightLimitReachedMenuTitle:void 0})}return!Wt&&Ye!==void 0&&(Ye&&x&&te?.unpinParticipantMenuLabel&&Fe.push({key:"unpin",text:te?.unpinParticipantMenuLabel,role:"menuitem",iconProps:{iconName:"UnpinParticipant",styles:{root:{lineHeight:"1rem",textAlign:"center"}}},onClick:()=>{x?.(kt)},"data-ui-id":"participant-item-unpin-participant-button",ariaLabel:te.unpinParticipantMenuItemAriaLabel}),!Ye&&F&&te?.pinParticipantMenuLabel&&Fe.push({key:"pin",text:B?te.pinParticipantLimitReachedMenuLabel:te.pinParticipantMenuLabel,role:"menuitem",iconProps:{iconName:"PinParticipant",styles:{root:{lineHeight:"1rem",textAlign:"center"}}},onClick:()=>{F(kt)},"data-ui-id":"participant-item-pin-participant-button",disabled:B||St,ariaLabel:te.pinParticipantMenuItemAriaLabel})),Ae&&Fe.push(...Ae),o?o(kt,je,Fe):Fe},[D,g,w,Se,H,z,re,Z,o,te.permitAudioMenuLabel,te.forbidAudioMenuLabel,te.permitVideoMenuLabel,te.forbidVideoMenuLabel,te.stopSpotlightOnSelfMenuLabel,te.stopSpotlightMenuLabel,te.addSpotlightMenuLabel,te.startSpotlightMenuLabel,te.spotlightLimitReachedMenuTitle,te?.unpinParticipantMenuLabel,te.pinParticipantMenuLabel,te.unpinParticipantMenuItemAriaLabel,te.pinParticipantLimitReachedMenuLabel,te.pinParticipantMenuItemAriaLabel,y,C,I,f,T,x,F,B]),jt=qn(XC),Nt=qn($je),Vt=$.useCallback(()=>U.createElement(U.Fragment,null,U.createElement(fF,Object.assign({},ve,{styles:{main:{minWidth:"22.5rem",padding:"1.5rem"}},onConfirm:()=>Te(),isOpen:ce,onCancel:()=>X(!1)})),U.createElement(fF,{heading:te.forbidOthersAudioDialogTitle,text:te.forbidOthersAudioDialogContent,confirmButtonLabel:te.forbidOthersAudioConfirmButtonLabel,cancelButtonLabel:te.forbidOthersAudioCancelButtonLabel,styles:{main:{minWidth:"22.5rem",padding:"1.5rem"}},onConfirm:()=>Pt(),isOpen:Be,onCancel:()=>qe(!1)}),U.createElement(fF,{heading:te.permitOthersAudioDialogTitle,text:te.permitOthersAudioDialogContent,confirmButtonLabel:te.permitOthersAudioConfirmButtonLabel,cancelButtonLabel:te.permitOthersAudioCancelButtonLabel,styles:{main:{minWidth:"22.5rem",padding:"1.5rem"}},onConfirm:()=>ni(),isOpen:Ge,onCancel:()=>qe(!1)}),U.createElement(fF,{heading:te.forbidOthersVideoDialogTitle,text:te.forbidOthersVideoDialogContent,confirmButtonLabel:te.forbidOthersVideoConfirmButtonLabel,cancelButtonLabel:te.forbidOthersVideoCancelButtonLabel,styles:{main:{minWidth:"22.5rem",padding:"1.5rem"}},onConfirm:()=>Zt(),isOpen:ct,onCancel:()=>Mt(!1)}),U.createElement(fF,{heading:te.permitOthersVideoDialogTitle,text:te.permitOthersVideoDialogContent,confirmButtonLabel:te.permitOthersVideoConfirmButtonLabel,cancelButtonLabel:te.permitOthersVideoCancelButtonLabel,styles:{main:{minWidth:"22.5rem",padding:"1.5rem"}},onConfirm:()=>it(),isOpen:ht,onCancel:()=>Mt(!1)}),U.createElement(Vai,{inviteLink:i,onFetchAvatarPersonaData:r,onFetchParticipantMenuItems:Ht,setDrawerMenuItems:l,mobileView:d,setParticipantActioned:p,participantListHeadingMoreButtonProps:Ke,pinnedParticipants:D,role:jt,alternateCallerId:Nt})),[ve,ce,te.forbidOthersAudioDialogTitle,te.forbidOthersAudioDialogContent,te.forbidOthersAudioConfirmButtonLabel,te.forbidOthersAudioCancelButtonLabel,te.permitOthersAudioDialogTitle,te.permitOthersAudioDialogContent,te.permitOthersAudioConfirmButtonLabel,te.permitOthersAudioCancelButtonLabel,te.forbidOthersVideoDialogTitle,te.forbidOthersVideoDialogContent,te.forbidOthersVideoConfirmButtonLabel,te.forbidOthersVideoCancelButtonLabel,te.permitOthersVideoDialogTitle,te.permitOthersVideoDialogContent,te.permitOthersVideoConfirmButtonLabel,te.permitOthersVideoCancelButtonLabel,Be,Ge,ct,ht,i,r,Ht,l,d,p,Ke,D,jt,Nt,Te,Pt,ni,Zt,it]),$t=$.useMemo(()=>({headerRenderer:ot,contentRenderer:Vt,id:N6e}),[Vt,ot]),dt=$.useCallback(()=>{e($t)},[$t,e]),yt=Q8(N6e);return $.useEffect(()=>{yt&&dt()},[yt,dt]),{openPeoplePane:dt,closePeoplePane:pe,isPeoplePaneOpen:yt}},x6e={childrenGap:"0.5rem"},B6e={root:{position:"relative",maxHeight:"100%",overflow:"hidden"}},Gai=It({fontWeight:600,fontSize:_n(20),lineHeight:_n(28)}),qai=It({paddingBottom:_n(20)}),H4=It({fontSize:_n(14),lineHeight:_n(40)}),Dk=It({fontSize:_n(14),lineHeight:_n(40),fontWeight:xs.semibold}),j4=t=>It({background:`${t.palette.themeLighter}`,height:_n(36),width:_n(36),marginRight:_n(12),borderRadius:_n(18)}),G4=It({padding:"0.5rem 1rem"}),LX=It({minWidth:_n(150),textAlign:"right"}),q4=t=>It({padding:_n(8),color:`${t.palette.themePrimary}`,zIndex:2}),F6e=t=>It({background:`${t.palette.themeLighter}`,width:_n(2),position:"relative",left:_n(19),top:_n(20),zIndex:1}),Wai=t=>{const{conferencePhoneInfoList:e}=t,i=hc(),r=ks().component.strings.meetingConferencePhoneInfo;return t.mobileView?U.createElement(Et,{verticalFill:!0,styles:B6e,tokens:x6e,"data-ui-id":"phone-info-pane-content"},(e===void 0||e.length===0)&&U.createElement(Et,{horizontal:!0},U.createElement(ja,{className:Dk},r.meetingConferencePhoneInfoModalNoPhoneAvailable)),e&&e[0]&&U.createElement(Et,null,U.createElement(Et,{horizontal:!0,horizontalAlign:"space-between",className:G4},U.createElement(Et.Item,null,U.createElement(Et,{horizontal:!0,className:LX},U.createElement(Et.Item,{className:j4(i)},U.createElement(Et,{verticalAlign:"center",horizontalAlign:"center"},U.createElement(Fr,{iconName:"JoinByPhoneDialStepIcon",className:q4(i)}))),U.createElement(Et.Item,null,U.createElement(ja,{className:H4},r.meetingConferencePhoneInfoModalDialIn)))),U.createElement(Et.Item,{className:LX},e.map((o,l)=>U.createElement(Et.Item,{key:l},U.createElement(uW,{className:Dk,href:F$e(o)},V8(o.phoneNumber,!0)),U.createElement(ja,{className:Dk}," ",o.isTollFree?r.meetingConferencePhoneInfoModalTollFree:r.meetingConferencePhoneInfoModalToll),U.createElement("br",null),U.createElement(ja,{className:Dk}," ",Gme(o,r)))))),U.createElement(Et,{horizontal:!0,horizontalAlign:"space-between",verticalAlign:"center",className:G4},U.createElement(Et.Item,null,U.createElement(Et,{horizontal:!0},U.createElement(Et.Item,{className:j4(i)},U.createElement(Fr,{iconName:"JoinByPhoneConferenceIdIcon",className:q4(i)})),U.createElement(Et.Item,null,U.createElement(ja,{className:H4},r.meetingConferencePhoneInfoModalMeetingId)))),U.createElement(ja,{className:Dk},e[0].conferenceId,"#")),U.createElement(Et,{horizontal:!0,horizontalAlign:"space-between",verticalAlign:"center",className:G4},U.createElement(Et,{horizontal:!0},U.createElement(Et.Item,{className:j4(i)},U.createElement(Fr,{iconName:"JoinByPhoneWaitToBeAdmittedIcon",className:q4(i)})),U.createElement(Et.Item,null,U.createElement(ja,{className:H4},r.meetingConferencePhoneInfoModalWait)))))):U.createElement(Et,{verticalFill:!0,styles:B6e,tokens:x6e,"data-ui-id":"phone-info-pane-content"})},U6e="Meeting Phone Info",Kai=t=>{const{updateSidePaneRenderer:e,mobileView:i,conferencePhoneInfo:r}=t,o=$.useCallback(()=>{e(void 0)},[e]),l=ks().component.strings.meetingConferencePhoneInfo,d=ks().strings.call,h=$.useCallback(()=>U.createElement(Ofe,{onClose:o,headingText:l.meetingConferencePhoneInfoModalTitle,dismissSidePaneButtonAriaLabel:d.dismissSidePaneButtonLabel,mobileView:i??!1}),[i,o,l,d]),p=$.useCallback(()=>U.createElement(Wai,{mobileView:i,conferencePhoneInfoList:r}),[i,r]),g=$.useMemo(()=>({headerRenderer:h,contentRenderer:p,id:U6e}),[p,h]),f=$.useCallback(()=>{e(g)},[g,e]),y=Q8(U6e);return $.useEffect(()=>{y&&f()},[y,f]),{openMeetingPhoneInfoPane:f,closeMeetingPhoneInfoPane:o,isMeetingPhoneInfoPaneOpen:y}},Jai=Xs([Gii],t=>t&&(t.effectName==="blur"||t.effectName==="none")?t.effectName:t&&t.effectName==="replacement"?t?.key:"none"),W4=Xs([Y8,q8,xje],(t,e,i)=>{var r,o;let l;return HA(t.callStatus)?l=i?.find(d=>d.mediaStreamType==="Video"):c8(e)&&(l=e.unparentedViews[0]),{isAvailable:!!l,isMirrored:(r=l?.view)===null||r===void 0?void 0:r.isMirrored,renderElement:(o=l?.view)===null||o===void 0?void 0:o.target,activeVideoEffects:l?.videoEffects}});var Yai=function(t,e,i,r){function o(l){return l instanceof i?l:new i(function(d){d(l)})}return new(i||(i=Promise))(function(l,d){function h(f){try{g(r.next(f))}catch(y){d(y)}}function p(f){try{g(r.throw(f))}catch(y){d(y)}}function g(f){f.done?l(f.value):o(f.value).then(h,p)}g((r=r.apply(t,e||[])).next())})};const Qai=t=>{var e;const{onDismissError:i,activeVideoEffectError:r,activeVideoEffectChange:o}=t,l=ks(),d=QE(),h=l.strings.call,p=(e=qn(W4).activeVideoEffects)===null||e===void 0?void 0:e.activeEffects,g=$.useMemo(()=>{const y=[{itemKey:"none",iconProps:{iconName:"RemoveVideoBackgroundEffect"},title:h.removeBackgroundEffectButtonLabel,tooltipProps:{content:h.removeBackgroundTooltip}},{itemKey:"blur",iconProps:{iconName:"BlurVideoBackground"},title:h.blurBackgroundEffectButtonLabel,tooltipProps:{content:h.blurBackgroundTooltip}}];return t.backgroundImages&&t.backgroundImages.forEach(T=>{var C;y.push({itemKey:T.key,backgroundProps:{url:T.url},tooltipProps:{content:(C=T.tooltipText)!==null&&C!==void 0?C:""}})}),y},[h.removeBackgroundEffectButtonLabel,h.removeBackgroundTooltip,h.blurBackgroundEffectButtonLabel,h.blurBackgroundTooltip,t.backgroundImages]),f=$.useCallback(y=>Yai(void 0,void 0,void 0,function*(){if(y==="blur"){const T={effectName:y};o({type:"blur",timestamp:new Date(Date.now())}),yield d.startVideoBackgroundEffect(T),d.updateSelectedVideoBackgroundEffect(T)}else if(y==="none"){const T={effectName:y};yield d.stopVideoBackgroundEffects(),d.updateSelectedVideoBackgroundEffect(T)}else{const T=g.find(C=>C.itemKey===y);if(T&&T.backgroundProps){const C={effectName:"replacement",key:y,backgroundImageUrl:T.backgroundProps.url};o({type:"replacement",timestamp:new Date(Date.now())}),yield d.startVideoBackgroundEffect(C),d.updateSelectedVideoBackgroundEffect(C)}}}),[d,o,g]);if(r&&p&&p.length===0){const y={effectName:"none"};d.updateSelectedVideoBackgroundEffect(y)}return Zai(i,t.updateFocusHandle,r,g,f)},Zai=(t,e,i,r,o)=>{const l=qn(Jai),d=qn(W4).isAvailable,h=!d&&l!=="none",p=ks();return U.createElement(Et,{tokens:{childrenGap:"0.75rem"},className:It({paddingLeft:"0.5rem"})},i&&d&&U.createElement(CW,{messageBarType:qo.error,onDismiss:()=>t(i),role:"alert","aria-live":"assertive"},p.strings.call.unableToStartVideoEffect),h&&U.createElement(CW,{messageBarType:qo.warning,role:"alert","aria-live":"assertive"},p.strings.call.cameraOffBackgroundEffectWarningText),U.createElement(yYt,{label:p.strings.call.videoEffectsPaneBackgroundSelectionTitle,styles:Xai,options:r??[],onChange:o,selectedEffectKey:l,componentRef:e}))},Xai={label:{fontSize:"0.75rem",lineHeight:"0.5rem",fontWeight:"400"}},Bfe="videoeffects",Z8=17.5,z6e=(t,e,i,r,o)=>{const l=$.useCallback(()=>{var w;t(void 0),(w=o?.current)===null||w===void 0||w.focus()},[o,t]),d=ks(),h=$.useCallback(()=>{var w,D;return U.createElement(Ofe,{onClose:l,headingText:d.strings.call.videoEffectsPaneTitle,dismissSidePaneButtonAriaLabel:(D=(w=d.strings.call.dismissSidePaneButtonLabel)!==null&&w!==void 0?w:d.strings.callWithChat.dismissSidePaneButtonLabel)!==null&&D!==void 0?D:"Close",mobileView:e})},[l,d.strings,e]),p=i.find(w=>w.type==="unableToStartVideoEffect"),g=$.useMemo(()=>$.createRef(),[]),f=qn(tni),y=$.useCallback(()=>U.createElement(Qai,{onDismissError:r,activeVideoEffectError:p,activeVideoEffectChange:()=>{p&&r?.(p)},updateFocusHandle:g,backgroundImages:f}),[p,r,g,f]),T=$.useMemo(()=>({headerRenderer:h,contentRenderer:y,id:Bfe}),[y,h]),C=$.useCallback(()=>{t(T),setTimeout(()=>{var w;return(w=g.current)===null||w===void 0?void 0:w.focus()},0)},[T,t,g]),E=Q8(Bfe);$.useEffect(()=>{E&&C()},[E,C]);const I=$.useCallback(()=>{E?l():C()},[l,E,C]);return{openVideoEffectsPane:C,closeVideoEffectsPane:l,toggleVideoEffectsPane:I,isVideoEffectsPaneOpen:E}},eri=t=>{var e,i;const{localParticipant:r,remoteParticipant:o,onCreateLocalStreamView:l,onDisposeLocalStreamView:d,onCreateRemoteStreamView:h,onDisposeRemoteStreamView:p}=t,g=$.useMemo(()=>{var w,D;return{onCreateLocalStreamView:l,onDisposeLocalStreamView:d,localVideoViewOptions:tri,displayName:r.displayName,showLabel:!1,showMuteIndicator:!1,showCameraSwitcherInLocalPreview:!1,isAvailable:(w=r.videoStream)===null||w===void 0?void 0:w.isAvailable,renderElement:(D=r.videoStream)===null||D===void 0?void 0:D.renderElement,raisedHand:r.raisedHand}},[r.displayName,(e=r.videoStream)===null||e===void 0?void 0:e.isAvailable,(i=r.videoStream)===null||i===void 0?void 0:i.renderElement,l,d,r.raisedHand]),f=$.useMemo(()=>{var w,D,F;return o?{remoteParticipant:o,onCreateRemoteStreamView:h,onDisposeRemoteStreamView:p,remoteVideoViewOptions:iri,displayName:o?.displayName,showLabel:!1,showMuteIndicator:!1,isAvailable:(w=o.videoStream)===null||w===void 0?void 0:w.isAvailable,isReceiving:(D=o.videoStream)===null||D===void 0?void 0:D.isReceiving,renderElement:(F=o.videoStream)===null||F===void 0?void 0:F.renderElement,userId:o.userId,key:o.userId}:void 0},[o,h,p]),y=ks(),T=y.strings.callWithChat.pictureInPictureTileAriaLabel,C=$.useMemo(()=>({rootAriaLabel:T}),[T]),E=$.useMemo(()=>({children:f?U.createElement(Tme,Object.assign({},f,{strings:y.component.strings.videoGallery,onLongTouch:()=>{}})):U.createElement(Cme,Object.assign({},g)),orientation:"portrait"}),[g,f,y.component.strings.videoGallery]),I=$.useMemo(()=>f?{children:U.createElement(Cme,Object.assign({},g,{personaMinSize:20})),orientation:"portrait"}:void 0,[g,f]);return U.createElement($Jt,{onClick:t.onClick,strings:C,primaryTile:E,secondaryTile:I})},tri={scalingMode:"Crop",isMirrored:!0},iri={scalingMode:"Crop",isMirrored:!1},nri=Xs([GO,jii],(t,e)=>{const i=V$e(e);return t&&Object.keys(t).length>0?ari(t,i??[]):void 0}),ari=(t,e)=>{let i=e[0];const r=Object.keys(t);return(!i||!r.includes(i))&&(i=r[0]),i?t[i]:void 0},rri=Xs([GO,Jii],(t,e)=>{const i=e?e.map(o=>Ga(o.identifier)):[];return t?ori(t,i):void 0}),ori=(t,e)=>{const i=Object.keys(t),r=e.filter(o=>i.includes(o));return r[0]?t[r[0]]:void 0},sri=Xs([xii,nri,W4,Uii,rri],(t,e,i,r,o)=>{let l=e;o&&(l=o);const d=l?$$e(fge([l]))[0]:void 0;return{localParticipant:{displayName:t,videoStream:i,raisedHand:r},remoteParticipant:d}}),lri={moveMenuItemText:"Move",closeMenuItemText:"Close",menu:hx,keepInBounds:!0},cri=t=>{var e;const i=t.hidden?Hni:p6e,r=qn(XC),o=ks(),l=qn(sri),[d,h]=$.useState(null),p=$.useCallback(I=>{var w;if(d&&d[0]&&d.length===1&&I.changedTouches[0]&&I.changedTouches.length===1){const D=d[0],F=I.changedTouches[0];Math.abs(D.clientX-F.clientX)<10&&Math.abs(D.clientY-F.clientY)<10&&((w=t.onDismissSidePane)===null||w===void 0||w.call(t))}},[t,d]),g=$.useCallback(I=>{h(I.touches)},[]),f=$.useCallback(I=>{var w;(I.key==="Enter"||I.key===" ")&&((w=t.onDismissSidePane)===null||w===void 0||w.call(t))},[t]),y=JA(),T=l.remoteParticipant,C=$.useMemo(()=>{var I,w,D,F;return r==="Consumer"&&T?.userId?U.createElement(Et,{tabIndex:0,"aria-label":(w=(I=t.strings)===null||I===void 0?void 0:I.dismissModalAriaLabel)!==null&&w!==void 0?w:"",onKeyDown:f},U.createElement(Tme,Object.assign({strings:o.component.strings.videoGallery},T,{remoteParticipant:T}))):U.createElement(Et,{tabIndex:0,"aria-label":(F=(D=t.strings)===null||D===void 0?void 0:D.dismissModalAriaLabel)!==null&&F!==void 0?F:"",onKeyDown:f},U.createElement(eri,Object.assign({},l,y,{remoteParticipant:T})))},[r,f,l,t,y,o.component.strings.videoGallery,T]);if(r==="Consumer"&&!T)return null;const E=Ds(jni,(e=t.styles)===null||e===void 0?void 0:e.modal);return U.createElement(Et,{styles:i},U.createElement(Et,{onTouchStart:g,onTouchEnd:p},U.createElement(Rme,{isOpen:!0,isModeless:!0,dragOptions:lri,styles:E,layerProps:{hostId:t.modalLayerHostId},minDragPosition:t.minDragPosition,maxDragPosition:t.maxDragPosition},!t.hidden&&C)))},dri=t=>{const e=ks();return U.createElement(Et,{"data-ui-id":"capabilities-changed-notification-bar-stack"},t.capabilitiesChangedNotifications.map(i=>{const r=uri(i,e.strings.call.capabilityChangedNotification);if(!r)return null;const o=hri(i);return U.createElement(CW,{key:i.capabilityName,styles:pri,messageBarType:qo.warning,dismissIconProps:{iconName:"ErrorBarClear"},onDismiss:()=>t.onDismissNotification(i),messageBarIconProps:o},r)}))},uri=(t,e)=>{var i,r,o,l;switch(t.capabilityName){case"shareScreen":if(t.isPresent&&t.changedReason==="RoleChanged"&&t.role==="Presenter")return(i=e?.shareScreen)===null||i===void 0?void 0:i.grantedDueToRoleChangeToPresenter;if(!t.isPresent&&t.changedReason==="RoleChanged"&&t.role==="Attendee")return(r=e?.shareScreen)===null||r===void 0?void 0:r.lostDueToRoleChangeToAttendee;break;case"viewAttendeeNames":if(!t.isPresent&&t.changedReason==="MeetingOptionOrOrganizerPolicyChanged"&&t.role==="Attendee")return(o=e?.hideAttendeeNames)===null||o===void 0?void 0:o.hideAttendeeNameAttendee;if(!t.isPresent&&t.changedReason==="MeetingOptionOrOrganizerPolicyChanged"&&t.role==="Presenter")return(l=e?.hideAttendeeNames)===null||l===void 0?void 0:l.hideAttendeeNamePresenter}},hri=t=>{let e;switch(t.capabilityName){case"turnVideoOn":t.isPresent?e="ControlButtonCameraOn":e="ControlButtonCameraProhibited";break;case"unmuteMic":t.isPresent?e="ControlButtonMicOn":e="ControlButtonMicProhibited";break;default:return}return{iconName:e,styles:{root:{"> *":{height:"1rem",width:"1rem"}}}}},pri={innerText:{alignSelf:"center"},icon:{height:0},content:{lineHeight:"inherit"},dismissal:{height:0,paddingTop:"0.8rem"}};var X8=function(t,e,i,r){function o(l){return l instanceof i?l:new i(function(d){d(l)})}return new(i||(i=Promise))(function(l,d){function h(f){try{g(r.next(f))}catch(y){d(y)}}function p(f){try{g(r.throw(f))}catch(y){d(y)}}function g(f){f.done?l(f.value):o(f.value).then(h,p)}g((r=r.apply(t,e||[])).next())})};const V6e=(t,e,i,r)=>{const o=ks().strings.call;return $.useMemo(()=>!i||!r?{onStartLocalSpotlightWithPrompt:t,onStopLocalSpotlightWithPrompt:e}:{onStartLocalSpotlightWithPrompt:t?gri(t,i,r,o):void 0,onStopLocalSpotlightWithPrompt:e?mri(e,i,r,o):void 0},[t,e,i,r,o])},gri=(t,e,i,r)=>()=>X8(void 0,void 0,void 0,function*(){i({heading:r.spotlightPrompt.startSpotlightHeading,text:r.spotlightPrompt.startSpotlightOnSelfText,confirmButtonLabel:r.spotlightPrompt.startSpotlightConfirmButtonLabel,cancelButtonLabel:r.spotlightPrompt.startSpotlightCancelButtonLabel,closeButtonLabel:r.spotlightPrompt.closeSpotlightPromptButtonLabel,onConfirm:()=>{t(),e(!1)},onCancel:()=>e(!1)}),e(!0)}),mri=(t,e,i,r)=>()=>X8(void 0,void 0,void 0,function*(){i({heading:r.spotlightPrompt.stopSpotlightOnSelfHeading,text:r.spotlightPrompt.stopSpotlightOnSelfText,confirmButtonLabel:r.spotlightPrompt.stopSpotlightOnSelfConfirmButtonLabel,cancelButtonLabel:r.spotlightPrompt.stopSpotlightCancelButtonLabel,onConfirm:()=>{t(),e(!1)},onCancel:()=>e(!1)}),e(!0)}),$6e=(t,e,i,r)=>{const o=ks().strings.call;return $.useMemo(()=>!i||!r?{onStartRemoteSpotlightWithPrompt:t,onStopRemoteSpotlightWithPrompt:e}:{onStartRemoteSpotlightWithPrompt:t?fri(t,i,r,o):void 0,onStopRemoteSpotlightWithPrompt:e?vri(e,i,r,o):void 0},[t,e,i,r,o])},fri=(t,e,i,r)=>o=>X8(void 0,void 0,void 0,function*(){o.length>1&&t(o),i({heading:r.spotlightPrompt.startSpotlightHeading,text:r.spotlightPrompt.startSpotlightText,confirmButtonLabel:r.spotlightPrompt.startSpotlightConfirmButtonLabel,cancelButtonLabel:r.spotlightPrompt.startSpotlightCancelButtonLabel,closeButtonLabel:r.spotlightPrompt.closeSpotlightPromptButtonLabel,onConfirm:()=>{t(o),e(!1)},onCancel:()=>e(!1)}),e(!0)}),vri=(t,e,i,r)=>o=>X8(void 0,void 0,void 0,function*(){o.length>1&&t(o),i({heading:r.spotlightPrompt.stopSpotlightHeading,text:r.spotlightPrompt.stopSpotlightText,confirmButtonLabel:r.spotlightPrompt.stopSpotlightConfirmButtonLabel,cancelButtonLabel:r.spotlightPrompt.stopSpotlightCancelButtonLabel,closeButtonLabel:r.spotlightPrompt.closeSpotlightPromptButtonLabel,onConfirm:()=>{t(o),e(!1)},onCancel:()=>e(!1)}),e(!0)}),yri=(t,e,i)=>{const r=ks().strings.call;return $.useMemo(()=>!e||!i?{stopAllSpotlightWithPrompt:t}:{stopAllSpotlightWithPrompt:t?Sri(t,e,i,r):void 0},[t,e,i,r])},Sri=(t,e,i,r)=>()=>X8(void 0,void 0,void 0,function*(){i({heading:r.spotlightPrompt.stopAllSpotlightHeading,text:r.spotlightPrompt.stopAllSpotlightText,confirmButtonLabel:r.spotlightPrompt.stopSpotlightConfirmButtonLabel,cancelButtonLabel:r.spotlightPrompt.stopSpotlightCancelButtonLabel,closeButtonLabel:r.spotlightPrompt.closeSpotlightPromptButtonLabel,onConfirm:()=>{t(),e(!1)},onCancel:()=>e(!1)}),e(!0)}),bri=t=>{const e=qn(Yii),i=t.component.strings.notificationStack;return i.breakoutRoomJoined&&t.strings.call.breakoutRoomJoinedNotificationTitle&&e&&(i.breakoutRoomJoined.title=t.strings.call.breakoutRoomJoinedNotificationTitle.replace("{roomName}",e)),i},H6e=t=>{var e,i;const r=t.strings,o=hc();return U.createElement(Et,{horizontalAlign:"center"},U.createElement(Et,{"data-ui-id":"banner",className:Cri(o)},U.createElement(Et,{horizontal:!0,horizontalAlign:"space-between"},U.createElement(Et,{horizontal:!0},((e=t.iconProps)===null||e===void 0?void 0:e.iconName)&&U.createElement(Fr,Object.assign({className:_ri,iconName:(i=t.iconProps)===null||i===void 0?void 0:i.iconName},t.iconProps)),U.createElement(ja,{className:Tri},r?.title)),t.primaryButton?U.createElement(SE,{text:r?.primaryButtonLabel,ariaLabel:r?.primaryButtonLabel,onClick:t.onClickButton}):U.createElement(th,{text:r?.primaryButtonLabel,ariaLabel:r?.primaryButtonLabel,onClick:t.onClickButton}))))},Tri=It({fontWeight:400,fontSize:_n(14),lineHeight:_n(16),alignSelf:"center"}),Cri=t=>It({boxShadow:t.effects.elevation8,width:"20rem",padding:"0.75rem",borderRadius:"0.25rem",position:"relative",backgroundColor:t.palette.white}),_ri=It({fontSize:"1.25rem",alignSelf:"center",marginRight:"0.5rem",svg:{width:"1.25rem",height:"1.25rem"}}),Eri=t=>{const{locale:e,adapter:i}=t,r=qn(Uje),o=qn(zje),l=qn(Qii);return r&&r.state==="open"&&!o&&!l.assignedBreakoutRoomOpened?U.createElement(Et,{styles:kX},U.createElement(H6e,{strings:{title:r.displayName?e.strings.call.joinBreakoutRoomBannerTitle.replace("{roomName}",r.displayName):e.strings.call.joinBreakoutRoomBannerTitle,primaryButtonLabel:e.strings.call.joinBreakoutRoomBannerButtonLabel},onClickButton:()=>r.join(),iconProps:{iconName:"NotificationBarBreakoutRoomPromptJoin"},primaryButton:!0})):o&&o.disableReturnToMainMeeting!==!0?U.createElement(Et,{styles:kX},U.createElement(H6e,{strings:{title:e.strings.call.returnFromBreakoutRoomBannerTitle,primaryButtonLabel:e.strings.call.returnFromBreakoutRoomBannerButtonLabel},onClickButton:()=>i.returnFromBreakoutRoom(),iconProps:{iconName:"NotificationBarBreakoutRoomClosingSoon"}})):null},j6e=4,OX=t=>{var e,i,r,o,l,d,h,p,g,f,y,T,C;const E=$.useMemo(()=>t.mobileView?Eni:_ni,[t.mobileView]),I=Cs(),w=$.useMemo(()=>Ani(I.palette.neutralLighterAlt),[I.palette.neutralLighterAlt]),D=$.useRef(null),F=$.useRef(null),x=$.useRef(null),B=$.useRef(null),L=nF(B),z=_8(B),H=g4(qn(Y8).callStatus),{updateSidePaneRenderer:j}=t,J=qn(Oje)==="hold",Z=qn(z4),re=QE(),[ne,le]=$.useState(),he=qn(GO),[Me,Le]=$.useState([]);$.useEffect(()=>{ne&&he?.[ne]===void 0&&Le([])},[ne,he]);const pe=qn(AX),te={updateSidePaneRenderer:j,mobileView:t.mobileView,conferencePhoneInfo:pe},Se=$.useMemo(()=>{var as;return{updateSidePaneRenderer:j,setDrawerMenuItems:Le,inviteLink:t.callControlProps.callInvitationURL,onFetchAvatarPersonaData:t.onFetchAvatarPersonaData,onFetchParticipantMenuItems:(as=t.callControlProps)===null||as===void 0?void 0:as.onFetchParticipantMenuItems,mobileView:t.mobileView,peopleButtonRef:D,setParticipantActioned:le,sidePaneDismissButtonRef:x,chatButtonPresent:!!t.onCloseChatPane}},[j,t.callControlProps.callInvitationURL,(e=t.callControlProps)===null||e===void 0?void 0:e.onFetchParticipantMenuItems,t.onFetchAvatarPersonaData,t.mobileView,D,le,x,t.onCloseChatPane]),ce=ks(),X=qn(XC),ve=mc(XZ),Te=JA(),{setPromptProps:Be,setIsPromptOpen:qe,hideSpotlightButtons:Ge}=t,{onStartLocalSpotlight:tt,onStopLocalSpotlight:ct,onStartRemoteSpotlight:Mt,onStopRemoteSpotlight:ht,onMuteParticipant:vt,spotlightedParticipants:Pt,maxParticipantsToSpotlight:ni,localParticipant:Zt,onForbidAudio:it,onPermitAudio:Ke,onForbidVideo:ot,onPermitVideo:Ht}=ve,[jt,Nt]=$.useState(!1),Vt=$.useCallback(()=>{Nt(!jt)},[jt]),{isMeetingPhoneInfoPaneOpen:$t,openMeetingPhoneInfoPane:dt,closeMeetingPhoneInfoPane:yt}=Kai(Object.assign({},te)),kt=$.useCallback(()=>{$t?yt():dt()},[yt,$t,dt]),je=$.useCallback(()=>{pn(!1),kt()},[kt]),{pinnedParticipants:Ae,setPinnedParticipants:xe}=t,gt=$.useCallback(as=>{Ae&&Ae.length>=j6e||Ae&&xe&&!Ae.includes(as)&&xe(Ae.concat(as))},[Ae,xe]),Ye=$.useCallback(as=>{Ae&&xe&&xe(Ae.filter(td=>td!==as))},[xe,Ae]),Fe=$.useMemo(()=>({pinnedParticipants:Ae,onPinParticipant:gt,onUnpinParticipant:Ye,disablePinMenuItem:Ae&&Ae.length>=j6e}),[gt,Ye,Ae]),{onStartLocalSpotlightWithPrompt:St,onStopLocalSpotlightWithPrompt:Wt}=V6e(tt,ct,qe,Be),{onStartRemoteSpotlightWithPrompt:Ii,onStopRemoteSpotlightWithPrompt:en}=$6e(Mt,ht,qe,Be),sn=Z?.removeParticipantsSpotlight.isPresent,Qi=$.useMemo(()=>sn?()=>re.stopAllSpotlight():void 0,[sn,re]),{stopAllSpotlightWithPrompt:qt}=yri(Qi,qe,Be),ri=$.useMemo(()=>{var as,td;return{onMuteParticipant:!((as=Z?.muteOthers)===null||as===void 0)&&as.isPresent||X==="Unknown"?vt:void 0,onMuteAllRemoteParticipants:!((td=Z?.muteOthers)===null||td===void 0)&&td.isPresent||X==="Unknown"?Te.onMuteAllRemoteParticipants:void 0}},[vt,X,Z?.muteOthers,Te.onMuteAllRemoteParticipants]),Ti=$.useMemo(()=>({spotlightedParticipantUserIds:Pt,onStartLocalSpotlight:Ge?void 0:St,onStopLocalSpotlight:Ge?void 0:Wt,onStartRemoteSpotlight:Ge?void 0:Ii,onStopRemoteSpotlight:Ge?void 0:en,onStopAllSpotlight:Ge?void 0:qt,maxParticipantsToSpotlight:ni}),[Ge,ni,St,Ii,Wt,en,qt,Pt]),rn=qn(ini),Hn=!!(!((i=Z?.forbidOthersAudio)===null||i===void 0)&&i.isPresent),ha=!!(!((r=Z?.forbidOthersVideo)===null||r===void 0)&&r.isPresent),hr=$.useMemo(()=>({onForbidAudio:Hn?it:void 0,onPermitAudio:Hn?Ke:void 0,onForbidOthersAudio:Hn?Te.onForbidOthersAudio:void 0,onPermitOthersAudio:Hn?Te.onPermitOthersAudio:void 0,onForbidVideo:ha?ot:void 0,onPermitVideo:ha?Ht:void 0,onForbidOthersVideo:ha?Te.onForbidOthersVideo:void 0,onPermitOthersVideo:ha?Te.onPermitOthersVideo:void 0,meetingMediaAccess:rn}),[Hn,it,Ke,Te.onForbidOthersAudio,Te.onPermitOthersAudio,Te.onForbidOthersVideo,Te.onPermitOthersVideo,ha,ot,Ht,rn]),{isPeoplePaneOpen:yn,openPeoplePane:pr,closePeoplePane:Ho}=jai(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({},Se),Ti),ri),Fe),hr)),Rr=$.useCallback(()=>{yn?Ho():pr()},[Ho,yn,pr]);$.useEffect(()=>{J&&j(void 0)},[j,J,yn,Ho]);const La=w6e(),[us,al]=$.useState(!La&&t.mobileView);$.useEffect(()=>{La&&t.mobileView?al(!1):al(!0)},[t.mobileView,La]);const Us={dismissModalAriaLabel:ce.strings.call.dismissModalAriaLabel},$r=t.mobileView&&La,Zd=$.useMemo(()=>({display:$r?"none":"flex",minWidth:t.mobileView?"unset":`${hni}rem`,width:"100%",height:"100%",position:"relative"}),[$r,t.mobileView]),rc=qn(Vje),{openVideoEffectsPane:Yl,isVideoEffectsPaneOpen:ci}=z6e(t.updateSidePaneRenderer,t.mobileView,t.latestErrors,t.onDismissError,F),[Ai,pn]=$.useState(!1),Bn=$.useCallback(()=>{pn(!0)},[]),Pa=$.useCallback(()=>{pn(!1)},[]),qa=$.useCallback(()=>{pn(!1),Rr()},[Rr]),kr=$.useMemo(()=>DX(Cni),[]);let Sa=t.showErrorNotifications?t.latestErrors:[];const aa=qn(W4).isAvailable;X==="Consumer"&&(t.errorBarProps||t.showErrorNotifications)&&(Sa=Sa.filter(as=>as.type!=="callCameraAccessDenied"&&as.type!=="callCameraAccessDeniedSafari")),t.doNotShowCameraAccessNotifications&&(Sa=Sa.filter(as=>as.type!=="callCameraAccessDenied"&&as.type!=="callCameraAccessDeniedSafari"));const ti=Q8(Bfe);(ti||!aa)&&(t.errorBarProps||t.showErrorNotifications)&&(Sa=Sa.filter(as=>as.type!=="unableToStartVideoEffect"));const on=qn(EX),Fn=qn(Fje),Or=on&&((o=Z?.setCaptionLanguage)===null||o===void 0?void 0:o.isPresent)||Fn,Co=qn(G8)==="Connected",za=qn(qii),Za=qni(t.modalLayerHostId),ns=$.useMemo(()=>$ni(I),[I]),Uu=$.useMemo(()=>{var as;return Object.assign(Object.assign({},Ini),((as=t?.captionsOptions)===null||as===void 0?void 0:as.height)==="full"?{root:{postion:"absolute"}}:{})},[(l=t?.captionsOptions)===null||l===void 0?void 0:l.height]);on&&Sa.filter(as=>as.type==="teamsMeetingCallNetworkQualityLow").forEach(as=>{as.onClickPrimaryButton=t.mobileView?kt:Vt});const ml=!!(t.mobileView&&L&&z&&L/z>1),Cu=t.mobileView?(d=t.capabilitiesChangedNotificationBarProps)===null||d===void 0?void 0:d.capabilitiesChangedNotifications.filter(as=>as.capabilityName!=="shareScreen"):(h=t.capabilitiesChangedNotificationBarProps)===null||h===void 0?void 0:h.capabilitiesChangedNotifications,Xd=bri(ce);let Il=t.latestNotifications;Il=t.mobileView?(Il??[]).filter(as=>as.type!=="assignedBreakoutRoomOpenedPromptJoin"):Il;const Pp=qn(Cfe);return U.createElement("div",{ref:B,className:It(uni),id:t.id},U.createElement(Et,{verticalFill:!0,horizontalAlign:"stretch",className:E,"data-ui-id":t.dataUiId},U.createElement(Et,{reversed:!0,horizontal:ml,grow:!0,styles:kni(ml)},U.createElement(Et,{horizontal:!0,grow:!0},U.createElement(Et.Item,{style:Zd},U.createElement(Et.Item,{styles:w,grow:!0},U.createElement(Et,{verticalFill:!0,styles:Uu},U.createElement(Et.Item,{styles:wni},t.mobileView&&U.createElement(Eri,{locale:ce,adapter:re}),t.showErrorNotifications&&U.createElement(Et,{styles:i6e,horizontalAlign:"center",verticalAlign:"center"},U.createElement(H8,{onDismissNotification:t.onDismissError,activeNotifications:Sa})),Il&&U.createElement(Et,{styles:i6e,horizontalAlign:"center",verticalAlign:"center"},U.createElement(H8,{activeNotifications:Il,onDismissNotification:t.onDismissNotification,strings:Xd})),t.capabilitiesChangedNotificationBarProps&&t.capabilitiesChangedNotificationBarProps.capabilitiesChangedNotifications.length>0&&U.createElement(Et,{styles:kX},U.createElement(dri,Object.assign({},t.capabilitiesChangedNotificationBarProps,{capabilitiesChangedNotifications:Cu??[]})))),us&&t.onRenderGalleryContent&&t.onRenderGalleryContent(),!J&&U.createElement(dni,{captionsOptions:t.captionsOptions,isMobile:t.mobileView,onFetchAvatarPersonaData:t.onFetchAvatarPersonaData,useTeamsCaptions:Or})))),U.createElement(k6e,{mobileView:t.mobileView,maxWidth:ti?`${Z8}rem`:void 0,minWidth:ti?`${Z8}rem`:void 0,updateSidePaneRenderer:t.updateSidePaneRenderer,onPeopleButtonClicked:t.mobileView&&!Iri(t.callControlProps.options)?void 0:Rr,disablePeopleButton:typeof t.callControlProps.options!="boolean"&&tm((p=t.callControlProps.options)===null||p===void 0?void 0:p.participantsButton),onChatButtonClicked:(g=t.mobileChatTabHeader)===null||g===void 0?void 0:g.onClick,disableChatButton:(f=t.mobileChatTabHeader)===null||f===void 0?void 0:f.disabled,showAddPeopleButton:!!t.callControlProps.callInvitationURL,ariaLabel:ci?ce.strings.call.videoEffectsPaneAriaLabel:void 0}),t.mobileView&&U.createElement(cri,{modalLayerHostId:t.modalLayerHostId,hidden:!La,styles:ns,strings:Us,minDragPosition:Za.minDragPosition,maxDragPosition:Za.maxDragPosition,onDismissSidePane:()=>{Ho(),t.onCloseChatPane&&t.onCloseChatPane()}}),Me.length>0&&U.createElement(Et,{styles:DX()},U.createElement(sF,{onLightDismiss:()=>Le([]),items:Me}))),((y=t.callControlProps)===null||y===void 0?void 0:y.options)!==!1&&!$r&&U.createElement(Et,{verticalAlign:"center",className:It({zIndex:Efe,padding:ml?"0.25rem":"unset"})},Ari((T=t.callControlProps)===null||T===void 0?void 0:T.options)?U.createElement(Oni,Object.assign({},t.callControlProps,{containerWidth:L,containerHeight:z,isMobile:t.mobileView,peopleButtonChecked:yn,onPeopleButtonClicked:Rr,displayVertical:ml})):U.createElement(Xni,Object.assign({},t.callControlProps,{callControls:t.callControlProps.options,callAdapter:re,mobileView:t.mobileView,disableButtonsForLobbyPage:H,disableButtonsForHoldScreen:J,peopleButtonChecked:yn,onPeopleButtonClicked:Rr,onMoreButtonClicked:Bn,isCaptionsSupported:Or&&Co||Co,useTeamsCaptions:Or,isCaptionsOn:za,onClickVideoEffects:rc?Yl:void 0,displayVertical:ml,onUserSetOverflowGalleryPositionChange:t.onUserSetOverflowGalleryPositionChange,onUserSetGalleryLayout:t.onUserSetGalleryLayoutChange,userSetGalleryLayout:t.userSetGalleryLayout,onSetDialpadPage:t.onSetDialpadPage,dtmfDialerPresent:t.dtmfDialerPresent,peopleButtonRef:D,cameraButtonRef:F,onStopLocalSpotlight:!Ge&&Zt.spotlight?Wt:void 0,onToggleTeamsMeetingConferenceModal:Vt,teamsMeetingConferenceModalPresent:jt,sidePaneDismissButtonRef:x}))),((C=t.callControlProps)===null||C===void 0?void 0:C.options)!==!1&&Ai&&U.createElement(Et,{styles:kr},U.createElement(hai,{callControls:t.callControlProps.options,onLightDismiss:Pa,onPeopleButtonClicked:qa,disableButtonsForHoldScreen:J,isCaptionsSupported:Or&&Co||Co,useTeamsCaptions:Or,onUserSetGalleryLayout:t.onUserSetGalleryLayoutChange,userSetGalleryLayout:t.userSetGalleryLayout,onSetDialpadPage:t.onSetDialpadPage,dtmfDialerPresent:t.dtmfDialerPresent,dtmfDialerOptions:t.dtmfDialerOptions,reactionResources:Pp,onClickMeetingPhoneInfo:je})))))},Ari=t=>!!t&&t!==!0&&t?.legacyControlBarExperience===!0,Iri=t=>t===void 0||t===!0?!0:t===!1?!1:t.participantsButton!==!1&&t.peopleButton!==!1,G6e=Xs([q8],t=>({cameras:t.cameras,selectedCamera:t.selectedCamera})),wri={root:{height:"100%",minHeight:"10rem",minWidth:"6rem"}},kri={scalingMode:"Crop",isMirrored:!0},Rri={scalingMode:"Crop"},Mri=t=>{var e,i;const{pinnedParticipants:r=[],setPinnedParticipants:o,setIsPromptOpen:l,setPromptProps:d,hideSpotlightButtons:h,videoTilesOptions:p,captionsOptions:g}=t,f=mc(XZ),y=qn(G6e),T=JA(),C=Bni(),E=qn(XC),I=qn(z4),w=qn(W8),D=$.useRef(null),F=nF(D),x=_8(D),B=F&&x?F/x:0,L=qn(Cfe),z=Dri((e=t.localVideoTileOptions)===null||e===void 0?void 0:e.position),H=$.useMemo(()=>Object.assign(Object.assign({},T),y),[T,y]),j=$.useCallback((Te,Be)=>U.createElement(Et,{className:It({position:"absolute",height:"100%",width:"100%"})},U.createElement(Et,{styles:{root:{margin:"auto",maxHeight:"100%"}}},Be?.coinSize&&U.createElement(U4,Object.assign({userId:Te},Be,{dataProvider:t.onFetchAvatarPersonaData})))),[t.onFetchAvatarPersonaData]),J=$.useMemo(()=>{var Te;return!((Te=t.remoteVideoTileMenuOptions)===null||Te===void 0)&&Te.isHidden?!1:t.isMobile?{kind:"drawer",hostId:t.drawerMenuHostId}:{kind:"contextual"}},[(i=t.remoteVideoTileMenuOptions)===null||i===void 0?void 0:i.isHidden,t.isMobile,t.drawerMenuHostId]),Z=$.useMemo(()=>F&&x&&F/x>=16/9?"verticalRight":"horizontalBottom",[F,x]),{onStartLocalSpotlight:re,onStopLocalSpotlight:ne,onStartRemoteSpotlight:le,onStopRemoteSpotlight:he}=f,{onStartLocalSpotlightWithPrompt:Me,onStopLocalSpotlightWithPrompt:Le}=V6e(re,ne,l,d),{onStartRemoteSpotlightWithPrompt:pe,onStopRemoteSpotlightWithPrompt:te}=$6e(le,he,l,d),Se=$.useMemo(()=>Object.assign(Object.assign({},wri),g?.height==="full"?{root:{postion:"absolute"}}:{}),[g?.height]),ce=$.useMemo(()=>o?Te=>{r.includes(Te)||o(r.concat(Te))}:void 0,[o,r]),X=$.useMemo(()=>o?Te=>{o(r.filter(Be=>Be!==Te))}:void 0,[o,r]),ve=$.useMemo(()=>{var Te;const Be=()=>t.localVideoTileOptions?z:t.userSetGalleryLayout;return U.createElement(XZ,Object.assign({},f,{videoTilesOptions:p,localVideoViewOptions:kri,remoteVideoViewOptions:Rri,styles:Se,layout:Be(),showCameraSwitcherInLocalPreview:t.isMobile,localVideoCameraCycleButtonProps:H,onRenderAvatar:j,remoteVideoTileMenu:J,overflowGalleryPosition:Z,localVideoTileSize:t.localVideoTileOptions===!1||E==="Consumer"||w&&E==="Unknown"?"hidden":t.isMobile&&B<1?"9:16":"16:9",pinnedParticipants:r,onPinParticipant:ce,onUnpinParticipant:X,reactionResources:L,onStartLocalSpotlight:h?void 0:Me,onStopLocalSpotlight:h?void 0:Le,onStartRemoteSpotlight:h?void 0:pe,onStopRemoteSpotlight:h?void 0:te,onMuteParticipant:!((Te=I?.muteOthers)===null||Te===void 0)&&Te.isPresent||E==="Unknown"?f.onMuteParticipant:void 0,localScreenShareView:t.localScreenShareView}))},[f,p,Se,t.isMobile,t.localVideoTileOptions,t.userSetGalleryLayout,H,j,J,Z,E,w,B,r,ce,X,L,h,Me,Le,pe,te,z,I?.muteOthers,t.localScreenShareView]);return U.createElement("div",{ref:D,style:Pri},U.createElement(GA,{announcementString:C,ariaLive:"polite"}),ve)},Pri={width:"100%",height:"100%"},Dri=t=>t==="grid"?"default":"floatingLocalVideo",q6e=0,Lri=q6e+1,Ori={root:{height:"100%",width:"100%",position:"relative",padding:"0.5rem"}},Nri=t=>({position:"absolute",height:"100%",width:"100%",background:t?"black":void 0,opacity:t?.6:void 0,zIndex:q6e}),xri={height:"100%",width:"100%",zIndex:Lri},Bri={root:{height:"100%",width:"100%"}},Fri=()=>U.createElement(U.Fragment,null),Uri={scalingMode:"Crop",isMirrored:!0},W6e=t=>{var e;const i=t.localParticipantVideoStream,r=(e=i?.isAvailable)!==null&&e!==void 0?e:!1,o=i?.renderElement;return $.useEffect(()=>{i&&r&&t.onCreateLocalStreamView&&t.onCreateLocalStreamView(Uri).catch(l=>console.log("Can not render video",l))},[r,i,t,o]),U.createElement(Et,{horizontalAlign:"center",verticalAlign:"center",styles:Ori,grow:!0},U.createElement(UO,{styles:Bri,renderElement:o?U.createElement(w4,{videoStreamElement:o}):void 0,onRenderPlaceholder:Fri},t.overlayContent&&U.createElement(U.Fragment,null,U.createElement(Et,{className:It(Nri(r))}),U.createElement(Et,{horizontalAlign:"center",verticalAlign:"center",className:It(xri)},t.overlayContent))))},K6e={margin:"1rem",gap:"1.5rem"},zri={gap:"1.5rem",height:"auto"},Vri={gap:"1rem"},J6e=(t,e)=>({fontSize:"1.25rem",fontWeight:xs.semibold,color:e?"white":t.neutralPrimary,textAlign:"center"}),$ri=(t,e)=>({fontSize:"1rem",color:e?"white":t.neutralPrimary,textAlign:"center"}),Hri=t=>{var e;const i=t.localParticipantVideoStream,r=(e=i?.isAvailable)!==null&&e!==void 0?e:!1,o=Cs().palette,l=ks().strings.call,d=ks().component.strings.meetingConferencePhoneInfo,h=Cs(),p=JA(),g=qn(EX),f=qn(AX);return U.createElement(W6e,Object.assign({localParticipantVideoStream:t.localParticipantVideoStream,overlayContent:U.createElement(Et,{verticalFill:!0,horizontalAlign:"center",verticalAlign:"center",className:It(K6e),"aria-atomic":!0},U.createElement(Et,{role:"alert",verticalFill:!0,horizontalAlign:"center",verticalAlign:"center",className:It(zri)},U.createElement(Et,{horizontal:!0,className:It(Vri)},U.createElement(YE,{iconName:"NetworkReconnectIcon",className:It(J6e(o,r))}),U.createElement(ja,{className:It(J6e(o,r))},l.networkReconnectTitle)),U.createElement(ja,{className:It($ri(o,r))},l.networkReconnectMoreDetails)),g&&f&&f[0]&&U.createElement(Et,null,U.createElement(Et,{horizontal:!0,horizontalAlign:"center",verticalAlign:"center",className:qai},U.createElement(ja,{className:Gai},d.meetingConferencePhoneInfoModalTitle)),U.createElement(Et,{horizontal:!0,horizontalAlign:"space-between",className:G4},U.createElement(Et,{className:F6e(h)}),U.createElement(Et.Item,null,U.createElement(Et,{horizontal:!0,className:LX},U.createElement(Et.Item,{className:j4(h)},U.createElement(Et,{verticalAlign:"center",horizontalAlign:"center"},U.createElement(Fr,{iconName:"JoinByPhoneDialStepIcon",className:q4(h)}))),U.createElement(Et.Item,null,U.createElement(ja,{className:H4},d.meetingConferencePhoneInfoModalDialIn)))),U.createElement(Et.Item,{className:LX},f.map((y,T)=>U.createElement(Et.Item,{key:T},U.createElement(ja,{className:Dk},t.isMobile&&U.createElement(uW,{className:Dk,href:F$e(y)},V8(y.phoneNumber,!0)),!t.isMobile&&U.createElement(ja,{className:Dk},V8(y.phoneNumber,!0))," ",y.isTollFree?d.meetingConferencePhoneInfoModalTollFree:d.meetingConferencePhoneInfoModalToll),U.createElement("br",null),U.createElement(ja,{className:Dk}," ",Gme(y,d)))))),U.createElement(Et,{horizontal:!0,horizontalAlign:"space-between",verticalAlign:"center",className:G4},U.createElement(Et.Item,null,U.createElement(Et,{horizontal:!0},!t.isMobile&&U.createElement(Et,{className:F6e(h)}),U.createElement(Et.Item,{className:j4(h)},U.createElement(Fr,{iconName:"JoinByPhoneConferenceIdIcon",className:q4(h)})),U.createElement(Et.Item,null,U.createElement(ja,{className:H4},d.meetingConferencePhoneInfoModalMeetingId)))),U.createElement(ja,{className:Dk},f[0].conferenceId,"#")),!t.isMobile&&U.createElement(Et,{horizontal:!0,horizontalAlign:"space-between",verticalAlign:"center",className:G4},U.createElement(Et,{horizontal:!0},U.createElement(Et.Item,{className:j4(h),style:{marginLeft:_n(2)}},U.createElement(Fr,{iconName:"JoinByPhoneWaitToBeAdmittedIcon",className:q4(h)})),U.createElement(Et.Item,null,U.createElement(ja,{className:H4},d.meetingConferencePhoneInfoModalWait))))))},p))},Y6e=Xs([$ii,Hii],(t,e)=>({callTranscribeState:t,callRecordState:e})),jri=Xs([Bje],t=>{var e;return{speakingWhileMuted:!!(!((e=t?.media.latest.speakingWhileMicrophoneIsMuted)===null||e===void 0)&&e.value)}}),Q6e=Xs([W4],t=>({localParticipantVideoStream:t})),Gri=Xs([Bje,Q6e],(t,e)=>{var i;return{networkReconnectValue:(i=t?.network.latest.networkReconnect)===null||i===void 0?void 0:i.value,localParticipantVideoStream:e.localParticipantVideoStream}}),qri={root:{color:"inherit",fontWeight:600,fontSize:_n(20),lineHeight:_n(28),margin:"auto"}};var Wri=function(t,e,i,r){function o(l){return l instanceof i?l:new i(function(d){d(l)})}return new(i||(i=Promise))(function(l,d){function h(f){try{g(r.next(f))}catch(y){d(y)}}function p(f){try{g(r.throw(f))}catch(y){d(y)}}function g(f){f.done?l(f.value):o(f.value).then(h,p)}g((r=r.apply(t,e||[])).next())})};const Kri=t=>{const e=hc(),i=qn(V4),r=qn(GO),o=i?.[0];let l;if(r){const h=Object.values(r);o&&Vf(o)?l=o.phoneNumber:l=h.find(p=>p.identifier===o)}const d=QE();return U.createElement(Et,{style:{height:"100%",width:"100%",background:e.palette.white}},U.createElement(Et,{verticalAlign:"center",style:{margin:"auto"}},U.createElement(Jri,null),U.createElement(ja,{style:{margin:"auto"}},l&&l!=="Unnamed participant"?l?.toString():""),U.createElement(zme,{onSendDtmfTone:h=>Wri(void 0,void 0,void 0,function*(){yield d.sendDtmfTone(h)}),longPressTrigger:t.mobileView?"touch":"mouseAndTouch",dialpadMode:"dtmf",dtmfAudioContext:t.compositeAudioContext})))},Jri=()=>{const[t,e]=$.useState(0),i=f6e(t),r=qn(Kii),o=$.useMemo(()=>r??new Date(Date.now()),[r]);return $.useEffect(()=>{const l=setInterval(()=>{var d;e((d=new Date(Date.now()).getTime()-o?.getTime())!==null&&d!==void 0?d:0)},10);return()=>{clearInterval(l)}},[o]),U.createElement(ja,{styles:qri},i)},Yri=t=>U.createElement(Kri,Object.assign({},t,{mobileView:t.mobileView})),Z6e=t=>{var e,i;const{callInvitationURL:r,onFetchAvatarPersonaData:o,onFetchParticipantMenuItems:l,options:d,mobileView:h,galleryLayout:p="floatingLocalVideo",onUserSetGalleryLayoutChange:g,userSetOverflowGalleryPosition:f="Responsive",onSetUserSetOverflowGalleryPosition:y,onCloseChatPane:T,pinnedParticipants:C=[],setPinnedParticipants:E,compositeAudioContext:I,disableAutoShowDtmfDialer:w={dialerBehavior:"autoShow"},latestNotifications:D,onDismissNotification:F}=t,{callStatus:x}=qn(Y8),B=qn(xni),L=JA(),z=qn(Y6e),H=mc(jA),j=qn(jri),J=qn(Gri),Z=qn(Ife),re=qn(V4),ne=wfe(re,Z,w),[le,he]=$.useState(ne),Me=ks().strings.call,Le=$.useMemo(()=>C.filter(Mt=>Z.find(ht=>Ga(ht.identifier)===Mt)),[C,Z]),pe=h?TX(d?.callControls):d?.callControls,te=yu("drawerMenuHost"),[Se,ce]=$.useState(!1),[X,ve]=$.useState(),Te=qn(Mt=>Mt.page),Be=qn(Mt=>Mt.userId),qe=qn(Mt=>Mt.displayName),Ge=$.useCallback((Mt,ht)=>U.createElement(Et,{className:It({position:"absolute",height:"100%",width:"100%"})},U.createElement(Et,{styles:{root:{margin:"auto",maxHeight:"100%"}}},ht?.coinSize&&U.createElement(U4,Object.assign({userId:Mt},ht,{dataProvider:t.onFetchAvatarPersonaData})))),[t.onFetchAvatarPersonaData]);let tt=U.createElement(U.Fragment,null);!HA(x)&&Te==="returningFromBreakoutRoom"&&(tt=U.createElement(UO,{userId:Ga(Be),displayName:qe,initialsName:qe,onRenderPlaceholder:Ge}));const ct=()=>{var Mt,ht;return le?U.createElement(Yri,{mobileView:t.mobileView,modalLayerHostId:t.modalLayerHostId,options:t.options,updateSidePaneRenderer:t.updateSidePaneRenderer,mobileChatTabHeader:t.mobileChatTabHeader,latestErrors:t.latestErrors,onDismissError:t.onDismissError,capabilitiesChangedNotificationBarProps:t.capabilitiesChangedNotificationBarProps,onSetDialpadPage:()=>he(!le),dtmfDialerPresent:le,compositeAudioContext:I}):U.createElement(Mri,Object.assign({isMobile:h},B,L,{onFetchAvatarPersonaData:o,remoteVideoTileMenuOptions:d?.remoteVideoTileMenuOptions,drawerMenuHostId:te,localVideoTileOptions:d?.localVideoTile,userSetOverflowGalleryPosition:f,userSetGalleryLayout:p,pinnedParticipants:Le,setPinnedParticipants:E,setIsPromptOpen:ce,setPromptProps:ve,hideSpotlightButtons:(Mt=d?.spotlight)===null||Mt===void 0?void 0:Mt.hideSpotlightButtons,videoTilesOptions:d?.videoTilesOptions,captionsOptions:d?.captionsBanner,localScreenShareView:(ht=d?.galleryOptions)===null||ht===void 0?void 0:ht.localScreenShareView}))};return U.createElement(U.Fragment,null,U.createElement(OX,{id:te,complianceBannerProps:Object.assign(Object.assign({},z),{strings:Me}),errorBarProps:d?.errorBar!==!1&&H,showErrorNotifications:(e=d?.errorBar)!==null&&e!==void 0?e:!0,mutedNotificationProps:j,callControlProps:{callInvitationURL:r,onFetchParticipantMenuItems:l,options:pe,increaseFlyoutItemSize:h},onFetchAvatarPersonaData:o,mobileView:h,modalLayerHostId:t.modalLayerHostId,onRenderGalleryContent:()=>HA(x)?Qri(J.networkReconnectValue)?ct():U.createElement(Hri,Object.assign({},J,{isMobile:h})):tt,updateSidePaneRenderer:t.updateSidePaneRenderer,mobileChatTabHeader:t.mobileChatTabHeader,onCloseChatPane:T,dataUiId:"call-page",latestErrors:t.latestErrors,latestNotifications:D,onDismissError:t.onDismissError,onDismissNotification:F,onUserSetOverflowGalleryPositionChange:y,onUserSetGalleryLayoutChange:g,userSetGalleryLayout:p,capabilitiesChangedNotificationBarProps:t.capabilitiesChangedNotificationBarProps,onSetDialpadPage:()=>he(!le),dtmfDialerPresent:le,setIsPromptOpen:ce,setPromptProps:ve,hideSpotlightButtons:(i=d?.spotlight)===null||i===void 0?void 0:i.hideSpotlightButtons,pinnedParticipants:Le,setPinnedParticipants:E,captionsOptions:d?.captionsBanner,dtmfDialerOptions:w}),U.createElement(fF,Object.assign({isOpen:Se,onDismiss:()=>ce(!1)},X)))},Qri=t=>t===!0||t===!1||t===void 0||t===ah.Good,e7=2.25,Zri={childrenGap:"0.5rem"},Xri={childrenGap:"0.5rem"},t7=t=>({caretDownWrapper:{height:`${e7}rem`,lineHeight:`${e7}rem`},dropdownItem:{fontSize:"0.875rem",height:`${e7}rem`,background:t.palette.white},dropdown:{height:`${e7}rem`,width:"100%",svg:{verticalAlign:"top"}},title:{fontSize:"0.875rem",height:`${e7}rem`,lineHeight:"2rem",borderRadius:"0.25rem",border:`1px solid ${t.palette.neutralQuaternaryAlt}`},label:{fontWeight:600,fontSize:"0.875rem",zIndex:1},errorMessage:{fontSize:"0.875rem"}}),eoi=It({overflow:"hidden",textOverflow:"ellipsis",minWidth:"0",maxWidth:"100%",overflowWrap:"break-word",margin:".063rem"}),Ffe=It({marginRight:"8px",verticalAlign:"text-top"}),toi={root:{zIndex:1}},ioi=t=>t.cameraGrantedDropdown,noi=t=>t.micGrantedDropdown,X6e=11,e8e=20.625,Ufe=13.625,t8e=3,aoi={childrenGap:"1.5rem"},roi={childrenGap:"0.5rem"},ooi={childrenGap:"1.5rem"},soi=(t,e)=>({display:"flex",flexFlow:"column",height:"100%",position:"relative",width:"100%",padding:t?"2rem 1rem 2rem 1rem":"1rem 1rem 2rem 1rem",minWidth:t?"20rem":"16rem",minHeight:t?"22rem":"13rem","::before":e?Object.assign({content:'""',position:"absolute",top:0,left:0,zIndex:0,width:"100%",height:"100%",backgroundImage:`url(${e})`,backgroundSize:"cover",backgroundPosition:"center"},gre.fadeIn500):void 0}),loi={root:{width:"100%",minWidth:`${X6e}rem`,maxWidth:`${e8e}rem`}},coi=(t,e)=>It({width:"100%",minHeight:e?"auto":`${Ufe}rem`,padding:"1rem",borderRadius:t.effects.roundedCorner6,border:`0.0625rem solid ${t.palette.neutralLight}`,overflow:"hidden",boxShadow:t.effects.elevation4,position:"relative",":before":{content:'""',position:"absolute",top:0,bottom:0,left:0,right:0,zIndex:0,background:t.palette.white,opacity:.9}}),doi=t=>It({fontSize:"1.2rem",lineHeight:"1rem",fontWeight:600},i8e(t)),uoi=t=>It({fontSize:"1.0625rem",lineHeight:"1.375rem",fontWeight:600,textAlign:"center"},i8e(t)),i8e=t=>({textShadow:`0px 0px 8px ${t.palette.whiteTranslucent40}`,fill:t.semanticColors.bodyText,svg:{fill:"currentColor"},stroke:t.palette.whiteTranslucent40,paintOrder:"stroke fill",strokeWidth:_n(1.5),text:{letterSpacing:"-0.02rem"},"@media (forced-colors: active)":{textShadow:"none",stroke:"none"}}),hoi={root:{textAlign:"center",maxWidth:_n(700),alignSelf:"center"}},n8e=t=>({fontSize:"0.9375",lineHeight:"1.25rem",textShadow:`0px 0px 8px ${t.palette.whiteTranslucent40}`,marginTop:"-0.33rem"}),poi=t=>It(n8e(t)),goi=t=>It(n8e(t),{marginBottom:"0.5rem",textAlign:"center"}),moi={root:{paddingTop:"1.125rem"}},foi={root:{textAlign:"center"}},voi=It({width:"100%",maxWidth:"unset",borderRadius:"0.25rem",height:"3.25rem"}),yoi=It({borderRadius:"0.25rem",width:"auto",height:"2.25rem"}),Soi={root:{alignItems:"center"}},boi=(t,e)=>({root:{background:"transparent",border:"none",color:t.palette.themePrimary,padding:"5px 0.25rem",":hover, :focus":e?{}:{color:t.palette.themePrimary},svg:{height:"1rem",width:"1rem"}},labelHovered:e?{}:{color:t.palette.themePrimary},rootChecked:e?{}:{color:t.palette.themePrimary},rootHovered:e?{}:{color:t.palette.themePrimary},rootPressed:e?{}:{color:t.palette.themePrimary},rootFocused:e?{}:{color:t.palette.themePrimary}}),Toi=It({width:"100%",position:"relative"}),Coi=(t,e)=>It({width:"100%",position:"relative",height:`calc(100% - ${!t&&e?`${t8e}rem`:"0rem"})`}),_oi={content:{display:"flex",flexBasis:"100%",paddingLeft:"0rem",paddingRight:"0rem"},commands:{paddingTop:"0rem"},scrollableContent:{display:"flex",flexDirection:"column",height:"100%"}},Eoi={forceFocusInsideTrap:!1},Aoi=t=>({root:{overflow:"initial",display:"flex",justifyContent:"center"},image:{height:`${t8e}rem`,borderRadius:t==="circle"?"100%":void 0,aspectRatio:t==="circle"?"1 / 1":void 0,objectFit:t==="circle"?"cover":void 0}});var Ioi=function(t,e,i,r){function o(l){return l instanceof i?l:new i(function(d){d(l)})}return new(i||(i=Promise))(function(l,d){function h(f){try{g(r.next(f))}catch(y){d(y)}}function p(f){try{g(r.throw(f))}catch(y){d(y)}}function g(f){f.done?l(f.value):o(f.value).then(h,p)}g((r=r.apply(t,e||[])).next())})};const zfe=t=>{const e=new Map;for(const r of t)e.set(r.id,r);const i=[];for(const r of e.values())i.push({key:r.id,text:r.name===""?r.deviceType:r.name});return i},woi=t=>t==="Camera"?U.createElement(YE,{iconName:"LocalDeviceSettingsCamera",className:Ffe}):t==="Microphone"?U.createElement(YE,{iconName:"LocalDeviceSettingsMic",className:Ffe}):t==="Speaker"?U.createElement(YE,{iconName:"LocalDeviceSettingsSpeaker",className:Ffe}):void 0,Vfe=(t,e)=>{var i;return e?U.createElement("div",{className:eoi},woi(t),U.createElement("span",null,(i=e[0])===null||i===void 0?void 0:i.text)):U.createElement(U.Fragment,null)},koi={scalingMode:"Crop",isMirrored:!0},Roi=t=>{var e;const i=Cs(),r=ks(),o=QE(),l=qn(Vje),d=r.strings.call.defaultPlaceHolder,h=r.strings.call.cameraLabel,p=r.strings.call.soundLabel,g=r.strings.call.noSpeakersLabel,f=r.strings.call.noCamerasLabel,y=r.strings.call.noMicrophonesLabel,T=qn(XC),C=t.cameraPermissionGranted,E=t.microphonePermissionGranted,I=T!=="Consumer",w=T!=="Consumer";$.useEffect(()=>{C&&o.queryCameras(),E&&o.queryMicrophones(),o.querySpeakers()},[o,C,E]);const D=t.cameras.length>0,F=t.microphones.length>0,x=t.speakers.length>0,B=qn(_X),L=CX(B)&&!x,z=yu("camera-label"),H=yu("sound-label"),j=U.createElement(s5,{"data-ui-id":"call-composite-local-camera-settings","aria-labelledby":z,placeholder:D?d:f,options:C?zfe(t.cameras):[{key:"deniedOrUnknown",text:""}],styles:t7(i),disabled:!C||!D,errorMessage:t.cameraPermissionGranted===void 0||t.cameraPermissionGranted?void 0:r.strings.call.cameraPermissionDenied,defaultSelectedKey:E?t.selectedCamera?t.selectedCamera.id:t.cameras?(e=t.cameras[0])===null||e===void 0?void 0:e.id:"":"deniedOrUnknown",onChange:(re,ne,le)=>Ioi(void 0,void 0,void 0,function*(){const he=t.cameras[le??0];he?yield t.onSelectCamera(he,koi):console.error("No cameras available")}),onRenderTitle:re=>Vfe("Camera",re)}),J=U.createElement(U.Fragment,null,w&&U.createElement(s5,{"aria-labelledby":H,placeholder:F?d:y,styles:t7(i),disabled:!E||!F,errorMessage:t.microphonePermissionGranted===void 0||t.microphonePermissionGranted?void 0:r.strings.call.microphonePermissionDenied,options:E?zfe(t.microphones):[{key:"deniedOrUnknown",text:""}],defaultSelectedKey:E?t.selectedMicrophone?t.selectedMicrophone.id:a8e(t.microphones):"deniedOrUnknown",onChange:(re,ne,le)=>{const he=t.microphones[le??0];he?t.onSelectMicrophone(he):console.error("No microphones available")},onRenderTitle:re=>Vfe("Microphone",re)})),Z=U.createElement(s5,{"aria-labelledby":H,placeholder:x?d:g,styles:t7(i),disabled:t.speakers.length===0,options:zfe(t.speakers),defaultSelectedKey:t.selectedSpeaker?t.selectedSpeaker.id:a8e(t.speakers),onChange:(re,ne,le)=>{const he=t.speakers[le??0];he?t.onSelectSpeaker(he):console.error("No speakers available")},onRenderTitle:re=>Vfe("Speaker",re)});return U.createElement(Et,{"data-ui-id":"call-composite-device-settings",tokens:Zri,styles:toi},I&&U.createElement(Et,null,U.createElement(Et,{horizontal:!0,horizontalAlign:"space-between",styles:Soi},U.createElement(px,{id:z,className:It(t7(i).label)},h),l&&U.createElement(th,{iconProps:{iconName:"ConfigurationScreenVideoEffectsButton"},styles:boi(i,!C),onClick:t.onClickVideoEffects,disabled:!C,"data-ui-id":"call-config-video-effects-button"},r.strings.call.configurationPageVideoEffectsButtonLabel)),U.createElement(ioi,{cameraGrantedDropdown:j,cameraPermissionGranted:C??!1,ariaLabelledby:z})),U.createElement(Et,null,U.createElement(px,{id:H,className:It(t7(i).label)},p),U.createElement(Et,{"data-ui-id":"call-composite-sound-settings",tokens:Xri},U.createElement(noi,{micGrantedDropdown:J,micPermissionGranted:E??!1,ariaLabelledby:H}),L?U.createElement(U.Fragment,null):Z)))},a8e=t=>{var e;if(t.length===0)return;const i=t.find(r=>r.isSystemDefault);return i?i.id:(e=t[0])===null||e===void 0?void 0:e.id},Moi=It({marginRight:"0.375rem",fontSize:"1.375rem"}),Poi=It({fontWeight:600,fontSize:"0.875rem",height:"2.75rem",width:"100%"}),Doi={textContainer:{display:"contents"}},r8e=t=>{const{rejoinCall:e}=t,i=ks();return U.createElement(SE,Object.assign({},t,{"data-ui-id":"call-composite-start-call-button",className:It(Poi,t.className),styles:Doi,text:e?i.strings.call.rejoinCallButtonLabel:i.strings.call.startCallButtonLabel,onRenderIcon:t.hideIcon?void 0:()=>U.createElement(zH,{className:Moi})}))},$fe=Xs([q8],t=>({video:t.deviceAccess?t.deviceAccess.video:void 0,audio:t.deviceAccess?t.deviceAccess.audio:void 0})),Loi=Xs([q8],t=>{var e;const i=t.cameras.length>0&&t.unparentedViews.length>0&&((e=t.unparentedViews[0])===null||e===void 0?void 0:e.view);return{videoStreamElement:i?i.target:null}}),o8e=t=>({borderRadius:t.effects.roundedCorner6,overflow:"hidden"}),Ooi=t=>It(o8e(t),{width:"100%",height:`${Ufe}rem`,minWidth:`${X6e}rem`,maxWidth:`${e8e}rem`,border:`0.0625rem solid ${t.palette.neutralLight}`,borderRadius:t.effects.roundedCorner6,boxShadow:t.effects.elevation4}),Noi=t=>It(o8e(t),{width:"100%",height:"100%",minHeight:`${Ufe}rem`}),s8e=It({fontSize:"0.75rem"}),xoi={root:{"@media (forced-colors: active)":{borderColor:"#FFFFFF",border:"1px solid"}}},l8e=t=>({root:{minWidth:t?"unset":_n(75),"@media (forced-colors: active)":{":focus":{border:"1px solid !important"},":focus::after":{border:"unset !important",outline:"unset !important"}}}});var Boi=function(t,e,i,r){function o(l){return l instanceof i?l:new i(function(d){d(l)})}return new(i||(i=Promise))(function(l,d){function h(f){try{g(r.next(f))}catch(y){d(y)}}function p(f){try{g(r.throw(f))}catch(y){d(y)}}function g(f){f.done?l(f.value):o(f.value).then(h,p)}g((r=r.apply(t,e||[])).next())})};const Foi=t=>{var e;const i=ks(),r=mc(O4),o=qn(Loi),l=mc(dF),{audio:d,video:h}=qn($fe),p=qn(Nje),g=QE(),f=$.useCallback(()=>Boi(void 0,void 0,void 0,function*(){p?g.mute():g.unmute()}),[g,p]),y=!l.speakers.length,T=l.cameras.length===0&&l.microphones.length===0&&l.speakers.length===0,C=l.cameras.length>0,E=l.microphones.length>0,I=(e=i.strings.call.configurationPageCameraIsLoadingLabel)!==null&&e!==void 0?e:i.strings.call.cameraTurnedOff,w=t.cameraLoading?I:i.strings.call.cameraTurnedOff,D=Cs(),F=$.useCallback(()=>U.createElement(Et,{className:It({width:"100%",height:"100%",marginTop:"-0.8rem"}),verticalAlign:"center"},U.createElement(Et.Item,{align:"center"},U.createElement(YE,{iconName:"LocalPreviewPlaceholder",className:It(s8e,{color:D.palette.neutralTertiary})})),U.createElement(Et.Item,{align:"center"},U.createElement(ja,{className:It(s8e,{color:D.palette.neutralSecondary})},w))),[D,w]),x=t.mobileView?{menuStyles:{menuItemStyles:lh}}:void 0;return U.createElement(Et,{"data-ui-id":"call-composite-local-preview",className:t.mobileView?Noi(D):Ooi(D)},U.createElement(UO,{styles:xoi,renderElement:o?.videoStreamElement?U.createElement(w4,{videoStreamElement:o.videoStreamElement}):void 0,onRenderPlaceholder:F},U.createElement(Lme,{layout:"floatingBottom"},U.createElement(tX,{"data-ui-id":"call-composite-local-device-settings-microphone-button",checked:p,onToggleMicrophone:f,disabled:!d||!E,showLabel:!0,strings:t.mobileView?{tooltipOnContent:"",tooltipOffContent:"",tooltipDisabledContent:""}:{},styles:l8e(t.mobileView)}),U.createElement(O4,Object.assign({"data-ui-id":"call-composite-local-device-settings-camera-button"},r,{onToggleCamera:t.onToggleCamera,showLabel:!0,disabled:!h||!C||t.cameraLoading,strings:t.mobileView?{tooltipOnContent:"",tooltipOffContent:"",tooltipDisabledContent:"",tooltipVideoLoadingContent:""}:{},styles:l8e(t.mobileView)})),t.showDevicesButton&&U.createElement(dF,Object.assign({"data-ui-id":"call-composite-local-device-settings-options-button"},l,{disabled:!d&&!h&&y||T,showLabel:!0,strings:t.mobileView?{tooltipContent:""}:{},styles:x})))))},Uoi=t=>{const{errorBarProps:e}=t;return e.activeErrorMessages.length===0?U.createElement(U.Fragment,null):U.createElement(hA,{shouldFocusOnMount:!0},U.createElement(jA,Object.assign({},e,{onDismissError:t.onDismissError})))},zoi=t=>{const{width:e,text:i,lineHeightPx:r,bufferHeightPx:o,role:l}=t,d=$.useRef(null),h=$.useRef(null),p=$.useRef(null),[g,f]=$.useState(0);return $.useLayoutEffect(()=>{if(i&&h.current&&p.current){const y=Voi(h.current,p.current,e,r);f(y*r)}},[e,r,i]),U.createElement("svg",{"aria-level":1,role:l,width:e,height:g+o,ref:d,xmlns:"http://www.w3.org/2000/svg"},U.createElement("text",{height:0,ref:h,style:{visibility:"hidden"}},i),U.createElement("text",{ref:p,x:"0",y:o/4,role:"heading","aria-level":1}))},Voi=(t,e,i,r)=>{var o,l;const d=(l=(o=t.textContent)===null||o===void 0?void 0:o.split(" "))!==null&&l!==void 0?l:[];if(d.length===0||d[0]==="")throw new Error("Text element must contain text");let h="",p=0;e.textContent="";for(let f=0;f<d.length;f++){const y=h+d[f]+" ";if(t.getSubStringLength(0,y.length)>i&&f>0){const C=c8e(h,r);e.appendChild(C),h=d[f]+" ",p++}else h=y}const g=c8e(h,r);return e.appendChild(g),p++,p},c8e=(t,e)=>{const i=document.createElementNS("http://www.w3.org/2000/svg","tspan");return i.textContent=t,i.setAttribute("x","50%"),i.setAttribute("dy",`${e}px`),i.setAttribute("text-anchor","middle"),i};var Hfe=function(t,e,i,r){function o(l){return l instanceof i?l:new i(function(d){d(l)})}return new(i||(i=Promise))(function(l,d){function h(f){try{g(r.next(f))}catch(y){d(y)}}function p(f){try{g(r.throw(f))}catch(y){d(y)}}function g(f){f.done?l(f.value):o(f.value).then(h,p)}g((r=r.apply(t,e||[])).next())})};const $oi=t=>{var e;const{startCallHandler:i,mobileView:r,modalLayerHostId:o,joinCallOptions:l={microphoneCheck:"requireMicrophoneAvailable"}}=t,d=Cs(),h=Cje(K$e(dF)),p=JA(),{video:g,audio:f}=qn($fe),y=$.useRef(null),T=nF(y),C=!!T&&T<450,E=mc(jA),I=qn(Lje),w=qn(_X);let D=(!f||I?.length===0)&&l.microphoneCheck==="requireMicrophoneAvailable";const F=qn(XC),x=qn(W4).isAvailable,[B,L]=$.useState(!1),z=$.useCallback((X,ve)=>Hfe(void 0,void 0,void 0,function*(){L(x);try{yield p.onSelectCamera(X,ve)}finally{L(!1)}}),[p,x]),{onToggleCamera:H}=mc(O4),j=$.useCallback(X=>Hfe(void 0,void 0,void 0,function*(){L(!x);try{yield H(X)}finally{L(!1)}}),[x,H]);let J=t.latestErrors;F!=="Consumer"&&(J=J.filter(X=>X.type!=="callCameraAccessDenied"&&X.type!=="callCameraAccessDeniedSafari")),(Q8("videoeffects")||!x)&&E&&(J=J.filter(X=>X.type!=="unableToStartVideoEffect")),F==="Consumer"&&(D=!1);const Z=ks(),re=Z.strings.call.configurationPageTitle.length>0?U.createElement(Et.Item,{className:r?uoi(d):doi(d)},U.createElement(zoi,{width:r?325:445,lineHeightPx:16*1.5,bufferHeightPx:16,text:Z.strings.call.configurationPageTitle,role:"heading"})):U.createElement(U.Fragment,null),ne=Z.strings.call.configurationPageCallDetails&&U.createElement(Et.Item,{className:r?goi(d):poi(d)},Z.strings.call.configurationPageCallDetails),le=r&&F!=="Consumer",{toggleVideoEffectsPane:he,closeVideoEffectsPane:Me,isVideoEffectsPaneOpen:Le}=z6e(t.updateSidePaneRenderer,r,t.latestErrors,t.onDismissError),pe=$.useCallback(()=>Hfe(void 0,void 0,void 0,function*(){Me(),i()}),[i,Me]),te=$.useMemo(()=>({hostId:o}),[o]),Se=$.useMemo(()=>Object.assign(Object.assign({},E),{activeErrorMessages:J}),[E,J]),ce=$.useMemo(()=>{var X;return soi(!r,(X=t.backgroundImage)===null||X===void 0?void 0:X.url)},[r,(e=t.backgroundImage)===null||e===void 0?void 0:e.url]);return U.createElement("div",{ref:y,className:It(ce)},U.createElement(Et,{styles:kX},U.createElement(Uoi,{errorBarProps:Se,onDismissError:t.onDismissError})),U.createElement(Et,{verticalFill:!0,grow:!0,horizontal:!0,className:Toi},U.createElement(Et,{className:Coi(le,!!t.logo),verticalAlign:C&&!r?void 0:"center",verticalFill:le,tokens:le?roi:aoi},U.createElement(Et.Item,{styles:hoi},U.createElement(Goi,{logo:t.logo}),re,ne),U.createElement(Et,{horizontal:qoi(le,r,C),horizontalAlign:le?"stretch":"center",verticalFill:le,tokens:ooi},F!=="Consumer"&&U.createElement(Foi,{mobileView:le,showDevicesButton:r,onToggleCamera:j,cameraLoading:B&&!x}),U.createElement(Et,{styles:r?void 0:loi},!le&&U.createElement(Et,{className:r?void 0:coi(d,CX(w))},U.createElement(Roi,Object.assign({},h,p,{onSelectCamera:z,cameraPermissionGranted:Hoi(g),microphonePermissionGranted:joi(f),onClickVideoEffects:he}))),U.createElement(Et,{styles:le?foi:moi,horizontalAlign:le?"stretch":"end"},U.createElement(r8e,{className:le?voi:yoi,onClick:pe,disabled:D,hideIcon:!0}))))),U.createElement(N0e,{isOpen:Le,hasCloseButton:!1,isBlocking:!1,isHiddenOnDismiss:!1,styles:_oi,focusTrapZoneProps:Eoi,layerProps:te,type:Om.custom,customWidth:`${Z8}rem`},U.createElement(k6e,{ariaLabel:Le?Z.strings.call.videoEffectsPaneAriaLabel:void 0,mobileView:t.mobileView,updateSidePaneRenderer:t.updateSidePaneRenderer,maxWidth:`${Z8}rem`,minWidth:`${Z8}rem`}))))},Hoi=(t,e)=>t,joi=(t,e)=>t,Goi=t=>t.logo?U.createElement(nH,{styles:Aoi(t.logo.shape),src:t.logo.url,alt:t.logo.alt}):U.createElement(U.Fragment,null),qoi=(t,e,i)=>i&&!e?!1:!t,d8e={maxWidth:"22.5rem",margin:"1rem"},jfe={childrenGap:"0.5rem"},Woi={root:{paddingTop:"1.125rem",borderRadius:"0.25rem"}},u8e={fontSize:"1.25rem",fontWeight:600},Koi={fontSize:"1rem"};function yF(t){const e=QE(),i=qn(V4);return U.createElement(Et,{className:It(t.pageStyle),verticalFill:!0,verticalAlign:"center",horizontalAlign:"center","data-ui-id":t.dataUiId,"aria-atomic":!0},U.createElement(Et,{className:It(d8e),tokens:jfe},t.iconName&&U.createElement(YE,{iconName:t.iconName}),U.createElement(ja,{className:It(u8e),"aria-live":"assertive",role:"alert"},t.title),U.createElement(ja,{className:It(Koi),"aria-live":"assertive"},t.moreDetails),!t.disableStartCallButton&&U.createElement(Et,{styles:Woi},U.createElement(r8e,{onClick:()=>{i&&i.length>0?e.startCall(i):e.joinCall()},disabled:!1,rejoinCall:!0,autoFocus:!0}))))}const Joi={margin:"1rem"},h8e=(t,e)=>({fontSize:"1rem",color:e?"white":t.themePrimary,textAlign:"center"}),Yoi=(t,e)=>({fontSize:"0.75rem",color:e?"white":t.themePrimary,textAlign:"center"}),Qoi={root:{position:"absolute",top:"0rem",right:"0rem"}},Zoi=t=>{var e;const i=t.localParticipantVideoStream,r=(e=i?.isAvailable)!==null&&e!==void 0?e:!1,o=qn(G6e),l=JA(),d=Cs().palette,h=JA();return U.createElement(W6e,Object.assign({localParticipantVideoStream:t.localParticipantVideoStream,overlayContent:t.overlayProps?U.createElement(Et,{verticalFill:!0,horizontalAlign:"center",verticalAlign:"center",className:It(Joi),"aria-atomic":!0},t.showLocalVideoCameraCycleButton&&r&&U.createElement(Et.Item,{styles:Qoi},U.createElement(l$e,Object.assign({},l,o,{size:"large"}))),U.createElement(Et.Item,{className:It(h8e(d,r))},t.overlayProps.overlayIcon),U.createElement(ja,{className:It(h8e(d,r)),"aria-live":"assertive","data-ui-id":"lobbyScreenTitle",role:"alert"},t.overlayProps.title),t.overlayProps.moreDetails&&U.createElement(ja,{className:It(Yoi(d,r)),"aria-live":"assertive"},t.overlayProps.moreDetails)):void 0},h))},Xoi=t=>{var e,i,r,o,l,d;const h=mc(jA),p=qn(Q6e),g=ks().strings.call,y=qn(G8)==="InLobby",T=(e=qn(GO))!==null&&e!==void 0?e:{};let C=t.mobileView?TX((i=t.options)===null||i===void 0?void 0:i.callControls):(r=t.options)===null||r===void 0?void 0:r.callControls;return C=Pje(C,["screenShareButton","participantsButton"]),U.createElement(OX,{complianceBannerProps:{strings:g},errorBarProps:((o=t.options)===null||o===void 0?void 0:o.errorBar)!==!1&&h,showErrorNotifications:(d=(l=t.options)===null||l===void 0?void 0:l.errorBar)!==null&&d!==void 0?d:!0,callControlProps:{options:C,increaseFlyoutItemSize:t.mobileView},mobileView:t.mobileView,modalLayerHostId:t.modalLayerHostId,onRenderGalleryContent:()=>U.createElement(Zoi,Object.assign({},p,{showLocalVideoCameraCycleButton:t.mobileView,overlayProps:esi(g,y,Object.values(T))})),dataUiId:"lobby-page",updateSidePaneRenderer:t.updateSidePaneRenderer,mobileChatTabHeader:t.mobileChatTabHeader,latestErrors:t.latestErrors,onDismissError:t.onDismissError,latestNotifications:t.latestNotifications,onDismissNotification:t.onDismissNotification})},esi=(t,e,i)=>{const r=i[0]&&["Ringing","Connecting"].includes(i[0].state)&&i.length===1?i[0]:void 0;return e?isi(t):r?nsi(t,r):tsi(t)},tsi=t=>({title:t.lobbyScreenConnectingToCallTitle,moreDetails:t.lobbyScreenConnectingToCallMoreDetails,overlayIcon:U.createElement(YE,{iconName:"LobbyScreenConnectingToCall"})}),isi=t=>({title:t.lobbyScreenWaitingToBeAdmittedTitle,moreDetails:t.lobbyScreenWaitingToBeAdmittedMoreDetails,overlayIcon:U.createElement(YE,{iconName:"LobbyScreenWaitingToBeAdmitted"})}),nsi=(t,e)=>{var i;return Vf(e.identifier)?{title:e.identifier.phoneNumber,moreDetails:t.outboundCallingNoticeString}:{title:(i=t.outboundCallingNoticeString)!==null&&i!==void 0?i:""}},asi={width:"100%",height:"100%"},rsi={opacity:.4},osi={position:"absolute",top:"0",left:"0",width:"100%",height:"100%",minWidth:"100%",minHeight:"100%",objectPosition:"center",objectFit:"cover",zIndex:0},ssi={width:"100%",position:"absolute",top:"50%",transform:"translate(0, -50%)",display:"flex",justifyContent:"center"},lsi={root:{margin:"auto"}},csi={textAlign:"center",fontSize:"1.5rem",fontWeight:400},dsi={circle:{borderWidth:"0.125rem"}},usi={textAlign:"center",fontSize:"1rem"},hsi=t=>{var e,i,r,o,l,d,h;const p=mc(jA),g=ks().strings.call,f=qn(GO),y=qn(Vii),[T,C]=$.useState(void 0),E=t.mobileView?TX((e=t.options)===null||e===void 0?void 0:e.callControls):(i=t.options)===null||i===void 0?void 0:i.callControls,I=$.useMemo(()=>{var B;return f?(B=Object.values(f))===null||B===void 0?void 0:B[0]:void 0},[f]),w=$.useMemo(()=>{var B;return y?.remoteParticipants?(B=Object.values(y.remoteParticipants))===null||B===void 0?void 0:B[0]:void 0},[y]),D=$.useMemo(()=>y&&w?.displayName?"transferTarget":"transferor",[y,w?.displayName]);$.useEffect(()=>{C(g.transferPageNoticeString)},[g.transferPageNoticeString]);let F=I;D==="transferTarget"&&(F=w);let x=(r=I?.displayName)!==null&&r!==void 0?r:g.transferPageUnknownTransferorDisplayName;return D==="transferTarget"&&(x=(o=w?.displayName)!==null&&o!==void 0?o:g.transferPageUnknownTransferTargetDisplayName),U.createElement(Et,{className:It(asi)},U.createElement(GA,{announcementString:T,ariaLive:"polite"}),U.createElement(OX,{complianceBannerProps:{strings:g},errorBarProps:((l=t.options)===null||l===void 0?void 0:l.errorBar)!==!1&&p,showErrorNotifications:(h=(d=t.options)===null||d===void 0?void 0:d.errorBar)!==null&&h!==void 0?h:!0,callControlProps:{options:E,increaseFlyoutItemSize:t.mobileView},mobileView:t.mobileView,modalLayerHostId:t.modalLayerHostId,onRenderGalleryContent:()=>U.createElement(psi,{userId:F?Ga(F?.identifier):void 0,displayName:x,initialsName:x,statusText:D==="transferTarget"?g.transferPageTransferTargetText:g.transferPageTransferorText,onFetchAvatarPersonaData:t.onFetchAvatarPersonaData}),dataUiId:"transfer-page",updateSidePaneRenderer:t.updateSidePaneRenderer,mobileChatTabHeader:t.mobileChatTabHeader,latestErrors:t.latestErrors,onDismissError:t.onDismissError,onDismissNotification:t.onDismissNotification,latestNotifications:t.latestNotifications}))},psi=t=>{const{displayName:e,initialsName:i,userId:r,onFetchAvatarPersonaData:o,statusText:l}=t,[d,h]=$.useState(),p=$.useRef(null),g=$.useRef(new ResizeObserver(C=>{if(!C[0])return;const{width:E,height:I}=C[0].contentRect,w=Math.min(E,I)/2;h(Math.max(Math.min(w,150),32))}));$.useLayoutEffect(()=>{p.current&&g.current.observe(p.current);const C=g.current;return()=>C.disconnect()},[g,p]);const f=$.useMemo(()=>({userId:r,text:i??e,coinSize:d,styles:lsi,hidePersonaDetails:!0}),[r,i,e,d]),y=$.useCallback(()=>d?U.createElement(U4,Object.assign({},f,{dataProvider:o,className:It(rsi)})):U.createElement(U.Fragment,null),[f,o,d]),T=$.useMemo(()=>y(),[y]);return U.createElement("div",{ref:p,className:It(osi),"data-is-focusable":!0},U.createElement(Et,{className:It(ssi),tokens:{childrenGap:"1rem"}},U.createElement(Et,{horizontalAlign:"center",tokens:{childrenGap:"0.5rem"}},T,U.createElement(ja,{className:It(csi)},e)),U.createElement(Et,{horizontal:!0,horizontalAlign:"center",verticalAlign:"center",tokens:{childrenGap:"0.5rem"}},U.createElement(gx,{size:bE.large,className:It(dsi)}),U.createElement(ja,{className:It(usi)},l))))},gsi={root:{borderRadius:_n(4),padding:`${_n(6)} ${_n(20)} `},label:{fontWeight:400,display:"flex",fontSize:_n(14)},labelDisabled:{fontWeight:400,display:"flex",fontSize:_n(14)}},msi={root:{color:"inherit",fontWeight:600,fontHeight:_n(22),fontSize:_n(16),marginTop:"0.5rem",marginBottom:"1.5rem"}},fsi={root:{color:"inherit",fontWeight:600,fontSize:_n(20),lineHeight:_n(28),margin:"auto"}},vsi={root:{width:"100%",height:"100%",background:"inherit"}},ysi={root:{display:"flex",margin:"auto",flexDirection:"column",justifyContent:"center",alignContent:"center",alignItems:"center"}};var Ssi=function(t,e,i,r){function o(l){return l instanceof i?l:new i(function(d){d(l)})}return new(i||(i=Promise))(function(l,d){function h(f){try{g(r.next(f))}catch(y){d(y)}}function p(f){try{g(r.throw(f))}catch(y){d(y)}}function g(f){f.done?l(f.value):o(f.value).then(h,p)}g((r=r.apply(t,e||[])).next())})};const bsi=()=>{var t,e,i,r,o;const l=mc($8),d=ks(),h={holdScreenLabel:(t=d.strings.call.holdScreenLabel)!==null&&t!==void 0?t:"",resumeCallButtonLabel:(e=d.strings.call.resumeCallButtonLabel)!==null&&e!==void 0?e:"",resumeCallButtonAriaLabel:(i=d.strings.call.resumeCallButtonAriaLabel)!==null&&i!==void 0?i:"",resumingCallButtonLabel:(r=d.strings.call.resumingCallButtonLabel)!==null&&r!==void 0?r:"",resumingCallButtonAriaLabel:(o=d.strings.call.resumingCallButtonAriaLabel)!==null&&o!==void 0?o:""},[p,g]=$.useState(0),f=Csi(p),y=$.useRef(performance.now()),[T,C]=$.useState(!1);return U.useEffect(()=>{const E=setInterval(()=>{g(performance.now()-y.current)},10);return()=>{clearInterval(E)}},[y]),U.createElement(Et,{styles:vsi},U.createElement(Et,{horizontal:!0,styles:ysi},U.createElement(ja,{styles:fsi},f),U.createElement(ja,{styles:msi,role:"alert","aria-live":"assertive"},h.holdScreenLabel),U.createElement(SE,{text:T?h.resumingCallButtonLabel:h.resumeCallButtonLabel,ariaLabel:T?h.resumingCallButtonAriaLabel:h.resumeCallButtonAriaLabel,styles:gsi,disabled:T,onClick:()=>Ssi(void 0,void 0,void 0,function*(){C(!0);try{yield l.onToggleHold()}catch(E){throw C(!1),E}}),"data-ui-id":"hold-page-resume-call-button",autoFocus:!0})))},p8e=t=>Math.floor(g8e(t)/60),g8e=t=>Math.floor(t/1e3),Tsi=t=>Math.floor(p8e(t)/60),Csi=t=>{const e=Tsi(t),i=("0"+p8e(t)%60).slice(-2),r=("0"+g8e(t)%60).slice(-2);return`${e>0?e+":":""}${i}:${r}`},_si=t=>{var e,i,r,o,l;const d=mc(jA),h=ks().strings.call;let p=t.mobileView?TX((e=t.options)===null||e===void 0?void 0:e.callControls):(i=t.options)===null||i===void 0?void 0:i.callControls;return p=Pje(p,["cameraButton","microphoneButton","devicesButton","screenShareButton","holdButton"]),U.createElement(OX,{complianceBannerProps:{strings:h},errorBarProps:((r=t.options)===null||r===void 0?void 0:r.errorBar)!==!1&&d,showErrorNotifications:(l=(o=t.options)===null||o===void 0?void 0:o.errorBar)!==null&&l!==void 0?l:!0,callControlProps:{options:p,increaseFlyoutItemSize:t.mobileView},mobileView:t.mobileView,modalLayerHostId:t.modalLayerHostId,onRenderGalleryContent:()=>U.createElement(bsi,null),dataUiId:"hold-page",updateSidePaneRenderer:t.updateSidePaneRenderer,mobileChatTabHeader:t.mobileChatTabHeader,latestErrors:t.latestErrors,latestNotifications:t.latestNotifications,onDismissError:t.onDismissError,onDismissNotification:t.onDismissNotification})},Esi=Xs([zii,Lje],(t,e)=>({camerasCount:t.length,microphonesCount:e.length})),Asi=Xs([Wii,XC],(t,e)=>({capabilitiesChangeInfo:t,participantRole:e})),Isi=t=>{const[e,i]=$.useState({}),r=$.useRef({});$.useEffect(()=>{r.current=Msi(t,r.current),i(d=>ksi(d,Object.values(r.current)))},[t]);const o=$.useCallback(d=>{i(h=>Rsi(d.capabilityName,h))},[]);return{capabilitiesChangedNotifications:$.useMemo(()=>wsi(Object.values(r.current),e),[e]),onDismissNotification:o}},wsi=(t,e)=>t.filter(r=>{const o=e[r.capabilityName];return!o||!o.lastDismissedAt||o.lastDismissedAt<o.mostRecentlyActive}),ksi=(t,e)=>{var i,r;const o={};for(const l of e){const d=t[l.capabilityName];o[l.capabilityName]={mostRecentlyActive:(r=(i=l.timestamp)!==null&&i!==void 0?i:d?.mostRecentlyActive)!==null&&r!==void 0?r:new Date(Date.now()),lastDismissedAt:d?.lastDismissedAt}}return o},Rsi=(t,e)=>{const i=new Date(Date.now()),r=e[t];return Object.assign(Object.assign({},e),{[t]:Object.assign(Object.assign({},r||{}),{lastDismissedAt:i})})},Msi=(t,e)=>{var i,r;if(!t.capabilitiesChangeInfo)return e;for(const[o,l]of Object.entries(t.capabilitiesChangeInfo.newValue)){const d=o;if(e[d]&&l.isPresent===((i=e[d])===null||i===void 0?void 0:i.isPresent)&&t.capabilitiesChangeInfo.reason===((r=e[d])===null||r===void 0?void 0:r.changedReason))continue;const h=t.capabilitiesChangeInfo.oldValue[d];if(l.isPresent===!0&&h?.isPresent===!1&&h?.reason==="FeatureNotSupported"&&t.capabilitiesChangeInfo.reason==="MeetingOptionOrOrganizerPolicyChanged"||d==="shareScreen"&&e.shareScreen===void 0&&l.isPresent===!0&&h?.isPresent===!1&&t.capabilitiesChangeInfo.reason==="RoleChanged")continue;const p={capabilityName:d,isPresent:l.isPresent,changedReason:t.capabilitiesChangeInfo.reason,role:t.participantRole,timestamp:new Date(Date.now())};e[d]=p}return e},Psi=t=>{var e;$.useEffect(()=>{var i;switch((i=t?.callEndReason)===null||i===void 0?void 0:i.subCode){case Aje:console.error("Call ended because the room id provided through the adapter locator could not be found");break;case Ije:console.error("Call ended because this room is currently not valid.");break;case wje:console.error("Call ended because you are not invited to this room.");break;case kje:console.error("Call ended because your invite to this room has been removed.");break}},[(e=t?.callEndReason)===null||e===void 0?void 0:e.subCode])},Dsi=t=>{const{onStarRatingSelected:e}=t,i=ks().strings.call,r={starSurveyHelperText:i.starSurveyHelperText,starSurveyOneStarText:i.starSurveyOneStarText,starSurveyTwoStarText:i.starSurveyTwoStarText,starSurveyThreeStarText:i.starSurveyThreeStarText,starSurveyFourStarText:i.starSurveyFourStarText,starSurveyFiveStarText:i.starSurveyFiveStarText,starRatingAriaLabel:i.starRatingAriaLabel};return U.createElement(sYt,{strings:r,onStarRatingSelected:e})},Lsi=t=>{const e=ks().strings.call,i={tagsSurveyQuestion:e.tagsSurveyQuestion,tagsSurveyHelperText:e.tagsSurveyHelperText,tagsSurveyTextFieldDefaultText:e.tagsSurveyTextFieldDefaultText};return U.createElement(pYt,{callIssuesToTag:e.surveyIssues,categoryHeadings:e.surveyIssuesHeadingStrings,onConfirm:t.onConfirm,strings:i,showFreeFormTextField:t.showFreeFormTextField})},Osi=t=>{const[e,i]=$.useState(!1),r=l=>{l<5&&i(!0),t.setShowSubmitFeedbackButton(!0),t.setRatings(l)},o=(l,d)=>{t.setIssuesSelected(l),t.setShowSubmitFeedbackButton(!0),d&&t.setImprovementSuggestions&&t.setImprovementSuggestions(d)};return U.createElement(Et,{"data-ui-id":"call-composite-survey"},U.createElement(Dsi,{onStarRatingSelected:r}),e&&U.createElement(Lsi,{onConfirm:o,showFreeFormTextField:t.setImprovementSuggestions!==void 0}))};function Nsi(t){const e=ks().strings.call;return U.createElement(Et,{verticalFill:!0,verticalAlign:"center",horizontalAlign:"center","data-ui-id":"thank-you-page","aria-atomic":!0},U.createElement(Et,{className:It(d8e),tokens:jfe},t.iconName&&U.createElement(YE,{iconName:t.iconName}),U.createElement(ja,{className:It(u8e),"aria-live":"assertive"},e.endOfSurveyText)))}const xsi=t=>It({fontWeight:600,fontSize:_n(20),lineHeight:_n(20),color:t.palette.neutralPrimary}),Bsi=t=>It(t?{width:"20rem",position:"absolute",top:"10%",left:"50%",transform:"translateX(-50%)"}:{width:"24rem",position:"absolute",top:"20%",left:"50%",transform:"translateX(-50%)"});var Fsi=function(t,e,i,r){function o(l){return l instanceof i?l:new i(function(d){d(l)})}return new(i||(i=Promise))(function(l,d){function h(f){try{g(r.next(f))}catch(y){d(y)}}function p(f){try{g(r.throw(f))}catch(y){d(y)}}function g(f){f.done?l(f.value):o(f.value).then(h,p)}g((r=r.apply(t,e||[])).next())})};const Usi=t=>{const{onSubmitSurvey:e,onSurveySubmittedCustom:i,onSurveyClosed:r,iconName:o,title:l,moreDetails:d,disableStartCallButton:h,isMobile:p}=t,g=ks().strings.call,[f,y]=$.useState(0),[T,C]=$.useState(),[E,I]=$.useState(!1),[w,D]=$.useState({}),[F,x]=$.useState(!1),[B,L]=$.useState(!1),[z,H]=$.useState(!1),j=hc();return U.createElement(U.Fragment,null,F&&U.createElement(Nsi,{iconName:o}),B&&U.createElement(yF,{iconName:o,title:l,moreDetails:d,dataUiId:"left-call-page",disableStartCallButton:h}),!F&&!B&&U.createElement(Et,{verticalAlign:"center",className:Bsi(!!p)},U.createElement(ja,{className:xsi(j)},g.surveyTitle),U.createElement(Osi,{setShowSubmitFeedbackButton:J=>{I(J)},setRatings:J=>{y(J)},setIssuesSelected:J=>{C(J)},setImprovementSuggestions:i?J=>{D(J)}:void 0}),U.createElement(Et,{horizontal:!0,horizontalAlign:"end"},U.createElement(th,{style:{marginTop:"1rem",marginRight:"0.5rem"},onClick:()=>{r?r("skipped"):L(!0)}},g.surveySkipButtonLabel),E&&U.createElement(SE,{disabled:z,style:{marginTop:"1rem",marginLeft:"0.5rem"},onClick:()=>Fsi(void 0,void 0,void 0,function*(){const J={overallRating:{score:f}};T?.overallRating&&(J.overallRating={score:f,issues:T.overallRating.issues}),T?.audioRating&&(J.audioRating={score:f,issues:T.audioRating.issues}),T?.screenshareRating&&(J.screenshareRating={score:f,issues:T.screenshareRating.issues}),T?.videoRating&&(J.videoRating={score:f,issues:T.videoRating.issues}),e&&(H(!0),e(J).then(Z=>{var re,ne;i?i((re=Z?.callId)!==null&&re!==void 0?re:"",(ne=Z?.id)!==null&&ne!==void 0?ne:"",J,w).then(()=>H(!1)):H(!1),r?r("sent"):x(!0)}).catch(Z=>{console.log("error when submitting survey: "+Z),r&&r("error",Z)}))})},g.surveyConfirmButtonLabel))))};function zsi(t){var e,i;const r=JA();return U.createElement(Et,{verticalFill:!0,verticalAlign:"center",horizontalAlign:"center","data-ui-id":t.dataUiId,"aria-atomic":!0},U.createElement(Et,{className:It(K6e),tokens:jfe},U.createElement(Usi,Object.assign({},r,t,{onSurveySubmittedCustom:(e=t.surveyOptions)===null||e===void 0?void 0:e.onSurveySubmitted,onSurveyClosed:(i=t.surveyOptions)===null||i===void 0?void 0:i.onSurveyClosed,isMobile:t.mobileView}))))}var Vsi=function(t,e,i,r){function o(l){return l instanceof i?l:new i(function(d){d(l)})}return new(i||(i=Promise))(function(l,d){function h(f){try{g(r.next(f))}catch(y){d(y)}}function p(f){try{g(r.throw(f))}catch(y){d(y)}}function g(f){f.done?l(f.value):o(f.value).then(h,p)}g((r=r.apply(t,e||[])).next())})};const m8e=t=>!!t?.isActive,$si=t=>{var e,i,r,o,l,d,h,p,g,f,y,T,C,E;const I=QE(),{camerasCount:w,microphonesCount:D}=qn(Esi),F=w>0,x=D>0,B=qn(XC),{video:L,audio:z}=qn($fe);$.useEffect(()=>{Vsi(void 0,void 0,void 0,function*(){const Ye=Gsi({role:B}),Fe=yield I.askDevicePermission(Ye);Fe?.audio&&I.queryMicrophones(),Fe?.video&&I.queryCameras(),I.querySpeakers()})},[I,B,F,x,L,z]);const{callInvitationUrl:H,onFetchAvatarPersonaData:j,onFetchParticipantMenuItems:J}=t,Z=qn(Oje),re=qn(Bii),[ne,le]=U.useState(),[he,Me]=U.useState(),[Le,pe]=$.useState((r=(i=(e=t.options)===null||e===void 0?void 0:e.galleryOptions)===null||i===void 0?void 0:i.layout)!==null&&r!==void 0?r:"floatingLocalVideo"),[te,Se]=$.useState("Responsive"),ce=$.useRef(t.overrideSidePane);$.useEffect(()=>{Me(t.overrideSidePane),!m8e(ce.current)&&m8e(t.overrideSidePane)&&le(void 0),ce.current=t.overrideSidePane},[t.overrideSidePane]);const X=t.onSidePaneIdChange;$.useEffect(()=>{X?.(ne?.id)},[ne?.id,X]),$.useEffect(()=>{const Ye=()=>{le(void 0)};return I.on("callEnded",Ye),()=>{I.off("callEnded",Ye)}},[I]);const ve=uje(),Te=qn(Asi),Be=Isi(Te),qe=mc(jA).activeErrorMessages,Ge=mc(H8).activeErrorMessages,tt=mc(H8).activeNotifications,ct=qn(Y6e),Mt=$.useRef({latestBooleanState:{callTranscribeState:!1,callRecordState:!1},latestStringState:{callTranscribeState:"off",callRecordState:"off"},lastUpdated:Date.now()}),ht=$.useMemo(()=>Nii(ct,Mt),[ct,Mt]);$.useEffect(()=>{ht&&(tt.forEach((Ye,Fe)=>{["recordingStarted","transcriptionStarted","recordingStopped","transcriptionStopped","recordingAndTranscriptionStarted","recordingAndTranscriptionStopped","recordingStoppedStillTranscribing","transcriptionStoppedStillRecording"].includes(Ye.type)&&tt.splice(Fe,1)}),tt.push(ht)),Ke(Ye=>vfe(Ye,tt))},[ht,tt]);const[vt,Pt]=$.useState({}),[ni,Zt]=$.useState({}),[it,Ke]=$.useState({});$.useEffect(()=>{Pt(Ye=>vfe(Ye,qe)),Zt(Ye=>vfe(Ye,Ge))},[qe,Ge]);const ot=$.useCallback(Ye=>{Pt(Fe=>yfe(Ye.type,Fe)),Zt(Fe=>yfe(Ye.type,Fe))},[]),Ht=$.useCallback(Ye=>{Ke(Fe=>yfe(Ye.type,Fe))},[]),jt=$.useMemo(()=>ffe(qe,vt),[qe,vt]),Nt=$.useMemo(()=>ffe(Ge,ni),[Ge,ni]),Vt=$.useMemo(()=>{const Ye=ffe(tt,it);return Ye.sort((Fe,St)=>{var Wt,Ii;return((Wt=Fe.timestamp)!==null&&Wt!==void 0?Wt:new Date(Date.now())).getTime()-((Ii=St.timestamp)!==null&&Ii!==void 0?Ii:new Date(Date.now())).getTime()}),Ye},[tt,it]),$t=qn(V4),dt=ks(),yt=Cs().palette,kt=qn($je),je=$.useMemo(()=>fai(yt),[yt]);let Ae;const[xe,gt]=$.useState([]);switch(Z){case"configuration":Ae=U.createElement($oi,{joinCallOptions:(o=t.options)===null||o===void 0?void 0:o.joinCallOptions,mobileView:t.mobileView,startCallHandler:()=>{$t?I.startCall($t,kt?{alternateCallerId:{phoneNumber:kt}}:{}):I.joinCall({microphoneOn:"keep",cameraOn:"keep"})},updateSidePaneRenderer:le,latestErrors:jt,onDismissError:ot,modalLayerHostId:t.modalLayerHostId,capabilitiesChangedNotificationBarProps:Be,logo:(d=(l=t.options)===null||l===void 0?void 0:l.branding)===null||d===void 0?void 0:d.logo,backgroundImage:(p=(h=t.options)===null||h===void 0?void 0:h.branding)===null||p===void 0?void 0:p.backgroundImage});break;case"accessDeniedTeamsMeeting":Ae=U.createElement(yF,{iconName:"NoticePageAccessDeniedTeamsMeeting",title:dt.strings.call.failedToJoinTeamsMeetingReasonAccessDeniedTitle,moreDetails:dt.strings.call.failedToJoinTeamsMeetingReasonAccessDeniedMoreDetails,dataUiId:"access-denied-teams-meeting-page"});break;case"removedFromCall":Ae=U.createElement(yF,{iconName:"NoticePageRemovedFromCall",title:dt.strings.call.removedFromCallTitle,moreDetails:dt.strings.call.removedFromCallMoreDetails,dataUiId:"removed-from-call-page"});break;case"joinCallFailedDueToNoNetwork":Ae=U.createElement(yF,{iconName:"NoticePageJoinCallFailedDueToNoNetwork",title:dt.strings.call.failedToJoinCallDueToNoNetworkTitle,moreDetails:dt.strings.call.failedToJoinCallDueToNoNetworkMoreDetails,dataUiId:"join-call-failed-due-to-no-network-page"});break;case"leaving":Ae=U.createElement(yF,{title:(g=dt.strings.call.leavingCallTitle)!==null&&g!==void 0?g:"Leaving...",dataUiId:"leaving-page",pageStyle:je,disableStartCallButton:!0});break;case"badRequest":{const{title:Ye,moreDetails:Fe,disableStartCallButton:St,iconName:Wt}=Rje(dt,re);Ae=U.createElement(yF,{iconName:Wt,title:Ye,moreDetails:$t?"":Fe,dataUiId:"left-call-page",disableStartCallButton:St});break}case"leftCall":{const{title:Ye,moreDetails:Fe,disableStartCallButton:St,iconName:Wt}=Rje(dt,re);if(!(!((y=(f=t.options)===null||f===void 0?void 0:f.surveyOptions)===null||y===void 0)&&y.disableSurvey)){Ae=U.createElement(zsi,{dataUiId:"left-call-page",surveyOptions:(T=t.options)===null||T===void 0?void 0:T.surveyOptions,iconName:Wt,title:Ye,moreDetails:Fe,disableStartCallButton:St,mobileView:t.mobileView});break}Ae=U.createElement(yF,{iconName:Wt,title:Ye,moreDetails:$t?"":Fe,dataUiId:"left-call-page",disableStartCallButton:St});break}case"lobby":Ae=U.createElement(Xoi,{mobileView:t.mobileView,modalLayerHostId:t.modalLayerHostId,options:t.options,updateSidePaneRenderer:le,mobileChatTabHeader:t.mobileChatTabHeader,latestErrors:Nt,latestNotifications:Vt,onDismissError:ot,onDismissNotification:Ht,capabilitiesChangedNotificationBarProps:Be});break;case"transferring":Ae=U.createElement(hsi,{mobileView:t.mobileView,modalLayerHostId:t.modalLayerHostId,options:t.options,updateSidePaneRenderer:le,mobileChatTabHeader:t.mobileChatTabHeader,onFetchAvatarPersonaData:j,latestErrors:Nt,latestNotifications:Vt,onDismissError:ot,onDismissNotification:Ht,capabilitiesChangedNotificationBarProps:Be});break;case"call":Ae=U.createElement(Z6e,{callInvitationURL:H,onFetchAvatarPersonaData:j,onFetchParticipantMenuItems:J,mobileView:t.mobileView,modalLayerHostId:t.modalLayerHostId,options:t.options,updateSidePaneRenderer:le,mobileChatTabHeader:t.mobileChatTabHeader,onCloseChatPane:t.onCloseChatPane,latestErrors:Nt,latestNotifications:Vt,onDismissError:ot,onDismissNotification:Ht,galleryLayout:Le,onUserSetGalleryLayoutChange:pe,onSetUserSetOverflowGalleryPosition:Se,userSetOverflowGalleryPosition:te,capabilitiesChangedNotificationBarProps:Be,pinnedParticipants:xe,setPinnedParticipants:gt,compositeAudioContext:ve,disableAutoShowDtmfDialer:(C=t.options)===null||C===void 0?void 0:C.disableAutoShowDtmfDialer});break;case"hold":Ae=U.createElement(U.Fragment,null,U.createElement(_si,{mobileView:t.mobileView,modalLayerHostId:t.modalLayerHostId,options:t.options,updateSidePaneRenderer:le,mobileChatTabHeader:t.mobileChatTabHeader,latestErrors:Nt,latestNotifications:Vt,onDismissError:ot,onDismissNotification:Ht,capabilitiesChangedNotificationBarProps:Be}));break}if(Z==="returningFromBreakoutRoom"&&(Ae=U.createElement(Z6e,{callInvitationURL:H,onFetchAvatarPersonaData:j,onFetchParticipantMenuItems:J,mobileView:t.mobileView,modalLayerHostId:t.modalLayerHostId,options:t.options,updateSidePaneRenderer:le,mobileChatTabHeader:t.mobileChatTabHeader,onCloseChatPane:t.onCloseChatPane,latestErrors:Nt,latestNotifications:Vt,onDismissError:ot,onDismissNotification:Ht,galleryLayout:Le,onUserSetGalleryLayoutChange:pe,onSetUserSetOverflowGalleryPosition:Se,userSetOverflowGalleryPosition:te,capabilitiesChangedNotificationBarProps:Be,pinnedParticipants:xe,setPinnedParticipants:gt,compositeAudioContext:ve,disableAutoShowDtmfDialer:(E=t.options)===null||E===void 0?void 0:E.disableAutoShowDtmfDialer})),Psi(re),!Ae)throw new Error("Invalid call composite page");return U.createElement(bai,{sidePaneRenderer:ne,overrideSidePane:he},Ae)},Hsi=t=>U.createElement(jsi,Object.assign({},t)),jsi=t=>{const{adapter:e,callInvitationUrl:i,onFetchAvatarPersonaData:r,onFetchParticipantMenuItems:o,options:l,formFactor:d="desktop"}=t,h=d==="mobile",p=yu("modalLayerhost"),g=$.useMemo(()=>h?mai:gai,[h]);return U.createElement("div",{className:g},U.createElement(hje,Object.assign({},t),U.createElement(mfe,{adapter:e},U.createElement($si,{callInvitationUrl:i,onFetchAvatarPersonaData:r,onFetchParticipantMenuItems:o,mobileView:h,modalLayerHostId:p,options:l,onSidePaneIdChange:t.onSidePaneIdChange,overrideSidePane:t.overrideSidePane,mobileChatTabHeader:t.mobileChatTabHeader,onCloseChatPane:t.onCloseChatPane}),U.createElement(tH,{id:p,className:It(Gni)}))))},Gsi=t=>t.role==="Consumer"?{video:!1,audio:!0}:{video:!0,audio:!0},NX=zf("communication-react:composite");class qsi{constructor(e,i){this.isMutedChangedHandler=()=>{this.emitter.emit("isMutedChanged",{participantId:this.participant.identifier,isMuted:this.participant.isMuted})},this.displayNameChangedHandler=()=>{this.emitter.emit("displayNameChanged",{participantId:this.participant.identifier,displayName:this.participant.displayName})},this.isSpeakingChangedHandler=()=>{this.emitter.emit("isSpeakingChanged",{participantId:this.participant.identifier,isSpeaking:this.participant.isSpeaking})},this.videoStreamsUpdatedHandler=r=>{this.emitter.emit("videoStreamsUpdated",r)},this.participant=e,this.emitter=i,this.subscribeParticipantEvents()}subscribeParticipantEvents(){this.participant.on("isMutedChanged",this.isMutedChangedHandler),this.participant.on("displayNameChanged",this.displayNameChangedHandler),this.participant.on("isSpeakingChanged",this.isSpeakingChangedHandler),this.participant.on("videoStreamsUpdated",this.videoStreamsUpdatedHandler)}unsubscribeAll(){this.participant.off("isMutedChanged",this.isMutedChangedHandler),this.participant.off("displayNameChanged",this.displayNameChangedHandler),this.participant.off("isSpeakingChanged",this.isSpeakingChangedHandler),this.participant.off("videoStreamsUpdated",this.videoStreamsUpdatedHandler)}}class Wsi{constructor(e,i){this.unsubscribe=()=>{this._diagnostics.network.off("diagnosticChanged",this.networkDiagnosticsChanged.bind(this)),this._diagnostics.media.off("diagnosticChanged",this.mediaDiagnosticsChanged.bind(this))},this._diagnostics=i.feature(Ma.UserFacingDiagnostics),this._emitter=e,this.subscribe()}subscribe(){this._diagnostics.network.on("diagnosticChanged",this.networkDiagnosticsChanged.bind(this)),this._diagnostics.media.on("diagnosticChanged",this.mediaDiagnosticsChanged.bind(this))}networkDiagnosticsChanged(e){const i=Object.assign({type:"network"},e);this._emitter.emit("diagnosticChanged",i)}mediaDiagnosticsChanged(e){const i=Object.assign({type:"media"},e);this._emitter.emit("diagnosticChanged",i)}}function Gfe(t,e,i,r,o){if(h8(e)&&(!r||r&&Sge(r)))return ijt(t,e,i,r,o);if(f4(e)&&(!r||r&&bge(r)))return njt(t,e,i,r,o);throw new Error("Unhandled agent type")}var Ksi=function(t,e,i,r){function o(l){return l instanceof i?l:new i(function(d){d(l)})}return new(i||(i=Promise))(function(l,d){function h(f){try{g(r.next(f))}catch(y){d(y)}}function p(f){try{g(r.throw(f))}catch(y){d(y)}}function g(f){f.done?l(f.value):o(f.value).then(h,p)}g((r=r.apply(t,e||[])).next())})};const Jsi=(t,e)=>{const i={};return r=>{var o;const l=(o=r.call)===null||o===void 0?void 0:o.remoteParticipants;return Ksi(void 0,void 0,void 0,function*(){let h=!1;if(l){for(const[p,g]of Object.entries(l)){if(i[p])continue;const f=yield t(p,{displayName:g.displayName});f?.displayName&&g.displayName!==f?.displayName&&(i[p]=f?.displayName,h=!0)}h&&e()}}),Pii((h,p)=>{if(i[h])return Object.assign(Object.assign({},p),{displayName:i[h]})})(r)}},Ysi=603,Qsi=0,Zsi=7015;class Xsi{constructor(e,i,r){this.playingSounds=!1,this.onCallStateChanged=()=>{this.call.on("stateChanged",()=>{var o,l,d,h,p,g,f;f8e(this.call,this.callees)&&(!((o=this.soundsLoaded)===null||o===void 0)&&o.callRingingSound)&&(this.soundsLoaded.callRingingSound.loop=!0,this.playSound(this.soundsLoaded.callRingingSound),this.playingSounds=!0),!f8e(this.call,this.callees)&&(!((l=this.soundsLoaded)===null||l===void 0)&&l.callRingingSound)&&(this.soundsLoaded.callRingingSound.loop=!1,this.soundsLoaded.callRingingSound.pause(),this.playingSounds=!1),this.call.state==="Disconnected"&&(!((d=this.soundsLoaded)===null||d===void 0)&&d.callBusySound&&((h=this.call.callEndReason)===null||h===void 0?void 0:h.code)===Ysi?(this.playSound(this.soundsLoaded.callBusySound),this.playingSounds=!0):!((p=this.soundsLoaded)===null||p===void 0)&&p.callEndedSound&&((g=this.call.callEndReason)===null||g===void 0?void 0:g.code)===Qsi&&((f=this.call.callEndReason)===null||f===void 0?void 0:f.subCode)!==Zsi&&(this.playSound(this.soundsLoaded.callEndedSound),this.playingSounds=!0))})},this.call=e,this.callees=i,r&&(this.soundsLoaded=this.loadSounds(r),this.subscribeCallSoundEvents())}subscribeCallSoundEvents(){this.onCallStateChanged()}unsubscribeAll(){var e,i;(e=this.call)===null||e===void 0||e.off("stateChanged",this.onCallStateChanged),!((i=this.soundsLoaded)===null||i===void 0)&&i.callRingingSound&&this.soundsLoaded.callRingingSound.pause()}pauseSounds(){var e,i,r;!((e=this.soundsLoaded)===null||e===void 0)&&e.callRingingSound&&(this.soundsLoaded.callRingingSound.pause(),this.playingSounds=!1),!((i=this.soundsLoaded)===null||i===void 0)&&i.callEndedSound&&(this.soundsLoaded.callEndedSound.pause(),this.playingSounds=!1),!((r=this.soundsLoaded)===null||r===void 0)&&r.callBusySound&&(this.soundsLoaded.callBusySound.pause(),this.playingSounds=!1)}loadSounds(e){var i,r,o;let l;e?.callEnded&&(l=new Audio((i=e?.callEnded)===null||i===void 0?void 0:i.url),l.preload="auto");let d;e?.callRinging&&(d=new Audio((r=e?.callRinging)===null||r===void 0?void 0:r.url),d.preload="auto");let h;return e?.callBusy&&(h=new Audio((o=e?.callBusy)===null||o===void 0?void 0:o.url),h.preload="auto"),{callEndedSound:l,callRingingSound:d,callBusySound:h}}playSound(e){e.play().catch(i=>{console.error(i,"Failed to play sound, check loader config to make sure it is correct")})}}const f8e=(t,e)=>!!(e&&e[0]&&!Vf(e[0])&&(t.state==="Ringing"||t.state==="Connecting"));var ur=function(t,e,i,r){function o(l){return l instanceof i?l:new i(function(d){d(l)})}return new(i||(i=Promise))(function(l,d){function h(f){try{g(r.next(f))}catch(y){d(y)}}function p(f){try{g(r.throw(f))}catch(y){d(y)}}function g(f){f.done?l(f.value):o(f.value).then(h,p)}g((r=r.apply(t,e||[])).next())})};const eli=125;class tli{constructor(e,i,r,o,l,d){var h,p,g,f,y,T,C,E,I;this.emitter=new QB.EventEmitter,this.isReturningFromBreakoutRoom=!1,this.state={isLocalPreviewMicrophoneEnabled:!1,userId:e.userId,displayName:(h=e.callAgent)===null||h===void 0?void 0:h.displayName,devices:e.deviceManager,call:void 0,targetCallees:d,page:"configuration",latestErrors:e.latestErrors,latestNotifications:e.latestNotifications,isTeamsCall:i,isTeamsMeeting:r,isRoomsCall:o,alternateCallerId:l?.alternateCallerId,environmentInfo:e.environmentInfo,videoBackgroundImages:(p=l?.videoBackgroundOptions)===null||p===void 0?void 0:p.videoBackgroundImages,onResolveVideoEffectDependency:(g=l?.videoBackgroundOptions)===null||g===void 0?void 0:g.onResolveDependency,onResolveDeepNoiseSuppressionDependency:(f=l?.deepNoiseSuppressionOptions)===null||f===void 0?void 0:f.onResolveDependency,deepNoiseSuppressionOnByDefault:(T=(y=l?.deepNoiseSuppressionOptions)===null||y===void 0?void 0:y.deepNoiseSuppressionOnByDefault)!==null&&T!==void 0?T:!0,hideDeepNoiseSuppressionButton:(E=(C=l?.deepNoiseSuppressionOptions)===null||C===void 0?void 0:C.hideDeepNoiseSuppressionButton)!==null&&E!==void 0?E:!1,selectedVideoBackgroundEffect:void 0,cameraStatus:void 0,sounds:l?.callingSounds,reactions:l?.reactionResources},this.emitter.setMaxListeners((I=l?.maxListeners)!==null&&I!==void 0?I:eli),this.bindPublicMethods(),this.displayNameModifier=l?.onFetchProfile?Jsi(l.onFetchProfile,()=>{this.setState(this.getState())}):void 0}bindPublicMethods(){}onStateChange(e){this.emitter.on("stateChanged",e)}offStateChange(e){this.emitter.off("stateChanged",e)}setState(e){this.state=this.displayNameModifier?this.displayNameModifier(e):e,this.state=lli(this.state),this.emitter.emit("stateChanged",this.state)}updateCaptionsStartedInBackground(e){var i;const r=(i=this.state.captionsTriggers)!==null&&i!==void 0?i:{};r.captionsStartedInBackground=e,this.setState(Object.assign(Object.assign({},this.state),{captionsTriggers:r}))}updateCaptionsStartedWithUI(e){var i;const r=(i=this.state.captionsTriggers)!==null&&i!==void 0?i:{};r.captionsStartedWithUI=e,this.setState(Object.assign(Object.assign({},this.state),{captionsTriggers:r}))}getState(){return this.state}setIsLocalMicrophoneEnabled(e){this.setState(Object.assign(Object.assign({},this.state),{isLocalPreviewMicrophoneEnabled:e}))}setCurrentCallId(e){this.callId=e}setTargetCallee(e){this.setState(Object.assign(Object.assign({},this.state),{targetCallees:e}))}setIsReturningFromBreakoutRoom(e){this.isReturningFromBreakoutRoom=e}onCallEnded(e){this.emitter.on("callEnded",e)}offCallEnded(e){this.emitter.off("callEnded",e)}updateClientState(e){var i,r,o;let l=this.callId?e.calls[this.callId]:void 0;const d=e.callsEnded?ili(e.callsEnded):void 0,h=this.state.page,p=l?.transfer.acceptedTransfers?qfe(l.transfer.acceptedTransfers):void 0,g=p?e.calls[p.callId]:void 0;(l?.state==="Connected"||l?.state==="Connecting")&&this.setIsReturningFromBreakoutRoom(!1);let f=!1;f=this.isReturningFromBreakoutRoom;const y=Mii(l,d,g,f);!Mje(h)&&Mje(y)&&(this.callId===d?.id&&this.emitter.emit("callEnded",{callId:d?.id,code:(i=d?.callEndReason)===null||i===void 0?void 0:i.code,subCode:(r=d?.callEndReason)===null||r===void 0?void 0:r.subCode}),this.setCurrentCallId(void 0),l=void 0),this.state.page&&this.setState(Object.assign(Object.assign({},this.state),{userId:e.userId,displayName:(o=e.callAgent)===null||o===void 0?void 0:o.displayName,call:l,page:y,endedCall:d,devices:e.deviceManager,latestErrors:e.latestErrors,latestNotifications:e.latestNotifications,cameraStatus:l?.localVideoStreams.find(T=>T.mediaStreamType==="Video")||e.deviceManager.unparentedViews.find(T=>T.mediaStreamType==="Video")?"On":"Off",acceptedTransferCallState:g}))}setBackroundPickerImages(e){this.setState(Object.assign(Object.assign({},this.state),{videoBackgroundImages:e}))}setSelectedVideoBackgroundEffect(e){this.setState(Object.assign(Object.assign({},this.state),{selectedVideoBackgroundEffect:e}))}setAcceptedTransferCall(e){this.setState(Object.assign(Object.assign({},this.state),{acceptedTransferCallState:e}))}}const ili=t=>{var e,i,r,o;const l=Object.values(t);if(l.length===0)return;let d=l[0];for(const h of l.slice(1))((i=(e=h.endTime)===null||e===void 0?void 0:e.getTime())!==null&&i!==void 0?i:0)>((o=(r=d?.endTime)===null||r===void 0?void 0:r.getTime())!==null&&o!==void 0?o:0)&&(d=h);return d},qfe=t=>{var e,i,r,o;const l=Object.values(t);if(l.length===0)return;let d=l[0];for(const h of l.slice(1))((i=(e=h.timestamp)===null||e===void 0?void 0:e.getTime())!==null&&i!==void 0?i:0)>((o=(r=d?.timestamp)===null||r===void 0?void 0:r.getTime())!==null&&o!==void 0?o:0)&&(d=h);return d};class xX{get call(){return this._call}set call(e){this.resetDiagnosticsForwarder(e),this._call=e}constructor(e,i,r,o,l){var d,h,p;this.participantSubscribers=new Map,this.emitter=new QB.EventEmitter,this.isMyMutedChanged=()=>{var C;this.emitter.emit("isMutedChanged",{participantId:this.getState().userId,isMuted:(C=this.call)===null||C===void 0?void 0:C.isMuted})},this.bindPublicMethods(),this.callClient=e,this.callAgent=r,this.targetCallees=Tfe(i)===!0?i:void 0,this.locator=Tfe(i)===!1?i:void 0,this.deviceManager=o;const g=this.locator?"meetingLink"in this.locator||"meetingId"in this.locator:!1;let f;(d=this.targetCallees)===null||d===void 0||d.forEach(C=>{(HL(C)||xx(C))&&(f=!0)});const y=this.locator?"roomId"in this.locator:!1;this.onResolveVideoBackgroundEffectsDependency=(h=l?.videoBackgroundOptions)===null||h===void 0?void 0:h.onResolveDependency,this.onResolveDeepNoiseSuppressionDependency=(p=l?.deepNoiseSuppressionOptions)===null||p===void 0?void 0:p.onResolveDependency,this.context=new tli(e.getState(),!!f,g,y,l,this.targetCallees),this.context.onCallEnded(C=>this.emitter.emit("callEnded",C));const T=C=>{var E,I,w,D,F;if(!this){e.offStateChange(T);return}!((E=this.call)===null||E===void 0)&&E.id&&this.context.setCurrentCallId(this.call.id),((I=this.call)===null||I===void 0?void 0:I.state)==="Connected"&&(!((w=this.callingSoundSubscriber)===null||w===void 0)&&w.playingSounds)&&this.callingSoundSubscriber.pauseSounds(),(((D=this.call)===null||D===void 0?void 0:D.state)==="InLobby"||((F=this.call)===null||F===void 0?void 0:F.state)==="Connected")&&this.callClient.getState().deviceManager.unparentedViews.length>0&&this.callClient.getState().deviceManager.unparentedViews.forEach(x=>{this.callClient.disposeView(void 0,void 0,x)}),this.context.updateClientState(C)};if(this.handlers=Gfe(e,r,o,void 0,{onResolveVideoBackgroundEffectsDependency:this.onResolveVideoBackgroundEffectsDependency,onResolveDeepNoiseSuppressionDependency:this.onResolveDeepNoiseSuppressionDependency}),this.onClientStateChange=T,this.subscribeDeviceManagerEvents(),this.callClient.onStateChange(T),this.callAgent.kind==="CallAgent"){const C=E=>{var I;if(!(!((I=this.call)===null||I===void 0)&&I.id))return;const w=E.removed.find(L=>{var z;return L.id===((z=this.call)===null||z===void 0?void 0:z.id)});if(!w)return;const D=this.callClient.getState().callsEnded[w.id];if(!D)return;const F=qfe(D.transfer.acceptedTransfers),B=r.calls.find(L=>L.id===F?.callId);B&&this.processNewCall(B)};this.callAgent.on("callsUpdated",C)}if(this.callAgent.kind==="TeamsCallAgent"){const C=E=>{var I;if(!(!((I=this.call)===null||I===void 0)&&I.id))return;const w=E.removed.find(L=>{var z;return L.id===((z=this.call)===null||z===void 0?void 0:z.id)});if(!w)return;const D=this.callClient.getState().callsEnded[w.id];if(!D)return;const F=qfe(D.transfer.acceptedTransfers),B=r.calls.find(L=>L.id===F?.callId);B&&this.processNewCall(B)};this.callAgent.on("callsUpdated",C)}}subscribeDeviceManagerEvents(){this.deviceManager.on("selectedMicrophoneChanged",()=>{this.emitter.emit("selectedMicrophoneChanged")}),this.deviceManager.on("selectedSpeakerChanged",()=>{this.emitter.emit("selectedSpeakerChanged")})}bindPublicMethods(){this.onStateChange.bind(this),this.offStateChange.bind(this),this.getState.bind(this),this.dispose.bind(this),this.joinCall.bind(this),this.leaveCall.bind(this),this.setCamera.bind(this),this.setMicrophone.bind(this),this.setSpeaker.bind(this),this.askDevicePermission.bind(this),this.queryCameras.bind(this),this.queryMicrophones.bind(this),this.querySpeakers.bind(this),this.startCamera.bind(this),this.stopCamera.bind(this),this.mute.bind(this),this.unmute.bind(this),this.startCall.bind(this),this.startScreenShare.bind(this),this.stopScreenShare.bind(this),this.raiseHand.bind(this),this.onReactionClick.bind(this),this.lowerHand.bind(this),this.removeParticipant.bind(this),this.createStreamView.bind(this),this.disposeStreamView.bind(this),this.disposeScreenShareStreamView.bind(this),this.disposeRemoteVideoStreamView.bind(this),this.disposeLocalVideoStreamView.bind(this),this.on.bind(this),this.off.bind(this),this.processNewCall.bind(this),this.addParticipant.bind(this),this.holdCall.bind(this),this.resumeCall.bind(this),this.sendDtmfTone.bind(this),this.startCaptions.bind(this),this.stopCaptions.bind(this),this.setSpokenLanguage.bind(this),this.setCaptionLanguage.bind(this),this.startVideoBackgroundEffect.bind(this),this.stopVideoBackgroundEffects.bind(this),this.updateBackgroundPickerImages.bind(this),this.startNoiseSuppressionEffect.bind(this),this.stopNoiseSuppressionEffect.bind(this),this.submitSurvey.bind(this),this.startSpotlight.bind(this),this.stopSpotlight.bind(this),this.stopAllSpotlight.bind(this),this.muteParticipant.bind(this),this.muteAllRemoteParticipants.bind(this),this.forbidOthersAudio.bind(this),this.permitOthersAudio.bind(this),this.forbidOthersAudio.bind(this),this.permitOthersAudio.bind(this)}dispose(){this.resetDiagnosticsForwarder(),this.callClient.offStateChange(this.onClientStateChange),this.callAgent.dispose()}queryCameras(){return ur(this,void 0,void 0,function*(){const e=new Date().getTime();return yield this.asyncTeeErrorToEventEmitter(()=>ur(this,void 0,void 0,function*(){const i=yield this.deviceManager.getCameras(),r=new Date().getTime();return NX.info("time to query cameras",r-e,"ms"),i}))})}queryMicrophones(){return ur(this,void 0,void 0,function*(){const e=new Date().getTime();return yield this.asyncTeeErrorToEventEmitter(()=>ur(this,void 0,void 0,function*(){const i=yield this.deviceManager.getMicrophones(),r=new Date().getTime();return NX.info("time to query microphones",r-e,"ms"),i}))})}querySpeakers(){return ur(this,void 0,void 0,function*(){const e=new Date().getTime();return yield this.asyncTeeErrorToEventEmitter(()=>ur(this,void 0,void 0,function*(){const i=(yield this.deviceManager.isSpeakerSelectionAvailable)?this.deviceManager.getSpeakers():[],r=new Date().getTime();return NX.info("time to query speakers",r-e,"ms"),i}))})}askDevicePermission(e){return ur(this,void 0,void 0,function*(){const i=new Date().getTime();return yield this.asyncTeeErrorToEventEmitter(()=>ur(this,void 0,void 0,function*(){const r=yield this.deviceManager.askDevicePermission(e),o=new Date().getTime();return NX.info("time to query askDevicePermissions",o-i,"ms"),r}))})}joinCall(e){var i,r;if(HA((r=(i=this.getState().call)===null||i===void 0?void 0:i.state)!==null&&r!==void 0?r:"None"))throw new Error("You are already in the call!");if(this.locator===void 0)throw new Error("Locator is not defined!");return this.teeErrorToEventEmitter(()=>{let o=this.getState().cameraStatus==="On",l=this.getState().isLocalPreviewMicrophoneEnabled;typeof e=="boolean"?l=e:typeof e=="object"&&(e.microphoneOn&&e.microphoneOn!=="keep"&&(l=e.microphoneOn),e.cameraOn&&e.cameraOn!=="keep"&&(o=e.cameraOn));const d={muted:!l},h=bfe(this.getState()),p=h&&o?{localVideoStreams:[new kp(h)]}:{},g=this._joinCall(d,p);return this.originCall=g,this.processNewCall(g),g})}_joinCall(e,i){const r=this.locator?"meetingLink"in this.locator:!1,o=this.locator?"meetingId"in this.locator:!1,l=this.locator?"roomId"in this.locator:!1;if(f4(this.callAgent)){if(r)return this.callAgent.join(this.locator,{audioOptions:e,videoOptions:i});if(o)return this.callAgent.join(this.locator,{audioOptions:e,videoOptions:i});throw new Error("Locator not supported by TeamsCallAgent")}return r?this.callAgent.join(this.locator,{audioOptions:e,videoOptions:i}):o?this.callAgent.join(this.locator,{audioOptions:e,videoOptions:i}):l?this.callAgent.join(this.locator,{audioOptions:e,videoOptions:i}):this.callAgent.join(this.locator,{audioOptions:e,videoOptions:i})}createStreamView(e,i){return ur(this,void 0,void 0,function*(){return e===void 0?yield this.handlers.onCreateLocalStreamView(i):yield this.handlers.onCreateRemoteStreamView(e,i)})}disposeStreamView(e){return ur(this,void 0,void 0,function*(){e===void 0?yield this.handlers.onDisposeLocalStreamView():yield this.handlers.onDisposeRemoteStreamView(e)})}disposeScreenShareStreamView(e){return ur(this,void 0,void 0,function*(){e!==""?yield this.handlers.onDisposeRemoteScreenShareStreamView(e):yield this.handlers.onDisposeLocalScreenShareStreamView()})}disposeRemoteVideoStreamView(e){return ur(this,void 0,void 0,function*(){yield this.handlers.onDisposeRemoteVideoStreamView(e)})}disposeLocalVideoStreamView(){return ur(this,void 0,void 0,function*(){yield this.handlers.onDisposeLocalStreamView()})}leaveCall(e){return ur(this,void 0,void 0,function*(){if(this.getState().page==="transferring"){const i=this.callAgent.calls.filter(r=>{var o;return r.id===((o=this.getState().acceptedTransferCallState)===null||o===void 0?void 0:o.id)})[0];i?.hangUp()}yield this.handlers.onHangUp(e),this.unsubscribeCallEvents(),this.handlers=Gfe(this.callClient,this.callAgent,this.deviceManager,this.call,{onResolveVideoBackgroundEffectsDependency:this.onResolveVideoBackgroundEffectsDependency,onResolveDeepNoiseSuppressionDependency:this.onResolveDeepNoiseSuppressionDependency}),this.call=void 0,this.stopCamera(),this.mute()})}setCamera(e,i){return ur(this,void 0,void 0,function*(){return yield this.asyncTeeErrorToEventEmitter(()=>ur(this,void 0,void 0,function*(){yield this.handlers.onSelectCamera(e,i)}))})}setMicrophone(e){return ur(this,void 0,void 0,function*(){return yield this.asyncTeeErrorToEventEmitter(()=>ur(this,void 0,void 0,function*(){yield this.handlers.onSelectMicrophone(e)}))})}setSpeaker(e){return ur(this,void 0,void 0,function*(){return yield this.asyncTeeErrorToEventEmitter(()=>ur(this,void 0,void 0,function*(){yield this.handlers.onSelectSpeaker(e)}))})}startCamera(e){return ur(this,void 0,void 0,function*(){return yield this.asyncTeeErrorToEventEmitter(()=>ur(this,void 0,void 0,function*(){if(!Sfe(this.getState())){{const i=this.getState().selectedVideoBackgroundEffect,r=bfe(this.getState());if(i&&r&&this.onResolveVideoBackgroundEffectsDependency){const o=new kp(r),l=Dii(i,yield this.onResolveVideoBackgroundEffectsDependency());l?yield o.feature(Ma.VideoEffects).startEffects(l):yield o.feature(Ma.VideoEffects).stopEffects()}}yield this.handlers.onToggleCamera(e)}}))})}stopCamera(){return ur(this,void 0,void 0,function*(){return yield this.asyncTeeErrorToEventEmitter(()=>ur(this,void 0,void 0,function*(){Sfe(this.getState())&&(yield this.handlers.onToggleCamera())}))})}mute(){return ur(this,void 0,void 0,function*(){return yield this.asyncTeeErrorToEventEmitter(()=>ur(this,void 0,void 0,function*(){var e,i;this.context.setIsLocalMicrophoneEnabled(!1),HA((e=this.call)===null||e===void 0?void 0:e.state)&&!(!((i=this.call)===null||i===void 0)&&i.isMuted)&&(yield this.handlers.onToggleMicrophone())}))})}unmute(){return ur(this,void 0,void 0,function*(){return yield this.asyncTeeErrorToEventEmitter(()=>ur(this,void 0,void 0,function*(){var e,i,r;this.context.setIsLocalMicrophoneEnabled(!0),(HA((e=this.call)===null||e===void 0?void 0:e.state)||g4((i=this.call)===null||i===void 0?void 0:i.state))&&(!((r=this.call)===null||r===void 0)&&r.isMuted)&&(yield this.handlers.onToggleMicrophone())}))})}startScreenShare(){return ur(this,void 0,void 0,function*(){return yield this.asyncTeeErrorToEventEmitter(()=>ur(this,void 0,void 0,function*(){var e;!((e=this.call)===null||e===void 0)&&e.isScreenSharingOn||(yield this.handlers.onToggleScreenShare())}))})}stopScreenShare(){return ur(this,void 0,void 0,function*(){return yield this.asyncTeeErrorToEventEmitter(()=>ur(this,void 0,void 0,function*(){var e;!((e=this.call)===null||e===void 0)&&e.isScreenSharingOn&&(yield this.handlers.onToggleScreenShare())}))})}raiseHand(){return ur(this,void 0,void 0,function*(){return yield this.asyncTeeErrorToEventEmitter(()=>ur(this,void 0,void 0,function*(){yield this.handlers.onToggleRaiseHand()}))})}lowerHand(){return ur(this,void 0,void 0,function*(){return yield this.asyncTeeErrorToEventEmitter(()=>ur(this,void 0,void 0,function*(){yield this.handlers.onToggleRaiseHand()}))})}onReactionClick(e){return ur(this,void 0,void 0,function*(){return yield this.asyncTeeErrorToEventEmitter(()=>ur(this,void 0,void 0,function*(){yield this.handlers.onReactionClick(e)}))})}startVideoBackgroundEffect(e){return ur(this,void 0,void 0,function*(){if(this.isBlurEffect(e)){const i=e;yield this.handlers.onBlurVideoBackground(i)}else if(this.isReplacementEffect(e)){const i=e;yield this.handlers.onReplaceVideoBackground(i)}})}stopVideoBackgroundEffects(){return ur(this,void 0,void 0,function*(){yield this.handlers.onRemoveVideoBackgroundEffects()})}updateBackgroundPickerImages(e){this.context.setBackroundPickerImages(e)}updateSelectedVideoBackgroundEffect(e){this.context.setSelectedVideoBackgroundEffect(e)}startNoiseSuppressionEffect(){return ur(this,void 0,void 0,function*(){yield this.handlers.onStartNoiseSuppressionEffect()})}stopNoiseSuppressionEffect(){return ur(this,void 0,void 0,function*(){yield this.handlers.onStopNoiseSuppressionEffect()})}startCall(e,i){var r,o;if(HA((o=(r=this.getState().call)===null||r===void 0?void 0:r.state)!==null&&o!==void 0?o:"None"))throw new Error("You are already in the call.");const l=this.getState().cameraStatus==="On",d=bfe(this.getState()),h=d?{videoOptions:l?{localVideoStreams:[new kp(d)]}:void 0}:{},p=Object.assign(Object.assign({},h),i),g=e.map(y=>{const T=JS(y);if("phoneNumber"in T&&i?.alternateCallerId===void 0)throw new Error("Unable to start call, PSTN user present with no alternateCallerId.");return T});this.context.setTargetCallee(g);const f=this.handlers.onStartCall(g,p);if(!f)throw new Error("Unable to start call.");return this.processNewCall(f),f}processNewCall(e){this.call=e,this.context.setCurrentCallId(e.id),this.context.updateClientState(this.callClient.getState()),this.handlers=Gfe(this.callClient,this.callAgent,this.deviceManager,this.call,{onResolveVideoBackgroundEffectsDependency:this.onResolveVideoBackgroundEffectsDependency,onResolveDeepNoiseSuppressionDependency:this.onResolveDeepNoiseSuppressionDependency}),this.subscribeCallEvents()}isBlurEffect(e){return e.effectName==="blur"}isReplacementEffect(e){return e.effectName==="replacement"}removeParticipant(e){return ur(this,void 0,void 0,function*(){let i=e;i=JS(e),this.handlers.onRemoveParticipant(i)})}addParticipant(e,i){return ur(this,void 0,void 0,function*(){Vf(e)&&i?this.handlers.onAddParticipant(e,i):qw(e)&&this.handlers.onAddParticipant(e)})}holdCall(){return ur(this,void 0,void 0,function*(){var e,i;((e=this.call)===null||e===void 0?void 0:e.state)!=="LocalHold"&&(!((i=this.call)===null||i===void 0)&&i.isLocalVideoStarted?this.stopCamera().then(()=>{this.handlers.onToggleHold()}):this.handlers.onToggleHold())})}resumeCall(){return ur(this,void 0,void 0,function*(){var e;((e=this.call)===null||e===void 0?void 0:e.state)==="LocalHold"&&this.handlers.onToggleHold().then(()=>{var i;((i=this.call)===null||i===void 0?void 0:i.feature(Ma.Capabilities).capabilities.turnVideoOn.isPresent)===!1&&this.stopCamera()})})}sendDtmfTone(e){return ur(this,void 0,void 0,function*(){this.handlers.onSendDtmfTone(e)})}startCaptions(e){return ur(this,void 0,void 0,function*(){e?.startInBackground?this.context.updateCaptionsStartedInBackground(!0):this.context.updateCaptionsStartedWithUI(!0),this.handlers.onStartCaptions(e)})}stopCaptions(e){return ur(this,void 0,void 0,function*(){var i;e?.stopInBackground&&this.context.updateCaptionsStartedInBackground(!1),this.context.updateCaptionsStartedWithUI(!1),!((i=this.context.getState().captionsTriggers)===null||i===void 0)&&i.captionsStartedInBackground||this.handlers.onStopCaptions()})}setCaptionLanguage(e){return ur(this,void 0,void 0,function*(){this.handlers.onSetCaptionLanguage(e)})}setSpokenLanguage(e){return ur(this,void 0,void 0,function*(){this.handlers.onSetSpokenLanguage(e)})}submitSurvey(e){return ur(this,void 0,void 0,function*(){return this.handlers.onSubmitSurvey(e)})}muteParticipant(e){return ur(this,void 0,void 0,function*(){this.handlers.onMuteParticipant(e)})}muteAllRemoteParticipants(){return ur(this,void 0,void 0,function*(){this.handlers.onMuteAllRemoteParticipants()})}startSpotlight(e){return ur(this,void 0,void 0,function*(){this.handlers.onStartSpotlight(e)})}stopSpotlight(e){return ur(this,void 0,void 0,function*(){this.handlers.onStopSpotlight(e)})}stopAllSpotlight(){return ur(this,void 0,void 0,function*(){this.handlers.onStopAllSpotlight()})}forbidAudio(e){return ur(this,void 0,void 0,function*(){var i,r;(r=(i=this.handlers).onForbidAudio)===null||r===void 0||r.call(i,e)})}permitAudio(e){return ur(this,void 0,void 0,function*(){var i,r;(r=(i=this.handlers).onPermitAudio)===null||r===void 0||r.call(i,e)})}forbidOthersAudio(){return ur(this,void 0,void 0,function*(){var e,i;(i=(e=this.handlers).onForbidOthersAudio)===null||i===void 0||i.call(e)})}permitOthersAudio(){return ur(this,void 0,void 0,function*(){var e,i;(i=(e=this.handlers).onPermitOthersAudio)===null||i===void 0||i.call(e)})}forbidVideo(e){return ur(this,void 0,void 0,function*(){var i,r;(r=(i=this.handlers).onForbidVideo)===null||r===void 0||r.call(i,e)})}permitVideo(e){return ur(this,void 0,void 0,function*(){var i,r;(r=(i=this.handlers).onPermitVideo)===null||r===void 0||r.call(i,e)})}forbidOthersVideo(){return ur(this,void 0,void 0,function*(){var e,i;(i=(e=this.handlers).onForbidOthersVideo)===null||i===void 0||i.call(e)})}permitOthersVideo(){return ur(this,void 0,void 0,function*(){var e,i;(i=(e=this.handlers).onPermitOthersVideo)===null||i===void 0||i.call(e)})}returnFromBreakoutRoom(){return ur(this,void 0,void 0,function*(){var e,i;const r=!((e=this.call)===null||e===void 0)&&e.id?this.callClient.getState().calls[this.call.id]:void 0,o=(i=r?.breakoutRooms)===null||i===void 0?void 0:i.assignedBreakoutRoom;if(!o)throw new Error("Could not return from breakout room because assigned breakout room state could not be retrieved.");this.context.setIsReturningFromBreakoutRoom(!0);const l=yield o.returnToMainMeeting();this.originCall=l,this.processNewCall(l)})}getState(){return this.context.getState()}onStateChange(e){this.context.onStateChange(e)}offStateChange(e){this.context.offStateChange(e)}on(e,i){this.emitter.on(e,i)}subscribeToCaptionEvents(){var e;const i=(e=this.call)===null||e===void 0?void 0:e.feature(Ma.Captions);if(i?.captions.kind==="TeamsCaptions"&&(this.context.getState().isTeamsCall||this.context.getState().isTeamsMeeting)){const r=i.captions;r.on("CaptionsReceived",this.teamsCaptionsReceived.bind(this)),r.on("CaptionsActiveChanged",this.isCaptionsActiveChanged.bind(this)),r.on("CaptionLanguageChanged",this.isCaptionLanguageChanged.bind(this)),r.on("SpokenLanguageChanged",this.isSpokenLanguageChanged.bind(this))}else{const r=i?.captions;r.on("CaptionsReceived",this.captionsReceived.bind(this)),r.on("CaptionsActiveChanged",this.isCaptionsActiveChanged.bind(this)),r.on("SpokenLanguageChanged",this.isSpokenLanguageChanged.bind(this)),i?.on("CaptionsKindChanged",this.captionsKindChanged.bind(this))}}unsubscribeFromCaptionEvents(){var e;const i=(e=this.call)===null||e===void 0?void 0:e.feature(Ma.Captions);if(i?.captions.kind==="TeamsCaptions"&&(this.context.getState().isTeamsCall||this.context.getState().isTeamsMeeting)){const r=i.captions;r.off("CaptionsReceived",this.teamsCaptionsReceived.bind(this)),r.off("CaptionsActiveChanged",this.isCaptionsActiveChanged.bind(this)),r.off("CaptionLanguageChanged",this.isCaptionLanguageChanged.bind(this)),r.off("SpokenLanguageChanged",this.isSpokenLanguageChanged.bind(this))}else{const r=i?.captions;r.off("CaptionsReceived",this.captionsReceived.bind(this)),r.off("CaptionsActiveChanged",this.isCaptionsActiveChanged.bind(this)),r.off("SpokenLanguageChanged",this.isSpokenLanguageChanged.bind(this)),i?.off("CaptionsKindChanged",this.captionsKindChanged.bind(this))}}subscribeCallEvents(){var e,i,r,o,l,d,h,p,g;this.call&&(this.callingSoundSubscriber=new Xsi(this.call,this.getState().targetCallees,this.getState().sounds)),(e=this.call)===null||e===void 0||e.on("remoteParticipantsUpdated",this.onRemoteParticipantsUpdated.bind(this)),(i=this.call)===null||i===void 0||i.on("isMutedChanged",this.isMyMutedChanged.bind(this)),(r=this.call)===null||r===void 0||r.on("isScreenSharingOnChanged",this.isScreenSharingOnChanged.bind(this)),(o=this.call)===null||o===void 0||o.on("idChanged",this.callIdChanged.bind(this)),(l=this.call)===null||l===void 0||l.on("roleChanged",this.roleChanged.bind(this)),this.subscribeToCaptionEvents(),(d=this.call)===null||d===void 0||d.feature(Ma.Transfer).on("transferAccepted",this.transferAccepted.bind(this)),(h=this.call)===null||h===void 0||h.feature(Ma.Capabilities).on("capabilitiesChanged",this.capabilitiesChanged.bind(this)),(p=this.call)===null||p===void 0||p.feature(Ma.Spotlight).on("spotlightChanged",this.spotlightChanged.bind(this));const f=(g=this.call)===null||g===void 0?void 0:g.feature(Ma.BreakoutRooms);f&&f.on("breakoutRoomsUpdated",this.breakoutRoomsUpdated.bind(this))}unsubscribeCallEvents(){var e,i,r,o,l,d;for(const p of this.participantSubscribers.values())p.unsubscribeAll();this.participantSubscribers.clear(),(e=this.call)===null||e===void 0||e.off("remoteParticipantsUpdated",this.onRemoteParticipantsUpdated.bind(this)),(i=this.call)===null||i===void 0||i.off("isMutedChanged",this.isMyMutedChanged.bind(this)),(r=this.call)===null||r===void 0||r.off("isScreenSharingOnChanged",this.isScreenSharingOnChanged.bind(this)),(o=this.call)===null||o===void 0||o.off("idChanged",this.callIdChanged.bind(this)),(l=this.call)===null||l===void 0||l.off("roleChanged",this.roleChanged.bind(this)),this.unsubscribeFromCaptionEvents(),this.callingSoundSubscriber&&this.callingSoundSubscriber.unsubscribeAll();const h=(d=this.call)===null||d===void 0?void 0:d.feature(Ma.BreakoutRooms);h&&h.off("breakoutRoomsUpdated",this.breakoutRoomsUpdated.bind(this))}captionsKindChanged(){var e;const i=(e=this.call)===null||e===void 0?void 0:e.feature(Ma.Captions),r=i?.captions;r.on("CaptionsReceived",this.teamsCaptionsReceived.bind(this)),r.on("CaptionsActiveChanged",this.isCaptionsActiveChanged.bind(this)),r.on("CaptionLanguageChanged",this.isCaptionLanguageChanged.bind(this)),r.on("SpokenLanguageChanged",this.isSpokenLanguageChanged.bind(this))}onRemoteParticipantsUpdated({added:e,removed:i}){e&&e.length>0&&this.emitter.emit("participantsJoined",{joined:e}),i&&i.length>0&&this.emitter.emit("participantsLeft",{removed:i}),e.forEach(r=>{this.participantSubscribers.set(Ga(r.identifier),new qsi(r,this.emitter))}),i.forEach(r=>{const o=this.participantSubscribers.get(Ga(r.identifier));o&&o.unsubscribeAll(),this.participantSubscribers.delete(Ga(r.identifier))})}isScreenSharingOnChanged(){var e;this.emitter.emit("isLocalScreenSharingActiveChanged",{isScreenSharingOn:(e=this.call)===null||e===void 0?void 0:e.isScreenSharingOn})}teamsCaptionsReceived(e){this.emitter.emit("captionsReceived",{captionsInfo:e})}captionsReceived(e){this.emitter.emit("captionsReceived",{captionsInfo:e})}isCaptionsActiveChanged(){var e;const i=(e=this.call)===null||e===void 0?void 0:e.feature(Ma.Captions).captions;this.emitter.emit("isCaptionsActiveChanged",{isActive:i.isCaptionsFeatureActive})}isSpokenLanguageChanged(){var e;const i=(e=this.call)===null||e===void 0?void 0:e.feature(Ma.Captions).captions;this.emitter.emit("isSpokenLanguageChanged",{activeSpokenLanguage:i.activeSpokenLanguage})}isCaptionLanguageChanged(){var e;const i=(e=this.call)===null||e===void 0?void 0:e.feature(Ma.Captions).captions;this.emitter.emit("isCaptionLanguageChanged",{activeCaptionLanguage:i.activeCaptionLanguage})}transferAccepted(e){this.emitter.emit("transferAccepted",e)}capabilitiesChanged(e){var i,r;((i=e.newValue.turnVideoOn)===null||i===void 0?void 0:i.isPresent)===!1&&this.disposeLocalVideoStreamView(),((r=e.newValue.shareScreen)===null||r===void 0?void 0:r.isPresent)===!1&&this.stopScreenShare(),this.emitter.emit("capabilitiesChanged",e)}roleChanged(){var e,i;((e=this.call)===null||e===void 0?void 0:e.role)==="Consumer"&&((i=this.call)===null||i===void 0||i.feature(Ma.RaiseHand).lowerHand()),this.emitter.emit("roleChanged")}spotlightChanged(e){this.emitter.emit("spotlightChanged",e)}breakoutRoomsUpdated(e){e.type==="assignedBreakoutRooms"?this.assignedBreakoutRoomUpdated(e.data):e.type==="join"&&this.breakoutRoomJoined(e.data),this.emitter.emit("breakoutRoomsUpdated",e)}assignedBreakoutRoomUpdated(e){var i,r,o;!((i=this.call)===null||i===void 0)&&i.id&&((r=this.originCall)===null||r===void 0?void 0:r.id)!==((o=this.call)===null||o===void 0?void 0:o.id)&&(!e||e.state==="closed")&&this.returnFromBreakoutRoom()}breakoutRoomJoined(e){var i;((i=this.call)===null||i===void 0?void 0:i.id)!==e.id&&this.processNewCall(e),this.hangupOtherBreakoutRoomCalls(e.id)}hangupOtherBreakoutRoomCalls(e){const i=Object.values(this.callClient.getState().calls).filter(r=>{var o;return((o=r.breakoutRooms)===null||o===void 0?void 0:o.breakoutRoomSettings)&&r.id!==e});for(const r of i){const o=this.callAgent.calls.find(l=>l.id===r.id);o?.hangUp()}}callIdChanged(){var e;!((e=this.call)===null||e===void 0)&&e.id&&this.emitter.emit("callIdChanged",{callId:this.call.id})}resetDiagnosticsForwarder(e){this.diagnosticsForwarder&&this.diagnosticsForwarder.unsubscribe(),e&&(this.diagnosticsForwarder=new Wsi(this.emitter,e))}off(e,i){this.emitter.off(e,i)}asyncTeeErrorToEventEmitter(e){return ur(this,void 0,void 0,function*(){try{return yield e()}catch(i){throw S8e(i)&&this.emitter.emit("error",i),i}})}teeErrorToEventEmitter(e){try{return e()}catch(i){throw S8e(i)&&this.emitter.emit("error",i),i}}}function v8e(t){return ur(this,void 0,void 0,function*(){if(HL(t.userId))throw new Error("Microsoft Teams user identifier is not supported by AzureCommunicationCallAdapter. Instead use TeamsCallAdapter.");return nli({userId:t.userId,displayName:t.displayName,credential:t.credential,locator:t.locator,targetCallees:t.targetCallees,options:t.options})})}const nli=t=>ur(void 0,[t],void 0,function*({userId:e,displayName:i,credential:r,locator:o,targetCallees:l,options:d,telemetryImplementationHint:h="Call"}){if(!CDe(e))throw new Error("Invalid identifier. Please provide valid identifier object.");const p=_4e({userId:e},void 0,h),g=yield p.createCallAgent(r,{displayName:i});let f;return o?f=y8e(p,g,o,d):f=y8e(p,g,l,d),f}),ali=t=>ur(void 0,void 0,void 0,function*(){const{userId:e,credential:i,options:r}=t;if(qw(e))throw new Error("Communication User identifier is not supported by TeamsCallAdapter, please use our AzureCommunicationCallAdapter.");const o=_4e({userId:e},void 0,"Call"),l=yield o.createTeamsCallAgent(i,{undefined:void 0});return sli(o,l,t.locator,r)});function rli(t,e="AzureCommunication",i,r){const{credential:o,userId:l}=t,d="locator"in t?t.locator:void 0,h="targetCallees"in t?t.targetCallees:void 0,p="displayName"in t?t.displayName:void 0,g="options"in t?t.options:void 0,[f,y]=$.useState(void 0),T=$.useRef(void 0),C=$.useRef(!1),E=$.useRef(void 0),I=$.useRef(void 0);return E.current=i,I.current=r,$.useEffect(()=>{!o||!d&&!h||!l||e==="AzureCommunication"&&!p||ur(this,void 0,void 0,function*(){T.current&&(I.current&&(yield I.current(T.current)),T.current.dispose(),T.current=void 0);let w;if(e==="AzureCommunication"){if(!p)throw new Error("Unreachable code, displayName already checked above.");if(C.current){console.warn("Adapter is already being created, please see storybook for more information: https://azure.github.io/communication-ui-library/?path=/story/troubleshooting--page");return}C.current=!0,d?w=yield v8e({credential:o,displayName:p,locator:d,userId:l,options:g}):h&&(w=yield v8e({credential:o,displayName:p,targetCallees:h,userId:l,options:g}))}else if(e==="Teams"){if(C.current){console.warn("Adapter is already being created, skipping creation.");return}C.current=!0,h||(w=yield ali({credential:o,locator:d,userId:l,options:g}))}else throw new Error("Unreachable code, unknown adapterKind");if(!w)throw Error("Unreachable code! Get undefined adapter");E.current&&(w=yield E.current(w)),T.current=w,C.current=!1,y(w)})},[T,E,I,e,o,d,l,p,g,h]),$.useEffect(()=>()=>{ur(this,void 0,void 0,function*(){T.current&&(I.current&&(yield I.current(T.current)),T.current.dispose(),T.current=void 0)})},[]),f}const oli=(t,e,i)=>rli(t,"AzureCommunication",e,i);function y8e(t,e,i,r){return ur(this,void 0,void 0,function*(){const o=yield t.getDeviceManager();return yield Promise.all([o.getCameras(),o.getMicrophones()]),o.isSpeakerSelectionAvailable&&(yield o.getSpeakers()),Tfe(i)?new xX(t,i,e,o,r):new xX(t,i,e,o,r)})}const sli=(t,e,i,r)=>ur(void 0,void 0,void 0,function*(){const o=yield t.getDeviceManager();return yield Promise.all([o.getCameras(),o.getMicrophones()]),o.isSpeakerSelectionAvailable&&(yield o.getSpeakers()),Array.isArray(i)?new xX(t,i,e,o,r):new xX(t,i,e,o,r)}),lli=t=>{var e,i,r;return!((e=t.call)===null||e===void 0)&&e.captionsFeature&&(!((i=t.captionsTriggers)===null||i===void 0)&&i.captionsStartedInBackground)&&!(!((r=t.captionsTriggers)===null||r===void 0)&&r.captionsStartedWithUI)?Object.assign(Object.assign({},t),{call:Object.assign(Object.assign({},t.call),{captionsFeature:Object.assign(Object.assign({},t.call.captionsFeature),{isCaptionsFeatureActive:!1,startCaptionsInProgress:!1})})}):t},S8e=t=>"target"in t&&"innerError"in t,cli={call:JSON.parse(`{"cameraLabel":"Camera","noCamerasLabel":"No cameras found","cameraPermissionDenied":"Your browser is blocking access to your camera","cameraTurnedOff":"Your camera is turned off","chatButtonLabel":"Chat","close":"Close","complianceBannerNowOnlyRecording":"You are now only recording this meeting.","complianceBannerNowOnlyTranscription":"You are now only transcribing this meeting.","complianceBannerRecordingAndTranscriptionSaved":"Recording and transcription are being saved.","complianceBannerRecordingAndTranscriptionStarted":"Recording and transcription have started.","complianceBannerRecordingAndTranscriptionStopped":"Recording and transcription have stopped.","complianceBannerRecordingSaving":"Recording is being saved.","complianceBannerRecordingStarted":"Recording has started.","complianceBannerRecordingStopped":"Recording has stopped.","complianceBannerTranscriptionStarted":"Transcription has started.","complianceBannerTranscriptionConsent":"By joining, you are giving consent for this meeting to be transcribed.","complianceBannerTranscriptionSaving":"Transcription is being saved.","complianceBannerTranscriptionStopped":"Transcription has stopped.","configurationPageTitle":"Start a call","copyInviteLinkButtonLabel":"Copy invite link","copyInviteLinkButtonActionedLabel":"Link copied","copyInviteLinkActionedAriaLabel":"Invite link copied","defaultPlaceHolder":"Select an option","dismissSidePaneButtonLabel":"Close","videoEffectsPaneTitle":"Effects","videoEffectsPaneBackgroundSelectionTitle":"Background","videoEffectsPaneAriaLabel":"Video effects pane","configurationPageCameraIsLoadingLabel":"Video is loading...","configurationPageVideoEffectsButtonLabel":"Effects","unableToStartVideoEffect":"Unable to apply video effect.","blurBackgroundEffectButtonLabel":"Blur","blurBackgroundTooltip":"Blur Background","removeBackgroundEffectButtonLabel":"None","removeBackgroundTooltip":"Remove Background","cameraOffBackgroundEffectWarningText":"Your camera is off. Turn on camera to see video effect.","failedToJoinCallDueToNoNetworkMoreDetails":"Call was disconnected due to a network issue. Check your connection and join again.","failedToJoinCallDueToNoNetworkTitle":"Call disconnected","failedToJoinTeamsMeetingReasonAccessDeniedMoreDetails":"You were not granted entry in the call. If this was a mistake, re-join the call.","failedToJoinTeamsMeetingReasonAccessDeniedTitle":"Dismissed from lobby","learnMore":"Learn more","leavingCallTitle":"Leaving...","leftCallMoreDetails":"If this was a mistake, re-join the call.","leftCallTitle":"You left the call","lobbyScreenConnectingToCallTitle":"Joining call","lobbyScreenWaitingToBeAdmittedTitle":"Waiting to be admitted","microphonePermissionDenied":"Your browser is blocking access to your microphone","microphoneToggleInLobbyNotAllowed":"Cannot mute or unmute while in lobby.","mutedMessage":"You're muted","networkReconnectMoreDetails":"Looks like something went wrong. We're trying to get back into the call.","networkReconnectTitle":"Hold on","notInvitedToRoomDetails":"You are not able to join this room because you do not have an invite.","notInvitedToRoomTitle":"Not invited to room","peopleButtonLabel":"People","selectedPeopleButtonLabel":"People Button Selected","peoplePaneTitle":"People","peoplePaneMoreButtonAriaLabel":"More","peopleButtonTooltipOpen":"Show participants","peopleButtonTooltipClose":"Hide participants","peoplePaneSubTitle":"In this call {numberOfPeople}","privacyPolicy":"Privacy policy","rejoinCallButtonLabel":"Re-join call","removedFromCallMoreDetails":"Another participant removed you from the call.","removedFromCallTitle":"You were removed","removeMenuLabel":"Remove","startSpotlightMenuLabel":"Spotlight for everyone","addSpotlightMenuLabel":"Add spotlight","stopSpotlightMenuLabel":"Stop spotlighting","stopSpotlightOnSelfMenuLabel":"Exit spotlight","spotlightLimitReachedMenuTitle":"Spotlight limit reached","stopAllSpotlightMenuLabel":"Stop all spotlights","returnToCallButtonAriaDescription":"Return to Call","returnToCallButtonAriaLabel":"Back","roomNotFoundDetails":"The room ID provided could not be found.","roomNotFoundTitle":"Room not found","roomNotValidDetails":"This room is not valid at this current time.","roomNotValidTitle":"Room not valid","inviteToRoomRemovedDetails":"Your invite to join this room was removed.","inviteToRoomRemovedTitle":"Invite to room removed","soundLabel":"Sound","noMicrophonesLabel":"No microphones found","noSpeakersLabel":"No speakers found","startCallButtonLabel":"Start call","openDialpadButtonLabel":"Dial phone number","peoplePaneAddPeopleButtonLabel":"Add People","dialpadStartCallButtonLabel":"Call","dialpadModalTitle":"Dial Phone Number","dialpadModalAriaLabel":"Dialpad","dialpadCloseModalButtonAriaLabel":"Close dialpad","moreButtonCallingLabel":"More","resumeCallButtonLabel":"Resume","resumingCallButtonLabel":"Resuming...","resumeCallButtonAriaLabel":"Resume call","resumingCallButtonAriaLabel":"Resume call","holdScreenLabel":"You're on hold","openDtmfDialpadLabel":"Show dialpad","dtmfDialpadPlaceholderText":"Enter number","outboundCallingNoticeString":"Calling...","participantJoinedNoticeString":"{displayName} joined","twoParticipantJoinedNoticeString":"{displayName1} and {displayName2} have joined","threeParticipantJoinedNoticeString":"{displayName1}, {displayName2} and {displayName3} have joined","participantLeftNoticeString":"{displayName} left","twoParticipantLeftNoticeString":"{displayName1} and {displayName2} have left","threeParticipantLeftNoticeString":"{displayName1}, {displayName2} and {displayName3} have left","unnamedParticipantString":"unnamed participant","manyUnnamedParticipantsJoined":"unnamed participant and {numOfParticipants} other participants joined","manyUnnamedParticipantsLeft":"unnamed participant and {numOfParticipants} other participants left","manyParticipantsJoined":"{displayName1}, {displayName2}, {displayName3} and {numOfParticipants} other participants joined","manyParticipantsLeft":"{displayName1}, {displayName2}, {displayName3} and {numOfParticipants} other participants left","liveCaptionsLabel":"Live captions","captionsSettingsLabel":"Caption settings","startCaptionsButtonOnLabel":"Turn on captions","startCaptionsButtonOffLabel":"Turn off captions","startCaptionsButtonTooltipOnContent":"Turn off captions","startCaptionsButtonTooltipOffContent":"Turn on captions","captionsSettingsModalTitle":"Captions Settings","captionsSettingsSpokenLanguageDropdownLabel":"Spoken language","captionsSettingsCaptionLanguageDropdownLabel":"Captions language","captionsSettingsSpokenLanguageDropdownInfoText":"Language that everyone on this call is speaking.","captionsSettingsCaptionLanguageDropdownInfoText":"Captions will appear in this language.","captionsSettingsConfirmButtonLabel":"Confirm","captionsSettingsCancelButtonLabel":"Cancel","captionsSettingsModalAriaLabel":"Captions Setting Modal","captionsSettingsCloseModalButtonAriaLabel":"Close Captions Setting","captionsBannerMoreButtonCallingLabel":"Captions Settings More Options","captionsBannerMoreButtonTooltip":"More options","realTimeTextLabel":"Real-time text (RTT)","startRealTimeTextLabel":"Turn on RTT for this call","disabledStartRealTimeTextLabel":"RTT is currently turned on, it cannot be turned off","dismissModalAriaLabel":"Local and remote picture and picture, press enter to return to call","callRejectedTitle":"The call could not be completed","callRejectedMoreDetails":"The person you are trying to reach is unavailable. Please try again later.","callTimeoutTitle":"The call could not be completed","callTimeoutDetails":"The person you are trying to reach is unavailable. Please try again later.","callTimeoutBotTitle":"The call could not be completed","callTimeoutBotDetails":"The service that you are trying to reach is unavailable. Please try again later.","dtmfDialerButtonLabel":"Dialpad","dtmfDialerButtonTooltipOn":"Show dialpad","dtmfDialerButtonTooltipOff":"Hide dialpad","dtmfDialerMoreButtonLabelOn":"Show dialpad","dtmfDialerMoreButtonLabelOff":"Hide dialpad","phoneCallMoreButtonLabel":"Phone Call","spokenLanguageStrings":{"ar-ae":"Arabic - U.A.E.","ar-sa":"Arabic - Saudi Arabia","da-dk":"Danish","de-de":"German - Germany","en-au":"English - Australia","en-ca":"English - Canada","en-gb":"English - United Kingdom","en-in":"English - India","en-nz":"English - New Zealand","en-us":"English - United States","es-es":"Spanish - Spain (Modern Sort)","es-mx":"Spanish - Mexico","fi-fi":"Finnish","fr-ca":"French - Canada","fr-fr":"French - France","hi-in":"Hindi","it-it":"Italian - Italy","ja-jp":"Japanese","ko-kr":"Korean","nb-no":"Norwegian (Bokmål)","nl-be":"Dutch - Belgium","nl-nl":"Dutch - Netherlands","pl-pl":"Polish","pt-br":"Portuguese - Brazil","ru-ru":"Russian","sv-se":"Swedish","zh-cn":"Chinese - People's Republic of China","zh-hk":"Chinese - Hong Kong SAR","cs-cz":"Czech","pt-pt":"Portuguese - Portugal","tr-tr":"Turkish","vi-vn":"Vietnamese","th-th":"Thai","he-il":"Hebrew","cy-gb":"Welsh","uk-ua":"Ukrainian","el-gr":"Greek","hu-hu":"Hungarian","ro-ro":"Romanian","sk-sk":"Slovak","zh-tw":"Chinese - Taiwan"},"captionLanguageStrings":{"ar":"Arabic","da":"Danish","de":"German","en":"English","es":"Spanish","fi":"Finnish","fr-ca":"French - Canada","fr":"French - France","hi":"Hindi","it":"Italian","ja":"Japanese","ko":"Korean","nb":"Norwegian (Bokmål)","nl":"Dutch","pl":"Polish","pt":"Portuguese - Brazil","ru":"Russian","sv":"Swedish","zh-Hans":"Chinese (Simplified)","zh-Hant":"Chinese (Traditional)","cs":"Czech","pt-pt":"Portuguese - Portugal","tr":"Turkish","vi":"Vietnamese","th":"Thai","he":"Hebrew","cy":"Welsh","uk":"Ukrainian","el":"Greek","hu":"Hungarian","ro":"Romanian","sk":"Slovak"},"captionsBannerSpinnerText":"Starting captions...","realTimeTextInputBoxDefaultText":"Type message in real-time","realTimeTextInputErrorMessage":"Message cannot exceed 2000 characters","realTimeTextBannerTitle":"RTT","realTimeTextBannerContent":"RTT (real-time text) is enabled for all participants for the entire duration of the meeting.","realTimeTextBannerLinkLabel":"Learn more","realTimeTextModalAriaLabel":"Turn on RTT Modal","realTimeTextModalTitle":"Turn on RTT?","realTimeTextModalText":"Real-time text (RTT) will be turned on for everyone in the meeting.","realTimeTextConfirmButtonLabel":"Turn on","realTimeTextCancelButtonLabel":"Cancel","realTimeTextCloseModalButtonAriaLabel":"Close RTT Modal","captionsOnlyContainerTitle":"Captions","realTimeTextOnlyContainerTitle":"Real-Time Text","captionsAndRealTimeTextContainerTitle":"Captions and Real-Time Text","expandButtonAriaLabel":"Expand","minimizeButtonAriaLabel":"Collapse","transferPageTransferorText":"Transferring...","transferPageTransferTargetText":"Connecting...","transferPageUnknownTransferorDisplayName":"Unknown","transferPageUnknownTransferTargetDisplayName":"Unknown","transferPageNoticeString":"You are being transferred","participantCouldNotBeReachedTitle":"Target participant is currently not available","participantCouldNotBeReachedMoreDetails":"Please contact participant when they are available","permissionToReachTargetParticipantNotAllowedTitle":"Permission to reach target participant is not allowed","permissionToReachTargetParticipantNotAllowedMoreDetails":"Please check that the target participant is in the same tenant","unableToResolveTenantTitle":"Unable to resolve tenant id for the target participant","unableToResolveTenantMoreDetails":"Please check the participant id is entered correctly","participantIdIsMalformedTitle":"Participant id is not in the correct format","participantIdIsMalformedMoreDetails":"Please check that the participant id is in the correct format","moreButtonGalleryControlLabel":"View","moreButtonGalleryPositionToggleLabel":"Move gallery to top","moreButtonGallerySpeakerLayoutLabel":"Speaker","moreButtonGalleryFloatingLocalLayoutLabel":"Dynamic","moreButtonGalleryDefaultLayoutLabel":"Gallery view","moreButtonGalleryFocusedContentLayoutLabel":"Focus on content","moreButtonLargeGalleryDefaultLayoutLabel":"Large Gallery","moreButtonTogetherModeLayoutLabel":"Together mode","capabilityChangedNotification":{"turnVideoOn":{"lostDueToMeetingOption":"Your camera has been disabled. You can no longer share video.","grantedDueToMeetingOption":"Your camera has been enabled. Turn it on if you'd like to share video."},"unmuteMic":{"lostDueToMeetingOption":"Your mic has been disabled. You can no longer unmute.","grantedDueToMeetingOption":"Your mic has been enabled. Unmute if you'd like to speak."},"shareScreen":{"lostDueToRoleChangeToAttendee":"Your role has been changed. Some actions, like sharing content, won't be available to you.","grantedDueToRoleChangeToPresenter":"You're a presenter. You can share content and facilitate the meeting."},"hideAttendeeNames":{"hideAttendeeNameAttendee":"Your name is hidden from other attendees. Organisers and presenters can see your real name.","hideAttendeeNamePresenter":"Attendee names are hidden. Only organisers and presenters can see names to protect attendee privacy."}},"surveyTitle":"Help us improve","starSurveyHelperText":"How was the quality of the call?","starSurveyOneStarText":"The quality was bad.","starSurveyTwoStarText":"The quality was poor.","starSurveyThreeStarText":"The quality was good.","starSurveyFourStarText":"The quality was great.","starSurveyFiveStarText":"The quality was excellent.","surveyConfirmButtonLabel":"Send Feedback","starRatingAriaLabel":"Select {0} of {1} stars","surveySkipButtonLabel":"Skip","tagsSurveyQuestion":"What could have been better?","tagsSurveyTextFieldDefaultText":"Other, please specify","tagsSurveyHelperText":"Check any issues you experienced","endOfSurveyText":"Thank you for your feedback!","surveyIssues":{"overallRating":{"callCannotJoin":"I could not join call","callCannotInvite":"I could not invite others into the call","hadToRejoin":"I had to rejoin the call","callEndedUnexpectedly":"Call ended for me unexpectedly","otherIssues":"I was having other issues with the call"},"audioRating":{"noLocalAudio":"The other side could not hear any sound","noRemoteAudio":"I could not hear any sound","echo":"I heard echos on the call","audioNoise":"I heard noise on the call","lowVolume":"Volume was low","audioStoppedUnexpectedly":"Audio stopped unexpectedly","distortedSpeech":"Audio was distorted","audioInterruption":"Audio was interrupted","otherIssues":"I was having other audio issues in this call"},"videoRating":{"noVideoReceived":"I could not see any video","noVideoSent":"Others could not see me","lowQuality":"Video quality was low","freezes":"Video frozen","stoppedUnexpectedly":"Video stopped unexpectedly","darkVideoReceived":"I can only see dark screens when others turn on their camera","audioVideoOutOfSync":"Audio and Video was out of sync","otherIssues":"I was having other video issues in this call"},"screenshareRating":{"noContentLocal":"Other people could not see my screenshare","noContentRemote":"I could not see other people's screenshare","cannotPresent":"I could not present my screen","lowQuality":"Screen share quality was low","freezes":"Screen share frozen","stoppedUnexpectedly":"Screen share stopped unexpectedly","largeDelay":"Screen share has a large delay","otherIssues":"I was having other screen share issues in this call"}},"surveyIssuesHeadingStrings":{"overallRating":"Overall","audioRating":"Audio","videoRating":"Video","screenshareRating":"Presenting"},"spotlightPrompt":{"startSpotlightHeading":"Spotlight for everyone?","startSpotlightText":"You'll highlight this video for everyone in the meeting.","startSpotlightOnSelfText":"You'll highlight your video for everyone in the meeting.","startSpotlightConfirmButtonLabel":"Spotlight for everyone","startSpotlightCancelButtonLabel":"Cancel","stopSpotlightHeading":"Stop spotlighting this video?","stopSpotlightOnSelfHeading":"Exit spotlight?","stopAllSpotlightHeading":"Stop spotlighting all videos?","stopSpotlightText":"This video will no longer be highlighted for everyone in the meeting.","stopSpotlightOnSelfText":"Your video will no longer be highlighted for everyone in the meeting.","stopAllSpotlightText":"The videos will no longer be highlighted for everyone in the meeting.","stopSpotlightConfirmButtonLabel":"Stop spotlighting","stopSpotlightOnSelfConfirmButtonLabel":"Exit spotlight","stopSpotlightCancelButtonLabel":"Cancel","closeSpotlightPromptButtonLabel":"Close"},"exitSpotlightButtonLabel":"Exit spotlight","exitSpotlightButtonTooltip":"Exit spotlight","leaveConfirmButtonLabel":"Leave","endCallConfirmButtonLabel":"End call","hangUpCancelButtonLabel":"Cancel","leaveConfirmDialogTitle":"Leave the call?","leaveConfirmDialogContent":"Are you sure you want to leave the call?","endCallConfirmDialogTitle":"End the call?","endCallConfirmDialogContent":"You'll end the call for everyone.","invalidMeetingIdentifier":"Invalid meeting ID or passcode","pinParticipantMenuLabel":"Pin for me","pinParticipantLimitReachedMenuLabel":"Pin (limit reached)","unpinParticipantMenuLabel":"Unpin","pinParticipantMenuItemAriaLabel":"Pin for me","unpinParticipantMenuItemAriaLabel":"Unpin","muteAllMenuLabel":"Mute all","muteAllDialogTitle":"Mute everyone?","muteAllDialogContent":"This will mute everyone in the meeting but you.","muteAllConfirmButtonLabel":"Mute all","muteAllCancelButtonLabel":"Cancel","joinBreakoutRoomButtonLabel":"Join breakout room","returnFromBreakoutRoomButtonLabel":"Leave room","leaveBreakoutRoomAndMeetingButtonLabel":"Leave meeting","breakoutRoomJoinedNotificationTitle":"You've joined Breakout room '{roomName}'","joinBreakoutRoomBannerTitle":"Breakout room '{roomName}' is open","joinBreakoutRoomBannerButtonLabel":"Join","returnFromBreakoutRoomBannerTitle":"Return to main meeting","returnFromBreakoutRoomBannerButtonLabel":"Rejoin","forbidAudioMenuLabel":"Disable mic","permitAudioMenuLabel":"Allow mic","forbidOthersAudioDialogTitle":"Disable mic for attendees?","forbidOthersAudioDialogContent":"Attendees won’t be able to unmute themselves. The organiser and presenters can let people unmute as needed.","forbidOthersAudioConfirmButtonLabel":"Disable mics","forbidOthersAudioCancelButtonLabel":"Cancel","permitOthersAudioDialogTitle":"Allow mic for attendees?","permitOthersAudioDialogContent":"Everyone in the meeting will be able to unmute themselves.","permitOthersAudioConfirmButtonLabel":"Allow mics","permitOthersAudioCancelButtonLabel":"Cancel","forbidOthersAudioMenuLabel":"Disable mic for attendees","permitOthersAudioMenuLabel":"Allow mic for attendees","forbidVideoMenuLabel":"Disable camera","permitVideoMenuLabel":"Allow camera","forbidOthersVideoDialogTitle":"Disable camera for attendees?","forbidOthersVideoDialogContent":"Attendees won’t be able to turn on video themselves. The organiser and presenters can let people turn on camera as needed.","forbidOthersVideoConfirmButtonLabel":"Disable cameras","forbidOthersVideoCancelButtonLabel":"Cancel","permitOthersVideoDialogTitle":"Allow camera for attendees?","permitOthersVideoDialogContent":"Everyone in the meeting will be able to turn on video themselves.","permitOthersVideoConfirmButtonLabel":"Allow cameras","permitOthersVideoCancelButtonLabel":"Cancel","forbidOthersVideoMenuLabel":"Disable camera for attendees","permitOthersVideoMenuLabel":"Allow camera for attendees"}`),chat:{chatListHeader:"In this chat",uploadAttachment:"Upload Attachment",uploadImageDataNotProvided:"Image data is not provided.",uploadImageIsTooLarge:"Image is too large. Choose one that's less than {maxImageSize} MB.",uploadImageExtensionIsNotAllowed:"Uploading .{imageExtension} image is not allowed.",uploadImageFailed:"Unable to upload image. Please try again later."},callWithChat:{chatButtonLabel:"Chat",chatButtonNewMessageNotificationLabel:"New Message",chatButtonTooltipClosedWithMessageCount:"Show chat ({unreadMessagesCount} unread)",chatButtonTooltipClose:"Hide chat",chatButtonTooltipOpen:"Show chat",chatPaneTitle:"Chat",copyInviteLinkButtonLabel:"Copy invite link",copyInviteLinkButtonActionedLabel:"Link copied",copyInviteLinkActionedAriaLabel:"Invite link copied",dismissSidePaneButtonLabel:"Close",moreDrawerAudioDeviceMenuTitle:"Audio Device",moreDrawerButtonLabel:"More options",moreDrawerButtonTooltip:"More options",moreDrawerMicrophoneMenuTitle:"Microphone",moreDrawerSpeakerMenuTitle:"Speaker",moreDrawerCaptionsMenuTitle:"Live captions",moreDrawerSpokenLanguageMenuTitle:"Spoken language",moreDrawerCaptionLanguageMenuTitle:"Caption language",moreDrawerGalleryOptionsMenuTitle:"Gallery options",peopleButtonLabel:"People",selectedPeopleButtonLabel:"People Button Selected",peopleButtonTooltipOpen:"Show participants",peopleButtonTooltipClose:"Hide participants",peopleButtonTooltipOpenAriaLabel:"People button, Show participants",peopleButtonTooltipCloseAriaLabel:"People button, Hide participants",peoplePaneSubTitle:"In this call",peoplePaneTitle:"People",pictureInPictureTileAriaLabel:"Video Feeds. Click to return to call screen.",removeMenuLabel:"Remove",openDialpadButtonLabel:"Dial phone number",returnToCallButtonAriaDescription:"Return to Call",returnToCallButtonAriaLabel:"Back",peoplePaneAddPeopleButtonLabel:"Add People",dialpadStartCallButtonLabel:"Call",dialpadModalTitle:"Dial Phone Number",dialpadModalAriaLabel:"Dialpad",dialpadCloseModalButtonAriaLabel:"Close dialpad",openDtmfDialpadLabel:"Show dialpad",dtmfDialpadPlaceholderText:"Enter number",breakoutRoomChatPaneTitle:"Breakout Room Chat",chatContentSpinnerLabel:"Loading chat"}},Yh=t=>{const e=Object.assign({},oje);return Fx(t).forEach(i=>{e[i]=Object.assign(Object.assign({},e[i]),t[i])}),e},dli={component:aQt,strings:Yh(cli)},uli={component:rQt,strings:Yh({call:JSON.parse(`{"cameraLabel":"الكاميرا","noCamerasLabel":"لا توجد أي كاميرات","cameraPermissionDenied":"يقوم المستعرض بحظر الوصول إلى الكاميرا","cameraTurnedOff":"تم إيقاف تشغيل الكاميرا","chatButtonLabel":"دردشة","close":"إغلاق","complianceBannerNowOnlyRecording":"أنت الآن تسجل هذا الاجتماع فقط.","complianceBannerNowOnlyTranscription":"أنت الآن تقوم فقط بكتابة الحديث لهذا الاجتماع.","complianceBannerRecordingAndTranscriptionSaved":"يتم حفظ التسجيل وكتابة الحديث.","complianceBannerRecordingAndTranscriptionStarted":"بدء التسجيل والنسخ. ","complianceBannerRecordingAndTranscriptionStopped":"التسجيل وكتابة الحديث متوقفان.","complianceBannerRecordingSaving":"يتم حفظ التسجيل.","complianceBannerRecordingStarted":"تم بدء التسجيل.","complianceBannerRecordingStopped":"تم إيقاف التسجيل.","complianceBannerTranscriptionStarted":"كتابة الحديث مبدوءة.","complianceBannerTranscriptionConsent":"من خلال الانضمام، فأنت توافق على كتابة هذا الاجتماع.","complianceBannerTranscriptionSaving":"يتم حفظ كتابة الحديث.","complianceBannerTranscriptionStopped":"توقفت كتابة الحديث.","configurationPageTitle":"بدء مكالمة","copyInviteLinkButtonLabel":"نسخ ارتباط دعوة","copyInviteLinkButtonActionedLabel":"تم نسخ الارتباط","copyInviteLinkActionedAriaLabel":"تم نسخ ارتباط الدعوة","defaultPlaceHolder":"تحديد خيار","dismissSidePaneButtonLabel":"إغلاق","videoEffectsPaneTitle":"التأثيرات","videoEffectsPaneBackgroundSelectionTitle":"الخلفية","videoEffectsPaneAriaLabel":"جزء تأثيرات الفيديو","configurationPageCameraIsLoadingLabel":"يتم الآن تحميل الفيديو...","configurationPageVideoEffectsButtonLabel":"التأثيرات","unableToStartVideoEffect":"يتعذر تطبيق تأثير الفيديو.","blurBackgroundEffectButtonLabel":"تمويه","blurBackgroundTooltip":"تمويه الخلفية","removeBackgroundEffectButtonLabel":"لا شيء","removeBackgroundTooltip":"إزالة الخلفية","cameraOffBackgroundEffectWarningText":"الكاميرا قيد الإيقاف. قم بتشغيل الكاميرا لمشاهدة تأثير الفيديو.","failedToJoinCallDueToNoNetworkMoreDetails":"تم قطع الاتصال بسبب مشكلة في الشبكة. تحقق من اتصالك وانضم مرة أخرى.","failedToJoinCallDueToNoNetworkTitle":"‏‏تم قطع اتصال المكالمة","failedToJoinTeamsMeetingReasonAccessDeniedMoreDetails":"لم يتم منحك إدخالا في المكالمة. إذا كان هذا خطأ، فعاود الانضمام إلى المكالمة.","failedToJoinTeamsMeetingReasonAccessDeniedTitle":"تم التجاهل من ساحة الانتظار","learnMore":"تعرّف على المزيد","leavingCallTitle":"تتم الآن المغادرة...","leftCallMoreDetails":"إذا كان هذا خطأ، فعاود الانضمام إلى المكالمة.","leftCallTitle":"قمت بمغادرة المكالمة","lobbyScreenConnectingToCallTitle":"جارٍ الانضمام إلى مكالمة","lobbyScreenWaitingToBeAdmittedTitle":"في انتظار السماح","microphonePermissionDenied":"يقوم المستعرض بحظر الوصول إلى الميكروفون","microphoneToggleInLobbyNotAllowed":"لا يمكن كتم الصوت أو إلغاء كتمه أثناء وجودك في ساحة الانتظار.","mutedMessage":"تم كتم صوتك","networkReconnectMoreDetails":"يبدو أنه قد حدث خطأ ما. نحاول معاودة الاتصال.","networkReconnectTitle":"انتظار","notInvitedToRoomDetails":"لا يمكنك الانضمام إلى هذه الغرفة لأنه ليس لديك دعوة.","notInvitedToRoomTitle":"غير مدعو إلى الغرفة","peopleButtonLabel":"الأشخاص","selectedPeopleButtonLabel":"تم تحديد زر الأشخاص","peoplePaneTitle":"الأشخاص","peoplePaneMoreButtonAriaLabel":"المزيد","peopleButtonTooltipOpen":"إظهار المشاركين","peopleButtonTooltipClose":"إخفاء المشاركين","peoplePaneSubTitle":"في هذه المكالمة {numberOfPeople}","privacyPolicy":"نهج الخصوصية","rejoinCallButtonLabel":"الانضمام إلى المكالمة","removedFromCallMoreDetails":"قام مشارك آخر بإزالتك من المكالمة.","removedFromCallTitle":"تمت إزالتك","removeMenuLabel":"إزالة","startSpotlightMenuLabel":"تسليط الضوء لدى الجميع","addSpotlightMenuLabel":"إضافة تسليط ضوء","stopSpotlightMenuLabel":"التوقف عن تسليط الضوء","stopSpotlightOnSelfMenuLabel":"الخروج من وضع تسليط الضوء","spotlightLimitReachedMenuTitle":"تم الوصول إلى الحد الأقصى لتسليط الضوء","stopAllSpotlightMenuLabel":"إيقاف جميع عمليات تسليط الضوء","returnToCallButtonAriaDescription":"رجوع إلى المكالمة","returnToCallButtonAriaLabel":"رجوع","roomNotFoundDetails":"تعذر العثور على معرف الغرفة الذي تم توفيره.","roomNotFoundTitle":"لم يتم العثور على الغرفة","roomNotValidDetails":"هذه الغرفة غير صالحة في الوقت الحالي.","roomNotValidTitle":"الغرفة غير صالحة","inviteToRoomRemovedDetails":"تمت إزالة دعوتك للانضمام إلى هذه الغرفة.","inviteToRoomRemovedTitle":"تمت إزالة الدعوة إلى الغرفة","soundLabel":"صوت","noMicrophonesLabel":"لم يتم العثور على ميكروفونات","noSpeakersLabel":"لم يتم العثور على سماعات","startCallButtonLabel":"بدء مكالمة","openDialpadButtonLabel":"اطلب رقم الهاتف","peoplePaneAddPeopleButtonLabel":"إضافة أشخاص","dialpadStartCallButtonLabel":"مكالمة","dialpadModalTitle":"اطلب رقم الهاتف","dialpadModalAriaLabel":"لوحة الطلب","dialpadCloseModalButtonAriaLabel":"إغلاق لوحة الطلب","moreButtonCallingLabel":"المزيد","resumeCallButtonLabel":"استئناف","resumingCallButtonLabel":"يتم الآن الاستئناف...","resumeCallButtonAriaLabel":"استئناف المكالمة","resumingCallButtonAriaLabel":"استئناف المكالمة","holdScreenLabel":"أنت قيد الانتظار","openDtmfDialpadLabel":"عرض لوحة الطلب","dtmfDialpadPlaceholderText":"أدخل عدداً","outboundCallingNoticeString":"يتم الآن الاتصال...","participantJoinedNoticeString":"انضم {displayName}","twoParticipantJoinedNoticeString":"انضم {displayName1} و{displayName2}","threeParticipantJoinedNoticeString":"انضم {displayName1} و{displayName2} و{displayName3}","participantLeftNoticeString":"غادر {displayName}","twoParticipantLeftNoticeString":"غادر {displayName1} و{displayName2}","threeParticipantLeftNoticeString":"غادر {displayName1} و{displayName2} و{displayName3}","unnamedParticipantString":"مشارك غير مسمى","manyUnnamedParticipantsJoined":"انضم مشارك غير مسمى و{numOfParticipants} من المشاركين الآخرين","manyUnnamedParticipantsLeft":"غادر مشارك غير مسمى و{numOfParticipants} من المشاركين الآخرين","manyParticipantsJoined":"انضم {displayName1} {displayName2} {displayName3} {numOfParticipants} مشاركين آخرين","manyParticipantsLeft":"غادر {displayName1} {displayName2} {displayName3} والمشاركون الآخرون {numOfParticipants}","liveCaptionsLabel":"نص الكلام مباشرةً","captionsSettingsLabel":"إعدادات نص الكلام","startCaptionsButtonOnLabel":"تمكين نص الكلام","startCaptionsButtonOffLabel":"تعطيل نص الكلام","startCaptionsButtonTooltipOnContent":"تعطيل نص الكلام","startCaptionsButtonTooltipOffContent":"تمكين نص الكلام","captionsSettingsModalTitle":"إعدادات التسميات التوضيحية","captionsSettingsSpokenLanguageDropdownLabel":"اللغة المنطوقة","captionsSettingsCaptionLanguageDropdownLabel":"لغة التسميات التوضيحية","captionsSettingsSpokenLanguageDropdownInfoText":"اللغة التي يتحدث بها كل شخص في هذه المكالمة.","captionsSettingsCaptionLanguageDropdownInfoText":"سيظهر نص الكلام بهذه اللغة.","captionsSettingsConfirmButtonLabel":"تأكيد","captionsSettingsCancelButtonLabel":"إلغاء","captionsSettingsModalAriaLabel":"مربع حوار إعدادات نص الكلام المشروط","captionsSettingsCloseModalButtonAriaLabel":"إغلاق إعداد نص الكلام","captionsBannerMoreButtonCallingLabel":"خيارات إضافية لإعدادات التسميات التوضيحية","captionsBannerMoreButtonTooltip":"خيارات إضافية","realTimeTextLabel":"عرض الكتابة في الوقت الحقيقي (RTT)","startRealTimeTextLabel":"تشغيل RTT لهذه المكالمة","disabledStartRealTimeTextLabel":"RTT قيد التشغيل حاليا، ولا يمكن إيقاف تشغيله","dismissModalAriaLabel":"صورة وصورة محلية وبعيدة، اضغط على مفتاح الإدخال للعودة إلى المكالمة","callRejectedTitle":"إكمال المكالمة غير ممكن","callRejectedMoreDetails":"الشخص الذي تحاول الوصول إليه غير متوفر. الرجاء المحاولة مرة أخرى لاحقا.","callTimeoutTitle":"إكمال المكالمة غير ممكن","callTimeoutDetails":"الشخص الذي تحاول الوصول إليه غير متوفر. الرجاء المحاولة مرة أخرى لاحقا.","callTimeoutBotTitle":"إكمال المكالمة غير ممكن","callTimeoutBotDetails":"الخدمة التي تحاول الوصول إليها غير متوفرة. الرجاء المحاولة مرة أخرى لاحقا.","dtmfDialerButtonLabel":"لوحة الطلب","dtmfDialerButtonTooltipOn":"عرض لوحة الطلب","dtmfDialerButtonTooltipOff":"إخفاء لوحة الطلب","dtmfDialerMoreButtonLabelOn":"عرض لوحة الطلب","dtmfDialerMoreButtonLabelOff":"إخفاء لوحة الطلب","phoneCallMoreButtonLabel":"مكالمة هاتفية","spokenLanguageStrings":{"ar-ae":"العربية - الإمارات العربية المتحدة","ar-sa":"العربية - السعودية","da-dk":"الدانمركية","de-de":"الألمانية - ألمانيا","en-au":"الإنجليزية - أستراليا","en-ca":"الإنجليزية - كندا","en-gb":"الإنجليزية - المملكة المتحدة","en-in":"الإنجليزية - الهند","en-nz":"الإنجليزية - نيوزيلندا","en-us":"الإنجليزية - الولايات المتحدة","es-es":"الإسبانية - إسبانيا (فرز حديث)","es-mx":"الإسبانية - المكسيك","fi-fi":"الفنلندية","fr-ca":"الفرنسية - كندا","fr-fr":"الفرنسية - فرنسا","hi-in":"الهندية","it-it":"الإيطالية - إيطاليا","ja-jp":"اليابانية","ko-kr":"الكورية","nb-no":"النرويجية (بوكمال)","nl-be":"الهولندية - بلجيكا","nl-nl":"الهولندية - هولندا","pl-pl":"البولندية","pt-br":"البرتغالية - البرازيل","ru-ru":"الروسية","sv-se":"السويدية","zh-cn":"الصينية - جمهورية الصين الشعبية","zh-hk":"الصينية - منطقة هونغ كونغ الإدارية الخاصة","cs-cz":"التشيكية","pt-pt":"البرتغالية - البرتغال","tr-tr":"التركية","vi-vn":"الفيتنامية","th-th":"التايلاندية","he-il":"العبرية","cy-gb":"الويلزية","uk-ua":"الأوكرانية","el-gr":"اليونانية","hu-hu":"الهنغارية","ro-ro":"الرومانية","sk-sk":"السلوفاكية","zh-tw":"الصينية - تايوان"},"captionLanguageStrings":{"ar":"العربية","da":"الدانمركية","de":"الألمانية","en":"الإنجليزية","es":"الإسبانية","fi":"الفنلندية","fr-ca":"الفرنسية - كندا","fr":"الفرنسية - فرنسا","hi":"الهندية","it":"الإيطالية","ja":"اليابانية","ko":"الكورية","nb":"النرويجية (بوكمال)","nl":"الهولندية","pl":"البولندية","pt":"البرتغالية - البرازيل","ru":"الروسية","sv":"السويدية","zh-Hans":"الصينية (المبسطة)","zh-Hant":"الصينية (التقليدية)","cs":"التشيكية","pt-pt":"البرتغالية - البرتغال","tr":"التركية","vi":"الفيتنامية","th":"التايلاندية","he":"العبرية","cy":"الويلزية","uk":"الأوكرانية","el":"اليونانية","hu":"الهنغارية","ro":"الرومانية","sk":"السلوفاكية"},"captionsBannerSpinnerText":"يتم الآن بدء التسميات التوضيحية...","realTimeTextInputBoxDefaultText":"اكتب رسالة في الوقت الحقيقي","realTimeTextInputErrorMessage":"لا يمكن أن تتجاوز الرسالة 2000 حرف","realTimeTextBannerTitle":"عرض الكتابة في الوقت الحقيقي (RTT)","realTimeTextBannerContent":"تم تمكين RTT (نص الوقت الحقيقي) لجميع المشاركين طوال مدة الاجتماع.","realTimeTextBannerLinkLabel":"تعرّف على المزيد","realTimeTextModalAriaLabel":"تشغيل مربع حوار عرض الكتابة في الوقت الحقيقي (RTT) المشروط","realTimeTextModalTitle":"هل تريد تشغيل عرض الكتابة في الوقت الحقيقي؟","realTimeTextModalText":"سيتم تشغيل النص في الوقت الحقيقي (RTT) لكل شخص في الاجتماع.","realTimeTextConfirmButtonLabel":"تشغيل","realTimeTextCancelButtonLabel":"إلغاء الأمر","realTimeTextCloseModalButtonAriaLabel":"إغلاق مربع حوار عرض الكتابة في الوقت الحقيقي (RTT) المشروط","captionsOnlyContainerTitle":"نص الكلام","realTimeTextOnlyContainerTitle":"نص حقيقي","captionsAndRealTimeTextContainerTitle":"التسميات التوضيحية والنص في الوقت الحقيقي","expandButtonAriaLabel":"توسيع","minimizeButtonAriaLabel":"طي","transferPageTransferorText":"يتم الآن التحويل...","transferPageTransferTargetText":"جارٍ الاتصال...","transferPageUnknownTransferorDisplayName":"غير معروف","transferPageUnknownTransferTargetDisplayName":"غير معروف","transferPageNoticeString":"يجري نقلك","participantCouldNotBeReachedTitle":"المشارك المستهدف غير متوفر حاليا","participantCouldNotBeReachedMoreDetails":"الرجاء الاتصال بالمشارك عندما يكون متوفرا","permissionToReachTargetParticipantNotAllowedTitle":"غير مسموح بإذن الوصول إلى المشارك الهدف","permissionToReachTargetParticipantNotAllowedMoreDetails":"الرجاء التحقق من أن المشارك الهدف موجود في نفس المستأجر","unableToResolveTenantTitle":"تعذر حل معرف المستأجر للمشارك الهدف","unableToResolveTenantMoreDetails":"الرجاء التحقق من إدخال معرف المشارك بشكل صحيح","participantIdIsMalformedTitle":"تنسيق معرف المشارك غير صحيح","participantIdIsMalformedMoreDetails":"الرجاء التحقق من أن معرف المشارك بالتنسيق الصحيح","moreButtonGalleryControlLabel":"عرض","moreButtonGalleryPositionToggleLabel":"نقل المعرض إلى الأعلى","moreButtonGallerySpeakerLayoutLabel":"مكبر الصوت","moreButtonGalleryFloatingLocalLayoutLabel":"ديناميكي","moreButtonGalleryDefaultLayoutLabel":"طريقة عرض المعرض","moreButtonGalleryFocusedContentLayoutLabel":"التركيز على المحتوى","moreButtonLargeGalleryDefaultLayoutLabel":"معرض كبير","moreButtonTogetherModeLayoutLabel":"وضع التجميع","capabilityChangedNotification":{"turnVideoOn":{"lostDueToMeetingOption":"تم تعطيل الكاميرا الخاصة بك. لم يعد بإمكانك مشاركة الفيديو.","grantedDueToMeetingOption":"تم تمكين الكاميرا الخاصة بك. قم بتشغيله إذا كنت ترغب في مشاركة الفيديو."},"unmuteMic":{"lostDueToMeetingOption":"لقد تم تعطيل الميكروفون الخاص بك. لم يعد بإمكانك إلغاء كتم الصوت.","grantedDueToMeetingOption":"تم تمكين الميكروفون لديك. قم بإلغاء كتم الصوت إذا كنت ترغب في التحدث."},"shareScreen":{"lostDueToRoleChangeToAttendee":"تم تغيير دورك. لن تتوفر بعض الإجراءات، مثل مشاركة المحتوى، لك.","grantedDueToRoleChangeToPresenter":"أنت مقدم العرض. يمكنك مشاركة المحتوى وتسهيل الاجتماع."},"hideAttendeeNames":{"hideAttendeeNameAttendee":"اسمك مخفي عن الحضور الآخرين. يمكن للمنظمين والمقدمين رؤية اسمك الحقيقي.","hideAttendeeNamePresenter":"أسماء الحضور مخفية. يمكن للمنظمين والمقدمين فقط رؤية الأسماء لحماية خصوصية الحضور."}},"surveyTitle":"ساعدنا في تحسين خدماتنا","starSurveyHelperText":"كيف كانت جودة المكالمة؟","starSurveyOneStarText":"كانت الجودة سيئة.","starSurveyTwoStarText":"كانت الجودة رديئة.","starSurveyThreeStarText":"كانت الجودة جيدة.","starSurveyFourStarText":"كانت الجودة رائعة.","starSurveyFiveStarText":"كانت الجودة ممتازة.","surveyConfirmButtonLabel":"إرسال ملاحظات","starRatingAriaLabel":"حدد {0} من {1} نجوم","surveySkipButtonLabel":"تخطٍ","tagsSurveyQuestion":"ما الذي كان يمكن أن يكون أفضل؟","tagsSurveyTextFieldDefaultText":"أخرى، يُرجى التحديد","tagsSurveyHelperText":"تحقق من أي مشاكل واجهتك","endOfSurveyText":"شكراً لك على تقديم ملاحظاتك!","surveyIssues":{"overallRating":{"callCannotJoin":"تعذر علي الانضمام إلى المكالمة","callCannotInvite":"لم أتمكن من دعوة الآخرين إلى المكالمة","hadToRejoin":"اضطررت إلى إعادة الانضمام إلى المكالمة","callEndedUnexpectedly":"انتهت المكالمة عندي بشكل غير متوقع","otherIssues":"كنت أواجه مشكلات أخرى في المكالمة"},"audioRating":{"noLocalAudio":"لم تسمع الجهة الأخرى أي صوت","noRemoteAudio":"لم أسمع أي صوت","echo":"سمعت صدى في المكالمة","audioNoise":"سمعت ضوضاء في المكالمة","lowVolume":"كان مستوى الصوت منخفضاً","audioStoppedUnexpectedly":"تم إيقاف الصوت بشكل غير متوقع","distortedSpeech":"تم تشويه الصوت","audioInterruption":"تمت مقاطعة الصوت","otherIssues":"كنت أواجه مشكلات صوتية أخرى في هذه المكالمة"},"videoRating":{"noVideoReceived":"لم أتمكن من مشاهدة أي فيديو","noVideoSent":"لم يتمكن الآخرون من رؤيتي","lowQuality":"جودة الفيديو منخفضة","freezes":"الفيديو مجمد","stoppedUnexpectedly":"توقف الفيديو بشكل غير متوقع","darkVideoReceived":"أرى الشاشات الداكنة فقط عندما يقوم الآخرون بتشغيل الكاميرا الخاصة بهم","audioVideoOutOfSync":"لم تتم مزامنة الصوت والفيديو","otherIssues":"كنت أواجه مشكلات فيديو أخرى في هذه المكالمة"},"screenshareRating":{"noContentLocal":"تعذر على الأشخاص الآخرين رؤية مشاركة الشاشة","noContentRemote":"لم أتمكن من رؤية مشاركة الشاشة الخاصة بأشخاص آخرين","cannotPresent":"تعذر علي تقديم الشاشة","lowQuality":"كانت جودة مشاركة الشاشة منخفضة","freezes":"تم تجميد مشاركة الشاشة","stoppedUnexpectedly":"توقفت مشاركة الشاشة بشكل غير متوقع","largeDelay":"مشاركة الشاشة لها تأخير كبير","otherIssues":"كنت أواجه مشكلات أخرى في مشاركة الشاشة في هذه المكالمة"}},"surveyIssuesHeadingStrings":{"overallRating":"بشكل عام","audioRating":"صوت","videoRating":"فيديو","screenshareRating":"تقديم"},"spotlightPrompt":{"startSpotlightHeading":"هل تريد تسليط الضوء للجميع؟","startSpotlightText":"ستسلط الضوء على هذا الفيديو لجميع المشاركين في الاجتماع.","startSpotlightOnSelfText":"ستبرز مقطع الفيديو الخاص بك لجميع المشاركين في الاجتماع.","startSpotlightConfirmButtonLabel":"تسليط الضوء للجميع","startSpotlightCancelButtonLabel":"إلغاء","stopSpotlightHeading":"هل تريد إيقاف تسليط الضوء على مقطع الفيديو هذا؟","stopSpotlightOnSelfHeading":"هل تريد إنهاء تسليط الضوء؟","stopAllSpotlightHeading":"التوقف عن تسليط الضوء على جميع ملفات الفيديو؟","stopSpotlightText":"لن يتم تمييز الفيديو الخاص بك بعد الآن لجميع المشاركين في الاجتماع.","stopSpotlightOnSelfText":"لن يتم تمييز الفيديو الخاص بك بعد الآن لجميع المشاركين في الاجتماع.","stopAllSpotlightText":"لن يتم تمييز مقاطع الفيديو بعد الآن للجميع في الاجتماع.","stopSpotlightConfirmButtonLabel":"التوقف عن تسليط الضوء","stopSpotlightOnSelfConfirmButtonLabel":"الخروج من وضع تسليط الضوء","stopSpotlightCancelButtonLabel":"إلغاء","closeSpotlightPromptButtonLabel":"إغلاق"},"exitSpotlightButtonLabel":"الخروج من وضع تسليط الضوء","exitSpotlightButtonTooltip":"الخروج من وضع تسليط الضوء","leaveConfirmButtonLabel":"مغادرة","endCallConfirmButtonLabel":"إنهاء المكالمة","hangUpCancelButtonLabel":"إلغاء","leaveConfirmDialogTitle":"هل تريد مغادرة المكالمة؟","leaveConfirmDialogContent":"هل تريد بالتأكيد مغادرة المكالمة؟","endCallConfirmDialogTitle":"هل تريد إنهاء المكالمة؟","endCallConfirmDialogContent":"ستنهي المكالمة لدى الجميع.","invalidMeetingIdentifier":"معرف اجتماع أو رمز مرور غير صالح","pinParticipantMenuLabel":"تثبيت نيابة عني","pinParticipantLimitReachedMenuLabel":"تثبيت (تم بلوغ الحد الأقصى)","unpinParticipantMenuLabel":"إزالة التثبيت","pinParticipantMenuItemAriaLabel":"تثبيت نيابة عني","unpinParticipantMenuItemAriaLabel":"إزالة التثبيت","muteAllMenuLabel":"كتم صوت الجميع","muteAllDialogTitle":"هل تريد كتم صوت الجميع؟","muteAllDialogContent":"سيؤدي ذلك إلى كتم صوت الجميع في الاجتماع باستثننائك.","muteAllConfirmButtonLabel":"كتم صوت الجميع","muteAllCancelButtonLabel":"إلغاء","joinBreakoutRoomButtonLabel":"انضمام إلى غرفة فرعية","returnFromBreakoutRoomButtonLabel":"مغادرة الغرفة","leaveBreakoutRoomAndMeetingButtonLabel":"مغادرة الاجتماع","breakoutRoomJoinedNotificationTitle":"لقد انضممت إلى الغرفة الفرعية '{roomName}'","joinBreakoutRoomBannerTitle":"الغرفة الفرعية '{roomName}' مفتوحة","joinBreakoutRoomBannerButtonLabel":"انضمام","returnFromBreakoutRoomBannerTitle":"رجوع إلى الاجتماع الرئيسي","returnFromBreakoutRoomBannerButtonLabel":"إعادة الانضمام","forbidAudioMenuLabel":"تعطيل الميكروفون","permitAudioMenuLabel":"السماح بالميكروفون","forbidOthersAudioDialogTitle":"هل تريد تعطيل الميكروفون للحضور؟","forbidOthersAudioDialogContent":"لن يتمكن الحضور من إلغاء كتم الصوت لأنفسهم. يمكن للمنظم والمقدمين السماح للأشخاص بإلغاء كتم الصوت حسب الحاجة.","forbidOthersAudioConfirmButtonLabel":"تعطيل الميكروفونات","forbidOthersAudioCancelButtonLabel":"إلغاء الأمر","permitOthersAudioDialogTitle":"هل تريد السماح بالميكروفون لدى الحضور؟","permitOthersAudioDialogContent":"سيتمكن أي شخص في الاجتماع من إلغاء كتم الصوت لأنفسهم.","permitOthersAudioConfirmButtonLabel":"السماح بالميكروفونات","permitOthersAudioCancelButtonLabel":"إلغاء الأمر","forbidOthersAudioMenuLabel":"تعطيل الميكروفون للحضور","permitOthersAudioMenuLabel":"السماح بالميكروفون للحضور","forbidVideoMenuLabel":"تعطيل الكاميرا","permitVideoMenuLabel":"السماح بالكاميرا","forbidOthersVideoDialogTitle":"هل تريد تعطيل الكاميرا لدى الحضور؟","forbidOthersVideoDialogContent":"لن يتمكن الحضور من تشغيل الفيديو بأنفسهم. يمكن للمنظم والمقدمين السماح للأشخاص بتشغيل الكاميرا حسب الحاجة.","forbidOthersVideoConfirmButtonLabel":"تعطيل الكاميرات","forbidOthersVideoCancelButtonLabel":"إلغاء الأمر","permitOthersVideoDialogTitle":"هل تريد السماح بالكاميرا لدى الحضور؟","permitOthersVideoDialogContent":"سيتمكن كل شخص في الاجتماع من تشغيل الفيديو بأنفسهم.","permitOthersVideoConfirmButtonLabel":"السماح بالكاميرات","permitOthersVideoCancelButtonLabel":"إلغاء الأمر","forbidOthersVideoMenuLabel":"تعطيل الكاميرا للحضور","permitOthersVideoMenuLabel":"السماح بالكاميرا للحضور"}`),chat:{chatListHeader:"في هذه الدردشة",uploadAttachment:"تحميل المرفق",uploadImageDataNotProvided:"لم يتم توفير بيانات الصورة.",uploadImageIsTooLarge:"الصورة كبيرة جدا. اختر جهازا أقل من {maxImageSize} ميغابايت.",uploadImageExtensionIsNotAllowed:"تحميل الصورة .{imageExtension} غير مسموح به.",uploadImageFailed:"تعذر تحميل الصورة. الرجاء المحاولة مرة أخرى لاحقا."},callWithChat:{chatButtonLabel:"دردشة",chatButtonNewMessageNotificationLabel:"رسالة جديدة",chatButtonTooltipClosedWithMessageCount:"إظهار الدردشة ({unreadMessagesCount} غير مقروءة)",chatButtonTooltipClose:"إخفاء الدردشة",chatButtonTooltipOpen:"إظهار الدردشة",chatPaneTitle:"دردشة",copyInviteLinkButtonLabel:"نسخ ارتباط دعوة",copyInviteLinkButtonActionedLabel:"تم نسخ الارتباط",copyInviteLinkActionedAriaLabel:"تم نسخ ارتباط الدعوة",dismissSidePaneButtonLabel:"إغلاق",moreDrawerAudioDeviceMenuTitle:"جهاز صوت",moreDrawerButtonLabel:"المزيد من الخيارات",moreDrawerButtonTooltip:"المزيد من الخيارات",moreDrawerMicrophoneMenuTitle:"الميكروفون",moreDrawerSpeakerMenuTitle:"مكبر الصوت",moreDrawerCaptionsMenuTitle:"نص الكلام مباشرةً",moreDrawerSpokenLanguageMenuTitle:"اللغة المنطوقة",moreDrawerCaptionLanguageMenuTitle:"لغة التسمية التوضيحية",moreDrawerGalleryOptionsMenuTitle:"خيارات المعرض",peopleButtonLabel:"الأشخاص",selectedPeopleButtonLabel:"تم تحديد زر الأشخاص",peopleButtonTooltipOpen:"إظهار المشاركين",peopleButtonTooltipClose:"إخفاء المشاركين",peopleButtonTooltipOpenAriaLabel:"زر الأشخاص، إظهار المشاركين",peopleButtonTooltipCloseAriaLabel:"زر الأشخاص، إخفاء المشاركين",peoplePaneSubTitle:"في هذه المكالمة",peoplePaneTitle:"الأشخاص",pictureInPictureTileAriaLabel:"موجزات الفيديو. انقر للعودة إلى شاشة المكالمة.",removeMenuLabel:"إزالة",openDialpadButtonLabel:"اطلب رقم الهاتف",returnToCallButtonAriaDescription:"رجوع إلى المكالمة",returnToCallButtonAriaLabel:"رجوع",peoplePaneAddPeopleButtonLabel:"إضافة أشخاص",dialpadStartCallButtonLabel:"مكالمة",dialpadModalTitle:"اطلب رقم الهاتف",dialpadModalAriaLabel:"لوحة الطلب",dialpadCloseModalButtonAriaLabel:"إغلاق لوحة الطلب",openDtmfDialpadLabel:"عرض لوحة الطلب",dtmfDialpadPlaceholderText:"أدخل عدداً",breakoutRoomChatPaneTitle:"دردشة الغرفة الفرعية",chatContentSpinnerLabel:"يتم الآن تحميل الدردشة"}})},hli={component:oQt,strings:Yh({call:JSON.parse('{"cameraLabel":"Kamera","noCamerasLabel":"Nebyly nalezeny žádné kamery","cameraPermissionDenied":"Váš prohlížeč blokuje přístup ke kameře.","cameraTurnedOff":"Máte vypnutou kameru.","chatButtonLabel":"Chat","close":"Zavřít","complianceBannerNowOnlyRecording":"Nyní tuto schůzku pouze nahráváte.","complianceBannerNowOnlyTranscription":"Nyní tuto schůzku pouze přepisujete.","complianceBannerRecordingAndTranscriptionSaved":"Záznam a přepis se ukládají.","complianceBannerRecordingAndTranscriptionStarted":"Spustilo se nahrávání a přepis.","complianceBannerRecordingAndTranscriptionStopped":"Nahrávání a přepis se zastavily.","complianceBannerRecordingSaving":"Probíhá ukládání záznamu.","complianceBannerRecordingStarted":"Nahrávání se spustilo.","complianceBannerRecordingStopped":"Nahrávání se zastavilo.","complianceBannerTranscriptionStarted":"Přepis se spustil.","complianceBannerTranscriptionConsent":"Připojením vyjadřujete souhlas s přepisem této schůzky.","complianceBannerTranscriptionSaving":"Přepis se ukládá.","complianceBannerTranscriptionStopped":"Přepis se zastavil.","configurationPageTitle":"Začít hovor","copyInviteLinkButtonLabel":"Kopírovat odkaz pro pozvání","copyInviteLinkButtonActionedLabel":"Odkaz byl zkopírován.","copyInviteLinkActionedAriaLabel":"Odkaz pozvánky se zkopíroval","defaultPlaceHolder":"Vyberte jednu možnost","dismissSidePaneButtonLabel":"Zavřít","videoEffectsPaneTitle":"Efekty","videoEffectsPaneBackgroundSelectionTitle":"Pozadí","videoEffectsPaneAriaLabel":"Podokno video efektů","configurationPageCameraIsLoadingLabel":"Video se načítá…","configurationPageVideoEffectsButtonLabel":"Efekty","unableToStartVideoEffect":"Nelze použít efekt videa.","blurBackgroundEffectButtonLabel":"Rozostření","blurBackgroundTooltip":"Rozostřit pozadí","removeBackgroundEffectButtonLabel":"Žádná","removeBackgroundTooltip":"Odebrat pozadí","cameraOffBackgroundEffectWarningText":"Vaše kamera je vypnutá. Pokud chcete vidět efekt videa, zapněte kameru.","failedToJoinCallDueToNoNetworkMoreDetails":"Hovor byl odpojen z důvodu problému se sítí. Zkontrolujte připojení a připojte se znovu.","failedToJoinCallDueToNoNetworkTitle":"Hovor odpojen","failedToJoinTeamsMeetingReasonAccessDeniedMoreDetails":"Vstup do hovoru vám nebyl povolen. Pokud se jednalo o chybu, znovu se do hovoru přihlaste.","failedToJoinTeamsMeetingReasonAccessDeniedTitle":"Odchod z předsálí","learnMore":"Další informace","leavingCallTitle":"Opouštíte hovor...","leftCallMoreDetails":"Pokud se jedná o chybu, připojte se k hovoru znovu.","leftCallTitle":"Opustili jste hovor","lobbyScreenConnectingToCallTitle":"Připojování k hovoru","lobbyScreenWaitingToBeAdmittedTitle":"Čeká se na přijetí","microphonePermissionDenied":"Váš prohlížeč blokuje přístup k mikrofonu.","microphoneToggleInLobbyNotAllowed":"V předsálí nejde ztlumit ani zrušit ztlumení.","mutedMessage":"Jste ztlumení","networkReconnectMoreDetails":"Vypadá to, že se něco nepovedlo. Pokoušíme se znovu připojit k hovoru.","networkReconnectTitle":"Vydržte","notInvitedToRoomDetails":"K této místnosti se nemůžete připojit, protože nemáte pozvánku.","notInvitedToRoomTitle":"Nepozván(a) do místnosti","peopleButtonLabel":"Lidé","selectedPeopleButtonLabel":"Vybráno tlačítko Lidé","peoplePaneTitle":"Lidé","peoplePaneMoreButtonAriaLabel":"Více","peopleButtonTooltipOpen":"Zobrazit účastníky","peopleButtonTooltipClose":"Skrýt účastníky","peoplePaneSubTitle":"V tomto hovoru {numberOfPeople}","privacyPolicy":"Zásady ochrany osobních údajů","rejoinCallButtonLabel":"Znovu se připojit k hovoru","removedFromCallMoreDetails":"Jiný účastník vás odebral z hovoru.","removedFromCallTitle":"Byli jste odebráni","removeMenuLabel":"Odebrat","startSpotlightMenuLabel":"Přidat do hlavního výběru všem","addSpotlightMenuLabel":"Přidat do hlavního výběru","stopSpotlightMenuLabel":"Zastavit přidávání do hlavního výběru","stopSpotlightOnSelfMenuLabel":"Ukončit hlavní výběr","spotlightLimitReachedMenuTitle":"Dosáhlo se limitu hlavního výběru","stopAllSpotlightMenuLabel":"Zastavit všechny výběry","returnToCallButtonAriaDescription":"Pokračovat v hovoru","returnToCallButtonAriaLabel":"Zpět","roomNotFoundDetails":"Zadané ID místnosti se nepovedlo najít.","roomNotFoundTitle":"Místnost nebyla nalezena","roomNotValidDetails":"Tato místnost není v tuto chvíli platná.","roomNotValidTitle":"Neplatná místnost","inviteToRoomRemovedDetails":"Vaše pozvánka k připojení k této místnosti se odebrala.","inviteToRoomRemovedTitle":"Pozvánka do místnosti se odebrala","soundLabel":"Zvuk","noMicrophonesLabel":"Nenašly se žádné mikrofony","noSpeakersLabel":"Nenašly se žádné reproduktory","startCallButtonLabel":"Zahájit hovor","openDialpadButtonLabel":"Vytočit telefonní číslo","peoplePaneAddPeopleButtonLabel":"Přidat lidi","dialpadStartCallButtonLabel":"Volat","dialpadModalTitle":"Vytočit telefonní číslo","dialpadModalAriaLabel":"Číselník","dialpadCloseModalButtonAriaLabel":"Zavřít číselník","moreButtonCallingLabel":"Další","resumeCallButtonLabel":"Pokračovat","resumingCallButtonLabel":"Obnovování…","resumeCallButtonAriaLabel":"Pokračovat v hovoru","resumingCallButtonAriaLabel":"Pokračovat v hovoru","holdScreenLabel":"Váš hovor je přidržený","openDtmfDialpadLabel":"Zobrazit číselník","dtmfDialpadPlaceholderText":"Zadejte číslo","outboundCallingNoticeString":"Volání…","participantJoinedNoticeString":"{displayName} se připojil(a)","twoParticipantJoinedNoticeString":"{displayName1} a {displayName2} se připojili","threeParticipantJoinedNoticeString":"Uživatelé {displayName1}, {displayName2} a {displayName3} se připojili","participantLeftNoticeString":"{displayName} se odpojil(a)","twoParticipantLeftNoticeString":"{displayName1} a {displayName2} se odpojili","threeParticipantLeftNoticeString":"Uživatelé {displayName1}, {displayName2} a {displayName3} se odpojili","unnamedParticipantString":"nepojmenovaný účastník","manyUnnamedParticipantsJoined":"nepojmenovaný účastník a {numOfParticipants} další účastníci se připojili","manyUnnamedParticipantsLeft":"nepojmenovaný účastník a {numOfParticipants} další účastníci se odpojili","manyParticipantsJoined":"{displayName1}, {displayName2}, {displayName3} a {numOfParticipants} se připojili další účastníci","manyParticipantsLeft":"{displayName1}, {displayName2}, {displayName3} a {numOfParticipants} další účastníci","liveCaptionsLabel":"Živé titulky","captionsSettingsLabel":"Nastavení titulků","startCaptionsButtonOnLabel":"Zapnout titulky","startCaptionsButtonOffLabel":"Vypnout titulky","startCaptionsButtonTooltipOnContent":"Vypnout titulky","startCaptionsButtonTooltipOffContent":"Zapnout titulky","captionsSettingsModalTitle":"Nastavení titulků","captionsSettingsSpokenLanguageDropdownLabel":"Mluvený jazyk","captionsSettingsCaptionLanguageDropdownLabel":"Jazyk titulků","captionsSettingsSpokenLanguageDropdownInfoText":"Jazyk, kterým mluví všichni účastníci tohoto hovoru.","captionsSettingsCaptionLanguageDropdownInfoText":"Titulky se zobrazí v tomto jazyce.","captionsSettingsConfirmButtonLabel":"Potvrdit","captionsSettingsCancelButtonLabel":"Zrušit","captionsSettingsModalAriaLabel":"Modální nastavení titulků","captionsSettingsCloseModalButtonAriaLabel":"Nastavení titulků","captionsBannerMoreButtonCallingLabel":"Další možnosti nastavení titulků","captionsBannerMoreButtonTooltip":"Další možnosti","realTimeTextLabel":"Psaní v reálném čase (RTT)","startRealTimeTextLabel":"Zapnout RTT pro tento hovor","disabledStartRealTimeTextLabel":"Psaní v reálném čase je aktuálně zapnuté, nedá se vypnout","dismissModalAriaLabel":"Místní a vzdálený obrázek a obrázek, stisknutím klávesy Enter se vrátíte k hovoru","callRejectedTitle":"Hovor nešlo spojit.","callRejectedMoreDetails":"Osoba, se kterou se pokoušíte spojit, není k dispozici. Zkuste to prosím znovu později.","callTimeoutTitle":"Hovor nešlo spojit.","callTimeoutDetails":"Osoba, se kterou se pokoušíte spojit, není k dispozici. Zkuste to prosím znovu později.","callTimeoutBotTitle":"Hovor nešlo spojit.","callTimeoutBotDetails":"Služba, ke které se pokoušíte získat přístup, není k dispozici. Zkuste to prosím znovu později.","dtmfDialerButtonLabel":"Číselník","dtmfDialerButtonTooltipOn":"Zobrazit číselník","dtmfDialerButtonTooltipOff":"Skrýt číselník","dtmfDialerMoreButtonLabelOn":"Zobrazit číselník","dtmfDialerMoreButtonLabelOff":"Skrýt číselník","phoneCallMoreButtonLabel":"Telefonní hovor","spokenLanguageStrings":{"ar-ae":"Arabština - Spojené arabské emiráty","ar-sa":"Arabština - Saúdská Arábie","da-dk":"Dánština","de-de":"Němčina - Německo","en-au":"Angličtina - Austrálie","en-ca":"Angličtina - Kanada","en-gb":"Angličtina - Spojené království","en-in":"Angličtina - Indie","en-nz":"Angličtina - Nový Zéland","en-us":"Angličtina - Spojené státy americké","es-es":"Španělština - Španělsko (Modern Sort)","es-mx":"Španělština - Mexiko","fi-fi":"Finština","fr-ca":"Francouzština - Kanada","fr-fr":"Francouzština - Francie","hi-in":"Hindština","it-it":"Italština - Itálie","ja-jp":"Japonština","ko-kr":"Korejština","nb-no":"Norština (Bokmål)","nl-be":"Holandština – Belgie","nl-nl":"Holandština - Nizozemsko","pl-pl":"Polština","pt-br":"Portugalština – Brazílie","ru-ru":"Ruština","sv-se":"Švédština","zh-cn":"Čínština – Čínská lidová republika","zh-hk":"Čínština – Hong Kong SAR","cs-cz":"Čeština","pt-pt":"Portugalština – Portugalsko","tr-tr":"Turečtina","vi-vn":"Vietnamština","th-th":"Thajština","he-il":"Hebrejština","cy-gb":"Velština","uk-ua":"Ukrajinština","el-gr":"Řečtina","hu-hu":"Maďarština","ro-ro":"Rumunština","sk-sk":"Slovenština","zh-tw":"Čínština – Tchaj-wan"},"captionLanguageStrings":{"ar":"Arabština","da":"Dánština","de":"Němčina","en":"Angličtina","es":"Španělština","fi":"Finština","fr-ca":"Francouzština - Kanada","fr":"Francouzština - Francie","hi":"Hindština","it":"Italština","ja":"Japonština","ko":"Korejština","nb":"Norština (Bokmål)","nl":"Nizozemština","pl":"Polština","pt":"Portugalština – Brazílie","ru":"Ruština","sv":"Švédština","zh-Hans":"Čínština (zjednodušená)","zh-Hant":"Čínština (tradiční)","cs":"Čeština","pt-pt":"Portugalština – Portugalsko","tr":"Turečtina","vi":"Vietnamština","th":"Thajština","he":"Hebrejština","cy":"Velština","uk":"Ukrajinština","el":"Řečtina","hu":"Maďarština","ro":"Rumunština","sk":"Slovenština"},"captionsBannerSpinnerText":"Spouští se titulky...","realTimeTextInputBoxDefaultText":"Napište zprávu v reálném čase","realTimeTextInputErrorMessage":"Zpráva nesmí být delší než 2000 znaků","realTimeTextBannerTitle":"RTT","realTimeTextBannerContent":"RTT (psaní v reálném čase) je povolené pro všechny účastníky po celou dobu trvání schůzky.","realTimeTextBannerLinkLabel":"Další informace","realTimeTextModalAriaLabel":"Zapnout modální okno psaní v reálném čase","realTimeTextModalTitle":"Zapnout psaní v reálném čase?","realTimeTextModalText":"Text v reálném čase (RTT) se zapne pro všechny účastníky schůzky.","realTimeTextConfirmButtonLabel":"Zapnout","realTimeTextCancelButtonLabel":"Zrušit","realTimeTextCloseModalButtonAriaLabel":"Zavřít modální okno psaní v reálném čase","captionsOnlyContainerTitle":"Titulky","realTimeTextOnlyContainerTitle":"Text v reálném čase","captionsAndRealTimeTextContainerTitle":"Titulky a text v reálném čase","expandButtonAriaLabel":"Rozbalit","minimizeButtonAriaLabel":"Sbalit","transferPageTransferorText":"Probíhá přenos...","transferPageTransferTargetText":"Připojování...","transferPageUnknownTransferorDisplayName":"Neznámý","transferPageUnknownTransferTargetDisplayName":"Neznámý","transferPageNoticeString":"Přepojujeme vás","participantCouldNotBeReachedTitle":"Cílový účastník není v tuto chvíli k dispozici","participantCouldNotBeReachedMoreDetails":"Obraťte se prosím na účastníka, až bude k dispozici","permissionToReachTargetParticipantNotAllowedTitle":"Oprávnění k dosažení cílového účastníka není povolené","permissionToReachTargetParticipantNotAllowedMoreDetails":"Zkontrolujte prosím, jestli je cílový účastník ve stejném tenantovi.","unableToResolveTenantTitle":"Nepovedlo se přeložit ID tenanta pro cílového účastníka","unableToResolveTenantMoreDetails":"Zkontrolujte prosím, jestli je správně zadané ID účastníka.","participantIdIsMalformedTitle":"ID účastníka nemá správný formát.","participantIdIsMalformedMoreDetails":"Zkontrolujte prosím, jestli je ID účastníka ve správném formátu.","moreButtonGalleryControlLabel":"Zobrazit","moreButtonGalleryPositionToggleLabel":"Přesunout galerii na začátek","moreButtonGallerySpeakerLayoutLabel":"Reproduktor","moreButtonGalleryFloatingLocalLayoutLabel":"Dynamické","moreButtonGalleryDefaultLayoutLabel":"Zobrazení galerie","moreButtonGalleryFocusedContentLayoutLabel":"Přenést hlavní pozornost na obsah","moreButtonLargeGalleryDefaultLayoutLabel":"Velká galerie","moreButtonTogetherModeLayoutLabel":"Režim Společně","capabilityChangedNotification":{"turnVideoOn":{"lostDueToMeetingOption":"Vaše kamera byla zakázána. Už nemůžete sdílet video.","grantedDueToMeetingOption":"Vaše kamera je povolená. Pokud chcete sdílet video, zapněte ji."},"unmuteMic":{"lostDueToMeetingOption":"Váš mikrofon byl zakázán. Už nemůžete zrušit ztlumení.","grantedDueToMeetingOption":"Váš mikrofon je povolený. Zrušte ztlumení, pokud chcete mluvit."},"shareScreen":{"lostDueToRoleChangeToAttendee":"Vaše role se změnila. Některé akce, jako je sdílení obsahu, pro vás nebudou k dispozici.","grantedDueToRoleChangeToPresenter":"Jste prezentující. Můžete sdílet obsah a moderovat schůzku."},"hideAttendeeNames":{"hideAttendeeNameAttendee":"Vaše jméno je před ostatními účastníky skryté. Organizátoři a přednášející uvidí vaše skutečné jméno.","hideAttendeeNamePresenter":"Jména účastníků jsou skrytá. Pro ochranu soukromí účastníků uvidí jména jenom organizátoři a přednášející."}},"surveyTitle":"Pomozte nám se zlepšovat","starSurveyHelperText":"Jaká byla kvalita hovoru?","starSurveyOneStarText":"Kvalita byla špatná.","starSurveyTwoStarText":"Kvalita byla slabá.","starSurveyThreeStarText":"Kvalita byla dobrá.","starSurveyFourStarText":"Kvalita byla skvělá.","starSurveyFiveStarText":"Kvalita byla vynikající.","surveyConfirmButtonLabel":"Poslat zpětnou vazbu","starRatingAriaLabel":"Vybrat {0} z(e) {1} hvězdiček","surveySkipButtonLabel":"Přeskočit","tagsSurveyQuestion":"Co by mohlo být lepší?","tagsSurveyTextFieldDefaultText":"Jiné, upřesněte prosím","tagsSurveyHelperText":"Zkontrolujte všechny problémy, se které jste zaznamenali.","endOfSurveyText":"Děkujeme za váš názor!","surveyIssues":{"overallRating":{"callCannotJoin":"Nepovedlo se mi připojit se k hovoru","callCannotInvite":"Nepovedlo se mi pozvat ostatní do hovoru.","hadToRejoin":"Musel(a) jsem se znovu připojit k hovoru","callEndedUnexpectedly":"Hovor pro mě neočekávaně skončil","otherIssues":"Měl(a) jsem s hovorem jiné problémy"},"audioRating":{"noLocalAudio":"Druhá strana neslyšela žádný zvuk","noRemoteAudio":"Vůbec jsem neslyšel(a) zvuk","echo":"Při hovoru jsem slyšel(a) ozvěny","audioNoise":"Při hovoru jsem slyšel(a) šum","lowVolume":"Hlasitost byla nízká","audioStoppedUnexpectedly":"Zvuk se neočekávaně zastavil","distortedSpeech":"Zvuk byl zkreslený","audioInterruption":"Došlo k přerušení zvuku","otherIssues":"Během tohoto hovoru došlo k jiným problémům se zvukem"},"videoRating":{"noVideoReceived":"Vůbec se mi nezobrazovalo video","noVideoSent":"Ostatní mě neviděli","lowQuality":"Kvalita videa byla nízká.","freezes":"Video se zablokuje","stoppedUnexpectedly":"Video se neočekávaně zastavilo","darkVideoReceived":"Když ostatní zapnou kameru, vidím jenom tmavé obrazovky","audioVideoOutOfSync":"Zvuk a video se nesynchronizovaly","otherIssues":"V tomto hovoru došlo k jiným problémům s videem"},"screenshareRating":{"noContentLocal":"Ostatní uživatelé neviděli moje sdílení obrazovky","noContentRemote":"Nepovedlo se mi zobrazit sdílení obrazovky jiných lidí","cannotPresent":"Nepovedlo se mi ukázat obrazovku","lowQuality":"Kvalita sdílení obrazovky byla nízká","freezes":"Zablokované sdílení obrazovky","stoppedUnexpectedly":"Sdílení obrazovky se neočekávaně zastavilo","largeDelay":"Sdílení obrazovky má velké zpoždění","otherIssues":"Měl(a) jsem jiné problémy se sdílením obrazovky v tomto hovoru"}},"surveyIssuesHeadingStrings":{"overallRating":"Celkem","audioRating":"Zvuk","videoRating":"Video","screenshareRating":"Prezentování"},"spotlightPrompt":{"startSpotlightHeading":"Přidat do hlavního výběru všem?","startSpotlightText":"Toto video se zvýrazní všem účastníkům schůzky.","startSpotlightOnSelfText":"Vaše video se zvýrazní všem účastníkům schůzky.","startSpotlightConfirmButtonLabel":"Přidat do hlavního výběru všem","startSpotlightCancelButtonLabel":"Zrušit","stopSpotlightHeading":"Chcete přestat zobrazovat toto video v hlavním výběru?","stopSpotlightOnSelfHeading":"Ukončit hlavní výběr?","stopAllSpotlightHeading":"Zastavit zobrazování všech videí v hlavním výběru?","stopSpotlightText":"Účastníkům se už toto video nebude zvýrazňovat.","stopSpotlightOnSelfText":"Účastníkům se už vaše video nebude zvýrazňovat.","stopAllSpotlightText":"Účastníkům schůzky se už videa nebudou zvýrazňovat.","stopSpotlightConfirmButtonLabel":"Zastavit přidávání do hlavního výběru","stopSpotlightOnSelfConfirmButtonLabel":"Ukončit hlavní výběr","stopSpotlightCancelButtonLabel":"Zrušit","closeSpotlightPromptButtonLabel":"Zavřít"},"exitSpotlightButtonLabel":"Ukončit hlavní výběr","exitSpotlightButtonTooltip":"Ukončit hlavní výběr","leaveConfirmButtonLabel":"Odejít","endCallConfirmButtonLabel":"Ukončit hovor","hangUpCancelButtonLabel":"Zrušit","leaveConfirmDialogTitle":"Chcete z hovoru odejít?","leaveConfirmDialogContent":"Opravdu chcete hovor opustit?","endCallConfirmDialogTitle":"Chcete hovor ukončit?","endCallConfirmDialogContent":"Hovor ukončíte pro všechny.","invalidMeetingIdentifier":"Neplatné ID schůzky nebo heslo","pinParticipantMenuLabel":"Připnout pro mě","pinParticipantLimitReachedMenuLabel":"Připnout (dosáhlo se limitu)","unpinParticipantMenuLabel":"Odepnout","pinParticipantMenuItemAriaLabel":"Připnout pro mě","unpinParticipantMenuItemAriaLabel":"Odepnout","muteAllMenuLabel":"Ztlumit všechny","muteAllDialogTitle":"Chcete všechny ztlumit?","muteAllDialogContent":"Ztlumí všechny účastníky schůzky kromě vás.","muteAllConfirmButtonLabel":"Ztlumit všechny","muteAllCancelButtonLabel":"Zrušit","joinBreakoutRoomButtonLabel":"Připojí se ke skupinové místnosti.","returnFromBreakoutRoomButtonLabel":"Opustit místnost","leaveBreakoutRoomAndMeetingButtonLabel":"Opustit schůzku","breakoutRoomJoinedNotificationTitle":"Připojili jste se ke skupinové místnosti {roomName}","joinBreakoutRoomBannerTitle":"Skupinová místnost {roomName} je otevřená","joinBreakoutRoomBannerButtonLabel":"Připojit se","returnFromBreakoutRoomBannerTitle":"Vrátit se k hlavní schůzce","returnFromBreakoutRoomBannerButtonLabel":"Znovu připojit","forbidAudioMenuLabel":"Vypnout mikrofon","permitAudioMenuLabel":"Povolit mikrofon","forbidOthersAudioDialogTitle":"Zakázat účastníkům mikrofon?","forbidOthersAudioDialogContent":"Účastníci nebudou moct zrušit ztlumení. Organizátor a prezentující můžou lidem podle potřeby povolit zrušit ztlumení.","forbidOthersAudioConfirmButtonLabel":"Zakázat mikrofony","forbidOthersAudioCancelButtonLabel":"Zrušit","permitOthersAudioDialogTitle":"Povolit účastníkům mikrofon?","permitOthersAudioDialogContent":"Všichni účastníci schůzky si budou moct zrušit ztlumení.","permitOthersAudioConfirmButtonLabel":"Povolit mikrofony","permitOthersAudioCancelButtonLabel":"Zrušit","forbidOthersAudioMenuLabel":"Zakázat účastníkům mikrofon","permitOthersAudioMenuLabel":"Povolit mikrofon pro účastníky","forbidVideoMenuLabel":"Zakázat kameru","permitVideoMenuLabel":"Povolit kameru","forbidOthersVideoDialogTitle":"Zakázat účastníkům kameru?","forbidOthersVideoDialogContent":"Účastníci nebudou moct zapnout video sami. Organizátor a přednášející mohou lidem umožnit zapnout kameru podle potřeby.","forbidOthersVideoConfirmButtonLabel":"Zakázat kamery","forbidOthersVideoCancelButtonLabel":"Zrušit","permitOthersVideoDialogTitle":"Povolit účastníkům kameru?","permitOthersVideoDialogContent":"Všichni účastníci schůzky budou moct video zapnout sami.","permitOthersVideoConfirmButtonLabel":"Povolit kamery","permitOthersVideoCancelButtonLabel":"Zrušit","forbidOthersVideoMenuLabel":"Zakázat účastníkům kameru","permitOthersVideoMenuLabel":"Povolit kameru pro účastníky"}'),chat:{chatListHeader:"V tomto chatu",uploadAttachment:"Odeslat přílohu",uploadImageDataNotProvided:"Data obrázku nebyla zadána.",uploadImageIsTooLarge:"Obrázek je příliš velký. Zvolte míň než {maxImageSize} MB.",uploadImageExtensionIsNotAllowed:"Nahrávání. Obrázek {imageExtension} není povolený.",uploadImageFailed:"Obrázek nejde nahrát. Zkuste to prosím znovu později."},callWithChat:{chatButtonLabel:"Chat",chatButtonNewMessageNotificationLabel:"Nová zpráva",chatButtonTooltipClosedWithMessageCount:"Zobrazit chat (počet nepřečtených zpráv: {unreadMessagesCount})",chatButtonTooltipClose:"Skrýt chat",chatButtonTooltipOpen:"Zobrazit chat",chatPaneTitle:"Chat",copyInviteLinkButtonLabel:"Kopírovat odkaz pro pozvání",copyInviteLinkButtonActionedLabel:"Odkaz byl zkopírován.",copyInviteLinkActionedAriaLabel:"Odkaz pozvánky se zkopíroval",dismissSidePaneButtonLabel:"Zavřít",moreDrawerAudioDeviceMenuTitle:"Zvukové zařízení",moreDrawerButtonLabel:"Další možnosti",moreDrawerButtonTooltip:"Další možnosti",moreDrawerMicrophoneMenuTitle:"Mikrofon",moreDrawerSpeakerMenuTitle:"Mluvčí",moreDrawerCaptionsMenuTitle:"Živé titulky",moreDrawerSpokenLanguageMenuTitle:"Mluvený jazyk",moreDrawerCaptionLanguageMenuTitle:"Jazyk titulků",moreDrawerGalleryOptionsMenuTitle:"Možnosti galerie",peopleButtonLabel:"Lidé",selectedPeopleButtonLabel:"Vybráno tlačítko Lidé",peopleButtonTooltipOpen:"Zobrazit účastníky",peopleButtonTooltipClose:"Skrýt účastníky",peopleButtonTooltipOpenAriaLabel:"Tlačítko Lidé, Zobrazit účastníky",peopleButtonTooltipCloseAriaLabel:"Tlačítko Lidé, Skrýt účastníky",peoplePaneSubTitle:"V tomto hovoru",peoplePaneTitle:"Lidé",pictureInPictureTileAriaLabel:"Informační kanály videa. Kliknutím se vrátíte na obrazovku hovoru.",removeMenuLabel:"Odebrat",openDialpadButtonLabel:"Vytočit telefonní číslo",returnToCallButtonAriaDescription:"Pokračovat v hovoru",returnToCallButtonAriaLabel:"Zpět",peoplePaneAddPeopleButtonLabel:"Přidat lidi",dialpadStartCallButtonLabel:"Volat",dialpadModalTitle:"Vytočit telefonní číslo",dialpadModalAriaLabel:"Číselník",dialpadCloseModalButtonAriaLabel:"Zavřít číselník",openDtmfDialpadLabel:"Zobrazit číselník",dtmfDialpadPlaceholderText:"Zadejte číslo",breakoutRoomChatPaneTitle:"Chat ve skupinové místnosti",chatContentSpinnerLabel:"Načítá se chat"}})},pli={component:sQt,strings:Yh({call:JSON.parse(`{"cameraLabel":"Camera","noCamerasLabel":"Heb ganfod camerâu","cameraPermissionDenied":"Mae eich porwr yn rhwystro mynediad at eich camera","cameraTurnedOff":"Mae eich camera wedi'i ddiffodd","chatButtonLabel":"Sgwrs","close":"Cau","complianceBannerNowOnlyRecording":"Rydych chi ond yn recordio'r cyfarfod hwn bellach.","complianceBannerNowOnlyTranscription":"Rydych yn awr yn trawsgrifio'r cyfarfod hwn yn unig.","complianceBannerRecordingAndTranscriptionSaved":"Mae recordiad a thrawsgrifiad yn cael eu cadw.","complianceBannerRecordingAndTranscriptionStarted":"Wedi dechrau recordio a thrawsgrifio.","complianceBannerRecordingAndTranscriptionStopped":"Wedi stopio recordio a thrawsgrifio.","complianceBannerRecordingSaving":"Mae’r recordiad yn cael ei gadw.","complianceBannerRecordingStarted":"Recordio wedi dechrau.","complianceBannerRecordingStopped":"Recordio wedi stopio.","complianceBannerTranscriptionStarted":"Wedi dechrau’r trawsgrifiad.","complianceBannerTranscriptionConsent":"Drwy ymuno, rydych yn cydsynio i drawsgrifio'r cyfarfod hwn.","complianceBannerTranscriptionSaving":"Mae trawsgrifiad yn cael ei gadw.","complianceBannerTranscriptionStopped":"Wedi stopio’r trawsgrifiad.","configurationPageTitle":"Dechrau galwad","copyInviteLinkButtonLabel":"Copïo dolen y gwahoddiad","copyInviteLinkButtonActionedLabel":"Wedi copïo'r ddolen","copyInviteLinkActionedAriaLabel":"Wedi copïo dolen y gwahoddiad","defaultPlaceHolder":"Dewiswch opsiwn","dismissSidePaneButtonLabel":"Cau","videoEffectsPaneTitle":"Effeithiau","videoEffectsPaneBackgroundSelectionTitle":"Cefndir","videoEffectsPaneAriaLabel":"Cwarel effeithiau fideo","configurationPageCameraIsLoadingLabel":"Mae’r fideo’n llwytho...","configurationPageVideoEffectsButtonLabel":"Effeithiau","unableToStartVideoEffect":"Does dim modd defnyddio'r effaith fideo.","blurBackgroundEffectButtonLabel":"Pylu","blurBackgroundTooltip":"Niwlio'r Cefndir","removeBackgroundEffectButtonLabel":"Dim","removeBackgroundTooltip":"Tynnu'r Cefndir","cameraOffBackgroundEffectWarningText":"Mae eich camera wedi'i ddiffodd. Rhowch y camera ar waith i weld yr effaith fideo.","failedToJoinCallDueToNoNetworkMoreDetails":"Cafodd yr alwad ei datgysylltu oherwydd problem rhwydwaith. Tarwch olwg ar eich cysylltiad ac ymuno eto.","failedToJoinCallDueToNoNetworkTitle":"Galwad wedi'i datgysylltu","failedToJoinTeamsMeetingReasonAccessDeniedMoreDetails":"Doeddech chi ddim wedi cael mynediad yn yr alwad. Os mai camgymeriad oedd hyn, ailymunwch â'r alwad.","failedToJoinTeamsMeetingReasonAccessDeniedTitle":"Wedi'i anfon ymaith o'r ystafell aros","learnMore":"Dysgu mwy","leavingCallTitle":"Wrthi'n gadael...","leftCallMoreDetails":"Os mai camgymeriad oedd hyn, ailymunwch â'r alwad.","leftCallTitle":"Fe adawoch chi'r alwad","lobbyScreenConnectingToCallTitle":"Ymuno â galwad","lobbyScreenWaitingToBeAdmittedTitle":"Wrthi’n aros am dderbyniad","microphonePermissionDenied":"Mae eich porwr yn rhwystro mynediad at eich meicroffon","microphoneToggleInLobbyNotAllowed":"Does dim modd tewi na dad-dewi tra yn yr ystafell aros.","mutedMessage":"Rydych chi wedi'ch tewi","networkReconnectMoreDetails":"Mae'n debyg bod rhywbeth wedi mynd o'i le. Rydyn ni'n ceisio mynd yn ôl i mewn i'r alwad.","networkReconnectTitle":"Daliwch arni","notInvitedToRoomDetails":"Does dim modd i chi ymuno â'r ystafell hon oherwydd does gennych chi ddim gwahoddiad.","notInvitedToRoomTitle":"Heb wahoddiad i'r ystafell","peopleButtonLabel":"Pobl","selectedPeopleButtonLabel":"Wedi Dewis y Botwm Pobl","peoplePaneTitle":"Pobl","peoplePaneMoreButtonAriaLabel":"Mwy","peopleButtonTooltipOpen":"Dangos cyfranogwyr","peopleButtonTooltipClose":"Cuddio’r cyfranogwyr","peoplePaneSubTitle":"Yn yr alwad hon {numberOfPeople}","privacyPolicy":"Polisi preifatrwydd","rejoinCallButtonLabel":"Ail-ymuno â'r alwad","removedFromCallMoreDetails":"Mae cyfranogwr arall wedi eich tynnu o'r alwad.","removedFromCallTitle":"Cawsoch eich tynnu","removeMenuLabel":"Tynnu","startSpotlightMenuLabel":"Sbotolau i bawb","addSpotlightMenuLabel":"Ychwanegu sbotolau","stopSpotlightMenuLabel":"Diffodd y sbotolau","stopSpotlightOnSelfMenuLabel":"Gadael y sbotolau","spotlightLimitReachedMenuTitle":"Wedi cyrraedd y terfyn sbotolau","stopAllSpotlightMenuLabel":"Stopio pob sbotolau","returnToCallButtonAriaDescription":"Mynd yn ôl i'r Alwad","returnToCallButtonAriaLabel":"Yn ôl","roomNotFoundDetails":"Doedd dim modd canfod ID yr ystafell a roddwyd.","roomNotFoundTitle":"Heb ganfod yr ystafell","roomNotValidDetails":"Dydy'r ystafell hon ddim yn ddilys ar hyn o bryd.","roomNotValidTitle":"Dydy'r ystafell ddim yn ddilys","inviteToRoomRemovedDetails":"Wedi tynnu eich gwahoddiad i ymuno â'r ystafell hon.","inviteToRoomRemovedTitle":"Wedi tynnu'r gwahoddiad i'r ystafell","soundLabel":"Sain","noMicrophonesLabel":"Heb ganfod meicroffonau","noSpeakersLabel":"Heb ganfod seinyddion","startCallButtonLabel":"Dechrau galwad","openDialpadButtonLabel":"Deialu rhif ffôn","peoplePaneAddPeopleButtonLabel":"Ychwanegu Pobl","dialpadStartCallButtonLabel":"Galwad","dialpadModalTitle":"Deialu Rhif Ffôn","dialpadModalAriaLabel":"Pad deialu","dialpadCloseModalButtonAriaLabel":"Cau'r pad deialu","moreButtonCallingLabel":"Mwy","resumeCallButtonLabel":"Ailgydio","resumingCallButtonLabel":"Wrthi'n ailgydio...","resumeCallButtonAriaLabel":"Ailgydio yn yr alwad","resumingCallButtonAriaLabel":"Ailgydio yn yr alwad","holdScreenLabel":"Mae eich galwad yn aros","openDtmfDialpadLabel":"Dangos y pad deialu","dtmfDialpadPlaceholderText":"Cofnodi rhif","outboundCallingNoticeString":"Wrthi'n galw...","participantJoinedNoticeString":"Mae {displayName} wedi ymuno","twoParticipantJoinedNoticeString":"Mae {displayName1} a {displayName2} wedi ymuno","threeParticipantJoinedNoticeString":"Mae {displayName1}, {displayName2} a {displayName3} wedi ymuno","participantLeftNoticeString":"Mae {displayName} wedi gadael","twoParticipantLeftNoticeString":"Mae {displayName1} a {displayName2} wedi gadael","threeParticipantLeftNoticeString":"Mae {displayName1}, {displayName2} a {displayName3} wedi gadael","unnamedParticipantString":"cyfranogwr dienw","manyUnnamedParticipantsJoined":"Mae cyfranogwr dienw a {numOfParticipants} o gyfranogwyr eraill wedi ymuno","manyUnnamedParticipantsLeft":"Mae cyfranogwr dienw a {numOfParticipants} o gyfranogwyr eraill wedi gadael","manyParticipantsJoined":"{displayName1}, {displayName2}, {displayName3} a {numOfParticipants} cyfranogwyr eraill wedi ymuno","manyParticipantsLeft":"{displayName1}, {displayName2}, {displayName3} a {numOfParticipants} cyfranogwyr eraill ar ôl","liveCaptionsLabel":"Capsiynau byw","captionsSettingsLabel":"Gosodiadau capsiynau","startCaptionsButtonOnLabel":"Rhoi capsiynau ar waith","startCaptionsButtonOffLabel":"Diffodd capsiynau","startCaptionsButtonTooltipOnContent":"Diffodd capsiynau","startCaptionsButtonTooltipOffContent":"Rhoi capsiynau ar waith","captionsSettingsModalTitle":"Gosodiadau Capsiynau","captionsSettingsSpokenLanguageDropdownLabel":"Iaith lafar","captionsSettingsCaptionLanguageDropdownLabel":"Iaith capsiynau","captionsSettingsSpokenLanguageDropdownInfoText":"Yr iaith y mae pawb yn yr alwad hon yn ei siarad.","captionsSettingsCaptionLanguageDropdownInfoText":"Bydd capsiynau’n ymddangos yn yr iaith hon.","captionsSettingsConfirmButtonLabel":"Cadarnhau","captionsSettingsCancelButtonLabel":"Canslo","captionsSettingsModalAriaLabel":"Moddol Gosodiad Capsiynau","captionsSettingsCloseModalButtonAriaLabel":"Cau Gosodiad Capsiynau","captionsBannerMoreButtonCallingLabel":"Mwy o Ddewisiadau Gosodiadau Capsiynau","captionsBannerMoreButtonTooltip":"Mwy o ddewisiadau","realTimeTextLabel":"Testun amser go iawn (RTT)","startRealTimeTextLabel":"Rhoi RTT ar waith ar gyfer yr alwad hon","disabledStartRealTimeTextLabel":"Mae RTT ar waith ar hyn o bryd, nid oes modd ei ddiffodd","dismissModalAriaLabel":"Llun a llun lleol a phell, pwyswch Enter i fynd yn ôl i'r alwad","callRejectedTitle":"Doedd dim modd cwblhau'r alwad","callRejectedMoreDetails":"Dydy'r unigolyn rydych chi'n ceisio cysylltu â nhw ddim ar gael. Rhowch gynnig arall arni rywbryd eto.","callTimeoutTitle":"Doedd dim modd cwblhau'r alwad","callTimeoutDetails":"Dydy'r unigolyn rydych chi'n ceisio cysylltu â nhw ddim ar gael. Rhowch gynnig arall arni rywbryd eto.","callTimeoutBotTitle":"Doedd dim modd cwblhau'r alwad","callTimeoutBotDetails":"Dydy'r gwasanaeth rydych chi'n ceisio cysylltu ag ef ddim ar gael. Rhowch gynnig arall arni rywbryd eto.","dtmfDialerButtonLabel":"Pad deialu","dtmfDialerButtonTooltipOn":"Dangos y pad deialu","dtmfDialerButtonTooltipOff":"Cuddio'r pad deialu","dtmfDialerMoreButtonLabelOn":"Dangos y pad deialu","dtmfDialerMoreButtonLabelOff":"Cuddio'r pad deialu","phoneCallMoreButtonLabel":"Galwad Ffôn","spokenLanguageStrings":{"ar-ae":"Arabeg - E.A.U.","ar-sa":"Arabeg - Saudi Arabia","da-dk":"Daneg","de-de":"Almaeneg - Yr Almaen","en-au":"Saesneg - Awstralia","en-ca":"Saesneg - Canada","en-gb":"Saesneg - Y Deyrnas Unedig","en-in":"Saesneg - India","en-nz":"Saesneg - Seland Newydd","en-us":"Saesneg - Unol Daleithiau America","es-es":"Sbaeneg - Sbaen (Modern)","es-mx":"Sbaeneg - Mecsico","fi-fi":"Ffinneg","fr-ca":"Ffrangeg - Canada","fr-fr":"Ffrangeg - Ffrainc","hi-in":"Hindi","it-it":"Eidaleg - Yr Eidal","ja-jp":"Japaneeg","ko-kr":"Coreeg","nb-no":"Norwyeg (Bokmål)","nl-be":"Iseldireg - Gwlad Belg","nl-nl":"Iseldireg - Yr Iseldiroedd","pl-pl":"Pwyleg","pt-br":"Portiwgaleg - Brasil","ru-ru":"Rwseg","sv-se":"Swedeg","zh-cn":"Tsieinëeg - Gweriniaeth y Bobl Tsieina","zh-hk":"Tsieinëeg - Hong Kong SAR","cs-cz":"Tsieceg","pt-pt":"Portiwgaleg - Portiwgal","tr-tr":"Tyrceg","vi-vn":"Fietnameg","th-th":"Thai","he-il":"Hebraeg","cy-gb":"Cymraeg","uk-ua":"Wcreineg","el-gr":"Groeg","hu-hu":"Hwngareg","ro-ro":"Rwmaneg","sk-sk":"Slofaceg","zh-tw":"Tsieinëeg - Taiwan"},"captionLanguageStrings":{"ar":"Arabeg","da":"Daneg","de":"Almaeneg","en":"Saesneg","es":"Sbaeneg","fi":"Ffinneg","fr-ca":"Ffrangeg - Canada","fr":"Ffrangeg - Ffrainc","hi":"Hindi","it":"Eidaleg","ja":"Japaneeg","ko":"Coreeg","nb":"Norwyeg (Bokmål)","nl":"Iseldireg","pl":"Pwyleg","pt":"Portiwgaleg - Brasil","ru":"Rwseg","sv":"Swedeg","zh-Hans":"Tsieinëeg (Syml)","zh-Hant":"Tsieinëeg (Traddodiadol)","cs":"Tsieceg","pt-pt":"Portiwgaleg - Portiwgal","tr":"Tyrceg","vi":"Fietnameg","th":"Thai","he":"Hebraeg","cy":"Cymraeg","uk":"Wcreineg","el":"Groeg","hu":"Hwngareg","ro":"Rwmaneg","sk":"Slofaceg"},"captionsBannerSpinnerText":"Wrthi'n dechrau'r capsiynau...","realTimeTextInputBoxDefaultText":"Teipiwch neges mewn amser go iawn","realTimeTextInputErrorMessage":"All y neges ddim bod yn fwy na 2000 o nodau","realTimeTextBannerTitle":"RTT","realTimeTextBannerContent":"Mae RTT (testun amser real) wedi'i alluogi ar gyfer yr holl gyfranogwyr ar gyfer cyfnod cyfan y cyfarfod.","realTimeTextBannerLinkLabel":"Dysgu mwy","realTimeTextModalAriaLabel":"Galluogi’r moddol RTT","realTimeTextModalTitle":"Galluogi RTT?","realTimeTextModalText":"Bydd teipio mewn amser real (RTT) yn cael ei alluogi ar gyfer pawb yn y cyfarfod.","realTimeTextConfirmButtonLabel":"Galluogi","realTimeTextCancelButtonLabel":"Canslo","realTimeTextCloseModalButtonAriaLabel":"Cau'r Moddol RTT","captionsOnlyContainerTitle":"Capsiynau","realTimeTextOnlyContainerTitle":"Testun Amser Real","captionsAndRealTimeTextContainerTitle":"Capsiynau a Thestun Amser Real","expandButtonAriaLabel":"Ehangu","minimizeButtonAriaLabel":"Crebachu","transferPageTransferorText":"Wrthi'n trosglwyddo...","transferPageTransferTargetText":"Wrthi'n cysylltu...","transferPageUnknownTransferorDisplayName":"Dim manylion","transferPageUnknownTransferTargetDisplayName":"Dim manylion","transferPageNoticeString":"Rydych chi'n cael eich trosglwyddo","participantCouldNotBeReachedTitle":"Dydy'r cyfranogwr targed ddim ar gael ar hyn o bryd","participantCouldNotBeReachedMoreDetails":"Cysylltwch â'r cyfranogwr pan fydd ar gael","permissionToReachTargetParticipantNotAllowedTitle":"Ni chaniateir caniatâd i gyrraedd y cyfranogwr targed","permissionToReachTargetParticipantNotAllowedMoreDetails":"Gwnewch yn siŵr bod y cyfranogwr targed yn yr un tenant","unableToResolveTenantTitle":"Does dim modd datrys id tenant ar gyfer y cyfranogwr targed","unableToResolveTenantMoreDetails":"Gwnewch yn siŵr bod yr id cyfranogwr wedi'i roi'n gywir","participantIdIsMalformedTitle":"Dydy'r id cyfranogwr ddim yn y fformat cywir","participantIdIsMalformedMoreDetails":"Gwnewch yn siŵr bod id y cyfranogwr yn y fformat cywir","moreButtonGalleryControlLabel":"Gweld","moreButtonGalleryPositionToggleLabel":"Symud yr oriel i'r brig","moreButtonGallerySpeakerLayoutLabel":"Seinydd","moreButtonGalleryFloatingLocalLayoutLabel":"Deinamig","moreButtonGalleryDefaultLayoutLabel":"Gwedd oriel","moreButtonGalleryFocusedContentLayoutLabel":"Canolbwyntio ar y cynnwys","moreButtonLargeGalleryDefaultLayoutLabel":"Oriel Fawr","moreButtonTogetherModeLayoutLabel":"Modd Ynghyd","capabilityChangedNotification":{"turnVideoOn":{"lostDueToMeetingOption":"Mae eich camera wedi'i analluogi. Does dim modd i chi rannu fideo mwyach.","grantedDueToMeetingOption":"Mae eich camera wedi'i alluogi. Rhowch eich camera ar waith os hoffech chi rannu fideo."},"unmuteMic":{"lostDueToMeetingOption":"Mae eich meic wedi'i analluogi. Does dim modd i chi ddad-dewi mwyach.","grantedDueToMeetingOption":"Mae eich meic wedi cael ei alluogi. Dad-dewi’r meic os hoffech chi siarad."},"shareScreen":{"lostDueToRoleChangeToAttendee":"Mae eich rôl wedi cael ei newid. Fydd rhai gweithredoedd, fel rhannu cynnwys, ddim ar gael i chi.","grantedDueToRoleChangeToPresenter":"Rydych chi'n gyflwynydd. Gallwch rannu cynnwys a hwyluso'r cyfarfod."},"hideAttendeeNames":{"hideAttendeeNameAttendee":"Mae eich enw wedi'i guddio rhag mynychwyr eraill. Gall trefnwyr a chyflwynwyr weld eich enw go iawn.","hideAttendeeNamePresenter":"Mae enwau mynychwyr wedi'u cuddio. Dim ond trefnwyr a chyflwynwyr sy'n gallu gweld enwau i warchod preifatrwydd y mynychwr."}},"surveyTitle":"Helpwch ni i wella","starSurveyHelperText":"Sut oedd ansawdd yr alwad?","starSurveyOneStarText":"Roedd yr ansawdd yn wael.","starSurveyTwoStarText":"Roedd yr ansawdd yn wael.","starSurveyThreeStarText":"Roedd yr ansawdd yn dda.","starSurveyFourStarText":"Roedd yr ansawdd yn wych.","starSurveyFiveStarText":"Roedd yr ansawdd yn ardderchog.","surveyConfirmButtonLabel":"Anfon Adborth","starRatingAriaLabel":"Dewis {0} o {1} seren","surveySkipButtonLabel":"Hepgor","tagsSurveyQuestion":"Beth allai fod yn well?","tagsSurveyTextFieldDefaultText":"Arall, nodwch os gwelwch yn dda","tagsSurveyHelperText":"Gwiriwch unrhyw broblemau a gawsoch chi","endOfSurveyText":"Diolch am eich adborth!","surveyIssues":{"overallRating":{"callCannotJoin":"Doeddwn i ddim yn gallu ymuno â'r alwad","callCannotInvite":"Doeddwn i ddim yn gallu gwahodd eraill i'r alwad","hadToRejoin":"Roedd yn rhaid i fi ailymuno â'r alwad","callEndedUnexpectedly":"Daeth yr alwad i ben ar fy nghyfer i yn annisgwyl","otherIssues":"Roeddwn i'n cael problemau eraill gyda'r alwad"},"audioRating":{"noLocalAudio":"Doedd yr ochr arall ddim yn gallu clywed dim byd","noRemoteAudio":"Doeddwn i ddim yn gallu clywed dim byd","echo":"Roeddwn i'n clywed adlais ar yr alwad","audioNoise":"Roeddwn i'n clywed synau ar yr alwad","lowVolume":"Roedd lefel y sain yn isel","audioStoppedUnexpectedly":"Daeth y sain i ben yn annisgwyl","distortedSpeech":"Roedd y sain wedi'i haflunio","audioInterruption":"Torrwyd ar draws y sain","otherIssues":"Roeddwn i'n cael problemau sain eraill yn yr alwad hon"},"videoRating":{"noVideoReceived":"Doeddwn i ddim yn gallu gweld unrhyw fideo","noVideoSent":"Doedd pobl eraill ddim yn gallu fy ngweld i","lowQuality":"Roedd ansawdd y fideo yn isel","freezes":"Mae'r fideo wedi rhewi","stoppedUnexpectedly":"Daeth y fideo i ben yn annisgwyl","darkVideoReceived":"Rydw i'n gweld dim ond sgriniau tywyll pan fo pobl eraill yn rhoi eu camerâu ar waith","audioVideoOutOfSync":"Doedd y Sain a'r Fideo ddim wedi'u cysoni","otherIssues":"Roeddwn i'n cael problemau fideo eraill yn yr alwad hon"},"screenshareRating":{"noContentLocal":"Doedd pobl eraill ddim yn gallu gweld fy rhannu sgrin","noContentRemote":"Doeddwn i ddim yn gallu gweld rhannu sgrin pobl eraill","cannotPresent":"Doedd dim modd i fi gyflwyno fy sgrin","lowQuality":"Roedd ansawdd rhannu sgrin yn isel","freezes":"Mae rhannu sgrin wedi rhewi","stoppedUnexpectedly":"Stopiodd rhannu sgrin yn annisgwyl","largeDelay":"Mae cryn dipyn o ran rhannu sgrin","otherIssues":"Roeddwn i'n cael problemau rhannu sgrin eraill yn yr alwad hon"}},"surveyIssuesHeadingStrings":{"overallRating":"Cyffredinol","audioRating":"Sain","videoRating":"Fideo","screenshareRating":"Cyflwyno"},"spotlightPrompt":{"startSpotlightHeading":"Sbotolau i bawb?","startSpotlightText":"Byddwch chi’n amlygu'r fideo hwn ar gyfer pawb yn y cyfarfod.","startSpotlightOnSelfText":"Byddwch chi’n amlygu eich fideo ar gyfer pawb yn y cyfarfod.","startSpotlightConfirmButtonLabel":"Sbotolau i bawb","startSpotlightCancelButtonLabel":"Canslo","stopSpotlightHeading":"Stopio rhoi sbotolau ar y fideo hwn?","stopSpotlightOnSelfHeading":"Gadael y sbotolau?","stopAllSpotlightHeading":"Stopio rhoi sbotolau ar yr holl fideos?","stopSpotlightText":"Ni fydd y fideo hwn yn cael ei amlygu ar gyfer pawb yn y cyfarfod mwyach.","stopSpotlightOnSelfText":"Fydd eich fideo ddim yn cael ei amlygu ar gyfer pawb yn y cyfarfod mwyach.","stopAllSpotlightText":"Ni fydd y fideos bellach yn cael eu hamlygu i bawb yn y cyfarfod.","stopSpotlightConfirmButtonLabel":"Diffodd y sbotolau","stopSpotlightOnSelfConfirmButtonLabel":"Gadael y sbotolau","stopSpotlightCancelButtonLabel":"Canslo","closeSpotlightPromptButtonLabel":"Cau"},"exitSpotlightButtonLabel":"Gadael y sbotolau","exitSpotlightButtonTooltip":"Gadael y sbotolau","leaveConfirmButtonLabel":"Gadael","endCallConfirmButtonLabel":"Gorffen yr alwad","hangUpCancelButtonLabel":"Canslo","leaveConfirmDialogTitle":"Gadael yr alwad?","leaveConfirmDialogContent":"Ydych chi'n siŵr eich bod am adael yr alwad?","endCallConfirmDialogTitle":"Dod â'r alwad i ben?","endCallConfirmDialogContent":"Byddwch chi'n dod â'r alwad i ben ar gyfer pawb.","invalidMeetingIdentifier":"ID neu god cyfrin cyfarfod annilys","pinParticipantMenuLabel":"Pinio ar fy nghyfer i","pinParticipantLimitReachedMenuLabel":"Pinio (wedi cyrraedd y terfyn)","unpinParticipantMenuLabel":"Dadbinio","pinParticipantMenuItemAriaLabel":"Pinio ar fy nghyfer i","unpinParticipantMenuItemAriaLabel":"Dadbinio","muteAllMenuLabel":"Tewi pawb","muteAllDialogTitle":"Tewi pawb?","muteAllDialogContent":"Bydd hyn yn tewi pawb yn y cyfarfod ond chi.","muteAllConfirmButtonLabel":"Tewi pawb","muteAllCancelButtonLabel":"Canslo","joinBreakoutRoomButtonLabel":"Ymuno â'r cyfarfod ymylol","returnFromBreakoutRoomButtonLabel":"Gadael yr ystafell","leaveBreakoutRoomAndMeetingButtonLabel":"Gadael y cyfarfod","breakoutRoomJoinedNotificationTitle":"Rydych chi wedi ymuno â'r Cyfarfod Ymylol '{roomName}'","joinBreakoutRoomBannerTitle":"Mae'r cyfarfod ymylol '{roomName}' ar agor","joinBreakoutRoomBannerButtonLabel":"Ymuno","returnFromBreakoutRoomBannerTitle":"Mynd yn ôl i'r prif gyfarfod","returnFromBreakoutRoomBannerButtonLabel":"Ailymuno","forbidAudioMenuLabel":"Analluogi meic","permitAudioMenuLabel":"Caniatáu meic","forbidOthersAudioDialogTitle":"Analluogi meic ar gyfer mynychwyr?","forbidOthersAudioDialogContent":"Fydd dim modd i fynychwyr ddad-dewi eu hunain. Gall y trefnydd a'r cyflwynwyr ganiatáu i bobl ddad-dewi yn ôl yr angen.","forbidOthersAudioConfirmButtonLabel":"Analluogi meicroffonau","forbidOthersAudioCancelButtonLabel":"Canslo","permitOthersAudioDialogTitle":"Caniatáu meic ar gyfer mynychwyr?","permitOthersAudioDialogContent":"Bydd pawb yn y cyfarfod yn gallu dad-dewi eu hunain.","permitOthersAudioConfirmButtonLabel":"Caniatáu meicroffonau","permitOthersAudioCancelButtonLabel":"Canslo","forbidOthersAudioMenuLabel":"Analluogi meic ar gyfer mynychwyr","permitOthersAudioMenuLabel":"Caniatáu meic ar gyfer mynychwyr","forbidVideoMenuLabel":"Analluogi camera","permitVideoMenuLabel":"Caniatáu camera","forbidOthersVideoDialogTitle":"Analluogi camera ar gyfer mynychwyr?","forbidOthersVideoDialogContent":"Fydd dim modd i fynychwyr alluogi fideo eu hunain. Gall y trefnydd a'r cyflwynwyr ganiatáu i bobl alluogi camera yn ôl yr angen.","forbidOthersVideoConfirmButtonLabel":"Analluogi camerâu","forbidOthersVideoCancelButtonLabel":"Canslo","permitOthersVideoDialogTitle":"Caniatáu camera ar gyfer mynychwyr?","permitOthersVideoDialogContent":"Bydd pawb yn y cyfarfod yn gallu rhoi'r fideo eu hunain ar waith.","permitOthersVideoConfirmButtonLabel":"Caniatáu camerâu","permitOthersVideoCancelButtonLabel":"Canslo","forbidOthersVideoMenuLabel":"Analluogi camera ar gyfer mynychwyr","permitOthersVideoMenuLabel":"Caniatáu camera ar gyfer mynychwyr"}`),chat:{chatListHeader:"Yn y sgwrs hon",uploadAttachment:"Llwytho Atodiad i Fyny",uploadImageDataNotProvided:"Dydy data'r ddelwedd ddim wedi'i ddarparu.",uploadImageIsTooLarge:"Mae'r ddelwedd yn rhy fawr. Dewiswch un sy'n llai na {maxImageSize} MB.",uploadImageExtensionIsNotAllowed:"Ni chaniateir llwytho'r ddelwedd .{imageExtension} i fyny.",uploadImageFailed:"Does dim modd llwytho'r ddelwedd i fyny. Rhowch gynnig arall arni rywbryd eto."},callWithChat:{chatButtonLabel:"Sgwrs",chatButtonNewMessageNotificationLabel:"Neges Newydd",chatButtonTooltipClosedWithMessageCount:"Dangos sgwrs ({unreadMessagesCount} heb ei darllen)",chatButtonTooltipClose:"Cuddio'r sgwrs",chatButtonTooltipOpen:"Dangos y sgwrs",chatPaneTitle:"Sgwrs",copyInviteLinkButtonLabel:"Copïo dolen y gwahoddiad",copyInviteLinkButtonActionedLabel:"Wedi copïo'r ddolen",copyInviteLinkActionedAriaLabel:"Wedi copïo dolen y gwahoddiad",dismissSidePaneButtonLabel:"Cau",moreDrawerAudioDeviceMenuTitle:"Dyfais Sain",moreDrawerButtonLabel:"Mwy o ddewisiadau",moreDrawerButtonTooltip:"Mwy o ddewisiadau",moreDrawerMicrophoneMenuTitle:"Meicroffon",moreDrawerSpeakerMenuTitle:"Siaradwr",moreDrawerCaptionsMenuTitle:"Capsiynau byw",moreDrawerSpokenLanguageMenuTitle:"Iaith lafar",moreDrawerCaptionLanguageMenuTitle:"Iaith capsiwn",moreDrawerGalleryOptionsMenuTitle:"Dewisiadau oriel",peopleButtonLabel:"Pobl",selectedPeopleButtonLabel:"Wedi Dewis y Botwm Pobl",peopleButtonTooltipOpen:"Dangos y cyfranogwyr",peopleButtonTooltipClose:"Cuddio’r cyfranogwyr",peopleButtonTooltipOpenAriaLabel:"Botwm Pobl, Dangos cyfranogwyr",peopleButtonTooltipCloseAriaLabel:"Botwm Pobl, Cuddio cyfranogwyr",peoplePaneSubTitle:"Yn yr alwad hon",peoplePaneTitle:"Pobl",pictureInPictureTileAriaLabel:"Crynodebau Fideo. Cliciwch i fynd yn ôl i sgrin yr alwad.",removeMenuLabel:"Tynnu",openDialpadButtonLabel:"Deialu rhif ffôn",returnToCallButtonAriaDescription:"Mynd yn ôl i'r Alwad",returnToCallButtonAriaLabel:"Yn ôl",peoplePaneAddPeopleButtonLabel:"Ychwanegu Pobl",dialpadStartCallButtonLabel:"Galwad",dialpadModalTitle:"Deialu Rhif Ffôn",dialpadModalAriaLabel:"Pad deialu",dialpadCloseModalButtonAriaLabel:"Cau'r pad deialu",openDtmfDialpadLabel:"Dangos y pad deialu",dtmfDialpadPlaceholderText:"Cofnodi rhif",breakoutRoomChatPaneTitle:"Sgwrs y Cyfarfod Ymylol",chatContentSpinnerLabel:"Wrthi'n llwytho'r sgwrs"}})},gli={component:lQt,strings:Yh({call:JSON.parse('{"cameraLabel":"Kamera","noCamerasLabel":"Keine Kameras gefunden","cameraPermissionDenied":"Ihr Browser blockiert den Zugriff auf Ihre Kamera.","cameraTurnedOff":"Ihre Kamera ist deaktiviert.","chatButtonLabel":"Chat","close":"Schließen","complianceBannerNowOnlyRecording":"Sie zeichnen nun nur diese Besprechung auf.","complianceBannerNowOnlyTranscription":"Sie transkribieren diese Besprechung jetzt nur noch.","complianceBannerRecordingAndTranscriptionSaved":"Aufzeichnung und Transkription werden gespeichert.","complianceBannerRecordingAndTranscriptionStarted":"Die Aufzeichnung und Transkription haben begonnen.","complianceBannerRecordingAndTranscriptionStopped":"Die Aufzeichnung und Transkription wurden beendet.","complianceBannerRecordingSaving":"Aufzeichnung wird gespeichert.","complianceBannerRecordingStarted":"Die Aufzeichnung wurde gestartet.","complianceBannerRecordingStopped":"Aufzeichnung wurde beendet.","complianceBannerTranscriptionStarted":"Die Transkription hat begonnen.","complianceBannerTranscriptionConsent":"Durch Ihre Teilnahme stimmen Sie zu, dass diese Besprechung transkribiert wird.","complianceBannerTranscriptionSaving":"Die Transkription wird gespeichert.","complianceBannerTranscriptionStopped":"Die Transkription wurde beendet.","configurationPageTitle":"Einen Anruf beginnen","copyInviteLinkButtonLabel":"Einladungslink kopieren","copyInviteLinkButtonActionedLabel":"Link kopiert","copyInviteLinkActionedAriaLabel":"Gruppeneinladungslink kopiert","defaultPlaceHolder":"Option auswählen","dismissSidePaneButtonLabel":"Schließen","videoEffectsPaneTitle":"Effekte","videoEffectsPaneBackgroundSelectionTitle":"Hintergrund","videoEffectsPaneAriaLabel":"Bereich \\"Videoeffekte\\"","configurationPageCameraIsLoadingLabel":"Video wird geladen...","configurationPageVideoEffectsButtonLabel":"Effekte","unableToStartVideoEffect":"Videoeffekt kann nicht angewendet werden.","blurBackgroundEffectButtonLabel":"Unscharf machen","blurBackgroundTooltip":"Hintergrund unscharf machen","removeBackgroundEffectButtonLabel":"Keine","removeBackgroundTooltip":"Hintergrund entfernen","cameraOffBackgroundEffectWarningText":"Ihre Kamera ist ausgeschaltet. Aktivieren Sie die Kamera, um den Videoeffekt anzuzeigen.","failedToJoinCallDueToNoNetworkMoreDetails":"Der Anruf wurde aufgrund eines Netzwerkproblems getrennt. Überprüfen Sie Ihre Verbindung, und treten Sie erneut bei.","failedToJoinCallDueToNoNetworkTitle":"Anruf unterbrochen","failedToJoinTeamsMeetingReasonAccessDeniedMoreDetails":"Ihnen wurde keine Teilnahme am Anruf gewährt. Wenn dies ein Fehler war, treten Sie dem Anruf erneut bei.","failedToJoinTeamsMeetingReasonAccessDeniedTitle":"Aus Wartebereich entlassen","learnMore":"Weitere Informationen","leavingCallTitle":"Verlässt Besprechung...","leftCallMoreDetails":"Wenn dies ein Fehler war, nehmen Sie erneut am Anruf teil.","leftCallTitle":"Sie haben den Anruf verlassen","lobbyScreenConnectingToCallTitle":"Teilnehmen am Anruf","lobbyScreenWaitingToBeAdmittedTitle":"Warten auf die Zulassung","microphonePermissionDenied":"Ihr Browser blockiert den Zugriff auf Ihr Mikrofon.","microphoneToggleInLobbyNotAllowed":"Stummschalten oder Aufheben der Stummschaltung im Wartebereich nicht zulässig.","mutedMessage":"Sie sind stummgeschaltet.","networkReconnectMoreDetails":"Offensichtlich ist etwas schief gegangen. Wir versuchen, Sie wieder mit dem Anruf zu verbinden.","networkReconnectTitle":"Einen Augenblick bitte","notInvitedToRoomDetails":"Sie können diesem Raum ohne Einladung nicht beitreten.","notInvitedToRoomTitle":"Nicht zum Raum eingeladen","peopleButtonLabel":"Kontakte","selectedPeopleButtonLabel":"Schaltfläche \\"Personen\\" ausgewählt","peoplePaneTitle":"Kontakte","peoplePaneMoreButtonAriaLabel":"Mehr","peopleButtonTooltipOpen":"Teilnehmende anzeigen","peopleButtonTooltipClose":"Teilnehmende ausblenden","peoplePaneSubTitle":"In diesem Anruf {numberOfPeople}","privacyPolicy":"Datenschutzrichtlinie","rejoinCallButtonLabel":"Am Anruf erneut teilnehmen","removedFromCallMoreDetails":"Ein anderer Teilnehmer hat Sie aus dem Anruf entfernt.","removedFromCallTitle":"Sie wurden entfernt","removeMenuLabel":"Entfernen","startSpotlightMenuLabel":"Spotlight für alle","addSpotlightMenuLabel":"Spotlight hinzufügen","stopSpotlightMenuLabel":"Spotlight beenden","stopSpotlightOnSelfMenuLabel":"Spotlight beenden","spotlightLimitReachedMenuTitle":"Spotlight-Limit erreicht","stopAllSpotlightMenuLabel":"Alle Spotlights beenden","returnToCallButtonAriaDescription":"Zurück zum Anruf","returnToCallButtonAriaLabel":"Zurück","roomNotFoundDetails":"Die angegebene Raum-ID wurde nicht gefunden.","roomNotFoundTitle":"Raum nicht gefunden","roomNotValidDetails":"Dieser Raum ist zurzeit nicht gültig.","roomNotValidTitle":"Raum ungültig","inviteToRoomRemovedDetails":"Ihre Einladung, diesem Raum beizutreten, wurde entfernt.","inviteToRoomRemovedTitle":"Einladung zum Raum entfernt","soundLabel":"Sound","noMicrophonesLabel":"Keine Mikrofone gefunden","noSpeakersLabel":"Keine Lautsprecher gefunden","startCallButtonLabel":"Anruf beginnen","openDialpadButtonLabel":"Telefonnummer wählen","peoplePaneAddPeopleButtonLabel":"Personen hinzufügen","dialpadStartCallButtonLabel":"Anrufen","dialpadModalTitle":"Telefonnummer wählen","dialpadModalAriaLabel":"Wähltastatur","dialpadCloseModalButtonAriaLabel":"Wähltastatur schließen","moreButtonCallingLabel":"Mehr","resumeCallButtonLabel":"Fortsetzen","resumingCallButtonLabel":"Wird fortgesetzt…","resumeCallButtonAriaLabel":"Anruf fortsetzen","resumingCallButtonAriaLabel":"Anruf fortsetzen","holdScreenLabel":"Sie sind in der Warteschleife.","openDtmfDialpadLabel":"Wähltastatur anzeigen","dtmfDialpadPlaceholderText":"Nummer eingeben","outboundCallingNoticeString":"Anrufen...","participantJoinedNoticeString":"{displayName} ist beigetreten.","twoParticipantJoinedNoticeString":"{displayName1} und {displayName2} sind beigetreten.","threeParticipantJoinedNoticeString":"{displayName1}, {displayName2} und {displayName3} sind beigetreten.","participantLeftNoticeString":"{displayName} ist gegangen.","twoParticipantLeftNoticeString":"{displayName1} und {displayName2} sind gegangen.","threeParticipantLeftNoticeString":"{displayName1}, {displayName2} und {displayName3} sind gegangen.","unnamedParticipantString":"unbenannter Teilnehmer","manyUnnamedParticipantsJoined":"unbenannter Teilnehmer und {numOfParticipants} weitere Teilnehmer sind beigetreten.","manyUnnamedParticipantsLeft":"unbenannter Teilnehmer und {numOfParticipants} weitere Teilnehmer sind gegangen.","manyParticipantsJoined":"{displayName1}, {displayName2}, {displayName3} und {numOfParticipants} anderen Teilnehmern sind beigetreten.","manyParticipantsLeft":"{displayName1}, {displayName2}, {displayName3} und {numOfParticipants} anderen Teilnehmer verlassen","liveCaptionsLabel":"Liveuntertitel","captionsSettingsLabel":"Untertiteleinstellungen","startCaptionsButtonOnLabel":"Beschriftungen aktivieren","startCaptionsButtonOffLabel":"Untertitel deaktivieren","startCaptionsButtonTooltipOnContent":"Untertitel deaktivieren","startCaptionsButtonTooltipOffContent":"Beschriftungen aktivieren","captionsSettingsModalTitle":"Einstellungen für Untertitel","captionsSettingsSpokenLanguageDropdownLabel":"Gesprochene Sprache","captionsSettingsCaptionLanguageDropdownLabel":"Sprache der Untertitel","captionsSettingsSpokenLanguageDropdownInfoText":"Sprache, die jeder in diesem Anruf spricht.","captionsSettingsCaptionLanguageDropdownInfoText":"Untertitel werden in dieser Sprache angezeigt.","captionsSettingsConfirmButtonLabel":"Bestätigen","captionsSettingsCancelButtonLabel":"Abbrechen","captionsSettingsModalAriaLabel":"Untertiteleinstellung modal","captionsSettingsCloseModalButtonAriaLabel":"Einstellung „Untertitel“ schließen","captionsBannerMoreButtonCallingLabel":"Untertiteleinstellungen – Weitere Optionen","captionsBannerMoreButtonTooltip":"Weitere Optionen","realTimeTextLabel":"Echtzeittext (RTT)","startRealTimeTextLabel":"RTT für diesen Anruf aktivieren","disabledStartRealTimeTextLabel":"RTT ist zurzeit aktiviert und kann nicht ausgeschaltet werden.","dismissModalAriaLabel":"Lokales Bild und Remotebild. Drücken Sie die EINGABETASTE, um zum Anruf zurückzukehren.","callRejectedTitle":"Der Anruf konnte nicht ausgeführt werden.","callRejectedMoreDetails":"Die Person, die Sie erreichen möchten, ist nicht verfügbar. Versuchen Sie es später noch mal.","callTimeoutTitle":"Der Anruf konnte nicht ausgeführt werden.","callTimeoutDetails":"Die Person, die Sie erreichen möchten, ist nicht verfügbar. Versuchen Sie es später noch mal.","callTimeoutBotTitle":"Der Anruf konnte nicht ausgeführt werden.","callTimeoutBotDetails":"Der Dienst, den Sie erreichen möchten, ist nicht verfügbar. Versuchen Sie es später noch mal.","dtmfDialerButtonLabel":"Wähltastatur","dtmfDialerButtonTooltipOn":"Wähltastatur anzeigen","dtmfDialerButtonTooltipOff":"Wähltastatur ausblenden","dtmfDialerMoreButtonLabelOn":"Wähltastatur anzeigen","dtmfDialerMoreButtonLabelOff":"Wähltastatur ausblenden","phoneCallMoreButtonLabel":"Telefonanruf","spokenLanguageStrings":{"ar-ae":"Arabisch – Vereinigte Arabische Emirate","ar-sa":"Arabisch – Saudi-Arabien","da-dk":"Dänisch","de-de":"Deutsch – Deutschland","en-au":"Englisch – Australien","en-ca":"Englisch – Kanada","en-gb":"Englisch - Vereinigtes Königreich","en-in":"Englisch – Indien","en-nz":"Englisch – Neuseeland","en-us":"Englisch – USA","es-es":"Spanisch – Spanien (Moderne Sortierung)","es-mx":"Spanisch – Mexiko","fi-fi":"Finnisch","fr-ca":"Französisch (Kanada)","fr-fr":"Französisch (Frankreich)","hi-in":"Hindi","it-it":"Italienisch – Italien","ja-jp":"Japanisch","ko-kr":"Koreanisch","nb-no":"Norwegisch (Bokmål)","nl-be":"Niederländisch – Belgien","nl-nl":"Niederländisch – Niederlande","pl-pl":"Polnisch","pt-br":"Portugiesisch (Brasilien)","ru-ru":"Russisch","sv-se":"Schwedisch","zh-cn":"Chinesisch – Volksrepublik China","zh-hk":"Chinesisch – Hongkong (SAR)","cs-cz":"Tschechisch","pt-pt":"Portugiesisch (Portugal)","tr-tr":"Türkisch","vi-vn":"Vietnamesisch","th-th":"Thailändisch","he-il":"Hebräisch","cy-gb":"Walisisch","uk-ua":"Ukrainisch","el-gr":"Griechisch","hu-hu":"Ungarisch","ro-ro":"Rumänisch","sk-sk":"Slowakisch","zh-tw":"Chinesisch – Taiwan"},"captionLanguageStrings":{"ar":"Arabisch","da":"Dänisch","de":"Deutsch","en":"Englisch","es":"Spanisch","fi":"Finnisch","fr-ca":"Französisch – Kanada","fr":"Französisch – Frankreich","hi":"Hindi","it":"Italienisch","ja":"Japanisch","ko":"Koreanisch","nb":"Norwegisch (Bokmål)","nl":"Niederländisch","pl":"Polnisch","pt":"Portugiesisch – Brasilien","ru":"Russisch","sv":"Schwedisch","zh-Hans":"Chinesisch (vereinfacht)","zh-Hant":"Chinesisch (traditionell)","cs":"Tschechisch","pt-pt":"Portugiesisch – Portugal","tr":"Türkisch","vi":"Vietnamesisch","th":"Thailändisch","he":"Hebräisch","cy":"Walisisch","uk":"Ukrainisch","el":"Griechisch","hu":"Ungarisch","ro":"Rumänisch","sk":"Slowakisch"},"captionsBannerSpinnerText":"Untertitel werden gestartet...","realTimeTextInputBoxDefaultText":"Nachricht in Echtzeit eingeben","realTimeTextInputErrorMessage":"Die Nachricht darf 2000 Zeichen nicht überschreiten.","realTimeTextBannerTitle":"RTT","realTimeTextBannerContent":"RTT (Echtzeittext) ist für alle Teilnehmer für die gesamte Dauer der Besprechung aktiviert.","realTimeTextBannerLinkLabel":"Weitere Informationen","realTimeTextModalAriaLabel":"RTT Modal aktivieren","realTimeTextModalTitle":"RTT aktivieren?","realTimeTextModalText":"Echtzeittext (RTT) wird für alle Teilnehmer der Besprechung aktiviert.","realTimeTextConfirmButtonLabel":"Aktivieren","realTimeTextCancelButtonLabel":"Abbrechen","realTimeTextCloseModalButtonAriaLabel":"RTT Modal schließen","captionsOnlyContainerTitle":"Untertitel","realTimeTextOnlyContainerTitle":"Echtzeittext","captionsAndRealTimeTextContainerTitle":"Untertitel und Echtzeittext","expandButtonAriaLabel":"Erweitern","minimizeButtonAriaLabel":"Reduzieren","transferPageTransferorText":"Übertragung...","transferPageTransferTargetText":"Verbindung wird hergestellt...","transferPageUnknownTransferorDisplayName":"Unbekannt","transferPageUnknownTransferTargetDisplayName":"Unbekannt","transferPageNoticeString":"Sie werden versetzt","participantCouldNotBeReachedTitle":"Der Zielteilnehmer ist zurzeit nicht verfügbar","participantCouldNotBeReachedMoreDetails":"Wenden Sie sich an den Teilnehmer, wenn er verfügbar ist","permissionToReachTargetParticipantNotAllowedTitle":"Die Berechtigung zum Erreichen des Zielteilnehmers ist nicht zulässig","permissionToReachTargetParticipantNotAllowedMoreDetails":"Überprüfen Sie, ob sich der Zielteilnehmer im selben Mandanten befindet","unableToResolveTenantTitle":"Die Mandanten-ID für den Zielteilnehmer kann nicht aufgelöst werden","unableToResolveTenantMoreDetails":"Überprüfen Sie, ob die Teilnehmer-ID richtig eingegeben wurde.","participantIdIsMalformedTitle":"Die Teilnehmer-ID weist nicht das richtige Format auf","participantIdIsMalformedMoreDetails":"Überprüfen Sie, ob die Teilnehmer-ID das richtige Format aufweist.","moreButtonGalleryControlLabel":"Anzeigen","moreButtonGalleryPositionToggleLabel":"Katalog nach oben verschieben","moreButtonGallerySpeakerLayoutLabel":"Lautsprecher","moreButtonGalleryFloatingLocalLayoutLabel":"Dynamisch","moreButtonGalleryDefaultLayoutLabel":"Profilfotoansicht","moreButtonGalleryFocusedContentLayoutLabel":"Fokus auf Inhalte","moreButtonLargeGalleryDefaultLayoutLabel":"Große Galerie","moreButtonTogetherModeLayoutLabel":"Zusammen-Modus","capabilityChangedNotification":{"turnVideoOn":{"lostDueToMeetingOption":"Ihre Kamera wurde deaktiviert. Sie können kein Video mehr freigeben.","grantedDueToMeetingOption":"Ihre Kamera wurde aktiviert. Aktivieren Sie diese Option, wenn Sie Video freigeben möchten."},"unmuteMic":{"lostDueToMeetingOption":"Ihr Mikro wurde deaktiviert. Sie können die Stummschaltung nicht mehr aufheben.","grantedDueToMeetingOption":"Ihr Mikro wurde aktiviert. Heben Sie die Stummschaltung auf, wenn Sie sprechen möchten."},"shareScreen":{"lostDueToRoleChangeToAttendee":"Ihre Rolle wurde geändert. Einige Aktionen, z. B. das Teilen von Inhalten, stehen Ihnen nicht zur Verfügung.","grantedDueToRoleChangeToPresenter":"Sie sind Referent. Sie können Inhalte teilen und die Besprechung unterstützen."},"hideAttendeeNames":{"hideAttendeeNameAttendee":"Ihr Name ist für andere Teilnehmer ausgeblendet. Organisatoren und Referenten können Ihren richtigen Namen sehen.","hideAttendeeNamePresenter":"Teilnehmernamen sind ausgeblendet. Nur Organisatoren und Referenten können Namen sehen, um die Privatsphäre der Teilnehmer zu schützen."}},"surveyTitle":"Helfen Sie uns, besser zu werden.","starSurveyHelperText":"Wie war die Qualität des Anrufs?","starSurveyOneStarText":"Die Qualität war schlecht.","starSurveyTwoStarText":"Die Qualität war schlecht.","starSurveyThreeStarText":"Die Qualität war gut.","starSurveyFourStarText":"Die Qualität war toll.","starSurveyFiveStarText":"Die Qualität war ausgezeichnet.","surveyConfirmButtonLabel":"Feedback senden","starRatingAriaLabel":"{0} von {1} Sternen auswählen","surveySkipButtonLabel":"Überspringen","tagsSurveyQuestion":"Was hätte besser sein können?","tagsSurveyTextFieldDefaultText":"Sonstiges, bitte angeben","tagsSurveyHelperText":"Überprüfen Sie alle aufgetretenen Probleme","endOfSurveyText":"Vielen Dank für Ihr Feedback!","surveyIssues":{"overallRating":{"callCannotJoin":"Ich konnte dem Anruf nicht beitreten","callCannotInvite":"Ich konnte andere nicht zum Anruf einladen","hadToRejoin":"Ich musste dem Anruf erneut beitreten","callEndedUnexpectedly":"Anruf für mich unerwartet beendet","otherIssues":"Ich hatte andere Probleme mit dem Anruf"},"audioRating":{"noLocalAudio":"Die andere Seite konnte keinen Ton hören","noRemoteAudio":"Ich konnte keinen Ton hören","echo":"Ich habe Echos beim Anruf gehört","audioNoise":"Ich habe Rauschen beim Anruf gehört","lowVolume":"Die Lautstärke war niedrig","audioStoppedUnexpectedly":"Audio wurde unerwartet beendet","distortedSpeech":"Audio war verzerrt","audioInterruption":"Audio wurde unterbrochen","otherIssues":"In diesem Anruf gab es andere Audioprobleme"},"videoRating":{"noVideoReceived":"Ich konnte kein Video sehen.","noVideoSent":"Andere konnten mich nicht sehen","lowQuality":"Die Videoqualität war niedrig","freezes":"Video gefroren","stoppedUnexpectedly":"Video unerwartet beendet","darkVideoReceived":"Ich kann nur dunkle Bildschirme sehen, wenn andere ihre Kamera einschalten","audioVideoOutOfSync":"Audio und Video waren nicht synchronisiert","otherIssues":"In diesem Anruf gab es andere Videoprobleme"},"screenshareRating":{"noContentLocal":"Andere Personen konnten meine Bildschirmfreigabe nicht sehen","noContentRemote":"Ich konnte die Bildschirmfreigabe anderer Personen nicht sehen","cannotPresent":"Ich konnte meinen Bildschirm nicht präsentieren","lowQuality":"Qualität der Bildschirmfreigabe war niedrig","freezes":"Bildschirmfreigabe gefroren","stoppedUnexpectedly":"Bildschirmfreigabe unerwartet beendet","largeDelay":"Die Bildschirmfreigabe hat eine große Verzögerung","otherIssues":"Ich hatte andere Probleme mit der Bildschirmfreigabe in diesem Anruf."}},"surveyIssuesHeadingStrings":{"overallRating":"Insgesamt","audioRating":"Audio","videoRating":"Video","screenshareRating":"Hält Präsentation"},"spotlightPrompt":{"startSpotlightHeading":"Spotlight für alle?","startSpotlightText":"Sie heben dieses Video für alle Teilnehmer der Besprechung hervor.","startSpotlightOnSelfText":"Sie setzen Ihr Video für alle Teilnehmer der Besprechung ins Spotlight.","startSpotlightConfirmButtonLabel":"Spotlight für alle","startSpotlightCancelButtonLabel":"Abbrechen","stopSpotlightHeading":"Dieses Video aus dem Spotlight nehmen?","stopSpotlightOnSelfHeading":"Spotlight verlassen?","stopAllSpotlightHeading":"Spotlighting aller Videos beenden?","stopSpotlightText":"Dieses Video wird nicht mehr für alle Teilnehmer der Besprechung hervorgehoben.","stopSpotlightOnSelfText":"Ihr Video wird nicht mehr für alle Teilnehmer der Besprechung hervor gehoben.","stopAllSpotlightText":"Die Videos werden nicht mehr für alle Teilnehmer der Besprechung hervorgehoben.","stopSpotlightConfirmButtonLabel":"Spotlight beenden","stopSpotlightOnSelfConfirmButtonLabel":"Spotlight beenden","stopSpotlightCancelButtonLabel":"Abbrechen","closeSpotlightPromptButtonLabel":"Schließen"},"exitSpotlightButtonLabel":"Spotlight beenden","exitSpotlightButtonTooltip":"Spotlight beenden","leaveConfirmButtonLabel":"Beenden","endCallConfirmButtonLabel":"Gespräch beenden","hangUpCancelButtonLabel":"Abbrechen","leaveConfirmDialogTitle":"Gespräch beenden?","leaveConfirmDialogContent":"Möchten Sie den Anruf wirklich verlassen?","endCallConfirmDialogTitle":"Gespräch beenden?","endCallConfirmDialogContent":"Sie beenden das Gespräch für alle.","invalidMeetingIdentifier":"Ungültige Besprechungs-ID oder -Kennung","pinParticipantMenuLabel":"Für mich anheften","pinParticipantLimitReachedMenuLabel":"Anheften (Limit erreicht)","unpinParticipantMenuLabel":"Lösen","pinParticipantMenuItemAriaLabel":"Für mich anheften","unpinParticipantMenuItemAriaLabel":"Lösen","muteAllMenuLabel":"Alle stummschalten","muteAllDialogTitle":"Alle stummschalten?","muteAllDialogContent":"Hierdurch werden alle in der Besprechung stummgeschaltet, außer Ihnen.","muteAllConfirmButtonLabel":"Alle stummschalten","muteAllCancelButtonLabel":"Abbrechen","joinBreakoutRoomButtonLabel":"Breakout-Room beitreten","returnFromBreakoutRoomButtonLabel":"Raum verlassen","leaveBreakoutRoomAndMeetingButtonLabel":"Besprechung verlassen","breakoutRoomJoinedNotificationTitle":"Sie sind dem Gruppenraum „{roomName}“ beigetreten.","joinBreakoutRoomBannerTitle":"Der Gruppenraum „{roomName}“ ist geöffnet.","joinBreakoutRoomBannerButtonLabel":"Beitreten","returnFromBreakoutRoomBannerTitle":"Zurück zur Hauptbesprechung","returnFromBreakoutRoomBannerButtonLabel":"Erneut teilnehmen","forbidAudioMenuLabel":"Mikro deaktivieren","permitAudioMenuLabel":"Mikrofon zulassen","forbidOthersAudioDialogTitle":"Mikrofon für Teilnehmer deaktivieren?","forbidOthersAudioDialogContent":"Die Teilnehmer können ihre Stummschaltung nicht selber aufheben. Der Organisator und die Referenten können Personen bei Bedarf erlauben, die Stummschaltung aufzuheben.","forbidOthersAudioConfirmButtonLabel":"Mikrofone deaktivieren","forbidOthersAudioCancelButtonLabel":"Abbrechen","permitOthersAudioDialogTitle":"Mikrofon für Teilnehmer zulassen?","permitOthersAudioDialogContent":"Jeder Besprechungsteilnehmer kann seine Stummschaltung aufheben.","permitOthersAudioConfirmButtonLabel":"Mikrofone zulassen","permitOthersAudioCancelButtonLabel":"Abbrechen","forbidOthersAudioMenuLabel":"Mikrofone für Teilnehmer deaktivieren","permitOthersAudioMenuLabel":"Mikrofon für Teilnehmer zulassen","forbidVideoMenuLabel":"Kamera deaktivieren","permitVideoMenuLabel":"Kamera zulassen","forbidOthersVideoDialogTitle":"Kamera für Teilnehmer deaktivieren?","forbidOthersVideoDialogContent":"Teilnehmer können Video nicht selbst aktivieren. Der Organisator und die Referenten können Personen die Kamera nach Bedarf einschalten lassen.","forbidOthersVideoConfirmButtonLabel":"Kameras deaktivieren","forbidOthersVideoCancelButtonLabel":"Abbrechen","permitOthersVideoDialogTitle":"Kamera für Teilnehmer zulassen?","permitOthersVideoDialogContent":"Jeder in der Besprechung kann Video selbst aktivieren.","permitOthersVideoConfirmButtonLabel":"Kameras zulassen","permitOthersVideoCancelButtonLabel":"Abbrechen","forbidOthersVideoMenuLabel":"Kamera für Teilnehmer deaktivieren","permitOthersVideoMenuLabel":"Kamera für Teilnehmer zulassen"}'),chat:{chatListHeader:"In diesem Chat",uploadAttachment:"Anlage hochladen",uploadImageDataNotProvided:"Bilddaten werden nicht bereitgestellt.",uploadImageIsTooLarge:"Das Bild ist zu groß. Wählen Sie einen Wert aus, der kleiner als {maxImageSize} MB ist.",uploadImageExtensionIsNotAllowed:"Das Hochladen von .{imageExtension} Image ist nicht zulässig.",uploadImageFailed:"Das Bild kann nicht hochgeladen werden. Versuchen Sie es später noch mal."},callWithChat:{chatButtonLabel:"Chat",chatButtonNewMessageNotificationLabel:"Neue Nachricht",chatButtonTooltipClosedWithMessageCount:"Chat anzeigen ({unreadMessagesCount} ungelesen)",chatButtonTooltipClose:"Chat ausblenden",chatButtonTooltipOpen:"Chat anzeigen",chatPaneTitle:"Chat",copyInviteLinkButtonLabel:"Einladungslink kopieren",copyInviteLinkButtonActionedLabel:"Link kopiert",copyInviteLinkActionedAriaLabel:"Gruppeneinladungslink kopiert",dismissSidePaneButtonLabel:"Schließen",moreDrawerAudioDeviceMenuTitle:"Audiogerät",moreDrawerButtonLabel:"Weitere Optionen",moreDrawerButtonTooltip:"Weitere Optionen",moreDrawerMicrophoneMenuTitle:"Mikrofon",moreDrawerSpeakerMenuTitle:"Lautsprecher",moreDrawerCaptionsMenuTitle:"Liveuntertitel",moreDrawerSpokenLanguageMenuTitle:"Gesprochene Sprache",moreDrawerCaptionLanguageMenuTitle:"Sprache für Untertitel",moreDrawerGalleryOptionsMenuTitle:"Katalogoptionen",peopleButtonLabel:"Personen",selectedPeopleButtonLabel:'Schaltfläche "Personen" ausgewählt',peopleButtonTooltipOpen:"Teilnehmende anzeigen",peopleButtonTooltipClose:"Teilnehmende ausblenden",peopleButtonTooltipOpenAriaLabel:"Schaltfläche „Personen“, Teilnehmer anzeigen",peopleButtonTooltipCloseAriaLabel:"Schaltfläche „Personen“, Teilnehmer ausblenden",peoplePaneSubTitle:"In diesem Anruf",peoplePaneTitle:"Personen",pictureInPictureTileAriaLabel:"Videofeeds. Klicken Sie hier, um zum Anrufbildschirm zurückzukehren.",removeMenuLabel:"Entfernen",openDialpadButtonLabel:"Telefonnummer wählen",returnToCallButtonAriaDescription:"Zurück zum Anruf",returnToCallButtonAriaLabel:"Zurück",peoplePaneAddPeopleButtonLabel:"Personen hinzufügen",dialpadStartCallButtonLabel:"Anrufen",dialpadModalTitle:"Telefonnummer wählen",dialpadModalAriaLabel:"Wähltastatur",dialpadCloseModalButtonAriaLabel:"Wähltastatur schließen",openDtmfDialpadLabel:"Wähltastatur anzeigen",dtmfDialpadPlaceholderText:"Nummer eingeben",breakoutRoomChatPaneTitle:"Chat im Gruppenraum",chatContentSpinnerLabel:"Chat wird geladen"}})},mli={component:cQt,strings:Yh({call:JSON.parse(`{"cameraLabel":"Cámara","noCamerasLabel":"No se han encontrado cámaras","cameraPermissionDenied":"El explorador está bloqueando el acceso a la cámara","cameraTurnedOff":"La cámara está apagada","chatButtonLabel":"Chat","close":"Cerrar","complianceBannerNowOnlyRecording":"Solo está grabando esta reunión.","complianceBannerNowOnlyTranscription":"Solo está transcribiendo esta reunión.","complianceBannerRecordingAndTranscriptionSaved":"Se están guardando la grabación y la transcripción.","complianceBannerRecordingAndTranscriptionStarted":"Se han iniciado la grabación y la transcripción.","complianceBannerRecordingAndTranscriptionStopped":"Se han detenido la grabación y la transcripción.","complianceBannerRecordingSaving":"La grabación se está guardando.","complianceBannerRecordingStarted":"Se ha iniciado la grabación.","complianceBannerRecordingStopped":"La grabación se ha detenido.","complianceBannerTranscriptionStarted":"La transcripción se ha iniciado.","complianceBannerTranscriptionConsent":"Al unirse, da su consentimiento para que se transcriba esta reunión.","complianceBannerTranscriptionSaving":"Se está guardando la transcripción.","complianceBannerTranscriptionStopped":"La transcripción se ha detenido.","configurationPageTitle":"Iniciar una llamada","copyInviteLinkButtonLabel":"Copiar vínculo de invitación","copyInviteLinkButtonActionedLabel":"Vínculo copiado","copyInviteLinkActionedAriaLabel":"Vínculo de invitación copiado","defaultPlaceHolder":"Seleccionar una opción","dismissSidePaneButtonLabel":"Cerrar","videoEffectsPaneTitle":"Efectos","videoEffectsPaneBackgroundSelectionTitle":"Fondo","videoEffectsPaneAriaLabel":"Panel de efectos de vídeo","configurationPageCameraIsLoadingLabel":"El vídeo se está cargando...","configurationPageVideoEffectsButtonLabel":"Efectos","unableToStartVideoEffect":"No se puede aplicar el efecto de vídeo.","blurBackgroundEffectButtonLabel":"Desenfoque","blurBackgroundTooltip":"Desenfocar fondo","removeBackgroundEffectButtonLabel":"Ninguno","removeBackgroundTooltip":"Quitar fondo","cameraOffBackgroundEffectWarningText":"La cámara está apagada. Enciende la cámara para ver el efecto de vídeo.","failedToJoinCallDueToNoNetworkMoreDetails":"Se desconectó la llamada debido a un problema de red. Compruebe la conexión y únase de nuevo.","failedToJoinCallDueToNoNetworkTitle":"Llamada desconectada","failedToJoinTeamsMeetingReasonAccessDeniedMoreDetails":"No se te concedió la entrada a la llamada. Si se trata de un error, vuelve a unirte.","failedToJoinTeamsMeetingReasonAccessDeniedTitle":"Rechazado de la sala de espera","learnMore":"Más información","leavingCallTitle":"Saliendo...","leftCallMoreDetails":"Si se trata de un error, vuelve a unirte a la llamada.","leftCallTitle":"Has abandonado la llamada","lobbyScreenConnectingToCallTitle":"Uniéndose a la llamada","lobbyScreenWaitingToBeAdmittedTitle":"Esperando a ser admitido","microphonePermissionDenied":"El explorador está bloqueando el acceso al micrófono","microphoneToggleInLobbyNotAllowed":"No se puede silenciar ni reactivar el audio mientras se está en la sala de espera.","mutedMessage":"Estás silenciado","networkReconnectMoreDetails":"Parece que hubo un problema. Estamos intentando reconectar la llamada.","networkReconnectTitle":"Espere","notInvitedToRoomDetails":"No puede unirse a esta sala porque no tiene una invitación.","notInvitedToRoomTitle":"No invitado a la sala","peopleButtonLabel":"Contactos","selectedPeopleButtonLabel":"Se seleccionó el botón Contactos","peoplePaneTitle":"Contactos","peoplePaneMoreButtonAriaLabel":"Más","peopleButtonTooltipOpen":"Mostrar participantes","peopleButtonTooltipClose":"Ocultar participantes","peoplePaneSubTitle":"En esta llamada {numberOfPeople}","privacyPolicy":"Directiva de privacidad","rejoinCallButtonLabel":"Volver a unirse a la llamada","removedFromCallMoreDetails":"Otro participante te ha eliminado de la llamada.","removedFromCallTitle":"Fuiste eliminado","removeMenuLabel":"Quitar","startSpotlightMenuLabel":"Poner en primer plano para todos","addSpotlightMenuLabel":"Agregar primer plano","stopSpotlightMenuLabel":"Dejar de poner en primer plano","stopSpotlightOnSelfMenuLabel":"Primer plano","spotlightLimitReachedMenuTitle":"Se alcanzó el límite de primer plano","stopAllSpotlightMenuLabel":"Detener todos los primeros planos","returnToCallButtonAriaDescription":"Volver a llamada","returnToCallButtonAriaLabel":"Volver","roomNotFoundDetails":"No se encontró el Id. de sala proporcionado.","roomNotFoundTitle":"No se ha encontrado la sala","roomNotValidDetails":"Esta sala no es válida en este momento.","roomNotValidTitle":"Sala no válida","inviteToRoomRemovedDetails":"Se ha quitado la invitación para unirse a esta sala.","inviteToRoomRemovedTitle":"Invitación a sala quitada","soundLabel":"Sonido","noMicrophonesLabel":"No se han encontrado micrófonos","noSpeakersLabel":"No se han encontrado altavoces","startCallButtonLabel":"Iniciar llamada","openDialpadButtonLabel":"Marcar número de teléfono","peoplePaneAddPeopleButtonLabel":"Agregar contactos","dialpadStartCallButtonLabel":"Llamar","dialpadModalTitle":"Marcar número de teléfono","dialpadModalAriaLabel":"Teclado de marcado","dialpadCloseModalButtonAriaLabel":"Cerrar teclado de marcado","moreButtonCallingLabel":"Más","resumeCallButtonLabel":"Reanudar","resumingCallButtonLabel":"Reanudando…","resumeCallButtonAriaLabel":"Reanudar llamada","resumingCallButtonAriaLabel":"Reanudar llamada","holdScreenLabel":"Está en espera","openDtmfDialpadLabel":"Mostrar teclado de marcado","dtmfDialpadPlaceholderText":"Introducir número","outboundCallingNoticeString":"Llamando...","participantJoinedNoticeString":"{displayName} unido","twoParticipantJoinedNoticeString":"{displayName1} y {displayName2} se han unido","threeParticipantJoinedNoticeString":"{displayName1}, {displayName2} y {displayName3} se han unido","participantLeftNoticeString":"{displayName} se ha retirado","twoParticipantLeftNoticeString":"{displayName1} y {displayName2} se han retirado","threeParticipantLeftNoticeString":"{displayName1}, {displayName2} y {displayName3} se han retirado","unnamedParticipantString":"participante sin nombre","manyUnnamedParticipantsJoined":"participante sin nombre y {numOfParticipants} participantes más se han unido","manyUnnamedParticipantsLeft":"participante sin nombre y {numOfParticipants} participantes más se han retirado","manyParticipantsJoined":"{displayName1}, {displayName2}, {displayName3} y {numOfParticipants} se han unido otros participantes","manyParticipantsLeft":"{displayName1}, {displayName2}, {displayName3} y {numOfParticipants} restantes","liveCaptionsLabel":"Subtítulos en directo","captionsSettingsLabel":"Configuración de subtítulos","startCaptionsButtonOnLabel":"Activar subtítulos","startCaptionsButtonOffLabel":"Desactivar subtítulos","startCaptionsButtonTooltipOnContent":"Desactivar subtítulos","startCaptionsButtonTooltipOffContent":"Activar subtítulos","captionsSettingsModalTitle":"Configuración de subtítulos","captionsSettingsSpokenLanguageDropdownLabel":"Idioma hablado","captionsSettingsCaptionLanguageDropdownLabel":"Idioma de subtítulos","captionsSettingsSpokenLanguageDropdownInfoText":"Idioma en el que están hablando todos los usuarios de esta llamada.","captionsSettingsCaptionLanguageDropdownInfoText":"Los subtítulos aparecerán en este idioma.","captionsSettingsConfirmButtonLabel":"Confirmar","captionsSettingsCancelButtonLabel":"Cancelar","captionsSettingsModalAriaLabel":"Configuración modal de subtítulos","captionsSettingsCloseModalButtonAriaLabel":"Cerrar configuración de subtítulos","captionsBannerMoreButtonCallingLabel":"Configuración de subtítulos Más opciones","captionsBannerMoreButtonTooltip":"Más opciones","realTimeTextLabel":"Texto en tiempo real (RTT)","startRealTimeTextLabel":"Activar RTT para esta llamada","disabledStartRealTimeTextLabel":"RTT está activado actualmente, no se puede desactivar","dismissModalAriaLabel":"Imagen e imagen local y remota, presiona Entrar para volver a la llamada","callRejectedTitle":"No se pudo completar la llamada","callRejectedMoreDetails":"La persona con la que quieres contactarte no está disponible. Inténtalo de nuevo más tarde.","callTimeoutTitle":"No se pudo completar la llamada","callTimeoutDetails":"La persona con la que quieres contactarte no está disponible. Inténtalo de nuevo más tarde.","callTimeoutBotTitle":"No se pudo completar la llamada","callTimeoutBotDetails":"El servicio al que intenta conectarse no está disponible. Vuelva a intentarlo más tarde.","dtmfDialerButtonLabel":"Teclado de marcado","dtmfDialerButtonTooltipOn":"Mostrar teclado de marcado","dtmfDialerButtonTooltipOff":"Ocultar teclado de marcado","dtmfDialerMoreButtonLabelOn":"Mostrar teclado de marcado","dtmfDialerMoreButtonLabelOff":"Ocultar teclado de marcado","phoneCallMoreButtonLabel":"Llamada telefónica","spokenLanguageStrings":{"ar-ae":"Árabe - Emiratos Árabes Unidos","ar-sa":"Árabe - Arabia Saudí","da-dk":"Danés","de-de":"Alemán - Alemania","en-au":"Inglés - Australia","en-ca":"Inglés (Canadá)","en-gb":"Inglés - Reino Unido","en-in":"Inglés (India)","en-nz":"Inglés (Nueva Zelanda)","en-us":"Inglés - Estados Unidos","es-es":"Español - España (alfabetización internacional)","es-mx":"Español (México)","fi-fi":"Finés","fr-ca":"Francés (Canadá)","fr-fr":"Francés - Francia","hi-in":"Hindi","it-it":"Italiano (Italia)","ja-jp":"Japonés","ko-kr":"Coreano","nb-no":"Noruego (Bokmlå)","nl-be":"Neerlandés - Bélgica","nl-nl":"Neerlandés (Países Bajos)","pl-pl":"Polaco","pt-br":"Portugués (Brasil)","ru-ru":"Ruso","sv-se":"Sueco","zh-cn":"Chino - República Popular China","zh-hk":"Chino - Hong Kong (RAE)","cs-cz":"Checo","pt-pt":"Portugués de Portugal","tr-tr":"Turco","vi-vn":"Vietnamita","th-th":"Tailandés","he-il":"Hebreo","cy-gb":"Galés","uk-ua":"Ucraniano","el-gr":"Griego","hu-hu":"Húngaro","ro-ro":"Rumano","sk-sk":"Eslovaco","zh-tw":"Chino - Taiwán"},"captionLanguageStrings":{"ar":"Árabe","da":"Danés","de":"Alemán","en":"Inglés","es":"Español","fi":"Finés","fr-ca":"Francés (Canadá)","fr":"Francés - Francia","hi":"Hindi","it":"Italiano","ja":"Japonés","ko":"Coreano","nb":"Noruego (Bokmål)","nl":"Neerlandés","pl":"Polaco","pt":"Portugués (Brasil)","ru":"Ruso","sv":"Sueco","zh-Hans":"Chino (simplificado)","zh-Hant":"Chino (tradicional)","cs":"Checo","pt-pt":"Portugués de Portugal","tr":"Turco","vi":"Vietnamita","th":"Tailandés","he":"Hebreo","cy":"Galés","uk":"Ucraniano","el":"Griego","hu":"Húngaro","ro":"Rumano","sk":"Eslovaco"},"captionsBannerSpinnerText":"Iniciando subtítulos...","realTimeTextInputBoxDefaultText":"Escribir un mensaje en tiempo real","realTimeTextInputErrorMessage":"El mensaje no puede exceder los 2000 caracteres","realTimeTextBannerTitle":"RTT","realTimeTextBannerContent":"RtT (texto en tiempo real) está habilitado para todos los participantes durante toda la reunión.","realTimeTextBannerLinkLabel":"Más información","realTimeTextModalAriaLabel":"Activar modal RTT","realTimeTextModalTitle":"¿Activar RTT?","realTimeTextModalText":"Se activará el texto en tiempo real (RTT) para todos los participantes de la reunión.","realTimeTextConfirmButtonLabel":"Activar","realTimeTextCancelButtonLabel":"Cancelar","realTimeTextCloseModalButtonAriaLabel":"Cerrar modal RTT","captionsOnlyContainerTitle":"Subtítulos","realTimeTextOnlyContainerTitle":"Texto en tiempo real","captionsAndRealTimeTextContainerTitle":"Subtítulos y texto en tiempo real","expandButtonAriaLabel":"Expandir","minimizeButtonAriaLabel":"Contraer","transferPageTransferorText":"Transfiriendo...","transferPageTransferTargetText":"Conectando...","transferPageUnknownTransferorDisplayName":"Desconocido","transferPageUnknownTransferTargetDisplayName":"Desconocido","transferPageNoticeString":"Está siendo transferido","participantCouldNotBeReachedTitle":"El participante de destino no está disponible actualmente","participantCouldNotBeReachedMoreDetails":"Póngase en contacto con el participante cuando esté disponible","permissionToReachTargetParticipantNotAllowedTitle":"No se permite el permiso para llegar al participante objetivo","permissionToReachTargetParticipantNotAllowedMoreDetails":"Compruebe que el participante de destino está en el mismo inquilino.","unableToResolveTenantTitle":"No se puede resolver el id. de inquilino para el participante de destino","unableToResolveTenantMoreDetails":"Compruebe que el id. de participante se ha escrito correctamente.","participantIdIsMalformedTitle":"El id. de participante no tiene el formato correcto","participantIdIsMalformedMoreDetails":"Compruebe que el id. de participante tiene el formato correcto","moreButtonGalleryControlLabel":"Ver","moreButtonGalleryPositionToggleLabel":"Mover galería a la parte superior","moreButtonGallerySpeakerLayoutLabel":"Orador","moreButtonGalleryFloatingLocalLayoutLabel":"Dinámico","moreButtonGalleryDefaultLayoutLabel":"Vista galería","moreButtonGalleryFocusedContentLayoutLabel":"Centrarse en el contenido","moreButtonLargeGalleryDefaultLayoutLabel":"Galería de gran tamaño","moreButtonTogetherModeLayoutLabel":"Modo conferencia","capabilityChangedNotification":{"turnVideoOn":{"lostDueToMeetingOption":"La cámara se ha deshabilitado. Ya no puedes compartir vídeo.","grantedDueToMeetingOption":"Tu cámara ha sido habilitada. Actívala si quiere compartir un vídeo."},"unmuteMic":{"lostDueToMeetingOption":"El micrófono se ha deshabilitado. Ya no se puede reactivar el audio.","grantedDueToMeetingOption":"Se ha habilitado el micro. Reactive el audio si quiere hablar."},"shareScreen":{"lostDueToRoleChangeToAttendee":"Tu rol ha sido cambiado. Algunas acciones, como compartir contenido, no estarán disponibles para usted.","grantedDueToRoleChangeToPresenter":"Es moderador. Puede compartir contenido y facilitar la reunión."},"hideAttendeeNames":{"hideAttendeeNameAttendee":"Su nombre está oculto para otros asistentes. Los organizadores y moderadores pueden ver su nombre real.","hideAttendeeNamePresenter":"Los nombres de los asistentes están ocultos. Solo los organizadores y moderadores pueden ver los nombres para proteger la privacidad de los asistentes."}},"surveyTitle":"Ayúdenos a mejorar","starSurveyHelperText":"¿Qué tal era la calidad de la llamada?","starSurveyOneStarText":"La calidad era mala.","starSurveyTwoStarText":"La calidad era deficiente.","starSurveyThreeStarText":"La calidad era buena.","starSurveyFourStarText":"La calidad era estupenda.","starSurveyFiveStarText":"La calidad era excelente.","surveyConfirmButtonLabel":"Enviar comentarios","starRatingAriaLabel":"Seleccione {0} de {1} estrellas","surveySkipButtonLabel":"Omitir","tagsSurveyQuestion":"¿Qué podría haber sido mejor?","tagsSurveyTextFieldDefaultText":"Otro, especifique","tagsSurveyHelperText":"Marque los problemas que haya experimentado","endOfSurveyText":"Gracias por sus comentarios.","surveyIssues":{"overallRating":{"callCannotJoin":"No pude unirme a la llamada","callCannotInvite":"No podía invitar a nadie a la llamada","hadToRejoin":"He tenido que volver a unirme a la llamada","callEndedUnexpectedly":"La llamada finalizó inesperadamente","otherIssues":"Estaba teniendo otros problemas con la llamada"},"audioRating":{"noLocalAudio":"Los otros participantes no podían oír nada","noRemoteAudio":"No pude oír nada","echo":"He oído ecos en la llamada","audioNoise":"Se oía ruido en la llamada","lowVolume":"El volumen era bajo","audioStoppedUnexpectedly":"El audio se detuvo inesperadamente","distortedSpeech":"El audio se distorsionaba","audioInterruption":"Se interrumpió el audio","otherIssues":"Estaba teniendo otros problemas de audio en esta llamada"},"videoRating":{"noVideoReceived":"No pude ver ningún vídeo","noVideoSent":"Los demás usuarios no me veían","lowQuality":"La calidad de vídeo era baja","freezes":"Vídeo congelado","stoppedUnexpectedly":"El vídeo se detuvo inesperadamente","darkVideoReceived":"Solo puedo ver pantallas oscuras cuando otros usuarios activan su cámara","audioVideoOutOfSync":"Audio y vídeo no sincronizados","otherIssues":"Estaba teniendo otros problemas de vídeo en esta llamada"},"screenshareRating":{"noContentLocal":"Otras personas no pudieron ver mi pantalla compartida","noContentRemote":"No pude ver el la pantalla compartida de otras personas","cannotPresent":"No pude presentar mi pantalla","lowQuality":"La calidad de la pantalla compartida era baja","freezes":"Pantalla compartida congelada","stoppedUnexpectedly":"El la pantalla compartida se detuvo inesperadamente","largeDelay":"La pantalla compartida tiene mucho retraso","otherIssues":"Estaba teniendo otros problemas de pantalla compartida en esta llamada"}},"surveyIssuesHeadingStrings":{"overallRating":"General","audioRating":"Audio","videoRating":"Vídeo","screenshareRating":"Presentación"},"spotlightPrompt":{"startSpotlightHeading":"¿Poner en primer plano para todos?","startSpotlightText":"Este vídeo lo resaltará para todos en la reunión.","startSpotlightOnSelfText":"Resaltará el vídeo para todos los participantes de la reunión.","startSpotlightConfirmButtonLabel":"Poner en primer plano para todos","startSpotlightCancelButtonLabel":"Cancelar","stopSpotlightHeading":"¿Dejar de poner este vídeo en primer plano?","stopSpotlightOnSelfHeading":"¿Salir del primer plano?","stopAllSpotlightHeading":"¿Quieres dejar de poner en primer plano todos los vídeos?","stopSpotlightText":"Este vídeo dejará de estar resaltado para todos los asistentes a la reunión.","stopSpotlightOnSelfText":"Su vídeo ya no resaltará para todos en la reunión.","stopAllSpotlightText":"El vídeo ya no se pondrá en primer plano para todos los participantes de la reunión.","stopSpotlightConfirmButtonLabel":"Dejar de poner en primer plano","stopSpotlightOnSelfConfirmButtonLabel":"Salir del primer plano","stopSpotlightCancelButtonLabel":"Cancelar","closeSpotlightPromptButtonLabel":"Cerrar"},"exitSpotlightButtonLabel":"Salir del primer plano","exitSpotlightButtonTooltip":"Salir del primer plano","leaveConfirmButtonLabel":"Salir","endCallConfirmButtonLabel":"Finalizar llamada","hangUpCancelButtonLabel":"Cancelar","leaveConfirmDialogTitle":"¿Abandonar la llamada?","leaveConfirmDialogContent":"¿Está seguro de que desea abandonar la llamada?","endCallConfirmDialogTitle":"¿Finalizar la llamada?","endCallConfirmDialogContent":"Finalizará la llamada para todos los usuarios.","invalidMeetingIdentifier":"Id. de reunión o código de acceso no válidos","pinParticipantMenuLabel":"Anclar para mí","pinParticipantLimitReachedMenuLabel":"Pin (límite alcanzado)","unpinParticipantMenuLabel":"Desanclar","pinParticipantMenuItemAriaLabel":"Anclar para mí","unpinParticipantMenuItemAriaLabel":"Desanclar","muteAllMenuLabel":"Silenciar todo","muteAllDialogTitle":"¿Silenciar a todos?","muteAllDialogContent":"Esto silenciará a todos los participantes de la reunión, excepto usted.","muteAllConfirmButtonLabel":"Silenciar todo","muteAllCancelButtonLabel":"Cancelar","joinBreakoutRoomButtonLabel":"Unirse a la sala para sesión de subgrupo","returnFromBreakoutRoomButtonLabel":"Salir de la sala","leaveBreakoutRoomAndMeetingButtonLabel":"Salir de la reunión","breakoutRoomJoinedNotificationTitle":"Se has unido a la sala para sesión de subgrupo '{roomName}'","joinBreakoutRoomBannerTitle":"La sala para sesión de subgrupo '{roomName}' está abierta","joinBreakoutRoomBannerButtonLabel":"Unirse","returnFromBreakoutRoomBannerTitle":"Regresar a la reunión principal","returnFromBreakoutRoomBannerButtonLabel":"Volver a unirse","forbidAudioMenuLabel":"Deshabilitar micrófono","permitAudioMenuLabel":"Permitir micrófono","forbidOthersAudioDialogTitle":"¿Quiere deshabilitar el micrófono para los asistentes?","forbidOthersAudioDialogContent":"Los asistentes no podrán activar su audio. El organizador y los moderadores podrán permitir que la gente active su audio según sea necesario.","forbidOthersAudioConfirmButtonLabel":"Deshabilitar micrófonos","forbidOthersAudioCancelButtonLabel":"Cancelar","permitOthersAudioDialogTitle":"¿Permitir a los asistentes usar el micrófono?","permitOthersAudioDialogContent":"Todos los usuarios de la reunión podrán reactivar su audio.","permitOthersAudioConfirmButtonLabel":"Permitir micrófonos","permitOthersAudioCancelButtonLabel":"Cancelar","forbidOthersAudioMenuLabel":"Deshabilitar micrófono para los asistentes","permitOthersAudioMenuLabel":"Permitir el micrófono para los asistentes","forbidVideoMenuLabel":"Deshabilitar cámara","permitVideoMenuLabel":"Permitir cámara","forbidOthersVideoDialogTitle":"¿Quiere deshabilitar la cámara de los asistentes?","forbidOthersVideoDialogContent":"Los asistentes no podrán activar el vídeo ellos mismos. El organizador y los moderadores pueden permitir que los usuarios enciendan la cámara según sea necesario.","forbidOthersVideoConfirmButtonLabel":"Deshabilitar cámaras","forbidOthersVideoCancelButtonLabel":"Cancelar","permitOthersVideoDialogTitle":"¿Permitir a los asistentes usar la cámara?","permitOthersVideoDialogContent":"Todos los participantes de la reunión podrán activar el vídeo ellos mismos.","permitOthersVideoConfirmButtonLabel":"Permitir cámaras","permitOthersVideoCancelButtonLabel":"Cancelar","forbidOthersVideoMenuLabel":"Deshabilitar la cámara de los asistentes","permitOthersVideoMenuLabel":"Permitir la cámara para los asistentes"}`),chat:{chatListHeader:"En este chat",uploadAttachment:"Cargar datos adjuntos",uploadImageDataNotProvided:"No se proporcionaron datos de imagen.",uploadImageIsTooLarge:"La imagen es demasiado grande. Elige uno que sea inferior a {maxImageSize} MB.",uploadImageExtensionIsNotAllowed:"No se permite cargar una imagen .{imageExtension}.",uploadImageFailed:"No se puede cargar la imagen. Vuelva a intentarlo más tarde."},callWithChat:{chatButtonLabel:"Chat",chatButtonNewMessageNotificationLabel:"Nuevo mensaje",chatButtonTooltipClosedWithMessageCount:"Mostrar chat ({unreadMessagesCount} no leídos)",chatButtonTooltipClose:"Ocultar chat",chatButtonTooltipOpen:"Mostrar chat",chatPaneTitle:"Chat",copyInviteLinkButtonLabel:"Copiar vínculo de invitación",copyInviteLinkButtonActionedLabel:"Vínculo copiado",copyInviteLinkActionedAriaLabel:"Vínculo de invitación copiado",dismissSidePaneButtonLabel:"Cerrar",moreDrawerAudioDeviceMenuTitle:"Dispositivo de audio",moreDrawerButtonLabel:"Más opciones",moreDrawerButtonTooltip:"Más opciones",moreDrawerMicrophoneMenuTitle:"Micrófono",moreDrawerSpeakerMenuTitle:"Altavoz",moreDrawerCaptionsMenuTitle:"Subtítulos en directo",moreDrawerSpokenLanguageMenuTitle:"Idioma hablado",moreDrawerCaptionLanguageMenuTitle:"Idioma de subtítulos",moreDrawerGalleryOptionsMenuTitle:"Opciones de la Galería",peopleButtonLabel:"Contactos",selectedPeopleButtonLabel:"Se seleccionó el botón Contactos",peopleButtonTooltipOpen:"Mostrar participantes",peopleButtonTooltipClose:"Ocultar participantes",peopleButtonTooltipOpenAriaLabel:"Botón Contactos, Mostrar participantes",peopleButtonTooltipCloseAriaLabel:"Botón Contactos, Ocultar participantes",peoplePaneSubTitle:"En esta llamada",peoplePaneTitle:"Contactos",pictureInPictureTileAriaLabel:"Fuentes de vídeo. Hacer clic para volver a la pantalla de la llamada.",removeMenuLabel:"Quitar",openDialpadButtonLabel:"Marcar número de teléfono",returnToCallButtonAriaDescription:"Volver a llamada",returnToCallButtonAriaLabel:"Volver",peoplePaneAddPeopleButtonLabel:"Agregar contactos",dialpadStartCallButtonLabel:"Llamar",dialpadModalTitle:"Marcar número de teléfono",dialpadModalAriaLabel:"Teclado de marcado",dialpadCloseModalButtonAriaLabel:"Cerrar teclado de marcado",openDtmfDialpadLabel:"Mostrar teclado de marcado",dtmfDialpadPlaceholderText:"Introducir número",breakoutRoomChatPaneTitle:"Chat de sala para sesión de subgrupo",chatContentSpinnerLabel:"Cargando chat"}})},fli={component:dQt,strings:Yh({call:JSON.parse(`{"cameraLabel":"Cámara","noCamerasLabel":"No se han encontrado cámaras","cameraPermissionDenied":"El explorador está bloqueando el acceso a la cámara","cameraTurnedOff":"La cámara está apagada","chatButtonLabel":"Chat","close":"Cerrar","complianceBannerNowOnlyRecording":"Ahora solo estás grabando esta reunión.","complianceBannerNowOnlyTranscription":"Ahora solo estás transcribiendo esta reunión.","complianceBannerRecordingAndTranscriptionSaved":"Se están guardando la grabación y la transcripción.","complianceBannerRecordingAndTranscriptionStarted":"Se han iniciado la grabación y la transcripción.","complianceBannerRecordingAndTranscriptionStopped":"Se han detenido la grabación y la transcripción.","complianceBannerRecordingSaving":"La grabación se está guardando.","complianceBannerRecordingStarted":"La grabación se inició.","complianceBannerRecordingStopped":"La grabación se ha detenido.","complianceBannerTranscriptionStarted":"La transcripción se ha iniciado.","complianceBannerTranscriptionConsent":"Al unirte, das tu consentimiento para que se transcriba esta reunión.","complianceBannerTranscriptionSaving":"Se está guardando la transcripción.","complianceBannerTranscriptionStopped":"La transcripción se ha detenido.","configurationPageTitle":"Iniciar una llamada","copyInviteLinkButtonLabel":"Copiar vínculo de invitación","copyInviteLinkButtonActionedLabel":"Vínculo copiado","copyInviteLinkActionedAriaLabel":"Vínculo de invitación copiado","defaultPlaceHolder":"Seleccionar una opción","dismissSidePaneButtonLabel":"Cerrar","videoEffectsPaneTitle":"Efectos","videoEffectsPaneBackgroundSelectionTitle":"Fondo","videoEffectsPaneAriaLabel":"Panel de efectos de video","configurationPageCameraIsLoadingLabel":"El video se está cargando...","configurationPageVideoEffectsButtonLabel":"Efectos","unableToStartVideoEffect":"No se puede aplicar el efecto de video.","blurBackgroundEffectButtonLabel":"Desenfoque","blurBackgroundTooltip":"Desenfocar fondo","removeBackgroundEffectButtonLabel":"Ninguno","removeBackgroundTooltip":"Quitar fondo","cameraOffBackgroundEffectWarningText":"La cámara está apagada. Enciende la cámara para ver el efecto de video.","failedToJoinCallDueToNoNetworkMoreDetails":"Se desconectó la llamada debido a un problema de red. Comprueba la conexión y únete de nuevo.","failedToJoinCallDueToNoNetworkTitle":"Llamada desconectada","failedToJoinTeamsMeetingReasonAccessDeniedMoreDetails":"No se te concedió la entrada a la llamada. Si se trata de un error, vuelve a unirte.","failedToJoinTeamsMeetingReasonAccessDeniedTitle":"Rechazado de la sala de espera","learnMore":"Más información","leavingCallTitle":"Saliendo...","leftCallMoreDetails":"Si se trata de un error, vuelve a unirte a la llamada.","leftCallTitle":"Has abandonado la llamada","lobbyScreenConnectingToCallTitle":"Uniéndose a la llamada","lobbyScreenWaitingToBeAdmittedTitle":"Esperando a ser admitido","microphonePermissionDenied":"El explorador está bloqueando el acceso al micrófono","microphoneToggleInLobbyNotAllowed":"No se puede silenciar ni reactivar el audio mientras se está en la sala de espera.","mutedMessage":"Estás silenciado","networkReconnectMoreDetails":"Parece que hubo un problema. Estamos intentando reconectar la llamada.","networkReconnectTitle":"Espera","notInvitedToRoomDetails":"No puedes unirte a esta sala porque no tienes una invitación.","notInvitedToRoomTitle":"No invitado a la sala","peopleButtonLabel":"Contactos","selectedPeopleButtonLabel":"Se seleccionó el botón Contactos","peoplePaneTitle":"Contactos","peoplePaneMoreButtonAriaLabel":"Más","peopleButtonTooltipOpen":"Mostrar participantes","peopleButtonTooltipClose":"Ocultar participantes","peoplePaneSubTitle":"En esta llamada {numberOfPeople}","privacyPolicy":"Declaración de privacidad","rejoinCallButtonLabel":"Volver a unirse a la llamada","removedFromCallMoreDetails":"Otro participante te ha eliminado de la llamada.","removedFromCallTitle":"Fuiste eliminado","removeMenuLabel":"Quitar","startSpotlightMenuLabel":"Poner en primer plano para todos","addSpotlightMenuLabel":"Agregar primer plano","stopSpotlightMenuLabel":"Dejar de poner en primer plano","stopSpotlightOnSelfMenuLabel":"Salir de primer plano","spotlightLimitReachedMenuTitle":"Se alcanzó el límite de primer plano","stopAllSpotlightMenuLabel":"Detener todos los primeros planos","returnToCallButtonAriaDescription":"Volver a llamada","returnToCallButtonAriaLabel":"Volver","roomNotFoundDetails":"No se encontró el Id. de sala proporcionado.","roomNotFoundTitle":"No se ha encontrado la sala","roomNotValidDetails":"Esta sala no es válida en este momento.","roomNotValidTitle":"Sala no válida","inviteToRoomRemovedDetails":"Se ha quitado la invitación para unirse a esta sala.","inviteToRoomRemovedTitle":"Invitación a sala quitada","soundLabel":"Sonido","noMicrophonesLabel":"No se han encontrado micrófonos","noSpeakersLabel":"No se han encontrado altavoces","startCallButtonLabel":"Iniciar llamada","openDialpadButtonLabel":"Marcar número de teléfono","peoplePaneAddPeopleButtonLabel":"Agregar contactos","dialpadStartCallButtonLabel":"Llamar","dialpadModalTitle":"Marcar número de teléfono","dialpadModalAriaLabel":"Teclado de marcado","dialpadCloseModalButtonAriaLabel":"Cerrar teclado de marcado","moreButtonCallingLabel":"Más","resumeCallButtonLabel":"Reanudar","resumingCallButtonLabel":"Reanudando…","resumeCallButtonAriaLabel":"Reanudar llamada","resumingCallButtonAriaLabel":"Reanudar llamada","holdScreenLabel":"Está en espera","openDtmfDialpadLabel":"Mostrar teclado de marcado","dtmfDialpadPlaceholderText":"Introducir número","outboundCallingNoticeString":"Llamando...","participantJoinedNoticeString":"{displayName} unido","twoParticipantJoinedNoticeString":"{displayName1} y {displayName2} se han unido","threeParticipantJoinedNoticeString":"{displayName1}, {displayName2} y {displayName3} se han unido","participantLeftNoticeString":"{displayName} se ha retirado","twoParticipantLeftNoticeString":"{displayName1} y {displayName2} se han retirado","threeParticipantLeftNoticeString":"{displayName1}, {displayName2} y {displayName3} se han retirado","unnamedParticipantString":"participante sin nombre","manyUnnamedParticipantsJoined":"participante sin nombre y {numOfParticipants} participantes más se han unido","manyUnnamedParticipantsLeft":"participante sin nombre y {numOfParticipants} participantes más se han retirado","manyParticipantsJoined":"{displayName1}, {displayName2}, {displayName3} y {numOfParticipants} se han unido otros participantes","manyParticipantsLeft":"{displayName1}, {displayName2}, {displayName3} y {numOfParticipants} restantes","liveCaptionsLabel":"Subtítulos en directo","captionsSettingsLabel":"Configuración de subtítulos","startCaptionsButtonOnLabel":"Activar subtítulos","startCaptionsButtonOffLabel":"Desactivar subtítulos","startCaptionsButtonTooltipOnContent":"Desactivar subtítulos","startCaptionsButtonTooltipOffContent":"Activar subtítulos","captionsSettingsModalTitle":"Configuración de subtítulos","captionsSettingsSpokenLanguageDropdownLabel":"Idioma hablado","captionsSettingsCaptionLanguageDropdownLabel":"Idioma de subtítulos","captionsSettingsSpokenLanguageDropdownInfoText":"Idioma en el que están hablando todos los usuarios de esta llamada.","captionsSettingsCaptionLanguageDropdownInfoText":"Los subtítulos aparecerán en este idioma.","captionsSettingsConfirmButtonLabel":"Confirmar","captionsSettingsCancelButtonLabel":"Cancelar","captionsSettingsModalAriaLabel":"Configuración modal de subtítulos","captionsSettingsCloseModalButtonAriaLabel":"Cerrar configuración de subtítulos","captionsBannerMoreButtonCallingLabel":"Más opciones de configuración de subtítulos","captionsBannerMoreButtonTooltip":"Más opciones","realTimeTextLabel":"Escritura en tiempo real (RTT)","startRealTimeTextLabel":"Activar RTT para esta llamada","disabledStartRealTimeTextLabel":"RTT está activado actualmente, no se puede desactivar","dismissModalAriaLabel":"Imagen e imagen local y remota, presiona Entrar para volver a la llamada","callRejectedTitle":"No se pudo completar la llamada","callRejectedMoreDetails":"La persona con la que quieres contactarte no está disponible. Inténtalo de nuevo más tarde.","callTimeoutTitle":"No se pudo completar la llamada","callTimeoutDetails":"La persona con la que quieres contactarte no está disponible. Inténtalo de nuevo más tarde.","callTimeoutBotTitle":"No se pudo completar la llamada","callTimeoutBotDetails":"El servicio al que intentas conectarte no está disponible. Vuelve a intentarlo más tarde.","dtmfDialerButtonLabel":"Teclado de marcado","dtmfDialerButtonTooltipOn":"Mostrar teclado de marcado","dtmfDialerButtonTooltipOff":"Ocultar teclado de marcado","dtmfDialerMoreButtonLabelOn":"Mostrar teclado de marcado","dtmfDialerMoreButtonLabelOff":"Ocultar teclado de marcado","phoneCallMoreButtonLabel":"Llamada telefónica","spokenLanguageStrings":{"ar-ae":"Árabe - Emiratos Árabes Unidos","ar-sa":"Árabe - Arabia Saudí","da-dk":"Danés","de-de":"Alemán - Alemania","en-au":"Inglés - Australia","en-ca":"Inglés (Canadá)","en-gb":"Inglés - Reino Unido","en-in":"Inglés (India)","en-nz":"Inglés (Nueva Zelanda)","en-us":"Inglés - Estados Unidos","es-es":"Español - España (alfabetización internacional)","es-mx":"Español (México)","fi-fi":"Finés","fr-ca":"Francés (Canadá)","fr-fr":"Francés - Francia","hi-in":"Hindi","it-it":"Italiano (Italia)","ja-jp":"Japonés","ko-kr":"Coreano","nb-no":"Noruego (Bokmål)","nl-be":"Neerlandés - Bélgica","nl-nl":"Neerlandés (Países Bajos)","pl-pl":"Polaco","pt-br":"Portugués (Brasil)","ru-ru":"Ruso","sv-se":"Sueco","zh-cn":"Chino - República Popular China","zh-hk":"Chino - Hong Kong (RAE)","cs-cz":"Checo","pt-pt":"Portugués de Portugal","tr-tr":"Turco","vi-vn":"Vietnamita","th-th":"Tailandés","he-il":"Hebreo","cy-gb":"Galés","uk-ua":"Ucraniano","el-gr":"Griego","hu-hu":"Húngaro","ro-ro":"Rumano","sk-sk":"Eslovaco","zh-tw":"Chino - Taiwán"},"captionLanguageStrings":{"ar":"Árabe","da":"Danés","de":"Alemán","en":"Inglés","es":"Español","fi":"Finés","fr-ca":"Francés (Canadá)","fr":"Francés - Francia","hi":"Hindi","it":"Italiano","ja":"Japonés","ko":"Coreano","nb":"Noruego (Bokmål)","nl":"Neerlandés","pl":"Polaco","pt":"Portugués (Brasil)","ru":"Ruso","sv":"Sueco","zh-Hans":"Chino (simplificado)","zh-Hant":"Chino (tradicional)","cs":"Checo","pt-pt":"Portugués de Portugal","tr":"Turco","vi":"Vietnamita","th":"Tailandés","he":"Hebreo","cy":"Galés","uk":"Ucraniano","el":"Griego","hu":"Húngaro","ro":"Rumano","sk":"Eslovaco"},"captionsBannerSpinnerText":"Iniciando subtítulos...","realTimeTextInputBoxDefaultText":"Escribir un mensaje en tiempo real","realTimeTextInputErrorMessage":"El mensaje no puede exceder los 2000 caracteres","realTimeTextBannerTitle":"RTT","realTimeTextBannerContent":"RtT (texto en tiempo real) está habilitado para todos los participantes durante toda la reunión.","realTimeTextBannerLinkLabel":"Más información","realTimeTextModalAriaLabel":"Activar modal RTT","realTimeTextModalTitle":"¿Activar RTT?","realTimeTextModalText":"Se activará el texto en tiempo real (RTT) para todos los participantes de la reunión.","realTimeTextConfirmButtonLabel":"Activar","realTimeTextCancelButtonLabel":"Cancelar","realTimeTextCloseModalButtonAriaLabel":"Cerrar modal RTT","captionsOnlyContainerTitle":"Subtítulos","realTimeTextOnlyContainerTitle":"Texto en tiempo real","captionsAndRealTimeTextContainerTitle":"Subtítulos y texto en tiempo real","expandButtonAriaLabel":"Expandir","minimizeButtonAriaLabel":"Contraer","transferPageTransferorText":"Transfiriendo...","transferPageTransferTargetText":"Conectando...","transferPageUnknownTransferorDisplayName":"Desconocido","transferPageUnknownTransferTargetDisplayName":"Desconocido","transferPageNoticeString":"Está siendo transferido","participantCouldNotBeReachedTitle":"El participante de destino no está disponible actualmente","participantCouldNotBeReachedMoreDetails":"Ponte en contacto con el participante cuando esté disponible","permissionToReachTargetParticipantNotAllowedTitle":"No se permite el permiso para llegar al participante objetivo","permissionToReachTargetParticipantNotAllowedMoreDetails":"Comprueba que el participante de destino está en el mismo inquilino.","unableToResolveTenantTitle":"No se puede resolver el id. de inquilino para el participante de destino","unableToResolveTenantMoreDetails":"Comprueba que el id. de participante se ha escrito correctamente.","participantIdIsMalformedTitle":"El id. de participante no tiene el formato correcto","participantIdIsMalformedMoreDetails":"Comprueba que el id. de participante tiene el formato correcto","moreButtonGalleryControlLabel":"Ver","moreButtonGalleryPositionToggleLabel":"Mover galería a la parte superior","moreButtonGallerySpeakerLayoutLabel":"Altavoz","moreButtonGalleryFloatingLocalLayoutLabel":"Dinámico","moreButtonGalleryDefaultLayoutLabel":"Vista galería","moreButtonGalleryFocusedContentLayoutLabel":"Centrarse en el contenido","moreButtonLargeGalleryDefaultLayoutLabel":"Galería de gran tamaño","moreButtonTogetherModeLayoutLabel":"Modo conferencia","capabilityChangedNotification":{"turnVideoOn":{"lostDueToMeetingOption":"La cámara se ha deshabilitado. Ya no puedes compartir video.","grantedDueToMeetingOption":"Tu cámara ha sido habilitada. Actívala si quieres compartir un video."},"unmuteMic":{"lostDueToMeetingOption":"El micrófono se ha deshabilitado. Ya no se puede reactivar el audio.","grantedDueToMeetingOption":"Se ha habilitado el micro. Reactiva el audio si quieres hablar."},"shareScreen":{"lostDueToRoleChangeToAttendee":"Tu rol ha sido cambiado. Algunas acciones, como compartir contenido, no estarán disponibles para ti.","grantedDueToRoleChangeToPresenter":"Eres moderador. Puedes compartir contenido y facilitar la reunión."},"hideAttendeeNames":{"hideAttendeeNameAttendee":"Tu nombre está oculto para otros asistentes. Los organizadores y moderadores pueden ver tu nombre real.","hideAttendeeNamePresenter":"Los nombres de los asistentes están ocultos. Solo los organizadores y moderadores pueden ver los nombres para proteger la privacidad de los asistentes."}},"surveyTitle":"Ayúdanos a mejorar","starSurveyHelperText":"¿Qué tal era la calidad de la llamada?","starSurveyOneStarText":"La calidad era mala.","starSurveyTwoStarText":"La calidad era deficiente.","starSurveyThreeStarText":"La calidad era buena.","starSurveyFourStarText":"La calidad era estupenda.","starSurveyFiveStarText":"La calidad ha sido excelente.","surveyConfirmButtonLabel":"Enviar comentarios","starRatingAriaLabel":"Selecciona {0} de {1} estrellas","surveySkipButtonLabel":"Omitir","tagsSurveyQuestion":"¿Qué podría haber sido mejor?","tagsSurveyTextFieldDefaultText":"Otro, especifica","tagsSurveyHelperText":"Marca los problemas que hayas experimentado","endOfSurveyText":"Gracias por tus comentarios.","surveyIssues":{"overallRating":{"callCannotJoin":"No pude unirme a la llamada","callCannotInvite":"No podía invitar a nadie a la llamada","hadToRejoin":"He tenido que volver a unirme a la llamada","callEndedUnexpectedly":"La llamada finalizó inesperadamente","otherIssues":"Estaba teniendo otros problemas con la llamada"},"audioRating":{"noLocalAudio":"Los otros participantes no podían oír nada","noRemoteAudio":"No pude oír nada","echo":"Oía eco en la llamada","audioNoise":"Se oía ruido en la llamada","lowVolume":"El volumen era bajo","audioStoppedUnexpectedly":"El audio se detuvo inesperadamente","distortedSpeech":"El audio se distorsionaba","audioInterruption":"Se interrumpió el audio","otherIssues":"Estaba teniendo otros problemas de audio en esta llamada"},"videoRating":{"noVideoReceived":"No pude ver ningún video","noVideoSent":"Los demás usuarios no me veían","lowQuality":"La calidad de vídeo era baja","freezes":"Video congelado","stoppedUnexpectedly":"El video se detuvo inesperadamente","darkVideoReceived":"Solo puedo ver pantallas oscuras cuando otros usuarios activan su cámara","audioVideoOutOfSync":"El audio y el video no estaban sincronizados","otherIssues":"Estaba teniendo otros problemas de video en esta llamada"},"screenshareRating":{"noContentLocal":"Otras personas no pudieron ver mi pantalla compartida","noContentRemote":"No pude ver la pantalla compartida de otras personas","cannotPresent":"No pude presentar mi pantalla","lowQuality":"La calidad de la pantalla compartida era baja","freezes":"Pantalla compartida congelada","stoppedUnexpectedly":"La pantalla compartida se detuvo inesperadamente","largeDelay":"La pantalla compartida tiene mucho retraso","otherIssues":"Estaba teniendo otros problemas de pantalla compartida en esta llamada"}},"surveyIssuesHeadingStrings":{"overallRating":"General","audioRating":"Audio","videoRating":"Video","screenshareRating":"Presentando"},"spotlightPrompt":{"startSpotlightHeading":"¿Poner en primer plano para todos?","startSpotlightText":"Resaltarás este video para todos en la reunión.","startSpotlightOnSelfText":"Resaltarás el video para todos los participantes de la reunión.","startSpotlightConfirmButtonLabel":"Poner en primer plano para todos","startSpotlightCancelButtonLabel":"Cancelar","stopSpotlightHeading":"¿Dejar de poner este video en primer plano?","stopSpotlightOnSelfHeading":"¿Salir del primer plano?","stopAllSpotlightHeading":"¿Quieres dejar de poner en primer plano todos los videos?","stopSpotlightText":"Este video dejará de estar resaltado para todos en la reunión.","stopSpotlightOnSelfText":"Tu video ya no resaltará para todos en la reunión.","stopAllSpotlightText":"El video ya no se resaltará para todos los participantes de la reunión.","stopSpotlightConfirmButtonLabel":"Dejar de poner en primer plano","stopSpotlightOnSelfConfirmButtonLabel":"Salir de primer plano","stopSpotlightCancelButtonLabel":"Cancelar","closeSpotlightPromptButtonLabel":"Cerrar"},"exitSpotlightButtonLabel":"Salir de primer plano","exitSpotlightButtonTooltip":"Salir de primer plano","leaveConfirmButtonLabel":"Salir","endCallConfirmButtonLabel":"Finalizar llamada","hangUpCancelButtonLabel":"Cancelar","leaveConfirmDialogTitle":"¿Abandonar la llamada?","leaveConfirmDialogContent":"¿Estás seguro de que deseas abandonar la llamada?","endCallConfirmDialogTitle":"¿Finalizar la llamada?","endCallConfirmDialogContent":"Finalizarás la llamada para todos los usuarios.","invalidMeetingIdentifier":"Id. de reunión o código de acceso no válidos","pinParticipantMenuLabel":"Anclar para mí","pinParticipantLimitReachedMenuLabel":"Pin (límite alcanzado)","unpinParticipantMenuLabel":"Desanclar","pinParticipantMenuItemAriaLabel":"Anclar para mí","unpinParticipantMenuItemAriaLabel":"Desanclar","muteAllMenuLabel":"Silenciar todo","muteAllDialogTitle":"¿Silenciar a todos?","muteAllDialogContent":"Esto silenciará a todos los participantes de la reunión, excepto a ti.","muteAllConfirmButtonLabel":"Silenciar todo","muteAllCancelButtonLabel":"Cancelar","joinBreakoutRoomButtonLabel":"Únete a la sala para sesión de subgrupo","returnFromBreakoutRoomButtonLabel":"Salir de la sala","leaveBreakoutRoomAndMeetingButtonLabel":"Salir de la reunión","breakoutRoomJoinedNotificationTitle":"Te has unido a la sala para sesión de subgrupo '{roomName}'","joinBreakoutRoomBannerTitle":"La sala para sesión de subgrupo '{roomName}' está abierta","joinBreakoutRoomBannerButtonLabel":"Unirse","returnFromBreakoutRoomBannerTitle":"Regresar a la reunión principal","returnFromBreakoutRoomBannerButtonLabel":"Volver a unirse","forbidAudioMenuLabel":"Deshabilitar micrófono","permitAudioMenuLabel":"Permitir micrófono","forbidOthersAudioDialogTitle":"¿Quieres deshabilitar el micrófono para los asistentes?","forbidOthersAudioDialogContent":"Los asistentes no podrán activar su audio. El organizador y los moderadores podrán permitir que la gente active su audio según sea necesario.","forbidOthersAudioConfirmButtonLabel":"Deshabilitar micrófonos","forbidOthersAudioCancelButtonLabel":"Cancelar","permitOthersAudioDialogTitle":"¿Permitir a los asistentes usar el micrófono?","permitOthersAudioDialogContent":"Todos los usuarios de la reunión podrán reactivar su audio.","permitOthersAudioConfirmButtonLabel":"Permitir micrófonos","permitOthersAudioCancelButtonLabel":"Cancelar","forbidOthersAudioMenuLabel":"Deshabilitar micrófono para los asistentes","permitOthersAudioMenuLabel":"Permitir el micrófono para los asistentes","forbidVideoMenuLabel":"Deshabilitar cámara","permitVideoMenuLabel":"Permitir cámara","forbidOthersVideoDialogTitle":"¿Quieres deshabilitar la cámara de los asistentes?","forbidOthersVideoDialogContent":"Los asistentes no podrán activar el video ellos mismos. El organizador y los moderadores pueden permitir que los usuarios enciendan la cámara según sea necesario.","forbidOthersVideoConfirmButtonLabel":"Deshabilitar cámaras","forbidOthersVideoCancelButtonLabel":"Cancelar","permitOthersVideoDialogTitle":"¿Permitir a los asistentes usar la cámara?","permitOthersVideoDialogContent":"Todos los participantes de la reunión podrán activar el video ellos mismos.","permitOthersVideoConfirmButtonLabel":"Permitir cámaras","permitOthersVideoCancelButtonLabel":"Cancelar","forbidOthersVideoMenuLabel":"Deshabilitar la cámara de los asistentes","permitOthersVideoMenuLabel":"Permitir la cámara para los asistentes"}`),chat:{chatListHeader:"En este chat",uploadAttachment:"Cargar datos adjuntos",uploadImageDataNotProvided:"No se proporcionaron datos de imagen.",uploadImageIsTooLarge:"La imagen es demasiado grande. Elige uno que sea inferior a {maxImageSize} MB.",uploadImageExtensionIsNotAllowed:"No se permite cargar una imagen .{imageExtension}.",uploadImageFailed:"No se puede cargar la imagen. Vuelve a intentarlo más tarde."},callWithChat:{chatButtonLabel:"Chat",chatButtonNewMessageNotificationLabel:"Nuevo mensaje",chatButtonTooltipClosedWithMessageCount:"Mostrar chat ({unreadMessagesCount} no leídos)",chatButtonTooltipClose:"Ocultar chat",chatButtonTooltipOpen:"Mostrar chat",chatPaneTitle:"Chat",copyInviteLinkButtonLabel:"Copiar vínculo de invitación",copyInviteLinkButtonActionedLabel:"Vínculo copiado",copyInviteLinkActionedAriaLabel:"Vínculo de invitación copiado",dismissSidePaneButtonLabel:"Cerrar",moreDrawerAudioDeviceMenuTitle:"Dispositivo de audio",moreDrawerButtonLabel:"Más opciones",moreDrawerButtonTooltip:"Más opciones",moreDrawerMicrophoneMenuTitle:"Micrófono",moreDrawerSpeakerMenuTitle:"Altavoz",moreDrawerCaptionsMenuTitle:"Subtítulos en directo",moreDrawerSpokenLanguageMenuTitle:"Idioma hablado",moreDrawerCaptionLanguageMenuTitle:"Idioma de subtítulos",moreDrawerGalleryOptionsMenuTitle:"Opciones de la Galería",peopleButtonLabel:"Contactos",selectedPeopleButtonLabel:"Se seleccionó el botón Contactos",peopleButtonTooltipOpen:"Mostrar participantes",peopleButtonTooltipClose:"Ocultar participantes",peopleButtonTooltipOpenAriaLabel:"Botón Contactos, Mostrar participantes",peopleButtonTooltipCloseAriaLabel:"Botón Contactos, Ocultar participantes",peoplePaneSubTitle:"En esta llamada",peoplePaneTitle:"Contactos",pictureInPictureTileAriaLabel:"Fuentes de video. Hacer clic para volver a la pantalla de la llamada.",removeMenuLabel:"Quitar",openDialpadButtonLabel:"Marcar número de teléfono",returnToCallButtonAriaDescription:"Volver a llamada",returnToCallButtonAriaLabel:"Volver",peoplePaneAddPeopleButtonLabel:"Agregar contactos",dialpadStartCallButtonLabel:"Llamar",dialpadModalTitle:"Marcar número de teléfono",dialpadModalAriaLabel:"Teclado de marcado",dialpadCloseModalButtonAriaLabel:"Cerrar teclado de marcado",openDtmfDialpadLabel:"Mostrar teclado de marcado",dtmfDialpadPlaceholderText:"Introducir número",breakoutRoomChatPaneTitle:"Chat de sala para sesión de subgrupo",chatContentSpinnerLabel:"Cargando chat"}})},vli={component:uQt,strings:Yh({call:JSON.parse('{"cameraLabel":"Kamera","noCamerasLabel":"Kameroita ei löytynyt","cameraPermissionDenied":"Selaimesi estää kameran käytön","cameraTurnedOff":"Kamerasi on pois käytöstä","chatButtonLabel":"Keskustelu","close":"Sulje","complianceBannerNowOnlyRecording":"Tallennetta ollaan luomassa vain tästä kokouksesta.","complianceBannerNowOnlyTranscription":"Transkriptiota ollaan luomassa vain tästä kokouksesta.","complianceBannerRecordingAndTranscriptionSaved":"Tallennusta ja transkriptiota tallennetaan.","complianceBannerRecordingAndTranscriptionStarted":"Tallentaminen ja litterointi on aloitettu.","complianceBannerRecordingAndTranscriptionStopped":"Tallentaminen ja litterointi on pysäytetty.","complianceBannerRecordingSaving":"Tallennetta tallennetaan.","complianceBannerRecordingStarted":"Tallentaminen on aloitettu.","complianceBannerRecordingStopped":"Tallentaminen on pysäytetty.","complianceBannerTranscriptionStarted":"Transkriptio on aloitettu.","complianceBannerTranscriptionConsent":"Liittymällä annat suostumuksesi kokouksen litteroimiseen.","complianceBannerTranscriptionSaving":"Transkriptiota tallennetaan.","complianceBannerTranscriptionStopped":"Transkriptio on pysäytetty.","configurationPageTitle":"Aloita puhelu","copyInviteLinkButtonLabel":"Kopioi kutsulinkki","copyInviteLinkButtonActionedLabel":"Linkki kopioitu","copyInviteLinkActionedAriaLabel":"Kutsulinkki kopioitu","defaultPlaceHolder":"Valitse vaihtoehto","dismissSidePaneButtonLabel":"Sulje","videoEffectsPaneTitle":"Tehosteet","videoEffectsPaneBackgroundSelectionTitle":"Tausta","videoEffectsPaneAriaLabel":"Videotehosteet-ruutu","configurationPageCameraIsLoadingLabel":"Videota ladataan...","configurationPageVideoEffectsButtonLabel":"Tehosteet","unableToStartVideoEffect":"Videotehosteen käyttäminen ei onnistu.","blurBackgroundEffectButtonLabel":"Sumenna","blurBackgroundTooltip":"Sumenna tausta","removeBackgroundEffectButtonLabel":"Ei mitään","removeBackgroundTooltip":"Poista tausta","cameraOffBackgroundEffectWarningText":"Kamera ei ole käytössä. Ota kamera käyttöön nähdäksesi videotehosteen.","failedToJoinCallDueToNoNetworkMoreDetails":"Puhelu katkaistiin verkko-ongelman vuoksi. Tarkista yhteys ja liity uudelleen.","failedToJoinCallDueToNoNetworkTitle":"Puhelu on katkennut","failedToJoinTeamsMeetingReasonAccessDeniedMoreDetails":"Sinulle ei myönnetty puheluun merkintää. Jos tämä oli virhe, liity puheluun uudelleen.","failedToJoinTeamsMeetingReasonAccessDeniedTitle":"Poistettu odotustilasta","learnMore":"Lisätietoja","leavingCallTitle":"Poistumassa...","leftCallMoreDetails":"Jos tämä oli virhe, liity puheluun uudelleen.","leftCallTitle":"Poistuit puhelusta","lobbyScreenConnectingToCallTitle":"Liitytään puheluun","lobbyScreenWaitingToBeAdmittedTitle":"Odotetaan hyväksymistä mukaan kokoukseen","microphonePermissionDenied":"Selaimesi estää mikrofonin käytön","microphoneToggleInLobbyNotAllowed":"Mykistämistoimintoa ei voi käyttää odotustilassa.","mutedMessage":"Mikrofonisi on mykistetty","networkReconnectMoreDetails":"Vaikuttaa siltä, että tapahtui virhe. Sinua yritetään saada takaisin mukaan puheluun.","networkReconnectTitle":"Odota","notInvitedToRoomDetails":"Et voi liittyä tähän huoneeseen, koska sinulla ei ole kutsua.","notInvitedToRoomTitle":"Ei kutsuttu huoneeseen","peopleButtonLabel":"Ihmiset","selectedPeopleButtonLabel":"Henkilöt-painike valittu","peoplePaneTitle":"Ihmiset","peoplePaneMoreButtonAriaLabel":"Lisää","peopleButtonTooltipOpen":"Näytä osallistujat","peopleButtonTooltipClose":"Piilota osallistujat","peoplePaneSubTitle":"Tässä puhelussa {numberOfPeople}","privacyPolicy":"Tietosuojakäytännöt","rejoinCallButtonLabel":"Liity uudelleen puheluun","removedFromCallMoreDetails":"Toinen osallistuja poisti sinut puhelusta.","removedFromCallTitle":"Sinut on poistettu","removeMenuLabel":"Poista","startSpotlightMenuLabel":"Lisää valokeilaan kaikille","addSpotlightMenuLabel":"Lisää valokeilaan","stopSpotlightMenuLabel":"Poista valokeilasta","stopSpotlightOnSelfMenuLabel":"Valokeila","spotlightLimitReachedMenuTitle":"Spotlight-raja saavutettu","stopAllSpotlightMenuLabel":"Poista kaikki valokeilat","returnToCallButtonAriaDescription":"Palaa puheluun","returnToCallButtonAriaLabel":"Takaisin","roomNotFoundDetails":"Annettua huonetunnusta ei löydy.","roomNotFoundTitle":"Tilaa ei löytynyt","roomNotValidDetails":"Tämä huone ei ole kelvollinen tällä hetkellä.","roomNotValidTitle":"Huone ei ole kelvollinen","inviteToRoomRemovedDetails":"Kutsusi liittyä tähän huoneeseen poistettiin.","inviteToRoomRemovedTitle":"Kutsu huoneeseen poistettu","soundLabel":"Ääni","noMicrophonesLabel":"Mikrofoneja ei löytynyt","noSpeakersLabel":"Kaiuttimia ei löytynyt","startCallButtonLabel":"Aloita puhelu","openDialpadButtonLabel":"Valitse puhelinnumero","peoplePaneAddPeopleButtonLabel":"Lisää ihmisiä","dialpadStartCallButtonLabel":"Soita","dialpadModalTitle":"Valitse puhelinnumero","dialpadModalAriaLabel":"Valintapaneeli","dialpadCloseModalButtonAriaLabel":"Sulje valintapaneeli","moreButtonCallingLabel":"Lisää","resumeCallButtonLabel":"Jatka","resumingCallButtonLabel":"Jatketaan...","resumeCallButtonAriaLabel":"Jatka puhelua","resumingCallButtonAriaLabel":"Jatka puhelua","holdScreenLabel":"Olet pidossa","openDtmfDialpadLabel":"Näytä valintapaneeli","dtmfDialpadPlaceholderText":"Syötä numero","outboundCallingNoticeString":"Soitetaan...","participantJoinedNoticeString":"{displayName} liittyi","twoParticipantJoinedNoticeString":"{displayName1} ja {displayName2} ovat liittyneet","threeParticipantJoinedNoticeString":"{displayName1}, {displayName2} ja {displayName3} ovat liittyneet","participantLeftNoticeString":"{displayName} poistui","twoParticipantLeftNoticeString":"{displayName1} ja {displayName2} ovat poistuneet","threeParticipantLeftNoticeString":"{displayName1}, {displayName2} ja {displayName3} ovat poistuneet","unnamedParticipantString":"nimetön osallistuja","manyUnnamedParticipantsJoined":"nimetön osallistuja ja {numOfParticipants} muuta osallistujaa liittyi","manyUnnamedParticipantsLeft":"nimetön osallistuja ja {numOfParticipants} muuta osallistujaa poistuivat","manyParticipantsJoined":"{displayName1}, {displayName2}, {displayName3} ja {numOfParticipants} muuta osallistujaa liittyivät","manyParticipantsLeft":"{displayName1}, {displayName2}, {displayName3} ja {numOfParticipants} muuta osallistujaa poistuivat","liveCaptionsLabel":"Live-tekstitykset","captionsSettingsLabel":"Tekstitysasetukset","startCaptionsButtonOnLabel":"Ota tekstitykset käyttöön","startCaptionsButtonOffLabel":"Poista tekstitykset käytöstä","startCaptionsButtonTooltipOnContent":"Poista tekstitykset käytöstä","startCaptionsButtonTooltipOffContent":"Ota tekstitykset käyttöön","captionsSettingsModalTitle":"Tekstitysasetukset","captionsSettingsSpokenLanguageDropdownLabel":"Puhuttu kieli","captionsSettingsCaptionLanguageDropdownLabel":"Tekstitysten kieli","captionsSettingsSpokenLanguageDropdownInfoText":"Kieli, jota kaikki tähän puheluun osallistuvat puhuvat.","captionsSettingsCaptionLanguageDropdownInfoText":"Tekstitys näkyy tällä kielellä.","captionsSettingsConfirmButtonLabel":"Vahvista","captionsSettingsCancelButtonLabel":"Peruuta","captionsSettingsModalAriaLabel":"Tekstitysasetus, modaalinen valintaikkuna","captionsSettingsCloseModalButtonAriaLabel":"Sulje tekstitysasetus","captionsBannerMoreButtonCallingLabel":"Tekstitysasetusten lisäasetukset","captionsBannerMoreButtonTooltip":"Lisää vaihtoehtoja","realTimeTextLabel":"Reaaliaikainen teksti (RTT)","startRealTimeTextLabel":"Ota reaaliaikainen kirjoitus käyttöön tässä puhelussa","disabledStartRealTimeTextLabel":"RTT on tällä hetkellä käytössä, sitä ei voi poistaa käytöstä","dismissModalAriaLabel":"Paikallinen kuva ja etäkuva, palaa puheluun painamalla Enter-näppäintä","callRejectedTitle":"Puhelua ei voitu soittaa","callRejectedMoreDetails":"Henkilö, jota yrität tavoittaa, ei ole tavoitettavissa. Yritä myöhemmin uudelleen.","callTimeoutTitle":"Puhelua ei voitu soittaa","callTimeoutDetails":"Henkilö, jota yrität tavoittaa, ei ole tavoitettavissa. Yritä myöhemmin uudelleen.","callTimeoutBotTitle":"Puhelua ei voitu soittaa","callTimeoutBotDetails":"Palvelu, jota yrität tavoittaa, ei ole käytettävissä. Yritä myöhemmin uudelleen.","dtmfDialerButtonLabel":"Valintapaneeli","dtmfDialerButtonTooltipOn":"Näytä valintapaneeli","dtmfDialerButtonTooltipOff":"Piilota valintapaneeli","dtmfDialerMoreButtonLabelOn":"Näytä valintapaneeli","dtmfDialerMoreButtonLabelOff":"Piilota valintapaneeli","phoneCallMoreButtonLabel":"Puhelu","spokenLanguageStrings":{"ar-ae":"arabia – Arabiemiirikunnat","ar-sa":"arabia – Saudi-Arabia","da-dk":"tanska","de-de":"saksa – Saksa","en-au":"englanti – Australia","en-ca":"englanti – Kanada","en-gb":"englanti – Yhdistynyt kuningaskunta","en-in":"englanti – Intia","en-nz":"englanti – Uusi-Seelanti","en-us":"englanti – Yhdysvallat","es-es":"espanja – Espanja (nykykieli)","es-mx":"espanja – Meksiko","fi-fi":"suomi","fr-ca":"ranska – Kanada","fr-fr":"ranska – Ranska","hi-in":"hindi","it-it":"italia – Italia","ja-jp":"japani","ko-kr":"korea","nb-no":"norja (bokmål)","nl-be":"hollanti – Belgia","nl-nl":"hollanti – Alankomaat","pl-pl":"puola","pt-br":"portugali – Brasilia","ru-ru":"venäjä","sv-se":"ruotsi","zh-cn":"kiina – Kiinan kansantasavalta","zh-hk":"kiina – Hongkong, erityishallintoalue","cs-cz":"tšekki","pt-pt":"portugali – Portugali","tr-tr":"turkki","vi-vn":"vietnam","th-th":"thai","he-il":"heprea","cy-gb":"kymri","uk-ua":"ukraina","el-gr":"kreikka","hu-hu":"unkari","ro-ro":"romania","sk-sk":"slovakki","zh-tw":"kiina – Taiwan"},"captionLanguageStrings":{"ar":"arabia","da":"tanska","de":"saksa","en":"englanti","es":"espanja","fi":"suomi","fr-ca":"ranska – Kanada","fr":"ranska – Ranska","hi":"hindi","it":"italia","ja":"japani","ko":"korea","nb":"norja (bokmål)","nl":"hollanti","pl":"puola","pt":"portugali – Brasilia","ru":"venäjä","sv":"ruotsi","zh-Hans":"kiina (yksinkertaistettu)","zh-Hant":"kiinalainen (perinteinen)","cs":"tšekki","pt-pt":"portugali – Portugali","tr":"turkki","vi":"vietnam","th":"thai","he":"heprea","cy":"kymri","uk":"ukraina","el":"kreikka","hu":"unkari","ro":"romania","sk":"slovakki"},"captionsBannerSpinnerText":"Aloitetaan tekstitystä...","realTimeTextInputBoxDefaultText":"Kirjoita viesti reaaliaikaisesti","realTimeTextInputErrorMessage":"Viestissä voi olla enintään 2 000 merkkiä","realTimeTextBannerTitle":"Reaaliaikainen kirjoitus","realTimeTextBannerContent":"RTT (reaaliaikainen teksti) on käytössä kaikille osallistujille koko kokouksen keston ajan.","realTimeTextBannerLinkLabel":"Lue lisää","realTimeTextModalAriaLabel":"Ota modaalinen RTT-valintaikkuna käyttöön","realTimeTextModalTitle":"Otetaanko RTT käyttöön?","realTimeTextModalText":"Reaaliaikainen teksti (RTT) otetaan käyttöön kaikille kokouksen osallistuville.","realTimeTextConfirmButtonLabel":"Ota käyttöön","realTimeTextCancelButtonLabel":"Peruuta","realTimeTextCloseModalButtonAriaLabel":"Sulje modaalinen RTT-valintaikkuna","captionsOnlyContainerTitle":"Tekstitykset","realTimeTextOnlyContainerTitle":"Reaaliaikainen teksti","captionsAndRealTimeTextContainerTitle":"Tekstitykset ja reaaliaikainen teksti","expandButtonAriaLabel":"Laajenna","minimizeButtonAriaLabel":"Kutista","transferPageTransferorText":"Siirretään...","transferPageTransferTargetText":"Yhdistetään...","transferPageUnknownTransferorDisplayName":"Tuntematon","transferPageUnknownTransferTargetDisplayName":"Tuntematon","transferPageNoticeString":"Sinut siirretään","participantCouldNotBeReachedTitle":"Kohdeosallistuja ei ole tällä hetkellä tavoitettavissa","participantCouldNotBeReachedMoreDetails":"Ota yhteyttä osallistujaan, kun hän on tavoitettavissa","permissionToReachTargetParticipantNotAllowedTitle":"Kohdeosallistujan tavoittamisoikeutta ei sallita","permissionToReachTargetParticipantNotAllowedMoreDetails":"Tarkista, että kohdeosallistuja on samassa vuokraajassa","unableToResolveTenantTitle":"Kohdeosallistujan vuokraajan tunnusta ei voi selvittää","unableToResolveTenantMoreDetails":"Tarkista, että osallistujan tunnus on kirjoitettu oikein","participantIdIsMalformedTitle":"Osallistujan tunnus ei ole oikeassa muodossa","participantIdIsMalformedMoreDetails":"Tarkista, että osallistujan tunnus on oikeassa muodossa","moreButtonGalleryControlLabel":"Näkymä","moreButtonGalleryPositionToggleLabel":"Siirrä valikoima ylimmäiseksi","moreButtonGallerySpeakerLayoutLabel":"Kaiutin","moreButtonGalleryFloatingLocalLayoutLabel":"Dynaaminen","moreButtonGalleryDefaultLayoutLabel":"Valikoimanäkymä","moreButtonGalleryFocusedContentLayoutLabel":"Huomio sisältöön","moreButtonLargeGalleryDefaultLayoutLabel":"Suuri galleria","moreButtonTogetherModeLayoutLabel":"Yhdessä-tila","capabilityChangedNotification":{"turnVideoOn":{"lostDueToMeetingOption":"Kamerasi on poistettu käytöstä. Et voi enää jakaa videota.","grantedDueToMeetingOption":"Kamera on otettu käyttöön. Ota se käyttöön, jos haluat jakaa videota."},"unmuteMic":{"lostDueToMeetingOption":"Mikrofonisi on poistettu käytöstä. Et voi enää poistaa mykistystä.","grantedDueToMeetingOption":"Mikrofoni on otettu käyttöön. Poista mykistys, jos haluat puhua."},"shareScreen":{"lostDueToRoleChangeToAttendee":"Roolisi on muuttunut. Jotkin toiminnot, kuten sisällön jakaminen, eivät ole käytettävissäsi.","grantedDueToRoleChangeToPresenter":"Olet esittäjä. Voit jakaa sisältöä ja johtaa kokousta."},"hideAttendeeNames":{"hideAttendeeNameAttendee":"Nimesi on piilotettu muilta osallistujilta. Järjestäjät ja esittäjät voivat nähdä oikean nimesi.","hideAttendeeNamePresenter":"Osallistujien nimet on piilotettu. Vain järjestäjät ja esittäjät voivat nähdä nimet osallistujien yksityisyyden suojaamiseksi."}},"surveyTitle":"Auta kehittämään tuotetta","starSurveyHelperText":"Millainen oli puhelun äänenlaatu?","starSurveyOneStarText":"Laatu oli huono.","starSurveyTwoStarText":"Laatu oli heikko.","starSurveyThreeStarText":"Laatu oli hyvä.","starSurveyFourStarText":"Laatu oli erinomainen.","starSurveyFiveStarText":"Laatu oli erinomainen.","surveyConfirmButtonLabel":"Lähetä palautetta","starRatingAriaLabel":"Valitse {0}/{1} tähteä","surveySkipButtonLabel":"Ohita","tagsSurveyQuestion":"Mikä olisi voinut olla paremmin?","tagsSurveyTextFieldDefaultText":"Muu, anna kuvaus","tagsSurveyHelperText":"Tarkista havaitsematsi ongelmat","endOfSurveyText":"Kiitos palautteestasi!","surveyIssues":{"overallRating":{"callCannotJoin":"En pystynyt liittymään puheluun","callCannotInvite":"En pystynyt kutsumaan muita mukaan puheluun","hadToRejoin":"Minun oli pakko liittyä puheluun uudelleen","callEndedUnexpectedly":"Puhelu päättyi odottamatta","otherIssues":"Minulla oli muita ongelmia puhelun kanssa"},"audioRating":{"noLocalAudio":"Toinen osapuoli ei kuullut mitään","noRemoteAudio":"En kuullut mitään","echo":"Kuulin kaikua puhelun aikana","audioNoise":"Kuulin taustamelua puhelun aikana","lowVolume":"Äänenvoimakkuus oli matala","audioStoppedUnexpectedly":"Ääni lakkasi odottamatta kuulumasta","distortedSpeech":"Äänessä esiintyi vääristymiä","audioInterruption":"Ääni keskeytyi","otherIssues":"Minulla oli puhelun aikana muita ääneen liittyviä ongelmia"},"videoRating":{"noVideoReceived":"En nähnyt videokuvaa","noVideoSent":"Muut eivät pystyneet näkemään minua","lowQuality":"Videokuva oli laadultaan heikkoa","freezes":"Video jumitti","stoppedUnexpectedly":"Videokuva pysähtyi odottamatta","darkVideoReceived":"Näen ainoastaan tummia näyttöjä, kun toiset ottavat kameransa käyttöön","audioVideoOutOfSync":"Ääni ja kuva olivat epätahdissa","otherIssues":"Minulla oli puhelun aikana muita videokuvaan liittyviä ongelmia"},"screenshareRating":{"noContentLocal":"Muut henkilöt eivät nähneet jakamaani näyttöä","noContentRemote":"En nähnyt muiden jakamaa näyttöä","cannotPresent":"En voinut esittää näyttöni sisältöä","lowQuality":"Näytön jakaminen oli laadultaan heikkoa","freezes":"Näytön jakaminen jumitti","stoppedUnexpectedly":"Näytön jakaminen keskeytyi odottamatta","largeDelay":"Näytön jakamisessa ilmenee suurta viivettä","otherIssues":"Minulla oli puhelun aikana muita näytön jakamiseen liittyviä ongelmia"}},"surveyIssuesHeadingStrings":{"overallRating":"Yleinen","audioRating":"Äänet","videoRating":"Video","screenshareRating":"Esitys käynnissä"},"spotlightPrompt":{"startSpotlightHeading":"Lisätäänkö valokeilaan kaikille?","startSpotlightText":"Korostat videon kaikille kokouksen osallistujille.","startSpotlightOnSelfText":"Korostat videosi kaikille kokouksen osallistujille.","startSpotlightConfirmButtonLabel":"Lisää valokeilaan kaikille","startSpotlightCancelButtonLabel":"Peruuta","stopSpotlightHeading":"Haluatko poistaa videon valokeilasta?","stopSpotlightOnSelfHeading":"Haluatko poistua valokeilasta?","stopAllSpotlightHeading":"Poistetaanko kaikki videot valokeilasta?","stopSpotlightText":"Videota ei enää korosteta kaikille kokouksen osallistujille.","stopSpotlightOnSelfText":"Videota ei enää korosteta kaikille kokouksen osallistujille.","stopAllSpotlightText":"Videoita ei enää korosteta kaikille kokouksen osallistujille.","stopSpotlightConfirmButtonLabel":"Poista valokeilasta","stopSpotlightOnSelfConfirmButtonLabel":"Valokeila","stopSpotlightCancelButtonLabel":"Peruuta","closeSpotlightPromptButtonLabel":"Sulje"},"exitSpotlightButtonLabel":"Poistu valokeilasta","exitSpotlightButtonTooltip":"Poistu valokeilasta","leaveConfirmButtonLabel":"Poistu","endCallConfirmButtonLabel":"Lopeta puhelu","hangUpCancelButtonLabel":"Peruuta","leaveConfirmDialogTitle":"Poistutaanko puhelusta?","leaveConfirmDialogContent":"Haluatko varmasti poistua puhelusta?","endCallConfirmDialogTitle":"Lopetetaanko puhelu?","endCallConfirmDialogContent":"Puhelu lopetetaan kaikkien osallistujien osalta.","invalidMeetingIdentifier":"Virheellinen kokoustunnus tai tunnuskoodi","pinParticipantMenuLabel":"Kiinnitä minulle","pinParticipantLimitReachedMenuLabel":"Kiinnitä (enimmäisraja saavutettu)","unpinParticipantMenuLabel":"Poista kiinnitys","pinParticipantMenuItemAriaLabel":"Kiinnitä minulle","unpinParticipantMenuItemAriaLabel":"Poista kiinnitys","muteAllMenuLabel":"Mykistä kaikki","muteAllDialogTitle":"Mykistetäänkö kaikki?","muteAllDialogContent":"Tämä toiminto mykistää kaikki muut kokouksen osallistujat paitsi sinut.","muteAllConfirmButtonLabel":"Mykistä kaikki","muteAllCancelButtonLabel":"Peruuta","joinBreakoutRoomButtonLabel":"Liity pienryhmätilaan","returnFromBreakoutRoomButtonLabel":"Poistu kokoustilasta","leaveBreakoutRoomAndMeetingButtonLabel":"Poistu kokouksesta","breakoutRoomJoinedNotificationTitle":"Olet liittynyt pienryhmätilaan {roomName}","joinBreakoutRoomBannerTitle":"Pienryhmätila {roomName} on avoinna","joinBreakoutRoomBannerButtonLabel":"Liity","returnFromBreakoutRoomBannerTitle":"Palaa pääkokoukseen","returnFromBreakoutRoomBannerButtonLabel":"Liity uudelleen","forbidAudioMenuLabel":"Poista mikrofoni käytöstä","permitAudioMenuLabel":"Salli mikrofoni","forbidOthersAudioDialogTitle":"Poistetaanko mikrofoni osallistujien käytöstä?","forbidOthersAudioDialogContent":"Osallistujat eivät voi poistaa omaa mykistystään. Järjestäjä ja esittäjät voivat sallia muiden mykistyksen poistamisen.","forbidOthersAudioConfirmButtonLabel":"Poista mikrofonit käytöstä","forbidOthersAudioCancelButtonLabel":"Peruuta","permitOthersAudioDialogTitle":"Sallitaanko mikrofoni osallistujille?","permitOthersAudioDialogContent":"Kaikki kokoukseen osallistuvat voivat poistaa mykistyksensä.","permitOthersAudioConfirmButtonLabel":"Salli mikrofonit","permitOthersAudioCancelButtonLabel":"Peruuta","forbidOthersAudioMenuLabel":"Poista mikrofoni osallistujien käytöstä","permitOthersAudioMenuLabel":"Salli mikrofoni osallistujille","forbidVideoMenuLabel":"Poista kamera käytöstä","permitVideoMenuLabel":"Salli kamera","forbidOthersVideoDialogTitle":"Poistetaanko kamera osallistujien käytöstä?","forbidOthersVideoDialogContent":"Osallistujat eivät voi ottaa itse videota käyttöön. Järjestäjä ja esittäjät voivat antaa käyttäjien ottaa kameran käyttöön tarvittaessa.","forbidOthersVideoConfirmButtonLabel":"Poista kamerat käytöstä","forbidOthersVideoCancelButtonLabel":"Peruuta","permitOthersVideoDialogTitle":"Sallitaanko kamera osallistujille?","permitOthersVideoDialogContent":"Kaikki kokouksen osallistujat voivat itse ottaa videon käyttöön.","permitOthersVideoConfirmButtonLabel":"Salli kamerat","permitOthersVideoCancelButtonLabel":"Peruuta","forbidOthersVideoMenuLabel":"Poista kamera osallistujien käytöstä","permitOthersVideoMenuLabel":"Salli kamera osallistujille"}'),chat:{chatListHeader:"Tässä keskustelussa",uploadAttachment:"Lataa liite",uploadImageDataNotProvided:"Kuvatietoja ei ole annettu.",uploadImageIsTooLarge:"Kuva on liian suuri. Valitse sellainen, jonka koko on alle {maxImageSize} Mt.",uploadImageExtensionIsNotAllowed:".{imageExtension}-kuvan lataamista ei sallita.",uploadImageFailed:"Kuvaa ei voi ladata palvelimeen. Yritä myöhemmin uudelleen."},callWithChat:{chatButtonLabel:"Keskustelu",chatButtonNewMessageNotificationLabel:"Uusi viesti",chatButtonTooltipClosedWithMessageCount:"Näytä keskustelu ({unreadMessagesCount} lukematonta viestiä)",chatButtonTooltipClose:"Piilota keskustelu",chatButtonTooltipOpen:"Näytä keskustelu",chatPaneTitle:"Keskustelu",copyInviteLinkButtonLabel:"Kopioi kutsulinkki",copyInviteLinkButtonActionedLabel:"Linkki kopioitu",copyInviteLinkActionedAriaLabel:"Kutsulinkki kopioitu",dismissSidePaneButtonLabel:"Sulje",moreDrawerAudioDeviceMenuTitle:"Äänilaite",moreDrawerButtonLabel:"Lisää vaihtoehtoja",moreDrawerButtonTooltip:"Lisää vaihtoehtoja",moreDrawerMicrophoneMenuTitle:"Mikrofoni",moreDrawerSpeakerMenuTitle:"Kaiutin",moreDrawerCaptionsMenuTitle:"Live-tekstitykset",moreDrawerSpokenLanguageMenuTitle:"Puhuttu kieli",moreDrawerCaptionLanguageMenuTitle:"Tekstityksen kieli",moreDrawerGalleryOptionsMenuTitle:"Valikoiman asetukset",peopleButtonLabel:"Ihmiset",selectedPeopleButtonLabel:"Henkilöt-painike valittu",peopleButtonTooltipOpen:"Näytä osallistujat",peopleButtonTooltipClose:"Piilota osallistujat",peopleButtonTooltipOpenAriaLabel:"Henkilöt-painike, Näytä osallistujat",peopleButtonTooltipCloseAriaLabel:"Henkilöt-painike, Piilota osallistujat",peoplePaneSubTitle:"Tässä puhelussa",peoplePaneTitle:"Ihmiset",pictureInPictureTileAriaLabel:"Videosyötteet. Palaa puhelunäyttöön napsauttamalla.",removeMenuLabel:"Poista",openDialpadButtonLabel:"Valitse puhelinnumero",returnToCallButtonAriaDescription:"Palaa puheluun",returnToCallButtonAriaLabel:"Takaisin",peoplePaneAddPeopleButtonLabel:"Lisää ihmisiä",dialpadStartCallButtonLabel:"Soita",dialpadModalTitle:"Valitse puhelinnumero",dialpadModalAriaLabel:"Valintapaneeli",dialpadCloseModalButtonAriaLabel:"Sulje valintapaneeli",openDtmfDialpadLabel:"Näytä valintapaneeli",dtmfDialpadPlaceholderText:"Syötä numero",breakoutRoomChatPaneTitle:"Pienryhmätilan keskustelu",chatContentSpinnerLabel:"Ladataan keskustelua"}})},yli={component:hQt,strings:Yh({call:JSON.parse(`{"cameraLabel":"Appareil photo","noCamerasLabel":"Aucune caméra trouvée","cameraPermissionDenied":"Votre navigateur bloque l’accès à votre caméra","cameraTurnedOff":"Votre caméra est désactivée","chatButtonLabel":"Conversation","close":"Fermer","complianceBannerNowOnlyRecording":"Vous n’enregistrez désormais que cette réunion.","complianceBannerNowOnlyTranscription":"À présent, vous ne transcrivez que cette réunion.","complianceBannerRecordingAndTranscriptionSaved":"Sauvegarde en cours de l’enregistrement et de la transcription.","complianceBannerRecordingAndTranscriptionStarted":"Démarrage de l’enregistrement et de la transcription.","complianceBannerRecordingAndTranscriptionStopped":"L’enregistrement et la transcription ont pris fin.","complianceBannerRecordingSaving":"Sauvegarde en cours de l'enregistrement.","complianceBannerRecordingStarted":"L’enregistrement a démarré.","complianceBannerRecordingStopped":"L’enregistrement a pris fin.","complianceBannerTranscriptionStarted":"Démarrage de la transcription.","complianceBannerTranscriptionConsent":"En participant, vous autorisez la transcription de cette réunion.","complianceBannerTranscriptionSaving":"Sauvegarde en cours de la transcription.","complianceBannerTranscriptionStopped":"La transcription a pris fin.","configurationPageTitle":"Lancer un appel","copyInviteLinkButtonLabel":"Copier le lien d'invitation","copyInviteLinkButtonActionedLabel":"Lien copié","copyInviteLinkActionedAriaLabel":"Le lien d’invitation a été copié.","defaultPlaceHolder":"Sélectionnez une option","dismissSidePaneButtonLabel":"Fermer","videoEffectsPaneTitle":"Effets","videoEffectsPaneBackgroundSelectionTitle":"Arrière-plan","videoEffectsPaneAriaLabel":"Volet Effets vidéo","configurationPageCameraIsLoadingLabel":"Chargement de la vidéo...","configurationPageVideoEffectsButtonLabel":"Effets","unableToStartVideoEffect":"Impossible d’appliquer l’effet vidéo.","blurBackgroundEffectButtonLabel":"Flouter","blurBackgroundTooltip":"Flouter l'arrière-plan","removeBackgroundEffectButtonLabel":"Aucun","removeBackgroundTooltip":"Supprimer l’arrière-plan","cameraOffBackgroundEffectWarningText":"Votre caméra est désactivée. Activez la caméra pour voir l’effet vidéo.","failedToJoinCallDueToNoNetworkMoreDetails":"L’appel a été déconnecté en raison d’un problème réseau. Vérifiez votre connexion et rejoignez-la à nouveau.","failedToJoinCallDueToNoNetworkTitle":"Appel déconnecté","failedToJoinTeamsMeetingReasonAccessDeniedMoreDetails":"Vous n’avez pas reçu d’entrée dans l’appel. S’il s’agissait d’une erreur, rejoignez à nouveau l’appel.","failedToJoinTeamsMeetingReasonAccessDeniedTitle":"Rejeté de la salle d’attente","learnMore":"En savoir plus","leavingCallTitle":"Quitter...","leftCallMoreDetails":"S’il s’agissait d’une erreur, rejoignez à nouveau l’appel.","leftCallTitle":"Vous avez quitté l’appel.","lobbyScreenConnectingToCallTitle":"Connexion à l'appel","lobbyScreenWaitingToBeAdmittedTitle":"En attente d’admission","microphonePermissionDenied":"Votre navigateur bloque l’accès à votre micro","microphoneToggleInLobbyNotAllowed":"Impossible de désactiver ou d’activer le son dans la salle d’attente.","mutedMessage":"Le son de votre micro est désactivé.","networkReconnectMoreDetails":"On dirait qu'une erreur est survenue. Nous tentons de vous reconnecter à l’appel.","networkReconnectTitle":"Patience","notInvitedToRoomDetails":"Vous ne pouvez pas rejoindre cette salle, car vous n’avez pas d’invitation.","notInvitedToRoomTitle":"N’a pas été invité à la salle","peopleButtonLabel":"Personnes","selectedPeopleButtonLabel":"Bouton Contacts sélectionné","peoplePaneTitle":"Personnes","peoplePaneMoreButtonAriaLabel":"Autres","peopleButtonTooltipOpen":"Afficher les participants","peopleButtonTooltipClose":"Masquer les participants","peoplePaneSubTitle":"Dans cet appel {numberOfPeople}","privacyPolicy":"Politique de confidentialité","rejoinCallButtonLabel":"Rejoindre l’appel à nouveau.","removedFromCallMoreDetails":"Un autre participant vous a supprimé de l’appel.","removedFromCallTitle":"Vous avez été supprimé.","removeMenuLabel":"Supprimer","startSpotlightMenuLabel":"Mettre en évidence pour tout le monde","addSpotlightMenuLabel":"Ajouter la mise en évidence","stopSpotlightMenuLabel":"Arrêter la mise en évidence","stopSpotlightOnSelfMenuLabel":"Quitter la mise en évidence","spotlightLimitReachedMenuTitle":"Limite Spotlight atteinte","stopAllSpotlightMenuLabel":"Arrêtez tous les projecteurs","returnToCallButtonAriaDescription":"Revenir à l’appel","returnToCallButtonAriaLabel":"Précédent","roomNotFoundDetails":"L’ID de la salle fourni est introuvable.","roomNotFoundTitle":"Salle introuvable","roomNotValidDetails":"Cette salle n’est pas valide pour l’instant.","roomNotValidTitle":"Salle non valide","inviteToRoomRemovedDetails":"Votre invitation à rejoindre cette salle a été supprimée.","inviteToRoomRemovedTitle":"Invitation à la salle supprimée","soundLabel":"Son","noMicrophonesLabel":"Aucun microphone trouvé","noSpeakersLabel":"Aucun haut-parleur trouvé","startCallButtonLabel":"Lancer l'appel","openDialpadButtonLabel":"Composer le numéro de téléphone","peoplePaneAddPeopleButtonLabel":"Ajouter des personnes","dialpadStartCallButtonLabel":"Appeler","dialpadModalTitle":"Composer le numéro de téléphone","dialpadModalAriaLabel":"Clavier","dialpadCloseModalButtonAriaLabel":"Fermer le clavier","moreButtonCallingLabel":"Plus","resumeCallButtonLabel":"Reprendre","resumingCallButtonLabel":"Reprise...","resumeCallButtonAriaLabel":"Reprendre l’appel","resumingCallButtonAriaLabel":"Reprendre l’appel","holdScreenLabel":"Vous avez été mis(e) en attente.","openDtmfDialpadLabel":"Afficher le clavier","dtmfDialpadPlaceholderText":"Saisir un numéro","outboundCallingNoticeString":"Appel en cours...","participantJoinedNoticeString":"{displayName} a rejoint","twoParticipantJoinedNoticeString":"{displayName1} et {displayName2} ont rejoint","threeParticipantJoinedNoticeString":"{displayName1}, {displayName2} et {displayName3} ont rejoint","participantLeftNoticeString":"{displayName} a quitté","twoParticipantLeftNoticeString":"{displayName1} et {displayName2} sont partis","threeParticipantLeftNoticeString":"{displayName1}, {displayName2} et {displayName3} ont quitté","unnamedParticipantString":"participant sans nom","manyUnnamedParticipantsJoined":"participant sans nom et {numOfParticipants} autres participants ont rejoint","manyUnnamedParticipantsLeft":"participant sans nom et {numOfParticipants} autres participants ont quitté","manyParticipantsJoined":"{displayName1}, {displayName2}, {displayName3} et {numOfParticipants} autres participants ont rejoint","manyParticipantsLeft":"{displayName1}, {displayName2}, {displayName3} et {numOfParticipants} autres participants restants","liveCaptionsLabel":"Sous-titres en direct","captionsSettingsLabel":"Paramètres de sous-titres","startCaptionsButtonOnLabel":"Activer les sous-titres","startCaptionsButtonOffLabel":"Désactiver les sous-titres","startCaptionsButtonTooltipOnContent":"Désactiver les sous-titres","startCaptionsButtonTooltipOffContent":"Activer les sous-titres","captionsSettingsModalTitle":"Paramètres des sous-titres","captionsSettingsSpokenLanguageDropdownLabel":"Langue parlée","captionsSettingsCaptionLanguageDropdownLabel":"Langue des sous-titres","captionsSettingsSpokenLanguageDropdownInfoText":"Langue parlée par tous les participants à cet appel.","captionsSettingsCaptionLanguageDropdownInfoText":"Les sous-titres apparaîtront dans cette langue.","captionsSettingsConfirmButtonLabel":"Confirmer","captionsSettingsCancelButtonLabel":"Annuler","captionsSettingsModalAriaLabel":"Paramétrage des légendes Modal","captionsSettingsCloseModalButtonAriaLabel":"Paramètres de fermeture des sous-titres","captionsBannerMoreButtonCallingLabel":"Autres options de paramètres de sous-titres","captionsBannerMoreButtonTooltip":"Autres options","realTimeTextLabel":"Texte en temps réel (RTT)","startRealTimeTextLabel":"Activer RTT pour cet appel","disabledStartRealTimeTextLabel":"RTT est actuellement activé, il ne peut pas être désactivé","dismissModalAriaLabel":"Image et image locales et distantes, appuyez sur entrée pour revenir à l'appel","callRejectedTitle":"Nous n’avons pas pu effectuer l’appel","callRejectedMoreDetails":"La personne que vous essayez de rejoindre n’est pas disponible. Veuillez réessayer plus tard.","callTimeoutTitle":"Nous n’avons pas pu effectuer l’appel","callTimeoutDetails":"La personne que vous essayez de rejoindre n’est pas disponible. Veuillez réessayer plus tard.","callTimeoutBotTitle":"Nous n’avons pas pu effectuer l’appel","callTimeoutBotDetails":"Le service que vous essayez d’atteindre n’est pas disponible. Veuillez réessayer plus tard.","dtmfDialerButtonLabel":"Clavier","dtmfDialerButtonTooltipOn":"Afficher le clavier","dtmfDialerButtonTooltipOff":"Masquez le clavier","dtmfDialerMoreButtonLabelOn":"Afficher le clavier","dtmfDialerMoreButtonLabelOff":"Masquez le clavier","phoneCallMoreButtonLabel":"Appel téléphonique","spokenLanguageStrings":{"ar-ae":"Arabe – E.A.U.","ar-sa":"Arabe – Arabie saoudite","da-dk":"Danois","de-de":"Allemand – Allemagne","en-au":"Anglais – Australie","en-ca":"Anglais – Canada","en-gb":"Anglais – Royaume-Uni","en-in":"Anglais – Inde","en-nz":"Anglais – Nouvelle-Zélande","en-us":"Anglais – États-Unis","es-es":"Espagnol – Espagne (tri moderne)","es-mx":"Espagnol – Mexique","fi-fi":"Finnois","fr-ca":"Français – Canada","fr-fr":"Français – France","hi-in":"Hindi","it-it":"Italien – Italie","ja-jp":"Japonais","ko-kr":"Coréen","nb-no":"Norvégien (Bokmål)","nl-be":"Néerlandais – Belgique","nl-nl":"Néerlandais – Pays-Bas","pl-pl":"Polonais","pt-br":"Portugais – Brésil","ru-ru":"Russe","sv-se":"Suédois","zh-cn":"Chinois – République populaire de Chine","zh-hk":"Chinois – Hong Kong SAR","cs-cz":"Tchèque","pt-pt":"Portugais – Portugal","tr-tr":"Turc","vi-vn":"Vietnamien","th-th":"Thaï","he-il":"Hébreu","cy-gb":"Gallois","uk-ua":"Ukrainien","el-gr":"Grec","hu-hu":"Hongrois","ro-ro":"Roumain","sk-sk":"Slovaque","zh-tw":"Chinois – Taiwan"},"captionLanguageStrings":{"ar":"Arabe","da":"Danois","de":"Allemand","en":"Anglais","es":"Espagnol","fi":"Finnois","fr-ca":"Français – Canada","fr":"Français – France","hi":"Hindi","it":"Italien","ja":"Japonais","ko":"Coréen","nb":"Norvégien (Bokmål)","nl":"Néerlandais","pl":"Polonais","pt":"Portugais – Brésil","ru":"Russe","sv":"Suédois","zh-Hans":"Chinois (simplifié)","zh-Hant":"Chinois (traditionnel)","cs":"Tchèque","pt-pt":"Portugais – Portugal","tr":"Turc","vi":"Vietnamien","th":"Thaï","he":"Hébreu","cy":"Gallois","uk":"Ukrainien","el":"Grec","hu":"Hongrois","ro":"Roumain","sk":"Slovaque"},"captionsBannerSpinnerText":"Démarrage des sous-titres...","realTimeTextInputBoxDefaultText":"Tapez votre message en temps réel","realTimeTextInputErrorMessage":"Le message ne peut pas dépasser 2 000 caractères","realTimeTextBannerTitle":"RTT","realTimeTextBannerContent":"RTT (texte en temps réel) est activé pour tous les participants pendant toute la durée de la réunion.","realTimeTextBannerLinkLabel":"En savoir plus","realTimeTextModalAriaLabel":"Activer la boîte de dialogue modale RTT","realTimeTextModalTitle":"Activer la RTT ?","realTimeTextModalText":"Le texte en temps réel (RTT) sera activé pour tous les participants à la réunion.","realTimeTextConfirmButtonLabel":"Activer","realTimeTextCancelButtonLabel":"Annuler","realTimeTextCloseModalButtonAriaLabel":"Fermer la boîte de dialogue modale RTT","captionsOnlyContainerTitle":"Sous-titres","realTimeTextOnlyContainerTitle":"Texte en temps réel","captionsAndRealTimeTextContainerTitle":"Légendes et texte en temps réel","expandButtonAriaLabel":"Développer","minimizeButtonAriaLabel":"Réduire","transferPageTransferorText":"Transfert en cours...","transferPageTransferTargetText":"Connexion en cours...","transferPageUnknownTransferorDisplayName":"Inconnu","transferPageUnknownTransferTargetDisplayName":"Inconnu","transferPageNoticeString":"Vous êtes en cours de transfert","participantCouldNotBeReachedTitle":"Le participant cible n’est pas disponible actuellement","participantCouldNotBeReachedMoreDetails":"Contactez le participant lorsqu’il est disponible","permissionToReachTargetParticipantNotAllowedTitle":"L’autorisation d’atteindre le participant cible n’est pas autorisée","permissionToReachTargetParticipantNotAllowedMoreDetails":"Veuillez case activée que le participant cible se trouve dans le même client","unableToResolveTenantTitle":"Impossible de résoudre l’ID de locataire pour le participant cible","unableToResolveTenantMoreDetails":"Veuillez case activée l’ID de participant est entré correctement","participantIdIsMalformedTitle":"Le format de l’ID de participant n’est pas correct","participantIdIsMalformedMoreDetails":"Veuillez case activée que le format de l’ID de participant est correct","moreButtonGalleryControlLabel":"Afficher","moreButtonGalleryPositionToggleLabel":"Déplacer la galerie vers le haut","moreButtonGallerySpeakerLayoutLabel":"Haut-parleur","moreButtonGalleryFloatingLocalLayoutLabel":"Dynamique","moreButtonGalleryDefaultLayoutLabel":"Vue Galerie","moreButtonGalleryFocusedContentLayoutLabel":"Focalisation sur le contenu","moreButtonLargeGalleryDefaultLayoutLabel":"Grande galerie","moreButtonTogetherModeLayoutLabel":"Mode ensemble","capabilityChangedNotification":{"turnVideoOn":{"lostDueToMeetingOption":"Votre caméra a été désactivée. Vous ne pouvez plus partager de vidéo.","grantedDueToMeetingOption":"Votre caméra a été activée. Activez-la si vous souhaitez partager la vidéo."},"unmuteMic":{"lostDueToMeetingOption":"Votre micro a été désactivé. Vous ne pouvez plus activer le son.","grantedDueToMeetingOption":"Votre microphone a été activé. Activez le microphone pour parler."},"shareScreen":{"lostDueToRoleChangeToAttendee":"Votre rôle a été modifié. Certaines actions, telles que le partage de contenu, ne seront pas disponibles pour vous.","grantedDueToRoleChangeToPresenter":"Vous êtes présentateur. Vous pouvez partager du contenu et organiser la réunion."},"hideAttendeeNames":{"hideAttendeeNameAttendee":"Votre nom est masqué pour les autres participants. Les organisateurs et les présentateurs peuvent voir votre vrai nom.","hideAttendeeNamePresenter":"Les noms des participants sont masqués. Afin de protéger la vie privée des participants, seuls les organisateurs et les présentateurs peuvent visualiser les noms."}},"surveyTitle":"Aidez-nous à nous améliorer","starSurveyHelperText":"Quelle a été la qualité globale de cet appel ?","starSurveyOneStarText":"La qualité était mauvaise.","starSurveyTwoStarText":"La qualité était mauvaise.","starSurveyThreeStarText":"La qualité était bonne.","starSurveyFourStarText":"La qualité était excellente.","starSurveyFiveStarText":"La qualité était excellente.","surveyConfirmButtonLabel":"Envoyer des commentaires","starRatingAriaLabel":"Sélectionner {0} étoiles sur {1}","surveySkipButtonLabel":"Ignorer","tagsSurveyQuestion":"Que pouvons-nous améliorer ?","tagsSurveyTextFieldDefaultText":"Autre, veuillez préciser","tagsSurveyHelperText":"Cochez les problèmes que vous avez rencontrés","endOfSurveyText":"Merci pour vos commentaires !","surveyIssues":{"overallRating":{"callCannotJoin":"Je n’ai pas pu rejoindre l’appel","callCannotInvite":"Je n’ai pas pu inviter d’autres personnes à participer à l’appel","hadToRejoin":"J’ai dû rejoindre l’appel","callEndedUnexpectedly":"L’appel s’est terminé pour moi de manière inattendue","otherIssues":"J’avais d’autres problèmes avec l’appel"},"audioRating":{"noLocalAudio":"Mon interlocuteur n'entendait aucun son","noRemoteAudio":"Je n'entendais aucun son","echo":"J’ai entendu des échos lors de l’appel","audioNoise":"Il y avait des bruits parasites","lowVolume":"Le volume était faible","audioStoppedUnexpectedly":"L’audio s’est arrêté de manière inattendue","distortedSpeech":"L’audio a été altéré","audioInterruption":"L’audio a été interrompu","otherIssues":"J’ai rencontré d’autres problèmes audio pendant cet appel"},"videoRating":{"noVideoReceived":"La vidéo ne s'affichait pas sur mon écran","noVideoSent":"Les autres personnes n’ont pas pu me voir","lowQuality":"La qualité de la vidéo était faible","freezes":"Vidéo figée","stoppedUnexpectedly":"La vidéo s'est arrêtée de manière inattendue","darkVideoReceived":"Je ne vois que des écrans sombres lorsque d'autres personnes allument leur caméra","audioVideoOutOfSync":"L’audio et la vidéo n’étaient pas synchronisés","otherIssues":"J’ai rencontré d’autres problèmes vidéo pendant cet appel"},"screenshareRating":{"noContentLocal":"Les autres personnes n’ont pas pu voir mon partage d’écran","noContentRemote":"Je n’ai pas pu voir le partage d’écran d’autres personnes","cannotPresent":"Je n’ai pas pu présenter mon écran","lowQuality":"La qualité du partage d’écran était faible","freezes":"Partage d’écran figé","stoppedUnexpectedly":"Le partage d’écran s’est arrêté de manière inattendue","largeDelay":"Le partage d’écran a un retard important","otherIssues":"Je rencontre d’autres problèmes de partage d’écran dans cet appel"}},"surveyIssuesHeadingStrings":{"overallRating":"Globale","audioRating":"Audio","videoRating":"Vidéo","screenshareRating":"En présentation"},"spotlightPrompt":{"startSpotlightHeading":"Mettre en évidence pour tout le monde ?","startSpotlightText":"Votre vidéo ne sera plus mise en surbrillance pour tous les participants à la réunion.","startSpotlightOnSelfText":"Vous mettez en surbrillance votre vidéo pour tous les participants à la réunion.","startSpotlightConfirmButtonLabel":"Mettre en évidence pour tout le monde","startSpotlightCancelButtonLabel":"Annuler","stopSpotlightHeading":"Arrêter la mise en évidence de cette vidéo ?","stopSpotlightOnSelfHeading":"Quitter la mise en évidence ?","stopAllSpotlightHeading":"Voulez-vous arrêter de mettre en évidence toutes les vidéos ?","stopSpotlightText":"Cette vidéo ne sera plus mise en évidence pour tous les participants à la réunion.","stopSpotlightOnSelfText":"Votre vidéo ne sera plus mise en surbrillance pour tous les participants à la réunion.","stopAllSpotlightText":"Les vidéo n’apparaissent plus en surbrillance pour tous les participants à la réunion.","stopSpotlightConfirmButtonLabel":"Arrêter la mise en évidence","stopSpotlightOnSelfConfirmButtonLabel":"Quitter la mise en évidence","stopSpotlightCancelButtonLabel":"Annuler","closeSpotlightPromptButtonLabel":"Fermez"},"exitSpotlightButtonLabel":"Quitter la mise en évidence","exitSpotlightButtonTooltip":"Quitter la mise en évidence","leaveConfirmButtonLabel":"Partir","endCallConfirmButtonLabel":"Fin d’appel","hangUpCancelButtonLabel":"Annuler","leaveConfirmDialogTitle":"Quitter l'appel ?","leaveConfirmDialogContent":"Voulez-vous vraiment quitter l’appel ?","endCallConfirmDialogTitle":"Mettre fin à l'appel ?","endCallConfirmDialogContent":"Vous mettrez fin à l'appel pour tout le monde.","invalidMeetingIdentifier":"ID ou code secret de réunion non valide","pinParticipantMenuLabel":"Épingler pour moi","pinParticipantLimitReachedMenuLabel":"Épingler (limite atteinte)","unpinParticipantMenuLabel":"Désépingler","pinParticipantMenuItemAriaLabel":"Épingler pour moi","unpinParticipantMenuItemAriaLabel":"Désépingler","muteAllMenuLabel":"Désactiver le son de tous","muteAllDialogTitle":"Désactiver le son de tout le monde ?","muteAllDialogContent":"Cette opération va désactiver le son de tous les participants à la réunion, sauf vous.","muteAllConfirmButtonLabel":"Désactiver le son de tous","muteAllCancelButtonLabel":"Annuler","joinBreakoutRoomButtonLabel":"Rejoindre la salle de réunion","returnFromBreakoutRoomButtonLabel":"Quitter la salle","leaveBreakoutRoomAndMeetingButtonLabel":"Quitter la réunion","breakoutRoomJoinedNotificationTitle":"Vous avez rejoint la salle pour petit groupe « {roomName} »","joinBreakoutRoomBannerTitle":"La salle pour petit groupe « {roomName} » est ouverte","joinBreakoutRoomBannerButtonLabel":"Joindre","returnFromBreakoutRoomBannerTitle":"Revenir à la réunion principale","returnFromBreakoutRoomBannerButtonLabel":"Rejoindre","forbidAudioMenuLabel":"Désactiver le micro","permitAudioMenuLabel":"Autoriser le micro","forbidOthersAudioDialogTitle":"Désactiver le micro des participants ?","forbidOthersAudioDialogContent":"Les participants ne pourront pas activer leur micro. L’organisateur et les présentateurs peuvent permettre aux utilisateurs de désactiver le son selon les besoins.","forbidOthersAudioConfirmButtonLabel":"Désactiver les micros","forbidOthersAudioCancelButtonLabel":"Annuler","permitOthersAudioDialogTitle":"Autoriser le micro pour des participants ?","permitOthersAudioDialogContent":"Chaque participant à la réunion sera en mesure d’activer le son.","permitOthersAudioConfirmButtonLabel":"Autoriser les micros","permitOthersAudioCancelButtonLabel":"Annuler","forbidOthersAudioMenuLabel":"Désactiver le micro des participants","permitOthersAudioMenuLabel":"Autoriser le micro des participants","forbidVideoMenuLabel":"Désactiver la caméra","permitVideoMenuLabel":"Autoriser la caméra","forbidOthersVideoDialogTitle":"Désactiver la caméra des participants ?","forbidOthersVideoDialogContent":"Les participants ne pourront pas activer la vidéo eux-mêmes. L’organisateur et les présentateurs peuvent autoriser les utilisateurs à activer la caméra selon les besoins.","forbidOthersVideoConfirmButtonLabel":"Désactiver les caméras","forbidOthersVideoCancelButtonLabel":"Annuler","permitOthersVideoDialogTitle":"Autoriser la caméra des participants ?","permitOthersVideoDialogContent":"Tous les participants à la réunion pourront activer la vidéo eux-mêmes.","permitOthersVideoConfirmButtonLabel":"Autoriser les caméras","permitOthersVideoCancelButtonLabel":"Annuler","forbidOthersVideoMenuLabel":"Désactiver la caméra des participants","permitOthersVideoMenuLabel":"Autoriser la caméra des participants"}`),chat:{chatListHeader:"Dans cette conversation",uploadAttachment:"Charger une pièce jointe",uploadImageDataNotProvided:"Aucune donnée d'image n'est fournie.",uploadImageIsTooLarge:"L’image est trop grande. Choisissez une taille inférieure à {maxImageSize} Mo.",uploadImageExtensionIsNotAllowed:"Il est interdit de télécharger une image .{imageExtension}.",uploadImageFailed:"Impossible de charger l’image. Veuillez réessayer plus tard."},callWithChat:{chatButtonLabel:"Clavardage",chatButtonNewMessageNotificationLabel:"Nouveau message",chatButtonTooltipClosedWithMessageCount:"Afficher la conversation ({unreadMessagesCount} non lu)",chatButtonTooltipClose:"Masquer la conversation",chatButtonTooltipOpen:"Afficher la conversation",chatPaneTitle:"Clavardage",copyInviteLinkButtonLabel:"Copier le lien d'invitation",copyInviteLinkButtonActionedLabel:"Lien copié",copyInviteLinkActionedAriaLabel:"Le lien d’invitation a été copié.",dismissSidePaneButtonLabel:"Fermer",moreDrawerAudioDeviceMenuTitle:"Périphérique audio",moreDrawerButtonLabel:"Autres options",moreDrawerButtonTooltip:"Autres options",moreDrawerMicrophoneMenuTitle:"Microphone",moreDrawerSpeakerMenuTitle:"Haut-parleur",moreDrawerCaptionsMenuTitle:"Sous-titres en direct",moreDrawerSpokenLanguageMenuTitle:"Langue parlée",moreDrawerCaptionLanguageMenuTitle:"Langue des sous-titres",moreDrawerGalleryOptionsMenuTitle:"Options de galerie",peopleButtonLabel:"Personnes",selectedPeopleButtonLabel:"Bouton Contacts sélectionné",peopleButtonTooltipOpen:"Afficher les participants",peopleButtonTooltipClose:"Masquer les participants",peopleButtonTooltipOpenAriaLabel:"Bouton Contacts, Afficher les participants",peopleButtonTooltipCloseAriaLabel:"Bouton Contacts, Masquer les participants",peoplePaneSubTitle:"Pendant cet appel",peoplePaneTitle:"Personnes",pictureInPictureTileAriaLabel:"Flux vidéo. Cliquez pour revenir à l’écran d’appel.",removeMenuLabel:"Supprimer",openDialpadButtonLabel:"Composer le numéro de téléphone",returnToCallButtonAriaDescription:"Revenir à l’appel",returnToCallButtonAriaLabel:"Précédent",peoplePaneAddPeopleButtonLabel:"Ajouter des personnes",dialpadStartCallButtonLabel:"Appeler",dialpadModalTitle:"Composer le numéro de téléphone",dialpadModalAriaLabel:"Clavier",dialpadCloseModalButtonAriaLabel:"Fermer le clavier",openDtmfDialpadLabel:"Afficher le clavier",dtmfDialpadPlaceholderText:"Saisir un numéro",breakoutRoomChatPaneTitle:"Conversation dans une salle pour petit groupe",chatContentSpinnerLabel:"Chargement de la conversation"}})},Sli={component:pQt,strings:Yh({call:JSON.parse(`{"cameraLabel":"Caméra","noCamerasLabel":"Aucune caméra trouvée","cameraPermissionDenied":"Votre navigateur bloque l’accès à votre caméra","cameraTurnedOff":"Votre caméra est désactivée","chatButtonLabel":"Clavardage","close":"Fermer","complianceBannerNowOnlyRecording":"Vous n’enregistrez désormais que cette réunion.","complianceBannerNowOnlyTranscription":"À présent, vous ne transcrivez que cette réunion.","complianceBannerRecordingAndTranscriptionSaved":"Sauvegarde en cours de l’enregistrement et de la transcription.","complianceBannerRecordingAndTranscriptionStarted":"Démarrage de l’enregistrement et de la transcription.","complianceBannerRecordingAndTranscriptionStopped":"L’enregistrement et la transcription ont pris fin.","complianceBannerRecordingSaving":"Enregistrement en cours de sauvegarde.","complianceBannerRecordingStarted":"L’enregistrement a démarré.","complianceBannerRecordingStopped":"L’enregistrement s’est arrêté.","complianceBannerTranscriptionStarted":"La transcription a démarré.","complianceBannerTranscriptionConsent":"En participant, vous autorisez la transcription de cette réunion.","complianceBannerTranscriptionSaving":"La transcription est en cours d’enregistrement.","complianceBannerTranscriptionStopped":"Arrêt de la transcription.","configurationPageTitle":"Lancer un appel","copyInviteLinkButtonLabel":"Copier le lien d’invitation","copyInviteLinkButtonActionedLabel":"Lien copié","copyInviteLinkActionedAriaLabel":"Le lien d’invitation a été copié.","defaultPlaceHolder":"Sélectionner une option","dismissSidePaneButtonLabel":"Fermer","videoEffectsPaneTitle":"Effets","videoEffectsPaneBackgroundSelectionTitle":"Arrière-plan","videoEffectsPaneAriaLabel":"Volet Effets vidéo","configurationPageCameraIsLoadingLabel":"Chargement de la vidéo...","configurationPageVideoEffectsButtonLabel":"Effets","unableToStartVideoEffect":"Impossible d’appliquer l’effet vidéo.","blurBackgroundEffectButtonLabel":"Flouter","blurBackgroundTooltip":"Flou d’arrière-plan","removeBackgroundEffectButtonLabel":"Aucun","removeBackgroundTooltip":"Supprimer l’arrière-plan","cameraOffBackgroundEffectWarningText":"Votre caméra est désactivée. Activez la caméra pour voir l’effet vidéo.","failedToJoinCallDueToNoNetworkMoreDetails":"L’appel a été déconnecté en raison d’un problème réseau. Vérifiez votre connexion et rejoignez-le à nouveau.","failedToJoinCallDueToNoNetworkTitle":"Appel déconnecté","failedToJoinTeamsMeetingReasonAccessDeniedMoreDetails":"Vous n’avez pas reçu d’entrée dans l’appel. S’il s’agissait d’une erreur, rejoignez à nouveau l’appel.","failedToJoinTeamsMeetingReasonAccessDeniedTitle":"Rejeté de la salle d’attente","learnMore":"En savoir plus","leavingCallTitle":"Départ en cours...","leftCallMoreDetails":"S’il s’agissait d’une erreur, rejoignez à nouveau l’appel.","leftCallTitle":"Vous avez quitté l’appel.","lobbyScreenConnectingToCallTitle":"Rejoindre l’appel","lobbyScreenWaitingToBeAdmittedTitle":"En attente d’admission","microphonePermissionDenied":"Votre navigateur bloque l’accès à votre micro","microphoneToggleInLobbyNotAllowed":"Impossible de désactiver ou d’activer le son dans la salle d’attente.","mutedMessage":"Le son de votre micro est désactivé","networkReconnectMoreDetails":"On dirait qu'une erreur est survenue. Nous tentons de vous reconnecter à l’appel.","networkReconnectTitle":"Tenez bon","notInvitedToRoomDetails":"Vous ne pouvez pas rejoindre cette salle, car vous n’avez pas d’invitation.","notInvitedToRoomTitle":"N’a pas été invité à la salle","peopleButtonLabel":"Personnes","selectedPeopleButtonLabel":"Bouton Contacts sélectionné","peoplePaneTitle":"Personnes","peoplePaneMoreButtonAriaLabel":"Plus","peopleButtonTooltipOpen":"Afficher les participants","peopleButtonTooltipClose":"Masquer les participants","peoplePaneSubTitle":"Dans cet appel {numberOfPeople}","privacyPolicy":"Politique de confidentialité","rejoinCallButtonLabel":"Rejoindre à nouveau l’appel.","removedFromCallMoreDetails":"Un autre participant vous a supprimé de l’appel.","removedFromCallTitle":"Vous avez été supprimé.","removeMenuLabel":"Supprimer","startSpotlightMenuLabel":"Mettre en évidence pour tout le monde","addSpotlightMenuLabel":"Ajouter la mise en évidence","stopSpotlightMenuLabel":"Arrêter la mise en évidence","stopSpotlightOnSelfMenuLabel":"Quitter la mise en évidence","spotlightLimitReachedMenuTitle":"Limite Spotlight atteinte","stopAllSpotlightMenuLabel":"Arrêter tous les projecteurs","returnToCallButtonAriaDescription":"Revenir à l’appel","returnToCallButtonAriaLabel":"Précédent","roomNotFoundDetails":"L’ID de la salle fourni est introuvable.","roomNotFoundTitle":"Salle introuvable","roomNotValidDetails":"Cette salle n’est pas valide pour l’instant.","roomNotValidTitle":"Salle non valide","inviteToRoomRemovedDetails":"Votre invitation à rejoindre cette salle a été supprimée.","inviteToRoomRemovedTitle":"Invitation à la salle supprimée","soundLabel":"Son","noMicrophonesLabel":"Aucun microphone trouvé","noSpeakersLabel":"Aucun haut-parleur trouvé","startCallButtonLabel":"Lancer l’appel","openDialpadButtonLabel":"Composer le numéro de téléphone","peoplePaneAddPeopleButtonLabel":"Ajouter des personnes","dialpadStartCallButtonLabel":"Appeler","dialpadModalTitle":"Composer le numéro de téléphone","dialpadModalAriaLabel":"Clavier","dialpadCloseModalButtonAriaLabel":"Fermer le clavier","moreButtonCallingLabel":"Plus","resumeCallButtonLabel":"Reprendre","resumingCallButtonLabel":"Reprise...","resumeCallButtonAriaLabel":"Reprendre l’appel","resumingCallButtonAriaLabel":"Reprendre l’appel","holdScreenLabel":"Vous avez été mis(e) en attente.","openDtmfDialpadLabel":"Afficher le pavé ","dtmfDialpadPlaceholderText":"Entrer un numéro","outboundCallingNoticeString":"Appel en cours...","participantJoinedNoticeString":"{displayName} a rejoint","twoParticipantJoinedNoticeString":"{displayName1} et {displayName2} ont rejoint","threeParticipantJoinedNoticeString":"{displayName1}, {displayName2} et {displayName3} ont rejoint","participantLeftNoticeString":"{displayName} a quitté","twoParticipantLeftNoticeString":"{displayName1} et {displayName2} sont partis","threeParticipantLeftNoticeString":"{displayName1}, {displayName2} et {displayName3} ont quitté","unnamedParticipantString":"participant(e) sans nom","manyUnnamedParticipantsJoined":"participant sans nom et {numOfParticipants} autres participants ont rejoint","manyUnnamedParticipantsLeft":"participant sans nom et {numOfParticipants} autres participants ont quitté","manyParticipantsJoined":"{displayName1}, {displayName2}, {displayName3} et {numOfParticipants} autres participants ont rejoint","manyParticipantsLeft":"{displayName1}, {displayName2}, {displayName3} et {numOfParticipants} autres participants restants","liveCaptionsLabel":"Sous-titres en direct","captionsSettingsLabel":"Paramètres de sous-titre","startCaptionsButtonOnLabel":"Activer les sous-titres","startCaptionsButtonOffLabel":"Désactiver les sous-titres","startCaptionsButtonTooltipOnContent":"Désactiver les sous-titres","startCaptionsButtonTooltipOffContent":"Activer les sous-titres","captionsSettingsModalTitle":"Paramètres des sous-titres","captionsSettingsSpokenLanguageDropdownLabel":"Langue parlée","captionsSettingsCaptionLanguageDropdownLabel":"Langue des sous-titres","captionsSettingsSpokenLanguageDropdownInfoText":"Langue parlée par tous les participants à cet appel.","captionsSettingsCaptionLanguageDropdownInfoText":"Les sous-titres apparaîtront dans cette langue.","captionsSettingsConfirmButtonLabel":"Confirmer","captionsSettingsCancelButtonLabel":"Annuler","captionsSettingsModalAriaLabel":"Modalités de réglage des sous-titres","captionsSettingsCloseModalButtonAriaLabel":"Paramètres de fermeture des sous-titres","captionsBannerMoreButtonCallingLabel":"Autres options de paramètres de sous-titres","captionsBannerMoreButtonTooltip":"Autres options","realTimeTextLabel":"Texte en temps réel (RTT)","startRealTimeTextLabel":"Activer RTT pour cet appel","disabledStartRealTimeTextLabel":"La RTT est actuellement activée, elle ne peut pas être désactivée","dismissModalAriaLabel":"Images locales et distantes, appuyez sur entrée pour revenir à l'appel","callRejectedTitle":"Nous n’avons pas pu effectuer l’appel","callRejectedMoreDetails":"La personne que vous essayez de rejoindre n’est pas disponible. Veuillez réessayer plus tard.","callTimeoutTitle":"Nous n’avons pas pu effectuer l’appel","callTimeoutDetails":"La personne que vous essayez de rejoindre n’est pas disponible. Veuillez réessayer plus tard.","callTimeoutBotTitle":"Nous n’avons pas pu effectuer l’appel","callTimeoutBotDetails":"Le service auquel ou essayez d’accéder n’est pas disponible. Veuillez réessayer plus tard.","dtmfDialerButtonLabel":"Clavier","dtmfDialerButtonTooltipOn":"Afficher le pavé ","dtmfDialerButtonTooltipOff":"Masquez le clavier","dtmfDialerMoreButtonLabelOn":"Afficher le pavé ","dtmfDialerMoreButtonLabelOff":"Masquez le clavier","phoneCallMoreButtonLabel":"Appel téléphonique","spokenLanguageStrings":{"ar-ae":"Arabe (É.A.U.)","ar-sa":"Arabe (Arabie saoudite)","da-dk":"Danois","de-de":"Allemand (Allemagne)","en-au":"Anglais - Australie","en-ca":"Anglais (Canada)","en-gb":"Anglais (Royaume-Uni)","en-in":"Anglais (Inde)","en-nz":"Anglais (Nouvelle-Zélande)","en-us":"Anglais (États-Unis)","es-es":"Espagnol (Espagne, moderne)","es-mx":"Espagnol (Mexique)","fi-fi":"Finnois","fr-ca":"Français (Canada)","fr-fr":"Français (France)","hi-in":"Hindi","it-it":"Italien (Italie)","ja-jp":"Japonais","ko-kr":"Coréen","nb-no":"Norvégien (Bokmål)","nl-be":"Flamand (Belgique)","nl-nl":"Néerlandais (Pays-Bas)","pl-pl":"Polonais","pt-br":"Portugais (Brésil)","ru-ru":"Russe","sv-se":"Suédois","zh-cn":"Chinois (République populaire de Chine),","zh-hk":"Chinois (Hong Kong (R.A.S.))","cs-cz":"Tchèque","pt-pt":"Portugais (Portugal)","tr-tr":"Turc","vi-vn":"Vietnamien","th-th":"Thaï","he-il":"Hébreu","cy-gb":"Gallois","uk-ua":"Ukrainien","el-gr":"Grec","hu-hu":"Hongrois","ro-ro":"Roumain","sk-sk":"Slovaque","zh-tw":"Chinois – Taiwan"},"captionLanguageStrings":{"ar":"Arabe","da":"Danois","de":"Allemand","en":"Anglais","es":"Espagnol","fi":"Finnois","fr-ca":"Français (Canada)","fr":"Français (France)","hi":"Hindi","it":"Italien","ja":"Japonais","ko":"Coréen","nb":"Norvégien (Bokmål)","nl":"Néerlandais","pl":"Polonais","pt":"Portugais (Brésil)","ru":"Russe","sv":"Suédois","zh-Hans":"Chinois (simplifié)","zh-Hant":"Chinois (traditionnel)","cs":"Tchèque","pt-pt":"Portugais (Portugal)","tr":"Turc","vi":"Vietnamien","th":"Thaï","he":"Hébreu","cy":"Gallois","uk":"Ukrainien","el":"Grec","hu":"Hongrois","ro":"Roumain","sk":"Slovaque"},"captionsBannerSpinnerText":"Démarrage des sous-titres...","realTimeTextInputBoxDefaultText":"Tapez votre message en temps réel.","realTimeTextInputErrorMessage":"Le message ne peut pas dépasser 2000 caractères","realTimeTextBannerTitle":"RTT","realTimeTextBannerContent":"RTT (texte en temps réel) est activé pour tous les participants pendant toute la durée de la réunion.","realTimeTextBannerLinkLabel":"En savoir plus","realTimeTextModalAriaLabel":"Activer la boîte de dialogue modale RTT","realTimeTextModalTitle":"Activation de la RTT?","realTimeTextModalText":"Le texte en temps réel (RTT) sera activé pour tous les participants à la réunion.","realTimeTextConfirmButtonLabel":"Activer","realTimeTextCancelButtonLabel":"Annuler","realTimeTextCloseModalButtonAriaLabel":"Fermer la boîte de dialogue modale RTT","captionsOnlyContainerTitle":"Sous-titres en direct","realTimeTextOnlyContainerTitle":"Texte en temps réel","captionsAndRealTimeTextContainerTitle":"Sous-titres en direct et texte en temps réel","expandButtonAriaLabel":"Étendre","minimizeButtonAriaLabel":"Réduire","transferPageTransferorText":"Transfert en cours...","transferPageTransferTargetText":"Connexion en cours...","transferPageUnknownTransferorDisplayName":"Inconnu","transferPageUnknownTransferTargetDisplayName":"Inconnu","transferPageNoticeString":"Vous êtes en train d’être transféré","participantCouldNotBeReachedTitle":"Le participant cible n’est actuellement pas disponible","participantCouldNotBeReachedMoreDetails":"Veuillez communiquer avec le participant lorsqu’il sera disponible","permissionToReachTargetParticipantNotAllowedTitle":"L’autorisation d’atteindre le participant cible n’est pas valable","permissionToReachTargetParticipantNotAllowedMoreDetails":"Veuillez vérifier que le participant cible est dans le même locataire","unableToResolveTenantTitle":"Impossible de résoudre l’ID de locataire pour le participant cible","unableToResolveTenantMoreDetails":"Veuillez vérifier que l’ID du participant est entré correctement","participantIdIsMalformedTitle":"Le format de l’ID de participant n’est pas correct","participantIdIsMalformedMoreDetails":"Veuillez vérifier que l’identifiant du participant est dans le bon format","moreButtonGalleryControlLabel":"Afficher","moreButtonGalleryPositionToggleLabel":"Déplacer la galerie vers le haut","moreButtonGallerySpeakerLayoutLabel":"Haut-parleur","moreButtonGalleryFloatingLocalLayoutLabel":"Dynamique","moreButtonGalleryDefaultLayoutLabel":"Vue Galerie","moreButtonGalleryFocusedContentLayoutLabel":"Focalisation sur le contenu","moreButtonLargeGalleryDefaultLayoutLabel":"Grande galerie","moreButtonTogetherModeLayoutLabel":"Mode Ensemble","capabilityChangedNotification":{"turnVideoOn":{"lostDueToMeetingOption":"Votre caméra a été désactivée. Vous ne pouvez plus partager de vidéo.","grantedDueToMeetingOption":"Votre appareil photo a été activé. Activez-le si vous souhaitez partager une vidéo."},"unmuteMic":{"lostDueToMeetingOption":"Votre micro a été désactivé. Vous ne pouvez plus activer le son.","grantedDueToMeetingOption":"Votre microphone a été activé. Activez le microphone pour parler."},"shareScreen":{"lostDueToRoleChangeToAttendee":"Votre rôle a été modifié. Certaines actions, telles que le partage de contenu, ne seront pas disponibles pour vous.","grantedDueToRoleChangeToPresenter":"Vous êtes présentateur. Vous pouvez partager du contenu et organiser la réunion."},"hideAttendeeNames":{"hideAttendeeNameAttendee":"Votre nom est masqué pour les autres participants. Les organisateurs et les présentateurs peuvent voir votre vrai nom.","hideAttendeeNamePresenter":"Les noms des participants sont masqués. Afin de protéger la confidentialité des participants, seuls les organisateurs et les présentateurs peuvent visualiser les noms."}},"surveyTitle":"Aidez-nous à nous améliorer","starSurveyHelperText":"Quelle a été la qualité globale de cet appel?","starSurveyOneStarText":"La qualité était mauvaise.","starSurveyTwoStarText":"La qualité était mauvaise.","starSurveyThreeStarText":"La qualité était bonne.","starSurveyFourStarText":"La qualité était excellente.","starSurveyFiveStarText":"La qualité était excellente.","surveyConfirmButtonLabel":"Envoyer des commentaires","starRatingAriaLabel":"Sélectionner {0} étoiles sur {1}","surveySkipButtonLabel":"Ignorer","tagsSurveyQuestion":"Que pouvons-nous améliorer?","tagsSurveyTextFieldDefaultText":"Autre, veuillez préciser.","tagsSurveyHelperText":"Cochez les problèmes que vous avez rencontrés.","endOfSurveyText":"Merci pour vos commentaires!","surveyIssues":{"overallRating":{"callCannotJoin":"Je n’ai pas pu rejoindre l’appel","callCannotInvite":"Je n’ai pas pu inviter d’autres personnes à participer à l’appel","hadToRejoin":"J’ai dû rejoindre l’appel","callEndedUnexpectedly":"L’appel s’est terminé pour moi de manière brusque","otherIssues":"J’avais d’autres problèmes avec l’appel"},"audioRating":{"noLocalAudio":"Mon interlocuteur n’entendait aucun son","noRemoteAudio":"Je n’entendais aucun son","echo":"J’ai entendu des échos lors de l’appel","audioNoise":"Il y avait des bruits parasites","lowVolume":"Faible volume sonore","audioStoppedUnexpectedly":"L’audio s’est arrêté de manière inattendue","distortedSpeech":"Le fichier audio a été altéré","audioInterruption":"L’audio a été interrompu","otherIssues":"J’avais d’autres problèmes audio dans cet appel"},"videoRating":{"noVideoReceived":"La vidéo ne s'affichait pas sur mon écran","noVideoSent":"D’autres ne pouvaient pas me voir","lowQuality":"La qualité de la vidéo était faible","freezes":"Vidéo figée","stoppedUnexpectedly":"La vidéo s'est arrêtée brusquement.","darkVideoReceived":"Je ne peux voir les écrans sombres que lorsque d’autres allument leur appareil photo","audioVideoOutOfSync":"L’audio et la vidéo n’étaient pas synchronisés","otherIssues":"J’ai rencontré d’autres problèmes vidéo pendant cet appel"},"screenshareRating":{"noContentLocal":"Les autres n’ont pas pu voir mon partage d’écran","noContentRemote":"Je ne pouvais pas voir le partage d’écran des autres","cannotPresent":"Je n’ai pas pu présenter mon écran","lowQuality":"La qualité du partage d’écran était faible","freezes":"Partage d’écran figé","stoppedUnexpectedly":"Le partage d’écran s’est arrêté de manière inattendue","largeDelay":"Le partage d’écran accuse un retard important","otherIssues":"Je rencontre d’autres problèmes de partage d’écran dans cet appel"}},"surveyIssuesHeadingStrings":{"overallRating":"Globale","audioRating":"Audio","videoRating":"Vidéo","screenshareRating":"En présentation"},"spotlightPrompt":{"startSpotlightHeading":"Voulez-vous mettre en évidence pour tout le monde?","startSpotlightText":"Votre vidéo ne sera plus mise en surbrillance pour tous les participants à la réunion.","startSpotlightOnSelfText":"Vous mettez en surbrillance votre vidéo pour tous les participants à la réunion.","startSpotlightConfirmButtonLabel":"Mettre en évidence pour tout le monde","startSpotlightCancelButtonLabel":"Annuler","stopSpotlightHeading":"Voulez-vous arrêter la mise en évidence de cette vidéo?","stopSpotlightOnSelfHeading":"Voulez-vous quitter la mise en évidence?","stopAllSpotlightHeading":"Voulez-vous arrêter de mettre en évidence toutes les vidéos?","stopSpotlightText":"Cette vidéo ne sera plus mise en évidence pour tous les participants à la réunion.","stopSpotlightOnSelfText":"Votre vidéo ne sera plus mise en surbrillance pour tous les participants à la réunion.","stopAllSpotlightText":"Les vidéo n’apparaissent plus en surbrillance pour tous les participants à la réunion.","stopSpotlightConfirmButtonLabel":"Arrêter la mise en évidence","stopSpotlightOnSelfConfirmButtonLabel":"Quitter la mise en évidence","stopSpotlightCancelButtonLabel":"Annuler","closeSpotlightPromptButtonLabel":"Fermer"},"exitSpotlightButtonLabel":"Quitter la mise en évidence","exitSpotlightButtonTooltip":"Quitter la mise en évidence","leaveConfirmButtonLabel":"Quitter","endCallConfirmButtonLabel":"Raccrocher","hangUpCancelButtonLabel":"Annuler","leaveConfirmDialogTitle":"Quitter l’appel?","leaveConfirmDialogContent":"Voulez-vous vraiment quitter l’appel?","endCallConfirmDialogTitle":"Mettre fin à l'appel?","endCallConfirmDialogContent":"Vous mettrez fin à l’appel pour tout le monde.","invalidMeetingIdentifier":"ID de réunion ou code d’accès non valide","pinParticipantMenuLabel":"Épingler pour moi","pinParticipantLimitReachedMenuLabel":"Épingler (limite atteinte)","unpinParticipantMenuLabel":"Désépingler","pinParticipantMenuItemAriaLabel":"Épingler pour moi","unpinParticipantMenuItemAriaLabel":"Désépingler","muteAllMenuLabel":"Désactiver tous les micros","muteAllDialogTitle":"Couper le son pour tout le monde?","muteAllDialogContent":"Cette opération va désactiver le son de tous les autres participants à la réunion et pas le vôtre.","muteAllConfirmButtonLabel":"Désactiver tous les micros","muteAllCancelButtonLabel":"Annuler","joinBreakoutRoomButtonLabel":"Rejoindre la salle pour petit groupe","returnFromBreakoutRoomButtonLabel":"Quitter la salle","leaveBreakoutRoomAndMeetingButtonLabel":"Quitter la réunion","breakoutRoomJoinedNotificationTitle":"Vous avez rejoint la salle pour petit groupe « {roomName} »","joinBreakoutRoomBannerTitle":"La salle pour petit groupe « {roomName} » est ouverte","joinBreakoutRoomBannerButtonLabel":"Rejoindre","returnFromBreakoutRoomBannerTitle":"Revenir à la réunion principale","returnFromBreakoutRoomBannerButtonLabel":"Rejoindre","forbidAudioMenuLabel":"Désactiver le micro","permitAudioMenuLabel":"Autoriser le micro","forbidOthersAudioDialogTitle":"Voulez-vous désactiver le micro des participants?","forbidOthersAudioDialogContent":"Les participants ne pourront pas activer leur micro. L’organisateur(-trice) et les présentateurs peuvent permettre aux utilisateurs de désactiver le son selon les besoins.","forbidOthersAudioConfirmButtonLabel":"Désactiver les micros","forbidOthersAudioCancelButtonLabel":"Annuler","permitOthersAudioDialogTitle":"Voulez-vous autoriser le micro pour des participants?","permitOthersAudioDialogContent":"Chaque participant(e) à la réunion sera en mesure d’activer le son.","permitOthersAudioConfirmButtonLabel":"Autoriser les micros","permitOthersAudioCancelButtonLabel":"Annuler","forbidOthersAudioMenuLabel":"Désactiver le micro des participants","permitOthersAudioMenuLabel":"Autoriser le micro des participants","forbidVideoMenuLabel":"Désactiver la caméra","permitVideoMenuLabel":"Autoriser la caméra","forbidOthersVideoDialogTitle":"Voulez-vous désactiver la caméra des participants?","forbidOthersVideoDialogContent":"Les participants ne pourront pas activer la vidéo eux-mêmes. L’organisateur(-trice) et les présentateurs peuvent autoriser les utilisateurs à activer la caméra selon les besoins.","forbidOthersVideoConfirmButtonLabel":"Désactiver les caméras","forbidOthersVideoCancelButtonLabel":"Annuler","permitOthersVideoDialogTitle":"Voulez-vous autoriser la caméra des participants?","permitOthersVideoDialogContent":"Tous les participants à la réunion pourront activer la vidéo eux-mêmes.","permitOthersVideoConfirmButtonLabel":"Autoriser les caméras","permitOthersVideoCancelButtonLabel":"Annuler","forbidOthersVideoMenuLabel":"Désactiver la caméra des participants","permitOthersVideoMenuLabel":"Autoriser la caméra des participants"}`),chat:{chatListHeader:"Dans ce clavardage",uploadAttachment:"Charger une pièce jointe",uploadImageDataNotProvided:"Aucune donnée d’image n’est fournie.",uploadImageIsTooLarge:"L’image est trop grande. Choisissez une taille inférieure à {maxImageSize} Mo.",uploadImageExtensionIsNotAllowed:"Il est interdit de téléverser l’image {imageExtension}.",uploadImageFailed:"Impossible de téléverser l’image. Veuillez réessayer plus tard."},callWithChat:{chatButtonLabel:"Clavardage",chatButtonNewMessageNotificationLabel:"Nouveau message",chatButtonTooltipClosedWithMessageCount:"Afficher le clavardage ({unreadMessagesCount} non lu)",chatButtonTooltipClose:"Masquer le clavardage",chatButtonTooltipOpen:"Afficher le clavardage",chatPaneTitle:"Clavardage",copyInviteLinkButtonLabel:"Copier le lien d’invitation",copyInviteLinkButtonActionedLabel:"Lien copié",copyInviteLinkActionedAriaLabel:"Le lien d’invitation a été copié.",dismissSidePaneButtonLabel:"Fermer",moreDrawerAudioDeviceMenuTitle:"Périphérique audio",moreDrawerButtonLabel:"Autres options",moreDrawerButtonTooltip:"Autres options",moreDrawerMicrophoneMenuTitle:"Microphone",moreDrawerSpeakerMenuTitle:"Haut-parleur",moreDrawerCaptionsMenuTitle:"Sous-titres en direct",moreDrawerSpokenLanguageMenuTitle:"Langue parlée",moreDrawerCaptionLanguageMenuTitle:"Langue des sous-titres",moreDrawerGalleryOptionsMenuTitle:"Options de galerie",peopleButtonLabel:"Personnes",selectedPeopleButtonLabel:"Bouton Contacts sélectionné",peopleButtonTooltipOpen:"Afficher les participants",peopleButtonTooltipClose:"Masquer les participants",peopleButtonTooltipOpenAriaLabel:"Bouton Contacts, Afficher les participants",peopleButtonTooltipCloseAriaLabel:"Bouton Contacts, Masquer les participants",peoplePaneSubTitle:"Pendant cet appel",peoplePaneTitle:"Personnes",pictureInPictureTileAriaLabel:"Flux vidéo. Cliquez pour revenir à l’écran d’appel.",removeMenuLabel:"Supprimer",openDialpadButtonLabel:"Composer le numéro de téléphone",returnToCallButtonAriaDescription:"Revenir à l’appel",returnToCallButtonAriaLabel:"Précédent",peoplePaneAddPeopleButtonLabel:"Ajouter des personnes",dialpadStartCallButtonLabel:"Appeler",dialpadModalTitle:"Composer le numéro de téléphone",dialpadModalAriaLabel:"Clavier",dialpadCloseModalButtonAriaLabel:"Fermer le clavier",openDtmfDialpadLabel:"Afficher le pavé ",dtmfDialpadPlaceholderText:"Entrer un numéro",breakoutRoomChatPaneTitle:"Conversation dans une salle pour petit groupe",chatContentSpinnerLabel:"Chargement de la session de messagerie instantanée"}})},bli={component:gQt,strings:Yh({call:JSON.parse(`{"cameraLabel":"מצלמה","noCamerasLabel":"לא נמצאו מצלמות","cameraPermissionDenied":"הדפדפן שלך חוסם את הגישה למצלמה שלך","cameraTurnedOff":"המצלמה שלך כבויה","chatButtonLabel":"צ'אט","close":"סגור","complianceBannerNowOnlyRecording":"אתה כעת רק מקליט את הפגישה.","complianceBannerNowOnlyTranscription":"אתה רק מתעתק את הפגישה כעת.","complianceBannerRecordingAndTranscriptionSaved":"ההקלטה והתמלול בתהליך שמירה.","complianceBannerRecordingAndTranscriptionStarted":"הקלטה ותמלול התחילו.","complianceBannerRecordingAndTranscriptionStopped":"ההקלטה והתמלול הופסקו.","complianceBannerRecordingSaving":"ההקלטה נשמרת.","complianceBannerRecordingStarted":"ההקלטה התחילה.","complianceBannerRecordingStopped":"ההקלטה הופסקה.","complianceBannerTranscriptionStarted":"התמלול התחיל.","complianceBannerTranscriptionConsent":"על-ידי הצטרפות, אתה נותן הסכמה לתעתק פגישה זו.","complianceBannerTranscriptionSaving":"מתבצע תהליך שמירה של התמלול.","complianceBannerTranscriptionStopped":"התמלול הופסק.","configurationPageTitle":"התחל שיחה","copyInviteLinkButtonLabel":"העתק קישור להזמנה","copyInviteLinkButtonActionedLabel":"הקישור הועתק","copyInviteLinkActionedAriaLabel":"קישור ההזמנה הועתק","defaultPlaceHolder":"בחר אפשרות","dismissSidePaneButtonLabel":"סגור","videoEffectsPaneTitle":"אפקטים","videoEffectsPaneBackgroundSelectionTitle":"רקע","videoEffectsPaneAriaLabel":"חלונית אפקטי וידאו","configurationPageCameraIsLoadingLabel":"הווידאו נטען...","configurationPageVideoEffectsButtonLabel":"אפקטים","unableToStartVideoEffect":"לא ניתן להחיל אפקט וידאו.","blurBackgroundEffectButtonLabel":"טשטוש","blurBackgroundTooltip":"טשטש רקע","removeBackgroundEffectButtonLabel":"ללא","removeBackgroundTooltip":"הסר רקע","cameraOffBackgroundEffectWarningText":"המצלמה שלך כבויה. הפעל מצלמה כדי לראות את אפקט הווידאו.","failedToJoinCallDueToNoNetworkMoreDetails":"השיחה נותקה עקב בעיית רשת. בדוק את החיבור שלך והצטרף שוב.","failedToJoinCallDueToNoNetworkTitle":"‏‏השיחה נותקה","failedToJoinTeamsMeetingReasonAccessDeniedMoreDetails":"לא הוענקה לך כניסה בשיחה. אם זו היתה טעות, הצטרף מחדש לשיחה.","failedToJoinTeamsMeetingReasonAccessDeniedTitle":"הוצא מחדר הכניסה","learnMore":"למידע נוסף","leavingCallTitle":"עוזב...","leftCallMoreDetails":"אם זו היתה טעות, הצטרף מחדש לשיחה.","leftCallTitle":"עזבת את הצ'אט","lobbyScreenConnectingToCallTitle":"מצטרף לשיחה","lobbyScreenWaitingToBeAdmittedTitle":"ממתין לאישור כניסה","microphonePermissionDenied":"הדפדפן שלך חוסם את הגישה למיקרופון שלך","microphoneToggleInLobbyNotAllowed":"אין אפשרות להשתיק או לבטל השתקה בחדר הכניסה.","mutedMessage":"אתה מושתק","networkReconnectMoreDetails":"נראה שמשהו השתבש. אנו מנסים להיכנס שוב לשיחה.","networkReconnectTitle":"המתן","notInvitedToRoomDetails":"אין לך אפשרות להצטרף לחדר זה משום שאין לך הזמנה.","notInvitedToRoomTitle":"לא הוזמן לחדר","peopleButtonLabel":"אנשים","selectedPeopleButtonLabel":"לחצן 'אנשים' נבחר","peoplePaneTitle":"אנשים","peoplePaneMoreButtonAriaLabel":"עוד","peopleButtonTooltipOpen":"הצג משתתפים","peopleButtonTooltipClose":"הסתר משתתפים","peoplePaneSubTitle":"בשיחה זו {numberOfPeople}","privacyPolicy":"מדיניות פרטיות","rejoinCallButtonLabel":"הצטרף לשיחה מחדש","removedFromCallMoreDetails":"משתתף אחר הסיר אותך מהשיחה.","removedFromCallTitle":"הוסרת","removeMenuLabel":"הסר","startSpotlightMenuLabel":"הצבת זרקור עבור כולם","addSpotlightMenuLabel":"הוסף זרקור","stopSpotlightMenuLabel":"הפסק להציב זרקור","stopSpotlightOnSelfMenuLabel":"צא מזרקור","spotlightLimitReachedMenuTitle":"הגעת למגבלת הזרקורים","stopAllSpotlightMenuLabel":"הפסק את כל הצבות הזרקור","returnToCallButtonAriaDescription":"חזור לשיחה","returnToCallButtonAriaLabel":"הקודם","roomNotFoundDetails":"מזהה החדר שסופק לא נמצא.","roomNotFoundTitle":"החדר לא נמצא","roomNotValidDetails":"חדר זה אינו חוקי כעת.","roomNotValidTitle":"החדר אינו חוקי","inviteToRoomRemovedDetails":"ההזמנה שלך להצטרפות לחדר זה הוסרה.","inviteToRoomRemovedTitle":"ההזמנה לחדר הוסרה","soundLabel":"צליל","noMicrophonesLabel":"לא נמצאו מיקרופונים","noSpeakersLabel":"לא נמצאו רמקולים","startCallButtonLabel":"התחל שיחה","openDialpadButtonLabel":"חייג למספר הטלפון","peoplePaneAddPeopleButtonLabel":"הוסף אנשים","dialpadStartCallButtonLabel":"שיחה","dialpadModalTitle":"חייג למספר הטלפון","dialpadModalAriaLabel":"לוח חיוג","dialpadCloseModalButtonAriaLabel":"סגור לוח חיוג","moreButtonCallingLabel":"עוד","resumeCallButtonLabel":"המשך","resumingCallButtonLabel":"מחדש...","resumeCallButtonAriaLabel":"חדש שיחה","resumingCallButtonAriaLabel":"חדש שיחה","holdScreenLabel":"אתה בהמתנה","openDtmfDialpadLabel":"הצג לוח חיוג","dtmfDialpadPlaceholderText":"הזן מספר","outboundCallingNoticeString":"מתקשר...","participantJoinedNoticeString":"{displayName} הצטרף/ה","twoParticipantJoinedNoticeString":"{displayName1} ו{displayName2} הצטרפו","threeParticipantJoinedNoticeString":"{displayName1}, {displayName2} ו{displayName3} עזבו","participantLeftNoticeString":"{displayName} עזב/ה","twoParticipantLeftNoticeString":"{displayName1} ו{displayName2} עזבו","threeParticipantLeftNoticeString":"{displayName1}, {displayName2} ו{displayName3} עזבו","unnamedParticipantString":"משתתף/ת ללא שם","manyUnnamedParticipantsJoined":"משתתף/ת ללא שם ו{numOfParticipants} משתתפים אחרים הצטרפו","manyUnnamedParticipantsLeft":"משתתף/ת ללא שם ו{numOfParticipants} משתתפים אחרים","manyParticipantsJoined":"{displayName1}, {displayName2}, {displayName3} ו{numOfParticipants} משתתפים אחרים הצטרפו","manyParticipantsLeft":"{displayName1}, {displayName2}, {displayName3} ו{numOfParticipants} משתתפים אחרים נותרו","liveCaptionsLabel":"כתוביות חיות","captionsSettingsLabel":"הגדרות כתוביות","startCaptionsButtonOnLabel":"הפעל כתוביות","startCaptionsButtonOffLabel":"כבה כתוביות","startCaptionsButtonTooltipOnContent":"כבה כתוביות","startCaptionsButtonTooltipOffContent":"הפעל כתוביות","captionsSettingsModalTitle":"הגדרות כתוביות","captionsSettingsSpokenLanguageDropdownLabel":"שפה מדוברת","captionsSettingsCaptionLanguageDropdownLabel":"שפת כתוביות","captionsSettingsSpokenLanguageDropdownInfoText":"השפה שכולם בשיחה זו מדברים.","captionsSettingsCaptionLanguageDropdownInfoText":"הכתוביות יופיעו בשפה זו.","captionsSettingsConfirmButtonLabel":"אשר","captionsSettingsCancelButtonLabel":"ביטול","captionsSettingsModalAriaLabel":"מודאל הגדרת כתוביות","captionsSettingsCloseModalButtonAriaLabel":"סגור הגדרת כתוביות","captionsBannerMoreButtonCallingLabel":"הגדרות כתוביות אפשרויות נוספות","captionsBannerMoreButtonTooltip":"אפשרויות נוספות","realTimeTextLabel":"טקסט בזמן אמת (RTT)","startRealTimeTextLabel":"הפעל RTT עבור שיחה זו","disabledStartRealTimeTextLabel":"RTT מופעל כעת, לא ניתן לבטל אותו","dismissModalAriaLabel":"תמונה מקומית ותמונה מרוחקת, הקש על Enter כדי לחזור לשיחה.","callRejectedTitle":"לא הייתה אפשרות להשלים את השיחה.","callRejectedMoreDetails":"האדם שאליו אתה מנסה להגיע אינו זמין. נסה שוב מאוחר יותר.","callTimeoutTitle":"לא הייתה אפשרות להשלים את השיחה.","callTimeoutDetails":"האדם שאליו אתה מנסה להגיע אינו זמין. נסה שוב מאוחר יותר.","callTimeoutBotTitle":"לא הייתה אפשרות להשלים את השיחה.","callTimeoutBotDetails":"השירות אליו אתה מנסה להגיע אינו זמין. נסה שוב מאוחר יותר.","dtmfDialerButtonLabel":"לוח חיוג","dtmfDialerButtonTooltipOn":"הצג לוח חיוג","dtmfDialerButtonTooltipOff":"הסתר לוח חיוג","dtmfDialerMoreButtonLabelOn":"הצג לוח חיוג","dtmfDialerMoreButtonLabelOff":"הסתר לוח חיוג","phoneCallMoreButtonLabel":"שיחת טלפון","spokenLanguageStrings":{"ar-ae":"ערבית - איחוד האמירויות","ar-sa":"ערבית - ערב הסעודית","da-dk":"דנית","de-de":"גרמנית - גרמניה","en-au":"אנגלית - אוסטרליה","en-ca":"אנגלית - קנדה","en-gb":"אנגלית - בריטניה","en-in":"אנגלית - הודו","en-nz":"אנגלית - ניו זילנד","en-us":"אנגלית - ארצות הברית","es-es":"ספרדית - ספרד (ספרדית מודרנית)","es-mx":"ספרדית - מקסיקו","fi-fi":"פינית","fr-ca":"צרפתית - קנדה","fr-fr":"צרפתית - צרפת","hi-in":"הינדי","it-it":"איטלקית - איטליה","ja-jp":"יפנית","ko-kr":"קוריאנית","nb-no":"נורווגית (בוּקמוֹל)","nl-be":"הולנדית - בלגיה","nl-nl":"הולנדית - הולנד","pl-pl":"פולנית","pt-br":"פורטוגזית - ברזיל","ru-ru":"רוסית","sv-se":"שוודית","zh-cn":"סינית - הרפובליקה העממית של סין","zh-hk":"סינית - הונג קונג","cs-cz":"צ׳כית","pt-pt":"פורטוגזית - פורטוגל","tr-tr":"טורקית","vi-vn":"וייטנאמית","th-th":"תאית","he-il":"עברית","cy-gb":"וולשית","uk-ua":"אוקראינית","el-gr":"יוונית","hu-hu":"הונגרית","ro-ro":"רומנית","sk-sk":"סלובקית","zh-tw":"סינית - טייוואן"},"captionLanguageStrings":{"ar":"ערבית","da":"דנית","de":"גרמנית","en":"אנגלית","es":"ספרדית","fi":"פינית","fr-ca":"צרפתית - קנדה","fr":"צרפתית - צרפת","hi":"הינדי","it":"איטלקית","ja":"יפנית","ko":"קוריאנית","nb":"נורווגית (בוּקמוֹל)","nl":"הולנדית","pl":"פולנית","pt":"פורטוגזית - ברזיל","ru":"רוסית","sv":"שוודית","zh-Hans":"סינית (פשוטה)","zh-Hant":"סינית (מסורתית)","cs":"צ׳כית","pt-pt":"פורטוגזית - פורטוגל","tr":"טורקית","vi":"וייטנאמית","th":"תאית","he":"עברית","cy":"וולשית","uk":"אוקראינית","el":"יוונית","hu":"הונגרית","ro":"רומנית","sk":"סלובקית"},"captionsBannerSpinnerText":"מאתחל כתוביות...","realTimeTextInputBoxDefaultText":"הקלד הודעה בזמן אמת","realTimeTextInputErrorMessage":"ההודעה אינה יכולה לחרוג מ- 2,000 תווים","realTimeTextBannerTitle":"RTT","realTimeTextBannerContent":"RTT (טקסט בזמן אמת) זמין עבור כל המשתתפים למשך הזמן כולו של הפגישה.","realTimeTextBannerLinkLabel":"מידע נוסף","realTimeTextModalAriaLabel":"הפעל תיבת דו-שיח מודאלית של RTT","realTimeTextModalTitle":"להפעיל RTT?","realTimeTextModalText":"טקסט בזמן אמת (RTT) יופעל עבור כל האנשים בפגישה.","realTimeTextConfirmButtonLabel":"הפעל","realTimeTextCancelButtonLabel":"ביטול","realTimeTextCloseModalButtonAriaLabel":"סגור תיבת דו-שיח מודאלית של RTT","captionsOnlyContainerTitle":"כתוביות","realTimeTextOnlyContainerTitle":"טקסט בזמן אמת","captionsAndRealTimeTextContainerTitle":"כתוביות וטקסט בזמן אמת","expandButtonAriaLabel":"הרחב","minimizeButtonAriaLabel":"כווץ","transferPageTransferorText":"מעביר...","transferPageTransferTargetText":"מתחבר...","transferPageUnknownTransferorDisplayName":"לא ידוע","transferPageUnknownTransferTargetDisplayName":"לא ידוע","transferPageNoticeString":"אתה מועבר כעת","participantCouldNotBeReachedTitle":"ממשתתף היעד אינו זמין כעת","participantCouldNotBeReachedMoreDetails":"פנה למשתתף כאשר הוא זמין","permissionToReachTargetParticipantNotAllowedTitle":"אין הרשאה להגיע למשתתף היעד","permissionToReachTargetParticipantNotAllowedMoreDetails":"בדוק שמשתתף היעד נמצא באותו דייר","unableToResolveTenantTitle":"לא ניתן לזהות מזהה דייר עבור משתתף היעד","unableToResolveTenantMoreDetails":"בדוק שמזהה המשתתף הוזן כראוי","participantIdIsMalformedTitle":"מזהה המשתתף אינו בתבנית הנכונה","participantIdIsMalformedMoreDetails":"בדוק שמזהה המשתתף מופיע בתבנית הנכונה","moreButtonGalleryControlLabel":"הצג","moreButtonGalleryPositionToggleLabel":"העבר את הגלריה לחלק העליון","moreButtonGallerySpeakerLayoutLabel":"רמקול","moreButtonGalleryFloatingLocalLayoutLabel":"דינמי","moreButtonGalleryDefaultLayoutLabel":"תצוגת גלריה","moreButtonGalleryFocusedContentLayoutLabel":"התמקדות בתוכן","moreButtonLargeGalleryDefaultLayoutLabel":"גלריה גדולה","moreButtonTogetherModeLayoutLabel":"מצב ביחד","capabilityChangedNotification":{"turnVideoOn":{"lostDueToMeetingOption":"המצלמה שלך הפכה ללא זמינה. כבר אינך יכול לשתף וידאו.","grantedDueToMeetingOption":"המצלמה שלך הפכה לזמינה. הפעל אותה אם ברצונך לשתף וידאו."},"unmuteMic":{"lostDueToMeetingOption":"המיקרופון שלך הפך ללא זמין. לא ניתן עוד לבטל השתקה.","grantedDueToMeetingOption":"המיקרופון שלך הפך לזמין. בטל את ההשתקה אם ברצונך לדבר."},"shareScreen":{"lostDueToRoleChangeToAttendee":"התפקיד שלך השתנה. פעולות מסוימות, כגון שיתוף תוכן, לא יהיו זמינות עבורך.","grantedDueToRoleChangeToPresenter":"אתה מציג. באפשרותך לשתף תוכן ולסייע בפגישה."},"hideAttendeeNames":{"hideAttendeeNameAttendee":"שמך מוסתר ממשתתפים אחרים. מארגנים ומציגים יכולים לראות את שמך האמיתי.","hideAttendeeNamePresenter":"שמות המשתתפים מוסתרים. רק מארגנים ומציגים יכולים לראות את השמות, כדי להגן על פרטיות המשתתפים."}},"surveyTitle":"עזור לנו להשתפר","starSurveyHelperText":"מה היתה האיכות של שיחה זו?","starSurveyOneStarText":"האיכות הייתה גרועה.","starSurveyTwoStarText":"האיכות הייתה ירודה.","starSurveyThreeStarText":"האיכות הייתה טובה.","starSurveyFourStarText":"האיכות הייתה מעולה.","starSurveyFiveStarText":"האיכות הייתה מצוינת.","surveyConfirmButtonLabel":"שלח משוב","starRatingAriaLabel":"בחר {0} מתוך {1} כוכבים","surveySkipButtonLabel":"דלג","tagsSurveyQuestion":"מה יכול היה להיות טוב יותר?","tagsSurveyTextFieldDefaultText":"אחר, נא לציין","tagsSurveyHelperText":"בדוק את כל הבעיות שבהן נתקלת","endOfSurveyText":"תודה על המשוב!","surveyIssues":{"overallRating":{"callCannotJoin":"לא הצלחתי להצטרף לשיחה","callCannotInvite":"לא הצלחתי להזמין אחרים לשיחה","hadToRejoin":"הייתי צריך להצטרף מחדש לשיחה","callEndedUnexpectedly":"השיחה הסתיימה עבורי באופן בלתי צפוי","otherIssues":"נתקלתי בבעיות אחרות בשיחה"},"audioRating":{"noLocalAudio":"הצד השני בשיחה לא הצליח לשמוע שום צליל","noRemoteAudio":"לא יכולתי לשמוע אף צליל","echo":"שמעתי קולות הד בשיחה","audioNoise":"שמעתי רעש בשיחה","lowVolume":"עוצמת הקול הייתה נמוכה","audioStoppedUnexpectedly":"השמע הופסק באופן בלתי צפוי","distortedSpeech":"השמע היה מעוות","audioInterruption":"השמע הופסק","otherIssues":"נתקלתי בבעיות שמע אחרות בשיחה זו"},"videoRating":{"noVideoReceived":"לא ראיתי את הצד השני","noVideoSent":"אנשים אחרים לא הצליחו לראות אותי","lowQuality":"איכות הווידאו הייתה נמוכה","freezes":"הווידאו קפא","stoppedUnexpectedly":"הווידאו נעצר באופן בלתי צפוי","darkVideoReceived":"אני יכול לראות רק מסכים כהים כאשר אחרים מפעילים את המצלמה שלהם","audioVideoOutOfSync":"השמע והווידאו לא היו מסונכרנים","otherIssues":"נתקלתי בבעיות וידאו אחרות בשיחה זו"},"screenshareRating":{"noContentLocal":"אנשים אחרים לא הצליחו לראות את שיתוף המסך שלי","noContentRemote":"לא הצלחתי לראות את שיתוף המסך של אנשים אחרים","cannotPresent":"לא הצלחתי להציג את המסך שלי","lowQuality":"איכות שיתוף המסך הייתה נמוכה","freezes":"שיתוף מסך הוקפא","stoppedUnexpectedly":"שיתוף המסך הופסק באופן בלתי צפוי","largeDelay":"לשיתוף המסך יש עיכוב גדול","otherIssues":"נתקלתי בבעיות אחרות בשיתוף מסכים בשיחה זו"}},"surveyIssuesHeadingStrings":{"overallRating":"סך הכל","audioRating":"שם ציוד השמע","videoRating":"סרטון","screenshareRating":"מציג"},"spotlightPrompt":{"startSpotlightHeading":"לסמן בזרקור עבור כולם?","startSpotlightText":"תסמן סרטון וידאו זה עבור כל האנשים בפגישה.","startSpotlightOnSelfText":"תסמן את סרטון הווידאו שלך עבור כל האנשים בפגישה.","startSpotlightConfirmButtonLabel":"הצבת זרקור עבור כולם","startSpotlightCancelButtonLabel":"ביטול","stopSpotlightHeading":"להפסיק להאיר בזרקור וידאו זה?","stopSpotlightOnSelfHeading":"לצאת מזרקור?","stopAllSpotlightHeading":"להפסיק להציב זרקור על כל סרטוני הווידאו?","stopSpotlightText":"וידאו זה לא יסומן עוד עבור כל האנשים בפגישה.","stopSpotlightOnSelfText":"סרטון הווידאו שלך לא יסומן עוד עבור כל האנשים בפגישה.","stopAllSpotlightText":"סרטוני הווידאו לא יסומנו עוד עבור כל האנשים בפגישה.","stopSpotlightConfirmButtonLabel":"הפסק להציב זרקור","stopSpotlightOnSelfConfirmButtonLabel":"צא מזרקור","stopSpotlightCancelButtonLabel":"ביטול","closeSpotlightPromptButtonLabel":"סגור"},"exitSpotlightButtonLabel":"צא מהזרקור","exitSpotlightButtonTooltip":"צא מהזרקור","leaveConfirmButtonLabel":"צא","endCallConfirmButtonLabel":"סיים שיחה","hangUpCancelButtonLabel":"ביטול","leaveConfirmDialogTitle":"לצאת מהשיחה?","leaveConfirmDialogContent":"האם אתה בטוח שברצונך לעזוב את השיחה?","endCallConfirmDialogTitle":"לסיים את השיחה?","endCallConfirmDialogContent":"פעולה זאת תסיים את השיחה עבור כל המשתתפים.","invalidMeetingIdentifier":"מזהה פגישה או קוד סיסמה לא חוקיים","pinParticipantMenuLabel":"הצמד עבורי","pinParticipantLimitReachedMenuLabel":"הצמדה (הגעת למגבלה)","unpinParticipantMenuLabel":"בטל הצמדה","pinParticipantMenuItemAriaLabel":"הצמד עבורי","unpinParticipantMenuItemAriaLabel":"בטל הצמדה","muteAllMenuLabel":"השתק הכל","muteAllDialogTitle":"האם להשתיק את כולם?","muteAllDialogContent":"פעולה זו תשתיק את כל האנשים בפגישה חוץ ממך.","muteAllConfirmButtonLabel":"השתק הכל","muteAllCancelButtonLabel":"ביטול","joinBreakoutRoomButtonLabel":"הצטרף לחדר בריחה","returnFromBreakoutRoomButtonLabel":"עזוב את החדר","leaveBreakoutRoomAndMeetingButtonLabel":"עזוב פגישה","breakoutRoomJoinedNotificationTitle":"הצטרפת לפיצול חדרים '{roomName}'","joinBreakoutRoomBannerTitle":"פיצול החדרים '{roomName}' פתוח","joinBreakoutRoomBannerButtonLabel":"הצטרף","returnFromBreakoutRoomBannerTitle":"חזרה לפגישה הראשית","returnFromBreakoutRoomBannerButtonLabel":"הצטרף מחדש","forbidAudioMenuLabel":"הפוך את המיקרופון ללא זמין","permitAudioMenuLabel":"אפשר שימוש במיקרופון","forbidOthersAudioDialogTitle":"האם להפוך מיקרופון ללא זמין למשתתפים?","forbidOthersAudioDialogContent":"משתתפים לא יוכלו לבטל את ההשתקה שלהם. המארגן והמציגים יכולים לאפשר לאנשים לבטל השתקה לפי הצורך.","forbidOthersAudioConfirmButtonLabel":"הפוך את המיקרופונים ללא זמינים","forbidOthersAudioCancelButtonLabel":"ביטול","permitOthersAudioDialogTitle":"האם לאפשר שימוש במיקרופון עבור המשתתפים?","permitOthersAudioDialogContent":"כל האנשים בפגישה יוכלו לבטל את ההשתקה של עצמם.","permitOthersAudioConfirmButtonLabel":"אפשר שימוש במיקרופונים","permitOthersAudioCancelButtonLabel":"ביטול","forbidOthersAudioMenuLabel":"הפוך את המיקרופון ללא זמין עבור המשתתפים","permitOthersAudioMenuLabel":"אפשר למשתתפים להשתמש במיקרופון","forbidVideoMenuLabel":"הפוך את המצלמה ללא זמינה","permitVideoMenuLabel":"אפשר שימוש במצלמה","forbidOthersVideoDialogTitle":"האם להפוך את המצלמה ללא זמינה עבור המשתתפים?","forbidOthersVideoDialogContent":"משתתפים לא יוכלו להפעיל וידאו בעצמם. המארגן והמציגים יכולים לאפשר לאנשים להפעיל את המצלמה לפי הצורך.","forbidOthersVideoConfirmButtonLabel":"הפוך את המצלמות ללא זמינות","forbidOthersVideoCancelButtonLabel":"ביטול","permitOthersVideoDialogTitle":"האם לאפשר שימוש במצלמה עבור המשתתפים?","permitOthersVideoDialogContent":"כל המשתתפים בפגישה יוכלו להפעיל וידאו בעצמם.","permitOthersVideoConfirmButtonLabel":"אפשר שימוש במצלמות","permitOthersVideoCancelButtonLabel":"ביטול","forbidOthersVideoMenuLabel":"הפוך את המצלמה ללא זמינה עבור משתתפים","permitOthersVideoMenuLabel":"אפשר למשתתפים גישה למצלמה"}`),chat:{chatListHeader:"בצ'אט זה",uploadAttachment:"העלה קובץ מצורף",uploadImageDataNotProvided:"נתוני התמונה לא סופקו.",uploadImageIsTooLarge:"התמונה גדולה מדי. בחר אחד קטן יותר מ{maxImageSize} MB.",uploadImageExtensionIsNotAllowed:"העלאת תמונה {imageExtension} אסורה.",uploadImageFailed:"לא ניתן להעלות את התמונה. נסה שוב מאוחר יותר."},callWithChat:{chatButtonLabel:"צ'אט",chatButtonNewMessageNotificationLabel:"הודעה חדשה",chatButtonTooltipClosedWithMessageCount:"הצג צ'אט ({unreadMessagesCount} שלא נקראו)",chatButtonTooltipClose:"הסתר צ׳אט",chatButtonTooltipOpen:"הצג צ'אט",chatPaneTitle:"צ'אט",copyInviteLinkButtonLabel:"העתק קישור להזמנה",copyInviteLinkButtonActionedLabel:"הקישור הועתק",copyInviteLinkActionedAriaLabel:"קישור ההזמנה הועתק",dismissSidePaneButtonLabel:"סגור",moreDrawerAudioDeviceMenuTitle:"התקן שמע",moreDrawerButtonLabel:"אפשרויות נוספות",moreDrawerButtonTooltip:"אפשרויות נוספות",moreDrawerMicrophoneMenuTitle:"מיקרופון",moreDrawerSpeakerMenuTitle:"רמקול",moreDrawerCaptionsMenuTitle:"כתוביות חיות",moreDrawerSpokenLanguageMenuTitle:"שפה מדוברת",moreDrawerCaptionLanguageMenuTitle:"שפת כתוביות",moreDrawerGalleryOptionsMenuTitle:"אפשרויות גלריה",peopleButtonLabel:"אנשים",selectedPeopleButtonLabel:"לחצן 'אנשים' נבחר",peopleButtonTooltipOpen:"הצג משתתפים",peopleButtonTooltipClose:"הסתר משתתפים",peopleButtonTooltipOpenAriaLabel:"לחצן אנשים, הצג משתתפים",peopleButtonTooltipCloseAriaLabel:"לחצן אנשים, הסתר משתתפים",peoplePaneSubTitle:"בשיחה זו",peoplePaneTitle:"אנשים",pictureInPictureTileAriaLabel:"הזנות וידאו. לחץ כדי לחזור למסך השיחה.",removeMenuLabel:"הסר",openDialpadButtonLabel:"חייג למספר הטלפון",returnToCallButtonAriaDescription:"חזור לשיחה",returnToCallButtonAriaLabel:"הקודם",peoplePaneAddPeopleButtonLabel:"הוסף אנשים",dialpadStartCallButtonLabel:"שיחה",dialpadModalTitle:"חייג למספר הטלפון",dialpadModalAriaLabel:"לוח חיוג",dialpadCloseModalButtonAriaLabel:"סגור לוח חיוג",openDtmfDialpadLabel:"הצג לוח חיוג",dtmfDialpadPlaceholderText:"הזן מספר",breakoutRoomChatPaneTitle:"צ'אט פיצול חדרים",chatContentSpinnerLabel:"טוען את הצ'אט"}})},Tli={component:mQt,strings:Yh({call:JSON.parse(`{"cameraLabel":"Fotocamera","noCamerasLabel":"Nessuna fotocamera trovata","cameraPermissionDenied":"Il browser blocca l'accesso alla fotocamera","cameraTurnedOff":"La videocamera è disabilitata","chatButtonLabel":"Chat","close":"Chiudi","complianceBannerNowOnlyRecording":"È in corso la registrazione solo di questa riunione.","complianceBannerNowOnlyTranscription":"È in corso la trascrizione solo di questa riunione.","complianceBannerRecordingAndTranscriptionSaved":"È in corso il salvataggio della registrazione e della trascrizione.","complianceBannerRecordingAndTranscriptionStarted":"Registrazione e trascrizione avviate.","complianceBannerRecordingAndTranscriptionStopped":"Registrazione e trascrizione interrotte.","complianceBannerRecordingSaving":"Salvataggio della registrazione in corso.","complianceBannerRecordingStarted":"Registrazione avviata.","complianceBannerRecordingStopped":"Registrazione arrestata.","complianceBannerTranscriptionStarted":"Trascrizione avviata.","complianceBannerTranscriptionConsent":"Partecipando, fornisci il consenso per la trascrizione di questa riunione.","complianceBannerTranscriptionSaving":"È in corso il salvataggio della trascrizione.","complianceBannerTranscriptionStopped":"Trascrizione interrotta.","configurationPageTitle":"Avvia una chiamata","copyInviteLinkButtonLabel":"Copia il collegamento dell’invito","copyInviteLinkButtonActionedLabel":"Collegamento copiato","copyInviteLinkActionedAriaLabel":"Collegamento di invito copiato","defaultPlaceHolder":"Seleziona un'opzione","dismissSidePaneButtonLabel":"Chiudi","videoEffectsPaneTitle":"Effetti","videoEffectsPaneBackgroundSelectionTitle":"In background","videoEffectsPaneAriaLabel":"Riquadro Effetti video","configurationPageCameraIsLoadingLabel":"Il video è in corso di caricamento ...","configurationPageVideoEffectsButtonLabel":"Effetti","unableToStartVideoEffect":"Non è possibile applicare l'effetto video.","blurBackgroundEffectButtonLabel":"Sfocatura","blurBackgroundTooltip":"Sfoca sfondo","removeBackgroundEffectButtonLabel":"Nessuno","removeBackgroundTooltip":"Rimuovi sfondo","cameraOffBackgroundEffectWarningText":"La fotocamera è disattivata. Attiva la fotocamera per vedere l'effetto video.","failedToJoinCallDueToNoNetworkMoreDetails":"La chiamata è stata disconnessa a causa di un problema di rete. Controlla la connessione e partecipa di nuovo.","failedToJoinCallDueToNoNetworkTitle":"Chiamata interrotta","failedToJoinTeamsMeetingReasonAccessDeniedMoreDetails":"Non ti è stato concesso l’accesso alla chiamata. Se si è trattato di un errore, partecipa di nuovo alla chiamata.","failedToJoinTeamsMeetingReasonAccessDeniedTitle":"Ignorato dalla sala di attesa","learnMore":"Ulteriori informazioni","leavingCallTitle":"In uscita...","leftCallMoreDetails":"Se si è trattato di un errore, partecipa di nuovo alla chiamata.","leftCallTitle":"Hai abbandonato la chiamata","lobbyScreenConnectingToCallTitle":"Partecipazione alla chiamata","lobbyScreenWaitingToBeAdmittedTitle":"In attesa di essere ammessi","microphonePermissionDenied":"Il browser blocca l'accesso al microfono","microphoneToggleInLobbyNotAllowed":"Impossibile attivare o disattivare l'audio nella sala di attesa.","mutedMessage":"L'audio è disattivato.","networkReconnectMoreDetails":"Sembra si sia verificato un errore. Stiamo cercando di ristabilire la connessione alla chiamata.","networkReconnectTitle":"Attendi","notInvitedToRoomDetails":"Non puoi partecipare a questa chat room perché non hai un invito.","notInvitedToRoomTitle":"Non invitato alla stanza","peopleButtonLabel":"Persone","selectedPeopleButtonLabel":"Pulsante Persone selezionato","peoplePaneTitle":"Persone","peoplePaneMoreButtonAriaLabel":"Altro","peopleButtonTooltipOpen":"Mostra partecipanti","peopleButtonTooltipClose":"Nascondi partecipanti","peoplePaneSubTitle":"In questa chiamata {numberOfPeople}","privacyPolicy":"Informativa sulla privacy","rejoinCallButtonLabel":"Partecipa alla chiamata","removedFromCallMoreDetails":"Un altro partecipante ti ha rimosso dalla chiamata.","removedFromCallTitle":"Sei stato rimosso","removeMenuLabel":"Rimuovi","startSpotlightMenuLabel":"Metti in evidenza per tutti","addSpotlightMenuLabel":"Metti in evidenza","stopSpotlightMenuLabel":"Interrompi la posizione in evidenza","stopSpotlightOnSelfMenuLabel":"Chiudi visualizzazione in evidenza","spotlightLimitReachedMenuTitle":"È stato raggiunto il limite di contenuti in evidenza","stopAllSpotlightMenuLabel":"Smetti di mostrare in evidenza","returnToCallButtonAriaDescription":"Torna alla chiamata","returnToCallButtonAriaLabel":"Indietro","roomNotFoundDetails":"L'ID stanza specificato non è stato trovato.","roomNotFoundTitle":"La stanza non è stata trovata","roomNotValidDetails":"Questa stanza non è valida in questo momento.","roomNotValidTitle":"Stanza non valida","inviteToRoomRemovedDetails":"L'invito a partecipare a questa stanza è stato rimosso.","inviteToRoomRemovedTitle":"L’invito alla stanza è stato rimosso","soundLabel":"Suono","noMicrophonesLabel":"Nessun microfono trovato","noSpeakersLabel":"Nessun altoparlante trovato","startCallButtonLabel":"Avvia chiamata","openDialpadButtonLabel":"Componi il numero di telefono","peoplePaneAddPeopleButtonLabel":"Aggiungi persone","dialpadStartCallButtonLabel":"Chiamata","dialpadModalTitle":"Componi il numero di telefono","dialpadModalAriaLabel":"Tastiera","dialpadCloseModalButtonAriaLabel":"Chiudi tastiera","moreButtonCallingLabel":"Altro","resumeCallButtonLabel":"Riprendi","resumingCallButtonLabel":"Ripresa in corso...","resumeCallButtonAriaLabel":"Riprendi chiamata","resumingCallButtonAriaLabel":"Riprendi chiamata","holdScreenLabel":"In attesa.","openDtmfDialpadLabel":"Mostra tastiera","dtmfDialpadPlaceholderText":"Immetti il numero","outboundCallingNoticeString":"Chiamata in corso...","participantJoinedNoticeString":"{displayName} si è unito alla riunione","twoParticipantJoinedNoticeString":"{displayName1} e {displayName2} si sono uniti alla riunione","threeParticipantJoinedNoticeString":"{displayName1}, {displayName2} e {displayName3} si sono uniti alla riunione","participantLeftNoticeString":"{displayName} è uscito dalla riunione","twoParticipantLeftNoticeString":"{displayName1} e {displayName2} sono usciti dalla riunione","threeParticipantLeftNoticeString":"{displayName1}, {displayName2} e {displayName3} sono usciti dalla riunione","unnamedParticipantString":"partecipante senza nome","manyUnnamedParticipantsJoined":"partecipante senza nome e {numOfParticipants} altri partecipanti si sono uniti alla riunione","manyUnnamedParticipantsLeft":"partecipante senza nome e {numOfParticipants} altri partecipanti sono usciti dalla riunione","manyParticipantsJoined":"{displayName1}, {displayName2}, {displayName3} e {numOfParticipants} altri partecipanti si sono uniti","manyParticipantsLeft":"{displayName1}, {displayName2}, {displayName3} e {numOfParticipants} altri partecipanti rimasti","liveCaptionsLabel":"Sottotitoli in tempo reale","captionsSettingsLabel":"Impostazioni sottotitoli","startCaptionsButtonOnLabel":"Attiva i sottotitoli","startCaptionsButtonOffLabel":"Disabilita sottotitoli","startCaptionsButtonTooltipOnContent":"Disabilita sottotitoli","startCaptionsButtonTooltipOffContent":"Attiva i sottotitoli","captionsSettingsModalTitle":"Impostazioni sottotitoli","captionsSettingsSpokenLanguageDropdownLabel":"Lingua parlata","captionsSettingsCaptionLanguageDropdownLabel":"Lingua dei sottotitoli","captionsSettingsSpokenLanguageDropdownInfoText":"La lingua che parlano tutti i partecipanti a questa chiamata.","captionsSettingsCaptionLanguageDropdownInfoText":"I sottotitoli verranno visualizzati in questa lingua.","captionsSettingsConfirmButtonLabel":"Conferma","captionsSettingsCancelButtonLabel":"Annulla","captionsSettingsModalAriaLabel":"Finestra modale impostazioni sottotitoli","captionsSettingsCloseModalButtonAriaLabel":"Chiudi impostazione sottotitoli","captionsBannerMoreButtonCallingLabel":"Altre opzioni Impostazioni sottotitoli","captionsBannerMoreButtonTooltip":"Altre opzioni","realTimeTextLabel":"Scrittura in tempo reale (RTT)","startRealTimeTextLabel":"Attiva la scrittura in tempo reale per questa chiamata","disabledStartRealTimeTextLabel":"RTT è attualmente attivato, non può essere disattivato","dismissModalAriaLabel":"Immagine e immagine locale e remota, premi INVIO per tornare alla chiamata","callRejectedTitle":"Non è stato possibile completare la chiamata","callRejectedMoreDetails":"La persona che stai tentando di raggiungere non è disponibile. Riprovare più tardi.","callTimeoutTitle":"Non è stato possibile completare la chiamata","callTimeoutDetails":"La persona che stai tentando di raggiungere non è disponibile. Riprovare più tardi.","callTimeoutBotTitle":"Non è stato possibile completare la chiamata","callTimeoutBotDetails":"Il servizio che si sta tentando di raggiungere non è disponibile. Riprovare più tardi.","dtmfDialerButtonLabel":"Tastiera","dtmfDialerButtonTooltipOn":"Mostra tastiera","dtmfDialerButtonTooltipOff":"Nascondi tastierino","dtmfDialerMoreButtonLabelOn":"Mostra tastiera","dtmfDialerMoreButtonLabelOff":"Nascondi tastierino","phoneCallMoreButtonLabel":"Chiamata telefonica","spokenLanguageStrings":{"ar-ae":"Arabo - Emirati Arabi Uniti","ar-sa":"Arabo - Arabia Saudita","da-dk":"Danese","de-de":"Tedesco - Germania","en-au":"Inglese - Australia","en-ca":"Inglese - Canada","en-gb":"Inglese - Regno Unito","en-in":"Inglese - India","en-nz":"Inglese - Nuova Zelanda","en-us":"Inglese - Stati Uniti","es-es":"Spagnolo - Spagna (ordinamento moderno)","es-mx":"Spagnolo - Messico","fi-fi":"Finlandese","fr-ca":"Francese - Canada","fr-fr":"Francese - Francia","hi-in":"Hindi","it-it":"Italiano - Italia","ja-jp":"Giapponese","ko-kr":"Coreano","nb-no":"Norvegese (Bokmål)","nl-be":"Olandese - Belgio","nl-nl":"Olandese - Paesi Bassi","pl-pl":"Polacco","pt-br":"Portoghese - Brasile","ru-ru":"Russo","sv-se":"Svedese","zh-cn":"Cinese - Repubblica popolare cinese","zh-hk":"Cinese - Hong Kong R.A.S.","cs-cz":"Ceco","pt-pt":"Portoghese - Portogallo","tr-tr":"Turco","vi-vn":"Vietnamita","th-th":"Thailandese","he-il":"Ebraico","cy-gb":"Gallese","uk-ua":"Ucraino","el-gr":"Greco","hu-hu":"Ungherese","ro-ro":"Rumeno","sk-sk":"Slovacco","zh-tw":"Cinese - Taiwan"},"captionLanguageStrings":{"ar":"Arabo","da":"Danese","de":"Tedesco","en":"Inglese","es":"Spagnolo","fi":"Finlandese","fr-ca":"Francese - Canada","fr":"Francese - Francia","hi":"Hindi","it":"Italiano","ja":"Giapponese","ko":"Coreano","nb":"Norvegese (Bokmål)","nl":"Olandese","pl":"Polacco","pt":"Portoghese - Brasile","ru":"Russo","sv":"Svedese","zh-Hans":"Cinese (semplificato)","zh-Hant":"Cinese (tradizionale)","cs":"Ceco","pt-pt":"Portoghese - Portogallo","tr":"Turco","vi":"Vietnamita","th":"Thailandese","he":"Ebraico","cy":"Gallese","uk":"Ucraino","el":"Greco","hu":"Ungherese","ro":"Rumeno","sk":"Slovacco"},"captionsBannerSpinnerText":"Avvio dei sottotitoli in corso...","realTimeTextInputBoxDefaultText":"Digita messaggio in tempo reale","realTimeTextInputErrorMessage":"Il messaggio non può superare i 2000 caratteri","realTimeTextBannerTitle":"Scrittura in tempo reale","realTimeTextBannerContent":"RTT (testo in tempo reale) è abilitato per tutti i partecipanti per l'intera durata della riunione.","realTimeTextBannerLinkLabel":"Scopri di più","realTimeTextModalAriaLabel":"Abilita finestra modale scrittura in tempo reale","realTimeTextModalTitle":"Abilitare la scrittura in tempo reale?","realTimeTextModalText":"Il testo in tempo reale verrà attivato per tutti gli utenti della riunione.","realTimeTextConfirmButtonLabel":"Abilita","realTimeTextCancelButtonLabel":"Annulla","realTimeTextCloseModalButtonAriaLabel":"Chiudi finestra modale scrittura in tempo reale","captionsOnlyContainerTitle":"Sottotitoli","realTimeTextOnlyContainerTitle":"Testo in tempo reale","captionsAndRealTimeTextContainerTitle":"Sottotitoli e testo in tempo reale","expandButtonAriaLabel":"Espandi","minimizeButtonAriaLabel":"Comprimi","transferPageTransferorText":"Trasferimento in corso...","transferPageTransferTargetText":"Connessione in corso...","transferPageUnknownTransferorDisplayName":"Sconosciuto","transferPageUnknownTransferTargetDisplayName":"Sconosciuto","transferPageNoticeString":"Stai per essere trasferito","participantCouldNotBeReachedTitle":"Il partecipante di riferimento non è attualmente disponibile","participantCouldNotBeReachedMoreDetails":"Contatta il partecipante quando è disponibile","permissionToReachTargetParticipantNotAllowedTitle":"L'autorizzazione per raggiungere il partecipante di riferimento non è consentita","permissionToReachTargetParticipantNotAllowedMoreDetails":"Verificare che il partecipante di riferimento si trovi nello stesso tenant","unableToResolveTenantTitle":"Non è possibile risolvere l'ID tenant per il partecipante di destinazione","unableToResolveTenantMoreDetails":"Verifica che l'ID partecipante sia stato immesso correttamente","participantIdIsMalformedTitle":"Il formato dell'ID partecipante non è corretto","participantIdIsMalformedMoreDetails":"Verifica che il formato dell'ID partecipante sia corretto","moreButtonGalleryControlLabel":"Visualizza","moreButtonGalleryPositionToggleLabel":"Sposta raccolta in alto","moreButtonGallerySpeakerLayoutLabel":"Altoparlante","moreButtonGalleryFloatingLocalLayoutLabel":"Dinamico","moreButtonGalleryDefaultLayoutLabel":"Visualizzazione raccolta","moreButtonGalleryFocusedContentLayoutLabel":"Focus sul contenuto","moreButtonLargeGalleryDefaultLayoutLabel":"Galleria estesa","moreButtonTogetherModeLayoutLabel":"Modalità Insieme","capabilityChangedNotification":{"turnVideoOn":{"lostDueToMeetingOption":"La fotocamera è stata disattivata. Non è più possibile condividere video.","grantedDueToMeetingOption":"La fotocamera è stata abilitata. Attivala se vuoi condividere il video."},"unmuteMic":{"lostDueToMeetingOption":"Il microfono è stato disabilitato. Non puoi più riattivare l'audio.","grantedDueToMeetingOption":"Il microfono è stato abilitato. Riattiva l'audio se vuoi parlare."},"shareScreen":{"lostDueToRoleChangeToAttendee":"Il tuo ruolo è stato modificato. Alcune azioni, come la condivisione di contenuti, non saranno disponibili per te.","grantedDueToRoleChangeToPresenter":"Sei un relatore. Puoi condividere i contenuti e facilitare la riunione."},"hideAttendeeNames":{"hideAttendeeNameAttendee":"Il tuo nome è nascosto agli altri partecipanti. Gli organizzatori e i relatori possono vedere il tuo vero nome.","hideAttendeeNamePresenter":"I nomi dei partecipanti sono nascosti. Solo gli organizzatori e i relatori possono visualizzare i nomi per proteggere la privacy dei partecipanti."}},"surveyTitle":"Aiutaci a migliorare","starSurveyHelperText":"Come valuti la qualità della chiamata?","starSurveyOneStarText":"La qualità era pessima.","starSurveyTwoStarText":"La qualità era scadente.","starSurveyThreeStarText":"La qualità era buona.","starSurveyFourStarText":"La qualità era ottima.","starSurveyFiveStarText":"La qualità è stata eccellente.","surveyConfirmButtonLabel":"Invia feedback","starRatingAriaLabel":"Seleziona {0} di {1} stelle","surveySkipButtonLabel":"Salta","tagsSurveyQuestion":"Cosa avrebbe potuto essere migliore?","tagsSurveyTextFieldDefaultText":"Altro, specifica","tagsSurveyHelperText":"Controlla eventuali problemi riscontrati","endOfSurveyText":"Grazie per il feedback!","surveyIssues":{"overallRating":{"callCannotJoin":"Non sono riuscito a partecipare alla chiamata","callCannotInvite":"Non ho potuto invitare altri partecipanti alla chiamata","hadToRejoin":"Ho dovuto partecipare di nuovo alla chiamata","callEndedUnexpectedly":"La chiamata è terminata per me in modo imprevisto","otherIssues":"Ho avuto altri problemi con la chiamata"},"audioRating":{"noLocalAudio":"L'altro utente non mi sentiva","noRemoteAudio":"Non riuscivo a sentire niente","echo":"Ho sentito eco durante la chiamata","audioNoise":"Ho sentito rumore durante la chiamata","lowVolume":"Il volume era basso","audioStoppedUnexpectedly":"L’audio si è interrotto improvvisamente","distortedSpeech":"L'audio era distorto","audioInterruption":"L'audio è stato interrotto","otherIssues":"Ho avuto altri problemi audio in questa chiamata"},"videoRating":{"noVideoReceived":"Non vedevo nulla","noVideoSent":"Gli altri utenti non potevano vedermi","lowQuality":"La qualità del video era bassa","freezes":"Video bloccato","stoppedUnexpectedly":"Il video si è interrotto improvvisamente","darkVideoReceived":"Posso vedere gli schermi scuri solo quando altri utenti accendono la fotocamera","audioVideoOutOfSync":"Audio e immagini non erano sincronizzati","otherIssues":"Ho avuto altri problemi video in questa chiamata"},"screenshareRating":{"noContentLocal":"Altre persone non possono vedere la condivisione dello schermo","noContentRemote":"Non ho potuto visualizzare la condivisione dello schermo di altre persone","cannotPresent":"Non ho potuto presentare lo schermo","lowQuality":"La qualità della condivisione dello schermo è bassa","freezes":"Condivisione schermo bloccata","stoppedUnexpectedly":"Condivisione dello schermo interrotta in modo imprevisto","largeDelay":"La condivisione dello schermo presenta un ritardo elevato","otherIssues":"Ho avuto altri problemi di condivisione dello schermo in questa chiamata"}},"surveyIssuesHeadingStrings":{"overallRating":"Generale","audioRating":"Audio","videoRating":"Video","screenshareRating":"Presentazione in corso"},"spotlightPrompt":{"startSpotlightHeading":"Mettere in evidenza per tutti?","startSpotlightText":"Questo video sarà in evidenza per tutti i partecipanti alla riunione.","startSpotlightOnSelfText":"Il tuo video sarà in evidenza per tutti i partecipanti alla riunione.","startSpotlightConfirmButtonLabel":"Metti in evidenza per tutti","startSpotlightCancelButtonLabel":"Annulla","stopSpotlightHeading":"Smettere di mostrare in evidenza questo video?","stopSpotlightOnSelfHeading":"Uscire dalla messa in evidenza?","stopAllSpotlightHeading":"Vuoi smettere di mostrare in evidenza tutti i video?","stopSpotlightText":"Questo video non sarà più in evidenza per tutti i partecipanti alla riunione.","stopSpotlightOnSelfText":"Il tuo video non sarà più in evidenza per tutti i partecipanti alla riunione.","stopAllSpotlightText":"I video non saranno più in evidenza per tutti i partecipanti della riunione.","stopSpotlightConfirmButtonLabel":"Smetti di mettere in evidenza","stopSpotlightOnSelfConfirmButtonLabel":"Esci da visualizzazione in evidenza","stopSpotlightCancelButtonLabel":"Annulla","closeSpotlightPromptButtonLabel":"Chiudi"},"exitSpotlightButtonLabel":"Esci da visualizzazione in evidenza","exitSpotlightButtonTooltip":"Esci da visualizzazione in evidenza","leaveConfirmButtonLabel":"Abbandona","endCallConfirmButtonLabel":"Termina chiamata","hangUpCancelButtonLabel":"Annulla","leaveConfirmDialogTitle":"Vuoi abbandonare la chiamata?","leaveConfirmDialogContent":"Vuoi abbandonare la chiamata?","endCallConfirmDialogTitle":"Vuoi terminare la chiamata?","endCallConfirmDialogContent":"La chiamata terminerà per tutti gli utenti.","invalidMeetingIdentifier":"ID riunione o passcode non valido","pinParticipantMenuLabel":"Aggiungi per me","pinParticipantLimitReachedMenuLabel":"Segnaposto (limite raggiunto)","unpinParticipantMenuLabel":"Rimuovere dall’alto","pinParticipantMenuItemAriaLabel":"Aggiungi per me","unpinParticipantMenuItemAriaLabel":"Rimuovere dall’alto","muteAllMenuLabel":"Disattivare l'audio di tutti","muteAllDialogTitle":"Disattivare l'audio di tutti?","muteAllDialogContent":"Questa operazione disattiverà l'audio di tutte le persone nella riunione, tranne te.","muteAllConfirmButtonLabel":"Disattivare l'audio di tutti","muteAllCancelButtonLabel":"Annullare","joinBreakoutRoomButtonLabel":"Partecipa al gruppo di lavoro","returnFromBreakoutRoomButtonLabel":"Esci dalla stanza","leaveBreakoutRoomAndMeetingButtonLabel":"Abbandona riunione","breakoutRoomJoinedNotificationTitle":"Sei stato aggiunto alla stanza di lavoro '{roomName}'","joinBreakoutRoomBannerTitle":"La stanza di lavoro '{roomName}' è aperta","joinBreakoutRoomBannerButtonLabel":"Partecipa","returnFromBreakoutRoomBannerTitle":"Torna alla riunione principale","returnFromBreakoutRoomBannerButtonLabel":"Partecipa di nuovo","forbidAudioMenuLabel":"Disabilita microfono","permitAudioMenuLabel":"Consenti microfono","forbidOthersAudioDialogTitle":"Disabilita il microfono dei partecipanti?","forbidOthersAudioDialogContent":"I partecipanti non potranno riattivare l'audio. L'organizzatore e i relatori possono consentire ai partecipanti di riattivare l'audio se necessario.","forbidOthersAudioConfirmButtonLabel":"Disabilita microfoni","forbidOthersAudioCancelButtonLabel":"Annulla","permitOthersAudioDialogTitle":"Consentire il microfono dei partecipanti?","permitOthersAudioDialogContent":"Tutti i partecipanti alla riunione saranno in grado di riattivare l’audio.","permitOthersAudioConfirmButtonLabel":"Consenti microfoni","permitOthersAudioCancelButtonLabel":"Annulla","forbidOthersAudioMenuLabel":"Disabilita il microfono dei partecipanti","permitOthersAudioMenuLabel":"Abilita il microfono dei partecipanti","forbidVideoMenuLabel":"Disabilita videocamera","permitVideoMenuLabel":"Consenti videocamera","forbidOthersVideoDialogTitle":"Disabilitare la videocamera dei partecipanti?","forbidOthersVideoDialogContent":"I partecipanti non potranno attivare autonomamente il video. L'organizzatore e i relatori possono consentire alle persone di attivare la fotocamera se necessario.","forbidOthersVideoConfirmButtonLabel":"Disabilita videocamere","forbidOthersVideoCancelButtonLabel":"Annulla","permitOthersVideoDialogTitle":"Consentire la videocamera dei partecipanti?","permitOthersVideoDialogContent":"Tutti gli utenti della riunione potranno attivare autonomamente il video.","permitOthersVideoConfirmButtonLabel":"Consenti videocamere","permitOthersVideoCancelButtonLabel":"Annulla","forbidOthersVideoMenuLabel":"Disabilita videocamera dei partecipanti","permitOthersVideoMenuLabel":"Consenti videocamera dei partecipanti"}`),chat:{chatListHeader:"In questa chat",uploadAttachment:"Carica allegato",uploadImageDataNotProvided:"I dati dell'immagine non sono stati forniti.",uploadImageIsTooLarge:"L'immagine è troppo grande. Scegliere un valore inferiore a {maxImageSize} MB.",uploadImageExtensionIsNotAllowed:"Il caricamento dell’immagine .{imageExtension} non è consentito.",uploadImageFailed:"Non è possibile caricare l'immagine. Riprovare più tardi."},callWithChat:{chatButtonLabel:"Chat",chatButtonNewMessageNotificationLabel:"Nuovo messaggio",chatButtonTooltipClosedWithMessageCount:"Mostra chat ({unreadMessagesCount} non letto)",chatButtonTooltipClose:"Nascondi chat",chatButtonTooltipOpen:"Mostra chat",chatPaneTitle:"Chat",copyInviteLinkButtonLabel:"Copia il collegamento dell’invito",copyInviteLinkButtonActionedLabel:"Collegamento copiato",copyInviteLinkActionedAriaLabel:"Collegamento di invito copiato",dismissSidePaneButtonLabel:"Chiudi",moreDrawerAudioDeviceMenuTitle:"Dispositivo audio",moreDrawerButtonLabel:"Altre opzioni",moreDrawerButtonTooltip:"Altre opzioni",moreDrawerMicrophoneMenuTitle:"Microfono",moreDrawerSpeakerMenuTitle:"Altoparlante",moreDrawerCaptionsMenuTitle:"Sottotitoli in tempo reale",moreDrawerSpokenLanguageMenuTitle:"Lingua parlata",moreDrawerCaptionLanguageMenuTitle:"Lingua sottotitoli",moreDrawerGalleryOptionsMenuTitle:"Opzioni della raccolta",peopleButtonLabel:"Persone",selectedPeopleButtonLabel:"Pulsante Persone selezionato",peopleButtonTooltipOpen:"Mostra partecipanti",peopleButtonTooltipClose:"Nascondi partecipanti",peopleButtonTooltipOpenAriaLabel:"pulsante Persone, Mostra partecipanti",peopleButtonTooltipCloseAriaLabel:"Pulsante Persone, Nascondi partecipanti",peoplePaneSubTitle:"In questa chiamata",peoplePaneTitle:"Persone",pictureInPictureTileAriaLabel:"Feed video. Fare clic per tornare alla schermata della chiamata.",removeMenuLabel:"Rimuovi",openDialpadButtonLabel:"Componi il numero di telefono",returnToCallButtonAriaDescription:"Torna alla chiamata",returnToCallButtonAriaLabel:"Indietro",peoplePaneAddPeopleButtonLabel:"Aggiungi persone",dialpadStartCallButtonLabel:"Chiamata",dialpadModalTitle:"Componi il numero di telefono",dialpadModalAriaLabel:"Tastiera",dialpadCloseModalButtonAriaLabel:"Chiudi tastiera",openDtmfDialpadLabel:"Mostra tastiera",dtmfDialpadPlaceholderText:"Immetti il numero",breakoutRoomChatPaneTitle:"Chat della stanza di lavoro",chatContentSpinnerLabel:"Caricamento della chat"}})},Cli={component:fQt,strings:Yh({call:JSON.parse(`{"cameraLabel":"カメラ","noCamerasLabel":"カメラが見つかりません","cameraPermissionDenied":"お使いのブラウザーがカメラへのアクセスをブロックしています","cameraTurnedOff":"カメラはオフになっています","chatButtonLabel":"チャット","close":"閉じる","complianceBannerNowOnlyRecording":"今はこの会議の録画のみを行っています。","complianceBannerNowOnlyTranscription":"この会議のトランスクリプトを作成しています。","complianceBannerRecordingAndTranscriptionSaved":"レコーディングとトランスクリプトを保存されました。","complianceBannerRecordingAndTranscriptionStarted":"レコーディングとトランスクリプトが開始されました。","complianceBannerRecordingAndTranscriptionStopped":"レコーディングとトランスクリプトを停止しました。","complianceBannerRecordingSaving":"レコーディングを保存しています。","complianceBannerRecordingStarted":"レコーディングを開始しました。","complianceBannerRecordingStopped":"レコーディングを停止しました。","complianceBannerTranscriptionStarted":"トランスクリプトが開始しました。","complianceBannerTranscriptionConsent":"参加すると、この会議のトランスクリプトの作成に同意したことになります。","complianceBannerTranscriptionSaving":"トランスクリプトを保存されました。","complianceBannerTranscriptionStopped":"トランスクリプトが停止しました。","configurationPageTitle":"通話を開始","copyInviteLinkButtonLabel":"招待用のリンクをコピー","copyInviteLinkButtonActionedLabel":"リンクをコピーしました","copyInviteLinkActionedAriaLabel":"招待用のリンクがコピーされました","defaultPlaceHolder":"オプションを選択する","dismissSidePaneButtonLabel":"閉じる","videoEffectsPaneTitle":"効果","videoEffectsPaneBackgroundSelectionTitle":"バックグラウンド","videoEffectsPaneAriaLabel":"ビデオ効果ウィンドウ","configurationPageCameraIsLoadingLabel":"ビデオの読み込み中です...","configurationPageVideoEffectsButtonLabel":"効果","unableToStartVideoEffect":"ビデオ効果を適用できません。","blurBackgroundEffectButtonLabel":"ぼかし","blurBackgroundTooltip":"背景をぼかす","removeBackgroundEffectButtonLabel":"なし","removeBackgroundTooltip":"背景の削除","cameraOffBackgroundEffectWarningText":"カメラがオフになっています。カメラをオンにすると、ビデオ効果が表示されます。","failedToJoinCallDueToNoNetworkMoreDetails":"ネットワークの問題により、通話が切断されました。接続を確認して、もう一度参加してください。","failedToJoinCallDueToNoNetworkTitle":"通話が切断されました","failedToJoinTeamsMeetingReasonAccessDeniedMoreDetails":"通話のエントリが許可されませんでした。これが間違いだった場合は、通話に再参加してください。","failedToJoinTeamsMeetingReasonAccessDeniedTitle":"ロビーから消去しました","learnMore":"詳細情報","leavingCallTitle":"退出中...","leftCallMoreDetails":"これが間違いだった場合は、通話に再度参加してください。","leftCallTitle":"通話を終了しました","lobbyScreenConnectingToCallTitle":"通話に参加中","lobbyScreenWaitingToBeAdmittedTitle":"承認待機中","microphonePermissionDenied":"お使いのブラウザーがマイクへのアクセスをブロックしています","microphoneToggleInLobbyNotAllowed":"ロビーにいる間はミュートまたはミュート解除できません。","mutedMessage":"ミュートになっています","networkReconnectMoreDetails":"問題が発生したようです。通話に戻ろうとしています。","networkReconnectTitle":"お待ちください","notInvitedToRoomDetails":"招待がないため、このルームに参加できません。","notInvitedToRoomTitle":"ルームに招待されていません","peopleButtonLabel":"連絡先","selectedPeopleButtonLabel":"[ユーザー] ボタンが選択されました","peoplePaneTitle":"連絡先","peoplePaneMoreButtonAriaLabel":"その他","peopleButtonTooltipOpen":"参加者を表示","peopleButtonTooltipClose":"参加者を非表示","peoplePaneSubTitle":"この通話では {numberOfPeople} 人","privacyPolicy":"プライバシー ポリシー","rejoinCallButtonLabel":"通話に再度参加","removedFromCallMoreDetails":"別の参加者があなたを通話から削除しました。","removedFromCallTitle":"削除されました","removeMenuLabel":"削除","startSpotlightMenuLabel":"全員にスポットライトを設定","addSpotlightMenuLabel":"スポットライトを追加","stopSpotlightMenuLabel":"スポットライトの設定を解除","stopSpotlightOnSelfMenuLabel":"スポットライトを終了","spotlightLimitReachedMenuTitle":"スポットライトの上限に達しました","stopAllSpotlightMenuLabel":"すべてのスポットライトを停止","returnToCallButtonAriaDescription":"通話に戻る","returnToCallButtonAriaLabel":"戻る","roomNotFoundDetails":"指定されたルーム ID が見つかりませんでした。","roomNotFoundTitle":"ルームが見つかりません","roomNotValidDetails":"このルームは現在無効です。","roomNotValidTitle":"ルームが無効です","inviteToRoomRemovedDetails":"このルームに参加するための招待が削除されました。","inviteToRoomRemovedTitle":"ルームへの招待が削除されました","soundLabel":"音声","noMicrophonesLabel":"マイクが見つかりません","noSpeakersLabel":"話者が見つかりません","startCallButtonLabel":"通話を開始","openDialpadButtonLabel":"電話番号をダイヤルする","peoplePaneAddPeopleButtonLabel":"ユーザーの追加","dialpadStartCallButtonLabel":"通話","dialpadModalTitle":"電話番号をダイヤルする","dialpadModalAriaLabel":"ダイヤルパッド","dialpadCloseModalButtonAriaLabel":"ダイヤルパッドを閉じる","moreButtonCallingLabel":"その他","resumeCallButtonLabel":"再開","resumingCallButtonLabel":"再開しています...","resumeCallButtonAriaLabel":"通話の再開","resumingCallButtonAriaLabel":"通話の再開","holdScreenLabel":"保留中です","openDtmfDialpadLabel":"ダイヤルパッドを表示","dtmfDialpadPlaceholderText":"番号を入力してください","outboundCallingNoticeString":"呼び出し中。。。","participantJoinedNoticeString":"{displayName} が参加しました","twoParticipantJoinedNoticeString":"{displayName1} さんと {displayName2} さんが参加しました","threeParticipantJoinedNoticeString":"{displayName1} さん, {displayName2} さんと {displayName3} さんが参加しました","participantLeftNoticeString":"{displayName} さんが退出しました","twoParticipantLeftNoticeString":"{displayName1} さんと {displayName2} さんが退出しました","threeParticipantLeftNoticeString":"{displayName1} さん, {displayName2} さんと {displayName3} さんが退出しました","unnamedParticipantString":"名前のない参加者","manyUnnamedParticipantsJoined":"名前のない参加者と他の参加者 {numOfParticipants} 人が参加しました","manyUnnamedParticipantsLeft":"名前のない参加者と他の参加者 {numOfParticipants} 人が退出しました","manyParticipantsJoined":"{displayName1}、{displayName2}、{displayName3}、その他の参加者{numOfParticipants}参加しました","manyParticipantsLeft":"{displayName1}、{displayName2}、{displayName3}、その他の参加者{numOfParticipants}退出しました","liveCaptionsLabel":"ライブ キャプション","captionsSettingsLabel":"字幕の設定","startCaptionsButtonOnLabel":"キャプションをオンにする","startCaptionsButtonOffLabel":"キャプションをオフにする","startCaptionsButtonTooltipOnContent":"キャプションをオフにする","startCaptionsButtonTooltipOffContent":"キャプションをオンにする","captionsSettingsModalTitle":"ライブ キャプションの設定","captionsSettingsSpokenLanguageDropdownLabel":"音声言語","captionsSettingsCaptionLanguageDropdownLabel":"ライブ キャプションの言語","captionsSettingsSpokenLanguageDropdownInfoText":"この通話の全員が話している言語です。","captionsSettingsCaptionLanguageDropdownInfoText":"キャプションはこの言語で表示されます。","captionsSettingsConfirmButtonLabel":"確認","captionsSettingsCancelButtonLabel":"キャンセル","captionsSettingsModalAriaLabel":"字幕設定モーダル","captionsSettingsCloseModalButtonAriaLabel":"字幕設定を閉じる","captionsBannerMoreButtonCallingLabel":"キャプション設定のその他のオプション","captionsBannerMoreButtonTooltip":"その他のオプション","realTimeTextLabel":"リアルタイム テキスト (RTT)","startRealTimeTextLabel":"この呼び出しの RTT を有効にする","disabledStartRealTimeTextLabel":"RTT は現在オンになっています。オフにすることはできません","dismissModalAriaLabel":"ローカルとリモートの画像と画像。通話に戻るには Enter キーを押します","callRejectedTitle":"通話を完了できませんでした","callRejectedMoreDetails":"連絡を取ろうとしているユーザーは利用できません。後でもう一度お試しください。","callTimeoutTitle":"通話を完了できませんでした","callTimeoutDetails":"連絡を取ろうとしているユーザーは利用できません。後でもう一度お試しください。","callTimeoutBotTitle":"通話を完了できませんでした","callTimeoutBotDetails":"接続しようとしているサービスは利用できません。後でもう一度お試しください。","dtmfDialerButtonLabel":"ダイヤルパッド","dtmfDialerButtonTooltipOn":"ダイヤルパッドを表示","dtmfDialerButtonTooltipOff":"ダイヤル パッドを非表示","dtmfDialerMoreButtonLabelOn":"ダイヤルパッドを表示","dtmfDialerMoreButtonLabelOff":"ダイヤル パッドを非表示","phoneCallMoreButtonLabel":"電話での通話","spokenLanguageStrings":{"ar-ae":"アラビア語 - U.A.E.","ar-sa":"アラビア語 - サウジアラビア","da-dk":"デンマーク語","de-de":"ドイツ語 - ドイツ","en-au":"英語 - オーストラリア","en-ca":"英語 - カナダ","en-gb":"英語 - イギリス","en-in":"英語 - インド","en-nz":"英語 - ニュージーランド","en-us":"英語 - 米国","es-es":"スペイン語 - スペイン (モダン)","es-mx":"スペイン語 - メキシコ","fi-fi":"フィンランド語","fr-ca":"フランス語 - カナダ","fr-fr":"フランス語 - フランス","hi-in":"ヒンディー語","it-it":"イタリア語 - イタリア","ja-jp":"日本語","ko-kr":"韓国語","nb-no":"ノルウェー語 (ブークモール)","nl-be":"オランダ語 - ベルギー","nl-nl":"オランダ語 - オランダ","pl-pl":"ポーランド語","pt-br":"ポルトガル語 - ブラジル","ru-ru":"ロシア語","sv-se":"スウェーデン語","zh-cn":"中国語 - 中国","zh-hk":"中国語 - 香港特別行政区","cs-cz":"チェコ語","pt-pt":"ポルトガル語 - ポルトガル","tr-tr":"トルコ語","vi-vn":"ベトナム語","th-th":"タイ語","he-il":"ヘブライ語","cy-gb":"ウェールズ語","uk-ua":"ウクライナ語","el-gr":"ギリシャ語","hu-hu":"ハンガリー語","ro-ro":"ルーマニア語","sk-sk":"スロバキア語","zh-tw":"中国語 - 台湾"},"captionLanguageStrings":{"ar":"アラビア語","da":"デンマーク語","de":"ドイツ語","en":"英語","es":"スペイン語","fi":"フィンランド語","fr-ca":"フランス語 - カナダ","fr":"フランス語 - フランス","hi":"ヒンディー語","it":"イタリア語","ja":"日本語","ko":"韓国語","nb":"ノルウェー語 (ブークモール)","nl":"オランダ語","pl":"ポーランド語","pt":"ポルトガル語 - ブラジル","ru":"ロシア語","sv":"スウェーデン語","zh-Hans":"中国語 (簡体字)","zh-Hant":"中国語 (繁体字)","cs":"チェコ語","pt-pt":"ポルトガル語 - ポルトガル","tr":"トルコ語","vi":"ベトナム語","th":"タイ語","he":"ヘブライ語","cy":"ウェールズ語","uk":"ウクライナ語","el":"ギリシャ語","hu":"ハンガリー語","ro":"ルーマニア語","sk":"スロバキア語"},"captionsBannerSpinnerText":"キャプションを開始しています...","realTimeTextInputBoxDefaultText":"リアルタイムにメッセージを入力","realTimeTextInputErrorMessage":"メッセージは 2,000 文字以下にする必要があります","realTimeTextBannerTitle":"RTT","realTimeTextBannerContent":"RTT (リアルタイム テキスト) は、会議の全期間のすべての参加者に対して有効になっています。","realTimeTextBannerLinkLabel":"詳細情報","realTimeTextModalAriaLabel":"RTT モーダルを有効にする","realTimeTextModalTitle":"RTT を有効にしますか?","realTimeTextModalText":"会議の全員に対してリアルタイム テキスト (RTT) が有効になります。","realTimeTextConfirmButtonLabel":"有効にする","realTimeTextCancelButtonLabel":"キャンセル","realTimeTextCloseModalButtonAriaLabel":"RTT モーダルを閉じる","captionsOnlyContainerTitle":"キャプション","realTimeTextOnlyContainerTitle":"リアルタイム テキスト","captionsAndRealTimeTextContainerTitle":"キャプションとリアルタイム テキスト","expandButtonAriaLabel":"展開","minimizeButtonAriaLabel":"折りたたむ","transferPageTransferorText":"転送しています...","transferPageTransferTargetText":"接続中...","transferPageUnknownTransferorDisplayName":"不明","transferPageUnknownTransferTargetDisplayName":"不明","transferPageNoticeString":"転送中です","participantCouldNotBeReachedTitle":"ターゲットの参加者は現在連絡できません","participantCouldNotBeReachedMoreDetails":"参加者が連絡可能になったら連絡してください","permissionToReachTargetParticipantNotAllowedTitle":"ターゲットの参加者への連絡が許可されていません","permissionToReachTargetParticipantNotAllowedMoreDetails":"ターゲットの参加者が同じテナントにいることを確認してください","unableToResolveTenantTitle":"ターゲット参加者のテナント ID を解決できません","unableToResolveTenantMoreDetails":"参加者 ID が正しく入力チェックしてください","participantIdIsMalformedTitle":"参加者 ID の形式が正しくありません","participantIdIsMalformedMoreDetails":"参加者 ID の形式が正しいことをチェックしてください","moreButtonGalleryControlLabel":"表示","moreButtonGalleryPositionToggleLabel":"ギャラリーを上に移動","moreButtonGallerySpeakerLayoutLabel":"スピーカー","moreButtonGalleryFloatingLocalLayoutLabel":"ダイナミック","moreButtonGalleryDefaultLayoutLabel":"ギャラリー ビュー","moreButtonGalleryFocusedContentLayoutLabel":"コンテンツにフォーカスを移動","moreButtonLargeGalleryDefaultLayoutLabel":"ラージ ギャラリー","moreButtonTogetherModeLayoutLabel":"Together モード","capabilityChangedNotification":{"turnVideoOn":{"lostDueToMeetingOption":"カメラが無効になっています。ビデオを共有できなくなりました。","grantedDueToMeetingOption":"カメラが有効になりました。ビデオを共有する場合はオンにします。"},"unmuteMic":{"lostDueToMeetingOption":"マイクが無効になっています。ミュートを解除できません。","grantedDueToMeetingOption":"マイクが有効になりました。音声機能を使用する場合は、ミュートを解除します。"},"shareScreen":{"lostDueToRoleChangeToAttendee":"ロールが変更されました。コンテンツの共有などの一部の操作は利用できません。","grantedDueToRoleChangeToPresenter":"あなたは発表者です。コンテンツの共有と会議の進行を行うことができます。"},"hideAttendeeNames":{"hideAttendeeNameAttendee":"自分の名前は他の出席者には表示されません。開催者と発表者にあなたの名前が表示されます。","hideAttendeeNamePresenter":"出席者の名前は非表示です。出席者のプライバシーを守るため、開催者と発表者のみ名前を見ることができます。"}},"surveyTitle":"品質向上にご協力ください","starSurveyHelperText":"通話の音質はどうでしたか?","starSurveyOneStarText":"品質が悪かった。","starSurveyTwoStarText":"品質は低かった。","starSurveyThreeStarText":"品質は良かった。","starSurveyFourStarText":"品質は優れていた。","starSurveyFiveStarText":"品質は非常に優れていた。","surveyConfirmButtonLabel":"フィードバックの送信","starRatingAriaLabel":"{1} 個中 {0} 個の星を選択する","surveySkipButtonLabel":"スキップ","tagsSurveyQuestion":"何が良くなりましたか?","tagsSurveyTextFieldDefaultText":"その他、特定してください","tagsSurveyHelperText":"発生した問題を確認する","endOfSurveyText":"フィードバックをお送りいただき、ありがとうございます。","surveyIssues":{"overallRating":{"callCannotJoin":"通話に参加できなかった","callCannotInvite":"他のユーザーを通話に招待できなかった","hadToRejoin":"通話にもう参加し直す必要があった","callEndedUnexpectedly":"通話が突然終了した","otherIssues":"通話で他の問題が発生していた"},"audioRating":{"noLocalAudio":"相手側で音が聞こえませんでした","noRemoteAudio":"音がまったく聞こえなかった","echo":"通話でエコーが聞こえた","audioNoise":"通話中にノイズが聞こえた","lowVolume":"音量が小さかった","audioStoppedUnexpectedly":"オーディオが突然停止した","distortedSpeech":"オーディオが歪んでいた","audioInterruption":"オーディオが中断された","otherIssues":"この通話で他のオーディオの問題があった"},"videoRating":{"noVideoReceived":"ビデオを表示できなかった","noVideoSent":"他のユーザーに自分が表示されなかった","lowQuality":"ビデオの品質が低かった","freezes":"ビデオがフリーズした","stoppedUnexpectedly":"ビデオが突然停止した","darkVideoReceived":"他のユーザーがカメラをオンにした場合にのみ暗い画面を表示できる","audioVideoOutOfSync":"オーディオとビデオがずれている","otherIssues":"この通話で他のビデオの問題があった"},"screenshareRating":{"noContentLocal":"他のユーザーが自分の画面共有を表示できなかった","noContentRemote":"他のユーザーのスクリーン共有が表示されなかった","cannotPresent":"画面をプレゼンテーションできなかった","lowQuality":"画面共有の品質が低かった","freezes":"画面共有がフリーズした","stoppedUnexpectedly":"画面共有が突然停止した","largeDelay":"画面共有に大きな遅延がある","otherIssues":"この通話で他の画面共有の問題があった"}},"surveyIssuesHeadingStrings":{"overallRating":"全体","audioRating":"オーディオ","videoRating":"動画","screenshareRating":"発表中"},"spotlightPrompt":{"startSpotlightHeading":"全員にスポットライトを設定しますか?","startSpotlightText":"会議の全員にこのビデオをハイライトします。","startSpotlightOnSelfText":"会議の全員にビデオをハイライトします。","startSpotlightConfirmButtonLabel":"全員にスポットライトを設定","startSpotlightCancelButtonLabel":"キャンセル","stopSpotlightHeading":"このビデオへのスポットライトの設定を解除しますか?","stopSpotlightOnSelfHeading":"スポットライトを終了しますか?","stopAllSpotlightHeading":"すべてのビデオへのスポットライトの設定を解除しますか?","stopSpotlightText":"このビデオは、会議の全員に対して強調表示されなくなります。","stopSpotlightOnSelfText":"ビデオは、会議の全員に対して強調表示されなくなります。","stopAllSpotlightText":"ビデオは、会議の全員に対して強調表示されなくなります。","stopSpotlightConfirmButtonLabel":"スポットライトの設定を解除","stopSpotlightOnSelfConfirmButtonLabel":"スポットライトを終了","stopSpotlightCancelButtonLabel":"キャンセル","closeSpotlightPromptButtonLabel":"閉じる"},"exitSpotlightButtonLabel":"スポットライトを終了","exitSpotlightButtonTooltip":"スポットライトを終了","leaveConfirmButtonLabel":"退出","endCallConfirmButtonLabel":"通話の終了","hangUpCancelButtonLabel":"キャンセル","leaveConfirmDialogTitle":"通話から退出しますか?","leaveConfirmDialogContent":"通話から退出してよろしいですか?","endCallConfirmDialogTitle":"通話を終了しますか?","endCallConfirmDialogContent":"全員に対する通話が終了されます。","invalidMeetingIdentifier":"無効なミーティング ID またはパスコード","pinParticipantMenuLabel":"自分用にピン留め","pinParticipantLimitReachedMenuLabel":"ピン留め (上限に達しました)","unpinParticipantMenuLabel":"ピン留めを外す","pinParticipantMenuItemAriaLabel":"自分用にピン留め","unpinParticipantMenuItemAriaLabel":"ピン留めを外す","muteAllMenuLabel":"全員をミュート","muteAllDialogTitle":"全員をミュートにしますか?","muteAllDialogContent":"会議に参加している自分以外の全員がミュートになります。","muteAllConfirmButtonLabel":"全員をミュート","muteAllCancelButtonLabel":"取り消す","joinBreakoutRoomButtonLabel":"ブレークアウト ルームに参加","returnFromBreakoutRoomButtonLabel":"ルームから退出","leaveBreakoutRoomAndMeetingButtonLabel":"会議から退出","breakoutRoomJoinedNotificationTitle":"ブレークアウト ルーム '{roomName}' に参加しました","joinBreakoutRoomBannerTitle":"ブレークアウト ルーム '{roomName}' が開いています","joinBreakoutRoomBannerButtonLabel":"参加","returnFromBreakoutRoomBannerTitle":"メインの会議に戻る","returnFromBreakoutRoomBannerButtonLabel":"もう一度参加","forbidAudioMenuLabel":"マイクを無効にする","permitAudioMenuLabel":"マイクを許可する","forbidOthersAudioDialogTitle":"出席者のマイクを無効にしますか?","forbidOthersAudioDialogContent":"出席者は自身のミュートを解除できません。開催者と発表者は、必要に応じて出席者のミュートを解除できます。","forbidOthersAudioConfirmButtonLabel":"マイクを無効にする","forbidOthersAudioCancelButtonLabel":"キャンセル","permitOthersAudioDialogTitle":"出席者のマイクを許可しますか?","permitOthersAudioDialogContent":"会議に参加している全員が、ミュートを解除できます。","permitOthersAudioConfirmButtonLabel":"マイクを許可する","permitOthersAudioCancelButtonLabel":"キャンセル","forbidOthersAudioMenuLabel":"出席者のマイクを無効にする","permitOthersAudioMenuLabel":"出席者のマイクを許可する","forbidVideoMenuLabel":"カメラを無効にする","permitVideoMenuLabel":"カメラを許可する","forbidOthersVideoDialogTitle":"出席者のカメラを無効にしますか?","forbidOthersVideoDialogContent":"出席者は自分でビデオをオンにすることはできません。開催者と発表者は、必要に応じてカメラをオンにすることができます。","forbidOthersVideoConfirmButtonLabel":"カメラを無効にする","forbidOthersVideoCancelButtonLabel":"キャンセル","permitOthersVideoDialogTitle":"出席者のカメラを許可しますか?","permitOthersVideoDialogContent":"会議の参加者全員がビデオを自分でオンにできます。","permitOthersVideoConfirmButtonLabel":"カメラを許可する","permitOthersVideoCancelButtonLabel":"キャンセル","forbidOthersVideoMenuLabel":"出席者のカメラを無効にする","permitOthersVideoMenuLabel":"出席者のカメラを許可する"}`),chat:{chatListHeader:"このチャット内",uploadAttachment:"添付ファイルのアップロード",uploadImageDataNotProvided:"画像データが提供されていません。",uploadImageIsTooLarge:"画像が大きすぎます。{maxImageSize} MB 未満のものを選択してください。",uploadImageExtensionIsNotAllowed:".{imageExtension} 形式の画像はアップロードできません。",uploadImageFailed:"画像をアップロードできません。後でもう一度お試しください。"},callWithChat:{chatButtonLabel:"チャット",chatButtonNewMessageNotificationLabel:"新規メッセージ",chatButtonTooltipClosedWithMessageCount:"チャットを表示する ({unreadMessagesCount} 件の未読)",chatButtonTooltipClose:"チャットを非表示",chatButtonTooltipOpen:"チャットを表示",chatPaneTitle:"チャット",copyInviteLinkButtonLabel:"招待用のリンクをコピー",copyInviteLinkButtonActionedLabel:"リンクをコピーしました",copyInviteLinkActionedAriaLabel:"招待用のリンクがコピーされました",dismissSidePaneButtonLabel:"閉じる",moreDrawerAudioDeviceMenuTitle:"オーディオ デバイス",moreDrawerButtonLabel:"その他のオプション",moreDrawerButtonTooltip:"その他のオプション",moreDrawerMicrophoneMenuTitle:"マイク",moreDrawerSpeakerMenuTitle:"スピーカー",moreDrawerCaptionsMenuTitle:"ライブ キャプション",moreDrawerSpokenLanguageMenuTitle:"音声言語",moreDrawerCaptionLanguageMenuTitle:"字幕言語",moreDrawerGalleryOptionsMenuTitle:"ギャラリーのオプション",peopleButtonLabel:"ユーザー",selectedPeopleButtonLabel:"[ユーザー] ボタンが選択されました",peopleButtonTooltipOpen:"参加者を表示",peopleButtonTooltipClose:"参加者を非表示",peopleButtonTooltipOpenAriaLabel:"[ユーザー] ボタン、参加者を表示",peopleButtonTooltipCloseAriaLabel:"[ユーザー] ボタン、参加者を非表示",peoplePaneSubTitle:"この通話で",peoplePaneTitle:"ユーザー",pictureInPictureTileAriaLabel:"ビデオ フィード。 クリックすると通話画面に戻ります。",removeMenuLabel:"削除",openDialpadButtonLabel:"電話番号をダイヤルする",returnToCallButtonAriaDescription:"通話に戻る",returnToCallButtonAriaLabel:"戻る",peoplePaneAddPeopleButtonLabel:"ユーザーの追加",dialpadStartCallButtonLabel:"通話",dialpadModalTitle:"電話番号をダイヤルする",dialpadModalAriaLabel:"ダイヤルパッド",dialpadCloseModalButtonAriaLabel:"ダイヤルパッドを閉じる",openDtmfDialpadLabel:"ダイヤルパッドを表示",dtmfDialpadPlaceholderText:"番号を入力してください",breakoutRoomChatPaneTitle:"ブレークアウト ルーム チャット",chatContentSpinnerLabel:"チャットを読み込んでいます"}})},_li={component:vQt,strings:Yh({call:JSON.parse(`{"cameraLabel":"카메라","noCamerasLabel":"카메라를 찾을 수 없음","cameraPermissionDenied":"브라우저에서 카메라에 대한 액세스를 차단하고 있습니다.","cameraTurnedOff":"카메라가 꺼져 있음","chatButtonLabel":"채팅","close":"닫기","complianceBannerNowOnlyRecording":"이제 이 모임의 녹음/녹화만 진행합니다.","complianceBannerNowOnlyTranscription":"이제 이 모임의 전사만 진행합니다.","complianceBannerRecordingAndTranscriptionSaved":"녹음/녹화와 전사를 저장하는 중입니다.","complianceBannerRecordingAndTranscriptionStarted":"녹음/녹화와 전사를 시작했습니다.","complianceBannerRecordingAndTranscriptionStopped":"녹음/녹화와 전사를 중단했습니다.","complianceBannerRecordingSaving":"녹음/녹화를 저장하는 중입니다.","complianceBannerRecordingStarted":"녹음/녹화를 시작했습니다.","complianceBannerRecordingStopped":"녹음/녹화를 중단했습니다.","complianceBannerTranscriptionStarted":"전사를 시작했습니다.","complianceBannerTranscriptionConsent":"참가하면 이 모임이 전사되는 것에 동의하게 됩니다.","complianceBannerTranscriptionSaving":"전사를 저장하는 중입니다.","complianceBannerTranscriptionStopped":"전사를 중단했습니다.","configurationPageTitle":"통화 시작","copyInviteLinkButtonLabel":"초대 링크 복사","copyInviteLinkButtonActionedLabel":"링크 복사됨","copyInviteLinkActionedAriaLabel":"초대 링크를 복사함","defaultPlaceHolder":"옵션 선택","dismissSidePaneButtonLabel":"닫기","videoEffectsPaneTitle":"효과","videoEffectsPaneBackgroundSelectionTitle":"백그라운드","videoEffectsPaneAriaLabel":"동영상 효과 창","configurationPageCameraIsLoadingLabel":"비디오를 로드하는 중...","configurationPageVideoEffectsButtonLabel":"효과","unableToStartVideoEffect":"비디오 효과를 적용할 수 없습니다.","blurBackgroundEffectButtonLabel":"흐리기","blurBackgroundTooltip":"배경 흐리게","removeBackgroundEffectButtonLabel":"없음","removeBackgroundTooltip":"배경 제거","cameraOffBackgroundEffectWarningText":"카메라가 꺼져 있습니다. 비디오 효과를 보려면 카메라를 켜세요.","failedToJoinCallDueToNoNetworkMoreDetails":"네트워크 문제로 인해 통화 연결이 끊어졌습니다. 연결을 확인하고 다시 참가하세요.","failedToJoinCallDueToNoNetworkTitle":"통화 연결 끊김","failedToJoinTeamsMeetingReasonAccessDeniedMoreDetails":"통화에 참가할 수 있는 권한이 없습니다. 실수라면 통화에 다시 참가하세요.","failedToJoinTeamsMeetingReasonAccessDeniedTitle":"대기실에서 해제됐습니다.","learnMore":"자세한 정보","leavingCallTitle":"종료 중...","leftCallMoreDetails":"실수라면 통화에 다시 참가하세요.","leftCallTitle":"통화를 종료했습니다.","lobbyScreenConnectingToCallTitle":"통화에 참가","lobbyScreenWaitingToBeAdmittedTitle":"승인을 기다리는 중","microphonePermissionDenied":"브라우저에서 마이크에 대한 액세스를 차단하고 있습니다.","microphoneToggleInLobbyNotAllowed":"대기실에 있는 동안에는 음소거하거나 음소거를 해제할 수 없습니다.","mutedMessage":"음소거 되었습니다.","networkReconnectMoreDetails":"문제가 발생한 것 같습니다. 통화에 다시 연결하려고 합니다.","networkReconnectTitle":"잠시만","notInvitedToRoomDetails":"초대가 없으므로 이 채팅방에 참가할 수 없습니다.","notInvitedToRoomTitle":"소회의실에 초대되지 않음","peopleButtonLabel":"사용자","selectedPeopleButtonLabel":"사용자 단추 선택됨","peoplePaneTitle":"사용자","peoplePaneMoreButtonAriaLabel":"더 보기","peopleButtonTooltipOpen":"참가자 표시","peopleButtonTooltipClose":"참가자 숨기기","peoplePaneSubTitle":"이 통화에 {numberOfPeople}명","privacyPolicy":"개인 정보 취급 방침","rejoinCallButtonLabel":"통화 다시 참가","removedFromCallMoreDetails":"다른 참가자가 귀하를 통화에서 제거했습니다.","removedFromCallTitle":"통화에서 제거됐습니다.","removeMenuLabel":"제거","startSpotlightMenuLabel":"모두를 위한 스포트라이트","addSpotlightMenuLabel":"스포트라이트 추가","stopSpotlightMenuLabel":"스포트라이트 중지","stopSpotlightOnSelfMenuLabel":"스포트라이트 종료","spotlightLimitReachedMenuTitle":"스포트라이트 한도 도달","stopAllSpotlightMenuLabel":"모든 스포트라이트 중지","returnToCallButtonAriaDescription":"통화로 돌아가기","returnToCallButtonAriaLabel":"뒤로","roomNotFoundDetails":"제공된 소회의실 ID를 찾을 수 없습니다.","roomNotFoundTitle":"회의실을 찾을 수 없음","roomNotValidDetails":"현재 이 소회의실은 유효하지 않습니다.","roomNotValidTitle":"소회의실이 유효하지 않음","inviteToRoomRemovedDetails":"이 소회의실에 참가하기 위한 초대가 제거되었습니다.","inviteToRoomRemovedTitle":"소회의실 초대 제거됨","soundLabel":"소리","noMicrophonesLabel":"마이크를 찾을 수 없음","noSpeakersLabel":"스피커를 찾을 수 없음","startCallButtonLabel":"통화 시작","openDialpadButtonLabel":"전화 번호 전화 걸기","peoplePaneAddPeopleButtonLabel":"사용자 추가","dialpadStartCallButtonLabel":"통화","dialpadModalTitle":"전화 번호 전화 걸기","dialpadModalAriaLabel":"다이얼패드","dialpadCloseModalButtonAriaLabel":"다이얼패드 닫기","moreButtonCallingLabel":"기타","resumeCallButtonLabel":"계속","resumingCallButtonLabel":"다시 시작 중...","resumeCallButtonAriaLabel":"통화 다시 시작","resumingCallButtonAriaLabel":"통화 계속하기","holdScreenLabel":"대기 중입니다.","openDtmfDialpadLabel":"다이얼패드 표시","dtmfDialpadPlaceholderText":"번호 입력","outboundCallingNoticeString":"전화 거는 중...","participantJoinedNoticeString":"{displayName} 님이 참가","twoParticipantJoinedNoticeString":"{displayName1} 및 {displayName2} 님이 참가","threeParticipantJoinedNoticeString":"{displayName1}, {displayName2} 및 {displayName3} 님이 참가","participantLeftNoticeString":"{displayName} 님이 떠남","twoParticipantLeftNoticeString":"{displayName1} 및 {displayName2} 님이 떠남","threeParticipantLeftNoticeString":"{displayName1}, {displayName2} 및 {displayName3} 님이 떠남","unnamedParticipantString":"명명되지 않은 참가자","manyUnnamedParticipantsJoined":"명명되지 않은 참가자 및 {numOfParticipants}명의 다른 참가자가 참가","manyUnnamedParticipantsLeft":"명명되지 않은 참가자 및 {numOfParticipants}명의 다른 참가자가 떠남","manyParticipantsJoined":"{displayName1}, {displayName2}, {displayName3} 및 {numOfParticipants} 다른 참가자가 참가했습니다.","manyParticipantsLeft":"{displayName1}, {displayName2}, {displayName3} 및 다른 참가자 {numOfParticipants} 남음","liveCaptionsLabel":"라이브 캡션","captionsSettingsLabel":"캡션 설정","startCaptionsButtonOnLabel":"캡션 켜기","startCaptionsButtonOffLabel":"캡션 끄기","startCaptionsButtonTooltipOnContent":"캡션 끄기","startCaptionsButtonTooltipOffContent":"캡션 켜기","captionsSettingsModalTitle":"캡션 설정","captionsSettingsSpokenLanguageDropdownLabel":"음성 언어","captionsSettingsCaptionLanguageDropdownLabel":"캡션 언어","captionsSettingsSpokenLanguageDropdownInfoText":"이 통화의 모든 사람이 말하는 언어입니다.","captionsSettingsCaptionLanguageDropdownInfoText":"캡션은 이 언어로 표시됩니다.","captionsSettingsConfirmButtonLabel":"확인하기","captionsSettingsCancelButtonLabel":"취소하기","captionsSettingsModalAriaLabel":"캡션 설정 모달","captionsSettingsCloseModalButtonAriaLabel":"캡션 설정 닫기","captionsBannerMoreButtonCallingLabel":"캡션 설정 추가 옵션","captionsBannerMoreButtonTooltip":"기타 옵션","realTimeTextLabel":"실시간 텍스트(RTT)","startRealTimeTextLabel":"이 통화에 대한 RTT 켜기","disabledStartRealTimeTextLabel":"RTT가 현재 켜져 있으므로 끌 수 없습니다.","dismissModalAriaLabel":"로컬 및 원격 사진 및 그림, Enter 키를 눌러 통화로 돌아가기","callRejectedTitle":"통화를 완료할 수 없습니다.","callRejectedMoreDetails":"연결하려는 사용자와 지금 대화할 수 없습니다. 나중에 다시 시도하세요.","callTimeoutTitle":"통화를 완료할 수 없습니다.","callTimeoutDetails":"연결하려는 사용자와 지금 대화할 수 없습니다. 나중에 다시 시도하세요.","callTimeoutBotTitle":"통화를 완료할 수 없습니다.","callTimeoutBotDetails":"연결하려는 서비스를 사용할 수 없습니다. 나중에 다시 시도하세요.","dtmfDialerButtonLabel":"다이얼패드","dtmfDialerButtonTooltipOn":"다이얼패드 표시","dtmfDialerButtonTooltipOff":"다이얼패드 숨기기","dtmfDialerMoreButtonLabelOn":"다이얼패드 표시","dtmfDialerMoreButtonLabelOff":"다이얼패드 숨기기","phoneCallMoreButtonLabel":"전화 통화","spokenLanguageStrings":{"ar-ae":"아랍어 - 아랍에미리트","ar-sa":"아라비아어 - 사우디 아라비아","da-dk":"덴마크어","de-de":"독일어 - 독일","en-au":"영어 - 오스트레일리아","en-ca":"영어 - 캐나다","en-gb":"영어 - 영국","en-in":"영어 - 인도","en-nz":"영어 - 뉴질랜드","en-us":"영어 - 미국","es-es":"스페인어 - 스페인(현대 정렬)","es-mx":"스페인어 - 멕시코","fi-fi":"핀란드어","fr-ca":"프랑스어 - 캐나다","fr-fr":"프랑스어 - 프랑스","hi-in":"힌디어","it-it":"이탈리아어 - 이탈리아","ja-jp":"일본어","ko-kr":"한국어","nb-no":"노르웨이어(복말)","nl-be":"네덜란드어 - 벨기에","nl-nl":"네덜란드어 - 네덜란드","pl-pl":"폴란드어","pt-br":"포르투갈어 - 브라질","ru-ru":"러시아어","sv-se":"스웨덴어","zh-cn":"중국어 - 중국","zh-hk":"중국어 - 홍콩 특별 행정구","cs-cz":"체코어","pt-pt":"포르투갈어 - 포르투갈","tr-tr":"터키어","vi-vn":"베트남어","th-th":"태국어","he-il":"히브리어","cy-gb":"웨일스어","uk-ua":"우크라이나어","el-gr":"그리스어","hu-hu":"헝가리어","ro-ro":"루마니아어","sk-sk":"슬로바키아어","zh-tw":"중국어 - 대만"},"captionLanguageStrings":{"ar":"아랍어","da":"덴마크어","de":"독일어","en":"영어","es":"스페인어","fi":"핀란드어","fr-ca":"프랑스어 - 캐나다","fr":"프랑스어 - 프랑스","hi":"힌디어","it":"이탈리아어","ja":"일본어","ko":"한국어","nb":"노르웨이어(복말)","nl":"네덜란드어","pl":"폴란드어","pt":"포르투갈어 - 브라질","ru":"러시아어","sv":"스웨덴어","zh-Hans":"중국어(간체)","zh-Hant":"중국어(번체)","cs":"체코어","pt-pt":"포르투갈어 - 포르투갈","tr":"터키어","vi":"베트남어","th":"태국어","he":"히브리어","cy":"웨일스어","uk":"우크라이나어","el":"그리스어","hu":"헝가리어","ro":"루마니아어","sk":"슬로바키아어"},"captionsBannerSpinnerText":"캡션을 시작하는 중...","realTimeTextInputBoxDefaultText":"실시간으로 메시지 입력","realTimeTextInputErrorMessage":"메시지는 2000자를 초과할 수 없음","realTimeTextBannerTitle":"실시간 입력","realTimeTextBannerContent":"전체 모임 기간 동안 모든 참가자에 대해 RTT(실시간 텍스트)를 사용할 수 있습니다.","realTimeTextBannerLinkLabel":"자세한 정보","realTimeTextModalAriaLabel":"실시간 입력 모달 사용","realTimeTextModalTitle":"실시간 입력을 사용하시겠습니까?","realTimeTextModalText":"모임의 모든 사용자에 대해 RTT(실시간 텍스트)가 켜집니다.","realTimeTextConfirmButtonLabel":"사용","realTimeTextCancelButtonLabel":"취소","realTimeTextCloseModalButtonAriaLabel":"실시간 입력 모달 닫기","captionsOnlyContainerTitle":"캡션","realTimeTextOnlyContainerTitle":"실시간 텍스트","captionsAndRealTimeTextContainerTitle":"캡션 및 실시간 텍스트","expandButtonAriaLabel":"펼치기","minimizeButtonAriaLabel":"접기","transferPageTransferorText":"전송 중...","transferPageTransferTargetText":"연결 중...","transferPageUnknownTransferorDisplayName":"알 수 없음","transferPageUnknownTransferTargetDisplayName":"알 수 없음","transferPageNoticeString":"통화가 전달되고 있습니다.","participantCouldNotBeReachedTitle":"대상 참가자를 현재 사용할 수 없습니다.","participantCouldNotBeReachedMoreDetails":"참가자를 사용할 수 있는 경우 참가자에게 문의하세요.","permissionToReachTargetParticipantNotAllowedTitle":"대상 참가자에 연결할 수 있는 권한이 허용되지 않습니다.","permissionToReachTargetParticipantNotAllowedMoreDetails":"대상 참가자가 동일한 테넌트에 있는지 검사.","unableToResolveTenantTitle":"대상 참가자의 테넌트 ID를 resolve 수 없습니다.","unableToResolveTenantMoreDetails":"참가자 ID가 올바르게 입력되었는지 검사.","participantIdIsMalformedTitle":"참가자 ID의 형식이 잘못되었습니다.","participantIdIsMalformedMoreDetails":"참가자 ID가 올바른 형식인지 검사.","moreButtonGalleryControlLabel":"보기","moreButtonGalleryPositionToggleLabel":"갤러리를 맨 위로 이동","moreButtonGallerySpeakerLayoutLabel":"발표자","moreButtonGalleryFloatingLocalLayoutLabel":"동적","moreButtonGalleryDefaultLayoutLabel":"갤러리 보기","moreButtonGalleryFocusedContentLayoutLabel":"콘텐츠에 포커스 맞추기","moreButtonLargeGalleryDefaultLayoutLabel":"대형 갤러리","moreButtonTogetherModeLayoutLabel":"함께 모드","capabilityChangedNotification":{"turnVideoOn":{"lostDueToMeetingOption":"카메라를 사용할 수 없습니다. 더 이상 비디오를 공유할 수 없습니다.","grantedDueToMeetingOption":"카메라를 사용하도록 설정했습니다. 비디오를 공유하려면 켜세요."},"unmuteMic":{"lostDueToMeetingOption":"마이크를 사용할 수 없습니다. 더 이상 음소거를 해제할 수 없습니다.","grantedDueToMeetingOption":"마이크 사용 가능합니다. 말하려면 음소거를 해제하세요."},"shareScreen":{"lostDueToRoleChangeToAttendee":"역할이 변경되었습니다. 콘텐츠 공유와 같은 일부 작업은 사용할 수 없습니다.","grantedDueToRoleChangeToPresenter":"귀하는 발표자입니다. 콘텐츠를 공유하고 모임을 활성화할 수 있습니다."},"hideAttendeeNames":{"hideAttendeeNameAttendee":"다른 참석자가 내 이름을 볼 수 없도록 숨겨집니다. 주최자와 발표자는 내 실명을 볼 수 있습니다.","hideAttendeeNamePresenter":"참석자 이름이 숨겨집니다. 참석자 개인 정보를 보호하기 위해 주최자와 발표자만 이름을 볼 수 있습니다."}},"surveyTitle":"사용자 환경 개선","starSurveyHelperText":"통화 품질은 어떠했습니까?","starSurveyOneStarText":"품질이 매우 나쁩니다.","starSurveyTwoStarText":"품질이 나쁩니다.","starSurveyThreeStarText":"품질이 좋습니다.","starSurveyFourStarText":"품질이 매우 좋습니다.","starSurveyFiveStarText":"품질이 매우 좋았습니다.","surveyConfirmButtonLabel":"피드백 보내기","starRatingAriaLabel":"별 {0}/{1}개 선택","surveySkipButtonLabel":"건너뛰기","tagsSurveyQuestion":"개선할 사항을 알려주세요.","tagsSurveyTextFieldDefaultText":"기타(구체적으로)","tagsSurveyHelperText":"발생한 문제를 확인하세요.","endOfSurveyText":"피드백을 보내주셔서 감사합니다!","surveyIssues":{"overallRating":{"callCannotJoin":"통화에 참가할 수 없습니다.","callCannotInvite":"다른 사람을 통화에 초대할 수 없습니다.","hadToRejoin":"통화에 다시 참가해야 했습니다.","callEndedUnexpectedly":"예기치 않게 통화가 종료되었습니다.","otherIssues":"통화에 다른 문제가 발생했습니다."},"audioRating":{"noLocalAudio":"상대방이 아무 소리도 듣지 못합니다","noRemoteAudio":"아무 소리도 들리지 않습니다.","echo":"통화에서 에코가 들립니다.","audioNoise":"통화 중에 잡음이 들렸습니다.","lowVolume":"볼륨이 작습니다","audioStoppedUnexpectedly":"오디오가 예기치 않게 중지됨","distortedSpeech":"오디오가 왜곡되었습니다.","audioInterruption":"오디오가 중단되었습니다.","otherIssues":"이 통화에서 다른 오디오 문제가 발생했습니다."},"videoRating":{"noVideoReceived":"영상이 표시되지 않았습니다.","noVideoSent":"다른 사용자가 나를 볼 수 없습니다.","lowQuality":"비디오 품질이 낮음","freezes":"비디오 동결","stoppedUnexpectedly":"영상이 중간에 멈췄습니다.","darkVideoReceived":"다른 사람이 카메라를 켤 때만 어두운 화면을 볼 수 있습니다.","audioVideoOutOfSync":"오디오 및 비디오가 동기화되지 않았습니다.","otherIssues":"이 통화에서 다른 비디오 문제가 발생했습니다."},"screenshareRating":{"noContentLocal":"다른 사용자가 내 화면 공유를 볼 수 없습니다.","noContentRemote":"다른 사람의 화면 공유를 볼 수 없습니다.","cannotPresent":"내 화면을 표시할 수 없습니다.","lowQuality":"화면 공유 품질이 낮음","freezes":"화면 공유가 고정되었습니다.","stoppedUnexpectedly":"화면 공유가 예기치 않게 중지됨","largeDelay":"화면 공유에 큰 지연이 있음","otherIssues":"이 통화에서 다른 화면 공유 문제가 있었습니다."}},"surveyIssuesHeadingStrings":{"overallRating":"전체","audioRating":"오디오","videoRating":"비디오","screenshareRating":"프레젠테이션 중"},"spotlightPrompt":{"startSpotlightHeading":"모든 사용자에게 스포트라이트하시겠습니까?","startSpotlightText":"모임에 참석한 모든 사용자에 대해 이 비디오를 강조합니다.","startSpotlightOnSelfText":"모임에 참석한 모든 사용자에 대해 비디오를 강조합니다.","startSpotlightConfirmButtonLabel":"모든 사용자에게 스포트라이트","startSpotlightCancelButtonLabel":"취소","stopSpotlightHeading":"이 비디오 스포트라이트를 중지할까요?","stopSpotlightOnSelfHeading":"스포트라이트를 종료하시겠습니까?","stopAllSpotlightHeading":"모든 비디오 스포트라이트를 중지할까요?","stopSpotlightText":"모임에 참석한 모든 사용자에게 이 비디오가 더 이상 강조되지 않습니다.","stopSpotlightOnSelfText":"모임에 참석한 모든 사용자에 대해 비디오가 더 이상 강조되지 않습니다.","stopAllSpotlightText":"해당 비디오는 모임에 참석한 모든 사용자에 대해 더 이상 강조되지 않습니다.","stopSpotlightConfirmButtonLabel":"스포트라이트 중지","stopSpotlightOnSelfConfirmButtonLabel":"스포트라이트 종료","stopSpotlightCancelButtonLabel":"취소","closeSpotlightPromptButtonLabel":"닫기"},"exitSpotlightButtonLabel":"스포트라이트 종료","exitSpotlightButtonTooltip":"스포트라이트 종료","leaveConfirmButtonLabel":"나가기","endCallConfirmButtonLabel":"통화 종료","hangUpCancelButtonLabel":"취소","leaveConfirmDialogTitle":"통화에서 나가시겠습니까?","leaveConfirmDialogContent":"통화에서 나가시겠습니까?","endCallConfirmDialogTitle":"통화를 종료하시겠습니까?","endCallConfirmDialogContent":"모든 사용자의 통화가 종료됩니다.","invalidMeetingIdentifier":"유효하지 않은 모임 ID 또는 암호","pinParticipantMenuLabel":"고정","pinParticipantLimitReachedMenuLabel":"고정(제한에 도달함)","unpinParticipantMenuLabel":"고정 해제","pinParticipantMenuItemAriaLabel":"고정","unpinParticipantMenuItemAriaLabel":"고정 해제","muteAllMenuLabel":"모두 음소거","muteAllDialogTitle":"모든 사용자를 음소거하시겠습니까?","muteAllDialogContent":"나를 제외한 모임 참여자를 모두 음소거합니다.","muteAllConfirmButtonLabel":"모두 음소거","muteAllCancelButtonLabel":"취소","joinBreakoutRoomButtonLabel":"소규모 회의실 참가","returnFromBreakoutRoomButtonLabel":"회의실 나가기","leaveBreakoutRoomAndMeetingButtonLabel":"모임 나가기","breakoutRoomJoinedNotificationTitle":"소규모 회의실 '{roomName}'에 참가했습니다.","joinBreakoutRoomBannerTitle":"소규모 회의실 '{roomName}'이(가) 열려 있습니다.","joinBreakoutRoomBannerButtonLabel":"참가","returnFromBreakoutRoomBannerTitle":"주 모임으로 돌아가기","returnFromBreakoutRoomBannerButtonLabel":"다시 참가","forbidAudioMenuLabel":"마이크 비활성화","permitAudioMenuLabel":"마이크 허용","forbidOthersAudioDialogTitle":"참석자의 마이크를 비활성화하시겠어요?","forbidOthersAudioDialogContent":"참석자 본인이 음소거를 해제할 수 없습니다. 모임의 이끌이와 발표자는 필요에 따라 사람들이 음소거를 해제하도록 설정할 수 있습니다.","forbidOthersAudioConfirmButtonLabel":"마이크를 비활성화","forbidOthersAudioCancelButtonLabel":"취소","permitOthersAudioDialogTitle":"참석자의 마이크 사용을 허용하시겠어요?","permitOthersAudioDialogContent":"모임의 모든 사용자가 직접 음소거를 해제할 수 있습니다.","permitOthersAudioConfirmButtonLabel":"마이크 허용","permitOthersAudioCancelButtonLabel":"취소","forbidOthersAudioMenuLabel":"참석자의 마이크 비활성화","permitOthersAudioMenuLabel":"참석자의 마이크 허용","forbidVideoMenuLabel":"카메라 비활성화","permitVideoMenuLabel":"카메라 허용","forbidOthersVideoDialogTitle":"참석자의 카메라 사용을 비활성화하시겠어요?","forbidOthersVideoDialogContent":"참석자는 비디오를 직접 켤 수 없습니다. 이끌이와 발표자가 필요에 따라 카메라를 켜도록 할 수 있습니다.","forbidOthersVideoConfirmButtonLabel":"카메라 비활성화","forbidOthersVideoCancelButtonLabel":"취소","permitOthersVideoDialogTitle":"참석자의 카메라 사용을 허용하시겠어요?","permitOthersVideoDialogContent":"모임의 모든 사용자가 비디오를 직접 켤 수 있습니다.","permitOthersVideoConfirmButtonLabel":"카메라 허용","permitOthersVideoCancelButtonLabel":"취소","forbidOthersVideoMenuLabel":"참석자의 카메라 비활성화","permitOthersVideoMenuLabel":"참석자의 카메라 허용"}`),chat:{chatListHeader:"채팅 참가자",uploadAttachment:"첨부 파일 업로드",uploadImageDataNotProvided:"이미지 데이터가 제공되지 않았습니다.",uploadImageIsTooLarge:"이미지가 너무 큽 수 있습니다. {maxImageSize} 미만인 항목을 선택하세요.",uploadImageExtensionIsNotAllowed:".{imageExtension} 이미지 업로드는 허용되지 않습니다.",uploadImageFailed:"이미지를 업로드할 수 없습니다. 나중에 다시 시도하세요."},callWithChat:{chatButtonLabel:"채팅",chatButtonNewMessageNotificationLabel:"새 메시지",chatButtonTooltipClosedWithMessageCount:"채팅 표시({unreadMessagesCount} 읽지 않음)",chatButtonTooltipClose:"채팅 숨기기",chatButtonTooltipOpen:"채팅 표시",chatPaneTitle:"채팅",copyInviteLinkButtonLabel:"초대 링크 복사",copyInviteLinkButtonActionedLabel:"링크 복사됨",copyInviteLinkActionedAriaLabel:"초대 링크를 복사함",dismissSidePaneButtonLabel:"닫기",moreDrawerAudioDeviceMenuTitle:"오디오 장치",moreDrawerButtonLabel:"기타 옵션",moreDrawerButtonTooltip:"기타 옵션",moreDrawerMicrophoneMenuTitle:"마이크",moreDrawerSpeakerMenuTitle:"발화자",moreDrawerCaptionsMenuTitle:"라이브 캡션",moreDrawerSpokenLanguageMenuTitle:"음성 언어",moreDrawerCaptionLanguageMenuTitle:"캡션 언어",moreDrawerGalleryOptionsMenuTitle:"갤러리 옵션",peopleButtonLabel:"사용자",selectedPeopleButtonLabel:"사용자 단추 선택됨",peopleButtonTooltipOpen:"참가자 표시",peopleButtonTooltipClose:"참가자 숨기기",peopleButtonTooltipOpenAriaLabel:"사용자 단추, 참가자 표시",peopleButtonTooltipCloseAriaLabel:"사용자 단추, 참가자 숨기기",peoplePaneSubTitle:"이 통화에서",peoplePaneTitle:"사용자",pictureInPictureTileAriaLabel:"비디오 피드입니다. 클릭하면 통화 화면으로 돌아갑니다.",removeMenuLabel:"제거",openDialpadButtonLabel:"전화 번호 전화 걸기",returnToCallButtonAriaDescription:"통화로 돌아가기",returnToCallButtonAriaLabel:"뒤로",peoplePaneAddPeopleButtonLabel:"사용자 추가",dialpadStartCallButtonLabel:"통화",dialpadModalTitle:"전화 번호 전화 걸기",dialpadModalAriaLabel:"다이얼패드",dialpadCloseModalButtonAriaLabel:"다이얼패드 닫기",openDtmfDialpadLabel:"다이얼패드 표시",dtmfDialpadPlaceholderText:"번호 입력",breakoutRoomChatPaneTitle:"소규모 회의실 채팅",chatContentSpinnerLabel:"채팅 로드 중"}})},Eli={component:yQt,strings:Yh({call:JSON.parse('{"cameraLabel":"Kamera","noCamerasLabel":"Fant ingen kameraer","cameraPermissionDenied":"Nettleseren blokkerer tilgang til kameraet","cameraTurnedOff":"Kameraet er slått av","chatButtonLabel":"Chat","close":"Lukk","complianceBannerNowOnlyRecording":"Du tar nå bare opp dette møtet.","complianceBannerNowOnlyTranscription":"Du transkriberer nå bare dette møtet.","complianceBannerRecordingAndTranscriptionSaved":"Opptak og transkripsjon lagres.","complianceBannerRecordingAndTranscriptionStarted":"Opptak og transkripsjon har startet.","complianceBannerRecordingAndTranscriptionStopped":"Innspilling og transkripsjon har stoppet.","complianceBannerRecordingSaving":"Opptaket blir lagret.","complianceBannerRecordingStarted":"Innspillingen er startet.","complianceBannerRecordingStopped":"Opptaket har stoppet.","complianceBannerTranscriptionStarted":"Transkripsjon har startet.","complianceBannerTranscriptionConsent":"Ved å bli med gir du samtykke til at dette møtet kan transkriberes.","complianceBannerTranscriptionSaving":"Transkripsjonen blir lagret.","complianceBannerTranscriptionStopped":"Transkripsjon er stoppet.","configurationPageTitle":"Start en samtale","copyInviteLinkButtonLabel":"Kopier invitasjonskobling","copyInviteLinkButtonActionedLabel":"Koblingen er kopiert","copyInviteLinkActionedAriaLabel":"Invitasjonskobling er kopiert","defaultPlaceHolder":"Velg et alternativ","dismissSidePaneButtonLabel":"Lukk","videoEffectsPaneTitle":"Effekter","videoEffectsPaneBackgroundSelectionTitle":"Bakgrunn","videoEffectsPaneAriaLabel":"Videoeffekter-ruten","configurationPageCameraIsLoadingLabel":"Videoen lastes inn ...","configurationPageVideoEffectsButtonLabel":"Effekter","unableToStartVideoEffect":"Kan ikke bruke videoeffekt.","blurBackgroundEffectButtonLabel":"Uskarp bakgrunn","blurBackgroundTooltip":"Gjør bakgrunnen uskarp","removeBackgroundEffectButtonLabel":"Ingen","removeBackgroundTooltip":"Fjern bakgrunnen","cameraOffBackgroundEffectWarningText":"Kameraet er av. Slå på kameraet for å se videoeffekten.","failedToJoinCallDueToNoNetworkMoreDetails":"Samtalen ble frakoblet på grunn av et nettverksproblem. Kontroller tilkoblingen og bli med på nytt.","failedToJoinCallDueToNoNetworkTitle":"Samtale frakoblet","failedToJoinTeamsMeetingReasonAccessDeniedMoreDetails":"Du ble ikke gitt adgang i samtalen. Hvis dette var en feil, må du bli med i samtalen på nytt.","failedToJoinTeamsMeetingReasonAccessDeniedTitle":"Avvist fra lobbyen","learnMore":"Mer informasjon","leavingCallTitle":"Forlater...","leftCallMoreDetails":"Hvis dette var en feil, må du bli med i samtalen på nytt.","leftCallTitle":"Du forlot samtalen","lobbyScreenConnectingToCallTitle":"Blir med i samtalen","lobbyScreenWaitingToBeAdmittedTitle":"Venter på å bli sluppet inn","microphonePermissionDenied":"Nettleseren blokkerer tilgang til mikrofonen","microphoneToggleInLobbyNotAllowed":"Kan ikke dempe eller oppheve demping i lobbyen.","mutedMessage":"Du er dempet.","networkReconnectMoreDetails":"Det ser ut til at noe gikk galt. Vi prøver å gå tilbake til samtalen.","networkReconnectTitle":"Vent litt","notInvitedToRoomDetails":"Du kan ikke bli med i dette rommet fordi du ikke har en invitasjon.","notInvitedToRoomTitle":"Ikke invitert til rommet","peopleButtonLabel":"Personer","selectedPeopleButtonLabel":"Personer-knappen er valgt","peoplePaneTitle":"Personer","peoplePaneMoreButtonAriaLabel":"Mer","peopleButtonTooltipOpen":"Vis deltakere","peopleButtonTooltipClose":"Skjul deltakere","peoplePaneSubTitle":"I denne samtalen {numberOfPeople}","privacyPolicy":"Personvernerklæring","rejoinCallButtonLabel":"Bli med i samtale på nytt","removedFromCallMoreDetails":"En annen deltaker fjernet deg fra samtalen.","removedFromCallTitle":"Du ble fjernet","removeMenuLabel":"Fjern","startSpotlightMenuLabel":"Sett i rampelyset for alle","addSpotlightMenuLabel":"Legg til rampelys","stopSpotlightMenuLabel":"Fjern fra rampelyset","stopSpotlightOnSelfMenuLabel":"Rampelys av","spotlightLimitReachedMenuTitle":"Rampelys-grensen er nådd","stopAllSpotlightMenuLabel":"Stopp rampelyset for alle","returnToCallButtonAriaDescription":"Gå tilbake til samtale","returnToCallButtonAriaLabel":"Tilbake","roomNotFoundDetails":"Finner ikke den angitte rom-IDen.","roomNotFoundTitle":"Finner ikke rommet","roomNotValidDetails":"Dette rommet er ikke gyldig for øyeblikket.","roomNotValidTitle":"Ugyldig rom","inviteToRoomRemovedDetails":"Invitasjonen til å bli med i dette rommet ble fjernet.","inviteToRoomRemovedTitle":"Invitasjon til rommet er fjernet","soundLabel":"Lyd","noMicrophonesLabel":"Fant ingen mikrofoner","noSpeakersLabel":"Fant ingen høyttalere","startCallButtonLabel":"Start samtale","openDialpadButtonLabel":"Slå telefonnummeret","peoplePaneAddPeopleButtonLabel":"Legg til personer","dialpadStartCallButtonLabel":"Ringe","dialpadModalTitle":"Slå telefonnummeret","dialpadModalAriaLabel":"Numerisk tastatur","dialpadCloseModalButtonAriaLabel":"Lukk numerisk tastatur","moreButtonCallingLabel":"Mer","resumeCallButtonLabel":"Fortsett","resumingCallButtonLabel":"Gjenopptar …","resumeCallButtonAriaLabel":"Fortsett samtale","resumingCallButtonAriaLabel":"Fortsett samtale","holdScreenLabel":"Du er satt på vent","openDtmfDialpadLabel":"Vis numerisk tastatur","dtmfDialpadPlaceholderText":"Skriv inn nummer","outboundCallingNoticeString":"Ringer …","participantJoinedNoticeString":"{displayName} ble med","twoParticipantJoinedNoticeString":"{displayName1} og {displayName2} har blitt med","threeParticipantJoinedNoticeString":"{displayName1}, {displayName2} og {displayName3} har blitt med","participantLeftNoticeString":"{displayName} igjen","twoParticipantLeftNoticeString":"{displayName1} og {displayName2} har forlatt","threeParticipantLeftNoticeString":"{displayName1}, {displayName2} og {displayName3} har forlatt","unnamedParticipantString":"deltaker uten navn","manyUnnamedParticipantsJoined":"deltaker uten navn og {numOfParticipants} andre deltakere ble med","manyUnnamedParticipantsLeft":"deltaker uten navn og {numOfParticipants} andre deltakere igjen","manyParticipantsJoined":"{displayName1}, {displayName2}, {displayName3} og {numOfParticipants} andre deltakere ble med","manyParticipantsLeft":"{displayName1}, {displayName2}, {displayName3} og {numOfParticipants} andre deltakere igjen","liveCaptionsLabel":"Undertekster","captionsSettingsLabel":"Innstillinger for undertekster","startCaptionsButtonOnLabel":"Slå på undertekster","startCaptionsButtonOffLabel":"Deaktiver undertekster","startCaptionsButtonTooltipOnContent":"Deaktiver undertekster","startCaptionsButtonTooltipOffContent":"Slå på undertekster","captionsSettingsModalTitle":"Tekstinnstillinger","captionsSettingsSpokenLanguageDropdownLabel":"Talespråk","captionsSettingsCaptionLanguageDropdownLabel":"Undertekstspråk","captionsSettingsSpokenLanguageDropdownInfoText":"Språket som alle i denne samtalen snakker.","captionsSettingsCaptionLanguageDropdownInfoText":"Undertekster vises på dette språket.","captionsSettingsConfirmButtonLabel":"Bekreft","captionsSettingsCancelButtonLabel":"Avbryt","captionsSettingsModalAriaLabel":"Sperre for innstillinger for undertekster","captionsSettingsCloseModalButtonAriaLabel":"Lukk innstilling for undertekster","captionsBannerMoreButtonCallingLabel":"Flere alternativer for innstillinger for teksting","captionsBannerMoreButtonTooltip":"Flere alternativer","realTimeTextLabel":"Skriving i sanntid (RTT)","startRealTimeTextLabel":"Aktiver RTT for denne samtalen","disabledStartRealTimeTextLabel":"RTT er slått på for øyeblikket, den kan ikke deaktiveres","dismissModalAriaLabel":"Lokalt og eksternt bilde og bilde, trykk på Enter for å gå tilbake til samtalen","callRejectedTitle":"Kan ikke fullføre samtalen","callRejectedMoreDetails":"Personen du prøver å nå, er ikke tilgjengelig. Prøv på nytt senere.","callTimeoutTitle":"Kan ikke fullføre samtalen","callTimeoutDetails":"Personen du prøver å nå, er ikke tilgjengelig. Prøv på nytt senere.","callTimeoutBotTitle":"Kan ikke fullføre samtalen","callTimeoutBotDetails":"Tjenesten du prøver å nå, er ikke tilgjengelig. Prøv på nytt senere.","dtmfDialerButtonLabel":"Numerisk tastatur","dtmfDialerButtonTooltipOn":"Vis numerisk tastatur","dtmfDialerButtonTooltipOff":"Skjul numerisk tastatur","dtmfDialerMoreButtonLabelOn":"Vis numerisk tastatur","dtmfDialerMoreButtonLabelOff":"Skjul numerisk tastatur","phoneCallMoreButtonLabel":"Telefonsamtale","spokenLanguageStrings":{"ar-ae":"Arabisk – De forente arabiske emirater","ar-sa":"Arabisk – Saudi-Arabia","da-dk":"Dansk","de-de":"Tysk – Tyskland","en-au":"Engelsk – Australia","en-ca":"Engelsk – Canada","en-gb":"Engelsk – Storbritannia","en-in":"Engelsk – India","en-nz":"Engelsk – New Zealand","en-us":"Engelsk – USA","es-es":"Spansk – Spania (moderne)","es-mx":"Spansk – Mexico","fi-fi":"Finsk","fr-ca":"Fransk – Canada","fr-fr":"Fransk – Frankrike","hi-in":"Hindi","it-it":"Italiensk – Italia","ja-jp":"Japansk","ko-kr":"Koreansk","nb-no":"Norsk (bokmål)","nl-be":"Nederlandsk – Belgia","nl-nl":"Nederlandsk – Nederland","pl-pl":"Polsk","pt-br":"Portugisisk – Brasil","ru-ru":"Russisk","sv-se":"Svensk","zh-cn":"Kinesisk – Folkerepublikken Kina","zh-hk":"Kinesisk – Hongkong SAR","cs-cz":"Tsjekkisk","pt-pt":"Portugisisk – Portugal","tr-tr":"Tyrkisk","vi-vn":"Vietnamesisk","th-th":"Thai","he-il":"Hebraisk","cy-gb":"Walisisk","uk-ua":"Ukrainsk","el-gr":"Gresk","hu-hu":"Ungarsk","ro-ro":"Rumensk","sk-sk":"Slovakisk","zh-tw":"Kinesisk – Taiwan"},"captionLanguageStrings":{"ar":"Arabisk","da":"Dansk","de":"Tysk","en":"Engelsk","es":"Spansk","fi":"Finsk","fr-ca":"Fransk – Canada","fr":"Fransk – Frankrike","hi":"Hindi","it":"Italiensk","ja":"Japansk","ko":"Koreansk","nb":"Norsk (bokmål)","nl":"Nederlandsk","pl":"Polsk","pt":"Portugisisk – Brasil","ru":"Russisk","sv":"Svensk","zh-Hans":"Kinesisk (forenklet)","zh-Hant":"Kinesisk (tradisjonell)","cs":"Tsjekkisk","pt-pt":"Portugisisk – Portugal","tr":"Tyrkisk","vi":"Vietnamesisk","th":"Thai","he":"Hebraisk","cy":"Walisisk","uk":"Ukrainsk","el":"Gresk","hu":"Ungarsk","ro":"Rumensk","sk":"Slovakisk"},"captionsBannerSpinnerText":"Starter teksting...","realTimeTextInputBoxDefaultText":"Skriv inn melding i sanntid","realTimeTextInputErrorMessage":"Meldingen kan ikke overskride 2000 tegn","realTimeTextBannerTitle":"Skriving i sanntid","realTimeTextBannerContent":"RTT (sanntidstekst) er aktivert for alle deltakere hele varigheten for møtet.","realTimeTextBannerLinkLabel":"Mer informasjon","realTimeTextModalAriaLabel":"Aktiver sperrende dialogboks for skriving i sanntid","realTimeTextModalTitle":"Aktiver skriving i sanntid?","realTimeTextModalText":"Sanntidstekst (RTT) aktiveres for alle i møtet.","realTimeTextConfirmButtonLabel":"Aktiver","realTimeTextCancelButtonLabel":"Avbryt","realTimeTextCloseModalButtonAriaLabel":"Lukk sperrende dialogboks for skriving i sanntid","captionsOnlyContainerTitle":"Undertekster","realTimeTextOnlyContainerTitle":"Tekst i sanntid","captionsAndRealTimeTextContainerTitle":"Teksting og sanntidstekst","expandButtonAriaLabel":"Utvid","minimizeButtonAriaLabel":"Skjul","transferPageTransferorText":"Overfører...","transferPageTransferTargetText":"Kobler til...","transferPageUnknownTransferorDisplayName":"Ukjent","transferPageUnknownTransferTargetDisplayName":"Ukjent","transferPageNoticeString":"Anropet blir overført","participantCouldNotBeReachedTitle":"Måldeltaker er for øyeblikket ikke tilgjengelig","participantCouldNotBeReachedMoreDetails":"Kontakt deltakeren når vedkommende er tilgjengelig","permissionToReachTargetParticipantNotAllowedTitle":"Tillatelse til å nå måldeltaker er ikke tillatt","permissionToReachTargetParticipantNotAllowedMoreDetails":"Kontroller at måldeltakeren er i samme leier","unableToResolveTenantTitle":"Kan ikke løse leier-ID for måldeltakeren","unableToResolveTenantMoreDetails":"Kontroller at deltaker-ID-en er riktig angitt","participantIdIsMalformedTitle":"Deltaker-ID-en har ikke riktig format","participantIdIsMalformedMoreDetails":"Kontroller at deltaker-ID-en har riktig format","moreButtonGalleryControlLabel":"Vis","moreButtonGalleryPositionToggleLabel":"Flytt galleri øverst","moreButtonGallerySpeakerLayoutLabel":"Høyttaler","moreButtonGalleryFloatingLocalLayoutLabel":"Dynamisk","moreButtonGalleryDefaultLayoutLabel":"Gallerivisning","moreButtonGalleryFocusedContentLayoutLabel":"Fokuser på innhold","moreButtonLargeGalleryDefaultLayoutLabel":"Stort galleri","moreButtonTogetherModeLayoutLabel":"Sammen-modus","capabilityChangedNotification":{"turnVideoOn":{"lostDueToMeetingOption":"Kameraet er deaktivert. Du kan ikke lenger dele video.","grantedDueToMeetingOption":"Kameraet er aktivert. Slå den på hvis du vil dele video."},"unmuteMic":{"lostDueToMeetingOption":"Mikrofonen er deaktivert. Du kan ikke lenger oppheve dempingen.","grantedDueToMeetingOption":"Mikrofonen er aktivert. Opphev demping hvis du vil snakke."},"shareScreen":{"lostDueToRoleChangeToAttendee":"Rollen din er endret. Noen handlinger, for eksempel deling av innhold, vil ikke være tilgjengelige for deg.","grantedDueToRoleChangeToPresenter":"Du er presentatør. Du kan dele innhold og tilrettelegge møtet."},"hideAttendeeNames":{"hideAttendeeNameAttendee":"Navnet ditt er skjult for andre deltakere. Arrangører og presentatører kan se ditt virkelige navn.","hideAttendeeNamePresenter":"Deltakernavn er skjult. Bare arrangører og presentatører kan se navn for å beskytte deltakernes personvern."}},"surveyTitle":"Hjelp oss med å bli bedre","starSurveyHelperText":"Hvordan var kvaliteten på samtalen?","starSurveyOneStarText":"Kvaliteten var dårlig.","starSurveyTwoStarText":"Kvaliteten var dårlig.","starSurveyThreeStarText":"Kvaliteten var bra.","starSurveyFourStarText":"Kvaliteten var meget bra.","starSurveyFiveStarText":"Kvaliteten var meget bra.","surveyConfirmButtonLabel":"Send tilbakemelding","starRatingAriaLabel":"Velg {0} av {1} stjerner","surveySkipButtonLabel":"Hopp over","tagsSurveyQuestion":"Hva kunne ha vært bedre?","tagsSurveyTextFieldDefaultText":"Annet, spesifiser","tagsSurveyHelperText":"Merk eventuelle problemer du har opplevd.","endOfSurveyText":"Takk for tilbakemeldingen!","surveyIssues":{"overallRating":{"callCannotJoin":"Jeg kunne ikke bli i samtalen","callCannotInvite":"Jeg kunne ikke invitere noen til samtalen","hadToRejoin":"Jeg måtte bli med i samtalen på nytt","callEndedUnexpectedly":"Samtalen ble avbrutt","otherIssues":"Jeg hadde andre problemer med samtalen"},"audioRating":{"noLocalAudio":"Den andre parten hørte ikke noe lyd","noRemoteAudio":"Jeg hørte ikke lyd","echo":"Jeg hørte ekko i samtalen","audioNoise":"Jeg hørte støy i samtalen","lowVolume":"Volumet var lavt","audioStoppedUnexpectedly":"Lyd stoppet uventet","distortedSpeech":"Lyden var forvrengt","audioInterruption":"Lyden ble avbrutt","otherIssues":"Jeg hadde andre problemer med lyden i denne samtalen"},"videoRating":{"noVideoReceived":"Jeg kunne ikke se videoen","noVideoSent":"Andre kunne ikke se meg","lowQuality":"Videokvaliteten var dårlig","freezes":"Videoen frøs","stoppedUnexpectedly":"Video stoppet uventet","darkVideoReceived":"Jeg kan bare se mørke skjermer når andre slår på kameraet","audioVideoOutOfSync":"Lyd og video er ikke synkronisert","otherIssues":"Jeg hadde andre problemer med videoen i denne samtalen"},"screenshareRating":{"noContentLocal":"Andre personer kunne ikke se skjermdelingen min","noContentRemote":"Jeg kunne ikke se skjermdelingen til andre personer","cannotPresent":"Jeg kunne ikke vise skjermen min","lowQuality":"Kvaliteten på skjermdelingen var dårlig","freezes":"Skjermdeling frøs","stoppedUnexpectedly":"Skjermdelingen ble avbrutt","largeDelay":"Skjermdelingen har en stor forsinkelse","otherIssues":"Jeg hadde andre problemer med skjermdeling i denne samtalen"}},"surveyIssuesHeadingStrings":{"overallRating":"Samlet vurdering","audioRating":"Lyd","videoRating":"Video","screenshareRating":"Presentering"},"spotlightPrompt":{"startSpotlightHeading":"Sett i rampelyset for alle?","startSpotlightText":"Du merker denne videoen for alle i møtet.","startSpotlightOnSelfText":"Du merker videoen for alle i møtet.","startSpotlightConfirmButtonLabel":"Sett i rampelyset for alle","startSpotlightCancelButtonLabel":"Avbryt","stopSpotlightHeading":"Slutte å sette denne videoen i rampelyset?","stopSpotlightOnSelfHeading":"Fjern rampelyset?","stopAllSpotlightHeading":"Vil du stoppe rampelyset for alle videoer?","stopSpotlightText":"Denne videoen vil ikke lenger være uthevet for alle i møtet.","stopSpotlightOnSelfText":"Videoen vil ikke lenger være uthevet for alle i møtet.","stopAllSpotlightText":"Videoene vil ikke lenger være uthevet for alle i møtet.","stopSpotlightConfirmButtonLabel":"Fjern fra rampelyset","stopSpotlightOnSelfConfirmButtonLabel":"Rampelys av","stopSpotlightCancelButtonLabel":"Avbryt","closeSpotlightPromptButtonLabel":"Lukk"},"exitSpotlightButtonLabel":"Rampelys av","exitSpotlightButtonTooltip":"Rampelys av","leaveConfirmButtonLabel":"Forlat","endCallConfirmButtonLabel":"Avslutt samtalen","hangUpCancelButtonLabel":"Avbryt","leaveConfirmDialogTitle":"Forlat chatten","leaveConfirmDialogContent":"Er du sikker på at du vil forlate samtalen?","endCallConfirmDialogTitle":"Avslutt samtalen?","endCallConfirmDialogContent":"Du avslutter møtet for alle.","invalidMeetingIdentifier":"Ugyldig møte-ID eller passord","pinParticipantMenuLabel":"Fest for meg","pinParticipantLimitReachedMenuLabel":"Fest (grensen er nådd)","unpinParticipantMenuLabel":"Løsne","pinParticipantMenuItemAriaLabel":"Fest for meg","unpinParticipantMenuItemAriaLabel":"Løsne","muteAllMenuLabel":"Demp alle","muteAllDialogTitle":"Vil du dempe alle?","muteAllDialogContent":"Dette demper alle i møtet, bortsett fra deg selv.","muteAllConfirmButtonLabel":"Demp alle","muteAllCancelButtonLabel":"Avbryt","joinBreakoutRoomButtonLabel":"Bli med i grupperommet","returnFromBreakoutRoomButtonLabel":"Forlat rom","leaveBreakoutRoomAndMeetingButtonLabel":"Forlat møte","breakoutRoomJoinedNotificationTitle":"Du har blitt med i grupperommet {roomName}","joinBreakoutRoomBannerTitle":"Grupperommet {roomName} er åpent","joinBreakoutRoomBannerButtonLabel":"Bli med","returnFromBreakoutRoomBannerTitle":"Gå tilbake til hovedmøte","returnFromBreakoutRoomBannerButtonLabel":"Bli med på nytt","forbidAudioMenuLabel":"Deaktiver mikrofon","permitAudioMenuLabel":"Tillat mikrofon","forbidOthersAudioDialogTitle":"Deaktivere mikrofon for deltakere?","forbidOthersAudioDialogContent":"Deltakere kan ikke oppheve dempingen selv. Arrangøren og presentatørene kan la personer oppheve dempingen ved behov.","forbidOthersAudioConfirmButtonLabel":"Deaktiver mikrofoner","forbidOthersAudioCancelButtonLabel":"Avbryt","permitOthersAudioDialogTitle":"Tillat mikrofon for deltakere?","permitOthersAudioDialogContent":"Alle i møtet vil kunne oppheve dempingen.","permitOthersAudioConfirmButtonLabel":"Tillat mikrofoner","permitOthersAudioCancelButtonLabel":"Avbryt","forbidOthersAudioMenuLabel":"Deaktiver mikrofon for deltakere","permitOthersAudioMenuLabel":"Tillat mikrofon for deltakere","forbidVideoMenuLabel":"Deaktiver kamera","permitVideoMenuLabel":"Tillat kamera","forbidOthersVideoDialogTitle":"Deaktiver kamera for deltakere?","forbidOthersVideoDialogContent":"Deltakere kan ikke slå på videoen selv. Arrangøren og presentatørene kan la personer slå på kameraet etter behov.","forbidOthersVideoConfirmButtonLabel":"Deaktiver kameraer","forbidOthersVideoCancelButtonLabel":"Avbryt","permitOthersVideoDialogTitle":"Tillat kamera for deltakere?","permitOthersVideoDialogContent":"Alle i møtet kan slå på videoen selv.","permitOthersVideoConfirmButtonLabel":"Tillat kameraer","permitOthersVideoCancelButtonLabel":"Avbryt","forbidOthersVideoMenuLabel":"Deaktiver kamera for deltakere","permitOthersVideoMenuLabel":"Tillat kamera for deltakere"}'),chat:{chatListHeader:"I denne chatten",uploadAttachment:"Last opp vedlegg",uploadImageDataNotProvided:"Bildedata er ikke angitt.",uploadImageIsTooLarge:"Bildet er for stort. Velg en som er mindre enn {maxImageSize} MB.",uploadImageExtensionIsNotAllowed:"Opplasting av .{imageExtension}-bilde er ikke tillatt.",uploadImageFailed:"Kan ikke laste opp bilde. Prøv på nytt senere."},callWithChat:{chatButtonLabel:"Chat",chatButtonNewMessageNotificationLabel:"Ny melding",chatButtonTooltipClosedWithMessageCount:"Vis chat ({unreadMessagesCount} ulest)",chatButtonTooltipClose:"Skjul chat",chatButtonTooltipOpen:"Vis chat",chatPaneTitle:"Chat",copyInviteLinkButtonLabel:"Kopier invitasjonskobling",copyInviteLinkButtonActionedLabel:"Koblingen er kopiert",copyInviteLinkActionedAriaLabel:"Invitasjonskobling er kopiert",dismissSidePaneButtonLabel:"Lukk",moreDrawerAudioDeviceMenuTitle:"Lydenhet",moreDrawerButtonLabel:"Flere alternativer",moreDrawerButtonTooltip:"Flere alternativer",moreDrawerMicrophoneMenuTitle:"Mikrofon",moreDrawerSpeakerMenuTitle:"Høyttaler",moreDrawerCaptionsMenuTitle:"Undertekster",moreDrawerSpokenLanguageMenuTitle:"Talespråk",moreDrawerCaptionLanguageMenuTitle:"Språk for undertekst",moreDrawerGalleryOptionsMenuTitle:"Gallerialternativer",peopleButtonLabel:"Personer",selectedPeopleButtonLabel:"Personer-knappen er valgt",peopleButtonTooltipOpen:"Vis deltakere",peopleButtonTooltipClose:"Skjul deltakere",peopleButtonTooltipOpenAriaLabel:"Personer-knapp, Vis deltakere",peopleButtonTooltipCloseAriaLabel:"Personer-knapp, Skjul deltakere",peoplePaneSubTitle:"I denne samtalen",peoplePaneTitle:"Personer",pictureInPictureTileAriaLabel:"Videofeeder. Klikk for å gå tilbake til samtaleskjermen.",removeMenuLabel:"Fjern",openDialpadButtonLabel:"Slå telefonnummeret",returnToCallButtonAriaDescription:"Gå tilbake til samtale",returnToCallButtonAriaLabel:"Tilbake",peoplePaneAddPeopleButtonLabel:"Legg til personer",dialpadStartCallButtonLabel:"Ringe",dialpadModalTitle:"Slå telefonnummeret",dialpadModalAriaLabel:"Numerisk tastatur",dialpadCloseModalButtonAriaLabel:"Lukk numerisk tastatur",openDtmfDialpadLabel:"Vis numerisk tastatur",dtmfDialpadPlaceholderText:"Skriv inn nummer",breakoutRoomChatPaneTitle:"Grupperomchat",chatContentSpinnerLabel:"Laster inn chat"}})},Ali={component:SQt,strings:Yh({call:JSON.parse(`{"cameraLabel":"Camera","noCamerasLabel":"Geen camera's gevonden","cameraPermissionDenied":"Uw browser blokkeert de toegang tot uw camera","cameraTurnedOff":"Camera is uitgeschakeld","chatButtonLabel":"Chatten","close":"Sluiten","complianceBannerNowOnlyRecording":"U bent nu alleen deze vergadering aan het opnemen.","complianceBannerNowOnlyTranscription":"U bent nu alleen deze vergadering aan het transcriberen.","complianceBannerRecordingAndTranscriptionSaved":"Opname en transcriptie worden opgeslagen.","complianceBannerRecordingAndTranscriptionStarted":"Opname en transcriptie zijn gestart.","complianceBannerRecordingAndTranscriptionStopped":"Opname en transcriptie zijn gestopt.","complianceBannerRecordingSaving":"De opname wordt opgeslagen.","complianceBannerRecordingStarted":"De opname is gestart.","complianceBannerRecordingStopped":"De opname is gestopt.","complianceBannerTranscriptionStarted":"Transcriptie is gestart.","complianceBannerTranscriptionConsent":"Door deel te nemen, geeft u toestemming voor het transcriberen van deze vergadering.","complianceBannerTranscriptionSaving":"Transcriptie wordt opgeslagen.","complianceBannerTranscriptionStopped":"Transcriptie is gestopt.","configurationPageTitle":"Een oproep starten","copyInviteLinkButtonLabel":"Uitnodigingskoppeling kopiëren","copyInviteLinkButtonActionedLabel":"De koppeling is gekopieerd","copyInviteLinkActionedAriaLabel":"Uitnodigingskoppeling gekopieerd","defaultPlaceHolder":"Een optie selecteren","dismissSidePaneButtonLabel":"Sluiten","videoEffectsPaneTitle":"Effecten","videoEffectsPaneBackgroundSelectionTitle":"Achtergrond","videoEffectsPaneAriaLabel":"Deelvenster video-effectenVideo","configurationPageCameraIsLoadingLabel":"Video wordt geladen...","configurationPageVideoEffectsButtonLabel":"Effecten","unableToStartVideoEffect":"Kan video-effect niet toepassen.","blurBackgroundEffectButtonLabel":"Vervagen","blurBackgroundTooltip":"Achtergrond vervagen","removeBackgroundEffectButtonLabel":"Geen","removeBackgroundTooltip":"Achtergrond verwijderen","cameraOffBackgroundEffectWarningText":"Uw camera is uitgeschakeld. Schakel de camera in om het video-effect te zien.","failedToJoinCallDueToNoNetworkMoreDetails":"De verbinding is verbroken vanwege een netwerkprobleem. Controleer de verbinding en neem opnieuw deel.","failedToJoinCallDueToNoNetworkTitle":"Verbinding verbroken","failedToJoinTeamsMeetingReasonAccessDeniedMoreDetails":"U hebt geen toegang gekregen in het gesprek. Als dit een fout is, neemt u opnieuw deel aan het gesprek.","failedToJoinTeamsMeetingReasonAccessDeniedTitle":"Verwijderd uit lobby","learnMore":"Meer informatie","leavingCallTitle":"Verlaten...","leftCallMoreDetails":"Als dit een vergissing was, neemt u opnieuw deel aan het gesprek.","leftCallTitle":"U hebt het gesprek verlaten","lobbyScreenConnectingToCallTitle":"Deelnemen aan oproep","lobbyScreenWaitingToBeAdmittedTitle":"Wachten om te worden toegelaten","microphonePermissionDenied":"Uw browser blokkeert de toegang tot uw microfoon","microphoneToggleInLobbyNotAllowed":"Kan niet dempen of dempen opheffen in de lobby.","mutedMessage":"Uw geluid is gedempt","networkReconnectMoreDetails":"Er is iets misgegaan. We proberen terug te gaan naar het gesprek.","networkReconnectTitle":"Wacht even","notInvitedToRoomDetails":"U kunt niet deelnemen aan deze ruimte omdat u geen uitnodiging hebt.","notInvitedToRoomTitle":"Niet uitgenodigd voor ruimte","peopleButtonLabel":"Personen","selectedPeopleButtonLabel":"Knop Personen geselecteerd","peoplePaneTitle":"Personen","peoplePaneMoreButtonAriaLabel":"Meer","peopleButtonTooltipOpen":"Deelnemers weergeven","peopleButtonTooltipClose":"Deelnemers verbergen","peoplePaneSubTitle":"In dit gesprek {numberOfPeople}","privacyPolicy":"Privacybeleid","rejoinCallButtonLabel":"Opnieuw deelnemen aan gesprek","removedFromCallMoreDetails":"Een andere deelnemer heeft u uit het gesprek verwijderd.","removedFromCallTitle":"U bent verwijderd","removeMenuLabel":"Verwijderen","startSpotlightMenuLabel":"Spotlight voor iedereen","addSpotlightMenuLabel":"Spotlight toevoegen","stopSpotlightMenuLabel":"Spotlighten stoppen","stopSpotlightOnSelfMenuLabel":"Spotlight afsluiten","spotlightLimitReachedMenuTitle":"Spotlightlimiet bereikt","stopAllSpotlightMenuLabel":"Alle spotlights stoppen","returnToCallButtonAriaDescription":"Terug naar gesprek","returnToCallButtonAriaLabel":"Terug","roomNotFoundDetails":"Kan de opgegeven ruimte-id niet vinden.","roomNotFoundTitle":"Ruimte niet gevonden","roomNotValidDetails":"Deze ruimte is momenteel niet geldig.","roomNotValidTitle":"De ruimte is niet geldig","inviteToRoomRemovedDetails":"Uw uitnodiging om deel te nemen aan deze ruimte is verwijderd.","inviteToRoomRemovedTitle":"Uitnodiging voor ruimte verwijderd","soundLabel":"Geluid","noMicrophonesLabel":"Geen microfoons gevonden","noSpeakersLabel":"Geen luidsprekers gevonden","startCallButtonLabel":"Gesprek starten","openDialpadButtonLabel":"Telefoonnummer kiezen","peoplePaneAddPeopleButtonLabel":"Personen toevoegen","dialpadStartCallButtonLabel":"Bellen","dialpadModalTitle":"Telefoonnummer kiezen","dialpadModalAriaLabel":"Telefoonkiezer","dialpadCloseModalButtonAriaLabel":"Toetsenblok sluiten","moreButtonCallingLabel":"Meer","resumeCallButtonLabel":"Hervatten","resumingCallButtonLabel":"Hervatten...","resumeCallButtonAriaLabel":"Gesprek hervatten","resumingCallButtonAriaLabel":"Gesprek hervatten","holdScreenLabel":"U staat in de wacht","openDtmfDialpadLabel":"Toetsenblok weergeven","dtmfDialpadPlaceholderText":"Nummer invoeren","outboundCallingNoticeString":"Bellen...","participantJoinedNoticeString":"{displayName} neemt deel","twoParticipantJoinedNoticeString":"{displayName1} en {displayName2} nemen deel","threeParticipantJoinedNoticeString":"{displayName1}, {displayName2} en {displayName3} nemen deel","participantLeftNoticeString":"{displayName} is vertrokken","twoParticipantLeftNoticeString":"{displayName1} en {displayName2} zijn vertrokken","threeParticipantLeftNoticeString":"{displayName1}, {displayName2} en {displayName3} zijn vertrokken","unnamedParticipantString":"naamloze deelnemer","manyUnnamedParticipantsJoined":"naamloze deelnemer en {numOfParticipants} andere deelnemers nemen deel","manyUnnamedParticipantsLeft":"naamloze deelnemer en {numOfParticipants} andere deelnemers zijn vertrokken","manyParticipantsJoined":"{displayName1}, {displayName2}, {displayName3} en {numOfParticipants} andere deelnemers","manyParticipantsLeft":"{displayName1}, {displayName2}, {displayName3} en {numOfParticipants} andere deelnemers resterend","liveCaptionsLabel":"Liveondertitels","captionsSettingsLabel":"Instellingen voor ondertiteling","startCaptionsButtonOnLabel":"Bijschriften inschakelen","startCaptionsButtonOffLabel":"Ondertitels uitschakelen","startCaptionsButtonTooltipOnContent":"Ondertitels uitschakelen","startCaptionsButtonTooltipOffContent":"Bijschriften inschakelen","captionsSettingsModalTitle":"Instellingen voor ondertitels","captionsSettingsSpokenLanguageDropdownLabel":"Gesproken taal","captionsSettingsCaptionLanguageDropdownLabel":"Taal van ondertitels","captionsSettingsSpokenLanguageDropdownInfoText":"Taal die iedereen in dit gesprek spreekt.","captionsSettingsCaptionLanguageDropdownInfoText":"Ondertitels worden weergegeven in deze taal.","captionsSettingsConfirmButtonLabel":"Bevestigen","captionsSettingsCancelButtonLabel":"Annuleren","captionsSettingsModalAriaLabel":"Bijschriften instellen modaal","captionsSettingsCloseModalButtonAriaLabel":"Instelling voor ondertiteling sluiten","captionsBannerMoreButtonCallingLabel":"Instellingen voor ondertitels - Meer opties","captionsBannerMoreButtonTooltip":"Meer opties","realTimeTextLabel":"Typen in real time (RTT)","startRealTimeTextLabel":"RTT inschakelen voor dit gesprek","disabledStartRealTimeTextLabel":"RTT is momenteel ingeschakeld en kan niet worden uitgeschakeld","dismissModalAriaLabel":"Lokale en externe afbeelding en afbeelding, druk op Enter om terug te keren naar het gesprek","callRejectedTitle":"De aanroep kan niet worden voltooid","callRejectedMoreDetails":"De persoon die u probeert te bereiken, is niet beschikbaar. Probeer het later opnieuw.","callTimeoutTitle":"De aanroep kan niet worden voltooid","callTimeoutDetails":"De persoon die u probeert te bereiken, is niet beschikbaar. Probeer het later opnieuw.","callTimeoutBotTitle":"De aanroep kan niet worden voltooid","callTimeoutBotDetails":"De service die u probeert te bereiken, is niet beschikbaar. Probeer het later opnieuw.","dtmfDialerButtonLabel":"Toetsenblok","dtmfDialerButtonTooltipOn":"Toetsenblok weergeven","dtmfDialerButtonTooltipOff":"Toetsenblok verbergen","dtmfDialerMoreButtonLabelOn":"Toetsenblok weergeven","dtmfDialerMoreButtonLabelOff":"Toetsenblok verbergen","phoneCallMoreButtonLabel":"Oproep","spokenLanguageStrings":{"ar-ae":"Arabisch - Verenigde Arabische Emiraten","ar-sa":"Arabisch - Saudi-Arabië","da-dk":"Deens","de-de":"Duits - Duitsland","en-au":"Engels - Australië","en-ca":"Engels - Canada","en-gb":"Engels - Verenigd Koninkrijk","en-in":"Engels - India","en-nz":"Engels - Nieuw-Zeeland","en-us":"Engels - Verenigde Staten","es-es":"Spaans - Spanje (modern)","es-mx":"Spaans - Mexico","fi-fi":"Fins","fr-ca":"Frans - Canada","fr-fr":"Frans - Frankrijk","hi-in":"Hindi","it-it":"Italiaans - Italië","ja-jp":"Japans","ko-kr":"Koreaans","nb-no":"Noors (Bokmål)","nl-be":"Nederlands - België","nl-nl":"Nederlands - Nederland","pl-pl":"Pools","pt-br":"Portugees - Brazilië","ru-ru":"Russisch","sv-se":"Zweeds","zh-cn":"Chinees (Volksrepubliek China)","zh-hk":"Chinees - Hongkong SAR","cs-cz":"Tsjechisch","pt-pt":"Portugees - Portugal","tr-tr":"Turks","vi-vn":"Vietnamees","th-th":"Thai","he-il":"Hebreeuws","cy-gb":"Welsh","uk-ua":"Oekraïens","el-gr":"Grieks","hu-hu":"Hongaars","ro-ro":"Roemeens","sk-sk":"Slowaaks","zh-tw":"Chinees - Taiwan"},"captionLanguageStrings":{"ar":"Arabisch","da":"Deens","de":"Duits","en":"Engels","es":"Spaans","fi":"Fins","fr-ca":"Frans - Canada","fr":"Frans - Frankrijk","hi":"Hindi","it":"Italiaans","ja":"Japans","ko":"Koreaans","nb":"Noors (Bokmål)","nl":"Nederlands","pl":"Pools","pt":"Portugees - Brazilië","ru":"Russisch","sv":"Zweeds","zh-Hans":"Vereenvoudigd Chinees","zh-Hant":"Traditioneel Chinees","cs":"Tsjechisch","pt-pt":"Portugees - Portugal","tr":"Turks","vi":"Vietnamees","th":"Thai","he":"Hebreeuws","cy":"Welsh","uk":"Oekraïens","el":"Grieks","hu":"Hongaars","ro":"Roemeens","sk":"Slowaaks"},"captionsBannerSpinnerText":"Ondertitels starten...","realTimeTextInputBoxDefaultText":"Bericht in realtime typen","realTimeTextInputErrorMessage":"Het bericht mag niet langer zijn dan 2000 tekens","realTimeTextBannerTitle":"RTT","realTimeTextBannerContent":"RTT (realtime-tekst) is ingeschakeld voor alle deelnemers gedurende de hele duur van de vergadering.","realTimeTextBannerLinkLabel":"Meer informatie","realTimeTextModalAriaLabel":"RTT Modal inschakelen","realTimeTextModalTitle":"RTT inschakelen?","realTimeTextModalText":"Tekst in realtime (RTT) wordt ingeschakeld voor iedereen in de vergadering.","realTimeTextConfirmButtonLabel":"Inschakelen","realTimeTextCancelButtonLabel":"Annuleren","realTimeTextCloseModalButtonAriaLabel":"RTT Modaal sluiten","captionsOnlyContainerTitle":"Ondertitels","realTimeTextOnlyContainerTitle":"Real-time tekst","captionsAndRealTimeTextContainerTitle":"Ondertitels en realtime tekst","expandButtonAriaLabel":"Uitvouwen","minimizeButtonAriaLabel":"Samenvouwen","transferPageTransferorText":"Doorverbinden...","transferPageTransferTargetText":"Verbinding maken...","transferPageUnknownTransferorDisplayName":"Onbekend","transferPageUnknownTransferTargetDisplayName":"Onbekend","transferPageNoticeString":"U wordt doorgeschakeld","participantCouldNotBeReachedTitle":"Doeldeelnemer is momenteel niet beschikbaar","participantCouldNotBeReachedMoreDetails":"Neem contact op met de deelnemer wanneer deze beschikbaar is","permissionToReachTargetParticipantNotAllowedTitle":"Machtiging om de doeldeelnemer te bereiken is niet toegestaan","permissionToReachTargetParticipantNotAllowedMoreDetails":"Controleer of de doeldeelnemer zich in dezelfde tenant bevindt","unableToResolveTenantTitle":"Kan de tenant-id voor de doeldeelnemer niet omzetten","unableToResolveTenantMoreDetails":"Controleer of de deelnemer-id juist is ingevoerd","participantIdIsMalformedTitle":"Deelnemer-id heeft niet de juiste indeling","participantIdIsMalformedMoreDetails":"Controleer of de deelnemer-id de juiste indeling heeft","moreButtonGalleryControlLabel":"Bekijken","moreButtonGalleryPositionToggleLabel":"Galerie naar boven verplaatsen","moreButtonGallerySpeakerLayoutLabel":"Luidspreker","moreButtonGalleryFloatingLocalLayoutLabel":"Dynamisch","moreButtonGalleryDefaultLayoutLabel":"Galerieweergave","moreButtonGalleryFocusedContentLayoutLabel":"Focus op inhoud","moreButtonLargeGalleryDefaultLayoutLabel":"Grote galerie","moreButtonTogetherModeLayoutLabel":"Modus Samen","capabilityChangedNotification":{"turnVideoOn":{"lostDueToMeetingOption":"Uw camera is uitgeschakeld. U kunt geen video meer delen.","grantedDueToMeetingOption":"Uw camera is ingeschakeld. Schakel deze optie in als u video wilt delen."},"unmuteMic":{"lostDueToMeetingOption":"Uw microfoon is uitgeschakeld. U kunt het dempen niet meer opheffen.","grantedDueToMeetingOption":"Uw microfoon is ingeschakeld. Hef het dempen op als u wilt spreken."},"shareScreen":{"lostDueToRoleChangeToAttendee":"Uw rol is gewijzigd. Sommige acties, zoals het delen van inhoud, zijn niet beschikbaar voor u.","grantedDueToRoleChangeToPresenter":"U bent een presentator. U kunt inhoud delen en de vergadering vergemakkelijken."},"hideAttendeeNames":{"hideAttendeeNameAttendee":"Uw naam is verborgen voor andere genodigden. Organisatoren en presentatoren kunnen uw echte naam zien.","hideAttendeeNamePresenter":"Namen van genodigden zijn verborgen. Alleen organisatoren en presentatoren kunnen namen zien om de privacy van deelnemers te beschermen."}},"surveyTitle":"Help mee met verbeteren","starSurveyHelperText":"Wat was de kwaliteit van het gesprek?","starSurveyOneStarText":"De kwaliteit was erg slecht.","starSurveyTwoStarText":"De kwaliteit was slecht.","starSurveyThreeStarText":"De kwaliteit was goed.","starSurveyFourStarText":"De kwaliteit was geweldig.","starSurveyFiveStarText":"De kwaliteit was uitstekend.","surveyConfirmButtonLabel":"Feedback verzenden","starRatingAriaLabel":"Selecteer {0} van {1} sterren","surveySkipButtonLabel":"Overslaan","tagsSurveyQuestion":"Wat had beter kunnen zijn?","tagsSurveyTextFieldDefaultText":"Overig, geef een toelichting","tagsSurveyHelperText":"Controleer eventuele problemen die u hebt ondervonden","endOfSurveyText":"Hartelijk dank voor uw feedback.","surveyIssues":{"overallRating":{"callCannotJoin":"Ik kan niet deelnemen aan de oproep","callCannotInvite":"Ik kan niet iemand uitnodigen voor de oproep","hadToRejoin":"Ik moest opnieuw deelnemen aan de oproep","callEndedUnexpectedly":"Oproep is onverwacht beëindigd voor mij","otherIssues":"Ik had andere problemen met de oproep"},"audioRating":{"noLocalAudio":"De ander kon geen geluid horen","noRemoteAudio":"Ik kon geen geluid horen","echo":"Ik hoorde echo's tijdens de oproep","audioNoise":"Ik hoorde een ruis tijdens de oproep","lowVolume":"Het volume was laag","audioStoppedUnexpectedly":"Audio is onverwacht gestopt","distortedSpeech":"Audio is vervormd","audioInterruption":"Audio is onderbroken","otherIssues":"Ik had andere audioproblemen in deze oproep"},"videoRating":{"noVideoReceived":"Ik kon geen video zien","noVideoSent":"Anderen konden mij niet zien","lowQuality":"Videokwaliteit was laag","freezes":"Video bevroren","stoppedUnexpectedly":"De video stopte onverwacht","darkVideoReceived":"Ik zie alleen donkere schermen wanneer anderen hun camera inschakelen","audioVideoOutOfSync":"Audio en video niet gesynchroniseerd","otherIssues":"Ik had andere audioproblemen in deze oproep"},"screenshareRating":{"noContentLocal":"Anderen kunnen mijn gedeelde scherm niet zien","noContentRemote":"Ik kon het gedeelde scherm van anderen niet zien","cannotPresent":"Ik kon mijn scherm niet presenteren","lowQuality":"De kwaliteit van scherm delen was laag","freezes":"Scherm delen bevroren","stoppedUnexpectedly":"Scherm delen is onverwacht gestopt","largeDelay":"Scherm dele heeft een grote vertraging","otherIssues":"Ik had andere problemen met het delen van het scherm in dit gesprek"}},"surveyIssuesHeadingStrings":{"overallRating":"Algemeen","audioRating":"Audio","videoRating":"Video","screenshareRating":"Presenteren"},"spotlightPrompt":{"startSpotlightHeading":"Spotlight voor iedereen?","startSpotlightText":"U markeert deze video voor iedereen in de vergadering.","startSpotlightOnSelfText":"U markeert deze video voor iedereen in de vergadering.","startSpotlightConfirmButtonLabel":"Spotlight voor iedereen","startSpotlightCancelButtonLabel":"Annuleren","stopSpotlightHeading":"Wilt u deze video niet meer spotlighten?","stopSpotlightOnSelfHeading":"Spotlight afsluiten?","stopAllSpotlightHeading":"Stoppen met het uitlichten van alle video's?","stopSpotlightText":"Deze video wordt niet meer gemarkeerd voor iedereen in de vergadering.","stopSpotlightOnSelfText":"Uw video wordt niet meer gemarkeerd voor iedereen in de vergadering.","stopAllSpotlightText":"De video's worden niet meer gemarkeerd voor iedereen in de vergadering.","stopSpotlightConfirmButtonLabel":"Spotlighten stoppen","stopSpotlightOnSelfConfirmButtonLabel":"Spotlight afsluiten","stopSpotlightCancelButtonLabel":"Annuleren","closeSpotlightPromptButtonLabel":"Sluiten"},"exitSpotlightButtonLabel":"Spotlight afsluiten","exitSpotlightButtonTooltip":"Spotlight afsluiten","leaveConfirmButtonLabel":"Verlaten","endCallConfirmButtonLabel":"Gesprek beëindigen","hangUpCancelButtonLabel":"Annuleren","leaveConfirmDialogTitle":"Het gesprek verlaten?","leaveConfirmDialogContent":"Weet u zeker dat u het gesprek wilt verlaten?","endCallConfirmDialogTitle":"Het gesprek beëindigen?","endCallConfirmDialogContent":"U beëindigt het gesprek voor iedereen.","invalidMeetingIdentifier":"Ongeldige vergaderings-id of wachtwoordcode","pinParticipantMenuLabel":"Voor mij vastmaken","pinParticipantLimitReachedMenuLabel":"Pin (limiet bereikt)","unpinParticipantMenuLabel":"Losmaken","pinParticipantMenuItemAriaLabel":"Voor mij vastmaken","unpinParticipantMenuItemAriaLabel":"Losmaken","muteAllMenuLabel":"Allen dempen","muteAllDialogTitle":"Iedereen dempen?","muteAllDialogContent":"Hiermee wordt iedereen in de vergadering gedempt, behalve u.","muteAllConfirmButtonLabel":"Allen dempen","muteAllCancelButtonLabel":"Annuleren","joinBreakoutRoomButtonLabel":"Deelnemen aan aparte vergaderruimte","returnFromBreakoutRoomButtonLabel":"Vergaderruimte verlaten","leaveBreakoutRoomAndMeetingButtonLabel":"Vergadering verlaten","breakoutRoomJoinedNotificationTitle":"U neemt deel aan de aparte vergaderruimte '{roomName}'","joinBreakoutRoomBannerTitle":"Aparte vergaderruimte '{roomName}' is geopend","joinBreakoutRoomBannerButtonLabel":"Bijwonen","returnFromBreakoutRoomBannerTitle":"Terugkeren naar hoofdvergadering","returnFromBreakoutRoomBannerButtonLabel":"Opnieuw deelnemen","forbidAudioMenuLabel":"Microfoon uitschakelen","permitAudioMenuLabel":"Microfoon toestaan","forbidOthersAudioDialogTitle":"Microfoon uitschakelen voor deelnemers?","forbidOthersAudioDialogContent":"Deelnemers kunnen het dempen niet zelf opheffen. De organisator en de presentatoren kunnen indien nodig mensen het dempen laten opheffen.","forbidOthersAudioConfirmButtonLabel":"Microfoons uitschakelen","forbidOthersAudioCancelButtonLabel":"Annuleren","permitOthersAudioDialogTitle":"Microfoon toestaan voor deelnemers?","permitOthersAudioDialogContent":"Iedereen in de vergadering kan het gedempte eigen geluid opheffen.","permitOthersAudioConfirmButtonLabel":"Microfoons toestaan","permitOthersAudioCancelButtonLabel":"Annuleren","forbidOthersAudioMenuLabel":"Microfoon uitschakelen voor deelnemers","permitOthersAudioMenuLabel":"Microfoon toestaan voor deelnemers","forbidVideoMenuLabel":"Camera uitschakelen","permitVideoMenuLabel":"Camera toestaan","forbidOthersVideoDialogTitle":"Camera uitschakelen voor deelnemers?","forbidOthersVideoDialogContent":"Deelnemers kunnen video niet zelf inschakelen. De organisator en presentatoren kunnen mensen de camera laten inschakelen als dat nodig is.","forbidOthersVideoConfirmButtonLabel":"Camera's uitschakelen","forbidOthersVideoCancelButtonLabel":"Annuleren","permitOthersVideoDialogTitle":"Camera toestaan voor deelnemers?","permitOthersVideoDialogContent":"Iedereen in de vergadering kan zelf video inschakelen.","permitOthersVideoConfirmButtonLabel":"Camera's toestaan","permitOthersVideoCancelButtonLabel":"Annuleren","forbidOthersVideoMenuLabel":"Camera uitschakelen voor deelnemers","permitOthersVideoMenuLabel":"Camera toestaan voor deelnemers"}`),chat:{chatListHeader:"In deze chat",uploadAttachment:"Bijlage uploaden",uploadImageDataNotProvided:"Er zijn geen afbeeldingsgegevens opgegeven.",uploadImageIsTooLarge:"Afbeelding is te groot. Kies een optie die kleiner is dan {maxImageSize} MB.",uploadImageExtensionIsNotAllowed:"Het uploaden van {imageExtension} afbeelding is niet toegestaan.",uploadImageFailed:"Kan afbeelding niet uploaden. Probeer het later opnieuw."},callWithChat:{chatButtonLabel:"Chatten",chatButtonNewMessageNotificationLabel:"Nieuw bericht",chatButtonTooltipClosedWithMessageCount:"Chat weergeven ({unreadMessagesCount} ongelezen)",chatButtonTooltipClose:"Chat verbergen",chatButtonTooltipOpen:"Chat weergeven",chatPaneTitle:"Chatten",copyInviteLinkButtonLabel:"Uitnodigingskoppeling kopiëren",copyInviteLinkButtonActionedLabel:"De koppeling is gekopieerd",copyInviteLinkActionedAriaLabel:"Uitnodigingskoppeling gekopieerd",dismissSidePaneButtonLabel:"Sluiten",moreDrawerAudioDeviceMenuTitle:"Audioapparaat",moreDrawerButtonLabel:"Meer opties",moreDrawerButtonTooltip:"Meer opties",moreDrawerMicrophoneMenuTitle:"Microfoon",moreDrawerSpeakerMenuTitle:"Luidspreker",moreDrawerCaptionsMenuTitle:"Liveondertitels",moreDrawerSpokenLanguageMenuTitle:"Gesproken taal",moreDrawerCaptionLanguageMenuTitle:"Taal van ondertiteling",moreDrawerGalleryOptionsMenuTitle:"Galerieopties",peopleButtonLabel:"Personen",selectedPeopleButtonLabel:"Knop Personen geselecteerd",peopleButtonTooltipOpen:"Deelnemers weergeven",peopleButtonTooltipClose:"Deelnemers verbergen",peopleButtonTooltipOpenAriaLabel:"Knop Personen, Deelnemers weergeven",peopleButtonTooltipCloseAriaLabel:"Knop Personen, Deelnemers verbergen",peoplePaneSubTitle:"In dit gesprek",peoplePaneTitle:"Personen",pictureInPictureTileAriaLabel:"Videofeeds. Klik om terug te keren naar het oproepscherm.",removeMenuLabel:"Verwijderen",openDialpadButtonLabel:"Telefoonnummer kiezen",returnToCallButtonAriaDescription:"Terug naar gesprek",returnToCallButtonAriaLabel:"Terug",peoplePaneAddPeopleButtonLabel:"Personen toevoegen",dialpadStartCallButtonLabel:"Bellen",dialpadModalTitle:"Telefoonnummer kiezen",dialpadModalAriaLabel:"Telefoonkiezer",dialpadCloseModalButtonAriaLabel:"Toetsenblok sluiten",openDtmfDialpadLabel:"Toetsenblok weergeven",dtmfDialpadPlaceholderText:"Nummer invoeren",breakoutRoomChatPaneTitle:"Aparte vergaderruimte chat",chatContentSpinnerLabel:"Chat aan het laden"}})},Ili={component:bQt,strings:Yh({call:JSON.parse('{"cameraLabel":"Kamera","noCamerasLabel":"Nie znaleziono żadnej kamery","cameraPermissionDenied":"Przeglądarka blokuje dostęp do kamery","cameraTurnedOff":"Twoja kamera jest wyłączona","chatButtonLabel":"Czat","close":"Zamknij","complianceBannerNowOnlyRecording":"W tej chwili tylko Ty nagrywasz to spotkanie.","complianceBannerNowOnlyTranscription":"W tej chwili tylko Ty transkrybujesz to spotkanie.","complianceBannerRecordingAndTranscriptionSaved":"Trwa zapisywanie nagrania i transkrypcji.","complianceBannerRecordingAndTranscriptionStarted":"Rozpoczęto nagrywanie i transkrypcję.","complianceBannerRecordingAndTranscriptionStopped":"Zatrzymano nagrywanie i transkrypcję.","complianceBannerRecordingSaving":"Trwa zapisywanie nagrania.","complianceBannerRecordingStarted":"Rozpoczęto nagrywanie.","complianceBannerRecordingStopped":"Nagranie zostało zatrzymane.","complianceBannerTranscriptionStarted":"Rozpoczęto transkrypcję.","complianceBannerTranscriptionConsent":"Dołączając, wyrażasz zgodę na transkrypcję tego spotkania.","complianceBannerTranscriptionSaving":"Trwa zapisywanie transkrypcji.","complianceBannerTranscriptionStopped":"Zakończono transkrypcję.","configurationPageTitle":"Rozpocznij rozmowę","copyInviteLinkButtonLabel":"Kopiuj link do zaproszenia","copyInviteLinkButtonActionedLabel":"Skopiowano link","copyInviteLinkActionedAriaLabel":"Skopiowano link do zaproszenia","defaultPlaceHolder":"Wybierz opcję","dismissSidePaneButtonLabel":"Zamknij","videoEffectsPaneTitle":"Efekty","videoEffectsPaneBackgroundSelectionTitle":"Tło","videoEffectsPaneAriaLabel":"Okienko efektów wideo","configurationPageCameraIsLoadingLabel":"Ładowanie wideo w toku...","configurationPageVideoEffectsButtonLabel":"Efekty","unableToStartVideoEffect":"Nie można zastosować efektu wideo.","blurBackgroundEffectButtonLabel":"Rozmycie","blurBackgroundTooltip":"Rozmyj tło","removeBackgroundEffectButtonLabel":"Brak","removeBackgroundTooltip":"Usuń tło","cameraOffBackgroundEffectWarningText":"Kamera jest wyłączona. Włącz kamerę, aby zobaczyć efekt wideo.","failedToJoinCallDueToNoNetworkMoreDetails":"Połączenie zostało rozłączone z powodu problemu z siecią. Sprawdź połączenie i dołącz ponownie.","failedToJoinCallDueToNoNetworkTitle":"Rozmowa została rozłączona","failedToJoinTeamsMeetingReasonAccessDeniedMoreDetails":"Nie udzielono Ci dostępu do rozmowy. Jeśli to pomyłka, dołącz ponownie do rozmowy.","failedToJoinTeamsMeetingReasonAccessDeniedTitle":"Odrzucono z poczekalni","learnMore":"Dowiedz się więcej","leavingCallTitle":"Opuszczanie…","leftCallMoreDetails":"Jeśli to pomyłka, dołącz ponownie do rozmowy.","leftCallTitle":"Opuszczono rozmowę","lobbyScreenConnectingToCallTitle":"Dołączanie do rozmowy","lobbyScreenWaitingToBeAdmittedTitle":"Oczekiwanie na przyjęcie","microphonePermissionDenied":"Twoja przeglądarka blokuje dostęp do mikrofonu","microphoneToggleInLobbyNotAllowed":"Nie można wyciszyć ani wyłączyć wyciszenia w poczekalni.","mutedMessage":"Wyciszenie jest włączone","networkReconnectMoreDetails":"Wygląda na to, że wystąpił problem. Próbujemy wrócić do rozmowy.","networkReconnectTitle":"Czekaj","notInvitedToRoomDetails":"Nie możesz dołączyć do tego pokoju, ponieważ nie masz zaproszenia.","notInvitedToRoomTitle":"Nie zaproszono do pokoju","peopleButtonLabel":"Osoby","selectedPeopleButtonLabel":"Wybrano przycisk Kontakty","peoplePaneTitle":"Osoby","peoplePaneMoreButtonAriaLabel":"Więcej","peopleButtonTooltipOpen":"Pokaż uczestników","peopleButtonTooltipClose":"Ukryj uczestników","peoplePaneSubTitle":"W tej rozmowie {numberOfPeople}","privacyPolicy":"Zasady ochrony prywatności","rejoinCallButtonLabel":"Dołącz ponownie do rozmowy","removedFromCallMoreDetails":"Inny uczestnik usunął Cię z rozmowy.","removedFromCallTitle":"Usunięto Cię","removeMenuLabel":"Usuń","startSpotlightMenuLabel":"Wyróżnij dla wszystkich","addSpotlightMenuLabel":"Dodaj wyróżnienie","stopSpotlightMenuLabel":"Zatrzymaj wyróżnianie","stopSpotlightOnSelfMenuLabel":"Zakończ wyróżnienie","spotlightLimitReachedMenuTitle":"Osiągnięto limit wyróżnienia","stopAllSpotlightMenuLabel":"Zatrzymaj wszystkie wyróżnienia","returnToCallButtonAriaDescription":"Wróć do rozmowy","returnToCallButtonAriaLabel":"Wstecz","roomNotFoundDetails":"Nie można odnaleźć podanego identyfikatora pokoju.","roomNotFoundTitle":"Nie znaleziono pokoju","roomNotValidDetails":"Ten pokój jest obecnie nieprawidłowy.","roomNotValidTitle":"Pokój jest nieprawidłowy","inviteToRoomRemovedDetails":"Twoje zaproszenie do dołączenia do tego pokoju zostało usunięte.","inviteToRoomRemovedTitle":"Usunięto zaproszenie do pokoju","soundLabel":"Dźwięk","noMicrophonesLabel":"Nie znaleziono mikrofonów","noSpeakersLabel":"Nie znaleziono głośników","startCallButtonLabel":"Zadzwoń","openDialpadButtonLabel":"Wybierz numer telefonu","peoplePaneAddPeopleButtonLabel":"Dodaj osoby","dialpadStartCallButtonLabel":"Zadzwoń","dialpadModalTitle":"Wybieranie numeru telefonu","dialpadModalAriaLabel":"Klawiatura numeryczna","dialpadCloseModalButtonAriaLabel":"Zamknij klawiaturę numeryczną","moreButtonCallingLabel":"Więcej","resumeCallButtonLabel":"Wznów","resumingCallButtonLabel":"Trwa wznawianie...","resumeCallButtonAriaLabel":"Wznów połączenie","resumingCallButtonAriaLabel":"Wznów połączenie","holdScreenLabel":"Połączenie zostało zawieszone.","openDtmfDialpadLabel":"Pokaż klawiaturę numeryczną","dtmfDialpadPlaceholderText":"Wprowadź numer","outboundCallingNoticeString":"Trwa łączenie…","participantJoinedNoticeString":"użytkownik {displayName} dołączył","twoParticipantJoinedNoticeString":"użytkownicy {displayName1} i {displayName2} dołączyli","threeParticipantJoinedNoticeString":"użytkownicy {displayName1}, {displayName2} i {displayName3} dołączyli","participantLeftNoticeString":"uczestnik {displayName} opuścił","twoParticipantLeftNoticeString":"uczestnicy {displayName1} i {displayName2} opuścili","threeParticipantLeftNoticeString":"uczestnicy {displayName1}, {displayName2} i {displayName3} opuścili","unnamedParticipantString":"uczestnik bez nazwy","manyUnnamedParticipantsJoined":"uczestnik bez nazwy i {numOfParticipants} innych uczestników dołączyli","manyUnnamedParticipantsLeft":"uczestnik bez nazwy i {numOfParticipants} innych uczestników opuścili","manyParticipantsJoined":"dołączono {displayName1}, {displayName2}, {displayName3} i {numOfParticipants} innych uczestników","manyParticipantsLeft":"{displayName1}, {displayName2}, {displayName3} i {numOfParticipants} innych uczestników pozostało","liveCaptionsLabel":"Napisy na żywo","captionsSettingsLabel":"Ustawienia napisów","startCaptionsButtonOnLabel":"Włącz podpisy","startCaptionsButtonOffLabel":"Wyłącz podpisy","startCaptionsButtonTooltipOnContent":"Wyłącz podpisy","startCaptionsButtonTooltipOffContent":"Włącz podpisy","captionsSettingsModalTitle":"Ustawienia napisów","captionsSettingsSpokenLanguageDropdownLabel":"Język mówiony","captionsSettingsCaptionLanguageDropdownLabel":"Język napisów","captionsSettingsSpokenLanguageDropdownInfoText":"Język, w którym mówią wszyscy uczestnicy tej rozmowy.","captionsSettingsCaptionLanguageDropdownInfoText":"Podpisy będą wyświetlane w tym języku.","captionsSettingsConfirmButtonLabel":"Potwierdź","captionsSettingsCancelButtonLabel":"Anuluj","captionsSettingsModalAriaLabel":"Modalne ustawianie podpisów","captionsSettingsCloseModalButtonAriaLabel":"Ustawienie podpisów","captionsBannerMoreButtonCallingLabel":"Więcej opcji ustawień napisów","captionsBannerMoreButtonTooltip":"Więcej opcji","realTimeTextLabel":"Pisanie w czasie rzeczywistym (RTT)","startRealTimeTextLabel":"Włącz funkcję Pisanie w czasie rzeczywistym dla tego połączenia","disabledStartRealTimeTextLabel":"Funkcja RTT jest obecnie włączona, nie można jej wyłączyć","dismissModalAriaLabel":"Lokalny i zdalny obraz i obraz, naciśnij klawisz Enter, aby powrócić do rozmowy","callRejectedTitle":"Nie można zakończyć rozmowy","callRejectedMoreDetails":"Osoba, z którą próbujesz się skontaktować, jest niedostępna. Spróbuj ponownie później.","callTimeoutTitle":"Nie można zakończyć rozmowy","callTimeoutDetails":"Osoba, z którą próbujesz się skontaktować, jest niedostępna. Spróbuj ponownie później.","callTimeoutBotTitle":"Nie można zakończyć rozmowy","callTimeoutBotDetails":"Usługa, z którą próbujesz się skontaktować, jest niedostępna. Spróbuj ponownie później.","dtmfDialerButtonLabel":"Klawiatura numeryczna","dtmfDialerButtonTooltipOn":"Pokaż klawiaturę numeryczną","dtmfDialerButtonTooltipOff":"Ukryj klawiaturę numeryczną","dtmfDialerMoreButtonLabelOn":"Pokaż klawiaturę numeryczną","dtmfDialerMoreButtonLabelOff":"Ukryj klawiaturę numeryczną","phoneCallMoreButtonLabel":"Rozmowa telefoniczna","spokenLanguageStrings":{"ar-ae":"arabski — Zjednoczone Emiraty Arabskie","ar-sa":"arabski — Arabia Saudyjska","da-dk":"duński","de-de":"niemiecki — Niemcy","en-au":"angielski — Australia","en-ca":"angielski — Kanada","en-gb":"angielski — Zjednoczone Królestwo","en-in":"angielski — Indie","en-nz":"angielski — Nowa Zelandia","en-us":"angielski — Stany Zjednoczone","es-es":"hiszpański — Hiszpania (nowoczesny)","es-mx":"hiszpański — Meksyk","fi-fi":"fiński","fr-ca":"francuski — Kanada","fr-fr":"francuski — Francja","hi-in":"hindi","it-it":"włoski — Włochy","ja-jp":"japoński","ko-kr":"koreański","nb-no":"norweski (Bokmål)","nl-be":"niderlandzki — Belgia","nl-nl":"niderlandzki — Holandia","pl-pl":"polski","pt-br":"portugalski — Brazylia","ru-ru":"rosyjski","sv-se":"szwedzki","zh-cn":"chiński (Chińska Republika Ludowa)","zh-hk":"chiński — Hongkong SAR","cs-cz":"czeski","pt-pt":"portugalski — Portugalia","tr-tr":"turecki","vi-vn":"wietnamski","th-th":"tajski","he-il":"hebrajski","cy-gb":"walijski","uk-ua":"ukraiński","el-gr":"grecki","hu-hu":"węgierski","ro-ro":"rumuński","sk-sk":"słowacki","zh-tw":"chiński — Tajwan"},"captionLanguageStrings":{"ar":"arabski","da":"duński","de":"niemiecki","en":"Angielski","es":"hiszpański","fi":"fiński","fr-ca":"francuski — Kanada","fr":"francuski — Francja","hi":"hindi","it":"włoski","ja":"japoński","ko":"koreański","nb":"norweski (Bokmål)","nl":"niderlandzki","pl":"polski","pt":"portugalski (Brazylia)","ru":"rosyjski","sv":"szwedzki","zh-Hans":"Chiński (uproszczony)","zh-Hant":"Chiński (tradycyjny)","cs":"czeski","pt-pt":"portugalski (Portugalia)","tr":"turecki","vi":"wietnamski","th":"tajski","he":"hebrajski","cy":"walijski","uk":"ukraiński","el":"grecki","hu":"węgierski","ro":"rumuński","sk":"słowacki"},"captionsBannerSpinnerText":"Trwa uruchamianie napisów...","realTimeTextInputBoxDefaultText":"Pisanie wiadomości w czasie rzeczywistym","realTimeTextInputErrorMessage":"Wiadomość nie może przekraczać 2000 znaków","realTimeTextBannerTitle":"Pisanie w czasie rzeczywistym","realTimeTextBannerContent":"Funkcja RTT (tekst w czasie rzeczywistym) jest włączona dla wszystkich uczestników przez cały czas trwania spotkania.","realTimeTextBannerLinkLabel":"Dowiedz się więcej","realTimeTextModalAriaLabel":"Włącz modalne okno dialogowe pisania w czasie rzeczywistym","realTimeTextModalTitle":"Włączyć pisanie w czasie rzeczywistym?","realTimeTextModalText":"Tekst w czasie rzeczywistym zostanie włączony dla wszystkich uczestników spotkania.","realTimeTextConfirmButtonLabel":"Włącz","realTimeTextCancelButtonLabel":"Anuluj","realTimeTextCloseModalButtonAriaLabel":"Zamknij modalne okno dialogowe pisania w czasie rzeczywistym","captionsOnlyContainerTitle":"Napisy","realTimeTextOnlyContainerTitle":"Pisanie w czasie rzeczywistym","captionsAndRealTimeTextContainerTitle":"Napisy i pisanie w czasie rzeczywistym","expandButtonAriaLabel":"Rozwiń","minimizeButtonAriaLabel":"Zwiń","transferPageTransferorText":"Trwa przełączanie...","transferPageTransferTargetText":"Trwa łączenie...","transferPageUnknownTransferorDisplayName":"Nieznany","transferPageUnknownTransferTargetDisplayName":"Nieznany","transferPageNoticeString":"Jesteś w trakcie przekierowania","participantCouldNotBeReachedTitle":"Uczestnik docelowy jest obecnie niedostępny","participantCouldNotBeReachedMoreDetails":"Skontaktuj się z uczestnikiem, gdy będzie dostępny","permissionToReachTargetParticipantNotAllowedTitle":"Uprawnienie do dotarcia do uczestnika docelowego jest niedozwolone","permissionToReachTargetParticipantNotAllowedMoreDetails":"Sprawdź, czy uczestnik docelowy znajduje się w tej samej dzierżawie","unableToResolveTenantTitle":"Nie można rozpoznać identyfikatora dzierżawy dla uczestnika docelowego","unableToResolveTenantMoreDetails":"Sprawdź, czy identyfikator uczestnika został wprowadzony poprawnie","participantIdIsMalformedTitle":"Identyfikator uczestnika ma niepoprawny format","participantIdIsMalformedMoreDetails":"Sprawdź, czy identyfikator uczestnika ma poprawny format","moreButtonGalleryControlLabel":"Zobacz","moreButtonGalleryPositionToggleLabel":"Przenieś galerię na górę","moreButtonGallerySpeakerLayoutLabel":"Głośnik","moreButtonGalleryFloatingLocalLayoutLabel":"Dynamiczny","moreButtonGalleryDefaultLayoutLabel":"Widok galerii","moreButtonGalleryFocusedContentLayoutLabel":"Skoncentruj się na zawartości","moreButtonLargeGalleryDefaultLayoutLabel":"Duża galeria","moreButtonTogetherModeLayoutLabel":"Tryb Razem","capabilityChangedNotification":{"turnVideoOn":{"lostDueToMeetingOption":"Kamera została wyłączona. Nie możesz już udostępniać wideo.","grantedDueToMeetingOption":"Kamera została włączona. Włącz ją, jeśli chcesz udostępnić wideo."},"unmuteMic":{"lostDueToMeetingOption":"Mikrofon został wyłączony. Nie można już wyłączyć wyciszenia.","grantedDueToMeetingOption":"Mikrofon został włączony. Wyłącz wyciszenie, jeśli chcesz mówić."},"shareScreen":{"lostDueToRoleChangeToAttendee":"Rola została zmieniona. Niektóre akcje, takie jak udostępnianie zawartości, nie będą dla Ciebie dostępne.","grantedDueToRoleChangeToPresenter":"Jesteś osobą prowadzącą. Możesz udostępniać zawartość i prowadzić spotkanie."},"hideAttendeeNames":{"hideAttendeeNameAttendee":"Twoje imię i nazwisko jest ukryte przed innymi uczestnikami. Organizatorzy i osoby prowadzące mogą zobaczyć Twoje prawdziwe imię.","hideAttendeeNamePresenter":"Imiona i nazwiska uczestników są ukryte. Tylko organizatorzy i osoby prowadzące mogą wyświetlać imiona i nazwiska, aby chronić prywatność uczestników."}},"surveyTitle":"Pomóż nam w ulepszaniu","starSurveyHelperText":"Jaka była jakość połączenia?","starSurveyOneStarText":"Jakość była zła.","starSurveyTwoStarText":"Jakość była niska.","starSurveyThreeStarText":"Jakość była dobra.","starSurveyFourStarText":"Jakość była doskonała.","starSurveyFiveStarText":"Jakość była świetna.","surveyConfirmButtonLabel":"Prześlij opinię","starRatingAriaLabel":"Wybierz {0} z {1} gwiazdek","surveySkipButtonLabel":"Pomiń","tagsSurveyQuestion":"Co można było zrobić lepiej?","tagsSurveyTextFieldDefaultText":"Inny — prosimy określić","tagsSurveyHelperText":"Sprawdź wszelkie napotkane problemy","endOfSurveyText":"Dziękujemy za opinię!","surveyIssues":{"overallRating":{"callCannotJoin":"Nie mogę dołączyć do rozmowy","callCannotInvite":"Nie mogę zaprosić innych osób do rozmowy","hadToRejoin":"Konieczne było ponowne dołączenie do rozmowy","callEndedUnexpectedly":"Rozmowa została nieoczekiwanie zakończona","otherIssues":"Wystąpiły inne problemy z połączeniem"},"audioRating":{"noLocalAudio":"Mój rozmówca nic nie słyszał","noRemoteAudio":"Nie było słychać żadnego dźwięku","echo":"Podczas rozmowy słychać było echo","audioNoise":"Słyszę szum podczas rozmowy","lowVolume":"Poziom głośności był zbyt niski","audioStoppedUnexpectedly":"Dźwięk został nieoczekiwanie zatrzymany","distortedSpeech":"Dźwięk był zniekształcony","audioInterruption":"Dźwięk został przerwany","otherIssues":"Występowały inne problemy z dźwiękiem podczas tego połączenia"},"videoRating":{"noVideoReceived":"Nie było nic widać","noVideoSent":"Inne osoby mnie nie widziały","lowQuality":"Jakość wideo była niska","freezes":"Wideo zablokowane","stoppedUnexpectedly":"Wideo zostało nieoczekiwanie zatrzymane","darkVideoReceived":"Widzę ciemne ekrany tylko wtedy, gdy inni włączają kamerę","audioVideoOutOfSync":"Dźwięk i obraz nie były zsynchronizowane","otherIssues":"Występowały inne problemy z wideo podczas tego połączenia"},"screenshareRating":{"noContentLocal":"Inne osoby nie widziały mojego udostępnionego ekranu","noContentRemote":"Nie widzę zrzutów ekranu innych osób","cannotPresent":"Nie mogę zaprezentować ekranu","lowQuality":"Jakość udostępniania ekranu była niska","freezes":"Udostępnianie ekranu zablokowane","stoppedUnexpectedly":"Udostępnianie ekranu zostało nieoczekiwanie zatrzymane","largeDelay":"Udostępnianie ekranu ma duże opóźnienie","otherIssues":"Wystąpiły inne problemy z udostępnianiem ekranu podczas tej rozmowy"}},"surveyIssuesHeadingStrings":{"overallRating":"Ogólne","audioRating":"Dźwięk","videoRating":"Wideo","screenshareRating":"W trakcie prezentacji"},"spotlightPrompt":{"startSpotlightHeading":"Wyróżnić dla wszystkich?","startSpotlightText":"Wyróżnisz ten klip wideo dla wszystkich uczestników spotkania.","startSpotlightOnSelfText":"Wyróżnisz swój klip wideo dla wszystkich uczestników spotkania.","startSpotlightConfirmButtonLabel":"Wyróżnij dla wszystkich","startSpotlightCancelButtonLabel":"Anuluj","stopSpotlightHeading":"Zatrzymać wyróżnianie tego klipu wideo?","stopSpotlightOnSelfHeading":"Zakończyć wyróżnianie?","stopAllSpotlightHeading":"Zatrzymać wyróżnianie wszystkich klipów wideo?","stopSpotlightText":"Klip wideo nie będzie już wyróżniany dla wszystkich osób na spotkaniu.","stopSpotlightOnSelfText":"Twój klip wideo nie będzie już wyróżniany dla wszystkich osób na spotkaniu.","stopAllSpotlightText":"Klipy wideo nie będą już wyróżniane dla wszystkich osób na spotkaniu.","stopSpotlightConfirmButtonLabel":"Zatrzymaj wyróżnianie","stopSpotlightOnSelfConfirmButtonLabel":"Zakończ wyróżnienie","stopSpotlightCancelButtonLabel":"Anuluj","closeSpotlightPromptButtonLabel":"Zamknij"},"exitSpotlightButtonLabel":"Wyjdź z ważnych informacji","exitSpotlightButtonTooltip":"Wyjdź z ważnych informacji","leaveConfirmButtonLabel":"Opuść","endCallConfirmButtonLabel":"Zakończ połączenie","hangUpCancelButtonLabel":"Anuluj","leaveConfirmDialogTitle":"Opuścić połączenie?","leaveConfirmDialogContent":"Czy na pewno chcesz opuścić rozmowę?","endCallConfirmDialogTitle":"Zakończyć połączenie?","endCallConfirmDialogContent":"Zakończysz połączenie dla wszystkich.","invalidMeetingIdentifier":"Nieprawidłowy identyfikator spotkania lub kod dostępu","pinParticipantMenuLabel":"Przypnij dla mnie","pinParticipantLimitReachedMenuLabel":"Przypięcie (osiągnięto limit)","unpinParticipantMenuLabel":"Odepnij","pinParticipantMenuItemAriaLabel":"Przypnij dla mnie","unpinParticipantMenuItemAriaLabel":"Odepnij","muteAllMenuLabel":"Wycisz wszystkich","muteAllDialogTitle":"Wyciszyć wszystkich?","muteAllDialogContent":"Spowoduje to wyciszenie wszystkich osób na spotkaniu oprócz Ciebie.","muteAllConfirmButtonLabel":"Wycisz wszystkich","muteAllCancelButtonLabel":"Anuluj","joinBreakoutRoomButtonLabel":"Dołącz do osobnego pokoju","returnFromBreakoutRoomButtonLabel":"Opuść pokój","leaveBreakoutRoomAndMeetingButtonLabel":"Opuść spotkanie","breakoutRoomJoinedNotificationTitle":"Dołączono do osobnego pokoju „{roomName}”","joinBreakoutRoomBannerTitle":"Osobny pokój „{roomName}” jest otwarty","joinBreakoutRoomBannerButtonLabel":"Dołącz","returnFromBreakoutRoomBannerTitle":"Powrót do spotkania głównego","returnFromBreakoutRoomBannerButtonLabel":"Dołącz ponownie","forbidAudioMenuLabel":"Wyłącz mikrofon","permitAudioMenuLabel":"Zezwalaj na mikrofon","forbidOthersAudioDialogTitle":"Wyłączyć mikrofon uczestnikom?","forbidOthersAudioDialogContent":"Uczestnicy nie będą mogli samodzielnie wyłączyć wyciszenia. Organizator i osoby prowadzące mogą zezwolić innym osobom na wyłączanie wyciszenia w razie potrzeby.","forbidOthersAudioConfirmButtonLabel":"Wyłącz mikrofony","forbidOthersAudioCancelButtonLabel":"Anuluj","permitOthersAudioDialogTitle":"Czy zezwolić uczestnikom na używanie mikrofonu?","permitOthersAudioDialogContent":"Każdy uczestnik spotkania będzie mógł wyłączyć swoje wyciszenie.","permitOthersAudioConfirmButtonLabel":"Zezwalaj na mikrofony","permitOthersAudioCancelButtonLabel":"Anuluj","forbidOthersAudioMenuLabel":"Wyłącz mikrofon uczestników","permitOthersAudioMenuLabel":"Zezwalaj uczestnikom na używanie mikrofonu","forbidVideoMenuLabel":"Wyłącz kamerę","permitVideoMenuLabel":"Zezwalaj na kamerę","forbidOthersVideoDialogTitle":"Wyłączyć kamerę uczestników?","forbidOthersVideoDialogContent":"Uczestnicy nie będą mogli samodzielnie włączyć wideo. Organizator i osoby prowadzące mogą zezwolić innym osobom na włączenie kamery w razie potrzeby.","forbidOthersVideoConfirmButtonLabel":"Wyłącz kamery","forbidOthersVideoCancelButtonLabel":"Anuluj","permitOthersVideoDialogTitle":"Czy zezwolić uczestnikom na używanie kamer?","permitOthersVideoDialogContent":"Każdy uczestnik spotkania będzie mógł samodzielnie włączyć wideo.","permitOthersVideoConfirmButtonLabel":"Zezwalaj na kamery","permitOthersVideoCancelButtonLabel":"Anuluj","forbidOthersVideoMenuLabel":"Wyłącz kamerę uczestnikom","permitOthersVideoMenuLabel":"Zezwalaj uczestnikom na używanie kamery"}'),chat:{chatListHeader:"W tym czacie",uploadAttachment:"Przekaż załącznik",uploadImageDataNotProvided:"Nie udostępniono danych obrazu.",uploadImageIsTooLarge:"Obraz jest za duży. Wybierz rozmiar mniejszy niż {maxImageSize} MB.",uploadImageExtensionIsNotAllowed:"Przekazywanie obrazu .{imageExtension} nie jest dozwolone.",uploadImageFailed:"Nie można przekazać obrazu. Spróbuj ponownie później."},callWithChat:{chatButtonLabel:"Czat",chatButtonNewMessageNotificationLabel:"Nowa wiadomość",chatButtonTooltipClosedWithMessageCount:"Pokaż czat (nieprzeczytane: {unreadMessagesCount})",chatButtonTooltipClose:"Ukryj czat",chatButtonTooltipOpen:"Pokaż czat",chatPaneTitle:"Czat",copyInviteLinkButtonLabel:"Kopiuj link do zaproszenia",copyInviteLinkButtonActionedLabel:"Skopiowano link",copyInviteLinkActionedAriaLabel:"Skopiowano link do zaproszenia",dismissSidePaneButtonLabel:"Zamknij",moreDrawerAudioDeviceMenuTitle:"Urządzenie audio",moreDrawerButtonLabel:"Więcej opcji",moreDrawerButtonTooltip:"Więcej opcji",moreDrawerMicrophoneMenuTitle:"Mikrofon",moreDrawerSpeakerMenuTitle:"Głośnik",moreDrawerCaptionsMenuTitle:"Napisy na żywo",moreDrawerSpokenLanguageMenuTitle:"Język mówiony",moreDrawerCaptionLanguageMenuTitle:"Język napisów",moreDrawerGalleryOptionsMenuTitle:"Opcje galerii",peopleButtonLabel:"Osoby",selectedPeopleButtonLabel:"Wybrano przycisk Kontakty",peopleButtonTooltipOpen:"Pokaż uczestników",peopleButtonTooltipClose:"Ukryj uczestników",peopleButtonTooltipOpenAriaLabel:"Przycisk Kontakty, Pokaż uczestników",peopleButtonTooltipCloseAriaLabel:"Przycisk Kontakty, Ukryj uczestników",peoplePaneSubTitle:"W tej rozmowie",peoplePaneTitle:"Osoby",pictureInPictureTileAriaLabel:"Kanały wideo. Kliknij, aby powrócić do ekranu rozmowy.",removeMenuLabel:"Usuń",openDialpadButtonLabel:"Wybierz numer telefonu",returnToCallButtonAriaDescription:"Wróć do rozmowy",returnToCallButtonAriaLabel:"Wstecz",peoplePaneAddPeopleButtonLabel:"Dodaj osoby",dialpadStartCallButtonLabel:"Zadzwoń",dialpadModalTitle:"Wybieranie numeru telefonu",dialpadModalAriaLabel:"Klawiatura numeryczna",dialpadCloseModalButtonAriaLabel:"Zamknij klawiaturę numeryczną",openDtmfDialpadLabel:"Pokaż klawiaturę numeryczną",dtmfDialpadPlaceholderText:"Wprowadź numer",breakoutRoomChatPaneTitle:"Czat osobnego pokoju",chatContentSpinnerLabel:"Ładowanie czatu"}})},wli={component:TQt,strings:Yh({call:JSON.parse(`{"cameraLabel":"Câmera","noCamerasLabel":"Nenhuma câmera encontrada","cameraPermissionDenied":"Seu navegador está bloqueando o acesso à câmera","cameraTurnedOff":"Sua câmera está desativada","chatButtonLabel":"Chat","close":"Fechar","complianceBannerNowOnlyRecording":"Você agora está apenas gravando esta reunião.","complianceBannerNowOnlyTranscription":"Você agora está apenas transcrevendo esta reunião.","complianceBannerRecordingAndTranscriptionSaved":"A gravação e a transcrição estão sendo salvas.","complianceBannerRecordingAndTranscriptionStarted":"A gravação e a transcrição foram iniciadas.","complianceBannerRecordingAndTranscriptionStopped":"A gravação e a transcrição foram interrompidas.","complianceBannerRecordingSaving":"A gravação está sendo salva.","complianceBannerRecordingStarted":"A gravação foi iniciada.","complianceBannerRecordingStopped":"A gravação foi interrompida.","complianceBannerTranscriptionStarted":"A transcrição foi iniciada.","complianceBannerTranscriptionConsent":"Ao ingressar, você está dando consentimento para que esta reunião seja transcrita.","complianceBannerTranscriptionSaving":"A transcrição está sendo salva.","complianceBannerTranscriptionStopped":"A transcrição foi interrompida.","configurationPageTitle":"Iniciar uma chamada","copyInviteLinkButtonLabel":"Copiar o link de convite","copyInviteLinkButtonActionedLabel":"Link copiado","copyInviteLinkActionedAriaLabel":"Link de convite copiado","defaultPlaceHolder":"Selecionar uma opção","dismissSidePaneButtonLabel":"Fechar","videoEffectsPaneTitle":"Efeitos","videoEffectsPaneBackgroundSelectionTitle":"Tela de fundo","videoEffectsPaneAriaLabel":"Painel de efeitos de vídeo","configurationPageCameraIsLoadingLabel":"O vídeo está carregando...","configurationPageVideoEffectsButtonLabel":"Efeitos","unableToStartVideoEffect":"Não é possível aplicar o efeito de vídeo.","blurBackgroundEffectButtonLabel":"Desfoque","blurBackgroundTooltip":"Desfocar a Tela de fundo","removeBackgroundEffectButtonLabel":"Nenhum","removeBackgroundTooltip":"Remover Tela de fundo","cameraOffBackgroundEffectWarningText":"A câmera está desligada. Ligue a câmera para ver o efeito de vídeo.","failedToJoinCallDueToNoNetworkMoreDetails":"A chamada foi desconectada devido a um problema de rede. Verifique sua conexão e ingresse novamente.","failedToJoinCallDueToNoNetworkTitle":"Chamada desconectada","failedToJoinTeamsMeetingReasonAccessDeniedMoreDetails":"Você não recebeu entrada na chamada. Se isso foi um erro, ingresse novamente na chamada.","failedToJoinTeamsMeetingReasonAccessDeniedTitle":"Ignorado do lobby","learnMore":"Saber mais","leavingCallTitle":"Saindo...","leftCallMoreDetails":"Se isso foi um erro, ingresse novamente na chamada.","leftCallTitle":"Você saiu da chamada","lobbyScreenConnectingToCallTitle":"Ingressando na chamada","lobbyScreenWaitingToBeAdmittedTitle":"Esperando para ser admitido","microphonePermissionDenied":"Seu navegador está bloqueando o acesso ao microfone","microphoneToggleInLobbyNotAllowed":"Não é possível ativar ou desativar mudo enquanto estiver no lobby.","mutedMessage":"Você está com o mudo ativado","networkReconnectMoreDetails":"Parece que algo deu errado. Estamos tentando retornar à chamada.","networkReconnectTitle":"Em espera","notInvitedToRoomDetails":"Você não pode ingressar nesta sala porque não tem um convite.","notInvitedToRoomTitle":"Não convidado para a sala","peopleButtonLabel":"Pessoas","selectedPeopleButtonLabel":"Botão Pessoas Selecionado","peoplePaneTitle":"Pessoas","peoplePaneMoreButtonAriaLabel":"Mais","peopleButtonTooltipOpen":"Mostrar participantes","peopleButtonTooltipClose":"Ocultar participantes","peoplePaneSubTitle":"Nessa chamada {numberOfPeople}","privacyPolicy":"Política de privacidade","rejoinCallButtonLabel":"Reingressar na chamada","removedFromCallMoreDetails":"Outro participante removeu você da chamada.","removedFromCallTitle":"Você foi removido","removeMenuLabel":"Remover","startSpotlightMenuLabel":"Destacar para todos","addSpotlightMenuLabel":"Adicionar destaque","stopSpotlightMenuLabel":"Parar de destacar","stopSpotlightOnSelfMenuLabel":"Sair de destaque","spotlightLimitReachedMenuTitle":"Limite de destaque atingido","stopAllSpotlightMenuLabel":"Parar todos os refletores","returnToCallButtonAriaDescription":"Retornar à Chamada","returnToCallButtonAriaLabel":"Voltar","roomNotFoundDetails":"Não foi possível encontrar a ID da sala fornecida.","roomNotFoundTitle":"Sala não encontrada","roomNotValidDetails":"No momento, esta sala não é válida.","roomNotValidTitle":"Sala inválida","inviteToRoomRemovedDetails":"Seu convite para ingressar nesta sala foi removido.","inviteToRoomRemovedTitle":"O convite para a sala foi removido","soundLabel":"Som","noMicrophonesLabel":"Nenhum microfone encontrado","noSpeakersLabel":"Nenhum alto-falante encontrado","startCallButtonLabel":"Iniciar chamada","openDialpadButtonLabel":"Número de telefone de discagem","peoplePaneAddPeopleButtonLabel":"Adicionar Pessoas","dialpadStartCallButtonLabel":"Chamar","dialpadModalTitle":"Número de Telefone de Discagem","dialpadModalAriaLabel":"Teclado de discagem","dialpadCloseModalButtonAriaLabel":"Fechar teclado","moreButtonCallingLabel":"Mais","resumeCallButtonLabel":"Retomar","resumingCallButtonLabel":"Retomando…","resumeCallButtonAriaLabel":"Retomar chamada","resumingCallButtonAriaLabel":"Retomar chamada","holdScreenLabel":"Você está em espera","openDtmfDialpadLabel":"Mostrar teclado de discagem","dtmfDialpadPlaceholderText":"Digite o número","outboundCallingNoticeString":"Chamando...","participantJoinedNoticeString":"{displayName} ingressou","twoParticipantJoinedNoticeString":"{displayName1} e {displayName2} ingressaram","threeParticipantJoinedNoticeString":"{displayName1}, {displayName2} e {displayName3} ingressaram","participantLeftNoticeString":"{displayName} saiu","twoParticipantLeftNoticeString":"{displayName1} e {displayName2} saíram","threeParticipantLeftNoticeString":"{displayName1}, {displayName2} e {displayName3} saíram","unnamedParticipantString":"participante sem nome","manyUnnamedParticipantsJoined":"participante sem nome e outros {numOfParticipants} participantes ingressaram","manyUnnamedParticipantsLeft":"participante sem nome e outros {numOfParticipants} participantes saíram","manyParticipantsJoined":"{displayName1}, {displayName2}, {displayName3} e {numOfParticipants} outros participantes ingressaram","manyParticipantsLeft":"{displayName1}, {displayName2}, {displayName3} e {numOfParticipants} outros participantes saíram","liveCaptionsLabel":"Legendas ao Vivo","captionsSettingsLabel":"Configurações de legenda","startCaptionsButtonOnLabel":"Ativar legendas","startCaptionsButtonOffLabel":"Desativar legendas","startCaptionsButtonTooltipOnContent":"Desativar legendas","startCaptionsButtonTooltipOffContent":"Ativar legendas","captionsSettingsModalTitle":"Configurações de Legendas","captionsSettingsSpokenLanguageDropdownLabel":"Idioma falado","captionsSettingsCaptionLanguageDropdownLabel":"Idioma das legendas","captionsSettingsSpokenLanguageDropdownInfoText":"Idioma que todos nesta chamada estão falando.","captionsSettingsCaptionLanguageDropdownInfoText":"As legendas aparecerão neste idioma.","captionsSettingsConfirmButtonLabel":"Confirmar","captionsSettingsCancelButtonLabel":"Cancelar","captionsSettingsModalAriaLabel":"Configuração de Legendas Modal","captionsSettingsCloseModalButtonAriaLabel":"Fechar Configuração de Legendas","captionsBannerMoreButtonCallingLabel":"Mais Opções de Configurações de Legendas","captionsBannerMoreButtonTooltip":"Mais opções","realTimeTextLabel":"Digitação em tempo real (RTT)","startRealTimeTextLabel":"Habilitar a RTT para esta chamada","disabledStartRealTimeTextLabel":"O RTT está ativado no momento, não pode ser desativado","dismissModalAriaLabel":"Imagem e imagem local e remota, pressione Enter para retornar à chamada","callRejectedTitle":"Não foi possível concluir a chamada","callRejectedMoreDetails":"A pessoa que você está tentando acessar não está disponível. Tente novamente mais tarde.","callTimeoutTitle":"Não foi possível concluir a chamada","callTimeoutDetails":"A pessoa que você está tentando acessar não está disponível. Tente novamente mais tarde.","callTimeoutBotTitle":"Não foi possível concluir a chamada","callTimeoutBotDetails":"O serviço que você está tentando acessar não está disponível. Tente novamente mais tarde.","dtmfDialerButtonLabel":"Teclado de discagem","dtmfDialerButtonTooltipOn":"Mostrar teclado de discagem","dtmfDialerButtonTooltipOff":"Ocultar teclado de discagem","dtmfDialerMoreButtonLabelOn":"Mostrar teclado de discagem","dtmfDialerMoreButtonLabelOff":"Ocultar teclado de discagem","phoneCallMoreButtonLabel":"Chamada Telefônica","spokenLanguageStrings":{"ar-ae":"Árabe - Emirados Árabes Unidos","ar-sa":"Árabe - Arábia Saudita","da-dk":"Dinamarquês","de-de":"Alemão - Alemanha","en-au":"Inglês - Austrália","en-ca":"Inglês - Canadá","en-gb":"Inglês - Reino Unido","en-in":"Inglês - Índia","en-nz":"Inglês - Nova Zelândia","en-us":"Inglês - Estados Unidos","es-es":"Espanhol - Espanha (Moderno)","es-mx":"Espanhol - México","fi-fi":"Finlandês","fr-ca":"Francês - Canadá","fr-fr":"Francês - França","hi-in":"Híndi","it-it":"Italiano - Itália","ja-jp":"Japonês","ko-kr":"Coreano","nb-no":"Norueguês (Bokmål)","nl-be":"Holandês - Bélgica","nl-nl":"Holandês - Países Baixos","pl-pl":"Polonês","pt-br":"Português - Brasil","ru-ru":"Russo","sv-se":"Sueco","zh-cn":"Chinês - República Popular da China","zh-hk":"Chinês - RAE de Hong Kong","cs-cz":"Tcheco","pt-pt":"Português - Portugal","tr-tr":"Turco","vi-vn":"Vietnamita","th-th":"Tailandês","he-il":"Hebraico","cy-gb":"Galês","uk-ua":"Ucraniano","el-gr":"Grego","hu-hu":"Húngaro","ro-ro":"Romeno","sk-sk":"Eslovaco","zh-tw":"Chinês - Taiwan"},"captionLanguageStrings":{"ar":"Árabe","da":"Dinamarquês","de":"Alemão","en":"Inglês","es":"Espanhol","fi":"Finlandês","fr-ca":"Francês - Canadá","fr":"Francês - França","hi":"Híndi","it":"Italiano","ja":"Japonês","ko":"Coreano","nb":"Norueguês (Bokmål)","nl":"Holandês","pl":"Polonês","pt":"Português - Brasil","ru":"Russo","sv":"Sueco","zh-Hans":"Chinês (Simplificado)","zh-Hant":"Chinês (Tradicional)","cs":"Tcheco","pt-pt":"Português - Portugal","tr":"Turco","vi":"Vietnamita","th":"Tailandês","he":"Hebraico","cy":"Galês","uk":"Ucraniano","el":"Grego","hu":"Húngaro","ro":"Romeno","sk":"Eslovaco"},"captionsBannerSpinnerText":"Iniciando legendas...","realTimeTextInputBoxDefaultText":"Digitar mensagem em tempo real","realTimeTextInputErrorMessage":"A mensagem não pode ter mais de 2000 caracteres","realTimeTextBannerTitle":"RTT","realTimeTextBannerContent":"O RTT (texto em tempo real) está habilitado para todos os participantes durante toda a reunião.","realTimeTextBannerLinkLabel":"Saiba mais","realTimeTextModalAriaLabel":"Ativar Modal RTT","realTimeTextModalTitle":"Ativar a RTT?","realTimeTextModalText":"O texto em tempo real (RTT) será ativado para todos na reunião.","realTimeTextConfirmButtonLabel":"Ativar","realTimeTextCancelButtonLabel":"Cancelar","realTimeTextCloseModalButtonAriaLabel":"Fechar Modal RTT","captionsOnlyContainerTitle":"Legendas","realTimeTextOnlyContainerTitle":"Texto em Tempo Real","captionsAndRealTimeTextContainerTitle":"Legendas e Texto em Tempo Real","expandButtonAriaLabel":"Expandir","minimizeButtonAriaLabel":"Recolher","transferPageTransferorText":"Transferindo...","transferPageTransferTargetText":"Conectando...","transferPageUnknownTransferorDisplayName":"Desconhecido","transferPageUnknownTransferTargetDisplayName":"Desconhecido","transferPageNoticeString":"Você está sendo transferido","participantCouldNotBeReachedTitle":"O participante de destino não está disponível no momento","participantCouldNotBeReachedMoreDetails":"Entre em contato com o participante quando ele estiver disponível","permissionToReachTargetParticipantNotAllowedTitle":"A permissão para alcançar o participante de destino não é permitida","permissionToReachTargetParticipantNotAllowedMoreDetails":"Verifique se o participante de destino está no mesmo locatário","unableToResolveTenantTitle":"Não é possível resolve ID do locatário para o participante de destino","unableToResolveTenantMoreDetails":"Verifique se a ID do participante foi inserida corretamente","participantIdIsMalformedTitle":"A ID do participante não está no formato correto","participantIdIsMalformedMoreDetails":"Verifique marcar a ID do participante está no formato correto","moreButtonGalleryControlLabel":"Exibir","moreButtonGalleryPositionToggleLabel":"Mover a galeria para o topo","moreButtonGallerySpeakerLayoutLabel":"Viva-voz","moreButtonGalleryFloatingLocalLayoutLabel":"Dinâmica","moreButtonGalleryDefaultLayoutLabel":"Modo de exibição de galeria","moreButtonGalleryFocusedContentLayoutLabel":"Foco no conteúdo","moreButtonLargeGalleryDefaultLayoutLabel":"Galeria Grande","moreButtonTogetherModeLayoutLabel":"Modo Conferência","capabilityChangedNotification":{"turnVideoOn":{"lostDueToMeetingOption":"Sua câmera foi desabilitada. Você não pode mais compartilhar vídeo.","grantedDueToMeetingOption":"Sua câmera foi habilitada. Ative-o se quiser compartilhar vídeo."},"unmuteMic":{"lostDueToMeetingOption":"Seu microfone foi desabilitado. Você não pode mais ativar o som.","grantedDueToMeetingOption":"O seu microfone foi habilitado. Desative o mudo se quiser falar."},"shareScreen":{"lostDueToRoleChangeToAttendee":"Sua função foi alterada. Algumas ações, como o compartilhamento de conteúdo, não estarão disponíveis para você.","grantedDueToRoleChangeToPresenter":"Você é um apresentador. Você pode compartilhar conteúdo e facilitar a reunião."},"hideAttendeeNames":{"hideAttendeeNameAttendee":"Seu nome está oculto para outros participantes. Organizadores e apresentadores podem ver seu nome verdadeiro.","hideAttendeeNamePresenter":"Os nomes dos participantes estão ocultos. Somente organizadores e apresentadores podem ver os nomes para proteger a privacidade dos participantes."}},"surveyTitle":"Ajude-nos a melhorar","starSurveyHelperText":"Como estava a qualidade da chamada?","starSurveyOneStarText":"A qualidade era ruim.","starSurveyTwoStarText":"A qualidade era ruim.","starSurveyThreeStarText":"A qualidade era boa.","starSurveyFourStarText":"A qualidade era ótima.","starSurveyFiveStarText":"A qualidade estava excelente.","surveyConfirmButtonLabel":"Enviar Comentários","starRatingAriaLabel":"Selecione {0} de {1} estrelas","surveySkipButtonLabel":"Ignorar","tagsSurveyQuestion":"O que poderia ter sido melhor?","tagsSurveyTextFieldDefaultText":"Outro; especifique","tagsSurveyHelperText":"Marque quaisquer problemas que você tenha enfrentado.","endOfSurveyText":"Agradecemos seus comentários!","surveyIssues":{"overallRating":{"callCannotJoin":"Não foi possível ingressar na chamada","callCannotInvite":"Não foi possível convidar outras pessoas para a chamada","hadToRejoin":"Eu tive que reingressar na chamada","callEndedUnexpectedly":"A chamada foi encerrada inesperadamente para mim","otherIssues":"Eu tive outros problemas com a chamada"},"audioRating":{"noLocalAudio":"O outro lado não conseguiu ouvir nenhum som","noRemoteAudio":"Não consegui ouvir o som","echo":"Ouvi ecos na chamada","audioNoise":"Ouvi ruído na chamada","lowVolume":"O volume estava baixo","audioStoppedUnexpectedly":"O áudio foi interrompido inesperadamente","distortedSpeech":"O áudio estava distorcido","audioInterruption":"O áudio foi interrompido","otherIssues":"Eu tive outros problemas de áudio nesta chamada"},"videoRating":{"noVideoReceived":"Não consegui ver o vídeo","noVideoSent":"Outras pessoas não puderam me ver","lowQuality":"A qualidade do vídeo estava baixa","freezes":"O vídeo ficou congelado","stoppedUnexpectedly":"O vídeo foi interrompido inesperadamente","darkVideoReceived":"Só consigo ver telas escuras quando outras pessoas ativam a câmera","audioVideoOutOfSync":"O Áudio e o Vídeo estavam fora de sincronia","otherIssues":"Eu tive outros problemas de vídeo nesta chamada"},"screenshareRating":{"noContentLocal":"Outras pessoas não puderam ver meu compartilhamento de tela","noContentRemote":"Não foi possível ver o compartilhamento de tela de outras pessoas","cannotPresent":"Não foi possível apresentar minha tela","lowQuality":"A qualidade do compartilhamento de tela estava baixa","freezes":"O compartilhamento de tela ficou congelado","stoppedUnexpectedly":"O compartilhamento de tela foi interrompido inesperadamente","largeDelay":"O compartilhamento de tela tem um grande atraso","otherIssues":"Eu estava tendo outros problemas de compartilhamento de tela nesta chamada"}},"surveyIssuesHeadingStrings":{"overallRating":"De modo geral","audioRating":"Áudio","videoRating":"Vídeo","screenshareRating":"Apresentando"},"spotlightPrompt":{"startSpotlightHeading":"Destacar para todo mundo?","startSpotlightText":"Você vai realçar este vídeo para todos os participantes da reunião.","startSpotlightOnSelfText":"Você realçará seu vídeo para todos os participantes da reunião.","startSpotlightConfirmButtonLabel":"Destacar para todo mundo","startSpotlightCancelButtonLabel":"Cancelar","stopSpotlightHeading":"Parar de dar destaque a este vídeo?","stopSpotlightOnSelfHeading":"Sair do destaque?","stopAllSpotlightHeading":"Parar de destacar todos os vídeos?","stopSpotlightText":"Esse vídeo não será mais realçado para todos os participantes da reunião.","stopSpotlightOnSelfText":"Seu vídeo não será mais realçado para todos os participantes da reunião.","stopAllSpotlightText":"Os vídeos não serão mais destacados para todos na reunião.","stopSpotlightConfirmButtonLabel":"Parar de destacar","stopSpotlightOnSelfConfirmButtonLabel":"Sair do destaque","stopSpotlightCancelButtonLabel":"Cancelar","closeSpotlightPromptButtonLabel":"Fechar"},"exitSpotlightButtonLabel":"Sair do destaque","exitSpotlightButtonTooltip":"Sair do destaque","leaveConfirmButtonLabel":"Sair","endCallConfirmButtonLabel":"Encerrar chamada","hangUpCancelButtonLabel":"Cancelar","leaveConfirmDialogTitle":"Sair da chamada?","leaveConfirmDialogContent":"Tem certeza de que deseja sair da chamada?","endCallConfirmDialogTitle":"Encerrar a chamada?","endCallConfirmDialogContent":"Você encerrará a chamada para todos.","invalidMeetingIdentifier":"ID ou senha de reunião inválida","pinParticipantMenuLabel":"Fixar para mim","pinParticipantLimitReachedMenuLabel":"Fixar (limite alcançado)","unpinParticipantMenuLabel":"Desafixar","pinParticipantMenuItemAriaLabel":"Fixar para mim","unpinParticipantMenuItemAriaLabel":"Desafixar","muteAllMenuLabel":"Ativar mudo de todos","muteAllDialogTitle":"Ativar mudo para todos?","muteAllDialogContent":"Isso ativará o mudo para todas as pessoas na reunião, exceto para você.","muteAllConfirmButtonLabel":"Ativar mudo de todos","muteAllCancelButtonLabel":"Cancelar","joinBreakoutRoomButtonLabel":"Ingressar na sala da sessão de grupo","returnFromBreakoutRoomButtonLabel":"Sair da sala","leaveBreakoutRoomAndMeetingButtonLabel":"Sair da reunião","breakoutRoomJoinedNotificationTitle":"Você ingressou na sala para sessão de grupo '{roomName}'","joinBreakoutRoomBannerTitle":"A sala para sessão de grupo '{roomName}' está aberta","joinBreakoutRoomBannerButtonLabel":"Ingressar","returnFromBreakoutRoomBannerTitle":"Voltar à reunião principal","returnFromBreakoutRoomBannerButtonLabel":"Reingressar","forbidAudioMenuLabel":"Desligar microfone","permitAudioMenuLabel":"Permitir microfone","forbidOthersAudioDialogTitle":"Desligar microfone para os participantes?","forbidOthersAudioDialogContent":"Participantes não poderão ativar o som. O organizador e os apresentadores podem ativar o som das pessoas conforme necessário.","forbidOthersAudioConfirmButtonLabel":"Desligar microfones","forbidOthersAudioCancelButtonLabel":"Cancelar","permitOthersAudioDialogTitle":"Permitir microfone para os participantes?","permitOthersAudioDialogContent":"Todos na reunião poderão desativar o mudo.","permitOthersAudioConfirmButtonLabel":"Permitir microfones","permitOthersAudioCancelButtonLabel":"Cancelar","forbidOthersAudioMenuLabel":"Desligar microfone para os participantes","permitOthersAudioMenuLabel":"Permitir microfone para os participantes","forbidVideoMenuLabel":"Desabilitar câmera","permitVideoMenuLabel":"Permitir câmera","forbidOthersVideoDialogTitle":"Desabilitar câmera para os participantes?","forbidOthersVideoDialogContent":"Os participantes não poderão ativar o vídeo por conta própria. O organizador e os apresentadores podem permitir que as pessoas ativem a câmera conforme necessário.","forbidOthersVideoConfirmButtonLabel":"Desabilitar câmeras","forbidOthersVideoCancelButtonLabel":"Cancelar","permitOthersVideoDialogTitle":"Permitir câmera para os participantes?","permitOthersVideoDialogContent":"Todos na reunião poderão ativar o vídeo por conta própria.","permitOthersVideoConfirmButtonLabel":"Permitir câmeras","permitOthersVideoCancelButtonLabel":"Cancelar","forbidOthersVideoMenuLabel":"Desabilitar a câmera para os participantes","permitOthersVideoMenuLabel":"Permitir câmera para os participantes"}`),chat:{chatListHeader:"Neste chat",uploadAttachment:"Carregar anexo",uploadImageDataNotProvided:"Os dados da imagem não foram fornecidos.",uploadImageIsTooLarge:"A imagem é muito grande. Escolha um que seja menor que {maxImageSize} MB.",uploadImageExtensionIsNotAllowed:"O upload da imagem .{imageExtension} não é permitido.",uploadImageFailed:"Não é possível carregar a imagem. Tente novamente mais tarde."},callWithChat:{chatButtonLabel:"Chat",chatButtonNewMessageNotificationLabel:"Nova mensagem",chatButtonTooltipClosedWithMessageCount:"Mostrar chat ({unreadMessagesCount} não lido)",chatButtonTooltipClose:"Ocultar chat",chatButtonTooltipOpen:"Mostrar chat",chatPaneTitle:"Chat",copyInviteLinkButtonLabel:"Copiar o link de convite",copyInviteLinkButtonActionedLabel:"Link copiado",copyInviteLinkActionedAriaLabel:"Link de convite copiado",dismissSidePaneButtonLabel:"Fechar",moreDrawerAudioDeviceMenuTitle:"Dispositivo de Áudio",moreDrawerButtonLabel:"Mais opções",moreDrawerButtonTooltip:"Mais opções",moreDrawerMicrophoneMenuTitle:"Microfone",moreDrawerSpeakerMenuTitle:"Alto-falante",moreDrawerCaptionsMenuTitle:"Legendas ao Vivo",moreDrawerSpokenLanguageMenuTitle:"Idioma falado",moreDrawerCaptionLanguageMenuTitle:"Idioma da legenda",moreDrawerGalleryOptionsMenuTitle:"Opções da galeria",peopleButtonLabel:"Pessoas",selectedPeopleButtonLabel:"Botão Pessoas Selecionado",peopleButtonTooltipOpen:"Mostrar Participantes",peopleButtonTooltipClose:"Ocultar participantes",peopleButtonTooltipOpenAriaLabel:"Botão Pessoas, Mostrar participantes",peopleButtonTooltipCloseAriaLabel:"Botão Pessoas, Ocultar participantes",peoplePaneSubTitle:"Nesta chamada",peoplePaneTitle:"Pessoas",pictureInPictureTileAriaLabel:"Feeds de vídeo. Clique para retornar à tela de chamada.",removeMenuLabel:"Remover",openDialpadButtonLabel:"Número de telefone de discagem",returnToCallButtonAriaDescription:"Retornar à Chamada",returnToCallButtonAriaLabel:"Voltar",peoplePaneAddPeopleButtonLabel:"Adicionar Pessoas",dialpadStartCallButtonLabel:"Chamar",dialpadModalTitle:"Número de Telefone de Discagem",dialpadModalAriaLabel:"Teclado de discagem",dialpadCloseModalButtonAriaLabel:"Fechar teclado",openDtmfDialpadLabel:"Mostrar teclado de discagem",dtmfDialpadPlaceholderText:"Digite o número",breakoutRoomChatPaneTitle:"Chat da Sala para Sessão de Grupo",chatContentSpinnerLabel:"Carregando chat"}})},kli={component:CQt,strings:Yh({call:JSON.parse('{"cameraLabel":"Камера","noCamerasLabel":"Камеры не найдены","cameraPermissionDenied":"Браузер блокирует доступ к вашей камере","cameraTurnedOff":"Камера выключена","chatButtonLabel":"Чат","close":"Закрыть","complianceBannerNowOnlyRecording":"Сейчас для этого собрания ведется только запись.","complianceBannerNowOnlyTranscription":"Сейчас для этого собрания ведется только транскрибирование.","complianceBannerRecordingAndTranscriptionSaved":"Сохранение записи и транскрибирования.","complianceBannerRecordingAndTranscriptionStarted":"Начата запись и транскрибирование.","complianceBannerRecordingAndTranscriptionStopped":"Запись и транскрибирование остановлены.","complianceBannerRecordingSaving":"Сохранение записи.","complianceBannerRecordingStarted":"Запись начата.","complianceBannerRecordingStopped":"Запись остановлена.","complianceBannerTranscriptionStarted":"Транскрибирование запущено.","complianceBannerTranscriptionConsent":"Присоединяясь, вы даете согласие на транскрибирование этого собрания.","complianceBannerTranscriptionSaving":"Сохранение транскрибирования.","complianceBannerTranscriptionStopped":"Транскрибирование остановлено.","configurationPageTitle":"Позвонить","copyInviteLinkButtonLabel":"Копировать ссылку с приглашением","copyInviteLinkButtonActionedLabel":"Ссылка скопирована","copyInviteLinkActionedAriaLabel":"Ссылка на приглашение в группу скопирована","defaultPlaceHolder":"Выберите один из вариантов","dismissSidePaneButtonLabel":"Закрыть","videoEffectsPaneTitle":"Эффекты","videoEffectsPaneBackgroundSelectionTitle":"Фон","videoEffectsPaneAriaLabel":"Панель видеоэффектов","configurationPageCameraIsLoadingLabel":"Загрузка видео...","configurationPageVideoEffectsButtonLabel":"Эффекты","unableToStartVideoEffect":"Не удалось применить эффект видео.","blurBackgroundEffectButtonLabel":"Размытие","blurBackgroundTooltip":"Размытие фона","removeBackgroundEffectButtonLabel":"Нет","removeBackgroundTooltip":"Удалить фон","cameraOffBackgroundEffectWarningText":"Камера выключена. Включите камеру, чтобы увидеть видеоэффект.","failedToJoinCallDueToNoNetworkMoreDetails":"Звонок был отключен из-за проблемы с сетью. Проверьте подключение и присоединитесь еще раз.","failedToJoinCallDueToNoNetworkTitle":"Вызов прерван","failedToJoinTeamsMeetingReasonAccessDeniedMoreDetails":"Вам не предоставили доступ к беседе. Если это произошло по ошибке, заново присоединитесь к беседе.","failedToJoinTeamsMeetingReasonAccessDeniedTitle":"Вы были удалены из \\"зала ожидания\\"","learnMore":"Подробнее","leavingCallTitle":"Выход...","leftCallMoreDetails":"Если это произошло по ошибке, заново присоединитесь к беседе.","leftCallTitle":"Вы покинули беседу","lobbyScreenConnectingToCallTitle":"Подключение к звонку","lobbyScreenWaitingToBeAdmittedTitle":"Ожидание допуска","microphonePermissionDenied":"Браузер блокирует доступ к вашему микрофону","microphoneToggleInLobbyNotAllowed":"Невозможно отключить или включить звук, находясь в \\"зале ожидания\\".","mutedMessage":"Ваш звук отключен","networkReconnectMoreDetails":"Похоже, что-то пошло не так. Мы пытаемся вернуться к звонку.","networkReconnectTitle":"Подождите","notInvitedToRoomDetails":"Вы не можете присоединиться к этой комнате, так как у вас нет приглашения.","notInvitedToRoomTitle":"Нет приглашения в комнату","peopleButtonLabel":"Люди","selectedPeopleButtonLabel":"Нажата кнопка \\"Люди\\"","peoplePaneTitle":"Люди","peoplePaneMoreButtonAriaLabel":"Еще","peopleButtonTooltipOpen":"Показать участников","peopleButtonTooltipClose":"Скрыть участников","peoplePaneSubTitle":"В этом вызове {numberOfPeople}","privacyPolicy":"Политика конфиденциальности","rejoinCallButtonLabel":"Повторно присоединиться к звонку","removedFromCallMoreDetails":"Другой участник удалил вас из беседы.","removedFromCallTitle":"Вы были удалены","removeMenuLabel":"Удалить","startSpotlightMenuLabel":"Закрепить видео для всех","addSpotlightMenuLabel":"Добавить закрепление","stopSpotlightMenuLabel":"Не закреплять","stopSpotlightOnSelfMenuLabel":"Открепить","spotlightLimitReachedMenuTitle":"Достигнуто предельное число закреплений","stopAllSpotlightMenuLabel":"Отменить все закрепления","returnToCallButtonAriaDescription":"Вернуться к звонку","returnToCallButtonAriaLabel":"Назад","roomNotFoundDetails":"Не удалось найти указанный идентификатор комнаты.","roomNotFoundTitle":"Помещение не найдено","roomNotValidDetails":"В данный момент эта комната недопустима.","roomNotValidTitle":"Недопустимая комната","inviteToRoomRemovedDetails":"Ваше приглашение присоединиться к этой комнате было удалено.","inviteToRoomRemovedTitle":"Приглашение в комнату удалено","soundLabel":"Звук","noMicrophonesLabel":"Микрофоны не найдены","noSpeakersLabel":"Динамики не найдены","startCallButtonLabel":"Начать звонок","openDialpadButtonLabel":"Набрать номер телефона","peoplePaneAddPeopleButtonLabel":"Добавить людей","dialpadStartCallButtonLabel":"Позвонить","dialpadModalTitle":"Набор номера телефона","dialpadModalAriaLabel":"Панель набора номера","dialpadCloseModalButtonAriaLabel":"Закрыть панель набора номера","moreButtonCallingLabel":"Дополнительно","resumeCallButtonLabel":"Возобновить","resumingCallButtonLabel":"Возобновление…","resumeCallButtonAriaLabel":"Возобновить звонок","resumingCallButtonAriaLabel":"Возобновить вызов","holdScreenLabel":"Ваш звонок на удержании","openDtmfDialpadLabel":"Показать панель набора номера","dtmfDialpadPlaceholderText":"Введите номер","outboundCallingNoticeString":"Выполняется вызов...","participantJoinedNoticeString":"Пользователь {displayName} присоединился","twoParticipantJoinedNoticeString":"{displayName1} и {displayName2} присоединились","threeParticipantJoinedNoticeString":"{displayName1}, {displayName2} и {displayName3} присоединились","participantLeftNoticeString":"Пользователь {displayName} ушел","twoParticipantLeftNoticeString":"{displayName1} и {displayName2} ушли","threeParticipantLeftNoticeString":"{displayName1}, {displayName2} и {displayName3} ушли","unnamedParticipantString":"участник без имени","manyUnnamedParticipantsJoined":"участник без имени и еще {numOfParticipants} участников присоединились","manyUnnamedParticipantsLeft":"участник без имени и еще {numOfParticipants} участников ушли","manyParticipantsJoined":"{displayName1}, {displayName2}, {displayName3} и {numOfParticipants} других участников","manyParticipantsLeft":"{displayName1}, {displayName2}, {displayName3} и {numOfParticipants} других участников","liveCaptionsLabel":"Автоматические субтитры","captionsSettingsLabel":"Параметры субтитров","startCaptionsButtonOnLabel":"Включить автоматические субтитры","startCaptionsButtonOffLabel":"Отключить автоматические субтитры","startCaptionsButtonTooltipOnContent":"Отключить автоматические субтитры","startCaptionsButtonTooltipOffContent":"Включить автоматические субтитры","captionsSettingsModalTitle":"Параметры субтитров","captionsSettingsSpokenLanguageDropdownLabel":"Язык речи","captionsSettingsCaptionLanguageDropdownLabel":"Язык субтитров","captionsSettingsSpokenLanguageDropdownInfoText":"Язык, на котором говорят все участники звонка.","captionsSettingsCaptionLanguageDropdownInfoText":"Субтитры будут отображаться на этом языке.","captionsSettingsConfirmButtonLabel":"Подтвердить","captionsSettingsCancelButtonLabel":"Отменить","captionsSettingsModalAriaLabel":"Модальное окно параметров субтитров","captionsSettingsCloseModalButtonAriaLabel":"Закрыть параметры субтитров","captionsBannerMoreButtonCallingLabel":"Дополнительные возможности субтитров","captionsBannerMoreButtonTooltip":"Дополнительные параметры","realTimeTextLabel":"Текст в реальном времени (RTT)","startRealTimeTextLabel":"Включить ввод в режиме реального времени для этого звонка","disabledStartRealTimeTextLabel":"Ввод в режиме реального времени в настоящее время включен, его нельзя отключить","dismissModalAriaLabel":"Локальное и удаленное изображение. Нажмите клавишу ВВОД, чтобы вернуться к звонку.","callRejectedTitle":"Не удалось совершить звонок","callRejectedMoreDetails":"Пользователь, с которым вы пытаетесь связаться, недоступен. Повторите попытку позже.","callTimeoutTitle":"Не удалось совершить звонок","callTimeoutDetails":"Пользователь, с которым вы пытаетесь связаться, недоступен. Повторите попытку позже.","callTimeoutBotTitle":"Не удалось совершить звонок","callTimeoutBotDetails":"Служба, к которому вы пытаетесь подключиться, недоступна. Повторите попытку позже.","dtmfDialerButtonLabel":"Панель набора номера","dtmfDialerButtonTooltipOn":"Показать панель набора номера","dtmfDialerButtonTooltipOff":"Скрыть панель набора номера","dtmfDialerMoreButtonLabelOn":"Показать панель набора номера","dtmfDialerMoreButtonLabelOff":"Скрыть панель набора номера","phoneCallMoreButtonLabel":"Звонок","spokenLanguageStrings":{"ar-ae":"Арабский (ОАЭ)","ar-sa":"Арабский (Саудовская Аравия)","da-dk":"Датский","de-de":"Немецкий (Германия)","en-au":"Английский (Австралия)","en-ca":"Английский (Канада)","en-gb":"Английский (Соединенное Королевство)","en-in":"Английский (Индия)","en-nz":"Английский (Новая Зеландия)","en-us":"Английский (США)","es-es":"Испанский (Испания), современная сортировка","es-mx":"Испанский (Мексика)","fi-fi":"Финский","fr-ca":"Французский (Канада)","fr-fr":"Французский (Франция)","hi-in":"Хинди","it-it":"Итальянский (Италия)","ja-jp":"Японский","ko-kr":"Корейский","nb-no":"Норвежский (букмол)","nl-be":"Нидерландский (Бельгия)","nl-nl":"Нидерландский — Нидерланды","pl-pl":"Польский","pt-br":"Португальский (Бразилия)","ru-ru":"Русский","sv-se":"Шведский","zh-cn":"Китайский (Китайская Народная Республика)","zh-hk":"Китайский (Гонконг, САР)","cs-cz":"Чешский","pt-pt":"Португальский (Португалия)","tr-tr":"Турецкий","vi-vn":"Вьетнамский","th-th":"Тайский","he-il":"Иврит","cy-gb":"Валлийский","uk-ua":"Украинский","el-gr":"Греческий","hu-hu":"Венгерский","ro-ro":"Румынский","sk-sk":"Словацкий","zh-tw":"Китайский (Тайвань)"},"captionLanguageStrings":{"ar":"Арабский","da":"Датский","de":"Немецкий","en":"Английский","es":"Испанский","fi":"Финский","fr-ca":"Французский (Канада)","fr":"Французский (Франция)","hi":"Хинди","it":"Итальянский","ja":"Японский","ko":"Корейский","nb":"Норвежский (букмол)","nl":"Нидерландский","pl":"Польский","pt":"Португальский (Бразилия)","ru":"Русский","sv":"Шведский","zh-Hans":"китайский, упрощенное письмо","zh-Hant":"Китайский (традиционное письмо)","cs":"Чешский","pt-pt":"Португальский (Португалия)","tr":"Турецкий","vi":"Вьетнамский","th":"Тайский","he":"Иврит","cy":"Валлийский","uk":"Украинский","el":"Греческий","hu":"Венгерский","ro":"Румынский","sk":"Словацкий"},"captionsBannerSpinnerText":"Запуск субтитров...","realTimeTextInputBoxDefaultText":"Введите сообщение в режиме реального времени","realTimeTextInputErrorMessage":"Длина сообщения не может превышать 2000 символов","realTimeTextBannerTitle":"Ввод в режиме реального времени","realTimeTextBannerContent":"Ввод в режиме реального времени включен для всех участников в течение всего собрания.","realTimeTextBannerLinkLabel":"Подробнее","realTimeTextModalAriaLabel":"Модальное окно включения ввода в режиме реального времени","realTimeTextModalTitle":"Включить ввод в режиме реального времени?","realTimeTextModalText":"Текст в режиме реального времени (RTT) будет включен для всех участников собрания.","realTimeTextConfirmButtonLabel":"Включить","realTimeTextCancelButtonLabel":"Отмена","realTimeTextCloseModalButtonAriaLabel":"Закрыть модальное окно ввода в режиме реального времени","captionsOnlyContainerTitle":"Субтитры","realTimeTextOnlyContainerTitle":"Текст в режиме реального времени","captionsAndRealTimeTextContainerTitle":"Субтитры и текст в режиме реального времени","expandButtonAriaLabel":"Развернуть","minimizeButtonAriaLabel":"Свернуть","transferPageTransferorText":"Идет переключение...","transferPageTransferTargetText":"Подключение...","transferPageUnknownTransferorDisplayName":"Неизвестно","transferPageUnknownTransferTargetDisplayName":"Неизвестно","transferPageNoticeString":"Для вас выполняется передача","participantCouldNotBeReachedTitle":"Целевой участник сейчас недоступен","participantCouldNotBeReachedMoreDetails":"Обратитесь к участнику, когда он будет доступен","permissionToReachTargetParticipantNotAllowedTitle":"Разрешение на связь с целевым участником отсутствует","permissionToReachTargetParticipantNotAllowedMoreDetails":"Проверьте, что целевой участник находится в том же клиенте","unableToResolveTenantTitle":"Не удалось разрешить идентификатор клиента для целевого участника","unableToResolveTenantMoreDetails":"Проверьте, что идентификатор участника введен правильно","participantIdIsMalformedTitle":"Неправильный формат идентификатора участника","participantIdIsMalformedMoreDetails":"Проверьте, что идентификатор участника указан в правильном формате","moreButtonGalleryControlLabel":"Просмотр","moreButtonGalleryPositionToggleLabel":"Переместить коллекцию вверх","moreButtonGallerySpeakerLayoutLabel":"Докладчик","moreButtonGalleryFloatingLocalLayoutLabel":"Динамический","moreButtonGalleryDefaultLayoutLabel":"Представление галереи","moreButtonGalleryFocusedContentLayoutLabel":"Фокусировка на содержимом","moreButtonLargeGalleryDefaultLayoutLabel":"Большая галерея","moreButtonTogetherModeLayoutLabel":"Режим \\"Вместе\\"","capabilityChangedNotification":{"turnVideoOn":{"lostDueToMeetingOption":"Камера отключена. Вы больше не можете делиться видео.","grantedDueToMeetingOption":"Камера включена. Включите этот параметр, если хотите поделиться видео."},"unmuteMic":{"lostDueToMeetingOption":"Ваш микрофон отключен. Вы больше не можете включить звук.","grantedDueToMeetingOption":"Ваш микрофон подключен. Включите звук, если хотите выступить."},"shareScreen":{"lostDueToRoleChangeToAttendee":"Ваша роль изменилась. Некоторые действия, например общий доступ к содержимому, будут вам недоступны.","grantedDueToRoleChangeToPresenter":"Вы ведущий. Вы можете предоставлять доступ к содержимому и помогать вести собрание."},"hideAttendeeNames":{"hideAttendeeNameAttendee":"Ваше имя скрыто от других участников. Организаторы и выступающие могут видеть ваше настоящее имя.","hideAttendeeNamePresenter":"Имена участников скрыты. Для защиты конфиденциальности участников имена видят только организаторы и выступающие."}},"surveyTitle":"Улучшение продукта","starSurveyHelperText":"Как вы оцениваете качество звонка?","starSurveyOneStarText":"Качество было очень плохое.","starSurveyTwoStarText":"Качество было плохое.","starSurveyThreeStarText":"Качество было хорошее.","starSurveyFourStarText":"Качество было отличное.","starSurveyFiveStarText":"Качество было превосходное.","surveyConfirmButtonLabel":"Отправить отзыв","starRatingAriaLabel":"Выберите {0} из {1} звезд","surveySkipButtonLabel":"Пропустить","tagsSurveyQuestion":"Что можно было улучшить?","tagsSurveyTextFieldDefaultText":"Другое, укажите","tagsSurveyHelperText":"Отметьте все проблемы, с которыми вы столкнулись","endOfSurveyText":"Спасибо за отзыв!","surveyIssues":{"overallRating":{"callCannotJoin":"Не удалось присоединиться к звонку","callCannotInvite":"Не удалось пригласить других участников в звонок","hadToRejoin":"Мне пришлось повторно присоединиться к звонку","callEndedUnexpectedly":"Звонок неожиданно завершился","otherIssues":"У меня возникли другие проблемы с вызовом"},"audioRating":{"noLocalAudio":"У моего собеседника не было звука","noRemoteAudio":"У меня не было звука.","echo":"Во время звонка было слышно эхо","audioNoise":"Во время звонка был слышен шум","lowVolume":"Слишком низкая громкость","audioStoppedUnexpectedly":"Звук неожиданно остановился","distortedSpeech":"Звук искажен","audioInterruption":"Звук был прерван","otherIssues":"У меня возникли другие проблемы со звуком во время этого звонка"},"videoRating":{"noVideoReceived":"У меня не отображалось видео","noVideoSent":"Другие пользователи не слышали меня","lowQuality":"Низкое качество видео","freezes":"Видео зависло","stoppedUnexpectedly":"Видео неожиданно остановилось","darkVideoReceived":"Я вижу темные экраны, когда другие включают камеру","audioVideoOutOfSync":"Звук и видео не синхронизированы","otherIssues":"У меня возникли другие проблемы с видео во время этого звонка"},"screenshareRating":{"noContentLocal":"Другие пользователи не могут видеть мою демонстрацию экрана","noContentRemote":"Не удалось увидеть демонстрацию экрана других людей","cannotPresent":"Не удалось показать экран","lowQuality":"Низкое качество демонстрации экрана","freezes":"Демонстрация экрана зависла","stoppedUnexpectedly":"Демонстрация экрана неожиданно остановилась","largeDelay":"Демонстрация экрана имеет большую задержку","otherIssues":"У меня возникли другие проблемы с демонстрацией экрана во время этого звонка"}},"surveyIssuesHeadingStrings":{"overallRating":"Общий","audioRating":"Звук","videoRating":"Видео","screenshareRating":"Выступление"},"spotlightPrompt":{"startSpotlightHeading":"Пометить как важное для всех?","startSpotlightText":"Вы выделите это видео для всех участников собрания.","startSpotlightOnSelfText":"Вы выделите свое видео для всех участников собрания.","startSpotlightConfirmButtonLabel":"Отметить видео как важное для всех","startSpotlightCancelButtonLabel":"Отмена","stopSpotlightHeading":"Больше не рекомендовать это видео?","stopSpotlightOnSelfHeading":"Выйти из работы с важным?","stopAllSpotlightHeading":"Отменить закрепление всех видео?","stopSpotlightText":"Ваше видео больше не будет помечено как важное для всех участников собрания.","stopSpotlightOnSelfText":"Ваше видео больше не будет выделено для всех участников собрания.","stopAllSpotlightText":"Видео больше не будут выделены для всех участников собрания.","stopSpotlightConfirmButtonLabel":"Больше не помечать важное","stopSpotlightOnSelfConfirmButtonLabel":"Выйти из важного","stopSpotlightCancelButtonLabel":"Отмена","closeSpotlightPromptButtonLabel":"Закрыть"},"exitSpotlightButtonLabel":"Выйти из важного","exitSpotlightButtonTooltip":"Выйти из важного","leaveConfirmButtonLabel":"Выйти","endCallConfirmButtonLabel":"Завершить звонок","hangUpCancelButtonLabel":"Отмена","leaveConfirmDialogTitle":"Покинуть звонок?","leaveConfirmDialogContent":"Вы действительно хотите покинуть звонок?","endCallConfirmDialogTitle":"Завершить звонок?","endCallConfirmDialogContent":"Вы завершите звонок для всех пользователей.","invalidMeetingIdentifier":"Недопустимый идентификатор собрания или секретный код","pinParticipantMenuLabel":"Закрепить для меня","pinParticipantLimitReachedMenuLabel":"Закрепить (достигнуто ограничение)","unpinParticipantMenuLabel":"Открепить","pinParticipantMenuItemAriaLabel":"Закрепить для меня","unpinParticipantMenuItemAriaLabel":"Открепить","muteAllMenuLabel":"Отключить все микрофоны","muteAllDialogTitle":"Отключить микрофоны всех участников?","muteAllDialogContent":"Будут отключены микрофоны всех участников собрания, кроме вас.","muteAllConfirmButtonLabel":"Отключить все микрофоны","muteAllCancelButtonLabel":"Отмена","joinBreakoutRoomButtonLabel":"Присоединиться к переговорной комнате","returnFromBreakoutRoomButtonLabel":"Покинуть комнату","leaveBreakoutRoomAndMeetingButtonLabel":"Покинуть собрание","breakoutRoomJoinedNotificationTitle":"Вы присоединились к переговорной комнате \\"{roomName}\\"","joinBreakoutRoomBannerTitle":"Переговорная комната \\"{roomName}\\" открыта","joinBreakoutRoomBannerButtonLabel":"Присоединиться","returnFromBreakoutRoomBannerTitle":"Вернуться в главное собрание","returnFromBreakoutRoomBannerButtonLabel":"Присоединиться снова","forbidAudioMenuLabel":"Отключить микрофон","permitAudioMenuLabel":"Разрешить использовать микрофон","forbidOthersAudioDialogTitle":"Отключить микрофон для участников?","forbidOthersAudioDialogContent":"Участники не смогут самостоятельно включать звук. Организатор и выступающие могут разрешить участникам включать звук при необходимости.","forbidOthersAudioConfirmButtonLabel":"Отключить микрофоны","forbidOthersAudioCancelButtonLabel":"Отмена","permitOthersAudioDialogTitle":"Разрешить участникам использовать микрофон?","permitOthersAudioDialogContent":"Все участники собрания смогут включить свой микрофон.","permitOthersAudioConfirmButtonLabel":"Разрешить использовать микрофоны","permitOthersAudioCancelButtonLabel":"Отмена","forbidOthersAudioMenuLabel":"Отключить микрофон для участников","permitOthersAudioMenuLabel":"Разрешить участникам использовать микрофон","forbidVideoMenuLabel":"Выключить камеру","permitVideoMenuLabel":"Разрешить использовать камеру","forbidOthersVideoDialogTitle":"Отключить камеру для участников?","forbidOthersVideoDialogContent":"Участники не смогут сами включать видео. Организатор и выступающие могут разрешить участникам включать камеру при необходимости.","forbidOthersVideoConfirmButtonLabel":"Отключить камеры","forbidOthersVideoCancelButtonLabel":"Отмена","permitOthersVideoDialogTitle":"Разрешить участникам использовать камеру?","permitOthersVideoDialogContent":"Все участники собрания смогут включить видео самостоятельно.","permitOthersVideoConfirmButtonLabel":"Разрешить использовать камеры","permitOthersVideoCancelButtonLabel":"Отмена","forbidOthersVideoMenuLabel":"Отключить камеру для участников","permitOthersVideoMenuLabel":"Разрешить участникам использовать камеру"}'),chat:{chatListHeader:"В этом чате",uploadAttachment:"Отправить вложение",uploadImageDataNotProvided:"Данные образа не предоставлены.",uploadImageIsTooLarge:"Изображение слишком велико. Выберите размер меньше {maxImageSize} МБ.",uploadImageExtensionIsNotAllowed:"Отправка образа .{imageExtension} не разрешена.",uploadImageFailed:"Не удалось отправить изображение. Повторите попытку позже."},callWithChat:{chatButtonLabel:"Чат",chatButtonNewMessageNotificationLabel:"Новое сообщение",chatButtonTooltipClosedWithMessageCount:"Показать чат (непрочитано: {unreadMessagesCount})",chatButtonTooltipClose:"Скрыть чат",chatButtonTooltipOpen:"Показать чат",chatPaneTitle:"Чат",copyInviteLinkButtonLabel:"Копировать ссылку с приглашением",copyInviteLinkButtonActionedLabel:"Ссылка скопирована",copyInviteLinkActionedAriaLabel:"Ссылка на приглашение в группу скопирована",dismissSidePaneButtonLabel:"Закрыть",moreDrawerAudioDeviceMenuTitle:"Звуковое устройство",moreDrawerButtonLabel:"Дополнительные параметры",moreDrawerButtonTooltip:"Дополнительные параметры",moreDrawerMicrophoneMenuTitle:"Микрофон",moreDrawerSpeakerMenuTitle:"Динамик",moreDrawerCaptionsMenuTitle:"Автоматические субтитры",moreDrawerSpokenLanguageMenuTitle:"Язык речи",moreDrawerCaptionLanguageMenuTitle:"Язык субтитров",moreDrawerGalleryOptionsMenuTitle:"Параметры коллекции",peopleButtonLabel:"Люди",selectedPeopleButtonLabel:'Нажата кнопка "Люди"',peopleButtonTooltipOpen:"Показать участников",peopleButtonTooltipClose:"Скрыть участников",peopleButtonTooltipOpenAriaLabel:'Кнопка "Люди", показать участников',peopleButtonTooltipCloseAriaLabel:'Кнопка "Люди", скрыть участников',peoplePaneSubTitle:"В этом звонке",peoplePaneTitle:"Люди",pictureInPictureTileAriaLabel:"Ленты видео. Щелкните, чтобы вернуться на экран вызова.",removeMenuLabel:"Удалить",openDialpadButtonLabel:"Набрать номер телефона",returnToCallButtonAriaDescription:"Вернуться к звонку",returnToCallButtonAriaLabel:"Назад",peoplePaneAddPeopleButtonLabel:"Добавить людей",dialpadStartCallButtonLabel:"Позвонить",dialpadModalTitle:"Набор номера телефона",dialpadModalAriaLabel:"Панель набора номера",dialpadCloseModalButtonAriaLabel:"Закрыть панель набора номера",openDtmfDialpadLabel:"Показать панель набора номера",dtmfDialpadPlaceholderText:"Введите номер",breakoutRoomChatPaneTitle:"Чат переговорной комнаты",chatContentSpinnerLabel:"Загрузка чата"}})},Rli={component:_Qt,strings:Yh({call:JSON.parse('{"cameraLabel":"Kamera","noCamerasLabel":"Ingen kamera hittades","cameraPermissionDenied":"Din webbläsare blockerar åtkomsten till kameran","cameraTurnedOff":"Din kamera är avstängd","chatButtonLabel":"Chatt","close":"Stäng","complianceBannerNowOnlyRecording":"Du spelar nu bara in det här mötet.","complianceBannerNowOnlyTranscription":"Nu transkriberar du bara det här mötet.","complianceBannerRecordingAndTranscriptionSaved":"Inspelning och transkription sparas.","complianceBannerRecordingAndTranscriptionStarted":"Inspelning och transkription har startats.","complianceBannerRecordingAndTranscriptionStopped":"Inspelning och transkription har avslutats.","complianceBannerRecordingSaving":"Inspelningen sparas.","complianceBannerRecordingStarted":"Inspelningen har startat.","complianceBannerRecordingStopped":"Inspelningen har stoppats.","complianceBannerTranscriptionStarted":"Transkriptionen har startat.","complianceBannerTranscriptionConsent":"Genom att ansluta ger du ditt medgivande för att det här mötet ska transkriberas.","complianceBannerTranscriptionSaving":"Transkriptionen sparas.","complianceBannerTranscriptionStopped":"Transkriptionen har avslutats.","configurationPageTitle":"Starta ett samtal","copyInviteLinkButtonLabel":"Kopiera inbjudningslänk","copyInviteLinkButtonActionedLabel":"Länken har kopierats","copyInviteLinkActionedAriaLabel":"Inbjudningslänken har kopierats","defaultPlaceHolder":"Välj ett alternativ","dismissSidePaneButtonLabel":"Stäng","videoEffectsPaneTitle":"Effekter","videoEffectsPaneBackgroundSelectionTitle":"Bakgrund","videoEffectsPaneAriaLabel":"Fönstret Videoeffekter","configurationPageCameraIsLoadingLabel":"Videon läses in...","configurationPageVideoEffectsButtonLabel":"Effekter","unableToStartVideoEffect":"Det går inte att tillämpa videoeffekten.","blurBackgroundEffectButtonLabel":"Oskärpa","blurBackgroundTooltip":"Gör bakgrunden oskarp","removeBackgroundEffectButtonLabel":"Ingen","removeBackgroundTooltip":"Ta bort bakgrund","cameraOffBackgroundEffectWarningText":"Kameran är avstängd. Aktivera kameran för att se videoeffekten.","failedToJoinCallDueToNoNetworkMoreDetails":"Samtalet kopplades från på grund av ett nätverksproblem. Kontrollera anslutningen och anslut igen.","failedToJoinCallDueToNoNetworkTitle":"Samtalet har kopplats från","failedToJoinTeamsMeetingReasonAccessDeniedMoreDetails":"Du har inte beviljats något bidrag i samtalet. Om det var ett misstag ansluter du till samtalet igen.","failedToJoinTeamsMeetingReasonAccessDeniedTitle":"Avvisad från lobbyn","learnMore":"Mer information","leavingCallTitle":"Lämnar…","leftCallMoreDetails":"Anslut till samtalet igen om det var ett misstag.","leftCallTitle":"Du lämnade samtalet","lobbyScreenConnectingToCallTitle":"Ansluter till samtalet","lobbyScreenWaitingToBeAdmittedTitle":"Väntar på att bli insläst","microphonePermissionDenied":"Din webbläsare blockerar åtkomsten till mikrofonen","microphoneToggleInLobbyNotAllowed":"Det går inte att stänga av ljudet eller slå på ljudet i lobbyn.","mutedMessage":"Din mikrofon har stängts av","networkReconnectMoreDetails":"Något verkar ha gått fel. Vi försöker komma in i samtalet igen.","networkReconnectTitle":"Vänta","notInvitedToRoomDetails":"Du kan inte ansluta till det här rummet eftersom du inte har någon inbjudan.","notInvitedToRoomTitle":"Inte inbjuden till rummet","peopleButtonLabel":"Personer","selectedPeopleButtonLabel":"Knappen Kontakter har valts","peoplePaneTitle":"Personer","peoplePaneMoreButtonAriaLabel":"Mer","peopleButtonTooltipOpen":"Visa deltagare","peopleButtonTooltipClose":"Dölj deltagare","peoplePaneSubTitle":"I det här samtalet {numberOfPeople}","privacyPolicy":"Sekretesspolicy","rejoinCallButtonLabel":"Anslut till samtal igen","removedFromCallMoreDetails":"En annan deltagare tog bort dig från samtalet.","removedFromCallTitle":"Du har tagits bort","removeMenuLabel":"Ta bort","startSpotlightMenuLabel":"Uppmärksamma för alla","addSpotlightMenuLabel":"Lägg till uppmärksammande","stopSpotlightMenuLabel":"Sluta uppmärksamma","stopSpotlightOnSelfMenuLabel":"Spotlight","spotlightLimitReachedMenuTitle":"Spotlight-gränsen har nåtts","stopAllSpotlightMenuLabel":"Avsluta alla uppmärksammanden","returnToCallButtonAriaDescription":"Återgå till samtal","returnToCallButtonAriaLabel":"Tillbaka","roomNotFoundDetails":"Det gick inte att hitta det angivna rums-ID:t.","roomNotFoundTitle":"Rummet hittades inte","roomNotValidDetails":"Det här rummet är inte giltigt just nu.","roomNotValidTitle":"Rummet är inte giltigt","inviteToRoomRemovedDetails":"Din inbjudan att ansluta till det här rummet har tagits bort.","inviteToRoomRemovedTitle":"Inbjudan till rummet har tagits bort","soundLabel":"Ljud","noMicrophonesLabel":"Inga mikrofoner hittades","noSpeakersLabel":"Inga högtalare hittades","startCallButtonLabel":"Starta samtal","openDialpadButtonLabel":"Ring telefonnummer","peoplePaneAddPeopleButtonLabel":"Lägg till personer","dialpadStartCallButtonLabel":"Ringa upp","dialpadModalTitle":"Ring telefonnummer","dialpadModalAriaLabel":"Knappsats","dialpadCloseModalButtonAriaLabel":"Stäng knappsats","moreButtonCallingLabel":"Mer","resumeCallButtonLabel":"Återuppta","resumingCallButtonLabel":"Återupptar","resumeCallButtonAriaLabel":"Återuppta samtal","resumingCallButtonAriaLabel":"Återuppta samtal","holdScreenLabel":"Du är parkerad","openDtmfDialpadLabel":"Visa knappsats","dtmfDialpadPlaceholderText":"Ange nummer","outboundCallingNoticeString":"Ringer...","participantJoinedNoticeString":"{displayName} har anslutits","twoParticipantJoinedNoticeString":"{displayName1} och {displayName2} har anslutit","threeParticipantJoinedNoticeString":"{displayName1}, {displayName2} och {displayName3} gick med","participantLeftNoticeString":"{displayName} kvar","twoParticipantLeftNoticeString":"{displayName1} och {displayName2} har lämnat","threeParticipantLeftNoticeString":"{displayName1}, {displayName2} och {displayName3} har lämnat","unnamedParticipantString":"namnlös deltagare","manyUnnamedParticipantsJoined":"namnlös deltagare och {numOfParticipants} andra deltagare gick med","manyUnnamedParticipantsLeft":"namnlös deltagare och {numOfParticipants} andra deltagare kvar","manyParticipantsJoined":"{displayName1}, {displayName2}, {displayName3} och {numOfParticipants} andra deltagare har anslutit","manyParticipantsLeft":"{displayName1}, {displayName2}, {displayName3} och {numOfParticipants} andra deltagare har lämnat","liveCaptionsLabel":"Liveundertexter","captionsSettingsLabel":"Inställningar för undertexter","startCaptionsButtonOnLabel":"Aktivera undertexter","startCaptionsButtonOffLabel":"Stäng av undertexter","startCaptionsButtonTooltipOnContent":"Stäng av undertexter","startCaptionsButtonTooltipOffContent":"Aktivera undertexter","captionsSettingsModalTitle":"Inställningar för undertexter","captionsSettingsSpokenLanguageDropdownLabel":"Talat språk","captionsSettingsCaptionLanguageDropdownLabel":"Språk för undertexter","captionsSettingsSpokenLanguageDropdownInfoText":"Språk som alla i det här samtalet talar.","captionsSettingsCaptionLanguageDropdownInfoText":"Undertexter visas på det här språket.","captionsSettingsConfirmButtonLabel":"Bekräfta","captionsSettingsCancelButtonLabel":"Avbryt","captionsSettingsModalAriaLabel":"Modalt fönster för inställning av undertexter","captionsSettingsCloseModalButtonAriaLabel":"Stäng inställningar för undertexter","captionsBannerMoreButtonCallingLabel":"Inställningar för undertexter – Fler alternativ","captionsBannerMoreButtonTooltip":"Fler alternativ","realTimeTextLabel":"Skrift i realtid","startRealTimeTextLabel":"Aktivera RTT för det här samtalet","disabledStartRealTimeTextLabel":"RTT är för närvarande aktiverat och kan inte stängas av","dismissModalAriaLabel":"Lokal bild och fjärrbild och bild, tryck på Retur för att återgå till samtalet","callRejectedTitle":"Det gick inte att slutföra samtalet","callRejectedMoreDetails":"Personen du försöker nå är inte tillgänglig. Försök igen senare.","callTimeoutTitle":"Det gick inte att slutföra samtalet","callTimeoutDetails":"Personen du försöker nå är inte tillgänglig. Försök igen senare.","callTimeoutBotTitle":"Det gick inte att slutföra samtalet","callTimeoutBotDetails":"Tjänsten som du försöker nå är inte tillgänglig. Försök igen senare.","dtmfDialerButtonLabel":"Knappsats","dtmfDialerButtonTooltipOn":"Visa knappsats","dtmfDialerButtonTooltipOff":"Dölj knappsatsen","dtmfDialerMoreButtonLabelOn":"Visa knappsats","dtmfDialerMoreButtonLabelOff":"Dölj knappsatsen","phoneCallMoreButtonLabel":"Telefonsamtal","spokenLanguageStrings":{"ar-ae":"Arabiska – Förenade Arabemiraten","ar-sa":"Arabiska – Saudiarabien","da-dk":"Danska","de-de":"Tyska – Tyskland","en-au":"Engelska – Australien","en-ca":"Engelska – Kanada","en-gb":"Engelska – Storbritannien","en-in":"Engelska – Indien","en-nz":"Engelska – Nya Zeeland","en-us":"Engelska – USA","es-es":"Spanska – Spanien (modern sortering)","es-mx":"Spanska – Mexiko","fi-fi":"Finska","fr-ca":"Franska – Kanada","fr-fr":"Franska – Frankrike","hi-in":"Hindi","it-it":"Italienska – Italien","ja-jp":"Japanska","ko-kr":"Koreanska","nb-no":"Norska (bokmål)","nl-be":"Nederländska – Belgien","nl-nl":"Nederländska -–Nederländerna","pl-pl":"Polska","pt-br":"Portugisiska – Brasilien","ru-ru":"Ryska","sv-se":"Svenska","zh-cn":"Kinesiska (Kina),","zh-hk":"Kinesiska – Hongkong SAR","cs-cz":"Tjeckiska","pt-pt":"Portugisiska – Portugal","tr-tr":"Turkiska","vi-vn":"Vietnamesiska","th-th":"Thailändska","he-il":"Hebreiska","cy-gb":"Walesiska","uk-ua":"Ukrainska","el-gr":"Grekiska","hu-hu":"Ungerska","ro-ro":"Rumänska","sk-sk":"Slovakiska","zh-tw":"Kinesiska – Taiwan"},"captionLanguageStrings":{"ar":"Arabiska","da":"Danska","de":"Tyska","en":"Engelska","es":"Spanska","fi":"Finska","fr-ca":"Franska – Kanada","fr":"Franska – Frankrike","hi":"Hindi","it":"Italienska","ja":"Japanska","ko":"Koreanska","nb":"Norska (bokmål)","nl":"Nederländska","pl":"Polska","pt":"Portugisiska – Brasilien","ru":"Ryska","sv":"Svenska","zh-Hans":"Kinesiska (förenklad)","zh-Hant":"Kinesiska (traditionell)","cs":"Tjeckiska","pt-pt":"Portugisiska – Portugal","tr":"Turkiska","vi":"Vietnamesiska","th":"Thailändska","he":"Hebreiska","cy":"Walesiska","uk":"Ukrainska","el":"Grekiska","hu":"Ungerska","ro":"Rumänska","sk":"Slovakiska"},"captionsBannerSpinnerText":"Startar undertexter ...","realTimeTextInputBoxDefaultText":"Skriv meddelande i realtid","realTimeTextInputErrorMessage":"Meddelandet får inte överstiga 2 000 tecken","realTimeTextBannerTitle":"RTT","realTimeTextBannerContent":"RTT (realtidstext) är aktiverat för alla deltagare under hela mötets varaktighet.","realTimeTextBannerLinkLabel":"Mer information","realTimeTextModalAriaLabel":"Aktivera RTT-modal","realTimeTextModalTitle":"Aktivera RTT?","realTimeTextModalText":"Realtidstext (RTT) aktiveras för alla i mötet.","realTimeTextConfirmButtonLabel":"Aktivera","realTimeTextCancelButtonLabel":"Avbryt","realTimeTextCloseModalButtonAriaLabel":"Stäng RTT-modal","captionsOnlyContainerTitle":"Bildtexter","realTimeTextOnlyContainerTitle":"Skrift i realtid","captionsAndRealTimeTextContainerTitle":"Undertexter och text i realtid","expandButtonAriaLabel":"Visa","minimizeButtonAriaLabel":"Dölj","transferPageTransferorText":"Överför...","transferPageTransferTargetText":"Ansluter...","transferPageUnknownTransferorDisplayName":"Okänd","transferPageUnknownTransferTargetDisplayName":"Okänd","transferPageNoticeString":"Ditt samtal överförs","participantCouldNotBeReachedTitle":"Måldeltagaren är för närvarande inte tillgänglig","participantCouldNotBeReachedMoreDetails":"Kontakta deltagaren när de är tillgängliga","permissionToReachTargetParticipantNotAllowedTitle":"Behörighet att nå måldeltagaren är inte tillåten","permissionToReachTargetParticipantNotAllowedMoreDetails":"Kontrollera att måldeltagaren finns i samma klientorganisation","unableToResolveTenantTitle":"Det gick inte att matcha klientorganisations-ID för måldeltagaren","unableToResolveTenantMoreDetails":"Kontrollera att deltagar-ID:t har angetts korrekt","participantIdIsMalformedTitle":"Deltagar-ID:t har inte rätt format","participantIdIsMalformedMoreDetails":"Kontrollera att deltagar-ID:t har rätt format","moreButtonGalleryControlLabel":"Visa","moreButtonGalleryPositionToggleLabel":"Flytta galleriet högst upp","moreButtonGallerySpeakerLayoutLabel":"Högtalare","moreButtonGalleryFloatingLocalLayoutLabel":"Dynamisk","moreButtonGalleryDefaultLayoutLabel":"Gallerivy","moreButtonGalleryFocusedContentLayoutLabel":"Fokusera på innehållet","moreButtonLargeGalleryDefaultLayoutLabel":"Stort galleri","moreButtonTogetherModeLayoutLabel":"Tillsammans-läge","capabilityChangedNotification":{"turnVideoOn":{"lostDueToMeetingOption":"Kameran har inaktiverats. Du kan inte längre dela video.","grantedDueToMeetingOption":"Kameran har aktiverats. Aktivera det om du vill dela video."},"unmuteMic":{"lostDueToMeetingOption":"Mikrofonen har inaktiverats. Du kan inte längre slå på ljudet.","grantedDueToMeetingOption":"Din mikrofon har aktiverats. Slå på ljudet om du vill prata."},"shareScreen":{"lostDueToRoleChangeToAttendee":"Din roll har ändrats. Vissa åtgärder, som att dela innehåll, är inte tillgängliga för dig.","grantedDueToRoleChangeToPresenter":"Du är presentatör. Du kan dela innehåll och underlätta mötet."},"hideAttendeeNames":{"hideAttendeeNameAttendee":"Ditt namn är dolt för andra deltagare. Organisatörer och presentatörer kan se ditt riktiga namn.","hideAttendeeNamePresenter":"Deltagarnas namn är dolda. Endast organisatörer och presentatörer kan se namn för att skydda deltagarnas integritet."}},"surveyTitle":"Hjälp oss att förbättra","starSurveyHelperText":"Hur var kvaliteten på samtalet?","starSurveyOneStarText":"Kvaliteten var dålig.","starSurveyTwoStarText":"Kvaliteten var inte bra.","starSurveyThreeStarText":"Kvaliteten var bra.","starSurveyFourStarText":"Kvaliteten var utmärkt.","starSurveyFiveStarText":"Kvaliteten var mycket bra.","surveyConfirmButtonLabel":"Skicka feedback","starRatingAriaLabel":"Markera {0} av {1} stjärnor","surveySkipButtonLabel":"Hoppa över","tagsSurveyQuestion":"Vad kan förbättras?","tagsSurveyTextFieldDefaultText":"Annat, specificera","tagsSurveyHelperText":"Kontrollera eventuella problem som du har upplevt","endOfSurveyText":"Tack för din feedback!","surveyIssues":{"overallRating":{"callCannotJoin":"Jag kunde inte ansluta till samtalet","callCannotInvite":"Jag kunde inte bjuda in andra till samtalet","hadToRejoin":"Jag var tvungen att återansluta till samtalet","callEndedUnexpectedly":"Samtalet avslutades oväntat åt mig","otherIssues":"Jag hade andra problem med samtalet"},"audioRating":{"noLocalAudio":"Den jag talade med kunde inte höra något alls","noRemoteAudio":"Jag kunde inte höra något alls","echo":"Jag hörde eko i samtalet","audioNoise":"Jag hörde störande ljud i samtalet","lowVolume":"Volymen var för låg","audioStoppedUnexpectedly":"Ljudet avbröts plötsligt","distortedSpeech":"Ljudet förvrängdes","audioInterruption":"Ljudet avbröts","otherIssues":"Jag hade andra ljudproblem i det här samtalet"},"videoRating":{"noVideoReceived":"Jag kunde inte se någon video","noVideoSent":"De andra deltagarna kunde inte se mig","lowQuality":"Videokvaliteten var låg","freezes":"Videon är frusen","stoppedUnexpectedly":"Videon avbröts plötsligt","darkVideoReceived":"Jag kan bara se mörka skärmar när andra aktiverar kameran","audioVideoOutOfSync":"Ljud och video var inte synkroniserade","otherIssues":"Jag hade andra videoproblem i det här samtalet"},"screenshareRating":{"noContentLocal":"Andra personer kunde inte se min skärmdelning","noContentRemote":"Jag kunde inte se andra personers skärmdelning","cannotPresent":"Jag kunde inte presentera min skärm","lowQuality":"Skärmdelningskvaliteten var låg","freezes":"Skärmdelningen är frusen","stoppedUnexpectedly":"Skärmdelningen stoppades oväntat","largeDelay":"Skärmdelningen har en stor fördröjning","otherIssues":"Jag hade andra skärmdelningsproblem i det här samtalet"}},"surveyIssuesHeadingStrings":{"overallRating":"Övergripande","audioRating":"Ljud","videoRating":"Video","screenshareRating":"Presenterar"},"spotlightPrompt":{"startSpotlightHeading":"Uppmärksamma för alla?","startSpotlightText":"Du kommer markera den här videon för alla i mötet.","startSpotlightOnSelfText":"Du kommer att markera din video för alla i mötet.","startSpotlightConfirmButtonLabel":"Uppmärksamma för alla","startSpotlightCancelButtonLabel":"Avbryt","stopSpotlightHeading":"Sluta att uppmärksamma den här videon?","stopSpotlightOnSelfHeading":"Avsluta uppmärksammande?","stopAllSpotlightHeading":"Vill du sluta uppmärksamma alla videor?","stopSpotlightText":"Den här videon markeras inte längre för alla i mötet.","stopSpotlightOnSelfText":"Din video kommer inte längre vara markerad för alla i mötet.","stopAllSpotlightText":"Videorna kommer inte längre att markeras för alla i mötet.","stopSpotlightConfirmButtonLabel":"Sluta uppmärksamma","stopSpotlightOnSelfConfirmButtonLabel":"Spotlight","stopSpotlightCancelButtonLabel":"Avbryt","closeSpotlightPromptButtonLabel":"Stäng"},"exitSpotlightButtonLabel":"Spotlight","exitSpotlightButtonTooltip":"Spotlight","leaveConfirmButtonLabel":"Lämna","endCallConfirmButtonLabel":"Avsluta samtal","hangUpCancelButtonLabel":"Avbryt","leaveConfirmDialogTitle":"Vill du lämna samtalet?","leaveConfirmDialogContent":"Vill du lämna samtalet?","endCallConfirmDialogTitle":"Vill du avsluta samtalet?","endCallConfirmDialogContent":"Du avslutar samtalet för alla.","invalidMeetingIdentifier":"Ogiltigt mötes-ID eller lösenord","pinParticipantMenuLabel":"Fäst åt mig","pinParticipantLimitReachedMenuLabel":"Fäst (gränsen har nåtts)","unpinParticipantMenuLabel":"Ta bort","pinParticipantMenuItemAriaLabel":"Fäst åt mig","unpinParticipantMenuItemAriaLabel":"Ta bort","muteAllMenuLabel":"Stäng av ljudet för alla","muteAllDialogTitle":"Stäng av ljudet för alla?","muteAllDialogContent":"Detta stänger av ljudet för alla i mötet utom för dig.","muteAllConfirmButtonLabel":"Stäng av ljudet för alla","muteAllCancelButtonLabel":"Avbryt","joinBreakoutRoomButtonLabel":"Anslut till separat rum","returnFromBreakoutRoomButtonLabel":"Lämna rum","leaveBreakoutRoomAndMeetingButtonLabel":"Lämna möte","breakoutRoomJoinedNotificationTitle":"Du har gått med i grupprummet {roomName}","joinBreakoutRoomBannerTitle":"Grupprummet {roomName} är öppet","joinBreakoutRoomBannerButtonLabel":"Gå med","returnFromBreakoutRoomBannerTitle":"Återgå till huvudmötet","returnFromBreakoutRoomBannerButtonLabel":"Anslut igen","forbidAudioMenuLabel":"Inaktivera mikrofon","permitAudioMenuLabel":"Tillåt mikrofon","forbidOthersAudioDialogTitle":"Vill du inaktivera mikrofonen för deltagare?","forbidOthersAudioDialogContent":"Deltagarna kan inte slå på ljudet själva. Organisatören och presentatören kan tillåta att deltagare slår på ljudet vid behov.","forbidOthersAudioConfirmButtonLabel":"Inaktivera mikrofoner","forbidOthersAudioCancelButtonLabel":"Avbryt","permitOthersAudioDialogTitle":"Vill du tillåta mikrofon för deltagare?","permitOthersAudioDialogContent":"Alla på mötet kommer att kunna sätta på ljudet.","permitOthersAudioConfirmButtonLabel":"Tillåt mikrofoner","permitOthersAudioCancelButtonLabel":"Avbryt","forbidOthersAudioMenuLabel":"Inaktivera mikrofon för deltagare","permitOthersAudioMenuLabel":"Tillåt mikrofon för deltagare","forbidVideoMenuLabel":"Inaktivera kameran","permitVideoMenuLabel":"Tillåt kamera","forbidOthersVideoDialogTitle":"Vill du inaktivera kameran för deltagare?","forbidOthersVideoDialogContent":"Deltagarna kommer inte att kunna aktivera video själva. Organisatören och presentatörerna kan låta användarna aktivera kameran efter behov.","forbidOthersVideoConfirmButtonLabel":"Inaktivera kameror","forbidOthersVideoCancelButtonLabel":"Avbryt","permitOthersVideoDialogTitle":"Vill du tillåta kamera för deltagare?","permitOthersVideoDialogContent":"Alla i mötet kommer att kunna aktivera video själva.","permitOthersVideoConfirmButtonLabel":"Tillåt kameror","permitOthersVideoCancelButtonLabel":"Avbryt","forbidOthersVideoMenuLabel":"Inaktivera kameran för deltagare","permitOthersVideoMenuLabel":"Tillåt kamera för deltagare"}'),chat:{chatListHeader:"I den här chatten",uploadAttachment:"Ladda upp bifogad fil",uploadImageDataNotProvided:"Bilddata har inte angetts.",uploadImageIsTooLarge:"Bilden är för stor. Välj en som är mindre än {maxImageSize} MB.",uploadImageExtensionIsNotAllowed:"Uppladdning av .{imageExtension}-bilder tillåts inte.",uploadImageFailed:"Det gick inte att ladda upp bilden. Försök igen senare."},callWithChat:{chatButtonLabel:"Chatt",chatButtonNewMessageNotificationLabel:"Nytt meddelande",chatButtonTooltipClosedWithMessageCount:"Visa chatt ({unreadMessagesCount} oläst)",chatButtonTooltipClose:"Dölj chatt",chatButtonTooltipOpen:"Visa chatt",chatPaneTitle:"Chatt",copyInviteLinkButtonLabel:"Kopiera inbjudningslänk",copyInviteLinkButtonActionedLabel:"Länken har kopierats",copyInviteLinkActionedAriaLabel:"Inbjudningslänken har kopierats",dismissSidePaneButtonLabel:"Stäng",moreDrawerAudioDeviceMenuTitle:"Ljudenhet",moreDrawerButtonLabel:"Fler alternativ",moreDrawerButtonTooltip:"Fler alternativ",moreDrawerMicrophoneMenuTitle:"Mikrofon",moreDrawerSpeakerMenuTitle:"Högtalare",moreDrawerCaptionsMenuTitle:"Liveundertexter",moreDrawerSpokenLanguageMenuTitle:"Talat språk",moreDrawerCaptionLanguageMenuTitle:"Språk för undertext",moreDrawerGalleryOptionsMenuTitle:"Gallerialternativ",peopleButtonLabel:"Personer",selectedPeopleButtonLabel:"Knappen Kontakter har valts",peopleButtonTooltipOpen:"Visa deltagare",peopleButtonTooltipClose:"Dölj deltagare",peopleButtonTooltipOpenAriaLabel:"Knappen Personer, visa deltagare",peopleButtonTooltipCloseAriaLabel:"Knappen Personer, dölj deltagare",peoplePaneSubTitle:"I det här samtalet",peoplePaneTitle:"Personer",pictureInPictureTileAriaLabel:"Videofeeds. Klicka för att återgå till samtalsskärmen.",removeMenuLabel:"Ta bort",openDialpadButtonLabel:"Ring telefonnummer",returnToCallButtonAriaDescription:"Återgå till samtal",returnToCallButtonAriaLabel:"Tillbaka",peoplePaneAddPeopleButtonLabel:"Lägg till personer",dialpadStartCallButtonLabel:"Ringa upp",dialpadModalTitle:"Ring telefonnummer",dialpadModalAriaLabel:"Knappsats",dialpadCloseModalButtonAriaLabel:"Stäng knappsats",openDtmfDialpadLabel:"Visa knappsats",dtmfDialpadPlaceholderText:"Ange nummer",breakoutRoomChatPaneTitle:"Grupprumschatt",chatContentSpinnerLabel:"Läser in chatt"}})},Mli={component:EQt,strings:Yh({call:JSON.parse(`{"cameraLabel":"Kamera","noCamerasLabel":"Kamera bulunamadı","cameraPermissionDenied":"Tarayıcınız kameranıza erişimi engelliyor","cameraTurnedOff":"Kameranız kapatıldı","chatButtonLabel":"Sohbet","close":"Kapat","complianceBannerNowOnlyRecording":"Şu anda yalnızca bu toplantıyı kaydediyorsunuz.","complianceBannerNowOnlyTranscription":"Şu anda yalnızca bu toplantının dökümünü oluşturuyorsunuz.","complianceBannerRecordingAndTranscriptionSaved":"Kayıt ve döküm kaydediliyor.","complianceBannerRecordingAndTranscriptionStarted":"Kayıt ve döküm başlatıldı.","complianceBannerRecordingAndTranscriptionStopped":"Kayıt ve döküm durduruldu.","complianceBannerRecordingSaving":"Kayıt kaydediliyor.","complianceBannerRecordingStarted":"Kayıt başladı.","complianceBannerRecordingStopped":"Kayıt durduruldu.","complianceBannerTranscriptionStarted":"Döküm başlatıldı.","complianceBannerTranscriptionConsent":"Katılarak bu toplantının dökümünün çıkarılmasına onay verirsiniz.","complianceBannerTranscriptionSaving":"Döküm kaydediliyor.","complianceBannerTranscriptionStopped":"Döküm durduruldu.","configurationPageTitle":"Arama başlatın","copyInviteLinkButtonLabel":"Davet bağlantısını kopyala","copyInviteLinkButtonActionedLabel":"Bağlantı kopyalandı","copyInviteLinkActionedAriaLabel":"Davet bağlantısı kopyalandı","defaultPlaceHolder":"Bir seçenek belirleyin","dismissSidePaneButtonLabel":"Kapat","videoEffectsPaneTitle":"Efektler","videoEffectsPaneBackgroundSelectionTitle":"Arka plan","videoEffectsPaneAriaLabel":"Video efektleri paneli","configurationPageCameraIsLoadingLabel":"Video yükleniyor...","configurationPageVideoEffectsButtonLabel":"Efektler","unableToStartVideoEffect":"Video efekti uygulanamıyor.","blurBackgroundEffectButtonLabel":"Bulanıklaştır","blurBackgroundTooltip":"Arka Planı Bulanıklaştır","removeBackgroundEffectButtonLabel":"Seçilmedi","removeBackgroundTooltip":"Arka Planı Kaldır","cameraOffBackgroundEffectWarningText":"Kameranız kapalı. Video efektini görmek için kamerayı açın.","failedToJoinCallDueToNoNetworkMoreDetails":"Bir ağ sorunu nedeniyle arama bağlantısı kesildi. Bağlantınızı kontrol edin ve yeniden katılın.","failedToJoinCallDueToNoNetworkTitle":"Arama kesildi","failedToJoinTeamsMeetingReasonAccessDeniedMoreDetails":"Aramaya katılmanıza izin verilmedi. Bu işlem yanlışlıkla yapıldıysa aramaya yeniden katılın.","failedToJoinTeamsMeetingReasonAccessDeniedTitle":"Lobiden çıkarıldı","learnMore":"Daha fazla bilgi edinin","leavingCallTitle":"Ayrılıyor...","leftCallMoreDetails":"Bu bir hataysa aramaya yeniden katılın.","leftCallTitle":"Aramadan ayrıldınız","lobbyScreenConnectingToCallTitle":"Aramaya katılıyorsunuz","lobbyScreenWaitingToBeAdmittedTitle":"Kabul edilmeyi bekliyor","microphonePermissionDenied":"Tarayıcınız mikrofonunuza erişimi engelliyor","microphoneToggleInLobbyNotAllowed":"Lobideyken sesi kapatılamaz veya açılamaz.","mutedMessage":"Sesiniz kapatıldı","networkReconnectMoreDetails":"Bir sorun oluştu gibi görünüyor. Çağrıya geri alınmaya çalışılıyor.","networkReconnectTitle":"Bekleyin","notInvitedToRoomDetails":"Davetiniz olmadığı için bu odaya katılamazsınız.","notInvitedToRoomTitle":"Odaya davet edilmedi","peopleButtonLabel":"Kişiler","selectedPeopleButtonLabel":"Kişiler Düğmesi Seçildi","peoplePaneTitle":"Kişiler","peoplePaneMoreButtonAriaLabel":"Daha fazla","peopleButtonTooltipOpen":"Katılımcıları göster","peopleButtonTooltipClose":"Katılımcıları gizle","peoplePaneSubTitle":"Bu aramada {numberOfPeople} var","privacyPolicy":"Gizlilik ilkesi","rejoinCallButtonLabel":"Çağrıya yeniden katıl","removedFromCallMoreDetails":"Başka bir katılımcı sizi aramadan çıkardı.","removedFromCallTitle":"Çıkarıldınız","removeMenuLabel":"Kaldır","startSpotlightMenuLabel":"Herkes için öne çıkar","addSpotlightMenuLabel":"Öne çıkarma ekle","stopSpotlightMenuLabel":"Öne çıkarmayı durdur","stopSpotlightOnSelfMenuLabel":"Öne çıkarmadan çık","spotlightLimitReachedMenuTitle":"Öne çıkarma sınırına ulaşıldı","stopAllSpotlightMenuLabel":"Tüm öne çıkarmaları durdur","returnToCallButtonAriaDescription":"Aramaya Dön","returnToCallButtonAriaLabel":"Geri","roomNotFoundDetails":"Sağlanan oda kimliği bulunamadı.","roomNotFoundTitle":"Oda bulunamadı","roomNotValidDetails":"Bu oda şu anda geçerli değil.","roomNotValidTitle":"Oda geçerli değil","inviteToRoomRemovedDetails":"Bu odaya katılma davetiniz kaldırıldı.","inviteToRoomRemovedTitle":"Odaya davet kaldırıldı","soundLabel":"Ses","noMicrophonesLabel":"Mikrofon bulunamadı","noSpeakersLabel":"Hoparlör bulunamadı","startCallButtonLabel":"Arama başlat","openDialpadButtonLabel":"Telefon numarasını çevir","peoplePaneAddPeopleButtonLabel":"Kişi Ekle","dialpadStartCallButtonLabel":"Ara","dialpadModalTitle":"Telefon Numarasını Çevir","dialpadModalAriaLabel":"Tuş takımı","dialpadCloseModalButtonAriaLabel":"Tuş takımını kapat","moreButtonCallingLabel":"Diğer","resumeCallButtonLabel":"Devam edin","resumingCallButtonLabel":"Devam ediyor...","resumeCallButtonAriaLabel":"Görüşmeye devam edin","resumingCallButtonAriaLabel":"Görüşmeye devam edin","holdScreenLabel":"Beklemeye alındınız","openDtmfDialpadLabel":"Tuş takımını göster","dtmfDialpadPlaceholderText":"Numara girin","outboundCallingNoticeString":"Aranıyor...","participantJoinedNoticeString":"{displayName} katıldı","twoParticipantJoinedNoticeString":"{displayName1} ve {displayName2} katıldı","threeParticipantJoinedNoticeString":"{displayName1}, {displayName2} ve {displayName3} katıldı","participantLeftNoticeString":"{displayName} ayrıldı","twoParticipantLeftNoticeString":"{displayName1} ve {displayName2} ayrıldı","threeParticipantLeftNoticeString":"{displayName1}, {displayName2} ve {displayName3} ayrıldı","unnamedParticipantString":"adsız katılımcı","manyUnnamedParticipantsJoined":"adsız katılımcı ve {numOfParticipants} katılımcı katıldı","manyUnnamedParticipantsLeft":"adsız katılımcı ve {numOfParticipants} katılımcı ayrıldı","manyParticipantsJoined":"{displayName1}, {displayName2}, {displayName3} ve {numOfParticipants} katılımcı katıldı","manyParticipantsLeft":"{displayName1}, {displayName2}, {displayName3} ve {numOfParticipants} katılımcı kaldı","liveCaptionsLabel":"Açıklamalı canlı alt yazılar","captionsSettingsLabel":"Açıklamalı alt yazı ayarları","startCaptionsButtonOnLabel":"Açıklamalı alt yazıları açma","startCaptionsButtonOffLabel":"Açıklamalı alt yazıları kapat","startCaptionsButtonTooltipOnContent":"Açıklamalı alt yazıları kapat","startCaptionsButtonTooltipOffContent":"Açıklamalı alt yazıları açma","captionsSettingsModalTitle":"Açıklamalı Alt Yazı Ayarları","captionsSettingsSpokenLanguageDropdownLabel":"Konuşulan dil","captionsSettingsCaptionLanguageDropdownLabel":"Açıklamalı alt yazı dili","captionsSettingsSpokenLanguageDropdownInfoText":"Bu çağrıdaki herkesin konuşma dili.","captionsSettingsCaptionLanguageDropdownInfoText":"Açıklamalı alt yazılar bu dilde görünür.","captionsSettingsConfirmButtonLabel":"Onayla","captionsSettingsCancelButtonLabel":"İptal","captionsSettingsModalAriaLabel":"Açıklamalı Alt Yazı Ayarı Kalıcı","captionsSettingsCloseModalButtonAriaLabel":"Açıklamalı Alt Yazı Ayarını Kapat","captionsBannerMoreButtonCallingLabel":"Alt Yazı Ayarları Diğer Seçenekler","captionsBannerMoreButtonTooltip":"Diğer seçenekler","realTimeTextLabel":"Gerçek zamanlı metin (RTT)","startRealTimeTextLabel":"Bu arama için RTT'yi aç","disabledStartRealTimeTextLabel":"RTT şu anda açık, kapatılamaz","dismissModalAriaLabel":"Yerel ve uzak resim ve resim, aramaya geri dönmek için Enter tuşuna basın","callRejectedTitle":"Arama tamamlanamadı","callRejectedMoreDetails":"Ulaşmaya çalıştığınız kişi kullanılamıyor. Lütfen daha sonra yeniden deneyin.","callTimeoutTitle":"Arama tamamlanamadı","callTimeoutDetails":"Ulaşmaya çalıştığınız kişi kullanılamıyor. Lütfen daha sonra yeniden deneyin.","callTimeoutBotTitle":"Arama tamamlanamadı","callTimeoutBotDetails":"Erişmeye çalıştığınız hizmet kullanılamıyor. Lütfen daha sonra yeniden deneyin.","dtmfDialerButtonLabel":"Tuş takımı","dtmfDialerButtonTooltipOn":"Tuş takımını göster","dtmfDialerButtonTooltipOff":"Sayısal tuş takımını gizle","dtmfDialerMoreButtonLabelOn":"Tuş takımını göster","dtmfDialerMoreButtonLabelOff":"Sayısal tuş takımını gizle","phoneCallMoreButtonLabel":"Telefon Görüşmesi","spokenLanguageStrings":{"ar-ae":"Arapça - BAE","ar-sa":"Arapça - Suudi Arabistan","da-dk":"Danca","de-de":"Almanca - Almanya","en-au":"İngilizce - Avustralya","en-ca":"İngilizce - Kanada","en-gb":"İngilizce - Birleşik Krallık","en-in":"İngilizce - Hindistan","en-nz":"İngilizce - Yeni Zelanda","en-us":"İngilizce - ABD","es-es":"İspanyolca - İspanya (Modern)","es-mx":"İspanyolca - Meksika","fi-fi":"Fince","fr-ca":"Fransızca - Kanada","fr-fr":"Fransızca - Fransa","hi-in":"Hintçe","it-it":"İtalyanca - İtalya","ja-jp":"Japonca","ko-kr":"Korece","nb-no":"Norveççe (Bokmål)","nl-be":"Hollanda dili - Belçika","nl-nl":"Felemenkçe - Hollanda","pl-pl":"Lehçe","pt-br":"Portekizce - Brezilya","ru-ru":"Rusça","sv-se":"İsveççe","zh-cn":"Çince - Çin Halk Cumhuriyeti","zh-hk":"Çince - Hong Kong ÖİB","cs-cz":"Çekçe","pt-pt":"Portekizce - Portekiz","tr-tr":"Türkçe","vi-vn":"Vietnamca","th-th":"Tayca","he-il":"İbranice","cy-gb":"Galce","uk-ua":"Ukraynaca","el-gr":"Yunanca","hu-hu":"Macarca","ro-ro":"Rumence","sk-sk":"Slovakça","zh-tw":"Çince - Tayvan"},"captionLanguageStrings":{"ar":"Arapça","da":"Danca","de":"Almanca","en":"İngilizce","es":"İspanyolca","fi":"Fince","fr-ca":"Fransızca - Kanada","fr":"Fransızca - Fransa","hi":"Hintçe","it":"İtalyanca","ja":"Japonca","ko":"Korece","nb":"Norveççe (Bokmål)","nl":"Felemenkçe","pl":"Lehçe","pt":"Portekizce - Brezilya","ru":"Rusça","sv":"İsveççe","zh-Hans":"Çince (Basitleştirilmiş)","zh-Hant":"Çince (Geleneksel)","cs":"Çekçe","pt-pt":"Portekizce - Portekiz","tr":"Türkçe","vi":"Vietnamca","th":"Tayca","he":"İbranice","cy":"Galce","uk":"Ukraynaca","el":"Yunanca","hu":"Macarca","ro":"Rumence","sk":"Slovakça"},"captionsBannerSpinnerText":"Alt yazılar başlatılıyor...","realTimeTextInputBoxDefaultText":"İletiyi gerçek zamanlı yazın","realTimeTextInputErrorMessage":"İleti 2000 karakteri geçemez","realTimeTextBannerTitle":"RTT","realTimeTextBannerContent":"RTT (gerçek zamanlı metin) toplantı süresi boyunca tüm katılımcılar için etkindir.","realTimeTextBannerLinkLabel":"Daha fazla bilgi edinin","realTimeTextModalAriaLabel":"RTT Kalıcı İletişim Kutusunu Aç","realTimeTextModalTitle":"RTT açılsın mı?","realTimeTextModalText":"Gerçek zamanlı metin (RTT) toplantıdaki herkes için açılır.","realTimeTextConfirmButtonLabel":"Aç","realTimeTextCancelButtonLabel":"İptal","realTimeTextCloseModalButtonAriaLabel":"RTT Kalıcı İletişim Kutusunu Kapat","captionsOnlyContainerTitle":"Alt yazılar","realTimeTextOnlyContainerTitle":"Gerçek Zamanlı Metin","captionsAndRealTimeTextContainerTitle":"Altyazılar ve Gerçek Zamanlı Metin","expandButtonAriaLabel":"Genişlet","minimizeButtonAriaLabel":"Daralt","transferPageTransferorText":"Aktarılıyor...","transferPageTransferTargetText":"Bağlanıyor...","transferPageUnknownTransferorDisplayName":"Bilinmiyor","transferPageUnknownTransferTargetDisplayName":"Bilinmiyor","transferPageNoticeString":"Çağrı aktarılıyor","participantCouldNotBeReachedTitle":"Hedef katılımcı şu anda uygun değil","participantCouldNotBeReachedMoreDetails":"Uygun olduğunda katılımcıyla iletişim kurun","permissionToReachTargetParticipantNotAllowedTitle":"Hedef katılımcıya erişim iznine izin verilmiyor","permissionToReachTargetParticipantNotAllowedMoreDetails":"Lütfen hedef katılımcının aynı kiracıda olup olmadığını denetleyin","unableToResolveTenantTitle":"Hedef katılımcının kiracı kimliği çözülemiyor","unableToResolveTenantMoreDetails":"Lütfen katılımcı kimliğinin doğru giril olup olmadığını denetleyin","participantIdIsMalformedTitle":"Katılımcı kimliği doğru biçimde değil","participantIdIsMalformedMoreDetails":"Lütfen katılımcı kimliğinin doğru biçimde olduğundan emin olun","moreButtonGalleryControlLabel":"Görünüm","moreButtonGalleryPositionToggleLabel":"Galeriyi en üste taşı","moreButtonGallerySpeakerLayoutLabel":"Konuşmacı","moreButtonGalleryFloatingLocalLayoutLabel":"Dinamik","moreButtonGalleryDefaultLayoutLabel":"Galeri görünümü","moreButtonGalleryFocusedContentLayoutLabel":"İçeriğe odaklı","moreButtonLargeGalleryDefaultLayoutLabel":"Büyük Galeri","moreButtonTogetherModeLayoutLabel":"Birlikte modu","capabilityChangedNotification":{"turnVideoOn":{"lostDueToMeetingOption":"Kameranız devre dışı bırakıldı. Artık video paylaşasınız.","grantedDueToMeetingOption":"Kameranız etkinleştirildi. Video paylaşmak istiyorsanız açın."},"unmuteMic":{"lostDueToMeetingOption":"Mikrofonunuz devre dışı bırakıldı. Artık sesi açamaznız.","grantedDueToMeetingOption":"Mikrofonunuz etkinleştirildi. Konuşmak istiyorsanız sesi açın."},"shareScreen":{"lostDueToRoleChangeToAttendee":"Rolünüz değiştirildi. İçerik paylaşma gibi bazı eylemler kullanılamaz.","grantedDueToRoleChangeToPresenter":"Sunucuyuz. İçerik paylaşabilir ve toplantıya yardımcı olabilirsiniz."},"hideAttendeeNames":{"hideAttendeeNameAttendee":"Adınız diğer katılımcılardan gizlendi. Düzenleyiciler ve sunucular gerçek adınızı görebilir.","hideAttendeeNamePresenter":"Katılımcı adları gizlidir. Katılımcı gizliliğini korumak için yalnızca düzenleyiciler ve sunucular adları görebilir."}},"surveyTitle":"Geliştirmemize yardımcı olun","starSurveyHelperText":"Arama kalitesi nasıldı?","starSurveyOneStarText":"Kalite kötüydü.","starSurveyTwoStarText":"Kalite düşüktü.","starSurveyThreeStarText":"Kalite iyiydi.","starSurveyFourStarText":"Kalite harikaydı.","starSurveyFiveStarText":"Kalite mükemmeldi.","surveyConfirmButtonLabel":"Geri Bildirim Gönder","starRatingAriaLabel":"{1} üzerinden {0} yıldız seçin","surveySkipButtonLabel":"Atla","tagsSurveyQuestion":"Neleri iyileştirebiliriz?","tagsSurveyTextFieldDefaultText":"Diğer, lütfen belirtin","tagsSurveyHelperText":"Karşılaştığınız tüm sorunları işaretleyin","endOfSurveyText":"Geri bildiriminiz için teşekkür ederiz!","surveyIssues":{"overallRating":{"callCannotJoin":"Çağrıya katılamadım","callCannotInvite":"Başkalarını çağrıya davet edemedim","hadToRejoin":"Çağrıya yeniden katılmam gerekirdi","callEndedUnexpectedly":"Arama benim için beklenmedik bir şekilde sona erdi","otherIssues":"Aramayla ilgili başka sorunlar yaşıyorum"},"audioRating":{"noLocalAudio":"Karşı taraf ses duyamadı","noRemoteAudio":"Ses duyamadım","echo":"Aramada yankılar duydum","audioNoise":"Aramada parazit vardı","lowVolume":"Ses düzeyi düşüktü","audioStoppedUnexpectedly":"Ses beklenmedik şekilde durduruldu","distortedSpeech":"Ses bozuktu","audioInterruption":"Ses kesildi","otherIssues":"Bu aramada başka ses sorunlarıyla karşılaştım"},"videoRating":{"noVideoReceived":"Görüntü yoktu","noVideoSent":"Diğerleri beni göremedi","lowQuality":"Video kalitesi düşüktü","freezes":"Video dondu","stoppedUnexpectedly":"Görüntü beklenmedik şekilde durdu","darkVideoReceived":"Başkaları kameralarını etkinleştirildiğinde sadece siyah ekranlar görüyorum","audioVideoOutOfSync":"Ses ve Videoda senkron sorunu vardı","otherIssues":"Bu aramada başka video sorunlarıyla karşılaştım"},"screenshareRating":{"noContentLocal":"Diğer kişiler ekran paylaşımımı göremedi","noContentRemote":"Diğer kişilerin ekran paylaşımını göremedim","cannotPresent":"Ekranımı gösteremedim","lowQuality":"Ekran paylaşımı kalitesi düşüktü","freezes":"Ekran paylaşımı donduruldu","stoppedUnexpectedly":"Ekran paylaşımı beklenmedik şekilde durdu","largeDelay":"Ekran paylaşımında büyük bir gecikme var","otherIssues":"Bu aramada başka ekran paylaşımı sorunlarıyla karşılaştım"}},"surveyIssuesHeadingStrings":{"overallRating":"Genel","audioRating":"Ses","videoRating":"Video","screenshareRating":"Sunu"},"spotlightPrompt":{"startSpotlightHeading":"Herkes için öne çıkarılsın mı?","startSpotlightText":"Bu videoyu toplantıdaki herkes için öne çıkaracaksınız.","startSpotlightOnSelfText":"Videonuzu toplantıdaki herkes için öne çıkaracaksınız.","startSpotlightConfirmButtonLabel":"Herkes için öne çıkar","startSpotlightCancelButtonLabel":"İptal","stopSpotlightHeading":"Bu video için öne çıkarma durdurulsun mu?","stopSpotlightOnSelfHeading":"Öne çıkarmadan çıkılsın mı?","stopAllSpotlightHeading":"Tüm videolarda öne çıkarma durdurulsun mu?","stopSpotlightText":"Bu video artık toplantıdaki herkes için öne çıkarılmayacak.","stopSpotlightOnSelfText":"Videonuz toplantıdaki herkes için artık öne çıkarılmayacak.","stopAllSpotlightText":"Artık videolar toplantıdaki herkes için öne çıkarılmayacak.","stopSpotlightConfirmButtonLabel":"Öne çıkarmayı durdur","stopSpotlightOnSelfConfirmButtonLabel":"Öne çıkarmadan çık","stopSpotlightCancelButtonLabel":"İptal","closeSpotlightPromptButtonLabel":"Kapat"},"exitSpotlightButtonLabel":"Öne çıkarmadan çık","exitSpotlightButtonTooltip":"Öne çıkarmadan çık","leaveConfirmButtonLabel":"Ayrıl","endCallConfirmButtonLabel":"Aramayı sonlandır","hangUpCancelButtonLabel":"İptal","leaveConfirmDialogTitle":"Aramadan çıkılsın mı?","leaveConfirmDialogContent":"Aramadan ayrılmak istediğinizden emin misiniz?","endCallConfirmDialogTitle":"Arama sonlandırılsın mı?","endCallConfirmDialogContent":"Aramayı herkes için sonlandırıyorsunuz.","invalidMeetingIdentifier":"Geçersiz toplantı kimliği veya geçiş kodu","pinParticipantMenuLabel":"Benim için sabitle","pinParticipantLimitReachedMenuLabel":"Sabitleme (sınıra ulaşıldı)","unpinParticipantMenuLabel":"Sabitlemeyi kaldır","pinParticipantMenuItemAriaLabel":"Benim için sabitle","unpinParticipantMenuItemAriaLabel":"Sabitlemeyi kaldır","muteAllMenuLabel":"Tümünü sessize al","muteAllDialogTitle":"Herkesi sessize almak mı istiyorsunuz?","muteAllDialogContent":"Bu, toplantıda sizin dışınızdaki herkesi sessize alır.","muteAllConfirmButtonLabel":"Tümünü sessize al","muteAllCancelButtonLabel":"İptal","joinBreakoutRoomButtonLabel":"Tartışma odasına katıl","returnFromBreakoutRoomButtonLabel":"Odadan ayrıl","leaveBreakoutRoomAndMeetingButtonLabel":"Toplantıdan ayrıl","breakoutRoomJoinedNotificationTitle":"'{roomName}' Tartışma odasına katıldınız","joinBreakoutRoomBannerTitle":"'{roomName}' Tartışma odası açık","joinBreakoutRoomBannerButtonLabel":"Katıl","returnFromBreakoutRoomBannerTitle":"Ana toplantıya geri dön","returnFromBreakoutRoomBannerButtonLabel":"Yeniden Katıl","forbidAudioMenuLabel":"Mikrofonu devre dışı bırak","permitAudioMenuLabel":"Mikrofona izin ver","forbidOthersAudioDialogTitle":"Mikrofon katılımcılar için devre dışı bırakılsın mı?","forbidOthersAudioDialogContent":"Katılımcılar kendi seslerini açamaz. Düzenleyici ve sunucular, gerektiğinde kişilerin sesi açmasını sağlayabilir.","forbidOthersAudioConfirmButtonLabel":"Mikrofonları devre dışı bırak","forbidOthersAudioCancelButtonLabel":"İptal","permitOthersAudioDialogTitle":"Katılımcıların mikrofona erişimine izin verilsin mi?","permitOthersAudioDialogContent":"Toplantıdaki herkes kendi sesini kapatabilir.","permitOthersAudioConfirmButtonLabel":"Mikrofonlara izin ver","permitOthersAudioCancelButtonLabel":"İptal","forbidOthersAudioMenuLabel":"Mikrofonu katılımcılar için devre dışı bırak","permitOthersAudioMenuLabel":"Katılımcıların mikrofona erişimine izin ver","forbidVideoMenuLabel":"Kamerayı devre dışı bırak","permitVideoMenuLabel":"Kameraya izin ver","forbidOthersVideoDialogTitle":"Kamera katılımcılar için devre dışı bırakılsın mı?","forbidOthersVideoDialogContent":"Katılımcılar videoyu kendileri etkileştiremezler. Düzenleyici ve sunucular, gerektiğinde kişilerin kameralarını etkinleştirmelerine izin verebilir.","forbidOthersVideoConfirmButtonLabel":"Kameraları devre dışı bırak","forbidOthersVideoCancelButtonLabel":"İptal","permitOthersVideoDialogTitle":"Katılımcıların kameraya erişimine izin verilsin mi?","permitOthersVideoDialogContent":"Toplantıdaki herkes videoyu kendileri açabilir.","permitOthersVideoConfirmButtonLabel":"Kameralara izin ver","permitOthersVideoCancelButtonLabel":"İptal","forbidOthersVideoMenuLabel":"Kamerayı katılımcılar için devre dışı bırak","permitOthersVideoMenuLabel":"Katılımcıların kameraya erişimine izin ver"}`),chat:{chatListHeader:"Bu sohbette",uploadAttachment:"Eki Karşıya Yükle",uploadImageDataNotProvided:"Görüntü verileri sağlanmadı.",uploadImageIsTooLarge:"Resim çok büyük. Mb'den küçük bir {maxImageSize} seçin.",uploadImageExtensionIsNotAllowed:".{imageExtension} görüntüsünün karşıya yüklemesine izin verilmiyor.",uploadImageFailed:"Resim karşıya yüklenemiyor. Lütfen daha sonra yeniden deneyin."},callWithChat:{chatButtonLabel:"Sohbet",chatButtonNewMessageNotificationLabel:"Yeni İleti",chatButtonTooltipClosedWithMessageCount:"Sohbeti göster ({unreadMessagesCount} okunmamış)",chatButtonTooltipClose:"Sohbeti gizle",chatButtonTooltipOpen:"Sohbeti göster",chatPaneTitle:"Sohbet",copyInviteLinkButtonLabel:"Davet bağlantısını kopyala",copyInviteLinkButtonActionedLabel:"Bağlantı kopyalandı",copyInviteLinkActionedAriaLabel:"Davet bağlantısı kopyalandı",dismissSidePaneButtonLabel:"Kapat",moreDrawerAudioDeviceMenuTitle:"Ses Cihazı",moreDrawerButtonLabel:"Diğer seçenekler",moreDrawerButtonTooltip:"Diğer seçenekler",moreDrawerMicrophoneMenuTitle:"Mikrofon",moreDrawerSpeakerMenuTitle:"Hoparlör",moreDrawerCaptionsMenuTitle:"Açıklamalı canlı alt yazılar",moreDrawerSpokenLanguageMenuTitle:"Konuşulan dil",moreDrawerCaptionLanguageMenuTitle:"Açıklamalı alt yazı dili",moreDrawerGalleryOptionsMenuTitle:"Galeri seçenekleri",peopleButtonLabel:"Kişiler",selectedPeopleButtonLabel:"Kişiler Düğmesi Seçildi",peopleButtonTooltipOpen:"Katılımcıları göster",peopleButtonTooltipClose:"Katılımcıları gizle",peopleButtonTooltipOpenAriaLabel:"Kişiler düğmesi, Katılımcıları göster",peopleButtonTooltipCloseAriaLabel:"Kişiler düğmesi, Katılımcıları gizle",peoplePaneSubTitle:"Bu aramada",peoplePaneTitle:"Kişiler",pictureInPictureTileAriaLabel:"Video Akışları. Çağrı ekranına dönmek için tıklayın.",removeMenuLabel:"Kaldır",openDialpadButtonLabel:"Telefon numarasını çevir",returnToCallButtonAriaDescription:"Aramaya Dön",returnToCallButtonAriaLabel:"Geri",peoplePaneAddPeopleButtonLabel:"Kişi Ekle",dialpadStartCallButtonLabel:"Ara",dialpadModalTitle:"Telefon Numarasını Çevir",dialpadModalAriaLabel:"Tuş takımı",dialpadCloseModalButtonAriaLabel:"Tuş takımını kapat",openDtmfDialpadLabel:"Tuş takımını göster",dtmfDialpadPlaceholderText:"Numara girin",breakoutRoomChatPaneTitle:"Tartışma Odası Sohbeti",chatContentSpinnerLabel:"Sohbet yükleniyor"}})},Pli={component:AQt,strings:Yh({call:JSON.parse('{"cameraLabel":"照相机","noCamerasLabel":"未找到摄像头","cameraPermissionDenied":"你的浏览器正在阻止对相机的访问","cameraTurnedOff":"你的相机已关闭","chatButtonLabel":"聊天","close":"关闭","complianceBannerNowOnlyRecording":"现在仅录制此会议。","complianceBannerNowOnlyTranscription":"现在仅听录此会议。","complianceBannerRecordingAndTranscriptionSaved":"正在保存录制和听录。","complianceBannerRecordingAndTranscriptionStarted":"录制和听录已开始。","complianceBannerRecordingAndTranscriptionStopped":"录制和听录已停止。","complianceBannerRecordingSaving":"正在保存录制。","complianceBannerRecordingStarted":"录制已开始。","complianceBannerRecordingStopped":"录制已停止。","complianceBannerTranscriptionStarted":"听录已开始。","complianceBannerTranscriptionConsent":"加入即表示你同意转录此会议。","complianceBannerTranscriptionSaving":"正在保存听录。","complianceBannerTranscriptionStopped":"听录已停止。","configurationPageTitle":"开始通话","copyInviteLinkButtonLabel":"复制邀请链接","copyInviteLinkButtonActionedLabel":"已复制链接","copyInviteLinkActionedAriaLabel":"已复制邀请链接","defaultPlaceHolder":"选择一个选项","dismissSidePaneButtonLabel":"关闭","videoEffectsPaneTitle":"效果","videoEffectsPaneBackgroundSelectionTitle":"背景","videoEffectsPaneAriaLabel":"视频效果窗格","configurationPageCameraIsLoadingLabel":"正在加载视频...","configurationPageVideoEffectsButtonLabel":"效果","unableToStartVideoEffect":"无法应用视频效果。","blurBackgroundEffectButtonLabel":"模糊","blurBackgroundTooltip":"模糊背景","removeBackgroundEffectButtonLabel":"无","removeBackgroundTooltip":"删除背景","cameraOffBackgroundEffectWarningText":"你的相机已关闭。打开相机以查看视频效果。","failedToJoinCallDueToNoNetworkMoreDetails":"由于网络问题，呼叫已断开连接。请检查你的连接，然后重新加入。","failedToJoinCallDueToNoNetworkTitle":"通话已断开","failedToJoinTeamsMeetingReasonAccessDeniedMoreDetails":"未在通话中向你授予条目。如果这是一个错误，请重新加入呼叫。","failedToJoinTeamsMeetingReasonAccessDeniedTitle":"已从大厅中关闭","learnMore":"了解详细信息","leavingCallTitle":"正在退出...","leftCallMoreDetails":"如果这是一个错误，请重新加入呼叫。","leftCallTitle":"你已离开通话","lobbyScreenConnectingToCallTitle":"加入通话","lobbyScreenWaitingToBeAdmittedTitle":"正在等待被拒绝","microphonePermissionDenied":"你的浏览器正在阻止对麦克风的访问","microphoneToggleInLobbyNotAllowed":"在大厅中时无法静音或取消静音。","mutedMessage":"你已静音","networkReconnectMoreDetails":"似乎出现了问题。我们正在努力恢复通话。","networkReconnectTitle":"稍等","notInvitedToRoomDetails":"你无法加入此聊天室，因为你没有邀请。","notInvitedToRoomTitle":"未受邀加入会议室","peopleButtonLabel":"人员","selectedPeopleButtonLabel":"已选择“人员”按钮","peoplePaneTitle":"人员","peoplePaneMoreButtonAriaLabel":"更多","peopleButtonTooltipOpen":"显示参与者","peopleButtonTooltipClose":"隐藏参与者","peoplePaneSubTitle":"在此通话中 {numberOfPeople}","privacyPolicy":"隐私策略","rejoinCallButtonLabel":"重新加入呼叫","removedFromCallMoreDetails":"另一名参与者已将你从通话中删除。","removedFromCallTitle":"你已被删除","removeMenuLabel":"删除","startSpotlightMenuLabel":"对所有人聚焦","addSpotlightMenuLabel":"添加聚焦","stopSpotlightMenuLabel":"停止聚焦","stopSpotlightOnSelfMenuLabel":"退出聚焦","spotlightLimitReachedMenuTitle":"已达到聚焦限制","stopAllSpotlightMenuLabel":"停止所有聚焦","returnToCallButtonAriaDescription":"返回通话","returnToCallButtonAriaLabel":"返回","roomNotFoundDetails":"找不到提供的会议室 ID。","roomNotFoundTitle":"未找到会议室。","roomNotValidDetails":"此会议室当前无效。","roomNotValidTitle":"会议室无效","inviteToRoomRemovedDetails":"已删除你加入此会议室的邀请。","inviteToRoomRemovedTitle":"已删除加入会议室的邀请","soundLabel":"声音","noMicrophonesLabel":"未找到麦克风","noSpeakersLabel":"未找到扬声器","startCallButtonLabel":"开始通话","openDialpadButtonLabel":"拨打电话号码","peoplePaneAddPeopleButtonLabel":"添加人员","dialpadStartCallButtonLabel":"呼叫","dialpadModalTitle":"拨打电话号码","dialpadModalAriaLabel":"拨号盘","dialpadCloseModalButtonAriaLabel":"关闭拨号盘","moreButtonCallingLabel":"更多","resumeCallButtonLabel":"恢复","resumingCallButtonLabel":"正在恢复...","resumeCallButtonAriaLabel":"继续呼叫","resumingCallButtonAriaLabel":"继续通话","holdScreenLabel":"你的通话处于保留状态","openDtmfDialpadLabel":"显示拨号盘","dtmfDialpadPlaceholderText":"输入号码","outboundCallingNoticeString":"正在呼叫...","participantJoinedNoticeString":"{displayName} 已加入","twoParticipantJoinedNoticeString":"{displayName1} 和 {displayName2} 已加入","threeParticipantJoinedNoticeString":"{displayName1}、{displayName2} 和 {displayName3} 已加入","participantLeftNoticeString":"{displayName} 已离开","twoParticipantLeftNoticeString":"{displayName1} 和 {displayName2} 已离开","threeParticipantLeftNoticeString":"{displayName1}、{displayName2} 和 {displayName3} 已离开","unnamedParticipantString":"未命名的参与者","manyUnnamedParticipantsJoined":"未命名的参与者和其他 {numOfParticipants} 名参与者已加入","manyUnnamedParticipantsLeft":"未命名的参与者和其他 {numOfParticipants} 名参与者已离开","manyParticipantsJoined":"{displayName1}、{displayName2}、{displayName3}和其他{numOfParticipants}位参与者已加入","manyParticipantsLeft":"{displayName1}、{displayName2}、{displayName3}和其他{numOfParticipants}位参与者已离开","liveCaptionsLabel":"实时辅助字幕","captionsSettingsLabel":"字幕设置","startCaptionsButtonOnLabel":"开启字幕","startCaptionsButtonOffLabel":"关闭辅助字幕","startCaptionsButtonTooltipOnContent":"关闭辅助字幕","startCaptionsButtonTooltipOffContent":"开启字幕","captionsSettingsModalTitle":"字幕设置","captionsSettingsSpokenLanguageDropdownLabel":"口述语言","captionsSettingsCaptionLanguageDropdownLabel":"辅助字幕语言","captionsSettingsSpokenLanguageDropdownInfoText":"此通话中的每个人都在讲的语言。","captionsSettingsCaptionLanguageDropdownInfoText":"字幕将以此语言显示。","captionsSettingsConfirmButtonLabel":"确认","captionsSettingsCancelButtonLabel":"取消","captionsSettingsModalAriaLabel":"字幕设置模式","captionsSettingsCloseModalButtonAriaLabel":"关闭字幕设置","captionsBannerMoreButtonCallingLabel":"字幕设置更多选项","captionsBannerMoreButtonTooltip":"更多选项","realTimeTextLabel":"实时文本(RTT)","startRealTimeTextLabel":"为此通话启用 RTT","disabledStartRealTimeTextLabel":"RTT 当前已打开，无法关闭","dismissModalAriaLabel":"本地和远程图片和图像，按 Enter 返回呼叫","callRejectedTitle":"无法完成呼叫","callRejectedMoreDetails":"您尝试联系的人员不可用。请稍后重试。","callTimeoutTitle":"无法完成呼叫","callTimeoutDetails":"您尝试联系的人员不可用。请稍后重试。","callTimeoutBotTitle":"无法完成呼叫","callTimeoutBotDetails":"你尝试访问的服务不可用。请稍后重试。","dtmfDialerButtonLabel":"拨号盘","dtmfDialerButtonTooltipOn":"显示拨号盘","dtmfDialerButtonTooltipOff":"隐藏拨号盘","dtmfDialerMoreButtonLabelOn":"显示拨号盘","dtmfDialerMoreButtonLabelOff":"隐藏拨号盘","phoneCallMoreButtonLabel":"电话呼叫","spokenLanguageStrings":{"ar-ae":"阿拉伯语 - 阿拉伯联合酋长国","ar-sa":"阿拉伯语 - 沙特阿拉伯","da-dk":"丹麦语","de-de":"德语 - 德国","en-au":"英语 - 澳大利亚","en-ca":"英语 - 加拿大","en-gb":"英语 - 英国","en-in":"英语 - 印度","en-nz":"英语 - 新西兰","en-us":"英语 - 美国","es-es":"西班牙语 - 西班牙(现代风格)","es-mx":"西班牙语 - 墨西哥","fi-fi":"芬兰语","fr-ca":"法语 - 加拿大","fr-fr":"法语 - 法国","hi-in":"印地语","it-it":"意大利语–意大利","ja-jp":"日语","ko-kr":"朝鲜语","nb-no":"挪威语(博克马尔语)","nl-be":"荷兰语 - 比利时","nl-nl":"荷兰语 – 荷兰","pl-pl":"波兰语","pt-br":"葡萄牙语 - 巴西","ru-ru":"俄语","sv-se":"瑞典语","zh-cn":"中文 - 中华人民共和国","zh-hk":"中文 - 香港特别行政区","cs-cz":"捷克语","pt-pt":"葡萄牙语 - 葡萄牙","tr-tr":"土耳其语","vi-vn":"越南语","th-th":"泰语","he-il":"希伯来语","cy-gb":"威尔士语","uk-ua":"乌克兰语","el-gr":"希腊语","hu-hu":"匈牙利语","ro-ro":"罗马尼亚语","sk-sk":"斯洛伐克语","zh-tw":"中文 – 台湾"},"captionLanguageStrings":{"ar":"阿拉伯语","da":"丹麦语","de":"德语","en":"英语","es":"西班牙语","fi":"芬兰语","fr-ca":"法语 - 加拿大","fr":"法语 - 法国","hi":"印地语","it":"意大利语","ja":"日语","ko":"朝鲜语","nb":"挪威语(博克马尔语)","nl":"荷兰语","pl":"波兰语","pt":"葡萄牙语 - 巴西","ru":"俄语","sv":"瑞典语","zh-Hans":"中文(简体)","zh-Hant":"中文(繁体)","cs":"捷克语","pt-pt":"葡萄牙语 - 葡萄牙","tr":"土耳其语","vi":"越南语","th":"泰语","he":"希伯来语","cy":"威尔士语","uk":"乌克兰语","el":"希腊语","hu":"匈牙利语","ro":"罗马尼亚语","sk":"斯洛伐克语"},"captionsBannerSpinnerText":"正在启动字幕...","realTimeTextInputBoxDefaultText":"实时键入消息","realTimeTextInputErrorMessage":"消息不能超过 2000 个字符","realTimeTextBannerTitle":"RTT","realTimeTextBannerContent":"RTT (在会议的整个持续时间内为所有参与者启用实时文本)。","realTimeTextBannerLinkLabel":"了解详细信息","realTimeTextModalAriaLabel":"打开 RTT 模式","realTimeTextModalTitle":"是否启用 RTT?","realTimeTextModalText":"将为会议中的每个人启用实时文本 (RTT)。","realTimeTextConfirmButtonLabel":"启用","realTimeTextCancelButtonLabel":"取消","realTimeTextCloseModalButtonAriaLabel":"关闭 RTT 模式","captionsOnlyContainerTitle":"字幕","realTimeTextOnlyContainerTitle":"实时文本","captionsAndRealTimeTextContainerTitle":"字幕和实时文本","expandButtonAriaLabel":"展开","minimizeButtonAriaLabel":"折叠","transferPageTransferorText":"正在转接...","transferPageTransferTargetText":"正在连接...","transferPageUnknownTransferorDisplayName":"未知","transferPageUnknownTransferTargetDisplayName":"未知","transferPageNoticeString":"正在转接中","participantCouldNotBeReachedTitle":"目标参与者当前不可用","participantCouldNotBeReachedMoreDetails":"当参与者可用时，请联系他们","permissionToReachTargetParticipantNotAllowedTitle":"不允许访问目标参与者的权限","permissionToReachTargetParticipantNotAllowedMoreDetails":"请检查目标参与者位于同一租户中","unableToResolveTenantTitle":"无法解析目标参与者的租户 ID","unableToResolveTenantMoreDetails":"请检查正确输入参与者 ID","participantIdIsMalformedTitle":"参与者 ID 的格式不正确","participantIdIsMalformedMoreDetails":"请检查参与者 ID 的格式正确","moreButtonGalleryControlLabel":"查看","moreButtonGalleryPositionToggleLabel":"将库移到顶部","moreButtonGallerySpeakerLayoutLabel":"扬声器","moreButtonGalleryFloatingLocalLayoutLabel":"动态","moreButtonGalleryDefaultLayoutLabel":"库视图","moreButtonGalleryFocusedContentLayoutLabel":"关注内容","moreButtonLargeGalleryDefaultLayoutLabel":"大型画廊模式","moreButtonTogetherModeLayoutLabel":"同框场景模式","capabilityChangedNotification":{"turnVideoOn":{"lostDueToMeetingOption":"你的照相机已禁用。你无法再共享视频。","grantedDueToMeetingOption":"你的相机已启用。如果要共享视频，请将其打开。"},"unmuteMic":{"lostDueToMeetingOption":"你的麦克风已被禁用。你无法再取消静音。","grantedDueToMeetingOption":"你的麦克风已启用。如果想要讲话，请取消静音。"},"shareScreen":{"lostDueToRoleChangeToAttendee":"你的角色已更改。某些操作，如共享内容，对你不可用。","grantedDueToRoleChangeToPresenter":"你是演示者。你可以共享内容并促进会议。"},"hideAttendeeNames":{"hideAttendeeNameAttendee":"你的姓名对其他与会者隐藏。组织者和演示者可以看到你的真实姓名。","hideAttendeeNamePresenter":"与会者姓名已隐藏。为保护与会者隐私，只有组织者和演示者才能查看姓名。"}},"surveyTitle":"帮助我们改进","starSurveyHelperText":"通话质量如何?","starSurveyOneStarText":"质量很差。","starSurveyTwoStarText":"质量较差。","starSurveyThreeStarText":"质量良好。","starSurveyFourStarText":"质量很棒。","starSurveyFiveStarText":"质量很好。","surveyConfirmButtonLabel":"发送反馈","starRatingAriaLabel":"选择 {0} 星(共 {1} 星)","surveySkipButtonLabel":"跳过","tagsSurveyQuestion":"如何改进?","tagsSurveyTextFieldDefaultText":"其他，请说明","tagsSurveyHelperText":"检查遇到的任何问题","endOfSurveyText":"感谢你的反馈!","surveyIssues":{"overallRating":{"callCannotJoin":"我无法加入通话","callCannotInvite":"我无法邀请其他人加入通话","hadToRejoin":"我不得不重新加入通话","callEndedUnexpectedly":"通话意外结束","otherIssues":"我在通话时遇到其他问题"},"audioRating":{"noLocalAudio":"对方听不到任何声音","noRemoteAudio":"我听不到任何声音","echo":"我在通话中听到回音","audioNoise":"我在通话时听到噪音","lowVolume":"音量太低","audioStoppedUnexpectedly":"视频意外停止","distortedSpeech":"音频已失真","audioInterruption":"音频已中断","otherIssues":"我在此通话中遇到其他音频问题"},"videoRating":{"noVideoReceived":"我看不到视频","noVideoSent":"其他人看不到我","lowQuality":"视频质量低","freezes":"视频已冻结","stoppedUnexpectedly":"视频意外停止","darkVideoReceived":"我只能在其他人打开相机时看到深色屏幕","audioVideoOutOfSync":"音频和视频不同步","otherIssues":"我在此通话中遇到其他视频问题"},"screenshareRating":{"noContentLocal":"其他人看不到我的屏幕共享","noContentRemote":"我看不到其他人的屏幕共享","cannotPresent":"我无法显示我的屏幕","lowQuality":"屏幕共享质量低","freezes":"屏幕共享已冻结","stoppedUnexpectedly":"屏幕共享意外停止","largeDelay":"屏幕共享具有较大的延迟","otherIssues":"我在此通话中遇到其他屏幕共享问题"}},"surveyIssuesHeadingStrings":{"overallRating":"整体","audioRating":"音频","videoRating":"视频","screenshareRating":"正在演示"},"spotlightPrompt":{"startSpotlightHeading":"对所有人聚焦?","startSpotlightText":"你将对会议中的每个人突出显示此视频。","startSpotlightOnSelfText":"你将对会议中的每个人突出显示你的视频。","startSpotlightConfirmButtonLabel":"对所有人聚焦","startSpotlightCancelButtonLabel":"取消","stopSpotlightHeading":"停止聚焦此视频?","stopSpotlightOnSelfHeading":"退出聚焦?","stopAllSpotlightHeading":"是否停止聚焦所有视频?","stopSpotlightText":"将不再为会议中的每个人突出显示此视频。","stopSpotlightOnSelfText":"将不再对会议中的每个人突出显示你的视频。","stopAllSpotlightText":"将不再对会议中的每个人突出显示该视频。","stopSpotlightConfirmButtonLabel":"停止聚焦","stopSpotlightOnSelfConfirmButtonLabel":"退出聚焦","stopSpotlightCancelButtonLabel":"取消","closeSpotlightPromptButtonLabel":"关闭"},"exitSpotlightButtonLabel":"退出聚焦","exitSpotlightButtonTooltip":"退出聚焦","leaveConfirmButtonLabel":"退出","endCallConfirmButtonLabel":"结束通话","hangUpCancelButtonLabel":"取消","leaveConfirmDialogTitle":"离开聊天?","leaveConfirmDialogContent":"是否确实要离开此聊天?","endCallConfirmDialogTitle":"结束通话?","endCallConfirmDialogContent":"你将结束所有人的通话。","invalidMeetingIdentifier":"会议 ID 或密码无效","pinParticipantMenuLabel":"为我固定","pinParticipantLimitReachedMenuLabel":"固定(已达到上限)","unpinParticipantMenuLabel":"取消固定","pinParticipantMenuItemAriaLabel":"为我固定","unpinParticipantMenuItemAriaLabel":"取消固定","muteAllMenuLabel":"全部静音","muteAllDialogTitle":"对所有人静音?","muteAllDialogContent":"这会将会议中除你之外的所有人静音。","muteAllConfirmButtonLabel":"全部静音","muteAllCancelButtonLabel":"取消","joinBreakoutRoomButtonLabel":"加入分组讨论室","returnFromBreakoutRoomButtonLabel":"离开房间","leaveBreakoutRoomAndMeetingButtonLabel":"离开会议","breakoutRoomJoinedNotificationTitle":"你已加入分组讨论室“{roomName}”","joinBreakoutRoomBannerTitle":"分组讨论室“{roomName}”已打开","joinBreakoutRoomBannerButtonLabel":"加入","returnFromBreakoutRoomBannerTitle":"返回到主会议","returnFromBreakoutRoomBannerButtonLabel":"重新加入","forbidAudioMenuLabel":"禁用麦克风","permitAudioMenuLabel":"允许使用麦克风","forbidOthersAudioDialogTitle":"为与会者禁用麦克风?","forbidOthersAudioDialogContent":"与会者不能将自己取消静音。组织者和演示者可以根据需要允许与会人员取消静音。","forbidOthersAudioConfirmButtonLabel":"禁用麦克风","forbidOthersAudioCancelButtonLabel":"取消","permitOthersAudioDialogTitle":"是否允许与会者使用麦克风?","permitOthersAudioDialogContent":"会议中的每个人都能够自行取消静音。","permitOthersAudioConfirmButtonLabel":"允许使用麦克风","permitOthersAudioCancelButtonLabel":"取消","forbidOthersAudioMenuLabel":"为与会者禁用麦克风","permitOthersAudioMenuLabel":"允许与会者使用麦克风","forbidVideoMenuLabel":"禁用摄像头","permitVideoMenuLabel":"允许使用摄像头","forbidOthersVideoDialogTitle":"为与会者禁用摄像头?","forbidOthersVideoDialogContent":"与会者将无法自己打开视频。组织者和演示者可以允许用户根据需要打开摄像头。","forbidOthersVideoConfirmButtonLabel":"禁用摄像头","forbidOthersVideoCancelButtonLabel":"取消","permitOthersVideoDialogTitle":"是否允许与会者使用摄像头?","permitOthersVideoDialogContent":"会议中的每个人都能够自己打开视频。","permitOthersVideoConfirmButtonLabel":"允许使用摄像头","permitOthersVideoCancelButtonLabel":"取消","forbidOthersVideoMenuLabel":"为与会者禁用摄像头","permitOthersVideoMenuLabel":"允许与会者使用摄像头"}'),chat:{chatListHeader:"在此聊天中",uploadAttachment:"上传附件",uploadImageDataNotProvided:"未提供图像数据。",uploadImageIsTooLarge:"图像太大。选择小于 {maxImageSize} MB 的选项。",uploadImageExtensionIsNotAllowed:"上传。不允许使用 {imageExtension} 图像。",uploadImageFailed:"无法上传图像。请稍后重试。"},callWithChat:{chatButtonLabel:"聊天",chatButtonNewMessageNotificationLabel:"新建消息",chatButtonTooltipClosedWithMessageCount:"显示聊天({unreadMessagesCount} 条未读)",chatButtonTooltipClose:"隐藏聊天",chatButtonTooltipOpen:"显示聊天",chatPaneTitle:"聊天",copyInviteLinkButtonLabel:"复制邀请链接",copyInviteLinkButtonActionedLabel:"已复制链接",copyInviteLinkActionedAriaLabel:"已复制邀请链接",dismissSidePaneButtonLabel:"关闭",moreDrawerAudioDeviceMenuTitle:"音频设备",moreDrawerButtonLabel:"更多选项",moreDrawerButtonTooltip:"更多选项",moreDrawerMicrophoneMenuTitle:"麦克风",moreDrawerSpeakerMenuTitle:"扬声器",moreDrawerCaptionsMenuTitle:"实时辅助字幕",moreDrawerSpokenLanguageMenuTitle:"口述语言",moreDrawerCaptionLanguageMenuTitle:"字幕语言",moreDrawerGalleryOptionsMenuTitle:"库选项",peopleButtonLabel:"人员",selectedPeopleButtonLabel:"已选择“人员”按钮",peopleButtonTooltipOpen:"显示参与者",peopleButtonTooltipClose:"隐藏参与者",peopleButtonTooltipOpenAriaLabel:"“人员”按钮，显示参与者",peopleButtonTooltipCloseAriaLabel:"“人员”按钮，隐藏参与者",peoplePaneSubTitle:"在此通话中",peoplePaneTitle:"人员",pictureInPictureTileAriaLabel:"视频源。单击以返回到通话屏幕。",removeMenuLabel:"删除",openDialpadButtonLabel:"拨打电话号码",returnToCallButtonAriaDescription:"返回通话",returnToCallButtonAriaLabel:"返回",peoplePaneAddPeopleButtonLabel:"添加人员",dialpadStartCallButtonLabel:"呼叫",dialpadModalTitle:"拨打电话号码",dialpadModalAriaLabel:"拨号盘",dialpadCloseModalButtonAriaLabel:"关闭拨号盘",openDtmfDialpadLabel:"显示拨号盘",dtmfDialpadPlaceholderText:"输入号码",breakoutRoomChatPaneTitle:"分组讨论室聊天",chatContentSpinnerLabel:"正在加载聊天"}})},Dli={component:IQt,strings:Yh({call:JSON.parse(`{"cameraLabel":"相機","noCamerasLabel":"找不到相機","cameraPermissionDenied":"您的瀏覽器禁止存取您的相機","cameraTurnedOff":"您的相機已關閉","chatButtonLabel":"聊天","close":"關閉","complianceBannerNowOnlyRecording":"您現在只會錄製此會議。","complianceBannerNowOnlyTranscription":"您現在只會轉錄此會議。","complianceBannerRecordingAndTranscriptionSaved":"正在儲存錄製和轉錄。","complianceBannerRecordingAndTranscriptionStarted":"已開始錄製並進行轉錄。","complianceBannerRecordingAndTranscriptionStopped":"已停止錄製與轉錄。","complianceBannerRecordingSaving":"正在儲存錄製內容。","complianceBannerRecordingStarted":"已開始錄製。","complianceBannerRecordingStopped":"已停止錄製。","complianceBannerTranscriptionStarted":"已開始轉錄。","complianceBannerTranscriptionConsent":"一旦加入，即表示您同意轉譯此會議。","complianceBannerTranscriptionSaving":"正在儲存轉錄。","complianceBannerTranscriptionStopped":"已停止轉錄。","configurationPageTitle":"開始通話","copyInviteLinkButtonLabel":"複製邀請連結","copyInviteLinkButtonActionedLabel":"已複製連結","copyInviteLinkActionedAriaLabel":"已複製邀請連結","defaultPlaceHolder":"選取選項","dismissSidePaneButtonLabel":"關閉","videoEffectsPaneTitle":"效果","videoEffectsPaneBackgroundSelectionTitle":"背景","videoEffectsPaneAriaLabel":"視訊效果​​窗格","configurationPageCameraIsLoadingLabel":"正在載入影片...","configurationPageVideoEffectsButtonLabel":"效果","unableToStartVideoEffect":"無法套用視訊效果。","blurBackgroundEffectButtonLabel":"模糊","blurBackgroundTooltip":"模糊背景","removeBackgroundEffectButtonLabel":"無","removeBackgroundTooltip":"移除背景","cameraOffBackgroundEffectWarningText":"您的相機已關閉。開啟相機以查看影片效果。","failedToJoinCallDueToNoNetworkMoreDetails":"由於網路問題，通話已中斷連線。檢查您的連線並再次加入。","failedToJoinCallDueToNoNetworkTitle":"通話已斷線","failedToJoinTeamsMeetingReasonAccessDeniedMoreDetails":"您未被授予加入通話的權限。如果有誤，請重新加入通話。","failedToJoinTeamsMeetingReasonAccessDeniedTitle":"已從大廳關閉","learnMore":"深入了解","leavingCallTitle":"正在離開...","leftCallMoreDetails":"如果有誤，請重新加入通話。","leftCallTitle":"您已離開通話","lobbyScreenConnectingToCallTitle":"正在加入通話","lobbyScreenWaitingToBeAdmittedTitle":"正在等候認可","microphonePermissionDenied":"您的瀏覽器禁止存取您的麥克風","microphoneToggleInLobbyNotAllowed":"無法在大廳中靜音或取消靜音。","mutedMessage":"您已設為靜音","networkReconnectMoreDetails":"似乎發生錯誤。我們正在嘗試讓您返回通話。","networkReconnectTitle":"請稍候","notInvitedToRoomDetails":"您無法加入此聊天室，因為您沒有邀請。","notInvitedToRoomTitle":"未受邀至會議室","peopleButtonLabel":"人員","selectedPeopleButtonLabel":"已選取人員按鈕","peoplePaneTitle":"人員","peoplePaneMoreButtonAriaLabel":"其他","peopleButtonTooltipOpen":"顯示參與者","peopleButtonTooltipClose":"隱藏參與者","peoplePaneSubTitle":"在此通話 {numberOfPeople}","privacyPolicy":"隱私權原則","rejoinCallButtonLabel":"重新加入通話","removedFromCallMoreDetails":"另一名參與者已將您自通話中移除。","removedFromCallTitle":"您已遭移除","removeMenuLabel":"移除","startSpotlightMenuLabel":"設為每個人的焦點","addSpotlightMenuLabel":"新增焦點","stopSpotlightMenuLabel":"停止聚焦","stopSpotlightOnSelfMenuLabel":"結束聚焦","spotlightLimitReachedMenuTitle":"已達焦點限制","stopAllSpotlightMenuLabel":"停止所有聚焦","returnToCallButtonAriaDescription":"返回通話","returnToCallButtonAriaLabel":"返回","roomNotFoundDetails":"找不到提供的會議室識別碼。","roomNotFoundTitle":"找不到會議室","roomNotValidDetails":"此會議室目前無效。","roomNotValidTitle":"會議室無效","inviteToRoomRemovedDetails":"您加入此聊天室的邀請已移除。","inviteToRoomRemovedTitle":"已移除加入聊天室的邀請","soundLabel":"音效","noMicrophonesLabel":"找不到麥克風","noSpeakersLabel":"找不到喇叭","startCallButtonLabel":"開始通話","openDialpadButtonLabel":"撥打電話號碼","peoplePaneAddPeopleButtonLabel":"新增人員","dialpadStartCallButtonLabel":"通話","dialpadModalTitle":"撥打電話號碼","dialpadModalAriaLabel":"撥號鍵台","dialpadCloseModalButtonAriaLabel":"關閉撥號鍵台","moreButtonCallingLabel":"其他","resumeCallButtonLabel":"繼續","resumingCallButtonLabel":"正在繼續...","resumeCallButtonAriaLabel":"繼續通話","resumingCallButtonAriaLabel":"繼續通話","holdScreenLabel":"您的通話已保留","openDtmfDialpadLabel":"顯示撥號盤","dtmfDialpadPlaceholderText":"輸入號碼","outboundCallingNoticeString":"撥號中...","participantJoinedNoticeString":"{displayName} 已加入","twoParticipantJoinedNoticeString":"{displayName1} 和 {displayName2} 已加入","threeParticipantJoinedNoticeString":"{displayName1}、{displayName2} 和 {displayName3} 已加入","participantLeftNoticeString":"{displayName} 已離開","twoParticipantLeftNoticeString":"{displayName1} 和 {displayName2} 已離開","threeParticipantLeftNoticeString":"{displayName1}、{displayName2} 和 {displayName3} 已離開","unnamedParticipantString":"未命名的參與者","manyUnnamedParticipantsJoined":"未命名的參與者和 {numOfParticipants} 個其他參與者已加入","manyUnnamedParticipantsLeft":"未命名的參與者和 {numOfParticipants} 個其他參與者已離開","manyParticipantsJoined":"{displayName1}、{displayName2}、{displayName3}和其他{numOfParticipants}位參與者已加入","manyParticipantsLeft":"{displayName1}、{displayName2}、{displayName3}和其他{numOfParticipants}位參與者","liveCaptionsLabel":"即時字幕","captionsSettingsLabel":"字幕設定","startCaptionsButtonOnLabel":"開啟字幕","startCaptionsButtonOffLabel":"關閉字幕","startCaptionsButtonTooltipOnContent":"關閉字幕","startCaptionsButtonTooltipOffContent":"開啟字幕","captionsSettingsModalTitle":"字幕設定","captionsSettingsSpokenLanguageDropdownLabel":"口語語言","captionsSettingsCaptionLanguageDropdownLabel":"字幕語言","captionsSettingsSpokenLanguageDropdownInfoText":"此通話中的每個人在說的語言。","captionsSettingsCaptionLanguageDropdownInfoText":"字幕將會以此語言顯示。","captionsSettingsConfirmButtonLabel":"確認","captionsSettingsCancelButtonLabel":"取消","captionsSettingsModalAriaLabel":"字幕設定模式","captionsSettingsCloseModalButtonAriaLabel":"關閉字幕設定","captionsBannerMoreButtonCallingLabel":"字幕設定更多選項","captionsBannerMoreButtonTooltip":"更多選項","realTimeTextLabel":"即時輸入 (RTT)","startRealTimeTextLabel":"開啟此通話的即時輸入","disabledStartRealTimeTextLabel":"RTT 目前已開啟，無法關閉","dismissModalAriaLabel":"本機和遠端圖片，按 Enter 以返回通話","callRejectedTitle":"無法完成通話","callRejectedMoreDetails":"您嘗試連絡的人員無法使用。請稍後再試。","callTimeoutTitle":"無法完成通話","callTimeoutDetails":"您嘗試連絡的人員無法使用。請稍後再試。","callTimeoutBotTitle":"無法完成通話","callTimeoutBotDetails":"您嘗試連線的服務無法使用。請稍後再試。","dtmfDialerButtonLabel":"撥號鍵台","dtmfDialerButtonTooltipOn":"顯示撥號盤","dtmfDialerButtonTooltipOff":"隱藏撥號盤","dtmfDialerMoreButtonLabelOn":"顯示撥號盤","dtmfDialerMoreButtonLabelOff":"隱藏撥號盤","phoneCallMoreButtonLabel":"電話","spokenLanguageStrings":{"ar-ae":"阿拉伯文 - 阿拉伯聯合大公國","ar-sa":"阿拉伯文 - 沙烏地阿拉伯","da-dk":"丹麥文","de-de":"德文 - 德國","en-au":"英文 - 澳大利亞","en-ca":"英文 - 加拿大","en-gb":"英文 - 英國","en-in":"英文 - 印度","en-nz":"英文 - 紐西蘭","en-us":"英文 - 美國","es-es":"西班牙文 - 西班牙 (現代排序)","es-mx":"西班牙文 - 墨西哥","fi-fi":"芬蘭文","fr-ca":"法文 - 加拿大","fr-fr":"法文 - 法國","hi-in":"印地文","it-it":"義大利文 - 義大利","ja-jp":"日文","ko-kr":"韓文","nb-no":"挪威文 (巴克摩)","nl-be":"荷蘭文 - 比利時","nl-nl":"荷蘭文 - 荷蘭","pl-pl":"波蘭文","pt-br":"葡萄牙文 - 巴西","ru-ru":"俄文","sv-se":"瑞典文","zh-cn":"中文 - 中華人民共和國","zh-hk":"中文 - 香港特別行政區","cs-cz":"捷克文","pt-pt":"葡萄牙文 - 葡萄牙","tr-tr":"土耳其文","vi-vn":"越南文","th-th":"泰文","he-il":"希伯來文","cy-gb":"威爾斯文","uk-ua":"烏克蘭文","el-gr":"希臘文","hu-hu":"匈牙利文","ro-ro":"羅馬尼亞文","sk-sk":"斯洛伐克文","zh-tw":"中文 - 台灣"},"captionLanguageStrings":{"ar":"阿拉伯文","da":"丹麥文","de":"德文","en":"英文","es":"西班牙文","fi":"芬蘭文","fr-ca":"法文 - 加拿大","fr":"法文 - 法國","hi":"印地文","it":"義大利文","ja":"日文","ko":"韓文","nb":"挪威文 (巴克摩)","nl":"荷蘭文","pl":"波蘭文","pt":"葡萄牙文 - 巴西","ru":"俄文","sv":"瑞典文","zh-Hans":"中文 (簡體)","zh-Hant":"中文 (繁體)","cs":"捷克文","pt-pt":"葡萄牙文 - 葡萄牙","tr":"土耳其文","vi":"越南文","th":"泰文","he":"希伯來文","cy":"威爾斯文","uk":"烏克蘭文","el":"希臘文","hu":"匈牙利文","ro":"羅馬尼亞文","sk":"斯洛伐克文"},"captionsBannerSpinnerText":"正在啟動輔助字幕...","realTimeTextInputBoxDefaultText":"即時輸入訊息","realTimeTextInputErrorMessage":"訊息不得超過 2000 個字元","realTimeTextBannerTitle":"即時輸入","realTimeTextBannerContent":"已為整個會議期間的所有參與者啟用 RTT (即時文字)。","realTimeTextBannerLinkLabel":"深入了解","realTimeTextModalAriaLabel":"開啟 RTT 強制回應","realTimeTextModalTitle":"開啟 RTT?","realTimeTextModalText":"將為會議中的每個人開啟即時文字 (RTT)。","realTimeTextConfirmButtonLabel":"開啟","realTimeTextCancelButtonLabel":"取消","realTimeTextCloseModalButtonAriaLabel":"關閉 RTT 強制回應","captionsOnlyContainerTitle":"輔助字幕","realTimeTextOnlyContainerTitle":"即時文字","captionsAndRealTimeTextContainerTitle":"輔助字幕與即時文字","expandButtonAriaLabel":"展開","minimizeButtonAriaLabel":"摺疊","transferPageTransferorText":"正在轉接...","transferPageTransferTargetText":"正在連線...","transferPageUnknownTransferorDisplayName":"未知","transferPageUnknownTransferTargetDisplayName":"未知","transferPageNoticeString":"正在將您轉接","participantCouldNotBeReachedTitle":"目標參與者目前沒空","participantCouldNotBeReachedMoreDetails":"請在參與者有空時聯絡他們","permissionToReachTargetParticipantNotAllowedTitle":"不允許連絡目標參與者的權限","permissionToReachTargetParticipantNotAllowedMoreDetails":"請檢查目標參與者是否位於相同的租用戶中","unableToResolveTenantTitle":"無法解析目標參與者的租用戶識別碼","unableToResolveTenantMoreDetails":"請檢查已正確輸入參與者識別碼","participantIdIsMalformedTitle":"參與者識別碼的格式不正確","participantIdIsMalformedMoreDetails":"請檢查參與者識別碼的格式是否正確","moreButtonGalleryControlLabel":"檢視","moreButtonGalleryPositionToggleLabel":"將圖庫移至頂端","moreButtonGallerySpeakerLayoutLabel":"揚聲器","moreButtonGalleryFloatingLocalLayoutLabel":"動態","moreButtonGalleryDefaultLayoutLabel":"圖庫檢視","moreButtonGalleryFocusedContentLayoutLabel":"聚焦內容","moreButtonLargeGalleryDefaultLayoutLabel":"大型圖庫","moreButtonTogetherModeLayoutLabel":"在一起模式","capabilityChangedNotification":{"turnVideoOn":{"lostDueToMeetingOption":"您的相機已停用。您無法再分享視訊。","grantedDueToMeetingOption":"您的相機已啟用。如果您想要分享視訊，請將其開啟。"},"unmuteMic":{"lostDueToMeetingOption":"您的麥克風已停用。您無法再取消靜音。","grantedDueToMeetingOption":"您的麥克風已啟用。若您想進行語音，請取消靜音。"},"shareScreen":{"lostDueToRoleChangeToAttendee":"您的角色已變更。某些動作，例如共用內容，將無法供您使用。","grantedDueToRoleChangeToPresenter":"您就是簡報者。您可以分享內容並協助會議。"},"hideAttendeeNames":{"hideAttendeeNameAttendee":"其他出席者看不到您的名字。召集人和簡報者可以看到您的真實姓名。","hideAttendeeNamePresenter":"已隱藏出席者名稱。只有召集人和簡報者可以看到名稱以保護出席者隱私權。"}},"surveyTitle":"協助我們改善","starSurveyHelperText":"通話的品質如何?","starSurveyOneStarText":"品質劣等。","starSurveyTwoStarText":"品質差。","starSurveyThreeStarText":"品質佳。","starSurveyFourStarText":"品質很好。","starSurveyFiveStarText":"品質極佳。","surveyConfirmButtonLabel":"傳送意見反應","starRatingAriaLabel":"選取 {0} / {1} 顆星","surveySkipButtonLabel":"跳過","tagsSurveyQuestion":"什麼部分本來能做得更好?","tagsSurveyTextFieldDefaultText":"其他，請註明","tagsSurveyHelperText":"檢查您遇到的任何問題","endOfSurveyText":"感謝您提供意見反應!","surveyIssues":{"overallRating":{"callCannotJoin":"我無法加入通話","callCannotInvite":"無法邀請其他人加入通話","hadToRejoin":"我必須重新加入通話","callEndedUnexpectedly":"我的通話意外結束","otherIssues":"我在通話中遇到其他問題"},"audioRating":{"noLocalAudio":"另一方聽不到任何聲音","noRemoteAudio":"我聽不到任何聲音","echo":"我在通話中聽到回音","audioNoise":"我在通話時聽到雜音","lowVolume":"音量很小","audioStoppedUnexpectedly":"音訊意外停止","distortedSpeech":"音訊失真","audioInterruption":"音訊已中斷","otherIssues":"我在這次通話中遇到其他音訊問題"},"videoRating":{"noVideoReceived":"我看不到任何視訊","noVideoSent":"其他人看不到我","lowQuality":"視訊品質低落","freezes":"視訊凍結","stoppedUnexpectedly":"視訊意外停止","darkVideoReceived":"只有當其他人開啟他們的相機時，我才能看到深色螢幕","audioVideoOutOfSync":"音訊和視訊不同步","otherIssues":"我在這次通話中遇到其他視訊問題"},"screenshareRating":{"noContentLocal":"其他人看不到我的螢幕畫面分享","noContentRemote":"我看不到其他人的螢幕畫面分享","cannotPresent":"我無法展示我的螢幕","lowQuality":"螢幕畫面分享品質太低","freezes":"螢幕畫面分享已凍結","stoppedUnexpectedly":"螢幕畫面分享意外停止","largeDelay":"螢幕畫面分享有大量的延遲","otherIssues":"我在這次通話中遇到其他螢幕畫面分享問題"}},"surveyIssuesHeadingStrings":{"overallRating":"整體","audioRating":"音訊","videoRating":"影片","screenshareRating":"正在進行簡報"},"spotlightPrompt":{"startSpotlightHeading":"要設為每個人的精選嗎?","startSpotlightText":"您將向會議中的每個人醒目提示此影片。","startSpotlightOnSelfText":"您將向會議中的每個人醒目提示您的影片。","startSpotlightConfirmButtonLabel":"設為每個人的精選","startSpotlightCancelButtonLabel":"取消","stopSpotlightHeading":"要停止聚焦這部影片嗎?","stopSpotlightOnSelfHeading":"結束精選?","stopAllSpotlightHeading":"是否要停止聚焦所有影片?","stopSpotlightText":"不會再向會議中的每個人醒目提示該影片。","stopSpotlightOnSelfText":"不會再向會議中的每個人醒目提示您的影片。","stopAllSpotlightText":"不會再向會議中的每個人醒目提示此影片。","stopSpotlightConfirmButtonLabel":"停止選為精選","stopSpotlightOnSelfConfirmButtonLabel":"結束精選","stopSpotlightCancelButtonLabel":"取消","closeSpotlightPromptButtonLabel":"關閉"},"exitSpotlightButtonLabel":"結束精選","exitSpotlightButtonTooltip":"結束精選","leaveConfirmButtonLabel":"離開","endCallConfirmButtonLabel":"結束通話","hangUpCancelButtonLabel":"取消","leaveConfirmDialogTitle":"離開通話?","leaveConfirmDialogContent":"確定要離開此通話?","endCallConfirmDialogTitle":"結束通話?","endCallConfirmDialogContent":"您將結束所有人的通話。","invalidMeetingIdentifier":"會議標識碼或密碼無效","pinParticipantMenuLabel":"為我釘選","pinParticipantLimitReachedMenuLabel":"釘選 (已達到限制)","unpinParticipantMenuLabel":"取消釘選","pinParticipantMenuItemAriaLabel":"為我釘選","unpinParticipantMenuItemAriaLabel":"取消釘選","muteAllMenuLabel":"將所有人設為靜音","muteAllDialogTitle":"將所有人設為靜音?","muteAllDialogContent":"這會將會議中您以外的所有人設為靜音。","muteAllConfirmButtonLabel":"將所有人設為靜音","muteAllCancelButtonLabel":"取消","joinBreakoutRoomButtonLabel":"加入分組討論區","returnFromBreakoutRoomButtonLabel":"離開分組討論區","leaveBreakoutRoomAndMeetingButtonLabel":"離開會議","breakoutRoomJoinedNotificationTitle":"您已加入分組討論區 '{roomName}'","joinBreakoutRoomBannerTitle":"分組討論區 '{roomName}' 已開放","joinBreakoutRoomBannerButtonLabel":"加入","returnFromBreakoutRoomBannerTitle":"返回主要會議","returnFromBreakoutRoomBannerButtonLabel":"重新加入","forbidAudioMenuLabel":"停用麥克風","permitAudioMenuLabel":"允許麥克風","forbidOthersAudioDialogTitle":"要停用出席者的麥克風嗎?","forbidOthersAudioDialogContent":"出席者將無法自行取消靜音。召集人與簡報者可以視需要讓人員取消靜音。","forbidOthersAudioConfirmButtonLabel":"停用麥克風","forbidOthersAudioCancelButtonLabel":"取消","permitOthersAudioDialogTitle":"要允許出席者的麥克風嗎?","permitOthersAudioDialogContent":"會議中的每個人都可以自行解除靜音。","permitOthersAudioConfirmButtonLabel":"允許麥克風","permitOthersAudioCancelButtonLabel":"取消","forbidOthersAudioMenuLabel":"停用出席者的麥克風","permitOthersAudioMenuLabel":"允許出席者使用麥克風","forbidVideoMenuLabel":"停用相機","permitVideoMenuLabel":"允許相機","forbidOthersVideoDialogTitle":"要停用出席者的相機嗎?","forbidOthersVideoDialogContent":"出席者將無法自行開啟視訊。召集人和演示者可以讓人員視需要開啟攝影機。","forbidOthersVideoConfirmButtonLabel":"停用相機","forbidOthersVideoCancelButtonLabel":"取消","permitOthersVideoDialogTitle":"要允許出席者的相機嗎?","permitOthersVideoDialogContent":"會議中的每個人都能自行開啟視訊。","permitOthersVideoConfirmButtonLabel":"允許相機","permitOthersVideoCancelButtonLabel":"取消","forbidOthersVideoMenuLabel":"停用出席者的鏡頭","permitOthersVideoMenuLabel":"允許出席者使用相機"}`),chat:{chatListHeader:"在此聊天中",uploadAttachment:"上傳附件",uploadImageDataNotProvided:"未提供影像資料。",uploadImageIsTooLarge:"影像太大。選擇小於 {maxImageSize} MB 的選項。",uploadImageExtensionIsNotAllowed:"不允許上傳 .{imageExtension} 影像。",uploadImageFailed:"無法上傳影像。請稍後再試。"},callWithChat:{chatButtonLabel:"聊天",chatButtonNewMessageNotificationLabel:"新訊息",chatButtonTooltipClosedWithMessageCount:"顯示聊天 ({unreadMessagesCount} 個未讀取)",chatButtonTooltipClose:"隱藏聊天",chatButtonTooltipOpen:"顯示聊天",chatPaneTitle:"聊天",copyInviteLinkButtonLabel:"複製邀請連結",copyInviteLinkButtonActionedLabel:"已複製連結",copyInviteLinkActionedAriaLabel:"已複製邀請連結",dismissSidePaneButtonLabel:"關閉",moreDrawerAudioDeviceMenuTitle:"音訊裝置",moreDrawerButtonLabel:"更多選項",moreDrawerButtonTooltip:"更多選項",moreDrawerMicrophoneMenuTitle:"麥克風",moreDrawerSpeakerMenuTitle:"揚聲器",moreDrawerCaptionsMenuTitle:"即時字幕",moreDrawerSpokenLanguageMenuTitle:"口語語言",moreDrawerCaptionLanguageMenuTitle:"字幕語言",moreDrawerGalleryOptionsMenuTitle:"圖庫選項",peopleButtonLabel:"人員",selectedPeopleButtonLabel:"已選取人員按鈕",peopleButtonTooltipOpen:"顯示參與者",peopleButtonTooltipClose:"隱藏參與者",peopleButtonTooltipOpenAriaLabel:"[人員] 按鈕，顯示參與者",peopleButtonTooltipCloseAriaLabel:"[人員] 按鈕，隱藏參與者",peoplePaneSubTitle:"在此通話中",peoplePaneTitle:"人員",pictureInPictureTileAriaLabel:"影片摘要。按一下以返回通話畫面。",removeMenuLabel:"移除",openDialpadButtonLabel:"撥打電話號碼",returnToCallButtonAriaDescription:"返回通話",returnToCallButtonAriaLabel:"返回",peoplePaneAddPeopleButtonLabel:"新增人員",dialpadStartCallButtonLabel:"通話",dialpadModalTitle:"撥打電話號碼",dialpadModalAriaLabel:"撥號鍵台",dialpadCloseModalButtonAriaLabel:"關閉撥號鍵台",openDtmfDialpadLabel:"顯示撥號盤",dtmfDialpadPlaceholderText:"輸入號碼",breakoutRoomChatPaneTitle:"分組討論區聊天",chatContentSpinnerLabel:"正在載入聊天"}})};function BX({label:t}){const e=kK();return Da.jsx(E5,{className:"loading-screen",theme:e,children:Da.jsx(vMe,{size:"huge",labelPosition:"below",label:t})})}function b8e(t){const[e,i]=$.useState();return $.useEffect(()=>{if(!t)return;const r=[t.connectionSettings.onSettingsChange(o=>i(o))];return t.connectionSettings.getSettings(),()=>Vy.unsubscribe(r)},[t]),e}function T8e(t,e,i,r){try{const o={token:r,tokenRefresher:()=>e.connectionSettings.refreshToken(i),refreshProactively:!0};return new eIt(o)}catch(o){t.error("Failed to build Azure credential",o);return}}function C8e(t){const[e,i]=$.useState();return $.useEffect(()=>{if(!t)return;const r=[t.chat.onSettingsChange(o=>i(o))];return t.chat.getSettings(),()=>Vy.unsubscribe(r)},[t]),e}function Lli(t){const[e,i]=$.useState(),r=Oli(t,i);return[Cti(r),e]}function Oli(t,e){const i=b8e(t),r=C8e(t);return $.useMemo(()=>Nli(t,i,r,e),[i,r,t,e])}function Nli(t,e,i,r){if(!t||e===void 0||i===void 0)return r(void 0),{};if(e===null||i===null)return r(t.i18n.getString("chat.initialization_error")),{};const{userId:o,displayName:l,token:d}=e,{chatEndpoint:h,chatThreadId:p}=i,g=T8e(t.logging.chat,t,o,d);return g||r(t.i18n.getString("chat.initialization_error")),{endpoint:h,userId:tj(o),displayName:l,credential:g,threadId:p}}function FX({message:t,action:e,onAction:i}){const r=kK(),o=Da.jsx(P5,{as:"button",appearance:"primary",size:"large",onClick:i,children:e}),l=Da.jsx(ole,{align:"center",size:500,weight:"semibold",children:t});return Da.jsxs(E5,{className:"action-screen",theme:r,children:[t?l:void 0,e?o:void 0]})}const xli="COMPOSITE_LOCALE_EN_US",_8e={COMPOSITE_LOCALE_AR_SA:uli,COMPOSITE_LOCALE_CS_CZ:hli,COMPOSITE_LOCALE_CY_GB:pli,COMPOSITE_LOCALE_DE_DE:gli,COMPOSITE_LOCALE_EN_GB:dli,COMPOSITE_LOCALE_EN_US:sje,COMPOSITE_LOCALE_ES_ES:mli,COMPOSITE_LOCALE_ES_MX:fli,COMPOSITE_LOCALE_FI_FI:vli,COMPOSITE_LOCALE_FR_CA:Sli,COMPOSITE_LOCALE_FR_FR:yli,COMPOSITE_LOCALE_HE_IL:bli,COMPOSITE_LOCALE_IT_IT:Tli,COMPOSITE_LOCALE_JA_JP:Cli,COMPOSITE_LOCALE_KO_KR:_li,COMPOSITE_LOCALE_NB_NO:Eli,COMPOSITE_LOCALE_NL_NL:Ali,COMPOSITE_LOCALE_PL_PL:Ili,COMPOSITE_LOCALE_PT_BR:wli,COMPOSITE_LOCALE_RU_RU:kli,COMPOSITE_LOCALE_SV_SE:Rli,COMPOSITE_LOCALE_TR_TR:Mli,COMPOSITE_LOCALE_ZH_CN:Pli,COMPOSITE_LOCALE_ZH_TW:Dli};function E8e(t){const[e,i]=$.useState();return $.useEffect(()=>{if(!t)return;const r=Bli(t.i18n.selectedLanguage);i(r)},[t]),e}function Bli(t){const e=Pht(t).toUpperCase();let i=`COMPOSITE_LOCALE_${e}`;const r=Object.keys(_8e);return r.includes(i)||(i=r.find(o=>o.startsWith(`COMPOSITE_LOCALE_${e}_`))??xli),_8e[i]}function A8e(){const t=oPe();return $.useMemo(()=>t?T8:EZ,[t])}function Fli({services:t}){const[e,i]=Lli(t),r=E8e(t),o=A8e();return e?Da.jsx("div",{className:"chat-panel",children:Da.jsx(fii,{adapter:e,options:{topic:!1},locale:r,fluentTheme:o})}):i?Da.jsx(FX,{message:i,action:t?.i18n.getString("chat.initialization_retry"),onAction:()=>t?.chat.getSettings(!0)}):Da.jsx(BX,{label:t?.i18n.getString("chat.initializing")})}function I8e(t){const[e,i]=$.useState();return $.useEffect(()=>{if(!t)return;const r=()=>{if(!t.display.isFullScreen){i("horizontal");return}const l=t.display.orientation==="landscape"?"vertical":"horizontal";i(l)},o=[t.display.on("orientation-change",r),t.display.on("full-screen-change",r)];return e||r(),()=>Vy.unsubscribe(o)},[e,t]),e}function K4(t){const[e,i]=$.useState();return $.useEffect(()=>{if(!t)return;const r=[t.bootstrap.onResourcesChange(o=>i(o??void 0))];return t.bootstrap.getResources(),()=>Vy.unsubscribe(r)},[t]),e}function Uli({services:t}){const e=zli(t),i=I8e(t);return e?Da.jsx("div",{className:`iframe-panel ${i}`,children:Da.jsx("iframe",{src:e})}):null}function zli(t){const e=K4(t);return $.useMemo(()=>e?.embeddedUrl,[e])}function w8e(t){const e=K4(t),i=C8e(t),[r,o]=$.useState(new Set);return $.useEffect(()=>{if(!t||!e||!i){o(new Set);return}const l=new Set;i.chatThreadId&&i.chatEndpoint&&l.add("chat"),e.embeddedUrl&&l.add("iframe"),e.pollsEnabled&&l.add("polls"),o(l)},[t,e,i]),r}function Vli(t){const[e,i]=$.useState(),[r,o]=$.useState();return $.useEffect(()=>{if(!t){i(void 0),o(void 0);return}const l=[t.poll.onPollListChange(d=>{o(d??void 0),i(d?void 0:t.i18n.getString("polls.initialization_error"))})];return t.poll.getPolls(),()=>Vy.unsubscribe(l)},[t]),{polls:r,error:e}}function $li({services:t,multiple:e,selected:i,text:r,votes:o,voters:l,revealVotes:d,enabled:h,onSelectionChange:p}){const g=Hli(d,o,t),f=g?Da.jsx(sle,{shape:"rounded",thickness:"large",value:o,max:l}):void 0;return Da.jsxs("div",{className:"answer",children:[Da.jsxs("div",{className:"top",children:[Da.jsx(oMe,{checked:i,size:"large",label:r,shape:e?"square":"circular",disabled:!h,onChange:(y,{checked:T})=>p(!!T)}),g&&Da.jsx(qEt,{children:g})]}),f]})}function Hli(t,e,i){return $.useMemo(()=>t&&i?`${e} ${i.i18n.getString("polls.votes")}`:void 0,[e,i,t])}function jli({services:t,poll:e,setVoteCastNotification:i}){const[r,o]=$.useState(!1),l=d=>Da.jsx($li,{services:t,text:d.text,multiple:e.multipleChoice,votes:d.votes,voters:d.voters,selected:d.selectedByOwnUser,revealVotes:e.answeredByOwnUser,enabled:!r,onSelectionChange:h=>Gli(t,e,d,h,o,i)},d.optionId);return Da.jsxs(ule,{className:"poll",appearance:"filled",children:[Da.jsx(WEt,{children:e.question}),e.answers.map(l)]})}async function Gli(t,e,i,r,o,l){if(t)try{o(!0),await t.poll.castVote(e,i,r),l("success")}catch{l("error")}finally{o(!1)}}function k8e({level:t,title:e,subtitle:i,automaticDismiss:r=!1,onDismiss:o}){return $.useEffect(()=>{let l;return clearTimeout(l),r&&(l=setTimeout(()=>{o()},3e3)),()=>clearTimeout(l)},[r,o]),Da.jsx(aPe,{animate:"both",children:Da.jsxs(FMe,{intent:t,children:[Da.jsxs($Me,{children:[Da.jsx(UMe,{children:e}),i]}),Da.jsx(VMe,{containerAction:Da.jsx(P5,{onClick:o,appearance:"transparent",icon:Da.jsx(tSt,{})})})]})})}function qli({services:t,polls:e}){const[i,r]=$.useState(),o=i?Da.jsx(k8e,{level:i,title:t?.i18n.getString(`polls.vote_${i}_title`),subtitle:t?.i18n.getString(`polls.vote_${i}_subtitle`),automaticDismiss:!0,onDismiss:()=>r(void 0)}):void 0,l=d=>Da.jsx(jli,{services:t,poll:d,setVoteCastNotification:r},d.id);return Da.jsxs("div",{className:"poll-list",children:[o,e.map(l)]})}const Wli={id:-1,text:"",lastEditedTimestamp:Date.now()};function Kli({services:t,options:e,onChange:i}){const[r,o]=$.useState([Wli]),l=(h,p)=>{const g=e.filter(y=>y.text===p.text&&y.id!==p.id),f=g.length&&g.every(y=>y.lastEditedTimestamp<p.lastEditedTimestamp);return Da.jsx(jH,{className:"option",validationMessage:f?t?.i18n.getString("polls.form.duplicated_option_error"):void 0,validationState:f?"error":void 0,children:Da.jsx(CK,{value:p.text,onChange:(y,{value:T})=>Jli(e,h,T,i)})},p.id)},d=(h,p)=>{const g=e.filter(y=>y.text===p.text&&y.id!==p.id),f=g.length&&g.every(y=>y.lastEditedTimestamp<p.lastEditedTimestamp);return Da.jsx(jH,{className:"option",validationMessage:f?t?.i18n.getString("polls.form.duplicated_option_error"):void 0,validationState:f?"error":void 0,children:Da.jsx(CK,{value:p.text,onChange:(y,{value:T})=>Qli(r,h,T,o),onBlur:()=>Zli(e,r,h,i,o)})},p.id)};return Da.jsxs("div",{children:[e.map((h,p)=>l(p,h)),r.map((h,p)=>d(p,h))]})}function Jli(t,e,i,r){Yli(t,e,i,r)}function Yli(t,e,i,r){const o=[...t];i?o[e]={...o[e],text:i,lastEditedTimestamp:Date.now()}:o.splice(e,1),r(o)}function Qli(t,e,i,r){const o=[...t];i||t.length<=1?o[e]={...o[e],text:i,lastEditedTimestamp:Date.now()}:o.splice(e,1),i&&t.length===1&&o.push({id:Date.now(),text:"",lastEditedTimestamp:Date.now()}),r(o)}function Zli(t,e,i,r,o){const l=e[i];if(!l?.text)return;const d=[...t,l];r(d);const h=[...e];h.splice(i,1),o(h)}const Xli={multipleChoice:!1,question:"",options:[]},eci={question:void 0,options:void 0};function tci({services:t,onClose:e}){const[i,r]=$.useState(Xli),[o,l]=$.useState(eci),[d,h]=$.useState(!1),[p,g]=$.useState(!0),f=d?Da.jsx(k8e,{level:"error",title:t?.i18n.getString("polls.create_error_title"),subtitle:t?.i18n.getString("polls.create_error_subtitle"),onDismiss:()=>h(!1)}):void 0;return Da.jsxs("div",{className:"poll-form full-height",children:[f,Da.jsxs("div",{className:"form",children:[Da.jsx(jH,{label:t?.i18n.getString("polls.form.question"),required:!0,validationMessage:o?.question,validationState:o?.question?"error":void 0,children:Da.jsx(CK,{value:i.question,onChange:(y,{value:T})=>nci(i,T,r,o,l)})}),Da.jsx(jH,{label:t?.i18n.getString("polls.form.options"),required:!0,validationMessage:o?.options,validationState:o?.options?"error":void 0,children:Da.jsx(Kli,{services:t,options:i.options,onChange:y=>ici(i,y,r,o,l)})}),Da.jsx(yMe,{label:t?.i18n.getString("polls.form.multiple_choice"),checked:i.multipleChoice,onChange:(y,{checked:T})=>aci(i,T,r)})]}),Da.jsxs("div",{className:"actions",children:[Da.jsx(P5,{className:"action",appearance:"secondary",onClick:e,children:t?.i18n.getString("polls.cancel")}),Da.jsx(P5,{className:"action",appearance:"primary",disabled:!p,onClick:()=>rci(t,i,l,h,g,e),children:t?.i18n.getString("polls.create")})]})]})}function ici(t,e,i,r,o){const l={...t,options:e};i(l),o({...r,options:void 0})}function nci(t,e,i,r,o){const l={...t,question:e};i(l),o({...r,question:void 0})}function aci(t,e,i){const r={...t,multipleChoice:e};i(r)}async function rci(t,e,i,r,o,l){const d=!e.question,h=e.options.length<1,p=e.options.some((T,C)=>e.options.findIndex(E=>E.text===T.text)!==C),g=h||p,f=h?t?.i18n.getString("polls.form.options_required_error"):void 0;if(i({question:d?t?.i18n.getString("polls.form.question_required_error"):void 0,options:f}),!d&&!g)try{r(!1),o(!1);const T={question:e.question,multipleChoice:e.multipleChoice,options:e.options.map(C=>C.text)};await t?.poll.createPoll(T),l()}catch{r(!0)}finally{o(!0)}}function oci({services:t}){const e=kK(),{polls:i,error:r}=Vli(t),[o,l]=$.useState(!1);if(r)return Da.jsx(FX,{message:r,action:t?.i18n.getString("polls.initialization_retry"),onAction:()=>t?.poll.getPolls()});if(!i)return Da.jsx(BX,{label:t?.i18n.getString("polls.initializing")});const d=o?Da.jsx(tci,{services:t,onClose:()=>l(!1)}):Da.jsxs(Da.Fragment,{children:[Da.jsx(qli,{services:t,polls:i}),Da.jsx(P5,{className:"create-button actions",appearance:"primary",onClick:()=>l(!0),children:t?.i18n.getString("polls.create_poll")})]});return Da.jsx(E5,{className:"polls-panel full-height",theme:e,children:d})}function sci({services:t,onMinWidthChange:e,onMaxWidthChange:i}){const r=w8e(t),o=$.useMemo(()=>lci(t,r),[t,r]);return Da.jsx(HAt,{tabs:o,onSelectedTabChange:l=>cci(l,e,i)})}function lci(t,e){const i={};return t&&(e.has("chat")&&(i.chat={id:"chat",name:t?.i18n.getString("chat.tab_name"),iconName:"Chat",children:Da.jsx(Fli,{services:t})}),e.has("iframe")&&(i.iframe={id:"iframe",name:t?.i18n.getString("iframe.tab_name"),iconName:"Board",children:Da.jsx(Uli,{services:t})}),e.has("polls")&&(i.polls={id:"polls",name:t?.i18n.getString("polls.tab_name"),iconName:"Poll",children:Da.jsx(oci,{services:t})})),i}function cci(t,e,i){switch(t){case"chat":case"polls":e(300),i(500);break;case"iframe":e(300),i(void 0);break}}class R8e extends Error{}class M8e{constructor(e){this.config=e}async get(e){const i=this.buildBackendUrl(e),r=await fetch(i,{method:"GET",redirect:"manual",credentials:"include"});return await this.convertResponseToObject(r)}async post(e,i){const r=this.buildBackendUrl(e),o=await fetch(r,{method:"POST",credentials:"include",headers:{"content-type":"application/json"},body:JSON.stringify(i)});return await this.convertResponseToObject(o)}buildBackendUrl(e){return this.config.backendUrl+e}async convertResponseToObject(e){if(!e)throw new Error("Request failed. No response");const i=`Failed to make request to ${e.url} (status ${e.status} - ${e.statusText})`;if(!e.ok&&e.status===409)throw new R8e(i);if(!e.ok&&e.status)throw new Error(i);return e?.body?await e.json():null}}class AP{constructor(e,i,r){this.name=e,this.backend=i,this.config=r,this.remoteName=`rtc-toolkit.${e}`}remoteName;error(e,i,r=!0){this.log("error",e,i,r)}warn(e,i,r=!0){this.log("warn",e,i,r)}info(e,i,r=!0){this.log("info",e,i,r)}debug(e,i,r=!0){this.log("debug",e,i,r)}log(e,i,r,o=!0){console[e](`[${this.name}] ${i}`,r),o&&this.backend.post(`/api/v1/eid/${this.config.eid}/log`,{msg:i,logName:this.remoteName,type:e,payload:r,context:{conversationId:this.config.conversationId,breakoutsSessionId:this.config.breakoutsSessionId,sponsorId:this.config.sponsorId}})}}class dci{constructor(e,i,r=new AP("ConnectionSettingsProvider",i,e),o=new Vy){this.config=e,this.backend=i,this.logger=r,this.eventEmitter=o}cachedSettings=void 0;onSettingsChange(e){return this.eventEmitter.addEventListener("settings-change",e)}dispose(){this.clearSettings()}async getSettings(e=!1){e&&this.clearSettings(),this.cachedSettings||(this.cachedSettings=this.fetchSettings());const i=await this.cachedSettings;return this.eventEmitter.emit("settings-change",i),i}async refreshToken(e){const i={acsUserId:e},r=await this.backend.post(`/api/v1/eid/${this.config.eid}/video-calls/connection-settings/refresh-token`,i);if(!r)throw new Error("Failed to refresh token");return r}clearSettings(){this.cachedSettings=void 0,this.eventEmitter.emit("settings-change",void 0)}async fetchSettings(e=1,i=5,r=1e3,o=5e3){if(e>i)return this.logger.error("Fetch settings retries exhausted"),null;this.logger.info(`Fetching settings. Attempt: ${e}/${i}`);try{const l={conversationId:this.config.conversationId,breakoutsSessionId:this.config.breakoutsSessionId,sponsorId:this.config.sponsorId};return await this.backend.post(`/api/v1/eid/${this.config.eid}/video-calls/connection-settings/build`,l)}catch(l){if(!(l instanceof R8e)||e>=i)return this.logger.error("Failed to fetch settings",l),null;const d=Math.floor(Math.random()*(o-r+1))+r;return this.logger.warn(`Failed to fetch settings but it can be retried. Waiting for ${d} ms`,l,!1),await new Promise(h=>setTimeout(h,d)),await this.fetchSettings(e+1)}}}class P8e{get backendUrl(){return""}get eid(){return this.pathParts.eid}get conversationId(){return this.pathParts.conversationId}get breakoutsSessionId(){return this.pathParts.breakoutsSessionId}get sponsorId(){return this.pathParts.sponsorId}get pathParts(){const e=window.location.pathname;let i,r,o,l;if(/^\/.+\/conversation\/.+$/.test(e))[,i,,r]=e.split("/");else if(/^\/.+\/view\/session\/.+$/.test(e))[,i,,,o]=e.split("/");else if(/^\/.+\/view\/sponsor\/.+$/.test(e))[,i,,,l]=e.split("/");else throw new Error(`Failed to parse path: ${e}`);return{eid:i,conversationId:r,breakoutsSessionId:o,sponsorId:l}}}class D8e{constructor(e,i=document,r=new Vy){this.logger=e,this.dom=i,this.eventEmitter=r,this.unsubscribers=[]}unsubscribers;targetElement;cachedBreadth;cachedTallness;cachedOrientation;get isFullScreen(){return this.targetElement?this.dom.fullscreenElement===this.targetElement:!1}get breadth(){return this.cachedBreadth}get tallness(){return this.cachedTallness}get orientation(){return this.cachedOrientation}get width(){return this.targetElement?.offsetWidth}get height(){return this.targetElement?.offsetHeight}init(e){this.targetElement=this.dom.querySelector(e)??void 0,this.assertTargetElementPresent(`Element selector ${e} not found`);const i=Lht(()=>this.determineDimensionValues(),300),r=new ResizeObserver(()=>i());r.observe(this.targetElement),this.unsubscribers.push(vIe(this.targetElement,"fullscreenchange",()=>this.handleFullScreenChange()),()=>r?.disconnect()),i(),this.logger.info("Initialized",void 0,!1)}dispose(){Vy.unsubscribe(this.unsubscribers),this.targetElement=void 0,this.cachedBreadth=void 0,this.cachedTallness=void 0,this.cachedOrientation=void 0,this.logger.info("Disposed",void 0,!1)}on(e,i){return this.eventEmitter.addEventListener(e,i)}async enterFullScreen(){this.assertTargetElementPresent("Cannot enter full-screen because service not initialized");try{this.targetElement.requestFullscreen()}catch(e){this.logger.error("Failed to enter full-screen",e)}}async exitFullScreen(){try{this.dom?.exitFullscreen()}catch(e){this.logger.error("Failed to exit full-screen",e)}}determineDimensionValues(){const e=this.determineBreadth();e!==this.cachedBreadth&&(this.cachedBreadth=e,this.logger.info(`New breadth: ${e}`,void 0,!1),this.eventEmitter.emit("breadth-change",this.cachedBreadth));const i=this.determineTallness();i!==this.cachedTallness&&(this.cachedTallness=i,this.logger.info(`New tallness: ${i}`,void 0,!1),this.eventEmitter.emit("tallness-change",this.cachedTallness));const r=this.determineOrientation();r!==this.cachedOrientation&&(this.cachedOrientation=r,this.logger.info(`New orientation: ${r}`,void 0,!1),this.eventEmitter.emit("orientation-change",this.cachedOrientation))}determineBreadth(){if(this.width!==void 0)return this.width>=1150?"wide":this.width>=606?"medium":"narrow"}determineTallness(){if(this.height!==void 0)return this.height<=768?"short":"tall"}determineOrientation(){if(!(this.width===void 0||this.height===void 0))return this.width>this.height?"landscape":"portrait"}handleFullScreenChange(){const e=this.isFullScreen?"Switched to full screen":"Switched to compact view";this.logger.info(e,void 0,!1),this.eventEmitter.emit("full-screen-change",this.isFullScreen)}assertTargetElementPresent(e){if(!this.targetElement)throw this.logger.error(e),new Error(e)}}class uci{windowI18nProvider;constructor(e=window){const i=e.APP.services;this.windowI18nProvider=i.i18n}getString(e){return this.windowI18nProvider?.("video-calls."+e)}get selectedLanguage(){return this.windowI18nProvider?.lang}}class hci{constructor(e=window){this.win=e}addSignalListener;removeSignalListener;sendSignal;addEventListener;removeEventListener;init(){const i=this.win.APP.services.webSockets;this.addSignalListener=i.addSignalListener.bind(i),this.removeSignalListener=i.removeSignalListener.bind(i),this.sendSignal=i.sendSignal.bind(i),this.addEventListener=i.addEventListener.bind(i),this.removeEventListener=i.removeEventListener.bind(i)}}class pci{constructor(e,i,r,o=new AP("BootstrapResourcesProvider",i,e),l=new Vy){this.config=e,this.backend=i,this.signalProvider=r,this.logger=o,this.eventEmitter=l}cachedResources=null;unsubscribers=[];onResourcesChange(e){return this.eventEmitter.addEventListener("resources-change",e)}async init(){await this.getResources();const e=await this.cachedResources;this.unsubscribers.push(this.signalProvider.addEventListener?.("open",()=>this.getResources()),await this.signalProvider.addSignalListener?.(`video-call/${e?.videoCallId}/bootstrap-resources/updated`,i=>this.onResourcesUpdateReceived(i.resources))),this.logger.info("Initialized",{resources:e})}dispose(){Vy.unsubscribe(this.unsubscribers),this.unsubscribers=[],this.cachedResources=null}async getResources(e=!1){e&&(this.cachedResources=null),this.cachedResources||(this.cachedResources=this.fetchResources());const i=await this.cachedResources;return this.eventEmitter.emit("resources-change",i),i}async fetchResources(){this.logger.info("Fetching resources");try{const e={conversationId:this.config.conversationId,breakoutsSessionId:this.config.breakoutsSessionId,sponsorId:this.config.sponsorId};return await this.backend.post(`/api/v1/eid/${this.config.eid}/video-calls/bootstrap`,e)}catch(e){return this.logger.error("Failed to fetch resources",e),null}}async onResourcesUpdateReceived(e){const i=await this.cachedResources;i&&e.version<=i?.version&&this.logger.warn("Received outdated resources",{oldResources:i,resources:e}),this.logger.info("Received updated resources",e),this.cachedResources=Promise.resolve(e),this.eventEmitter.emit("resources-change",e)}}class gci{constructor(e,i,r){this.definition=e,this.ownUserId=i,this.ownUserName=r}cachedAnswers=void 0;get id(){return this.definition.id}get version(){return this.definition.version}get question(){return this.definition.question}get multipleChoice(){return this.definition.multipleChoice}get createdTimestampSecs(){return this.definition.createdTimestampSecs}get answeredByOwnUser(){return this.answers.some(e=>e.selectedByOwnUser===!0)}get answers(){return this.cachedAnswers||this.buildAnswersFromDefinition(),this.cachedAnswers}vote(e){this.multipleChoice||(this.definition.votes=mci(this.definition.votes,this.ownUserId)),this.definition.votes.push({optionId:e.optionId,userId:this.ownUserId,userName:this.ownUserName}),this.buildAnswersFromDefinition()}unvote(e){const r=this.definition.votes.filter(o=>o.userId!==this.ownUserId||o.optionId!==e.optionId);this.definition.votes=r,this.buildAnswersFromDefinition()}buildAnswersFromDefinition(){this.cachedAnswers=this.definition.options.map(e=>({optionId:e.id,text:e.text,votes:this.definition.votes.filter(i=>i.optionId===e.id).length,voters:Fht(this.definition.votes,i=>i.userId).length,selectedByOwnUser:this.definition.votes.some(i=>i.userId===this.ownUserId&&i.optionId===e.id)}))}}function mci(t,e){return t.filter(i=>i.userId!==e)}class fci{constructor(e,i,r,o,l,d=new AP("PollService",o,r),h=new Vy){this.connectionSettingsProvider=e,this.bootstrapResourcesProvider=i,this.config=r,this.backend=o,this.signalProvider=l,this.logger=d,this.eventEmitter=h}ownUserId;ownUserName;videoCallId;unsubscribers=[];cachedPollList;onPollListChange(e){return this.eventEmitter.addEventListener("poll-list-change",e)}async init(){this.videoCallId=(await this.bootstrapResourcesProvider.getResources())?.videoCallId,this.unsubscribers.push(this.connectionSettingsProvider.onSettingsChange(i=>this.ownUserId=i?.userId),this.signalProvider.addEventListener?.("open",()=>this.getPolls()),await this.signalProvider.addSignalListener?.(`video-call/${this.videoCallId}/poll/created`,i=>this.onCreatedPollReceived(i?.poll)),await this.signalProvider.addSignalListener?.(`video-call/${this.videoCallId}/poll/updated`,i=>this.onUpdatedPollReceived(i?.poll)));const e=await this.connectionSettingsProvider.getSettings();this.ownUserId=e?.userId,this.ownUserName=e?.displayName,this.logger.info("Initialized",{videoCallId:this.videoCallId,ownUserId:this.ownUserId})}dispose(){Vy.unsubscribe(this.unsubscribers),this.unsubscribers=[],this.ownUserName=void 0,this.videoCallId=void 0,this.cachedPollList=void 0,this.ownUserId=void 0}async getPolls(){this.logger.info("Getting polls");let e,i=await this.backend.get(`/api/v1/eid/${this.config.eid}/video-calls/video-call/${this.videoCallId}/polls`).catch(r=>e=r);i?this.logger.info(`Obtained ${i.length} polls`):(this.logger.error("Failed to get polls",e),i=null),this.updatePollList({polls:i})}async createPoll(e){this.logger.info("Creating poll",{poll:e});try{const i=await this.backend.post(`/api/v1/eid/${this.config.eid}/video-calls/video-call/${this.videoCallId}/polls`,e);if(!i)throw new Error("Poll is null");this.logger.info(`Poll created with ID: ${i.id}`),this.updatePollList({poll:i})}catch(i){throw this.logger.error("Failed to create poll",i),i}}async castVote(e,i,r){this.logger.info(`Setting vote for poll ${e.id}`,{answer:i,selected:r}),await this.backend.post(`/api/v1/eid/${this.config.eid}/video-calls/video-call/${this.videoCallId}/poll/${e.id}/vote`,{optionId:i.optionId,selected:r}).catch(o=>{throw this.logger.error(`Failed to cast vote for poll ${e.id}`,o),o}),r?e.vote(i):e.unvote(i),this.updatePollList({poll:e.definition})}updatePollList({polls:e,poll:i}){if(e!==void 0){const r=vci(e,this.ownUserId,this.ownUserName);this.cachedPollList=r?fIe(r,o=>o.createdTimestampSecs):null}else if(i){const r=L8e(i,this.ownUserId,this.ownUserName),o=yci(this.cachedPollList??[],r);this.cachedPollList=fIe(o,l=>l.createdTimestampSecs)}this.logger.debug(`Emitting internal poll list with ${this.cachedPollList?.length} polls`,void 0,!1),this.eventEmitter.emit("poll-list-change",this.cachedPollList)}onCreatedPollReceived(e){this.logger.info(`Received created poll with ID ${e.id} and version ${e.version}`),this.updatePollList({poll:e})}onUpdatedPollReceived(e){this.logger.info(`Received updated poll with ID ${e.id} and version ${e.version}`),this.updatePollList({poll:e})}}function vci(t,e,i){return t?t.map(r=>L8e(r,e,i)):null}function L8e(t,e,i){return new gci(t,e??"",i??"")}function yci(t,e){const i=t.find(r=>r.id===e.id);if(i){if(i.version>=e.version)return t;t=t.filter(o=>o.id!==i.id)}return[...t,e]}class Sci{constructor(e,i,r,o,l=new AP("ChatService",i,e),d=new Vy){this.config=e,this.backend=i,this.bootstrapResourcesProvider=r,this.signalProvider=o,this.logger=l,this.eventEmitter=d}cachedSettings=void 0;videoCallId;unsubscribers=[];onSettingsChange(e){return this.eventEmitter.addEventListener("settings-change",e)}async init(){this.videoCallId=(await this.bootstrapResourcesProvider.getResources())?.videoCallId,this.unsubscribers.push(this.signalProvider.addEventListener?.("open",()=>this.getSettings(!0)),await this.signalProvider.addSignalListener?.(`video-call/${this.videoCallId}/chat/updated`,e=>this.onChatUpdateReceived(e.enabled))),this.logger.info("Initialized",{videoCallId:this.videoCallId})}dispose(){Vy.unsubscribe(this.unsubscribers),this.unsubscribers=[],this.videoCallId=void 0,this.cachedSettings=void 0}async getSettings(e=!1){e&&this.clearSettings(),this.cachedSettings||(this.cachedSettings=this.connectToChat());const i=await this.cachedSettings;return this.eventEmitter.emit("settings-change",i),i}clearSettings(){this.cachedSettings=void 0,this.eventEmitter.emit("settings-change",void 0)}async connectToChat(e=1){this.logger.info("Connecting to chat");try{const i=await this.backend.post(`/api/v1/eid/${this.config.eid}/video-calls/video-call/${this.videoCallId}/chat/connect`);return i?.chatThreadId?this.logger.info("Connected to chat",i):this.logger.info("No chat thread ID found"),i}catch(i){if(this.logger.error("Failed to connect",i),e>0){const r=Math.floor(Math.random()*3e3);return await new Promise(o=>setTimeout(o,5*1e3+r)),this.connectToChat(e-1)}return null}}onChatUpdateReceived(e){this.logger.info("Chat update received",{enabled:e}),e?this.getSettings(!0):this.clearSettings()}}const IP=new P8e,qO=new M8e(IP),UX=new hci,O8e=new dci(IP,qO),Wfe=new pci(IP,qO,UX);function bci(){return{bootstrap:Wfe,display:new D8e(new AP("DisplayService",qO,IP)),connectionSettings:O8e,chat:new Sci(IP,qO,Wfe,UX),i18n:new uci,logging:{call:new AP("Call",qO,IP),chat:new AP("Chat",qO,IP),window:new AP("Window",qO,IP)},poll:new fci(O8e,Wfe,IP,qO,UX)}}async function Tci(t,{rootElementSelector:e}){UX.init(),await t.bootstrap.init(),t.display.init(e),await t.chat.init(),await t.poll.init()}function Cci(t){t.display.dispose(),t.poll.dispose(),t.chat.dispose(),t.bootstrap.dispose(),t.connectionSettings.dispose()}function _ci(t){const e=w8e(t),i=K4(t);return $.useMemo(()=>i?.i18nErrorKey?!1:!!e.size,[e,i])}function Eci(t){const[e,i]=$.useState();return $.useEffect(()=>{if(!t)return;const r=t.display.breadth==="narrow"?"mobile":"desktop";i(r)},[t]),e}function Aci(t){const[e,i]=$.useState(),r=Ici(t,i),o=oli(r);return $.useEffect(()=>{const l=()=>t?.display.exitFullScreen(),d=()=>{o?.off("callEnded",l)};return d(),o&&o.on("callEnded",l),()=>d()},[o,t]),[o,e]}function Ici(t,e){const i=b8e(t);return $.useMemo(()=>wci(t,i,e),[i,t,e])}function wci(t,e,i){if(!t||e===void 0)return i(void 0),{};if(e===null)return i(t.i18n.getString("call.initialization_error")),{};const{token:r,userId:o,displayName:l,callType:d,callId:h}=e,p=T8e(t.logging.call,t,o,r);p||i(t.i18n.getString("call.initialization_error"));const g=d==="conversation"?{groupId:h}:{roomId:h};return{userId:tj(o),displayName:l,credential:p,locator:g}}function kci(t){const[e,i]=$.useState();return $.useEffect(()=>{const r=new P8e,o=new M8e(r),l=new D8e(new AP("CallDisplayService",o,r));return l.init(`.${t}`),i(l),()=>l.dispose()},[t]),e}function Rci(t){const[e,i]=$.useState();return $.useEffect(()=>{if(!t)return;const r=()=>{const l=t.breadth==="wide"?"default":"compact";i(l)},o=[t.on("breadth-change",r)];return r(),()=>Vy.unsubscribe(o)},[t]),e}function Mci(t){const e=K4(t);return $.useMemo(()=>e?.captionsEnabled??!1,[e])}const N8e="call";function Pci({services:t}){return Da.jsx("div",{className:N8e,children:Da.jsx(Dci,{services:t})})}function Dci({services:t}){const e=kci(N8e),i=_oe(t),r=Eci(t),o=Rci(e),[l,d]=Aci(t),h=E8e(t),p=Mci(t),g=A8e(),f=$.useMemo(()=>Lci(t,i),[t,i]),y=$.useMemo(()=>({callControls:{onFetchCustomButtonProps:f,displayType:o,captionsButton:p,holdButton:!1}}),[f,o,p]);return $.useEffect(()=>(t?.logging.call.info("Component mounted"),()=>t?.logging.call.info("Component unmounted")),[t]),l?Da.jsx(Hsi,{formFactor:r,adapter:l,locale:h,options:y,fluentTheme:g}):d?Da.jsx(FX,{message:d,action:t?.i18n.getString("call.initialization_retry"),onAction:()=>t?.connectionSettings.getSettings(!0)}):Da.jsx(BX,{label:t?.i18n.getString("call.initializing")})}function Lci(t,e){return t?[()=>({id:"full-screen-button",placement:"secondary",disabled:!1,iconName:e?"BackToWindow":"FullScreen",onItemClick:()=>e?t.display.exitFullScreen():t.display.enterFullScreen(),strings:{label:e?t.i18n.getString("call.full_screen.exit_button"):t.i18n.getString("call.full_screen.enter_button"),tooltipContent:e?t.i18n.getString("call.full_screen.exit_tooltip"):t.i18n.getString("call.full_screen.enter_tooltip")}})]:[]}function Oci(t){const[e,i]=$.useState(document.visibilityState==="visible");return $.useEffect(()=>{const r=vIe(document,"visibilitychange",()=>i(document.visibilityState==="visible"));return()=>r?.()},[]),$.useEffect(()=>{t&&t.logging.window.info(`Tab is ${e?"active":"inactive"}`)}),e}const zX="root.bootstrap_error_before_start_time",Nci="root.bootstrap_error_before_start_time_action";function xci({services:t}){const e=K4(t),i=Bci(t,e),r=Fci(i,t,e),o=Uci(i,t,e);if(e?.i18nErrorKey)return Da.jsx(FX,{message:o,action:r,onAction:()=>zci(t,e.i18nErrorKey)})}function Bci(t,e){const[i,r]=$.useState(!1),o=Oci(t);return $.useEffect(()=>{if(!e?.scheduledStartTimestampSecs||e?.i18nErrorKey!==zX)return;let l;const d=Math.floor(Date.now()/1e3),h=e.scheduledStartTimestampSecs-d;if(h<=0){r(!0),clearTimeout(l);return}return l=setTimeout(()=>{r(!0)},h*1e3),()=>clearTimeout(l)},[e,o]),i}function Fci(t,e,i){return $.useMemo(()=>{if(!(!e||!t))return i?.i18nErrorKey===zX?e?.i18n.getString(Nci):void 0},[e,i,t])}function Uci(t,e,i){return $.useMemo(()=>{if(!(!e||!i?.i18nErrorKey)){if(i?.i18nErrorKey!==zX)return e?.i18n.getString(i.i18nErrorKey);if(!t)return e?.i18n.getString(i.i18nErrorKey)}},[e,i,t])}function zci(t,e){e===zX&&t?.bootstrap.getResources(!0)}const x8e="breakouts-app";Mot();function B8e(){return Da.jsx("div",{className:x8e,children:Da.jsx(Vci,{})})}function Vci(){const t=$ci(),e=_ci(t),i=I8e(t),r=K4(t),o=_oe(t),[l,d]=$.useState(),[h,p]=$.useState(),g=e?{key:"complements",minSizePx:l,maxSizePx:h,preferredSizePx:o?h:l,component:Da.jsx(sci,{services:t,onMinWidthChange:d,onMaxWidthChange:p})}:void 0,f=[{key:"call",component:Da.jsx(Pci,{services:t}),minSizePx:o?650:350}];return g&&f.push(g),Da.jsx("div",{className:`
                content
                ${o?"full-screen":""}
                ${e?"has-complements":""}
            `,children:Hci(r,t,f,i)})}function $ci(){const[t,e]=$.useState();return $.useEffect(()=>{const i=bci();return Tci(i,{rootElementSelector:`.${x8e}`}).then(()=>e(i)),()=>Cci(i)},[]),t}function Hci(t,e,i,r){return t?.i18nErrorKey?Da.jsx(xci,{services:e}):r?Da.jsx(Uht,{services:e,dividerDirection:r,paneConfigs:i}):Da.jsx(BX,{label:e?.i18n.getString("root.initializing")})}customElements.define("spotme-rtc-breakouts",nZe(B8e)),iT.BreakoutsApp=B8e,Object.defineProperty(iT,Symbol.toStringTag,{value:"Module"})});

}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],require("timers").setImmediate)
},{"_process":1185,"buffer":570,"timers":1216}],1105:[function(require,module,exports){
(function (global,setImmediate){(function (){
(function(){var t={7679:function(t,e){var i,s,n;(function(r,o){s=[],i=o,n="function"===typeof i?i.apply(e,s):i,void 0===n||(t.exports=n)})("undefined"!==typeof self&&self,(function(){function t(){var e=Object.getOwnPropertyDescriptor(document,"currentScript");if(!e&&"currentScript"in document&&document.currentScript)return document.currentScript;if(e&&e.get!==t&&document.currentScript)return document.currentScript;try{throw new Error}catch(p){var i,s,n,r=/.*at [^(]*\((.*):(.+):(.+)\)$/gi,o=/@([^@]*):(\d+):(\d+)\s*$/gi,a=r.exec(p.stack)||o.exec(p.stack),l=a&&a[1]||!1,c=a&&a[2]||!1,d=document.location.href.replace(document.location.hash,""),u=document.getElementsByTagName("script");l===d&&(i=document.documentElement.outerHTML,s=new RegExp("(?:[^\\n]+?\\n){0,"+(c-2)+"}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*","i"),n=i.replace(s,"$1").trim());for(var h=0;h<u.length;h++){if("interactive"===u[h].readyState)return u[h];if(u[h].src===l)return u[h];if(l===d&&u[h].innerHTML&&u[h].innerHTML.trim()===n)return u[h]}return null}}return t}))},8833:function(t,e,i){"use strict";i.r(e);var s=i(6190),n={};for(var r in s)"default"!==r&&(n[r]=function(t){return s[t]}.bind(0,r));i.d(e,n)},2212:function(t,e,i){"use strict";i.r(e);var s=i(2061),n={};for(var r in s)"default"!==r&&(n[r]=function(t){return s[t]}.bind(0,r));i.d(e,n)},9662:function(t,e,i){var s=i(614),n=i(6330),r=TypeError;t.exports=function(t){if(s(t))return t;throw r(n(t)+" is not a function")}},9670:function(t,e,i){var s=i(111),n=String,r=TypeError;t.exports=function(t){if(s(t))return t;throw r(n(t)+" is not an object")}},1318:function(t,e,i){var s=i(5656),n=i(1400),r=i(6244),o=function(t){return function(e,i,o){var a,l=s(e),c=r(l),d=n(o,c);if(t&&i!=i){while(c>d)if(a=l[d++],a!=a)return!0}else for(;c>d;d++)if((t||d in l)&&l[d]===i)return t||d||0;return!t&&-1}};t.exports={includes:o(!0),indexOf:o(!1)}},3658:function(t,e,i){"use strict";var s=i(9781),n=i(3157),r=TypeError,o=Object.getOwnPropertyDescriptor,a=s&&!function(){if(void 0!==this)return!0;try{Object.defineProperty([],"length",{writable:!1}).length=1}catch(t){return t instanceof TypeError}}();t.exports=a?function(t,e){if(n(t)&&!o(t,"length").writable)throw r("Cannot set read only .length");return t.length=e}:function(t,e){return t.length=e}},4326:function(t,e,i){var s=i(84),n=s({}.toString),r=s("".slice);t.exports=function(t){return r(n(t),8,-1)}},9920:function(t,e,i){var s=i(2597),n=i(3887),r=i(1236),o=i(3070);t.exports=function(t,e,i){for(var a=n(e),l=o.f,c=r.f,d=0;d<a.length;d++){var u=a[d];s(t,u)||i&&s(i,u)||l(t,u,c(e,u))}}},8880:function(t,e,i){var s=i(9781),n=i(3070),r=i(9114);t.exports=s?function(t,e,i){return n.f(t,e,r(1,i))}:function(t,e,i){return t[e]=i,t}},9114:function(t){t.exports=function(t,e){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}}},8052:function(t,e,i){var s=i(614),n=i(3070),r=i(6339),o=i(3072);t.exports=function(t,e,i,a){a||(a={});var l=a.enumerable,c=void 0!==a.name?a.name:e;if(s(i)&&r(i,c,a),a.global)l?t[e]=i:o(e,i);else{try{a.unsafe?t[e]&&(l=!0):delete t[e]}catch(d){}l?t[e]=i:n.f(t,e,{value:i,enumerable:!1,configurable:!a.nonConfigurable,writable:!a.nonWritable})}return t}},3072:function(t,e,i){var s=i(7854),n=Object.defineProperty;t.exports=function(t,e){try{n(s,t,{value:e,configurable:!0,writable:!0})}catch(i){s[t]=e}return e}},9781:function(t,e,i){var s=i(7293);t.exports=!s((function(){return 7!=Object.defineProperty({},1,{get:function(){return 7}})[1]}))},4154:function(t){var e="object"==typeof document&&document.all,i="undefined"==typeof e&&void 0!==e;t.exports={all:e,IS_HTMLDDA:i}},317:function(t,e,i){var s=i(7854),n=i(111),r=s.document,o=n(r)&&n(r.createElement);t.exports=function(t){return o?r.createElement(t):{}}},7207:function(t){var e=TypeError,i=9007199254740991;t.exports=function(t){if(t>i)throw e("Maximum allowed index exceeded");return t}},8113:function(t,e,i){var s=i(5005);t.exports=s("navigator","userAgent")||""},7392:function(t,e,i){var s,n,r=i(7854),o=i(8113),a=r.process,l=r.Deno,c=a&&a.versions||l&&l.version,d=c&&c.v8;d&&(s=d.split("."),n=s[0]>0&&s[0]<4?1:+(s[0]+s[1])),!n&&o&&(s=o.match(/Edge\/(\d+)/),(!s||s[1]>=74)&&(s=o.match(/Chrome\/(\d+)/),s&&(n=+s[1]))),t.exports=n},748:function(t){t.exports=["constructor","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","toLocaleString","toString","valueOf"]},2109:function(t,e,i){var s=i(7854),n=i(1236).f,r=i(8880),o=i(8052),a=i(3072),l=i(9920),c=i(4705);t.exports=function(t,e){var i,d,u,h,p,f,m=t.target,v=t.global,g=t.stat;if(d=v?s:g?s[m]||a(m,{}):(s[m]||{}).prototype,d)for(u in e){if(p=e[u],t.dontCallGetSet?(f=n(d,u),h=f&&f.value):h=d[u],i=c(v?u:m+(g?".":"#")+u,t.forced),!i&&void 0!==h){if(typeof p==typeof h)continue;l(p,h)}(t.sham||h&&h.sham)&&r(p,"sham",!0),o(d,u,p,t)}}},7293:function(t){t.exports=function(t){try{return!!t()}catch(e){return!0}}},4374:function(t,e,i){var s=i(7293);t.exports=!s((function(){var t=function(){}.bind();return"function"!=typeof t||t.hasOwnProperty("prototype")}))},6916:function(t,e,i){var s=i(4374),n=Function.prototype.call;t.exports=s?n.bind(n):function(){return n.apply(n,arguments)}},6530:function(t,e,i){var s=i(9781),n=i(2597),r=Function.prototype,o=s&&Object.getOwnPropertyDescriptor,a=n(r,"name"),l=a&&"something"===function(){}.name,c=a&&(!s||s&&o(r,"name").configurable);t.exports={EXISTS:a,PROPER:l,CONFIGURABLE:c}},84:function(t,e,i){var s=i(4374),n=Function.prototype,r=n.call,o=s&&n.bind.bind(r,r);t.exports=function(t){return s?o(t):function(){return r.apply(t,arguments)}}},1702:function(t,e,i){var s=i(4326),n=i(84);t.exports=function(t){if("Function"===s(t))return n(t)}},5005:function(t,e,i){var s=i(7854),n=i(614),r=function(t){return n(t)?t:void 0};t.exports=function(t,e){return arguments.length<2?r(s[t]):s[t]&&s[t][e]}},8173:function(t,e,i){var s=i(9662),n=i(8554);t.exports=function(t,e){var i=t[e];return n(i)?void 0:s(i)}},7854:function(t,e,i){var s=function(t){return t&&t.Math==Math&&t};t.exports=s("object"==typeof globalThis&&globalThis)||s("object"==typeof window&&window)||s("object"==typeof self&&self)||s("object"==typeof i.g&&i.g)||function(){return this}()||Function("return this")()},2597:function(t,e,i){var s=i(1702),n=i(7908),r=s({}.hasOwnProperty);t.exports=Object.hasOwn||function(t,e){return r(n(t),e)}},3501:function(t){t.exports={}},4664:function(t,e,i){var s=i(9781),n=i(7293),r=i(317);t.exports=!s&&!n((function(){return 7!=Object.defineProperty(r("div"),"a",{get:function(){return 7}}).a}))},8361:function(t,e,i){var s=i(1702),n=i(7293),r=i(4326),o=Object,a=s("".split);t.exports=n((function(){return!o("z").propertyIsEnumerable(0)}))?function(t){return"String"==r(t)?a(t,""):o(t)}:o},2788:function(t,e,i){var s=i(1702),n=i(614),r=i(5465),o=s(Function.toString);n(r.inspectSource)||(r.inspectSource=function(t){return o(t)}),t.exports=r.inspectSource},9909:function(t,e,i){var s,n,r,o=i(4811),a=i(7854),l=i(111),c=i(8880),d=i(2597),u=i(5465),h=i(6200),p=i(3501),f="Object already initialized",m=a.TypeError,v=a.WeakMap,g=function(t){return r(t)?n(t):s(t,{})},y=function(t){return function(e){var i;if(!l(e)||(i=n(e)).type!==t)throw m("Incompatible receiver, "+t+" required");return i}};if(o||u.state){var b=u.state||(u.state=new v);b.get=b.get,b.has=b.has,b.set=b.set,s=function(t,e){if(b.has(t))throw m(f);return e.facade=t,b.set(t,e),e},n=function(t){return b.get(t)||{}},r=function(t){return b.has(t)}}else{var w=h("state");p[w]=!0,s=function(t,e){if(d(t,w))throw m(f);return e.facade=t,c(t,w,e),e},n=function(t){return d(t,w)?t[w]:{}},r=function(t){return d(t,w)}}t.exports={set:s,get:n,has:r,enforce:g,getterFor:y}},3157:function(t,e,i){var s=i(4326);t.exports=Array.isArray||function(t){return"Array"==s(t)}},614:function(t,e,i){var s=i(4154),n=s.all;t.exports=s.IS_HTMLDDA?function(t){return"function"==typeof t||t===n}:function(t){return"function"==typeof t}},4705:function(t,e,i){var s=i(7293),n=i(614),r=/#|\.prototype\./,o=function(t,e){var i=l[a(t)];return i==d||i!=c&&(n(e)?s(e):!!e)},a=o.normalize=function(t){return String(t).replace(r,".").toLowerCase()},l=o.data={},c=o.NATIVE="N",d=o.POLYFILL="P";t.exports=o},8554:function(t){t.exports=function(t){return null===t||void 0===t}},111:function(t,e,i){var s=i(614),n=i(4154),r=n.all;t.exports=n.IS_HTMLDDA?function(t){return"object"==typeof t?null!==t:s(t)||t===r}:function(t){return"object"==typeof t?null!==t:s(t)}},1913:function(t){t.exports=!1},2190:function(t,e,i){var s=i(5005),n=i(614),r=i(7976),o=i(3307),a=Object;t.exports=o?function(t){return"symbol"==typeof t}:function(t){var e=s("Symbol");return n(e)&&r(e.prototype,a(t))}},6244:function(t,e,i){var s=i(7466);t.exports=function(t){return s(t.length)}},6339:function(t,e,i){var s=i(7293),n=i(614),r=i(2597),o=i(9781),a=i(6530).CONFIGURABLE,l=i(2788),c=i(9909),d=c.enforce,u=c.get,h=Object.defineProperty,p=o&&!s((function(){return 8!==h((function(){}),"length",{value:8}).length})),f=String(String).split("String"),m=t.exports=function(t,e,i){"Symbol("===String(e).slice(0,7)&&(e="["+String(e).replace(/^Symbol\(([^)]*)\)/,"$1")+"]"),i&&i.getter&&(e="get "+e),i&&i.setter&&(e="set "+e),(!r(t,"name")||a&&t.name!==e)&&(o?h(t,"name",{value:e,configurable:!0}):t.name=e),p&&i&&r(i,"arity")&&t.length!==i.arity&&h(t,"length",{value:i.arity});try{i&&r(i,"constructor")&&i.constructor?o&&h(t,"prototype",{writable:!1}):t.prototype&&(t.prototype=void 0)}catch(n){}var s=d(t);return r(s,"source")||(s.source=f.join("string"==typeof e?e:"")),t};Function.prototype.toString=m((function(){return n(this)&&u(this).source||l(this)}),"toString")},4758:function(t){var e=Math.ceil,i=Math.floor;t.exports=Math.trunc||function(t){var s=+t;return(s>0?i:e)(s)}},3070:function(t,e,i){var s=i(9781),n=i(4664),r=i(3353),o=i(9670),a=i(4948),l=TypeError,c=Object.defineProperty,d=Object.getOwnPropertyDescriptor,u="enumerable",h="configurable",p="writable";e.f=s?r?function(t,e,i){if(o(t),e=a(e),o(i),"function"===typeof t&&"prototype"===e&&"value"in i&&p in i&&!i[p]){var s=d(t,e);s&&s[p]&&(t[e]=i.value,i={configurable:h in i?i[h]:s[h],enumerable:u in i?i[u]:s[u],writable:!1})}return c(t,e,i)}:c:function(t,e,i){if(o(t),e=a(e),o(i),n)try{return c(t,e,i)}catch(s){}if("get"in i||"set"in i)throw l("Accessors not supported");return"value"in i&&(t[e]=i.value),t}},1236:function(t,e,i){var s=i(9781),n=i(6916),r=i(5296),o=i(9114),a=i(5656),l=i(4948),c=i(2597),d=i(4664),u=Object.getOwnPropertyDescriptor;e.f=s?u:function(t,e){if(t=a(t),e=l(e),d)try{return u(t,e)}catch(i){}if(c(t,e))return o(!n(r.f,t,e),t[e])}},8006:function(t,e,i){var s=i(6324),n=i(748),r=n.concat("length","prototype");e.f=Object.getOwnPropertyNames||function(t){return s(t,r)}},5181:function(t,e){e.f=Object.getOwnPropertySymbols},7976:function(t,e,i){var s=i(1702);t.exports=s({}.isPrototypeOf)},6324:function(t,e,i){var s=i(1702),n=i(2597),r=i(5656),o=i(1318).indexOf,a=i(3501),l=s([].push);t.exports=function(t,e){var i,s=r(t),c=0,d=[];for(i in s)!n(a,i)&&n(s,i)&&l(d,i);while(e.length>c)n(s,i=e[c++])&&(~o(d,i)||l(d,i));return d}},5296:function(t,e){"use strict";var i={}.propertyIsEnumerable,s=Object.getOwnPropertyDescriptor,n=s&&!i.call({1:2},1);e.f=n?function(t){var e=s(this,t);return!!e&&e.enumerable}:i},2140:function(t,e,i){var s=i(6916),n=i(614),r=i(111),o=TypeError;t.exports=function(t,e){var i,a;if("string"===e&&n(i=t.toString)&&!r(a=s(i,t)))return a;if(n(i=t.valueOf)&&!r(a=s(i,t)))return a;if("string"!==e&&n(i=t.toString)&&!r(a=s(i,t)))return a;throw o("Can't convert object to primitive value")}},3887:function(t,e,i){var s=i(5005),n=i(1702),r=i(8006),o=i(5181),a=i(9670),l=n([].concat);t.exports=s("Reflect","ownKeys")||function(t){var e=r.f(a(t)),i=o.f;return i?l(e,i(t)):e}},4488:function(t,e,i){var s=i(8554),n=TypeError;t.exports=function(t){if(s(t))throw n("Can't call method on "+t);return t}},6200:function(t,e,i){var s=i(2309),n=i(9711),r=s("keys");t.exports=function(t){return r[t]||(r[t]=n(t))}},5465:function(t,e,i){var s=i(7854),n=i(3072),r="__core-js_shared__",o=s[r]||n(r,{});t.exports=o},2309:function(t,e,i){var s=i(1913),n=i(5465);(t.exports=function(t,e){return n[t]||(n[t]=void 0!==e?e:{})})("versions",[]).push({version:"3.25.5",mode:s?"pure":"global",copyright:"© 2014-2022 Denis Pushkarev (zloirock.ru)",license:"https://github.com/zloirock/core-js/blob/v3.25.5/LICENSE",source:"https://github.com/zloirock/core-js"})},6293:function(t,e,i){var s=i(7392),n=i(7293);t.exports=!!Object.getOwnPropertySymbols&&!n((function(){var t=Symbol();return!String(t)||!(Object(t)instanceof Symbol)||!Symbol.sham&&s&&s<41}))},1400:function(t,e,i){var s=i(9303),n=Math.max,r=Math.min;t.exports=function(t,e){var i=s(t);return i<0?n(i+e,0):r(i,e)}},5656:function(t,e,i){var s=i(8361),n=i(4488);t.exports=function(t){return s(n(t))}},9303:function(t,e,i){var s=i(4758);t.exports=function(t){var e=+t;return e!==e||0===e?0:s(e)}},7466:function(t,e,i){var s=i(9303),n=Math.min;t.exports=function(t){return t>0?n(s(t),9007199254740991):0}},7908:function(t,e,i){var s=i(4488),n=Object;t.exports=function(t){return n(s(t))}},7593:function(t,e,i){var s=i(6916),n=i(111),r=i(2190),o=i(8173),a=i(2140),l=i(5112),c=TypeError,d=l("toPrimitive");t.exports=function(t,e){if(!n(t)||r(t))return t;var i,l=o(t,d);if(l){if(void 0===e&&(e="default"),i=s(l,t,e),!n(i)||r(i))return i;throw c("Can't convert object to primitive value")}return void 0===e&&(e="number"),a(t,e)}},4948:function(t,e,i){var s=i(7593),n=i(2190);t.exports=function(t){var e=s(t,"string");return n(e)?e:e+""}},6330:function(t){var e=String;t.exports=function(t){try{return e(t)}catch(i){return"Object"}}},9711:function(t,e,i){var s=i(1702),n=0,r=Math.random(),o=s(1..toString);t.exports=function(t){return"Symbol("+(void 0===t?"":t)+")_"+o(++n+r,36)}},3307:function(t,e,i){var s=i(6293);t.exports=s&&!Symbol.sham&&"symbol"==typeof Symbol.iterator},3353:function(t,e,i){var s=i(9781),n=i(7293);t.exports=s&&n((function(){return 42!=Object.defineProperty((function(){}),"prototype",{value:42,writable:!1}).prototype}))},4811:function(t,e,i){var s=i(7854),n=i(614),r=s.WeakMap;t.exports=n(r)&&/native code/.test(String(r))},5112:function(t,e,i){var s=i(7854),n=i(2309),r=i(2597),o=i(9711),a=i(6293),l=i(3307),c=n("wks"),d=s.Symbol,u=d&&d["for"],h=l?d:d&&d.withoutSetter||o;t.exports=function(t){if(!r(c,t)||!a&&"string"!=typeof c[t]){var e="Symbol."+t;a&&r(d,t)?c[t]=d[t]:c[t]=l&&u?u(e):h(e)}return c[t]}},7658:function(t,e,i){"use strict";var s=i(2109),n=i(7908),r=i(6244),o=i(3658),a=i(7207),l=i(7293),c=l((function(){return 4294967297!==[].push.call({length:4294967296},1)})),d=!function(){try{Object.defineProperty([],"length",{writable:!1}).push()}catch(t){return t instanceof TypeError}}();s({target:"Array",proto:!0,arity:1,forced:c||d},{push:function(t){var e=n(this),i=r(e),s=arguments.length;a(i+s);for(var l=0;l<s;l++)e[i]=arguments[l],i++;return o(e,i),i}})},8555:function(t,e,i){"use strict";i.r(e);var s=i(8081),n=i.n(s),r=i(3645),o=i.n(r),a=i(6672),l=i(1667),c=i.n(l),d=new URL(i(1586),i.b),u=new URL(i(5185),i.b),h=o()(n());h.i(a.Z);var p=c()(d),f=c()(u);h.push([t.id,'.smvp-badge{display:inline-block;font-size:10px;line-height:16px;font-weight:600;border-radius:4px;letter-spacing:.3px;padding:0 8px;text-transform:uppercase}.smvp-btn{background-color:transparent;padding:8px;border-radius:4px;box-sizing:border-box;cursor:pointer;transition:color .1s linear,background-color .1s linear;display:flex;justify-content:center;align-items:center;height:32px}.smvp-btn:hover{text-decoration:none;background-color:hsla(0,0%,100%,.2)}.smvp-button-with-dropdown{position:relative}.smvp-button-with-dropdown .smvp-button{width:100%;height:100%}.smvp-button-with-dropdown .smvp-content{display:none;position:absolute;bottom:100%;right:0;z-index:1}.smvp-button-with-dropdown.smvp-clicked .smvp-content{display:block}.smvp-dropdown-menu{position:relative}.smvp-dropdown-menu .smvp-label{display:flex;align-items:center}.smvp-dropdown-menu .smvp-label .smvp-arrow{display:inline-block;margin-left:4px}.smvp-dropdown-menu .smvp-label .smvp-arrow svg{transform:translateY(3px);width:12px}.smvp-dropdown-menu .smvp-label .smvp-arrow svg path{fill:#18191a}.smvp-dropdown-menu .smvp-dropdown-content{all:unset;z-index:1;position:absolute;transform:translateY(4px);right:0;min-width:92px;list-style-type:none;-webkit-padding-start:0;padding-inline-start:0;border:1px solid #ddd;box-shadow:-2px 4px 12px 0 rgba(0,0,0,.051)}.smvp-dropdown-menu .smvp-dropdown-content li.smvp-dropdown-option{padding:4px;cursor:pointer;font-weight:600;font-size:12px;line-height:16px;white-space:nowrap}.smvp-icon{width:16px;height:16px}.smvp-icon-button{width:32px;height:32px}.smvp-like-button{position:relative;min-width:44px;height:24px;padding:4px 8px;background-color:#fff;font-size:12px;border:1px solid #ddd;border-radius:4px;-webkit-user-select:none;-moz-user-select:none;user-select:none}.smvp-like-button svg.smvp-icon{margin-right:2px}.smvp-like-button svg.smvp-icon path{fill:#b1b3b8}.smvp-like-button:hover:not(.liked){background-color:#f3f3f3}.smvp-like-button.liked{border-color:var(--smvp-tab-active-color);color:var(--smvp-tab-active-color)}.smvp-like-button.liked:hover:after{content:"\\a";position:absolute;width:100%;height:100%;top:0;left:0;background-color:var(--smvp-tab-active-color);opacity:.1}.smvp-like-button.liked svg.smvp-icon path{fill:var(--smvp-tab-active-color)}.smvp-like-button.read-only{pointer-events:none;border:none}.dark-mode .smvp-like-button{background-color:#000;border-color:#000;color:var(--smvp-dark-mode-color)}.dark-mode .smvp-like-button:hover{border-color:#484d51;background-color:#3f4041}.dark-mode .smvp-like-button.liked svg.smvp-icon path{fill:var(--smvp-btn-color)}.dark-mode .smvp-like-button.read-only,.smvp-slider{background-color:transparent}.smvp-slider{margin:0;font-size:14px;line-height:22px;-webkit-font-smoothing:antialiased;box-sizing:border-box;box-shadow:none;display:block;color:#2d3339;-webkit-appearance:none;-moz-appearance:none;appearance:none;min-height:0;padding:0;border-radius:4px;height:2px;outline:none;border:0}.smvp-slider::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;background-color:#fff;height:16px;width:16px;box-shadow:0 0 4px rgba(0,0,0,.25);border-radius:50%}.smvp-slider::-ms-thumb{appearance:none;background-color:#fff;height:16px;width:16px;box-shadow:0 0 4px rgba(0,0,0,.25);border-radius:50%}.smvp-slider::-moz-range-thumb{-moz-appearance:none;appearance:none;background-color:#fff;height:16px;width:16px;box-shadow:0 0 4px rgba(0,0,0,.25);border-radius:50%}.smvp-menu{background-color:#000;color:#fff;font-size:12px;border-radius:4px;padding:4px 8px;width:160px}.smvp-menu .smvp-label{padding:4px;border-bottom:1px solid hsla(0,0%,100%,.2);width:100%;margin-bottom:5px;font-weight:700}.smvp-menu .smvp-option{padding:4px;cursor:pointer}.smvp-menu .smvp-option.smvp-selected{background:hsla(0,0%,100%,.8);color:#000}.smvp-menu .smvp-option:hover:not(.smvp-selected){background:hsla(0,0%,100%,.2)}.line-clamp-2{-webkit-line-clamp:2}.line-clamp-2,.line-clamp-3{display:-webkit-box;-webkit-box-orient:vertical;overflow:hidden;text-overflow:ellipsis}.line-clamp-3{-webkit-line-clamp:3}.smvp-control-bar{width:100%;position:absolute;bottom:0;left:0;box-sizing:border-box;background:linear-gradient(0deg,#000,transparent);opacity:1;transform:translateY(0);transition:opacity .3s ease-in,transform .3s ease-in;display:flex;padding:0 8px 8px 8px}.smvp-control-bar.smvp-fold-below{opacity:0;transform:translateY(100%);transition:opacity .3s ease-out 2s,transform .3s ease-out 2s}.smvp-control-bar .smvp-badge{margin-left:16px}@keyframes lds-ring{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.smvp-loading,.smvp-loading-shadow{display:inline-block;position:absolute;width:80px;height:80px;top:50%;left:50%;transform:translate(-50%,-50%)}.smvp-loading .part,.smvp-loading-shadow .part{box-sizing:border-box;display:block;position:absolute;width:64px;height:64px;margin:8px;border:8px solid #fff;border-radius:50%;animation:lds-ring 1.2s cubic-bezier(.5,0,.5,1) infinite;border-color:#fff transparent transparent transparent}.smvp-loading .part:first-child,.smvp-loading-shadow .part:first-child{animation-delay:-.45s}.smvp-loading .part:nth-child(2),.smvp-loading-shadow .part:nth-child(2){animation-delay:-.3s}.smvp-loading .part:nth-child(3),.smvp-loading-shadow .part:nth-child(3){animation-delay:-.15s}.smvp-loading-shadow{filter:blur(2px)}.smvp-loading-shadow .part{border-color:#bababa transparent transparent transparent}.smvp-error-notification{width:100%;height:100%;top:0;left:0;position:absolute;background-color:#000;display:flex;justify-content:center;align-items:center;color:#d3d3d3}.smvp-error-notification .smvp-message{text-align:center}.smvp-error-notification .smvp-message a{text-decoration:none}.smvp-video-player{position:relative;background-color:#000;overflow:hidden;width:100%;min-height:200px}.smvp-video-player:before{content:"";display:block;height:0;width:0;padding-bottom:56.25%}.smvp-video-player .video-area-wrapper{position:absolute;left:0;top:50%;transform:translateY(-50%);overflow:hidden}.smvp-video-player .video-area-wrapper,.smvp-video-player .video-area-wrapper .video-wrapper{max-height:100%;max-width:100%;width:100%;display:flex;justify-content:center}.smvp-video-player .video-area-wrapper .video-wrapper video{max-height:100%;max-width:100%;flex-grow:1}.smvp-video-player .video-area-wrapper.control-bar-at-bottom{height:100%}.smvp-video-player .smvp-core-iframe{position:absolute;width:100%;height:100%;top:0;left:0}.smvp-video-player.smvp-client-fullscreen.is-side-bar-below{height:0;padding-top:56.25%}.smvp-video-player.smvp-fullscreen{position:fixed;top:0;left:0;width:100%;height:100%;z-index:10000;display:flex;padding:0;margin:0;align-items:center;justify-content:center}.smvp-video-player.smvp-fullscreen.smvp-idle{cursor:none}.smvp-video-player .smvp-spacer{margin-left:auto}.smvp-interprefy{position:relative}.smvp-interprefy-iframe-wrapper{position:absolute;width:400px;height:400px;bottom:37px;right:0}.smvp-interprefy-iframe-wrapper iframe{width:100%;height:100%;border-radius:4px;background:#fff;border:0;box-shadow:0 0 4px rgba(0,0,0,.5);display:block;overflow:hidden}.smvp-interprefy-iframe-wrapper .smvp-icon-button{position:absolute;top:0;right:0;width:36px;height:36px;line-height:36px;text-align:center;cursor:pointer}.smvp-live-badge-container{height:32px;display:flex;align-items:center}.smvp-live-badge{color:#fff;background:#ff3b30}.smvp-preview-badge-container{height:32px;display:flex;align-items:center}.smvp-preview-badge{color:#b38f00;background:#fff0b3}.smvp-time{font-size:12px;color:#fff;margin-left:8px;line-height:32px}.smvp-volume-controls{display:flex;align-items:center}.smvp-volume-controls .smvp-volume{width:1px;opacity:0;transition:width .3s ease-in-out}.smvp-volume-controls .smvp-volume::-webkit-slider-thumb{-webkit-transition:opacity .3s ease-in-out;transition:opacity .3s ease-in-out;opacity:0}.smvp-volume-controls .smvp-volume::-moz-range-thumb{-moz-transition:opacity .3s ease-in-out;transition:opacity .3s ease-in-out;opacity:0}.smvp-volume-controls .smvp-volume::-ms-thumb{-ms-transition:opacity .3s ease-in-out;transition:opacity .3s ease-in-out;opacity:0}.smvp-volume-controls:hover .smvp-toggle{margin-right:8px}.smvp-volume-controls:hover .smvp-volume{width:48px;opacity:1}.smvp-volume-controls:hover .smvp-volume::-webkit-slider-thumb{opacity:1}.smvp-volume-controls:hover .smvp-volume::-moz-range-thumb{opacity:1}.smvp-volume-controls:hover .smvp-volume::-ms-thumb{opacity:1}.smvp-viewers-count-control{display:flex;justify-content:center;align-items:center;height:32px}.smvp-viewers-count-control .smvp-viewer-count-box{display:flex;justify-content:center;align-items:center;background:rgba(0,0,0,.3);border:1px solid hsla(0,0%,100%,.35);padding:2px 6px;border-radius:4px}.smvp-viewers-count-control .smvp-viewer-count-box span.count{margin-left:4px;color:#fff;font-style:normal;font-weight:700;font-size:12px;line-height:16px}.smvp-big-play-button-widget{position:absolute;width:100%;height:100%;top:0;left:0}.smvp-big-play-button-widget .smvp-play-button-overlay{width:100%;height:100%;top:0;left:0;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,.2)}.smvp-big-play-button-widget .smvp-play-button-overlay svg{color:#fff;border:2px solid #fff;border-radius:50%;width:30px;height:30px;padding:30px}.smvp-big-play-button-widget .smvp-play-button-overlay:hover svg{background:hsla(0,0%,100%,.4)}.smvp-big-unmute-button-widget{position:absolute;width:100%;height:100%;top:0;left:0;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,.2);cursor:pointer}.smvp-big-unmute-button-widget svg{color:#fff;border:2px solid #fff;border-radius:50%;width:30px;height:30px;padding:30px}.smvp-big-unmute-button-widget:hover svg{background:hsla(0,0%,100%,.4)}@keyframes growAndFadeUp{0%{transform:scale(0) translateY(0);opacity:0}10%{transform:scale(1.1) translateY(0);opacity:1}15%{transform:scale(1);opacity:1}to{transform:scale(.8) translateY(-200px);opacity:0}}.smvp-claps-widget{position:absolute;display:inline-block;bottom:50px;right:0}.smvp-claps-widget .smvp-tooltiptext{bottom:48px}.smvp-claps-widget .smvp-claps-button{background-color:#d8dbe3;border-radius:50%;padding:8px;margin:0 10px 0 0;cursor:pointer;opacity:1;transform:translateY(0)}.smvp-claps-widget .smvp-claps-button:active{background-color:rgba(216,219,227,.8)}.smvp-claps-widget .smvp-clap{background-image:url('+p+");background-size:contain;width:24px;height:24px}.smvp-claps-widget .smvp-clap.smvp-animated{position:absolute;bottom:32px;left:0;width:32px;height:32px;animation-duration:1.2s;animation-fill-mode:forwards;animation-name:growAndFadeUp}.smvp-claps-widget .smvp-clap.smvp-animated:nth-child(3n+2){left:64px}.smvp-claps-widget .smvp-clap.smvp-animated:nth-child(3n){left:32px}.smvp-claps-widget .smvp-floating-claps-animation{position:absolute;right:0;bottom:0;height:0;margin:10px;min-width:96px}.smvp-countdown-widget{position:absolute;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,.5);color:#fff;text-align:center;display:flex;justify-content:center;align-items:center}.smvp-countdown-widget .smvp-countdown-h1,.smvp-countdown-widget .smvp-countdown-h3,.smvp-countdown-widget .smvp-countdown-p{-webkit-user-select:none;-moz-user-select:none;user-select:none}.smvp-countdown-widget .smvp-countdown-p{font-size:14px;margin-top:0;margin-bottom:10px}.smvp-countdown-widget .smvp-countdown-h1{font-size:36px;margin-top:20px;margin-bottom:10px}.smvp-countdown-widget .smvp-countdown-h3{font-size:24px;margin-top:0;margin-bottom:10px}.smvp-invisible-overlay,.smvp-message-overlay-widget{position:absolute;top:0;left:0;width:100%;height:100%}.smvp-message-overlay-widget{background-color:rgba(0,0,0,.5);display:flex;justify-content:center;align-items:center}.smvp-message-overlay-widget.smvp-message-overlay-on-top{z-index:1000}.smvp-message-overlay-widget .smvp-message-overlay-dialog{position:relative;display:flex;flex-direction:column;justify-content:center;align-items:center;width:360px;background-color:rgba(0,0,0,.8);color:#e3e6e8;box-sizing:border-box;border-radius:16px;padding:24px}.smvp-message-overlay-widget .smvp-message-overlay-dialog h1.smvp-message-overlay-title{text-align:center;font-size:17px;font-weight:500;line-height:27px;-webkit-margin-before:unset;margin-block-start:unset;-webkit-margin-after:unset;margin-block-end:unset}.smvp-message-overlay-widget .smvp-message-overlay-dialog .smvp-message-overlay-message{text-align:center;font-size:14px;font-weight:400;line-height:19px}.smvp-message-overlay-widget .smvp-message-overlay-dialog .smvp-message-overlay-message a{color:#e3e6e8;text-decoration:underline}.smvp-message-overlay-widget .smvp-message-overlay-dialog .smvp-message-overlay-button{font-size:14px;font-weight:600;line-height:24px;padding:4px 12px;border:1px solid #e3e6e8;border-radius:4px;cursor:pointer;transition:all .2s ease-in-out;background-color:rgba(227,230,232,0);color:#e3e6e8}.smvp-message-overlay-widget .smvp-message-overlay-dialog .smvp-message-overlay-button:hover{background-color:rgba(227,230,232,.2);color:#fff}.smvp-overlay-widget{position:absolute;top:0;left:0;width:100%;height:100%;display:flex;justify-content:center;align-items:center}.smvp-overlay-widget img{max-width:100%;max-height:100%}.smvp-large-display .smvp-overlay-widget img{flex-grow:1;max-width:unset;max-height:unset;width:100%;height:100%;-o-object-fit:cover;object-fit:cover}.smvp-poll{border-radius:16px;box-shadow:0 0 4px rgba(0,0,0,.5);position:absolute;bottom:72px;left:50%;transform:translateX(-50%);background-color:#fff;width:546px;font-size:14px;padding:8px;color:#333}.smvp-poll.smvp-fullscreen{position:fixed}.smvp-poll .smvp-poll-question{margin-top:4px;text-align:center}.smvp-poll .smvp-poll-question p{margin:0;overflow-wrap:anywhere}.smvp-poll .smvp-answers-row{display:flex;box-sizing:border-box}.smvp-poll .smvp-answers-row :root{--smvp-dark-mode-background-color:initial;--smvp-dark-mode-color:initial;--smvp-dark-mode-border-color:initial;--smvp-tab-active-color:initial;--smvp-polls-selected-border-color:initial;--smvp-upvote-color:initial}.smvp-poll .smvp-answers-row .smvp-answer{box-sizing:border-box;padding:8px;margin:8px;border:2px solid #ddd;background-color:#fff;width:calc(50% - 16px);position:relative;display:flex;border-radius:.5vw}.smvp-poll .smvp-answers-row .smvp-answer .smvp-answer-progress-bar{height:100%;background-color:#d5e6fe;position:absolute;top:0;left:0;transition:width 1s}.smvp-poll .smvp-answers-row .smvp-answer .smvp-progress-bar-correct{background-color:#d4f4e0}.smvp-poll .smvp-answers-row .smvp-answer .smvp-answer-text{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;position:relative;text-align:left;flex-grow:10}.smvp-poll .smvp-answers-row .smvp-answer .smvp-percentages{position:relative}.smvp-poll .smvp-answers-row .smvp-answer.smvp-selected-correct{border:2px solid #2dd269}.smvp-poll .smvp-answers-row .smvp-answer .smvp-icon-correct{display:block;margin:0 2px 0 0;width:20px;height:18px;background-repeat:no-repeat;z-index:1;background-image:url("+f+')}.smvp-poll .smvp-single-item-row{justify-content:center}.smvp-poll.smvp-waiting-results-msg{text-align:center}.smvp-poll .smvp-poll-question.empty{background-color:#fff}.smvp-poll .smvp-poll-question.empty,.smvp-poll .smvp-poll-question.empty p{display:flex;align-items:center;height:100%}.smvp-large-display .smvp-poll{width:80%;top:50%;bottom:auto;transform:translate(-50%,-50%);box-shadow:0 0 .5vw rgba(0,0,0,.5);padding:2vw;background-color:#fff;max-height:80%;overflow-y:auto}.smvp-large-display .smvp-poll .smvp-poll-countdown-timer{max-height:1vw;margin-bottom:.5vw;border-radius:.5vw;transition:max-height .3s ease-in-out,width 1s linear}.smvp-large-display .smvp-poll .smvp-poll-countdown-timer.blinking{animation:blink 1s infinite}.smvp-large-display .smvp-poll .smvp-poll-countdown-timer.hidden{max-height:0}.smvp-large-display .smvp-poll .smvp-word-cloud-wrapper{height:100%}.smvp-large-display .smvp-poll .smvp-poll-question{display:-webkit-box;-webkit-box-orient:vertical;overflow:hidden;text-overflow:ellipsis;-webkit-line-clamp:3;position:relative;box-sizing:border-box;width:100%;top:0;text-align:left;font-size:2vw;line-height:3.38vw;padding:0;font-weight:700;margin-bottom:1.5vw;transform:translateY(0);background-color:transparent;border-radius:8px;transition:top .3s linear,transform .3s linear,background-color .3s linear,padding .3s linear}.smvp-large-display .smvp-poll .smvp-poll-question.empty{margin:0}.smvp-large-display .smvp-poll .smvp-polls-cloud-container{display:block;justify-content:center;margin-top:1.5vw;width:100%;height:80%}.smvp-large-display .smvp-poll .smvp-answers-row{display:flex;box-sizing:border-box;flex-direction:column}.smvp-large-display .smvp-poll .smvp-answers-row :root{--smvp-dark-mode-background-color:initial;--smvp-dark-mode-color:initial;--smvp-dark-mode-border-color:initial;--smvp-tab-active-color:initial;--smvp-polls-selected-border-color:initial;--smvp-upvote-color:initial}.smvp-large-display .smvp-poll .smvp-answers-row .smvp-answer{box-sizing:content-box;padding:1vw;margin:.75vw 0;border:.125vw solid #fff;border-radius:.5vw;background-color:#f3f3f3;width:calc(100% - 4vw);position:relative;display:flex;font-size:1.75vw;line-height:normal;font-weight:400}.smvp-large-display .smvp-poll .smvp-answers-row .smvp-answer .smvp-progress-bar-correct{background-color:#d4f4e0}.smvp-large-display .smvp-poll .smvp-answers-row .smvp-answer.smvp-selected-correct{border:.125vw solid #2dd269}.smvp-large-display .smvp-poll .smvp-answers-row .smvp-answer .smvp-icon-correct{margin:.125vw .75vw 0 0;width:2vw;height:2vw;background-size:contain}.smvp-large-display .smvp-poll .smvp-answers-row .smvp-answer .smvp-answer-text{margin-right:.5vw}.smvp-large-display.smvp-vertical-display .smvp-poll{max-height:80%;height:80%;box-shadow:0 0 .5856515373vh rgba(0,0,0,.5)}.smvp-large-display.smvp-vertical-display .smvp-poll .smvp-polls-cloud-container{height:calc(100% - 3.51391vh)}.smvp-large-display.smvp-vertical-display .smvp-poll .smvp-poll-question{font-size:2.3426061493vh;line-height:3.9590043924vh}.smvp-large-display.smvp-vertical-display .smvp-poll .smvp-poll-question.empty{margin:0}.smvp-large-display.smvp-vertical-display .smvp-poll .smvp-answers-row :root{--smvp-dark-mode-background-color:initial;--smvp-dark-mode-color:initial;--smvp-dark-mode-border-color:initial;--smvp-tab-active-color:initial;--smvp-polls-selected-border-color:initial;--smvp-upvote-color:initial}.smvp-large-display.smvp-vertical-display .smvp-poll .smvp-answers-row .smvp-answer{padding:1.1713030747vh;margin:.878477306vh 0;border:.1464128843vh solid #fff;border-radius:.5856515373vh;width:calc(100% - 4.68521vh);font-size:2.0497803807vh}.smvp-large-display.smvp-vertical-display .smvp-poll .smvp-answers-row .smvp-answer.smvp-voted{border:.0732064422vh solid #e3e6e8}.smvp-large-display.smvp-vertical-display .smvp-poll .smvp-answers-row .smvp-answer.smvp-selected-correct{border:.1464128843vh solid #2dd269}.smvp-large-display.smvp-vertical-display .smvp-poll .smvp-answers-row .smvp-answer .smvp-icon-correct{margin:.1464128843vh .878477306vh 0 0;width:2.3426061493vh;height:2.3426061493vh}.smvp-large-display.smvp-vertical-display .smvp-poll .smvp-answers-row .smvp-answer.smvp-selected-incorrect{border:.1464128843vh solid #3587fb}.smvp-large-display.smvp-vertical-display .smvp-poll .smvp-answers-row .smvp-answer .smvp-answer-text{margin-right:.5856515373vh;white-space:unset;overflow:hidden;-webkit-line-clamp:3;text-overflow:ellipsis;display:-webkit-box;-webkit-box-orient:vertical}.smvp-poll.smvp-word-cloud-poll{height:80%;overflow:hidden}.smvp-video-player-wrapper.dark-mode .smvp-qna-widget{background-color:var(--smvp-dark-mode-background-color)}.smvp-video-player-wrapper.dark-mode .smvp-qna-widget .smvp-question .smvp-body .smvp-paragraph{color:var(--smvp-dark-mode-color)}.smvp-video-player-wrapper.dark-mode .smvp-qna-widget .smvp-label-chevron-wrapper .smvp-icon-button svg path{fill:var(--smvp-dark-mode-color)}.smvp-qna-widget{width:300px;background-color:#fff;border-radius:8px;box-shadow:0 0 4px rgba(0,0,0,.5);position:absolute;bottom:72px;left:50%;transform:translateX(-50%)}.smvp-qna-widget.collapsed{width:unset}.smvp-qna-widget.collapsed .smvp-question .smvp-label-chevron-wrapper{display:flex;align-items:center;justify-content:space-between;margin-bottom:0}.smvp-qna-widget.collapsed .smvp-question .smvp-body,.smvp-qna-widget.collapsed .smvp-question .smvp-profile{display:none}.smvp-large-display .smvp-qna-widget{display:flex;width:80vw;max-height:42.625vw;bottom:auto;top:50%;overflow:hidden;transform:translate(-50%,-50%);box-shadow:0 0 .5vw rgba(0,0,0,.5);padding:2vw}.smvp-large-display .smvp-qna-widget .smvp-badge,.smvp-large-display .smvp-qna-widget .smvp-label-chevron-wrapper{display:none}.smvp-large-display .smvp-qna-widget .smvp-question{display:flex;flex-direction:column-reverse;flex-grow:1}.smvp-large-display .smvp-qna-widget .smvp-question:first-child{margin-top:unset}.smvp-large-display .smvp-qna-widget .smvp-question .smvp-small{display:none}.smvp-large-display .smvp-qna-widget .smvp-question .smvp-body{flex-grow:1;display:block;margin-bottom:.75vw;font-size:2vw;line-height:3.2vw;max-height:25.6vw;overflow:hidden;overflow-wrap:break-word;text-overflow:ellipsis}.smvp-large-display .smvp-qna-widget .smvp-question .smvp-body .smvp-paragraph{color:#18191a;font-weight:600}.smvp-large-display .smvp-qna-widget .smvp-question .smvp-profile{margin-top:.75vw}.smvp-large-display .smvp-qna-widget .smvp-question .smvp-profile .title{font-size:1.75vw;line-height:3vw;font-weight:400}.smvp-large-display .smvp-qna-widget .smvp-question .smvp-profile .subtitle{display:none}.smvp-large-display .smvp-qna-widget .smvp-question .smvp-profile .smvp-avatar{width:3vw;height:3vw;border-radius:50%;margin-right:.75vw}.smvp-large-display .smvp-qna-widget .smvp-question .smvp-profile .smvp-avatar .initials{font-size:1.125vw;line-height:3vw}.smvp-large-display .smvp-qna-widget .smvp-question .player-upvote,.smvp-large-display .smvp-qna-widget .smvp-question .smvp-icon-button{display:none}.smvp-large-display .smvp-qna-widget .smvp-question .live-display-upvote{display:inline-flex;margin-bottom:24px}.smvp-large-display .smvp-qna-widget .smvp-question .live-display-upvote .smvp-like-button{font-size:24px;font-weight:600;padding-left:0;margin-left:-4px;color:#18191a}.smvp-large-display .smvp-qna-widget .smvp-question .live-display-upvote svg{width:48px;height:48px}.smvp-large-display .smvp-qna-widget .smvp-question .live-display-upvote svg path{fill:var(--smvp-upvote-color)}.smvp-large-display.smvp-vertical-display .smvp-qna-widget{width:80%;max-height:80%;box-shadow:0 0 .5856515373vh rgba(0,0,0,.5);padding:2.3426061493vh}.smvp-large-display.smvp-vertical-display .smvp-qna-widget .smvp-question{display:flex;flex-direction:column}.smvp-large-display.smvp-vertical-display .smvp-qna-widget .smvp-question .smvp-body{font-size:2.3426061493vh;line-height:3.7481698389vh;max-height:unset;overflow:hidden;overflow-wrap:break-word;text-overflow:ellipsis}.smvp-large-display.smvp-vertical-display .smvp-qna-widget .smvp-question .smvp-profile{margin-top:.878477306vh;margin-bottom:.878477306vh}.smvp-large-display.smvp-vertical-display .smvp-qna-widget .smvp-question .smvp-profile .title{font-size:2.0497803807vh;line-height:3.513909224vh}.smvp-large-display.smvp-vertical-display .smvp-qna-widget .smvp-question .smvp-profile .smvp-avatar{width:3.513909224vh;height:3.513909224vh;margin-right:.878477306vh}.smvp-large-display.smvp-vertical-display .smvp-qna-widget .smvp-question .smvp-profile .smvp-avatar .initials{font-size:1.317715959vh;line-height:3.513909224vh}.smvp-qna-widget.fullscreen{position:fixed}.smvp-qna-widget .smvp-question{padding:12px;border-bottom:1px solid #f1f2f4}.smvp-qna-widget .smvp-question:first-child{margin-top:auto}.smvp-qna-widget .smvp-question:last-child{border-bottom:0}.smvp-qna-widget .smvp-question .smvp-badge{color:var(--smvp-tab-active-color);font-weight:700;position:relative}.smvp-qna-widget .smvp-question .smvp-badge:after{background-color:var(--smvp-tab-active-color);opacity:.2;content:"";position:absolute;top:0;bottom:0;right:0;left:0;border-radius:4px}.smvp-qna-widget .smvp-question .smvp-profile .details{display:inline-block;vertical-align:middle;flex:1}.smvp-qna-widget .smvp-question .smvp-profile .title{font-weight:700;font-size:12px;line-height:14px;color:#5b6771;overflow:hidden;white-space:normal}.dark-mode .smvp-qna-widget .smvp-question .smvp-profile .title{color:var(--smvp-dark-mode-color)}.smvp-qna-widget .smvp-question .smvp-profile .title.no-subtitle{padding-top:4px;line-height:24px}.smvp-qna-widget .smvp-question .smvp-profile .subtitle{color:#7d8082;font-size:12px;line-height:14px}.smvp-qna-widget .smvp-question .smvp-profile.click-disabled{cursor:default}.smvp-qna-widget .smvp-question .smvp-avatar,.smvp-qna-widget .smvp-question .smvp-silhouette{display:flex;align-items:center;border-radius:50%;margin-right:8px;height:32px;width:32px;line-height:32px;text-align:center;color:#fff;overflow:hidden}.smvp-qna-widget .smvp-question .smvp-avatar img,.smvp-qna-widget .smvp-question .smvp-silhouette img{display:flex;height:100%;width:100%}.smvp-qna-widget .smvp-question .smvp-avatar .initials,.smvp-qna-widget .smvp-question .smvp-avatar .smvp-silhouette,.smvp-qna-widget .smvp-question .smvp-silhouette .initials,.smvp-qna-widget .smvp-question .smvp-silhouette .smvp-silhouette{height:100%;width:100%}.smvp-qna-widget .smvp-question .smvp-avatar .smvp-silhouette,.smvp-qna-widget .smvp-question .smvp-silhouette .smvp-silhouette{margin:0}.smvp-qna-widget .smvp-question .smvp-avatar .smvp-silhouette svg,.smvp-qna-widget .smvp-question .smvp-silhouette .smvp-silhouette svg{height:16px;width:14px;margin:auto}.smvp-qna-widget .smvp-question .smvp-profile{display:flex;align-items:center;margin-bottom:4px;overflow:hidden}.smvp-qna-widget .smvp-question .smvp-body{overflow-wrap:break-word;font-size:1rem;max-height:128px;overflow:auto}.smvp-qna-widget .smvp-question .smvp-body .smvp-paragraph{color:#5b6771;margin:0;word-break:break-word}.smvp-qna-widget .smvp-question .smvp-label-chevron-wrapper{display:flex;align-items:center;justify-content:space-between;margin-bottom:8px}.smvp-qna-widget .smvp-question .smvp-label-chevron-wrapper .smvp-icon-button{height:0}.smvp-qna-widget .smvp-question .smvp-label-chevron-wrapper .smvp-icon-button:hover{background-color:inherit}.smvp-qna-widget .smvp-question .player-upvote{margin-left:auto;margin-right:8px}.smvp-qna-widget .smvp-question .live-display-upvote{display:none}.smvp-seek-bar{position:absolute;bottom:48px;left:8px;width:calc(100% - 16px);box-shadow:0 0 1px 1px rgba(0,0,0,.25);opacity:1;transform:translateY(0);transition:opacity .3s ease-in,transform .3s ease-in,border-color .1s linear}.smvp-seek-bar.smvp-collapsed{opacity:0;transform:translateY(2000%);transition:opacity .3s ease-out 2s,transform .3s ease-out 2s}.splitpanes__pane .smvp-slides-widget{right:0;max-width:100%;max-height:100%;justify-content:unset;background-color:unset;position:unset;width:unset;height:unset;top:unset;left:unset}.smvp-slides-widget{position:absolute;background-color:#000;display:flex;align-items:center;justify-content:center;width:100%;height:100%;top:0;left:0}.smvp-slides-widget img{pointer-events:none}.is-side-bar-below .smvp-slides-widget,.smvp-slides-widget img{max-height:100%;max-width:100%}.is-side-bar-below .smvp-slides-widget img{width:unset;height:100%;max-width:100%;max-height:100%}.smvp-subtitles-container{position:absolute;display:flex;flex-direction:column;justify-content:center;width:100%;left:0;bottom:66px}.smvp-subtitles-container.smvp-position-top{top:66px;bottom:unset}.smvp-subtitles-container .smvp-subtitle{display:flex;justify-content:center;align-items:center;text-align:center}.smvp-subtitles-container .smvp-subtitle .smvp-text{display:inline-block;box-shadow:8px 0 0 rgba(0,0,0,.45),-8px 0 0 rgba(0,0,0,.45);background-color:rgba(0,0,0,.45);color:#fff;font-weight:500}.smvp-subtitles-container .new-subtitles-wrapper .smvp-text{position:relative;overflow:hidden;-webkit-clip-path:inset(0 100% 0 0);clip-path:inset(0 100% 0 0);animation:reveal-text .2s steps(30) forwards}.smvp-subtitles-container .new-subtitles-wrapper div:nth-of-type(2) .smvp-text{animation-delay:.2s}.smvp-subtitles-container .new-subtitles-wrapper div:nth-of-type(3) .smvp-text{animation-delay:.4s}.smvp-subtitles-container .new-subtitles-wrapper div:nth-of-type(4) .smvp-text{animation-delay:.6s}.smvp-subtitles-container .new-subtitles-wrapper div:nth-of-type(5) .smvp-text{animation-delay:.8s}.smvp-subtitles-container .new-subtitles-wrapper div:nth-of-type(6) .smvp-text{animation-delay:1s}@keyframes reveal-text{0%{-webkit-clip-path:inset(0 100% 0 0);clip-path:inset(0 100% 0 0)}to{-webkit-clip-path:inset(0 0 0 0);clip-path:inset(0 0 0 0)}}.smvp-user-interactor-widget{position:absolute;width:100%;height:100%;top:0;left:0;display:flex;align-items:center;justify-content:center;background-color:#000;cursor:pointer}.smvp-user-interactor-widget svg{color:#fff;border:2px solid #fff;border-radius:50%;width:30px;height:30px;padding:30px}.smvp-user-interactor-widget:hover svg{background:hsla(0,0%,100%,.4)}.is-side-bar-below .smvp-side-bar{flex-direction:column}.is-side-bar-below .smvp-side-bar .tabs{width:unset;height:56px;box-shadow:unset;padding-top:4px}.is-side-bar-below .smvp-side-bar .tabs ul{flex-direction:row;margin-left:4px}.is-side-bar-below .smvp-side-bar .tabs ul li{margin-bottom:0;margin-right:8px}.is-side-bar-below .smvp-side-bar .tabs ul li.toggler{display:none}.is-side-bar-below .smvp-side-bar,.smvp-side-bar.no-player{width:100%;height:100%;overflow:hidden}.is-side-bar-below .smvp-side-bar .main-view,.smvp-side-bar.no-player .main-view{max-width:unset;width:100%}.is-side-bar-below .smvp-side-bar .main-view .smvp-tab,.smvp-side-bar.no-player .main-view .smvp-tab{width:100%;overflow-x:hidden}.is-side-bar-below .smvp-side-bar .main-view{overflow-y:auto}.smvp-video-player-wrapper.dark-mode .smvp-side-bar,.smvp-video-player-wrapper.dark-mode .smvp-side-bar input{background-color:var(--smvp-dark-mode-background-color);color:var(--smvp-dark-mode-color)}.smvp-video-player-wrapper.dark-mode .smvp-side-bar .main-view{border-left:1px solid #18191a}.smvp-video-player-wrapper.dark-mode .smvp-side-bar .tabs ul li .smvp-tab-text{color:var(--smvp-dark-mode-color)}.smvp-video-player-wrapper.dark-mode .smvp-side-bar .tabs ul li:not(.active):hover{background-color:#18191a}.smvp-video-player-wrapper.dark-mode .smvp-side-bar .tabs ul li.active{background-color:#3f4041}.smvp-video-player-wrapper.dark-mode .smvp-side-bar .tabs ul li.active:after{content:none}.smvp-side-bar{display:flex;flex-direction:row;background-color:#fff}.smvp-side-bar .tabs{width:56px;padding:4px;opacity:1;box-shadow:-1px 0 12px rgba(0,0,0,.1)}.smvp-side-bar .main-view{transition:max-width .3s ease-in-out}.smvp-side-bar .main-view.closed{max-width:0;overflow:hidden}.smvp-side-bar.collapsed .highlight{left:50%}.smvp-side-bar.smvp-side-bar-narrowing .main-view .smvp-tab,.smvp-side-bar.smvp-sidebar-wide .main-view .smvp-tab{width:564px}.smvp-side-bar.smvp-sidebar-wide.smvp-side-bar-narrowing .main-view{max-width:282px}.smvp-side-bar.smvp-sidebar-wide .main-view{width:564px;max-width:564px}.smvp-side-bar.smvp-sidebar-fullscreen.smvp-sidebar-wide .main-view{max-width:66vw;width:66vw}.smvp-side-bar.smvp-sidebar-fullscreen.smvp-sidebar-wide .main-view .smvp-tab{width:66vw}.smvp-side-bar.smvp-sidebar-fullscreen.smvp-sidebar-wide.smvp-side-bar-narrowing .main-view{max-width:282px}.is-side-bar-below .smvp-side-bar{max-width:unset}.smvp-side-bar .smvp-viewers{display:flex;flex-direction:column;overflow:auto}.smvp-side-bar .smvp-viewers section.content{display:flex;flex-direction:column-reverse}.is-side-bar-below .smvp-side-bar .smvp-viewers section.content{flex-direction:column}.smvp-side-bar .smvp-viewers section.content.empty{justify-content:center}.smvp-side-bar .smvp-viewers .no-viewers{text-align:center;padding:16px;line-height:24px}.smvp-side-bar .smvp-viewers .smvp-viewer .profile{margin-bottom:0}.smvp-side-bar .smvp-viewers .viewer{padding:8px}.smvp-side-bar .smvp-viewers .viewer:last-child{border-bottom:0}.smvp-side-bar .smvp-viewers .viewer small{font-weight:500;font-size:12px;color:#828282}.smvp-side-bar .smvp-viewers .viewer .body{overflow-wrap:break-word}.smvp-side-bar .smvp-viewers .viewer .body p{margin-bottom:0}.smvp-side-bar .smvp-viewers .viewer:not(.is-webinar):hover{cursor:pointer;background-color:#f3f3f3}.dark-mode .smvp-side-bar .smvp-viewers .viewer:not(.is-webinar):hover{background-color:#3f4041}.smvp-side-bar .smvp-avatar,.smvp-side-bar .smvp-silhouette{display:flex;align-items:center;border-radius:50%;margin-right:8px;height:32px;width:32px;line-height:32px;text-align:center;color:#fff;overflow:hidden}.smvp-side-bar .smvp-avatar img,.smvp-side-bar .smvp-silhouette img{display:flex;height:100%;width:100%}.smvp-side-bar .smvp-avatar .initials,.smvp-side-bar .smvp-avatar .smvp-silhouette,.smvp-side-bar .smvp-silhouette .initials,.smvp-side-bar .smvp-silhouette .smvp-silhouette{height:100%;width:100%}.smvp-side-bar .smvp-avatar .smvp-silhouette,.smvp-side-bar .smvp-silhouette .smvp-silhouette{margin:0}.smvp-side-bar .smvp-avatar .smvp-silhouette svg,.smvp-side-bar .smvp-silhouette .smvp-silhouette svg{height:16px;width:14px;margin:auto}.smvp-side-bar .smvp-profile{display:flex}.smvp-side-bar .smvp-profile .details{display:inline-block;vertical-align:middle;flex:1}.smvp-side-bar .smvp-profile .title{font-weight:700;font-size:12px;line-height:14px;color:#5b6771;overflow:hidden;white-space:normal}.dark-mode .smvp-side-bar .smvp-profile .title{color:var(--smvp-dark-mode-color)}.smvp-side-bar .smvp-profile .title.no-subtitle{padding-top:4px;line-height:24px}.smvp-side-bar .smvp-profile .subtitle{color:#7d8082;font-size:12px;line-height:14px}.smvp-side-bar .smvp-profile.click-disabled{cursor:default}.smvp-side-bar .main-view{height:100%;width:282px;max-width:282px;display:flex;flex-direction:column;border-left:1px solid #f1f2f4}.smvp-side-bar .main-view section.content{flex-grow:1;overflow:auto}.smvp-side-bar .main-view .smvp-tab{width:282px;height:100%}.smvp-side-bar .tabs ul{list-style-type:none;margin:0;-webkit-margin-before:0;margin-block-start:0;-webkit-margin-after:0;margin-block-end:0;-webkit-padding-start:0;padding-inline-start:0;-webkit-margin-end:0;margin-inline-end:0;height:100%}.smvp-side-bar .tabs ul,.smvp-side-bar .tabs ul li{display:flex;flex-direction:column;align-items:center}.smvp-side-bar .tabs ul li{text-align:center;position:relative;margin-bottom:8px;font-weight:500;justify-items:center;cursor:pointer;padding:4px;border-radius:4px;width:48px}.smvp-side-bar .tabs ul li.fullscreen-toggler,.smvp-side-bar .tabs ul li.toggler{margin-top:12px;margin-bottom:12px;height:20px;width:20px;border-radius:50%;display:flex;justify-content:center;align-content:center}.smvp-side-bar .tabs ul li.fullscreen-toggler svg path,.smvp-side-bar .tabs ul li.toggler svg path{fill:#000}.smvp-side-bar .tabs ul li.fullscreen-toggler .smvp-tab-icon,.smvp-side-bar .tabs ul li.toggler .smvp-tab-icon{display:flex;justify-content:center;align-content:center;margin:0;padding:0}.smvp-side-bar .tabs ul li.sidebar-spacer{cursor:default;flex-grow:2}.smvp-side-bar .tabs ul li.sidebar-spacer:not(.active):hover{text-decoration:unset;background-color:unset}.smvp-side-bar .tabs ul li .smvp-tab-icon{font-size:16px;margin-top:4px;margin-bottom:4px}.smvp-side-bar .tabs ul li .smvp-tab-icon svg path{fill:var(--smvp-tab-active-color)}.smvp-side-bar .tabs ul li:not(.active):hover{text-decoration:none;background-color:#f3f3f3}.smvp-side-bar .tabs ul li:after{content:"";position:absolute;top:0;bottom:0;right:0;left:0;opacity:.2;border-radius:4px}.smvp-side-bar .tabs ul li.active:after{background-color:var(--smvp-tab-active-color)}.smvp-side-bar .tabs ul li.active .smvp-tab-text{color:var(--smvp-tab-active-color)}.smvp-side-bar .tabs ul li.active .smvp-tab-icon svg path{fill:var(--smvp-tab-active-color)}.smvp-side-bar .tabs ul li.active.active:hover:after{opacity:.3}.smvp-side-bar .tabs ul li .smvp-tab-text{font-size:10px;line-height:12px;color:#7d8082;margin-bottom:1px}.smvp-side-bar .streamless-close-btn{position:absolute;right:0;top:0;margin-top:6px}.smvp-side-bar .streamless-close-btn i{font-size:1rem}.smvp-side-bar .no-objectfit .smvp-side-bar section.content{display:block;width:100%}.smvp-side-bar .no-objectfit .smvp-side-bar footer{min-height:78px}.smvp-side-bar .smvp-tab-notification-dot{position:absolute;right:10px;top:0;transform:translate(50%,50%);width:8px;height:8px;background-color:#ff3e33;border-radius:4px;animation-name:smvp-tab-notification-dot-animation;animation-duration:1s;animation-iteration-count:infinite}@keyframes smvp-tab-notification-dot-animation{0%{right:10px;top:0;border-radius:4px;width:8px;height:8px;background-color:#ff3e33}10%{right:10px;top:0;border-radius:4px;width:8px;height:8px;background-color:#ff3e33}40%{right:10px;top:2px;border-radius:3px;width:6px;height:6px;background-color:#b20a00}60%{right:10px;top:2px;border-radius:3px;width:6px;height:6px;background-color:#b20a00}90%{right:10px;top:0;border-radius:4px;width:8px;height:8px;background-color:#ff3e33}to{right:10px;top:0;border-radius:4px;width:8px;height:8px;background-color:#ff3e33}}.smvp-side-bar .button-icon{color:#2d3339;background:#e3e6e8;border-radius:2px;border:transparent}.smvp-side-bar .button-icon:hover{background:#d5d9dd}.smvp-side-bar .button-icon svg{width:16px;height:16px;margin-left:8px;transform:translateY(2px)}.smvp-side-bar .button-icon svg path{fill:#2d3339}.smvp-video-player-wrapper.dark-mode .smvp-side-bar-notification .smvp-side-bar-notification-message{background-color:var(--smvp-dark-mode-background-color);color:var(--smvp-dark-mode-color);border-color:var(--smvp-dark-mode-border-color)}.smvp-side-bar-notification{position:absolute;width:100%;bottom:10%;left:0;display:flex;align-items:center;justify-content:center}.smvp-side-bar-notification .smvp-side-bar-notification-message{display:flex;box-sizing:border-box;max-width:90%;background-color:#fff;box-shadow:0 0 16px rgba(0,0,0,.15);padding:12px 16px;border-radius:12px}.smvp-side-bar-notification .smvp-side-bar-notification-message span.title{font-style:normal;font-weight:700;font-size:17px;line-height:20px}.smvp-side-bar-notification .smvp-side-bar-notification-message span.subtitle{font-style:normal;font-weight:600;font-size:14px;line-height:24px;word-break:break-all}.smvp-side-bar-notification .smvp-side-bar-notification-message button{background-color:#3687fa;color:#fff;border:none;border-radius:4px;white-space:nowrap;cursor:pointer}.no-player .smvp-side-bar-notification .smvp-side-bar-notification-message{flex-direction:column}.no-player .smvp-side-bar-notification .smvp-side-bar-notification-message span{margin-bottom:8px}.no-player .smvp-side-bar-notification .smvp-side-bar-notification-message button{padding:8px 16px}.with-player .smvp-side-bar-notification span.title{display:none}.with-player .smvp-side-bar-notification span.subtitle{text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.with-player .smvp-side-bar-notification button{margin-left:12px;padding:4px 12px}.smvp-video-player-wrapper.dark-mode .smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-poll-answer{background-color:var(--smvp-dark-mode-background-color);color:var(--smvp-dark-mode-color)}.smvp-video-player-wrapper.dark-mode .smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-poll-answer:not(.selected) input[type=radio]{border-color:var(--smvp-dark-mode-color)}.smvp-video-player-wrapper.dark-mode .smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-word-cloud .question{color:var(--smvp-dark-mode-color);border-color:var(--smvp-dark-mode-border-color);background-color:var(--smvp-dark-mode-background-color);background-color:hsla(0,0%,100%,0)}.smvp-video-player-wrapper.dark-mode .smvp-side-bar .smvp-sidebar-polls .smvp-expand-sidebar-button,.smvp-video-player-wrapper.dark-mode .smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-word-cloud .question.empty .question-text{color:var(--smvp-dark-mode-color);background-color:#3f4041}.smvp-video-player-wrapper.dark-mode .smvp-side-bar .smvp-sidebar-polls .smvp-expand-sidebar-button:hover{background-color:hsla(0,0%,100%,.2)}.smvp-video-player-wrapper.dark-mode .smvp-side-bar .smvp-sidebar-polls .smvp-expand-sidebar-button svg path{fill:var(--smvp-dark-mode-color)!important}.smvp-video-player-wrapper.dark-mode .smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-poll .smvp-sidebar-poll-answer:not(.disabled):hover{background-color:var(--smvp-dark-mode-background-color);background:hsla(0,0%,100%,.1)}.smvp-video-player-wrapper.dark-mode .smvp-side-bar .smvp-sidebar-polls .thank-you-alert{background-color:#484d51}.smvp-video-player-wrapper.dark-mode .smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-poll-result-answer{border-color:#484d51}.smvp-video-player-wrapper.dark-mode .smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-poll-result-answer.selected{border-color:#b1b3b8}.smvp-video-player-wrapper.dark-mode .smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-poll-result-answer.correct{border-color:#484d51}.smvp-video-player-wrapper.dark-mode .smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-poll-result-answer .gauge-bar .gauge-background{background-color:#484d51}.smvp-video-player-wrapper.dark-mode .smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-poll-result-answer .gauge-bar .gauge-foreground{background-color:#b1b3b8}.smvp-video-player-wrapper.dark-mode .smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-poll-countdown{border:1px solid #484d51}.smvp-side-bar .smvp-sidebar-polls{height:100%;overflow:auto;overflow-wrap:anywhere;padding-top:12px}.is-side-bar-below .smvp-side-bar .smvp-sidebar-polls footer button{height:32px;font-size:16px}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-poll-countdown{width:100%;border-radius:4px;border:1px solid #e3e6e8;margin-bottom:16px}.is-side-bar-below .smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-poll-countdown{order:1}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-poll-countdown .smvp-top-border{width:100%;height:4px;transition:width 1s linear}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-poll-countdown.blinking{animation:blink 1s infinite}@keyframes blink{50%{opacity:.5}}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-poll-countdown .smvp-countdown-timer{height:56px;display:flex;align-items:center}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-poll-countdown .smvp-countdown-timer .smvp-timer-wrapper{display:flex;margin-left:12px;align-items:center}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-poll-countdown .smvp-countdown-timer .smvp-timer-wrapper .smvp-icon{width:20px;height:20px}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-poll-countdown .smvp-countdown-timer .smvp-timer-wrapper span{margin-left:8px;font-weight:600;font-size:20px;line-height:32px}.smvp-side-bar .smvp-sidebar-polls .poll-wrapper{height:100%;width:100%}.smvp-side-bar .smvp-sidebar-polls .question{font-style:normal;font-weight:600;font-size:14px;line-height:24px}.smvp-side-bar .smvp-sidebar-polls .answer{font-style:normal;font-weight:400;font-size:14px;line-height:22px}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-poll-answer{border:1px solid #e3e6e8;background-color:#fff;margin:8px 0;padding:8px;border-radius:8px;display:flex;flex-direction:row;align-items:center}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-poll-answer input{margin:0;min-width:20px;accent-color:var(--smvp-polls-selected-border-color)}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-poll-answer input[type=radio]{-webkit-appearance:none;-moz-appearance:none;appearance:none;width:12px;height:12px;min-width:12px;max-width:12px;min-height:12px;max-height:12px;border:2px solid #e3e6e8;border-radius:100%;padding:0}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-poll-answer.selected{border:1px solid var(--smvp-polls-selected-border-color)}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-poll-answer.selected input[type=radio]{border:4px solid var(--smvp-polls-selected-border-color)}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-poll-answer span{margin-left:8px}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-poll,.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-poll-results,.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-poll-voted,.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-word-cloud{height:100%;padding:0 12px 0 12px}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-word-cloud .question{display:-webkit-box;-webkit-box-orient:vertical;overflow:hidden;text-overflow:ellipsis;-webkit-line-clamp:3;max-height:68px;min-height:68px}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-polls.smvp-tab.smvp-sidebar-polls-is-wordcloud,.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-word-cloud,.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-word-cloud .content{overflow:hidden;overflow-wrap:unset}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-poll .smvp-sidebar-poll-answer.selected,.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-poll-voted .smvp-sidebar-poll-answer.selected{border:1px solid var(--smvp-polls-selected-border-color)}.smvp-side-bar .smvp-sidebar-polls footer .notification{position:absolute;color:#fff;background:#4f4f4f;border-radius:4px;bottom:80px;box-sizing:border-box;width:calc(100% - 16px);padding:8px 16px}.is-side-bar-below .smvp-side-bar .smvp-sidebar-polls footer .notification{bottom:-40px}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-poll{display:flex;flex-direction:column;justify-content:space-between}.is-side-bar-below .smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-poll{flex-direction:column-reverse}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-poll .answer-limit-hint{font-size:12px;color:#7d8082}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-poll footer{position:relative;border-top:1px solid var(--border-color);padding:8px}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-poll footer button{float:right;line-height:1.4;color:#fff;background-color:#3687fa;padding:4px 12px;border:0;border-radius:4px;cursor:pointer}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-poll footer button:active{opacity:.75}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-poll footer button.disabled{cursor:not-allowed;pointer-events:none;opacity:.65;filter:alpha(opacity=65);box-shadow:none}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-poll .smvp-sidebar-poll-answer:not(.disabled),.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-poll .smvp-sidebar-poll-answer:not(.disabled) input{cursor:pointer}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-poll .smvp-sidebar-poll-answer:not(.disabled):hover{background-color:#f7f7f7}.smvp-side-bar .smvp-sidebar-polls .thank-you-wrapper{padding:0 12px 0 12px}.smvp-side-bar .smvp-sidebar-polls .thank-you-wrapper .thank-you-alert{display:flex;padding:12px;margin-bottom:8px;background-color:#d4f4e0;border-radius:8px}.smvp-side-bar .smvp-sidebar-polls .thank-you-wrapper .thank-you-alert span{margin-left:8px;font-style:normal;font-weight:600;font-size:12px;line-height:16px}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-poll-results .smvp-sidebar-poll-result-answer{margin:12px 0;padding:12px;border-radius:8px;border:1px solid #ddd}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-poll-results .smvp-sidebar-poll-result-answer.selected{border:1px solid #7d8082}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-poll-results .smvp-sidebar-poll-result-answer.correct{border:1px solid #d4f4e0}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-poll-results .smvp-sidebar-poll-result-answer.correct.selected{border:1px solid #2dd269}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-poll-results .smvp-sidebar-poll-result-answer .gauge-wrapper{position:relative;display:flex;flex-direction:row;align-items:center;height:16px;justify-content:space-between;margin-top:8px}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-poll-results .smvp-sidebar-poll-result-answer .gauge-wrapper .gauge-value{position:absolute;right:0;top:0}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-poll-results .smvp-sidebar-poll-result-answer .gauge-bar{position:relative;width:calc(100% - 60px);height:8px}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-poll-results .smvp-sidebar-poll-result-answer .gauge-bar .gauge-background,.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-poll-results .smvp-sidebar-poll-result-answer .gauge-bar .gauge-foreground{position:absolute;height:8px;border-radius:4px;left:0;top:0}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-poll-results .smvp-sidebar-poll-result-answer .gauge-bar .gauge-background{width:100%;background-color:#ddd}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-poll-results .smvp-sidebar-poll-result-answer .gauge-bar .gauge-background.correct{background-color:#d4f4e0}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-poll-results .smvp-sidebar-poll-result-answer .gauge-bar .gauge-foreground{background-color:#7d8082}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-poll-results .smvp-sidebar-poll-result-answer .gauge-bar .gauge-foreground.correct{background-color:#2dd269}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-nopoll{height:100%;padding:0 16px;display:flex;flex-direction:column;align-items:center;justify-content:center;min-height:100px}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-nopoll .subtitle,.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-nopoll .title{text-align:center}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-nopoll .title{font-weight:700}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-nopoll svg{height:32px;width:32px;padding:8px}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-word-cloud{display:flex;flex-direction:column;overflow:hidden}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-word-cloud .smvp-word-cloud-wrapper svg{transform:translateY(-20px);transition:transform .3s linear}.is-side-bar-below .smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-word-cloud{flex-direction:column-reverse}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-word-cloud .smvp-expand-sidebar-button{cursor:pointer;transform:translateY(-44px);padding:4px}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-word-cloud .smvp-expand-sidebar-button span{display:inline-block;transform:translateY(-1px)}.is-side-bar-below .smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-word-cloud .smvp-expand-sidebar-button{display:none}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-word-cloud section.content{display:flex;flex-direction:column}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-word-cloud section.content .question{position:relative;transform:translateY(0);background-color:#fff;border-radius:8px;padding:0;top:0;transition:top .3s linear,transform .3s linear,background-color .3s linear,background-color .3s linear,padding .3s linear,font-size .3s linear}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-word-cloud section.content .question .btn-collapse{position:absolute;top:0;right:0;padding-left:6px;width:32px;cursor:pointer;border-radius:3px;border:none;line-height:unset;padding-bottom:0;padding-top:8px;margin-left:8px;margin-bottom:16px}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-word-cloud section.content .question .btn-collapse svg{width:20px;height:20px}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-word-cloud section.content .question.empty{display:flex;transform:translateY(-50%);top:50%;max-height:-moz-fit-content;max-height:fit-content;justify-content:center}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-word-cloud section.content .question.empty .question-text{position:relative;height:-moz-fit-content;height:fit-content;background-color:#f1f2f4;color:#18191a;border-radius:8px;padding:12px}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-word-cloud section.content .word-cloud-wrapper{height:calc(100% - 63px)}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-word-cloud section.content .smvp-word-cloud-wrapper{width:100%;height:100%}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-word-cloud section.content .smvp-word-cloud-wrapper svg{max-height:100%}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-word-cloud footer{position:relative;border-top:1px solid var(--border-color);padding:8px}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-word-cloud footer input[type=text]{border:0;width:100%;height:22px;line-height:22px;margin-bottom:10px}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-word-cloud footer button:active,.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-word-cloud footer button:focus,.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-word-cloud footer button:focus:active,.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-word-cloud footer input:active,.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-word-cloud footer input:focus,.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-word-cloud footer input:focus:active{outline:none}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-word-cloud footer .options{display:flex;justify-content:space-between;align-items:center}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-word-cloud footer .options .char-count span{color:#aab3bb;font-weight:400;font-size:12px;line-height:16px}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-word-cloud footer .options .btn{line-height:1.4;margin-left:auto;color:#fff;background-color:#828282;padding:4px 12px;border:0;border-radius:4px;cursor:pointer}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-word-cloud footer .options .btn:active{opacity:.75}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-word-cloud footer .options .btn label{font-size:12px;font-weight:400;cursor:pointer;margin:0}.smvp-side-bar .smvp-sidebar-polls .smvp-sidebar-word-cloud footer .options .btn.disabled{cursor:not-allowed;pointer-events:none;opacity:.65;filter:alpha(opacity=65);box-shadow:none}.smvp-sidebar-wide .smvp-word-cloud-wrapper svg{transform:translateY(0)}.smvp-sidebar-wide .smvp-sidebar-polls .smvp-sidebar-word-cloud .content span.question{font-size:18px;max-height:48px;min-height:48px;border-radius:3px}.smvp-sidebar-wide .smvp-sidebar-polls .smvp-sidebar-word-cloud .content span.question .question-text{display:-webkit-box;-webkit-box-orient:vertical;overflow:hidden;text-overflow:ellipsis;-webkit-line-clamp:2;float:left;width:calc(100% - 32px)}.smvp-side-bar-narrowing section.content span.question{font-size:14px}.smvp-translation-tab{padding:12px}.smvp-translation-tab .header{margin-bottom:14px;font-style:normal;font-weight:600;font-size:12px;line-height:24px}.smvp-translation-tab iframe{border:none;border-radius:4px;max-width:calc(100% - 24px);max-height:calc(100% - 48px)}.smvp-video-player-wrapper.dark-mode .smvp-side-bar .smvp-qna footer{border-color:#484d51}.smvp-video-player-wrapper.dark-mode .smvp-side-bar .smvp-qna .smvp-question.from-bstg{background-color:#18191a}.smvp-video-player-wrapper.dark-mode .smvp-side-bar .smvp-qna section.qna-sorting-picker{box-shadow:inset 0 -1px 0 hsla(0,0%,100%,.2)}.smvp-video-player-wrapper.dark-mode .smvp-side-bar .smvp-qna section.qna-sorting-picker .orientation-toggler{color:#b1b3b8}.smvp-video-player-wrapper.dark-mode .smvp-side-bar .smvp-qna section.qna-sorting-picker .orientation-toggler:hover{background:#3f4041;color:#e4e6eb}.smvp-video-player-wrapper.dark-mode .smvp-side-bar .smvp-qna section.qna-sorting-picker .orientation-toggler:hover .smvp-icon path{fill:#e4e6eb}.smvp-video-player-wrapper.dark-mode .smvp-side-bar .smvp-qna .smvp-upvote-sortby .smvp-label{color:#e4e6eb}.smvp-video-player-wrapper.dark-mode .smvp-side-bar .smvp-qna .smvp-upvote-sortby .smvp-label.smvp-expanded,.smvp-video-player-wrapper.dark-mode .smvp-side-bar .smvp-qna .smvp-upvote-sortby .smvp-label:hover{background-color:#3f4041}.smvp-video-player-wrapper.dark-mode .smvp-side-bar .smvp-qna .smvp-upvote-sortby .smvp-label .smvp-arrow .smvp-icon path{fill:#e4e6eb}.smvp-video-player-wrapper.dark-mode .smvp-side-bar .smvp-qna .smvp-upvote-sortby .smvp-dropdown-content{background-color:#3f4041;color:#b1b3b8;border-color:#484d51}.smvp-video-player-wrapper.dark-mode .smvp-side-bar .smvp-qna .smvp-upvote-sortby .smvp-dropdown-content li:hover{background:#4f5051}.smvp-video-player-wrapper.dark-mode .smvp-side-bar .smvp-qna section.content{scrollbar-color:#3f4041 #7d8082}.smvp-video-player-wrapper.dark-mode .smvp-side-bar .smvp-qna section.content::-webkit-scrollbar,.smvp-video-player-wrapper.dark-mode .smvp-side-bar .smvp-qna section.content::-webkit-scrollbar-track{background-color:#3f4041}.smvp-video-player-wrapper.dark-mode .smvp-side-bar .smvp-qna section.content::-webkit-scrollbar-thumb{background-color:#7d8082}.smvp-qna{display:flex;flex-direction:column;overflow:auto}.is-side-bar-below .smvp-qna{flex-direction:column-reverse}.is-side-bar-below .smvp-qna .sticky-highlighted-question{padding:12px 0 8px 0;order:1;box-shadow:0 4px 12px -2px rgba(0,0,0,.1)}.is-side-bar-below .smvp-qna footer{order:3;border-top:none;border-bottom:1px solid #e3e6e8}.is-side-bar-below .smvp-qna footer button{height:32px;font-size:16px}.is-side-bar-below .smvp-qna section.qna-sorting-picker{order:2;justify-content:flex-end}.smvp-qna section.qna-sorting-picker{display:flex;align-items:center;padding:8px;box-shadow:inset 0 -1px 0 #e5e5e5}.smvp-qna section.qna-sorting-picker .orientation-toggler{display:flex;align-items:center;padding:8px;border-radius:4px;font-size:12px;line-height:16px;font-weight:400;color:#7d8082;cursor:pointer}.smvp-qna section.qna-sorting-picker .orientation-toggler .orientation-label{margin-right:4px}.smvp-qna section.qna-sorting-picker .orientation-toggler .smvp-icon path{fill:#7d8082}.smvp-qna section.qna-sorting-picker .orientation-toggler:hover{background:#f3f3f3;color:#18191a}.smvp-qna section.qna-sorting-picker .orientation-toggler:hover .smvp-icon path{fill:#18191a}.smvp-qna section.qna-sorting-picker .smvp-upvote-sortby{margin-left:auto}.smvp-qna section.qna-sorting-picker .smvp-upvote-sortby .smvp-label{cursor:pointer;margin-left:auto;padding:8px;border-radius:4px;font-weight:600;font-size:12px;line-height:16px;color:#18191a}.smvp-qna section.qna-sorting-picker .smvp-upvote-sortby .smvp-label.smvp-expanded,.smvp-qna section.qna-sorting-picker .smvp-upvote-sortby .smvp-label:hover{background:#f3f3f3}.smvp-qna section.qna-sorting-picker .smvp-upvote-sortby .smvp-dropdown-content{color:#7d8082;border-radius:4px;padding:4px;background-color:#fff}.smvp-qna section.qna-sorting-picker .smvp-upvote-sortby .smvp-dropdown-content li.smvp-dropdown-selected{color:var(--smvp-tab-active-color)}.smvp-qna section.qna-sorting-picker .smvp-upvote-sortby .smvp-dropdown-content li:hover{background:#f3f3f3}.smvp-qna .smvp-question.from-bstg{background-color:#f3f3f3}.smvp-qna section.content{display:flex;flex-direction:column-reverse;overflow:unset}.is-side-bar-below .smvp-qna section.content{flex-direction:column}.smvp-qna section.content.empty{justify-content:center}.smvp-qna section.content.align-top{justify-content:flex-start;flex-direction:column}.smvp-qna .smvp-no-questions{height:100%;padding:0 16px;display:flex;flex-direction:column;align-items:center;justify-content:center;min-height:100px}.smvp-qna .smvp-no-questions .subtitle,.smvp-qna .smvp-no-questions .title{text-align:center}.smvp-qna .smvp-no-questions .title{font-weight:700}.smvp-qna .smvp-no-questions svg{height:32px;width:32px;padding:8px}.smvp-qna .sticky-highlighted-question{padding:8px 0 0 0;box-shadow:0 2px 12px rgba(0,0,0,.1)}.smvp-qna .sticky-highlighted-question .smvp-question{padding-top:0}.smvp-qna .sticky-highlighted-question .answering-now span{border-radius:2px;text-transform:uppercase;font-weight:700;font-size:10px;line-height:16px;padding:2px 4px}.smvp-qna .sticky-highlighted-question .question-body{max-height:64px;overflow:auto}.smvp-qna .smvp-question{padding:8px}.smvp-qna .smvp-question .question-header{display:flex;justify-content:space-between}.smvp-qna .smvp-question .question-body{margin-left:40px;overflow-wrap:break-word}.smvp-qna .smvp-question .question-body p{margin:0}.smvp-qna .smvp-question a.link{word-break:break-all;overflow-wrap:anywhere}.smvp-qna .smvp-question a.link.disabled{color:#333;cursor:not-allowed}.smvp-qna .smvp-question .answering-now{margin-bottom:6px}.smvp-qna .smvp-question .answering-now span{text-transform:uppercase;font-weight:700;font-size:10px;line-height:16px;border-radius:2px;padding:2px 4px}.smvp-qna .smvp-question:first-child{margin-top:auto}.smvp-qna .smvp-question:last-child{border-bottom:0}.smvp-qna .smvp-question small{font-weight:500;font-size:12px;color:#828282}.smvp-qna .highlight{border-radius:16px;box-shadow:0 0 4px rgba(0,0,0,.5);position:absolute;bottom:72px;left:calc(50% - 141px);transform:translateX(-50%);width:300px;background-color:#fff;z-index:11}.smvp-qna .highlight.fullscreen{position:fixed;z-index:1012}.smvp-qna .highlight .smvp-question{padding:8px 16px}.smvp-qna .highlight .smvp-question .title{line-height:20px;font-size:12px}.smvp-qna .highlight .smvp-question .avatar,.smvp-qna .highlight .smvp-question .picture{font-size:10px;font-weight:700;height:20px;width:20px;line-height:20px}.smvp-qna .highlight .smvp-question .question-body{max-height:128px;overflow:auto}.smvp-qna footer{position:relative;border-top:1px solid #e3e6e8;padding:8px}.smvp-qna footer input[type=text]{border:0;width:100%;height:22px;line-height:22px;margin-bottom:10px}.smvp-qna footer input[type=checkbox]{margin-right:8px}.smvp-qna footer button:active,.smvp-qna footer button:focus,.smvp-qna footer button:focus:active,.smvp-qna footer input:active,.smvp-qna footer input:focus,.smvp-qna footer input:focus:active{outline:none}.smvp-qna footer .options .checkbox{display:block;position:relative;float:left;padding-left:25px;cursor:pointer;margin-top:5px;margin-bottom:0;-webkit-user-select:none;-moz-user-select:none;user-select:none}.smvp-qna footer .options .checkbox input{position:absolute;opacity:0;cursor:pointer;height:0;width:0}.smvp-qna footer .options .checkbox .checkmark,.smvp-qna footer .options .checkbox .checkmark-anonymous{box-sizing:border-box;position:absolute;top:0;left:0;height:15px;width:15px;border-radius:4px}.smvp-qna footer .options .checkbox .checkmark-anonymous:after{box-sizing:border-box;content:"";position:absolute;left:5px;top:2px;width:5px;height:10px;border:solid #fff;border-width:0 3px 3px 0;transform:rotate(45deg)}.smvp-qna footer .options .btn{float:right;line-height:1.4;color:#fff;background-color:#828282;padding:4px 12px;border:0;border-radius:4px;cursor:pointer}.smvp-qna footer .options .btn:active{opacity:.75}.smvp-qna footer .options .btn label{font-size:12px;font-weight:400;cursor:pointer;margin:0}.smvp-qna footer .options .btn.disabled{cursor:not-allowed;pointer-events:none;opacity:.65;filter:alpha(opacity=65);box-shadow:none}.smvp-qna .post-notification{color:#fff;background:#4f4f4f;position:absolute;border-radius:4px;bottom:80px;box-sizing:border-box;width:calc(100% - 16px);padding:8px 16px}.is-side-bar-below .smvp-qna .post-notification{bottom:-40px}.smvp-qna .smvp-questions-enter-active,.smvp-qna .smvp-questions-leave-active,.smvp-qna .smvp-questions-move{transition:all .5s cubic-bezier(.55,0,.1,1)}.smvp-qna .smvp-questions-enter-from,.smvp-qna .smvp-questions-leave-to{opacity:0;transform:scaleY(.01) translate(30px)}.smvp-qna .smvp-questions-leave-active{position:absolute}:root{--smvp-dark-mode-background-color:initial;--smvp-dark-mode-color:initial;--smvp-dark-mode-border-color:initial;--smvp-tab-active-color:initial;--smvp-polls-selected-border-color:initial;--smvp-upvote-color:initial}.smvp-stream-tab .stream-wrapper{height:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;min-height:100px;padding:0 16px}.smvp-stream-tab .subtitle,.smvp-stream-tab .title{text-align:center}.smvp-stream-tab .title{font-weight:700;padding-bottom:4px}.smvp-stream-tab .btn{cursor:pointer;margin-top:16px;padding:4px 12px;border:0;border-radius:4px;line-height:1.4}.smvp-stream-tab .smvp-icon{height:32px;width:32px;padding-bottom:8px}.smvp-word-cloud-empty{display:flex;justify-content:center;align-items:center;height:100%;width:100%}.smvp-word-cloud-empty .smvp-word-cloud-empty-text{display:block}.smvp-word-cloud-group,.smvp-word-cloud-inner-wrapper{transition:transform 1s ease-in-out}.smvp-video-player-wrapper{display:flex;position:relative;flex-direction:row;height:100%;width:100%;overflow:hidden}.smvp-video-player-wrapper .splitpanes--vertical{align-items:center}.smvp-video-player-wrapper .splitpanes.default-theme .splitpanes__pane{background-color:#000}.smvp-video-player-wrapper .splitpanes{background-color:#000;-webkit-user-select:none;-moz-user-select:none;user-select:none}.smvp-video-player-wrapper .splitpanes.has-no-split-panes .splitpanes__splitter{display:none}.smvp-video-player-wrapper .splitpanes.has-no-split-panes .splitpanes__pane{display:flex;height:100%}.smvp-video-player-wrapper .splitpanes .splitpanes__pane{position:relative;height:unset}.smvp-video-player-wrapper .splitpanes .splitpanes__splitter{height:100%;width:10px;background:#333;border:none}.smvp-video-player-wrapper .splitpanes .splitpanes__splitter:before{background-color:#fff;width:4px;height:20px;border-radius:4px}.smvp-video-player-wrapper .splitpanes .splitpanes__splitter:after{display:none}.smvp-video-player-wrapper .splitpanes .splitpanes__splitter:hover:before{height:100%;width:1px;margin-left:-1px;background-color:#fff}.smvp-video-player-wrapper.is-side-bar-below{flex-direction:column}.smvp-video-player-wrapper.is-side-bar-below input[type=number],.smvp-video-player-wrapper.is-side-bar-below input[type=text],.smvp-video-player-wrapper.is-side-bar-below textarea{font-size:16px}.smvp-video-player-wrapper.is-side-bar-below .splitpanes__pane{display:flex;justify-content:center}.smvp-video-player-wrapper.is-side-bar-below .splitpanes__splitter{height:10px;width:100%}.smvp-tooltip{position:relative}.smvp-tooltip .smvp-tooltiptext{height:unset;display:none;position:relative;background-color:#000;color:#fff;text-align:center;border-radius:4px;border:1px solid hsla(0,0%,100%,.2);padding:4px 8px;width:96px;bottom:32px;font-size:12px;transition:opacity .2s ease-in-out;opacity:0;clip:unset}.smvp-tooltip .smvp-tooltiptext.left{position:absolute;left:-24px}.smvp-tooltip .smvp-tooltiptext.right{position:absolute;right:-8px}.smvp-show-tooltip-on-hover:hover .smvp-tooltip .smvp-tooltiptext,.smvp-tooltip .smvp-tooltiptext.smvp-in{display:block;opacity:.9}',""]),e["default"]=h},2483:function(t,e,i){"use strict";i.r(e);var s=i(8081),n=i.n(s),r=i(3645),o=i.n(r),a=o()(n());a.push([t.id,".smvp-word-cloud-empty{display:flex;justify-content:center;align-items:center;height:100%;width:100%}.smvp-word-cloud-empty .smvp-word-cloud-empty-text{display:block}.smvp-word-cloud-group,.smvp-word-cloud-inner-wrapper{transition:transform 1s ease-in-out}",""]),e["default"]=a},6672:function(t,e,i){"use strict";var s=i(8081),n=i.n(s),r=i(3645),o=i.n(r),a=o()(n());a.push([t.id,'.splitpanes{display:flex;width:100%;height:100%}.splitpanes--vertical{flex-direction:row}.splitpanes--horizontal{flex-direction:column}.splitpanes--dragging *{-webkit-user-select:none;-moz-user-select:none;user-select:none}.splitpanes__pane{width:100%;height:100%;overflow:hidden}.splitpanes--vertical .splitpanes__pane{transition:width .2s ease-out}.splitpanes--horizontal .splitpanes__pane{transition:height .2s ease-out}.splitpanes--dragging .splitpanes__pane{transition:none}.splitpanes__splitter{touch-action:none}.splitpanes--vertical>.splitpanes__splitter{min-width:1px;cursor:col-resize}.splitpanes--horizontal>.splitpanes__splitter{min-height:1px;cursor:row-resize}.splitpanes.default-theme .splitpanes__pane{background-color:#f2f2f2}.splitpanes.default-theme .splitpanes__splitter{background-color:#fff;box-sizing:border-box;position:relative;flex-shrink:0}.splitpanes.default-theme .splitpanes__splitter:after,.splitpanes.default-theme .splitpanes__splitter:before{content:"";position:absolute;top:50%;left:50%;background-color:#00000026;transition:background-color .3s}.splitpanes.default-theme .splitpanes__splitter:hover:after,.splitpanes.default-theme .splitpanes__splitter:hover:before{background-color:#00000040}.splitpanes.default-theme .splitpanes__splitter:first-child{cursor:auto}.default-theme.splitpanes .splitpanes .splitpanes__splitter{z-index:1}.default-theme .splitpanes--vertical>.splitpanes__splitter,.default-theme.splitpanes--vertical>.splitpanes__splitter{width:7px;border-left:1px solid #eee;margin-left:-1px}.default-theme .splitpanes--vertical>.splitpanes__splitter:after,.default-theme .splitpanes--vertical>.splitpanes__splitter:before,.default-theme.splitpanes--vertical>.splitpanes__splitter:after,.default-theme.splitpanes--vertical>.splitpanes__splitter:before{transform:translateY(-50%);width:1px;height:30px}.default-theme .splitpanes--vertical>.splitpanes__splitter:before,.default-theme.splitpanes--vertical>.splitpanes__splitter:before{margin-left:-2px}.default-theme .splitpanes--vertical>.splitpanes__splitter:after,.default-theme.splitpanes--vertical>.splitpanes__splitter:after{margin-left:1px}.default-theme .splitpanes--horizontal>.splitpanes__splitter,.default-theme.splitpanes--horizontal>.splitpanes__splitter{height:7px;border-top:1px solid #eee;margin-top:-1px}.default-theme .splitpanes--horizontal>.splitpanes__splitter:after,.default-theme .splitpanes--horizontal>.splitpanes__splitter:before,.default-theme.splitpanes--horizontal>.splitpanes__splitter:after,.default-theme.splitpanes--horizontal>.splitpanes__splitter:before{transform:translate(-50%);width:30px;height:1px}.default-theme .splitpanes--horizontal>.splitpanes__splitter:before,.default-theme.splitpanes--horizontal>.splitpanes__splitter:before{margin-top:-2px}.default-theme .splitpanes--horizontal>.splitpanes__splitter:after,.default-theme.splitpanes--horizontal>.splitpanes__splitter:after{margin-top:1px}',""]),e["Z"]=a},3645:function(t){"use strict";t.exports=function(t){var e=[];return e.toString=function(){return this.map((function(e){var i="",s="undefined"!==typeof e[5];return e[4]&&(i+="@supports (".concat(e[4],") {")),e[2]&&(i+="@media ".concat(e[2]," {")),s&&(i+="@layer".concat(e[5].length>0?" ".concat(e[5]):""," {")),i+=t(e),s&&(i+="}"),e[2]&&(i+="}"),e[4]&&(i+="}"),i})).join("")},e.i=function(t,i,s,n,r){"string"===typeof t&&(t=[[null,t,void 0]]);var o={};if(s)for(var a=0;a<this.length;a++){var l=this[a][0];null!=l&&(o[l]=!0)}for(var c=0;c<t.length;c++){var d=[].concat(t[c]);s&&o[d[0]]||("undefined"!==typeof r&&("undefined"===typeof d[5]||(d[1]="@layer".concat(d[5].length>0?" ".concat(d[5]):""," {").concat(d[1],"}")),d[5]=r),i&&(d[2]?(d[1]="@media ".concat(d[2]," {").concat(d[1],"}"),d[2]=i):d[2]=i),n&&(d[4]?(d[1]="@supports (".concat(d[4],") {").concat(d[1],"}"),d[4]=n):d[4]="".concat(n)),e.push(d))}},e}},1667:function(t){"use strict";t.exports=function(t,e){return e||(e={}),t?(t=String(t.__esModule?t.default:t),/^['"].*['"]$/.test(t)&&(t=t.slice(1,-1)),e.hash&&(t+=e.hash),/["'() \t\n]|(%20)/.test(t)||e.needQuotes?'"'.concat(t.replace(/"/g,'\\"').replace(/\n/g,"\\n"),'"'):t):t}},8081:function(t){"use strict";t.exports=function(t){return t[1]}},6929:function(t,e,i){var s=i(6724).W,n=Math.PI/180,r=64,o=2048;function a(t){return t.text}function l(){return"serif"}function c(){return"normal"}function d(t){return Math.sqrt(t.value)}function u(){return 30*(~~(6*Math.random())-3)}function h(){return 1}function p(t,e,i,s){if(!e.sprite){var a=t.context,l=t.ratio;a.clearRect(0,0,(r<<5)/l,o/l);var c=0,d=0,u=0,h=i.length;--s;while(++s<h){e=i[s],a.save(),a.font=e.style+" "+e.weight+" "+~~((e.size+1)/l)+"px "+e.font;var p=a.measureText(e.text+"m").width*l,f=e.size<<1;if(e.rotate){var m=Math.sin(e.rotate*n),v=Math.cos(e.rotate*n),g=p*v,y=p*m,b=f*v,w=f*m;p=Math.max(Math.abs(g+w),Math.abs(g-w))+31>>5<<5,f=~~Math.max(Math.abs(y+b),Math.abs(y-b))}else p=p+31>>5<<5;if(f>u&&(u=f),c+p>=r<<5&&(c=0,d+=u,u=0),d+f>=o)break;a.translate((c+(p>>1))/l,(d+(f>>1))/l),e.rotate&&a.rotate(e.rotate*n),a.fillText(e.text,0,0),e.padding&&(a.lineWidth=2*e.padding,a.strokeText(e.text,0,0)),a.restore(),e.width=p,e.height=f,e.xoff=c,e.yoff=d,e.x1=p>>1,e.y1=f>>1,e.x0=-e.x1,e.y0=-e.y1,e.hasText=!0,c+=p}var S=a.getImageData(0,0,(r<<5)/l,o/l).data,E=[];while(--s>=0)if(e=i[s],e.hasText){p=e.width;for(var T=p>>5,x=(f=e.y1-e.y0,0);x<f*T;x++)E[x]=0;if(c=e.xoff,null==c)return;d=e.yoff;for(var C=0,_=-1,k=0;k<f;k++){for(x=0;x<p;x++){var L=T*k+(x>>5),A=S[(d+k)*(r<<5)+(c+x)<<2]?1<<31-x%32:0;E[L]|=A,C|=A}C?_=k:(e.y0++,f--,k--,d++)}e.y1=e.y0+_,e.sprite=E.slice(0,(e.y1-e.y0)*T)}}}function f(t,e,i){i>>=5;for(var s,n=t.sprite,r=t.width>>5,o=t.x-(r<<4),a=127&o,l=32-a,c=t.y1-t.y0,d=(t.y+t.y0)*i+(o>>5),u=0;u<c;u++){s=0;for(var h=0;h<=r;h++)if((s<<l|(h<r?(s=n[u*r+h])>>>a:0))&e[d+h])return!0;d+=i}return!1}function m(t,e){var i=t[0],s=t[1];e.x+e.x0<i.x&&(i.x=e.x+e.x0),e.y+e.y0<i.y&&(i.y=e.y+e.y0),e.x+e.x1>s.x&&(s.x=e.x+e.x1),e.y+e.y1>s.y&&(s.y=e.y+e.y1)}function v(t,e){return t.x+t.x1>e[0].x&&t.x+t.x0<e[1].x&&t.y+t.y1>e[0].y&&t.y+t.y0<e[1].y}function g(t){var e=t[0]/t[1];return function(t){return[e*(t*=.1)*Math.cos(t),t*Math.sin(t)]}}function y(t){var e=4,i=e*t[0]/t[1],s=0,n=0;return function(t){var r=t<0?-1:1;switch(Math.sqrt(1+4*r*t)-r&3){case 0:s+=i;break;case 1:n+=e;break;case 2:s-=i;break;default:n-=e;break}return[s,n]}}function b(t){var e=[],i=-1;while(++i<t)e[i]=0;return e}function w(){return document.createElement("canvas")}function S(t){return"function"===typeof t?t:function(){return t}}t.exports=function(){var t=[256,256],e=a,i=l,n=d,y=c,T=c,x=u,C=h,_=g,k=[],L=1/0,A=s("word","end"),R=null,I=Math.random,D={},P=w;function O(t){t.width=t.height=1;var e=Math.sqrt(t.getContext("2d").getImageData(0,0,1,1).data.length>>2);t.width=(r<<5)/e,t.height=o/e;var i=t.getContext("2d");return i.fillStyle=i.strokeStyle="red",i.textAlign="center",{context:i,ratio:e}}function M(e,i,s){t[0],t[1];var n,r,o,a=i.x,l=i.y,c=Math.sqrt(t[0]*t[0]+t[1]*t[1]),d=_(t),u=I()<.5?1:-1,h=-u;while(n=d(h+=u)){if(r=~~n[0],o=~~n[1],Math.min(Math.abs(r),Math.abs(o))>=c)break;if(i.x=a+r,i.y=l+o,!(i.x+i.x0<0||i.y+i.y0<0||i.x+i.x1>t[0]||i.y+i.y1>t[1])&&(!s||!f(i,e,t[0]))&&(!s||v(i,s))){for(var p,m=i.sprite,g=i.width>>5,y=t[0]>>5,b=i.x-(g<<4),w=127&b,S=32-w,E=i.y1-i.y0,T=(i.y+i.y0)*y+(b>>5),x=0;x<E;x++){p=0;for(var C=0;C<=g;C++)e[T+C]|=p<<S|(C<g?(p=m[x*g+C])>>>w:0);T+=y}return delete i.sprite,!0}}return!1}return D.canvas=function(t){return arguments.length?(P=S(t),D):P},D.start=function(){var s=O(P()),r=b((t[0]>>5)*t[1]),o=null,a=k.length,l=-1,c=[],d=k.map((function(t,s){return t.text=e.call(this,t,s),t.font=i.call(this,t,s),t.style=y.call(this,t,s),t.weight=T.call(this,t,s),t.rotate=x.call(this,t,s),t.size=~~n.call(this,t,s),t.padding=C.call(this,t,s),t})).sort((function(t,e){return e.size-t.size}));return R&&clearInterval(R),R=setInterval(u,0),u(),D;function u(){var e=Date.now();while(Date.now()-e<L&&++l<a&&R){var i=d[l];i.x=t[0]*(I()+.5)>>1,i.y=t[1]*(I()+.5)>>1,p(s,i,d,l),i.hasText&&M(r,i,o)&&(c.push(i),A.call("word",D,i),o?m(o,i):o=[{x:i.x+i.x0,y:i.y+i.y0},{x:i.x+i.x1,y:i.y+i.y1}],i.x-=t[0]>>1,i.y-=t[1]>>1)}l>=a&&(D.stop(),A.call("end",D,c,o))}},D.stop=function(){return R&&(clearInterval(R),R=null),D},D.timeInterval=function(t){return arguments.length?(L=null==t?1/0:t,D):L},D.words=function(t){return arguments.length?(k=t,D):k},D.size=function(e){return arguments.length?(t=[+e[0],+e[1]],D):t},D.font=function(t){return arguments.length?(i=S(t),D):i},D.fontStyle=function(t){return arguments.length?(y=S(t),D):y},D.fontWeight=function(t){return arguments.length?(T=S(t),D):T},D.rotate=function(t){return arguments.length?(x=S(t),D):x},D.text=function(t){return arguments.length?(e=S(t),D):e},D.spiral=function(t){return arguments.length?(_=E[t]||t,D):_},D.fontSize=function(t){return arguments.length?(n=S(t),D):n},D.padding=function(t){return arguments.length?(C=S(t),D):C},D.random=function(t){return arguments.length?(I=t,D):I},D.on=function(){var t=A.on.apply(A,arguments);return t===A?D:t},D};var E={archimedean:g,rectangular:y}},6724:function(t,e,i){"use strict";i.d(e,{W:function(){return c}});var s={value:function(){}};function n(){for(var t,e=0,i=arguments.length,s={};e<i;++e){if(!(t=arguments[e]+"")||t in s||/[\s.]/.test(t))throw new Error("illegal type: "+t);s[t]=[]}return new r(s)}function r(t){this._=t}function o(t,e){return t.trim().split(/^|\s+/).map((function(t){var i="",s=t.indexOf(".");if(s>=0&&(i=t.slice(s+1),t=t.slice(0,s)),t&&!e.hasOwnProperty(t))throw new Error("unknown type: "+t);return{type:t,name:i}}))}function a(t,e){for(var i,s=0,n=t.length;s<n;++s)if((i=t[s]).name===e)return i.value}function l(t,e,i){for(var n=0,r=t.length;n<r;++n)if(t[n].name===e){t[n]=s,t=t.slice(0,n).concat(t.slice(n+1));break}return null!=i&&t.push({name:e,value:i}),t}r.prototype=n.prototype={constructor:r,on:function(t,e){var i,s=this._,n=o(t+"",s),r=-1,c=n.length;if(!(arguments.length<2)){if(null!=e&&"function"!==typeof e)throw new Error("invalid callback: "+e);while(++r<c)if(i=(t=n[r]).type)s[i]=l(s[i],t.name,e);else if(null==e)for(i in s)s[i]=l(s[i],t.name,null);return this}while(++r<c)if((i=(t=n[r]).type)&&(i=a(s[i],t.name)))return i},copy:function(){var t={},e=this._;for(var i in e)t[i]=e[i].slice();return new r(t)},call:function(t,e){if((i=arguments.length-2)>0)for(var i,s,n=new Array(i),r=0;r<i;++r)n[r]=arguments[r+2];if(!this._.hasOwnProperty(t))throw new Error("unknown type: "+t);for(s=this._[t],r=0,i=s.length;r<i;++r)s[r].value.apply(e,n)},apply:function(t,e,i){if(!this._.hasOwnProperty(t))throw new Error("unknown type: "+t);for(var s=this._[t],n=0,r=s.length;n<r;++n)s[n].value.apply(e,i)}};var c=n},4491:function(t,e){"use strict";e.__esModule=!0,e["default"]=void 0;var i=["change","keydown","mousedown","mousemove","mouseup","orientationchange","resize","scroll","touchend","touchmove","touchstart","visibilitychange"],s=i;e["default"]=s},6862:function(t,e,i){"use strict";e.Z=void 0;var s=r(i(4491)),n=r(i(3641));function r(t){return t&&t.__esModule?t:{default:t}}var o=t=>{},a=500,l=3e4,c={capture:!1,passive:!1};class d{constructor(t){var e=this,{timeout:i=l,onIdleCallback:r=o,events:d=s.default,throttle:u=a}=t;this.start=function(t){var{onIdleCallback:i}=void 0===t?{}:t;e.callback=i||e.callback,e.handleEvent=e.handleEvent.bind(e),e.listeners=e.events.map((t=>(document.addEventListener(t,e.handleEvent,!!n.default&&c),t))),e.startTimer.call(e)},this.startTimer=()=>{this.state.lastActive=Date.now(),this.resetTimer()},this.handleEvent=t=>{var e=Date.now();e-this.state.lastActive<this.throttleTime||("mousemove"!==t.type&&"touchmove"!==t.type||this.resetTimer(t),this.state.idle&&this.callback({event:t,idle:!1}),this.state.idle=!1,this.resetTimer())},this.resetTimer=t=>{var e=Date.now();this.clearTimer(),this.state.lastActive=e,this.timer=setTimeout((()=>{this.state.idle||this.callback({event:t,idle:!0}),this.state.idle=!0,this.resetTimer(t)}),this.timeout)},this.isIdle=()=>this.state.idle,this.clearTimer=()=>{this.timer&&(clearTimeout(this.timer),this.timer=null)},this.end=()=>{this.listeners.length&&this.listeners.forEach((t=>document.removeEventListener(t,this.handleEvent,!!n.default&&c))),this.clearTimer()},this.callback=r,this.events=d,this.listeners=[],this.throttleTime=u,this.timeout=i,this.timer=null,this.state={idle:!1,lastActive:0}}}var u=d;e.Z=u},3641:function(t,e){"use strict";e.__esModule=!0,e["default"]=void 0;var i=!1;if("undefined"!==typeof window)try{var s=Object.defineProperty({},"passive",{get(){return i=!0,!1}}),n=()=>{};window.addEventListener("test",n,s),window.removeEventListener("test",n,s)}catch(o){i=!1}var r=i;e["default"]=r},2433:function(t,e,i){"use strict";function s(t){return t&&"object"===typeof t&&"default"in t?t["default"]:t}var n=s(i(144));function r(t){return r="function"===typeof Symbol&&"symbol"===typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"===typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},r(t)}function o(t){return a(t)||l(t)||c()}function a(t){if(Array.isArray(t)){for(var e=0,i=new Array(t.length);e<t.length;e++)i[e]=t[e];return i}}function l(t){if(Symbol.iterator in Object(t)||"[object Arguments]"===Object.prototype.toString.call(t))return Array.from(t)}function c(){throw new TypeError("Invalid attempt to spread non-iterable instance")}var d="undefined"!==typeof window;function u(t){return Array.isArray(t)||"object"===r(t)?Object.freeze(t):t}function h(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return t.reduce((function(t,i){var s=i.passengers[0],n="function"===typeof s?s(e):i.passengers;return t.concat(n)}),[])}function p(t,e){return t.map((function(t,e){return[e,t]})).sort((function(t,i){return e(t[1],i[1])||t[0]-i[0]})).map((function(t){return t[1]}))}function f(t,e){return e.reduce((function(e,i){return t.hasOwnProperty(i)&&(e[i]=t[i]),e}),{})}var m={},v={},g={},y=n.extend({data:function(){return{transports:m,targets:v,sources:g,trackInstances:d}},methods:{open:function(t){if(d){var e=t.to,i=t.from,s=t.passengers,r=t.order,o=void 0===r?1/0:r;if(e&&i&&s){var a={to:e,from:i,passengers:u(s),order:o},l=Object.keys(this.transports);-1===l.indexOf(e)&&n.set(this.transports,e,[]);var c=this.$_getTransportIndex(a),h=this.transports[e].slice(0);-1===c?h.push(a):h[c]=a,this.transports[e]=p(h,(function(t,e){return t.order-e.order}))}}},close:function(t){var e=arguments.length>1&&void 0!==arguments[1]&&arguments[1],i=t.to,s=t.from;if(i&&(s||!1!==e)&&this.transports[i])if(e)this.transports[i]=[];else{var n=this.$_getTransportIndex(t);if(n>=0){var r=this.transports[i].slice(0);r.splice(n,1),this.transports[i]=r}}},registerTarget:function(t,e,i){d&&(this.trackInstances&&!i&&this.targets[t]&&console.warn("[portal-vue]: Target ".concat(t," already exists")),this.$set(this.targets,t,Object.freeze([e])))},unregisterTarget:function(t){this.$delete(this.targets,t)},registerSource:function(t,e,i){d&&(this.trackInstances&&!i&&this.sources[t]&&console.warn("[portal-vue]: source ".concat(t," already exists")),this.$set(this.sources,t,Object.freeze([e])))},unregisterSource:function(t){this.$delete(this.sources,t)},hasTarget:function(t){return!(!this.targets[t]||!this.targets[t][0])},hasSource:function(t){return!(!this.sources[t]||!this.sources[t][0])},hasContentFor:function(t){return!!this.transports[t]&&!!this.transports[t].length},$_getTransportIndex:function(t){var e=t.to,i=t.from;for(var s in this.transports[e])if(this.transports[e][s].from===i)return+s;return-1}}}),b=new y(m),w=1,S=n.extend({name:"portal",props:{disabled:{type:Boolean},name:{type:String,default:function(){return String(w++)}},order:{type:Number,default:0},slim:{type:Boolean},slotProps:{type:Object,default:function(){return{}}},tag:{type:String,default:"DIV"},to:{type:String,default:function(){return String(Math.round(1e7*Math.random()))}}},created:function(){var t=this;this.$nextTick((function(){b.registerSource(t.name,t)}))},mounted:function(){this.disabled||this.sendUpdate()},updated:function(){this.disabled?this.clear():this.sendUpdate()},beforeDestroy:function(){b.unregisterSource(this.name),this.clear()},watch:{to:function(t,e){e&&e!==t&&this.clear(e),this.sendUpdate()}},methods:{clear:function(t){var e={from:this.name,to:t||this.to};b.close(e)},normalizeSlots:function(){return this.$scopedSlots.default?[this.$scopedSlots.default]:this.$slots.default},normalizeOwnChildren:function(t){return"function"===typeof t?t(this.slotProps):t},sendUpdate:function(){var t=this.normalizeSlots();if(t){var e={from:this.name,to:this.to,passengers:o(t),order:this.order};b.open(e)}else this.clear()}},render:function(t){var e=this.$slots.default||this.$scopedSlots.default||[],i=this.tag;return e&&this.disabled?e.length<=1&&this.slim?this.normalizeOwnChildren(e)[0]:t(i,[this.normalizeOwnChildren(e)]):this.slim?t():t(i,{class:{"v-portal":!0},style:{display:"none"},key:"v-portal-placeholder"})}}),E=n.extend({name:"portalTarget",props:{multiple:{type:Boolean,default:!1},name:{type:String,required:!0},slim:{type:Boolean,default:!1},slotProps:{type:Object,default:function(){return{}}},tag:{type:String,default:"div"},transition:{type:[String,Object,Function]}},data:function(){return{transports:b.transports,firstRender:!0}},created:function(){var t=this;this.$nextTick((function(){b.registerTarget(t.name,t)}))},watch:{ownTransports:function(){this.$emit("change",this.children().length>0)},name:function(t,e){b.unregisterTarget(e),b.registerTarget(t,this)}},mounted:function(){var t=this;this.transition&&this.$nextTick((function(){t.firstRender=!1}))},beforeDestroy:function(){b.unregisterTarget(this.name)},computed:{ownTransports:function(){var t=this.transports[this.name]||[];return this.multiple?t:0===t.length?[]:[t[t.length-1]]},passengers:function(){return h(this.ownTransports,this.slotProps)}},methods:{children:function(){return 0!==this.passengers.length?this.passengers:this.$scopedSlots.default?this.$scopedSlots.default(this.slotProps):this.$slots.default||[]},noWrapper:function(){var t=this.slim&&!this.transition;return t&&this.children().length>1&&console.warn("[portal-vue]: PortalTarget with `slim` option received more than one child element."),t}},render:function(t){var e=this.noWrapper(),i=this.children(),s=this.transition||this.tag;return e?i[0]:this.slim&&!s?t():t(s,{props:{tag:this.transition&&this.tag?this.tag:void 0},class:{"vue-portal-target":!0}},i)}}),T=0,x=["disabled","name","order","slim","slotProps","tag","to"],C=["multiple","transition"],_=n.extend({name:"MountingPortal",inheritAttrs:!1,props:{append:{type:[Boolean,String]},bail:{type:Boolean},mountTo:{type:String,required:!0},disabled:{type:Boolean},name:{type:String,default:function(){return"mounted_"+String(T++)}},order:{type:Number,default:0},slim:{type:Boolean},slotProps:{type:Object,default:function(){return{}}},tag:{type:String,default:"DIV"},to:{type:String,default:function(){return String(Math.round(1e7*Math.random()))}},multiple:{type:Boolean,default:!1},targetSlim:{type:Boolean},targetSlotProps:{type:Object,default:function(){return{}}},targetTag:{type:String,default:"div"},transition:{type:[String,Object,Function]}},created:function(){if("undefined"!==typeof document){var t=document.querySelector(this.mountTo);if(t){var e=this.$props;if(b.targets[e.name])e.bail?console.warn("[portal-vue]: Target ".concat(e.name," is already mounted.\n        Aborting because 'bail: true' is set")):this.portalTarget=b.targets[e.name];else{var i=e.append;if(i){var s="string"===typeof i?i:"DIV",n=document.createElement(s);t.appendChild(n),t=n}var r=f(this.$props,C);r.slim=this.targetSlim,r.tag=this.targetTag,r.slotProps=this.targetSlotProps,r.name=this.to,this.portalTarget=new E({el:t,parent:this.$parent||this,propsData:r})}}else console.error("[portal-vue]: Mount Point '".concat(this.mountTo,"' not found in document"))}},beforeDestroy:function(){var t=this.portalTarget;if(this.append){var e=t.$el;e.parentNode.removeChild(e)}t.$destroy()},render:function(t){if(!this.portalTarget)return console.warn("[portal-vue] Target wasn't mounted"),t();if(!this.$scopedSlots.manual){var e=f(this.$props,x);return t(S,{props:e,attrs:this.$attrs,on:this.$listeners,scopedSlots:this.$scopedSlots},this.$slots.default)}var i=this.$scopedSlots.manual({to:this.to});return Array.isArray(i)&&(i=i[0]),i||t()}});function k(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};t.component(e.portalName||"Portal",S),t.component(e.portalTargetName||"PortalTarget",E),t.component(e.MountingPortalName||"MountingPortal",_)}var L={install:k};e.h_=S,e.YC=E},6190:function(t,e,i){var s=i(8555);s.__esModule&&(s=s.default),"string"===typeof s&&(s=[[t.id,s,""]]),s.locals&&(t.exports=s.locals);var n=i(2339).Z;t.exports.__inject__=function(t){n("0db9c476",s,t)}},2061:function(t,e,i){var s=i(2483);s.__esModule&&(s=s.default),"string"===typeof s&&(s=[[t.id,s,""]]),s.locals&&(t.exports=s.locals);var n=i(2339).Z;t.exports.__inject__=function(t){n("4b070767",s,t)}},2339:function(t,e,i){"use strict";function s(t,e){for(var i=[],s={},n=0;n<e.length;n++){var r=e[n],o=r[0],a=r[1],l=r[2],c=r[3],d={id:t+":"+n,css:a,media:l,sourceMap:c};s[o]?s[o].parts.push(d):i.push(s[o]={id:o,parts:[d]})}return i}function n(t,e,i){var n=s(t,e);r(n,i)}function r(t,e){const i=e._injectedStyles||(e._injectedStyles={});for(var s=0;s<t.length;s++){var n=t[s],r=i[n.id];if(!r){for(var o=0;o<n.parts.length;o++)a(n.parts[o],e);i[n.id]=!0}}}function o(t){var e=document.createElement("style");return e.type="text/css",t.appendChild(e),e}function a(t,e){var i=o(e),s=t.css,n=t.media,r=t.sourceMap;if(n&&i.setAttribute("media",n),r&&(s+="\n/*# sourceURL="+r.sources[0]+" */",s+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(r))))+" */"),i.styleSheet)i.styleSheet.cssText=s;else{while(i.firstChild)i.removeChild(i.firstChild);i.appendChild(document.createTextNode(s))}}i.d(e,{Z:function(){return n}})},144:function(t,e,i){"use strict";i.r(e),i.d(e,{EffectScope:function(){return Le},computed:function(){return ve},customRef:function(){return ae},default:function(){return sr},defineAsyncComponent:function(){return ts},defineComponent:function(){return gs},del:function(){return jt},effectScope:function(){return Ae},getCurrentInstance:function(){return vt},getCurrentScope:function(){return Ie},h:function(){return Fi},inject:function(){return Me},isProxy:function(){return Yt},isReactive:function(){return zt},isReadonly:function(){return Wt},isRef:function(){return Jt},isShallow:function(){return Kt},markRaw:function(){return Zt},mergeDefaults:function(){return Ti},nextTick:function(){return Zi},onActivated:function(){return cs},onBeforeMount:function(){return ss},onBeforeUnmount:function(){return as},onBeforeUpdate:function(){return rs},onDeactivated:function(){return ds},onErrorCaptured:function(){return ms},onMounted:function(){return ns},onRenderTracked:function(){return hs},onRenderTriggered:function(){return ps},onScopeDispose:function(){return De},onServerPrefetch:function(){return us},onUnmounted:function(){return ls},onUpdated:function(){return os},provide:function(){return Pe},proxyRefs:function(){return re},reactive:function(){return Gt},readonly:function(){return he},ref:function(){return te},set:function(){return Ut},shallowReactive:function(){return Vt},shallowReadonly:function(){return me},shallowRef:function(){return ee},toRaw:function(){return Xt},toRef:function(){return ce},toRefs:function(){return le},triggerRef:function(){return se},unref:function(){return ne},useAttrs:function(){return wi},useCssModule:function(){return Qi},useCssVars:function(){return Ji},useListeners:function(){return Si},useSlots:function(){return bi},version:function(){return vs},watch:function(){return _e},watchEffect:function(){return Se},watchPostEffect:function(){return Ee},watchSyncEffect:function(){return Te}});
/*!
 * Vue.js v2.7.14
 * (c) 2014-2022 Evan You
 * Released under the MIT License.
 */
var s=Object.freeze({}),n=Array.isArray;function r(t){return void 0===t||null===t}function o(t){return void 0!==t&&null!==t}function a(t){return!0===t}function l(t){return!1===t}function c(t){return"string"===typeof t||"number"===typeof t||"symbol"===typeof t||"boolean"===typeof t}function d(t){return"function"===typeof t}function u(t){return null!==t&&"object"===typeof t}var h=Object.prototype.toString;function p(t){return"[object Object]"===h.call(t)}function f(t){return"[object RegExp]"===h.call(t)}function m(t){var e=parseFloat(String(t));return e>=0&&Math.floor(e)===e&&isFinite(t)}function v(t){return o(t)&&"function"===typeof t.then&&"function"===typeof t.catch}function g(t){return null==t?"":Array.isArray(t)||p(t)&&t.toString===h?JSON.stringify(t,null,2):String(t)}function y(t){var e=parseFloat(t);return isNaN(e)?t:e}function b(t,e){for(var i=Object.create(null),s=t.split(","),n=0;n<s.length;n++)i[s[n]]=!0;return e?function(t){return i[t.toLowerCase()]}:function(t){return i[t]}}b("slot,component",!0);var w=b("key,ref,slot,slot-scope,is");function S(t,e){var i=t.length;if(i){if(e===t[i-1])return void(t.length=i-1);var s=t.indexOf(e);if(s>-1)return t.splice(s,1)}}var E=Object.prototype.hasOwnProperty;function T(t,e){return E.call(t,e)}function x(t){var e=Object.create(null);return function(i){var s=e[i];return s||(e[i]=t(i))}}var C=/-(\w)/g,_=x((function(t){return t.replace(C,(function(t,e){return e?e.toUpperCase():""}))})),k=x((function(t){return t.charAt(0).toUpperCase()+t.slice(1)})),L=/\B([A-Z])/g,A=x((function(t){return t.replace(L,"-$1").toLowerCase()}));function R(t,e){function i(i){var s=arguments.length;return s?s>1?t.apply(e,arguments):t.call(e,i):t.call(e)}return i._length=t.length,i}function I(t,e){return t.bind(e)}var D=Function.prototype.bind?I:R;function P(t,e){e=e||0;var i=t.length-e,s=new Array(i);while(i--)s[i]=t[i+e];return s}function O(t,e){for(var i in e)t[i]=e[i];return t}function M(t){for(var e={},i=0;i<t.length;i++)t[i]&&O(e,t[i]);return e}function N(t,e,i){}var F=function(t,e,i){return!1},B=function(t){return t};function $(t,e){if(t===e)return!0;var i=u(t),s=u(e);if(!i||!s)return!i&&!s&&String(t)===String(e);try{var n=Array.isArray(t),r=Array.isArray(e);if(n&&r)return t.length===e.length&&t.every((function(t,i){return $(t,e[i])}));if(t instanceof Date&&e instanceof Date)return t.getTime()===e.getTime();if(n||r)return!1;var o=Object.keys(t),a=Object.keys(e);return o.length===a.length&&o.every((function(i){return $(t[i],e[i])}))}catch(l){return!1}}function U(t,e){for(var i=0;i<t.length;i++)if($(t[i],e))return i;return-1}function j(t){var e=!1;return function(){e||(e=!0,t.apply(this,arguments))}}function q(t,e){return t===e?0===t&&1/t!==1/e:t===t||e===e}var G="data-server-rendered",V=["component","directive","filter"],H=["beforeCreate","created","beforeMount","mounted","beforeUpdate","updated","beforeDestroy","destroyed","activated","deactivated","errorCaptured","serverPrefetch","renderTracked","renderTriggered"],z={optionMergeStrategies:Object.create(null),silent:!1,productionTip:!1,devtools:!1,performance:!1,errorHandler:null,warnHandler:null,ignoredElements:[],keyCodes:Object.create(null),isReservedTag:F,isReservedAttr:F,isUnknownElement:F,getTagNamespace:N,parsePlatformTagName:B,mustUseProp:F,async:!0,_lifecycleHooks:H},K=/a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;function W(t){var e=(t+"").charCodeAt(0);return 36===e||95===e}function Y(t,e,i,s){Object.defineProperty(t,e,{value:i,enumerable:!!s,writable:!0,configurable:!0})}var X=new RegExp("[^".concat(K.source,".$_\\d]"));function Z(t){if(!X.test(t)){var e=t.split(".");return function(t){for(var i=0;i<e.length;i++){if(!t)return;t=t[e[i]]}return t}}}var Q="__proto__"in{},J="undefined"!==typeof window,tt=J&&window.navigator.userAgent.toLowerCase(),et=tt&&/msie|trident/.test(tt),it=tt&&tt.indexOf("msie 9.0")>0,st=tt&&tt.indexOf("edge/")>0;tt&&tt.indexOf("android");var nt=tt&&/iphone|ipad|ipod|ios/.test(tt);tt&&/chrome\/\d+/.test(tt),tt&&/phantomjs/.test(tt);var rt,ot=tt&&tt.match(/firefox\/(\d+)/),at={}.watch,lt=!1;if(J)try{var ct={};Object.defineProperty(ct,"passive",{get:function(){lt=!0}}),window.addEventListener("test-passive",null,ct)}catch(nl){}var dt=function(){return void 0===rt&&(rt=!J&&"undefined"!==typeof i.g&&(i.g["process"]&&"server"===i.g["process"].env.VUE_ENV)),rt},ut=J&&window.__VUE_DEVTOOLS_GLOBAL_HOOK__;function ht(t){return"function"===typeof t&&/native code/.test(t.toString())}var pt,ft="undefined"!==typeof Symbol&&ht(Symbol)&&"undefined"!==typeof Reflect&&ht(Reflect.ownKeys);pt="undefined"!==typeof Set&&ht(Set)?Set:function(){function t(){this.set=Object.create(null)}return t.prototype.has=function(t){return!0===this.set[t]},t.prototype.add=function(t){this.set[t]=!0},t.prototype.clear=function(){this.set=Object.create(null)},t}();var mt=null;function vt(){return mt&&{proxy:mt}}function gt(t){void 0===t&&(t=null),t||mt&&mt._scope.off(),mt=t,t&&t._scope.on()}var yt=function(){function t(t,e,i,s,n,r,o,a){this.tag=t,this.data=e,this.children=i,this.text=s,this.elm=n,this.ns=void 0,this.context=r,this.fnContext=void 0,this.fnOptions=void 0,this.fnScopeId=void 0,this.key=e&&e.key,this.componentOptions=o,this.componentInstance=void 0,this.parent=void 0,this.raw=!1,this.isStatic=!1,this.isRootInsert=!0,this.isComment=!1,this.isCloned=!1,this.isOnce=!1,this.asyncFactory=a,this.asyncMeta=void 0,this.isAsyncPlaceholder=!1}return Object.defineProperty(t.prototype,"child",{get:function(){return this.componentInstance},enumerable:!1,configurable:!0}),t}(),bt=function(t){void 0===t&&(t="");var e=new yt;return e.text=t,e.isComment=!0,e};function wt(t){return new yt(void 0,void 0,void 0,String(t))}function St(t){var e=new yt(t.tag,t.data,t.children&&t.children.slice(),t.text,t.elm,t.context,t.componentOptions,t.asyncFactory);return e.ns=t.ns,e.isStatic=t.isStatic,e.key=t.key,e.isComment=t.isComment,e.fnContext=t.fnContext,e.fnOptions=t.fnOptions,e.fnScopeId=t.fnScopeId,e.asyncMeta=t.asyncMeta,e.isCloned=!0,e}var Et=0,Tt=[],xt=function(){for(var t=0;t<Tt.length;t++){var e=Tt[t];e.subs=e.subs.filter((function(t){return t})),e._pending=!1}Tt.length=0},Ct=function(){function t(){this._pending=!1,this.id=Et++,this.subs=[]}return t.prototype.addSub=function(t){this.subs.push(t)},t.prototype.removeSub=function(t){this.subs[this.subs.indexOf(t)]=null,this._pending||(this._pending=!0,Tt.push(this))},t.prototype.depend=function(e){t.target&&t.target.addDep(this)},t.prototype.notify=function(t){var e=this.subs.filter((function(t){return t}));for(var i=0,s=e.length;i<s;i++){var n=e[i];0,n.update()}},t}();Ct.target=null;var _t=[];function kt(t){_t.push(t),Ct.target=t}function Lt(){_t.pop(),Ct.target=_t[_t.length-1]}var At=Array.prototype,Rt=Object.create(At),It=["push","pop","shift","unshift","splice","sort","reverse"];It.forEach((function(t){var e=At[t];Y(Rt,t,(function(){for(var i=[],s=0;s<arguments.length;s++)i[s]=arguments[s];var n,r=e.apply(this,i),o=this.__ob__;switch(t){case"push":case"unshift":n=i;break;case"splice":n=i.slice(2);break}return n&&o.observeArray(n),o.dep.notify(),r}))}));var Dt=Object.getOwnPropertyNames(Rt),Pt={},Ot=!0;function Mt(t){Ot=t}var Nt={notify:N,depend:N,addSub:N,removeSub:N},Ft=function(){function t(t,e,i){if(void 0===e&&(e=!1),void 0===i&&(i=!1),this.value=t,this.shallow=e,this.mock=i,this.dep=i?Nt:new Ct,this.vmCount=0,Y(t,"__ob__",this),n(t)){if(!i)if(Q)t.__proto__=Rt;else for(var s=0,r=Dt.length;s<r;s++){var o=Dt[s];Y(t,o,Rt[o])}e||this.observeArray(t)}else{var a=Object.keys(t);for(s=0;s<a.length;s++){o=a[s];$t(t,o,Pt,void 0,e,i)}}}return t.prototype.observeArray=function(t){for(var e=0,i=t.length;e<i;e++)Bt(t[e],!1,this.mock)},t}();function Bt(t,e,i){return t&&T(t,"__ob__")&&t.__ob__ instanceof Ft?t.__ob__:!Ot||!i&&dt()||!n(t)&&!p(t)||!Object.isExtensible(t)||t.__v_skip||Jt(t)||t instanceof yt?void 0:new Ft(t,e,i)}function $t(t,e,i,s,r,o){var a=new Ct,l=Object.getOwnPropertyDescriptor(t,e);if(!l||!1!==l.configurable){var c=l&&l.get,d=l&&l.set;c&&!d||i!==Pt&&2!==arguments.length||(i=t[e]);var u=!r&&Bt(i,!1,o);return Object.defineProperty(t,e,{enumerable:!0,configurable:!0,get:function(){var e=c?c.call(t):i;return Ct.target&&(a.depend(),u&&(u.dep.depend(),n(e)&&qt(e))),Jt(e)&&!r?e.value:e},set:function(e){var s=c?c.call(t):i;if(q(s,e)){if(d)d.call(t,e);else{if(c)return;if(!r&&Jt(s)&&!Jt(e))return void(s.value=e);i=e}u=!r&&Bt(e,!1,o),a.notify()}}}),a}}function Ut(t,e,i){if(!Wt(t)){var s=t.__ob__;return n(t)&&m(e)?(t.length=Math.max(t.length,e),t.splice(e,1,i),s&&!s.shallow&&s.mock&&Bt(i,!1,!0),i):e in t&&!(e in Object.prototype)?(t[e]=i,i):t._isVue||s&&s.vmCount?i:s?($t(s.value,e,i,void 0,s.shallow,s.mock),s.dep.notify(),i):(t[e]=i,i)}}function jt(t,e){if(n(t)&&m(e))t.splice(e,1);else{var i=t.__ob__;t._isVue||i&&i.vmCount||Wt(t)||T(t,e)&&(delete t[e],i&&i.dep.notify())}}function qt(t){for(var e=void 0,i=0,s=t.length;i<s;i++)e=t[i],e&&e.__ob__&&e.__ob__.dep.depend(),n(e)&&qt(e)}function Gt(t){return Ht(t,!1),t}function Vt(t){return Ht(t,!0),Y(t,"__v_isShallow",!0),t}function Ht(t,e){if(!Wt(t)){Bt(t,e,dt());0}}function zt(t){return Wt(t)?zt(t["__v_raw"]):!(!t||!t.__ob__)}function Kt(t){return!(!t||!t.__v_isShallow)}function Wt(t){return!(!t||!t.__v_isReadonly)}function Yt(t){return zt(t)||Wt(t)}function Xt(t){var e=t&&t["__v_raw"];return e?Xt(e):t}function Zt(t){return Object.isExtensible(t)&&Y(t,"__v_skip",!0),t}var Qt="__v_isRef";function Jt(t){return!(!t||!0!==t.__v_isRef)}function te(t){return ie(t,!1)}function ee(t){return ie(t,!0)}function ie(t,e){if(Jt(t))return t;var i={};return Y(i,Qt,!0),Y(i,"__v_isShallow",e),Y(i,"dep",$t(i,"value",t,null,e,dt())),i}function se(t){t.dep&&t.dep.notify()}function ne(t){return Jt(t)?t.value:t}function re(t){if(zt(t))return t;for(var e={},i=Object.keys(t),s=0;s<i.length;s++)oe(e,t,i[s]);return e}function oe(t,e,i){Object.defineProperty(t,i,{enumerable:!0,configurable:!0,get:function(){var t=e[i];if(Jt(t))return t.value;var s=t&&t.__ob__;return s&&s.dep.depend(),t},set:function(t){var s=e[i];Jt(s)&&!Jt(t)?s.value=t:e[i]=t}})}function ae(t){var e=new Ct,i=t((function(){e.depend()}),(function(){e.notify()})),s=i.get,n=i.set,r={get value(){return s()},set value(t){n(t)}};return Y(r,Qt,!0),r}function le(t){var e=n(t)?new Array(t.length):{};for(var i in t)e[i]=ce(t,i);return e}function ce(t,e,i){var s=t[e];if(Jt(s))return s;var n={get value(){var s=t[e];return void 0===s?i:s},set value(i){t[e]=i}};return Y(n,Qt,!0),n}var de="__v_rawToReadonly",ue="__v_rawToShallowReadonly";function he(t){return pe(t,!1)}function pe(t,e){if(!p(t))return t;if(Wt(t))return t;var i=e?ue:de,s=t[i];if(s)return s;var n=Object.create(Object.getPrototypeOf(t));Y(t,i,n),Y(n,"__v_isReadonly",!0),Y(n,"__v_raw",t),Jt(t)&&Y(n,Qt,!0),(e||Kt(t))&&Y(n,"__v_isShallow",!0);for(var r=Object.keys(t),o=0;o<r.length;o++)fe(n,t,r[o],e);return n}function fe(t,e,i,s){Object.defineProperty(t,i,{enumerable:!0,configurable:!0,get:function(){var t=e[i];return s||!p(t)?t:he(t)},set:function(){}})}function me(t){return pe(t,!0)}function ve(t,e){var i,s,n=d(t);n?(i=t,s=N):(i=t.get,s=t.set);var r=dt()?null:new Ts(mt,i,N,{lazy:!0});var o={effect:r,get value(){return r?(r.dirty&&r.evaluate(),Ct.target&&r.depend(),r.value):i()},set value(t){s(t)}};return Y(o,Qt,!0),Y(o,"__v_isReadonly",n),o}var ge="watcher",ye="".concat(ge," callback"),be="".concat(ge," getter"),we="".concat(ge," cleanup");function Se(t,e){return ke(t,null,e)}function Ee(t,e){return ke(t,null,{flush:"post"})}function Te(t,e){return ke(t,null,{flush:"sync"})}var xe,Ce={};function _e(t,e,i){return ke(t,e,i)}function ke(t,e,i){var r=void 0===i?s:i,o=r.immediate,a=r.deep,l=r.flush,c=void 0===l?"pre":l;r.onTrack,r.onTrigger;var u,h,p=mt,f=function(t,e,i){return void 0===i&&(i=null),$i(t,null,i,p,e)},m=!1,v=!1;if(Jt(t)?(u=function(){return t.value},m=Kt(t)):zt(t)?(u=function(){return t.__ob__.dep.depend(),t},a=!0):n(t)?(v=!0,m=t.some((function(t){return zt(t)||Kt(t)})),u=function(){return t.map((function(t){return Jt(t)?t.value:zt(t)?bs(t):d(t)?f(t,be):void 0}))}):u=d(t)?e?function(){return f(t,be)}:function(){if(!p||!p._isDestroyed)return h&&h(),f(t,ge,[y])}:N,e&&a){var g=u;u=function(){return bs(g())}}var y=function(t){h=b.onStop=function(){f(t,we)}};if(dt())return y=N,e?o&&f(e,ye,[u(),v?[]:void 0,y]):u(),N;var b=new Ts(mt,u,N,{lazy:!0});b.noRecurse=!e;var w=v?[]:Ce;return b.run=function(){if(b.active)if(e){var t=b.get();(a||m||(v?t.some((function(t,e){return q(t,w[e])})):q(t,w)))&&(h&&h(),f(e,ye,[t,w===Ce?void 0:w,y]),w=t)}else b.get()},"sync"===c?b.update=b.run:"post"===c?(b.post=!0,b.update=function(){return en(b)}):b.update=function(){if(p&&p===mt&&!p._isMounted){var t=p._preWatchers||(p._preWatchers=[]);t.indexOf(b)<0&&t.push(b)}else en(b)},e?o?b.run():w=b.get():"post"===c&&p?p.$once("hook:mounted",(function(){return b.get()})):b.get(),function(){b.teardown()}}var Le=function(){function t(t){void 0===t&&(t=!1),this.detached=t,this.active=!0,this.effects=[],this.cleanups=[],this.parent=xe,!t&&xe&&(this.index=(xe.scopes||(xe.scopes=[])).push(this)-1)}return t.prototype.run=function(t){if(this.active){var e=xe;try{return xe=this,t()}finally{xe=e}}else 0},t.prototype.on=function(){xe=this},t.prototype.off=function(){xe=this.parent},t.prototype.stop=function(t){if(this.active){var e=void 0,i=void 0;for(e=0,i=this.effects.length;e<i;e++)this.effects[e].teardown();for(e=0,i=this.cleanups.length;e<i;e++)this.cleanups[e]();if(this.scopes)for(e=0,i=this.scopes.length;e<i;e++)this.scopes[e].stop(!0);if(!this.detached&&this.parent&&!t){var s=this.parent.scopes.pop();s&&s!==this&&(this.parent.scopes[this.index]=s,s.index=this.index)}this.parent=void 0,this.active=!1}},t}();function Ae(t){return new Le(t)}function Re(t,e){void 0===e&&(e=xe),e&&e.active&&e.effects.push(t)}function Ie(){return xe}function De(t){xe&&xe.cleanups.push(t)}function Pe(t,e){mt&&(Oe(mt)[t]=e)}function Oe(t){var e=t._provided,i=t.$parent&&t.$parent._provided;return i===e?t._provided=Object.create(i):e}function Me(t,e,i){void 0===i&&(i=!1);var s=mt;if(s){var n=s.$parent&&s.$parent._provided;if(n&&t in n)return n[t];if(arguments.length>1)return i&&d(e)?e.call(s):e}else 0}var Ne=x((function(t){var e="&"===t.charAt(0);t=e?t.slice(1):t;var i="~"===t.charAt(0);t=i?t.slice(1):t;var s="!"===t.charAt(0);return t=s?t.slice(1):t,{name:t,once:i,capture:s,passive:e}}));function Fe(t,e){function i(){var t=i.fns;if(!n(t))return $i(t,null,arguments,e,"v-on handler");for(var s=t.slice(),r=0;r<s.length;r++)$i(s[r],null,arguments,e,"v-on handler")}return i.fns=t,i}function Be(t,e,i,s,n,o){var l,c,d,u;for(l in t)c=t[l],d=e[l],u=Ne(l),r(c)||(r(d)?(r(c.fns)&&(c=t[l]=Fe(c,o)),a(u.once)&&(c=t[l]=n(u.name,c,u.capture)),i(u.name,c,u.capture,u.passive,u.params)):c!==d&&(d.fns=c,t[l]=d));for(l in e)r(t[l])&&(u=Ne(l),s(u.name,e[l],u.capture))}function $e(t,e,i){var s;t instanceof yt&&(t=t.data.hook||(t.data.hook={}));var n=t[e];function l(){i.apply(this,arguments),S(s.fns,l)}r(n)?s=Fe([l]):o(n.fns)&&a(n.merged)?(s=n,s.fns.push(l)):s=Fe([n,l]),s.merged=!0,t[e]=s}function Ue(t,e,i){var s=e.options.props;if(!r(s)){var n={},a=t.attrs,l=t.props;if(o(a)||o(l))for(var c in s){var d=A(c);je(n,l,c,d,!0)||je(n,a,c,d,!1)}return n}}function je(t,e,i,s,n){if(o(e)){if(T(e,i))return t[i]=e[i],n||delete e[i],!0;if(T(e,s))return t[i]=e[s],n||delete e[s],!0}return!1}function qe(t){for(var e=0;e<t.length;e++)if(n(t[e]))return Array.prototype.concat.apply([],t);return t}function Ge(t){return c(t)?[wt(t)]:n(t)?He(t):void 0}function Ve(t){return o(t)&&o(t.text)&&l(t.isComment)}function He(t,e){var i,s,l,d,u=[];for(i=0;i<t.length;i++)s=t[i],r(s)||"boolean"===typeof s||(l=u.length-1,d=u[l],n(s)?s.length>0&&(s=He(s,"".concat(e||"","_").concat(i)),Ve(s[0])&&Ve(d)&&(u[l]=wt(d.text+s[0].text),s.shift()),u.push.apply(u,s)):c(s)?Ve(d)?u[l]=wt(d.text+s):""!==s&&u.push(wt(s)):Ve(s)&&Ve(d)?u[l]=wt(d.text+s.text):(a(t._isVList)&&o(s.tag)&&r(s.key)&&o(e)&&(s.key="__vlist".concat(e,"_").concat(i,"__")),u.push(s)));return u}function ze(t,e){var i,s,r,a,l=null;if(n(t)||"string"===typeof t)for(l=new Array(t.length),i=0,s=t.length;i<s;i++)l[i]=e(t[i],i);else if("number"===typeof t)for(l=new Array(t),i=0;i<t;i++)l[i]=e(i+1,i);else if(u(t))if(ft&&t[Symbol.iterator]){l=[];var c=t[Symbol.iterator](),d=c.next();while(!d.done)l.push(e(d.value,l.length)),d=c.next()}else for(r=Object.keys(t),l=new Array(r.length),i=0,s=r.length;i<s;i++)a=r[i],l[i]=e(t[a],a,i);return o(l)||(l=[]),l._isVList=!0,l}function Ke(t,e,i,s){var n,r=this.$scopedSlots[t];r?(i=i||{},s&&(i=O(O({},s),i)),n=r(i)||(d(e)?e():e)):n=this.$slots[t]||(d(e)?e():e);var o=i&&i.slot;return o?this.$createElement("template",{slot:o},n):n}function We(t){return Rn(this.$options,"filters",t,!0)||B}function Ye(t,e){return n(t)?-1===t.indexOf(e):t!==e}function Xe(t,e,i,s,n){var r=z.keyCodes[e]||i;return n&&s&&!z.keyCodes[e]?Ye(n,s):r?Ye(r,t):s?A(s)!==e:void 0===t}function Ze(t,e,i,s,r){if(i)if(u(i)){n(i)&&(i=M(i));var o=void 0,a=function(n){if("class"===n||"style"===n||w(n))o=t;else{var a=t.attrs&&t.attrs.type;o=s||z.mustUseProp(e,a,n)?t.domProps||(t.domProps={}):t.attrs||(t.attrs={})}var l=_(n),c=A(n);if(!(l in o)&&!(c in o)&&(o[n]=i[n],r)){var d=t.on||(t.on={});d["update:".concat(n)]=function(t){i[n]=t}}};for(var l in i)a(l)}else;return t}function Qe(t,e){var i=this._staticTrees||(this._staticTrees=[]),s=i[t];return s&&!e||(s=i[t]=this.$options.staticRenderFns[t].call(this._renderProxy,this._c,this),ti(s,"__static__".concat(t),!1)),s}function Je(t,e,i){return ti(t,"__once__".concat(e).concat(i?"_".concat(i):""),!0),t}function ti(t,e,i){if(n(t))for(var s=0;s<t.length;s++)t[s]&&"string"!==typeof t[s]&&ei(t[s],"".concat(e,"_").concat(s),i);else ei(t,e,i)}function ei(t,e,i){t.isStatic=!0,t.key=e,t.isOnce=i}function ii(t,e){if(e)if(p(e)){var i=t.on=t.on?O({},t.on):{};for(var s in e){var n=i[s],r=e[s];i[s]=n?[].concat(n,r):r}}else;return t}function si(t,e,i,s){e=e||{$stable:!i};for(var r=0;r<t.length;r++){var o=t[r];n(o)?si(o,e,i):o&&(o.proxy&&(o.fn.proxy=!0),e[o.key]=o.fn)}return s&&(e.$key=s),e}function ni(t,e){for(var i=0;i<e.length;i+=2){var s=e[i];"string"===typeof s&&s&&(t[e[i]]=e[i+1])}return t}function ri(t,e){return"string"===typeof t?e+t:t}function oi(t){t._o=Je,t._n=y,t._s=g,t._l=ze,t._t=Ke,t._q=$,t._i=U,t._m=Qe,t._f=We,t._k=Xe,t._b=Ze,t._v=wt,t._e=bt,t._u=si,t._g=ii,t._d=ni,t._p=ri}function ai(t,e){if(!t||!t.length)return{};for(var i={},s=0,n=t.length;s<n;s++){var r=t[s],o=r.data;if(o&&o.attrs&&o.attrs.slot&&delete o.attrs.slot,r.context!==e&&r.fnContext!==e||!o||null==o.slot)(i.default||(i.default=[])).push(r);else{var a=o.slot,l=i[a]||(i[a]=[]);"template"===r.tag?l.push.apply(l,r.children||[]):l.push(r)}}for(var c in i)i[c].every(li)&&delete i[c];return i}function li(t){return t.isComment&&!t.asyncFactory||" "===t.text}function ci(t){return t.isComment&&t.asyncFactory}function di(t,e,i,n){var r,o=Object.keys(i).length>0,a=e?!!e.$stable:!o,l=e&&e.$key;if(e){if(e._normalized)return e._normalized;if(a&&n&&n!==s&&l===n.$key&&!o&&!n.$hasNormal)return n;for(var c in r={},e)e[c]&&"$"!==c[0]&&(r[c]=ui(t,i,c,e[c]))}else r={};for(var d in i)d in r||(r[d]=hi(i,d));return e&&Object.isExtensible(e)&&(e._normalized=r),Y(r,"$stable",a),Y(r,"$key",l),Y(r,"$hasNormal",o),r}function ui(t,e,i,s){var r=function(){var e=mt;gt(t);var i=arguments.length?s.apply(null,arguments):s({});i=i&&"object"===typeof i&&!n(i)?[i]:Ge(i);var r=i&&i[0];return gt(e),i&&(!r||1===i.length&&r.isComment&&!ci(r))?void 0:i};return s.proxy&&Object.defineProperty(e,i,{get:r,enumerable:!0,configurable:!0}),r}function hi(t,e){return function(){return t[e]}}function pi(t){var e=t.$options,i=e.setup;if(i){var s=t._setupContext=fi(t);gt(t),kt();var n=$i(i,null,[t._props||Vt({}),s],t,"setup");if(Lt(),gt(),d(n))e.render=n;else if(u(n))if(t._setupState=n,n.__sfc){var r=t._setupProxy={};for(var o in n)"__sfc"!==o&&oe(r,n,o)}else for(var o in n)W(o)||oe(t,n,o);else 0}}function fi(t){return{get attrs(){if(!t._attrsProxy){var e=t._attrsProxy={};Y(e,"_v_attr_proxy",!0),mi(e,t.$attrs,s,t,"$attrs")}return t._attrsProxy},get listeners(){if(!t._listenersProxy){var e=t._listenersProxy={};mi(e,t.$listeners,s,t,"$listeners")}return t._listenersProxy},get slots(){return gi(t)},emit:D(t.$emit,t),expose:function(e){e&&Object.keys(e).forEach((function(i){return oe(t,e,i)}))}}}function mi(t,e,i,s,n){var r=!1;for(var o in e)o in t?e[o]!==i[o]&&(r=!0):(r=!0,vi(t,o,s,n));for(var o in t)o in e||(r=!0,delete t[o]);return r}function vi(t,e,i,s){Object.defineProperty(t,e,{enumerable:!0,configurable:!0,get:function(){return i[s][e]}})}function gi(t){return t._slotsProxy||yi(t._slotsProxy={},t.$scopedSlots),t._slotsProxy}function yi(t,e){for(var i in e)t[i]=e[i];for(var i in t)i in e||delete t[i]}function bi(){return Ei().slots}function wi(){return Ei().attrs}function Si(){return Ei().listeners}function Ei(){var t=mt;return t._setupContext||(t._setupContext=fi(t))}function Ti(t,e){var i=n(t)?t.reduce((function(t,e){return t[e]={},t}),{}):t;for(var s in e){var r=i[s];r?n(r)||d(r)?i[s]={type:r,default:e[s]}:r.default=e[s]:null===r&&(i[s]={default:e[s]})}return i}function xi(t){t._vnode=null,t._staticTrees=null;var e=t.$options,i=t.$vnode=e._parentVnode,n=i&&i.context;t.$slots=ai(e._renderChildren,n),t.$scopedSlots=i?di(t.$parent,i.data.scopedSlots,t.$slots):s,t._c=function(e,i,s,n){return Pi(t,e,i,s,n,!1)},t.$createElement=function(e,i,s,n){return Pi(t,e,i,s,n,!0)};var r=i&&i.data;$t(t,"$attrs",r&&r.attrs||s,null,!0),$t(t,"$listeners",e._parentListeners||s,null,!0)}var Ci=null;function _i(t){oi(t.prototype),t.prototype.$nextTick=function(t){return Zi(t,this)},t.prototype._render=function(){var t,e=this,i=e.$options,s=i.render,r=i._parentVnode;r&&e._isMounted&&(e.$scopedSlots=di(e.$parent,r.data.scopedSlots,e.$slots,e.$scopedSlots),e._slotsProxy&&yi(e._slotsProxy,e.$scopedSlots)),e.$vnode=r;try{gt(e),Ci=e,t=s.call(e._renderProxy,e.$createElement)}catch(nl){Bi(nl,e,"render"),t=e._vnode}finally{Ci=null,gt()}return n(t)&&1===t.length&&(t=t[0]),t instanceof yt||(t=bt()),t.parent=r,t}}function ki(t,e){return(t.__esModule||ft&&"Module"===t[Symbol.toStringTag])&&(t=t.default),u(t)?e.extend(t):t}function Li(t,e,i,s,n){var r=bt();return r.asyncFactory=t,r.asyncMeta={data:e,context:i,children:s,tag:n},r}function Ai(t,e){if(a(t.error)&&o(t.errorComp))return t.errorComp;if(o(t.resolved))return t.resolved;var i=Ci;if(i&&o(t.owners)&&-1===t.owners.indexOf(i)&&t.owners.push(i),a(t.loading)&&o(t.loadingComp))return t.loadingComp;if(i&&!o(t.owners)){var s=t.owners=[i],n=!0,l=null,c=null;i.$on("hook:destroyed",(function(){return S(s,i)}));var d=function(t){for(var e=0,i=s.length;e<i;e++)s[e].$forceUpdate();t&&(s.length=0,null!==l&&(clearTimeout(l),l=null),null!==c&&(clearTimeout(c),c=null))},h=j((function(i){t.resolved=ki(i,e),n?s.length=0:d(!0)})),p=j((function(e){o(t.errorComp)&&(t.error=!0,d(!0))})),f=t(h,p);return u(f)&&(v(f)?r(t.resolved)&&f.then(h,p):v(f.component)&&(f.component.then(h,p),o(f.error)&&(t.errorComp=ki(f.error,e)),o(f.loading)&&(t.loadingComp=ki(f.loading,e),0===f.delay?t.loading=!0:l=setTimeout((function(){l=null,r(t.resolved)&&r(t.error)&&(t.loading=!0,d(!1))}),f.delay||200)),o(f.timeout)&&(c=setTimeout((function(){c=null,r(t.resolved)&&p(null)}),f.timeout)))),n=!1,t.loading?t.loadingComp:t.resolved}}function Ri(t){if(n(t))for(var e=0;e<t.length;e++){var i=t[e];if(o(i)&&(o(i.componentOptions)||ci(i)))return i}}var Ii=1,Di=2;function Pi(t,e,i,s,r,o){return(n(i)||c(i))&&(r=s,s=i,i=void 0),a(o)&&(r=Di),Oi(t,e,i,s,r)}function Oi(t,e,i,s,r){if(o(i)&&o(i.__ob__))return bt();if(o(i)&&o(i.is)&&(e=i.is),!e)return bt();var a,l;if(n(s)&&d(s[0])&&(i=i||{},i.scopedSlots={default:s[0]},s.length=0),r===Di?s=Ge(s):r===Ii&&(s=qe(s)),"string"===typeof e){var c=void 0;l=t.$vnode&&t.$vnode.ns||z.getTagNamespace(e),a=z.isReservedTag(e)?new yt(z.parsePlatformTagName(e),i,s,void 0,void 0,t):i&&i.pre||!o(c=Rn(t.$options,"components",e))?new yt(e,i,s,void 0,void 0,t):pn(c,i,t,s,e)}else a=pn(e,i,t,s);return n(a)?a:o(a)?(o(l)&&Mi(a,l),o(i)&&Ni(i),a):bt()}function Mi(t,e,i){if(t.ns=e,"foreignObject"===t.tag&&(e=void 0,i=!0),o(t.children))for(var s=0,n=t.children.length;s<n;s++){var l=t.children[s];o(l.tag)&&(r(l.ns)||a(i)&&"svg"!==l.tag)&&Mi(l,e,i)}}function Ni(t){u(t.style)&&bs(t.style),u(t.class)&&bs(t.class)}function Fi(t,e,i){return Pi(mt,t,e,i,2,!0)}function Bi(t,e,i){kt();try{if(e){var s=e;while(s=s.$parent){var n=s.$options.errorCaptured;if(n)for(var r=0;r<n.length;r++)try{var o=!1===n[r].call(s,t,e,i);if(o)return}catch(nl){Ui(nl,s,"errorCaptured hook")}}}Ui(t,e,i)}finally{Lt()}}function $i(t,e,i,s,n){var r;try{r=i?t.apply(e,i):t.call(e),r&&!r._isVue&&v(r)&&!r._handled&&(r.catch((function(t){return Bi(t,s,n+" (Promise/async)")})),r._handled=!0)}catch(nl){Bi(nl,s,n)}return r}function Ui(t,e,i){if(z.errorHandler)try{return z.errorHandler.call(null,t,e,i)}catch(nl){nl!==t&&ji(nl,null,"config.errorHandler")}ji(t,e,i)}function ji(t,e,i){if(!J||"undefined"===typeof console)throw t;console.error(t)}var qi,Gi=!1,Vi=[],Hi=!1;function zi(){Hi=!1;var t=Vi.slice(0);Vi.length=0;for(var e=0;e<t.length;e++)t[e]()}if("undefined"!==typeof Promise&&ht(Promise)){var Ki=Promise.resolve();qi=function(){Ki.then(zi),nt&&setTimeout(N)},Gi=!0}else if(et||"undefined"===typeof MutationObserver||!ht(MutationObserver)&&"[object MutationObserverConstructor]"!==MutationObserver.toString())qi="undefined"!==typeof setImmediate&&ht(setImmediate)?function(){setImmediate(zi)}:function(){setTimeout(zi,0)};else{var Wi=1,Yi=new MutationObserver(zi),Xi=document.createTextNode(String(Wi));Yi.observe(Xi,{characterData:!0}),qi=function(){Wi=(Wi+1)%2,Xi.data=String(Wi)},Gi=!0}function Zi(t,e){var i;if(Vi.push((function(){if(t)try{t.call(e)}catch(nl){Bi(nl,e,"nextTick")}else i&&i(e)})),Hi||(Hi=!0,qi()),!t&&"undefined"!==typeof Promise)return new Promise((function(t){i=t}))}function Qi(t){if(void 0===t&&(t="$style"),!mt)return s;var e=mt[t];return e||s}function Ji(t){if(J){var e=mt;e&&Ee((function(){var i=e.$el,s=t(e,e._setupProxy);if(i&&1===i.nodeType){var n=i.style;for(var r in s)n.setProperty("--".concat(r),s[r])}}))}}function ts(t){d(t)&&(t={loader:t});var e=t.loader,i=t.loadingComponent,s=t.errorComponent,n=t.delay,r=void 0===n?200:n,o=t.timeout,a=(t.suspensible,t.onError);var l=null,c=0,u=function(){return c++,l=null,h()},h=function(){var t;return l||(t=l=e().catch((function(t){if(t=t instanceof Error?t:new Error(String(t)),a)return new Promise((function(e,i){var s=function(){return e(u())},n=function(){return i(t)};a(t,s,n,c+1)}));throw t})).then((function(e){return t!==l&&l?l:(e&&(e.__esModule||"Module"===e[Symbol.toStringTag])&&(e=e.default),e)})))};return function(){var t=h();return{component:t,delay:r,timeout:o,error:s,loading:i}}}function es(t){return function(e,i){if(void 0===i&&(i=mt),i)return is(i,t,e)}}function is(t,e,i){var s=t.$options;s[e]=En(s[e],i)}var ss=es("beforeMount"),ns=es("mounted"),rs=es("beforeUpdate"),os=es("updated"),as=es("beforeDestroy"),ls=es("destroyed"),cs=es("activated"),ds=es("deactivated"),us=es("serverPrefetch"),hs=es("renderTracked"),ps=es("renderTriggered"),fs=es("errorCaptured");function ms(t,e){void 0===e&&(e=mt),fs(t,e)}var vs="2.7.14";function gs(t){return t}var ys=new pt;function bs(t){return ws(t,ys),ys.clear(),t}function ws(t,e){var i,s,r=n(t);if(!(!r&&!u(t)||t.__v_skip||Object.isFrozen(t)||t instanceof yt)){if(t.__ob__){var o=t.__ob__.dep.id;if(e.has(o))return;e.add(o)}if(r){i=t.length;while(i--)ws(t[i],e)}else if(Jt(t))ws(t.value,e);else{s=Object.keys(t),i=s.length;while(i--)ws(t[s[i]],e)}}}var Ss,Es=0,Ts=function(){function t(t,e,i,s,n){Re(this,xe&&!xe._vm?xe:t?t._scope:void 0),(this.vm=t)&&n&&(t._watcher=this),s?(this.deep=!!s.deep,this.user=!!s.user,this.lazy=!!s.lazy,this.sync=!!s.sync,this.before=s.before):this.deep=this.user=this.lazy=this.sync=!1,this.cb=i,this.id=++Es,this.active=!0,this.post=!1,this.dirty=this.lazy,this.deps=[],this.newDeps=[],this.depIds=new pt,this.newDepIds=new pt,this.expression="",d(e)?this.getter=e:(this.getter=Z(e),this.getter||(this.getter=N)),this.value=this.lazy?void 0:this.get()}return t.prototype.get=function(){var t;kt(this);var e=this.vm;try{t=this.getter.call(e,e)}catch(nl){if(!this.user)throw nl;Bi(nl,e,'getter for watcher "'.concat(this.expression,'"'))}finally{this.deep&&bs(t),Lt(),this.cleanupDeps()}return t},t.prototype.addDep=function(t){var e=t.id;this.newDepIds.has(e)||(this.newDepIds.add(e),this.newDeps.push(t),this.depIds.has(e)||t.addSub(this))},t.prototype.cleanupDeps=function(){var t=this.deps.length;while(t--){var e=this.deps[t];this.newDepIds.has(e.id)||e.removeSub(this)}var i=this.depIds;this.depIds=this.newDepIds,this.newDepIds=i,this.newDepIds.clear(),i=this.deps,this.deps=this.newDeps,this.newDeps=i,this.newDeps.length=0},t.prototype.update=function(){this.lazy?this.dirty=!0:this.sync?this.run():en(this)},t.prototype.run=function(){if(this.active){var t=this.get();if(t!==this.value||u(t)||this.deep){var e=this.value;if(this.value=t,this.user){var i='callback for watcher "'.concat(this.expression,'"');$i(this.cb,this.vm,[t,e],this.vm,i)}else this.cb.call(this.vm,t,e)}}},t.prototype.evaluate=function(){this.value=this.get(),this.dirty=!1},t.prototype.depend=function(){var t=this.deps.length;while(t--)this.deps[t].depend()},t.prototype.teardown=function(){if(this.vm&&!this.vm._isBeingDestroyed&&S(this.vm._scope.effects,this),this.active){var t=this.deps.length;while(t--)this.deps[t].removeSub(this);this.active=!1,this.onStop&&this.onStop()}},t}();function xs(t){t._events=Object.create(null),t._hasHookEvent=!1;var e=t.$options._parentListeners;e&&Ls(t,e)}function Cs(t,e){Ss.$on(t,e)}function _s(t,e){Ss.$off(t,e)}function ks(t,e){var i=Ss;return function s(){var n=e.apply(null,arguments);null!==n&&i.$off(t,s)}}function Ls(t,e,i){Ss=t,Be(e,i||{},Cs,_s,ks,t),Ss=void 0}function As(t){var e=/^hook:/;t.prototype.$on=function(t,i){var s=this;if(n(t))for(var r=0,o=t.length;r<o;r++)s.$on(t[r],i);else(s._events[t]||(s._events[t]=[])).push(i),e.test(t)&&(s._hasHookEvent=!0);return s},t.prototype.$once=function(t,e){var i=this;function s(){i.$off(t,s),e.apply(i,arguments)}return s.fn=e,i.$on(t,s),i},t.prototype.$off=function(t,e){var i=this;if(!arguments.length)return i._events=Object.create(null),i;if(n(t)){for(var s=0,r=t.length;s<r;s++)i.$off(t[s],e);return i}var o,a=i._events[t];if(!a)return i;if(!e)return i._events[t]=null,i;var l=a.length;while(l--)if(o=a[l],o===e||o.fn===e){a.splice(l,1);break}return i},t.prototype.$emit=function(t){var e=this,i=e._events[t];if(i){i=i.length>1?P(i):i;for(var s=P(arguments,1),n='event handler for "'.concat(t,'"'),r=0,o=i.length;r<o;r++)$i(i[r],e,s,e,n)}return e}}var Rs=null;function Is(t){var e=Rs;return Rs=t,function(){Rs=e}}function Ds(t){var e=t.$options,i=e.parent;if(i&&!e.abstract){while(i.$options.abstract&&i.$parent)i=i.$parent;i.$children.push(t)}t.$parent=i,t.$root=i?i.$root:t,t.$children=[],t.$refs={},t._provided=i?i._provided:Object.create(null),t._watcher=null,t._inactive=null,t._directInactive=!1,t._isMounted=!1,t._isDestroyed=!1,t._isBeingDestroyed=!1}function Ps(t){t.prototype._update=function(t,e){var i=this,s=i.$el,n=i._vnode,r=Is(i);i._vnode=t,i.$el=n?i.__patch__(n,t):i.__patch__(i.$el,t,e,!1),r(),s&&(s.__vue__=null),i.$el&&(i.$el.__vue__=i);var o=i;while(o&&o.$vnode&&o.$parent&&o.$vnode===o.$parent._vnode)o.$parent.$el=o.$el,o=o.$parent},t.prototype.$forceUpdate=function(){var t=this;t._watcher&&t._watcher.update()},t.prototype.$destroy=function(){var t=this;if(!t._isBeingDestroyed){$s(t,"beforeDestroy"),t._isBeingDestroyed=!0;var e=t.$parent;!e||e._isBeingDestroyed||t.$options.abstract||S(e.$children,t),t._scope.stop(),t._data.__ob__&&t._data.__ob__.vmCount--,t._isDestroyed=!0,t.__patch__(t._vnode,null),$s(t,"destroyed"),t.$off(),t.$el&&(t.$el.__vue__=null),t.$vnode&&(t.$vnode.parent=null)}}}function Os(t,e,i){var s;t.$el=e,t.$options.render||(t.$options.render=bt),$s(t,"beforeMount"),s=function(){t._update(t._render(),i)};var n={before:function(){t._isMounted&&!t._isDestroyed&&$s(t,"beforeUpdate")}};new Ts(t,s,N,n,!0),i=!1;var r=t._preWatchers;if(r)for(var o=0;o<r.length;o++)r[o].run();return null==t.$vnode&&(t._isMounted=!0,$s(t,"mounted")),t}function Ms(t,e,i,n,r){var o=n.data.scopedSlots,a=t.$scopedSlots,l=!!(o&&!o.$stable||a!==s&&!a.$stable||o&&t.$scopedSlots.$key!==o.$key||!o&&t.$scopedSlots.$key),c=!!(r||t.$options._renderChildren||l),d=t.$vnode;t.$options._parentVnode=n,t.$vnode=n,t._vnode&&(t._vnode.parent=n),t.$options._renderChildren=r;var u=n.data.attrs||s;t._attrsProxy&&mi(t._attrsProxy,u,d.data&&d.data.attrs||s,t,"$attrs")&&(c=!0),t.$attrs=u,i=i||s;var h=t.$options._parentListeners;if(t._listenersProxy&&mi(t._listenersProxy,i,h||s,t,"$listeners"),t.$listeners=t.$options._parentListeners=i,Ls(t,i,h),e&&t.$options.props){Mt(!1);for(var p=t._props,f=t.$options._propKeys||[],m=0;m<f.length;m++){var v=f[m],g=t.$options.props;p[v]=In(v,g,e,t)}Mt(!0),t.$options.propsData=e}c&&(t.$slots=ai(r,n.context),t.$forceUpdate())}function Ns(t){while(t&&(t=t.$parent))if(t._inactive)return!0;return!1}function Fs(t,e){if(e){if(t._directInactive=!1,Ns(t))return}else if(t._directInactive)return;if(t._inactive||null===t._inactive){t._inactive=!1;for(var i=0;i<t.$children.length;i++)Fs(t.$children[i]);$s(t,"activated")}}function Bs(t,e){if((!e||(t._directInactive=!0,!Ns(t)))&&!t._inactive){t._inactive=!0;for(var i=0;i<t.$children.length;i++)Bs(t.$children[i]);$s(t,"deactivated")}}function $s(t,e,i,s){void 0===s&&(s=!0),kt();var n=mt;s&&gt(t);var r=t.$options[e],o="".concat(e," hook");if(r)for(var a=0,l=r.length;a<l;a++)$i(r[a],t,i||null,t,o);t._hasHookEvent&&t.$emit("hook:"+e),s&&gt(n),Lt()}var Us=[],js=[],qs={},Gs=!1,Vs=!1,Hs=0;function zs(){Hs=Us.length=js.length=0,qs={},Gs=Vs=!1}var Ks=0,Ws=Date.now;if(J&&!et){var Ys=window.performance;Ys&&"function"===typeof Ys.now&&Ws()>document.createEvent("Event").timeStamp&&(Ws=function(){return Ys.now()})}var Xs=function(t,e){if(t.post){if(!e.post)return 1}else if(e.post)return-1;return t.id-e.id};function Zs(){var t,e;for(Ks=Ws(),Vs=!0,Us.sort(Xs),Hs=0;Hs<Us.length;Hs++)t=Us[Hs],t.before&&t.before(),e=t.id,qs[e]=null,t.run();var i=js.slice(),s=Us.slice();zs(),tn(i),Qs(s),xt(),ut&&z.devtools&&ut.emit("flush")}function Qs(t){var e=t.length;while(e--){var i=t[e],s=i.vm;s&&s._watcher===i&&s._isMounted&&!s._isDestroyed&&$s(s,"updated")}}function Js(t){t._inactive=!1,js.push(t)}function tn(t){for(var e=0;e<t.length;e++)t[e]._inactive=!0,Fs(t[e],!0)}function en(t){var e=t.id;if(null==qs[e]&&(t!==Ct.target||!t.noRecurse)){if(qs[e]=!0,Vs){var i=Us.length-1;while(i>Hs&&Us[i].id>t.id)i--;Us.splice(i+1,0,t)}else Us.push(t);Gs||(Gs=!0,Zi(Zs))}}function sn(t){var e=t.$options.provide;if(e){var i=d(e)?e.call(t):e;if(!u(i))return;for(var s=Oe(t),n=ft?Reflect.ownKeys(i):Object.keys(i),r=0;r<n.length;r++){var o=n[r];Object.defineProperty(s,o,Object.getOwnPropertyDescriptor(i,o))}}}function nn(t){var e=rn(t.$options.inject,t);e&&(Mt(!1),Object.keys(e).forEach((function(i){$t(t,i,e[i])})),Mt(!0))}function rn(t,e){if(t){for(var i=Object.create(null),s=ft?Reflect.ownKeys(t):Object.keys(t),n=0;n<s.length;n++){var r=s[n];if("__ob__"!==r){var o=t[r].from;if(o in e._provided)i[r]=e._provided[o];else if("default"in t[r]){var a=t[r].default;i[r]=d(a)?a.call(e):a}else 0}}return i}}function on(t,e,i,r,o){var l,c=this,d=o.options;T(r,"_uid")?(l=Object.create(r),l._original=r):(l=r,r=r._original);var u=a(d._compiled),h=!u;this.data=t,this.props=e,this.children=i,this.parent=r,this.listeners=t.on||s,this.injections=rn(d.inject,r),this.slots=function(){return c.$slots||di(r,t.scopedSlots,c.$slots=ai(i,r)),c.$slots},Object.defineProperty(this,"scopedSlots",{enumerable:!0,get:function(){return di(r,t.scopedSlots,this.slots())}}),u&&(this.$options=d,this.$slots=this.slots(),this.$scopedSlots=di(r,t.scopedSlots,this.$slots)),d._scopeId?this._c=function(t,e,i,s){var o=Pi(l,t,e,i,s,h);return o&&!n(o)&&(o.fnScopeId=d._scopeId,o.fnContext=r),o}:this._c=function(t,e,i,s){return Pi(l,t,e,i,s,h)}}function an(t,e,i,r,a){var l=t.options,c={},d=l.props;if(o(d))for(var u in d)c[u]=In(u,d,e||s);else o(i.attrs)&&cn(c,i.attrs),o(i.props)&&cn(c,i.props);var h=new on(i,c,a,r,t),p=l.render.call(null,h._c,h);if(p instanceof yt)return ln(p,i,h.parent,l,h);if(n(p)){for(var f=Ge(p)||[],m=new Array(f.length),v=0;v<f.length;v++)m[v]=ln(f[v],i,h.parent,l,h);return m}}function ln(t,e,i,s,n){var r=St(t);return r.fnContext=i,r.fnOptions=s,e.slot&&((r.data||(r.data={})).slot=e.slot),r}function cn(t,e){for(var i in e)t[_(i)]=e[i]}function dn(t){return t.name||t.__name||t._componentTag}oi(on.prototype);var un={init:function(t,e){if(t.componentInstance&&!t.componentInstance._isDestroyed&&t.data.keepAlive){var i=t;un.prepatch(i,i)}else{var s=t.componentInstance=fn(t,Rs);s.$mount(e?t.elm:void 0,e)}},prepatch:function(t,e){var i=e.componentOptions,s=e.componentInstance=t.componentInstance;Ms(s,i.propsData,i.listeners,e,i.children)},insert:function(t){var e=t.context,i=t.componentInstance;i._isMounted||(i._isMounted=!0,$s(i,"mounted")),t.data.keepAlive&&(e._isMounted?Js(i):Fs(i,!0))},destroy:function(t){var e=t.componentInstance;e._isDestroyed||(t.data.keepAlive?Bs(e,!0):e.$destroy())}},hn=Object.keys(un);function pn(t,e,i,s,n){if(!r(t)){var l=i.$options._base;if(u(t)&&(t=l.extend(t)),"function"===typeof t){var c;if(r(t.cid)&&(c=t,t=Ai(c,l),void 0===t))return Li(c,e,i,s,n);e=e||{},er(t),o(e.model)&&gn(t.options,e);var d=Ue(e,t,n);if(a(t.options.functional))return an(t,d,e,i,s);var h=e.on;if(e.on=e.nativeOn,a(t.options.abstract)){var p=e.slot;e={},p&&(e.slot=p)}mn(e);var f=dn(t.options)||n,m=new yt("vue-component-".concat(t.cid).concat(f?"-".concat(f):""),e,void 0,void 0,void 0,i,{Ctor:t,propsData:d,listeners:h,tag:n,children:s},c);return m}}}function fn(t,e){var i={_isComponent:!0,_parentVnode:t,parent:e},s=t.data.inlineTemplate;return o(s)&&(i.render=s.render,i.staticRenderFns=s.staticRenderFns),new t.componentOptions.Ctor(i)}function mn(t){for(var e=t.hook||(t.hook={}),i=0;i<hn.length;i++){var s=hn[i],n=e[s],r=un[s];n===r||n&&n._merged||(e[s]=n?vn(r,n):r)}}function vn(t,e){var i=function(i,s){t(i,s),e(i,s)};return i._merged=!0,i}function gn(t,e){var i=t.model&&t.model.prop||"value",s=t.model&&t.model.event||"input";(e.attrs||(e.attrs={}))[i]=e.model.value;var r=e.on||(e.on={}),a=r[s],l=e.model.callback;o(a)?(n(a)?-1===a.indexOf(l):a!==l)&&(r[s]=[l].concat(a)):r[s]=l}var yn=N,bn=z.optionMergeStrategies;function wn(t,e,i){if(void 0===i&&(i=!0),!e)return t;for(var s,n,r,o=ft?Reflect.ownKeys(e):Object.keys(e),a=0;a<o.length;a++)s=o[a],"__ob__"!==s&&(n=t[s],r=e[s],i&&T(t,s)?n!==r&&p(n)&&p(r)&&wn(n,r):Ut(t,s,r));return t}function Sn(t,e,i){return i?function(){var s=d(e)?e.call(i,i):e,n=d(t)?t.call(i,i):t;return s?wn(s,n):n}:e?t?function(){return wn(d(e)?e.call(this,this):e,d(t)?t.call(this,this):t)}:e:t}function En(t,e){var i=e?t?t.concat(e):n(e)?e:[e]:t;return i?Tn(i):i}function Tn(t){for(var e=[],i=0;i<t.length;i++)-1===e.indexOf(t[i])&&e.push(t[i]);return e}function xn(t,e,i,s){var n=Object.create(t||null);return e?O(n,e):n}bn.data=function(t,e,i){return i?Sn(t,e,i):e&&"function"!==typeof e?t:Sn(t,e)},H.forEach((function(t){bn[t]=En})),V.forEach((function(t){bn[t+"s"]=xn})),bn.watch=function(t,e,i,s){if(t===at&&(t=void 0),e===at&&(e=void 0),!e)return Object.create(t||null);if(!t)return e;var r={};for(var o in O(r,t),e){var a=r[o],l=e[o];a&&!n(a)&&(a=[a]),r[o]=a?a.concat(l):n(l)?l:[l]}return r},bn.props=bn.methods=bn.inject=bn.computed=function(t,e,i,s){if(!t)return e;var n=Object.create(null);return O(n,t),e&&O(n,e),n},bn.provide=function(t,e){return t?function(){var i=Object.create(null);return wn(i,d(t)?t.call(this):t),e&&wn(i,d(e)?e.call(this):e,!1),i}:e};var Cn=function(t,e){return void 0===e?t:e};function _n(t,e){var i=t.props;if(i){var s,r,o,a={};if(n(i)){s=i.length;while(s--)r=i[s],"string"===typeof r&&(o=_(r),a[o]={type:null})}else if(p(i))for(var l in i)r=i[l],o=_(l),a[o]=p(r)?r:{type:r};else 0;t.props=a}}function kn(t,e){var i=t.inject;if(i){var s=t.inject={};if(n(i))for(var r=0;r<i.length;r++)s[i[r]]={from:i[r]};else if(p(i))for(var o in i){var a=i[o];s[o]=p(a)?O({from:o},a):{from:a}}else 0}}function Ln(t){var e=t.directives;if(e)for(var i in e){var s=e[i];d(s)&&(e[i]={bind:s,update:s})}}function An(t,e,i){if(d(e)&&(e=e.options),_n(e,i),kn(e,i),Ln(e),!e._base&&(e.extends&&(t=An(t,e.extends,i)),e.mixins))for(var s=0,n=e.mixins.length;s<n;s++)t=An(t,e.mixins[s],i);var r,o={};for(r in t)a(r);for(r in e)T(t,r)||a(r);function a(s){var n=bn[s]||Cn;o[s]=n(t[s],e[s],i,s)}return o}function Rn(t,e,i,s){if("string"===typeof i){var n=t[e];if(T(n,i))return n[i];var r=_(i);if(T(n,r))return n[r];var o=k(r);if(T(n,o))return n[o];var a=n[i]||n[r]||n[o];return a}}function In(t,e,i,s){var n=e[t],r=!T(i,t),o=i[t],a=Nn(Boolean,n.type);if(a>-1)if(r&&!T(n,"default"))o=!1;else if(""===o||o===A(t)){var l=Nn(String,n.type);(l<0||a<l)&&(o=!0)}if(void 0===o){o=Dn(s,n,t);var c=Ot;Mt(!0),Bt(o),Mt(c)}return o}function Dn(t,e,i){if(T(e,"default")){var s=e.default;return t&&t.$options.propsData&&void 0===t.$options.propsData[i]&&void 0!==t._props[i]?t._props[i]:d(s)&&"Function"!==On(e.type)?s.call(t):s}}var Pn=/^\s*function (\w+)/;function On(t){var e=t&&t.toString().match(Pn);return e?e[1]:""}function Mn(t,e){return On(t)===On(e)}function Nn(t,e){if(!n(e))return Mn(e,t)?0:-1;for(var i=0,s=e.length;i<s;i++)if(Mn(e[i],t))return i;return-1}var Fn={enumerable:!0,configurable:!0,get:N,set:N};function Bn(t,e,i){Fn.get=function(){return this[e][i]},Fn.set=function(t){this[e][i]=t},Object.defineProperty(t,i,Fn)}function $n(t){var e=t.$options;if(e.props&&Un(t,e.props),pi(t),e.methods&&Wn(t,e.methods),e.data)jn(t);else{var i=Bt(t._data={});i&&i.vmCount++}e.computed&&Vn(t,e.computed),e.watch&&e.watch!==at&&Yn(t,e.watch)}function Un(t,e){var i=t.$options.propsData||{},s=t._props=Vt({}),n=t.$options._propKeys=[],r=!t.$parent;r||Mt(!1);var o=function(r){n.push(r);var o=In(r,e,i,t);$t(s,r,o),r in t||Bn(t,"_props",r)};for(var a in e)o(a);Mt(!0)}function jn(t){var e=t.$options.data;e=t._data=d(e)?qn(e,t):e||{},p(e)||(e={});var i=Object.keys(e),s=t.$options.props,n=(t.$options.methods,i.length);while(n--){var r=i[n];0,s&&T(s,r)||W(r)||Bn(t,"_data",r)}var o=Bt(e);o&&o.vmCount++}function qn(t,e){kt();try{return t.call(e,e)}catch(nl){return Bi(nl,e,"data()"),{}}finally{Lt()}}var Gn={lazy:!0};function Vn(t,e){var i=t._computedWatchers=Object.create(null),s=dt();for(var n in e){var r=e[n],o=d(r)?r:r.get;0,s||(i[n]=new Ts(t,o||N,N,Gn)),n in t||Hn(t,n,r)}}function Hn(t,e,i){var s=!dt();d(i)?(Fn.get=s?zn(e):Kn(i),Fn.set=N):(Fn.get=i.get?s&&!1!==i.cache?zn(e):Kn(i.get):N,Fn.set=i.set||N),Object.defineProperty(t,e,Fn)}function zn(t){return function(){var e=this._computedWatchers&&this._computedWatchers[t];if(e)return e.dirty&&e.evaluate(),Ct.target&&e.depend(),e.value}}function Kn(t){return function(){return t.call(this,this)}}function Wn(t,e){t.$options.props;for(var i in e)t[i]="function"!==typeof e[i]?N:D(e[i],t)}function Yn(t,e){for(var i in e){var s=e[i];if(n(s))for(var r=0;r<s.length;r++)Xn(t,i,s[r]);else Xn(t,i,s)}}function Xn(t,e,i,s){return p(i)&&(s=i,i=i.handler),"string"===typeof i&&(i=t[i]),t.$watch(e,i,s)}function Zn(t){var e={get:function(){return this._data}},i={get:function(){return this._props}};Object.defineProperty(t.prototype,"$data",e),Object.defineProperty(t.prototype,"$props",i),t.prototype.$set=Ut,t.prototype.$delete=jt,t.prototype.$watch=function(t,e,i){var s=this;if(p(e))return Xn(s,t,e,i);i=i||{},i.user=!0;var n=new Ts(s,t,e,i);if(i.immediate){var r='callback for immediate watcher "'.concat(n.expression,'"');kt(),$i(e,s,[n.value],s,r),Lt()}return function(){n.teardown()}}}var Qn=0;function Jn(t){t.prototype._init=function(t){var e=this;e._uid=Qn++,e._isVue=!0,e.__v_skip=!0,e._scope=new Le(!0),e._scope._vm=!0,t&&t._isComponent?tr(e,t):e.$options=An(er(e.constructor),t||{},e),e._renderProxy=e,e._self=e,Ds(e),xs(e),xi(e),$s(e,"beforeCreate",void 0,!1),nn(e),$n(e),sn(e),$s(e,"created"),e.$options.el&&e.$mount(e.$options.el)}}function tr(t,e){var i=t.$options=Object.create(t.constructor.options),s=e._parentVnode;i.parent=e.parent,i._parentVnode=s;var n=s.componentOptions;i.propsData=n.propsData,i._parentListeners=n.listeners,i._renderChildren=n.children,i._componentTag=n.tag,e.render&&(i.render=e.render,i.staticRenderFns=e.staticRenderFns)}function er(t){var e=t.options;if(t.super){var i=er(t.super),s=t.superOptions;if(i!==s){t.superOptions=i;var n=ir(t);n&&O(t.extendOptions,n),e=t.options=An(i,t.extendOptions),e.name&&(e.components[e.name]=t)}}return e}function ir(t){var e,i=t.options,s=t.sealedOptions;for(var n in i)i[n]!==s[n]&&(e||(e={}),e[n]=i[n]);return e}function sr(t){this._init(t)}function nr(t){t.use=function(t){var e=this._installedPlugins||(this._installedPlugins=[]);if(e.indexOf(t)>-1)return this;var i=P(arguments,1);return i.unshift(this),d(t.install)?t.install.apply(t,i):d(t)&&t.apply(null,i),e.push(t),this}}function rr(t){t.mixin=function(t){return this.options=An(this.options,t),this}}function or(t){t.cid=0;var e=1;t.extend=function(t){t=t||{};var i=this,s=i.cid,n=t._Ctor||(t._Ctor={});if(n[s])return n[s];var r=dn(t)||dn(i.options);var o=function(t){this._init(t)};return o.prototype=Object.create(i.prototype),o.prototype.constructor=o,o.cid=e++,o.options=An(i.options,t),o["super"]=i,o.options.props&&ar(o),o.options.computed&&lr(o),o.extend=i.extend,o.mixin=i.mixin,o.use=i.use,V.forEach((function(t){o[t]=i[t]})),r&&(o.options.components[r]=o),o.superOptions=i.options,o.extendOptions=t,o.sealedOptions=O({},o.options),n[s]=o,o}}function ar(t){var e=t.options.props;for(var i in e)Bn(t.prototype,"_props",i)}function lr(t){var e=t.options.computed;for(var i in e)Hn(t.prototype,i,e[i])}function cr(t){V.forEach((function(e){t[e]=function(t,i){return i?("component"===e&&p(i)&&(i.name=i.name||t,i=this.options._base.extend(i)),"directive"===e&&d(i)&&(i={bind:i,update:i}),this.options[e+"s"][t]=i,i):this.options[e+"s"][t]}}))}function dr(t){return t&&(dn(t.Ctor.options)||t.tag)}function ur(t,e){return n(t)?t.indexOf(e)>-1:"string"===typeof t?t.split(",").indexOf(e)>-1:!!f(t)&&t.test(e)}function hr(t,e){var i=t.cache,s=t.keys,n=t._vnode;for(var r in i){var o=i[r];if(o){var a=o.name;a&&!e(a)&&pr(i,r,s,n)}}}function pr(t,e,i,s){var n=t[e];!n||s&&n.tag===s.tag||n.componentInstance.$destroy(),t[e]=null,S(i,e)}Jn(sr),Zn(sr),As(sr),Ps(sr),_i(sr);var fr=[String,RegExp,Array],mr={name:"keep-alive",abstract:!0,props:{include:fr,exclude:fr,max:[String,Number]},methods:{cacheVNode:function(){var t=this,e=t.cache,i=t.keys,s=t.vnodeToCache,n=t.keyToCache;if(s){var r=s.tag,o=s.componentInstance,a=s.componentOptions;e[n]={name:dr(a),tag:r,componentInstance:o},i.push(n),this.max&&i.length>parseInt(this.max)&&pr(e,i[0],i,this._vnode),this.vnodeToCache=null}}},created:function(){this.cache=Object.create(null),this.keys=[]},destroyed:function(){for(var t in this.cache)pr(this.cache,t,this.keys)},mounted:function(){var t=this;this.cacheVNode(),this.$watch("include",(function(e){hr(t,(function(t){return ur(e,t)}))})),this.$watch("exclude",(function(e){hr(t,(function(t){return!ur(e,t)}))}))},updated:function(){this.cacheVNode()},render:function(){var t=this.$slots.default,e=Ri(t),i=e&&e.componentOptions;if(i){var s=dr(i),n=this,r=n.include,o=n.exclude;if(r&&(!s||!ur(r,s))||o&&s&&ur(o,s))return e;var a=this,l=a.cache,c=a.keys,d=null==e.key?i.Ctor.cid+(i.tag?"::".concat(i.tag):""):e.key;l[d]?(e.componentInstance=l[d].componentInstance,S(c,d),c.push(d)):(this.vnodeToCache=e,this.keyToCache=d),e.data.keepAlive=!0}return e||t&&t[0]}},vr={KeepAlive:mr};function gr(t){var e={get:function(){return z}};Object.defineProperty(t,"config",e),t.util={warn:yn,extend:O,mergeOptions:An,defineReactive:$t},t.set=Ut,t.delete=jt,t.nextTick=Zi,t.observable=function(t){return Bt(t),t},t.options=Object.create(null),V.forEach((function(e){t.options[e+"s"]=Object.create(null)})),t.options._base=t,O(t.options.components,vr),nr(t),rr(t),or(t),cr(t)}gr(sr),Object.defineProperty(sr.prototype,"$isServer",{get:dt}),Object.defineProperty(sr.prototype,"$ssrContext",{get:function(){return this.$vnode&&this.$vnode.ssrContext}}),Object.defineProperty(sr,"FunctionalRenderContext",{value:on}),sr.version=vs;var yr=b("style,class"),br=b("input,textarea,option,select,progress"),wr=function(t,e,i){return"value"===i&&br(t)&&"button"!==e||"selected"===i&&"option"===t||"checked"===i&&"input"===t||"muted"===i&&"video"===t},Sr=b("contenteditable,draggable,spellcheck"),Er=b("events,caret,typing,plaintext-only"),Tr=function(t,e){return Lr(e)||"false"===e?"false":"contenteditable"===t&&Er(e)?e:"true"},xr=b("allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,default,defaultchecked,defaultmuted,defaultselected,defer,disabled,enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,required,reversed,scoped,seamless,selected,sortable,truespeed,typemustmatch,visible"),Cr="http://www.w3.org/1999/xlink",_r=function(t){return":"===t.charAt(5)&&"xlink"===t.slice(0,5)},kr=function(t){return _r(t)?t.slice(6,t.length):""},Lr=function(t){return null==t||!1===t};function Ar(t){var e=t.data,i=t,s=t;while(o(s.componentInstance))s=s.componentInstance._vnode,s&&s.data&&(e=Rr(s.data,e));while(o(i=i.parent))i&&i.data&&(e=Rr(e,i.data));return Ir(e.staticClass,e.class)}function Rr(t,e){return{staticClass:Dr(t.staticClass,e.staticClass),class:o(t.class)?[t.class,e.class]:e.class}}function Ir(t,e){return o(t)||o(e)?Dr(t,Pr(e)):""}function Dr(t,e){return t?e?t+" "+e:t:e||""}function Pr(t){return Array.isArray(t)?Or(t):u(t)?Mr(t):"string"===typeof t?t:""}function Or(t){for(var e,i="",s=0,n=t.length;s<n;s++)o(e=Pr(t[s]))&&""!==e&&(i&&(i+=" "),i+=e);return i}function Mr(t){var e="";for(var i in t)t[i]&&(e&&(e+=" "),e+=i);return e}var Nr={svg:"http://www.w3.org/2000/svg",math:"http://www.w3.org/1998/Math/MathML"},Fr=b("html,body,base,head,link,meta,style,title,address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,menuitem,summary,content,element,shadow,template,blockquote,iframe,tfoot"),Br=b("svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,foreignobject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view",!0),$r=function(t){return Fr(t)||Br(t)};function Ur(t){return Br(t)?"svg":"math"===t?"math":void 0}var jr=Object.create(null);function qr(t){if(!J)return!0;if($r(t))return!1;if(t=t.toLowerCase(),null!=jr[t])return jr[t];var e=document.createElement(t);return t.indexOf("-")>-1?jr[t]=e.constructor===window.HTMLUnknownElement||e.constructor===window.HTMLElement:jr[t]=/HTMLUnknownElement/.test(e.toString())}var Gr=b("text,number,password,search,email,tel,url");function Vr(t){if("string"===typeof t){var e=document.querySelector(t);return e||document.createElement("div")}return t}function Hr(t,e){var i=document.createElement(t);return"select"!==t||e.data&&e.data.attrs&&void 0!==e.data.attrs.multiple&&i.setAttribute("multiple","multiple"),i}function zr(t,e){return document.createElementNS(Nr[t],e)}function Kr(t){return document.createTextNode(t)}function Wr(t){return document.createComment(t)}function Yr(t,e,i){t.insertBefore(e,i)}function Xr(t,e){t.removeChild(e)}function Zr(t,e){t.appendChild(e)}function Qr(t){return t.parentNode}function Jr(t){return t.nextSibling}function to(t){return t.tagName}function eo(t,e){t.textContent=e}function io(t,e){t.setAttribute(e,"")}var so=Object.freeze({__proto__:null,createElement:Hr,createElementNS:zr,createTextNode:Kr,createComment:Wr,insertBefore:Yr,removeChild:Xr,appendChild:Zr,parentNode:Qr,nextSibling:Jr,tagName:to,setTextContent:eo,setStyleScope:io}),no={create:function(t,e){ro(e)},update:function(t,e){t.data.ref!==e.data.ref&&(ro(t,!0),ro(e))},destroy:function(t){ro(t,!0)}};function ro(t,e){var i=t.data.ref;if(o(i)){var s=t.context,r=t.componentInstance||t.elm,a=e?null:r,l=e?void 0:r;if(d(i))$i(i,s,[a],s,"template ref function");else{var c=t.data.refInFor,u="string"===typeof i||"number"===typeof i,h=Jt(i),p=s.$refs;if(u||h)if(c){var f=u?p[i]:i.value;e?n(f)&&S(f,r):n(f)?f.includes(r)||f.push(r):u?(p[i]=[r],oo(s,i,p[i])):i.value=[r]}else if(u){if(e&&p[i]!==r)return;p[i]=l,oo(s,i,a)}else if(h){if(e&&i.value!==r)return;i.value=a}else 0}}}function oo(t,e,i){var s=t._setupState;s&&T(s,e)&&(Jt(s[e])?s[e].value=i:s[e]=i)}var ao=new yt("",{},[]),lo=["create","activate","update","remove","destroy"];function co(t,e){return t.key===e.key&&t.asyncFactory===e.asyncFactory&&(t.tag===e.tag&&t.isComment===e.isComment&&o(t.data)===o(e.data)&&uo(t,e)||a(t.isAsyncPlaceholder)&&r(e.asyncFactory.error))}function uo(t,e){if("input"!==t.tag)return!0;var i,s=o(i=t.data)&&o(i=i.attrs)&&i.type,n=o(i=e.data)&&o(i=i.attrs)&&i.type;return s===n||Gr(s)&&Gr(n)}function ho(t,e,i){var s,n,r={};for(s=e;s<=i;++s)n=t[s].key,o(n)&&(r[n]=s);return r}function po(t){var e,i,s={},l=t.modules,d=t.nodeOps;for(e=0;e<lo.length;++e)for(s[lo[e]]=[],i=0;i<l.length;++i)o(l[i][lo[e]])&&s[lo[e]].push(l[i][lo[e]]);function u(t){return new yt(d.tagName(t).toLowerCase(),{},[],void 0,t)}function h(t,e){function i(){0===--i.listeners&&p(t)}return i.listeners=e,i}function p(t){var e=d.parentNode(t);o(e)&&d.removeChild(e,t)}function f(t,e,i,s,n,r,l){if(o(t.elm)&&o(r)&&(t=r[l]=St(t)),t.isRootInsert=!n,!m(t,e,i,s)){var c=t.data,u=t.children,h=t.tag;o(h)?(t.elm=t.ns?d.createElementNS(t.ns,h):d.createElement(h,t),T(t),w(t,u,e),o(c)&&E(t,e),y(i,t.elm,s)):a(t.isComment)?(t.elm=d.createComment(t.text),y(i,t.elm,s)):(t.elm=d.createTextNode(t.text),y(i,t.elm,s))}}function m(t,e,i,s){var n=t.data;if(o(n)){var r=o(t.componentInstance)&&n.keepAlive;if(o(n=n.hook)&&o(n=n.init)&&n(t,!1),o(t.componentInstance))return v(t,e),y(i,t.elm,s),a(r)&&g(t,e,i,s),!0}}function v(t,e){o(t.data.pendingInsert)&&(e.push.apply(e,t.data.pendingInsert),t.data.pendingInsert=null),t.elm=t.componentInstance.$el,S(t)?(E(t,e),T(t)):(ro(t),e.push(t))}function g(t,e,i,n){var r,a=t;while(a.componentInstance)if(a=a.componentInstance._vnode,o(r=a.data)&&o(r=r.transition)){for(r=0;r<s.activate.length;++r)s.activate[r](ao,a);e.push(a);break}y(i,t.elm,n)}function y(t,e,i){o(t)&&(o(i)?d.parentNode(i)===t&&d.insertBefore(t,e,i):d.appendChild(t,e))}function w(t,e,i){if(n(e)){0;for(var s=0;s<e.length;++s)f(e[s],i,t.elm,null,!0,e,s)}else c(t.text)&&d.appendChild(t.elm,d.createTextNode(String(t.text)))}function S(t){while(t.componentInstance)t=t.componentInstance._vnode;return o(t.tag)}function E(t,i){for(var n=0;n<s.create.length;++n)s.create[n](ao,t);e=t.data.hook,o(e)&&(o(e.create)&&e.create(ao,t),o(e.insert)&&i.push(t))}function T(t){var e;if(o(e=t.fnScopeId))d.setStyleScope(t.elm,e);else{var i=t;while(i)o(e=i.context)&&o(e=e.$options._scopeId)&&d.setStyleScope(t.elm,e),i=i.parent}o(e=Rs)&&e!==t.context&&e!==t.fnContext&&o(e=e.$options._scopeId)&&d.setStyleScope(t.elm,e)}function x(t,e,i,s,n,r){for(;s<=n;++s)f(i[s],r,t,e,!1,i,s)}function C(t){var e,i,n=t.data;if(o(n))for(o(e=n.hook)&&o(e=e.destroy)&&e(t),e=0;e<s.destroy.length;++e)s.destroy[e](t);if(o(e=t.children))for(i=0;i<t.children.length;++i)C(t.children[i])}function _(t,e,i){for(;e<=i;++e){var s=t[e];o(s)&&(o(s.tag)?(k(s),C(s)):p(s.elm))}}function k(t,e){if(o(e)||o(t.data)){var i,n=s.remove.length+1;for(o(e)?e.listeners+=n:e=h(t.elm,n),o(i=t.componentInstance)&&o(i=i._vnode)&&o(i.data)&&k(i,e),i=0;i<s.remove.length;++i)s.remove[i](t,e);o(i=t.data.hook)&&o(i=i.remove)?i(t,e):e()}else p(t.elm)}function L(t,e,i,s,n){var a,l,c,u,h=0,p=0,m=e.length-1,v=e[0],g=e[m],y=i.length-1,b=i[0],w=i[y],S=!n;while(h<=m&&p<=y)r(v)?v=e[++h]:r(g)?g=e[--m]:co(v,b)?(R(v,b,s,i,p),v=e[++h],b=i[++p]):co(g,w)?(R(g,w,s,i,y),g=e[--m],w=i[--y]):co(v,w)?(R(v,w,s,i,y),S&&d.insertBefore(t,v.elm,d.nextSibling(g.elm)),v=e[++h],w=i[--y]):co(g,b)?(R(g,b,s,i,p),S&&d.insertBefore(t,g.elm,v.elm),g=e[--m],b=i[++p]):(r(a)&&(a=ho(e,h,m)),l=o(b.key)?a[b.key]:A(b,e,h,m),r(l)?f(b,s,t,v.elm,!1,i,p):(c=e[l],co(c,b)?(R(c,b,s,i,p),e[l]=void 0,S&&d.insertBefore(t,c.elm,v.elm)):f(b,s,t,v.elm,!1,i,p)),b=i[++p]);h>m?(u=r(i[y+1])?null:i[y+1].elm,x(t,u,i,p,y,s)):p>y&&_(e,h,m)}function A(t,e,i,s){for(var n=i;n<s;n++){var r=e[n];if(o(r)&&co(t,r))return n}}function R(t,e,i,n,l,c){if(t!==e){o(e.elm)&&o(n)&&(e=n[l]=St(e));var u=e.elm=t.elm;if(a(t.isAsyncPlaceholder))o(e.asyncFactory.resolved)?P(t.elm,e,i):e.isAsyncPlaceholder=!0;else if(a(e.isStatic)&&a(t.isStatic)&&e.key===t.key&&(a(e.isCloned)||a(e.isOnce)))e.componentInstance=t.componentInstance;else{var h,p=e.data;o(p)&&o(h=p.hook)&&o(h=h.prepatch)&&h(t,e);var f=t.children,m=e.children;if(o(p)&&S(e)){for(h=0;h<s.update.length;++h)s.update[h](t,e);o(h=p.hook)&&o(h=h.update)&&h(t,e)}r(e.text)?o(f)&&o(m)?f!==m&&L(u,f,m,i,c):o(m)?(o(t.text)&&d.setTextContent(u,""),x(u,null,m,0,m.length-1,i)):o(f)?_(f,0,f.length-1):o(t.text)&&d.setTextContent(u,""):t.text!==e.text&&d.setTextContent(u,e.text),o(p)&&o(h=p.hook)&&o(h=h.postpatch)&&h(t,e)}}}function I(t,e,i){if(a(i)&&o(t.parent))t.parent.data.pendingInsert=e;else for(var s=0;s<e.length;++s)e[s].data.hook.insert(e[s])}var D=b("attrs,class,staticClass,staticStyle,key");function P(t,e,i,s){var n,r=e.tag,l=e.data,c=e.children;if(s=s||l&&l.pre,e.elm=t,a(e.isComment)&&o(e.asyncFactory))return e.isAsyncPlaceholder=!0,!0;if(o(l)&&(o(n=l.hook)&&o(n=n.init)&&n(e,!0),o(n=e.componentInstance)))return v(e,i),!0;if(o(r)){if(o(c))if(t.hasChildNodes())if(o(n=l)&&o(n=n.domProps)&&o(n=n.innerHTML)){if(n!==t.innerHTML)return!1}else{for(var d=!0,u=t.firstChild,h=0;h<c.length;h++){if(!u||!P(u,c[h],i,s)){d=!1;break}u=u.nextSibling}if(!d||u)return!1}else w(e,c,i);if(o(l)){var p=!1;for(var f in l)if(!D(f)){p=!0,E(e,i);break}!p&&l["class"]&&bs(l["class"])}}else t.data!==e.text&&(t.data=e.text);return!0}return function(t,e,i,n){if(!r(e)){var l=!1,c=[];if(r(t))l=!0,f(e,c);else{var h=o(t.nodeType);if(!h&&co(t,e))R(t,e,c,null,null,n);else{if(h){if(1===t.nodeType&&t.hasAttribute(G)&&(t.removeAttribute(G),i=!0),a(i)&&P(t,e,c))return I(e,c,!0),t;t=u(t)}var p=t.elm,m=d.parentNode(p);if(f(e,c,p._leaveCb?null:m,d.nextSibling(p)),o(e.parent)){var v=e.parent,g=S(e);while(v){for(var y=0;y<s.destroy.length;++y)s.destroy[y](v);if(v.elm=e.elm,g){for(var b=0;b<s.create.length;++b)s.create[b](ao,v);var w=v.data.hook.insert;if(w.merged)for(var E=1;E<w.fns.length;E++)w.fns[E]()}else ro(v);v=v.parent}}o(m)?_([t],0,0):o(t.tag)&&C(t)}}return I(e,c,l),e.elm}o(t)&&C(t)}}var fo={create:mo,update:mo,destroy:function(t){mo(t,ao)}};function mo(t,e){(t.data.directives||e.data.directives)&&vo(t,e)}function vo(t,e){var i,s,n,r=t===ao,o=e===ao,a=yo(t.data.directives,t.context),l=yo(e.data.directives,e.context),c=[],d=[];for(i in l)s=a[i],n=l[i],s?(n.oldValue=s.value,n.oldArg=s.arg,wo(n,"update",e,t),n.def&&n.def.componentUpdated&&d.push(n)):(wo(n,"bind",e,t),n.def&&n.def.inserted&&c.push(n));if(c.length){var u=function(){for(var i=0;i<c.length;i++)wo(c[i],"inserted",e,t)};r?$e(e,"insert",u):u()}if(d.length&&$e(e,"postpatch",(function(){for(var i=0;i<d.length;i++)wo(d[i],"componentUpdated",e,t)})),!r)for(i in a)l[i]||wo(a[i],"unbind",t,t,o)}var go=Object.create(null);function yo(t,e){var i,s,n=Object.create(null);if(!t)return n;for(i=0;i<t.length;i++){if(s=t[i],s.modifiers||(s.modifiers=go),n[bo(s)]=s,e._setupState&&e._setupState.__sfc){var r=s.def||Rn(e,"_setupState","v-"+s.name);s.def="function"===typeof r?{bind:r,update:r}:r}s.def=s.def||Rn(e.$options,"directives",s.name,!0)}return n}function bo(t){return t.rawName||"".concat(t.name,".").concat(Object.keys(t.modifiers||{}).join("."))}function wo(t,e,i,s,n){var r=t.def&&t.def[e];if(r)try{r(i.elm,t,i,s,n)}catch(nl){Bi(nl,i.context,"directive ".concat(t.name," ").concat(e," hook"))}}var So=[no,fo];function Eo(t,e){var i=e.componentOptions;if((!o(i)||!1!==i.Ctor.options.inheritAttrs)&&(!r(t.data.attrs)||!r(e.data.attrs))){var s,n,l,c=e.elm,d=t.data.attrs||{},u=e.data.attrs||{};for(s in(o(u.__ob__)||a(u._v_attr_proxy))&&(u=e.data.attrs=O({},u)),u)n=u[s],l=d[s],l!==n&&To(c,s,n,e.data.pre);for(s in(et||st)&&u.value!==d.value&&To(c,"value",u.value),d)r(u[s])&&(_r(s)?c.removeAttributeNS(Cr,kr(s)):Sr(s)||c.removeAttribute(s))}}function To(t,e,i,s){s||t.tagName.indexOf("-")>-1?xo(t,e,i):xr(e)?Lr(i)?t.removeAttribute(e):(i="allowfullscreen"===e&&"EMBED"===t.tagName?"true":e,t.setAttribute(e,i)):Sr(e)?t.setAttribute(e,Tr(e,i)):_r(e)?Lr(i)?t.removeAttributeNS(Cr,kr(e)):t.setAttributeNS(Cr,e,i):xo(t,e,i)}function xo(t,e,i){if(Lr(i))t.removeAttribute(e);else{if(et&&!it&&"TEXTAREA"===t.tagName&&"placeholder"===e&&""!==i&&!t.__ieph){var s=function(e){e.stopImmediatePropagation(),t.removeEventListener("input",s)};t.addEventListener("input",s),t.__ieph=!0}t.setAttribute(e,i)}}var Co={create:Eo,update:Eo};function _o(t,e){var i=e.elm,s=e.data,n=t.data;if(!(r(s.staticClass)&&r(s.class)&&(r(n)||r(n.staticClass)&&r(n.class)))){var a=Ar(e),l=i._transitionClasses;o(l)&&(a=Dr(a,Pr(l))),a!==i._prevClass&&(i.setAttribute("class",a),i._prevClass=a)}}var ko,Lo={create:_o,update:_o},Ao="__r",Ro="__c";function Io(t){if(o(t[Ao])){var e=et?"change":"input";t[e]=[].concat(t[Ao],t[e]||[]),delete t[Ao]}o(t[Ro])&&(t.change=[].concat(t[Ro],t.change||[]),delete t[Ro])}function Do(t,e,i){var s=ko;return function n(){var r=e.apply(null,arguments);null!==r&&Mo(t,n,i,s)}}var Po=Gi&&!(ot&&Number(ot[1])<=53);function Oo(t,e,i,s){if(Po){var n=Ks,r=e;e=r._wrapper=function(t){if(t.target===t.currentTarget||t.timeStamp>=n||t.timeStamp<=0||t.target.ownerDocument!==document)return r.apply(this,arguments)}}ko.addEventListener(t,e,lt?{capture:i,passive:s}:i)}function Mo(t,e,i,s){(s||ko).removeEventListener(t,e._wrapper||e,i)}function No(t,e){if(!r(t.data.on)||!r(e.data.on)){var i=e.data.on||{},s=t.data.on||{};ko=e.elm||t.elm,Io(i),Be(i,s,Oo,Mo,Do,e.context),ko=void 0}}var Fo,Bo={create:No,update:No,destroy:function(t){return No(t,ao)}};function $o(t,e){if(!r(t.data.domProps)||!r(e.data.domProps)){var i,s,n=e.elm,l=t.data.domProps||{},c=e.data.domProps||{};for(i in(o(c.__ob__)||a(c._v_attr_proxy))&&(c=e.data.domProps=O({},c)),l)i in c||(n[i]="");for(i in c){if(s=c[i],"textContent"===i||"innerHTML"===i){if(e.children&&(e.children.length=0),s===l[i])continue;1===n.childNodes.length&&n.removeChild(n.childNodes[0])}if("value"===i&&"PROGRESS"!==n.tagName){n._value=s;var d=r(s)?"":String(s);Uo(n,d)&&(n.value=d)}else if("innerHTML"===i&&Br(n.tagName)&&r(n.innerHTML)){Fo=Fo||document.createElement("div"),Fo.innerHTML="<svg>".concat(s,"</svg>");var u=Fo.firstChild;while(n.firstChild)n.removeChild(n.firstChild);while(u.firstChild)n.appendChild(u.firstChild)}else if(s!==l[i])try{n[i]=s}catch(nl){}}}}function Uo(t,e){return!t.composing&&("OPTION"===t.tagName||jo(t,e)||qo(t,e))}function jo(t,e){var i=!0;try{i=document.activeElement!==t}catch(nl){}return i&&t.value!==e}function qo(t,e){var i=t.value,s=t._vModifiers;if(o(s)){if(s.number)return y(i)!==y(e);if(s.trim)return i.trim()!==e.trim()}return i!==e}var Go={create:$o,update:$o},Vo=x((function(t){var e={},i=/;(?![^(]*\))/g,s=/:(.+)/;return t.split(i).forEach((function(t){if(t){var i=t.split(s);i.length>1&&(e[i[0].trim()]=i[1].trim())}})),e}));function Ho(t){var e=zo(t.style);return t.staticStyle?O(t.staticStyle,e):e}function zo(t){return Array.isArray(t)?M(t):"string"===typeof t?Vo(t):t}function Ko(t,e){var i,s={};if(e){var n=t;while(n.componentInstance)n=n.componentInstance._vnode,n&&n.data&&(i=Ho(n.data))&&O(s,i)}(i=Ho(t.data))&&O(s,i);var r=t;while(r=r.parent)r.data&&(i=Ho(r.data))&&O(s,i);return s}var Wo,Yo=/^--/,Xo=/\s*!important$/,Zo=function(t,e,i){if(Yo.test(e))t.style.setProperty(e,i);else if(Xo.test(i))t.style.setProperty(A(e),i.replace(Xo,""),"important");else{var s=Jo(e);if(Array.isArray(i))for(var n=0,r=i.length;n<r;n++)t.style[s]=i[n];else t.style[s]=i}},Qo=["Webkit","Moz","ms"],Jo=x((function(t){if(Wo=Wo||document.createElement("div").style,t=_(t),"filter"!==t&&t in Wo)return t;for(var e=t.charAt(0).toUpperCase()+t.slice(1),i=0;i<Qo.length;i++){var s=Qo[i]+e;if(s in Wo)return s}}));function ta(t,e){var i=e.data,s=t.data;if(!(r(i.staticStyle)&&r(i.style)&&r(s.staticStyle)&&r(s.style))){var n,a,l=e.elm,c=s.staticStyle,d=s.normalizedStyle||s.style||{},u=c||d,h=zo(e.data.style)||{};e.data.normalizedStyle=o(h.__ob__)?O({},h):h;var p=Ko(e,!0);for(a in u)r(p[a])&&Zo(l,a,"");for(a in p)n=p[a],n!==u[a]&&Zo(l,a,null==n?"":n)}}var ea={create:ta,update:ta},ia=/\s+/;function sa(t,e){if(e&&(e=e.trim()))if(t.classList)e.indexOf(" ")>-1?e.split(ia).forEach((function(e){return t.classList.add(e)})):t.classList.add(e);else{var i=" ".concat(t.getAttribute("class")||""," ");i.indexOf(" "+e+" ")<0&&t.setAttribute("class",(i+e).trim())}}function na(t,e){if(e&&(e=e.trim()))if(t.classList)e.indexOf(" ")>-1?e.split(ia).forEach((function(e){return t.classList.remove(e)})):t.classList.remove(e),t.classList.length||t.removeAttribute("class");else{var i=" ".concat(t.getAttribute("class")||""," "),s=" "+e+" ";while(i.indexOf(s)>=0)i=i.replace(s," ");i=i.trim(),i?t.setAttribute("class",i):t.removeAttribute("class")}}function ra(t){if(t){if("object"===typeof t){var e={};return!1!==t.css&&O(e,oa(t.name||"v")),O(e,t),e}return"string"===typeof t?oa(t):void 0}}var oa=x((function(t){return{enterClass:"".concat(t,"-enter"),enterToClass:"".concat(t,"-enter-to"),enterActiveClass:"".concat(t,"-enter-active"),leaveClass:"".concat(t,"-leave"),leaveToClass:"".concat(t,"-leave-to"),leaveActiveClass:"".concat(t,"-leave-active")}})),aa=J&&!it,la="transition",ca="animation",da="transition",ua="transitionend",ha="animation",pa="animationend";aa&&(void 0===window.ontransitionend&&void 0!==window.onwebkittransitionend&&(da="WebkitTransition",ua="webkitTransitionEnd"),void 0===window.onanimationend&&void 0!==window.onwebkitanimationend&&(ha="WebkitAnimation",pa="webkitAnimationEnd"));var fa=J?window.requestAnimationFrame?window.requestAnimationFrame.bind(window):setTimeout:function(t){return t()};function ma(t){fa((function(){fa(t)}))}function va(t,e){var i=t._transitionClasses||(t._transitionClasses=[]);i.indexOf(e)<0&&(i.push(e),sa(t,e))}function ga(t,e){t._transitionClasses&&S(t._transitionClasses,e),na(t,e)}function ya(t,e,i){var s=wa(t,e),n=s.type,r=s.timeout,o=s.propCount;if(!n)return i();var a=n===la?ua:pa,l=0,c=function(){t.removeEventListener(a,d),i()},d=function(e){e.target===t&&++l>=o&&c()};setTimeout((function(){l<o&&c()}),r+1),t.addEventListener(a,d)}var ba=/\b(transform|all)(,|$)/;function wa(t,e){var i,s=window.getComputedStyle(t),n=(s[da+"Delay"]||"").split(", "),r=(s[da+"Duration"]||"").split(", "),o=Sa(n,r),a=(s[ha+"Delay"]||"").split(", "),l=(s[ha+"Duration"]||"").split(", "),c=Sa(a,l),d=0,u=0;e===la?o>0&&(i=la,d=o,u=r.length):e===ca?c>0&&(i=ca,d=c,u=l.length):(d=Math.max(o,c),i=d>0?o>c?la:ca:null,u=i?i===la?r.length:l.length:0);var h=i===la&&ba.test(s[da+"Property"]);return{type:i,timeout:d,propCount:u,hasTransform:h}}function Sa(t,e){while(t.length<e.length)t=t.concat(t);return Math.max.apply(null,e.map((function(e,i){return Ea(e)+Ea(t[i])})))}function Ea(t){return 1e3*Number(t.slice(0,-1).replace(",","."))}function Ta(t,e){var i=t.elm;o(i._leaveCb)&&(i._leaveCb.cancelled=!0,i._leaveCb());var s=ra(t.data.transition);if(!r(s)&&!o(i._enterCb)&&1===i.nodeType){var n=s.css,a=s.type,l=s.enterClass,c=s.enterToClass,h=s.enterActiveClass,p=s.appearClass,f=s.appearToClass,m=s.appearActiveClass,v=s.beforeEnter,g=s.enter,b=s.afterEnter,w=s.enterCancelled,S=s.beforeAppear,E=s.appear,T=s.afterAppear,x=s.appearCancelled,C=s.duration,_=Rs,k=Rs.$vnode;while(k&&k.parent)_=k.context,k=k.parent;var L=!_._isMounted||!t.isRootInsert;if(!L||E||""===E){var A=L&&p?p:l,R=L&&m?m:h,I=L&&f?f:c,D=L&&S||v,P=L&&d(E)?E:g,O=L&&T||b,M=L&&x||w,N=y(u(C)?C.enter:C);0;var F=!1!==n&&!it,B=_a(P),$=i._enterCb=j((function(){F&&(ga(i,I),ga(i,R)),$.cancelled?(F&&ga(i,A),M&&M(i)):O&&O(i),i._enterCb=null}));t.data.show||$e(t,"insert",(function(){var e=i.parentNode,s=e&&e._pending&&e._pending[t.key];s&&s.tag===t.tag&&s.elm._leaveCb&&s.elm._leaveCb(),P&&P(i,$)})),D&&D(i),F&&(va(i,A),va(i,R),ma((function(){ga(i,A),$.cancelled||(va(i,I),B||(Ca(N)?setTimeout($,N):ya(i,a,$)))}))),t.data.show&&(e&&e(),P&&P(i,$)),F||B||$()}}}function xa(t,e){var i=t.elm;o(i._enterCb)&&(i._enterCb.cancelled=!0,i._enterCb());var s=ra(t.data.transition);if(r(s)||1!==i.nodeType)return e();if(!o(i._leaveCb)){var n=s.css,a=s.type,l=s.leaveClass,c=s.leaveToClass,d=s.leaveActiveClass,h=s.beforeLeave,p=s.leave,f=s.afterLeave,m=s.leaveCancelled,v=s.delayLeave,g=s.duration,b=!1!==n&&!it,w=_a(p),S=y(u(g)?g.leave:g);0;var E=i._leaveCb=j((function(){i.parentNode&&i.parentNode._pending&&(i.parentNode._pending[t.key]=null),b&&(ga(i,c),ga(i,d)),E.cancelled?(b&&ga(i,l),m&&m(i)):(e(),f&&f(i)),i._leaveCb=null}));v?v(T):T()}function T(){E.cancelled||(!t.data.show&&i.parentNode&&((i.parentNode._pending||(i.parentNode._pending={}))[t.key]=t),h&&h(i),b&&(va(i,l),va(i,d),ma((function(){ga(i,l),E.cancelled||(va(i,c),w||(Ca(S)?setTimeout(E,S):ya(i,a,E)))}))),p&&p(i,E),b||w||E())}}function Ca(t){return"number"===typeof t&&!isNaN(t)}function _a(t){if(r(t))return!1;var e=t.fns;return o(e)?_a(Array.isArray(e)?e[0]:e):(t._length||t.length)>1}function ka(t,e){!0!==e.data.show&&Ta(e)}var La=J?{create:ka,activate:ka,remove:function(t,e){!0!==t.data.show?xa(t,e):e()}}:{},Aa=[Co,Lo,Bo,Go,ea,La],Ra=Aa.concat(So),Ia=po({nodeOps:so,modules:Ra});it&&document.addEventListener("selectionchange",(function(){var t=document.activeElement;t&&t.vmodel&&$a(t,"input")}));var Da={inserted:function(t,e,i,s){"select"===i.tag?(s.elm&&!s.elm._vOptions?$e(i,"postpatch",(function(){Da.componentUpdated(t,e,i)})):Pa(t,e,i.context),t._vOptions=[].map.call(t.options,Na)):("textarea"===i.tag||Gr(t.type))&&(t._vModifiers=e.modifiers,e.modifiers.lazy||(t.addEventListener("compositionstart",Fa),t.addEventListener("compositionend",Ba),t.addEventListener("change",Ba),it&&(t.vmodel=!0)))},componentUpdated:function(t,e,i){if("select"===i.tag){Pa(t,e,i.context);var s=t._vOptions,n=t._vOptions=[].map.call(t.options,Na);if(n.some((function(t,e){return!$(t,s[e])}))){var r=t.multiple?e.value.some((function(t){return Ma(t,n)})):e.value!==e.oldValue&&Ma(e.value,n);r&&$a(t,"change")}}}};function Pa(t,e,i){Oa(t,e,i),(et||st)&&setTimeout((function(){Oa(t,e,i)}),0)}function Oa(t,e,i){var s=e.value,n=t.multiple;if(!n||Array.isArray(s)){for(var r,o,a=0,l=t.options.length;a<l;a++)if(o=t.options[a],n)r=U(s,Na(o))>-1,o.selected!==r&&(o.selected=r);else if($(Na(o),s))return void(t.selectedIndex!==a&&(t.selectedIndex=a));n||(t.selectedIndex=-1)}}function Ma(t,e){return e.every((function(e){return!$(e,t)}))}function Na(t){return"_value"in t?t._value:t.value}function Fa(t){t.target.composing=!0}function Ba(t){t.target.composing&&(t.target.composing=!1,$a(t.target,"input"))}function $a(t,e){var i=document.createEvent("HTMLEvents");i.initEvent(e,!0,!0),t.dispatchEvent(i)}function Ua(t){return!t.componentInstance||t.data&&t.data.transition?t:Ua(t.componentInstance._vnode)}var ja={bind:function(t,e,i){var s=e.value;i=Ua(i);var n=i.data&&i.data.transition,r=t.__vOriginalDisplay="none"===t.style.display?"":t.style.display;s&&n?(i.data.show=!0,Ta(i,(function(){t.style.display=r}))):t.style.display=s?r:"none"},update:function(t,e,i){var s=e.value,n=e.oldValue;if(!s!==!n){i=Ua(i);var r=i.data&&i.data.transition;r?(i.data.show=!0,s?Ta(i,(function(){t.style.display=t.__vOriginalDisplay})):xa(i,(function(){t.style.display="none"}))):t.style.display=s?t.__vOriginalDisplay:"none"}},unbind:function(t,e,i,s,n){n||(t.style.display=t.__vOriginalDisplay)}},qa={model:Da,show:ja},Ga={name:String,appear:Boolean,css:Boolean,mode:String,type:String,enterClass:String,leaveClass:String,enterToClass:String,leaveToClass:String,enterActiveClass:String,leaveActiveClass:String,appearClass:String,appearActiveClass:String,appearToClass:String,duration:[Number,String,Object]};function Va(t){var e=t&&t.componentOptions;return e&&e.Ctor.options.abstract?Va(Ri(e.children)):t}function Ha(t){var e={},i=t.$options;for(var s in i.propsData)e[s]=t[s];var n=i._parentListeners;for(var s in n)e[_(s)]=n[s];return e}function za(t,e){if(/\d-keep-alive$/.test(e.tag))return t("keep-alive",{props:e.componentOptions.propsData})}function Ka(t){while(t=t.parent)if(t.data.transition)return!0}function Wa(t,e){return e.key===t.key&&e.tag===t.tag}var Ya=function(t){return t.tag||ci(t)},Xa=function(t){return"show"===t.name},Za={name:"transition",props:Ga,abstract:!0,render:function(t){var e=this,i=this.$slots.default;if(i&&(i=i.filter(Ya),i.length)){0;var s=this.mode;0;var n=i[0];if(Ka(this.$vnode))return n;var r=Va(n);if(!r)return n;if(this._leaving)return za(t,n);var o="__transition-".concat(this._uid,"-");r.key=null==r.key?r.isComment?o+"comment":o+r.tag:c(r.key)?0===String(r.key).indexOf(o)?r.key:o+r.key:r.key;var a=(r.data||(r.data={})).transition=Ha(this),l=this._vnode,d=Va(l);if(r.data.directives&&r.data.directives.some(Xa)&&(r.data.show=!0),d&&d.data&&!Wa(r,d)&&!ci(d)&&(!d.componentInstance||!d.componentInstance._vnode.isComment)){var u=d.data.transition=O({},a);if("out-in"===s)return this._leaving=!0,$e(u,"afterLeave",(function(){e._leaving=!1,e.$forceUpdate()})),za(t,n);if("in-out"===s){if(ci(r))return l;var h,p=function(){h()};$e(a,"afterEnter",p),$e(a,"enterCancelled",p),$e(u,"delayLeave",(function(t){h=t}))}}return n}}},Qa=O({tag:String,moveClass:String},Ga);delete Qa.mode;var Ja={props:Qa,beforeMount:function(){var t=this,e=this._update;this._update=function(i,s){var n=Is(t);t.__patch__(t._vnode,t.kept,!1,!0),t._vnode=t.kept,n(),e.call(t,i,s)}},render:function(t){for(var e=this.tag||this.$vnode.data.tag||"span",i=Object.create(null),s=this.prevChildren=this.children,n=this.$slots.default||[],r=this.children=[],o=Ha(this),a=0;a<n.length;a++){var l=n[a];if(l.tag)if(null!=l.key&&0!==String(l.key).indexOf("__vlist"))r.push(l),i[l.key]=l,(l.data||(l.data={})).transition=o;else;}if(s){var c=[],d=[];for(a=0;a<s.length;a++){l=s[a];l.data.transition=o,l.data.pos=l.elm.getBoundingClientRect(),i[l.key]?c.push(l):d.push(l)}this.kept=t(e,null,c),this.removed=d}return t(e,null,r)},updated:function(){var t=this.prevChildren,e=this.moveClass||(this.name||"v")+"-move";t.length&&this.hasMove(t[0].elm,e)&&(t.forEach(tl),t.forEach(el),t.forEach(il),this._reflow=document.body.offsetHeight,t.forEach((function(t){if(t.data.moved){var i=t.elm,s=i.style;va(i,e),s.transform=s.WebkitTransform=s.transitionDuration="",i.addEventListener(ua,i._moveCb=function t(s){s&&s.target!==i||s&&!/transform$/.test(s.propertyName)||(i.removeEventListener(ua,t),i._moveCb=null,ga(i,e))})}})))},methods:{hasMove:function(t,e){if(!aa)return!1;if(this._hasMove)return this._hasMove;var i=t.cloneNode();t._transitionClasses&&t._transitionClasses.forEach((function(t){na(i,t)})),sa(i,e),i.style.display="none",this.$el.appendChild(i);var s=wa(i);return this.$el.removeChild(i),this._hasMove=s.hasTransform}}};function tl(t){t.elm._moveCb&&t.elm._moveCb(),t.elm._enterCb&&t.elm._enterCb()}function el(t){t.data.newPos=t.elm.getBoundingClientRect()}function il(t){var e=t.data.pos,i=t.data.newPos,s=e.left-i.left,n=e.top-i.top;if(s||n){t.data.moved=!0;var r=t.elm.style;r.transform=r.WebkitTransform="translate(".concat(s,"px,").concat(n,"px)"),r.transitionDuration="0s"}}var sl={Transition:Za,TransitionGroup:Ja};sr.config.mustUseProp=wr,sr.config.isReservedTag=$r,sr.config.isReservedAttr=yr,sr.config.getTagNamespace=Ur,sr.config.isUnknownElement=qr,O(sr.options.directives,qa),O(sr.options.components,sl),sr.prototype.__patch__=J?Ia:N,sr.prototype.$mount=function(t,e){return t=t&&J?Vr(t):void 0,Os(this,t,e)},J&&setTimeout((function(){z.devtools&&ut&&ut.emit("init",sr)}),0)},1586:function(t){"use strict";t.exports="data:image/svg+xml;charset=utf-8,%3Csvg width=%27144%27 height=%27144%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M9.544 73.269a6.922 6.922 0 0 1 9.806-.225l-9.614-9.261a7.948 7.948 0 0 1 10.992-11.441l.385.384a8.46 8.46 0 0 1 11.697-12.21l5.513 5.288A7.948 7.948 0 0 1 49.25 34.363L77.87 61.828c-3.558-5.256-2.372-14.422 3.204-17.37a5.128 5.128 0 0 1 6.698 1.859l13.941 17.978c11.727 19.09 9.093 43.691-6.41 59.866a29.644 29.644 0 0 1-41.918.865L9.736 83.076a6.922 6.922 0 0 1-.192-9.807Z%27 fill=%27%23FAC232%27/%3E%3Cpath d=%27M9.544 73.269a6.922 6.922 0 0 1 9.806-.225l-9.614-9.261a7.948 7.948 0 0 1 10.992-11.441l.385.384a8.46 8.46 0 0 1 11.697-12.21l5.513 5.288A7.948 7.948 0 0 1 49.25 34.363L77.87 61.828c-3.558-5.256-2.372-14.422 3.204-17.37a5.128 5.128 0 0 1 6.698 1.859l13.941 17.978c11.727 19.09 9.093 43.691-6.41 59.866a29.644 29.644 0 0 1-41.918.865L9.736 83.076a6.922 6.922 0 0 1-.192-9.807Z%27 fill=%27%23000%27 fill-opacity=%27.05%27/%3E%3Cpath d=%27M37.435 34.016a9.55 9.55 0 0 1 12.806-.913l.12.104 23.942 22.978-.019-.23c-.388-5.084 1.66-10.405 5.775-12.766l.284-.157a6.73 6.73 0 0 1 8.791 2.44l-.052-.08 13.898 17.922.099.143c12.108 19.712 9.389 45.111-6.619 61.813a31.25 31.25 0 0 1-21.903 9.609 31.251 31.251 0 0 1-22.282-8.697L8.628 84.233a8.525 8.525 0 0 1-.245-12.068 8.525 8.525 0 0 1 4.97-2.563l.102-.013-4.897-4.72a9.55 9.55 0 0 1-.076-12.857l.214-.23a9.544 9.544 0 0 1 8.458-2.804l.213.038-.076-.377a10.053 10.053 0 0 1 2.415-8.52l.22-.238c3.743-3.906 9.904-4.155 13.994-.521l.88.844.006-.133a9.523 9.523 0 0 1 2.412-5.82l.217-.235Zm10.603 1.44a6.346 6.346 0 0 0-8.502 9.302l.07.088L62.795 67.08a1.602 1.602 0 0 1-2.094 2.42l-.124-.107-23.395-22.433a1.615 1.615 0 0 1-.171-.192l-5.264-5.054a6.858 6.858 0 0 0-9.482 9.897l.093.103.051.063 28.657 27.514a1.602 1.602 0 0 1-2.095 2.42l-.124-.108-28.875-27.722a1.614 1.614 0 0 1-.192-.22l-.131-.133-.174-.141a6.346 6.346 0 0 0-8.271.418l-.197.197c-2.324 2.418-2.364 6.227-.159 8.626l9.602 9.25.01.01 19.645 18.844a1.602 1.602 0 0 1-2.094 2.42l-.124-.108-19.634-18.833-.195-.179a5.32 5.32 0 0 0-3.336-1.31h-.284a5.327 5.327 0 0 0-3.741 1.659 5.32 5.32 0 0 0 .15 7.538l43.648 41.95a28.039 28.039 0 0 0 39.652-.818c14.999-15.649 17.547-39.448 6.201-57.918l.042.07-13.883-17.905-.096-.137a3.52 3.52 0 0 0-4.587-1.287c-4.495 2.376-5.814 10.347-2.627 15.055l-.143-.218 14.315 13.74a1.603 1.603 0 0 1-2.095 2.42l-.124-.107-14.166-13.597a1.851 1.851 0 0 1-.224-.184l-28.55-27.4-.172-.128Z%27 fill=%27%2345413C%27/%3E%3Cpath d=%27m119.404 42.888 17.049-5.32a1.25 1.25 0 0 0 .802-1.795l-4.391-7.403a1.281 1.281 0 0 0-1.987 0L118.25 41.19a1.122 1.122 0 0 0 1.154 1.698ZM109.981 35.228l8.333-15.767a1.249 1.249 0 0 0-.673-1.86l-8.365-2.146a1.248 1.248 0 0 0-1.474 1.314v17.914a1.154 1.154 0 0 0 2.179.545ZM48.866 23.403 57.807 7.86a1.282 1.282 0 0 0-.64-1.86l-8.3-2.37a1.25 1.25 0 0 0-1.507 1.25l-.513 17.946a1.122 1.122 0 0 0 2.02.577ZM36.752 24.268 32.17 7.058a1.25 1.25 0 0 0-1.762-.865l-7.692 4.134a1.282 1.282 0 0 0-.16 1.987L34.797 25.39a1.154 1.154 0 0 0 1.955-1.122Z%27 fill=%27%23FAC232%27/%3E%3Cpath d=%27M131.654 26.303a2.883 2.883 0 0 0-1.877.892l-.052.058-12.618 12.811a1.65 1.65 0 0 0-.216.274 2.725 2.725 0 0 0 2.802 4.125l.187-.046 17.049-5.32c.762-.189 1.466-.78 1.823-1.58.357-.798.327-1.717-.081-2.491l-4.43-7.474-.136-.195a2.886 2.886 0 0 0-2.236-1.062l-.215.008Zm.144 3.412 3.817 6.437-14.661 4.572 10.844-11.009ZM107.152 14.554a2.852 2.852 0 0 0-.948 2.323l-.004 17.806a2.75 2.75 0 0 0 2.088 2.69 2.755 2.755 0 0 0 3.118-1.411l8.325-15.753-.063.11a2.852 2.852 0 0 0-1.536-4.243l-8.457-2.174c-.899-.17-1.728.03-2.367.523l-.156.13Zm2.252 2.584 7.329 1.884-7.329 13.868V17.138ZM46.789 2.657a2.852 2.852 0 0 0-1.03 2.256l-.513 17.867.005.176a2.724 2.724 0 0 0 4.903 1.4l.102-.155 8.941-15.543a2.867 2.867 0 0 0 .24-2.4 2.885 2.885 0 0 0-1.698-1.754l-.132-.044-8.3-2.372-.111-.027a2.852 2.852 0 0 0-2.407.596ZM48.95 5.32l7.274 2.078-7.717 13.414.443-15.492ZM29.714 4.748l-7.757 4.168-.146.088a2.884 2.884 0 0 0-.36 4.47l12.177 13.01a2.749 2.749 0 0 0 3.396.52 2.756 2.756 0 0 0 1.257-3.217L33.718 6.646c-.164-.778-.73-1.501-1.514-1.887a2.852 2.852 0 0 0-2.49-.011Zm1.008 3.094L34.756 23 23.964 11.474l6.758-3.632Z%27 fill=%27%2345413C%27/%3E%3Cpath d=%27M30.183 80.127a6.922 6.922 0 0 1 9.807-.192l-9.615-9.262a7.948 7.948 0 1 1 10.993-11.441l.384.352a8.46 8.46 0 1 1 11.698-12.21l5.512 5.288a7.922 7.922 0 1 1 10.96-11.441l28.619 27.465c-3.557-5.256-2.372-14.454 3.205-17.37a5.096 5.096 0 0 1 6.698 1.827l13.94 18.01c11.734 19.078 9.099 43.674-6.409 59.834a29.645 29.645 0 0 1-41.919.865l-43.68-41.886a6.986 6.986 0 0 1-.193-9.84Z%27 fill=%27%23FAC232%27/%3E%3Cpath opacity=%27.45%27 d=%27M101.745 60.514a5.096 5.096 0 0 1 6.698 1.826l13.941 18.011a49.478 49.478 0 0 1 7.082 21.312 49.195 49.195 0 0 0-7.082-30.35l-13.941-18.17a5.096 5.096 0 0 0-6.698-1.827c-4.775 2.5-6.41 9.614-4.487 14.806a9.614 9.614 0 0 1 4.487-5.608ZM58.705 50.643a7.948 7.948 0 0 1 11.184-.256l19.966 19.229a11.056 11.056 0 0 0 11.954 2.275L69.761 41.157a7.916 7.916 0 0 0-11.921 10.32c.252-.314.542-.593.865-.834Z%27 fill=%27%23fff%27/%3E%3Cpath d=%27M57.564 40.353c3.639-3.798 9.668-3.928 13.467-.288l23.942 22.977-.011-.129c-.426-5.126 1.622-10.514 5.76-12.864l.279-.152a6.698 6.698 0 0 1 8.804 2.401l-.056-.086 13.902 17.961.098.141c12.115 19.7 9.395 45.096-6.618 61.782a31.247 31.247 0 0 1-44.184.913L29.259 91.116a8.59 8.59 0 0 1-.234-12.097 8.525 8.525 0 0 1 4.979-2.547l.074-.009-4.74-4.569a9.55 9.55 0 0 1-3.202-9.05l.068-.325a9.55 9.55 0 0 1 11.042-7.296l.265.053-.05-.258a10.05 10.05 0 0 1 .033-3.695l.072-.337a10.063 10.063 0 0 1 7.113-7.424c3.552-.986 7.358.05 9.88 2.656l.365.35a9.496 9.496 0 0 1 2.426-5.984l.214-.231Zm11.25 2.025a6.32 6.32 0 0 0-8.744 9.127l.097.1c.036.04.07.08.1.12l23.167 22.247a1.603 1.603 0 0 1-2.096 2.419l-.124-.108L57.82 53.819a1.62 1.62 0 0 1-.17-.192l-5.351-5.137a6.858 6.858 0 0 0-6.482-1.91l-.28.07a6.858 6.858 0 0 0-2.72 11.737l.025.023c.084.078.157.159.22.24l28.675 27.533a1.602 1.602 0 0 1-2.095 2.42l-.124-.108L40.61 60.74a1.625 1.625 0 0 1-.147-.161l-.178-.165-.097-.096a6.345 6.345 0 0 0-10.858 2.904c-.518 2.303.284 4.702 2.156 6.297l9.615 9.262.013.013 19.63 18.829a1.602 1.602 0 0 1-2.095 2.42l-.124-.108L38.88 81.091l-.008-.007-.204-.187a5.32 5.32 0 0 0-3.309-1.299l-.282-.001a5.318 5.318 0 0 0-3.735 1.636 5.382 5.382 0 0 0 .142 7.576l43.681 41.887a28.037 28.037 0 0 0 19.996 7.804 28.037 28.037 0 0 0 19.657-8.623c15.003-15.633 17.552-39.427 6.201-57.884l.038.064-13.881-17.933-.095-.137a3.493 3.493 0 0 0-4.593-1.25c-4.486 2.345-5.808 10.342-2.62 15.05l-.034-.05 14.172 13.572a1.603 1.603 0 0 1-2.093 2.422l-.124-.107-14.39-13.78a1.624 1.624 0 0 1-.174-.197L68.814 42.378Z%27 fill=%27%2345413C%27/%3E%3C/svg%3E"},5185:function(t){"use strict";t.exports="data:image/svg+xml;charset=utf-8,%3Csvg width=%2716%27 height=%2716%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0Z%27 fill=%27%232DD269%27/%3E%3Cpath d=%27M11.608 4.242a.5.5 0 0 1 .816.575l-.032.045L7.17 11.47a1.198 1.198 0 0 1-1.903.01L3.591 9.103a.5.5 0 0 1 .784-.618l.034.042 1.64 2.328a.199.199 0 0 0 .312.024l.018-.022 5.229-6.615Z%27 fill=%27%23fff%27/%3E%3C/svg%3E"}},e={};function i(s){var n=e[s];if(void 0!==n)return n.exports;var r=e[s]={id:s,exports:{}};return t[s].call(r.exports,r,r.exports,i),r.exports}i.m=t,function(){i.n=function(t){var e=t&&t.__esModule?function(){return t["default"]}:function(){return t};return i.d(e,{a:e}),e}}(),function(){i.d=function(t,e){for(var s in e)i.o(e,s)&&!i.o(t,s)&&Object.defineProperty(t,s,{enumerable:!0,get:e[s]})}}(),function(){i.g=function(){if("object"===typeof globalThis)return globalThis;try{return this||new Function("return this")()}catch(t){if("object"===typeof window)return window}}()}(),function(){i.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)}}(),function(){i.r=function(t){"undefined"!==typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})}}(),function(){i.p=""}(),function(){i.b=document.baseURI||self.location.href}();!function(){"use strict";if("undefined"!==typeof window){var t=window.document.currentScript;if({NODE_ENV:"production",BASE_URL:"/"}.NEED_CURRENTSCRIPT_POLYFILL){var e=i(7679);t=e(),"currentScript"in document||Object.defineProperty(document,"currentScript",{get:e})}var s=t&&t.src.match(/(.+\/)[^/]+\.js(\?.*)?$/);s&&(i.p=s[1])}var n=i(144);const r=/-(\w)/g,o=t=>t.replace(r,((t,e)=>e?e.toUpperCase():"")),a=/\B([A-Z])/g,l=t=>t.replace(a,"-$1").toLowerCase();function c(t){const e={};return t.forEach((t=>{e[t]=void 0})),e}function d(t,e,i){t[e]=[].concat(t[e]||[]),t[e].unshift(i)}function u(t,e){if(t){const i=t.$options[e]||[];i.forEach((e=>{e.call(t)}))}}function h(t,e){return new CustomEvent(t,{bubbles:!1,cancelable:!1,detail:e})}const p=t=>/function Boolean/.test(String(t)),f=t=>/function Number/.test(String(t));function m(t,e,{type:i}={}){if(p(i))return"true"===t||"false"===t?"true"===t:""===t||t===e||null!=t||t;if(f(i)){const e=parseFloat(t,10);return isNaN(e)?t:e}return t}function v(t,e){const i=[];for(let s=0,n=e.length;s<n;s++)i.push(g(t,e[s]));return i}function g(t,e){if(3===e.nodeType)return e.data.trim()?e.data:null;if(1===e.nodeType){const i={attrs:y(e),domProps:{innerHTML:e.innerHTML}};return i.attrs.slot&&(i.slot=i.attrs.slot,delete i.attrs.slot),t(e.tagName,i)}return null}function y(t){const e={};for(let i=0,s=t.attributes.length;i<s;i++){const s=t.attributes[i];e[s.nodeName]=s.nodeValue}return e}function b(t,e){const i="function"===typeof e&&!e.cid;let s,n,r,a=!1;function p(t){if(a)return;const e="function"===typeof t?t.options:t,i=Array.isArray(e.props)?e.props:Object.keys(e.props||{});s=i.map(l),n=i.map(o);const c=Array.isArray(e.props)?{}:e.props||{};r=n.reduce(((t,e,s)=>(t[e]=c[i[s]],t)),{}),d(e,"beforeCreate",(function(){const t=this.$emit;this.$emit=(e,...i)=>(this.$root.$options.customElement.dispatchEvent(h(e,i)),t.call(this,e,...i))})),d(e,"created",(function(){n.forEach((t=>{this.$root.props[t]=this[t]}))})),n.forEach((t=>{Object.defineProperty(g.prototype,t,{get(){return this._wrapper.props[t]},set(e){this._wrapper.props[t]=e},enumerable:!1,configurable:!0})})),a=!0}function f(t,e){const i=o(e),s=t.hasAttribute(e)?t.getAttribute(e):void 0;t._wrapper.props[i]=m(s,e,r[i])}class g extends HTMLElement{constructor(){const i=super();i.attachShadow({mode:"open"});const s=i._wrapper=new t({name:"shadow-root",customElement:i,shadowRoot:i.shadowRoot,data(){return{props:{},slotChildren:[]}},render(t){return t(e,{ref:"inner",props:this.props},this.slotChildren)}}),n=new MutationObserver((t=>{let e=!1;for(let s=0;s<t.length;s++){const n=t[s];a&&"attributes"===n.type&&n.target===i?f(i,n.attributeName):e=!0}e&&(s.slotChildren=Object.freeze(v(s.$createElement,i.childNodes)))}));n.observe(i,{childList:!0,subtree:!0,characterData:!0,attributes:!0})}get vueComponent(){return this._wrapper.$refs.inner}connectedCallback(){const t=this._wrapper;if(t._isMounted)u(this.vueComponent,"activated");else{const i=()=>{t.props=c(n),s.forEach((t=>{f(this,t)}))};a?i():e().then((t=>{(t.__esModule||"Module"===t[Symbol.toStringTag])&&(t=t.default),p(t),i()})),t.slotChildren=Object.freeze(v(t.$createElement,this.childNodes)),t.$mount(),this.shadowRoot.appendChild(t.$el)}}disconnectedCallback(){u(this.vueComponent,"deactivated")}}return i||p(e),g}var w=b,S=(i(3645),function(){var t=this,e=t._self._c;t._self._setupProxy;return e("div",{staticClass:"smvp-video-player-wrapper",class:{"is-side-bar-below":t.isSideBarBelow,"smvp-large-display":t.large,"smvp-vertical-display":t.isVertical,"dark-mode":t.darkMode.enabled},style:t.cssOverrides},[t.noPlayer?t._e():e("video-player-core",{ref:"videoPlayerCore",attrs:{"event-bus":t.eventBus,"player-state-repository":t.playerStateRepository,"source-url":t.sourceUrl,autoplay:t.autoplay,preload:t.preload,"loop-video":t.loopVideo,thumbnail:t.thumbnail,"use-credentials":t.useCredentials,"restrict-metadata":t.restrictMetadata,"metadata-types":t.metadataTypes,"has-control-bar":t.hasControlBar,"hide-control-bar":t.hideControlBar,"hide-mouse-on-idle":t.hideMouseOnIdle,"always-collapse-control-bar-on-idle":t.alwaysCollapseControlBarOnIdle,"is-iframe-content":t.isIframeContent,"is-side-bar-below":t.isSideBarBelow,"disable-native-pip":t.disableNativePip,api:t.api,"content-id":t.contentId,"cmcd-session-id":t.cmcdSessionId,"hls-config-overwrites":t.hlsConfigOverwritesObject,"hive-config":t.hiveConfig,"has-split-panes":t.hasSplitPanes,"default-split-pane-size":t.defaultSplitPaneSize},scopedSlots:t._u([{key:"widgetsBehind",fn:function(){return t._l(t.widgetsBehind,(function(i){return e(i.component,{directives:[{name:"show",rawName:"v-show",value:!i.hidden,expression:"!widget.hidden"}],key:i.id,tag:"component",attrs:{api:t.api,config:i.config,labels:i.labels}})}))},proxy:!0},{key:"widgetsInside",fn:function(){return t._l(t.widgetsInside,(function(i){return e(i.component,{directives:[{name:"show",rawName:"v-show",value:!i.hidden,expression:"!widget.hidden"}],key:i.id,tag:"component",attrs:{api:t.api,config:i.config,labels:i.labels}})}))},proxy:!0},{key:"widgetsOutside",fn:function(){return t._l(t.widgetsOutside,(function(i){return e(i.component,{directives:[{name:"show",rawName:"v-show",value:!i.hidden,expression:"!widget.hidden"}],key:i.id,tag:"component",attrs:{api:t.api,config:i.config,labels:i.labels}})}))},proxy:!0},{key:"widgetsSplitPane",fn:function(){return t._l(t.widgetsSplitPane,(function(i){return e(i.component,{directives:[{name:"show",rawName:"v-show",value:!i.hidden,expression:"!widget.hidden"}],key:i.id,tag:"component",attrs:{api:t.api,config:i.config,labels:i.labels},on:{"has-content":t.onSplitPaneHasContent}})}))},proxy:!0},{key:"controlbar-left",fn:function(){return t._l(t.controlsLeft,(function(i){return e(i.component,{directives:[{name:"show",rawName:"v-show",value:!i.hidden,expression:"!control.hidden"}],key:i.id,tag:"component",attrs:{api:t.api,config:i.config,labels:i.labels,"is-left":!0}})}))},proxy:!0},{key:"controlbar-right",fn:function(){return t._l(t.controlsRight,(function(i){return e(i.component,{directives:[{name:"show",rawName:"v-show",value:!i.hidden,expression:"!control.hidden"}],key:i.id,tag:"component",attrs:{api:t.api,config:i.config,labels:i.labels}})}))},proxy:!0}],null,!1,3016456490)}),t.sideBarConfig?e("side-bar",{attrs:{api:t.api,labels:t.labels["side-bar"],config:t.sideBarConfig,"is-side-bar-below":t.isSideBarBelow,"is-webinar":t.isWebinar,"no-player":t.noPlayer}}):t._e(),t.noPlayer?e("portal-target",{staticClass:"no-player",attrs:{name:t.sideBarNotificationPortalId}}):t._e()],1)}),E=[],T=(i(7658),Array.isArray),x=T,C="object"==typeof global&&global&&global.Object===Object&&global,_=C,k="object"==typeof self&&self&&self.Object===Object&&self,L=_||k||Function("return this")(),A=L,R=A.Symbol,I=R,D=Object.prototype,P=D.hasOwnProperty,O=D.toString,M=I?I.toStringTag:void 0;function N(t){var e=P.call(t,M),i=t[M];try{t[M]=void 0;var s=!0}catch(r){}var n=O.call(t);return s&&(e?t[M]=i:delete t[M]),n}var F=N,B=Object.prototype,$=B.toString;function U(t){return $.call(t)}var j=U,q="[object Null]",G="[object Undefined]",V=I?I.toStringTag:void 0;function H(t){return null==t?void 0===t?G:q:V&&V in Object(t)?F(t):j(t)}var z=H;function K(t){return null!=t&&"object"==typeof t}var W=K,Y="[object Symbol]";function X(t){return"symbol"==typeof t||W(t)&&z(t)==Y}var Z=X,Q=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,J=/^\w*$/;function tt(t,e){if(x(t))return!1;var i=typeof t;return!("number"!=i&&"symbol"!=i&&"boolean"!=i&&null!=t&&!Z(t))||(J.test(t)||!Q.test(t)||null!=e&&t in Object(e))}var et=tt;function it(t){var e=typeof t;return null!=t&&("object"==e||"function"==e)}var st=it,nt="[object AsyncFunction]",rt="[object Function]",ot="[object GeneratorFunction]",at="[object Proxy]";function lt(t){if(!st(t))return!1;var e=z(t);return e==rt||e==ot||e==nt||e==at}var ct=lt,dt=A["__core-js_shared__"],ut=dt,ht=function(){var t=/[^.]+$/.exec(ut&&ut.keys&&ut.keys.IE_PROTO||"");return t?"Symbol(src)_1."+t:""}();function pt(t){return!!ht&&ht in t}var ft=pt,mt=Function.prototype,vt=mt.toString;function gt(t){if(null!=t){try{return vt.call(t)}catch(e){}try{return t+""}catch(e){}}return""}var yt=gt,bt=/[\\^$.*+?()[\]{}|]/g,wt=/^\[object .+?Constructor\]$/,St=Function.prototype,Et=Object.prototype,Tt=St.toString,xt=Et.hasOwnProperty,Ct=RegExp("^"+Tt.call(xt).replace(bt,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$");function _t(t){if(!st(t)||ft(t))return!1;var e=ct(t)?Ct:wt;return e.test(yt(t))}var kt=_t;function Lt(t,e){return null==t?void 0:t[e]}var At=Lt;function Rt(t,e){var i=At(t,e);return kt(i)?i:void 0}var It=Rt,Dt=It(Object,"create"),Pt=Dt;function Ot(){this.__data__=Pt?Pt(null):{},this.size=0}var Mt=Ot;function Nt(t){var e=this.has(t)&&delete this.__data__[t];return this.size-=e?1:0,e}var Ft=Nt,Bt="__lodash_hash_undefined__",$t=Object.prototype,Ut=$t.hasOwnProperty;function jt(t){var e=this.__data__;if(Pt){var i=e[t];return i===Bt?void 0:i}return Ut.call(e,t)?e[t]:void 0}var qt=jt,Gt=Object.prototype,Vt=Gt.hasOwnProperty;function Ht(t){var e=this.__data__;return Pt?void 0!==e[t]:Vt.call(e,t)}var zt=Ht,Kt="__lodash_hash_undefined__";function Wt(t,e){var i=this.__data__;return this.size+=this.has(t)?0:1,i[t]=Pt&&void 0===e?Kt:e,this}var Yt=Wt;function Xt(t){var e=-1,i=null==t?0:t.length;this.clear();while(++e<i){var s=t[e];this.set(s[0],s[1])}}Xt.prototype.clear=Mt,Xt.prototype["delete"]=Ft,Xt.prototype.get=qt,Xt.prototype.has=zt,Xt.prototype.set=Yt;var Zt=Xt;function Qt(){this.__data__=[],this.size=0}var Jt=Qt;function te(t,e){return t===e||t!==t&&e!==e}var ee=te;function ie(t,e){var i=t.length;while(i--)if(ee(t[i][0],e))return i;return-1}var se=ie,ne=Array.prototype,re=ne.splice;function oe(t){var e=this.__data__,i=se(e,t);if(i<0)return!1;var s=e.length-1;return i==s?e.pop():re.call(e,i,1),--this.size,!0}var ae=oe;function le(t){var e=this.__data__,i=se(e,t);return i<0?void 0:e[i][1]}var ce=le;function de(t){return se(this.__data__,t)>-1}var ue=de;function he(t,e){var i=this.__data__,s=se(i,t);return s<0?(++this.size,i.push([t,e])):i[s][1]=e,this}var pe=he;function fe(t){var e=-1,i=null==t?0:t.length;this.clear();while(++e<i){var s=t[e];this.set(s[0],s[1])}}fe.prototype.clear=Jt,fe.prototype["delete"]=ae,fe.prototype.get=ce,fe.prototype.has=ue,fe.prototype.set=pe;var me=fe,ve=It(A,"Map"),ge=ve;function ye(){this.size=0,this.__data__={hash:new Zt,map:new(ge||me),string:new Zt}}var be=ye;function we(t){var e=typeof t;return"string"==e||"number"==e||"symbol"==e||"boolean"==e?"__proto__"!==t:null===t}var Se=we;function Ee(t,e){var i=t.__data__;return Se(e)?i["string"==typeof e?"string":"hash"]:i.map}var Te=Ee;function xe(t){var e=Te(this,t)["delete"](t);return this.size-=e?1:0,e}var Ce=xe;function _e(t){return Te(this,t).get(t)}var ke=_e;function Le(t){return Te(this,t).has(t)}var Ae=Le;function Re(t,e){var i=Te(this,t),s=i.size;return i.set(t,e),this.size+=i.size==s?0:1,this}var Ie=Re;function De(t){var e=-1,i=null==t?0:t.length;this.clear();while(++e<i){var s=t[e];this.set(s[0],s[1])}}De.prototype.clear=be,De.prototype["delete"]=Ce,De.prototype.get=ke,De.prototype.has=Ae,De.prototype.set=Ie;var Pe=De,Oe="Expected a function";function Me(t,e){if("function"!=typeof t||null!=e&&"function"!=typeof e)throw new TypeError(Oe);var i=function(){var s=arguments,n=e?e.apply(this,s):s[0],r=i.cache;if(r.has(n))return r.get(n);var o=t.apply(this,s);return i.cache=r.set(n,o)||r,o};return i.cache=new(Me.Cache||Pe),i}Me.Cache=Pe;var Ne=Me,Fe=500;function Be(t){var e=Ne(t,(function(t){return i.size===Fe&&i.clear(),t})),i=e.cache;return e}var $e=Be,Ue=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,je=/\\(\\)?/g,qe=$e((function(t){var e=[];return 46===t.charCodeAt(0)&&e.push(""),t.replace(Ue,(function(t,i,s,n){e.push(s?n.replace(je,"$1"):i||t)})),e})),Ge=qe;function Ve(t,e){var i=-1,s=null==t?0:t.length,n=Array(s);while(++i<s)n[i]=e(t[i],i,t);return n}var He=Ve,ze=1/0,Ke=I?I.prototype:void 0,We=Ke?Ke.toString:void 0;function Ye(t){if("string"==typeof t)return t;if(x(t))return He(t,Ye)+"";if(Z(t))return We?We.call(t):"";var e=t+"";return"0"==e&&1/t==-ze?"-0":e}var Xe=Ye;function Ze(t){return null==t?"":Xe(t)}var Qe=Ze;function Je(t,e){return x(t)?t:et(t,e)?[t]:Ge(Qe(t))}var ti=Je,ei=1/0;function ii(t){if("string"==typeof t||Z(t))return t;var e=t+"";return"0"==e&&1/t==-ei?"-0":e}var si=ii;function ni(t,e){e=ti(e,t);var i=0,s=e.length;while(null!=t&&i<s)t=t[si(e[i++])];return i&&i==s?t:void 0}var ri=ni;function oi(t,e,i){var s=null==t?void 0:ri(t,e);return void 0===s?i:s}var ai=oi,li=function(){var t=this,e=t._self._c;t._self._setupProxy;return e("div",{ref:"video-player",staticClass:"smvp-video-player",class:{"smvp-fullscreen":t.state.isVideoElementFullScreen,"smvp-client-fullscreen":t.isClientFullScreen,"smvp-idle":t.state.isIdle,"is-side-bar-below":t.isSideBarBelow},on:{mouseover:t.onMouseEnters,mouseleave:t.onMouseLeaves}},[e("div",{staticClass:"video-area-wrapper",class:{"control-bar-at-bottom":t.controlBarAtBottom},style:{cursor:t.hideMouseCursor?"none":"default"}},[t._t("widgetsBehind"),e("splitpanes",{staticClass:"default-theme",class:{"has-no-split-panes":!t.hasSplitPanes}},[e("pane",{attrs:{"min-size":"25",size:100-t.splitPaneSize}},[e("div",{staticClass:"video-wrapper"},[t.isIframeContent?t._e():e("video",{key:t.videoElementKey,ref:"media-video",attrs:{poster:t.thumbnail,preload:"none",disablePictureInPicture:t.disableNativePip,controlsList:"nodownload",crossorigin:t.crossorigin,loop:t.loopVideo,playsinline:"","webkit-playsinline":""}},[e("source",{attrs:{type:t.srcType,src:t.sourceUrl}})]),t.isIframeContent?e("iframe",{key:t.iframeKey,staticClass:"smvp-core-iframe",attrs:{src:t.sourceUrl,frameborder:"0",allow:"microphone; camera; fullscreen; display-capture; autoplay",referrerpolicy:"origin",allowfullscreen:""}}):t._e()]),t.hasSplitPanes?t._t("widgetsInside"):t._e()],2),t.hasSplitPanes?t._e():t._t("widgetsInside"),e("pane",{attrs:{"min-size":"25",size:t.splitPaneSize}},[t._t("widgetsSplitPane")],2)],2),e("notifications",{attrs:{"player-state-repository":t.playerStateRepository,"event-bus":t.eventBus}}),e("portal-target",{staticClass:"with-player",attrs:{name:t.sideBarNotificationPortalId}}),t.hasControlBar?e("control-bar",{directives:[{name:"show",rawName:"v-show",value:!t.hideControlBar,expression:"!hideControlBar"}],attrs:{visible:t.isControlBarVisible}},[t._t("controlbar-left"),e("div",{staticClass:"smvp-spacer"}),t._t("controlbar-right")],2):t._e()],2),t._t("widgetsOutside")],2)},ci=[];function di(t,e,i,s){function n(t){return t instanceof i?t:new i((function(e){e(t)}))}return new(i||(i=Promise))((function(i,r){function o(t){try{l(s.next(t))}catch(e){r(e)}}function a(t){try{l(s["throw"](t))}catch(e){r(e)}}function l(t){t.done?i(t.value):n(t.value).then(o,a)}l((s=s.apply(t,e||[])).next())}))}Object.create;Object.create;var ui=function(){var t=this,e=t._self._c;t._self._setupProxy;return e("div",{staticClass:"smvp-control-bar",class:{"smvp-fold-below":!t.visible}},[t._t("default")],2)},hi=[],pi=n["default"].extend({props:{visible:{type:Boolean,default:!1}}}),fi=pi;function mi(t,e,i,s,n,r,o,a){var l,c="function"===typeof t?t.options:t;if(e&&(c.render=e,c.staticRenderFns=i,c._compiled=!0),s&&(c.functional=!0),r&&(c._scopeId="data-v-"+r),o?(l=function(t){t=t||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext,t||"undefined"===typeof __VUE_SSR_CONTEXT__||(t=__VUE_SSR_CONTEXT__),n&&n.call(this,t),t&&t._registeredComponents&&t._registeredComponents.add(o)},c._ssrRegister=l):n&&(l=a?function(){n.call(this,(c.functional?this.parent:this).$root.$options.shadowRoot)}:n),l)if(c.functional){c._injectStyles=l;var d=c.render;c.render=function(t,e){return l.call(e),d(t,e)}}else{var u=c.beforeCreate;c.beforeCreate=u?[].concat(u,l):[l]}return{exports:t,options:c}}var vi,gi=mi(fi,ui,hi,!1,null,null,null,!0),yi=gi.exports,bi=function(){var t=this,e=t._self._c;t._self._setupProxy;return e("div",{directives:[{name:"show",rawName:"v-show",value:!t.disabled,expression:"!disabled"}],staticClass:"smvp-notifications"},[e("loading",{attrs:{"player-state-repository":t.playerStateRepository}}),e("error-notification",{attrs:{"event-bus":t.eventBus}})],1)},wi=[],Si=function(){var t=this,e=t._self._c;t._self._setupProxy;return e("div",{staticClass:"smvp-loading-notification"},[t.show?e("div",{staticClass:"smvp-loading-shadow"},[e("div",{staticClass:"part"}),e("div",{staticClass:"part"}),e("div",{staticClass:"part"}),e("div",{staticClass:"part"})]):t._e(),t.show?e("div",{staticClass:"smvp-loading"},[e("div",{staticClass:"part"}),e("div",{staticClass:"part"}),e("div",{staticClass:"part"}),e("div",{staticClass:"part"})]):t._e()])},Ei=[],Ti=n["default"].extend({name:"Loading",props:{playerStateRepository:{type:Object,required:!0}},computed:{show(){var t,e;return null===(e=null===(t=this.playerStateRepository.state)||void 0===t?void 0:t.playback)||void 0===e?void 0:e.isStuck}}}),xi=Ti,Ci=mi(xi,Si,Ei,!1,null,null,null,!0),_i=Ci.exports,ki=function(){var t=this,e=t._self._c;t._self._setupProxy;return t.show?e("div",{staticClass:"smvp-error-notification"},[e("div",{staticClass:"smvp-message",domProps:{innerHTML:t._s(t.message)}})]):t._e()},Li=[];(function(t){t["stateChange"]="state-change",t["error"]="error",t["customAction"]="custom-action",t["clientAction"]="client-action",t["dispose"]="dispose",t["reset"]="reset",t["metadata"]="metadata",t["notification"]="notification",t["analytics"]="analytics",t["resize"]="resize",t["alwaysShowControlBar"]="always-show-control-bar",t["play"]="play",t["pause"]="pause",t["enterFullScreen"]="enter-full-screen",t["exitFullScreen"]="exit-full-screen",t["enterNativeFullScreen"]="enter-native-full-screen",t["exitNativeFullScreen"]="exit-native-full-screen",t["seek"]="seek",t["mute"]="mute",t["unmute"]="unmute",t["changeVolume"]="change-volume",t["selectSubtitleTrack"]="select-subtitle-track",t["disableSubtitles"]="disable-subtitles",t["disableNotifications"]="disable-notifications",t["selectLevel"]="select-level"})(vi||(vi={}));const Ai=new Set([vi.play,vi.pause,vi.mute,vi.unmute,vi.stateChange]);class Ri{constructor(){this.handlers=new Map}on(t,e){var i;const s=[...null!==(i=this.handlers.get(t))&&void 0!==i?i:[],e];return this.handlers.set(t,s),()=>{this.off(t,e)}}off(t,e){var i;const s=null!==(i=this.handlers.get(t))&&void 0!==i?i:[];this.handlers.set(t,s.filter((t=>t!==e)))}emit(t,e,i){var s;const n=null!==(s=this.handlers.get(t))&&void 0!==s?s:[];for(const o of n)if(Ai.has(t))try{o(e,i)}catch(r){console.error("[EventBus] handler error",r)}else setTimeout((()=>{try{o(e,i)}catch(r){console.error("[EventBus] handler error",r)}}))}}var Ii=n["default"].extend({name:"ErrorNotification",props:{eventBus:{type:Object,required:!0}},data(){return{show:!1,message:""}},mounted(){this.eventBus.on(vi.notification,this.onNotification)},methods:{onNotification(t,e){if("errorNotification"!==e||"object"!==typeof t)return;const{message:i,show:s}=t;this.message=i,this.show=s}}}),Di=Ii,Pi=mi(Di,ki,Li,!1,null,null,null,!0),Oi=Pi.exports,Mi=n["default"].extend({name:"Notifications",components:{Loading:_i,ErrorNotification:Oi},props:{eventBus:{type:Object,required:!0},playerStateRepository:{type:Object,required:!0}},data(){return{disabled:!1}},mounted(){this.eventBus.on(vi.disableNotifications,this.onDisableNotifications)},methods:{onDisableNotifications(t){this.disabled=t}}}),Ni=Mi,Fi=mi(Ni,bi,wi,!1,null,null,null,!0),Bi=Fi.exports,$i=i(2433);function Ui(t){return t&&t.__esModule&&Object.prototype.hasOwnProperty.call(t,"default")?t["default"]:t}var ji={exports:{}};(function(t,e){(function(e){var i=/^(?=((?:[a-zA-Z0-9+\-.]+:)?))\1(?=((?:\/\/[^\/?#]*)?))\2(?=((?:(?:[^?#\/]*\/)*[^;?#\/]*)?))\3((?:;[^?#]*)?)(\?[^#]*)?(#[^]*)?$/,s=/^(?=([^\/?#]*))\1([^]*)$/,n=/(?:\/|^)\.(?=\/)/g,r=/(?:\/|^)\.\.\/(?!\.\.\/)[^\/]*(?=\/)/g,o={buildAbsoluteURL:function(t,e,i){if(i=i||{},t=t.trim(),e=e.trim(),!e){if(!i.alwaysNormalize)return t;var n=o.parseURL(t);if(!n)throw new Error("Error trying to parse base URL.");return n.path=o.normalizePath(n.path),o.buildURLFromParts(n)}var r=o.parseURL(e);if(!r)throw new Error("Error trying to parse relative URL.");if(r.scheme)return i.alwaysNormalize?(r.path=o.normalizePath(r.path),o.buildURLFromParts(r)):e;var a=o.parseURL(t);if(!a)throw new Error("Error trying to parse base URL.");if(!a.netLoc&&a.path&&"/"!==a.path[0]){var l=s.exec(a.path);a.netLoc=l[1],a.path=l[2]}a.netLoc&&!a.path&&(a.path="/");var c={scheme:a.scheme,netLoc:r.netLoc,path:null,params:r.params,query:r.query,fragment:r.fragment};if(!r.netLoc&&(c.netLoc=a.netLoc,"/"!==r.path[0]))if(r.path){var d=a.path,u=d.substring(0,d.lastIndexOf("/")+1)+r.path;c.path=o.normalizePath(u)}else c.path=a.path,r.params||(c.params=a.params,r.query||(c.query=a.query));return null===c.path&&(c.path=i.alwaysNormalize?o.normalizePath(r.path):r.path),o.buildURLFromParts(c)},parseURL:function(t){var e=i.exec(t);return e?{scheme:e[1]||"",netLoc:e[2]||"",path:e[3]||"",params:e[4]||"",query:e[5]||"",fragment:e[6]||""}:null},normalizePath:function(t){t=t.split("").reverse().join("").replace(n,"");while(t.length!==(t=t.replace(r,"")).length);return t.split("").reverse().join("")},buildURLFromParts:function(t){return t.scheme+t.netLoc+t.path+t.params+t.query+t.fragment}};t.exports=o})()})(ji);var qi=ji.exports;function Gi(t,e){var i=Object.keys(t);if(Object.getOwnPropertySymbols){var s=Object.getOwnPropertySymbols(t);e&&(s=s.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),i.push.apply(i,s)}return i}function Vi(t){for(var e=1;e<arguments.length;e++){var i=null!=arguments[e]?arguments[e]:{};e%2?Gi(Object(i),!0).forEach((function(e){Ki(t,e,i[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(i)):Gi(Object(i)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(i,e))}))}return t}function Hi(t,e){if("object"!=typeof t||!t)return t;var i=t[Symbol.toPrimitive];if(void 0!==i){var s=i.call(t,e||"default");if("object"!=typeof s)return s;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===e?String:Number)(t)}function zi(t){var e=Hi(t,"string");return"symbol"==typeof e?e:String(e)}function Ki(t,e,i){return e=zi(e),e in t?Object.defineProperty(t,e,{value:i,enumerable:!0,configurable:!0,writable:!0}):t[e]=i,t}function Wi(){return Wi=Object.assign?Object.assign.bind():function(t){for(var e=1;e<arguments.length;e++){var i=arguments[e];for(var s in i)Object.prototype.hasOwnProperty.call(i,s)&&(t[s]=i[s])}return t},Wi.apply(this,arguments)}const Yi=Number.isFinite||function(t){return"number"===typeof t&&isFinite(t)},Xi=Number.isSafeInteger||function(t){return"number"===typeof t&&Math.abs(t)<=Zi},Zi=Number.MAX_SAFE_INTEGER||9007199254740991;let Qi=function(t){return t["MEDIA_ATTACHING"]="hlsMediaAttaching",t["MEDIA_ATTACHED"]="hlsMediaAttached",t["MEDIA_DETACHING"]="hlsMediaDetaching",t["MEDIA_DETACHED"]="hlsMediaDetached",t["BUFFER_RESET"]="hlsBufferReset",t["BUFFER_CODECS"]="hlsBufferCodecs",t["BUFFER_CREATED"]="hlsBufferCreated",t["BUFFER_APPENDING"]="hlsBufferAppending",t["BUFFER_APPENDED"]="hlsBufferAppended",t["BUFFER_EOS"]="hlsBufferEos",t["BUFFER_FLUSHING"]="hlsBufferFlushing",t["BUFFER_FLUSHED"]="hlsBufferFlushed",t["MANIFEST_LOADING"]="hlsManifestLoading",t["MANIFEST_LOADED"]="hlsManifestLoaded",t["MANIFEST_PARSED"]="hlsManifestParsed",t["LEVEL_SWITCHING"]="hlsLevelSwitching",t["LEVEL_SWITCHED"]="hlsLevelSwitched",t["LEVEL_LOADING"]="hlsLevelLoading",t["LEVEL_LOADED"]="hlsLevelLoaded",t["LEVEL_UPDATED"]="hlsLevelUpdated",t["LEVEL_PTS_UPDATED"]="hlsLevelPtsUpdated",t["LEVELS_UPDATED"]="hlsLevelsUpdated",t["AUDIO_TRACKS_UPDATED"]="hlsAudioTracksUpdated",t["AUDIO_TRACK_SWITCHING"]="hlsAudioTrackSwitching",t["AUDIO_TRACK_SWITCHED"]="hlsAudioTrackSwitched",t["AUDIO_TRACK_LOADING"]="hlsAudioTrackLoading",t["AUDIO_TRACK_LOADED"]="hlsAudioTrackLoaded",t["SUBTITLE_TRACKS_UPDATED"]="hlsSubtitleTracksUpdated",t["SUBTITLE_TRACKS_CLEARED"]="hlsSubtitleTracksCleared",t["SUBTITLE_TRACK_SWITCH"]="hlsSubtitleTrackSwitch",t["SUBTITLE_TRACK_LOADING"]="hlsSubtitleTrackLoading",t["SUBTITLE_TRACK_LOADED"]="hlsSubtitleTrackLoaded",t["SUBTITLE_FRAG_PROCESSED"]="hlsSubtitleFragProcessed",t["CUES_PARSED"]="hlsCuesParsed",t["NON_NATIVE_TEXT_TRACKS_FOUND"]="hlsNonNativeTextTracksFound",t["INIT_PTS_FOUND"]="hlsInitPtsFound",t["FRAG_LOADING"]="hlsFragLoading",t["FRAG_LOAD_EMERGENCY_ABORTED"]="hlsFragLoadEmergencyAborted",t["FRAG_LOADED"]="hlsFragLoaded",t["FRAG_DECRYPTED"]="hlsFragDecrypted",t["FRAG_PARSING_INIT_SEGMENT"]="hlsFragParsingInitSegment",t["FRAG_PARSING_USERDATA"]="hlsFragParsingUserdata",t["FRAG_PARSING_METADATA"]="hlsFragParsingMetadata",t["FRAG_PARSED"]="hlsFragParsed",t["FRAG_BUFFERED"]="hlsFragBuffered",t["FRAG_CHANGED"]="hlsFragChanged",t["FPS_DROP"]="hlsFpsDrop",t["FPS_DROP_LEVEL_CAPPING"]="hlsFpsDropLevelCapping",t["MAX_AUTO_LEVEL_UPDATED"]="hlsMaxAutoLevelUpdated",t["ERROR"]="hlsError",t["DESTROYING"]="hlsDestroying",t["KEY_LOADING"]="hlsKeyLoading",t["KEY_LOADED"]="hlsKeyLoaded",t["LIVE_BACK_BUFFER_REACHED"]="hlsLiveBackBufferReached",t["BACK_BUFFER_REACHED"]="hlsBackBufferReached",t["STEERING_MANIFEST_LOADED"]="hlsSteeringManifestLoaded",t}({}),Ji=function(t){return t["NETWORK_ERROR"]="networkError",t["MEDIA_ERROR"]="mediaError",t["KEY_SYSTEM_ERROR"]="keySystemError",t["MUX_ERROR"]="muxError",t["OTHER_ERROR"]="otherError",t}({}),ts=function(t){return t["KEY_SYSTEM_NO_KEYS"]="keySystemNoKeys",t["KEY_SYSTEM_NO_ACCESS"]="keySystemNoAccess",t["KEY_SYSTEM_NO_SESSION"]="keySystemNoSession",t["KEY_SYSTEM_NO_CONFIGURED_LICENSE"]="keySystemNoConfiguredLicense",t["KEY_SYSTEM_LICENSE_REQUEST_FAILED"]="keySystemLicenseRequestFailed",t["KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED"]="keySystemServerCertificateRequestFailed",t["KEY_SYSTEM_SERVER_CERTIFICATE_UPDATE_FAILED"]="keySystemServerCertificateUpdateFailed",t["KEY_SYSTEM_SESSION_UPDATE_FAILED"]="keySystemSessionUpdateFailed",t["KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED"]="keySystemStatusOutputRestricted",t["KEY_SYSTEM_STATUS_INTERNAL_ERROR"]="keySystemStatusInternalError",t["MANIFEST_LOAD_ERROR"]="manifestLoadError",t["MANIFEST_LOAD_TIMEOUT"]="manifestLoadTimeOut",t["MANIFEST_PARSING_ERROR"]="manifestParsingError",t["MANIFEST_INCOMPATIBLE_CODECS_ERROR"]="manifestIncompatibleCodecsError",t["LEVEL_EMPTY_ERROR"]="levelEmptyError",t["LEVEL_LOAD_ERROR"]="levelLoadError",t["LEVEL_LOAD_TIMEOUT"]="levelLoadTimeOut",t["LEVEL_PARSING_ERROR"]="levelParsingError",t["LEVEL_SWITCH_ERROR"]="levelSwitchError",t["AUDIO_TRACK_LOAD_ERROR"]="audioTrackLoadError",t["AUDIO_TRACK_LOAD_TIMEOUT"]="audioTrackLoadTimeOut",t["SUBTITLE_LOAD_ERROR"]="subtitleTrackLoadError",t["SUBTITLE_TRACK_LOAD_TIMEOUT"]="subtitleTrackLoadTimeOut",t["FRAG_LOAD_ERROR"]="fragLoadError",t["FRAG_LOAD_TIMEOUT"]="fragLoadTimeOut",t["FRAG_DECRYPT_ERROR"]="fragDecryptError",t["FRAG_PARSING_ERROR"]="fragParsingError",t["FRAG_GAP"]="fragGap",t["REMUX_ALLOC_ERROR"]="remuxAllocError",t["KEY_LOAD_ERROR"]="keyLoadError",t["KEY_LOAD_TIMEOUT"]="keyLoadTimeOut",t["BUFFER_ADD_CODEC_ERROR"]="bufferAddCodecError",t["BUFFER_INCOMPATIBLE_CODECS_ERROR"]="bufferIncompatibleCodecsError",t["BUFFER_APPEND_ERROR"]="bufferAppendError",t["BUFFER_APPENDING_ERROR"]="bufferAppendingError",t["BUFFER_STALLED_ERROR"]="bufferStalledError",t["BUFFER_FULL_ERROR"]="bufferFullError",t["BUFFER_SEEK_OVER_HOLE"]="bufferSeekOverHole",t["BUFFER_NUDGE_ON_STALL"]="bufferNudgeOnStall",t["INTERNAL_EXCEPTION"]="internalException",t["INTERNAL_ABORTED"]="aborted",t["UNKNOWN"]="unknown",t}({});const es=function(){},is={trace:es,debug:es,log:es,warn:es,info:es,error:es};let ss=is;function ns(t){const e=self.console[t];return e?e.bind(self.console,`[${t}] >`):es}function rs(t,...e){e.forEach((function(e){ss[e]=t[e]?t[e].bind(t):ns(e)}))}function os(t,e){if("object"===typeof console&&!0===t||"object"===typeof t){rs(t,"debug","log","info","warn","error");try{ss.log(`Debug logs enabled for "${e}" in hls.js version 1.5.18`)}catch(i){ss=is}}else ss=is}const as=ss,ls=/^(\d+)x(\d+)$/,cs=/(.+?)=(".*?"|.*?)(?:,|$)/g;class ds{constructor(t){"string"===typeof t&&(t=ds.parseAttrList(t)),Wi(this,t)}get clientAttrs(){return Object.keys(this).filter((t=>"X-"===t.substring(0,2)))}decimalInteger(t){const e=parseInt(this[t],10);return e>Number.MAX_SAFE_INTEGER?1/0:e}hexadecimalInteger(t){if(this[t]){let e=(this[t]||"0x").slice(2);e=(1&e.length?"0":"")+e;const i=new Uint8Array(e.length/2);for(let t=0;t<e.length/2;t++)i[t]=parseInt(e.slice(2*t,2*t+2),16);return i}return null}hexadecimalIntegerAsNumber(t){const e=parseInt(this[t],16);return e>Number.MAX_SAFE_INTEGER?1/0:e}decimalFloatingPoint(t){return parseFloat(this[t])}optionalFloat(t,e){const i=this[t];return i?parseFloat(i):e}enumeratedString(t){return this[t]}bool(t){return"YES"===this[t]}decimalResolution(t){const e=ls.exec(this[t]);if(null!==e)return{width:parseInt(e[1],10),height:parseInt(e[2],10)}}static parseAttrList(t){let e;const i={},s='"';cs.lastIndex=0;while(null!==(e=cs.exec(t))){let t=e[2];0===t.indexOf(s)&&t.lastIndexOf(s)===t.length-1&&(t=t.slice(1,-1));const n=e[1].trim();i[n]=t}return i}}function us(t){return"ID"!==t&&"CLASS"!==t&&"START-DATE"!==t&&"DURATION"!==t&&"END-DATE"!==t&&"END-ON-NEXT"!==t}function hs(t){return"SCTE35-OUT"===t||"SCTE35-IN"===t}class ps{constructor(t,e){if(this.attr=void 0,this._startDate=void 0,this._endDate=void 0,this._badValueForSameId=void 0,e){const i=e.attr;for(const e in i)if(Object.prototype.hasOwnProperty.call(t,e)&&t[e]!==i[e]){as.warn(`DATERANGE tag attribute: "${e}" does not match for tags with ID: "${t.ID}"`),this._badValueForSameId=e;break}t=Wi(new ds({}),i,t)}if(this.attr=t,this._startDate=new Date(t["START-DATE"]),"END-DATE"in this.attr){const t=new Date(this.attr["END-DATE"]);Yi(t.getTime())&&(this._endDate=t)}}get id(){return this.attr.ID}get class(){return this.attr.CLASS}get startDate(){return this._startDate}get endDate(){if(this._endDate)return this._endDate;const t=this.duration;return null!==t?new Date(this._startDate.getTime()+1e3*t):null}get duration(){if("DURATION"in this.attr){const t=this.attr.decimalFloatingPoint("DURATION");if(Yi(t))return t}else if(this._endDate)return(this._endDate.getTime()-this._startDate.getTime())/1e3;return null}get plannedDuration(){return"PLANNED-DURATION"in this.attr?this.attr.decimalFloatingPoint("PLANNED-DURATION"):null}get endOnNext(){return this.attr.bool("END-ON-NEXT")}get isValid(){return!!this.id&&!this._badValueForSameId&&Yi(this.startDate.getTime())&&(null===this.duration||this.duration>=0)&&(!this.endOnNext||!!this.class)}}class fs{constructor(){this.aborted=!1,this.loaded=0,this.retry=0,this.total=0,this.chunkCount=0,this.bwEstimate=0,this.loading={start:0,first:0,end:0},this.parsing={start:0,end:0},this.buffering={start:0,first:0,end:0}}}var ms={AUDIO:"audio",VIDEO:"video",AUDIOVIDEO:"audiovideo"};class vs{constructor(t){this._byteRange=null,this._url=null,this.baseurl=void 0,this.relurl=void 0,this.elementaryStreams={[ms.AUDIO]:null,[ms.VIDEO]:null,[ms.AUDIOVIDEO]:null},this.baseurl=t}setByteRange(t,e){const i=t.split("@",2);let s;s=1===i.length?(null==e?void 0:e.byteRangeEndOffset)||0:parseInt(i[1]),this._byteRange=[s,parseInt(i[0])+s]}get byteRange(){return this._byteRange?this._byteRange:[]}get byteRangeStartOffset(){return this.byteRange[0]}get byteRangeEndOffset(){return this.byteRange[1]}get url(){return!this._url&&this.baseurl&&this.relurl&&(this._url=qi.buildAbsoluteURL(this.baseurl,this.relurl,{alwaysNormalize:!0})),this._url||""}set url(t){this._url=t}}class gs extends vs{constructor(t,e){super(e),this._decryptdata=null,this.rawProgramDateTime=null,this.programDateTime=null,this.tagList=[],this.duration=0,this.sn=0,this.levelkeys=void 0,this.type=void 0,this.loader=null,this.keyLoader=null,this.level=-1,this.cc=0,this.startPTS=void 0,this.endPTS=void 0,this.startDTS=void 0,this.endDTS=void 0,this.start=0,this.deltaPTS=void 0,this.maxStartPTS=void 0,this.minEndPTS=void 0,this.stats=new fs,this.data=void 0,this.bitrateTest=!1,this.title=null,this.initSegment=null,this.endList=void 0,this.gap=void 0,this.urlId=0,this.type=t}get decryptdata(){const{levelkeys:t}=this;if(!t&&!this._decryptdata)return null;if(!this._decryptdata&&this.levelkeys&&!this.levelkeys.NONE){const t=this.levelkeys.identity;if(t)this._decryptdata=t.getDecryptData(this.sn);else{const t=Object.keys(this.levelkeys);if(1===t.length)return this._decryptdata=this.levelkeys[t[0]].getDecryptData(this.sn)}}return this._decryptdata}get end(){return this.start+this.duration}get endProgramDateTime(){if(null===this.programDateTime)return null;if(!Yi(this.programDateTime))return null;const t=Yi(this.duration)?this.duration:0;return this.programDateTime+1e3*t}get encrypted(){var t;if(null!=(t=this._decryptdata)&&t.encrypted)return!0;if(this.levelkeys){const t=Object.keys(this.levelkeys),e=t.length;if(e>1||1===e&&this.levelkeys[t[0]].encrypted)return!0}return!1}setKeyFormat(t){if(this.levelkeys){const e=this.levelkeys[t];e&&!this._decryptdata&&(this._decryptdata=e.getDecryptData(this.sn))}}abortRequests(){var t,e;null==(t=this.loader)||t.abort(),null==(e=this.keyLoader)||e.abort()}setElementaryStreamInfo(t,e,i,s,n,r=!1){const{elementaryStreams:o}=this,a=o[t];a?(a.startPTS=Math.min(a.startPTS,e),a.endPTS=Math.max(a.endPTS,i),a.startDTS=Math.min(a.startDTS,s),a.endDTS=Math.max(a.endDTS,n)):o[t]={startPTS:e,endPTS:i,startDTS:s,endDTS:n,partial:r}}clearElementaryStreamInfo(){const{elementaryStreams:t}=this;t[ms.AUDIO]=null,t[ms.VIDEO]=null,t[ms.AUDIOVIDEO]=null}}class ys extends vs{constructor(t,e,i,s,n){super(i),this.fragOffset=0,this.duration=0,this.gap=!1,this.independent=!1,this.relurl=void 0,this.fragment=void 0,this.index=void 0,this.stats=new fs,this.duration=t.decimalFloatingPoint("DURATION"),this.gap=t.bool("GAP"),this.independent=t.bool("INDEPENDENT"),this.relurl=t.enumeratedString("URI"),this.fragment=e,this.index=s;const r=t.enumeratedString("BYTERANGE");r&&this.setByteRange(r,n),n&&(this.fragOffset=n.fragOffset+n.duration)}get start(){return this.fragment.start+this.fragOffset}get end(){return this.start+this.duration}get loaded(){const{elementaryStreams:t}=this;return!!(t.audio||t.video||t.audiovideo)}}const bs=10;class ws{constructor(t){this.PTSKnown=!1,this.alignedSliding=!1,this.averagetargetduration=void 0,this.endCC=0,this.endSN=0,this.fragments=void 0,this.fragmentHint=void 0,this.partList=null,this.dateRanges=void 0,this.live=!0,this.ageHeader=0,this.advancedDateTime=void 0,this.updated=!0,this.advanced=!0,this.availabilityDelay=void 0,this.misses=0,this.startCC=0,this.startSN=0,this.startTimeOffset=null,this.targetduration=0,this.totalduration=0,this.type=null,this.url=void 0,this.m3u8="",this.version=null,this.canBlockReload=!1,this.canSkipUntil=0,this.canSkipDateRanges=!1,this.skippedSegments=0,this.recentlyRemovedDateranges=void 0,this.partHoldBack=0,this.holdBack=0,this.partTarget=0,this.preloadHint=void 0,this.renditionReports=void 0,this.tuneInGoal=0,this.deltaUpdateFailed=void 0,this.driftStartTime=0,this.driftEndTime=0,this.driftStart=0,this.driftEnd=0,this.encryptedFragments=void 0,this.playlistParsingError=null,this.variableList=null,this.hasVariableRefs=!1,this.fragments=[],this.encryptedFragments=[],this.dateRanges={},this.url=t}reloaded(t){if(!t)return this.advanced=!0,void(this.updated=!0);const e=this.lastPartSn-t.lastPartSn,i=this.lastPartIndex-t.lastPartIndex;this.updated=this.endSN!==t.endSN||!!i||!!e||!this.live,this.advanced=this.endSN>t.endSN||e>0||0===e&&i>0,this.updated||this.advanced?this.misses=Math.floor(.6*t.misses):this.misses=t.misses+1,this.availabilityDelay=t.availabilityDelay}get hasProgramDateTime(){return!!this.fragments.length&&Yi(this.fragments[this.fragments.length-1].programDateTime)}get levelTargetDuration(){return this.averagetargetduration||this.targetduration||bs}get drift(){const t=this.driftEndTime-this.driftStartTime;if(t>0){const e=this.driftEnd-this.driftStart;return 1e3*e/t}return 1}get edge(){return this.partEnd||this.fragmentEnd}get partEnd(){var t;return null!=(t=this.partList)&&t.length?this.partList[this.partList.length-1].end:this.fragmentEnd}get fragmentEnd(){var t;return null!=(t=this.fragments)&&t.length?this.fragments[this.fragments.length-1].end:0}get age(){return this.advancedDateTime?Math.max(Date.now()-this.advancedDateTime,0)/1e3:0}get lastPartIndex(){var t;return null!=(t=this.partList)&&t.length?this.partList[this.partList.length-1].index:-1}get lastPartSn(){var t;return null!=(t=this.partList)&&t.length?this.partList[this.partList.length-1].fragment.sn:this.endSN}}function Ss(t){return Uint8Array.from(atob(t),(t=>t.charCodeAt(0)))}function Es(t){const e=Cs(t).subarray(0,16),i=new Uint8Array(16);return i.set(e,16-e.length),i}function Ts(t){const e=function(t,e,i){const s=t[e];t[e]=t[i],t[i]=s};e(t,0,3),e(t,1,2),e(t,4,5),e(t,6,7)}function xs(t){const e=t.split(":");let i=null;if("data"===e[0]&&2===e.length){const t=e[1].split(";"),s=t[t.length-1].split(",");if(2===s.length){const e="base64"===s[0],n=s[1];e?(t.splice(-1,1),i=Ss(n)):i=Es(n)}}return i}function Cs(t){return Uint8Array.from(unescape(encodeURIComponent(t)),(t=>t.charCodeAt(0)))}const _s="undefined"!==typeof self?self:void 0;var ks={CLEARKEY:"org.w3.clearkey",FAIRPLAY:"com.apple.fps",PLAYREADY:"com.microsoft.playready",WIDEVINE:"com.widevine.alpha"},Ls={CLEARKEY:"org.w3.clearkey",FAIRPLAY:"com.apple.streamingkeydelivery",PLAYREADY:"com.microsoft.playready",WIDEVINE:"urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed"};function As(t){switch(t){case Ls.FAIRPLAY:return ks.FAIRPLAY;case Ls.PLAYREADY:return ks.PLAYREADY;case Ls.WIDEVINE:return ks.WIDEVINE;case Ls.CLEARKEY:return ks.CLEARKEY}}var Rs={CENC:"1077efecc0b24d02ace33c1e52e2fb4b",CLEARKEY:"e2719d58a985b3c9781ab030af78d30e",FAIRPLAY:"94ce86fb07ff4f43adb893d2fa968ca2",PLAYREADY:"9a04f07998404286ab92e65be0885f95",WIDEVINE:"edef8ba979d64acea3c827dcd51d21ed"};function Is(t){return t===Rs.WIDEVINE?ks.WIDEVINE:t===Rs.PLAYREADY?ks.PLAYREADY:t===Rs.CENC||t===Rs.CLEARKEY?ks.CLEARKEY:void 0}function Ds(t){switch(t){case ks.FAIRPLAY:return Ls.FAIRPLAY;case ks.PLAYREADY:return Ls.PLAYREADY;case ks.WIDEVINE:return Ls.WIDEVINE;case ks.CLEARKEY:return Ls.CLEARKEY}}function Ps(t){const{drmSystems:e,widevineLicenseUrl:i}=t,s=e?[ks.FAIRPLAY,ks.WIDEVINE,ks.PLAYREADY,ks.CLEARKEY].filter((t=>!!e[t])):[];return!s[ks.WIDEVINE]&&i&&s.push(ks.WIDEVINE),s}const Os=function(t){return null!=_s&&null!=(t=_s.navigator)&&t.requestMediaKeySystemAccess?self.navigator.requestMediaKeySystemAccess.bind(self.navigator):null}();function Ms(t,e,i,s){let n;switch(t){case ks.FAIRPLAY:n=["cenc","sinf"];break;case ks.WIDEVINE:case ks.PLAYREADY:n=["cenc"];break;case ks.CLEARKEY:n=["cenc","keyids"];break;default:throw new Error(`Unknown key-system: ${t}`)}return Ns(n,e,i,s)}function Ns(t,e,i,s){const n={initDataTypes:t,persistentState:s.persistentState||"optional",distinctiveIdentifier:s.distinctiveIdentifier||"optional",sessionTypes:s.sessionTypes||[s.sessionType||"temporary"],audioCapabilities:e.map((t=>({contentType:`audio/mp4; codecs="${t}"`,robustness:s.audioRobustness||"",encryptionScheme:s.audioEncryptionScheme||null}))),videoCapabilities:i.map((t=>({contentType:`video/mp4; codecs="${t}"`,robustness:s.videoRobustness||"",encryptionScheme:s.videoEncryptionScheme||null})))};return[n]}function Fs(t,e,i){return Uint8Array.prototype.slice?t.slice(e,i):new Uint8Array(Array.prototype.slice.call(t,e,i))}const Bs=(t,e)=>e+10<=t.length&&73===t[e]&&68===t[e+1]&&51===t[e+2]&&t[e+3]<255&&t[e+4]<255&&t[e+6]<128&&t[e+7]<128&&t[e+8]<128&&t[e+9]<128,$s=(t,e)=>e+10<=t.length&&51===t[e]&&68===t[e+1]&&73===t[e+2]&&t[e+3]<255&&t[e+4]<255&&t[e+6]<128&&t[e+7]<128&&t[e+8]<128&&t[e+9]<128,Us=(t,e)=>{const i=e;let s=0;while(Bs(t,e)){s+=10;const i=js(t,e+6);s+=i,$s(t,e+10)&&(s+=10),e+=s}if(s>0)return t.subarray(i,i+s)},js=(t,e)=>{let i=0;return i=(127&t[e])<<21,i|=(127&t[e+1])<<14,i|=(127&t[e+2])<<7,i|=127&t[e+3],i},qs=(t,e)=>Bs(t,e)&&js(t,e+6)+10<=t.length-e,Gs=t=>{const e=zs(t);for(let i=0;i<e.length;i++){const t=e[i];if(Vs(t))return Zs(t)}},Vs=t=>t&&"PRIV"===t.key&&"com.apple.streaming.transportStreamTimestamp"===t.info,Hs=t=>{const e=String.fromCharCode(t[0],t[1],t[2],t[3]),i=js(t,4),s=10;return{type:e,size:i,data:t.subarray(s,s+i)}},zs=t=>{let e=0;const i=[];while(Bs(t,e)){const s=js(t,e+6);e+=10;const n=e+s;while(e+8<n){const s=Hs(t.subarray(e)),n=Ks(s);n&&i.push(n),e+=s.size+10}$s(t,e)&&(e+=10)}return i},Ks=t=>"PRIV"===t.type?Ws(t):"W"===t.type[0]?Xs(t):Ys(t),Ws=t=>{if(t.size<2)return;const e=Qs(t.data,!0),i=new Uint8Array(t.data.subarray(e.length+1));return{key:t.type,info:e,data:i.buffer}},Ys=t=>{if(t.size<2)return;if("TXXX"===t.type){let e=1;const i=Qs(t.data.subarray(e),!0);e+=i.length+1;const s=Qs(t.data.subarray(e));return{key:t.type,info:i,data:s}}const e=Qs(t.data.subarray(1));return{key:t.type,data:e}},Xs=t=>{if("WXXX"===t.type){if(t.size<2)return;let e=1;const i=Qs(t.data.subarray(e),!0);e+=i.length+1;const s=Qs(t.data.subarray(e));return{key:t.type,info:i,data:s}}const e=Qs(t.data);return{key:t.type,data:e}},Zs=t=>{if(8===t.data.byteLength){const e=new Uint8Array(t.data),i=1&e[3];let s=(e[4]<<23)+(e[5]<<15)+(e[6]<<7)+e[7];return s/=45,i&&(s+=47721858.84),Math.round(s)}},Qs=(t,e=!1)=>{const i=tn();if(i){const s=i.decode(t);if(e){const t=s.indexOf("\0");return-1!==t?s.substring(0,t):s}return s.replace(/\0/g,"")}const s=t.length;let n,r,o,a="",l=0;while(l<s){if(n=t[l++],0===n&&e)return a;if(0!==n&&3!==n)switch(n>>4){case 0:case 1:case 2:case 3:case 4:case 5:case 6:case 7:a+=String.fromCharCode(n);break;case 12:case 13:r=t[l++],a+=String.fromCharCode((31&n)<<6|63&r);break;case 14:r=t[l++],o=t[l++],a+=String.fromCharCode((15&n)<<12|(63&r)<<6|(63&o)<<0);break}}return a};let Js;function tn(){if(!navigator.userAgent.includes("PlayStation 4"))return Js||"undefined"===typeof self.TextDecoder||(Js=new self.TextDecoder("utf-8")),Js}const en={hexDump:function(t){let e="";for(let i=0;i<t.length;i++){let s=t[i].toString(16);s.length<2&&(s="0"+s),e+=s}return e}},sn=Math.pow(2,32)-1,nn=[].push,rn={video:1,audio:2,id3:3,text:4};function on(t){return String.fromCharCode.apply(null,t)}function an(t,e){const i=t[e]<<8|t[e+1];return i<0?65536+i:i}function ln(t,e){const i=dn(t,e);return i<0?4294967296+i:i}function cn(t,e){let i=ln(t,e);return i*=Math.pow(2,32),i+=ln(t,e+4),i}function dn(t,e){return t[e]<<24|t[e+1]<<16|t[e+2]<<8|t[e+3]}function un(t,e,i){t[e]=i>>24,t[e+1]=i>>16&255,t[e+2]=i>>8&255,t[e+3]=255&i}function hn(t){const e=t.byteLength;for(let i=0;i<e;){const s=ln(t,i);if(s>8&&109===t[i+4]&&111===t[i+5]&&111===t[i+6]&&102===t[i+7])return!0;i=s>1?i+s:e}return!1}function pn(t,e){const i=[];if(!e.length)return i;const s=t.byteLength;for(let n=0;n<s;){const r=ln(t,n),o=on(t.subarray(n+4,n+8)),a=r>1?n+r:s;if(o===e[0])if(1===e.length)i.push(t.subarray(n+8,a));else{const s=pn(t.subarray(n+8,a),e.slice(1));s.length&&nn.apply(i,s)}n=a}return i}function fn(t){const e=[],i=t[0];let s=8;const n=ln(t,s);s+=4;let r=0,o=0;0===i?(r=ln(t,s),o=ln(t,s+4),s+=8):(r=cn(t,s),o=cn(t,s+8),s+=16),s+=2;let a=t.length+o;const l=an(t,s);s+=2;for(let c=0;c<l;c++){let i=s;const r=ln(t,i);i+=4;const o=2147483647&r,l=(2147483648&r)>>>31;if(1===l)return as.warn("SIDX has hierarchical references (not supported)"),null;const c=ln(t,i);i+=4,e.push({referenceSize:o,subsegmentDuration:c,info:{duration:c/n,start:a,end:a+o-1}}),a+=o,i+=4,s=i}return{earliestPresentationTime:r,timescale:n,version:i,referencesCount:l,references:e}}function mn(t){const e=[],i=pn(t,["moov","trak"]);for(let n=0;n<i.length;n++){const t=i[n],s=pn(t,["tkhd"])[0];if(s){let i=s[0];const n=ln(s,0===i?12:20),r=pn(t,["mdia","mdhd"])[0];if(r){i=r[0];const s=ln(r,0===i?12:20),o=pn(t,["mdia","hdlr"])[0];if(o){const i=on(o.subarray(8,12)),r={soun:ms.AUDIO,vide:ms.VIDEO}[i];if(r){const i=pn(t,["mdia","minf","stbl","stsd"])[0],o=vn(i);e[n]={timescale:s,type:r},e[r]=Vi({timescale:s,id:n},o)}}}}}const s=pn(t,["moov","mvex","trex"]);return s.forEach((t=>{const i=ln(t,4),s=e[i];s&&(s.default={duration:ln(t,12),flags:ln(t,20)})})),e}function vn(t){const e=t.subarray(8),i=e.subarray(86),s=on(e.subarray(4,8));let n=s;const r="enca"===s||"encv"===s;if(r){const t=pn(e,[s])[0],i=t.subarray("enca"===s?28:78),r=pn(i,["sinf"]);r.forEach((t=>{const e=pn(t,["schm"])[0];if(e){const i=on(e.subarray(4,8));if("cbcs"===i||"cenc"===i){const e=pn(t,["frma"])[0];e&&(n=on(e))}}}))}switch(n){case"avc1":case"avc2":case"avc3":case"avc4":{const t=pn(i,["avcC"])[0];n+="."+yn(t[1])+yn(t[2])+yn(t[3]);break}case"mp4a":{const t=pn(e,[s])[0],i=pn(t.subarray(28),["esds"])[0];if(i&&i.length>12){let t=4;if(3!==i[t++])break;t=gn(i,t),t+=2;const e=i[t++];if(128&e&&(t+=2),64&e&&(t+=i[t++]),4!==i[t++])break;t=gn(i,t);const s=i[t++];if(64!==s)break;if(n+="."+yn(s),t+=12,5!==i[t++])break;t=gn(i,t);const r=i[t++];let o=(248&r)>>3;31===o&&(o+=1+((7&r)<<3)+((224&i[t])>>5)),n+="."+o}break}case"hvc1":case"hev1":{const t=pn(i,["hvcC"])[0],e=t[1],s=["","A","B","C"][e>>6],r=31&e,o=ln(t,2),a=(32&e)>>5?"H":"L",l=t[12],c=t.subarray(6,12);n+="."+s+r,n+="."+o.toString(16).toUpperCase(),n+="."+a+l;let d="";for(let i=c.length;i--;){const t=c[i];if(t||d){const e=t.toString(16).toUpperCase();d="."+e+d}}n+=d;break}case"dvh1":case"dvhe":{const t=pn(i,["dvcC"])[0],e=t[2]>>1&127,s=t[2]<<5&32|t[3]>>3&31;n+="."+bn(e)+"."+bn(s);break}case"vp09":{const t=pn(i,["vpcC"])[0],e=t[4],s=t[5],r=t[6]>>4&15;n+="."+bn(e)+"."+bn(s)+"."+bn(r);break}case"av01":{const t=pn(i,["av1C"])[0],e=t[1]>>>5,s=31&t[1],r=t[2]>>>7?"H":"M",o=(64&t[2])>>6,a=(32&t[2])>>5,l=2===e&&o?a?12:10:o?10:8,c=(16&t[2])>>4,d=(8&t[2])>>3,u=(4&t[2])>>2,h=3&t[2],p=1,f=1,m=1,v=0;n+="."+e+"."+bn(s)+r+"."+bn(l)+"."+c+"."+d+u+h+"."+bn(p)+"."+bn(f)+"."+bn(m)+"."+v;break}}return{codec:n,encrypted:r}}function gn(t,e){const i=e+5;while(128&t[e++]&&e<i);return e}function yn(t){return("0"+t.toString(16).toUpperCase()).slice(-2)}function bn(t){return(t<10?"0":"")+t}function wn(t,e){if(!t||!e)return t;const i=e.keyId;if(i&&e.isCommonEncryption){const e=pn(t,["moov","trak"]);e.forEach((t=>{const e=pn(t,["mdia","minf","stbl","stsd"])[0],s=e.subarray(8);let n=pn(s,["enca"]);const r=n.length>0;r||(n=pn(s,["encv"])),n.forEach((t=>{const e=r?t.subarray(28):t.subarray(78),s=pn(e,["sinf"]);s.forEach((t=>{const e=Sn(t);if(e){const t=e.subarray(8,24);t.some((t=>0!==t))||(as.log(`[eme] Patching keyId in 'enc${r?"a":"v"}>sinf>>tenc' box: ${en.hexDump(t)} -> ${en.hexDump(i)}`),e.set(i,8))}}))}))}))}return t}function Sn(t){const e=pn(t,["schm"])[0];if(e){const i=on(e.subarray(4,8));if("cbcs"===i||"cenc"===i)return pn(t,["schi","tenc"])[0]}return null}function En(t,e){return pn(e,["moof","traf"]).reduce(((e,i)=>{const s=pn(i,["tfdt"])[0],n=s[0],r=pn(i,["tfhd"]).reduce(((e,i)=>{const r=ln(i,4),o=t[r];if(o){let t=ln(s,4);if(1===n){if(t===sn)return as.warn("[mp4-demuxer]: Ignoring assumed invalid signed 64-bit track fragment decode time"),e;t*=sn+1,t+=ln(s,8)}const i=o.timescale||9e4,r=t/i;if(Yi(r)&&(null===e||r<e))return r}return e}),null);return null!==r&&Yi(r)&&(null===e||r<e)?r:e}),null)}function Tn(t,e){let i=0,s=0,n=0;const r=pn(t,["moof","traf"]);for(let o=0;o<r.length;o++){const t=r[o],a=pn(t,["tfhd"])[0],l=ln(a,4),c=e[l];if(!c)continue;const d=c.default,u=ln(a,0)|(null==d?void 0:d.flags);let h=null==d?void 0:d.duration;8&u&&(h=ln(a,2&u?12:8));const p=c.timescale||9e4,f=pn(t,["trun"]);for(let e=0;e<f.length;e++){if(i=xn(f[e]),!i&&h){const t=ln(f[e],4);i=h*t}c.type===ms.VIDEO?s+=i/p:c.type===ms.AUDIO&&(n+=i/p)}}if(0===s&&0===n){let e=1/0,i=0,s=0;const n=pn(t,["sidx"]);for(let t=0;t<n.length;t++){const r=fn(n[t]);if(null!=r&&r.references){e=Math.min(e,r.earliestPresentationTime/r.timescale);const t=r.references.reduce(((t,e)=>t+e.info.duration||0),0);i=Math.max(i,t+r.earliestPresentationTime/r.timescale),s=i-e}}if(s&&Yi(s))return s}return s||n}function xn(t){const e=ln(t,0);let i=8;1&e&&(i+=4),4&e&&(i+=4);let s=0;const n=ln(t,4);for(let r=0;r<n;r++){if(256&e){const e=ln(t,i);s+=e,i+=4}512&e&&(i+=4),1024&e&&(i+=4),2048&e&&(i+=4)}return s}function Cn(t,e,i){pn(e,["moof","traf"]).forEach((e=>{pn(e,["tfhd"]).forEach((s=>{const n=ln(s,4),r=t[n];if(!r)return;const o=r.timescale||9e4;pn(e,["tfdt"]).forEach((t=>{const e=t[0],s=i*o;if(s){let i=ln(t,4);if(0===e)i-=s,i=Math.max(i,0),un(t,4,i);else{i*=Math.pow(2,32),i+=ln(t,8),i-=s,i=Math.max(i,0);const e=Math.floor(i/(sn+1)),n=Math.floor(i%(sn+1));un(t,4,e),un(t,8,n)}}}))}))}))}function _n(t){const e={valid:null,remainder:null},i=pn(t,["moof"]);if(i.length<2)return e.remainder=t,e;const s=i[i.length-1];return e.valid=Fs(t,0,s.byteOffset-8),e.remainder=Fs(t,s.byteOffset-8),e}function kn(t,e){const i=new Uint8Array(t.length+e.length);return i.set(t),i.set(e,t.length),i}function Ln(t,e){const i=[],s=e.samples,n=e.timescale,r=e.id;let o=!1;const a=pn(s,["moof"]);return a.map((a=>{const l=a.byteOffset-8,c=pn(a,["traf"]);c.map((a=>{const c=pn(a,["tfdt"]).map((t=>{const e=t[0];let i=ln(t,4);return 1===e&&(i*=Math.pow(2,32),i+=ln(t,8)),i/n}))[0];return void 0!==c&&(t=c),pn(a,["tfhd"]).map((c=>{const d=ln(c,4),u=16777215&ln(c,0),h=0!==(1&u),p=0!==(2&u),f=0!==(8&u);let m=0;const v=0!==(16&u);let g=0;const y=0!==(32&u);let b=8;d===r&&(h&&(b+=8),p&&(b+=4),f&&(m=ln(c,b),b+=4),v&&(g=ln(c,b),b+=4),y&&(b+=4),"video"===e.type&&(o=An(e.codec)),pn(a,["trun"]).map((r=>{const a=r[0],c=16777215&ln(r,0),d=0!==(1&c);let u=0;const h=0!==(4&c),p=0!==(256&c);let f=0;const v=0!==(512&c);let y=0;const b=0!==(1024&c),w=0!==(2048&c);let S=0;const E=ln(r,4);let T=8;d&&(u=ln(r,T),T+=4),h&&(T+=4);let x=u+l;for(let l=0;l<E;l++){if(p?(f=ln(r,T),T+=4):f=m,v?(y=ln(r,T),T+=4):y=g,b&&(T+=4),w&&(S=0===a?ln(r,T):dn(r,T),T+=4),e.type===ms.VIDEO){let e=0;while(e<y){const r=ln(s,x);if(x+=4,Rn(o,s[x])){const e=s.subarray(x,x+r);In(e,o?2:1,t+S/n,i)}x+=r,e+=r+4}}t+=f/n}})))}))}))})),i}function An(t){if(!t)return!1;const e=t.indexOf("."),i=e<0?t:t.substring(0,e);return"hvc1"===i||"hev1"===i||"dvh1"===i||"dvhe"===i}function Rn(t,e){if(t){const t=e>>1&63;return 39===t||40===t}{const t=31&e;return 6===t}}function In(t,e,i,s){const n=Dn(t);let r=0;r+=e;let o=0,a=0,l=0;while(r<n.length){o=0;do{if(r>=n.length)break;l=n[r++],o+=l}while(255===l);a=0;do{if(r>=n.length)break;l=n[r++],a+=l}while(255===l);const t=n.length-r;let e=r;if(a<t)r+=a;else if(a>t){as.error(`Malformed SEI payload. ${a} is too small, only ${t} bytes left to parse.`);break}if(4===o){const t=n[e++];if(181===t){const t=an(n,e);if(e+=2,49===t){const t=ln(n,e);if(e+=4,1195456820===t){const t=n[e++];if(3===t){const r=n[e++],a=31&r,l=64&r,c=l?2+3*a:0,d=new Uint8Array(c);if(l){d[0]=r;for(let t=1;t<c;t++)d[t]=n[e++]}s.push({type:t,payloadType:o,pts:i,bytes:d})}}}}}else if(5===o&&a>16){const t=[];for(let i=0;i<16;i++){const s=n[e++].toString(16);t.push(1==s.length?"0"+s:s),3!==i&&5!==i&&7!==i&&9!==i||t.push("-")}const r=a-16,l=new Uint8Array(r);for(let i=0;i<r;i++)l[i]=n[e++];s.push({payloadType:o,pts:i,uuid:t.join(""),userData:Qs(l),userDataBytes:l})}}}function Dn(t){const e=t.byteLength,i=[];let s=1;while(s<e-2)0===t[s]&&0===t[s+1]&&3===t[s+2]?(i.push(s+2),s+=2):s++;if(0===i.length)return t;const n=e-i.length,r=new Uint8Array(n);let o=0;for(s=0;s<n;o++,s++)o===i[0]&&(o++,i.shift()),r[s]=t[o];return r}function Pn(t){const e=t[0];let i="",s="",n=0,r=0,o=0,a=0,l=0,c=0;if(0===e){while("\0"!==on(t.subarray(c,c+1)))i+=on(t.subarray(c,c+1)),c+=1;i+=on(t.subarray(c,c+1)),c+=1;while("\0"!==on(t.subarray(c,c+1)))s+=on(t.subarray(c,c+1)),c+=1;s+=on(t.subarray(c,c+1)),c+=1,n=ln(t,12),r=ln(t,16),a=ln(t,20),l=ln(t,24),c=28}else if(1===e){c+=4,n=ln(t,c),c+=4;const e=ln(t,c);c+=4;const r=ln(t,c);c+=4,o=2**32*e+r,Xi(o)||(o=Number.MAX_SAFE_INTEGER,as.warn("Presentation time exceeds safe integer limit and wrapped to max safe integer in parsing emsg box")),a=ln(t,c),c+=4,l=ln(t,c),c+=4;while("\0"!==on(t.subarray(c,c+1)))i+=on(t.subarray(c,c+1)),c+=1;i+=on(t.subarray(c,c+1)),c+=1;while("\0"!==on(t.subarray(c,c+1)))s+=on(t.subarray(c,c+1)),c+=1;s+=on(t.subarray(c,c+1)),c+=1}const d=t.subarray(c,t.byteLength);return{schemeIdUri:i,value:s,timeScale:n,presentationTime:o,presentationTimeDelta:r,eventDuration:a,id:l,payload:d}}function On(t,...e){const i=e.length;let s=8,n=i;while(n--)s+=e[n].byteLength;const r=new Uint8Array(s);for(r[0]=s>>24&255,r[1]=s>>16&255,r[2]=s>>8&255,r[3]=255&s,r.set(t,4),n=0,s=8;n<i;n++)r.set(e[n],s),s+=e[n].byteLength;return r}function Mn(t,e,i){if(16!==t.byteLength)throw new RangeError("Invalid system id");let s,n,r;if(e){s=1,n=new Uint8Array(16*e.length);for(let t=0;t<e.length;t++){const i=e[t];if(16!==i.byteLength)throw new RangeError("Invalid key");n.set(i,16*t)}}else s=0,n=new Uint8Array;s>0?(r=new Uint8Array(4),e.length>0&&new DataView(r.buffer).setUint32(0,e.length,!1)):r=new Uint8Array;const o=new Uint8Array(4);return i&&i.byteLength>0&&new DataView(o.buffer).setUint32(0,i.byteLength,!1),On([112,115,115,104],new Uint8Array([s,0,0,0]),t,r,n,o,i||new Uint8Array)}function Nn(t){const e=[];if(t instanceof ArrayBuffer){const i=t.byteLength;let s=0;while(s+32<i){const i=new DataView(t,s),n=Fn(i);e.push(n),s+=n.size}}return e}function Fn(t){const e=t.getUint32(0),i=t.byteOffset,s=t.byteLength;if(s<e)return{offset:i,size:s};const n=t.getUint32(4);if(1886614376!==n)return{offset:i,size:e};const r=t.getUint32(8)>>>24;if(0!==r&&1!==r)return{offset:i,size:e};const o=t.buffer,a=en.hexDump(new Uint8Array(o,i+12,16)),l=t.getUint32(28);let c=null,d=null;if(0===r){if(e-32<l||l<22)return{offset:i,size:e};d=new Uint8Array(o,i+32,l)}else if(1===r){if(!l||s<i+32+16*l+16)return{offset:i,size:e};c=[];for(let t=0;t<l;t++)c.push(new Uint8Array(o,i+32+16*t,16))}return{version:r,systemId:a,kids:c,data:d,offset:i,size:e}}let Bn={};class $n{static clearKeyUriToKeyIdMap(){Bn={}}constructor(t,e,i,s=[1],n=null){this.uri=void 0,this.method=void 0,this.keyFormat=void 0,this.keyFormatVersions=void 0,this.encrypted=void 0,this.isCommonEncryption=void 0,this.iv=null,this.key=null,this.keyId=null,this.pssh=null,this.method=t,this.uri=e,this.keyFormat=i,this.keyFormatVersions=s,this.iv=n,this.encrypted=!!t&&"NONE"!==t,this.isCommonEncryption=this.encrypted&&"AES-128"!==t}isSupported(){if(this.method){if("AES-128"===this.method||"NONE"===this.method)return!0;if("identity"===this.keyFormat)return"SAMPLE-AES"===this.method;switch(this.keyFormat){case Ls.FAIRPLAY:case Ls.WIDEVINE:case Ls.PLAYREADY:case Ls.CLEARKEY:return-1!==["ISO-23001-7","SAMPLE-AES","SAMPLE-AES-CENC","SAMPLE-AES-CTR"].indexOf(this.method)}}return!1}getDecryptData(t){if(!this.encrypted||!this.uri)return null;if("AES-128"===this.method&&this.uri&&!this.iv){"number"!==typeof t&&("AES-128"!==this.method||this.iv||as.warn(`missing IV for initialization segment with method="${this.method}" - compliance issue`),t=0);const e=Un(t),i=new $n(this.method,this.uri,"identity",this.keyFormatVersions,e);return i}const e=xs(this.uri);if(e)switch(this.keyFormat){case Ls.WIDEVINE:this.pssh=e,e.length>=22&&(this.keyId=e.subarray(e.length-22,e.length-6));break;case Ls.PLAYREADY:{const t=new Uint8Array([154,4,240,121,152,64,66,134,171,146,230,91,224,136,95,149]);this.pssh=Mn(t,null,e);const i=new Uint16Array(e.buffer,e.byteOffset,e.byteLength/2),s=String.fromCharCode.apply(null,Array.from(i)),n=s.substring(s.indexOf("<"),s.length),r=new DOMParser,o=r.parseFromString(n,"text/xml"),a=o.getElementsByTagName("KID")[0];if(a){const t=a.childNodes[0]?a.childNodes[0].nodeValue:a.getAttribute("VALUE");if(t){const e=Ss(t).subarray(0,16);Ts(e),this.keyId=e}}break}default:{let t=e.subarray(0,16);if(16!==t.length){const e=new Uint8Array(16);e.set(t,16-t.length),t=e}this.keyId=t;break}}if(!this.keyId||16!==this.keyId.byteLength){let t=Bn[this.uri];if(!t){const e=Object.keys(Bn).length%Number.MAX_SAFE_INTEGER;t=new Uint8Array(16);const i=new DataView(t.buffer,12,4);i.setUint32(0,e),Bn[this.uri]=t}this.keyId=t}return this}}function Un(t){const e=new Uint8Array(16);for(let i=12;i<16;i++)e[i]=t>>8*(15-i)&255;return e}const jn=/\{\$([a-zA-Z0-9-_]+)\}/g;function qn(t){return jn.test(t)}function Gn(t,e,i){if(null!==t.variableList||t.hasVariableRefs)for(let s=i.length;s--;){const n=i[s],r=e[n];r&&(e[n]=Vn(t,r))}}function Vn(t,e){if(null!==t.variableList||t.hasVariableRefs){const i=t.variableList;return e.replace(jn,(e=>{const s=e.substring(2,e.length-1),n=null==i?void 0:i[s];return void 0===n?(t.playlistParsingError||(t.playlistParsingError=new Error(`Missing preceding EXT-X-DEFINE tag for Variable Reference: "${s}"`)),e):n}))}return e}function Hn(t,e,i){let s,n,r=t.variableList;if(r||(t.variableList=r={}),"QUERYPARAM"in e){s=e.QUERYPARAM;try{const t=new self.URL(i).searchParams;if(!t.has(s))throw new Error(`"${s}" does not match any query parameter in URI: "${i}"`);n=t.get(s)}catch(o){t.playlistParsingError||(t.playlistParsingError=new Error(`EXT-X-DEFINE QUERYPARAM: ${o.message}`))}}else s=e.NAME,n=e.VALUE;s in r?t.playlistParsingError||(t.playlistParsingError=new Error(`EXT-X-DEFINE duplicate Variable Name declarations: "${s}"`)):r[s]=n||""}function zn(t,e,i){const s=e.IMPORT;if(i&&s in i){let e=t.variableList;e||(t.variableList=e={}),e[s]=i[s]}else t.playlistParsingError||(t.playlistParsingError=new Error(`EXT-X-DEFINE IMPORT attribute not found in Multivariant Playlist: "${s}"`))}function Kn(t=!0){if("undefined"===typeof self)return;const e=(t||!self.MediaSource)&&self.ManagedMediaSource;return e||self.MediaSource||self.WebKitMediaSource}function Wn(t){return"undefined"!==typeof self&&t===self.ManagedMediaSource}const Yn={audio:{a3ds:1,"ac-3":.95,"ac-4":1,alac:.9,alaw:1,dra1:1,"dts+":1,"dts-":1,dtsc:1,dtse:1,dtsh:1,"ec-3":.9,enca:1,fLaC:.9,flac:.9,FLAC:.9,g719:1,g726:1,m4ae:1,mha1:1,mha2:1,mhm1:1,mhm2:1,mlpa:1,mp4a:1,"raw ":1,Opus:1,opus:1,samr:1,sawb:1,sawp:1,sevc:1,sqcp:1,ssmv:1,twos:1,ulaw:1},video:{avc1:1,avc2:1,avc3:1,avc4:1,avcp:1,av01:.8,drac:1,dva1:1,dvav:1,dvh1:.7,dvhe:.7,encv:1,hev1:.75,hvc1:.75,mjp2:1,mp4v:1,mvc1:1,mvc2:1,mvc3:1,mvc4:1,resv:1,rv60:1,s263:1,svc1:1,svc2:1,"vc-1":1,vp08:1,vp09:.9},text:{stpp:1,wvtt:1}};function Xn(t,e){const i=Yn[e];return!!i&&!!i[t.slice(0,4)]}function Zn(t,e,i=!0){return!t.split(",").some((t=>!Qn(t,e,i)))}function Qn(t,e,i=!0){var s;const n=Kn(i);return null!=(s=null==n?void 0:n.isTypeSupported(Jn(t,e)))&&s}function Jn(t,e){return`${e}/mp4;codecs="${t}"`}function tr(t){if(t){const e=t.substring(0,4);return Yn.video[e]}return 2}function er(t){return t.split(",").reduce(((t,e)=>{const i=Yn.video[e];return i?(2*i+t)/(t?3:2):(Yn.audio[e]+t)/(t?2:1)}),0)}const ir={};function sr(t,e=!0){if(ir[t])return ir[t];const i={flac:["flac","fLaC","FLAC"],opus:["opus","Opus"]}[t];for(let s=0;s<i.length;s++)if(Qn(i[s],"audio",e))return ir[t]=i[s],i[s];return t}const nr=/flac|opus/i;function rr(t,e=!0){return t.replace(nr,(t=>sr(t.toLowerCase(),e)))}function or(t,e){return t&&"mp4a"!==t?t:e?e.split(",")[0]:e}function ar(t){const e=t.split(",");for(let i=0;i<e.length;i++){const t=e[i].split(".");if(t.length>2){let s=t.shift()+".";s+=parseInt(t.shift()).toString(16),s+=("000"+parseInt(t.shift()).toString(16)).slice(-4),e[i]=s}}return e.join(",")}const lr=/#EXT-X-STREAM-INF:([^\r\n]*)(?:[\r\n](?:#[^\r\n]*)?)*([^\r\n]+)|#EXT-X-(SESSION-DATA|SESSION-KEY|DEFINE|CONTENT-STEERING|START):([^\r\n]*)[\r\n]+/g,cr=/#EXT-X-MEDIA:(.*)/g,dr=/^#EXT(?:INF|-X-TARGETDURATION):/m,ur=new RegExp([/#EXTINF:\s*(\d*(?:\.\d+)?)(?:,(.*)\s+)?/.source,/(?!#) *(\S[^\r\n]*)/.source,/#EXT-X-BYTERANGE:*(.+)/.source,/#EXT-X-PROGRAM-DATE-TIME:(.+)/.source,/#.*/.source].join("|"),"g"),hr=new RegExp([/#(EXTM3U)/.source,/#EXT-X-(DATERANGE|DEFINE|KEY|MAP|PART|PART-INF|PLAYLIST-TYPE|PRELOAD-HINT|RENDITION-REPORT|SERVER-CONTROL|SKIP|START):(.+)/.source,/#EXT-X-(BITRATE|DISCONTINUITY-SEQUENCE|MEDIA-SEQUENCE|TARGETDURATION|VERSION): *(\d+)/.source,/#EXT-X-(DISCONTINUITY|ENDLIST|GAP|INDEPENDENT-SEGMENTS)/.source,/(#)([^:]*):(.*)/.source,/(#)(.*)(?:.*)\r?\n?/.source].join("|"));class pr{static findGroup(t,e){for(let i=0;i<t.length;i++){const s=t[i];if(s.id===e)return s}}static resolve(t,e){return qi.buildAbsoluteURL(e,t,{alwaysNormalize:!0})}static isMediaPlaylist(t){return dr.test(t)}static parseMasterPlaylist(t,e){const i=qn(t),s={contentSteering:null,levels:[],playlistParsingError:null,sessionData:null,sessionKeys:null,startTimeOffset:null,variableList:null,hasVariableRefs:i},n=[];let r;lr.lastIndex=0;while(null!=(r=lr.exec(t)))if(r[1]){var o;const t=new ds(r[1]);Gn(s,t,["CODECS","SUPPLEMENTAL-CODECS","ALLOWED-CPC","PATHWAY-ID","STABLE-VARIANT-ID","AUDIO","VIDEO","SUBTITLES","CLOSED-CAPTIONS","NAME"]);const i=Vn(s,r[2]),a={attrs:t,bitrate:t.decimalInteger("BANDWIDTH")||t.decimalInteger("AVERAGE-BANDWIDTH"),name:t.NAME,url:pr.resolve(i,e)},l=t.decimalResolution("RESOLUTION");l&&(a.width=l.width,a.height=l.height),vr(t.CODECS,a),null!=(o=a.unknownCodecs)&&o.length||n.push(a),s.levels.push(a)}else if(r[3]){const t=r[3],i=r[4];switch(t){case"SESSION-DATA":{const t=new ds(i);Gn(s,t,["DATA-ID","LANGUAGE","VALUE","URI"]);const e=t["DATA-ID"];e&&(null===s.sessionData&&(s.sessionData={}),s.sessionData[e]=t);break}case"SESSION-KEY":{const t=fr(i,e,s);t.encrypted&&t.isSupported()?(null===s.sessionKeys&&(s.sessionKeys=[]),s.sessionKeys.push(t)):as.warn(`[Keys] Ignoring invalid EXT-X-SESSION-KEY tag: "${i}"`);break}case"DEFINE":{const t=new ds(i);Gn(s,t,["NAME","VALUE","QUERYPARAM"]),Hn(s,t,e)}break;case"CONTENT-STEERING":{const t=new ds(i);Gn(s,t,["SERVER-URI","PATHWAY-ID"]),s.contentSteering={uri:pr.resolve(t["SERVER-URI"],e),pathwayId:t["PATHWAY-ID"]||"."};break}case"START":s.startTimeOffset=mr(i);break}}const a=n.length>0&&n.length<s.levels.length;return s.levels=a?n:s.levels,0===s.levels.length&&(s.playlistParsingError=new Error("no levels found in manifest")),s}static parseMasterPlaylistMedia(t,e,i){let s;const n={},r=i.levels,o={AUDIO:r.map((t=>({id:t.attrs.AUDIO,audioCodec:t.audioCodec}))),SUBTITLES:r.map((t=>({id:t.attrs.SUBTITLES,textCodec:t.textCodec}))),"CLOSED-CAPTIONS":[]};let a=0;cr.lastIndex=0;while(null!==(s=cr.exec(t))){const t=new ds(s[1]),r=t.TYPE;if(r){const s=o[r],l=n[r]||[];n[r]=l,Gn(i,t,["URI","GROUP-ID","LANGUAGE","ASSOC-LANGUAGE","STABLE-RENDITION-ID","NAME","INSTREAM-ID","CHARACTERISTICS","CHANNELS"]);const c=t.LANGUAGE,d=t["ASSOC-LANGUAGE"],u=t.CHANNELS,h=t.CHARACTERISTICS,p=t["INSTREAM-ID"],f={attrs:t,bitrate:0,id:a++,groupId:t["GROUP-ID"]||"",name:t.NAME||c||"",type:r,default:t.bool("DEFAULT"),autoselect:t.bool("AUTOSELECT"),forced:t.bool("FORCED"),lang:c,url:t.URI?pr.resolve(t.URI,e):""};if(d&&(f.assocLang=d),u&&(f.channels=u),h&&(f.characteristics=h),p&&(f.instreamId=p),null!=s&&s.length){const t=pr.findGroup(s,f.groupId)||s[0];gr(f,t,"audioCodec"),gr(f,t,"textCodec")}l.push(f)}}return n}static parseLevelPlaylist(t,e,i,s,n,r){const o=new ws(e),a=o.fragments;let l,c,d,u=null,h=0,p=0,f=0,m=0,v=null,g=new gs(s,e),y=-1,b=!1,w=null;ur.lastIndex=0,o.m3u8=t,o.hasVariableRefs=qn(t);while(null!==(l=ur.exec(t))){b&&(b=!1,g=new gs(s,e),g.start=f,g.sn=h,g.cc=m,g.level=i,u&&(g.initSegment=u,g.rawProgramDateTime=u.rawProgramDateTime,u.rawProgramDateTime=null,w&&(g.setByteRange(w),w=null)));const t=l[1];if(t){g.duration=parseFloat(t);const e=(" "+l[2]).slice(1);g.title=e||null,g.tagList.push(e?["INF",t,e]:["INF",t])}else if(l[3]){if(Yi(g.duration)){g.start=f,d&&Sr(g,d,o),g.sn=h,g.level=i,g.cc=m,a.push(g);const t=(" "+l[3]).slice(1);g.relurl=Vn(o,t),br(g,v),v=g,f+=g.duration,h++,p=0,b=!0}}else if(l[4]){const t=(" "+l[4]).slice(1);v?g.setByteRange(t,v):g.setByteRange(t)}else if(l[5])g.rawProgramDateTime=(" "+l[5]).slice(1),g.tagList.push(["PROGRAM-DATE-TIME",g.rawProgramDateTime]),-1===y&&(y=a.length);else{if(l=l[0].match(hr),!l){as.warn("No matches on slow regex match for level playlist!");continue}for(c=1;c<l.length;c++)if("undefined"!==typeof l[c])break;const t=(" "+l[c]).slice(1),n=(" "+l[c+1]).slice(1),f=l[c+2]?(" "+l[c+2]).slice(1):"";switch(t){case"PLAYLIST-TYPE":o.type=n.toUpperCase();break;case"MEDIA-SEQUENCE":h=o.startSN=parseInt(n);break;case"SKIP":{const t=new ds(n);Gn(o,t,["RECENTLY-REMOVED-DATERANGES"]);const e=t.decimalInteger("SKIPPED-SEGMENTS");if(Yi(e)){o.skippedSegments=e;for(let t=e;t--;)a.unshift(null);h+=e}const i=t.enumeratedString("RECENTLY-REMOVED-DATERANGES");i&&(o.recentlyRemovedDateranges=i.split("\t"));break}case"TARGETDURATION":o.targetduration=Math.max(parseInt(n),1);break;case"VERSION":o.version=parseInt(n);break;case"INDEPENDENT-SEGMENTS":case"EXTM3U":break;case"ENDLIST":o.live=!1;break;case"#":(n||f)&&g.tagList.push(f?[n,f]:[n]);break;case"DISCONTINUITY":m++,g.tagList.push(["DIS"]);break;case"GAP":g.gap=!0,g.tagList.push([t]);break;case"BITRATE":g.tagList.push([t,n]);break;case"DATERANGE":{const t=new ds(n);Gn(o,t,["ID","CLASS","START-DATE","END-DATE","SCTE35-CMD","SCTE35-OUT","SCTE35-IN"]),Gn(o,t,t.clientAttrs);const e=new ps(t,o.dateRanges[t.ID]);e.isValid||o.skippedSegments?o.dateRanges[e.id]=e:as.warn(`Ignoring invalid DATERANGE tag: "${n}"`),g.tagList.push(["EXT-X-DATERANGE",n]);break}case"DEFINE":{const t=new ds(n);Gn(o,t,["NAME","VALUE","IMPORT","QUERYPARAM"]),"IMPORT"in t?zn(o,t,r):Hn(o,t,e)}break;case"DISCONTINUITY-SEQUENCE":m=parseInt(n);break;case"KEY":{const t=fr(n,e,o);if(t.isSupported()){if("NONE"===t.method){d=void 0;break}d||(d={}),d[t.keyFormat]&&(d=Wi({},d)),d[t.keyFormat]=t}else as.warn(`[Keys] Ignoring invalid EXT-X-KEY tag: "${n}"`);break}case"START":o.startTimeOffset=mr(n);break;case"MAP":{const t=new ds(n);if(Gn(o,t,["BYTERANGE","URI"]),g.duration){const n=new gs(s,e);wr(n,t,i,d),u=n,g.initSegment=u,u.rawProgramDateTime&&!g.rawProgramDateTime&&(g.rawProgramDateTime=u.rawProgramDateTime)}else{const e=g.byteRangeEndOffset;if(e){const t=g.byteRangeStartOffset;w=`${e-t}@${t}`}else w=null;wr(g,t,i,d),u=g,b=!0}break}case"SERVER-CONTROL":{const t=new ds(n);o.canBlockReload=t.bool("CAN-BLOCK-RELOAD"),o.canSkipUntil=t.optionalFloat("CAN-SKIP-UNTIL",0),o.canSkipDateRanges=o.canSkipUntil>0&&t.bool("CAN-SKIP-DATERANGES"),o.partHoldBack=t.optionalFloat("PART-HOLD-BACK",0),o.holdBack=t.optionalFloat("HOLD-BACK",0);break}case"PART-INF":{const t=new ds(n);o.partTarget=t.decimalFloatingPoint("PART-TARGET");break}case"PART":{let t=o.partList;t||(t=o.partList=[]);const i=p>0?t[t.length-1]:void 0,s=p++,r=new ds(n);Gn(o,r,["BYTERANGE","URI"]);const a=new ys(r,g,e,s,i);t.push(a),g.duration+=a.duration;break}case"PRELOAD-HINT":{const t=new ds(n);Gn(o,t,["URI"]),o.preloadHint=t;break}case"RENDITION-REPORT":{const t=new ds(n);Gn(o,t,["URI"]),o.renditionReports=o.renditionReports||[],o.renditionReports.push(t);break}default:as.warn(`line parsed but not handled: ${l}`);break}}}v&&!v.relurl?(a.pop(),f-=v.duration,o.partList&&(o.fragmentHint=v)):o.partList&&(br(g,v),g.cc=m,o.fragmentHint=g,d&&Sr(g,d,o));const S=a.length,E=a[0],T=a[S-1];if(f+=o.skippedSegments*o.targetduration,f>0&&S&&T){o.averagetargetduration=f/S;const t=T.sn;o.endSN="initSegment"!==t?t:0,o.live||(T.endList=!0),E&&(o.startCC=E.cc)}else o.endSN=0,o.startCC=0;return o.fragmentHint&&(f+=o.fragmentHint.duration),o.totalduration=f,o.endCC=m,y>0&&yr(a,y),o}}function fr(t,e,i){var s,n;const r=new ds(t);Gn(i,r,["KEYFORMAT","KEYFORMATVERSIONS","URI","IV","URI"]);const o=null!=(s=r.METHOD)?s:"",a=r.URI,l=r.hexadecimalInteger("IV"),c=r.KEYFORMATVERSIONS,d=null!=(n=r.KEYFORMAT)?n:"identity";a&&r.IV&&!l&&as.error(`Invalid IV: ${r.IV}`);const u=a?pr.resolve(a,e):"",h=(c||"1").split("/").map(Number).filter(Number.isFinite);return new $n(o,u,d,h,l)}function mr(t){const e=new ds(t),i=e.decimalFloatingPoint("TIME-OFFSET");return Yi(i)?i:null}function vr(t,e){let i=(t||"").split(/[ ,]+/).filter((t=>t));["video","audio","text"].forEach((t=>{const s=i.filter((e=>Xn(e,t)));s.length&&(e[`${t}Codec`]=s.join(","),i=i.filter((t=>-1===s.indexOf(t))))})),e.unknownCodecs=i}function gr(t,e,i){const s=e[i];s&&(t[i]=s)}function yr(t,e){let i=t[e];for(let s=e;s--;){const e=t[s];if(!e)return;e.programDateTime=i.programDateTime-1e3*e.duration,i=e}}function br(t,e){t.rawProgramDateTime?t.programDateTime=Date.parse(t.rawProgramDateTime):null!=e&&e.programDateTime&&(t.programDateTime=e.endProgramDateTime),Yi(t.programDateTime)||(t.programDateTime=null,t.rawProgramDateTime=null)}function wr(t,e,i,s){t.relurl=e.URI,e.BYTERANGE&&t.setByteRange(e.BYTERANGE),t.level=i,t.sn="initSegment",s&&(t.levelkeys=s),t.initSegment=null}function Sr(t,e,i){t.levelkeys=e;const{encryptedFragments:s}=i;s.length&&s[s.length-1].levelkeys===e||!Object.keys(e).some((t=>e[t].isCommonEncryption))||s.push(t)}var Er={MANIFEST:"manifest",LEVEL:"level",AUDIO_TRACK:"audioTrack",SUBTITLE_TRACK:"subtitleTrack"},Tr={MAIN:"main",AUDIO:"audio",SUBTITLE:"subtitle"};function xr(t){const{type:e}=t;switch(e){case Er.AUDIO_TRACK:return Tr.AUDIO;case Er.SUBTITLE_TRACK:return Tr.SUBTITLE;default:return Tr.MAIN}}function Cr(t,e){let i=t.url;return void 0!==i&&0!==i.indexOf("data:")||(i=e.url),i}class _r{constructor(t){this.hls=void 0,this.loaders=Object.create(null),this.variableList=null,this.hls=t,this.registerListeners()}startLoad(t){}stopLoad(){this.destroyInternalLoaders()}registerListeners(){const{hls:t}=this;t.on(Qi.MANIFEST_LOADING,this.onManifestLoading,this),t.on(Qi.LEVEL_LOADING,this.onLevelLoading,this),t.on(Qi.AUDIO_TRACK_LOADING,this.onAudioTrackLoading,this),t.on(Qi.SUBTITLE_TRACK_LOADING,this.onSubtitleTrackLoading,this)}unregisterListeners(){const{hls:t}=this;t.off(Qi.MANIFEST_LOADING,this.onManifestLoading,this),t.off(Qi.LEVEL_LOADING,this.onLevelLoading,this),t.off(Qi.AUDIO_TRACK_LOADING,this.onAudioTrackLoading,this),t.off(Qi.SUBTITLE_TRACK_LOADING,this.onSubtitleTrackLoading,this)}createInternalLoader(t){const e=this.hls.config,i=e.pLoader,s=e.loader,n=i||s,r=new n(e);return this.loaders[t.type]=r,r}getInternalLoader(t){return this.loaders[t.type]}resetInternalLoader(t){this.loaders[t]&&delete this.loaders[t]}destroyInternalLoaders(){for(const t in this.loaders){const e=this.loaders[t];e&&e.destroy(),this.resetInternalLoader(t)}}destroy(){this.variableList=null,this.unregisterListeners(),this.destroyInternalLoaders()}onManifestLoading(t,e){const{url:i}=e;this.variableList=null,this.load({id:null,level:0,responseType:"text",type:Er.MANIFEST,url:i,deliveryDirectives:null})}onLevelLoading(t,e){const{id:i,level:s,pathwayId:n,url:r,deliveryDirectives:o}=e;this.load({id:i,level:s,pathwayId:n,responseType:"text",type:Er.LEVEL,url:r,deliveryDirectives:o})}onAudioTrackLoading(t,e){const{id:i,groupId:s,url:n,deliveryDirectives:r}=e;this.load({id:i,groupId:s,level:null,responseType:"text",type:Er.AUDIO_TRACK,url:n,deliveryDirectives:r})}onSubtitleTrackLoading(t,e){const{id:i,groupId:s,url:n,deliveryDirectives:r}=e;this.load({id:i,groupId:s,level:null,responseType:"text",type:Er.SUBTITLE_TRACK,url:n,deliveryDirectives:r})}load(t){var e;const i=this.hls.config;let s,n=this.getInternalLoader(t);if(n){const e=n.context;if(e&&e.url===t.url&&e.level===t.level)return void as.trace("[playlist-loader]: playlist request ongoing");as.log(`[playlist-loader]: aborting previous loader for type: ${t.type}`),n.abort()}if(s=t.type===Er.MANIFEST?i.manifestLoadPolicy.default:Wi({},i.playlistLoadPolicy.default,{timeoutRetry:null,errorRetry:null}),n=this.createInternalLoader(t),Yi(null==(e=t.deliveryDirectives)?void 0:e.part)){let e;if(t.type===Er.LEVEL&&null!==t.level?e=this.hls.levels[t.level].details:t.type===Er.AUDIO_TRACK&&null!==t.id?e=this.hls.audioTracks[t.id].details:t.type===Er.SUBTITLE_TRACK&&null!==t.id&&(e=this.hls.subtitleTracks[t.id].details),e){const t=e.partTarget,i=e.targetduration;if(t&&i){const e=1e3*Math.max(3*t,.8*i);s=Wi({},s,{maxTimeToFirstByteMs:Math.min(e,s.maxTimeToFirstByteMs),maxLoadTimeMs:Math.min(e,s.maxTimeToFirstByteMs)})}}}const r=s.errorRetry||s.timeoutRetry||{},o={loadPolicy:s,timeout:s.maxLoadTimeMs,maxRetry:r.maxNumRetry||0,retryDelay:r.retryDelayMs||0,maxRetryDelay:r.maxRetryDelayMs||0},a={onSuccess:(t,e,i,s)=>{const n=this.getInternalLoader(i);this.resetInternalLoader(i.type);const r=t.data;0===r.indexOf("#EXTM3U")?(e.parsing.start=performance.now(),pr.isMediaPlaylist(r)?this.handleTrackOrLevelPlaylist(t,e,i,s||null,n):this.handleMasterPlaylist(t,e,i,s)):this.handleManifestParsingError(t,i,new Error("no EXTM3U delimiter"),s||null,e)},onError:(t,e,i,s)=>{this.handleNetworkError(e,i,!1,t,s)},onTimeout:(t,e,i)=>{this.handleNetworkError(e,i,!0,void 0,t)}};n.load(t,o,a)}handleMasterPlaylist(t,e,i,s){const n=this.hls,r=t.data,o=Cr(t,i),a=pr.parseMasterPlaylist(r,o);if(a.playlistParsingError)return void this.handleManifestParsingError(t,i,a.playlistParsingError,s,e);const{contentSteering:l,levels:c,sessionData:d,sessionKeys:u,startTimeOffset:h,variableList:p}=a;this.variableList=p;const{AUDIO:f=[],SUBTITLES:m,"CLOSED-CAPTIONS":v}=pr.parseMasterPlaylistMedia(r,o,a);if(f.length){const t=f.some((t=>!t.url));t||!c[0].audioCodec||c[0].attrs.AUDIO||(as.log("[playlist-loader]: audio codec signaled in quality level, but no embedded audio track signaled, create one"),f.unshift({type:"main",name:"main",groupId:"main",default:!1,autoselect:!1,forced:!1,id:-1,attrs:new ds({}),bitrate:0,url:""}))}n.trigger(Qi.MANIFEST_LOADED,{levels:c,audioTracks:f,subtitles:m,captions:v,contentSteering:l,url:o,stats:e,networkDetails:s,sessionData:d,sessionKeys:u,startTimeOffset:h,variableList:p})}handleTrackOrLevelPlaylist(t,e,i,s,n){const r=this.hls,{id:o,level:a,type:l}=i,c=Cr(t,i),d=0,u=Yi(a)?a:Yi(o)?o:0,h=xr(i),p=pr.parseLevelPlaylist(t.data,c,u,h,d,this.variableList);if(l===Er.MANIFEST){const t={attrs:new ds({}),bitrate:0,details:p,name:"",url:c};r.trigger(Qi.MANIFEST_LOADED,{levels:[t],audioTracks:[],url:c,stats:e,networkDetails:s,sessionData:null,sessionKeys:null,contentSteering:null,startTimeOffset:null,variableList:null})}e.parsing.end=performance.now(),i.levelDetails=p,this.handlePlaylistLoaded(p,t,e,i,s,n)}handleManifestParsingError(t,e,i,s,n){this.hls.trigger(Qi.ERROR,{type:Ji.NETWORK_ERROR,details:ts.MANIFEST_PARSING_ERROR,fatal:e.type===Er.MANIFEST,url:t.url,err:i,error:i,reason:i.message,response:t,context:e,networkDetails:s,stats:n})}handleNetworkError(t,e,i=!1,s,n){let r=`A network ${i?"timeout":"error"+(s?" (status "+s.code+")":"")} occurred while loading ${t.type}`;t.type===Er.LEVEL?r+=`: ${t.level} id: ${t.id}`:t.type!==Er.AUDIO_TRACK&&t.type!==Er.SUBTITLE_TRACK||(r+=` id: ${t.id} group-id: "${t.groupId}"`);const o=new Error(r);as.warn(`[playlist-loader]: ${r}`);let a=ts.UNKNOWN,l=!1;const c=this.getInternalLoader(t);switch(t.type){case Er.MANIFEST:a=i?ts.MANIFEST_LOAD_TIMEOUT:ts.MANIFEST_LOAD_ERROR,l=!0;break;case Er.LEVEL:a=i?ts.LEVEL_LOAD_TIMEOUT:ts.LEVEL_LOAD_ERROR,l=!1;break;case Er.AUDIO_TRACK:a=i?ts.AUDIO_TRACK_LOAD_TIMEOUT:ts.AUDIO_TRACK_LOAD_ERROR,l=!1;break;case Er.SUBTITLE_TRACK:a=i?ts.SUBTITLE_TRACK_LOAD_TIMEOUT:ts.SUBTITLE_LOAD_ERROR,l=!1;break}c&&this.resetInternalLoader(t.type);const d={type:Ji.NETWORK_ERROR,details:a,fatal:l,url:t.url,loader:c,context:t,error:o,networkDetails:e,stats:n};if(s){const i=(null==e?void 0:e.url)||t.url;d.response=Vi({url:i,data:void 0},s)}this.hls.trigger(Qi.ERROR,d)}handlePlaylistLoaded(t,e,i,s,n,r){const o=this.hls,{type:a,level:l,id:c,groupId:d,deliveryDirectives:u}=s,h=Cr(e,s),p=xr(s),f="number"===typeof s.level&&p===Tr.MAIN?l:void 0;if(!t.fragments.length){const t=new Error("No Segments found in Playlist");return void o.trigger(Qi.ERROR,{type:Ji.NETWORK_ERROR,details:ts.LEVEL_EMPTY_ERROR,fatal:!1,url:h,error:t,reason:t.message,response:e,context:s,level:f,parent:p,networkDetails:n,stats:i})}t.targetduration||(t.playlistParsingError=new Error("Missing Target Duration"));const m=t.playlistParsingError;if(m)o.trigger(Qi.ERROR,{type:Ji.NETWORK_ERROR,details:ts.LEVEL_PARSING_ERROR,fatal:!1,url:h,error:m,reason:m.message,response:e,context:s,level:f,parent:p,networkDetails:n,stats:i});else switch(t.live&&r&&(r.getCacheAge&&(t.ageHeader=r.getCacheAge()||0),r.getCacheAge&&!isNaN(t.ageHeader)||(t.ageHeader=0)),a){case Er.MANIFEST:case Er.LEVEL:o.trigger(Qi.LEVEL_LOADED,{details:t,level:f||0,id:c||0,stats:i,networkDetails:n,deliveryDirectives:u});break;case Er.AUDIO_TRACK:o.trigger(Qi.AUDIO_TRACK_LOADED,{details:t,id:c||0,groupId:d||"",stats:i,networkDetails:n,deliveryDirectives:u});break;case Er.SUBTITLE_TRACK:o.trigger(Qi.SUBTITLE_TRACK_LOADED,{details:t,id:c||0,groupId:d||"",stats:i,networkDetails:n,deliveryDirectives:u});break}}}function kr(t,e){let i;try{i=new Event("addtrack")}catch(s){i=document.createEvent("Event"),i.initEvent("addtrack",!1,!1)}i.track=t,e.dispatchEvent(i)}function Lr(t,e){const i=t.mode;if("disabled"===i&&(t.mode="hidden"),t.cues&&!t.cues.getCueById(e.id))try{if(t.addCue(e),!t.cues.getCueById(e.id))throw new Error(`addCue is failed for: ${e}`)}catch(s){as.debug(`[texttrack-utils]: ${s}`);try{const i=new self.TextTrackCue(e.startTime,e.endTime,e.text);i.id=e.id,t.addCue(i)}catch(n){as.debug(`[texttrack-utils]: Legacy TextTrackCue fallback failed: ${n}`)}}"disabled"===i&&(t.mode=i)}function Ar(t){const e=t.mode;if("disabled"===e&&(t.mode="hidden"),t.cues)for(let i=t.cues.length;i--;)t.removeCue(t.cues[i]);"disabled"===e&&(t.mode=e)}function Rr(t,e,i,s){const n=t.mode;if("disabled"===n&&(t.mode="hidden"),t.cues&&t.cues.length>0){const n=Dr(t.cues,e,i);for(let e=0;e<n.length;e++)s&&!s(n[e])||t.removeCue(n[e])}"disabled"===n&&(t.mode=n)}function Ir(t,e){if(e<t[0].startTime)return 0;const i=t.length-1;if(e>t[i].endTime)return-1;let s=0,n=i;while(s<=n){const r=Math.floor((n+s)/2);if(e<t[r].startTime)n=r-1;else{if(!(e>t[r].startTime&&s<i))return r;s=r+1}}return t[s].startTime-e<e-t[n].startTime?s:n}function Dr(t,e,i){const s=[],n=Ir(t,e);if(n>-1)for(let r=n,o=t.length;r<o;r++){const n=t[r];if(n.startTime>=e&&n.endTime<=i)s.push(n);else if(n.startTime>i)return s}return s}function Pr(t){const e=[];for(let i=0;i<t.length;i++){const s=t[i];"subtitles"!==s.kind&&"captions"!==s.kind||!s.label||e.push(t[i])}return e}var Or={audioId3:"org.id3",dateRange:"com.apple.quicktime.HLS",emsg:"https://aomedia.org/emsg/ID3"};const Mr=.25;function Nr(){if("undefined"!==typeof self)return self.VTTCue||self.TextTrackCue}function Fr(t,e,i,s,n){let r=new t(e,i,"");try{r.value=s,n&&(r.type=n)}catch(o){r=new t(e,i,JSON.stringify(n?Vi({type:n},s):s))}return r}const Br=(()=>{const t=Nr();try{t&&new t(0,Number.POSITIVE_INFINITY,"")}catch(e){return Number.MAX_VALUE}return Number.POSITIVE_INFINITY})();function $r(t,e){return t.getTime()/1e3-e}function Ur(t){return Uint8Array.from(t.replace(/^0x/,"").replace(/([\da-fA-F]{2}) ?/g,"0x$1 ").replace(/ +$/,"").split(" ")).buffer}class jr{constructor(t){this.hls=void 0,this.id3Track=null,this.media=null,this.dateRangeCuesAppended={},this.hls=t,this._registerListeners()}destroy(){this._unregisterListeners(),this.id3Track=null,this.media=null,this.dateRangeCuesAppended={},this.hls=null}_registerListeners(){const{hls:t}=this;t.on(Qi.MEDIA_ATTACHED,this.onMediaAttached,this),t.on(Qi.MEDIA_DETACHING,this.onMediaDetaching,this),t.on(Qi.MANIFEST_LOADING,this.onManifestLoading,this),t.on(Qi.FRAG_PARSING_METADATA,this.onFragParsingMetadata,this),t.on(Qi.BUFFER_FLUSHING,this.onBufferFlushing,this),t.on(Qi.LEVEL_UPDATED,this.onLevelUpdated,this)}_unregisterListeners(){const{hls:t}=this;t.off(Qi.MEDIA_ATTACHED,this.onMediaAttached,this),t.off(Qi.MEDIA_DETACHING,this.onMediaDetaching,this),t.off(Qi.MANIFEST_LOADING,this.onManifestLoading,this),t.off(Qi.FRAG_PARSING_METADATA,this.onFragParsingMetadata,this),t.off(Qi.BUFFER_FLUSHING,this.onBufferFlushing,this),t.off(Qi.LEVEL_UPDATED,this.onLevelUpdated,this)}onMediaAttached(t,e){this.media=e.media}onMediaDetaching(){this.id3Track&&(Ar(this.id3Track),this.id3Track=null,this.media=null,this.dateRangeCuesAppended={})}onManifestLoading(){this.dateRangeCuesAppended={}}createTrack(t){const e=this.getID3Track(t.textTracks);return e.mode="hidden",e}getID3Track(t){if(this.media){for(let e=0;e<t.length;e++){const i=t[e];if("metadata"===i.kind&&"id3"===i.label)return kr(i,this.media),i}return this.media.addTextTrack("metadata","id3")}}onFragParsingMetadata(t,e){if(!this.media)return;const{hls:{config:{enableEmsgMetadataCues:i,enableID3MetadataCues:s}}}=this;if(!i&&!s)return;const{samples:n}=e;this.id3Track||(this.id3Track=this.createTrack(this.media));const r=Nr();if(r)for(let o=0;o<n.length;o++){const t=n[o].type;if(t===Or.emsg&&!i||!s)continue;const e=zs(n[o].data);if(e){const i=n[o].pts;let s=i+n[o].duration;s>Br&&(s=Br);const a=s-i;a<=0&&(s=i+Mr);for(let n=0;n<e.length;n++){const o=e[n];if(!Vs(o)){this.updateId3CueEnds(i,t);const e=Fr(r,i,s,o,t);e&&this.id3Track.addCue(e)}}}}}updateId3CueEnds(t,e){var i;const s=null==(i=this.id3Track)?void 0:i.cues;if(s)for(let n=s.length;n--;){const i=s[n];i.type===e&&i.startTime<t&&i.endTime===Br&&(i.endTime=t)}}onBufferFlushing(t,{startOffset:e,endOffset:i,type:s}){const{id3Track:n,hls:r}=this;if(!r)return;const{config:{enableEmsgMetadataCues:o,enableID3MetadataCues:a}}=r;if(n&&(o||a)){let t;t="audio"===s?t=>t.type===Or.audioId3&&a:"video"===s?t=>t.type===Or.emsg&&o:t=>t.type===Or.audioId3&&a||t.type===Or.emsg&&o,Rr(n,e,i,t)}}onLevelUpdated(t,{details:e}){if(!this.media||!e.hasProgramDateTime||!this.hls.config.enableDateRangeMetadataCues)return;const{dateRangeCuesAppended:i,id3Track:s}=this,{dateRanges:n}=e,r=Object.keys(n);if(s){const t=Object.keys(i).filter((t=>!r.includes(t)));for(let e=t.length;e--;){const n=t[e];Object.keys(i[n].cues).forEach((t=>{s.removeCue(i[n].cues[t])})),delete i[n]}}const o=e.fragments[e.fragments.length-1];if(0===r.length||!Yi(null==o?void 0:o.programDateTime))return;this.id3Track||(this.id3Track=this.createTrack(this.media));const a=o.programDateTime/1e3-o.start,l=Nr();for(let c=0;c<r.length;c++){const t=r[c],e=n[t],s=$r(e.startDate,a),o=i[t],d=(null==o?void 0:o.cues)||{};let u=(null==o?void 0:o.durationKnown)||!1,h=Br;const p=e.endDate;if(p)h=$r(p,a),u=!0;else if(e.endOnNext&&!u){const t=r.reduce(((t,i)=>{if(i!==e.id){const s=n[i];if(s.class===e.class&&s.startDate>e.startDate&&(!t||e.startDate<t.startDate))return s}return t}),null);t&&(h=$r(t.startDate,a),u=!0)}const f=Object.keys(e.attr);for(let i=0;i<f.length;i++){const n=f[i];if(!us(n))continue;const r=d[n];if(r)u&&!o.durationKnown&&(r.endTime=h);else if(l){let i=e.attr[n];hs(n)&&(i=Ur(i));const r=Fr(l,s,h,{key:n,data:i},Or.dateRange);r&&(r.id=t,this.id3Track.addCue(r),d[n]=r)}}i[t]={cues:d,dateRange:e,durationKnown:u}}}}class qr{constructor(t){this.hls=void 0,this.config=void 0,this.media=null,this.levelDetails=null,this.currentTime=0,this.stallCount=0,this._latency=null,this.timeupdateHandler=()=>this.timeupdate(),this.hls=t,this.config=t.config,this.registerListeners()}get latency(){return this._latency||0}get maxLatency(){const{config:t,levelDetails:e}=this;return void 0!==t.liveMaxLatencyDuration?t.liveMaxLatencyDuration:e?t.liveMaxLatencyDurationCount*e.targetduration:0}get targetLatency(){const{levelDetails:t}=this;if(null===t)return null;const{holdBack:e,partHoldBack:i,targetduration:s}=t,{liveSyncDuration:n,liveSyncDurationCount:r,lowLatencyMode:o}=this.config,a=this.hls.userConfig;let l=o&&i||e;(a.liveSyncDuration||a.liveSyncDurationCount||0===l)&&(l=void 0!==n?n:r*s);const c=s,d=1;return l+Math.min(this.stallCount*d,c)}get liveSyncPosition(){const t=this.estimateLiveEdge(),e=this.targetLatency,i=this.levelDetails;if(null===t||null===e||null===i)return null;const s=i.edge,n=t-e-this.edgeStalled,r=s-i.totalduration,o=s-(this.config.lowLatencyMode&&i.partTarget||i.targetduration);return Math.min(Math.max(r,n),o)}get drift(){const{levelDetails:t}=this;return null===t?1:t.drift}get edgeStalled(){const{levelDetails:t}=this;if(null===t)return 0;const e=3*(this.config.lowLatencyMode&&t.partTarget||t.targetduration);return Math.max(t.age-e,0)}get forwardBufferLength(){const{media:t,levelDetails:e}=this;if(!t||!e)return 0;const i=t.buffered.length;return(i?t.buffered.end(i-1):e.edge)-this.currentTime}destroy(){this.unregisterListeners(),this.onMediaDetaching(),this.levelDetails=null,this.hls=this.timeupdateHandler=null}registerListeners(){this.hls.on(Qi.MEDIA_ATTACHED,this.onMediaAttached,this),this.hls.on(Qi.MEDIA_DETACHING,this.onMediaDetaching,this),this.hls.on(Qi.MANIFEST_LOADING,this.onManifestLoading,this),this.hls.on(Qi.LEVEL_UPDATED,this.onLevelUpdated,this),this.hls.on(Qi.ERROR,this.onError,this)}unregisterListeners(){this.hls.off(Qi.MEDIA_ATTACHED,this.onMediaAttached,this),this.hls.off(Qi.MEDIA_DETACHING,this.onMediaDetaching,this),this.hls.off(Qi.MANIFEST_LOADING,this.onManifestLoading,this),this.hls.off(Qi.LEVEL_UPDATED,this.onLevelUpdated,this),this.hls.off(Qi.ERROR,this.onError,this)}onMediaAttached(t,e){this.media=e.media,this.media.addEventListener("timeupdate",this.timeupdateHandler)}onMediaDetaching(){this.media&&(this.media.removeEventListener("timeupdate",this.timeupdateHandler),this.media=null)}onManifestLoading(){this.levelDetails=null,this._latency=null,this.stallCount=0}onLevelUpdated(t,{details:e}){this.levelDetails=e,e.advanced&&this.timeupdate(),!e.live&&this.media&&this.media.removeEventListener("timeupdate",this.timeupdateHandler)}onError(t,e){var i;e.details===ts.BUFFER_STALLED_ERROR&&(this.stallCount++,null!=(i=this.levelDetails)&&i.live&&as.warn("[playback-rate-controller]: Stall detected, adjusting target latency"))}timeupdate(){const{media:t,levelDetails:e}=this;if(!t||!e)return;this.currentTime=t.currentTime;const i=this.computeLatency();if(null===i)return;this._latency=i;const{lowLatencyMode:s,maxLiveSyncPlaybackRate:n}=this.config;if(!s||1===n||!e.live)return;const r=this.targetLatency;if(null===r)return;const o=i-r,a=Math.min(this.maxLatency,r+e.targetduration),l=o<a;if(l&&o>.05&&this.forwardBufferLength>1){const e=Math.min(2,Math.max(1,n)),i=Math.round(2/(1+Math.exp(-.75*o-this.edgeStalled))*20)/20;t.playbackRate=Math.min(e,Math.max(1,i))}else 1!==t.playbackRate&&0!==t.playbackRate&&(t.playbackRate=1)}estimateLiveEdge(){const{levelDetails:t}=this;return null===t?null:t.edge+t.age}computeLatency(){const t=this.estimateLiveEdge();return null===t?null:t-this.currentTime}}const Gr=["NONE","TYPE-0","TYPE-1",null];function Vr(t){return Gr.indexOf(t)>-1}const Hr=["SDR","PQ","HLG"];function zr(t){return!!t&&Hr.indexOf(t)>-1}var Kr={No:"",Yes:"YES",v2:"v2"};function Wr(t){const{canSkipUntil:e,canSkipDateRanges:i,age:s}=t,n=s<e/2;return e&&n?i?Kr.v2:Kr.Yes:Kr.No}class Yr{constructor(t,e,i){this.msn=void 0,this.part=void 0,this.skip=void 0,this.msn=t,this.part=e,this.skip=i}addDirectives(t){const e=new self.URL(t);return void 0!==this.msn&&e.searchParams.set("_HLS_msn",this.msn.toString()),void 0!==this.part&&e.searchParams.set("_HLS_part",this.part.toString()),this.skip&&e.searchParams.set("_HLS_skip",this.skip),e.href}}class Xr{constructor(t){this._attrs=void 0,this.audioCodec=void 0,this.bitrate=void 0,this.codecSet=void 0,this.url=void 0,this.frameRate=void 0,this.height=void 0,this.id=void 0,this.name=void 0,this.videoCodec=void 0,this.width=void 0,this.details=void 0,this.fragmentError=0,this.loadError=0,this.loaded=void 0,this.realBitrate=0,this.supportedPromise=void 0,this.supportedResult=void 0,this._avgBitrate=0,this._audioGroups=void 0,this._subtitleGroups=void 0,this._urlId=0,this.url=[t.url],this._attrs=[t.attrs],this.bitrate=t.bitrate,t.details&&(this.details=t.details),this.id=t.id||0,this.name=t.name,this.width=t.width||0,this.height=t.height||0,this.frameRate=t.attrs.optionalFloat("FRAME-RATE",0),this._avgBitrate=t.attrs.decimalInteger("AVERAGE-BANDWIDTH"),this.audioCodec=t.audioCodec,this.videoCodec=t.videoCodec,this.codecSet=[t.videoCodec,t.audioCodec].filter((t=>!!t)).map((t=>t.substring(0,4))).join(","),this.addGroupId("audio",t.attrs.AUDIO),this.addGroupId("text",t.attrs.SUBTITLES)}get maxBitrate(){return Math.max(this.realBitrate,this.bitrate)}get averageBitrate(){return this._avgBitrate||this.realBitrate||this.bitrate}get attrs(){return this._attrs[0]}get codecs(){return this.attrs.CODECS||""}get pathwayId(){return this.attrs["PATHWAY-ID"]||"."}get videoRange(){return this.attrs["VIDEO-RANGE"]||"SDR"}get score(){return this.attrs.optionalFloat("SCORE",0)}get uri(){return this.url[0]||""}hasAudioGroup(t){return Zr(this._audioGroups,t)}hasSubtitleGroup(t){return Zr(this._subtitleGroups,t)}get audioGroups(){return this._audioGroups}get subtitleGroups(){return this._subtitleGroups}addGroupId(t,e){if(e)if("audio"===t){let t=this._audioGroups;t||(t=this._audioGroups=[]),-1===t.indexOf(e)&&t.push(e)}else if("text"===t){let t=this._subtitleGroups;t||(t=this._subtitleGroups=[]),-1===t.indexOf(e)&&t.push(e)}}get urlId(){return 0}set urlId(t){}get audioGroupIds(){return this.audioGroups?[this.audioGroupId]:void 0}get textGroupIds(){return this.subtitleGroups?[this.textGroupId]:void 0}get audioGroupId(){var t;return null==(t=this.audioGroups)?void 0:t[0]}get textGroupId(){var t;return null==(t=this.subtitleGroups)?void 0:t[0]}addFallback(){}}function Zr(t,e){return!(!e||!t)&&-1!==t.indexOf(e)}function Qr(t,e){const i=e.startPTS;if(Yi(i)){let s,n=0;e.sn>t.sn?(n=i-t.start,s=t):(n=t.start-i,s=e),s.duration!==n&&(s.duration=n)}else if(e.sn>t.sn){const i=t.cc===e.cc;i&&t.minEndPTS?e.start=t.start+(t.minEndPTS-t.start):e.start=t.start+t.duration}else e.start=Math.max(t.start-e.duration,0)}function Jr(t,e,i,s,n,r){const o=s-i;o<=0&&(as.warn("Fragment should have a positive duration",e),s=i+e.duration,r=n+e.duration);let a=i,l=s;const c=e.startPTS,d=e.endPTS;if(Yi(c)){const t=Math.abs(c-i);Yi(e.deltaPTS)?e.deltaPTS=Math.max(t,e.deltaPTS):e.deltaPTS=t,a=Math.max(i,c),i=Math.min(i,c),n=Math.min(n,e.startDTS),l=Math.min(s,d),s=Math.max(s,d),r=Math.max(r,e.endDTS)}const u=i-e.start;0!==e.start&&(e.start=i),e.duration=s-e.start,e.startPTS=i,e.maxStartPTS=a,e.startDTS=n,e.endPTS=s,e.minEndPTS=l,e.endDTS=r;const h=e.sn;if(!t||h<t.startSN||h>t.endSN)return 0;let p;const f=h-t.startSN,m=t.fragments;for(m[f]=e,p=f;p>0;p--)Qr(m[p],m[p-1]);for(p=f;p<m.length-1;p++)Qr(m[p],m[p+1]);return t.fragmentHint&&Qr(m[m.length-1],t.fragmentHint),t.PTSKnown=t.alignedSliding=!0,u}function to(t,e){let i=null;const s=t.fragments;for(let l=s.length-1;l>=0;l--){const t=s[l].initSegment;if(t){i=t;break}}t.fragmentHint&&delete t.fragmentHint.endPTS;let n,r=0;if(so(t,e,((t,s)=>{t.relurl&&(r=t.cc-s.cc),Yi(t.startPTS)&&Yi(t.endPTS)&&(s.start=s.startPTS=t.startPTS,s.startDTS=t.startDTS,s.maxStartPTS=t.maxStartPTS,s.endPTS=t.endPTS,s.endDTS=t.endDTS,s.minEndPTS=t.minEndPTS,s.duration=t.endPTS-t.startPTS,s.duration&&(n=s),e.PTSKnown=e.alignedSliding=!0),s.elementaryStreams=t.elementaryStreams,s.loader=t.loader,s.stats=t.stats,t.initSegment&&(s.initSegment=t.initSegment,i=t.initSegment)})),i){const t=e.fragmentHint?e.fragments.concat(e.fragmentHint):e.fragments;t.forEach((t=>{var e;!t||t.initSegment&&t.initSegment.relurl!==(null==(e=i)?void 0:e.relurl)||(t.initSegment=i)}))}if(e.skippedSegments)if(e.deltaUpdateFailed=e.fragments.some((t=>!t)),e.deltaUpdateFailed){as.warn("[level-helper] Previous playlist missing segments skipped in delta playlist");for(let t=e.skippedSegments;t--;)e.fragments.shift();e.startSN=e.fragments[0].sn,e.startCC=e.fragments[0].cc}else e.canSkipDateRanges&&(e.dateRanges=eo(t.dateRanges,e.dateRanges,e.recentlyRemovedDateranges));const o=e.fragments;if(r){as.warn("discontinuity sliding from playlist, take drift into account");for(let t=0;t<o.length;t++)o[t].cc+=r}e.skippedSegments&&(e.startCC=e.fragments[0].cc),io(t.partList,e.partList,((t,e)=>{e.elementaryStreams=t.elementaryStreams,e.stats=t.stats})),n?Jr(e,n,n.startPTS,n.endPTS,n.startDTS,n.endDTS):no(t,e),o.length&&(e.totalduration=e.edge-o[0].start),e.driftStartTime=t.driftStartTime,e.driftStart=t.driftStart;const a=e.advancedDateTime;if(e.advanced&&a){const t=e.edge;e.driftStart||(e.driftStartTime=a,e.driftStart=t),e.driftEndTime=a,e.driftEnd=t}else e.driftEndTime=t.driftEndTime,e.driftEnd=t.driftEnd,e.advancedDateTime=t.advancedDateTime}function eo(t,e,i){const s=Wi({},t);return i&&i.forEach((t=>{delete s[t]})),Object.keys(e).forEach((t=>{const i=new ps(e[t].attr,s[t]);i.isValid?s[t]=i:as.warn(`Ignoring invalid Playlist Delta Update DATERANGE tag: "${JSON.stringify(e[t].attr)}"`)})),s}function io(t,e,i){if(t&&e){let s=0;for(let n=0,r=t.length;n<=r;n++){const r=t[n],o=e[n+s];r&&o&&r.index===o.index&&r.fragment.sn===o.fragment.sn?i(r,o):s--}}}function so(t,e,i){const s=e.skippedSegments,n=Math.max(t.startSN,e.startSN)-e.startSN,r=(t.fragmentHint?1:0)+(s?e.endSN:Math.min(t.endSN,e.endSN))-e.startSN,o=e.startSN-t.startSN,a=e.fragmentHint?e.fragments.concat(e.fragmentHint):e.fragments,l=t.fragmentHint?t.fragments.concat(t.fragmentHint):t.fragments;for(let c=n;c<=r;c++){const t=l[o+c];let n=a[c];s&&!n&&c<s&&(n=e.fragments[c]=t),t&&n&&i(t,n)}}function no(t,e){const i=e.startSN+e.skippedSegments-t.startSN,s=t.fragments;i<0||i>=s.length||ro(e,s[i].start)}function ro(t,e){if(e){const i=t.fragments;for(let s=t.skippedSegments;s<i.length;s++)i[s].start+=e;t.fragmentHint&&(t.fragmentHint.start+=e)}}function oo(t,e=1/0){let i=1e3*t.targetduration;if(t.updated){const s=t.fragments,n=4;if(s.length&&i*n>e){const t=1e3*s[s.length-1].duration;t<i&&(i=t)}}else i/=2;return Math.round(i)}function ao(t,e,i){if(null==t||!t.details)return null;const s=t.details;let n=s.fragments[e-s.startSN];return n||(n=s.fragmentHint,n&&n.sn===e?n:e<s.startSN&&i&&i.sn===e?i:null)}function lo(t,e,i){var s;return null!=t&&t.details?co(null==(s=t.details)?void 0:s.partList,e,i):null}function co(t,e,i){if(t)for(let s=t.length;s--;){const n=t[s];if(n.index===i&&n.fragment.sn===e)return n}return null}function uo(t){t.forEach(((t,e)=>{const{details:i}=t;null!=i&&i.fragments&&i.fragments.forEach((t=>{t.level=e}))}))}function ho(t){switch(t.details){case ts.FRAG_LOAD_TIMEOUT:case ts.KEY_LOAD_TIMEOUT:case ts.LEVEL_LOAD_TIMEOUT:case ts.MANIFEST_LOAD_TIMEOUT:return!0}return!1}function po(t,e){const i=ho(e);return t.default[(i?"timeout":"error")+"Retry"]}function fo(t,e){const i="linear"===t.backoff?1:Math.pow(2,e);return Math.min(i*t.retryDelayMs,t.maxRetryDelayMs)}function mo(t){return Vi(Vi({},t),{errorRetry:null,timeoutRetry:null})}function vo(t,e,i,s){if(!t)return!1;const n=null==s?void 0:s.code,r=e<t.maxNumRetry&&(go(n)||!!i);return t.shouldRetry?t.shouldRetry(t,e,i,s,r):r}function go(t){return 0===t&&!1===navigator.onLine||!!t&&(t<400||t>499)}const yo={search:function(t,e){let i=0,s=t.length-1,n=null,r=null;while(i<=s){n=(i+s)/2|0,r=t[n];const o=e(r);if(o>0)i=n+1;else{if(!(o<0))return r;s=n-1}}return null}};function bo(t,e,i){if(null===e||!Array.isArray(t)||!t.length||!Yi(e))return null;const s=t[0].programDateTime;if(e<(s||0))return null;const n=t[t.length-1].endProgramDateTime;if(e>=(n||0))return null;i=i||0;for(let r=0;r<t.length;++r){const s=t[r];if(To(e,i,s))return s}return null}function wo(t,e,i=0,s=0,n=.005){let r=null;if(t){r=e[t.sn-e[0].sn+1]||null;const s=t.endDTS-i;s>0&&s<15e-7&&(i+=15e-7)}else 0===i&&0===e[0].start&&(r=e[0]);if(r&&((!t||t.level===r.level)&&0===Eo(i,s,r)||So(r,t,Math.min(n,s))))return r;const o=yo.search(e,Eo.bind(null,i,s));return!o||o===t&&r?r:o}function So(t,e,i){if(e&&0===e.start&&e.level<t.level&&(e.endPTS||0)>0){const s=e.tagList.reduce(((t,e)=>("INF"===e[0]&&(t+=parseFloat(e[1])),t)),i);return t.start<=s}return!1}function Eo(t=0,e=0,i){if(i.start<=t&&i.start+i.duration>t)return 0;const s=Math.min(e,i.duration+(i.deltaPTS?i.deltaPTS:0));return i.start+i.duration-s<=t?1:i.start-s>t&&i.start?-1:0}function To(t,e,i){const s=1e3*Math.min(e,i.duration+(i.deltaPTS?i.deltaPTS:0)),n=i.endProgramDateTime||0;return n-s>t}function xo(t,e){return yo.search(t,(t=>t.cc<e?1:t.cc>e?-1:0))}var Co={DoNothing:0,SendEndCallback:1,SendAlternateToPenaltyBox:2,RemoveAlternatePermanently:3,InsertDiscontinuity:4,RetryRequest:5},_o={None:0,MoveAllAlternatesMatchingHost:1,MoveAllAlternatesMatchingHDCP:2,SwitchToSDR:4};class ko{constructor(t){this.hls=void 0,this.playlistError=0,this.penalizedRenditions={},this.log=void 0,this.warn=void 0,this.error=void 0,this.hls=t,this.log=as.log.bind(as,"[info]:"),this.warn=as.warn.bind(as,"[warning]:"),this.error=as.error.bind(as,"[error]:"),this.registerListeners()}registerListeners(){const t=this.hls;t.on(Qi.ERROR,this.onError,this),t.on(Qi.MANIFEST_LOADING,this.onManifestLoading,this),t.on(Qi.LEVEL_UPDATED,this.onLevelUpdated,this)}unregisterListeners(){const t=this.hls;t&&(t.off(Qi.ERROR,this.onError,this),t.off(Qi.ERROR,this.onErrorOut,this),t.off(Qi.MANIFEST_LOADING,this.onManifestLoading,this),t.off(Qi.LEVEL_UPDATED,this.onLevelUpdated,this))}destroy(){this.unregisterListeners(),this.hls=null,this.penalizedRenditions={}}startLoad(t){}stopLoad(){this.playlistError=0}getVariantLevelIndex(t){return(null==t?void 0:t.type)===Tr.MAIN?t.level:this.hls.loadLevel}onManifestLoading(){this.playlistError=0,this.penalizedRenditions={}}onLevelUpdated(){this.playlistError=0}onError(t,e){var i,s;if(e.fatal)return;const n=this.hls,r=e.context;switch(e.details){case ts.FRAG_LOAD_ERROR:case ts.FRAG_LOAD_TIMEOUT:case ts.KEY_LOAD_ERROR:case ts.KEY_LOAD_TIMEOUT:return void(e.errorAction=this.getFragRetryOrSwitchAction(e));case ts.FRAG_PARSING_ERROR:if(null!=(i=e.frag)&&i.gap)return void(e.errorAction={action:Co.DoNothing,flags:_o.None});case ts.FRAG_GAP:case ts.FRAG_DECRYPT_ERROR:return e.errorAction=this.getFragRetryOrSwitchAction(e),void(e.errorAction.action=Co.SendAlternateToPenaltyBox);case ts.LEVEL_EMPTY_ERROR:case ts.LEVEL_PARSING_ERROR:{var o,a;const t=e.parent===Tr.MAIN?e.level:n.loadLevel;e.details===ts.LEVEL_EMPTY_ERROR&&null!=(o=e.context)&&null!=(a=o.levelDetails)&&a.live?e.errorAction=this.getPlaylistRetryOrSwitchAction(e,t):(e.levelRetry=!1,e.errorAction=this.getLevelSwitchAction(e,t))}return;case ts.LEVEL_LOAD_ERROR:case ts.LEVEL_LOAD_TIMEOUT:return void("number"===typeof(null==r?void 0:r.level)&&(e.errorAction=this.getPlaylistRetryOrSwitchAction(e,r.level)));case ts.AUDIO_TRACK_LOAD_ERROR:case ts.AUDIO_TRACK_LOAD_TIMEOUT:case ts.SUBTITLE_LOAD_ERROR:case ts.SUBTITLE_TRACK_LOAD_TIMEOUT:if(r){const t=n.levels[n.loadLevel];if(t&&(r.type===Er.AUDIO_TRACK&&t.hasAudioGroup(r.groupId)||r.type===Er.SUBTITLE_TRACK&&t.hasSubtitleGroup(r.groupId)))return e.errorAction=this.getPlaylistRetryOrSwitchAction(e,n.loadLevel),e.errorAction.action=Co.SendAlternateToPenaltyBox,void(e.errorAction.flags=_o.MoveAllAlternatesMatchingHost)}return;case ts.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED:{const t=n.levels[n.loadLevel],i=null==t?void 0:t.attrs["HDCP-LEVEL"];i?e.errorAction={action:Co.SendAlternateToPenaltyBox,flags:_o.MoveAllAlternatesMatchingHDCP,hdcpLevel:i}:this.keySystemError(e)}return;case ts.BUFFER_ADD_CODEC_ERROR:case ts.REMUX_ALLOC_ERROR:case ts.BUFFER_APPEND_ERROR:return void(e.errorAction=this.getLevelSwitchAction(e,null!=(s=e.level)?s:n.loadLevel));case ts.INTERNAL_EXCEPTION:case ts.BUFFER_APPENDING_ERROR:case ts.BUFFER_FULL_ERROR:case ts.LEVEL_SWITCH_ERROR:case ts.BUFFER_STALLED_ERROR:case ts.BUFFER_SEEK_OVER_HOLE:case ts.BUFFER_NUDGE_ON_STALL:return void(e.errorAction={action:Co.DoNothing,flags:_o.None})}e.type===Ji.KEY_SYSTEM_ERROR&&this.keySystemError(e)}keySystemError(t){const e=this.getVariantLevelIndex(t.frag);t.levelRetry=!1,t.errorAction=this.getLevelSwitchAction(t,e)}getPlaylistRetryOrSwitchAction(t,e){const i=this.hls,s=po(i.config.playlistLoadPolicy,t),n=this.playlistError++,r=vo(s,n,ho(t),t.response);if(r)return{action:Co.RetryRequest,flags:_o.None,retryConfig:s,retryCount:n};const o=this.getLevelSwitchAction(t,e);return s&&(o.retryConfig=s,o.retryCount=n),o}getFragRetryOrSwitchAction(t){const e=this.hls,i=this.getVariantLevelIndex(t.frag),s=e.levels[i],{fragLoadPolicy:n,keyLoadPolicy:r}=e.config,o=po(t.details.startsWith("key")?r:n,t),a=e.levels.reduce(((t,e)=>t+e.fragmentError),0);if(s){t.details!==ts.FRAG_GAP&&s.fragmentError++;const e=vo(o,a,ho(t),t.response);if(e)return{action:Co.RetryRequest,flags:_o.None,retryConfig:o,retryCount:a}}const l=this.getLevelSwitchAction(t,i);return o&&(l.retryConfig=o,l.retryCount=a),l}getLevelSwitchAction(t,e){const i=this.hls;null!==e&&void 0!==e||(e=i.loadLevel);const s=this.hls.levels[e];if(s){var n,r;const e=t.details;s.loadError++,e===ts.BUFFER_APPEND_ERROR&&s.fragmentError++;let l=-1;const{levels:c,loadLevel:d,minAutoLevel:u,maxAutoLevel:h}=i;i.autoLevelEnabled||(i.loadLevel=-1);const p=null==(n=t.frag)?void 0:n.type,f=p===Tr.AUDIO&&e===ts.FRAG_PARSING_ERROR||"audio"===t.sourceBufferName&&(e===ts.BUFFER_ADD_CODEC_ERROR||e===ts.BUFFER_APPEND_ERROR),m=f&&c.some((({audioCodec:t})=>s.audioCodec!==t)),v="video"===t.sourceBufferName&&(e===ts.BUFFER_ADD_CODEC_ERROR||e===ts.BUFFER_APPEND_ERROR),g=v&&c.some((({codecSet:t,audioCodec:e})=>s.codecSet!==t&&s.audioCodec===e)),{type:y,groupId:b}=null!=(r=t.context)?r:{};for(let i=c.length;i--;){const n=(i+d)%c.length;if(n!==d&&n>=u&&n<=h&&0===c[n].loadError){var o,a;const i=c[n];if(e===ts.FRAG_GAP&&p===Tr.MAIN&&t.frag){const e=c[n].details;if(e){const i=wo(t.frag,e.fragments,t.frag.start);if(null!=i&&i.gap)continue}}else{if(y===Er.AUDIO_TRACK&&i.hasAudioGroup(b)||y===Er.SUBTITLE_TRACK&&i.hasSubtitleGroup(b))continue;if(p===Tr.AUDIO&&null!=(o=s.audioGroups)&&o.some((t=>i.hasAudioGroup(t)))||p===Tr.SUBTITLE&&null!=(a=s.subtitleGroups)&&a.some((t=>i.hasSubtitleGroup(t)))||m&&s.audioCodec===i.audioCodec||!m&&s.audioCodec!==i.audioCodec||g&&s.codecSet===i.codecSet)continue}l=n;break}}if(l>-1&&i.loadLevel!==l)return t.levelRetry=!0,this.playlistError=0,{action:Co.SendAlternateToPenaltyBox,flags:_o.None,nextAutoLevel:l}}return{action:Co.SendAlternateToPenaltyBox,flags:_o.MoveAllAlternatesMatchingHost}}onErrorOut(t,e){var i;switch(null==(i=e.errorAction)?void 0:i.action){case Co.DoNothing:break;case Co.SendAlternateToPenaltyBox:this.sendAlternateToPenaltyBox(e),e.errorAction.resolved||e.details===ts.FRAG_GAP?/MediaSource readyState: ended/.test(e.error.message)&&(this.warn(`MediaSource ended after "${e.sourceBufferName}" sourceBuffer append error. Attempting to recover from media error.`),this.hls.recoverMediaError()):e.fatal=!0;break;case Co.RetryRequest:break}e.fatal&&this.hls.stopLoad()}sendAlternateToPenaltyBox(t){const e=this.hls,i=t.errorAction;if(!i)return;const{flags:s,hdcpLevel:n,nextAutoLevel:r}=i;switch(s){case _o.None:this.switchLevel(t,r);break;case _o.MoveAllAlternatesMatchingHDCP:n&&(e.maxHdcpLevel=Gr[Gr.indexOf(n)-1],i.resolved=!0),this.warn(`Restricting playback to HDCP-LEVEL of "${e.maxHdcpLevel}" or lower`);break}i.resolved||this.switchLevel(t,r)}switchLevel(t,e){void 0!==e&&t.errorAction&&(this.warn(`switching to level ${e} after ${t.details}`),this.hls.nextAutoLevel=e,t.errorAction.resolved=!0,this.hls.nextLoadLevel=this.hls.nextAutoLevel)}}class Lo{constructor(t,e){this.hls=void 0,this.timer=-1,this.requestScheduled=-1,this.canLoad=!1,this.log=void 0,this.warn=void 0,this.log=as.log.bind(as,`${e}:`),this.warn=as.warn.bind(as,`${e}:`),this.hls=t}destroy(){this.clearTimer(),this.hls=this.log=this.warn=null}clearTimer(){-1!==this.timer&&(self.clearTimeout(this.timer),this.timer=-1)}startLoad(){this.canLoad=!0,this.requestScheduled=-1,this.loadPlaylist()}stopLoad(){this.canLoad=!1,this.clearTimer()}switchParams(t,e,i){const s=null==e?void 0:e.renditionReports;if(s){let r=-1;for(let i=0;i<s.length;i++){const o=s[i];let a;try{a=new self.URL(o.URI,e.url).href}catch(n){as.warn(`Could not construct new URL for Rendition Report: ${n}`),a=o.URI||""}if(a===t){r=i;break}a===t.substring(0,a.length)&&(r=i)}if(-1!==r){const t=s[r],n=parseInt(t["LAST-MSN"])||(null==e?void 0:e.lastPartSn);let o=parseInt(t["LAST-PART"])||(null==e?void 0:e.lastPartIndex);if(this.hls.config.lowLatencyMode){const t=Math.min(e.age-e.partTarget,e.targetduration);o>=0&&t>e.partTarget&&(o+=1)}const a=i&&Wr(i);return new Yr(n,o>=0?o:void 0,a)}}}loadPlaylist(t){-1===this.requestScheduled&&(this.requestScheduled=self.performance.now())}shouldLoadPlaylist(t){return this.canLoad&&!!t&&!!t.url&&(!t.details||t.details.live)}shouldReloadPlaylist(t){return-1===this.timer&&-1===this.requestScheduled&&this.shouldLoadPlaylist(t)}playlistLoaded(t,e,i){const{details:s,stats:n}=e,r=self.performance.now(),o=n.loading.first?Math.max(0,r-n.loading.first):0;if(s.advancedDateTime=Date.now()-o,s.live||null!=i&&i.live){if(s.reloaded(i),i&&this.log(`live playlist ${t} ${s.advanced?"REFRESHED "+s.lastPartSn+"-"+s.lastPartIndex:s.updated?"UPDATED":"MISSED"}`),i&&s.fragments.length>0&&to(i,s),!this.canLoad||!s.live)return;let o,a,l;if(s.canBlockReload&&s.endSN&&s.advanced){const t=this.hls.config.lowLatencyMode,n=s.lastPartSn,r=s.endSN,c=s.lastPartIndex,d=-1!==c,u=n===r,h=t?0:c;d?(a=u?r+1:n,l=u?h:c+1):a=r+1;const p=s.age,f=p+s.ageHeader;let m=Math.min(f-s.partTarget,1.5*s.targetduration);if(m>0){if(i&&m>i.tuneInGoal)this.warn(`CDN Tune-in goal increased from: ${i.tuneInGoal} to: ${m} with playlist age: ${s.age}`),m=0;else{const t=Math.floor(m/s.targetduration);if(a+=t,void 0!==l){const t=Math.round(m%s.targetduration/s.partTarget);l+=t}this.log(`CDN Tune-in age: ${s.ageHeader}s last advanced ${p.toFixed(2)}s goal: ${m} skip sn ${t} to part ${l}`)}s.tuneInGoal=m}if(o=this.getDeliveryDirectives(s,e.deliveryDirectives,a,l),t||!u)return void this.loadPlaylist(o)}else(s.canBlockReload||s.canSkipUntil)&&(o=this.getDeliveryDirectives(s,e.deliveryDirectives,a,l));const c=this.hls.mainForwardBufferInfo,d=c?c.end-c.len:0,u=1e3*(s.edge-d),h=oo(s,u);s.updated&&r>this.requestScheduled+h&&(this.requestScheduled=n.loading.start),void 0!==a&&s.canBlockReload?this.requestScheduled=n.loading.first+h-(1e3*s.partTarget||1e3):-1===this.requestScheduled||this.requestScheduled+h<r?this.requestScheduled=r:this.requestScheduled-r<=0&&(this.requestScheduled+=h);let p=this.requestScheduled-r;p=Math.max(0,p),this.log(`reload live playlist ${t} in ${Math.round(p)} ms`),this.timer=self.setTimeout((()=>this.loadPlaylist(o)),p)}else this.clearTimer()}getDeliveryDirectives(t,e,i,s){let n=Wr(t);return null!=e&&e.skip&&t.deltaUpdateFailed&&(i=e.msn,s=e.part,n=Kr.No),new Yr(i,s,n)}checkRetry(t){const e=t.details,i=ho(t),s=t.errorAction,{action:n,retryCount:r=0,retryConfig:o}=s||{},a=!!s&&!!o&&(n===Co.RetryRequest||!s.resolved&&n===Co.SendAlternateToPenaltyBox);if(a){var l;if(this.requestScheduled=-1,r>=o.maxNumRetry)return!1;if(i&&null!=(l=t.context)&&l.deliveryDirectives)this.warn(`Retrying playlist loading ${r+1}/${o.maxNumRetry} after "${e}" without delivery-directives`),this.loadPlaylist();else{const t=fo(o,r);this.timer=self.setTimeout((()=>this.loadPlaylist()),t),this.warn(`Retrying playlist loading ${r+1}/${o.maxNumRetry} after "${e}" in ${t}ms`)}t.levelRetry=!0,s.resolved=!0}return a}}class Ao{constructor(t,e=0,i=0){this.halfLife=void 0,this.alpha_=void 0,this.estimate_=void 0,this.totalWeight_=void 0,this.halfLife=t,this.alpha_=t?Math.exp(Math.log(.5)/t):0,this.estimate_=e,this.totalWeight_=i}sample(t,e){const i=Math.pow(this.alpha_,t);this.estimate_=e*(1-i)+i*this.estimate_,this.totalWeight_+=t}getTotalWeight(){return this.totalWeight_}getEstimate(){if(this.alpha_){const t=1-Math.pow(this.alpha_,this.totalWeight_);if(t)return this.estimate_/t}return this.estimate_}}class Ro{constructor(t,e,i,s=100){this.defaultEstimate_=void 0,this.minWeight_=void 0,this.minDelayMs_=void 0,this.slow_=void 0,this.fast_=void 0,this.defaultTTFB_=void 0,this.ttfb_=void 0,this.defaultEstimate_=i,this.minWeight_=.001,this.minDelayMs_=50,this.slow_=new Ao(t),this.fast_=new Ao(e),this.defaultTTFB_=s,this.ttfb_=new Ao(t)}update(t,e){const{slow_:i,fast_:s,ttfb_:n}=this;i.halfLife!==t&&(this.slow_=new Ao(t,i.getEstimate(),i.getTotalWeight())),s.halfLife!==e&&(this.fast_=new Ao(e,s.getEstimate(),s.getTotalWeight())),n.halfLife!==t&&(this.ttfb_=new Ao(t,n.getEstimate(),n.getTotalWeight()))}sample(t,e){t=Math.max(t,this.minDelayMs_);const i=8*e,s=t/1e3,n=i/s;this.fast_.sample(s,n),this.slow_.sample(s,n)}sampleTTFB(t){const e=t/1e3,i=Math.sqrt(2)*Math.exp(-Math.pow(e,2)/2);this.ttfb_.sample(i,Math.max(t,5))}canEstimate(){return this.fast_.getTotalWeight()>=this.minWeight_}getEstimate(){return this.canEstimate()?Math.min(this.fast_.getEstimate(),this.slow_.getEstimate()):this.defaultEstimate_}getEstimateTTFB(){return this.ttfb_.getTotalWeight()>=this.minWeight_?this.ttfb_.getEstimate():this.defaultTTFB_}destroy(){}}const Io={supported:!0,configurations:[],decodingInfoResults:[{supported:!0,powerEfficient:!0,smooth:!0}]},Do={};function Po(t,e,i,s,n,r){const o=t.audioCodec?t.audioGroups:null,a=null==r?void 0:r.audioCodec,l=null==r?void 0:r.channels,c=l?parseInt(l):a?1/0:2;let d=null;if(null!=o&&o.length)try{d=1===o.length&&o[0]?e.groups[o[0]].channels:o.reduce(((t,i)=>{if(i){const s=e.groups[i];if(!s)throw new Error(`Audio track group ${i} not found`);Object.keys(s.channels).forEach((e=>{t[e]=(t[e]||0)+s.channels[e]}))}return t}),{2:0})}catch(u){return!0}return void 0!==t.videoCodec&&(t.width>1920&&t.height>1088||t.height>1920&&t.width>1088||t.frameRate>Math.max(s,30)||"SDR"!==t.videoRange&&t.videoRange!==i||t.bitrate>Math.max(n,8e6))||!!d&&Yi(c)&&Object.keys(d).some((t=>parseInt(t)>c))}function Oo(t,e,i){const s=t.videoCodec,n=t.audioCodec;if(!s||!n||!i)return Promise.resolve(Io);const r={width:t.width,height:t.height,bitrate:Math.ceil(Math.max(.9*t.bitrate,t.averageBitrate)),framerate:t.frameRate||30},o=t.videoRange;"SDR"!==o&&(r.transferFunction=o.toLowerCase());const a=s.split(",").map((t=>({type:"media-source",video:Vi(Vi({},r),{},{contentType:Jn(t,"video")})})));return n&&t.audioGroups&&t.audioGroups.forEach((t=>{var i;t&&(null==(i=e.groups[t])||i.tracks.forEach((e=>{if(e.groupId===t){const t=e.channels||"",i=parseFloat(t);Yi(i)&&i>2&&a.push.apply(a,n.split(",").map((t=>({type:"media-source",audio:{contentType:Jn(t,"audio"),channels:""+i}}))))}})))})),Promise.all(a.map((t=>{const e=Mo(t);return Do[e]||(Do[e]=i.decodingInfo(t))}))).then((t=>({supported:!t.some((t=>!t.supported)),configurations:a,decodingInfoResults:t}))).catch((t=>({supported:!1,configurations:a,decodingInfoResults:[],error:t})))}function Mo(t){const{audio:e,video:i}=t,s=i||e;if(s){const t=s.contentType.split('"')[1];if(i)return`r${i.height}x${i.width}f${Math.ceil(i.framerate)}${i.transferFunction||"sd"}_${t}_${Math.ceil(i.bitrate/1e5)}`;if(e)return`c${e.channels}${e.spatialRendering?"s":"n"}_${t}`}return""}function No(){if("function"===typeof matchMedia){const t=matchMedia("(dynamic-range: high)"),e=matchMedia("bad query");if(t.media!==e.media)return!0===t.matches}return!1}function Fo(t,e){let i=!1,s=[];return t&&(i="SDR"!==t,s=[t]),e&&(s=e.allowedVideoRanges||Hr.slice(0),i=void 0!==e.preferHDR?e.preferHDR:No(),s=i?s.filter((t=>"SDR"!==t)):["SDR"]),{preferHDR:i,allowedVideoRanges:s}}function Bo(t,e,i,s,n){const r=Object.keys(t),o=null==s?void 0:s.channels,a=null==s?void 0:s.audioCodec,l=o&&2===parseInt(o);let c=!0,d=!1,u=1/0,h=1/0,p=1/0,f=0,m=[];const{preferHDR:v,allowedVideoRanges:g}=Fo(e,n);for(let S=r.length;S--;){const e=t[r[S]];c=e.channels[2]>0,u=Math.min(u,e.minHeight),h=Math.min(h,e.minFramerate),p=Math.min(p,e.minBitrate);const i=g.filter((t=>e.videoRanges[t]>0));i.length>0&&(d=!0,m=i)}u=Yi(u)?u:0,h=Yi(h)?h:0;const y=Math.max(1080,u),b=Math.max(30,h);p=Yi(p)?p:i,i=Math.max(p,i),d||(e=void 0,m=[]);const w=r.reduce(((e,s)=>{const n=t[s];if(s===e)return e;if(n.minBitrate>i)return $o(s,`min bitrate of ${n.minBitrate} > current estimate of ${i}`),e;if(!n.hasDefaultAudio)return $o(s,"no renditions with default or auto-select sound found"),e;if(a&&s.indexOf(a.substring(0,4))%5!==0)return $o(s,`audio codec preference "${a}" not found`),e;if(o&&!l){if(!n.channels[o])return $o(s,`no renditions with ${o} channel sound found (channels options: ${Object.keys(n.channels)})`),e}else if((!a||l)&&c&&0===n.channels["2"])return $o(s,"no renditions with stereo sound found"),e;return n.minHeight>y?($o(s,`min resolution of ${n.minHeight} > maximum of ${y}`),e):n.minFramerate>b?($o(s,`min framerate of ${n.minFramerate} > maximum of ${b}`),e):m.some((t=>n.videoRanges[t]>0))?n.maxScore<f?($o(s,`max score of ${n.maxScore} < selected max of ${f}`),e):e&&(er(s)>=er(e)||n.fragmentError>t[e].fragmentError)?e:(f=n.maxScore,s):($o(s,`no variants with VIDEO-RANGE of ${JSON.stringify(m)} found`),e)}),void 0);return{codecSet:w,videoRanges:m,preferHDR:v,minFramerate:h,minBitrate:p}}function $o(t,e){as.log(`[abr] start candidates with "${t}" ignored because ${e}`)}function Uo(t){return t.reduce(((t,e)=>{let i=t.groups[e.groupId];i||(i=t.groups[e.groupId]={tracks:[],channels:{2:0},hasDefault:!1,hasAutoSelect:!1}),i.tracks.push(e);const s=e.channels||"2";return i.channels[s]=(i.channels[s]||0)+1,i.hasDefault=i.hasDefault||e.default,i.hasAutoSelect=i.hasAutoSelect||e.autoselect,i.hasDefault&&(t.hasDefaultAudio=!0),i.hasAutoSelect&&(t.hasAutoSelectAudio=!0),t}),{hasDefaultAudio:!1,hasAutoSelectAudio:!1,groups:{}})}function jo(t,e,i,s){return t.slice(i,s+1).reduce(((t,i)=>{if(!i.codecSet)return t;const s=i.audioGroups;let n=t[i.codecSet];n||(t[i.codecSet]=n={minBitrate:1/0,minHeight:1/0,minFramerate:1/0,maxScore:0,videoRanges:{SDR:0},channels:{2:0},hasDefaultAudio:!s,fragmentError:0}),n.minBitrate=Math.min(n.minBitrate,i.bitrate);const r=Math.min(i.height,i.width);return n.minHeight=Math.min(n.minHeight,r),n.minFramerate=Math.min(n.minFramerate,i.frameRate),n.maxScore=Math.max(n.maxScore,i.score),n.fragmentError+=i.fragmentError,n.videoRanges[i.videoRange]=(n.videoRanges[i.videoRange]||0)+1,s&&s.forEach((t=>{if(!t)return;const i=e.groups[t];i&&(n.hasDefaultAudio=n.hasDefaultAudio||e.hasDefaultAudio?i.hasDefault:i.hasAutoSelect||!e.hasDefaultAudio&&!e.hasAutoSelectAudio,Object.keys(i.channels).forEach((t=>{n.channels[t]=(n.channels[t]||0)+i.channels[t]})))})),t}),{})}function qo(t,e,i){if("attrs"in t){const i=e.indexOf(t);if(-1!==i)return i}for(let s=0;s<e.length;s++){const n=e[s];if(Go(t,n,i))return s}return-1}function Go(t,e,i){const{groupId:s,name:n,lang:r,assocLang:o,characteristics:a,default:l}=t,c=t.forced;return(void 0===s||e.groupId===s)&&(void 0===n||e.name===n)&&(void 0===r||e.lang===r)&&(void 0===r||e.assocLang===o)&&(void 0===l||e.default===l)&&(void 0===c||e.forced===c)&&(void 0===a||Vo(a,e.characteristics))&&(void 0===i||i(t,e))}function Vo(t,e=""){const i=t.split(","),s=e.split(",");return i.length===s.length&&!i.some((t=>-1===s.indexOf(t)))}function Ho(t,e){const{audioCodec:i,channels:s}=t;return(void 0===i||(e.audioCodec||"").substring(0,4)===i.substring(0,4))&&(void 0===s||s===(e.channels||"2"))}function zo(t,e,i,s,n){const r=e[s],o=e.reduce(((t,e,i)=>{const s=e.uri,n=t[s]||(t[s]=[]);return n.push(i),t}),{}),a=o[r.uri];a.length>1&&(s=Math.max.apply(Math,a));const l=r.videoRange,c=r.frameRate,d=r.codecSet.substring(0,4),u=Ko(e,s,(e=>{if(e.videoRange!==l||e.frameRate!==c||e.codecSet.substring(0,4)!==d)return!1;const s=e.audioGroups,r=i.filter((t=>!s||-1!==s.indexOf(t.groupId)));return qo(t,r,n)>-1}));return u>-1?u:Ko(e,s,(e=>{const s=e.audioGroups,r=i.filter((t=>!s||-1!==s.indexOf(t.groupId)));return qo(t,r,n)>-1}))}function Ko(t,e,i){for(let s=e;s>-1;s--)if(i(t[s]))return s;for(let s=e+1;s<t.length;s++)if(i(t[s]))return s;return-1}class Wo{constructor(t){this.hls=void 0,this.lastLevelLoadSec=0,this.lastLoadedFragLevel=-1,this.firstSelection=-1,this._nextAutoLevel=-1,this.nextAutoLevelKey="",this.audioTracksByGroup=null,this.codecTiers=null,this.timer=-1,this.fragCurrent=null,this.partCurrent=null,this.bitrateTestDelay=0,this.bwEstimator=void 0,this._abandonRulesCheck=()=>{const{fragCurrent:t,partCurrent:e,hls:i}=this,{autoLevelEnabled:s,media:n}=i;if(!t||!n)return;const r=performance.now(),o=e?e.stats:t.stats,a=e?e.duration:t.duration,l=r-o.loading.start,c=i.minAutoLevel;if(o.aborted||o.loaded&&o.loaded===o.total||t.level<=c)return this.clearTimer(),void(this._nextAutoLevel=-1);if(!s||n.paused||!n.playbackRate||!n.readyState)return;const d=i.mainForwardBufferInfo;if(null===d)return;const u=this.bwEstimator.getEstimateTTFB(),h=Math.abs(n.playbackRate);if(l<=Math.max(u,a/(2*h)*1e3))return;const p=d.len/h,f=o.loading.first?o.loading.first-o.loading.start:-1,m=o.loaded&&f>-1,v=this.getBwEstimate(),g=i.levels,y=g[t.level],b=o.total||Math.max(o.loaded,Math.round(a*y.averageBitrate/8));let w=m?l-f:l;w<1&&m&&(w=Math.min(l,8*o.loaded/v));const S=m?1e3*o.loaded/w:0,E=S?(b-o.loaded)/S:8*b/v+u/1e3;if(E<=p)return;const T=S?8*S:v;let x,C=Number.POSITIVE_INFINITY;for(x=t.level-1;x>c;x--){const t=g[x].maxBitrate;if(C=this.getTimeToLoadFrag(u/1e3,T,a*t,!g[x].details),C<p)break}if(C>=E)return;if(C>10*a)return;i.nextLoadLevel=i.nextAutoLevel=x,m?this.bwEstimator.sample(l-Math.min(u,f),o.loaded):this.bwEstimator.sampleTTFB(l);const _=g[x].maxBitrate;this.getBwEstimate()*this.hls.config.abrBandWidthUpFactor>_&&this.resetEstimator(_),this.clearTimer(),as.warn(`[abr] Fragment ${t.sn}${e?" part "+e.index:""} of level ${t.level} is loading too slowly;\n      Time to underbuffer: ${p.toFixed(3)} s\n      Estimated load time for current fragment: ${E.toFixed(3)} s\n      Estimated load time for down switch fragment: ${C.toFixed(3)} s\n      TTFB estimate: ${0|f} ms\n      Current BW estimate: ${Yi(v)?0|v:"Unknown"} bps\n      New BW estimate: ${0|this.getBwEstimate()} bps\n      Switching to level ${x} @ ${0|_} bps`),i.trigger(Qi.FRAG_LOAD_EMERGENCY_ABORTED,{frag:t,part:e,stats:o})},this.hls=t,this.bwEstimator=this.initEstimator(),this.registerListeners()}resetEstimator(t){t&&(as.log(`setting initial bwe to ${t}`),this.hls.config.abrEwmaDefaultEstimate=t),this.firstSelection=-1,this.bwEstimator=this.initEstimator()}initEstimator(){const t=this.hls.config;return new Ro(t.abrEwmaSlowVoD,t.abrEwmaFastVoD,t.abrEwmaDefaultEstimate)}registerListeners(){const{hls:t}=this;t.on(Qi.MANIFEST_LOADING,this.onManifestLoading,this),t.on(Qi.FRAG_LOADING,this.onFragLoading,this),t.on(Qi.FRAG_LOADED,this.onFragLoaded,this),t.on(Qi.FRAG_BUFFERED,this.onFragBuffered,this),t.on(Qi.LEVEL_SWITCHING,this.onLevelSwitching,this),t.on(Qi.LEVEL_LOADED,this.onLevelLoaded,this),t.on(Qi.LEVELS_UPDATED,this.onLevelsUpdated,this),t.on(Qi.MAX_AUTO_LEVEL_UPDATED,this.onMaxAutoLevelUpdated,this),t.on(Qi.ERROR,this.onError,this)}unregisterListeners(){const{hls:t}=this;t&&(t.off(Qi.MANIFEST_LOADING,this.onManifestLoading,this),t.off(Qi.FRAG_LOADING,this.onFragLoading,this),t.off(Qi.FRAG_LOADED,this.onFragLoaded,this),t.off(Qi.FRAG_BUFFERED,this.onFragBuffered,this),t.off(Qi.LEVEL_SWITCHING,this.onLevelSwitching,this),t.off(Qi.LEVEL_LOADED,this.onLevelLoaded,this),t.off(Qi.LEVELS_UPDATED,this.onLevelsUpdated,this),t.off(Qi.MAX_AUTO_LEVEL_UPDATED,this.onMaxAutoLevelUpdated,this),t.off(Qi.ERROR,this.onError,this))}destroy(){this.unregisterListeners(),this.clearTimer(),this.hls=this._abandonRulesCheck=null,this.fragCurrent=this.partCurrent=null}onManifestLoading(t,e){this.lastLoadedFragLevel=-1,this.firstSelection=-1,this.lastLevelLoadSec=0,this.fragCurrent=this.partCurrent=null,this.onLevelsUpdated(),this.clearTimer()}onLevelsUpdated(){this.lastLoadedFragLevel>-1&&this.fragCurrent&&(this.lastLoadedFragLevel=this.fragCurrent.level),this._nextAutoLevel=-1,this.onMaxAutoLevelUpdated(),this.codecTiers=null,this.audioTracksByGroup=null}onMaxAutoLevelUpdated(){this.firstSelection=-1,this.nextAutoLevelKey=""}onFragLoading(t,e){const i=e.frag;if(!this.ignoreFragment(i)){var s;if(!i.bitrateTest)this.fragCurrent=i,this.partCurrent=null!=(s=e.part)?s:null;this.clearTimer(),this.timer=self.setInterval(this._abandonRulesCheck,100)}}onLevelSwitching(t,e){this.clearTimer()}onError(t,e){if(!e.fatal)switch(e.details){case ts.BUFFER_ADD_CODEC_ERROR:case ts.BUFFER_APPEND_ERROR:this.lastLoadedFragLevel=-1,this.firstSelection=-1;break;case ts.FRAG_LOAD_TIMEOUT:{const t=e.frag,{fragCurrent:i,partCurrent:s}=this;if(t&&i&&t.sn===i.sn&&t.level===i.level){const e=performance.now(),i=s?s.stats:t.stats,n=e-i.loading.start,r=i.loading.first?i.loading.first-i.loading.start:-1,o=i.loaded&&r>-1;if(o){const t=this.bwEstimator.getEstimateTTFB();this.bwEstimator.sample(n-Math.min(t,r),i.loaded)}else this.bwEstimator.sampleTTFB(n)}break}}}getTimeToLoadFrag(t,e,i,s){const n=t+i/e,r=s?this.lastLevelLoadSec:0;return n+r}onLevelLoaded(t,e){const i=this.hls.config,{loading:s}=e.stats,n=s.end-s.start;Yi(n)&&(this.lastLevelLoadSec=n/1e3),e.details.live?this.bwEstimator.update(i.abrEwmaSlowLive,i.abrEwmaFastLive):this.bwEstimator.update(i.abrEwmaSlowVoD,i.abrEwmaFastVoD)}onFragLoaded(t,{frag:e,part:i}){const s=i?i.stats:e.stats;if(e.type===Tr.MAIN&&this.bwEstimator.sampleTTFB(s.loading.first-s.loading.start),!this.ignoreFragment(e)){if(this.clearTimer(),e.level===this._nextAutoLevel&&(this._nextAutoLevel=-1),this.firstSelection=-1,this.hls.config.abrMaxWithRealBitrate){const t=i?i.duration:e.duration,n=this.hls.levels[e.level],r=(n.loaded?n.loaded.bytes:0)+s.loaded,o=(n.loaded?n.loaded.duration:0)+t;n.loaded={bytes:r,duration:o},n.realBitrate=Math.round(8*r/o)}if(e.bitrateTest){const t={stats:s,frag:e,part:i,id:e.type};this.onFragBuffered(Qi.FRAG_BUFFERED,t),e.bitrateTest=!1}else this.lastLoadedFragLevel=e.level}}onFragBuffered(t,e){const{frag:i,part:s}=e,n=null!=s&&s.stats.loaded?s.stats:i.stats;if(n.aborted)return;if(this.ignoreFragment(i))return;const r=n.parsing.end-n.loading.start-Math.min(n.loading.first-n.loading.start,this.bwEstimator.getEstimateTTFB());this.bwEstimator.sample(r,n.loaded),n.bwEstimate=this.getBwEstimate(),i.bitrateTest?this.bitrateTestDelay=r/1e3:this.bitrateTestDelay=0}ignoreFragment(t){return t.type!==Tr.MAIN||"initSegment"===t.sn}clearTimer(){this.timer>-1&&(self.clearInterval(this.timer),this.timer=-1)}get firstAutoLevel(){const{maxAutoLevel:t,minAutoLevel:e}=this.hls,i=this.getBwEstimate(),s=this.hls.config.maxStarvationDelay,n=this.findBestLevel(i,e,t,0,s,1,1);if(n>-1)return n;const r=this.hls.firstLevel,o=Math.min(Math.max(r,e),t);return as.warn(`[abr] Could not find best starting auto level. Defaulting to first in playlist ${r} clamped to ${o}`),o}get forcedAutoLevel(){return this.nextAutoLevelKey?-1:this._nextAutoLevel}get nextAutoLevel(){const t=this.forcedAutoLevel,e=this.bwEstimator,i=e.canEstimate(),s=this.lastLoadedFragLevel>-1;if(-1!==t&&(!i||!s||this.nextAutoLevelKey===this.getAutoLevelKey()))return t;const n=i&&s?this.getNextABRAutoLevel():this.firstAutoLevel;if(-1!==t){const e=this.hls.levels;if(e.length>Math.max(t,n)&&e[t].loadError<=e[n].loadError)return t}return this._nextAutoLevel=n,this.nextAutoLevelKey=this.getAutoLevelKey(),n}getAutoLevelKey(){return`${this.getBwEstimate()}_${this.getStarvationDelay().toFixed(2)}`}getNextABRAutoLevel(){const{fragCurrent:t,partCurrent:e,hls:i}=this,{maxAutoLevel:s,config:n,minAutoLevel:r}=i,o=e?e.duration:t?t.duration:0,a=this.getBwEstimate(),l=this.getStarvationDelay();let c=n.abrBandWidthFactor,d=n.abrBandWidthUpFactor;if(l){const t=this.findBestLevel(a,r,s,l,0,c,d);if(t>=0)return t}let u=o?Math.min(o,n.maxStarvationDelay):n.maxStarvationDelay;if(!l){const t=this.bitrateTestDelay;if(t){const e=o?Math.min(o,n.maxLoadingDelay):n.maxLoadingDelay;u=e-t,as.info(`[abr] bitrate test took ${Math.round(1e3*t)}ms, set first fragment max fetchDuration to ${Math.round(1e3*u)} ms`),c=d=1}}const h=this.findBestLevel(a,r,s,l,u,c,d);if(as.info(`[abr] ${l?"rebuffering expected":"buffer is empty"}, optimal quality level ${h}`),h>-1)return h;const p=i.levels[r],f=i.levels[i.loadLevel];return(null==p?void 0:p.bitrate)<(null==f?void 0:f.bitrate)?r:i.loadLevel}getStarvationDelay(){const t=this.hls,e=t.media;if(!e)return 1/0;const i=e&&0!==e.playbackRate?Math.abs(e.playbackRate):1,s=t.mainForwardBufferInfo;return(s?s.len:0)/i}getBwEstimate(){return this.bwEstimator.canEstimate()?this.bwEstimator.getEstimate():this.hls.config.abrEwmaDefaultEstimate}findBestLevel(t,e,i,s,n,r,o){var a;const l=s+n,c=this.lastLoadedFragLevel,d=-1===c?this.hls.firstLevel:c,{fragCurrent:u,partCurrent:h}=this,{levels:p,allAudioTracks:f,loadLevel:m,config:v}=this.hls;if(1===p.length)return 0;const g=p[d],y=!(null==g||null==(a=g.details)||!a.live),b=-1===m||-1===c;let w,S="SDR",E=(null==g?void 0:g.frameRate)||0;const{audioPreference:T,videoPreference:x}=v,C=this.audioTracksByGroup||(this.audioTracksByGroup=Uo(f));if(b){if(-1!==this.firstSelection)return this.firstSelection;const s=this.codecTiers||(this.codecTiers=jo(p,C,e,i)),n=Bo(s,S,t,T,x),{codecSet:r,videoRanges:o,minFramerate:a,minBitrate:l,preferHDR:c}=n;w=r,S=c?o[o.length-1]:o[0],E=a,t=Math.max(t,l),as.log(`[abr] picked start tier ${JSON.stringify(n)}`)}else w=null==g?void 0:g.codecSet,S=null==g?void 0:g.videoRange;const _=h?h.duration:u?u.duration:0,k=this.bwEstimator.getEstimateTTFB()/1e3,L=[];for(let R=i;R>=e;R--){var A;const e=p[R],a=R>d;if(!e)continue;if(v.useMediaCapabilities&&!e.supportedResult&&!e.supportedPromise){const i=navigator.mediaCapabilities;"function"===typeof(null==i?void 0:i.decodingInfo)&&Po(e,C,S,E,t,T)?(e.supportedPromise=Oo(e,C,i),e.supportedPromise.then((t=>{if(!this.hls)return;e.supportedResult=t;const i=this.hls.levels,s=i.indexOf(e);t.error?as.warn(`[abr] MediaCapabilities decodingInfo error: "${t.error}" for level ${s} ${JSON.stringify(t)}`):t.supported||(as.warn(`[abr] Unsupported MediaCapabilities decodingInfo result for level ${s} ${JSON.stringify(t)}`),s>-1&&i.length>1&&(as.log(`[abr] Removing unsupported level ${s}`),this.hls.removeLevel(s)))}))):e.supportedResult=Io}if(w&&e.codecSet!==w||S&&e.videoRange!==S||a&&E>e.frameRate||!a&&E>0&&E<e.frameRate||e.supportedResult&&(null==(A=e.supportedResult.decodingInfoResults)||!A[0].smooth)){L.push(R);continue}const u=e.details,f=(h?null==u?void 0:u.partTarget:null==u?void 0:u.averagetargetduration)||_;let x;x=a?o*t:r*t;const I=_&&s>=2*_&&0===n?p[R].averageBitrate:p[R].maxBitrate,D=this.getTimeToLoadFrag(k,x,I*f,void 0===u),P=x>=I&&(R===c||0===e.loadError&&0===e.fragmentError)&&(D<=k||!Yi(D)||y&&!this.bitrateTestDelay||D<l);if(P){const t=this.forcedAutoLevel;return R===m||-1!==t&&t===m||(L.length&&as.trace(`[abr] Skipped level(s) ${L.join(",")} of ${i} max with CODECS and VIDEO-RANGE:"${p[L[0]].codecs}" ${p[L[0]].videoRange}; not compatible with "${g.codecs}" ${S}`),as.info(`[abr] switch candidate:${d}->${R} adjustedbw(${Math.round(x)})-bitrate=${Math.round(x-I)} ttfb:${k.toFixed(1)} avgDuration:${f.toFixed(1)} maxFetchDuration:${l.toFixed(1)} fetchDuration:${D.toFixed(1)} firstSelection:${b} codecSet:${w} videoRange:${S} hls.loadLevel:${m}`)),b&&(this.firstSelection=R),R}}return-1}set nextAutoLevel(t){const{maxAutoLevel:e,minAutoLevel:i}=this.hls,s=Math.min(Math.max(t,i),e);this._nextAutoLevel!==s&&(this.nextAutoLevelKey="",this._nextAutoLevel=s)}}class Yo{constructor(){this._boundTick=void 0,this._tickTimer=null,this._tickInterval=null,this._tickCallCount=0,this._boundTick=this.tick.bind(this)}destroy(){this.onHandlerDestroying(),this.onHandlerDestroyed()}onHandlerDestroying(){this.clearNextTick(),this.clearInterval()}onHandlerDestroyed(){}hasInterval(){return!!this._tickInterval}hasNextTick(){return!!this._tickTimer}setInterval(t){return!this._tickInterval&&(this._tickCallCount=0,this._tickInterval=self.setInterval(this._boundTick,t),!0)}clearInterval(){return!!this._tickInterval&&(self.clearInterval(this._tickInterval),this._tickInterval=null,!0)}clearNextTick(){return!!this._tickTimer&&(self.clearTimeout(this._tickTimer),this._tickTimer=null,!0)}tick(){this._tickCallCount++,1===this._tickCallCount&&(this.doTick(),this._tickCallCount>1&&this.tickImmediate(),this._tickCallCount=0)}tickImmediate(){this.clearNextTick(),this._tickTimer=self.setTimeout(this._boundTick,0)}doTick(){}}var Xo={NOT_LOADED:"NOT_LOADED",APPENDING:"APPENDING",PARTIAL:"PARTIAL",OK:"OK"};class Zo{constructor(t){this.activePartLists=Object.create(null),this.endListFragments=Object.create(null),this.fragments=Object.create(null),this.timeRanges=Object.create(null),this.bufferPadding=.2,this.hls=void 0,this.hasGaps=!1,this.hls=t,this._registerListeners()}_registerListeners(){const{hls:t}=this;t.on(Qi.BUFFER_APPENDED,this.onBufferAppended,this),t.on(Qi.FRAG_BUFFERED,this.onFragBuffered,this),t.on(Qi.FRAG_LOADED,this.onFragLoaded,this)}_unregisterListeners(){const{hls:t}=this;t.off(Qi.BUFFER_APPENDED,this.onBufferAppended,this),t.off(Qi.FRAG_BUFFERED,this.onFragBuffered,this),t.off(Qi.FRAG_LOADED,this.onFragLoaded,this)}destroy(){this._unregisterListeners(),this.fragments=this.activePartLists=this.endListFragments=this.timeRanges=null}getAppendedFrag(t,e){const i=this.activePartLists[e];if(i)for(let s=i.length;s--;){const e=i[s];if(!e)break;const n=e.end;if(e.start<=t&&null!==n&&t<=n)return e}return this.getBufferedFrag(t,e)}getBufferedFrag(t,e){const{fragments:i}=this,s=Object.keys(i);for(let n=s.length;n--;){const r=i[s[n]];if((null==r?void 0:r.body.type)===e&&r.buffered){const e=r.body;if(e.start<=t&&t<=e.end)return e}}return null}detectEvictedFragments(t,e,i,s){this.timeRanges&&(this.timeRanges[t]=e);const n=(null==s?void 0:s.fragment.sn)||-1;Object.keys(this.fragments).forEach((s=>{const r=this.fragments[s];if(!r)return;if(n>=r.body.sn)return;if(!r.buffered&&!r.loaded)return void(r.body.type===i&&this.removeFragment(r.body));const o=r.range[t];o&&o.time.some((t=>{const i=!this.isTimeBuffered(t.startPTS,t.endPTS,e);return i&&this.removeFragment(r.body),i}))}))}detectPartialFragments(t){const e=this.timeRanges,{frag:i,part:s}=t;if(!e||"initSegment"===i.sn)return;const n=Jo(i),r=this.fragments[n];if(!r||r.buffered&&i.gap)return;const o=!i.relurl;if(Object.keys(e).forEach((t=>{const n=i.elementaryStreams[t];if(!n)return;const a=e[t],l=o||!0===n.partial;r.range[t]=this.getBufferedTimes(i,s,l,a)})),r.loaded=null,Object.keys(r.range).length){r.buffered=!0;const t=r.body.endList=i.endList||r.body.endList;t&&(this.endListFragments[r.body.type]=r),Qo(r)||this.removeParts(i.sn-1,i.type)}else this.removeFragment(r.body)}removeParts(t,e){const i=this.activePartLists[e];i&&(this.activePartLists[e]=i.filter((e=>e.fragment.sn>=t)))}fragBuffered(t,e){const i=Jo(t);let s=this.fragments[i];!s&&e&&(s=this.fragments[i]={body:t,appendedPTS:null,loaded:null,buffered:!1,range:Object.create(null)},t.gap&&(this.hasGaps=!0)),s&&(s.loaded=null,s.buffered=!0)}getBufferedTimes(t,e,i,s){const n={time:[],partial:i},r=t.start,o=t.end,a=t.minEndPTS||o,l=t.maxStartPTS||r;for(let c=0;c<s.length;c++){const t=s.start(c)-this.bufferPadding,e=s.end(c)+this.bufferPadding;if(l>=t&&a<=e){n.time.push({startPTS:Math.max(r,s.start(c)),endPTS:Math.min(o,s.end(c))});break}if(r<e&&o>t){const t=Math.max(r,s.start(c)),e=Math.min(o,s.end(c));e>t&&(n.partial=!0,n.time.push({startPTS:t,endPTS:e}))}else if(o<=t)break}return n}getPartialFragment(t){let e,i,s,n=null,r=0;const{bufferPadding:o,fragments:a}=this;return Object.keys(a).forEach((l=>{const c=a[l];c&&Qo(c)&&(i=c.body.start-o,s=c.body.end+o,t>=i&&t<=s&&(e=Math.min(t-i,s-t),r<=e&&(n=c.body,r=e)))})),n}isEndListAppended(t){const e=this.endListFragments[t];return void 0!==e&&(e.buffered||Qo(e))}getState(t){const e=Jo(t),i=this.fragments[e];return i?i.buffered?Qo(i)?Xo.PARTIAL:Xo.OK:Xo.APPENDING:Xo.NOT_LOADED}isTimeBuffered(t,e,i){let s,n;for(let r=0;r<i.length;r++){if(s=i.start(r)-this.bufferPadding,n=i.end(r)+this.bufferPadding,t>=s&&e<=n)return!0;if(e<=s)return!1}return!1}onFragLoaded(t,e){const{frag:i,part:s}=e;if("initSegment"===i.sn||i.bitrateTest)return;const n=s?null:e,r=Jo(i);this.fragments[r]={body:i,appendedPTS:null,loaded:n,buffered:!1,range:Object.create(null)}}onBufferAppended(t,e){const{frag:i,part:s,timeRanges:n}=e;if("initSegment"===i.sn)return;const r=i.type;if(s){let t=this.activePartLists[r];t||(this.activePartLists[r]=t=[]),t.push(s)}this.timeRanges=n,Object.keys(n).forEach((t=>{const e=n[t];this.detectEvictedFragments(t,e,r,s)}))}onFragBuffered(t,e){this.detectPartialFragments(e)}hasFragment(t){const e=Jo(t);return!!this.fragments[e]}hasParts(t){var e;return!(null==(e=this.activePartLists[t])||!e.length)}removeFragmentsInRange(t,e,i,s,n){s&&!this.hasGaps||Object.keys(this.fragments).forEach((r=>{const o=this.fragments[r];if(!o)return;const a=o.body;a.type!==i||s&&!a.gap||a.start<e&&a.end>t&&(o.buffered||n)&&this.removeFragment(a)}))}removeFragment(t){const e=Jo(t);t.stats.loaded=0,t.clearElementaryStreamInfo();const i=this.activePartLists[t.type];if(i){const e=t.sn;this.activePartLists[t.type]=i.filter((t=>t.fragment.sn!==e))}delete this.fragments[e],t.endList&&delete this.endListFragments[t.type]}removeAllFragments(){this.fragments=Object.create(null),this.endListFragments=Object.create(null),this.activePartLists=Object.create(null),this.hasGaps=!1}}function Qo(t){var e,i,s;return t.buffered&&(t.body.gap||(null==(e=t.range.video)?void 0:e.partial)||(null==(i=t.range.audio)?void 0:i.partial)||(null==(s=t.range.audiovideo)?void 0:s.partial))}function Jo(t){return`${t.type}_${t.level}_${t.sn}`}const ta={length:0,start:()=>0,end:()=>0};class ea{static isBuffered(t,e){try{if(t){const i=ea.getBuffered(t);for(let t=0;t<i.length;t++)if(e>=i.start(t)&&e<=i.end(t))return!0}}catch(i){}return!1}static bufferInfo(t,e,i){try{if(t){const s=ea.getBuffered(t),n=[];let r;for(r=0;r<s.length;r++)n.push({start:s.start(r),end:s.end(r)});return this.bufferedInfo(n,e,i)}}catch(s){}return{len:0,start:e,end:e,nextStart:void 0}}static bufferedInfo(t,e,i){e=Math.max(0,e),t.sort((function(t,e){const i=t.start-e.start;return i||e.end-t.end}));let s=[];if(i)for(let l=0;l<t.length;l++){const e=s.length;if(e){const n=s[e-1].end;t[l].start-n<i?t[l].end>n&&(s[e-1].end=t[l].end):s.push(t[l])}else s.push(t[l])}else s=t;let n,r=0,o=e,a=e;for(let l=0;l<s.length;l++){const t=s[l].start,c=s[l].end;if(e+i>=t&&e<c)o=t,a=c,r=a-e;else if(e+i<t){n=t;break}}return{len:r,start:o||0,end:a||0,nextStart:n}}static getBuffered(t){try{return t.buffered}catch(e){return as.log("failed to get media.buffered",e),ta}}}class ia{constructor(t,e,i,s=0,n=-1,r=!1){this.level=void 0,this.sn=void 0,this.part=void 0,this.id=void 0,this.size=void 0,this.partial=void 0,this.transmuxing=sa(),this.buffering={audio:sa(),video:sa(),audiovideo:sa()},this.level=t,this.sn=e,this.id=i,this.size=s,this.part=n,this.partial=r}}function sa(){return{start:0,executeStart:0,executeEnd:0,end:0}}function na(t,e){for(let s=0,n=t.length;s<n;s++){var i;if((null==(i=t[s])?void 0:i.cc)===e)return t[s]}return null}function ra(t,e,i){return!(!e||!(i.endCC>i.startCC||t&&t.cc<i.startCC))}function oa(t,e){const i=t.fragments,s=e.fragments;if(!s.length||!i.length)return void as.log("No fragments to align");const n=na(i,s[0].cc);if(n&&(!n||n.startPTS))return n;as.log("No frag in previous level to align on")}function aa(t,e){if(t){const i=t.start+e;t.start=t.startPTS=i,t.endPTS=i+t.duration}}function la(t,e){const i=e.fragments;for(let s=0,n=i.length;s<n;s++)aa(i[s],t);e.fragmentHint&&aa(e.fragmentHint,t),e.alignedSliding=!0}function ca(t,e,i){e&&(da(t,i,e),!i.alignedSliding&&e&&ua(i,e),i.alignedSliding||!e||i.skippedSegments||no(e,i))}function da(t,e,i){if(ra(t,i,e)){const t=oa(i,e);t&&Yi(t.start)&&(as.log(`Adjusting PTS using last level due to CC increase within current level ${e.url}`),la(t.start,e))}}function ua(t,e){if(!t.hasProgramDateTime||!e.hasProgramDateTime)return;const i=t.fragments,s=e.fragments;if(!i.length||!s.length)return;let n,r;const o=Math.min(e.endCC,t.endCC);e.startCC<o&&t.startCC<o&&(n=na(s,o),r=na(i,o)),n&&r||(n=s[Math.floor(s.length/2)],r=na(i,n.cc)||i[Math.floor(i.length/2)]);const a=n.programDateTime,l=r.programDateTime;if(!a||!l)return;const c=(l-a)/1e3-(r.start-n.start);la(c,t)}const ha=Math.pow(2,17);class pa{constructor(t){this.config=void 0,this.loader=null,this.partLoadTimeout=-1,this.config=t}destroy(){this.loader&&(this.loader.destroy(),this.loader=null)}abort(){this.loader&&this.loader.abort()}load(t,e){const i=t.url;if(!i)return Promise.reject(new va({type:Ji.NETWORK_ERROR,details:ts.FRAG_LOAD_ERROR,fatal:!1,frag:t,error:new Error("Fragment does not have a "+(i?"part list":"url")),networkDetails:null}));this.abort();const s=this.config,n=s.fLoader,r=s.loader;return new Promise(((o,a)=>{if(this.loader&&this.loader.destroy(),t.gap){if(t.tagList.some((t=>"GAP"===t[0])))return void a(ma(t));t.gap=!1}const l=this.loader=t.loader=n?new n(s):new r(s),c=fa(t),d=mo(s.fragLoadPolicy.default),u={loadPolicy:d,timeout:d.maxLoadTimeMs,maxRetry:0,retryDelay:0,maxRetryDelay:0,highWaterMark:"initSegment"===t.sn?1/0:ha};t.stats=l.stats,l.load(c,u,{onSuccess:(e,i,s,n)=>{this.resetLoader(t,l);let r=e.data;s.resetIV&&t.decryptdata&&(t.decryptdata.iv=new Uint8Array(r.slice(0,16)),r=r.slice(16)),o({frag:t,part:null,payload:r,networkDetails:n})},onError:(e,s,n,r)=>{this.resetLoader(t,l),a(new va({type:Ji.NETWORK_ERROR,details:ts.FRAG_LOAD_ERROR,fatal:!1,frag:t,response:Vi({url:i,data:void 0},e),error:new Error(`HTTP Error ${e.code} ${e.text}`),networkDetails:n,stats:r}))},onAbort:(e,i,s)=>{this.resetLoader(t,l),a(new va({type:Ji.NETWORK_ERROR,details:ts.INTERNAL_ABORTED,fatal:!1,frag:t,error:new Error("Aborted"),networkDetails:s,stats:e}))},onTimeout:(e,i,s)=>{this.resetLoader(t,l),a(new va({type:Ji.NETWORK_ERROR,details:ts.FRAG_LOAD_TIMEOUT,fatal:!1,frag:t,error:new Error(`Timeout after ${u.timeout}ms`),networkDetails:s,stats:e}))},onProgress:(i,s,n,r)=>{e&&e({frag:t,part:null,payload:n,networkDetails:r})}})}))}loadPart(t,e,i){this.abort();const s=this.config,n=s.fLoader,r=s.loader;return new Promise(((o,a)=>{if(this.loader&&this.loader.destroy(),t.gap||e.gap)return void a(ma(t,e));const l=this.loader=t.loader=n?new n(s):new r(s),c=fa(t,e),d=mo(s.fragLoadPolicy.default),u={loadPolicy:d,timeout:d.maxLoadTimeMs,maxRetry:0,retryDelay:0,maxRetryDelay:0,highWaterMark:ha};e.stats=l.stats,l.load(c,u,{onSuccess:(s,n,r,a)=>{this.resetLoader(t,l),this.updateStatsFromPart(t,e);const c={frag:t,part:e,payload:s.data,networkDetails:a};i(c),o(c)},onError:(i,s,n,r)=>{this.resetLoader(t,l),a(new va({type:Ji.NETWORK_ERROR,details:ts.FRAG_LOAD_ERROR,fatal:!1,frag:t,part:e,response:Vi({url:c.url,data:void 0},i),error:new Error(`HTTP Error ${i.code} ${i.text}`),networkDetails:n,stats:r}))},onAbort:(i,s,n)=>{t.stats.aborted=e.stats.aborted,this.resetLoader(t,l),a(new va({type:Ji.NETWORK_ERROR,details:ts.INTERNAL_ABORTED,fatal:!1,frag:t,part:e,error:new Error("Aborted"),networkDetails:n,stats:i}))},onTimeout:(i,s,n)=>{this.resetLoader(t,l),a(new va({type:Ji.NETWORK_ERROR,details:ts.FRAG_LOAD_TIMEOUT,fatal:!1,frag:t,part:e,error:new Error(`Timeout after ${u.timeout}ms`),networkDetails:n,stats:i}))}})}))}updateStatsFromPart(t,e){const i=t.stats,s=e.stats,n=s.total;if(i.loaded+=s.loaded,n){const s=Math.round(t.duration/e.duration),r=Math.min(Math.round(i.loaded/n),s),o=s-r,a=o*Math.round(i.loaded/r);i.total=i.loaded+a}else i.total=Math.max(i.loaded,i.total);const r=i.loading,o=s.loading;r.start?r.first+=o.first-o.start:(r.start=o.start,r.first=o.first),r.end=o.end}resetLoader(t,e){t.loader=null,this.loader===e&&(self.clearTimeout(this.partLoadTimeout),this.loader=null),e.destroy()}}function fa(t,e=null){const i=e||t,s={frag:t,part:e,responseType:"arraybuffer",url:i.url,headers:{},rangeStart:0,rangeEnd:0},n=i.byteRangeStartOffset,r=i.byteRangeEndOffset;if(Yi(n)&&Yi(r)){var o;let e=n,i=r;if("initSegment"===t.sn&&"AES-128"===(null==(o=t.decryptdata)?void 0:o.method)){const t=r-n;t%16&&(i=r+(16-t%16)),0!==n&&(s.resetIV=!0,e=n-16)}s.rangeStart=e,s.rangeEnd=i}return s}function ma(t,e){const i=new Error(`GAP ${t.gap?"tag":"attribute"} found`),s={type:Ji.MEDIA_ERROR,details:ts.FRAG_GAP,fatal:!1,frag:t,error:i,networkDetails:null};return e&&(s.part=e),(e||t).stats.aborted=!0,new va(s)}class va extends Error{constructor(t){super(t.error.message),this.data=void 0,this.data=t}}class ga{constructor(t,e){this.subtle=void 0,this.aesIV=void 0,this.subtle=t,this.aesIV=e}decrypt(t,e){return this.subtle.decrypt({name:"AES-CBC",iv:this.aesIV},e,t)}}class ya{constructor(t,e){this.subtle=void 0,this.key=void 0,this.subtle=t,this.key=e}expandKey(){return this.subtle.importKey("raw",this.key,{name:"AES-CBC"},!1,["encrypt","decrypt"])}}function ba(t){const e=t.byteLength,i=e&&new DataView(t.buffer).getUint8(e-1);return i?Fs(t,0,e-i):t}class wa{constructor(){this.rcon=[0,1,2,4,8,16,32,64,128,27,54],this.subMix=[new Uint32Array(256),new Uint32Array(256),new Uint32Array(256),new Uint32Array(256)],this.invSubMix=[new Uint32Array(256),new Uint32Array(256),new Uint32Array(256),new Uint32Array(256)],this.sBox=new Uint32Array(256),this.invSBox=new Uint32Array(256),this.key=new Uint32Array(0),this.ksRows=0,this.keySize=0,this.keySchedule=void 0,this.invKeySchedule=void 0,this.initTable()}uint8ArrayToUint32Array_(t){const e=new DataView(t),i=new Uint32Array(4);for(let s=0;s<4;s++)i[s]=e.getUint32(4*s);return i}initTable(){const t=this.sBox,e=this.invSBox,i=this.subMix,s=i[0],n=i[1],r=i[2],o=i[3],a=this.invSubMix,l=a[0],c=a[1],d=a[2],u=a[3],h=new Uint32Array(256);let p=0,f=0,m=0;for(m=0;m<256;m++)h[m]=m<128?m<<1:m<<1^283;for(m=0;m<256;m++){let i=f^f<<1^f<<2^f<<3^f<<4;i=i>>>8^255&i^99,t[p]=i,e[i]=p;const a=h[p],m=h[a],v=h[m];let g=257*h[i]^16843008*i;s[p]=g<<24|g>>>8,n[p]=g<<16|g>>>16,r[p]=g<<8|g>>>24,o[p]=g,g=16843009*v^65537*m^257*a^16843008*p,l[i]=g<<24|g>>>8,c[i]=g<<16|g>>>16,d[i]=g<<8|g>>>24,u[i]=g,p?(p=a^h[h[h[v^a]]],f^=h[h[f]]):p=f=1}}expandKey(t){const e=this.uint8ArrayToUint32Array_(t);let i=!0,s=0;while(s<e.length&&i)i=e[s]===this.key[s],s++;if(i)return;this.key=e;const n=this.keySize=e.length;if(4!==n&&6!==n&&8!==n)throw new Error("Invalid aes key size="+n);const r=this.ksRows=4*(n+6+1);let o,a;const l=this.keySchedule=new Uint32Array(r),c=this.invKeySchedule=new Uint32Array(r),d=this.sBox,u=this.rcon,h=this.invSubMix,p=h[0],f=h[1],m=h[2],v=h[3];let g,y;for(o=0;o<r;o++)o<n?g=l[o]=e[o]:(y=g,o%n===0?(y=y<<8|y>>>24,y=d[y>>>24]<<24|d[y>>>16&255]<<16|d[y>>>8&255]<<8|d[255&y],y^=u[o/n|0]<<24):n>6&&o%n===4&&(y=d[y>>>24]<<24|d[y>>>16&255]<<16|d[y>>>8&255]<<8|d[255&y]),l[o]=g=(l[o-n]^y)>>>0);for(a=0;a<r;a++)o=r-a,y=3&a?l[o]:l[o-4],c[a]=a<4||o<=4?y:p[d[y>>>24]]^f[d[y>>>16&255]]^m[d[y>>>8&255]]^v[d[255&y]],c[a]=c[a]>>>0}networkToHostOrderSwap(t){return t<<24|(65280&t)<<8|(16711680&t)>>8|t>>>24}decrypt(t,e,i){const s=this.keySize+6,n=this.invKeySchedule,r=this.invSBox,o=this.invSubMix,a=o[0],l=o[1],c=o[2],d=o[3],u=this.uint8ArrayToUint32Array_(i);let h=u[0],p=u[1],f=u[2],m=u[3];const v=new Int32Array(t),g=new Int32Array(v.length);let y,b,w,S,E,T,x,C,_,k,L,A,R,I;const D=this.networkToHostOrderSwap;while(e<v.length){for(_=D(v[e]),k=D(v[e+1]),L=D(v[e+2]),A=D(v[e+3]),E=_^n[0],T=A^n[1],x=L^n[2],C=k^n[3],R=4,I=1;I<s;I++)y=a[E>>>24]^l[T>>16&255]^c[x>>8&255]^d[255&C]^n[R],b=a[T>>>24]^l[x>>16&255]^c[C>>8&255]^d[255&E]^n[R+1],w=a[x>>>24]^l[C>>16&255]^c[E>>8&255]^d[255&T]^n[R+2],S=a[C>>>24]^l[E>>16&255]^c[T>>8&255]^d[255&x]^n[R+3],E=y,T=b,x=w,C=S,R+=4;y=r[E>>>24]<<24^r[T>>16&255]<<16^r[x>>8&255]<<8^r[255&C]^n[R],b=r[T>>>24]<<24^r[x>>16&255]<<16^r[C>>8&255]<<8^r[255&E]^n[R+1],w=r[x>>>24]<<24^r[C>>16&255]<<16^r[E>>8&255]<<8^r[255&T]^n[R+2],S=r[C>>>24]<<24^r[E>>16&255]<<16^r[T>>8&255]<<8^r[255&x]^n[R+3],g[e]=D(y^h),g[e+1]=D(S^p),g[e+2]=D(w^f),g[e+3]=D(b^m),h=_,p=k,f=L,m=A,e+=4}return g.buffer}}const Sa=16;class Ea{constructor(t,{removePKCS7Padding:e=!0}={}){if(this.logEnabled=!0,this.removePKCS7Padding=void 0,this.subtle=null,this.softwareDecrypter=null,this.key=null,this.fastAesKey=null,this.remainderData=null,this.currentIV=null,this.currentResult=null,this.useSoftware=void 0,this.useSoftware=t.enableSoftwareAES,this.removePKCS7Padding=e,e)try{const t=self.crypto;t&&(this.subtle=t.subtle||t.webkitSubtle)}catch(i){}this.useSoftware=!this.subtle}destroy(){this.subtle=null,this.softwareDecrypter=null,this.key=null,this.fastAesKey=null,this.remainderData=null,this.currentIV=null,this.currentResult=null}isSync(){return this.useSoftware}flush(){const{currentResult:t,remainderData:e}=this;if(!t||e)return this.reset(),null;const i=new Uint8Array(t);return this.reset(),this.removePKCS7Padding?ba(i):i}reset(){this.currentResult=null,this.currentIV=null,this.remainderData=null,this.softwareDecrypter&&(this.softwareDecrypter=null)}decrypt(t,e,i){return this.useSoftware?new Promise(((s,n)=>{this.softwareDecrypt(new Uint8Array(t),e,i);const r=this.flush();r?s(r.buffer):n(new Error("[softwareDecrypt] Failed to decrypt data"))})):this.webCryptoDecrypt(new Uint8Array(t),e,i)}softwareDecrypt(t,e,i){const{currentIV:s,currentResult:n,remainderData:r}=this;this.logOnce("JS AES decrypt"),r&&(t=kn(r,t),this.remainderData=null);const o=this.getValidChunk(t);if(!o.length)return null;s&&(i=s);let a=this.softwareDecrypter;a||(a=this.softwareDecrypter=new wa),a.expandKey(e);const l=n;return this.currentResult=a.decrypt(o.buffer,0,i),this.currentIV=Fs(o,-16).buffer,l||null}webCryptoDecrypt(t,e,i){if(this.key!==e||!this.fastAesKey){if(!this.subtle)return Promise.resolve(this.onWebCryptoError(t,e,i));this.key=e,this.fastAesKey=new ya(this.subtle,e)}return this.fastAesKey.expandKey().then((e=>{if(!this.subtle)return Promise.reject(new Error("web crypto not initialized"));this.logOnce("WebCrypto AES decrypt");const s=new ga(this.subtle,new Uint8Array(i));return s.decrypt(t.buffer,e)})).catch((s=>(as.warn(`[decrypter]: WebCrypto Error, disable WebCrypto API, ${s.name}: ${s.message}`),this.onWebCryptoError(t,e,i))))}onWebCryptoError(t,e,i){this.useSoftware=!0,this.logEnabled=!0,this.softwareDecrypt(t,e,i);const s=this.flush();if(s)return s.buffer;throw new Error("WebCrypto and softwareDecrypt: failed to decrypt data")}getValidChunk(t){let e=t;const i=t.length-t.length%Sa;return i!==t.length&&(e=Fs(t,0,i),this.remainderData=Fs(t,i)),e}logOnce(t){this.logEnabled&&(as.log(`[decrypter]: ${t}`),this.logEnabled=!1)}}const Ta={toString:function(t){let e="";const i=t.length;for(let s=0;s<i;s++)e+=`[${t.start(s).toFixed(3)}-${t.end(s).toFixed(3)}]`;return e}},xa={STOPPED:"STOPPED",IDLE:"IDLE",KEY_LOADING:"KEY_LOADING",FRAG_LOADING:"FRAG_LOADING",FRAG_LOADING_WAITING_RETRY:"FRAG_LOADING_WAITING_RETRY",WAITING_TRACK:"WAITING_TRACK",PARSING:"PARSING",PARSED:"PARSED",ENDED:"ENDED",ERROR:"ERROR",WAITING_INIT_PTS:"WAITING_INIT_PTS",WAITING_LEVEL:"WAITING_LEVEL"};class Ca extends Yo{constructor(t,e,i,s,n){super(),this.hls=void 0,this.fragPrevious=null,this.fragCurrent=null,this.fragmentTracker=void 0,this.transmuxer=null,this._state=xa.STOPPED,this.playlistType=void 0,this.media=null,this.mediaBuffer=null,this.config=void 0,this.bitrateTest=!1,this.lastCurrentTime=0,this.nextLoadPosition=0,this.startPosition=0,this.startTimeOffset=null,this.loadedmetadata=!1,this.retryDate=0,this.levels=null,this.fragmentLoader=void 0,this.keyLoader=void 0,this.levelLastLoaded=null,this.startFragRequested=!1,this.decrypter=void 0,this.initPTS=[],this.buffering=!0,this.onvseeking=null,this.onvended=null,this.logPrefix="",this.log=void 0,this.warn=void 0,this.playlistType=n,this.logPrefix=s,this.log=as.log.bind(as,`${s}:`),this.warn=as.warn.bind(as,`${s}:`),this.hls=t,this.fragmentLoader=new pa(t.config),this.keyLoader=i,this.fragmentTracker=e,this.config=t.config,this.decrypter=new Ea(t.config),t.on(Qi.MANIFEST_LOADED,this.onManifestLoaded,this)}doTick(){this.onTickEnd()}onTickEnd(){}startLoad(t){}stopLoad(){this.fragmentLoader.abort(),this.keyLoader.abort(this.playlistType);const t=this.fragCurrent;null!=t&&t.loader&&(t.abortRequests(),this.fragmentTracker.removeFragment(t)),this.resetTransmuxer(),this.fragCurrent=null,this.fragPrevious=null,this.clearInterval(),this.clearNextTick(),this.state=xa.STOPPED}pauseBuffering(){this.buffering=!1}resumeBuffering(){this.buffering=!0}_streamEnded(t,e){if(e.live||t.nextStart||!t.end||!this.media)return!1;const i=e.partList;if(null!=i&&i.length){const t=i[i.length-1],e=ea.isBuffered(this.media,t.start+t.duration/2);return e}const s=e.fragments[e.fragments.length-1].type;return this.fragmentTracker.isEndListAppended(s)}getLevelDetails(){var t;if(this.levels&&null!==this.levelLastLoaded)return null==(t=this.levelLastLoaded)?void 0:t.details}onMediaAttached(t,e){const i=this.media=this.mediaBuffer=e.media;this.onvseeking=this.onMediaSeeking.bind(this),this.onvended=this.onMediaEnded.bind(this),i.addEventListener("seeking",this.onvseeking),i.addEventListener("ended",this.onvended);const s=this.config;this.levels&&s.autoStartLoad&&this.state===xa.STOPPED&&this.startLoad(s.startPosition)}onMediaDetaching(){const t=this.media;null!=t&&t.ended&&(this.log("MSE detaching and video ended, reset startPosition"),this.startPosition=this.lastCurrentTime=0),t&&this.onvseeking&&this.onvended&&(t.removeEventListener("seeking",this.onvseeking),t.removeEventListener("ended",this.onvended),this.onvseeking=this.onvended=null),this.keyLoader&&this.keyLoader.detach(),this.media=this.mediaBuffer=null,this.loadedmetadata=!1,this.fragmentTracker.removeAllFragments(),this.stopLoad()}onMediaSeeking(){const{config:t,fragCurrent:e,media:i,mediaBuffer:s,state:n}=this,r=i?i.currentTime:0,o=ea.bufferInfo(s||i,r,t.maxBufferHole);if(this.log(`media seeking to ${Yi(r)?r.toFixed(3):r}, state: ${n}`),this.state===xa.ENDED)this.resetLoadingState();else if(e){const i=t.maxFragLookUpTolerance,s=e.start-i,n=e.start+e.duration+i;if(!o.len||n<o.start||s>o.end){const t=r>n;(r<s||t)&&(t&&e.loader&&(this.log("seeking outside of buffer while fragment load in progress, cancel fragment load"),e.abortRequests(),this.resetLoadingState()),this.fragPrevious=null)}}i&&(this.fragmentTracker.removeFragmentsInRange(r,1/0,this.playlistType,!0),this.lastCurrentTime=r),this.loadedmetadata||o.len||(this.nextLoadPosition=this.startPosition=r),this.tickImmediate()}onMediaEnded(){this.startPosition=this.lastCurrentTime=0}onManifestLoaded(t,e){this.startTimeOffset=e.startTimeOffset,this.initPTS=[]}onHandlerDestroying(){this.hls.off(Qi.MANIFEST_LOADED,this.onManifestLoaded,this),this.stopLoad(),super.onHandlerDestroying(),this.hls=null}onHandlerDestroyed(){this.state=xa.STOPPED,this.fragmentLoader&&this.fragmentLoader.destroy(),this.keyLoader&&this.keyLoader.destroy(),this.decrypter&&this.decrypter.destroy(),this.hls=this.log=this.warn=this.decrypter=this.keyLoader=this.fragmentLoader=this.fragmentTracker=null,super.onHandlerDestroyed()}loadFragment(t,e,i){this._loadFragForPlayback(t,e,i)}_loadFragForPlayback(t,e,i){const s=e=>{if(this.fragContextChanged(t))return this.warn(`Fragment ${t.sn}${e.part?" p: "+e.part.index:""} of level ${t.level} was dropped during download.`),void this.fragmentTracker.removeFragment(t);t.stats.chunkCount++,this._handleFragmentLoadProgress(e)};this._doFragLoad(t,e,i,s).then((e=>{if(!e)return;const i=this.state;this.fragContextChanged(t)?(i===xa.FRAG_LOADING||!this.fragCurrent&&i===xa.PARSING)&&(this.fragmentTracker.removeFragment(t),this.state=xa.IDLE):("payload"in e&&(this.log(`Loaded fragment ${t.sn} of level ${t.level}`),this.hls.trigger(Qi.FRAG_LOADED,e)),this._handleFragmentLoadComplete(e))})).catch((e=>{this.state!==xa.STOPPED&&this.state!==xa.ERROR&&(this.warn(`Frag error: ${(null==e?void 0:e.message)||e}`),this.resetFragmentLoading(t))}))}clearTrackerIfNeeded(t){var e;const{fragmentTracker:i}=this,s=i.getState(t);if(s===Xo.APPENDING){const e=t.type,s=this.getFwdBufferInfo(this.mediaBuffer,e),n=Math.max(t.duration,s?s.len:this.config.maxBufferLength),r=this.backtrackFragment,o=r?t.sn-r.sn:0;(1===o||this.reduceMaxBufferLength(n,t.duration))&&i.removeFragment(t)}else 0===(null==(e=this.mediaBuffer)?void 0:e.buffered.length)?i.removeAllFragments():i.hasParts(t.type)&&(i.detectPartialFragments({frag:t,part:null,stats:t.stats,id:t.type}),i.getState(t)===Xo.PARTIAL&&i.removeFragment(t))}checkLiveUpdate(t){if(t.updated&&!t.live){const e=t.fragments[t.fragments.length-1];this.fragmentTracker.detectPartialFragments({frag:e,part:null,stats:e.stats,id:e.type})}t.fragments[0]||(t.deltaUpdateFailed=!0)}flushMainBuffer(t,e,i=null){if(!(t-e))return;const s={startOffset:t,endOffset:e,type:i};this.hls.trigger(Qi.BUFFER_FLUSHING,s)}_loadInitSegment(t,e){this._doFragLoad(t,e).then((e=>{if(!e||this.fragContextChanged(t)||!this.levels)throw new Error("init load aborted");return e})).then((e=>{const{hls:i}=this,{payload:s}=e,n=t.decryptdata;if(s&&s.byteLength>0&&null!=n&&n.key&&n.iv&&"AES-128"===n.method){const r=self.performance.now();return this.decrypter.decrypt(new Uint8Array(s),n.key.buffer,n.iv.buffer).catch((e=>{throw i.trigger(Qi.ERROR,{type:Ji.MEDIA_ERROR,details:ts.FRAG_DECRYPT_ERROR,fatal:!1,error:e,reason:e.message,frag:t}),e})).then((s=>{const n=self.performance.now();return i.trigger(Qi.FRAG_DECRYPTED,{frag:t,payload:s,stats:{tstart:r,tdecrypt:n}}),e.payload=s,this.completeInitSegmentLoad(e)}))}return this.completeInitSegmentLoad(e)})).catch((e=>{this.state!==xa.STOPPED&&this.state!==xa.ERROR&&(this.warn(e),this.resetFragmentLoading(t))}))}completeInitSegmentLoad(t){const{levels:e}=this;if(!e)throw new Error("init load aborted, missing levels");const i=t.frag.stats;this.state=xa.IDLE,t.frag.data=new Uint8Array(t.payload),i.parsing.start=i.buffering.start=self.performance.now(),i.parsing.end=i.buffering.end=self.performance.now(),this.tick()}fragContextChanged(t){const{fragCurrent:e}=this;return!t||!e||t.sn!==e.sn||t.level!==e.level}fragBufferedComplete(t,e){var i,s,n,r;const o=this.mediaBuffer?this.mediaBuffer:this.media;if(this.log(`Buffered ${t.type} sn: ${t.sn}${e?" part: "+e.index:""} of ${this.playlistType===Tr.MAIN?"level":"track"} ${t.level} (frag:[${(null!=(i=t.startPTS)?i:NaN).toFixed(3)}-${(null!=(s=t.endPTS)?s:NaN).toFixed(3)}] > buffer:${o?Ta.toString(ea.getBuffered(o)):"(detached)"})`),"initSegment"!==t.sn){var a;if(t.type!==Tr.SUBTITLE){const e=t.elementaryStreams;if(!Object.keys(e).some((t=>!!e[t])))return void(this.state=xa.IDLE)}const e=null==(a=this.levels)?void 0:a[t.level];null!=e&&e.fragmentError&&(this.log(`Resetting level fragment error count of ${e.fragmentError} on frag buffered`),e.fragmentError=0)}this.state=xa.IDLE,o&&(!this.loadedmetadata&&t.type==Tr.MAIN&&o.buffered.length&&(null==(n=this.fragCurrent)?void 0:n.sn)===(null==(r=this.fragPrevious)?void 0:r.sn)&&(this.loadedmetadata=!0,this.seekToStartPos()),this.tick())}seekToStartPos(){}_handleFragmentLoadComplete(t){const{transmuxer:e}=this;if(!e)return;const{frag:i,part:s,partsLoaded:n}=t,r=!n||0===n.length||n.some((t=>!t)),o=new ia(i.level,i.sn,i.stats.chunkCount+1,0,s?s.index:-1,!r);e.flush(o)}_handleFragmentLoadProgress(t){}_doFragLoad(t,e,i=null,s){var n;const r=null==e?void 0:e.details;if(!this.levels||!r)throw new Error(`frag load aborted, missing level${r?"":" detail"}s`);let o=null;if(!t.encrypted||null!=(n=t.decryptdata)&&n.key?!t.encrypted&&r.encryptedFragments.length&&this.keyLoader.loadClear(t,r.encryptedFragments):(this.log(`Loading key for ${t.sn} of [${r.startSN}-${r.endSN}], ${"[stream-controller]"===this.logPrefix?"level":"track"} ${t.level}`),this.state=xa.KEY_LOADING,this.fragCurrent=t,o=this.keyLoader.load(t).then((t=>{if(!this.fragContextChanged(t.frag))return this.hls.trigger(Qi.KEY_LOADED,t),this.state===xa.KEY_LOADING&&(this.state=xa.IDLE),t})),this.hls.trigger(Qi.KEY_LOADING,{frag:t}),null===this.fragCurrent&&(o=Promise.reject(new Error("frag load aborted, context changed in KEY_LOADING")))),i=Math.max(t.start,i||0),this.config.lowLatencyMode&&"initSegment"!==t.sn){const n=r.partList;if(n&&s){i>t.end&&r.fragmentHint&&(t=r.fragmentHint);const a=this.getNextPart(n,t,i);if(a>-1){const l=n[a];let c;return this.log(`Loading part sn: ${t.sn} p: ${l.index} cc: ${t.cc} of playlist [${r.startSN}-${r.endSN}] parts [0-${a}-${n.length-1}] ${"[stream-controller]"===this.logPrefix?"level":"track"}: ${t.level}, target: ${parseFloat(i.toFixed(3))}`),this.nextLoadPosition=l.start+l.duration,this.state=xa.FRAG_LOADING,c=o?o.then((i=>!i||this.fragContextChanged(i.frag)?null:this.doFragPartsLoad(t,l,e,s))).catch((t=>this.handleFragLoadError(t))):this.doFragPartsLoad(t,l,e,s).catch((t=>this.handleFragLoadError(t))),this.hls.trigger(Qi.FRAG_LOADING,{frag:t,part:l,targetBufferTime:i}),null===this.fragCurrent?Promise.reject(new Error("frag load aborted, context changed in FRAG_LOADING parts")):c}if(!t.url||this.loadedEndOfParts(n,i))return Promise.resolve(null)}}this.log(`Loading fragment ${t.sn} cc: ${t.cc} ${r?"of ["+r.startSN+"-"+r.endSN+"] ":""}${"[stream-controller]"===this.logPrefix?"level":"track"}: ${t.level}, target: ${parseFloat(i.toFixed(3))}`),Yi(t.sn)&&!this.bitrateTest&&(this.nextLoadPosition=t.start+t.duration),this.state=xa.FRAG_LOADING;const a=this.config.progressive;let l;return l=a&&o?o.then((e=>!e||this.fragContextChanged(null==e?void 0:e.frag)?null:this.fragmentLoader.load(t,s))).catch((t=>this.handleFragLoadError(t))):Promise.all([this.fragmentLoader.load(t,a?s:void 0),o]).then((([t])=>(!a&&t&&s&&s(t),t))).catch((t=>this.handleFragLoadError(t))),this.hls.trigger(Qi.FRAG_LOADING,{frag:t,targetBufferTime:i}),null===this.fragCurrent?Promise.reject(new Error("frag load aborted, context changed in FRAG_LOADING")):l}doFragPartsLoad(t,e,i,s){return new Promise(((n,r)=>{var o;const a=[],l=null==(o=i.details)?void 0:o.partList,c=e=>{this.fragmentLoader.loadPart(t,e,s).then((s=>{a[e.index]=s;const r=s.part;this.hls.trigger(Qi.FRAG_LOADED,s);const o=lo(i,t.sn,e.index+1)||co(l,t.sn,e.index+1);if(!o)return n({frag:t,part:r,partsLoaded:a});c(o)})).catch(r)};c(e)}))}handleFragLoadError(t){if("data"in t){const e=t.data;t.data&&e.details===ts.INTERNAL_ABORTED?this.handleFragLoadAborted(e.frag,e.part):this.hls.trigger(Qi.ERROR,e)}else this.hls.trigger(Qi.ERROR,{type:Ji.OTHER_ERROR,details:ts.INTERNAL_EXCEPTION,err:t,error:t,fatal:!0});return null}_handleTransmuxerFlush(t){const e=this.getCurrentContext(t);if(!e||this.state!==xa.PARSING)return void(this.fragCurrent||this.state===xa.STOPPED||this.state===xa.ERROR||(this.state=xa.IDLE));const{frag:i,part:s,level:n}=e,r=self.performance.now();i.stats.parsing.end=r,s&&(s.stats.parsing.end=r),this.updateLevelTiming(i,s,n,t.partial)}getCurrentContext(t){const{levels:e,fragCurrent:i}=this,{level:s,sn:n,part:r}=t;if(null==e||!e[s])return this.warn(`Levels object was unset while buffering fragment ${n} of level ${s}. The current chunk will not be buffered.`),null;const o=e[s],a=r>-1?lo(o,n,r):null,l=a?a.fragment:ao(o,n,i);return l?(i&&i!==l&&(l.stats=i.stats),{frag:l,part:a,level:o}):null}bufferFragmentData(t,e,i,s,n){var r;if(!t||this.state!==xa.PARSING)return;const{data1:o,data2:a}=t;let l=o;if(o&&a&&(l=kn(o,a)),null==(r=l)||!r.length)return;const c={type:t.type,frag:e,part:i,chunkMeta:s,parent:e.type,data:l};if(this.hls.trigger(Qi.BUFFER_APPENDING,c),t.dropped&&t.independent&&!i){if(n)return;this.flushBufferGap(e)}}flushBufferGap(t){const e=this.media;if(!e)return;if(!ea.isBuffered(e,e.currentTime))return void this.flushMainBuffer(0,t.start);const i=e.currentTime,s=ea.bufferInfo(e,i,0),n=t.duration,r=Math.min(2*this.config.maxFragLookUpTolerance,.25*n),o=Math.max(Math.min(t.start-r,s.end-r),i+r);t.start-o>r&&this.flushMainBuffer(o,t.start)}getFwdBufferInfo(t,e){const i=this.getLoadPosition();return Yi(i)?this.getFwdBufferInfoAtPos(t,i,e):null}getFwdBufferInfoAtPos(t,e,i){const{config:{maxBufferHole:s}}=this,n=ea.bufferInfo(t,e,s);if(0===n.len&&void 0!==n.nextStart){const r=this.fragmentTracker.getBufferedFrag(e,i);if(r&&n.nextStart<r.end)return ea.bufferInfo(t,e,Math.max(n.nextStart,s))}return n}getMaxBufferLength(t){const{config:e}=this;let i;return i=t?Math.max(8*e.maxBufferSize/t,e.maxBufferLength):e.maxBufferLength,Math.min(i,e.maxMaxBufferLength)}reduceMaxBufferLength(t,e){const i=this.config,s=Math.max(Math.min(t-e,i.maxBufferLength),e),n=Math.max(t-3*e,i.maxMaxBufferLength/2,s);return n>=s&&(i.maxMaxBufferLength=n,this.warn(`Reduce max buffer length to ${n}s`),!0)}getAppendedFrag(t,e=Tr.MAIN){const i=this.fragmentTracker.getAppendedFrag(t,Tr.MAIN);return i&&"fragment"in i?i.fragment:i}getNextFragment(t,e){const i=e.fragments,s=i.length;if(!s)return null;const{config:n}=this,r=i[0].start;let o;if(e.live){const a=n.initialLiveManifestSize;if(s<a)return this.warn(`Not enough fragments to start playback (have: ${s}, need: ${a})`),null;(!e.PTSKnown&&!this.startFragRequested&&-1===this.startPosition||t<r)&&(o=this.getInitialLiveFragment(e,i),this.startPosition=this.nextLoadPosition=o?this.hls.liveSyncPosition||o.start:t)}else t<=r&&(o=i[0]);if(!o){const i=n.lowLatencyMode?e.partEnd:e.fragmentEnd;o=this.getFragmentAtPosition(t,i,e)}return this.mapToInitFragWhenRequired(o)}isLoopLoading(t,e){const i=this.fragmentTracker.getState(t);return(i===Xo.OK||i===Xo.PARTIAL&&!!t.gap)&&this.nextLoadPosition>e}getNextFragmentLoopLoading(t,e,i,s,n){const r=t.gap,o=this.getNextFragment(this.nextLoadPosition,e);if(null===o)return o;if(t=o,r&&t&&!t.gap&&i.nextStart){const e=this.getFwdBufferInfoAtPos(this.mediaBuffer?this.mediaBuffer:this.media,i.nextStart,s);if(null!==e&&i.len+e.len>=n)return this.log(`buffer full after gaps in "${s}" playlist starting at sn: ${t.sn}`),null}return t}mapToInitFragWhenRequired(t){return null==t||!t.initSegment||null!=t&&t.initSegment.data||this.bitrateTest?t:t.initSegment}getNextPart(t,e,i){let s=-1,n=!1,r=!0;for(let o=0,a=t.length;o<a;o++){const a=t[o];if(r=r&&!a.independent,s>-1&&i<a.start)break;const l=a.loaded;l?s=-1:(n||a.independent||r)&&a.fragment===e&&(s=o),n=l}return s}loadedEndOfParts(t,e){const i=t[t.length-1];return i&&e>i.start&&i.loaded}getInitialLiveFragment(t,e){const i=this.fragPrevious;let s=null;if(i){if(t.hasProgramDateTime&&(this.log(`Live playlist, switching playlist, load frag with same PDT: ${i.programDateTime}`),s=bo(e,i.endProgramDateTime,this.config.maxFragLookUpTolerance)),!s){const n=i.sn+1;if(n>=t.startSN&&n<=t.endSN){const r=e[n-t.startSN];i.cc===r.cc&&(s=r,this.log(`Live playlist, switching playlist, load frag with next SN: ${s.sn}`))}s||(s=xo(e,i.cc),s&&this.log(`Live playlist, switching playlist, load frag with same CC: ${s.sn}`))}}else{const e=this.hls.liveSyncPosition;null!==e&&(s=this.getFragmentAtPosition(e,this.bitrateTest?t.fragmentEnd:t.edge,t))}return s}getFragmentAtPosition(t,e,i){const{config:s}=this;let{fragPrevious:n}=this,{fragments:r,endSN:o}=i;const{fragmentHint:a}=i,{maxFragLookUpTolerance:l}=s,c=i.partList,d=!!(s.lowLatencyMode&&null!=c&&c.length&&a);let u;if(d&&a&&!this.bitrateTest&&(r=r.concat(a),o=a.sn),t<e){const i=t>e-l?0:l;u=wo(n,r,t,i)}else u=r[r.length-1];if(u){const t=u.sn-i.startSN,e=this.fragmentTracker.getState(u);if((e===Xo.OK||e===Xo.PARTIAL&&u.gap)&&(n=u),n&&u.sn===n.sn&&(!d||c[0].fragment.sn>u.sn)){const e=n&&u.level===n.level;if(e){const e=r[t+1];u=u.sn<o&&this.fragmentTracker.getState(e)!==Xo.OK?e:null}}}return u}synchronizeToLiveEdge(t){const{config:e,media:i}=this;if(!i)return;const s=this.hls.liveSyncPosition,n=i.currentTime,r=t.fragments[0].start,o=t.edge,a=n>=r-e.maxFragLookUpTolerance&&n<=o;if(null!==s&&i.duration>s&&(n<s||!a)){const r=void 0!==e.liveMaxLatencyDuration?e.liveMaxLatencyDuration:e.liveMaxLatencyDurationCount*t.targetduration;(!a&&i.readyState<4||n<o-r)&&(this.loadedmetadata||(this.nextLoadPosition=s),i.readyState&&(this.warn(`Playback: ${n.toFixed(3)} is located too far from the end of live sliding playlist: ${o}, reset currentTime to : ${s.toFixed(3)}`),i.currentTime=s))}}alignPlaylists(t,e,i){const s=t.fragments.length;if(!s)return this.warn("No fragments in live playlist"),0;const n=t.fragments[0].start,r=!e,o=t.alignedSliding&&Yi(n);if(r||!o&&!n){const{fragPrevious:n}=this;ca(n,i,t);const r=t.fragments[0].start;return this.log(`Live playlist sliding: ${r.toFixed(2)} start-sn: ${e?e.startSN:"na"}->${t.startSN} prev-sn: ${n?n.sn:"na"} fragments: ${s}`),r}return n}waitForCdnTuneIn(t){const e=3;return t.live&&t.canBlockReload&&t.partTarget&&t.tuneInGoal>Math.max(t.partHoldBack,t.partTarget*e)}setStartPosition(t,e){let i=this.startPosition;if(i<e&&(i=-1),-1===i||-1===this.lastCurrentTime){const s=null!==this.startTimeOffset,n=s?this.startTimeOffset:t.startTimeOffset;null!==n&&Yi(n)?(i=e+n,n<0&&(i+=t.totalduration),i=Math.min(Math.max(e,i),e+t.totalduration),this.log(`Start time offset ${n} found in ${s?"multivariant":"media"} playlist, adjust startPosition to ${i}`),this.startPosition=i):t.live?i=this.hls.liveSyncPosition||e:this.startPosition=i=0,this.lastCurrentTime=i}this.nextLoadPosition=i}getLoadPosition(){const{media:t}=this;let e=0;return this.loadedmetadata&&t?e=t.currentTime:this.nextLoadPosition&&(e=this.nextLoadPosition),e}handleFragLoadAborted(t,e){this.transmuxer&&"initSegment"!==t.sn&&t.stats.aborted&&(this.warn(`Fragment ${t.sn}${e?" part "+e.index:""} of level ${t.level} was aborted`),this.resetFragmentLoading(t))}resetFragmentLoading(t){this.fragCurrent&&(this.fragContextChanged(t)||this.state===xa.FRAG_LOADING_WAITING_RETRY)||(this.state=xa.IDLE)}onFragmentOrKeyLoadError(t,e){if(e.chunkMeta&&!e.frag){const t=this.getCurrentContext(e.chunkMeta);t&&(e.frag=t.frag)}const i=e.frag;if(!i||i.type!==t||!this.levels)return;var s;if(this.fragContextChanged(i))return void this.warn(`Frag load error must match current frag to retry ${i.url} > ${null==(s=this.fragCurrent)?void 0:s.url}`);const n=e.details===ts.FRAG_GAP;n&&this.fragmentTracker.fragBuffered(i,!0);const r=e.errorAction,{action:o,retryCount:a=0,retryConfig:l}=r||{};if(r&&o===Co.RetryRequest&&l){this.resetStartWhenNotLoaded(this.levelLastLoaded);const s=fo(l,a);this.warn(`Fragment ${i.sn} of ${t} ${i.level} errored with ${e.details}, retrying loading ${a+1}/${l.maxNumRetry} in ${s}ms`),r.resolved=!0,this.retryDate=self.performance.now()+s,this.state=xa.FRAG_LOADING_WAITING_RETRY}else if(l&&r){if(this.resetFragmentErrors(t),!(a<l.maxNumRetry))return void as.warn(`${e.details} reached or exceeded max retry (${a})`);n||o===Co.RemoveAlternatePermanently||(r.resolved=!0)}else(null==r?void 0:r.action)===Co.SendAlternateToPenaltyBox?this.state=xa.WAITING_LEVEL:this.state=xa.ERROR;this.tickImmediate()}reduceLengthAndFlushBuffer(t){if(this.state===xa.PARSING||this.state===xa.PARSED){const e=t.frag,i=t.parent,s=this.getFwdBufferInfo(this.mediaBuffer,i),n=s&&s.len>.5;n&&this.reduceMaxBufferLength(s.len,(null==e?void 0:e.duration)||10);const r=!n;return r&&this.warn(`Buffer full error while media.currentTime is not buffered, flush ${i} buffer`),e&&(this.fragmentTracker.removeFragment(e),this.nextLoadPosition=e.start),this.resetLoadingState(),r}return!1}resetFragmentErrors(t){t===Tr.AUDIO&&(this.fragCurrent=null),this.loadedmetadata||(this.startFragRequested=!1),this.state!==xa.STOPPED&&(this.state=xa.IDLE)}afterBufferFlushed(t,e,i){if(!t)return;const s=ea.getBuffered(t);this.fragmentTracker.detectEvictedFragments(e,s,i),this.state===xa.ENDED&&this.resetLoadingState()}resetLoadingState(){this.log("Reset loading state"),this.fragCurrent=null,this.fragPrevious=null,this.state=xa.IDLE}resetStartWhenNotLoaded(t){if(!this.loadedmetadata){this.startFragRequested=!1;const e=t?t.details:null;null!=e&&e.live?(this.startPosition=-1,this.setStartPosition(e,0),this.resetLoadingState()):this.nextLoadPosition=this.startPosition}}resetWhenMissingContext(t){this.warn(`The loading context changed while buffering fragment ${t.sn} of level ${t.level}. This chunk will not be buffered.`),this.removeUnbufferedFrags(),this.resetStartWhenNotLoaded(this.levelLastLoaded),this.resetLoadingState()}removeUnbufferedFrags(t=0){this.fragmentTracker.removeFragmentsInRange(t,1/0,this.playlistType,!1,!0)}updateLevelTiming(t,e,i,s){var n;const r=i.details;if(!r)return void this.warn("level.details undefined");const o=Object.keys(t.elementaryStreams).reduce(((e,n)=>{const o=t.elementaryStreams[n];if(o){const a=o.endPTS-o.startPTS;if(a<=0)return this.warn(`Could not parse fragment ${t.sn} ${n} duration reliably (${a})`),e||!1;const l=s?0:Jr(r,t,o.startPTS,o.endPTS,o.startDTS,o.endDTS);return this.hls.trigger(Qi.LEVEL_PTS_UPDATED,{details:r,level:i,drift:l,type:n,frag:t,start:o.startPTS,end:o.endPTS}),!0}return e}),!1);if(!o&&null===(null==(n=this.transmuxer)?void 0:n.error)){const e=new Error(`Found no media in fragment ${t.sn} of level ${t.level} resetting transmuxer to fallback to playlist timing`);if(0===i.fragmentError&&(i.fragmentError++,t.gap=!0,this.fragmentTracker.removeFragment(t),this.fragmentTracker.fragBuffered(t,!0)),this.warn(e.message),this.hls.trigger(Qi.ERROR,{type:Ji.MEDIA_ERROR,details:ts.FRAG_PARSING_ERROR,fatal:!1,error:e,frag:t,reason:`Found no media in msn ${t.sn} of level "${i.url}"`}),!this.hls)return;this.resetTransmuxer()}this.state=xa.PARSED,this.hls.trigger(Qi.FRAG_PARSED,{frag:t,part:e})}resetTransmuxer(){this.transmuxer&&(this.transmuxer.destroy(),this.transmuxer=null)}recoverWorkerError(t){"demuxerWorker"===t.event&&(this.fragmentTracker.removeAllFragments(),this.resetTransmuxer(),this.resetStartWhenNotLoaded(this.levelLastLoaded),this.resetLoadingState())}set state(t){const e=this._state;e!==t&&(this._state=t,this.log(`${e}->${t}`))}get state(){return this._state}}class _a{constructor(){this.chunks=[],this.dataLength=0}push(t){this.chunks.push(t),this.dataLength+=t.length}flush(){const{chunks:t,dataLength:e}=this;let i;return t.length?(i=1===t.length?t[0]:ka(t,e),this.reset(),i):new Uint8Array(0)}reset(){this.chunks.length=0,this.dataLength=0}}function ka(t,e){const i=new Uint8Array(e);let s=0;for(let n=0;n<t.length;n++){const e=t[n];i.set(e,s),s+=e.length}return i}function La(){return"function"===typeof __HLS_WORKER_BUNDLE__}function Aa(){const t=new self.Blob([`var exports={};var module={exports:exports};function define(f){f()};define.amd=true;(${__HLS_WORKER_BUNDLE__.toString()})(true);`],{type:"text/javascript"}),e=self.URL.createObjectURL(t),i=new self.Worker(e);return{worker:i,objectURL:e}}function Ra(t){const e=new self.URL(t,self.location.href).href,i=new self.Worker(e);return{worker:i,scriptURL:e}}function Ia(t="",e=9e4){return{type:t,id:-1,pid:-1,inputTimeScale:e,sequenceNumber:-1,samples:[],dropped:0}}class Da{constructor(){this._audioTrack=void 0,this._id3Track=void 0,this.frameIndex=0,this.cachedData=null,this.basePTS=null,this.initPTS=null,this.lastPTS=null}resetInitSegment(t,e,i,s){this._id3Track={type:"id3",id:3,pid:-1,inputTimeScale:9e4,sequenceNumber:0,samples:[],dropped:0}}resetTimeStamp(t){this.initPTS=t,this.resetContiguity()}resetContiguity(){this.basePTS=null,this.lastPTS=null,this.frameIndex=0}canParse(t,e){return!1}appendFrame(t,e,i){}demux(t,e){this.cachedData&&(t=kn(this.cachedData,t),this.cachedData=null);let i,s=Us(t,0),n=s?s.length:0;const r=this._audioTrack,o=this._id3Track,a=s?Gs(s):void 0,l=t.length;(null===this.basePTS||0===this.frameIndex&&Yi(a))&&(this.basePTS=Pa(a,e,this.initPTS),this.lastPTS=this.basePTS),null===this.lastPTS&&(this.lastPTS=this.basePTS),s&&s.length>0&&o.samples.push({pts:this.lastPTS,dts:this.lastPTS,data:s,type:Or.audioId3,duration:Number.POSITIVE_INFINITY});while(n<l){if(this.canParse(t,n)){const e=this.appendFrame(r,t,n);e?(this.frameIndex++,this.lastPTS=e.sample.pts,n+=e.length,i=n):n=l}else qs(t,n)?(s=Us(t,n),o.samples.push({pts:this.lastPTS,dts:this.lastPTS,data:s,type:Or.audioId3,duration:Number.POSITIVE_INFINITY}),n+=s.length,i=n):n++;if(n===l&&i!==l){const e=Fs(t,i);this.cachedData?this.cachedData=kn(this.cachedData,e):this.cachedData=e}}return{audioTrack:r,videoTrack:Ia(),id3Track:o,textTrack:Ia()}}demuxSampleAes(t,e,i){return Promise.reject(new Error(`[${this}] This demuxer does not support Sample-AES decryption`))}flush(t){const e=this.cachedData;return e&&(this.cachedData=null,this.demux(e,0)),{audioTrack:this._audioTrack,videoTrack:Ia(),id3Track:this._id3Track,textTrack:Ia()}}destroy(){}}const Pa=(t,e,i)=>{if(Yi(t))return 90*t;const s=i?9e4*i.baseTime/i.timescale:0;return 9e4*e+s};function Oa(t,e,i,s){let n,r,o,a;const l=navigator.userAgent.toLowerCase(),c=s,d=[96e3,88200,64e3,48e3,44100,32e3,24e3,22050,16e3,12e3,11025,8e3,7350];n=1+((192&e[i+2])>>>6);const u=(60&e[i+2])>>>2;if(!(u>d.length-1))return o=(1&e[i+2])<<2,o|=(192&e[i+3])>>>6,as.log(`manifest codec:${s}, ADTS type:${n}, samplingIndex:${u}`),/firefox/i.test(l)?u>=6?(n=5,a=new Array(4),r=u-3):(n=2,a=new Array(2),r=u):-1!==l.indexOf("android")?(n=2,a=new Array(2),r=u):(n=5,a=new Array(4),s&&(-1!==s.indexOf("mp4a.40.29")||-1!==s.indexOf("mp4a.40.5"))||!s&&u>=6?r=u-3:((s&&-1!==s.indexOf("mp4a.40.2")&&(u>=6&&1===o||/vivaldi/i.test(l))||!s&&1===o)&&(n=2,a=new Array(2)),r=u)),a[0]=n<<3,a[0]|=(14&u)>>1,a[1]|=(1&u)<<7,a[1]|=o<<3,5===n&&(a[1]|=(14&r)>>1,a[2]=(1&r)<<7,a[2]|=8,a[3]=0),{config:a,samplerate:d[u],channelCount:o,codec:"mp4a.40."+n,manifestCodec:c};{const e=new Error(`invalid ADTS sampling index:${u}`);t.emit(Qi.ERROR,Qi.ERROR,{type:Ji.MEDIA_ERROR,details:ts.FRAG_PARSING_ERROR,fatal:!0,error:e,reason:e.message})}}function Ma(t,e){return 255===t[e]&&240===(246&t[e+1])}function Na(t,e){return 1&t[e+1]?7:9}function Fa(t,e){return(3&t[e+3])<<11|t[e+4]<<3|(224&t[e+5])>>>5}function Ba(t,e){return e+5<t.length}function $a(t,e){return e+1<t.length&&Ma(t,e)}function Ua(t,e){return Ba(t,e)&&Ma(t,e)&&Fa(t,e)<=t.length-e}function ja(t,e){if($a(t,e)){const i=Na(t,e);if(e+i>=t.length)return!1;const s=Fa(t,e);if(s<=i)return!1;const n=e+s;return n===t.length||$a(t,n)}return!1}function qa(t,e,i,s,n){if(!t.samplerate){const r=Oa(e,i,s,n);if(!r)return;t.config=r.config,t.samplerate=r.samplerate,t.channelCount=r.channelCount,t.codec=r.codec,t.manifestCodec=r.manifestCodec,as.log(`parsed codec:${t.codec}, rate:${r.samplerate}, channels:${r.channelCount}`)}}function Ga(t){return 9216e4/t}function Va(t,e){const i=Na(t,e);if(e+i<=t.length){const s=Fa(t,e)-i;if(s>0)return{headerLength:i,frameLength:s}}}function Ha(t,e,i,s,n){const r=Ga(t.samplerate),o=s+n*r,a=Va(e,i);let l;if(a){const{frameLength:s,headerLength:n}=a,r=n+s,c=Math.max(0,i+r-e.length);c?(l=new Uint8Array(r-n),l.set(e.subarray(i+n,e.length),0)):l=e.subarray(i+n,i+r);const d={unit:l,pts:o};return c||t.samples.push(d),{sample:d,length:r,missing:c}}const c=e.length-i;l=new Uint8Array(c),l.set(e.subarray(i,e.length),0);const d={unit:l,pts:o};return{sample:d,length:c,missing:-1}}let za=null;const Ka=[32,64,96,128,160,192,224,256,288,320,352,384,416,448,32,48,56,64,80,96,112,128,160,192,224,256,320,384,32,40,48,56,64,80,96,112,128,160,192,224,256,320,32,48,56,64,80,96,112,128,144,160,176,192,224,256,8,16,24,32,40,48,56,64,80,96,112,128,144,160],Wa=[44100,48e3,32e3,22050,24e3,16e3,11025,12e3,8e3],Ya=[[0,72,144,12],[0,0,0,0],[0,72,144,12],[0,144,144,12]],Xa=[0,1,1,4];function Za(t,e,i,s,n){if(i+24>e.length)return;const r=Qa(e,i);if(r&&i+r.frameLength<=e.length){const o=9e4*r.samplesPerFrame/r.sampleRate,a=s+n*o,l={unit:e.subarray(i,i+r.frameLength),pts:a,dts:a};return t.config=[],t.channelCount=r.channelCount,t.samplerate=r.sampleRate,t.samples.push(l),{sample:l,length:r.frameLength,missing:0}}}function Qa(t,e){const i=t[e+1]>>3&3,s=t[e+1]>>1&3,n=t[e+2]>>4&15,r=t[e+2]>>2&3;if(1!==i&&0!==n&&15!==n&&3!==r){const o=t[e+2]>>1&1,a=t[e+3]>>6,l=3===i?3-s:3===s?3:4,c=1e3*Ka[14*l+n-1],d=3===i?0:2===i?1:2,u=Wa[3*d+r],h=3===a?1:2,p=Ya[i][s],f=Xa[s],m=8*p*f,v=Math.floor(p*c/u+o)*f;if(null===za){const t=navigator.userAgent||"",e=t.match(/Chrome\/(\d+)/i);za=e?parseInt(e[1]):0}const g=!!za&&za<=87;return g&&2===s&&c>=224e3&&0===a&&(t[e+3]=128|t[e+3]),{sampleRate:u,channelCount:h,frameLength:v,samplesPerFrame:m}}}function Ja(t,e){return 255===t[e]&&224===(224&t[e+1])&&0!==(6&t[e+1])}function tl(t,e){return e+1<t.length&&Ja(t,e)}function el(t,e){const i=4;return Ja(t,e)&&i<=t.length-e}function il(t,e){if(e+1<t.length&&Ja(t,e)){const i=4,s=Qa(t,e);let n=i;null!=s&&s.frameLength&&(n=s.frameLength);const r=e+n;return r===t.length||tl(t,r)}return!1}class sl extends Da{constructor(t,e){super(),this.observer=void 0,this.config=void 0,this.observer=t,this.config=e}resetInitSegment(t,e,i,s){super.resetInitSegment(t,e,i,s),this._audioTrack={container:"audio/adts",type:"audio",id:2,pid:-1,sequenceNumber:0,segmentCodec:"aac",samples:[],manifestCodec:e,duration:s,inputTimeScale:9e4,dropped:0}}static probe(t){if(!t)return!1;const e=Us(t,0);let i=(null==e?void 0:e.length)||0;if(il(t,i))return!1;for(let s=t.length;i<s;i++)if(ja(t,i))return as.log("ADTS sync word found !"),!0;return!1}canParse(t,e){return Ua(t,e)}appendFrame(t,e,i){qa(t,this.observer,e,i,t.manifestCodec);const s=Ha(t,e,i,this.basePTS,this.frameIndex);if(s&&0===s.missing)return s}}const nl=/\/emsg[-/]ID3/i;class rl{constructor(t,e){this.remainderData=null,this.timeOffset=0,this.config=void 0,this.videoTrack=void 0,this.audioTrack=void 0,this.id3Track=void 0,this.txtTrack=void 0,this.config=e}resetTimeStamp(){}resetInitSegment(t,e,i,s){const n=this.videoTrack=Ia("video",1),r=this.audioTrack=Ia("audio",1),o=this.txtTrack=Ia("text",1);if(this.id3Track=Ia("id3",1),this.timeOffset=0,null==t||!t.byteLength)return;const a=mn(t);if(a.video){const{id:t,timescale:e,codec:i}=a.video;n.id=t,n.timescale=o.timescale=e,n.codec=i}if(a.audio){const{id:t,timescale:e,codec:i}=a.audio;r.id=t,r.timescale=e,r.codec=i}o.id=rn.text,n.sampleDuration=0,n.duration=r.duration=s}resetContiguity(){this.remainderData=null}static probe(t){return hn(t)}demux(t,e){this.timeOffset=e;let i=t;const s=this.videoTrack,n=this.txtTrack;if(this.config.progressive){this.remainderData&&(i=kn(this.remainderData,t));const e=_n(i);this.remainderData=e.remainder,s.samples=e.valid||new Uint8Array}else s.samples=i;const r=this.extractID3Track(s,e);return n.samples=Ln(e,s),{videoTrack:s,audioTrack:this.audioTrack,id3Track:r,textTrack:this.txtTrack}}flush(){const t=this.timeOffset,e=this.videoTrack,i=this.txtTrack;e.samples=this.remainderData||new Uint8Array,this.remainderData=null;const s=this.extractID3Track(e,this.timeOffset);return i.samples=Ln(t,e),{videoTrack:e,audioTrack:Ia(),id3Track:s,textTrack:Ia()}}extractID3Track(t,e){const i=this.id3Track;if(t.samples.length){const s=pn(t.samples,["emsg"]);s&&s.forEach((t=>{const s=Pn(t);if(nl.test(s.schemeIdUri)){const t=Yi(s.presentationTime)?s.presentationTime/s.timeScale:e+s.presentationTimeDelta/s.timeScale;let n=4294967295===s.eventDuration?Number.POSITIVE_INFINITY:s.eventDuration/s.timeScale;n<=.001&&(n=Number.POSITIVE_INFINITY);const r=s.payload;i.samples.push({data:r,len:r.byteLength,dts:t,pts:t,type:Or.emsg,duration:n})}}))}return i}demuxSampleAes(t,e,i){return Promise.reject(new Error("The MP4 demuxer does not support SAMPLE-AES decryption"))}destroy(){}}const ol=(t,e)=>{let i=0,s=5;e+=s;const n=new Uint32Array(1),r=new Uint32Array(1),o=new Uint8Array(1);while(s>0){o[0]=t[e];const a=Math.min(s,8),l=8-a;r[0]=4278190080>>>24+l<<l,n[0]=(o[0]&r[0])>>l,i=i?i<<a|n[0]:n[0],e+=1,s-=a}return i};class al extends Da{constructor(t){super(),this.observer=void 0,this.observer=t}resetInitSegment(t,e,i,s){super.resetInitSegment(t,e,i,s),this._audioTrack={container:"audio/ac-3",type:"audio",id:2,pid:-1,sequenceNumber:0,segmentCodec:"ac3",samples:[],manifestCodec:e,duration:s,inputTimeScale:9e4,dropped:0}}canParse(t,e){return e+64<t.length}appendFrame(t,e,i){const s=ll(t,e,i,this.basePTS,this.frameIndex);if(-1!==s){const e=t.samples[t.samples.length-1];return{sample:e,length:s,missing:0}}}static probe(t){if(!t)return!1;const e=Us(t,0);if(!e)return!1;const i=e.length;return 11===t[i]&&119===t[i+1]&&void 0!==Gs(e)&&ol(t,i)<16}}function ll(t,e,i,s,n){if(i+8>e.length)return-1;if(11!==e[i]||119!==e[i+1])return-1;const r=e[i+4]>>6;if(r>=3)return-1;const o=[48e3,44100,32e3],a=o[r],l=63&e[i+4],c=[64,69,96,64,70,96,80,87,120,80,88,120,96,104,144,96,105,144,112,121,168,112,122,168,128,139,192,128,140,192,160,174,240,160,175,240,192,208,288,192,209,288,224,243,336,224,244,336,256,278,384,256,279,384,320,348,480,320,349,480,384,417,576,384,418,576,448,487,672,448,488,672,512,557,768,512,558,768,640,696,960,640,697,960,768,835,1152,768,836,1152,896,975,1344,896,976,1344,1024,1114,1536,1024,1115,1536,1152,1253,1728,1152,1254,1728,1280,1393,1920,1280,1394,1920],d=2*c[3*l+r];if(i+d>e.length)return-1;const u=e[i+6]>>5;let h=0;2===u?h+=2:(1&u&&1!==u&&(h+=2),4&u&&(h+=2));const p=(e[i+6]<<8|e[i+7])>>12-h&1,f=[2,1,2,3,3,4,4,5],m=f[u]+p,v=e[i+5]>>3,g=7&e[i+5],y=new Uint8Array([r<<6|v<<1|g>>2,(3&g)<<6|u<<3|p<<2|l>>4,l<<4&224]),b=1536/a*9e4,w=s+n*b,S=e.subarray(i,i+d);return t.config=y,t.channelCount=m,t.samplerate=a,t.samples.push({unit:S,pts:w}),d}class cl{constructor(){this.VideoSample=null}createVideoSample(t,e,i,s){return{key:t,frame:!1,pts:e,dts:i,units:[],debug:s,length:0}}getLastNalUnit(t){var e;let i,s=this.VideoSample;if(s&&0!==s.units.length||(s=t[t.length-1]),null!=(e=s)&&e.units){const t=s.units;i=t[t.length-1]}return i}pushAccessUnit(t,e){if(t.units.length&&t.frame){if(void 0===t.pts){const i=e.samples,s=i.length;if(!s)return void e.dropped++;{const e=i[s-1];t.pts=e.pts,t.dts=e.dts}}e.samples.push(t)}t.debug.length&&as.log(t.pts+"/"+t.dts+":"+t.debug)}}class dl{constructor(t){this.data=void 0,this.bytesAvailable=void 0,this.word=void 0,this.bitsAvailable=void 0,this.data=t,this.bytesAvailable=t.byteLength,this.word=0,this.bitsAvailable=0}loadWord(){const t=this.data,e=this.bytesAvailable,i=t.byteLength-e,s=new Uint8Array(4),n=Math.min(4,e);if(0===n)throw new Error("no bytes available");s.set(t.subarray(i,i+n)),this.word=new DataView(s.buffer).getUint32(0),this.bitsAvailable=8*n,this.bytesAvailable-=n}skipBits(t){let e;t=Math.min(t,8*this.bytesAvailable+this.bitsAvailable),this.bitsAvailable>t?(this.word<<=t,this.bitsAvailable-=t):(t-=this.bitsAvailable,e=t>>3,t-=e<<3,this.bytesAvailable-=e,this.loadWord(),this.word<<=t,this.bitsAvailable-=t)}readBits(t){let e=Math.min(this.bitsAvailable,t);const i=this.word>>>32-e;if(t>32&&as.error("Cannot read more than 32 bits at a time"),this.bitsAvailable-=e,this.bitsAvailable>0)this.word<<=e;else{if(!(this.bytesAvailable>0))throw new Error("no bits available");this.loadWord()}return e=t-e,e>0&&this.bitsAvailable?i<<e|this.readBits(e):i}skipLZ(){let t;for(t=0;t<this.bitsAvailable;++t)if(0!==(this.word&2147483648>>>t))return this.word<<=t,this.bitsAvailable-=t,t;return this.loadWord(),t+this.skipLZ()}skipUEG(){this.skipBits(1+this.skipLZ())}skipEG(){this.skipBits(1+this.skipLZ())}readUEG(){const t=this.skipLZ();return this.readBits(t+1)-1}readEG(){const t=this.readUEG();return 1&t?1+t>>>1:-1*(t>>>1)}readBoolean(){return 1===this.readBits(1)}readUByte(){return this.readBits(8)}readUShort(){return this.readBits(16)}readUInt(){return this.readBits(32)}skipScalingList(t){let e,i=8,s=8;for(let n=0;n<t;n++)0!==s&&(e=this.readEG(),s=(i+e+256)%256),i=0===s?i:s}readSPS(){let t,e,i,s=0,n=0,r=0,o=0;const a=this.readUByte.bind(this),l=this.readBits.bind(this),c=this.readUEG.bind(this),d=this.readBoolean.bind(this),u=this.skipBits.bind(this),h=this.skipEG.bind(this),p=this.skipUEG.bind(this),f=this.skipScalingList.bind(this);a();const m=a();if(l(5),u(3),a(),p(),100===m||110===m||122===m||244===m||44===m||83===m||86===m||118===m||128===m){const t=c();if(3===t&&u(1),p(),p(),u(1),d())for(e=3!==t?8:12,i=0;i<e;i++)d()&&f(i<6?16:64)}p();const v=c();if(0===v)c();else if(1===v)for(u(1),h(),h(),t=c(),i=0;i<t;i++)h();p(),u(1);const g=c(),y=c(),b=l(1);0===b&&u(1),u(1),d()&&(s=c(),n=c(),r=c(),o=c());let w=[1,1];if(d()&&d()){const t=a();switch(t){case 1:w=[1,1];break;case 2:w=[12,11];break;case 3:w=[10,11];break;case 4:w=[16,11];break;case 5:w=[40,33];break;case 6:w=[24,11];break;case 7:w=[20,11];break;case 8:w=[32,11];break;case 9:w=[80,33];break;case 10:w=[18,11];break;case 11:w=[15,11];break;case 12:w=[64,33];break;case 13:w=[160,99];break;case 14:w=[4,3];break;case 15:w=[3,2];break;case 16:w=[2,1];break;case 255:w=[a()<<8|a(),a()<<8|a()];break}}return{width:Math.ceil(16*(g+1)-2*s-2*n),height:(2-b)*(y+1)*16-(b?2:4)*(r+o),pixelRatio:w}}readSliceType(){return this.readUByte(),this.readUEG(),this.readUEG()}}class ul extends cl{parseAVCPES(t,e,i,s,n){const r=this.parseAVCNALu(t,i.data);let o,a=this.VideoSample,l=!1;i.data=null,a&&r.length&&!t.audFound&&(this.pushAccessUnit(a,t),a=this.VideoSample=this.createVideoSample(!1,i.pts,i.dts,"")),r.forEach((s=>{var r;switch(s.type){case 1:{let e=!1;o=!0;const n=s.data;if(l&&n.length>4){const t=new dl(n).readSliceType();2!==t&&4!==t&&7!==t&&9!==t||(e=!0)}var c;if(e)null!=(c=a)&&c.frame&&!a.key&&(this.pushAccessUnit(a,t),a=this.VideoSample=null);a||(a=this.VideoSample=this.createVideoSample(!0,i.pts,i.dts,"")),a.frame=!0,a.key=e;break}case 5:o=!0,null!=(r=a)&&r.frame&&!a.key&&(this.pushAccessUnit(a,t),a=this.VideoSample=null),a||(a=this.VideoSample=this.createVideoSample(!0,i.pts,i.dts,"")),a.key=!0,a.frame=!0;break;case 6:o=!0,In(s.data,1,i.pts,e.samples);break;case 7:{var d,u;o=!0,l=!0;const e=s.data,i=new dl(e),r=i.readSPS();if(!t.sps||t.width!==r.width||t.height!==r.height||(null==(d=t.pixelRatio)?void 0:d[0])!==r.pixelRatio[0]||(null==(u=t.pixelRatio)?void 0:u[1])!==r.pixelRatio[1]){t.width=r.width,t.height=r.height,t.pixelRatio=r.pixelRatio,t.sps=[e],t.duration=n;const i=e.subarray(1,4);let s="avc1.";for(let t=0;t<3;t++){let e=i[t].toString(16);e.length<2&&(e="0"+e),s+=e}t.codec=s}break}case 8:o=!0,t.pps=[s.data];break;case 9:o=!0,t.audFound=!0,a&&this.pushAccessUnit(a,t),a=this.VideoSample=this.createVideoSample(!1,i.pts,i.dts,"");break;case 12:o=!0;break;default:o=!1,a&&(a.debug+="unknown NAL "+s.type+" ");break}if(a&&o){const t=a.units;t.push(s)}})),s&&a&&(this.pushAccessUnit(a,t),this.VideoSample=null)}parseAVCNALu(t,e){const i=e.byteLength;let s=t.naluState||0;const n=s,r=[];let o,a,l,c=0,d=-1,u=0;-1===s&&(d=0,u=31&e[0],s=0,c=1);while(c<i)if(o=e[c++],s)if(1!==s)if(o)if(1===o){if(a=c-s-1,d>=0){const t={data:e.subarray(d,a),type:u};r.push(t)}else{const i=this.getLastNalUnit(t.samples);i&&(n&&c<=4-n&&i.state&&(i.data=i.data.subarray(0,i.data.byteLength-n)),a>0&&(i.data=kn(i.data,e.subarray(0,a)),i.state=0))}c<i?(l=31&e[c],d=c,u=l,s=0):s=-1}else s=0;else s=3;else s=o?0:2;else s=o?0:1;if(d>=0&&s>=0){const t={data:e.subarray(d,i),type:u,state:s};r.push(t)}if(0===r.length){const i=this.getLastNalUnit(t.samples);i&&(i.data=kn(i.data,e))}return t.naluState=s,r}}class hl{constructor(t,e,i){this.keyData=void 0,this.decrypter=void 0,this.keyData=i,this.decrypter=new Ea(e,{removePKCS7Padding:!1})}decryptBuffer(t){return this.decrypter.decrypt(t,this.keyData.key.buffer,this.keyData.iv.buffer)}decryptAacSample(t,e,i){const s=t[e].unit;if(s.length<=16)return;const n=s.subarray(16,s.length-s.length%16),r=n.buffer.slice(n.byteOffset,n.byteOffset+n.length);this.decryptBuffer(r).then((n=>{const r=new Uint8Array(n);s.set(r,16),this.decrypter.isSync()||this.decryptAacSamples(t,e+1,i)}))}decryptAacSamples(t,e,i){for(;;e++){if(e>=t.length)return void i();if(!(t[e].unit.length<32)&&(this.decryptAacSample(t,e,i),!this.decrypter.isSync()))return}}getAvcEncryptedData(t){const e=16*Math.floor((t.length-48)/160)+16,i=new Int8Array(e);let s=0;for(let n=32;n<t.length-16;n+=160,s+=16)i.set(t.subarray(n,n+16),s);return i}getAvcDecryptedUnit(t,e){const i=new Uint8Array(e);let s=0;for(let n=32;n<t.length-16;n+=160,s+=16)t.set(i.subarray(s,s+16),n);return t}decryptAvcSample(t,e,i,s,n){const r=Dn(n.data),o=this.getAvcEncryptedData(r);this.decryptBuffer(o.buffer).then((o=>{n.data=this.getAvcDecryptedUnit(r,o),this.decrypter.isSync()||this.decryptAvcSamples(t,e,i+1,s)}))}decryptAvcSamples(t,e,i,s){if(t instanceof Uint8Array)throw new Error("Cannot decrypt samples of type Uint8Array");for(;;e++,i=0){if(e>=t.length)return void s();const n=t[e].units;for(;;i++){if(i>=n.length)break;const r=n[i];if(!(r.data.length<=48||1!==r.type&&5!==r.type)&&(this.decryptAvcSample(t,e,i,s,r),!this.decrypter.isSync()))return}}}}const pl=188;class fl{constructor(t,e,i){this.observer=void 0,this.config=void 0,this.typeSupported=void 0,this.sampleAes=null,this.pmtParsed=!1,this.audioCodec=void 0,this.videoCodec=void 0,this._duration=0,this._pmtId=-1,this._videoTrack=void 0,this._audioTrack=void 0,this._id3Track=void 0,this._txtTrack=void 0,this.aacOverFlow=null,this.remainderData=null,this.videoParser=void 0,this.observer=t,this.config=e,this.typeSupported=i,this.videoParser=new ul}static probe(t){const e=fl.syncOffset(t);return e>0&&as.warn(`MPEG2-TS detected but first sync word found @ offset ${e}`),-1!==e}static syncOffset(t){const e=t.length;let i=Math.min(5*pl,e-pl)+1,s=0;while(s<i){let n=!1,r=-1,o=0;for(let a=s;a<e;a+=pl){if(71!==t[a]||e-a!==pl&&71!==t[a+pl]){if(o)return-1;break}if(o++,-1===r&&(r=a,0!==r&&(i=Math.min(r+99*pl,t.length-pl)+1)),n||(n=0===ml(t,a)),n&&o>1&&(0===r&&o>2||a+pl>i))return r}s++}return-1}static createTrack(t,e){return{container:"video"===t||"audio"===t?"video/mp2t":void 0,type:t,id:rn[t],pid:-1,inputTimeScale:9e4,sequenceNumber:0,samples:[],dropped:0,duration:"audio"===t?e:void 0}}resetInitSegment(t,e,i,s){this.pmtParsed=!1,this._pmtId=-1,this._videoTrack=fl.createTrack("video"),this._audioTrack=fl.createTrack("audio",s),this._id3Track=fl.createTrack("id3"),this._txtTrack=fl.createTrack("text"),this._audioTrack.segmentCodec="aac",this.aacOverFlow=null,this.remainderData=null,this.audioCodec=e,this.videoCodec=i,this._duration=s}resetTimeStamp(){}resetContiguity(){const{_audioTrack:t,_videoTrack:e,_id3Track:i}=this;t&&(t.pesData=null),e&&(e.pesData=null),i&&(i.pesData=null),this.aacOverFlow=null,this.remainderData=null}demux(t,e,i=!1,s=!1){let n;i||(this.sampleAes=null);const r=this._videoTrack,o=this._audioTrack,a=this._id3Track,l=this._txtTrack;let c=r.pid,d=r.pesData,u=o.pid,h=a.pid,p=o.pesData,f=a.pesData,m=null,v=this.pmtParsed,g=this._pmtId,y=t.length;if(this.remainderData&&(t=kn(this.remainderData,t),y=t.length,this.remainderData=null),y<pl&&!s)return this.remainderData=t,{audioTrack:o,videoTrack:r,id3Track:a,textTrack:l};const b=Math.max(0,fl.syncOffset(t));y-=(y-b)%pl,y<t.byteLength&&!s&&(this.remainderData=new Uint8Array(t.buffer,y,t.buffer.byteLength-y));let w=0;for(let E=b;E<y;E+=pl)if(71===t[E]){const e=!!(64&t[E+1]),s=ml(t,E),y=(48&t[E+3])>>4;let w;if(y>1){if(w=E+5+t[E+4],w===E+pl)continue}else w=E+4;switch(s){case c:e&&(d&&(n=wl(d))&&this.videoParser.parseAVCPES(r,l,n,!1,this._duration),d={data:[],size:0}),d&&(d.data.push(t.subarray(w,E+pl)),d.size+=E+pl-w);break;case u:if(e){if(p&&(n=wl(p)))switch(o.segmentCodec){case"aac":this.parseAACPES(o,n);break;case"mp3":this.parseMPEGPES(o,n);break;case"ac3":this.parseAC3PES(o,n);break}p={data:[],size:0}}p&&(p.data.push(t.subarray(w,E+pl)),p.size+=E+pl-w);break;case h:e&&(f&&(n=wl(f))&&this.parseID3PES(a,n),f={data:[],size:0}),f&&(f.data.push(t.subarray(w,E+pl)),f.size+=E+pl-w);break;case 0:e&&(w+=t[w]+1),g=this._pmtId=vl(t,w);break;case g:{e&&(w+=t[w]+1);const s=gl(t,w,this.typeSupported,i,this.observer);c=s.videoPid,c>0&&(r.pid=c,r.segmentCodec=s.segmentVideoCodec),u=s.audioPid,u>0&&(o.pid=u,o.segmentCodec=s.segmentAudioCodec),h=s.id3Pid,h>0&&(a.pid=h),null===m||v||(as.warn(`MPEG-TS PMT found at ${E} after unknown PID '${m}'. Backtracking to sync byte @${b} to parse all TS packets.`),m=null,E=b-188),v=this.pmtParsed=!0;break}case 17:case 8191:break;default:m=s;break}}else w++;w>0&&yl(this.observer,new Error(`Found ${w} TS packet/s that do not start with 0x47`)),r.pesData=d,o.pesData=p,a.pesData=f;const S={audioTrack:o,videoTrack:r,id3Track:a,textTrack:l};return s&&this.extractRemainingSamples(S),S}flush(){const{remainderData:t}=this;let e;return this.remainderData=null,e=t?this.demux(t,-1,!1,!0):{videoTrack:this._videoTrack,audioTrack:this._audioTrack,id3Track:this._id3Track,textTrack:this._txtTrack},this.extractRemainingSamples(e),this.sampleAes?this.decrypt(e,this.sampleAes):e}extractRemainingSamples(t){const{audioTrack:e,videoTrack:i,id3Track:s,textTrack:n}=t,r=i.pesData,o=e.pesData,a=s.pesData;let l;if(r&&(l=wl(r))?(this.videoParser.parseAVCPES(i,n,l,!0,this._duration),i.pesData=null):i.pesData=r,o&&(l=wl(o))){switch(e.segmentCodec){case"aac":this.parseAACPES(e,l);break;case"mp3":this.parseMPEGPES(e,l);break;case"ac3":this.parseAC3PES(e,l);break}e.pesData=null}else null!=o&&o.size&&as.log("last AAC PES packet truncated,might overlap between fragments"),e.pesData=o;a&&(l=wl(a))?(this.parseID3PES(s,l),s.pesData=null):s.pesData=a}demuxSampleAes(t,e,i){const s=this.demux(t,i,!0,!this.config.progressive),n=this.sampleAes=new hl(this.observer,this.config,e);return this.decrypt(s,n)}decrypt(t,e){return new Promise((i=>{const{audioTrack:s,videoTrack:n}=t;s.samples&&"aac"===s.segmentCodec?e.decryptAacSamples(s.samples,0,(()=>{n.samples?e.decryptAvcSamples(n.samples,0,0,(()=>{i(t)})):i(t)})):n.samples&&e.decryptAvcSamples(n.samples,0,0,(()=>{i(t)}))}))}destroy(){this._duration=0}parseAACPES(t,e){let i=0;const s=this.aacOverFlow;let n,r,o,a=e.data;if(s){this.aacOverFlow=null;const e=s.missing,n=s.sample.unit.byteLength;if(-1===e)a=kn(s.sample.unit,a);else{const r=n-e;s.sample.unit.set(a.subarray(0,e),r),t.samples.push(s.sample),i=s.missing}}for(n=i,r=a.length;n<r-1;n++)if($a(a,n))break;if(n!==i){let t;const e=n<r-1;if(t=e?`AAC PES did not start with ADTS header,offset:${n}`:"No ADTS header found in AAC PES",yl(this.observer,new Error(t),e),!e)return}if(qa(t,this.observer,a,n,this.audioCodec),void 0!==e.pts)o=e.pts;else{if(!s)return void as.warn("[tsdemuxer]: AAC PES unknown PTS");{const e=Ga(t.samplerate);o=s.sample.pts+e}}let l,c=0;while(n<r){if(l=Ha(t,a,n,o,c),n+=l.length,l.missing){this.aacOverFlow=l;break}for(c++;n<r-1;n++)if($a(a,n))break}}parseMPEGPES(t,e){const i=e.data,s=i.length;let n=0,r=0;const o=e.pts;if(void 0!==o)while(r<s)if(tl(i,r)){const e=Za(t,i,r,o,n);if(!e)break;r+=e.length,n++}else r++;else as.warn("[tsdemuxer]: MPEG PES unknown PTS")}parseAC3PES(t,e){{const i=e.data,s=e.pts;if(void 0===s)return void as.warn("[tsdemuxer]: AC3 PES unknown PTS");const n=i.length;let r,o=0,a=0;while(a<n&&(r=ll(t,i,a,s,o++))>0)a+=r}}parseID3PES(t,e){if(void 0===e.pts)return void as.warn("[tsdemuxer]: ID3 PES unknown PTS");const i=Wi({},e,{type:this._videoTrack?Or.emsg:Or.audioId3,duration:Number.POSITIVE_INFINITY});t.samples.push(i)}}function ml(t,e){return((31&t[e+1])<<8)+t[e+2]}function vl(t,e){return(31&t[e+10])<<8|t[e+11]}function gl(t,e,i,s,n){const r={audioPid:-1,videoPid:-1,id3Pid:-1,segmentVideoCodec:"avc",segmentAudioCodec:"aac"},o=(15&t[e+1])<<8|t[e+2],a=e+3+o-4,l=(15&t[e+10])<<8|t[e+11];e+=12+l;while(e<a){const o=ml(t,e),a=(15&t[e+3])<<8|t[e+4];switch(t[e]){case 207:if(!s){bl("ADTS AAC");break}case 15:-1===r.audioPid&&(r.audioPid=o);break;case 21:-1===r.id3Pid&&(r.id3Pid=o);break;case 219:if(!s){bl("H.264");break}case 27:-1===r.videoPid&&(r.videoPid=o,r.segmentVideoCodec="avc");break;case 3:case 4:i.mpeg||i.mp3?-1===r.audioPid&&(r.audioPid=o,r.segmentAudioCodec="mp3"):as.log("MPEG audio found, not supported in this browser");break;case 193:if(!s){bl("AC-3");break}case 129:i.ac3?-1===r.audioPid&&(r.audioPid=o,r.segmentAudioCodec="ac3"):as.log("AC-3 audio found, not supported in this browser");break;case 6:if(-1===r.audioPid&&a>0){let s=e+5,n=a;while(n>2){const e=t[s];switch(e){case 106:!0!==i.ac3?as.log("AC-3 audio found, not supported in this browser for now"):(r.audioPid=o,r.segmentAudioCodec="ac3");break}const a=t[s+1]+2;s+=a,n-=a}}break;case 194:case 135:return yl(n,new Error("Unsupported EC-3 in M2TS found")),r;case 36:return yl(n,new Error("Unsupported HEVC in M2TS found")),r}e+=a+5}return r}function yl(t,e,i){as.warn(`parsing error: ${e.message}`),t.emit(Qi.ERROR,Qi.ERROR,{type:Ji.MEDIA_ERROR,details:ts.FRAG_PARSING_ERROR,fatal:!1,levelRetry:i,error:e,reason:e.message})}function bl(t){as.log(`${t} with AES-128-CBC encryption found in unencrypted stream`)}function wl(t){let e,i,s,n,r,o=0;const a=t.data;if(!t||0===t.size)return null;while(a[0].length<19&&a.length>1)a[0]=kn(a[0],a[1]),a.splice(1,1);e=a[0];const l=(e[0]<<16)+(e[1]<<8)+e[2];if(1===l){if(i=(e[4]<<8)+e[5],i&&i>t.size-6)return null;const l=e[7];192&l&&(n=536870912*(14&e[9])+4194304*(255&e[10])+16384*(254&e[11])+128*(255&e[12])+(254&e[13])/2,64&l?(r=536870912*(14&e[14])+4194304*(255&e[15])+16384*(254&e[16])+128*(255&e[17])+(254&e[18])/2,n-r>54e5&&(as.warn(`${Math.round((n-r)/9e4)}s delta between PTS and DTS, align them`),n=r)):r=n),s=e[8];let c=s+9;if(t.size<=c)return null;t.size-=c;const d=new Uint8Array(t.size);for(let t=0,i=a.length;t<i;t++){e=a[t];let i=e.byteLength;if(c){if(c>i){c-=i;continue}e=e.subarray(c),i-=c,c=0}d.set(e,o),o+=i}return i&&(i-=s+3),{data:d,pts:n,dts:r,len:i}}return null}class Sl extends Da{resetInitSegment(t,e,i,s){super.resetInitSegment(t,e,i,s),this._audioTrack={container:"audio/mpeg",type:"audio",id:2,pid:-1,sequenceNumber:0,segmentCodec:"mp3",samples:[],manifestCodec:e,duration:s,inputTimeScale:9e4,dropped:0}}static probe(t){if(!t)return!1;const e=Us(t,0);let i=(null==e?void 0:e.length)||0;if(e&&11===t[i]&&119===t[i+1]&&void 0!==Gs(e)&&ol(t,i)<=16)return!1;for(let s=t.length;i<s;i++)if(il(t,i))return as.log("MPEG Audio sync word found !"),!0;return!1}canParse(t,e){return el(t,e)}appendFrame(t,e,i){if(null!==this.basePTS)return Za(t,e,i,this.basePTS,this.frameIndex)}}class El{static getSilentFrame(t,e){switch(t){case"mp4a.40.2":if(1===e)return new Uint8Array([0,200,0,128,35,128]);if(2===e)return new Uint8Array([33,0,73,144,2,25,0,35,128]);if(3===e)return new Uint8Array([0,200,0,128,32,132,1,38,64,8,100,0,142]);if(4===e)return new Uint8Array([0,200,0,128,32,132,1,38,64,8,100,0,128,44,128,8,2,56]);if(5===e)return new Uint8Array([0,200,0,128,32,132,1,38,64,8,100,0,130,48,4,153,0,33,144,2,56]);if(6===e)return new Uint8Array([0,200,0,128,32,132,1,38,64,8,100,0,130,48,4,153,0,33,144,2,0,178,0,32,8,224]);break;default:if(1===e)return new Uint8Array([1,64,34,128,163,78,230,128,186,8,0,0,0,28,6,241,193,10,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,94]);if(2===e)return new Uint8Array([1,64,34,128,163,94,230,128,186,8,0,0,0,0,149,0,6,241,161,10,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,94]);if(3===e)return new Uint8Array([1,64,34,128,163,94,230,128,186,8,0,0,0,0,149,0,6,241,161,10,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,90,94]);break}}}const Tl=Math.pow(2,32)-1;class xl{static init(){let t;for(t in xl.types={avc1:[],avcC:[],btrt:[],dinf:[],dref:[],esds:[],ftyp:[],hdlr:[],mdat:[],mdhd:[],mdia:[],mfhd:[],minf:[],moof:[],moov:[],mp4a:[],".mp3":[],dac3:[],"ac-3":[],mvex:[],mvhd:[],pasp:[],sdtp:[],stbl:[],stco:[],stsc:[],stsd:[],stsz:[],stts:[],tfdt:[],tfhd:[],traf:[],trak:[],trun:[],trex:[],tkhd:[],vmhd:[],smhd:[]},xl.types)xl.types.hasOwnProperty(t)&&(xl.types[t]=[t.charCodeAt(0),t.charCodeAt(1),t.charCodeAt(2),t.charCodeAt(3)]);const e=new Uint8Array([0,0,0,0,0,0,0,0,118,105,100,101,0,0,0,0,0,0,0,0,0,0,0,0,86,105,100,101,111,72,97,110,100,108,101,114,0]),i=new Uint8Array([0,0,0,0,0,0,0,0,115,111,117,110,0,0,0,0,0,0,0,0,0,0,0,0,83,111,117,110,100,72,97,110,100,108,101,114,0]);xl.HDLR_TYPES={video:e,audio:i};const s=new Uint8Array([0,0,0,0,0,0,0,1,0,0,0,12,117,114,108,32,0,0,0,1]),n=new Uint8Array([0,0,0,0,0,0,0,0]);xl.STTS=xl.STSC=xl.STCO=n,xl.STSZ=new Uint8Array([0,0,0,0,0,0,0,0,0,0,0,0]),xl.VMHD=new Uint8Array([0,0,0,1,0,0,0,0,0,0,0,0]),xl.SMHD=new Uint8Array([0,0,0,0,0,0,0,0]),xl.STSD=new Uint8Array([0,0,0,0,0,0,0,1]);const r=new Uint8Array([105,115,111,109]),o=new Uint8Array([97,118,99,49]),a=new Uint8Array([0,0,0,1]);xl.FTYP=xl.box(xl.types.ftyp,r,a,r,o),xl.DINF=xl.box(xl.types.dinf,xl.box(xl.types.dref,s))}static box(t,...e){let i=8,s=e.length;const n=s;while(s--)i+=e[s].byteLength;const r=new Uint8Array(i);for(r[0]=i>>24&255,r[1]=i>>16&255,r[2]=i>>8&255,r[3]=255&i,r.set(t,4),s=0,i=8;s<n;s++)r.set(e[s],i),i+=e[s].byteLength;return r}static hdlr(t){return xl.box(xl.types.hdlr,xl.HDLR_TYPES[t])}static mdat(t){return xl.box(xl.types.mdat,t)}static mdhd(t,e){e*=t;const i=Math.floor(e/(Tl+1)),s=Math.floor(e%(Tl+1));return xl.box(xl.types.mdhd,new Uint8Array([1,0,0,0,0,0,0,0,0,0,0,2,0,0,0,0,0,0,0,3,t>>24&255,t>>16&255,t>>8&255,255&t,i>>24,i>>16&255,i>>8&255,255&i,s>>24,s>>16&255,s>>8&255,255&s,85,196,0,0]))}static mdia(t){return xl.box(xl.types.mdia,xl.mdhd(t.timescale,t.duration),xl.hdlr(t.type),xl.minf(t))}static mfhd(t){return xl.box(xl.types.mfhd,new Uint8Array([0,0,0,0,t>>24,t>>16&255,t>>8&255,255&t]))}static minf(t){return"audio"===t.type?xl.box(xl.types.minf,xl.box(xl.types.smhd,xl.SMHD),xl.DINF,xl.stbl(t)):xl.box(xl.types.minf,xl.box(xl.types.vmhd,xl.VMHD),xl.DINF,xl.stbl(t))}static moof(t,e,i){return xl.box(xl.types.moof,xl.mfhd(t),xl.traf(i,e))}static moov(t){let e=t.length;const i=[];while(e--)i[e]=xl.trak(t[e]);return xl.box.apply(null,[xl.types.moov,xl.mvhd(t[0].timescale,t[0].duration)].concat(i).concat(xl.mvex(t)))}static mvex(t){let e=t.length;const i=[];while(e--)i[e]=xl.trex(t[e]);return xl.box.apply(null,[xl.types.mvex,...i])}static mvhd(t,e){e*=t;const i=Math.floor(e/(Tl+1)),s=Math.floor(e%(Tl+1)),n=new Uint8Array([1,0,0,0,0,0,0,0,0,0,0,2,0,0,0,0,0,0,0,3,t>>24&255,t>>16&255,t>>8&255,255&t,i>>24,i>>16&255,i>>8&255,255&i,s>>24,s>>16&255,s>>8&255,255&s,0,1,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,64,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,255,255,255,255]);return xl.box(xl.types.mvhd,n)}static sdtp(t){const e=t.samples||[],i=new Uint8Array(4+e.length);let s,n;for(s=0;s<e.length;s++)n=e[s].flags,i[s+4]=n.dependsOn<<4|n.isDependedOn<<2|n.hasRedundancy;return xl.box(xl.types.sdtp,i)}static stbl(t){return xl.box(xl.types.stbl,xl.stsd(t),xl.box(xl.types.stts,xl.STTS),xl.box(xl.types.stsc,xl.STSC),xl.box(xl.types.stsz,xl.STSZ),xl.box(xl.types.stco,xl.STCO))}static avc1(t){let e,i,s,n=[],r=[];for(e=0;e<t.sps.length;e++)i=t.sps[e],s=i.byteLength,n.push(s>>>8&255),n.push(255&s),n=n.concat(Array.prototype.slice.call(i));for(e=0;e<t.pps.length;e++)i=t.pps[e],s=i.byteLength,r.push(s>>>8&255),r.push(255&s),r=r.concat(Array.prototype.slice.call(i));const o=xl.box(xl.types.avcC,new Uint8Array([1,n[3],n[4],n[5],255,224|t.sps.length].concat(n).concat([t.pps.length]).concat(r))),a=t.width,l=t.height,c=t.pixelRatio[0],d=t.pixelRatio[1];return xl.box(xl.types.avc1,new Uint8Array([0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,a>>8&255,255&a,l>>8&255,255&l,0,72,0,0,0,72,0,0,0,0,0,0,0,1,18,100,97,105,108,121,109,111,116,105,111,110,47,104,108,115,46,106,115,0,0,0,0,0,0,0,0,0,0,0,0,0,0,24,17,17]),o,xl.box(xl.types.btrt,new Uint8Array([0,28,156,128,0,45,198,192,0,45,198,192])),xl.box(xl.types.pasp,new Uint8Array([c>>24,c>>16&255,c>>8&255,255&c,d>>24,d>>16&255,d>>8&255,255&d])))}static esds(t){const e=t.config.length;return new Uint8Array([0,0,0,0,3,23+e,0,1,0,4,15+e,64,21,0,0,0,0,0,0,0,0,0,0,0,5].concat([e]).concat(t.config).concat([6,1,2]))}static audioStsd(t){const e=t.samplerate;return new Uint8Array([0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,t.channelCount,0,16,0,0,0,0,e>>8&255,255&e,0,0])}static mp4a(t){return xl.box(xl.types.mp4a,xl.audioStsd(t),xl.box(xl.types.esds,xl.esds(t)))}static mp3(t){return xl.box(xl.types[".mp3"],xl.audioStsd(t))}static ac3(t){return xl.box(xl.types["ac-3"],xl.audioStsd(t),xl.box(xl.types.dac3,t.config))}static stsd(t){return"audio"===t.type?"mp3"===t.segmentCodec&&"mp3"===t.codec?xl.box(xl.types.stsd,xl.STSD,xl.mp3(t)):"ac3"===t.segmentCodec?xl.box(xl.types.stsd,xl.STSD,xl.ac3(t)):xl.box(xl.types.stsd,xl.STSD,xl.mp4a(t)):xl.box(xl.types.stsd,xl.STSD,xl.avc1(t))}static tkhd(t){const e=t.id,i=t.duration*t.timescale,s=t.width,n=t.height,r=Math.floor(i/(Tl+1)),o=Math.floor(i%(Tl+1));return xl.box(xl.types.tkhd,new Uint8Array([1,0,0,7,0,0,0,0,0,0,0,2,0,0,0,0,0,0,0,3,e>>24&255,e>>16&255,e>>8&255,255&e,0,0,0,0,r>>24,r>>16&255,r>>8&255,255&r,o>>24,o>>16&255,o>>8&255,255&o,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,64,0,0,0,s>>8&255,255&s,0,0,n>>8&255,255&n,0,0]))}static traf(t,e){const i=xl.sdtp(t),s=t.id,n=Math.floor(e/(Tl+1)),r=Math.floor(e%(Tl+1));return xl.box(xl.types.traf,xl.box(xl.types.tfhd,new Uint8Array([0,0,0,0,s>>24,s>>16&255,s>>8&255,255&s])),xl.box(xl.types.tfdt,new Uint8Array([1,0,0,0,n>>24,n>>16&255,n>>8&255,255&n,r>>24,r>>16&255,r>>8&255,255&r])),xl.trun(t,i.length+16+20+8+16+8+8),i)}static trak(t){return t.duration=t.duration||4294967295,xl.box(xl.types.trak,xl.tkhd(t),xl.mdia(t))}static trex(t){const e=t.id;return xl.box(xl.types.trex,new Uint8Array([0,0,0,0,e>>24,e>>16&255,e>>8&255,255&e,0,0,0,1,0,0,0,0,0,0,0,0,0,1,0,1]))}static trun(t,e){const i=t.samples||[],s=i.length,n=12+16*s,r=new Uint8Array(n);let o,a,l,c,d,u;for(e+=8+n,r.set(["video"===t.type?1:0,0,15,1,s>>>24&255,s>>>16&255,s>>>8&255,255&s,e>>>24&255,e>>>16&255,e>>>8&255,255&e],0),o=0;o<s;o++)a=i[o],l=a.duration,c=a.size,d=a.flags,u=a.cts,r.set([l>>>24&255,l>>>16&255,l>>>8&255,255&l,c>>>24&255,c>>>16&255,c>>>8&255,255&c,d.isLeading<<2|d.dependsOn,d.isDependedOn<<6|d.hasRedundancy<<4|d.paddingValue<<1|d.isNonSync,61440&d.degradPrio,15&d.degradPrio,u>>>24&255,u>>>16&255,u>>>8&255,255&u],12+16*o);return xl.box(xl.types.trun,r)}static initSegment(t){xl.types||xl.init();const e=xl.moov(t),i=kn(xl.FTYP,e);return i}}xl.types=void 0,xl.HDLR_TYPES=void 0,xl.STTS=void 0,xl.STSC=void 0,xl.STCO=void 0,xl.STSZ=void 0,xl.VMHD=void 0,xl.SMHD=void 0,xl.STSD=void 0,xl.FTYP=void 0,xl.DINF=void 0;const Cl=9e4;function _l(t,e,i=1,s=!1){const n=t*e*i;return s?Math.round(n):n}function kl(t,e,i=1,s=!1){return _l(t,e,1/i,s)}function Ll(t,e=!1){return _l(t,1e3,1/Cl,e)}function Al(t,e=1){return _l(t,Cl,1/e)}const Rl=1e4,Il=1024,Dl=1152,Pl=1536;let Ol,Ml=null,Nl=null;class Fl{constructor(t,e,i,s=""){if(this.observer=void 0,this.config=void 0,this.typeSupported=void 0,this.ISGenerated=!1,this._initPTS=null,this._initDTS=null,this.nextAvcDts=null,this.nextAudioPts=null,this.videoSampleDuration=null,this.isAudioContiguous=!1,this.isVideoContiguous=!1,this.videoTrackConfig=void 0,this.observer=t,this.config=e,this.typeSupported=i,this.ISGenerated=!1,null===Ml){const t=navigator.userAgent||"",e=t.match(/Chrome\/(\d+)/i);Ml=e?parseInt(e[1]):0}if(null===Nl){const t=navigator.userAgent.match(/Safari\/(\d+)/i);Nl=t?parseInt(t[1]):0}}destroy(){this.config=this.videoTrackConfig=this._initPTS=this._initDTS=null}resetTimeStamp(t){as.log("[mp4-remuxer]: initPTS & initDTS reset"),this._initPTS=this._initDTS=t}resetNextTimestamp(){as.log("[mp4-remuxer]: reset next timestamp"),this.isVideoContiguous=!1,this.isAudioContiguous=!1}resetInitSegment(){as.log("[mp4-remuxer]: ISGenerated flag reset"),this.ISGenerated=!1,this.videoTrackConfig=void 0}getVideoStartPts(t){let e=!1;const i=t[0].pts,s=t.reduce(((t,s)=>{let n=s.pts,r=n-t;return r<-4294967296&&(e=!0,n=Bl(n,i),r=n-t),r>0?t:n}),i);return e&&as.debug("PTS rollover detected"),s}remux(t,e,i,s,n,r,o,a){let l,c,d,u,h,p,f=n,m=n;const v=t.pid>-1,g=e.pid>-1,y=e.samples.length,b=t.samples.length>0,w=o&&y>0||y>1,S=(!v||b)&&(!g||w)||this.ISGenerated||o;if(S){if(this.ISGenerated){var E,T,x,C;const t=this.videoTrackConfig;!t||e.width===t.width&&e.height===t.height&&(null==(E=e.pixelRatio)?void 0:E[0])===(null==(T=t.pixelRatio)?void 0:T[0])&&(null==(x=e.pixelRatio)?void 0:x[1])===(null==(C=t.pixelRatio)?void 0:C[1])||this.resetInitSegment()}else d=this.generateIS(t,e,n,r);const i=this.isVideoContiguous;let s,o=-1;if(w&&(o=$l(e.samples),!i&&this.config.forceKeyFrameOnDiscontinuity))if(p=!0,o>0){as.warn(`[mp4-remuxer]: Dropped ${o} out of ${y} video samples due to a missing keyframe`);const t=this.getVideoStartPts(e.samples);e.samples=e.samples.slice(o),e.dropped+=o,m+=(e.samples[0].pts-t)/e.inputTimeScale,s=m}else-1===o&&(as.warn(`[mp4-remuxer]: No keyframe found out of ${y} video samples`),p=!1);if(this.ISGenerated){if(b&&w){const i=this.getVideoStartPts(e.samples),s=Bl(t.samples[0].pts,i)-i,n=s/e.inputTimeScale;f+=Math.max(0,n),m+=Math.max(0,-n)}if(b){if(t.samplerate||(as.warn("[mp4-remuxer]: regenerate InitSegment as audio detected"),d=this.generateIS(t,e,n,r)),c=this.remuxAudio(t,f,this.isAudioContiguous,r,g||w||a===Tr.AUDIO?m:void 0),w){const s=c?c.endPTS-c.startPTS:0;e.inputTimeScale||(as.warn("[mp4-remuxer]: regenerate InitSegment as video detected"),d=this.generateIS(t,e,n,r)),l=this.remuxVideo(e,m,i,s)}}else w&&(l=this.remuxVideo(e,m,i,0));l&&(l.firstKeyFrame=o,l.independent=-1!==o,l.firstKeyFramePTS=s)}}return this.ISGenerated&&this._initPTS&&this._initDTS&&(i.samples.length&&(h=Ul(i,n,this._initPTS,this._initDTS)),s.samples.length&&(u=jl(s,n,this._initPTS))),{audio:c,video:l,initSegment:d,independent:p,text:u,id3:h}}generateIS(t,e,i,s){const n=t.samples,r=e.samples,o=this.typeSupported,a={},l=this._initPTS;let c,d,u,h=!l||s,p="audio/mp4";if(h&&(c=d=1/0),t.config&&n.length){switch(t.timescale=t.samplerate,t.segmentCodec){case"mp3":o.mpeg?(p="audio/mpeg",t.codec=""):o.mp3&&(t.codec="mp3");break;case"ac3":t.codec="ac-3";break}a.audio={id:"audio",container:p,codec:t.codec,initSegment:"mp3"===t.segmentCodec&&o.mpeg?new Uint8Array(0):xl.initSegment([t]),metadata:{channelCount:t.channelCount}},h&&(u=t.inputTimeScale,l&&u===l.timescale?h=!1:c=d=n[0].pts-Math.round(u*i))}if(e.sps&&e.pps&&r.length){if(e.timescale=e.inputTimeScale,a.video={id:"main",container:"video/mp4",codec:e.codec,initSegment:xl.initSegment([e]),metadata:{width:e.width,height:e.height}},h)if(u=e.inputTimeScale,l&&u===l.timescale)h=!1;else{const t=this.getVideoStartPts(r),e=Math.round(u*i);d=Math.min(d,Bl(r[0].dts,t)-e),c=Math.min(c,t-e)}this.videoTrackConfig={width:e.width,height:e.height,pixelRatio:e.pixelRatio}}if(Object.keys(a).length)return this.ISGenerated=!0,h?(this._initPTS={baseTime:c,timescale:u},this._initDTS={baseTime:d,timescale:u}):c=u=void 0,{tracks:a,initPTS:c,timescale:u}}remuxVideo(t,e,i,s){const n=t.inputTimeScale,r=t.samples,o=[],a=r.length,l=this._initPTS;let c,d,u=this.nextAvcDts,h=8,p=this.videoSampleDuration,f=Number.POSITIVE_INFINITY,m=Number.NEGATIVE_INFINITY,v=!1;if(!i||null===u){const t=e*n,s=r[0].pts-Bl(r[0].dts,r[0].pts);Ml&&null!==u&&Math.abs(t-s-u)<15e3?i=!0:u=t-s}const g=l.baseTime*n/l.timescale;for(let M=0;M<a;M++){const t=r[M];t.pts=Bl(t.pts-g,u),t.dts=Bl(t.dts-g,u),t.dts<r[M>0?M-1:M].dts&&(v=!0)}v&&r.sort((function(t,e){const i=t.dts-e.dts,s=t.pts-e.pts;return i||s})),c=r[0].dts,d=r[r.length-1].dts;const y=d-c,b=y?Math.round(y/(a-1)):p||t.inputTimeScale/30;if(i){const t=c-u,i=t>b,s=t<-1;if((i||s)&&(i?as.warn(`AVC: ${Ll(t,!0)} ms (${t}dts) hole between fragments detected at ${e.toFixed(3)}`):as.warn(`AVC: ${Ll(-t,!0)} ms (${t}dts) overlapping between fragments detected at ${e.toFixed(3)}`),!s||u>=r[0].pts||Ml)){c=u;const e=r[0].pts-t;if(i)r[0].dts=c,r[0].pts=e;else for(let i=0;i<r.length;i++){if(r[i].dts>e)break;r[i].dts-=t,r[i].pts-=t}as.log(`Video: Initial PTS/DTS adjusted: ${Ll(e,!0)}/${Ll(c,!0)}, delta: ${Ll(t,!0)} ms`)}}c=Math.max(0,c);let w=0,S=0,E=c;for(let M=0;M<a;M++){const t=r[M],e=t.units,i=e.length;let s=0;for(let n=0;n<i;n++)s+=e[n].data.length;S+=s,w+=i,t.length=s,t.dts<E?(t.dts=E,E+=b/4|0||1):E=t.dts,f=Math.min(t.pts,f),m=Math.max(t.pts,m)}d=r[a-1].dts;const T=S+4*w+8;let x;try{x=new Uint8Array(T)}catch(O){return void this.observer.emit(Qi.ERROR,Qi.ERROR,{type:Ji.MUX_ERROR,details:ts.REMUX_ALLOC_ERROR,fatal:!1,error:O,bytes:T,reason:`fail allocating video mdat ${T}`})}const C=new DataView(x.buffer);C.setUint32(0,T),x.set(xl.types.mdat,4);let _=!1,k=Number.POSITIVE_INFINITY,L=Number.POSITIVE_INFINITY,A=Number.NEGATIVE_INFINITY,R=Number.NEGATIVE_INFINITY;for(let M=0;M<a;M++){const t=r[M],e=t.units;let i,l=0;for(let s=0,n=e.length;s<n;s++){const t=e[s],i=t.data,n=t.data.byteLength;C.setUint32(h,n),h+=4,x.set(i,h),h+=n,l+=4+n}if(M<a-1)p=r[M+1].dts-t.dts,i=r[M+1].pts-t.pts;else{const e=this.config,o=M>0?t.dts-r[M-1].dts:b;if(i=M>0?t.pts-r[M-1].pts:b,e.stretchShortVideoTrack&&null!==this.nextAudioPts){const i=Math.floor(e.maxBufferHole*n),r=(s?f+s*n:this.nextAudioPts)-t.pts;r>i?(p=r-o,p<0?p=o:_=!0,as.log(`[mp4-remuxer]: It is approximately ${r/90} ms to the next segment; using duration ${p/90} ms for the last video frame.`)):p=o}else p=o}const c=Math.round(t.pts-t.dts);k=Math.min(k,p),A=Math.max(A,p),L=Math.min(L,i),R=Math.max(R,i),o.push(new ql(t.key,p,l,c))}if(o.length)if(Ml){if(Ml<70){const t=o[0].flags;t.dependsOn=2,t.isNonSync=0}}else if(Nl&&R-L<A-k&&b/A<.025&&0===o[0].cts){as.warn("Found irregular gaps in sample duration. Using PTS instead of DTS to determine MP4 sample duration.");let t=c;for(let e=0,i=o.length;e<i;e++){const s=t+o[e].duration,n=t+o[e].cts;if(e<i-1){const t=s+o[e+1].cts;o[e].duration=t-n}else o[e].duration=e?o[e-1].duration:b;o[e].cts=0,t=s}}p=_||!p?b:p,this.nextAvcDts=u=d+p,this.videoSampleDuration=p,this.isVideoContiguous=!0;const I=xl.moof(t.sequenceNumber++,c,Wi({},t,{samples:o})),D="video",P={data1:I,data2:x,startPTS:f/n,endPTS:(m+p)/n,startDTS:c/n,endDTS:u/n,type:D,hasAudio:!1,hasVideo:!0,nb:o.length,dropped:t.dropped};return t.samples=[],t.dropped=0,P}getSamplesPerFrame(t){switch(t.segmentCodec){case"mp3":return Dl;case"ac3":return Pl;default:return Il}}remuxAudio(t,e,i,s,n){const r=t.inputTimeScale,o=t.samplerate?t.samplerate:r,a=r/o,l=this.getSamplesPerFrame(t),c=l*a,d=this._initPTS,u="mp3"===t.segmentCodec&&this.typeSupported.mpeg,h=[],p=void 0!==n;let f=t.samples,m=u?0:8,v=this.nextAudioPts||-1;const g=e*r,y=d.baseTime*r/d.timescale;if(this.isAudioContiguous=i=i||f.length&&v>0&&(s&&Math.abs(g-v)<9e3||Math.abs(Bl(f[0].pts-y,g)-v)<20*c),f.forEach((function(t){t.pts=Bl(t.pts-y,g)})),!i||v<0){if(f=f.filter((t=>t.pts>=0)),!f.length)return;v=0===n?0:s&&!p?Math.max(0,g):f[0].pts}if("aac"===t.segmentCodec){const e=this.config.maxAudioFramesDrift;for(let i=0,s=v;i<f.length;i++){const n=f[i],o=n.pts,a=o-s,l=Math.abs(1e3*a/r);if(a<=-e*c&&p)0===i&&(as.warn(`Audio frame @ ${(o/r).toFixed(3)}s overlaps nextAudioPts by ${Math.round(1e3*a/r)} ms.`),this.nextAudioPts=v=s=o);else if(a>=e*c&&l<Rl&&p){let e=Math.round(a/c);s=o-e*c,s<0&&(e--,s+=c),0===i&&(this.nextAudioPts=v=s),as.warn(`[mp4-remuxer]: Injecting ${e} audio frame @ ${(s/r).toFixed(3)}s due to ${Math.round(1e3*a/r)} ms gap.`);for(let r=0;r<e;r++){const e=Math.max(s,0);let r=El.getSilentFrame(t.manifestCodec||t.codec,t.channelCount);r||(as.log("[mp4-remuxer]: Unable to get silent frame for given audio codec; duplicating last frame instead."),r=n.unit.subarray()),f.splice(i,0,{unit:r,pts:e}),s+=c,i++}}n.pts=s,s+=c}}let b,w=null,S=null,E=0,T=f.length;while(T--)E+=f[T].unit.byteLength;for(let D=0,P=f.length;D<P;D++){const e=f[D],s=e.unit;let n=e.pts;if(null!==S){const t=h[D-1];t.duration=Math.round((n-S)/a)}else{if(i&&"aac"===t.segmentCodec&&(n=v),w=n,!(E>0))return;E+=m;try{b=new Uint8Array(E)}catch(I){return void this.observer.emit(Qi.ERROR,Qi.ERROR,{type:Ji.MUX_ERROR,details:ts.REMUX_ALLOC_ERROR,fatal:!1,error:I,bytes:E,reason:`fail allocating audio mdat ${E}`})}if(!u){const t=new DataView(b.buffer);t.setUint32(0,E),b.set(xl.types.mdat,4)}}b.set(s,m);const r=s.byteLength;m+=r,h.push(new ql(!0,l,r,0)),S=n}const x=h.length;if(!x)return;const C=h[h.length-1];this.nextAudioPts=v=S+a*C.duration;const _=u?new Uint8Array(0):xl.moof(t.sequenceNumber++,w/a,Wi({},t,{samples:h}));t.samples=[];const k=w/r,L=v/r,A="audio",R={data1:_,data2:b,startPTS:k,endPTS:L,startDTS:k,endDTS:L,type:A,hasAudio:!0,hasVideo:!1,nb:x};return this.isAudioContiguous=!0,R}remuxEmptyAudio(t,e,i,s){const n=t.inputTimeScale,r=t.samplerate?t.samplerate:n,o=n/r,a=this.nextAudioPts,l=this._initDTS,c=9e4*l.baseTime/l.timescale,d=(null!==a?a:s.startDTS*n)+c,u=s.endDTS*n+c,h=o*Il,p=Math.ceil((u-d)/h),f=El.getSilentFrame(t.manifestCodec||t.codec,t.channelCount);if(as.warn("[mp4-remuxer]: remux empty Audio"),!f)return void as.trace("[mp4-remuxer]: Unable to remuxEmptyAudio since we were unable to get a silent frame for given audio codec");const m=[];for(let v=0;v<p;v++){const t=d+v*h;m.push({unit:f,pts:t,dts:t})}return t.samples=m,this.remuxAudio(t,e,i,!1)}}function Bl(t,e){let i;if(null===e)return t;i=e<t?-8589934592:8589934592;while(Math.abs(t-e)>4294967296)t+=i;return t}function $l(t){for(let e=0;e<t.length;e++)if(t[e].key)return e;return-1}function Ul(t,e,i,s){const n=t.samples.length;if(!n)return;const r=t.inputTimeScale;for(let a=0;a<n;a++){const n=t.samples[a];n.pts=Bl(n.pts-i.baseTime*r/i.timescale,e*r)/r,n.dts=Bl(n.dts-s.baseTime*r/s.timescale,e*r)/r}const o=t.samples;return t.samples=[],{samples:o}}function jl(t,e,i){const s=t.samples.length;if(!s)return;const n=t.inputTimeScale;for(let o=0;o<s;o++){const s=t.samples[o];s.pts=Bl(s.pts-i.baseTime*n/i.timescale,e*n)/n}t.samples.sort(((t,e)=>t.pts-e.pts));const r=t.samples;return t.samples=[],{samples:r}}class ql{constructor(t,e,i,s){this.size=void 0,this.duration=void 0,this.cts=void 0,this.flags=void 0,this.duration=e,this.size=i,this.cts=s,this.flags={isLeading:0,isDependedOn:0,hasRedundancy:0,degradPrio:0,dependsOn:t?2:1,isNonSync:t?0:1}}}class Gl{constructor(){this.emitInitSegment=!1,this.audioCodec=void 0,this.videoCodec=void 0,this.initData=void 0,this.initPTS=null,this.initTracks=void 0,this.lastEndTime=null}destroy(){}resetTimeStamp(t){this.initPTS=t,this.lastEndTime=null}resetNextTimestamp(){this.lastEndTime=null}resetInitSegment(t,e,i,s){this.audioCodec=e,this.videoCodec=i,this.generateInitSegment(wn(t,s)),this.emitInitSegment=!0}generateInitSegment(t){let{audioCodec:e,videoCodec:i}=this;if(null==t||!t.byteLength)return this.initTracks=void 0,void(this.initData=void 0);const s=this.initData=mn(t);s.audio&&(e=Hl(s.audio,ms.AUDIO)),s.video&&(i=Hl(s.video,ms.VIDEO));const n={};s.audio&&s.video?n.audiovideo={container:"video/mp4",codec:e+","+i,initSegment:t,id:"main"}:s.audio?n.audio={container:"audio/mp4",codec:e,initSegment:t,id:"audio"}:s.video?n.video={container:"video/mp4",codec:i,initSegment:t,id:"main"}:as.warn("[passthrough-remuxer.ts]: initSegment does not contain moov or trak boxes."),this.initTracks=n}remux(t,e,i,s,n,r){var o,a;let{initPTS:l,lastEndTime:c}=this;const d={audio:void 0,video:void 0,text:s,id3:i,initSegment:void 0};Yi(c)||(c=this.lastEndTime=n||0);const u=e.samples;if(null==u||!u.length)return d;const h={initPTS:void 0,timescale:1};let p=this.initData;if(null!=(o=p)&&o.length||(this.generateInitSegment(u),p=this.initData),null==(a=p)||!a.length)return as.warn("[passthrough-remuxer.ts]: Failed to generate initSegment."),d;this.emitInitSegment&&(h.tracks=this.initTracks,this.emitInitSegment=!1);const f=Tn(u,p),m=En(p,u),v=null===m?n:m;(Vl(l,v,n,f)||h.timescale!==l.timescale&&r)&&(h.initPTS=v-n,l&&1===l.timescale&&as.warn("Adjusting initPTS by "+(h.initPTS-l.baseTime)),this.initPTS=l={baseTime:h.initPTS,timescale:1});const g=t?v-l.baseTime/l.timescale:c,y=g+f;Cn(p,u,l.baseTime/l.timescale),f>0?this.lastEndTime=y:(as.warn("Duration parsed from mp4 should be greater than zero"),this.resetNextTimestamp());const b=!!p.audio,w=!!p.video;let S="";b&&(S+="audio"),w&&(S+="video");const E={data1:u,startPTS:g,startDTS:g,endPTS:y,endDTS:y,type:S,hasAudio:b,hasVideo:w,nb:1,dropped:0};return d.audio="audio"===E.type?E:void 0,d.video="audio"!==E.type?E:void 0,d.initSegment=h,d.id3=Ul(i,n,l,l),s.samples.length&&(d.text=jl(s,n,l)),d}}function Vl(t,e,i,s){if(null===t)return!0;const n=Math.max(s,1),r=e-t.baseTime/t.timescale;return Math.abs(r-i)>n}function Hl(t,e){const i=null==t?void 0:t.codec;if(i&&i.length>4)return i;if(e===ms.AUDIO){if("ec-3"===i||"ac-3"===i||"alac"===i)return i;if("fLaC"===i||"Opus"===i){const t=!1;return rr(i,t)}const t="mp4a.40.5";return as.info(`Parsed audio codec "${i}" or audio object type not handled. Using "${t}"`),t}return as.warn(`Unhandled video codec "${i}"`),"hvc1"===i||"hev1"===i?"hvc1.1.6.L120.90":"av01"===i?"av01.0.04M.08":"avc1.42e01e"}try{Ol=self.performance.now.bind(self.performance)}catch(UP){as.debug("Unable to use Performance API on this environment"),Ol=null==_s?void 0:_s.Date.now}const zl=[{demux:rl,remux:Gl},{demux:fl,remux:Fl},{demux:sl,remux:Fl},{demux:Sl,remux:Fl}];zl.splice(2,0,{demux:al,remux:Fl});class Kl{constructor(t,e,i,s,n){this.async=!1,this.observer=void 0,this.typeSupported=void 0,this.config=void 0,this.vendor=void 0,this.id=void 0,this.demuxer=void 0,this.remuxer=void 0,this.decrypter=void 0,this.probe=void 0,this.decryptionPromise=null,this.transmuxConfig=void 0,this.currentTransmuxState=void 0,this.observer=t,this.typeSupported=e,this.config=i,this.vendor=s,this.id=n}configure(t){this.transmuxConfig=t,this.decrypter&&this.decrypter.reset()}push(t,e,i,s){const n=i.transmuxing;n.executeStart=Ol();let r=new Uint8Array(t);const{currentTransmuxState:o,transmuxConfig:a}=this;s&&(this.currentTransmuxState=s);const{contiguous:l,discontinuity:c,trackSwitch:d,accurateTimeOffset:u,timeOffset:h,initSegmentChange:p}=s||o,{audioCodec:f,videoCodec:m,defaultInitPts:v,duration:g,initSegmentData:y}=a,b=Wl(r,e);if(b&&"AES-128"===b.method){const t=this.getDecrypter();if(!t.isSync())return this.decryptionPromise=t.webCryptoDecrypt(r,b.key.buffer,b.iv.buffer).then((t=>{const e=this.push(t,null,i);return this.decryptionPromise=null,e})),this.decryptionPromise;{let e=t.softwareDecrypt(r,b.key.buffer,b.iv.buffer);const s=i.part>-1;if(s&&(e=t.flush()),!e)return n.executeEnd=Ol(),Yl(i);r=new Uint8Array(e)}}const w=this.needsProbing(c,d);if(w){const t=this.configureTransmuxer(r);if(t)return as.warn(`[transmuxer] ${t.message}`),this.observer.emit(Qi.ERROR,Qi.ERROR,{type:Ji.MEDIA_ERROR,details:ts.FRAG_PARSING_ERROR,fatal:!1,error:t,reason:t.message}),n.executeEnd=Ol(),Yl(i)}(c||d||p||w)&&this.resetInitSegment(y,f,m,g,e),(c||p||w)&&this.resetInitialTimestamp(v),l||this.resetContiguity();const S=this.transmux(r,b,h,u,i),E=this.currentTransmuxState;return E.contiguous=!0,E.discontinuity=!1,E.trackSwitch=!1,n.executeEnd=Ol(),S}flush(t){const e=t.transmuxing;e.executeStart=Ol();const{decrypter:i,currentTransmuxState:s,decryptionPromise:n}=this;if(n)return n.then((()=>this.flush(t)));const r=[],{timeOffset:o}=s;if(i){const e=i.flush();e&&r.push(this.push(e,null,t))}const{demuxer:a,remuxer:l}=this;if(!a||!l)return e.executeEnd=Ol(),[Yl(t)];const c=a.flush(o);return Xl(c)?c.then((e=>(this.flushRemux(r,e,t),r))):(this.flushRemux(r,c,t),r)}flushRemux(t,e,i){const{audioTrack:s,videoTrack:n,id3Track:r,textTrack:o}=e,{accurateTimeOffset:a,timeOffset:l}=this.currentTransmuxState;as.log(`[transmuxer.ts]: Flushed fragment ${i.sn}${i.part>-1?" p: "+i.part:""} of level ${i.level}`);const c=this.remuxer.remux(s,n,r,o,l,a,!0,this.id);t.push({remuxResult:c,chunkMeta:i}),i.transmuxing.executeEnd=Ol()}resetInitialTimestamp(t){const{demuxer:e,remuxer:i}=this;e&&i&&(e.resetTimeStamp(t),i.resetTimeStamp(t))}resetContiguity(){const{demuxer:t,remuxer:e}=this;t&&e&&(t.resetContiguity(),e.resetNextTimestamp())}resetInitSegment(t,e,i,s,n){const{demuxer:r,remuxer:o}=this;r&&o&&(r.resetInitSegment(t,e,i,s),o.resetInitSegment(t,e,i,n))}destroy(){this.demuxer&&(this.demuxer.destroy(),this.demuxer=void 0),this.remuxer&&(this.remuxer.destroy(),this.remuxer=void 0)}transmux(t,e,i,s,n){let r;return r=e&&"SAMPLE-AES"===e.method?this.transmuxSampleAes(t,e,i,s,n):this.transmuxUnencrypted(t,i,s,n),r}transmuxUnencrypted(t,e,i,s){const{audioTrack:n,videoTrack:r,id3Track:o,textTrack:a}=this.demuxer.demux(t,e,!1,!this.config.progressive),l=this.remuxer.remux(n,r,o,a,e,i,!1,this.id);return{remuxResult:l,chunkMeta:s}}transmuxSampleAes(t,e,i,s,n){return this.demuxer.demuxSampleAes(t,e,i).then((t=>{const e=this.remuxer.remux(t.audioTrack,t.videoTrack,t.id3Track,t.textTrack,i,s,!1,this.id);return{remuxResult:e,chunkMeta:n}}))}configureTransmuxer(t){const{config:e,observer:i,typeSupported:s,vendor:n}=this;let r;for(let u=0,h=zl.length;u<h;u++){var o;if(null!=(o=zl[u].demux)&&o.probe(t)){r=zl[u];break}}if(!r)return new Error("Failed to find demuxer by probing fragment data");const a=this.demuxer,l=this.remuxer,c=r.remux,d=r.demux;l&&l instanceof c||(this.remuxer=new c(i,e,s,n)),a&&a instanceof d||(this.demuxer=new d(i,e,s),this.probe=d.probe)}needsProbing(t,e){return!this.demuxer||!this.remuxer||t||e}getDecrypter(){let t=this.decrypter;return t||(t=this.decrypter=new Ea(this.config)),t}}function Wl(t,e){let i=null;return t.byteLength>0&&null!=(null==e?void 0:e.key)&&null!==e.iv&&null!=e.method&&(i=e),i}const Yl=t=>({remuxResult:{},chunkMeta:t});function Xl(t){return"then"in t&&t.then instanceof Function}class Zl{constructor(t,e,i,s,n){this.audioCodec=void 0,this.videoCodec=void 0,this.initSegmentData=void 0,this.duration=void 0,this.defaultInitPts=void 0,this.audioCodec=t,this.videoCodec=e,this.initSegmentData=i,this.duration=s,this.defaultInitPts=n||null}}class Ql{constructor(t,e,i,s,n,r){this.discontinuity=void 0,this.contiguous=void 0,this.accurateTimeOffset=void 0,this.trackSwitch=void 0,this.timeOffset=void 0,this.initSegmentChange=void 0,this.discontinuity=t,this.contiguous=e,this.accurateTimeOffset=i,this.trackSwitch=s,this.timeOffset=n,this.initSegmentChange=r}}var Jl={exports:{}};(function(t){var e=Object.prototype.hasOwnProperty,i="~";function s(){}function n(t,e,i){this.fn=t,this.context=e,this.once=i||!1}function r(t,e,s,r,o){if("function"!==typeof s)throw new TypeError("The listener must be a function");var a=new n(s,r||t,o),l=i?i+e:e;return t._events[l]?t._events[l].fn?t._events[l]=[t._events[l],a]:t._events[l].push(a):(t._events[l]=a,t._eventsCount++),t}function o(t,e){0===--t._eventsCount?t._events=new s:delete t._events[e]}function a(){this._events=new s,this._eventsCount=0}Object.create&&(s.prototype=Object.create(null),(new s).__proto__||(i=!1)),a.prototype.eventNames=function(){var t,s,n=[];if(0===this._eventsCount)return n;for(s in t=this._events)e.call(t,s)&&n.push(i?s.slice(1):s);return Object.getOwnPropertySymbols?n.concat(Object.getOwnPropertySymbols(t)):n},a.prototype.listeners=function(t){var e=i?i+t:t,s=this._events[e];if(!s)return[];if(s.fn)return[s.fn];for(var n=0,r=s.length,o=new Array(r);n<r;n++)o[n]=s[n].fn;return o},a.prototype.listenerCount=function(t){var e=i?i+t:t,s=this._events[e];return s?s.fn?1:s.length:0},a.prototype.emit=function(t,e,s,n,r,o){var a=i?i+t:t;if(!this._events[a])return!1;var l,c,d=this._events[a],u=arguments.length;if(d.fn){switch(d.once&&this.removeListener(t,d.fn,void 0,!0),u){case 1:return d.fn.call(d.context),!0;case 2:return d.fn.call(d.context,e),!0;case 3:return d.fn.call(d.context,e,s),!0;case 4:return d.fn.call(d.context,e,s,n),!0;case 5:return d.fn.call(d.context,e,s,n,r),!0;case 6:return d.fn.call(d.context,e,s,n,r,o),!0}for(c=1,l=new Array(u-1);c<u;c++)l[c-1]=arguments[c];d.fn.apply(d.context,l)}else{var h,p=d.length;for(c=0;c<p;c++)switch(d[c].once&&this.removeListener(t,d[c].fn,void 0,!0),u){case 1:d[c].fn.call(d[c].context);break;case 2:d[c].fn.call(d[c].context,e);break;case 3:d[c].fn.call(d[c].context,e,s);break;case 4:d[c].fn.call(d[c].context,e,s,n);break;default:if(!l)for(h=1,l=new Array(u-1);h<u;h++)l[h-1]=arguments[h];d[c].fn.apply(d[c].context,l)}}return!0},a.prototype.on=function(t,e,i){return r(this,t,e,i,!1)},a.prototype.once=function(t,e,i){return r(this,t,e,i,!0)},a.prototype.removeListener=function(t,e,s,n){var r=i?i+t:t;if(!this._events[r])return this;if(!e)return o(this,r),this;var a=this._events[r];if(a.fn)a.fn!==e||n&&!a.once||s&&a.context!==s||o(this,r);else{for(var l=0,c=[],d=a.length;l<d;l++)(a[l].fn!==e||n&&!a[l].once||s&&a[l].context!==s)&&c.push(a[l]);c.length?this._events[r]=1===c.length?c[0]:c:o(this,r)}return this},a.prototype.removeAllListeners=function(t){var e;return t?(e=i?i+t:t,this._events[e]&&o(this,e)):(this._events=new s,this._eventsCount=0),this},a.prototype.off=a.prototype.removeListener,a.prototype.addListener=a.prototype.on,a.prefixed=i,a.EventEmitter=a,t.exports=a})(Jl);var tc=Jl.exports,ec=Ui(tc);class ic{constructor(t,e,i,s){this.error=null,this.hls=void 0,this.id=void 0,this.observer=void 0,this.frag=null,this.part=null,this.useWorker=void 0,this.workerContext=null,this.onwmsg=void 0,this.transmuxer=null,this.onTransmuxComplete=void 0,this.onFlush=void 0;const n=t.config;this.hls=t,this.id=e,this.useWorker=!!n.enableWorker,this.onTransmuxComplete=i,this.onFlush=s;const r=(t,e)=>{e=e||{},e.frag=this.frag,e.id=this.id,t===Qi.ERROR&&(this.error=e.error),this.hls.trigger(t,e)};this.observer=new ec,this.observer.on(Qi.FRAG_DECRYPTED,r),this.observer.on(Qi.ERROR,r);const o=Kn(n.preferManagedMediaSource)||{isTypeSupported:()=>!1},a={mpeg:o.isTypeSupported("audio/mpeg"),mp3:o.isTypeSupported('audio/mp4; codecs="mp3"'),ac3:o.isTypeSupported('audio/mp4; codecs="ac-3"')};if(this.useWorker&&"undefined"!==typeof Worker){const t=n.workerPath||La();if(t){try{n.workerPath?(as.log(`loading Web Worker ${n.workerPath} for "${e}"`),this.workerContext=Ra(n.workerPath)):(as.log(`injecting Web Worker for "${e}"`),this.workerContext=Aa()),this.onwmsg=t=>this.onWorkerMessage(t);const{worker:t}=this.workerContext;t.addEventListener("message",this.onwmsg),t.onerror=t=>{const i=new Error(`${t.message}  (${t.filename}:${t.lineno})`);n.enableWorker=!1,as.warn(`Error in "${e}" Web Worker, fallback to inline`),this.hls.trigger(Qi.ERROR,{type:Ji.OTHER_ERROR,details:ts.INTERNAL_EXCEPTION,fatal:!1,event:"demuxerWorker",error:i})},t.postMessage({cmd:"init",typeSupported:a,vendor:"",id:e,config:JSON.stringify(n)})}catch(UP){as.warn(`Error setting up "${e}" Web Worker, fallback to inline`,UP),this.resetWorker(),this.error=null,this.transmuxer=new Kl(this.observer,a,n,"",e)}return}}this.transmuxer=new Kl(this.observer,a,n,"",e)}resetWorker(){if(this.workerContext){const{worker:t,objectURL:e}=this.workerContext;e&&self.URL.revokeObjectURL(e),t.removeEventListener("message",this.onwmsg),t.onerror=null,t.terminate(),this.workerContext=null}}destroy(){if(this.workerContext)this.resetWorker(),this.onwmsg=void 0;else{const t=this.transmuxer;t&&(t.destroy(),this.transmuxer=null)}const t=this.observer;t&&t.removeAllListeners(),this.frag=null,this.observer=null,this.hls=null}push(t,e,i,s,n,r,o,a,l,c){var d,u;l.transmuxing.start=self.performance.now();const{transmuxer:h}=this,p=r?r.start:n.start,f=n.decryptdata,m=this.frag,v=!(m&&n.cc===m.cc),g=!(m&&l.level===m.level),y=m?l.sn-m.sn:-1,b=this.part?l.part-this.part.index:-1,w=0===y&&l.id>1&&l.id===(null==m?void 0:m.stats.chunkCount),S=!g&&(1===y||0===y&&(1===b||w&&b<=0)),E=self.performance.now();(g||y||0===n.stats.parsing.start)&&(n.stats.parsing.start=E),!r||!b&&S||(r.stats.parsing.start=E);const T=!(m&&(null==(d=n.initSegment)?void 0:d.url)===(null==(u=m.initSegment)?void 0:u.url)),x=new Ql(v,S,a,g,p,T);if(!S||v||T){as.log(`[transmuxer-interface, ${n.type}]: Starting new transmux session for sn: ${l.sn} p: ${l.part} level: ${l.level} id: ${l.id}\n        discontinuity: ${v}\n        trackSwitch: ${g}\n        contiguous: ${S}\n        accurateTimeOffset: ${a}\n        timeOffset: ${p}\n        initSegmentChange: ${T}`);const t=new Zl(i,s,e,o,c);this.configureTransmuxer(t)}if(this.frag=n,this.part=r,this.workerContext)this.workerContext.worker.postMessage({cmd:"demux",data:t,decryptdata:f,chunkMeta:l,state:x},t instanceof ArrayBuffer?[t]:[]);else if(h){const e=h.push(t,f,l,x);Xl(e)?(h.async=!0,e.then((t=>{this.handleTransmuxComplete(t)})).catch((t=>{this.transmuxerError(t,l,"transmuxer-interface push error")}))):(h.async=!1,this.handleTransmuxComplete(e))}}flush(t){t.transmuxing.start=self.performance.now();const{transmuxer:e}=this;if(this.workerContext)this.workerContext.worker.postMessage({cmd:"flush",chunkMeta:t});else if(e){let i=e.flush(t);const s=Xl(i);s||e.async?(Xl(i)||(i=Promise.resolve(i)),i.then((e=>{this.handleFlushResult(e,t)})).catch((e=>{this.transmuxerError(e,t,"transmuxer-interface flush error")}))):this.handleFlushResult(i,t)}}transmuxerError(t,e,i){this.hls&&(this.error=t,this.hls.trigger(Qi.ERROR,{type:Ji.MEDIA_ERROR,details:ts.FRAG_PARSING_ERROR,chunkMeta:e,frag:this.frag||void 0,fatal:!1,error:t,err:t,reason:i}))}handleFlushResult(t,e){t.forEach((t=>{this.handleTransmuxComplete(t)})),this.onFlush(e)}onWorkerMessage(t){const e=t.data;if(null==e||!e.event)return void as.warn("worker message received with no "+(e?"event name":"data"));const i=this.hls;if(this.hls)switch(e.event){case"init":{var s;const t=null==(s=this.workerContext)?void 0:s.objectURL;t&&self.URL.revokeObjectURL(t);break}case"transmuxComplete":this.handleTransmuxComplete(e.data);break;case"flush":this.onFlush(e.data);break;case"workerLog":as[e.data.logType]&&as[e.data.logType](e.data.message);break;default:e.data=e.data||{},e.data.frag=this.frag,e.data.id=this.id,i.trigger(e.event,e.data);break}}configureTransmuxer(t){const{transmuxer:e}=this;this.workerContext?this.workerContext.worker.postMessage({cmd:"configure",config:t}):e&&e.configure(t)}handleTransmuxComplete(t){t.chunkMeta.transmuxing.end=self.performance.now(),this.onTransmuxComplete(t)}}function sc(t,e){if(t.length!==e.length)return!1;for(let i=0;i<t.length;i++)if(!nc(t[i].attrs,e[i].attrs))return!1;return!0}function nc(t,e,i){const s=t["STABLE-RENDITION-ID"];return s&&!i?s===e["STABLE-RENDITION-ID"]:!(i||["LANGUAGE","NAME","CHARACTERISTICS","AUTOSELECT","DEFAULT","FORCED","ASSOC-LANGUAGE"]).some((i=>t[i]!==e[i]))}function rc(t,e){return e.label.toLowerCase()===t.name.toLowerCase()&&(!e.language||e.language.toLowerCase()===(t.lang||"").toLowerCase())}const oc=100;class ac extends Ca{constructor(t,e,i){super(t,e,i,"[audio-stream-controller]",Tr.AUDIO),this.videoBuffer=null,this.videoTrackCC=-1,this.waitingVideoCC=-1,this.bufferedTrack=null,this.switchingTrack=null,this.trackId=-1,this.waitingData=null,this.mainDetails=null,this.flushing=!1,this.bufferFlushed=!1,this.cachedTrackLoadedData=null,this._registerListeners()}onHandlerDestroying(){this._unregisterListeners(),super.onHandlerDestroying(),this.mainDetails=null,this.bufferedTrack=null,this.switchingTrack=null}_registerListeners(){const{hls:t}=this;t.on(Qi.MEDIA_ATTACHED,this.onMediaAttached,this),t.on(Qi.MEDIA_DETACHING,this.onMediaDetaching,this),t.on(Qi.MANIFEST_LOADING,this.onManifestLoading,this),t.on(Qi.LEVEL_LOADED,this.onLevelLoaded,this),t.on(Qi.AUDIO_TRACKS_UPDATED,this.onAudioTracksUpdated,this),t.on(Qi.AUDIO_TRACK_SWITCHING,this.onAudioTrackSwitching,this),t.on(Qi.AUDIO_TRACK_LOADED,this.onAudioTrackLoaded,this),t.on(Qi.ERROR,this.onError,this),t.on(Qi.BUFFER_RESET,this.onBufferReset,this),t.on(Qi.BUFFER_CREATED,this.onBufferCreated,this),t.on(Qi.BUFFER_FLUSHING,this.onBufferFlushing,this),t.on(Qi.BUFFER_FLUSHED,this.onBufferFlushed,this),t.on(Qi.INIT_PTS_FOUND,this.onInitPtsFound,this),t.on(Qi.FRAG_BUFFERED,this.onFragBuffered,this)}_unregisterListeners(){const{hls:t}=this;t.off(Qi.MEDIA_ATTACHED,this.onMediaAttached,this),t.off(Qi.MEDIA_DETACHING,this.onMediaDetaching,this),t.off(Qi.MANIFEST_LOADING,this.onManifestLoading,this),t.off(Qi.LEVEL_LOADED,this.onLevelLoaded,this),t.off(Qi.AUDIO_TRACKS_UPDATED,this.onAudioTracksUpdated,this),t.off(Qi.AUDIO_TRACK_SWITCHING,this.onAudioTrackSwitching,this),t.off(Qi.AUDIO_TRACK_LOADED,this.onAudioTrackLoaded,this),t.off(Qi.ERROR,this.onError,this),t.off(Qi.BUFFER_RESET,this.onBufferReset,this),t.off(Qi.BUFFER_CREATED,this.onBufferCreated,this),t.off(Qi.BUFFER_FLUSHING,this.onBufferFlushing,this),t.off(Qi.BUFFER_FLUSHED,this.onBufferFlushed,this),t.off(Qi.INIT_PTS_FOUND,this.onInitPtsFound,this),t.off(Qi.FRAG_BUFFERED,this.onFragBuffered,this)}onInitPtsFound(t,{frag:e,id:i,initPTS:s,timescale:n}){if("main"===i){const t=e.cc;this.initPTS[e.cc]={baseTime:s,timescale:n},this.log(`InitPTS for cc: ${t} found from main: ${s}`),this.videoTrackCC=t,this.state===xa.WAITING_INIT_PTS&&this.tick()}}startLoad(t){if(!this.levels)return this.startPosition=t,void(this.state=xa.STOPPED);const e=this.lastCurrentTime;this.stopLoad(),this.setInterval(oc),e>0&&-1===t?(this.log(`Override startPosition with lastCurrentTime @${e.toFixed(3)}`),t=e,this.state=xa.IDLE):(this.loadedmetadata=!1,this.state=xa.WAITING_TRACK),this.nextLoadPosition=this.startPosition=this.lastCurrentTime=t,this.tick()}doTick(){switch(this.state){case xa.IDLE:this.doTickIdle();break;case xa.WAITING_TRACK:{var t;const{levels:e,trackId:i}=this,s=null==e||null==(t=e[i])?void 0:t.details;if(s){if(this.waitForCdnTuneIn(s))break;this.state=xa.WAITING_INIT_PTS}break}case xa.FRAG_LOADING_WAITING_RETRY:{var e;const t=performance.now(),i=this.retryDate;if(!i||t>=i||null!=(e=this.media)&&e.seeking){const{levels:t,trackId:e}=this;this.log("RetryDate reached, switch back to IDLE state"),this.resetStartWhenNotLoaded((null==t?void 0:t[e])||null),this.state=xa.IDLE}break}case xa.WAITING_INIT_PTS:{const t=this.waitingData;if(t){const{frag:e,part:i,cache:s,complete:n}=t;if(void 0!==this.initPTS[e.cc]){this.waitingData=null,this.waitingVideoCC=-1,this.state=xa.FRAG_LOADING;const t=s.flush(),r={frag:e,part:i,payload:t,networkDetails:null};this._handleFragmentLoadProgress(r),n&&super._handleFragmentLoadComplete(r)}else if(this.videoTrackCC!==this.waitingVideoCC)this.log(`Waiting fragment cc (${e.cc}) cancelled because video is at cc ${this.videoTrackCC}`),this.clearWaitingFragment();else{const t=this.getLoadPosition(),i=ea.bufferInfo(this.mediaBuffer,t,this.config.maxBufferHole),s=Eo(i.end,this.config.maxFragLookUpTolerance,e);s<0&&(this.log(`Waiting fragment cc (${e.cc}) @ ${e.start} cancelled because another fragment at ${i.end} is needed`),this.clearWaitingFragment())}}else this.state=xa.IDLE}}this.onTickEnd()}clearWaitingFragment(){const t=this.waitingData;t&&(this.fragmentTracker.removeFragment(t.frag),this.waitingData=null,this.waitingVideoCC=-1,this.state=xa.IDLE)}resetLoadingState(){this.clearWaitingFragment(),super.resetLoadingState()}onTickEnd(){const{media:t}=this;null!=t&&t.readyState&&(this.lastCurrentTime=t.currentTime)}doTickIdle(){const{hls:t,levels:e,media:i,trackId:s}=this,n=t.config;if(!this.buffering||!i&&(this.startFragRequested||!n.startFragPrefetch)||null==e||!e[s])return;const r=e[s],o=r.details;if(!o||o.live&&this.levelLastLoaded!==r||this.waitForCdnTuneIn(o))return void(this.state=xa.WAITING_TRACK);const a=this.mediaBuffer?this.mediaBuffer:this.media;this.bufferFlushed&&a&&(this.bufferFlushed=!1,this.afterBufferFlushed(a,ms.AUDIO,Tr.AUDIO));const l=this.getFwdBufferInfo(a,Tr.AUDIO);if(null===l)return;const{bufferedTrack:c,switchingTrack:d}=this;if(!d&&this._streamEnded(l,o))return t.trigger(Qi.BUFFER_EOS,{type:"audio"}),void(this.state=xa.ENDED);const u=this.getFwdBufferInfo(this.videoBuffer?this.videoBuffer:this.media,Tr.MAIN),h=l.len,p=this.getMaxBufferLength(null==u?void 0:u.len),f=o.fragments,m=f[0].start;let v=this.flushing?this.getLoadPosition():l.end;if(d&&i){const t=this.getLoadPosition();c&&!nc(d.attrs,c.attrs)&&(v=t),o.PTSKnown&&t<m&&(l.end>m||l.nextStart)&&(this.log("Alt audio track ahead of main track, seek to start of alt audio track"),i.currentTime=m+.05)}if(h>=p&&!d&&v<f[f.length-1].start)return;let g=this.getNextFragment(v,o),y=!1;if(g&&this.isLoopLoading(g,v)&&(y=!!g.gap,g=this.getNextFragmentLoopLoading(g,o,l,Tr.MAIN,p)),!g)return void(this.bufferFlushed=!0);const b=u&&g.start>u.end+o.targetduration;if(b||(null==u||!u.len)&&l.len){const t=this.getAppendedFrag(g.start,Tr.MAIN);if(null===t)return;if(y||(y=!!t.gap||!!b&&0===u.len),b&&!y||y&&l.nextStart&&l.nextStart<t.end)return}this.loadFragment(g,r,v)}getMaxBufferLength(t){const e=super.getMaxBufferLength();return t?Math.min(Math.max(e,t),this.config.maxMaxBufferLength):e}onMediaDetaching(){this.videoBuffer=null,this.bufferFlushed=this.flushing=!1,super.onMediaDetaching()}onAudioTracksUpdated(t,{audioTracks:e}){this.resetTransmuxer(),this.levels=e.map((t=>new Xr(t)))}onAudioTrackSwitching(t,e){const i=!!e.url;this.trackId=e.id;const{fragCurrent:s}=this;s&&(s.abortRequests(),this.removeUnbufferedFrags(s.start)),this.resetLoadingState(),i?this.setInterval(oc):this.resetTransmuxer(),i?(this.switchingTrack=e,this.state=xa.IDLE,this.flushAudioIfNeeded(e)):(this.switchingTrack=null,this.bufferedTrack=e,this.state=xa.STOPPED),this.tick()}onManifestLoading(){this.fragmentTracker.removeAllFragments(),this.startPosition=this.lastCurrentTime=0,this.bufferFlushed=this.flushing=!1,this.levels=this.mainDetails=this.waitingData=this.bufferedTrack=this.cachedTrackLoadedData=this.switchingTrack=null,this.startFragRequested=!1,this.trackId=this.videoTrackCC=this.waitingVideoCC=-1}onLevelLoaded(t,e){this.mainDetails=e.details,null!==this.cachedTrackLoadedData&&(this.hls.trigger(Qi.AUDIO_TRACK_LOADED,this.cachedTrackLoadedData),this.cachedTrackLoadedData=null)}onAudioTrackLoaded(t,e){var i;if(null==this.mainDetails)return void(this.cachedTrackLoadedData=e);const{levels:s}=this,{details:n,id:r}=e;if(!s)return void this.warn(`Audio tracks were reset while loading level ${r}`);this.log(`Audio track ${r} loaded [${n.startSN},${n.endSN}]${n.lastPartSn?`[part-${n.lastPartSn}-${n.lastPartIndex}]`:""},duration:${n.totalduration}`);const o=s[r];let a=0;if(n.live||null!=(i=o.details)&&i.live){this.checkLiveUpdate(n);const t=this.mainDetails;if(n.deltaUpdateFailed||!t)return;var l;if(!o.details&&n.hasProgramDateTime&&t.hasProgramDateTime)ua(n,t),a=n.fragments[0].start;else a=this.alignPlaylists(n,o.details,null==(l=this.levelLastLoaded)?void 0:l.details)}o.details=n,this.levelLastLoaded=o,this.startFragRequested||!this.mainDetails&&n.live||this.setStartPosition(this.mainDetails||n,a),this.state!==xa.WAITING_TRACK||this.waitForCdnTuneIn(n)||(this.state=xa.IDLE),this.tick()}_handleFragmentLoadProgress(t){var e;const{frag:i,part:s,payload:n}=t,{config:r,trackId:o,levels:a}=this;if(!a)return void this.warn(`Audio tracks were reset while fragment load was in progress. Fragment ${i.sn} of level ${i.level} will not be buffered`);const l=a[o];if(!l)return void this.warn("Audio track is undefined on fragment load progress");const c=l.details;if(!c)return this.warn("Audio track details undefined on fragment load progress"),void this.removeUnbufferedFrags(i.start);const d=r.defaultAudioCodec||l.audioCodec||"mp4a.40.2";let u=this.transmuxer;u||(u=this.transmuxer=new ic(this.hls,Tr.AUDIO,this._handleTransmuxComplete.bind(this),this._handleTransmuxerFlush.bind(this)));const h=this.initPTS[i.cc],p=null==(e=i.initSegment)?void 0:e.data;if(void 0!==h){const t=!1,e=s?s.index:-1,r=-1!==e,o=new ia(i.level,i.sn,i.stats.chunkCount,n.byteLength,e,r);u.push(n,p,d,"",i,s,c.totalduration,t,o,h)}else{this.log(`Unknown video PTS for cc ${i.cc}, waiting for video PTS before demuxing audio frag ${i.sn} of [${c.startSN} ,${c.endSN}],track ${o}`);const{cache:t}=this.waitingData=this.waitingData||{frag:i,part:s,cache:new _a,complete:!1};t.push(new Uint8Array(n)),this.waitingVideoCC=this.videoTrackCC,this.state=xa.WAITING_INIT_PTS}}_handleFragmentLoadComplete(t){this.waitingData?this.waitingData.complete=!0:super._handleFragmentLoadComplete(t)}onBufferReset(){this.mediaBuffer=this.videoBuffer=null,this.loadedmetadata=!1}onBufferCreated(t,e){const i=e.tracks.audio;i&&(this.mediaBuffer=i.buffer||null),e.tracks.video&&(this.videoBuffer=e.tracks.video.buffer||null)}onFragBuffered(t,e){const{frag:i,part:s}=e;if(i.type===Tr.AUDIO)if(this.fragContextChanged(i))this.warn(`Fragment ${i.sn}${s?" p: "+s.index:""} of level ${i.level} finished buffering, but was aborted. state: ${this.state}, audioSwitch: ${this.switchingTrack?this.switchingTrack.name:"false"}`);else{if("initSegment"!==i.sn){this.fragPrevious=i;const t=this.switchingTrack;t&&(this.bufferedTrack=t,this.switchingTrack=null,this.hls.trigger(Qi.AUDIO_TRACK_SWITCHED,Vi({},t)))}this.fragBufferedComplete(i,s)}else if(!this.loadedmetadata&&i.type===Tr.MAIN){const t=this.videoBuffer||this.media;if(t){const e=ea.getBuffered(t);e.length&&(this.loadedmetadata=!0)}}}onError(t,e){var i;if(e.fatal)this.state=xa.ERROR;else switch(e.details){case ts.FRAG_GAP:case ts.FRAG_PARSING_ERROR:case ts.FRAG_DECRYPT_ERROR:case ts.FRAG_LOAD_ERROR:case ts.FRAG_LOAD_TIMEOUT:case ts.KEY_LOAD_ERROR:case ts.KEY_LOAD_TIMEOUT:this.onFragmentOrKeyLoadError(Tr.AUDIO,e);break;case ts.AUDIO_TRACK_LOAD_ERROR:case ts.AUDIO_TRACK_LOAD_TIMEOUT:case ts.LEVEL_PARSING_ERROR:e.levelRetry||this.state!==xa.WAITING_TRACK||(null==(i=e.context)?void 0:i.type)!==Er.AUDIO_TRACK||(this.state=xa.IDLE);break;case ts.BUFFER_APPEND_ERROR:case ts.BUFFER_FULL_ERROR:if(!e.parent||"audio"!==e.parent)return;if(e.details===ts.BUFFER_APPEND_ERROR)return void this.resetLoadingState();this.reduceLengthAndFlushBuffer(e)&&(this.bufferedTrack=null,super.flushMainBuffer(0,Number.POSITIVE_INFINITY,"audio"));break;case ts.INTERNAL_EXCEPTION:this.recoverWorkerError(e);break}}onBufferFlushing(t,{type:e}){e!==ms.VIDEO&&(this.flushing=!0)}onBufferFlushed(t,{type:e}){if(e!==ms.VIDEO){this.flushing=!1,this.bufferFlushed=!0,this.state===xa.ENDED&&(this.state=xa.IDLE);const t=this.mediaBuffer||this.media;t&&(this.afterBufferFlushed(t,e,Tr.AUDIO),this.tick())}}_handleTransmuxComplete(t){var e;const i="audio",{hls:s}=this,{remuxResult:n,chunkMeta:r}=t,o=this.getCurrentContext(r);if(!o)return void this.resetWhenMissingContext(r);const{frag:a,part:l,level:c}=o,{details:d}=c,{audio:u,text:h,id3:p,initSegment:f}=n;if(!this.fragContextChanged(a)&&d){if(this.state=xa.PARSING,this.switchingTrack&&u&&this.completeAudioSwitch(this.switchingTrack),null!=f&&f.tracks){const t=a.initSegment||a;this._bufferInitSegment(c,f.tracks,t,r),s.trigger(Qi.FRAG_PARSING_INIT_SEGMENT,{frag:t,id:i,tracks:f.tracks})}if(u){const{startPTS:t,endPTS:e,startDTS:i,endDTS:s}=u;l&&(l.elementaryStreams[ms.AUDIO]={startPTS:t,endPTS:e,startDTS:i,endDTS:s}),a.setElementaryStreamInfo(ms.AUDIO,t,e,i,s),this.bufferFragmentData(u,a,l,r)}if(null!=p&&null!=(e=p.samples)&&e.length){const t=Wi({id:i,frag:a,details:d},p);s.trigger(Qi.FRAG_PARSING_METADATA,t)}if(h){const t=Wi({id:i,frag:a,details:d},h);s.trigger(Qi.FRAG_PARSING_USERDATA,t)}}else this.fragmentTracker.removeFragment(a)}_bufferInitSegment(t,e,i,s){if(this.state!==xa.PARSING)return;e.video&&delete e.video;const n=e.audio;if(!n)return;n.id="audio";const r=t.audioCodec;this.log(`Init audio buffer, container:${n.container}, codecs[level/parsed]=[${r}/${n.codec}]`),r&&1===r.split(",").length&&(n.levelCodec=r),this.hls.trigger(Qi.BUFFER_CODECS,e);const o=n.initSegment;if(null!=o&&o.byteLength){const t={type:"audio",frag:i,part:null,chunkMeta:s,parent:i.type,data:o};this.hls.trigger(Qi.BUFFER_APPENDING,t)}this.tickImmediate()}loadFragment(t,e,i){const s=this.fragmentTracker.getState(t);var n;if(this.fragCurrent=t,this.switchingTrack||s===Xo.NOT_LOADED||s===Xo.PARTIAL)if("initSegment"===t.sn)this._loadInitSegment(t,e);else if(null!=(n=e.details)&&n.live&&!this.initPTS[t.cc]){this.log(`Waiting for video PTS in continuity counter ${t.cc} of live stream before loading audio fragment ${t.sn} of level ${this.trackId}`),this.state=xa.WAITING_INIT_PTS;const i=this.mainDetails;i&&i.fragments[0].start!==e.details.fragments[0].start&&ua(e.details,i)}else this.startFragRequested=!0,super.loadFragment(t,e,i);else this.clearTrackerIfNeeded(t)}flushAudioIfNeeded(t){const{media:e,bufferedTrack:i}=this,s=null==i?void 0:i.attrs,n=t.attrs;e&&s&&(s.CHANNELS!==n.CHANNELS||i.name!==t.name||i.lang!==t.lang)&&(this.log("Switching audio track : flushing all audio"),super.flushMainBuffer(0,Number.POSITIVE_INFINITY,"audio"),this.bufferedTrack=null)}completeAudioSwitch(t){const{hls:e}=this;this.flushAudioIfNeeded(t),this.bufferedTrack=t,this.switchingTrack=null,e.trigger(Qi.AUDIO_TRACK_SWITCHED,Vi({},t))}}class lc extends Lo{constructor(t){super(t,"[audio-track-controller]"),this.tracks=[],this.groupIds=null,this.tracksInGroup=[],this.trackId=-1,this.currentTrack=null,this.selectDefaultTrack=!0,this.registerListeners()}registerListeners(){const{hls:t}=this;t.on(Qi.MANIFEST_LOADING,this.onManifestLoading,this),t.on(Qi.MANIFEST_PARSED,this.onManifestParsed,this),t.on(Qi.LEVEL_LOADING,this.onLevelLoading,this),t.on(Qi.LEVEL_SWITCHING,this.onLevelSwitching,this),t.on(Qi.AUDIO_TRACK_LOADED,this.onAudioTrackLoaded,this),t.on(Qi.ERROR,this.onError,this)}unregisterListeners(){const{hls:t}=this;t.off(Qi.MANIFEST_LOADING,this.onManifestLoading,this),t.off(Qi.MANIFEST_PARSED,this.onManifestParsed,this),t.off(Qi.LEVEL_LOADING,this.onLevelLoading,this),t.off(Qi.LEVEL_SWITCHING,this.onLevelSwitching,this),t.off(Qi.AUDIO_TRACK_LOADED,this.onAudioTrackLoaded,this),t.off(Qi.ERROR,this.onError,this)}destroy(){this.unregisterListeners(),this.tracks.length=0,this.tracksInGroup.length=0,this.currentTrack=null,super.destroy()}onManifestLoading(){this.tracks=[],this.tracksInGroup=[],this.groupIds=null,this.currentTrack=null,this.trackId=-1,this.selectDefaultTrack=!0}onManifestParsed(t,e){this.tracks=e.audioTracks||[]}onAudioTrackLoaded(t,e){const{id:i,groupId:s,details:n}=e,r=this.tracksInGroup[i];if(!r||r.groupId!==s)return void this.warn(`Audio track with id:${i} and group:${s} not found in active group ${null==r?void 0:r.groupId}`);const o=r.details;r.details=e.details,this.log(`Audio track ${i} "${r.name}" lang:${r.lang} group:${s} loaded [${n.startSN}-${n.endSN}]`),i===this.trackId&&this.playlistLoaded(i,e,o)}onLevelLoading(t,e){this.switchLevel(e.level)}onLevelSwitching(t,e){this.switchLevel(e.level)}switchLevel(t){const e=this.hls.levels[t];if(!e)return;const i=e.audioGroups||null,s=this.groupIds;let n=this.currentTrack;if(!i||(null==s?void 0:s.length)!==(null==i?void 0:i.length)||null!=i&&i.some((t=>-1===(null==s?void 0:s.indexOf(t))))){this.groupIds=i,this.trackId=-1,this.currentTrack=null;const t=this.tracks.filter((t=>!i||-1!==i.indexOf(t.groupId)));if(t.length)this.selectDefaultTrack&&!t.some((t=>t.default))&&(this.selectDefaultTrack=!1),t.forEach(((t,e)=>{t.id=e}));else if(!n&&!this.tracksInGroup.length)return;this.tracksInGroup=t;const e=this.hls.config.audioPreference;if(!n&&e){const i=qo(e,t,Ho);if(i>-1)n=t[i];else{const t=qo(e,this.tracks);n=this.tracks[t]}}let s=this.findTrackId(n);-1===s&&n&&(s=this.findTrackId(null));const o={audioTracks:t};this.log(`Updating audio tracks, ${t.length} track(s) found in group(s): ${null==i?void 0:i.join(",")}`),this.hls.trigger(Qi.AUDIO_TRACKS_UPDATED,o);const a=this.trackId;if(-1!==s&&-1===a)this.setAudioTrack(s);else if(t.length&&-1===a){var r;const e=new Error(`No audio track selected for current audio group-ID(s): ${null==(r=this.groupIds)?void 0:r.join(",")} track count: ${t.length}`);this.warn(e.message),this.hls.trigger(Qi.ERROR,{type:Ji.MEDIA_ERROR,details:ts.AUDIO_TRACK_LOAD_ERROR,fatal:!0,error:e})}}else this.shouldReloadPlaylist(n)&&this.setAudioTrack(this.trackId)}onError(t,e){!e.fatal&&e.context&&(e.context.type!==Er.AUDIO_TRACK||e.context.id!==this.trackId||this.groupIds&&-1===this.groupIds.indexOf(e.context.groupId)||(this.requestScheduled=-1,this.checkRetry(e)))}get allAudioTracks(){return this.tracks}get audioTracks(){return this.tracksInGroup}get audioTrack(){return this.trackId}set audioTrack(t){this.selectDefaultTrack=!1,this.setAudioTrack(t)}setAudioOption(t){const e=this.hls;if(e.config.audioPreference=t,t){const i=this.allAudioTracks;if(this.selectDefaultTrack=!1,i.length){const s=this.currentTrack;if(s&&Go(t,s,Ho))return s;const n=qo(t,this.tracksInGroup,Ho);if(n>-1){const t=this.tracksInGroup[n];return this.setAudioTrack(n),t}if(s){let s=e.loadLevel;-1===s&&(s=e.firstAutoLevel);const n=zo(t,e.levels,i,s,Ho);if(-1===n)return null;e.nextLoadLevel=n}if(t.channels||t.audioCodec){const e=qo(t,i);if(e>-1)return i[e]}}}return null}setAudioTrack(t){const e=this.tracksInGroup;if(t<0||t>=e.length)return void this.warn(`Invalid audio track id: ${t}`);this.clearTimer(),this.selectDefaultTrack=!1;const i=this.currentTrack,s=e[t],n=s.details&&!s.details.live;if(t===this.trackId&&s===i&&n)return;if(this.log(`Switching to audio-track ${t} "${s.name}" lang:${s.lang} group:${s.groupId} channels:${s.channels}`),this.trackId=t,this.currentTrack=s,this.hls.trigger(Qi.AUDIO_TRACK_SWITCHING,Vi({},s)),n)return;const r=this.switchParams(s.url,null==i?void 0:i.details,s.details);this.loadPlaylist(r)}findTrackId(t){const e=this.tracksInGroup;for(let i=0;i<e.length;i++){const s=e[i];if((!this.selectDefaultTrack||s.default)&&(!t||Go(t,s,Ho)))return i}if(t){const{name:i,lang:s,assocLang:n,characteristics:r,audioCodec:o,channels:a}=t;for(let t=0;t<e.length;t++){const l=e[t];if(Go({name:i,lang:s,assocLang:n,characteristics:r,audioCodec:o,channels:a},l,Ho))return t}for(let l=0;l<e.length;l++){const i=e[l];if(nc(t.attrs,i.attrs,["LANGUAGE","ASSOC-LANGUAGE","CHARACTERISTICS"]))return l}for(let l=0;l<e.length;l++){const i=e[l];if(nc(t.attrs,i.attrs,["LANGUAGE"]))return l}}return-1}loadPlaylist(t){const e=this.currentTrack;if(this.shouldLoadPlaylist(e)&&e){super.loadPlaylist();const s=e.id,n=e.groupId;let r=e.url;if(t)try{r=t.addDirectives(r)}catch(i){this.warn(`Could not construct new URL with HLS Delivery Directives: ${i}`)}this.log(`loading audio-track playlist ${s} "${e.name}" lang:${e.lang} group:${n}`),this.clearTimer(),this.hls.trigger(Qi.AUDIO_TRACK_LOADING,{url:r,id:s,groupId:n,deliveryDirectives:t||null})}}}const cc=500;class dc extends Ca{constructor(t,e,i){super(t,e,i,"[subtitle-stream-controller]",Tr.SUBTITLE),this.currentTrackId=-1,this.tracksBuffered=[],this.mainDetails=null,this._registerListeners()}onHandlerDestroying(){this._unregisterListeners(),super.onHandlerDestroying(),this.mainDetails=null}_registerListeners(){const{hls:t}=this;t.on(Qi.MEDIA_ATTACHED,this.onMediaAttached,this),t.on(Qi.MEDIA_DETACHING,this.onMediaDetaching,this),t.on(Qi.MANIFEST_LOADING,this.onManifestLoading,this),t.on(Qi.LEVEL_LOADED,this.onLevelLoaded,this),t.on(Qi.ERROR,this.onError,this),t.on(Qi.SUBTITLE_TRACKS_UPDATED,this.onSubtitleTracksUpdated,this),t.on(Qi.SUBTITLE_TRACK_SWITCH,this.onSubtitleTrackSwitch,this),t.on(Qi.SUBTITLE_TRACK_LOADED,this.onSubtitleTrackLoaded,this),t.on(Qi.SUBTITLE_FRAG_PROCESSED,this.onSubtitleFragProcessed,this),t.on(Qi.BUFFER_FLUSHING,this.onBufferFlushing,this),t.on(Qi.FRAG_BUFFERED,this.onFragBuffered,this)}_unregisterListeners(){const{hls:t}=this;t.off(Qi.MEDIA_ATTACHED,this.onMediaAttached,this),t.off(Qi.MEDIA_DETACHING,this.onMediaDetaching,this),t.off(Qi.MANIFEST_LOADING,this.onManifestLoading,this),t.off(Qi.LEVEL_LOADED,this.onLevelLoaded,this),t.off(Qi.ERROR,this.onError,this),t.off(Qi.SUBTITLE_TRACKS_UPDATED,this.onSubtitleTracksUpdated,this),t.off(Qi.SUBTITLE_TRACK_SWITCH,this.onSubtitleTrackSwitch,this),t.off(Qi.SUBTITLE_TRACK_LOADED,this.onSubtitleTrackLoaded,this),t.off(Qi.SUBTITLE_FRAG_PROCESSED,this.onSubtitleFragProcessed,this),t.off(Qi.BUFFER_FLUSHING,this.onBufferFlushing,this),t.off(Qi.FRAG_BUFFERED,this.onFragBuffered,this)}startLoad(t){this.stopLoad(),this.state=xa.IDLE,this.setInterval(cc),this.nextLoadPosition=this.startPosition=this.lastCurrentTime=t,this.tick()}onManifestLoading(){this.mainDetails=null,this.fragmentTracker.removeAllFragments()}onMediaDetaching(){this.tracksBuffered=[],super.onMediaDetaching()}onLevelLoaded(t,e){this.mainDetails=e.details}onSubtitleFragProcessed(t,e){const{frag:i,success:s}=e;if(this.fragPrevious=i,this.state=xa.IDLE,!s)return;const n=this.tracksBuffered[this.currentTrackId];if(!n)return;let r;const o=i.start;for(let l=0;l<n.length;l++)if(o>=n[l].start&&o<=n[l].end){r=n[l];break}const a=i.start+i.duration;r?r.end=a:(r={start:o,end:a},n.push(r)),this.fragmentTracker.fragBuffered(i),this.fragBufferedComplete(i,null)}onBufferFlushing(t,e){const{startOffset:i,endOffset:s}=e;if(0===i&&s!==Number.POSITIVE_INFINITY){const t=s-1;if(t<=0)return;e.endOffsetSubtitles=Math.max(0,t),this.tracksBuffered.forEach((e=>{for(let i=0;i<e.length;)if(e[i].end<=t)e.shift();else{if(!(e[i].start<t))break;e[i].start=t,i++}})),this.fragmentTracker.removeFragmentsInRange(i,t,Tr.SUBTITLE)}}onFragBuffered(t,e){var i;this.loadedmetadata||e.frag.type!==Tr.MAIN||null!=(i=this.media)&&i.buffered.length&&(this.loadedmetadata=!0)}onError(t,e){const i=e.frag;(null==i?void 0:i.type)===Tr.SUBTITLE&&(e.details===ts.FRAG_GAP&&this.fragmentTracker.fragBuffered(i,!0),this.fragCurrent&&this.fragCurrent.abortRequests(),this.state!==xa.STOPPED&&(this.state=xa.IDLE))}onSubtitleTracksUpdated(t,{subtitleTracks:e}){this.levels&&sc(this.levels,e)?this.levels=e.map((t=>new Xr(t))):(this.tracksBuffered=[],this.levels=e.map((t=>{const e=new Xr(t);return this.tracksBuffered[e.id]=[],e})),this.fragmentTracker.removeFragmentsInRange(0,Number.POSITIVE_INFINITY,Tr.SUBTITLE),this.fragPrevious=null,this.mediaBuffer=null)}onSubtitleTrackSwitch(t,e){var i;if(this.currentTrackId=e.id,null==(i=this.levels)||!i.length||-1===this.currentTrackId)return void this.clearInterval();const s=this.levels[this.currentTrackId];null!=s&&s.details?this.mediaBuffer=this.mediaBufferTimeRanges:this.mediaBuffer=null,s&&this.setInterval(cc)}onSubtitleTrackLoaded(t,e){var i;const{currentTrackId:s,levels:n}=this,{details:r,id:o}=e;if(!n)return void this.warn(`Subtitle tracks were reset while loading level ${o}`);const a=n[o];if(o>=n.length||!a)return;this.log(`Subtitle track ${o} loaded [${r.startSN},${r.endSN}]${r.lastPartSn?`[part-${r.lastPartSn}-${r.lastPartIndex}]`:""},duration:${r.totalduration}`),this.mediaBuffer=this.mediaBufferTimeRanges;let l=0;if(r.live||null!=(i=a.details)&&i.live){const t=this.mainDetails;if(r.deltaUpdateFailed||!t)return;const e=t.fragments[0];var c;if(a.details)l=this.alignPlaylists(r,a.details,null==(c=this.levelLastLoaded)?void 0:c.details),0===l&&e&&(l=e.start,ro(r,l));else r.hasProgramDateTime&&t.hasProgramDateTime?(ua(r,t),l=r.fragments[0].start):e&&(l=e.start,ro(r,l))}if(a.details=r,this.levelLastLoaded=a,o===s&&(this.startFragRequested||!this.mainDetails&&r.live||this.setStartPosition(this.mainDetails||r,l),this.tick(),r.live&&!this.fragCurrent&&this.media&&this.state===xa.IDLE)){const t=wo(null,r.fragments,this.media.currentTime,0);t||(this.warn("Subtitle playlist not aligned with playback"),a.details=void 0)}}_handleFragmentLoadComplete(t){const{frag:e,payload:i}=t,s=e.decryptdata,n=this.hls;if(!this.fragContextChanged(e)&&i&&i.byteLength>0&&null!=s&&s.key&&s.iv&&"AES-128"===s.method){const t=performance.now();this.decrypter.decrypt(new Uint8Array(i),s.key.buffer,s.iv.buffer).catch((t=>{throw n.trigger(Qi.ERROR,{type:Ji.MEDIA_ERROR,details:ts.FRAG_DECRYPT_ERROR,fatal:!1,error:t,reason:t.message,frag:e}),t})).then((i=>{const s=performance.now();n.trigger(Qi.FRAG_DECRYPTED,{frag:e,payload:i,stats:{tstart:t,tdecrypt:s}})})).catch((t=>{this.warn(`${t.name}: ${t.message}`),this.state=xa.IDLE}))}}doTick(){if(this.media){if(this.state===xa.IDLE){const{currentTrackId:t,levels:e}=this,i=null==e?void 0:e[t];if(!i||!e.length||!i.details)return;const{config:s}=this,n=this.getLoadPosition(),r=ea.bufferedInfo(this.tracksBuffered[this.currentTrackId]||[],n,s.maxBufferHole),{end:o,len:a}=r,l=this.getFwdBufferInfo(this.media,Tr.MAIN),c=i.details,d=this.getMaxBufferLength(null==l?void 0:l.len)+c.levelTargetDuration;if(a>d)return;const u=c.fragments,h=u.length,p=c.edge;let f=null;const m=this.fragPrevious;if(o<p){const t=s.maxFragLookUpTolerance,e=o>p-t?0:t;f=wo(m,u,Math.max(u[0].start,o),e),!f&&m&&m.start<u[0].start&&(f=u[0])}else f=u[h-1];if(!f)return;if(f=this.mapToInitFragWhenRequired(f),"initSegment"!==f.sn){const t=f.sn-c.startSN,e=u[t-1];e&&e.cc===f.cc&&this.fragmentTracker.getState(e)===Xo.NOT_LOADED&&(f=e)}this.fragmentTracker.getState(f)===Xo.NOT_LOADED&&this.loadFragment(f,i,o)}}else this.state=xa.IDLE}getMaxBufferLength(t){const e=super.getMaxBufferLength();return t?Math.max(e,t):e}loadFragment(t,e,i){this.fragCurrent=t,"initSegment"===t.sn?this._loadInitSegment(t,e):(this.startFragRequested=!0,super.loadFragment(t,e,i))}get mediaBufferTimeRanges(){return new uc(this.tracksBuffered[this.currentTrackId]||[])}}class uc{constructor(t){this.buffered=void 0;const e=(e,i,s)=>{if(i>>>=0,i>s-1)throw new DOMException(`Failed to execute '${e}' on 'TimeRanges': The index provided (${i}) is greater than the maximum bound (${s})`);return t[i][e]};this.buffered={get length(){return t.length},end(i){return e("end",i,t.length)},start(i){return e("start",i,t.length)}}}}class hc extends Lo{constructor(t){super(t,"[subtitle-track-controller]"),this.media=null,this.tracks=[],this.groupIds=null,this.tracksInGroup=[],this.trackId=-1,this.currentTrack=null,this.selectDefaultTrack=!0,this.queuedDefaultTrack=-1,this.asyncPollTrackChange=()=>this.pollTrackChange(0),this.useTextTrackPolling=!1,this.subtitlePollingInterval=-1,this._subtitleDisplay=!0,this.onTextTracksChanged=()=>{if(this.useTextTrackPolling||self.clearInterval(this.subtitlePollingInterval),!this.media||!this.hls.config.renderTextTracksNatively)return;let t=null;const e=Pr(this.media.textTracks);for(let s=0;s<e.length;s++)if("hidden"===e[s].mode)t=e[s];else if("showing"===e[s].mode){t=e[s];break}const i=this.findTrackForTextTrack(t);this.subtitleTrack!==i&&this.setSubtitleTrack(i)},this.registerListeners()}destroy(){this.unregisterListeners(),this.tracks.length=0,this.tracksInGroup.length=0,this.currentTrack=null,this.onTextTracksChanged=this.asyncPollTrackChange=null,super.destroy()}get subtitleDisplay(){return this._subtitleDisplay}set subtitleDisplay(t){this._subtitleDisplay=t,this.trackId>-1&&this.toggleTrackModes()}registerListeners(){const{hls:t}=this;t.on(Qi.MEDIA_ATTACHED,this.onMediaAttached,this),t.on(Qi.MEDIA_DETACHING,this.onMediaDetaching,this),t.on(Qi.MANIFEST_LOADING,this.onManifestLoading,this),t.on(Qi.MANIFEST_PARSED,this.onManifestParsed,this),t.on(Qi.LEVEL_LOADING,this.onLevelLoading,this),t.on(Qi.LEVEL_SWITCHING,this.onLevelSwitching,this),t.on(Qi.SUBTITLE_TRACK_LOADED,this.onSubtitleTrackLoaded,this),t.on(Qi.ERROR,this.onError,this)}unregisterListeners(){const{hls:t}=this;t.off(Qi.MEDIA_ATTACHED,this.onMediaAttached,this),t.off(Qi.MEDIA_DETACHING,this.onMediaDetaching,this),t.off(Qi.MANIFEST_LOADING,this.onManifestLoading,this),t.off(Qi.MANIFEST_PARSED,this.onManifestParsed,this),t.off(Qi.LEVEL_LOADING,this.onLevelLoading,this),t.off(Qi.LEVEL_SWITCHING,this.onLevelSwitching,this),t.off(Qi.SUBTITLE_TRACK_LOADED,this.onSubtitleTrackLoaded,this),t.off(Qi.ERROR,this.onError,this)}onMediaAttached(t,e){this.media=e.media,this.media&&(this.queuedDefaultTrack>-1&&(this.subtitleTrack=this.queuedDefaultTrack,this.queuedDefaultTrack=-1),this.useTextTrackPolling=!(this.media.textTracks&&"onchange"in this.media.textTracks),this.useTextTrackPolling?this.pollTrackChange(500):this.media.textTracks.addEventListener("change",this.asyncPollTrackChange))}pollTrackChange(t){self.clearInterval(this.subtitlePollingInterval),this.subtitlePollingInterval=self.setInterval(this.onTextTracksChanged,t)}onMediaDetaching(){if(!this.media)return;self.clearInterval(this.subtitlePollingInterval),this.useTextTrackPolling||this.media.textTracks.removeEventListener("change",this.asyncPollTrackChange),this.trackId>-1&&(this.queuedDefaultTrack=this.trackId);const t=Pr(this.media.textTracks);t.forEach((t=>{Ar(t)})),this.subtitleTrack=-1,this.media=null}onManifestLoading(){this.tracks=[],this.groupIds=null,this.tracksInGroup=[],this.trackId=-1,this.currentTrack=null,this.selectDefaultTrack=!0}onManifestParsed(t,e){this.tracks=e.subtitleTracks}onSubtitleTrackLoaded(t,e){const{id:i,groupId:s,details:n}=e,r=this.tracksInGroup[i];if(!r||r.groupId!==s)return void this.warn(`Subtitle track with id:${i} and group:${s} not found in active group ${null==r?void 0:r.groupId}`);const o=r.details;r.details=e.details,this.log(`Subtitle track ${i} "${r.name}" lang:${r.lang} group:${s} loaded [${n.startSN}-${n.endSN}]`),i===this.trackId&&this.playlistLoaded(i,e,o)}onLevelLoading(t,e){this.switchLevel(e.level)}onLevelSwitching(t,e){this.switchLevel(e.level)}switchLevel(t){const e=this.hls.levels[t];if(!e)return;const i=e.subtitleGroups||null,s=this.groupIds;let n=this.currentTrack;if(!i||(null==s?void 0:s.length)!==(null==i?void 0:i.length)||null!=i&&i.some((t=>-1===(null==s?void 0:s.indexOf(t))))){this.groupIds=i,this.trackId=-1,this.currentTrack=null;const t=this.tracks.filter((t=>!i||-1!==i.indexOf(t.groupId)));if(t.length)this.selectDefaultTrack&&!t.some((t=>t.default))&&(this.selectDefaultTrack=!1),t.forEach(((t,e)=>{t.id=e}));else if(!n&&!this.tracksInGroup.length)return;this.tracksInGroup=t;const e=this.hls.config.subtitlePreference;if(!n&&e){this.selectDefaultTrack=!1;const i=qo(e,t);if(i>-1)n=t[i];else{const t=qo(e,this.tracks);n=this.tracks[t]}}let s=this.findTrackId(n);-1===s&&n&&(s=this.findTrackId(null));const r={subtitleTracks:t};this.log(`Updating subtitle tracks, ${t.length} track(s) found in "${null==i?void 0:i.join(",")}" group-id`),this.hls.trigger(Qi.SUBTITLE_TRACKS_UPDATED,r),-1!==s&&-1===this.trackId&&this.setSubtitleTrack(s)}else this.shouldReloadPlaylist(n)&&this.setSubtitleTrack(this.trackId)}findTrackId(t){const e=this.tracksInGroup,i=this.selectDefaultTrack;for(let s=0;s<e.length;s++){const n=e[s];if((!i||n.default)&&(i||t)&&(!t||Go(n,t)))return s}if(t){for(let i=0;i<e.length;i++){const s=e[i];if(nc(t.attrs,s.attrs,["LANGUAGE","ASSOC-LANGUAGE","CHARACTERISTICS"]))return i}for(let i=0;i<e.length;i++){const s=e[i];if(nc(t.attrs,s.attrs,["LANGUAGE"]))return i}}return-1}findTrackForTextTrack(t){if(t){const e=this.tracksInGroup;for(let i=0;i<e.length;i++){const s=e[i];if(rc(s,t))return i}}return-1}onError(t,e){!e.fatal&&e.context&&(e.context.type!==Er.SUBTITLE_TRACK||e.context.id!==this.trackId||this.groupIds&&-1===this.groupIds.indexOf(e.context.groupId)||this.checkRetry(e))}get allSubtitleTracks(){return this.tracks}get subtitleTracks(){return this.tracksInGroup}get subtitleTrack(){return this.trackId}set subtitleTrack(t){this.selectDefaultTrack=!1,this.setSubtitleTrack(t)}setSubtitleOption(t){if(this.hls.config.subtitlePreference=t,t){const e=this.allSubtitleTracks;if(this.selectDefaultTrack=!1,e.length){const i=this.currentTrack;if(i&&Go(t,i))return i;const s=qo(t,this.tracksInGroup);if(s>-1){const t=this.tracksInGroup[s];return this.setSubtitleTrack(s),t}if(i)return null;{const i=qo(t,e);if(i>-1)return e[i]}}}return null}loadPlaylist(t){super.loadPlaylist();const e=this.currentTrack;if(this.shouldLoadPlaylist(e)&&e){const s=e.id,n=e.groupId;let r=e.url;if(t)try{r=t.addDirectives(r)}catch(i){this.warn(`Could not construct new URL with HLS Delivery Directives: ${i}`)}this.log(`Loading subtitle playlist for id ${s}`),this.hls.trigger(Qi.SUBTITLE_TRACK_LOADING,{url:r,id:s,groupId:n,deliveryDirectives:t||null})}}toggleTrackModes(){const{media:t}=this;if(!t)return;const e=Pr(t.textTracks),i=this.currentTrack;let s;if(i&&(s=e.filter((t=>rc(i,t)))[0],s||this.warn(`Unable to find subtitle TextTrack with name "${i.name}" and language "${i.lang}"`)),[].slice.call(e).forEach((t=>{"disabled"!==t.mode&&t!==s&&(t.mode="disabled")})),s){const t=this.subtitleDisplay?"showing":"hidden";s.mode!==t&&(s.mode=t)}}setSubtitleTrack(t){const e=this.tracksInGroup;if(!this.media)return void(this.queuedDefaultTrack=t);if(t<-1||t>=e.length||!Yi(t))return void this.warn(`Invalid subtitle track id: ${t}`);this.clearTimer(),this.selectDefaultTrack=!1;const i=this.currentTrack,s=e[t]||null;if(this.trackId=t,this.currentTrack=s,this.toggleTrackModes(),!s)return void this.hls.trigger(Qi.SUBTITLE_TRACK_SWITCH,{id:t});const n=!!s.details&&!s.details.live;if(t===this.trackId&&s===i&&n)return;this.log(`Switching to subtitle-track ${t}`+(s?` "${s.name}" lang:${s.lang} group:${s.groupId}`:""));const{id:r,groupId:o="",name:a,type:l,url:c}=s;this.hls.trigger(Qi.SUBTITLE_TRACK_SWITCH,{id:r,groupId:o,name:a,type:l,url:c});const d=this.switchParams(s.url,null==i?void 0:i.details,s.details);this.loadPlaylist(d)}}class pc{constructor(t){this.buffers=void 0,this.queues={video:[],audio:[],audiovideo:[]},this.buffers=t}append(t,e,i){const s=this.queues[e];s.push(t),1!==s.length||i||this.executeNext(e)}insertAbort(t,e){const i=this.queues[e];i.unshift(t),this.executeNext(e)}appendBlocker(t){let e;const i=new Promise((t=>{e=t})),s={execute:e,onStart:()=>{},onComplete:()=>{},onError:()=>{}};return this.append(s,t),i}executeNext(t){const e=this.queues[t];if(e.length){const s=e[0];try{s.execute()}catch(i){as.warn(`[buffer-operation-queue]: Exception executing "${t}" SourceBuffer operation: ${i}`),s.onError(i);const e=this.buffers[t];null!=e&&e.updating||this.shiftAndExecuteNext(t)}}}shiftAndExecuteNext(t){this.queues[t].shift(),this.executeNext(t)}current(t){return this.queues[t][0]}}const fc=/(avc[1234]|hvc1|hev1|dvh[1e]|vp09|av01)(?:\.[^.,]+)+/;class mc{constructor(t){this.details=null,this._objectUrl=null,this.operationQueue=void 0,this.listeners=void 0,this.hls=void 0,this.bufferCodecEventsExpected=0,this._bufferCodecEventsTotal=0,this.media=null,this.mediaSource=null,this.lastMpegAudioChunk=null,this.appendSource=void 0,this.appendErrors={audio:0,video:0,audiovideo:0},this.tracks={},this.pendingTracks={},this.sourceBuffer=void 0,this.log=void 0,this.warn=void 0,this.error=void 0,this._onEndStreaming=t=>{this.hls&&this.hls.pauseBuffering()},this._onStartStreaming=t=>{this.hls&&this.hls.resumeBuffering()},this._onMediaSourceOpen=()=>{const{media:t,mediaSource:e}=this;this.log("Media source opened"),t&&(t.removeEventListener("emptied",this._onMediaEmptied),this.updateMediaElementDuration(),this.hls.trigger(Qi.MEDIA_ATTACHED,{media:t,mediaSource:e})),e&&e.removeEventListener("sourceopen",this._onMediaSourceOpen),this.checkPendingTracks()},this._onMediaSourceClose=()=>{this.log("Media source closed")},this._onMediaSourceEnded=()=>{this.log("Media source ended")},this._onMediaEmptied=()=>{const{mediaSrc:t,_objectUrl:e}=this;t!==e&&as.error(`Media element src was set while attaching MediaSource (${e} > ${t})`)},this.hls=t;const e="[buffer-controller]";this.appendSource=Wn(Kn(t.config.preferManagedMediaSource)),this.log=as.log.bind(as,e),this.warn=as.warn.bind(as,e),this.error=as.error.bind(as,e),this._initSourceBuffer(),this.registerListeners()}hasSourceTypes(){return this.getSourceBufferTypes().length>0||Object.keys(this.pendingTracks).length>0}destroy(){this.unregisterListeners(),this.details=null,this.lastMpegAudioChunk=null,this.hls=null}registerListeners(){const{hls:t}=this;t.on(Qi.MEDIA_ATTACHING,this.onMediaAttaching,this),t.on(Qi.MEDIA_DETACHING,this.onMediaDetaching,this),t.on(Qi.MANIFEST_LOADING,this.onManifestLoading,this),t.on(Qi.MANIFEST_PARSED,this.onManifestParsed,this),t.on(Qi.BUFFER_RESET,this.onBufferReset,this),t.on(Qi.BUFFER_APPENDING,this.onBufferAppending,this),t.on(Qi.BUFFER_CODECS,this.onBufferCodecs,this),t.on(Qi.BUFFER_EOS,this.onBufferEos,this),t.on(Qi.BUFFER_FLUSHING,this.onBufferFlushing,this),t.on(Qi.LEVEL_UPDATED,this.onLevelUpdated,this),t.on(Qi.FRAG_PARSED,this.onFragParsed,this),t.on(Qi.FRAG_CHANGED,this.onFragChanged,this)}unregisterListeners(){const{hls:t}=this;t.off(Qi.MEDIA_ATTACHING,this.onMediaAttaching,this),t.off(Qi.MEDIA_DETACHING,this.onMediaDetaching,this),t.off(Qi.MANIFEST_LOADING,this.onManifestLoading,this),t.off(Qi.MANIFEST_PARSED,this.onManifestParsed,this),t.off(Qi.BUFFER_RESET,this.onBufferReset,this),t.off(Qi.BUFFER_APPENDING,this.onBufferAppending,this),t.off(Qi.BUFFER_CODECS,this.onBufferCodecs,this),t.off(Qi.BUFFER_EOS,this.onBufferEos,this),t.off(Qi.BUFFER_FLUSHING,this.onBufferFlushing,this),t.off(Qi.LEVEL_UPDATED,this.onLevelUpdated,this),t.off(Qi.FRAG_PARSED,this.onFragParsed,this),t.off(Qi.FRAG_CHANGED,this.onFragChanged,this)}_initSourceBuffer(){this.sourceBuffer={},this.operationQueue=new pc(this.sourceBuffer),this.listeners={audio:[],video:[],audiovideo:[]},this.appendErrors={audio:0,video:0,audiovideo:0},this.lastMpegAudioChunk=null}onManifestLoading(){this.bufferCodecEventsExpected=this._bufferCodecEventsTotal=0,this.details=null}onManifestParsed(t,e){let i=2;(e.audio&&!e.video||!e.altAudio)&&(i=1),this.bufferCodecEventsExpected=this._bufferCodecEventsTotal=i,this.log(`${this.bufferCodecEventsExpected} bufferCodec event(s) expected`)}onMediaAttaching(t,e){const i=this.media=e.media,s=Kn(this.appendSource);if(i&&s){var n;const t=this.mediaSource=new s;this.log(`created media source: ${null==(n=t.constructor)?void 0:n.name}`),t.addEventListener("sourceopen",this._onMediaSourceOpen),t.addEventListener("sourceended",this._onMediaSourceEnded),t.addEventListener("sourceclose",this._onMediaSourceClose),this.appendSource&&(t.addEventListener("startstreaming",this._onStartStreaming),t.addEventListener("endstreaming",this._onEndStreaming));const e=this._objectUrl=self.URL.createObjectURL(t);if(this.appendSource)try{i.removeAttribute("src");const s=self.ManagedMediaSource;i.disableRemotePlayback=i.disableRemotePlayback||s&&t instanceof s,vc(i),gc(i,e),i.load()}catch(r){i.src=e}else i.src=e;i.addEventListener("emptied",this._onMediaEmptied)}}onMediaDetaching(){const{media:t,mediaSource:e,_objectUrl:i}=this;if(e){if(this.log("media source detaching"),"open"===e.readyState)try{e.endOfStream()}catch(UP){this.warn(`onMediaDetaching: ${UP.message} while calling endOfStream`)}this.onBufferReset(),e.removeEventListener("sourceopen",this._onMediaSourceOpen),e.removeEventListener("sourceended",this._onMediaSourceEnded),e.removeEventListener("sourceclose",this._onMediaSourceClose),this.appendSource&&(e.removeEventListener("startstreaming",this._onStartStreaming),e.removeEventListener("endstreaming",this._onEndStreaming)),t&&(t.removeEventListener("emptied",this._onMediaEmptied),i&&self.URL.revokeObjectURL(i),this.mediaSrc===i?(t.removeAttribute("src"),this.appendSource&&vc(t),t.load()):this.warn("media|source.src was changed by a third party - skip cleanup")),this.mediaSource=null,this.media=null,this._objectUrl=null,this.bufferCodecEventsExpected=this._bufferCodecEventsTotal,this.pendingTracks={},this.tracks={}}this.hls.trigger(Qi.MEDIA_DETACHED,void 0)}onBufferReset(){this.getSourceBufferTypes().forEach((t=>{this.resetBuffer(t)})),this._initSourceBuffer(),this.hls.resumeBuffering()}resetBuffer(t){const e=this.sourceBuffer[t];try{var i;if(e)this.removeBufferListeners(t),this.sourceBuffer[t]=void 0,null!=(i=this.mediaSource)&&i.sourceBuffers.length&&this.mediaSource.removeSourceBuffer(e)}catch(UP){this.warn(`onBufferReset ${t}`,UP)}}onBufferCodecs(t,e){const i=this.getSourceBufferTypes().length,s=Object.keys(e);if(s.forEach((t=>{if(i){const i=this.tracks[t];if(i&&"function"===typeof i.buffer.changeType){var s;const{id:n,codec:r,levelCodec:o,container:a,metadata:l}=e[t],c=or(i.codec,i.levelCodec),d=null==c?void 0:c.replace(fc,"$1");let u=or(r,o);const h=null==(s=u)?void 0:s.replace(fc,"$1");if(u&&d!==h){"audio"===t.slice(0,5)&&(u=rr(u,this.appendSource));const e=`${a};codecs=${u}`;this.appendChangeType(t,e),this.log(`switching codec ${c} to ${u}`),this.tracks[t]={buffer:i.buffer,codec:r,container:a,levelCodec:o,metadata:l,id:n}}}}else this.pendingTracks[t]=e[t]})),i)return;const n=Math.max(this.bufferCodecEventsExpected-1,0);this.bufferCodecEventsExpected!==n&&(this.log(`${n} bufferCodec event(s) expected ${s.join(",")}`),this.bufferCodecEventsExpected=n),this.mediaSource&&"open"===this.mediaSource.readyState&&this.checkPendingTracks()}appendChangeType(t,e){const{operationQueue:i}=this,s={execute:()=>{const s=this.sourceBuffer[t];s&&(this.log(`changing ${t} sourceBuffer type to ${e}`),s.changeType(e)),i.shiftAndExecuteNext(t)},onStart:()=>{},onComplete:()=>{},onError:e=>{this.warn(`Failed to change ${t} SourceBuffer type`,e)}};i.append(s,t,!!this.pendingTracks[t])}onBufferAppending(t,e){const{hls:i,operationQueue:s,tracks:n}=this,{data:r,type:o,frag:a,part:l,chunkMeta:c}=e,d=c.buffering[o],u=self.performance.now();d.start=u;const h=a.stats.buffering,p=l?l.stats.buffering:null;0===h.start&&(h.start=u),p&&0===p.start&&(p.start=u);const f=n.audio;let m=!1;"audio"===o&&"audio/mpeg"===(null==f?void 0:f.container)&&(m=!this.lastMpegAudioChunk||1===c.id||this.lastMpegAudioChunk.sn!==c.sn,this.lastMpegAudioChunk=c);const v=a.start,g={execute:()=>{if(d.executeStart=self.performance.now(),m){const t=this.sourceBuffer[o];if(t){const e=v-t.timestampOffset;Math.abs(e)>=.1&&(this.log(`Updating audio SourceBuffer timestampOffset to ${v} (delta: ${e}) sn: ${a.sn})`),t.timestampOffset=v)}}this.appendExecutor(r,o)},onStart:()=>{},onComplete:()=>{const t=self.performance.now();d.executeEnd=d.end=t,0===h.first&&(h.first=t),p&&0===p.first&&(p.first=t);const{sourceBuffer:e}=this,i={};for(const s in e)i[s]=ea.getBuffered(e[s]);this.appendErrors[o]=0,"audio"===o||"video"===o?this.appendErrors.audiovideo=0:(this.appendErrors.audio=0,this.appendErrors.video=0),this.hls.trigger(Qi.BUFFER_APPENDED,{type:o,frag:a,part:l,chunkMeta:c,parent:a.type,timeRanges:i})},onError:t=>{const e={type:Ji.MEDIA_ERROR,parent:a.type,details:ts.BUFFER_APPEND_ERROR,sourceBufferName:o,frag:a,part:l,chunkMeta:c,error:t,err:t,fatal:!1};if(t.code===DOMException.QUOTA_EXCEEDED_ERR)e.details=ts.BUFFER_FULL_ERROR;else{const t=++this.appendErrors[o];e.details=ts.BUFFER_APPEND_ERROR,this.warn(`Failed ${t}/${i.config.appendErrorMaxRetry} times to append segment in "${o}" sourceBuffer`),t>=i.config.appendErrorMaxRetry&&(e.fatal=!0)}i.trigger(Qi.ERROR,e)}};s.append(g,o,!!this.pendingTracks[o])}onBufferFlushing(t,e){const{operationQueue:i}=this,s=t=>({execute:this.removeExecutor.bind(this,t,e.startOffset,e.endOffset),onStart:()=>{},onComplete:()=>{this.hls.trigger(Qi.BUFFER_FLUSHED,{type:t})},onError:e=>{this.warn(`Failed to remove from ${t} SourceBuffer`,e)}});e.type?i.append(s(e.type),e.type):this.getSourceBufferTypes().forEach((t=>{i.append(s(t),t)}))}onFragParsed(t,e){const{frag:i,part:s}=e,n=[],r=s?s.elementaryStreams:i.elementaryStreams;r[ms.AUDIOVIDEO]?n.push("audiovideo"):(r[ms.AUDIO]&&n.push("audio"),r[ms.VIDEO]&&n.push("video"));const o=()=>{const t=self.performance.now();i.stats.buffering.end=t,s&&(s.stats.buffering.end=t);const e=s?s.stats:i.stats;this.hls.trigger(Qi.FRAG_BUFFERED,{frag:i,part:s,stats:e,id:i.type})};0===n.length&&this.warn(`Fragments must have at least one ElementaryStreamType set. type: ${i.type} level: ${i.level} sn: ${i.sn}`),this.blockBuffers(o,n)}onFragChanged(t,e){this.trimBuffers()}onBufferEos(t,e){const i=this.getSourceBufferTypes().reduce(((t,i)=>{const s=this.sourceBuffer[i];return!s||e.type&&e.type!==i||(s.ending=!0,s.ended||(s.ended=!0,this.log(`${i} sourceBuffer now EOS`))),t&&!(s&&!s.ended)}),!0);i&&(this.log("Queueing mediaSource.endOfStream()"),this.blockBuffers((()=>{this.getSourceBufferTypes().forEach((t=>{const e=this.sourceBuffer[t];e&&(e.ending=!1)}));const{mediaSource:t}=this;t&&"open"===t.readyState?(this.log("Calling mediaSource.endOfStream()"),t.endOfStream()):t&&this.log(`Could not call mediaSource.endOfStream(). mediaSource.readyState: ${t.readyState}`)})))}onLevelUpdated(t,{details:e}){e.fragments.length&&(this.details=e,this.getSourceBufferTypes().length?this.blockBuffers(this.updateMediaElementDuration.bind(this)):this.updateMediaElementDuration())}trimBuffers(){const{hls:t,details:e,media:i}=this;if(!i||null===e)return;const s=this.getSourceBufferTypes();if(!s.length)return;const n=t.config,r=i.currentTime,o=e.levelTargetDuration,a=e.live&&null!==n.liveBackBufferLength?n.liveBackBufferLength:n.backBufferLength;if(Yi(a)&&a>0){const t=Math.max(a,o),e=Math.floor(r/o)*o-t;this.flushBackBuffer(r,o,e)}if(Yi(n.frontBufferFlushThreshold)&&n.frontBufferFlushThreshold>0){const t=Math.max(n.maxBufferLength,n.frontBufferFlushThreshold),e=Math.max(t,o),i=Math.floor(r/o)*o+e;this.flushFrontBuffer(r,o,i)}}flushBackBuffer(t,e,i){const{details:s,sourceBuffer:n}=this,r=this.getSourceBufferTypes();r.forEach((r=>{const o=n[r];if(o){const n=ea.getBuffered(o);if(n.length>0&&i>n.start(0)){if(this.hls.trigger(Qi.BACK_BUFFER_REACHED,{bufferEnd:i}),null!=s&&s.live)this.hls.trigger(Qi.LIVE_BACK_BUFFER_REACHED,{bufferEnd:i});else if(o.ended&&n.end(n.length-1)-t<2*e)return void this.log(`Cannot flush ${r} back buffer while SourceBuffer is in ended state`);this.hls.trigger(Qi.BUFFER_FLUSHING,{startOffset:0,endOffset:i,type:r})}}}))}flushFrontBuffer(t,e,i){const{sourceBuffer:s}=this,n=this.getSourceBufferTypes();n.forEach((n=>{const r=s[n];if(r){const s=ea.getBuffered(r),o=s.length;if(o<2)return;const a=s.start(o-1),l=s.end(o-1);if(i>a||t>=a&&t<=l)return;if(r.ended&&t-l<2*e)return void this.log(`Cannot flush ${n} front buffer while SourceBuffer is in ended state`);this.hls.trigger(Qi.BUFFER_FLUSHING,{startOffset:a,endOffset:1/0,type:n})}}))}updateMediaElementDuration(){if(!this.details||!this.media||!this.mediaSource||"open"!==this.mediaSource.readyState)return;const{details:t,hls:e,media:i,mediaSource:s}=this,n=t.fragments[0].start+t.totalduration,r=i.duration,o=Yi(s.duration)?s.duration:0;t.live&&e.config.liveDurationInfinity?(s.duration=1/0,this.updateSeekableRange(t)):(n>o&&n>r||!Yi(r))&&(this.log(`Updating Media Source duration to ${n.toFixed(3)}`),s.duration=n)}updateSeekableRange(t){const e=this.mediaSource,i=t.fragments,s=i.length;if(s&&t.live&&null!=e&&e.setLiveSeekableRange){const s=Math.max(0,i[0].start),n=Math.max(s,s+t.totalduration);this.log(`Media Source duration is set to ${e.duration}. Setting seekable range to ${s}-${n}.`),e.setLiveSeekableRange(s,n)}}checkPendingTracks(){const{bufferCodecEventsExpected:t,operationQueue:e,pendingTracks:i}=this,s=Object.keys(i).length;if(s&&(!t||2===s||"audiovideo"in i)){this.createSourceBuffers(i),this.pendingTracks={};const t=this.getSourceBufferTypes();if(t.length)this.hls.trigger(Qi.BUFFER_CREATED,{tracks:this.tracks}),t.forEach((t=>{e.executeNext(t)}));else{const t=new Error("could not create source buffer for media codec(s)");this.hls.trigger(Qi.ERROR,{type:Ji.MEDIA_ERROR,details:ts.BUFFER_INCOMPATIBLE_CODECS_ERROR,fatal:!0,error:t,reason:t.message})}}}createSourceBuffers(t){const{sourceBuffer:e,mediaSource:i}=this;if(!i)throw Error("createSourceBuffers called when mediaSource was null");for(const n in t)if(!e[n]){var s;const r=t[n];if(!r)throw Error(`source buffer exists for track ${n}, however track does not`);let o=-1===(null==(s=r.levelCodec)?void 0:s.indexOf(","))?r.levelCodec:r.codec;o&&"audio"===n.slice(0,5)&&(o=rr(o,this.appendSource));const a=`${r.container};codecs=${o}`;this.log(`creating sourceBuffer(${a})`);try{const t=e[n]=i.addSourceBuffer(a),s=n;this.addBufferListener(s,"updatestart",this._onSBUpdateStart),this.addBufferListener(s,"updateend",this._onSBUpdateEnd),this.addBufferListener(s,"error",this._onSBUpdateError),this.appendSource&&this.addBufferListener(s,"bufferedchange",((t,e)=>{const i=e.removedRanges;null!=i&&i.length&&this.hls.trigger(Qi.BUFFER_FLUSHED,{type:n})})),this.tracks[n]={buffer:t,codec:o,container:r.container,levelCodec:r.levelCodec,metadata:r.metadata,id:r.id}}catch(UP){this.error(`error while trying to add sourceBuffer: ${UP.message}`),this.hls.trigger(Qi.ERROR,{type:Ji.MEDIA_ERROR,details:ts.BUFFER_ADD_CODEC_ERROR,fatal:!1,error:UP,sourceBufferName:n,mimeType:a})}}}get mediaSrc(){var t,e;const i=(null==(t=this.media)||null==(e=t.querySelector)?void 0:e.call(t,"source"))||this.media;return null==i?void 0:i.src}_onSBUpdateStart(t){const{operationQueue:e}=this,i=e.current(t);i.onStart()}_onSBUpdateEnd(t){var e;if("closed"===(null==(e=this.mediaSource)?void 0:e.readyState))return void this.resetBuffer(t);const{operationQueue:i}=this,s=i.current(t);s.onComplete(),i.shiftAndExecuteNext(t)}_onSBUpdateError(t,e){var i;const s=new Error(`${t} SourceBuffer error. MediaSource readyState: ${null==(i=this.mediaSource)?void 0:i.readyState}`);this.error(`${s}`,e),this.hls.trigger(Qi.ERROR,{type:Ji.MEDIA_ERROR,details:ts.BUFFER_APPENDING_ERROR,sourceBufferName:t,error:s,fatal:!1});const n=this.operationQueue.current(t);n&&n.onError(s)}removeExecutor(t,e,i){const{media:s,mediaSource:n,operationQueue:r,sourceBuffer:o}=this,a=o[t];if(!s||!n||!a)return this.warn(`Attempting to remove from the ${t} SourceBuffer, but it does not exist`),void r.shiftAndExecuteNext(t);const l=Yi(s.duration)?s.duration:1/0,c=Yi(n.duration)?n.duration:1/0,d=Math.max(0,e),u=Math.min(i,l,c);u>d&&(!a.ending||a.ended)?(a.ended=!1,this.log(`Removing [${d},${u}] from the ${t} SourceBuffer`),a.remove(d,u)):r.shiftAndExecuteNext(t)}appendExecutor(t,e){const i=this.sourceBuffer[e];if(i)i.ended=!1,i.appendBuffer(t);else if(!this.pendingTracks[e])throw new Error(`Attempting to append to the ${e} SourceBuffer, but it does not exist`)}blockBuffers(t,e=this.getSourceBufferTypes()){if(!e.length)return this.log("Blocking operation requested, but no SourceBuffers exist"),void Promise.resolve().then(t);const{operationQueue:i}=this,s=e.map((t=>i.appendBlocker(t)));Promise.all(s).then((()=>{t(),e.forEach((t=>{const e=this.sourceBuffer[t];null!=e&&e.updating||i.shiftAndExecuteNext(t)}))}))}getSourceBufferTypes(){return Object.keys(this.sourceBuffer)}addBufferListener(t,e,i){const s=this.sourceBuffer[t];if(!s)return;const n=i.bind(this,t);this.listeners[t].push({event:e,listener:n}),s.addEventListener(e,n)}removeBufferListeners(t){const e=this.sourceBuffer[t];e&&this.listeners[t].forEach((t=>{e.removeEventListener(t.event,t.listener)}))}}function vc(t){const e=t.querySelectorAll("source");[].slice.call(e).forEach((e=>{t.removeChild(e)}))}function gc(t,e){const i=self.document.createElement("source");i.type="video/mp4",i.src=e,t.appendChild(i)}const yc={42:225,92:233,94:237,95:243,96:250,123:231,124:247,125:209,126:241,127:9608,128:174,129:176,130:189,131:191,132:8482,133:162,134:163,135:9834,136:224,137:32,138:232,139:226,140:234,141:238,142:244,143:251,144:193,145:201,146:211,147:218,148:220,149:252,150:8216,151:161,152:42,153:8217,154:9473,155:169,156:8480,157:8226,158:8220,159:8221,160:192,161:194,162:199,163:200,164:202,165:203,166:235,167:206,168:207,169:239,170:212,171:217,172:249,173:219,174:171,175:187,176:195,177:227,178:205,179:204,180:236,181:210,182:242,183:213,184:245,185:123,186:125,187:92,188:94,189:95,190:124,191:8764,192:196,193:228,194:214,195:246,196:223,197:165,198:164,199:9475,200:197,201:229,202:216,203:248,204:9487,205:9491,206:9495,207:9499},bc=t=>String.fromCharCode(yc[t]||t),wc=15,Sc=100,Ec={17:1,18:3,21:5,22:7,23:9,16:11,19:12,20:14},Tc={17:2,18:4,21:6,22:8,23:10,19:13,20:15},xc={25:1,26:3,29:5,30:7,31:9,24:11,27:12,28:14},Cc={25:2,26:4,29:6,30:8,31:10,27:13,28:15},_c=["white","green","blue","cyan","red","yellow","magenta","black","transparent"];class kc{constructor(){this.time=null,this.verboseLevel=0}log(t,e){if(this.verboseLevel>=t){const i="function"===typeof e?e():e;as.log(`${this.time} [${t}] ${i}`)}}}const Lc=function(t){const e=[];for(let i=0;i<t.length;i++)e.push(t[i].toString(16));return e};class Ac{constructor(){this.foreground="white",this.underline=!1,this.italics=!1,this.background="black",this.flash=!1}reset(){this.foreground="white",this.underline=!1,this.italics=!1,this.background="black",this.flash=!1}setStyles(t){const e=["foreground","underline","italics","background","flash"];for(let i=0;i<e.length;i++){const s=e[i];t.hasOwnProperty(s)&&(this[s]=t[s])}}isDefault(){return"white"===this.foreground&&!this.underline&&!this.italics&&"black"===this.background&&!this.flash}equals(t){return this.foreground===t.foreground&&this.underline===t.underline&&this.italics===t.italics&&this.background===t.background&&this.flash===t.flash}copy(t){this.foreground=t.foreground,this.underline=t.underline,this.italics=t.italics,this.background=t.background,this.flash=t.flash}toString(){return"color="+this.foreground+", underline="+this.underline+", italics="+this.italics+", background="+this.background+", flash="+this.flash}}class Rc{constructor(){this.uchar=" ",this.penState=new Ac}reset(){this.uchar=" ",this.penState.reset()}setChar(t,e){this.uchar=t,this.penState.copy(e)}setPenState(t){this.penState.copy(t)}equals(t){return this.uchar===t.uchar&&this.penState.equals(t.penState)}copy(t){this.uchar=t.uchar,this.penState.copy(t.penState)}isEmpty(){return" "===this.uchar&&this.penState.isDefault()}}class Ic{constructor(t){this.chars=[],this.pos=0,this.currPenState=new Ac,this.cueStartTime=null,this.logger=void 0;for(let e=0;e<Sc;e++)this.chars.push(new Rc);this.logger=t}equals(t){for(let e=0;e<Sc;e++)if(!this.chars[e].equals(t.chars[e]))return!1;return!0}copy(t){for(let e=0;e<Sc;e++)this.chars[e].copy(t.chars[e])}isEmpty(){let t=!0;for(let e=0;e<Sc;e++)if(!this.chars[e].isEmpty()){t=!1;break}return t}setCursor(t){this.pos!==t&&(this.pos=t),this.pos<0?(this.logger.log(3,"Negative cursor position "+this.pos),this.pos=0):this.pos>Sc&&(this.logger.log(3,"Too large cursor position "+this.pos),this.pos=Sc)}moveCursor(t){const e=this.pos+t;if(t>1)for(let i=this.pos+1;i<e+1;i++)this.chars[i].setPenState(this.currPenState);this.setCursor(e)}backSpace(){this.moveCursor(-1),this.chars[this.pos].setChar(" ",this.currPenState)}insertChar(t){t>=144&&this.backSpace();const e=bc(t);this.pos>=Sc?this.logger.log(0,(()=>"Cannot insert "+t.toString(16)+" ("+e+") at position "+this.pos+". Skipping it!")):(this.chars[this.pos].setChar(e,this.currPenState),this.moveCursor(1))}clearFromPos(t){let e;for(e=t;e<Sc;e++)this.chars[e].reset()}clear(){this.clearFromPos(0),this.pos=0,this.currPenState.reset()}clearToEndOfRow(){this.clearFromPos(this.pos)}getTextString(){const t=[];let e=!0;for(let i=0;i<Sc;i++){const s=this.chars[i].uchar;" "!==s&&(e=!1),t.push(s)}return e?"":t.join("")}setPenStyles(t){this.currPenState.setStyles(t);const e=this.chars[this.pos];e.setPenState(this.currPenState)}}class Dc{constructor(t){this.rows=[],this.currRow=wc-1,this.nrRollUpRows=null,this.lastOutputScreen=null,this.logger=void 0;for(let e=0;e<wc;e++)this.rows.push(new Ic(t));this.logger=t}reset(){for(let t=0;t<wc;t++)this.rows[t].clear();this.currRow=wc-1}equals(t){let e=!0;for(let i=0;i<wc;i++)if(!this.rows[i].equals(t.rows[i])){e=!1;break}return e}copy(t){for(let e=0;e<wc;e++)this.rows[e].copy(t.rows[e])}isEmpty(){let t=!0;for(let e=0;e<wc;e++)if(!this.rows[e].isEmpty()){t=!1;break}return t}backSpace(){const t=this.rows[this.currRow];t.backSpace()}clearToEndOfRow(){const t=this.rows[this.currRow];t.clearToEndOfRow()}insertChar(t){const e=this.rows[this.currRow];e.insertChar(t)}setPen(t){const e=this.rows[this.currRow];e.setPenStyles(t)}moveCursor(t){const e=this.rows[this.currRow];e.moveCursor(t)}setCursor(t){this.logger.log(2,"setCursor: "+t);const e=this.rows[this.currRow];e.setCursor(t)}setPAC(t){this.logger.log(2,(()=>"pacData = "+JSON.stringify(t)));let e=t.row-1;if(this.nrRollUpRows&&e<this.nrRollUpRows-1&&(e=this.nrRollUpRows-1),this.nrRollUpRows&&this.currRow!==e){for(let e=0;e<wc;e++)this.rows[e].clear();const t=this.currRow+1-this.nrRollUpRows,i=this.lastOutputScreen;if(i){const s=i.rows[t].cueStartTime,n=this.logger.time;if(null!==s&&null!==n&&s<n)for(let r=0;r<this.nrRollUpRows;r++)this.rows[e-this.nrRollUpRows+r+1].copy(i.rows[t+r])}}this.currRow=e;const i=this.rows[this.currRow];if(null!==t.indent){const e=t.indent,s=Math.max(e-1,0);i.setCursor(t.indent),t.color=i.chars[s].penState.foreground}const s={foreground:t.color,underline:t.underline,italics:t.italics,background:"black",flash:!1};this.setPen(s)}setBkgData(t){this.logger.log(2,(()=>"bkgData = "+JSON.stringify(t))),this.backSpace(),this.setPen(t),this.insertChar(32)}setRollUpRows(t){this.nrRollUpRows=t}rollUp(){if(null===this.nrRollUpRows)return void this.logger.log(3,"roll_up but nrRollUpRows not set yet");this.logger.log(1,(()=>this.getDisplayText()));const t=this.currRow+1-this.nrRollUpRows,e=this.rows.splice(t,1)[0];e.clear(),this.rows.splice(this.currRow,0,e),this.logger.log(2,"Rolling up")}getDisplayText(t){t=t||!1;const e=[];let i="",s=-1;for(let n=0;n<wc;n++){const i=this.rows[n].getTextString();i&&(s=n+1,t?e.push("Row "+s+": '"+i+"'"):e.push(i.trim()))}return e.length>0&&(i=t?"["+e.join(" | ")+"]":e.join("\n")),i}getTextAndFormat(){return this.rows}}class Pc{constructor(t,e,i){this.chNr=void 0,this.outputFilter=void 0,this.mode=void 0,this.verbose=void 0,this.displayedMemory=void 0,this.nonDisplayedMemory=void 0,this.lastOutputScreen=void 0,this.currRollUpRow=void 0,this.writeScreen=void 0,this.cueStartTime=void 0,this.logger=void 0,this.chNr=t,this.outputFilter=e,this.mode=null,this.verbose=0,this.displayedMemory=new Dc(i),this.nonDisplayedMemory=new Dc(i),this.lastOutputScreen=new Dc(i),this.currRollUpRow=this.displayedMemory.rows[wc-1],this.writeScreen=this.displayedMemory,this.mode=null,this.cueStartTime=null,this.logger=i}reset(){this.mode=null,this.displayedMemory.reset(),this.nonDisplayedMemory.reset(),this.lastOutputScreen.reset(),this.outputFilter.reset(),this.currRollUpRow=this.displayedMemory.rows[wc-1],this.writeScreen=this.displayedMemory,this.mode=null,this.cueStartTime=null}getHandler(){return this.outputFilter}setHandler(t){this.outputFilter=t}setPAC(t){this.writeScreen.setPAC(t)}setBkgData(t){this.writeScreen.setBkgData(t)}setMode(t){t!==this.mode&&(this.mode=t,this.logger.log(2,(()=>"MODE="+t)),"MODE_POP-ON"===this.mode?this.writeScreen=this.nonDisplayedMemory:(this.writeScreen=this.displayedMemory,this.writeScreen.reset()),"MODE_ROLL-UP"!==this.mode&&(this.displayedMemory.nrRollUpRows=null,this.nonDisplayedMemory.nrRollUpRows=null),this.mode=t)}insertChars(t){for(let i=0;i<t.length;i++)this.writeScreen.insertChar(t[i]);const e=this.writeScreen===this.displayedMemory?"DISP":"NON_DISP";this.logger.log(2,(()=>e+": "+this.writeScreen.getDisplayText(!0))),"MODE_PAINT-ON"!==this.mode&&"MODE_ROLL-UP"!==this.mode||(this.logger.log(1,(()=>"DISPLAYED: "+this.displayedMemory.getDisplayText(!0))),this.outputDataUpdate())}ccRCL(){this.logger.log(2,"RCL - Resume Caption Loading"),this.setMode("MODE_POP-ON")}ccBS(){this.logger.log(2,"BS - BackSpace"),"MODE_TEXT"!==this.mode&&(this.writeScreen.backSpace(),this.writeScreen===this.displayedMemory&&this.outputDataUpdate())}ccAOF(){}ccAON(){}ccDER(){this.logger.log(2,"DER- Delete to End of Row"),this.writeScreen.clearToEndOfRow(),this.outputDataUpdate()}ccRU(t){this.logger.log(2,"RU("+t+") - Roll Up"),this.writeScreen=this.displayedMemory,this.setMode("MODE_ROLL-UP"),this.writeScreen.setRollUpRows(t)}ccFON(){this.logger.log(2,"FON - Flash On"),this.writeScreen.setPen({flash:!0})}ccRDC(){this.logger.log(2,"RDC - Resume Direct Captioning"),this.setMode("MODE_PAINT-ON")}ccTR(){this.logger.log(2,"TR"),this.setMode("MODE_TEXT")}ccRTD(){this.logger.log(2,"RTD"),this.setMode("MODE_TEXT")}ccEDM(){this.logger.log(2,"EDM - Erase Displayed Memory"),this.displayedMemory.reset(),this.outputDataUpdate(!0)}ccCR(){this.logger.log(2,"CR - Carriage Return"),this.writeScreen.rollUp(),this.outputDataUpdate(!0)}ccENM(){this.logger.log(2,"ENM - Erase Non-displayed Memory"),this.nonDisplayedMemory.reset()}ccEOC(){if(this.logger.log(2,"EOC - End Of Caption"),"MODE_POP-ON"===this.mode){const t=this.displayedMemory;this.displayedMemory=this.nonDisplayedMemory,this.nonDisplayedMemory=t,this.writeScreen=this.nonDisplayedMemory,this.logger.log(1,(()=>"DISP: "+this.displayedMemory.getDisplayText()))}this.outputDataUpdate(!0)}ccTO(t){this.logger.log(2,"TO("+t+") - Tab Offset"),this.writeScreen.moveCursor(t)}ccMIDROW(t){const e={flash:!1};if(e.underline=t%2===1,e.italics=t>=46,e.italics)e.foreground="white";else{const i=Math.floor(t/2)-16,s=["white","green","blue","cyan","red","yellow","magenta"];e.foreground=s[i]}this.logger.log(2,"MIDROW: "+JSON.stringify(e)),this.writeScreen.setPen(e)}outputDataUpdate(t=!1){const e=this.logger.time;null!==e&&this.outputFilter&&(null!==this.cueStartTime||this.displayedMemory.isEmpty()?this.displayedMemory.equals(this.lastOutputScreen)||(this.outputFilter.newCue(this.cueStartTime,e,this.lastOutputScreen),t&&this.outputFilter.dispatchCue&&this.outputFilter.dispatchCue(),this.cueStartTime=this.displayedMemory.isEmpty()?null:e):this.cueStartTime=e,this.lastOutputScreen.copy(this.displayedMemory))}cueSplitAtTime(t){this.outputFilter&&(this.displayedMemory.isEmpty()||(this.outputFilter.newCue&&this.outputFilter.newCue(this.cueStartTime,t,this.displayedMemory),this.cueStartTime=t))}}class Oc{constructor(t,e,i){this.channels=void 0,this.currentChannel=0,this.cmdHistory=Fc(),this.logger=void 0;const s=this.logger=new kc;this.channels=[null,new Pc(t,e,s),new Pc(t+1,i,s)]}getHandler(t){return this.channels[t].getHandler()}setHandler(t,e){this.channels[t].setHandler(e)}addData(t,e){this.logger.time=t;for(let i=0;i<e.length;i+=2){const t=127&e[i],s=127&e[i+1];let n=!1,r=null;if(0===t&&0===s)continue;this.logger.log(3,(()=>"["+Lc([e[i],e[i+1]])+"] -> ("+Lc([t,s])+")"));const o=this.cmdHistory,a=t>=16&&t<=31;if(a){if(Nc(t,s,o)){Mc(null,null,o),this.logger.log(3,(()=>"Repeated command ("+Lc([t,s])+") is dropped"));continue}Mc(t,s,this.cmdHistory),n=this.parseCmd(t,s),n||(n=this.parseMidrow(t,s)),n||(n=this.parsePAC(t,s)),n||(n=this.parseBackgroundAttributes(t,s))}else Mc(null,null,o);if(!n&&(r=this.parseChars(t,s),r)){const t=this.currentChannel;if(t&&t>0){const e=this.channels[t];e.insertChars(r)}else this.logger.log(2,"No channel found yet. TEXT-MODE?")}n||r||this.logger.log(2,(()=>"Couldn't parse cleaned data "+Lc([t,s])+" orig: "+Lc([e[i],e[i+1]])))}}parseCmd(t,e){const i=(20===t||28===t||21===t||29===t)&&e>=32&&e<=47,s=(23===t||31===t)&&e>=33&&e<=35;if(!i&&!s)return!1;const n=20===t||21===t||23===t?1:2,r=this.channels[n];return 20===t||21===t||28===t||29===t?32===e?r.ccRCL():33===e?r.ccBS():34===e?r.ccAOF():35===e?r.ccAON():36===e?r.ccDER():37===e?r.ccRU(2):38===e?r.ccRU(3):39===e?r.ccRU(4):40===e?r.ccFON():41===e?r.ccRDC():42===e?r.ccTR():43===e?r.ccRTD():44===e?r.ccEDM():45===e?r.ccCR():46===e?r.ccENM():47===e&&r.ccEOC():r.ccTO(e-32),this.currentChannel=n,!0}parseMidrow(t,e){let i=0;if((17===t||25===t)&&e>=32&&e<=47){if(i=17===t?1:2,i!==this.currentChannel)return this.logger.log(0,"Mismatch channel in midrow parsing"),!1;const s=this.channels[i];return!!s&&(s.ccMIDROW(e),this.logger.log(3,(()=>"MIDROW ("+Lc([t,e])+")")),!0)}return!1}parsePAC(t,e){let i;const s=(t>=17&&t<=23||t>=25&&t<=31)&&e>=64&&e<=127,n=(16===t||24===t)&&e>=64&&e<=95;if(!s&&!n)return!1;const r=t<=23?1:2;i=e>=64&&e<=95?1===r?Ec[t]:xc[t]:1===r?Tc[t]:Cc[t];const o=this.channels[r];return!!o&&(o.setPAC(this.interpretPAC(i,e)),this.currentChannel=r,!0)}interpretPAC(t,e){let i;const s={color:null,italics:!1,indent:null,underline:!1,row:t};return i=e>95?e-96:e-64,s.underline=1===(1&i),i<=13?s.color=["white","green","blue","cyan","red","yellow","magenta","white"][Math.floor(i/2)]:i<=15?(s.italics=!0,s.color="white"):s.indent=4*Math.floor((i-16)/2),s}parseChars(t,e){let i,s=null,n=null;if(t>=25?(i=2,n=t-8):(i=1,n=t),n>=17&&n<=19){let t;t=17===n?e+80:18===n?e+112:e+144,this.logger.log(2,(()=>"Special char '"+bc(t)+"' in channel "+i)),s=[t]}else t>=32&&t<=127&&(s=0===e?[t]:[t,e]);return s&&this.logger.log(3,(()=>"Char codes =  "+Lc(s).join(","))),s}parseBackgroundAttributes(t,e){const i=(16===t||24===t)&&e>=32&&e<=47,s=(23===t||31===t)&&e>=45&&e<=47;if(!i&&!s)return!1;let n;const r={};16===t||24===t?(n=Math.floor((e-32)/2),r.background=_c[n],e%2===1&&(r.background=r.background+"_semi")):45===e?r.background="transparent":(r.foreground="black",47===e&&(r.underline=!0));const o=t<=23?1:2,a=this.channels[o];return a.setBkgData(r),!0}reset(){for(let t=0;t<Object.keys(this.channels).length;t++){const e=this.channels[t];e&&e.reset()}Mc(null,null,this.cmdHistory)}cueSplitAtTime(t){for(let e=0;e<this.channels.length;e++){const i=this.channels[e];i&&i.cueSplitAtTime(t)}}}function Mc(t,e,i){i.a=t,i.b=e}function Nc(t,e,i){return i.a===t&&i.b===e}function Fc(){return{a:null,b:null}}class Bc{constructor(t,e){this.timelineController=void 0,this.cueRanges=[],this.trackName=void 0,this.startTime=null,this.endTime=null,this.screen=null,this.timelineController=t,this.trackName=e}dispatchCue(){null!==this.startTime&&(this.timelineController.addCues(this.trackName,this.startTime,this.endTime,this.screen,this.cueRanges),this.startTime=null)}newCue(t,e,i){(null===this.startTime||this.startTime>t)&&(this.startTime=t),this.endTime=e,this.screen=i,this.timelineController.createCaptionsTrack(this.trackName)}reset(){this.cueRanges=[],this.startTime=null}}var $c=function(){if(null!=_s&&_s.VTTCue)return self.VTTCue;const t=["","lr","rl"],e=["start","middle","end","left","right"];function i(t,e){if("string"!==typeof e)return!1;if(!Array.isArray(t))return!1;const i=e.toLowerCase();return!!~t.indexOf(i)&&i}function s(e){return i(t,e)}function n(t){return i(e,t)}function r(t,...e){let i=1;for(;i<arguments.length;i++){const e=arguments[i];for(const i in e)t[i]=e[i]}return t}function o(t,e,i){const o=this,a={enumerable:!0};o.hasBeenReset=!1;let l="",c=!1,d=t,u=e,h=i,p=null,f="",m=!0,v="auto",g="start",y=50,b="middle",w=50,S="middle";Object.defineProperty(o,"id",r({},a,{get:function(){return l},set:function(t){l=""+t}})),Object.defineProperty(o,"pauseOnExit",r({},a,{get:function(){return c},set:function(t){c=!!t}})),Object.defineProperty(o,"startTime",r({},a,{get:function(){return d},set:function(t){if("number"!==typeof t)throw new TypeError("Start time must be set to a number.");d=t,this.hasBeenReset=!0}})),Object.defineProperty(o,"endTime",r({},a,{get:function(){return u},set:function(t){if("number"!==typeof t)throw new TypeError("End time must be set to a number.");u=t,this.hasBeenReset=!0}})),Object.defineProperty(o,"text",r({},a,{get:function(){return h},set:function(t){h=""+t,this.hasBeenReset=!0}})),Object.defineProperty(o,"region",r({},a,{get:function(){return p},set:function(t){p=t,this.hasBeenReset=!0}})),Object.defineProperty(o,"vertical",r({},a,{get:function(){return f},set:function(t){const e=s(t);if(!1===e)throw new SyntaxError("An invalid or illegal string was specified.");f=e,this.hasBeenReset=!0}})),Object.defineProperty(o,"snapToLines",r({},a,{get:function(){return m},set:function(t){m=!!t,this.hasBeenReset=!0}})),Object.defineProperty(o,"line",r({},a,{get:function(){return v},set:function(t){if("number"!==typeof t&&"auto"!==t)throw new SyntaxError("An invalid number or illegal string was specified.");v=t,this.hasBeenReset=!0}})),Object.defineProperty(o,"lineAlign",r({},a,{get:function(){return g},set:function(t){const e=n(t);if(!e)throw new SyntaxError("An invalid or illegal string was specified.");g=e,this.hasBeenReset=!0}})),Object.defineProperty(o,"position",r({},a,{get:function(){return y},set:function(t){if(t<0||t>100)throw new Error("Position must be between 0 and 100.");y=t,this.hasBeenReset=!0}})),Object.defineProperty(o,"positionAlign",r({},a,{get:function(){return b},set:function(t){const e=n(t);if(!e)throw new SyntaxError("An invalid or illegal string was specified.");b=e,this.hasBeenReset=!0}})),Object.defineProperty(o,"size",r({},a,{get:function(){return w},set:function(t){if(t<0||t>100)throw new Error("Size must be between 0 and 100.");w=t,this.hasBeenReset=!0}})),Object.defineProperty(o,"align",r({},a,{get:function(){return S},set:function(t){const e=n(t);if(!e)throw new SyntaxError("An invalid or illegal string was specified.");S=e,this.hasBeenReset=!0}})),o.displayState=void 0}return o.prototype.getCueAsHTML=function(){const t=self.WebVTT;return t.convertCueToDOMTree(self,this.text)},o}();class Uc{decode(t,e){if(!t)return"";if("string"!==typeof t)throw new Error("Error - expected string data.");return decodeURIComponent(encodeURIComponent(t))}}function jc(t){function e(t,e,i,s){return 3600*(0|t)+60*(0|e)+(0|i)+parseFloat(s||0)}const i=t.match(/^(?:(\d+):)?(\d{2}):(\d{2})(\.\d+)?/);return i?parseFloat(i[2])>59?e(i[2],i[3],0,i[4]):e(i[1],i[2],i[3],i[4]):null}class qc{constructor(){this.values=Object.create(null)}set(t,e){this.get(t)||""===e||(this.values[t]=e)}get(t,e,i){return i?this.has(t)?this.values[t]:e[i]:this.has(t)?this.values[t]:e}has(t){return t in this.values}alt(t,e,i){for(let s=0;s<i.length;++s)if(e===i[s]){this.set(t,e);break}}integer(t,e){/^-?\d+$/.test(e)&&this.set(t,parseInt(e,10))}percent(t,e){if(/^([\d]{1,3})(\.[\d]*)?%$/.test(e)){const i=parseFloat(e);if(i>=0&&i<=100)return this.set(t,i),!0}return!1}}function Gc(t,e,i,s){const n=s?t.split(s):[t];for(const r in n){if("string"!==typeof n[r])continue;const t=n[r].split(i);if(2!==t.length)continue;const s=t[0],o=t[1];e(s,o)}}const Vc=new $c(0,0,""),Hc="middle"===Vc.align?"middle":"center";function zc(t,e,i){const s=t;function n(){const e=jc(t);if(null===e)throw new Error("Malformed timestamp: "+s);return t=t.replace(/^[^\sa-zA-Z-]+/,""),e}function r(t,e){const s=new qc;Gc(t,(function(t,e){let n;switch(t){case"region":for(let n=i.length-1;n>=0;n--)if(i[n].id===e){s.set(t,i[n].region);break}break;case"vertical":s.alt(t,e,["rl","lr"]);break;case"line":n=e.split(","),s.integer(t,n[0]),s.percent(t,n[0])&&s.set("snapToLines",!1),s.alt(t,n[0],["auto"]),2===n.length&&s.alt("lineAlign",n[1],["start",Hc,"end"]);break;case"position":n=e.split(","),s.percent(t,n[0]),2===n.length&&s.alt("positionAlign",n[1],["start",Hc,"end","line-left","line-right","auto"]);break;case"size":s.percent(t,e);break;case"align":s.alt(t,e,["start",Hc,"end","left","right"]);break}}),/:/,/\s/),e.region=s.get("region",null),e.vertical=s.get("vertical","");let n=s.get("line","auto");"auto"===n&&-1===Vc.line&&(n=-1),e.line=n,e.lineAlign=s.get("lineAlign","start"),e.snapToLines=s.get("snapToLines",!0),e.size=s.get("size",100),e.align=s.get("align",Hc);let r=s.get("position","auto");"auto"===r&&50===Vc.position&&(r="start"===e.align||"left"===e.align?0:"end"===e.align||"right"===e.align?100:50),e.position=r}function o(){t=t.replace(/^\s+/,"")}if(o(),e.startTime=n(),o(),"--\x3e"!==t.slice(0,3))throw new Error("Malformed time stamp (time stamps must be separated by '--\x3e'): "+s);t=t.slice(3),o(),e.endTime=n(),o(),r(t,e)}function Kc(t){return t.replace(/<br(?: \/)?>/gi,"\n")}class Wc{constructor(){this.state="INITIAL",this.buffer="",this.decoder=new Uc,this.regionList=[],this.cue=null,this.oncue=void 0,this.onparsingerror=void 0,this.onflush=void 0}parse(t){const e=this;function i(){let t=e.buffer,i=0;t=Kc(t);while(i<t.length&&"\r"!==t[i]&&"\n"!==t[i])++i;const s=t.slice(0,i);return"\r"===t[i]&&++i,"\n"===t[i]&&++i,e.buffer=t.slice(i),s}function s(t){Gc(t,(function(t,e){}),/:/)}t&&(e.buffer+=e.decoder.decode(t,{stream:!0}));try{let t="";if("INITIAL"===e.state){if(!/\r\n|\n/.test(e.buffer))return this;t=i();const s=t.match(/^(ï»¿)?WEBVTT([ \t].*)?$/);if(null==s||!s[0])throw new Error("Malformed WebVTT signature.");e.state="HEADER"}let r=!1;while(e.buffer){if(!/\r\n|\n/.test(e.buffer))return this;switch(r?r=!1:t=i(),e.state){case"HEADER":/:/.test(t)?s(t):t||(e.state="ID");continue;case"NOTE":t||(e.state="ID");continue;case"ID":if(/^NOTE($|[ \t])/.test(t)){e.state="NOTE";break}if(!t)continue;if(e.cue=new $c(0,0,""),e.state="CUE",-1===t.indexOf("--\x3e")){e.cue.id=t;continue}case"CUE":if(!e.cue){e.state="BADCUE";continue}try{zc(t,e.cue,e.regionList)}catch(n){e.cue=null,e.state="BADCUE";continue}e.state="CUETEXT";continue;case"CUETEXT":{const i=-1!==t.indexOf("--\x3e");if(!t||i&&(r=!0)){e.oncue&&e.cue&&e.oncue(e.cue),e.cue=null,e.state="ID";continue}if(null===e.cue)continue;e.cue.text&&(e.cue.text+="\n"),e.cue.text+=t}continue;case"BADCUE":t||(e.state="ID")}}}catch(n){"CUETEXT"===e.state&&e.cue&&e.oncue&&e.oncue(e.cue),e.cue=null,e.state="INITIAL"===e.state?"BADWEBVTT":"BADCUE"}return this}flush(){const t=this;try{if((t.cue||"HEADER"===t.state)&&(t.buffer+="\n\n",t.parse()),"INITIAL"===t.state||"BADWEBVTT"===t.state)throw new Error("Malformed WebVTT signature.")}catch(e){t.onparsingerror&&t.onparsingerror(e)}return t.onflush&&t.onflush(),this}}const Yc=/\r\n|\n\r|\n|\r/g,Xc=function(t,e,i=0){return t.slice(i,i+e.length)===e},Zc=function(t){let e=parseInt(t.slice(-3));const i=parseInt(t.slice(-6,-4)),s=parseInt(t.slice(-9,-7)),n=t.length>9?parseInt(t.substring(0,t.indexOf(":"))):0;if(!Yi(e)||!Yi(i)||!Yi(s)||!Yi(n))throw Error(`Malformed X-TIMESTAMP-MAP: Local:${t}`);return e+=1e3*i,e+=6e4*s,e+=36e5*n,e},Qc=function(t){let e=5381,i=t.length;while(i)e=33*e^t.charCodeAt(--i);return(e>>>0).toString()};function Jc(t,e,i){return Qc(t.toString())+Qc(e.toString())+Qc(i)}const td=function(t,e,i){let s=t[e],n=t[s.prevCC];if(!n||!n.new&&s.new)return t.ccOffset=t.presentationOffset=s.start,void(s.new=!1);while(null!=(r=n)&&r.new){var r;t.ccOffset+=s.start-n.start,s.new=!1,s=n,n=t[s.prevCC]}t.presentationOffset=i};function ed(t,e,i,s,n,r,o){const a=new Wc,l=Qs(new Uint8Array(t)).trim().replace(Yc,"\n").split("\n"),c=[],d=e?Al(e.baseTime,e.timescale):0;let u,h="00:00.000",p=0,f=0,m=!0;a.oncue=function(t){const r=i[s];let o=i.ccOffset;const a=(p-d)/9e4;if(null!=r&&r.new&&(void 0!==f?o=i.ccOffset=r.start:td(i,s,a)),a){if(!e)return void(u=new Error("Missing initPTS for VTT MPEGTS"));o=a-i.presentationOffset}const l=t.endTime-t.startTime,h=Bl(9e4*(t.startTime+o-f),9e4*n)/9e4;t.startTime=Math.max(h,0),t.endTime=Math.max(h+l,0);const m=t.text.trim();t.text=decodeURIComponent(encodeURIComponent(m)),t.id||(t.id=Jc(t.startTime,t.endTime,m)),t.endTime>0&&c.push(t)},a.onparsingerror=function(t){u=t},a.onflush=function(){u?o(u):r(c)},l.forEach((t=>{if(m){if(Xc(t,"X-TIMESTAMP-MAP=")){m=!1,t.slice(16).split(",").forEach((t=>{Xc(t,"LOCAL:")?h=t.slice(6):Xc(t,"MPEGTS:")&&(p=parseInt(t.slice(7)))}));try{f=Zc(h)/1e3}catch(e){u=e}return}""===t&&(m=!1)}a.parse(t+"\n")})),a.flush()}const id="stpp.ttml.im1t",sd=/^(\d{2,}):(\d{2}):(\d{2}):(\d{2})\.?(\d+)?$/,nd=/^(\d*(?:\.\d*)?)(h|m|s|ms|f|t)$/,rd={left:"start",center:"center",right:"end",start:"start",end:"end"};function od(t,e,i,s){const n=pn(new Uint8Array(t),["mdat"]);if(0===n.length)return void s(new Error("Could not parse IMSC1 mdat"));const r=n.map((t=>Qs(t))),o=kl(e.baseTime,1,e.timescale);try{r.forEach((t=>i(ad(t,o))))}catch(a){s(a)}}function ad(t,e){const i=new DOMParser,s=i.parseFromString(t,"text/xml"),n=s.getElementsByTagName("tt")[0];if(!n)throw new Error("Invalid ttml");const r={frameRate:30,subFrameRate:1,frameRateMultiplier:0,tickRate:0},o=Object.keys(r).reduce(((t,e)=>(t[e]=n.getAttribute(`ttp:${e}`)||r[e],t)),{}),a="preserve"!==n.getAttribute("xml:space"),l=cd(ld(n,"styling","style")),c=cd(ld(n,"layout","region")),d=ld(n,"body","[begin]");return[].map.call(d,(t=>{const i=dd(t,a);if(!i||!t.hasAttribute("begin"))return null;const s=fd(t.getAttribute("begin"),o),n=fd(t.getAttribute("dur"),o);let r=fd(t.getAttribute("end"),o);if(null===s)throw pd(t);if(null===r){if(null===n)throw pd(t);r=s+n}const d=new $c(s-e,r-e,i);d.id=Jc(d.startTime,d.endTime,d.text);const u=c[t.getAttribute("region")],h=l[t.getAttribute("style")],p=ud(u,h,l),{textAlign:f}=p;if(f){const t=rd[f];t&&(d.lineAlign=t),d.align=f}return Wi(d,p),d})).filter((t=>null!==t))}function ld(t,e,i){const s=t.getElementsByTagName(e)[0];return s?[].slice.call(s.querySelectorAll(i)):[]}function cd(t){return t.reduce(((t,e)=>{const i=e.getAttribute("xml:id");return i&&(t[i]=e),t}),{})}function dd(t,e){return[].slice.call(t.childNodes).reduce(((t,i,s)=>{var n;return"br"===i.nodeName&&s?t+"\n":null!=(n=i.childNodes)&&n.length?dd(i,e):e?t+i.textContent.trim().replace(/\s+/g," "):t+i.textContent}),"")}function ud(t,e,i){const s="http://www.w3.org/ns/ttml#styling";let n=null;const r=["displayAlign","textAlign","color","backgroundColor","fontSize","fontFamily"],o=null!=t&&t.hasAttribute("style")?t.getAttribute("style"):null;return o&&i.hasOwnProperty(o)&&(n=i[o]),r.reduce(((i,r)=>{const o=hd(e,s,r)||hd(t,s,r)||hd(n,s,r);return o&&(i[r]=o),i}),{})}function hd(t,e,i){return t&&t.hasAttributeNS(e,i)?t.getAttributeNS(e,i):null}function pd(t){return new Error(`Could not parse ttml timestamp ${t}`)}function fd(t,e){if(!t)return null;let i=jc(t);return null===i&&(sd.test(t)?i=md(t,e):nd.test(t)&&(i=vd(t,e))),i}function md(t,e){const i=sd.exec(t),s=(0|i[4])+(0|i[5])/e.subFrameRate;return 3600*(0|i[1])+60*(0|i[2])+(0|i[3])+s/e.frameRate}function vd(t,e){const i=nd.exec(t),s=Number(i[1]),n=i[2];switch(n){case"h":return 3600*s;case"m":return 60*s;case"ms":return 1e3*s;case"f":return s/e.frameRate;case"t":return s/e.tickRate}return s}class gd{constructor(t){this.hls=void 0,this.media=null,this.config=void 0,this.enabled=!0,this.Cues=void 0,this.textTracks=[],this.tracks=[],this.initPTS=[],this.unparsedVttFrags=[],this.captionsTracks={},this.nonNativeCaptionsTracks={},this.cea608Parser1=void 0,this.cea608Parser2=void 0,this.lastCc=-1,this.lastSn=-1,this.lastPartIndex=-1,this.prevCC=-1,this.vttCCs=Sd(),this.captionsProperties=void 0,this.hls=t,this.config=t.config,this.Cues=t.config.cueHandler,this.captionsProperties={textTrack1:{label:this.config.captionsTextTrack1Label,languageCode:this.config.captionsTextTrack1LanguageCode},textTrack2:{label:this.config.captionsTextTrack2Label,languageCode:this.config.captionsTextTrack2LanguageCode},textTrack3:{label:this.config.captionsTextTrack3Label,languageCode:this.config.captionsTextTrack3LanguageCode},textTrack4:{label:this.config.captionsTextTrack4Label,languageCode:this.config.captionsTextTrack4LanguageCode}},t.on(Qi.MEDIA_ATTACHING,this.onMediaAttaching,this),t.on(Qi.MEDIA_DETACHING,this.onMediaDetaching,this),t.on(Qi.MANIFEST_LOADING,this.onManifestLoading,this),t.on(Qi.MANIFEST_LOADED,this.onManifestLoaded,this),t.on(Qi.SUBTITLE_TRACKS_UPDATED,this.onSubtitleTracksUpdated,this),t.on(Qi.FRAG_LOADING,this.onFragLoading,this),t.on(Qi.FRAG_LOADED,this.onFragLoaded,this),t.on(Qi.FRAG_PARSING_USERDATA,this.onFragParsingUserdata,this),t.on(Qi.FRAG_DECRYPTED,this.onFragDecrypted,this),t.on(Qi.INIT_PTS_FOUND,this.onInitPtsFound,this),t.on(Qi.SUBTITLE_TRACKS_CLEARED,this.onSubtitleTracksCleared,this),t.on(Qi.BUFFER_FLUSHING,this.onBufferFlushing,this)}destroy(){const{hls:t}=this;t.off(Qi.MEDIA_ATTACHING,this.onMediaAttaching,this),t.off(Qi.MEDIA_DETACHING,this.onMediaDetaching,this),t.off(Qi.MANIFEST_LOADING,this.onManifestLoading,this),t.off(Qi.MANIFEST_LOADED,this.onManifestLoaded,this),t.off(Qi.SUBTITLE_TRACKS_UPDATED,this.onSubtitleTracksUpdated,this),t.off(Qi.FRAG_LOADING,this.onFragLoading,this),t.off(Qi.FRAG_LOADED,this.onFragLoaded,this),t.off(Qi.FRAG_PARSING_USERDATA,this.onFragParsingUserdata,this),t.off(Qi.FRAG_DECRYPTED,this.onFragDecrypted,this),t.off(Qi.INIT_PTS_FOUND,this.onInitPtsFound,this),t.off(Qi.SUBTITLE_TRACKS_CLEARED,this.onSubtitleTracksCleared,this),t.off(Qi.BUFFER_FLUSHING,this.onBufferFlushing,this),this.hls=this.config=null,this.cea608Parser1=this.cea608Parser2=void 0}initCea608Parsers(){if(this.config.enableCEA708Captions&&(!this.cea608Parser1||!this.cea608Parser2)){const t=new Bc(this,"textTrack1"),e=new Bc(this,"textTrack2"),i=new Bc(this,"textTrack3"),s=new Bc(this,"textTrack4");this.cea608Parser1=new Oc(1,t,e),this.cea608Parser2=new Oc(3,i,s)}}addCues(t,e,i,s,n){let r=!1;for(let o=n.length;o--;){const t=n[o],s=wd(t[0],t[1],e,i);if(s>=0&&(t[0]=Math.min(t[0],e),t[1]=Math.max(t[1],i),r=!0,s/(i-e)>.5))return}if(r||n.push([e,i]),this.config.renderTextTracksNatively){const n=this.captionsTracks[t];this.Cues.newCue(n,e,i,s)}else{const n=this.Cues.newCue(null,e,i,s);this.hls.trigger(Qi.CUES_PARSED,{type:"captions",cues:n,track:t})}}onInitPtsFound(t,{frag:e,id:i,initPTS:s,timescale:n}){const{unparsedVttFrags:r}=this;"main"===i&&(this.initPTS[e.cc]={baseTime:s,timescale:n}),r.length&&(this.unparsedVttFrags=[],r.forEach((t=>{this.onFragLoaded(Qi.FRAG_LOADED,t)})))}getExistingTrack(t,e){const{media:i}=this;if(i)for(let s=0;s<i.textTracks.length;s++){const n=i.textTracks[s];if(bd(n,{name:t,lang:e,attrs:{}}))return n}return null}createCaptionsTrack(t){this.config.renderTextTracksNatively?this.createNativeTrack(t):this.createNonNativeTrack(t)}createNativeTrack(t){if(this.captionsTracks[t])return;const{captionsProperties:e,captionsTracks:i,media:s}=this,{label:n,languageCode:r}=e[t],o=this.getExistingTrack(n,r);if(o)i[t]=o,Ar(i[t]),kr(i[t],s);else{const e=this.createTextTrack("captions",n,r);e&&(e[t]=!0,i[t]=e)}}createNonNativeTrack(t){if(this.nonNativeCaptionsTracks[t])return;const e=this.captionsProperties[t];if(!e)return;const i=e.label,s={_id:t,label:i,kind:"captions",default:!!e.media&&!!e.media.default,closedCaptions:e.media};this.nonNativeCaptionsTracks[t]=s,this.hls.trigger(Qi.NON_NATIVE_TEXT_TRACKS_FOUND,{tracks:[s]})}createTextTrack(t,e,i){const s=this.media;if(s)return s.addTextTrack(t,e,i)}onMediaAttaching(t,e){this.media=e.media,this._cleanTracks()}onMediaDetaching(){const{captionsTracks:t}=this;Object.keys(t).forEach((e=>{Ar(t[e]),delete t[e]})),this.nonNativeCaptionsTracks={}}onManifestLoading(){this.lastCc=-1,this.lastSn=-1,this.lastPartIndex=-1,this.prevCC=-1,this.vttCCs=Sd(),this._cleanTracks(),this.tracks=[],this.captionsTracks={},this.nonNativeCaptionsTracks={},this.textTracks=[],this.unparsedVttFrags=[],this.initPTS=[],this.cea608Parser1&&this.cea608Parser2&&(this.cea608Parser1.reset(),this.cea608Parser2.reset())}_cleanTracks(){const{media:t}=this;if(!t)return;const e=t.textTracks;if(e)for(let i=0;i<e.length;i++)Ar(e[i])}onSubtitleTracksUpdated(t,e){const i=e.subtitleTracks||[],s=i.some((t=>t.textCodec===id));if(this.config.enableWebVTT||s&&this.config.enableIMSC1){const t=sc(this.tracks,i);if(t)return void(this.tracks=i);if(this.textTracks=[],this.tracks=i,this.config.renderTextTracksNatively){const t=this.media,e=t?Pr(t.textTracks):null;if(this.tracks.forEach(((t,i)=>{let s;if(e){let i=null;for(let s=0;s<e.length;s++)if(e[s]&&bd(e[s],t)){i=e[s],e[s]=null;break}i&&(s=i)}if(s)Ar(s);else{const e=yd(t);s=this.createTextTrack(e,t.name,t.lang),s&&(s.mode="disabled")}s&&this.textTracks.push(s)})),null!=e&&e.length){const t=e.filter((t=>null!==t)).map((t=>t.label));t.length&&as.warn(`Media element contains unused subtitle tracks: ${t.join(", ")}. Replace media element for each source to clear TextTracks and captions menu.`)}}else if(this.tracks.length){const t=this.tracks.map((t=>({label:t.name,kind:t.type.toLowerCase(),default:t.default,subtitleTrack:t})));this.hls.trigger(Qi.NON_NATIVE_TEXT_TRACKS_FOUND,{tracks:t})}}}onManifestLoaded(t,e){this.config.enableCEA708Captions&&e.captions&&e.captions.forEach((t=>{const e=/(?:CC|SERVICE)([1-4])/.exec(t.instreamId);if(!e)return;const i=`textTrack${e[1]}`,s=this.captionsProperties[i];s&&(s.label=t.name,t.lang&&(s.languageCode=t.lang),s.media=t)}))}closedCaptionsForLevel(t){const e=this.hls.levels[t.level];return null==e?void 0:e.attrs["CLOSED-CAPTIONS"]}onFragLoading(t,e){if(this.enabled&&e.frag.type===Tr.MAIN){var i,s;const{cea608Parser1:t,cea608Parser2:n,lastSn:r}=this,{cc:o,sn:a}=e.frag,l=null!=(i=null==(s=e.part)?void 0:s.index)?i:-1;t&&n&&(a!==r+1||a===r&&l!==this.lastPartIndex+1||o!==this.lastCc)&&(t.reset(),n.reset()),this.lastCc=o,this.lastSn=a,this.lastPartIndex=l}}onFragLoaded(t,e){const{frag:i,payload:s}=e;if(i.type===Tr.SUBTITLE)if(s.byteLength){const t=i.decryptdata,n="stats"in e;if(null==t||!t.encrypted||n){const t=this.tracks[i.level],n=this.vttCCs;n[i.cc]||(n[i.cc]={start:i.start,prevCC:this.prevCC,new:!0},this.prevCC=i.cc),t&&t.textCodec===id?this._parseIMSC1(i,s):this._parseVTTs(e)}}else this.hls.trigger(Qi.SUBTITLE_FRAG_PROCESSED,{success:!1,frag:i,error:new Error("Empty subtitle payload")})}_parseIMSC1(t,e){const i=this.hls;od(e,this.initPTS[t.cc],(e=>{this._appendCues(e,t.level),i.trigger(Qi.SUBTITLE_FRAG_PROCESSED,{success:!0,frag:t})}),(e=>{as.log(`Failed to parse IMSC1: ${e}`),i.trigger(Qi.SUBTITLE_FRAG_PROCESSED,{success:!1,frag:t,error:e})}))}_parseVTTs(t){var e;const{frag:i,payload:s}=t,{initPTS:n,unparsedVttFrags:r}=this,o=n.length-1;if(!n[i.cc]&&-1===o)return void r.push(t);const a=this.hls,l=null!=(e=i.initSegment)&&e.data?kn(i.initSegment.data,new Uint8Array(s)):s;ed(l,this.initPTS[i.cc],this.vttCCs,i.cc,i.start,(t=>{this._appendCues(t,i.level),a.trigger(Qi.SUBTITLE_FRAG_PROCESSED,{success:!0,frag:i})}),(e=>{const n="Missing initPTS for VTT MPEGTS"===e.message;n?r.push(t):this._fallbackToIMSC1(i,s),as.log(`Failed to parse VTT cue: ${e}`),n&&o>i.cc||a.trigger(Qi.SUBTITLE_FRAG_PROCESSED,{success:!1,frag:i,error:e})}))}_fallbackToIMSC1(t,e){const i=this.tracks[t.level];i.textCodec||od(e,this.initPTS[t.cc],(()=>{i.textCodec=id,this._parseIMSC1(t,e)}),(()=>{i.textCodec="wvtt"}))}_appendCues(t,e){const i=this.hls;if(this.config.renderTextTracksNatively){const i=this.textTracks[e];if(!i||"disabled"===i.mode)return;t.forEach((t=>Lr(i,t)))}else{const s=this.tracks[e];if(!s)return;const n=s.default?"default":"subtitles"+e;i.trigger(Qi.CUES_PARSED,{type:"subtitles",cues:t,track:n})}}onFragDecrypted(t,e){const{frag:i}=e;i.type===Tr.SUBTITLE&&this.onFragLoaded(Qi.FRAG_LOADED,e)}onSubtitleTracksCleared(){this.tracks=[],this.captionsTracks={}}onFragParsingUserdata(t,e){this.initCea608Parsers();const{cea608Parser1:i,cea608Parser2:s}=this;if(!this.enabled||!i||!s)return;const{frag:n,samples:r}=e;if(n.type!==Tr.MAIN||"NONE"!==this.closedCaptionsForLevel(n))for(let o=0;o<r.length;o++){const t=r[o].bytes;if(t){const e=this.extractCea608Data(t);i.addData(r[o].pts,e[0]),s.addData(r[o].pts,e[1])}}}onBufferFlushing(t,{startOffset:e,endOffset:i,endOffsetSubtitles:s,type:n}){const{media:r}=this;if(r&&!(r.currentTime<i)){if(!n||"video"===n){const{captionsTracks:t}=this;Object.keys(t).forEach((s=>Rr(t[s],e,i)))}if(this.config.renderTextTracksNatively&&0===e&&void 0!==s){const{textTracks:t}=this;Object.keys(t).forEach((i=>Rr(t[i],e,s)))}}}extractCea608Data(t){const e=[[],[]],i=31&t[0];let s=2;for(let n=0;n<i;n++){const i=t[s++],n=127&t[s++],r=127&t[s++];if(0===n&&0===r)continue;const o=0!==(4&i);if(o){const t=3&i;0!==t&&1!==t||(e[t].push(n),e[t].push(r))}}return e}}function yd(t){return t.characteristics&&/transcribes-spoken-dialog/gi.test(t.characteristics)&&/describes-music-and-sound/gi.test(t.characteristics)?"captions":"subtitles"}function bd(t,e){return!!t&&t.kind===yd(e)&&rc(e,t)}function wd(t,e,i,s){return Math.min(e,s)-Math.max(t,i)}function Sd(){return{ccOffset:0,presentationOffset:0,0:{start:0,prevCC:-1,new:!0}}}class Ed{constructor(t){this.hls=void 0,this.autoLevelCapping=void 0,this.firstLevel=void 0,this.media=void 0,this.restrictedLevels=void 0,this.timer=void 0,this.clientRect=void 0,this.streamController=void 0,this.hls=t,this.autoLevelCapping=Number.POSITIVE_INFINITY,this.firstLevel=-1,this.media=null,this.restrictedLevels=[],this.timer=void 0,this.clientRect=null,this.registerListeners()}setStreamController(t){this.streamController=t}destroy(){this.hls&&this.unregisterListener(),this.timer&&this.stopCapping(),this.media=null,this.clientRect=null,this.hls=this.streamController=null}registerListeners(){const{hls:t}=this;t.on(Qi.FPS_DROP_LEVEL_CAPPING,this.onFpsDropLevelCapping,this),t.on(Qi.MEDIA_ATTACHING,this.onMediaAttaching,this),t.on(Qi.MANIFEST_PARSED,this.onManifestParsed,this),t.on(Qi.LEVELS_UPDATED,this.onLevelsUpdated,this),t.on(Qi.BUFFER_CODECS,this.onBufferCodecs,this),t.on(Qi.MEDIA_DETACHING,this.onMediaDetaching,this)}unregisterListener(){const{hls:t}=this;t.off(Qi.FPS_DROP_LEVEL_CAPPING,this.onFpsDropLevelCapping,this),t.off(Qi.MEDIA_ATTACHING,this.onMediaAttaching,this),t.off(Qi.MANIFEST_PARSED,this.onManifestParsed,this),t.off(Qi.LEVELS_UPDATED,this.onLevelsUpdated,this),t.off(Qi.BUFFER_CODECS,this.onBufferCodecs,this),t.off(Qi.MEDIA_DETACHING,this.onMediaDetaching,this)}onFpsDropLevelCapping(t,e){const i=this.hls.levels[e.droppedLevel];this.isLevelAllowed(i)&&this.restrictedLevels.push({bitrate:i.bitrate,height:i.height,width:i.width})}onMediaAttaching(t,e){this.media=e.media instanceof HTMLVideoElement?e.media:null,this.clientRect=null,this.timer&&this.hls.levels.length&&this.detectPlayerSize()}onManifestParsed(t,e){const i=this.hls;this.restrictedLevels=[],this.firstLevel=e.firstLevel,i.config.capLevelToPlayerSize&&e.video&&this.startCapping()}onLevelsUpdated(t,e){this.timer&&Yi(this.autoLevelCapping)&&this.detectPlayerSize()}onBufferCodecs(t,e){const i=this.hls;i.config.capLevelToPlayerSize&&e.video&&this.startCapping()}onMediaDetaching(){this.stopCapping()}detectPlayerSize(){if(this.media){if(this.mediaHeight<=0||this.mediaWidth<=0)return void(this.clientRect=null);const t=this.hls.levels;if(t.length){const e=this.hls,i=this.getMaxLevel(t.length-1);i!==this.autoLevelCapping&&as.log(`Setting autoLevelCapping to ${i}: ${t[i].height}p@${t[i].bitrate} for media ${this.mediaWidth}x${this.mediaHeight}`),e.autoLevelCapping=i,e.autoLevelCapping>this.autoLevelCapping&&this.streamController&&this.streamController.nextLevelSwitch(),this.autoLevelCapping=e.autoLevelCapping}}}getMaxLevel(t){const e=this.hls.levels;if(!e.length)return-1;const i=e.filter(((e,i)=>this.isLevelAllowed(e)&&i<=t));return this.clientRect=null,Ed.getMaxLevelByMediaSize(i,this.mediaWidth,this.mediaHeight)}startCapping(){this.timer||(this.autoLevelCapping=Number.POSITIVE_INFINITY,self.clearInterval(this.timer),this.timer=self.setInterval(this.detectPlayerSize.bind(this),1e3),this.detectPlayerSize())}stopCapping(){this.restrictedLevels=[],this.firstLevel=-1,this.autoLevelCapping=Number.POSITIVE_INFINITY,this.timer&&(self.clearInterval(this.timer),this.timer=void 0)}getDimensions(){if(this.clientRect)return this.clientRect;const t=this.media,e={width:0,height:0};if(t){const i=t.getBoundingClientRect();e.width=i.width,e.height=i.height,e.width||e.height||(e.width=i.right-i.left||t.width||0,e.height=i.bottom-i.top||t.height||0)}return this.clientRect=e,e}get mediaWidth(){return this.getDimensions().width*this.contentScaleFactor}get mediaHeight(){return this.getDimensions().height*this.contentScaleFactor}get contentScaleFactor(){let t=1;if(!this.hls.config.ignoreDevicePixelRatio)try{t=self.devicePixelRatio}catch(e){}return t}isLevelAllowed(t){const e=this.restrictedLevels;return!e.some((e=>t.bitrate===e.bitrate&&t.width===e.width&&t.height===e.height))}static getMaxLevelByMediaSize(t,e,i){if(null==t||!t.length)return-1;const s=(t,e)=>!e||(t.width!==e.width||t.height!==e.height);let n=t.length-1;const r=Math.max(e,i);for(let o=0;o<t.length;o+=1){const e=t[o];if((e.width>=r||e.height>=r)&&s(e,t[o+1])){n=o;break}}return n}}class Td{constructor(t){this.hls=void 0,this.isVideoPlaybackQualityAvailable=!1,this.timer=void 0,this.media=null,this.lastTime=void 0,this.lastDroppedFrames=0,this.lastDecodedFrames=0,this.streamController=void 0,this.hls=t,this.registerListeners()}setStreamController(t){this.streamController=t}registerListeners(){this.hls.on(Qi.MEDIA_ATTACHING,this.onMediaAttaching,this)}unregisterListeners(){this.hls.off(Qi.MEDIA_ATTACHING,this.onMediaAttaching,this)}destroy(){this.timer&&clearInterval(this.timer),this.unregisterListeners(),this.isVideoPlaybackQualityAvailable=!1,this.media=null}onMediaAttaching(t,e){const i=this.hls.config;if(i.capLevelOnFPSDrop){const t=e.media instanceof self.HTMLVideoElement?e.media:null;this.media=t,t&&"function"===typeof t.getVideoPlaybackQuality&&(this.isVideoPlaybackQualityAvailable=!0),self.clearInterval(this.timer),this.timer=self.setInterval(this.checkFPSInterval.bind(this),i.fpsDroppedMonitoringPeriod)}}checkFPS(t,e,i){const s=performance.now();if(e){if(this.lastTime){const t=s-this.lastTime,n=i-this.lastDroppedFrames,r=e-this.lastDecodedFrames,o=1e3*n/t,a=this.hls;if(a.trigger(Qi.FPS_DROP,{currentDropped:n,currentDecoded:r,totalDroppedFrames:i}),o>0&&n>a.config.fpsDroppedMonitoringThreshold*r){let t=a.currentLevel;as.warn("drop FPS ratio greater than max allowed value for currentLevel: "+t),t>0&&(-1===a.autoLevelCapping||a.autoLevelCapping>=t)&&(t-=1,a.trigger(Qi.FPS_DROP_LEVEL_CAPPING,{level:t,droppedLevel:a.currentLevel}),a.autoLevelCapping=t,this.streamController.nextLevelSwitch())}}this.lastTime=s,this.lastDroppedFrames=i,this.lastDecodedFrames=e}}checkFPSInterval(){const t=this.media;if(t)if(this.isVideoPlaybackQualityAvailable){const e=t.getVideoPlaybackQuality();this.checkFPS(t,e.totalVideoFrames,e.droppedVideoFrames)}else this.checkFPS(t,t.webkitDecodedFrameCount,t.webkitDroppedFrameCount)}}const xd="[eme]";class Cd{constructor(t){this.hls=void 0,this.config=void 0,this.media=null,this.keyFormatPromise=null,this.keySystemAccessPromises={},this._requestLicenseFailureCount=0,this.mediaKeySessions=[],this.keyIdToKeySessionPromise={},this.setMediaKeysQueue=Cd.CDMCleanupPromise?[Cd.CDMCleanupPromise]:[],this.onMediaEncrypted=this._onMediaEncrypted.bind(this),this.onWaitingForKey=this._onWaitingForKey.bind(this),this.debug=as.debug.bind(as,xd),this.log=as.log.bind(as,xd),this.warn=as.warn.bind(as,xd),this.error=as.error.bind(as,xd),this.hls=t,this.config=t.config,this.registerListeners()}destroy(){this.unregisterListeners(),this.onMediaDetached();const t=this.config;t.requestMediaKeySystemAccessFunc=null,t.licenseXhrSetup=t.licenseResponseCallback=void 0,t.drmSystems=t.drmSystemOptions={},this.hls=this.onMediaEncrypted=this.onWaitingForKey=this.keyIdToKeySessionPromise=null,this.config=null}registerListeners(){this.hls.on(Qi.MEDIA_ATTACHED,this.onMediaAttached,this),this.hls.on(Qi.MEDIA_DETACHED,this.onMediaDetached,this),this.hls.on(Qi.MANIFEST_LOADING,this.onManifestLoading,this),this.hls.on(Qi.MANIFEST_LOADED,this.onManifestLoaded,this)}unregisterListeners(){this.hls.off(Qi.MEDIA_ATTACHED,this.onMediaAttached,this),this.hls.off(Qi.MEDIA_DETACHED,this.onMediaDetached,this),this.hls.off(Qi.MANIFEST_LOADING,this.onManifestLoading,this),this.hls.off(Qi.MANIFEST_LOADED,this.onManifestLoaded,this)}getLicenseServerUrl(t){const{drmSystems:e,widevineLicenseUrl:i}=this.config,s=e[t];if(s)return s.licenseUrl;if(t===ks.WIDEVINE&&i)return i;throw new Error(`no license server URL configured for key-system "${t}"`)}getServerCertificateUrl(t){const{drmSystems:e}=this.config,i=e[t];if(i)return i.serverCertificateUrl;this.log(`No Server Certificate in config.drmSystems["${t}"]`)}attemptKeySystemAccess(t){const e=this.hls.levels,i=(t,e,i)=>!!t&&i.indexOf(t)===e,s=e.map((t=>t.audioCodec)).filter(i),n=e.map((t=>t.videoCodec)).filter(i);return s.length+n.length===0&&n.push("avc1.42e01e"),new Promise(((e,i)=>{const r=t=>{const o=t.shift();this.getMediaKeysPromise(o,s,n).then((t=>e({keySystem:o,mediaKeys:t}))).catch((e=>{t.length?r(t):i(e instanceof _d?e:new _d({type:Ji.KEY_SYSTEM_ERROR,details:ts.KEY_SYSTEM_NO_ACCESS,error:e,fatal:!0},e.message))}))};r(t)}))}requestMediaKeySystemAccess(t,e){const{requestMediaKeySystemAccessFunc:i}=this.config;if("function"!==typeof i){let t=`Configured requestMediaKeySystemAccess is not a function ${i}`;return null===Os&&"http:"===self.location.protocol&&(t=`navigator.requestMediaKeySystemAccess is not available over insecure protocol ${location.protocol}`),Promise.reject(new Error(t))}return i(t,e)}getMediaKeysPromise(t,e,i){const s=Ms(t,e,i,this.config.drmSystemOptions),n=this.keySystemAccessPromises[t];let r=null==n?void 0:n.keySystemAccess;if(!r){this.log(`Requesting encrypted media "${t}" key-system access with config: ${JSON.stringify(s)}`),r=this.requestMediaKeySystemAccess(t,s);const e=this.keySystemAccessPromises[t]={keySystemAccess:r};return r.catch((e=>{this.log(`Failed to obtain access to key-system "${t}": ${e}`)})),r.then((i=>{this.log(`Access for key-system "${i.keySystem}" obtained`);const s=this.fetchServerCertificate(t);return this.log(`Create media-keys for "${t}"`),e.mediaKeys=i.createMediaKeys().then((e=>(this.log(`Media-keys created for "${t}"`),s.then((i=>i?this.setMediaKeysServerCertificate(e,t,i):e))))),e.mediaKeys.catch((e=>{this.error(`Failed to create media-keys for "${t}"}: ${e}`)})),e.mediaKeys}))}return r.then((()=>n.mediaKeys))}createMediaKeySessionContext({decryptdata:t,keySystem:e,mediaKeys:i}){this.log(`Creating key-system session "${e}" keyId: ${en.hexDump(t.keyId||[])}`);const s=i.createSession(),n={decryptdata:t,keySystem:e,mediaKeys:i,mediaKeysSession:s,keyStatus:"status-pending"};return this.mediaKeySessions.push(n),n}renewKeySession(t){const e=t.decryptdata;if(e.pssh){const i=this.createMediaKeySessionContext(t),s=this.getKeyIdString(e),n="cenc";this.keyIdToKeySessionPromise[s]=this.generateRequestWithPreferredKeySession(i,n,e.pssh,"expired")}else this.warn("Could not renew expired session. Missing pssh initData.");this.removeSession(t)}getKeyIdString(t){if(!t)throw new Error("Could not read keyId of undefined decryptdata");if(null===t.keyId)throw new Error("keyId is null");return en.hexDump(t.keyId)}updateKeySession(t,e){var i;const s=t.mediaKeysSession;return this.log(`Updating key-session "${s.sessionId}" for keyID ${en.hexDump((null==(i=t.decryptdata)?void 0:i.keyId)||[])}\n      } (data length: ${e?e.byteLength:e})`),s.update(e)}selectKeySystemFormat(t){const e=Object.keys(t.levelkeys||{});return this.keyFormatPromise||(this.log(`Selecting key-system from fragment (sn: ${t.sn} ${t.type}: ${t.level}) key formats ${e.join(", ")}`),this.keyFormatPromise=this.getKeyFormatPromise(e)),this.keyFormatPromise}getKeyFormatPromise(t){return new Promise(((e,i)=>{const s=Ps(this.config),n=t.map(As).filter((t=>!!t&&-1!==s.indexOf(t)));return this.getKeySystemSelectionPromise(n).then((({keySystem:t})=>{const s=Ds(t);s?e(s):i(new Error(`Unable to find format for key-system "${t}"`))})).catch(i)}))}loadKey(t){const e=t.keyInfo.decryptdata,i=this.getKeyIdString(e),s=`(keyId: ${i} format: "${e.keyFormat}" method: ${e.method} uri: ${e.uri})`;this.log(`Starting session for key ${s}`);let n=this.keyIdToKeySessionPromise[i];return n||(n=this.keyIdToKeySessionPromise[i]=this.getKeySystemForKeyPromise(e).then((({keySystem:i,mediaKeys:n})=>(this.throwIfDestroyed(),this.log(`Handle encrypted media sn: ${t.frag.sn} ${t.frag.type}: ${t.frag.level} using key ${s}`),this.attemptSetMediaKeys(i,n).then((()=>{this.throwIfDestroyed();const t=this.createMediaKeySessionContext({keySystem:i,mediaKeys:n,decryptdata:e}),s="cenc";return this.generateRequestWithPreferredKeySession(t,s,e.pssh,"playlist-key")}))))),n.catch((t=>this.handleError(t)))),n}throwIfDestroyed(t="Invalid state"){if(!this.hls)throw new Error("invalid state")}handleError(t){this.hls&&(this.error(t.message),t instanceof _d?this.hls.trigger(Qi.ERROR,t.data):this.hls.trigger(Qi.ERROR,{type:Ji.KEY_SYSTEM_ERROR,details:ts.KEY_SYSTEM_NO_KEYS,error:t,fatal:!0}))}getKeySystemForKeyPromise(t){const e=this.getKeyIdString(t),i=this.keyIdToKeySessionPromise[e];if(!i){const e=As(t.keyFormat),i=e?[e]:Ps(this.config);return this.attemptKeySystemAccess(i)}return i}getKeySystemSelectionPromise(t){if(t.length||(t=Ps(this.config)),0===t.length)throw new _d({type:Ji.KEY_SYSTEM_ERROR,details:ts.KEY_SYSTEM_NO_CONFIGURED_LICENSE,fatal:!0},`Missing key-system license configuration options ${JSON.stringify({drmSystems:this.config.drmSystems})}`);return this.attemptKeySystemAccess(t)}_onMediaEncrypted(t){const{initDataType:e,initData:i}=t,s=`"${t.type}" event: init data type: "${e}"`;if(this.debug(s),null===i)return;let n,r;if("sinf"===e&&this.config.drmSystems[ks.FAIRPLAY]){const t=on(new Uint8Array(i));try{const e=Ss(JSON.parse(t).sinf),i=Sn(new Uint8Array(e));if(!i)throw new Error("'schm' box missing or not cbcs/cenc with schi > tenc");n=i.subarray(8,24),r=ks.FAIRPLAY}catch(d){return void this.warn(`${s} Failed to parse sinf: ${d}`)}}else{const t=Nn(i),e=t.filter((t=>t.systemId===Rs.WIDEVINE))[0];if(!e)return void(0===t.length||t.some((t=>!t.systemId))?this.warn(`${s} contains incomplete or invalid pssh data`):this.log(`ignoring ${s} for ${t.map((t=>Is(t.systemId))).join(",")} pssh data in favor of playlist keys`));if(r=Is(e.systemId),0===e.version&&e.data){const t=e.data.length-22;n=e.data.subarray(t,t+16)}}if(!r||!n)return;const o=en.hexDump(n),{keyIdToKeySessionPromise:a,mediaKeySessions:l}=this;let c=a[o];for(let u=0;u<l.length;u++){const t=l[u],s=t.decryptdata;if(!s.keyId)continue;const r=en.hexDump(s.keyId);if(o===r||-1!==s.uri.replace(/-/g,"").indexOf(o)){if(c=a[r],s.pssh)break;delete a[r],s.pssh=new Uint8Array(i),s.keyId=n,c=a[o]=c.then((()=>this.generateRequestWithPreferredKeySession(t,e,i,"encrypted-event-key-match")));break}}c||(c=a[o]=this.getKeySystemSelectionPromise([r]).then((({keySystem:t,mediaKeys:s})=>{var r;this.throwIfDestroyed();const a=new $n("ISO-23001-7",o,null!=(r=Ds(t))?r:"");return a.pssh=new Uint8Array(i),a.keyId=n,this.attemptSetMediaKeys(t,s).then((()=>{this.throwIfDestroyed();const n=this.createMediaKeySessionContext({decryptdata:a,keySystem:t,mediaKeys:s});return this.generateRequestWithPreferredKeySession(n,e,i,"encrypted-event-no-match")}))}))),c.catch((t=>this.handleError(t)))}_onWaitingForKey(t){this.log(`"${t.type}" event`)}attemptSetMediaKeys(t,e){const i=this.setMediaKeysQueue.slice();this.log(`Setting media-keys for "${t}"`);const s=Promise.all(i).then((()=>{if(!this.media)throw new Error("Attempted to set mediaKeys without media element attached");return this.media.setMediaKeys(e)}));return this.setMediaKeysQueue.push(s),s.then((()=>{this.log(`Media-keys set for "${t}"`),i.push(s),this.setMediaKeysQueue=this.setMediaKeysQueue.filter((t=>-1===i.indexOf(t)))}))}generateRequestWithPreferredKeySession(t,e,i,s){var n,r;const o=null==(n=this.config.drmSystems)||null==(r=n[t.keySystem])?void 0:r.generateRequest;if(o)try{const s=o.call(this.hls,e,i,t);if(!s)throw new Error("Invalid response from configured generateRequest filter");e=s.initDataType,i=t.decryptdata.pssh=s.initData?new Uint8Array(s.initData):null}catch(p){var a;if(this.warn(p.message),null!=(a=this.hls)&&a.config.debug)throw p}if(null===i)return this.log(`Skipping key-session request for "${s}" (no initData)`),Promise.resolve(t);const l=this.getKeyIdString(t.decryptdata);this.log(`Generating key-session request for "${s}": ${l} (init data type: ${e} length: ${i?i.byteLength:null})`);const c=new ec,d=t._onmessage=e=>{const i=t.mediaKeysSession;if(!i)return void c.emit("error",new Error("invalid state"));const{messageType:s,message:n}=e;this.log(`"${s}" message event for session "${i.sessionId}" message size: ${n.byteLength}`),"license-request"===s||"license-renewal"===s?this.renewLicense(t,n).catch((t=>{this.handleError(t),c.emit("error",t)})):"license-release"===s?t.keySystem===ks.FAIRPLAY&&(this.updateKeySession(t,Cs("acknowledged")),this.removeSession(t)):this.warn(`unhandled media key message type "${s}"`)},u=t._onkeystatuseschange=e=>{const i=t.mediaKeysSession;if(!i)return void c.emit("error",new Error("invalid state"));this.onKeyStatusChange(t);const s=t.keyStatus;c.emit("keyStatus",s),"expired"===s&&(this.warn(`${t.keySystem} expired for key ${l}`),this.renewKeySession(t))};t.mediaKeysSession.addEventListener("message",d),t.mediaKeysSession.addEventListener("keystatuseschange",u);const h=new Promise(((t,e)=>{c.on("error",e),c.on("keyStatus",(i=>{i.startsWith("usable")?t():"output-restricted"===i?e(new _d({type:Ji.KEY_SYSTEM_ERROR,details:ts.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED,fatal:!1},"HDCP level output restricted")):"internal-error"===i?e(new _d({type:Ji.KEY_SYSTEM_ERROR,details:ts.KEY_SYSTEM_STATUS_INTERNAL_ERROR,fatal:!0},`key status changed to "${i}"`)):"expired"===i?e(new Error("key expired while generating request")):this.warn(`unhandled key status change "${i}"`)}))}));return t.mediaKeysSession.generateRequest(e,i).then((()=>{var e;this.log(`Request generated for key-session "${null==(e=t.mediaKeysSession)?void 0:e.sessionId}" keyId: ${l}`)})).catch((t=>{throw new _d({type:Ji.KEY_SYSTEM_ERROR,details:ts.KEY_SYSTEM_NO_SESSION,error:t,fatal:!1},`Error generating key-session request: ${t}`)})).then((()=>h)).catch((e=>{throw c.removeAllListeners(),this.removeSession(t),e})).then((()=>(c.removeAllListeners(),t)))}onKeyStatusChange(t){t.mediaKeysSession.keyStatuses.forEach(((e,i)=>{this.log(`key status change "${e}" for keyStatuses keyId: ${en.hexDump("buffer"in i?new Uint8Array(i.buffer,i.byteOffset,i.byteLength):new Uint8Array(i))} session keyId: ${en.hexDump(new Uint8Array(t.decryptdata.keyId||[]))} uri: ${t.decryptdata.uri}`),t.keyStatus=e}))}fetchServerCertificate(t){const e=this.config,i=e.loader,s=new i(e),n=this.getServerCertificateUrl(t);return n?(this.log(`Fetching server certificate for "${t}"`),new Promise(((i,r)=>{const o={responseType:"arraybuffer",url:n},a=e.certLoadPolicy.default,l={loadPolicy:a,timeout:a.maxLoadTimeMs,maxRetry:0,retryDelay:0,maxRetryDelay:0},c={onSuccess:(t,e,s,n)=>{i(t.data)},onError:(e,i,s,a)=>{r(new _d({type:Ji.KEY_SYSTEM_ERROR,details:ts.KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED,fatal:!0,networkDetails:s,response:Vi({url:o.url,data:void 0},e)},`"${t}" certificate request failed (${n}). Status: ${e.code} (${e.text})`))},onTimeout:(e,i,s)=>{r(new _d({type:Ji.KEY_SYSTEM_ERROR,details:ts.KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED,fatal:!0,networkDetails:s,response:{url:o.url,data:void 0}},`"${t}" certificate request timed out (${n})`))},onAbort:(t,e,i)=>{r(new Error("aborted"))}};s.load(o,l,c)}))):Promise.resolve()}setMediaKeysServerCertificate(t,e,i){return new Promise(((s,n)=>{t.setServerCertificate(i).then((n=>{this.log(`setServerCertificate ${n?"success":"not supported by CDM"} (${null==i?void 0:i.byteLength}) on "${e}"`),s(t)})).catch((t=>{n(new _d({type:Ji.KEY_SYSTEM_ERROR,details:ts.KEY_SYSTEM_SERVER_CERTIFICATE_UPDATE_FAILED,error:t,fatal:!0},t.message))}))}))}renewLicense(t,e){return this.requestLicense(t,new Uint8Array(e)).then((e=>this.updateKeySession(t,new Uint8Array(e)).catch((t=>{throw new _d({type:Ji.KEY_SYSTEM_ERROR,details:ts.KEY_SYSTEM_SESSION_UPDATE_FAILED,error:t,fatal:!0},t.message)}))))}unpackPlayReadyKeyMessage(t,e){const i=String.fromCharCode.apply(null,new Uint16Array(e.buffer));if(!i.includes("PlayReadyKeyMessage"))return t.setRequestHeader("Content-Type","text/xml; charset=utf-8"),e;const s=(new DOMParser).parseFromString(i,"application/xml"),n=s.querySelectorAll("HttpHeader");if(n.length>0){let e;for(let i=0,s=n.length;i<s;i++){var r,o;e=n[i];const s=null==(r=e.querySelector("name"))?void 0:r.textContent,a=null==(o=e.querySelector("value"))?void 0:o.textContent;s&&a&&t.setRequestHeader(s,a)}}const a=s.querySelector("Challenge"),l=null==a?void 0:a.textContent;if(!l)throw new Error("Cannot find <Challenge> in key message");return Cs(atob(l))}setupLicenseXHR(t,e,i,s){const n=this.config.licenseXhrSetup;return n?Promise.resolve().then((()=>{if(!i.decryptdata)throw new Error("Key removed");return n.call(this.hls,t,e,i,s)})).catch((r=>{if(!i.decryptdata)throw r;return t.open("POST",e,!0),n.call(this.hls,t,e,i,s)})).then((i=>{t.readyState||t.open("POST",e,!0);const n=i||s;return{xhr:t,licenseChallenge:n}})):(t.open("POST",e,!0),Promise.resolve({xhr:t,licenseChallenge:s}))}requestLicense(t,e){const i=this.config.keyLoadPolicy.default;return new Promise(((s,n)=>{const r=this.getLicenseServerUrl(t.keySystem);this.log(`Sending license request to URL: ${r}`);const o=new XMLHttpRequest;o.responseType="arraybuffer",o.onreadystatechange=()=>{if(!this.hls||!t.mediaKeysSession)return n(new Error("invalid state"));if(4===o.readyState)if(200===o.status){this._requestLicenseFailureCount=0;let e=o.response;this.log(`License received ${e instanceof ArrayBuffer?e.byteLength:e}`);const i=this.config.licenseResponseCallback;if(i)try{e=i.call(this.hls,o,r,t)}catch(a){this.error(a)}s(e)}else{const a=i.errorRetry,l=a?a.maxNumRetry:0;if(this._requestLicenseFailureCount++,this._requestLicenseFailureCount>l||o.status>=400&&o.status<500)n(new _d({type:Ji.KEY_SYSTEM_ERROR,details:ts.KEY_SYSTEM_LICENSE_REQUEST_FAILED,fatal:!0,networkDetails:o,response:{url:r,data:void 0,code:o.status,text:o.statusText}},`License Request XHR failed (${r}). Status: ${o.status} (${o.statusText})`));else{const i=l-this._requestLicenseFailureCount+1;this.warn(`Retrying license request, ${i} attempts left`),this.requestLicense(t,e).then(s,n)}}},t.licenseXhr&&t.licenseXhr.readyState!==XMLHttpRequest.DONE&&t.licenseXhr.abort(),t.licenseXhr=o,this.setupLicenseXHR(o,r,t,e).then((({xhr:e,licenseChallenge:i})=>{t.keySystem==ks.PLAYREADY&&(i=this.unpackPlayReadyKeyMessage(e,i)),e.send(i)}))}))}onMediaAttached(t,e){if(!this.config.emeEnabled)return;const i=e.media;this.media=i,i.addEventListener("encrypted",this.onMediaEncrypted),i.addEventListener("waitingforkey",this.onWaitingForKey)}onMediaDetached(){const t=this.media,e=this.mediaKeySessions;t&&(t.removeEventListener("encrypted",this.onMediaEncrypted),t.removeEventListener("waitingforkey",this.onWaitingForKey),this.media=null),this._requestLicenseFailureCount=0,this.setMediaKeysQueue=[],this.mediaKeySessions=[],this.keyIdToKeySessionPromise={},$n.clearKeyUriToKeyIdMap();const i=e.length;Cd.CDMCleanupPromise=Promise.all(e.map((t=>this.removeSession(t))).concat(null==t?void 0:t.setMediaKeys(null).catch((t=>{this.log(`Could not clear media keys: ${t}`)})))).then((()=>{i&&(this.log("finished closing key sessions and clearing media keys"),e.length=0)})).catch((t=>{this.log(`Could not close sessions and clear media keys: ${t}`)}))}onManifestLoading(){this.keyFormatPromise=null}onManifestLoaded(t,{sessionKeys:e}){if(e&&this.config.emeEnabled&&!this.keyFormatPromise){const t=e.reduce(((t,e)=>(-1===t.indexOf(e.keyFormat)&&t.push(e.keyFormat),t)),[]);this.log(`Selecting key-system from session-keys ${t.join(", ")}`),this.keyFormatPromise=this.getKeyFormatPromise(t)}}removeSession(t){const{mediaKeysSession:e,licenseXhr:i}=t;if(e){this.log(`Remove licenses and keys and close session ${e.sessionId}`),t._onmessage&&(e.removeEventListener("message",t._onmessage),t._onmessage=void 0),t._onkeystatuseschange&&(e.removeEventListener("keystatuseschange",t._onkeystatuseschange),t._onkeystatuseschange=void 0),i&&i.readyState!==XMLHttpRequest.DONE&&i.abort(),t.mediaKeysSession=t.decryptdata=t.licenseXhr=void 0;const s=this.mediaKeySessions.indexOf(t);return s>-1&&this.mediaKeySessions.splice(s,1),e.remove().catch((t=>{this.log(`Could not remove session: ${t}`)})).then((()=>e.close())).catch((t=>{this.log(`Could not close session: ${t}`)}))}}}Cd.CDMCleanupPromise=void 0;class _d extends Error{constructor(t,e){super(e),this.data=void 0,t.error||(t.error=new Error(e)),this.data=t,t.err=t.error}}var kd,Ld,Ad;(function(t){t["MANIFEST"]="m",t["AUDIO"]="a",t["VIDEO"]="v",t["MUXED"]="av",t["INIT"]="i",t["CAPTION"]="c",t["TIMED_TEXT"]="tt",t["KEY"]="k",t["OTHER"]="o"})(kd||(kd={})),function(t){t["DASH"]="d",t["HLS"]="h",t["SMOOTH"]="s",t["OTHER"]="o"}(Ld||(Ld={})),function(t){t["OBJECT"]="CMCD-Object",t["REQUEST"]="CMCD-Request",t["SESSION"]="CMCD-Session",t["STATUS"]="CMCD-Status"}(Ad||(Ad={}));const Rd={[Ad.OBJECT]:["br","d","ot","tb"],[Ad.REQUEST]:["bl","dl","mtp","nor","nrr","su"],[Ad.SESSION]:["cid","pr","sf","sid","st","v"],[Ad.STATUS]:["bs","rtp"]};class Id{constructor(t,e){this.value=void 0,this.params=void 0,Array.isArray(t)&&(t=t.map((t=>t instanceof Id?t:new Id(t)))),this.value=t,this.params=e}}class Dd{constructor(t){this.description=void 0,this.description=t}}const Pd="Dict";function Od(t){return Array.isArray(t)?JSON.stringify(t):t instanceof Map?"Map{}":t instanceof Set?"Set{}":"object"===typeof t?JSON.stringify(t):String(t)}function Md(t,e,i,s){return new Error(`failed to ${t} "${Od(e)}" as ${i}`,{cause:s})}const Nd="Bare Item",Fd="Boolean",Bd="Byte Sequence",$d="Decimal",Ud="Integer";function jd(t){return t<-999999999999999||999999999999999<t}const qd=/[\x00-\x1f\x7f]+/,Gd="Token",Vd="Key";function Hd(t,e,i){return Md("serialize",t,e,i)}function zd(t){if("boolean"!==typeof t)throw Hd(t,Fd);return t?"?1":"?0"}function Kd(t){return btoa(String.fromCharCode(...t))}function Wd(t){if(!1===ArrayBuffer.isView(t))throw Hd(t,Bd);return`:${Kd(t)}:`}function Yd(t){if(jd(t))throw Hd(t,Ud);return t.toString()}function Xd(t){return`@${Yd(t.getTime()/1e3)}`}function Zd(t,e){if(t<0)return-Zd(-t,e);const i=Math.pow(10,e),s=Math.abs(t*i%1-.5)<Number.EPSILON;if(s){const e=Math.floor(t*i);return(e%2===0?e:e+1)/i}return Math.round(t*i)/i}function Qd(t){const e=Zd(t,3);if(Math.floor(Math.abs(e)).toString().length>12)throw Hd(t,$d);const i=e.toString();return i.includes(".")?i:`${i}.0`}const Jd="String";function tu(t){if(qd.test(t))throw Hd(t,Jd);return`"${t.replace(/\\/g,"\\\\").replace(/"/g,'\\"')}"`}function eu(t){return t.description||t.toString().slice(7,-1)}function iu(t){const e=eu(t);if(!1===/^([a-zA-Z*])([!#$%&'*+\-.^_`|~\w:/]*)$/.test(e))throw Hd(e,Gd);return e}function su(t){switch(typeof t){case"number":if(!Yi(t))throw Hd(t,Nd);return Number.isInteger(t)?Yd(t):Qd(t);case"string":return tu(t);case"symbol":return iu(t);case"boolean":return zd(t);case"object":if(t instanceof Date)return Xd(t);if(t instanceof Uint8Array)return Wd(t);if(t instanceof Dd)return iu(t);default:throw Hd(t,Nd)}}function nu(t){if(!1===/^[a-z*][a-z0-9\-_.*]*$/.test(t))throw Hd(t,Vd);return t}function ru(t){return null==t?"":Object.entries(t).map((([t,e])=>!0===e?`;${nu(t)}`:`;${nu(t)}=${su(e)}`)).join("")}function ou(t){return t instanceof Id?`${su(t.value)}${ru(t.params)}`:su(t)}function au(t){return`(${t.value.map(ou).join(" ")})${ru(t.params)}`}function lu(t,e={whitespace:!0}){if("object"!==typeof t)throw Hd(t,Pd);const i=t instanceof Map?t.entries():Object.entries(t),s=null!=e&&e.whitespace?" ":"";return Array.from(i).map((([t,e])=>{e instanceof Id===!1&&(e=new Id(e));let i=nu(t);return!0===e.value?i+=ru(e.params):(i+="=",Array.isArray(e.value)?i+=au(e):i+=ou(e)),i})).join(`,${s}`)}function cu(t,e){return lu(t,e)}const du=t=>"ot"===t||"sf"===t||"st"===t,uu=t=>"number"===typeof t?Yi(t):null!=t&&""!==t&&!1!==t;function hu(t,e){const i=new URL(t),s=new URL(e);if(i.origin!==s.origin)return t;const n=i.pathname.split("/").slice(1),r=s.pathname.split("/").slice(1,-1);while(n[0]===r[0])n.shift(),r.shift();while(r.length)r.shift(),n.unshift("..");return n.join("/")}function pu(){try{return crypto.randomUUID()}catch(t){try{const t=URL.createObjectURL(new Blob),e=t.toString();return URL.revokeObjectURL(t),e.slice(e.lastIndexOf("/")+1)}catch(t){let e=(new Date).getTime();const i="xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g,(t=>{const i=(e+16*Math.random())%16|0;return e=Math.floor(e/16),("x"==t?i:3&i|8).toString(16)}));return i}}}const fu=t=>Math.round(t),mu=(t,e)=>(null!=e&&e.baseUrl&&(t=hu(t,e.baseUrl)),encodeURIComponent(t)),vu=t=>100*fu(t/100),gu={br:fu,d:fu,bl:vu,dl:vu,mtp:vu,nor:mu,rtp:vu,tb:fu};function yu(t,e){const i={};if(null==t||"object"!==typeof t)return i;const s=Object.keys(t).sort(),n=Wi({},gu,null==e?void 0:e.formatters),r=null==e?void 0:e.filter;return s.forEach((s=>{if(null!=r&&r(s))return;let o=t[s];const a=n[s];a&&(o=a(o,e)),"v"===s&&1===o||"pr"==s&&1===o||uu(o)&&(du(s)&&"string"===typeof o&&(o=new Dd(o)),i[s]=o)})),i}function bu(t,e={}){return t?cu(yu(t,e),Wi({whitespace:!1},e)):""}function wu(t,e={}){if(!t)return{};const i=Object.entries(t),s=Object.entries(Rd).concat(Object.entries((null==e?void 0:e.customHeaderMap)||{})),n=i.reduce(((t,e)=>{var i;const[n,r]=e,o=(null==(i=s.find((t=>t[1].includes(n))))?void 0:i[0])||Ad.REQUEST;return null!=t[o]||(t[o]={}),t[o][n]=r,t}),{});return Object.entries(n).reduce(((t,[i,s])=>(t[i]=bu(s,e),t)),{})}function Su(t,e,i){return Wi(t,wu(e,i))}const Eu="CMCD";function Tu(t,e={}){if(!t)return"";const i=bu(t,e);return`${Eu}=${encodeURIComponent(i)}`}const xu=/CMCD=[^&#]+/;function Cu(t,e,i){const s=Tu(e,i);if(!s)return t;if(xu.test(t))return t.replace(xu,s);const n=t.includes("?")?"&":"?";return`${t}${n}${s}`}class _u{constructor(t){this.hls=void 0,this.config=void 0,this.media=void 0,this.sid=void 0,this.cid=void 0,this.useHeaders=!1,this.includeKeys=void 0,this.initialized=!1,this.starved=!1,this.buffering=!0,this.audioBuffer=void 0,this.videoBuffer=void 0,this.onWaiting=()=>{this.initialized&&(this.starved=!0),this.buffering=!0},this.onPlaying=()=>{this.initialized||(this.initialized=!0),this.buffering=!1},this.applyPlaylistData=t=>{try{this.apply(t,{ot:kd.MANIFEST,su:!this.initialized})}catch(e){as.warn("Could not generate manifest CMCD data.",e)}},this.applyFragmentData=t=>{try{const e=t.frag,i=this.hls.levels[e.level],s=this.getObjectType(e),n={d:1e3*e.duration,ot:s};s!==kd.VIDEO&&s!==kd.AUDIO&&s!=kd.MUXED||(n.br=i.bitrate/1e3,n.tb=this.getTopBandwidth(s)/1e3,n.bl=this.getBufferLength(s)),this.apply(t,n)}catch(e){as.warn("Could not generate segment CMCD data.",e)}},this.hls=t;const e=this.config=t.config,{cmcd:i}=e;null!=i&&(e.pLoader=this.createPlaylistLoader(),e.fLoader=this.createFragmentLoader(),this.sid=i.sessionId||pu(),this.cid=i.contentId,this.useHeaders=!0===i.useHeaders,this.includeKeys=i.includeKeys,this.registerListeners())}registerListeners(){const t=this.hls;t.on(Qi.MEDIA_ATTACHED,this.onMediaAttached,this),t.on(Qi.MEDIA_DETACHED,this.onMediaDetached,this),t.on(Qi.BUFFER_CREATED,this.onBufferCreated,this)}unregisterListeners(){const t=this.hls;t.off(Qi.MEDIA_ATTACHED,this.onMediaAttached,this),t.off(Qi.MEDIA_DETACHED,this.onMediaDetached,this),t.off(Qi.BUFFER_CREATED,this.onBufferCreated,this)}destroy(){this.unregisterListeners(),this.onMediaDetached(),this.hls=this.config=this.audioBuffer=this.videoBuffer=null,this.onWaiting=this.onPlaying=null}onMediaAttached(t,e){this.media=e.media,this.media.addEventListener("waiting",this.onWaiting),this.media.addEventListener("playing",this.onPlaying)}onMediaDetached(){this.media&&(this.media.removeEventListener("waiting",this.onWaiting),this.media.removeEventListener("playing",this.onPlaying),this.media=null)}onBufferCreated(t,e){var i,s;this.audioBuffer=null==(i=e.tracks.audio)?void 0:i.buffer,this.videoBuffer=null==(s=e.tracks.video)?void 0:s.buffer}createData(){var t;return{v:1,sf:Ld.HLS,sid:this.sid,cid:this.cid,pr:null==(t=this.media)?void 0:t.playbackRate,mtp:this.hls.bandwidthEstimate/1e3}}apply(t,e={}){Wi(e,this.createData());const i=e.ot===kd.INIT||e.ot===kd.VIDEO||e.ot===kd.MUXED;this.starved&&i&&(e.bs=!0,e.su=!0,this.starved=!1),null==e.su&&(e.su=this.buffering);const{includeKeys:s}=this;s&&(e=Object.keys(e).reduce(((t,i)=>(s.includes(i)&&(t[i]=e[i]),t)),{})),this.useHeaders?(t.headers||(t.headers={}),Su(t.headers,e)):t.url=Cu(t.url,e)}getObjectType(t){const{type:e}=t;return"subtitle"===e?kd.TIMED_TEXT:"initSegment"===t.sn?kd.INIT:"audio"===e?kd.AUDIO:"main"===e?this.hls.audioTracks.length?kd.VIDEO:kd.MUXED:void 0}getTopBandwidth(t){let e,i=0;const s=this.hls;if(t===kd.AUDIO)e=s.audioTracks;else{const t=s.maxAutoLevel,i=t>-1?t+1:s.levels.length;e=s.levels.slice(0,i)}for(const n of e)n.bitrate>i&&(i=n.bitrate);return i>0?i:NaN}getBufferLength(t){const e=this.hls.media,i=t===kd.AUDIO?this.audioBuffer:this.videoBuffer;if(!i||!e)return NaN;const s=ea.bufferInfo(i,e.currentTime,this.config.maxBufferHole);return 1e3*s.len}createPlaylistLoader(){const{pLoader:t}=this.config,e=this.applyPlaylistData,i=t||this.config.loader;return class{constructor(t){this.loader=void 0,this.loader=new i(t)}get stats(){return this.loader.stats}get context(){return this.loader.context}destroy(){this.loader.destroy()}abort(){this.loader.abort()}load(t,i,s){e(t),this.loader.load(t,i,s)}}}createFragmentLoader(){const{fLoader:t}=this.config,e=this.applyFragmentData,i=t||this.config.loader;return class{constructor(t){this.loader=void 0,this.loader=new i(t)}get stats(){return this.loader.stats}get context(){return this.loader.context}destroy(){this.loader.destroy()}abort(){this.loader.abort()}load(t,i,s){e(t),this.loader.load(t,i,s)}}}}const ku=3e5;class Lu{constructor(t){this.hls=void 0,this.log=void 0,this.loader=null,this.uri=null,this.pathwayId=".",this.pathwayPriority=null,this.timeToLoad=300,this.reloadTimer=-1,this.updated=0,this.started=!1,this.enabled=!0,this.levels=null,this.audioTracks=null,this.subtitleTracks=null,this.penalizedPathways={},this.hls=t,this.log=as.log.bind(as,"[content-steering]:"),this.registerListeners()}registerListeners(){const t=this.hls;t.on(Qi.MANIFEST_LOADING,this.onManifestLoading,this),t.on(Qi.MANIFEST_LOADED,this.onManifestLoaded,this),t.on(Qi.MANIFEST_PARSED,this.onManifestParsed,this),t.on(Qi.ERROR,this.onError,this)}unregisterListeners(){const t=this.hls;t&&(t.off(Qi.MANIFEST_LOADING,this.onManifestLoading,this),t.off(Qi.MANIFEST_LOADED,this.onManifestLoaded,this),t.off(Qi.MANIFEST_PARSED,this.onManifestParsed,this),t.off(Qi.ERROR,this.onError,this))}startLoad(){if(this.started=!0,this.clearTimeout(),this.enabled&&this.uri){if(this.updated){const t=1e3*this.timeToLoad-(performance.now()-this.updated);if(t>0)return void this.scheduleRefresh(this.uri,t)}this.loadSteeringManifest(this.uri)}}stopLoad(){this.started=!1,this.loader&&(this.loader.destroy(),this.loader=null),this.clearTimeout()}clearTimeout(){-1!==this.reloadTimer&&(self.clearTimeout(this.reloadTimer),this.reloadTimer=-1)}destroy(){this.unregisterListeners(),this.stopLoad(),this.hls=null,this.levels=this.audioTracks=this.subtitleTracks=null}removeLevel(t){const e=this.levels;e&&(this.levels=e.filter((e=>e!==t)))}onManifestLoading(){this.stopLoad(),this.enabled=!0,this.timeToLoad=300,this.updated=0,this.uri=null,this.pathwayId=".",this.levels=this.audioTracks=this.subtitleTracks=null}onManifestLoaded(t,e){const{contentSteering:i}=e;null!==i&&(this.pathwayId=i.pathwayId,this.uri=i.uri,this.started&&this.startLoad())}onManifestParsed(t,e){this.audioTracks=e.audioTracks,this.subtitleTracks=e.subtitleTracks}onError(t,e){const{errorAction:i}=e;if((null==i?void 0:i.action)===Co.SendAlternateToPenaltyBox&&i.flags===_o.MoveAllAlternatesMatchingHost){const t=this.levels;let s=this.pathwayPriority,n=this.pathwayId;if(e.context){const{groupId:i,pathwayId:s,type:r}=e.context;i&&t?n=this.getPathwayForGroupId(i,r,n):s&&(n=s)}n in this.penalizedPathways||(this.penalizedPathways[n]=performance.now()),!s&&t&&(s=t.reduce(((t,e)=>(-1===t.indexOf(e.pathwayId)&&t.push(e.pathwayId),t)),[])),s&&s.length>1&&(this.updatePathwayPriority(s),i.resolved=this.pathwayId!==n),i.resolved||as.warn(`Could not resolve ${e.details} ("${e.error.message}") with content-steering for Pathway: ${n} levels: ${t?t.length:t} priorities: ${JSON.stringify(s)} penalized: ${JSON.stringify(this.penalizedPathways)}`)}}filterParsedLevels(t){this.levels=t;let e=this.getLevelsForPathway(this.pathwayId);if(0===e.length){const i=t[0].pathwayId;this.log(`No levels found in Pathway ${this.pathwayId}. Setting initial Pathway to "${i}"`),e=this.getLevelsForPathway(i),this.pathwayId=i}return e.length!==t.length&&this.log(`Found ${e.length}/${t.length} levels in Pathway "${this.pathwayId}"`),e}getLevelsForPathway(t){return null===this.levels?[]:this.levels.filter((e=>t===e.pathwayId))}updatePathwayPriority(t){let e;this.pathwayPriority=t;const i=this.penalizedPathways,s=performance.now();Object.keys(i).forEach((t=>{s-i[t]>ku&&delete i[t]}));for(let n=0;n<t.length;n++){const s=t[n];if(s in i)continue;if(s===this.pathwayId)return;const r=this.hls.nextLoadLevel,o=this.hls.levels[r];if(e=this.getLevelsForPathway(s),e.length>0){this.log(`Setting Pathway to "${s}"`),this.pathwayId=s,uo(e),this.hls.trigger(Qi.LEVELS_UPDATED,{levels:e});const t=this.hls.levels[r];o&&t&&this.levels&&(t.attrs["STABLE-VARIANT-ID"]!==o.attrs["STABLE-VARIANT-ID"]&&t.bitrate!==o.bitrate&&this.log(`Unstable Pathways change from bitrate ${o.bitrate} to ${t.bitrate}`),this.hls.nextLoadLevel=r);break}}}getPathwayForGroupId(t,e,i){const s=this.getLevelsForPathway(i).concat(this.levels||[]);for(let n=0;n<s.length;n++)if(e===Er.AUDIO_TRACK&&s[n].hasAudioGroup(t)||e===Er.SUBTITLE_TRACK&&s[n].hasSubtitleGroup(t))return s[n].pathwayId;return i}clonePathways(t){const e=this.levels;if(!e)return;const i={},s={};t.forEach((t=>{const{ID:n,"BASE-ID":r,"URI-REPLACEMENT":o}=t;if(e.some((t=>t.pathwayId===n)))return;const a=this.getLevelsForPathway(r).map((t=>{const e=new ds(t.attrs);e["PATHWAY-ID"]=n;const r=e.AUDIO&&`${e.AUDIO}_clone_${n}`,a=e.SUBTITLES&&`${e.SUBTITLES}_clone_${n}`;r&&(i[e.AUDIO]=r,e.AUDIO=r),a&&(s[e.SUBTITLES]=a,e.SUBTITLES=a);const l=Ru(t.uri,e["STABLE-VARIANT-ID"],"PER-VARIANT-URIS",o),c=new Xr({attrs:e,audioCodec:t.audioCodec,bitrate:t.bitrate,height:t.height,name:t.name,url:l,videoCodec:t.videoCodec,width:t.width});if(t.audioGroups)for(let i=1;i<t.audioGroups.length;i++)c.addGroupId("audio",`${t.audioGroups[i]}_clone_${n}`);if(t.subtitleGroups)for(let i=1;i<t.subtitleGroups.length;i++)c.addGroupId("text",`${t.subtitleGroups[i]}_clone_${n}`);return c}));e.push(...a),Au(this.audioTracks,i,o,n),Au(this.subtitleTracks,s,o,n)}))}loadSteeringManifest(t){const e=this.hls.config,i=e.loader;let s;this.loader&&this.loader.destroy(),this.loader=new i(e);try{s=new self.URL(t)}catch(c){return this.enabled=!1,void this.log(`Failed to parse Steering Manifest URI: ${t}`)}if("data:"!==s.protocol){const t=0|(this.hls.bandwidthEstimate||e.abrEwmaDefaultEstimate);s.searchParams.set("_HLS_pathway",this.pathwayId),s.searchParams.set("_HLS_throughput",""+t)}const n={responseType:"json",url:s.href},r=e.steeringManifestLoadPolicy.default,o=r.errorRetry||r.timeoutRetry||{},a={loadPolicy:r,timeout:r.maxLoadTimeMs,maxRetry:o.maxNumRetry||0,retryDelay:o.retryDelayMs||0,maxRetryDelay:o.maxRetryDelayMs||0},l={onSuccess:(t,e,i,n)=>{this.log(`Loaded steering manifest: "${s}"`);const r=t.data;if(1!==r.VERSION)return void this.log(`Steering VERSION ${r.VERSION} not supported!`);this.updated=performance.now(),this.timeToLoad=r.TTL;const{"RELOAD-URI":o,"PATHWAY-CLONES":a,"PATHWAY-PRIORITY":l}=r;if(o)try{this.uri=new self.URL(o,s).href}catch(c){return this.enabled=!1,void this.log(`Failed to parse Steering Manifest RELOAD-URI: ${o}`)}this.scheduleRefresh(this.uri||i.url),a&&this.clonePathways(a);const d={steeringManifest:r,url:s.toString()};this.hls.trigger(Qi.STEERING_MANIFEST_LOADED,d),l&&this.updatePathwayPriority(l)},onError:(t,e,i,s)=>{if(this.log(`Error loading steering manifest: ${t.code} ${t.text} (${e.url})`),this.stopLoad(),410===t.code)return this.enabled=!1,void this.log(`Steering manifest ${e.url} no longer available`);let n=1e3*this.timeToLoad;if(429!==t.code)this.scheduleRefresh(this.uri||e.url,n);else{const t=this.loader;if("function"===typeof(null==t?void 0:t.getResponseHeader)){const e=t.getResponseHeader("Retry-After");e&&(n=1e3*parseFloat(e))}this.log(`Steering manifest ${e.url} rate limited`)}},onTimeout:(t,e,i)=>{this.log(`Timeout loading steering manifest (${e.url})`),this.scheduleRefresh(this.uri||e.url)}};this.log(`Requesting steering manifest: ${s}`),this.loader.load(n,a,l)}scheduleRefresh(t,e=1e3*this.timeToLoad){this.clearTimeout(),this.reloadTimer=self.setTimeout((()=>{var e;const i=null==(e=this.hls)?void 0:e.media;!i||i.ended?this.scheduleRefresh(t,1e3*this.timeToLoad):this.loadSteeringManifest(t)}),e)}}function Au(t,e,i,s){t&&Object.keys(e).forEach((n=>{const r=t.filter((t=>t.groupId===n)).map((t=>{const r=Wi({},t);return r.details=void 0,r.attrs=new ds(r.attrs),r.url=r.attrs.URI=Ru(t.url,t.attrs["STABLE-RENDITION-ID"],"PER-RENDITION-URIS",i),r.groupId=r.attrs["GROUP-ID"]=e[n],r.attrs["PATHWAY-ID"]=s,r}));t.push(...r)}))}function Ru(t,e,i,s){const{HOST:n,PARAMS:r,[i]:o}=s;let a;e&&(a=null==o?void 0:o[e],a&&(t=a));const l=new self.URL(t);return n&&!a&&(l.host=n),r&&Object.keys(r).sort().forEach((t=>{t&&l.searchParams.set(t,r[t])})),l.href}const Iu=/^age:\s*[\d.]+\s*$/im;class Du{constructor(t){this.xhrSetup=void 0,this.requestTimeout=void 0,this.retryTimeout=void 0,this.retryDelay=void 0,this.config=null,this.callbacks=null,this.context=null,this.loader=null,this.stats=void 0,this.xhrSetup=t&&t.xhrSetup||null,this.stats=new fs,this.retryDelay=0}destroy(){this.callbacks=null,this.abortInternal(),this.loader=null,this.config=null,this.context=null,this.xhrSetup=null}abortInternal(){const t=this.loader;self.clearTimeout(this.requestTimeout),self.clearTimeout(this.retryTimeout),t&&(t.onreadystatechange=null,t.onprogress=null,4!==t.readyState&&(this.stats.aborted=!0,t.abort()))}abort(){var t;this.abortInternal(),null!=(t=this.callbacks)&&t.onAbort&&this.callbacks.onAbort(this.stats,this.context,this.loader)}load(t,e,i){if(this.stats.loading.start)throw new Error("Loader can only be used once.");this.stats.loading.start=self.performance.now(),this.context=t,this.config=e,this.callbacks=i,this.loadInternal()}loadInternal(){const{config:t,context:e}=this;if(!t||!e)return;const i=this.loader=new self.XMLHttpRequest,s=this.stats;s.loading.first=0,s.loaded=0,s.aborted=!1;const n=this.xhrSetup;n?Promise.resolve().then((()=>{if(this.loader===i&&!this.stats.aborted)return n(i,e.url)})).catch((t=>{if(this.loader===i&&!this.stats.aborted)return i.open("GET",e.url,!0),n(i,e.url)})).then((()=>{this.loader!==i||this.stats.aborted||this.openAndSendXhr(i,e,t)})).catch((t=>{this.callbacks.onError({code:i.status,text:t.message},e,i,s)})):this.openAndSendXhr(i,e,t)}openAndSendXhr(t,e,i){t.readyState||t.open("GET",e.url,!0);const s=e.headers,{maxTimeToFirstByteMs:n,maxLoadTimeMs:r}=i.loadPolicy;if(s)for(const o in s)t.setRequestHeader(o,s[o]);e.rangeEnd&&t.setRequestHeader("Range","bytes="+e.rangeStart+"-"+(e.rangeEnd-1)),t.onreadystatechange=this.readystatechange.bind(this),t.onprogress=this.loadprogress.bind(this),t.responseType=e.responseType,self.clearTimeout(this.requestTimeout),i.timeout=n&&Yi(n)?n:r,this.requestTimeout=self.setTimeout(this.loadtimeout.bind(this),i.timeout),t.send()}readystatechange(){const{context:t,loader:e,stats:i}=this;if(!t||!e)return;const s=e.readyState,n=this.config;if(!i.aborted&&s>=2&&(0===i.loading.first&&(i.loading.first=Math.max(self.performance.now(),i.loading.start),n.timeout!==n.loadPolicy.maxLoadTimeMs&&(self.clearTimeout(this.requestTimeout),n.timeout=n.loadPolicy.maxLoadTimeMs,this.requestTimeout=self.setTimeout(this.loadtimeout.bind(this),n.loadPolicy.maxLoadTimeMs-(i.loading.first-i.loading.start)))),4===s)){self.clearTimeout(this.requestTimeout),e.onreadystatechange=null,e.onprogress=null;const s=e.status,r="text"===e.responseType?e.responseText:null;if(s>=200&&s<300){const n=null!=r?r:e.response;if(null!=n){i.loading.end=Math.max(self.performance.now(),i.loading.first);const r="arraybuffer"===e.responseType?n.byteLength:n.length;if(i.loaded=i.total=r,i.bwEstimate=8e3*i.total/(i.loading.end-i.loading.first),!this.callbacks)return;const o=this.callbacks.onProgress;if(o&&o(i,t,n,e),!this.callbacks)return;const a={url:e.responseURL,data:n,code:s};return void this.callbacks.onSuccess(a,i,t,e)}}const o=n.loadPolicy.errorRetry,a=i.retry,l={url:t.url,data:void 0,code:s};vo(o,a,!1,l)?this.retry(o):(as.error(`${s} while loading ${t.url}`),this.callbacks.onError({code:s,text:e.statusText},t,e,i))}}loadtimeout(){if(!this.config)return;const t=this.config.loadPolicy.timeoutRetry,e=this.stats.retry;if(vo(t,e,!0))this.retry(t);else{var i;as.warn(`timeout while loading ${null==(i=this.context)?void 0:i.url}`);const t=this.callbacks;t&&(this.abortInternal(),t.onTimeout(this.stats,this.context,this.loader))}}retry(t){const{context:e,stats:i}=this;this.retryDelay=fo(t,i.retry),i.retry++,as.warn(`${status?"HTTP Status "+status:"Timeout"} while loading ${null==e?void 0:e.url}, retrying ${i.retry}/${t.maxNumRetry} in ${this.retryDelay}ms`),this.abortInternal(),this.loader=null,self.clearTimeout(this.retryTimeout),this.retryTimeout=self.setTimeout(this.loadInternal.bind(this),this.retryDelay)}loadprogress(t){const e=this.stats;e.loaded=t.loaded,t.lengthComputable&&(e.total=t.total)}getCacheAge(){let t=null;if(this.loader&&Iu.test(this.loader.getAllResponseHeaders())){const e=this.loader.getResponseHeader("age");t=e?parseFloat(e):null}return t}getResponseHeader(t){return this.loader&&new RegExp(`^${t}:\\s*[\\d.]+\\s*$`,"im").test(this.loader.getAllResponseHeaders())?this.loader.getResponseHeader(t):null}}function Pu(){if(self.fetch&&self.AbortController&&self.ReadableStream&&self.Request)try{return new self.ReadableStream({}),!0}catch(t){}return!1}const Ou=/(\d+)-(\d+)\/(\d+)/;class Mu{constructor(t){this.fetchSetup=void 0,this.requestTimeout=void 0,this.request=null,this.response=null,this.controller=void 0,this.context=null,this.config=null,this.callbacks=null,this.stats=void 0,this.loader=null,this.fetchSetup=t.fetchSetup||$u,this.controller=new self.AbortController,this.stats=new fs}destroy(){this.loader=this.callbacks=this.context=this.config=this.request=null,this.abortInternal(),this.response=null,this.fetchSetup=this.controller=this.stats=null}abortInternal(){this.controller&&!this.stats.loading.end&&(this.stats.aborted=!0,this.controller.abort())}abort(){var t;this.abortInternal(),null!=(t=this.callbacks)&&t.onAbort&&this.callbacks.onAbort(this.stats,this.context,this.response)}load(t,e,i){const s=this.stats;if(s.loading.start)throw new Error("Loader can only be used once.");s.loading.start=self.performance.now();const n=Nu(t,this.controller.signal),r=i.onProgress,o="arraybuffer"===t.responseType,a=o?"byteLength":"length",{maxTimeToFirstByteMs:l,maxLoadTimeMs:c}=e.loadPolicy;this.context=t,this.config=e,this.callbacks=i,this.request=this.fetchSetup(t,n),self.clearTimeout(this.requestTimeout),e.timeout=l&&Yi(l)?l:c,this.requestTimeout=self.setTimeout((()=>{this.abortInternal(),i.onTimeout(s,t,this.response)}),e.timeout),self.fetch(this.request).then((n=>{this.response=this.loader=n;const a=Math.max(self.performance.now(),s.loading.start);if(self.clearTimeout(this.requestTimeout),e.timeout=c,this.requestTimeout=self.setTimeout((()=>{this.abortInternal(),i.onTimeout(s,t,this.response)}),c-(a-s.loading.start)),!n.ok){const{status:t,statusText:e}=n;throw new Uu(e||"fetch, bad network response",t,n)}return s.loading.first=a,s.total=Bu(n.headers)||s.total,r&&Yi(e.highWaterMark)?this.loadProgressively(n,s,t,e.highWaterMark,r):o?n.arrayBuffer():"json"===t.responseType?n.json():n.text()})).then((n=>{const o=this.response;if(!o)throw new Error("loader destroyed");self.clearTimeout(this.requestTimeout),s.loading.end=Math.max(self.performance.now(),s.loading.first);const l=n[a];l&&(s.loaded=s.total=l);const c={url:o.url,data:n,code:o.status};r&&!Yi(e.highWaterMark)&&r(s,t,n,o),i.onSuccess(c,s,t,o)})).catch((e=>{if(self.clearTimeout(this.requestTimeout),s.aborted)return;const n=e&&e.code||0,r=e?e.message:null;i.onError({code:n,text:r},t,e?e.details:null,s)}))}getCacheAge(){let t=null;if(this.response){const e=this.response.headers.get("age");t=e?parseFloat(e):null}return t}getResponseHeader(t){return this.response?this.response.headers.get(t):null}loadProgressively(t,e,i,s=0,n){const r=new _a,o=t.body.getReader(),a=()=>o.read().then((o=>{if(o.done)return r.dataLength&&n(e,i,r.flush(),t),Promise.resolve(new ArrayBuffer(0));const l=o.value,c=l.length;return e.loaded+=c,c<s||r.dataLength?(r.push(l),r.dataLength>=s&&n(e,i,r.flush(),t)):n(e,i,l,t),a()})).catch((()=>Promise.reject()));return a()}}function Nu(t,e){const i={method:"GET",mode:"cors",credentials:"same-origin",signal:e,headers:new self.Headers(Wi({},t.headers))};return t.rangeEnd&&i.headers.set("Range","bytes="+t.rangeStart+"-"+String(t.rangeEnd-1)),i}function Fu(t){const e=Ou.exec(t);if(e)return parseInt(e[2])-parseInt(e[1])+1}function Bu(t){const e=t.get("Content-Range");if(e){const t=Fu(e);if(Yi(t))return t}const i=t.get("Content-Length");if(i)return parseInt(i)}function $u(t,e){return new self.Request(t.url,e)}class Uu extends Error{constructor(t,e,i){super(t),this.code=void 0,this.details=void 0,this.code=e,this.details=i}}const ju=/\s/,qu={newCue(t,e,i,s){const n=[];let r,o,a,l,c;const d=self.VTTCue||self.TextTrackCue;for(let h=0;h<s.rows.length;h++)if(r=s.rows[h],a=!0,l=0,c="",!r.isEmpty()){var u;for(let t=0;t<r.chars.length;t++)ju.test(r.chars[t].uchar)&&a?l++:(c+=r.chars[t].uchar,a=!1);r.cueStartTime=e,e===i&&(i+=1e-4),l>=16?l--:l++;const s=Kc(c.trim()),p=Jc(e,i,s);null!=t&&null!=(u=t.cues)&&u.getCueById(p)||(o=new d(e,i,s),o.id=p,o.line=h+1,o.align="left",o.position=10+Math.min(80,10*Math.floor(8*l/32)),n.push(o))}return t&&n.length&&(n.sort(((t,e)=>"auto"===t.line||"auto"===e.line?0:t.line>8&&e.line>8?e.line-t.line:t.line-e.line)),n.forEach((e=>Lr(t,e)))),n}},Gu={maxTimeToFirstByteMs:8e3,maxLoadTimeMs:2e4,timeoutRetry:null,errorRetry:null},Vu=Vi(Vi({autoStartLoad:!0,startPosition:-1,defaultAudioCodec:void 0,debug:!1,capLevelOnFPSDrop:!1,capLevelToPlayerSize:!1,ignoreDevicePixelRatio:!1,preferManagedMediaSource:!0,initialLiveManifestSize:1,maxBufferLength:30,backBufferLength:1/0,frontBufferFlushThreshold:1/0,maxBufferSize:6e7,maxBufferHole:.1,highBufferWatchdogPeriod:2,nudgeOffset:.1,nudgeMaxRetry:3,maxFragLookUpTolerance:.25,liveSyncDurationCount:3,liveMaxLatencyDurationCount:1/0,liveSyncDuration:void 0,liveMaxLatencyDuration:void 0,maxLiveSyncPlaybackRate:1,liveDurationInfinity:!1,liveBackBufferLength:null,maxMaxBufferLength:600,enableWorker:!0,workerPath:null,enableSoftwareAES:!0,startLevel:void 0,startFragPrefetch:!1,fpsDroppedMonitoringPeriod:5e3,fpsDroppedMonitoringThreshold:.2,appendErrorMaxRetry:3,loader:Du,fLoader:void 0,pLoader:void 0,xhrSetup:void 0,licenseXhrSetup:void 0,licenseResponseCallback:void 0,abrController:Wo,bufferController:mc,capLevelController:Ed,errorController:ko,fpsController:Td,stretchShortVideoTrack:!1,maxAudioFramesDrift:1,forceKeyFrameOnDiscontinuity:!0,abrEwmaFastLive:3,abrEwmaSlowLive:9,abrEwmaFastVoD:3,abrEwmaSlowVoD:9,abrEwmaDefaultEstimate:5e5,abrEwmaDefaultEstimateMax:5e6,abrBandWidthFactor:.95,abrBandWidthUpFactor:.7,abrMaxWithRealBitrate:!1,maxStarvationDelay:4,maxLoadingDelay:4,minAutoBitrate:0,emeEnabled:!1,widevineLicenseUrl:void 0,drmSystems:{},drmSystemOptions:{},requestMediaKeySystemAccessFunc:Os,testBandwidth:!0,progressive:!1,lowLatencyMode:!0,cmcd:void 0,enableDateRangeMetadataCues:!0,enableEmsgMetadataCues:!0,enableID3MetadataCues:!0,useMediaCapabilities:!0,certLoadPolicy:{default:Gu},keyLoadPolicy:{default:{maxTimeToFirstByteMs:8e3,maxLoadTimeMs:2e4,timeoutRetry:{maxNumRetry:1,retryDelayMs:1e3,maxRetryDelayMs:2e4,backoff:"linear"},errorRetry:{maxNumRetry:8,retryDelayMs:1e3,maxRetryDelayMs:2e4,backoff:"linear"}}},manifestLoadPolicy:{default:{maxTimeToFirstByteMs:1/0,maxLoadTimeMs:2e4,timeoutRetry:{maxNumRetry:2,retryDelayMs:0,maxRetryDelayMs:0},errorRetry:{maxNumRetry:1,retryDelayMs:1e3,maxRetryDelayMs:8e3}}},playlistLoadPolicy:{default:{maxTimeToFirstByteMs:1e4,maxLoadTimeMs:2e4,timeoutRetry:{maxNumRetry:2,retryDelayMs:0,maxRetryDelayMs:0},errorRetry:{maxNumRetry:2,retryDelayMs:1e3,maxRetryDelayMs:8e3}}},fragLoadPolicy:{default:{maxTimeToFirstByteMs:1e4,maxLoadTimeMs:12e4,timeoutRetry:{maxNumRetry:4,retryDelayMs:0,maxRetryDelayMs:0},errorRetry:{maxNumRetry:6,retryDelayMs:1e3,maxRetryDelayMs:8e3}}},steeringManifestLoadPolicy:{default:{maxTimeToFirstByteMs:1e4,maxLoadTimeMs:2e4,timeoutRetry:{maxNumRetry:2,retryDelayMs:0,maxRetryDelayMs:0},errorRetry:{maxNumRetry:1,retryDelayMs:1e3,maxRetryDelayMs:8e3}}},manifestLoadingTimeOut:1e4,manifestLoadingMaxRetry:1,manifestLoadingRetryDelay:1e3,manifestLoadingMaxRetryTimeout:64e3,levelLoadingTimeOut:1e4,levelLoadingMaxRetry:4,levelLoadingRetryDelay:1e3,levelLoadingMaxRetryTimeout:64e3,fragLoadingTimeOut:2e4,fragLoadingMaxRetry:6,fragLoadingRetryDelay:1e3,fragLoadingMaxRetryTimeout:64e3},Hu()),{},{subtitleStreamController:dc,subtitleTrackController:hc,timelineController:gd,audioStreamController:ac,audioTrackController:lc,emeController:Cd,cmcdController:_u,contentSteeringController:Lu});function Hu(){return{cueHandler:qu,enableWebVTT:!0,enableIMSC1:!0,enableCEA708Captions:!0,captionsTextTrack1Label:"English",captionsTextTrack1LanguageCode:"en",captionsTextTrack2Label:"Spanish",captionsTextTrack2LanguageCode:"es",captionsTextTrack3Label:"Unknown CC",captionsTextTrack3LanguageCode:"",captionsTextTrack4Label:"Unknown CC",captionsTextTrack4LanguageCode:"",renderTextTracksNatively:!0}}function zu(t,e){if((e.liveSyncDurationCount||e.liveMaxLatencyDurationCount)&&(e.liveSyncDuration||e.liveMaxLatencyDuration))throw new Error("Illegal hls.js config: don't mix up liveSyncDurationCount/liveMaxLatencyDurationCount and liveSyncDuration/liveMaxLatencyDuration");if(void 0!==e.liveMaxLatencyDurationCount&&(void 0===e.liveSyncDurationCount||e.liveMaxLatencyDurationCount<=e.liveSyncDurationCount))throw new Error('Illegal hls.js config: "liveMaxLatencyDurationCount" must be greater than "liveSyncDurationCount"');if(void 0!==e.liveMaxLatencyDuration&&(void 0===e.liveSyncDuration||e.liveMaxLatencyDuration<=e.liveSyncDuration))throw new Error('Illegal hls.js config: "liveMaxLatencyDuration" must be greater than "liveSyncDuration"');const i=Ku(t),s=["manifest","level","frag"],n=["TimeOut","MaxRetry","RetryDelay","MaxRetryTimeout"];return s.forEach((t=>{const s=`${"level"===t?"playlist":t}LoadPolicy`,r=void 0===e[s],o=[];n.forEach((n=>{const a=`${t}Loading${n}`,l=e[a];if(void 0!==l&&r){o.push(a);const t=i[s].default;switch(e[s]={default:t},n){case"TimeOut":t.maxLoadTimeMs=l,t.maxTimeToFirstByteMs=l;break;case"MaxRetry":t.errorRetry.maxNumRetry=l,t.timeoutRetry.maxNumRetry=l;break;case"RetryDelay":t.errorRetry.retryDelayMs=l,t.timeoutRetry.retryDelayMs=l;break;case"MaxRetryTimeout":t.errorRetry.maxRetryDelayMs=l,t.timeoutRetry.maxRetryDelayMs=l;break}}})),o.length&&as.warn(`hls.js config: "${o.join('", "')}" setting(s) are deprecated, use "${s}": ${JSON.stringify(e[s])}`)})),Vi(Vi({},i),e)}function Ku(t){return t&&"object"===typeof t?Array.isArray(t)?t.map(Ku):Object.keys(t).reduce(((e,i)=>(e[i]=Ku(t[i]),e)),{}):t}function Wu(t){const e=t.loader;if(e!==Mu&&e!==Du)as.log("[config]: Custom loader detected, cannot enable progressive streaming"),t.progressive=!1;else{const e=Pu();e&&(t.loader=Mu,t.progressive=!0,t.enableSoftwareAES=!0,as.log("[config]: Progressive streaming enabled, using FetchLoader"))}}let Yu;class Xu extends Lo{constructor(t,e){super(t,"[level-controller]"),this._levels=[],this._firstLevel=-1,this._maxAutoLevel=-1,this._startLevel=void 0,this.currentLevel=null,this.currentLevelIndex=-1,this.manualLevelIndex=-1,this.steering=void 0,this.onParsedComplete=void 0,this.steering=e,this._registerListeners()}_registerListeners(){const{hls:t}=this;t.on(Qi.MANIFEST_LOADING,this.onManifestLoading,this),t.on(Qi.MANIFEST_LOADED,this.onManifestLoaded,this),t.on(Qi.LEVEL_LOADED,this.onLevelLoaded,this),t.on(Qi.LEVELS_UPDATED,this.onLevelsUpdated,this),t.on(Qi.FRAG_BUFFERED,this.onFragBuffered,this),t.on(Qi.ERROR,this.onError,this)}_unregisterListeners(){const{hls:t}=this;t.off(Qi.MANIFEST_LOADING,this.onManifestLoading,this),t.off(Qi.MANIFEST_LOADED,this.onManifestLoaded,this),t.off(Qi.LEVEL_LOADED,this.onLevelLoaded,this),t.off(Qi.LEVELS_UPDATED,this.onLevelsUpdated,this),t.off(Qi.FRAG_BUFFERED,this.onFragBuffered,this),t.off(Qi.ERROR,this.onError,this)}destroy(){this._unregisterListeners(),this.steering=null,this.resetLevels(),super.destroy()}stopLoad(){const t=this._levels;t.forEach((t=>{t.loadError=0,t.fragmentError=0})),super.stopLoad()}resetLevels(){this._startLevel=void 0,this.manualLevelIndex=-1,this.currentLevelIndex=-1,this.currentLevel=null,this._levels=[],this._maxAutoLevel=-1}onManifestLoading(t,e){this.resetLevels()}onManifestLoaded(t,e){const i=this.hls.config.preferManagedMediaSource,s=[],n={},r={};let o=!1,a=!1,l=!1;e.levels.forEach((t=>{var e,c;const d=t.attrs;let{audioCodec:u,videoCodec:h}=t;-1!==(null==(e=u)?void 0:e.indexOf("mp4a.40.34"))&&(Yu||(Yu=/chrome|firefox/i.test(navigator.userAgent)),Yu&&(t.audioCodec=u=void 0)),u&&(t.audioCodec=u=rr(u,i)),0===(null==(c=h)?void 0:c.indexOf("avc1"))&&(h=t.videoCodec=ar(h));const{width:p,height:f,unknownCodecs:m}=t;if(o||(o=!(!p||!f)),a||(a=!!h),l||(l=!!u),null!=m&&m.length||u&&!Zn(u,"audio",i)||h&&!Zn(h,"video",i))return;const{CODECS:v,"FRAME-RATE":g,"HDCP-LEVEL":y,"PATHWAY-ID":b,RESOLUTION:w,"VIDEO-RANGE":S}=d,E=`${b||"."}-`,T=`${E}${t.bitrate}-${w}-${g}-${v}-${S}-${y}`;if(n[T])if(n[T].uri===t.url||t.attrs["PATHWAY-ID"])n[T].addGroupId("audio",d.AUDIO),n[T].addGroupId("text",d.SUBTITLES);else{const e=r[T]+=1;t.attrs["PATHWAY-ID"]=new Array(e+1).join(".");const i=new Xr(t);n[T]=i,s.push(i)}else{const e=new Xr(t);n[T]=e,r[T]=1,s.push(e)}})),this.filterAndSortMediaOptions(s,e,o,a,l)}filterAndSortMediaOptions(t,e,i,s,n){let r=[],o=[],a=t;if((i||s)&&n&&(a=a.filter((({videoCodec:t,videoRange:e,width:i,height:s})=>(!!t||!(!i||!s))&&zr(e)))),0===a.length)return void Promise.resolve().then((()=>{if(this.hls){e.levels.length&&this.warn(`One or more CODECS in variant not supported: ${JSON.stringify(e.levels[0].attrs)}`);const t=new Error("no level with compatible codecs found in manifest");this.hls.trigger(Qi.ERROR,{type:Ji.MEDIA_ERROR,details:ts.MANIFEST_INCOMPATIBLE_CODECS_ERROR,fatal:!0,url:e.url,error:t,reason:t.message})}}));if(e.audioTracks){const{preferManagedMediaSource:t}=this.hls.config;r=e.audioTracks.filter((e=>!e.audioCodec||Zn(e.audioCodec,"audio",t))),Zu(r)}e.subtitles&&(o=e.subtitles,Zu(o));const l=a.slice(0);a.sort(((t,e)=>{if(t.attrs["HDCP-LEVEL"]!==e.attrs["HDCP-LEVEL"])return(t.attrs["HDCP-LEVEL"]||"")>(e.attrs["HDCP-LEVEL"]||"")?1:-1;if(i&&t.height!==e.height)return t.height-e.height;if(t.frameRate!==e.frameRate)return t.frameRate-e.frameRate;if(t.videoRange!==e.videoRange)return Hr.indexOf(t.videoRange)-Hr.indexOf(e.videoRange);if(t.videoCodec!==e.videoCodec){const i=tr(t.videoCodec),s=tr(e.videoCodec);if(i!==s)return s-i}if(t.uri===e.uri&&t.codecSet!==e.codecSet){const i=er(t.codecSet),s=er(e.codecSet);if(i!==s)return s-i}return t.averageBitrate!==e.averageBitrate?t.averageBitrate-e.averageBitrate:0}));let c=l[0];if(this.steering&&(a=this.steering.filterParsedLevels(a),a.length!==l.length))for(let p=0;p<l.length;p++)if(l[p].pathwayId===a[0].pathwayId){c=l[p];break}this._levels=a;for(let p=0;p<a.length;p++)if(a[p]===c){var d;this._firstLevel=p;const t=c.bitrate,e=this.hls.bandwidthEstimate;if(this.log(`manifest loaded, ${a.length} level(s) found, first bitrate: ${t}`),void 0===(null==(d=this.hls.userConfig)?void 0:d.abrEwmaDefaultEstimate)){const i=Math.min(t,this.hls.config.abrEwmaDefaultEstimateMax);i>e&&e===Vu.abrEwmaDefaultEstimate&&(this.hls.bandwidthEstimate=i)}break}const u=n&&!s,h={levels:a,audioTracks:r,subtitleTracks:o,sessionData:e.sessionData,sessionKeys:e.sessionKeys,firstLevel:this._firstLevel,stats:e.stats,audio:n,video:s,altAudio:!u&&r.some((t=>!!t.url))};this.hls.trigger(Qi.MANIFEST_PARSED,h),(this.hls.config.autoStartLoad||this.hls.forceStartLoad)&&this.hls.startLoad(this.hls.config.startPosition)}get levels(){return 0===this._levels.length?null:this._levels}get level(){return this.currentLevelIndex}set level(t){const e=this._levels;if(0===e.length)return;if(t<0||t>=e.length){const i=new Error("invalid level idx"),s=t<0;if(this.hls.trigger(Qi.ERROR,{type:Ji.OTHER_ERROR,details:ts.LEVEL_SWITCH_ERROR,level:t,fatal:s,error:i,reason:i.message}),s)return;t=Math.min(t,e.length-1)}const i=this.currentLevelIndex,s=this.currentLevel,n=s?s.attrs["PATHWAY-ID"]:void 0,r=e[t],o=r.attrs["PATHWAY-ID"];if(this.currentLevelIndex=t,this.currentLevel=r,i===t&&r.details&&s&&n===o)return;this.log(`Switching to level ${t} (${r.height?r.height+"p ":""}${r.videoRange?r.videoRange+" ":""}${r.codecSet?r.codecSet+" ":""}@${r.bitrate})${o?" with Pathway "+o:""} from level ${i}${n?" with Pathway "+n:""}`);const a={level:t,attrs:r.attrs,details:r.details,bitrate:r.bitrate,averageBitrate:r.averageBitrate,maxBitrate:r.maxBitrate,realBitrate:r.realBitrate,width:r.width,height:r.height,codecSet:r.codecSet,audioCodec:r.audioCodec,videoCodec:r.videoCodec,audioGroups:r.audioGroups,subtitleGroups:r.subtitleGroups,loaded:r.loaded,loadError:r.loadError,fragmentError:r.fragmentError,name:r.name,id:r.id,uri:r.uri,url:r.url,urlId:0,audioGroupIds:r.audioGroupIds,textGroupIds:r.textGroupIds};this.hls.trigger(Qi.LEVEL_SWITCHING,a);const l=r.details;if(!l||l.live){const t=this.switchParams(r.uri,null==s?void 0:s.details,l);this.loadPlaylist(t)}}get manualLevel(){return this.manualLevelIndex}set manualLevel(t){this.manualLevelIndex=t,void 0===this._startLevel&&(this._startLevel=t),-1!==t&&(this.level=t)}get firstLevel(){return this._firstLevel}set firstLevel(t){this._firstLevel=t}get startLevel(){if(void 0===this._startLevel){const t=this.hls.config.startLevel;return void 0!==t?t:this.hls.firstAutoLevel}return this._startLevel}set startLevel(t){this._startLevel=t}onError(t,e){!e.fatal&&e.context&&e.context.type===Er.LEVEL&&e.context.level===this.level&&this.checkRetry(e)}onFragBuffered(t,{frag:e}){if(void 0!==e&&e.type===Tr.MAIN){const t=e.elementaryStreams;if(!Object.keys(t).some((e=>!!t[e])))return;const i=this._levels[e.level];null!=i&&i.loadError&&(this.log(`Resetting level error count of ${i.loadError} on frag buffered`),i.loadError=0)}}onLevelLoaded(t,e){var i;const{level:s,details:n}=e,r=this._levels[s];var o;if(!r)return this.warn(`Invalid level index ${s}`),void(null!=(o=e.deliveryDirectives)&&o.skip&&(n.deltaUpdateFailed=!0));s===this.currentLevelIndex?(0===r.fragmentError&&(r.loadError=0),this.playlistLoaded(s,e,r.details)):null!=(i=e.deliveryDirectives)&&i.skip&&(n.deltaUpdateFailed=!0)}loadPlaylist(t){super.loadPlaylist();const e=this.currentLevelIndex,i=this.currentLevel;if(i&&this.shouldLoadPlaylist(i)){let n=i.uri;if(t)try{n=t.addDirectives(n)}catch(s){this.warn(`Could not construct new URL with HLS Delivery Directives: ${s}`)}const r=i.attrs["PATHWAY-ID"];this.log(`Loading level index ${e}${void 0!==(null==t?void 0:t.msn)?" at sn "+t.msn+" part "+t.part:""} with${r?" Pathway "+r:""} ${n}`),this.clearTimer(),this.hls.trigger(Qi.LEVEL_LOADING,{url:n,level:e,pathwayId:i.attrs["PATHWAY-ID"],id:0,deliveryDirectives:t||null})}}get nextLoadLevel(){return-1!==this.manualLevelIndex?this.manualLevelIndex:this.hls.nextAutoLevel}set nextLoadLevel(t){this.level=t,-1===this.manualLevelIndex&&(this.hls.nextAutoLevel=t)}removeLevel(t){var e;const i=this._levels.filter(((e,i)=>i!==t||(this.steering&&this.steering.removeLevel(e),e===this.currentLevel&&(this.currentLevel=null,this.currentLevelIndex=-1,e.details&&e.details.fragments.forEach((t=>t.level=-1))),!1)));uo(i),this._levels=i,this.currentLevelIndex>-1&&null!=(e=this.currentLevel)&&e.details&&(this.currentLevelIndex=this.currentLevel.details.fragments[0].level),this.hls.trigger(Qi.LEVELS_UPDATED,{levels:i})}onLevelsUpdated(t,{levels:e}){this._levels=e}checkMaxAutoUpdated(){const{autoLevelCapping:t,maxAutoLevel:e,maxHdcpLevel:i}=this.hls;this._maxAutoLevel!==e&&(this._maxAutoLevel=e,this.hls.trigger(Qi.MAX_AUTO_LEVEL_UPDATED,{autoLevelCapping:t,levels:this.levels,maxAutoLevel:e,minAutoLevel:this.hls.minAutoLevel,maxHdcpLevel:i}))}}function Zu(t){const e={};t.forEach((t=>{const i=t.groupId||"";t.id=e[i]=e[i]||0,e[i]++}))}class Qu{constructor(t){this.config=void 0,this.keyUriToKeyInfo={},this.emeController=null,this.config=t}abort(t){for(const i in this.keyUriToKeyInfo){const s=this.keyUriToKeyInfo[i].loader;if(s){var e;if(t&&t!==(null==(e=s.context)?void 0:e.frag.type))return;s.abort()}}}detach(){for(const t in this.keyUriToKeyInfo){const e=this.keyUriToKeyInfo[t];(e.mediaKeySessionContext||e.decryptdata.isCommonEncryption)&&delete this.keyUriToKeyInfo[t]}}destroy(){this.detach();for(const t in this.keyUriToKeyInfo){const e=this.keyUriToKeyInfo[t].loader;e&&e.destroy()}this.keyUriToKeyInfo={}}createKeyLoadError(t,e=ts.KEY_LOAD_ERROR,i,s,n){return new va({type:Ji.NETWORK_ERROR,details:e,fatal:!1,frag:t,response:n,error:i,networkDetails:s})}loadClear(t,e){if(this.emeController&&this.config.emeEnabled){const{sn:i,cc:s}=t;for(let t=0;t<e.length;t++){const n=e[t];if(s<=n.cc&&("initSegment"===i||"initSegment"===n.sn||i<n.sn)){this.emeController.selectKeySystemFormat(n).then((t=>{n.setKeyFormat(t)}));break}}}}load(t){return!t.decryptdata&&t.encrypted&&this.emeController?this.emeController.selectKeySystemFormat(t).then((e=>this.loadInternal(t,e))):this.loadInternal(t)}loadInternal(t,e){var i,s;e&&t.setKeyFormat(e);const n=t.decryptdata;if(!n){const i=new Error(e?`Expected frag.decryptdata to be defined after setting format ${e}`:"Missing decryption data on fragment in onKeyLoading");return Promise.reject(this.createKeyLoadError(t,ts.KEY_LOAD_ERROR,i))}const r=n.uri;if(!r)return Promise.reject(this.createKeyLoadError(t,ts.KEY_LOAD_ERROR,new Error(`Invalid key URI: "${r}"`)));let o=this.keyUriToKeyInfo[r];if(null!=(i=o)&&i.decryptdata.key)return n.key=o.decryptdata.key,Promise.resolve({frag:t,keyInfo:o});var a;if(null!=(s=o)&&s.keyLoadPromise)switch(null==(a=o.mediaKeySessionContext)?void 0:a.keyStatus){case void 0:case"status-pending":case"usable":case"usable-in-future":return o.keyLoadPromise.then((e=>(n.key=e.keyInfo.decryptdata.key,{frag:t,keyInfo:o})))}switch(o=this.keyUriToKeyInfo[r]={decryptdata:n,keyLoadPromise:null,loader:null,mediaKeySessionContext:null},n.method){case"ISO-23001-7":case"SAMPLE-AES":case"SAMPLE-AES-CENC":case"SAMPLE-AES-CTR":return"identity"===n.keyFormat?this.loadKeyHTTP(o,t):this.loadKeyEME(o,t);case"AES-128":return this.loadKeyHTTP(o,t);default:return Promise.reject(this.createKeyLoadError(t,ts.KEY_LOAD_ERROR,new Error(`Key supplied with unsupported METHOD: "${n.method}"`)))}}loadKeyEME(t,e){const i={frag:e,keyInfo:t};if(this.emeController&&this.config.emeEnabled){const e=this.emeController.loadKey(i);if(e)return(t.keyLoadPromise=e.then((e=>(t.mediaKeySessionContext=e,i)))).catch((e=>{throw t.keyLoadPromise=null,e}))}return Promise.resolve(i)}loadKeyHTTP(t,e){const i=this.config,s=i.loader,n=new s(i);return e.keyLoader=t.loader=n,t.keyLoadPromise=new Promise(((s,r)=>{const o={keyInfo:t,frag:e,responseType:"arraybuffer",url:t.decryptdata.uri},a=i.keyLoadPolicy.default,l={loadPolicy:a,timeout:a.maxLoadTimeMs,maxRetry:0,retryDelay:0,maxRetryDelay:0},c={onSuccess:(t,e,i,n)=>{const{frag:o,keyInfo:a,url:l}=i;if(!o.decryptdata||a!==this.keyUriToKeyInfo[l])return r(this.createKeyLoadError(o,ts.KEY_LOAD_ERROR,new Error("after key load, decryptdata unset or changed"),n));a.decryptdata.key=o.decryptdata.key=new Uint8Array(t.data),o.keyLoader=null,a.loader=null,s({frag:o,keyInfo:a})},onError:(t,i,s,n)=>{this.resetLoader(i),r(this.createKeyLoadError(e,ts.KEY_LOAD_ERROR,new Error(`HTTP Error ${t.code} loading key ${t.text}`),s,Vi({url:o.url,data:void 0},t)))},onTimeout:(t,i,s)=>{this.resetLoader(i),r(this.createKeyLoadError(e,ts.KEY_LOAD_TIMEOUT,new Error("key loading timed out"),s))},onAbort:(t,i,s)=>{this.resetLoader(i),r(this.createKeyLoadError(e,ts.INTERNAL_ABORTED,new Error("key loading aborted"),s))}};n.load(o,l,c)}))}resetLoader(t){const{frag:e,keyInfo:i,url:s}=t,n=i.loader;e.keyLoader===n&&(e.keyLoader=null,i.loader=null),delete this.keyUriToKeyInfo[s],n&&n.destroy()}}function Ju(){return self.SourceBuffer||self.WebKitSourceBuffer}function th(){const t=Kn();if(!t)return!1;const e=Ju();return!e||e.prototype&&"function"===typeof e.prototype.appendBuffer&&"function"===typeof e.prototype.remove}function eh(){if(!th())return!1;const t=Kn();return"function"===typeof(null==t?void 0:t.isTypeSupported)&&(["avc1.42E01E,mp4a.40.2","av01.0.01M.08","vp09.00.50.08"].some((e=>t.isTypeSupported(Jn(e,"video"))))||["mp4a.40.2","fLaC"].some((e=>t.isTypeSupported(Jn(e,"audio")))))}function ih(){var t;const e=Ju();return"function"===typeof(null==e||null==(t=e.prototype)?void 0:t.changeType)}const sh=250,nh=2,rh=.1,oh=.05;class ah{constructor(t,e,i,s){this.config=void 0,this.media=null,this.fragmentTracker=void 0,this.hls=void 0,this.nudgeRetry=0,this.stallReported=!1,this.stalled=null,this.moved=!1,this.seeking=!1,this.config=t,this.media=e,this.fragmentTracker=i,this.hls=s}destroy(){this.media=null,this.hls=this.fragmentTracker=null}poll(t,e){const{config:i,media:s,stalled:n}=this;if(null===s)return;const{currentTime:r,seeking:o}=s,a=this.seeking&&!o,l=!this.seeking&&o;if(this.seeking=o,r!==t){if(this.moved=!0,o||(this.nudgeRetry=0),null!==n){if(this.stallReported){const t=self.performance.now()-n;as.warn(`playback not stuck anymore @${r}, after ${Math.round(t)}ms`),this.stallReported=!1}this.stalled=null}return}if(l||a)return void(this.stalled=null);if(s.paused&&!o||s.ended||0===s.playbackRate||!ea.getBuffered(s).length)return void(this.nudgeRetry=0);const c=ea.bufferInfo(s,r,0),d=c.nextStart||0;if(o){const t=c.len>nh,i=!d||e&&e.start<=r||d-r>nh&&!this.fragmentTracker.getPartialFragment(r);if(t||i)return;this.moved=!1}if(!this.moved&&null!==this.stalled){var u;const t=c.len>0;if(!t&&!d)return;const e=Math.max(d,c.start||0)-r,i=this.hls.levels?this.hls.levels[this.hls.currentLevel]:null,n=null==i||null==(u=i.details)?void 0:u.live,o=n?2*i.details.targetduration:nh,a=this.fragmentTracker.getPartialFragment(r);if(e>0&&(e<=o||a))return void(s.paused||this._trySkipBufferHole(a))}const h=self.performance.now();if(null===n)return void(this.stalled=h);const p=h-n;if(!o&&p>=sh&&(this._reportStall(c),!this.media))return;const f=ea.bufferInfo(s,r,i.maxBufferHole);this._tryFixBufferStall(f,p)}_tryFixBufferStall(t,e){const{config:i,fragmentTracker:s,media:n}=this;if(null===n)return;const r=n.currentTime,o=s.getPartialFragment(r);if(o){const t=this._trySkipBufferHole(o);if(t||!this.media)return}(t.len>i.maxBufferHole||t.nextStart&&t.nextStart-r<i.maxBufferHole)&&e>1e3*i.highBufferWatchdogPeriod&&(as.warn("Trying to nudge playhead over buffer-hole"),this.stalled=null,this._tryNudgeBuffer())}_reportStall(t){const{hls:e,media:i,stallReported:s}=this;if(!s&&i){this.stallReported=!0;const s=new Error(`Playback stalling at @${i.currentTime} due to low buffer (${JSON.stringify(t)})`);as.warn(s.message),e.trigger(Qi.ERROR,{type:Ji.MEDIA_ERROR,details:ts.BUFFER_STALLED_ERROR,fatal:!1,error:s,buffer:t.len})}}_trySkipBufferHole(t){const{config:e,hls:i,media:s}=this;if(null===s)return 0;const n=s.currentTime,r=ea.bufferInfo(s,n,0),o=n<r.start?r.start:r.nextStart;if(o){const a=r.len<=e.maxBufferHole,l=r.len>0&&r.len<1&&s.readyState<3,c=o-n;if(c>0&&(a||l)){if(c>e.maxBufferHole){const{fragmentTracker:e}=this;let i=!1;if(0===n){const t=e.getAppendedFrag(0,Tr.MAIN);t&&o<t.end&&(i=!0)}if(!i){const i=t||e.getAppendedFrag(n,Tr.MAIN);if(i){let t=!1,s=i.end;while(s<o){const i=e.getPartialFragment(s);if(!i){t=!0;break}s+=i.duration}if(t)return 0}}}const r=Math.max(o+oh,n+rh);if(as.warn(`skipping hole, adjusting currentTime from ${n} to ${r}`),this.moved=!0,this.stalled=null,s.currentTime=r,t&&!t.gap){const e=new Error(`fragment loaded with buffer holes, seeking from ${n} to ${r}`);i.trigger(Qi.ERROR,{type:Ji.MEDIA_ERROR,details:ts.BUFFER_SEEK_OVER_HOLE,fatal:!1,error:e,reason:e.message,frag:t})}return r}}return 0}_tryNudgeBuffer(){const{config:t,hls:e,media:i,nudgeRetry:s}=this;if(null===i)return;const n=i.currentTime;if(this.nudgeRetry++,s<t.nudgeMaxRetry){const r=n+(s+1)*t.nudgeOffset,o=new Error(`Nudging 'currentTime' from ${n} to ${r}`);as.warn(o.message),i.currentTime=r,e.trigger(Qi.ERROR,{type:Ji.MEDIA_ERROR,details:ts.BUFFER_NUDGE_ON_STALL,error:o,fatal:!1})}else{const i=new Error(`Playhead still not moving while enough data buffered @${n} after ${t.nudgeMaxRetry} nudges`);as.error(i.message),e.trigger(Qi.ERROR,{type:Ji.MEDIA_ERROR,details:ts.BUFFER_STALLED_ERROR,error:i,fatal:!0})}}}const lh=100;class ch extends Ca{constructor(t,e,i){super(t,e,i,"[stream-controller]",Tr.MAIN),this.audioCodecSwap=!1,this.gapController=null,this.level=-1,this._forceStartLoad=!1,this.altAudio=!1,this.audioOnly=!1,this.fragPlaying=null,this.onvplaying=null,this.onvseeked=null,this.fragLastKbps=0,this.couldBacktrack=!1,this.backtrackFragment=null,this.audioCodecSwitch=!1,this.videoBuffer=null,this._registerListeners()}_registerListeners(){const{hls:t}=this;t.on(Qi.MEDIA_ATTACHED,this.onMediaAttached,this),t.on(Qi.MEDIA_DETACHING,this.onMediaDetaching,this),t.on(Qi.MANIFEST_LOADING,this.onManifestLoading,this),t.on(Qi.MANIFEST_PARSED,this.onManifestParsed,this),t.on(Qi.LEVEL_LOADING,this.onLevelLoading,this),t.on(Qi.LEVEL_LOADED,this.onLevelLoaded,this),t.on(Qi.FRAG_LOAD_EMERGENCY_ABORTED,this.onFragLoadEmergencyAborted,this),t.on(Qi.ERROR,this.onError,this),t.on(Qi.AUDIO_TRACK_SWITCHING,this.onAudioTrackSwitching,this),t.on(Qi.AUDIO_TRACK_SWITCHED,this.onAudioTrackSwitched,this),t.on(Qi.BUFFER_CREATED,this.onBufferCreated,this),t.on(Qi.BUFFER_FLUSHED,this.onBufferFlushed,this),t.on(Qi.LEVELS_UPDATED,this.onLevelsUpdated,this),t.on(Qi.FRAG_BUFFERED,this.onFragBuffered,this)}_unregisterListeners(){const{hls:t}=this;t.off(Qi.MEDIA_ATTACHED,this.onMediaAttached,this),t.off(Qi.MEDIA_DETACHING,this.onMediaDetaching,this),t.off(Qi.MANIFEST_LOADING,this.onManifestLoading,this),t.off(Qi.MANIFEST_PARSED,this.onManifestParsed,this),t.off(Qi.LEVEL_LOADED,this.onLevelLoaded,this),t.off(Qi.FRAG_LOAD_EMERGENCY_ABORTED,this.onFragLoadEmergencyAborted,this),t.off(Qi.ERROR,this.onError,this),t.off(Qi.AUDIO_TRACK_SWITCHING,this.onAudioTrackSwitching,this),t.off(Qi.AUDIO_TRACK_SWITCHED,this.onAudioTrackSwitched,this),t.off(Qi.BUFFER_CREATED,this.onBufferCreated,this),t.off(Qi.BUFFER_FLUSHED,this.onBufferFlushed,this),t.off(Qi.LEVELS_UPDATED,this.onLevelsUpdated,this),t.off(Qi.FRAG_BUFFERED,this.onFragBuffered,this)}onHandlerDestroying(){this._unregisterListeners(),super.onHandlerDestroying()}startLoad(t){if(this.levels){const{lastCurrentTime:e,hls:i}=this;if(this.stopLoad(),this.setInterval(lh),this.level=-1,!this.startFragRequested){let t=i.startLevel;-1===t&&(i.config.testBandwidth&&this.levels.length>1?(t=0,this.bitrateTest=!0):t=i.firstAutoLevel),i.nextLoadLevel=t,this.level=i.loadLevel,this.loadedmetadata=!1}e>0&&-1===t&&(this.log(`Override startPosition with lastCurrentTime @${e.toFixed(3)}`),t=e),this.state=xa.IDLE,this.nextLoadPosition=this.startPosition=this.lastCurrentTime=t,this.tick()}else this._forceStartLoad=!0,this.state=xa.STOPPED}stopLoad(){this._forceStartLoad=!1,super.stopLoad()}doTick(){switch(this.state){case xa.WAITING_LEVEL:{const{levels:t,level:e}=this,i=null==t?void 0:t[e],s=null==i?void 0:i.details;if(s&&(!s.live||this.levelLastLoaded===i)){if(this.waitForCdnTuneIn(s))break;this.state=xa.IDLE;break}if(this.hls.nextLoadLevel!==this.level){this.state=xa.IDLE;break}break}case xa.FRAG_LOADING_WAITING_RETRY:{var t;const e=self.performance.now(),i=this.retryDate;if(!i||e>=i||null!=(t=this.media)&&t.seeking){const{levels:t,level:e}=this,i=null==t?void 0:t[e];this.resetStartWhenNotLoaded(i||null),this.state=xa.IDLE}}break}this.state===xa.IDLE&&this.doTickIdle(),this.onTickEnd()}onTickEnd(){super.onTickEnd(),this.checkBuffer(),this.checkFragmentChanged()}doTickIdle(){const{hls:t,levelLastLoaded:e,levels:i,media:s}=this;if(null===e||!s&&(this.startFragRequested||!t.config.startFragPrefetch))return;if(this.altAudio&&this.audioOnly)return;const n=this.buffering?t.nextLoadLevel:t.loadLevel;if(null==i||!i[n])return;const r=i[n],o=this.getMainFwdBufferInfo();if(null===o)return;const a=this.getLevelDetails();if(a&&this._streamEnded(o,a)){const t={};return this.altAudio&&(t.type="video"),this.hls.trigger(Qi.BUFFER_EOS,t),void(this.state=xa.ENDED)}if(!this.buffering)return;t.loadLevel!==n&&-1===t.manualLevel&&this.log(`Adapting to level ${n} from level ${this.level}`),this.level=t.nextLoadLevel=n;const l=r.details;if(!l||this.state===xa.WAITING_LEVEL||l.live&&this.levelLastLoaded!==r)return this.level=n,void(this.state=xa.WAITING_LEVEL);const c=o.len,d=this.getMaxBufferLength(r.maxBitrate);if(c>=d)return;this.backtrackFragment&&this.backtrackFragment.start>o.end&&(this.backtrackFragment=null);const u=this.backtrackFragment?this.backtrackFragment.start:o.end;let h=this.getNextFragment(u,l);if(this.couldBacktrack&&!this.fragPrevious&&h&&"initSegment"!==h.sn&&this.fragmentTracker.getState(h)!==Xo.OK){var p;const t=(null!=(p=this.backtrackFragment)?p:h).sn,e=t-l.startSN,i=l.fragments[e-1];i&&h.cc===i.cc&&(h=i,this.fragmentTracker.removeFragment(i))}else this.backtrackFragment&&o.len&&(this.backtrackFragment=null);if(h&&this.isLoopLoading(h,u)){const t=h.gap;if(!t){const t=this.audioOnly&&!this.altAudio?ms.AUDIO:ms.VIDEO,e=(t===ms.VIDEO?this.videoBuffer:this.mediaBuffer)||this.media;e&&this.afterBufferFlushed(e,t,Tr.MAIN)}h=this.getNextFragmentLoopLoading(h,l,o,Tr.MAIN,d)}h&&(!h.initSegment||h.initSegment.data||this.bitrateTest||(h=h.initSegment),this.loadFragment(h,r,u))}loadFragment(t,e,i){const s=this.fragmentTracker.getState(t);this.fragCurrent=t,s===Xo.NOT_LOADED||s===Xo.PARTIAL?"initSegment"===t.sn?this._loadInitSegment(t,e):this.bitrateTest?(this.log(`Fragment ${t.sn} of level ${t.level} is being downloaded to test bitrate and will not be buffered`),this._loadBitrateTestFrag(t,e)):(this.startFragRequested=!0,super.loadFragment(t,e,i)):this.clearTrackerIfNeeded(t)}getBufferedFrag(t){return this.fragmentTracker.getBufferedFrag(t,Tr.MAIN)}followingBufferedFrag(t){return t?this.getBufferedFrag(t.end+.5):null}immediateLevelSwitch(){this.abortCurrentFrag(),this.flushMainBuffer(0,Number.POSITIVE_INFINITY)}nextLevelSwitch(){const{levels:t,media:e}=this;if(null!=e&&e.readyState){let i;const s=this.getAppendedFrag(e.currentTime);s&&s.start>1&&this.flushMainBuffer(0,s.start-1);const n=this.getLevelDetails();if(null!=n&&n.live){const t=this.getMainFwdBufferInfo();if(!t||t.len<2*n.targetduration)return}if(!e.paused&&t){const e=this.hls.nextLoadLevel,s=t[e],n=this.fragLastKbps;i=n&&this.fragCurrent?this.fragCurrent.duration*s.maxBitrate/(1e3*n)+1:0}else i=0;const r=this.getBufferedFrag(e.currentTime+i);if(r){const t=this.followingBufferedFrag(r);if(t){this.abortCurrentFrag();const e=t.maxStartPTS?t.maxStartPTS:t.start,i=t.duration,s=Math.max(r.end,e+Math.min(Math.max(i-this.config.maxFragLookUpTolerance,i*(this.couldBacktrack?.5:.125)),i*(this.couldBacktrack?.75:.25)));this.flushMainBuffer(s,Number.POSITIVE_INFINITY)}}}}abortCurrentFrag(){const t=this.fragCurrent;switch(this.fragCurrent=null,this.backtrackFragment=null,t&&(t.abortRequests(),this.fragmentTracker.removeFragment(t)),this.state){case xa.KEY_LOADING:case xa.FRAG_LOADING:case xa.FRAG_LOADING_WAITING_RETRY:case xa.PARSING:case xa.PARSED:this.state=xa.IDLE;break}this.nextLoadPosition=this.getLoadPosition()}flushMainBuffer(t,e){super.flushMainBuffer(t,e,this.altAudio?"video":null)}onMediaAttached(t,e){super.onMediaAttached(t,e);const i=e.media;this.onvplaying=this.onMediaPlaying.bind(this),this.onvseeked=this.onMediaSeeked.bind(this),i.addEventListener("playing",this.onvplaying),i.addEventListener("seeked",this.onvseeked),this.gapController=new ah(this.config,i,this.fragmentTracker,this.hls)}onMediaDetaching(){const{media:t}=this;t&&this.onvplaying&&this.onvseeked&&(t.removeEventListener("playing",this.onvplaying),t.removeEventListener("seeked",this.onvseeked),this.onvplaying=this.onvseeked=null,this.videoBuffer=null),this.fragPlaying=null,this.gapController&&(this.gapController.destroy(),this.gapController=null),super.onMediaDetaching()}onMediaPlaying(){this.tick()}onMediaSeeked(){const t=this.media,e=t?t.currentTime:null;Yi(e)&&this.log(`Media seeked to ${e.toFixed(3)}`);const i=this.getMainFwdBufferInfo();null!==i&&0!==i.len?this.tick():this.warn(`Main forward buffer length on "seeked" event ${i?i.len:"empty"})`)}onManifestLoading(){this.log("Trigger BUFFER_RESET"),this.hls.trigger(Qi.BUFFER_RESET,void 0),this.fragmentTracker.removeAllFragments(),this.couldBacktrack=!1,this.startPosition=this.lastCurrentTime=this.fragLastKbps=0,this.levels=this.fragPlaying=this.backtrackFragment=this.levelLastLoaded=null,this.altAudio=this.audioOnly=this.startFragRequested=!1}onManifestParsed(t,e){let i=!1,s=!1;e.levels.forEach((t=>{const e=t.audioCodec;e&&(i=i||-1!==e.indexOf("mp4a.40.2"),s=s||-1!==e.indexOf("mp4a.40.5"))})),this.audioCodecSwitch=i&&s&&!ih(),this.audioCodecSwitch&&this.log("Both AAC/HE-AAC audio found in levels; declaring level codec as HE-AAC"),this.levels=e.levels,this.startFragRequested=!1}onLevelLoading(t,e){const{levels:i}=this;if(!i||this.state!==xa.IDLE)return;const s=i[e.level];(!s.details||s.details.live&&this.levelLastLoaded!==s||this.waitForCdnTuneIn(s.details))&&(this.state=xa.WAITING_LEVEL)}onLevelLoaded(t,e){var i;const{levels:s}=this,n=e.level,r=e.details,o=r.totalduration;if(!s)return void this.warn(`Levels were reset while loading level ${n}`);this.log(`Level ${n} loaded [${r.startSN},${r.endSN}]${r.lastPartSn?`[part-${r.lastPartSn}-${r.lastPartIndex}]`:""}, cc [${r.startCC}, ${r.endCC}] duration:${o}`);const a=s[n],l=this.fragCurrent;!l||this.state!==xa.FRAG_LOADING&&this.state!==xa.FRAG_LOADING_WAITING_RETRY||l.level!==e.level&&l.loader&&this.abortCurrentFrag();let c=0;if(r.live||null!=(i=a.details)&&i.live){var d;if(this.checkLiveUpdate(r),r.deltaUpdateFailed)return;c=this.alignPlaylists(r,a.details,null==(d=this.levelLastLoaded)?void 0:d.details)}if(a.details=r,this.levelLastLoaded=a,this.hls.trigger(Qi.LEVEL_UPDATED,{details:r,level:n}),this.state===xa.WAITING_LEVEL){if(this.waitForCdnTuneIn(r))return;this.state=xa.IDLE}this.startFragRequested?r.live&&this.synchronizeToLiveEdge(r):this.setStartPosition(r,c),this.tick()}_handleFragmentLoadProgress(t){var e;const{frag:i,part:s,payload:n}=t,{levels:r}=this;if(!r)return void this.warn(`Levels were reset while fragment load was in progress. Fragment ${i.sn} of level ${i.level} will not be buffered`);const o=r[i.level],a=o.details;if(!a)return this.warn(`Dropping fragment ${i.sn} of level ${i.level} after level details were reset`),void this.fragmentTracker.removeFragment(i);const l=o.videoCodec,c=a.PTSKnown||!a.live,d=null==(e=i.initSegment)?void 0:e.data,u=this._getAudioCodec(o),h=this.transmuxer=this.transmuxer||new ic(this.hls,Tr.MAIN,this._handleTransmuxComplete.bind(this),this._handleTransmuxerFlush.bind(this)),p=s?s.index:-1,f=-1!==p,m=new ia(i.level,i.sn,i.stats.chunkCount,n.byteLength,p,f),v=this.initPTS[i.cc];h.push(n,d,u,l,i,s,a.totalduration,c,m,v)}onAudioTrackSwitching(t,e){const i=this.altAudio,s=!!e.url;if(!s){if(this.mediaBuffer!==this.media){this.log("Switching on main audio, use media.buffered to schedule main fragment loading"),this.mediaBuffer=this.media;const t=this.fragCurrent;t&&(this.log("Switching to main audio track, cancel main fragment load"),t.abortRequests(),this.fragmentTracker.removeFragment(t)),this.resetTransmuxer(),this.resetLoadingState()}else this.audioOnly&&this.resetTransmuxer();const t=this.hls;i&&(t.trigger(Qi.BUFFER_FLUSHING,{startOffset:0,endOffset:Number.POSITIVE_INFINITY,type:null}),this.fragmentTracker.removeAllFragments()),t.trigger(Qi.AUDIO_TRACK_SWITCHED,e)}}onAudioTrackSwitched(t,e){const i=e.id,s=!!this.hls.audioTracks[i].url;if(s){const t=this.videoBuffer;t&&this.mediaBuffer!==t&&(this.log("Switching on alternate audio, use video.buffered to schedule main fragment loading"),this.mediaBuffer=t)}this.altAudio=s,this.tick()}onBufferCreated(t,e){const i=e.tracks;let s,n,r=!1;for(const o in i){const t=i[o];if("main"===t.id){if(n=o,s=t,"video"===o){const t=i[o];t&&(this.videoBuffer=t.buffer)}}else r=!0}r&&s?(this.log(`Alternate track found, use ${n}.buffered to schedule main fragment loading`),this.mediaBuffer=s.buffer):this.mediaBuffer=this.media}onFragBuffered(t,e){const{frag:i,part:s}=e;if(i&&i.type!==Tr.MAIN)return;if(this.fragContextChanged(i))return this.warn(`Fragment ${i.sn}${s?" p: "+s.index:""} of level ${i.level} finished buffering, but was aborted. state: ${this.state}`),void(this.state===xa.PARSED&&(this.state=xa.IDLE));const n=s?s.stats:i.stats;this.fragLastKbps=Math.round(8*n.total/(n.buffering.end-n.loading.first)),"initSegment"!==i.sn&&(this.fragPrevious=i),this.fragBufferedComplete(i,s)}onError(t,e){var i;if(e.fatal)this.state=xa.ERROR;else switch(e.details){case ts.FRAG_GAP:case ts.FRAG_PARSING_ERROR:case ts.FRAG_DECRYPT_ERROR:case ts.FRAG_LOAD_ERROR:case ts.FRAG_LOAD_TIMEOUT:case ts.KEY_LOAD_ERROR:case ts.KEY_LOAD_TIMEOUT:this.onFragmentOrKeyLoadError(Tr.MAIN,e);break;case ts.LEVEL_LOAD_ERROR:case ts.LEVEL_LOAD_TIMEOUT:case ts.LEVEL_PARSING_ERROR:e.levelRetry||this.state!==xa.WAITING_LEVEL||(null==(i=e.context)?void 0:i.type)!==Er.LEVEL||(this.state=xa.IDLE);break;case ts.BUFFER_APPEND_ERROR:case ts.BUFFER_FULL_ERROR:if(!e.parent||"main"!==e.parent)return;if(e.details===ts.BUFFER_APPEND_ERROR)return void this.resetLoadingState();this.reduceLengthAndFlushBuffer(e)&&this.flushMainBuffer(0,Number.POSITIVE_INFINITY);break;case ts.INTERNAL_EXCEPTION:this.recoverWorkerError(e);break}}checkBuffer(){const{media:t,gapController:e}=this;if(t&&e&&t.readyState){if(this.loadedmetadata||!ea.getBuffered(t).length){const t=this.state!==xa.IDLE?this.fragCurrent:null;e.poll(this.lastCurrentTime,t)}this.lastCurrentTime=t.currentTime}}onFragLoadEmergencyAborted(){this.state=xa.IDLE,this.loadedmetadata||(this.startFragRequested=!1,this.nextLoadPosition=this.startPosition),this.tickImmediate()}onBufferFlushed(t,{type:e}){if(e!==ms.AUDIO||this.audioOnly&&!this.altAudio){const t=(e===ms.VIDEO?this.videoBuffer:this.mediaBuffer)||this.media;this.afterBufferFlushed(t,e,Tr.MAIN),this.tick()}}onLevelsUpdated(t,e){this.level>-1&&this.fragCurrent&&(this.level=this.fragCurrent.level),this.levels=e.levels}swapAudioCodec(){this.audioCodecSwap=!this.audioCodecSwap}seekToStartPos(){const{media:t}=this;if(!t)return;const e=t.currentTime;let i=this.startPosition;if(i>=0&&e<i){if(t.seeking)return void this.log(`could not seek to ${i}, already seeking at ${e}`);const s=ea.getBuffered(t),n=s.length?s.start(0):0,r=n-i;r>0&&(r<this.config.maxBufferHole||r<this.config.maxFragLookUpTolerance)&&(this.log(`adjusting start position by ${r} to match buffer start`),i+=r,this.startPosition=i),this.log(`seek to target start position ${i} from current time ${e}`),t.currentTime=i}}_getAudioCodec(t){let e=this.config.defaultAudioCodec||t.audioCodec;return this.audioCodecSwap&&e&&(this.log("Swapping audio codec"),e=-1!==e.indexOf("mp4a.40.5")?"mp4a.40.2":"mp4a.40.5"),e}_loadBitrateTestFrag(t,e){t.bitrateTest=!0,this._doFragLoad(t,e).then((i=>{const{hls:s}=this;if(!i||this.fragContextChanged(t))return;e.fragmentError=0,this.state=xa.IDLE,this.startFragRequested=!1,this.bitrateTest=!1;const n=t.stats;n.parsing.start=n.parsing.end=n.buffering.start=n.buffering.end=self.performance.now(),s.trigger(Qi.FRAG_LOADED,i),t.bitrateTest=!1}))}_handleTransmuxComplete(t){var e;const i="main",{hls:s}=this,{remuxResult:n,chunkMeta:r}=t,o=this.getCurrentContext(r);if(!o)return void this.resetWhenMissingContext(r);const{frag:a,part:l,level:c}=o,{video:d,text:u,id3:h,initSegment:p}=n,{details:f}=c,m=this.altAudio?void 0:n.audio;if(this.fragContextChanged(a))this.fragmentTracker.removeFragment(a);else{if(this.state=xa.PARSING,p){if(null!=p&&p.tracks){const t=a.initSegment||a;this._bufferInitSegment(c,p.tracks,t,r),s.trigger(Qi.FRAG_PARSING_INIT_SEGMENT,{frag:t,id:i,tracks:p.tracks})}const t=p.initPTS,e=p.timescale;Yi(t)&&(this.initPTS[a.cc]={baseTime:t,timescale:e},s.trigger(Qi.INIT_PTS_FOUND,{frag:a,id:i,initPTS:t,timescale:e}))}if(d&&f&&"initSegment"!==a.sn){const t=f.fragments[a.sn-1-f.startSN],e=a.sn===f.startSN,i=!t||a.cc>t.cc;if(!1!==n.independent){const{startPTS:t,endPTS:s,startDTS:n,endDTS:o}=d;if(l)l.elementaryStreams[d.type]={startPTS:t,endPTS:s,startDTS:n,endDTS:o};else if(d.firstKeyFrame&&d.independent&&1===r.id&&!i&&(this.couldBacktrack=!0),d.dropped&&d.independent){const n=this.getMainFwdBufferInfo(),r=(n?n.end:this.getLoadPosition())+this.config.maxBufferHole,l=d.firstKeyFramePTS?d.firstKeyFramePTS:t;if(!e&&r<l-this.config.maxBufferHole&&!i)return void this.backtrack(a);i&&(a.gap=!0),a.setElementaryStreamInfo(d.type,a.start,s,a.start,o,!0)}else e&&t>nh&&(a.gap=!0);a.setElementaryStreamInfo(d.type,t,s,n,o),this.backtrackFragment&&(this.backtrackFragment=a),this.bufferFragmentData(d,a,l,r,e||i)}else{if(!e&&!i)return void this.backtrack(a);a.gap=!0}}if(m){const{startPTS:t,endPTS:e,startDTS:i,endDTS:s}=m;l&&(l.elementaryStreams[ms.AUDIO]={startPTS:t,endPTS:e,startDTS:i,endDTS:s}),a.setElementaryStreamInfo(ms.AUDIO,t,e,i,s),this.bufferFragmentData(m,a,l,r)}if(f&&null!=h&&null!=(e=h.samples)&&e.length){const t={id:i,frag:a,details:f,samples:h.samples};s.trigger(Qi.FRAG_PARSING_METADATA,t)}if(f&&u){const t={id:i,frag:a,details:f,samples:u.samples};s.trigger(Qi.FRAG_PARSING_USERDATA,t)}}}_bufferInitSegment(t,e,i,s){if(this.state!==xa.PARSING)return;this.audioOnly=!!e.audio&&!e.video,this.altAudio&&!this.audioOnly&&delete e.audio;const{audio:n,video:r,audiovideo:o}=e;if(n){let e=t.audioCodec;const i=navigator.userAgent.toLowerCase();if(this.audioCodecSwitch){e&&(e=-1!==e.indexOf("mp4a.40.5")?"mp4a.40.2":"mp4a.40.5");const t=n.metadata;t&&"channelCount"in t&&1!==(t.channelCount||1)&&-1===i.indexOf("firefox")&&(e="mp4a.40.5")}e&&-1!==e.indexOf("mp4a.40.5")&&-1!==i.indexOf("android")&&"audio/mpeg"!==n.container&&(e="mp4a.40.2",this.log(`Android: force audio codec to ${e}`)),t.audioCodec&&t.audioCodec!==e&&this.log(`Swapping manifest audio codec "${t.audioCodec}" for "${e}"`),n.levelCodec=e,n.id="main",this.log(`Init audio buffer, container:${n.container}, codecs[selected/level/parsed]=[${e||""}/${t.audioCodec||""}/${n.codec}]`)}r&&(r.levelCodec=t.videoCodec,r.id="main",this.log(`Init video buffer, container:${r.container}, codecs[level/parsed]=[${t.videoCodec||""}/${r.codec}]`)),o&&this.log(`Init audiovideo buffer, container:${o.container}, codecs[level/parsed]=[${t.codecs}/${o.codec}]`),this.hls.trigger(Qi.BUFFER_CODECS,e),Object.keys(e).forEach((t=>{const n=e[t],r=n.initSegment;null!=r&&r.byteLength&&this.hls.trigger(Qi.BUFFER_APPENDING,{type:t,data:r,frag:i,part:null,chunkMeta:s,parent:i.type})})),this.tickImmediate()}getMainFwdBufferInfo(){return this.getFwdBufferInfo(this.mediaBuffer?this.mediaBuffer:this.media,Tr.MAIN)}backtrack(t){this.couldBacktrack=!0,this.backtrackFragment=t,this.resetTransmuxer(),this.flushBufferGap(t),this.fragmentTracker.removeFragment(t),this.fragPrevious=null,this.nextLoadPosition=t.start,this.state=xa.IDLE}checkFragmentChanged(){const t=this.media;let e=null;if(t&&t.readyState>1&&!1===t.seeking){const i=t.currentTime;if(ea.isBuffered(t,i)?e=this.getAppendedFrag(i):ea.isBuffered(t,i+.1)&&(e=this.getAppendedFrag(i+.1)),e){this.backtrackFragment=null;const t=this.fragPlaying,i=e.level;t&&e.sn===t.sn&&t.level===i||(this.fragPlaying=e,this.hls.trigger(Qi.FRAG_CHANGED,{frag:e}),t&&t.level===i||this.hls.trigger(Qi.LEVEL_SWITCHED,{level:i}))}}}get nextLevel(){const t=this.nextBufferedFrag;return t?t.level:-1}get currentFrag(){const t=this.media;return t?this.fragPlaying||this.getAppendedFrag(t.currentTime):null}get currentProgramDateTime(){const t=this.media;if(t){const e=t.currentTime,i=this.currentFrag;if(i&&Yi(e)&&Yi(i.programDateTime)){const t=i.programDateTime+1e3*(e-i.start);return new Date(t)}}return null}get currentLevel(){const t=this.currentFrag;return t?t.level:-1}get nextBufferedFrag(){const t=this.currentFrag;return t?this.followingBufferedFrag(t):null}get forceStartLoad(){return this._forceStartLoad}}class dh{static get version(){return"1.5.18"}static isMSESupported(){return th()}static isSupported(){return eh()}static getMediaSource(){return Kn()}static get Events(){return Qi}static get ErrorTypes(){return Ji}static get ErrorDetails(){return ts}static get DefaultConfig(){return dh.defaultConfig?dh.defaultConfig:Vu}static set DefaultConfig(t){dh.defaultConfig=t}constructor(t={}){this.config=void 0,this.userConfig=void 0,this.coreComponents=void 0,this.networkControllers=void 0,this.started=!1,this._emitter=new ec,this._autoLevelCapping=-1,this._maxHdcpLevel=null,this.abrController=void 0,this.bufferController=void 0,this.capLevelController=void 0,this.latencyController=void 0,this.levelController=void 0,this.streamController=void 0,this.audioTrackController=void 0,this.subtitleTrackController=void 0,this.emeController=void 0,this.cmcdController=void 0,this._media=null,this.url=null,this.triggeringException=void 0,os(t.debug||!1,"Hls instance");const e=this.config=zu(dh.DefaultConfig,t);this.userConfig=t,e.progressive&&Wu(e);const{abrController:i,bufferController:s,capLevelController:n,errorController:r,fpsController:o}=e,a=new r(this),l=this.abrController=new i(this),c=this.bufferController=new s(this),d=this.capLevelController=new n(this),u=new o(this),h=new _r(this),p=new jr(this),f=e.contentSteeringController,m=f?new f(this):null,v=this.levelController=new Xu(this,m),g=new Zo(this),y=new Qu(this.config),b=this.streamController=new ch(this,g,y);d.setStreamController(b),u.setStreamController(b);const w=[h,v,b];m&&w.splice(1,0,m),this.networkControllers=w;const S=[l,c,d,u,p,g];this.audioTrackController=this.createController(e.audioTrackController,w);const E=e.audioStreamController;E&&w.push(new E(this,g,y)),this.subtitleTrackController=this.createController(e.subtitleTrackController,w);const T=e.subtitleStreamController;T&&w.push(new T(this,g,y)),this.createController(e.timelineController,S),y.emeController=this.emeController=this.createController(e.emeController,S),this.cmcdController=this.createController(e.cmcdController,S),this.latencyController=this.createController(qr,S),this.coreComponents=S,w.push(a);const x=a.onErrorOut;"function"===typeof x&&this.on(Qi.ERROR,x,a)}createController(t,e){if(t){const i=new t(this);return e&&e.push(i),i}return null}on(t,e,i=this){this._emitter.on(t,e,i)}once(t,e,i=this){this._emitter.once(t,e,i)}removeAllListeners(t){this._emitter.removeAllListeners(t)}off(t,e,i=this,s){this._emitter.off(t,e,i,s)}listeners(t){return this._emitter.listeners(t)}emit(t,e,i){return this._emitter.emit(t,e,i)}trigger(t,e){if(this.config.debug)return this.emit(t,t,e);try{return this.emit(t,t,e)}catch(i){if(as.error("An internal error happened while handling event "+t+'. Error message: "'+i.message+'". Here is a stacktrace:',i),!this.triggeringException){this.triggeringException=!0;const e=t===Qi.ERROR;this.trigger(Qi.ERROR,{type:Ji.OTHER_ERROR,details:ts.INTERNAL_EXCEPTION,fatal:e,event:t,error:i}),this.triggeringException=!1}}return!1}listenerCount(t){return this._emitter.listenerCount(t)}destroy(){as.log("destroy"),this.trigger(Qi.DESTROYING,void 0),this.detachMedia(),this.removeAllListeners(),this._autoLevelCapping=-1,this.url=null,this.networkControllers.forEach((t=>t.destroy())),this.networkControllers.length=0,this.coreComponents.forEach((t=>t.destroy())),this.coreComponents.length=0;const t=this.config;t.xhrSetup=t.fetchSetup=void 0,this.userConfig=null}attachMedia(t){as.log("attachMedia"),this._media=t,this.trigger(Qi.MEDIA_ATTACHING,{media:t})}detachMedia(){as.log("detachMedia"),this.trigger(Qi.MEDIA_DETACHING,void 0),this._media=null}loadSource(t){this.stopLoad();const e=this.media,i=this.url,s=this.url=qi.buildAbsoluteURL(self.location.href,t,{alwaysNormalize:!0});this._autoLevelCapping=-1,this._maxHdcpLevel=null,as.log(`loadSource:${s}`),e&&i&&(i!==s||this.bufferController.hasSourceTypes())&&(this.detachMedia(),this.attachMedia(e)),this.trigger(Qi.MANIFEST_LOADING,{url:t})}startLoad(t=-1){as.log(`startLoad(${t})`),this.started=!0,this.resumeBuffering();for(let e=0;e<this.networkControllers.length;e++)if(this.networkControllers[e].startLoad(t),!this.started||!this.networkControllers)break}stopLoad(){as.log("stopLoad"),this.started=!1;for(let t=0;t<this.networkControllers.length;t++)if(this.networkControllers[t].stopLoad(),this.started||!this.networkControllers)break}resumeBuffering(){as.log("resume buffering"),this.networkControllers.forEach((t=>{t.resumeBuffering&&t.resumeBuffering()}))}pauseBuffering(){as.log("pause buffering"),this.networkControllers.forEach((t=>{t.pauseBuffering&&t.pauseBuffering()}))}swapAudioCodec(){as.log("swapAudioCodec"),this.streamController.swapAudioCodec()}recoverMediaError(){as.log("recoverMediaError");const t=this._media;this.detachMedia(),t&&this.attachMedia(t)}removeLevel(t){this.levelController.removeLevel(t)}get levels(){const t=this.levelController.levels;return t||[]}get currentLevel(){return this.streamController.currentLevel}set currentLevel(t){as.log(`set currentLevel:${t}`),this.levelController.manualLevel=t,this.streamController.immediateLevelSwitch()}get nextLevel(){return this.streamController.nextLevel}set nextLevel(t){as.log(`set nextLevel:${t}`),this.levelController.manualLevel=t,this.streamController.nextLevelSwitch()}get loadLevel(){return this.levelController.level}set loadLevel(t){as.log(`set loadLevel:${t}`),this.levelController.manualLevel=t}get nextLoadLevel(){return this.levelController.nextLoadLevel}set nextLoadLevel(t){this.levelController.nextLoadLevel=t}get firstLevel(){return Math.max(this.levelController.firstLevel,this.minAutoLevel)}set firstLevel(t){as.log(`set firstLevel:${t}`),this.levelController.firstLevel=t}get startLevel(){const t=this.levelController.startLevel;return-1===t&&this.abrController.forcedAutoLevel>-1?this.abrController.forcedAutoLevel:t}set startLevel(t){as.log(`set startLevel:${t}`),-1!==t&&(t=Math.max(t,this.minAutoLevel)),this.levelController.startLevel=t}get capLevelToPlayerSize(){return this.config.capLevelToPlayerSize}set capLevelToPlayerSize(t){const e=!!t;e!==this.config.capLevelToPlayerSize&&(e?this.capLevelController.startCapping():(this.capLevelController.stopCapping(),this.autoLevelCapping=-1,this.streamController.nextLevelSwitch()),this.config.capLevelToPlayerSize=e)}get autoLevelCapping(){return this._autoLevelCapping}get bandwidthEstimate(){const{bwEstimator:t}=this.abrController;return t?t.getEstimate():NaN}set bandwidthEstimate(t){this.abrController.resetEstimator(t)}get ttfbEstimate(){const{bwEstimator:t}=this.abrController;return t?t.getEstimateTTFB():NaN}set autoLevelCapping(t){this._autoLevelCapping!==t&&(as.log(`set autoLevelCapping:${t}`),this._autoLevelCapping=t,this.levelController.checkMaxAutoUpdated())}get maxHdcpLevel(){return this._maxHdcpLevel}set maxHdcpLevel(t){Vr(t)&&this._maxHdcpLevel!==t&&(this._maxHdcpLevel=t,this.levelController.checkMaxAutoUpdated())}get autoLevelEnabled(){return-1===this.levelController.manualLevel}get manualLevel(){return this.levelController.manualLevel}get minAutoLevel(){const{levels:t,config:{minAutoBitrate:e}}=this;if(!t)return 0;const i=t.length;for(let s=0;s<i;s++)if(t[s].maxBitrate>=e)return s;return 0}get maxAutoLevel(){const{levels:t,autoLevelCapping:e,maxHdcpLevel:i}=this;let s;if(s=-1===e&&null!=t&&t.length?t.length-1:e,i)for(let n=s;n--;){const e=t[n].attrs["HDCP-LEVEL"];if(e&&e<=i)return n}return s}get firstAutoLevel(){return this.abrController.firstAutoLevel}get nextAutoLevel(){return this.abrController.nextAutoLevel}set nextAutoLevel(t){this.abrController.nextAutoLevel=t}get playingDate(){return this.streamController.currentProgramDateTime}get mainForwardBufferInfo(){return this.streamController.getMainFwdBufferInfo()}setAudioOption(t){var e;return null==(e=this.audioTrackController)?void 0:e.setAudioOption(t)}setSubtitleOption(t){var e;return null==(e=this.subtitleTrackController)||e.setSubtitleOption(t),null}get allAudioTracks(){const t=this.audioTrackController;return t?t.allAudioTracks:[]}get audioTracks(){const t=this.audioTrackController;return t?t.audioTracks:[]}get audioTrack(){const t=this.audioTrackController;return t?t.audioTrack:-1}set audioTrack(t){const e=this.audioTrackController;e&&(e.audioTrack=t)}get allSubtitleTracks(){const t=this.subtitleTrackController;return t?t.allSubtitleTracks:[]}get subtitleTracks(){const t=this.subtitleTrackController;return t?t.subtitleTracks:[]}get subtitleTrack(){const t=this.subtitleTrackController;return t?t.subtitleTrack:-1}get media(){return this._media}set subtitleTrack(t){const e=this.subtitleTrackController;e&&(e.subtitleTrack=t)}get subtitleDisplay(){const t=this.subtitleTrackController;return!!t&&t.subtitleDisplay}set subtitleDisplay(t){const e=this.subtitleTrackController;e&&(e.subtitleDisplay=t)}get lowLatencyMode(){return this.config.lowLatencyMode}set lowLatencyMode(t){this.config.lowLatencyMode=t}get liveSyncPosition(){return this.latencyController.liveSyncPosition}get latency(){return this.latencyController.latency}get maxLatency(){return this.latencyController.maxLatency}get targetLatency(){return this.latencyController.targetLatency}get drift(){return this.latencyController.drift}get forceStartLoad(){return this.streamController.forceStartLoad}}function uh(){this.__data__=new me,this.size=0}dh.defaultConfig=void 0;var hh=uh;function ph(t){var e=this.__data__,i=e["delete"](t);return this.size=e.size,i}var fh=ph;function mh(t){return this.__data__.get(t)}var vh=mh;function gh(t){return this.__data__.has(t)}var yh=gh,bh=200;function wh(t,e){var i=this.__data__;if(i instanceof me){var s=i.__data__;if(!ge||s.length<bh-1)return s.push([t,e]),this.size=++i.size,this;i=this.__data__=new Pe(s)}return i.set(t,e),this.size=i.size,this}var Sh=wh;function Eh(t){var e=this.__data__=new me(t);this.size=e.size}Eh.prototype.clear=hh,Eh.prototype["delete"]=fh,Eh.prototype.get=vh,Eh.prototype.has=yh,Eh.prototype.set=Sh;var Th=Eh;function xh(t,e){var i=-1,s=null==t?0:t.length;while(++i<s)if(!1===e(t[i],i,t))break;return t}var Ch=xh,_h=function(){try{var t=It(Object,"defineProperty");return t({},"",{}),t}catch(e){}}(),kh=_h;function Lh(t,e,i){"__proto__"==e&&kh?kh(t,e,{configurable:!0,enumerable:!0,value:i,writable:!0}):t[e]=i}var Ah=Lh,Rh=Object.prototype,Ih=Rh.hasOwnProperty;function Dh(t,e,i){var s=t[e];Ih.call(t,e)&&ee(s,i)&&(void 0!==i||e in t)||Ah(t,e,i)}var Ph=Dh;function Oh(t,e,i,s){var n=!i;i||(i={});var r=-1,o=e.length;while(++r<o){var a=e[r],l=s?s(i[a],t[a],a,i,t):void 0;void 0===l&&(l=t[a]),n?Ah(i,a,l):Ph(i,a,l)}return i}var Mh=Oh;function Nh(t,e){var i=-1,s=Array(t);while(++i<t)s[i]=e(i);return s}var Fh=Nh,Bh="[object Arguments]";function $h(t){return W(t)&&z(t)==Bh}var Uh=$h,jh=Object.prototype,qh=jh.hasOwnProperty,Gh=jh.propertyIsEnumerable,Vh=Uh(function(){return arguments}())?Uh:function(t){return W(t)&&qh.call(t,"callee")&&!Gh.call(t,"callee")},Hh=Vh;function zh(){return!1}var Kh=zh,Wh="object"==typeof exports&&exports&&!exports.nodeType&&exports,Yh=Wh&&"object"==typeof module&&module&&!module.nodeType&&module,Xh=Yh&&Yh.exports===Wh,Zh=Xh?A.Buffer:void 0,Qh=Zh?Zh.isBuffer:void 0,Jh=Qh||Kh,tp=Jh,ep=9007199254740991,ip=/^(?:0|[1-9]\d*)$/;function sp(t,e){var i=typeof t;return e=null==e?ep:e,!!e&&("number"==i||"symbol"!=i&&ip.test(t))&&t>-1&&t%1==0&&t<e}var np=sp,rp=9007199254740991;function op(t){return"number"==typeof t&&t>-1&&t%1==0&&t<=rp}var ap=op,lp="[object Arguments]",cp="[object Array]",dp="[object Boolean]",up="[object Date]",hp="[object Error]",pp="[object Function]",fp="[object Map]",mp="[object Number]",vp="[object Object]",gp="[object RegExp]",yp="[object Set]",bp="[object String]",wp="[object WeakMap]",Sp="[object ArrayBuffer]",Ep="[object DataView]",Tp="[object Float32Array]",xp="[object Float64Array]",Cp="[object Int8Array]",_p="[object Int16Array]",kp="[object Int32Array]",Lp="[object Uint8Array]",Ap="[object Uint8ClampedArray]",Rp="[object Uint16Array]",Ip="[object Uint32Array]",Dp={};function Pp(t){return W(t)&&ap(t.length)&&!!Dp[z(t)]}Dp[Tp]=Dp[xp]=Dp[Cp]=Dp[_p]=Dp[kp]=Dp[Lp]=Dp[Ap]=Dp[Rp]=Dp[Ip]=!0,Dp[lp]=Dp[cp]=Dp[Sp]=Dp[dp]=Dp[Ep]=Dp[up]=Dp[hp]=Dp[pp]=Dp[fp]=Dp[mp]=Dp[vp]=Dp[gp]=Dp[yp]=Dp[bp]=Dp[wp]=!1;var Op=Pp;function Mp(t){return function(e){return t(e)}}var Np=Mp,Fp="object"==typeof exports&&exports&&!exports.nodeType&&exports,Bp=Fp&&"object"==typeof module&&module&&!module.nodeType&&module,$p=Bp&&Bp.exports===Fp,Up=$p&&_.process,jp=function(){try{var t=Bp&&Bp.require&&Bp.require("util").types;return t||Up&&Up.binding&&Up.binding("util")}catch(e){}}(),qp=jp,Gp=qp&&qp.isTypedArray,Vp=Gp?Np(Gp):Op,Hp=Vp,zp=Object.prototype,Kp=zp.hasOwnProperty;function Wp(t,e){var i=x(t),s=!i&&Hh(t),n=!i&&!s&&tp(t),r=!i&&!s&&!n&&Hp(t),o=i||s||n||r,a=o?Fh(t.length,String):[],l=a.length;for(var c in t)!e&&!Kp.call(t,c)||o&&("length"==c||n&&("offset"==c||"parent"==c)||r&&("buffer"==c||"byteLength"==c||"byteOffset"==c)||np(c,l))||a.push(c);return a}var Yp=Wp,Xp=Object.prototype;function Zp(t){var e=t&&t.constructor,i="function"==typeof e&&e.prototype||Xp;return t===i}var Qp=Zp;function Jp(t,e){return function(i){return t(e(i))}}var tf=Jp,ef=tf(Object.keys,Object),sf=ef,nf=Object.prototype,rf=nf.hasOwnProperty;function of(t){if(!Qp(t))return sf(t);var e=[];for(var i in Object(t))rf.call(t,i)&&"constructor"!=i&&e.push(i);return e}var af=of;function lf(t){return null!=t&&ap(t.length)&&!ct(t)}var cf=lf;function df(t){return cf(t)?Yp(t):af(t)}var uf=df;function hf(t,e){return t&&Mh(e,uf(e),t)}var pf=hf;function ff(t){var e=[];if(null!=t)for(var i in Object(t))e.push(i);return e}var mf=ff,vf=Object.prototype,gf=vf.hasOwnProperty;function yf(t){if(!st(t))return mf(t);var e=Qp(t),i=[];for(var s in t)("constructor"!=s||!e&&gf.call(t,s))&&i.push(s);return i}var bf=yf;function wf(t){return cf(t)?Yp(t,!0):bf(t)}var Sf=wf;function Ef(t,e){return t&&Mh(e,Sf(e),t)}var Tf=Ef,xf="object"==typeof exports&&exports&&!exports.nodeType&&exports,Cf=xf&&"object"==typeof module&&module&&!module.nodeType&&module,_f=Cf&&Cf.exports===xf,kf=_f?A.Buffer:void 0,Lf=kf?kf.allocUnsafe:void 0;function Af(t,e){if(e)return t.slice();var i=t.length,s=Lf?Lf(i):new t.constructor(i);return t.copy(s),s}var Rf=Af;function If(t,e){var i=-1,s=t.length;e||(e=Array(s));while(++i<s)e[i]=t[i];return e}var Df=If;function Pf(t,e){var i=-1,s=null==t?0:t.length,n=0,r=[];while(++i<s){var o=t[i];e(o,i,t)&&(r[n++]=o)}return r}var Of=Pf;function Mf(){return[]}var Nf=Mf,Ff=Object.prototype,Bf=Ff.propertyIsEnumerable,$f=Object.getOwnPropertySymbols,Uf=$f?function(t){return null==t?[]:(t=Object(t),Of($f(t),(function(e){return Bf.call(t,e)})))}:Nf,jf=Uf;function qf(t,e){return Mh(t,jf(t),e)}var Gf=qf;function Vf(t,e){var i=-1,s=e.length,n=t.length;while(++i<s)t[n+i]=e[i];return t}var Hf=Vf,zf=tf(Object.getPrototypeOf,Object),Kf=zf,Wf=Object.getOwnPropertySymbols,Yf=Wf?function(t){var e=[];while(t)Hf(e,jf(t)),t=Kf(t);return e}:Nf,Xf=Yf;function Zf(t,e){return Mh(t,Xf(t),e)}var Qf=Zf;function Jf(t,e,i){var s=e(t);return x(t)?s:Hf(s,i(t))}var tm=Jf;function em(t){return tm(t,uf,jf)}var im=em;function sm(t){return tm(t,Sf,Xf)}var nm=sm,rm=It(A,"DataView"),om=rm,am=It(A,"Promise"),lm=am,cm=It(A,"Set"),dm=cm,um=It(A,"WeakMap"),hm=um,pm="[object Map]",fm="[object Object]",mm="[object Promise]",vm="[object Set]",gm="[object WeakMap]",ym="[object DataView]",bm=yt(om),wm=yt(ge),Sm=yt(lm),Em=yt(dm),Tm=yt(hm),xm=z;(om&&xm(new om(new ArrayBuffer(1)))!=ym||ge&&xm(new ge)!=pm||lm&&xm(lm.resolve())!=mm||dm&&xm(new dm)!=vm||hm&&xm(new hm)!=gm)&&(xm=function(t){var e=z(t),i=e==fm?t.constructor:void 0,s=i?yt(i):"";if(s)switch(s){case bm:return ym;case wm:return pm;case Sm:return mm;case Em:return vm;case Tm:return gm}return e});var Cm=xm,_m=Object.prototype,km=_m.hasOwnProperty;function Lm(t){var e=t.length,i=new t.constructor(e);return e&&"string"==typeof t[0]&&km.call(t,"index")&&(i.index=t.index,i.input=t.input),i}var Am=Lm,Rm=A.Uint8Array,Im=Rm;function Dm(t){var e=new t.constructor(t.byteLength);return new Im(e).set(new Im(t)),e}var Pm=Dm;function Om(t,e){var i=e?Pm(t.buffer):t.buffer;return new t.constructor(i,t.byteOffset,t.byteLength)}var Mm=Om,Nm=/\w*$/;function Fm(t){var e=new t.constructor(t.source,Nm.exec(t));return e.lastIndex=t.lastIndex,e}var Bm=Fm,$m=I?I.prototype:void 0,Um=$m?$m.valueOf:void 0;function jm(t){return Um?Object(Um.call(t)):{}}var qm=jm;function Gm(t,e){var i=e?Pm(t.buffer):t.buffer;return new t.constructor(i,t.byteOffset,t.length)}var Vm=Gm,Hm="[object Boolean]",zm="[object Date]",Km="[object Map]",Wm="[object Number]",Ym="[object RegExp]",Xm="[object Set]",Zm="[object String]",Qm="[object Symbol]",Jm="[object ArrayBuffer]",tv="[object DataView]",ev="[object Float32Array]",iv="[object Float64Array]",sv="[object Int8Array]",nv="[object Int16Array]",rv="[object Int32Array]",ov="[object Uint8Array]",av="[object Uint8ClampedArray]",lv="[object Uint16Array]",cv="[object Uint32Array]";function dv(t,e,i){var s=t.constructor;switch(e){case Jm:return Pm(t);case Hm:case zm:return new s(+t);case tv:return Mm(t,i);case ev:case iv:case sv:case nv:case rv:case ov:case av:case lv:case cv:return Vm(t,i);case Km:return new s;case Wm:case Zm:return new s(t);case Ym:return Bm(t);case Xm:return new s;case Qm:return qm(t)}}var uv=dv,hv=Object.create,pv=function(){function t(){}return function(e){if(!st(e))return{};if(hv)return hv(e);t.prototype=e;var i=new t;return t.prototype=void 0,i}}(),fv=pv;function mv(t){return"function"!=typeof t.constructor||Qp(t)?{}:fv(Kf(t))}var vv=mv,gv="[object Map]";function yv(t){return W(t)&&Cm(t)==gv}var bv=yv,wv=qp&&qp.isMap,Sv=wv?Np(wv):bv,Ev=Sv,Tv="[object Set]";function xv(t){return W(t)&&Cm(t)==Tv}var Cv=xv,_v=qp&&qp.isSet,kv=_v?Np(_v):Cv,Lv=kv,Av=1,Rv=2,Iv=4,Dv="[object Arguments]",Pv="[object Array]",Ov="[object Boolean]",Mv="[object Date]",Nv="[object Error]",Fv="[object Function]",Bv="[object GeneratorFunction]",$v="[object Map]",Uv="[object Number]",jv="[object Object]",qv="[object RegExp]",Gv="[object Set]",Vv="[object String]",Hv="[object Symbol]",zv="[object WeakMap]",Kv="[object ArrayBuffer]",Wv="[object DataView]",Yv="[object Float32Array]",Xv="[object Float64Array]",Zv="[object Int8Array]",Qv="[object Int16Array]",Jv="[object Int32Array]",tg="[object Uint8Array]",eg="[object Uint8ClampedArray]",ig="[object Uint16Array]",sg="[object Uint32Array]",ng={};function rg(t,e,i,s,n,r){var o,a=e&Av,l=e&Rv,c=e&Iv;if(i&&(o=n?i(t,s,n,r):i(t)),void 0!==o)return o;if(!st(t))return t;var d=x(t);if(d){if(o=Am(t),!a)return Df(t,o)}else{var u=Cm(t),h=u==Fv||u==Bv;if(tp(t))return Rf(t,a);if(u==jv||u==Dv||h&&!n){if(o=l||h?{}:vv(t),!a)return l?Qf(t,Tf(o,t)):Gf(t,pf(o,t))}else{if(!ng[u])return n?t:{};o=uv(t,u,a)}}r||(r=new Th);var p=r.get(t);if(p)return p;r.set(t,o),Lv(t)?t.forEach((function(s){o.add(rg(s,e,i,s,t,r))})):Ev(t)&&t.forEach((function(s,n){o.set(n,rg(s,e,i,n,t,r))}));var f=c?l?nm:im:l?Sf:uf,m=d?void 0:f(t);return Ch(m||t,(function(s,n){m&&(n=s,s=t[n]),Ph(o,n,rg(s,e,i,n,t,r))})),o}ng[Dv]=ng[Pv]=ng[Kv]=ng[Wv]=ng[Ov]=ng[Mv]=ng[Yv]=ng[Xv]=ng[Zv]=ng[Qv]=ng[Jv]=ng[$v]=ng[Uv]=ng[jv]=ng[qv]=ng[Gv]=ng[Vv]=ng[Hv]=ng[tg]=ng[eg]=ng[ig]=ng[sg]=!0,ng[Nv]=ng[Fv]=ng[zv]=!1;var og=rg,ag=1,lg=4;function cg(t){return og(t,ag|lg)}var dg=cg,ug="[object Map]",hg="[object Set]",pg=Object.prototype,fg=pg.hasOwnProperty;function mg(t){if(null==t)return!0;if(cf(t)&&(x(t)||"string"==typeof t||"function"==typeof t.splice||tp(t)||Hp(t)||Hh(t)))return!t.length;var e=Cm(t);if(e==ug||e==hg)return!t.size;if(Qp(t))return!af(t).length;for(var i in t)if(fg.call(t,i))return!1;return!0}var vg=mg,gg="[object Number]";function yg(t){return"number"==typeof t||W(t)&&z(t)==gg}var bg,wg=yg;function Sg(t){if(!t)return bg.mp4;const e=t.split("?")[0];return e.endsWith(".mpd")?bg.mpd:e.endsWith(".m3u8")?bg.m3u8:bg.mp4}(function(t){t["mpd"]="application/dash+xml",t["m3u8"]="application/x-mpegURL",t["mp4"]="video/mp4"})(bg||(bg={}));const Eg=1e4,Tg="smvpError";class xg{constructor(t,e){this.hls=t,this.eventBus=e,this.smvpErrorTimeout=void 0}startFatalTimeoutHandler(t,e){this.smvpErrorTimeout||(this.smvpErrorTimeout=setTimeout((()=>{console.debug("[SmvpErrorHandler] fatal timeout callback"),this.smvpErrorTimeout=void 0,this.smvpFatalEmit(t,e)}),Eg))}smvpFatalEmit(t,e){e.fatal=!0,e.details=Tg,Ng(this.hls,this.eventBus,t,e)}stopFatalTimeoutHandler(){console.debug("[SmvpErrorHandler] stopping fatal timeout"),clearTimeout(this.smvpErrorTimeout),this.smvpErrorTimeout=void 0}playbackLoadingErrorHandler(t){if(!t)return this.stopFatalTimeoutHandler(),this.eventBus.emit(vi.customAction,{hls:Cg(this.hls),event:"smvpErrorRecover",data:{shouldShowLoading:t}},Mg);console.debug("[SmvpErrorHandler] starting fatal timeout on playbackLoadingErrorHandler",{shouldShowLoading:t}),this.startFatalTimeoutHandler("loadingNotification",{type:"otherError",details:Tg,fatal:!1,error:new Error("playbackLoadingErrorHandler")})}}function Cg(t){return{ERROR_TYPES:Object.assign({},dh.ErrorTypes),ERROR_DETAILS:Object.assign(Object.assign({},dh.ErrorDetails),{[Tg]:Tg}),destroy:t.destroy.bind(t),startLoad:t.startLoad.bind(t),stopLoad:t.stopLoad.bind(t),recoverMediaError:t.recoverMediaError.bind(t)}}const _g=3e3,kg=3,Lg=(t,e,i,s,n,r)=>{switch(s){case 0:console.error(`[Hls] fatal ${null===r||void 0===r?void 0:r.details} encountered. Trying to recover with startLoad()`,{event:n,data:r}),t.startLoad();break;case 1:console.error(`[Hls] fatal ${null===r||void 0===r?void 0:r.details} encountered. Trying to recover with recoverMediaError()`,{event:n,data:r}),t.recoverMediaError();break;case 2:console.error(`[Hls] fatal ${null===r||void 0===r?void 0:r.details} encountered. Could not recover. Emitting to client`,{event:n,data:r}),i.smvpFatalEmit(n,r);break}};function Ag(t,e,i){let s=0,n=-1/0;return(r,o)=>{if(o.fatal){const a=Date.now()-n;s=a>_g?0:(s+1)%kg,Lg(t,e,i,s,r,o),n=Date.now()}else console.warn(`[Hls] ${null===o||void 0===o?void 0:o.details} encountered. Emitting to client`,{event:r,data:o});Ng(t,e,r,o)}}class Rg{constructor(t,e,i){this.hls=t,this.eventBus=e,this.smvpErrorHandler=i}handleError(t,e){e.fatal?this.handleFatal(t,e):this.handleNonFatal(t,e),Ng(this.hls,this.eventBus,t,e)}handleFatal(t,e){switch(console.debug("[DefaultErrorHandler] starting fatal timeout on handleFatal",{event:t,data:e}),this.smvpErrorHandler.startFatalTimeoutHandler(t,e),e.type){case dh.ErrorTypes.NETWORK_ERROR:return this.handleNetworkError(t,e);case dh.ErrorTypes.MEDIA_ERROR:return this.handleMediaError(t,e);default:return this.handleUnknownError(t,e)}}handleNonFatal(t,e){Ig(t,e)}handleNetworkError(t,e){var i;Ig(t,e),"subtitle"===(null===(i=null===e||void 0===e?void 0:e.frag)||void 0===i?void 0:i.type)&&(console.error("[DefaultErrorHandler] fatal network error on subtitle, disabling subtitles",e.error),this.eventBus.emit(vi.disableSubtitles)),this.hls.startLoad()}handleMediaError(t,e){Ig(t,e),this.hls.recoverMediaError()}handleUnknownError(t,e){Ig(t,e,!1),this.smvpErrorHandler.smvpFatalEmit(t,e)}}function Ig(t,e,i=!0){const s=e.fatal?" fatal":"",n=i?"Trying to recover":"Cannot recover",r=e.fatal?console.error:console.warn;r(`[Hls]${s} ${null===e||void 0===e?void 0:e.details} encountered. ${n}`,{event:t,data:e})}function Dg(t,e,i){const s=new Rg(t,e,i);return s.handleError.bind(s)}function Pg(t,e){return(i,s)=>{s.fatal&&e.emit(vi.reset,{timeout:5e3}),console.warn(`[Hls] ${null===s||void 0===s?void 0:s.details} encountered. Emitting to client`,{event:i,data:s}),Ng(t,e,i,s)}}const Og=dh.ErrorDetails,Mg="hls";function Ng(t,e,i,s){const n={event:i,data:s,hls:Cg(t)};e.emit(vi.error,n,Mg)}function Fg(t,e,i){const s={};return s[Og.BUFFER_STALLED_ERROR]=Ag(t,e,i),s[Og.MANIFEST_LOAD_ERROR]=Pg(t,e),s[Og.MANIFEST_PARSING_ERROR]=Pg(t,e),s[Og.MANIFEST_LOAD_TIMEOUT]=Pg(t,e),s[Og.MANIFEST_INCOMPATIBLE_CODECS_ERROR]=Pg(t,e),s.default=Dg(t,e,i),s}const Bg={liveSyncDurationCount:2,liveMaxLatencyDurationCount:4,initialLiveManifestSize:1,maxLiveSyncPlaybackRate:1,liveDurationInfinity:!1,backBufferLength:0,maxBufferLength:30,maxBufferSize:0,maxBufferHole:.5,highBufferWatchdogPeriod:3,nudgeOffset:.1,nudgeMaxRetry:3,maxFragLookUpTolerance:.25,maxMaxBufferLength:600,startFragPrefetch:!1,stretchShortVideoTrack:!1,startLevel:void 0,testBandwidth:!0,capLevelToPlayerSize:!0,ignoreDevicePixelRatio:!1,capLevelOnFPSDrop:!1,fpsDroppedMonitoringPeriod:5e3,fpsDroppedMonitoringThreshold:.2,maxLoadingDelay:4,maxStarvationDelay:4,lowLatencyMode:!0,abrMaxWithRealBitrate:!1,abrEwmaDefaultEstimate:5e5,minAutoBitrate:0,abrBandWidthFactor:.95,abrBandWidthUpFactor:.7,abrEwmaFastLive:3,abrEwmaFastVoD:3,abrEwmaSlowLive:9,abrEwmaSlowVoD:9,manifestLoadPolicy:{default:{maxTimeToFirstByteMs:1/0,maxLoadTimeMs:2e4,timeoutRetry:{maxNumRetry:2,retryDelayMs:0,maxRetryDelayMs:0},errorRetry:{maxNumRetry:1,retryDelayMs:1e3,maxRetryDelayMs:8e3}}},playlistLoadPolicy:{default:{maxTimeToFirstByteMs:1e4,maxLoadTimeMs:2e4,timeoutRetry:{maxNumRetry:2,retryDelayMs:0,maxRetryDelayMs:0},errorRetry:{maxNumRetry:2,retryDelayMs:1e3,maxRetryDelayMs:8e3}}},fragLoadPolicy:{default:{maxTimeToFirstByteMs:1e4,maxLoadTimeMs:12e4,timeoutRetry:{maxNumRetry:4,retryDelayMs:0,maxRetryDelayMs:0},errorRetry:{maxNumRetry:6,retryDelayMs:1e3,maxRetryDelayMs:8e3}}},keyLoadPolicy:{default:{maxTimeToFirstByteMs:8e3,maxLoadTimeMs:2e4,timeoutRetry:{maxNumRetry:1,retryDelayMs:1e3,maxRetryDelayMs:2e4,backoff:"linear"},errorRetry:{maxNumRetry:8,retryDelayMs:1e3,maxRetryDelayMs:2e4,backoff:"linear"}}},certLoadPolicy:{default:{maxTimeToFirstByteMs:8e3,maxLoadTimeMs:2e4,timeoutRetry:null,errorRetry:null}},steeringManifestLoadPolicy:{default:{maxTimeToFirstByteMs:1e4,maxLoadTimeMs:2e4,timeoutRetry:{maxNumRetry:2,retryDelayMs:0,maxRetryDelayMs:0},errorRetry:{maxNumRetry:1,retryDelayMs:1e3,maxRetryDelayMs:8e3}}}};var $g=Bg;function Ug(t){return{url:ai(t,"url.0"),bandwidth:t.attrs.BANDWIDTH,codecs:t.attrs.CODECS,resolution:t.attrs.RESOLUTION,height:t.height,width:t.width}}function jg(t,e,i=-1){return wg(t)||(t=-1),wg(e)||(e=-1),wg(i)||(i=-1),-1===t?-1===e?i:e:-1!==e?Math.min(t,e):-1===i?t:Math.min(t,i)}function qg(t,e){const i=dh.DefaultConfig.capLevelController;class s extends i{getMaxLevel(i){const s=super.getMaxLevel(i);return jg(t(),e(),s)}}return s}function Gg(t){var e,i,s;const n=null!==(e=null===t||void 0===t?void 0:t.currentLevel)&&void 0!==e?e:0,r=null===(i=null===t||void 0===t?void 0:t.levels)||void 0===i?void 0:i[n];return null===(s=null===r||void 0===r?void 0:r.details)||void 0===s?void 0:s.live}function Vg(){try{if(!/iPad|iPhone|iPod/.test(navigator.userAgent))return!1;const t=navigator.userAgent.match(/OS (\d+)_/);return!!t&&parseInt(t[1],10)>=18}catch(t){return!1}}function Hg(){return window.HiveHtml5}function zg(){return window.HiveModule}function Kg(t){return Boolean((null===t||void 0===t?void 0:t.jwt)&&(null===t||void 0===t?void 0:t.videoId)&&(null===t||void 0===t?void 0:t.manifest))}function Wg({hiveConfig:t,useCredentials:e,hls:i,src:s,video:n,loadSource:r,retriesLeft:o=3}){return di(this,void 0,void 0,(function*(){console.log("[Hive] setupHive",t);const a=zg(),l=Hg();if(!a||!l)return console.error("[Hive] HiveJS is not loaded"),r(s);let c;const d=a=>{0===a.severity?console.error("[Hive] low severity error occurred",a):1===a.severity?(console.error("[Hive] high severity error occurred, retrying...",a),o>0?(o--,Wg({hiveConfig:t,useCredentials:e,hls:i,video:n,loadSource:r,retriesLeft:o,src:s})):(console.error("[Hive] no retries left, disable HivePlugin and fall back to CDN",a),null===c||void 0===c||c.destroyHivePlugin(),r(s))):2===a.severity&&(console.error("[Hive] critical error occurred, disable HivePlugin and fall back to CDN",a),null===c||void 0===c||c.destroyHivePlugin(),r(s))};if(c=Yg({video:n,useCredentials:e,onError:d}),!c)return r(t.manifest);const{manifest:u}=yield c.initSession(t);return a.enable(c,i,dh),r(u)}))}function Yg({video:t,useCredentials:e,onError:i}){const s=Hg();let n;e&&(n={headers:["Cookie"]});const r={playerName:"hlsjs",playerVersion:dh.version,debugLevel:"notice",hiveTechOrder:["HiveJava","HiveJS","StatsJS"],isLowLatency:!1,onError:i,HiveJS:{requestCache:n,renderStatsCallback:t=>{(null===t||void 0===t?void 0:t.savings)&&console.debug("[Hive] renderStatsCallback",t)}}};return new s(t,r)}const Xg=t=>!!t&&Sg(t)!==bg.mp4,Zg=t=>{var e,i,s,n;return!!(null===(e=t.media)||void 0===e?void 0:e.currentTime)&&(null===(i=t.media)||void 0===i?void 0:i.currentTime)>0&&!(null===(s=t.media)||void 0===s?void 0:s.paused)&&!(null===(n=t.media)||void 0===n?void 0:n.ended)},Qg={"1920x1080":4,"1280x720":3,"960x540":2,"768x432":1,"640x360":0,auto:-1};class Jg{constructor({eventBus:t,playerStateRepository:e,useCredentials:i,contentId:s,cmcdSessionId:n,hlsConfigOverwrites:r,hiveConfig:o}){this.isPlayingInterval=0,this.unsubscribers=[],this.maxLevelFromConfig=-1,this.maxLevelFromUser=-1,this.startPosition=-1,this.eventBus=t,this.playerStateRepository=e,this.hiveConfig=o,this.useCredentials=i;const a=Vg();if(dh.isSupported()||a){console.log("[HlsProvider] hls supported, initializing...");let e=dg($g);i&&(console.log("[HlsProvider] use credentials"),e.xhrSetup=t=>{t.withCredentials=i}),this.updateOverrides(r),e.capLevelController=qg((()=>this.maxLevelFromConfig),(()=>this.maxLevelFromUser)),vg(r)||(console.log("[HlsProvider] overwriting hls config with",r),e=Object.assign(Object.assign({},e),r),delete e.maxLevel,delete e.maxResolution),s&&n&&(null===r||void 0===r?void 0:r.cmcd)&&(e.cmcd=Object.assign({contentId:s,sessionId:n,useHeaders:!1},r.cmcd),console.log("[HlsProvider] enable cmcd",e.cmcd)),this.hls=new dh(e),this.hls.subtitleDisplay=!1,this.smvpErrorHandler=new xg(this.hls,this.eventBus),this.errorHandlers=Fg(this.hls,t,this.smvpErrorHandler),this.setupHlsListeners(this.hls)}else console.log("[HlsProvider] hls unsupported");const{unsubscriber:l,state:c}=this.playerStateRepository.onStateChange(this.onStateChange.bind(this));this.onStateChange(c),this.unsubscribers.push(l,this.eventBus.on(vi.selectLevel,(t=>{var e;return this.onChangeLevel(null===(e=t)||void 0===e?void 0:e.id)}))),console.log("[HlsProvider] ready")}loadSource(t,e){return di(this,void 0,void 0,(function*(){if(!this.hls||!Xg(e))throw"Hls or source is not supported";return Kg(this.hiveConfig)?Wg({hiveConfig:this.hiveConfig,src:e,useCredentials:this.useCredentials,hls:this.hls,video:t,loadSource:this.hlsLoadSource.bind(this)}):this.hlsLoadSource(e)}))}hlsLoadSource(t){return console.log("[HlsProvider] loading hls source",t),new Promise(((e,i)=>{if(!this.hls||!Xg(t))return i("Hls or source is not supported");const s=(t,i)=>{var n;null===(n=this.hls)||void 0===n||n.off(dh.Events.MANIFEST_PARSED,s),e(`[HlsProvider] Manifest loaded, found ${i.levels.length} quality level`),this.updateLevelsInStateRepo()};this.hls.on(dh.Events.MANIFEST_PARSED,s),this.hls.loadSource(t)}))}updateOverrides(t){var e,i;this.maxLevelFromConfig=ai(t,"maxLevel",this.maxLevelFromConfig),this.startPosition=null!==(e=null===t||void 0===t?void 0:t.startPosition)&&void 0!==e?e:this.startPosition;const s=ai(t,"maxResolution");s&&(this.maxLevelFromConfig=null!==(i=Qg[s])&&void 0!==i?i:Qg["auto"],console.log(`[HlsProvider] using config value for maxResolution: ${s}, mapping to level: ${this.maxLevelFromConfig}`)),this.updateLevelsInStateRepo()}updateLevelsInStateRepo(){if(!this.hls)return;let t=this.hls.levels.map((t=>Ug(t)));this.maxLevelFromConfig>=0&&(t=t.slice(0,this.maxLevelFromConfig+1)),console.debug("[HlsProvider] levels available update",t),this.playerStateRepository.setState({levelsAvailable:t})}attachMedia(t){return console.log("[HlsProvider] attaching media..."),new Promise(((e,i)=>{if(!this.hls)return i("Hls is not supported");const s=()=>{var t;null===(t=this.hls)||void 0===t||t.off(dh.Events.MEDIA_ATTACHED,s),e("[HlsProvider] Media attached")};this.hls.on(dh.Events.MEDIA_ATTACHED,s),this.hls.attachMedia(t)}))}dispose(){this.removeIsPlayingInterval(),this.hls instanceof dh&&(this.hls.destroy(),this.hls=void 0);for(const t of this.unsubscribers)ct(t)&&t()}isSrcSupported(t){return!!this.hls&&Xg(t)}setupHlsListeners(t){t.on(dh.Events.MEDIA_ATTACHED,this.onMediaAttached.bind(this,t)),t.on(dh.Events.MEDIA_DETACHED,this.onMediaDetached.bind(this,t)),t.on(dh.Events.DESTROYING,this.onDestroying.bind(this)),t.on(dh.Events.ERROR,this.onHlsError.bind(this)),t.on(dh.Events.LEVEL_LOADED,this.sendEventToClient.bind(this,t)),t.on(dh.Events.LEVEL_UPDATED,this.onLevelUpdated.bind(this)),t.on(dh.Events.FRAG_LOAD_EMERGENCY_ABORTED,this.sendEventToClient.bind(this,t)),t.on(dh.Events.LEVEL_SWITCHING,this.onLevelSwitching.bind(this)),t.on(dh.Events.FRAG_LOADING,this.onFragLoading.bind(this)),t.on(dh.Events.FRAG_BUFFERED,this.onFragBuffered.bind(this))}onPlaybackStuck(t){var e;this.stuck!==t&&(this.playerStateRepository.setState({playback:{isStuck:t}}),null===(e=this.smvpErrorHandler)||void 0===e||e.playbackLoadingErrorHandler(t))}onLevelSwitching(t,e){this.playerStateRepository.setState({currentLevel:Ug(e)})}onLevelUpdated(t,e){var i,s,n;this.hls&&this.eventBus.emit(vi.customAction,{hls:Cg(this.hls),event:t,isLive:!!(null===(i=e.details)||void 0===i?void 0:i.live),averageTargetDuration:null!==(n=null===(s=e.details)||void 0===s?void 0:s.averagetargetduration)&&void 0!==n?n:6},Mg)}onFragLoading(t,e){var i,s;if(!this.startPosition||this.startPosition<=0||!(null===(i=this.hls)||void 0===i?void 0:i.media))return;const n=null===(s=null===e||void 0===e?void 0:e.frag)||void 0===s?void 0:s.end;wg(n)&&n<this.startPosition&&(this.hls.media.currentTime=this.startPosition)}onFragBuffered(){if(!this.hls)return;const t=Gg(this.hls);console.debug("Loaded a fragment",{isLive:t})}setupIsPlayingInterval(t){let e=-1/0;this.removeIsPlayingInterval();const i=()=>{var i,s;if(!this.isPlaying)return this.onPlaybackStuck(!1);const n=null!==(s=null===(i=t.media)||void 0===i?void 0:i.currentTime)&&void 0!==s?s:e,r=Zg(t),o=n<=e&&r,a=this.isPlaying&&!r&&n===-1/0,l=o||a;l&&console.debug("[HlsProvider] isPlayingInterval",{stuck:o,isStuckOnStart:a,head:n,lastHead:e,isPlaying:r}),this.onPlaybackStuck(l),e=n};this.isPlayingInterval=setInterval(i,200)}removeIsPlayingInterval(){clearInterval(this.isPlayingInterval),this.onPlaybackStuck(!1)}onDestroying(t){this.hls=void 0,this.removeIsPlayingInterval(),this.eventBus.emit(vi.customAction,t,Mg)}onMediaAttached(t,e,i){this.setupIsPlayingInterval(t),this.playIfPaused(t),this.sendEventToClient(t,e,i)}onMediaDetached(t,e){this.removeIsPlayingInterval(),this.sendEventToClient(t,e)}sendEventToClient(t,e,i){this.eventBus.emit(vi.customAction,{hls:Cg(t),data:i,event:e},Mg)}playIfPaused(t){var e,i;const s=null===(e=null===t||void 0===t?void 0:t.media)||void 0===e?void 0:e.paused;this.playerStateRepository.state.isPlaying&&s&&(console.debug("[HlsProvider] hls play on media attached"),null===(i=null===t||void 0===t?void 0:t.media)||void 0===i||i.play())}onStateChange(t,e){var i,s;this.onPlayingStateChange(t,e),!1===(null===(i=t.playback)||void 0===i?void 0:i.isStuck)&&!0===(null===(s=null===e||void 0===e?void 0:e.playback)||void 0===s?void 0:s.isStuck)&&this.eventBus.emit(vi.customAction,{event:"bufferingEnded"},Mg)}onPlayingStateChange(t,e){const i=t.isPlaying;if(!this.hls||void 0===i)return;const s=null===e||void 0===e?void 0:e.isPlaying,n=s&&!i,r=!s&&i;if(r)console.debug("[HlsProvider] startLoad on play"),this.hls.startLoad();else if(n){const t=Gg(this.hls);(t||void 0===t)&&(console.debug("[HlsProvider] stopLoad on pause"),this.hls.stopLoad())}}onHlsError(t,e){var i;if(!this.errorHandlers)return console.error(`[HlsProvider] ${t} encountered, cannot recover as there are no handlers`,{event:t,data:e});const s=e.details,n=ai(this.errorHandlers,s);if(ct(n))return n(t,e);null===(i=this.errorHandlers)||void 0===i||i.default(t,e)}onChangeLevel(t){if(console.log("[HlsProvider] select level",t),!this.hls)return;if(!wg(t)||t<-1||t>=this.hls.levels.length)return;this.maxLevelFromUser=t;const e=jg(this.maxLevelFromConfig,this.maxLevelFromUser);this.hls.autoLevelCapping=e,this.hls.loadLevel=e,this.hls.currentLevel=e,this.hls.nextLevel=e}get isPlaying(){var t;return null===(t=this.playerStateRepository.state)||void 0===t?void 0:t.isPlaying}get stuck(){var t,e;return!!(null===(e=null===(t=this.playerStateRepository.state)||void 0===t?void 0:t.playback)||void 0===e?void 0:e.isStuck)}}function ty(t,e,i){return t.on(vi.play,(()=>ey(e,i)))}function ey(t,e){return di(this,void 0,void 0,(function*(){yield e(),yield t.play().catch((t=>{console.error("[ActionHandlers] could not play",t)}))}))}function iy(t,e,i){return console.debug("[ActionHandlers] pauseHandler"),t.on(vi.pause,(()=>{console.debug("[ActionHandlers] event bus on Event.pause"),i(!0),e.pause()}))}function sy(t,e){return t.on(vi.enterFullScreen,(()=>e({isVideoElementFullScreen:!0})))}function ny(t,e){return t.on(vi.exitFullScreen,(()=>e({isVideoElementFullScreen:!1})))}function ry(t,e){return t.on(vi.enterNativeFullScreen,(()=>di(this,void 0,void 0,(function*(){try{yield e.requestFullscreen()}catch(UP){t.emit(vi.error,UP,"native-fullscreen")}}))))}function oy(t){return t.on(vi.exitNativeFullScreen,(()=>document.exitFullscreen()))}function ay(t,e){return t.on(vi.alwaysShowControlBar,(t=>{const i=ai(t,"alwaysShowControlBar");e({alwaysShowControlBar:i})}))}function ly(t,e,i){return t.on(vi.seek,(t=>{cy(e,t,i)}))}function cy(t,e,i){let s=ai(e,"seconds");wg(s)&&(s=Math.min(Math.max(s,0),t.duration||s),i({videoElapsedSecs:s},vi.seek),t.currentTime=s)}function dy(t,e){return t.on(vi.mute,(()=>e(!0)))}function uy(t,e){return t.on(vi.unmute,(()=>e(!1)))}function hy(t,e,i){return t.on(vi.changeVolume,(t=>{let s=ai(t,"volume");wg(s)&&(s=Math.min(Math.max(s,0),1),e.volume=s,i({volume:s}))}))}function py(t,e,i,s){t&&"metadata"===t.kind&&!e&&(t.mode="hidden",t.oncuechange=()=>{const e=t.activeCues||[];for(const t of e){const e=t.value;if(!e.data||"TXXX"!==e.key)return;let r;try{r=JSON.parse(e.data)}catch(n){return void console.warn("[MetadataManagement] failed to parse cue data",e.data)}const o=i.includes(r.tag_id);o&&(console.log("[MetadataManagement] emitting",r),delete r.type,delete r.start,delete r.startBroadcast,delete r.stopBroadcast,delete r.data,s({value:r}))}})}function fy(t,e){const i=by(t),s=i.map(wy).filter((t=>!!t));s.sort(((t,e)=>t.label&&e.label?t.label<e.label?-1:1:0)),e({subtitleTracks:s})}function my(t,e){yy(t),e({subtitlesEnabled:!1})}function vy(t,e,i){return i({subtitles:[]}),t.on(vi.selectSubtitleTrack,(t=>{yy(e.textTracks);const s=ai(t,"track");if(!s)return;const n=by(e.textTracks).find((t=>Sy(t)===s.id));n&&(i({subtitleTrackActive:wy(n)}),i({subtitlesEnabled:!0}),n.mode="hidden",n.oncuechange=t=>{const e=ai(t,"target");if(!e||!e.activeCues||!e.activeCues.length)return;const s=e.activeCues||[],n=Array.from(s).map((t=>ai(t,"text",""))).reverse();i({subtitles:n})})}))}function gy(t,e,i){return i({subtitles:[]}),t.on(vi.disableSubtitles,(()=>my(e.textTracks,i)))}function yy(t){const e=by(t);e.forEach((t=>{t.mode="disabled",t.oncuechange=null}))}function by(t){const e=[];if(t)for(let i=0;i<t.length;++i){const s=t[i];"subtitles"!==s.kind&&"captions"!==s.kind||e.push(s)}return e}function wy(t){return t?{id:Sy(t),language:t.language,label:t.label}:null}function Sy(t){return`${t.language}-${t.label}`}var Ey=i(6862);class Ty{constructor(t,e,i){this.eventBus=t,this.playerStateRepository=e,this.alwaysCollapseControlBarOnIdle=i,this.idleTracker=void 0,this.wasInitialized=!1,this.setupIdleTracker()}revealControlBar(){this.updateState({isControlBarVisible:!0})}hideControlBar(){const t=!this.playerStateRepository.state.isPlaying&&!this.alwaysCollapseControlBarOnIdle;t||this.playerStateRepository.state.alwaysShowControlBar||this.updateState({isControlBarVisible:!1})}setupIdleTracker(){this.idleTracker=new Ey.Z({timeout:3e3,onIdleCallback:this.trackIdle.bind(this)}),this.idleTracker.start()}trackIdle({idle:t}){const e=this.playerStateRepository.state.isIdle;t!==e&&(this.updateState({isIdle:t}),t?this.hideControlBar():this.revealControlBar())}dispose(){this.idleTracker&&this.idleTracker.end()}updateState(t,e){this.playerStateRepository.setState(t,e)}updateOverrides(t){}}function xy(t,e){if(e.length<t)throw new TypeError(t+" argument"+(t>1?"s":"")+" required, but only "+e.length+" present")}function Cy(t){return Cy="function"===typeof Symbol&&"symbol"===typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"===typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},Cy(t)}function _y(t){xy(1,arguments);var e=Object.prototype.toString.call(t);return t instanceof Date||"object"===Cy(t)&&"[object Date]"===e?new Date(t.getTime()):"number"===typeof t||"[object Number]"===e?new Date(t):("string"!==typeof t&&"[object String]"!==e||"undefined"===typeof console||(console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"),console.warn((new Error).stack)),new Date(NaN))}function ky(t){xy(1,arguments);var e=_y(t);return e.setHours(23,59,59,999),e}const Ly=ky,Ay=3600,Ry=24*Ay;function Iy(t){return Math.floor(t/Ry)}const Dy=()=>Math.floor(Date.now()/1e3),Py=()=>{const t=new Date;return t.getHours()+":"+t.getMinutes()+":"+t.getSeconds()+"."+t.getMilliseconds()};function Oy(t){if(t<=0)return"00:00:00";t=Math.round(t);const e=Math.floor(t/Ay),i=Math.floor((t-e*Ay)/60),s=t-e*Ay-60*i;return`${e.toString().padStart(2,"0")}:${i.toString().padStart(2,"0")}:${s.toString().padStart(2,"0")}`}function My(t){if(t<=0)return"00:00";t=Math.round(t);const e=Math.floor(t/Ay),i=Math.floor((t-e*Ay)/60),s=t-e*Ay-60*i;return`${i.toString().padStart(2,"0")}:${s.toString().padStart(2,"0")}`}class Ny extends Ty{constructor({playerElement:t,videoElement:e,sourceUrl:i,eventBus:s,playerStateRepository:n,useCredentials:r,restrictMetadata:o,metadataTypes:a,contentId:l,cmcdSessionId:c,hlsConfigOverwrites:d,hiveConfig:u,alwaysCollapseControlBarOnIdle:h}){super(s,n,h),this.unsubscribers=[],this.lastEmittedTag=null,this.expectingPauseEvent=!1,this.disposing=!1,this.playerElement=t,this.video=e,this.src=i,this.hlsProvider=new Jg({eventBus:s,playerStateRepository:n,useCredentials:r,contentId:l,cmcdSessionId:c,hlsConfigOverwrites:d,hiveConfig:u}),this.playerElement&&this.setupPlayerElement(),this.video&&(this.setupVideo(),this.setupVideoTracks(o,a)),this.setupEventListeners(),console.debug("[VideoPlayerCore] controller created")}updateOverrides(t){var e,i;null===(i=null===(e=this.hlsProvider)||void 0===e?void 0:e.updateOverrides)||void 0===i||i.call(e,t)}init(){return di(this,void 0,void 0,(function*(){this.wasInitialized||(this.wasInitialized=!0,this.hlsProvider.isSrcSupported(this.src)?yield this.setupHls(this.src):this.video&&this.video.load(),this.setMuted(this.playerStateRepository.state.muted),console.debug(`[VideoPlayerCore] controller initialized at ${Py()}`))}))}tryAutoplay(){console.log(`[VideoPlayerCore] trying to autoplay at ${Py()}`),setTimeout((()=>di(this,void 0,void 0,(function*(){try{if(this.disposing)return;yield this.video.play(),this.sendAutoplayedEvent({muted:!1}),console.log(`[VideoPlayerCore] successfully autoplayed with sound at ${Py()}`)}catch(t){console.warn(`[VideoPlayerCore] failed to autoplay, play again muted at ${Py()}`),this.setMuted(!0);try{if(this.disposing)return;yield this.video.play(),console.log(`[VideoPlayerCore] successfully autoplayed muted at ${Py()}`),this.sendAutoplayedEvent({muted:!0})}catch(e){console.error(`[VideoPlayerCore] could not autoplay muted at ${Py()}`,e),this.setMuted(!1)}}}))))}sendAutoplayedEvent({muted:t=!1}={}){this.eventBus.emit(vi.customAction,{muted:t},"autoplayed")}dispose(){super.dispose(),this.disposing=!0,this.hlsProvider.dispose(),this.disposeEventListeners()}setupHls(t){return di(this,void 0,void 0,(function*(){yield this.hlsProvider.attachMedia(this.video).then(console.log).catch(console.error),yield this.hlsProvider.loadSource(this.video,t).then(console.log).catch(console.error)}))}setupPlayerElement(){this.playerElement.onfullscreenchange=()=>{this.updateState({isNativeFullScreen:!!document.fullscreenElement})}}setupVideo(){this.video.onplay=()=>this.setIsPlaying(!0),this.video.onpause=()=>this.setIsPlaying(!1),this.video.onerror=t=>this.onVideoElementError(t),this.video.onloadedmetadata=()=>{this.updateState({videoLoaded:!0})},this.video.ontimeupdate=()=>{const t=this.video.currentTime,e=this.playerStateRepository.state.hasPlayed||t>0;this.updateState({videoElapsedSecs:t,hasPlayed:e})},this.video.ondurationchange=()=>{const t=this.video.duration;this.updateState({videoDurationSecs:t})},this.video.onresize=()=>{const t=this.video.videoHeight;this.updateState({videoHeight:t})},this.video.oncontextmenu=t=>t.preventDefault()}setupVideoTracks(t,e){this.video.textTracks.onaddtrack=i=>{py(null===i||void 0===i?void 0:i.track,t,e,this.emitMetadata.bind(this)),fy(this.video.textTracks,this.updateState.bind(this)),my(this.video.textTracks,this.updateState.bind(this))},this.unsubscribers.push(this.eventBus.on(vi.seek,(()=>{this.lastEmittedTag=null})))}setupEventListeners(){this.unsubscribers.push(ty(this.eventBus,this.video,this.init.bind(this)),iy(this.eventBus,this.video,(t=>this.expectingPauseEvent=t)),sy(this.eventBus,this.updateState.bind(this)),ny(this.eventBus,this.updateState.bind(this)),ay(this.eventBus,this.updateState.bind(this)),ry(this.eventBus,this.playerElement),oy(this.eventBus),ly(this.eventBus,this.video,this.updateState.bind(this)),dy(this.eventBus,this.setMuted.bind(this)),uy(this.eventBus,this.setMuted.bind(this)),hy(this.eventBus,this.video,this.updateState.bind(this)),vy(this.eventBus,this.video,this.updateState.bind(this)),gy(this.eventBus,this.video,this.updateState.bind(this)))}disposeEventListeners(){for(const t of this.unsubscribers)ct(t)&&t();this.unsubscribers=[]}setMuted(t){this.updateState({muted:t}),this.video.muted!==t?(console.debug(`[VideoPlayerCore] set ${t?"muted":"unmuted"} at ${Py()}`),this.video.muted=t):console.debug(`[VideoPlayerCore] skip ${t?"muting":"unmuting"} because it's already the case at ${Py()}`)}onVideoElementError(t){console.error(`[VideoPlayerCore] video element error at ${Py()}s`,t)}setIsPlaying(t){var e;const i=dg(null===(e=this.playerStateRepository)||void 0===e?void 0:e.state);null===i||void 0===i||delete i.levelsAvailable,null===i||void 0===i||delete i.subtitleTracks,null===i||void 0===i||delete i.subtitleTrackActive,null===i||void 0===i||delete i.subtitles,null===i||void 0===i||delete i.currentLevel,null===i||void 0===i||delete i.isControlBarVisible,console.debug(`[VideoPlayerCore] video ${t?"playing":"paused"} at ${Py()}`,JSON.stringify(i));const s=this.video.currentTime;this.updateState({isPlaying:t,videoElapsedSecs:s});const n=this.playerStateRepository.state,r=n.videoElapsedSecs>=n.videoDurationSecs;t||this.expectingPauseEvent||r||(n.muted?console.warn("[VideoPlayerCore] video was paused without user request, and player is muted"):(console.warn(`[VideoPlayerCore] video was paused without user request, trying to resume at ${Py()}`),this.tryAutoplay())),this.expectingPauseEvent=!1}emitMetadata(t){var e;const i=t.value||{},s=i.timestamp||0,n=(null===(e=this.lastEmittedTag)||void 0===e?void 0:e.timestamp)||0,r=n&&s&&s<n;r||(this.lastEmittedTag=i,this.eventBus.emit(vi.metadata,t))}}class Fy extends Ty{constructor({sourceUrl:t,eventBus:e,playerStateRepository:i,alwaysCollapseControlBarOnIdle:s}){super(e,i,s),this.src=t}init(){return di(this,void 0,void 0,(function*(){this.wasInitialized=!0,this.src&&(this.start=Date.now(),this.timer=setInterval((()=>{this.start&&this.playerStateRepository.setState({videoElapsedSecs:Math.floor((Date.now()-this.start)/1e3)})}),1e3),this.playerStateRepository.setState({isPlaying:!0}))}))}tryAutoplay(){}dispose(){super.dispose(),clearInterval(this.timer)}}var By=Object.defineProperty,$y=Object.defineProperties,Uy=Object.getOwnPropertyDescriptors,jy=Object.getOwnPropertySymbols,qy=Object.prototype.hasOwnProperty,Gy=Object.prototype.propertyIsEnumerable,Vy=(t,e,i)=>e in t?By(t,e,{enumerable:!0,configurable:!0,writable:!0,value:i}):t[e]=i,Hy=(t,e)=>{for(var i in e||(e={}))qy.call(e,i)&&Vy(t,i,e[i]);if(jy)for(var i of jy(e))Gy.call(e,i)&&Vy(t,i,e[i]);return t},zy=(t,e)=>$y(t,Uy(e)),Ky=(t,e)=>{var i={};for(var s in t)qy.call(t,s)&&e.indexOf(s)<0&&(i[s]=t[s]);if(null!=t&&jy)for(var s of jy(t))e.indexOf(s)<0&&Gy.call(t,s)&&(i[s]=t[s]);return i};function Wy(t,e,i,s,n,r,o,a){var l,c="function"===typeof t?t.options:t;if(e&&(c.render=e,c.staticRenderFns=i,c._compiled=!0),s&&(c.functional=!0),r&&(c._scopeId="data-v-"+r),o?(l=function(t){t=t||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext,t||"undefined"===typeof __VUE_SSR_CONTEXT__||(t=__VUE_SSR_CONTEXT__),n&&n.call(this,t),t&&t._registeredComponents&&t._registeredComponents.add(o)},c._ssrRegister=l):n&&(l=a?function(){n.call(this,(c.functional?this.parent:this).$root.$options.shadowRoot)}:n),l)if(c.functional){c._injectStyles=l;var d=c.render;c.render=function(t,e){return l.call(e),d(t,e)}}else{var u=c.beforeCreate;c.beforeCreate=u?[].concat(u,l):[l]}return{exports:t,options:c}}const Yy={name:"splitpanes",props:{horizontal:{type:Boolean},pushOtherPanes:{type:Boolean,default:!0},dblClickSplitter:{type:Boolean,default:!0},rtl:{type:Boolean,default:!1},firstSplitter:{type:Boolean}},provide(){return{requestUpdate:this.requestUpdate,onPaneAdd:this.onPaneAdd,onPaneRemove:this.onPaneRemove,onPaneClick:this.onPaneClick}},data:()=>({container:null,ready:!1,panes:[],touch:{mouseDown:!1,dragging:!1,activeSplitter:null},splitterTaps:{splitter:null,timeoutId:null}}),computed:{panesCount(){return this.panes.length},indexedPanes(){return this.panes.reduce(((t,e)=>(t[e.id]=e)&&t),{})}},methods:{updatePaneComponents(){this.panes.forEach((t=>{t.update&&t.update({[this.horizontal?"height":"width"]:`${this.indexedPanes[t.id].size}%`})}))},bindEvents(){document.addEventListener("mousemove",this.onMouseMove,{passive:!1}),document.addEventListener("mouseup",this.onMouseUp),"ontouchstart"in window&&(document.addEventListener("touchmove",this.onMouseMove,{passive:!1}),document.addEventListener("touchend",this.onMouseUp))},unbindEvents(){document.removeEventListener("mousemove",this.onMouseMove,{passive:!1}),document.removeEventListener("mouseup",this.onMouseUp),"ontouchstart"in window&&(document.removeEventListener("touchmove",this.onMouseMove,{passive:!1}),document.removeEventListener("touchend",this.onMouseUp))},onMouseDown(t,e){this.bindEvents(),this.touch.mouseDown=!0,this.touch.activeSplitter=e},onMouseMove(t){this.touch.mouseDown&&(t.preventDefault(),this.touch.dragging=!0,this.calculatePanesSize(this.getCurrentMouseDrag(t)),this.$emit("resize",this.panes.map((t=>({min:t.min,max:t.max,size:t.size})))))},onMouseUp(){this.touch.dragging&&this.$emit("resized",this.panes.map((t=>({min:t.min,max:t.max,size:t.size})))),this.touch.mouseDown=!1,setTimeout((()=>{this.touch.dragging=!1,this.unbindEvents()}),100)},onSplitterClick(t,e){"ontouchstart"in window&&(t.preventDefault(),this.dblClickSplitter&&(this.splitterTaps.splitter===e?(clearTimeout(this.splitterTaps.timeoutId),this.splitterTaps.timeoutId=null,this.onSplitterDblClick(t,e),this.splitterTaps.splitter=null):(this.splitterTaps.splitter=e,this.splitterTaps.timeoutId=setTimeout((()=>{this.splitterTaps.splitter=null}),500)))),this.touch.dragging||this.$emit("splitter-click",this.panes[e])},onSplitterDblClick(t,e){let i=0;this.panes=this.panes.map(((t,s)=>(t.size=s===e?t.max:t.min,s!==e&&(i+=t.min),t))),this.panes[e].size-=i,this.$emit("pane-maximize",this.panes[e])},onPaneClick(t,e){this.$emit("pane-click",this.indexedPanes[e])},getCurrentMouseDrag(t){const e=this.container.getBoundingClientRect(),{clientX:i,clientY:s}="ontouchstart"in window&&t.touches?t.touches[0]:t;return{x:i-e.left,y:s-e.top}},getCurrentDragPercentage(t){t=t[this.horizontal?"y":"x"];const e=this.container[this.horizontal?"clientHeight":"clientWidth"];return this.rtl&&!this.horizontal&&(t=e-t),100*t/e},calculatePanesSize(t){const e=this.touch.activeSplitter;let i={prevPanesSize:this.sumPrevPanesSize(e),nextPanesSize:this.sumNextPanesSize(e),prevReachedMinPanes:0,nextReachedMinPanes:0};const s=0+(this.pushOtherPanes?0:i.prevPanesSize),n=100-(this.pushOtherPanes?0:i.nextPanesSize),r=Math.max(Math.min(this.getCurrentDragPercentage(t),n),s);let o=[e,e+1],a=this.panes[o[0]]||null,l=this.panes[o[1]]||null;const c=a.max<100&&r>=a.max+i.prevPanesSize,d=l.max<100&&r<=100-(l.max+this.sumNextPanesSize(e+1));if(c||d)c?(a.size=a.max,l.size=Math.max(100-a.max-i.prevPanesSize-i.nextPanesSize,0)):(a.size=Math.max(100-l.max-i.prevPanesSize-this.sumNextPanesSize(e+1),0),l.size=l.max);else{if(this.pushOtherPanes){const t=this.doPushOtherPanes(i,r);if(!t)return;({sums:i,panesToResize:o}=t),a=this.panes[o[0]]||null,l=this.panes[o[1]]||null}null!==a&&(a.size=Math.min(Math.max(r-i.prevPanesSize-i.prevReachedMinPanes,a.min),a.max)),null!==l&&(l.size=Math.min(Math.max(100-r-i.nextPanesSize-i.nextReachedMinPanes,l.min),l.max))}},doPushOtherPanes(t,e){const i=this.touch.activeSplitter,s=[i,i+1];return e<t.prevPanesSize+this.panes[s[0]].min&&(s[0]=this.findPrevExpandedPane(i).index,t.prevReachedMinPanes=0,s[0]<i&&this.panes.forEach(((e,n)=>{n>s[0]&&n<=i&&(e.size=e.min,t.prevReachedMinPanes+=e.min)})),t.prevPanesSize=this.sumPrevPanesSize(s[0]),void 0===s[0])?(t.prevReachedMinPanes=0,this.panes[0].size=this.panes[0].min,this.panes.forEach(((e,s)=>{s>0&&s<=i&&(e.size=e.min,t.prevReachedMinPanes+=e.min)})),this.panes[s[1]].size=100-t.prevReachedMinPanes-this.panes[0].min-t.prevPanesSize-t.nextPanesSize,null):e>100-t.nextPanesSize-this.panes[s[1]].min&&(s[1]=this.findNextExpandedPane(i).index,t.nextReachedMinPanes=0,s[1]>i+1&&this.panes.forEach(((e,n)=>{n>i&&n<s[1]&&(e.size=e.min,t.nextReachedMinPanes+=e.min)})),t.nextPanesSize=this.sumNextPanesSize(s[1]-1),void 0===s[1])?(t.nextReachedMinPanes=0,this.panes[this.panesCount-1].size=this.panes[this.panesCount-1].min,this.panes.forEach(((e,s)=>{s<this.panesCount-1&&s>=i+1&&(e.size=e.min,t.nextReachedMinPanes+=e.min)})),this.panes[s[0]].size=100-t.prevPanesSize-t.nextReachedMinPanes-this.panes[this.panesCount-1].min-t.nextPanesSize,null):{sums:t,panesToResize:s}},sumPrevPanesSize(t){return this.panes.reduce(((e,i,s)=>e+(s<t?i.size:0)),0)},sumNextPanesSize(t){return this.panes.reduce(((e,i,s)=>e+(s>t+1?i.size:0)),0)},findPrevExpandedPane(t){const e=[...this.panes].reverse().find((e=>e.index<t&&e.size>e.min));return e||{}},findNextExpandedPane(t){const e=this.panes.find((e=>e.index>t+1&&e.size>e.min));return e||{}},checkSplitpanesNodes(){const t=Array.from(this.container.children);t.forEach((t=>{const e=t.classList.contains("splitpanes__pane"),i=t.classList.contains("splitpanes__splitter");if(!e&&!i)return t.parentNode.removeChild(t),void console.warn("Splitpanes: Only <pane> elements are allowed at the root of <splitpanes>. One of your DOM nodes was removed.")}))},addSplitter(t,e,i=!1){const s=t-1,n=document.createElement("div");n.classList.add("splitpanes__splitter"),i||(n.onmousedown=t=>this.onMouseDown(t,s),"undefined"!==typeof window&&"ontouchstart"in window&&(n.ontouchstart=t=>this.onMouseDown(t,s)),n.onclick=t=>this.onSplitterClick(t,s+1)),this.dblClickSplitter&&(n.ondblclick=t=>this.onSplitterDblClick(t,s+1)),e.parentNode.insertBefore(n,e)},removeSplitter(t){t.onmousedown=void 0,t.onclick=void 0,t.ondblclick=void 0,t.parentNode.removeChild(t)},redoSplitters(){const t=Array.from(this.container.children);t.forEach((t=>{t.className.includes("splitpanes__splitter")&&this.removeSplitter(t)}));let e=0;t.forEach((t=>{t.className.includes("splitpanes__pane")&&(!e&&this.firstSplitter?this.addSplitter(e,t,!0):e&&this.addSplitter(e,t),e++)}))},requestUpdate(t){var e=t,{target:i}=e,s=Ky(e,["target"]);const n=this.indexedPanes[i._uid];Object.entries(s).forEach((([t,e])=>n[t]=e))},onPaneAdd(t){let e=-1;Array.from(t.$el.parentNode.children).some((i=>(i.className.includes("splitpanes__pane")&&e++,i===t.$el)));const i=parseFloat(t.minSize),s=parseFloat(t.maxSize);this.panes.splice(e,0,{id:t._uid,index:e,min:isNaN(i)?0:i,max:isNaN(s)?100:s,size:null===t.size?null:parseFloat(t.size),givenSize:t.size,update:t.update}),this.panes.forEach(((t,e)=>t.index=e)),this.ready&&this.$nextTick((()=>{this.redoSplitters(),this.resetPaneSizes({addedPane:this.panes[e]}),this.$emit("pane-add",{index:e,panes:this.panes.map((t=>({min:t.min,max:t.max,size:t.size})))})}))},onPaneRemove(t){const e=this.panes.findIndex((e=>e.id===t._uid)),i=this.panes.splice(e,1)[0];this.panes.forEach(((t,e)=>t.index=e)),this.$nextTick((()=>{this.redoSplitters(),this.resetPaneSizes({removedPane:zy(Hy({},i),{index:e})}),this.$emit("pane-remove",{removed:i,panes:this.panes.map((t=>({min:t.min,max:t.max,size:t.size})))})}))},resetPaneSizes(t={}){t.addedPane||t.removedPane?this.panes.some((t=>null!==t.givenSize||t.min||t.max<100))?this.equalizeAfterAddOrRemove(t):this.equalize():this.initialPanesSizing(),this.ready&&this.$emit("resized",this.panes.map((t=>({min:t.min,max:t.max,size:t.size}))))},equalize(){const t=100/this.panesCount;let e=0,i=[],s=[];this.panes.forEach((n=>{n.size=Math.max(Math.min(t,n.max),n.min),e-=n.size,n.size>=n.max&&i.push(n.id),n.size<=n.min&&s.push(n.id)})),e>.1&&this.readjustSizes(e,i,s)},initialPanesSizing(){this.panesCount;let t=100,e=[],i=[],s=0;this.panes.forEach((n=>{t-=n.size,null!==n.size&&s++,n.size>=n.max&&e.push(n.id),n.size<=n.min&&i.push(n.id)}));let n=100;t>.1&&(this.panes.forEach((e=>{null===e.size&&(e.size=Math.max(Math.min(t/(this.panesCount-s),e.max),e.min)),n-=e.size})),n>.1&&this.readjustSizes(t,e,i))},equalizeAfterAddOrRemove({addedPane:t,removedPane:e}={}){let i=100/this.panesCount,s=0,n=[],r=[];t&&null!==t.givenSize&&(i=(100-t.givenSize)/(this.panesCount-1)),this.panes.forEach((t=>{s-=t.size,t.size>=t.max&&n.push(t.id),t.size<=t.min&&r.push(t.id)})),Math.abs(s)<.1||(this.panes.forEach((e=>{t&&null!==t.givenSize&&t.id===e.id||(e.size=Math.max(Math.min(i,e.max),e.min)),s-=e.size,e.size>=e.max&&n.push(e.id),e.size<=e.min&&r.push(e.id)})),s>.1&&this.readjustSizes(s,n,r))},readjustSizes(t,e,i){let s;s=t>0?t/(this.panesCount-e.length):t/(this.panesCount-i.length),this.panes.forEach(((n,r)=>{if(t>0&&!e.includes(n.id)){const e=Math.max(Math.min(n.size+s,n.max),n.min),i=e-n.size;t-=i,n.size=e}else if(!i.includes(n.id)){const e=Math.max(Math.min(n.size+s,n.max),n.min),i=e-n.size;t-=i,n.size=e}n.update({[this.horizontal?"height":"width"]:`${this.indexedPanes[n.id].size}%`})})),Math.abs(t)>.1&&this.$nextTick((()=>{this.ready&&console.warn("Splitpanes: Could not resize panes correctly due to their constraints.")}))}},watch:{panes:{deep:!0,immediate:!1,handler(){this.updatePaneComponents()}},horizontal(){this.updatePaneComponents()},firstSplitter(){this.redoSplitters()},dblClickSplitter(t){const e=[...this.container.querySelectorAll(".splitpanes__splitter")];e.forEach(((e,i)=>{e.ondblclick=t?t=>this.onSplitterDblClick(t,i):void 0}))}},beforeDestroy(){this.ready=!1},mounted(){this.container=this.$refs.container,this.checkSplitpanesNodes(),this.redoSplitters(),this.resetPaneSizes(),this.$emit("ready"),this.ready=!0},render(t){return t("div",{ref:"container",class:["splitpanes","splitpanes--"+(this.horizontal?"horizontal":"vertical"),{"splitpanes--dragging":this.touch.dragging}]},this.$slots.default)}};let Xy,Zy;const Qy={};var Jy=Wy(Yy,Xy,Zy,!1,tb,null,null,null);function tb(t){for(let e in Qy)this[e]=Qy[e]}var eb=function(){return Jy.exports}(),ib=function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{staticClass:"splitpanes__pane",style:t.style,on:{click:function(e){return t.onPaneClick(e,t._uid)}}},[t._t("default")],2)},sb=[];const nb={name:"pane",inject:["requestUpdate","onPaneAdd","onPaneRemove","onPaneClick"],props:{size:{type:[Number,String],default:null},minSize:{type:[Number,String],default:0},maxSize:{type:[Number,String],default:100}},data:()=>({style:{}}),mounted(){this.onPaneAdd(this)},beforeDestroy(){this.onPaneRemove(this)},methods:{update(t){this.style=t}},computed:{sizeNumber(){return this.size||0===this.size?parseFloat(this.size):null},minSizeNumber(){return parseFloat(this.minSize)},maxSizeNumber(){return parseFloat(this.maxSize)}},watch:{sizeNumber(t){this.requestUpdate({target:this,size:t})},minSizeNumber(t){this.requestUpdate({target:this,min:t})},maxSizeNumber(t){this.requestUpdate({target:this,max:t})}}},rb={};var ob=Wy(nb,ib,sb,!1,ab,null,null,null);function ab(t){for(let e in rb)this[e]=rb[e]}var lb=function(){return ob.exports}(),cb=n["default"].extend({name:"VideoPlayerCore",components:{ControlBar:yi,Notifications:Bi,PortalTarget:$i.YC,Splitpanes:eb,Pane:lb},props:{api:{type:Object,required:!0},eventBus:{type:Object,required:!0},playerStateRepository:{type:Object,required:!0},hasControlBar:{type:Boolean,default:!0},hideControlBar:{type:Boolean,default:!0},alwaysCollapseControlBarOnIdle:{type:Boolean,default:!1},hideMouseOnIdle:{type:Boolean,default:!0},sourceUrl:{type:String,required:!0},useCredentials:{type:Boolean,default:!0},autoplay:{type:Boolean,default:!0},preload:{type:Boolean,default:!1},restrictMetadata:{type:Boolean,default:!1},metadataTypes:{type:Array,default:()=>["spotme_metadata"]},isIframeContent:{type:Boolean,default:!1},thumbnail:{type:String,default:void 0},disableNativePip:{type:Boolean,default:!0},isSideBarBelow:{type:Boolean,default:!1},loopVideo:{type:Boolean,default:!1},contentId:{type:String,default:void 0},cmcdSessionId:{type:String,default:void 0},hlsConfigOverwrites:{type:Object,default:void 0},hiveConfig:{type:Object,default:()=>({})},hasSplitPanes:{type:Boolean,required:!0},defaultSplitPaneSize:{type:Number,default:50}},data(){return{controller:null,iframeKey:0,videoElementKey:0,videoElapsedSecs:0,videoDurationSecs:0,resetTimeout:0,isClientFullScreen:!1,isVideoElementFullScreen:!1,unsubscribers:[],playRequested:!1}},computed:{state(){return this.playerStateRepository.state},srcType(){return Sg(this.sourceUrl)},crossorigin(){return this.useCredentials?"use-credentials":void 0},sideBarNotificationPortalId(){return""+this.api.getPortalId("SIDEBAR_NOTIFICATION")},controlBarAtBottom(){const t=this.isSideBarBelow&&this.isVideoElementFullScreen;return!this.state.videoHeight||!t},isPlaying(){return this.playerStateRepository.state.isPlaying},startPosition(){var t,e;return null!==(e=null===(t=this.hlsConfigOverwrites)||void 0===t?void 0:t.startPosition)&&void 0!==e?e:-1},shouldAutoPlay(){return this.autoplay||this.isPlaying||this.playRequested},splitPaneSize(){return this.hasSplitPanes?this.defaultSplitPaneSize:0},isControlBarVisible(){return this.state.isControlBarVisible},hideMouseCursor(){return!this.isControlBarVisible&&this.hideMouseOnIdle}},watch:{sourceUrl(t,e){t!==e&&(this.playRequested=!1,this.iframeKey++,this.videoElementKey++,n["default"].nextTick((()=>{const i=(null!==t&&void 0!==t?t:"").split("?")[0],s=(null!==e&&void 0!==e?e:"").split("?")[0],n=!!t&&i===s;console.debug("[VideoPlayerCore] new url, resetting controller",{newVal:t,oldVal:e,shouldSeek:n}),this.resetController(n)})))},useCredentials(){this.resetController()},isIframeContent(){this.resetController()},startPosition(t,e){t!==e&&this.resetController()},hlsConfigOverwrites(t){var e,i;null===(i=null===(e=this.controller)||void 0===e?void 0:e.updateOverrides)||void 0===i||i.call(e,t)}},mounted(){const{unsubscriber:t,state:e}=this.api.onStateChange((t=>this.onStateChange(t)));this.onStateChange(e),this.unsubscribers.push(t,this.api.onClientAction(this.onClientAction.bind(this)),this.eventBus.on(vi.dispose,(()=>this.disposeController())),this.eventBus.on(vi.reset,this.onReset.bind(this)),this.eventBus.on(vi.play,(()=>{this.playRequested=!0})),this.eventBus.on(vi.pause,(()=>{this.playRequested=!1}))),this.createController()},beforeDestroy(){clearTimeout(this.resetTimeout),this.disposeController();for(const t of this.unsubscribers)ct(t)&&t()},deactivated(){this.disposeController()},methods:{createController(){return di(this,void 0,void 0,(function*(){if(this.isIframeContent)this.controller=new Fy({sourceUrl:this.sourceUrl,eventBus:this.eventBus,playerStateRepository:this.playerStateRepository,alwaysCollapseControlBarOnIdle:this.alwaysCollapseControlBarOnIdle}),yield this.controller.init();else{const t=this.$refs["media-video"];if(this.controller=new Ny({playerElement:this.$refs["video-player"],videoElement:t,sourceUrl:this.sourceUrl,eventBus:this.eventBus,playerStateRepository:this.playerStateRepository,useCredentials:this.useCredentials,restrictMetadata:this.restrictMetadata,metadataTypes:this.metadataTypes,contentId:this.contentId,cmcdSessionId:this.cmcdSessionId,hlsConfigOverwrites:this.hlsConfigOverwrites,hiveConfig:this.hiveConfig,alwaysCollapseControlBarOnIdle:this.alwaysCollapseControlBarOnIdle}),!this.sourceUrl)return void console.debug("[VideoPlayerCore] no source url provided");const e=this.shouldAutoPlay;console.debug("[VideoPlayerCore] resolve preload and autoplay",{autoplay:this.autoplay,preload:this.preload,isPlaying:this.isPlaying,shouldAutoPlay:e,playRequested:this.playRequested}),(e||this.preload)&&(yield this.controller.init()),e&&this.controller.tryAutoplay()}}))},onStateChange(t){this.isVideoElementFullScreen=ai(t,"isVideoElementFullScreen",this.isVideoElementFullScreen),this.videoElapsedSecs=ai(t,"videoElapsedSecs",this.videoElapsedSecs),this.videoDurationSecs=ai(t,"videoDurationSecs",this.videoDurationSecs),this.videoElapsedSecs<this.startPosition&&this.api.seek(this.startPosition)},onClientAction(t,e){switch(e){case"clientFullscreen":this.isClientFullScreen=t;break;case"resetController":this.onReset(t);break}},onReset(t){if(this.resetTimeout)return;const e=ai(t,"timeout",0);console.log("[VideoPlayerCore] resetting controller in "+e+"ms"),this.resetTimeout=setTimeout((()=>{this.resetController()}),e)},disposeController(){this.controller&&(this.controller.dispose(),this.controller=null)},resetController(t=!1){console.log("[VideoPlayerCore] resetting controller"),clearTimeout(this.resetTimeout),this.resetTimeout=0,this.disposeController(),this.createController(),t&&!this.isIframeContent&&(console.log("[VideoPlayerCore] seeking to last position before reset"),this.api.seek(this.videoElapsedSecs))},onMouseEnters(){this.controller&&this.controller.revealControlBar()},onMouseLeaves(){this.controller&&this.controller.hideControlBar()}}}),db=cb,ub=mi(db,li,ci,!1,null,null,null,!0),hb=ub.exports,pb=function(){var t=this,e=t._self._c;t._self._setupProxy;return t.tabCount||t.showToggler||t.showFullscreenToggler?e("div",{staticClass:"smvp-side-bar",class:{"no-player":t.noPlayer,"smvp-sidebar-wide":t.isSideBarExpanded,"smvp-sidebar-fullscreen":t.isClientFullScreen}},[t.tabCount>1||t.showToggler||t.showFullscreenToggler?e("div",{staticClass:"tabs"},[e("ul",[t.showToggler?e("li",{key:"smvp-sidebar-toggler",staticClass:"toggler",class:{opened:t.opened},on:{click:t.toggleSideBar}},[e("span",{staticClass:"smvp-tab-icon"},[e("icon",{attrs:{name:t.togglerIcon}})],1)]):t._e(),t._l(t.configuredTabs,(function(i){return e("li",{key:i.id,class:{active:t.openedTab&&t.openedTab.id===i.id,[`smvp-tabs-${i.id}`]:!0},on:{click:function(e){return t.changeTab(i)}}},[e("span",{staticClass:"smvp-tab-icon"},[e("icon",{attrs:{name:i.icon}})],1),e("span",{staticClass:"smvp-tab-text"},[t._v(t._s("qna"===i.id&&t.isPrivateQna?t.labels[i.id]?.private.tabName:t.labels[i.id]?.tabName))]),t.notificationDots.includes(i.id)&&t.openedTab.id!==i.id?e("div",{staticClass:"smvp-tab-notification-dot"}):t._e()])})),t.showFullscreenToggler?[e("li",{staticClass:"sidebar-spacer"},[t._v(" ")]),e("li",{staticClass:"fullscreen-toggler",on:{click:t.toggleFullscreen}},[e("span",{staticClass:"smvp-tab-icon"},[e("icon",{attrs:{name:t.fullscreenIcon}})],1)])]:t._e()],2)]):t._e(),t.tabCount?e("div",{staticClass:"main-view",class:{streamless:t.config.isStreamless,closed:!t.opened}},[t.showCloseButton?e("div",{staticClass:"btn streamless-close-btn",on:{click:function(e){return t.close()}}},[e("i",{staticClass:"icon-cross"})]):t._e(),t._l(t.configuredTabsInMainView,(function(i){return e(i.component,{directives:[{name:"show",rawName:"v-show",value:t.openedTab&&t.openedTab.id===i.id,expression:"openedTab && openedTab.id === tab.id"}],key:i.id,tag:"component",staticClass:"smvp-tab",attrs:{api:t.api,config:t.tabsConfig[i.id],labels:t.labels[i.id],theme:t.theme,expanded:t.isSideBarExpanded,"is-webinar":t.isWebinar,"is-private-qna":t.isPrivateQna,"no-player":t.noPlayer}})}))],2):t._e(),e("portal",{attrs:{to:t.sideBarNotificationPortalId}},[t.pollNotification?e("side-bar-notification",{attrs:{config:t.pollNotification,theme:t.theme},on:{click:function(e){return t.pollNotificationClick(t.pollNotification.toTab)}}}):t._e()],1)],1):t._e()},fb=[],mb=function(){var t=this,e=t._self._c;t._self._setupProxy;return t.hidden?t._e():e("div",{staticClass:"smvp-viewers"},[e("section",{staticClass:"content",class:{empty:!t.viewers.length}},[t.viewers.length?t._e():e("div",{staticClass:"no-viewers"},[e("p",[t._v(t._s(t.labels.waitingForViewers))])]),t._l(t.viewers,(function(i,s){return e("div",{key:s,staticClass:"viewer",class:{"is-webinar":t.isWebinar}},[e("viewer",{attrs:{viewer:i,api:t.api}})],1)}))],2)])},vb=[],gb=function(){var t=this,e=t._self._c;t._self._setupProxy;return e("div",{staticClass:"smvp-viewer"},[e("div",{staticClass:"profile",on:{click:function(e){return t.onViewerClick()}}},[e("profile",{attrs:{"user-id":t.pid,"user-name":t.userName,subtitle:t.subtitle,"no-subtitle":!t.subtitle.length}})],1)])},yb=[],bb=function(){var t=this,e=t._self._c;t._self._setupProxy;return e("div",{staticClass:"smvp-profile",on:{click:function(e){return t.onProfileClick()}}},[e("avatar",{attrs:{"user-id":t.userId,"user-name":t.userName,"question-id":t.questionId,"profile-picture":t.profilePicture,"show-user-initials":t.showUserInitials}}),e("div",{staticClass:"details"},[e("div",{staticClass:"title",class:{"no-subtitle":t.noSubtitle}},[t._v(t._s(t.userName))]),t.noSubtitle?t._e():e("div",{staticClass:"subtitle"},[e("span",[t._v(t._s(t.subtitle))])])])],1)},wb=[],Sb=function(){var t=this,e=t._self._c;t._self._setupProxy;return e("div",{staticClass:"smvp-avatar"},[t.profilePic?e("div",{staticClass:"picture"},[e("img",{attrs:{src:t.profilePic}})]):t._e(),!t.profilePic&&t.showUserInitials?e("div",{staticClass:"initials",style:{"background-color":t.color}},[t._v(t._s(t.initials))]):t._e(),t.profilePic||t.showUserInitials?t._e():e("div",{staticClass:"smvp-silhouette",style:{"background-color":t.color}},[e("icon",{attrs:{name:t.icon}})],1)])},Eb=[];function Tb(t,e,i){const s=t||i,n=Cb(s),r=Lb[n%Lb.length],o=xb(e)?kb(n):_b(e);return{color:r,initials:o}}function xb(t){return!t||"anonymous"===t.toLowerCase()}function Cb(t){let e=0;for(let i=0;i<(t||"").length;++i)e+=t.charCodeAt(i);return e}function _b(t){return(t||"").trim().replace(/[^\p{L}\s]/gu,"").split(/\s+/).slice(0,2).map((t=>t.charAt(0).toLocaleUpperCase())).join("")}function kb(t){const e=Ab[t%Ab.length],i=t%10;return e+i}const Lb=["#6F1E00","#705000","#886F65","#74564A","#3B2823","#B04021","#CC3E20","#80762C","#457A3B","#305C28","#36685D","#10828F","#C4281B","#C73461","#B22F5B","#7D1F4E","#B52C61","#9E50B6","#8232A4","#612794","#431E87","#9B2EF5","#A60064","#700041","#775BBC","#6041B1","#7355F6","#5823E1","#5E6CBB","#3466F6","#2F65B9","#1E499C","#1A2679","#001082","#001082","#00185A","#DA1F77","#965635","#6162A9","#7CA00D","#529AA3","#296FB4","#264C41","#596D79","#495A63","#757575","#616161","#212121","#E46C51","#D08015"],Ab=["α","β","γ","δ","ε","ζ","η","θ","ι","κ","λ","μ","ν","ξ","ο","π","ρ","σ","τ","υ","φ","χ","ψ","ω"];function Rb(t){return di(this,void 0,void 0,(function*(){return new Promise((e=>{const i=new Image;i.addEventListener("load",(()=>e(!0))),i.addEventListener("error",(()=>{e(!1)})),i.src=t}))}))}var Ib,Db=function(){var t=this,e=t._self._c;t._self._setupProxy;return e("svg",{staticClass:"smvp-icon",attrs:{version:"1.1",xmlns:"http://www.w3.org/2000/svg",width:"120",height:"120",viewBox:t.contents.viewBox||"0 0 120 120","aria-label":t.ariaLabel},on:{click:function(e){return t.$emit("click")}}},[t._l(t.contents.rects,(function(i,s){return e("rect",{key:"rect"+s,attrs:{width:i.width,height:i.height,rx:i.rx,fill:t.color||i.fill}})})),t._l(t.contents.paths,(function(i,s){return e("path",{key:"path"+s,attrs:{fill:t.color||i.fill||"white",d:i.path||i,"fill-rule":i.fillRule||"","clip-rule":i.clipRule||"",stroke:i.stroke}})}))],2)},Pb=[];(function(t){t["captionsOff"]="captions-off",t["captionsOn"]="captions-on",t["chevronRight"]="chevron-right",t["chevronLeft"]="chevron-left",t["chevronUp"]="chevron-up",t["chevronDown"]="chevron-down",t["check"]="check",t["clock"]="clock",t["cross"]="cross",t["expand"]="expand",t["eye"]="eye",t["help"]="help",t["interprefy"]="interprefy",t["maximize"]="maximize",t["minimize"]="minimize",t["participants"]="participants",t["pause"]="pause",t["play"]="play",t["playCircle"]="play-circle",t["pollingStar"]="polling-star",t["question"]="question",t["ranking"]="ranking",t["sidebar"]="sidebar",t["silhouette"]="silhouette",t["stop"]="stop",t["settings"]="settings",t["translations"]="translations",t["thumbUp"]="thumb-up",t["upDown"]="up-down",t["volumeLow"]="volume-low",t["volumeMax"]="volume-max",t["volumeMid"]="volume-mid",t["volumeOff"]="volume-off"})(Ib||(Ib={}));const Ob={[Ib.captionsOff]:{paths:["M119.997 106.243l-0.017 0.364c-0.264 2.861-3.61 4.415-5.983 2.635l-29-19.242h-73.747c-6.211 0-11.25-5.039-11.25-11.25v-57.499c0-6.21 5.039-11.249 11.25-11.249h97.497c6.211 0 11.25 5.038 11.25 11.249v84.992zM112.497 99.247v-77.995c0-2.068-1.68-3.749-3.75-3.749h-97.497c-2.069 0-3.75 1.681-3.75 3.749v57.499c0 2.068 1.681 3.75 3.75 3.75h76.009l25.238 16.747z","M15 65.001h34.999c2.761 0 5 2.239 5 5s-2.239 5-5 5h-34.999c-2.761 0-5-2.239-5-5s2.239-5 5-5z","M49.999 45.001h29.999c2.761 0 5 2.239 5 5s-2.239 5-5 5h-29.999c-2.761 0-5-2.239-5-5s2.239-5 5-5z","M15 45.001h15c2.761 0 5 2.239 5 5s-2.239 5-5 5h-15c-2.761 0-5-2.239-5-5s2.239-5 5-5z","M99.998 45.001h5c2.761 0 5 2.239 5 5s-2.239 5-5 5h-5c-2.761 0-5-2.239-5-5s2.239-5 5-5z","M69.999 65.001h19.999c2.761 0 5 2.239 5 5s-2.239 5-5 5h-19.999c-2.761 0-5-2.239-5-5s2.239-5 5-5z"]},[Ib.captionsOn]:{paths:["M105.096 13.752c5.745 0 10.406 4.661 10.406 10.406v78.62l-0.015 0.337c-0.244 2.646-3.339 4.084-5.535 2.438l-26.826-17.8h-68.218c-5.745 0-10.406-4.662-10.406-10.406v-53.188c0-5.745 4.661-10.406 10.406-10.406h90.188zM18.377 64.627c-2.554 0-4.625 2.071-4.625 4.625s2.071 4.625 4.625 4.625h32.375c2.554 0 4.625-2.071 4.625-4.625s-2.071-4.625-4.625-4.625h-32.375zM46.127 50.752c0 2.554 2.071 4.625 4.625 4.625h27.75c2.554 0 4.625-2.071 4.625-4.625s-2.071-4.625-4.625-4.625h-27.75c-2.554 0-4.625 2.071-4.625 4.625zM18.377 46.127c-2.554 0-4.625 2.071-4.625 4.625s2.071 4.625 4.625 4.625h13.875c2.554 0 4.625-2.071 4.625-4.625s-2.071-4.625-4.625-4.625h-13.875zM92.377 50.752c0 2.554 2.071 4.625 4.625 4.625h4.625c2.554 0 4.625-2.071 4.625-4.625s-2.071-4.625-4.625-4.625h-4.625c-2.554 0-4.625 2.071-4.625 4.625zM69.252 64.627c-2.554 0-4.625 2.071-4.625 4.625s2.071 4.625 4.625 4.625h18.5c2.554 0 4.625-2.071 4.625-4.625s-2.071-4.625-4.625-4.625h-18.5z"]},[Ib.maximize]:{paths:["M40 10h-15c-8.284 0-15 6.716-15 15v15c0 2.761 2.239 5 5 5s5-2.239 5-5v-15c0-2.761 2.239-5 5-5h15c2.761 0 5-2.239 5-5s-2.239-5-5-5zM110 40v-15c0-8.284-6.716-15-15-15h-15c-2.761 0-5 2.239-5 5s2.239 5 5 5h15c2.761 0 5 2.239 5 5v15c0 2.761 2.239 5 5 5s5-2.239 5-5zM80 110h15c8.284 0 15-6.716 15-15v-15c0-2.761-2.239-5-5-5s-5 2.239-5 5v15c0 2.761-2.239 5-5 5h-15c-2.761 0-5 2.239-5 5s2.239 5 5 5zM10 80v15c0 8.284 6.716 15 15 15h15c2.761 0 5-2.239 5-5s-2.239-5-5-5h-15c-2.761 0-5-2.239-5-5v-15c0-2.761-2.239-5-5-5s-5 2.239-5 5z"]},[Ib.minimize]:{paths:["M35 15v15c0 2.761-2.239 5-5 5h-15c-2.761 0-5 2.239-5 5s2.239 5 5 5h15c8.284 0 15-6.716 15-15v-15c0-2.761-2.239-5-5-5s-5 2.239-5 5zM105 35h-15c-2.761 0-5-2.239-5-5v-15c0-2.761-2.239-5-5-5s-5 2.239-5 5v15c0 8.284 6.716 15 15 15h15c2.761 0 5-2.239 5-5s-2.239-5-5-5zM85 105v-15c0-2.761 2.239-5 5-5h15c2.761 0 5-2.239 5-5s-2.239-5-5-5h-15c-8.284 0-15 6.716-15 15v15c0 2.761 2.239 5 5 5s5-2.239 5-5zM15 85h15c2.761 0 5 2.239 5 5v15c0 2.761 2.239 5 5 5s5-2.239 5-5v-15c0-8.284-6.716-15-15-15h-15c-2.761 0-5 2.239-5 5s2.239 5 5 5z"]},[Ib.participants]:{viewBox:"0 0 16 16",paths:[{fillRule:"evenodd",clipRule:"evenodd",path:"M11 9.165a3.243 3.243 0 0 1-1.776-.527.495.495 0 0 1-.216-.316.498.498 0 0 1 .762-.521 2.246 2.246 0 0 0 2.455.002 2.252 2.252 0 0 0-1.23-4.138c-.432 0-.854.126-1.222.364a.5.5 0 1 1-.544-.84 3.234 3.234 0 0 1 2.446-.453c.849.18 1.577.68 2.05 1.409a3.254 3.254 0 0 1-.955 4.496 3.241 3.241 0 0 1-1.77.524Zm-6 0a3.254 3.254 0 0 1-3.25-3.25A3.254 3.254 0 0 1 5 2.666a3.254 3.254 0 0 1 3.25 3.25A3.254 3.254 0 0 1 5 9.166Zm0-5.5c-1.24 0-2.25 1.01-2.25 2.25 0 1.242 1.01 2.25 2.25 2.25s2.25-1.008 2.25-2.25c0-1.24-1.01-2.25-2.25-2.25Zm4 10.5a.5.5 0 0 0 1 0c0-2.756-2.243-5-5-5s-5 2.244-5 5a.5.5 0 0 0 1 0c0-2.204 1.795-4 4-4s4 1.796 4 4Zm6 .002a.5.5 0 0 0 1-.002c0-.37-.042-.74-.124-1.1a4.97 4.97 0 0 0-2.211-3.127A4.986 4.986 0 0 0 9.89 9.29a.496.496 0 0 0-.377.598.497.497 0 0 0 .598.376 3.988 3.988 0 0 1 3.021.518 3.98 3.98 0 0 1 1.77 2.503c.065.289.098.585.098.88Z"}]},[Ib.pause]:{paths:["M25 10c-2.761 0-5 2.239-5 5v90c0 2.762 2.239 5 5 5h20c2.761 0 5-2.239 5-5v-90c0-2.761-2.239-5-5-5h-20zM75 10c-2.762 0-5 2.239-5 5v90c0 2.762 2.239 5 5 5h20c2.762 0 5-2.239 5-5v-90c0-2.761-2.239-5-5-5h-20z"]},[Ib.play]:{paths:["M25 19.022c0-3.927 4.32-6.321 7.65-4.24l65.566 40.979c3.133 1.959 3.133 6.521 0 8.48l-65.566 40.978c-3.33 2.081-7.65-0.313-7.65-4.24v-81.957z"]},[Ib.playCircle]:{viewBox:"0 0 16 16",paths:[{fillRule:"evenodd",clipRule:"evenodd",path:"M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"},{fillRule:"evenodd",clipRule:"evenodd",path:"M10.5784 8.25004L6.75 5.91691L6.75 10.5832L10.5784 8.25004ZM11.7994 8.677C12.1191 8.48214 12.1191 8.01793 11.7994 7.82308L6.5102 4.5997C6.17701 4.39664 5.75 4.63647 5.75 5.02666L5.75 11.4734C5.75 11.8636 6.177 12.1034 6.5102 11.9004L11.7994 8.677Z"}]},[Ib.stop]:{viewBox:"-3 -3 20 20",paths:["M0 0.99998C0 0.63179 0.373003 0.333313 0.833125 0.333313H12.4969C12.957 0.333313 13.33 0.63179 13.33 0.99998V13C13.33 13.3682 12.957 13.6666 12.4969 13.6666H0.833125C0.373003 13.6666 0 13.3682 0 13V0.99998Z"]},[Ib.translations]:{viewBox:"0 0 16 16",paths:["M8 0C12.4329 0 16 3.56588 16 8C16 12.4326 12.4326 16 8 16C3.56738 16 0 12.4332 0 8C0 3.56738 3.56738 0 8 0ZM12.7958 2.60921C11.9882 1.89051 11.0311 1.36168 9.99363 1.0642C10.6109 1.78492 11.0321 2.7365 11.3129 3.62997C11.8472 3.35318 12.3464 3.00979 12.7958 2.60921ZM13.3525 3.16176C12.8039 3.65571 12.1888 4.07342 11.5261 4.39919C11.7796 5.44472 11.9069 6.53267 11.9317 7.6073H15.2041C15.1153 5.95262 14.4637 4.38987 13.3525 3.16146L13.3525 3.16176ZM11.9317 8.39227C11.9069 9.46754 11.7796 10.5556 11.5256 11.6016C12.1877 11.9274 12.8034 12.3446 13.352 12.839C14.4632 11.6102 15.1152 10.0474 15.2041 8.39287H11.9316L11.9317 8.39227ZM11.3124 12.3703C11.0316 13.2638 10.6104 14.2149 9.99315 14.9356C11.0306 14.6382 11.9882 14.1093 12.7953 13.3906C12.3458 12.99 11.8468 12.6472 11.3124 12.3703ZM4.68726 12.3703C4.15294 12.6471 3.65381 12.9905 3.20439 13.3906C4.01154 14.1093 4.96911 14.6382 6.00655 14.9356C5.38931 14.2149 4.96806 13.2638 4.68726 12.3704V12.3703ZM4.47411 11.6016C4.22057 10.5556 4.09326 9.46811 4.06801 8.39227H0.795557C0.884455 10.047 1.536 11.6097 2.64764 12.8384C3.19619 12.3445 3.81181 11.9268 4.47402 11.601L4.47411 11.6016ZM4.06801 7.60791C4.09279 6.53264 4.22009 5.44517 4.47363 4.39979C3.81093 4.07402 3.1958 3.65631 2.64725 3.16236C1.53606 4.39074 0.884065 5.95394 0.795617 7.60821L4.06801 7.60791ZM3.20379 2.60979C3.65334 3.01036 4.15234 3.35327 4.68667 3.63054C4.96746 2.73708 5.38872 1.78549 6.00596 1.06477C4.96851 1.36224 4.01095 1.89105 3.20379 2.60979ZM8.39192 0.845066V4.42267C9.1455 4.38227 9.88748 4.22573 10.592 3.95445C10.2667 2.89224 9.53435 1.18963 8.39192 0.845246V0.845066ZM7.60698 0.845066C6.46443 1.18999 5.73268 2.89269 5.40691 3.95427C6.11094 4.22555 6.85349 4.38208 7.60698 4.42249V0.845066ZM5.20434 4.71459C4.98614 5.65962 4.87598 6.63844 4.85286 7.60764H7.60698V5.20806C6.78527 5.16813 5.97508 5.00195 5.20434 4.71411V4.71459ZM4.85286 8.3926C4.87611 9.3618 4.98615 10.3412 5.20434 11.2867C5.97508 10.9989 6.78527 10.8332 7.60698 10.7933V8.39308H4.85286V8.3926ZM5.40739 12.0463C5.73268 13.1079 6.46503 14.8106 7.60698 15.1555V11.5785C6.8534 11.6189 6.11142 11.776 5.40739 12.0467V12.0463ZM8.39192 15.1555C9.53387 14.8106 10.2662 13.1084 10.5915 12.0463C9.88748 11.7756 9.1455 11.6185 8.39192 11.5781V15.1555ZM10.7946 11.2866C11.0128 10.3415 11.1229 9.36222 11.146 8.39242H8.39192V10.7926C9.21363 10.8325 10.0238 10.9981 10.7946 11.2861V11.2866ZM10.7946 4.71489C10.0238 5.00273 9.21363 5.16891 8.39192 5.20884V7.60842H11.146C11.1228 6.63922 11.0128 5.66037 10.7946 4.71537V4.71489Z"]},[Ib.thumbUp]:{viewBox:"0 -2 11 16",paths:["M9.14915 4.05018C9.56801 4.05018 9.93408 4.50046 9.9912 4.92379C10.0181 6.33157 9.99348 5.95297 9.76545 7.77714C9.53743 9.60131 9.08139 9.82933 8.62535 10.0574C8.16931 10.2854 6.34514 10.2854 6.34514 10.2854C5.43306 10.2854 3.60889 10.0574 3.60889 10.0574V9.47276V4.31223V4.2316C4.16101 3.82843 4.75121 3.14305 4.97967 2.86084C5.03679 2.7802 5.09391 2.69957 5.13198 2.59878C5.26526 2.27624 5.60795 1.46991 5.68411 0.925639C5.72218 0.623264 5.91257 0.461997 6.16007 0.482156C6.55989 0.522472 7.13105 1.04659 7.13105 1.9134C7.13105 2.67941 6.84547 3.44543 6.69316 3.84859C6.65508 3.92922 6.63605 3.98969 6.61701 4.05016L6.61701 4.05018H9.14915Z","M2.19724 4.12891H0.915979C0.655383 4.12891 0.416504 4.34032 0.416504 4.61515V10.0273C0.416504 10.2809 0.633667 10.5135 0.915979 10.5135H2.19724C2.45784 10.5135 2.69671 10.3021 2.69671 10.0273V4.61515C2.675 4.36146 2.45784 4.12891 2.19724 4.12891Z"]},[Ib.upDown]:{viewBox:"0 0 16 16",paths:["M4.33333 14.5002C4.37784 14.5002 4.42184 14.4917 4.46483 14.4754C4.46887 14.4738 4.47241 14.4727 4.47595 14.4711C4.5245 14.4506 4.56648 14.4215 4.60188 14.3841L7.88873 10.9535C7.96055 10.8786 8 10.7793 8 10.6738C8 10.5682 7.96055 10.4685 7.88873 10.3941C7.81742 10.3191 7.72184 10.2779 7.62069 10.2779C7.51954 10.2779 7.42395 10.3191 7.35264 10.3941L4.71264 13.1491L4.71264 2.22933C4.71264 2.01083 4.54271 1.8335 4.33333 1.8335C4.12395 1.8335 3.95402 2.01083 3.95402 2.22933L3.95402 13.1485L1.31402 10.3935C1.24271 10.3191 1.14713 10.2779 1.04598 10.2779C0.944827 10.2779 0.849241 10.3191 0.77793 10.3941C0.706114 10.469 0.666667 10.5682 0.666667 10.6738C0.666667 10.7793 0.706114 10.8791 0.77793 10.9535L4.06529 14.3841C4.10069 14.421 4.14267 14.45 4.1897 14.4706C4.19375 14.4722 4.1988 14.4743 4.20336 14.4759C4.24634 14.4922 4.28984 14.5002 4.33333 14.5002Z","M13.3335 1.83333C13.2849 1.83333 13.2369 1.84178 13.19 1.85814C13.1856 1.85972 13.1818 1.86078 13.1779 1.86236C13.1249 1.88294 13.0792 1.91197 13.0405 1.94944L9.45488 5.38C9.37653 5.45494 9.3335 5.55417 9.3335 5.65972C9.3335 5.76528 9.37653 5.86503 9.45488 5.93944C9.53267 6.01439 9.63694 6.05555 9.74729 6.05555C9.85763 6.05555 9.96191 6.01439 10.0397 5.93944L12.9197 3.18444V14.1042C12.9197 14.3227 13.1051 14.5 13.3335 14.5C13.5619 14.5 13.7473 14.3227 13.7473 14.1042V3.18497L16.6273 5.93997C16.7051 6.01439 16.8094 6.05555 16.9197 6.05555C17.03 6.05555 17.1343 6.01439 17.2121 5.93944C17.2905 5.8645 17.3335 5.76528 17.3335 5.65972C17.3335 5.55417 17.2905 5.45442 17.2121 5.38L13.6259 1.94944C13.5873 1.9125 13.5415 1.88347 13.4902 1.86289C13.4858 1.8613 13.4803 1.85919 13.4753 1.85761C13.4284 1.84125 13.3809 1.83333 13.3335 1.83333Z"]},[Ib.volumeLow]:{paths:["M51.5 11.455l-29.66 29.635c-0.116 0.116-0.254 0.208-0.406 0.271s-0.315 0.095-0.479 0.094h-10.955c-2.652 0-5.196 1.054-7.071 2.929s-2.929 4.419-2.929 7.071v17.070c0 2.652 1.054 5.196 2.929 7.071s4.419 2.929 7.071 2.929h10.955c0.165 0 0.328 0.033 0.479 0.096s0.29 0.156 0.406 0.274l29.63 29.63c0.699 0.696 1.588 1.171 2.556 1.363s1.971 0.094 2.883-0.283 1.693-1.016 2.242-1.835c0.549-0.819 0.845-1.783 0.848-2.77v-90c-0.005-0.982-0.3-1.942-0.846-2.758s-1.322-1.453-2.229-1.831c-0.906-0.378-1.905-0.481-2.869-0.295s-1.854 0.651-2.555 1.339v0z","M75.695 37.5c-0.464-0.465-1.015-0.834-1.622-1.086s-1.256-0.382-1.913-0.383c-0.657-0.001-1.307 0.128-1.914 0.379s-1.159 0.618-1.624 1.082c-0.465 0.464-0.834 1.015-1.086 1.621s-0.382 1.257-0.383 1.913c-0 0.657 0.128 1.307 0.379 1.914s0.619 1.159 1.082 1.624c4.085 4.103 6.379 9.658 6.379 15.448s-2.293 11.344-6.379 15.448c-0.51 0.453-0.923 1.006-1.211 1.625s-0.448 1.29-0.467 1.972c-0.019 0.682 0.101 1.361 0.354 1.995s0.633 1.209 1.117 1.691c0.484 0.482 1.061 0.859 1.697 1.109s1.315 0.367 1.997 0.344c0.682-0.023 1.352-0.185 1.97-0.477s1.168-0.707 1.618-1.219c5.946-5.979 9.284-14.067 9.285-22.499s-3.336-16.521-9.28-22.501v0z"]},[Ib.volumeMax]:{paths:["M51.5 11.455l-29.65 29.635c-0.116 0.116-0.254 0.208-0.406 0.271s-0.315 0.095-0.479 0.094h-10.965c-2.652 0-5.196 1.054-7.071 2.929s-2.929 4.419-2.929 7.071v17.070c0 2.652 1.054 5.196 2.929 7.071s4.419 2.929 7.071 2.929h10.965c0.165 0 0.328 0.033 0.479 0.096s0.29 0.156 0.406 0.274l29.65 29.63c0.701 0.686 1.587 1.152 2.55 1.339s1.959 0.086 2.865-0.291c0.906-0.375 1.682-1.009 2.23-1.822s0.846-1.77 0.855-2.751v-90c-0.005-0.983-0.3-1.942-0.846-2.758s-1.322-1.453-2.229-1.831c-0.906-0.378-1.905-0.481-2.869-0.295s-1.854 0.651-2.555 1.339v0z","M87.95 24.83c-0.943-0.911-2.206-1.415-3.517-1.403s-2.565 0.537-3.492 1.464c-0.927 0.927-1.453 2.181-1.464 3.492s0.493 2.574 1.404 3.517c3.692 3.689 6.621 8.069 8.619 12.89s3.026 9.989 3.026 15.207c0 5.219-1.029 10.386-3.026 15.208s-4.927 9.201-8.619 12.89c-0.911 0.943-1.414 2.206-1.404 3.517s0.538 2.565 1.464 3.492 2.181 1.453 3.492 1.464c1.311 0.011 2.574-0.493 3.517-1.404 4.62-4.617 8.286-10.099 10.787-16.134s3.788-12.502 3.788-19.034-1.288-13-3.788-19.034c-2.501-6.034-6.167-11.516-10.787-16.133v0z","M100.205 12.17c-0.943-0.911-2.206-1.415-3.517-1.403s-2.565 0.537-3.492 1.464c-0.927 0.927-1.453 2.181-1.464 3.492s0.493 2.574 1.404 3.517c10.788 10.818 16.846 25.472 16.846 40.75s-6.058 29.932-16.846 40.75c-0.478 0.461-0.859 1.013-1.121 1.623s-0.4 1.266-0.405 1.93c-0.006 0.664 0.12 1.322 0.372 1.937s0.623 1.172 1.092 1.642c0.469 0.469 1.028 0.841 1.642 1.093s1.273 0.377 1.937 0.372c0.664-0.006 1.32-0.144 1.93-0.406s1.162-0.643 1.623-1.121c12.662-12.694 19.772-29.891 19.772-47.82s-7.11-35.126-19.772-47.82v0z","M75.705 37.5c-0.464-0.465-1.015-0.834-1.622-1.086s-1.256-0.382-1.913-0.383c-0.657-0.001-1.307 0.128-1.914 0.379s-1.159 0.618-1.624 1.082c-0.465 0.464-0.834 1.015-1.086 1.621s-0.382 1.257-0.382 1.913c-0 0.657 0.128 1.307 0.379 1.914s0.619 1.159 1.082 1.624c4.085 4.103 6.379 9.658 6.379 15.448s-2.293 11.344-6.379 15.448c-0.51 0.453-0.923 1.006-1.211 1.625s-0.448 1.29-0.467 1.972c-0.019 0.682 0.101 1.361 0.354 1.995s0.633 1.209 1.117 1.691c0.484 0.482 1.061 0.859 1.697 1.109s1.315 0.367 1.997 0.344c0.682-0.023 1.352-0.185 1.97-0.477s1.168-0.707 1.618-1.219c5.946-5.979 9.284-14.067 9.285-22.499s-3.336-16.521-9.28-22.501v0z"]},[Ib.volumeMid]:{paths:["M51.46 11.455l-29.63 29.635c-0.235 0.234-0.553 0.365-0.885 0.365h-10.945c-2.652 0-5.196 1.054-7.071 2.929s-2.929 4.419-2.929 7.071v17.070c0 2.652 1.054 5.196 2.929 7.071s4.419 2.929 7.071 2.929h10.945c0.332 0.002 0.65 0.135 0.885 0.37l29.63 29.63c0.699 0.7 1.588 1.177 2.559 1.371s1.975 0.096 2.889-0.281c0.915-0.377 1.696-1.017 2.246-1.839s0.845-1.788 0.846-2.777v-90c0.003-0.991-0.289-1.96-0.838-2.784s-1.331-1.468-2.246-1.847-1.922-0.479-2.893-0.286c-0.971 0.193-1.864 0.671-2.563 1.373v0z","M87.925 24.83c-0.943-0.911-2.206-1.415-3.517-1.403s-2.565 0.537-3.492 1.464c-0.927 0.927-1.453 2.181-1.464 3.492s0.493 2.574 1.404 3.517c3.692 3.689 6.621 8.069 8.619 12.89s3.026 9.989 3.026 15.207c0 5.219-1.029 10.386-3.026 15.208s-4.927 9.201-8.619 12.89c-0.911 0.943-1.415 2.206-1.404 3.517s0.538 2.565 1.464 3.492c0.927 0.927 2.181 1.453 3.492 1.464s2.574-0.493 3.517-1.404c4.62-4.617 8.286-10.099 10.787-16.134s3.788-12.502 3.788-19.034-1.288-13-3.788-19.034c-2.501-6.034-6.167-11.516-10.787-16.133v0z","M75.68 37.5c-0.454-0.503-1.005-0.909-1.62-1.192s-1.281-0.439-1.959-0.458c-0.677-0.018-1.351 0.101-1.98 0.351s-1.202 0.625-1.682 1.103c-0.48 0.478-0.859 1.048-1.112 1.676s-0.375 1.301-0.36 1.978c0.015 0.677 0.167 1.344 0.448 1.961s0.683 1.17 1.184 1.626c4.085 4.103 6.379 9.657 6.379 15.447s-2.293 11.344-6.379 15.448c-0.488 0.459-0.879 1.011-1.149 1.624s-0.414 1.274-0.424 1.944 0.115 1.335 0.367 1.956c0.252 0.621 0.626 1.185 1.101 1.657s1.039 0.846 1.66 1.097c0.621 0.251 1.286 0.374 1.956 0.362s1.331-0.157 1.943-0.429c0.613-0.272 1.164-0.664 1.622-1.153 5.949-5.977 9.289-14.066 9.289-22.499s-3.337-16.522-9.284-22.501v0z"]},[Ib.volumeOff]:{paths:["M73.385 30.29c0.234-0.235 0.365-0.553 0.365-0.885v-10.645c0-0.989-0.294-1.955-0.843-2.777s-1.33-1.463-2.244-1.841c-0.913-0.378-1.919-0.477-2.889-0.285s-1.86 0.669-2.56 1.368l-29.635 29.635c-0.116 0.116-0.254 0.208-0.406 0.271s-0.315 0.095-0.479 0.094h-10.945c-2.652 0-5.196 1.054-7.071 2.929s-2.929 4.419-2.929 7.071v17.070c0 2.149 0.693 4.241 1.975 5.966s3.086 2.991 5.145 3.609c0.217 0.065 0.447 0.070 0.666 0.015s0.419-0.169 0.579-0.33l51.27-51.265z","M118.535 8.545c0.937-0.938 1.464-2.209 1.464-3.535s-0.527-2.597-1.464-3.535c-0.944-0.925-2.214-1.444-3.535-1.444s-2.591 0.518-3.535 1.444l-110 110c-0.937 0.938-1.464 2.209-1.464 3.535s0.527 2.597 1.464 3.535c0.224 0.224 0.469 0.426 0.73 0.605 0.962 0.652 2.122 0.948 3.279 0.838s2.239-0.621 3.061-1.442l30.58-30.58c0.235-0.234 0.553-0.365 0.885-0.365s0.65 0.131 0.885 0.365l24.325 24.33c0.699 0.701 1.59 1.179 2.561 1.373s1.977 0.095 2.891-0.283 1.697-1.020 2.246-1.843c0.549-0.823 0.842-1.791 0.842-2.781v-54.91c0-0.332 0.131-0.649 0.365-0.885l44.42-44.42z"]},[Ib.sidebar]:{viewBox:"0 0 16 16",paths:["M11 0H15C15.5523 0 16 0.447715 16 1V15C16 15.5523 15.5523 16 15 16H11V0Z",{path:"M0 1C0 0.447715 0.447715 0 1 0H9V16H1C0.447715 16 0 15.5523 0 15V1Z",fill:"#AAB3BB"}]},[Ib.help]:{viewBox:"0 0 16 16",paths:["M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM8 14C7.46667 14 7 13.5333 7 13C7 12.4667 7.46667 12 8 12C8.53333 12 9 12.4667 9 13C9 13.5333 8.53333 14 8 14ZM11.4 7.06667C11.1333 7.73333 10.6667 8.33333 10.0667 8.73333C9.73333 8.93333 9.4 9.13333 9 9.2V10.3333C9 10.8667 8.53333 11.3333 8 11.3333C7.46667 11.3333 7 10.8667 7 10.3333V8.33333C7 7.86667 7.33333 7.46667 7.8 7.4C7.86667 7.4 7.93333 7.4 8 7.4C8.33333 7.4 8.66667 7.33333 8.93333 7.13333C9.2 6.93333 9.4 6.66667 9.53333 6.4C9.74061 5.8818 9.65648 5.12332 9.33333 4.66667C8.87035 4.01242 8.06029 3.84255 7.33333 4.13333C7 4.26667 6.8 4.46667 6.6 4.73333C6.4 5 6.33333 5.33333 6.33333 5.66667C6.33333 6.2 5.86667 6.66667 5.33333 6.66667C4.8 6.66667 4.33333 6.2 4.33333 5.66667C4.33333 4.93333 4.53333 4.2 4.93333 3.6C5.33333 3 5.93333 2.53333 6.6 2.26667C7.26667 2 8 1.93333 8.73333 2.06667C9.46667 2.2 10.0667 2.53333 10.6 3.06667C11.1333 3.6 11.4667 4.2 11.6 4.93333C11.7333 5.66667 11.6667 6.4 11.4 7.06667Z"]},[Ib.interprefy]:{viewBox:"0 0 16 16",paths:[{path:"M8 14.6667C11.6819 14.6667 14.6667 11.6819 14.6667 8C14.6667 4.3181 11.6819 1.33333 8 1.33333C4.3181 1.33333 1.33333 4.3181 1.33333 8C1.33333 11.6819 4.3181 14.6667 8 14.6667ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",fillRule:"evenodd"},{path:"M9.63586 13.0606C10.249 11.8343 10.6667 10.047 10.6667 8C10.6667 5.95297 10.249 4.16565 9.63586 2.93943C8.98287 1.63345 8.32747 1.33333 8 1.33333C7.67253 1.33333 7.01713 1.63345 6.36414 2.93943C5.75103 4.16565 5.33333 5.95297 5.33333 8C5.33333 10.047 5.75103 11.8343 6.36414 13.0606C7.01713 14.3665 7.67253 14.6667 8 14.6667C8.32747 14.6667 8.98287 14.3665 9.63586 13.0606ZM8 16C10.2091 16 12 12.4183 12 8C12 3.58172 10.2091 0 8 0C5.79086 0 4 3.58172 4 8C4 12.4183 5.79086 16 8 16Z",fillRule:"evenodd"},{path:"M1.33329 4.66669C0.965103 4.66669 0.666626 4.96516 0.666626 5.33335C0.666626 5.70154 0.965103 6.00002 1.33329 6.00002H14.6666C15.0348 6.00002 15.3333 5.70154 15.3333 5.33335C15.3333 4.96516 15.0348 4.66669 14.6666 4.66669H1.33329Z",fillRule:"evenodd"},{path:"M1.33329 10C0.965103 10 0.666626 10.2985 0.666626 10.6667C0.666626 11.0349 0.965103 11.3333 1.33329 11.3333H14.6666C15.0348 11.3333 15.3333 11.0349 15.3333 10.6667C15.3333 10.2985 15.0348 10 14.6666 10H1.33329Z",fillRule:"evenodd"}]},[Ib.chevronRight]:{viewBox:"0 0 9 18",paths:[{path:"M0.75 17.4001C0.55 17.4001 0.361 17.3221 0.22 17.1801C-0.072 16.8881 -0.072 16.4121 0.22 16.1191L7.34 9.0001L0.22 1.8801C0.078 1.7391 0 1.5501 0 1.3501C0 1.1501 0.078 0.961098 0.22 0.820098C0.361 0.678098 0.55 0.600098 0.75 0.600098C0.95 0.600098 1.139 0.678098 1.28 0.820098L8.4 7.9401C8.984 8.5241 8.985 9.4751 8.401 10.0591L1.28 17.1801C1.139 17.3221 0.95 17.4001 0.75 17.4001Z",fill:"#2D3339"}]},[Ib.chevronLeft]:{viewBox:"0 0 9 18",paths:[{path:"M8.25 17.4C8.45 17.4 8.639 17.322 8.78 17.18C9.072 16.888 9.072 16.412 8.78 16.119L1.66 8.99998L8.78 1.87998C8.922 1.73898 9 1.54998 9 1.34998C9 1.14998 8.922 0.960976 8.78 0.819976C8.639 0.677976 8.45 0.599976 8.25 0.599976C8.05 0.599976 7.861 0.677976 7.72 0.819976L0.6 7.93998C0.0160004 8.52398 0.015 9.47498 0.599 10.059L7.72 17.18C7.861 17.322 8.05 17.4 8.25 17.4Z",fill:"#2D3339"}]},[Ib.chevronUp]:{viewBox:"0 0 12 6",paths:[{path:"M11.4538 5.44617C11.4538 5.5795 11.4018 5.7055 11.3072 5.7995C11.1125 5.99417 10.7952 5.99417 10.5998 5.7995L5.85385 1.05283L1.10718 5.7995C1.01318 5.89417 0.887179 5.94617 0.753845 5.94617C0.620512 5.94617 0.494512 5.89417 0.400512 5.7995C0.305845 5.7055 0.253845 5.5795 0.253845 5.44617C0.253845 5.31283 0.305845 5.18683 0.400512 5.09283L5.14718 0.346168C5.53651 -0.0431658 6.17051 -0.0438327 6.55985 0.345501L11.3072 5.09283C11.4018 5.18683 11.4538 5.31283 11.4538 5.44617Z",fill:"#2D3339"}]},[Ib.chevronDown]:{viewBox:"0 0 12 6",paths:[{path:"M0.546155 0.553833C0.546155 0.4205 0.598155 0.2945 0.692821 0.2005C0.887488 0.00583301 1.20482 0.00583301 1.40015 0.2005L6.14615 4.94717L10.8928 0.2005C10.9868 0.105833 11.1128 0.053833 11.2462 0.053833C11.3795 0.053833 11.5055 0.105833 11.5995 0.2005C11.6942 0.2945 11.7462 0.4205 11.7462 0.553833C11.7462 0.687166 11.6942 0.813166 11.5995 0.907166L6.85282 5.65383C6.46349 6.04317 5.82949 6.04383 5.44015 5.6545L0.692821 0.907166C0.598155 0.813166 0.546155 0.687166 0.546155 0.553833Z",fill:"#2D3339"}]},[Ib.clock]:{viewBox:"0 0 20 20",paths:[{path:"M10 19.375C4.83083 19.375 0.625 15.1692 0.625 10C0.625 4.83083 4.83083 0.625 10 0.625C15.1692 0.625 19.375 4.83083 19.375 10C19.375 15.1692 15.1692 19.375 10 19.375ZM10 1.875C5.52 1.875 1.875 5.52 1.875 10C1.875 14.48 5.52 18.125 10 18.125C14.48 18.125 18.125 14.48 18.125 10C18.125 5.52 14.48 1.875 10 1.875ZM13.4642 14.3483C13.5817 14.4667 13.7392 14.5317 13.9058 14.5317C14.0725 14.5317 14.23 14.465 14.3483 14.3475C14.4667 14.23 14.5317 14.0725 14.5317 13.9058C14.5317 13.7392 14.4667 13.5825 14.3483 13.4642L10.6258 9.74083V6.875C10.6258 6.53 10.3458 6.25 10.0008 6.25C9.65583 6.25 9.37583 6.53 9.37583 6.875V10C9.37583 10.0733 9.38833 10.145 9.415 10.2167L9.4225 10.2375C9.45417 10.315 9.5 10.3833 9.55833 10.4417L13.4642 14.3483Z",fillRule:"evenodd",clipRule:"evenodd"}]},[Ib.eye]:{viewBox:"0 0 17 16",paths:[{path:"M0.413967 7.04882C-0.138699 7.59 -0.138699 8.40706 0.415301 8.95C2.1373 10.6229 5.00597 12.9994 7.89463 12.9994H7.99063L8.08997 13C10.9886 13 13.8626 10.6235 15.5866 8.94941C16.14 8.40765 16.1393 7.59059 15.5853 7.04765C13.862 5.37529 10.9913 3 8.10597 3C8.06863 3 8.03197 3 8.00397 3.00059C7.96997 3 7.9373 3 7.9033 3C5.00863 3 2.13663 5.37529 0.413967 7.04882ZM4.66695 7.99777C4.66695 6.15987 6.16261 4.66532 8.00051 4.66532C8.89057 4.66532 9.72729 5.01201 10.3562 5.63983C10.9863 6.26876 11.333 7.10549 11.333 7.99888C11.333 8.88894 10.9852 9.72677 10.3562 10.3557C9.72729 10.9846 8.89057 11.3313 7.9994 11.3313C7.10934 11.3313 6.27261 10.9846 5.64257 10.3546C5.01364 9.72566 4.66695 8.88783 4.66695 7.99777Z",fillRule:"evenodd"},"M8 5.99866C6.89733 5.99866 6 6.89532 6 7.99799C6 8.53199 6.208 9.03466 6.58533 9.41199C6.96333 9.78999 7.46533 9.99799 7.99933 9.99799C8.534 9.99799 9.036 9.78999 9.41333 9.41266C9.79067 9.03532 9.99933 8.53266 9.99933 7.99866C9.99933 7.46266 9.79133 6.96066 9.41333 6.58332C9.036 6.20666 8.534 5.99866 8 5.99866V5.99866Z"]},[Ib.pollingStar]:{viewBox:"0 0 32 32",paths:[{path:"M16 32C7.17733 32 0 24.8227 0 16C0 7.17733 7.17733 0 16 0C24.8227 0 32 7.17733 32 16C32 24.8227 24.8227 32 16 32ZM16 2C8.28 2 2 8.28 2 16C2 23.72 8.28 30 16 30C23.72 30 30 23.72 30 16C30 8.28 23.72 2 16 2ZM11.6653 23.0013C11.504 23.0013 11.3413 22.98 11.1826 22.9387C10.6973 22.8107 10.2906 22.5013 10.0386 22.068C9.74397 21.5613 9.70397 20.9373 9.92931 20.3973L11.2573 17.3453L8.88664 15.232C8.50131 14.8533 8.29731 14.3787 8.29464 13.8787C8.29197 13.38 8.48264 12.9093 8.83331 12.5547C9.18264 12.2027 9.67197 12 10.1733 12H12.7146L14.3106 8.63867C14.5533 8.16667 14.948 7.83067 15.428 7.676C15.616 7.616 15.8093 7.58533 16.004 7.58533C16.3013 7.58533 16.6 7.65867 16.8666 7.796C17.216 7.976 17.4973 8.256 17.6786 8.60667C17.6813 8.612 19.2893 12 19.2893 12H21.8266C22.32 12 22.7946 12.1907 23.1386 12.524C23.4973 12.8707 23.7 13.336 23.7093 13.8347C23.7173 14.3427 23.516 14.84 23.1546 15.196L20.7413 17.3453L22.064 20.3853C22.2613 20.856 22.264 21.368 22.0746 21.8333C21.8853 22.2987 21.5266 22.6613 21.0626 22.856C20.832 22.952 20.5893 23 20.3386 23C20.0053 23 19.6786 22.912 19.3933 22.7453L16 20.836L12.5933 22.752C12.316 22.9147 11.9933 23.0013 11.6653 23.0013ZM13.1293 16.3333C13.452 16.6213 13.5533 17.0827 13.3813 17.4787L11.92 20.8373L15.5106 18.8187C15.6613 18.7347 15.8306 18.6907 16.0013 18.6907C16.172 18.6907 16.3413 18.7347 16.4906 18.8187L20.0826 20.8387L18.6213 17.4813C18.448 17.084 18.5493 16.6227 18.8733 16.3347L21.496 14.0013H18.6586C18.2746 14.0013 17.92 13.7773 17.756 13.4307L16.004 9.74L14.2533 13.4307C14.0893 13.7773 13.7346 14.0013 13.3506 14.0013H10.5106L13.1293 16.3333Z",fillRule:"evenodd",fill:"#3587FB"}]},[Ib.check]:{viewBox:"0 0 20 20",paths:[{path:"M8.37395 14.2015C8.07345 14.2015 7.78295 14.11 7.53395 13.937C7.40345 13.8465 7.28945 13.7355 7.19395 13.608L5.27545 11.65C5.21545 11.57 5.18995 11.471 5.20395 11.372C5.21845 11.273 5.27045 11.185 5.35045 11.125C5.41595 11.076 5.49345 11.05 5.57545 11.05C5.69295 11.05 5.80495 11.106 5.87545 11.2L7.79495 13.159C7.84195 13.2225 7.89845 13.277 7.96245 13.3215C8.08494 13.4065 8.22745 13.4515 8.37545 13.4515C8.41845 13.4515 8.46195 13.4475 8.50495 13.44C8.69545 13.406 8.86094 13.2995 8.97145 13.1405L14.1184 5.95999C14.1879 5.85999 14.3029 5.79999 14.4254 5.79999C14.5024 5.79999 14.5769 5.82349 14.6399 5.86749C14.7224 5.92499 14.7769 6.01099 14.7944 6.10949C14.8119 6.20799 14.7899 6.30749 14.7324 6.38999L9.58645 13.5695C9.36195 13.892 9.02445 14.1085 8.63645 14.178C8.54995 14.1935 8.46145 14.2015 8.37395 14.2015Z",stroke:"white"}],rects:[{width:20,height:20,rx:10,fill:"#2DD269"}]},[Ib.question]:{viewBox:"0 0 32 32",paths:[{path:"M6.552 31.8947C6.69067 31.964 6.84533 32 7 32C7.21467 32 7.428 31.9293 7.6 31.8L15.3333 26H29C30.6547 26 32 24.6547 32 23V3C32 1.34533 30.6547 0 29 0H3C1.34533 0 0 1.34533 0 3V23C0 24.6547 1.34533 26 3 26H6V31C6 31.3813 6.212 31.724 6.552 31.8947ZM2 3C2 2.448 2.448 2 3 2H29C29.552 2 30 2.448 30 3V23C30 23.552 29.552 24 29 24H15C14.7853 24 14.572 24.0707 14.4 24.2L8 29V25C8 24.448 7.552 24 7 24H3C2.448 24 2 23.552 2 23V3ZM15.6667 16C15.1147 16 14.6667 15.552 14.6667 15V14.6573C14.6667 13.388 15.4707 12.252 16.6667 11.8293C17.8627 11.4067 18.6667 10.2693 18.6667 9.00133C18.6667 8.2 18.3547 7.44667 17.788 6.88C17.2213 6.31333 16.468 6.00133 15.6667 6.00133C14.8653 6.00133 14.112 6.31333 13.5453 6.88C12.9787 7.44533 12.6667 8.19867 12.6667 9C12.6667 9.55067 12.2187 10 11.6667 10C11.1147 10 10.6667 9.55067 10.6667 9C10.6667 7.664 11.188 6.40933 12.132 5.46533C13.076 4.52133 14.332 4.00133 15.6667 4.00133C17.0027 4.00133 18.2587 4.52133 19.2027 5.46667C20.1467 6.41067 20.6667 7.66667 20.6667 9.00133C20.6667 11.116 19.3267 13.0093 17.3333 13.7147C16.9347 13.856 16.6667 14.2347 16.6667 14.6573V15C16.6667 15.552 16.2187 16 15.6667 16ZM17.1667 19.5C17.1667 20.3284 16.4951 21 15.6667 21C14.8382 21 14.1667 20.3284 14.1667 19.5C14.1667 18.6716 14.8382 18 15.6667 18C16.4951 18 17.1667 18.6716 17.1667 19.5Z",fillRule:"evenodd",fill:"#3587FB"}]},[Ib.ranking]:{viewBox:"0 0 24 24",paths:["M15.94 8a.644.644 0 0 0-.15-.25 4.952 4.952 0 0 0-2.12-1.48c.51-.3.93-.72 1.22-1.24.29-.51.45-1.09.44-1.68s-.16-1.17-.46-1.68c-.3-.51-.72-.93-1.23-1.23-.5-.29-1.08-.44-1.67-.44-.59 0-1.17.16-1.68.45-.51.3-.93.72-1.23 1.23s-.45 1.09-.45 1.68c0 .59.16 1.17.45 1.68.29.51.72.93 1.23 1.23a5.112 5.112 0 0 0-2.13 1.48.702.702 0 0 0-.17.54c0 .1.03.19.08.28.04.09.11.17.18.23.13.12.3.18.48.18.11 0 .22-.02.32-.07a.7.7 0 0 0 .26-.19c.12-.14.25-.28.39-.4.64-.54 1.44-.84 2.28-.84.51 0 1.01.11 1.48.32s.87.53 1.2.92a.7.7 0 0 0 .26.19c.1.04.21.07.32.07.18 0 .35-.06.48-.18.08-.06.14-.14.18-.23a.9.9 0 0 0 .08-.28c0-.1 0-.2-.03-.29Zm-3.25-2.9c-.34.14-.72.18-1.09.11-.36-.07-.7-.25-.96-.52a1.875 1.875 0 0 1-.4-2.05c.14-.34.39-.64.7-.84.31-.21.67-.31 1.05-.31a1.88 1.88 0 0 1 1.87 1.87c0 .37-.11.73-.32 1.04s-.5.55-.84.69Zm10.63 12.02c-.42-.42-.99-.66-1.59-.66h-5.24v-3.74c0-.6-.24-1.17-.66-1.59-.42-.42-.99-.66-1.59-.66h-4.5c-.6 0-1.17.24-1.59.66-.42.42-.66.99-.66 1.59v3.74H2.25c-.6 0-1.17.24-1.59.66-.42.42-.66.99-.66 1.59v4.49c0 .1.02.2.05.29.04.09.09.17.16.24.07.07.15.12.24.16.09.04.19.06.29.05l22.48.05a.75.75 0 0 0 .75-.75V18.7c0-.6-.24-1.17-.66-1.59ZM7.49 22.45H1.5v-3.74a.75.75 0 0 1 .75-.75h5.24v4.49Zm7.49 0H8.99v-9.73a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 .75.75v9.73Zm7.49 0h-5.99v-4.49h5.24a.75.75 0 0 1 .75.75v3.74Z","M23.97 14.72a.939.939 0 0 0-.14-.26c-.57-.67-1.3-1.17-2.13-1.47a3.365 3.365 0 0 0 1.58-3.78c-.19-.72-.61-1.35-1.2-1.8-.59-.45-1.31-.7-2.05-.7s-1.46.24-2.05.7a3.36 3.36 0 0 0-1.2 1.8 3.371 3.371 0 0 0 1.58 3.78.757.757 0 0 0-.32.84c.05.16.14.29.27.39.13.1.29.15.45.15h.22c.32-.1.66-.16 1-.16.51 0 1.01.11 1.47.32.46.21.87.53 1.2.91a.7.7 0 0 0 .26.19c.1.04.21.07.32.07.19 0 .37-.06.51-.19.08-.06.14-.14.18-.23A.9.9 0 0 0 24 15c0-.1 0-.2-.03-.29Zm-3.28-2.89c-.34.14-.72.18-1.09.11-.36-.07-.7-.25-.96-.52a1.875 1.875 0 0 1-.4-2.05c.14-.35.39-.64.7-.84.31-.21.67-.31 1.05-.31.49 0 .96.24 1.3.59.35.34.55.8.56 1.29 0 .37-.11.73-.32 1.04-.21.31-.5.55-.84.69ZM6.91 8.41c-.3-.51-.72-.94-1.23-1.24-.51-.3-1.1-.45-1.69-.45-.59 0-1.18.15-1.69.45-.51.3-.94.72-1.24 1.23S.61 9.5.61 10.09c0 .59.16 1.17.45 1.69.3.51.72.94 1.24 1.24-.82.3-1.54.82-2.1 1.49-.07.07-.12.16-.15.26a.765.765 0 0 0 .21.78.744.744 0 0 0 .82.13c.1-.05.19-.11.26-.19.33-.39.74-.7 1.2-.92.46-.21.97-.32 1.48-.32.34 0 .68.05 1 .16h.22c.16 0 .32-.05.45-.15.13-.1.22-.23.27-.38.05-.16.04-.32-.01-.48a.817.817 0 0 0-.29-.37c.52-.29.95-.72 1.26-1.23s.46-1.1.46-1.7c0-.59-.15-1.18-.45-1.69Zm-1.18 2.4c-.14.34-.39.64-.7.84-.31.21-.67.31-1.05.31-.5 0-.97-.2-1.32-.55-.35-.35-.55-.82-.55-1.32h.01c0-.37.11-.74.31-1.05s.5-.55.84-.7c.34-.14.72-.18 1.09-.11.37.07.7.25.96.51a1.875 1.875 0 0 1 .4 2.05Z"]},[Ib.cross]:{viewBox:"0 0 24 24",paths:[{path:"M19.5 20.25C19.3 20.25 19.111 20.172 18.97 20.03L12 13.061L5.03 20.031C4.888 20.173 4.7 20.251 4.5 20.251C4.3 20.251 4.111 20.173 3.97 20.031C3.678 19.739 3.678 19.263 3.97 18.97L10.94 12L3.97 5.03C3.828 4.889 3.75 4.7 3.75 4.5C3.75 4.3 3.828 4.111 3.97 3.97C4.111 3.828 4.3 3.75 4.5 3.75C4.7 3.75 4.889 3.828 5.03 3.97L12 10.94L18.97 3.97C19.112 3.828 19.3 3.75 19.5 3.75C19.7 3.75 19.889 3.828 20.03 3.97C20.172 4.111 20.25 4.3 20.25 4.5C20.25 4.7 20.172 4.889 20.03 5.03L13.061 12L20.031 18.97C20.323 19.262 20.323 19.738 20.031 20.031C19.889 20.172 19.7 20.25 19.5 20.25Z",fill:"#2D3339"}]},[Ib.expand]:{viewBox:"0 0 24 24",paths:[{fillRule:"evenodd",clipRule:"evenodd",fill:"#2D3339",path:"M9.90039 3.15002C9.90039 2.73581 9.5646 2.40002 9.15039 2.40002H3.15039L3.11058 2.40108L3.03567 2.40879L2.96347 2.42356L2.90114 2.44247L2.81801 2.47748L2.7363 2.5246L2.66432 2.5788L2.6198 2.61995L2.56939 2.67565L2.54492 2.70733L2.49453 2.78593L2.47577 2.82187L2.43969 2.90978L2.41576 2.99826L2.40634 3.05511C2.40241 3.08619 2.40039 3.11787 2.40039 3.15002V9.15002L2.40426 9.22671C2.44267 9.6049 2.76207 9.90002 3.15039 9.90002L3.22707 9.89615C3.60527 9.85774 3.90039 9.53835 3.90039 9.15002V4.96042L7.87006 8.93035L7.93096 8.98503C8.22546 9.22195 8.65735 9.20372 8.93072 8.93035C9.22361 8.63746 9.22361 8.16259 8.93072 7.86969L4.96059 3.89962L9.15039 3.90002L9.22707 3.89615C9.60527 3.85774 9.90039 3.53835 9.90039 3.15002ZM20.8504 2.40002H14.8504L14.7737 2.4039C14.3955 2.4423 14.1004 2.7617 14.1004 3.15002L14.1043 3.22671C14.1427 3.6049 14.4621 3.90002 14.8504 3.90002L19.0396 3.89962L15.0701 7.86969L15.0154 7.93059C14.7785 8.2251 14.7967 8.65699 15.0701 8.93035C15.363 9.22325 15.8378 9.22325 16.1307 8.93035L20.1004 4.95982V9.15002L20.1043 9.22671C20.1427 9.6049 20.4621 9.90002 20.8504 9.90002C21.2646 9.90002 21.6004 9.56424 21.6004 9.15002V3.15002L21.5965 3.07334L21.585 2.99827L21.561 2.90972L21.5332 2.83932L21.5063 2.78594L21.4662 2.72179L21.4203 2.66237L21.381 2.61999L21.3254 2.56958L21.2898 2.54219L21.2305 2.50337L21.1828 2.47748L21.1002 2.44262L21.0373 2.42356L20.9651 2.40879L20.8979 2.40151L20.8504 2.40002ZM14.7737 21.5962L14.8504 21.6H20.8504L20.8979 21.5985L20.9651 21.5913L21.018 21.5812L21.0874 21.5618L21.1589 21.5338L21.2305 21.4967L21.2898 21.4579L21.3248 21.431L21.3807 21.3803C21.4094 21.3517 21.4352 21.3213 21.4583 21.2895L21.4972 21.23L21.525 21.1783L21.5541 21.11L21.5701 21.0619L21.5881 20.9858L21.5982 20.9076L21.6004 20.85V14.85C21.6004 14.4358 21.2646 14.1 20.8504 14.1C20.4621 14.1 20.1427 14.3952 20.1043 14.7733L20.1004 14.85V19.0404L16.1307 15.0697C15.8378 14.7768 15.363 14.7768 15.0701 15.0697C14.7967 15.3431 14.7785 15.775 15.0154 16.0695L15.0701 16.1304L19.0396 20.1H14.8504C14.4621 20.1 14.1427 20.3951 14.1043 20.7733L14.1004 20.85C14.1004 21.2383 14.3955 21.5577 14.7737 21.5962ZM9.90039 20.85C9.90039 21.2642 9.5646 21.6 9.15039 21.6H3.15039L3.07371 21.5962L3.01465 21.5878L2.93856 21.5697L2.89041 21.5537L2.82213 21.5246L2.77038 21.4968L2.71093 21.4579C2.67913 21.4349 2.64872 21.409 2.62008 21.3804L2.56943 21.3244L2.54256 21.2895L2.50374 21.2302L2.46657 21.1585L2.43863 21.0871L2.41918 21.0176L2.40916 20.9647L2.40187 20.8976L2.40039 20.85V14.85L2.40426 14.7733C2.44267 14.3952 2.76207 14.1 3.15039 14.1L3.22707 14.1039C3.60527 14.1423 3.90039 14.4617 3.90039 14.85V19.0398L7.87006 15.0697L7.93096 15.015C8.22546 14.7781 8.65735 14.7963 8.93072 15.0697C9.22361 15.3626 9.22361 15.8375 8.93072 16.1304L4.96059 20.1H9.15039L9.22707 20.1039C9.60527 20.1423 9.90039 20.4617 9.90039 20.85Z"}]},[Ib.settings]:{viewBox:"0 0 16 16",paths:[{fillRule:"evenodd",clipRule:"evenodd",fill:"white",path:"M5.43734 15.992C4.98668 15.992 4.55534 15.8254 4.22268 15.5227C3.82401 15.16 3.60934 14.6427 3.63401 14.104L3.68201 13.168C3.70468 12.7247 3.36268 12.3454 2.91934 12.322L2.91928 12.322C2.9053 12.3214 2.89132 12.3207 2.87801 12.3207C2.86401 12.3207 2.85068 12.3207 2.83668 12.322L1.90268 12.3694C1.87134 12.3707 1.83868 12.372 1.80668 12.372C1.36134 12.372 0.932676 12.2074 0.600676 11.908C0.242676 11.5854 0.0313429 11.1427 0.00600959 10.6607C-0.0226571 10.116 0.193343 9.59402 0.597343 9.22802L1.29201 8.60135C1.45134 8.45735 1.54534 8.25935 1.55668 8.04402C1.56734 7.82869 1.49401 7.62202 1.35001 7.46202C1.33201 7.44202 1.31268 7.42269 1.29201 7.40402L0.597343 6.77335C0.24001 6.44935 0.0306763 6.00602 0.00734292 5.52402C-0.0166571 5.04269 0.149343 4.58069 0.473343 4.22335C0.814676 3.84669 1.30134 3.63069 1.80801 3.63069C1.83734 3.63069 1.86734 3.63135 1.89668 3.63269L2.83134 3.68002C2.84534 3.68135 2.87334 3.68135 2.87334 3.68135C3.30268 3.68135 3.65601 3.34602 3.67868 2.91869C3.68001 2.89069 3.68001 2.86202 3.67868 2.83402L3.63401 1.89669C3.58734 0.901352 4.35868 0.0540189 5.35334 0.00735221C5.38201 0.00601888 5.41068 0.00535221 5.43934 0.00535221C5.94601 0.00535221 6.43201 0.220686 6.77334 0.596019L7.40068 1.28869C7.54534 1.44935 7.74268 1.54335 7.95734 1.55469C7.97201 1.55535 7.98668 1.55602 8.00134 1.55602C8.20201 1.55602 8.38734 1.48469 8.53801 1.34935C8.55868 1.33069 8.57801 1.31135 8.59601 1.29069L9.22934 0.596019C9.55134 0.239352 9.99468 0.0293522 10.4767 0.00468555C10.5073 0.00335221 10.5373 0.00268555 10.5673 0.00268555C11.016 0.00268555 11.4467 0.168019 11.7793 0.468686C12.184 0.834019 12.4 1.35602 12.372 1.90069L12.3247 2.83402C12.3027 3.27735 12.6453 3.65602 13.0887 3.67869C13.1027 3.67935 13.116 3.68002 13.1293 3.68002C13.142 3.68002 13.1547 3.68002 13.1673 3.67935L14.1007 3.63202C14.132 3.63069 14.162 3.63002 14.1927 3.63002C14.6407 3.63002 15.07 3.79602 15.4027 4.09802C15.76 4.42202 15.97 4.86602 15.994 5.34735C16.0207 5.89069 15.8047 6.41135 15.4013 6.77602L14.7067 7.40269C14.5473 7.54669 14.4533 7.74469 14.4427 7.96002C14.4313 8.17535 14.5053 8.38202 14.6493 8.54135C14.668 8.56202 14.6867 8.58135 14.7067 8.59869L15.4013 9.22602C15.7593 9.54935 15.97 9.99269 15.9947 10.4747C16.0193 10.9567 15.8547 11.4194 15.5313 11.7767C15.1893 12.1547 14.7 12.3714 14.188 12.3714C14.1593 12.3714 14.13 12.3707 14.1007 12.3694L13.166 12.322L13.1659 12.322C13.1513 12.3214 13.1367 12.3207 13.122 12.3207C12.9207 12.3207 12.7353 12.3927 12.5847 12.528C12.4247 12.672 12.3307 12.8694 12.32 13.0847C12.3187 13.112 12.3187 13.14 12.32 13.168L12.3673 14.1014C12.3887 14.5847 12.2213 15.0467 11.8953 15.4034C11.5693 15.76 11.1247 15.968 10.6433 15.9894C10.6147 15.9907 10.5847 15.9914 10.5547 15.9914C10.0547 15.9914 9.57201 15.7774 9.23068 15.4047L8.60134 14.7087C8.44868 14.54 8.23068 14.4434 8.00201 14.4434C7.80201 14.4434 7.61068 14.5167 7.46268 14.6507C7.44268 14.6687 7.42268 14.688 7.40468 14.7087L6.77401 15.4034C6.43268 15.7774 5.94534 15.992 5.43734 15.992ZM2.87801 11.3214C2.90868 11.3214 2.93934 11.322 2.97001 11.324C3.96468 11.3754 4.73201 12.226 4.68068 13.22L4.63268 14.1534C4.62201 14.3914 4.71734 14.622 4.89534 14.784C5.04601 14.9214 5.23334 14.9934 5.43668 14.9934H5.43673C5.45005 14.9934 5.4627 14.9934 5.47601 14.9927C5.69068 14.9827 5.88934 14.8894 6.03401 14.73L6.66334 14.0367C6.70334 13.992 6.74668 13.9487 6.79201 13.9074C7.12468 13.6074 7.55401 13.442 8.00201 13.442C8.51268 13.442 9.00134 13.6587 9.34334 14.0367L9.97068 14.7307C10.1213 14.8954 10.3387 14.99 10.568 14.99L10.6007 14.9894C11.0433 14.9694 11.3887 14.592 11.3687 14.148L11.3213 13.218C11.318 13.1567 11.318 13.0947 11.3213 13.0327C11.346 12.5514 11.5567 12.108 11.9147 11.7854C12.2473 11.4854 12.6753 11.32 13.1207 11.32C13.1527 11.32 13.1847 11.3207 13.2173 11.3227L14.15 11.37L14.152 11.3701C14.1673 11.3707 14.182 11.3714 14.196 11.3714C14.42 11.3714 14.636 11.2747 14.7887 11.1054C14.9333 10.9454 15.0067 10.7387 14.996 10.524C14.9853 10.3087 14.8913 10.1114 14.7313 9.96669L14.0367 9.34002C13.9913 9.29935 13.948 9.25602 13.9067 9.21002C13.2393 8.47135 13.2973 7.32669 14.0367 6.65869L14.7313 6.03202C14.9113 5.86935 15.0073 5.63735 14.9953 5.39469C14.9847 5.17935 14.8913 4.98135 14.7313 4.83669C14.5827 4.70202 14.3913 4.62802 14.192 4.62802C14.1786 4.62802 14.1659 4.62863 14.1525 4.62926L14.1525 4.62926L14.1507 4.62935L13.218 4.67669C13.1887 4.67802 13.1587 4.67869 13.1293 4.67869C13.0987 4.67869 13.068 4.67802 13.038 4.67602C12.044 4.62602 11.276 3.77669 11.326 2.78269L11.3733 1.84869C11.386 1.60535 11.2893 1.37269 11.1087 1.21002C10.958 1.07335 10.7733 1.00202 10.574 1.00202C10.5593 1.00202 10.544 1.00269 10.5287 1.00335C10.3127 1.01402 10.1147 1.10802 9.97068 1.26802L9.33868 1.96135C9.29934 2.00535 9.25468 2.05002 9.20801 2.09202C8.87601 2.39135 8.44668 2.55602 7.99868 2.55602C7.96801 2.55602 7.93734 2.55535 7.90668 2.55402C7.42468 2.52869 6.98201 2.31802 6.65934 1.96002L6.03334 1.26802C5.88134 1.10135 5.66401 1.00535 5.43734 1.00535C5.42468 1.00535 5.41201 1.00535 5.39934 1.00602C4.95601 1.02669 4.61201 1.40535 4.63268 1.84935L4.67734 2.78269C4.68068 2.84335 4.68068 2.90735 4.67734 2.97135C4.62668 3.93002 3.83468 4.68135 2.87401 4.68135C2.84268 4.68135 2.81134 4.68069 2.78001 4.67869L1.84734 4.63202C1.83534 4.63135 1.82201 4.63069 1.80934 4.63069C1.58334 4.63069 1.36601 4.72735 1.21401 4.89469C1.06934 5.05402 0.995343 5.26002 1.00601 5.47469C1.01668 5.68935 1.11001 5.88735 1.26934 6.03202L1.96334 6.66202C2.00801 6.70269 2.05134 6.74535 2.09201 6.79135C2.75934 7.53069 2.70134 8.67535 1.96201 9.34269L1.26801 9.96935C1.08801 10.132 0.99201 10.3654 1.00468 10.608C1.01601 10.8227 1.11001 11.0207 1.27001 11.1647C1.41801 11.298 1.60934 11.3714 1.80801 11.3714C1.82201 11.3714 1.83668 11.3714 1.85068 11.37L2.78468 11.3227L2.78659 11.3226C2.81726 11.322 2.84732 11.3214 2.87801 11.3214ZM8.00001 11.5C6.07001 11.5 4.50001 9.93002 4.50001 8.00002C4.50001 6.07002 6.07001 4.50002 8.00001 4.50002C9.93001 4.50002 11.5 6.07002 11.5 8.00002C11.5 9.93002 9.93001 11.5 8.00001 11.5ZM8.00001 5.50002C6.62134 5.50002 5.50001 6.62135 5.50001 8.00002C5.50001 9.37869 6.62134 10.5 8.00001 10.5C9.37868 10.5 10.5 9.37869 10.5 8.00002C10.5 6.62135 9.37868 5.50002 8.00001 5.50002Z"}]},[Ib.silhouette]:{viewBox:"0 0 14 16",paths:[{fillRule:"evenodd",clipRule:"evenodd",fill:"white",path:"M7 8C4.79467 8 3 6.20533 3 4C3 1.79467 4.79467 0 7 0C9.20533 0 11 1.79467 11 4C11 6.20533 9.20533 8 7 8ZM7 1C5.346 1 4 2.346 4 4C4 5.654 5.346 7 7 7C8.654 7 10 5.654 10 4C10 2.346 8.654 1 7 1ZM13 15.5C13 15.776 13.224 16 13.5 16C13.776 16 14 15.776 14 15.5C14 11.64 10.86 8.5 7 8.5C3.14 8.5 0 11.64 0 15.5C0 15.776 0.224 16 0.5 16C0.776 16 1 15.776 1 15.5C1 12.1913 3.69133 9.5 7 9.5C10.3087 9.5 13 12.1913 13 15.5Z"}]}};var Mb=n["default"].extend({props:{name:{type:String,required:!0},ariaLabel:{type:String,default:void 0},color:{type:String,default:void 0}},computed:{contents(){return Ob[this.name]||[]}}}),Nb=Mb,Fb=mi(Nb,Db,Pb,!1,null,null,null,!0),Bb=Fb.exports,$b=n["default"].extend({name:"Avatar",components:{Icon:Bb},props:{userId:{type:String,default:""},userName:{type:String,default:""},questionId:{type:String,default:""},profilePicture:{type:String,default:""},showUserInitials:{type:Boolean,default:!0}},data(){return{profilePic:"",icon:Ib.silhouette}},computed:{avatar(){return Tb(this.userId,this.userName,this.questionId)},color(){return this.avatar.color},initials(){return this.avatar.initials}},watch:{profilePicture:{immediate:!0,handler(){this.setProfilePic()}}},methods:{setProfilePic(){return di(this,void 0,void 0,(function*(){this.profilePic=this.profilePicture&&(yield Rb(this.profilePicture))?this.profilePicture:""}))}}}),Ub=$b,jb=mi(Ub,Sb,Eb,!1,null,null,null,!0),qb=jb.exports,Gb=n["default"].extend({name:"Profile",components:{Avatar:qb},props:{userId:{type:String,default:""},userName:{type:String,default:""},questionId:{type:String,default:""},profilePicture:{type:String,default:""},subtitle:{type:String,default:""},noSubtitle:{type:Boolean,default:!1},showUserInitials:{type:Boolean,default:!0}},methods:{onProfileClick(){this.$emit("click")}}}),Vb=Gb,Hb=mi(Vb,bb,wb,!1,null,null,null,!0),zb=Hb.exports,Kb=n["default"].extend({name:"Viewer",components:{Profile:zb},props:{api:{type:Object,required:!0},viewer:{type:Object,required:!0}},computed:{pid(){return ai(this,"viewer.pid","")},userName(){return ai(this,"viewer.participant","")},subtitle(){return ai(this,"viewer.subtitle","")}},methods:{onViewerClick(){this.api.customAction({pid:this.pid},"sideBarViewers")}}}),Wb=Kb,Yb=mi(Wb,gb,yb,!1,null,null,null,!0),Xb=Yb.exports,Zb=n["default"].extend({name:"Viewers",components:{Viewer:Xb},props:{api:{type:Object,required:!0},labels:{type:Object,default:()=>({})},config:{type:Object,default:()=>({})},isWebinar:{type:Boolean,default:!1}},computed:{viewers(){return ai(this,"config.viewers",[])},hidden(){return ai(this,"config.hidden")}}}),Qb=Zb,Jb=mi(Qb,mb,vb,!1,null,null,null,!0),tw=Jb.exports,ew=function(){var t=this,e=t._self._c;t._self._setupProxy;return t.hidden?t._e():e("div",{staticClass:"smvp-qna"},[t.sorting?e("qna-sorting-picker",{attrs:{options:t.sorting.options,"selected-option":t.sorting.selectedOption,labels:t.labels,"selected-orientation":t.selectedOrientation},on:{"update:selectedOrientation":function(e){t.selectedOrientation=e},"update:selected-orientation":function(e){t.selectedOrientation=e},select:t.onSortBySelected}}):t._e(),t.highlightedQuestion?e("div",{staticClass:"sticky-highlighted-question"},[e("question",{attrs:{api:t.api,question:t.highlightedQuestion,labels:t.labels,theme:t.theme,"show-highlighted":t.showHighlighted,"upvoting-enabled":t.upvotingEnabled,"upvoting-allowed":t.upvotingAllowed},on:{"click-upvote":function(e){return t.onUpvoteClick(t.highlightedQuestion)}}})],1):t._e(),e("section",{ref:"qnaContent",staticClass:"content",class:{empty:!t.questions.length,[`align-${t.align}`]:!0}},[t.questions.length?t._e():e("no-question",{attrs:{labels:t.labels,theme:t.theme,"is-private-qna":t.isPrivateQna}}),e("transition-group",{attrs:{tag:"div",name:"smvp-questions"}},t._l(t.questions,(function(i){return e("div",{key:i.id,staticClass:"questions",class:{"from-bstg":!i.userId}},[e("question",{attrs:{api:t.api,question:i,labels:t.labels,"upvoting-enabled":t.upvotingEnabled,"upvoting-allowed":t.upvotingAllowed,theme:t.theme},on:{"click-upvote":function(e){return t.onUpvoteClick(i)}}})],1)})),0)],1),t.disableSending?t._e():e("footer",[e("input",{directives:[{name:"model",rawName:"v-model",value:t.newQuestion,expression:"newQuestion"}],attrs:{type:"text",maxlength:"300",placeholder:t.labels.inputPlaceholder},domProps:{value:t.newQuestion},on:{input:function(e){e.target.composing||(t.newQuestion=e.target.value)}}}),e("div",{staticClass:"options"},[t.anonymousAllowed?e("label",{staticClass:"checkbox"},[t._v(t._s(t.labels.sendAnonymously)),e("input",{directives:[{name:"model",rawName:"v-model",value:t.sendAnonymously,expression:"sendAnonymously"}],attrs:{type:"checkbox"},domProps:{checked:Array.isArray(t.sendAnonymously)?t._i(t.sendAnonymously,null)>-1:t.sendAnonymously},on:{change:function(e){var i=t.sendAnonymously,s=e.target,n=!!s.checked;if(Array.isArray(i)){var r=null,o=t._i(i,r);s.checked?o<0&&(t.sendAnonymously=i.concat([r])):o>-1&&(t.sendAnonymously=i.slice(0,o).concat(i.slice(o+1)))}else t.sendAnonymously=n}}}),t.sendAnonymously?t._e():e("span",{staticClass:"checkmark",style:{border:"1px solid "+t.theme.borderColor}}),t.sendAnonymously?e("span",{staticClass:"checkmark-anonymous",style:{"background-color":t.theme.btnBackgroundColor}}):t._e()]):t._e(),e("button",{staticClass:"btn",class:{disabled:t.sending||!t.newQuestion||!t.newQuestion.length},style:{"background-color":t.theme.btnBackgroundColor,color:t.theme.btnColor},on:{click:function(e){return t.sendComment()}}},[t._v(t._s(t.labels.send))])]),t.showPostNotification?e("div",{staticClass:"post-notification"},[t._v(t._s(t.isPrivateQna?t.labels.private.postNotification:t.labels.postNotification))]):t._e(),t.showQnaLimitNotification?e("div",{staticClass:"post-notification"},[t._v(t._s(t.qnaLimitMessage))]):t._e()])],1)},iw=[],sw=function(){var t=this,e=t._self._c;t._self._setupProxy;return e("div",{staticClass:"smvp-question",style:t.questionStyles},[t.isHighlighted?e("div",{staticClass:"answering-now"},[e("span",{style:{"background-color":t.theme.btnBackgroundColor,color:t.theme.btnColor}},[t._v(t._s(t.labels.answerNow))])]):t._e(),e("div",{staticClass:"question-header"},[e("profile",{attrs:{"user-id":t.question.userId,"user-name":t.question.userName||t.labels.anonymous,"question-id":t.question.id,"profile-picture":t.question.profilePicture,subtitle:t.subtitle,"show-user-initials":t.showUserInitials},on:{click:function(e){return t.onProfileClick()}}}),t.upvotingEnabled?e("like-button",{attrs:{liked:t.question.upvoted,likes:t.question.upvotes,"read-only":!t.upvotingAllowed},on:{click:t.onLikeButtonClick}}):t._e()],1),e("div",{staticClass:"question-body"},[e("p",{domProps:{innerHTML:t._s(t.question.question)}})])])},nw=[],rw=function(){var t=this,e=t._self._c;t._self._setupProxy;return e("btn",{staticClass:"smvp-like-button",class:t.classes,style:t.cssOverrides,on:{click:function(e){return t.$emit("click")}}},[e("icon",{attrs:{name:"thumb-up"}}),e("span",{staticClass:"smvp-like-count"},[t._v(t._s(t.likes))])],1)},ow=[],aw=function(){var t=this,e=t._self._c;t._self._setupProxy;return e("div",{staticClass:"smvp-btn",attrs:{"aria-label":t.ariaLabel},on:{click:function(e){return t.$emit("click")}}},[t._t("default")],2)},lw=[],cw=n["default"].extend({props:{ariaLabel:{type:String,default:void 0}}}),dw=cw,uw=mi(dw,aw,lw,!1,null,null,null,!0),hw=uw.exports,pw=n["default"].extend({name:"LikeButton",components:{Btn:hw,Icon:Bb},props:{likes:{required:!0,type:Number},liked:{type:Boolean,default:!1},readOnly:{type:Boolean,default:!1},color:{type:String,default:()=>""}},computed:{classes(){return{liked:this.liked,"read-only":this.readOnly}},cssOverrides(){return{"--smvp-upvote-color":this.color}}}}),fw=pw,mw=mi(fw,rw,ow,!1,null,null,null,!0),vw=mw.exports,gw=n["default"].extend({name:"Question",components:{LikeButton:vw,Profile:zb},props:{api:{type:Object,required:!0},labels:{type:Object,default:()=>({})},question:{type:Object,required:!0},showHighlighted:{type:Boolean,default:!1},theme:{type:Object,default:()=>({})},upvotingEnabled:{type:Boolean,default:!1},upvotingAllowed:{type:Boolean,default:!1}},computed:{subtitle(){return this.question.sent||""},questionStyles(){return this.isHighlighted?{}:ai(this,"question.styles",{})},isHighlighted(){return"highlighted"===this.question.status&&this.showHighlighted},showUserInitials(){return ai(this,"question.showUserInitials",!0)}},methods:{onProfileClick(){this.api.customAction({pid:this.question.userId},"questionCLicked")},onLikeButtonClick(){const t=this.question.upvoted?"removeQuestionUpvote":"addQuestionUpvote";this.api.customAction(this.question,t)}}}),yw=gw,bw=mi(yw,sw,nw,!1,null,null,null,!0),ww=bw.exports,Sw=function(){var t=this,e=t._self._c;t._self._setupProxy;return e("div",{staticClass:"smvp-no-questions"},[e("icon",{attrs:{name:t.icon,color:t.theme.btnBackgroundColor}}),e("span",{staticClass:"title"},[t._v(t._s(t.isPrivateQna?t.labels.private.noQuestionTitle:t.labels.noQuestionTitle))]),e("span",{staticClass:"subtitle"},[t._v(t._s(t.isPrivateQna?t.labels.private.askFirst:t.labels.askFirst))])],1)},Ew=[],Tw=n["default"].extend({components:{Icon:Bb},props:{labels:{type:Object,default:()=>({})},theme:{type:Object,default:()=>({})},isPrivateQna:{type:Boolean,default:!1}},data(){return{icon:Ib.question}}}),xw=Tw,Cw=mi(xw,Sw,Ew,!1,null,null,null,!0),_w=Cw.exports,kw=function(){var t=this,e=t._self._c;t._self._setupProxy;return t.options.length>0?e("section",{staticClass:"qna-sorting-picker"},[t.showOrientationToggler?e("div",{staticClass:"orientation-toggler",on:{click:t.toggleOrientation}},[e("div",{staticClass:"orientation-label"},[t._v(t._s(t.orientationLabel))]),e("icon",{attrs:{name:t.upDownIcon}})],1):t._e(),e("dropdown-menu",{staticClass:"smvp-upvote-sortby",attrs:{options:t.options,selected:t.selectedOption},on:{select:t.onSelect}})],1):t._e()},Lw=[],Aw=function(){var t=this,e=t._self._c;t._self._setupProxy;return e("div",{staticClass:"smvp-dropdown-menu"},[e("div",{staticClass:"smvp-label",class:{"smvp-expanded":t.expanded},on:{click:()=>t.expanded=!t.expanded}},[e("span",[t._v(t._s(t.selected.label))]),e("div",{staticClass:"smvp-arrow"},[e("icon",{attrs:{name:t.expanded?"chevron-up":"chevron-down"}})],1)]),e("ul",{directives:[{name:"show",rawName:"v-show",value:t.expanded,expression:"expanded"}],staticClass:"smvp-dropdown-content"},t._l(t.options,(function(i,s){return e("li",{key:s,staticClass:"smvp-dropdown-option",class:{"smvp-dropdown-selected":t.selected&&t.selected.id===i.id},on:{click:()=>t.onOptionSelected(i)}},[t._v(t._s(i.label))])})),0)])},Rw=[],Iw=n["default"].extend({name:"DropdownMenu",components:{Icon:Bb},props:{options:{type:Array,default:()=>[]},selected:{type:Object,default:()=>({})}},data(){return{expanded:!1}},methods:{onOptionSelected(t){this.$emit("select",t.id),this.expanded=!1}}}),Dw=Iw,Pw=mi(Dw,Aw,Rw,!1,null,null,null,!0),Ow=Pw.exports;const Mw={BOTTOM_TO_TOP:"bottomToTop",TOP_TO_BOTTOM:"topToBottom"};var Nw=n["default"].extend({name:"QnaSortingPicker",components:{DropdownMenu:Ow,Icon:Bb},props:{options:{type:Array,required:!0},selectedOption:{type:Object,default:()=>({})},labels:{type:Object,default:()=>({})},selectedOrientation:{type:String,default:()=>null}},data(){var t;return{orientation:null===(t=this.selectedOption)||void 0===t?void 0:t.defaultOrientation,upDownIcon:Ib.upDown}},computed:{showOrientationToggler(){var t;return null===(t=this.selectedOption)||void 0===t?void 0:t.showOrientationToggler},orientationLabel(){var t;if(!this.showOrientationToggler)return null;const e=ai(this,"labels.orientationOptions",{});return null===(t=null===e||void 0===e?void 0:e[this.selectedOption.id])||void 0===t?void 0:t[this.orientation]}},methods:{onSelect(t){const e=this.options.find((e=>e.id===t));e&&(e.showOrientationToggler&&this.setOrientation(e.defaultOrientation),this.$emit("select",t))},toggleOrientation(){const t=this.orientation===Mw.BOTTOM_TO_TOP?Mw.TOP_TO_BOTTOM:Mw.BOTTOM_TO_TOP;this.setOrientation(t)},setOrientation(t){this.orientation=t,this.$emit("update:selected-orientation",this.orientation)}}}),Fw=Nw,Bw=mi(Fw,kw,Lw,!1,null,null,null,!0),$w=Bw.exports;const Uw=2,jw=60,qw=5e3;var Gw=n["default"].extend({name:"Qna",components:{NoQuestion:_w,Question:ww,QnaSortingPicker:$w},props:{api:{type:Object,required:!0},labels:{type:Object,default:()=>({})},config:{type:Object,default:()=>({})},theme:{type:Object,default:()=>({})},isPrivateQna:{type:Boolean,default:()=>!1}},data(){return{newQuestion:"",sendAnonymously:!1,nrQuestionsAllowed:Uw,throttleTime:jw,showQnaLimitNotification:!1,showPostNotification:!1,sending:!1,notificationTimeout:0,throttleInterval:0,timerTicker:0,selectedOrientation:""}},computed:{upvotingEnabled(){return ai(this,"config.upvotingEnabled",!1)},upvotingAllowed(){return ai(this,"config.upvotingAllowed",!1)},sorting(){var t;const e=ai(this,"config.sorting");if(!e)return;const i=ai(this,"labels.sortOptions",{}),s=e.options.map((t=>({defaultOrientation:t.defaultOrientation||Mw.BOTTOM_TO_TOP,label:i[t.id],id:t.id,showOrientationToggler:t.showOrientationToggler||!1}))).filter((t=>t.label&&t.id));return Object.assign(Object.assign({},e),{options:s,selectedOption:null!==(t=s.find((t=>t.id===e.sortBy)))&&void 0!==t?t:s[0]})},align(){return this.orientation===Mw.TOP_TO_BOTTOM?"top":"bottom"},orientation(){var t,e;return this.sorting?(null===(t=this.sorting.selectedOption)||void 0===t?void 0:t.showOrientationToggler)&&this.selectedOrientation?this.selectedOrientation:null===(e=this.sorting.selectedOption)||void 0===e?void 0:e.defaultOrientation:Mw.BOTTOM_TO_TOP},questions(){var t;const e=ai(this,"config.questions",[]),i=this.$refs.qnaContent,s=(null===i||void 0===i?void 0:i.scrollHeight)-(null===i||void 0===i?void 0:i.offsetHeight)===(null===i||void 0===i?void 0:i.scrollTop),n=(null===i||void 0===i?void 0:i.scrollTop)<1&&(null===i||void 0===i?void 0:i.scrollTop)>-1;return this.sorting&&"newest"!==(null===(t=this.sorting)||void 0===t?void 0:t.sortBy)||(this.orientation===Mw.BOTTOM_TO_TOP&&n&&(i.scrollTop=0),this.orientation===Mw.TOP_TO_BOTTOM&&s&&(i.scrollTop=i.scrollHeight),this.orientation!==Mw.TOP_TO_BOTTOM)?e:[...e].reverse()},highlightedQuestion(){return ai(this,"config.highlightedQuestion")},anonymousAllowed(){return ai(this,"config.anonymousAllowed",!1)},hidden(){return ai(this,"config.hidden",!1)},throttleAskingQuestions(){return ai(this,"config.throttleAskingQuestions",!1)},qnaLimitMessage(){return ai(this,"labels.qnaLimitNotification","").replace("{0}",this.throttleTime)},showHighlighted(){return!!this.highlightedQuestion},disableSending(){return ai(this,"config.disableSendingQuestions",!1)}},watch:{throttleAskingQuestions:{immediate:!0,handler(){this.throttleAskingQuestions?this.initThrottling():this.cancelThrottling()}}},beforeDestroy(){this.cancelThrottling(),clearTimeout(this.notificationTimeout)},methods:{sendComment(){if(this.throttleAskingQuestions){if(this.nrQuestionsAllowed<=0)return console.info("[Qna] Too many unmoderated questions, throttling"),this.showQnaLimitNotification=!0,clearTimeout(this.notificationTimeout),void(this.notificationTimeout=setTimeout((()=>this.showQnaLimitNotification=!1),qw));--this.nrQuestionsAllowed}this.sending=!0,this.api.customAction({newQuestion:this.newQuestion,anonymous:this.anonymousAllowed&&this.sendAnonymously,onSuccess:()=>this.onSendingSuccess(),onError:()=>this.onSendingError()},"sideBarQna")},onSendingSuccess(){this.newQuestion="",this.sending=!1,this.throttleAskingQuestions||(this.showPostNotification=!0,clearTimeout(this.notificationTimeout),this.notificationTimeout=setTimeout((()=>this.showPostNotification=!1),qw))},onSendingError(){this.sending=!1},initThrottling(){this.resetThrottling(),this.throttleInterval=setInterval((()=>this.resetThrottling()),1e3*jw)},cancelThrottling(){clearInterval(this.timerTicker),clearInterval(this.throttleInterval)},resetThrottling(){console.log("[Qna] Unthrottling"),this.nrQuestionsAllowed=Uw,this.throttleTime=jw,clearInterval(this.timerTicker),this.timerTicker=setInterval((()=>{this.throttleTime>1&&this.throttleTime--}),1e3)},onSortBySelected(t){this.api.customAction(t,"sideBarQnaSortBy")}}}),Vw=Gw,Hw=mi(Vw,ew,iw,!1,null,null,null,!0),zw=Hw.exports,Kw=function(){var t=this,e=t._self._c;t._self._setupProxy;return e("div",{staticClass:"smvp-sidebar-polls",class:{"smvp-sidebar-polls-is-wordcloud":t.showWordCloud},style:{"--smvp-polls-selected-border-color":t.theme.borderColor}},[t.showWordCloud?e("word-cloud",{key:t.pollId,ref:"wordCloud",attrs:{api:t.api,"poll-id":t.pollId,"character-limit":t.characterLimit,labels:t.labels,"allow-multi-words":t.allowMultiWords,"can-submit-answer":t.canSubmitAnswer,"allow-voting":t.allowVoting,question:t.question,theme:t.theme,results:t.results,"show-results":t.showResults,"word-cloud-config":t.wordCloudConfig,expanded:t.pollId&&t.question&&t.expanded,"prevent-expand":t.preventExpand,"countdown-end-timestamp":t.countdownEndTimestamp,"countdown-duration":t.countdownDuration}}):e("div",{staticClass:"poll-wrapper"},[t.hasVoted?e("div",{staticClass:"thank-you-wrapper"},[e("div",{staticClass:"thank-you-alert"},[e("icon",{attrs:{name:t.checkIcon}}),e("span",[t._v(t._s(t.labels.thankYouForVoting))])],1)]):t._e(),"poll"===t.pollState?e("poll",{key:t.pollId,attrs:{api:t.api,"poll-id":t.pollId,answers:t.answers,labels:t.labels,"answer-limit":t.answerLimit,question:t.question,theme:t.theme,"countdown-end-timestamp":t.countdownEndTimestamp,"countdown-duration":t.countdownDuration}}):t._e(),"voted"===t.pollState?e("voted",{key:t.pollId,attrs:{votes:t.answers,question:t.question}}):t._e(),"results"===t.pollState?e("results",{key:t.pollId,attrs:{question:t.question,results:t.results}}):t._e(),"noPoll"===t.pollState?e("no-poll",{attrs:{labels:t.labels,theme:t.theme,"show-poll-incoming":t.showPollIncoming}}):t._e()],1)],1)},Ww=[],Yw=function(){var t=this,e=t._self._c;t._self._setupProxy;return e("div",{staticClass:"smvp-sidebar-poll-voted"},[e("span",{staticClass:"question"},[t._v(t._s(t.question))]),t._l(t.votes,(function(t,i){return e("poll-answer",{key:i,attrs:{text:t.text,selected:t.selected}})}))],2)},Xw=[],Zw=function(){var t=this,e=t._self._c;t._self._setupProxy;return e("div",{staticClass:"smvp-sidebar-poll-answer",class:{selected:t.selected,disabled:t.disabled},on:{click:function(e){return e.stopPropagation(),t.onClick.apply(null,arguments)}}},[t.showRadioButton?e("input",{attrs:{type:"radio",disabled:t.disabled},domProps:{checked:t.selected}}):t._e(),t.showCheckBox?e("input",{attrs:{type:"checkbox",disabled:t.disabled},domProps:{checked:t.selected}}):t._e(),e("span",{staticClass:"answer"},[t._v(t._s(t.text))])])},Qw=[],Jw=n["default"].extend({name:"Poll",props:{text:{type:String,required:!0},selected:{type:Boolean,default:!1},showRadioButton:{type:Boolean,default:!1},showCheckBox:{type:Boolean,default:!1},disableUnselected:{type:Boolean,default:!1}},computed:{disabled(){return this.disableUnselected&&!this.selected}},methods:{onClick(t){this.disabled||this.$emit("click",t)}}}),tS=Jw,eS=mi(tS,Zw,Qw,!1,null,null,null,!0),iS=eS.exports,sS=n["default"].extend({components:{PollAnswer:iS},props:{question:{type:String,required:!0},votes:{type:Array,required:!0}}}),nS=sS,rS=mi(nS,Yw,Xw,!1,null,null,null,!0),oS=rS.exports,aS=function(){var t=this,e=t._self._c;t._self._setupProxy;return e("div",{staticClass:"smvp-sidebar-poll"},[-1!==t.countdownEndTimestamp?e("pollCountdown",{attrs:{"countdown-end-timestamp":t.countdownEndTimestamp,"countdown-duration":t.countdownDuration,theme:t.theme}}):t._e(),e("section",{staticClass:"content"},[e("span",{staticClass:"question"},[t._v(t._s(t.question))]),t.multipleAnswersAllowed?e("p",{staticClass:"answer-limit-hint"},[t._v(t._s(t.answerLimitHint))]):t._e(),t._l(t.votes,(function(i){return e("poll-answer",{key:i.id,attrs:{text:i.text,selected:i.selected,"show-radio-button":!t.multipleAnswersAllowed,"show-check-box":t.multipleAnswersAllowed,"disable-unselected":t.disableUnselected},on:{click:function(e){return t.onClick(i)}}})}))],2),e("footer",[e("button",{class:{disabled:t.disableSubmit},style:{"background-color":t.theme.btnBackgroundColor,color:t.theme.btnColor},on:{click:t.submit}},[t._v(t._s(t.labels.submit))]),t.showMessage?e("div",{staticClass:"notification"},[t._v(t._s(t.message))]):t._e()])],1)},lS=[],cS=function(){var t=this,e=t._self._c;t._self._setupProxy;return e("div",{staticClass:"smvp-sidebar-poll-countdown",class:{blinking:t.shouldBlink}},[e("div",{staticClass:"smvp-top-border",style:{"background-color":t.theme.btnBackgroundColor,width:t.barWidth+"%"}}),e("div",{staticClass:"smvp-countdown-timer"},[e("div",{staticClass:"smvp-timer-wrapper"},[e("icon",{attrs:{name:t.icon,color:t.theme.btnBackgroundColor}}),e("span",{style:{color:t.theme.btnBackgroundColor}},[t._v(t._s(t.readableTimeLeft))])],1)])])},dS=[],uS=n["default"].extend({components:{Icon:Bb},props:{countdownEndTimestamp:{type:Number,required:!0},countdownDuration:{type:Number,required:!0},theme:{type:Object,default:()=>({})}},data(){return{icon:Ib.clock,timeout:0,timeLeft:0}},computed:{readableTimeLeft(){return this.countdownDuration>=3600?Oy(this.timeLeft):My(this.timeLeft)},shouldBlink(){return this.timeLeft<=5&&this.timeLeft>0},barWidth(){return Math.max(0,Math.min(100,Math.floor(100*this.timeLeft/this.countdownDuration)))}},watch:{countdownEndTimestamp:{handler:function(){this.createTimeout()},immediate:!0}},beforeDestroy(){clearTimeout(this.timeout)},methods:{updateTimeLeft(){const t=Dy();this.timeLeft=Math.max(Math.floor(this.countdownEndTimestamp)-t,0)},createTimeout(){clearTimeout(this.timeout),this.timeout=setTimeout((()=>{this.updateTimeLeft(),this.timeLeft>0&&this.createTimeout()}),1e3)}}}),hS=uS,pS=mi(hS,cS,dS,!1,null,null,null,!0),fS=pS.exports;const mS=3e3;var vS,gS=n["default"].extend({components:{PollAnswer:iS,PollCountdown:fS},props:{api:{type:Object,required:!0},pollId:{type:String,required:!0},question:{type:String,required:!0},countdownEndTimestamp:{type:Number,default:-1},countdownDuration:{type:Number,default:-1},answers:{type:Array,required:!0},labels:{type:Object,default:()=>({})},answerLimit:{type:Number,required:!0},theme:{type:Object,default:()=>({})}},data(){return{votes:[],sending:!1,showMessage:!1,message:"",messageTimeout:0}},computed:{multipleAnswersAllowed(){return this.answerLimit>1},hasSelectedAnAnswer(){return this.selectedAnswers.length>0},reachedMaxAnswers(){return this.selectedAnswers.length===this.answerLimit},disableUnselected(){return this.multipleAnswersAllowed&&this.reachedMaxAnswers},selectedAnswers(){return this.votes.filter((t=>t.selected))},answerLimitHint(){return(this.labels.answerLimitHint||"").replace("{0}",this.answerLimit.toString())},disableSubmit(){return this.sending||!this.hasSelectedAnAnswer}},watch:{answers:{immediate:!0,handler(){this.votes&&this.votes.length||(this.votes=dg(this.answers||{}).map((t=>(t.selected=!1,t))))}}},beforeDestroy(){clearTimeout(this.messageTimeout)},methods:{onClick(t){const e=!t.selected;this.multipleAnswersAllowed||this.votes.forEach((t=>t.selected=!1)),t.selected=e},submit(){this.sending=!0,this.api.customAction({pollId:this.pollId,answers:this.selectedAnswers.map((t=>t.id)),onError:t=>this.onSendingError(t)},"sideBarPolls")},onSendingError(t){this.sending=!1,this.displayNewMessage(t||this.labels.anErrorOccurred)},displayNewMessage(t){t&&(clearTimeout(this.messageTimeout),this.message=t,this.showMessage=!0,this.messageTimeout=setTimeout((()=>this.showMessage=!1),mS))}}}),yS=gS,bS=mi(yS,aS,lS,!1,null,null,null,!0),wS=bS.exports,SS=function(){var t=this,e=t._self._c;t._self._setupProxy;return e("div",{staticClass:"smvp-sidebar-poll-results"},[e("span",{staticClass:"question"},[t._v(t._s(t.question))]),t._l(t.results,(function(t,i){return e("result-answer",{key:i,attrs:{correct:t.correct,selected:t.selected,text:t.text,percentage:t.percentage}})}))],2)},ES=[],TS=function(){var t=this,e=t._self._c;t._self._setupProxy;return e("div",{staticClass:"smvp-sidebar-poll-result-answer",class:{correct:t.correct,selected:t.selected}},[e("span",{staticClass:"answer"},[t._v(t._s(t.text))]),e("div",{staticClass:"gauge-wrapper"},[e("div",{staticClass:"gauge-bar"},[e("div",{staticClass:"gauge-background",class:{correct:t.correct}}),e("div",{staticClass:"gauge-foreground",class:{correct:t.correct},style:{width:t.percent+"%"}})]),e("span",{staticClass:"gauge-value"},[t._v(t._s(t.percentageText))])])])},xS=[],CS=n["default"].extend({props:{text:{type:String,required:!0},selected:{type:Boolean,default:!1},correct:{type:Boolean,default:!1},percentage:{type:Number,default:100}},computed:{percent(){return Math.max(Math.min(100,this.percentage),0)},percentageText(){return this.percent.toFixed(2)+"%"}}}),_S=CS,kS=mi(_S,TS,xS,!1,null,null,null,!0),LS=kS.exports,AS=n["default"].extend({components:{ResultAnswer:LS},props:{question:{type:String,required:!0},results:{type:Array,default:()=>[]},labels:{type:Object,default:()=>({})}}}),RS=AS,IS=mi(RS,SS,ES,!1,null,null,null,!0),DS=IS.exports,PS=function(){var t=this,e=t._self._c;t._self._setupProxy;return e("div",{staticClass:"smvp-sidebar-nopoll"},[e("icon",{attrs:{name:t.icon,color:t.theme.btnBackgroundColor}}),e("span",{staticClass:"title"},[t._v(t._s(t.showPollIncoming?t.labels.pollIncomingTitle:t.labels.noPollTitle))]),e("span",{staticClass:"subtitle"},[t._v(t._s(t.showPollIncoming?t.labels.pollIncomingSubtitle:t.labels.noPollSubtitle))])],1)},OS=[],MS=n["default"].extend({components:{Icon:Bb},props:{labels:{type:Object,default:()=>({})},theme:{type:Object,default:()=>({})},showPollIncoming:{type:Boolean,default:!1}},data(){return{icon:Ib.pollingStar}}}),NS=MS,FS=mi(NS,PS,OS,!1,null,null,null,!0),BS=FS.exports,$S=function(){var t=this,e=t._self._c;t._self._setupProxy;return e("div",{staticClass:"smvp-sidebar-word-cloud"},[-1!==t.countdownEndTimestamp?e("pollCountdown",{attrs:{"countdown-end-timestamp":t.countdownEndTimestamp,"countdown-duration":t.countdownDuration,theme:t.theme}}):t._e(),e("section",{staticClass:"content"},[e("span",{staticClass:"question",class:{empty:!t.words.length}},[e("span",{staticClass:"question-text"},[t._v(t._s(t.question))]),t.expanded?e("button",{staticClass:"btn btn-collapse",style:{"background-color":t.theme.btnBackgroundColor},on:{click:t.collapseSidebar}},[e("icon",{attrs:{name:"cross",color:t.theme.btnColor}})],1):t._e()]),t.words.length?e("div",{staticClass:"word-cloud-wrapper"},[e("word-cloud",{attrs:{words:t.words,config:t.wordCloudConfig}})],1):t._e(),t.showExpandButton?e("button",{staticClass:"btn button-icon smvp-expand-sidebar-button",on:{click:function(e){return t.expandSidebar()}}},[e("span",[t._v(t._s(t.labels.expandSidebar))]),e("icon",{attrs:{name:"expand"}})],1):t._e()]),t.allowVoting?e("footer",[e("input",{directives:[{name:"model",rawName:"v-model",value:t.answer,expression:"answer"}],attrs:{type:"text",maxlength:t.characterLimit?t.characterLimit:1/0,placeholder:t.labels.inputPlaceholder},domProps:{value:t.answer},on:{input:function(e){e.target.composing||(t.answer=e.target.value)}}}),e("div",{staticClass:"options"},[t.characterLimit?e("div",{staticClass:"char-count"},[e("span",[t._v(t._s(t.answer.length+" / "+t.characterLimit))])]):t._e(),e("button",{staticClass:"btn",class:{disabled:t.disableSubmit},style:{"background-color":t.theme.btnBackgroundColor,color:t.theme.btnColor},on:{click:function(e){return t.sendAnswer()}}},[t._v(t._s(t.labels.send))])]),t.showMessage?e("div",{staticClass:"notification"},[t._v(t._s(t.message))]):t._e()]):t._e()],1)},US=[],jS=function(){var t=this,e=t._self._c;t._self._setupProxy;return e("div",{staticClass:"smvp-word-cloud-wrapper"},[t.currentWords&&t.currentWords.length>0?e("word-cloud-svg",{ref:"canvas",attrs:{width:t.width,height:t.height,viewBox:`0 0 ${t.width} ${t.height}`,words:t.currentWords,config:t.preparedConfig,rpx:t.rpx}}):e("div",{staticClass:"smvp-word-cloud-empty"},[e("div",{staticClass:"smvp-word-cloud-empty-text"},[t._v(t._s(t.preparedConfig.labels.wordCloudEmpty||"No words yet"))])])],1)},qS=[];(function(t){t["Compact"]="compact",t["Expanded"]="expanded",t["Display"]="display"})(vS||(vS={}));const GS={[vS.Display]:{SIZE_RANGE:[24,48],RECT_PADDING:{X:8,Y:4},LAYOUT_PADDING:7,FONT_SCALE_EXPONENT:1.5,MAX_WORDS:60,ROTATE_ACCESSOR:0,SPIRAL:"archimedean",WIDTH_TRANSFORMER:t=>t},[vS.Compact]:{SIZE_RANGE:[9,18],RECT_PADDING:{X:4,Y:4},LAYOUT_PADDING:9,FONT_SCALE_EXPONENT:1,MAX_WORDS:25,ROTATE_ACCESSOR:()=>90*~~(3*Math.random()-1),SPIRAL:"rectangular",WIDTH_TRANSFORMER:t=>1.5*t},[vS.Expanded]:{SIZE_RANGE:[9,18],RECT_PADDING:{X:4,Y:4},LAYOUT_PADDING:6,FONT_SCALE_EXPONENT:1,MAX_WORDS:40,ROTATE_ACCESSOR:()=>90*~~(3*Math.random()-1),SPIRAL:"archimedean",WIDTH_TRANSFORMER:t=>t}},VS=400,HS=6e3;var zS="__lodash_hash_undefined__";function KS(t){return this.__data__.set(t,zS),this}var WS=KS;function YS(t){return this.__data__.has(t)}var XS=YS;function ZS(t){var e=-1,i=null==t?0:t.length;this.__data__=new Pe;while(++e<i)this.add(t[e])}ZS.prototype.add=ZS.prototype.push=WS,ZS.prototype.has=XS;var QS=ZS;function JS(t,e){var i=-1,s=null==t?0:t.length;while(++i<s)if(e(t[i],i,t))return!0;return!1}var tE=JS;function eE(t,e){return t.has(e)}var iE=eE,sE=1,nE=2;function rE(t,e,i,s,n,r){var o=i&sE,a=t.length,l=e.length;if(a!=l&&!(o&&l>a))return!1;var c=r.get(t),d=r.get(e);if(c&&d)return c==e&&d==t;var u=-1,h=!0,p=i&nE?new QS:void 0;r.set(t,e),r.set(e,t);while(++u<a){var f=t[u],m=e[u];if(s)var v=o?s(m,f,u,e,t,r):s(f,m,u,t,e,r);if(void 0!==v){if(v)continue;h=!1;break}if(p){if(!tE(e,(function(t,e){if(!iE(p,e)&&(f===t||n(f,t,i,s,r)))return p.push(e)}))){h=!1;break}}else if(f!==m&&!n(f,m,i,s,r)){h=!1;break}}return r["delete"](t),r["delete"](e),h}var oE=rE;function aE(t){var e=-1,i=Array(t.size);return t.forEach((function(t,s){i[++e]=[s,t]})),i}var lE=aE;function cE(t){var e=-1,i=Array(t.size);return t.forEach((function(t){i[++e]=t})),i}var dE=cE,uE=1,hE=2,pE="[object Boolean]",fE="[object Date]",mE="[object Error]",vE="[object Map]",gE="[object Number]",yE="[object RegExp]",bE="[object Set]",wE="[object String]",SE="[object Symbol]",EE="[object ArrayBuffer]",TE="[object DataView]",xE=I?I.prototype:void 0,CE=xE?xE.valueOf:void 0;function _E(t,e,i,s,n,r,o){switch(i){case TE:if(t.byteLength!=e.byteLength||t.byteOffset!=e.byteOffset)return!1;t=t.buffer,e=e.buffer;case EE:return!(t.byteLength!=e.byteLength||!r(new Im(t),new Im(e)));case pE:case fE:case gE:return ee(+t,+e);case mE:return t.name==e.name&&t.message==e.message;case yE:case wE:return t==e+"";case vE:var a=lE;case bE:var l=s&uE;if(a||(a=dE),t.size!=e.size&&!l)return!1;var c=o.get(t);if(c)return c==e;s|=hE,o.set(t,e);var d=oE(a(t),a(e),s,n,r,o);return o["delete"](t),d;case SE:if(CE)return CE.call(t)==CE.call(e)}return!1}var kE=_E,LE=1,AE=Object.prototype,RE=AE.hasOwnProperty;function IE(t,e,i,s,n,r){var o=i&LE,a=im(t),l=a.length,c=im(e),d=c.length;if(l!=d&&!o)return!1;var u=l;while(u--){var h=a[u];if(!(o?h in e:RE.call(e,h)))return!1}var p=r.get(t),f=r.get(e);if(p&&f)return p==e&&f==t;var m=!0;r.set(t,e),r.set(e,t);var v=o;while(++u<l){h=a[u];var g=t[h],y=e[h];if(s)var b=o?s(y,g,h,e,t,r):s(g,y,h,t,e,r);if(!(void 0===b?g===y||n(g,y,i,s,r):b)){m=!1;break}v||(v="constructor"==h)}if(m&&!v){var w=t.constructor,S=e.constructor;w==S||!("constructor"in t)||!("constructor"in e)||"function"==typeof w&&w instanceof w&&"function"==typeof S&&S instanceof S||(m=!1)}return r["delete"](t),r["delete"](e),m}var DE=IE,PE=1,OE="[object Arguments]",ME="[object Array]",NE="[object Object]",FE=Object.prototype,BE=FE.hasOwnProperty;function $E(t,e,i,s,n,r){var o=x(t),a=x(e),l=o?ME:Cm(t),c=a?ME:Cm(e);l=l==OE?NE:l,c=c==OE?NE:c;var d=l==NE,u=c==NE,h=l==c;if(h&&tp(t)){if(!tp(e))return!1;o=!0,d=!1}if(h&&!d)return r||(r=new Th),o||Hp(t)?oE(t,e,i,s,n,r):kE(t,e,l,i,s,n,r);if(!(i&PE)){var p=d&&BE.call(t,"__wrapped__"),f=u&&BE.call(e,"__wrapped__");if(p||f){var m=p?t.value():t,v=f?e.value():e;return r||(r=new Th),n(m,v,i,s,r)}}return!!h&&(r||(r=new Th),DE(t,e,i,s,n,r))}var UE=$E;function jE(t,e,i,s,n){return t===e||(null==t||null==e||!W(t)&&!W(e)?t!==t&&e!==e:UE(t,e,i,s,jE,n))}var qE=jE;function GE(t,e){return qE(t,e)}var VE=GE,HE=function(){return A.Date.now()},zE=HE,KE=/\s/;function WE(t){var e=t.length;while(e--&&KE.test(t.charAt(e)));return e}var YE=WE,XE=/^\s+/;function ZE(t){return t?t.slice(0,YE(t)+1).replace(XE,""):t}var QE=ZE,JE=NaN,tT=/^[-+]0x[0-9a-f]+$/i,eT=/^0b[01]+$/i,iT=/^0o[0-7]+$/i,sT=parseInt;function nT(t){if("number"==typeof t)return t;if(Z(t))return JE;if(st(t)){var e="function"==typeof t.valueOf?t.valueOf():t;t=st(e)?e+"":e}if("string"!=typeof t)return 0===t?t:+t;t=QE(t);var i=eT.test(t);return i||iT.test(t)?sT(t.slice(2),i?2:8):tT.test(t)?JE:+t}var rT=nT,oT="Expected a function",aT=Math.max,lT=Math.min;function cT(t,e,i){var s,n,r,o,a,l,c=0,d=!1,u=!1,h=!0;if("function"!=typeof t)throw new TypeError(oT);function p(e){var i=s,r=n;return s=n=void 0,c=e,o=t.apply(r,i),o}function f(t){return c=t,a=setTimeout(g,e),d?p(t):o}function m(t){var i=t-l,s=t-c,n=e-i;return u?lT(n,r-s):n}function v(t){var i=t-l,s=t-c;return void 0===l||i>=e||i<0||u&&s>=r}function g(){var t=zE();if(v(t))return y(t);a=setTimeout(g,m(t))}function y(t){return a=void 0,h&&s?p(t):(s=n=void 0,o)}function b(){void 0!==a&&clearTimeout(a),c=0,s=l=n=a=void 0}function w(){return void 0===a?o:y(zE())}function S(){var t=zE(),i=v(t);if(s=arguments,n=this,l=t,i){if(void 0===a)return f(l);if(u)return clearTimeout(a),a=setTimeout(g,e),p(l)}return void 0===a&&(a=setTimeout(g,e)),o}return e=rT(e)||0,st(i)&&(d=!!i.leading,u="maxWait"in i,r=u?aT(rT(i.maxWait)||0,e):r,h="trailing"in i?!!i.trailing:h),S.cancel=b,S.flush=w,S}var dT=cT,uT="Expected a function";function hT(t,e,i){var s=!0,n=!0;if("function"!=typeof t)throw new TypeError(uT);return st(i)&&(s="leading"in i?!!i.leading:s,n="trailing"in i?!!i.trailing:n),dT(t,e,{leading:s,maxWait:e,trailing:n})}var pT=hT,fT=function(){var t=this,e=t._self._c;t._self._setupProxy;return e("svg",{staticClass:"smvp-word-cloud",style:{width:`${t.width}px`,height:`${t.height}px`},attrs:{width:t.width,height:t.height,viewBox:`0 0 ${t.width} ${t.height}`}},[e("g",{staticClass:"smvp-word-cloud-inner-wrapper",attrs:{transform:`translate(${t.innerCenter.x}, ${t.innerCenter.y})`}},t._l(t.items,(function(i){return e("g",{key:i.id,staticClass:"smvp-word-cloud-group",attrs:{id:i.id,transform:`translate(${i.x||0}, ${i.y||0}) rotate(${i.rotate||0})`}},[e("text",{staticClass:"smvp-word-cloud-text",attrs:{"font-family":t.config.font.family,"font-weight":t.config.font.weight,"font-size":t.fontSizeScale(i.votes),fill:t.color(i),"text-anchor":"middle","dominant-baseline":"middle"}},[t._v(t._s(i.text))]),e("rect",{staticClass:"smvp-word-cloud-rect",attrs:{x:i.rectX||(t.getTextBounds(i)||{}).x,y:i.rectY||(t.getTextBounds(i)||{}).y,rx:t.layoutSet.RECT_PADDING.Y,ry:t.layoutSet.RECT_PADDING.Y,width:i.rectWidth||t.getRectWidth(i,(t.getTextBounds(i)||{}).width),height:i.rectHeight||t.getRectHeight((t.getTextBounds(i)||{}).height),"fill-opacity":"0.2","stroke-opacity":"0.4","stroke-width":"0",fill:t.color(i)}})])})),0)])},mT=[];function vT(){}function gT(t){return null==t?vT:function(){return this.querySelector(t)}}function yT(t){"function"!==typeof t&&(t=gT(t));for(var e=this._groups,i=e.length,s=new Array(i),n=0;n<i;++n)for(var r,o,a=e[n],l=a.length,c=s[n]=new Array(l),d=0;d<l;++d)(r=a[d])&&(o=t.call(r,r.__data__,d,a))&&("__data__"in r&&(o.__data__=r.__data__),c[d]=o);return new hC(s,this._parents)}function bT(t){return null==t?[]:Array.isArray(t)?t:Array.from(t)}function wT(){return[]}function ST(t){return null==t?wT:function(){return this.querySelectorAll(t)}}function ET(t){return function(){return bT(t.apply(this,arguments))}}function TT(t){t="function"===typeof t?ET(t):ST(t);for(var e=this._groups,i=e.length,s=[],n=[],r=0;r<i;++r)for(var o,a=e[r],l=a.length,c=0;c<l;++c)(o=a[c])&&(s.push(t.call(o,o.__data__,c,a)),n.push(o));return new hC(s,n)}function xT(t){return function(){return this.matches(t)}}function CT(t){return function(e){return e.matches(t)}}var _T=Array.prototype.find;function kT(t){return function(){return _T.call(this.children,t)}}function LT(){return this.firstElementChild}function AT(t){return this.select(null==t?LT:kT("function"===typeof t?t:CT(t)))}var RT=Array.prototype.filter;function IT(){return Array.from(this.children)}function DT(t){return function(){return RT.call(this.children,t)}}function PT(t){return this.selectAll(null==t?IT:DT("function"===typeof t?t:CT(t)))}function OT(t){"function"!==typeof t&&(t=xT(t));for(var e=this._groups,i=e.length,s=new Array(i),n=0;n<i;++n)for(var r,o=e[n],a=o.length,l=s[n]=[],c=0;c<a;++c)(r=o[c])&&t.call(r,r.__data__,c,o)&&l.push(r);return new hC(s,this._parents)}function MT(t){return new Array(t.length)}function NT(){return new hC(this._enter||this._groups.map(MT),this._parents)}function FT(t,e){this.ownerDocument=t.ownerDocument,this.namespaceURI=t.namespaceURI,this._next=null,this._parent=t,this.__data__=e}function BT(t){return function(){return t}}function $T(t,e,i,s,n,r){for(var o,a=0,l=e.length,c=r.length;a<c;++a)(o=e[a])?(o.__data__=r[a],s[a]=o):i[a]=new FT(t,r[a]);for(;a<l;++a)(o=e[a])&&(n[a]=o)}function UT(t,e,i,s,n,r,o){var a,l,c,d=new Map,u=e.length,h=r.length,p=new Array(u);for(a=0;a<u;++a)(l=e[a])&&(p[a]=c=o.call(l,l.__data__,a,e)+"",d.has(c)?n[a]=l:d.set(c,l));for(a=0;a<h;++a)c=o.call(t,r[a],a,r)+"",(l=d.get(c))?(s[a]=l,l.__data__=r[a],d.delete(c)):i[a]=new FT(t,r[a]);for(a=0;a<u;++a)(l=e[a])&&d.get(p[a])===l&&(n[a]=l)}function jT(t){return t.__data__}function qT(t,e){if(!arguments.length)return Array.from(this,jT);var i=e?UT:$T,s=this._parents,n=this._groups;"function"!==typeof t&&(t=BT(t));for(var r=n.length,o=new Array(r),a=new Array(r),l=new Array(r),c=0;c<r;++c){var d=s[c],u=n[c],h=u.length,p=GT(t.call(d,d&&d.__data__,c,s)),f=p.length,m=a[c]=new Array(f),v=o[c]=new Array(f),g=l[c]=new Array(h);i(d,u,m,v,g,p,e);for(var y,b,w=0,S=0;w<f;++w)if(y=m[w]){w>=S&&(S=w+1);while(!(b=v[S])&&++S<f);y._next=b||null}}return o=new hC(o,s),o._enter=a,o._exit=l,o}function GT(t){return"object"===typeof t&&"length"in t?t:Array.from(t)}function VT(){return new hC(this._exit||this._groups.map(MT),this._parents)}function HT(t,e,i){var s=this.enter(),n=this,r=this.exit();return"function"===typeof t?(s=t(s),s&&(s=s.selection())):s=s.append(t+""),null!=e&&(n=e(n),n&&(n=n.selection())),null==i?r.remove():i(r),s&&n?s.merge(n).order():n}function zT(t){for(var e=t.selection?t.selection():t,i=this._groups,s=e._groups,n=i.length,r=s.length,o=Math.min(n,r),a=new Array(n),l=0;l<o;++l)for(var c,d=i[l],u=s[l],h=d.length,p=a[l]=new Array(h),f=0;f<h;++f)(c=d[f]||u[f])&&(p[f]=c);for(;l<n;++l)a[l]=i[l];return new hC(a,this._parents)}function KT(){for(var t=this._groups,e=-1,i=t.length;++e<i;)for(var s,n=t[e],r=n.length-1,o=n[r];--r>=0;)(s=n[r])&&(o&&4^s.compareDocumentPosition(o)&&o.parentNode.insertBefore(s,o),o=s);return this}function WT(t){function e(e,i){return e&&i?t(e.__data__,i.__data__):!e-!i}t||(t=YT);for(var i=this._groups,s=i.length,n=new Array(s),r=0;r<s;++r){for(var o,a=i[r],l=a.length,c=n[r]=new Array(l),d=0;d<l;++d)(o=a[d])&&(c[d]=o);c.sort(e)}return new hC(n,this._parents).order()}function YT(t,e){return t<e?-1:t>e?1:t>=e?0:NaN}function XT(){var t=arguments[0];return arguments[0]=this,t.apply(null,arguments),this}function ZT(){return Array.from(this)}function QT(){for(var t=this._groups,e=0,i=t.length;e<i;++e)for(var s=t[e],n=0,r=s.length;n<r;++n){var o=s[n];if(o)return o}return null}function JT(){let t=0;for(const e of this)++t;return t}function tx(){return!this.node()}function ex(t){for(var e=this._groups,i=0,s=e.length;i<s;++i)for(var n,r=e[i],o=0,a=r.length;o<a;++o)(n=r[o])&&t.call(n,n.__data__,o,r);return this}FT.prototype={constructor:FT,appendChild:function(t){return this._parent.insertBefore(t,this._next)},insertBefore:function(t,e){return this._parent.insertBefore(t,e)},querySelector:function(t){return this._parent.querySelector(t)},querySelectorAll:function(t){return this._parent.querySelectorAll(t)}};var ix="http://www.w3.org/1999/xhtml",sx={svg:"http://www.w3.org/2000/svg",xhtml:ix,xlink:"http://www.w3.org/1999/xlink",xml:"http://www.w3.org/XML/1998/namespace",xmlns:"http://www.w3.org/2000/xmlns/"};function nx(t){var e=t+="",i=e.indexOf(":");return i>=0&&"xmlns"!==(e=t.slice(0,i))&&(t=t.slice(i+1)),sx.hasOwnProperty(e)?{space:sx[e],local:t}:t}function rx(t){return function(){this.removeAttribute(t)}}function ox(t){return function(){this.removeAttributeNS(t.space,t.local)}}function ax(t,e){return function(){this.setAttribute(t,e)}}function lx(t,e){return function(){this.setAttributeNS(t.space,t.local,e)}}function cx(t,e){return function(){var i=e.apply(this,arguments);null==i?this.removeAttribute(t):this.setAttribute(t,i)}}function dx(t,e){return function(){var i=e.apply(this,arguments);null==i?this.removeAttributeNS(t.space,t.local):this.setAttributeNS(t.space,t.local,i)}}function ux(t,e){var i=nx(t);if(arguments.length<2){var s=this.node();return i.local?s.getAttributeNS(i.space,i.local):s.getAttribute(i)}return this.each((null==e?i.local?ox:rx:"function"===typeof e?i.local?dx:cx:i.local?lx:ax)(i,e))}function hx(t){return t.ownerDocument&&t.ownerDocument.defaultView||t.document&&t||t.defaultView}function px(t){return function(){this.style.removeProperty(t)}}function fx(t,e,i){return function(){this.style.setProperty(t,e,i)}}function mx(t,e,i){return function(){var s=e.apply(this,arguments);null==s?this.style.removeProperty(t):this.style.setProperty(t,s,i)}}function vx(t,e,i){return arguments.length>1?this.each((null==e?px:"function"===typeof e?mx:fx)(t,e,null==i?"":i)):gx(this.node(),t)}function gx(t,e){return t.style.getPropertyValue(e)||hx(t).getComputedStyle(t,null).getPropertyValue(e)}function yx(t){return function(){delete this[t]}}function bx(t,e){return function(){this[t]=e}}function wx(t,e){return function(){var i=e.apply(this,arguments);null==i?delete this[t]:this[t]=i}}function Sx(t,e){return arguments.length>1?this.each((null==e?yx:"function"===typeof e?wx:bx)(t,e)):this.node()[t]}function Ex(t){return t.trim().split(/^|\s+/)}function Tx(t){return t.classList||new xx(t)}function xx(t){this._node=t,this._names=Ex(t.getAttribute("class")||"")}function Cx(t,e){var i=Tx(t),s=-1,n=e.length;while(++s<n)i.add(e[s])}function _x(t,e){var i=Tx(t),s=-1,n=e.length;while(++s<n)i.remove(e[s])}function kx(t){return function(){Cx(this,t)}}function Lx(t){return function(){_x(this,t)}}function Ax(t,e){return function(){(e.apply(this,arguments)?Cx:_x)(this,t)}}function Rx(t,e){var i=Ex(t+"");if(arguments.length<2){var s=Tx(this.node()),n=-1,r=i.length;while(++n<r)if(!s.contains(i[n]))return!1;return!0}return this.each(("function"===typeof e?Ax:e?kx:Lx)(i,e))}function Ix(){this.textContent=""}function Dx(t){return function(){this.textContent=t}}function Px(t){return function(){var e=t.apply(this,arguments);this.textContent=null==e?"":e}}function Ox(t){return arguments.length?this.each(null==t?Ix:("function"===typeof t?Px:Dx)(t)):this.node().textContent}function Mx(){this.innerHTML=""}function Nx(t){return function(){this.innerHTML=t}}function Fx(t){return function(){var e=t.apply(this,arguments);this.innerHTML=null==e?"":e}}function Bx(t){return arguments.length?this.each(null==t?Mx:("function"===typeof t?Fx:Nx)(t)):this.node().innerHTML}function $x(){this.nextSibling&&this.parentNode.appendChild(this)}function Ux(){return this.each($x)}function jx(){this.previousSibling&&this.parentNode.insertBefore(this,this.parentNode.firstChild)}function qx(){return this.each(jx)}function Gx(t){return function(){var e=this.ownerDocument,i=this.namespaceURI;return i===ix&&e.documentElement.namespaceURI===ix?e.createElement(t):e.createElementNS(i,t)}}function Vx(t){return function(){return this.ownerDocument.createElementNS(t.space,t.local)}}function Hx(t){var e=nx(t);return(e.local?Vx:Gx)(e)}function zx(t){var e="function"===typeof t?t:Hx(t);return this.select((function(){return this.appendChild(e.apply(this,arguments))}))}function Kx(){return null}function Wx(t,e){var i="function"===typeof t?t:Hx(t),s=null==e?Kx:"function"===typeof e?e:gT(e);return this.select((function(){return this.insertBefore(i.apply(this,arguments),s.apply(this,arguments)||null)}))}function Yx(){var t=this.parentNode;t&&t.removeChild(this)}function Xx(){return this.each(Yx)}function Zx(){var t=this.cloneNode(!1),e=this.parentNode;return e?e.insertBefore(t,this.nextSibling):t}function Qx(){var t=this.cloneNode(!0),e=this.parentNode;return e?e.insertBefore(t,this.nextSibling):t}function Jx(t){return this.select(t?Qx:Zx)}function tC(t){return arguments.length?this.property("__data__",t):this.node().__data__}function eC(t){return function(e){t.call(this,e,this.__data__)}}function iC(t){return t.trim().split(/^|\s+/).map((function(t){var e="",i=t.indexOf(".");return i>=0&&(e=t.slice(i+1),t=t.slice(0,i)),{type:t,name:e}}))}function sC(t){return function(){var e=this.__on;if(e){for(var i,s=0,n=-1,r=e.length;s<r;++s)i=e[s],t.type&&i.type!==t.type||i.name!==t.name?e[++n]=i:this.removeEventListener(i.type,i.listener,i.options);++n?e.length=n:delete this.__on}}}function nC(t,e,i){return function(){var s,n=this.__on,r=eC(e);if(n)for(var o=0,a=n.length;o<a;++o)if((s=n[o]).type===t.type&&s.name===t.name)return this.removeEventListener(s.type,s.listener,s.options),this.addEventListener(s.type,s.listener=r,s.options=i),void(s.value=e);this.addEventListener(t.type,r,i),s={type:t.type,name:t.name,value:e,listener:r,options:i},n?n.push(s):this.__on=[s]}}function rC(t,e,i){var s,n,r=iC(t+""),o=r.length;if(!(arguments.length<2)){for(a=e?nC:sC,s=0;s<o;++s)this.each(a(r[s],e,i));return this}var a=this.node().__on;if(a)for(var l,c=0,d=a.length;c<d;++c)for(s=0,l=a[c];s<o;++s)if((n=r[s]).type===l.type&&n.name===l.name)return l.value}function oC(t,e,i){var s=hx(t),n=s.CustomEvent;"function"===typeof n?n=new n(e,i):(n=s.document.createEvent("Event"),i?(n.initEvent(e,i.bubbles,i.cancelable),n.detail=i.detail):n.initEvent(e,!1,!1)),t.dispatchEvent(n)}function aC(t,e){return function(){return oC(this,t,e)}}function lC(t,e){return function(){return oC(this,t,e.apply(this,arguments))}}function cC(t,e){return this.each(("function"===typeof e?lC:aC)(t,e))}function*dC(){for(var t=this._groups,e=0,i=t.length;e<i;++e)for(var s,n=t[e],r=0,o=n.length;r<o;++r)(s=n[r])&&(yield s)}xx.prototype={add:function(t){var e=this._names.indexOf(t);e<0&&(this._names.push(t),this._node.setAttribute("class",this._names.join(" ")))},remove:function(t){var e=this._names.indexOf(t);e>=0&&(this._names.splice(e,1),this._node.setAttribute("class",this._names.join(" ")))},contains:function(t){return this._names.indexOf(t)>=0}};var uC=[null];function hC(t,e){this._groups=t,this._parents=e}function pC(){return new hC([[document.documentElement]],uC)}function fC(){return this}hC.prototype=pC.prototype={constructor:hC,select:yT,selectAll:TT,selectChild:AT,selectChildren:PT,filter:OT,data:qT,enter:NT,exit:VT,join:HT,merge:zT,selection:fC,order:KT,sort:WT,call:XT,nodes:ZT,node:QT,size:JT,empty:tx,each:ex,attr:ux,style:vx,property:Sx,classed:Rx,text:Ox,html:Bx,raise:Ux,lower:qx,append:zx,insert:Wx,remove:Xx,clone:Jx,datum:tC,on:rC,dispatch:cC,[Symbol.iterator]:dC};function mC(t){return"string"===typeof t?new hC([[document.querySelector(t)]],[document.documentElement]):new hC([[t]],uC)}var vC=i(6929),gC=i.n(vC),yC=Math.sqrt(50),bC=Math.sqrt(10),wC=Math.sqrt(2);function SC(t,e,i){var s,n,r,o,a=-1;if(e=+e,t=+t,i=+i,t===e&&i>0)return[t];if((s=e<t)&&(n=t,t=e,e=n),0===(o=EC(t,e,i))||!isFinite(o))return[];if(o>0){let i=Math.round(t/o),s=Math.round(e/o);i*o<t&&++i,s*o>e&&--s,r=new Array(n=s-i+1);while(++a<n)r[a]=(i+a)*o}else{o=-o;let i=Math.round(t*o),s=Math.round(e*o);i/o<t&&++i,s/o>e&&--s,r=new Array(n=s-i+1);while(++a<n)r[a]=(i+a)/o}return s&&r.reverse(),r}function EC(t,e,i){var s=(e-t)/Math.max(0,i),n=Math.floor(Math.log(s)/Math.LN10),r=s/Math.pow(10,n);return n>=0?(r>=yC?10:r>=bC?5:r>=wC?2:1)*Math.pow(10,n):-Math.pow(10,-n)/(r>=yC?10:r>=bC?5:r>=wC?2:1)}function TC(t,e,i){var s=Math.abs(e-t)/Math.max(0,i),n=Math.pow(10,Math.floor(Math.log(s)/Math.LN10)),r=s/n;return r>=yC?n*=10:r>=bC?n*=5:r>=wC&&(n*=2),e<t?-n:n}var xC,CC=/^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;function _C(t){if(!(e=CC.exec(t)))throw new Error("invalid format: "+t);var e;return new kC({fill:e[1],align:e[2],sign:e[3],symbol:e[4],zero:e[5],width:e[6],comma:e[7],precision:e[8]&&e[8].slice(1),trim:e[9],type:e[10]})}function kC(t){this.fill=void 0===t.fill?" ":t.fill+"",this.align=void 0===t.align?">":t.align+"",this.sign=void 0===t.sign?"-":t.sign+"",this.symbol=void 0===t.symbol?"":t.symbol+"",this.zero=!!t.zero,this.width=void 0===t.width?void 0:+t.width,this.comma=!!t.comma,this.precision=void 0===t.precision?void 0:+t.precision,this.trim=!!t.trim,this.type=void 0===t.type?"":t.type+""}function LC(t){return Math.abs(t=Math.round(t))>=1e21?t.toLocaleString("en").replace(/,/g,""):t.toString(10)}function AC(t,e){if((i=(t=e?t.toExponential(e-1):t.toExponential()).indexOf("e"))<0)return null;var i,s=t.slice(0,i);return[s.length>1?s[0]+s.slice(2):s,+t.slice(i+1)]}function RC(t){return t=AC(Math.abs(t)),t?t[1]:NaN}function IC(t,e){return Math.max(0,3*Math.max(-8,Math.min(8,Math.floor(RC(e)/3)))-RC(Math.abs(t)))}function DC(t,e){return function(i,s){var n=i.length,r=[],o=0,a=t[0],l=0;while(n>0&&a>0){if(l+a+1>s&&(a=Math.max(1,s-l)),r.push(i.substring(n-=a,n+a)),(l+=a+1)>s)break;a=t[o=(o+1)%t.length]}return r.reverse().join(e)}}function PC(t){return function(e){return e.replace(/[0-9]/g,(function(e){return t[+e]}))}}function OC(t){t:for(var e,i=t.length,s=1,n=-1;s<i;++s)switch(t[s]){case".":n=e=s;break;case"0":0===n&&(n=s),e=s;break;default:if(!+t[s])break t;n>0&&(n=0);break}return n>0?t.slice(0,n)+t.slice(e+1):t}function MC(t,e){var i=AC(t,e);if(!i)return t+"";var s=i[0],n=i[1],r=n-(xC=3*Math.max(-8,Math.min(8,Math.floor(n/3))))+1,o=s.length;return r===o?s:r>o?s+new Array(r-o+1).join("0"):r>0?s.slice(0,r)+"."+s.slice(r):"0."+new Array(1-r).join("0")+AC(t,Math.max(0,e+r-1))[0]}function NC(t,e){var i=AC(t,e);if(!i)return t+"";var s=i[0],n=i[1];return n<0?"0."+new Array(-n).join("0")+s:s.length>n+1?s.slice(0,n+1)+"."+s.slice(n+1):s+new Array(n-s.length+2).join("0")}_C.prototype=kC.prototype,kC.prototype.toString=function(){return this.fill+this.align+this.sign+this.symbol+(this.zero?"0":"")+(void 0===this.width?"":Math.max(1,0|this.width))+(this.comma?",":"")+(void 0===this.precision?"":"."+Math.max(0,0|this.precision))+(this.trim?"~":"")+this.type};var FC={"%":(t,e)=>(100*t).toFixed(e),b:t=>Math.round(t).toString(2),c:t=>t+"",d:LC,e:(t,e)=>t.toExponential(e),f:(t,e)=>t.toFixed(e),g:(t,e)=>t.toPrecision(e),o:t=>Math.round(t).toString(8),p:(t,e)=>NC(100*t,e),r:NC,s:MC,X:t=>Math.round(t).toString(16).toUpperCase(),x:t=>Math.round(t).toString(16)};function BC(t){return t}var $C,UC,jC,qC=Array.prototype.map,GC=["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];function VC(t){var e=void 0===t.grouping||void 0===t.thousands?BC:DC(qC.call(t.grouping,Number),t.thousands+""),i=void 0===t.currency?"":t.currency[0]+"",s=void 0===t.currency?"":t.currency[1]+"",n=void 0===t.decimal?".":t.decimal+"",r=void 0===t.numerals?BC:PC(qC.call(t.numerals,String)),o=void 0===t.percent?"%":t.percent+"",a=void 0===t.minus?"−":t.minus+"",l=void 0===t.nan?"NaN":t.nan+"";function c(t){t=_C(t);var c=t.fill,d=t.align,u=t.sign,h=t.symbol,p=t.zero,f=t.width,m=t.comma,v=t.precision,g=t.trim,y=t.type;"n"===y?(m=!0,y="g"):FC[y]||(void 0===v&&(v=12),g=!0,y="g"),(p||"0"===c&&"="===d)&&(p=!0,c="0",d="=");var b="$"===h?i:"#"===h&&/[boxX]/.test(y)?"0"+y.toLowerCase():"",w="$"===h?s:/[%p]/.test(y)?o:"",S=FC[y],E=/[defgprs%]/.test(y);function T(t){var i,s,o,h=b,T=w;if("c"===y)T=S(t)+T,t="";else{t=+t;var x=t<0||1/t<0;if(t=isNaN(t)?l:S(Math.abs(t),v),g&&(t=OC(t)),x&&0===+t&&"+"!==u&&(x=!1),h=(x?"("===u?u:a:"-"===u||"("===u?"":u)+h,T=("s"===y?GC[8+xC/3]:"")+T+(x&&"("===u?")":""),E){i=-1,s=t.length;while(++i<s)if(o=t.charCodeAt(i),48>o||o>57){T=(46===o?n+t.slice(i+1):t.slice(i))+T,t=t.slice(0,i);break}}}m&&!p&&(t=e(t,1/0));var C=h.length+t.length+T.length,_=C<f?new Array(f-C+1).join(c):"";switch(m&&p&&(t=e(_+t,_.length?f-T.length:1/0),_=""),d){case"<":t=h+t+T+_;break;case"=":t=h+_+t+T;break;case"^":t=_.slice(0,C=_.length>>1)+h+t+T+_.slice(C);break;default:t=_+h+t+T;break}return r(t)}return v=void 0===v?6:/[gprs]/.test(y)?Math.max(1,Math.min(21,v)):Math.max(0,Math.min(20,v)),T.toString=function(){return t+""},T}function d(t,e){var i=c((t=_C(t),t.type="f",t)),s=3*Math.max(-8,Math.min(8,Math.floor(RC(e)/3))),n=Math.pow(10,-s),r=GC[8+s/3];return function(t){return i(n*t)+r}}return{format:c,formatPrefix:d}}function HC(t){return $C=VC(t),UC=$C.format,jC=$C.formatPrefix,$C}function zC(t,e){return t=Math.abs(t),e=Math.abs(e)-t,Math.max(0,RC(e)-RC(t))+1}function KC(t){return Math.max(0,-RC(Math.abs(t)))}function WC(t,e,i,s){var n,r=TC(t,e,i);switch(s=_C(null==s?",f":s),s.type){case"s":var o=Math.max(Math.abs(t),Math.abs(e));return null!=s.precision||isNaN(n=IC(r,o))||(s.precision=n),jC(s,o);case"":case"e":case"g":case"p":case"r":null!=s.precision||isNaN(n=zC(r,Math.max(Math.abs(t),Math.abs(e))))||(s.precision=n-("e"===s.type));break;case"f":case"%":null!=s.precision||isNaN(n=KC(r))||(s.precision=n-2*("%"===s.type));break}return UC(s)}function YC(t){var e=t.domain;return t.ticks=function(t){var i=e();return SC(i[0],i[i.length-1],null==t?10:t)},t.tickFormat=function(t,i){var s=e();return WC(s[0],s[s.length-1],null==t?10:t,i)},t.nice=function(i){null==i&&(i=10);var s,n,r=e(),o=0,a=r.length-1,l=r[o],c=r[a],d=10;c<l&&(n=l,l=c,c=n,n=o,o=a,a=n);while(d-- >0){if(n=EC(l,c,i),n===s)return r[o]=l,r[a]=c,e(r);if(n>0)l=Math.floor(l/n)*n,c=Math.ceil(c/n)*n;else{if(!(n<0))break;l=Math.ceil(l*n)/n,c=Math.floor(c*n)/n}s=n}return t},t}function XC(t,e){return null==t||null==e?NaN:t<e?-1:t>e?1:t>=e?0:NaN}function ZC(t,e){return null==t||null==e?NaN:e<t?-1:e>t?1:e>=t?0:NaN}function QC(t){let e,i,s;function n(t,s,n=0,r=t.length){if(n<r){if(0!==e(s,s))return r;do{const e=n+r>>>1;i(t[e],s)<0?n=e+1:r=e}while(n<r)}return n}function r(t,s,n=0,r=t.length){if(n<r){if(0!==e(s,s))return r;do{const e=n+r>>>1;i(t[e],s)<=0?n=e+1:r=e}while(n<r)}return n}function o(t,e,i=0,r=t.length){const o=n(t,e,i,r-1);return o>i&&s(t[o-1],e)>-s(t[o],e)?o-1:o}return 2!==t.length?(e=XC,i=(e,i)=>XC(t(e),i),s=(e,i)=>t(e)-i):(e=t===XC||t===ZC?t:JC,i=t,s=t),{left:n,center:o,right:r}}function JC(){return 0}function t_(t){return null===t?NaN:+t}HC({thousands:",",grouping:[3],currency:["$",""]});const e_=QC(XC),i_=e_.right;e_.left,QC(t_).center;var s_=i_;function n_(t,e,i){t.prototype=e.prototype=i,i.constructor=t}function r_(t,e){var i=Object.create(t.prototype);for(var s in e)i[s]=e[s];return i}function o_(){}var a_=.7,l_=1/a_,c_="\\s*([+-]?\\d+)\\s*",d_="\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*",u_="\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*",h_=/^#([0-9a-f]{3,8})$/,p_=new RegExp(`^rgb\\(${c_},${c_},${c_}\\)$`),f_=new RegExp(`^rgb\\(${u_},${u_},${u_}\\)$`),m_=new RegExp(`^rgba\\(${c_},${c_},${c_},${d_}\\)$`),v_=new RegExp(`^rgba\\(${u_},${u_},${u_},${d_}\\)$`),g_=new RegExp(`^hsl\\(${d_},${u_},${u_}\\)$`),y_=new RegExp(`^hsla\\(${d_},${u_},${u_},${d_}\\)$`),b_={aliceblue:15792383,antiquewhite:16444375,aqua:65535,aquamarine:8388564,azure:15794175,beige:16119260,bisque:16770244,black:0,blanchedalmond:16772045,blue:255,blueviolet:9055202,brown:10824234,burlywood:14596231,cadetblue:6266528,chartreuse:8388352,chocolate:13789470,coral:16744272,cornflowerblue:6591981,cornsilk:16775388,crimson:14423100,cyan:65535,darkblue:139,darkcyan:35723,darkgoldenrod:12092939,darkgray:11119017,darkgreen:25600,darkgrey:11119017,darkkhaki:12433259,darkmagenta:9109643,darkolivegreen:5597999,darkorange:16747520,darkorchid:10040012,darkred:9109504,darksalmon:15308410,darkseagreen:9419919,darkslateblue:4734347,darkslategray:3100495,darkslategrey:3100495,darkturquoise:52945,darkviolet:9699539,deeppink:16716947,deepskyblue:49151,dimgray:6908265,dimgrey:6908265,dodgerblue:2003199,firebrick:11674146,floralwhite:16775920,forestgreen:2263842,fuchsia:16711935,gainsboro:14474460,ghostwhite:16316671,gold:16766720,goldenrod:14329120,gray:8421504,green:32768,greenyellow:11403055,grey:8421504,honeydew:15794160,hotpink:16738740,indianred:13458524,indigo:4915330,ivory:16777200,khaki:15787660,lavender:15132410,lavenderblush:16773365,lawngreen:8190976,lemonchiffon:16775885,lightblue:11393254,lightcoral:15761536,lightcyan:14745599,lightgoldenrodyellow:16448210,lightgray:13882323,lightgreen:9498256,lightgrey:13882323,lightpink:16758465,lightsalmon:16752762,lightseagreen:2142890,lightskyblue:8900346,lightslategray:7833753,lightslategrey:7833753,lightsteelblue:11584734,lightyellow:16777184,lime:65280,limegreen:3329330,linen:16445670,magenta:16711935,maroon:8388608,mediumaquamarine:6737322,mediumblue:205,mediumorchid:12211667,mediumpurple:9662683,mediumseagreen:3978097,mediumslateblue:8087790,mediumspringgreen:64154,mediumturquoise:4772300,mediumvioletred:13047173,midnightblue:1644912,mintcream:16121850,mistyrose:16770273,moccasin:16770229,navajowhite:16768685,navy:128,oldlace:16643558,olive:8421376,olivedrab:7048739,orange:16753920,orangered:16729344,orchid:14315734,palegoldenrod:15657130,palegreen:10025880,paleturquoise:11529966,palevioletred:14381203,papayawhip:16773077,peachpuff:16767673,peru:13468991,pink:16761035,plum:14524637,powderblue:11591910,purple:8388736,rebeccapurple:6697881,red:16711680,rosybrown:12357519,royalblue:4286945,saddlebrown:9127187,salmon:16416882,sandybrown:16032864,seagreen:3050327,seashell:16774638,sienna:10506797,silver:12632256,skyblue:8900331,slateblue:6970061,slategray:7372944,slategrey:7372944,snow:16775930,springgreen:65407,steelblue:4620980,tan:13808780,teal:32896,thistle:14204888,tomato:16737095,turquoise:4251856,violet:15631086,wheat:16113331,white:16777215,whitesmoke:16119285,yellow:16776960,yellowgreen:10145074};function w_(){return this.rgb().formatHex()}function S_(){return this.rgb().formatHex8()}function E_(){return F_(this).formatHsl()}function T_(){return this.rgb().formatRgb()}function x_(t){var e,i;return t=(t+"").trim().toLowerCase(),(e=h_.exec(t))?(i=e[1].length,e=parseInt(e[1],16),6===i?C_(e):3===i?new A_(e>>8&15|e>>4&240,e>>4&15|240&e,(15&e)<<4|15&e,1):8===i?__(e>>24&255,e>>16&255,e>>8&255,(255&e)/255):4===i?__(e>>12&15|e>>8&240,e>>8&15|e>>4&240,e>>4&15|240&e,((15&e)<<4|15&e)/255):null):(e=p_.exec(t))?new A_(e[1],e[2],e[3],1):(e=f_.exec(t))?new A_(255*e[1]/100,255*e[2]/100,255*e[3]/100,1):(e=m_.exec(t))?__(e[1],e[2],e[3],e[4]):(e=v_.exec(t))?__(255*e[1]/100,255*e[2]/100,255*e[3]/100,e[4]):(e=g_.exec(t))?N_(e[1],e[2]/100,e[3]/100,1):(e=y_.exec(t))?N_(e[1],e[2]/100,e[3]/100,e[4]):b_.hasOwnProperty(t)?C_(b_[t]):"transparent"===t?new A_(NaN,NaN,NaN,0):null}function C_(t){return new A_(t>>16&255,t>>8&255,255&t,1)}function __(t,e,i,s){return s<=0&&(t=e=i=NaN),new A_(t,e,i,s)}function k_(t){return t instanceof o_||(t=x_(t)),t?(t=t.rgb(),new A_(t.r,t.g,t.b,t.opacity)):new A_}function L_(t,e,i,s){return 1===arguments.length?k_(t):new A_(t,e,i,null==s?1:s)}function A_(t,e,i,s){this.r=+t,this.g=+e,this.b=+i,this.opacity=+s}function R_(){return`#${M_(this.r)}${M_(this.g)}${M_(this.b)}`}function I_(){return`#${M_(this.r)}${M_(this.g)}${M_(this.b)}${M_(255*(isNaN(this.opacity)?1:this.opacity))}`}function D_(){const t=P_(this.opacity);return`${1===t?"rgb(":"rgba("}${O_(this.r)}, ${O_(this.g)}, ${O_(this.b)}${1===t?")":`, ${t})`}`}function P_(t){return isNaN(t)?1:Math.max(0,Math.min(1,t))}function O_(t){return Math.max(0,Math.min(255,Math.round(t)||0))}function M_(t){return t=O_(t),(t<16?"0":"")+t.toString(16)}function N_(t,e,i,s){return s<=0?t=e=i=NaN:i<=0||i>=1?t=e=NaN:e<=0&&(t=NaN),new $_(t,e,i,s)}function F_(t){if(t instanceof $_)return new $_(t.h,t.s,t.l,t.opacity);if(t instanceof o_||(t=x_(t)),!t)return new $_;if(t instanceof $_)return t;t=t.rgb();var e=t.r/255,i=t.g/255,s=t.b/255,n=Math.min(e,i,s),r=Math.max(e,i,s),o=NaN,a=r-n,l=(r+n)/2;return a?(o=e===r?(i-s)/a+6*(i<s):i===r?(s-e)/a+2:(e-i)/a+4,a/=l<.5?r+n:2-r-n,o*=60):a=l>0&&l<1?0:o,new $_(o,a,l,t.opacity)}function B_(t,e,i,s){return 1===arguments.length?F_(t):new $_(t,e,i,null==s?1:s)}function $_(t,e,i,s){this.h=+t,this.s=+e,this.l=+i,this.opacity=+s}function U_(t){return t=(t||0)%360,t<0?t+360:t}function j_(t){return Math.max(0,Math.min(1,t||0))}function q_(t,e,i){return 255*(t<60?e+(i-e)*t/60:t<180?i:t<240?e+(i-e)*(240-t)/60:e)}function G_(t,e,i,s,n){var r=t*t,o=r*t;return((1-3*t+3*r-o)*e+(4-6*r+3*o)*i+(1+3*t+3*r-3*o)*s+o*n)/6}function V_(t){var e=t.length-1;return function(i){var s=i<=0?i=0:i>=1?(i=1,e-1):Math.floor(i*e),n=t[s],r=t[s+1],o=s>0?t[s-1]:2*n-r,a=s<e-1?t[s+2]:2*r-n;return G_((i-s/e)*e,o,n,r,a)}}function H_(t){var e=t.length;return function(i){var s=Math.floor(((i%=1)<0?++i:i)*e),n=t[(s+e-1)%e],r=t[s%e],o=t[(s+1)%e],a=t[(s+2)%e];return G_((i-s/e)*e,n,r,o,a)}}n_(o_,x_,{copy(t){return Object.assign(new this.constructor,this,t)},displayable(){return this.rgb().displayable()},hex:w_,formatHex:w_,formatHex8:S_,formatHsl:E_,formatRgb:T_,toString:T_}),n_(A_,L_,r_(o_,{brighter(t){return t=null==t?l_:Math.pow(l_,t),new A_(this.r*t,this.g*t,this.b*t,this.opacity)},darker(t){return t=null==t?a_:Math.pow(a_,t),new A_(this.r*t,this.g*t,this.b*t,this.opacity)},rgb(){return this},clamp(){return new A_(O_(this.r),O_(this.g),O_(this.b),P_(this.opacity))},displayable(){return-.5<=this.r&&this.r<255.5&&-.5<=this.g&&this.g<255.5&&-.5<=this.b&&this.b<255.5&&0<=this.opacity&&this.opacity<=1},hex:R_,formatHex:R_,formatHex8:I_,formatRgb:D_,toString:D_})),n_($_,B_,r_(o_,{brighter(t){return t=null==t?l_:Math.pow(l_,t),new $_(this.h,this.s,this.l*t,this.opacity)},darker(t){return t=null==t?a_:Math.pow(a_,t),new $_(this.h,this.s,this.l*t,this.opacity)},rgb(){var t=this.h%360+360*(this.h<0),e=isNaN(t)||isNaN(this.s)?0:this.s,i=this.l,s=i+(i<.5?i:1-i)*e,n=2*i-s;return new A_(q_(t>=240?t-240:t+120,n,s),q_(t,n,s),q_(t<120?t+240:t-120,n,s),this.opacity)},clamp(){return new $_(U_(this.h),j_(this.s),j_(this.l),P_(this.opacity))},displayable(){return(0<=this.s&&this.s<=1||isNaN(this.s))&&0<=this.l&&this.l<=1&&0<=this.opacity&&this.opacity<=1},formatHsl(){const t=P_(this.opacity);return`${1===t?"hsl(":"hsla("}${U_(this.h)}, ${100*j_(this.s)}%, ${100*j_(this.l)}%${1===t?")":`, ${t})`}`}}));var z_=t=>()=>t;function K_(t,e){return function(i){return t+i*e}}function W_(t,e,i){return t=Math.pow(t,i),e=Math.pow(e,i)-t,i=1/i,function(s){return Math.pow(t+s*e,i)}}function Y_(t){return 1===(t=+t)?X_:function(e,i){return i-e?W_(e,i,t):z_(isNaN(e)?i:e)}}function X_(t,e){var i=e-t;return i?K_(t,i):z_(isNaN(t)?e:t)}var Z_=function t(e){var i=Y_(e);function s(t,e){var s=i((t=L_(t)).r,(e=L_(e)).r),n=i(t.g,e.g),r=i(t.b,e.b),o=X_(t.opacity,e.opacity);return function(e){return t.r=s(e),t.g=n(e),t.b=r(e),t.opacity=o(e),t+""}}return s.gamma=t,s}(1);function Q_(t){return function(e){var i,s,n=e.length,r=new Array(n),o=new Array(n),a=new Array(n);for(i=0;i<n;++i)s=L_(e[i]),r[i]=s.r||0,o[i]=s.g||0,a[i]=s.b||0;return r=t(r),o=t(o),a=t(a),s.opacity=1,function(t){return s.r=r(t),s.g=o(t),s.b=a(t),s+""}}}Q_(V_),Q_(H_);function J_(t,e){var i,s=e?e.length:0,n=t?Math.min(s,t.length):0,r=new Array(n),o=new Array(s);for(i=0;i<n;++i)r[i]=dk(t[i],e[i]);for(;i<s;++i)o[i]=e[i];return function(t){for(i=0;i<n;++i)o[i]=r[i](t);return o}}function tk(t,e){var i=new Date;return t=+t,e=+e,function(s){return i.setTime(t*(1-s)+e*s),i}}function ek(t,e){return t=+t,e=+e,function(i){return t*(1-i)+e*i}}function ik(t,e){var i,s={},n={};for(i in null!==t&&"object"===typeof t||(t={}),null!==e&&"object"===typeof e||(e={}),e)i in t?s[i]=dk(t[i],e[i]):n[i]=e[i];return function(t){for(i in s)n[i]=s[i](t);return n}}var sk=/[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,nk=new RegExp(sk.source,"g");function rk(t){return function(){return t}}function ok(t){return function(e){return t(e)+""}}function ak(t,e){var i,s,n,r=sk.lastIndex=nk.lastIndex=0,o=-1,a=[],l=[];t+="",e+="";while((i=sk.exec(t))&&(s=nk.exec(e)))(n=s.index)>r&&(n=e.slice(r,n),a[o]?a[o]+=n:a[++o]=n),(i=i[0])===(s=s[0])?a[o]?a[o]+=s:a[++o]=s:(a[++o]=null,l.push({i:o,x:ek(i,s)})),r=nk.lastIndex;return r<e.length&&(n=e.slice(r),a[o]?a[o]+=n:a[++o]=n),a.length<2?l[0]?ok(l[0].x):rk(e):(e=l.length,function(t){for(var i,s=0;s<e;++s)a[(i=l[s]).i]=i.x(t);return a.join("")})}function lk(t,e){e||(e=[]);var i,s=t?Math.min(e.length,t.length):0,n=e.slice();return function(r){for(i=0;i<s;++i)n[i]=t[i]*(1-r)+e[i]*r;return n}}function ck(t){return ArrayBuffer.isView(t)&&!(t instanceof DataView)}function dk(t,e){var i,s=typeof e;return null==e||"boolean"===s?z_(e):("number"===s?ek:"string"===s?(i=x_(e))?(e=i,Z_):ak:e instanceof x_?Z_:e instanceof Date?tk:ck(e)?lk:Array.isArray(e)?J_:"function"!==typeof e.valueOf&&"function"!==typeof e.toString||isNaN(e)?ik:ek)(t,e)}function uk(t,e){return t=+t,e=+e,function(i){return Math.round(t*(1-i)+e*i)}}function hk(t){return function(){return t}}function pk(t){return+t}var fk=[0,1];function mk(t){return t}function vk(t,e){return(e-=t=+t)?function(i){return(i-t)/e}:hk(isNaN(e)?NaN:.5)}function gk(t,e){var i;return t>e&&(i=t,t=e,e=i),function(i){return Math.max(t,Math.min(e,i))}}function yk(t,e,i){var s=t[0],n=t[1],r=e[0],o=e[1];return n<s?(s=vk(n,s),r=i(o,r)):(s=vk(s,n),r=i(r,o)),function(t){return r(s(t))}}function bk(t,e,i){var s=Math.min(t.length,e.length)-1,n=new Array(s),r=new Array(s),o=-1;t[s]<t[0]&&(t=t.slice().reverse(),e=e.slice().reverse());while(++o<s)n[o]=vk(t[o],t[o+1]),r[o]=i(e[o],e[o+1]);return function(e){var i=s_(t,e,1,s)-1;return r[i](n[i](e))}}function wk(t,e){return e.domain(t.domain()).range(t.range()).interpolate(t.interpolate()).clamp(t.clamp()).unknown(t.unknown())}function Sk(){var t,e,i,s,n,r,o=fk,a=fk,l=dk,c=mk;function d(){var t=Math.min(o.length,a.length);return c!==mk&&(c=gk(o[0],o[t-1])),s=t>2?bk:yk,n=r=null,u}function u(e){return null==e||isNaN(e=+e)?i:(n||(n=s(o.map(t),a,l)))(t(c(e)))}return u.invert=function(i){return c(e((r||(r=s(a,o.map(t),ek)))(i)))},u.domain=function(t){return arguments.length?(o=Array.from(t,pk),d()):o.slice()},u.range=function(t){return arguments.length?(a=Array.from(t),d()):a.slice()},u.rangeRound=function(t){return a=Array.from(t),l=uk,d()},u.clamp=function(t){return arguments.length?(c=!!t||mk,d()):c!==mk},u.interpolate=function(t){return arguments.length?(l=t,d()):l},u.unknown=function(t){return arguments.length?(i=t,u):i},function(i,s){return t=i,e=s,d()}}function Ek(t,e){switch(arguments.length){case 0:break;case 1:this.range(t);break;default:this.range(e).domain(t);break}return this}function Tk(t){return function(e){return e<0?-Math.pow(-e,t):Math.pow(e,t)}}function xk(t){return t<0?-Math.sqrt(-t):Math.sqrt(t)}function Ck(t){return t<0?-t*t:t*t}function _k(t){var e=t(mk,mk),i=1;function s(){return 1===i?t(mk,mk):.5===i?t(xk,Ck):t(Tk(i),Tk(1/i))}return e.exponent=function(t){return arguments.length?(i=+t,s()):i},YC(e)}function kk(){var t=_k(Sk());return t.copy=function(){return wk(t,kk()).exponent(t.exponent())},Ek.apply(t,arguments),t}function Lk(t,e){let i,s;if(void 0===e)for(const n of t)null!=n&&(void 0===i?n>=n&&(i=s=n):(i>n&&(i=n),s<n&&(s=n)));else{let n=-1;for(let r of t)null!=(r=e(r,++n,t))&&(void 0===i?r>=r&&(i=s=r):(i>r&&(i=r),s<r&&(s=r)))}return[i,s]}var Ak=n["default"].extend({props:{width:{type:Number,required:!0},height:{type:Number,required:!0},words:{type:Array,required:!0},config:{type:Object,required:!0},rpx:{type:Number,required:!0}},data(){return{items:[],tickCounter:0,innerCenter:{x:0,y:0}}},computed:{layoutSet(){return GS[this.config.layout||"compact"]},innerWidth(){return this.layoutSet.WIDTH_TRANSFORMER(this.width)},center(){return{x:this.width/2,y:this.height/2}},origin(){return{x:0,y:0}},fontSizeScale(){return this.items,this.config,kk().domain(Lk(this.items,(t=>t.votes))).exponent(this.layoutSet.FONT_SCALE_EXPONENT).range(this.config.font.sizeRange.map((t=>t*this.rpx)))},colors(){return Object.values(this.config.colors)}},methods:{color(t){return this.colors[t.text.length%this.colors.length]},fixRectangles(){this.items.forEach((t=>{const e=this.calculateRectBounds(t);e&&(t.rectX=e.rectX||t.rectX,t.rectY=e.rectY||t.rectY,t.rectWidth=e.rectWidth||t.rectWidth,t.rectHeight=e.rectHeight||t.rectHeight)}))},getTextBounds(t){var e,i;const s=null===(e=this.$el)||void 0===e?void 0:e.querySelector(`#${t.id} .smvp-word-cloud-text`);return null===(i=null===s||void 0===s?void 0:s.getBBox)||void 0===i?void 0:i.call(s)},calculateRectBounds(t){const e=this.getTextBounds(t);let i,s,n,r;if(e)return i=e.x-this.layoutSet.RECT_PADDING.X*this.rpx,s=e.y-this.layoutSet.RECT_PADDING.Y*this.rpx,n=this.getRectWidth(t,e.width),r=this.getRectHeight(e.height),{rectX:i,rectY:s,rectWidth:n,rectHeight:r}},getRectWidth(t,e){var i;return e?e+2*this.layoutSet.RECT_PADDING.X*this.rpx:((null===(i=null===t||void 0===t?void 0:t.text)||void 0===i?void 0:i.length)||5)*this.config.font.sizeRange[1]*this.rpx},getRectHeight(t){return t?t+2*this.layoutSet.RECT_PADDING.Y*this.rpx:this.config.font.sizeRange[1]*this.rpx},externalRecenter(){this.innerCenter={x:this.innerWidth/2,y:this.height/2}},internalRecenter([t,e]){this.innerCenter={x:this.width-(this.width-this.innerWidth+e.x+t.x)/2,y:this.height-(e.y+t.y)/2}}}}),Rk=n["default"].extend({name:"WordCloudSvg",mixins:[Ak],props:{width:{type:Number,required:!0},height:{type:Number,required:!0},words:{type:Array,required:!0},config:{type:Object,required:!0},rpx:{type:Number,required:!0}},data(){return{DRAW_CIRCLES:!1,items:[],forceSimulation:null,innerCenter:{x:0,y:0},layout:gC()(),tickCounter:0,debouncedHandler:Function.prototype,redraw:Function.prototype}},watch:{words:{immediate:!0,handler(t,e){VE(t,e)||this.debouncedHandler()}},config:{deep:!0,handler(t,e){VE(t,e)||t.layout!==e.layout&&(this.items=this.mapWords(this.words,this.items),this.changeHandler(),this.fixRectangles)}},width:{immediate:!0,handler(t,e){VE(t,e)||(this.externalRecenter(),this.mapAndAnnotate(),this.debouncedHandler())}}},created(){this.debouncedHandler=dT((()=>this.changeHandler()),HS,{leading:!0,trailing:!0,maxWait:HS}),this.items=this.mapWords(this.words),this.graphAnnotate()},mounted(){return di(this,void 0,void 0,(function*(){yield this.$nextTick(),this.items=this.mapWords(this.words,this.items),yield this.debouncedHandler()}))},methods:{refit(){return di(this,void 0,void 0,(function*(){yield this.$nextTick(),this.fixRectangles()}))},changeHandler(){return di(this,void 0,void 0,(function*(){yield this.$nextTick(),this.mapAndAnnotate(),yield this.executeLayout(),yield this.refit()}))},mapAndAnnotate(){this.items=this.mapWords(this.words,this.items),this.graphAnnotate()},graphAnnotate(){mC(this.$el).selectAll(".smvp-word-cloud-group").data(this.items,(function(t){var e;return(null===(e=t)||void 0===e?void 0:e.id)||mC(this).attr("id")}))},mapWords(t=[],e=[]){return t.map((t=>{var i;const s=(null===(i=null===t||void 0===t?void 0:t.text)||void 0===i?void 0:i.length)?"w_"+t.text.split("").reduce(((t,e)=>(t<<7)-t+e.charCodeAt(0)%Number.MAX_SAFE_INTEGER),5381).toString(16).toLowerCase():"";return Object.assign(Object.assign(Object.assign(Object.assign({},this.origin),e.find((e=>e.text===t.text))||{}),t),{id:s})})).filter((t=>t.id.length))},executeLayout(){return this.graphAnnotate(),this.$forceUpdate(),this.$nextTick().then((()=>new Promise((t=>{this.layout=gC()().size([this.innerWidth,this.height]).words(this.items).text((t=>null===t||void 0===t?void 0:t.text)).padding(Number(this.layoutSet.LAYOUT_PADDING)).rotate(this.layoutSet.ROTATE_ACCESSOR).font(this.config.font.family).fontWeight(this.config.font.weight).fontSize((t=>this.fontSizeScale(t.votes))).spiral(this.layoutSet.SPIRAL).timeInterval(VS).on("end",((e,i)=>{i&&this.internalRecenter(i),this.refit(),t()})),this.layout.start()}))))}}}),Ik=Rk,Dk=mi(Ik,fT,mT,!1,null,null,null,!0),Pk=Dk.exports,Ok=n["default"].extend({name:"WordCloud",components:{WordCloudSvg:Pk},props:{words:{type:Array,required:!0},config:{type:Object,required:!0}},data(){return{resizeObserver:null,width:0,height:0,rpx:1,currentWords:[],onResizeThrottled:()=>{}}},computed:{preparedConfig(){var t,e,i,s;const n=this.config.hasOwnProperty("layout"),r=!!(null===(t=this.config)||void 0===t?void 0:t.large),o=n&&this.config.layout?this.config.layout:r?vS.Display:vS.Compact,a=0!==Object.keys((null===(e=this.config)||void 0===e?void 0:e.colors)||{}).length?this.config.colors:{colour_1:"#0000",colour_2:"#0000",colour_3:"#0000"};return{font:Object.assign({sizeRange:GS[o].SIZE_RANGE,family:"sans-serif",weight:"normal"},(null===(i=this.config)||void 0===i?void 0:i.font)||{}),large:n?this.config.layout===vS.Display:r,layout:o,colors:a,labels:(null===(s=this.config)||void 0===s?void 0:s.labels)||{wordCloudEmpty:"No words yet"}}}},watch:{config:{handler(t,e){VE(t,e)||(console.debug("[WordCloud]: config changed",t),this.setRpx(t),this.onResize())},immediate:!0,deep:!0},width(t,e){VE(t,e)||this.redraw()},height(t,e){VE(t,e)||this.redraw()},words:{immediate:!0,deep:!0,handler(t){const e=this.prepareWords(t||[]),i=this.prepareWords(this.currentWords||[]);this.currentWords=this.prepareWords(t||[]),VE(e,i)||(console.debug("[WordCloud]: words changed",e),this.currentWords=e,this.debouncedRedraw())}}},created(){this.onResizeThrottled=pT(this.onResize.bind(this),500)},mounted(){this.width=this.$el.clientWidth,this.height=this.$el.clientHeight,this.resizeObserver=new ResizeObserver(this.onResizeThrottled),this.resizeObserver.observe(this.$el),this.resizeObserver.observe(window.document.body),this.setRpx(this.config)},beforeDestroy(){var t;null===(t=this.resizeObserver)||void 0===t||t.disconnect(),this.resizeObserver=null},methods:{prepareWords(t){return dg(t).sort(((t,e)=>e.votes-t.votes)).slice(0,GS[this.preparedConfig.layout].MAX_WORDS)},handleRedraw(t){var e;return di(this,void 0,void 0,(function*(){const i=null===(e=this.$refs)||void 0===e?void 0:e.canvas;i&&(i.$forceUpdate(),i.refit(),yield this.$nextTick(),i[t]())}))},redraw(){this.handleRedraw("changeHandler")},debouncedRedraw(){this.handleRedraw("debouncedHandler")},onResize(){if(!this.$el)return;const t=this.$el.clientWidth;this.width=this.$el.clientWidth,this.height=this.$el.clientHeight,(this.setRpx(this.config)||this.width!==t)&&this.redraw()},setRpx(t){let e=!1;const i=t.large?this.getRpx():1;return this.rpx!==i&&(this.rpx=i,e=!0),e},getRpx(){return this.$el?(this.width=this.$el.clientWidth,this.height=this.$el.clientHeight,this.width>=this.height?this.width/1216:this.height/1216):1}}}),Mk=Ok;function Nk(t){var e=i(2212);e.__inject__&&e.__inject__(t)}var Fk=mi(Mk,jS,qS,!1,Nk,null,null,!0),Bk=Fk.exports;const $k=300,Uk=3e3;var jk,qk=n["default"].extend({components:{WordCloud:Bk,Icon:Bb,PollCountdown:fS},props:{api:{type:Object,required:!0},pollId:{type:String,required:!0},question:{type:String,required:!0},countdownEndTimestamp:{type:Number,default:-1},countdownDuration:{type:Number,default:-1},labels:{type:Object,default:()=>({})},theme:{type:Object,default:()=>({})},characterLimit:{type:Number,default:0},canSubmitAnswer:{type:Boolean,default:!0},allowVoting:{type:Boolean,default:!0},allowMultiWords:{type:Boolean,default:!1},showResults:{type:Boolean,default:!1},results:{type:Array,default:()=>[]},wordCloudConfig:{type:Object,default:()=>({})},expanded:{type:Boolean,default:!1},preventExpand:{type:Boolean,default:!1}},data(){return{answer:"",showMessage:!1,message:"",sending:!1,messageTimeout:0}},computed:{disableSubmit(){return this.sending||!this.answer||!this.answer.length||!this.canSubmitAnswer},words(){return this.results.map((t=>({text:ai(t,"text"),votes:ai(t,"votes",0)}))).filter((t=>!!t.text&&t.votes>0))},showExpandButton(){return!this.preventExpand&&this.words.length>0&&!this.expanded}},watch:{answer(){this.canSubmitAnswer?this.hasWhiteSpace(this.answer)&&(this.allowMultiWords?this.displayNewMessage(this.labels.multipleWordAnswerTooltip):this.answer=this.answer.replace(/\s/g,"")):this.displayNewMessage(this.labels.youCannotSubmitMore)}},beforeDestroy(){clearTimeout(this.messageTimeout)},methods:{sendAnswer(){this.sending=!0,this.api.customAction({pollId:this.pollId,answer:this.answer,onSuccess:t=>this.onSendingSuccess(t),onError:t=>this.onSendingError(t)},"sideBarPolls")},onSendingSuccess(t){this.sending=!1,this.answer="",this.displayNewMessage(t||this.labels.thankYouForAnswer)},onSendingError(t){this.sending=!1,this.displayNewMessage(t||this.labels.anErrorOccurred)},displayNewMessage(t){t&&(clearTimeout(this.messageTimeout),this.message=t,this.showMessage=!0,this.messageTimeout=setTimeout((()=>this.showMessage=!1),Uk))},hasWhiteSpace(t){return t.indexOf(" ")>=0},expandSidebar(){this.api.expandSidebar("sidebar.wordcloud")},collapseSidebar(){var t,e,i,s,n;const r=null===(i=null===(e=null===(t=this.$root)||void 0===t?void 0:t.$el)||void 0===e?void 0:e.querySelector)||void 0===i?void 0:i.call(e,".smvp-side-bar");null===(n=null===(s=null===r||void 0===r?void 0:r.classList)||void 0===s?void 0:s.add)||void 0===n||n.call(s,"smvp-side-bar-narrowing"),setTimeout((()=>{var t,e;this.api.collapseSidebar("sidebar.wordcloud"),null===(e=null===(t=null===r||void 0===r?void 0:r.classList)||void 0===t?void 0:t.remove)||void 0===e||e.call(t,"smvp-side-bar-narrowing")}),$k-25)}}}),Gk=qk,Vk=mi(Gk,$S,US,!1,null,null,null,!0),Hk=Vk.exports;(function(t){t["MULTIPLE_CHOICE"]="multiple_choice",t["WORD_CLOUD"]="word_cloud"})(jk||(jk={}));class zk{parseMultiChoiceAnswers(t){const e=this.getTotalVotes(ai(t,"results",{})),i=e=>ai(t,`results.${e}`,0);return ai(t,"answers",[]).map((t=>Object.assign(Object.assign({},t),{votePercentage:`${(100*(i(t.id)/e||0)).toFixed(2)}%`})))}parseWordcloudAnswers(t){return ai(t,"results",[])}parseAnswers(t){return t.poll_type===jk.WORD_CLOUD?this.parseWordcloudAnswers(t):this.parseMultiChoiceAnswers(t)}getTotalVotes(t){return Object.keys(t).reduce(((e,i)=>e+t[i]),0)}}var Kk=n["default"].extend({name:"Polls",components:{Poll:wS,Results:DS,Voted:oS,NoPoll:BS,WordCloud:Hk,Icon:Bb},props:{api:{type:Object,required:!0},labels:{type:Object,default:()=>({})},config:{type:Object,required:!0},theme:{type:Object,default:()=>({})},expanded:{type:Boolean,default:!1}},data(){return{checkIcon:Ib.check}},computed:{question(){return this.config.question},countdownEndTimestamp(){return this.config.countdownEndTimestamp||-1},countdownDuration(){return this.config.countdownDuration||-1},results(){return this.config.results||[]},showResults(){return this.config.showResults},answers(){return this.config.answers||[]},answerLimit(){return this.config.answerLimit||1},canSubmitAnswer(){return!!this.config.answerLimit},hasVoted(){return this.config.hasVoted||!1},pollId(){return this.config.pollId},pollType(){return this.config.pollType||jk.MULTIPLE_CHOICE},characterLimit(){return this.config.characterLimit||0},allowMultiWords(){return this.config.allowMultiWords||!1},allowVoting(){return this.config.allowVoting||!1},wordCloudConfig(){var t;return Object.assign(Object.assign({},(null===(t=this.config)||void 0===t?void 0:t.wordCloudConfig)||{}),{layout:this.expanded?vS.Expanded:vS.Compact})},showWordCloud(){return this.pollType===jk.WORD_CLOUD},preventExpand(){var t;return(null===(t=this.config)||void 0===t?void 0:t.preventExpand)||!1},showPollIncoming(){var t;return(null===(t=this.config)||void 0===t?void 0:t.showPollIncoming)||!1},pollState(){const t=this.results&&this.results.length,e=this.answers&&this.answers.length;return this.pollId&&this.question&&(e||t)?this.results&&this.results.length&&this.showResults?"results":this.hasVoted?"voted":this.allowVoting?"poll":"noPoll":"noPoll"}},watch:{pollState(t,e){var i,s;"noPoll"===t&&"noPoll"!==e&&(null===(s=null===(i=null===this||void 0===this?void 0:this.$refs)||void 0===i?void 0:i.wordCloud)||void 0===s||s.collapseSidebar())}}}),Wk=Kk,Yk=mi(Wk,Kw,Ww,!1,null,null,null,!0),Xk=Yk.exports,Zk=function(){var t=this,e=t._self._c;t._self._setupProxy;return e("div",{directives:[{name:"show",rawName:"v-show",value:!t.hidden,expression:"!hidden"}],staticClass:"smvp-translation-tab"},[t.labels.header?e("div",{staticClass:"header"},[t._v(t._s(t.labels.header))]):t._e(),t.src?e("iframe",{attrs:{src:t.src,width:"100%",height:"90%"}}):t._e()])},Qk=[],Jk=n["default"].extend({name:"Translations",props:{labels:{type:Object,default:()=>({})},config:{type:Object,default:()=>({})}},computed:{src(){return ai(this,"config.src")},hidden(){return ai(this,"config.hidden")}}}),tL=Jk,eL=mi(tL,Zk,Qk,!1,null,null,null,!0),iL=eL.exports,sL=function(){var t=this,e=t._self._c;t._self._setupProxy;return e("div",{directives:[{name:"show",rawName:"v-show",value:!t.hidden,expression:"!hidden"}],staticClass:"smvp-stream-tab"},[e("div",{staticClass:"stream-wrapper"},[e("icon",{attrs:{name:t.icon,color:t.theme.btnBackgroundColor}}),e("span",{staticClass:"title"},[t._v(t._s(t.noPlayer?t.labels.streamEnableTitle:t.labels.streamDisableTitle))]),e("span",{staticClass:"subtitle"},[t._v(t._s(t.noPlayer?t.labels.streamEnableSubtitle:t.labels.streamDisableSubtitle))]),e("button",{staticClass:"btn",style:{"background-color":t.theme.btnBackgroundColor,color:t.theme.btnColor},on:{click:function(e){return t.toggleStreamView()}}},[t._v(t._s(t.noPlayer?t.labels.streamEnableButton:t.labels.streamDisableButton))])],1)])},nL=[],rL=n["default"].extend({name:"Stream",components:{Icon:Bb},props:{api:{type:Object,required:!0},labels:{type:Object,default:()=>({})},config:{type:Object,default:()=>({})},theme:{type:Object,default:()=>({})},noPlayer:{type:Boolean,default:!1}},data(){return{icon:Ib.playCircle}},computed:{hidden(){return ai(this,"config.hidden")}},methods:{toggleStreamView(){this.api.customAction({showStream:this.noPlayer},"sideBarStream")}}}),oL=rL,aL=mi(oL,sL,nL,!1,null,null,null,!0),lL=aL.exports,cL=function(){var t=this,e=t._self._c;t._self._setupProxy;return e("btn",{staticClass:"smvp-icon-button smvp-show-tooltip-on-hover",attrs:{"aria-label":t.ariaLabel},on:{click:function(e){return t.$emit("click")}}},[e("icon",{attrs:{name:t.icon}}),t.tooltip?e("div",{staticClass:"smvp-tooltip"},[e("div",{staticClass:"smvp-tooltiptext",class:{left:t.alignTooltipLeft,right:!t.alignTooltipLeft}},[t._v(t._s(t.tooltip))])]):t._e()],1)},dL=[],uL=n["default"].extend({components:{Btn:hw,Icon:Bb},props:{icon:{type:String,required:!0},tooltip:{type:String,default:void 0},ariaLabel:{type:String,default:void 0},alignTooltipLeft:{type:Boolean,default:!1}}}),hL=uL,pL=mi(hL,cL,dL,!1,null,null,null,!0),fL=pL.exports,mL=function(){var t=this,e=t._self._c;t._self._setupProxy;return e("div",{staticClass:"smvp-side-bar-notification"},[e("div",{staticClass:"smvp-side-bar-notification-message"},[e("span",{staticClass:"title"},[t._v(t._s(t.config.title))]),e("span",{staticClass:"subtitle"},[t._v(t._s(t.config.subtitle))]),e("button",{style:{"background-color":t.theme.btnBackgroundColor,color:t.theme.btnColor},on:{click:function(e){return t.$emit("click")}}},[t._v(t._s(t.config.buttonText))])])])},vL=[],gL=n["default"].extend({name:"SideBarNotification",props:{config:{type:Object,required:!0},theme:{type:Object,default:()=>({})}}}),yL=gL,bL=mi(yL,mL,vL,!1,null,null,null,!0),wL=bL.exports,SL=n["default"].extend({name:"SideBar",components:{Viewers:tw,Qna:zw,IconButton:fL,Polls:Xk,SideBarNotification:wL,Portal:$i.h_,Icon:Bb},props:{api:{type:Object,required:!0},labels:{type:Object,default:()=>({})},config:{type:Object,required:!0},isSideBarBelow:{type:Boolean,required:!0},noPlayer:{type:Boolean,required:!0},isWebinar:{type:Boolean,required:!0}},data(){const t=[{id:"qna",component:zw,icon:Ib.question},{id:"polls",component:Xk,icon:Ib.ranking},{id:"translations",component:iL,icon:Ib.translations},{id:"viewers",component:tw,icon:Ib.participants},{id:"stream",component:lL,icon:Ib.playCircle}];return{unsubscribers:[],tabs:t,opened:!0,pollNotification:null,qnaNotification:null,openedTab:void 0,previouslyOpenedTab:void 0,isClientFullScreen:!1,isVideoElementFullScreen:!1,isSideBarExpanded:!1}},computed:{configuredTabs(){return this.tabs.filter((t=>this.tabsConfig[t.id]))},configuredTabsInMainView(){return this.openedTab?this.configuredTabs:[]},tabsConfig(){var t,e;const i={};for(const s of this.tabs)i[s.id]=(null!==(e=null===(t=this.config)||void 0===t?void 0:t.components)&&void 0!==e?e:[]).find((t=>t.id===s.id));return i},showCloseButton(){return!1},tabCount(){var t,e,i;return null!==(i=null===(e=null===(t=this.config)||void 0===t?void 0:t.components)||void 0===e?void 0:e.length)&&void 0!==i?i:0},showToggler(){return!!this.tabCount&&!this.noPlayer},showFullscreenToggler(){var t;return!!(null===(t=this.config)||void 0===t?void 0:t.showFullscreenToggler)&&!this.isSideBarBelow},togglerIcon(){return this.opened?Ib.chevronRight:Ib.chevronLeft},fullscreenIcon(){return this.isClientFullScreen?Ib.minimize:Ib.maximize},sideBarNotificationPortalId(){return""+this.api.getPortalId("SIDEBAR_NOTIFICATION")},showPollNotification(){var t;return"polls"!==(null===(t=this.openedTab)||void 0===t?void 0:t.id)&&!!this.pollNotification},showQnaNotification(){var t;return"qna"!==(null===(t=this.openedTab)||void 0===t?void 0:t.id)&&!!this.qnaNotification},notificationDots(){return[...this.showPollNotification?["polls"]:[],...this.showQnaNotification?["qna"]:[]]},theme(){var t,e;return null!==(e=null===(t=this.config)||void 0===t?void 0:t.theme)&&void 0!==e?e:{}},isPrivateQna(){var t;return!!(null===(t=this.config)||void 0===t?void 0:t.isPrivateQna)}},watch:{isSideBarBelow:{immediate:!0,handler(){this.isSideBarBelow&&(this.opened=!0)}},config(){this.resetOpenedTab()},tabsConfig:{deep:!0,handler(t,e){const i=ai(e,"qna.questions",[]),s=ai(t,"qna.questions",[]);i.length!==s.length&&(this.qnaNotification=s[s.length-1])}}},mounted(){const{unsubscriber:t,state:e}=this.api.onStateChange((t=>{this.isVideoElementFullScreen=ai(t,"isVideoElementFullScreen",this.isVideoElementFullScreen),this.isSideBarExpanded=!ai(this.config,"components.polls.preventExpand",!1)&&(ai(this,"tabsConfig.polls.question")&&ai(this,"tabsConfig.polls.pollType")===jk.WORD_CLOUD&&ai(t,"isSidebarExpanded",this.isSideBarExpanded))}));this.isVideoElementFullScreen=ai(e,"isVideoElementFullScreen",this.isVideoElementFullScreen),this.unsubscribers.push(t),this.unsubscribers.push(this.api.onClientAction(((t,e)=>{"clientFullscreen"===e&&(this.isClientFullScreen=t)})),this.api.onCustomAction(((t,e)=>{"sidebarToggle"===e&&this.toggleSideBar()})),this.api.onClientAction(((t,e)=>this.onClientAction(t,e)))),this.resetOpenedTab()},beforeDestroy(){for(const t of this.unsubscribers)ct(t)&&t()},methods:{onClientAction(t,e){var i;if("sideBarNotification"!==e)return;const s=ai(t,"toTab");if(!this.isVideoElementFullScreen&&this.opened&&s===(null===(i=this.openedTab)||void 0===i?void 0:i.id))return;const n=ai(t,"immediateTabSwitch");if(n)return this.pollNotificationClick(s);this.pollNotification=t,this.api.customAction(t,"sideBarNotification")},resetOpenedTab(){this.openedTab&&this.tabsConfig[this.openedTab.id]||(this.openedTab=this.tabs.find((t=>!!this.tabsConfig[t.id])),this.isSideBarExpanded=!1)},changeTab(t){this.opened=!0;const e=this.openedTab;this.openedTab=t,ai(this,"pollNotification.toTab")===this.openedTab.id&&(this.pollNotification=null,this.api.customAction(null,"sideBarNotification")),"qna"!==this.openedTab.id&&"qna"!==(null===e||void 0===e?void 0:e.id)||(this.qnaNotification=null),this.api.collapseSidebar("sidebar.wordcloud")},pollNotificationClick(t){this.api.exitFullScreen(),this.changeTab(this.tabs.find((e=>e.id===t))),this.scrollToSideBar()},toggleSideBar(){var t,e;this.opened?(this.api.collapseSidebar("sidebar.wordcloud"),this.opened=!1,(null===(t=this.openedTab)||void 0===t?void 0:t.id)&&(this.previouslyOpenedTab=this.openedTab),setTimeout((()=>this.openedTab=void 0),$k)):(this.opened=!0,(null===(e=this.previouslyOpenedTab)||void 0===e?void 0:e.id)?this.changeTab(this.previouslyOpenedTab):this.resetOpenedTab())},toggleFullscreen(){this.api.customAction(null,"clientFullscreen")},close(){},scrollToSideBar(){setTimeout((()=>{const t=this.$el,e=this.$el.getBoundingClientRect(),i=Math.max(document.documentElement.clientHeight,window.innerHeight||0),s=Math.max(document.documentElement.clientWidth,window.innerWidth||0),n=e.top>=0&&e.left>=0&&e.top+.5*e.height<=i&&e.left+.5*e.width<=s;n||(console.log("[SideBar] sidebar is out of view, scrolling to it"),window.scrollTo({top:t.offsetTop-i/4,left:t.offsetLeft-s/4,behavior:"smooth"}))}),100)}}}),EL=SL,TL=mi(EL,pb,fb,!1,null,null,null,!0),xL=TL.exports;const CL={SIDEBAR_NOTIFICATION:"side-bar-notification"};class _L{constructor(t,e,i){this.eventBus=t,this.playerStateRepo=e,this._instanceId=i}play(){this.eventBus.emit(vi.play)}pause(){console.debug("[PlayerApi] pause"),this.eventBus.emit(vi.pause)}enterFullScreen(){this.eventBus.emit(vi.enterFullScreen)}exitFullScreen(){this.eventBus.emit(vi.exitFullScreen)}enterNativeFullScreen(){this.eventBus.emit(vi.enterNativeFullScreen)}exitNativeFullScreen(){this.eventBus.emit(vi.exitNativeFullScreen)}seek(t){this.eventBus.emit(vi.seek,{seconds:t})}mute(){this.eventBus.emit(vi.mute)}unmute(){this.eventBus.emit(vi.unmute)}changeVolume(t){this.eventBus.emit(vi.changeVolume,{volume:t})}alwaysShowControlBar(t){this.eventBus.emit(vi.alwaysShowControlBar,{alwaysShowControlBar:t})}selectSubtitleTrack(t){this.eventBus.emit(vi.selectSubtitleTrack,{track:t})}disableSubtitles(){this.eventBus.emit(vi.disableSubtitles)}disableNotifications(t){this.eventBus.emit(vi.disableNotifications,t)}errorNotification(t,e=!0){this.eventBus.emit(vi.notification,{message:t,show:e},"errorNotification")}customAction(t,e){this.eventBus.emit(vi.customAction,t,e)}clientAction(t,e){this.eventBus.emit(vi.clientAction,t,e)}dispose(){this.eventBus.emit(vi.dispose)}onStateChange(t){return this.playerStateRepo.onStateChange(t)}getState(){return this.playerStateRepo.state}onCustomAction(t){return this.eventBus.on(vi.customAction,t)}onClientAction(t){return this.eventBus.on(vi.clientAction,t)}onMetadataChange(t){return this.eventBus.on(vi.metadata,t)}onSeek(t){return this.eventBus.on(vi.seek,t)}getPortalId(t){return`smvp-${CL[t]}-${this._instanceId}`}expandSidebar(t){return this.playerStateRepo.setState({isSidebarExpanded:!0},t||"api")}collapseSidebar(t){return this.playerStateRepo.setState({isSidebarExpanded:!1},t||"api")}selectLevel(t){return this.eventBus.emit(vi.selectLevel,{id:t})}}var kL=function(){var t=this,e=t._self._c;t._self._setupProxy;return e("icon-button",{attrs:{icon:t.icon,tooltip:t.labels.tooltip,"align-tooltip-left":t.isLeft,"aria-label":t.labels.ariaLabel},on:{click:t.toggleFullScreen}})},LL=[],AL=n["default"].extend({components:{IconButton:fL},props:{api:{type:Object,required:!0},labels:{type:Object,default:()=>({})},isLeft:{type:Boolean,default:!1}},data(){return{isClientFullscreen:!1,unsubscribers:[]}},computed:{icon(){return this.isClientFullscreen?Ib.minimize:Ib.maximize}},mounted(){const t=(t,e)=>{"clientFullscreen"===e&&(this.isClientFullscreen=t)},e=this.api.onClientAction(t);this.unsubscribers.push(e)},beforeDestroy(){for(const t of this.unsubscribers)ct(t)&&t()},methods:{toggleFullScreen(){this.api.customAction(null,"clientFullscreen")}}}),RL=AL,IL=mi(RL,kL,LL,!1,null,null,null,!0),DL=IL.exports,PL=function(){var t=this,e=t._self._c;t._self._setupProxy;return e("icon-button",{attrs:{icon:t.icon,tooltip:t.labels.tooltip,"align-tooltip-left":t.isLeft,"aria-label":t.labels.ariaLabel},on:{click:t.toggleFullScreen}})},OL=[],ML=n["default"].extend({components:{IconButton:fL},props:{api:{type:Object,required:!0},labels:{type:Object,default:()=>({})},isLeft:{type:Boolean,default:!1}},data(){return{isVideoElementFullScreen:!1,unsubscribers:[]}},computed:{icon(){return this.isVideoElementFullScreen?Ib.minimize:Ib.maximize}},watch:{isVideoElementFullScreen:{immediate:!0,handler(){this.api.customAction({isFullScreen:this.isVideoElementFullScreen},"fullscreen")}}},mounted(){const{unsubscriber:t,state:e}=this.api.onStateChange((t=>{this.isVideoElementFullScreen=ai(t,"isVideoElementFullScreen",this.isVideoElementFullScreen)}));this.isVideoElementFullScreen=ai(e,"isVideoElementFullScreen",this.isVideoElementFullScreen),this.unsubscribers.push(t)},beforeDestroy(){for(const t of this.unsubscribers)"function"===typeof t&&t()},methods:{toggleFullScreen(){this.isVideoElementFullScreen?this.api.exitFullScreen():this.api.enterFullScreen()}}}),NL=ML,FL=mi(NL,PL,OL,!1,null,null,null,!0),BL=FL.exports,$L=function(){var t=this,e=t._self._c;t._self._setupProxy;return e("icon-button",{attrs:{icon:t.icon,tooltip:t.labels.tooltip,"align-tooltip-left":t.isLeft,"aria-label":t.labels.ariaLabel},on:{click:t.toggleFullScreen}})},UL=[],jL=n["default"].extend({components:{IconButton:fL},props:{api:{type:Object,required:!0},labels:{type:Object,default:()=>({})},isLeft:{type:Boolean,default:!1}},data(){return{isNativeFullScreen:!1,unsubscribers:[]}},computed:{icon(){return this.isNativeFullScreen?Ib.minimize:Ib.maximize}},mounted(){const{unsubscriber:t,state:e}=this.api.onStateChange((t=>{this.isNativeFullScreen=ai(t,"isNativeFullScreen",this.isNativeFullScreen)}));this.isNativeFullScreen=ai(e,"isNativeFullScreen",this.isNativeFullScreen),this.unsubscribers.push(t)},beforeDestroy(){for(const t of this.unsubscribers)"function"===typeof t&&t()},methods:{toggleFullScreen(){this.isNativeFullScreen?this.api.exitNativeFullScreen():this.api.enterNativeFullScreen()}}}),qL=jL,GL=mi(qL,$L,UL,!1,null,null,null,!0),VL=GL.exports,HL=function(){var t=this,e=t._self._c;t._self._setupProxy;return t.iframeUrl?e("div",{staticClass:"smvp-interprefy",attrs:{"aria-label":t.labels.ariaLabel}},[e("icon-button",{attrs:{icon:"interprefy",tooltip:t.labels.tooltip,"align-tooltip-left":t.isLeft},on:{click:t.onClick}}),t.createIframe?e("div",{directives:[{name:"show",rawName:"v-show",value:t.showIframe,expression:"showIframe"}],staticClass:"smvp-interprefy-iframe-wrapper"},[e("iframe",{attrs:{src:t.iframeUrl}}),e("icon-button",{attrs:{icon:"cross"},on:{click:t.onClick}})],1):t._e()],1):t._e()},zL=[],KL=n["default"].extend({components:{IconButton:fL},props:{api:{type:Object,required:!0},config:{type:Object,default:()=>({})},labels:{type:Object,default:()=>({})},isLeft:{type:Boolean,default:!1}},data(){return{createIframe:!1,showIframe:!1}},computed:{iframeUrl(){var t;return null===(t=this.config)||void 0===t?void 0:t.iframeUrl}},methods:{onClick(){this.createIframe=!0,this.showIframe=!this.showIframe,this.showIframe&&this.api.mute(),this.api.alwaysShowControlBar(this.showIframe)}}}),WL=KL,YL=mi(WL,HL,zL,!1,null,null,null,!0),XL=YL.exports,ZL=function(){var t=this,e=t._self._c;t._self._setupProxy;return e("icon-button",{attrs:{icon:"help",tooltip:t.labels.tooltip,"align-tooltip-left":t.isLeft,"aria-label":t.labels.ariaLabel},on:{click:t.onClick}})},QL=[],JL=n["default"].extend({components:{IconButton:fL},props:{config:{type:Object,default:()=>({})},labels:{type:Object,default:()=>({})},isLeft:{type:Boolean,default:!1}},computed:{onClick(){const t=ai(this,"config.onClick",{});return ct(t)?t:()=>{}}}}),tA=JL,eA=mi(tA,ZL,QL,!1,null,null,null,!0),iA=eA.exports,sA=function(){var t=this,e=t._self._c;t._self._setupProxy;return t.hasSubtitleTracks?e("div",{staticClass:"smvp-language",attrs:{"aria-label":t.labels.ariaLabel}},[1===t.subtitleTrackCount?e("icon-button",{attrs:{icon:t.icon,tooltip:t.tooltip,"align-tooltip-left":t.isLeft},on:{click:t.onSingleTrackButtonClicked}}):t._e(),t.subtitleTrackCount>1?e("icon-button-with-dropdown",{attrs:{icon:t.icon,"close-on-click":!0,tooltip:t.tooltip,"align-tooltip-left":t.isLeft}},[e("video-player-menu",{attrs:{title:t.labels.title,items:t.subtitleMenuItems,selected:t.selectedSubtitleMenuItem},on:{select:t.onSubtitleSelected}})],1):t._e()],1):t._e()},nA=[],rA=function(){var t=this,e=t._self._c;t._self._setupProxy;return e("button-with-dropdown",{staticClass:"smvp-show-tooltip-on-hover",attrs:{"close-on-click":t.closeOnClick,"aria-label":t.ariaLabel},scopedSlots:t._u([{key:"button-content",fn:function(){return[e("icon",{attrs:{name:t.icon}}),t.tooltip?e("div",{staticClass:"smvp-tooltip"},[e("div",{staticClass:"smvp-tooltiptext",class:{left:t.alignTooltipLeft,right:!t.alignTooltipLeft}},[t._v(t._s(t.tooltip))])]):t._e()]},proxy:!0},{key:"menu-content",fn:function(){return[t._t("default")]},proxy:!0}],null,!0)})},oA=[],aA=function(){var t=this,e=t._self._c;t._self._setupProxy;return e("div",{staticClass:"smvp-button-with-dropdown",class:{"smvp-clicked":t.clicked},attrs:{"aria-label":t.ariaLabel}},[e("btn",{staticClass:"smvp-button",on:{click:()=>t.clicked=!t.clicked}},[t._t("button-content")],2),e("div",{staticClass:"smvp-content",on:{click:t.onContentClicked}},[t._t("menu-content")],2)],1)},lA=[],cA=n["default"].extend({components:{Btn:hw},props:{closeOnClick:{type:Boolean,default:!1},ariaLabel:{type:String,default:void 0}},data(){return{clicked:!1}},methods:{onContentClicked(){this.closeOnClick&&(this.clicked=!1)}}}),dA=cA,uA=mi(dA,aA,lA,!1,null,null,null,!0),hA=uA.exports,pA=n["default"].extend({components:{ButtonWithDropdown:hA,Icon:Bb},props:{icon:{type:String,required:!0},closeOnClick:{type:Boolean,default:!1},tooltip:{type:String,default:""},ariaLabel:{type:String,default:void 0},alignTooltipLeft:{type:Boolean,default:!1}}}),fA=pA,mA=mi(fA,rA,oA,!1,null,null,null,!0),vA=mA.exports,gA=function(){var t=this,e=t._self._c;t._self._setupProxy;return e("div",{staticClass:"smvp-menu"},[t.title?e("div",{staticClass:"smvp-label"},[t._v(t._s(t.title))]):t._e(),t._l(t.items,(function(i,s){return e("div",{key:s,staticClass:"smvp-option",class:{"smvp-selected":t.selected&&t.selected.id===i.id},on:{click:()=>t.onItemSelected(i)}},[t._v(t._s(i.value))])}))],2)},yA=[],bA=n["default"].extend({props:{title:{type:String,default:""},items:{type:Array,default:()=>[]},selected:{type:Object,default:()=>({})}},methods:{onItemSelected(t){this.$emit("select",t)}}}),wA=bA,SA=mi(wA,gA,yA,!1,null,null,null,!0),EA=SA.exports;function TA(t,e){return t?{id:t.id,value:e[t.label]||t.label}:null}const xA={id:"off",value:"Off"};var CA=n["default"].extend({components:{IconButton:fL,IconButtonWithDropdown:vA,VideoPlayerMenu:EA},props:{api:{type:Object,required:!0},config:{type:Object,default:()=>({})},labels:{type:Object,default:()=>({})},isLeft:{type:Boolean,default:!1}},data(){return{subtitleTracks:[],selectedSubtitleTrack:null,subtitlesEnabled:!1,unsubscribers:[]}},computed:{icon(){return this.subtitlesEnabled?Ib.captionsOn:Ib.captionsOff},subtitleTrackNameDictionary(){var t,e;return null!==(e=null===(t=this.config)||void 0===t?void 0:t.subtitleTrackNames)&&void 0!==e?e:{}},visibleSubtitleTrackLabels(){var t,e;return new Set(null!==(e=null===(t=this.config)||void 0===t?void 0:t.visibleSubtitleTrackLabels)&&void 0!==e?e:[])},isSubtitleTrackVisibilityRestricted(){var t;return!!(null===(t=this.config)||void 0===t?void 0:t.visibleSubtitleTrackLabels)},subtitleMenuItems(){const t=[];if(!this.subtitleTracks||!this.subtitleTracks.length)return t;t.push(xA);for(const e of this.subtitleTracks){const i=TA(e,this.subtitleTrackNameDictionary);i&&t.push(i)}return t},selectedSubtitleMenuItem(){return this.subtitlesEnabled?TA(this.selectedSubtitleTrack,this.subtitleTrackNameDictionary):xA},hasSubtitleTracks(){return this.subtitleTracks&&!!this.subtitleTracks.length},subtitleTrackCount(){return(this.subtitleTracks||[]).length},tooltip(){const t=ai(this.labels,"tooltip","");return 1===this.subtitleTrackCount?this.subtitlesEnabled?ai(this.labels,"tooltip_disable",t):ai(this.labels,"tooltip_enable",t):t}},mounted(){const{unsubscriber:t,state:e}=this.api.onStateChange((t=>{this.updateState(t)}));this.updateState(e),this.unsubscribers.push(t)},beforeDestroy(){for(const t of this.unsubscribers)"function"===typeof t&&t()},methods:{updateState(t){this.selectedSubtitleTrack=ai(t,"subtitleTrackActive",this.selectedSubtitleTrack),this.subtitlesEnabled=ai(t,"subtitlesEnabled",this.subtitlesEnabled),this.subtitleTracks=ai(t,"subtitleTracks",this.subtitleTracks).filter((t=>!this.isSubtitleTrackVisibilityRestricted||this.visibleSubtitleTrackLabels.has(t.label)))},onSubtitleSelected(t){if(t.id===xA.id)return void this.api.disableSubtitles();const e=this.subtitleTracks.find((e=>e.id===t.id));e&&this.api.selectSubtitleTrack(e)},onSingleTrackButtonClicked(){this.subtitlesEnabled?this.api.disableSubtitles():this.api.selectSubtitleTrack(this.subtitleTracks[0])}}}),_A=CA,kA=mi(_A,sA,nA,!1,null,null,null,!0),LA=kA.exports,AA=function(){var t=this,e=t._self._c;t._self._setupProxy;return t.showControl?e("div",{staticClass:"smvp-resolution",attrs:{"aria-label":t.labels.ariaLabel}},[e("icon-button-with-dropdown",{attrs:{icon:t.icon,"close-on-click":!0,tooltip:t.labels.tooltip,"align-tooltip-left":t.isLeft}},[e("video-player-menu",{attrs:{title:t.labels.title,items:t.resolutionMenuItems,selected:t.selectedLevel},on:{select:t.onLevelSelected}})],1)],1):t._e()},RA=[];function IA(t){return`${t.width}x${t.height}`}var DA=n["default"].extend({components:{IconButtonWithDropdown:vA,VideoPlayerMenu:EA},props:{api:{type:Object,required:!0},labels:{type:Object,default:()=>({})},isLeft:{type:Boolean,default:!1}},data(){return{unsubscribers:[],levelsAvailable:[],currentLevel:null}},computed:{icon(){return Ib.settings},resolutionMenuItems(){const t=[{id:-1,value:"Auto"}];for(let e=0;e<this.levelsAvailable.length;e++){const i=this.levelsAvailable[e];t.push({id:e,value:IA(i)})}return t},selectedLevel(){var t;if(!this.currentLevel)return null;const e=this.resolutionMenuItems.find((t=>{var e;return t.value===(null===(e=this.currentLevel)||void 0===e?void 0:e.resolution)}));return{id:null===e||void 0===e?void 0:e.id,value:null===(t=this.currentLevel)||void 0===t?void 0:t.resolution}},showControl(){return this.levelsAvailable.length>0}},mounted(){const{unsubscriber:t,state:e}=this.api.onStateChange((t=>{this.updateState(t)}));this.updateState(e),this.unsubscribers.push(t)},beforeDestroy(){for(const t of this.unsubscribers)"function"===typeof t&&t()},methods:{updateState(t){this.levelsAvailable=ai(t,"levelsAvailable",this.levelsAvailable),this.currentLevel=ai(t,"currentLevel",this.currentLevel)},onLevelSelected(t){this.api.selectLevel(t.id)}}}),PA=DA,OA=mi(PA,AA,RA,!1,null,null,null,!0),MA=OA.exports,NA=function(){var t=this,e=t._self._c;t._self._setupProxy;return e("div",{staticClass:"smvp-live-badge-container",attrs:{"aria-label":t.labels.ariaLabel}},[e("badge",{staticClass:"smvp-live-badge"},[t._v("Live")])],1)},FA=[],BA=function(){var t=this,e=t._self._c;return e("div",{staticClass:"smvp-badge"},[t._t("default")],2)},$A=[],UA={},jA=mi(UA,BA,$A,!1,null,null,null,!0),qA=jA.exports,GA=n["default"].extend({components:{Badge:qA},props:{labels:{type:Object,default:()=>({})}}}),VA=GA,HA=mi(VA,NA,FA,!1,null,null,null,!0),zA=HA.exports,KA=function(){var t=this,e=t._self._c;t._self._setupProxy;return e("icon-button",{attrs:{icon:t.icon,tooltip:t.labels.tooltip,"align-tooltip-left":t.isLeft,"aria-label":t.labels.ariaLabel},on:{click:t.togglePlayPause}})},WA=[],YA=n["default"].extend({components:{IconButton:fL},props:{api:{type:Object,required:!0},labels:{type:Object,default:()=>({})},isLeft:{type:Boolean,default:!1}},data(){return{isPlaying:!1,unsubscribers:[]}},computed:{icon(){return this.isPlaying?Ib.pause:Ib.play}},mounted(){const{unsubscriber:t,state:e}=this.api.onStateChange((t=>{this.isPlaying=ai(t,"isPlaying",this.isPlaying)}));this.isPlaying=ai(e,"isPlaying",this.isPlaying),this.unsubscribers.push(t)},beforeDestroy(){for(const t of this.unsubscribers)"function"===typeof t&&t()},methods:{togglePlayPause(){this.isPlaying?(console.debug("[PlayPauseToggle] pause"),this.api.pause()):this.api.play()}}}),XA=YA,ZA=mi(XA,KA,WA,!1,null,null,null,!0),QA=ZA.exports,JA=function(){var t=this,e=t._self._c;t._self._setupProxy;return e("icon-button",{attrs:{icon:t.icon,tooltip:t.labels.tooltip,"align-tooltip-left":t.isLeft,"aria-label":t.labels.ariaLabel},on:{click:t.togglePlayStop}})},tR=[],eR=n["default"].extend({components:{IconButton:fL},props:{api:{type:Object,required:!0},config:{type:Object,default:()=>({})},labels:{type:Object,default:()=>({})},isLeft:{type:Boolean,default:!1}},data(){return{isPlaying:!1,videoDurationSecs:0,unsubscribers:[]}},computed:{icon(){return this.isPlaying?Ib.stop:Ib.play},seekToLiveOnPlay(){return this.config.seekToLiveOnPlay}},mounted(){const{unsubscriber:t,state:e}=this.api.onStateChange(this.onStateChange);this.onStateChange(e),this.unsubscribers.push(t)},beforeDestroy(){for(const t of this.unsubscribers)"function"===typeof t&&t()},methods:{onStateChange(t){this.isPlaying=ai(t,"isPlaying",this.isPlaying),this.videoDurationSecs=ai(t,"videoDurationSecs",this.videoDurationSecs)},togglePlayStop(){this.isPlaying?(console.debug("[PlayStopToggle] pause"),this.api.pause()):(this.seekToLiveOnPlay&&this.videoDurationSecs>1&&(console.log("[PlayStopToggle] seeking to live position"),this.api.seek(this.videoDurationSecs-1)),this.api.play())}}}),iR=eR,sR=mi(iR,JA,tR,!1,null,null,null,!0),nR=sR.exports,rR=function(){var t=this,e=t._self._c;t._self._setupProxy;return e("div",{staticClass:"smvp-preview-badge-container",attrs:{"aria-label":t.labels.ariaLabel}},[e("badge",{staticClass:"smvp-preview-badge"},[t._v("Preview")])],1)},oR=[],aR=n["default"].extend({components:{Badge:qA},props:{labels:{type:Object,default:()=>({})}}}),lR=aR,cR=mi(lR,rR,oR,!1,null,null,null,!0),dR=cR.exports,uR=function(){var t=this,e=t._self._c;t._self._setupProxy;return e("icon-button",{attrs:{icon:"sidebar",tooltip:t.labels.tooltip,"align-tooltip-left":t.isLeft,"aria-label":t.labels.ariaLabel},on:{click:t.toggleSidebar}})},hR=[],pR=n["default"].extend({components:{IconButton:fL},props:{api:{type:Object,required:!0},labels:{type:Object,default:()=>({})},isLeft:{type:Boolean,default:!1}},methods:{toggleSidebar(){this.api.customAction(null,"sidebarToggle")}}}),fR=pR,mR=mi(fR,uR,hR,!1,null,null,null,!0),vR=mR.exports,gR=function(){var t=this,e=t._self._c;t._self._setupProxy;return t.videoLoaded?e("div",{staticClass:"smvp-time"},[t._v(t._s(t.formattedTime))]):t._e()},yR=[],bR=n["default"].extend({props:{api:{type:Object,required:!0},config:{type:Object,default:()=>({})}},data(){return{videoLoaded:!1,videoDurationSecs:NaN,videoElapsedSecs:0,unsubscribers:[]}},computed:{formattedTime(){const t=this.videoElapsedSecs-this.startPosition,e=this.videoDurationSecs-this.startPosition,i=wR(t),s=wR(e);return`${i||"-"} / ${s||"-"}`},startPosition(){var t,e;return null!==(e=null===(t=this.config)||void 0===t?void 0:t.startPosition)&&void 0!==e?e:0}},mounted(){const{unsubscriber:t,state:e}=this.api.onStateChange((t=>{this.updateState(t)}));this.updateState(e),this.unsubscribers.push(t)},beforeDestroy(){for(const t of this.unsubscribers)"function"===typeof t&&t()},methods:{updateState(t){var e,i,s;this.videoLoaded=null!==(e=null===t||void 0===t?void 0:t.videoLoaded)&&void 0!==e?e:this.videoLoaded,this.videoDurationSecs=null!==(i=null===t||void 0===t?void 0:t.videoDurationSecs)&&void 0!==i?i:this.videoDurationSecs,this.videoElapsedSecs=null!==(s=null===t||void 0===t?void 0:t.videoElapsedSecs)&&void 0!==s?s:this.videoElapsedSecs}}});function wR(t){if(!t||t<0)return"00:00";t=Math.round(t);const e=Math.floor(t/3600).toString(),i=(Math.floor(t/60)%60).toString(),s=(t%60).toString();return t<3600?`${i.padStart(2,"0")}:${s.padStart(2,"0")}`:`${e.padStart(2,"0")}:${i.padStart(2,"0")}:${s.padStart(2,"0")}`}var SR,ER=bR,TR=mi(ER,gR,yR,!1,null,null,null,!0),xR=TR.exports,CR=function(){var t=this,e=t._self._c;t._self._setupProxy;return null!==t.volume?e("btn",{staticClass:"smvp-volume-controls"},[e("icon",{staticClass:"smvp-toggle",attrs:{name:t.icon,"aria-label":t.labels.buttonAriaLabel},on:{click:function(e){return t.toggleMute()}}}),e("slider",{staticClass:"smvp-volume",attrs:{value:t.volume,max:1,step:.01,"aria-label":t.labels.sliderAriaLabel},on:{input:t.onVolumeSliderChanged}})],1):t._e()},_R=[],kR=function(){var t=this,e=t._self._c;t._self._setupProxy;return e("input",{ref:"slider",staticClass:"smvp-slider",style:t.rangeProgressStyle,attrs:{type:"range",min:`${t.min}`,max:`${t.max}`,step:`${t.step}`,"aria-label":t.ariaLabel},domProps:{value:`${t.value}`},on:{mousedown:function(e){return t.$emit("mousedown")},mouseup:function(e){return t.$emit("mouseup")},input:function(e){return t.onInputChanged()}}})},LR=[],AR=n["default"].extend({props:{value:{type:Number,required:!0},min:{type:Number,default:0},max:{type:Number,default:0},step:{type:Number,default:1},ariaLabel:{type:String,default:void 0}},data(){return{sliderEl:null}},computed:{rangeProgressStyle(){if(!this.max)return null;const t=(this.value-this.min)/(this.max-this.min)*100;return{background:`linear-gradient(\n                        to right,\n                        white 0%,\n                        white ${t}%,\n                        rgba(255,255,255,0.3) ${t}%,\n                        rgba(255,255,255,0.3) 100%)`}}},mounted(){this.sliderEl=this.$refs.slider},methods:{onInputChanged(){const t=Number.parseFloat(this.sliderEl.value);this.$emit("input",t)}}}),RR=AR,IR=mi(RR,kR,LR,!1,null,null,null,!0),DR=IR.exports;(function(t){t[t["muted"]=0]="muted",t[t["low"]=1]="low",t[t["mid"]=2]="mid",t[t["high"]=3]="high"})(SR||(SR={}));var PR,OR=n["default"].extend({components:{Btn:hw,Icon:Bb,Slider:DR},props:{api:{type:Object,required:!0},labels:{type:Object,default:()=>({})}},data(){return{volume:null,videoVolume:NaN,muted:!0,unsubscribers:[]}},computed:{volumeLevel(){return this.muted||!this.volume||this.volume<0?SR.muted:this.volume<.4?SR.low:this.volume<=.6?SR.mid:SR.high},icon(){switch(this.volumeLevel){case SR.muted:return Ib.volumeOff;case SR.low:return Ib.volumeLow;case SR.mid:return Ib.volumeMid;case SR.high:default:return Ib.volumeMax}}},mounted(){const{unsubscriber:t,state:e}=this.api.onStateChange((t=>{this.updateState(t)}));this.updateState(e),this.unsubscribers.push(t)},beforeDestroy(){for(const t of this.unsubscribers)"function"===typeof t&&t()},methods:{onVolumeSliderChanged(t){this.muted&&this.api.unmute(),this.api.changeVolume(t)},toggleMute(){this.muted?this.api.unmute():this.api.mute()},updateState(t){this.muted=ai(t,"muted",this.muted),this.videoVolume=ai(t,"volume",this.videoVolume),this.volume=this.muted?0:this.videoVolume}}}),MR=OR,NR=mi(MR,CR,_R,!1,null,null,null,!0),FR=NR.exports,BR=function(){var t=this,e=t._self._c;t._self._setupProxy;return e("div",{staticClass:"smvp-viewers-count-control"},[e("badge",{staticClass:"smvp-viewer-count-box"},[e("icon",{staticClass:"smvp-toggle",attrs:{name:"eye"}}),e("span",{staticClass:"count"},[t._v(t._s(t.count))])],1)],1)},$R=[],UR=n["default"].extend({components:{Icon:Bb,Badge:qA},props:{config:{type:Object,default:()=>({})}},computed:{count(){var t,e;return null!==(e=null===(t=this.config)||void 0===t?void 0:t.count)&&void 0!==e?e:0}}}),jR=UR,qR=mi(jR,BR,$R,!1,null,null,null,!0),GR=qR.exports;(function(t){t["ClientFullscreen"]="client-fullscreen",t["Fullscreen"]="fullscreen",t["NativeFullscreen"]="native-fullscreen",t["Interprefy"]="interprefy",t["Help"]="help",t["Language"]="language",t["LiveBadge"]="live-badge",t["PlayPauseToggle"]="play-pause-toggle",t["PlayStopToggle"]="play-stop-toggle",t["PreviewBadge"]="preview-badge",t["Resolution"]="resolution",t["SidebarToggle"]="sidebar-toggle",t["Time"]="time",t["Viewers"]="viewers-count",t["Volume"]="volume"})(PR||(PR={}));var VR={get[PR.ClientFullscreen](){return{id:PR.ClientFullscreen,component:DL,rightAlign:!0}},get[PR.Fullscreen](){return{id:PR.Fullscreen,component:BL,rightAlign:!0}},get[PR.NativeFullscreen](){return{id:PR.NativeFullscreen,component:VL,rightAlign:!0}},get[PR.Interprefy](){return{id:PR.Interprefy,component:XL,rightAlign:!0}},get[PR.Help](){return{id:PR.Help,component:iA,rightAlign:!0}},get[PR.Language](){return{id:PR.Language,component:LA,rightAlign:!0}},get[PR.Resolution](){return{id:PR.Resolution,component:MA,rightAlign:!0}},get[PR.LiveBadge](){return{id:PR.LiveBadge,component:zA}},get[PR.PlayPauseToggle](){return{id:PR.PlayPauseToggle,component:QA}},get[PR.PlayStopToggle](){return{id:PR.PlayStopToggle,component:nR}},get[PR.PreviewBadge](){return{id:PR.PreviewBadge,component:dR}},get[PR.SidebarToggle](){return{id:PR.SidebarToggle,component:vR,rightAlign:!0}},get[PR.Time](){return{id:PR.Time,component:xR}},get[PR.Viewers](){return{id:PR.Viewers,component:GR}},get[PR.Volume](){return{id:PR.Volume,component:FR}}},HR=function(){var t=this,e=t._self._c;t._self._setupProxy;return e("div",{staticClass:"smvp-big-play-button-widget",attrs:{"aria-label":t.labels.ariaLabel},on:{click:t.click}},[t.isPlaying?t._e():e("div",{staticClass:"smvp-play-button-overlay"},[e("icon",{attrs:{name:"play"}})],1)])},zR=[],KR=n["default"].extend({name:"BigPlayButton",components:{Icon:Bb},props:{api:{type:Object,required:!0},config:{type:Object,default:()=>({})},labels:{type:Object,default:()=>({})}},data(){return{isPlaying:!1,videoDurationSecs:0,unsubscribers:[]}},computed:{seekToLiveOnPlay(){return this.config.seekToLiveOnPlay}},mounted(){const{unsubscriber:t,state:e}=this.api.onStateChange(this.onStateChange);this.onStateChange(e),this.unsubscribers.push(t)},beforeDestroy(){for(const t of this.unsubscribers)ct(t)&&t()},methods:{onStateChange(t){this.isPlaying=ai(t,"isPlaying",this.isPlaying),this.videoDurationSecs=ai(t,"videoDurationSecs",this.videoDurationSecs)},click(){this.isPlaying?(console.debug("[BigPlayButton] pause"),this.api.pause()):(this.seekToLiveOnPlay&&this.videoDurationSecs>1&&(console.log("[PlayStopToggle] seeking to live position"),this.api.seek(this.videoDurationSecs-1)),this.api.play())}}}),WR=KR,YR=mi(WR,HR,zR,!1,null,null,null,!0),XR=YR.exports,ZR=function(){var t=this,e=t._self._c;t._self._setupProxy;return t.showUnmuteButton?e("div",{staticClass:"smvp-big-unmute-button-widget",attrs:{"aria-label":t.labels.ariaLabel},on:{click:t.click}},[e("icon",{attrs:{name:"volume-off"}})],1):t._e()},QR=[],JR=n["default"].extend({name:"BigUnmuteButton",components:{Icon:Bb},props:{api:{type:Object,required:!0},labels:{type:Object,default:()=>({})}},data(){return{muted:!0,isPlaying:!1,videoLoaded:!1,videoElapsedSecs:0,unsubscribers:[],hasBeenUnmuted:!1}},computed:{showUnmuteButton(){return!this.hasBeenUnmuted&&(!!(this.isPlaying&&this.videoLoaded&&this.videoElapsedSecs)&&this.muted)}},mounted(){const{unsubscriber:t,state:e}=this.api.onStateChange((t=>{this.onNewState(t)}));this.onNewState(e),this.unsubscribers.push(this.api.onCustomAction(((t,e)=>{"autoplayed"===e&&(this.hasBeenUnmuted=!ai(t,"muted"))})),t)},beforeDestroy(){for(const t of this.unsubscribers)ct(t)&&t()},methods:{onNewState(t){this.videoLoaded=ai(t,"videoLoaded",this.videoLoaded),this.isPlaying=ai(t,"isPlaying",this.isPlaying),this.muted=ai(t,"muted",this.muted),this.videoElapsedSecs=ai(t,"videoElapsedSecs",this.videoElapsedSecs)},click(){this.api.unmute(),this.hasBeenUnmuted=!0}}}),tI=JR,eI=mi(tI,ZR,QR,!1,null,null,null,!0),iI=eI.exports,sI=function(){var t=this,e=t._self._c;t._self._setupProxy;return e("div",{staticClass:"smvp-claps-widget"},[e("div",{ref:"animationContainer",staticClass:"smvp-floating-claps-animation"}),t.config.readonly?t._e():e("div",{staticClass:"smvp-claps-button",class:{"smvp-collapsed":!t.visible},attrs:{"aria-label":t.labels.ariaLabel},on:{click:function(e){return t.onClick()}}},[e("div",{staticClass:"smvp-clap"}),e("div",{staticClass:"smvp-tooltip"},[e("div",{staticClass:"smvp-tooltiptext right",class:{"smvp-in":t.showThrottlingMessage}},[t._v(t._s(t.labels.throttleMessage))])])])])},nI=[];class rI{constructor(t,e=0,i=0,s=0,n=0,r=!0){this.clapsToAnimate=e,this.totalClaps=i,this._newClaps=s,this._throttledClaps=n,this._skipRound=r,this.api=t}setNewClaps(t,e=0){if(this._skipRound)return this.totalClaps=t,this.clapsToAnimate+=e,void(this._skipRound=!1);const i=t-this.totalClaps;this.totalClaps=Math.max(this.totalClaps,t),this.clapsToAnimate+=i}incrementCounters(){this._newClaps++,this._throttledClaps++}sendClaps(){0!==this._newClaps&&(this.api.customAction(this._newClaps,"claps"),this.totalClaps+=this._newClaps,this._newClaps=0)}set skipRound(t){this._skipRound=t}consumeOneClap(){return!(this.clapsToAnimate<=0)&&(this.clapsToAnimate--,this.clapsToAnimate>=0)}get throttledClaps(){return this._throttledClaps}set throttledClaps(t){this._throttledClaps=t}}const oI=6e4,aI=20;var lI=n["default"].extend({name:"Claps",props:{api:{type:Object,required:!0},config:{type:Object,default:()=>({})},labels:{type:Object,default:()=>({})}},data(){return{controller:new rI(this.api),visible:!1,showThrottlingMessage:!1,unsubscribers:[],intervals:[],throttleMessageTimeout:0}},mounted(){const{unsubscriber:t,state:e}=this.api.onStateChange((t=>{this.updateState(t)}));this.updateState(e),this.unsubscribers.push(t,this.api.onMetadataChange(this.onMetadataChange.bind(this)),this.api.onClientAction(this.onClientClaps.bind(this)),this.api.onSeek(this.onSeek.bind(this))),this.clapsAnimationInterval(),this.sendClapsInterval(),this.throttleClapsInterval()},beforeDestroy(){for(const t of this.unsubscribers)ct(t)&&t();for(const t of this.intervals)clearInterval(t);clearTimeout(this.throttleMessageTimeout)},methods:{onSeek(){this.controller.skipRound=!0},onMetadataChange(t){if(!ai(this,"config.useMetadata"))return;const e=ai(t,"value.claps.totalCount"),i=ai(t,"value.claps.partialCount");e&&this.controller.setNewClaps(e,i)},onClientClaps(t,e){"claps"===e&&"number"===typeof t&&this.controller.setNewClaps(t)},updateState(t){this.visible=ai(t,"isControlBarVisible",this.visible)},onClick(){const t=ai(this,"config.maxClapsPerThrottle",aI);if(this.controller.throttledClaps>=t)return this.showThrottlingMessage=!0,clearTimeout(this.throttleMessageTimeout),void(this.throttleMessageTimeout=setTimeout((()=>{this.showThrottlingMessage=!1}),3e3));this.controller.incrementCounters(),this.newClap()},newClap(){const t=this.$refs.animationContainer,e=document.createElement("div");e.classList.add("smvp-clap"),e.classList.add("smvp-animated"),t.append(e)},sendClapsInterval(){this.intervals.push(setInterval((()=>this.controller.sendClaps()),2e3))},throttleClapsInterval(){this.intervals.push(setInterval((()=>{this.controller.throttledClaps=0,this.showThrottlingMessage=!1,clearTimeout(this.throttleMessageTimeout)}),ai(this,"config.throttleTime",oI)))},clapsAnimationInterval(){let t,e=!1;const i=s=>{t||(t=s);const n=s-t;n>=200&&(t=s,this.controller.consumeOneClap()&&this.newClap()),e||requestAnimationFrame(i)};requestAnimationFrame(i),this.unsubscribers.push((()=>e=!0))}}}),cI=lI,dI=mi(cI,sI,nI,!1,null,null,null,!0),uI=dI.exports,hI=function(){var t=this,e=t._self._c;t._self._setupProxy;return t.state!==t.STATES.STREAM_IS_LIVE?e("div",{staticClass:"smvp-countdown-widget"},[t.state===t.STATES.COUNTDOWN_ONGOING?e("div",{staticClass:"smvp-countdown-ongoing"},[e("div",{staticClass:"smvp-countdown-h3"},[t._v(t._s(t.labels.title))]),e("div",{staticClass:"smvp-countdown-p"},[t._v(t._s(t.labels.countdownMessage))]),e("div",{staticClass:"smvp-countdown-h1"},[t._v(t._s(t.countdownTime))])]):t._e(),t.state===t.STATES.COUNTDOWN_ENDED?e("div",{staticClass:"smvp-countdown-ended"},[e("div",{staticClass:"smvp-countdown-h3"},[t._v(t._s(t.labels.countdownEndedMessage))])]):t._e(),t.state===t.STATES.STREAM_ENDED?e("div",{staticClass:"smvp-stream-ended"},[e("div",{staticClass:"smvp-countdown-h3"},[t._v(t._s(t.labels.streamEnded))])]):t._e()]):t._e()},pI=[],fI=new Blob([new Uint8Array([255,227,24,196,0,0,0,3,72,1,64,0,0,4,132,16,31,227,192,225,76,255,67,12,255,221,27,255,228,97,73,63,255,195,131,69,192,232,223,255,255,207,102,239,255,255,255,101,158,206,70,20,59,255,254,95,70,149,66,4,16,128,0,2,2,32,240,138,255,36,106,183,255,227,24,196,59,11,34,62,80,49,135,40,0,253,29,191,209,200,141,71,7,255,252,152,74,15,130,33,185,6,63,255,252,195,70,203,86,53,15,255,255,247,103,76,121,64,32,47,255,34,227,194,209,138,76,65,77,69,51,46,57,55,170,170,170,170,170,170,170,170,170,170,255,227,24,196,73,13,153,210,100,81,135,56,0,170,170,170,170,170,170,170,170,170,170,170,170,170,170,170,170,170,170,170,170,170,170,170,170,170,170,170,170,170,170,170,170,170,170,170,170,170,170,170,170,170,170,170,170,170,170,170,170,170,170,170,170,170,170,170,170,170,170,170])],{type:"audio/mpeg"}),mI=new Blob([new Uint8Array([0,0,0,28,102,116,121,112,105,115,111,109,0,0,2,0,105,115,111,109,105,115,111,50,109,112,52,49,0,0,0,8,102,114,101,101,0,0,2,239,109,100,97,116,33,16,5,32,164,27,255,192,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,55,167,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,112,33,16,5,32,164,27,255,192,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,55,167,128,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,112,0,0,2,194,109,111,111,118,0,0,0,108,109,118,104,100,0,0,0,0,0,0,0,0,0,0,0,0,0,0,3,232,0,0,0,47,0,1,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,64,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,3,0,0,1,236,116,114,97,107,0,0,0,92,116,107,104,100,0,0,0,3,0,0,0,0,0,0,0,0,0,0,0,2,0,0,0,0,0,0,0,47,0,0,0,0,0,0,0,0,0,0,0,1,1,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,64,0,0,0,0,0,0,0,0,0,0,0,0,0,0,36,101,100,116,115,0,0,0,28,101,108,115,116,0,0,0,0,0,0,0,1,0,0,0,47,0,0,0,0,0,1,0,0,0,0,1,100,109,100,105,97,0,0,0,32,109,100,104,100,0,0,0,0,0,0,0,0,0,0,0,0,0,0,172,68,0,0,8,0,85,196,0,0,0,0,0,45,104,100,108,114,0,0,0,0,0,0,0,0,115,111,117,110,0,0,0,0,0,0,0,0,0,0,0,0,83,111,117,110,100,72,97,110,100,108,101,114,0,0,0,1,15,109,105,110,102,0,0,0,16,115,109,104,100,0,0,0,0,0,0,0,0,0,0,0,36,100,105,110,102,0,0,0,28,100,114,101,102,0,0,0,0,0,0,0,1,0,0,0,12,117,114,108,32,0,0,0,1,0,0,0,211,115,116,98,108,0,0,0,103,115,116,115,100,0,0,0,0,0,0,0,1,0,0,0,87,109,112,52,97,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,2,0,16,0,0,0,0,172,68,0,0,0,0,0,51,101,115,100,115,0,0,0,0,3,128,128,128,34,0,2,0,4,128,128,128,20,64,21,0,0,0,0,1,244,0,0,1,243,249,5,128,128,128,2,18,16,6,128,128,128,1,2,0,0,0,24,115,116,116,115,0,0,0,0,0,0,0,1,0,0,0,2,0,0,4,0,0,0,0,28,115,116,115,99,0,0,0,0,0,0,0,1,0,0,0,1,0,0,0,2,0,0,0,1,0,0,0,28,115,116,115,122,0,0,0,0,0,0,0,0,0,0,0,2,0,0,1,115,0,0,1,116,0,0,0,20,115,116,99,111,0,0,0,0,0,0,0,1,0,0,0,44,0,0,0,98,117,100,116,97,0,0,0,90,109,101,116,97,0,0,0,0,0,0,0,33,104,100,108,114,0,0,0,0,0,0,0,0,109,100,105,114,97,112,112,108,0,0,0,0,0,0,0,0,0,0,0,0,45,105,108,115,116,0,0,0,37,169,116,111,111,0,0,0,29,100,97,116,97,0,0,0,1,0,0,0,0,76,97,118,102,53,54,46,52,48,46,49,48,49])],{type:"video/mp4"});function vI(t){return Object.assign({muted:!1,timeout:250,inline:!1},t)}function gI(t,e){var i=t.muted,s=t.timeout,n=t.inline,r=e(),o=r.element,a=r.source,l=void 0,c=void 0,d=void 0;return o.muted=i,!0===i&&o.setAttribute("muted","muted"),!0===n&&o.setAttribute("playsinline","playsinline"),o.src=a,new Promise((function(t){l=o.play(),c=setTimeout((function(){d(!1,new Error("Timeout "+s+" ms has been reached"))}),s),d=function(e){var i=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null;o.remove(),o.srcObject=null,clearTimeout(c),t({result:e,error:i})},void 0!==l?l.then((function(){return d(!0)})).catch((function(t){return d(!1,t)})):d(!0)}))}function yI(t){return t=vI(t),gI(t,(function(){return{element:document.createElement("video"),source:URL.createObjectURL(mI)}}))}function bI(t){return t=vI(t),gI(t,(function(){return{element:document.createElement("audio"),source:URL.createObjectURL(fI)}}))}var wI={audio:bI,video:yI},SI=wI,EI=n["default"].extend({name:"Countdown",props:{api:{type:Object,required:!0},config:{type:Object,default:()=>({})},labels:{type:Object,default:()=>({})}},data(){return{unsubscribers:[],timeLeft:0,countdownInterval:0,muted:!1,STATES:{STREAM_IS_LIVE:"streamIsLive",COUNTDOWN_ONGOING:"countdownOngoing",COUNTDOWN_ENDED:"countdownEnded",STREAM_ENDED:"streamEnded"}}},computed:{startTime(){var t,e;return null!==(e=null===(t=this.config)||void 0===t?void 0:t.startTime)&&void 0!==e?e:0},streamEnded(){var t;return!!(null===(t=this.config)||void 0===t?void 0:t.streamEnded)},streamIsLive(){var t;return!!(null===(t=this.config)||void 0===t?void 0:t.streamIsLive)},state(){return this.streamEnded?this.STATES.STREAM_ENDED:this.streamIsLive?this.STATES.STREAM_IS_LIVE:this.timeLeft>0?this.STATES.COUNTDOWN_ONGOING:this.STATES.COUNTDOWN_ENDED},countdownTime(){if(!this.timeLeft||this.timeLeft<=0)return"00:00:00";const t=Iy(this.timeLeft);if(t>=1){const t=Math.floor(Number(Ly(1e3*this.startTime))/1e3),e=Iy(t-Dy());return 1!==e||this.labels.day?e>1&&!this.labels.days?"":`${e} ${1===e?this.labels.day:this.labels.days}`:""}return Oy(this.timeLeft)}},watch:{state:{immediate:!0,handler(t){console.debug("[Countdown] state changed to "+t),this.api.customAction({newState:t},"countdown"),this.resolveMutingState(),t===this.STATES.STREAM_IS_LIVE&&this.unmute(),this.api.disableNotifications(t!==this.STATES.STREAM_IS_LIVE)}},startTime(){this.updateCurrentTime()}},created(){const{unsubscriber:t,state:e}=this.api.onStateChange((t=>{this.onNewState(t)}));this.onNewState(e),this.unsubscribers.push(t,this.api.onMetadataChange((t=>this.onMetadataChange(t)))),this.updateCurrentTime(),this.resolveMutingState()},beforeDestroy(){clearInterval(this.countdownInterval);for(const t of this.unsubscribers)ct(t)&&t();this.api.disableNotifications(!1)},methods:{onNewState(t){this.muted=ai(t,"muted",this.muted);const e=["isPlaying","videoLoaded","muted"],i=Object.keys(t).some((t=>e.includes(t)));i&&this.resolveMutingState()},resolveMutingState(){this.muted||this.state===this.STATES.STREAM_IS_LIVE||this.api.mute()},updateCurrentTime(){const t=Dy();this.timeLeft=this.startTime-t,this.timeLeft<=0?(this.timeLeft=0,clearInterval(this.countdownInterval),this.countdownInterval=0):this.countdownInterval||(this.countdownInterval=setInterval((()=>this.updateCurrentTime()),1e3))},onMetadataChange(t){const e=ai(t,"value.is_live");e&&!this.streamIsLive&&this.api.customAction({streamIsLive:!0},"countdown"),e||!this.streamIsLive||this.streamEnded||this.api.customAction({streamEnded:!0},"countdown")},unmute(){return di(this,void 0,void 0,(function*(){const t=yield SI.video({muted:!1});t.result&&(console.debug("[Countdown] Unmuting",t),this.api.unmute())}))}}}),TI=EI,xI=mi(TI,hI,pI,!1,null,null,null,!0),CI=xI.exports,_I=function(){var t=this,e=t._self._c;t._self._setupProxy;return e("div",{staticClass:"smvp-invisible-overlay"})},kI=[],LI=n["default"].extend({}),AI=LI,RI=mi(AI,_I,kI,!1,null,null,null,!0),II=RI.exports,DI=function(){var t=this,e=t._self._c;t._self._setupProxy;return e("div",{staticClass:"smvp-message-overlay-widget",class:{"smvp-message-overlay-on-top":t.config.onTop}},[e("div",{staticClass:"smvp-message-overlay-dialog"},[t.config.title?e("h1",{staticClass:"smvp-message-overlay-title"},[t._v(t._s(t.config.title))]):t._e(),t.config.message&&t.config.link?e("a",{staticClass:"smvp-message-overlay-message",attrs:{href:t.config.link,target:"_blank"}},[t._v(t._s(t.config.message))]):t._e(),t.config.message&&!t.config.link?e("p",{staticClass:"smvp-message-overlay-message"},[t._v(t._s(t.config.message))]):t._e(),t.config.button?e("button",{staticClass:"smvp-message-overlay-button",on:{click:t.click}},[t._v(t._s(t.buttonText))]):t._e()])])},PI=[],OI=n["default"].extend({name:"Overlay",props:{api:{type:Object,required:!0},config:{type:Object,default:()=>({})}},computed:{buttonText(){return ai(this.config,"button.text","OK")}},methods:{click(){var t,e;this.api.customAction({clicked:!0},"message-overlay"),"function"===typeof(null===(e=null===(t=this.config)||void 0===t?void 0:t.button)||void 0===e?void 0:e.action)&&this.config.button.action()}}}),MI=OI,NI=mi(MI,DI,PI,!1,null,null,null,!0),FI=NI.exports,BI=function(){var t=this,e=t._self._c;t._self._setupProxy;return e("div",{staticClass:"smvp-overlay-widget",style:t.style},[t.imgUrl?e("img",{attrs:{src:t.imgUrl}}):t._e()])},$I=[],UI=n["default"].extend({name:"Overlay",props:{config:{type:Object,default:()=>({})}},data(){return{imgUrl:null}},computed:{style(){return{backgroundColor:ai(this,"config.color","black")}}},watch:{config(){this.setImageUrl()}},mounted(){this.setImageUrl()},methods:{setImageUrl(){return di(this,void 0,void 0,(function*(){const t=ai(this,"config.imageUrl");this.imgUrl=t&&(yield Rb(t))?t:null}))}}}),jI=UI,qI=mi(jI,BI,$I,!1,null,null,null,!0),GI=qI.exports,VI=function(){var t=this,e=t._self._c;t._self._setupProxy;return e("div",{staticClass:"smvp-polls"},[t.showPoll?e("div",{staticClass:"smvp-poll",class:{"smvp-fullscreen":t.isVideoElementFullScreen,"smvp-word-cloud-poll":t.isWordCloud}},[e("div",{staticClass:"smvp-poll-countdown-timer",class:{blinking:t.shouldCountdownBlink,hidden:!t.showCountdownTimer},style:{backgroundColor:t.countdownColor,width:t.countdownWidth+"%"}},[t._v(" ")]),t.poll.poll_type===t.PollType.MULTIPLE_CHOICE?[e("div",{staticClass:"smvp-poll-question"},[e("p",{class:t.questionClass},[t._v(t._s(t.poll.question))])])]:t._e(),t.isWordCloud?[e("div",{staticClass:"smvp-poll-question",class:{empty:t.isEmpty}},[e("p",[t._v(t._s(t.poll.question))])]),e("div",{staticClass:"smvp-polls-cloud-container"},[t.wordCloudWords.length?e("word-cloud",{staticClass:"smvp-polls-cloud-container",attrs:{words:t.wordCloudWords,config:t.wordCloudConfig,refs:"wordcloud"}}):t._e()],1)]:t._l(t.poll.rows,(function(i,s){return e("div",{key:s,staticClass:"smvp-answers-row",class:{"smvp-single-item-row":1===i.length}},t._l(i,(function(i){return e("answer",{key:i.id,attrs:{poll:t.poll,answer:i,"results-color":t.resultsColor}})})),1)}))],2):t._e()])},HI=[];function zI(t,e,i){var s=-1,n=t.length;e<0&&(e=-e>n?0:n+e),i=i>n?n:i,i<0&&(i+=n),n=e>i?0:i-e>>>0,e>>>=0;var r=Array(n);while(++s<n)r[s]=t[s+e];return r}var KI=zI;function WI(t,e,i){if(!st(i))return!1;var s=typeof e;return!!("number"==s?cf(i)&&np(e,i.length):"string"==s&&e in i)&&ee(i[e],t)}var YI=WI,XI=1/0,ZI=17976931348623157e292;function QI(t){if(!t)return 0===t?t:0;if(t=rT(t),t===XI||t===-XI){var e=t<0?-1:1;return e*ZI}return t===t?t:0}var JI=QI;function tD(t){var e=JI(t),i=e%1;return e===e?i?e-i:e:0}var eD=tD,iD=Math.ceil,sD=Math.max;function nD(t,e,i){e=(i?YI(t,e,i):void 0===e)?1:sD(eD(e),0);var s=null==t?0:t.length;if(!s||e<1)return[];var n=0,r=0,o=Array(iD(s/e));while(n<s)o[r++]=KI(t,n,n+=e);return o}var rD=nD,oD=function(){var t=this,e=t._self._c;t._self._setupProxy;return e("div",{staticClass:"smvp-answer",class:t.answerClasses,attrs:{title:t.answer.text}},[t.poll.show_results?e("div",{staticClass:"smvp-answer-progress-bar",class:{"smvp-progress-bar-correct":t.correct},style:t.cssOverrides}):t._e(),e("div",{staticClass:"smvp-answer-text"},[t._v(t._s(t.answer.text))]),t.correct?e("div",{staticClass:"smvp-icon-correct"}):t._e(),t.showResults?e("div",{staticClass:"smvp-percentages"},[t._v(t._s(t.answer.votePercentage))]):t._e()])},aD=[],lD=n["default"].extend({name:"Answer",props:{poll:{type:Object,default:()=>({})},answer:{type:Object,default:()=>({})},resultsColor:{type:String,default:()=>""}},computed:{cssOverrides(){return this.correct||!this.resultsColor?{width:this.answer.votePercentage}:{width:this.answer.votePercentage,"background-color":this.resultsColor,opacity:.3}},correct(){return this.showResults&&this.answer.correct},showResults(){return this.poll.show_results},answerClasses(){return{"smvp-selected-correct":this.correct}}}}),cD=lD,dD=mi(cD,oD,aD,!1,null,null,null,!0),uD=dD.exports,hD=n["default"].extend({name:"Polls",components:{Answer:uD,WordCloud:Bk},props:{api:{type:Object,required:!0},config:{type:Object,default:()=>({})},labels:{type:Object,default:()=>({})}},data(){return{controller:new zk,poll:void 0,isVideoElementFullScreen:!1,unsubscribers:[],countdownStart:0,countdownDuration:void 0,nowUnixTimestamp:void 0,interval:void 0,PollType:jk}},computed:{showResultsOnly(){return ai(this,"config.showResultsOnly")},resultsColor(){return ai(this,"config.resultsColor")},showPoll(){var t;return this.showResultsOnly?!!(null===(t=this.poll)||void 0===t?void 0:t.show_results):!!this.poll},isEmpty(){var t,e;return this.isWordCloud?!this.wordCloudWords.length:!(null===(e=null===(t=this.poll)||void 0===t?void 0:t.answers)||void 0===e?void 0:e.length)},isWordCloud(){var t;return(null===(t=this.poll)||void 0===t?void 0:t.poll_type)===jk.WORD_CLOUD},wordCloudConfig(){const{colors:t,font:e,large:i}=this.config;return{colors:t,font:e,large:i}},questionClass(){var t,e,i;return(null===(t=this.poll)||void 0===t?void 0:t.poll_type)!==jk.WORD_CLOUD&&Number(null===(i=null===(e=this.poll)||void 0===e?void 0:e.answers)||void 0===i?void 0:i.length)>4?"line-clamp-2":"line-clamp-3"},wordCloudWords(){var t;return(null===(t=this.poll)||void 0===t?void 0:t.results)||[]},timeLeft(){if(!this.countdownDuration)return-1;if(0===this.countdownStart)return-1;if(!this.nowUnixTimestamp)return-1;const t=this.countdownDuration-(this.nowUnixTimestamp-this.countdownStart);return!t||t<0||Number.isNaN(t)?-1:t},showCountdownTimer(){return this.timeLeft>-1},shouldCountdownBlink(){return this.timeLeft<=10&&this.timeLeft>-1},countdownWidth(){return this.countdownDuration?Math.max(0,Math.min(100,Math.floor(100*this.timeLeft/this.countdownDuration))):0},countdownColor(){return ai(this.poll,"countdown_color","#000000")}},mounted(){const{unsubscriber:t,state:e}=this.api.onStateChange((t=>{this.updateState(t)}));this.updateState(e),this.unsubscribers.push(t,this.api.onMetadataChange(this.onMetadataChange.bind(this)),this.api.onClientAction(this.onClientAction.bind(this)))},beforeDestroy(){this.clearCountdownInterval();for(const t of this.unsubscribers)ct(t)&&t()},methods:{updateState(t){this.isVideoElementFullScreen=ai(t,"isVideoElementFullScreen",this.isVideoElementFullScreen)},onMetadataChange(t){return di(this,void 0,void 0,(function*(){const e=ai(t,"value.poll",{});this.api.customAction(e,"polls")}))},onClientAction(t,e){var i;"polls"===e&&(this.poll=this.parseIncomingPoll(t),this.countdownStart=ai(this.poll,"voting_opened_timestamp",null===(i=this.poll)||void 0===i?void 0:i.fp_created_timestamp)||0,this.countdownDuration=ai(this.poll,"countdown_duration"),this.nowUnixTimestamp=Dy(),this.clearCountdownInterval(),this.poll&&this.countdownDuration&&(this.interval=setInterval((()=>{this.nowUnixTimestamp=Dy(),this.timeLeft<0&&this.clearCountdownInterval()}),1e3)))},parseIncomingPoll(t){if(!(null===t||void 0===t?void 0:t.poll_id))return;const e=(null===t||void 0===t?void 0:t.poll_type)||jk.MULTIPLE_CHOICE,i=this.controller.parseAnswers(Object.assign(Object.assign({},t),{poll_type:e}));return Object.assign(Object.assign(Object.assign({},t),{poll_type:e}),e===jk.MULTIPLE_CHOICE?{rows:rD(i,2)}:{})},clearCountdownInterval(){clearInterval(this.interval),this.interval=void 0}}}),pD=hD,fD=mi(pD,VI,HI,!1,null,null,null,!0),mD=fD.exports,vD=function(){var t=this,e=t._self._c;t._self._setupProxy;return t.question?e("div",{staticClass:"smvp-qna-widget",class:{"smvp-fullscreen":t.isVideoElementFullScreen,collapsed:t.collapsed}},[e("div",{staticClass:"smvp-question"},[e("div",{staticClass:"smvp-label-chevron-wrapper"},[e("badge",[t._v(t._s(t.labels.answerNow))]),e("div",{staticClass:"player-upvote"},[t.upvotingEnabled&&!t.collapsed?e("like-button",{attrs:{liked:t.question.upvoted||!1,likes:t.question.upvotes||0,"read-only":!t.upvotingAllowed},on:{click:t.onLikeButtonClick}}):t._e()],1),e("icon-button",{attrs:{icon:t.collapsed?t.chevronUp:t.chevronDown},on:{click:t.toggleCollapse}})],1),e("profile",{attrs:{"user-id":t.userId,"user-name":t.userName||t.labels.anonymous,"question-id":t.questionId,"profile-picture":t.profilePicture,"show-user-initials":t.showUserInitials}}),e("div",{staticClass:"smvp-body"},[e("div",{staticClass:"smvp-paragraph",domProps:{innerHTML:t._s(t.question.question)}})]),e("div",{staticClass:"live-display-upvote"},[t.upvotingEnabled?e("like-button",{attrs:{liked:!0,likes:t.question.upvotes||0,"read-only":!0,color:t.color}}):t._e()],1)],1)]):t._e()},gD=[],yD=n["default"].extend({name:"Qna",components:{IconButton:fL,LikeButton:vw,Profile:zb,Badge:qA},props:{api:{type:Object,required:!0},config:{type:Object,default:()=>({})},labels:{type:Object,default:()=>({})}},data(){return{question:void 0,isVideoElementFullScreen:!1,profilePic:null,unsubscribers:[],collapsed:!1,chevronUp:Ib.chevronUp,chevronDown:Ib.chevronDown}},computed:{isLarge(){return this.config.large||!1},upvotingEnabled(){return this.config.upvotingEnabled||!1},upvotingAllowed(){return this.config.upvotingAllowed||!1},userId(){return ai(this,"question.pid","")},userName(){return ai(this,"question.participant","")},questionId(){return ai(this,"question.id","")},profilePicture(){return ai(this,"question.profile_pic","")},showUserInitials(){return ai(this,"question.showUserInitials",!0)},color(){return ai(this,"config.color")}},mounted(){const{unsubscriber:t,state:e}=this.api.onStateChange(this.onStateChange.bind(this));this.unsubscribers.push(t,this.api.onMetadataChange(this.onMetadataChange.bind(this)),this.api.onClientAction(this.onClientQuestion.bind(this))),this.onStateChange(e)},beforeDestroy(){for(const t of this.unsubscribers)"function"===typeof t&&t()},methods:{onStateChange(t){this.isVideoElementFullScreen=ai(t,"isVideoElementFullScreen",this.isVideoElementFullScreen)},onMetadataChange(t){ai(this,"config.useMetadata")&&this.api.customAction(ai(t,"value.qna"),"qna")},onClientQuestion(t,e){"qna"===e&&(this.question=t)},toggleCollapse(){this.collapsed=!this.collapsed},onLikeButtonClick(){if(!this.question)return;const t=this.question.upvoted?"removeQuestionUpvote":"addQuestionUpvote";this.api.customAction(this.question,t)}}}),bD=yD,wD=mi(bD,vD,gD,!1,null,null,null,!0),SD=wD.exports,ED=function(){var t=this,e=t._self._c;t._self._setupProxy;return e("slider",{directives:[{name:"show",rawName:"v-show",value:t.videoLoaded,expression:"videoLoaded"}],staticClass:"smvp-seek-bar",class:{"smvp-collapsed":!t.visible},attrs:{value:t.videoElapsedSecs,max:t.videoDurationSecs,min:t.startPosition,"aria-label":t.labels.ariaLabel},on:{mousedown:t.onMouseDown,mouseup:t.onMouseUp,input:t.onProgressSliderInput}})},TD=[],xD=n["default"].extend({components:{Slider:DR},props:{api:{type:Object,required:!0},labels:{type:Object,default:()=>({})},config:{type:Object,default:()=>({})}},data(){return{videoLoaded:!1,videoDurationSecs:NaN,videoElapsedSecs:0,isBeingClicked:!1,isPlaying:!1,wasPlayingOnMouseDown:!1,visible:!1,unsubscribers:[]}},computed:{startPosition(){var t,e;return null!==(e=null===(t=this.config)||void 0===t?void 0:t.startPosition)&&void 0!==e?e:0}},mounted(){const{unsubscriber:t,state:e}=this.api.onStateChange((t=>{this.updateState(t)}));this.updateState(e),this.unsubscribers.push(t)},beforeDestroy(){for(const t of this.unsubscribers)ct(t)&&t()},methods:{onMouseDown(){this.isBeingClicked=!0,this.wasPlayingOnMouseDown=this.isPlaying,this.api.pause()},onMouseUp(){this.isBeingClicked=!1,this.wasPlayingOnMouseDown&&this.api.play()},onProgressSliderInput(t){this.videoElapsedSecs=t,this.api.seek(t)},updateState(t){this.videoLoaded=ai(t,"videoLoaded",this.videoLoaded),this.videoDurationSecs=Math.round(ai(t,"videoDurationSecs",this.videoDurationSecs)),this.visible=ai(t,"isControlBarVisible",this.visible),this.isPlaying=ai(t,"isPlaying",this.isPlaying),this.isBeingClicked||(this.videoElapsedSecs=Math.round(ai(t,"videoElapsedSecs",this.videoElapsedSecs)))}}}),CD=xD,_D=mi(CD,ED,TD,!1,null,null,null,!0),kD=_D.exports,LD=function(){var t=this,e=t._self._c;t._self._setupProxy;return e("div")},AD=[];function RD(t,e,i){return t.addEventListener(e,i),()=>t.removeEventListener(e,i)}var ID="[object String]";function DD(t){return"string"==typeof t||!x(t)&&W(t)&&z(t)==ID}var PD=DD,OD=n["default"].extend({name:"Shortcuts",props:{api:{type:Object,required:!0}},data(){return{unsubscribers:[]}},mounted(){this.unsubscribers.push(RD(document,"keydown",(t=>this.keyDownHandler(t))))},beforeDestroy(){for(const t of this.unsubscribers)ct(t)&&t()},methods:{keyDownHandler(t){if(!t||!PD(t.key))return;const e=this.api.getState();return e.isVideoElementFullScreen?"ArrowUp"===t.key?this.onArrowUpPressed(e):"ArrowDown"===t.key?this.onArrowDownPressed(e):"ArrowRight"===t.key?this.onArrowRightPressed(e):"ArrowLeft"===t.key?this.onArrowLeftPressed(e):"Escape"===t.key?this.onEscapePressed(e):" "===t.key?this.onSpacePressed(e):"Enter"===t.key?this.onEnterPressed(e):"c"===t.key||"C"===t.key?this.onCPressed():"f"===t.key||"F"===t.key?this.onFPressed(e):"m"===t.key||"M"===t.key?this.onMPressed(e):["1","2","3","4","5","6","7","8","9","0"].includes(t.key)?this.onNumberPressed(e,parseInt(t.key)):void 0:void 0},onEscapePressed(t){t.isVideoElementFullScreen&&this.api.exitFullScreen()},onSpacePressed(t){console.debug("[Shortcuts] play/pause onSpacePressed"),t.isPlaying?this.api.pause():this.api.play()},onEnterPressed(t){console.debug("[Shortcuts] play/pause onEnterPressed"),t.isPlaying?this.api.pause():this.api.play()},onCPressed(){},onFPressed(t){t.isVideoElementFullScreen?this.api.exitFullScreen():this.api.enterFullScreen()},onMPressed(t){t.muted?this.api.unmute():this.api.mute()},onArrowUpPressed(t){this.api.changeVolume(t.volume+.1)},onArrowDownPressed(t){this.api.changeVolume(t.volume-.1)},onArrowLeftPressed(t){this.api.seek(t.videoElapsedSecs-5)},onArrowRightPressed(t){this.api.seek(t.videoElapsedSecs+5)},onNumberPressed(t,e){const i=null===t||void 0===t?void 0:t.videoDurationSecs;wg(i)&&this.api.seek(i*e/10)}}}),MD=OD,ND=mi(MD,LD,AD,!1,null,null,null,!0),FD=ND.exports,BD=function(){var t=this,e=t._self._c;t._self._setupProxy;return t.imageSrc?e("div",{staticClass:"smvp-slides-widget"},[e("img",{attrs:{src:t.imageSrc,alt:"Slide Image"},on:{load:t.onImageLoad,error:t.onImageError}})]):t._e()},$D=[];const UD=10485760;class jD{constructor(t,e=UD){this.getSlidesUrl=t,this.maxCacheSize=e,this.cache=new Map,this.currentCacheSize=0}getImage(t,e){var i;return di(this,void 0,void 0,(function*(){if(!t||!wg(e))return null;const s=this._getKey(t,e);let n;return this.cache.has(s)?(n=(null===(i=this.cache.get(s))||void 0===i?void 0:i.data)||null,this.cache.get(s).lastAccess=Date.now()):n=yield this._fetchAndStoreImage({slideShowId:t,slideIndex:e}),this.preload(t,e+1),n}))}preload(t,e){if(!t||!e)return;const i=this._getKey(t,e);this.cache.has(i)||this._fetchAndStoreImage({slideShowId:t,slideIndex:e}).catch((()=>{console.log("Failed to preload image")}))}_getBase64SlideFromUrl(t,e){return di(this,void 0,void 0,(function*(){const i=this.getSlidesUrl.replace("{{slideShowId}}",t).replace("{{slideIndex}}",e.toString()),s=yield fetch(i).catch((()=>{console.log("Failed to fetch image")}));if(!s||200!==s.status)return null;const n=yield s.blob();return yield this._convertBlobToBase64(n)}))}_getKey(t,e){return`${t}-${e}`}_fetchAndStoreImage({slideShowId:t,slideIndex:e}){return di(this,void 0,void 0,(function*(){const i=yield this._getBase64SlideFromUrl(t,e);if(!i)return null;const s=this._getKey(t,e),n=this._getBase64Size(i);return this._manageCacheSize(s,n),this.cache.set(s,{data:i,lastAccess:Date.now()}),i}))}_manageCacheSize(t,e){var i;if(this.currentCacheSize+=e,this.currentCacheSize<=this.maxCacheSize)return;const s=Array.from(this.cache.entries()).map((([t,e])=>({key:t,lastAccess:e.lastAccess}))).sort(((t,e)=>t.lastAccess-e.lastAccess));for(const n of s){if(this.currentCacheSize<=this.maxCacheSize)return;if(n.key===t)continue;const e=this._getBase64Size(null===(i=this.cache.get(n.key))||void 0===i?void 0:i.data);this.currentCacheSize-=e,this.cache.delete(n.key)}}_getBase64Size(t){return t?Math.ceil(3*t.length/4):0}_convertBlobToBase64(t){return new Promise(((e,i)=>{const s=new FileReader;s.onerror=i,s.onload=()=>{e(s.result)},s.readAsDataURL(t)}))}}var qD=n["default"].extend({name:"Slides",props:{api:{type:Object,required:!0},config:{type:Object,default:()=>({})},labels:{type:Object,default:()=>({})}},data(){const t=this.config.url,e=t?new jD(t):null;return{imageSrc:null,slidesStore:e,slideshowDocId:null,slideIndex:null,unsubscribers:[],getSlideImageUrl:this.config.getSlideImageUrl}},computed:{useMetadata(){var t,e;return null===(e=null===(t=this.config)||void 0===t?void 0:t.useMetadata)||void 0===e||e}},created(){console.log("[SlidesComponent] created"),this.unsubscribers.push(this.api.onMetadataChange((t=>this.onMetadataChange(t))),this.api.onClientAction(this.onClientAction.bind(this)))},beforeDestroy(){for(const t of this.unsubscribers)ct(t)&&t()},methods:{onMetadataChange(t){if(!this.useMetadata)return;const e=ai(t,"value.slide",{});this.slideshowDocId=ai(e,"slideshowDocId"),this.slideIndex=ai(e,"slideIndex"),this.loadImage()},onClientAction(t,e){"slide"===e&&(this.useMetadata||(this.slideshowDocId=ai(t,"slideshowDocId"),this.slideIndex=ai(t,"slideIndex"),this.loadImage()))},loadImage(){return di(this,void 0,void 0,(function*(){let t=null;this.slideshowDocId&&wg(this.slideIndex)&&(this.getSlideImageUrl?t=yield this.getSlideImageUrl(this.slideshowDocId,this.slideIndex):this.slidesStore&&(t=yield this.slidesStore.getImage(this.slideshowDocId,this.slideIndex).catch((()=>null)))),this.imageSrc=t,t||this.emitHasContent(!1)}))},emitHasContent(t){console.log("[SlidesComponent] emitHasContent",t),this.$emit("has-content",t)},onImageLoad(){this.emitHasContent(!0)},onImageError(){this.emitHasContent(!1)}}}),GD=qD,VD=mi(GD,BD,$D,!1,null,null,null,!0),HD=VD.exports,zD=function(){var t=this,e=t._self._c;t._self._setupProxy;return t.subtitleVisible?e("div",{staticClass:"smvp-subtitles-container",class:`smvp-position-${t.subtitlePosition}`},[t._l(t.oldSubtitles,(function(i,s){return e("div",{key:`old-${i}-${s}`,staticClass:"smvp-subtitle"},[e("span",{staticClass:"smvp-text",style:t.fontStyles},[t._v(t._s(i))])])})),e("div",{staticClass:"new-subtitles-wrapper"},t._l(t.newSubtitles,(function(i,s){return e("div",{key:`new-${i}-${s}`,staticClass:"smvp-subtitle"},[e("span",{staticClass:"smvp-text",style:t.fontStyles},[t._v(t._s(i))])])})),0)],2):t._e()},KD=[];const WD=[{minWidth:1920,style:{fontSize:40,lineHeight:62}},{minWidth:1440,style:{fontSize:30,lineHeight:45}},{minWidth:1024,style:{fontSize:25,lineHeight:40}},{minWidth:560,style:{fontSize:17,lineHeight:27}},{minWidth:375,style:{fontSize:14,lineHeight:22}},{minWidth:0,style:{fontSize:0,lineHeight:0}}];var YD=n["default"].extend({props:{api:{type:Object,required:!0},config:{type:Object,default:()=>({})}},data(){return{rawSubtitles:[],oldSubtitles:[],newSubtitles:[],subtitlesEnabled:!1,unsubscribers:[],resizeListener:()=>{},fontStyles:{},styles:[]}},computed:{subtitleVisible(){var t,e;return this.subtitlesEnabled&&(!!(null===(t=this.newSubtitles)||void 0===t?void 0:t.length)||!!(null===(e=this.oldSubtitles)||void 0===e?void 0:e.length))},subtitlePosition(){var t;return(null===(t=this.config)||void 0===t?void 0:t.position)||"bottom"}},watch:{rawSubtitles:{immediate:!0,handler(t,e){this.resizeListener();let i=[],s=[];for(const n of t)(e.filter((t=>n===t)).length?s:i).push(n);i=QD(i),s=QD(s),this.oldSubtitles=s,this.newSubtitles=i}},subtitlesEnabled:{immediate:!0,handler(){this.resizeListener()}}},mounted(){this.interpolateFontSizes();const{unsubscriber:t,state:e}=this.api.onStateChange((t=>{this.updateState(t)}));this.updateState(e),this.api.onSeek((()=>{this.rawSubtitles=[]})),this.resizeListener=pT((()=>{const t=ai(this,"$parent.$el.offsetWidth",300);this.fontStyles=this.getFontStyles(t)}),500),this.unsubscribers.push(t,RD(window,"resize",(()=>this.resizeListener())),this.api.onCustomAction(((t,e)=>{"clientFullscreen"===e&&this.resizeListener()}))),this.resizeListener()},beforeDestroy(){for(const t of this.unsubscribers)"function"===typeof t&&t()},methods:{updateState(t){this.rawSubtitles=ai(t,"subtitles",this.rawSubtitles),this.subtitlesEnabled=ai(t,"subtitlesEnabled",this.subtitlesEnabled),ai(t,"subtitleTrackActive")&&(this.rawSubtitles=[]),t.hasOwnProperty("isVideoElementFullScreen")&&this.resizeListener()},getFontStyles(t){for(const e of this.styles)if(t>=e.minWidth)return console.log("[Subtitle component] switching to style",e.minWidth),XD(e.style,t);return XD(this.styles[this.styles.length-1].style,t)},interpolateFontSizes(){const t=WD.length;this.styles=dg(WD);for(let e=t-1;e>0;e--){const t={x:WD[e].minWidth,y:WD[e].style.fontSize},i={x:WD[e-1].minWidth,y:WD[e-1].style.fontSize};this.styles[e].style.fontSize=ZD(t,i),t.y=WD[e].style.lineHeight,i.y=WD[e-1].style.lineHeight,this.styles[e].style.lineHeight=ZD(t,i)}this.styles[0].style.fontSize=this.styles[1].style.fontSize,this.styles[0].style.lineHeight=this.styles[1].style.lineHeight}}});const XD=(t,e)=>Object.assign(Object.assign({},t),{fontSize:Math.round(t.fontSize(e))+"px",lineHeight:Math.round(t.lineHeight(e))+"px"}),ZD=(t,e)=>{const i=(e.y-t.y)/(e.x-t.x),s=t.y-i*t.x;return t=>i*t+s},QD=t=>{const e=[];for(const i of t)e.push(...i.split(/\r?\n/).filter((t=>""!==t)));return e};var JD,tP=YD,eP=mi(tP,zD,KD,!1,null,null,null,!0),iP=eP.exports,sP=function(){var t=this,e=t._self._c;t._self._setupProxy;return t.userHasInteracted?t._e():e("div",{staticClass:"smvp-user-interactor-widget",attrs:{"aria-label":t.labels.ariaLabel},on:{click:t.click}},[e("icon",{attrs:{name:"play"}})],1)},nP=[],rP=n["default"].extend({name:"UserInteractor",components:{Icon:Bb},props:{api:{type:Object,required:!0},config:{type:Object,default:()=>({})},labels:{type:Object,default:()=>({})}},data(){return{userHasInteracted:!1,isPlaying:!1,onStateChangeUnsubscriber:void 0,videoElapsedSecs:0}},computed:{destroyOnAutoPlay(){return ai(this,"config.destroyOnAutoPlay",!0)}},mounted(){return di(this,void 0,void 0,(function*(){const{unsubscriber:t,state:e}=this.api.onStateChange((t=>{this.onNewState(t)}));this.onNewState(e),this.onStateChangeUnsubscriber=t;const i=yield SI.video({muted:!1});i.result&&this.destroy()}))},beforeDestroy(){this.destroy()},methods:{click(){this.api.customAction({clicked:!0},"userInteractor"),this.api.unmute(),this.api.play(),this.destroy()},onNewState(t){this.isPlaying=ai(t,"isPlaying",this.isPlaying),this.videoElapsedSecs=ai(t,"videoElapsedSecs",this.videoElapsedSecs),this.destroyOnAutoPlay&&this.isPlaying&&this.videoElapsedSecs&&this.destroy()},destroy(){this.userHasInteracted=!0,ct(this.onStateChangeUnsubscriber)&&this.onStateChangeUnsubscriber()}}}),oP=rP,aP=mi(oP,sP,nP,!1,null,null,null,!0),lP=aP.exports;(function(t){t["BigPlayButton"]="big-play-button",t["BigUnmuteButton"]="big-unmute-button",t["Claps"]="claps",t["Countdown"]="countdown",t["MessageOverlay"]="message-overlay",t["InvisibleOverlay"]="invisible-overlay",t["Overlay"]="overlay",t["Polls"]="polls",t["Qna"]="qna",t["SeekBar"]="seek-bar",t["Shortcuts"]="shortcuts",t["Slides"]="slides",t["Subtitles"]="subtitles",t["UserInteractor"]="user-interactor"})(JD||(JD={}));const cP=({isSideBarBelow:t,hasSplitPanes:e})=>!!e&&!t;var dP,uP={get[JD.BigPlayButton](){return{id:JD.BigPlayButton,component:XR,insideVideoElement:()=>!0}},get[JD.BigUnmuteButton](){return{id:JD.BigUnmuteButton,component:iI,insideVideoElement:()=>!0}},get[JD.Claps](){return{id:JD.Claps,component:uI,insideVideoElement:t=>!cP(t)}},get[JD.Countdown](){return{id:JD.Countdown,component:CI,insideVideoElement:()=>!0}},get[JD.InvisibleOverlay](){return{id:JD.InvisibleOverlay,component:II,insideVideoElement:()=>!0}},get[JD.MessageOverlay](){return{id:JD.MessageOverlay,component:FI,insideVideoElement:()=>!1}},get[JD.Overlay](){return{id:JD.Overlay,component:GI,insideVideoElement:()=>!0}},get[JD.Qna](){return{id:JD.Qna,component:SD,insideVideoElement:()=>!1}},get[JD.Polls](){return{id:JD.Polls,component:mD,insideVideoElement:()=>!1}},get[JD.SeekBar](){return{id:JD.SeekBar,component:kD,insideVideoElement:t=>!cP(t)}},get[JD.Shortcuts](){return{id:JD.Shortcuts,component:FD,insideVideoElement:()=>!1}},get[JD.Slides](){return{id:JD.Slides,component:HD,insideVideoElement:()=>!0}},get[JD.Subtitles](){return{id:JD.Subtitles,component:iP,insideVideoElement:()=>!0}},get[JD.UserInteractor](){return{id:JD.UserInteractor,component:lP,insideVideoElement:()=>!1}}};class hP{constructor(t){this.eventBus=t,this.resizeObserver=new ResizeObserver(this.onResize.bind(this))}init(t){this.el=t,this.resizeObserver.observe(this.el),window.addEventListener("resize",this.onWindowResize.bind(this))}destroy(){this.resizeObserver.disconnect()}onResize(t){const e=t[0],{width:i,height:s}=e.contentRect;this.eventBus.emit(vi.resize,{width:i,height:s},"root")}onWindowResize(t){if(t.target===window&&this.el){const{width:t,height:e}=this.el.getBoundingClientRect();this.eventBus.emit(vi.resize,{width:t,height:e},"window")}}}class pP{constructor(){this.isStuck=!1,this.stuckTimestamp=-1/0}setState(t){return void 0===t.isStuck||(this.isStuck=t.isStuck,this.stuckTimestamp=Date.now()),this.state}get state(){return{isStuck:this.isStuck,stuckTimestamp:this.stuckTimestamp}}}class fP{constructor(){this.alwaysShowControlBar=!1,this.isPlaying=!1,this.hasPlayed=!1,this.isVideoElementFullScreen=!1,this.isNativeFullScreen=!1,this.isControlBarVisible=!1,this.isIdle=!1,this.isSidebarExpanded=!1,this.levelsAvailable=[],this.videoLoaded=!1,this.videoDurationSecs=NaN,this.videoElapsedSecs=0,this.videoHeight=0,this.volume=.5,this.muted=!1,this.subtitleTracks=[],this.subtitleTrackActive=null,this.subtitlesEnabled=!1,this.subtitles=[],this.playbackHandler=new pP}setState(t){var e,i,s,n,r,o,a,l,c,d,u,h,p,f,m,v,g,y,b,w,S,E;this.alwaysShowControlBar=null!==(e=t.alwaysShowControlBar)&&void 0!==e?e:this.alwaysShowControlBar,this.isPlaying=null!==(i=t.isPlaying)&&void 0!==i?i:this.isPlaying,this.hasPlayed=null!==(s=t.hasPlayed)&&void 0!==s?s:this.hasPlayed,this.isVideoElementFullScreen=null!==(n=t.isVideoElementFullScreen)&&void 0!==n?n:this.isVideoElementFullScreen,this.isNativeFullScreen=null!==(r=t.isNativeFullScreen)&&void 0!==r?r:this.isNativeFullScreen,this.isControlBarVisible=null!==(o=t.isControlBarVisible)&&void 0!==o?o:this.isControlBarVisible,this.isIdle=null!==(a=t.isIdle)&&void 0!==a?a:this.isIdle,this.isSidebarExpanded=null!==(l=t.isSidebarExpanded)&&void 0!==l?l:this.isSidebarExpanded,this.levelsAvailable=null!==(c=t.levelsAvailable)&&void 0!==c?c:this.levelsAvailable,this.currentLevel=null!==(d=t.currentLevel)&&void 0!==d?d:this.currentLevel,this.videoLoaded=null!==(u=t.videoLoaded)&&void 0!==u?u:this.videoLoaded,this.videoDurationSecs=null!==(h=t.videoDurationSecs)&&void 0!==h?h:this.videoDurationSecs,this.videoElapsedSecs=null!==(p=t.videoElapsedSecs)&&void 0!==p?p:this.videoElapsedSecs,this.videoHeight=null!==(f=t.videoHeight)&&void 0!==f?f:this.videoHeight,this.videoSource=null!==(m=t.videoSource)&&void 0!==m?m:this.videoSource,this.volume=null!==(v=t.volume)&&void 0!==v?v:this.volume,this.muted=null!==(g=t.muted)&&void 0!==g?g:this.muted,this.subtitleTracks=null!==(y=t.subtitleTracks)&&void 0!==y?y:this.subtitleTracks,this.subtitleTrackActive=null!==(b=t.subtitleTrackActive)&&void 0!==b?b:this.subtitleTrackActive,this.subtitlesEnabled=null!==(w=t.subtitlesEnabled)&&void 0!==w?w:this.subtitlesEnabled,this.subtitles=null!==(S=t.subtitles)&&void 0!==S?S:this.subtitles;const T=this.playbackHandler.setState(null!==(E=t.playback)&&void 0!==E?E:{});return Object.assign(Object.assign({},t),{playback:T})}get state(){return{alwaysShowControlBar:this.alwaysShowControlBar,isPlaying:this.isPlaying,hasPlayed:this.hasPlayed,isVideoElementFullScreen:this.isVideoElementFullScreen,isNativeFullScreen:this.isNativeFullScreen,isControlBarVisible:this.isControlBarVisible,isIdle:this.isIdle,isSidebarExpanded:this.isSidebarExpanded,levelsAvailable:this.levelsAvailable,currentLevel:this.currentLevel,videoLoaded:this.videoLoaded,videoDurationSecs:this.videoDurationSecs,videoElapsedSecs:this.videoElapsedSecs,videoHeight:this.videoHeight,videoSource:this.videoSource,volume:this.volume,muted:this.muted,subtitleTracks:this.subtitleTracks,subtitleTrackActive:this.subtitleTrackActive,subtitlesEnabled:this.subtitlesEnabled,subtitles:this.subtitles,playback:this.playbackHandler.state}}}class mP{constructor(t=new Ri){this.eventBus=t,this.rootStateHandler=new fP}onStateChange(t){const e=({partial:e,previousState:i},s)=>{t(e,i,s)},i=this.eventBus.on(vi.stateChange,e);return{unsubscriber:i,state:this.state}}emitState(t,e,i){this.eventBus.emit(vi.stateChange,{partial:t,previousState:e},i)}setState(t,e){const i=this.state,s=this.rootStateHandler.setState(t);this.emitState(s,i,e)}get state(){return this.rootStateHandler.state}}var vP=new Uint8Array(16);function gP(){if(!dP&&(dP="undefined"!==typeof crypto&&crypto.getRandomValues&&crypto.getRandomValues.bind(crypto)||"undefined"!==typeof msCrypto&&"function"===typeof msCrypto.getRandomValues&&msCrypto.getRandomValues.bind(msCrypto),!dP))throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");return dP(vP)}var yP=/^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;function bP(t){return"string"===typeof t&&yP.test(t)}for(var wP=bP,SP=[],EP=0;EP<256;++EP)SP.push((EP+256).toString(16).substr(1));function TP(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,i=(SP[t[e+0]]+SP[t[e+1]]+SP[t[e+2]]+SP[t[e+3]]+"-"+SP[t[e+4]]+SP[t[e+5]]+"-"+SP[t[e+6]]+SP[t[e+7]]+"-"+SP[t[e+8]]+SP[t[e+9]]+"-"+SP[t[e+10]]+SP[t[e+11]]+SP[t[e+12]]+SP[t[e+13]]+SP[t[e+14]]+SP[t[e+15]]).toLowerCase();if(!wP(i))throw TypeError("Stringified UUID is invalid");return i}var xP=TP;function CP(t,e,i){t=t||{};var s=t.random||(t.rng||gP)();if(s[6]=15&s[6]|64,s[8]=63&s[8]|128,e){i=i||0;for(var n=0;n<16;++n)e[i+n]=s[n];return e}return xP(s)}var _P=CP;class kP{constructor(t){this.playerStateRepository=t,this.stuckCount=0,this.lastStuckCount=0,this.stuckDuration=0,this.listeners=[],this.lastSnapshotTimestamp=-1/0,this.listeners.push(this.playerStateRepository.onStateChange(this.onStateChange.bind(this)).unsubscriber)}dispose(){for(const t of this.listeners)t()}onStateChange(t,e){var i,s;if(!t.hasOwnProperty("playback"))return;const n=null===(i=t.playback)||void 0===i?void 0:i.isStuck,r=null===(s=e.playback)||void 0===s?void 0:s.isStuck;n&&!1===r?this.stuckCount++:!1===n&&r&&(this.stuckDuration+=this.calculateStuckDuration(e))}calculateStuckDuration(t){var e,i;const s=Math.max(null!==(i=null===(e=t.playback)||void 0===e?void 0:e.stuckTimestamp)&&void 0!==i?i:-1/0,this.lastSnapshotTimestamp);return Date.now()-s}get snapshot(){var t;const e=this.stuckCount-this.lastStuckCount,i=(null===(t=this.state.playback)||void 0===t?void 0:t.isStuck)?this.stuckDuration+this.calculateStuckDuration(this.state):this.stuckDuration;return this.lastStuckCount=this.stuckCount,this.lastSnapshotTimestamp=Date.now(),this.stuckDuration=0,{stuckCount:this.stuckCount,stuckDiff:e,stuckDurationDiff:Math.ceil(i/1e3)}}get state(){return this.playerStateRepository.state}}function*LP(t){try{while(1)yield t.snapshot}finally{t.dispose()}}function AP(t){const e=new kP(t);return LP(e)}class RP{static get connection(){return ai(navigator,"connection")||ai(navigator,"mozConnection")||ai(navigator,"webkitConnection")||{downlink:"unsupported",effectiveType:"unsupported",rtt:"unsupported",saveData:"unsupported"}}}const IP="SMVP analytics provider",DP=3e4,PP=12e4;class OP{constructor(t,e,i=DP,s=PP){this.eventBus=t,this.playerStateRepository=e,this.intervalTimer=i,this.newSessionIdThreshhold=s,this.video_session_id=void 0,this.unsubscribers=[],this.lastSnapshotTimestamp=-1/0,this.lastElapsedSecs=-1/0,console.debug(`[${IP}] initializing...`),this.playbackStuckTracker=AP(e);const{state:n,unsubscriber:r}=e.onStateChange(this.onStateChange.bind(this));this.unsubscribers.push(r),n.isPlaying&&this.startSession(),console.debug(`[${IP}] done initializing`)}dispose(){this.endSession(),this.playbackStuckTracker.next(),this.playbackStuckTracker.return(void 0);for(const t of this.unsubscribers)"function"===typeof t&&t()}getStats(t){const e=Object.assign({},this.snapshot);return(null===t||void 0===t?void 0:t.videoElapsedSecs)&&e.player&&(e.player.video_time=t.videoElapsedSecs),(null===t||void 0===t?void 0:t.videoSource)&&e.player&&(e.player.source={src:t.videoSource,type:Sg(t.videoSource)}),e}onStateChange(t,e,i){if(this.onSourceChange(t,e),!0===t.isPlaying&&!1===e.isPlaying)return this.startSession();if(!1===t.isPlaying&&!0===e.isPlaying)return this.endSession();const s=t.videoElapsedSecs||0;if(i===vi.seek&&s>=0&&this.videoSessionId)return this.resetSession(e);this.doTrackingIteration()}onSourceChange(t,e){if(!t.videoSource||!PD(t.videoSource))return;const i=(e.videoSource||"").split("?")[0],s=t.videoSource.split("?")[0];i!==s&&this.resetSession(e)}resetSession(t){this.endSession(t),t.isPlaying&&this.startSession()}startSession(){this.video_session_id=_P();const t=this.trackAnalyticsSnapshot();this.lastSnapshotTimestamp=Date.now(),this.lastElapsedSecs=this.videoElapsedSecs,console.debug(`[${IP}] session started. ${this.videoSessionId}`,t.player)}endSession(t){if(!this.videoSessionId)return;const e=this.trackAnalyticsSnapshot(t);console.debug(`[${IP}] session ending. ${this.videoSessionId}`,e.player),this.video_session_id=void 0}doTrackingIteration(){if(!this.videoSessionId)return;const t=Date.now()-this.lastSnapshotTimestamp;if(t>=this.newSessionIdThreshhold)this.endSession(),this.startSession();else if(t>=this.intervalTimer&&this.lastElapsedSecs!==this.videoElapsedSecs){const t=this.trackAnalyticsSnapshot();this.lastSnapshotTimestamp=Date.now(),this.lastElapsedSecs=this.videoElapsedSecs,console.debug(`[${IP}] interval snapshot emitted. ${this.videoSessionId}`,t.player)}}trackAnalyticsSnapshot(t){const e=this.getStats(t);return this.emitToClient(e),e}emitToClient(t){this.eventBus.emit(vi.analytics,{stats:t,getUpdatedStats:()=>this.getStats()},"hls")}get videoSessionId(){return this.video_session_id}get videoElapsedSecs(){var t;return null===(t=this.playerStateRepository.state)||void 0===t?void 0:t.videoElapsedSecs}get snapshot(){var t;const{stuckDiff:e,stuckDurationDiff:i}=this.playbackStuckTracker.next().value||{},s=null===(t=this.playerStateRepository.state)||void 0===t?void 0:t.videoSource;return Object.assign({name:"video",player:{source:{src:s,type:Sg(s)},buffer_count:e,buffer_duration:i,video_time:this.videoElapsedSecs},network:RP.connection,video_session_id:this.videoSessionId},this.levelStats)}get levelStats(){var t;const e=null===(t=this.playerStateRepository.state)||void 0===t?void 0:t.currentLevel;if(!e)return{};const i=e.url,s=PD(i)?i.substring(i.lastIndexOf("/")+1):void 0;return{playlist_uri:i,playlist_id:s,playlist_bandwidth:e.bandwidth,playlist_codecs:e.codecs,playlist_resolution:e.resolution}}}var MP=n["default"].extend({name:"VideoPlayer",components:{VideoPlayerCore:hb,SideBar:xL,PortalTarget:$i.YC},props:{sourceUrl:{type:String,required:!0},useCredentials:{type:Boolean,default:!1},config:{type:Object,default:null},autoplay:{type:Boolean,default:!1},preload:{type:Boolean,default:!1},loopVideo:{type:Boolean,default:!1},restrictMetadata:{type:Boolean,default:!1},metadataTypes:{type:Array,default:()=>["spotme_metadata"]},contentId:{type:String,default:void 0},cmcdSessionId:{type:String,default:void 0},hlsConfigOverwrites:{type:String,default:void 0},eventBus:{type:Object,default:()=>new Ri}},data(){const t=_P(),e=new mP,i=new _L(this.eventBus,e,t),s=[],n=new hP(this.eventBus),r=new OP(this.eventBus,e);return{playerStateRepository:e,analyticsProvider:r,api:i,unsubscribers:s,resizer:n,verticalDisplay:!1,widgets:[],controlsLeft:[],controlsRight:[],splitPaneHasContent:!1}},computed:{configComponents(){var t,e;let i=["invisible-overlay"];this.isIframeContent&&(i=[]);const s=[...i,...null!==(e=null===(t=this.config)||void 0===t?void 0:t.components)&&void 0!==e?e:[]];return[...new Set(s)]},hasControlBar(){var t,e,i,s;return!(null===(e=null===(t=this.controlsLeft)||void 0===t?void 0:t.length)||void 0===e||!e)||!(null===(s=null===(i=this.controlsRight)||void 0===i?void 0:i.length)||void 0===s||!s)},hideControlBar(){var t;return!!(null===(t=this.config)||void 0===t?void 0:t.hideControlBar)},alwaysCollapseControlBarOnIdle(){var t;return!!(null===(t=this.config)||void 0===t?void 0:t.alwaysCollapseControlBarOnIdle)},hideMouseOnIdle(){var t;return!!(null===(t=this.config)||void 0===t?void 0:t.hideMouseOnIdle)},isIframeContent(){var t;return!!(null===(t=this.config)||void 0===t?void 0:t.isIframeContent)},disableNativePip(){var t,e;return null===(e=null===(t=this.config)||void 0===t?void 0:t.disableNativePip)||void 0===e||e},thumbnail(){var t,e;return null!==(e=null===(t=this.config)||void 0===t?void 0:t.thumbnail)&&void 0!==e?e:""},labels(){var t,e;return null!==(e=null===(t=this.config)||void 0===t?void 0:t.labels)&&void 0!==e?e:{}},sideBarConfig(){var t;return null===(t=this.config)||void 0===t?void 0:t.sideBar},isSideBarBelow(){var t;return!!(null===(t=this.config)||void 0===t?void 0:t.isSideBarBelow)},isWebinar(){var t;return!!(null===(t=this.config)||void 0===t?void 0:t.isWebinar)},darkMode(){var t,e;return null!==(e=null===(t=this.config)||void 0===t?void 0:t.darkMode)&&void 0!==e?e:{}},noPlayer(){var t;return!!(null===(t=this.config)||void 0===t?void 0:t.noPlayer)},sideBarNotificationPortalId(){return this.api.getPortalId("SIDEBAR_NOTIFICATION")},large(){var t;return!!(null===(t=this.config)||void 0===t?void 0:t.large)},isVertical(){return this.large&&this.verticalDisplay},cssOverrides(){var t,e,i,s;return{"--smvp-dark-mode-background-color":this.darkMode["background-color"],"--smvp-dark-mode-color":this.darkMode.color,"--smvp-dark-mode-border-color":this.darkMode["border-color"],"--smvp-tab-active-color":null===(e=null===(t=this.sideBarConfig)||void 0===t?void 0:t.theme)||void 0===e?void 0:e.tabHighlightColor,"--smvp-btn-color":(null===(s=null===(i=this.sideBarConfig)||void 0===i?void 0:i.theme)||void 0===s?void 0:s.btnBackgroundColor)||"rgb(54, 135, 250)"}},widgetsInside(){return this.widgets.filter((t=>{var e,i,s;return(null===(e=t.insideVideoElement)||void 0===e?void 0:e.call(t,{isSideBarBelow:this.isSideBarBelow,hasSplitPanes:this.hasSplitPanes}))&&!(null===(i=t.config)||void 0===i?void 0:i.splitPane)&&!(null===(s=t.config)||void 0===s?void 0:s.behindVideoElement)}))},widgetsOutside(){return this.widgets.filter((t=>{var e,i,s;return!(null===(e=t.insideVideoElement)||void 0===e?void 0:e.call(t,{isSideBarBelow:this.isSideBarBelow,hasSplitPanes:this.hasSplitPanes}))&&!(null===(i=t.config)||void 0===i?void 0:i.splitPane)&&!(null===(s=t.config)||void 0===s?void 0:s.behindVideoElement)}))},widgetsSplitPane(){return this.widgets.filter((t=>{var e,i;return(null===(e=t.config)||void 0===e?void 0:e.splitPane)&&!(null===(i=t.config)||void 0===i?void 0:i.behindVideoElement)}))},widgetsBehind(){return this.widgets.filter((t=>{var e;return null===(e=t.config)||void 0===e?void 0:e.behindVideoElement}))},hlsConfigOverwritesObject(){if(this.hlsConfigOverwrites)try{return JSON.parse(this.hlsConfigOverwrites)}catch(t){return void console.error("Invalid hlsConfigOverwrites",t)}},startPosition(){var t,e;return null!==(e=null===(t=this.hlsConfigOverwritesObject)||void 0===t?void 0:t.startPosition)&&void 0!==e?e:0},hiveConfig(){var t,e;return null!==(e=null===(t=this.config)||void 0===t?void 0:t.hiveConfig)&&void 0!==e?e:{}},defaultSplitPaneSize(){var t,e;return null!==(e=null===(t=this.config)||void 0===t?void 0:t.defaultSplitPaneSize)&&void 0!==e?e:50},hasSplitPanes(){return this.splitPaneHasContent&&!!this.widgetsSplitPane.length}},watch:{sourceUrl:{immediate:!0,handler(){this.playerStateRepository.setState({videoSource:this.sourceUrl})}},startPosition(t,e){var i,s,n;if(t!==e){const e=null!==(n=null===(s=null===(i=this.playerStateRepository)||void 0===i?void 0:i.state)||void 0===s?void 0:s.videoElapsedSecs)&&void 0!==n?n:0,r=Math.max(null!==t&&void 0!==t?t:0,e);r>e&&this.api.seek(r)}}},mounted(){var t,e,i,s;this.buildControlsAndWidgets();const{unsubscriber:n}=this.playerStateRepository.onStateChange((t=>{this.$emit("state-change",t)}));this.unsubscribers.push(n,this.eventBus.on(vi.error,((t,e)=>{this.$emit("player-error",t,e)})),this.eventBus.on(vi.customAction,((t,e)=>{this.$emit("custom-action",t,e)})),this.eventBus.on(vi.metadata,(t=>{this.$emit("metadata",t)})),this.eventBus.on(vi.analytics,((t,e)=>{this.$emit("player-analytics",t,e)})),this.eventBus.on(vi.resize,(t=>{const{width:e,height:i}=t;this.verticalDisplay=i>e}))),(null===(e=null===(t=this.$refs)||void 0===t?void 0:t.videoPlayerCore)||void 0===e?void 0:e.$el)&&this.resizer.init(null===(s=null===(i=this.$refs)||void 0===i?void 0:i.videoPlayerCore)||void 0===s?void 0:s.$el)},beforeUpdate(){this.addGetApiToWCProps(),this.buildControlsAndWidgets()},beforeDestroy(){var t;for(const e of this.unsubscribers)"function"===typeof e&&e();null===(t=this.analyticsProvider)||void 0===t||t.dispose()},methods:{buildControlsAndWidgets(){this.widgets=this.buildComponentArray(this.getWidget),this.controlsLeft=this.buildComponentArray(((t,e,i)=>this.getControl(t,e,!1,i))),this.controlsRight=this.buildComponentArray(((t,e,i)=>this.getControl(t,e,!0,i)))},buildComponentArray(t){return this.configComponents.reduce(((e,i)=>{const s="string"!==typeof i?ai(i,"id",""):i,n=ai(i,"config",{}),r=ai(i,"hidden",!1),o=t(s,n,r);return[...e,...o?[o]:[]]}),[])},getControl(t,e,i=!1,s){const n=ai(VR,t);if(!n)return!1;const r=Object.assign(Object.assign({},this.withClientConfig(n,e)),{labels:ai(this.labels,t,{}),hidden:s});return i?ai(VR,`${t}.rightAlign`)&&r:!ai(VR,`${t}.rightAlign`)&&r},getWidget(t,e,i){return Object.assign(Object.assign({},this.withClientConfig(ai(uP,t),e)),{labels:ai(this.labels,t,{}),hidden:i})},withClientConfig(t,e){return Object.assign(Object.assign({},t),{config:Object.assign(Object.assign(Object.assign({startPosition:this.startPosition},ai(t,"config",{})),{large:this.large}),e)})},getApi(){return this.api},addGetApiToWCProps(){const t=this.$el.getRootNode();t&&t instanceof ShadowRoot&&!ai(t,"host.getApi")&&(t.host.getApi=this.getApi)},onSplitPaneHasContent(t){this.splitPaneHasContent=t}}}),NP=MP;function FP(t){var e=i(8833);e.__inject__&&e.__inject__(t)}var BP=mi(NP,S,E,!1,FP,null,null,!0),$P=BP.exports;window.customElements.define("spotme-video-player",w(n["default"],$P))}()})();

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("timers").setImmediate)
},{"timers":1216}],1106:[function(require,module,exports){
module.exports = require('./lib/webcomponent/spotme-video-player.min.js');

},{"./lib/webcomponent/spotme-video-player.min.js":1105}],1107:[function(require,module,exports){
var _ = require('underscore');
var missingImages = {};

var setFallbackImage = function(element, attr) {
    var errorUrl = (attr || {}).onErrorSrc || element.attr('on-error-src');
    var errored = element.attr('errored');

    if (!errored && errorUrl) {
        element.attr('errored', true);
    }

    if (errorUrl) {
        element[0].src = errorUrl;
        markLoaded(element);
    }
}

var markLoaded = function(element) {
    return element.addClass('asset-loaded')
        .parent()
        .addClass('child-asset-loaded')
}

var loadImg = function (elem, urls, callback, attr, onErrorFn) {
    callback = callback || function () {};

    var allMissing = _.every(urls, function (url) {
        return missingImages[url];
    });

    if (allMissing) {
        setFallbackImage(elem, attr);
        if (_.isFunction(onErrorFn)) {
            onErrorFn();
        }
        return callback();
    }

    var img = new Image();
    var startedAt = Date.now();

    if (!_.isArray(urls)) {
        urls = [urls];
    }
    urls = _.compact(urls);
    if (!urls.length) {
        return callback();
    }

    var url = urls.shift();

    img.onload = function (e) {
        var loadTime = Date.now() - startedAt;

        var el = elem[0];
        if (el.tagName === 'IMG') {
            el.src = url;
        } else {
            el.style.backgroundImage = 'url("' + url.replace('"', '\"').replace('\\', '\\\\') + '")';

            var maxRatio = el.getAttribute('data-max-ratio');

            if (maxRatio) {
                maxRatio = parseInt(maxRatio, 10);
                var ratio = this.width / ( this.height || 1 );
                var padding = ( 1 / (ratio || 1) ) * 100;

                if (padding > maxRatio) {
                    padding = maxRatio;
                }

                el.style.paddingBottom = padding + '%';
            }
        }

        markLoaded(elem).addClass(loadTime > 500 ? 'animate-child-asset-load' : '');

        callback(e, this);
    };
    img.onerror = function () {
        missingImages[url] = true;
        url = urls.shift();
        setFallbackImage(elem, attr);
        if (_.isFunction(onErrorFn)) {
            onErrorFn();
        }
    };
    img.src = url;
};

function LoadImgProvider () {
    this.$get = function () {
        return loadImg;
    };
}

function assetUrlsFilter($filter) {
    // $injector.has(...) works only within the same angular module
    // so there is no other reliable way to know if a filter exists then using try catch
    try {
        return $filter('assetUrls');
    } catch (err) {
        if (err.message.indexOf('$injector:unpr') !== -1) {
            var assetUrl = $filter('assetUrl');
            return function(src) {
                return [ assetUrl(src) ]
            };
        } else {
            throw err;
        }
    }
}

function AssetSrcDirective ($filter) {
    var assetUrls = assetUrlsFilter($filter);

    return {
        scope: {
            onerror: '&'
        },
        link: function (scope, elem, attr) {
            var observer = null;
            var cancelObserver = function () {
                if (!observer) return;
                if (attr.watchSrc === 'true') { return; }

                observer();
                observer = null;
            };
            observer = attr.$observe('assetSrc', function (src) {
                loadImg(elem, assetUrls(src), cancelObserver, attr, scope.onerror);
            });
            scope.$on('$destroy', cancelObserver);
        },
    };
}

function BackgroundAssetSrcDirective ($filter) {
    var assetUrls = assetUrlsFilter($filter);

    return {
        priority: 0,
        scope: {
            onerror: '&'
        },
        link: function (scope, elem, attr) {
            var observer = null;
            var cancelObserver = function () {
                if (!observer) return;
                if (attr.watchSrc === 'true') return;

                observer();
                observer = null;
            };
            observer = attr.$observe('backgroundAssetSrc', function (src) {
                if (!src || !src.length) return;

                loadImg(elem, assetUrls(src), _.noop, attr, scope.onerror);
                cancelObserver();
            });
            scope.$on('$destroy', cancelObserver);
        }
    };
}

module.exports = 'assetUtils';
angular.module(module.exports, [])
.provider('loadAssetImg', LoadImgProvider)
    .directive('assetSrc', ['$filter', AssetSrcDirective])
    .directive('backgroundAssetSrc', ['$filter', BackgroundAssetSrcDirective]);

},{"underscore":1217}],1108:[function(require,module,exports){
var throttle = require('lodash').throttle;

var FORM_FACTORS = ['Phone', 'Tablet', 'Desktop'];

var DATA_BROWSER = [
    {subString: 'Chrome',  identity: 'Chrome' },
    {subString: 'MSIE',    identity: 'Explorer' },
    {subString: 'Trident', identity: 'Explorer' },
    {subString: 'Edge',    identity: 'Explorer' },
    {subString: 'Firefox', identity: 'Firefox' },
    {subString: 'iPad',    identity: 'iOS' },
    {subString: 'iPod',    identity: 'iOS' },
    {subString: 'iPhone',  identity: 'iOS' },
    {subString: 'Safari',  identity: 'Safari' },
    {subString: 'Opera',   identity: 'Opera' }
];

var DATA_MOBILE_BROWSER = [
    {subString: 'Android', identity: 'android' },
    {subString: 'CriOS',   identity: 'mobile-chrome' },
    {subString: 'Version', identity: 'mobile-safari' }
];

// Based on Bootstrap's screen breakpoints
// http://getbootstrap.com/css/#responsive-utilities-classes
var formFactorForWidth = function(width) {
    if (width >= 992) {
        return 'desktop';
    }

    if (width >= 768) {
        return 'tablet';
    }

    return 'phone';
};

var detectDeviceCharacteristics = function(
    $rootScope,
    $window,
    $document,
    $injector,
    $log
) {
    $rootScope.device = {};

    var detectTouchScreen = function() {
        // based on: http://git.io/vWhU2
        $rootScope.device.hasTouchScreen = !!(
            'ontouchstart' in $window ||
            $window.navigator.maxTouchPoints > 0 ||
            $window.navigator.msMaxTouchPoints > 0 ||
            ($window.DocumentTouch && $document[0] instanceof DocumentTouch)
        );

        $log.debug(
            '[DeviceProvider] hasTouchScreen',
            $rootScope.device.hasTouchScreen
        );
    };

    var $eventBus;
    var detectFormFactor = function() {
        var nativeFormFactor;
        // native apps provide this value
        if ($injector.has('DEVICE_FORM_FACTOR')) {
            nativeFormFactor = $injector.get('DEVICE_FORM_FACTOR');
        }
        if (!$eventBus && $injector.has('$eventBus')) {
            $eventBus = $injector.get('$eventBus');
        }

        var guessFormFactor = function() {
            var prevFormFactor = $rootScope.device.formFactor;
            var formFactor =
                nativeFormFactor || formFactorForWidth($window.innerWidth);
            if (prevFormFactor === formFactor) {
                return;
            }

            // close eyes
            // it's faster than...
            var prevFormFactorClassName = prevFormFactor + '-form-factor';
            var newFormFactorClassName = formFactor + '-form-factor';

            // keeping this line for backwards-compatibility
            $document
                .find('body')
                .removeClass(prevFormFactorClassName)
                .addClass(newFormFactorClassName);

            angular
                .element('.decorate-with-device-form-factor')
                .removeClass(prevFormFactorClassName)
                .addClass(newFormFactorClassName);
            // ...$digest()
            // open eyes

            $rootScope.device.formFactor = formFactor;

            var n = FORM_FACTORS.length;
            while (n--) {
                var factor = FORM_FACTORS[n];
                var isKey = 'is' + factor;
                $rootScope.device[isKey] = factor.toLowerCase() === formFactor;
            }

            $log.debug('[DeviceService] form factor change', $rootScope.device);
            if ($eventBus) {
                $eventBus.emit('formFactorChange', formFactor);
            }
        };

        if (!nativeFormFactor) {
            angular
                .element($window)
                .on('resize', throttle(guessFormFactor, 500));
        }

        guessFormFactor();
    };

    var detectObjectFit = function() {
        if ('objectFit' in document.documentElement.style === false) {
            $rootScope.device.objectfit = false;
            $rootScope.device.features += ' no-objectfit';
        } else {
            $rootScope.device.objectfit = true;
            $rootScope.device.features += ' objectfit';
        }
    };

    var init = function() {
        $rootScope.device.features = '';
        $rootScope.device.browser = searchString(DATA_BROWSER) || 'Other';
        $rootScope.device.version =
            searchVersion(navigator.userAgent) ||
            searchVersion(navigator.appVersion) ||
            'Unknown';

        $log.log('[DeviceService] Browser: ' + toString());

        $rootScope.device.features = toCssClass();

        if (
            window.matchMedia &&
            window.matchMedia('(display-mode: standalone)').matches
        ) {
            $rootScope.device.features += ' standalone';
        } else {
            $rootScope.device.features += ' browser';
        }

        detectTouchScreen();
        detectFormFactor();
        detectObjectFit();

        $document.find('html').addClass($rootScope.device.features);
    };

    var toString = function() {
        return $rootScope.device.browser + ' ' + $rootScope.device.version;
    };

    var toCssClass = function() {
        return (
            $rootScope.device.browser +
            ' ' +
            $rootScope.device.browser +
            '-' +
            $rootScope.device.version
        ).toLowerCase();
    };

    var is = function(match) {
        return $rootScope.device.features.match(match) != null;
    };

    var scanMobileBrowsers = function() {
        for (var i = 0; i < DATA_MOBILE_BROWSER.length; i++) {
            if (
                navigator.userAgent.indexOf(
                    DATA_MOBILE_BROWSER[i].subString
                ) !== -1
            ) {
                $rootScope.device.versionSearchString =
                    DATA_MOBILE_BROWSER[i].subString;
                return DATA_MOBILE_BROWSER[i].identity;
            }
        }
    };

    var searchString = function(data) {
        for (var i = 0; i < data.length; i++) {
            $rootScope.device.versionSearchString = data[i].subString;
            if (navigator.userAgent.indexOf(data[i].subString) !== -1) {
                return data[i].identity;
            }
        }
    };

    var searchVersion = function(dataString) {
        var index = dataString.indexOf($rootScope.device.versionSearchString);
        if (index === -1) {
            return;
        }

        $log.info('[DeviceService] Checking version against: ', dataString);

        var rv = dataString.indexOf('rv:'),
            ap = dataString.indexOf($rootScope.device.versionSearchString);

        if ($rootScope.device.versionSearchString === 'Trident' && rv !== -1) {
            return parseFloat(dataString.substring(rv + 3));
        } else if ($rootScope.device.browser == 'iOS' && ap !== -1) {
            var version = dataString.indexOf('OS '),
                ios = dataString
                    .substring(version + 'OS '.length)
                    .replace(/\_/g, '.');

            $rootScope.device.browser =
                navigator.platform + ' ' + $rootScope.device.browser;
            ios = ios.substring(0, ios.indexOf(' '));

            $log.info('[DeviceService] iOS detected: ', ios);

            $rootScope.device.browser =
                scanMobileBrowsers() + ' ' + $rootScope.device.browser;

            return parseFloat(ios);
        } else if ($rootScope.device.browser == 'Chrome') {
            var version = parseFloat(
                dataString.substring(
                    index + $rootScope.device.versionSearchString.length + 1
                )
            );
            var mobile = scanMobileBrowsers();
            $rootScope.device.browser = mobile
                ? scanMobileBrowsers() + ' ' + $rootScope.device.browser
                : $rootScope.device.browser;
            return version;
        } else {
            return parseFloat(
                dataString.substring(
                    index + $rootScope.device.versionSearchString.length + 1
                )
            );
        }
    };

    init();
};

function DeviceProvider() {
    this.$get = [
        '$rootScope',
        function($rootScope) {
            return function(prop) {
                return prop ? $rootScope.device[prop] : $rootScope.device;
            };
        }
    ];
}

function DecorateWithDeviceFormFactorDirective($device) {
    return {
        restrict: 'C',
        link: function(scope, element) {
            element.addClass($device('formFactor') + '-form-factor');
        }
    };
}

module.exports = 'deviceProvider';

angular
    .module(module.exports, [])
    .provider('$device', DeviceProvider)
    .directive('decorateWithDeviceFormFactor', [
        '$device',
        DecorateWithDeviceFormFactorDirective
    ])
    .run([
        '$rootScope',
        '$window',
        '$document',
        '$injector',
        '$log',
        detectDeviceCharacteristics
    ]);

},{"lodash":"lodash"}],1109:[function(require,module,exports){
var _ = require('lodash');
var uniq = _.uniq;
var isObject = _.isObject;
var isArray = _.isArray;
var isString = _.isString;
var values = _.values;
// to have consistent behaviour between browsers for `ar`
var langLookup = {
    'ar': 'ar-eg'
};
var lang = navigator.languages && navigator.languages.length ?
    navigator.languages[0] :
    (navigator.language || navigator.userLanguage);
var langGroup = lang.split('-')[0];

if (lang === 'zh-CN') {
    lang = 'zh-Hans';
} else if (lang === 'zh-TW') {
    lang = 'zh-Hant';
}

// at({a: 1, b: {c: 2}}, 'a.b.c') => 2
var at = function (obj, path) {
    path = path.split('.');
    var out = obj;

    for (var i = 0, n = path.length; i < n; i++) {
        if (!out) break;
        out = out[path[i]];
    }

    return out;
};

function I18NService () {
    var cache = {};

    this.$get = ['EVENT', 'I18N', function (EVENT, I18N) {
        var eventLanguages = EVENT.languages || [lang, langGroup];
        // if the language is in eventLanguages promote it to first position
        if (eventLanguages.indexOf(lang) !== -1) {
            eventLanguages = uniq([lang].concat(eventLanguages));
        }
        if (lang !== langGroup && eventLanguages.indexOf(langGroup) !== -1) {
            eventLanguages = uniq([langGroup].concat(eventLanguages));
        }

        var getPreferredTranslation = function (trData, languages, key) {
            if (typeof(trData) === 'undefined' || trData === null) return key;
            if (!isObject(trData) || isArray(trData)) return trData;

            var langKey, tr;
            for (var n = languages.length, i = 0; i < n; i++) {
                langKey = languages[i];
                tr = trData[langKey];
                if (tr && typeof(tr) == 'string') {
                    return tr;
                }
            }

            var fallback = values(trData)[0];
            if (typeof (fallback) == 'string') {
                return fallback;
            }
            return key;
        };

        var service = function (key, languages) {
            if (!key) return '';
            if (!languages || !isArray(languages)) languages = eventLanguages;
            if (isObject(key)) {
                return getPreferredTranslation(key, languages, key);
            }
            if (!isString(key)) {
                return key;
            }

            var cacheKey = key + '-' + languages.join(',');
            if (cache[cacheKey]) {
                return cache[cacheKey];
            }

            var tr = at(I18N, key);
            if (!tr) {
                return key;
            }

            cache[cacheKey] = getPreferredTranslation(tr, languages, key);
            return cache[cacheKey];
        };
        service.lang = lang;

        service.localizeNumber = function(n, locale = lang) {
            if (!_.isNumber(n) || Number.isNaN(n)) {
                return '';
            }
            try {
                var l = langLookup[locale] ? langLookup[locale] : locale;
                return Number(n).toLocaleString(l);
            } catch (err) {
                console.warn('Failed to localize number ' + n, err);
                return n;
            }
        }

        return service;
    }];
}

module.exports = 'i18n';
angular.module(module.exports, [])
.provider('$i18n', I18NService)
.filter('i18n', ['$i18n', function ($i18n) { return $i18n; }]);

},{"lodash":"lodash"}],1110:[function(require,module,exports){
module.exports = require('./vendor/labjs/LAB').$LAB;

},{"./vendor/labjs/LAB":1115}],1111:[function(require,module,exports){
/*global angular*/
var extend = require('lodash').extend;

function MetaService ($window, $timeout, $injector, $log) {
    var callServiceMethod = function (serviceName, methodName, args) {
        serviceName = serviceName || 'navService';
        if (!$injector.has(serviceName)) {
            $log.error('[metaService] unknown service', serviceName);
            return;
        }

        var service = $injector.get(serviceName);
        if (!service[methodName]) {
            $log.error('[metaService] unknown method', serviceName, methodName);
            return;
        }

        $log.debug('[metaService] dispatching', serviceName, methodName, args);
        return service[methodName].apply(service, args);
    };

    return {
        callServiceMethod: callServiceMethod,
        runAction: function (opts, arg, extraParams) {
            opts = opts || {};
            var service = opts.service;
            var method = opts.method;
            var params = opts.params || {};
            extraParams = extraParams || {};
            if (!method || !method.length) return;

            return callServiceMethod(service, method, [arg, extend({}, params, extraParams)]);
        },
        exposeGlobalHelper: function () {
            $window.$a = $window.$a || function (method, args) {
                $timeout(callServiceMethod.bind(null, 'navService', method, [args]));
            };
        }
    };
}

module.exports = 'metaService';
angular.module(module.exports, [])
.service('metaService', ['$window', '$timeout', '$injector', '$log', MetaService]);

},{"lodash":"lodash"}],1112:[function(require,module,exports){
var get = require('lodash').get;

function hexToRgbArray (hex) {
    hex = hex.slice(1);
    var bigint = parseInt(hex, 16);
    var r = (bigint >> 16) & 255;
    var g = (bigint >> 8) & 255;
    var b = bigint & 255;
    return [r,g,b];
}

function hexToRgb (hex) {
    return hexToRgbArray(hex).join(',');
}

// 0 is dark, 1 is light
function getLightFromHex(hex) {
    var rgb = hexToRgbArray(hex);
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    // see http://alienryderflex.com/hsp.html
    return Math.sqrt(
        0.299 * (r * r) +
        0.587 * (g * g) +
        0.114 * (b * b)
    );
}

function ThemeProvider () {
    this.$get = [
        'THEME',
        function(THEME) {
            var normalizedTheme = {
                version: THEME.version,
                contrastColor: THEME.contrastColor,
                primary: {
                    color: THEME.toolbar.font_color,
                    backgroundColor: THEME.toolbar.background_color,
                },

                backgroundColor1: THEME.backgroundColor1,
                backgroundColor2: THEME.backgroundColor2,
                backgroundColor3: THEME.backgroundColor3,
                backgroundColor4: THEME.backgroundColor4,
                backgroundColor5: THEME.backgroundColor5,
                contrastColor: THEME.contrastColor,
                foregroundColor1: THEME.foregroundColor1,
                foregroundColor2: THEME.foregroundColor2
            };

            return function (prop) {
                return prop ? get(normalizedTheme, prop) : normalizedTheme;
            };
        }
    ];
}

function injectStyleOverrides ($theme) {
    let primary = $theme('primary.backgroundColor');
    let primaryText = $theme('primary.color');
    let primaryRgb = hexToRgb(primary);

    // case where the primary background has been set to something very light, then invert
    if (getLightFromHex(primary) > 0.9) {
        primary = $theme('primary.color');
        primaryText = $theme('primary.backgroundColor');
    }

    let theme = '';

    if ($theme('version') === 3) {
        primary = $theme('contrastColor');
        primaryText = 'inherit';
        primaryRgb = '255,255,255';

        const backgroundColor1 = $theme('backgroundColor1');
        const backgroundColor2 = $theme('backgroundColor2');
        const backgroundColor3 = $theme('backgroundColor3');
        const backgroundColor4 = $theme('backgroundColor4');
        const foregroundColor1 = $theme('foregroundColor1');
        const foregroundColor2 = $theme('foregroundColor2');

        theme = `
        html, body {
            background-color: ${backgroundColor4};
        }
        body .panel,
        body .panel.panel-default,
        body .card-block,
        body update-browser-box .content,
        .platform-web .fstg-block .panel.panel-default {
            background-color: ${backgroundColor3};
            color: ${foregroundColor1};
            border-color: ${backgroundColor2};
        }
        body .panel.panel-default .extras {
          color: ${foregroundColor2};
        }
        .panel-default > .panel-heading {
            color: ${foregroundColor1};
            border-color: ${backgroundColor2};
        }
        .panel-footer {
            background-color: ${backgroundColor1};
            color: ${foregroundColor1};
        }
        .card-block .widget > div {
            color: ${foregroundColor1};
        }
        .row-separator {
            background-color: ${backgroundColor3};
        }
        .fstg-block .header-container {
            background-color: ${backgroundColor4};
        }
        .fstg-block .panel.panel-default .list-group-item,
        .fstg-block .panel.panel-default {
            background-color: ${backgroundColor3};
            color: ${foregroundColor1};
            border-color: ${backgroundColor2};
        }
        .fstg-block,
        .fstg-block .panel.panel-default > .panel-heading,
        .fstg-block .panel.panel-default .nav-list-item-title {
            color: ${foregroundColor1};
        }
        .inverse-bg, .inverse-bg-when-active.active {
            color: var(--contrast-color) !important;
            background-color: ${primaryText} !important;
        }
        `
    } else {
        theme += `
        .inverse-bg, .inverse-bg-when-active.active {
            color: var(--contrast-color) !important;
            background-color: var(--foreground-color-0) !important;
        }
        `
    }

    theme += `

    a, a:hover, a:focus, .btn.btn-default, .btn.btn-link {
        color: ${primary};
    }
    .active-text-color,
    .active-text-color-when-active.active {
        color: ${primary} !important;
    }
    .inverse-text-color,
    .inverse-text-color-when-active.active {
        color: ${primaryText} !important;
    }
    .active-bg,
    .active-bg-when-active.active {
        color: ${primaryText} !important;
        background-color: ${primary} !important;
    }
    .active-border,
    .active-border-when-active.active {
        border-color: ${primary};
    }
    .btn.btn-default,
    .btn.btn-default:active,
    .btn.btn-default:focus {
        border-color: ${primary};
    }
    .btn.btn-default:hover, .active-bg-highlight:hover {
        background-color: rgba(${primaryRgb}, 0.05);
    }
    .btn.btn-transparent:hover {
        background-color: rgba(${primaryRgb}, 0.05) !important;
    }
    .ng-click-active[ng-click]:not(.no-click-effect),
    *[ng-click]:active:not(.no-click-effect) {
        background-color: rgba(${primaryRgb}, 0.1) !important;
    }
    .btn.btn-primary, .btn.btn-primary:hover,
    .modal.modal-sheet.menu .modal-footer .btn-group.btn-group-justified .btn-group .btn.btn-default:hover {
        color: ${primaryText} !important;
        background-color: ${primary} !important;
    }`;

    var style = document.createElement('style');
    style.innerText = theme;
    document.head.appendChild(style);
}

module.exports = '$theme';

angular
    .module('$theme', [])
    .provider('$theme', ThemeProvider)
    .run(['$theme', injectStyleOverrides]);

},{"lodash":"lodash"}],1113:[function(require,module,exports){
/* ========================================================================
 * Bootstrap: popover.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#popovers
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // POPOVER PUBLIC CLASS DEFINITION
  // ===============================

  var Popover = function (element, options) {
    this.init('popover', element, options)
  }

  if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js')

  Popover.VERSION  = '3.4.1'

  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
    placement: 'right',
    trigger: 'click',
    content: '',
    template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
  })


  // NOTE: POPOVER EXTENDS tooltip.js
  // ================================

  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype)

  Popover.prototype.constructor = Popover

  Popover.prototype.getDefaults = function () {
    return Popover.DEFAULTS
  }

  Popover.prototype.setContent = function () {
    var $tip    = this.tip()
    var title   = this.getTitle()
    var content = this.getContent()

    if (this.options.html) {
      var typeContent = typeof content

      if (this.options.sanitize) {
        title = this.sanitizeHtml(title)

        if (typeContent === 'string') {
          content = this.sanitizeHtml(content)
        }
      }

      $tip.find('.popover-title').html(title)
      $tip.find('.popover-content').children().detach().end()[
        typeContent === 'string' ? 'html' : 'append'
      ](content)
    } else {
      $tip.find('.popover-title').text(title)
      $tip.find('.popover-content').children().detach().end().text(content)
    }

    $tip.removeClass('fade top bottom left right in')

    // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
    // this manually by checking the contents.
    if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide()
  }

  Popover.prototype.hasContent = function () {
    return this.getTitle() || this.getContent()
  }

  Popover.prototype.getContent = function () {
    var $e = this.$element
    var o  = this.options

    return $e.attr('data-content')
      || (typeof o.content == 'function' ?
        o.content.call($e[0]) :
        o.content)
  }

  Popover.prototype.arrow = function () {
    return (this.$arrow = this.$arrow || this.tip().find('.arrow'))
  }


  // POPOVER PLUGIN DEFINITION
  // =========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.popover')
      var options = typeof option == 'object' && option

      if (!data && /destroy|hide/.test(option)) return
      if (!data) $this.data('bs.popover', (data = new Popover(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.popover

  $.fn.popover             = Plugin
  $.fn.popover.Constructor = Popover


  // POPOVER NO CONFLICT
  // ===================

  $.fn.popover.noConflict = function () {
    $.fn.popover = old
    return this
  }

}(jQuery);

},{}],1114:[function(require,module,exports){
/* ========================================================================
 * Bootstrap: tooltip.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#tooltip
 * Inspired by the original jQuery.tipsy by Jason Frame
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

+function ($) {
  'use strict';

  var DISALLOWED_ATTRIBUTES = ['sanitize', 'whiteList', 'sanitizeFn']

  var uriAttrs = [
    'background',
    'cite',
    'href',
    'itemtype',
    'longdesc',
    'poster',
    'src',
    'xlink:href'
  ]

  var ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i

  var DefaultWhitelist = {
    // Global attributes allowed on any supplied element below.
    '*': ['class', 'dir', 'id', 'lang', 'role', ARIA_ATTRIBUTE_PATTERN],
    a: ['target', 'href', 'title', 'rel'],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    div: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: ['src', 'alt', 'title', 'width', 'height'],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
  }

  /**
   * A pattern that recognizes a commonly useful subset of URLs that are safe.
   *
   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
   */
  var SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file):|[^&:/?#]*(?:[/?#]|$))/gi

  /**
   * A pattern that matches safe data URLs. Only matches image, video and audio types.
   *
   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
   */
  var DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[a-z0-9+/]+=*$/i

  function allowedAttribute(attr, allowedAttributeList) {
    var attrName = attr.nodeName.toLowerCase()

    if ($.inArray(attrName, allowedAttributeList) !== -1) {
      if ($.inArray(attrName, uriAttrs) !== -1) {
        return Boolean(attr.nodeValue.match(SAFE_URL_PATTERN) || attr.nodeValue.match(DATA_URL_PATTERN))
      }

      return true
    }

    var regExp = $(allowedAttributeList).filter(function (index, value) {
      return value instanceof RegExp
    })

    // Check if a regular expression validates the attribute.
    for (var i = 0, l = regExp.length; i < l; i++) {
      if (attrName.match(regExp[i])) {
        return true
      }
    }

    return false
  }

  function sanitizeHtml(unsafeHtml, whiteList, sanitizeFn) {
    if (unsafeHtml.length === 0) {
      return unsafeHtml
    }

    if (sanitizeFn && typeof sanitizeFn === 'function') {
      return sanitizeFn(unsafeHtml)
    }

    // IE 8 and below don't support createHTMLDocument
    if (!document.implementation || !document.implementation.createHTMLDocument) {
      return unsafeHtml
    }

    var createdDocument = document.implementation.createHTMLDocument('sanitization')
    createdDocument.body.innerHTML = unsafeHtml

    var whitelistKeys = $.map(whiteList, function (el, i) { return i })
    var elements = $(createdDocument.body).find('*')

    for (var i = 0, len = elements.length; i < len; i++) {
      var el = elements[i]
      var elName = el.nodeName.toLowerCase()

      if ($.inArray(elName, whitelistKeys) === -1) {
        el.parentNode.removeChild(el)

        continue
      }

      var attributeList = $.map(el.attributes, function (el) { return el })
      var whitelistedAttributes = [].concat(whiteList['*'] || [], whiteList[elName] || [])

      for (var j = 0, len2 = attributeList.length; j < len2; j++) {
        if (!allowedAttribute(attributeList[j], whitelistedAttributes)) {
          el.removeAttribute(attributeList[j].nodeName)
        }
      }
    }

    return createdDocument.body.innerHTML
  }

  // TOOLTIP PUBLIC CLASS DEFINITION
  // ===============================

  var Tooltip = function (element, options) {
    this.type       = null
    this.options    = null
    this.enabled    = null
    this.timeout    = null
    this.hoverState = null
    this.$element   = null
    this.inState    = null

    this.init('tooltip', element, options)
  }

  Tooltip.VERSION  = '3.4.1'

  Tooltip.TRANSITION_DURATION = 150

  Tooltip.DEFAULTS = {
    animation: true,
    placement: 'top',
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    trigger: 'hover focus',
    title: '',
    delay: 0,
    html: false,
    container: false,
    viewport: {
      selector: 'body',
      padding: 0
    },
    sanitize : true,
    sanitizeFn : null,
    whiteList : DefaultWhitelist
  }

  Tooltip.prototype.init = function (type, element, options) {
    this.enabled   = true
    this.type      = type
    this.$element  = $(element)
    this.options   = this.getOptions(options)
    this.$viewport = this.options.viewport && $(document).find($.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : (this.options.viewport.selector || this.options.viewport))
    this.inState   = { click: false, hover: false, focus: false }

    if (this.$element[0] instanceof document.constructor && !this.options.selector) {
      throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!')
    }

    var triggers = this.options.trigger.split(' ')

    for (var i = triggers.length; i--;) {
      var trigger = triggers[i]

      if (trigger == 'click') {
        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))
      } else if (trigger != 'manual') {
        var eventIn  = trigger == 'hover' ? 'mouseenter' : 'focusin'
        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout'

        this.$element.on(eventIn  + '.' + this.type, this.options.selector, $.proxy(this.enter, this))
        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))
      }
    }

    this.options.selector ?
      (this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' })) :
      this.fixTitle()
  }

  Tooltip.prototype.getDefaults = function () {
    return Tooltip.DEFAULTS
  }

  Tooltip.prototype.getOptions = function (options) {
    var dataAttributes = this.$element.data()

    for (var dataAttr in dataAttributes) {
      if (dataAttributes.hasOwnProperty(dataAttr) && $.inArray(dataAttr, DISALLOWED_ATTRIBUTES) !== -1) {
        delete dataAttributes[dataAttr]
      }
    }

    options = $.extend({}, this.getDefaults(), dataAttributes, options)

    if (options.delay && typeof options.delay == 'number') {
      options.delay = {
        show: options.delay,
        hide: options.delay
      }
    }

    if (options.sanitize) {
      options.template = sanitizeHtml(options.template, options.whiteList, options.sanitizeFn)
    }

    return options
  }

  Tooltip.prototype.getDelegateOptions = function () {
    var options  = {}
    var defaults = this.getDefaults()

    this._options && $.each(this._options, function (key, value) {
      if (defaults[key] != value) options[key] = value
    })

    return options
  }

  Tooltip.prototype.enter = function (obj) {
    var self = obj instanceof this.constructor ?
      obj : $(obj.currentTarget).data('bs.' + this.type)

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
      $(obj.currentTarget).data('bs.' + this.type, self)
    }

    if (obj instanceof $.Event) {
      self.inState[obj.type == 'focusin' ? 'focus' : 'hover'] = true
    }

    if (self.tip().hasClass('in') || self.hoverState == 'in') {
      self.hoverState = 'in'
      return
    }

    clearTimeout(self.timeout)

    self.hoverState = 'in'

    if (!self.options.delay || !self.options.delay.show) return self.show()

    self.timeout = setTimeout(function () {
      if (self.hoverState == 'in') self.show()
    }, self.options.delay.show)
  }

  Tooltip.prototype.isInStateTrue = function () {
    for (var key in this.inState) {
      if (this.inState[key]) return true
    }

    return false
  }

  Tooltip.prototype.leave = function (obj) {
    var self = obj instanceof this.constructor ?
      obj : $(obj.currentTarget).data('bs.' + this.type)

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
      $(obj.currentTarget).data('bs.' + this.type, self)
    }

    if (obj instanceof $.Event) {
      self.inState[obj.type == 'focusout' ? 'focus' : 'hover'] = false
    }

    if (self.isInStateTrue()) return

    clearTimeout(self.timeout)

    self.hoverState = 'out'

    if (!self.options.delay || !self.options.delay.hide) return self.hide()

    self.timeout = setTimeout(function () {
      if (self.hoverState == 'out') self.hide()
    }, self.options.delay.hide)
  }

  Tooltip.prototype.show = function () {
    var e = $.Event('show.bs.' + this.type)

    if (this.hasContent() && this.enabled) {
      this.$element.trigger(e)

      var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0])
      if (e.isDefaultPrevented() || !inDom) return
      var that = this

      var $tip = this.tip()

      var tipId = this.getUID(this.type)

      this.setContent()
      $tip.attr('id', tipId)
      this.$element.attr('aria-describedby', tipId)

      if (this.options.animation) $tip.addClass('fade')

      var placement = typeof this.options.placement == 'function' ?
        this.options.placement.call(this, $tip[0], this.$element[0]) :
        this.options.placement

      var autoToken = /\s?auto?\s?/i
      var autoPlace = autoToken.test(placement)
      if (autoPlace) placement = placement.replace(autoToken, '') || 'top'

      $tip
        .detach()
        .css({ top: 0, left: 0, display: 'block' })
        .addClass(placement)
        .data('bs.' + this.type, this)

      this.options.container ? $tip.appendTo($(document).find(this.options.container)) : $tip.insertAfter(this.$element)
      this.$element.trigger('inserted.bs.' + this.type)

      var pos          = this.getPosition()
      var actualWidth  = $tip[0].offsetWidth
      var actualHeight = $tip[0].offsetHeight

      if (autoPlace) {
        var orgPlacement = placement
        var viewportDim = this.getPosition(this.$viewport)

        placement = placement == 'bottom' && pos.bottom + actualHeight > viewportDim.bottom ? 'top'    :
                    placement == 'top'    && pos.top    - actualHeight < viewportDim.top    ? 'bottom' :
                    placement == 'right'  && pos.right  + actualWidth  > viewportDim.width  ? 'left'   :
                    placement == 'left'   && pos.left   - actualWidth  < viewportDim.left   ? 'right'  :
                    placement

        $tip
          .removeClass(orgPlacement)
          .addClass(placement)
      }

      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight)

      this.applyPlacement(calculatedOffset, placement)

      var complete = function () {
        var prevHoverState = that.hoverState
        that.$element.trigger('shown.bs.' + that.type)
        that.hoverState = null

        if (prevHoverState == 'out') that.leave(that)
      }

      $.support.transition && this.$tip.hasClass('fade') ?
        $tip
          .one('bsTransitionEnd', complete)
          .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
        complete()
    }
  }

  Tooltip.prototype.applyPlacement = function (offset, placement) {
    var $tip   = this.tip()
    var width  = $tip[0].offsetWidth
    var height = $tip[0].offsetHeight

    // manually read margins because getBoundingClientRect includes difference
    var marginTop = parseInt($tip.css('margin-top'), 10)
    var marginLeft = parseInt($tip.css('margin-left'), 10)

    // we must check for NaN for ie 8/9
    if (isNaN(marginTop))  marginTop  = 0
    if (isNaN(marginLeft)) marginLeft = 0

    offset.top  += marginTop
    offset.left += marginLeft

    // $.fn.offset doesn't round pixel values
    // so we use setOffset directly with our own function B-0
    $.offset.setOffset($tip[0], $.extend({
      using: function (props) {
        $tip.css({
          top: Math.round(props.top),
          left: Math.round(props.left)
        })
      }
    }, offset), 0)

    $tip.addClass('in')

    // check to see if placing tip in new offset caused the tip to resize itself
    var actualWidth  = $tip[0].offsetWidth
    var actualHeight = $tip[0].offsetHeight

    if (placement == 'top' && actualHeight != height) {
      offset.top = offset.top + height - actualHeight
    }

    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight)

    if (delta.left) offset.left += delta.left
    else offset.top += delta.top

    var isVertical          = /top|bottom/.test(placement)
    var arrowDelta          = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight
    var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight'

    $tip.offset(offset)
    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical)
  }

  Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {
    this.arrow()
      .css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%')
      .css(isVertical ? 'top' : 'left', '')
  }

  Tooltip.prototype.setContent = function () {
    var $tip  = this.tip()
    var title = this.getTitle()

    if (this.options.html) {
      if (this.options.sanitize) {
        title = sanitizeHtml(title, this.options.whiteList, this.options.sanitizeFn)
      }

      $tip.find('.tooltip-inner').html(title)
    } else {
      $tip.find('.tooltip-inner').text(title)
    }

    $tip.removeClass('fade in top bottom left right')
  }

  Tooltip.prototype.hide = function (callback) {
    var that = this
    var $tip = $(this.$tip)
    var e    = $.Event('hide.bs.' + this.type)

    function complete() {
      if (that.hoverState != 'in') $tip.detach()
      if (that.$element) { // TODO: Check whether guarding this code with this `if` is really necessary.
        that.$element
          .removeAttr('aria-describedby')
          .trigger('hidden.bs.' + that.type)
      }
      callback && callback()
    }

    this.$element.trigger(e)

    if (e.isDefaultPrevented()) return

    $tip.removeClass('in')

    $.support.transition && $tip.hasClass('fade') ?
      $tip
        .one('bsTransitionEnd', complete)
        .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
      complete()

    this.hoverState = null

    return this
  }

  Tooltip.prototype.fixTitle = function () {
    var $e = this.$element
    if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')
    }
  }

  Tooltip.prototype.hasContent = function () {
    return this.getTitle()
  }

  Tooltip.prototype.getPosition = function ($element) {
    $element   = $element || this.$element

    var el     = $element[0]
    var isBody = el.tagName == 'BODY'

    var elRect    = el.getBoundingClientRect()
    if (elRect.width == null) {
      // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
      elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top })
    }
    var isSvg = window.SVGElement && el instanceof window.SVGElement
    // Avoid using $.offset() on SVGs since it gives incorrect results in jQuery 3.
    // See https://github.com/twbs/bootstrap/issues/20280
    var elOffset  = isBody ? { top: 0, left: 0 } : (isSvg ? null : $element.offset())
    var scroll    = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() }
    var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null

    return $.extend({}, elRect, scroll, outerDims, elOffset)
  }

  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
    return placement == 'bottom' ? { top: pos.top + pos.height,   left: pos.left + pos.width / 2 - actualWidth / 2 } :
           placement == 'top'    ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } :
           placement == 'left'   ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
        /* placement == 'right' */ { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width }

  }

  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
    var delta = { top: 0, left: 0 }
    if (!this.$viewport) return delta

    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0
    var viewportDimensions = this.getPosition(this.$viewport)

    if (/right|left/.test(placement)) {
      var topEdgeOffset    = pos.top - viewportPadding - viewportDimensions.scroll
      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight
      if (topEdgeOffset < viewportDimensions.top) { // top overflow
        delta.top = viewportDimensions.top - topEdgeOffset
      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) { // bottom overflow
        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset
      }
    } else {
      var leftEdgeOffset  = pos.left - viewportPadding
      var rightEdgeOffset = pos.left + viewportPadding + actualWidth
      if (leftEdgeOffset < viewportDimensions.left) { // left overflow
        delta.left = viewportDimensions.left - leftEdgeOffset
      } else if (rightEdgeOffset > viewportDimensions.right) { // right overflow
        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset
      }
    }

    return delta
  }

  Tooltip.prototype.getTitle = function () {
    var title
    var $e = this.$element
    var o  = this.options

    title = $e.attr('data-original-title')
      || (typeof o.title == 'function' ? o.title.call($e[0]) :  o.title)

    return title
  }

  Tooltip.prototype.getUID = function (prefix) {
    do prefix += ~~(Math.random() * 1000000)
    while (document.getElementById(prefix))
    return prefix
  }

  Tooltip.prototype.tip = function () {
    if (!this.$tip) {
      this.$tip = $(this.options.template)
      if (this.$tip.length != 1) {
        throw new Error(this.type + ' `template` option must consist of exactly 1 top-level element!')
      }
    }
    return this.$tip
  }

  Tooltip.prototype.arrow = function () {
    return (this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow'))
  }

  Tooltip.prototype.enable = function () {
    this.enabled = true
  }

  Tooltip.prototype.disable = function () {
    this.enabled = false
  }

  Tooltip.prototype.toggleEnabled = function () {
    this.enabled = !this.enabled
  }

  Tooltip.prototype.toggle = function (e) {
    var self = this
    if (e) {
      self = $(e.currentTarget).data('bs.' + this.type)
      if (!self) {
        self = new this.constructor(e.currentTarget, this.getDelegateOptions())
        $(e.currentTarget).data('bs.' + this.type, self)
      }
    }

    if (e) {
      self.inState.click = !self.inState.click
      if (self.isInStateTrue()) self.enter(self)
      else self.leave(self)
    } else {
      self.tip().hasClass('in') ? self.leave(self) : self.enter(self)
    }
  }

  Tooltip.prototype.destroy = function () {
    var that = this
    clearTimeout(this.timeout)
    this.hide(function () {
      that.$element.off('.' + that.type).removeData('bs.' + that.type)
      if (that.$tip) {
        that.$tip.detach()
      }
      that.$tip = null
      that.$arrow = null
      that.$viewport = null
      that.$element = null
    })
  }

  Tooltip.prototype.sanitizeHtml = function (unsafeHtml) {
    return sanitizeHtml(unsafeHtml, this.options.whiteList, this.options.sanitizeFn)
  }

  // TOOLTIP PLUGIN DEFINITION
  // =========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.tooltip')
      var options = typeof option == 'object' && option

      if (!data && /destroy|hide/.test(option)) return
      if (!data) $this.data('bs.tooltip', (data = new Tooltip(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.tooltip

  $.fn.tooltip             = Plugin
  $.fn.tooltip.Constructor = Tooltip


  // TOOLTIP NO CONFLICT
  // ===================

  $.fn.tooltip.noConflict = function () {
    $.fn.tooltip = old
    return this
  }

}(jQuery);

},{}],1115:[function(require,module,exports){
/*! LAB.js (LABjs :: Loading And Blocking JavaScript)
    v2.0.3 (c) Kyle Simpson
    MIT License
*/
(function(o){var K=o.$LAB,y="UseLocalXHR",z="AlwaysPreserveOrder",u="AllowDuplicates",A="CacheBust",B="BasePath",C=/^[^?#]*\//.exec(location.href)[0],D=/^\w+\:\/\/\/?[^\/]+/.exec(C)[0],i=document.head||document.getElementsByTagName("head"),L=(o.opera&&Object.prototype.toString.call(o.opera)=="[object Opera]")||("MozAppearance"in document.documentElement.style),q=document.createElement("script"),E=typeof q.preload=="boolean",r=E||(q.readyState&&q.readyState=="uninitialized"),F=!r&&q.async===true,M=!r&&!F&&!L;function G(a){return Object.prototype.toString.call(a)=="[object Function]"}function H(a){return Object.prototype.toString.call(a)=="[object Array]"}function N(a,c){var b=/^\w+\:\/\//;if(/^\/\/\/?/.test(a)){a=location.protocol+a}else if(!b.test(a)&&a.charAt(0)!="/"){a=(c||"")+a}return b.test(a)?a:((a.charAt(0)=="/"?D:C)+a)}function s(a,c){for(var b in a){if(a.hasOwnProperty(b)){c[b]=a[b]}}return c}function O(a){var c=false;for(var b=0;b<a.scripts.length;b++){if(a.scripts[b].ready&&a.scripts[b].exec_trigger){c=true;a.scripts[b].exec_trigger();a.scripts[b].exec_trigger=null}}return c}function t(a,c,b,d){a.onload=a.onreadystatechange=function(){if((a.readyState&&a.readyState!="complete"&&a.readyState!="loaded")||c[b])return;a.onload=a.onreadystatechange=null;d()}}function I(a){a.ready=a.finished=true;for(var c=0;c<a.finished_listeners.length;c++){a.finished_listeners[c]()}a.ready_listeners=[];a.finished_listeners=[]}function P(d,f,e,g,h){setTimeout(function(){var a,c=f.real_src,b;if("item"in i){if(!i[0]){setTimeout(arguments.callee,25);return}i=i[0]}a=document.createElement("script");if(f.type)a.type=f.type;if(f.charset)a.charset=f.charset;if(h){if(r){e.elem=a;if(E){a.preload=true;a.onpreload=g}else{a.onreadystatechange=function(){if(a.readyState=="loaded")g()}}a.src=c}else if(h&&c.indexOf(D)==0&&d[y]){b=new XMLHttpRequest();b.onreadystatechange=function(){if(b.readyState==4){b.onreadystatechange=function(){};e.text=b.responseText+"\n//@ sourceURL="+c;g()}};b.open("GET",c);b.send()}else{a.type="text/cache-script";t(a,e,"ready",function(){i.removeChild(a);g()});a.src=c;i.insertBefore(a,i.firstChild)}}else if(F){a.async=false;t(a,e,"finished",g);a.src=c;i.insertBefore(a,i.firstChild)}else{t(a,e,"finished",g);a.src=c;i.insertBefore(a,i.firstChild)}},0)}function J(){var l={},Q=r||M,n=[],p={},m;l[y]=true;l[z]=false;l[u]=false;l[A]=false;l[B]="";function R(a,c,b){var d;function f(){if(d!=null){d=null;I(b)}}if(p[c.src].finished)return;if(!a[u])p[c.src].finished=true;d=b.elem||document.createElement("script");if(c.type)d.type=c.type;if(c.charset)d.charset=c.charset;t(d,b,"finished",f);if(b.elem){b.elem=null}else if(b.text){d.onload=d.onreadystatechange=null;d.text=b.text}else{d.src=c.real_src}i.insertBefore(d,i.firstChild);if(b.text){f()}}function S(c,b,d,f){var e,g,h=function(){b.ready_cb(b,function(){R(c,b,e)})},j=function(){b.finished_cb(b,d)};b.src=N(b.src,c[B]);b.real_src=b.src+(c[A]?((/\?.*$/.test(b.src)?"&_":"?_")+~~(Math.random()*1E9)+"="):"");if(!p[b.src])p[b.src]={items:[],finished:false};g=p[b.src].items;if(c[u]||g.length==0){e=g[g.length]={ready:false,finished:false,ready_listeners:[h],finished_listeners:[j]};P(c,b,e,((f)?function(){e.ready=true;for(var a=0;a<e.ready_listeners.length;a++){e.ready_listeners[a]()}e.ready_listeners=[]}:function(){I(e)}),f)}else{e=g[0];if(e.finished){j()}else{e.finished_listeners.push(j)}}}function v(){var e,g=s(l,{}),h=[],j=0,w=false,k;function T(a,c){a.ready=true;a.exec_trigger=c;x()}function U(a,c){a.ready=a.finished=true;a.exec_trigger=null;for(var b=0;b<c.scripts.length;b++){if(!c.scripts[b].finished)return}c.finished=true;x()}function x(){while(j<h.length){if(G(h[j])){try{h[j++]()}catch(err){}continue}else if(!h[j].finished){if(O(h[j]))continue;break}j++}if(j==h.length){w=false;k=false}}function V(){if(!k||!k.scripts){h.push(k={scripts:[],finished:true})}}e={script:function(){for(var f=0;f<arguments.length;f++){(function(a,c){var b;if(!H(a)){c=[a]}for(var d=0;d<c.length;d++){V();a=c[d];if(G(a))a=a();if(!a)continue;if(H(a)){b=[].slice.call(a);b.unshift(d,1);[].splice.apply(c,b);d--;continue}if(typeof a=="string")a={src:a};a=s(a,{ready:false,ready_cb:T,finished:false,finished_cb:U});k.finished=false;k.scripts.push(a);S(g,a,k,(Q&&w));w=true;if(g[z])e.wait()}})(arguments[f],arguments[f])}return e},wait:function(){if(arguments.length>0){for(var a=0;a<arguments.length;a++){h.push(arguments[a])}k=h[h.length-1]}else k=false;x();return e}};return{script:e.script,wait:e.wait,setOptions:function(a){s(a,g);return e}}}m={setGlobalDefaults:function(a){s(a,l);return m},setOptions:function(){return v().setOptions.apply(null,arguments)},script:function(){return v().script.apply(null,arguments)},wait:function(){return v().wait.apply(null,arguments)},queueScript:function(){n[n.length]={type:"script",args:[].slice.call(arguments)};return m},queueWait:function(){n[n.length]={type:"wait",args:[].slice.call(arguments)};return m},runQueue:function(){var a=m,c=n.length,b=c,d;for(;--b>=0;){d=n.shift();a=a[d.type].apply(null,d.args)}return a},noConflict:function(){o.$LAB=K;return m},sandbox:function(){return J()}};return m}o.$LAB=J();(function(a,c,b){if(document.readyState==null&&document[a]){document.readyState="loading";document[a](c,b=function(){document.removeEventListener(c,b,false);document.readyState="complete"},false)}})("addEventListener","DOMContentLoaded")})(this);

},{}],1116:[function(require,module,exports){
'use strict';

/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var toStr = Object.prototype.toString;
var max = Math.max;
var funcType = '[object Function]';

var concatty = function concatty(a, b) {
    var arr = [];

    for (var i = 0; i < a.length; i += 1) {
        arr[i] = a[i];
    }
    for (var j = 0; j < b.length; j += 1) {
        arr[j + a.length] = b[j];
    }

    return arr;
};

var slicy = function slicy(arrLike, offset) {
    var arr = [];
    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
        arr[j] = arrLike[i];
    }
    return arr;
};

var joiny = function (arr, joiner) {
    var str = '';
    for (var i = 0; i < arr.length; i += 1) {
        str += arr[i];
        if (i + 1 < arr.length) {
            str += joiner;
        }
    }
    return str;
};

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slicy(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                concatty(args, arguments)
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        }
        return target.apply(
            that,
            concatty(args, arguments)
        );

    };

    var boundLength = max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs[i] = '$' + i;
    }

    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};

},{}],1117:[function(require,module,exports){
'use strict';

var implementation = require('./implementation');

module.exports = Function.prototype.bind || implementation;

},{"./implementation":1116}],1118:[function(require,module,exports){
'use strict';

var undefined;

var $Error = require('es-errors');
var $EvalError = require('es-errors/eval');
var $RangeError = require('es-errors/range');
var $ReferenceError = require('es-errors/ref');
var $SyntaxError = require('es-errors/syntax');
var $TypeError = require('es-errors/type');
var $URIError = require('es-errors/uri');

var $Function = Function;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = require('has-symbols')();
var hasProto = require('has-proto')();

var getProto = Object.getPrototypeOf || (
	hasProto
		? function (x) { return x.__proto__; } // eslint-disable-line no-proto
		: null
);

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	__proto__: null,
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': $Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': $EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': $RangeError,
	'%ReferenceError%': $ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': $URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};

if (getProto) {
	try {
		null.error; // eslint-disable-line no-unused-expressions
	} catch (e) {
		// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
		var errorProto = getProto(getProto(e));
		INTRINSICS['%Error.prototype%'] = errorProto;
	}
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen && getProto) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	__proto__: null,
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = require('function-bind');
var hasOwn = require('hasown');
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
var $exec = bind.call(Function.call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};

},{"es-errors":1096,"es-errors/eval":1095,"es-errors/range":1097,"es-errors/ref":1098,"es-errors/syntax":1099,"es-errors/type":1100,"es-errors/uri":1101,"function-bind":1117,"has-proto":1153,"has-symbols":1154,"hasown":1157}],1119:[function(require,module,exports){
'use strict';

var GetIntrinsic = require('get-intrinsic');

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);

if ($gOPD) {
	try {
		$gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD = null;
	}
}

module.exports = $gOPD;

},{"get-intrinsic":1118}],1120:[function(require,module,exports){
'use strict';

exports.__esModule = true;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _handlebarsRuntime = require('./handlebars.runtime');

var _handlebarsRuntime2 = _interopRequireDefault(_handlebarsRuntime);

// Compiler imports

var _handlebarsCompilerAst = require('./handlebars/compiler/ast');

var _handlebarsCompilerAst2 = _interopRequireDefault(_handlebarsCompilerAst);

var _handlebarsCompilerBase = require('./handlebars/compiler/base');

var _handlebarsCompilerCompiler = require('./handlebars/compiler/compiler');

var _handlebarsCompilerJavascriptCompiler = require('./handlebars/compiler/javascript-compiler');

var _handlebarsCompilerJavascriptCompiler2 = _interopRequireDefault(_handlebarsCompilerJavascriptCompiler);

var _handlebarsCompilerVisitor = require('./handlebars/compiler/visitor');

var _handlebarsCompilerVisitor2 = _interopRequireDefault(_handlebarsCompilerVisitor);

var _handlebarsNoConflict = require('./handlebars/no-conflict');

var _handlebarsNoConflict2 = _interopRequireDefault(_handlebarsNoConflict);

var _create = _handlebarsRuntime2['default'].create;
function create() {
  var hb = _create();

  hb.compile = function (input, options) {
    return _handlebarsCompilerCompiler.compile(input, options, hb);
  };
  hb.precompile = function (input, options) {
    return _handlebarsCompilerCompiler.precompile(input, options, hb);
  };

  hb.AST = _handlebarsCompilerAst2['default'];
  hb.Compiler = _handlebarsCompilerCompiler.Compiler;
  hb.JavaScriptCompiler = _handlebarsCompilerJavascriptCompiler2['default'];
  hb.Parser = _handlebarsCompilerBase.parser;
  hb.parse = _handlebarsCompilerBase.parse;
  hb.parseWithoutProcessing = _handlebarsCompilerBase.parseWithoutProcessing;

  return hb;
}

var inst = create();
inst.create = create;

_handlebarsNoConflict2['default'](inst);

inst.Visitor = _handlebarsCompilerVisitor2['default'];

inst['default'] = inst;

exports['default'] = inst;
module.exports = exports['default'];


},{"./handlebars.runtime":1121,"./handlebars/compiler/ast":1123,"./handlebars/compiler/base":1124,"./handlebars/compiler/compiler":1126,"./handlebars/compiler/javascript-compiler":1128,"./handlebars/compiler/visitor":1131,"./handlebars/no-conflict":1148}],1121:[function(require,module,exports){
'use strict';

exports.__esModule = true;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// istanbul ignore next

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

var _handlebarsBase = require('./handlebars/base');

var base = _interopRequireWildcard(_handlebarsBase);

// Each of these augment the Handlebars object. No need to setup here.
// (This is done to easily share code between commonjs and browse envs)

var _handlebarsSafeString = require('./handlebars/safe-string');

var _handlebarsSafeString2 = _interopRequireDefault(_handlebarsSafeString);

var _handlebarsException = require('./handlebars/exception');

var _handlebarsException2 = _interopRequireDefault(_handlebarsException);

var _handlebarsUtils = require('./handlebars/utils');

var Utils = _interopRequireWildcard(_handlebarsUtils);

var _handlebarsRuntime = require('./handlebars/runtime');

var runtime = _interopRequireWildcard(_handlebarsRuntime);

var _handlebarsNoConflict = require('./handlebars/no-conflict');

var _handlebarsNoConflict2 = _interopRequireDefault(_handlebarsNoConflict);

// For compatibility and usage outside of module systems, make the Handlebars object a namespace
function create() {
  var hb = new base.HandlebarsEnvironment();

  Utils.extend(hb, base);
  hb.SafeString = _handlebarsSafeString2['default'];
  hb.Exception = _handlebarsException2['default'];
  hb.Utils = Utils;
  hb.escapeExpression = Utils.escapeExpression;

  hb.VM = runtime;
  hb.template = function (spec) {
    return runtime.template(spec, hb);
  };

  return hb;
}

var inst = create();
inst.create = create;

_handlebarsNoConflict2['default'](inst);

inst['default'] = inst;

exports['default'] = inst;
module.exports = exports['default'];


},{"./handlebars/base":1122,"./handlebars/exception":1135,"./handlebars/no-conflict":1148,"./handlebars/runtime":1149,"./handlebars/safe-string":1150,"./handlebars/utils":1151}],1122:[function(require,module,exports){
'use strict';

exports.__esModule = true;
exports.HandlebarsEnvironment = HandlebarsEnvironment;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _utils = require('./utils');

var _exception = require('./exception');

var _exception2 = _interopRequireDefault(_exception);

var _helpers = require('./helpers');

var _decorators = require('./decorators');

var _logger = require('./logger');

var _logger2 = _interopRequireDefault(_logger);

var _internalProtoAccess = require('./internal/proto-access');

var VERSION = '4.7.7';
exports.VERSION = VERSION;
var COMPILER_REVISION = 8;
exports.COMPILER_REVISION = COMPILER_REVISION;
var LAST_COMPATIBLE_COMPILER_REVISION = 7;

exports.LAST_COMPATIBLE_COMPILER_REVISION = LAST_COMPATIBLE_COMPILER_REVISION;
var REVISION_CHANGES = {
  1: '<= 1.0.rc.2', // 1.0.rc.2 is actually rev2 but doesn't report it
  2: '== 1.0.0-rc.3',
  3: '== 1.0.0-rc.4',
  4: '== 1.x.x',
  5: '== 2.0.0-alpha.x',
  6: '>= 2.0.0-beta.1',
  7: '>= 4.0.0 <4.3.0',
  8: '>= 4.3.0'
};

exports.REVISION_CHANGES = REVISION_CHANGES;
var objectType = '[object Object]';

function HandlebarsEnvironment(helpers, partials, decorators) {
  this.helpers = helpers || {};
  this.partials = partials || {};
  this.decorators = decorators || {};

  _helpers.registerDefaultHelpers(this);
  _decorators.registerDefaultDecorators(this);
}

HandlebarsEnvironment.prototype = {
  constructor: HandlebarsEnvironment,

  logger: _logger2['default'],
  log: _logger2['default'].log,

  registerHelper: function registerHelper(name, fn) {
    if (_utils.toString.call(name) === objectType) {
      if (fn) {
        throw new _exception2['default']('Arg not supported with multiple helpers');
      }
      _utils.extend(this.helpers, name);
    } else {
      this.helpers[name] = fn;
    }
  },
  unregisterHelper: function unregisterHelper(name) {
    delete this.helpers[name];
  },

  registerPartial: function registerPartial(name, partial) {
    if (_utils.toString.call(name) === objectType) {
      _utils.extend(this.partials, name);
    } else {
      if (typeof partial === 'undefined') {
        throw new _exception2['default']('Attempting to register a partial called "' + name + '" as undefined');
      }
      this.partials[name] = partial;
    }
  },
  unregisterPartial: function unregisterPartial(name) {
    delete this.partials[name];
  },

  registerDecorator: function registerDecorator(name, fn) {
    if (_utils.toString.call(name) === objectType) {
      if (fn) {
        throw new _exception2['default']('Arg not supported with multiple decorators');
      }
      _utils.extend(this.decorators, name);
    } else {
      this.decorators[name] = fn;
    }
  },
  unregisterDecorator: function unregisterDecorator(name) {
    delete this.decorators[name];
  },
  /**
   * Reset the memory of illegal property accesses that have already been logged.
   * @deprecated should only be used in handlebars test-cases
   */
  resetLoggedPropertyAccesses: function resetLoggedPropertyAccesses() {
    _internalProtoAccess.resetLoggedProperties();
  }
};

var log = _logger2['default'].log;

exports.log = log;
exports.createFrame = _utils.createFrame;
exports.logger = _logger2['default'];


},{"./decorators":1133,"./exception":1135,"./helpers":1136,"./internal/proto-access":1145,"./logger":1147,"./utils":1151}],1123:[function(require,module,exports){
'use strict';

exports.__esModule = true;
var AST = {
  // Public API used to evaluate derived attributes regarding AST nodes
  helpers: {
    // a mustache is definitely a helper if:
    // * it is an eligible helper, and
    // * it has at least one parameter or hash segment
    helperExpression: function helperExpression(node) {
      return node.type === 'SubExpression' || (node.type === 'MustacheStatement' || node.type === 'BlockStatement') && !!(node.params && node.params.length || node.hash);
    },

    scopedId: function scopedId(path) {
      return (/^\.|this\b/.test(path.original)
      );
    },

    // an ID is simple if it only has one part, and that part is not
    // `..` or `this`.
    simpleId: function simpleId(path) {
      return path.parts.length === 1 && !AST.helpers.scopedId(path) && !path.depth;
    }
  }
};

// Must be exported as an object rather than the root of the module as the jison lexer
// must modify the object to operate properly.
exports['default'] = AST;
module.exports = exports['default'];


},{}],1124:[function(require,module,exports){
'use strict';

exports.__esModule = true;
exports.parseWithoutProcessing = parseWithoutProcessing;
exports.parse = parse;
// istanbul ignore next

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _parser = require('./parser');

var _parser2 = _interopRequireDefault(_parser);

var _whitespaceControl = require('./whitespace-control');

var _whitespaceControl2 = _interopRequireDefault(_whitespaceControl);

var _helpers = require('./helpers');

var Helpers = _interopRequireWildcard(_helpers);

var _utils = require('../utils');

exports.parser = _parser2['default'];

var yy = {};
_utils.extend(yy, Helpers);

function parseWithoutProcessing(input, options) {
  // Just return if an already-compiled AST was passed in.
  if (input.type === 'Program') {
    return input;
  }

  _parser2['default'].yy = yy;

  // Altering the shared object here, but this is ok as parser is a sync operation
  yy.locInfo = function (locInfo) {
    return new yy.SourceLocation(options && options.srcName, locInfo);
  };

  var ast = _parser2['default'].parse(input);

  return ast;
}

function parse(input, options) {
  var ast = parseWithoutProcessing(input, options);
  var strip = new _whitespaceControl2['default'](options);

  return strip.accept(ast);
}


},{"../utils":1151,"./helpers":1127,"./parser":1129,"./whitespace-control":1132}],1125:[function(require,module,exports){
/* global define */
'use strict';

exports.__esModule = true;

var _utils = require('../utils');

var SourceNode = undefined;

try {
  /* istanbul ignore next */
  if (typeof define !== 'function' || !define.amd) {
    // We don't support this in AMD environments. For these environments, we asusme that
    // they are running on the browser and thus have no need for the source-map library.
    var SourceMap = require('source-map');
    SourceNode = SourceMap.SourceNode;
  }
} catch (err) {}
/* NOP */

/* istanbul ignore if: tested but not covered in istanbul due to dist build  */
if (!SourceNode) {
  SourceNode = function (line, column, srcFile, chunks) {
    this.src = '';
    if (chunks) {
      this.add(chunks);
    }
  };
  /* istanbul ignore next */
  SourceNode.prototype = {
    add: function add(chunks) {
      if (_utils.isArray(chunks)) {
        chunks = chunks.join('');
      }
      this.src += chunks;
    },
    prepend: function prepend(chunks) {
      if (_utils.isArray(chunks)) {
        chunks = chunks.join('');
      }
      this.src = chunks + this.src;
    },
    toStringWithSourceMap: function toStringWithSourceMap() {
      return { code: this.toString() };
    },
    toString: function toString() {
      return this.src;
    }
  };
}

function castChunk(chunk, codeGen, loc) {
  if (_utils.isArray(chunk)) {
    var ret = [];

    for (var i = 0, len = chunk.length; i < len; i++) {
      ret.push(codeGen.wrap(chunk[i], loc));
    }
    return ret;
  } else if (typeof chunk === 'boolean' || typeof chunk === 'number') {
    // Handle primitives that the SourceNode will throw up on
    return chunk + '';
  }
  return chunk;
}

function CodeGen(srcFile) {
  this.srcFile = srcFile;
  this.source = [];
}

CodeGen.prototype = {
  isEmpty: function isEmpty() {
    return !this.source.length;
  },
  prepend: function prepend(source, loc) {
    this.source.unshift(this.wrap(source, loc));
  },
  push: function push(source, loc) {
    this.source.push(this.wrap(source, loc));
  },

  merge: function merge() {
    var source = this.empty();
    this.each(function (line) {
      source.add(['  ', line, '\n']);
    });
    return source;
  },

  each: function each(iter) {
    for (var i = 0, len = this.source.length; i < len; i++) {
      iter(this.source[i]);
    }
  },

  empty: function empty() {
    var loc = this.currentLocation || { start: {} };
    return new SourceNode(loc.start.line, loc.start.column, this.srcFile);
  },
  wrap: function wrap(chunk) {
    var loc = arguments.length <= 1 || arguments[1] === undefined ? this.currentLocation || { start: {} } : arguments[1];

    if (chunk instanceof SourceNode) {
      return chunk;
    }

    chunk = castChunk(chunk, this, loc);

    return new SourceNode(loc.start.line, loc.start.column, this.srcFile, chunk);
  },

  functionCall: function functionCall(fn, type, params) {
    params = this.generateList(params);
    return this.wrap([fn, type ? '.' + type + '(' : '(', params, ')']);
  },

  quotedString: function quotedString(str) {
    return '"' + (str + '').replace(/\\/g, '\\\\').replace(/"/g, '\\"').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/\u2028/g, '\\u2028') // Per Ecma-262 7.3 + 7.8.4
    .replace(/\u2029/g, '\\u2029') + '"';
  },

  objectLiteral: function objectLiteral(obj) {
    // istanbul ignore next

    var _this = this;

    var pairs = [];

    Object.keys(obj).forEach(function (key) {
      var value = castChunk(obj[key], _this);
      if (value !== 'undefined') {
        pairs.push([_this.quotedString(key), ':', value]);
      }
    });

    var ret = this.generateList(pairs);
    ret.prepend('{');
    ret.add('}');
    return ret;
  },

  generateList: function generateList(entries) {
    var ret = this.empty();

    for (var i = 0, len = entries.length; i < len; i++) {
      if (i) {
        ret.add(',');
      }

      ret.add(castChunk(entries[i], this));
    }

    return ret;
  },

  generateArray: function generateArray(entries) {
    var ret = this.generateList(entries);
    ret.prepend('[');
    ret.add(']');

    return ret;
  }
};

exports['default'] = CodeGen;
module.exports = exports['default'];


},{"../utils":1151,"source-map":1199}],1126:[function(require,module,exports){
/* eslint-disable new-cap */

'use strict';

exports.__esModule = true;
exports.Compiler = Compiler;
exports.precompile = precompile;
exports.compile = compile;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _exception = require('../exception');

var _exception2 = _interopRequireDefault(_exception);

var _utils = require('../utils');

var _ast = require('./ast');

var _ast2 = _interopRequireDefault(_ast);

var slice = [].slice;

function Compiler() {}

// the foundHelper register will disambiguate helper lookup from finding a
// function in a context. This is necessary for mustache compatibility, which
// requires that context functions in blocks are evaluated by blockHelperMissing,
// and then proceed as if the resulting value was provided to blockHelperMissing.

Compiler.prototype = {
  compiler: Compiler,

  equals: function equals(other) {
    var len = this.opcodes.length;
    if (other.opcodes.length !== len) {
      return false;
    }

    for (var i = 0; i < len; i++) {
      var opcode = this.opcodes[i],
          otherOpcode = other.opcodes[i];
      if (opcode.opcode !== otherOpcode.opcode || !argEquals(opcode.args, otherOpcode.args)) {
        return false;
      }
    }

    // We know that length is the same between the two arrays because they are directly tied
    // to the opcode behavior above.
    len = this.children.length;
    for (var i = 0; i < len; i++) {
      if (!this.children[i].equals(other.children[i])) {
        return false;
      }
    }

    return true;
  },

  guid: 0,

  compile: function compile(program, options) {
    this.sourceNode = [];
    this.opcodes = [];
    this.children = [];
    this.options = options;
    this.stringParams = options.stringParams;
    this.trackIds = options.trackIds;

    options.blockParams = options.blockParams || [];

    options.knownHelpers = _utils.extend(Object.create(null), {
      helperMissing: true,
      blockHelperMissing: true,
      each: true,
      'if': true,
      unless: true,
      'with': true,
      log: true,
      lookup: true
    }, options.knownHelpers);

    return this.accept(program);
  },

  compileProgram: function compileProgram(program) {
    var childCompiler = new this.compiler(),
        // eslint-disable-line new-cap
    result = childCompiler.compile(program, this.options),
        guid = this.guid++;

    this.usePartial = this.usePartial || result.usePartial;

    this.children[guid] = result;
    this.useDepths = this.useDepths || result.useDepths;

    return guid;
  },

  accept: function accept(node) {
    /* istanbul ignore next: Sanity code */
    if (!this[node.type]) {
      throw new _exception2['default']('Unknown type: ' + node.type, node);
    }

    this.sourceNode.unshift(node);
    var ret = this[node.type](node);
    this.sourceNode.shift();
    return ret;
  },

  Program: function Program(program) {
    this.options.blockParams.unshift(program.blockParams);

    var body = program.body,
        bodyLength = body.length;
    for (var i = 0; i < bodyLength; i++) {
      this.accept(body[i]);
    }

    this.options.blockParams.shift();

    this.isSimple = bodyLength === 1;
    this.blockParams = program.blockParams ? program.blockParams.length : 0;

    return this;
  },

  BlockStatement: function BlockStatement(block) {
    transformLiteralToPath(block);

    var program = block.program,
        inverse = block.inverse;

    program = program && this.compileProgram(program);
    inverse = inverse && this.compileProgram(inverse);

    var type = this.classifySexpr(block);

    if (type === 'helper') {
      this.helperSexpr(block, program, inverse);
    } else if (type === 'simple') {
      this.simpleSexpr(block);

      // now that the simple mustache is resolved, we need to
      // evaluate it by executing `blockHelperMissing`
      this.opcode('pushProgram', program);
      this.opcode('pushProgram', inverse);
      this.opcode('emptyHash');
      this.opcode('blockValue', block.path.original);
    } else {
      this.ambiguousSexpr(block, program, inverse);

      // now that the simple mustache is resolved, we need to
      // evaluate it by executing `blockHelperMissing`
      this.opcode('pushProgram', program);
      this.opcode('pushProgram', inverse);
      this.opcode('emptyHash');
      this.opcode('ambiguousBlockValue');
    }

    this.opcode('append');
  },

  DecoratorBlock: function DecoratorBlock(decorator) {
    var program = decorator.program && this.compileProgram(decorator.program);
    var params = this.setupFullMustacheParams(decorator, program, undefined),
        path = decorator.path;

    this.useDecorators = true;
    this.opcode('registerDecorator', params.length, path.original);
  },

  PartialStatement: function PartialStatement(partial) {
    this.usePartial = true;

    var program = partial.program;
    if (program) {
      program = this.compileProgram(partial.program);
    }

    var params = partial.params;
    if (params.length > 1) {
      throw new _exception2['default']('Unsupported number of partial arguments: ' + params.length, partial);
    } else if (!params.length) {
      if (this.options.explicitPartialContext) {
        this.opcode('pushLiteral', 'undefined');
      } else {
        params.push({ type: 'PathExpression', parts: [], depth: 0 });
      }
    }

    var partialName = partial.name.original,
        isDynamic = partial.name.type === 'SubExpression';
    if (isDynamic) {
      this.accept(partial.name);
    }

    this.setupFullMustacheParams(partial, program, undefined, true);

    var indent = partial.indent || '';
    if (this.options.preventIndent && indent) {
      this.opcode('appendContent', indent);
      indent = '';
    }

    this.opcode('invokePartial', isDynamic, partialName, indent);
    this.opcode('append');
  },
  PartialBlockStatement: function PartialBlockStatement(partialBlock) {
    this.PartialStatement(partialBlock);
  },

  MustacheStatement: function MustacheStatement(mustache) {
    this.SubExpression(mustache);

    if (mustache.escaped && !this.options.noEscape) {
      this.opcode('appendEscaped');
    } else {
      this.opcode('append');
    }
  },
  Decorator: function Decorator(decorator) {
    this.DecoratorBlock(decorator);
  },

  ContentStatement: function ContentStatement(content) {
    if (content.value) {
      this.opcode('appendContent', content.value);
    }
  },

  CommentStatement: function CommentStatement() {},

  SubExpression: function SubExpression(sexpr) {
    transformLiteralToPath(sexpr);
    var type = this.classifySexpr(sexpr);

    if (type === 'simple') {
      this.simpleSexpr(sexpr);
    } else if (type === 'helper') {
      this.helperSexpr(sexpr);
    } else {
      this.ambiguousSexpr(sexpr);
    }
  },
  ambiguousSexpr: function ambiguousSexpr(sexpr, program, inverse) {
    var path = sexpr.path,
        name = path.parts[0],
        isBlock = program != null || inverse != null;

    this.opcode('getContext', path.depth);

    this.opcode('pushProgram', program);
    this.opcode('pushProgram', inverse);

    path.strict = true;
    this.accept(path);

    this.opcode('invokeAmbiguous', name, isBlock);
  },

  simpleSexpr: function simpleSexpr(sexpr) {
    var path = sexpr.path;
    path.strict = true;
    this.accept(path);
    this.opcode('resolvePossibleLambda');
  },

  helperSexpr: function helperSexpr(sexpr, program, inverse) {
    var params = this.setupFullMustacheParams(sexpr, program, inverse),
        path = sexpr.path,
        name = path.parts[0];

    if (this.options.knownHelpers[name]) {
      this.opcode('invokeKnownHelper', params.length, name);
    } else if (this.options.knownHelpersOnly) {
      throw new _exception2['default']('You specified knownHelpersOnly, but used the unknown helper ' + name, sexpr);
    } else {
      path.strict = true;
      path.falsy = true;

      this.accept(path);
      this.opcode('invokeHelper', params.length, path.original, _ast2['default'].helpers.simpleId(path));
    }
  },

  PathExpression: function PathExpression(path) {
    this.addDepth(path.depth);
    this.opcode('getContext', path.depth);

    var name = path.parts[0],
        scoped = _ast2['default'].helpers.scopedId(path),
        blockParamId = !path.depth && !scoped && this.blockParamIndex(name);

    if (blockParamId) {
      this.opcode('lookupBlockParam', blockParamId, path.parts);
    } else if (!name) {
      // Context reference, i.e. `{{foo .}}` or `{{foo ..}}`
      this.opcode('pushContext');
    } else if (path.data) {
      this.options.data = true;
      this.opcode('lookupData', path.depth, path.parts, path.strict);
    } else {
      this.opcode('lookupOnContext', path.parts, path.falsy, path.strict, scoped);
    }
  },

  StringLiteral: function StringLiteral(string) {
    this.opcode('pushString', string.value);
  },

  NumberLiteral: function NumberLiteral(number) {
    this.opcode('pushLiteral', number.value);
  },

  BooleanLiteral: function BooleanLiteral(bool) {
    this.opcode('pushLiteral', bool.value);
  },

  UndefinedLiteral: function UndefinedLiteral() {
    this.opcode('pushLiteral', 'undefined');
  },

  NullLiteral: function NullLiteral() {
    this.opcode('pushLiteral', 'null');
  },

  Hash: function Hash(hash) {
    var pairs = hash.pairs,
        i = 0,
        l = pairs.length;

    this.opcode('pushHash');

    for (; i < l; i++) {
      this.pushParam(pairs[i].value);
    }
    while (i--) {
      this.opcode('assignToHash', pairs[i].key);
    }
    this.opcode('popHash');
  },

  // HELPERS
  opcode: function opcode(name) {
    this.opcodes.push({
      opcode: name,
      args: slice.call(arguments, 1),
      loc: this.sourceNode[0].loc
    });
  },

  addDepth: function addDepth(depth) {
    if (!depth) {
      return;
    }

    this.useDepths = true;
  },

  classifySexpr: function classifySexpr(sexpr) {
    var isSimple = _ast2['default'].helpers.simpleId(sexpr.path);

    var isBlockParam = isSimple && !!this.blockParamIndex(sexpr.path.parts[0]);

    // a mustache is an eligible helper if:
    // * its id is simple (a single part, not `this` or `..`)
    var isHelper = !isBlockParam && _ast2['default'].helpers.helperExpression(sexpr);

    // if a mustache is an eligible helper but not a definite
    // helper, it is ambiguous, and will be resolved in a later
    // pass or at runtime.
    var isEligible = !isBlockParam && (isHelper || isSimple);

    // if ambiguous, we can possibly resolve the ambiguity now
    // An eligible helper is one that does not have a complex path, i.e. `this.foo`, `../foo` etc.
    if (isEligible && !isHelper) {
      var _name = sexpr.path.parts[0],
          options = this.options;
      if (options.knownHelpers[_name]) {
        isHelper = true;
      } else if (options.knownHelpersOnly) {
        isEligible = false;
      }
    }

    if (isHelper) {
      return 'helper';
    } else if (isEligible) {
      return 'ambiguous';
    } else {
      return 'simple';
    }
  },

  pushParams: function pushParams(params) {
    for (var i = 0, l = params.length; i < l; i++) {
      this.pushParam(params[i]);
    }
  },

  pushParam: function pushParam(val) {
    var value = val.value != null ? val.value : val.original || '';

    if (this.stringParams) {
      if (value.replace) {
        value = value.replace(/^(\.?\.\/)*/g, '').replace(/\//g, '.');
      }

      if (val.depth) {
        this.addDepth(val.depth);
      }
      this.opcode('getContext', val.depth || 0);
      this.opcode('pushStringParam', value, val.type);

      if (val.type === 'SubExpression') {
        // SubExpressions get evaluated and passed in
        // in string params mode.
        this.accept(val);
      }
    } else {
      if (this.trackIds) {
        var blockParamIndex = undefined;
        if (val.parts && !_ast2['default'].helpers.scopedId(val) && !val.depth) {
          blockParamIndex = this.blockParamIndex(val.parts[0]);
        }
        if (blockParamIndex) {
          var blockParamChild = val.parts.slice(1).join('.');
          this.opcode('pushId', 'BlockParam', blockParamIndex, blockParamChild);
        } else {
          value = val.original || value;
          if (value.replace) {
            value = value.replace(/^this(?:\.|$)/, '').replace(/^\.\//, '').replace(/^\.$/, '');
          }

          this.opcode('pushId', val.type, value);
        }
      }
      this.accept(val);
    }
  },

  setupFullMustacheParams: function setupFullMustacheParams(sexpr, program, inverse, omitEmpty) {
    var params = sexpr.params;
    this.pushParams(params);

    this.opcode('pushProgram', program);
    this.opcode('pushProgram', inverse);

    if (sexpr.hash) {
      this.accept(sexpr.hash);
    } else {
      this.opcode('emptyHash', omitEmpty);
    }

    return params;
  },

  blockParamIndex: function blockParamIndex(name) {
    for (var depth = 0, len = this.options.blockParams.length; depth < len; depth++) {
      var blockParams = this.options.blockParams[depth],
          param = blockParams && _utils.indexOf(blockParams, name);
      if (blockParams && param >= 0) {
        return [depth, param];
      }
    }
  }
};

function precompile(input, options, env) {
  if (input == null || typeof input !== 'string' && input.type !== 'Program') {
    throw new _exception2['default']('You must pass a string or Handlebars AST to Handlebars.precompile. You passed ' + input);
  }

  options = options || {};
  if (!('data' in options)) {
    options.data = true;
  }
  if (options.compat) {
    options.useDepths = true;
  }

  var ast = env.parse(input, options),
      environment = new env.Compiler().compile(ast, options);
  return new env.JavaScriptCompiler().compile(environment, options);
}

function compile(input, options, env) {
  if (options === undefined) options = {};

  if (input == null || typeof input !== 'string' && input.type !== 'Program') {
    throw new _exception2['default']('You must pass a string or Handlebars AST to Handlebars.compile. You passed ' + input);
  }

  options = _utils.extend({}, options);
  if (!('data' in options)) {
    options.data = true;
  }
  if (options.compat) {
    options.useDepths = true;
  }

  var compiled = undefined;

  function compileInput() {
    var ast = env.parse(input, options),
        environment = new env.Compiler().compile(ast, options),
        templateSpec = new env.JavaScriptCompiler().compile(environment, options, undefined, true);
    return env.template(templateSpec);
  }

  // Template is only compiled on first use and cached after that point.
  function ret(context, execOptions) {
    if (!compiled) {
      compiled = compileInput();
    }
    return compiled.call(this, context, execOptions);
  }
  ret._setup = function (setupOptions) {
    if (!compiled) {
      compiled = compileInput();
    }
    return compiled._setup(setupOptions);
  };
  ret._child = function (i, data, blockParams, depths) {
    if (!compiled) {
      compiled = compileInput();
    }
    return compiled._child(i, data, blockParams, depths);
  };
  return ret;
}

function argEquals(a, b) {
  if (a === b) {
    return true;
  }

  if (_utils.isArray(a) && _utils.isArray(b) && a.length === b.length) {
    for (var i = 0; i < a.length; i++) {
      if (!argEquals(a[i], b[i])) {
        return false;
      }
    }
    return true;
  }
}

function transformLiteralToPath(sexpr) {
  if (!sexpr.path.parts) {
    var literal = sexpr.path;
    // Casting to string here to make false and 0 literal values play nicely with the rest
    // of the system.
    sexpr.path = {
      type: 'PathExpression',
      data: false,
      depth: 0,
      parts: [literal.original + ''],
      original: literal.original + '',
      loc: literal.loc
    };
  }
}


},{"../exception":1135,"../utils":1151,"./ast":1123}],1127:[function(require,module,exports){
'use strict';

exports.__esModule = true;
exports.SourceLocation = SourceLocation;
exports.id = id;
exports.stripFlags = stripFlags;
exports.stripComment = stripComment;
exports.preparePath = preparePath;
exports.prepareMustache = prepareMustache;
exports.prepareRawBlock = prepareRawBlock;
exports.prepareBlock = prepareBlock;
exports.prepareProgram = prepareProgram;
exports.preparePartialBlock = preparePartialBlock;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _exception = require('../exception');

var _exception2 = _interopRequireDefault(_exception);

function validateClose(open, close) {
  close = close.path ? close.path.original : close;

  if (open.path.original !== close) {
    var errorNode = { loc: open.path.loc };

    throw new _exception2['default'](open.path.original + " doesn't match " + close, errorNode);
  }
}

function SourceLocation(source, locInfo) {
  this.source = source;
  this.start = {
    line: locInfo.first_line,
    column: locInfo.first_column
  };
  this.end = {
    line: locInfo.last_line,
    column: locInfo.last_column
  };
}

function id(token) {
  if (/^\[.*\]$/.test(token)) {
    return token.substring(1, token.length - 1);
  } else {
    return token;
  }
}

function stripFlags(open, close) {
  return {
    open: open.charAt(2) === '~',
    close: close.charAt(close.length - 3) === '~'
  };
}

function stripComment(comment) {
  return comment.replace(/^\{\{~?!-?-?/, '').replace(/-?-?~?\}\}$/, '');
}

function preparePath(data, parts, loc) {
  loc = this.locInfo(loc);

  var original = data ? '@' : '',
      dig = [],
      depth = 0;

  for (var i = 0, l = parts.length; i < l; i++) {
    var part = parts[i].part,

    // If we have [] syntax then we do not treat path references as operators,
    // i.e. foo.[this] resolves to approximately context.foo['this']
    isLiteral = parts[i].original !== part;
    original += (parts[i].separator || '') + part;

    if (!isLiteral && (part === '..' || part === '.' || part === 'this')) {
      if (dig.length > 0) {
        throw new _exception2['default']('Invalid path: ' + original, { loc: loc });
      } else if (part === '..') {
        depth++;
      }
    } else {
      dig.push(part);
    }
  }

  return {
    type: 'PathExpression',
    data: data,
    depth: depth,
    parts: dig,
    original: original,
    loc: loc
  };
}

function prepareMustache(path, params, hash, open, strip, locInfo) {
  // Must use charAt to support IE pre-10
  var escapeFlag = open.charAt(3) || open.charAt(2),
      escaped = escapeFlag !== '{' && escapeFlag !== '&';

  var decorator = /\*/.test(open);
  return {
    type: decorator ? 'Decorator' : 'MustacheStatement',
    path: path,
    params: params,
    hash: hash,
    escaped: escaped,
    strip: strip,
    loc: this.locInfo(locInfo)
  };
}

function prepareRawBlock(openRawBlock, contents, close, locInfo) {
  validateClose(openRawBlock, close);

  locInfo = this.locInfo(locInfo);
  var program = {
    type: 'Program',
    body: contents,
    strip: {},
    loc: locInfo
  };

  return {
    type: 'BlockStatement',
    path: openRawBlock.path,
    params: openRawBlock.params,
    hash: openRawBlock.hash,
    program: program,
    openStrip: {},
    inverseStrip: {},
    closeStrip: {},
    loc: locInfo
  };
}

function prepareBlock(openBlock, program, inverseAndProgram, close, inverted, locInfo) {
  if (close && close.path) {
    validateClose(openBlock, close);
  }

  var decorator = /\*/.test(openBlock.open);

  program.blockParams = openBlock.blockParams;

  var inverse = undefined,
      inverseStrip = undefined;

  if (inverseAndProgram) {
    if (decorator) {
      throw new _exception2['default']('Unexpected inverse block on decorator', inverseAndProgram);
    }

    if (inverseAndProgram.chain) {
      inverseAndProgram.program.body[0].closeStrip = close.strip;
    }

    inverseStrip = inverseAndProgram.strip;
    inverse = inverseAndProgram.program;
  }

  if (inverted) {
    inverted = inverse;
    inverse = program;
    program = inverted;
  }

  return {
    type: decorator ? 'DecoratorBlock' : 'BlockStatement',
    path: openBlock.path,
    params: openBlock.params,
    hash: openBlock.hash,
    program: program,
    inverse: inverse,
    openStrip: openBlock.strip,
    inverseStrip: inverseStrip,
    closeStrip: close && close.strip,
    loc: this.locInfo(locInfo)
  };
}

function prepareProgram(statements, loc) {
  if (!loc && statements.length) {
    var firstLoc = statements[0].loc,
        lastLoc = statements[statements.length - 1].loc;

    /* istanbul ignore else */
    if (firstLoc && lastLoc) {
      loc = {
        source: firstLoc.source,
        start: {
          line: firstLoc.start.line,
          column: firstLoc.start.column
        },
        end: {
          line: lastLoc.end.line,
          column: lastLoc.end.column
        }
      };
    }
  }

  return {
    type: 'Program',
    body: statements,
    strip: {},
    loc: loc
  };
}

function preparePartialBlock(open, program, close, locInfo) {
  validateClose(open, close);

  return {
    type: 'PartialBlockStatement',
    name: open.path,
    params: open.params,
    hash: open.hash,
    program: program,
    openStrip: open.strip,
    closeStrip: close && close.strip,
    loc: this.locInfo(locInfo)
  };
}


},{"../exception":1135}],1128:[function(require,module,exports){
'use strict';

exports.__esModule = true;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _base = require('../base');

var _exception = require('../exception');

var _exception2 = _interopRequireDefault(_exception);

var _utils = require('../utils');

var _codeGen = require('./code-gen');

var _codeGen2 = _interopRequireDefault(_codeGen);

function Literal(value) {
  this.value = value;
}

function JavaScriptCompiler() {}

JavaScriptCompiler.prototype = {
  // PUBLIC API: You can override these methods in a subclass to provide
  // alternative compiled forms for name lookup and buffering semantics
  nameLookup: function nameLookup(parent, name /*,  type */) {
    return this.internalNameLookup(parent, name);
  },
  depthedLookup: function depthedLookup(name) {
    return [this.aliasable('container.lookup'), '(depths, ', JSON.stringify(name), ')'];
  },

  compilerInfo: function compilerInfo() {
    var revision = _base.COMPILER_REVISION,
        versions = _base.REVISION_CHANGES[revision];
    return [revision, versions];
  },

  appendToBuffer: function appendToBuffer(source, location, explicit) {
    // Force a source as this simplifies the merge logic.
    if (!_utils.isArray(source)) {
      source = [source];
    }
    source = this.source.wrap(source, location);

    if (this.environment.isSimple) {
      return ['return ', source, ';'];
    } else if (explicit) {
      // This is a case where the buffer operation occurs as a child of another
      // construct, generally braces. We have to explicitly output these buffer
      // operations to ensure that the emitted code goes in the correct location.
      return ['buffer += ', source, ';'];
    } else {
      source.appendToBuffer = true;
      return source;
    }
  },

  initializeBuffer: function initializeBuffer() {
    return this.quotedString('');
  },
  // END PUBLIC API
  internalNameLookup: function internalNameLookup(parent, name) {
    this.lookupPropertyFunctionIsUsed = true;
    return ['lookupProperty(', parent, ',', JSON.stringify(name), ')'];
  },

  lookupPropertyFunctionIsUsed: false,

  compile: function compile(environment, options, context, asObject) {
    this.environment = environment;
    this.options = options;
    this.stringParams = this.options.stringParams;
    this.trackIds = this.options.trackIds;
    this.precompile = !asObject;

    this.name = this.environment.name;
    this.isChild = !!context;
    this.context = context || {
      decorators: [],
      programs: [],
      environments: []
    };

    this.preamble();

    this.stackSlot = 0;
    this.stackVars = [];
    this.aliases = {};
    this.registers = { list: [] };
    this.hashes = [];
    this.compileStack = [];
    this.inlineStack = [];
    this.blockParams = [];

    this.compileChildren(environment, options);

    this.useDepths = this.useDepths || environment.useDepths || environment.useDecorators || this.options.compat;
    this.useBlockParams = this.useBlockParams || environment.useBlockParams;

    var opcodes = environment.opcodes,
        opcode = undefined,
        firstLoc = undefined,
        i = undefined,
        l = undefined;

    for (i = 0, l = opcodes.length; i < l; i++) {
      opcode = opcodes[i];

      this.source.currentLocation = opcode.loc;
      firstLoc = firstLoc || opcode.loc;
      this[opcode.opcode].apply(this, opcode.args);
    }

    // Flush any trailing content that might be pending.
    this.source.currentLocation = firstLoc;
    this.pushSource('');

    /* istanbul ignore next */
    if (this.stackSlot || this.inlineStack.length || this.compileStack.length) {
      throw new _exception2['default']('Compile completed with content left on stack');
    }

    if (!this.decorators.isEmpty()) {
      this.useDecorators = true;

      this.decorators.prepend(['var decorators = container.decorators, ', this.lookupPropertyFunctionVarDeclaration(), ';\n']);
      this.decorators.push('return fn;');

      if (asObject) {
        this.decorators = Function.apply(this, ['fn', 'props', 'container', 'depth0', 'data', 'blockParams', 'depths', this.decorators.merge()]);
      } else {
        this.decorators.prepend('function(fn, props, container, depth0, data, blockParams, depths) {\n');
        this.decorators.push('}\n');
        this.decorators = this.decorators.merge();
      }
    } else {
      this.decorators = undefined;
    }

    var fn = this.createFunctionContext(asObject);
    if (!this.isChild) {
      var ret = {
        compiler: this.compilerInfo(),
        main: fn
      };

      if (this.decorators) {
        ret.main_d = this.decorators; // eslint-disable-line camelcase
        ret.useDecorators = true;
      }

      var _context = this.context;
      var programs = _context.programs;
      var decorators = _context.decorators;

      for (i = 0, l = programs.length; i < l; i++) {
        if (programs[i]) {
          ret[i] = programs[i];
          if (decorators[i]) {
            ret[i + '_d'] = decorators[i];
            ret.useDecorators = true;
          }
        }
      }

      if (this.environment.usePartial) {
        ret.usePartial = true;
      }
      if (this.options.data) {
        ret.useData = true;
      }
      if (this.useDepths) {
        ret.useDepths = true;
      }
      if (this.useBlockParams) {
        ret.useBlockParams = true;
      }
      if (this.options.compat) {
        ret.compat = true;
      }

      if (!asObject) {
        ret.compiler = JSON.stringify(ret.compiler);

        this.source.currentLocation = { start: { line: 1, column: 0 } };
        ret = this.objectLiteral(ret);

        if (options.srcName) {
          ret = ret.toStringWithSourceMap({ file: options.destName });
          ret.map = ret.map && ret.map.toString();
        } else {
          ret = ret.toString();
        }
      } else {
        ret.compilerOptions = this.options;
      }

      return ret;
    } else {
      return fn;
    }
  },

  preamble: function preamble() {
    // track the last context pushed into place to allow skipping the
    // getContext opcode when it would be a noop
    this.lastContext = 0;
    this.source = new _codeGen2['default'](this.options.srcName);
    this.decorators = new _codeGen2['default'](this.options.srcName);
  },

  createFunctionContext: function createFunctionContext(asObject) {
    // istanbul ignore next

    var _this = this;

    var varDeclarations = '';

    var locals = this.stackVars.concat(this.registers.list);
    if (locals.length > 0) {
      varDeclarations += ', ' + locals.join(', ');
    }

    // Generate minimizer alias mappings
    //
    // When using true SourceNodes, this will update all references to the given alias
    // as the source nodes are reused in situ. For the non-source node compilation mode,
    // aliases will not be used, but this case is already being run on the client and
    // we aren't concern about minimizing the template size.
    var aliasCount = 0;
    Object.keys(this.aliases).forEach(function (alias) {
      var node = _this.aliases[alias];
      if (node.children && node.referenceCount > 1) {
        varDeclarations += ', alias' + ++aliasCount + '=' + alias;
        node.children[0] = 'alias' + aliasCount;
      }
    });

    if (this.lookupPropertyFunctionIsUsed) {
      varDeclarations += ', ' + this.lookupPropertyFunctionVarDeclaration();
    }

    var params = ['container', 'depth0', 'helpers', 'partials', 'data'];

    if (this.useBlockParams || this.useDepths) {
      params.push('blockParams');
    }
    if (this.useDepths) {
      params.push('depths');
    }

    // Perform a second pass over the output to merge content when possible
    var source = this.mergeSource(varDeclarations);

    if (asObject) {
      params.push(source);

      return Function.apply(this, params);
    } else {
      return this.source.wrap(['function(', params.join(','), ') {\n  ', source, '}']);
    }
  },
  mergeSource: function mergeSource(varDeclarations) {
    var isSimple = this.environment.isSimple,
        appendOnly = !this.forceBuffer,
        appendFirst = undefined,
        sourceSeen = undefined,
        bufferStart = undefined,
        bufferEnd = undefined;
    this.source.each(function (line) {
      if (line.appendToBuffer) {
        if (bufferStart) {
          line.prepend('  + ');
        } else {
          bufferStart = line;
        }
        bufferEnd = line;
      } else {
        if (bufferStart) {
          if (!sourceSeen) {
            appendFirst = true;
          } else {
            bufferStart.prepend('buffer += ');
          }
          bufferEnd.add(';');
          bufferStart = bufferEnd = undefined;
        }

        sourceSeen = true;
        if (!isSimple) {
          appendOnly = false;
        }
      }
    });

    if (appendOnly) {
      if (bufferStart) {
        bufferStart.prepend('return ');
        bufferEnd.add(';');
      } else if (!sourceSeen) {
        this.source.push('return "";');
      }
    } else {
      varDeclarations += ', buffer = ' + (appendFirst ? '' : this.initializeBuffer());

      if (bufferStart) {
        bufferStart.prepend('return buffer + ');
        bufferEnd.add(';');
      } else {
        this.source.push('return buffer;');
      }
    }

    if (varDeclarations) {
      this.source.prepend('var ' + varDeclarations.substring(2) + (appendFirst ? '' : ';\n'));
    }

    return this.source.merge();
  },

  lookupPropertyFunctionVarDeclaration: function lookupPropertyFunctionVarDeclaration() {
    return '\n      lookupProperty = container.lookupProperty || function(parent, propertyName) {\n        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {\n          return parent[propertyName];\n        }\n        return undefined\n    }\n    '.trim();
  },

  // [blockValue]
  //
  // On stack, before: hash, inverse, program, value
  // On stack, after: return value of blockHelperMissing
  //
  // The purpose of this opcode is to take a block of the form
  // `{{#this.foo}}...{{/this.foo}}`, resolve the value of `foo`, and
  // replace it on the stack with the result of properly
  // invoking blockHelperMissing.
  blockValue: function blockValue(name) {
    var blockHelperMissing = this.aliasable('container.hooks.blockHelperMissing'),
        params = [this.contextName(0)];
    this.setupHelperArgs(name, 0, params);

    var blockName = this.popStack();
    params.splice(1, 0, blockName);

    this.push(this.source.functionCall(blockHelperMissing, 'call', params));
  },

  // [ambiguousBlockValue]
  //
  // On stack, before: hash, inverse, program, value
  // Compiler value, before: lastHelper=value of last found helper, if any
  // On stack, after, if no lastHelper: same as [blockValue]
  // On stack, after, if lastHelper: value
  ambiguousBlockValue: function ambiguousBlockValue() {
    // We're being a bit cheeky and reusing the options value from the prior exec
    var blockHelperMissing = this.aliasable('container.hooks.blockHelperMissing'),
        params = [this.contextName(0)];
    this.setupHelperArgs('', 0, params, true);

    this.flushInline();

    var current = this.topStack();
    params.splice(1, 0, current);

    this.pushSource(['if (!', this.lastHelper, ') { ', current, ' = ', this.source.functionCall(blockHelperMissing, 'call', params), '}']);
  },

  // [appendContent]
  //
  // On stack, before: ...
  // On stack, after: ...
  //
  // Appends the string value of `content` to the current buffer
  appendContent: function appendContent(content) {
    if (this.pendingContent) {
      content = this.pendingContent + content;
    } else {
      this.pendingLocation = this.source.currentLocation;
    }

    this.pendingContent = content;
  },

  // [append]
  //
  // On stack, before: value, ...
  // On stack, after: ...
  //
  // Coerces `value` to a String and appends it to the current buffer.
  //
  // If `value` is truthy, or 0, it is coerced into a string and appended
  // Otherwise, the empty string is appended
  append: function append() {
    if (this.isInline()) {
      this.replaceStack(function (current) {
        return [' != null ? ', current, ' : ""'];
      });

      this.pushSource(this.appendToBuffer(this.popStack()));
    } else {
      var local = this.popStack();
      this.pushSource(['if (', local, ' != null) { ', this.appendToBuffer(local, undefined, true), ' }']);
      if (this.environment.isSimple) {
        this.pushSource(['else { ', this.appendToBuffer("''", undefined, true), ' }']);
      }
    }
  },

  // [appendEscaped]
  //
  // On stack, before: value, ...
  // On stack, after: ...
  //
  // Escape `value` and append it to the buffer
  appendEscaped: function appendEscaped() {
    this.pushSource(this.appendToBuffer([this.aliasable('container.escapeExpression'), '(', this.popStack(), ')']));
  },

  // [getContext]
  //
  // On stack, before: ...
  // On stack, after: ...
  // Compiler value, after: lastContext=depth
  //
  // Set the value of the `lastContext` compiler value to the depth
  getContext: function getContext(depth) {
    this.lastContext = depth;
  },

  // [pushContext]
  //
  // On stack, before: ...
  // On stack, after: currentContext, ...
  //
  // Pushes the value of the current context onto the stack.
  pushContext: function pushContext() {
    this.pushStackLiteral(this.contextName(this.lastContext));
  },

  // [lookupOnContext]
  //
  // On stack, before: ...
  // On stack, after: currentContext[name], ...
  //
  // Looks up the value of `name` on the current context and pushes
  // it onto the stack.
  lookupOnContext: function lookupOnContext(parts, falsy, strict, scoped) {
    var i = 0;

    if (!scoped && this.options.compat && !this.lastContext) {
      // The depthed query is expected to handle the undefined logic for the root level that
      // is implemented below, so we evaluate that directly in compat mode
      this.push(this.depthedLookup(parts[i++]));
    } else {
      this.pushContext();
    }

    this.resolvePath('context', parts, i, falsy, strict);
  },

  // [lookupBlockParam]
  //
  // On stack, before: ...
  // On stack, after: blockParam[name], ...
  //
  // Looks up the value of `parts` on the given block param and pushes
  // it onto the stack.
  lookupBlockParam: function lookupBlockParam(blockParamId, parts) {
    this.useBlockParams = true;

    this.push(['blockParams[', blockParamId[0], '][', blockParamId[1], ']']);
    this.resolvePath('context', parts, 1);
  },

  // [lookupData]
  //
  // On stack, before: ...
  // On stack, after: data, ...
  //
  // Push the data lookup operator
  lookupData: function lookupData(depth, parts, strict) {
    if (!depth) {
      this.pushStackLiteral('data');
    } else {
      this.pushStackLiteral('container.data(data, ' + depth + ')');
    }

    this.resolvePath('data', parts, 0, true, strict);
  },

  resolvePath: function resolvePath(type, parts, i, falsy, strict) {
    // istanbul ignore next

    var _this2 = this;

    if (this.options.strict || this.options.assumeObjects) {
      this.push(strictLookup(this.options.strict && strict, this, parts, type));
      return;
    }

    var len = parts.length;
    for (; i < len; i++) {
      /* eslint-disable no-loop-func */
      this.replaceStack(function (current) {
        var lookup = _this2.nameLookup(current, parts[i], type);
        // We want to ensure that zero and false are handled properly if the context (falsy flag)
        // needs to have the special handling for these values.
        if (!falsy) {
          return [' != null ? ', lookup, ' : ', current];
        } else {
          // Otherwise we can use generic falsy handling
          return [' && ', lookup];
        }
      });
      /* eslint-enable no-loop-func */
    }
  },

  // [resolvePossibleLambda]
  //
  // On stack, before: value, ...
  // On stack, after: resolved value, ...
  //
  // If the `value` is a lambda, replace it on the stack by
  // the return value of the lambda
  resolvePossibleLambda: function resolvePossibleLambda() {
    this.push([this.aliasable('container.lambda'), '(', this.popStack(), ', ', this.contextName(0), ')']);
  },

  // [pushStringParam]
  //
  // On stack, before: ...
  // On stack, after: string, currentContext, ...
  //
  // This opcode is designed for use in string mode, which
  // provides the string value of a parameter along with its
  // depth rather than resolving it immediately.
  pushStringParam: function pushStringParam(string, type) {
    this.pushContext();
    this.pushString(type);

    // If it's a subexpression, the string result
    // will be pushed after this opcode.
    if (type !== 'SubExpression') {
      if (typeof string === 'string') {
        this.pushString(string);
      } else {
        this.pushStackLiteral(string);
      }
    }
  },

  emptyHash: function emptyHash(omitEmpty) {
    if (this.trackIds) {
      this.push('{}'); // hashIds
    }
    if (this.stringParams) {
      this.push('{}'); // hashContexts
      this.push('{}'); // hashTypes
    }
    this.pushStackLiteral(omitEmpty ? 'undefined' : '{}');
  },
  pushHash: function pushHash() {
    if (this.hash) {
      this.hashes.push(this.hash);
    }
    this.hash = { values: {}, types: [], contexts: [], ids: [] };
  },
  popHash: function popHash() {
    var hash = this.hash;
    this.hash = this.hashes.pop();

    if (this.trackIds) {
      this.push(this.objectLiteral(hash.ids));
    }
    if (this.stringParams) {
      this.push(this.objectLiteral(hash.contexts));
      this.push(this.objectLiteral(hash.types));
    }

    this.push(this.objectLiteral(hash.values));
  },

  // [pushString]
  //
  // On stack, before: ...
  // On stack, after: quotedString(string), ...
  //
  // Push a quoted version of `string` onto the stack
  pushString: function pushString(string) {
    this.pushStackLiteral(this.quotedString(string));
  },

  // [pushLiteral]
  //
  // On stack, before: ...
  // On stack, after: value, ...
  //
  // Pushes a value onto the stack. This operation prevents
  // the compiler from creating a temporary variable to hold
  // it.
  pushLiteral: function pushLiteral(value) {
    this.pushStackLiteral(value);
  },

  // [pushProgram]
  //
  // On stack, before: ...
  // On stack, after: program(guid), ...
  //
  // Push a program expression onto the stack. This takes
  // a compile-time guid and converts it into a runtime-accessible
  // expression.
  pushProgram: function pushProgram(guid) {
    if (guid != null) {
      this.pushStackLiteral(this.programExpression(guid));
    } else {
      this.pushStackLiteral(null);
    }
  },

  // [registerDecorator]
  //
  // On stack, before: hash, program, params..., ...
  // On stack, after: ...
  //
  // Pops off the decorator's parameters, invokes the decorator,
  // and inserts the decorator into the decorators list.
  registerDecorator: function registerDecorator(paramSize, name) {
    var foundDecorator = this.nameLookup('decorators', name, 'decorator'),
        options = this.setupHelperArgs(name, paramSize);

    this.decorators.push(['fn = ', this.decorators.functionCall(foundDecorator, '', ['fn', 'props', 'container', options]), ' || fn;']);
  },

  // [invokeHelper]
  //
  // On stack, before: hash, inverse, program, params..., ...
  // On stack, after: result of helper invocation
  //
  // Pops off the helper's parameters, invokes the helper,
  // and pushes the helper's return value onto the stack.
  //
  // If the helper is not found, `helperMissing` is called.
  invokeHelper: function invokeHelper(paramSize, name, isSimple) {
    var nonHelper = this.popStack(),
        helper = this.setupHelper(paramSize, name);

    var possibleFunctionCalls = [];

    if (isSimple) {
      // direct call to helper
      possibleFunctionCalls.push(helper.name);
    }
    // call a function from the input object
    possibleFunctionCalls.push(nonHelper);
    if (!this.options.strict) {
      possibleFunctionCalls.push(this.aliasable('container.hooks.helperMissing'));
    }

    var functionLookupCode = ['(', this.itemsSeparatedBy(possibleFunctionCalls, '||'), ')'];
    var functionCall = this.source.functionCall(functionLookupCode, 'call', helper.callParams);
    this.push(functionCall);
  },

  itemsSeparatedBy: function itemsSeparatedBy(items, separator) {
    var result = [];
    result.push(items[0]);
    for (var i = 1; i < items.length; i++) {
      result.push(separator, items[i]);
    }
    return result;
  },
  // [invokeKnownHelper]
  //
  // On stack, before: hash, inverse, program, params..., ...
  // On stack, after: result of helper invocation
  //
  // This operation is used when the helper is known to exist,
  // so a `helperMissing` fallback is not required.
  invokeKnownHelper: function invokeKnownHelper(paramSize, name) {
    var helper = this.setupHelper(paramSize, name);
    this.push(this.source.functionCall(helper.name, 'call', helper.callParams));
  },

  // [invokeAmbiguous]
  //
  // On stack, before: hash, inverse, program, params..., ...
  // On stack, after: result of disambiguation
  //
  // This operation is used when an expression like `{{foo}}`
  // is provided, but we don't know at compile-time whether it
  // is a helper or a path.
  //
  // This operation emits more code than the other options,
  // and can be avoided by passing the `knownHelpers` and
  // `knownHelpersOnly` flags at compile-time.
  invokeAmbiguous: function invokeAmbiguous(name, helperCall) {
    this.useRegister('helper');

    var nonHelper = this.popStack();

    this.emptyHash();
    var helper = this.setupHelper(0, name, helperCall);

    var helperName = this.lastHelper = this.nameLookup('helpers', name, 'helper');

    var lookup = ['(', '(helper = ', helperName, ' || ', nonHelper, ')'];
    if (!this.options.strict) {
      lookup[0] = '(helper = ';
      lookup.push(' != null ? helper : ', this.aliasable('container.hooks.helperMissing'));
    }

    this.push(['(', lookup, helper.paramsInit ? ['),(', helper.paramsInit] : [], '),', '(typeof helper === ', this.aliasable('"function"'), ' ? ', this.source.functionCall('helper', 'call', helper.callParams), ' : helper))']);
  },

  // [invokePartial]
  //
  // On stack, before: context, ...
  // On stack after: result of partial invocation
  //
  // This operation pops off a context, invokes a partial with that context,
  // and pushes the result of the invocation back.
  invokePartial: function invokePartial(isDynamic, name, indent) {
    var params = [],
        options = this.setupParams(name, 1, params);

    if (isDynamic) {
      name = this.popStack();
      delete options.name;
    }

    if (indent) {
      options.indent = JSON.stringify(indent);
    }
    options.helpers = 'helpers';
    options.partials = 'partials';
    options.decorators = 'container.decorators';

    if (!isDynamic) {
      params.unshift(this.nameLookup('partials', name, 'partial'));
    } else {
      params.unshift(name);
    }

    if (this.options.compat) {
      options.depths = 'depths';
    }
    options = this.objectLiteral(options);
    params.push(options);

    this.push(this.source.functionCall('container.invokePartial', '', params));
  },

  // [assignToHash]
  //
  // On stack, before: value, ..., hash, ...
  // On stack, after: ..., hash, ...
  //
  // Pops a value off the stack and assigns it to the current hash
  assignToHash: function assignToHash(key) {
    var value = this.popStack(),
        context = undefined,
        type = undefined,
        id = undefined;

    if (this.trackIds) {
      id = this.popStack();
    }
    if (this.stringParams) {
      type = this.popStack();
      context = this.popStack();
    }

    var hash = this.hash;
    if (context) {
      hash.contexts[key] = context;
    }
    if (type) {
      hash.types[key] = type;
    }
    if (id) {
      hash.ids[key] = id;
    }
    hash.values[key] = value;
  },

  pushId: function pushId(type, name, child) {
    if (type === 'BlockParam') {
      this.pushStackLiteral('blockParams[' + name[0] + '].path[' + name[1] + ']' + (child ? ' + ' + JSON.stringify('.' + child) : ''));
    } else if (type === 'PathExpression') {
      this.pushString(name);
    } else if (type === 'SubExpression') {
      this.pushStackLiteral('true');
    } else {
      this.pushStackLiteral('null');
    }
  },

  // HELPERS

  compiler: JavaScriptCompiler,

  compileChildren: function compileChildren(environment, options) {
    var children = environment.children,
        child = undefined,
        compiler = undefined;

    for (var i = 0, l = children.length; i < l; i++) {
      child = children[i];
      compiler = new this.compiler(); // eslint-disable-line new-cap

      var existing = this.matchExistingProgram(child);

      if (existing == null) {
        this.context.programs.push(''); // Placeholder to prevent name conflicts for nested children
        var index = this.context.programs.length;
        child.index = index;
        child.name = 'program' + index;
        this.context.programs[index] = compiler.compile(child, options, this.context, !this.precompile);
        this.context.decorators[index] = compiler.decorators;
        this.context.environments[index] = child;

        this.useDepths = this.useDepths || compiler.useDepths;
        this.useBlockParams = this.useBlockParams || compiler.useBlockParams;
        child.useDepths = this.useDepths;
        child.useBlockParams = this.useBlockParams;
      } else {
        child.index = existing.index;
        child.name = 'program' + existing.index;

        this.useDepths = this.useDepths || existing.useDepths;
        this.useBlockParams = this.useBlockParams || existing.useBlockParams;
      }
    }
  },
  matchExistingProgram: function matchExistingProgram(child) {
    for (var i = 0, len = this.context.environments.length; i < len; i++) {
      var environment = this.context.environments[i];
      if (environment && environment.equals(child)) {
        return environment;
      }
    }
  },

  programExpression: function programExpression(guid) {
    var child = this.environment.children[guid],
        programParams = [child.index, 'data', child.blockParams];

    if (this.useBlockParams || this.useDepths) {
      programParams.push('blockParams');
    }
    if (this.useDepths) {
      programParams.push('depths');
    }

    return 'container.program(' + programParams.join(', ') + ')';
  },

  useRegister: function useRegister(name) {
    if (!this.registers[name]) {
      this.registers[name] = true;
      this.registers.list.push(name);
    }
  },

  push: function push(expr) {
    if (!(expr instanceof Literal)) {
      expr = this.source.wrap(expr);
    }

    this.inlineStack.push(expr);
    return expr;
  },

  pushStackLiteral: function pushStackLiteral(item) {
    this.push(new Literal(item));
  },

  pushSource: function pushSource(source) {
    if (this.pendingContent) {
      this.source.push(this.appendToBuffer(this.source.quotedString(this.pendingContent), this.pendingLocation));
      this.pendingContent = undefined;
    }

    if (source) {
      this.source.push(source);
    }
  },

  replaceStack: function replaceStack(callback) {
    var prefix = ['('],
        stack = undefined,
        createdStack = undefined,
        usedLiteral = undefined;

    /* istanbul ignore next */
    if (!this.isInline()) {
      throw new _exception2['default']('replaceStack on non-inline');
    }

    // We want to merge the inline statement into the replacement statement via ','
    var top = this.popStack(true);

    if (top instanceof Literal) {
      // Literals do not need to be inlined
      stack = [top.value];
      prefix = ['(', stack];
      usedLiteral = true;
    } else {
      // Get or create the current stack name for use by the inline
      createdStack = true;
      var _name = this.incrStack();

      prefix = ['((', this.push(_name), ' = ', top, ')'];
      stack = this.topStack();
    }

    var item = callback.call(this, stack);

    if (!usedLiteral) {
      this.popStack();
    }
    if (createdStack) {
      this.stackSlot--;
    }
    this.push(prefix.concat(item, ')'));
  },

  incrStack: function incrStack() {
    this.stackSlot++;
    if (this.stackSlot > this.stackVars.length) {
      this.stackVars.push('stack' + this.stackSlot);
    }
    return this.topStackName();
  },
  topStackName: function topStackName() {
    return 'stack' + this.stackSlot;
  },
  flushInline: function flushInline() {
    var inlineStack = this.inlineStack;
    this.inlineStack = [];
    for (var i = 0, len = inlineStack.length; i < len; i++) {
      var entry = inlineStack[i];
      /* istanbul ignore if */
      if (entry instanceof Literal) {
        this.compileStack.push(entry);
      } else {
        var stack = this.incrStack();
        this.pushSource([stack, ' = ', entry, ';']);
        this.compileStack.push(stack);
      }
    }
  },
  isInline: function isInline() {
    return this.inlineStack.length;
  },

  popStack: function popStack(wrapped) {
    var inline = this.isInline(),
        item = (inline ? this.inlineStack : this.compileStack).pop();

    if (!wrapped && item instanceof Literal) {
      return item.value;
    } else {
      if (!inline) {
        /* istanbul ignore next */
        if (!this.stackSlot) {
          throw new _exception2['default']('Invalid stack pop');
        }
        this.stackSlot--;
      }
      return item;
    }
  },

  topStack: function topStack() {
    var stack = this.isInline() ? this.inlineStack : this.compileStack,
        item = stack[stack.length - 1];

    /* istanbul ignore if */
    if (item instanceof Literal) {
      return item.value;
    } else {
      return item;
    }
  },

  contextName: function contextName(context) {
    if (this.useDepths && context) {
      return 'depths[' + context + ']';
    } else {
      return 'depth' + context;
    }
  },

  quotedString: function quotedString(str) {
    return this.source.quotedString(str);
  },

  objectLiteral: function objectLiteral(obj) {
    return this.source.objectLiteral(obj);
  },

  aliasable: function aliasable(name) {
    var ret = this.aliases[name];
    if (ret) {
      ret.referenceCount++;
      return ret;
    }

    ret = this.aliases[name] = this.source.wrap(name);
    ret.aliasable = true;
    ret.referenceCount = 1;

    return ret;
  },

  setupHelper: function setupHelper(paramSize, name, blockHelper) {
    var params = [],
        paramsInit = this.setupHelperArgs(name, paramSize, params, blockHelper);
    var foundHelper = this.nameLookup('helpers', name, 'helper'),
        callContext = this.aliasable(this.contextName(0) + ' != null ? ' + this.contextName(0) + ' : (container.nullContext || {})');

    return {
      params: params,
      paramsInit: paramsInit,
      name: foundHelper,
      callParams: [callContext].concat(params)
    };
  },

  setupParams: function setupParams(helper, paramSize, params) {
    var options = {},
        contexts = [],
        types = [],
        ids = [],
        objectArgs = !params,
        param = undefined;

    if (objectArgs) {
      params = [];
    }

    options.name = this.quotedString(helper);
    options.hash = this.popStack();

    if (this.trackIds) {
      options.hashIds = this.popStack();
    }
    if (this.stringParams) {
      options.hashTypes = this.popStack();
      options.hashContexts = this.popStack();
    }

    var inverse = this.popStack(),
        program = this.popStack();

    // Avoid setting fn and inverse if neither are set. This allows
    // helpers to do a check for `if (options.fn)`
    if (program || inverse) {
      options.fn = program || 'container.noop';
      options.inverse = inverse || 'container.noop';
    }

    // The parameters go on to the stack in order (making sure that they are evaluated in order)
    // so we need to pop them off the stack in reverse order
    var i = paramSize;
    while (i--) {
      param = this.popStack();
      params[i] = param;

      if (this.trackIds) {
        ids[i] = this.popStack();
      }
      if (this.stringParams) {
        types[i] = this.popStack();
        contexts[i] = this.popStack();
      }
    }

    if (objectArgs) {
      options.args = this.source.generateArray(params);
    }

    if (this.trackIds) {
      options.ids = this.source.generateArray(ids);
    }
    if (this.stringParams) {
      options.types = this.source.generateArray(types);
      options.contexts = this.source.generateArray(contexts);
    }

    if (this.options.data) {
      options.data = 'data';
    }
    if (this.useBlockParams) {
      options.blockParams = 'blockParams';
    }
    return options;
  },

  setupHelperArgs: function setupHelperArgs(helper, paramSize, params, useRegister) {
    var options = this.setupParams(helper, paramSize, params);
    options.loc = JSON.stringify(this.source.currentLocation);
    options = this.objectLiteral(options);
    if (useRegister) {
      this.useRegister('options');
      params.push('options');
      return ['options=', options];
    } else if (params) {
      params.push(options);
      return '';
    } else {
      return options;
    }
  }
};

(function () {
  var reservedWords = ('break else new var' + ' case finally return void' + ' catch for switch while' + ' continue function this with' + ' default if throw' + ' delete in try' + ' do instanceof typeof' + ' abstract enum int short' + ' boolean export interface static' + ' byte extends long super' + ' char final native synchronized' + ' class float package throws' + ' const goto private transient' + ' debugger implements protected volatile' + ' double import public let yield await' + ' null true false').split(' ');

  var compilerWords = JavaScriptCompiler.RESERVED_WORDS = {};

  for (var i = 0, l = reservedWords.length; i < l; i++) {
    compilerWords[reservedWords[i]] = true;
  }
})();

/**
 * @deprecated May be removed in the next major version
 */
JavaScriptCompiler.isValidJavaScriptVariableName = function (name) {
  return !JavaScriptCompiler.RESERVED_WORDS[name] && /^[a-zA-Z_$][0-9a-zA-Z_$]*$/.test(name);
};

function strictLookup(requireTerminal, compiler, parts, type) {
  var stack = compiler.popStack(),
      i = 0,
      len = parts.length;
  if (requireTerminal) {
    len--;
  }

  for (; i < len; i++) {
    stack = compiler.nameLookup(stack, parts[i], type);
  }

  if (requireTerminal) {
    return [compiler.aliasable('container.strict'), '(', stack, ', ', compiler.quotedString(parts[i]), ', ', JSON.stringify(compiler.source.currentLocation), ' )'];
  } else {
    return stack;
  }
}

exports['default'] = JavaScriptCompiler;
module.exports = exports['default'];


},{"../base":1122,"../exception":1135,"../utils":1151,"./code-gen":1125}],1129:[function(require,module,exports){
// File ignored in coverage tests via setting in .istanbul.yml
/* Jison generated parser */
"use strict";

exports.__esModule = true;
var handlebars = (function () {
    var parser = { trace: function trace() {},
        yy: {},
        symbols_: { "error": 2, "root": 3, "program": 4, "EOF": 5, "program_repetition0": 6, "statement": 7, "mustache": 8, "block": 9, "rawBlock": 10, "partial": 11, "partialBlock": 12, "content": 13, "COMMENT": 14, "CONTENT": 15, "openRawBlock": 16, "rawBlock_repetition0": 17, "END_RAW_BLOCK": 18, "OPEN_RAW_BLOCK": 19, "helperName": 20, "openRawBlock_repetition0": 21, "openRawBlock_option0": 22, "CLOSE_RAW_BLOCK": 23, "openBlock": 24, "block_option0": 25, "closeBlock": 26, "openInverse": 27, "block_option1": 28, "OPEN_BLOCK": 29, "openBlock_repetition0": 30, "openBlock_option0": 31, "openBlock_option1": 32, "CLOSE": 33, "OPEN_INVERSE": 34, "openInverse_repetition0": 35, "openInverse_option0": 36, "openInverse_option1": 37, "openInverseChain": 38, "OPEN_INVERSE_CHAIN": 39, "openInverseChain_repetition0": 40, "openInverseChain_option0": 41, "openInverseChain_option1": 42, "inverseAndProgram": 43, "INVERSE": 44, "inverseChain": 45, "inverseChain_option0": 46, "OPEN_ENDBLOCK": 47, "OPEN": 48, "mustache_repetition0": 49, "mustache_option0": 50, "OPEN_UNESCAPED": 51, "mustache_repetition1": 52, "mustache_option1": 53, "CLOSE_UNESCAPED": 54, "OPEN_PARTIAL": 55, "partialName": 56, "partial_repetition0": 57, "partial_option0": 58, "openPartialBlock": 59, "OPEN_PARTIAL_BLOCK": 60, "openPartialBlock_repetition0": 61, "openPartialBlock_option0": 62, "param": 63, "sexpr": 64, "OPEN_SEXPR": 65, "sexpr_repetition0": 66, "sexpr_option0": 67, "CLOSE_SEXPR": 68, "hash": 69, "hash_repetition_plus0": 70, "hashSegment": 71, "ID": 72, "EQUALS": 73, "blockParams": 74, "OPEN_BLOCK_PARAMS": 75, "blockParams_repetition_plus0": 76, "CLOSE_BLOCK_PARAMS": 77, "path": 78, "dataName": 79, "STRING": 80, "NUMBER": 81, "BOOLEAN": 82, "UNDEFINED": 83, "NULL": 84, "DATA": 85, "pathSegments": 86, "SEP": 87, "$accept": 0, "$end": 1 },
        terminals_: { 2: "error", 5: "EOF", 14: "COMMENT", 15: "CONTENT", 18: "END_RAW_BLOCK", 19: "OPEN_RAW_BLOCK", 23: "CLOSE_RAW_BLOCK", 29: "OPEN_BLOCK", 33: "CLOSE", 34: "OPEN_INVERSE", 39: "OPEN_INVERSE_CHAIN", 44: "INVERSE", 47: "OPEN_ENDBLOCK", 48: "OPEN", 51: "OPEN_UNESCAPED", 54: "CLOSE_UNESCAPED", 55: "OPEN_PARTIAL", 60: "OPEN_PARTIAL_BLOCK", 65: "OPEN_SEXPR", 68: "CLOSE_SEXPR", 72: "ID", 73: "EQUALS", 75: "OPEN_BLOCK_PARAMS", 77: "CLOSE_BLOCK_PARAMS", 80: "STRING", 81: "NUMBER", 82: "BOOLEAN", 83: "UNDEFINED", 84: "NULL", 85: "DATA", 87: "SEP" },
        productions_: [0, [3, 2], [4, 1], [7, 1], [7, 1], [7, 1], [7, 1], [7, 1], [7, 1], [7, 1], [13, 1], [10, 3], [16, 5], [9, 4], [9, 4], [24, 6], [27, 6], [38, 6], [43, 2], [45, 3], [45, 1], [26, 3], [8, 5], [8, 5], [11, 5], [12, 3], [59, 5], [63, 1], [63, 1], [64, 5], [69, 1], [71, 3], [74, 3], [20, 1], [20, 1], [20, 1], [20, 1], [20, 1], [20, 1], [20, 1], [56, 1], [56, 1], [79, 2], [78, 1], [86, 3], [86, 1], [6, 0], [6, 2], [17, 0], [17, 2], [21, 0], [21, 2], [22, 0], [22, 1], [25, 0], [25, 1], [28, 0], [28, 1], [30, 0], [30, 2], [31, 0], [31, 1], [32, 0], [32, 1], [35, 0], [35, 2], [36, 0], [36, 1], [37, 0], [37, 1], [40, 0], [40, 2], [41, 0], [41, 1], [42, 0], [42, 1], [46, 0], [46, 1], [49, 0], [49, 2], [50, 0], [50, 1], [52, 0], [52, 2], [53, 0], [53, 1], [57, 0], [57, 2], [58, 0], [58, 1], [61, 0], [61, 2], [62, 0], [62, 1], [66, 0], [66, 2], [67, 0], [67, 1], [70, 1], [70, 2], [76, 1], [76, 2]],
        performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$) {

            var $0 = $$.length - 1;
            switch (yystate) {
                case 1:
                    return $$[$0 - 1];
                    break;
                case 2:
                    this.$ = yy.prepareProgram($$[$0]);
                    break;
                case 3:
                    this.$ = $$[$0];
                    break;
                case 4:
                    this.$ = $$[$0];
                    break;
                case 5:
                    this.$ = $$[$0];
                    break;
                case 6:
                    this.$ = $$[$0];
                    break;
                case 7:
                    this.$ = $$[$0];
                    break;
                case 8:
                    this.$ = $$[$0];
                    break;
                case 9:
                    this.$ = {
                        type: 'CommentStatement',
                        value: yy.stripComment($$[$0]),
                        strip: yy.stripFlags($$[$0], $$[$0]),
                        loc: yy.locInfo(this._$)
                    };

                    break;
                case 10:
                    this.$ = {
                        type: 'ContentStatement',
                        original: $$[$0],
                        value: $$[$0],
                        loc: yy.locInfo(this._$)
                    };

                    break;
                case 11:
                    this.$ = yy.prepareRawBlock($$[$0 - 2], $$[$0 - 1], $$[$0], this._$);
                    break;
                case 12:
                    this.$ = { path: $$[$0 - 3], params: $$[$0 - 2], hash: $$[$0 - 1] };
                    break;
                case 13:
                    this.$ = yy.prepareBlock($$[$0 - 3], $$[$0 - 2], $$[$0 - 1], $$[$0], false, this._$);
                    break;
                case 14:
                    this.$ = yy.prepareBlock($$[$0 - 3], $$[$0 - 2], $$[$0 - 1], $$[$0], true, this._$);
                    break;
                case 15:
                    this.$ = { open: $$[$0 - 5], path: $$[$0 - 4], params: $$[$0 - 3], hash: $$[$0 - 2], blockParams: $$[$0 - 1], strip: yy.stripFlags($$[$0 - 5], $$[$0]) };
                    break;
                case 16:
                    this.$ = { path: $$[$0 - 4], params: $$[$0 - 3], hash: $$[$0 - 2], blockParams: $$[$0 - 1], strip: yy.stripFlags($$[$0 - 5], $$[$0]) };
                    break;
                case 17:
                    this.$ = { path: $$[$0 - 4], params: $$[$0 - 3], hash: $$[$0 - 2], blockParams: $$[$0 - 1], strip: yy.stripFlags($$[$0 - 5], $$[$0]) };
                    break;
                case 18:
                    this.$ = { strip: yy.stripFlags($$[$0 - 1], $$[$0 - 1]), program: $$[$0] };
                    break;
                case 19:
                    var inverse = yy.prepareBlock($$[$0 - 2], $$[$0 - 1], $$[$0], $$[$0], false, this._$),
                        program = yy.prepareProgram([inverse], $$[$0 - 1].loc);
                    program.chained = true;

                    this.$ = { strip: $$[$0 - 2].strip, program: program, chain: true };

                    break;
                case 20:
                    this.$ = $$[$0];
                    break;
                case 21:
                    this.$ = { path: $$[$0 - 1], strip: yy.stripFlags($$[$0 - 2], $$[$0]) };
                    break;
                case 22:
                    this.$ = yy.prepareMustache($$[$0 - 3], $$[$0 - 2], $$[$0 - 1], $$[$0 - 4], yy.stripFlags($$[$0 - 4], $$[$0]), this._$);
                    break;
                case 23:
                    this.$ = yy.prepareMustache($$[$0 - 3], $$[$0 - 2], $$[$0 - 1], $$[$0 - 4], yy.stripFlags($$[$0 - 4], $$[$0]), this._$);
                    break;
                case 24:
                    this.$ = {
                        type: 'PartialStatement',
                        name: $$[$0 - 3],
                        params: $$[$0 - 2],
                        hash: $$[$0 - 1],
                        indent: '',
                        strip: yy.stripFlags($$[$0 - 4], $$[$0]),
                        loc: yy.locInfo(this._$)
                    };

                    break;
                case 25:
                    this.$ = yy.preparePartialBlock($$[$0 - 2], $$[$0 - 1], $$[$0], this._$);
                    break;
                case 26:
                    this.$ = { path: $$[$0 - 3], params: $$[$0 - 2], hash: $$[$0 - 1], strip: yy.stripFlags($$[$0 - 4], $$[$0]) };
                    break;
                case 27:
                    this.$ = $$[$0];
                    break;
                case 28:
                    this.$ = $$[$0];
                    break;
                case 29:
                    this.$ = {
                        type: 'SubExpression',
                        path: $$[$0 - 3],
                        params: $$[$0 - 2],
                        hash: $$[$0 - 1],
                        loc: yy.locInfo(this._$)
                    };

                    break;
                case 30:
                    this.$ = { type: 'Hash', pairs: $$[$0], loc: yy.locInfo(this._$) };
                    break;
                case 31:
                    this.$ = { type: 'HashPair', key: yy.id($$[$0 - 2]), value: $$[$0], loc: yy.locInfo(this._$) };
                    break;
                case 32:
                    this.$ = yy.id($$[$0 - 1]);
                    break;
                case 33:
                    this.$ = $$[$0];
                    break;
                case 34:
                    this.$ = $$[$0];
                    break;
                case 35:
                    this.$ = { type: 'StringLiteral', value: $$[$0], original: $$[$0], loc: yy.locInfo(this._$) };
                    break;
                case 36:
                    this.$ = { type: 'NumberLiteral', value: Number($$[$0]), original: Number($$[$0]), loc: yy.locInfo(this._$) };
                    break;
                case 37:
                    this.$ = { type: 'BooleanLiteral', value: $$[$0] === 'true', original: $$[$0] === 'true', loc: yy.locInfo(this._$) };
                    break;
                case 38:
                    this.$ = { type: 'UndefinedLiteral', original: undefined, value: undefined, loc: yy.locInfo(this._$) };
                    break;
                case 39:
                    this.$ = { type: 'NullLiteral', original: null, value: null, loc: yy.locInfo(this._$) };
                    break;
                case 40:
                    this.$ = $$[$0];
                    break;
                case 41:
                    this.$ = $$[$0];
                    break;
                case 42:
                    this.$ = yy.preparePath(true, $$[$0], this._$);
                    break;
                case 43:
                    this.$ = yy.preparePath(false, $$[$0], this._$);
                    break;
                case 44:
                    $$[$0 - 2].push({ part: yy.id($$[$0]), original: $$[$0], separator: $$[$0 - 1] });this.$ = $$[$0 - 2];
                    break;
                case 45:
                    this.$ = [{ part: yy.id($$[$0]), original: $$[$0] }];
                    break;
                case 46:
                    this.$ = [];
                    break;
                case 47:
                    $$[$0 - 1].push($$[$0]);
                    break;
                case 48:
                    this.$ = [];
                    break;
                case 49:
                    $$[$0 - 1].push($$[$0]);
                    break;
                case 50:
                    this.$ = [];
                    break;
                case 51:
                    $$[$0 - 1].push($$[$0]);
                    break;
                case 58:
                    this.$ = [];
                    break;
                case 59:
                    $$[$0 - 1].push($$[$0]);
                    break;
                case 64:
                    this.$ = [];
                    break;
                case 65:
                    $$[$0 - 1].push($$[$0]);
                    break;
                case 70:
                    this.$ = [];
                    break;
                case 71:
                    $$[$0 - 1].push($$[$0]);
                    break;
                case 78:
                    this.$ = [];
                    break;
                case 79:
                    $$[$0 - 1].push($$[$0]);
                    break;
                case 82:
                    this.$ = [];
                    break;
                case 83:
                    $$[$0 - 1].push($$[$0]);
                    break;
                case 86:
                    this.$ = [];
                    break;
                case 87:
                    $$[$0 - 1].push($$[$0]);
                    break;
                case 90:
                    this.$ = [];
                    break;
                case 91:
                    $$[$0 - 1].push($$[$0]);
                    break;
                case 94:
                    this.$ = [];
                    break;
                case 95:
                    $$[$0 - 1].push($$[$0]);
                    break;
                case 98:
                    this.$ = [$$[$0]];
                    break;
                case 99:
                    $$[$0 - 1].push($$[$0]);
                    break;
                case 100:
                    this.$ = [$$[$0]];
                    break;
                case 101:
                    $$[$0 - 1].push($$[$0]);
                    break;
            }
        },
        table: [{ 3: 1, 4: 2, 5: [2, 46], 6: 3, 14: [2, 46], 15: [2, 46], 19: [2, 46], 29: [2, 46], 34: [2, 46], 48: [2, 46], 51: [2, 46], 55: [2, 46], 60: [2, 46] }, { 1: [3] }, { 5: [1, 4] }, { 5: [2, 2], 7: 5, 8: 6, 9: 7, 10: 8, 11: 9, 12: 10, 13: 11, 14: [1, 12], 15: [1, 20], 16: 17, 19: [1, 23], 24: 15, 27: 16, 29: [1, 21], 34: [1, 22], 39: [2, 2], 44: [2, 2], 47: [2, 2], 48: [1, 13], 51: [1, 14], 55: [1, 18], 59: 19, 60: [1, 24] }, { 1: [2, 1] }, { 5: [2, 47], 14: [2, 47], 15: [2, 47], 19: [2, 47], 29: [2, 47], 34: [2, 47], 39: [2, 47], 44: [2, 47], 47: [2, 47], 48: [2, 47], 51: [2, 47], 55: [2, 47], 60: [2, 47] }, { 5: [2, 3], 14: [2, 3], 15: [2, 3], 19: [2, 3], 29: [2, 3], 34: [2, 3], 39: [2, 3], 44: [2, 3], 47: [2, 3], 48: [2, 3], 51: [2, 3], 55: [2, 3], 60: [2, 3] }, { 5: [2, 4], 14: [2, 4], 15: [2, 4], 19: [2, 4], 29: [2, 4], 34: [2, 4], 39: [2, 4], 44: [2, 4], 47: [2, 4], 48: [2, 4], 51: [2, 4], 55: [2, 4], 60: [2, 4] }, { 5: [2, 5], 14: [2, 5], 15: [2, 5], 19: [2, 5], 29: [2, 5], 34: [2, 5], 39: [2, 5], 44: [2, 5], 47: [2, 5], 48: [2, 5], 51: [2, 5], 55: [2, 5], 60: [2, 5] }, { 5: [2, 6], 14: [2, 6], 15: [2, 6], 19: [2, 6], 29: [2, 6], 34: [2, 6], 39: [2, 6], 44: [2, 6], 47: [2, 6], 48: [2, 6], 51: [2, 6], 55: [2, 6], 60: [2, 6] }, { 5: [2, 7], 14: [2, 7], 15: [2, 7], 19: [2, 7], 29: [2, 7], 34: [2, 7], 39: [2, 7], 44: [2, 7], 47: [2, 7], 48: [2, 7], 51: [2, 7], 55: [2, 7], 60: [2, 7] }, { 5: [2, 8], 14: [2, 8], 15: [2, 8], 19: [2, 8], 29: [2, 8], 34: [2, 8], 39: [2, 8], 44: [2, 8], 47: [2, 8], 48: [2, 8], 51: [2, 8], 55: [2, 8], 60: [2, 8] }, { 5: [2, 9], 14: [2, 9], 15: [2, 9], 19: [2, 9], 29: [2, 9], 34: [2, 9], 39: [2, 9], 44: [2, 9], 47: [2, 9], 48: [2, 9], 51: [2, 9], 55: [2, 9], 60: [2, 9] }, { 20: 25, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 36, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 4: 37, 6: 3, 14: [2, 46], 15: [2, 46], 19: [2, 46], 29: [2, 46], 34: [2, 46], 39: [2, 46], 44: [2, 46], 47: [2, 46], 48: [2, 46], 51: [2, 46], 55: [2, 46], 60: [2, 46] }, { 4: 38, 6: 3, 14: [2, 46], 15: [2, 46], 19: [2, 46], 29: [2, 46], 34: [2, 46], 44: [2, 46], 47: [2, 46], 48: [2, 46], 51: [2, 46], 55: [2, 46], 60: [2, 46] }, { 15: [2, 48], 17: 39, 18: [2, 48] }, { 20: 41, 56: 40, 64: 42, 65: [1, 43], 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 4: 44, 6: 3, 14: [2, 46], 15: [2, 46], 19: [2, 46], 29: [2, 46], 34: [2, 46], 47: [2, 46], 48: [2, 46], 51: [2, 46], 55: [2, 46], 60: [2, 46] }, { 5: [2, 10], 14: [2, 10], 15: [2, 10], 18: [2, 10], 19: [2, 10], 29: [2, 10], 34: [2, 10], 39: [2, 10], 44: [2, 10], 47: [2, 10], 48: [2, 10], 51: [2, 10], 55: [2, 10], 60: [2, 10] }, { 20: 45, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 46, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 47, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 41, 56: 48, 64: 42, 65: [1, 43], 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 33: [2, 78], 49: 49, 65: [2, 78], 72: [2, 78], 80: [2, 78], 81: [2, 78], 82: [2, 78], 83: [2, 78], 84: [2, 78], 85: [2, 78] }, { 23: [2, 33], 33: [2, 33], 54: [2, 33], 65: [2, 33], 68: [2, 33], 72: [2, 33], 75: [2, 33], 80: [2, 33], 81: [2, 33], 82: [2, 33], 83: [2, 33], 84: [2, 33], 85: [2, 33] }, { 23: [2, 34], 33: [2, 34], 54: [2, 34], 65: [2, 34], 68: [2, 34], 72: [2, 34], 75: [2, 34], 80: [2, 34], 81: [2, 34], 82: [2, 34], 83: [2, 34], 84: [2, 34], 85: [2, 34] }, { 23: [2, 35], 33: [2, 35], 54: [2, 35], 65: [2, 35], 68: [2, 35], 72: [2, 35], 75: [2, 35], 80: [2, 35], 81: [2, 35], 82: [2, 35], 83: [2, 35], 84: [2, 35], 85: [2, 35] }, { 23: [2, 36], 33: [2, 36], 54: [2, 36], 65: [2, 36], 68: [2, 36], 72: [2, 36], 75: [2, 36], 80: [2, 36], 81: [2, 36], 82: [2, 36], 83: [2, 36], 84: [2, 36], 85: [2, 36] }, { 23: [2, 37], 33: [2, 37], 54: [2, 37], 65: [2, 37], 68: [2, 37], 72: [2, 37], 75: [2, 37], 80: [2, 37], 81: [2, 37], 82: [2, 37], 83: [2, 37], 84: [2, 37], 85: [2, 37] }, { 23: [2, 38], 33: [2, 38], 54: [2, 38], 65: [2, 38], 68: [2, 38], 72: [2, 38], 75: [2, 38], 80: [2, 38], 81: [2, 38], 82: [2, 38], 83: [2, 38], 84: [2, 38], 85: [2, 38] }, { 23: [2, 39], 33: [2, 39], 54: [2, 39], 65: [2, 39], 68: [2, 39], 72: [2, 39], 75: [2, 39], 80: [2, 39], 81: [2, 39], 82: [2, 39], 83: [2, 39], 84: [2, 39], 85: [2, 39] }, { 23: [2, 43], 33: [2, 43], 54: [2, 43], 65: [2, 43], 68: [2, 43], 72: [2, 43], 75: [2, 43], 80: [2, 43], 81: [2, 43], 82: [2, 43], 83: [2, 43], 84: [2, 43], 85: [2, 43], 87: [1, 50] }, { 72: [1, 35], 86: 51 }, { 23: [2, 45], 33: [2, 45], 54: [2, 45], 65: [2, 45], 68: [2, 45], 72: [2, 45], 75: [2, 45], 80: [2, 45], 81: [2, 45], 82: [2, 45], 83: [2, 45], 84: [2, 45], 85: [2, 45], 87: [2, 45] }, { 52: 52, 54: [2, 82], 65: [2, 82], 72: [2, 82], 80: [2, 82], 81: [2, 82], 82: [2, 82], 83: [2, 82], 84: [2, 82], 85: [2, 82] }, { 25: 53, 38: 55, 39: [1, 57], 43: 56, 44: [1, 58], 45: 54, 47: [2, 54] }, { 28: 59, 43: 60, 44: [1, 58], 47: [2, 56] }, { 13: 62, 15: [1, 20], 18: [1, 61] }, { 33: [2, 86], 57: 63, 65: [2, 86], 72: [2, 86], 80: [2, 86], 81: [2, 86], 82: [2, 86], 83: [2, 86], 84: [2, 86], 85: [2, 86] }, { 33: [2, 40], 65: [2, 40], 72: [2, 40], 80: [2, 40], 81: [2, 40], 82: [2, 40], 83: [2, 40], 84: [2, 40], 85: [2, 40] }, { 33: [2, 41], 65: [2, 41], 72: [2, 41], 80: [2, 41], 81: [2, 41], 82: [2, 41], 83: [2, 41], 84: [2, 41], 85: [2, 41] }, { 20: 64, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 26: 65, 47: [1, 66] }, { 30: 67, 33: [2, 58], 65: [2, 58], 72: [2, 58], 75: [2, 58], 80: [2, 58], 81: [2, 58], 82: [2, 58], 83: [2, 58], 84: [2, 58], 85: [2, 58] }, { 33: [2, 64], 35: 68, 65: [2, 64], 72: [2, 64], 75: [2, 64], 80: [2, 64], 81: [2, 64], 82: [2, 64], 83: [2, 64], 84: [2, 64], 85: [2, 64] }, { 21: 69, 23: [2, 50], 65: [2, 50], 72: [2, 50], 80: [2, 50], 81: [2, 50], 82: [2, 50], 83: [2, 50], 84: [2, 50], 85: [2, 50] }, { 33: [2, 90], 61: 70, 65: [2, 90], 72: [2, 90], 80: [2, 90], 81: [2, 90], 82: [2, 90], 83: [2, 90], 84: [2, 90], 85: [2, 90] }, { 20: 74, 33: [2, 80], 50: 71, 63: 72, 64: 75, 65: [1, 43], 69: 73, 70: 76, 71: 77, 72: [1, 78], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 72: [1, 79] }, { 23: [2, 42], 33: [2, 42], 54: [2, 42], 65: [2, 42], 68: [2, 42], 72: [2, 42], 75: [2, 42], 80: [2, 42], 81: [2, 42], 82: [2, 42], 83: [2, 42], 84: [2, 42], 85: [2, 42], 87: [1, 50] }, { 20: 74, 53: 80, 54: [2, 84], 63: 81, 64: 75, 65: [1, 43], 69: 82, 70: 76, 71: 77, 72: [1, 78], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 26: 83, 47: [1, 66] }, { 47: [2, 55] }, { 4: 84, 6: 3, 14: [2, 46], 15: [2, 46], 19: [2, 46], 29: [2, 46], 34: [2, 46], 39: [2, 46], 44: [2, 46], 47: [2, 46], 48: [2, 46], 51: [2, 46], 55: [2, 46], 60: [2, 46] }, { 47: [2, 20] }, { 20: 85, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 4: 86, 6: 3, 14: [2, 46], 15: [2, 46], 19: [2, 46], 29: [2, 46], 34: [2, 46], 47: [2, 46], 48: [2, 46], 51: [2, 46], 55: [2, 46], 60: [2, 46] }, { 26: 87, 47: [1, 66] }, { 47: [2, 57] }, { 5: [2, 11], 14: [2, 11], 15: [2, 11], 19: [2, 11], 29: [2, 11], 34: [2, 11], 39: [2, 11], 44: [2, 11], 47: [2, 11], 48: [2, 11], 51: [2, 11], 55: [2, 11], 60: [2, 11] }, { 15: [2, 49], 18: [2, 49] }, { 20: 74, 33: [2, 88], 58: 88, 63: 89, 64: 75, 65: [1, 43], 69: 90, 70: 76, 71: 77, 72: [1, 78], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 65: [2, 94], 66: 91, 68: [2, 94], 72: [2, 94], 80: [2, 94], 81: [2, 94], 82: [2, 94], 83: [2, 94], 84: [2, 94], 85: [2, 94] }, { 5: [2, 25], 14: [2, 25], 15: [2, 25], 19: [2, 25], 29: [2, 25], 34: [2, 25], 39: [2, 25], 44: [2, 25], 47: [2, 25], 48: [2, 25], 51: [2, 25], 55: [2, 25], 60: [2, 25] }, { 20: 92, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 74, 31: 93, 33: [2, 60], 63: 94, 64: 75, 65: [1, 43], 69: 95, 70: 76, 71: 77, 72: [1, 78], 75: [2, 60], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 74, 33: [2, 66], 36: 96, 63: 97, 64: 75, 65: [1, 43], 69: 98, 70: 76, 71: 77, 72: [1, 78], 75: [2, 66], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 74, 22: 99, 23: [2, 52], 63: 100, 64: 75, 65: [1, 43], 69: 101, 70: 76, 71: 77, 72: [1, 78], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 74, 33: [2, 92], 62: 102, 63: 103, 64: 75, 65: [1, 43], 69: 104, 70: 76, 71: 77, 72: [1, 78], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 33: [1, 105] }, { 33: [2, 79], 65: [2, 79], 72: [2, 79], 80: [2, 79], 81: [2, 79], 82: [2, 79], 83: [2, 79], 84: [2, 79], 85: [2, 79] }, { 33: [2, 81] }, { 23: [2, 27], 33: [2, 27], 54: [2, 27], 65: [2, 27], 68: [2, 27], 72: [2, 27], 75: [2, 27], 80: [2, 27], 81: [2, 27], 82: [2, 27], 83: [2, 27], 84: [2, 27], 85: [2, 27] }, { 23: [2, 28], 33: [2, 28], 54: [2, 28], 65: [2, 28], 68: [2, 28], 72: [2, 28], 75: [2, 28], 80: [2, 28], 81: [2, 28], 82: [2, 28], 83: [2, 28], 84: [2, 28], 85: [2, 28] }, { 23: [2, 30], 33: [2, 30], 54: [2, 30], 68: [2, 30], 71: 106, 72: [1, 107], 75: [2, 30] }, { 23: [2, 98], 33: [2, 98], 54: [2, 98], 68: [2, 98], 72: [2, 98], 75: [2, 98] }, { 23: [2, 45], 33: [2, 45], 54: [2, 45], 65: [2, 45], 68: [2, 45], 72: [2, 45], 73: [1, 108], 75: [2, 45], 80: [2, 45], 81: [2, 45], 82: [2, 45], 83: [2, 45], 84: [2, 45], 85: [2, 45], 87: [2, 45] }, { 23: [2, 44], 33: [2, 44], 54: [2, 44], 65: [2, 44], 68: [2, 44], 72: [2, 44], 75: [2, 44], 80: [2, 44], 81: [2, 44], 82: [2, 44], 83: [2, 44], 84: [2, 44], 85: [2, 44], 87: [2, 44] }, { 54: [1, 109] }, { 54: [2, 83], 65: [2, 83], 72: [2, 83], 80: [2, 83], 81: [2, 83], 82: [2, 83], 83: [2, 83], 84: [2, 83], 85: [2, 83] }, { 54: [2, 85] }, { 5: [2, 13], 14: [2, 13], 15: [2, 13], 19: [2, 13], 29: [2, 13], 34: [2, 13], 39: [2, 13], 44: [2, 13], 47: [2, 13], 48: [2, 13], 51: [2, 13], 55: [2, 13], 60: [2, 13] }, { 38: 55, 39: [1, 57], 43: 56, 44: [1, 58], 45: 111, 46: 110, 47: [2, 76] }, { 33: [2, 70], 40: 112, 65: [2, 70], 72: [2, 70], 75: [2, 70], 80: [2, 70], 81: [2, 70], 82: [2, 70], 83: [2, 70], 84: [2, 70], 85: [2, 70] }, { 47: [2, 18] }, { 5: [2, 14], 14: [2, 14], 15: [2, 14], 19: [2, 14], 29: [2, 14], 34: [2, 14], 39: [2, 14], 44: [2, 14], 47: [2, 14], 48: [2, 14], 51: [2, 14], 55: [2, 14], 60: [2, 14] }, { 33: [1, 113] }, { 33: [2, 87], 65: [2, 87], 72: [2, 87], 80: [2, 87], 81: [2, 87], 82: [2, 87], 83: [2, 87], 84: [2, 87], 85: [2, 87] }, { 33: [2, 89] }, { 20: 74, 63: 115, 64: 75, 65: [1, 43], 67: 114, 68: [2, 96], 69: 116, 70: 76, 71: 77, 72: [1, 78], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 33: [1, 117] }, { 32: 118, 33: [2, 62], 74: 119, 75: [1, 120] }, { 33: [2, 59], 65: [2, 59], 72: [2, 59], 75: [2, 59], 80: [2, 59], 81: [2, 59], 82: [2, 59], 83: [2, 59], 84: [2, 59], 85: [2, 59] }, { 33: [2, 61], 75: [2, 61] }, { 33: [2, 68], 37: 121, 74: 122, 75: [1, 120] }, { 33: [2, 65], 65: [2, 65], 72: [2, 65], 75: [2, 65], 80: [2, 65], 81: [2, 65], 82: [2, 65], 83: [2, 65], 84: [2, 65], 85: [2, 65] }, { 33: [2, 67], 75: [2, 67] }, { 23: [1, 123] }, { 23: [2, 51], 65: [2, 51], 72: [2, 51], 80: [2, 51], 81: [2, 51], 82: [2, 51], 83: [2, 51], 84: [2, 51], 85: [2, 51] }, { 23: [2, 53] }, { 33: [1, 124] }, { 33: [2, 91], 65: [2, 91], 72: [2, 91], 80: [2, 91], 81: [2, 91], 82: [2, 91], 83: [2, 91], 84: [2, 91], 85: [2, 91] }, { 33: [2, 93] }, { 5: [2, 22], 14: [2, 22], 15: [2, 22], 19: [2, 22], 29: [2, 22], 34: [2, 22], 39: [2, 22], 44: [2, 22], 47: [2, 22], 48: [2, 22], 51: [2, 22], 55: [2, 22], 60: [2, 22] }, { 23: [2, 99], 33: [2, 99], 54: [2, 99], 68: [2, 99], 72: [2, 99], 75: [2, 99] }, { 73: [1, 108] }, { 20: 74, 63: 125, 64: 75, 65: [1, 43], 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 5: [2, 23], 14: [2, 23], 15: [2, 23], 19: [2, 23], 29: [2, 23], 34: [2, 23], 39: [2, 23], 44: [2, 23], 47: [2, 23], 48: [2, 23], 51: [2, 23], 55: [2, 23], 60: [2, 23] }, { 47: [2, 19] }, { 47: [2, 77] }, { 20: 74, 33: [2, 72], 41: 126, 63: 127, 64: 75, 65: [1, 43], 69: 128, 70: 76, 71: 77, 72: [1, 78], 75: [2, 72], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 5: [2, 24], 14: [2, 24], 15: [2, 24], 19: [2, 24], 29: [2, 24], 34: [2, 24], 39: [2, 24], 44: [2, 24], 47: [2, 24], 48: [2, 24], 51: [2, 24], 55: [2, 24], 60: [2, 24] }, { 68: [1, 129] }, { 65: [2, 95], 68: [2, 95], 72: [2, 95], 80: [2, 95], 81: [2, 95], 82: [2, 95], 83: [2, 95], 84: [2, 95], 85: [2, 95] }, { 68: [2, 97] }, { 5: [2, 21], 14: [2, 21], 15: [2, 21], 19: [2, 21], 29: [2, 21], 34: [2, 21], 39: [2, 21], 44: [2, 21], 47: [2, 21], 48: [2, 21], 51: [2, 21], 55: [2, 21], 60: [2, 21] }, { 33: [1, 130] }, { 33: [2, 63] }, { 72: [1, 132], 76: 131 }, { 33: [1, 133] }, { 33: [2, 69] }, { 15: [2, 12], 18: [2, 12] }, { 14: [2, 26], 15: [2, 26], 19: [2, 26], 29: [2, 26], 34: [2, 26], 47: [2, 26], 48: [2, 26], 51: [2, 26], 55: [2, 26], 60: [2, 26] }, { 23: [2, 31], 33: [2, 31], 54: [2, 31], 68: [2, 31], 72: [2, 31], 75: [2, 31] }, { 33: [2, 74], 42: 134, 74: 135, 75: [1, 120] }, { 33: [2, 71], 65: [2, 71], 72: [2, 71], 75: [2, 71], 80: [2, 71], 81: [2, 71], 82: [2, 71], 83: [2, 71], 84: [2, 71], 85: [2, 71] }, { 33: [2, 73], 75: [2, 73] }, { 23: [2, 29], 33: [2, 29], 54: [2, 29], 65: [2, 29], 68: [2, 29], 72: [2, 29], 75: [2, 29], 80: [2, 29], 81: [2, 29], 82: [2, 29], 83: [2, 29], 84: [2, 29], 85: [2, 29] }, { 14: [2, 15], 15: [2, 15], 19: [2, 15], 29: [2, 15], 34: [2, 15], 39: [2, 15], 44: [2, 15], 47: [2, 15], 48: [2, 15], 51: [2, 15], 55: [2, 15], 60: [2, 15] }, { 72: [1, 137], 77: [1, 136] }, { 72: [2, 100], 77: [2, 100] }, { 14: [2, 16], 15: [2, 16], 19: [2, 16], 29: [2, 16], 34: [2, 16], 44: [2, 16], 47: [2, 16], 48: [2, 16], 51: [2, 16], 55: [2, 16], 60: [2, 16] }, { 33: [1, 138] }, { 33: [2, 75] }, { 33: [2, 32] }, { 72: [2, 101], 77: [2, 101] }, { 14: [2, 17], 15: [2, 17], 19: [2, 17], 29: [2, 17], 34: [2, 17], 39: [2, 17], 44: [2, 17], 47: [2, 17], 48: [2, 17], 51: [2, 17], 55: [2, 17], 60: [2, 17] }],
        defaultActions: { 4: [2, 1], 54: [2, 55], 56: [2, 20], 60: [2, 57], 73: [2, 81], 82: [2, 85], 86: [2, 18], 90: [2, 89], 101: [2, 53], 104: [2, 93], 110: [2, 19], 111: [2, 77], 116: [2, 97], 119: [2, 63], 122: [2, 69], 135: [2, 75], 136: [2, 32] },
        parseError: function parseError(str, hash) {
            throw new Error(str);
        },
        parse: function parse(input) {
            var self = this,
                stack = [0],
                vstack = [null],
                lstack = [],
                table = this.table,
                yytext = "",
                yylineno = 0,
                yyleng = 0,
                recovering = 0,
                TERROR = 2,
                EOF = 1;
            this.lexer.setInput(input);
            this.lexer.yy = this.yy;
            this.yy.lexer = this.lexer;
            this.yy.parser = this;
            if (typeof this.lexer.yylloc == "undefined") this.lexer.yylloc = {};
            var yyloc = this.lexer.yylloc;
            lstack.push(yyloc);
            var ranges = this.lexer.options && this.lexer.options.ranges;
            if (typeof this.yy.parseError === "function") this.parseError = this.yy.parseError;
            function popStack(n) {
                stack.length = stack.length - 2 * n;
                vstack.length = vstack.length - n;
                lstack.length = lstack.length - n;
            }
            function lex() {
                var token;
                token = self.lexer.lex() || 1;
                if (typeof token !== "number") {
                    token = self.symbols_[token] || token;
                }
                return token;
            }
            var symbol,
                preErrorSymbol,
                state,
                action,
                a,
                r,
                yyval = {},
                p,
                len,
                newState,
                expected;
            while (true) {
                state = stack[stack.length - 1];
                if (this.defaultActions[state]) {
                    action = this.defaultActions[state];
                } else {
                    if (symbol === null || typeof symbol == "undefined") {
                        symbol = lex();
                    }
                    action = table[state] && table[state][symbol];
                }
                if (typeof action === "undefined" || !action.length || !action[0]) {
                    var errStr = "";
                    if (!recovering) {
                        expected = [];
                        for (p in table[state]) if (this.terminals_[p] && p > 2) {
                            expected.push("'" + this.terminals_[p] + "'");
                        }
                        if (this.lexer.showPosition) {
                            errStr = "Parse error on line " + (yylineno + 1) + ":\n" + this.lexer.showPosition() + "\nExpecting " + expected.join(", ") + ", got '" + (this.terminals_[symbol] || symbol) + "'";
                        } else {
                            errStr = "Parse error on line " + (yylineno + 1) + ": Unexpected " + (symbol == 1 ? "end of input" : "'" + (this.terminals_[symbol] || symbol) + "'");
                        }
                        this.parseError(errStr, { text: this.lexer.match, token: this.terminals_[symbol] || symbol, line: this.lexer.yylineno, loc: yyloc, expected: expected });
                    }
                }
                if (action[0] instanceof Array && action.length > 1) {
                    throw new Error("Parse Error: multiple actions possible at state: " + state + ", token: " + symbol);
                }
                switch (action[0]) {
                    case 1:
                        stack.push(symbol);
                        vstack.push(this.lexer.yytext);
                        lstack.push(this.lexer.yylloc);
                        stack.push(action[1]);
                        symbol = null;
                        if (!preErrorSymbol) {
                            yyleng = this.lexer.yyleng;
                            yytext = this.lexer.yytext;
                            yylineno = this.lexer.yylineno;
                            yyloc = this.lexer.yylloc;
                            if (recovering > 0) recovering--;
                        } else {
                            symbol = preErrorSymbol;
                            preErrorSymbol = null;
                        }
                        break;
                    case 2:
                        len = this.productions_[action[1]][1];
                        yyval.$ = vstack[vstack.length - len];
                        yyval._$ = { first_line: lstack[lstack.length - (len || 1)].first_line, last_line: lstack[lstack.length - 1].last_line, first_column: lstack[lstack.length - (len || 1)].first_column, last_column: lstack[lstack.length - 1].last_column };
                        if (ranges) {
                            yyval._$.range = [lstack[lstack.length - (len || 1)].range[0], lstack[lstack.length - 1].range[1]];
                        }
                        r = this.performAction.call(yyval, yytext, yyleng, yylineno, this.yy, action[1], vstack, lstack);
                        if (typeof r !== "undefined") {
                            return r;
                        }
                        if (len) {
                            stack = stack.slice(0, -1 * len * 2);
                            vstack = vstack.slice(0, -1 * len);
                            lstack = lstack.slice(0, -1 * len);
                        }
                        stack.push(this.productions_[action[1]][0]);
                        vstack.push(yyval.$);
                        lstack.push(yyval._$);
                        newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
                        stack.push(newState);
                        break;
                    case 3:
                        return true;
                }
            }
            return true;
        }
    };
    /* Jison generated lexer */
    var lexer = (function () {
        var lexer = { EOF: 1,
            parseError: function parseError(str, hash) {
                if (this.yy.parser) {
                    this.yy.parser.parseError(str, hash);
                } else {
                    throw new Error(str);
                }
            },
            setInput: function setInput(input) {
                this._input = input;
                this._more = this._less = this.done = false;
                this.yylineno = this.yyleng = 0;
                this.yytext = this.matched = this.match = '';
                this.conditionStack = ['INITIAL'];
                this.yylloc = { first_line: 1, first_column: 0, last_line: 1, last_column: 0 };
                if (this.options.ranges) this.yylloc.range = [0, 0];
                this.offset = 0;
                return this;
            },
            input: function input() {
                var ch = this._input[0];
                this.yytext += ch;
                this.yyleng++;
                this.offset++;
                this.match += ch;
                this.matched += ch;
                var lines = ch.match(/(?:\r\n?|\n).*/g);
                if (lines) {
                    this.yylineno++;
                    this.yylloc.last_line++;
                } else {
                    this.yylloc.last_column++;
                }
                if (this.options.ranges) this.yylloc.range[1]++;

                this._input = this._input.slice(1);
                return ch;
            },
            unput: function unput(ch) {
                var len = ch.length;
                var lines = ch.split(/(?:\r\n?|\n)/g);

                this._input = ch + this._input;
                this.yytext = this.yytext.substr(0, this.yytext.length - len - 1);
                //this.yyleng -= len;
                this.offset -= len;
                var oldLines = this.match.split(/(?:\r\n?|\n)/g);
                this.match = this.match.substr(0, this.match.length - 1);
                this.matched = this.matched.substr(0, this.matched.length - 1);

                if (lines.length - 1) this.yylineno -= lines.length - 1;
                var r = this.yylloc.range;

                this.yylloc = { first_line: this.yylloc.first_line,
                    last_line: this.yylineno + 1,
                    first_column: this.yylloc.first_column,
                    last_column: lines ? (lines.length === oldLines.length ? this.yylloc.first_column : 0) + oldLines[oldLines.length - lines.length].length - lines[0].length : this.yylloc.first_column - len
                };

                if (this.options.ranges) {
                    this.yylloc.range = [r[0], r[0] + this.yyleng - len];
                }
                return this;
            },
            more: function more() {
                this._more = true;
                return this;
            },
            less: function less(n) {
                this.unput(this.match.slice(n));
            },
            pastInput: function pastInput() {
                var past = this.matched.substr(0, this.matched.length - this.match.length);
                return (past.length > 20 ? '...' : '') + past.substr(-20).replace(/\n/g, "");
            },
            upcomingInput: function upcomingInput() {
                var next = this.match;
                if (next.length < 20) {
                    next += this._input.substr(0, 20 - next.length);
                }
                return (next.substr(0, 20) + (next.length > 20 ? '...' : '')).replace(/\n/g, "");
            },
            showPosition: function showPosition() {
                var pre = this.pastInput();
                var c = new Array(pre.length + 1).join("-");
                return pre + this.upcomingInput() + "\n" + c + "^";
            },
            next: function next() {
                if (this.done) {
                    return this.EOF;
                }
                if (!this._input) this.done = true;

                var token, match, tempMatch, index, col, lines;
                if (!this._more) {
                    this.yytext = '';
                    this.match = '';
                }
                var rules = this._currentRules();
                for (var i = 0; i < rules.length; i++) {
                    tempMatch = this._input.match(this.rules[rules[i]]);
                    if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                        match = tempMatch;
                        index = i;
                        if (!this.options.flex) break;
                    }
                }
                if (match) {
                    lines = match[0].match(/(?:\r\n?|\n).*/g);
                    if (lines) this.yylineno += lines.length;
                    this.yylloc = { first_line: this.yylloc.last_line,
                        last_line: this.yylineno + 1,
                        first_column: this.yylloc.last_column,
                        last_column: lines ? lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + match[0].length };
                    this.yytext += match[0];
                    this.match += match[0];
                    this.matches = match;
                    this.yyleng = this.yytext.length;
                    if (this.options.ranges) {
                        this.yylloc.range = [this.offset, this.offset += this.yyleng];
                    }
                    this._more = false;
                    this._input = this._input.slice(match[0].length);
                    this.matched += match[0];
                    token = this.performAction.call(this, this.yy, this, rules[index], this.conditionStack[this.conditionStack.length - 1]);
                    if (this.done && this._input) this.done = false;
                    if (token) return token;else return;
                }
                if (this._input === "") {
                    return this.EOF;
                } else {
                    return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. Unrecognized text.\n' + this.showPosition(), { text: "", token: null, line: this.yylineno });
                }
            },
            lex: function lex() {
                var r = this.next();
                if (typeof r !== 'undefined') {
                    return r;
                } else {
                    return this.lex();
                }
            },
            begin: function begin(condition) {
                this.conditionStack.push(condition);
            },
            popState: function popState() {
                return this.conditionStack.pop();
            },
            _currentRules: function _currentRules() {
                return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
            },
            topState: function topState() {
                return this.conditionStack[this.conditionStack.length - 2];
            },
            pushState: function begin(condition) {
                this.begin(condition);
            } };
        lexer.options = {};
        lexer.performAction = function anonymous(yy, yy_, $avoiding_name_collisions, YY_START) {

            function strip(start, end) {
                return yy_.yytext = yy_.yytext.substring(start, yy_.yyleng - end + start);
            }

            var YYSTATE = YY_START;
            switch ($avoiding_name_collisions) {
                case 0:
                    if (yy_.yytext.slice(-2) === "\\\\") {
                        strip(0, 1);
                        this.begin("mu");
                    } else if (yy_.yytext.slice(-1) === "\\") {
                        strip(0, 1);
                        this.begin("emu");
                    } else {
                        this.begin("mu");
                    }
                    if (yy_.yytext) return 15;

                    break;
                case 1:
                    return 15;
                    break;
                case 2:
                    this.popState();
                    return 15;

                    break;
                case 3:
                    this.begin('raw');return 15;
                    break;
                case 4:
                    this.popState();
                    // Should be using `this.topState()` below, but it currently
                    // returns the second top instead of the first top. Opened an
                    // issue about it at https://github.com/zaach/jison/issues/291
                    if (this.conditionStack[this.conditionStack.length - 1] === 'raw') {
                        return 15;
                    } else {
                        strip(5, 9);
                        return 'END_RAW_BLOCK';
                    }

                    break;
                case 5:
                    return 15;
                    break;
                case 6:
                    this.popState();
                    return 14;

                    break;
                case 7:
                    return 65;
                    break;
                case 8:
                    return 68;
                    break;
                case 9:
                    return 19;
                    break;
                case 10:
                    this.popState();
                    this.begin('raw');
                    return 23;

                    break;
                case 11:
                    return 55;
                    break;
                case 12:
                    return 60;
                    break;
                case 13:
                    return 29;
                    break;
                case 14:
                    return 47;
                    break;
                case 15:
                    this.popState();return 44;
                    break;
                case 16:
                    this.popState();return 44;
                    break;
                case 17:
                    return 34;
                    break;
                case 18:
                    return 39;
                    break;
                case 19:
                    return 51;
                    break;
                case 20:
                    return 48;
                    break;
                case 21:
                    this.unput(yy_.yytext);
                    this.popState();
                    this.begin('com');

                    break;
                case 22:
                    this.popState();
                    return 14;

                    break;
                case 23:
                    return 48;
                    break;
                case 24:
                    return 73;
                    break;
                case 25:
                    return 72;
                    break;
                case 26:
                    return 72;
                    break;
                case 27:
                    return 87;
                    break;
                case 28:
                    // ignore whitespace
                    break;
                case 29:
                    this.popState();return 54;
                    break;
                case 30:
                    this.popState();return 33;
                    break;
                case 31:
                    yy_.yytext = strip(1, 2).replace(/\\"/g, '"');return 80;
                    break;
                case 32:
                    yy_.yytext = strip(1, 2).replace(/\\'/g, "'");return 80;
                    break;
                case 33:
                    return 85;
                    break;
                case 34:
                    return 82;
                    break;
                case 35:
                    return 82;
                    break;
                case 36:
                    return 83;
                    break;
                case 37:
                    return 84;
                    break;
                case 38:
                    return 81;
                    break;
                case 39:
                    return 75;
                    break;
                case 40:
                    return 77;
                    break;
                case 41:
                    return 72;
                    break;
                case 42:
                    yy_.yytext = yy_.yytext.replace(/\\([\\\]])/g, '$1');return 72;
                    break;
                case 43:
                    return 'INVALID';
                    break;
                case 44:
                    return 5;
                    break;
            }
        };
        lexer.rules = [/^(?:[^\x00]*?(?=(\{\{)))/, /^(?:[^\x00]+)/, /^(?:[^\x00]{2,}?(?=(\{\{|\\\{\{|\\\\\{\{|$)))/, /^(?:\{\{\{\{(?=[^\/]))/, /^(?:\{\{\{\{\/[^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=[=}\s\/.])\}\}\}\})/, /^(?:[^\x00]+?(?=(\{\{\{\{)))/, /^(?:[\s\S]*?--(~)?\}\})/, /^(?:\()/, /^(?:\))/, /^(?:\{\{\{\{)/, /^(?:\}\}\}\})/, /^(?:\{\{(~)?>)/, /^(?:\{\{(~)?#>)/, /^(?:\{\{(~)?#\*?)/, /^(?:\{\{(~)?\/)/, /^(?:\{\{(~)?\^\s*(~)?\}\})/, /^(?:\{\{(~)?\s*else\s*(~)?\}\})/, /^(?:\{\{(~)?\^)/, /^(?:\{\{(~)?\s*else\b)/, /^(?:\{\{(~)?\{)/, /^(?:\{\{(~)?&)/, /^(?:\{\{(~)?!--)/, /^(?:\{\{(~)?![\s\S]*?\}\})/, /^(?:\{\{(~)?\*?)/, /^(?:=)/, /^(?:\.\.)/, /^(?:\.(?=([=~}\s\/.)|])))/, /^(?:[\/.])/, /^(?:\s+)/, /^(?:\}(~)?\}\})/, /^(?:(~)?\}\})/, /^(?:"(\\["]|[^"])*")/, /^(?:'(\\[']|[^'])*')/, /^(?:@)/, /^(?:true(?=([~}\s)])))/, /^(?:false(?=([~}\s)])))/, /^(?:undefined(?=([~}\s)])))/, /^(?:null(?=([~}\s)])))/, /^(?:-?[0-9]+(?:\.[0-9]+)?(?=([~}\s)])))/, /^(?:as\s+\|)/, /^(?:\|)/, /^(?:([^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=([=~}\s\/.)|]))))/, /^(?:\[(\\\]|[^\]])*\])/, /^(?:.)/, /^(?:$)/];
        lexer.conditions = { "mu": { "rules": [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44], "inclusive": false }, "emu": { "rules": [2], "inclusive": false }, "com": { "rules": [6], "inclusive": false }, "raw": { "rules": [3, 4, 5], "inclusive": false }, "INITIAL": { "rules": [0, 1, 44], "inclusive": true } };
        return lexer;
    })();
    parser.lexer = lexer;
    function Parser() {
        this.yy = {};
    }Parser.prototype = parser;parser.Parser = Parser;
    return new Parser();
})();exports["default"] = handlebars;
module.exports = exports["default"];


},{}],1130:[function(require,module,exports){
/* eslint-disable new-cap */
'use strict';

exports.__esModule = true;
exports.print = print;
exports.PrintVisitor = PrintVisitor;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _visitor = require('./visitor');

var _visitor2 = _interopRequireDefault(_visitor);

function print(ast) {
  return new PrintVisitor().accept(ast);
}

function PrintVisitor() {
  this.padding = 0;
}

PrintVisitor.prototype = new _visitor2['default']();

PrintVisitor.prototype.pad = function (string) {
  var out = '';

  for (var i = 0, l = this.padding; i < l; i++) {
    out += '  ';
  }

  out += string + '\n';
  return out;
};

PrintVisitor.prototype.Program = function (program) {
  var out = '',
      body = program.body,
      i = undefined,
      l = undefined;

  if (program.blockParams) {
    var blockParams = 'BLOCK PARAMS: [';
    for (i = 0, l = program.blockParams.length; i < l; i++) {
      blockParams += ' ' + program.blockParams[i];
    }
    blockParams += ' ]';
    out += this.pad(blockParams);
  }

  for (i = 0, l = body.length; i < l; i++) {
    out += this.accept(body[i]);
  }

  this.padding--;

  return out;
};

PrintVisitor.prototype.MustacheStatement = function (mustache) {
  return this.pad('{{ ' + this.SubExpression(mustache) + ' }}');
};
PrintVisitor.prototype.Decorator = function (mustache) {
  return this.pad('{{ DIRECTIVE ' + this.SubExpression(mustache) + ' }}');
};

PrintVisitor.prototype.BlockStatement = PrintVisitor.prototype.DecoratorBlock = function (block) {
  var out = '';

  out += this.pad((block.type === 'DecoratorBlock' ? 'DIRECTIVE ' : '') + 'BLOCK:');
  this.padding++;
  out += this.pad(this.SubExpression(block));
  if (block.program) {
    out += this.pad('PROGRAM:');
    this.padding++;
    out += this.accept(block.program);
    this.padding--;
  }
  if (block.inverse) {
    if (block.program) {
      this.padding++;
    }
    out += this.pad('{{^}}');
    this.padding++;
    out += this.accept(block.inverse);
    this.padding--;
    if (block.program) {
      this.padding--;
    }
  }
  this.padding--;

  return out;
};

PrintVisitor.prototype.PartialStatement = function (partial) {
  var content = 'PARTIAL:' + partial.name.original;
  if (partial.params[0]) {
    content += ' ' + this.accept(partial.params[0]);
  }
  if (partial.hash) {
    content += ' ' + this.accept(partial.hash);
  }
  return this.pad('{{> ' + content + ' }}');
};
PrintVisitor.prototype.PartialBlockStatement = function (partial) {
  var content = 'PARTIAL BLOCK:' + partial.name.original;
  if (partial.params[0]) {
    content += ' ' + this.accept(partial.params[0]);
  }
  if (partial.hash) {
    content += ' ' + this.accept(partial.hash);
  }

  content += ' ' + this.pad('PROGRAM:');
  this.padding++;
  content += this.accept(partial.program);
  this.padding--;

  return this.pad('{{> ' + content + ' }}');
};

PrintVisitor.prototype.ContentStatement = function (content) {
  return this.pad("CONTENT[ '" + content.value + "' ]");
};

PrintVisitor.prototype.CommentStatement = function (comment) {
  return this.pad("{{! '" + comment.value + "' }}");
};

PrintVisitor.prototype.SubExpression = function (sexpr) {
  var params = sexpr.params,
      paramStrings = [],
      hash = undefined;

  for (var i = 0, l = params.length; i < l; i++) {
    paramStrings.push(this.accept(params[i]));
  }

  params = '[' + paramStrings.join(', ') + ']';

  hash = sexpr.hash ? ' ' + this.accept(sexpr.hash) : '';

  return this.accept(sexpr.path) + ' ' + params + hash;
};

PrintVisitor.prototype.PathExpression = function (id) {
  var path = id.parts.join('/');
  return (id.data ? '@' : '') + 'PATH:' + path;
};

PrintVisitor.prototype.StringLiteral = function (string) {
  return '"' + string.value + '"';
};

PrintVisitor.prototype.NumberLiteral = function (number) {
  return 'NUMBER{' + number.value + '}';
};

PrintVisitor.prototype.BooleanLiteral = function (bool) {
  return 'BOOLEAN{' + bool.value + '}';
};

PrintVisitor.prototype.UndefinedLiteral = function () {
  return 'UNDEFINED';
};

PrintVisitor.prototype.NullLiteral = function () {
  return 'NULL';
};

PrintVisitor.prototype.Hash = function (hash) {
  var pairs = hash.pairs,
      joinedPairs = [];

  for (var i = 0, l = pairs.length; i < l; i++) {
    joinedPairs.push(this.accept(pairs[i]));
  }

  return 'HASH{' + joinedPairs.join(', ') + '}';
};
PrintVisitor.prototype.HashPair = function (pair) {
  return pair.key + '=' + this.accept(pair.value);
};
/* eslint-enable new-cap */


},{"./visitor":1131}],1131:[function(require,module,exports){
'use strict';

exports.__esModule = true;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _exception = require('../exception');

var _exception2 = _interopRequireDefault(_exception);

function Visitor() {
  this.parents = [];
}

Visitor.prototype = {
  constructor: Visitor,
  mutating: false,

  // Visits a given value. If mutating, will replace the value if necessary.
  acceptKey: function acceptKey(node, name) {
    var value = this.accept(node[name]);
    if (this.mutating) {
      // Hacky sanity check: This may have a few false positives for type for the helper
      // methods but will generally do the right thing without a lot of overhead.
      if (value && !Visitor.prototype[value.type]) {
        throw new _exception2['default']('Unexpected node type "' + value.type + '" found when accepting ' + name + ' on ' + node.type);
      }
      node[name] = value;
    }
  },

  // Performs an accept operation with added sanity check to ensure
  // required keys are not removed.
  acceptRequired: function acceptRequired(node, name) {
    this.acceptKey(node, name);

    if (!node[name]) {
      throw new _exception2['default'](node.type + ' requires ' + name);
    }
  },

  // Traverses a given array. If mutating, empty respnses will be removed
  // for child elements.
  acceptArray: function acceptArray(array) {
    for (var i = 0, l = array.length; i < l; i++) {
      this.acceptKey(array, i);

      if (!array[i]) {
        array.splice(i, 1);
        i--;
        l--;
      }
    }
  },

  accept: function accept(object) {
    if (!object) {
      return;
    }

    /* istanbul ignore next: Sanity code */
    if (!this[object.type]) {
      throw new _exception2['default']('Unknown type: ' + object.type, object);
    }

    if (this.current) {
      this.parents.unshift(this.current);
    }
    this.current = object;

    var ret = this[object.type](object);

    this.current = this.parents.shift();

    if (!this.mutating || ret) {
      return ret;
    } else if (ret !== false) {
      return object;
    }
  },

  Program: function Program(program) {
    this.acceptArray(program.body);
  },

  MustacheStatement: visitSubExpression,
  Decorator: visitSubExpression,

  BlockStatement: visitBlock,
  DecoratorBlock: visitBlock,

  PartialStatement: visitPartial,
  PartialBlockStatement: function PartialBlockStatement(partial) {
    visitPartial.call(this, partial);

    this.acceptKey(partial, 'program');
  },

  ContentStatement: function ContentStatement() /* content */{},
  CommentStatement: function CommentStatement() /* comment */{},

  SubExpression: visitSubExpression,

  PathExpression: function PathExpression() /* path */{},

  StringLiteral: function StringLiteral() /* string */{},
  NumberLiteral: function NumberLiteral() /* number */{},
  BooleanLiteral: function BooleanLiteral() /* bool */{},
  UndefinedLiteral: function UndefinedLiteral() /* literal */{},
  NullLiteral: function NullLiteral() /* literal */{},

  Hash: function Hash(hash) {
    this.acceptArray(hash.pairs);
  },
  HashPair: function HashPair(pair) {
    this.acceptRequired(pair, 'value');
  }
};

function visitSubExpression(mustache) {
  this.acceptRequired(mustache, 'path');
  this.acceptArray(mustache.params);
  this.acceptKey(mustache, 'hash');
}
function visitBlock(block) {
  visitSubExpression.call(this, block);

  this.acceptKey(block, 'program');
  this.acceptKey(block, 'inverse');
}
function visitPartial(partial) {
  this.acceptRequired(partial, 'name');
  this.acceptArray(partial.params);
  this.acceptKey(partial, 'hash');
}

exports['default'] = Visitor;
module.exports = exports['default'];


},{"../exception":1135}],1132:[function(require,module,exports){
'use strict';

exports.__esModule = true;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _visitor = require('./visitor');

var _visitor2 = _interopRequireDefault(_visitor);

function WhitespaceControl() {
  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  this.options = options;
}
WhitespaceControl.prototype = new _visitor2['default']();

WhitespaceControl.prototype.Program = function (program) {
  var doStandalone = !this.options.ignoreStandalone;

  var isRoot = !this.isRootSeen;
  this.isRootSeen = true;

  var body = program.body;
  for (var i = 0, l = body.length; i < l; i++) {
    var current = body[i],
        strip = this.accept(current);

    if (!strip) {
      continue;
    }

    var _isPrevWhitespace = isPrevWhitespace(body, i, isRoot),
        _isNextWhitespace = isNextWhitespace(body, i, isRoot),
        openStandalone = strip.openStandalone && _isPrevWhitespace,
        closeStandalone = strip.closeStandalone && _isNextWhitespace,
        inlineStandalone = strip.inlineStandalone && _isPrevWhitespace && _isNextWhitespace;

    if (strip.close) {
      omitRight(body, i, true);
    }
    if (strip.open) {
      omitLeft(body, i, true);
    }

    if (doStandalone && inlineStandalone) {
      omitRight(body, i);

      if (omitLeft(body, i)) {
        // If we are on a standalone node, save the indent info for partials
        if (current.type === 'PartialStatement') {
          // Pull out the whitespace from the final line
          current.indent = /([ \t]+$)/.exec(body[i - 1].original)[1];
        }
      }
    }
    if (doStandalone && openStandalone) {
      omitRight((current.program || current.inverse).body);

      // Strip out the previous content node if it's whitespace only
      omitLeft(body, i);
    }
    if (doStandalone && closeStandalone) {
      // Always strip the next node
      omitRight(body, i);

      omitLeft((current.inverse || current.program).body);
    }
  }

  return program;
};

WhitespaceControl.prototype.BlockStatement = WhitespaceControl.prototype.DecoratorBlock = WhitespaceControl.prototype.PartialBlockStatement = function (block) {
  this.accept(block.program);
  this.accept(block.inverse);

  // Find the inverse program that is involed with whitespace stripping.
  var program = block.program || block.inverse,
      inverse = block.program && block.inverse,
      firstInverse = inverse,
      lastInverse = inverse;

  if (inverse && inverse.chained) {
    firstInverse = inverse.body[0].program;

    // Walk the inverse chain to find the last inverse that is actually in the chain.
    while (lastInverse.chained) {
      lastInverse = lastInverse.body[lastInverse.body.length - 1].program;
    }
  }

  var strip = {
    open: block.openStrip.open,
    close: block.closeStrip.close,

    // Determine the standalone candiacy. Basically flag our content as being possibly standalone
    // so our parent can determine if we actually are standalone
    openStandalone: isNextWhitespace(program.body),
    closeStandalone: isPrevWhitespace((firstInverse || program).body)
  };

  if (block.openStrip.close) {
    omitRight(program.body, null, true);
  }

  if (inverse) {
    var inverseStrip = block.inverseStrip;

    if (inverseStrip.open) {
      omitLeft(program.body, null, true);
    }

    if (inverseStrip.close) {
      omitRight(firstInverse.body, null, true);
    }
    if (block.closeStrip.open) {
      omitLeft(lastInverse.body, null, true);
    }

    // Find standalone else statments
    if (!this.options.ignoreStandalone && isPrevWhitespace(program.body) && isNextWhitespace(firstInverse.body)) {
      omitLeft(program.body);
      omitRight(firstInverse.body);
    }
  } else if (block.closeStrip.open) {
    omitLeft(program.body, null, true);
  }

  return strip;
};

WhitespaceControl.prototype.Decorator = WhitespaceControl.prototype.MustacheStatement = function (mustache) {
  return mustache.strip;
};

WhitespaceControl.prototype.PartialStatement = WhitespaceControl.prototype.CommentStatement = function (node) {
  /* istanbul ignore next */
  var strip = node.strip || {};
  return {
    inlineStandalone: true,
    open: strip.open,
    close: strip.close
  };
};

function isPrevWhitespace(body, i, isRoot) {
  if (i === undefined) {
    i = body.length;
  }

  // Nodes that end with newlines are considered whitespace (but are special
  // cased for strip operations)
  var prev = body[i - 1],
      sibling = body[i - 2];
  if (!prev) {
    return isRoot;
  }

  if (prev.type === 'ContentStatement') {
    return (sibling || !isRoot ? /\r?\n\s*?$/ : /(^|\r?\n)\s*?$/).test(prev.original);
  }
}
function isNextWhitespace(body, i, isRoot) {
  if (i === undefined) {
    i = -1;
  }

  var next = body[i + 1],
      sibling = body[i + 2];
  if (!next) {
    return isRoot;
  }

  if (next.type === 'ContentStatement') {
    return (sibling || !isRoot ? /^\s*?\r?\n/ : /^\s*?(\r?\n|$)/).test(next.original);
  }
}

// Marks the node to the right of the position as omitted.
// I.e. {{foo}}' ' will mark the ' ' node as omitted.
//
// If i is undefined, then the first child will be marked as such.
//
// If mulitple is truthy then all whitespace will be stripped out until non-whitespace
// content is met.
function omitRight(body, i, multiple) {
  var current = body[i == null ? 0 : i + 1];
  if (!current || current.type !== 'ContentStatement' || !multiple && current.rightStripped) {
    return;
  }

  var original = current.value;
  current.value = current.value.replace(multiple ? /^\s+/ : /^[ \t]*\r?\n?/, '');
  current.rightStripped = current.value !== original;
}

// Marks the node to the left of the position as omitted.
// I.e. ' '{{foo}} will mark the ' ' node as omitted.
//
// If i is undefined then the last child will be marked as such.
//
// If mulitple is truthy then all whitespace will be stripped out until non-whitespace
// content is met.
function omitLeft(body, i, multiple) {
  var current = body[i == null ? body.length - 1 : i - 1];
  if (!current || current.type !== 'ContentStatement' || !multiple && current.leftStripped) {
    return;
  }

  // We omit the last node if it's whitespace only and not preceded by a non-content node.
  var original = current.value;
  current.value = current.value.replace(multiple ? /\s+$/ : /[ \t]+$/, '');
  current.leftStripped = current.value !== original;
  return current.leftStripped;
}

exports['default'] = WhitespaceControl;
module.exports = exports['default'];


},{"./visitor":1131}],1133:[function(require,module,exports){
'use strict';

exports.__esModule = true;
exports.registerDefaultDecorators = registerDefaultDecorators;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _decoratorsInline = require('./decorators/inline');

var _decoratorsInline2 = _interopRequireDefault(_decoratorsInline);

function registerDefaultDecorators(instance) {
  _decoratorsInline2['default'](instance);
}


},{"./decorators/inline":1134}],1134:[function(require,module,exports){
'use strict';

exports.__esModule = true;

var _utils = require('../utils');

exports['default'] = function (instance) {
  instance.registerDecorator('inline', function (fn, props, container, options) {
    var ret = fn;
    if (!props.partials) {
      props.partials = {};
      ret = function (context, options) {
        // Create a new partials stack frame prior to exec.
        var original = container.partials;
        container.partials = _utils.extend({}, original, props.partials);
        var ret = fn(context, options);
        container.partials = original;
        return ret;
      };
    }

    props.partials[options.args[0]] = options.fn;

    return ret;
  });
};

module.exports = exports['default'];


},{"../utils":1151}],1135:[function(require,module,exports){
'use strict';

exports.__esModule = true;
var errorProps = ['description', 'fileName', 'lineNumber', 'endLineNumber', 'message', 'name', 'number', 'stack'];

function Exception(message, node) {
  var loc = node && node.loc,
      line = undefined,
      endLineNumber = undefined,
      column = undefined,
      endColumn = undefined;

  if (loc) {
    line = loc.start.line;
    endLineNumber = loc.end.line;
    column = loc.start.column;
    endColumn = loc.end.column;

    message += ' - ' + line + ':' + column;
  }

  var tmp = Error.prototype.constructor.call(this, message);

  // Unfortunately errors are not enumerable in Chrome (at least), so `for prop in tmp` doesn't work.
  for (var idx = 0; idx < errorProps.length; idx++) {
    this[errorProps[idx]] = tmp[errorProps[idx]];
  }

  /* istanbul ignore else */
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, Exception);
  }

  try {
    if (loc) {
      this.lineNumber = line;
      this.endLineNumber = endLineNumber;

      // Work around issue under safari where we can't directly set the column value
      /* istanbul ignore next */
      if (Object.defineProperty) {
        Object.defineProperty(this, 'column', {
          value: column,
          enumerable: true
        });
        Object.defineProperty(this, 'endColumn', {
          value: endColumn,
          enumerable: true
        });
      } else {
        this.column = column;
        this.endColumn = endColumn;
      }
    }
  } catch (nop) {
    /* Ignore if the browser is very particular */
  }
}

Exception.prototype = new Error();

exports['default'] = Exception;
module.exports = exports['default'];


},{}],1136:[function(require,module,exports){
'use strict';

exports.__esModule = true;
exports.registerDefaultHelpers = registerDefaultHelpers;
exports.moveHelperToHooks = moveHelperToHooks;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _helpersBlockHelperMissing = require('./helpers/block-helper-missing');

var _helpersBlockHelperMissing2 = _interopRequireDefault(_helpersBlockHelperMissing);

var _helpersEach = require('./helpers/each');

var _helpersEach2 = _interopRequireDefault(_helpersEach);

var _helpersHelperMissing = require('./helpers/helper-missing');

var _helpersHelperMissing2 = _interopRequireDefault(_helpersHelperMissing);

var _helpersIf = require('./helpers/if');

var _helpersIf2 = _interopRequireDefault(_helpersIf);

var _helpersLog = require('./helpers/log');

var _helpersLog2 = _interopRequireDefault(_helpersLog);

var _helpersLookup = require('./helpers/lookup');

var _helpersLookup2 = _interopRequireDefault(_helpersLookup);

var _helpersWith = require('./helpers/with');

var _helpersWith2 = _interopRequireDefault(_helpersWith);

function registerDefaultHelpers(instance) {
  _helpersBlockHelperMissing2['default'](instance);
  _helpersEach2['default'](instance);
  _helpersHelperMissing2['default'](instance);
  _helpersIf2['default'](instance);
  _helpersLog2['default'](instance);
  _helpersLookup2['default'](instance);
  _helpersWith2['default'](instance);
}

function moveHelperToHooks(instance, helperName, keepHelper) {
  if (instance.helpers[helperName]) {
    instance.hooks[helperName] = instance.helpers[helperName];
    if (!keepHelper) {
      delete instance.helpers[helperName];
    }
  }
}


},{"./helpers/block-helper-missing":1137,"./helpers/each":1138,"./helpers/helper-missing":1139,"./helpers/if":1140,"./helpers/log":1141,"./helpers/lookup":1142,"./helpers/with":1143}],1137:[function(require,module,exports){
'use strict';

exports.__esModule = true;

var _utils = require('../utils');

exports['default'] = function (instance) {
  instance.registerHelper('blockHelperMissing', function (context, options) {
    var inverse = options.inverse,
        fn = options.fn;

    if (context === true) {
      return fn(this);
    } else if (context === false || context == null) {
      return inverse(this);
    } else if (_utils.isArray(context)) {
      if (context.length > 0) {
        if (options.ids) {
          options.ids = [options.name];
        }

        return instance.helpers.each(context, options);
      } else {
        return inverse(this);
      }
    } else {
      if (options.data && options.ids) {
        var data = _utils.createFrame(options.data);
        data.contextPath = _utils.appendContextPath(options.data.contextPath, options.name);
        options = { data: data };
      }

      return fn(context, options);
    }
  });
};

module.exports = exports['default'];


},{"../utils":1151}],1138:[function(require,module,exports){
(function (global){(function (){
'use strict';

exports.__esModule = true;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _utils = require('../utils');

var _exception = require('../exception');

var _exception2 = _interopRequireDefault(_exception);

exports['default'] = function (instance) {
  instance.registerHelper('each', function (context, options) {
    if (!options) {
      throw new _exception2['default']('Must pass iterator to #each');
    }

    var fn = options.fn,
        inverse = options.inverse,
        i = 0,
        ret = '',
        data = undefined,
        contextPath = undefined;

    if (options.data && options.ids) {
      contextPath = _utils.appendContextPath(options.data.contextPath, options.ids[0]) + '.';
    }

    if (_utils.isFunction(context)) {
      context = context.call(this);
    }

    if (options.data) {
      data = _utils.createFrame(options.data);
    }

    function execIteration(field, index, last) {
      if (data) {
        data.key = field;
        data.index = index;
        data.first = index === 0;
        data.last = !!last;

        if (contextPath) {
          data.contextPath = contextPath + field;
        }
      }

      ret = ret + fn(context[field], {
        data: data,
        blockParams: _utils.blockParams([context[field], field], [contextPath + field, null])
      });
    }

    if (context && typeof context === 'object') {
      if (_utils.isArray(context)) {
        for (var j = context.length; i < j; i++) {
          if (i in context) {
            execIteration(i, i, i === context.length - 1);
          }
        }
      } else if (global.Symbol && context[global.Symbol.iterator]) {
        var newContext = [];
        var iterator = context[global.Symbol.iterator]();
        for (var it = iterator.next(); !it.done; it = iterator.next()) {
          newContext.push(it.value);
        }
        context = newContext;
        for (var j = context.length; i < j; i++) {
          execIteration(i, i, i === context.length - 1);
        }
      } else {
        (function () {
          var priorKey = undefined;

          Object.keys(context).forEach(function (key) {
            // We're running the iterations one step out of sync so we can detect
            // the last iteration without have to scan the object twice and create
            // an itermediate keys array.
            if (priorKey !== undefined) {
              execIteration(priorKey, i - 1);
            }
            priorKey = key;
            i++;
          });
          if (priorKey !== undefined) {
            execIteration(priorKey, i - 1, true);
          }
        })();
      }
    }

    if (i === 0) {
      ret = inverse(this);
    }

    return ret;
  });
};

module.exports = exports['default'];


}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"../exception":1135,"../utils":1151}],1139:[function(require,module,exports){
'use strict';

exports.__esModule = true;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _exception = require('../exception');

var _exception2 = _interopRequireDefault(_exception);

exports['default'] = function (instance) {
  instance.registerHelper('helperMissing', function () /* [args, ]options */{
    if (arguments.length === 1) {
      // A missing field in a {{foo}} construct.
      return undefined;
    } else {
      // Someone is actually trying to call something, blow up.
      throw new _exception2['default']('Missing helper: "' + arguments[arguments.length - 1].name + '"');
    }
  });
};

module.exports = exports['default'];


},{"../exception":1135}],1140:[function(require,module,exports){
'use strict';

exports.__esModule = true;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _utils = require('../utils');

var _exception = require('../exception');

var _exception2 = _interopRequireDefault(_exception);

exports['default'] = function (instance) {
  instance.registerHelper('if', function (conditional, options) {
    if (arguments.length != 2) {
      throw new _exception2['default']('#if requires exactly one argument');
    }
    if (_utils.isFunction(conditional)) {
      conditional = conditional.call(this);
    }

    // Default behavior is to render the positive path if the value is truthy and not empty.
    // The `includeZero` option may be set to treat the condtional as purely not empty based on the
    // behavior of isEmpty. Effectively this determines if 0 is handled by the positive path or negative.
    if (!options.hash.includeZero && !conditional || _utils.isEmpty(conditional)) {
      return options.inverse(this);
    } else {
      return options.fn(this);
    }
  });

  instance.registerHelper('unless', function (conditional, options) {
    if (arguments.length != 2) {
      throw new _exception2['default']('#unless requires exactly one argument');
    }
    return instance.helpers['if'].call(this, conditional, {
      fn: options.inverse,
      inverse: options.fn,
      hash: options.hash
    });
  });
};

module.exports = exports['default'];


},{"../exception":1135,"../utils":1151}],1141:[function(require,module,exports){
'use strict';

exports.__esModule = true;

exports['default'] = function (instance) {
  instance.registerHelper('log', function () /* message, options */{
    var args = [undefined],
        options = arguments[arguments.length - 1];
    for (var i = 0; i < arguments.length - 1; i++) {
      args.push(arguments[i]);
    }

    var level = 1;
    if (options.hash.level != null) {
      level = options.hash.level;
    } else if (options.data && options.data.level != null) {
      level = options.data.level;
    }
    args[0] = level;

    instance.log.apply(instance, args);
  });
};

module.exports = exports['default'];


},{}],1142:[function(require,module,exports){
'use strict';

exports.__esModule = true;

exports['default'] = function (instance) {
  instance.registerHelper('lookup', function (obj, field, options) {
    if (!obj) {
      // Note for 5.0: Change to "obj == null" in 5.0
      return obj;
    }
    return options.lookupProperty(obj, field);
  });
};

module.exports = exports['default'];


},{}],1143:[function(require,module,exports){
'use strict';

exports.__esModule = true;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _utils = require('../utils');

var _exception = require('../exception');

var _exception2 = _interopRequireDefault(_exception);

exports['default'] = function (instance) {
  instance.registerHelper('with', function (context, options) {
    if (arguments.length != 2) {
      throw new _exception2['default']('#with requires exactly one argument');
    }
    if (_utils.isFunction(context)) {
      context = context.call(this);
    }

    var fn = options.fn;

    if (!_utils.isEmpty(context)) {
      var data = options.data;
      if (options.data && options.ids) {
        data = _utils.createFrame(options.data);
        data.contextPath = _utils.appendContextPath(options.data.contextPath, options.ids[0]);
      }

      return fn(context, {
        data: data,
        blockParams: _utils.blockParams([context], [data && data.contextPath])
      });
    } else {
      return options.inverse(this);
    }
  });
};

module.exports = exports['default'];


},{"../exception":1135,"../utils":1151}],1144:[function(require,module,exports){
'use strict';

exports.__esModule = true;
exports.createNewLookupObject = createNewLookupObject;

var _utils = require('../utils');

/**
 * Create a new object with "null"-prototype to avoid truthy results on prototype properties.
 * The resulting object can be used with "object[property]" to check if a property exists
 * @param {...object} sources a varargs parameter of source objects that will be merged
 * @returns {object}
 */

function createNewLookupObject() {
  for (var _len = arguments.length, sources = Array(_len), _key = 0; _key < _len; _key++) {
    sources[_key] = arguments[_key];
  }

  return _utils.extend.apply(undefined, [Object.create(null)].concat(sources));
}


},{"../utils":1151}],1145:[function(require,module,exports){
'use strict';

exports.__esModule = true;
exports.createProtoAccessControl = createProtoAccessControl;
exports.resultIsAllowed = resultIsAllowed;
exports.resetLoggedProperties = resetLoggedProperties;
// istanbul ignore next

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

var _createNewLookupObject = require('./create-new-lookup-object');

var _logger = require('../logger');

var logger = _interopRequireWildcard(_logger);

var loggedProperties = Object.create(null);

function createProtoAccessControl(runtimeOptions) {
  var defaultMethodWhiteList = Object.create(null);
  defaultMethodWhiteList['constructor'] = false;
  defaultMethodWhiteList['__defineGetter__'] = false;
  defaultMethodWhiteList['__defineSetter__'] = false;
  defaultMethodWhiteList['__lookupGetter__'] = false;

  var defaultPropertyWhiteList = Object.create(null);
  // eslint-disable-next-line no-proto
  defaultPropertyWhiteList['__proto__'] = false;

  return {
    properties: {
      whitelist: _createNewLookupObject.createNewLookupObject(defaultPropertyWhiteList, runtimeOptions.allowedProtoProperties),
      defaultValue: runtimeOptions.allowProtoPropertiesByDefault
    },
    methods: {
      whitelist: _createNewLookupObject.createNewLookupObject(defaultMethodWhiteList, runtimeOptions.allowedProtoMethods),
      defaultValue: runtimeOptions.allowProtoMethodsByDefault
    }
  };
}

function resultIsAllowed(result, protoAccessControl, propertyName) {
  if (typeof result === 'function') {
    return checkWhiteList(protoAccessControl.methods, propertyName);
  } else {
    return checkWhiteList(protoAccessControl.properties, propertyName);
  }
}

function checkWhiteList(protoAccessControlForType, propertyName) {
  if (protoAccessControlForType.whitelist[propertyName] !== undefined) {
    return protoAccessControlForType.whitelist[propertyName] === true;
  }
  if (protoAccessControlForType.defaultValue !== undefined) {
    return protoAccessControlForType.defaultValue;
  }
  logUnexpecedPropertyAccessOnce(propertyName);
  return false;
}

function logUnexpecedPropertyAccessOnce(propertyName) {
  if (loggedProperties[propertyName] !== true) {
    loggedProperties[propertyName] = true;
    logger.log('error', 'Handlebars: Access has been denied to resolve the property "' + propertyName + '" because it is not an "own property" of its parent.\n' + 'You can add a runtime option to disable the check or this warning:\n' + 'See https://handlebarsjs.com/api-reference/runtime-options.html#options-to-control-prototype-access for details');
  }
}

function resetLoggedProperties() {
  Object.keys(loggedProperties).forEach(function (propertyName) {
    delete loggedProperties[propertyName];
  });
}


},{"../logger":1147,"./create-new-lookup-object":1144}],1146:[function(require,module,exports){
'use strict';

exports.__esModule = true;
exports.wrapHelper = wrapHelper;

function wrapHelper(helper, transformOptionsFn) {
  if (typeof helper !== 'function') {
    // This should not happen, but apparently it does in https://github.com/wycats/handlebars.js/issues/1639
    // We try to make the wrapper least-invasive by not wrapping it, if the helper is not a function.
    return helper;
  }
  var wrapper = function wrapper() /* dynamic arguments */{
    var options = arguments[arguments.length - 1];
    arguments[arguments.length - 1] = transformOptionsFn(options);
    return helper.apply(this, arguments);
  };
  return wrapper;
}


},{}],1147:[function(require,module,exports){
'use strict';

exports.__esModule = true;

var _utils = require('./utils');

var logger = {
  methodMap: ['debug', 'info', 'warn', 'error'],
  level: 'info',

  // Maps a given level value to the `methodMap` indexes above.
  lookupLevel: function lookupLevel(level) {
    if (typeof level === 'string') {
      var levelMap = _utils.indexOf(logger.methodMap, level.toLowerCase());
      if (levelMap >= 0) {
        level = levelMap;
      } else {
        level = parseInt(level, 10);
      }
    }

    return level;
  },

  // Can be overridden in the host environment
  log: function log(level) {
    level = logger.lookupLevel(level);

    if (typeof console !== 'undefined' && logger.lookupLevel(logger.level) <= level) {
      var method = logger.methodMap[level];
      // eslint-disable-next-line no-console
      if (!console[method]) {
        method = 'log';
      }

      for (var _len = arguments.length, message = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        message[_key - 1] = arguments[_key];
      }

      console[method].apply(console, message); // eslint-disable-line no-console
    }
  }
};

exports['default'] = logger;
module.exports = exports['default'];


},{"./utils":1151}],1148:[function(require,module,exports){
(function (global){(function (){
'use strict';

exports.__esModule = true;

exports['default'] = function (Handlebars) {
  /* istanbul ignore next */
  var root = typeof global !== 'undefined' ? global : window,
      $Handlebars = root.Handlebars;
  /* istanbul ignore next */
  Handlebars.noConflict = function () {
    if (root.Handlebars === Handlebars) {
      root.Handlebars = $Handlebars;
    }
    return Handlebars;
  };
};

module.exports = exports['default'];


}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],1149:[function(require,module,exports){
'use strict';

exports.__esModule = true;
exports.checkRevision = checkRevision;
exports.template = template;
exports.wrapProgram = wrapProgram;
exports.resolvePartial = resolvePartial;
exports.invokePartial = invokePartial;
exports.noop = noop;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// istanbul ignore next

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

var _utils = require('./utils');

var Utils = _interopRequireWildcard(_utils);

var _exception = require('./exception');

var _exception2 = _interopRequireDefault(_exception);

var _base = require('./base');

var _helpers = require('./helpers');

var _internalWrapHelper = require('./internal/wrapHelper');

var _internalProtoAccess = require('./internal/proto-access');

function checkRevision(compilerInfo) {
  var compilerRevision = compilerInfo && compilerInfo[0] || 1,
      currentRevision = _base.COMPILER_REVISION;

  if (compilerRevision >= _base.LAST_COMPATIBLE_COMPILER_REVISION && compilerRevision <= _base.COMPILER_REVISION) {
    return;
  }

  if (compilerRevision < _base.LAST_COMPATIBLE_COMPILER_REVISION) {
    var runtimeVersions = _base.REVISION_CHANGES[currentRevision],
        compilerVersions = _base.REVISION_CHANGES[compilerRevision];
    throw new _exception2['default']('Template was precompiled with an older version of Handlebars than the current runtime. ' + 'Please update your precompiler to a newer version (' + runtimeVersions + ') or downgrade your runtime to an older version (' + compilerVersions + ').');
  } else {
    // Use the embedded version info since the runtime doesn't know about this revision yet
    throw new _exception2['default']('Template was precompiled with a newer version of Handlebars than the current runtime. ' + 'Please update your runtime to a newer version (' + compilerInfo[1] + ').');
  }
}

function template(templateSpec, env) {
  /* istanbul ignore next */
  if (!env) {
    throw new _exception2['default']('No environment passed to template');
  }
  if (!templateSpec || !templateSpec.main) {
    throw new _exception2['default']('Unknown template object: ' + typeof templateSpec);
  }

  templateSpec.main.decorator = templateSpec.main_d;

  // Note: Using env.VM references rather than local var references throughout this section to allow
  // for external users to override these as pseudo-supported APIs.
  env.VM.checkRevision(templateSpec.compiler);

  // backwards compatibility for precompiled templates with compiler-version 7 (<4.3.0)
  var templateWasPrecompiledWithCompilerV7 = templateSpec.compiler && templateSpec.compiler[0] === 7;

  function invokePartialWrapper(partial, context, options) {
    if (options.hash) {
      context = Utils.extend({}, context, options.hash);
      if (options.ids) {
        options.ids[0] = true;
      }
    }
    partial = env.VM.resolvePartial.call(this, partial, context, options);

    var extendedOptions = Utils.extend({}, options, {
      hooks: this.hooks,
      protoAccessControl: this.protoAccessControl
    });

    var result = env.VM.invokePartial.call(this, partial, context, extendedOptions);

    if (result == null && env.compile) {
      options.partials[options.name] = env.compile(partial, templateSpec.compilerOptions, env);
      result = options.partials[options.name](context, extendedOptions);
    }
    if (result != null) {
      if (options.indent) {
        var lines = result.split('\n');
        for (var i = 0, l = lines.length; i < l; i++) {
          if (!lines[i] && i + 1 === l) {
            break;
          }

          lines[i] = options.indent + lines[i];
        }
        result = lines.join('\n');
      }
      return result;
    } else {
      throw new _exception2['default']('The partial ' + options.name + ' could not be compiled when running in runtime-only mode');
    }
  }

  // Just add water
  var container = {
    strict: function strict(obj, name, loc) {
      if (!obj || !(name in obj)) {
        throw new _exception2['default']('"' + name + '" not defined in ' + obj, {
          loc: loc
        });
      }
      return container.lookupProperty(obj, name);
    },
    lookupProperty: function lookupProperty(parent, propertyName) {
      var result = parent[propertyName];
      if (result == null) {
        return result;
      }
      if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
        return result;
      }

      if (_internalProtoAccess.resultIsAllowed(result, container.protoAccessControl, propertyName)) {
        return result;
      }
      return undefined;
    },
    lookup: function lookup(depths, name) {
      var len = depths.length;
      for (var i = 0; i < len; i++) {
        var result = depths[i] && container.lookupProperty(depths[i], name);
        if (result != null) {
          return depths[i][name];
        }
      }
    },
    lambda: function lambda(current, context) {
      return typeof current === 'function' ? current.call(context) : current;
    },

    escapeExpression: Utils.escapeExpression,
    invokePartial: invokePartialWrapper,

    fn: function fn(i) {
      var ret = templateSpec[i];
      ret.decorator = templateSpec[i + '_d'];
      return ret;
    },

    programs: [],
    program: function program(i, data, declaredBlockParams, blockParams, depths) {
      var programWrapper = this.programs[i],
          fn = this.fn(i);
      if (data || depths || blockParams || declaredBlockParams) {
        programWrapper = wrapProgram(this, i, fn, data, declaredBlockParams, blockParams, depths);
      } else if (!programWrapper) {
        programWrapper = this.programs[i] = wrapProgram(this, i, fn);
      }
      return programWrapper;
    },

    data: function data(value, depth) {
      while (value && depth--) {
        value = value._parent;
      }
      return value;
    },
    mergeIfNeeded: function mergeIfNeeded(param, common) {
      var obj = param || common;

      if (param && common && param !== common) {
        obj = Utils.extend({}, common, param);
      }

      return obj;
    },
    // An empty object to use as replacement for null-contexts
    nullContext: Object.seal({}),

    noop: env.VM.noop,
    compilerInfo: templateSpec.compiler
  };

  function ret(context) {
    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    var data = options.data;

    ret._setup(options);
    if (!options.partial && templateSpec.useData) {
      data = initData(context, data);
    }
    var depths = undefined,
        blockParams = templateSpec.useBlockParams ? [] : undefined;
    if (templateSpec.useDepths) {
      if (options.depths) {
        depths = context != options.depths[0] ? [context].concat(options.depths) : options.depths;
      } else {
        depths = [context];
      }
    }

    function main(context /*, options*/) {
      return '' + templateSpec.main(container, context, container.helpers, container.partials, data, blockParams, depths);
    }

    main = executeDecorators(templateSpec.main, main, container, options.depths || [], data, blockParams);
    return main(context, options);
  }

  ret.isTop = true;

  ret._setup = function (options) {
    if (!options.partial) {
      var mergedHelpers = Utils.extend({}, env.helpers, options.helpers);
      wrapHelpersToPassLookupProperty(mergedHelpers, container);
      container.helpers = mergedHelpers;

      if (templateSpec.usePartial) {
        // Use mergeIfNeeded here to prevent compiling global partials multiple times
        container.partials = container.mergeIfNeeded(options.partials, env.partials);
      }
      if (templateSpec.usePartial || templateSpec.useDecorators) {
        container.decorators = Utils.extend({}, env.decorators, options.decorators);
      }

      container.hooks = {};
      container.protoAccessControl = _internalProtoAccess.createProtoAccessControl(options);

      var keepHelperInHelpers = options.allowCallsToHelperMissing || templateWasPrecompiledWithCompilerV7;
      _helpers.moveHelperToHooks(container, 'helperMissing', keepHelperInHelpers);
      _helpers.moveHelperToHooks(container, 'blockHelperMissing', keepHelperInHelpers);
    } else {
      container.protoAccessControl = options.protoAccessControl; // internal option
      container.helpers = options.helpers;
      container.partials = options.partials;
      container.decorators = options.decorators;
      container.hooks = options.hooks;
    }
  };

  ret._child = function (i, data, blockParams, depths) {
    if (templateSpec.useBlockParams && !blockParams) {
      throw new _exception2['default']('must pass block params');
    }
    if (templateSpec.useDepths && !depths) {
      throw new _exception2['default']('must pass parent depths');
    }

    return wrapProgram(container, i, templateSpec[i], data, 0, blockParams, depths);
  };
  return ret;
}

function wrapProgram(container, i, fn, data, declaredBlockParams, blockParams, depths) {
  function prog(context) {
    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    var currentDepths = depths;
    if (depths && context != depths[0] && !(context === container.nullContext && depths[0] === null)) {
      currentDepths = [context].concat(depths);
    }

    return fn(container, context, container.helpers, container.partials, options.data || data, blockParams && [options.blockParams].concat(blockParams), currentDepths);
  }

  prog = executeDecorators(fn, prog, container, depths, data, blockParams);

  prog.program = i;
  prog.depth = depths ? depths.length : 0;
  prog.blockParams = declaredBlockParams || 0;
  return prog;
}

/**
 * This is currently part of the official API, therefore implementation details should not be changed.
 */

function resolvePartial(partial, context, options) {
  if (!partial) {
    if (options.name === '@partial-block') {
      partial = options.data['partial-block'];
    } else {
      partial = options.partials[options.name];
    }
  } else if (!partial.call && !options.name) {
    // This is a dynamic partial that returned a string
    options.name = partial;
    partial = options.partials[partial];
  }
  return partial;
}

function invokePartial(partial, context, options) {
  // Use the current closure context to save the partial-block if this partial
  var currentPartialBlock = options.data && options.data['partial-block'];
  options.partial = true;
  if (options.ids) {
    options.data.contextPath = options.ids[0] || options.data.contextPath;
  }

  var partialBlock = undefined;
  if (options.fn && options.fn !== noop) {
    (function () {
      options.data = _base.createFrame(options.data);
      // Wrapper function to get access to currentPartialBlock from the closure
      var fn = options.fn;
      partialBlock = options.data['partial-block'] = function partialBlockWrapper(context) {
        var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

        // Restore the partial-block from the closure for the execution of the block
        // i.e. the part inside the block of the partial call.
        options.data = _base.createFrame(options.data);
        options.data['partial-block'] = currentPartialBlock;
        return fn(context, options);
      };
      if (fn.partials) {
        options.partials = Utils.extend({}, options.partials, fn.partials);
      }
    })();
  }

  if (partial === undefined && partialBlock) {
    partial = partialBlock;
  }

  if (partial === undefined) {
    throw new _exception2['default']('The partial ' + options.name + ' could not be found');
  } else if (partial instanceof Function) {
    return partial(context, options);
  }
}

function noop() {
  return '';
}

function initData(context, data) {
  if (!data || !('root' in data)) {
    data = data ? _base.createFrame(data) : {};
    data.root = context;
  }
  return data;
}

function executeDecorators(fn, prog, container, depths, data, blockParams) {
  if (fn.decorator) {
    var props = {};
    prog = fn.decorator(prog, props, container, depths && depths[0], data, blockParams, depths);
    Utils.extend(prog, props);
  }
  return prog;
}

function wrapHelpersToPassLookupProperty(mergedHelpers, container) {
  Object.keys(mergedHelpers).forEach(function (helperName) {
    var helper = mergedHelpers[helperName];
    mergedHelpers[helperName] = passLookupPropertyOption(helper, container);
  });
}

function passLookupPropertyOption(helper, container) {
  var lookupProperty = container.lookupProperty;
  return _internalWrapHelper.wrapHelper(helper, function (options) {
    return Utils.extend({ lookupProperty: lookupProperty }, options);
  });
}


},{"./base":1122,"./exception":1135,"./helpers":1136,"./internal/proto-access":1145,"./internal/wrapHelper":1146,"./utils":1151}],1150:[function(require,module,exports){
// Build out our basic SafeString type
'use strict';

exports.__esModule = true;
function SafeString(string) {
  this.string = string;
}

SafeString.prototype.toString = SafeString.prototype.toHTML = function () {
  return '' + this.string;
};

exports['default'] = SafeString;
module.exports = exports['default'];


},{}],1151:[function(require,module,exports){
'use strict';

exports.__esModule = true;
exports.extend = extend;
exports.indexOf = indexOf;
exports.escapeExpression = escapeExpression;
exports.isEmpty = isEmpty;
exports.createFrame = createFrame;
exports.blockParams = blockParams;
exports.appendContextPath = appendContextPath;
var escape = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#x27;',
  '`': '&#x60;',
  '=': '&#x3D;'
};

var badChars = /[&<>"'`=]/g,
    possible = /[&<>"'`=]/;

function escapeChar(chr) {
  return escape[chr];
}

function extend(obj /* , ...source */) {
  for (var i = 1; i < arguments.length; i++) {
    for (var key in arguments[i]) {
      if (Object.prototype.hasOwnProperty.call(arguments[i], key)) {
        obj[key] = arguments[i][key];
      }
    }
  }

  return obj;
}

var toString = Object.prototype.toString;

exports.toString = toString;
// Sourced from lodash
// https://github.com/bestiejs/lodash/blob/master/LICENSE.txt
/* eslint-disable func-style */
var isFunction = function isFunction(value) {
  return typeof value === 'function';
};
// fallback for older versions of Chrome and Safari
/* istanbul ignore next */
if (isFunction(/x/)) {
  exports.isFunction = isFunction = function (value) {
    return typeof value === 'function' && toString.call(value) === '[object Function]';
  };
}
exports.isFunction = isFunction;

/* eslint-enable func-style */

/* istanbul ignore next */
var isArray = Array.isArray || function (value) {
  return value && typeof value === 'object' ? toString.call(value) === '[object Array]' : false;
};

exports.isArray = isArray;
// Older IE versions do not directly support indexOf so we must implement our own, sadly.

function indexOf(array, value) {
  for (var i = 0, len = array.length; i < len; i++) {
    if (array[i] === value) {
      return i;
    }
  }
  return -1;
}

function escapeExpression(string) {
  if (typeof string !== 'string') {
    // don't escape SafeStrings, since they're already safe
    if (string && string.toHTML) {
      return string.toHTML();
    } else if (string == null) {
      return '';
    } else if (!string) {
      return string + '';
    }

    // Force a string conversion as this will be done by the append regardless and
    // the regex test will do this transparently behind the scenes, causing issues if
    // an object's to string has escaped characters in it.
    string = '' + string;
  }

  if (!possible.test(string)) {
    return string;
  }
  return string.replace(badChars, escapeChar);
}

function isEmpty(value) {
  if (!value && value !== 0) {
    return true;
  } else if (isArray(value) && value.length === 0) {
    return true;
  } else {
    return false;
  }
}

function createFrame(object) {
  var frame = extend({}, object);
  frame._parent = object;
  return frame;
}

function blockParams(params, ids) {
  params.path = ids;
  return params;
}

function appendContextPath(contextPath, id) {
  return (contextPath ? contextPath + '.' : '') + id;
}


},{}],1152:[function(require,module,exports){
'use strict';

var $defineProperty = require('es-define-property');

var hasPropertyDescriptors = function hasPropertyDescriptors() {
	return !!$defineProperty;
};

hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
	// node v0.6 has a bug where array lengths can be Set but not Defined
	if (!$defineProperty) {
		return null;
	}
	try {
		return $defineProperty([], 'length', { value: 1 }).length !== 1;
	} catch (e) {
		// In Firefox 4-22, defining length on an array throws an exception.
		return true;
	}
};

module.exports = hasPropertyDescriptors;

},{"es-define-property":1094}],1153:[function(require,module,exports){
'use strict';

var test = {
	foo: {}
};

var $Object = Object;

module.exports = function hasProto() {
	return { __proto__: test }.foo === test.foo && !({ __proto__: null } instanceof $Object);
};

},{}],1154:[function(require,module,exports){
'use strict';

var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = require('./shams');

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};

},{"./shams":1155}],1155:[function(require,module,exports){
'use strict';

/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};

},{}],1156:[function(require,module,exports){
'use strict';

var hasSymbols = require('has-symbols/shams');

module.exports = function hasToStringTagShams() {
	return hasSymbols() && !!Symbol.toStringTag;
};

},{"has-symbols/shams":1155}],1157:[function(require,module,exports){
'use strict';

var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind = require('function-bind');

/** @type {import('.')} */
module.exports = bind.call(call, $hasOwn);

},{"function-bind":1117}],1158:[function(require,module,exports){
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}

},{}],1159:[function(require,module,exports){
if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
}

},{}],1160:[function(require,module,exports){
'use strict';

var hasToStringTag = require('has-tostringtag/shams')();
var callBound = require('call-bind/callBound');

var $toString = callBound('Object.prototype.toString');

var isStandardArguments = function isArguments(value) {
	if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
		return false;
	}
	return $toString(value) === '[object Arguments]';
};

var isLegacyArguments = function isArguments(value) {
	if (isStandardArguments(value)) {
		return true;
	}
	return value !== null &&
		typeof value === 'object' &&
		typeof value.length === 'number' &&
		value.length >= 0 &&
		$toString(value) !== '[object Array]' &&
		$toString(value.callee) === '[object Function]';
};

var supportsStandardArguments = (function () {
	return isStandardArguments(arguments);
}());

isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests

module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;

},{"call-bind/callBound":571,"has-tostringtag/shams":1156}],1161:[function(require,module,exports){
'use strict';

var fnToStr = Function.prototype.toString;
var reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var badArrayLike;
var isCallableMarker;
if (typeof reflectApply === 'function' && typeof Object.defineProperty === 'function') {
	try {
		badArrayLike = Object.defineProperty({}, 'length', {
			get: function () {
				throw isCallableMarker;
			}
		});
		isCallableMarker = {};
		// eslint-disable-next-line no-throw-literal
		reflectApply(function () { throw 42; }, null, badArrayLike);
	} catch (_) {
		if (_ !== isCallableMarker) {
			reflectApply = null;
		}
	}
} else {
	reflectApply = null;
}

var constructorRegex = /^\s*class\b/;
var isES6ClassFn = function isES6ClassFunction(value) {
	try {
		var fnStr = fnToStr.call(value);
		return constructorRegex.test(fnStr);
	} catch (e) {
		return false; // not a function
	}
};

var tryFunctionObject = function tryFunctionToStr(value) {
	try {
		if (isES6ClassFn(value)) { return false; }
		fnToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var objectClass = '[object Object]';
var fnClass = '[object Function]';
var genClass = '[object GeneratorFunction]';
var ddaClass = '[object HTMLAllCollection]'; // IE 11
var ddaClass2 = '[object HTML document.all class]';
var ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`

var isIE68 = !(0 in [,]); // eslint-disable-line no-sparse-arrays, comma-spacing

var isDDA = function isDocumentDotAll() { return false; };
if (typeof document === 'object') {
	// Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
	var all = document.all;
	if (toStr.call(all) === toStr.call(document.all)) {
		isDDA = function isDocumentDotAll(value) {
			/* globals document: false */
			// in IE 6-8, typeof document.all is "object" and it's truthy
			if ((isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) {
				try {
					var str = toStr.call(value);
					return (
						str === ddaClass
						|| str === ddaClass2
						|| str === ddaClass3 // opera 12.16
						|| str === objectClass // IE 6-8
					) && value('') == null; // eslint-disable-line eqeqeq
				} catch (e) { /**/ }
			}
			return false;
		};
	}
}

module.exports = reflectApply
	? function isCallable(value) {
		if (isDDA(value)) { return true; }
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		try {
			reflectApply(value, null, badArrayLike);
		} catch (e) {
			if (e !== isCallableMarker) { return false; }
		}
		return !isES6ClassFn(value) && tryFunctionObject(value);
	}
	: function isCallable(value) {
		if (isDDA(value)) { return true; }
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		if (hasToStringTag) { return tryFunctionObject(value); }
		if (isES6ClassFn(value)) { return false; }
		var strClass = toStr.call(value);
		if (strClass !== fnClass && strClass !== genClass && !(/^\[object HTML/).test(strClass)) { return false; }
		return tryFunctionObject(value);
	};

},{}],1162:[function(require,module,exports){
'use strict';

var toStr = Object.prototype.toString;
var fnToStr = Function.prototype.toString;
var isFnRegex = /^\s*(?:function)?\*/;
var hasToStringTag = require('has-tostringtag/shams')();
var getProto = Object.getPrototypeOf;
var getGeneratorFunc = function () { // eslint-disable-line consistent-return
	if (!hasToStringTag) {
		return false;
	}
	try {
		return Function('return function*() {}')();
	} catch (e) {
	}
};
var GeneratorFunction;

module.exports = function isGeneratorFunction(fn) {
	if (typeof fn !== 'function') {
		return false;
	}
	if (isFnRegex.test(fnToStr.call(fn))) {
		return true;
	}
	if (!hasToStringTag) {
		var str = toStr.call(fn);
		return str === '[object GeneratorFunction]';
	}
	if (!getProto) {
		return false;
	}
	if (typeof GeneratorFunction === 'undefined') {
		var generatorFunc = getGeneratorFunc();
		GeneratorFunction = generatorFunc ? getProto(generatorFunc) : false;
	}
	return getProto(fn) === GeneratorFunction;
};

},{"has-tostringtag/shams":1156}],1163:[function(require,module,exports){
(function (global){(function (){
'use strict';

var forEach = require('for-each');
var availableTypedArrays = require('available-typed-arrays');
var callBound = require('call-bind/callBound');

var $toString = callBound('Object.prototype.toString');
var hasToStringTag = require('has-tostringtag/shams')();
var gOPD = require('gopd');

var g = typeof globalThis === 'undefined' ? global : globalThis;
var typedArrays = availableTypedArrays();

var $indexOf = callBound('Array.prototype.indexOf', true) || function indexOf(array, value) {
	for (var i = 0; i < array.length; i += 1) {
		if (array[i] === value) {
			return i;
		}
	}
	return -1;
};
var $slice = callBound('String.prototype.slice');
var toStrTags = {};
var getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
if (hasToStringTag && gOPD && getPrototypeOf) {
	forEach(typedArrays, function (typedArray) {
		var arr = new g[typedArray]();
		if (Symbol.toStringTag in arr) {
			var proto = getPrototypeOf(arr);
			var descriptor = gOPD(proto, Symbol.toStringTag);
			if (!descriptor) {
				var superProto = getPrototypeOf(proto);
				descriptor = gOPD(superProto, Symbol.toStringTag);
			}
			toStrTags[typedArray] = descriptor.get;
		}
	});
}

var tryTypedArrays = function tryAllTypedArrays(value) {
	var anyTrue = false;
	forEach(toStrTags, function (getter, typedArray) {
		if (!anyTrue) {
			try {
				anyTrue = getter.call(value) === typedArray;
			} catch (e) { /**/ }
		}
	});
	return anyTrue;
};

module.exports = function isTypedArray(value) {
	if (!value || typeof value !== 'object') { return false; }
	if (!hasToStringTag || !(Symbol.toStringTag in value)) {
		var tag = $slice($toString(value), 8, -1);
		return $indexOf(typedArrays, tag) > -1;
	}
	if (!gOPD) { return false; }
	return tryTypedArrays(value);
};

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"available-typed-arrays":564,"call-bind/callBound":571,"for-each":1103,"gopd":1119,"has-tostringtag/shams":1156}],1164:[function(require,module,exports){
module.exports={
	"version": "2023c",
	"zones": [
		"Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5",
		"Africa/Nairobi|LMT +0230 EAT +0245|-2r.g -2u -30 -2J|012132|-2ua2r.g N6nV.g 3Fbu h1cu dzbJ|47e5",
		"Africa/Algiers|LMT PMT WET WEST CET CEST|-c.c -9.l 0 -10 -10 -20|01232323232323232454542423234542324|-3bQ0c.c MDA2.P cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5",
		"Africa/Lagos|LMT GMT +0030 WAT|-d.z 0 -u -10|01023|-2B40d.z 7iod.z dnXK.p dLzH.z|17e6",
		"Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4",
		"Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5",
		"Africa/Cairo|LMT EET EEST|-25.9 -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBC5.9 1AQM5.9 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0 kSp0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0|15e6",
		"Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|32e5",
		"Africa/Ceuta|LMT WET WEST CET CEST|l.g 0 -10 -10 -20|0121212121212121212121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2M0M0 GdX0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|85e3",
		"Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|20e4",
		"Africa/Johannesburg|LMT SAST SAST SAST|-1Q -1u -20 -30|0123232|-39EpQ qTcm 1Ajdu 1cL0 1cN0 1cL0|84e5",
		"Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|012121212121212121212121212121212131|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 PeX0|",
		"Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5",
		"Africa/Monrovia|LMT MMT MMT GMT|H.8 H.8 I.u 0|0123|-3ygng.Q 1usM0 28G01.m|11e5",
		"Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5",
		"Africa/Sao_Tome|LMT LMT GMT WAT|-q.U A.J 0 -10|01232|-3tooq.U 18aoq.U 4i6N0 2q00|",
		"Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5",
		"Africa/Tunis|LMT PMT CET CEST|-E.I -9.l -10 -20|01232323232323232323232323232323232|-3zO0E.I 1cBAv.n 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5",
		"Africa/Windhoek|LMT +0130 SAST SAST CAT WAT|-18.o -1u -20 -30 -20 -10|012324545454545454545454545454545454545454545454545454|-39Ep8.o qTbC.o 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4",
		"America/Adak|LMT LMT NST NWT NPT BST BDT AHST HST HDT|-cd.m bK.C b0 a0 a0 b0 a0 a0 a0 90|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVzf.p 1EX1d.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326",
		"America/Anchorage|LMT LMT AST AWT APT AHST AHDT YST AKST AKDT|-e0.o 9X.A a0 90 90 a0 90 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVxs.n 1EX20.o 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4",
		"America/Puerto_Rico|LMT AST AWT APT|4o.p 40 30 30|01231|-2Qi7z.z 1IUbz.z 7XT0 iu0|24e5",
		"America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4",
		"America/Argentina/Buenos_Aires|LMT CMT -04 -03 -02|3R.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343434343|-331U6.c 125cn pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0|",
		"America/Argentina/Catamarca|LMT CMT -04 -03 -02|4n.8 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243432343|-331TA.Q 125bR.E pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0|",
		"America/Argentina/Cordoba|LMT CMT -04 -03 -02|4g.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243434343|-331TH.c 125c0 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0|",
		"America/Argentina/Jujuy|LMT CMT -04 -03 -02|4l.c 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232434343|-331TC.M 125bT.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0|",
		"America/Argentina/La_Rioja|LMT CMT -04 -03 -02|4r.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tw.A 125bN.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|",
		"America/Argentina/Mendoza|LMT CMT -04 -03 -02|4z.g 4g.M 40 30 20|012323232323232323232323232323232323232323234343423232432343|-331To.I 125bF.w pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0|",
		"America/Argentina/Rio_Gallegos|LMT CMT -04 -03 -02|4A.Q 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tn.8 125bD.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|",
		"America/Argentina/Salta|LMT CMT -04 -03 -02|4l.E 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342434343|-331TC.k 125bT.8 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0|",
		"America/Argentina/San_Juan|LMT CMT -04 -03 -02|4y.4 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tp.U 125bG.I pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0|",
		"America/Argentina/San_Luis|LMT CMT -04 -03 -02|4p.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232323432323|-331Ty.A 125bP.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0|",
		"America/Argentina/Tucuman|LMT CMT -04 -03 -02|4k.Q 4g.M 40 30 20|01232323232323232323232323232323232323232323434343424343234343|-331TD.8 125bT.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0|",
		"America/Argentina/Ushuaia|LMT CMT -04 -03 -02|4x.c 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tq.M 125bH.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0|",
		"America/Asuncion|LMT AMT -04 -03|3O.E 3O.E 40 30|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-3eLw9.k 1FGo0 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0|28e5",
		"America/Panama|LMT CMT EST|5i.8 5j.A 50|012|-3eLuF.Q Iy01.s|15e5",
		"America/Bahia_Banderas|LMT MST CST MDT PST CDT|71 70 60 60 80 50|0121312141313131313131313131313131313152525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|84e3",
		"America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5",
		"America/Barbados|LMT AST ADT -0330|3W.t 40 30 3u|0121213121212121|-2m4k1.v 1eAN1.v RB0 1Bz0 Op0 1rb0 11d0 1jJc0 IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4",
		"America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5",
		"America/Belize|LMT CST -0530 CWT CPT CDT|5Q.M 60 5u 50 50 50|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121215151|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu Rcu 7Bt0 Ni0 4nd0 Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu e9Au qn0 lxB0 mn0|57e3",
		"America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2",
		"America/Bogota|LMT BMT -05 -04|4U.g 4U.g 50 40|01232|-3sTv3.I 1eIo0 38yo3.I 1PX0|90e5",
		"America/Boise|LMT PST PDT MST MWT MPT MDT|7I.N 80 70 70 60 60 60|01212134536363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-3tFE0 1nEe0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4",
		"America/Cambridge_Bay|-00 MST MWT MPT MDT CST CDT EST|0 70 60 60 60 60 50 50|012314141414141414141414141414141414141414141414141414141414567541414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-21Jc0 RO90 8x20 ix0 14HB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2",
		"America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4",
		"America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4",
		"America/Caracas|LMT CMT -0430 -04|4r.I 4r.E 4u 40|012323|-3eLvw.g ROnX.U 28KM2.k 1IwOu kqo0|29e5",
		"America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3",
		"America/Chicago|LMT CST CDT EST CWT CPT|5O.A 60 50 50 50 50|012121212121212121212121212121212121213121212121214512121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5",
		"America/Chihuahua|LMT MST CST MDT CDT|74.k 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|81e4",
		"America/Ciudad_Juarez|LMT MST CST MDT CDT|75.U 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0 cm0 EP0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|",
		"America/Costa_Rica|LMT SJMT CST CDT|5A.d 5A.d 60 50|01232323232|-3eLun.L 1fyo0 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5",
		"America/Phoenix|LMT MST MDT MWT|7s.i 70 60 60|012121313121|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5",
		"America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4",
		"America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8",
		"America/Dawson_Creek|LMT PST PDT PWT PPT MST|80.U 80 70 70 70 70|01213412121212121212121212121212121212121212121212121212125|-3tofX.4 1nspX.4 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3",
		"America/Dawson|LMT YST YDT YWT YPT YDDT PST PDT MST|9h.E 90 80 80 80 70 80 70 70|0121213415167676767676767676767676767676767676767676767676767676767676767676767676767676767678|-2MSeG.k GWpG.k 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|13e2",
		"America/Denver|LMT MST MDT MWT MPT|6X.U 70 60 60 60|012121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFF0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5",
		"America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5",
		"America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5",
		"America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3",
		"America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5",
		"America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 4Q00 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5",
		"America/Fort_Nelson|LMT PST PDT PWT PPT MST|8a.L 80 70 70 70 70|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121215|-3tofN.d 1nspN.d 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2",
		"America/Fort_Wayne|LMT CST CDT CWT CPT EST EDT|5I.C 60 50 50 50 50 40|0121212134121212121212121212151565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
		"America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5",
		"America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3",
		"America/Godthab|LMT -03 -02 -01|3q.U 30 20 10|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 2so0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e3",
		"America/Goose_Bay|LMT NST NDT NST NDT NWT NPT AST ADT ADDT|41.E 3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|0121343434343434356343434343434343434343434343434343434343437878787878787878787878787878787878787878787879787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-3tojW.k 1nspt.c 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2",
		"America/Grand_Turk|LMT KMT EST EDT AST|4I.w 57.a 50 40 40|01232323232323232323232323232323232323232323232323232323232323232323232323243232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLvf.s RK0m.C 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 7jA0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2",
		"America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5",
		"America/Guayaquil|LMT QMT -05 -04|5j.k 5e 50 40|01232|-3eLuE.E 1DNzS.E 2uILK rz0|27e5",
		"America/Guyana|LMT -04 -0345 -03|3Q.D 40 3J 30|01231|-2mf87.l 8Hc7.l 2r7bJ Ey0f|80e4",
		"America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4",
		"America/Havana|LMT HMT CST CDT|5t.s 5t.A 50 40|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLuu.w 1qx00.8 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5",
		"America/Hermosillo|LMT MST CST MDT PST|7n.Q 70 60 60 80|0121312141313131|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4",
		"America/Indiana/Knox|LMT CST CDT CWT CPT EST|5K.u 60 50 50 50 50|01212134121212121212121212121212121212151212121212121212121212121212121212121212121212121252121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
		"America/Indiana/Marengo|LMT CST CDT CWT CPT EST EDT|5J.n 60 50 50 50 50 40|01212134121212121212121215656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
		"America/Indiana/Petersburg|LMT CST CDT CWT CPT EST EDT|5N.7 60 50 50 50 50 40|01212134121212121212121212121512121212121212121212125212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
		"America/Indiana/Tell_City|LMT CST CDT CWT CPT EST EDT|5L.3 60 50 50 50 50 40|012121341212121212121212121512165652121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
		"America/Indiana/Vevay|LMT CST CDT CWT CPT EST EDT|5E.g 60 50 50 50 50 40|0121213415656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
		"America/Indiana/Vincennes|LMT CST CDT CWT CPT EST EDT|5O.7 60 50 50 50 50 40|01212134121212121212121212121212156565212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
		"America/Indiana/Winamac|LMT CST CDT CWT CPT EST EDT|5K.p 60 50 50 50 50 40|012121341212121212121212121212121212121565652165656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
		"America/Inuvik|-00 PST PDT MDT MST|0 80 70 60 70|01212121212121213434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-FnA0 L3K0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2",
		"America/Iqaluit|-00 EWT EPT EST EDT CST CDT|0 40 40 50 40 60 50|0123434343434343434343434343434343434343434343434343434343456343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-16K00 7nX0 iv0 14HB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2",
		"America/Jamaica|LMT KMT EST EDT|57.a 57.a 50 40|01232323232323232323232|-3eLuQ.O RK00 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4",
		"America/Juneau|LMT LMT PST PWT PPT PDT YDT YST AKST AKDT|-f2.j 8V.F 80 70 70 70 80 90 90 80|0123425252525252525252525252625252578989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVwq.s 1EX12.j 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3",
		"America/Kentucky/Louisville|LMT CST CDT CWT CPT EST EDT|5H.2 60 50 50 50 50 40|01212121213412121212121212121212121212565656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
		"America/Kentucky/Monticello|LMT CST CDT CWT CPT EST EDT|5D.o 60 50 50 50 50 40|01212134121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
		"America/La_Paz|LMT CMT BST -04|4w.A 4w.A 3w.A 40|0123|-3eLvr.o 1FIo0 13b0|19e5",
		"America/Lima|LMT LMT -05 -04|58.c 58.A 50 40|01232323232323232|-3eLuP.M JcM0.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6",
		"America/Los_Angeles|LMT PST PDT PWT PPT|7Q.W 80 70 70 70|0121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFE0 1nEe0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6",
		"America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4",
		"America/Managua|LMT MMT CST EST CDT|5J.8 5J.c 60 50 50|01232424232324242|-3eLue.Q 1Mhc0.4 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5",
		"America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5",
		"America/Martinique|LMT FFMT AST ADT|44.k 44.k 40 30|01232|-3eLvT.E PTA0 2LPbT.E 19X0|39e4",
		"America/Matamoros|LMT CST CDT|6u 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4",
		"America/Mazatlan|LMT MST CST MDT PST|75.E 70 60 60 80|0121312141313131313131313131313131313131313131313131313131313131|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|44e4",
		"America/Menominee|LMT CST CDT CWT CPT EST|5O.r 60 50 50 50 50|012121341212152121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3pdG9.x 1jce9.x 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2",
		"America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|11e5",
		"America/Metlakatla|LMT LMT PST PWT PPT PDT AKST AKDT|-fd.G 8K.i 80 70 70 70 90 80|0123425252525252525252525252525252526767672676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwf.5 1EX1d.G 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
		"America/Mexico_City|LMT MST CST MDT CDT CWT|6A.A 70 60 60 50 50|012131242425242424242424242424242424242424242424242424242424242424242|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|20e6",
		"America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2",
		"America/Moncton|LMT EST AST ADT AWT APT|4j.8 50 40 30 30 30|0123232323232323232323245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3txvE.Q J4ME.Q CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3",
		"America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|41e5",
		"America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5",
		"America/Toronto|LMT EST EDT EWT EPT|5h.w 50 40 40 40|012121212121212121212121212121212121212121212123412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-32B6G.s UFdG.s 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5",
		"America/New_York|LMT EST EDT EWT EPT|4U.2 50 40 40 40|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFH0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6",
		"America/Nome|LMT LMT NST NWT NPT BST BDT YST AKST AKDT|-cW.m b1.C b0 a0 a0 b0 a0 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVyu.p 1EX1W.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2",
		"America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2",
		"America/North_Dakota/Beulah|LMT MST MDT MWT MPT CST CDT|6L.7 70 60 60 60 60 50|012121341212121212121212121212121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0|",
		"America/North_Dakota/Center|LMT MST MDT MWT MPT CST CDT|6J.c 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
		"America/North_Dakota/New_Salem|LMT MST MDT MWT MPT CST CDT|6J.D 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
		"America/Ojinaga|LMT MST CST MDT CDT|6V.E 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0 Rc0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3",
		"America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4",
		"America/Port-au-Prince|LMT PPMT EST EDT|4N.k 4N 50 40|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLva.E 15RLX.E 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
		"America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4",
		"America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4",
		"America/Punta_Arenas|LMT SMT -05 -04 -03|4H.E 4G.J 50 40 30|01213132323232323232343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvg.k MJbX.5 fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|",
		"America/Winnipeg|LMT CST CDT CWT CPT|6s.A 60 50 50 50|0121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3kLtv.o 1a3bv.o WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4",
		"America/Rankin_Inlet|-00 CST CDT EST|0 60 50 50|01212121212121212121212121212121212121212121212121212121212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-vDc0 Bjk0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2",
		"America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5",
		"America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4",
		"America/Resolute|-00 CST CDT EST|0 60 50 50|01212121212121212121212121212121212121212121212121212121212321212121212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-SnA0 103I0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229",
		"America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4",
		"America/Santiago|LMT SMT -05 -04 -03|4G.J 4G.J 50 40 30|0121313232323232323432343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvh.f MJc0 fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 hX0 1q10 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|62e5",
		"America/Santo_Domingo|LMT SDMT EST EDT -0430 AST|4D.A 4E 50 40 4u 40|012324242424242525|-3eLvk.o 1Jic0.o 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5",
		"America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6",
		"America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|452",
		"America/Sitka|LMT LMT PST PWT PPT PDT YST AKST AKDT|-eW.L 91.d 80 70 70 70 90 90 80|0123425252525252525252525252525252567878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-48Pzs.L 1jVwu 1EX0W.L 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2",
		"America/St_Johns|LMT NST NDT NST NDT NWT NPT NDDT|3u.Q 3u.Q 2u.Q 3u 2u 2u 2u 1u|012121212121212121212121212121212121213434343434343435634343434343434343434343434343434343434343434343434343434343434343434343434343434343437343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tokt.8 1l020 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
		"America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3",
		"America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5",
		"America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656",
		"America/Vancouver|LMT PST PDT PWT PPT|8c.s 80 70 70 70|01213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tofL.w 1nspL.w 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
		"America/Whitehorse|LMT YST YDT YWT YPT YDDT PST PDT MST|90.c 90 80 80 80 70 80 70 70|0121213415167676767676767676767676767676767676767676767676767676767676767676767676767676767678|-2MSeX.M GWpX.M 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 LA0 ytd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|23e3",
		"America/Yakutat|LMT LMT YST YWT YPT YDT AKST AKDT|-eF.5 9i.T 90 80 80 80 90 80|0123425252525252525252525252525252526767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwL.G 1EX1F.5 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642",
		"Antarctica/Casey|-00 +08 +11|0 -80 -b0|0121212121212|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10 1o30 14k0 1kr0 12l0 1o01|10",
		"Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70",
		"Pacific/Port_Moresby|LMT PMMT +10|-9M.E -9M.w -a0|012|-3D8VM.E AvA0.8|25e4",
		"Antarctica/Macquarie|-00 AEST AEDT|0 -a0 -b0|0121012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2OPc0 Fb40 1a00 4SK0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 3Co0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|1",
		"Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60",
		"Pacific/Auckland|LMT NZMT NZST NZST NZDT|-bD.4 -bu -cu -c0 -d0|012131313131313131313131313134343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-46jLD.4 2nEO9.4 Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|14e5",
		"Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40",
		"Antarctica/Rothera|-00 -03|0 30|01|gOo0|130",
		"Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5",
		"Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|40",
		"Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5",
		"Europe/Berlin|LMT CET CEST CEMT|-R.s -10 -20 -30|012121212121212321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36RcR.s UbWR.s 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e5",
		"Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5",
		"Asia/Amman|LMT EET EEST +03|-2n.I -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 LA0 1C00|25e5",
		"Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3",
		"Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4",
		"Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4",
		"Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4",
		"Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|",
		"Asia/Baghdad|LMT BMT +03 +04|-2V.E -2V.A -30 -40|0123232323232323232323232323232323232323232323232323232|-3eLCV.E 18ao0.4 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5",
		"Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4",
		"Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5",
		"Asia/Bangkok|LMT BMT +07|-6G.4 -6G.4 -70|012|-3D8SG.4 1C000|15e6",
		"Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|",
		"Asia/Beirut|LMT EET EEST|-2m -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3D8Om 1BWom 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|22e5",
		"Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4",
		"Asia/Brunei|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|42e4",
		"Asia/Kolkata|LMT HMT MMT IST +0630|-5R.s -5R.k -5l.a -5u -6u|01234343|-4Fg5R.s BKo0.8 1rDcw.a 1r2LP.a 1un0 HB0 7zX0|15e6",
		"Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4",
		"Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3",
		"Asia/Shanghai|LMT CST CDT|-85.H -80 -90|012121212121212121212121212121|-2M0U5.H Iuo5.H 18n0 OjB0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6",
		"Asia/Colombo|LMT MMT +0530 +06 +0630|-5j.o -5j.w -5u -60 -6u|012342432|-3D8Rj.o 13inX.Q 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5",
		"Asia/Dhaka|LMT HMT +0630 +0530 +06 +07|-61.E -5R.k -6u -5u -60 -70|01232454|-3eLG1.E 26008.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6",
		"Asia/Damascus|LMT EET EEST +03|-2p.c -20 -30 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0|26e5",
		"Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4",
		"Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5",
		"Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4",
		"Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|",
		"Asia/Gaza|LMT EET EEST IST IDT|-2h.Q -20 -30 -20 -30|01212121212121212121212121212121212343434343434343434343434343434312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCh.Q 1Azeh.Q MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0 1cN0 1cL0 17d0 1in0 14p0 1lb0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1lb0 14p0 1in0 17d0 1cL0 1cN0 19X0 e10 2L0 WN0 14n0 gN0 5z0 11B0 WL0 e10 bb0 11B0 TX0 e10 dX0 11B0 On0 gN0 gL0 11B0 Lz0 e10 pb0 WN0 IL0 e10 rX0 WN0 Db0 gN0 uL0 11B0 xz0 e10 An0 11B0 rX0 gN0 Db0 11B0 pb0 e10 Lz0 WN0 mn0 e10 On0 WN0 gL0 gN0 Rb0 11B0 bb0 e10 WL0 11B0 5z0 gN0 11z0 11B0 2L0 gN0 14n0 1fB0 1cL0 1a10 1fz0 14p0 1lb0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1nX0 14p0 1in0 17d0 1fz0 1a10 19X0 1fB0 17b0 e10 28L0 e10 25X0 gN0 25X0 e10 gL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|18e5",
		"Asia/Hebron|LMT EET EEST IST IDT|-2k.n -20 -30 -20 -30|0121212121212121212121212121212121234343434343434343434343434343431212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCk.n 1Azek.n MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0 1cN0 1cL0 17d0 1in0 14p0 1lb0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1lb0 14p0 1in0 17d0 1cL0 1cN0 19X0 e10 2L0 WN0 14n0 gN0 5z0 11B0 WL0 e10 bb0 11B0 TX0 e10 dX0 11B0 On0 gN0 gL0 11B0 Lz0 e10 pb0 WN0 IL0 e10 rX0 WN0 Db0 gN0 uL0 11B0 xz0 e10 An0 11B0 rX0 gN0 Db0 11B0 pb0 e10 Lz0 WN0 mn0 e10 On0 WN0 gL0 gN0 Rb0 11B0 bb0 e10 WL0 11B0 5z0 gN0 11z0 11B0 2L0 gN0 14n0 1fB0 1cL0 1a10 1fz0 14p0 1lb0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1nX0 14p0 1in0 17d0 1fz0 1a10 19X0 1fB0 17b0 e10 28L0 e10 25X0 gN0 25X0 e10 gL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|25e4",
		"Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.u -76.u -70 -80 -90|0123423232|-2yC76.u bK00 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5",
		"Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5",
		"Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3",
		"Asia/Irkutsk|LMT IMT +07 +08 +09|-6V.5 -6V.5 -70 -80 -90|012343434343434343434343234343434343434343434343434343434343434343|-3D8SV.5 1Bxc0 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
		"Europe/Istanbul|LMT IMT EET EEST +03 +04|-1T.Q -1U.U -20 -30 -30 -40|01232323232323232323232323232323232323232323232345423232323232323232323232323232323232323232323232323232323232323234|-3D8NT.Q 1ePXW.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6",
		"Asia/Jakarta|LMT BMT +0720 +0730 +09 +08 WIB|-77.c -77.c -7k -7u -90 -80 -70|012343536|-49jH7.c 2hiLL.c luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6",
		"Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4",
		"Asia/Jerusalem|LMT JMT IST IDT IDDT|-2k.S -2k.E -20 -30 -40|012323232323232432323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8Ok.S 1wvA0.e SyOk.E MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 3LA0 Eo0 oo0 1co0 1dA0 16o0 10M0 1jc0 1tA0 14o0 1cM0 1a00 11A0 1Nc0 Ao0 1Nc0 Ao0 1Ko0 LA0 1o00 WM0 EQK0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0|81e4",
		"Asia/Kabul|LMT +04 +0430|-4A.M -40 -4u|012|-3eLEA.M 2dTcA.M|46e5",
		"Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4",
		"Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6",
		"Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5",
		"Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2",
		"Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5",
		"Asia/Kuala_Lumpur|LMT SMT +07 +0720 +0730 +09 +08|-6T.p -6T.p -70 -7k -7u -90 -80|01234546|-2M0ST.p aIM0 17anT.p l5XE 17bO 8Fyu 1so10|71e5",
		"Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4",
		"Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3",
		"Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5",
		"Asia/Manila|LMT LMT PST PDT JST|fU -84 -80 -90 -90|01232423232|-54m84 2clc0 1vfc4 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6",
		"Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|32e4",
		"Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4",
		"Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5",
		"Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5",
		"Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4",
		"Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4",
		"Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5",
		"Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|012323232323232323232123232323232323232323232323|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|",
		"Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4",
		"Asia/Rangoon|LMT RMT +0630 +09|-6o.L -6o.L -6u -90|01232|-3D8So.L 1BnA0 SmnS.L 7j9u|48e5",
		"Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4",
		"Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4",
		"Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6",
		"Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2",
		"Asia/Taipei|LMT CST JST CDT|-86 -80 -90 -90|012131313131313131313131313131313131313131|-30bk6 1FDc6 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5",
		"Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5",
		"Asia/Tbilisi|LMT TBMT +03 +04 +05|-2X.b -2X.b -30 -40 -50|01234343434343434343434323232343434343434343434323|-3D8OX.b 1LUM0 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5",
		"Asia/Tehran|LMT TMT +0330 +0430 +04 +05|-3p.I -3p.I -3u -4u -40 -50|012345423232323232323232323232323232323232323232323232323232323232323232|-2btDp.I Llc0 1FHaT.I 1pc0 120u Rc0 XA0 Wou JX0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0|14e6",
		"Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3",
		"Asia/Tokyo|LMT JST JDT|-9i.X -90 -a0|0121212121|-3jE90 2qSo0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6",
		"Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5",
		"Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5",
		"Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2",
		"Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
		"Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4",
		"Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5",
		"Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5",
		"Atlantic/Azores|LMT HMT -02 -01 +00 WET|1G.E 1S.w 20 10 0 0|01232323232323232323232323232323232323232323234323432343234323232323232323232323232323232323232323232343434343434343434343434343434345434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tomh.k 18aoh.k aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|25e4",
		"Atlantic/Bermuda|LMT BMT BST AST ADT|4j.i 4j.i 3j.i 40 30|0121213434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3eLvE.G 16mo0 1bb0 1i10 11X0 ru30 thbE.G 1PX0 11B0 1tz0 Rd0 1zb0 Op0 1zb0 3I10 Lz0 1EN0 FX0 1HB0 FX0 1Kp0 Db0 1Kp0 Db0 1Kp0 FX0 93d0 11z0 GAp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3",
		"Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4",
		"Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4",
		"Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|49e3",
		"Atlantic/Madeira|LMT FMT -01 +00 +01 WET WEST|17.A 17.A 10 0 -10 0 -10|01232323232323232323232323232323232323232323234323432343234323232323232323232323232323232323232323232565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tomQ.o 18anQ.o aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e4",
		"Atlantic/South_Georgia|LMT -02|2q.8 20|01|-3eLxx.Q|30",
		"Atlantic/Stanley|LMT SMT -04 -03 -02|3P.o 3P.o 40 30 20|0123232323232323434323232323232323232323232323232323232323232323232323|-3eLw8.A S200 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2",
		"Australia/Sydney|LMT AEST AEDT|-a4.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oW4.Q RlC4.Q xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|40e5",
		"Australia/Adelaide|LMT ACST ACST ACDT|-9e.k -90 -9u -au|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-32oVe.k ak0e.k H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|11e5",
		"Australia/Brisbane|LMT AEST AEDT|-ac.8 -a0 -b0|012121212121212121|-32Bmc.8 Ry2c.8 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5",
		"Australia/Broken_Hill|LMT AEST ACST ACST ACDT|-9p.M -a0 -90 -9u -au|0123434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-32oVp.M 3Lzp.M 6wp0 H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|18e3",
		"Australia/Hobart|LMT AEST AEDT|-9N.g -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-3109N.g Pk1N.g 1a00 1qM0 Oo0 1zc0 Oo0 TAo0 yM0 1cM0 1cM0 1fA0 1a00 VfA0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|21e4",
		"Australia/Darwin|LMT ACST ACST ACDT|-8H.k -90 -9u -au|01232323232|-32oUH.k ajXH.k H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00|12e4",
		"Australia/Eucla|LMT +0845 +0945|-8z.s -8J -9J|01212121212121212121|-30nIz.s PkpO.s xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368",
		"Australia/Lord_Howe|LMT AEST +1030 +1130 +11|-aA.k -a0 -au -bu -b0|01232323232424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424|-32oWA.k 3tzAA.k 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu|347",
		"Australia/Lindeman|LMT AEST AEDT|-9T.U -a0 -b0|0121212121212121212121|-32BlT.U Ry1T.U xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10",
		"Australia/Melbourne|LMT AEST AEDT|-9D.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oVD.Q RlBD.Q xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|39e5",
		"Australia/Perth|LMT AWST AWDT|-7H.o -80 -90|01212121212121212121|-30nHH.o PkpH.o xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5",
		"CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|",
		"Pacific/Easter|LMT EMT -07 -06 -05|7h.s 7h.s 70 60 50|0123232323232323232323232323234343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLsG.w 1HRc0 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|30e2",
		"CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
		"EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|",
		"Europe/Dublin|LMT DMT IST GMT BST IST|p.l p.l -y.D 0 -10 -10|012343434343435353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353|-3BHby.D 1ra20 Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5",
		"EST|EST|50|0||",
		"EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
		"Etc/GMT-0|GMT|0|0||",
		"Etc/GMT-1|+01|-10|0||",
		"Etc/GMT-10|+10|-a0|0||",
		"Etc/GMT-11|+11|-b0|0||",
		"Etc/GMT-12|+12|-c0|0||",
		"Etc/GMT-13|+13|-d0|0||",
		"Etc/GMT-14|+14|-e0|0||",
		"Etc/GMT-2|+02|-20|0||",
		"Etc/GMT-3|+03|-30|0||",
		"Etc/GMT-4|+04|-40|0||",
		"Etc/GMT-5|+05|-50|0||",
		"Etc/GMT-6|+06|-60|0||",
		"Etc/GMT-7|+07|-70|0||",
		"Etc/GMT-8|+08|-80|0||",
		"Etc/GMT-9|+09|-90|0||",
		"Etc/GMT+1|-01|10|0||",
		"Etc/GMT+10|-10|a0|0||",
		"Etc/GMT+11|-11|b0|0||",
		"Etc/GMT+12|-12|c0|0||",
		"Etc/GMT+2|-02|20|0||",
		"Etc/GMT+3|-03|30|0||",
		"Etc/GMT+4|-04|40|0||",
		"Etc/GMT+5|-05|50|0||",
		"Etc/GMT+6|-06|60|0||",
		"Etc/GMT+7|-07|70|0||",
		"Etc/GMT+8|-08|80|0||",
		"Etc/GMT+9|-09|90|0||",
		"Etc/UTC|UTC|0|0||",
		"Europe/Brussels|LMT BMT WET CET CEST WEST|-h.u -h.u 0 -10 -20 -10|012343434325252525252525252525252525252525252525252525434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8Mh.u u1Ah.u SO00 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|21e5",
		"Europe/Andorra|LMT WET CET CEST|-6.4 0 -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2M0M6.4 1Pnc6.4 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|79e3",
		"Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5",
		"Europe/Athens|LMT AMT EET EEST CEST CET|-1y.Q -1y.Q -20 -30 -20 -10|0123234545232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-30SNy.Q OMM1 CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|35e5",
		"Europe/London|LMT GMT BST BDST|1.f 0 -10 -20|01212121212121212121212121212121212121212121212121232323232321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-4VgnW.J 2KHdW.J Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|10e6",
		"Europe/Belgrade|LMT CET CEST|-1m -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3topm 2juLm 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5",
		"Europe/Prague|LMT PMT CET CEST GMT|-V.I -V.I -10 -20 0|0123232323232323232423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4QbAV.I 1FDc0 XPaV.I 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|13e5",
		"Europe/Bucharest|LMT BMT EET EEST|-1I.o -1I.o -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3awpI.o 1AU00 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|19e5",
		"Europe/Budapest|LMT CET CEST|-1g.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3cK1g.k 124Lg.k 11d0 1iO0 11A0 1o00 11A0 1oo0 11c0 1lc0 17c0 O1V0 3Nf0 WM0 1fA0 1cM0 1cM0 1oJ0 1dd0 1020 1fX0 1cp0 1cM0 1cM0 1cM0 1fA0 1a00 bhy0 Rb0 1wr0 Rc0 1C00 LA0 1C00 LA0 SNW0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cO0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5",
		"Europe/Zurich|LMT BMT CET CEST|-y.8 -t.K -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4HyMy.8 1Dw04.m 1SfAt.K 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|38e4",
		"Europe/Chisinau|LMT CMT BMT EET EEST CEST CET MSK MSD|-1T.k -1T -1I.o -20 -30 -20 -10 -30 -40|0123434343434343434345656578787878787878787878434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8NT.k 1wNA0.k wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|67e4",
		"Europe/Gibraltar|LMT GMT BST BDST CET CEST|l.o 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123232323232121232121212121212121212145454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-3BHbC.A 1ra1C.A Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|30e3",
		"Europe/Helsinki|LMT HMT EET EEST|-1D.N -1D.N -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3H0ND.N 1Iu00 OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5",
		"Europe/Kaliningrad|LMT CET CEST EET EEST MSK MSD +03|-1m -10 -20 -20 -30 -30 -40 -30|012121212121212343565656565656565654343434343434343434343434343434343434343434373|-36Rdm UbXm 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4",
		"Europe/Kiev|LMT KMT EET MSK CEST CET MSD EEST|-22.4 -22.4 -20 -30 -20 -10 -40 -30|01234545363636363636363636367272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-3D8O2.4 1LUM0 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o10 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|34e5",
		"Europe/Kirov|LMT +03 +04 +05 MSD MSK MSK|-3i.M -30 -40 -50 -40 -30 -40|0123232323232323232454524545454545454545454545454545454545454565|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 2pz0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4",
		"Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5",
		"Europe/Madrid|LMT WET WEST WEMT CET CEST|e.I 0 -10 -20 -10 -20|0121212121212121212321454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2M0M0 G5z0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|62e5",
		"Europe/Malta|LMT CET CEST|-W.4 -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-35rcW.4 SXzW.4 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4",
		"Europe/Minsk|LMT MMT EET MSK CEST CET MSD EEST +03|-1O.g -1O -20 -30 -20 -10 -40 -30 -30|012345454363636363636363636372727272727272727272727272727272727272728|-3D8NO.g 1LUM0.g eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5",
		"Europe/Paris|LMT PMT WET WEST CEST CET WEMT|-9.l -9.l 0 -10 -20 -10 -20|01232323232323232323232323232323232323232323232323234545463654545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-3bQ09.l MDA0 cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|11e6",
		"Europe/Moscow|LMT MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|01232434565756865656565656565656565698656565656565656565656565656565656565656a6|-3D8Ou.h 1sQM0 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6",
		"Europe/Riga|LMT RMT LST EET MSK CEST CET MSD EEST|-1A.y -1A.y -2A.y -20 -30 -20 -10 -40 -30|0121213456565647474747474747474838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383|-3D8NA.y 1xde0 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|64e4",
		"Europe/Rome|LMT RMT CET CEST|-N.U -N.U -10 -20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4aU0N.U 15snN.U T000 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|39e5",
		"Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5",
		"Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810|",
		"Europe/Simferopol|LMT SMT EET MSK CEST CET MSD EEST MSK|-2g.o -2g -20 -30 -20 -10 -40 -30 -40|0123454543636363636363636363272727636363727272727272727272727272727272727283|-3D8Og.o 1LUM0.o eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eN0 1cM0 1cM0 1cM0 1cM0 dV0 WO0 1cM0 1cM0 1fy0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4",
		"Europe/Sofia|LMT IMT EET CET CEST EEST|-1x.g -1U.U -20 -10 -20 -30|0123434325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-3D8Nx.g AiLA.k 1UFeU.U WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5",
		"Europe/Tallinn|LMT TMT CET CEST EET MSK MSD EEST|-1D -1D -10 -20 -20 -30 -40 -30|0123214532323565656565656565657474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474|-3D8ND 1wI00 teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e4",
		"Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4",
		"Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5",
		"Europe/Vienna|LMT CET CEST|-15.l -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36Rd5.l UbX5.l 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|18e5",
		"Europe/Vilnius|LMT WMT KMT CET EET MSK CEST MSD EEST|-1F.g -1o -1z.A -10 -20 -30 -20 -40 -30|0123435636365757575757575757584848484848484848463648484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484|-3D8NF.g 1u5Ah.g 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4",
		"Europe/Volgograd|LMT +03 +04 +05 MSD MSK MSK|-2V.E -30 -40 -50 -40 -30 -40|012323232323232324545452454545454545454545454545454545454545456525|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1fA0 1cM0 2pz0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0 5gn0|10e5",
		"Europe/Warsaw|LMT WMT CET CEST EET EEST|-1o -1o -10 -20 -20 -30|0123232345423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8No 1qDA0 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5",
		"HST|HST|a0|0||",
		"Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2",
		"Indian/Maldives|LMT MMT +05|-4S -4S -50|012|-3D8QS 3eLA0|35e4",
		"Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4",
		"Pacific/Kwajalein|LMT +11 +10 +09 -12 +12|-b9.k -b0 -a0 -90 c0 -c0|0123145|-2M0X9.k 1rDA9.k akp0 6Up0 12ry0 Wan0|14e3",
		"MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|",
		"MST|MST|70|0||",
		"MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
		"Pacific/Chatham|LMT +1215 +1245 +1345|-cd.M -cf -cJ -dJ|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-46jMd.M 37RbW.M 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|600",
		"Pacific/Apia|LMT LMT -1130 -11 -10 +14 +13|-cx.4 bq.U bu b0 a0 -e0 -d0|012343456565656565656565656|-38Fox.4 J1A0 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0|37e3",
		"Pacific/Bougainville|LMT PMMT +10 +09 +11|-am.g -9M.w -a0 -90 -b0|012324|-3D8Wm.g AvAx.I 1TCLM.w 7CN0 2MQp0|18e4",
		"Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|012121212121212121212121|-2l9nd.g 2uNXd.g Dc0 n610 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3",
		"Pacific/Enderbury|-00 -12 -11 +13|0 c0 b0 -d0|0123|-1iIo0 1GsA0 B7X0|1",
		"Pacific/Fakaofo|LMT -11 +13|bo.U b0 -d0|012|-2M0Az.4 4ufXz.4|483",
		"Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|012121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 2hc0 bc0|88e4",
		"Pacific/Tarawa|LMT +12|-bw.4 -c0|01|-2M0Xw.4|29e3",
		"Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3",
		"Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125",
		"Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4",
		"Pacific/Guam|LMT LMT GST +09 GDT ChST|el -9D -a0 -90 -b0 -a0|0123242424242424242425|-54m9D 2glc0 1DFbD 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4",
		"Pacific/Honolulu|LMT HST HDT HWT HPT HST|av.q au 9u 9u 9u a0|01213415|-3061s.y 1uMdW.y 8x0 lef0 8wWu iAu 46p0|37e4",
		"Pacific/Kiritimati|LMT -1040 -10 +14|at.k aE a0 -e0|0123|-2M0Bu.E 3bIMa.E B7Xk|51e2",
		"Pacific/Kosrae|LMT LMT +11 +09 +10 +12|d8.4 -aP.U -b0 -90 -a0 -c0|0123243252|-54maP.U 2glc0 xsnP.U axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2",
		"Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2",
		"Pacific/Pago_Pago|LMT LMT SST|-cB.c bm.M b0|012|-38FoB.c J1A0|37e2",
		"Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3",
		"Pacific/Niue|LMT -1120 -11|bj.E bk b0|012|-FScE.k suo0.k|12e2",
		"Pacific/Norfolk|LMT +1112 +1130 +1230 +11 +12|-bb.Q -bc -bu -cu -b0 -c0|0123245454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2M0Xb.Q 21ILX.Q W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|25e4",
		"Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3",
		"Pacific/Palau|LMT LMT +09|f2.4 -8V.U -90|012|-54m8V.U 2glc0|21e3",
		"Pacific/Pitcairn|LMT -0830 -08|8E.k 8u 80|012|-2M0Dj.E 3UVXN.E|56",
		"Pacific/Rarotonga|LMT LMT -1030 -0930 -10|-dk.U aD.4 au 9u a0|01234343434343434343434343434|-2Otpk.U 28zc0 13tbO.U IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3",
		"Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4",
		"Pacific/Tongatapu|LMT +1220 +13 +14|-cj.c -ck -d0 -e0|01232323232|-XbMj.c BgLX.c 1yndk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3",
		"PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
		"WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|"
	],
	"links": [
		"Africa/Abidjan|Africa/Accra",
		"Africa/Abidjan|Africa/Bamako",
		"Africa/Abidjan|Africa/Banjul",
		"Africa/Abidjan|Africa/Conakry",
		"Africa/Abidjan|Africa/Dakar",
		"Africa/Abidjan|Africa/Freetown",
		"Africa/Abidjan|Africa/Lome",
		"Africa/Abidjan|Africa/Nouakchott",
		"Africa/Abidjan|Africa/Ouagadougou",
		"Africa/Abidjan|Africa/Timbuktu",
		"Africa/Abidjan|Atlantic/Reykjavik",
		"Africa/Abidjan|Atlantic/St_Helena",
		"Africa/Abidjan|Iceland",
		"Africa/Cairo|Egypt",
		"Africa/Johannesburg|Africa/Maseru",
		"Africa/Johannesburg|Africa/Mbabane",
		"Africa/Lagos|Africa/Bangui",
		"Africa/Lagos|Africa/Brazzaville",
		"Africa/Lagos|Africa/Douala",
		"Africa/Lagos|Africa/Kinshasa",
		"Africa/Lagos|Africa/Libreville",
		"Africa/Lagos|Africa/Luanda",
		"Africa/Lagos|Africa/Malabo",
		"Africa/Lagos|Africa/Niamey",
		"Africa/Lagos|Africa/Porto-Novo",
		"Africa/Maputo|Africa/Blantyre",
		"Africa/Maputo|Africa/Bujumbura",
		"Africa/Maputo|Africa/Gaborone",
		"Africa/Maputo|Africa/Harare",
		"Africa/Maputo|Africa/Kigali",
		"Africa/Maputo|Africa/Lubumbashi",
		"Africa/Maputo|Africa/Lusaka",
		"Africa/Nairobi|Africa/Addis_Ababa",
		"Africa/Nairobi|Africa/Asmara",
		"Africa/Nairobi|Africa/Asmera",
		"Africa/Nairobi|Africa/Dar_es_Salaam",
		"Africa/Nairobi|Africa/Djibouti",
		"Africa/Nairobi|Africa/Kampala",
		"Africa/Nairobi|Africa/Mogadishu",
		"Africa/Nairobi|Indian/Antananarivo",
		"Africa/Nairobi|Indian/Comoro",
		"Africa/Nairobi|Indian/Mayotte",
		"Africa/Tripoli|Libya",
		"America/Adak|America/Atka",
		"America/Adak|US/Aleutian",
		"America/Anchorage|US/Alaska",
		"America/Argentina/Buenos_Aires|America/Buenos_Aires",
		"America/Argentina/Catamarca|America/Argentina/ComodRivadavia",
		"America/Argentina/Catamarca|America/Catamarca",
		"America/Argentina/Cordoba|America/Cordoba",
		"America/Argentina/Cordoba|America/Rosario",
		"America/Argentina/Jujuy|America/Jujuy",
		"America/Argentina/Mendoza|America/Mendoza",
		"America/Chicago|US/Central",
		"America/Denver|America/Shiprock",
		"America/Denver|Navajo",
		"America/Denver|US/Mountain",
		"America/Detroit|US/Michigan",
		"America/Edmonton|America/Yellowknife",
		"America/Edmonton|Canada/Mountain",
		"America/Fort_Wayne|America/Indiana/Indianapolis",
		"America/Fort_Wayne|America/Indianapolis",
		"America/Fort_Wayne|US/East-Indiana",
		"America/Godthab|America/Nuuk",
		"America/Halifax|Canada/Atlantic",
		"America/Havana|Cuba",
		"America/Indiana/Knox|America/Knox_IN",
		"America/Indiana/Knox|US/Indiana-Starke",
		"America/Iqaluit|America/Pangnirtung",
		"America/Jamaica|Jamaica",
		"America/Kentucky/Louisville|America/Louisville",
		"America/Los_Angeles|US/Pacific",
		"America/Manaus|Brazil/West",
		"America/Mazatlan|Mexico/BajaSur",
		"America/Mexico_City|Mexico/General",
		"America/New_York|US/Eastern",
		"America/Noronha|Brazil/DeNoronha",
		"America/Panama|America/Atikokan",
		"America/Panama|America/Cayman",
		"America/Panama|America/Coral_Harbour",
		"America/Phoenix|America/Creston",
		"America/Phoenix|US/Arizona",
		"America/Puerto_Rico|America/Anguilla",
		"America/Puerto_Rico|America/Antigua",
		"America/Puerto_Rico|America/Aruba",
		"America/Puerto_Rico|America/Blanc-Sablon",
		"America/Puerto_Rico|America/Curacao",
		"America/Puerto_Rico|America/Dominica",
		"America/Puerto_Rico|America/Grenada",
		"America/Puerto_Rico|America/Guadeloupe",
		"America/Puerto_Rico|America/Kralendijk",
		"America/Puerto_Rico|America/Lower_Princes",
		"America/Puerto_Rico|America/Marigot",
		"America/Puerto_Rico|America/Montserrat",
		"America/Puerto_Rico|America/Port_of_Spain",
		"America/Puerto_Rico|America/St_Barthelemy",
		"America/Puerto_Rico|America/St_Kitts",
		"America/Puerto_Rico|America/St_Lucia",
		"America/Puerto_Rico|America/St_Thomas",
		"America/Puerto_Rico|America/St_Vincent",
		"America/Puerto_Rico|America/Tortola",
		"America/Puerto_Rico|America/Virgin",
		"America/Regina|Canada/Saskatchewan",
		"America/Rio_Branco|America/Porto_Acre",
		"America/Rio_Branco|Brazil/Acre",
		"America/Santiago|Chile/Continental",
		"America/Sao_Paulo|Brazil/East",
		"America/St_Johns|Canada/Newfoundland",
		"America/Tijuana|America/Ensenada",
		"America/Tijuana|America/Santa_Isabel",
		"America/Tijuana|Mexico/BajaNorte",
		"America/Toronto|America/Montreal",
		"America/Toronto|America/Nassau",
		"America/Toronto|America/Nipigon",
		"America/Toronto|America/Thunder_Bay",
		"America/Toronto|Canada/Eastern",
		"America/Vancouver|Canada/Pacific",
		"America/Whitehorse|Canada/Yukon",
		"America/Winnipeg|America/Rainy_River",
		"America/Winnipeg|Canada/Central",
		"Asia/Ashgabat|Asia/Ashkhabad",
		"Asia/Bangkok|Asia/Phnom_Penh",
		"Asia/Bangkok|Asia/Vientiane",
		"Asia/Bangkok|Indian/Christmas",
		"Asia/Brunei|Asia/Kuching",
		"Asia/Dhaka|Asia/Dacca",
		"Asia/Dubai|Asia/Muscat",
		"Asia/Dubai|Indian/Mahe",
		"Asia/Dubai|Indian/Reunion",
		"Asia/Ho_Chi_Minh|Asia/Saigon",
		"Asia/Hong_Kong|Hongkong",
		"Asia/Jerusalem|Asia/Tel_Aviv",
		"Asia/Jerusalem|Israel",
		"Asia/Kathmandu|Asia/Katmandu",
		"Asia/Kolkata|Asia/Calcutta",
		"Asia/Kuala_Lumpur|Asia/Singapore",
		"Asia/Kuala_Lumpur|Singapore",
		"Asia/Macau|Asia/Macao",
		"Asia/Makassar|Asia/Ujung_Pandang",
		"Asia/Nicosia|Europe/Nicosia",
		"Asia/Qatar|Asia/Bahrain",
		"Asia/Rangoon|Asia/Yangon",
		"Asia/Rangoon|Indian/Cocos",
		"Asia/Riyadh|Antarctica/Syowa",
		"Asia/Riyadh|Asia/Aden",
		"Asia/Riyadh|Asia/Kuwait",
		"Asia/Seoul|ROK",
		"Asia/Shanghai|Asia/Chongqing",
		"Asia/Shanghai|Asia/Chungking",
		"Asia/Shanghai|Asia/Harbin",
		"Asia/Shanghai|PRC",
		"Asia/Taipei|ROC",
		"Asia/Tehran|Iran",
		"Asia/Thimphu|Asia/Thimbu",
		"Asia/Tokyo|Japan",
		"Asia/Ulaanbaatar|Asia/Ulan_Bator",
		"Asia/Urumqi|Antarctica/Vostok",
		"Asia/Urumqi|Asia/Kashgar",
		"Atlantic/Faroe|Atlantic/Faeroe",
		"Australia/Adelaide|Australia/South",
		"Australia/Brisbane|Australia/Queensland",
		"Australia/Broken_Hill|Australia/Yancowinna",
		"Australia/Darwin|Australia/North",
		"Australia/Hobart|Australia/Currie",
		"Australia/Hobart|Australia/Tasmania",
		"Australia/Lord_Howe|Australia/LHI",
		"Australia/Melbourne|Australia/Victoria",
		"Australia/Perth|Australia/West",
		"Australia/Sydney|Australia/ACT",
		"Australia/Sydney|Australia/Canberra",
		"Australia/Sydney|Australia/NSW",
		"Etc/GMT-0|Etc/GMT",
		"Etc/GMT-0|Etc/GMT+0",
		"Etc/GMT-0|Etc/GMT0",
		"Etc/GMT-0|Etc/Greenwich",
		"Etc/GMT-0|GMT",
		"Etc/GMT-0|GMT+0",
		"Etc/GMT-0|GMT-0",
		"Etc/GMT-0|GMT0",
		"Etc/GMT-0|Greenwich",
		"Etc/UTC|Etc/UCT",
		"Etc/UTC|Etc/Universal",
		"Etc/UTC|Etc/Zulu",
		"Etc/UTC|UCT",
		"Etc/UTC|UTC",
		"Etc/UTC|Universal",
		"Etc/UTC|Zulu",
		"Europe/Belgrade|Europe/Ljubljana",
		"Europe/Belgrade|Europe/Podgorica",
		"Europe/Belgrade|Europe/Sarajevo",
		"Europe/Belgrade|Europe/Skopje",
		"Europe/Belgrade|Europe/Zagreb",
		"Europe/Berlin|Arctic/Longyearbyen",
		"Europe/Berlin|Atlantic/Jan_Mayen",
		"Europe/Berlin|Europe/Copenhagen",
		"Europe/Berlin|Europe/Oslo",
		"Europe/Berlin|Europe/Stockholm",
		"Europe/Brussels|Europe/Amsterdam",
		"Europe/Brussels|Europe/Luxembourg",
		"Europe/Chisinau|Europe/Tiraspol",
		"Europe/Dublin|Eire",
		"Europe/Helsinki|Europe/Mariehamn",
		"Europe/Istanbul|Asia/Istanbul",
		"Europe/Istanbul|Turkey",
		"Europe/Kiev|Europe/Kyiv",
		"Europe/Kiev|Europe/Uzhgorod",
		"Europe/Kiev|Europe/Zaporozhye",
		"Europe/Lisbon|Portugal",
		"Europe/London|Europe/Belfast",
		"Europe/London|Europe/Guernsey",
		"Europe/London|Europe/Isle_of_Man",
		"Europe/London|Europe/Jersey",
		"Europe/London|GB",
		"Europe/London|GB-Eire",
		"Europe/Moscow|W-SU",
		"Europe/Paris|Europe/Monaco",
		"Europe/Prague|Europe/Bratislava",
		"Europe/Rome|Europe/San_Marino",
		"Europe/Rome|Europe/Vatican",
		"Europe/Warsaw|Poland",
		"Europe/Zurich|Europe/Busingen",
		"Europe/Zurich|Europe/Vaduz",
		"Indian/Maldives|Indian/Kerguelen",
		"Pacific/Auckland|Antarctica/McMurdo",
		"Pacific/Auckland|Antarctica/South_Pole",
		"Pacific/Auckland|NZ",
		"Pacific/Chatham|NZ-CHAT",
		"Pacific/Easter|Chile/EasterIsland",
		"Pacific/Enderbury|Pacific/Kanton",
		"Pacific/Guadalcanal|Pacific/Pohnpei",
		"Pacific/Guadalcanal|Pacific/Ponape",
		"Pacific/Guam|Pacific/Saipan",
		"Pacific/Honolulu|Pacific/Johnston",
		"Pacific/Honolulu|US/Hawaii",
		"Pacific/Kwajalein|Kwajalein",
		"Pacific/Pago_Pago|Pacific/Midway",
		"Pacific/Pago_Pago|Pacific/Samoa",
		"Pacific/Pago_Pago|US/Samoa",
		"Pacific/Port_Moresby|Antarctica/DumontDUrville",
		"Pacific/Port_Moresby|Pacific/Chuuk",
		"Pacific/Port_Moresby|Pacific/Truk",
		"Pacific/Port_Moresby|Pacific/Yap",
		"Pacific/Tarawa|Pacific/Funafuti",
		"Pacific/Tarawa|Pacific/Majuro",
		"Pacific/Tarawa|Pacific/Wake",
		"Pacific/Tarawa|Pacific/Wallis"
	],
	"countries": [
		"AD|Europe/Andorra",
		"AE|Asia/Dubai",
		"AF|Asia/Kabul",
		"AG|America/Puerto_Rico America/Antigua",
		"AI|America/Puerto_Rico America/Anguilla",
		"AL|Europe/Tirane",
		"AM|Asia/Yerevan",
		"AO|Africa/Lagos Africa/Luanda",
		"AQ|Antarctica/Casey Antarctica/Davis Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Troll Asia/Urumqi Pacific/Auckland Pacific/Port_Moresby Asia/Riyadh Antarctica/McMurdo Antarctica/DumontDUrville Antarctica/Syowa Antarctica/Vostok",
		"AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia",
		"AS|Pacific/Pago_Pago",
		"AT|Europe/Vienna",
		"AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla",
		"AW|America/Puerto_Rico America/Aruba",
		"AX|Europe/Helsinki Europe/Mariehamn",
		"AZ|Asia/Baku",
		"BA|Europe/Belgrade Europe/Sarajevo",
		"BB|America/Barbados",
		"BD|Asia/Dhaka",
		"BE|Europe/Brussels",
		"BF|Africa/Abidjan Africa/Ouagadougou",
		"BG|Europe/Sofia",
		"BH|Asia/Qatar Asia/Bahrain",
		"BI|Africa/Maputo Africa/Bujumbura",
		"BJ|Africa/Lagos Africa/Porto-Novo",
		"BL|America/Puerto_Rico America/St_Barthelemy",
		"BM|Atlantic/Bermuda",
		"BN|Asia/Kuching Asia/Brunei",
		"BO|America/La_Paz",
		"BQ|America/Puerto_Rico America/Kralendijk",
		"BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco",
		"BS|America/Toronto America/Nassau",
		"BT|Asia/Thimphu",
		"BW|Africa/Maputo Africa/Gaborone",
		"BY|Europe/Minsk",
		"BZ|America/Belize",
		"CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Toronto America/Iqaluit America/Winnipeg America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Inuvik America/Dawson_Creek America/Fort_Nelson America/Whitehorse America/Dawson America/Vancouver America/Panama America/Puerto_Rico America/Phoenix America/Blanc-Sablon America/Atikokan America/Creston",
		"CC|Asia/Yangon Indian/Cocos",
		"CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi",
		"CF|Africa/Lagos Africa/Bangui",
		"CG|Africa/Lagos Africa/Brazzaville",
		"CH|Europe/Zurich",
		"CI|Africa/Abidjan",
		"CK|Pacific/Rarotonga",
		"CL|America/Santiago America/Punta_Arenas Pacific/Easter",
		"CM|Africa/Lagos Africa/Douala",
		"CN|Asia/Shanghai Asia/Urumqi",
		"CO|America/Bogota",
		"CR|America/Costa_Rica",
		"CU|America/Havana",
		"CV|Atlantic/Cape_Verde",
		"CW|America/Puerto_Rico America/Curacao",
		"CX|Asia/Bangkok Indian/Christmas",
		"CY|Asia/Nicosia Asia/Famagusta",
		"CZ|Europe/Prague",
		"DE|Europe/Zurich Europe/Berlin Europe/Busingen",
		"DJ|Africa/Nairobi Africa/Djibouti",
		"DK|Europe/Berlin Europe/Copenhagen",
		"DM|America/Puerto_Rico America/Dominica",
		"DO|America/Santo_Domingo",
		"DZ|Africa/Algiers",
		"EC|America/Guayaquil Pacific/Galapagos",
		"EE|Europe/Tallinn",
		"EG|Africa/Cairo",
		"EH|Africa/El_Aaiun",
		"ER|Africa/Nairobi Africa/Asmara",
		"ES|Europe/Madrid Africa/Ceuta Atlantic/Canary",
		"ET|Africa/Nairobi Africa/Addis_Ababa",
		"FI|Europe/Helsinki",
		"FJ|Pacific/Fiji",
		"FK|Atlantic/Stanley",
		"FM|Pacific/Kosrae Pacific/Port_Moresby Pacific/Guadalcanal Pacific/Chuuk Pacific/Pohnpei",
		"FO|Atlantic/Faroe",
		"FR|Europe/Paris",
		"GA|Africa/Lagos Africa/Libreville",
		"GB|Europe/London",
		"GD|America/Puerto_Rico America/Grenada",
		"GE|Asia/Tbilisi",
		"GF|America/Cayenne",
		"GG|Europe/London Europe/Guernsey",
		"GH|Africa/Abidjan Africa/Accra",
		"GI|Europe/Gibraltar",
		"GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule",
		"GM|Africa/Abidjan Africa/Banjul",
		"GN|Africa/Abidjan Africa/Conakry",
		"GP|America/Puerto_Rico America/Guadeloupe",
		"GQ|Africa/Lagos Africa/Malabo",
		"GR|Europe/Athens",
		"GS|Atlantic/South_Georgia",
		"GT|America/Guatemala",
		"GU|Pacific/Guam",
		"GW|Africa/Bissau",
		"GY|America/Guyana",
		"HK|Asia/Hong_Kong",
		"HN|America/Tegucigalpa",
		"HR|Europe/Belgrade Europe/Zagreb",
		"HT|America/Port-au-Prince",
		"HU|Europe/Budapest",
		"ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura",
		"IE|Europe/Dublin",
		"IL|Asia/Jerusalem",
		"IM|Europe/London Europe/Isle_of_Man",
		"IN|Asia/Kolkata",
		"IO|Indian/Chagos",
		"IQ|Asia/Baghdad",
		"IR|Asia/Tehran",
		"IS|Africa/Abidjan Atlantic/Reykjavik",
		"IT|Europe/Rome",
		"JE|Europe/London Europe/Jersey",
		"JM|America/Jamaica",
		"JO|Asia/Amman",
		"JP|Asia/Tokyo",
		"KE|Africa/Nairobi",
		"KG|Asia/Bishkek",
		"KH|Asia/Bangkok Asia/Phnom_Penh",
		"KI|Pacific/Tarawa Pacific/Kanton Pacific/Kiritimati",
		"KM|Africa/Nairobi Indian/Comoro",
		"KN|America/Puerto_Rico America/St_Kitts",
		"KP|Asia/Pyongyang",
		"KR|Asia/Seoul",
		"KW|Asia/Riyadh Asia/Kuwait",
		"KY|America/Panama America/Cayman",
		"KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral",
		"LA|Asia/Bangkok Asia/Vientiane",
		"LB|Asia/Beirut",
		"LC|America/Puerto_Rico America/St_Lucia",
		"LI|Europe/Zurich Europe/Vaduz",
		"LK|Asia/Colombo",
		"LR|Africa/Monrovia",
		"LS|Africa/Johannesburg Africa/Maseru",
		"LT|Europe/Vilnius",
		"LU|Europe/Brussels Europe/Luxembourg",
		"LV|Europe/Riga",
		"LY|Africa/Tripoli",
		"MA|Africa/Casablanca",
		"MC|Europe/Paris Europe/Monaco",
		"MD|Europe/Chisinau",
		"ME|Europe/Belgrade Europe/Podgorica",
		"MF|America/Puerto_Rico America/Marigot",
		"MG|Africa/Nairobi Indian/Antananarivo",
		"MH|Pacific/Tarawa Pacific/Kwajalein Pacific/Majuro",
		"MK|Europe/Belgrade Europe/Skopje",
		"ML|Africa/Abidjan Africa/Bamako",
		"MM|Asia/Yangon",
		"MN|Asia/Ulaanbaatar Asia/Hovd Asia/Choibalsan",
		"MO|Asia/Macau",
		"MP|Pacific/Guam Pacific/Saipan",
		"MQ|America/Martinique",
		"MR|Africa/Abidjan Africa/Nouakchott",
		"MS|America/Puerto_Rico America/Montserrat",
		"MT|Europe/Malta",
		"MU|Indian/Mauritius",
		"MV|Indian/Maldives",
		"MW|Africa/Maputo Africa/Blantyre",
		"MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Chihuahua America/Ciudad_Juarez America/Ojinaga America/Mazatlan America/Bahia_Banderas America/Hermosillo America/Tijuana",
		"MY|Asia/Kuching Asia/Singapore Asia/Kuala_Lumpur",
		"MZ|Africa/Maputo",
		"NA|Africa/Windhoek",
		"NC|Pacific/Noumea",
		"NE|Africa/Lagos Africa/Niamey",
		"NF|Pacific/Norfolk",
		"NG|Africa/Lagos",
		"NI|America/Managua",
		"NL|Europe/Brussels Europe/Amsterdam",
		"NO|Europe/Berlin Europe/Oslo",
		"NP|Asia/Kathmandu",
		"NR|Pacific/Nauru",
		"NU|Pacific/Niue",
		"NZ|Pacific/Auckland Pacific/Chatham",
		"OM|Asia/Dubai Asia/Muscat",
		"PA|America/Panama",
		"PE|America/Lima",
		"PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier",
		"PG|Pacific/Port_Moresby Pacific/Bougainville",
		"PH|Asia/Manila",
		"PK|Asia/Karachi",
		"PL|Europe/Warsaw",
		"PM|America/Miquelon",
		"PN|Pacific/Pitcairn",
		"PR|America/Puerto_Rico",
		"PS|Asia/Gaza Asia/Hebron",
		"PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores",
		"PW|Pacific/Palau",
		"PY|America/Asuncion",
		"QA|Asia/Qatar",
		"RE|Asia/Dubai Indian/Reunion",
		"RO|Europe/Bucharest",
		"RS|Europe/Belgrade",
		"RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Volgograd Europe/Astrakhan Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr",
		"RW|Africa/Maputo Africa/Kigali",
		"SA|Asia/Riyadh",
		"SB|Pacific/Guadalcanal",
		"SC|Asia/Dubai Indian/Mahe",
		"SD|Africa/Khartoum",
		"SE|Europe/Berlin Europe/Stockholm",
		"SG|Asia/Singapore",
		"SH|Africa/Abidjan Atlantic/St_Helena",
		"SI|Europe/Belgrade Europe/Ljubljana",
		"SJ|Europe/Berlin Arctic/Longyearbyen",
		"SK|Europe/Prague Europe/Bratislava",
		"SL|Africa/Abidjan Africa/Freetown",
		"SM|Europe/Rome Europe/San_Marino",
		"SN|Africa/Abidjan Africa/Dakar",
		"SO|Africa/Nairobi Africa/Mogadishu",
		"SR|America/Paramaribo",
		"SS|Africa/Juba",
		"ST|Africa/Sao_Tome",
		"SV|America/El_Salvador",
		"SX|America/Puerto_Rico America/Lower_Princes",
		"SY|Asia/Damascus",
		"SZ|Africa/Johannesburg Africa/Mbabane",
		"TC|America/Grand_Turk",
		"TD|Africa/Ndjamena",
		"TF|Asia/Dubai Indian/Maldives Indian/Kerguelen",
		"TG|Africa/Abidjan Africa/Lome",
		"TH|Asia/Bangkok",
		"TJ|Asia/Dushanbe",
		"TK|Pacific/Fakaofo",
		"TL|Asia/Dili",
		"TM|Asia/Ashgabat",
		"TN|Africa/Tunis",
		"TO|Pacific/Tongatapu",
		"TR|Europe/Istanbul",
		"TT|America/Puerto_Rico America/Port_of_Spain",
		"TV|Pacific/Tarawa Pacific/Funafuti",
		"TW|Asia/Taipei",
		"TZ|Africa/Nairobi Africa/Dar_es_Salaam",
		"UA|Europe/Simferopol Europe/Kyiv",
		"UG|Africa/Nairobi Africa/Kampala",
		"UM|Pacific/Pago_Pago Pacific/Tarawa Pacific/Midway Pacific/Wake",
		"US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu",
		"UY|America/Montevideo",
		"UZ|Asia/Samarkand Asia/Tashkent",
		"VA|Europe/Rome Europe/Vatican",
		"VC|America/Puerto_Rico America/St_Vincent",
		"VE|America/Caracas",
		"VG|America/Puerto_Rico America/Tortola",
		"VI|America/Puerto_Rico America/St_Thomas",
		"VN|Asia/Bangkok Asia/Ho_Chi_Minh",
		"VU|Pacific/Efate",
		"WF|Pacific/Tarawa Pacific/Wallis",
		"WS|Pacific/Apia",
		"YE|Asia/Riyadh Asia/Aden",
		"YT|Africa/Nairobi Indian/Mayotte",
		"ZA|Africa/Johannesburg",
		"ZM|Africa/Maputo Africa/Lusaka",
		"ZW|Africa/Maputo Africa/Harare"
	]
}
},{}],1165:[function(require,module,exports){
//! moment-timezone.js
//! version : 0.5.43
//! Copyright (c) JS Foundation and other contributors
//! license : MIT
//! github.com/moment/moment-timezone

(function (root, factory) {
	"use strict";

	/*global define*/
	if (typeof module === 'object' && module.exports) {
		module.exports = factory(require('moment')); // Node
	} else if (typeof define === 'function' && define.amd) {
		define(['moment'], factory);                 // AMD
	} else {
		factory(root.moment);                        // Browser
	}
}(this, function (moment) {
	"use strict";

	// Resolves es6 module loading issue
	if (moment.version === undefined && moment.default) {
		moment = moment.default;
	}

	// Do not load moment-timezone a second time.
	// if (moment.tz !== undefined) {
	// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
	// 	return moment;
	// }

	var VERSION = "0.5.43",
		zones = {},
		links = {},
		countries = {},
		names = {},
		guesses = {},
		cachedGuess;

	if (!moment || typeof moment.version !== 'string') {
		logError('Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/');
	}

	var momentVersion = moment.version.split('.'),
		major = +momentVersion[0],
		minor = +momentVersion[1];

	// Moment.js version check
	if (major < 2 || (major === 2 && minor < 6)) {
		logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
	}

	/************************************
		Unpacking
	************************************/

	function charCodeToInt(charCode) {
		if (charCode > 96) {
			return charCode - 87;
		} else if (charCode > 64) {
			return charCode - 29;
		}
		return charCode - 48;
	}

	function unpackBase60(string) {
		var i = 0,
			parts = string.split('.'),
			whole = parts[0],
			fractional = parts[1] || '',
			multiplier = 1,
			num,
			out = 0,
			sign = 1;

		// handle negative numbers
		if (string.charCodeAt(0) === 45) {
			i = 1;
			sign = -1;
		}

		// handle digits before the decimal
		for (i; i < whole.length; i++) {
			num = charCodeToInt(whole.charCodeAt(i));
			out = 60 * out + num;
		}

		// handle digits after the decimal
		for (i = 0; i < fractional.length; i++) {
			multiplier = multiplier / 60;
			num = charCodeToInt(fractional.charCodeAt(i));
			out += num * multiplier;
		}

		return out * sign;
	}

	function arrayToInt (array) {
		for (var i = 0; i < array.length; i++) {
			array[i] = unpackBase60(array[i]);
		}
	}

	function intToUntil (array, length) {
		for (var i = 0; i < length; i++) {
			array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
		}

		array[length - 1] = Infinity;
	}

	function mapIndices (source, indices) {
		var out = [], i;

		for (i = 0; i < indices.length; i++) {
			out[i] = source[indices[i]];
		}

		return out;
	}

	function unpack (string) {
		var data = string.split('|'),
			offsets = data[2].split(' '),
			indices = data[3].split(''),
			untils  = data[4].split(' ');

		arrayToInt(offsets);
		arrayToInt(indices);
		arrayToInt(untils);

		intToUntil(untils, indices.length);

		return {
			name       : data[0],
			abbrs      : mapIndices(data[1].split(' '), indices),
			offsets    : mapIndices(offsets, indices),
			untils     : untils,
			population : data[5] | 0
		};
	}

	/************************************
		Zone object
	************************************/

	function Zone (packedString) {
		if (packedString) {
			this._set(unpack(packedString));
		}
	}

	Zone.prototype = {
		_set : function (unpacked) {
			this.name       = unpacked.name;
			this.abbrs      = unpacked.abbrs;
			this.untils     = unpacked.untils;
			this.offsets    = unpacked.offsets;
			this.population = unpacked.population;
		},

		_index : function (timestamp) {
			var target = +timestamp,
				untils = this.untils,
				i;

			for (i = 0; i < untils.length; i++) {
				if (target < untils[i]) {
					return i;
				}
			}
		},

		countries : function () {
			var zone_name = this.name;
			return Object.keys(countries).filter(function (country_code) {
				return countries[country_code].zones.indexOf(zone_name) !== -1;
			});
		},

		parse : function (timestamp) {
			var target  = +timestamp,
				offsets = this.offsets,
				untils  = this.untils,
				max     = untils.length - 1,
				offset, offsetNext, offsetPrev, i;

			for (i = 0; i < max; i++) {
				offset     = offsets[i];
				offsetNext = offsets[i + 1];
				offsetPrev = offsets[i ? i - 1 : i];

				if (offset < offsetNext && tz.moveAmbiguousForward) {
					offset = offsetNext;
				} else if (offset > offsetPrev && tz.moveInvalidForward) {
					offset = offsetPrev;
				}

				if (target < untils[i] - (offset * 60000)) {
					return offsets[i];
				}
			}

			return offsets[max];
		},

		abbr : function (mom) {
			return this.abbrs[this._index(mom)];
		},

		offset : function (mom) {
			logError("zone.offset has been deprecated in favor of zone.utcOffset");
			return this.offsets[this._index(mom)];
		},

		utcOffset : function (mom) {
			return this.offsets[this._index(mom)];
		}
	};

	/************************************
		Country object
	************************************/

	function Country (country_name, zone_names) {
		this.name = country_name;
		this.zones = zone_names;
	}

	/************************************
		Current Timezone
	************************************/

	function OffsetAt(at) {
		var timeString = at.toTimeString();
		var abbr = timeString.match(/\([a-z ]+\)/i);
		if (abbr && abbr[0]) {
			// 17:56:31 GMT-0600 (CST)
			// 17:56:31 GMT-0600 (Central Standard Time)
			abbr = abbr[0].match(/[A-Z]/g);
			abbr = abbr ? abbr.join('') : undefined;
		} else {
			// 17:56:31 CST
			// 17:56:31 GMT+0800 (台北標準時間)
			abbr = timeString.match(/[A-Z]{3,5}/g);
			abbr = abbr ? abbr[0] : undefined;
		}

		if (abbr === 'GMT') {
			abbr = undefined;
		}

		this.at = +at;
		this.abbr = abbr;
		this.offset = at.getTimezoneOffset();
	}

	function ZoneScore(zone) {
		this.zone = zone;
		this.offsetScore = 0;
		this.abbrScore = 0;
	}

	ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
		this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
		if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
			this.abbrScore++;
		}
	};

	function findChange(low, high) {
		var mid, diff;

		while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
			mid = new OffsetAt(new Date(low.at + diff));
			if (mid.offset === low.offset) {
				low = mid;
			} else {
				high = mid;
			}
		}

		return low;
	}

	function userOffsets() {
		var startYear = new Date().getFullYear() - 2,
			last = new OffsetAt(new Date(startYear, 0, 1)),
			offsets = [last],
			change, next, i;

		for (i = 1; i < 48; i++) {
			next = new OffsetAt(new Date(startYear, i, 1));
			if (next.offset !== last.offset) {
				change = findChange(last, next);
				offsets.push(change);
				offsets.push(new OffsetAt(new Date(change.at + 6e4)));
			}
			last = next;
		}

		for (i = 0; i < 4; i++) {
			offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
			offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
		}

		return offsets;
	}

	function sortZoneScores (a, b) {
		if (a.offsetScore !== b.offsetScore) {
			return a.offsetScore - b.offsetScore;
		}
		if (a.abbrScore !== b.abbrScore) {
			return a.abbrScore - b.abbrScore;
		}
		if (a.zone.population !== b.zone.population) {
			return b.zone.population - a.zone.population;
		}
		return b.zone.name.localeCompare(a.zone.name);
	}

	function addToGuesses (name, offsets) {
		var i, offset;
		arrayToInt(offsets);
		for (i = 0; i < offsets.length; i++) {
			offset = offsets[i];
			guesses[offset] = guesses[offset] || {};
			guesses[offset][name] = true;
		}
	}

	function guessesForUserOffsets (offsets) {
		var offsetsLength = offsets.length,
			filteredGuesses = {},
			out = [],
			i, j, guessesOffset;

		for (i = 0; i < offsetsLength; i++) {
			guessesOffset = guesses[offsets[i].offset] || {};
			for (j in guessesOffset) {
				if (guessesOffset.hasOwnProperty(j)) {
					filteredGuesses[j] = true;
				}
			}
		}

		for (i in filteredGuesses) {
			if (filteredGuesses.hasOwnProperty(i)) {
				out.push(names[i]);
			}
		}

		return out;
	}

	function rebuildGuess () {

		// use Intl API when available and returning valid time zone
		try {
			var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
			if (intlName && intlName.length > 3) {
				var name = names[normalizeName(intlName)];
				if (name) {
					return name;
				}
				logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
			}
		} catch (e) {
			// Intl unavailable, fall back to manual guessing.
		}

		var offsets = userOffsets(),
			offsetsLength = offsets.length,
			guesses = guessesForUserOffsets(offsets),
			zoneScores = [],
			zoneScore, i, j;

		for (i = 0; i < guesses.length; i++) {
			zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
			for (j = 0; j < offsetsLength; j++) {
				zoneScore.scoreOffsetAt(offsets[j]);
			}
			zoneScores.push(zoneScore);
		}

		zoneScores.sort(sortZoneScores);

		return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
	}

	function guess (ignoreCache) {
		if (!cachedGuess || ignoreCache) {
			cachedGuess = rebuildGuess();
		}
		return cachedGuess;
	}

	/************************************
		Global Methods
	************************************/

	function normalizeName (name) {
		return (name || '').toLowerCase().replace(/\//g, '_');
	}

	function addZone (packed) {
		var i, name, split, normalized;

		if (typeof packed === "string") {
			packed = [packed];
		}

		for (i = 0; i < packed.length; i++) {
			split = packed[i].split('|');
			name = split[0];
			normalized = normalizeName(name);
			zones[normalized] = packed[i];
			names[normalized] = name;
			addToGuesses(normalized, split[2].split(' '));
		}
	}

	function getZone (name, caller) {

		name = normalizeName(name);

		var zone = zones[name];
		var link;

		if (zone instanceof Zone) {
			return zone;
		}

		if (typeof zone === 'string') {
			zone = new Zone(zone);
			zones[name] = zone;
			return zone;
		}

		// Pass getZone to prevent recursion more than 1 level deep
		if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
			zone = zones[name] = new Zone();
			zone._set(link);
			zone.name = names[name];
			return zone;
		}

		return null;
	}

	function getNames () {
		var i, out = [];

		for (i in names) {
			if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
				out.push(names[i]);
			}
		}

		return out.sort();
	}

	function getCountryNames () {
		return Object.keys(countries);
	}

	function addLink (aliases) {
		var i, alias, normal0, normal1;

		if (typeof aliases === "string") {
			aliases = [aliases];
		}

		for (i = 0; i < aliases.length; i++) {
			alias = aliases[i].split('|');

			normal0 = normalizeName(alias[0]);
			normal1 = normalizeName(alias[1]);

			links[normal0] = normal1;
			names[normal0] = alias[0];

			links[normal1] = normal0;
			names[normal1] = alias[1];
		}
	}

	function addCountries (data) {
		var i, country_code, country_zones, split;
		if (!data || !data.length) return;
		for (i = 0; i < data.length; i++) {
			split = data[i].split('|');
			country_code = split[0].toUpperCase();
			country_zones = split[1].split(' ');
			countries[country_code] = new Country(
				country_code,
				country_zones
			);
		}
	}

	function getCountry (name) {
		name = name.toUpperCase();
		return countries[name] || null;
	}

	function zonesForCountry(country, with_offset) {
		country = getCountry(country);

		if (!country) return null;

		var zones = country.zones.sort();

		if (with_offset) {
			return zones.map(function (zone_name) {
				var zone = getZone(zone_name);
				return {
					name: zone_name,
					offset: zone.utcOffset(new Date())
				};
			});
		}

		return zones;
	}

	function loadData (data) {
		addZone(data.zones);
		addLink(data.links);
		addCountries(data.countries);
		tz.dataVersion = data.version;
	}

	function zoneExists (name) {
		if (!zoneExists.didShowError) {
			zoneExists.didShowError = true;
				logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
		}
		return !!getZone(name);
	}

	function needsOffset (m) {
		var isUnixTimestamp = (m._f === 'X' || m._f === 'x');
		return !!(m._a && (m._tzm === undefined) && !isUnixTimestamp);
	}

	function logError (message) {
		if (typeof console !== 'undefined' && typeof console.error === 'function') {
			console.error(message);
		}
	}

	/************************************
		moment.tz namespace
	************************************/

	function tz (input) {
		var args = Array.prototype.slice.call(arguments, 0, -1),
			name = arguments[arguments.length - 1],
			zone = getZone(name),
			out  = moment.utc.apply(null, args);

		if (zone && !moment.isMoment(input) && needsOffset(out)) {
			out.add(zone.parse(out), 'minutes');
		}

		out.tz(name);

		return out;
	}

	tz.version      = VERSION;
	tz.dataVersion  = '';
	tz._zones       = zones;
	tz._links       = links;
	tz._names       = names;
	tz._countries	= countries;
	tz.add          = addZone;
	tz.link         = addLink;
	tz.load         = loadData;
	tz.zone         = getZone;
	tz.zoneExists   = zoneExists; // deprecated in 0.1.0
	tz.guess        = guess;
	tz.names        = getNames;
	tz.Zone         = Zone;
	tz.unpack       = unpack;
	tz.unpackBase60 = unpackBase60;
	tz.needsOffset  = needsOffset;
	tz.moveInvalidForward   = true;
	tz.moveAmbiguousForward = false;
	tz.countries    = getCountryNames;
	tz.zonesForCountry = zonesForCountry;

	/************************************
		Interface with Moment.js
	************************************/

	var fn = moment.fn;

	moment.tz = tz;

	moment.defaultZone = null;

	moment.updateOffset = function (mom, keepTime) {
		var zone = moment.defaultZone,
			offset;

		if (mom._z === undefined) {
			if (zone && needsOffset(mom) && !mom._isUTC) {
				mom._d = moment.utc(mom._a)._d;
				mom.utc().add(zone.parse(mom), 'minutes');
			}
			mom._z = zone;
		}
		if (mom._z) {
			offset = mom._z.utcOffset(mom);
			if (Math.abs(offset) < 16) {
				offset = offset / 60;
			}
			if (mom.utcOffset !== undefined) {
				var z = mom._z;
				mom.utcOffset(-offset, keepTime);
				mom._z = z;
			} else {
				mom.zone(offset, keepTime);
			}
		}
	};

	fn.tz = function (name, keepTime) {
		if (name) {
			if (typeof name !== 'string') {
				throw new Error('Time zone name must be a string, got ' + name + ' [' + typeof name + ']');
			}
			this._z = getZone(name);
			if (this._z) {
				moment.updateOffset(this, keepTime);
			} else {
				logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
			}
			return this;
		}
		if (this._z) { return this._z.name; }
	};

	function abbrWrap (old) {
		return function () {
			if (this._z) { return this._z.abbr(this); }
			return old.call(this);
		};
	}

	function resetZoneWrap (old) {
		return function () {
			this._z = null;
			return old.apply(this, arguments);
		};
	}

	function resetZoneWrap2 (old) {
		return function () {
			if (arguments.length > 0) this._z = null;
			return old.apply(this, arguments);
		};
	}

	fn.zoneName  = abbrWrap(fn.zoneName);
	fn.zoneAbbr  = abbrWrap(fn.zoneAbbr);
	fn.utc       = resetZoneWrap(fn.utc);
	fn.local     = resetZoneWrap(fn.local);
	fn.utcOffset = resetZoneWrap2(fn.utcOffset);

	moment.tz.setDefault = function(name) {
		if (major < 2 || (major === 2 && minor < 9)) {
			logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
		}
		moment.defaultZone = name ? getZone(name) : null;
		return moment;
	};

	// Cloning a moment should include the _z property.
	var momentProperties = moment.momentProperties;
	if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
		// moment 2.8.1+
		momentProperties.push('_z');
		momentProperties.push('_a');
	} else if (momentProperties) {
		// moment 2.7.0
		momentProperties._z = null;
	}

	// INJECT DATA

	return moment;
}));

},{"moment":"moment"}],1166:[function(require,module,exports){
!function(e,a){"object"==typeof exports&&"undefined"!=typeof module&&"function"==typeof require?a(require("../moment")):"function"==typeof define&&define.amd?define(["../moment"],a):a(e.moment)}(this,function(e){"use strict";e.defineLocale("af",{months:"Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember".split("_"),monthsShort:"Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des".split("_"),weekdays:"Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag".split("_"),weekdaysShort:"Son_Maa_Din_Woe_Don_Vry_Sat".split("_"),weekdaysMin:"So_Ma_Di_Wo_Do_Vr_Sa".split("_"),meridiemParse:/vm|nm/i,isPM:function(e){return/^nm$/i.test(e)},meridiem:function(e,a,_){return e<12?_?"vm":"VM":_?"nm":"NM"},longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Vandag om] LT",nextDay:"[M\xf4re om] LT",nextWeek:"dddd [om] LT",lastDay:"[Gister om] LT",lastWeek:"[Laas] dddd [om] LT",sameElse:"L"},relativeTime:{future:"oor %s",past:"%s gelede",s:"'n paar sekondes",ss:"%d sekondes",m:"'n minuut",mm:"%d minute",h:"'n uur",hh:"%d ure",d:"'n dag",dd:"%d dae",M:"'n maand",MM:"%d maande",y:"'n jaar",yy:"%d jaar"},dayOfMonthOrdinalParse:/\d{1,2}(ste|de)/,ordinal:function(e){return e+(1===e||8===e||20<=e?"ste":"de")},week:{dow:1,doy:4}});function E(e){return 0===e?0:1===e?1:2===e?2:3<=e%100&&e%100<=10?3:11<=e%100?4:5}function a(n){return function(e,a,_,s){var d=E(e),t=J[n][E(e)];return(t=2===d?t[a?0:1]:t).replace(/%d/i,e)}}function F(e){return 0===e?0:1===e?1:2===e?2:3<=e%100&&e%100<=10?3:11<=e%100?4:5}function _(n){return function(e,a,_,s){var d=F(e),t=N[n][F(e)];return(t=2===d?t[a?0:1]:t).replace(/%d/i,e)}}function z(e){return 0===e?0:1===e?1:2===e?2:3<=e%100&&e%100<=10?3:11<=e%100?4:5}function s(n){return function(e,a,_,s){var d=z(e),t=B[n][z(e)];return(t=2===d?t[a?0:1]:t).replace(/%d/i,e)}}var J={s:["\u0623\u0642\u0644 \u0645\u0646 \u062b\u0627\u0646\u064a\u0629","\u062b\u0627\u0646\u064a\u0629 \u0648\u0627\u062d\u062f\u0629",["\u062b\u0627\u0646\u064a\u062a\u0627\u0646","\u062b\u0627\u0646\u064a\u062a\u064a\u0646"],"%d \u062b\u0648\u0627\u0646","%d \u062b\u0627\u0646\u064a\u0629","%d \u062b\u0627\u0646\u064a\u0629"],m:["\u0623\u0642\u0644 \u0645\u0646 \u062f\u0642\u064a\u0642\u0629","\u062f\u0642\u064a\u0642\u0629 \u0648\u0627\u062d\u062f\u0629",["\u062f\u0642\u064a\u0642\u062a\u0627\u0646","\u062f\u0642\u064a\u0642\u062a\u064a\u0646"],"%d \u062f\u0642\u0627\u0626\u0642","%d \u062f\u0642\u064a\u0642\u0629","%d \u062f\u0642\u064a\u0642\u0629"],h:["\u0623\u0642\u0644 \u0645\u0646 \u0633\u0627\u0639\u0629","\u0633\u0627\u0639\u0629 \u0648\u0627\u062d\u062f\u0629",["\u0633\u0627\u0639\u062a\u0627\u0646","\u0633\u0627\u0639\u062a\u064a\u0646"],"%d \u0633\u0627\u0639\u0627\u062a","%d \u0633\u0627\u0639\u0629","%d \u0633\u0627\u0639\u0629"],d:["\u0623\u0642\u0644 \u0645\u0646 \u064a\u0648\u0645","\u064a\u0648\u0645 \u0648\u0627\u062d\u062f",["\u064a\u0648\u0645\u0627\u0646","\u064a\u0648\u0645\u064a\u0646"],"%d \u0623\u064a\u0627\u0645","%d \u064a\u0648\u0645\u064b\u0627","%d \u064a\u0648\u0645"],M:["\u0623\u0642\u0644 \u0645\u0646 \u0634\u0647\u0631","\u0634\u0647\u0631 \u0648\u0627\u062d\u062f",["\u0634\u0647\u0631\u0627\u0646","\u0634\u0647\u0631\u064a\u0646"],"%d \u0623\u0634\u0647\u0631","%d \u0634\u0647\u0631\u0627","%d \u0634\u0647\u0631"],y:["\u0623\u0642\u0644 \u0645\u0646 \u0639\u0627\u0645","\u0639\u0627\u0645 \u0648\u0627\u062d\u062f",["\u0639\u0627\u0645\u0627\u0646","\u0639\u0627\u0645\u064a\u0646"],"%d \u0623\u0639\u0648\u0627\u0645","%d \u0639\u0627\u0645\u064b\u0627","%d \u0639\u0627\u0645"]},d=["\u062c\u0627\u0646\u0641\u064a","\u0641\u064a\u0641\u0631\u064a","\u0645\u0627\u0631\u0633","\u0623\u0641\u0631\u064a\u0644","\u0645\u0627\u064a","\u062c\u0648\u0627\u0646","\u062c\u0648\u064a\u0644\u064a\u0629","\u0623\u0648\u062a","\u0633\u0628\u062a\u0645\u0628\u0631","\u0623\u0643\u062a\u0648\u0628\u0631","\u0646\u0648\u0641\u0645\u0628\u0631","\u062f\u064a\u0633\u0645\u0628\u0631"],I=(e.defineLocale("ar-dz",{months:d,monthsShort:d,weekdays:"\u0627\u0644\u0623\u062d\u062f_\u0627\u0644\u0625\u062b\u0646\u064a\u0646_\u0627\u0644\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062e\u0645\u064a\u0633_\u0627\u0644\u062c\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062a".split("_"),weekdaysShort:"\u0623\u062d\u062f_\u0625\u062b\u0646\u064a\u0646_\u062b\u0644\u0627\u062b\u0627\u0621_\u0623\u0631\u0628\u0639\u0627\u0621_\u062e\u0645\u064a\u0633_\u062c\u0645\u0639\u0629_\u0633\u0628\u062a".split("_"),weekdaysMin:"\u062d_\u0646_\u062b_\u0631_\u062e_\u062c_\u0633".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"D/\u200fM/\u200fYYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},meridiemParse:/\u0635|\u0645/,isPM:function(e){return"\u0645"===e},meridiem:function(e,a,_){return e<12?"\u0635":"\u0645"},calendar:{sameDay:"[\u0627\u0644\u064a\u0648\u0645 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextDay:"[\u063a\u062f\u064b\u0627 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextWeek:"dddd [\u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastDay:"[\u0623\u0645\u0633 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastWeek:"dddd [\u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",sameElse:"L"},relativeTime:{future:"\u0628\u0639\u062f %s",past:"\u0645\u0646\u0630 %s",s:a("s"),ss:a("s"),m:a("m"),mm:a("m"),h:a("h"),hh:a("h"),d:a("d"),dd:a("d"),M:a("M"),MM:a("M"),y:a("y"),yy:a("y")},postformat:function(e){return e.replace(/,/g,"\u060c")},week:{dow:0,doy:4}}),e.defineLocale("ar-kw",{months:"\u064a\u0646\u0627\u064a\u0631_\u0641\u0628\u0631\u0627\u064a\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064a\u0644_\u0645\u0627\u064a_\u064a\u0648\u0646\u064a\u0648_\u064a\u0648\u0644\u064a\u0648\u0632_\u063a\u0634\u062a_\u0634\u062a\u0646\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0646\u0628\u0631_\u062f\u062c\u0646\u0628\u0631".split("_"),monthsShort:"\u064a\u0646\u0627\u064a\u0631_\u0641\u0628\u0631\u0627\u064a\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064a\u0644_\u0645\u0627\u064a_\u064a\u0648\u0646\u064a\u0648_\u064a\u0648\u0644\u064a\u0648\u0632_\u063a\u0634\u062a_\u0634\u062a\u0646\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0646\u0628\u0631_\u062f\u062c\u0646\u0628\u0631".split("_"),weekdays:"\u0627\u0644\u0623\u062d\u062f_\u0627\u0644\u0625\u062a\u0646\u064a\u0646_\u0627\u0644\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062e\u0645\u064a\u0633_\u0627\u0644\u062c\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062a".split("_"),weekdaysShort:"\u0627\u062d\u062f_\u0627\u062a\u0646\u064a\u0646_\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0631\u0628\u0639\u0627\u0621_\u062e\u0645\u064a\u0633_\u062c\u0645\u0639\u0629_\u0633\u0628\u062a".split("_"),weekdaysMin:"\u062d_\u0646_\u062b_\u0631_\u062e_\u062c_\u0633".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[\u0627\u0644\u064a\u0648\u0645 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextDay:"[\u063a\u062f\u0627 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextWeek:"dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastDay:"[\u0623\u0645\u0633 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastWeek:"dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",sameElse:"L"},relativeTime:{future:"\u0641\u064a %s",past:"\u0645\u0646\u0630 %s",s:"\u062b\u0648\u0627\u0646",ss:"%d \u062b\u0627\u0646\u064a\u0629",m:"\u062f\u0642\u064a\u0642\u0629",mm:"%d \u062f\u0642\u0627\u0626\u0642",h:"\u0633\u0627\u0639\u0629",hh:"%d \u0633\u0627\u0639\u0627\u062a",d:"\u064a\u0648\u0645",dd:"%d \u0623\u064a\u0627\u0645",M:"\u0634\u0647\u0631",MM:"%d \u0623\u0634\u0647\u0631",y:"\u0633\u0646\u0629",yy:"%d \u0633\u0646\u0648\u0627\u062a"},week:{dow:0,doy:12}}),{1:"1",2:"2",3:"3",4:"4",5:"5",6:"6",7:"7",8:"8",9:"9",0:"0"}),N={s:["\u0623\u0642\u0644 \u0645\u0646 \u062b\u0627\u0646\u064a\u0629","\u062b\u0627\u0646\u064a\u0629 \u0648\u0627\u062d\u062f\u0629",["\u062b\u0627\u0646\u064a\u062a\u0627\u0646","\u062b\u0627\u0646\u064a\u062a\u064a\u0646"],"%d \u062b\u0648\u0627\u0646","%d \u062b\u0627\u0646\u064a\u0629","%d \u062b\u0627\u0646\u064a\u0629"],m:["\u0623\u0642\u0644 \u0645\u0646 \u062f\u0642\u064a\u0642\u0629","\u062f\u0642\u064a\u0642\u0629 \u0648\u0627\u062d\u062f\u0629",["\u062f\u0642\u064a\u0642\u062a\u0627\u0646","\u062f\u0642\u064a\u0642\u062a\u064a\u0646"],"%d \u062f\u0642\u0627\u0626\u0642","%d \u062f\u0642\u064a\u0642\u0629","%d \u062f\u0642\u064a\u0642\u0629"],h:["\u0623\u0642\u0644 \u0645\u0646 \u0633\u0627\u0639\u0629","\u0633\u0627\u0639\u0629 \u0648\u0627\u062d\u062f\u0629",["\u0633\u0627\u0639\u062a\u0627\u0646","\u0633\u0627\u0639\u062a\u064a\u0646"],"%d \u0633\u0627\u0639\u0627\u062a","%d \u0633\u0627\u0639\u0629","%d \u0633\u0627\u0639\u0629"],d:["\u0623\u0642\u0644 \u0645\u0646 \u064a\u0648\u0645","\u064a\u0648\u0645 \u0648\u0627\u062d\u062f",["\u064a\u0648\u0645\u0627\u0646","\u064a\u0648\u0645\u064a\u0646"],"%d \u0623\u064a\u0627\u0645","%d \u064a\u0648\u0645\u064b\u0627","%d \u064a\u0648\u0645"],M:["\u0623\u0642\u0644 \u0645\u0646 \u0634\u0647\u0631","\u0634\u0647\u0631 \u0648\u0627\u062d\u062f",["\u0634\u0647\u0631\u0627\u0646","\u0634\u0647\u0631\u064a\u0646"],"%d \u0623\u0634\u0647\u0631","%d \u0634\u0647\u0631\u0627","%d \u0634\u0647\u0631"],y:["\u0623\u0642\u0644 \u0645\u0646 \u0639\u0627\u0645","\u0639\u0627\u0645 \u0648\u0627\u062d\u062f",["\u0639\u0627\u0645\u0627\u0646","\u0639\u0627\u0645\u064a\u0646"],"%d \u0623\u0639\u0648\u0627\u0645","%d \u0639\u0627\u0645\u064b\u0627","%d \u0639\u0627\u0645"]},d=["\u064a\u0646\u0627\u064a\u0631","\u0641\u0628\u0631\u0627\u064a\u0631","\u0645\u0627\u0631\u0633","\u0623\u0628\u0631\u064a\u0644","\u0645\u0627\u064a\u0648","\u064a\u0648\u0646\u064a\u0648","\u064a\u0648\u0644\u064a\u0648","\u0623\u063a\u0633\u0637\u0633","\u0633\u0628\u062a\u0645\u0628\u0631","\u0623\u0643\u062a\u0648\u0628\u0631","\u0646\u0648\u0641\u0645\u0628\u0631","\u062f\u064a\u0633\u0645\u0628\u0631"],R=(e.defineLocale("ar-ly",{months:d,monthsShort:d,weekdays:"\u0627\u0644\u0623\u062d\u062f_\u0627\u0644\u0625\u062b\u0646\u064a\u0646_\u0627\u0644\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062e\u0645\u064a\u0633_\u0627\u0644\u062c\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062a".split("_"),weekdaysShort:"\u0623\u062d\u062f_\u0625\u062b\u0646\u064a\u0646_\u062b\u0644\u0627\u062b\u0627\u0621_\u0623\u0631\u0628\u0639\u0627\u0621_\u062e\u0645\u064a\u0633_\u062c\u0645\u0639\u0629_\u0633\u0628\u062a".split("_"),weekdaysMin:"\u062d_\u0646_\u062b_\u0631_\u062e_\u062c_\u0633".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"D/\u200fM/\u200fYYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},meridiemParse:/\u0635|\u0645/,isPM:function(e){return"\u0645"===e},meridiem:function(e,a,_){return e<12?"\u0635":"\u0645"},calendar:{sameDay:"[\u0627\u0644\u064a\u0648\u0645 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextDay:"[\u063a\u062f\u064b\u0627 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextWeek:"dddd [\u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastDay:"[\u0623\u0645\u0633 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastWeek:"dddd [\u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",sameElse:"L"},relativeTime:{future:"\u0628\u0639\u062f %s",past:"\u0645\u0646\u0630 %s",s:_("s"),ss:_("s"),m:_("m"),mm:_("m"),h:_("h"),hh:_("h"),d:_("d"),dd:_("d"),M:_("M"),MM:_("M"),y:_("y"),yy:_("y")},preparse:function(e){return e.replace(/\u060c/g,",")},postformat:function(e){return e.replace(/\d/g,function(e){return I[e]}).replace(/,/g,"\u060c")},week:{dow:6,doy:12}}),e.defineLocale("ar-ma",{months:"\u064a\u0646\u0627\u064a\u0631_\u0641\u0628\u0631\u0627\u064a\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064a\u0644_\u0645\u0627\u064a_\u064a\u0648\u0646\u064a\u0648_\u064a\u0648\u0644\u064a\u0648\u0632_\u063a\u0634\u062a_\u0634\u062a\u0646\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0646\u0628\u0631_\u062f\u062c\u0646\u0628\u0631".split("_"),monthsShort:"\u064a\u0646\u0627\u064a\u0631_\u0641\u0628\u0631\u0627\u064a\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064a\u0644_\u0645\u0627\u064a_\u064a\u0648\u0646\u064a\u0648_\u064a\u0648\u0644\u064a\u0648\u0632_\u063a\u0634\u062a_\u0634\u062a\u0646\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0646\u0628\u0631_\u062f\u062c\u0646\u0628\u0631".split("_"),weekdays:"\u0627\u0644\u0623\u062d\u062f_\u0627\u0644\u0625\u062b\u0646\u064a\u0646_\u0627\u0644\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062e\u0645\u064a\u0633_\u0627\u0644\u062c\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062a".split("_"),weekdaysShort:"\u0627\u062d\u062f_\u0627\u062b\u0646\u064a\u0646_\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0631\u0628\u0639\u0627\u0621_\u062e\u0645\u064a\u0633_\u062c\u0645\u0639\u0629_\u0633\u0628\u062a".split("_"),weekdaysMin:"\u062d_\u0646_\u062b_\u0631_\u062e_\u062c_\u0633".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[\u0627\u0644\u064a\u0648\u0645 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextDay:"[\u063a\u062f\u0627 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextWeek:"dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastDay:"[\u0623\u0645\u0633 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastWeek:"dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",sameElse:"L"},relativeTime:{future:"\u0641\u064a %s",past:"\u0645\u0646\u0630 %s",s:"\u062b\u0648\u0627\u0646",ss:"%d \u062b\u0627\u0646\u064a\u0629",m:"\u062f\u0642\u064a\u0642\u0629",mm:"%d \u062f\u0642\u0627\u0626\u0642",h:"\u0633\u0627\u0639\u0629",hh:"%d \u0633\u0627\u0639\u0627\u062a",d:"\u064a\u0648\u0645",dd:"%d \u0623\u064a\u0627\u0645",M:"\u0634\u0647\u0631",MM:"%d \u0623\u0634\u0647\u0631",y:"\u0633\u0646\u0629",yy:"%d \u0633\u0646\u0648\u0627\u062a"},week:{dow:1,doy:4}}),{1:"\u0661",2:"\u0662",3:"\u0663",4:"\u0664",5:"\u0665",6:"\u0666",7:"\u0667",8:"\u0668",9:"\u0669",0:"\u0660"}),C={"\u0661":"1","\u0662":"2","\u0663":"3","\u0664":"4","\u0665":"5","\u0666":"6","\u0667":"7","\u0668":"8","\u0669":"9","\u0660":"0"},K=(e.defineLocale("ar-sa",{months:"\u064a\u0646\u0627\u064a\u0631_\u0641\u0628\u0631\u0627\u064a\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064a\u0644_\u0645\u0627\u064a\u0648_\u064a\u0648\u0646\u064a\u0648_\u064a\u0648\u0644\u064a\u0648_\u0623\u063a\u0633\u0637\u0633_\u0633\u0628\u062a\u0645\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0641\u0645\u0628\u0631_\u062f\u064a\u0633\u0645\u0628\u0631".split("_"),monthsShort:"\u064a\u0646\u0627\u064a\u0631_\u0641\u0628\u0631\u0627\u064a\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064a\u0644_\u0645\u0627\u064a\u0648_\u064a\u0648\u0646\u064a\u0648_\u064a\u0648\u0644\u064a\u0648_\u0623\u063a\u0633\u0637\u0633_\u0633\u0628\u062a\u0645\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0641\u0645\u0628\u0631_\u062f\u064a\u0633\u0645\u0628\u0631".split("_"),weekdays:"\u0627\u0644\u0623\u062d\u062f_\u0627\u0644\u0625\u062b\u0646\u064a\u0646_\u0627\u0644\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062e\u0645\u064a\u0633_\u0627\u0644\u062c\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062a".split("_"),weekdaysShort:"\u0623\u062d\u062f_\u0625\u062b\u0646\u064a\u0646_\u062b\u0644\u0627\u062b\u0627\u0621_\u0623\u0631\u0628\u0639\u0627\u0621_\u062e\u0645\u064a\u0633_\u062c\u0645\u0639\u0629_\u0633\u0628\u062a".split("_"),weekdaysMin:"\u062d_\u0646_\u062b_\u0631_\u062e_\u062c_\u0633".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},meridiemParse:/\u0635|\u0645/,isPM:function(e){return"\u0645"===e},meridiem:function(e,a,_){return e<12?"\u0635":"\u0645"},calendar:{sameDay:"[\u0627\u0644\u064a\u0648\u0645 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextDay:"[\u063a\u062f\u0627 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextWeek:"dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastDay:"[\u0623\u0645\u0633 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastWeek:"dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",sameElse:"L"},relativeTime:{future:"\u0641\u064a %s",past:"\u0645\u0646\u0630 %s",s:"\u062b\u0648\u0627\u0646",ss:"%d \u062b\u0627\u0646\u064a\u0629",m:"\u062f\u0642\u064a\u0642\u0629",mm:"%d \u062f\u0642\u0627\u0626\u0642",h:"\u0633\u0627\u0639\u0629",hh:"%d \u0633\u0627\u0639\u0627\u062a",d:"\u064a\u0648\u0645",dd:"%d \u0623\u064a\u0627\u0645",M:"\u0634\u0647\u0631",MM:"%d \u0623\u0634\u0647\u0631",y:"\u0633\u0646\u0629",yy:"%d \u0633\u0646\u0648\u0627\u062a"},preparse:function(e){return e.replace(/[\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669\u0660]/g,function(e){return C[e]}).replace(/\u060c/g,",")},postformat:function(e){return e.replace(/\d/g,function(e){return R[e]}).replace(/,/g,"\u060c")},week:{dow:0,doy:6}}),e.defineLocale("ar-tn",{months:"\u062c\u0627\u0646\u0641\u064a_\u0641\u064a\u0641\u0631\u064a_\u0645\u0627\u0631\u0633_\u0623\u0641\u0631\u064a\u0644_\u0645\u0627\u064a_\u062c\u0648\u0627\u0646_\u062c\u0648\u064a\u0644\u064a\u0629_\u0623\u0648\u062a_\u0633\u0628\u062a\u0645\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0641\u0645\u0628\u0631_\u062f\u064a\u0633\u0645\u0628\u0631".split("_"),monthsShort:"\u062c\u0627\u0646\u0641\u064a_\u0641\u064a\u0641\u0631\u064a_\u0645\u0627\u0631\u0633_\u0623\u0641\u0631\u064a\u0644_\u0645\u0627\u064a_\u062c\u0648\u0627\u0646_\u062c\u0648\u064a\u0644\u064a\u0629_\u0623\u0648\u062a_\u0633\u0628\u062a\u0645\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0641\u0645\u0628\u0631_\u062f\u064a\u0633\u0645\u0628\u0631".split("_"),weekdays:"\u0627\u0644\u0623\u062d\u062f_\u0627\u0644\u0625\u062b\u0646\u064a\u0646_\u0627\u0644\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062e\u0645\u064a\u0633_\u0627\u0644\u062c\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062a".split("_"),weekdaysShort:"\u0623\u062d\u062f_\u0625\u062b\u0646\u064a\u0646_\u062b\u0644\u0627\u062b\u0627\u0621_\u0623\u0631\u0628\u0639\u0627\u0621_\u062e\u0645\u064a\u0633_\u062c\u0645\u0639\u0629_\u0633\u0628\u062a".split("_"),weekdaysMin:"\u062d_\u0646_\u062b_\u0631_\u062e_\u062c_\u0633".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[\u0627\u0644\u064a\u0648\u0645 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextDay:"[\u063a\u062f\u0627 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextWeek:"dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastDay:"[\u0623\u0645\u0633 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastWeek:"dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",sameElse:"L"},relativeTime:{future:"\u0641\u064a %s",past:"\u0645\u0646\u0630 %s",s:"\u062b\u0648\u0627\u0646",ss:"%d \u062b\u0627\u0646\u064a\u0629",m:"\u062f\u0642\u064a\u0642\u0629",mm:"%d \u062f\u0642\u0627\u0626\u0642",h:"\u0633\u0627\u0639\u0629",hh:"%d \u0633\u0627\u0639\u0627\u062a",d:"\u064a\u0648\u0645",dd:"%d \u0623\u064a\u0627\u0645",M:"\u0634\u0647\u0631",MM:"%d \u0623\u0634\u0647\u0631",y:"\u0633\u0646\u0629",yy:"%d \u0633\u0646\u0648\u0627\u062a"},week:{dow:1,doy:4}}),{1:"\u0661",2:"\u0662",3:"\u0663",4:"\u0664",5:"\u0665",6:"\u0666",7:"\u0667",8:"\u0668",9:"\u0669",0:"\u0660"}),G={"\u0661":"1","\u0662":"2","\u0663":"3","\u0664":"4","\u0665":"5","\u0666":"6","\u0667":"7","\u0668":"8","\u0669":"9","\u0660":"0"},B={s:["\u0623\u0642\u0644 \u0645\u0646 \u062b\u0627\u0646\u064a\u0629","\u062b\u0627\u0646\u064a\u0629 \u0648\u0627\u062d\u062f\u0629",["\u062b\u0627\u0646\u064a\u062a\u0627\u0646","\u062b\u0627\u0646\u064a\u062a\u064a\u0646"],"%d \u062b\u0648\u0627\u0646","%d \u062b\u0627\u0646\u064a\u0629","%d \u062b\u0627\u0646\u064a\u0629"],m:["\u0623\u0642\u0644 \u0645\u0646 \u062f\u0642\u064a\u0642\u0629","\u062f\u0642\u064a\u0642\u0629 \u0648\u0627\u062d\u062f\u0629",["\u062f\u0642\u064a\u0642\u062a\u0627\u0646","\u062f\u0642\u064a\u0642\u062a\u064a\u0646"],"%d \u062f\u0642\u0627\u0626\u0642","%d \u062f\u0642\u064a\u0642\u0629","%d \u062f\u0642\u064a\u0642\u0629"],h:["\u0623\u0642\u0644 \u0645\u0646 \u0633\u0627\u0639\u0629","\u0633\u0627\u0639\u0629 \u0648\u0627\u062d\u062f\u0629",["\u0633\u0627\u0639\u062a\u0627\u0646","\u0633\u0627\u0639\u062a\u064a\u0646"],"%d \u0633\u0627\u0639\u0627\u062a","%d \u0633\u0627\u0639\u0629","%d \u0633\u0627\u0639\u0629"],d:["\u0623\u0642\u0644 \u0645\u0646 \u064a\u0648\u0645","\u064a\u0648\u0645 \u0648\u0627\u062d\u062f",["\u064a\u0648\u0645\u0627\u0646","\u064a\u0648\u0645\u064a\u0646"],"%d \u0623\u064a\u0627\u0645","%d \u064a\u0648\u0645\u064b\u0627","%d \u064a\u0648\u0645"],M:["\u0623\u0642\u0644 \u0645\u0646 \u0634\u0647\u0631","\u0634\u0647\u0631 \u0648\u0627\u062d\u062f",["\u0634\u0647\u0631\u0627\u0646","\u0634\u0647\u0631\u064a\u0646"],"%d \u0623\u0634\u0647\u0631","%d \u0634\u0647\u0631\u0627","%d \u0634\u0647\u0631"],y:["\u0623\u0642\u0644 \u0645\u0646 \u0639\u0627\u0645","\u0639\u0627\u0645 \u0648\u0627\u062d\u062f",["\u0639\u0627\u0645\u0627\u0646","\u0639\u0627\u0645\u064a\u0646"],"%d \u0623\u0639\u0648\u0627\u0645","%d \u0639\u0627\u0645\u064b\u0627","%d \u0639\u0627\u0645"]},d=["\u064a\u0646\u0627\u064a\u0631","\u0641\u0628\u0631\u0627\u064a\u0631","\u0645\u0627\u0631\u0633","\u0623\u0628\u0631\u064a\u0644","\u0645\u0627\u064a\u0648","\u064a\u0648\u0646\u064a\u0648","\u064a\u0648\u0644\u064a\u0648","\u0623\u063a\u0633\u0637\u0633","\u0633\u0628\u062a\u0645\u0628\u0631","\u0623\u0643\u062a\u0648\u0628\u0631","\u0646\u0648\u0641\u0645\u0628\u0631","\u062f\u064a\u0633\u0645\u0628\u0631"],q=(e.defineLocale("ar",{months:d,monthsShort:d,weekdays:"\u0627\u0644\u0623\u062d\u062f_\u0627\u0644\u0625\u062b\u0646\u064a\u0646_\u0627\u0644\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062e\u0645\u064a\u0633_\u0627\u0644\u062c\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062a".split("_"),weekdaysShort:"\u0623\u062d\u062f_\u0625\u062b\u0646\u064a\u0646_\u062b\u0644\u0627\u062b\u0627\u0621_\u0623\u0631\u0628\u0639\u0627\u0621_\u062e\u0645\u064a\u0633_\u062c\u0645\u0639\u0629_\u0633\u0628\u062a".split("_"),weekdaysMin:"\u062d_\u0646_\u062b_\u0631_\u062e_\u062c_\u0633".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"D/\u200fM/\u200fYYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},meridiemParse:/\u0635|\u0645/,isPM:function(e){return"\u0645"===e},meridiem:function(e,a,_){return e<12?"\u0635":"\u0645"},calendar:{sameDay:"[\u0627\u0644\u064a\u0648\u0645 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextDay:"[\u063a\u062f\u064b\u0627 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",nextWeek:"dddd [\u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastDay:"[\u0623\u0645\u0633 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",lastWeek:"dddd [\u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",sameElse:"L"},relativeTime:{future:"\u0628\u0639\u062f %s",past:"\u0645\u0646\u0630 %s",s:s("s"),ss:s("s"),m:s("m"),mm:s("m"),h:s("h"),hh:s("h"),d:s("d"),dd:s("d"),M:s("M"),MM:s("M"),y:s("y"),yy:s("y")},preparse:function(e){return e.replace(/[\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669\u0660]/g,function(e){return G[e]}).replace(/\u060c/g,",")},postformat:function(e){return e.replace(/\d/g,function(e){return K[e]}).replace(/,/g,"\u060c")},week:{dow:6,doy:12}}),{1:"-inci",5:"-inci",8:"-inci",70:"-inci",80:"-inci",2:"-nci",7:"-nci",20:"-nci",50:"-nci",3:"-\xfcnc\xfc",4:"-\xfcnc\xfc",100:"-\xfcnc\xfc",6:"-nc\u0131",9:"-uncu",10:"-uncu",30:"-uncu",60:"-\u0131nc\u0131",90:"-\u0131nc\u0131"});function t(e,a,_){return"m"===_?a?"\u0445\u0432\u0456\u043b\u0456\u043d\u0430":"\u0445\u0432\u0456\u043b\u0456\u043d\u0443":"h"===_?a?"\u0433\u0430\u0434\u0437\u0456\u043d\u0430":"\u0433\u0430\u0434\u0437\u0456\u043d\u0443":e+" "+(e=+e,a=(a={ss:a?"\u0441\u0435\u043a\u0443\u043d\u0434\u0430_\u0441\u0435\u043a\u0443\u043d\u0434\u044b_\u0441\u0435\u043a\u0443\u043d\u0434":"\u0441\u0435\u043a\u0443\u043d\u0434\u0443_\u0441\u0435\u043a\u0443\u043d\u0434\u044b_\u0441\u0435\u043a\u0443\u043d\u0434",mm:a?"\u0445\u0432\u0456\u043b\u0456\u043d\u0430_\u0445\u0432\u0456\u043b\u0456\u043d\u044b_\u0445\u0432\u0456\u043b\u0456\u043d":"\u0445\u0432\u0456\u043b\u0456\u043d\u0443_\u0445\u0432\u0456\u043b\u0456\u043d\u044b_\u0445\u0432\u0456\u043b\u0456\u043d",hh:a?"\u0433\u0430\u0434\u0437\u0456\u043d\u0430_\u0433\u0430\u0434\u0437\u0456\u043d\u044b_\u0433\u0430\u0434\u0437\u0456\u043d":"\u0433\u0430\u0434\u0437\u0456\u043d\u0443_\u0433\u0430\u0434\u0437\u0456\u043d\u044b_\u0433\u0430\u0434\u0437\u0456\u043d",dd:"\u0434\u0437\u0435\u043d\u044c_\u0434\u043d\u0456_\u0434\u0437\u0451\u043d",MM:"\u043c\u0435\u0441\u044f\u0446_\u043c\u0435\u0441\u044f\u0446\u044b_\u043c\u0435\u0441\u044f\u0446\u0430\u045e",yy:"\u0433\u043e\u0434_\u0433\u0430\u0434\u044b_\u0433\u0430\u0434\u043e\u045e"}[_]).split("_"),e%10==1&&e%100!=11?a[0]:2<=e%10&&e%10<=4&&(e%100<10||20<=e%100)?a[1]:a[2])}e.defineLocale("az",{months:"yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr".split("_"),monthsShort:"yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek".split("_"),weekdays:"Bazar_Bazar ert\u0259si_\xc7\u0259r\u015f\u0259nb\u0259 ax\u015fam\u0131_\xc7\u0259r\u015f\u0259nb\u0259_C\xfcm\u0259 ax\u015fam\u0131_C\xfcm\u0259_\u015e\u0259nb\u0259".split("_"),weekdaysShort:"Baz_BzE_\xc7Ax_\xc7\u0259r_CAx_C\xfcm_\u015e\u0259n".split("_"),weekdaysMin:"Bz_BE_\xc7A_\xc7\u0259_CA_C\xfc_\u015e\u0259".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[bug\xfcn saat] LT",nextDay:"[sabah saat] LT",nextWeek:"[g\u0259l\u0259n h\u0259ft\u0259] dddd [saat] LT",lastDay:"[d\xfcn\u0259n] LT",lastWeek:"[ke\xe7\u0259n h\u0259ft\u0259] dddd [saat] LT",sameElse:"L"},relativeTime:{future:"%s sonra",past:"%s \u0259vv\u0259l",s:"bir ne\xe7\u0259 saniy\u0259",ss:"%d saniy\u0259",m:"bir d\u0259qiq\u0259",mm:"%d d\u0259qiq\u0259",h:"bir saat",hh:"%d saat",d:"bir g\xfcn",dd:"%d g\xfcn",M:"bir ay",MM:"%d ay",y:"bir il",yy:"%d il"},meridiemParse:/gec\u0259|s\u0259h\u0259r|g\xfcnd\xfcz|ax\u015fam/,isPM:function(e){return/^(g\xfcnd\xfcz|ax\u015fam)$/.test(e)},meridiem:function(e,a,_){return e<4?"gec\u0259":e<12?"s\u0259h\u0259r":e<17?"g\xfcnd\xfcz":"ax\u015fam"},dayOfMonthOrdinalParse:/\d{1,2}-(\u0131nc\u0131|inci|nci|\xfcnc\xfc|nc\u0131|uncu)/,ordinal:function(e){if(0===e)return e+"-\u0131nc\u0131";var a=e%10;return e+(q[a]||q[e%100-a]||q[100<=e?100:null])},week:{dow:1,doy:7}}),e.defineLocale("be",{months:{format:"\u0441\u0442\u0443\u0434\u0437\u0435\u043d\u044f_\u043b\u044e\u0442\u0430\u0433\u0430_\u0441\u0430\u043a\u0430\u0432\u0456\u043a\u0430_\u043a\u0440\u0430\u0441\u0430\u0432\u0456\u043a\u0430_\u0442\u0440\u0430\u045e\u043d\u044f_\u0447\u044d\u0440\u0432\u0435\u043d\u044f_\u043b\u0456\u043f\u0435\u043d\u044f_\u0436\u043d\u0456\u045e\u043d\u044f_\u0432\u0435\u0440\u0430\u0441\u043d\u044f_\u043a\u0430\u0441\u0442\u0440\u044b\u0447\u043d\u0456\u043a\u0430_\u043b\u0456\u0441\u0442\u0430\u043f\u0430\u0434\u0430_\u0441\u043d\u0435\u0436\u043d\u044f".split("_"),standalone:"\u0441\u0442\u0443\u0434\u0437\u0435\u043d\u044c_\u043b\u044e\u0442\u044b_\u0441\u0430\u043a\u0430\u0432\u0456\u043a_\u043a\u0440\u0430\u0441\u0430\u0432\u0456\u043a_\u0442\u0440\u0430\u0432\u0435\u043d\u044c_\u0447\u044d\u0440\u0432\u0435\u043d\u044c_\u043b\u0456\u043f\u0435\u043d\u044c_\u0436\u043d\u0456\u0432\u0435\u043d\u044c_\u0432\u0435\u0440\u0430\u0441\u0435\u043d\u044c_\u043a\u0430\u0441\u0442\u0440\u044b\u0447\u043d\u0456\u043a_\u043b\u0456\u0441\u0442\u0430\u043f\u0430\u0434_\u0441\u043d\u0435\u0436\u0430\u043d\u044c".split("_")},monthsShort:"\u0441\u0442\u0443\u0434_\u043b\u044e\u0442_\u0441\u0430\u043a_\u043a\u0440\u0430\u0441_\u0442\u0440\u0430\u0432_\u0447\u044d\u0440\u0432_\u043b\u0456\u043f_\u0436\u043d\u0456\u0432_\u0432\u0435\u0440_\u043a\u0430\u0441\u0442_\u043b\u0456\u0441\u0442_\u0441\u043d\u0435\u0436".split("_"),weekdays:{format:"\u043d\u044f\u0434\u0437\u0435\u043b\u044e_\u043f\u0430\u043d\u044f\u0434\u0437\u0435\u043b\u0430\u043a_\u0430\u045e\u0442\u043e\u0440\u0430\u043a_\u0441\u0435\u0440\u0430\u0434\u0443_\u0447\u0430\u0446\u0432\u0435\u0440_\u043f\u044f\u0442\u043d\u0456\u0446\u0443_\u0441\u0443\u0431\u043e\u0442\u0443".split("_"),standalone:"\u043d\u044f\u0434\u0437\u0435\u043b\u044f_\u043f\u0430\u043d\u044f\u0434\u0437\u0435\u043b\u0430\u043a_\u0430\u045e\u0442\u043e\u0440\u0430\u043a_\u0441\u0435\u0440\u0430\u0434\u0430_\u0447\u0430\u0446\u0432\u0435\u0440_\u043f\u044f\u0442\u043d\u0456\u0446\u0430_\u0441\u0443\u0431\u043e\u0442\u0430".split("_"),isFormat:/\[ ?[\u0423\u0443\u045e] ?(?:\u043c\u0456\u043d\u0443\u043b\u0443\u044e|\u043d\u0430\u0441\u0442\u0443\u043f\u043d\u0443\u044e)? ?\] ?dddd/},weekdaysShort:"\u043d\u0434_\u043f\u043d_\u0430\u0442_\u0441\u0440_\u0447\u0446_\u043f\u0442_\u0441\u0431".split("_"),weekdaysMin:"\u043d\u0434_\u043f\u043d_\u0430\u0442_\u0441\u0440_\u0447\u0446_\u043f\u0442_\u0441\u0431".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY \u0433.",LLL:"D MMMM YYYY \u0433., HH:mm",LLLL:"dddd, D MMMM YYYY \u0433., HH:mm"},calendar:{sameDay:"[\u0421\u0451\u043d\u043d\u044f \u045e] LT",nextDay:"[\u0417\u0430\u045e\u0442\u0440\u0430 \u045e] LT",lastDay:"[\u0423\u0447\u043e\u0440\u0430 \u045e] LT",nextWeek:function(){return"[\u0423] dddd [\u045e] LT"},lastWeek:function(){switch(this.day()){case 0:case 3:case 5:case 6:return"[\u0423 \u043c\u0456\u043d\u0443\u043b\u0443\u044e] dddd [\u045e] LT";case 1:case 2:case 4:return"[\u0423 \u043c\u0456\u043d\u0443\u043b\u044b] dddd [\u045e] LT"}},sameElse:"L"},relativeTime:{future:"\u043f\u0440\u0430\u0437 %s",past:"%s \u0442\u0430\u043c\u0443",s:"\u043d\u0435\u043a\u0430\u043b\u044c\u043a\u0456 \u0441\u0435\u043a\u0443\u043d\u0434",m:t,mm:t,h:t,hh:t,d:"\u0434\u0437\u0435\u043d\u044c",dd:t,M:"\u043c\u0435\u0441\u044f\u0446",MM:t,y:"\u0433\u043e\u0434",yy:t},meridiemParse:/\u043d\u043e\u0447\u044b|\u0440\u0430\u043d\u0456\u0446\u044b|\u0434\u043d\u044f|\u0432\u0435\u0447\u0430\u0440\u0430/,isPM:function(e){return/^(\u0434\u043d\u044f|\u0432\u0435\u0447\u0430\u0440\u0430)$/.test(e)},meridiem:function(e,a,_){return e<4?"\u043d\u043e\u0447\u044b":e<12?"\u0440\u0430\u043d\u0456\u0446\u044b":e<17?"\u0434\u043d\u044f":"\u0432\u0435\u0447\u0430\u0440\u0430"},dayOfMonthOrdinalParse:/\d{1,2}-(\u0456|\u044b|\u0433\u0430)/,ordinal:function(e,a){switch(a){case"M":case"d":case"DDD":case"w":case"W":return e%10!=2&&e%10!=3||e%100==12||e%100==13?e+"-\u044b":e+"-\u0456";case"D":return e+"-\u0433\u0430";default:return e}},week:{dow:1,doy:7}}),e.defineLocale("bg",{months:"\u044f\u043d\u0443\u0430\u0440\u0438_\u0444\u0435\u0432\u0440\u0443\u0430\u0440\u0438_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440\u0438\u043b_\u043c\u0430\u0439_\u044e\u043d\u0438_\u044e\u043b\u0438_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043f\u0442\u0435\u043c\u0432\u0440\u0438_\u043e\u043a\u0442\u043e\u043c\u0432\u0440\u0438_\u043d\u043e\u0435\u043c\u0432\u0440\u0438_\u0434\u0435\u043a\u0435\u043c\u0432\u0440\u0438".split("_"),monthsShort:"\u044f\u043d\u0443_\u0444\u0435\u0432_\u043c\u0430\u0440_\u0430\u043f\u0440_\u043c\u0430\u0439_\u044e\u043d\u0438_\u044e\u043b\u0438_\u0430\u0432\u0433_\u0441\u0435\u043f_\u043e\u043a\u0442_\u043d\u043e\u0435_\u0434\u0435\u043a".split("_"),weekdays:"\u043d\u0435\u0434\u0435\u043b\u044f_\u043f\u043e\u043d\u0435\u0434\u0435\u043b\u043d\u0438\u043a_\u0432\u0442\u043e\u0440\u043d\u0438\u043a_\u0441\u0440\u044f\u0434\u0430_\u0447\u0435\u0442\u0432\u044a\u0440\u0442\u044a\u043a_\u043f\u0435\u0442\u044a\u043a_\u0441\u044a\u0431\u043e\u0442\u0430".split("_"),weekdaysShort:"\u043d\u0435\u0434_\u043f\u043e\u043d_\u0432\u0442\u043e_\u0441\u0440\u044f_\u0447\u0435\u0442_\u043f\u0435\u0442_\u0441\u044a\u0431".split("_"),weekdaysMin:"\u043d\u0434_\u043f\u043d_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043f\u0442_\u0441\u0431".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"D.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY H:mm",LLLL:"dddd, D MMMM YYYY H:mm"},calendar:{sameDay:"[\u0414\u043d\u0435\u0441 \u0432] LT",nextDay:"[\u0423\u0442\u0440\u0435 \u0432] LT",nextWeek:"dddd [\u0432] LT",lastDay:"[\u0412\u0447\u0435\u0440\u0430 \u0432] LT",lastWeek:function(){switch(this.day()){case 0:case 3:case 6:return"[\u041c\u0438\u043d\u0430\u043b\u0430\u0442\u0430] dddd [\u0432] LT";case 1:case 2:case 4:case 5:return"[\u041c\u0438\u043d\u0430\u043b\u0438\u044f] dddd [\u0432] LT"}},sameElse:"L"},relativeTime:{future:"\u0441\u043b\u0435\u0434 %s",past:"\u043f\u0440\u0435\u0434\u0438 %s",s:"\u043d\u044f\u043a\u043e\u043b\u043a\u043e \u0441\u0435\u043a\u0443\u043d\u0434\u0438",ss:"%d \u0441\u0435\u043a\u0443\u043d\u0434\u0438",m:"\u043c\u0438\u043d\u0443\u0442\u0430",mm:"%d \u043c\u0438\u043d\u0443\u0442\u0438",h:"\u0447\u0430\u0441",hh:"%d \u0447\u0430\u0441\u0430",d:"\u0434\u0435\u043d",dd:"%d \u0434\u0435\u043d\u0430",w:"\u0441\u0435\u0434\u043c\u0438\u0446\u0430",ww:"%d \u0441\u0435\u0434\u043c\u0438\u0446\u0438",M:"\u043c\u0435\u0441\u0435\u0446",MM:"%d \u043c\u0435\u0441\u0435\u0446\u0430",y:"\u0433\u043e\u0434\u0438\u043d\u0430",yy:"%d \u0433\u043e\u0434\u0438\u043d\u0438"},dayOfMonthOrdinalParse:/\d{1,2}-(\u0435\u0432|\u0435\u043d|\u0442\u0438|\u0432\u0438|\u0440\u0438|\u043c\u0438)/,ordinal:function(e){var a=e%10,_=e%100;return 0===e?e+"-\u0435\u0432":0==_?e+"-\u0435\u043d":10<_&&_<20?e+"-\u0442\u0438":1==a?e+"-\u0432\u0438":2==a?e+"-\u0440\u0438":7==a||8==a?e+"-\u043c\u0438":e+"-\u0442\u0438"},week:{dow:1,doy:7}}),e.defineLocale("bm",{months:"Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_M\u025bkalo_Zuw\u025bnkalo_Zuluyekalo_Utikalo_S\u025btanburukalo_\u0254kut\u0254burukalo_Nowanburukalo_Desanburukalo".split("_"),monthsShort:"Zan_Few_Mar_Awi_M\u025b_Zuw_Zul_Uti_S\u025bt_\u0254ku_Now_Des".split("_"),weekdays:"Kari_Nt\u025bn\u025bn_Tarata_Araba_Alamisa_Juma_Sibiri".split("_"),weekdaysShort:"Kar_Nt\u025b_Tar_Ara_Ala_Jum_Sib".split("_"),weekdaysMin:"Ka_Nt_Ta_Ar_Al_Ju_Si".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"MMMM [tile] D [san] YYYY",LLL:"MMMM [tile] D [san] YYYY [l\u025br\u025b] HH:mm",LLLL:"dddd MMMM [tile] D [san] YYYY [l\u025br\u025b] HH:mm"},calendar:{sameDay:"[Bi l\u025br\u025b] LT",nextDay:"[Sini l\u025br\u025b] LT",nextWeek:"dddd [don l\u025br\u025b] LT",lastDay:"[Kunu l\u025br\u025b] LT",lastWeek:"dddd [t\u025bm\u025bnen l\u025br\u025b] LT",sameElse:"L"},relativeTime:{future:"%s k\u0254n\u0254",past:"a b\u025b %s b\u0254",s:"sanga dama dama",ss:"sekondi %d",m:"miniti kelen",mm:"miniti %d",h:"l\u025br\u025b kelen",hh:"l\u025br\u025b %d",d:"tile kelen",dd:"tile %d",M:"kalo kelen",MM:"kalo %d",y:"san kelen",yy:"san %d"},week:{dow:1,doy:4}});var U={1:"\u09e7",2:"\u09e8",3:"\u09e9",4:"\u09ea",5:"\u09eb",6:"\u09ec",7:"\u09ed",8:"\u09ee",9:"\u09ef",0:"\u09e6"},$={"\u09e7":"1","\u09e8":"2","\u09e9":"3","\u09ea":"4","\u09eb":"5","\u09ec":"6","\u09ed":"7","\u09ee":"8","\u09ef":"9","\u09e6":"0"},Q=(e.defineLocale("bn-bd",{months:"\u099c\u09be\u09a8\u09c1\u09df\u09be\u09b0\u09bf_\u09ab\u09c7\u09ac\u09cd\u09b0\u09c1\u09df\u09be\u09b0\u09bf_\u09ae\u09be\u09b0\u09cd\u099a_\u098f\u09aa\u09cd\u09b0\u09bf\u09b2_\u09ae\u09c7_\u099c\u09c1\u09a8_\u099c\u09c1\u09b2\u09be\u0987_\u0986\u0997\u09b8\u09cd\u099f_\u09b8\u09c7\u09aa\u09cd\u099f\u09c7\u09ae\u09cd\u09ac\u09b0_\u0985\u0995\u09cd\u099f\u09cb\u09ac\u09b0_\u09a8\u09ad\u09c7\u09ae\u09cd\u09ac\u09b0_\u09a1\u09bf\u09b8\u09c7\u09ae\u09cd\u09ac\u09b0".split("_"),monthsShort:"\u099c\u09be\u09a8\u09c1_\u09ab\u09c7\u09ac\u09cd\u09b0\u09c1_\u09ae\u09be\u09b0\u09cd\u099a_\u098f\u09aa\u09cd\u09b0\u09bf\u09b2_\u09ae\u09c7_\u099c\u09c1\u09a8_\u099c\u09c1\u09b2\u09be\u0987_\u0986\u0997\u09b8\u09cd\u099f_\u09b8\u09c7\u09aa\u09cd\u099f_\u0985\u0995\u09cd\u099f\u09cb_\u09a8\u09ad\u09c7_\u09a1\u09bf\u09b8\u09c7".split("_"),weekdays:"\u09b0\u09ac\u09bf\u09ac\u09be\u09b0_\u09b8\u09cb\u09ae\u09ac\u09be\u09b0_\u09ae\u0999\u09cd\u0997\u09b2\u09ac\u09be\u09b0_\u09ac\u09c1\u09a7\u09ac\u09be\u09b0_\u09ac\u09c3\u09b9\u09b8\u09cd\u09aa\u09a4\u09bf\u09ac\u09be\u09b0_\u09b6\u09c1\u0995\u09cd\u09b0\u09ac\u09be\u09b0_\u09b6\u09a8\u09bf\u09ac\u09be\u09b0".split("_"),weekdaysShort:"\u09b0\u09ac\u09bf_\u09b8\u09cb\u09ae_\u09ae\u0999\u09cd\u0997\u09b2_\u09ac\u09c1\u09a7_\u09ac\u09c3\u09b9\u09b8\u09cd\u09aa\u09a4\u09bf_\u09b6\u09c1\u0995\u09cd\u09b0_\u09b6\u09a8\u09bf".split("_"),weekdaysMin:"\u09b0\u09ac\u09bf_\u09b8\u09cb\u09ae_\u09ae\u0999\u09cd\u0997\u09b2_\u09ac\u09c1\u09a7_\u09ac\u09c3\u09b9_\u09b6\u09c1\u0995\u09cd\u09b0_\u09b6\u09a8\u09bf".split("_"),longDateFormat:{LT:"A h:mm \u09b8\u09ae\u09df",LTS:"A h:mm:ss \u09b8\u09ae\u09df",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm \u09b8\u09ae\u09df",LLLL:"dddd, D MMMM YYYY, A h:mm \u09b8\u09ae\u09df"},calendar:{sameDay:"[\u0986\u099c] LT",nextDay:"[\u0986\u0997\u09be\u09ae\u09c0\u0995\u09be\u09b2] LT",nextWeek:"dddd, LT",lastDay:"[\u0997\u09a4\u0995\u09be\u09b2] LT",lastWeek:"[\u0997\u09a4] dddd, LT",sameElse:"L"},relativeTime:{future:"%s \u09aa\u09b0\u09c7",past:"%s \u0986\u0997\u09c7",s:"\u0995\u09df\u09c7\u0995 \u09b8\u09c7\u0995\u09c7\u09a8\u09cd\u09a1",ss:"%d \u09b8\u09c7\u0995\u09c7\u09a8\u09cd\u09a1",m:"\u098f\u0995 \u09ae\u09bf\u09a8\u09bf\u099f",mm:"%d \u09ae\u09bf\u09a8\u09bf\u099f",h:"\u098f\u0995 \u0998\u09a8\u09cd\u099f\u09be",hh:"%d \u0998\u09a8\u09cd\u099f\u09be",d:"\u098f\u0995 \u09a6\u09bf\u09a8",dd:"%d \u09a6\u09bf\u09a8",M:"\u098f\u0995 \u09ae\u09be\u09b8",MM:"%d \u09ae\u09be\u09b8",y:"\u098f\u0995 \u09ac\u099b\u09b0",yy:"%d \u09ac\u099b\u09b0"},preparse:function(e){return e.replace(/[\u09e7\u09e8\u09e9\u09ea\u09eb\u09ec\u09ed\u09ee\u09ef\u09e6]/g,function(e){return $[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return U[e]})},meridiemParse:/\u09b0\u09be\u09a4|\u09ad\u09cb\u09b0|\u09b8\u0995\u09be\u09b2|\u09a6\u09c1\u09aa\u09c1\u09b0|\u09ac\u09bf\u0995\u09be\u09b2|\u09b8\u09a8\u09cd\u09a7\u09cd\u09af\u09be|\u09b0\u09be\u09a4/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u09b0\u09be\u09a4"===a?e<4?e:e+12:"\u09ad\u09cb\u09b0"===a||"\u09b8\u0995\u09be\u09b2"===a?e:"\u09a6\u09c1\u09aa\u09c1\u09b0"===a?3<=e?e:e+12:"\u09ac\u09bf\u0995\u09be\u09b2"===a||"\u09b8\u09a8\u09cd\u09a7\u09cd\u09af\u09be"===a?e+12:void 0},meridiem:function(e,a,_){return e<4?"\u09b0\u09be\u09a4":e<6?"\u09ad\u09cb\u09b0":e<12?"\u09b8\u0995\u09be\u09b2":e<15?"\u09a6\u09c1\u09aa\u09c1\u09b0":e<18?"\u09ac\u09bf\u0995\u09be\u09b2":e<20?"\u09b8\u09a8\u09cd\u09a7\u09cd\u09af\u09be":"\u09b0\u09be\u09a4"},week:{dow:0,doy:6}}),{1:"\u09e7",2:"\u09e8",3:"\u09e9",4:"\u09ea",5:"\u09eb",6:"\u09ec",7:"\u09ed",8:"\u09ee",9:"\u09ef",0:"\u09e6"}),V={"\u09e7":"1","\u09e8":"2","\u09e9":"3","\u09ea":"4","\u09eb":"5","\u09ec":"6","\u09ed":"7","\u09ee":"8","\u09ef":"9","\u09e6":"0"},Z=(e.defineLocale("bn",{months:"\u099c\u09be\u09a8\u09c1\u09df\u09be\u09b0\u09bf_\u09ab\u09c7\u09ac\u09cd\u09b0\u09c1\u09df\u09be\u09b0\u09bf_\u09ae\u09be\u09b0\u09cd\u099a_\u098f\u09aa\u09cd\u09b0\u09bf\u09b2_\u09ae\u09c7_\u099c\u09c1\u09a8_\u099c\u09c1\u09b2\u09be\u0987_\u0986\u0997\u09b8\u09cd\u099f_\u09b8\u09c7\u09aa\u09cd\u099f\u09c7\u09ae\u09cd\u09ac\u09b0_\u0985\u0995\u09cd\u099f\u09cb\u09ac\u09b0_\u09a8\u09ad\u09c7\u09ae\u09cd\u09ac\u09b0_\u09a1\u09bf\u09b8\u09c7\u09ae\u09cd\u09ac\u09b0".split("_"),monthsShort:"\u099c\u09be\u09a8\u09c1_\u09ab\u09c7\u09ac\u09cd\u09b0\u09c1_\u09ae\u09be\u09b0\u09cd\u099a_\u098f\u09aa\u09cd\u09b0\u09bf\u09b2_\u09ae\u09c7_\u099c\u09c1\u09a8_\u099c\u09c1\u09b2\u09be\u0987_\u0986\u0997\u09b8\u09cd\u099f_\u09b8\u09c7\u09aa\u09cd\u099f_\u0985\u0995\u09cd\u099f\u09cb_\u09a8\u09ad\u09c7_\u09a1\u09bf\u09b8\u09c7".split("_"),weekdays:"\u09b0\u09ac\u09bf\u09ac\u09be\u09b0_\u09b8\u09cb\u09ae\u09ac\u09be\u09b0_\u09ae\u0999\u09cd\u0997\u09b2\u09ac\u09be\u09b0_\u09ac\u09c1\u09a7\u09ac\u09be\u09b0_\u09ac\u09c3\u09b9\u09b8\u09cd\u09aa\u09a4\u09bf\u09ac\u09be\u09b0_\u09b6\u09c1\u0995\u09cd\u09b0\u09ac\u09be\u09b0_\u09b6\u09a8\u09bf\u09ac\u09be\u09b0".split("_"),weekdaysShort:"\u09b0\u09ac\u09bf_\u09b8\u09cb\u09ae_\u09ae\u0999\u09cd\u0997\u09b2_\u09ac\u09c1\u09a7_\u09ac\u09c3\u09b9\u09b8\u09cd\u09aa\u09a4\u09bf_\u09b6\u09c1\u0995\u09cd\u09b0_\u09b6\u09a8\u09bf".split("_"),weekdaysMin:"\u09b0\u09ac\u09bf_\u09b8\u09cb\u09ae_\u09ae\u0999\u09cd\u0997\u09b2_\u09ac\u09c1\u09a7_\u09ac\u09c3\u09b9_\u09b6\u09c1\u0995\u09cd\u09b0_\u09b6\u09a8\u09bf".split("_"),longDateFormat:{LT:"A h:mm \u09b8\u09ae\u09df",LTS:"A h:mm:ss \u09b8\u09ae\u09df",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm \u09b8\u09ae\u09df",LLLL:"dddd, D MMMM YYYY, A h:mm \u09b8\u09ae\u09df"},calendar:{sameDay:"[\u0986\u099c] LT",nextDay:"[\u0986\u0997\u09be\u09ae\u09c0\u0995\u09be\u09b2] LT",nextWeek:"dddd, LT",lastDay:"[\u0997\u09a4\u0995\u09be\u09b2] LT",lastWeek:"[\u0997\u09a4] dddd, LT",sameElse:"L"},relativeTime:{future:"%s \u09aa\u09b0\u09c7",past:"%s \u0986\u0997\u09c7",s:"\u0995\u09df\u09c7\u0995 \u09b8\u09c7\u0995\u09c7\u09a8\u09cd\u09a1",ss:"%d \u09b8\u09c7\u0995\u09c7\u09a8\u09cd\u09a1",m:"\u098f\u0995 \u09ae\u09bf\u09a8\u09bf\u099f",mm:"%d \u09ae\u09bf\u09a8\u09bf\u099f",h:"\u098f\u0995 \u0998\u09a8\u09cd\u099f\u09be",hh:"%d \u0998\u09a8\u09cd\u099f\u09be",d:"\u098f\u0995 \u09a6\u09bf\u09a8",dd:"%d \u09a6\u09bf\u09a8",M:"\u098f\u0995 \u09ae\u09be\u09b8",MM:"%d \u09ae\u09be\u09b8",y:"\u098f\u0995 \u09ac\u099b\u09b0",yy:"%d \u09ac\u099b\u09b0"},preparse:function(e){return e.replace(/[\u09e7\u09e8\u09e9\u09ea\u09eb\u09ec\u09ed\u09ee\u09ef\u09e6]/g,function(e){return V[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return Q[e]})},meridiemParse:/\u09b0\u09be\u09a4|\u09b8\u0995\u09be\u09b2|\u09a6\u09c1\u09aa\u09c1\u09b0|\u09ac\u09bf\u0995\u09be\u09b2|\u09b0\u09be\u09a4/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u09b0\u09be\u09a4"===a&&4<=e||"\u09a6\u09c1\u09aa\u09c1\u09b0"===a&&e<5||"\u09ac\u09bf\u0995\u09be\u09b2"===a?e+12:e},meridiem:function(e,a,_){return e<4?"\u09b0\u09be\u09a4":e<10?"\u09b8\u0995\u09be\u09b2":e<17?"\u09a6\u09c1\u09aa\u09c1\u09b0":e<20?"\u09ac\u09bf\u0995\u09be\u09b2":"\u09b0\u09be\u09a4"},week:{dow:0,doy:6}}),{1:"\u0f21",2:"\u0f22",3:"\u0f23",4:"\u0f24",5:"\u0f25",6:"\u0f26",7:"\u0f27",8:"\u0f28",9:"\u0f29",0:"\u0f20"}),X={"\u0f21":"1","\u0f22":"2","\u0f23":"3","\u0f24":"4","\u0f25":"5","\u0f26":"6","\u0f27":"7","\u0f28":"8","\u0f29":"9","\u0f20":"0"};function ee(e,a,_){return e+" "+(_={mm:"munutenn",MM:"miz",dd:"devezh"}[_],2!==(e=e)?_:void 0!==(e={m:"v",b:"v",d:"z"})[(_=_).charAt(0)]?e[_.charAt(0)]+_.substring(1):_)}e.defineLocale("bo",{months:"\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f51\u0f44\u0f0b\u0f54\u0f7c_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f42\u0f49\u0f72\u0f66\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f42\u0f66\u0f74\u0f58\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f56\u0f5e\u0f72\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f63\u0f94\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f51\u0fb2\u0f74\u0f42\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f56\u0f51\u0f74\u0f53\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f56\u0f62\u0f92\u0fb1\u0f51\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f51\u0f42\u0f74\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f56\u0f45\u0f74\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f56\u0f45\u0f74\u0f0b\u0f42\u0f45\u0f72\u0f42\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f56\u0f45\u0f74\u0f0b\u0f42\u0f49\u0f72\u0f66\u0f0b\u0f54".split("_"),monthsShort:"\u0f5f\u0fb3\u0f0b1_\u0f5f\u0fb3\u0f0b2_\u0f5f\u0fb3\u0f0b3_\u0f5f\u0fb3\u0f0b4_\u0f5f\u0fb3\u0f0b5_\u0f5f\u0fb3\u0f0b6_\u0f5f\u0fb3\u0f0b7_\u0f5f\u0fb3\u0f0b8_\u0f5f\u0fb3\u0f0b9_\u0f5f\u0fb3\u0f0b10_\u0f5f\u0fb3\u0f0b11_\u0f5f\u0fb3\u0f0b12".split("_"),monthsShortRegex:/^(\u0f5f\u0fb3\u0f0b\d{1,2})/,monthsParseExact:!0,weekdays:"\u0f42\u0f5f\u0f60\u0f0b\u0f49\u0f72\u0f0b\u0f58\u0f0b_\u0f42\u0f5f\u0f60\u0f0b\u0f5f\u0fb3\u0f0b\u0f56\u0f0b_\u0f42\u0f5f\u0f60\u0f0b\u0f58\u0f72\u0f42\u0f0b\u0f51\u0f58\u0f62\u0f0b_\u0f42\u0f5f\u0f60\u0f0b\u0f63\u0fb7\u0f42\u0f0b\u0f54\u0f0b_\u0f42\u0f5f\u0f60\u0f0b\u0f55\u0f74\u0f62\u0f0b\u0f56\u0f74_\u0f42\u0f5f\u0f60\u0f0b\u0f54\u0f0b\u0f66\u0f44\u0f66\u0f0b_\u0f42\u0f5f\u0f60\u0f0b\u0f66\u0fa4\u0f7a\u0f53\u0f0b\u0f54\u0f0b".split("_"),weekdaysShort:"\u0f49\u0f72\u0f0b\u0f58\u0f0b_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b_\u0f58\u0f72\u0f42\u0f0b\u0f51\u0f58\u0f62\u0f0b_\u0f63\u0fb7\u0f42\u0f0b\u0f54\u0f0b_\u0f55\u0f74\u0f62\u0f0b\u0f56\u0f74_\u0f54\u0f0b\u0f66\u0f44\u0f66\u0f0b_\u0f66\u0fa4\u0f7a\u0f53\u0f0b\u0f54\u0f0b".split("_"),weekdaysMin:"\u0f49\u0f72_\u0f5f\u0fb3_\u0f58\u0f72\u0f42_\u0f63\u0fb7\u0f42_\u0f55\u0f74\u0f62_\u0f66\u0f44\u0f66_\u0f66\u0fa4\u0f7a\u0f53".split("_"),longDateFormat:{LT:"A h:mm",LTS:"A h:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm",LLLL:"dddd, D MMMM YYYY, A h:mm"},calendar:{sameDay:"[\u0f51\u0f72\u0f0b\u0f62\u0f72\u0f44] LT",nextDay:"[\u0f66\u0f44\u0f0b\u0f49\u0f72\u0f53] LT",nextWeek:"[\u0f56\u0f51\u0f74\u0f53\u0f0b\u0f55\u0fb2\u0f42\u0f0b\u0f62\u0f97\u0f7a\u0f66\u0f0b\u0f58], LT",lastDay:"[\u0f41\u0f0b\u0f66\u0f44] LT",lastWeek:"[\u0f56\u0f51\u0f74\u0f53\u0f0b\u0f55\u0fb2\u0f42\u0f0b\u0f58\u0f50\u0f60\u0f0b\u0f58] dddd, LT",sameElse:"L"},relativeTime:{future:"%s \u0f63\u0f0b",past:"%s \u0f66\u0f94\u0f53\u0f0b\u0f63",s:"\u0f63\u0f58\u0f0b\u0f66\u0f44",ss:"%d \u0f66\u0f90\u0f62\u0f0b\u0f46\u0f0d",m:"\u0f66\u0f90\u0f62\u0f0b\u0f58\u0f0b\u0f42\u0f45\u0f72\u0f42",mm:"%d \u0f66\u0f90\u0f62\u0f0b\u0f58",h:"\u0f46\u0f74\u0f0b\u0f5a\u0f7c\u0f51\u0f0b\u0f42\u0f45\u0f72\u0f42",hh:"%d \u0f46\u0f74\u0f0b\u0f5a\u0f7c\u0f51",d:"\u0f49\u0f72\u0f53\u0f0b\u0f42\u0f45\u0f72\u0f42",dd:"%d \u0f49\u0f72\u0f53\u0f0b",M:"\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f42\u0f45\u0f72\u0f42",MM:"%d \u0f5f\u0fb3\u0f0b\u0f56",y:"\u0f63\u0f7c\u0f0b\u0f42\u0f45\u0f72\u0f42",yy:"%d \u0f63\u0f7c"},preparse:function(e){return e.replace(/[\u0f21\u0f22\u0f23\u0f24\u0f25\u0f26\u0f27\u0f28\u0f29\u0f20]/g,function(e){return X[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return Z[e]})},meridiemParse:/\u0f58\u0f5a\u0f53\u0f0b\u0f58\u0f7c|\u0f5e\u0f7c\u0f42\u0f66\u0f0b\u0f40\u0f66|\u0f49\u0f72\u0f53\u0f0b\u0f42\u0f74\u0f44|\u0f51\u0f42\u0f7c\u0f44\u0f0b\u0f51\u0f42|\u0f58\u0f5a\u0f53\u0f0b\u0f58\u0f7c/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u0f58\u0f5a\u0f53\u0f0b\u0f58\u0f7c"===a&&4<=e||"\u0f49\u0f72\u0f53\u0f0b\u0f42\u0f74\u0f44"===a&&e<5||"\u0f51\u0f42\u0f7c\u0f44\u0f0b\u0f51\u0f42"===a?e+12:e},meridiem:function(e,a,_){return e<4?"\u0f58\u0f5a\u0f53\u0f0b\u0f58\u0f7c":e<10?"\u0f5e\u0f7c\u0f42\u0f66\u0f0b\u0f40\u0f66":e<17?"\u0f49\u0f72\u0f53\u0f0b\u0f42\u0f74\u0f44":e<20?"\u0f51\u0f42\u0f7c\u0f44\u0f0b\u0f51\u0f42":"\u0f58\u0f5a\u0f53\u0f0b\u0f58\u0f7c"},week:{dow:0,doy:6}});var d=[/^gen/i,/^c[\u02bc\']hwe/i,/^meu/i,/^ebr/i,/^mae/i,/^(mez|eve)/i,/^gou/i,/^eos/i,/^gwe/i,/^her/i,/^du/i,/^ker/i],n=/^(genver|c[\u02bc\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[\u02bc\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,r=[/^Su/i,/^Lu/i,/^Me([^r]|$)/i,/^Mer/i,/^Ya/i,/^Gw/i,/^Sa/i];function i(e,a,_){var s=e+" ";switch(_){case"ss":return s+=1===e?"sekunda":2===e||3===e||4===e?"sekunde":"sekundi";case"m":return a?"jedna minuta":"jedne minute";case"mm":return s+=1!==e&&(2===e||3===e||4===e)?"minute":"minuta";case"h":return a?"jedan sat":"jednog sata";case"hh":return s+=1===e?"sat":2===e||3===e||4===e?"sata":"sati";case"dd":return s+=1===e?"dan":"dana";case"MM":return s+=1===e?"mjesec":2===e||3===e||4===e?"mjeseca":"mjeseci";case"yy":return s+=1!==e&&(2===e||3===e||4===e)?"godine":"godina"}}e.defineLocale("br",{months:"Genver_C\u02bchwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu".split("_"),monthsShort:"Gen_C\u02bchwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker".split("_"),weekdays:"Sul_Lun_Meurzh_Merc\u02bcher_Yaou_Gwener_Sadorn".split("_"),weekdaysShort:"Sul_Lun_Meu_Mer_Yao_Gwe_Sad".split("_"),weekdaysMin:"Su_Lu_Me_Mer_Ya_Gw_Sa".split("_"),weekdaysParse:r,fullWeekdaysParse:[/^sul/i,/^lun/i,/^meurzh/i,/^merc[\u02bc\']her/i,/^yaou/i,/^gwener/i,/^sadorn/i],shortWeekdaysParse:[/^Sul/i,/^Lun/i,/^Meu/i,/^Mer/i,/^Yao/i,/^Gwe/i,/^Sad/i],minWeekdaysParse:r,monthsRegex:n,monthsShortRegex:n,monthsStrictRegex:/^(genver|c[\u02bc\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,monthsShortStrictRegex:/^(gen|c[\u02bc\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,monthsParse:d,longMonthsParse:d,shortMonthsParse:d,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D [a viz] MMMM YYYY",LLL:"D [a viz] MMMM YYYY HH:mm",LLLL:"dddd, D [a viz] MMMM YYYY HH:mm"},calendar:{sameDay:"[Hiziv da] LT",nextDay:"[Warc\u02bchoazh da] LT",nextWeek:"dddd [da] LT",lastDay:"[Dec\u02bch da] LT",lastWeek:"dddd [paset da] LT",sameElse:"L"},relativeTime:{future:"a-benn %s",past:"%s \u02bczo",s:"un nebeud segondenno\xf9",ss:"%d eilenn",m:"ur vunutenn",mm:ee,h:"un eur",hh:"%d eur",d:"un devezh",dd:ee,M:"ur miz",MM:ee,y:"ur bloaz",yy:function(e){switch(function e(a){if(9<a)return e(a%10);return a}(e)){case 1:case 3:case 4:case 5:case 9:return e+" bloaz";default:return e+" vloaz"}}},dayOfMonthOrdinalParse:/\d{1,2}(a\xf1|vet)/,ordinal:function(e){return e+(1===e?"a\xf1":"vet")},week:{dow:1,doy:4},meridiemParse:/a.m.|g.m./,isPM:function(e){return"g.m."===e},meridiem:function(e,a,_){return e<12?"a.m.":"g.m."}}),e.defineLocale("bs",{months:"januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar".split("_"),monthsShort:"jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"nedjelja_ponedjeljak_utorak_srijeda_\u010detvrtak_petak_subota".split("_"),weekdaysShort:"ned._pon._uto._sri._\u010det._pet._sub.".split("_"),weekdaysMin:"ne_po_ut_sr_\u010de_pe_su".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd, D. MMMM YYYY H:mm"},calendar:{sameDay:"[danas u] LT",nextDay:"[sutra u] LT",nextWeek:function(){switch(this.day()){case 0:return"[u] [nedjelju] [u] LT";case 3:return"[u] [srijedu] [u] LT";case 6:return"[u] [subotu] [u] LT";case 1:case 2:case 4:case 5:return"[u] dddd [u] LT"}},lastDay:"[ju\u010der u] LT",lastWeek:function(){switch(this.day()){case 0:case 3:return"[pro\u0161lu] dddd [u] LT";case 6:return"[pro\u0161le] [subote] [u] LT";case 1:case 2:case 4:case 5:return"[pro\u0161li] dddd [u] LT"}},sameElse:"L"},relativeTime:{future:"za %s",past:"prije %s",s:"par sekundi",ss:i,m:i,mm:i,h:i,hh:i,d:"dan",dd:i,M:"mjesec",MM:i,y:"godinu",yy:i},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}}),e.defineLocale("ca",{months:{standalone:"gener_febrer_mar\xe7_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre".split("_"),format:"de gener_de febrer_de mar\xe7_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split("_"),isFormat:/D[oD]?(\s)+MMMM/},monthsShort:"gen._febr._mar\xe7_abr._maig_juny_jul._ag._set._oct._nov._des.".split("_"),monthsParseExact:!0,weekdays:"diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte".split("_"),weekdaysShort:"dg._dl._dt._dc._dj._dv._ds.".split("_"),weekdaysMin:"dg_dl_dt_dc_dj_dv_ds".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM [de] YYYY",ll:"D MMM YYYY",LLL:"D MMMM [de] YYYY [a les] H:mm",lll:"D MMM YYYY, H:mm",LLLL:"dddd D MMMM [de] YYYY [a les] H:mm",llll:"ddd D MMM YYYY, H:mm"},calendar:{sameDay:function(){return"[avui a "+(1!==this.hours()?"les":"la")+"] LT"},nextDay:function(){return"[dem\xe0 a "+(1!==this.hours()?"les":"la")+"] LT"},nextWeek:function(){return"dddd [a "+(1!==this.hours()?"les":"la")+"] LT"},lastDay:function(){return"[ahir a "+(1!==this.hours()?"les":"la")+"] LT"},lastWeek:function(){return"[el] dddd [passat a "+(1!==this.hours()?"les":"la")+"] LT"},sameElse:"L"},relativeTime:{future:"d'aqu\xed %s",past:"fa %s",s:"uns segons",ss:"%d segons",m:"un minut",mm:"%d minuts",h:"una hora",hh:"%d hores",d:"un dia",dd:"%d dies",M:"un mes",MM:"%d mesos",y:"un any",yy:"%d anys"},dayOfMonthOrdinalParse:/\d{1,2}(r|n|t|\xe8|a)/,ordinal:function(e,a){return e+("w"!==a&&"W"!==a?1===e?"r":2===e?"n":3===e?"r":4===e?"t":"\xe8":"a")},week:{dow:1,doy:4}});var r={format:"leden_\xfanor_b\u0159ezen_duben_kv\u011bten_\u010derven_\u010dervenec_srpen_z\xe1\u0159\xed_\u0159\xedjen_listopad_prosinec".split("_"),standalone:"ledna_\xfanora_b\u0159ezna_dubna_kv\u011btna_\u010dervna_\u010dervence_srpna_z\xe1\u0159\xed_\u0159\xedjna_listopadu_prosince".split("_")},n="led_\xfano_b\u0159e_dub_kv\u011b_\u010dvn_\u010dvc_srp_z\xe1\u0159_\u0159\xedj_lis_pro".split("_"),d=[/^led/i,/^\xfano/i,/^b\u0159e/i,/^dub/i,/^kv\u011b/i,/^(\u010dvn|\u010derven$|\u010dervna)/i,/^(\u010dvc|\u010dervenec|\u010dervence)/i,/^srp/i,/^z\xe1\u0159/i,/^\u0159\xedj/i,/^lis/i,/^pro/i],m=/^(leden|\xfanor|b\u0159ezen|duben|kv\u011bten|\u010dervenec|\u010dervence|\u010derven|\u010dervna|srpen|z\xe1\u0159\xed|\u0159\xedjen|listopad|prosinec|led|\xfano|b\u0159e|dub|kv\u011b|\u010dvn|\u010dvc|srp|z\xe1\u0159|\u0159\xedj|lis|pro)/i;function o(e){return 1<e&&e<5&&1!=~~(e/10)}function u(e,a,_,s){var d=e+" ";switch(_){case"s":return a||s?"p\xe1r sekund":"p\xe1r sekundami";case"ss":return a||s?d+(o(e)?"sekundy":"sekund"):d+"sekundami";case"m":return a?"minuta":s?"minutu":"minutou";case"mm":return a||s?d+(o(e)?"minuty":"minut"):d+"minutami";case"h":return a?"hodina":s?"hodinu":"hodinou";case"hh":return a||s?d+(o(e)?"hodiny":"hodin"):d+"hodinami";case"d":return a||s?"den":"dnem";case"dd":return a||s?d+(o(e)?"dny":"dn\xed"):d+"dny";case"M":return a||s?"m\u011bs\xedc":"m\u011bs\xedcem";case"MM":return a||s?d+(o(e)?"m\u011bs\xedce":"m\u011bs\xedc\u016f"):d+"m\u011bs\xedci";case"y":return a||s?"rok":"rokem";case"yy":return a||s?d+(o(e)?"roky":"let"):d+"lety"}}function l(e,a,_,s){e={m:["eine Minute","einer Minute"],h:["eine Stunde","einer Stunde"],d:["ein Tag","einem Tag"],dd:[e+" Tage",e+" Tagen"],w:["eine Woche","einer Woche"],M:["ein Monat","einem Monat"],MM:[e+" Monate",e+" Monaten"],y:["ein Jahr","einem Jahr"],yy:[e+" Jahre",e+" Jahren"]};return a?e[_][0]:e[_][1]}function M(e,a,_,s){e={m:["eine Minute","einer Minute"],h:["eine Stunde","einer Stunde"],d:["ein Tag","einem Tag"],dd:[e+" Tage",e+" Tagen"],w:["eine Woche","einer Woche"],M:["ein Monat","einem Monat"],MM:[e+" Monate",e+" Monaten"],y:["ein Jahr","einem Jahr"],yy:[e+" Jahre",e+" Jahren"]};return a?e[_][0]:e[_][1]}function L(e,a,_,s){e={m:["eine Minute","einer Minute"],h:["eine Stunde","einer Stunde"],d:["ein Tag","einem Tag"],dd:[e+" Tage",e+" Tagen"],w:["eine Woche","einer Woche"],M:["ein Monat","einem Monat"],MM:[e+" Monate",e+" Monaten"],y:["ein Jahr","einem Jahr"],yy:[e+" Jahre",e+" Jahren"]};return a?e[_][0]:e[_][1]}e.defineLocale("cs",{months:r,monthsShort:n,monthsRegex:m,monthsShortRegex:m,monthsStrictRegex:/^(leden|ledna|\xfanora|\xfanor|b\u0159ezen|b\u0159ezna|duben|dubna|kv\u011bten|kv\u011btna|\u010dervenec|\u010dervence|\u010derven|\u010dervna|srpen|srpna|z\xe1\u0159\xed|\u0159\xedjen|\u0159\xedjna|listopadu|listopad|prosinec|prosince)/i,monthsShortStrictRegex:/^(led|\xfano|b\u0159e|dub|kv\u011b|\u010dvn|\u010dvc|srp|z\xe1\u0159|\u0159\xedj|lis|pro)/i,monthsParse:d,longMonthsParse:d,shortMonthsParse:d,weekdays:"ned\u011ble_pond\u011bl\xed_\xfater\xfd_st\u0159eda_\u010dtvrtek_p\xe1tek_sobota".split("_"),weekdaysShort:"ne_po_\xfat_st_\u010dt_p\xe1_so".split("_"),weekdaysMin:"ne_po_\xfat_st_\u010dt_p\xe1_so".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd D. MMMM YYYY H:mm",l:"D. M. YYYY"},calendar:{sameDay:"[dnes v] LT",nextDay:"[z\xedtra v] LT",nextWeek:function(){switch(this.day()){case 0:return"[v ned\u011bli v] LT";case 1:case 2:return"[v] dddd [v] LT";case 3:return"[ve st\u0159edu v] LT";case 4:return"[ve \u010dtvrtek v] LT";case 5:return"[v p\xe1tek v] LT";case 6:return"[v sobotu v] LT"}},lastDay:"[v\u010dera v] LT",lastWeek:function(){switch(this.day()){case 0:return"[minulou ned\u011bli v] LT";case 1:case 2:return"[minul\xe9] dddd [v] LT";case 3:return"[minulou st\u0159edu v] LT";case 4:case 5:return"[minul\xfd] dddd [v] LT";case 6:return"[minulou sobotu v] LT"}},sameElse:"L"},relativeTime:{future:"za %s",past:"p\u0159ed %s",s:u,ss:u,m:u,mm:u,h:u,hh:u,d:u,dd:u,M:u,MM:u,y:u,yy:u},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),e.defineLocale("cv",{months:"\u043a\u04d1\u0440\u043b\u0430\u0447_\u043d\u0430\u0440\u04d1\u0441_\u043f\u0443\u0448_\u0430\u043a\u0430_\u043c\u0430\u0439_\u04ab\u04d7\u0440\u0442\u043c\u0435_\u0443\u0442\u04d1_\u04ab\u0443\u0440\u043b\u0430_\u0430\u0432\u04d1\u043d_\u044e\u043f\u0430_\u0447\u04f3\u043a_\u0440\u0430\u0448\u0442\u0430\u0432".split("_"),monthsShort:"\u043a\u04d1\u0440_\u043d\u0430\u0440_\u043f\u0443\u0448_\u0430\u043a\u0430_\u043c\u0430\u0439_\u04ab\u04d7\u0440_\u0443\u0442\u04d1_\u04ab\u0443\u0440_\u0430\u0432\u043d_\u044e\u043f\u0430_\u0447\u04f3\u043a_\u0440\u0430\u0448".split("_"),weekdays:"\u0432\u044b\u0440\u0441\u0430\u0440\u043d\u0438\u043a\u0443\u043d_\u0442\u0443\u043d\u0442\u0438\u043a\u0443\u043d_\u044b\u0442\u043b\u0430\u0440\u0438\u043a\u0443\u043d_\u044e\u043d\u043a\u0443\u043d_\u043a\u04d7\u04ab\u043d\u0435\u0440\u043d\u0438\u043a\u0443\u043d_\u044d\u0440\u043d\u0435\u043a\u0443\u043d_\u0448\u04d1\u043c\u0430\u0442\u043a\u0443\u043d".split("_"),weekdaysShort:"\u0432\u044b\u0440_\u0442\u0443\u043d_\u044b\u0442\u043b_\u044e\u043d_\u043a\u04d7\u04ab_\u044d\u0440\u043d_\u0448\u04d1\u043c".split("_"),weekdaysMin:"\u0432\u0440_\u0442\u043d_\u044b\u0442_\u044e\u043d_\u043a\u04ab_\u044d\u0440_\u0448\u043c".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD-MM-YYYY",LL:"YYYY [\u04ab\u0443\u043b\u0445\u0438] MMMM [\u0443\u0439\u04d1\u0445\u04d7\u043d] D[-\u043c\u04d7\u0448\u04d7]",LLL:"YYYY [\u04ab\u0443\u043b\u0445\u0438] MMMM [\u0443\u0439\u04d1\u0445\u04d7\u043d] D[-\u043c\u04d7\u0448\u04d7], HH:mm",LLLL:"dddd, YYYY [\u04ab\u0443\u043b\u0445\u0438] MMMM [\u0443\u0439\u04d1\u0445\u04d7\u043d] D[-\u043c\u04d7\u0448\u04d7], HH:mm"},calendar:{sameDay:"[\u041f\u0430\u044f\u043d] LT [\u0441\u0435\u0445\u0435\u0442\u0440\u0435]",nextDay:"[\u042b\u0440\u0430\u043d] LT [\u0441\u0435\u0445\u0435\u0442\u0440\u0435]",lastDay:"[\u04d6\u043d\u0435\u0440] LT [\u0441\u0435\u0445\u0435\u0442\u0440\u0435]",nextWeek:"[\u04aa\u0438\u0442\u0435\u0441] dddd LT [\u0441\u0435\u0445\u0435\u0442\u0440\u0435]",lastWeek:"[\u0418\u0440\u0442\u043d\u04d7] dddd LT [\u0441\u0435\u0445\u0435\u0442\u0440\u0435]",sameElse:"L"},relativeTime:{future:function(e){return e+(/\u0441\u0435\u0445\u0435\u0442$/i.exec(e)?"\u0440\u0435\u043d":/\u04ab\u0443\u043b$/i.exec(e)?"\u0442\u0430\u043d":"\u0440\u0430\u043d")},past:"%s \u043a\u0430\u044f\u043b\u043b\u0430",s:"\u043f\u04d7\u0440-\u0438\u043a \u04ab\u0435\u043a\u043a\u0443\u043d\u0442",ss:"%d \u04ab\u0435\u043a\u043a\u0443\u043d\u0442",m:"\u043f\u04d7\u0440 \u043c\u0438\u043d\u0443\u0442",mm:"%d \u043c\u0438\u043d\u0443\u0442",h:"\u043f\u04d7\u0440 \u0441\u0435\u0445\u0435\u0442",hh:"%d \u0441\u0435\u0445\u0435\u0442",d:"\u043f\u04d7\u0440 \u043a\u0443\u043d",dd:"%d \u043a\u0443\u043d",M:"\u043f\u04d7\u0440 \u0443\u0439\u04d1\u0445",MM:"%d \u0443\u0439\u04d1\u0445",y:"\u043f\u04d7\u0440 \u04ab\u0443\u043b",yy:"%d \u04ab\u0443\u043b"},dayOfMonthOrdinalParse:/\d{1,2}-\u043c\u04d7\u0448/,ordinal:"%d-\u043c\u04d7\u0448",week:{dow:1,doy:7}}),e.defineLocale("cy",{months:"Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr".split("_"),monthsShort:"Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag".split("_"),weekdays:"Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn".split("_"),weekdaysShort:"Sul_Llun_Maw_Mer_Iau_Gwe_Sad".split("_"),weekdaysMin:"Su_Ll_Ma_Me_Ia_Gw_Sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Heddiw am] LT",nextDay:"[Yfory am] LT",nextWeek:"dddd [am] LT",lastDay:"[Ddoe am] LT",lastWeek:"dddd [diwethaf am] LT",sameElse:"L"},relativeTime:{future:"mewn %s",past:"%s yn \xf4l",s:"ychydig eiliadau",ss:"%d eiliad",m:"munud",mm:"%d munud",h:"awr",hh:"%d awr",d:"diwrnod",dd:"%d diwrnod",M:"mis",MM:"%d mis",y:"blwyddyn",yy:"%d flynedd"},dayOfMonthOrdinalParse:/\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,ordinal:function(e){var a="";return 20<e?a=40===e||50===e||60===e||80===e||100===e?"fed":"ain":0<e&&(a=["","af","il","ydd","ydd","ed","ed","ed","fed","fed","fed","eg","fed","eg","eg","fed","eg","eg","fed","eg","fed"][e]),e+a},week:{dow:1,doy:4}}),e.defineLocale("da",{months:"januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december".split("_"),monthsShort:"jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec".split("_"),weekdays:"s\xf8ndag_mandag_tirsdag_onsdag_torsdag_fredag_l\xf8rdag".split("_"),weekdaysShort:"s\xf8n_man_tir_ons_tor_fre_l\xf8r".split("_"),weekdaysMin:"s\xf8_ma_ti_on_to_fr_l\xf8".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY HH:mm",LLLL:"dddd [d.] D. MMMM YYYY [kl.] HH:mm"},calendar:{sameDay:"[i dag kl.] LT",nextDay:"[i morgen kl.] LT",nextWeek:"p\xe5 dddd [kl.] LT",lastDay:"[i g\xe5r kl.] LT",lastWeek:"[i] dddd[s kl.] LT",sameElse:"L"},relativeTime:{future:"om %s",past:"%s siden",s:"f\xe5 sekunder",ss:"%d sekunder",m:"et minut",mm:"%d minutter",h:"en time",hh:"%d timer",d:"en dag",dd:"%d dage",M:"en m\xe5ned",MM:"%d m\xe5neder",y:"et \xe5r",yy:"%d \xe5r"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),e.defineLocale("de-at",{months:"J\xe4nner_Februar_M\xe4rz_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),monthsShort:"J\xe4n._Feb._M\xe4rz_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split("_"),monthsParseExact:!0,weekdays:"Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),weekdaysShort:"So._Mo._Di._Mi._Do._Fr._Sa.".split("_"),weekdaysMin:"So_Mo_Di_Mi_Do_Fr_Sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY HH:mm",LLLL:"dddd, D. MMMM YYYY HH:mm"},calendar:{sameDay:"[heute um] LT [Uhr]",sameElse:"L",nextDay:"[morgen um] LT [Uhr]",nextWeek:"dddd [um] LT [Uhr]",lastDay:"[gestern um] LT [Uhr]",lastWeek:"[letzten] dddd [um] LT [Uhr]"},relativeTime:{future:"in %s",past:"vor %s",s:"ein paar Sekunden",ss:"%d Sekunden",m:l,mm:"%d Minuten",h:l,hh:"%d Stunden",d:l,dd:l,w:l,ww:"%d Wochen",M:l,MM:l,y:l,yy:l},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),e.defineLocale("de-ch",{months:"Januar_Februar_M\xe4rz_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),monthsShort:"Jan._Feb._M\xe4rz_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split("_"),monthsParseExact:!0,weekdays:"Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),weekdaysShort:"So_Mo_Di_Mi_Do_Fr_Sa".split("_"),weekdaysMin:"So_Mo_Di_Mi_Do_Fr_Sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY HH:mm",LLLL:"dddd, D. MMMM YYYY HH:mm"},calendar:{sameDay:"[heute um] LT [Uhr]",sameElse:"L",nextDay:"[morgen um] LT [Uhr]",nextWeek:"dddd [um] LT [Uhr]",lastDay:"[gestern um] LT [Uhr]",lastWeek:"[letzten] dddd [um] LT [Uhr]"},relativeTime:{future:"in %s",past:"vor %s",s:"ein paar Sekunden",ss:"%d Sekunden",m:M,mm:"%d Minuten",h:M,hh:"%d Stunden",d:M,dd:M,w:M,ww:"%d Wochen",M:M,MM:M,y:M,yy:M},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),e.defineLocale("de",{months:"Januar_Februar_M\xe4rz_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),monthsShort:"Jan._Feb._M\xe4rz_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split("_"),monthsParseExact:!0,weekdays:"Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),weekdaysShort:"So._Mo._Di._Mi._Do._Fr._Sa.".split("_"),weekdaysMin:"So_Mo_Di_Mi_Do_Fr_Sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY HH:mm",LLLL:"dddd, D. MMMM YYYY HH:mm"},calendar:{sameDay:"[heute um] LT [Uhr]",sameElse:"L",nextDay:"[morgen um] LT [Uhr]",nextWeek:"dddd [um] LT [Uhr]",lastDay:"[gestern um] LT [Uhr]",lastWeek:"[letzten] dddd [um] LT [Uhr]"},relativeTime:{future:"in %s",past:"vor %s",s:"ein paar Sekunden",ss:"%d Sekunden",m:L,mm:"%d Minuten",h:L,hh:"%d Stunden",d:L,dd:L,w:L,ww:"%d Wochen",M:L,MM:L,y:L,yy:L},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}});r=["\u0796\u07ac\u0782\u07aa\u0787\u07a6\u0783\u07a9","\u078a\u07ac\u0784\u07b0\u0783\u07aa\u0787\u07a6\u0783\u07a9","\u0789\u07a7\u0783\u07a8\u0797\u07aa","\u0787\u07ad\u0795\u07b0\u0783\u07a9\u078d\u07aa","\u0789\u07ad","\u0796\u07ab\u0782\u07b0","\u0796\u07aa\u078d\u07a6\u0787\u07a8","\u0787\u07af\u078e\u07a6\u0790\u07b0\u0793\u07aa","\u0790\u07ac\u0795\u07b0\u0793\u07ac\u0789\u07b0\u0784\u07a6\u0783\u07aa","\u0787\u07ae\u0786\u07b0\u0793\u07af\u0784\u07a6\u0783\u07aa","\u0782\u07ae\u0788\u07ac\u0789\u07b0\u0784\u07a6\u0783\u07aa","\u0791\u07a8\u0790\u07ac\u0789\u07b0\u0784\u07a6\u0783\u07aa"],n=["\u0787\u07a7\u078b\u07a8\u0787\u07b0\u078c\u07a6","\u0780\u07af\u0789\u07a6","\u0787\u07a6\u0782\u07b0\u078e\u07a7\u0783\u07a6","\u0784\u07aa\u078b\u07a6","\u0784\u07aa\u0783\u07a7\u0790\u07b0\u078a\u07a6\u078c\u07a8","\u0780\u07aa\u0786\u07aa\u0783\u07aa","\u0780\u07ae\u0782\u07a8\u0780\u07a8\u0783\u07aa"];e.defineLocale("dv",{months:r,monthsShort:r,weekdays:n,weekdaysShort:n,weekdaysMin:"\u0787\u07a7\u078b\u07a8_\u0780\u07af\u0789\u07a6_\u0787\u07a6\u0782\u07b0_\u0784\u07aa\u078b\u07a6_\u0784\u07aa\u0783\u07a7_\u0780\u07aa\u0786\u07aa_\u0780\u07ae\u0782\u07a8".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"D/M/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},meridiemParse:/\u0789\u0786|\u0789\u078a/,isPM:function(e){return"\u0789\u078a"===e},meridiem:function(e,a,_){return e<12?"\u0789\u0786":"\u0789\u078a"},calendar:{sameDay:"[\u0789\u07a8\u0787\u07a6\u078b\u07aa] LT",nextDay:"[\u0789\u07a7\u078b\u07a6\u0789\u07a7] LT",nextWeek:"dddd LT",lastDay:"[\u0787\u07a8\u0787\u07b0\u0794\u07ac] LT",lastWeek:"[\u078a\u07a7\u0787\u07a8\u078c\u07aa\u0788\u07a8] dddd LT",sameElse:"L"},relativeTime:{future:"\u078c\u07ac\u0783\u07ad\u078e\u07a6\u0787\u07a8 %s",past:"\u0786\u07aa\u0783\u07a8\u0782\u07b0 %s",s:"\u0790\u07a8\u0786\u07aa\u0782\u07b0\u078c\u07aa\u0786\u07ae\u0785\u07ac\u0787\u07b0",ss:"d% \u0790\u07a8\u0786\u07aa\u0782\u07b0\u078c\u07aa",m:"\u0789\u07a8\u0782\u07a8\u0793\u07ac\u0787\u07b0",mm:"\u0789\u07a8\u0782\u07a8\u0793\u07aa %d",h:"\u078e\u07a6\u0791\u07a8\u0787\u07a8\u0783\u07ac\u0787\u07b0",hh:"\u078e\u07a6\u0791\u07a8\u0787\u07a8\u0783\u07aa %d",d:"\u078b\u07aa\u0788\u07a6\u0780\u07ac\u0787\u07b0",dd:"\u078b\u07aa\u0788\u07a6\u0790\u07b0 %d",M:"\u0789\u07a6\u0780\u07ac\u0787\u07b0",MM:"\u0789\u07a6\u0790\u07b0 %d",y:"\u0787\u07a6\u0780\u07a6\u0783\u07ac\u0787\u07b0",yy:"\u0787\u07a6\u0780\u07a6\u0783\u07aa %d"},preparse:function(e){return e.replace(/\u060c/g,",")},postformat:function(e){return e.replace(/,/g,"\u060c")},week:{dow:7,doy:12}}),e.defineLocale("el",{monthsNominativeEl:"\u0399\u03b1\u03bd\u03bf\u03c5\u03ac\u03c1\u03b9\u03bf\u03c2_\u03a6\u03b5\u03b2\u03c1\u03bf\u03c5\u03ac\u03c1\u03b9\u03bf\u03c2_\u039c\u03ac\u03c1\u03c4\u03b9\u03bf\u03c2_\u0391\u03c0\u03c1\u03af\u03bb\u03b9\u03bf\u03c2_\u039c\u03ac\u03b9\u03bf\u03c2_\u0399\u03bf\u03cd\u03bd\u03b9\u03bf\u03c2_\u0399\u03bf\u03cd\u03bb\u03b9\u03bf\u03c2_\u0391\u03cd\u03b3\u03bf\u03c5\u03c3\u03c4\u03bf\u03c2_\u03a3\u03b5\u03c0\u03c4\u03ad\u03bc\u03b2\u03c1\u03b9\u03bf\u03c2_\u039f\u03ba\u03c4\u03ce\u03b2\u03c1\u03b9\u03bf\u03c2_\u039d\u03bf\u03ad\u03bc\u03b2\u03c1\u03b9\u03bf\u03c2_\u0394\u03b5\u03ba\u03ad\u03bc\u03b2\u03c1\u03b9\u03bf\u03c2".split("_"),monthsGenitiveEl:"\u0399\u03b1\u03bd\u03bf\u03c5\u03b1\u03c1\u03af\u03bf\u03c5_\u03a6\u03b5\u03b2\u03c1\u03bf\u03c5\u03b1\u03c1\u03af\u03bf\u03c5_\u039c\u03b1\u03c1\u03c4\u03af\u03bf\u03c5_\u0391\u03c0\u03c1\u03b9\u03bb\u03af\u03bf\u03c5_\u039c\u03b1\u0390\u03bf\u03c5_\u0399\u03bf\u03c5\u03bd\u03af\u03bf\u03c5_\u0399\u03bf\u03c5\u03bb\u03af\u03bf\u03c5_\u0391\u03c5\u03b3\u03bf\u03cd\u03c3\u03c4\u03bf\u03c5_\u03a3\u03b5\u03c0\u03c4\u03b5\u03bc\u03b2\u03c1\u03af\u03bf\u03c5_\u039f\u03ba\u03c4\u03c9\u03b2\u03c1\u03af\u03bf\u03c5_\u039d\u03bf\u03b5\u03bc\u03b2\u03c1\u03af\u03bf\u03c5_\u0394\u03b5\u03ba\u03b5\u03bc\u03b2\u03c1\u03af\u03bf\u03c5".split("_"),months:function(e,a){return e?("string"==typeof a&&/D/.test(a.substring(0,a.indexOf("MMMM")))?this._monthsGenitiveEl:this._monthsNominativeEl)[e.month()]:this._monthsNominativeEl},monthsShort:"\u0399\u03b1\u03bd_\u03a6\u03b5\u03b2_\u039c\u03b1\u03c1_\u0391\u03c0\u03c1_\u039c\u03b1\u03ca_\u0399\u03bf\u03c5\u03bd_\u0399\u03bf\u03c5\u03bb_\u0391\u03c5\u03b3_\u03a3\u03b5\u03c0_\u039f\u03ba\u03c4_\u039d\u03bf\u03b5_\u0394\u03b5\u03ba".split("_"),weekdays:"\u039a\u03c5\u03c1\u03b9\u03b1\u03ba\u03ae_\u0394\u03b5\u03c5\u03c4\u03ad\u03c1\u03b1_\u03a4\u03c1\u03af\u03c4\u03b7_\u03a4\u03b5\u03c4\u03ac\u03c1\u03c4\u03b7_\u03a0\u03ad\u03bc\u03c0\u03c4\u03b7_\u03a0\u03b1\u03c1\u03b1\u03c3\u03ba\u03b5\u03c5\u03ae_\u03a3\u03ac\u03b2\u03b2\u03b1\u03c4\u03bf".split("_"),weekdaysShort:"\u039a\u03c5\u03c1_\u0394\u03b5\u03c5_\u03a4\u03c1\u03b9_\u03a4\u03b5\u03c4_\u03a0\u03b5\u03bc_\u03a0\u03b1\u03c1_\u03a3\u03b1\u03b2".split("_"),weekdaysMin:"\u039a\u03c5_\u0394\u03b5_\u03a4\u03c1_\u03a4\u03b5_\u03a0\u03b5_\u03a0\u03b1_\u03a3\u03b1".split("_"),meridiem:function(e,a,_){return 11<e?_?"\u03bc\u03bc":"\u039c\u039c":_?"\u03c0\u03bc":"\u03a0\u039c"},isPM:function(e){return"\u03bc"===(e+"").toLowerCase()[0]},meridiemParse:/[\u03a0\u039c]\.?\u039c?\.?/i,longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY h:mm A",LLLL:"dddd, D MMMM YYYY h:mm A"},calendarEl:{sameDay:"[\u03a3\u03ae\u03bc\u03b5\u03c1\u03b1 {}] LT",nextDay:"[\u0391\u03cd\u03c1\u03b9\u03bf {}] LT",nextWeek:"dddd [{}] LT",lastDay:"[\u03a7\u03b8\u03b5\u03c2 {}] LT",lastWeek:function(){switch(this.day()){case 6:return"[\u03c4\u03bf \u03c0\u03c1\u03bf\u03b7\u03b3\u03bf\u03cd\u03bc\u03b5\u03bd\u03bf] dddd [{}] LT";default:return"[\u03c4\u03b7\u03bd \u03c0\u03c1\u03bf\u03b7\u03b3\u03bf\u03cd\u03bc\u03b5\u03bd\u03b7] dddd [{}] LT"}},sameElse:"L"},calendar:function(e,a){var _,e=this._calendarEl[e],s=a&&a.hours();return _=e,(e="undefined"!=typeof Function&&_ instanceof Function||"[object Function]"===Object.prototype.toString.call(_)?e.apply(a):e).replace("{}",s%12==1?"\u03c3\u03c4\u03b7":"\u03c3\u03c4\u03b9\u03c2")},relativeTime:{future:"\u03c3\u03b5 %s",past:"%s \u03c0\u03c1\u03b9\u03bd",s:"\u03bb\u03af\u03b3\u03b1 \u03b4\u03b5\u03c5\u03c4\u03b5\u03c1\u03cc\u03bb\u03b5\u03c0\u03c4\u03b1",ss:"%d \u03b4\u03b5\u03c5\u03c4\u03b5\u03c1\u03cc\u03bb\u03b5\u03c0\u03c4\u03b1",m:"\u03ad\u03bd\u03b1 \u03bb\u03b5\u03c0\u03c4\u03cc",mm:"%d \u03bb\u03b5\u03c0\u03c4\u03ac",h:"\u03bc\u03af\u03b1 \u03ce\u03c1\u03b1",hh:"%d \u03ce\u03c1\u03b5\u03c2",d:"\u03bc\u03af\u03b1 \u03bc\u03ad\u03c1\u03b1",dd:"%d \u03bc\u03ad\u03c1\u03b5\u03c2",M:"\u03ad\u03bd\u03b1\u03c2 \u03bc\u03ae\u03bd\u03b1\u03c2",MM:"%d \u03bc\u03ae\u03bd\u03b5\u03c2",y:"\u03ad\u03bd\u03b1\u03c2 \u03c7\u03c1\u03cc\u03bd\u03bf\u03c2",yy:"%d \u03c7\u03c1\u03cc\u03bd\u03b9\u03b1"},dayOfMonthOrdinalParse:/\d{1,2}\u03b7/,ordinal:"%d\u03b7",week:{dow:1,doy:4}}),e.defineLocale("en-au",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY h:mm A",LLLL:"dddd, D MMMM YYYY h:mm A"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?"th":1==a?"st":2==a?"nd":3==a?"rd":"th")},week:{dow:0,doy:4}}),e.defineLocale("en-ca",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"YYYY-MM-DD",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY h:mm A",LLLL:"dddd, MMMM D, YYYY h:mm A"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?"th":1==a?"st":2==a?"nd":3==a?"rd":"th")}}),e.defineLocale("en-gb",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?"th":1==a?"st":2==a?"nd":3==a?"rd":"th")},week:{dow:1,doy:4}}),e.defineLocale("en-ie",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?"th":1==a?"st":2==a?"nd":3==a?"rd":"th")},week:{dow:1,doy:4}}),e.defineLocale("en-il",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?"th":1==a?"st":2==a?"nd":3==a?"rd":"th")}}),e.defineLocale("en-in",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY h:mm A",LLLL:"dddd, D MMMM YYYY h:mm A"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?"th":1==a?"st":2==a?"nd":3==a?"rd":"th")},week:{dow:0,doy:6}}),e.defineLocale("en-nz",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY h:mm A",LLLL:"dddd, D MMMM YYYY h:mm A"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?"th":1==a?"st":2==a?"nd":3==a?"rd":"th")},week:{dow:1,doy:4}}),e.defineLocale("en-sg",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?"th":1==a?"st":2==a?"nd":3==a?"rd":"th")},week:{dow:1,doy:4}}),e.defineLocale("eo",{months:"januaro_februaro_marto_aprilo_majo_junio_julio_a\u016dgusto_septembro_oktobro_novembro_decembro".split("_"),monthsShort:"jan_feb_mart_apr_maj_jun_jul_a\u016dg_sept_okt_nov_dec".split("_"),weekdays:"diman\u0109o_lundo_mardo_merkredo_\u0135a\u016ddo_vendredo_sabato".split("_"),weekdaysShort:"dim_lun_mard_merk_\u0135a\u016d_ven_sab".split("_"),weekdaysMin:"di_lu_ma_me_\u0135a_ve_sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"[la] D[-an de] MMMM, YYYY",LLL:"[la] D[-an de] MMMM, YYYY HH:mm",LLLL:"dddd[n], [la] D[-an de] MMMM, YYYY HH:mm",llll:"ddd, [la] D[-an de] MMM, YYYY HH:mm"},meridiemParse:/[ap]\.t\.m/i,isPM:function(e){return"p"===e.charAt(0).toLowerCase()},meridiem:function(e,a,_){return 11<e?_?"p.t.m.":"P.T.M.":_?"a.t.m.":"A.T.M."},calendar:{sameDay:"[Hodia\u016d je] LT",nextDay:"[Morga\u016d je] LT",nextWeek:"dddd[n je] LT",lastDay:"[Hiera\u016d je] LT",lastWeek:"[pasintan] dddd[n je] LT",sameElse:"L"},relativeTime:{future:"post %s",past:"anta\u016d %s",s:"kelkaj sekundoj",ss:"%d sekundoj",m:"unu minuto",mm:"%d minutoj",h:"unu horo",hh:"%d horoj",d:"unu tago",dd:"%d tagoj",M:"unu monato",MM:"%d monatoj",y:"unu jaro",yy:"%d jaroj"},dayOfMonthOrdinalParse:/\d{1,2}a/,ordinal:"%da",week:{dow:1,doy:7}});var ae="ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_"),_e="ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),m=[/^ene/i,/^feb/i,/^mar/i,/^abr/i,/^may/i,/^jun/i,/^jul/i,/^ago/i,/^sep/i,/^oct/i,/^nov/i,/^dic/i],d=/^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,se=(e.defineLocale("es-do",{months:"enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),monthsShort:function(e,a){return e?(/-MMM-/.test(a)?_e:ae)[e.month()]:ae},monthsRegex:d,monthsShortRegex:d,monthsStrictRegex:/^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,monthsShortStrictRegex:/^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,monthsParse:m,longMonthsParse:m,shortMonthsParse:m,weekdays:"domingo_lunes_martes_mi\xe9rcoles_jueves_viernes_s\xe1bado".split("_"),weekdaysShort:"dom._lun._mar._mi\xe9._jue._vie._s\xe1b.".split("_"),weekdaysMin:"do_lu_ma_mi_ju_vi_s\xe1".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY h:mm A",LLLL:"dddd, D [de] MMMM [de] YYYY h:mm A"},calendar:{sameDay:function(){return"[hoy a la"+(1!==this.hours()?"s":"")+"] LT"},nextDay:function(){return"[ma\xf1ana a la"+(1!==this.hours()?"s":"")+"] LT"},nextWeek:function(){return"dddd [a la"+(1!==this.hours()?"s":"")+"] LT"},lastDay:function(){return"[ayer a la"+(1!==this.hours()?"s":"")+"] LT"},lastWeek:function(){return"[el] dddd [pasado a la"+(1!==this.hours()?"s":"")+"] LT"},sameElse:"L"},relativeTime:{future:"en %s",past:"hace %s",s:"unos segundos",ss:"%d segundos",m:"un minuto",mm:"%d minutos",h:"una hora",hh:"%d horas",d:"un d\xeda",dd:"%d d\xedas",w:"una semana",ww:"%d semanas",M:"un mes",MM:"%d meses",y:"un a\xf1o",yy:"%d a\xf1os"},dayOfMonthOrdinalParse:/\d{1,2}\xba/,ordinal:"%d\xba",week:{dow:1,doy:4}}),"ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_")),de="ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),r=[/^ene/i,/^feb/i,/^mar/i,/^abr/i,/^may/i,/^jun/i,/^jul/i,/^ago/i,/^sep/i,/^oct/i,/^nov/i,/^dic/i],n=/^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,te=(e.defineLocale("es-mx",{months:"enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),monthsShort:function(e,a){return e?(/-MMM-/.test(a)?de:se)[e.month()]:se},monthsRegex:n,monthsShortRegex:n,monthsStrictRegex:/^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,monthsShortStrictRegex:/^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,monthsParse:r,longMonthsParse:r,shortMonthsParse:r,weekdays:"domingo_lunes_martes_mi\xe9rcoles_jueves_viernes_s\xe1bado".split("_"),weekdaysShort:"dom._lun._mar._mi\xe9._jue._vie._s\xe1b.".split("_"),weekdaysMin:"do_lu_ma_mi_ju_vi_s\xe1".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY H:mm",LLLL:"dddd, D [de] MMMM [de] YYYY H:mm"},calendar:{sameDay:function(){return"[hoy a la"+(1!==this.hours()?"s":"")+"] LT"},nextDay:function(){return"[ma\xf1ana a la"+(1!==this.hours()?"s":"")+"] LT"},nextWeek:function(){return"dddd [a la"+(1!==this.hours()?"s":"")+"] LT"},lastDay:function(){return"[ayer a la"+(1!==this.hours()?"s":"")+"] LT"},lastWeek:function(){return"[el] dddd [pasado a la"+(1!==this.hours()?"s":"")+"] LT"},sameElse:"L"},relativeTime:{future:"en %s",past:"hace %s",s:"unos segundos",ss:"%d segundos",m:"un minuto",mm:"%d minutos",h:"una hora",hh:"%d horas",d:"un d\xeda",dd:"%d d\xedas",w:"una semana",ww:"%d semanas",M:"un mes",MM:"%d meses",y:"un a\xf1o",yy:"%d a\xf1os"},dayOfMonthOrdinalParse:/\d{1,2}\xba/,ordinal:"%d\xba",week:{dow:0,doy:4},invalidDate:"Fecha inv\xe1lida"}),"ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_")),ne="ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),d=[/^ene/i,/^feb/i,/^mar/i,/^abr/i,/^may/i,/^jun/i,/^jul/i,/^ago/i,/^sep/i,/^oct/i,/^nov/i,/^dic/i],m=/^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,re=(e.defineLocale("es-us",{months:"enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),monthsShort:function(e,a){return e?(/-MMM-/.test(a)?ne:te)[e.month()]:te},monthsRegex:m,monthsShortRegex:m,monthsStrictRegex:/^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,monthsShortStrictRegex:/^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,monthsParse:d,longMonthsParse:d,shortMonthsParse:d,weekdays:"domingo_lunes_martes_mi\xe9rcoles_jueves_viernes_s\xe1bado".split("_"),weekdaysShort:"dom._lun._mar._mi\xe9._jue._vie._s\xe1b.".split("_"),weekdaysMin:"do_lu_ma_mi_ju_vi_s\xe1".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"MM/DD/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY h:mm A",LLLL:"dddd, D [de] MMMM [de] YYYY h:mm A"},calendar:{sameDay:function(){return"[hoy a la"+(1!==this.hours()?"s":"")+"] LT"},nextDay:function(){return"[ma\xf1ana a la"+(1!==this.hours()?"s":"")+"] LT"},nextWeek:function(){return"dddd [a la"+(1!==this.hours()?"s":"")+"] LT"},lastDay:function(){return"[ayer a la"+(1!==this.hours()?"s":"")+"] LT"},lastWeek:function(){return"[el] dddd [pasado a la"+(1!==this.hours()?"s":"")+"] LT"},sameElse:"L"},relativeTime:{future:"en %s",past:"hace %s",s:"unos segundos",ss:"%d segundos",m:"un minuto",mm:"%d minutos",h:"una hora",hh:"%d horas",d:"un d\xeda",dd:"%d d\xedas",w:"una semana",ww:"%d semanas",M:"un mes",MM:"%d meses",y:"un a\xf1o",yy:"%d a\xf1os"},dayOfMonthOrdinalParse:/\d{1,2}\xba/,ordinal:"%d\xba",week:{dow:0,doy:6}}),"ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_")),ie="ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),n=[/^ene/i,/^feb/i,/^mar/i,/^abr/i,/^may/i,/^jun/i,/^jul/i,/^ago/i,/^sep/i,/^oct/i,/^nov/i,/^dic/i],r=/^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;function Y(e,a,_,s){e={s:["m\xf5ne sekundi","m\xf5ni sekund","paar sekundit"],ss:[e+"sekundi",e+"sekundit"],m:["\xfche minuti","\xfcks minut"],mm:[e+" minuti",e+" minutit"],h:["\xfche tunni","tund aega","\xfcks tund"],hh:[e+" tunni",e+" tundi"],d:["\xfche p\xe4eva","\xfcks p\xe4ev"],M:["kuu aja","kuu aega","\xfcks kuu"],MM:[e+" kuu",e+" kuud"],y:["\xfche aasta","aasta","\xfcks aasta"],yy:[e+" aasta",e+" aastat"]};return a?e[_][2]||e[_][1]:s?e[_][0]:e[_][1]}e.defineLocale("es",{months:"enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),monthsShort:function(e,a){return e?(/-MMM-/.test(a)?ie:re)[e.month()]:re},monthsRegex:r,monthsShortRegex:r,monthsStrictRegex:/^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,monthsShortStrictRegex:/^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,monthsParse:n,longMonthsParse:n,shortMonthsParse:n,weekdays:"domingo_lunes_martes_mi\xe9rcoles_jueves_viernes_s\xe1bado".split("_"),weekdaysShort:"dom._lun._mar._mi\xe9._jue._vie._s\xe1b.".split("_"),weekdaysMin:"do_lu_ma_mi_ju_vi_s\xe1".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY H:mm",LLLL:"dddd, D [de] MMMM [de] YYYY H:mm"},calendar:{sameDay:function(){return"[hoy a la"+(1!==this.hours()?"s":"")+"] LT"},nextDay:function(){return"[ma\xf1ana a la"+(1!==this.hours()?"s":"")+"] LT"},nextWeek:function(){return"dddd [a la"+(1!==this.hours()?"s":"")+"] LT"},lastDay:function(){return"[ayer a la"+(1!==this.hours()?"s":"")+"] LT"},lastWeek:function(){return"[el] dddd [pasado a la"+(1!==this.hours()?"s":"")+"] LT"},sameElse:"L"},relativeTime:{future:"en %s",past:"hace %s",s:"unos segundos",ss:"%d segundos",m:"un minuto",mm:"%d minutos",h:"una hora",hh:"%d horas",d:"un d\xeda",dd:"%d d\xedas",w:"una semana",ww:"%d semanas",M:"un mes",MM:"%d meses",y:"un a\xf1o",yy:"%d a\xf1os"},dayOfMonthOrdinalParse:/\d{1,2}\xba/,ordinal:"%d\xba",week:{dow:1,doy:4},invalidDate:"Fecha inv\xe1lida"}),e.defineLocale("et",{months:"jaanuar_veebruar_m\xe4rts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember".split("_"),monthsShort:"jaan_veebr_m\xe4rts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets".split("_"),weekdays:"p\xfchap\xe4ev_esmasp\xe4ev_teisip\xe4ev_kolmap\xe4ev_neljap\xe4ev_reede_laup\xe4ev".split("_"),weekdaysShort:"P_E_T_K_N_R_L".split("_"),weekdaysMin:"P_E_T_K_N_R_L".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd, D. MMMM YYYY H:mm"},calendar:{sameDay:"[T\xe4na,] LT",nextDay:"[Homme,] LT",nextWeek:"[J\xe4rgmine] dddd LT",lastDay:"[Eile,] LT",lastWeek:"[Eelmine] dddd LT",sameElse:"L"},relativeTime:{future:"%s p\xe4rast",past:"%s tagasi",s:Y,ss:Y,m:Y,mm:Y,h:Y,hh:Y,d:Y,dd:"%d p\xe4eva",M:Y,MM:Y,y:Y,yy:Y},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),e.defineLocale("eu",{months:"urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua".split("_"),monthsShort:"urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.".split("_"),monthsParseExact:!0,weekdays:"igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata".split("_"),weekdaysShort:"ig._al._ar._az._og._ol._lr.".split("_"),weekdaysMin:"ig_al_ar_az_og_ol_lr".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"YYYY[ko] MMMM[ren] D[a]",LLL:"YYYY[ko] MMMM[ren] D[a] HH:mm",LLLL:"dddd, YYYY[ko] MMMM[ren] D[a] HH:mm",l:"YYYY-M-D",ll:"YYYY[ko] MMM D[a]",lll:"YYYY[ko] MMM D[a] HH:mm",llll:"ddd, YYYY[ko] MMM D[a] HH:mm"},calendar:{sameDay:"[gaur] LT[etan]",nextDay:"[bihar] LT[etan]",nextWeek:"dddd LT[etan]",lastDay:"[atzo] LT[etan]",lastWeek:"[aurreko] dddd LT[etan]",sameElse:"L"},relativeTime:{future:"%s barru",past:"duela %s",s:"segundo batzuk",ss:"%d segundo",m:"minutu bat",mm:"%d minutu",h:"ordu bat",hh:"%d ordu",d:"egun bat",dd:"%d egun",M:"hilabete bat",MM:"%d hilabete",y:"urte bat",yy:"%d urte"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}});var me={1:"\u06f1",2:"\u06f2",3:"\u06f3",4:"\u06f4",5:"\u06f5",6:"\u06f6",7:"\u06f7",8:"\u06f8",9:"\u06f9",0:"\u06f0"},oe={"\u06f1":"1","\u06f2":"2","\u06f3":"3","\u06f4":"4","\u06f5":"5","\u06f6":"6","\u06f7":"7","\u06f8":"8","\u06f9":"9","\u06f0":"0"},ue=(e.defineLocale("fa",{months:"\u0698\u0627\u0646\u0648\u06cc\u0647_\u0641\u0648\u0631\u06cc\u0647_\u0645\u0627\u0631\u0633_\u0622\u0648\u0631\u06cc\u0644_\u0645\u0647_\u0698\u0648\u0626\u0646_\u0698\u0648\u0626\u06cc\u0647_\u0627\u0648\u062a_\u0633\u067e\u062a\u0627\u0645\u0628\u0631_\u0627\u06a9\u062a\u0628\u0631_\u0646\u0648\u0627\u0645\u0628\u0631_\u062f\u0633\u0627\u0645\u0628\u0631".split("_"),monthsShort:"\u0698\u0627\u0646\u0648\u06cc\u0647_\u0641\u0648\u0631\u06cc\u0647_\u0645\u0627\u0631\u0633_\u0622\u0648\u0631\u06cc\u0644_\u0645\u0647_\u0698\u0648\u0626\u0646_\u0698\u0648\u0626\u06cc\u0647_\u0627\u0648\u062a_\u0633\u067e\u062a\u0627\u0645\u0628\u0631_\u0627\u06a9\u062a\u0628\u0631_\u0646\u0648\u0627\u0645\u0628\u0631_\u062f\u0633\u0627\u0645\u0628\u0631".split("_"),weekdays:"\u06cc\u06a9\u200c\u0634\u0646\u0628\u0647_\u062f\u0648\u0634\u0646\u0628\u0647_\u0633\u0647\u200c\u0634\u0646\u0628\u0647_\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647_\u067e\u0646\u062c\u200c\u0634\u0646\u0628\u0647_\u062c\u0645\u0639\u0647_\u0634\u0646\u0628\u0647".split("_"),weekdaysShort:"\u06cc\u06a9\u200c\u0634\u0646\u0628\u0647_\u062f\u0648\u0634\u0646\u0628\u0647_\u0633\u0647\u200c\u0634\u0646\u0628\u0647_\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647_\u067e\u0646\u062c\u200c\u0634\u0646\u0628\u0647_\u062c\u0645\u0639\u0647_\u0634\u0646\u0628\u0647".split("_"),weekdaysMin:"\u06cc_\u062f_\u0633_\u0686_\u067e_\u062c_\u0634".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},meridiemParse:/\u0642\u0628\u0644 \u0627\u0632 \u0638\u0647\u0631|\u0628\u0639\u062f \u0627\u0632 \u0638\u0647\u0631/,isPM:function(e){return/\u0628\u0639\u062f \u0627\u0632 \u0638\u0647\u0631/.test(e)},meridiem:function(e,a,_){return e<12?"\u0642\u0628\u0644 \u0627\u0632 \u0638\u0647\u0631":"\u0628\u0639\u062f \u0627\u0632 \u0638\u0647\u0631"},calendar:{sameDay:"[\u0627\u0645\u0631\u0648\u0632 \u0633\u0627\u0639\u062a] LT",nextDay:"[\u0641\u0631\u062f\u0627 \u0633\u0627\u0639\u062a] LT",nextWeek:"dddd [\u0633\u0627\u0639\u062a] LT",lastDay:"[\u062f\u06cc\u0631\u0648\u0632 \u0633\u0627\u0639\u062a] LT",lastWeek:"dddd [\u067e\u06cc\u0634] [\u0633\u0627\u0639\u062a] LT",sameElse:"L"},relativeTime:{future:"\u062f\u0631 %s",past:"%s \u067e\u06cc\u0634",s:"\u0686\u0646\u062f \u062b\u0627\u0646\u06cc\u0647",ss:"%d \u062b\u0627\u0646\u06cc\u0647",m:"\u06cc\u06a9 \u062f\u0642\u06cc\u0642\u0647",mm:"%d \u062f\u0642\u06cc\u0642\u0647",h:"\u06cc\u06a9 \u0633\u0627\u0639\u062a",hh:"%d \u0633\u0627\u0639\u062a",d:"\u06cc\u06a9 \u0631\u0648\u0632",dd:"%d \u0631\u0648\u0632",M:"\u06cc\u06a9 \u0645\u0627\u0647",MM:"%d \u0645\u0627\u0647",y:"\u06cc\u06a9 \u0633\u0627\u0644",yy:"%d \u0633\u0627\u0644"},preparse:function(e){return e.replace(/[\u06f0-\u06f9]/g,function(e){return oe[e]}).replace(/\u060c/g,",")},postformat:function(e){return e.replace(/\d/g,function(e){return me[e]}).replace(/,/g,"\u060c")},dayOfMonthOrdinalParse:/\d{1,2}\u0645/,ordinal:"%d\u0645",week:{dow:6,doy:12}}),"nolla yksi kaksi kolme nelj\xe4 viisi kuusi seitsem\xe4n kahdeksan yhdeks\xe4n".split(" ")),le=["nolla","yhden","kahden","kolmen","nelj\xe4n","viiden","kuuden",ue[7],ue[8],ue[9]];function h(e,a,_,s){var d="";switch(_){case"s":return s?"muutaman sekunnin":"muutama sekunti";case"ss":d=s?"sekunnin":"sekuntia";break;case"m":return s?"minuutin":"minuutti";case"mm":d=s?"minuutin":"minuuttia";break;case"h":return s?"tunnin":"tunti";case"hh":d=s?"tunnin":"tuntia";break;case"d":return s?"p\xe4iv\xe4n":"p\xe4iv\xe4";case"dd":d=s?"p\xe4iv\xe4n":"p\xe4iv\xe4\xe4";break;case"M":return s?"kuukauden":"kuukausi";case"MM":d=s?"kuukauden":"kuukautta";break;case"y":return s?"vuoden":"vuosi";case"yy":d=s?"vuoden":"vuotta";break}return _=s,d=((e=e)<10?(_?le:ue)[e]:e)+" "+d}e.defineLocale("fi",{months:"tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kes\xe4kuu_hein\xe4kuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu".split("_"),monthsShort:"tammi_helmi_maalis_huhti_touko_kes\xe4_hein\xe4_elo_syys_loka_marras_joulu".split("_"),weekdays:"sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai".split("_"),weekdaysShort:"su_ma_ti_ke_to_pe_la".split("_"),weekdaysMin:"su_ma_ti_ke_to_pe_la".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD.MM.YYYY",LL:"Do MMMM[ta] YYYY",LLL:"Do MMMM[ta] YYYY, [klo] HH.mm",LLLL:"dddd, Do MMMM[ta] YYYY, [klo] HH.mm",l:"D.M.YYYY",ll:"Do MMM YYYY",lll:"Do MMM YYYY, [klo] HH.mm",llll:"ddd, Do MMM YYYY, [klo] HH.mm"},calendar:{sameDay:"[t\xe4n\xe4\xe4n] [klo] LT",nextDay:"[huomenna] [klo] LT",nextWeek:"dddd [klo] LT",lastDay:"[eilen] [klo] LT",lastWeek:"[viime] dddd[na] [klo] LT",sameElse:"L"},relativeTime:{future:"%s p\xe4\xe4st\xe4",past:"%s sitten",s:h,ss:h,m:h,mm:h,h:h,hh:h,d:h,dd:h,M:h,MM:h,y:h,yy:h},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),e.defineLocale("fil",{months:"Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre".split("_"),monthsShort:"Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis".split("_"),weekdays:"Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado".split("_"),weekdaysShort:"Lin_Lun_Mar_Miy_Huw_Biy_Sab".split("_"),weekdaysMin:"Li_Lu_Ma_Mi_Hu_Bi_Sab".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"MM/D/YYYY",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY HH:mm",LLLL:"dddd, MMMM DD, YYYY HH:mm"},calendar:{sameDay:"LT [ngayong araw]",nextDay:"[Bukas ng] LT",nextWeek:"LT [sa susunod na] dddd",lastDay:"LT [kahapon]",lastWeek:"LT [noong nakaraang] dddd",sameElse:"L"},relativeTime:{future:"sa loob ng %s",past:"%s ang nakalipas",s:"ilang segundo",ss:"%d segundo",m:"isang minuto",mm:"%d minuto",h:"isang oras",hh:"%d oras",d:"isang araw",dd:"%d araw",M:"isang buwan",MM:"%d buwan",y:"isang taon",yy:"%d taon"},dayOfMonthOrdinalParse:/\d{1,2}/,ordinal:function(e){return e},week:{dow:1,doy:4}}),e.defineLocale("fo",{months:"januar_februar_mars_apr\xedl_mai_juni_juli_august_september_oktober_november_desember".split("_"),monthsShort:"jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des".split("_"),weekdays:"sunnudagur_m\xe1nadagur_t\xfdsdagur_mikudagur_h\xf3sdagur_fr\xedggjadagur_leygardagur".split("_"),weekdaysShort:"sun_m\xe1n_t\xfds_mik_h\xf3s_fr\xed_ley".split("_"),weekdaysMin:"su_m\xe1_t\xfd_mi_h\xf3_fr_le".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D. MMMM, YYYY HH:mm"},calendar:{sameDay:"[\xcd dag kl.] LT",nextDay:"[\xcd morgin kl.] LT",nextWeek:"dddd [kl.] LT",lastDay:"[\xcd gj\xe1r kl.] LT",lastWeek:"[s\xed\xf0stu] dddd [kl] LT",sameElse:"L"},relativeTime:{future:"um %s",past:"%s s\xed\xf0ani",s:"f\xe1 sekund",ss:"%d sekundir",m:"ein minuttur",mm:"%d minuttir",h:"ein t\xedmi",hh:"%d t\xedmar",d:"ein dagur",dd:"%d dagar",M:"ein m\xe1na\xf0ur",MM:"%d m\xe1na\xf0ir",y:"eitt \xe1r",yy:"%d \xe1r"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),e.defineLocale("fr-ca",{months:"janvier_f\xe9vrier_mars_avril_mai_juin_juillet_ao\xfbt_septembre_octobre_novembre_d\xe9cembre".split("_"),monthsShort:"janv._f\xe9vr._mars_avr._mai_juin_juil._ao\xfbt_sept._oct._nov._d\xe9c.".split("_"),monthsParseExact:!0,weekdays:"dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),weekdaysShort:"dim._lun._mar._mer._jeu._ven._sam.".split("_"),weekdaysMin:"di_lu_ma_me_je_ve_sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[Aujourd\u2019hui \xe0] LT",nextDay:"[Demain \xe0] LT",nextWeek:"dddd [\xe0] LT",lastDay:"[Hier \xe0] LT",lastWeek:"dddd [dernier \xe0] LT",sameElse:"L"},relativeTime:{future:"dans %s",past:"il y a %s",s:"quelques secondes",ss:"%d secondes",m:"une minute",mm:"%d minutes",h:"une heure",hh:"%d heures",d:"un jour",dd:"%d jours",M:"un mois",MM:"%d mois",y:"un an",yy:"%d ans"},dayOfMonthOrdinalParse:/\d{1,2}(er|e)/,ordinal:function(e,a){switch(a){default:case"M":case"Q":case"D":case"DDD":case"d":return e+(1===e?"er":"e");case"w":case"W":return e+(1===e?"re":"e")}}}),e.defineLocale("fr-ch",{months:"janvier_f\xe9vrier_mars_avril_mai_juin_juillet_ao\xfbt_septembre_octobre_novembre_d\xe9cembre".split("_"),monthsShort:"janv._f\xe9vr._mars_avr._mai_juin_juil._ao\xfbt_sept._oct._nov._d\xe9c.".split("_"),monthsParseExact:!0,weekdays:"dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),weekdaysShort:"dim._lun._mar._mer._jeu._ven._sam.".split("_"),weekdaysMin:"di_lu_ma_me_je_ve_sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[Aujourd\u2019hui \xe0] LT",nextDay:"[Demain \xe0] LT",nextWeek:"dddd [\xe0] LT",lastDay:"[Hier \xe0] LT",lastWeek:"dddd [dernier \xe0] LT",sameElse:"L"},relativeTime:{future:"dans %s",past:"il y a %s",s:"quelques secondes",ss:"%d secondes",m:"une minute",mm:"%d minutes",h:"une heure",hh:"%d heures",d:"un jour",dd:"%d jours",M:"un mois",MM:"%d mois",y:"un an",yy:"%d ans"},dayOfMonthOrdinalParse:/\d{1,2}(er|e)/,ordinal:function(e,a){switch(a){default:case"M":case"Q":case"D":case"DDD":case"d":return e+(1===e?"er":"e");case"w":case"W":return e+(1===e?"re":"e")}},week:{dow:1,doy:4}});var m=/(janv\.?|f\xe9vr\.?|mars|avr\.?|mai|juin|juil\.?|ao\xfbt|sept\.?|oct\.?|nov\.?|d\xe9c\.?|janvier|f\xe9vrier|mars|avril|mai|juin|juillet|ao\xfbt|septembre|octobre|novembre|d\xe9cembre)/i,d=[/^janv/i,/^f\xe9vr/i,/^mars/i,/^avr/i,/^mai/i,/^juin/i,/^juil/i,/^ao\xfbt/i,/^sept/i,/^oct/i,/^nov/i,/^d\xe9c/i],Me=(e.defineLocale("fr",{months:"janvier_f\xe9vrier_mars_avril_mai_juin_juillet_ao\xfbt_septembre_octobre_novembre_d\xe9cembre".split("_"),monthsShort:"janv._f\xe9vr._mars_avr._mai_juin_juil._ao\xfbt_sept._oct._nov._d\xe9c.".split("_"),monthsRegex:m,monthsShortRegex:m,monthsStrictRegex:/^(janvier|f\xe9vrier|mars|avril|mai|juin|juillet|ao\xfbt|septembre|octobre|novembre|d\xe9cembre)/i,monthsShortStrictRegex:/(janv\.?|f\xe9vr\.?|mars|avr\.?|mai|juin|juil\.?|ao\xfbt|sept\.?|oct\.?|nov\.?|d\xe9c\.?)/i,monthsParse:d,longMonthsParse:d,shortMonthsParse:d,weekdays:"dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),weekdaysShort:"dim._lun._mar._mer._jeu._ven._sam.".split("_"),weekdaysMin:"di_lu_ma_me_je_ve_sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[Aujourd\u2019hui \xe0] LT",nextDay:"[Demain \xe0] LT",nextWeek:"dddd [\xe0] LT",lastDay:"[Hier \xe0] LT",lastWeek:"dddd [dernier \xe0] LT",sameElse:"L"},relativeTime:{future:"dans %s",past:"il y a %s",s:"quelques secondes",ss:"%d secondes",m:"une minute",mm:"%d minutes",h:"une heure",hh:"%d heures",d:"un jour",dd:"%d jours",w:"une semaine",ww:"%d semaines",M:"un mois",MM:"%d mois",y:"un an",yy:"%d ans"},dayOfMonthOrdinalParse:/\d{1,2}(er|)/,ordinal:function(e,a){switch(a){case"D":return e+(1===e?"er":"");default:case"M":case"Q":case"DDD":case"d":return e+(1===e?"er":"e");case"w":case"W":return e+(1===e?"re":"e")}},week:{dow:1,doy:4}}),"jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.".split("_")),Le="jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des".split("_");e.defineLocale("fy",{months:"jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber".split("_"),monthsShort:function(e,a){return e?(/-MMM-/.test(a)?Le:Me)[e.month()]:Me},monthsParseExact:!0,weekdays:"snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon".split("_"),weekdaysShort:"si._mo._ti._wo._to._fr._so.".split("_"),weekdaysMin:"Si_Mo_Ti_Wo_To_Fr_So".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD-MM-YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[hjoed om] LT",nextDay:"[moarn om] LT",nextWeek:"dddd [om] LT",lastDay:"[juster om] LT",lastWeek:"[\xf4fr\xfbne] dddd [om] LT",sameElse:"L"},relativeTime:{future:"oer %s",past:"%s lyn",s:"in pear sekonden",ss:"%d sekonden",m:"ien min\xfat",mm:"%d minuten",h:"ien oere",hh:"%d oeren",d:"ien dei",dd:"%d dagen",M:"ien moanne",MM:"%d moannen",y:"ien jier",yy:"%d jierren"},dayOfMonthOrdinalParse:/\d{1,2}(ste|de)/,ordinal:function(e){return e+(1===e||8===e||20<=e?"ste":"de")},week:{dow:1,doy:4}}),e.defineLocale("ga",{months:["Ean\xe1ir","Feabhra","M\xe1rta","Aibre\xe1n","Bealtaine","Meitheamh","I\xfail","L\xfanasa","Me\xe1n F\xf3mhair","Deireadh F\xf3mhair","Samhain","Nollaig"],monthsShort:["Ean","Feabh","M\xe1rt","Aib","Beal","Meith","I\xfail","L\xfan","M.F.","D.F.","Samh","Noll"],monthsParseExact:!0,weekdays:["D\xe9 Domhnaigh","D\xe9 Luain","D\xe9 M\xe1irt","D\xe9 C\xe9adaoin","D\xe9ardaoin","D\xe9 hAoine","D\xe9 Sathairn"],weekdaysShort:["Domh","Luan","M\xe1irt","C\xe9ad","D\xe9ar","Aoine","Sath"],weekdaysMin:["Do","Lu","M\xe1","C\xe9","D\xe9","A","Sa"],longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Inniu ag] LT",nextDay:"[Am\xe1rach ag] LT",nextWeek:"dddd [ag] LT",lastDay:"[Inn\xe9 ag] LT",lastWeek:"dddd [seo caite] [ag] LT",sameElse:"L"},relativeTime:{future:"i %s",past:"%s \xf3 shin",s:"c\xfapla soicind",ss:"%d soicind",m:"n\xf3im\xe9ad",mm:"%d n\xf3im\xe9ad",h:"uair an chloig",hh:"%d uair an chloig",d:"l\xe1",dd:"%d l\xe1",M:"m\xed",MM:"%d m\xedonna",y:"bliain",yy:"%d bliain"},dayOfMonthOrdinalParse:/\d{1,2}(d|na|mh)/,ordinal:function(e){return e+(1===e?"d":e%10==2?"na":"mh")},week:{dow:1,doy:4}});function y(e,a,_,s){e={s:["\u0925\u094b\u0921\u092f\u093e \u0938\u0945\u0915\u0902\u0921\u093e\u0902\u0928\u0940","\u0925\u094b\u0921\u0947 \u0938\u0945\u0915\u0902\u0921"],ss:[e+" \u0938\u0945\u0915\u0902\u0921\u093e\u0902\u0928\u0940",e+" \u0938\u0945\u0915\u0902\u0921"],m:["\u090f\u0915\u093e \u092e\u093f\u0923\u091f\u093e\u0928","\u090f\u0915 \u092e\u093f\u0928\u0942\u091f"],mm:[e+" \u092e\u093f\u0923\u091f\u093e\u0902\u0928\u0940",e+" \u092e\u093f\u0923\u091f\u093e\u0902"],h:["\u090f\u0915\u093e \u0935\u0930\u093e\u0928","\u090f\u0915 \u0935\u0930"],hh:[e+" \u0935\u0930\u093e\u0902\u0928\u0940",e+" \u0935\u0930\u093e\u0902"],d:["\u090f\u0915\u093e \u0926\u093f\u0938\u093e\u0928","\u090f\u0915 \u0926\u0940\u0938"],dd:[e+" \u0926\u093f\u0938\u093e\u0902\u0928\u0940",e+" \u0926\u0940\u0938"],M:["\u090f\u0915\u093e \u092e\u094d\u0939\u092f\u0928\u094d\u092f\u093e\u0928","\u090f\u0915 \u092e\u094d\u0939\u092f\u0928\u094b"],MM:[e+" \u092e\u094d\u0939\u092f\u0928\u094d\u092f\u093e\u0928\u0940",e+" \u092e\u094d\u0939\u092f\u0928\u0947"],y:["\u090f\u0915\u093e \u0935\u0930\u094d\u0938\u093e\u0928","\u090f\u0915 \u0935\u0930\u094d\u0938"],yy:[e+" \u0935\u0930\u094d\u0938\u093e\u0902\u0928\u0940",e+" \u0935\u0930\u094d\u0938\u093e\u0902"]};return s?e[_][0]:e[_][1]}function c(e,a,_,s){e={s:["thoddea sekondamni","thodde sekond"],ss:[e+" sekondamni",e+" sekond"],m:["eka mintan","ek minut"],mm:[e+" mintamni",e+" mintam"],h:["eka voran","ek vor"],hh:[e+" voramni",e+" voram"],d:["eka disan","ek dis"],dd:[e+" disamni",e+" dis"],M:["eka mhoinean","ek mhoino"],MM:[e+" mhoineamni",e+" mhoine"],y:["eka vorsan","ek voros"],yy:[e+" vorsamni",e+" vorsam"]};return s?e[_][0]:e[_][1]}e.defineLocale("gd",{months:["Am Faoilleach","An Gearran","Am M\xe0rt","An Giblean","An C\xe8itean","An t-\xd2gmhios","An t-Iuchar","An L\xf9nastal","An t-Sultain","An D\xe0mhair","An t-Samhain","An D\xf9bhlachd"],monthsShort:["Faoi","Gear","M\xe0rt","Gibl","C\xe8it","\xd2gmh","Iuch","L\xf9n","Sult","D\xe0mh","Samh","D\xf9bh"],monthsParseExact:!0,weekdays:["Did\xf2mhnaich","Diluain","Dim\xe0irt","Diciadain","Diardaoin","Dihaoine","Disathairne"],weekdaysShort:["Did","Dil","Dim","Dic","Dia","Dih","Dis"],weekdaysMin:["D\xf2","Lu","M\xe0","Ci","Ar","Ha","Sa"],longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[An-diugh aig] LT",nextDay:"[A-m\xe0ireach aig] LT",nextWeek:"dddd [aig] LT",lastDay:"[An-d\xe8 aig] LT",lastWeek:"dddd [seo chaidh] [aig] LT",sameElse:"L"},relativeTime:{future:"ann an %s",past:"bho chionn %s",s:"beagan diogan",ss:"%d diogan",m:"mionaid",mm:"%d mionaidean",h:"uair",hh:"%d uairean",d:"latha",dd:"%d latha",M:"m\xecos",MM:"%d m\xecosan",y:"bliadhna",yy:"%d bliadhna"},dayOfMonthOrdinalParse:/\d{1,2}(d|na|mh)/,ordinal:function(e){return e+(1===e?"d":e%10==2?"na":"mh")},week:{dow:1,doy:4}}),e.defineLocale("gl",{months:"xaneiro_febreiro_marzo_abril_maio_xu\xf1o_xullo_agosto_setembro_outubro_novembro_decembro".split("_"),monthsShort:"xan._feb._mar._abr._mai._xu\xf1._xul._ago._set._out._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"domingo_luns_martes_m\xe9rcores_xoves_venres_s\xe1bado".split("_"),weekdaysShort:"dom._lun._mar._m\xe9r._xov._ven._s\xe1b.".split("_"),weekdaysMin:"do_lu_ma_m\xe9_xo_ve_s\xe1".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY H:mm",LLLL:"dddd, D [de] MMMM [de] YYYY H:mm"},calendar:{sameDay:function(){return"[hoxe "+(1!==this.hours()?"\xe1s":"\xe1")+"] LT"},nextDay:function(){return"[ma\xf1\xe1 "+(1!==this.hours()?"\xe1s":"\xe1")+"] LT"},nextWeek:function(){return"dddd ["+(1!==this.hours()?"\xe1s":"a")+"] LT"},lastDay:function(){return"[onte "+(1!==this.hours()?"\xe1":"a")+"] LT"},lastWeek:function(){return"[o] dddd [pasado "+(1!==this.hours()?"\xe1s":"a")+"] LT"},sameElse:"L"},relativeTime:{future:function(e){return 0===e.indexOf("un")?"n"+e:"en "+e},past:"hai %s",s:"uns segundos",ss:"%d segundos",m:"un minuto",mm:"%d minutos",h:"unha hora",hh:"%d horas",d:"un d\xeda",dd:"%d d\xedas",M:"un mes",MM:"%d meses",y:"un ano",yy:"%d anos"},dayOfMonthOrdinalParse:/\d{1,2}\xba/,ordinal:"%d\xba",week:{dow:1,doy:4}}),e.defineLocale("gom-deva",{months:{standalone:"\u091c\u093e\u0928\u0947\u0935\u093e\u0930\u0940_\u092b\u0947\u092c\u094d\u0930\u0941\u0935\u093e\u0930\u0940_\u092e\u093e\u0930\u094d\u091a_\u090f\u092a\u094d\u0930\u0940\u0932_\u092e\u0947_\u091c\u0942\u0928_\u091c\u0941\u0932\u092f_\u0911\u0917\u0938\u094d\u091f_\u0938\u092a\u094d\u091f\u0947\u0902\u092c\u0930_\u0911\u0915\u094d\u091f\u094b\u092c\u0930_\u0928\u094b\u0935\u094d\u0939\u0947\u0902\u092c\u0930_\u0921\u093f\u0938\u0947\u0902\u092c\u0930".split("_"),format:"\u091c\u093e\u0928\u0947\u0935\u093e\u0930\u0940\u091a\u094d\u092f\u093e_\u092b\u0947\u092c\u094d\u0930\u0941\u0935\u093e\u0930\u0940\u091a\u094d\u092f\u093e_\u092e\u093e\u0930\u094d\u091a\u093e\u091a\u094d\u092f\u093e_\u090f\u092a\u094d\u0930\u0940\u0932\u093e\u091a\u094d\u092f\u093e_\u092e\u0947\u092f\u093e\u091a\u094d\u092f\u093e_\u091c\u0942\u0928\u093e\u091a\u094d\u092f\u093e_\u091c\u0941\u0932\u092f\u093e\u091a\u094d\u092f\u093e_\u0911\u0917\u0938\u094d\u091f\u093e\u091a\u094d\u092f\u093e_\u0938\u092a\u094d\u091f\u0947\u0902\u092c\u0930\u093e\u091a\u094d\u092f\u093e_\u0911\u0915\u094d\u091f\u094b\u092c\u0930\u093e\u091a\u094d\u092f\u093e_\u0928\u094b\u0935\u094d\u0939\u0947\u0902\u092c\u0930\u093e\u091a\u094d\u092f\u093e_\u0921\u093f\u0938\u0947\u0902\u092c\u0930\u093e\u091a\u094d\u092f\u093e".split("_"),isFormat:/MMMM(\s)+D[oD]?/},monthsShort:"\u091c\u093e\u0928\u0947._\u092b\u0947\u092c\u094d\u0930\u0941._\u092e\u093e\u0930\u094d\u091a_\u090f\u092a\u094d\u0930\u0940._\u092e\u0947_\u091c\u0942\u0928_\u091c\u0941\u0932._\u0911\u0917._\u0938\u092a\u094d\u091f\u0947\u0902._\u0911\u0915\u094d\u091f\u094b._\u0928\u094b\u0935\u094d\u0939\u0947\u0902._\u0921\u093f\u0938\u0947\u0902.".split("_"),monthsParseExact:!0,weekdays:"\u0906\u092f\u0924\u093e\u0930_\u0938\u094b\u092e\u093e\u0930_\u092e\u0902\u0917\u0933\u093e\u0930_\u092c\u0941\u0927\u0935\u093e\u0930_\u092c\u093f\u0930\u0947\u0938\u094d\u0924\u093e\u0930_\u0938\u0941\u0915\u094d\u0930\u093e\u0930_\u0936\u0947\u0928\u0935\u093e\u0930".split("_"),weekdaysShort:"\u0906\u092f\u0924._\u0938\u094b\u092e._\u092e\u0902\u0917\u0933._\u092c\u0941\u0927._\u092c\u094d\u0930\u0947\u0938\u094d\u0924._\u0938\u0941\u0915\u094d\u0930._\u0936\u0947\u0928.".split("_"),weekdaysMin:"\u0906_\u0938\u094b_\u092e\u0902_\u092c\u0941_\u092c\u094d\u0930\u0947_\u0938\u0941_\u0936\u0947".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"A h:mm [\u0935\u093e\u091c\u0924\u093e\u0902]",LTS:"A h:mm:ss [\u0935\u093e\u091c\u0924\u093e\u0902]",L:"DD-MM-YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY A h:mm [\u0935\u093e\u091c\u0924\u093e\u0902]",LLLL:"dddd, MMMM Do, YYYY, A h:mm [\u0935\u093e\u091c\u0924\u093e\u0902]",llll:"ddd, D MMM YYYY, A h:mm [\u0935\u093e\u091c\u0924\u093e\u0902]"},calendar:{sameDay:"[\u0906\u092f\u091c] LT",nextDay:"[\u092b\u093e\u0932\u094d\u092f\u093e\u0902] LT",nextWeek:"[\u092b\u0941\u0921\u0932\u094b] dddd[,] LT",lastDay:"[\u0915\u093e\u0932] LT",lastWeek:"[\u092b\u093e\u091f\u0932\u094b] dddd[,] LT",sameElse:"L"},relativeTime:{future:"%s",past:"%s \u0906\u0926\u0940\u0902",s:y,ss:y,m:y,mm:y,h:y,hh:y,d:y,dd:y,M:y,MM:y,y:y,yy:y},dayOfMonthOrdinalParse:/\d{1,2}(\u0935\u0947\u0930)/,ordinal:function(e,a){switch(a){case"D":return e+"\u0935\u0947\u0930";default:case"M":case"Q":case"DDD":case"d":case"w":case"W":return e}},week:{dow:0,doy:3},meridiemParse:/\u0930\u093e\u0924\u0940|\u0938\u0915\u093e\u0933\u0940\u0902|\u0926\u0928\u092a\u093e\u0930\u093e\u0902|\u0938\u093e\u0902\u091c\u0947/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u0930\u093e\u0924\u0940"===a?e<4?e:e+12:"\u0938\u0915\u093e\u0933\u0940\u0902"===a?e:"\u0926\u0928\u092a\u093e\u0930\u093e\u0902"===a?12<e?e:e+12:"\u0938\u093e\u0902\u091c\u0947"===a?e+12:void 0},meridiem:function(e,a,_){return e<4?"\u0930\u093e\u0924\u0940":e<12?"\u0938\u0915\u093e\u0933\u0940\u0902":e<16?"\u0926\u0928\u092a\u093e\u0930\u093e\u0902":e<20?"\u0938\u093e\u0902\u091c\u0947":"\u0930\u093e\u0924\u0940"}}),e.defineLocale("gom-latn",{months:{standalone:"Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr".split("_"),format:"Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea".split("_"),isFormat:/MMMM(\s)+D[oD]?/},monthsShort:"Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.".split("_"),monthsParseExact:!0,weekdays:"Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split("_"),weekdaysShort:"Ait._Som._Mon._Bud._Bre._Suk._Son.".split("_"),weekdaysMin:"Ai_Sm_Mo_Bu_Br_Su_Sn".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"A h:mm [vazta]",LTS:"A h:mm:ss [vazta]",L:"DD-MM-YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY A h:mm [vazta]",LLLL:"dddd, MMMM Do, YYYY, A h:mm [vazta]",llll:"ddd, D MMM YYYY, A h:mm [vazta]"},calendar:{sameDay:"[Aiz] LT",nextDay:"[Faleam] LT",nextWeek:"[Fuddlo] dddd[,] LT",lastDay:"[Kal] LT",lastWeek:"[Fattlo] dddd[,] LT",sameElse:"L"},relativeTime:{future:"%s",past:"%s adim",s:c,ss:c,m:c,mm:c,h:c,hh:c,d:c,dd:c,M:c,MM:c,y:c,yy:c},dayOfMonthOrdinalParse:/\d{1,2}(er)/,ordinal:function(e,a){switch(a){case"D":return e+"er";default:case"M":case"Q":case"DDD":case"d":case"w":case"W":return e}},week:{dow:0,doy:3},meridiemParse:/rati|sokallim|donparam|sanje/,meridiemHour:function(e,a){return 12===e&&(e=0),"rati"===a?e<4?e:e+12:"sokallim"===a?e:"donparam"===a?12<e?e:e+12:"sanje"===a?e+12:void 0},meridiem:function(e,a,_){return e<4?"rati":e<12?"sokallim":e<16?"donparam":e<20?"sanje":"rati"}});var Ye={1:"\u0ae7",2:"\u0ae8",3:"\u0ae9",4:"\u0aea",5:"\u0aeb",6:"\u0aec",7:"\u0aed",8:"\u0aee",9:"\u0aef",0:"\u0ae6"},he={"\u0ae7":"1","\u0ae8":"2","\u0ae9":"3","\u0aea":"4","\u0aeb":"5","\u0aec":"6","\u0aed":"7","\u0aee":"8","\u0aef":"9","\u0ae6":"0"},ye=(e.defineLocale("gu",{months:"\u0a9c\u0abe\u0aa8\u0acd\u0aaf\u0ac1\u0a86\u0ab0\u0ac0_\u0aab\u0ac7\u0aac\u0acd\u0ab0\u0ac1\u0a86\u0ab0\u0ac0_\u0aae\u0abe\u0ab0\u0acd\u0a9a_\u0a8f\u0aaa\u0acd\u0ab0\u0abf\u0ab2_\u0aae\u0ac7_\u0a9c\u0ac2\u0aa8_\u0a9c\u0ac1\u0ab2\u0abe\u0a88_\u0a91\u0a97\u0ab8\u0acd\u0a9f_\u0ab8\u0aaa\u0acd\u0a9f\u0ac7\u0aae\u0acd\u0aac\u0ab0_\u0a91\u0a95\u0acd\u0a9f\u0acd\u0aac\u0ab0_\u0aa8\u0ab5\u0ac7\u0aae\u0acd\u0aac\u0ab0_\u0aa1\u0abf\u0ab8\u0ac7\u0aae\u0acd\u0aac\u0ab0".split("_"),monthsShort:"\u0a9c\u0abe\u0aa8\u0acd\u0aaf\u0ac1._\u0aab\u0ac7\u0aac\u0acd\u0ab0\u0ac1._\u0aae\u0abe\u0ab0\u0acd\u0a9a_\u0a8f\u0aaa\u0acd\u0ab0\u0abf._\u0aae\u0ac7_\u0a9c\u0ac2\u0aa8_\u0a9c\u0ac1\u0ab2\u0abe._\u0a91\u0a97._\u0ab8\u0aaa\u0acd\u0a9f\u0ac7._\u0a91\u0a95\u0acd\u0a9f\u0acd._\u0aa8\u0ab5\u0ac7._\u0aa1\u0abf\u0ab8\u0ac7.".split("_"),monthsParseExact:!0,weekdays:"\u0ab0\u0ab5\u0abf\u0ab5\u0abe\u0ab0_\u0ab8\u0acb\u0aae\u0ab5\u0abe\u0ab0_\u0aae\u0a82\u0a97\u0ab3\u0ab5\u0abe\u0ab0_\u0aac\u0ac1\u0aa7\u0acd\u0ab5\u0abe\u0ab0_\u0a97\u0ac1\u0ab0\u0ac1\u0ab5\u0abe\u0ab0_\u0ab6\u0ac1\u0a95\u0acd\u0ab0\u0ab5\u0abe\u0ab0_\u0ab6\u0aa8\u0abf\u0ab5\u0abe\u0ab0".split("_"),weekdaysShort:"\u0ab0\u0ab5\u0abf_\u0ab8\u0acb\u0aae_\u0aae\u0a82\u0a97\u0ab3_\u0aac\u0ac1\u0aa7\u0acd_\u0a97\u0ac1\u0ab0\u0ac1_\u0ab6\u0ac1\u0a95\u0acd\u0ab0_\u0ab6\u0aa8\u0abf".split("_"),weekdaysMin:"\u0ab0_\u0ab8\u0acb_\u0aae\u0a82_\u0aac\u0ac1_\u0a97\u0ac1_\u0ab6\u0ac1_\u0ab6".split("_"),longDateFormat:{LT:"A h:mm \u0ab5\u0abe\u0a97\u0acd\u0aaf\u0ac7",LTS:"A h:mm:ss \u0ab5\u0abe\u0a97\u0acd\u0aaf\u0ac7",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm \u0ab5\u0abe\u0a97\u0acd\u0aaf\u0ac7",LLLL:"dddd, D MMMM YYYY, A h:mm \u0ab5\u0abe\u0a97\u0acd\u0aaf\u0ac7"},calendar:{sameDay:"[\u0a86\u0a9c] LT",nextDay:"[\u0a95\u0abe\u0ab2\u0ac7] LT",nextWeek:"dddd, LT",lastDay:"[\u0a97\u0a87\u0a95\u0abe\u0ab2\u0ac7] LT",lastWeek:"[\u0aaa\u0abe\u0a9b\u0ab2\u0abe] dddd, LT",sameElse:"L"},relativeTime:{future:"%s \u0aae\u0abe",past:"%s \u0aaa\u0ab9\u0ac7\u0ab2\u0abe",s:"\u0a85\u0aae\u0ac1\u0a95 \u0aaa\u0ab3\u0acb",ss:"%d \u0ab8\u0ac7\u0a95\u0a82\u0aa1",m:"\u0a8f\u0a95 \u0aae\u0abf\u0aa8\u0abf\u0a9f",mm:"%d \u0aae\u0abf\u0aa8\u0abf\u0a9f",h:"\u0a8f\u0a95 \u0a95\u0ab2\u0abe\u0a95",hh:"%d \u0a95\u0ab2\u0abe\u0a95",d:"\u0a8f\u0a95 \u0aa6\u0abf\u0ab5\u0ab8",dd:"%d \u0aa6\u0abf\u0ab5\u0ab8",M:"\u0a8f\u0a95 \u0aae\u0ab9\u0abf\u0aa8\u0acb",MM:"%d \u0aae\u0ab9\u0abf\u0aa8\u0acb",y:"\u0a8f\u0a95 \u0ab5\u0ab0\u0acd\u0ab7",yy:"%d \u0ab5\u0ab0\u0acd\u0ab7"},preparse:function(e){return e.replace(/[\u0ae7\u0ae8\u0ae9\u0aea\u0aeb\u0aec\u0aed\u0aee\u0aef\u0ae6]/g,function(e){return he[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return Ye[e]})},meridiemParse:/\u0ab0\u0abe\u0aa4|\u0aac\u0aaa\u0acb\u0ab0|\u0ab8\u0ab5\u0abe\u0ab0|\u0ab8\u0abe\u0a82\u0a9c/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u0ab0\u0abe\u0aa4"===a?e<4?e:e+12:"\u0ab8\u0ab5\u0abe\u0ab0"===a?e:"\u0aac\u0aaa\u0acb\u0ab0"===a?10<=e?e:e+12:"\u0ab8\u0abe\u0a82\u0a9c"===a?e+12:void 0},meridiem:function(e,a,_){return e<4?"\u0ab0\u0abe\u0aa4":e<10?"\u0ab8\u0ab5\u0abe\u0ab0":e<17?"\u0aac\u0aaa\u0acb\u0ab0":e<20?"\u0ab8\u0abe\u0a82\u0a9c":"\u0ab0\u0abe\u0aa4"},week:{dow:0,doy:6}}),e.defineLocale("he",{months:"\u05d9\u05e0\u05d5\u05d0\u05e8_\u05e4\u05d1\u05e8\u05d5\u05d0\u05e8_\u05de\u05e8\u05e5_\u05d0\u05e4\u05e8\u05d9\u05dc_\u05de\u05d0\u05d9_\u05d9\u05d5\u05e0\u05d9_\u05d9\u05d5\u05dc\u05d9_\u05d0\u05d5\u05d2\u05d5\u05e1\u05d8_\u05e1\u05e4\u05d8\u05de\u05d1\u05e8_\u05d0\u05d5\u05e7\u05d8\u05d5\u05d1\u05e8_\u05e0\u05d5\u05d1\u05de\u05d1\u05e8_\u05d3\u05e6\u05de\u05d1\u05e8".split("_"),monthsShort:"\u05d9\u05e0\u05d5\u05f3_\u05e4\u05d1\u05e8\u05f3_\u05de\u05e8\u05e5_\u05d0\u05e4\u05e8\u05f3_\u05de\u05d0\u05d9_\u05d9\u05d5\u05e0\u05d9_\u05d9\u05d5\u05dc\u05d9_\u05d0\u05d5\u05d2\u05f3_\u05e1\u05e4\u05d8\u05f3_\u05d0\u05d5\u05e7\u05f3_\u05e0\u05d5\u05d1\u05f3_\u05d3\u05e6\u05de\u05f3".split("_"),weekdays:"\u05e8\u05d0\u05e9\u05d5\u05df_\u05e9\u05e0\u05d9_\u05e9\u05dc\u05d9\u05e9\u05d9_\u05e8\u05d1\u05d9\u05e2\u05d9_\u05d7\u05de\u05d9\u05e9\u05d9_\u05e9\u05d9\u05e9\u05d9_\u05e9\u05d1\u05ea".split("_"),weekdaysShort:"\u05d0\u05f3_\u05d1\u05f3_\u05d2\u05f3_\u05d3\u05f3_\u05d4\u05f3_\u05d5\u05f3_\u05e9\u05f3".split("_"),weekdaysMin:"\u05d0_\u05d1_\u05d2_\u05d3_\u05d4_\u05d5_\u05e9".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D [\u05d1]MMMM YYYY",LLL:"D [\u05d1]MMMM YYYY HH:mm",LLLL:"dddd, D [\u05d1]MMMM YYYY HH:mm",l:"D/M/YYYY",ll:"D MMM YYYY",lll:"D MMM YYYY HH:mm",llll:"ddd, D MMM YYYY HH:mm"},calendar:{sameDay:"[\u05d4\u05d9\u05d5\u05dd \u05d1\u05be]LT",nextDay:"[\u05de\u05d7\u05e8 \u05d1\u05be]LT",nextWeek:"dddd [\u05d1\u05e9\u05e2\u05d4] LT",lastDay:"[\u05d0\u05ea\u05de\u05d5\u05dc \u05d1\u05be]LT",lastWeek:"[\u05d1\u05d9\u05d5\u05dd] dddd [\u05d4\u05d0\u05d7\u05e8\u05d5\u05df \u05d1\u05e9\u05e2\u05d4] LT",sameElse:"L"},relativeTime:{future:"\u05d1\u05e2\u05d5\u05d3 %s",past:"\u05dc\u05e4\u05e0\u05d9 %s",s:"\u05de\u05e1\u05e4\u05e8 \u05e9\u05e0\u05d9\u05d5\u05ea",ss:"%d \u05e9\u05e0\u05d9\u05d5\u05ea",m:"\u05d3\u05e7\u05d4",mm:"%d \u05d3\u05e7\u05d5\u05ea",h:"\u05e9\u05e2\u05d4",hh:function(e){return 2===e?"\u05e9\u05e2\u05ea\u05d9\u05d9\u05dd":e+" \u05e9\u05e2\u05d5\u05ea"},d:"\u05d9\u05d5\u05dd",dd:function(e){return 2===e?"\u05d9\u05d5\u05de\u05d9\u05d9\u05dd":e+" \u05d9\u05de\u05d9\u05dd"},M:"\u05d7\u05d5\u05d3\u05e9",MM:function(e){return 2===e?"\u05d7\u05d5\u05d3\u05e9\u05d9\u05d9\u05dd":e+" \u05d7\u05d5\u05d3\u05e9\u05d9\u05dd"},y:"\u05e9\u05e0\u05d4",yy:function(e){return 2===e?"\u05e9\u05e0\u05ea\u05d9\u05d9\u05dd":e%10==0&&10!==e?e+" \u05e9\u05e0\u05d4":e+" \u05e9\u05e0\u05d9\u05dd"}},meridiemParse:/\u05d0\u05d7\u05d4"\u05e6|\u05dc\u05e4\u05e0\u05d4"\u05e6|\u05d0\u05d7\u05e8\u05d9 \u05d4\u05e6\u05d4\u05e8\u05d9\u05d9\u05dd|\u05dc\u05e4\u05e0\u05d9 \u05d4\u05e6\u05d4\u05e8\u05d9\u05d9\u05dd|\u05dc\u05e4\u05e0\u05d5\u05ea \u05d1\u05d5\u05e7\u05e8|\u05d1\u05d1\u05d5\u05e7\u05e8|\u05d1\u05e2\u05e8\u05d1/i,isPM:function(e){return/^(\u05d0\u05d7\u05d4"\u05e6|\u05d0\u05d7\u05e8\u05d9 \u05d4\u05e6\u05d4\u05e8\u05d9\u05d9\u05dd|\u05d1\u05e2\u05e8\u05d1)$/.test(e)},meridiem:function(e,a,_){return e<5?"\u05dc\u05e4\u05e0\u05d5\u05ea \u05d1\u05d5\u05e7\u05e8":e<10?"\u05d1\u05d1\u05d5\u05e7\u05e8":e<12?_?'\u05dc\u05e4\u05e0\u05d4"\u05e6':"\u05dc\u05e4\u05e0\u05d9 \u05d4\u05e6\u05d4\u05e8\u05d9\u05d9\u05dd":e<18?_?'\u05d0\u05d7\u05d4"\u05e6':"\u05d0\u05d7\u05e8\u05d9 \u05d4\u05e6\u05d4\u05e8\u05d9\u05d9\u05dd":"\u05d1\u05e2\u05e8\u05d1"}}),{1:"\u0967",2:"\u0968",3:"\u0969",4:"\u096a",5:"\u096b",6:"\u096c",7:"\u096d",8:"\u096e",9:"\u096f",0:"\u0966"}),ce={"\u0967":"1","\u0968":"2","\u0969":"3","\u096a":"4","\u096b":"5","\u096c":"6","\u096d":"7","\u096e":"8","\u096f":"9","\u0966":"0"},r=[/^\u091c\u0928/i,/^\u092b\u093c\u0930|\u092b\u0930/i,/^\u092e\u093e\u0930\u094d\u091a/i,/^\u0905\u092a\u094d\u0930\u0948/i,/^\u092e\u0908/i,/^\u091c\u0942\u0928/i,/^\u091c\u0941\u0932/i,/^\u0905\u0917/i,/^\u0938\u093f\u0924\u0902|\u0938\u093f\u0924/i,/^\u0905\u0915\u094d\u091f\u0942/i,/^\u0928\u0935|\u0928\u0935\u0902/i,/^\u0926\u093f\u0938\u0902|\u0926\u093f\u0938/i];function k(e,a,_){var s=e+" ";switch(_){case"ss":return s+=1===e?"sekunda":2===e||3===e||4===e?"sekunde":"sekundi";case"m":return a?"jedna minuta":"jedne minute";case"mm":return s+=1!==e&&(2===e||3===e||4===e)?"minute":"minuta";case"h":return a?"jedan sat":"jednog sata";case"hh":return s+=1===e?"sat":2===e||3===e||4===e?"sata":"sati";case"dd":return s+=1===e?"dan":"dana";case"MM":return s+=1===e?"mjesec":2===e||3===e||4===e?"mjeseca":"mjeseci";case"yy":return s+=1!==e&&(2===e||3===e||4===e)?"godine":"godina"}}e.defineLocale("hi",{months:{format:"\u091c\u0928\u0935\u0930\u0940_\u092b\u093c\u0930\u0935\u0930\u0940_\u092e\u093e\u0930\u094d\u091a_\u0905\u092a\u094d\u0930\u0948\u0932_\u092e\u0908_\u091c\u0942\u0928_\u091c\u0941\u0932\u093e\u0908_\u0905\u0917\u0938\u094d\u0924_\u0938\u093f\u0924\u092e\u094d\u092c\u0930_\u0905\u0915\u094d\u091f\u0942\u092c\u0930_\u0928\u0935\u092e\u094d\u092c\u0930_\u0926\u093f\u0938\u092e\u094d\u092c\u0930".split("_"),standalone:"\u091c\u0928\u0935\u0930\u0940_\u092b\u0930\u0935\u0930\u0940_\u092e\u093e\u0930\u094d\u091a_\u0905\u092a\u094d\u0930\u0948\u0932_\u092e\u0908_\u091c\u0942\u0928_\u091c\u0941\u0932\u093e\u0908_\u0905\u0917\u0938\u094d\u0924_\u0938\u093f\u0924\u0902\u092c\u0930_\u0905\u0915\u094d\u091f\u0942\u092c\u0930_\u0928\u0935\u0902\u092c\u0930_\u0926\u093f\u0938\u0902\u092c\u0930".split("_")},monthsShort:"\u091c\u0928._\u092b\u093c\u0930._\u092e\u093e\u0930\u094d\u091a_\u0905\u092a\u094d\u0930\u0948._\u092e\u0908_\u091c\u0942\u0928_\u091c\u0941\u0932._\u0905\u0917._\u0938\u093f\u0924._\u0905\u0915\u094d\u091f\u0942._\u0928\u0935._\u0926\u093f\u0938.".split("_"),weekdays:"\u0930\u0935\u093f\u0935\u093e\u0930_\u0938\u094b\u092e\u0935\u093e\u0930_\u092e\u0902\u0917\u0932\u0935\u093e\u0930_\u092c\u0941\u0927\u0935\u093e\u0930_\u0917\u0941\u0930\u0942\u0935\u093e\u0930_\u0936\u0941\u0915\u094d\u0930\u0935\u093e\u0930_\u0936\u0928\u093f\u0935\u093e\u0930".split("_"),weekdaysShort:"\u0930\u0935\u093f_\u0938\u094b\u092e_\u092e\u0902\u0917\u0932_\u092c\u0941\u0927_\u0917\u0941\u0930\u0942_\u0936\u0941\u0915\u094d\u0930_\u0936\u0928\u093f".split("_"),weekdaysMin:"\u0930_\u0938\u094b_\u092e\u0902_\u092c\u0941_\u0917\u0941_\u0936\u0941_\u0936".split("_"),longDateFormat:{LT:"A h:mm \u092c\u091c\u0947",LTS:"A h:mm:ss \u092c\u091c\u0947",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm \u092c\u091c\u0947",LLLL:"dddd, D MMMM YYYY, A h:mm \u092c\u091c\u0947"},monthsParse:r,longMonthsParse:r,shortMonthsParse:[/^\u091c\u0928/i,/^\u092b\u093c\u0930/i,/^\u092e\u093e\u0930\u094d\u091a/i,/^\u0905\u092a\u094d\u0930\u0948/i,/^\u092e\u0908/i,/^\u091c\u0942\u0928/i,/^\u091c\u0941\u0932/i,/^\u0905\u0917/i,/^\u0938\u093f\u0924/i,/^\u0905\u0915\u094d\u091f\u0942/i,/^\u0928\u0935/i,/^\u0926\u093f\u0938/i],monthsRegex:/^(\u091c\u0928\u0935\u0930\u0940|\u091c\u0928\.?|\u092b\u093c\u0930\u0935\u0930\u0940|\u092b\u0930\u0935\u0930\u0940|\u092b\u093c\u0930\.?|\u092e\u093e\u0930\u094d\u091a?|\u0905\u092a\u094d\u0930\u0948\u0932|\u0905\u092a\u094d\u0930\u0948\.?|\u092e\u0908?|\u091c\u0942\u0928?|\u091c\u0941\u0932\u093e\u0908|\u091c\u0941\u0932\.?|\u0905\u0917\u0938\u094d\u0924|\u0905\u0917\.?|\u0938\u093f\u0924\u092e\u094d\u092c\u0930|\u0938\u093f\u0924\u0902\u092c\u0930|\u0938\u093f\u0924\.?|\u0905\u0915\u094d\u091f\u0942\u092c\u0930|\u0905\u0915\u094d\u091f\u0942\.?|\u0928\u0935\u092e\u094d\u092c\u0930|\u0928\u0935\u0902\u092c\u0930|\u0928\u0935\.?|\u0926\u093f\u0938\u092e\u094d\u092c\u0930|\u0926\u093f\u0938\u0902\u092c\u0930|\u0926\u093f\u0938\.?)/i,monthsShortRegex:/^(\u091c\u0928\u0935\u0930\u0940|\u091c\u0928\.?|\u092b\u093c\u0930\u0935\u0930\u0940|\u092b\u0930\u0935\u0930\u0940|\u092b\u093c\u0930\.?|\u092e\u093e\u0930\u094d\u091a?|\u0905\u092a\u094d\u0930\u0948\u0932|\u0905\u092a\u094d\u0930\u0948\.?|\u092e\u0908?|\u091c\u0942\u0928?|\u091c\u0941\u0932\u093e\u0908|\u091c\u0941\u0932\.?|\u0905\u0917\u0938\u094d\u0924|\u0905\u0917\.?|\u0938\u093f\u0924\u092e\u094d\u092c\u0930|\u0938\u093f\u0924\u0902\u092c\u0930|\u0938\u093f\u0924\.?|\u0905\u0915\u094d\u091f\u0942\u092c\u0930|\u0905\u0915\u094d\u091f\u0942\.?|\u0928\u0935\u092e\u094d\u092c\u0930|\u0928\u0935\u0902\u092c\u0930|\u0928\u0935\.?|\u0926\u093f\u0938\u092e\u094d\u092c\u0930|\u0926\u093f\u0938\u0902\u092c\u0930|\u0926\u093f\u0938\.?)/i,monthsStrictRegex:/^(\u091c\u0928\u0935\u0930\u0940?|\u092b\u093c\u0930\u0935\u0930\u0940|\u092b\u0930\u0935\u0930\u0940?|\u092e\u093e\u0930\u094d\u091a?|\u0905\u092a\u094d\u0930\u0948\u0932?|\u092e\u0908?|\u091c\u0942\u0928?|\u091c\u0941\u0932\u093e\u0908?|\u0905\u0917\u0938\u094d\u0924?|\u0938\u093f\u0924\u092e\u094d\u092c\u0930|\u0938\u093f\u0924\u0902\u092c\u0930|\u0938\u093f\u0924?\.?|\u0905\u0915\u094d\u091f\u0942\u092c\u0930|\u0905\u0915\u094d\u091f\u0942\.?|\u0928\u0935\u092e\u094d\u092c\u0930|\u0928\u0935\u0902\u092c\u0930?|\u0926\u093f\u0938\u092e\u094d\u092c\u0930|\u0926\u093f\u0938\u0902\u092c\u0930?)/i,monthsShortStrictRegex:/^(\u091c\u0928\.?|\u092b\u093c\u0930\.?|\u092e\u093e\u0930\u094d\u091a?|\u0905\u092a\u094d\u0930\u0948\.?|\u092e\u0908?|\u091c\u0942\u0928?|\u091c\u0941\u0932\.?|\u0905\u0917\.?|\u0938\u093f\u0924\.?|\u0905\u0915\u094d\u091f\u0942\.?|\u0928\u0935\.?|\u0926\u093f\u0938\.?)/i,calendar:{sameDay:"[\u0906\u091c] LT",nextDay:"[\u0915\u0932] LT",nextWeek:"dddd, LT",lastDay:"[\u0915\u0932] LT",lastWeek:"[\u092a\u093f\u091b\u0932\u0947] dddd, LT",sameElse:"L"},relativeTime:{future:"%s \u092e\u0947\u0902",past:"%s \u092a\u0939\u0932\u0947",s:"\u0915\u0941\u091b \u0939\u0940 \u0915\u094d\u0937\u0923",ss:"%d \u0938\u0947\u0915\u0902\u0921",m:"\u090f\u0915 \u092e\u093f\u0928\u091f",mm:"%d \u092e\u093f\u0928\u091f",h:"\u090f\u0915 \u0918\u0902\u091f\u093e",hh:"%d \u0918\u0902\u091f\u0947",d:"\u090f\u0915 \u0926\u093f\u0928",dd:"%d \u0926\u093f\u0928",M:"\u090f\u0915 \u092e\u0939\u0940\u0928\u0947",MM:"%d \u092e\u0939\u0940\u0928\u0947",y:"\u090f\u0915 \u0935\u0930\u094d\u0937",yy:"%d \u0935\u0930\u094d\u0937"},preparse:function(e){return e.replace(/[\u0967\u0968\u0969\u096a\u096b\u096c\u096d\u096e\u096f\u0966]/g,function(e){return ce[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return ye[e]})},meridiemParse:/\u0930\u093e\u0924|\u0938\u0941\u092c\u0939|\u0926\u094b\u092a\u0939\u0930|\u0936\u093e\u092e/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u0930\u093e\u0924"===a?e<4?e:e+12:"\u0938\u0941\u092c\u0939"===a?e:"\u0926\u094b\u092a\u0939\u0930"===a?10<=e?e:e+12:"\u0936\u093e\u092e"===a?e+12:void 0},meridiem:function(e,a,_){return e<4?"\u0930\u093e\u0924":e<10?"\u0938\u0941\u092c\u0939":e<17?"\u0926\u094b\u092a\u0939\u0930":e<20?"\u0936\u093e\u092e":"\u0930\u093e\u0924"},week:{dow:0,doy:6}}),e.defineLocale("hr",{months:{format:"sije\u010dnja_velja\u010de_o\u017eujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca".split("_"),standalone:"sije\u010danj_velja\u010da_o\u017eujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac".split("_")},monthsShort:"sij._velj._o\u017eu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.".split("_"),monthsParseExact:!0,weekdays:"nedjelja_ponedjeljak_utorak_srijeda_\u010detvrtak_petak_subota".split("_"),weekdaysShort:"ned._pon._uto._sri._\u010det._pet._sub.".split("_"),weekdaysMin:"ne_po_ut_sr_\u010de_pe_su".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"Do MMMM YYYY",LLL:"Do MMMM YYYY H:mm",LLLL:"dddd, Do MMMM YYYY H:mm"},calendar:{sameDay:"[danas u] LT",nextDay:"[sutra u] LT",nextWeek:function(){switch(this.day()){case 0:return"[u] [nedjelju] [u] LT";case 3:return"[u] [srijedu] [u] LT";case 6:return"[u] [subotu] [u] LT";case 1:case 2:case 4:case 5:return"[u] dddd [u] LT"}},lastDay:"[ju\u010der u] LT",lastWeek:function(){switch(this.day()){case 0:return"[pro\u0161lu] [nedjelju] [u] LT";case 3:return"[pro\u0161lu] [srijedu] [u] LT";case 6:return"[pro\u0161le] [subote] [u] LT";case 1:case 2:case 4:case 5:return"[pro\u0161li] dddd [u] LT"}},sameElse:"L"},relativeTime:{future:"za %s",past:"prije %s",s:"par sekundi",ss:k,m:k,mm:k,h:k,hh:k,d:"dan",dd:k,M:"mjesec",MM:k,y:"godinu",yy:k},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}});var ke="vas\xe1rnap h\xe9tf\u0151n kedden szerd\xe1n cs\xfct\xf6rt\xf6k\xf6n p\xe9nteken szombaton".split(" ");function D(e,a,_,s){var d=e;switch(_){case"s":return s||a?"n\xe9h\xe1ny m\xe1sodperc":"n\xe9h\xe1ny m\xe1sodperce";case"ss":return d+(s||a)?" m\xe1sodperc":" m\xe1sodperce";case"m":return"egy"+(s||a?" perc":" perce");case"mm":return d+(s||a?" perc":" perce");case"h":return"egy"+(s||a?" \xf3ra":" \xf3r\xe1ja");case"hh":return d+(s||a?" \xf3ra":" \xf3r\xe1ja");case"d":return"egy"+(s||a?" nap":" napja");case"dd":return d+(s||a?" nap":" napja");case"M":return"egy"+(s||a?" h\xf3nap":" h\xf3napja");case"MM":return d+(s||a?" h\xf3nap":" h\xf3napja");case"y":return"egy"+(s||a?" \xe9v":" \xe9ve");case"yy":return d+(s||a?" \xe9v":" \xe9ve")}return""}function De(e){return(e?"":"[m\xfalt] ")+"["+ke[this.day()]+"] LT[-kor]"}function p(e){return e%100==11||e%10!=1}function T(e,a,_,s){var d=e+" ";switch(_){case"s":return a||s?"nokkrar sek\xfandur":"nokkrum sek\xfandum";case"ss":return p(e)?d+(a||s?"sek\xfandur":"sek\xfandum"):d+"sek\xfanda";case"m":return a?"m\xedn\xfata":"m\xedn\xfatu";case"mm":return p(e)?d+(a||s?"m\xedn\xfatur":"m\xedn\xfatum"):a?d+"m\xedn\xfata":d+"m\xedn\xfatu";case"hh":return p(e)?d+(a||s?"klukkustundir":"klukkustundum"):d+"klukkustund";case"d":return a?"dagur":s?"dag":"degi";case"dd":return p(e)?a?d+"dagar":d+(s?"daga":"d\xf6gum"):a?d+"dagur":d+(s?"dag":"degi");case"M":return a?"m\xe1nu\xf0ur":s?"m\xe1nu\xf0":"m\xe1nu\xf0i";case"MM":return p(e)?a?d+"m\xe1nu\xf0ir":d+(s?"m\xe1nu\xf0i":"m\xe1nu\xf0um"):a?d+"m\xe1nu\xf0ur":d+(s?"m\xe1nu\xf0":"m\xe1nu\xf0i");case"y":return a||s?"\xe1r":"\xe1ri";case"yy":return p(e)?d+(a||s?"\xe1r":"\xe1rum"):d+(a||s?"\xe1r":"\xe1ri")}}e.defineLocale("hu",{months:"janu\xe1r_febru\xe1r_m\xe1rcius_\xe1prilis_m\xe1jus_j\xfanius_j\xfalius_augusztus_szeptember_okt\xf3ber_november_december".split("_"),monthsShort:"jan._feb._m\xe1rc._\xe1pr._m\xe1j._j\xfan._j\xfal._aug._szept._okt._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"vas\xe1rnap_h\xe9tf\u0151_kedd_szerda_cs\xfct\xf6rt\xf6k_p\xe9ntek_szombat".split("_"),weekdaysShort:"vas_h\xe9t_kedd_sze_cs\xfct_p\xe9n_szo".split("_"),weekdaysMin:"v_h_k_sze_cs_p_szo".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"YYYY.MM.DD.",LL:"YYYY. MMMM D.",LLL:"YYYY. MMMM D. H:mm",LLLL:"YYYY. MMMM D., dddd H:mm"},meridiemParse:/de|du/i,isPM:function(e){return"u"===e.charAt(1).toLowerCase()},meridiem:function(e,a,_){return e<12?!0===_?"de":"DE":!0===_?"du":"DU"},calendar:{sameDay:"[ma] LT[-kor]",nextDay:"[holnap] LT[-kor]",nextWeek:function(){return De.call(this,!0)},lastDay:"[tegnap] LT[-kor]",lastWeek:function(){return De.call(this,!1)},sameElse:"L"},relativeTime:{future:"%s m\xfalva",past:"%s",s:D,ss:D,m:D,mm:D,h:D,hh:D,d:D,dd:D,M:D,MM:D,y:D,yy:D},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),e.defineLocale("hy-am",{months:{format:"\u0570\u0578\u0582\u0576\u057e\u0561\u0580\u056b_\u0583\u0565\u057f\u0580\u057e\u0561\u0580\u056b_\u0574\u0561\u0580\u057f\u056b_\u0561\u057a\u0580\u056b\u056c\u056b_\u0574\u0561\u0575\u056b\u057d\u056b_\u0570\u0578\u0582\u0576\u056b\u057d\u056b_\u0570\u0578\u0582\u056c\u056b\u057d\u056b_\u0585\u0563\u0578\u057d\u057f\u0578\u057d\u056b_\u057d\u0565\u057a\u057f\u0565\u0574\u0562\u0565\u0580\u056b_\u0570\u0578\u056f\u057f\u0565\u0574\u0562\u0565\u0580\u056b_\u0576\u0578\u0575\u0565\u0574\u0562\u0565\u0580\u056b_\u0564\u0565\u056f\u057f\u0565\u0574\u0562\u0565\u0580\u056b".split("_"),standalone:"\u0570\u0578\u0582\u0576\u057e\u0561\u0580_\u0583\u0565\u057f\u0580\u057e\u0561\u0580_\u0574\u0561\u0580\u057f_\u0561\u057a\u0580\u056b\u056c_\u0574\u0561\u0575\u056b\u057d_\u0570\u0578\u0582\u0576\u056b\u057d_\u0570\u0578\u0582\u056c\u056b\u057d_\u0585\u0563\u0578\u057d\u057f\u0578\u057d_\u057d\u0565\u057a\u057f\u0565\u0574\u0562\u0565\u0580_\u0570\u0578\u056f\u057f\u0565\u0574\u0562\u0565\u0580_\u0576\u0578\u0575\u0565\u0574\u0562\u0565\u0580_\u0564\u0565\u056f\u057f\u0565\u0574\u0562\u0565\u0580".split("_")},monthsShort:"\u0570\u0576\u057e_\u0583\u057f\u0580_\u0574\u0580\u057f_\u0561\u057a\u0580_\u0574\u0575\u057d_\u0570\u0576\u057d_\u0570\u056c\u057d_\u0585\u0563\u057d_\u057d\u057a\u057f_\u0570\u056f\u057f_\u0576\u0574\u0562_\u0564\u056f\u057f".split("_"),weekdays:"\u056f\u056b\u0580\u0561\u056f\u056b_\u0565\u0580\u056f\u0578\u0582\u0577\u0561\u0562\u0569\u056b_\u0565\u0580\u0565\u0584\u0577\u0561\u0562\u0569\u056b_\u0579\u0578\u0580\u0565\u0584\u0577\u0561\u0562\u0569\u056b_\u0570\u056b\u0576\u0563\u0577\u0561\u0562\u0569\u056b_\u0578\u0582\u0580\u0562\u0561\u0569_\u0577\u0561\u0562\u0561\u0569".split("_"),weekdaysShort:"\u056f\u0580\u056f_\u0565\u0580\u056f_\u0565\u0580\u0584_\u0579\u0580\u0584_\u0570\u0576\u0563_\u0578\u0582\u0580\u0562_\u0577\u0562\u0569".split("_"),weekdaysMin:"\u056f\u0580\u056f_\u0565\u0580\u056f_\u0565\u0580\u0584_\u0579\u0580\u0584_\u0570\u0576\u0563_\u0578\u0582\u0580\u0562_\u0577\u0562\u0569".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY \u0569.",LLL:"D MMMM YYYY \u0569., HH:mm",LLLL:"dddd, D MMMM YYYY \u0569., HH:mm"},calendar:{sameDay:"[\u0561\u0575\u057d\u0585\u0580] LT",nextDay:"[\u057e\u0561\u0572\u0568] LT",lastDay:"[\u0565\u0580\u0565\u056f] LT",nextWeek:function(){return"dddd [\u0585\u0580\u0568 \u056a\u0561\u0574\u0568] LT"},lastWeek:function(){return"[\u0561\u0576\u0581\u0561\u056e] dddd [\u0585\u0580\u0568 \u056a\u0561\u0574\u0568] LT"},sameElse:"L"},relativeTime:{future:"%s \u0570\u0565\u057f\u0578",past:"%s \u0561\u057c\u0561\u057b",s:"\u0574\u056b \u0584\u0561\u0576\u056b \u057e\u0561\u0575\u0580\u056f\u0575\u0561\u0576",ss:"%d \u057e\u0561\u0575\u0580\u056f\u0575\u0561\u0576",m:"\u0580\u0578\u057a\u0565",mm:"%d \u0580\u0578\u057a\u0565",h:"\u056a\u0561\u0574",hh:"%d \u056a\u0561\u0574",d:"\u0585\u0580",dd:"%d \u0585\u0580",M:"\u0561\u0574\u056b\u057d",MM:"%d \u0561\u0574\u056b\u057d",y:"\u057f\u0561\u0580\u056b",yy:"%d \u057f\u0561\u0580\u056b"},meridiemParse:/\u0563\u056b\u0577\u0565\u0580\u057e\u0561|\u0561\u057c\u0561\u057e\u0578\u057f\u057e\u0561|\u0581\u0565\u0580\u0565\u056f\u057e\u0561|\u0565\u0580\u0565\u056f\u0578\u0575\u0561\u0576/,isPM:function(e){return/^(\u0581\u0565\u0580\u0565\u056f\u057e\u0561|\u0565\u0580\u0565\u056f\u0578\u0575\u0561\u0576)$/.test(e)},meridiem:function(e){return e<4?"\u0563\u056b\u0577\u0565\u0580\u057e\u0561":e<12?"\u0561\u057c\u0561\u057e\u0578\u057f\u057e\u0561":e<17?"\u0581\u0565\u0580\u0565\u056f\u057e\u0561":"\u0565\u0580\u0565\u056f\u0578\u0575\u0561\u0576"},dayOfMonthOrdinalParse:/\d{1,2}|\d{1,2}-(\u056b\u0576|\u0580\u0564)/,ordinal:function(e,a){switch(a){case"DDD":case"w":case"W":case"DDDo":return 1===e?e+"-\u056b\u0576":e+"-\u0580\u0564";default:return e}},week:{dow:1,doy:7}}),e.defineLocale("id",{months:"Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember".split("_"),monthsShort:"Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des".split("_"),weekdays:"Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu".split("_"),weekdaysShort:"Min_Sen_Sel_Rab_Kam_Jum_Sab".split("_"),weekdaysMin:"Mg_Sn_Sl_Rb_Km_Jm_Sb".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [pukul] HH.mm",LLLL:"dddd, D MMMM YYYY [pukul] HH.mm"},meridiemParse:/pagi|siang|sore|malam/,meridiemHour:function(e,a){return 12===e&&(e=0),"pagi"===a?e:"siang"===a?11<=e?e:e+12:"sore"===a||"malam"===a?e+12:void 0},meridiem:function(e,a,_){return e<11?"pagi":e<15?"siang":e<19?"sore":"malam"},calendar:{sameDay:"[Hari ini pukul] LT",nextDay:"[Besok pukul] LT",nextWeek:"dddd [pukul] LT",lastDay:"[Kemarin pukul] LT",lastWeek:"dddd [lalu pukul] LT",sameElse:"L"},relativeTime:{future:"dalam %s",past:"%s yang lalu",s:"beberapa detik",ss:"%d detik",m:"semenit",mm:"%d menit",h:"sejam",hh:"%d jam",d:"sehari",dd:"%d hari",M:"sebulan",MM:"%d bulan",y:"setahun",yy:"%d tahun"},week:{dow:0,doy:6}}),e.defineLocale("is",{months:"jan\xfaar_febr\xfaar_mars_apr\xedl_ma\xed_j\xfan\xed_j\xfal\xed_\xe1g\xfast_september_okt\xf3ber_n\xf3vember_desember".split("_"),monthsShort:"jan_feb_mar_apr_ma\xed_j\xfan_j\xfal_\xe1g\xfa_sep_okt_n\xf3v_des".split("_"),weekdays:"sunnudagur_m\xe1nudagur_\xferi\xf0judagur_mi\xf0vikudagur_fimmtudagur_f\xf6studagur_laugardagur".split("_"),weekdaysShort:"sun_m\xe1n_\xferi_mi\xf0_fim_f\xf6s_lau".split("_"),weekdaysMin:"Su_M\xe1_\xder_Mi_Fi_F\xf6_La".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY [kl.] H:mm",LLLL:"dddd, D. MMMM YYYY [kl.] H:mm"},calendar:{sameDay:"[\xed dag kl.] LT",nextDay:"[\xe1 morgun kl.] LT",nextWeek:"dddd [kl.] LT",lastDay:"[\xed g\xe6r kl.] LT",lastWeek:"[s\xed\xf0asta] dddd [kl.] LT",sameElse:"L"},relativeTime:{future:"eftir %s",past:"fyrir %s s\xed\xf0an",s:T,ss:T,m:T,mm:T,h:"klukkustund",hh:T,d:T,dd:T,M:T,MM:T,y:T,yy:T},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),e.defineLocale("it-ch",{months:"gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split("_"),monthsShort:"gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"),weekdays:"domenica_luned\xec_marted\xec_mercoled\xec_gioved\xec_venerd\xec_sabato".split("_"),weekdaysShort:"dom_lun_mar_mer_gio_ven_sab".split("_"),weekdaysMin:"do_lu_ma_me_gi_ve_sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[Oggi alle] LT",nextDay:"[Domani alle] LT",nextWeek:"dddd [alle] LT",lastDay:"[Ieri alle] LT",lastWeek:function(){switch(this.day()){case 0:return"[la scorsa] dddd [alle] LT";default:return"[lo scorso] dddd [alle] LT"}},sameElse:"L"},relativeTime:{future:function(e){return(/^[0-9].+$/.test(e)?"tra":"in")+" "+e},past:"%s fa",s:"alcuni secondi",ss:"%d secondi",m:"un minuto",mm:"%d minuti",h:"un'ora",hh:"%d ore",d:"un giorno",dd:"%d giorni",M:"un mese",MM:"%d mesi",y:"un anno",yy:"%d anni"},dayOfMonthOrdinalParse:/\d{1,2}\xba/,ordinal:"%d\xba",week:{dow:1,doy:4}}),e.defineLocale("it",{months:"gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split("_"),monthsShort:"gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"),weekdays:"domenica_luned\xec_marted\xec_mercoled\xec_gioved\xec_venerd\xec_sabato".split("_"),weekdaysShort:"dom_lun_mar_mer_gio_ven_sab".split("_"),weekdaysMin:"do_lu_ma_me_gi_ve_sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:function(){return"[Oggi a"+(1<this.hours()?"lle ":0===this.hours()?" ":"ll'")+"]LT"},nextDay:function(){return"[Domani a"+(1<this.hours()?"lle ":0===this.hours()?" ":"ll'")+"]LT"},nextWeek:function(){return"dddd [a"+(1<this.hours()?"lle ":0===this.hours()?" ":"ll'")+"]LT"},lastDay:function(){return"[Ieri a"+(1<this.hours()?"lle ":0===this.hours()?" ":"ll'")+"]LT"},lastWeek:function(){switch(this.day()){case 0:return"[La scorsa] dddd [a"+(1<this.hours()?"lle ":0===this.hours()?" ":"ll'")+"]LT";default:return"[Lo scorso] dddd [a"+(1<this.hours()?"lle ":0===this.hours()?" ":"ll'")+"]LT"}},sameElse:"L"},relativeTime:{future:"tra %s",past:"%s fa",s:"alcuni secondi",ss:"%d secondi",m:"un minuto",mm:"%d minuti",h:"un'ora",hh:"%d ore",d:"un giorno",dd:"%d giorni",w:"una settimana",ww:"%d settimane",M:"un mese",MM:"%d mesi",y:"un anno",yy:"%d anni"},dayOfMonthOrdinalParse:/\d{1,2}\xba/,ordinal:"%d\xba",week:{dow:1,doy:4}}),e.defineLocale("ja",{eras:[{since:"2019-05-01",offset:1,name:"\u4ee4\u548c",narrow:"\u32ff",abbr:"R"},{since:"1989-01-08",until:"2019-04-30",offset:1,name:"\u5e73\u6210",narrow:"\u337b",abbr:"H"},{since:"1926-12-25",until:"1989-01-07",offset:1,name:"\u662d\u548c",narrow:"\u337c",abbr:"S"},{since:"1912-07-30",until:"1926-12-24",offset:1,name:"\u5927\u6b63",narrow:"\u337d",abbr:"T"},{since:"1873-01-01",until:"1912-07-29",offset:6,name:"\u660e\u6cbb",narrow:"\u337e",abbr:"M"},{since:"0001-01-01",until:"1873-12-31",offset:1,name:"\u897f\u66a6",narrow:"AD",abbr:"AD"},{since:"0000-12-31",until:-1/0,offset:1,name:"\u7d00\u5143\u524d",narrow:"BC",abbr:"BC"}],eraYearOrdinalRegex:/(\u5143|\d+)\u5e74/,eraYearOrdinalParse:function(e,a){return"\u5143"===a[1]?1:parseInt(a[1]||e,10)},months:"1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split("_"),monthsShort:"1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split("_"),weekdays:"\u65e5\u66dc\u65e5_\u6708\u66dc\u65e5_\u706b\u66dc\u65e5_\u6c34\u66dc\u65e5_\u6728\u66dc\u65e5_\u91d1\u66dc\u65e5_\u571f\u66dc\u65e5".split("_"),weekdaysShort:"\u65e5_\u6708_\u706b_\u6c34_\u6728_\u91d1_\u571f".split("_"),weekdaysMin:"\u65e5_\u6708_\u706b_\u6c34_\u6728_\u91d1_\u571f".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY/MM/DD",LL:"YYYY\u5e74M\u6708D\u65e5",LLL:"YYYY\u5e74M\u6708D\u65e5 HH:mm",LLLL:"YYYY\u5e74M\u6708D\u65e5 dddd HH:mm",l:"YYYY/MM/DD",ll:"YYYY\u5e74M\u6708D\u65e5",lll:"YYYY\u5e74M\u6708D\u65e5 HH:mm",llll:"YYYY\u5e74M\u6708D\u65e5(ddd) HH:mm"},meridiemParse:/\u5348\u524d|\u5348\u5f8c/i,isPM:function(e){return"\u5348\u5f8c"===e},meridiem:function(e,a,_){return e<12?"\u5348\u524d":"\u5348\u5f8c"},calendar:{sameDay:"[\u4eca\u65e5] LT",nextDay:"[\u660e\u65e5] LT",nextWeek:function(e){return e.week()!==this.week()?"[\u6765\u9031]dddd LT":"dddd LT"},lastDay:"[\u6628\u65e5] LT",lastWeek:function(e){return this.week()!==e.week()?"[\u5148\u9031]dddd LT":"dddd LT"},sameElse:"L"},dayOfMonthOrdinalParse:/\d{1,2}\u65e5/,ordinal:function(e,a){switch(a){case"y":return 1===e?"\u5143\u5e74":e+"\u5e74";case"d":case"D":case"DDD":return e+"\u65e5";default:return e}},relativeTime:{future:"%s\u5f8c",past:"%s\u524d",s:"\u6570\u79d2",ss:"%d\u79d2",m:"1\u5206",mm:"%d\u5206",h:"1\u6642\u9593",hh:"%d\u6642\u9593",d:"1\u65e5",dd:"%d\u65e5",M:"1\u30f6\u6708",MM:"%d\u30f6\u6708",y:"1\u5e74",yy:"%d\u5e74"}}),e.defineLocale("jv",{months:"Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember".split("_"),monthsShort:"Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des".split("_"),weekdays:"Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu".split("_"),weekdaysShort:"Min_Sen_Sel_Reb_Kem_Jem_Sep".split("_"),weekdaysMin:"Mg_Sn_Sl_Rb_Km_Jm_Sp".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [pukul] HH.mm",LLLL:"dddd, D MMMM YYYY [pukul] HH.mm"},meridiemParse:/enjing|siyang|sonten|ndalu/,meridiemHour:function(e,a){return 12===e&&(e=0),"enjing"===a?e:"siyang"===a?11<=e?e:e+12:"sonten"===a||"ndalu"===a?e+12:void 0},meridiem:function(e,a,_){return e<11?"enjing":e<15?"siyang":e<19?"sonten":"ndalu"},calendar:{sameDay:"[Dinten puniko pukul] LT",nextDay:"[Mbenjang pukul] LT",nextWeek:"dddd [pukul] LT",lastDay:"[Kala wingi pukul] LT",lastWeek:"dddd [kepengker pukul] LT",sameElse:"L"},relativeTime:{future:"wonten ing %s",past:"%s ingkang kepengker",s:"sawetawis detik",ss:"%d detik",m:"setunggal menit",mm:"%d menit",h:"setunggal jam",hh:"%d jam",d:"sedinten",dd:"%d dinten",M:"sewulan",MM:"%d wulan",y:"setaun",yy:"%d taun"},week:{dow:1,doy:7}}),e.defineLocale("ka",{months:"\u10d8\u10d0\u10dc\u10d5\u10d0\u10e0\u10d8_\u10d7\u10d4\u10d1\u10d4\u10e0\u10d5\u10d0\u10da\u10d8_\u10db\u10d0\u10e0\u10e2\u10d8_\u10d0\u10de\u10e0\u10d8\u10da\u10d8_\u10db\u10d0\u10d8\u10e1\u10d8_\u10d8\u10d5\u10dc\u10d8\u10e1\u10d8_\u10d8\u10d5\u10da\u10d8\u10e1\u10d8_\u10d0\u10d2\u10d5\u10d8\u10e1\u10e2\u10dd_\u10e1\u10d4\u10e5\u10e2\u10d4\u10db\u10d1\u10d4\u10e0\u10d8_\u10dd\u10e5\u10e2\u10dd\u10db\u10d1\u10d4\u10e0\u10d8_\u10dc\u10dd\u10d4\u10db\u10d1\u10d4\u10e0\u10d8_\u10d3\u10d4\u10d9\u10d4\u10db\u10d1\u10d4\u10e0\u10d8".split("_"),monthsShort:"\u10d8\u10d0\u10dc_\u10d7\u10d4\u10d1_\u10db\u10d0\u10e0_\u10d0\u10de\u10e0_\u10db\u10d0\u10d8_\u10d8\u10d5\u10dc_\u10d8\u10d5\u10da_\u10d0\u10d2\u10d5_\u10e1\u10d4\u10e5_\u10dd\u10e5\u10e2_\u10dc\u10dd\u10d4_\u10d3\u10d4\u10d9".split("_"),weekdays:{standalone:"\u10d9\u10d5\u10d8\u10e0\u10d0_\u10dd\u10e0\u10e8\u10d0\u10d1\u10d0\u10d7\u10d8_\u10e1\u10d0\u10db\u10e8\u10d0\u10d1\u10d0\u10d7\u10d8_\u10dd\u10d7\u10ee\u10e8\u10d0\u10d1\u10d0\u10d7\u10d8_\u10ee\u10e3\u10d7\u10e8\u10d0\u10d1\u10d0\u10d7\u10d8_\u10de\u10d0\u10e0\u10d0\u10e1\u10d9\u10d4\u10d5\u10d8_\u10e8\u10d0\u10d1\u10d0\u10d7\u10d8".split("_"),format:"\u10d9\u10d5\u10d8\u10e0\u10d0\u10e1_\u10dd\u10e0\u10e8\u10d0\u10d1\u10d0\u10d7\u10e1_\u10e1\u10d0\u10db\u10e8\u10d0\u10d1\u10d0\u10d7\u10e1_\u10dd\u10d7\u10ee\u10e8\u10d0\u10d1\u10d0\u10d7\u10e1_\u10ee\u10e3\u10d7\u10e8\u10d0\u10d1\u10d0\u10d7\u10e1_\u10de\u10d0\u10e0\u10d0\u10e1\u10d9\u10d4\u10d5\u10e1_\u10e8\u10d0\u10d1\u10d0\u10d7\u10e1".split("_"),isFormat:/(\u10ec\u10d8\u10dc\u10d0|\u10e8\u10d4\u10db\u10d3\u10d4\u10d2)/},weekdaysShort:"\u10d9\u10d5\u10d8_\u10dd\u10e0\u10e8_\u10e1\u10d0\u10db_\u10dd\u10d7\u10ee_\u10ee\u10e3\u10d7_\u10de\u10d0\u10e0_\u10e8\u10d0\u10d1".split("_"),weekdaysMin:"\u10d9\u10d5_\u10dd\u10e0_\u10e1\u10d0_\u10dd\u10d7_\u10ee\u10e3_\u10de\u10d0_\u10e8\u10d0".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[\u10d3\u10e6\u10d4\u10e1] LT[-\u10d6\u10d4]",nextDay:"[\u10ee\u10d5\u10d0\u10da] LT[-\u10d6\u10d4]",lastDay:"[\u10d2\u10e3\u10e8\u10d8\u10dc] LT[-\u10d6\u10d4]",nextWeek:"[\u10e8\u10d4\u10db\u10d3\u10d4\u10d2] dddd LT[-\u10d6\u10d4]",lastWeek:"[\u10ec\u10d8\u10dc\u10d0] dddd LT-\u10d6\u10d4",sameElse:"L"},relativeTime:{future:function(e){return e.replace(/(\u10ec\u10d0\u10db|\u10ec\u10e3\u10d7|\u10e1\u10d0\u10d0\u10d7|\u10ec\u10d4\u10da|\u10d3\u10e6|\u10d7\u10d5)(\u10d8|\u10d4)/,function(e,a,_){return"\u10d8"===_?a+"\u10e8\u10d8":a+_+"\u10e8\u10d8"})},past:function(e){return/(\u10ec\u10d0\u10db\u10d8|\u10ec\u10e3\u10d7\u10d8|\u10e1\u10d0\u10d0\u10d7\u10d8|\u10d3\u10e6\u10d4|\u10d7\u10d5\u10d4)/.test(e)?e.replace(/(\u10d8|\u10d4)$/,"\u10d8\u10e1 \u10ec\u10d8\u10dc"):/\u10ec\u10d4\u10da\u10d8/.test(e)?e.replace(/\u10ec\u10d4\u10da\u10d8$/,"\u10ec\u10da\u10d8\u10e1 \u10ec\u10d8\u10dc"):e},s:"\u10e0\u10d0\u10db\u10d3\u10d4\u10dc\u10d8\u10db\u10d4 \u10ec\u10d0\u10db\u10d8",ss:"%d \u10ec\u10d0\u10db\u10d8",m:"\u10ec\u10e3\u10d7\u10d8",mm:"%d \u10ec\u10e3\u10d7\u10d8",h:"\u10e1\u10d0\u10d0\u10d7\u10d8",hh:"%d \u10e1\u10d0\u10d0\u10d7\u10d8",d:"\u10d3\u10e6\u10d4",dd:"%d \u10d3\u10e6\u10d4",M:"\u10d7\u10d5\u10d4",MM:"%d \u10d7\u10d5\u10d4",y:"\u10ec\u10d4\u10da\u10d8",yy:"%d \u10ec\u10d4\u10da\u10d8"},dayOfMonthOrdinalParse:/0|1-\u10da\u10d8|\u10db\u10d4-\d{1,2}|\d{1,2}-\u10d4/,ordinal:function(e){return 0===e?e:1===e?e+"-\u10da\u10d8":e<20||e<=100&&e%20==0||e%100==0?"\u10db\u10d4-"+e:e+"-\u10d4"},week:{dow:1,doy:7}});var pe={0:"-\u0448\u0456",1:"-\u0448\u0456",2:"-\u0448\u0456",3:"-\u0448\u0456",4:"-\u0448\u0456",5:"-\u0448\u0456",6:"-\u0448\u044b",7:"-\u0448\u0456",8:"-\u0448\u0456",9:"-\u0448\u044b",10:"-\u0448\u044b",20:"-\u0448\u044b",30:"-\u0448\u044b",40:"-\u0448\u044b",50:"-\u0448\u0456",60:"-\u0448\u044b",70:"-\u0448\u0456",80:"-\u0448\u0456",90:"-\u0448\u044b",100:"-\u0448\u0456"},Te=(e.defineLocale("kk",{months:"\u049b\u0430\u04a3\u0442\u0430\u0440_\u0430\u049b\u043f\u0430\u043d_\u043d\u0430\u0443\u0440\u044b\u0437_\u0441\u04d9\u0443\u0456\u0440_\u043c\u0430\u043c\u044b\u0440_\u043c\u0430\u0443\u0441\u044b\u043c_\u0448\u0456\u043b\u0434\u0435_\u0442\u0430\u043c\u044b\u0437_\u049b\u044b\u0440\u043a\u04af\u0439\u0435\u043a_\u049b\u0430\u0437\u0430\u043d_\u049b\u0430\u0440\u0430\u0448\u0430_\u0436\u0435\u043b\u0442\u043e\u049b\u0441\u0430\u043d".split("_"),monthsShort:"\u049b\u0430\u04a3_\u0430\u049b\u043f_\u043d\u0430\u0443_\u0441\u04d9\u0443_\u043c\u0430\u043c_\u043c\u0430\u0443_\u0448\u0456\u043b_\u0442\u0430\u043c_\u049b\u044b\u0440_\u049b\u0430\u0437_\u049b\u0430\u0440_\u0436\u0435\u043b".split("_"),weekdays:"\u0436\u0435\u043a\u0441\u0435\u043d\u0431\u0456_\u0434\u04af\u0439\u0441\u0435\u043d\u0431\u0456_\u0441\u0435\u0439\u0441\u0435\u043d\u0431\u0456_\u0441\u04d9\u0440\u0441\u0435\u043d\u0431\u0456_\u0431\u0435\u0439\u0441\u0435\u043d\u0431\u0456_\u0436\u04b1\u043c\u0430_\u0441\u0435\u043d\u0431\u0456".split("_"),weekdaysShort:"\u0436\u0435\u043a_\u0434\u04af\u0439_\u0441\u0435\u0439_\u0441\u04d9\u0440_\u0431\u0435\u0439_\u0436\u04b1\u043c_\u0441\u0435\u043d".split("_"),weekdaysMin:"\u0436\u043a_\u0434\u0439_\u0441\u0439_\u0441\u0440_\u0431\u0439_\u0436\u043c_\u0441\u043d".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[\u0411\u04af\u0433\u0456\u043d \u0441\u0430\u0493\u0430\u0442] LT",nextDay:"[\u0415\u0440\u0442\u0435\u04a3 \u0441\u0430\u0493\u0430\u0442] LT",nextWeek:"dddd [\u0441\u0430\u0493\u0430\u0442] LT",lastDay:"[\u041a\u0435\u0448\u0435 \u0441\u0430\u0493\u0430\u0442] LT",lastWeek:"[\u04e8\u0442\u043a\u0435\u043d \u0430\u043f\u0442\u0430\u043d\u044b\u04a3] dddd [\u0441\u0430\u0493\u0430\u0442] LT",sameElse:"L"},relativeTime:{future:"%s \u0456\u0448\u0456\u043d\u0434\u0435",past:"%s \u0431\u04b1\u0440\u044b\u043d",s:"\u0431\u0456\u0440\u043d\u0435\u0448\u0435 \u0441\u0435\u043a\u0443\u043d\u0434",ss:"%d \u0441\u0435\u043a\u0443\u043d\u0434",m:"\u0431\u0456\u0440 \u043c\u0438\u043d\u0443\u0442",mm:"%d \u043c\u0438\u043d\u0443\u0442",h:"\u0431\u0456\u0440 \u0441\u0430\u0493\u0430\u0442",hh:"%d \u0441\u0430\u0493\u0430\u0442",d:"\u0431\u0456\u0440 \u043a\u04af\u043d",dd:"%d \u043a\u04af\u043d",M:"\u0431\u0456\u0440 \u0430\u0439",MM:"%d \u0430\u0439",y:"\u0431\u0456\u0440 \u0436\u044b\u043b",yy:"%d \u0436\u044b\u043b"},dayOfMonthOrdinalParse:/\d{1,2}-(\u0448\u0456|\u0448\u044b)/,ordinal:function(e){return e+(pe[e]||pe[e%10]||pe[100<=e?100:null])},week:{dow:1,doy:7}}),{1:"\u17e1",2:"\u17e2",3:"\u17e3",4:"\u17e4",5:"\u17e5",6:"\u17e6",7:"\u17e7",8:"\u17e8",9:"\u17e9",0:"\u17e0"}),fe={"\u17e1":"1","\u17e2":"2","\u17e3":"3","\u17e4":"4","\u17e5":"5","\u17e6":"6","\u17e7":"7","\u17e8":"8","\u17e9":"9","\u17e0":"0"},we=(e.defineLocale("km",{months:"\u1798\u1780\u179a\u17b6_\u1780\u17bb\u1798\u17d2\u1797\u17c8_\u1798\u17b8\u1793\u17b6_\u1798\u17c1\u179f\u17b6_\u17a7\u179f\u1797\u17b6_\u1798\u17b7\u1790\u17bb\u1793\u17b6_\u1780\u1780\u17d2\u1780\u178a\u17b6_\u179f\u17b8\u17a0\u17b6_\u1780\u1789\u17d2\u1789\u17b6_\u178f\u17bb\u179b\u17b6_\u179c\u17b7\u1785\u17d2\u1786\u17b7\u1780\u17b6_\u1792\u17d2\u1793\u17bc".split("_"),monthsShort:"\u1798\u1780\u179a\u17b6_\u1780\u17bb\u1798\u17d2\u1797\u17c8_\u1798\u17b8\u1793\u17b6_\u1798\u17c1\u179f\u17b6_\u17a7\u179f\u1797\u17b6_\u1798\u17b7\u1790\u17bb\u1793\u17b6_\u1780\u1780\u17d2\u1780\u178a\u17b6_\u179f\u17b8\u17a0\u17b6_\u1780\u1789\u17d2\u1789\u17b6_\u178f\u17bb\u179b\u17b6_\u179c\u17b7\u1785\u17d2\u1786\u17b7\u1780\u17b6_\u1792\u17d2\u1793\u17bc".split("_"),weekdays:"\u17a2\u17b6\u1791\u17b7\u178f\u17d2\u1799_\u1785\u17d0\u1793\u17d2\u1791_\u17a2\u1784\u17d2\u1782\u17b6\u179a_\u1796\u17bb\u1792_\u1796\u17d2\u179a\u17a0\u179f\u17d2\u1794\u178f\u17b7\u17cd_\u179f\u17bb\u1780\u17d2\u179a_\u179f\u17c5\u179a\u17cd".split("_"),weekdaysShort:"\u17a2\u17b6_\u1785_\u17a2_\u1796_\u1796\u17d2\u179a_\u179f\u17bb_\u179f".split("_"),weekdaysMin:"\u17a2\u17b6_\u1785_\u17a2_\u1796_\u1796\u17d2\u179a_\u179f\u17bb_\u179f".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},meridiemParse:/\u1796\u17d2\u179a\u17b9\u1780|\u179b\u17d2\u1784\u17b6\u1785/,isPM:function(e){return"\u179b\u17d2\u1784\u17b6\u1785"===e},meridiem:function(e,a,_){return e<12?"\u1796\u17d2\u179a\u17b9\u1780":"\u179b\u17d2\u1784\u17b6\u1785"},calendar:{sameDay:"[\u1790\u17d2\u1784\u17c3\u1793\u17c1\u17c7 \u1798\u17c9\u17c4\u1784] LT",nextDay:"[\u179f\u17d2\u17a2\u17c2\u1780 \u1798\u17c9\u17c4\u1784] LT",nextWeek:"dddd [\u1798\u17c9\u17c4\u1784] LT",lastDay:"[\u1798\u17d2\u179f\u17b7\u179b\u1798\u17b7\u1789 \u1798\u17c9\u17c4\u1784] LT",lastWeek:"dddd [\u179f\u1794\u17d2\u178f\u17b6\u17a0\u17cd\u1798\u17bb\u1793] [\u1798\u17c9\u17c4\u1784] LT",sameElse:"L"},relativeTime:{future:"%s\u1791\u17c0\u178f",past:"%s\u1798\u17bb\u1793",s:"\u1794\u17c9\u17bb\u1793\u17d2\u1798\u17b6\u1793\u179c\u17b7\u1793\u17b6\u1791\u17b8",ss:"%d \u179c\u17b7\u1793\u17b6\u1791\u17b8",m:"\u1798\u17bd\u1799\u1793\u17b6\u1791\u17b8",mm:"%d \u1793\u17b6\u1791\u17b8",h:"\u1798\u17bd\u1799\u1798\u17c9\u17c4\u1784",hh:"%d \u1798\u17c9\u17c4\u1784",d:"\u1798\u17bd\u1799\u1790\u17d2\u1784\u17c3",dd:"%d \u1790\u17d2\u1784\u17c3",M:"\u1798\u17bd\u1799\u1781\u17c2",MM:"%d \u1781\u17c2",y:"\u1798\u17bd\u1799\u1786\u17d2\u1793\u17b6\u17c6",yy:"%d \u1786\u17d2\u1793\u17b6\u17c6"},dayOfMonthOrdinalParse:/\u1791\u17b8\d{1,2}/,ordinal:"\u1791\u17b8%d",preparse:function(e){return e.replace(/[\u17e1\u17e2\u17e3\u17e4\u17e5\u17e6\u17e7\u17e8\u17e9\u17e0]/g,function(e){return fe[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return Te[e]})},week:{dow:1,doy:4}}),{1:"\u0ce7",2:"\u0ce8",3:"\u0ce9",4:"\u0cea",5:"\u0ceb",6:"\u0cec",7:"\u0ced",8:"\u0cee",9:"\u0cef",0:"\u0ce6"}),ge={"\u0ce7":"1","\u0ce8":"2","\u0ce9":"3","\u0cea":"4","\u0ceb":"5","\u0cec":"6","\u0ced":"7","\u0cee":"8","\u0cef":"9","\u0ce6":"0"},He=(e.defineLocale("kn",{months:"\u0c9c\u0ca8\u0cb5\u0cb0\u0cbf_\u0cab\u0cc6\u0cac\u0ccd\u0cb0\u0cb5\u0cb0\u0cbf_\u0cae\u0cbe\u0cb0\u0ccd\u0c9a\u0ccd_\u0c8f\u0caa\u0ccd\u0cb0\u0cbf\u0cb2\u0ccd_\u0cae\u0cc6\u0cd5_\u0c9c\u0cc2\u0ca8\u0ccd_\u0c9c\u0cc1\u0cb2\u0cc6\u0cd6_\u0c86\u0c97\u0cb8\u0ccd\u0c9f\u0ccd_\u0cb8\u0cc6\u0caa\u0ccd\u0c9f\u0cc6\u0c82\u0cac\u0cb0\u0ccd_\u0c85\u0c95\u0ccd\u0c9f\u0cc6\u0cc2\u0cd5\u0cac\u0cb0\u0ccd_\u0ca8\u0cb5\u0cc6\u0c82\u0cac\u0cb0\u0ccd_\u0ca1\u0cbf\u0cb8\u0cc6\u0c82\u0cac\u0cb0\u0ccd".split("_"),monthsShort:"\u0c9c\u0ca8_\u0cab\u0cc6\u0cac\u0ccd\u0cb0_\u0cae\u0cbe\u0cb0\u0ccd\u0c9a\u0ccd_\u0c8f\u0caa\u0ccd\u0cb0\u0cbf\u0cb2\u0ccd_\u0cae\u0cc6\u0cd5_\u0c9c\u0cc2\u0ca8\u0ccd_\u0c9c\u0cc1\u0cb2\u0cc6\u0cd6_\u0c86\u0c97\u0cb8\u0ccd\u0c9f\u0ccd_\u0cb8\u0cc6\u0caa\u0ccd\u0c9f\u0cc6\u0c82_\u0c85\u0c95\u0ccd\u0c9f\u0cc6\u0cc2\u0cd5_\u0ca8\u0cb5\u0cc6\u0c82_\u0ca1\u0cbf\u0cb8\u0cc6\u0c82".split("_"),monthsParseExact:!0,weekdays:"\u0cad\u0cbe\u0ca8\u0cc1\u0cb5\u0cbe\u0cb0_\u0cb8\u0cc6\u0cc2\u0cd5\u0cae\u0cb5\u0cbe\u0cb0_\u0cae\u0c82\u0c97\u0cb3\u0cb5\u0cbe\u0cb0_\u0cac\u0cc1\u0ca7\u0cb5\u0cbe\u0cb0_\u0c97\u0cc1\u0cb0\u0cc1\u0cb5\u0cbe\u0cb0_\u0cb6\u0cc1\u0c95\u0ccd\u0cb0\u0cb5\u0cbe\u0cb0_\u0cb6\u0ca8\u0cbf\u0cb5\u0cbe\u0cb0".split("_"),weekdaysShort:"\u0cad\u0cbe\u0ca8\u0cc1_\u0cb8\u0cc6\u0cc2\u0cd5\u0cae_\u0cae\u0c82\u0c97\u0cb3_\u0cac\u0cc1\u0ca7_\u0c97\u0cc1\u0cb0\u0cc1_\u0cb6\u0cc1\u0c95\u0ccd\u0cb0_\u0cb6\u0ca8\u0cbf".split("_"),weekdaysMin:"\u0cad\u0cbe_\u0cb8\u0cc6\u0cc2\u0cd5_\u0cae\u0c82_\u0cac\u0cc1_\u0c97\u0cc1_\u0cb6\u0cc1_\u0cb6".split("_"),longDateFormat:{LT:"A h:mm",LTS:"A h:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm",LLLL:"dddd, D MMMM YYYY, A h:mm"},calendar:{sameDay:"[\u0c87\u0c82\u0ca6\u0cc1] LT",nextDay:"[\u0ca8\u0cbe\u0cb3\u0cc6] LT",nextWeek:"dddd, LT",lastDay:"[\u0ca8\u0cbf\u0ca8\u0ccd\u0ca8\u0cc6] LT",lastWeek:"[\u0c95\u0cc6\u0cc2\u0ca8\u0cc6\u0caf] dddd, LT",sameElse:"L"},relativeTime:{future:"%s \u0ca8\u0c82\u0ca4\u0cb0",past:"%s \u0cb9\u0cbf\u0c82\u0ca6\u0cc6",s:"\u0c95\u0cc6\u0cb2\u0cb5\u0cc1 \u0c95\u0ccd\u0cb7\u0ca3\u0c97\u0cb3\u0cc1",ss:"%d \u0cb8\u0cc6\u0c95\u0cc6\u0c82\u0ca1\u0cc1\u0c97\u0cb3\u0cc1",m:"\u0c92\u0c82\u0ca6\u0cc1 \u0ca8\u0cbf\u0cae\u0cbf\u0cb7",mm:"%d \u0ca8\u0cbf\u0cae\u0cbf\u0cb7",h:"\u0c92\u0c82\u0ca6\u0cc1 \u0c97\u0c82\u0c9f\u0cc6",hh:"%d \u0c97\u0c82\u0c9f\u0cc6",d:"\u0c92\u0c82\u0ca6\u0cc1 \u0ca6\u0cbf\u0ca8",dd:"%d \u0ca6\u0cbf\u0ca8",M:"\u0c92\u0c82\u0ca6\u0cc1 \u0ca4\u0cbf\u0c82\u0c97\u0cb3\u0cc1",MM:"%d \u0ca4\u0cbf\u0c82\u0c97\u0cb3\u0cc1",y:"\u0c92\u0c82\u0ca6\u0cc1 \u0cb5\u0cb0\u0ccd\u0cb7",yy:"%d \u0cb5\u0cb0\u0ccd\u0cb7"},preparse:function(e){return e.replace(/[\u0ce7\u0ce8\u0ce9\u0cea\u0ceb\u0cec\u0ced\u0cee\u0cef\u0ce6]/g,function(e){return ge[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return we[e]})},meridiemParse:/\u0cb0\u0cbe\u0ca4\u0ccd\u0cb0\u0cbf|\u0cac\u0cc6\u0cb3\u0cbf\u0c97\u0ccd\u0c97\u0cc6|\u0cae\u0ca7\u0ccd\u0caf\u0cbe\u0cb9\u0ccd\u0ca8|\u0cb8\u0c82\u0c9c\u0cc6/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u0cb0\u0cbe\u0ca4\u0ccd\u0cb0\u0cbf"===a?e<4?e:e+12:"\u0cac\u0cc6\u0cb3\u0cbf\u0c97\u0ccd\u0c97\u0cc6"===a?e:"\u0cae\u0ca7\u0ccd\u0caf\u0cbe\u0cb9\u0ccd\u0ca8"===a?10<=e?e:e+12:"\u0cb8\u0c82\u0c9c\u0cc6"===a?e+12:void 0},meridiem:function(e,a,_){return e<4?"\u0cb0\u0cbe\u0ca4\u0ccd\u0cb0\u0cbf":e<10?"\u0cac\u0cc6\u0cb3\u0cbf\u0c97\u0ccd\u0c97\u0cc6":e<17?"\u0cae\u0ca7\u0ccd\u0caf\u0cbe\u0cb9\u0ccd\u0ca8":e<20?"\u0cb8\u0c82\u0c9c\u0cc6":"\u0cb0\u0cbe\u0ca4\u0ccd\u0cb0\u0cbf"},dayOfMonthOrdinalParse:/\d{1,2}(\u0ca8\u0cc6\u0cd5)/,ordinal:function(e){return e+"\u0ca8\u0cc6\u0cd5"},week:{dow:0,doy:6}}),e.defineLocale("ko",{months:"1\uc6d4_2\uc6d4_3\uc6d4_4\uc6d4_5\uc6d4_6\uc6d4_7\uc6d4_8\uc6d4_9\uc6d4_10\uc6d4_11\uc6d4_12\uc6d4".split("_"),monthsShort:"1\uc6d4_2\uc6d4_3\uc6d4_4\uc6d4_5\uc6d4_6\uc6d4_7\uc6d4_8\uc6d4_9\uc6d4_10\uc6d4_11\uc6d4_12\uc6d4".split("_"),weekdays:"\uc77c\uc694\uc77c_\uc6d4\uc694\uc77c_\ud654\uc694\uc77c_\uc218\uc694\uc77c_\ubaa9\uc694\uc77c_\uae08\uc694\uc77c_\ud1a0\uc694\uc77c".split("_"),weekdaysShort:"\uc77c_\uc6d4_\ud654_\uc218_\ubaa9_\uae08_\ud1a0".split("_"),weekdaysMin:"\uc77c_\uc6d4_\ud654_\uc218_\ubaa9_\uae08_\ud1a0".split("_"),longDateFormat:{LT:"A h:mm",LTS:"A h:mm:ss",L:"YYYY.MM.DD.",LL:"YYYY\ub144 MMMM D\uc77c",LLL:"YYYY\ub144 MMMM D\uc77c A h:mm",LLLL:"YYYY\ub144 MMMM D\uc77c dddd A h:mm",l:"YYYY.MM.DD.",ll:"YYYY\ub144 MMMM D\uc77c",lll:"YYYY\ub144 MMMM D\uc77c A h:mm",llll:"YYYY\ub144 MMMM D\uc77c dddd A h:mm"},calendar:{sameDay:"\uc624\ub298 LT",nextDay:"\ub0b4\uc77c LT",nextWeek:"dddd LT",lastDay:"\uc5b4\uc81c LT",lastWeek:"\uc9c0\ub09c\uc8fc dddd LT",sameElse:"L"},relativeTime:{future:"%s \ud6c4",past:"%s \uc804",s:"\uba87 \ucd08",ss:"%d\ucd08",m:"1\ubd84",mm:"%d\ubd84",h:"\ud55c \uc2dc\uac04",hh:"%d\uc2dc\uac04",d:"\ud558\ub8e8",dd:"%d\uc77c",M:"\ud55c \ub2ec",MM:"%d\ub2ec",y:"\uc77c \ub144",yy:"%d\ub144"},dayOfMonthOrdinalParse:/\d{1,2}(\uc77c|\uc6d4|\uc8fc)/,ordinal:function(e,a){switch(a){case"d":case"D":case"DDD":return e+"\uc77c";case"M":return e+"\uc6d4";case"w":case"W":return e+"\uc8fc";default:return e}},meridiemParse:/\uc624\uc804|\uc624\ud6c4/,isPM:function(e){return"\uc624\ud6c4"===e},meridiem:function(e,a,_){return e<12?"\uc624\uc804":"\uc624\ud6c4"}}),{1:"\u0661",2:"\u0662",3:"\u0663",4:"\u0664",5:"\u0665",6:"\u0666",7:"\u0667",8:"\u0668",9:"\u0669",0:"\u0660"}),be={"\u0661":"1","\u0662":"2","\u0663":"3","\u0664":"4","\u0665":"5","\u0666":"6","\u0667":"7","\u0668":"8","\u0669":"9","\u0660":"0"},n=["\u06a9\u0627\u0646\u0648\u0646\u06cc \u062f\u0648\u0648\u06d5\u0645","\u0634\u0648\u0628\u0627\u062a","\u0626\u0627\u0632\u0627\u0631","\u0646\u06cc\u0633\u0627\u0646","\u0626\u0627\u06cc\u0627\u0631","\u062d\u0648\u0632\u06d5\u06cc\u0631\u0627\u0646","\u062a\u06d5\u0645\u0645\u0648\u0632","\u0626\u0627\u0628","\u0626\u06d5\u06cc\u0644\u0648\u0648\u0644","\u062a\u0634\u0631\u06cc\u0646\u06cc \u06cc\u06d5\u0643\u06d5\u0645","\u062a\u0634\u0631\u06cc\u0646\u06cc \u062f\u0648\u0648\u06d5\u0645","\u0643\u0627\u0646\u0648\u0646\u06cc \u06cc\u06d5\u06a9\u06d5\u0645"],Se=(e.defineLocale("ku",{months:n,monthsShort:n,weekdays:"\u06cc\u0647\u200c\u0643\u0634\u0647\u200c\u0645\u0645\u0647\u200c_\u062f\u0648\u0648\u0634\u0647\u200c\u0645\u0645\u0647\u200c_\u0633\u06ce\u0634\u0647\u200c\u0645\u0645\u0647\u200c_\u0686\u0648\u0627\u0631\u0634\u0647\u200c\u0645\u0645\u0647\u200c_\u067e\u06ce\u0646\u062c\u0634\u0647\u200c\u0645\u0645\u0647\u200c_\u0647\u0647\u200c\u06cc\u0646\u06cc_\u0634\u0647\u200c\u0645\u0645\u0647\u200c".split("_"),weekdaysShort:"\u06cc\u0647\u200c\u0643\u0634\u0647\u200c\u0645_\u062f\u0648\u0648\u0634\u0647\u200c\u0645_\u0633\u06ce\u0634\u0647\u200c\u0645_\u0686\u0648\u0627\u0631\u0634\u0647\u200c\u0645_\u067e\u06ce\u0646\u062c\u0634\u0647\u200c\u0645_\u0647\u0647\u200c\u06cc\u0646\u06cc_\u0634\u0647\u200c\u0645\u0645\u0647\u200c".split("_"),weekdaysMin:"\u06cc_\u062f_\u0633_\u0686_\u067e_\u0647_\u0634".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},meridiemParse:/\u0626\u06ce\u0648\u0627\u0631\u0647\u200c|\u0628\u0647\u200c\u06cc\u0627\u0646\u06cc/,isPM:function(e){return/\u0626\u06ce\u0648\u0627\u0631\u0647\u200c/.test(e)},meridiem:function(e,a,_){return e<12?"\u0628\u0647\u200c\u06cc\u0627\u0646\u06cc":"\u0626\u06ce\u0648\u0627\u0631\u0647\u200c"},calendar:{sameDay:"[\u0626\u0647\u200c\u0645\u0631\u06c6 \u0643\u0627\u062a\u0698\u0645\u06ce\u0631] LT",nextDay:"[\u0628\u0647\u200c\u06cc\u0627\u0646\u06cc \u0643\u0627\u062a\u0698\u0645\u06ce\u0631] LT",nextWeek:"dddd [\u0643\u0627\u062a\u0698\u0645\u06ce\u0631] LT",lastDay:"[\u062f\u0648\u06ce\u0646\u06ce \u0643\u0627\u062a\u0698\u0645\u06ce\u0631] LT",lastWeek:"dddd [\u0643\u0627\u062a\u0698\u0645\u06ce\u0631] LT",sameElse:"L"},relativeTime:{future:"\u0644\u0647\u200c %s",past:"%s",s:"\u0686\u0647\u200c\u0646\u062f \u0686\u0631\u0643\u0647\u200c\u06cc\u0647\u200c\u0643",ss:"\u0686\u0631\u0643\u0647\u200c %d",m:"\u06cc\u0647\u200c\u0643 \u062e\u0648\u0644\u0647\u200c\u0643",mm:"%d \u062e\u0648\u0644\u0647\u200c\u0643",h:"\u06cc\u0647\u200c\u0643 \u0643\u0627\u062a\u0698\u0645\u06ce\u0631",hh:"%d \u0643\u0627\u062a\u0698\u0645\u06ce\u0631",d:"\u06cc\u0647\u200c\u0643 \u0695\u06c6\u0698",dd:"%d \u0695\u06c6\u0698",M:"\u06cc\u0647\u200c\u0643 \u0645\u0627\u0646\u06af",MM:"%d \u0645\u0627\u0646\u06af",y:"\u06cc\u0647\u200c\u0643 \u0633\u0627\u06b5",yy:"%d \u0633\u0627\u06b5"},preparse:function(e){return e.replace(/[\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669\u0660]/g,function(e){return be[e]}).replace(/\u060c/g,",")},postformat:function(e){return e.replace(/\d/g,function(e){return He[e]}).replace(/,/g,"\u060c")},week:{dow:6,doy:12}}),{0:"-\u0447\u04af",1:"-\u0447\u0438",2:"-\u0447\u0438",3:"-\u0447\u04af",4:"-\u0447\u04af",5:"-\u0447\u0438",6:"-\u0447\u044b",7:"-\u0447\u0438",8:"-\u0447\u0438",9:"-\u0447\u0443",10:"-\u0447\u0443",20:"-\u0447\u044b",30:"-\u0447\u0443",40:"-\u0447\u044b",50:"-\u0447\u04af",60:"-\u0447\u044b",70:"-\u0447\u0438",80:"-\u0447\u0438",90:"-\u0447\u0443",100:"-\u0447\u04af"});function ve(e,a,_,s){var d={m:["eng Minutt","enger Minutt"],h:["eng Stonn","enger Stonn"],d:["een Dag","engem Dag"],M:["ee Mount","engem Mount"],y:["ee Joer","engem Joer"]};return a?d[_][0]:d[_][1]}function je(e){if(e=parseInt(e,10),isNaN(e))return!1;if(e<0)return!0;if(e<10)return 4<=e&&e<=7;var a;if(e<100)return je(0==(a=e%10)?e/10:a);if(e<1e4){for(;10<=e;)e/=10;return je(e)}return je(e/=1e3)}e.defineLocale("ky",{months:"\u044f\u043d\u0432\u0430\u0440\u044c_\u0444\u0435\u0432\u0440\u0430\u043b\u044c_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440\u0435\u043b\u044c_\u043c\u0430\u0439_\u0438\u044e\u043d\u044c_\u0438\u044e\u043b\u044c_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043d\u0442\u044f\u0431\u0440\u044c_\u043e\u043a\u0442\u044f\u0431\u0440\u044c_\u043d\u043e\u044f\u0431\u0440\u044c_\u0434\u0435\u043a\u0430\u0431\u0440\u044c".split("_"),monthsShort:"\u044f\u043d\u0432_\u0444\u0435\u0432_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440_\u043c\u0430\u0439_\u0438\u044e\u043d\u044c_\u0438\u044e\u043b\u044c_\u0430\u0432\u0433_\u0441\u0435\u043d_\u043e\u043a\u0442_\u043d\u043e\u044f_\u0434\u0435\u043a".split("_"),weekdays:"\u0416\u0435\u043a\u0448\u0435\u043c\u0431\u0438_\u0414\u04af\u0439\u0448\u04e9\u043c\u0431\u04af_\u0428\u0435\u0439\u0448\u0435\u043c\u0431\u0438_\u0428\u0430\u0440\u0448\u0435\u043c\u0431\u0438_\u0411\u0435\u0439\u0448\u0435\u043c\u0431\u0438_\u0416\u0443\u043c\u0430_\u0418\u0448\u0435\u043c\u0431\u0438".split("_"),weekdaysShort:"\u0416\u0435\u043a_\u0414\u04af\u0439_\u0428\u0435\u0439_\u0428\u0430\u0440_\u0411\u0435\u0439_\u0416\u0443\u043c_\u0418\u0448\u0435".split("_"),weekdaysMin:"\u0416\u043a_\u0414\u0439_\u0428\u0439_\u0428\u0440_\u0411\u0439_\u0416\u043c_\u0418\u0448".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[\u0411\u04af\u0433\u04af\u043d \u0441\u0430\u0430\u0442] LT",nextDay:"[\u042d\u0440\u0442\u0435\u04a3 \u0441\u0430\u0430\u0442] LT",nextWeek:"dddd [\u0441\u0430\u0430\u0442] LT",lastDay:"[\u041a\u0435\u0447\u044d\u044d \u0441\u0430\u0430\u0442] LT",lastWeek:"[\u04e8\u0442\u043a\u04e9\u043d \u0430\u043f\u0442\u0430\u043d\u044b\u043d] dddd [\u043a\u04af\u043d\u04af] [\u0441\u0430\u0430\u0442] LT",sameElse:"L"},relativeTime:{future:"%s \u0438\u0447\u0438\u043d\u0434\u0435",past:"%s \u043c\u0443\u0440\u0443\u043d",s:"\u0431\u0438\u0440\u043d\u0435\u0447\u0435 \u0441\u0435\u043a\u0443\u043d\u0434",ss:"%d \u0441\u0435\u043a\u0443\u043d\u0434",m:"\u0431\u0438\u0440 \u043c\u04af\u043d\u04e9\u0442",mm:"%d \u043c\u04af\u043d\u04e9\u0442",h:"\u0431\u0438\u0440 \u0441\u0430\u0430\u0442",hh:"%d \u0441\u0430\u0430\u0442",d:"\u0431\u0438\u0440 \u043a\u04af\u043d",dd:"%d \u043a\u04af\u043d",M:"\u0431\u0438\u0440 \u0430\u0439",MM:"%d \u0430\u0439",y:"\u0431\u0438\u0440 \u0436\u044b\u043b",yy:"%d \u0436\u044b\u043b"},dayOfMonthOrdinalParse:/\d{1,2}-(\u0447\u0438|\u0447\u044b|\u0447\u04af|\u0447\u0443)/,ordinal:function(e){return e+(Se[e]||Se[e%10]||Se[100<=e?100:null])},week:{dow:1,doy:7}}),e.defineLocale("lb",{months:"Januar_Februar_M\xe4erz_Abr\xebll_Mee_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),monthsShort:"Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.".split("_"),monthsParseExact:!0,weekdays:"Sonndeg_M\xe9indeg_D\xebnschdeg_M\xebttwoch_Donneschdeg_Freideg_Samschdeg".split("_"),weekdaysShort:"So._M\xe9._D\xeb._M\xeb._Do._Fr._Sa.".split("_"),weekdaysMin:"So_M\xe9_D\xeb_M\xeb_Do_Fr_Sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm [Auer]",LTS:"H:mm:ss [Auer]",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm [Auer]",LLLL:"dddd, D. MMMM YYYY H:mm [Auer]"},calendar:{sameDay:"[Haut um] LT",sameElse:"L",nextDay:"[Muer um] LT",nextWeek:"dddd [um] LT",lastDay:"[G\xebschter um] LT",lastWeek:function(){switch(this.day()){case 2:case 4:return"[Leschten] dddd [um] LT";default:return"[Leschte] dddd [um] LT"}}},relativeTime:{future:function(e){return je(e.substr(0,e.indexOf(" ")))?"a "+e:"an "+e},past:function(e){return je(e.substr(0,e.indexOf(" ")))?"viru "+e:"virun "+e},s:"e puer Sekonnen",ss:"%d Sekonnen",m:ve,mm:"%d Minutten",h:ve,hh:"%d Stonnen",d:ve,dd:"%d Deeg",M:ve,MM:"%d M\xe9int",y:ve,yy:"%d Joer"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),e.defineLocale("lo",{months:"\u0ea1\u0eb1\u0e87\u0e81\u0ead\u0e99_\u0e81\u0eb8\u0ea1\u0e9e\u0eb2_\u0ea1\u0eb5\u0e99\u0eb2_\u0ec0\u0ea1\u0eaa\u0eb2_\u0e9e\u0eb6\u0e94\u0eaa\u0eb0\u0e9e\u0eb2_\u0ea1\u0eb4\u0e96\u0eb8\u0e99\u0eb2_\u0e81\u0ecd\u0ea5\u0eb0\u0e81\u0ebb\u0e94_\u0eaa\u0eb4\u0e87\u0eab\u0eb2_\u0e81\u0eb1\u0e99\u0e8d\u0eb2_\u0e95\u0eb8\u0ea5\u0eb2_\u0e9e\u0eb0\u0e88\u0eb4\u0e81_\u0e97\u0eb1\u0e99\u0ea7\u0eb2".split("_"),monthsShort:"\u0ea1\u0eb1\u0e87\u0e81\u0ead\u0e99_\u0e81\u0eb8\u0ea1\u0e9e\u0eb2_\u0ea1\u0eb5\u0e99\u0eb2_\u0ec0\u0ea1\u0eaa\u0eb2_\u0e9e\u0eb6\u0e94\u0eaa\u0eb0\u0e9e\u0eb2_\u0ea1\u0eb4\u0e96\u0eb8\u0e99\u0eb2_\u0e81\u0ecd\u0ea5\u0eb0\u0e81\u0ebb\u0e94_\u0eaa\u0eb4\u0e87\u0eab\u0eb2_\u0e81\u0eb1\u0e99\u0e8d\u0eb2_\u0e95\u0eb8\u0ea5\u0eb2_\u0e9e\u0eb0\u0e88\u0eb4\u0e81_\u0e97\u0eb1\u0e99\u0ea7\u0eb2".split("_"),weekdays:"\u0ead\u0eb2\u0e97\u0eb4\u0e94_\u0e88\u0eb1\u0e99_\u0ead\u0eb1\u0e87\u0e84\u0eb2\u0e99_\u0e9e\u0eb8\u0e94_\u0e9e\u0eb0\u0eab\u0eb1\u0e94_\u0eaa\u0eb8\u0e81_\u0ec0\u0eaa\u0ebb\u0eb2".split("_"),weekdaysShort:"\u0e97\u0eb4\u0e94_\u0e88\u0eb1\u0e99_\u0ead\u0eb1\u0e87\u0e84\u0eb2\u0e99_\u0e9e\u0eb8\u0e94_\u0e9e\u0eb0\u0eab\u0eb1\u0e94_\u0eaa\u0eb8\u0e81_\u0ec0\u0eaa\u0ebb\u0eb2".split("_"),weekdaysMin:"\u0e97_\u0e88_\u0ead\u0e84_\u0e9e_\u0e9e\u0eab_\u0eaa\u0e81_\u0eaa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"\u0ea7\u0eb1\u0e99dddd D MMMM YYYY HH:mm"},meridiemParse:/\u0e95\u0ead\u0e99\u0ec0\u0e8a\u0ebb\u0ec9\u0eb2|\u0e95\u0ead\u0e99\u0ec1\u0ea5\u0e87/,isPM:function(e){return"\u0e95\u0ead\u0e99\u0ec1\u0ea5\u0e87"===e},meridiem:function(e,a,_){return e<12?"\u0e95\u0ead\u0e99\u0ec0\u0e8a\u0ebb\u0ec9\u0eb2":"\u0e95\u0ead\u0e99\u0ec1\u0ea5\u0e87"},calendar:{sameDay:"[\u0ea1\u0eb7\u0ec9\u0e99\u0eb5\u0ec9\u0ec0\u0ea7\u0ea5\u0eb2] LT",nextDay:"[\u0ea1\u0eb7\u0ec9\u0ead\u0eb7\u0ec8\u0e99\u0ec0\u0ea7\u0ea5\u0eb2] LT",nextWeek:"[\u0ea7\u0eb1\u0e99]dddd[\u0edc\u0ec9\u0eb2\u0ec0\u0ea7\u0ea5\u0eb2] LT",lastDay:"[\u0ea1\u0eb7\u0ec9\u0ea7\u0eb2\u0e99\u0e99\u0eb5\u0ec9\u0ec0\u0ea7\u0ea5\u0eb2] LT",lastWeek:"[\u0ea7\u0eb1\u0e99]dddd[\u0ec1\u0ea5\u0ec9\u0ea7\u0e99\u0eb5\u0ec9\u0ec0\u0ea7\u0ea5\u0eb2] LT",sameElse:"L"},relativeTime:{future:"\u0ead\u0eb5\u0e81 %s",past:"%s\u0e9c\u0ec8\u0eb2\u0e99\u0ea1\u0eb2",s:"\u0e9a\u0ecd\u0ec8\u0ec0\u0e97\u0ebb\u0ec8\u0eb2\u0ec3\u0e94\u0ea7\u0eb4\u0e99\u0eb2\u0e97\u0eb5",ss:"%d \u0ea7\u0eb4\u0e99\u0eb2\u0e97\u0eb5",m:"1 \u0e99\u0eb2\u0e97\u0eb5",mm:"%d \u0e99\u0eb2\u0e97\u0eb5",h:"1 \u0e8a\u0ebb\u0ec8\u0ea7\u0ec2\u0ea1\u0e87",hh:"%d \u0e8a\u0ebb\u0ec8\u0ea7\u0ec2\u0ea1\u0e87",d:"1 \u0ea1\u0eb7\u0ec9",dd:"%d \u0ea1\u0eb7\u0ec9",M:"1 \u0ec0\u0e94\u0eb7\u0ead\u0e99",MM:"%d \u0ec0\u0e94\u0eb7\u0ead\u0e99",y:"1 \u0e9b\u0eb5",yy:"%d \u0e9b\u0eb5"},dayOfMonthOrdinalParse:/(\u0e97\u0eb5\u0ec8)\d{1,2}/,ordinal:function(e){return"\u0e97\u0eb5\u0ec8"+e}});var xe={ss:"sekund\u0117_sekund\u017ei\u0173_sekundes",m:"minut\u0117_minut\u0117s_minut\u0119",mm:"minut\u0117s_minu\u010di\u0173_minutes",h:"valanda_valandos_valand\u0105",hh:"valandos_valand\u0173_valandas",d:"diena_dienos_dien\u0105",dd:"dienos_dien\u0173_dienas",M:"m\u0117nuo_m\u0117nesio_m\u0117nes\u012f",MM:"m\u0117nesiai_m\u0117nesi\u0173_m\u0117nesius",y:"metai_met\u0173_metus",yy:"metai_met\u0173_metus"};function Pe(e,a,_,s){return a?f(_)[0]:s?f(_)[1]:f(_)[2]}function We(e){return e%10==0||10<e&&e<20}function f(e){return xe[e].split("_")}function Ae(e,a,_,s){var d=e+" ";return 1===e?d+Pe(0,a,_[0],s):a?d+(We(e)?f(_)[1]:f(_)[0]):s?d+f(_)[1]:d+(We(e)?f(_)[1]:f(_)[2])}e.defineLocale("lt",{months:{format:"sausio_vasario_kovo_baland\u017eio_gegu\u017e\u0117s_bir\u017eelio_liepos_rugpj\u016b\u010dio_rugs\u0117jo_spalio_lapkri\u010dio_gruod\u017eio".split("_"),standalone:"sausis_vasaris_kovas_balandis_gegu\u017e\u0117_bir\u017eelis_liepa_rugpj\u016btis_rugs\u0117jis_spalis_lapkritis_gruodis".split("_"),isFormat:/D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/},monthsShort:"sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd".split("_"),weekdays:{format:"sekmadien\u012f_pirmadien\u012f_antradien\u012f_tre\u010diadien\u012f_ketvirtadien\u012f_penktadien\u012f_\u0161e\u0161tadien\u012f".split("_"),standalone:"sekmadienis_pirmadienis_antradienis_tre\u010diadienis_ketvirtadienis_penktadienis_\u0161e\u0161tadienis".split("_"),isFormat:/dddd HH:mm/},weekdaysShort:"Sek_Pir_Ant_Tre_Ket_Pen_\u0160e\u0161".split("_"),weekdaysMin:"S_P_A_T_K_Pn_\u0160".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"YYYY [m.] MMMM D [d.]",LLL:"YYYY [m.] MMMM D [d.], HH:mm [val.]",LLLL:"YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]",l:"YYYY-MM-DD",ll:"YYYY [m.] MMMM D [d.]",lll:"YYYY [m.] MMMM D [d.], HH:mm [val.]",llll:"YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]"},calendar:{sameDay:"[\u0160iandien] LT",nextDay:"[Rytoj] LT",nextWeek:"dddd LT",lastDay:"[Vakar] LT",lastWeek:"[Pra\u0117jus\u012f] dddd LT",sameElse:"L"},relativeTime:{future:"po %s",past:"prie\u0161 %s",s:function(e,a,_,s){return a?"kelios sekund\u0117s":s?"keli\u0173 sekund\u017ei\u0173":"kelias sekundes"},ss:Ae,m:Pe,mm:Ae,h:Pe,hh:Ae,d:Pe,dd:Ae,M:Pe,MM:Ae,y:Pe,yy:Ae},dayOfMonthOrdinalParse:/\d{1,2}-oji/,ordinal:function(e){return e+"-oji"},week:{dow:1,doy:4}});var Oe={ss:"sekundes_sekund\u0113m_sekunde_sekundes".split("_"),m:"min\u016btes_min\u016bt\u0113m_min\u016bte_min\u016btes".split("_"),mm:"min\u016btes_min\u016bt\u0113m_min\u016bte_min\u016btes".split("_"),h:"stundas_stund\u0101m_stunda_stundas".split("_"),hh:"stundas_stund\u0101m_stunda_stundas".split("_"),d:"dienas_dien\u0101m_diena_dienas".split("_"),dd:"dienas_dien\u0101m_diena_dienas".split("_"),M:"m\u0113ne\u0161a_m\u0113ne\u0161iem_m\u0113nesis_m\u0113ne\u0161i".split("_"),MM:"m\u0113ne\u0161a_m\u0113ne\u0161iem_m\u0113nesis_m\u0113ne\u0161i".split("_"),y:"gada_gadiem_gads_gadi".split("_"),yy:"gada_gadiem_gads_gadi".split("_")};function Ee(e,a,_){return _?a%10==1&&a%100!=11?e[2]:e[3]:a%10==1&&a%100!=11?e[0]:e[1]}function Fe(e,a,_){return e+" "+Ee(Oe[_],e,a)}function ze(e,a,_){return Ee(Oe[_],e,a)}e.defineLocale("lv",{months:"janv\u0101ris_febru\u0101ris_marts_apr\u012blis_maijs_j\u016bnijs_j\u016blijs_augusts_septembris_oktobris_novembris_decembris".split("_"),monthsShort:"jan_feb_mar_apr_mai_j\u016bn_j\u016bl_aug_sep_okt_nov_dec".split("_"),weekdays:"sv\u0113tdiena_pirmdiena_otrdiena_tre\u0161diena_ceturtdiena_piektdiena_sestdiena".split("_"),weekdaysShort:"Sv_P_O_T_C_Pk_S".split("_"),weekdaysMin:"Sv_P_O_T_C_Pk_S".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY.",LL:"YYYY. [gada] D. MMMM",LLL:"YYYY. [gada] D. MMMM, HH:mm",LLLL:"YYYY. [gada] D. MMMM, dddd, HH:mm"},calendar:{sameDay:"[\u0160odien pulksten] LT",nextDay:"[R\u012bt pulksten] LT",nextWeek:"dddd [pulksten] LT",lastDay:"[Vakar pulksten] LT",lastWeek:"[Pag\u0101ju\u0161\u0101] dddd [pulksten] LT",sameElse:"L"},relativeTime:{future:"p\u0113c %s",past:"pirms %s",s:function(e,a){return a?"da\u017eas sekundes":"da\u017e\u0101m sekund\u0113m"},ss:Fe,m:ze,mm:Fe,h:ze,hh:Fe,d:ze,dd:Fe,M:ze,MM:Fe,y:ze,yy:Fe},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}});var w={words:{ss:["sekund","sekunda","sekundi"],m:["jedan minut","jednog minuta"],mm:["minut","minuta","minuta"],h:["jedan sat","jednog sata"],hh:["sat","sata","sati"],dd:["dan","dana","dana"],MM:["mjesec","mjeseca","mjeseci"],yy:["godina","godine","godina"]},correctGrammaticalCase:function(e,a){return 1===e?a[0]:2<=e&&e<=4?a[1]:a[2]},translate:function(e,a,_){var s=w.words[_];return 1===_.length?a?s[0]:s[1]:e+" "+w.correctGrammaticalCase(e,s)}};function g(e,a,_,s){switch(_){case"s":return a?"\u0445\u044d\u0434\u0445\u044d\u043d \u0441\u0435\u043a\u0443\u043d\u0434":"\u0445\u044d\u0434\u0445\u044d\u043d \u0441\u0435\u043a\u0443\u043d\u0434\u044b\u043d";case"ss":return e+(a?" \u0441\u0435\u043a\u0443\u043d\u0434":" \u0441\u0435\u043a\u0443\u043d\u0434\u044b\u043d");case"m":case"mm":return e+(a?" \u043c\u0438\u043d\u0443\u0442":" \u043c\u0438\u043d\u0443\u0442\u044b\u043d");case"h":case"hh":return e+(a?" \u0446\u0430\u0433":" \u0446\u0430\u0433\u0438\u0439\u043d");case"d":case"dd":return e+(a?" \u04e9\u0434\u04e9\u0440":" \u04e9\u0434\u0440\u0438\u0439\u043d");case"M":case"MM":return e+(a?" \u0441\u0430\u0440":" \u0441\u0430\u0440\u044b\u043d");case"y":case"yy":return e+(a?" \u0436\u0438\u043b":" \u0436\u0438\u043b\u0438\u0439\u043d");default:return e}}e.defineLocale("me",{months:"januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar".split("_"),monthsShort:"jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"nedjelja_ponedjeljak_utorak_srijeda_\u010detvrtak_petak_subota".split("_"),weekdaysShort:"ned._pon._uto._sri._\u010det._pet._sub.".split("_"),weekdaysMin:"ne_po_ut_sr_\u010de_pe_su".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd, D. MMMM YYYY H:mm"},calendar:{sameDay:"[danas u] LT",nextDay:"[sjutra u] LT",nextWeek:function(){switch(this.day()){case 0:return"[u] [nedjelju] [u] LT";case 3:return"[u] [srijedu] [u] LT";case 6:return"[u] [subotu] [u] LT";case 1:case 2:case 4:case 5:return"[u] dddd [u] LT"}},lastDay:"[ju\u010de u] LT",lastWeek:function(){return["[pro\u0161le] [nedjelje] [u] LT","[pro\u0161log] [ponedjeljka] [u] LT","[pro\u0161log] [utorka] [u] LT","[pro\u0161le] [srijede] [u] LT","[pro\u0161log] [\u010detvrtka] [u] LT","[pro\u0161log] [petka] [u] LT","[pro\u0161le] [subote] [u] LT"][this.day()]},sameElse:"L"},relativeTime:{future:"za %s",past:"prije %s",s:"nekoliko sekundi",ss:w.translate,m:w.translate,mm:w.translate,h:w.translate,hh:w.translate,d:"dan",dd:w.translate,M:"mjesec",MM:w.translate,y:"godinu",yy:w.translate},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}}),e.defineLocale("mi",{months:"Kohi-t\u0101te_Hui-tanguru_Pout\u016b-te-rangi_Paenga-wh\u0101wh\u0101_Haratua_Pipiri_H\u014dngoingoi_Here-turi-k\u014dk\u0101_Mahuru_Whiringa-\u0101-nuku_Whiringa-\u0101-rangi_Hakihea".split("_"),monthsShort:"Kohi_Hui_Pou_Pae_Hara_Pipi_H\u014dngoi_Here_Mahu_Whi-nu_Whi-ra_Haki".split("_"),monthsRegex:/(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,monthsStrictRegex:/(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,monthsShortRegex:/(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,monthsShortStrictRegex:/(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,weekdays:"R\u0101tapu_Mane_T\u016brei_Wenerei_T\u0101ite_Paraire_H\u0101tarei".split("_"),weekdaysShort:"Ta_Ma_T\u016b_We_T\u0101i_Pa_H\u0101".split("_"),weekdaysMin:"Ta_Ma_T\u016b_We_T\u0101i_Pa_H\u0101".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [i] HH:mm",LLLL:"dddd, D MMMM YYYY [i] HH:mm"},calendar:{sameDay:"[i teie mahana, i] LT",nextDay:"[apopo i] LT",nextWeek:"dddd [i] LT",lastDay:"[inanahi i] LT",lastWeek:"dddd [whakamutunga i] LT",sameElse:"L"},relativeTime:{future:"i roto i %s",past:"%s i mua",s:"te h\u0113kona ruarua",ss:"%d h\u0113kona",m:"he meneti",mm:"%d meneti",h:"te haora",hh:"%d haora",d:"he ra",dd:"%d ra",M:"he marama",MM:"%d marama",y:"he tau",yy:"%d tau"},dayOfMonthOrdinalParse:/\d{1,2}\xba/,ordinal:"%d\xba",week:{dow:1,doy:4}}),e.defineLocale("mk",{months:"\u0458\u0430\u043d\u0443\u0430\u0440\u0438_\u0444\u0435\u0432\u0440\u0443\u0430\u0440\u0438_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440\u0438\u043b_\u043c\u0430\u0458_\u0458\u0443\u043d\u0438_\u0458\u0443\u043b\u0438_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043f\u0442\u0435\u043c\u0432\u0440\u0438_\u043e\u043a\u0442\u043e\u043c\u0432\u0440\u0438_\u043d\u043e\u0435\u043c\u0432\u0440\u0438_\u0434\u0435\u043a\u0435\u043c\u0432\u0440\u0438".split("_"),monthsShort:"\u0458\u0430\u043d_\u0444\u0435\u0432_\u043c\u0430\u0440_\u0430\u043f\u0440_\u043c\u0430\u0458_\u0458\u0443\u043d_\u0458\u0443\u043b_\u0430\u0432\u0433_\u0441\u0435\u043f_\u043e\u043a\u0442_\u043d\u043e\u0435_\u0434\u0435\u043a".split("_"),weekdays:"\u043d\u0435\u0434\u0435\u043b\u0430_\u043f\u043e\u043d\u0435\u0434\u0435\u043b\u043d\u0438\u043a_\u0432\u0442\u043e\u0440\u043d\u0438\u043a_\u0441\u0440\u0435\u0434\u0430_\u0447\u0435\u0442\u0432\u0440\u0442\u043e\u043a_\u043f\u0435\u0442\u043e\u043a_\u0441\u0430\u0431\u043e\u0442\u0430".split("_"),weekdaysShort:"\u043d\u0435\u0434_\u043f\u043e\u043d_\u0432\u0442\u043e_\u0441\u0440\u0435_\u0447\u0435\u0442_\u043f\u0435\u0442_\u0441\u0430\u0431".split("_"),weekdaysMin:"\u043de_\u043fo_\u0432\u0442_\u0441\u0440_\u0447\u0435_\u043f\u0435_\u0441a".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"D.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY H:mm",LLLL:"dddd, D MMMM YYYY H:mm"},calendar:{sameDay:"[\u0414\u0435\u043d\u0435\u0441 \u0432\u043e] LT",nextDay:"[\u0423\u0442\u0440\u0435 \u0432\u043e] LT",nextWeek:"[\u0412\u043e] dddd [\u0432\u043e] LT",lastDay:"[\u0412\u0447\u0435\u0440\u0430 \u0432\u043e] LT",lastWeek:function(){switch(this.day()){case 0:case 3:case 6:return"[\u0418\u0437\u043c\u0438\u043d\u0430\u0442\u0430\u0442\u0430] dddd [\u0432\u043e] LT";case 1:case 2:case 4:case 5:return"[\u0418\u0437\u043c\u0438\u043d\u0430\u0442\u0438\u043e\u0442] dddd [\u0432\u043e] LT"}},sameElse:"L"},relativeTime:{future:"\u0437\u0430 %s",past:"\u043f\u0440\u0435\u0434 %s",s:"\u043d\u0435\u043a\u043e\u043b\u043a\u0443 \u0441\u0435\u043a\u0443\u043d\u0434\u0438",ss:"%d \u0441\u0435\u043a\u0443\u043d\u0434\u0438",m:"\u0435\u0434\u043d\u0430 \u043c\u0438\u043d\u0443\u0442\u0430",mm:"%d \u043c\u0438\u043d\u0443\u0442\u0438",h:"\u0435\u0434\u0435\u043d \u0447\u0430\u0441",hh:"%d \u0447\u0430\u0441\u0430",d:"\u0435\u0434\u0435\u043d \u0434\u0435\u043d",dd:"%d \u0434\u0435\u043d\u0430",M:"\u0435\u0434\u0435\u043d \u043c\u0435\u0441\u0435\u0446",MM:"%d \u043c\u0435\u0441\u0435\u0446\u0438",y:"\u0435\u0434\u043d\u0430 \u0433\u043e\u0434\u0438\u043d\u0430",yy:"%d \u0433\u043e\u0434\u0438\u043d\u0438"},dayOfMonthOrdinalParse:/\d{1,2}-(\u0435\u0432|\u0435\u043d|\u0442\u0438|\u0432\u0438|\u0440\u0438|\u043c\u0438)/,ordinal:function(e){var a=e%10,_=e%100;return 0===e?e+"-\u0435\u0432":0==_?e+"-\u0435\u043d":10<_&&_<20?e+"-\u0442\u0438":1==a?e+"-\u0432\u0438":2==a?e+"-\u0440\u0438":7==a||8==a?e+"-\u043c\u0438":e+"-\u0442\u0438"},week:{dow:1,doy:7}}),e.defineLocale("ml",{months:"\u0d1c\u0d28\u0d41\u0d35\u0d30\u0d3f_\u0d2b\u0d46\u0d2c\u0d4d\u0d30\u0d41\u0d35\u0d30\u0d3f_\u0d2e\u0d3e\u0d7c\u0d1a\u0d4d\u0d1a\u0d4d_\u0d0f\u0d2a\u0d4d\u0d30\u0d3f\u0d7d_\u0d2e\u0d47\u0d2f\u0d4d_\u0d1c\u0d42\u0d7a_\u0d1c\u0d42\u0d32\u0d48_\u0d13\u0d17\u0d38\u0d4d\u0d31\u0d4d\u0d31\u0d4d_\u0d38\u0d46\u0d2a\u0d4d\u0d31\u0d4d\u0d31\u0d02\u0d2c\u0d7c_\u0d12\u0d15\u0d4d\u0d1f\u0d4b\u0d2c\u0d7c_\u0d28\u0d35\u0d02\u0d2c\u0d7c_\u0d21\u0d3f\u0d38\u0d02\u0d2c\u0d7c".split("_"),monthsShort:"\u0d1c\u0d28\u0d41._\u0d2b\u0d46\u0d2c\u0d4d\u0d30\u0d41._\u0d2e\u0d3e\u0d7c._\u0d0f\u0d2a\u0d4d\u0d30\u0d3f._\u0d2e\u0d47\u0d2f\u0d4d_\u0d1c\u0d42\u0d7a_\u0d1c\u0d42\u0d32\u0d48._\u0d13\u0d17._\u0d38\u0d46\u0d2a\u0d4d\u0d31\u0d4d\u0d31._\u0d12\u0d15\u0d4d\u0d1f\u0d4b._\u0d28\u0d35\u0d02._\u0d21\u0d3f\u0d38\u0d02.".split("_"),monthsParseExact:!0,weekdays:"\u0d1e\u0d3e\u0d2f\u0d31\u0d3e\u0d34\u0d4d\u0d1a_\u0d24\u0d3f\u0d19\u0d4d\u0d15\u0d33\u0d3e\u0d34\u0d4d\u0d1a_\u0d1a\u0d4a\u0d35\u0d4d\u0d35\u0d3e\u0d34\u0d4d\u0d1a_\u0d2c\u0d41\u0d27\u0d28\u0d3e\u0d34\u0d4d\u0d1a_\u0d35\u0d4d\u0d2f\u0d3e\u0d34\u0d3e\u0d34\u0d4d\u0d1a_\u0d35\u0d46\u0d33\u0d4d\u0d33\u0d3f\u0d2f\u0d3e\u0d34\u0d4d\u0d1a_\u0d36\u0d28\u0d3f\u0d2f\u0d3e\u0d34\u0d4d\u0d1a".split("_"),weekdaysShort:"\u0d1e\u0d3e\u0d2f\u0d7c_\u0d24\u0d3f\u0d19\u0d4d\u0d15\u0d7e_\u0d1a\u0d4a\u0d35\u0d4d\u0d35_\u0d2c\u0d41\u0d27\u0d7b_\u0d35\u0d4d\u0d2f\u0d3e\u0d34\u0d02_\u0d35\u0d46\u0d33\u0d4d\u0d33\u0d3f_\u0d36\u0d28\u0d3f".split("_"),weekdaysMin:"\u0d1e\u0d3e_\u0d24\u0d3f_\u0d1a\u0d4a_\u0d2c\u0d41_\u0d35\u0d4d\u0d2f\u0d3e_\u0d35\u0d46_\u0d36".split("_"),longDateFormat:{LT:"A h:mm -\u0d28\u0d41",LTS:"A h:mm:ss -\u0d28\u0d41",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm -\u0d28\u0d41",LLLL:"dddd, D MMMM YYYY, A h:mm -\u0d28\u0d41"},calendar:{sameDay:"[\u0d07\u0d28\u0d4d\u0d28\u0d4d] LT",nextDay:"[\u0d28\u0d3e\u0d33\u0d46] LT",nextWeek:"dddd, LT",lastDay:"[\u0d07\u0d28\u0d4d\u0d28\u0d32\u0d46] LT",lastWeek:"[\u0d15\u0d34\u0d3f\u0d1e\u0d4d\u0d1e] dddd, LT",sameElse:"L"},relativeTime:{future:"%s \u0d15\u0d34\u0d3f\u0d1e\u0d4d\u0d1e\u0d4d",past:"%s \u0d2e\u0d41\u0d7b\u0d2a\u0d4d",s:"\u0d05\u0d7d\u0d2a \u0d28\u0d3f\u0d2e\u0d3f\u0d37\u0d19\u0d4d\u0d19\u0d7e",ss:"%d \u0d38\u0d46\u0d15\u0d4d\u0d15\u0d7b\u0d21\u0d4d",m:"\u0d12\u0d30\u0d41 \u0d2e\u0d3f\u0d28\u0d3f\u0d31\u0d4d\u0d31\u0d4d",mm:"%d \u0d2e\u0d3f\u0d28\u0d3f\u0d31\u0d4d\u0d31\u0d4d",h:"\u0d12\u0d30\u0d41 \u0d2e\u0d23\u0d3f\u0d15\u0d4d\u0d15\u0d42\u0d7c",hh:"%d \u0d2e\u0d23\u0d3f\u0d15\u0d4d\u0d15\u0d42\u0d7c",d:"\u0d12\u0d30\u0d41 \u0d26\u0d3f\u0d35\u0d38\u0d02",dd:"%d \u0d26\u0d3f\u0d35\u0d38\u0d02",M:"\u0d12\u0d30\u0d41 \u0d2e\u0d3e\u0d38\u0d02",MM:"%d \u0d2e\u0d3e\u0d38\u0d02",y:"\u0d12\u0d30\u0d41 \u0d35\u0d7c\u0d37\u0d02",yy:"%d \u0d35\u0d7c\u0d37\u0d02"},meridiemParse:/\u0d30\u0d3e\u0d24\u0d4d\u0d30\u0d3f|\u0d30\u0d3e\u0d35\u0d3f\u0d32\u0d46|\u0d09\u0d1a\u0d4d\u0d1a \u0d15\u0d34\u0d3f\u0d1e\u0d4d\u0d1e\u0d4d|\u0d35\u0d48\u0d15\u0d41\u0d28\u0d4d\u0d28\u0d47\u0d30\u0d02|\u0d30\u0d3e\u0d24\u0d4d\u0d30\u0d3f/i,meridiemHour:function(e,a){return 12===e&&(e=0),"\u0d30\u0d3e\u0d24\u0d4d\u0d30\u0d3f"===a&&4<=e||"\u0d09\u0d1a\u0d4d\u0d1a \u0d15\u0d34\u0d3f\u0d1e\u0d4d\u0d1e\u0d4d"===a||"\u0d35\u0d48\u0d15\u0d41\u0d28\u0d4d\u0d28\u0d47\u0d30\u0d02"===a?e+12:e},meridiem:function(e,a,_){return e<4?"\u0d30\u0d3e\u0d24\u0d4d\u0d30\u0d3f":e<12?"\u0d30\u0d3e\u0d35\u0d3f\u0d32\u0d46":e<17?"\u0d09\u0d1a\u0d4d\u0d1a \u0d15\u0d34\u0d3f\u0d1e\u0d4d\u0d1e\u0d4d":e<20?"\u0d35\u0d48\u0d15\u0d41\u0d28\u0d4d\u0d28\u0d47\u0d30\u0d02":"\u0d30\u0d3e\u0d24\u0d4d\u0d30\u0d3f"}}),e.defineLocale("mn",{months:"\u041d\u044d\u0433\u0434\u04af\u0433\u044d\u044d\u0440 \u0441\u0430\u0440_\u0425\u043e\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u0413\u0443\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u0414\u04e9\u0440\u04e9\u0432\u0434\u04af\u0433\u044d\u044d\u0440 \u0441\u0430\u0440_\u0422\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u0417\u0443\u0440\u0433\u0430\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u0414\u043e\u043b\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u041d\u0430\u0439\u043c\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u0415\u0441\u0434\u04af\u0433\u044d\u044d\u0440 \u0441\u0430\u0440_\u0410\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u0410\u0440\u0432\u0430\u043d \u043d\u044d\u0433\u0434\u04af\u0433\u044d\u044d\u0440 \u0441\u0430\u0440_\u0410\u0440\u0432\u0430\u043d \u0445\u043e\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440".split("_"),monthsShort:"1 \u0441\u0430\u0440_2 \u0441\u0430\u0440_3 \u0441\u0430\u0440_4 \u0441\u0430\u0440_5 \u0441\u0430\u0440_6 \u0441\u0430\u0440_7 \u0441\u0430\u0440_8 \u0441\u0430\u0440_9 \u0441\u0430\u0440_10 \u0441\u0430\u0440_11 \u0441\u0430\u0440_12 \u0441\u0430\u0440".split("_"),monthsParseExact:!0,weekdays:"\u041d\u044f\u043c_\u0414\u0430\u0432\u0430\u0430_\u041c\u044f\u0433\u043c\u0430\u0440_\u041b\u0445\u0430\u0433\u0432\u0430_\u041f\u04af\u0440\u044d\u0432_\u0411\u0430\u0430\u0441\u0430\u043d_\u0411\u044f\u043c\u0431\u0430".split("_"),weekdaysShort:"\u041d\u044f\u043c_\u0414\u0430\u0432_\u041c\u044f\u0433_\u041b\u0445\u0430_\u041f\u04af\u0440_\u0411\u0430\u0430_\u0411\u044f\u043c".split("_"),weekdaysMin:"\u041d\u044f_\u0414\u0430_\u041c\u044f_\u041b\u0445_\u041f\u04af_\u0411\u0430_\u0411\u044f".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"YYYY \u043e\u043d\u044b MMMM\u044b\u043d D",LLL:"YYYY \u043e\u043d\u044b MMMM\u044b\u043d D HH:mm",LLLL:"dddd, YYYY \u043e\u043d\u044b MMMM\u044b\u043d D HH:mm"},meridiemParse:/\u04ae\u04e8|\u04ae\u0425/i,isPM:function(e){return"\u04ae\u0425"===e},meridiem:function(e,a,_){return e<12?"\u04ae\u04e8":"\u04ae\u0425"},calendar:{sameDay:"[\u04e8\u043d\u04e9\u04e9\u0434\u04e9\u0440] LT",nextDay:"[\u041c\u0430\u0440\u0433\u0430\u0430\u0448] LT",nextWeek:"[\u0418\u0440\u044d\u0445] dddd LT",lastDay:"[\u04e8\u0447\u0438\u0433\u0434\u04e9\u0440] LT",lastWeek:"[\u04e8\u043d\u0433\u04e9\u0440\u0441\u04e9\u043d] dddd LT",sameElse:"L"},relativeTime:{future:"%s \u0434\u0430\u0440\u0430\u0430",past:"%s \u04e9\u043c\u043d\u04e9",s:g,ss:g,m:g,mm:g,h:g,hh:g,d:g,dd:g,M:g,MM:g,y:g,yy:g},dayOfMonthOrdinalParse:/\d{1,2} \u04e9\u0434\u04e9\u0440/,ordinal:function(e,a){switch(a){case"d":case"D":case"DDD":return e+" \u04e9\u0434\u04e9\u0440";default:return e}}});var Je={1:"\u0967",2:"\u0968",3:"\u0969",4:"\u096a",5:"\u096b",6:"\u096c",7:"\u096d",8:"\u096e",9:"\u096f",0:"\u0966"},Ie={"\u0967":"1","\u0968":"2","\u0969":"3","\u096a":"4","\u096b":"5","\u096c":"6","\u096d":"7","\u096e":"8","\u096f":"9","\u0966":"0"};function H(e,a,_,s){var d="";if(a)switch(_){case"s":d="\u0915\u093e\u0939\u0940 \u0938\u0947\u0915\u0902\u0926";break;case"ss":d="%d \u0938\u0947\u0915\u0902\u0926";break;case"m":d="\u090f\u0915 \u092e\u093f\u0928\u093f\u091f";break;case"mm":d="%d \u092e\u093f\u0928\u093f\u091f\u0947";break;case"h":d="\u090f\u0915 \u0924\u093e\u0938";break;case"hh":d="%d \u0924\u093e\u0938";break;case"d":d="\u090f\u0915 \u0926\u093f\u0935\u0938";break;case"dd":d="%d \u0926\u093f\u0935\u0938";break;case"M":d="\u090f\u0915 \u092e\u0939\u093f\u0928\u093e";break;case"MM":d="%d \u092e\u0939\u093f\u0928\u0947";break;case"y":d="\u090f\u0915 \u0935\u0930\u094d\u0937";break;case"yy":d="%d \u0935\u0930\u094d\u0937\u0947";break}else switch(_){case"s":d="\u0915\u093e\u0939\u0940 \u0938\u0947\u0915\u0902\u0926\u093e\u0902";break;case"ss":d="%d \u0938\u0947\u0915\u0902\u0926\u093e\u0902";break;case"m":d="\u090f\u0915\u093e \u092e\u093f\u0928\u093f\u091f\u093e";break;case"mm":d="%d \u092e\u093f\u0928\u093f\u091f\u093e\u0902";break;case"h":d="\u090f\u0915\u093e \u0924\u093e\u0938\u093e";break;case"hh":d="%d \u0924\u093e\u0938\u093e\u0902";break;case"d":d="\u090f\u0915\u093e \u0926\u093f\u0935\u0938\u093e";break;case"dd":d="%d \u0926\u093f\u0935\u0938\u093e\u0902";break;case"M":d="\u090f\u0915\u093e \u092e\u0939\u093f\u0928\u094d\u092f\u093e";break;case"MM":d="%d \u092e\u0939\u093f\u0928\u094d\u092f\u093e\u0902";break;case"y":d="\u090f\u0915\u093e \u0935\u0930\u094d\u0937\u093e";break;case"yy":d="%d \u0935\u0930\u094d\u0937\u093e\u0902";break}return d.replace(/%d/i,e)}e.defineLocale("mr",{months:"\u091c\u093e\u0928\u0947\u0935\u093e\u0930\u0940_\u092b\u0947\u092c\u094d\u0930\u0941\u0935\u093e\u0930\u0940_\u092e\u093e\u0930\u094d\u091a_\u090f\u092a\u094d\u0930\u093f\u0932_\u092e\u0947_\u091c\u0942\u0928_\u091c\u0941\u0932\u0948_\u0911\u0917\u0938\u094d\u091f_\u0938\u092a\u094d\u091f\u0947\u0902\u092c\u0930_\u0911\u0915\u094d\u091f\u094b\u092c\u0930_\u0928\u094b\u0935\u094d\u0939\u0947\u0902\u092c\u0930_\u0921\u093f\u0938\u0947\u0902\u092c\u0930".split("_"),monthsShort:"\u091c\u093e\u0928\u0947._\u092b\u0947\u092c\u094d\u0930\u0941._\u092e\u093e\u0930\u094d\u091a._\u090f\u092a\u094d\u0930\u093f._\u092e\u0947._\u091c\u0942\u0928._\u091c\u0941\u0932\u0948._\u0911\u0917._\u0938\u092a\u094d\u091f\u0947\u0902._\u0911\u0915\u094d\u091f\u094b._\u0928\u094b\u0935\u094d\u0939\u0947\u0902._\u0921\u093f\u0938\u0947\u0902.".split("_"),monthsParseExact:!0,weekdays:"\u0930\u0935\u093f\u0935\u093e\u0930_\u0938\u094b\u092e\u0935\u093e\u0930_\u092e\u0902\u0917\u0933\u0935\u093e\u0930_\u092c\u0941\u0927\u0935\u093e\u0930_\u0917\u0941\u0930\u0942\u0935\u093e\u0930_\u0936\u0941\u0915\u094d\u0930\u0935\u093e\u0930_\u0936\u0928\u093f\u0935\u093e\u0930".split("_"),weekdaysShort:"\u0930\u0935\u093f_\u0938\u094b\u092e_\u092e\u0902\u0917\u0933_\u092c\u0941\u0927_\u0917\u0941\u0930\u0942_\u0936\u0941\u0915\u094d\u0930_\u0936\u0928\u093f".split("_"),weekdaysMin:"\u0930_\u0938\u094b_\u092e\u0902_\u092c\u0941_\u0917\u0941_\u0936\u0941_\u0936".split("_"),longDateFormat:{LT:"A h:mm \u0935\u093e\u091c\u0924\u093e",LTS:"A h:mm:ss \u0935\u093e\u091c\u0924\u093e",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm \u0935\u093e\u091c\u0924\u093e",LLLL:"dddd, D MMMM YYYY, A h:mm \u0935\u093e\u091c\u0924\u093e"},calendar:{sameDay:"[\u0906\u091c] LT",nextDay:"[\u0909\u0926\u094d\u092f\u093e] LT",nextWeek:"dddd, LT",lastDay:"[\u0915\u093e\u0932] LT",lastWeek:"[\u092e\u093e\u0917\u0940\u0932] dddd, LT",sameElse:"L"},relativeTime:{future:"%s\u092e\u0927\u094d\u092f\u0947",past:"%s\u092a\u0942\u0930\u094d\u0935\u0940",s:H,ss:H,m:H,mm:H,h:H,hh:H,d:H,dd:H,M:H,MM:H,y:H,yy:H},preparse:function(e){return e.replace(/[\u0967\u0968\u0969\u096a\u096b\u096c\u096d\u096e\u096f\u0966]/g,function(e){return Ie[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return Je[e]})},meridiemParse:/\u092a\u0939\u093e\u091f\u0947|\u0938\u0915\u093e\u0933\u0940|\u0926\u0941\u092a\u093e\u0930\u0940|\u0938\u093e\u092f\u0902\u0915\u093e\u0933\u0940|\u0930\u093e\u0924\u094d\u0930\u0940/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u092a\u0939\u093e\u091f\u0947"===a||"\u0938\u0915\u093e\u0933\u0940"===a?e:"\u0926\u0941\u092a\u093e\u0930\u0940"===a||"\u0938\u093e\u092f\u0902\u0915\u093e\u0933\u0940"===a||"\u0930\u093e\u0924\u094d\u0930\u0940"===a?12<=e?e:e+12:void 0},meridiem:function(e,a,_){return 0<=e&&e<6?"\u092a\u0939\u093e\u091f\u0947":e<12?"\u0938\u0915\u093e\u0933\u0940":e<17?"\u0926\u0941\u092a\u093e\u0930\u0940":e<20?"\u0938\u093e\u092f\u0902\u0915\u093e\u0933\u0940":"\u0930\u093e\u0924\u094d\u0930\u0940"},week:{dow:0,doy:6}}),e.defineLocale("ms-my",{months:"Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember".split("_"),monthsShort:"Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis".split("_"),weekdays:"Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu".split("_"),weekdaysShort:"Ahd_Isn_Sel_Rab_Kha_Jum_Sab".split("_"),weekdaysMin:"Ah_Is_Sl_Rb_Km_Jm_Sb".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [pukul] HH.mm",LLLL:"dddd, D MMMM YYYY [pukul] HH.mm"},meridiemParse:/pagi|tengahari|petang|malam/,meridiemHour:function(e,a){return 12===e&&(e=0),"pagi"===a?e:"tengahari"===a?11<=e?e:e+12:"petang"===a||"malam"===a?e+12:void 0},meridiem:function(e,a,_){return e<11?"pagi":e<15?"tengahari":e<19?"petang":"malam"},calendar:{sameDay:"[Hari ini pukul] LT",nextDay:"[Esok pukul] LT",nextWeek:"dddd [pukul] LT",lastDay:"[Kelmarin pukul] LT",lastWeek:"dddd [lepas pukul] LT",sameElse:"L"},relativeTime:{future:"dalam %s",past:"%s yang lepas",s:"beberapa saat",ss:"%d saat",m:"seminit",mm:"%d minit",h:"sejam",hh:"%d jam",d:"sehari",dd:"%d hari",M:"sebulan",MM:"%d bulan",y:"setahun",yy:"%d tahun"},week:{dow:1,doy:7}}),e.defineLocale("ms",{months:"Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember".split("_"),monthsShort:"Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis".split("_"),weekdays:"Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu".split("_"),weekdaysShort:"Ahd_Isn_Sel_Rab_Kha_Jum_Sab".split("_"),weekdaysMin:"Ah_Is_Sl_Rb_Km_Jm_Sb".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [pukul] HH.mm",LLLL:"dddd, D MMMM YYYY [pukul] HH.mm"},meridiemParse:/pagi|tengahari|petang|malam/,meridiemHour:function(e,a){return 12===e&&(e=0),"pagi"===a?e:"tengahari"===a?11<=e?e:e+12:"petang"===a||"malam"===a?e+12:void 0},meridiem:function(e,a,_){return e<11?"pagi":e<15?"tengahari":e<19?"petang":"malam"},calendar:{sameDay:"[Hari ini pukul] LT",nextDay:"[Esok pukul] LT",nextWeek:"dddd [pukul] LT",lastDay:"[Kelmarin pukul] LT",lastWeek:"dddd [lepas pukul] LT",sameElse:"L"},relativeTime:{future:"dalam %s",past:"%s yang lepas",s:"beberapa saat",ss:"%d saat",m:"seminit",mm:"%d minit",h:"sejam",hh:"%d jam",d:"sehari",dd:"%d hari",M:"sebulan",MM:"%d bulan",y:"setahun",yy:"%d tahun"},week:{dow:1,doy:7}}),e.defineLocale("mt",{months:"Jannar_Frar_Marzu_April_Mejju_\u0120unju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Di\u010bembru".split("_"),monthsShort:"Jan_Fra_Mar_Apr_Mej_\u0120un_Lul_Aww_Set_Ott_Nov_Di\u010b".split("_"),weekdays:"Il-\u0126add_It-Tnejn_It-Tlieta_L-Erbg\u0127a_Il-\u0126amis_Il-\u0120img\u0127a_Is-Sibt".split("_"),weekdaysShort:"\u0126ad_Tne_Tli_Erb_\u0126am_\u0120im_Sib".split("_"),weekdaysMin:"\u0126a_Tn_Tl_Er_\u0126a_\u0120i_Si".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Illum fil-]LT",nextDay:"[G\u0127ada fil-]LT",nextWeek:"dddd [fil-]LT",lastDay:"[Il-biera\u0127 fil-]LT",lastWeek:"dddd [li g\u0127adda] [fil-]LT",sameElse:"L"},relativeTime:{future:"f\u2019 %s",past:"%s ilu",s:"ftit sekondi",ss:"%d sekondi",m:"minuta",mm:"%d minuti",h:"sieg\u0127a",hh:"%d sieg\u0127at",d:"\u0121urnata",dd:"%d \u0121ranet",M:"xahar",MM:"%d xhur",y:"sena",yy:"%d sni"},dayOfMonthOrdinalParse:/\d{1,2}\xba/,ordinal:"%d\xba",week:{dow:1,doy:4}});var Ne={1:"\u1041",2:"\u1042",3:"\u1043",4:"\u1044",5:"\u1045",6:"\u1046",7:"\u1047",8:"\u1048",9:"\u1049",0:"\u1040"},Re={"\u1041":"1","\u1042":"2","\u1043":"3","\u1044":"4","\u1045":"5","\u1046":"6","\u1047":"7","\u1048":"8","\u1049":"9","\u1040":"0"},Ce=(e.defineLocale("my",{months:"\u1007\u1014\u103a\u1014\u101d\u102b\u101b\u102e_\u1016\u1031\u1016\u1031\u102c\u103a\u101d\u102b\u101b\u102e_\u1019\u1010\u103a_\u1027\u1015\u103c\u102e_\u1019\u1031_\u1007\u103d\u1014\u103a_\u1007\u1030\u101c\u102d\u102f\u1004\u103a_\u101e\u103c\u1002\u102f\u1010\u103a_\u1005\u1000\u103a\u1010\u1004\u103a\u1018\u102c_\u1021\u1031\u102c\u1000\u103a\u1010\u102d\u102f\u1018\u102c_\u1014\u102d\u102f\u101d\u1004\u103a\u1018\u102c_\u1012\u102e\u1007\u1004\u103a\u1018\u102c".split("_"),monthsShort:"\u1007\u1014\u103a_\u1016\u1031_\u1019\u1010\u103a_\u1015\u103c\u102e_\u1019\u1031_\u1007\u103d\u1014\u103a_\u101c\u102d\u102f\u1004\u103a_\u101e\u103c_\u1005\u1000\u103a_\u1021\u1031\u102c\u1000\u103a_\u1014\u102d\u102f_\u1012\u102e".split("_"),weekdays:"\u1010\u1014\u1004\u103a\u1039\u1002\u1014\u103d\u1031_\u1010\u1014\u1004\u103a\u1039\u101c\u102c_\u1021\u1004\u103a\u1039\u1002\u102b_\u1017\u102f\u1012\u1039\u1013\u101f\u1030\u1038_\u1000\u103c\u102c\u101e\u1015\u1010\u1031\u1038_\u101e\u1031\u102c\u1000\u103c\u102c_\u1005\u1014\u1031".split("_"),weekdaysShort:"\u1014\u103d\u1031_\u101c\u102c_\u1002\u102b_\u101f\u1030\u1038_\u1000\u103c\u102c_\u101e\u1031\u102c_\u1014\u1031".split("_"),weekdaysMin:"\u1014\u103d\u1031_\u101c\u102c_\u1002\u102b_\u101f\u1030\u1038_\u1000\u103c\u102c_\u101e\u1031\u102c_\u1014\u1031".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[\u101a\u1014\u1031.] LT [\u1019\u103e\u102c]",nextDay:"[\u1019\u1014\u1000\u103a\u1016\u103c\u1014\u103a] LT [\u1019\u103e\u102c]",nextWeek:"dddd LT [\u1019\u103e\u102c]",lastDay:"[\u1019\u1014\u1031.\u1000] LT [\u1019\u103e\u102c]",lastWeek:"[\u1015\u103c\u102e\u1038\u1001\u1032\u1037\u101e\u1031\u102c] dddd LT [\u1019\u103e\u102c]",sameElse:"L"},relativeTime:{future:"\u101c\u102c\u1019\u100a\u103a\u1037 %s \u1019\u103e\u102c",past:"\u101c\u103d\u1014\u103a\u1001\u1032\u1037\u101e\u1031\u102c %s \u1000",s:"\u1005\u1000\u1039\u1000\u1014\u103a.\u1021\u1014\u100a\u103a\u1038\u1004\u101a\u103a",ss:"%d \u1005\u1000\u1039\u1000\u1014\u1037\u103a",m:"\u1010\u1005\u103a\u1019\u102d\u1014\u1005\u103a",mm:"%d \u1019\u102d\u1014\u1005\u103a",h:"\u1010\u1005\u103a\u1014\u102c\u101b\u102e",hh:"%d \u1014\u102c\u101b\u102e",d:"\u1010\u1005\u103a\u101b\u1000\u103a",dd:"%d \u101b\u1000\u103a",M:"\u1010\u1005\u103a\u101c",MM:"%d \u101c",y:"\u1010\u1005\u103a\u1014\u103e\u1005\u103a",yy:"%d \u1014\u103e\u1005\u103a"},preparse:function(e){return e.replace(/[\u1041\u1042\u1043\u1044\u1045\u1046\u1047\u1048\u1049\u1040]/g,function(e){return Re[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return Ne[e]})},week:{dow:1,doy:4}}),e.defineLocale("nb",{months:"januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember".split("_"),monthsShort:"jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.".split("_"),monthsParseExact:!0,weekdays:"s\xf8ndag_mandag_tirsdag_onsdag_torsdag_fredag_l\xf8rdag".split("_"),weekdaysShort:"s\xf8._ma._ti._on._to._fr._l\xf8.".split("_"),weekdaysMin:"s\xf8_ma_ti_on_to_fr_l\xf8".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY [kl.] HH:mm",LLLL:"dddd D. MMMM YYYY [kl.] HH:mm"},calendar:{sameDay:"[i dag kl.] LT",nextDay:"[i morgen kl.] LT",nextWeek:"dddd [kl.] LT",lastDay:"[i g\xe5r kl.] LT",lastWeek:"[forrige] dddd [kl.] LT",sameElse:"L"},relativeTime:{future:"om %s",past:"%s siden",s:"noen sekunder",ss:"%d sekunder",m:"ett minutt",mm:"%d minutter",h:"en time",hh:"%d timer",d:"en dag",dd:"%d dager",w:"en uke",ww:"%d uker",M:"en m\xe5ned",MM:"%d m\xe5neder",y:"ett \xe5r",yy:"%d \xe5r"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),{1:"\u0967",2:"\u0968",3:"\u0969",4:"\u096a",5:"\u096b",6:"\u096c",7:"\u096d",8:"\u096e",9:"\u096f",0:"\u0966"}),Ke={"\u0967":"1","\u0968":"2","\u0969":"3","\u096a":"4","\u096b":"5","\u096c":"6","\u096d":"7","\u096e":"8","\u096f":"9","\u0966":"0"},Ge=(e.defineLocale("ne",{months:"\u091c\u0928\u0935\u0930\u0940_\u092b\u0947\u092c\u094d\u0930\u0941\u0935\u0930\u0940_\u092e\u093e\u0930\u094d\u091a_\u0905\u092a\u094d\u0930\u093f\u0932_\u092e\u0908_\u091c\u0941\u0928_\u091c\u0941\u0932\u093e\u0908_\u0905\u0917\u0937\u094d\u091f_\u0938\u0947\u092a\u094d\u091f\u0947\u092e\u094d\u092c\u0930_\u0905\u0915\u094d\u091f\u094b\u092c\u0930_\u0928\u094b\u092d\u0947\u092e\u094d\u092c\u0930_\u0921\u093f\u0938\u0947\u092e\u094d\u092c\u0930".split("_"),monthsShort:"\u091c\u0928._\u092b\u0947\u092c\u094d\u0930\u0941._\u092e\u093e\u0930\u094d\u091a_\u0905\u092a\u094d\u0930\u093f._\u092e\u0908_\u091c\u0941\u0928_\u091c\u0941\u0932\u093e\u0908._\u0905\u0917._\u0938\u0947\u092a\u094d\u091f._\u0905\u0915\u094d\u091f\u094b._\u0928\u094b\u092d\u0947._\u0921\u093f\u0938\u0947.".split("_"),monthsParseExact:!0,weekdays:"\u0906\u0907\u0924\u092c\u093e\u0930_\u0938\u094b\u092e\u092c\u093e\u0930_\u092e\u0919\u094d\u0917\u0932\u092c\u093e\u0930_\u092c\u0941\u0927\u092c\u093e\u0930_\u092c\u093f\u0939\u093f\u092c\u093e\u0930_\u0936\u0941\u0915\u094d\u0930\u092c\u093e\u0930_\u0936\u0928\u093f\u092c\u093e\u0930".split("_"),weekdaysShort:"\u0906\u0907\u0924._\u0938\u094b\u092e._\u092e\u0919\u094d\u0917\u0932._\u092c\u0941\u0927._\u092c\u093f\u0939\u093f._\u0936\u0941\u0915\u094d\u0930._\u0936\u0928\u093f.".split("_"),weekdaysMin:"\u0906._\u0938\u094b._\u092e\u0902._\u092c\u0941._\u092c\u093f._\u0936\u0941._\u0936.".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"A\u0915\u094b h:mm \u092c\u091c\u0947",LTS:"A\u0915\u094b h:mm:ss \u092c\u091c\u0947",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A\u0915\u094b h:mm \u092c\u091c\u0947",LLLL:"dddd, D MMMM YYYY, A\u0915\u094b h:mm \u092c\u091c\u0947"},preparse:function(e){return e.replace(/[\u0967\u0968\u0969\u096a\u096b\u096c\u096d\u096e\u096f\u0966]/g,function(e){return Ke[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return Ce[e]})},meridiemParse:/\u0930\u093e\u0924\u093f|\u092c\u093f\u0939\u093e\u0928|\u0926\u093f\u0909\u0901\u0938\u094b|\u0938\u093e\u0901\u091d/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u0930\u093e\u0924\u093f"===a?e<4?e:e+12:"\u092c\u093f\u0939\u093e\u0928"===a?e:"\u0926\u093f\u0909\u0901\u0938\u094b"===a?10<=e?e:e+12:"\u0938\u093e\u0901\u091d"===a?e+12:void 0},meridiem:function(e,a,_){return e<3?"\u0930\u093e\u0924\u093f":e<12?"\u092c\u093f\u0939\u093e\u0928":e<16?"\u0926\u093f\u0909\u0901\u0938\u094b":e<20?"\u0938\u093e\u0901\u091d":"\u0930\u093e\u0924\u093f"},calendar:{sameDay:"[\u0906\u091c] LT",nextDay:"[\u092d\u094b\u0932\u093f] LT",nextWeek:"[\u0906\u0909\u0901\u0926\u094b] dddd[,] LT",lastDay:"[\u0939\u093f\u091c\u094b] LT",lastWeek:"[\u0917\u090f\u0915\u094b] dddd[,] LT",sameElse:"L"},relativeTime:{future:"%s\u092e\u093e",past:"%s \u0905\u0917\u093e\u0921\u093f",s:"\u0915\u0947\u0939\u0940 \u0915\u094d\u0937\u0923",ss:"%d \u0938\u0947\u0915\u0947\u0923\u094d\u0921",m:"\u090f\u0915 \u092e\u093f\u0928\u0947\u091f",mm:"%d \u092e\u093f\u0928\u0947\u091f",h:"\u090f\u0915 \u0918\u0923\u094d\u091f\u093e",hh:"%d \u0918\u0923\u094d\u091f\u093e",d:"\u090f\u0915 \u0926\u093f\u0928",dd:"%d \u0926\u093f\u0928",M:"\u090f\u0915 \u092e\u0939\u093f\u0928\u093e",MM:"%d \u092e\u0939\u093f\u0928\u093e",y:"\u090f\u0915 \u092c\u0930\u094d\u0937",yy:"%d \u092c\u0930\u094d\u0937"},week:{dow:0,doy:6}}),"jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.".split("_")),Be="jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"),m=[/^jan/i,/^feb/i,/^maart|mrt.?$/i,/^apr/i,/^mei$/i,/^jun[i.]?$/i,/^jul[i.]?$/i,/^aug/i,/^sep/i,/^okt/i,/^nov/i,/^dec/i],d=/^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,qe=(e.defineLocale("nl-be",{months:"januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),monthsShort:function(e,a){return e?(/-MMM-/.test(a)?Be:Ge)[e.month()]:Ge},monthsRegex:d,monthsShortRegex:d,monthsStrictRegex:/^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,monthsShortStrictRegex:/^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,monthsParse:m,longMonthsParse:m,shortMonthsParse:m,weekdays:"zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),weekdaysShort:"zo._ma._di._wo._do._vr._za.".split("_"),weekdaysMin:"zo_ma_di_wo_do_vr_za".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[vandaag om] LT",nextDay:"[morgen om] LT",nextWeek:"dddd [om] LT",lastDay:"[gisteren om] LT",lastWeek:"[afgelopen] dddd [om] LT",sameElse:"L"},relativeTime:{future:"over %s",past:"%s geleden",s:"een paar seconden",ss:"%d seconden",m:"\xe9\xe9n minuut",mm:"%d minuten",h:"\xe9\xe9n uur",hh:"%d uur",d:"\xe9\xe9n dag",dd:"%d dagen",M:"\xe9\xe9n maand",MM:"%d maanden",y:"\xe9\xe9n jaar",yy:"%d jaar"},dayOfMonthOrdinalParse:/\d{1,2}(ste|de)/,ordinal:function(e){return e+(1===e||8===e||20<=e?"ste":"de")},week:{dow:1,doy:4}}),"jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.".split("_")),Ue="jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"),r=[/^jan/i,/^feb/i,/^maart|mrt.?$/i,/^apr/i,/^mei$/i,/^jun[i.]?$/i,/^jul[i.]?$/i,/^aug/i,/^sep/i,/^okt/i,/^nov/i,/^dec/i],n=/^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,$e=(e.defineLocale("nl",{months:"januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),monthsShort:function(e,a){return e?(/-MMM-/.test(a)?Ue:qe)[e.month()]:qe},monthsRegex:n,monthsShortRegex:n,monthsStrictRegex:/^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,monthsShortStrictRegex:/^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,monthsParse:r,longMonthsParse:r,shortMonthsParse:r,weekdays:"zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),weekdaysShort:"zo._ma._di._wo._do._vr._za.".split("_"),weekdaysMin:"zo_ma_di_wo_do_vr_za".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD-MM-YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[vandaag om] LT",nextDay:"[morgen om] LT",nextWeek:"dddd [om] LT",lastDay:"[gisteren om] LT",lastWeek:"[afgelopen] dddd [om] LT",sameElse:"L"},relativeTime:{future:"over %s",past:"%s geleden",s:"een paar seconden",ss:"%d seconden",m:"\xe9\xe9n minuut",mm:"%d minuten",h:"\xe9\xe9n uur",hh:"%d uur",d:"\xe9\xe9n dag",dd:"%d dagen",w:"\xe9\xe9n week",ww:"%d weken",M:"\xe9\xe9n maand",MM:"%d maanden",y:"\xe9\xe9n jaar",yy:"%d jaar"},dayOfMonthOrdinalParse:/\d{1,2}(ste|de)/,ordinal:function(e){return e+(1===e||8===e||20<=e?"ste":"de")},week:{dow:1,doy:4}}),e.defineLocale("nn",{months:"januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember".split("_"),monthsShort:"jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.".split("_"),monthsParseExact:!0,weekdays:"sundag_m\xe5ndag_tysdag_onsdag_torsdag_fredag_laurdag".split("_"),weekdaysShort:"su._m\xe5._ty._on._to._fr._lau.".split("_"),weekdaysMin:"su_m\xe5_ty_on_to_fr_la".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY [kl.] H:mm",LLLL:"dddd D. MMMM YYYY [kl.] HH:mm"},calendar:{sameDay:"[I dag klokka] LT",nextDay:"[I morgon klokka] LT",nextWeek:"dddd [klokka] LT",lastDay:"[I g\xe5r klokka] LT",lastWeek:"[F\xf8reg\xe5ande] dddd [klokka] LT",sameElse:"L"},relativeTime:{future:"om %s",past:"%s sidan",s:"nokre sekund",ss:"%d sekund",m:"eit minutt",mm:"%d minutt",h:"ein time",hh:"%d timar",d:"ein dag",dd:"%d dagar",w:"ei veke",ww:"%d veker",M:"ein m\xe5nad",MM:"%d m\xe5nader",y:"eit \xe5r",yy:"%d \xe5r"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),e.defineLocale("oc-lnc",{months:{standalone:"geni\xe8r_febri\xe8r_mar\xe7_abril_mai_junh_julhet_agost_setembre_oct\xf2bre_novembre_decembre".split("_"),format:"de geni\xe8r_de febri\xe8r_de mar\xe7_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'oct\xf2bre_de novembre_de decembre".split("_"),isFormat:/D[oD]?(\s)+MMMM/},monthsShort:"gen._febr._mar\xe7_abr._mai_junh_julh._ago._set._oct._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"dimenge_diluns_dimars_dim\xe8cres_dij\xf2us_divendres_dissabte".split("_"),weekdaysShort:"dg._dl._dm._dc._dj._dv._ds.".split("_"),weekdaysMin:"dg_dl_dm_dc_dj_dv_ds".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM [de] YYYY",ll:"D MMM YYYY",LLL:"D MMMM [de] YYYY [a] H:mm",lll:"D MMM YYYY, H:mm",LLLL:"dddd D MMMM [de] YYYY [a] H:mm",llll:"ddd D MMM YYYY, H:mm"},calendar:{sameDay:"[u\xe8i a] LT",nextDay:"[deman a] LT",nextWeek:"dddd [a] LT",lastDay:"[i\xe8r a] LT",lastWeek:"dddd [passat a] LT",sameElse:"L"},relativeTime:{future:"d'aqu\xed %s",past:"fa %s",s:"unas segondas",ss:"%d segondas",m:"una minuta",mm:"%d minutas",h:"una ora",hh:"%d oras",d:"un jorn",dd:"%d jorns",M:"un mes",MM:"%d meses",y:"un an",yy:"%d ans"},dayOfMonthOrdinalParse:/\d{1,2}(r|n|t|\xe8|a)/,ordinal:function(e,a){return e+("w"!==a&&"W"!==a?1===e?"r":2===e?"n":3===e?"r":4===e?"t":"\xe8":"a")},week:{dow:1,doy:4}}),{1:"\u0a67",2:"\u0a68",3:"\u0a69",4:"\u0a6a",5:"\u0a6b",6:"\u0a6c",7:"\u0a6d",8:"\u0a6e",9:"\u0a6f",0:"\u0a66"}),Qe={"\u0a67":"1","\u0a68":"2","\u0a69":"3","\u0a6a":"4","\u0a6b":"5","\u0a6c":"6","\u0a6d":"7","\u0a6e":"8","\u0a6f":"9","\u0a66":"0"},Ve=(e.defineLocale("pa-in",{months:"\u0a1c\u0a28\u0a35\u0a30\u0a40_\u0a2b\u0a3c\u0a30\u0a35\u0a30\u0a40_\u0a2e\u0a3e\u0a30\u0a1a_\u0a05\u0a2a\u0a4d\u0a30\u0a48\u0a32_\u0a2e\u0a08_\u0a1c\u0a42\u0a28_\u0a1c\u0a41\u0a32\u0a3e\u0a08_\u0a05\u0a17\u0a38\u0a24_\u0a38\u0a24\u0a70\u0a2c\u0a30_\u0a05\u0a15\u0a24\u0a42\u0a2c\u0a30_\u0a28\u0a35\u0a70\u0a2c\u0a30_\u0a26\u0a38\u0a70\u0a2c\u0a30".split("_"),monthsShort:"\u0a1c\u0a28\u0a35\u0a30\u0a40_\u0a2b\u0a3c\u0a30\u0a35\u0a30\u0a40_\u0a2e\u0a3e\u0a30\u0a1a_\u0a05\u0a2a\u0a4d\u0a30\u0a48\u0a32_\u0a2e\u0a08_\u0a1c\u0a42\u0a28_\u0a1c\u0a41\u0a32\u0a3e\u0a08_\u0a05\u0a17\u0a38\u0a24_\u0a38\u0a24\u0a70\u0a2c\u0a30_\u0a05\u0a15\u0a24\u0a42\u0a2c\u0a30_\u0a28\u0a35\u0a70\u0a2c\u0a30_\u0a26\u0a38\u0a70\u0a2c\u0a30".split("_"),weekdays:"\u0a10\u0a24\u0a35\u0a3e\u0a30_\u0a38\u0a4b\u0a2e\u0a35\u0a3e\u0a30_\u0a2e\u0a70\u0a17\u0a32\u0a35\u0a3e\u0a30_\u0a2c\u0a41\u0a27\u0a35\u0a3e\u0a30_\u0a35\u0a40\u0a30\u0a35\u0a3e\u0a30_\u0a38\u0a3c\u0a41\u0a71\u0a15\u0a30\u0a35\u0a3e\u0a30_\u0a38\u0a3c\u0a28\u0a40\u0a1a\u0a30\u0a35\u0a3e\u0a30".split("_"),weekdaysShort:"\u0a10\u0a24_\u0a38\u0a4b\u0a2e_\u0a2e\u0a70\u0a17\u0a32_\u0a2c\u0a41\u0a27_\u0a35\u0a40\u0a30_\u0a38\u0a3c\u0a41\u0a15\u0a30_\u0a38\u0a3c\u0a28\u0a40".split("_"),weekdaysMin:"\u0a10\u0a24_\u0a38\u0a4b\u0a2e_\u0a2e\u0a70\u0a17\u0a32_\u0a2c\u0a41\u0a27_\u0a35\u0a40\u0a30_\u0a38\u0a3c\u0a41\u0a15\u0a30_\u0a38\u0a3c\u0a28\u0a40".split("_"),longDateFormat:{LT:"A h:mm \u0a35\u0a1c\u0a47",LTS:"A h:mm:ss \u0a35\u0a1c\u0a47",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm \u0a35\u0a1c\u0a47",LLLL:"dddd, D MMMM YYYY, A h:mm \u0a35\u0a1c\u0a47"},calendar:{sameDay:"[\u0a05\u0a1c] LT",nextDay:"[\u0a15\u0a32] LT",nextWeek:"[\u0a05\u0a17\u0a32\u0a3e] dddd, LT",lastDay:"[\u0a15\u0a32] LT",lastWeek:"[\u0a2a\u0a3f\u0a1b\u0a32\u0a47] dddd, LT",sameElse:"L"},relativeTime:{future:"%s \u0a35\u0a3f\u0a71\u0a1a",past:"%s \u0a2a\u0a3f\u0a1b\u0a32\u0a47",s:"\u0a15\u0a41\u0a1d \u0a38\u0a15\u0a3f\u0a70\u0a1f",ss:"%d \u0a38\u0a15\u0a3f\u0a70\u0a1f",m:"\u0a07\u0a15 \u0a2e\u0a3f\u0a70\u0a1f",mm:"%d \u0a2e\u0a3f\u0a70\u0a1f",h:"\u0a07\u0a71\u0a15 \u0a18\u0a70\u0a1f\u0a3e",hh:"%d \u0a18\u0a70\u0a1f\u0a47",d:"\u0a07\u0a71\u0a15 \u0a26\u0a3f\u0a28",dd:"%d \u0a26\u0a3f\u0a28",M:"\u0a07\u0a71\u0a15 \u0a2e\u0a39\u0a40\u0a28\u0a3e",MM:"%d \u0a2e\u0a39\u0a40\u0a28\u0a47",y:"\u0a07\u0a71\u0a15 \u0a38\u0a3e\u0a32",yy:"%d \u0a38\u0a3e\u0a32"},preparse:function(e){return e.replace(/[\u0a67\u0a68\u0a69\u0a6a\u0a6b\u0a6c\u0a6d\u0a6e\u0a6f\u0a66]/g,function(e){return Qe[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return $e[e]})},meridiemParse:/\u0a30\u0a3e\u0a24|\u0a38\u0a35\u0a47\u0a30|\u0a26\u0a41\u0a2a\u0a39\u0a3f\u0a30|\u0a38\u0a3c\u0a3e\u0a2e/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u0a30\u0a3e\u0a24"===a?e<4?e:e+12:"\u0a38\u0a35\u0a47\u0a30"===a?e:"\u0a26\u0a41\u0a2a\u0a39\u0a3f\u0a30"===a?10<=e?e:e+12:"\u0a38\u0a3c\u0a3e\u0a2e"===a?e+12:void 0},meridiem:function(e,a,_){return e<4?"\u0a30\u0a3e\u0a24":e<10?"\u0a38\u0a35\u0a47\u0a30":e<17?"\u0a26\u0a41\u0a2a\u0a39\u0a3f\u0a30":e<20?"\u0a38\u0a3c\u0a3e\u0a2e":"\u0a30\u0a3e\u0a24"},week:{dow:0,doy:6}}),"stycze\u0144_luty_marzec_kwiecie\u0144_maj_czerwiec_lipiec_sierpie\u0144_wrzesie\u0144_pa\u017adziernik_listopad_grudzie\u0144".split("_")),Ze="stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_wrze\u015bnia_pa\u017adziernika_listopada_grudnia".split("_"),d=[/^sty/i,/^lut/i,/^mar/i,/^kwi/i,/^maj/i,/^cze/i,/^lip/i,/^sie/i,/^wrz/i,/^pa\u017a/i,/^lis/i,/^gru/i];function Xe(e){return e%10<5&&1<e%10&&~~(e/10)%10!=1}function b(e,a,_){var s=e+" ";switch(_){case"ss":return s+(Xe(e)?"sekundy":"sekund");case"m":return a?"minuta":"minut\u0119";case"mm":return s+(Xe(e)?"minuty":"minut");case"h":return a?"godzina":"godzin\u0119";case"hh":return s+(Xe(e)?"godziny":"godzin");case"ww":return s+(Xe(e)?"tygodnie":"tygodni");case"MM":return s+(Xe(e)?"miesi\u0105ce":"miesi\u0119cy");case"yy":return s+(Xe(e)?"lata":"lat")}}function S(e,a,_){return e+(20<=e%100||100<=e&&e%100==0?" de ":" ")+{ss:"secunde",mm:"minute",hh:"ore",dd:"zile",ww:"s\u0103pt\u0103m\xe2ni",MM:"luni",yy:"ani"}[_]}function v(e,a,_){return"m"===_?a?"\u043c\u0438\u043d\u0443\u0442\u0430":"\u043c\u0438\u043d\u0443\u0442\u0443":e+" "+(e=+e,a=(a={ss:a?"\u0441\u0435\u043a\u0443\u043d\u0434\u0430_\u0441\u0435\u043a\u0443\u043d\u0434\u044b_\u0441\u0435\u043a\u0443\u043d\u0434":"\u0441\u0435\u043a\u0443\u043d\u0434\u0443_\u0441\u0435\u043a\u0443\u043d\u0434\u044b_\u0441\u0435\u043a\u0443\u043d\u0434",mm:a?"\u043c\u0438\u043d\u0443\u0442\u0430_\u043c\u0438\u043d\u0443\u0442\u044b_\u043c\u0438\u043d\u0443\u0442":"\u043c\u0438\u043d\u0443\u0442\u0443_\u043c\u0438\u043d\u0443\u0442\u044b_\u043c\u0438\u043d\u0443\u0442",hh:"\u0447\u0430\u0441_\u0447\u0430\u0441\u0430_\u0447\u0430\u0441\u043e\u0432",dd:"\u0434\u0435\u043d\u044c_\u0434\u043d\u044f_\u0434\u043d\u0435\u0439",ww:"\u043d\u0435\u0434\u0435\u043b\u044f_\u043d\u0435\u0434\u0435\u043b\u0438_\u043d\u0435\u0434\u0435\u043b\u044c",MM:"\u043c\u0435\u0441\u044f\u0446_\u043c\u0435\u0441\u044f\u0446\u0430_\u043c\u0435\u0441\u044f\u0446\u0435\u0432",yy:"\u0433\u043e\u0434_\u0433\u043e\u0434\u0430_\u043b\u0435\u0442"}[_]).split("_"),e%10==1&&e%100!=11?a[0]:2<=e%10&&e%10<=4&&(e%100<10||20<=e%100)?a[1]:a[2])}e.defineLocale("pl",{months:function(e,a){return e?(/D MMMM/.test(a)?Ze:Ve)[e.month()]:Ve},monthsShort:"sty_lut_mar_kwi_maj_cze_lip_sie_wrz_pa\u017a_lis_gru".split("_"),monthsParse:d,longMonthsParse:d,shortMonthsParse:d,weekdays:"niedziela_poniedzia\u0142ek_wtorek_\u015broda_czwartek_pi\u0105tek_sobota".split("_"),weekdaysShort:"ndz_pon_wt_\u015br_czw_pt_sob".split("_"),weekdaysMin:"Nd_Pn_Wt_\u015ar_Cz_Pt_So".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Dzi\u015b o] LT",nextDay:"[Jutro o] LT",nextWeek:function(){switch(this.day()){case 0:return"[W niedziel\u0119 o] LT";case 2:return"[We wtorek o] LT";case 3:return"[W \u015brod\u0119 o] LT";case 6:return"[W sobot\u0119 o] LT";default:return"[W] dddd [o] LT"}},lastDay:"[Wczoraj o] LT",lastWeek:function(){switch(this.day()){case 0:return"[W zesz\u0142\u0105 niedziel\u0119 o] LT";case 3:return"[W zesz\u0142\u0105 \u015brod\u0119 o] LT";case 6:return"[W zesz\u0142\u0105 sobot\u0119 o] LT";default:return"[W zesz\u0142y] dddd [o] LT"}},sameElse:"L"},relativeTime:{future:"za %s",past:"%s temu",s:"kilka sekund",ss:b,m:b,mm:b,h:b,hh:b,d:"1 dzie\u0144",dd:"%d dni",w:"tydzie\u0144",ww:b,M:"miesi\u0105c",MM:b,y:"rok",yy:b},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),e.defineLocale("pt-br",{months:"janeiro_fevereiro_mar\xe7o_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro".split("_"),monthsShort:"jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez".split("_"),weekdays:"domingo_segunda-feira_ter\xe7a-feira_quarta-feira_quinta-feira_sexta-feira_s\xe1bado".split("_"),weekdaysShort:"dom_seg_ter_qua_qui_sex_s\xe1b".split("_"),weekdaysMin:"do_2\xaa_3\xaa_4\xaa_5\xaa_6\xaa_s\xe1".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY [\xe0s] HH:mm",LLLL:"dddd, D [de] MMMM [de] YYYY [\xe0s] HH:mm"},calendar:{sameDay:"[Hoje \xe0s] LT",nextDay:"[Amanh\xe3 \xe0s] LT",nextWeek:"dddd [\xe0s] LT",lastDay:"[Ontem \xe0s] LT",lastWeek:function(){return 0===this.day()||6===this.day()?"[\xdaltimo] dddd [\xe0s] LT":"[\xdaltima] dddd [\xe0s] LT"},sameElse:"L"},relativeTime:{future:"em %s",past:"h\xe1 %s",s:"poucos segundos",ss:"%d segundos",m:"um minuto",mm:"%d minutos",h:"uma hora",hh:"%d horas",d:"um dia",dd:"%d dias",M:"um m\xeas",MM:"%d meses",y:"um ano",yy:"%d anos"},dayOfMonthOrdinalParse:/\d{1,2}\xba/,ordinal:"%d\xba",invalidDate:"Data inv\xe1lida"}),e.defineLocale("pt",{months:"janeiro_fevereiro_mar\xe7o_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro".split("_"),monthsShort:"jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez".split("_"),weekdays:"Domingo_Segunda-feira_Ter\xe7a-feira_Quarta-feira_Quinta-feira_Sexta-feira_S\xe1bado".split("_"),weekdaysShort:"Dom_Seg_Ter_Qua_Qui_Sex_S\xe1b".split("_"),weekdaysMin:"Do_2\xaa_3\xaa_4\xaa_5\xaa_6\xaa_S\xe1".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY HH:mm",LLLL:"dddd, D [de] MMMM [de] YYYY HH:mm"},calendar:{sameDay:"[Hoje \xe0s] LT",nextDay:"[Amanh\xe3 \xe0s] LT",nextWeek:"dddd [\xe0s] LT",lastDay:"[Ontem \xe0s] LT",lastWeek:function(){return 0===this.day()||6===this.day()?"[\xdaltimo] dddd [\xe0s] LT":"[\xdaltima] dddd [\xe0s] LT"},sameElse:"L"},relativeTime:{future:"em %s",past:"h\xe1 %s",s:"segundos",ss:"%d segundos",m:"um minuto",mm:"%d minutos",h:"uma hora",hh:"%d horas",d:"um dia",dd:"%d dias",w:"uma semana",ww:"%d semanas",M:"um m\xeas",MM:"%d meses",y:"um ano",yy:"%d anos"},dayOfMonthOrdinalParse:/\d{1,2}\xba/,ordinal:"%d\xba",week:{dow:1,doy:4}}),e.defineLocale("ro",{months:"ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie".split("_"),monthsShort:"ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"duminic\u0103_luni_mar\u021bi_miercuri_joi_vineri_s\xe2mb\u0103t\u0103".split("_"),weekdaysShort:"Dum_Lun_Mar_Mie_Joi_Vin_S\xe2m".split("_"),weekdaysMin:"Du_Lu_Ma_Mi_Jo_Vi_S\xe2".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY H:mm",LLLL:"dddd, D MMMM YYYY H:mm"},calendar:{sameDay:"[azi la] LT",nextDay:"[m\xe2ine la] LT",nextWeek:"dddd [la] LT",lastDay:"[ieri la] LT",lastWeek:"[fosta] dddd [la] LT",sameElse:"L"},relativeTime:{future:"peste %s",past:"%s \xeen urm\u0103",s:"c\xe2teva secunde",ss:S,m:"un minut",mm:S,h:"o or\u0103",hh:S,d:"o zi",dd:S,w:"o s\u0103pt\u0103m\xe2n\u0103",ww:S,M:"o lun\u0103",MM:S,y:"un an",yy:S},week:{dow:1,doy:7}});m=[/^\u044f\u043d\u0432/i,/^\u0444\u0435\u0432/i,/^\u043c\u0430\u0440/i,/^\u0430\u043f\u0440/i,/^\u043c\u0430[\u0439\u044f]/i,/^\u0438\u044e\u043d/i,/^\u0438\u044e\u043b/i,/^\u0430\u0432\u0433/i,/^\u0441\u0435\u043d/i,/^\u043e\u043a\u0442/i,/^\u043d\u043e\u044f/i,/^\u0434\u0435\u043a/i],e.defineLocale("ru",{months:{format:"\u044f\u043d\u0432\u0430\u0440\u044f_\u0444\u0435\u0432\u0440\u0430\u043b\u044f_\u043c\u0430\u0440\u0442\u0430_\u0430\u043f\u0440\u0435\u043b\u044f_\u043c\u0430\u044f_\u0438\u044e\u043d\u044f_\u0438\u044e\u043b\u044f_\u0430\u0432\u0433\u0443\u0441\u0442\u0430_\u0441\u0435\u043d\u0442\u044f\u0431\u0440\u044f_\u043e\u043a\u0442\u044f\u0431\u0440\u044f_\u043d\u043e\u044f\u0431\u0440\u044f_\u0434\u0435\u043a\u0430\u0431\u0440\u044f".split("_"),standalone:"\u044f\u043d\u0432\u0430\u0440\u044c_\u0444\u0435\u0432\u0440\u0430\u043b\u044c_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440\u0435\u043b\u044c_\u043c\u0430\u0439_\u0438\u044e\u043d\u044c_\u0438\u044e\u043b\u044c_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043d\u0442\u044f\u0431\u0440\u044c_\u043e\u043a\u0442\u044f\u0431\u0440\u044c_\u043d\u043e\u044f\u0431\u0440\u044c_\u0434\u0435\u043a\u0430\u0431\u0440\u044c".split("_")},monthsShort:{format:"\u044f\u043d\u0432._\u0444\u0435\u0432\u0440._\u043c\u0430\u0440._\u0430\u043f\u0440._\u043c\u0430\u044f_\u0438\u044e\u043d\u044f_\u0438\u044e\u043b\u044f_\u0430\u0432\u0433._\u0441\u0435\u043d\u0442._\u043e\u043a\u0442._\u043d\u043e\u044f\u0431._\u0434\u0435\u043a.".split("_"),standalone:"\u044f\u043d\u0432._\u0444\u0435\u0432\u0440._\u043c\u0430\u0440\u0442_\u0430\u043f\u0440._\u043c\u0430\u0439_\u0438\u044e\u043d\u044c_\u0438\u044e\u043b\u044c_\u0430\u0432\u0433._\u0441\u0435\u043d\u0442._\u043e\u043a\u0442._\u043d\u043e\u044f\u0431._\u0434\u0435\u043a.".split("_")},weekdays:{standalone:"\u0432\u043e\u0441\u043a\u0440\u0435\u0441\u0435\u043d\u044c\u0435_\u043f\u043e\u043d\u0435\u0434\u0435\u043b\u044c\u043d\u0438\u043a_\u0432\u0442\u043e\u0440\u043d\u0438\u043a_\u0441\u0440\u0435\u0434\u0430_\u0447\u0435\u0442\u0432\u0435\u0440\u0433_\u043f\u044f\u0442\u043d\u0438\u0446\u0430_\u0441\u0443\u0431\u0431\u043e\u0442\u0430".split("_"),format:"\u0432\u043e\u0441\u043a\u0440\u0435\u0441\u0435\u043d\u044c\u0435_\u043f\u043e\u043d\u0435\u0434\u0435\u043b\u044c\u043d\u0438\u043a_\u0432\u0442\u043e\u0440\u043d\u0438\u043a_\u0441\u0440\u0435\u0434\u0443_\u0447\u0435\u0442\u0432\u0435\u0440\u0433_\u043f\u044f\u0442\u043d\u0438\u0446\u0443_\u0441\u0443\u0431\u0431\u043e\u0442\u0443".split("_"),isFormat:/\[ ?[\u0412\u0432] ?(?:\u043f\u0440\u043e\u0448\u043b\u0443\u044e|\u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0443\u044e|\u044d\u0442\u0443)? ?] ?dddd/},weekdaysShort:"\u0432\u0441_\u043f\u043d_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043f\u0442_\u0441\u0431".split("_"),weekdaysMin:"\u0432\u0441_\u043f\u043d_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043f\u0442_\u0441\u0431".split("_"),monthsParse:m,longMonthsParse:m,shortMonthsParse:m,monthsRegex:/^(\u044f\u043d\u0432\u0430\u0440[\u044c\u044f]|\u044f\u043d\u0432\.?|\u0444\u0435\u0432\u0440\u0430\u043b[\u044c\u044f]|\u0444\u0435\u0432\u0440?\.?|\u043c\u0430\u0440\u0442\u0430?|\u043c\u0430\u0440\.?|\u0430\u043f\u0440\u0435\u043b[\u044c\u044f]|\u0430\u043f\u0440\.?|\u043c\u0430[\u0439\u044f]|\u0438\u044e\u043d[\u044c\u044f]|\u0438\u044e\u043d\.?|\u0438\u044e\u043b[\u044c\u044f]|\u0438\u044e\u043b\.?|\u0430\u0432\u0433\u0443\u0441\u0442\u0430?|\u0430\u0432\u0433\.?|\u0441\u0435\u043d\u0442\u044f\u0431\u0440[\u044c\u044f]|\u0441\u0435\u043d\u0442?\.?|\u043e\u043a\u0442\u044f\u0431\u0440[\u044c\u044f]|\u043e\u043a\u0442\.?|\u043d\u043e\u044f\u0431\u0440[\u044c\u044f]|\u043d\u043e\u044f\u0431?\.?|\u0434\u0435\u043a\u0430\u0431\u0440[\u044c\u044f]|\u0434\u0435\u043a\.?)/i,monthsShortRegex:/^(\u044f\u043d\u0432\u0430\u0440[\u044c\u044f]|\u044f\u043d\u0432\.?|\u0444\u0435\u0432\u0440\u0430\u043b[\u044c\u044f]|\u0444\u0435\u0432\u0440?\.?|\u043c\u0430\u0440\u0442\u0430?|\u043c\u0430\u0440\.?|\u0430\u043f\u0440\u0435\u043b[\u044c\u044f]|\u0430\u043f\u0440\.?|\u043c\u0430[\u0439\u044f]|\u0438\u044e\u043d[\u044c\u044f]|\u0438\u044e\u043d\.?|\u0438\u044e\u043b[\u044c\u044f]|\u0438\u044e\u043b\.?|\u0430\u0432\u0433\u0443\u0441\u0442\u0430?|\u0430\u0432\u0433\.?|\u0441\u0435\u043d\u0442\u044f\u0431\u0440[\u044c\u044f]|\u0441\u0435\u043d\u0442?\.?|\u043e\u043a\u0442\u044f\u0431\u0440[\u044c\u044f]|\u043e\u043a\u0442\.?|\u043d\u043e\u044f\u0431\u0440[\u044c\u044f]|\u043d\u043e\u044f\u0431?\.?|\u0434\u0435\u043a\u0430\u0431\u0440[\u044c\u044f]|\u0434\u0435\u043a\.?)/i,monthsStrictRegex:/^(\u044f\u043d\u0432\u0430\u0440[\u044f\u044c]|\u0444\u0435\u0432\u0440\u0430\u043b[\u044f\u044c]|\u043c\u0430\u0440\u0442\u0430?|\u0430\u043f\u0440\u0435\u043b[\u044f\u044c]|\u043c\u0430[\u044f\u0439]|\u0438\u044e\u043d[\u044f\u044c]|\u0438\u044e\u043b[\u044f\u044c]|\u0430\u0432\u0433\u0443\u0441\u0442\u0430?|\u0441\u0435\u043d\u0442\u044f\u0431\u0440[\u044f\u044c]|\u043e\u043a\u0442\u044f\u0431\u0440[\u044f\u044c]|\u043d\u043e\u044f\u0431\u0440[\u044f\u044c]|\u0434\u0435\u043a\u0430\u0431\u0440[\u044f\u044c])/i,monthsShortStrictRegex:/^(\u044f\u043d\u0432\.|\u0444\u0435\u0432\u0440?\.|\u043c\u0430\u0440[\u0442.]|\u0430\u043f\u0440\.|\u043c\u0430[\u044f\u0439]|\u0438\u044e\u043d[\u044c\u044f.]|\u0438\u044e\u043b[\u044c\u044f.]|\u0430\u0432\u0433\.|\u0441\u0435\u043d\u0442?\.|\u043e\u043a\u0442\.|\u043d\u043e\u044f\u0431?\.|\u0434\u0435\u043a\.)/i,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY \u0433.",LLL:"D MMMM YYYY \u0433., H:mm",LLLL:"dddd, D MMMM YYYY \u0433., H:mm"},calendar:{sameDay:"[\u0421\u0435\u0433\u043e\u0434\u043d\u044f, \u0432] LT",nextDay:"[\u0417\u0430\u0432\u0442\u0440\u0430, \u0432] LT",lastDay:"[\u0412\u0447\u0435\u0440\u0430, \u0432] LT",nextWeek:function(e){if(e.week()===this.week())return 2===this.day()?"[\u0412\u043e] dddd, [\u0432] LT":"[\u0412] dddd, [\u0432] LT";switch(this.day()){case 0:return"[\u0412 \u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0435\u0435] dddd, [\u0432] LT";case 1:case 2:case 4:return"[\u0412 \u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0438\u0439] dddd, [\u0432] LT";case 3:case 5:case 6:return"[\u0412 \u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0443\u044e] dddd, [\u0432] LT"}},lastWeek:function(e){if(e.week()===this.week())return 2===this.day()?"[\u0412\u043e] dddd, [\u0432] LT":"[\u0412] dddd, [\u0432] LT";switch(this.day()){case 0:return"[\u0412 \u043f\u0440\u043e\u0448\u043b\u043e\u0435] dddd, [\u0432] LT";case 1:case 2:case 4:return"[\u0412 \u043f\u0440\u043e\u0448\u043b\u044b\u0439] dddd, [\u0432] LT";case 3:case 5:case 6:return"[\u0412 \u043f\u0440\u043e\u0448\u043b\u0443\u044e] dddd, [\u0432] LT"}},sameElse:"L"},relativeTime:{future:"\u0447\u0435\u0440\u0435\u0437 %s",past:"%s \u043d\u0430\u0437\u0430\u0434",s:"\u043d\u0435\u0441\u043a\u043e\u043b\u044c\u043a\u043e \u0441\u0435\u043a\u0443\u043d\u0434",ss:v,m:v,mm:v,h:"\u0447\u0430\u0441",hh:v,d:"\u0434\u0435\u043d\u044c",dd:v,w:"\u043d\u0435\u0434\u0435\u043b\u044f",ww:v,M:"\u043c\u0435\u0441\u044f\u0446",MM:v,y:"\u0433\u043e\u0434",yy:v},meridiemParse:/\u043d\u043e\u0447\u0438|\u0443\u0442\u0440\u0430|\u0434\u043d\u044f|\u0432\u0435\u0447\u0435\u0440\u0430/i,isPM:function(e){return/^(\u0434\u043d\u044f|\u0432\u0435\u0447\u0435\u0440\u0430)$/.test(e)},meridiem:function(e,a,_){return e<4?"\u043d\u043e\u0447\u0438":e<12?"\u0443\u0442\u0440\u0430":e<17?"\u0434\u043d\u044f":"\u0432\u0435\u0447\u0435\u0440\u0430"},dayOfMonthOrdinalParse:/\d{1,2}-(\u0439|\u0433\u043e|\u044f)/,ordinal:function(e,a){switch(a){case"M":case"d":case"DDD":return e+"-\u0439";case"D":return e+"-\u0433\u043e";case"w":case"W":return e+"-\u044f";default:return e}},week:{dow:1,doy:4}}),n=["\u062c\u0646\u0648\u0631\u064a","\u0641\u064a\u0628\u0631\u0648\u0631\u064a","\u0645\u0627\u0631\u0686","\u0627\u067e\u0631\u064a\u0644","\u0645\u0626\u064a","\u062c\u0648\u0646","\u062c\u0648\u0644\u0627\u0621\u0650","\u0622\u06af\u0633\u067d","\u0633\u064a\u067e\u067d\u0645\u0628\u0631","\u0622\u06aa\u067d\u0648\u0628\u0631","\u0646\u0648\u0645\u0628\u0631","\u068a\u0633\u0645\u0628\u0631"],r=["\u0622\u0686\u0631","\u0633\u0648\u0645\u0631","\u0627\u06b1\u0627\u0631\u0648","\u0627\u0631\u0628\u0639","\u062e\u0645\u064a\u0633","\u062c\u0645\u0639","\u0687\u0646\u0687\u0631"],e.defineLocale("sd",{months:n,monthsShort:n,weekdays:r,weekdaysShort:r,weekdaysMin:r,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd\u060c D MMMM YYYY HH:mm"},meridiemParse:/\u0635\u0628\u062d|\u0634\u0627\u0645/,isPM:function(e){return"\u0634\u0627\u0645"===e},meridiem:function(e,a,_){return e<12?"\u0635\u0628\u062d":"\u0634\u0627\u0645"},calendar:{sameDay:"[\u0627\u0684] LT",nextDay:"[\u0633\u0680\u0627\u06bb\u064a] LT",nextWeek:"dddd [\u0627\u06b3\u064a\u0646 \u0647\u0641\u062a\u064a \u062a\u064a] LT",lastDay:"[\u06aa\u0627\u0644\u0647\u0647] LT",lastWeek:"[\u06af\u0632\u0631\u064a\u0644 \u0647\u0641\u062a\u064a] dddd [\u062a\u064a] LT",sameElse:"L"},relativeTime:{future:"%s \u067e\u0648\u0621",past:"%s \u0627\u06b3",s:"\u0686\u0646\u062f \u0633\u064a\u06aa\u0646\u068a",ss:"%d \u0633\u064a\u06aa\u0646\u068a",m:"\u0647\u06aa \u0645\u0646\u067d",mm:"%d \u0645\u0646\u067d",h:"\u0647\u06aa \u06aa\u0644\u0627\u06aa",hh:"%d \u06aa\u0644\u0627\u06aa",d:"\u0647\u06aa \u068f\u064a\u0646\u0647\u0646",dd:"%d \u068f\u064a\u0646\u0647\u0646",M:"\u0647\u06aa \u0645\u0647\u064a\u0646\u0648",MM:"%d \u0645\u0647\u064a\u0646\u0627",y:"\u0647\u06aa \u0633\u0627\u0644",yy:"%d \u0633\u0627\u0644"},preparse:function(e){return e.replace(/\u060c/g,",")},postformat:function(e){return e.replace(/,/g,"\u060c")},week:{dow:1,doy:4}}),e.defineLocale("se",{months:"o\u0111\u0111ajagem\xe1nnu_guovvam\xe1nnu_njuk\u010dam\xe1nnu_cuo\u014bom\xe1nnu_miessem\xe1nnu_geassem\xe1nnu_suoidnem\xe1nnu_borgem\xe1nnu_\u010dak\u010dam\xe1nnu_golggotm\xe1nnu_sk\xe1bmam\xe1nnu_juovlam\xe1nnu".split("_"),monthsShort:"o\u0111\u0111j_guov_njuk_cuo_mies_geas_suoi_borg_\u010dak\u010d_golg_sk\xe1b_juov".split("_"),weekdays:"sotnabeaivi_vuoss\xe1rga_ma\u014b\u014beb\xe1rga_gaskavahkku_duorastat_bearjadat_l\xe1vvardat".split("_"),weekdaysShort:"sotn_vuos_ma\u014b_gask_duor_bear_l\xe1v".split("_"),weekdaysMin:"s_v_m_g_d_b_L".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"MMMM D. [b.] YYYY",LLL:"MMMM D. [b.] YYYY [ti.] HH:mm",LLLL:"dddd, MMMM D. [b.] YYYY [ti.] HH:mm"},calendar:{sameDay:"[otne ti] LT",nextDay:"[ihttin ti] LT",nextWeek:"dddd [ti] LT",lastDay:"[ikte ti] LT",lastWeek:"[ovddit] dddd [ti] LT",sameElse:"L"},relativeTime:{future:"%s gea\u017ees",past:"ma\u014bit %s",s:"moadde sekunddat",ss:"%d sekunddat",m:"okta minuhta",mm:"%d minuhtat",h:"okta diimmu",hh:"%d diimmut",d:"okta beaivi",dd:"%d beaivvit",M:"okta m\xe1nnu",MM:"%d m\xe1nut",y:"okta jahki",yy:"%d jagit"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),e.defineLocale("si",{months:"\u0da2\u0db1\u0dc0\u0dcf\u0dbb\u0dd2_\u0db4\u0dd9\u0db6\u0dbb\u0dc0\u0dcf\u0dbb\u0dd2_\u0db8\u0dcf\u0dbb\u0dca\u0dad\u0dd4_\u0d85\u0db4\u0dca\u200d\u0dbb\u0dda\u0dbd\u0dca_\u0db8\u0dd0\u0dba\u0dd2_\u0da2\u0dd6\u0db1\u0dd2_\u0da2\u0dd6\u0dbd\u0dd2_\u0d85\u0d9c\u0ddd\u0dc3\u0dca\u0dad\u0dd4_\u0dc3\u0dd0\u0db4\u0dca\u0dad\u0dd0\u0db8\u0dca\u0db6\u0dbb\u0dca_\u0d94\u0d9a\u0dca\u0dad\u0ddd\u0db6\u0dbb\u0dca_\u0db1\u0ddc\u0dc0\u0dd0\u0db8\u0dca\u0db6\u0dbb\u0dca_\u0daf\u0dd9\u0dc3\u0dd0\u0db8\u0dca\u0db6\u0dbb\u0dca".split("_"),monthsShort:"\u0da2\u0db1_\u0db4\u0dd9\u0db6_\u0db8\u0dcf\u0dbb\u0dca_\u0d85\u0db4\u0dca_\u0db8\u0dd0\u0dba\u0dd2_\u0da2\u0dd6\u0db1\u0dd2_\u0da2\u0dd6\u0dbd\u0dd2_\u0d85\u0d9c\u0ddd_\u0dc3\u0dd0\u0db4\u0dca_\u0d94\u0d9a\u0dca_\u0db1\u0ddc\u0dc0\u0dd0_\u0daf\u0dd9\u0dc3\u0dd0".split("_"),weekdays:"\u0d89\u0dbb\u0dd2\u0daf\u0dcf_\u0dc3\u0db3\u0dd4\u0daf\u0dcf_\u0d85\u0d9f\u0dc4\u0dbb\u0dd4\u0dc0\u0dcf\u0daf\u0dcf_\u0db6\u0daf\u0dcf\u0daf\u0dcf_\u0db6\u0dca\u200d\u0dbb\u0dc4\u0dc3\u0dca\u0db4\u0dad\u0dd2\u0db1\u0dca\u0daf\u0dcf_\u0dc3\u0dd2\u0d9a\u0dd4\u0dbb\u0dcf\u0daf\u0dcf_\u0dc3\u0dd9\u0db1\u0dc3\u0dd4\u0dbb\u0dcf\u0daf\u0dcf".split("_"),weekdaysShort:"\u0d89\u0dbb\u0dd2_\u0dc3\u0db3\u0dd4_\u0d85\u0d9f_\u0db6\u0daf\u0dcf_\u0db6\u0dca\u200d\u0dbb\u0dc4_\u0dc3\u0dd2\u0d9a\u0dd4_\u0dc3\u0dd9\u0db1".split("_"),weekdaysMin:"\u0d89_\u0dc3_\u0d85_\u0db6_\u0db6\u0dca\u200d\u0dbb_\u0dc3\u0dd2_\u0dc3\u0dd9".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"a h:mm",LTS:"a h:mm:ss",L:"YYYY/MM/DD",LL:"YYYY MMMM D",LLL:"YYYY MMMM D, a h:mm",LLLL:"YYYY MMMM D [\u0dc0\u0dd0\u0db1\u0dd2] dddd, a h:mm:ss"},calendar:{sameDay:"[\u0d85\u0daf] LT[\u0da7]",nextDay:"[\u0dc4\u0dd9\u0da7] LT[\u0da7]",nextWeek:"dddd LT[\u0da7]",lastDay:"[\u0d8a\u0dba\u0dda] LT[\u0da7]",lastWeek:"[\u0db4\u0dc3\u0dd4\u0d9c\u0dd2\u0dba] dddd LT[\u0da7]",sameElse:"L"},relativeTime:{future:"%s\u0d9a\u0dd2\u0db1\u0dca",past:"%s\u0d9a\u0da7 \u0db4\u0dd9\u0dbb",s:"\u0dad\u0dad\u0dca\u0db4\u0dbb \u0d9a\u0dd2\u0dc4\u0dd2\u0db4\u0dba",ss:"\u0dad\u0dad\u0dca\u0db4\u0dbb %d",m:"\u0db8\u0dd2\u0db1\u0dd2\u0dad\u0dca\u0dad\u0dd4\u0dc0",mm:"\u0db8\u0dd2\u0db1\u0dd2\u0dad\u0dca\u0dad\u0dd4 %d",h:"\u0db4\u0dd0\u0dba",hh:"\u0db4\u0dd0\u0dba %d",d:"\u0daf\u0dd2\u0db1\u0dba",dd:"\u0daf\u0dd2\u0db1 %d",M:"\u0db8\u0dcf\u0dc3\u0dba",MM:"\u0db8\u0dcf\u0dc3 %d",y:"\u0dc0\u0dc3\u0dbb",yy:"\u0dc0\u0dc3\u0dbb %d"},dayOfMonthOrdinalParse:/\d{1,2} \u0dc0\u0dd0\u0db1\u0dd2/,ordinal:function(e){return e+" \u0dc0\u0dd0\u0db1\u0dd2"},meridiemParse:/\u0db4\u0dd9\u0dbb \u0dc0\u0dbb\u0dd4|\u0db4\u0dc3\u0dca \u0dc0\u0dbb\u0dd4|\u0db4\u0dd9.\u0dc0|\u0db4.\u0dc0./,isPM:function(e){return"\u0db4.\u0dc0."===e||"\u0db4\u0dc3\u0dca \u0dc0\u0dbb\u0dd4"===e},meridiem:function(e,a,_){return 11<e?_?"\u0db4.\u0dc0.":"\u0db4\u0dc3\u0dca \u0dc0\u0dbb\u0dd4":_?"\u0db4\u0dd9.\u0dc0.":"\u0db4\u0dd9\u0dbb \u0dc0\u0dbb\u0dd4"}}),d="janu\xe1r_febru\xe1r_marec_apr\xedl_m\xe1j_j\xfan_j\xfal_august_september_okt\xf3ber_november_december".split("_"),m="jan_feb_mar_apr_m\xe1j_j\xfan_j\xfal_aug_sep_okt_nov_dec".split("_");function ea(e){return 1<e&&e<5}function j(e,a,_,s){var d=e+" ";switch(_){case"s":return a||s?"p\xe1r sek\xfand":"p\xe1r sekundami";case"ss":return a||s?d+(ea(e)?"sekundy":"sek\xfand"):d+"sekundami";case"m":return a?"min\xfata":s?"min\xfatu":"min\xfatou";case"mm":return a||s?d+(ea(e)?"min\xfaty":"min\xfat"):d+"min\xfatami";case"h":return a?"hodina":s?"hodinu":"hodinou";case"hh":return a||s?d+(ea(e)?"hodiny":"hod\xedn"):d+"hodinami";case"d":return a||s?"de\u0148":"d\u0148om";case"dd":return a||s?d+(ea(e)?"dni":"dn\xed"):d+"d\u0148ami";case"M":return a||s?"mesiac":"mesiacom";case"MM":return a||s?d+(ea(e)?"mesiace":"mesiacov"):d+"mesiacmi";case"y":return a||s?"rok":"rokom";case"yy":return a||s?d+(ea(e)?"roky":"rokov"):d+"rokmi"}}function x(e,a,_,s){var d=e+" ";switch(_){case"s":return a||s?"nekaj sekund":"nekaj sekundami";case"ss":return d+=1===e?a?"sekundo":"sekundi":2===e?a||s?"sekundi":"sekundah":e<5?a||s?"sekunde":"sekundah":"sekund";case"m":return a?"ena minuta":"eno minuto";case"mm":return d+=1===e?a?"minuta":"minuto":2===e?a||s?"minuti":"minutama":e<5?a||s?"minute":"minutami":a||s?"minut":"minutami";case"h":return a?"ena ura":"eno uro";case"hh":return d+=1===e?a?"ura":"uro":2===e?a||s?"uri":"urama":e<5?a||s?"ure":"urami":a||s?"ur":"urami";case"d":return a||s?"en dan":"enim dnem";case"dd":return d+=1===e?a||s?"dan":"dnem":2===e?a||s?"dni":"dnevoma":a||s?"dni":"dnevi";case"M":return a||s?"en mesec":"enim mesecem";case"MM":return d+=1===e?a||s?"mesec":"mesecem":2===e?a||s?"meseca":"mesecema":e<5?a||s?"mesece":"meseci":a||s?"mesecev":"meseci";case"y":return a||s?"eno leto":"enim letom";case"yy":return d+=1===e?a||s?"leto":"letom":2===e?a||s?"leti":"letoma":e<5?a||s?"leta":"leti":a||s?"let":"leti"}}e.defineLocale("sk",{months:d,monthsShort:m,weekdays:"nede\u013ea_pondelok_utorok_streda_\u0161tvrtok_piatok_sobota".split("_"),weekdaysShort:"ne_po_ut_st_\u0161t_pi_so".split("_"),weekdaysMin:"ne_po_ut_st_\u0161t_pi_so".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd D. MMMM YYYY H:mm"},calendar:{sameDay:"[dnes o] LT",nextDay:"[zajtra o] LT",nextWeek:function(){switch(this.day()){case 0:return"[v nede\u013eu o] LT";case 1:case 2:return"[v] dddd [o] LT";case 3:return"[v stredu o] LT";case 4:return"[vo \u0161tvrtok o] LT";case 5:return"[v piatok o] LT";case 6:return"[v sobotu o] LT"}},lastDay:"[v\u010dera o] LT",lastWeek:function(){switch(this.day()){case 0:return"[minul\xfa nede\u013eu o] LT";case 1:case 2:return"[minul\xfd] dddd [o] LT";case 3:return"[minul\xfa stredu o] LT";case 4:case 5:return"[minul\xfd] dddd [o] LT";case 6:return"[minul\xfa sobotu o] LT"}},sameElse:"L"},relativeTime:{future:"za %s",past:"pred %s",s:j,ss:j,m:j,mm:j,h:j,hh:j,d:j,dd:j,M:j,MM:j,y:j,yy:j},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),e.defineLocale("sl",{months:"januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december".split("_"),monthsShort:"jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"nedelja_ponedeljek_torek_sreda_\u010detrtek_petek_sobota".split("_"),weekdaysShort:"ned._pon._tor._sre._\u010det._pet._sob.".split("_"),weekdaysMin:"ne_po_to_sr_\u010de_pe_so".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD. MM. YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd, D. MMMM YYYY H:mm"},calendar:{sameDay:"[danes ob] LT",nextDay:"[jutri ob] LT",nextWeek:function(){switch(this.day()){case 0:return"[v] [nedeljo] [ob] LT";case 3:return"[v] [sredo] [ob] LT";case 6:return"[v] [soboto] [ob] LT";case 1:case 2:case 4:case 5:return"[v] dddd [ob] LT"}},lastDay:"[v\u010deraj ob] LT",lastWeek:function(){switch(this.day()){case 0:return"[prej\u0161njo] [nedeljo] [ob] LT";case 3:return"[prej\u0161njo] [sredo] [ob] LT";case 6:return"[prej\u0161njo] [soboto] [ob] LT";case 1:case 2:case 4:case 5:return"[prej\u0161nji] dddd [ob] LT"}},sameElse:"L"},relativeTime:{future:"\u010dez %s",past:"pred %s",s:x,ss:x,m:x,mm:x,h:x,hh:x,d:x,dd:x,M:x,MM:x,y:x,yy:x},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}}),e.defineLocale("sq",{months:"Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_N\xebntor_Dhjetor".split("_"),monthsShort:"Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_N\xebn_Dhj".split("_"),weekdays:"E Diel_E H\xebn\xeb_E Mart\xeb_E M\xebrkur\xeb_E Enjte_E Premte_E Shtun\xeb".split("_"),weekdaysShort:"Die_H\xebn_Mar_M\xebr_Enj_Pre_Sht".split("_"),weekdaysMin:"D_H_Ma_M\xeb_E_P_Sh".split("_"),weekdaysParseExact:!0,meridiemParse:/PD|MD/,isPM:function(e){return"M"===e.charAt(0)},meridiem:function(e,a,_){return e<12?"PD":"MD"},longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Sot n\xeb] LT",nextDay:"[Nes\xebr n\xeb] LT",nextWeek:"dddd [n\xeb] LT",lastDay:"[Dje n\xeb] LT",lastWeek:"dddd [e kaluar n\xeb] LT",sameElse:"L"},relativeTime:{future:"n\xeb %s",past:"%s m\xeb par\xeb",s:"disa sekonda",ss:"%d sekonda",m:"nj\xeb minut\xeb",mm:"%d minuta",h:"nj\xeb or\xeb",hh:"%d or\xeb",d:"nj\xeb dit\xeb",dd:"%d dit\xeb",M:"nj\xeb muaj",MM:"%d muaj",y:"nj\xeb vit",yy:"%d vite"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}});var P={words:{ss:["\u0441\u0435\u043a\u0443\u043d\u0434\u0430","\u0441\u0435\u043a\u0443\u043d\u0434\u0435","\u0441\u0435\u043a\u0443\u043d\u0434\u0438"],m:["\u0458\u0435\u0434\u0430\u043d \u043c\u0438\u043d\u0443\u0442","\u0458\u0435\u0434\u043d\u043e\u0433 \u043c\u0438\u043d\u0443\u0442\u0430"],mm:["\u043c\u0438\u043d\u0443\u0442","\u043c\u0438\u043d\u0443\u0442\u0430","\u043c\u0438\u043d\u0443\u0442\u0430"],h:["\u0458\u0435\u0434\u0430\u043d \u0441\u0430\u0442","\u0458\u0435\u0434\u043d\u043e\u0433 \u0441\u0430\u0442\u0430"],hh:["\u0441\u0430\u0442","\u0441\u0430\u0442\u0430","\u0441\u0430\u0442\u0438"],d:["\u0458\u0435\u0434\u0430\u043d \u0434\u0430\u043d","\u0458\u0435\u0434\u043d\u043e\u0433 \u0434\u0430\u043d\u0430"],dd:["\u0434\u0430\u043d","\u0434\u0430\u043d\u0430","\u0434\u0430\u043d\u0430"],M:["\u0458\u0435\u0434\u0430\u043d \u043c\u0435\u0441\u0435\u0446","\u0458\u0435\u0434\u043d\u043e\u0433 \u043c\u0435\u0441\u0435\u0446\u0430"],MM:["\u043c\u0435\u0441\u0435\u0446","\u043c\u0435\u0441\u0435\u0446\u0430","\u043c\u0435\u0441\u0435\u0446\u0438"],y:["\u0458\u0435\u0434\u043d\u0443 \u0433\u043e\u0434\u0438\u043d\u0443","\u0458\u0435\u0434\u043d\u0435 \u0433\u043e\u0434\u0438\u043d\u0435"],yy:["\u0433\u043e\u0434\u0438\u043d\u0443","\u0433\u043e\u0434\u0438\u043d\u0435","\u0433\u043e\u0434\u0438\u043d\u0430"]},correctGrammaticalCase:function(e,a){return 1<=e%10&&e%10<=4&&(e%100<10||20<=e%100)?e%10==1?a[0]:a[1]:a[2]},translate:function(e,a,_,s){var d=P.words[_];return 1===_.length?"y"===_&&a?"\u0458\u0435\u0434\u043d\u0430 \u0433\u043e\u0434\u0438\u043d\u0430":s||a?d[0]:d[1]:(s=P.correctGrammaticalCase(e,d),"yy"===_&&a&&"\u0433\u043e\u0434\u0438\u043d\u0443"===s?e+" \u0433\u043e\u0434\u0438\u043d\u0430":e+" "+s)}},W=(e.defineLocale("sr-cyrl",{months:"\u0458\u0430\u043d\u0443\u0430\u0440_\u0444\u0435\u0431\u0440\u0443\u0430\u0440_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440\u0438\u043b_\u043c\u0430\u0458_\u0458\u0443\u043d_\u0458\u0443\u043b_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043f\u0442\u0435\u043c\u0431\u0430\u0440_\u043e\u043a\u0442\u043e\u0431\u0430\u0440_\u043d\u043e\u0432\u0435\u043c\u0431\u0430\u0440_\u0434\u0435\u0446\u0435\u043c\u0431\u0430\u0440".split("_"),monthsShort:"\u0458\u0430\u043d._\u0444\u0435\u0431._\u043c\u0430\u0440._\u0430\u043f\u0440._\u043c\u0430\u0458_\u0458\u0443\u043d_\u0458\u0443\u043b_\u0430\u0432\u0433._\u0441\u0435\u043f._\u043e\u043a\u0442._\u043d\u043e\u0432._\u0434\u0435\u0446.".split("_"),monthsParseExact:!0,weekdays:"\u043d\u0435\u0434\u0435\u0459\u0430_\u043f\u043e\u043d\u0435\u0434\u0435\u0459\u0430\u043a_\u0443\u0442\u043e\u0440\u0430\u043a_\u0441\u0440\u0435\u0434\u0430_\u0447\u0435\u0442\u0432\u0440\u0442\u0430\u043a_\u043f\u0435\u0442\u0430\u043a_\u0441\u0443\u0431\u043e\u0442\u0430".split("_"),weekdaysShort:"\u043d\u0435\u0434._\u043f\u043e\u043d._\u0443\u0442\u043e._\u0441\u0440\u0435._\u0447\u0435\u0442._\u043f\u0435\u0442._\u0441\u0443\u0431.".split("_"),weekdaysMin:"\u043d\u0435_\u043f\u043e_\u0443\u0442_\u0441\u0440_\u0447\u0435_\u043f\u0435_\u0441\u0443".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"D. M. YYYY.",LL:"D. MMMM YYYY.",LLL:"D. MMMM YYYY. H:mm",LLLL:"dddd, D. MMMM YYYY. H:mm"},calendar:{sameDay:"[\u0434\u0430\u043d\u0430\u0441 \u0443] LT",nextDay:"[\u0441\u0443\u0442\u0440\u0430 \u0443] LT",nextWeek:function(){switch(this.day()){case 0:return"[\u0443] [\u043d\u0435\u0434\u0435\u0459\u0443] [\u0443] LT";case 3:return"[\u0443] [\u0441\u0440\u0435\u0434\u0443] [\u0443] LT";case 6:return"[\u0443] [\u0441\u0443\u0431\u043e\u0442\u0443] [\u0443] LT";case 1:case 2:case 4:case 5:return"[\u0443] dddd [\u0443] LT"}},lastDay:"[\u0458\u0443\u0447\u0435 \u0443] LT",lastWeek:function(){return["[\u043f\u0440\u043e\u0448\u043b\u0435] [\u043d\u0435\u0434\u0435\u0459\u0435] [\u0443] LT","[\u043f\u0440\u043e\u0448\u043b\u043e\u0433] [\u043f\u043e\u043d\u0435\u0434\u0435\u0459\u043a\u0430] [\u0443] LT","[\u043f\u0440\u043e\u0448\u043b\u043e\u0433] [\u0443\u0442\u043e\u0440\u043a\u0430] [\u0443] LT","[\u043f\u0440\u043e\u0448\u043b\u0435] [\u0441\u0440\u0435\u0434\u0435] [\u0443] LT","[\u043f\u0440\u043e\u0448\u043b\u043e\u0433] [\u0447\u0435\u0442\u0432\u0440\u0442\u043a\u0430] [\u0443] LT","[\u043f\u0440\u043e\u0448\u043b\u043e\u0433] [\u043f\u0435\u0442\u043a\u0430] [\u0443] LT","[\u043f\u0440\u043e\u0448\u043b\u0435] [\u0441\u0443\u0431\u043e\u0442\u0435] [\u0443] LT"][this.day()]},sameElse:"L"},relativeTime:{future:"\u0437\u0430 %s",past:"\u043f\u0440\u0435 %s",s:"\u043d\u0435\u043a\u043e\u043b\u0438\u043a\u043e \u0441\u0435\u043a\u0443\u043d\u0434\u0438",ss:P.translate,m:P.translate,mm:P.translate,h:P.translate,hh:P.translate,d:P.translate,dd:P.translate,M:P.translate,MM:P.translate,y:P.translate,yy:P.translate},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}}),{words:{ss:["sekunda","sekunde","sekundi"],m:["jedan minut","jednog minuta"],mm:["minut","minuta","minuta"],h:["jedan sat","jednog sata"],hh:["sat","sata","sati"],d:["jedan dan","jednog dana"],dd:["dan","dana","dana"],M:["jedan mesec","jednog meseca"],MM:["mesec","meseca","meseci"],y:["jednu godinu","jedne godine"],yy:["godinu","godine","godina"]},correctGrammaticalCase:function(e,a){return 1<=e%10&&e%10<=4&&(e%100<10||20<=e%100)?e%10==1?a[0]:a[1]:a[2]},translate:function(e,a,_,s){var d=W.words[_];return 1===_.length?"y"===_&&a?"jedna godina":s||a?d[0]:d[1]:(s=W.correctGrammaticalCase(e,d),"yy"===_&&a&&"godinu"===s?e+" godina":e+" "+s)}}),aa=(e.defineLocale("sr",{months:"januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar".split("_"),monthsShort:"jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"nedelja_ponedeljak_utorak_sreda_\u010detvrtak_petak_subota".split("_"),weekdaysShort:"ned._pon._uto._sre._\u010det._pet._sub.".split("_"),weekdaysMin:"ne_po_ut_sr_\u010de_pe_su".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"D. M. YYYY.",LL:"D. MMMM YYYY.",LLL:"D. MMMM YYYY. H:mm",LLLL:"dddd, D. MMMM YYYY. H:mm"},calendar:{sameDay:"[danas u] LT",nextDay:"[sutra u] LT",nextWeek:function(){switch(this.day()){case 0:return"[u] [nedelju] [u] LT";case 3:return"[u] [sredu] [u] LT";case 6:return"[u] [subotu] [u] LT";case 1:case 2:case 4:case 5:return"[u] dddd [u] LT"}},lastDay:"[ju\u010de u] LT",lastWeek:function(){return["[pro\u0161le] [nedelje] [u] LT","[pro\u0161log] [ponedeljka] [u] LT","[pro\u0161log] [utorka] [u] LT","[pro\u0161le] [srede] [u] LT","[pro\u0161log] [\u010detvrtka] [u] LT","[pro\u0161log] [petka] [u] LT","[pro\u0161le] [subote] [u] LT"][this.day()]},sameElse:"L"},relativeTime:{future:"za %s",past:"pre %s",s:"nekoliko sekundi",ss:W.translate,m:W.translate,mm:W.translate,h:W.translate,hh:W.translate,d:W.translate,dd:W.translate,M:W.translate,MM:W.translate,y:W.translate,yy:W.translate},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}}),e.defineLocale("ss",{months:"Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split("_"),monthsShort:"Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo".split("_"),weekdays:"Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo".split("_"),weekdaysShort:"Lis_Umb_Lsb_Les_Lsi_Lsh_Umg".split("_"),weekdaysMin:"Li_Us_Lb_Lt_Ls_Lh_Ug".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY h:mm A",LLLL:"dddd, D MMMM YYYY h:mm A"},calendar:{sameDay:"[Namuhla nga] LT",nextDay:"[Kusasa nga] LT",nextWeek:"dddd [nga] LT",lastDay:"[Itolo nga] LT",lastWeek:"dddd [leliphelile] [nga] LT",sameElse:"L"},relativeTime:{future:"nga %s",past:"wenteka nga %s",s:"emizuzwana lomcane",ss:"%d mzuzwana",m:"umzuzu",mm:"%d emizuzu",h:"lihora",hh:"%d emahora",d:"lilanga",dd:"%d emalanga",M:"inyanga",MM:"%d tinyanga",y:"umnyaka",yy:"%d iminyaka"},meridiemParse:/ekuseni|emini|entsambama|ebusuku/,meridiem:function(e,a,_){return e<11?"ekuseni":e<15?"emini":e<19?"entsambama":"ebusuku"},meridiemHour:function(e,a){return 12===e&&(e=0),"ekuseni"===a?e:"emini"===a?11<=e?e:e+12:"entsambama"===a||"ebusuku"===a?0===e?0:e+12:void 0},dayOfMonthOrdinalParse:/\d{1,2}/,ordinal:"%d",week:{dow:1,doy:4}}),e.defineLocale("sv",{months:"januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december".split("_"),monthsShort:"jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec".split("_"),weekdays:"s\xf6ndag_m\xe5ndag_tisdag_onsdag_torsdag_fredag_l\xf6rdag".split("_"),weekdaysShort:"s\xf6n_m\xe5n_tis_ons_tor_fre_l\xf6r".split("_"),weekdaysMin:"s\xf6_m\xe5_ti_on_to_fr_l\xf6".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [kl.] HH:mm",LLLL:"dddd D MMMM YYYY [kl.] HH:mm",lll:"D MMM YYYY HH:mm",llll:"ddd D MMM YYYY HH:mm"},calendar:{sameDay:"[Idag] LT",nextDay:"[Imorgon] LT",lastDay:"[Ig\xe5r] LT",nextWeek:"[P\xe5] dddd LT",lastWeek:"[I] dddd[s] LT",sameElse:"L"},relativeTime:{future:"om %s",past:"f\xf6r %s sedan",s:"n\xe5gra sekunder",ss:"%d sekunder",m:"en minut",mm:"%d minuter",h:"en timme",hh:"%d timmar",d:"en dag",dd:"%d dagar",M:"en m\xe5nad",MM:"%d m\xe5nader",y:"ett \xe5r",yy:"%d \xe5r"},dayOfMonthOrdinalParse:/\d{1,2}(\:e|\:a)/,ordinal:function(e){var a=e%10;return e+(1!=~~(e%100/10)&&(1==a||2==a)?":a":":e")},week:{dow:1,doy:4}}),e.defineLocale("sw",{months:"Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba".split("_"),monthsShort:"Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des".split("_"),weekdays:"Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi".split("_"),weekdaysShort:"Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos".split("_"),weekdaysMin:"J2_J3_J4_J5_Al_Ij_J1".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"hh:mm A",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[leo saa] LT",nextDay:"[kesho saa] LT",nextWeek:"[wiki ijayo] dddd [saat] LT",lastDay:"[jana] LT",lastWeek:"[wiki iliyopita] dddd [saat] LT",sameElse:"L"},relativeTime:{future:"%s baadaye",past:"tokea %s",s:"hivi punde",ss:"sekunde %d",m:"dakika moja",mm:"dakika %d",h:"saa limoja",hh:"masaa %d",d:"siku moja",dd:"siku %d",M:"mwezi mmoja",MM:"miezi %d",y:"mwaka mmoja",yy:"miaka %d"},week:{dow:1,doy:7}}),{1:"\u0be7",2:"\u0be8",3:"\u0be9",4:"\u0bea",5:"\u0beb",6:"\u0bec",7:"\u0bed",8:"\u0bee",9:"\u0bef",0:"\u0be6"}),_a={"\u0be7":"1","\u0be8":"2","\u0be9":"3","\u0bea":"4","\u0beb":"5","\u0bec":"6","\u0bed":"7","\u0bee":"8","\u0bef":"9","\u0be6":"0"},sa=(e.defineLocale("ta",{months:"\u0b9c\u0ba9\u0bb5\u0bb0\u0bbf_\u0baa\u0bbf\u0baa\u0bcd\u0bb0\u0bb5\u0bb0\u0bbf_\u0bae\u0bbe\u0bb0\u0bcd\u0b9a\u0bcd_\u0b8f\u0baa\u0bcd\u0bb0\u0bb2\u0bcd_\u0bae\u0bc7_\u0b9c\u0bc2\u0ba9\u0bcd_\u0b9c\u0bc2\u0bb2\u0bc8_\u0b86\u0b95\u0bb8\u0bcd\u0b9f\u0bcd_\u0b9a\u0bc6\u0baa\u0bcd\u0b9f\u0bc6\u0bae\u0bcd\u0baa\u0bb0\u0bcd_\u0b85\u0b95\u0bcd\u0b9f\u0bc7\u0bbe\u0baa\u0bb0\u0bcd_\u0ba8\u0bb5\u0bae\u0bcd\u0baa\u0bb0\u0bcd_\u0b9f\u0bbf\u0b9a\u0bae\u0bcd\u0baa\u0bb0\u0bcd".split("_"),monthsShort:"\u0b9c\u0ba9\u0bb5\u0bb0\u0bbf_\u0baa\u0bbf\u0baa\u0bcd\u0bb0\u0bb5\u0bb0\u0bbf_\u0bae\u0bbe\u0bb0\u0bcd\u0b9a\u0bcd_\u0b8f\u0baa\u0bcd\u0bb0\u0bb2\u0bcd_\u0bae\u0bc7_\u0b9c\u0bc2\u0ba9\u0bcd_\u0b9c\u0bc2\u0bb2\u0bc8_\u0b86\u0b95\u0bb8\u0bcd\u0b9f\u0bcd_\u0b9a\u0bc6\u0baa\u0bcd\u0b9f\u0bc6\u0bae\u0bcd\u0baa\u0bb0\u0bcd_\u0b85\u0b95\u0bcd\u0b9f\u0bc7\u0bbe\u0baa\u0bb0\u0bcd_\u0ba8\u0bb5\u0bae\u0bcd\u0baa\u0bb0\u0bcd_\u0b9f\u0bbf\u0b9a\u0bae\u0bcd\u0baa\u0bb0\u0bcd".split("_"),weekdays:"\u0b9e\u0bbe\u0baf\u0bbf\u0bb1\u0bcd\u0bb1\u0bc1\u0b95\u0bcd\u0b95\u0bbf\u0bb4\u0bae\u0bc8_\u0ba4\u0bbf\u0b99\u0bcd\u0b95\u0b9f\u0bcd\u0b95\u0bbf\u0bb4\u0bae\u0bc8_\u0b9a\u0bc6\u0bb5\u0bcd\u0bb5\u0bbe\u0baf\u0bcd\u0b95\u0bbf\u0bb4\u0bae\u0bc8_\u0baa\u0bc1\u0ba4\u0ba9\u0bcd\u0b95\u0bbf\u0bb4\u0bae\u0bc8_\u0bb5\u0bbf\u0baf\u0bbe\u0bb4\u0b95\u0bcd\u0b95\u0bbf\u0bb4\u0bae\u0bc8_\u0bb5\u0bc6\u0bb3\u0bcd\u0bb3\u0bbf\u0b95\u0bcd\u0b95\u0bbf\u0bb4\u0bae\u0bc8_\u0b9a\u0ba9\u0bbf\u0b95\u0bcd\u0b95\u0bbf\u0bb4\u0bae\u0bc8".split("_"),weekdaysShort:"\u0b9e\u0bbe\u0baf\u0bbf\u0bb1\u0bc1_\u0ba4\u0bbf\u0b99\u0bcd\u0b95\u0bb3\u0bcd_\u0b9a\u0bc6\u0bb5\u0bcd\u0bb5\u0bbe\u0baf\u0bcd_\u0baa\u0bc1\u0ba4\u0ba9\u0bcd_\u0bb5\u0bbf\u0baf\u0bbe\u0bb4\u0ba9\u0bcd_\u0bb5\u0bc6\u0bb3\u0bcd\u0bb3\u0bbf_\u0b9a\u0ba9\u0bbf".split("_"),weekdaysMin:"\u0b9e\u0bbe_\u0ba4\u0bbf_\u0b9a\u0bc6_\u0baa\u0bc1_\u0bb5\u0bbf_\u0bb5\u0bc6_\u0b9a".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, HH:mm",LLLL:"dddd, D MMMM YYYY, HH:mm"},calendar:{sameDay:"[\u0b87\u0ba9\u0bcd\u0bb1\u0bc1] LT",nextDay:"[\u0ba8\u0bbe\u0bb3\u0bc8] LT",nextWeek:"dddd, LT",lastDay:"[\u0ba8\u0bc7\u0bb1\u0bcd\u0bb1\u0bc1] LT",lastWeek:"[\u0b95\u0b9f\u0ba8\u0bcd\u0ba4 \u0bb5\u0bbe\u0bb0\u0bae\u0bcd] dddd, LT",sameElse:"L"},relativeTime:{future:"%s \u0b87\u0bb2\u0bcd",past:"%s \u0bae\u0bc1\u0ba9\u0bcd",s:"\u0b92\u0bb0\u0bc1 \u0b9a\u0bbf\u0bb2 \u0bb5\u0bbf\u0ba8\u0bbe\u0b9f\u0bbf\u0b95\u0bb3\u0bcd",ss:"%d \u0bb5\u0bbf\u0ba8\u0bbe\u0b9f\u0bbf\u0b95\u0bb3\u0bcd",m:"\u0b92\u0bb0\u0bc1 \u0ba8\u0bbf\u0bae\u0bbf\u0b9f\u0bae\u0bcd",mm:"%d \u0ba8\u0bbf\u0bae\u0bbf\u0b9f\u0b99\u0bcd\u0b95\u0bb3\u0bcd",h:"\u0b92\u0bb0\u0bc1 \u0bae\u0ba3\u0bbf \u0ba8\u0bc7\u0bb0\u0bae\u0bcd",hh:"%d \u0bae\u0ba3\u0bbf \u0ba8\u0bc7\u0bb0\u0bae\u0bcd",d:"\u0b92\u0bb0\u0bc1 \u0ba8\u0bbe\u0bb3\u0bcd",dd:"%d \u0ba8\u0bbe\u0b9f\u0bcd\u0b95\u0bb3\u0bcd",M:"\u0b92\u0bb0\u0bc1 \u0bae\u0bbe\u0ba4\u0bae\u0bcd",MM:"%d \u0bae\u0bbe\u0ba4\u0b99\u0bcd\u0b95\u0bb3\u0bcd",y:"\u0b92\u0bb0\u0bc1 \u0bb5\u0bb0\u0bc1\u0b9f\u0bae\u0bcd",yy:"%d \u0b86\u0ba3\u0bcd\u0b9f\u0bc1\u0b95\u0bb3\u0bcd"},dayOfMonthOrdinalParse:/\d{1,2}\u0bb5\u0ba4\u0bc1/,ordinal:function(e){return e+"\u0bb5\u0ba4\u0bc1"},preparse:function(e){return e.replace(/[\u0be7\u0be8\u0be9\u0bea\u0beb\u0bec\u0bed\u0bee\u0bef\u0be6]/g,function(e){return _a[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return aa[e]})},meridiemParse:/\u0baf\u0bbe\u0bae\u0bae\u0bcd|\u0bb5\u0bc8\u0b95\u0bb1\u0bc8|\u0b95\u0bbe\u0bb2\u0bc8|\u0ba8\u0ba3\u0bcd\u0baa\u0b95\u0bb2\u0bcd|\u0b8e\u0bb1\u0bcd\u0baa\u0bbe\u0b9f\u0bc1|\u0bae\u0bbe\u0bb2\u0bc8/,meridiem:function(e,a,_){return e<2?" \u0baf\u0bbe\u0bae\u0bae\u0bcd":e<6?" \u0bb5\u0bc8\u0b95\u0bb1\u0bc8":e<10?" \u0b95\u0bbe\u0bb2\u0bc8":e<14?" \u0ba8\u0ba3\u0bcd\u0baa\u0b95\u0bb2\u0bcd":e<18?" \u0b8e\u0bb1\u0bcd\u0baa\u0bbe\u0b9f\u0bc1":e<22?" \u0bae\u0bbe\u0bb2\u0bc8":" \u0baf\u0bbe\u0bae\u0bae\u0bcd"},meridiemHour:function(e,a){return 12===e&&(e=0),"\u0baf\u0bbe\u0bae\u0bae\u0bcd"===a?e<2?e:e+12:"\u0bb5\u0bc8\u0b95\u0bb1\u0bc8"===a||"\u0b95\u0bbe\u0bb2\u0bc8"===a||"\u0ba8\u0ba3\u0bcd\u0baa\u0b95\u0bb2\u0bcd"===a&&10<=e?e:e+12},week:{dow:0,doy:6}}),e.defineLocale("te",{months:"\u0c1c\u0c28\u0c35\u0c30\u0c3f_\u0c2b\u0c3f\u0c2c\u0c4d\u0c30\u0c35\u0c30\u0c3f_\u0c2e\u0c3e\u0c30\u0c4d\u0c1a\u0c3f_\u0c0f\u0c2a\u0c4d\u0c30\u0c3f\u0c32\u0c4d_\u0c2e\u0c47_\u0c1c\u0c42\u0c28\u0c4d_\u0c1c\u0c41\u0c32\u0c48_\u0c06\u0c17\u0c38\u0c4d\u0c1f\u0c41_\u0c38\u0c46\u0c2a\u0c4d\u0c1f\u0c46\u0c02\u0c2c\u0c30\u0c4d_\u0c05\u0c15\u0c4d\u0c1f\u0c4b\u0c2c\u0c30\u0c4d_\u0c28\u0c35\u0c02\u0c2c\u0c30\u0c4d_\u0c21\u0c3f\u0c38\u0c46\u0c02\u0c2c\u0c30\u0c4d".split("_"),monthsShort:"\u0c1c\u0c28._\u0c2b\u0c3f\u0c2c\u0c4d\u0c30._\u0c2e\u0c3e\u0c30\u0c4d\u0c1a\u0c3f_\u0c0f\u0c2a\u0c4d\u0c30\u0c3f._\u0c2e\u0c47_\u0c1c\u0c42\u0c28\u0c4d_\u0c1c\u0c41\u0c32\u0c48_\u0c06\u0c17._\u0c38\u0c46\u0c2a\u0c4d._\u0c05\u0c15\u0c4d\u0c1f\u0c4b._\u0c28\u0c35._\u0c21\u0c3f\u0c38\u0c46.".split("_"),monthsParseExact:!0,weekdays:"\u0c06\u0c26\u0c3f\u0c35\u0c3e\u0c30\u0c02_\u0c38\u0c4b\u0c2e\u0c35\u0c3e\u0c30\u0c02_\u0c2e\u0c02\u0c17\u0c33\u0c35\u0c3e\u0c30\u0c02_\u0c2c\u0c41\u0c27\u0c35\u0c3e\u0c30\u0c02_\u0c17\u0c41\u0c30\u0c41\u0c35\u0c3e\u0c30\u0c02_\u0c36\u0c41\u0c15\u0c4d\u0c30\u0c35\u0c3e\u0c30\u0c02_\u0c36\u0c28\u0c3f\u0c35\u0c3e\u0c30\u0c02".split("_"),weekdaysShort:"\u0c06\u0c26\u0c3f_\u0c38\u0c4b\u0c2e_\u0c2e\u0c02\u0c17\u0c33_\u0c2c\u0c41\u0c27_\u0c17\u0c41\u0c30\u0c41_\u0c36\u0c41\u0c15\u0c4d\u0c30_\u0c36\u0c28\u0c3f".split("_"),weekdaysMin:"\u0c06_\u0c38\u0c4b_\u0c2e\u0c02_\u0c2c\u0c41_\u0c17\u0c41_\u0c36\u0c41_\u0c36".split("_"),longDateFormat:{LT:"A h:mm",LTS:"A h:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm",LLLL:"dddd, D MMMM YYYY, A h:mm"},calendar:{sameDay:"[\u0c28\u0c47\u0c21\u0c41] LT",nextDay:"[\u0c30\u0c47\u0c2a\u0c41] LT",nextWeek:"dddd, LT",lastDay:"[\u0c28\u0c3f\u0c28\u0c4d\u0c28] LT",lastWeek:"[\u0c17\u0c24] dddd, LT",sameElse:"L"},relativeTime:{future:"%s \u0c32\u0c4b",past:"%s \u0c15\u0c4d\u0c30\u0c3f\u0c24\u0c02",s:"\u0c15\u0c4a\u0c28\u0c4d\u0c28\u0c3f \u0c15\u0c4d\u0c37\u0c23\u0c3e\u0c32\u0c41",ss:"%d \u0c38\u0c46\u0c15\u0c28\u0c4d\u0c32\u0c41",m:"\u0c12\u0c15 \u0c28\u0c3f\u0c2e\u0c3f\u0c37\u0c02",mm:"%d \u0c28\u0c3f\u0c2e\u0c3f\u0c37\u0c3e\u0c32\u0c41",h:"\u0c12\u0c15 \u0c17\u0c02\u0c1f",hh:"%d \u0c17\u0c02\u0c1f\u0c32\u0c41",d:"\u0c12\u0c15 \u0c30\u0c4b\u0c1c\u0c41",dd:"%d \u0c30\u0c4b\u0c1c\u0c41\u0c32\u0c41",M:"\u0c12\u0c15 \u0c28\u0c46\u0c32",MM:"%d \u0c28\u0c46\u0c32\u0c32\u0c41",y:"\u0c12\u0c15 \u0c38\u0c02\u0c35\u0c24\u0c4d\u0c38\u0c30\u0c02",yy:"%d \u0c38\u0c02\u0c35\u0c24\u0c4d\u0c38\u0c30\u0c3e\u0c32\u0c41"},dayOfMonthOrdinalParse:/\d{1,2}\u0c35/,ordinal:"%d\u0c35",meridiemParse:/\u0c30\u0c3e\u0c24\u0c4d\u0c30\u0c3f|\u0c09\u0c26\u0c2f\u0c02|\u0c2e\u0c27\u0c4d\u0c2f\u0c3e\u0c39\u0c4d\u0c28\u0c02|\u0c38\u0c3e\u0c2f\u0c02\u0c24\u0c4d\u0c30\u0c02/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u0c30\u0c3e\u0c24\u0c4d\u0c30\u0c3f"===a?e<4?e:e+12:"\u0c09\u0c26\u0c2f\u0c02"===a?e:"\u0c2e\u0c27\u0c4d\u0c2f\u0c3e\u0c39\u0c4d\u0c28\u0c02"===a?10<=e?e:e+12:"\u0c38\u0c3e\u0c2f\u0c02\u0c24\u0c4d\u0c30\u0c02"===a?e+12:void 0},meridiem:function(e,a,_){return e<4?"\u0c30\u0c3e\u0c24\u0c4d\u0c30\u0c3f":e<10?"\u0c09\u0c26\u0c2f\u0c02":e<17?"\u0c2e\u0c27\u0c4d\u0c2f\u0c3e\u0c39\u0c4d\u0c28\u0c02":e<20?"\u0c38\u0c3e\u0c2f\u0c02\u0c24\u0c4d\u0c30\u0c02":"\u0c30\u0c3e\u0c24\u0c4d\u0c30\u0c3f"},week:{dow:0,doy:6}}),e.defineLocale("tet",{months:"Janeiru_Fevereiru_Marsu_Abril_Maiu_Ju\xf1u_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru".split("_"),monthsShort:"Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split("_"),weekdays:"Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu".split("_"),weekdaysShort:"Dom_Seg_Ters_Kua_Kint_Sest_Sab".split("_"),weekdaysMin:"Do_Seg_Te_Ku_Ki_Ses_Sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Ohin iha] LT",nextDay:"[Aban iha] LT",nextWeek:"dddd [iha] LT",lastDay:"[Horiseik iha] LT",lastWeek:"dddd [semana kotuk] [iha] LT",sameElse:"L"},relativeTime:{future:"iha %s",past:"%s liuba",s:"segundu balun",ss:"segundu %d",m:"minutu ida",mm:"minutu %d",h:"oras ida",hh:"oras %d",d:"loron ida",dd:"loron %d",M:"fulan ida",MM:"fulan %d",y:"tinan ida",yy:"tinan %d"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?"th":1==a?"st":2==a?"nd":3==a?"rd":"th")},week:{dow:1,doy:4}}),{0:"-\u0443\u043c",1:"-\u0443\u043c",2:"-\u044e\u043c",3:"-\u044e\u043c",4:"-\u0443\u043c",5:"-\u0443\u043c",6:"-\u0443\u043c",7:"-\u0443\u043c",8:"-\u0443\u043c",9:"-\u0443\u043c",10:"-\u0443\u043c",12:"-\u0443\u043c",13:"-\u0443\u043c",20:"-\u0443\u043c",30:"-\u044e\u043c",40:"-\u0443\u043c",50:"-\u0443\u043c",60:"-\u0443\u043c",70:"-\u0443\u043c",80:"-\u0443\u043c",90:"-\u0443\u043c",100:"-\u0443\u043c"}),da=(e.defineLocale("tg",{months:{format:"\u044f\u043d\u0432\u0430\u0440\u0438_\u0444\u0435\u0432\u0440\u0430\u043b\u0438_\u043c\u0430\u0440\u0442\u0438_\u0430\u043f\u0440\u0435\u043b\u0438_\u043c\u0430\u0439\u0438_\u0438\u044e\u043d\u0438_\u0438\u044e\u043b\u0438_\u0430\u0432\u0433\u0443\u0441\u0442\u0438_\u0441\u0435\u043d\u0442\u044f\u0431\u0440\u0438_\u043e\u043a\u0442\u044f\u0431\u0440\u0438_\u043d\u043e\u044f\u0431\u0440\u0438_\u0434\u0435\u043a\u0430\u0431\u0440\u0438".split("_"),standalone:"\u044f\u043d\u0432\u0430\u0440_\u0444\u0435\u0432\u0440\u0430\u043b_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440\u0435\u043b_\u043c\u0430\u0439_\u0438\u044e\u043d_\u0438\u044e\u043b_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043d\u0442\u044f\u0431\u0440_\u043e\u043a\u0442\u044f\u0431\u0440_\u043d\u043e\u044f\u0431\u0440_\u0434\u0435\u043a\u0430\u0431\u0440".split("_")},monthsShort:"\u044f\u043d\u0432_\u0444\u0435\u0432_\u043c\u0430\u0440_\u0430\u043f\u0440_\u043c\u0430\u0439_\u0438\u044e\u043d_\u0438\u044e\u043b_\u0430\u0432\u0433_\u0441\u0435\u043d_\u043e\u043a\u0442_\u043d\u043e\u044f_\u0434\u0435\u043a".split("_"),weekdays:"\u044f\u043a\u0448\u0430\u043d\u0431\u0435_\u0434\u0443\u0448\u0430\u043d\u0431\u0435_\u0441\u0435\u0448\u0430\u043d\u0431\u0435_\u0447\u043e\u0440\u0448\u0430\u043d\u0431\u0435_\u043f\u0430\u043d\u04b7\u0448\u0430\u043d\u0431\u0435_\u04b7\u0443\u043c\u044a\u0430_\u0448\u0430\u043d\u0431\u0435".split("_"),weekdaysShort:"\u044f\u0448\u0431_\u0434\u0448\u0431_\u0441\u0448\u0431_\u0447\u0448\u0431_\u043f\u0448\u0431_\u04b7\u0443\u043c_\u0448\u043d\u0431".split("_"),weekdaysMin:"\u044f\u0448_\u0434\u0448_\u0441\u0448_\u0447\u0448_\u043f\u0448_\u04b7\u043c_\u0448\u0431".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[\u0418\u043c\u0440\u04ef\u0437 \u0441\u043e\u0430\u0442\u0438] LT",nextDay:"[\u0424\u0430\u0440\u0434\u043e \u0441\u043e\u0430\u0442\u0438] LT",lastDay:"[\u0414\u0438\u0440\u04ef\u0437 \u0441\u043e\u0430\u0442\u0438] LT",nextWeek:"dddd[\u0438] [\u04b3\u0430\u0444\u0442\u0430\u0438 \u043e\u044f\u043d\u0434\u0430 \u0441\u043e\u0430\u0442\u0438] LT",lastWeek:"dddd[\u0438] [\u04b3\u0430\u0444\u0442\u0430\u0438 \u0433\u0443\u0437\u0430\u0448\u0442\u0430 \u0441\u043e\u0430\u0442\u0438] LT",sameElse:"L"},relativeTime:{future:"\u0431\u0430\u044a\u0434\u0438 %s",past:"%s \u043f\u0435\u0448",s:"\u044f\u043a\u0447\u0430\u043d\u0434 \u0441\u043e\u043d\u0438\u044f",m:"\u044f\u043a \u0434\u0430\u049b\u0438\u049b\u0430",mm:"%d \u0434\u0430\u049b\u0438\u049b\u0430",h:"\u044f\u043a \u0441\u043e\u0430\u0442",hh:"%d \u0441\u043e\u0430\u0442",d:"\u044f\u043a \u0440\u04ef\u0437",dd:"%d \u0440\u04ef\u0437",M:"\u044f\u043a \u043c\u043e\u04b3",MM:"%d \u043c\u043e\u04b3",y:"\u044f\u043a \u0441\u043e\u043b",yy:"%d \u0441\u043e\u043b"},meridiemParse:/\u0448\u0430\u0431|\u0441\u0443\u0431\u04b3|\u0440\u04ef\u0437|\u0431\u0435\u0433\u043e\u04b3/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u0448\u0430\u0431"===a?e<4?e:e+12:"\u0441\u0443\u0431\u04b3"===a?e:"\u0440\u04ef\u0437"===a?11<=e?e:e+12:"\u0431\u0435\u0433\u043e\u04b3"===a?e+12:void 0},meridiem:function(e,a,_){return e<4?"\u0448\u0430\u0431":e<11?"\u0441\u0443\u0431\u04b3":e<16?"\u0440\u04ef\u0437":e<19?"\u0431\u0435\u0433\u043e\u04b3":"\u0448\u0430\u0431"},dayOfMonthOrdinalParse:/\d{1,2}-(\u0443\u043c|\u044e\u043c)/,ordinal:function(e){return e+(sa[e]||sa[e%10]||sa[100<=e?100:null])},week:{dow:1,doy:7}}),e.defineLocale("th",{months:"\u0e21\u0e01\u0e23\u0e32\u0e04\u0e21_\u0e01\u0e38\u0e21\u0e20\u0e32\u0e1e\u0e31\u0e19\u0e18\u0e4c_\u0e21\u0e35\u0e19\u0e32\u0e04\u0e21_\u0e40\u0e21\u0e29\u0e32\u0e22\u0e19_\u0e1e\u0e24\u0e29\u0e20\u0e32\u0e04\u0e21_\u0e21\u0e34\u0e16\u0e38\u0e19\u0e32\u0e22\u0e19_\u0e01\u0e23\u0e01\u0e0e\u0e32\u0e04\u0e21_\u0e2a\u0e34\u0e07\u0e2b\u0e32\u0e04\u0e21_\u0e01\u0e31\u0e19\u0e22\u0e32\u0e22\u0e19_\u0e15\u0e38\u0e25\u0e32\u0e04\u0e21_\u0e1e\u0e24\u0e28\u0e08\u0e34\u0e01\u0e32\u0e22\u0e19_\u0e18\u0e31\u0e19\u0e27\u0e32\u0e04\u0e21".split("_"),monthsShort:"\u0e21.\u0e04._\u0e01.\u0e1e._\u0e21\u0e35.\u0e04._\u0e40\u0e21.\u0e22._\u0e1e.\u0e04._\u0e21\u0e34.\u0e22._\u0e01.\u0e04._\u0e2a.\u0e04._\u0e01.\u0e22._\u0e15.\u0e04._\u0e1e.\u0e22._\u0e18.\u0e04.".split("_"),monthsParseExact:!0,weekdays:"\u0e2d\u0e32\u0e17\u0e34\u0e15\u0e22\u0e4c_\u0e08\u0e31\u0e19\u0e17\u0e23\u0e4c_\u0e2d\u0e31\u0e07\u0e04\u0e32\u0e23_\u0e1e\u0e38\u0e18_\u0e1e\u0e24\u0e2b\u0e31\u0e2a\u0e1a\u0e14\u0e35_\u0e28\u0e38\u0e01\u0e23\u0e4c_\u0e40\u0e2a\u0e32\u0e23\u0e4c".split("_"),weekdaysShort:"\u0e2d\u0e32\u0e17\u0e34\u0e15\u0e22\u0e4c_\u0e08\u0e31\u0e19\u0e17\u0e23\u0e4c_\u0e2d\u0e31\u0e07\u0e04\u0e32\u0e23_\u0e1e\u0e38\u0e18_\u0e1e\u0e24\u0e2b\u0e31\u0e2a_\u0e28\u0e38\u0e01\u0e23\u0e4c_\u0e40\u0e2a\u0e32\u0e23\u0e4c".split("_"),weekdaysMin:"\u0e2d\u0e32._\u0e08._\u0e2d._\u0e1e._\u0e1e\u0e24._\u0e28._\u0e2a.".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY \u0e40\u0e27\u0e25\u0e32 H:mm",LLLL:"\u0e27\u0e31\u0e19dddd\u0e17\u0e35\u0e48 D MMMM YYYY \u0e40\u0e27\u0e25\u0e32 H:mm"},meridiemParse:/\u0e01\u0e48\u0e2d\u0e19\u0e40\u0e17\u0e35\u0e48\u0e22\u0e07|\u0e2b\u0e25\u0e31\u0e07\u0e40\u0e17\u0e35\u0e48\u0e22\u0e07/,isPM:function(e){return"\u0e2b\u0e25\u0e31\u0e07\u0e40\u0e17\u0e35\u0e48\u0e22\u0e07"===e},meridiem:function(e,a,_){return e<12?"\u0e01\u0e48\u0e2d\u0e19\u0e40\u0e17\u0e35\u0e48\u0e22\u0e07":"\u0e2b\u0e25\u0e31\u0e07\u0e40\u0e17\u0e35\u0e48\u0e22\u0e07"},calendar:{sameDay:"[\u0e27\u0e31\u0e19\u0e19\u0e35\u0e49 \u0e40\u0e27\u0e25\u0e32] LT",nextDay:"[\u0e1e\u0e23\u0e38\u0e48\u0e07\u0e19\u0e35\u0e49 \u0e40\u0e27\u0e25\u0e32] LT",nextWeek:"dddd[\u0e2b\u0e19\u0e49\u0e32 \u0e40\u0e27\u0e25\u0e32] LT",lastDay:"[\u0e40\u0e21\u0e37\u0e48\u0e2d\u0e27\u0e32\u0e19\u0e19\u0e35\u0e49 \u0e40\u0e27\u0e25\u0e32] LT",lastWeek:"[\u0e27\u0e31\u0e19]dddd[\u0e17\u0e35\u0e48\u0e41\u0e25\u0e49\u0e27 \u0e40\u0e27\u0e25\u0e32] LT",sameElse:"L"},relativeTime:{future:"\u0e2d\u0e35\u0e01 %s",past:"%s\u0e17\u0e35\u0e48\u0e41\u0e25\u0e49\u0e27",s:"\u0e44\u0e21\u0e48\u0e01\u0e35\u0e48\u0e27\u0e34\u0e19\u0e32\u0e17\u0e35",ss:"%d \u0e27\u0e34\u0e19\u0e32\u0e17\u0e35",m:"1 \u0e19\u0e32\u0e17\u0e35",mm:"%d \u0e19\u0e32\u0e17\u0e35",h:"1 \u0e0a\u0e31\u0e48\u0e27\u0e42\u0e21\u0e07",hh:"%d \u0e0a\u0e31\u0e48\u0e27\u0e42\u0e21\u0e07",d:"1 \u0e27\u0e31\u0e19",dd:"%d \u0e27\u0e31\u0e19",w:"1 \u0e2a\u0e31\u0e1b\u0e14\u0e32\u0e2b\u0e4c",ww:"%d \u0e2a\u0e31\u0e1b\u0e14\u0e32\u0e2b\u0e4c",M:"1 \u0e40\u0e14\u0e37\u0e2d\u0e19",MM:"%d \u0e40\u0e14\u0e37\u0e2d\u0e19",y:"1 \u0e1b\u0e35",yy:"%d \u0e1b\u0e35"}}),{1:"'inji",5:"'inji",8:"'inji",70:"'inji",80:"'inji",2:"'nji",7:"'nji",20:"'nji",50:"'nji",3:"'\xfcnji",4:"'\xfcnji",100:"'\xfcnji",6:"'njy",9:"'unjy",10:"'unjy",30:"'unjy",60:"'ynjy",90:"'ynjy"}),ta=(e.defineLocale("tk",{months:"\xddanwar_Fewral_Mart_Aprel_Ma\xfd_I\xfdun_I\xfdul_Awgust_Sent\xfdabr_Okt\xfdabr_No\xfdabr_Dekabr".split("_"),monthsShort:"\xddan_Few_Mar_Apr_Ma\xfd_I\xfdn_I\xfdl_Awg_Sen_Okt_No\xfd_Dek".split("_"),weekdays:"\xddek\u015fenbe_Du\u015fenbe_Si\u015fenbe_\xc7ar\u015fenbe_Pen\u015fenbe_Anna_\u015eenbe".split("_"),weekdaysShort:"\xddek_Du\u015f_Si\u015f_\xc7ar_Pen_Ann_\u015een".split("_"),weekdaysMin:"\xddk_D\u015f_S\u015f_\xc7r_Pn_An_\u015en".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[bug\xfcn sagat] LT",nextDay:"[ertir sagat] LT",nextWeek:"[indiki] dddd [sagat] LT",lastDay:"[d\xfc\xfdn] LT",lastWeek:"[ge\xe7en] dddd [sagat] LT",sameElse:"L"},relativeTime:{future:"%s so\u0148",past:"%s \xf6\u0148",s:"birn\xe4\xe7e sekunt",m:"bir minut",mm:"%d minut",h:"bir sagat",hh:"%d sagat",d:"bir g\xfcn",dd:"%d g\xfcn",M:"bir a\xfd",MM:"%d a\xfd",y:"bir \xfdyl",yy:"%d \xfdyl"},ordinal:function(e,a){switch(a){case"d":case"D":case"Do":case"DD":return e;default:if(0===e)return e+"'unjy";var _=e%10;return e+(da[_]||da[e%100-_]||da[100<=e?100:null])}},week:{dow:1,doy:7}}),e.defineLocale("tl-ph",{months:"Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre".split("_"),monthsShort:"Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis".split("_"),weekdays:"Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado".split("_"),weekdaysShort:"Lin_Lun_Mar_Miy_Huw_Biy_Sab".split("_"),weekdaysMin:"Li_Lu_Ma_Mi_Hu_Bi_Sab".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"MM/D/YYYY",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY HH:mm",LLLL:"dddd, MMMM DD, YYYY HH:mm"},calendar:{sameDay:"LT [ngayong araw]",nextDay:"[Bukas ng] LT",nextWeek:"LT [sa susunod na] dddd",lastDay:"LT [kahapon]",lastWeek:"LT [noong nakaraang] dddd",sameElse:"L"},relativeTime:{future:"sa loob ng %s",past:"%s ang nakalipas",s:"ilang segundo",ss:"%d segundo",m:"isang minuto",mm:"%d minuto",h:"isang oras",hh:"%d oras",d:"isang araw",dd:"%d araw",M:"isang buwan",MM:"%d buwan",y:"isang taon",yy:"%d taon"},dayOfMonthOrdinalParse:/\d{1,2}/,ordinal:function(e){return e},week:{dow:1,doy:4}}),"pagh_wa\u2019_cha\u2019_wej_loS_vagh_jav_Soch_chorgh_Hut".split("_"));function na(e,a,_,s){var d=function(e){var a=Math.floor(e%1e3/100),_=Math.floor(e%100/10),e=e%10,s="";0<a&&(s+=ta[a]+"vatlh");0<_&&(s+=(""!==s?" ":"")+ta[_]+"maH");0<e&&(s+=(""!==s?" ":"")+ta[e]);return""===s?"pagh":s}(e);switch(_){case"ss":return d+" lup";case"mm":return d+" tup";case"hh":return d+" rep";case"dd":return d+" jaj";case"MM":return d+" jar";case"yy":return d+" DIS"}}e.defineLocale("tlh",{months:"tera\u2019 jar wa\u2019_tera\u2019 jar cha\u2019_tera\u2019 jar wej_tera\u2019 jar loS_tera\u2019 jar vagh_tera\u2019 jar jav_tera\u2019 jar Soch_tera\u2019 jar chorgh_tera\u2019 jar Hut_tera\u2019 jar wa\u2019maH_tera\u2019 jar wa\u2019maH wa\u2019_tera\u2019 jar wa\u2019maH cha\u2019".split("_"),monthsShort:"jar wa\u2019_jar cha\u2019_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa\u2019maH_jar wa\u2019maH wa\u2019_jar wa\u2019maH cha\u2019".split("_"),monthsParseExact:!0,weekdays:"lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj".split("_"),weekdaysShort:"lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj".split("_"),weekdaysMin:"lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[DaHjaj] LT",nextDay:"[wa\u2019leS] LT",nextWeek:"LLL",lastDay:"[wa\u2019Hu\u2019] LT",lastWeek:"LLL",sameElse:"L"},relativeTime:{future:function(e){var a=e;return a=-1!==e.indexOf("jaj")?a.slice(0,-3)+"leS":-1!==e.indexOf("jar")?a.slice(0,-3)+"waQ":-1!==e.indexOf("DIS")?a.slice(0,-3)+"nem":a+" pIq"},past:function(e){var a=e;return a=-1!==e.indexOf("jaj")?a.slice(0,-3)+"Hu\u2019":-1!==e.indexOf("jar")?a.slice(0,-3)+"wen":-1!==e.indexOf("DIS")?a.slice(0,-3)+"ben":a+" ret"},s:"puS lup",ss:na,m:"wa\u2019 tup",mm:na,h:"wa\u2019 rep",hh:na,d:"wa\u2019 jaj",dd:na,M:"wa\u2019 jar",MM:na,y:"wa\u2019 DIS",yy:na},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}});var ra={1:"'inci",5:"'inci",8:"'inci",70:"'inci",80:"'inci",2:"'nci",7:"'nci",20:"'nci",50:"'nci",3:"'\xfcnc\xfc",4:"'\xfcnc\xfc",100:"'\xfcnc\xfc",6:"'nc\u0131",9:"'uncu",10:"'uncu",30:"'uncu",60:"'\u0131nc\u0131",90:"'\u0131nc\u0131"};function A(e,a,_,s){e={s:["viensas secunds","'iensas secunds"],ss:[e+" secunds",e+" secunds"],m:["'n m\xedut","'iens m\xedut"],mm:[e+" m\xeduts",e+" m\xeduts"],h:["'n \xfeora","'iensa \xfeora"],hh:[e+" \xfeoras",e+" \xfeoras"],d:["'n ziua","'iensa ziua"],dd:[e+" ziuas",e+" ziuas"],M:["'n mes","'iens mes"],MM:[e+" mesen",e+" mesen"],y:["'n ar","'iens ar"],yy:[e+" ars",e+" ars"]};return s||a?e[_][0]:e[_][1]}function O(e,a,_){return"m"===_?a?"\u0445\u0432\u0438\u043b\u0438\u043d\u0430":"\u0445\u0432\u0438\u043b\u0438\u043d\u0443":"h"===_?a?"\u0433\u043e\u0434\u0438\u043d\u0430":"\u0433\u043e\u0434\u0438\u043d\u0443":e+" "+(e=+e,a=(a={ss:a?"\u0441\u0435\u043a\u0443\u043d\u0434\u0430_\u0441\u0435\u043a\u0443\u043d\u0434\u0438_\u0441\u0435\u043a\u0443\u043d\u0434":"\u0441\u0435\u043a\u0443\u043d\u0434\u0443_\u0441\u0435\u043a\u0443\u043d\u0434\u0438_\u0441\u0435\u043a\u0443\u043d\u0434",mm:a?"\u0445\u0432\u0438\u043b\u0438\u043d\u0430_\u0445\u0432\u0438\u043b\u0438\u043d\u0438_\u0445\u0432\u0438\u043b\u0438\u043d":"\u0445\u0432\u0438\u043b\u0438\u043d\u0443_\u0445\u0432\u0438\u043b\u0438\u043d\u0438_\u0445\u0432\u0438\u043b\u0438\u043d",hh:a?"\u0433\u043e\u0434\u0438\u043d\u0430_\u0433\u043e\u0434\u0438\u043d\u0438_\u0433\u043e\u0434\u0438\u043d":"\u0433\u043e\u0434\u0438\u043d\u0443_\u0433\u043e\u0434\u0438\u043d\u0438_\u0433\u043e\u0434\u0438\u043d",dd:"\u0434\u0435\u043d\u044c_\u0434\u043d\u0456_\u0434\u043d\u0456\u0432",MM:"\u043c\u0456\u0441\u044f\u0446\u044c_\u043c\u0456\u0441\u044f\u0446\u0456_\u043c\u0456\u0441\u044f\u0446\u0456\u0432",yy:"\u0440\u0456\u043a_\u0440\u043e\u043a\u0438_\u0440\u043e\u043a\u0456\u0432"}[_]).split("_"),e%10==1&&e%100!=11?a[0]:2<=e%10&&e%10<=4&&(e%100<10||20<=e%100)?a[1]:a[2])}function ia(e){return function(){return e+"\u043e"+(11===this.hours()?"\u0431":"")+"] LT"}}e.defineLocale("tr",{months:"Ocak_\u015eubat_Mart_Nisan_May\u0131s_Haziran_Temmuz_A\u011fustos_Eyl\xfcl_Ekim_Kas\u0131m_Aral\u0131k".split("_"),monthsShort:"Oca_\u015eub_Mar_Nis_May_Haz_Tem_A\u011fu_Eyl_Eki_Kas_Ara".split("_"),weekdays:"Pazar_Pazartesi_Sal\u0131_\xc7ar\u015famba_Per\u015fembe_Cuma_Cumartesi".split("_"),weekdaysShort:"Paz_Pzt_Sal_\xc7ar_Per_Cum_Cmt".split("_"),weekdaysMin:"Pz_Pt_Sa_\xc7a_Pe_Cu_Ct".split("_"),meridiem:function(e,a,_){return e<12?_?"\xf6\xf6":"\xd6\xd6":_?"\xf6s":"\xd6S"},meridiemParse:/\xf6\xf6|\xd6\xd6|\xf6s|\xd6S/,isPM:function(e){return"\xf6s"===e||"\xd6S"===e},longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[bug\xfcn saat] LT",nextDay:"[yar\u0131n saat] LT",nextWeek:"[gelecek] dddd [saat] LT",lastDay:"[d\xfcn] LT",lastWeek:"[ge\xe7en] dddd [saat] LT",sameElse:"L"},relativeTime:{future:"%s sonra",past:"%s \xf6nce",s:"birka\xe7 saniye",ss:"%d saniye",m:"bir dakika",mm:"%d dakika",h:"bir saat",hh:"%d saat",d:"bir g\xfcn",dd:"%d g\xfcn",w:"bir hafta",ww:"%d hafta",M:"bir ay",MM:"%d ay",y:"bir y\u0131l",yy:"%d y\u0131l"},ordinal:function(e,a){switch(a){case"d":case"D":case"Do":case"DD":return e;default:if(0===e)return e+"'\u0131nc\u0131";var _=e%10;return e+(ra[_]||ra[e%100-_]||ra[100<=e?100:null])}},week:{dow:1,doy:7}}),e.defineLocale("tzl",{months:"Januar_Fevraglh_Mar\xe7_Avr\xefu_Mai_G\xfcn_Julia_Guscht_Setemvar_Listop\xe4ts_Noemvar_Zecemvar".split("_"),monthsShort:"Jan_Fev_Mar_Avr_Mai_G\xfcn_Jul_Gus_Set_Lis_Noe_Zec".split("_"),weekdays:"S\xfaladi_L\xfane\xe7i_Maitzi_M\xe1rcuri_Xh\xfaadi_Vi\xe9ner\xe7i_S\xe1turi".split("_"),weekdaysShort:"S\xfal_L\xfan_Mai_M\xe1r_Xh\xfa_Vi\xe9_S\xe1t".split("_"),weekdaysMin:"S\xfa_L\xfa_Ma_M\xe1_Xh_Vi_S\xe1".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD.MM.YYYY",LL:"D. MMMM [dallas] YYYY",LLL:"D. MMMM [dallas] YYYY HH.mm",LLLL:"dddd, [li] D. MMMM [dallas] YYYY HH.mm"},meridiemParse:/d\'o|d\'a/i,isPM:function(e){return"d'o"===e.toLowerCase()},meridiem:function(e,a,_){return 11<e?_?"d'o":"D'O":_?"d'a":"D'A"},calendar:{sameDay:"[oxhi \xe0] LT",nextDay:"[dem\xe0 \xe0] LT",nextWeek:"dddd [\xe0] LT",lastDay:"[ieiri \xe0] LT",lastWeek:"[s\xfcr el] dddd [lasteu \xe0] LT",sameElse:"L"},relativeTime:{future:"osprei %s",past:"ja%s",s:A,ss:A,m:A,mm:A,h:A,hh:A,d:A,dd:A,M:A,MM:A,y:A,yy:A},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),e.defineLocale("tzm-latn",{months:"innayr_br\u02e4ayr\u02e4_mar\u02e4s\u02e4_ibrir_mayyw_ywnyw_ywlywz_\u0263w\u0161t_\u0161wtanbir_kt\u02e4wbr\u02e4_nwwanbir_dwjnbir".split("_"),monthsShort:"innayr_br\u02e4ayr\u02e4_mar\u02e4s\u02e4_ibrir_mayyw_ywnyw_ywlywz_\u0263w\u0161t_\u0161wtanbir_kt\u02e4wbr\u02e4_nwwanbir_dwjnbir".split("_"),weekdays:"asamas_aynas_asinas_akras_akwas_asimwas_asi\u1e0dyas".split("_"),weekdaysShort:"asamas_aynas_asinas_akras_akwas_asimwas_asi\u1e0dyas".split("_"),weekdaysMin:"asamas_aynas_asinas_akras_akwas_asimwas_asi\u1e0dyas".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[asdkh g] LT",nextDay:"[aska g] LT",nextWeek:"dddd [g] LT",lastDay:"[assant g] LT",lastWeek:"dddd [g] LT",sameElse:"L"},relativeTime:{future:"dadkh s yan %s",past:"yan %s",s:"imik",ss:"%d imik",m:"minu\u1e0d",mm:"%d minu\u1e0d",h:"sa\u025ba",hh:"%d tassa\u025bin",d:"ass",dd:"%d ossan",M:"ayowr",MM:"%d iyyirn",y:"asgas",yy:"%d isgasn"},week:{dow:6,doy:12}}),e.defineLocale("tzm",{months:"\u2d49\u2d4f\u2d4f\u2d30\u2d62\u2d54_\u2d31\u2d55\u2d30\u2d62\u2d55_\u2d4e\u2d30\u2d55\u2d5a_\u2d49\u2d31\u2d54\u2d49\u2d54_\u2d4e\u2d30\u2d62\u2d62\u2d53_\u2d62\u2d53\u2d4f\u2d62\u2d53_\u2d62\u2d53\u2d4d\u2d62\u2d53\u2d63_\u2d56\u2d53\u2d5b\u2d5c_\u2d5b\u2d53\u2d5c\u2d30\u2d4f\u2d31\u2d49\u2d54_\u2d3d\u2d5f\u2d53\u2d31\u2d55_\u2d4f\u2d53\u2d61\u2d30\u2d4f\u2d31\u2d49\u2d54_\u2d37\u2d53\u2d4a\u2d4f\u2d31\u2d49\u2d54".split("_"),monthsShort:"\u2d49\u2d4f\u2d4f\u2d30\u2d62\u2d54_\u2d31\u2d55\u2d30\u2d62\u2d55_\u2d4e\u2d30\u2d55\u2d5a_\u2d49\u2d31\u2d54\u2d49\u2d54_\u2d4e\u2d30\u2d62\u2d62\u2d53_\u2d62\u2d53\u2d4f\u2d62\u2d53_\u2d62\u2d53\u2d4d\u2d62\u2d53\u2d63_\u2d56\u2d53\u2d5b\u2d5c_\u2d5b\u2d53\u2d5c\u2d30\u2d4f\u2d31\u2d49\u2d54_\u2d3d\u2d5f\u2d53\u2d31\u2d55_\u2d4f\u2d53\u2d61\u2d30\u2d4f\u2d31\u2d49\u2d54_\u2d37\u2d53\u2d4a\u2d4f\u2d31\u2d49\u2d54".split("_"),weekdays:"\u2d30\u2d59\u2d30\u2d4e\u2d30\u2d59_\u2d30\u2d62\u2d4f\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d4f\u2d30\u2d59_\u2d30\u2d3d\u2d54\u2d30\u2d59_\u2d30\u2d3d\u2d61\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d4e\u2d61\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d39\u2d62\u2d30\u2d59".split("_"),weekdaysShort:"\u2d30\u2d59\u2d30\u2d4e\u2d30\u2d59_\u2d30\u2d62\u2d4f\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d4f\u2d30\u2d59_\u2d30\u2d3d\u2d54\u2d30\u2d59_\u2d30\u2d3d\u2d61\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d4e\u2d61\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d39\u2d62\u2d30\u2d59".split("_"),weekdaysMin:"\u2d30\u2d59\u2d30\u2d4e\u2d30\u2d59_\u2d30\u2d62\u2d4f\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d4f\u2d30\u2d59_\u2d30\u2d3d\u2d54\u2d30\u2d59_\u2d30\u2d3d\u2d61\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d4e\u2d61\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d39\u2d62\u2d30\u2d59".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[\u2d30\u2d59\u2d37\u2d45 \u2d34] LT",nextDay:"[\u2d30\u2d59\u2d3d\u2d30 \u2d34] LT",nextWeek:"dddd [\u2d34] LT",lastDay:"[\u2d30\u2d5a\u2d30\u2d4f\u2d5c \u2d34] LT",lastWeek:"dddd [\u2d34] LT",sameElse:"L"},relativeTime:{future:"\u2d37\u2d30\u2d37\u2d45 \u2d59 \u2d62\u2d30\u2d4f %s",past:"\u2d62\u2d30\u2d4f %s",s:"\u2d49\u2d4e\u2d49\u2d3d",ss:"%d \u2d49\u2d4e\u2d49\u2d3d",m:"\u2d4e\u2d49\u2d4f\u2d53\u2d3a",mm:"%d \u2d4e\u2d49\u2d4f\u2d53\u2d3a",h:"\u2d59\u2d30\u2d44\u2d30",hh:"%d \u2d5c\u2d30\u2d59\u2d59\u2d30\u2d44\u2d49\u2d4f",d:"\u2d30\u2d59\u2d59",dd:"%d o\u2d59\u2d59\u2d30\u2d4f",M:"\u2d30\u2d62o\u2d53\u2d54",MM:"%d \u2d49\u2d62\u2d62\u2d49\u2d54\u2d4f",y:"\u2d30\u2d59\u2d33\u2d30\u2d59",yy:"%d \u2d49\u2d59\u2d33\u2d30\u2d59\u2d4f"},week:{dow:6,doy:12}}),e.defineLocale("ug-cn",{months:"\u064a\u0627\u0646\u06cb\u0627\u0631_\u0641\u06d0\u06cb\u0631\u0627\u0644_\u0645\u0627\u0631\u062a_\u0626\u0627\u067e\u0631\u06d0\u0644_\u0645\u0627\u064a_\u0626\u0649\u064a\u06c7\u0646_\u0626\u0649\u064a\u06c7\u0644_\u0626\u0627\u06cb\u063a\u06c7\u0633\u062a_\u0633\u06d0\u0646\u062a\u06d5\u0628\u0649\u0631_\u0626\u06c6\u0643\u062a\u06d5\u0628\u0649\u0631_\u0646\u0648\u064a\u0627\u0628\u0649\u0631_\u062f\u06d0\u0643\u0627\u0628\u0649\u0631".split("_"),monthsShort:"\u064a\u0627\u0646\u06cb\u0627\u0631_\u0641\u06d0\u06cb\u0631\u0627\u0644_\u0645\u0627\u0631\u062a_\u0626\u0627\u067e\u0631\u06d0\u0644_\u0645\u0627\u064a_\u0626\u0649\u064a\u06c7\u0646_\u0626\u0649\u064a\u06c7\u0644_\u0626\u0627\u06cb\u063a\u06c7\u0633\u062a_\u0633\u06d0\u0646\u062a\u06d5\u0628\u0649\u0631_\u0626\u06c6\u0643\u062a\u06d5\u0628\u0649\u0631_\u0646\u0648\u064a\u0627\u0628\u0649\u0631_\u062f\u06d0\u0643\u0627\u0628\u0649\u0631".split("_"),weekdays:"\u064a\u06d5\u0643\u0634\u06d5\u0646\u0628\u06d5_\u062f\u06c8\u0634\u06d5\u0646\u0628\u06d5_\u0633\u06d5\u064a\u0634\u06d5\u0646\u0628\u06d5_\u0686\u0627\u0631\u0634\u06d5\u0646\u0628\u06d5_\u067e\u06d5\u064a\u0634\u06d5\u0646\u0628\u06d5_\u062c\u06c8\u0645\u06d5_\u0634\u06d5\u0646\u0628\u06d5".split("_"),weekdaysShort:"\u064a\u06d5_\u062f\u06c8_\u0633\u06d5_\u0686\u0627_\u067e\u06d5_\u062c\u06c8_\u0634\u06d5".split("_"),weekdaysMin:"\u064a\u06d5_\u062f\u06c8_\u0633\u06d5_\u0686\u0627_\u067e\u06d5_\u062c\u06c8_\u0634\u06d5".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"YYYY-\u064a\u0649\u0644\u0649M-\u0626\u0627\u064a\u0646\u0649\u06adD-\u0643\u06c8\u0646\u0649",LLL:"YYYY-\u064a\u0649\u0644\u0649M-\u0626\u0627\u064a\u0646\u0649\u06adD-\u0643\u06c8\u0646\u0649\u060c HH:mm",LLLL:"dddd\u060c YYYY-\u064a\u0649\u0644\u0649M-\u0626\u0627\u064a\u0646\u0649\u06adD-\u0643\u06c8\u0646\u0649\u060c HH:mm"},meridiemParse:/\u064a\u06d0\u0631\u0649\u0645 \u0643\u06d0\u0686\u06d5|\u0633\u06d5\u06be\u06d5\u0631|\u0686\u06c8\u0634\u062a\u0649\u0646 \u0628\u06c7\u0631\u06c7\u0646|\u0686\u06c8\u0634|\u0686\u06c8\u0634\u062a\u0649\u0646 \u0643\u06d0\u064a\u0649\u0646|\u0643\u06d5\u0686/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u064a\u06d0\u0631\u0649\u0645 \u0643\u06d0\u0686\u06d5"===a||"\u0633\u06d5\u06be\u06d5\u0631"===a||"\u0686\u06c8\u0634\u062a\u0649\u0646 \u0628\u06c7\u0631\u06c7\u0646"===a||"\u0686\u06c8\u0634\u062a\u0649\u0646 \u0643\u06d0\u064a\u0649\u0646"!==a&&"\u0643\u06d5\u0686"!==a&&11<=e?e:e+12},meridiem:function(e,a,_){e=100*e+a;return e<600?"\u064a\u06d0\u0631\u0649\u0645 \u0643\u06d0\u0686\u06d5":e<900?"\u0633\u06d5\u06be\u06d5\u0631":e<1130?"\u0686\u06c8\u0634\u062a\u0649\u0646 \u0628\u06c7\u0631\u06c7\u0646":e<1230?"\u0686\u06c8\u0634":e<1800?"\u0686\u06c8\u0634\u062a\u0649\u0646 \u0643\u06d0\u064a\u0649\u0646":"\u0643\u06d5\u0686"},calendar:{sameDay:"[\u0628\u06c8\u06af\u06c8\u0646 \u0633\u0627\u0626\u06d5\u062a] LT",nextDay:"[\u0626\u06d5\u062a\u06d5 \u0633\u0627\u0626\u06d5\u062a] LT",nextWeek:"[\u0643\u06d0\u0644\u06d5\u0631\u0643\u0649] dddd [\u0633\u0627\u0626\u06d5\u062a] LT",lastDay:"[\u062a\u06c6\u0646\u06c8\u06af\u06c8\u0646] LT",lastWeek:"[\u0626\u0627\u0644\u062f\u0649\u0646\u0642\u0649] dddd [\u0633\u0627\u0626\u06d5\u062a] LT",sameElse:"L"},relativeTime:{future:"%s \u0643\u06d0\u064a\u0649\u0646",past:"%s \u0628\u06c7\u0631\u06c7\u0646",s:"\u0646\u06d5\u0686\u0686\u06d5 \u0633\u06d0\u0643\u0648\u0646\u062a",ss:"%d \u0633\u06d0\u0643\u0648\u0646\u062a",m:"\u0628\u0649\u0631 \u0645\u0649\u0646\u06c7\u062a",mm:"%d \u0645\u0649\u0646\u06c7\u062a",h:"\u0628\u0649\u0631 \u0633\u0627\u0626\u06d5\u062a",hh:"%d \u0633\u0627\u0626\u06d5\u062a",d:"\u0628\u0649\u0631 \u0643\u06c8\u0646",dd:"%d \u0643\u06c8\u0646",M:"\u0628\u0649\u0631 \u0626\u0627\u064a",MM:"%d \u0626\u0627\u064a",y:"\u0628\u0649\u0631 \u064a\u0649\u0644",yy:"%d \u064a\u0649\u0644"},dayOfMonthOrdinalParse:/\d{1,2}(-\u0643\u06c8\u0646\u0649|-\u0626\u0627\u064a|-\u06be\u06d5\u067e\u062a\u06d5)/,ordinal:function(e,a){switch(a){case"d":case"D":case"DDD":return e+"-\u0643\u06c8\u0646\u0649";case"w":case"W":return e+"-\u06be\u06d5\u067e\u062a\u06d5";default:return e}},preparse:function(e){return e.replace(/\u060c/g,",")},postformat:function(e){return e.replace(/,/g,"\u060c")},week:{dow:1,doy:7}}),e.defineLocale("uk",{months:{format:"\u0441\u0456\u0447\u043d\u044f_\u043b\u044e\u0442\u043e\u0433\u043e_\u0431\u0435\u0440\u0435\u0437\u043d\u044f_\u043a\u0432\u0456\u0442\u043d\u044f_\u0442\u0440\u0430\u0432\u043d\u044f_\u0447\u0435\u0440\u0432\u043d\u044f_\u043b\u0438\u043f\u043d\u044f_\u0441\u0435\u0440\u043f\u043d\u044f_\u0432\u0435\u0440\u0435\u0441\u043d\u044f_\u0436\u043e\u0432\u0442\u043d\u044f_\u043b\u0438\u0441\u0442\u043e\u043f\u0430\u0434\u0430_\u0433\u0440\u0443\u0434\u043d\u044f".split("_"),standalone:"\u0441\u0456\u0447\u0435\u043d\u044c_\u043b\u044e\u0442\u0438\u0439_\u0431\u0435\u0440\u0435\u0437\u0435\u043d\u044c_\u043a\u0432\u0456\u0442\u0435\u043d\u044c_\u0442\u0440\u0430\u0432\u0435\u043d\u044c_\u0447\u0435\u0440\u0432\u0435\u043d\u044c_\u043b\u0438\u043f\u0435\u043d\u044c_\u0441\u0435\u0440\u043f\u0435\u043d\u044c_\u0432\u0435\u0440\u0435\u0441\u0435\u043d\u044c_\u0436\u043e\u0432\u0442\u0435\u043d\u044c_\u043b\u0438\u0441\u0442\u043e\u043f\u0430\u0434_\u0433\u0440\u0443\u0434\u0435\u043d\u044c".split("_")},monthsShort:"\u0441\u0456\u0447_\u043b\u044e\u0442_\u0431\u0435\u0440_\u043a\u0432\u0456\u0442_\u0442\u0440\u0430\u0432_\u0447\u0435\u0440\u0432_\u043b\u0438\u043f_\u0441\u0435\u0440\u043f_\u0432\u0435\u0440_\u0436\u043e\u0432\u0442_\u043b\u0438\u0441\u0442_\u0433\u0440\u0443\u0434".split("_"),weekdays:function(e,a){var _={nominative:"\u043d\u0435\u0434\u0456\u043b\u044f_\u043f\u043e\u043d\u0435\u0434\u0456\u043b\u043e\u043a_\u0432\u0456\u0432\u0442\u043e\u0440\u043e\u043a_\u0441\u0435\u0440\u0435\u0434\u0430_\u0447\u0435\u0442\u0432\u0435\u0440_\u043f\u2019\u044f\u0442\u043d\u0438\u0446\u044f_\u0441\u0443\u0431\u043e\u0442\u0430".split("_"),accusative:"\u043d\u0435\u0434\u0456\u043b\u044e_\u043f\u043e\u043d\u0435\u0434\u0456\u043b\u043e\u043a_\u0432\u0456\u0432\u0442\u043e\u0440\u043e\u043a_\u0441\u0435\u0440\u0435\u0434\u0443_\u0447\u0435\u0442\u0432\u0435\u0440_\u043f\u2019\u044f\u0442\u043d\u0438\u0446\u044e_\u0441\u0443\u0431\u043e\u0442\u0443".split("_"),genitive:"\u043d\u0435\u0434\u0456\u043b\u0456_\u043f\u043e\u043d\u0435\u0434\u0456\u043b\u043a\u0430_\u0432\u0456\u0432\u0442\u043e\u0440\u043a\u0430_\u0441\u0435\u0440\u0435\u0434\u0438_\u0447\u0435\u0442\u0432\u0435\u0440\u0433\u0430_\u043f\u2019\u044f\u0442\u043d\u0438\u0446\u0456_\u0441\u0443\u0431\u043e\u0442\u0438".split("_")};return!0===e?_.nominative.slice(1,7).concat(_.nominative.slice(0,1)):e?_[/(\[[\u0412\u0432\u0423\u0443]\]) ?dddd/.test(a)?"accusative":/\[?(?:\u043c\u0438\u043d\u0443\u043b\u043e\u0457|\u043d\u0430\u0441\u0442\u0443\u043f\u043d\u043e\u0457)? ?\] ?dddd/.test(a)?"genitive":"nominative"][e.day()]:_.nominative},weekdaysShort:"\u043d\u0434_\u043f\u043d_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043f\u0442_\u0441\u0431".split("_"),weekdaysMin:"\u043d\u0434_\u043f\u043d_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043f\u0442_\u0441\u0431".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY \u0440.",LLL:"D MMMM YYYY \u0440., HH:mm",LLLL:"dddd, D MMMM YYYY \u0440., HH:mm"},calendar:{sameDay:ia("[\u0421\u044c\u043e\u0433\u043e\u0434\u043d\u0456 "),nextDay:ia("[\u0417\u0430\u0432\u0442\u0440\u0430 "),lastDay:ia("[\u0412\u0447\u043e\u0440\u0430 "),nextWeek:ia("[\u0423] dddd ["),lastWeek:function(){switch(this.day()){case 0:case 3:case 5:case 6:return ia("[\u041c\u0438\u043d\u0443\u043b\u043e\u0457] dddd [").call(this);case 1:case 2:case 4:return ia("[\u041c\u0438\u043d\u0443\u043b\u043e\u0433\u043e] dddd [").call(this)}},sameElse:"L"},relativeTime:{future:"\u0437\u0430 %s",past:"%s \u0442\u043e\u043c\u0443",s:"\u0434\u0435\u043a\u0456\u043b\u044c\u043a\u0430 \u0441\u0435\u043a\u0443\u043d\u0434",ss:O,m:O,mm:O,h:"\u0433\u043e\u0434\u0438\u043d\u0443",hh:O,d:"\u0434\u0435\u043d\u044c",dd:O,M:"\u043c\u0456\u0441\u044f\u0446\u044c",MM:O,y:"\u0440\u0456\u043a",yy:O},meridiemParse:/\u043d\u043e\u0447\u0456|\u0440\u0430\u043d\u043a\u0443|\u0434\u043d\u044f|\u0432\u0435\u0447\u043e\u0440\u0430/,isPM:function(e){return/^(\u0434\u043d\u044f|\u0432\u0435\u0447\u043e\u0440\u0430)$/.test(e)},meridiem:function(e,a,_){return e<4?"\u043d\u043e\u0447\u0456":e<12?"\u0440\u0430\u043d\u043a\u0443":e<17?"\u0434\u043d\u044f":"\u0432\u0435\u0447\u043e\u0440\u0430"},dayOfMonthOrdinalParse:/\d{1,2}-(\u0439|\u0433\u043e)/,ordinal:function(e,a){switch(a){case"M":case"d":case"DDD":case"w":case"W":return e+"-\u0439";case"D":return e+"-\u0433\u043e";default:return e}},week:{dow:1,doy:7}});n=["\u062c\u0646\u0648\u0631\u06cc","\u0641\u0631\u0648\u0631\u06cc","\u0645\u0627\u0631\u0686","\u0627\u067e\u0631\u06cc\u0644","\u0645\u0626\u06cc","\u062c\u0648\u0646","\u062c\u0648\u0644\u0627\u0626\u06cc","\u0627\u06af\u0633\u062a","\u0633\u062a\u0645\u0628\u0631","\u0627\u06a9\u062a\u0648\u0628\u0631","\u0646\u0648\u0645\u0628\u0631","\u062f\u0633\u0645\u0628\u0631"],r=["\u0627\u062a\u0648\u0627\u0631","\u067e\u06cc\u0631","\u0645\u0646\u06af\u0644","\u0628\u062f\u06be","\u062c\u0645\u0639\u0631\u0627\u062a","\u062c\u0645\u0639\u06c1","\u06c1\u0641\u062a\u06c1"];return e.defineLocale("ur",{months:n,monthsShort:n,weekdays:r,weekdaysShort:r,weekdaysMin:r,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd\u060c D MMMM YYYY HH:mm"},meridiemParse:/\u0635\u0628\u062d|\u0634\u0627\u0645/,isPM:function(e){return"\u0634\u0627\u0645"===e},meridiem:function(e,a,_){return e<12?"\u0635\u0628\u062d":"\u0634\u0627\u0645"},calendar:{sameDay:"[\u0622\u062c \u0628\u0648\u0642\u062a] LT",nextDay:"[\u06a9\u0644 \u0628\u0648\u0642\u062a] LT",nextWeek:"dddd [\u0628\u0648\u0642\u062a] LT",lastDay:"[\u06af\u0630\u0634\u062a\u06c1 \u0631\u0648\u0632 \u0628\u0648\u0642\u062a] LT",lastWeek:"[\u06af\u0630\u0634\u062a\u06c1] dddd [\u0628\u0648\u0642\u062a] LT",sameElse:"L"},relativeTime:{future:"%s \u0628\u0639\u062f",past:"%s \u0642\u0628\u0644",s:"\u0686\u0646\u062f \u0633\u06cc\u06a9\u0646\u0688",ss:"%d \u0633\u06cc\u06a9\u0646\u0688",m:"\u0627\u06cc\u06a9 \u0645\u0646\u0679",mm:"%d \u0645\u0646\u0679",h:"\u0627\u06cc\u06a9 \u06af\u06be\u0646\u0679\u06c1",hh:"%d \u06af\u06be\u0646\u0679\u06d2",d:"\u0627\u06cc\u06a9 \u062f\u0646",dd:"%d \u062f\u0646",M:"\u0627\u06cc\u06a9 \u0645\u0627\u06c1",MM:"%d \u0645\u0627\u06c1",y:"\u0627\u06cc\u06a9 \u0633\u0627\u0644",yy:"%d \u0633\u0627\u0644"},preparse:function(e){return e.replace(/\u060c/g,",")},postformat:function(e){return e.replace(/,/g,"\u060c")},week:{dow:1,doy:4}}),e.defineLocale("uz-latn",{months:"Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr".split("_"),monthsShort:"Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek".split("_"),weekdays:"Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba".split("_"),weekdaysShort:"Yak_Dush_Sesh_Chor_Pay_Jum_Shan".split("_"),weekdaysMin:"Ya_Du_Se_Cho_Pa_Ju_Sha".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"D MMMM YYYY, dddd HH:mm"},calendar:{sameDay:"[Bugun soat] LT [da]",nextDay:"[Ertaga] LT [da]",nextWeek:"dddd [kuni soat] LT [da]",lastDay:"[Kecha soat] LT [da]",lastWeek:"[O'tgan] dddd [kuni soat] LT [da]",sameElse:"L"},relativeTime:{future:"Yaqin %s ichida",past:"Bir necha %s oldin",s:"soniya",ss:"%d soniya",m:"bir daqiqa",mm:"%d daqiqa",h:"bir soat",hh:"%d soat",d:"bir kun",dd:"%d kun",M:"bir oy",MM:"%d oy",y:"bir yil",yy:"%d yil"},week:{dow:1,doy:7}}),e.defineLocale("uz",{months:"\u044f\u043d\u0432\u0430\u0440_\u0444\u0435\u0432\u0440\u0430\u043b_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440\u0435\u043b_\u043c\u0430\u0439_\u0438\u044e\u043d_\u0438\u044e\u043b_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043d\u0442\u044f\u0431\u0440_\u043e\u043a\u0442\u044f\u0431\u0440_\u043d\u043e\u044f\u0431\u0440_\u0434\u0435\u043a\u0430\u0431\u0440".split("_"),monthsShort:"\u044f\u043d\u0432_\u0444\u0435\u0432_\u043c\u0430\u0440_\u0430\u043f\u0440_\u043c\u0430\u0439_\u0438\u044e\u043d_\u0438\u044e\u043b_\u0430\u0432\u0433_\u0441\u0435\u043d_\u043e\u043a\u0442_\u043d\u043e\u044f_\u0434\u0435\u043a".split("_"),weekdays:"\u042f\u043a\u0448\u0430\u043d\u0431\u0430_\u0414\u0443\u0448\u0430\u043d\u0431\u0430_\u0421\u0435\u0448\u0430\u043d\u0431\u0430_\u0427\u043e\u0440\u0448\u0430\u043d\u0431\u0430_\u041f\u0430\u0439\u0448\u0430\u043d\u0431\u0430_\u0416\u0443\u043c\u0430_\u0428\u0430\u043d\u0431\u0430".split("_"),weekdaysShort:"\u042f\u043a\u0448_\u0414\u0443\u0448_\u0421\u0435\u0448_\u0427\u043e\u0440_\u041f\u0430\u0439_\u0416\u0443\u043c_\u0428\u0430\u043d".split("_"),weekdaysMin:"\u042f\u043a_\u0414\u0443_\u0421\u0435_\u0427\u043e_\u041f\u0430_\u0416\u0443_\u0428\u0430".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"D MMMM YYYY, dddd HH:mm"},calendar:{sameDay:"[\u0411\u0443\u0433\u0443\u043d \u0441\u043e\u0430\u0442] LT [\u0434\u0430]",nextDay:"[\u042d\u0440\u0442\u0430\u0433\u0430] LT [\u0434\u0430]",nextWeek:"dddd [\u043a\u0443\u043d\u0438 \u0441\u043e\u0430\u0442] LT [\u0434\u0430]",lastDay:"[\u041a\u0435\u0447\u0430 \u0441\u043e\u0430\u0442] LT [\u0434\u0430]",lastWeek:"[\u0423\u0442\u0433\u0430\u043d] dddd [\u043a\u0443\u043d\u0438 \u0441\u043e\u0430\u0442] LT [\u0434\u0430]",sameElse:"L"},relativeTime:{future:"\u042f\u043a\u0438\u043d %s \u0438\u0447\u0438\u0434\u0430",past:"\u0411\u0438\u0440 \u043d\u0435\u0447\u0430 %s \u043e\u043b\u0434\u0438\u043d",s:"\u0444\u0443\u0440\u0441\u0430\u0442",ss:"%d \u0444\u0443\u0440\u0441\u0430\u0442",m:"\u0431\u0438\u0440 \u0434\u0430\u043a\u0438\u043a\u0430",mm:"%d \u0434\u0430\u043a\u0438\u043a\u0430",h:"\u0431\u0438\u0440 \u0441\u043e\u0430\u0442",hh:"%d \u0441\u043e\u0430\u0442",d:"\u0431\u0438\u0440 \u043a\u0443\u043d",dd:"%d \u043a\u0443\u043d",M:"\u0431\u0438\u0440 \u043e\u0439",MM:"%d \u043e\u0439",y:"\u0431\u0438\u0440 \u0439\u0438\u043b",yy:"%d \u0439\u0438\u043b"},week:{dow:1,doy:7}}),e.defineLocale("vi",{months:"th\xe1ng 1_th\xe1ng 2_th\xe1ng 3_th\xe1ng 4_th\xe1ng 5_th\xe1ng 6_th\xe1ng 7_th\xe1ng 8_th\xe1ng 9_th\xe1ng 10_th\xe1ng 11_th\xe1ng 12".split("_"),monthsShort:"Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12".split("_"),monthsParseExact:!0,weekdays:"ch\u1ee7 nh\u1eadt_th\u1ee9 hai_th\u1ee9 ba_th\u1ee9 t\u01b0_th\u1ee9 n\u0103m_th\u1ee9 s\xe1u_th\u1ee9 b\u1ea3y".split("_"),weekdaysShort:"CN_T2_T3_T4_T5_T6_T7".split("_"),weekdaysMin:"CN_T2_T3_T4_T5_T6_T7".split("_"),weekdaysParseExact:!0,meridiemParse:/sa|ch/i,isPM:function(e){return/^ch$/i.test(e)},meridiem:function(e,a,_){return e<12?_?"sa":"SA":_?"ch":"CH"},longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM [n\u0103m] YYYY",LLL:"D MMMM [n\u0103m] YYYY HH:mm",LLLL:"dddd, D MMMM [n\u0103m] YYYY HH:mm",l:"DD/M/YYYY",ll:"D MMM YYYY",lll:"D MMM YYYY HH:mm",llll:"ddd, D MMM YYYY HH:mm"},calendar:{sameDay:"[H\xf4m nay l\xfac] LT",nextDay:"[Ng\xe0y mai l\xfac] LT",nextWeek:"dddd [tu\u1ea7n t\u1edbi l\xfac] LT",lastDay:"[H\xf4m qua l\xfac] LT",lastWeek:"dddd [tu\u1ea7n tr\u01b0\u1edbc l\xfac] LT",sameElse:"L"},relativeTime:{future:"%s t\u1edbi",past:"%s tr\u01b0\u1edbc",s:"v\xe0i gi\xe2y",ss:"%d gi\xe2y",m:"m\u1ed9t ph\xfat",mm:"%d ph\xfat",h:"m\u1ed9t gi\u1edd",hh:"%d gi\u1edd",d:"m\u1ed9t ng\xe0y",dd:"%d ng\xe0y",w:"m\u1ed9t tu\u1ea7n",ww:"%d tu\u1ea7n",M:"m\u1ed9t th\xe1ng",MM:"%d th\xe1ng",y:"m\u1ed9t n\u0103m",yy:"%d n\u0103m"},dayOfMonthOrdinalParse:/\d{1,2}/,ordinal:function(e){return e},week:{dow:1,doy:4}}),e.defineLocale("x-pseudo",{months:"J~\xe1\xf1\xfa\xe1~r\xfd_F~\xe9br\xfa~\xe1r\xfd_~M\xe1rc~h_\xc1p~r\xedl_~M\xe1\xfd_~J\xfa\xf1\xe9~_J\xfal~\xfd_\xc1\xfa~g\xfast~_S\xe9p~t\xe9mb~\xe9r_\xd3~ct\xf3b~\xe9r_\xd1~\xf3v\xe9m~b\xe9r_~D\xe9c\xe9~mb\xe9r".split("_"),monthsShort:"J~\xe1\xf1_~F\xe9b_~M\xe1r_~\xc1pr_~M\xe1\xfd_~J\xfa\xf1_~J\xfal_~\xc1\xfag_~S\xe9p_~\xd3ct_~\xd1\xf3v_~D\xe9c".split("_"),monthsParseExact:!0,weekdays:"S~\xfa\xf1d\xe1~\xfd_M\xf3~\xf1d\xe1\xfd~_T\xfa\xe9~sd\xe1\xfd~_W\xe9d~\xf1\xe9sd~\xe1\xfd_T~h\xfars~d\xe1\xfd_~Fr\xedd~\xe1\xfd_S~\xe1t\xfar~d\xe1\xfd".split("_"),weekdaysShort:"S~\xfa\xf1_~M\xf3\xf1_~T\xfa\xe9_~W\xe9d_~Th\xfa_~Fr\xed_~S\xe1t".split("_"),weekdaysMin:"S~\xfa_M\xf3~_T\xfa_~W\xe9_T~h_Fr~_S\xe1".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[T~\xf3d\xe1~\xfd \xe1t] LT",nextDay:"[T~\xf3m\xf3~rr\xf3~w \xe1t] LT",nextWeek:"dddd [\xe1t] LT",lastDay:"[\xdd~\xe9st~\xe9rd\xe1~\xfd \xe1t] LT",lastWeek:"[L~\xe1st] dddd [\xe1t] LT",sameElse:"L"},relativeTime:{future:"\xed~\xf1 %s",past:"%s \xe1~g\xf3",s:"\xe1 ~f\xe9w ~s\xe9c\xf3~\xf1ds",ss:"%d s~\xe9c\xf3\xf1~ds",m:"\xe1 ~m\xed\xf1~\xfat\xe9",mm:"%d m~\xed\xf1\xfa~t\xe9s",h:"\xe1~\xf1 h\xf3~\xfar",hh:"%d h~\xf3\xfars",d:"\xe1 ~d\xe1\xfd",dd:"%d d~\xe1\xfds",M:"\xe1 ~m\xf3\xf1~th",MM:"%d m~\xf3\xf1t~hs",y:"\xe1 ~\xfd\xe9\xe1r",yy:"%d \xfd~\xe9\xe1rs"},dayOfMonthOrdinalParse:/\d{1,2}(th|st|nd|rd)/,ordinal:function(e){var a=e%10;return e+(1==~~(e%100/10)?"th":1==a?"st":2==a?"nd":3==a?"rd":"th")},week:{dow:1,doy:4}}),e.defineLocale("yo",{months:"S\u1eb9\u0301r\u1eb9\u0301_E\u0300re\u0300le\u0300_\u1eb8r\u1eb9\u0300na\u0300_I\u0300gbe\u0301_E\u0300bibi_O\u0300ku\u0300du_Ag\u1eb9mo_O\u0300gu\u0301n_Owewe_\u1ecc\u0300wa\u0300ra\u0300_Be\u0301lu\u0301_\u1ecc\u0300p\u1eb9\u0300\u0300".split("_"),monthsShort:"S\u1eb9\u0301r_E\u0300rl_\u1eb8rn_I\u0300gb_E\u0300bi_O\u0300ku\u0300_Ag\u1eb9_O\u0300gu\u0301_Owe_\u1ecc\u0300wa\u0300_Be\u0301l_\u1ecc\u0300p\u1eb9\u0300\u0300".split("_"),weekdays:"A\u0300i\u0300ku\u0301_Aje\u0301_I\u0300s\u1eb9\u0301gun_\u1eccj\u1ecd\u0301ru\u0301_\u1eccj\u1ecd\u0301b\u1ecd_\u1eb8ti\u0300_A\u0300ba\u0301m\u1eb9\u0301ta".split("_"),weekdaysShort:"A\u0300i\u0300k_Aje\u0301_I\u0300s\u1eb9\u0301_\u1eccjr_\u1eccjb_\u1eb8ti\u0300_A\u0300ba\u0301".split("_"),weekdaysMin:"A\u0300i\u0300_Aj_I\u0300s_\u1eccr_\u1eccb_\u1eb8t_A\u0300b".split("_"),longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY h:mm A",LLLL:"dddd, D MMMM YYYY h:mm A"},calendar:{sameDay:"[O\u0300ni\u0300 ni] LT",nextDay:"[\u1ecc\u0300la ni] LT",nextWeek:"dddd [\u1eccs\u1eb9\u0300 to\u0301n'b\u1ecd] [ni] LT",lastDay:"[A\u0300na ni] LT",lastWeek:"dddd [\u1eccs\u1eb9\u0300 to\u0301l\u1ecd\u0301] [ni] LT",sameElse:"L"},relativeTime:{future:"ni\u0301 %s",past:"%s k\u1ecdja\u0301",s:"i\u0300s\u1eb9ju\u0301 aaya\u0301 die",ss:"aaya\u0301 %d",m:"i\u0300s\u1eb9ju\u0301 kan",mm:"i\u0300s\u1eb9ju\u0301 %d",h:"wa\u0301kati kan",hh:"wa\u0301kati %d",d:"\u1ecdj\u1ecd\u0301 kan",dd:"\u1ecdj\u1ecd\u0301 %d",M:"osu\u0300 kan",MM:"osu\u0300 %d",y:"\u1ecddu\u0301n kan",yy:"\u1ecddu\u0301n %d"},dayOfMonthOrdinalParse:/\u1ecdj\u1ecd\u0301\s\d{1,2}/,ordinal:"\u1ecdj\u1ecd\u0301 %d",week:{dow:1,doy:4}}),e.defineLocale("zh-cn",{months:"\u4e00\u6708_\u4e8c\u6708_\u4e09\u6708_\u56db\u6708_\u4e94\u6708_\u516d\u6708_\u4e03\u6708_\u516b\u6708_\u4e5d\u6708_\u5341\u6708_\u5341\u4e00\u6708_\u5341\u4e8c\u6708".split("_"),monthsShort:"1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split("_"),weekdays:"\u661f\u671f\u65e5_\u661f\u671f\u4e00_\u661f\u671f\u4e8c_\u661f\u671f\u4e09_\u661f\u671f\u56db_\u661f\u671f\u4e94_\u661f\u671f\u516d".split("_"),weekdaysShort:"\u5468\u65e5_\u5468\u4e00_\u5468\u4e8c_\u5468\u4e09_\u5468\u56db_\u5468\u4e94_\u5468\u516d".split("_"),weekdaysMin:"\u65e5_\u4e00_\u4e8c_\u4e09_\u56db_\u4e94_\u516d".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY/MM/DD",LL:"YYYY\u5e74M\u6708D\u65e5",LLL:"YYYY\u5e74M\u6708D\u65e5Ah\u70b9mm\u5206",LLLL:"YYYY\u5e74M\u6708D\u65e5ddddAh\u70b9mm\u5206",l:"YYYY/M/D",ll:"YYYY\u5e74M\u6708D\u65e5",lll:"YYYY\u5e74M\u6708D\u65e5 HH:mm",llll:"YYYY\u5e74M\u6708D\u65e5dddd HH:mm"},meridiemParse:/\u51cc\u6668|\u65e9\u4e0a|\u4e0a\u5348|\u4e2d\u5348|\u4e0b\u5348|\u665a\u4e0a/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u51cc\u6668"===a||"\u65e9\u4e0a"===a||"\u4e0a\u5348"===a||"\u4e0b\u5348"!==a&&"\u665a\u4e0a"!==a&&11<=e?e:e+12},meridiem:function(e,a,_){e=100*e+a;return e<600?"\u51cc\u6668":e<900?"\u65e9\u4e0a":e<1130?"\u4e0a\u5348":e<1230?"\u4e2d\u5348":e<1800?"\u4e0b\u5348":"\u665a\u4e0a"},calendar:{sameDay:"[\u4eca\u5929]LT",nextDay:"[\u660e\u5929]LT",nextWeek:function(e){return e.week()!==this.week()?"[\u4e0b]dddLT":"[\u672c]dddLT"},lastDay:"[\u6628\u5929]LT",lastWeek:function(e){return this.week()!==e.week()?"[\u4e0a]dddLT":"[\u672c]dddLT"},sameElse:"L"},dayOfMonthOrdinalParse:/\d{1,2}(\u65e5|\u6708|\u5468)/,ordinal:function(e,a){switch(a){case"d":case"D":case"DDD":return e+"\u65e5";case"M":return e+"\u6708";case"w":case"W":return e+"\u5468";default:return e}},relativeTime:{future:"%s\u540e",past:"%s\u524d",s:"\u51e0\u79d2",ss:"%d \u79d2",m:"1 \u5206\u949f",mm:"%d \u5206\u949f",h:"1 \u5c0f\u65f6",hh:"%d \u5c0f\u65f6",d:"1 \u5929",dd:"%d \u5929",w:"1 \u5468",ww:"%d \u5468",M:"1 \u4e2a\u6708",MM:"%d \u4e2a\u6708",y:"1 \u5e74",yy:"%d \u5e74"},week:{dow:1,doy:4}}),e.defineLocale("zh-hk",{months:"\u4e00\u6708_\u4e8c\u6708_\u4e09\u6708_\u56db\u6708_\u4e94\u6708_\u516d\u6708_\u4e03\u6708_\u516b\u6708_\u4e5d\u6708_\u5341\u6708_\u5341\u4e00\u6708_\u5341\u4e8c\u6708".split("_"),monthsShort:"1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split("_"),weekdays:"\u661f\u671f\u65e5_\u661f\u671f\u4e00_\u661f\u671f\u4e8c_\u661f\u671f\u4e09_\u661f\u671f\u56db_\u661f\u671f\u4e94_\u661f\u671f\u516d".split("_"),weekdaysShort:"\u9031\u65e5_\u9031\u4e00_\u9031\u4e8c_\u9031\u4e09_\u9031\u56db_\u9031\u4e94_\u9031\u516d".split("_"),weekdaysMin:"\u65e5_\u4e00_\u4e8c_\u4e09_\u56db_\u4e94_\u516d".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY/MM/DD",LL:"YYYY\u5e74M\u6708D\u65e5",LLL:"YYYY\u5e74M\u6708D\u65e5 HH:mm",LLLL:"YYYY\u5e74M\u6708D\u65e5dddd HH:mm",l:"YYYY/M/D",ll:"YYYY\u5e74M\u6708D\u65e5",lll:"YYYY\u5e74M\u6708D\u65e5 HH:mm",llll:"YYYY\u5e74M\u6708D\u65e5dddd HH:mm"},meridiemParse:/\u51cc\u6668|\u65e9\u4e0a|\u4e0a\u5348|\u4e2d\u5348|\u4e0b\u5348|\u665a\u4e0a/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u51cc\u6668"===a||"\u65e9\u4e0a"===a||"\u4e0a\u5348"===a?e:"\u4e2d\u5348"===a?11<=e?e:e+12:"\u4e0b\u5348"===a||"\u665a\u4e0a"===a?e+12:void 0},meridiem:function(e,a,_){e=100*e+a;return e<600?"\u51cc\u6668":e<900?"\u65e9\u4e0a":e<1200?"\u4e0a\u5348":1200===e?"\u4e2d\u5348":e<1800?"\u4e0b\u5348":"\u665a\u4e0a"},calendar:{sameDay:"[\u4eca\u5929]LT",nextDay:"[\u660e\u5929]LT",nextWeek:"[\u4e0b]ddddLT",lastDay:"[\u6628\u5929]LT",lastWeek:"[\u4e0a]ddddLT",sameElse:"L"},dayOfMonthOrdinalParse:/\d{1,2}(\u65e5|\u6708|\u9031)/,ordinal:function(e,a){switch(a){case"d":case"D":case"DDD":return e+"\u65e5";case"M":return e+"\u6708";case"w":case"W":return e+"\u9031";default:return e}},relativeTime:{future:"%s\u5f8c",past:"%s\u524d",s:"\u5e7e\u79d2",ss:"%d \u79d2",m:"1 \u5206\u9418",mm:"%d \u5206\u9418",h:"1 \u5c0f\u6642",hh:"%d \u5c0f\u6642",d:"1 \u5929",dd:"%d \u5929",M:"1 \u500b\u6708",MM:"%d \u500b\u6708",y:"1 \u5e74",yy:"%d \u5e74"}}),e.defineLocale("zh-mo",{months:"\u4e00\u6708_\u4e8c\u6708_\u4e09\u6708_\u56db\u6708_\u4e94\u6708_\u516d\u6708_\u4e03\u6708_\u516b\u6708_\u4e5d\u6708_\u5341\u6708_\u5341\u4e00\u6708_\u5341\u4e8c\u6708".split("_"),monthsShort:"1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split("_"),weekdays:"\u661f\u671f\u65e5_\u661f\u671f\u4e00_\u661f\u671f\u4e8c_\u661f\u671f\u4e09_\u661f\u671f\u56db_\u661f\u671f\u4e94_\u661f\u671f\u516d".split("_"),weekdaysShort:"\u9031\u65e5_\u9031\u4e00_\u9031\u4e8c_\u9031\u4e09_\u9031\u56db_\u9031\u4e94_\u9031\u516d".split("_"),weekdaysMin:"\u65e5_\u4e00_\u4e8c_\u4e09_\u56db_\u4e94_\u516d".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"YYYY\u5e74M\u6708D\u65e5",LLL:"YYYY\u5e74M\u6708D\u65e5 HH:mm",LLLL:"YYYY\u5e74M\u6708D\u65e5dddd HH:mm",l:"D/M/YYYY",ll:"YYYY\u5e74M\u6708D\u65e5",lll:"YYYY\u5e74M\u6708D\u65e5 HH:mm",llll:"YYYY\u5e74M\u6708D\u65e5dddd HH:mm"},meridiemParse:/\u51cc\u6668|\u65e9\u4e0a|\u4e0a\u5348|\u4e2d\u5348|\u4e0b\u5348|\u665a\u4e0a/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u51cc\u6668"===a||"\u65e9\u4e0a"===a||"\u4e0a\u5348"===a?e:"\u4e2d\u5348"===a?11<=e?e:e+12:"\u4e0b\u5348"===a||"\u665a\u4e0a"===a?e+12:void 0},meridiem:function(e,a,_){e=100*e+a;return e<600?"\u51cc\u6668":e<900?"\u65e9\u4e0a":e<1130?"\u4e0a\u5348":e<1230?"\u4e2d\u5348":e<1800?"\u4e0b\u5348":"\u665a\u4e0a"},calendar:{sameDay:"[\u4eca\u5929] LT",nextDay:"[\u660e\u5929] LT",nextWeek:"[\u4e0b]dddd LT",lastDay:"[\u6628\u5929] LT",lastWeek:"[\u4e0a]dddd LT",sameElse:"L"},dayOfMonthOrdinalParse:/\d{1,2}(\u65e5|\u6708|\u9031)/,ordinal:function(e,a){switch(a){case"d":case"D":case"DDD":return e+"\u65e5";case"M":return e+"\u6708";case"w":case"W":return e+"\u9031";default:return e}},relativeTime:{future:"%s\u5167",past:"%s\u524d",s:"\u5e7e\u79d2",ss:"%d \u79d2",m:"1 \u5206\u9418",mm:"%d \u5206\u9418",h:"1 \u5c0f\u6642",hh:"%d \u5c0f\u6642",d:"1 \u5929",dd:"%d \u5929",M:"1 \u500b\u6708",MM:"%d \u500b\u6708",y:"1 \u5e74",yy:"%d \u5e74"}}),e.defineLocale("zh-tw",{months:"\u4e00\u6708_\u4e8c\u6708_\u4e09\u6708_\u56db\u6708_\u4e94\u6708_\u516d\u6708_\u4e03\u6708_\u516b\u6708_\u4e5d\u6708_\u5341\u6708_\u5341\u4e00\u6708_\u5341\u4e8c\u6708".split("_"),monthsShort:"1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split("_"),weekdays:"\u661f\u671f\u65e5_\u661f\u671f\u4e00_\u661f\u671f\u4e8c_\u661f\u671f\u4e09_\u661f\u671f\u56db_\u661f\u671f\u4e94_\u661f\u671f\u516d".split("_"),weekdaysShort:"\u9031\u65e5_\u9031\u4e00_\u9031\u4e8c_\u9031\u4e09_\u9031\u56db_\u9031\u4e94_\u9031\u516d".split("_"),weekdaysMin:"\u65e5_\u4e00_\u4e8c_\u4e09_\u56db_\u4e94_\u516d".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY/MM/DD",LL:"YYYY\u5e74M\u6708D\u65e5",LLL:"YYYY\u5e74M\u6708D\u65e5 HH:mm",LLLL:"YYYY\u5e74M\u6708D\u65e5dddd HH:mm",l:"YYYY/M/D",ll:"YYYY\u5e74M\u6708D\u65e5",lll:"YYYY\u5e74M\u6708D\u65e5 HH:mm",llll:"YYYY\u5e74M\u6708D\u65e5dddd HH:mm"},meridiemParse:/\u51cc\u6668|\u65e9\u4e0a|\u4e0a\u5348|\u4e2d\u5348|\u4e0b\u5348|\u665a\u4e0a/,meridiemHour:function(e,a){return 12===e&&(e=0),"\u51cc\u6668"===a||"\u65e9\u4e0a"===a||"\u4e0a\u5348"===a?e:"\u4e2d\u5348"===a?11<=e?e:e+12:"\u4e0b\u5348"===a||"\u665a\u4e0a"===a?e+12:void 0},meridiem:function(e,a,_){e=100*e+a;return e<600?"\u51cc\u6668":e<900?"\u65e9\u4e0a":e<1130?"\u4e0a\u5348":e<1230?"\u4e2d\u5348":e<1800?"\u4e0b\u5348":"\u665a\u4e0a"},calendar:{sameDay:"[\u4eca\u5929] LT",nextDay:"[\u660e\u5929] LT",nextWeek:"[\u4e0b]dddd LT",lastDay:"[\u6628\u5929] LT",lastWeek:"[\u4e0a]dddd LT",sameElse:"L"},dayOfMonthOrdinalParse:/\d{1,2}(\u65e5|\u6708|\u9031)/,ordinal:function(e,a){switch(a){case"d":case"D":case"DDD":return e+"\u65e5";case"M":return e+"\u6708";case"w":case"W":return e+"\u9031";default:return e}},relativeTime:{future:"%s\u5f8c",past:"%s\u524d",s:"\u5e7e\u79d2",ss:"%d \u79d2",m:"1 \u5206\u9418",mm:"%d \u5206\u9418",h:"1 \u5c0f\u6642",hh:"%d \u5c0f\u6642",d:"1 \u5929",dd:"%d \u5929",M:"1 \u500b\u6708",MM:"%d \u500b\u6708",y:"1 \u5e74",yy:"%d \u5e74"}}),e.locale("en"),e});

},{"../moment":"moment"}],1167:[function(require,module,exports){
/* globals define, angular */
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    define(['quill'], factory)
  } else if (typeof module !== 'undefined' && typeof exports === 'object') {
    module.exports = factory(require('quill'))
  } else {
    root.Requester = factory(root.Quill)
  }
}(this, function (Quill) {
  'use strict'

  var app
  // declare ngQuill module
  app = angular.module('ngQuill', ['ngSanitize'])

  app.provider('ngQuillConfig', function () {
    var config = {
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
          ['blockquote', 'code-block'],

          [{ 'header': 1 }, { 'header': 2 }],               // custom button values
          [{ 'list': 'ordered' }, { 'list': 'bullet' }],
          [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
          [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
          [{ 'direction': 'rtl' }],                         // text direction

          [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
          [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

          [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
          [{ 'font': [] }],
          [{ 'align': [] }],

          ['clean'],                                         // remove formatting button

          ['link', 'image', 'video']                         // link and image, video
        ]
      },
      bounds: document.body,
      debug: 'warn',
      theme: 'snow',
      scrollingContainer: null,
      placeholder: 'Insert text here ...',
      readOnly: false,
      trackChanges: 'user',
      preserveWhitespace: false
    }

    this.set = function (customConf) {
      customConf = customConf || {}

      if (customConf.modules) {
        config.modules = customConf.modules
      }
      if (customConf.theme) {
        config.theme = customConf.theme
      }
      if (customConf.placeholder !== null && customConf.placeholder !== undefined) {
        config.placeholder = customConf.placeholder.trim()
      }
      if (customConf.readOnly) {
        config.readOnly = customConf.readOnly
      }
      if (customConf.formats) {
        config.formats = customConf.formats
      }
      if (customConf.bounds) {
        config.bounds = customConf.bounds
      }
      if (customConf.scrollingContainer) {
        config.scrollingContainer = customConf.scrollingContainer
      }
      if (customConf.debug || customConf.debug === false) {
        config.debug = customConf.debug
      }
      if (customConf.trackChanges && ['all', 'user'].indexOf(customConf.trackChanges) > -1) {
        config.trackChanges = customConf.trackChanges
      }
      if (customConf.preserveWhitespace) {
        config.preserveWhitespace = true
      }
    }

    this.$get = function () {
      return config
    }
  })

  app.component('ngQuillEditor', {
    bindings: {
      'modules': '<modules',
      'theme': '@?',
      'readOnly': '<?',
      'format': '@?',
      'debug': '@?',
      'formats': '<?',
      'placeholder': '<?',
      'bounds': '<?',
      'scrollingContainer': '<?',
      'strict': '<?',
      'onEditorCreated': '&?',
      'onContentChanged': '&?',
      'onBlur': '&?',
      'onFocus': '&?',
      'onSelectionChanged': '&?',
      'ngModel': '<',
      'maxLength': '<',
      'minLength': '<',
      'customOptions': '<?',
      'styles': '<?',
      'sanitize': '<?',
      'customToolbarPosition': '@?',
      'trackChanges': '@?',
      'preserveWhitespace': '<?',
    },
    require: {
      ngModelCtrl: 'ngModel'
    },
    transclude: {
      'toolbar': '?ngQuillToolbar'
    },
    template: '<div class="ng-hide" ng-show="$ctrl.ready"><ng-transclude ng-transclude-slot="toolbar"></ng-transclude></div>',
    controller: ['$scope', '$element', '$sanitize', '$timeout', '$transclude', 'ngQuillConfig', function ($scope, $element, $sanitize, $timeout, $transclude, ngQuillConfig) {
      var config = {}
      var content
      var editorElem
      var format = 'html'
      var editorChanged = false
      var editor
      var placeholder = ngQuillConfig.placeholder
      var textChangeEvent
      var selectionChangeEvent

      this.setter = function (value) {
        if (format === 'html') {
          return editor.clipboard.convert(this.sanitize ? $sanitize(value) : value)
        } else if (this.format === 'json') {
          try {
            return JSON.parse(value)
          } catch (e) {
            return [{ insert: value }]
          }
        }

        return value
      }

      this.validate = function (text) {
        var textLength = text.trim().length

        if (this.maxLength) {
          if (textLength > this.maxLength) {
            this.ngModelCtrl.$setValidity('maxlength', false)
          } else {
            this.ngModelCtrl.$setValidity('maxlength', true)
          }
        }

        if (this.minLength > 0) {
          if (textLength < this.minLength && textLength) {
            this.ngModelCtrl.$setValidity('minlength', false)
          } else {
            this.ngModelCtrl.$setValidity('minlength', true)
          }
        }
      }

      this.$onChanges = function (changes) {
        if (changes.ngModel) {
          content = changes.ngModel.currentValue

          if (editor) {
            if (!editorChanged) {
              if (content) {
                if (changes.ngModel.currentValue !== changes.ngModel.previousValue) {
                  if (this.format === 'text') {
                    editor.setText(content)
                  } else {
                    editor.setContents(
                      this.setter(content)
                    )
                  }
                }
              } else {
                editor.setText('')
              }
            }
            editorChanged = false
          }
        }

        if (editor && changes.readOnly) {
          editor.enable(!changes.readOnly.currentValue)
        }

        if (editor && changes.placeholder) {
          editor.root.dataset.placeholder = changes.placeholder.currentValue
        }

        if (editor && editorElem && changes.styles) {
          var currentStyling = changes.styles.currentValue
          var previousStyling = changes.styles.previousValue

          if (previousStyling) {
            for (var key in previousStyling) {
              editorElem.style[key] = ''
            }
          }
          if (currentStyling) {
            for (var activeStyle in currentStyling) {
              if (currentStyling.hasOwnProperty(activeStyle)) {
                editorElem.style[activeStyle] = currentStyling[activeStyle]
              }
            }
          }
        }
      }

      this.$onInit = function () {
        if (this.placeholder !== null && this.placeholder !== undefined) {
          placeholder = this.placeholder.trim()
        }

        if (this.format && ['object', 'html', 'text', 'json'].indexOf(this.format) > -1) {
          format = this.format
        }

        config = {
          theme: this.theme || ngQuillConfig.theme,
          readOnly: this.readOnly || ngQuillConfig.readOnly,
          modules: this.modules || ngQuillConfig.modules,
          formats: this.formats || ngQuillConfig.formats,
          placeholder: placeholder,
          bounds: this.bounds || ngQuillConfig.bounds,
          strict: this.strict,
          scrollingContainer: this.scrollingContainer || ngQuillConfig.scrollingContainer,
          debug: this.debug || this.debug === false ? this.debug : ngQuillConfig.debug
        }
      }

      this.$postLink = function () {
        // create quill instance after dom is rendered
        $timeout(function () {
          this._initEditor()
        }.bind(this), 0)
      }

      this.$onDestroy = function () {
        editor = null

        if (textChangeEvent) {
          textChangeEvent.removeListener('text-change')
        }
        if (selectionChangeEvent) {
          selectionChangeEvent.removeListener('selection-change')
        }
      }

      this._initEditor = function () {
        var $editorElem = this.preserveWhitespace ? angular.element('<pre></pre>') : angular.element('<div></div>')
        var container = $element.children()

        editorElem = $editorElem[0]

        if (config.bounds === 'self') {
          config.bounds = editorElem
        }

        // set toolbar to custom one
        if ($transclude.isSlotFilled('toolbar')) {
          config.modules.toolbar = container.find('ng-quill-toolbar').children()[0]
        }

        if (this.styles) {
          for (var activeStyle in this.styles) {
            if (this.styles.hasOwnProperty(activeStyle)) {
              editorElem.style[activeStyle] = this.styles[activeStyle]
            }
          }
        }

        if (!this.customToolbarPosition || this.customToolbarPosition === 'top') {
          container.append($editorElem)
        } else {
          container.prepend($editorElem)
        }

        if (this.customOptions) {
          this.customOptions.forEach(function (customOption) {
            var newCustomOption = Quill.import(customOption.import)
            newCustomOption.whitelist = customOption.whitelist
            if (customOption.toRegister) {
              newCustomOption[customOption.toRegister.key] = customOption.toRegister.value
            }
            Quill.register(newCustomOption, true)
          })
        }

        editor = new Quill(editorElem, config)

        this.ready = true

        // mark model as touched if editor lost focus
        selectionChangeEvent = editor.on('selection-change', function (range, oldRange, source) {
          if (range === null && this.onBlur) {
            this.onBlur({
              editor: editor,
              source: source
            })
          } else if (oldRange === null && this.onFocus) {
            this.onFocus({
              editor: editor,
              source: source
            })
          }

          if (this.onSelectionChanged) {
            this.onSelectionChanged({
              editor: editor,
              oldRange: oldRange,
              range: range,
              source: source
            })
          }

          if (range) {
            return
          }
          $scope.$applyAsync(function () {
            this.ngModelCtrl.$setTouched()
          }.bind(this))
        }.bind(this))

        // update model if text changes
        textChangeEvent = editor.on('text-change', function (delta, oldDelta, source) {
          var html = editorElem.querySelector('.ql-editor').innerHTML
          var text = editor.getText()
          var content = editor.getContents()

          var emptyModelTag = ['<' + editor.root.firstChild.localName + '>', '</' + editor.root.firstChild.localName + '>']

          if (html === emptyModelTag[0] + '<br>' + emptyModelTag[1]) {
            html = null
          }
          this.validate(text)

          $scope.$applyAsync(function () {
            var trackChanges = this.trackChanges || ngQuillConfig.trackChanges
            if (source === 'user' || trackChanges && trackChanges === 'all') {
              editorChanged = true
              if (format === 'text') {
                // if nothing changed $ngOnChanges is not called again
                // But we have to reset editorChanged flag
                if (text === this.ngModelCtrl.$viewValue) {
                  editorChanged = false
                } else {
                  this.ngModelCtrl.$setViewValue(text)
                }
              } else if (format === 'object') {
                this.ngModelCtrl.$setViewValue(content)
              } else if (this.format === 'json') {
                try {
                  this.ngModelCtrl.$setViewValue(JSON.stringify(content))
                } catch (e) {
                  this.ngModelCtrl.$setViewValue(text)
                }
              } else {
                this.ngModelCtrl.$setViewValue(html)
              }
            }

            if (this.onContentChanged) {
              this.onContentChanged({
                editor: editor,
                html: html,
                text: text,
                content: content,
                delta: delta,
                oldDelta: oldDelta,
                source: source
              })
            }
          }.bind(this))
        }.bind(this))

        // set initial content
        if (content) {
          if (format === 'text') {
            editor.setText(content, 'silent')
          } else if (format === 'object') {
            editor.setContents(content, 'silent')
          } else if (format === 'json') {
            try {
              editor.setContents(JSON.parse(content), 'silent')
            } catch (e) {
              editor.setText(content, 'silent')
            }
          } else {
            editor.setContents(editor.clipboard.convert(this.sanitize ? $sanitize(content) : content, 'silent'))
          }

          editor.history.clear()
        }
        this.validate(editor.getText())

        // provide event to get informed when editor is created -> pass editor object.
        if (this.onEditorCreated) {
          this.onEditorCreated({editor: editor})
        }
      }
    }]
  })

  return app.name
}))
;

},{"quill":"quill"}],1168:[function(require,module,exports){
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

'use strict';
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

},{}],1169:[function(require,module,exports){
/**
 * oclazyload - Load modules on demand (lazy load) with angularJS
 * @version v1.0.10
 * @link https://github.com/ocombe/ocLazyLoad
 * @license MIT
 * @author Olivier Combe <olivier.combe@gmail.com>
 */
(function (angular, window) {
    'use strict';

    var regModules = ['ng', 'oc.lazyLoad'],
        regInvokes = {},
        regConfigs = [],
        modulesToLoad = [],
        // modules to load from angular.module or other sources
    realModules = [],
        // real modules called from angular.module
    recordDeclarations = [],
        broadcast = angular.noop,
        runBlocks = {},
        justLoaded = [];

    var ocLazyLoad = angular.module('oc.lazyLoad', ['ng']);

    ocLazyLoad.provider('$ocLazyLoad', ["$controllerProvider", "$provide", "$compileProvider", "$filterProvider", "$injector", "$animateProvider", function ($controllerProvider, $provide, $compileProvider, $filterProvider, $injector, $animateProvider) {
        var modules = {},
            providers = {
            $controllerProvider: $controllerProvider,
            $compileProvider: $compileProvider,
            $filterProvider: $filterProvider,
            $provide: $provide, // other things (constant, decorator, provider, factory, service)
            $injector: $injector,
            $animateProvider: $animateProvider
        },
            debug = false,
            events = false,
            moduleCache = [],
            modulePromises = {};

        moduleCache.push = function (value) {
            if (this.indexOf(value) === -1) {
                Array.prototype.push.apply(this, arguments);
            }
        };

        this.config = function (config) {
            // If we want to define modules configs
            if (angular.isDefined(config.modules)) {
                if (angular.isArray(config.modules)) {
                    angular.forEach(config.modules, function (moduleConfig) {
                        modules[moduleConfig.name] = moduleConfig;
                    });
                } else {
                    modules[config.modules.name] = config.modules;
                }
            }

            if (angular.isDefined(config.debug)) {
                debug = config.debug;
            }

            if (angular.isDefined(config.events)) {
                events = config.events;
            }
        };

        /**
         * Get the list of existing registered modules
         * @param element
         */
        this._init = function _init(element) {
            // this is probably useless now because we override angular.bootstrap
            if (modulesToLoad.length === 0) {
                var elements = [element],
                    names = ['ng:app', 'ng-app', 'x-ng-app', 'data-ng-app'],
                    NG_APP_CLASS_REGEXP = /\sng[:\-]app(:\s*([\w\d_]+);?)?\s/,
                    append = function append(elm) {
                    return elm && elements.push(elm);
                };

                angular.forEach(names, function (name) {
                    names[name] = true;
                    append(document.getElementById(name));
                    name = name.replace(':', '\\:');
                    if (typeof element[0] !== 'undefined' && element[0].querySelectorAll) {
                        angular.forEach(element[0].querySelectorAll('.' + name), append);
                        angular.forEach(element[0].querySelectorAll('.' + name + '\\:'), append);
                        angular.forEach(element[0].querySelectorAll('[' + name + ']'), append);
                    }
                });

                angular.forEach(elements, function (elm) {
                    if (modulesToLoad.length === 0) {
                        var className = ' ' + element.className + ' ';
                        var match = NG_APP_CLASS_REGEXP.exec(className);
                        if (match) {
                            modulesToLoad.push((match[2] || '').replace(/\s+/g, ','));
                        } else {
                            angular.forEach(elm.attributes, function (attr) {
                                if (modulesToLoad.length === 0 && names[attr.name]) {
                                    modulesToLoad.push(attr.value);
                                }
                            });
                        }
                    }
                });
            }

            if (modulesToLoad.length === 0 && !((window.jasmine || window.mocha) && angular.isDefined(angular.mock))) {
                console.error('No module found during bootstrap, unable to init ocLazyLoad. You should always use the ng-app directive or angular.boostrap when you use ocLazyLoad.');
            }

            var addReg = function addReg(moduleName) {
                if (regModules.indexOf(moduleName) === -1) {
                    // register existing modules
                    regModules.push(moduleName);
                    var mainModule = angular.module(moduleName);

                    // register existing components (directives, services, ...)
                    _invokeQueue(null, mainModule._invokeQueue, moduleName);
                    _invokeQueue(null, mainModule._configBlocks, moduleName); // angular 1.3+

                    angular.forEach(mainModule.requires, addReg);
                }
            };

            angular.forEach(modulesToLoad, function (moduleName) {
                addReg(moduleName);
            });

            modulesToLoad = []; // reset for next bootstrap
            recordDeclarations.pop(); // wait for the next lazy load
        };

        /**
         * Like JSON.stringify but that doesn't throw on circular references
         * @param obj
         */
        var stringify = function stringify(obj) {
            try {
                return JSON.stringify(obj);
            } catch (e) {
                var cache = [];
                return JSON.stringify(obj, function (key, value) {
                    if (angular.isObject(value) && value !== null) {
                        if (cache.indexOf(value) !== -1) {
                            // Circular reference found, discard key
                            return;
                        }
                        // Store value in our collection
                        cache.push(value);
                    }
                    return value;
                });
            }
        };

        var hashCode = function hashCode(str) {
            var hash = 0,
                i,
                chr,
                len;
            if (str.length == 0) {
                return hash;
            }
            for (i = 0, len = str.length; i < len; i++) {
                chr = str.charCodeAt(i);
                hash = (hash << 5) - hash + chr;
                hash |= 0; // Convert to 32bit integer
            }
            return hash;
        };

        function _register(providers, registerModules, params) {
            if (registerModules) {
                var k,
                    moduleName,
                    moduleFn,
                    tempRunBlocks = [];
                for (k = registerModules.length - 1; k >= 0; k--) {
                    moduleName = registerModules[k];
                    if (!angular.isString(moduleName)) {
                        moduleName = getModuleName(moduleName);
                    }
                    if (!moduleName || justLoaded.indexOf(moduleName) !== -1 || modules[moduleName] && realModules.indexOf(moduleName) === -1) {
                        continue;
                    }
                    // new if not registered
                    var newModule = regModules.indexOf(moduleName) === -1;
                    moduleFn = ngModuleFct(moduleName);
                    if (newModule) {
                        regModules.push(moduleName);
                        _register(providers, moduleFn.requires, params);
                    }
                    if (moduleFn._runBlocks.length > 0) {
                        // new run blocks detected! Replace the old ones (if existing)
                        runBlocks[moduleName] = [];
                        while (moduleFn._runBlocks.length > 0) {
                            runBlocks[moduleName].push(moduleFn._runBlocks.shift());
                        }
                    }
                    if (angular.isDefined(runBlocks[moduleName]) && (newModule || params.rerun)) {
                        tempRunBlocks = tempRunBlocks.concat(runBlocks[moduleName]);
                    }
                    _invokeQueue(providers, moduleFn._invokeQueue, moduleName, params.reconfig);
                    _invokeQueue(providers, moduleFn._configBlocks, moduleName, params.reconfig); // angular 1.3+
                    broadcast(newModule ? 'ocLazyLoad.moduleLoaded' : 'ocLazyLoad.moduleReloaded', moduleName);
                    registerModules.pop();
                    justLoaded.push(moduleName);
                }
                // execute the run blocks at the end
                var instanceInjector = providers.getInstanceInjector();
                angular.forEach(tempRunBlocks, function (fn) {
                    instanceInjector.invoke(fn);
                });
            }
        }

        function _registerInvokeList(args, moduleName) {
            var invokeList = args[2][0],
                type = args[1],
                newInvoke = false;
            if (angular.isUndefined(regInvokes[moduleName])) {
                regInvokes[moduleName] = {};
            }
            if (angular.isUndefined(regInvokes[moduleName][type])) {
                regInvokes[moduleName][type] = {};
            }
            var onInvoke = function onInvoke(invokeName, invoke) {
                if (!regInvokes[moduleName][type].hasOwnProperty(invokeName)) {
                    regInvokes[moduleName][type][invokeName] = [];
                }
                if (checkHashes(invoke, regInvokes[moduleName][type][invokeName])) {
                    newInvoke = true;
                    regInvokes[moduleName][type][invokeName].push(invoke);
                    broadcast('ocLazyLoad.componentLoaded', [moduleName, type, invokeName]);
                }
            };

            function checkHashes(potentialNew, invokes) {
                var isNew = true,
                    newHash;
                if (invokes.length) {
                    newHash = signature(potentialNew);
                    angular.forEach(invokes, function (invoke) {
                        isNew = isNew && signature(invoke) !== newHash;
                    });
                }
                return isNew;
            }

            function signature(data) {
                if (angular.isArray(data)) {
                    // arrays are objects, we need to test for it first
                    return hashCode(data.toString());
                } else if (angular.isObject(data)) {
                    // constants & values for example
                    return hashCode(stringify(data));
                } else {
                    if (angular.isDefined(data) && data !== null) {
                        return hashCode(data.toString());
                    } else {
                        // null & undefined constants
                        return data;
                    }
                }
            }

            if (angular.isString(invokeList)) {
                onInvoke(invokeList, args[2][1]);
            } else if (angular.isObject(invokeList)) {
                angular.forEach(invokeList, function (invoke, key) {
                    if (angular.isString(invoke)) {
                        // decorators for example
                        onInvoke(invoke, invokeList[1]);
                    } else {
                        // components registered as object lists {"componentName": function() {}}
                        onInvoke(key, invoke);
                    }
                });
            } else {
                return false;
            }
            return newInvoke;
        }

        function _invokeQueue(providers, queue, moduleName, reconfig) {
            if (!queue) {
                return;
            }

            var i, len, args, provider;
            for (i = 0, len = queue.length; i < len; i++) {
                args = queue[i];
                if (angular.isArray(args)) {
                    if (providers !== null) {
                        if (providers.hasOwnProperty(args[0])) {
                            provider = providers[args[0]];
                        } else {
                            throw new Error('unsupported provider ' + args[0]);
                        }
                    }
                    var isNew = _registerInvokeList(args, moduleName);
                    if (args[1] !== 'invoke') {
                        if (isNew && angular.isDefined(provider)) {
                            provider[args[1]].apply(provider, args[2]);
                        }
                    } else {
                        // config block
                        var callInvoke = function callInvoke(fct) {
                            var invoked = regConfigs.indexOf(moduleName + '-' + fct);
                            if (invoked === -1 || reconfig) {
                                if (invoked === -1) {
                                    regConfigs.push(moduleName + '-' + fct);
                                }
                                if (angular.isDefined(provider)) {
                                    provider[args[1]].apply(provider, args[2]);
                                }
                            }
                        };
                        if (angular.isFunction(args[2][0])) {
                            callInvoke(args[2][0]);
                        } else if (angular.isArray(args[2][0])) {
                            for (var j = 0, jlen = args[2][0].length; j < jlen; j++) {
                                if (angular.isFunction(args[2][0][j])) {
                                    callInvoke(args[2][0][j]);
                                }
                            }
                        }
                    }
                }
            }
        }

        function getModuleName(module) {
            var moduleName = null;
            if (angular.isString(module)) {
                moduleName = module;
            } else if (angular.isObject(module) && module.hasOwnProperty('name') && angular.isString(module.name)) {
                moduleName = module.name;
            }
            return moduleName;
        }

        function moduleExists(moduleName) {
            if (!angular.isString(moduleName)) {
                return false;
            }
            try {
                return ngModuleFct(moduleName);
            } catch (e) {
                if (/No module/.test(e) || e.message.indexOf('$injector:nomod') > -1) {
                    return false;
                }
            }
        }

        this.$get = ["$log", "$rootElement", "$rootScope", "$cacheFactory", "$q", function ($log, $rootElement, $rootScope, $cacheFactory, $q) {
            var instanceInjector,
                filesCache = $cacheFactory('ocLazyLoad');

            if (!debug) {
                $log = {};
                $log['error'] = angular.noop;
                $log['warn'] = angular.noop;
                $log['info'] = angular.noop;
            }

            // Make this lazy because when $get() is called the instance injector hasn't been assigned to the rootElement yet
            providers.getInstanceInjector = function () {
                return instanceInjector ? instanceInjector : instanceInjector = $rootElement.data('$injector') || angular.injector();
            };

            broadcast = function broadcast(eventName, params) {
                if (events) {
                    $rootScope.$broadcast(eventName, params);
                }
                if (debug) {
                    $log.info(eventName, params);
                }
            };

            function reject(e) {
                var deferred = $q.defer();
                $log.error(e.message);
                deferred.reject(e);
                return deferred.promise;
            }

            return {
                _broadcast: broadcast,

                _$log: $log,

                /**
                 * Returns the files cache used by the loaders to store the files currently loading
                 * @returns {*}
                 */
                _getFilesCache: function getFilesCache() {
                    return filesCache;
                },

                /**
                 * Let the service know that it should monitor angular.module because files are loading
                 * @param watch boolean
                 */
                toggleWatch: function toggleWatch(watch) {
                    if (watch) {
                        recordDeclarations.push(true);
                    } else {
                        recordDeclarations.pop();
                    }
                },

                /**
                 * Let you get a module config object
                 * @param moduleName String the name of the module
                 * @returns {*}
                 */
                getModuleConfig: function getModuleConfig(moduleName) {
                    if (!angular.isString(moduleName)) {
                        throw new Error('You need to give the name of the module to get');
                    }
                    if (!modules[moduleName]) {
                        return null;
                    }
                    return angular.copy(modules[moduleName]);
                },

                /**
                 * Let you define a module config object
                 * @param moduleConfig Object the module config object
                 * @returns {*}
                 */
                setModuleConfig: function setModuleConfig(moduleConfig) {
                    if (!angular.isObject(moduleConfig)) {
                        throw new Error('You need to give the module config object to set');
                    }
                    modules[moduleConfig.name] = moduleConfig;
                    return moduleConfig;
                },

                /**
                 * Returns the list of loaded modules
                 * @returns {string[]}
                 */
                getModules: function getModules() {
                    return regModules;
                },

                /**
                 * Let you check if a module has been loaded into Angular or not
                 * @param modulesNames String/Object a module name, or a list of module names
                 * @returns {boolean}
                 */
                isLoaded: function isLoaded(modulesNames) {
                    var moduleLoaded = function moduleLoaded(module) {
                        var isLoaded = regModules.indexOf(module) > -1;
                        if (!isLoaded) {
                            isLoaded = !!moduleExists(module);
                        }
                        return isLoaded;
                    };
                    if (angular.isString(modulesNames)) {
                        modulesNames = [modulesNames];
                    }
                    if (angular.isArray(modulesNames)) {
                        var i, len;
                        for (i = 0, len = modulesNames.length; i < len; i++) {
                            if (!moduleLoaded(modulesNames[i])) {
                                return false;
                            }
                        }
                        return true;
                    } else {
                        throw new Error('You need to define the module(s) name(s)');
                    }
                },

                /**
                 * Given a module, return its name
                 * @param module
                 * @returns {String}
                 */
                _getModuleName: getModuleName,

                /**
                 * Returns a module if it exists
                 * @param moduleName
                 * @returns {module}
                 */
                _getModule: function getModule(moduleName) {
                    try {
                        return ngModuleFct(moduleName);
                    } catch (e) {
                        // this error message really suxx
                        if (/No module/.test(e) || e.message.indexOf('$injector:nomod') > -1) {
                            e.message = 'The module "' + stringify(moduleName) + '" that you are trying to load does not exist. ' + e.message;
                        }
                        throw e;
                    }
                },

                /**
                 * Check if a module exists and returns it if it does
                 * @param moduleName
                 * @returns {boolean}
                 */
                moduleExists: moduleExists,

                /**
                 * Load the dependencies, and might try to load new files depending on the config
                 * @param moduleName (String or Array of Strings)
                 * @param localParams
                 * @returns {*}
                 * @private
                 */
                _loadDependencies: function _loadDependencies(moduleName, localParams) {
                    var loadedModule,
                        requires,
                        diff,
                        promisesList = [],
                        self = this;

                    moduleName = self._getModuleName(moduleName);

                    if (moduleName === null) {
                        return $q.when();
                    } else {
                        try {
                            loadedModule = self._getModule(moduleName);
                        } catch (e) {
                            return reject(e);
                        }
                        // get unloaded requires
                        requires = self.getRequires(loadedModule);
                    }

                    angular.forEach(requires, function (requireEntry) {
                        // If no configuration is provided, try and find one from a previous load.
                        // If there isn't one, bail and let the normal flow run
                        if (angular.isString(requireEntry)) {
                            var config = self.getModuleConfig(requireEntry);
                            if (config === null) {
                                moduleCache.push(requireEntry); // We don't know about this module, but something else might, so push it anyway.
                                return;
                            }
                            requireEntry = config;
                            // ignore the name because it's probably not a real module name
                            config.name = undefined;
                        }

                        // Check if this dependency has been loaded previously
                        if (self.moduleExists(requireEntry.name)) {
                            // compare against the already loaded module to see if the new definition adds any new files
                            diff = requireEntry.files.filter(function (n) {
                                return self.getModuleConfig(requireEntry.name).files.indexOf(n) < 0;
                            });

                            // If the module was redefined, advise via the console
                            if (diff.length !== 0) {
                                self._$log.warn('Module "', moduleName, '" attempted to redefine configuration for dependency. "', requireEntry.name, '"\n Additional Files Loaded:', diff);
                            }

                            // Push everything to the file loader, it will weed out the duplicates.
                            if (angular.isDefined(self.filesLoader)) {
                                // if a files loader is defined
                                promisesList.push(self.filesLoader(requireEntry, localParams).then(function () {
                                    return self._loadDependencies(requireEntry);
                                }));
                            } else {
                                return reject(new Error('Error: New dependencies need to be loaded from external files (' + requireEntry.files + '), but no loader has been defined.'));
                            }
                            return;
                        } else if (angular.isArray(requireEntry)) {
                            var files = [];
                            angular.forEach(requireEntry, function (entry) {
                                // let's check if the entry is a file name or a config name
                                var config = self.getModuleConfig(entry);
                                if (config === null) {
                                    files.push(entry);
                                } else if (config.files) {
                                    files = files.concat(config.files);
                                }
                            });
                            if (files.length > 0) {
                                requireEntry = {
                                    files: files
                                };
                            }
                        } else if (angular.isObject(requireEntry)) {
                            if (requireEntry.hasOwnProperty('name') && requireEntry['name']) {
                                // The dependency doesn't exist in the module cache and is a new configuration, so store and push it.
                                self.setModuleConfig(requireEntry);
                                moduleCache.push(requireEntry['name']);
                            }
                        }

                        // Check if the dependency has any files that need to be loaded. If there are, push a new promise to the promise list.
                        if (angular.isDefined(requireEntry.files) && requireEntry.files.length !== 0) {
                            if (angular.isDefined(self.filesLoader)) {
                                // if a files loader is defined
                                promisesList.push(self.filesLoader(requireEntry, localParams).then(function () {
                                    return self._loadDependencies(requireEntry);
                                }));
                            } else {
                                return reject(new Error('Error: the module "' + requireEntry.name + '" is defined in external files (' + requireEntry.files + '), but no loader has been defined.'));
                            }
                        }
                    });

                    // Create a wrapper promise to watch the promise list and resolve it once everything is done.
                    return $q.all(promisesList);
                },

                /**
                 * Inject new modules into Angular
                 * @param moduleName
                 * @param localParams
                 * @param real
                 */
                inject: function inject(moduleName) {
                    var localParams = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
                    var real = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];

                    var self = this,
                        deferred = $q.defer();
                    if (angular.isDefined(moduleName) && moduleName !== null) {
                        if (angular.isArray(moduleName)) {
                            var promisesList = [];
                            angular.forEach(moduleName, function (module) {
                                promisesList.push(self.inject(module, localParams, real));
                            });
                            return $q.all(promisesList);
                        } else {
                            self._addToLoadList(self._getModuleName(moduleName), true, real);
                        }
                    }
                    if (modulesToLoad.length > 0) {
                        var res = modulesToLoad.slice(); // clean copy
                        var loadNext = function loadNext(moduleName) {
                            moduleCache.push(moduleName);
                            modulePromises[moduleName] = deferred.promise;
                            self._loadDependencies(moduleName, localParams).then(function success() {
                                try {
                                    justLoaded = [];
                                    _register(providers, moduleCache, localParams);
                                } catch (e) {
                                    self._$log.error(e.message);
                                    deferred.reject(e);
                                    return;
                                }

                                if (modulesToLoad.length > 0) {
                                    loadNext(modulesToLoad.shift()); // load the next in list
                                } else {
                                        deferred.resolve(res); // everything has been loaded, resolve
                                    }
                            }, function error(err) {
                                deferred.reject(err);
                            });
                        };

                        // load the first in list
                        loadNext(modulesToLoad.shift());
                    } else if (localParams && localParams.name && modulePromises[localParams.name]) {
                        return modulePromises[localParams.name];
                    } else {
                        deferred.resolve();
                    }
                    return deferred.promise;
                },

                /**
                 * Get the list of required modules/services/... for this module
                 * @param module
                 * @returns {Array}
                 */
                getRequires: function getRequires(module) {
                    var requires = [];
                    angular.forEach(module.requires, function (requireModule) {
                        if (regModules.indexOf(requireModule) === -1) {
                            requires.push(requireModule);
                        }
                    });
                    return requires;
                },

                /**
                 * Invoke the new modules & component by their providers
                 * @param providers
                 * @param queue
                 * @param moduleName
                 * @param reconfig
                 * @private
                 */
                _invokeQueue: _invokeQueue,

                /**
                 * Check if a module has been invoked and registers it if not
                 * @param args
                 * @param moduleName
                 * @returns {boolean} is new
                 */
                _registerInvokeList: _registerInvokeList,

                /**
                 * Register a new module and loads it, executing the run/config blocks if needed
                 * @param providers
                 * @param registerModules
                 * @param params
                 * @private
                 */
                _register: _register,

                /**
                 * Add a module name to the list of modules that will be loaded in the next inject
                 * @param name
                 * @param force
                 * @private
                 */
                _addToLoadList: _addToLoadList,

                /**
                 * Unregister modules (you shouldn't have to use this)
                 * @param modules
                 */
                _unregister: function _unregister(modules) {
                    if (angular.isDefined(modules)) {
                        if (angular.isArray(modules)) {
                            angular.forEach(modules, function (module) {
                                regInvokes[module] = undefined;
                            });
                        }
                    }
                }
            };
        }];

        // Let's get the list of loaded modules & components
        this._init(angular.element(window.document));
    }]);

    var bootstrapFct = angular.bootstrap;
    angular.bootstrap = function (element, modules, config) {
        // Clean state from previous bootstrap
        regModules = ['ng', 'oc.lazyLoad'];
        regInvokes = {};
        regConfigs = [];
        modulesToLoad = [];
        realModules = [];
        recordDeclarations = [];
        broadcast = angular.noop;
        runBlocks = {};
        justLoaded = [];
        // we use slice to make a clean copy
        angular.forEach(modules.slice(), function (module) {
            _addToLoadList(module, true, true);
        });
        return bootstrapFct(element, modules, config);
    };

    var _addToLoadList = function _addToLoadList(name, force, real) {
        if ((recordDeclarations.length > 0 || force) && angular.isString(name) && modulesToLoad.indexOf(name) === -1) {
            modulesToLoad.push(name);
            if (real) {
                realModules.push(name);
            }
        }
    };

    var ngModuleFct = angular.module;
    angular.module = function (name, requires, configFn) {
        _addToLoadList(name, false, true);
        return ngModuleFct(name, requires, configFn);
    };

    // CommonJS package manager support:
    if (typeof module !== 'undefined' && typeof exports !== 'undefined' && module.exports === exports) {
        module.exports = 'oc.lazyLoad';
    }
})(angular, window);
(function (angular) {
    'use strict';

    angular.module('oc.lazyLoad').directive('ocLazyLoad', ["$ocLazyLoad", "$compile", "$animate", "$parse", "$timeout", function ($ocLazyLoad, $compile, $animate, $parse, $timeout) {
        return {
            restrict: 'A',
            terminal: true,
            priority: 1000,
            compile: function compile(element, attrs) {
                // we store the content and remove it before compilation
                var content = element[0].innerHTML;
                element.html('');

                return function ($scope, $element, $attr) {
                    var model = $parse($attr.ocLazyLoad);
                    $scope.$watch(function () {
                        return model($scope) || $attr.ocLazyLoad; // it can be a module name (string), an object, an array, or a scope reference to any of this
                    }, function (moduleName) {
                        if (angular.isDefined(moduleName)) {
                            $ocLazyLoad.load(moduleName).then(function () {
                                // Attach element contents to DOM and then compile them.
                                // This prevents an issue where IE invalidates saved element objects (HTMLCollections)
                                // of the compiled contents when attaching to the parent DOM.
                                $animate.enter(content, $element);
                                // get the new content & compile it
                                $compile($element.contents())($scope);
                            });
                        }
                    }, true);
                };
            }
        };
    }]);
})(angular);
(function (angular) {
    'use strict';

    angular.module('oc.lazyLoad').config(["$provide", function ($provide) {
        $provide.decorator('$ocLazyLoad', ["$delegate", "$q", "$window", "$interval", function ($delegate, $q, $window, $interval) {
            var uaCssChecked = false,
                useCssLoadPatch = false,
                anchor = $window.document.getElementsByTagName('head')[0] || $window.document.getElementsByTagName('body')[0];

            /**
             * Load a js/css file
             * @param type
             * @param path
             * @param params
             * @returns promise
             */
            $delegate.buildElement = function buildElement(type, path, params) {
                var deferred = $q.defer(),
                    el,
                    loaded,
                    filesCache = $delegate._getFilesCache(),
                    cacheBuster = function cacheBuster(url) {
                    var dc = new Date().getTime();
                    if (url.indexOf('?') >= 0) {
                        if (url.substring(0, url.length - 1) === '&') {
                            return url + '_dc=' + dc;
                        }
                        return url + '&_dc=' + dc;
                    } else {
                        return url + '?_dc=' + dc;
                    }
                };

                // Store the promise early so the file load can be detected by other parallel lazy loads
                // (ie: multiple routes on one page) a 'true' value isn't sufficient
                // as it causes false positive load results.
                if (angular.isUndefined(filesCache.get(path))) {
                    filesCache.put(path, deferred.promise);
                }

                // Switch in case more content types are added later
                switch (type) {
                    case 'css':
                        el = $window.document.createElement('link');
                        el.type = 'text/css';
                        el.rel = 'stylesheet';
                        el.href = params.cache === false ? cacheBuster(path) : path;
                        break;
                    case 'js':
                        el = $window.document.createElement('script');
                        el.src = params.cache === false ? cacheBuster(path) : path;
                        break;
                    default:
                        filesCache.remove(path);
                        deferred.reject(new Error('Requested type "' + type + '" is not known. Could not inject "' + path + '"'));
                        break;
                }
                el.onload = el['onreadystatechange'] = function (e) {
                    if (el['readyState'] && !/^c|loade/.test(el['readyState']) || loaded) return;
                    el.onload = el['onreadystatechange'] = null;
                    loaded = 1;
                    $delegate._broadcast('ocLazyLoad.fileLoaded', path);
                    deferred.resolve(el);
                };
                el.onerror = function () {
                    filesCache.remove(path);
                    deferred.reject(new Error('Unable to load ' + path));
                };
                el.async = params.serie ? 0 : 1;

                var insertBeforeElem = anchor.lastChild;
                if (params.insertBefore) {
                    var element = angular.element(angular.isDefined(window.jQuery) ? params.insertBefore : document.querySelector(params.insertBefore));
                    if (element && element.length > 0) {
                        insertBeforeElem = element[0];
                    }
                }
                insertBeforeElem.parentNode.insertBefore(el, insertBeforeElem);

                /*
                 The event load or readystatechange doesn't fire in:
                 - PhantomJS 1.9 (headless webkit browser)
                 - iOS < 6       (default mobile browser)
                 - Android < 4.4 (default mobile browser)
                 - Safari < 6    (desktop browser)
                 */
                if (type == 'css') {
                    if (!uaCssChecked) {
                        var ua = $window.navigator.userAgent.toLowerCase();

                        if (ua.indexOf('phantomjs/1.9') > -1) {
                            // PhantomJS ~1.9
                            useCssLoadPatch = true;
                        } else if (/iP(hone|od|ad)/.test($window.navigator.platform)) {
                            // iOS < 6
                            var v = $window.navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
                            var iOSVersion = parseFloat([parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)].join('.'));
                            useCssLoadPatch = iOSVersion < 6;
                        } else if (ua.indexOf('android') > -1) {
                            // Android < 4.4
                            var androidVersion = parseFloat(ua.slice(ua.indexOf('android') + 8));
                            useCssLoadPatch = androidVersion < 4.4;
                        } else if (ua.indexOf('safari') > -1) {
                            // Safari < 6
                            var versionMatch = ua.match(/version\/([\.\d]+)/i);
                            useCssLoadPatch = versionMatch && versionMatch[1] && parseFloat(versionMatch[1]) < 6;
                        }
                    }

                    if (useCssLoadPatch) {
                        var tries = 1000; // * 20 = 20000 miliseconds
                        var interval = $interval(function () {
                            try {
                                el.sheet.cssRules;
                                $interval.cancel(interval);
                                el.onload();
                            } catch (e) {
                                if (--tries <= 0) {
                                    el.onerror();
                                }
                            }
                        }, 20);
                    }
                }

                return deferred.promise;
            };

            return $delegate;
        }]);
    }]);
})(angular);
(function (angular) {
    'use strict';

    angular.module('oc.lazyLoad').config(["$provide", function ($provide) {
        $provide.decorator('$ocLazyLoad', ["$delegate", "$q", function ($delegate, $q) {
            /**
             * The function that loads new files
             * @param config
             * @param params
             * @returns {*}
             */
            $delegate.filesLoader = function filesLoader(config) {
                var params = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

                var cssFiles = [],
                    templatesFiles = [],
                    jsFiles = [],
                    promises = [],
                    cachePromise = null,
                    filesCache = $delegate._getFilesCache();

                $delegate.toggleWatch(true); // start watching angular.module calls

                angular.extend(params, config);

                var pushFile = function pushFile(path) {
                    var file_type = null,
                        m;
                    if (angular.isObject(path)) {
                        file_type = path.type;
                        path = path.path;
                    }
                    cachePromise = filesCache.get(path);
                    if (angular.isUndefined(cachePromise) || params.cache === false) {

                        // always check for requirejs syntax just in case
                        if ((m = /^(css|less|html|htm|js)?(?=!)/.exec(path)) !== null) {
                            // Detect file type using preceding type declaration (ala requireJS)
                            file_type = m[1];
                            path = path.substr(m[1].length + 1, path.length); // Strip the type from the path
                        }

                        if (!file_type) {
                            if ((m = /[.](css|less|html|htm|js)?((\?|#).*)?$/.exec(path)) !== null) {
                                // Detect file type via file extension
                                file_type = m[1];
                            } else if (!$delegate.jsLoader.hasOwnProperty('ocLazyLoadLoader') && $delegate.jsLoader.hasOwnProperty('requirejs')) {
                                // requirejs
                                file_type = 'js';
                            } else {
                                $delegate._$log.error('File type could not be determined. ' + path);
                                return;
                            }
                        }

                        if ((file_type === 'css' || file_type === 'less') && cssFiles.indexOf(path) === -1) {
                            cssFiles.push(path);
                        } else if ((file_type === 'html' || file_type === 'htm') && templatesFiles.indexOf(path) === -1) {
                            templatesFiles.push(path);
                        } else if (file_type === 'js' || jsFiles.indexOf(path) === -1) {
                            jsFiles.push(path);
                        } else {
                            $delegate._$log.error('File type is not valid. ' + path);
                        }
                    } else if (cachePromise) {
                        promises.push(cachePromise);
                    }
                };

                if (params.serie) {
                    pushFile(params.files.shift());
                } else {
                    angular.forEach(params.files, function (path) {
                        pushFile(path);
                    });
                }

                if (cssFiles.length > 0) {
                    var cssDeferred = $q.defer();
                    $delegate.cssLoader(cssFiles, function (err) {
                        if (angular.isDefined(err) && $delegate.cssLoader.hasOwnProperty('ocLazyLoadLoader')) {
                            $delegate._$log.error(err);
                            cssDeferred.reject(err);
                        } else {
                            cssDeferred.resolve();
                        }
                    }, params);
                    promises.push(cssDeferred.promise);
                }

                if (templatesFiles.length > 0) {
                    var templatesDeferred = $q.defer();
                    $delegate.templatesLoader(templatesFiles, function (err) {
                        if (angular.isDefined(err) && $delegate.templatesLoader.hasOwnProperty('ocLazyLoadLoader')) {
                            $delegate._$log.error(err);
                            templatesDeferred.reject(err);
                        } else {
                            templatesDeferred.resolve();
                        }
                    }, params);
                    promises.push(templatesDeferred.promise);
                }

                if (jsFiles.length > 0) {
                    var jsDeferred = $q.defer();
                    $delegate.jsLoader(jsFiles, function (err) {
                        if (angular.isDefined(err) && ($delegate.jsLoader.hasOwnProperty("ocLazyLoadLoader") || $delegate.jsLoader.hasOwnProperty("requirejs"))) {
                            $delegate._$log.error(err);
                            jsDeferred.reject(err);
                        } else {
                            jsDeferred.resolve();
                        }
                    }, params);
                    promises.push(jsDeferred.promise);
                }

                if (promises.length === 0) {
                    var deferred = $q.defer(),
                        err = "Error: no file to load has been found, if you're trying to load an existing module you should use the 'inject' method instead of 'load'.";
                    $delegate._$log.error(err);
                    deferred.reject(err);
                    return deferred.promise;
                } else if (params.serie && params.files.length > 0) {
                    return $q.all(promises).then(function () {
                        return $delegate.filesLoader(config, params);
                    });
                } else {
                    return $q.all(promises)['finally'](function (res) {
                        $delegate.toggleWatch(false); // stop watching angular.module calls
                        return res;
                    });
                }
            };

            /**
             * Load a module or a list of modules into Angular
             * @param module Mixed the name of a predefined module config object, or a module config object, or an array of either
             * @param params Object optional parameters
             * @returns promise
             */
            $delegate.load = function (originalModule) {
                var originalParams = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

                var self = this,
                    config = null,
                    deferredList = [],
                    deferred = $q.defer(),
                    errText;

                // clean copy
                var module = angular.copy(originalModule);
                var params = angular.copy(originalParams);

                // If module is an array, break it down
                if (angular.isArray(module)) {
                    // Resubmit each entry as a single module
                    angular.forEach(module, function (m) {
                        deferredList.push(self.load(m, params));
                    });

                    // Resolve the promise once everything has loaded
                    $q.all(deferredList).then(function (res) {
                        deferred.resolve(res);
                    }, function (err) {
                        deferred.reject(err);
                    });

                    return deferred.promise;
                }

                // Get or Set a configuration depending on what was passed in
                if (angular.isString(module)) {
                    config = self.getModuleConfig(module);
                    if (!config) {
                        config = {
                            files: [module]
                        };
                    }
                } else if (angular.isObject(module)) {
                    // case {type: 'js', path: lazyLoadUrl + 'testModule.fakejs'}
                    if (angular.isDefined(module.path) && angular.isDefined(module.type)) {
                        config = {
                            files: [module]
                        };
                    } else {
                        config = self.setModuleConfig(module);
                    }
                }

                if (config === null) {
                    var moduleName = self._getModuleName(module);
                    errText = 'Module "' + (moduleName || 'unknown') + '" is not configured, cannot load.';
                    $delegate._$log.error(errText);
                    deferred.reject(new Error(errText));
                    return deferred.promise;
                } else {
                    // deprecated
                    if (angular.isDefined(config.template)) {
                        if (angular.isUndefined(config.files)) {
                            config.files = [];
                        }
                        if (angular.isString(config.template)) {
                            config.files.push(config.template);
                        } else if (angular.isArray(config.template)) {
                            config.files.concat(config.template);
                        }
                    }
                }

                var localParams = angular.extend({}, params, config);

                // if someone used an external loader and called the load function with just the module name
                if (angular.isUndefined(config.files) && angular.isDefined(config.name) && $delegate.moduleExists(config.name)) {
                    return $delegate.inject(config.name, localParams, true);
                }

                $delegate.filesLoader(config, localParams).then(function () {
                    $delegate.inject(null, localParams).then(function (res) {
                        deferred.resolve(res);
                    }, function (err) {
                        deferred.reject(err);
                    });
                }, function (err) {
                    deferred.reject(err);
                });

                return deferred.promise;
            };

            // return the patched service
            return $delegate;
        }]);
    }]);
})(angular);
(function (angular) {
    'use strict';

    angular.module('oc.lazyLoad').config(["$provide", function ($provide) {
        $provide.decorator('$ocLazyLoad', ["$delegate", "$q", function ($delegate, $q) {
            /**
             * cssLoader function
             * @type Function
             * @param paths array list of css files to load
             * @param callback to call when everything is loaded. We use a callback and not a promise
             * @param params object config parameters
             * because the user can overwrite cssLoader and it will probably not use promises :(
             */
            $delegate.cssLoader = function (paths, callback, params) {
                var promises = [];
                angular.forEach(paths, function (path) {
                    promises.push($delegate.buildElement('css', path, params));
                });
                $q.all(promises).then(function () {
                    callback();
                }, function (err) {
                    callback(err);
                });
            };
            $delegate.cssLoader.ocLazyLoadLoader = true;

            return $delegate;
        }]);
    }]);
})(angular);
(function (angular) {
    'use strict';

    angular.module('oc.lazyLoad').config(["$provide", function ($provide) {
        $provide.decorator('$ocLazyLoad', ["$delegate", "$q", function ($delegate, $q) {
            /**
             * jsLoader function
             * @type Function
             * @param paths array list of js files to load
             * @param callback to call when everything is loaded. We use a callback and not a promise
             * @param params object config parameters
             * because the user can overwrite jsLoader and it will probably not use promises :(
             */
            $delegate.jsLoader = function (paths, callback, params) {
                var promises = [];
                angular.forEach(paths, function (path) {
                    promises.push($delegate.buildElement('js', path, params));
                });
                $q.all(promises).then(function () {
                    callback();
                }, function (err) {
                    callback(err);
                });
            };
            $delegate.jsLoader.ocLazyLoadLoader = true;

            return $delegate;
        }]);
    }]);
})(angular);
(function (angular) {
    'use strict';

    angular.module('oc.lazyLoad').config(["$provide", function ($provide) {
        $provide.decorator('$ocLazyLoad', ["$delegate", "$templateCache", "$q", "$http", function ($delegate, $templateCache, $q, $http) {
            /**
             * templatesLoader function
             * @type Function
             * @param paths array list of css files to load
             * @param callback to call when everything is loaded. We use a callback and not a promise
             * @param params object config parameters for $http
             * because the user can overwrite templatesLoader and it will probably not use promises :(
             */
            $delegate.templatesLoader = function (paths, callback, params) {
                var promises = [],
                    filesCache = $delegate._getFilesCache();

                angular.forEach(paths, function (url) {
                    var deferred = $q.defer();
                    promises.push(deferred.promise);
                    $http.get(url, params).then(function (response) {
                        var data = response.data;
                        if (angular.isString(data) && data.length > 0) {
                            angular.forEach(angular.element(data), function (node) {
                                if (node.nodeName === 'SCRIPT' && node.type === 'text/ng-template') {
                                    $templateCache.put(node.id, node.innerHTML);
                                }
                            });
                        }
                        if (angular.isUndefined(filesCache.get(url))) {
                            filesCache.put(url, true);
                        }
                        deferred.resolve();
                    })['catch'](function (response) {
                        deferred.reject(new Error('Unable to load template file "' + url + '": ' + response.data));
                    });
                });
                return $q.all(promises).then(function () {
                    callback();
                }, function (err) {
                    callback(err);
                });
            };
            $delegate.templatesLoader.ocLazyLoadLoader = true;

            return $delegate;
        }]);
    }]);
})(angular);
// Array.indexOf polyfill for IE8
if (!Array.prototype.indexOf) {
        Array.prototype.indexOf = function (searchElement, fromIndex) {
                var k;

                // 1. Let O be the result of calling ToObject passing
                //    the this value as the argument.
                if (this == null) {
                        throw new TypeError('"this" is null or not defined');
                }

                var O = Object(this);

                // 2. Let lenValue be the result of calling the Get
                //    internal method of O with the argument "length".
                // 3. Let len be ToUint32(lenValue).
                var len = O.length >>> 0;

                // 4. If len is 0, return -1.
                if (len === 0) {
                        return -1;
                }

                // 5. If argument fromIndex was passed let n be
                //    ToInteger(fromIndex); else let n be 0.
                var n = +fromIndex || 0;

                if (Math.abs(n) === Infinity) {
                        n = 0;
                }

                // 6. If n >= len, return -1.
                if (n >= len) {
                        return -1;
                }

                // 7. If n >= 0, then Let k be n.
                // 8. Else, n<0, Let k be len - abs(n).
                //    If k is less than 0, then let k be 0.
                k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

                // 9. Repeat, while k < len
                while (k < len) {
                        // a. Let Pk be ToString(k).
                        //   This is implicit for LHS operands of the in operator
                        // b. Let kPresent be the result of calling the
                        //    HasProperty internal method of O with argument Pk.
                        //   This step can be combined with c
                        // c. If kPresent is true, then
                        //    i.  Let elementK be the result of calling the Get
                        //        internal method of O with the argument ToString(k).
                        //   ii.  Let same be the result of applying the
                        //        Strict Equality Comparison Algorithm to
                        //        searchElement and elementK.
                        //  iii.  If same is true, return k.
                        if (k in O && O[k] === searchElement) {
                                return k;
                        }
                        k++;
                }
                return -1;
        };
}
},{}],1170:[function(require,module,exports){
'use strict';


var TYPED_OK =  (typeof Uint8Array !== 'undefined') &&
                (typeof Uint16Array !== 'undefined') &&
                (typeof Int32Array !== 'undefined');

function _has(obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key);
}

exports.assign = function (obj /*from1, from2, from3, ...*/) {
  var sources = Array.prototype.slice.call(arguments, 1);
  while (sources.length) {
    var source = sources.shift();
    if (!source) { continue; }

    if (typeof source !== 'object') {
      throw new TypeError(source + 'must be non-object');
    }

    for (var p in source) {
      if (_has(source, p)) {
        obj[p] = source[p];
      }
    }
  }

  return obj;
};


// reduce buffer size, avoiding mem copy
exports.shrinkBuf = function (buf, size) {
  if (buf.length === size) { return buf; }
  if (buf.subarray) { return buf.subarray(0, size); }
  buf.length = size;
  return buf;
};


var fnTyped = {
  arraySet: function (dest, src, src_offs, len, dest_offs) {
    if (src.subarray && dest.subarray) {
      dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
      return;
    }
    // Fallback to ordinary array
    for (var i = 0; i < len; i++) {
      dest[dest_offs + i] = src[src_offs + i];
    }
  },
  // Join array of chunks to single array.
  flattenChunks: function (chunks) {
    var i, l, len, pos, chunk, result;

    // calculate data length
    len = 0;
    for (i = 0, l = chunks.length; i < l; i++) {
      len += chunks[i].length;
    }

    // join chunks
    result = new Uint8Array(len);
    pos = 0;
    for (i = 0, l = chunks.length; i < l; i++) {
      chunk = chunks[i];
      result.set(chunk, pos);
      pos += chunk.length;
    }

    return result;
  }
};

var fnUntyped = {
  arraySet: function (dest, src, src_offs, len, dest_offs) {
    for (var i = 0; i < len; i++) {
      dest[dest_offs + i] = src[src_offs + i];
    }
  },
  // Join array of chunks to single array.
  flattenChunks: function (chunks) {
    return [].concat.apply([], chunks);
  }
};


// Enable/Disable typed arrays use, for testing
//
exports.setTyped = function (on) {
  if (on) {
    exports.Buf8  = Uint8Array;
    exports.Buf16 = Uint16Array;
    exports.Buf32 = Int32Array;
    exports.assign(exports, fnTyped);
  } else {
    exports.Buf8  = Array;
    exports.Buf16 = Array;
    exports.Buf32 = Array;
    exports.assign(exports, fnUntyped);
  }
};

exports.setTyped(TYPED_OK);

},{}],1171:[function(require,module,exports){
'use strict';

// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

function adler32(adler, buf, len, pos) {
  var s1 = (adler & 0xffff) |0,
      s2 = ((adler >>> 16) & 0xffff) |0,
      n = 0;

  while (len !== 0) {
    // Set limit ~ twice less than 5552, to keep
    // s2 in 31-bits, because we force signed ints.
    // in other case %= will fail.
    n = len > 2000 ? 2000 : len;
    len -= n;

    do {
      s1 = (s1 + buf[pos++]) |0;
      s2 = (s2 + s1) |0;
    } while (--n);

    s1 %= 65521;
    s2 %= 65521;
  }

  return (s1 | (s2 << 16)) |0;
}


module.exports = adler32;

},{}],1172:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

module.exports = {

  /* Allowed flush values; see deflate() and inflate() below for details */
  Z_NO_FLUSH:         0,
  Z_PARTIAL_FLUSH:    1,
  Z_SYNC_FLUSH:       2,
  Z_FULL_FLUSH:       3,
  Z_FINISH:           4,
  Z_BLOCK:            5,
  Z_TREES:            6,

  /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */
  Z_OK:               0,
  Z_STREAM_END:       1,
  Z_NEED_DICT:        2,
  Z_ERRNO:           -1,
  Z_STREAM_ERROR:    -2,
  Z_DATA_ERROR:      -3,
  //Z_MEM_ERROR:     -4,
  Z_BUF_ERROR:       -5,
  //Z_VERSION_ERROR: -6,

  /* compression levels */
  Z_NO_COMPRESSION:         0,
  Z_BEST_SPEED:             1,
  Z_BEST_COMPRESSION:       9,
  Z_DEFAULT_COMPRESSION:   -1,


  Z_FILTERED:               1,
  Z_HUFFMAN_ONLY:           2,
  Z_RLE:                    3,
  Z_FIXED:                  4,
  Z_DEFAULT_STRATEGY:       0,

  /* Possible values of the data_type field (though see inflate()) */
  Z_BINARY:                 0,
  Z_TEXT:                   1,
  //Z_ASCII:                1, // = Z_TEXT (deprecated)
  Z_UNKNOWN:                2,

  /* The deflate compression method */
  Z_DEFLATED:               8
  //Z_NULL:                 null // Use -1 or null inline, depending on var type
};

},{}],1173:[function(require,module,exports){
'use strict';

// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

// Use ordinary array, since untyped makes no boost here
function makeTable() {
  var c, table = [];

  for (var n = 0; n < 256; n++) {
    c = n;
    for (var k = 0; k < 8; k++) {
      c = ((c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
    }
    table[n] = c;
  }

  return table;
}

// Create table on load. Just 255 signed longs. Not a problem.
var crcTable = makeTable();


function crc32(crc, buf, len, pos) {
  var t = crcTable,
      end = pos + len;

  crc ^= -1;

  for (var i = pos; i < end; i++) {
    crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
  }

  return (crc ^ (-1)); // >>> 0;
}


module.exports = crc32;

},{}],1174:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var utils   = require('../utils/common');
var trees   = require('./trees');
var adler32 = require('./adler32');
var crc32   = require('./crc32');
var msg     = require('./messages');

/* Public constants ==========================================================*/
/* ===========================================================================*/


/* Allowed flush values; see deflate() and inflate() below for details */
var Z_NO_FLUSH      = 0;
var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
var Z_FULL_FLUSH    = 3;
var Z_FINISH        = 4;
var Z_BLOCK         = 5;
//var Z_TREES         = 6;


/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */
var Z_OK            = 0;
var Z_STREAM_END    = 1;
//var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var Z_STREAM_ERROR  = -2;
var Z_DATA_ERROR    = -3;
//var Z_MEM_ERROR     = -4;
var Z_BUF_ERROR     = -5;
//var Z_VERSION_ERROR = -6;


/* compression levels */
//var Z_NO_COMPRESSION      = 0;
//var Z_BEST_SPEED          = 1;
//var Z_BEST_COMPRESSION    = 9;
var Z_DEFAULT_COMPRESSION = -1;


var Z_FILTERED            = 1;
var Z_HUFFMAN_ONLY        = 2;
var Z_RLE                 = 3;
var Z_FIXED               = 4;
var Z_DEFAULT_STRATEGY    = 0;

/* Possible values of the data_type field (though see inflate()) */
//var Z_BINARY              = 0;
//var Z_TEXT                = 1;
//var Z_ASCII               = 1; // = Z_TEXT
var Z_UNKNOWN             = 2;


/* The deflate compression method */
var Z_DEFLATED  = 8;

/*============================================================================*/


var MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */
var MAX_WBITS = 15;
/* 32K LZ77 window */
var DEF_MEM_LEVEL = 8;


var LENGTH_CODES  = 29;
/* number of length codes, not counting the special END_BLOCK code */
var LITERALS      = 256;
/* number of literal bytes 0..255 */
var L_CODES       = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */
var D_CODES       = 30;
/* number of distance codes */
var BL_CODES      = 19;
/* number of codes used to transfer the bit lengths */
var HEAP_SIZE     = 2 * L_CODES + 1;
/* maximum heap size */
var MAX_BITS  = 15;
/* All codes must not exceed MAX_BITS bits */

var MIN_MATCH = 3;
var MAX_MATCH = 258;
var MIN_LOOKAHEAD = (MAX_MATCH + MIN_MATCH + 1);

var PRESET_DICT = 0x20;

var INIT_STATE = 42;
var EXTRA_STATE = 69;
var NAME_STATE = 73;
var COMMENT_STATE = 91;
var HCRC_STATE = 103;
var BUSY_STATE = 113;
var FINISH_STATE = 666;

var BS_NEED_MORE      = 1; /* block not completed, need more input or more output */
var BS_BLOCK_DONE     = 2; /* block flush performed */
var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
var BS_FINISH_DONE    = 4; /* finish done, accept no more input or output */

var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.

function err(strm, errorCode) {
  strm.msg = msg[errorCode];
  return errorCode;
}

function rank(f) {
  return ((f) << 1) - ((f) > 4 ? 9 : 0);
}

function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }


/* =========================================================================
 * Flush as much pending output as possible. All deflate() output goes
 * through this function so some applications may wish to modify it
 * to avoid allocating a large strm->output buffer and copying into it.
 * (See also read_buf()).
 */
function flush_pending(strm) {
  var s = strm.state;

  //_tr_flush_bits(s);
  var len = s.pending;
  if (len > strm.avail_out) {
    len = strm.avail_out;
  }
  if (len === 0) { return; }

  utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
  strm.next_out += len;
  s.pending_out += len;
  strm.total_out += len;
  strm.avail_out -= len;
  s.pending -= len;
  if (s.pending === 0) {
    s.pending_out = 0;
  }
}


function flush_block_only(s, last) {
  trees._tr_flush_block(s, (s.block_start >= 0 ? s.block_start : -1), s.strstart - s.block_start, last);
  s.block_start = s.strstart;
  flush_pending(s.strm);
}


function put_byte(s, b) {
  s.pending_buf[s.pending++] = b;
}


/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */
function putShortMSB(s, b) {
//  put_byte(s, (Byte)(b >> 8));
//  put_byte(s, (Byte)(b & 0xff));
  s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
  s.pending_buf[s.pending++] = b & 0xff;
}


/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */
function read_buf(strm, buf, start, size) {
  var len = strm.avail_in;

  if (len > size) { len = size; }
  if (len === 0) { return 0; }

  strm.avail_in -= len;

  // zmemcpy(buf, strm->next_in, len);
  utils.arraySet(buf, strm.input, strm.next_in, len, start);
  if (strm.state.wrap === 1) {
    strm.adler = adler32(strm.adler, buf, len, start);
  }

  else if (strm.state.wrap === 2) {
    strm.adler = crc32(strm.adler, buf, len, start);
  }

  strm.next_in += len;
  strm.total_in += len;

  return len;
}


/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */
function longest_match(s, cur_match) {
  var chain_length = s.max_chain_length;      /* max hash chain length */
  var scan = s.strstart; /* current string */
  var match;                       /* matched string */
  var len;                           /* length of current match */
  var best_len = s.prev_length;              /* best match length so far */
  var nice_match = s.nice_match;             /* stop if match long enough */
  var limit = (s.strstart > (s.w_size - MIN_LOOKAHEAD)) ?
      s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0/*NIL*/;

  var _win = s.window; // shortcut

  var wmask = s.w_mask;
  var prev  = s.prev;

  /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */

  var strend = s.strstart + MAX_MATCH;
  var scan_end1  = _win[scan + best_len - 1];
  var scan_end   = _win[scan + best_len];

  /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */
  // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");

  /* Do not waste too much time if we already have a good match: */
  if (s.prev_length >= s.good_match) {
    chain_length >>= 2;
  }
  /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */
  if (nice_match > s.lookahead) { nice_match = s.lookahead; }

  // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");

  do {
    // Assert(cur_match < s->strstart, "no future");
    match = cur_match;

    /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */

    if (_win[match + best_len]     !== scan_end  ||
        _win[match + best_len - 1] !== scan_end1 ||
        _win[match]                !== _win[scan] ||
        _win[++match]              !== _win[scan + 1]) {
      continue;
    }

    /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */
    scan += 2;
    match++;
    // Assert(*scan == *match, "match[2]?");

    /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */
    do {
      /*jshint noempty:false*/
    } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             scan < strend);

    // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");

    len = MAX_MATCH - (strend - scan);
    scan = strend - MAX_MATCH;

    if (len > best_len) {
      s.match_start = cur_match;
      best_len = len;
      if (len >= nice_match) {
        break;
      }
      scan_end1  = _win[scan + best_len - 1];
      scan_end   = _win[scan + best_len];
    }
  } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);

  if (best_len <= s.lookahead) {
    return best_len;
  }
  return s.lookahead;
}


/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */
function fill_window(s) {
  var _w_size = s.w_size;
  var p, n, m, more, str;

  //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");

  do {
    more = s.window_size - s.lookahead - s.strstart;

    // JS ints have 32 bit, block below not needed
    /* Deal with !@#$% 64K limit: */
    //if (sizeof(int) <= 2) {
    //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
    //        more = wsize;
    //
    //  } else if (more == (unsigned)(-1)) {
    //        /* Very unlikely, but possible on 16 bit machine if
    //         * strstart == 0 && lookahead == 1 (input done a byte at time)
    //         */
    //        more--;
    //    }
    //}


    /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */
    if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {

      utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
      s.match_start -= _w_size;
      s.strstart -= _w_size;
      /* we now have strstart >= MAX_DIST */
      s.block_start -= _w_size;

      /* Slide the hash table (could be avoided with 32 bit values
       at the expense of memory usage). We slide even when level == 0
       to keep the hash table consistent if we switch back to level > 0
       later. (Using level 0 permanently is not an optimal usage of
       zlib, so we don't care about this pathological case.)
       */

      n = s.hash_size;
      p = n;
      do {
        m = s.head[--p];
        s.head[p] = (m >= _w_size ? m - _w_size : 0);
      } while (--n);

      n = _w_size;
      p = n;
      do {
        m = s.prev[--p];
        s.prev[p] = (m >= _w_size ? m - _w_size : 0);
        /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */
      } while (--n);

      more += _w_size;
    }
    if (s.strm.avail_in === 0) {
      break;
    }

    /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */
    //Assert(more >= 2, "more < 2");
    n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
    s.lookahead += n;

    /* Initialize the hash value now that we have some input: */
    if (s.lookahead + s.insert >= MIN_MATCH) {
      str = s.strstart - s.insert;
      s.ins_h = s.window[str];

      /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + 1]) & s.hash_mask;
//#if MIN_MATCH != 3
//        Call update_hash() MIN_MATCH-3 more times
//#endif
      while (s.insert) {
        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;

        s.prev[str & s.w_mask] = s.head[s.ins_h];
        s.head[s.ins_h] = str;
        str++;
        s.insert--;
        if (s.lookahead + s.insert < MIN_MATCH) {
          break;
        }
      }
    }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */

  } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);

  /* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */
//  if (s.high_water < s.window_size) {
//    var curr = s.strstart + s.lookahead;
//    var init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
}

/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 * This function does not insert new strings in the dictionary since
 * uncompressible data is probably not useful. This function is used
 * only for the level=0 compression option.
 * NOTE: this function should be optimized to avoid extra copying from
 * window to pending_buf.
 */
function deflate_stored(s, flush) {
  /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
   * to pending_buf_size, and each stored block has a 5 byte header:
   */
  var max_block_size = 0xffff;

  if (max_block_size > s.pending_buf_size - 5) {
    max_block_size = s.pending_buf_size - 5;
  }

  /* Copy as much as possible from input to output: */
  for (;;) {
    /* Fill the window as much as possible: */
    if (s.lookahead <= 1) {

      //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
      //  s->block_start >= (long)s->w_size, "slide too late");
//      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
//        s.block_start >= s.w_size)) {
//        throw  new Error("slide too late");
//      }

      fill_window(s);
      if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }

      if (s.lookahead === 0) {
        break;
      }
      /* flush the current block */
    }
    //Assert(s->block_start >= 0L, "block gone");
//    if (s.block_start < 0) throw new Error("block gone");

    s.strstart += s.lookahead;
    s.lookahead = 0;

    /* Emit a stored block if pending_buf will be full: */
    var max_start = s.block_start + max_block_size;

    if (s.strstart === 0 || s.strstart >= max_start) {
      /* strstart == 0 is possible when wraparound on 16-bit machine */
      s.lookahead = s.strstart - max_start;
      s.strstart = max_start;
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/


    }
    /* Flush if we may have to slide, otherwise block_start may become
     * negative and the data will be gone:
     */
    if (s.strstart - s.block_start >= (s.w_size - MIN_LOOKAHEAD)) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }

  s.insert = 0;

  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }

  if (s.strstart > s.block_start) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }

  return BS_NEED_MORE;
}

/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */
function deflate_fast(s, flush) {
  var hash_head;        /* head of the hash chain */
  var bflush;           /* set if current block must be flushed */

  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */
    if (s.lookahead < MIN_LOOKAHEAD) {
      fill_window(s);
      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) {
        break; /* flush the current block */
      }
    }

    /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */
    hash_head = 0/*NIL*/;
    if (s.lookahead >= MIN_MATCH) {
      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = s.strstart;
      /***/
    }

    /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */
    if (hash_head !== 0/*NIL*/ && ((s.strstart - hash_head) <= (s.w_size - MIN_LOOKAHEAD))) {
      /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */
      s.match_length = longest_match(s, hash_head);
      /* longest_match() sets match_start */
    }
    if (s.match_length >= MIN_MATCH) {
      // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only

      /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/
      bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);

      s.lookahead -= s.match_length;

      /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */
      if (s.match_length <= s.max_lazy_match/*max_insert_length*/ && s.lookahead >= MIN_MATCH) {
        s.match_length--; /* string at strstart already in table */
        do {
          s.strstart++;
          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
          /***/
          /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */
        } while (--s.match_length !== 0);
        s.strstart++;
      } else
      {
        s.strstart += s.match_length;
        s.match_length = 0;
        s.ins_h = s.window[s.strstart];
        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + 1]) & s.hash_mask;

//#if MIN_MATCH != 3
//                Call UPDATE_HASH() MIN_MATCH-3 more times
//#endif
        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */
      }
    } else {
      /* No match, output a literal byte */
      //Tracevv((stderr,"%c", s.window[s.strstart]));
      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);

      s.lookahead--;
      s.strstart++;
    }
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = ((s.strstart < (MIN_MATCH - 1)) ? s.strstart : MIN_MATCH - 1);
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */
function deflate_slow(s, flush) {
  var hash_head;          /* head of hash chain */
  var bflush;              /* set if current block must be flushed */

  var max_insert;

  /* Process the input block. */
  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */
    if (s.lookahead < MIN_LOOKAHEAD) {
      fill_window(s);
      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) { break; } /* flush the current block */
    }

    /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */
    hash_head = 0/*NIL*/;
    if (s.lookahead >= MIN_MATCH) {
      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = s.strstart;
      /***/
    }

    /* Find the longest match, discarding those <= prev_length.
     */
    s.prev_length = s.match_length;
    s.prev_match = s.match_start;
    s.match_length = MIN_MATCH - 1;

    if (hash_head !== 0/*NIL*/ && s.prev_length < s.max_lazy_match &&
        s.strstart - hash_head <= (s.w_size - MIN_LOOKAHEAD)/*MAX_DIST(s)*/) {
      /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */
      s.match_length = longest_match(s, hash_head);
      /* longest_match() sets match_start */

      if (s.match_length <= 5 &&
         (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096/*TOO_FAR*/))) {

        /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */
        s.match_length = MIN_MATCH - 1;
      }
    }
    /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */
    if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
      max_insert = s.strstart + s.lookahead - MIN_MATCH;
      /* Do not insert strings in hash table beyond this. */

      //check_match(s, s.strstart-1, s.prev_match, s.prev_length);

      /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/
      bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
      /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */
      s.lookahead -= s.prev_length - 1;
      s.prev_length -= 2;
      do {
        if (++s.strstart <= max_insert) {
          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
          /***/
        }
      } while (--s.prev_length !== 0);
      s.match_available = 0;
      s.match_length = MIN_MATCH - 1;
      s.strstart++;

      if (bflush) {
        /*** FLUSH_BLOCK(s, 0); ***/
        flush_block_only(s, false);
        if (s.strm.avail_out === 0) {
          return BS_NEED_MORE;
        }
        /***/
      }

    } else if (s.match_available) {
      /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */
      //Tracevv((stderr,"%c", s->window[s->strstart-1]));
      /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);

      if (bflush) {
        /*** FLUSH_BLOCK_ONLY(s, 0) ***/
        flush_block_only(s, false);
        /***/
      }
      s.strstart++;
      s.lookahead--;
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
    } else {
      /* There is no previous match to compare with, wait for
       * the next step to decide.
       */
      s.match_available = 1;
      s.strstart++;
      s.lookahead--;
    }
  }
  //Assert (flush != Z_NO_FLUSH, "no flush?");
  if (s.match_available) {
    //Tracevv((stderr,"%c", s->window[s->strstart-1]));
    /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
    bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);

    s.match_available = 0;
  }
  s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }

  return BS_BLOCK_DONE;
}


/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */
function deflate_rle(s, flush) {
  var bflush;            /* set if current block must be flushed */
  var prev;              /* byte at distance one to match */
  var scan, strend;      /* scan goes up to strend for length of run */

  var _win = s.window;

  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */
    if (s.lookahead <= MAX_MATCH) {
      fill_window(s);
      if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) { break; } /* flush the current block */
    }

    /* See how many times the previous byte repeats */
    s.match_length = 0;
    if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
      scan = s.strstart - 1;
      prev = _win[scan];
      if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
        strend = s.strstart + MAX_MATCH;
        do {
          /*jshint noempty:false*/
        } while (prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 scan < strend);
        s.match_length = MAX_MATCH - (strend - scan);
        if (s.match_length > s.lookahead) {
          s.match_length = s.lookahead;
        }
      }
      //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
    }

    /* Emit match if have run of MIN_MATCH or longer, else emit literal */
    if (s.match_length >= MIN_MATCH) {
      //check_match(s, s.strstart, s.strstart - 1, s.match_length);

      /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
      bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);

      s.lookahead -= s.match_length;
      s.strstart += s.match_length;
      s.match_length = 0;
    } else {
      /* No match, output a literal byte */
      //Tracevv((stderr,"%c", s->window[s->strstart]));
      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);

      s.lookahead--;
      s.strstart++;
    }
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */
function deflate_huff(s, flush) {
  var bflush;             /* set if current block must be flushed */

  for (;;) {
    /* Make sure that we have a literal to write. */
    if (s.lookahead === 0) {
      fill_window(s);
      if (s.lookahead === 0) {
        if (flush === Z_NO_FLUSH) {
          return BS_NEED_MORE;
        }
        break;      /* flush the current block */
      }
    }

    /* Output a literal byte */
    s.match_length = 0;
    //Tracevv((stderr,"%c", s->window[s->strstart]));
    /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
    bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
    s.lookahead--;
    s.strstart++;
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */
function Config(good_length, max_lazy, nice_length, max_chain, func) {
  this.good_length = good_length;
  this.max_lazy = max_lazy;
  this.nice_length = nice_length;
  this.max_chain = max_chain;
  this.func = func;
}

var configuration_table;

configuration_table = [
  /*      good lazy nice chain */
  new Config(0, 0, 0, 0, deflate_stored),          /* 0 store only */
  new Config(4, 4, 8, 4, deflate_fast),            /* 1 max speed, no lazy matches */
  new Config(4, 5, 16, 8, deflate_fast),           /* 2 */
  new Config(4, 6, 32, 32, deflate_fast),          /* 3 */

  new Config(4, 4, 16, 16, deflate_slow),          /* 4 lazy matches */
  new Config(8, 16, 32, 32, deflate_slow),         /* 5 */
  new Config(8, 16, 128, 128, deflate_slow),       /* 6 */
  new Config(8, 32, 128, 256, deflate_slow),       /* 7 */
  new Config(32, 128, 258, 1024, deflate_slow),    /* 8 */
  new Config(32, 258, 258, 4096, deflate_slow)     /* 9 max compression */
];


/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */
function lm_init(s) {
  s.window_size = 2 * s.w_size;

  /*** CLEAR_HASH(s); ***/
  zero(s.head); // Fill with NIL (= 0);

  /* Set the default configuration parameters:
   */
  s.max_lazy_match = configuration_table[s.level].max_lazy;
  s.good_match = configuration_table[s.level].good_length;
  s.nice_match = configuration_table[s.level].nice_length;
  s.max_chain_length = configuration_table[s.level].max_chain;

  s.strstart = 0;
  s.block_start = 0;
  s.lookahead = 0;
  s.insert = 0;
  s.match_length = s.prev_length = MIN_MATCH - 1;
  s.match_available = 0;
  s.ins_h = 0;
}


function DeflateState() {
  this.strm = null;            /* pointer back to this zlib stream */
  this.status = 0;            /* as the name implies */
  this.pending_buf = null;      /* output still pending */
  this.pending_buf_size = 0;  /* size of pending_buf */
  this.pending_out = 0;       /* next pending byte to output to the stream */
  this.pending = 0;           /* nb of bytes in the pending buffer */
  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
  this.gzhead = null;         /* gzip header information to write */
  this.gzindex = 0;           /* where in extra, name, or comment */
  this.method = Z_DEFLATED; /* can only be DEFLATED */
  this.last_flush = -1;   /* value of flush param for previous deflate call */

  this.w_size = 0;  /* LZ77 window size (32K by default) */
  this.w_bits = 0;  /* log2(w_size)  (8..16) */
  this.w_mask = 0;  /* w_size - 1 */

  this.window = null;
  /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */

  this.window_size = 0;
  /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */

  this.prev = null;
  /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */

  this.head = null;   /* Heads of the hash chains or NIL. */

  this.ins_h = 0;       /* hash index of string to be inserted */
  this.hash_size = 0;   /* number of elements in hash table */
  this.hash_bits = 0;   /* log2(hash_size) */
  this.hash_mask = 0;   /* hash_size-1 */

  this.hash_shift = 0;
  /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */

  this.block_start = 0;
  /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */

  this.match_length = 0;      /* length of best match */
  this.prev_match = 0;        /* previous match */
  this.match_available = 0;   /* set if previous match exists */
  this.strstart = 0;          /* start of string to insert */
  this.match_start = 0;       /* start of matching string */
  this.lookahead = 0;         /* number of valid bytes ahead in window */

  this.prev_length = 0;
  /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */

  this.max_chain_length = 0;
  /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */

  this.max_lazy_match = 0;
  /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */
  // That's alias to max_lazy_match, don't use directly
  //this.max_insert_length = 0;
  /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */

  this.level = 0;     /* compression level (1..9) */
  this.strategy = 0;  /* favor or force Huffman coding*/

  this.good_match = 0;
  /* Use a faster search when the previous match is longer than this */

  this.nice_match = 0; /* Stop searching when current match exceeds this */

              /* used by trees.c: */

  /* Didn't use ct_data typedef below to suppress compiler warning */

  // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
  // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
  // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */

  // Use flat array of DOUBLE size, with interleaved fata,
  // because JS does not support effective
  this.dyn_ltree  = new utils.Buf16(HEAP_SIZE * 2);
  this.dyn_dtree  = new utils.Buf16((2 * D_CODES + 1) * 2);
  this.bl_tree    = new utils.Buf16((2 * BL_CODES + 1) * 2);
  zero(this.dyn_ltree);
  zero(this.dyn_dtree);
  zero(this.bl_tree);

  this.l_desc   = null;         /* desc. for literal tree */
  this.d_desc   = null;         /* desc. for distance tree */
  this.bl_desc  = null;         /* desc. for bit length tree */

  //ush bl_count[MAX_BITS+1];
  this.bl_count = new utils.Buf16(MAX_BITS + 1);
  /* number of codes at each bit length for an optimal tree */

  //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
  this.heap = new utils.Buf16(2 * L_CODES + 1);  /* heap used to build the Huffman trees */
  zero(this.heap);

  this.heap_len = 0;               /* number of elements in the heap */
  this.heap_max = 0;               /* element of largest frequency */
  /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */

  this.depth = new utils.Buf16(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
  zero(this.depth);
  /* Depth of each subtree used as tie breaker for trees of equal frequency
   */

  this.l_buf = 0;          /* buffer index for literals or lengths */

  this.lit_bufsize = 0;
  /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */

  this.last_lit = 0;      /* running index in l_buf */

  this.d_buf = 0;
  /* Buffer index for distances. To simplify the code, d_buf and l_buf have
   * the same number of elements. To use different lengths, an extra flag
   * array would be necessary.
   */

  this.opt_len = 0;       /* bit length of current block with optimal trees */
  this.static_len = 0;    /* bit length of current block with static trees */
  this.matches = 0;       /* number of string matches in current block */
  this.insert = 0;        /* bytes at end of window left to insert */


  this.bi_buf = 0;
  /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */
  this.bi_valid = 0;
  /* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */

  // Used for window memory init. We safely ignore it for JS. That makes
  // sense only for pointers and memory check tools.
  //this.high_water = 0;
  /* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */
}


function deflateResetKeep(strm) {
  var s;

  if (!strm || !strm.state) {
    return err(strm, Z_STREAM_ERROR);
  }

  strm.total_in = strm.total_out = 0;
  strm.data_type = Z_UNKNOWN;

  s = strm.state;
  s.pending = 0;
  s.pending_out = 0;

  if (s.wrap < 0) {
    s.wrap = -s.wrap;
    /* was made negative by deflate(..., Z_FINISH); */
  }
  s.status = (s.wrap ? INIT_STATE : BUSY_STATE);
  strm.adler = (s.wrap === 2) ?
    0  // crc32(0, Z_NULL, 0)
  :
    1; // adler32(0, Z_NULL, 0)
  s.last_flush = Z_NO_FLUSH;
  trees._tr_init(s);
  return Z_OK;
}


function deflateReset(strm) {
  var ret = deflateResetKeep(strm);
  if (ret === Z_OK) {
    lm_init(strm.state);
  }
  return ret;
}


function deflateSetHeader(strm, head) {
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  if (strm.state.wrap !== 2) { return Z_STREAM_ERROR; }
  strm.state.gzhead = head;
  return Z_OK;
}


function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
  if (!strm) { // === Z_NULL
    return Z_STREAM_ERROR;
  }
  var wrap = 1;

  if (level === Z_DEFAULT_COMPRESSION) {
    level = 6;
  }

  if (windowBits < 0) { /* suppress zlib wrapper */
    wrap = 0;
    windowBits = -windowBits;
  }

  else if (windowBits > 15) {
    wrap = 2;           /* write gzip wrapper instead */
    windowBits -= 16;
  }


  if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED ||
    windowBits < 8 || windowBits > 15 || level < 0 || level > 9 ||
    strategy < 0 || strategy > Z_FIXED) {
    return err(strm, Z_STREAM_ERROR);
  }


  if (windowBits === 8) {
    windowBits = 9;
  }
  /* until 256-byte window bug fixed */

  var s = new DeflateState();

  strm.state = s;
  s.strm = strm;

  s.wrap = wrap;
  s.gzhead = null;
  s.w_bits = windowBits;
  s.w_size = 1 << s.w_bits;
  s.w_mask = s.w_size - 1;

  s.hash_bits = memLevel + 7;
  s.hash_size = 1 << s.hash_bits;
  s.hash_mask = s.hash_size - 1;
  s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);

  s.window = new utils.Buf8(s.w_size * 2);
  s.head = new utils.Buf16(s.hash_size);
  s.prev = new utils.Buf16(s.w_size);

  // Don't need mem init magic for JS.
  //s.high_water = 0;  /* nothing written to s->window yet */

  s.lit_bufsize = 1 << (memLevel + 6); /* 16K elements by default */

  s.pending_buf_size = s.lit_bufsize * 4;

  //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
  //s->pending_buf = (uchf *) overlay;
  s.pending_buf = new utils.Buf8(s.pending_buf_size);

  // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
  //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
  s.d_buf = 1 * s.lit_bufsize;

  //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
  s.l_buf = (1 + 2) * s.lit_bufsize;

  s.level = level;
  s.strategy = strategy;
  s.method = method;

  return deflateReset(strm);
}

function deflateInit(strm, level) {
  return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
}


function deflate(strm, flush) {
  var old_flush, s;
  var beg, val; // for gzip header write only

  if (!strm || !strm.state ||
    flush > Z_BLOCK || flush < 0) {
    return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
  }

  s = strm.state;

  if (!strm.output ||
      (!strm.input && strm.avail_in !== 0) ||
      (s.status === FINISH_STATE && flush !== Z_FINISH)) {
    return err(strm, (strm.avail_out === 0) ? Z_BUF_ERROR : Z_STREAM_ERROR);
  }

  s.strm = strm; /* just in case */
  old_flush = s.last_flush;
  s.last_flush = flush;

  /* Write the header */
  if (s.status === INIT_STATE) {

    if (s.wrap === 2) { // GZIP header
      strm.adler = 0;  //crc32(0L, Z_NULL, 0);
      put_byte(s, 31);
      put_byte(s, 139);
      put_byte(s, 8);
      if (!s.gzhead) { // s->gzhead == Z_NULL
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, s.level === 9 ? 2 :
                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
                     4 : 0));
        put_byte(s, OS_CODE);
        s.status = BUSY_STATE;
      }
      else {
        put_byte(s, (s.gzhead.text ? 1 : 0) +
                    (s.gzhead.hcrc ? 2 : 0) +
                    (!s.gzhead.extra ? 0 : 4) +
                    (!s.gzhead.name ? 0 : 8) +
                    (!s.gzhead.comment ? 0 : 16)
        );
        put_byte(s, s.gzhead.time & 0xff);
        put_byte(s, (s.gzhead.time >> 8) & 0xff);
        put_byte(s, (s.gzhead.time >> 16) & 0xff);
        put_byte(s, (s.gzhead.time >> 24) & 0xff);
        put_byte(s, s.level === 9 ? 2 :
                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
                     4 : 0));
        put_byte(s, s.gzhead.os & 0xff);
        if (s.gzhead.extra && s.gzhead.extra.length) {
          put_byte(s, s.gzhead.extra.length & 0xff);
          put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
        }
        if (s.gzhead.hcrc) {
          strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
        }
        s.gzindex = 0;
        s.status = EXTRA_STATE;
      }
    }
    else // DEFLATE header
    {
      var header = (Z_DEFLATED + ((s.w_bits - 8) << 4)) << 8;
      var level_flags = -1;

      if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
        level_flags = 0;
      } else if (s.level < 6) {
        level_flags = 1;
      } else if (s.level === 6) {
        level_flags = 2;
      } else {
        level_flags = 3;
      }
      header |= (level_flags << 6);
      if (s.strstart !== 0) { header |= PRESET_DICT; }
      header += 31 - (header % 31);

      s.status = BUSY_STATE;
      putShortMSB(s, header);

      /* Save the adler32 of the preset dictionary: */
      if (s.strstart !== 0) {
        putShortMSB(s, strm.adler >>> 16);
        putShortMSB(s, strm.adler & 0xffff);
      }
      strm.adler = 1; // adler32(0L, Z_NULL, 0);
    }
  }

//#ifdef GZIP
  if (s.status === EXTRA_STATE) {
    if (s.gzhead.extra/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */

      while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            break;
          }
        }
        put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
        s.gzindex++;
      }
      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (s.gzindex === s.gzhead.extra.length) {
        s.gzindex = 0;
        s.status = NAME_STATE;
      }
    }
    else {
      s.status = NAME_STATE;
    }
  }
  if (s.status === NAME_STATE) {
    if (s.gzhead.name/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */
      //int val;

      do {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            val = 1;
            break;
          }
        }
        // JS specific: little magic to add zero terminator to end of string
        if (s.gzindex < s.gzhead.name.length) {
          val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
        } else {
          val = 0;
        }
        put_byte(s, val);
      } while (val !== 0);

      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (val === 0) {
        s.gzindex = 0;
        s.status = COMMENT_STATE;
      }
    }
    else {
      s.status = COMMENT_STATE;
    }
  }
  if (s.status === COMMENT_STATE) {
    if (s.gzhead.comment/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */
      //int val;

      do {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            val = 1;
            break;
          }
        }
        // JS specific: little magic to add zero terminator to end of string
        if (s.gzindex < s.gzhead.comment.length) {
          val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
        } else {
          val = 0;
        }
        put_byte(s, val);
      } while (val !== 0);

      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (val === 0) {
        s.status = HCRC_STATE;
      }
    }
    else {
      s.status = HCRC_STATE;
    }
  }
  if (s.status === HCRC_STATE) {
    if (s.gzhead.hcrc) {
      if (s.pending + 2 > s.pending_buf_size) {
        flush_pending(strm);
      }
      if (s.pending + 2 <= s.pending_buf_size) {
        put_byte(s, strm.adler & 0xff);
        put_byte(s, (strm.adler >> 8) & 0xff);
        strm.adler = 0; //crc32(0L, Z_NULL, 0);
        s.status = BUSY_STATE;
      }
    }
    else {
      s.status = BUSY_STATE;
    }
  }
//#endif

  /* Flush as much pending output as possible */
  if (s.pending !== 0) {
    flush_pending(strm);
    if (strm.avail_out === 0) {
      /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */
      s.last_flush = -1;
      return Z_OK;
    }

    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */
  } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) &&
    flush !== Z_FINISH) {
    return err(strm, Z_BUF_ERROR);
  }

  /* User must not provide more input after the first FINISH: */
  if (s.status === FINISH_STATE && strm.avail_in !== 0) {
    return err(strm, Z_BUF_ERROR);
  }

  /* Start a new block or continue the current one.
   */
  if (strm.avail_in !== 0 || s.lookahead !== 0 ||
    (flush !== Z_NO_FLUSH && s.status !== FINISH_STATE)) {
    var bstate = (s.strategy === Z_HUFFMAN_ONLY) ? deflate_huff(s, flush) :
      (s.strategy === Z_RLE ? deflate_rle(s, flush) :
        configuration_table[s.level].func(s, flush));

    if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
      s.status = FINISH_STATE;
    }
    if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
      if (strm.avail_out === 0) {
        s.last_flush = -1;
        /* avoid BUF_ERROR next call, see above */
      }
      return Z_OK;
      /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */
    }
    if (bstate === BS_BLOCK_DONE) {
      if (flush === Z_PARTIAL_FLUSH) {
        trees._tr_align(s);
      }
      else if (flush !== Z_BLOCK) { /* FULL_FLUSH or SYNC_FLUSH */

        trees._tr_stored_block(s, 0, 0, false);
        /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */
        if (flush === Z_FULL_FLUSH) {
          /*** CLEAR_HASH(s); ***/             /* forget history */
          zero(s.head); // Fill with NIL (= 0);

          if (s.lookahead === 0) {
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
          }
        }
      }
      flush_pending(strm);
      if (strm.avail_out === 0) {
        s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */
        return Z_OK;
      }
    }
  }
  //Assert(strm->avail_out > 0, "bug2");
  //if (strm.avail_out <= 0) { throw new Error("bug2");}

  if (flush !== Z_FINISH) { return Z_OK; }
  if (s.wrap <= 0) { return Z_STREAM_END; }

  /* Write the trailer */
  if (s.wrap === 2) {
    put_byte(s, strm.adler & 0xff);
    put_byte(s, (strm.adler >> 8) & 0xff);
    put_byte(s, (strm.adler >> 16) & 0xff);
    put_byte(s, (strm.adler >> 24) & 0xff);
    put_byte(s, strm.total_in & 0xff);
    put_byte(s, (strm.total_in >> 8) & 0xff);
    put_byte(s, (strm.total_in >> 16) & 0xff);
    put_byte(s, (strm.total_in >> 24) & 0xff);
  }
  else
  {
    putShortMSB(s, strm.adler >>> 16);
    putShortMSB(s, strm.adler & 0xffff);
  }

  flush_pending(strm);
  /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */
  if (s.wrap > 0) { s.wrap = -s.wrap; }
  /* write the trailer only once! */
  return s.pending !== 0 ? Z_OK : Z_STREAM_END;
}

function deflateEnd(strm) {
  var status;

  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
    return Z_STREAM_ERROR;
  }

  status = strm.state.status;
  if (status !== INIT_STATE &&
    status !== EXTRA_STATE &&
    status !== NAME_STATE &&
    status !== COMMENT_STATE &&
    status !== HCRC_STATE &&
    status !== BUSY_STATE &&
    status !== FINISH_STATE
  ) {
    return err(strm, Z_STREAM_ERROR);
  }

  strm.state = null;

  return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
}


/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */
function deflateSetDictionary(strm, dictionary) {
  var dictLength = dictionary.length;

  var s;
  var str, n;
  var wrap;
  var avail;
  var next;
  var input;
  var tmpDict;

  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
    return Z_STREAM_ERROR;
  }

  s = strm.state;
  wrap = s.wrap;

  if (wrap === 2 || (wrap === 1 && s.status !== INIT_STATE) || s.lookahead) {
    return Z_STREAM_ERROR;
  }

  /* when using zlib wrappers, compute Adler-32 for provided dictionary */
  if (wrap === 1) {
    /* adler32(strm->adler, dictionary, dictLength); */
    strm.adler = adler32(strm.adler, dictionary, dictLength, 0);
  }

  s.wrap = 0;   /* avoid computing Adler-32 in read_buf */

  /* if dictionary would fill window, just replace the history */
  if (dictLength >= s.w_size) {
    if (wrap === 0) {            /* already empty otherwise */
      /*** CLEAR_HASH(s); ***/
      zero(s.head); // Fill with NIL (= 0);
      s.strstart = 0;
      s.block_start = 0;
      s.insert = 0;
    }
    /* use the tail */
    // dictionary = dictionary.slice(dictLength - s.w_size);
    tmpDict = new utils.Buf8(s.w_size);
    utils.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
    dictionary = tmpDict;
    dictLength = s.w_size;
  }
  /* insert dictionary into window and hash */
  avail = strm.avail_in;
  next = strm.next_in;
  input = strm.input;
  strm.avail_in = dictLength;
  strm.next_in = 0;
  strm.input = dictionary;
  fill_window(s);
  while (s.lookahead >= MIN_MATCH) {
    str = s.strstart;
    n = s.lookahead - (MIN_MATCH - 1);
    do {
      /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;

      s.prev[str & s.w_mask] = s.head[s.ins_h];

      s.head[s.ins_h] = str;
      str++;
    } while (--n);
    s.strstart = str;
    s.lookahead = MIN_MATCH - 1;
    fill_window(s);
  }
  s.strstart += s.lookahead;
  s.block_start = s.strstart;
  s.insert = s.lookahead;
  s.lookahead = 0;
  s.match_length = s.prev_length = MIN_MATCH - 1;
  s.match_available = 0;
  strm.next_in = next;
  strm.input = input;
  strm.avail_in = avail;
  s.wrap = wrap;
  return Z_OK;
}


exports.deflateInit = deflateInit;
exports.deflateInit2 = deflateInit2;
exports.deflateReset = deflateReset;
exports.deflateResetKeep = deflateResetKeep;
exports.deflateSetHeader = deflateSetHeader;
exports.deflate = deflate;
exports.deflateEnd = deflateEnd;
exports.deflateSetDictionary = deflateSetDictionary;
exports.deflateInfo = 'pako deflate (from Nodeca project)';

/* Not implemented
exports.deflateBound = deflateBound;
exports.deflateCopy = deflateCopy;
exports.deflateParams = deflateParams;
exports.deflatePending = deflatePending;
exports.deflatePrime = deflatePrime;
exports.deflateTune = deflateTune;
*/

},{"../utils/common":1170,"./adler32":1171,"./crc32":1173,"./messages":1178,"./trees":1179}],1175:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

// See state defs from inflate.js
var BAD = 30;       /* got a data error -- remain here until reset */
var TYPE = 12;      /* i: waiting for type bits, including last-flag bit */

/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */
module.exports = function inflate_fast(strm, start) {
  var state;
  var _in;                    /* local strm.input */
  var last;                   /* have enough input while in < last */
  var _out;                   /* local strm.output */
  var beg;                    /* inflate()'s initial strm.output */
  var end;                    /* while out < end, enough space available */
//#ifdef INFLATE_STRICT
  var dmax;                   /* maximum distance from zlib header */
//#endif
  var wsize;                  /* window size or zero if not using window */
  var whave;                  /* valid bytes in the window */
  var wnext;                  /* window write index */
  // Use `s_window` instead `window`, avoid conflict with instrumentation tools
  var s_window;               /* allocated sliding window, if wsize != 0 */
  var hold;                   /* local strm.hold */
  var bits;                   /* local strm.bits */
  var lcode;                  /* local strm.lencode */
  var dcode;                  /* local strm.distcode */
  var lmask;                  /* mask for first level of length codes */
  var dmask;                  /* mask for first level of distance codes */
  var here;                   /* retrieved table entry */
  var op;                     /* code bits, operation, extra bits, or */
                              /*  window position, window bytes to copy */
  var len;                    /* match length, unused bytes */
  var dist;                   /* match distance */
  var from;                   /* where to copy match from */
  var from_source;


  var input, output; // JS specific, because we have no pointers

  /* copy state to local variables */
  state = strm.state;
  //here = state.here;
  _in = strm.next_in;
  input = strm.input;
  last = _in + (strm.avail_in - 5);
  _out = strm.next_out;
  output = strm.output;
  beg = _out - (start - strm.avail_out);
  end = _out + (strm.avail_out - 257);
//#ifdef INFLATE_STRICT
  dmax = state.dmax;
//#endif
  wsize = state.wsize;
  whave = state.whave;
  wnext = state.wnext;
  s_window = state.window;
  hold = state.hold;
  bits = state.bits;
  lcode = state.lencode;
  dcode = state.distcode;
  lmask = (1 << state.lenbits) - 1;
  dmask = (1 << state.distbits) - 1;


  /* decode literals and length/distances until end-of-block or not enough
     input data or output space */

  top:
  do {
    if (bits < 15) {
      hold += input[_in++] << bits;
      bits += 8;
      hold += input[_in++] << bits;
      bits += 8;
    }

    here = lcode[hold & lmask];

    dolen:
    for (;;) { // Goto emulation
      op = here >>> 24/*here.bits*/;
      hold >>>= op;
      bits -= op;
      op = (here >>> 16) & 0xff/*here.op*/;
      if (op === 0) {                          /* literal */
        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
        //        "inflate:         literal '%c'\n" :
        //        "inflate:         literal 0x%02x\n", here.val));
        output[_out++] = here & 0xffff/*here.val*/;
      }
      else if (op & 16) {                     /* length base */
        len = here & 0xffff/*here.val*/;
        op &= 15;                           /* number of extra bits */
        if (op) {
          if (bits < op) {
            hold += input[_in++] << bits;
            bits += 8;
          }
          len += hold & ((1 << op) - 1);
          hold >>>= op;
          bits -= op;
        }
        //Tracevv((stderr, "inflate:         length %u\n", len));
        if (bits < 15) {
          hold += input[_in++] << bits;
          bits += 8;
          hold += input[_in++] << bits;
          bits += 8;
        }
        here = dcode[hold & dmask];

        dodist:
        for (;;) { // goto emulation
          op = here >>> 24/*here.bits*/;
          hold >>>= op;
          bits -= op;
          op = (here >>> 16) & 0xff/*here.op*/;

          if (op & 16) {                      /* distance base */
            dist = here & 0xffff/*here.val*/;
            op &= 15;                       /* number of extra bits */
            if (bits < op) {
              hold += input[_in++] << bits;
              bits += 8;
              if (bits < op) {
                hold += input[_in++] << bits;
                bits += 8;
              }
            }
            dist += hold & ((1 << op) - 1);
//#ifdef INFLATE_STRICT
            if (dist > dmax) {
              strm.msg = 'invalid distance too far back';
              state.mode = BAD;
              break top;
            }
//#endif
            hold >>>= op;
            bits -= op;
            //Tracevv((stderr, "inflate:         distance %u\n", dist));
            op = _out - beg;                /* max distance in output */
            if (dist > op) {                /* see if copy from window */
              op = dist - op;               /* distance back in window */
              if (op > whave) {
                if (state.sane) {
                  strm.msg = 'invalid distance too far back';
                  state.mode = BAD;
                  break top;
                }

// (!) This block is disabled in zlib defaults,
// don't enable it for binary compatibility
//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
//                if (len <= op - whave) {
//                  do {
//                    output[_out++] = 0;
//                  } while (--len);
//                  continue top;
//                }
//                len -= op - whave;
//                do {
//                  output[_out++] = 0;
//                } while (--op > whave);
//                if (op === 0) {
//                  from = _out - dist;
//                  do {
//                    output[_out++] = output[from++];
//                  } while (--len);
//                  continue top;
//                }
//#endif
              }
              from = 0; // window index
              from_source = s_window;
              if (wnext === 0) {           /* very common case */
                from += wsize - op;
                if (op < len) {         /* some from window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = _out - dist;  /* rest from output */
                  from_source = output;
                }
              }
              else if (wnext < op) {      /* wrap around window */
                from += wsize + wnext - op;
                op -= wnext;
                if (op < len) {         /* some from end of window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = 0;
                  if (wnext < len) {  /* some from start of window */
                    op = wnext;
                    len -= op;
                    do {
                      output[_out++] = s_window[from++];
                    } while (--op);
                    from = _out - dist;      /* rest from output */
                    from_source = output;
                  }
                }
              }
              else {                      /* contiguous in window */
                from += wnext - op;
                if (op < len) {         /* some from window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = _out - dist;  /* rest from output */
                  from_source = output;
                }
              }
              while (len > 2) {
                output[_out++] = from_source[from++];
                output[_out++] = from_source[from++];
                output[_out++] = from_source[from++];
                len -= 3;
              }
              if (len) {
                output[_out++] = from_source[from++];
                if (len > 1) {
                  output[_out++] = from_source[from++];
                }
              }
            }
            else {
              from = _out - dist;          /* copy direct from output */
              do {                        /* minimum length is three */
                output[_out++] = output[from++];
                output[_out++] = output[from++];
                output[_out++] = output[from++];
                len -= 3;
              } while (len > 2);
              if (len) {
                output[_out++] = output[from++];
                if (len > 1) {
                  output[_out++] = output[from++];
                }
              }
            }
          }
          else if ((op & 64) === 0) {          /* 2nd level distance code */
            here = dcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
            continue dodist;
          }
          else {
            strm.msg = 'invalid distance code';
            state.mode = BAD;
            break top;
          }

          break; // need to emulate goto via "continue"
        }
      }
      else if ((op & 64) === 0) {              /* 2nd level length code */
        here = lcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
        continue dolen;
      }
      else if (op & 32) {                     /* end-of-block */
        //Tracevv((stderr, "inflate:         end of block\n"));
        state.mode = TYPE;
        break top;
      }
      else {
        strm.msg = 'invalid literal/length code';
        state.mode = BAD;
        break top;
      }

      break; // need to emulate goto via "continue"
    }
  } while (_in < last && _out < end);

  /* return unused bytes (on entry, bits < 8, so in won't go too far back) */
  len = bits >> 3;
  _in -= len;
  bits -= len << 3;
  hold &= (1 << bits) - 1;

  /* update state and return */
  strm.next_in = _in;
  strm.next_out = _out;
  strm.avail_in = (_in < last ? 5 + (last - _in) : 5 - (_in - last));
  strm.avail_out = (_out < end ? 257 + (end - _out) : 257 - (_out - end));
  state.hold = hold;
  state.bits = bits;
  return;
};

},{}],1176:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var utils         = require('../utils/common');
var adler32       = require('./adler32');
var crc32         = require('./crc32');
var inflate_fast  = require('./inffast');
var inflate_table = require('./inftrees');

var CODES = 0;
var LENS = 1;
var DISTS = 2;

/* Public constants ==========================================================*/
/* ===========================================================================*/


/* Allowed flush values; see deflate() and inflate() below for details */
//var Z_NO_FLUSH      = 0;
//var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
//var Z_FULL_FLUSH    = 3;
var Z_FINISH        = 4;
var Z_BLOCK         = 5;
var Z_TREES         = 6;


/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */
var Z_OK            = 0;
var Z_STREAM_END    = 1;
var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var Z_STREAM_ERROR  = -2;
var Z_DATA_ERROR    = -3;
var Z_MEM_ERROR     = -4;
var Z_BUF_ERROR     = -5;
//var Z_VERSION_ERROR = -6;

/* The deflate compression method */
var Z_DEFLATED  = 8;


/* STATES ====================================================================*/
/* ===========================================================================*/


var    HEAD = 1;       /* i: waiting for magic header */
var    FLAGS = 2;      /* i: waiting for method and flags (gzip) */
var    TIME = 3;       /* i: waiting for modification time (gzip) */
var    OS = 4;         /* i: waiting for extra flags and operating system (gzip) */
var    EXLEN = 5;      /* i: waiting for extra length (gzip) */
var    EXTRA = 6;      /* i: waiting for extra bytes (gzip) */
var    NAME = 7;       /* i: waiting for end of file name (gzip) */
var    COMMENT = 8;    /* i: waiting for end of comment (gzip) */
var    HCRC = 9;       /* i: waiting for header crc (gzip) */
var    DICTID = 10;    /* i: waiting for dictionary check value */
var    DICT = 11;      /* waiting for inflateSetDictionary() call */
var        TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
var        TYPEDO = 13;    /* i: same, but skip check to exit inflate on new block */
var        STORED = 14;    /* i: waiting for stored size (length and complement) */
var        COPY_ = 15;     /* i/o: same as COPY below, but only first time in */
var        COPY = 16;      /* i/o: waiting for input or output to copy stored block */
var        TABLE = 17;     /* i: waiting for dynamic block table lengths */
var        LENLENS = 18;   /* i: waiting for code length code lengths */
var        CODELENS = 19;  /* i: waiting for length/lit and distance code lengths */
var            LEN_ = 20;      /* i: same as LEN below, but only first time in */
var            LEN = 21;       /* i: waiting for length/lit/eob code */
var            LENEXT = 22;    /* i: waiting for length extra bits */
var            DIST = 23;      /* i: waiting for distance code */
var            DISTEXT = 24;   /* i: waiting for distance extra bits */
var            MATCH = 25;     /* o: waiting for output space to copy string */
var            LIT = 26;       /* o: waiting for output space to write literal */
var    CHECK = 27;     /* i: waiting for 32-bit check value */
var    LENGTH = 28;    /* i: waiting for 32-bit length (gzip) */
var    DONE = 29;      /* finished check, done -- remain here until reset */
var    BAD = 30;       /* got a data error -- remain here until reset */
var    MEM = 31;       /* got an inflate() memory error -- remain here until reset */
var    SYNC = 32;      /* looking for synchronization bytes to restart inflate() */

/* ===========================================================================*/



var ENOUGH_LENS = 852;
var ENOUGH_DISTS = 592;
//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);

var MAX_WBITS = 15;
/* 32K LZ77 window */
var DEF_WBITS = MAX_WBITS;


function zswap32(q) {
  return  (((q >>> 24) & 0xff) +
          ((q >>> 8) & 0xff00) +
          ((q & 0xff00) << 8) +
          ((q & 0xff) << 24));
}


function InflateState() {
  this.mode = 0;             /* current inflate mode */
  this.last = false;          /* true if processing last block */
  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
  this.havedict = false;      /* true if dictionary provided */
  this.flags = 0;             /* gzip header method and flags (0 if zlib) */
  this.dmax = 0;              /* zlib header max distance (INFLATE_STRICT) */
  this.check = 0;             /* protected copy of check value */
  this.total = 0;             /* protected copy of output count */
  // TODO: may be {}
  this.head = null;           /* where to save gzip header information */

  /* sliding window */
  this.wbits = 0;             /* log base 2 of requested window size */
  this.wsize = 0;             /* window size or zero if not using window */
  this.whave = 0;             /* valid bytes in the window */
  this.wnext = 0;             /* window write index */
  this.window = null;         /* allocated sliding window, if needed */

  /* bit accumulator */
  this.hold = 0;              /* input bit accumulator */
  this.bits = 0;              /* number of bits in "in" */

  /* for string and stored block copying */
  this.length = 0;            /* literal or length of data to copy */
  this.offset = 0;            /* distance back to copy string from */

  /* for table and code decoding */
  this.extra = 0;             /* extra bits needed */

  /* fixed and dynamic code tables */
  this.lencode = null;          /* starting table for length/literal codes */
  this.distcode = null;         /* starting table for distance codes */
  this.lenbits = 0;           /* index bits for lencode */
  this.distbits = 0;          /* index bits for distcode */

  /* dynamic table building */
  this.ncode = 0;             /* number of code length code lengths */
  this.nlen = 0;              /* number of length code lengths */
  this.ndist = 0;             /* number of distance code lengths */
  this.have = 0;              /* number of code lengths in lens[] */
  this.next = null;              /* next available space in codes[] */

  this.lens = new utils.Buf16(320); /* temporary storage for code lengths */
  this.work = new utils.Buf16(288); /* work area for code table building */

  /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */
  //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
  this.lendyn = null;              /* dynamic table for length/literal codes (JS specific) */
  this.distdyn = null;             /* dynamic table for distance codes (JS specific) */
  this.sane = 0;                   /* if false, allow invalid distance too far */
  this.back = 0;                   /* bits back of last unprocessed length/lit */
  this.was = 0;                    /* initial length of match */
}

function inflateResetKeep(strm) {
  var state;

  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  strm.total_in = strm.total_out = state.total = 0;
  strm.msg = ''; /*Z_NULL*/
  if (state.wrap) {       /* to support ill-conceived Java test suite */
    strm.adler = state.wrap & 1;
  }
  state.mode = HEAD;
  state.last = 0;
  state.havedict = 0;
  state.dmax = 32768;
  state.head = null/*Z_NULL*/;
  state.hold = 0;
  state.bits = 0;
  //state.lencode = state.distcode = state.next = state.codes;
  state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
  state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);

  state.sane = 1;
  state.back = -1;
  //Tracev((stderr, "inflate: reset\n"));
  return Z_OK;
}

function inflateReset(strm) {
  var state;

  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  state.wsize = 0;
  state.whave = 0;
  state.wnext = 0;
  return inflateResetKeep(strm);

}

function inflateReset2(strm, windowBits) {
  var wrap;
  var state;

  /* get the state */
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;

  /* extract wrap request from windowBits parameter */
  if (windowBits < 0) {
    wrap = 0;
    windowBits = -windowBits;
  }
  else {
    wrap = (windowBits >> 4) + 1;
    if (windowBits < 48) {
      windowBits &= 15;
    }
  }

  /* set number of window bits, free window if different */
  if (windowBits && (windowBits < 8 || windowBits > 15)) {
    return Z_STREAM_ERROR;
  }
  if (state.window !== null && state.wbits !== windowBits) {
    state.window = null;
  }

  /* update state and reset the rest of it */
  state.wrap = wrap;
  state.wbits = windowBits;
  return inflateReset(strm);
}

function inflateInit2(strm, windowBits) {
  var ret;
  var state;

  if (!strm) { return Z_STREAM_ERROR; }
  //strm.msg = Z_NULL;                 /* in case we return an error */

  state = new InflateState();

  //if (state === Z_NULL) return Z_MEM_ERROR;
  //Tracev((stderr, "inflate: allocated\n"));
  strm.state = state;
  state.window = null/*Z_NULL*/;
  ret = inflateReset2(strm, windowBits);
  if (ret !== Z_OK) {
    strm.state = null/*Z_NULL*/;
  }
  return ret;
}

function inflateInit(strm) {
  return inflateInit2(strm, DEF_WBITS);
}


/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */
var virgin = true;

var lenfix, distfix; // We have no pointers in JS, so keep tables separate

function fixedtables(state) {
  /* build fixed huffman tables if first call (may not be thread safe) */
  if (virgin) {
    var sym;

    lenfix = new utils.Buf32(512);
    distfix = new utils.Buf32(32);

    /* literal/length table */
    sym = 0;
    while (sym < 144) { state.lens[sym++] = 8; }
    while (sym < 256) { state.lens[sym++] = 9; }
    while (sym < 280) { state.lens[sym++] = 7; }
    while (sym < 288) { state.lens[sym++] = 8; }

    inflate_table(LENS,  state.lens, 0, 288, lenfix,   0, state.work, { bits: 9 });

    /* distance table */
    sym = 0;
    while (sym < 32) { state.lens[sym++] = 5; }

    inflate_table(DISTS, state.lens, 0, 32,   distfix, 0, state.work, { bits: 5 });

    /* do this just once */
    virgin = false;
  }

  state.lencode = lenfix;
  state.lenbits = 9;
  state.distcode = distfix;
  state.distbits = 5;
}


/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */
function updatewindow(strm, src, end, copy) {
  var dist;
  var state = strm.state;

  /* if it hasn't been done already, allocate space for the window */
  if (state.window === null) {
    state.wsize = 1 << state.wbits;
    state.wnext = 0;
    state.whave = 0;

    state.window = new utils.Buf8(state.wsize);
  }

  /* copy state->wsize or less output bytes into the circular window */
  if (copy >= state.wsize) {
    utils.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
    state.wnext = 0;
    state.whave = state.wsize;
  }
  else {
    dist = state.wsize - state.wnext;
    if (dist > copy) {
      dist = copy;
    }
    //zmemcpy(state->window + state->wnext, end - copy, dist);
    utils.arraySet(state.window, src, end - copy, dist, state.wnext);
    copy -= dist;
    if (copy) {
      //zmemcpy(state->window, end - copy, copy);
      utils.arraySet(state.window, src, end - copy, copy, 0);
      state.wnext = copy;
      state.whave = state.wsize;
    }
    else {
      state.wnext += dist;
      if (state.wnext === state.wsize) { state.wnext = 0; }
      if (state.whave < state.wsize) { state.whave += dist; }
    }
  }
  return 0;
}

function inflate(strm, flush) {
  var state;
  var input, output;          // input/output buffers
  var next;                   /* next input INDEX */
  var put;                    /* next output INDEX */
  var have, left;             /* available input and output */
  var hold;                   /* bit buffer */
  var bits;                   /* bits in bit buffer */
  var _in, _out;              /* save starting available input and output */
  var copy;                   /* number of stored or match bytes to copy */
  var from;                   /* where to copy match bytes from */
  var from_source;
  var here = 0;               /* current decoding table entry */
  var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
  //var last;                   /* parent table entry */
  var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
  var len;                    /* length to copy for repeats, bits to drop */
  var ret;                    /* return code */
  var hbuf = new utils.Buf8(4);    /* buffer for gzip header crc calculation */
  var opts;

  var n; // temporary var for NEED_BITS

  var order = /* permutation of code lengths */
    [ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ];


  if (!strm || !strm.state || !strm.output ||
      (!strm.input && strm.avail_in !== 0)) {
    return Z_STREAM_ERROR;
  }

  state = strm.state;
  if (state.mode === TYPE) { state.mode = TYPEDO; }    /* skip check */


  //--- LOAD() ---
  put = strm.next_out;
  output = strm.output;
  left = strm.avail_out;
  next = strm.next_in;
  input = strm.input;
  have = strm.avail_in;
  hold = state.hold;
  bits = state.bits;
  //---

  _in = have;
  _out = left;
  ret = Z_OK;

  inf_leave: // goto emulation
  for (;;) {
    switch (state.mode) {
      case HEAD:
        if (state.wrap === 0) {
          state.mode = TYPEDO;
          break;
        }
        //=== NEEDBITS(16);
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if ((state.wrap & 2) && hold === 0x8b1f) {  /* gzip header */
          state.check = 0/*crc32(0L, Z_NULL, 0)*/;
          //=== CRC2(state.check, hold);
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          state.check = crc32(state.check, hbuf, 2, 0);
          //===//

          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
          state.mode = FLAGS;
          break;
        }
        state.flags = 0;           /* expect zlib header */
        if (state.head) {
          state.head.done = false;
        }
        if (!(state.wrap & 1) ||   /* check if zlib header allowed */
          (((hold & 0xff)/*BITS(8)*/ << 8) + (hold >> 8)) % 31) {
          strm.msg = 'incorrect header check';
          state.mode = BAD;
          break;
        }
        if ((hold & 0x0f)/*BITS(4)*/ !== Z_DEFLATED) {
          strm.msg = 'unknown compression method';
          state.mode = BAD;
          break;
        }
        //--- DROPBITS(4) ---//
        hold >>>= 4;
        bits -= 4;
        //---//
        len = (hold & 0x0f)/*BITS(4)*/ + 8;
        if (state.wbits === 0) {
          state.wbits = len;
        }
        else if (len > state.wbits) {
          strm.msg = 'invalid window size';
          state.mode = BAD;
          break;
        }
        state.dmax = 1 << len;
        //Tracev((stderr, "inflate:   zlib header ok\n"));
        strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
        state.mode = hold & 0x200 ? DICTID : TYPE;
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        break;
      case FLAGS:
        //=== NEEDBITS(16); */
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.flags = hold;
        if ((state.flags & 0xff) !== Z_DEFLATED) {
          strm.msg = 'unknown compression method';
          state.mode = BAD;
          break;
        }
        if (state.flags & 0xe000) {
          strm.msg = 'unknown header flags set';
          state.mode = BAD;
          break;
        }
        if (state.head) {
          state.head.text = ((hold >> 8) & 1);
        }
        if (state.flags & 0x0200) {
          //=== CRC2(state.check, hold);
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          state.check = crc32(state.check, hbuf, 2, 0);
          //===//
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = TIME;
        /* falls through */
      case TIME:
        //=== NEEDBITS(32); */
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if (state.head) {
          state.head.time = hold;
        }
        if (state.flags & 0x0200) {
          //=== CRC4(state.check, hold)
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          hbuf[2] = (hold >>> 16) & 0xff;
          hbuf[3] = (hold >>> 24) & 0xff;
          state.check = crc32(state.check, hbuf, 4, 0);
          //===
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = OS;
        /* falls through */
      case OS:
        //=== NEEDBITS(16); */
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if (state.head) {
          state.head.xflags = (hold & 0xff);
          state.head.os = (hold >> 8);
        }
        if (state.flags & 0x0200) {
          //=== CRC2(state.check, hold);
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          state.check = crc32(state.check, hbuf, 2, 0);
          //===//
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = EXLEN;
        /* falls through */
      case EXLEN:
        if (state.flags & 0x0400) {
          //=== NEEDBITS(16); */
          while (bits < 16) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.length = hold;
          if (state.head) {
            state.head.extra_len = hold;
          }
          if (state.flags & 0x0200) {
            //=== CRC2(state.check, hold);
            hbuf[0] = hold & 0xff;
            hbuf[1] = (hold >>> 8) & 0xff;
            state.check = crc32(state.check, hbuf, 2, 0);
            //===//
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
        }
        else if (state.head) {
          state.head.extra = null/*Z_NULL*/;
        }
        state.mode = EXTRA;
        /* falls through */
      case EXTRA:
        if (state.flags & 0x0400) {
          copy = state.length;
          if (copy > have) { copy = have; }
          if (copy) {
            if (state.head) {
              len = state.head.extra_len - state.length;
              if (!state.head.extra) {
                // Use untyped array for more convenient processing later
                state.head.extra = new Array(state.head.extra_len);
              }
              utils.arraySet(
                state.head.extra,
                input,
                next,
                // extra field is limited to 65536 bytes
                // - no need for additional size check
                copy,
                /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
                len
              );
              //zmemcpy(state.head.extra + len, next,
              //        len + copy > state.head.extra_max ?
              //        state.head.extra_max - len : copy);
            }
            if (state.flags & 0x0200) {
              state.check = crc32(state.check, input, copy, next);
            }
            have -= copy;
            next += copy;
            state.length -= copy;
          }
          if (state.length) { break inf_leave; }
        }
        state.length = 0;
        state.mode = NAME;
        /* falls through */
      case NAME:
        if (state.flags & 0x0800) {
          if (have === 0) { break inf_leave; }
          copy = 0;
          do {
            // TODO: 2 or 1 bytes?
            len = input[next + copy++];
            /* use constant limit because in js we should not preallocate memory */
            if (state.head && len &&
                (state.length < 65536 /*state.head.name_max*/)) {
              state.head.name += String.fromCharCode(len);
            }
          } while (len && copy < have);

          if (state.flags & 0x0200) {
            state.check = crc32(state.check, input, copy, next);
          }
          have -= copy;
          next += copy;
          if (len) { break inf_leave; }
        }
        else if (state.head) {
          state.head.name = null;
        }
        state.length = 0;
        state.mode = COMMENT;
        /* falls through */
      case COMMENT:
        if (state.flags & 0x1000) {
          if (have === 0) { break inf_leave; }
          copy = 0;
          do {
            len = input[next + copy++];
            /* use constant limit because in js we should not preallocate memory */
            if (state.head && len &&
                (state.length < 65536 /*state.head.comm_max*/)) {
              state.head.comment += String.fromCharCode(len);
            }
          } while (len && copy < have);
          if (state.flags & 0x0200) {
            state.check = crc32(state.check, input, copy, next);
          }
          have -= copy;
          next += copy;
          if (len) { break inf_leave; }
        }
        else if (state.head) {
          state.head.comment = null;
        }
        state.mode = HCRC;
        /* falls through */
      case HCRC:
        if (state.flags & 0x0200) {
          //=== NEEDBITS(16); */
          while (bits < 16) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          if (hold !== (state.check & 0xffff)) {
            strm.msg = 'header crc mismatch';
            state.mode = BAD;
            break;
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
        }
        if (state.head) {
          state.head.hcrc = ((state.flags >> 9) & 1);
          state.head.done = true;
        }
        strm.adler = state.check = 0;
        state.mode = TYPE;
        break;
      case DICTID:
        //=== NEEDBITS(32); */
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        strm.adler = state.check = zswap32(hold);
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = DICT;
        /* falls through */
      case DICT:
        if (state.havedict === 0) {
          //--- RESTORE() ---
          strm.next_out = put;
          strm.avail_out = left;
          strm.next_in = next;
          strm.avail_in = have;
          state.hold = hold;
          state.bits = bits;
          //---
          return Z_NEED_DICT;
        }
        strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
        state.mode = TYPE;
        /* falls through */
      case TYPE:
        if (flush === Z_BLOCK || flush === Z_TREES) { break inf_leave; }
        /* falls through */
      case TYPEDO:
        if (state.last) {
          //--- BYTEBITS() ---//
          hold >>>= bits & 7;
          bits -= bits & 7;
          //---//
          state.mode = CHECK;
          break;
        }
        //=== NEEDBITS(3); */
        while (bits < 3) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.last = (hold & 0x01)/*BITS(1)*/;
        //--- DROPBITS(1) ---//
        hold >>>= 1;
        bits -= 1;
        //---//

        switch ((hold & 0x03)/*BITS(2)*/) {
          case 0:                             /* stored block */
            //Tracev((stderr, "inflate:     stored block%s\n",
            //        state.last ? " (last)" : ""));
            state.mode = STORED;
            break;
          case 1:                             /* fixed block */
            fixedtables(state);
            //Tracev((stderr, "inflate:     fixed codes block%s\n",
            //        state.last ? " (last)" : ""));
            state.mode = LEN_;             /* decode codes */
            if (flush === Z_TREES) {
              //--- DROPBITS(2) ---//
              hold >>>= 2;
              bits -= 2;
              //---//
              break inf_leave;
            }
            break;
          case 2:                             /* dynamic block */
            //Tracev((stderr, "inflate:     dynamic codes block%s\n",
            //        state.last ? " (last)" : ""));
            state.mode = TABLE;
            break;
          case 3:
            strm.msg = 'invalid block type';
            state.mode = BAD;
        }
        //--- DROPBITS(2) ---//
        hold >>>= 2;
        bits -= 2;
        //---//
        break;
      case STORED:
        //--- BYTEBITS() ---// /* go to byte boundary */
        hold >>>= bits & 7;
        bits -= bits & 7;
        //---//
        //=== NEEDBITS(32); */
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if ((hold & 0xffff) !== ((hold >>> 16) ^ 0xffff)) {
          strm.msg = 'invalid stored block lengths';
          state.mode = BAD;
          break;
        }
        state.length = hold & 0xffff;
        //Tracev((stderr, "inflate:       stored length %u\n",
        //        state.length));
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = COPY_;
        if (flush === Z_TREES) { break inf_leave; }
        /* falls through */
      case COPY_:
        state.mode = COPY;
        /* falls through */
      case COPY:
        copy = state.length;
        if (copy) {
          if (copy > have) { copy = have; }
          if (copy > left) { copy = left; }
          if (copy === 0) { break inf_leave; }
          //--- zmemcpy(put, next, copy); ---
          utils.arraySet(output, input, next, copy, put);
          //---//
          have -= copy;
          next += copy;
          left -= copy;
          put += copy;
          state.length -= copy;
          break;
        }
        //Tracev((stderr, "inflate:       stored end\n"));
        state.mode = TYPE;
        break;
      case TABLE:
        //=== NEEDBITS(14); */
        while (bits < 14) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.nlen = (hold & 0x1f)/*BITS(5)*/ + 257;
        //--- DROPBITS(5) ---//
        hold >>>= 5;
        bits -= 5;
        //---//
        state.ndist = (hold & 0x1f)/*BITS(5)*/ + 1;
        //--- DROPBITS(5) ---//
        hold >>>= 5;
        bits -= 5;
        //---//
        state.ncode = (hold & 0x0f)/*BITS(4)*/ + 4;
        //--- DROPBITS(4) ---//
        hold >>>= 4;
        bits -= 4;
        //---//
//#ifndef PKZIP_BUG_WORKAROUND
        if (state.nlen > 286 || state.ndist > 30) {
          strm.msg = 'too many length or distance symbols';
          state.mode = BAD;
          break;
        }
//#endif
        //Tracev((stderr, "inflate:       table sizes ok\n"));
        state.have = 0;
        state.mode = LENLENS;
        /* falls through */
      case LENLENS:
        while (state.have < state.ncode) {
          //=== NEEDBITS(3);
          while (bits < 3) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.lens[order[state.have++]] = (hold & 0x07);//BITS(3);
          //--- DROPBITS(3) ---//
          hold >>>= 3;
          bits -= 3;
          //---//
        }
        while (state.have < 19) {
          state.lens[order[state.have++]] = 0;
        }
        // We have separate tables & no pointers. 2 commented lines below not needed.
        //state.next = state.codes;
        //state.lencode = state.next;
        // Switch to use dynamic table
        state.lencode = state.lendyn;
        state.lenbits = 7;

        opts = { bits: state.lenbits };
        ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
        state.lenbits = opts.bits;

        if (ret) {
          strm.msg = 'invalid code lengths set';
          state.mode = BAD;
          break;
        }
        //Tracev((stderr, "inflate:       code lengths ok\n"));
        state.have = 0;
        state.mode = CODELENS;
        /* falls through */
      case CODELENS:
        while (state.have < state.nlen + state.ndist) {
          for (;;) {
            here = state.lencode[hold & ((1 << state.lenbits) - 1)];/*BITS(state.lenbits)*/
            here_bits = here >>> 24;
            here_op = (here >>> 16) & 0xff;
            here_val = here & 0xffff;

            if ((here_bits) <= bits) { break; }
            //--- PULLBYTE() ---//
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
            //---//
          }
          if (here_val < 16) {
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.lens[state.have++] = here_val;
          }
          else {
            if (here_val === 16) {
              //=== NEEDBITS(here.bits + 2);
              n = here_bits + 2;
              while (bits < n) {
                if (have === 0) { break inf_leave; }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              //--- DROPBITS(here.bits) ---//
              hold >>>= here_bits;
              bits -= here_bits;
              //---//
              if (state.have === 0) {
                strm.msg = 'invalid bit length repeat';
                state.mode = BAD;
                break;
              }
              len = state.lens[state.have - 1];
              copy = 3 + (hold & 0x03);//BITS(2);
              //--- DROPBITS(2) ---//
              hold >>>= 2;
              bits -= 2;
              //---//
            }
            else if (here_val === 17) {
              //=== NEEDBITS(here.bits + 3);
              n = here_bits + 3;
              while (bits < n) {
                if (have === 0) { break inf_leave; }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              //--- DROPBITS(here.bits) ---//
              hold >>>= here_bits;
              bits -= here_bits;
              //---//
              len = 0;
              copy = 3 + (hold & 0x07);//BITS(3);
              //--- DROPBITS(3) ---//
              hold >>>= 3;
              bits -= 3;
              //---//
            }
            else {
              //=== NEEDBITS(here.bits + 7);
              n = here_bits + 7;
              while (bits < n) {
                if (have === 0) { break inf_leave; }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              //--- DROPBITS(here.bits) ---//
              hold >>>= here_bits;
              bits -= here_bits;
              //---//
              len = 0;
              copy = 11 + (hold & 0x7f);//BITS(7);
              //--- DROPBITS(7) ---//
              hold >>>= 7;
              bits -= 7;
              //---//
            }
            if (state.have + copy > state.nlen + state.ndist) {
              strm.msg = 'invalid bit length repeat';
              state.mode = BAD;
              break;
            }
            while (copy--) {
              state.lens[state.have++] = len;
            }
          }
        }

        /* handle error breaks in while */
        if (state.mode === BAD) { break; }

        /* check for end-of-block code (better have one) */
        if (state.lens[256] === 0) {
          strm.msg = 'invalid code -- missing end-of-block';
          state.mode = BAD;
          break;
        }

        /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */
        state.lenbits = 9;

        opts = { bits: state.lenbits };
        ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
        // We have separate tables & no pointers. 2 commented lines below not needed.
        // state.next_index = opts.table_index;
        state.lenbits = opts.bits;
        // state.lencode = state.next;

        if (ret) {
          strm.msg = 'invalid literal/lengths set';
          state.mode = BAD;
          break;
        }

        state.distbits = 6;
        //state.distcode.copy(state.codes);
        // Switch to use dynamic table
        state.distcode = state.distdyn;
        opts = { bits: state.distbits };
        ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
        // We have separate tables & no pointers. 2 commented lines below not needed.
        // state.next_index = opts.table_index;
        state.distbits = opts.bits;
        // state.distcode = state.next;

        if (ret) {
          strm.msg = 'invalid distances set';
          state.mode = BAD;
          break;
        }
        //Tracev((stderr, 'inflate:       codes ok\n'));
        state.mode = LEN_;
        if (flush === Z_TREES) { break inf_leave; }
        /* falls through */
      case LEN_:
        state.mode = LEN;
        /* falls through */
      case LEN:
        if (have >= 6 && left >= 258) {
          //--- RESTORE() ---
          strm.next_out = put;
          strm.avail_out = left;
          strm.next_in = next;
          strm.avail_in = have;
          state.hold = hold;
          state.bits = bits;
          //---
          inflate_fast(strm, _out);
          //--- LOAD() ---
          put = strm.next_out;
          output = strm.output;
          left = strm.avail_out;
          next = strm.next_in;
          input = strm.input;
          have = strm.avail_in;
          hold = state.hold;
          bits = state.bits;
          //---

          if (state.mode === TYPE) {
            state.back = -1;
          }
          break;
        }
        state.back = 0;
        for (;;) {
          here = state.lencode[hold & ((1 << state.lenbits) - 1)];  /*BITS(state.lenbits)*/
          here_bits = here >>> 24;
          here_op = (here >>> 16) & 0xff;
          here_val = here & 0xffff;

          if (here_bits <= bits) { break; }
          //--- PULLBYTE() ---//
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
          //---//
        }
        if (here_op && (here_op & 0xf0) === 0) {
          last_bits = here_bits;
          last_op = here_op;
          last_val = here_val;
          for (;;) {
            here = state.lencode[last_val +
                    ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
            here_bits = here >>> 24;
            here_op = (here >>> 16) & 0xff;
            here_val = here & 0xffff;

            if ((last_bits + here_bits) <= bits) { break; }
            //--- PULLBYTE() ---//
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
            //---//
          }
          //--- DROPBITS(last.bits) ---//
          hold >>>= last_bits;
          bits -= last_bits;
          //---//
          state.back += last_bits;
        }
        //--- DROPBITS(here.bits) ---//
        hold >>>= here_bits;
        bits -= here_bits;
        //---//
        state.back += here_bits;
        state.length = here_val;
        if (here_op === 0) {
          //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
          //        "inflate:         literal '%c'\n" :
          //        "inflate:         literal 0x%02x\n", here.val));
          state.mode = LIT;
          break;
        }
        if (here_op & 32) {
          //Tracevv((stderr, "inflate:         end of block\n"));
          state.back = -1;
          state.mode = TYPE;
          break;
        }
        if (here_op & 64) {
          strm.msg = 'invalid literal/length code';
          state.mode = BAD;
          break;
        }
        state.extra = here_op & 15;
        state.mode = LENEXT;
        /* falls through */
      case LENEXT:
        if (state.extra) {
          //=== NEEDBITS(state.extra);
          n = state.extra;
          while (bits < n) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.length += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
          //--- DROPBITS(state.extra) ---//
          hold >>>= state.extra;
          bits -= state.extra;
          //---//
          state.back += state.extra;
        }
        //Tracevv((stderr, "inflate:         length %u\n", state.length));
        state.was = state.length;
        state.mode = DIST;
        /* falls through */
      case DIST:
        for (;;) {
          here = state.distcode[hold & ((1 << state.distbits) - 1)];/*BITS(state.distbits)*/
          here_bits = here >>> 24;
          here_op = (here >>> 16) & 0xff;
          here_val = here & 0xffff;

          if ((here_bits) <= bits) { break; }
          //--- PULLBYTE() ---//
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
          //---//
        }
        if ((here_op & 0xf0) === 0) {
          last_bits = here_bits;
          last_op = here_op;
          last_val = here_val;
          for (;;) {
            here = state.distcode[last_val +
                    ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
            here_bits = here >>> 24;
            here_op = (here >>> 16) & 0xff;
            here_val = here & 0xffff;

            if ((last_bits + here_bits) <= bits) { break; }
            //--- PULLBYTE() ---//
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
            //---//
          }
          //--- DROPBITS(last.bits) ---//
          hold >>>= last_bits;
          bits -= last_bits;
          //---//
          state.back += last_bits;
        }
        //--- DROPBITS(here.bits) ---//
        hold >>>= here_bits;
        bits -= here_bits;
        //---//
        state.back += here_bits;
        if (here_op & 64) {
          strm.msg = 'invalid distance code';
          state.mode = BAD;
          break;
        }
        state.offset = here_val;
        state.extra = (here_op) & 15;
        state.mode = DISTEXT;
        /* falls through */
      case DISTEXT:
        if (state.extra) {
          //=== NEEDBITS(state.extra);
          n = state.extra;
          while (bits < n) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.offset += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
          //--- DROPBITS(state.extra) ---//
          hold >>>= state.extra;
          bits -= state.extra;
          //---//
          state.back += state.extra;
        }
//#ifdef INFLATE_STRICT
        if (state.offset > state.dmax) {
          strm.msg = 'invalid distance too far back';
          state.mode = BAD;
          break;
        }
//#endif
        //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
        state.mode = MATCH;
        /* falls through */
      case MATCH:
        if (left === 0) { break inf_leave; }
        copy = _out - left;
        if (state.offset > copy) {         /* copy from window */
          copy = state.offset - copy;
          if (copy > state.whave) {
            if (state.sane) {
              strm.msg = 'invalid distance too far back';
              state.mode = BAD;
              break;
            }
// (!) This block is disabled in zlib defaults,
// don't enable it for binary compatibility
//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
//          Trace((stderr, "inflate.c too far\n"));
//          copy -= state.whave;
//          if (copy > state.length) { copy = state.length; }
//          if (copy > left) { copy = left; }
//          left -= copy;
//          state.length -= copy;
//          do {
//            output[put++] = 0;
//          } while (--copy);
//          if (state.length === 0) { state.mode = LEN; }
//          break;
//#endif
          }
          if (copy > state.wnext) {
            copy -= state.wnext;
            from = state.wsize - copy;
          }
          else {
            from = state.wnext - copy;
          }
          if (copy > state.length) { copy = state.length; }
          from_source = state.window;
        }
        else {                              /* copy from output */
          from_source = output;
          from = put - state.offset;
          copy = state.length;
        }
        if (copy > left) { copy = left; }
        left -= copy;
        state.length -= copy;
        do {
          output[put++] = from_source[from++];
        } while (--copy);
        if (state.length === 0) { state.mode = LEN; }
        break;
      case LIT:
        if (left === 0) { break inf_leave; }
        output[put++] = state.length;
        left--;
        state.mode = LEN;
        break;
      case CHECK:
        if (state.wrap) {
          //=== NEEDBITS(32);
          while (bits < 32) {
            if (have === 0) { break inf_leave; }
            have--;
            // Use '|' instead of '+' to make sure that result is signed
            hold |= input[next++] << bits;
            bits += 8;
          }
          //===//
          _out -= left;
          strm.total_out += _out;
          state.total += _out;
          if (_out) {
            strm.adler = state.check =
                /*UPDATE(state.check, put - _out, _out);*/
                (state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out));

          }
          _out = left;
          // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
          if ((state.flags ? hold : zswap32(hold)) !== state.check) {
            strm.msg = 'incorrect data check';
            state.mode = BAD;
            break;
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
          //Tracev((stderr, "inflate:   check matches trailer\n"));
        }
        state.mode = LENGTH;
        /* falls through */
      case LENGTH:
        if (state.wrap && state.flags) {
          //=== NEEDBITS(32);
          while (bits < 32) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          if (hold !== (state.total & 0xffffffff)) {
            strm.msg = 'incorrect length check';
            state.mode = BAD;
            break;
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
          //Tracev((stderr, "inflate:   length matches trailer\n"));
        }
        state.mode = DONE;
        /* falls through */
      case DONE:
        ret = Z_STREAM_END;
        break inf_leave;
      case BAD:
        ret = Z_DATA_ERROR;
        break inf_leave;
      case MEM:
        return Z_MEM_ERROR;
      case SYNC:
        /* falls through */
      default:
        return Z_STREAM_ERROR;
    }
  }

  // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"

  /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */

  //--- RESTORE() ---
  strm.next_out = put;
  strm.avail_out = left;
  strm.next_in = next;
  strm.avail_in = have;
  state.hold = hold;
  state.bits = bits;
  //---

  if (state.wsize || (_out !== strm.avail_out && state.mode < BAD &&
                      (state.mode < CHECK || flush !== Z_FINISH))) {
    if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
      state.mode = MEM;
      return Z_MEM_ERROR;
    }
  }
  _in -= strm.avail_in;
  _out -= strm.avail_out;
  strm.total_in += _in;
  strm.total_out += _out;
  state.total += _out;
  if (state.wrap && _out) {
    strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
      (state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out));
  }
  strm.data_type = state.bits + (state.last ? 64 : 0) +
                    (state.mode === TYPE ? 128 : 0) +
                    (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
  if (((_in === 0 && _out === 0) || flush === Z_FINISH) && ret === Z_OK) {
    ret = Z_BUF_ERROR;
  }
  return ret;
}

function inflateEnd(strm) {

  if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/) {
    return Z_STREAM_ERROR;
  }

  var state = strm.state;
  if (state.window) {
    state.window = null;
  }
  strm.state = null;
  return Z_OK;
}

function inflateGetHeader(strm, head) {
  var state;

  /* check state */
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  if ((state.wrap & 2) === 0) { return Z_STREAM_ERROR; }

  /* save header structure */
  state.head = head;
  head.done = false;
  return Z_OK;
}

function inflateSetDictionary(strm, dictionary) {
  var dictLength = dictionary.length;

  var state;
  var dictid;
  var ret;

  /* check state */
  if (!strm /* == Z_NULL */ || !strm.state /* == Z_NULL */) { return Z_STREAM_ERROR; }
  state = strm.state;

  if (state.wrap !== 0 && state.mode !== DICT) {
    return Z_STREAM_ERROR;
  }

  /* check for correct dictionary identifier */
  if (state.mode === DICT) {
    dictid = 1; /* adler32(0, null, 0)*/
    /* dictid = adler32(dictid, dictionary, dictLength); */
    dictid = adler32(dictid, dictionary, dictLength, 0);
    if (dictid !== state.check) {
      return Z_DATA_ERROR;
    }
  }
  /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */
  ret = updatewindow(strm, dictionary, dictLength, dictLength);
  if (ret) {
    state.mode = MEM;
    return Z_MEM_ERROR;
  }
  state.havedict = 1;
  // Tracev((stderr, "inflate:   dictionary set\n"));
  return Z_OK;
}

exports.inflateReset = inflateReset;
exports.inflateReset2 = inflateReset2;
exports.inflateResetKeep = inflateResetKeep;
exports.inflateInit = inflateInit;
exports.inflateInit2 = inflateInit2;
exports.inflate = inflate;
exports.inflateEnd = inflateEnd;
exports.inflateGetHeader = inflateGetHeader;
exports.inflateSetDictionary = inflateSetDictionary;
exports.inflateInfo = 'pako inflate (from Nodeca project)';

/* Not implemented
exports.inflateCopy = inflateCopy;
exports.inflateGetDictionary = inflateGetDictionary;
exports.inflateMark = inflateMark;
exports.inflatePrime = inflatePrime;
exports.inflateSync = inflateSync;
exports.inflateSyncPoint = inflateSyncPoint;
exports.inflateUndermine = inflateUndermine;
*/

},{"../utils/common":1170,"./adler32":1171,"./crc32":1173,"./inffast":1175,"./inftrees":1177}],1177:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var utils = require('../utils/common');

var MAXBITS = 15;
var ENOUGH_LENS = 852;
var ENOUGH_DISTS = 592;
//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);

var CODES = 0;
var LENS = 1;
var DISTS = 2;

var lbase = [ /* Length codes 257..285 base */
  3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31,
  35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0
];

var lext = [ /* Length codes 257..285 extra */
  16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18,
  19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78
];

var dbase = [ /* Distance codes 0..29 base */
  1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193,
  257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145,
  8193, 12289, 16385, 24577, 0, 0
];

var dext = [ /* Distance codes 0..29 extra */
  16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22,
  23, 23, 24, 24, 25, 25, 26, 26, 27, 27,
  28, 28, 29, 29, 64, 64
];

module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts)
{
  var bits = opts.bits;
      //here = opts.here; /* table entry for duplication */

  var len = 0;               /* a code's length in bits */
  var sym = 0;               /* index of code symbols */
  var min = 0, max = 0;          /* minimum and maximum code lengths */
  var root = 0;              /* number of index bits for root table */
  var curr = 0;              /* number of index bits for current table */
  var drop = 0;              /* code bits to drop for sub-table */
  var left = 0;                   /* number of prefix codes available */
  var used = 0;              /* code entries in table used */
  var huff = 0;              /* Huffman code */
  var incr;              /* for incrementing code, index */
  var fill;              /* index for replicating entries */
  var low;               /* low bits for current root entry */
  var mask;              /* mask for low root bits */
  var next;             /* next available space in table */
  var base = null;     /* base value table to use */
  var base_index = 0;
//  var shoextra;    /* extra bits table to use */
  var end;                    /* use base and extra for symbol > end */
  var count = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
  var offs = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
  var extra = null;
  var extra_index = 0;

  var here_bits, here_op, here_val;

  /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */

  /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */
  for (len = 0; len <= MAXBITS; len++) {
    count[len] = 0;
  }
  for (sym = 0; sym < codes; sym++) {
    count[lens[lens_index + sym]]++;
  }

  /* bound code lengths, force root to be within code lengths */
  root = bits;
  for (max = MAXBITS; max >= 1; max--) {
    if (count[max] !== 0) { break; }
  }
  if (root > max) {
    root = max;
  }
  if (max === 0) {                     /* no symbols to code at all */
    //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
    //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
    //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
    table[table_index++] = (1 << 24) | (64 << 16) | 0;


    //table.op[opts.table_index] = 64;
    //table.bits[opts.table_index] = 1;
    //table.val[opts.table_index++] = 0;
    table[table_index++] = (1 << 24) | (64 << 16) | 0;

    opts.bits = 1;
    return 0;     /* no symbols, but wait for decoding to report error */
  }
  for (min = 1; min < max; min++) {
    if (count[min] !== 0) { break; }
  }
  if (root < min) {
    root = min;
  }

  /* check for an over-subscribed or incomplete set of lengths */
  left = 1;
  for (len = 1; len <= MAXBITS; len++) {
    left <<= 1;
    left -= count[len];
    if (left < 0) {
      return -1;
    }        /* over-subscribed */
  }
  if (left > 0 && (type === CODES || max !== 1)) {
    return -1;                      /* incomplete set */
  }

  /* generate offsets into symbol table for each length for sorting */
  offs[1] = 0;
  for (len = 1; len < MAXBITS; len++) {
    offs[len + 1] = offs[len] + count[len];
  }

  /* sort symbols by length, by symbol order within each length */
  for (sym = 0; sym < codes; sym++) {
    if (lens[lens_index + sym] !== 0) {
      work[offs[lens[lens_index + sym]]++] = sym;
    }
  }

  /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */

  /* set up for code type */
  // poor man optimization - use if-else instead of switch,
  // to avoid deopts in old v8
  if (type === CODES) {
    base = extra = work;    /* dummy value--not used */
    end = 19;

  } else if (type === LENS) {
    base = lbase;
    base_index -= 257;
    extra = lext;
    extra_index -= 257;
    end = 256;

  } else {                    /* DISTS */
    base = dbase;
    extra = dext;
    end = -1;
  }

  /* initialize opts for loop */
  huff = 0;                   /* starting code */
  sym = 0;                    /* starting code symbol */
  len = min;                  /* starting code length */
  next = table_index;              /* current table to fill in */
  curr = root;                /* current table index bits */
  drop = 0;                   /* current bits to drop from code for index */
  low = -1;                   /* trigger new sub-table when len > root */
  used = 1 << root;          /* use root table entries */
  mask = used - 1;            /* mask for comparing low */

  /* check available table space */
  if ((type === LENS && used > ENOUGH_LENS) ||
    (type === DISTS && used > ENOUGH_DISTS)) {
    return 1;
  }

  /* process all codes and make table entries */
  for (;;) {
    /* create table entry */
    here_bits = len - drop;
    if (work[sym] < end) {
      here_op = 0;
      here_val = work[sym];
    }
    else if (work[sym] > end) {
      here_op = extra[extra_index + work[sym]];
      here_val = base[base_index + work[sym]];
    }
    else {
      here_op = 32 + 64;         /* end of block */
      here_val = 0;
    }

    /* replicate for those indices with low len bits equal to huff */
    incr = 1 << (len - drop);
    fill = 1 << curr;
    min = fill;                 /* save offset to next table */
    do {
      fill -= incr;
      table[next + (huff >> drop) + fill] = (here_bits << 24) | (here_op << 16) | here_val |0;
    } while (fill !== 0);

    /* backwards increment the len-bit code huff */
    incr = 1 << (len - 1);
    while (huff & incr) {
      incr >>= 1;
    }
    if (incr !== 0) {
      huff &= incr - 1;
      huff += incr;
    } else {
      huff = 0;
    }

    /* go to next symbol, update count, len */
    sym++;
    if (--count[len] === 0) {
      if (len === max) { break; }
      len = lens[lens_index + work[sym]];
    }

    /* create new sub-table if needed */
    if (len > root && (huff & mask) !== low) {
      /* if first time, transition to sub-tables */
      if (drop === 0) {
        drop = root;
      }

      /* increment past last table */
      next += min;            /* here min is 1 << curr */

      /* determine length of next table */
      curr = len - drop;
      left = 1 << curr;
      while (curr + drop < max) {
        left -= count[curr + drop];
        if (left <= 0) { break; }
        curr++;
        left <<= 1;
      }

      /* check for enough space */
      used += 1 << curr;
      if ((type === LENS && used > ENOUGH_LENS) ||
        (type === DISTS && used > ENOUGH_DISTS)) {
        return 1;
      }

      /* point entry in root table to sub-table */
      low = huff & mask;
      /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/
      table[low] = (root << 24) | (curr << 16) | (next - table_index) |0;
    }
  }

  /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */
  if (huff !== 0) {
    //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = ((len - drop) << 24) | (64 << 16) |0;
  }

  /* set return parameters */
  //opts.table_index += used;
  opts.bits = root;
  return 0;
};

},{"../utils/common":1170}],1178:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

module.exports = {
  2:      'need dictionary',     /* Z_NEED_DICT       2  */
  1:      'stream end',          /* Z_STREAM_END      1  */
  0:      '',                    /* Z_OK              0  */
  '-1':   'file error',          /* Z_ERRNO         (-1) */
  '-2':   'stream error',        /* Z_STREAM_ERROR  (-2) */
  '-3':   'data error',          /* Z_DATA_ERROR    (-3) */
  '-4':   'insufficient memory', /* Z_MEM_ERROR     (-4) */
  '-5':   'buffer error',        /* Z_BUF_ERROR     (-5) */
  '-6':   'incompatible version' /* Z_VERSION_ERROR (-6) */
};

},{}],1179:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

/* eslint-disable space-unary-ops */

var utils = require('../utils/common');

/* Public constants ==========================================================*/
/* ===========================================================================*/


//var Z_FILTERED          = 1;
//var Z_HUFFMAN_ONLY      = 2;
//var Z_RLE               = 3;
var Z_FIXED               = 4;
//var Z_DEFAULT_STRATEGY  = 0;

/* Possible values of the data_type field (though see inflate()) */
var Z_BINARY              = 0;
var Z_TEXT                = 1;
//var Z_ASCII             = 1; // = Z_TEXT
var Z_UNKNOWN             = 2;

/*============================================================================*/


function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }

// From zutil.h

var STORED_BLOCK = 0;
var STATIC_TREES = 1;
var DYN_TREES    = 2;
/* The three kinds of block type */

var MIN_MATCH    = 3;
var MAX_MATCH    = 258;
/* The minimum and maximum match lengths */

// From deflate.h
/* ===========================================================================
 * Internal compression state.
 */

var LENGTH_CODES  = 29;
/* number of length codes, not counting the special END_BLOCK code */

var LITERALS      = 256;
/* number of literal bytes 0..255 */

var L_CODES       = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */

var D_CODES       = 30;
/* number of distance codes */

var BL_CODES      = 19;
/* number of codes used to transfer the bit lengths */

var HEAP_SIZE     = 2 * L_CODES + 1;
/* maximum heap size */

var MAX_BITS      = 15;
/* All codes must not exceed MAX_BITS bits */

var Buf_size      = 16;
/* size of bit buffer in bi_buf */


/* ===========================================================================
 * Constants
 */

var MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */

var END_BLOCK   = 256;
/* end of block literal code */

var REP_3_6     = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */

var REPZ_3_10   = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */

var REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */

/* eslint-disable comma-spacing,array-bracket-spacing */
var extra_lbits =   /* extra bits for each length code */
  [0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0];

var extra_dbits =   /* extra bits for each distance code */
  [0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13];

var extra_blbits =  /* extra bits for each bit length code */
  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7];

var bl_order =
  [16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];
/* eslint-enable comma-spacing,array-bracket-spacing */

/* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */

/* ===========================================================================
 * Local data. These are initialized only once.
 */

// We pre-fill arrays with 0 to avoid uninitialized gaps

var DIST_CODE_LEN = 512; /* see definition of array dist_code below */

// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
var static_ltree  = new Array((L_CODES + 2) * 2);
zero(static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */

var static_dtree  = new Array(D_CODES * 2);
zero(static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */

var _dist_code    = new Array(DIST_CODE_LEN);
zero(_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */

var _length_code  = new Array(MAX_MATCH - MIN_MATCH + 1);
zero(_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */

var base_length   = new Array(LENGTH_CODES);
zero(base_length);
/* First normalized length for each code (0 = MIN_MATCH) */

var base_dist     = new Array(D_CODES);
zero(base_dist);
/* First normalized distance for each code (0 = distance of 1) */


function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {

  this.static_tree  = static_tree;  /* static tree or NULL */
  this.extra_bits   = extra_bits;   /* extra bits for each code or NULL */
  this.extra_base   = extra_base;   /* base index for extra_bits */
  this.elems        = elems;        /* max number of elements in the tree */
  this.max_length   = max_length;   /* max bit length for the codes */

  // show if `static_tree` has data or dummy - needed for monomorphic objects
  this.has_stree    = static_tree && static_tree.length;
}


var static_l_desc;
var static_d_desc;
var static_bl_desc;


function TreeDesc(dyn_tree, stat_desc) {
  this.dyn_tree = dyn_tree;     /* the dynamic tree */
  this.max_code = 0;            /* largest code with non zero frequency */
  this.stat_desc = stat_desc;   /* the corresponding static tree */
}



function d_code(dist) {
  return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
}


/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */
function put_short(s, w) {
//    put_byte(s, (uch)((w) & 0xff));
//    put_byte(s, (uch)((ush)(w) >> 8));
  s.pending_buf[s.pending++] = (w) & 0xff;
  s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
}


/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */
function send_bits(s, value, length) {
  if (s.bi_valid > (Buf_size - length)) {
    s.bi_buf |= (value << s.bi_valid) & 0xffff;
    put_short(s, s.bi_buf);
    s.bi_buf = value >> (Buf_size - s.bi_valid);
    s.bi_valid += length - Buf_size;
  } else {
    s.bi_buf |= (value << s.bi_valid) & 0xffff;
    s.bi_valid += length;
  }
}


function send_code(s, c, tree) {
  send_bits(s, tree[c * 2]/*.Code*/, tree[c * 2 + 1]/*.Len*/);
}


/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */
function bi_reverse(code, len) {
  var res = 0;
  do {
    res |= code & 1;
    code >>>= 1;
    res <<= 1;
  } while (--len > 0);
  return res >>> 1;
}


/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */
function bi_flush(s) {
  if (s.bi_valid === 16) {
    put_short(s, s.bi_buf);
    s.bi_buf = 0;
    s.bi_valid = 0;

  } else if (s.bi_valid >= 8) {
    s.pending_buf[s.pending++] = s.bi_buf & 0xff;
    s.bi_buf >>= 8;
    s.bi_valid -= 8;
  }
}


/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */
function gen_bitlen(s, desc)
//    deflate_state *s;
//    tree_desc *desc;    /* the tree descriptor */
{
  var tree            = desc.dyn_tree;
  var max_code        = desc.max_code;
  var stree           = desc.stat_desc.static_tree;
  var has_stree       = desc.stat_desc.has_stree;
  var extra           = desc.stat_desc.extra_bits;
  var base            = desc.stat_desc.extra_base;
  var max_length      = desc.stat_desc.max_length;
  var h;              /* heap index */
  var n, m;           /* iterate over the tree elements */
  var bits;           /* bit length */
  var xbits;          /* extra bits */
  var f;              /* frequency */
  var overflow = 0;   /* number of elements with bit length too large */

  for (bits = 0; bits <= MAX_BITS; bits++) {
    s.bl_count[bits] = 0;
  }

  /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */
  tree[s.heap[s.heap_max] * 2 + 1]/*.Len*/ = 0; /* root of the heap */

  for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
    n = s.heap[h];
    bits = tree[tree[n * 2 + 1]/*.Dad*/ * 2 + 1]/*.Len*/ + 1;
    if (bits > max_length) {
      bits = max_length;
      overflow++;
    }
    tree[n * 2 + 1]/*.Len*/ = bits;
    /* We overwrite tree[n].Dad which is no longer needed */

    if (n > max_code) { continue; } /* not a leaf node */

    s.bl_count[bits]++;
    xbits = 0;
    if (n >= base) {
      xbits = extra[n - base];
    }
    f = tree[n * 2]/*.Freq*/;
    s.opt_len += f * (bits + xbits);
    if (has_stree) {
      s.static_len += f * (stree[n * 2 + 1]/*.Len*/ + xbits);
    }
  }
  if (overflow === 0) { return; }

  // Trace((stderr,"\nbit length overflow\n"));
  /* This happens for example on obj2 and pic of the Calgary corpus */

  /* Find the first bit length which could increase: */
  do {
    bits = max_length - 1;
    while (s.bl_count[bits] === 0) { bits--; }
    s.bl_count[bits]--;      /* move one leaf down the tree */
    s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */
    s.bl_count[max_length]--;
    /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */
    overflow -= 2;
  } while (overflow > 0);

  /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */
  for (bits = max_length; bits !== 0; bits--) {
    n = s.bl_count[bits];
    while (n !== 0) {
      m = s.heap[--h];
      if (m > max_code) { continue; }
      if (tree[m * 2 + 1]/*.Len*/ !== bits) {
        // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
        s.opt_len += (bits - tree[m * 2 + 1]/*.Len*/) * tree[m * 2]/*.Freq*/;
        tree[m * 2 + 1]/*.Len*/ = bits;
      }
      n--;
    }
  }
}


/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */
function gen_codes(tree, max_code, bl_count)
//    ct_data *tree;             /* the tree to decorate */
//    int max_code;              /* largest code with non zero frequency */
//    ushf *bl_count;            /* number of codes at each bit length */
{
  var next_code = new Array(MAX_BITS + 1); /* next code value for each bit length */
  var code = 0;              /* running code value */
  var bits;                  /* bit index */
  var n;                     /* code index */

  /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */
  for (bits = 1; bits <= MAX_BITS; bits++) {
    next_code[bits] = code = (code + bl_count[bits - 1]) << 1;
  }
  /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */
  //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
  //        "inconsistent bit counts");
  //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));

  for (n = 0;  n <= max_code; n++) {
    var len = tree[n * 2 + 1]/*.Len*/;
    if (len === 0) { continue; }
    /* Now reverse the bits */
    tree[n * 2]/*.Code*/ = bi_reverse(next_code[len]++, len);

    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
  }
}


/* ===========================================================================
 * Initialize the various 'constant' tables.
 */
function tr_static_init() {
  var n;        /* iterates over tree elements */
  var bits;     /* bit counter */
  var length;   /* length value */
  var code;     /* code value */
  var dist;     /* distance index */
  var bl_count = new Array(MAX_BITS + 1);
  /* number of codes at each bit length for an optimal tree */

  // do check in _tr_init()
  //if (static_init_done) return;

  /* For some embedded targets, global variables are not initialized: */
/*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/

  /* Initialize the mapping length (0..255) -> length code (0..28) */
  length = 0;
  for (code = 0; code < LENGTH_CODES - 1; code++) {
    base_length[code] = length;
    for (n = 0; n < (1 << extra_lbits[code]); n++) {
      _length_code[length++] = code;
    }
  }
  //Assert (length == 256, "tr_static_init: length != 256");
  /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */
  _length_code[length - 1] = code;

  /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
  dist = 0;
  for (code = 0; code < 16; code++) {
    base_dist[code] = dist;
    for (n = 0; n < (1 << extra_dbits[code]); n++) {
      _dist_code[dist++] = code;
    }
  }
  //Assert (dist == 256, "tr_static_init: dist != 256");
  dist >>= 7; /* from now on, all distances are divided by 128 */
  for (; code < D_CODES; code++) {
    base_dist[code] = dist << 7;
    for (n = 0; n < (1 << (extra_dbits[code] - 7)); n++) {
      _dist_code[256 + dist++] = code;
    }
  }
  //Assert (dist == 256, "tr_static_init: 256+dist != 512");

  /* Construct the codes of the static literal tree */
  for (bits = 0; bits <= MAX_BITS; bits++) {
    bl_count[bits] = 0;
  }

  n = 0;
  while (n <= 143) {
    static_ltree[n * 2 + 1]/*.Len*/ = 8;
    n++;
    bl_count[8]++;
  }
  while (n <= 255) {
    static_ltree[n * 2 + 1]/*.Len*/ = 9;
    n++;
    bl_count[9]++;
  }
  while (n <= 279) {
    static_ltree[n * 2 + 1]/*.Len*/ = 7;
    n++;
    bl_count[7]++;
  }
  while (n <= 287) {
    static_ltree[n * 2 + 1]/*.Len*/ = 8;
    n++;
    bl_count[8]++;
  }
  /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */
  gen_codes(static_ltree, L_CODES + 1, bl_count);

  /* The static distance tree is trivial: */
  for (n = 0; n < D_CODES; n++) {
    static_dtree[n * 2 + 1]/*.Len*/ = 5;
    static_dtree[n * 2]/*.Code*/ = bi_reverse(n, 5);
  }

  // Now data ready and we can init static trees
  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
  static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0,          D_CODES, MAX_BITS);
  static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0,         BL_CODES, MAX_BL_BITS);

  //static_init_done = true;
}


/* ===========================================================================
 * Initialize a new block.
 */
function init_block(s) {
  var n; /* iterates over tree elements */

  /* Initialize the trees. */
  for (n = 0; n < L_CODES;  n++) { s.dyn_ltree[n * 2]/*.Freq*/ = 0; }
  for (n = 0; n < D_CODES;  n++) { s.dyn_dtree[n * 2]/*.Freq*/ = 0; }
  for (n = 0; n < BL_CODES; n++) { s.bl_tree[n * 2]/*.Freq*/ = 0; }

  s.dyn_ltree[END_BLOCK * 2]/*.Freq*/ = 1;
  s.opt_len = s.static_len = 0;
  s.last_lit = s.matches = 0;
}


/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */
function bi_windup(s)
{
  if (s.bi_valid > 8) {
    put_short(s, s.bi_buf);
  } else if (s.bi_valid > 0) {
    //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
  }
  s.bi_buf = 0;
  s.bi_valid = 0;
}

/* ===========================================================================
 * Copy a stored block, storing first the length and its
 * one's complement if requested.
 */
function copy_block(s, buf, len, header)
//DeflateState *s;
//charf    *buf;    /* the input data */
//unsigned len;     /* its length */
//int      header;  /* true if block header must be written */
{
  bi_windup(s);        /* align on byte boundary */

  if (header) {
    put_short(s, len);
    put_short(s, ~len);
  }
//  while (len--) {
//    put_byte(s, *buf++);
//  }
  utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
  s.pending += len;
}

/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */
function smaller(tree, n, m, depth) {
  var _n2 = n * 2;
  var _m2 = m * 2;
  return (tree[_n2]/*.Freq*/ < tree[_m2]/*.Freq*/ ||
         (tree[_n2]/*.Freq*/ === tree[_m2]/*.Freq*/ && depth[n] <= depth[m]));
}

/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */
function pqdownheap(s, tree, k)
//    deflate_state *s;
//    ct_data *tree;  /* the tree to restore */
//    int k;               /* node to move down */
{
  var v = s.heap[k];
  var j = k << 1;  /* left son of k */
  while (j <= s.heap_len) {
    /* Set j to the smallest of the two sons: */
    if (j < s.heap_len &&
      smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
      j++;
    }
    /* Exit if v is smaller than both sons */
    if (smaller(tree, v, s.heap[j], s.depth)) { break; }

    /* Exchange v with the smallest son */
    s.heap[k] = s.heap[j];
    k = j;

    /* And continue down the tree, setting j to the left son of k */
    j <<= 1;
  }
  s.heap[k] = v;
}


// inlined manually
// var SMALLEST = 1;

/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */
function compress_block(s, ltree, dtree)
//    deflate_state *s;
//    const ct_data *ltree; /* literal tree */
//    const ct_data *dtree; /* distance tree */
{
  var dist;           /* distance of matched string */
  var lc;             /* match length or unmatched char (if dist == 0) */
  var lx = 0;         /* running index in l_buf */
  var code;           /* the code to send */
  var extra;          /* number of extra bits to send */

  if (s.last_lit !== 0) {
    do {
      dist = (s.pending_buf[s.d_buf + lx * 2] << 8) | (s.pending_buf[s.d_buf + lx * 2 + 1]);
      lc = s.pending_buf[s.l_buf + lx];
      lx++;

      if (dist === 0) {
        send_code(s, lc, ltree); /* send a literal byte */
        //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
      } else {
        /* Here, lc is the match length - MIN_MATCH */
        code = _length_code[lc];
        send_code(s, code + LITERALS + 1, ltree); /* send the length code */
        extra = extra_lbits[code];
        if (extra !== 0) {
          lc -= base_length[code];
          send_bits(s, lc, extra);       /* send the extra length bits */
        }
        dist--; /* dist is now the match distance - 1 */
        code = d_code(dist);
        //Assert (code < D_CODES, "bad d_code");

        send_code(s, code, dtree);       /* send the distance code */
        extra = extra_dbits[code];
        if (extra !== 0) {
          dist -= base_dist[code];
          send_bits(s, dist, extra);   /* send the extra distance bits */
        }
      } /* literal or match pair ? */

      /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
      //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
      //       "pendingBuf overflow");

    } while (lx < s.last_lit);
  }

  send_code(s, END_BLOCK, ltree);
}


/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */
function build_tree(s, desc)
//    deflate_state *s;
//    tree_desc *desc; /* the tree descriptor */
{
  var tree     = desc.dyn_tree;
  var stree    = desc.stat_desc.static_tree;
  var has_stree = desc.stat_desc.has_stree;
  var elems    = desc.stat_desc.elems;
  var n, m;          /* iterate over heap elements */
  var max_code = -1; /* largest code with non zero frequency */
  var node;          /* new node being created */

  /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */
  s.heap_len = 0;
  s.heap_max = HEAP_SIZE;

  for (n = 0; n < elems; n++) {
    if (tree[n * 2]/*.Freq*/ !== 0) {
      s.heap[++s.heap_len] = max_code = n;
      s.depth[n] = 0;

    } else {
      tree[n * 2 + 1]/*.Len*/ = 0;
    }
  }

  /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */
  while (s.heap_len < 2) {
    node = s.heap[++s.heap_len] = (max_code < 2 ? ++max_code : 0);
    tree[node * 2]/*.Freq*/ = 1;
    s.depth[node] = 0;
    s.opt_len--;

    if (has_stree) {
      s.static_len -= stree[node * 2 + 1]/*.Len*/;
    }
    /* node is 0 or 1 so it does not have extra bits */
  }
  desc.max_code = max_code;

  /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */
  for (n = (s.heap_len >> 1/*int /2*/); n >= 1; n--) { pqdownheap(s, tree, n); }

  /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */
  node = elems;              /* next internal node of the tree */
  do {
    //pqremove(s, tree, n);  /* n = node of least frequency */
    /*** pqremove ***/
    n = s.heap[1/*SMALLEST*/];
    s.heap[1/*SMALLEST*/] = s.heap[s.heap_len--];
    pqdownheap(s, tree, 1/*SMALLEST*/);
    /***/

    m = s.heap[1/*SMALLEST*/]; /* m = node of next least frequency */

    s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
    s.heap[--s.heap_max] = m;

    /* Create a new node father of n and m */
    tree[node * 2]/*.Freq*/ = tree[n * 2]/*.Freq*/ + tree[m * 2]/*.Freq*/;
    s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
    tree[n * 2 + 1]/*.Dad*/ = tree[m * 2 + 1]/*.Dad*/ = node;

    /* and insert the new node in the heap */
    s.heap[1/*SMALLEST*/] = node++;
    pqdownheap(s, tree, 1/*SMALLEST*/);

  } while (s.heap_len >= 2);

  s.heap[--s.heap_max] = s.heap[1/*SMALLEST*/];

  /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */
  gen_bitlen(s, desc);

  /* The field len is now set, we can generate the bit codes */
  gen_codes(tree, max_code, s.bl_count);
}


/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */
function scan_tree(s, tree, max_code)
//    deflate_state *s;
//    ct_data *tree;   /* the tree to be scanned */
//    int max_code;    /* and its largest code of non zero frequency */
{
  var n;                     /* iterates over all tree elements */
  var prevlen = -1;          /* last emitted length */
  var curlen;                /* length of current code */

  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */

  var count = 0;             /* repeat count of the current code */
  var max_count = 7;         /* max repeat count */
  var min_count = 4;         /* min repeat count */

  if (nextlen === 0) {
    max_count = 138;
    min_count = 3;
  }
  tree[(max_code + 1) * 2 + 1]/*.Len*/ = 0xffff; /* guard */

  for (n = 0; n <= max_code; n++) {
    curlen = nextlen;
    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;

    if (++count < max_count && curlen === nextlen) {
      continue;

    } else if (count < min_count) {
      s.bl_tree[curlen * 2]/*.Freq*/ += count;

    } else if (curlen !== 0) {

      if (curlen !== prevlen) { s.bl_tree[curlen * 2]/*.Freq*/++; }
      s.bl_tree[REP_3_6 * 2]/*.Freq*/++;

    } else if (count <= 10) {
      s.bl_tree[REPZ_3_10 * 2]/*.Freq*/++;

    } else {
      s.bl_tree[REPZ_11_138 * 2]/*.Freq*/++;
    }

    count = 0;
    prevlen = curlen;

    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;

    } else if (curlen === nextlen) {
      max_count = 6;
      min_count = 3;

    } else {
      max_count = 7;
      min_count = 4;
    }
  }
}


/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */
function send_tree(s, tree, max_code)
//    deflate_state *s;
//    ct_data *tree; /* the tree to be scanned */
//    int max_code;       /* and its largest code of non zero frequency */
{
  var n;                     /* iterates over all tree elements */
  var prevlen = -1;          /* last emitted length */
  var curlen;                /* length of current code */

  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */

  var count = 0;             /* repeat count of the current code */
  var max_count = 7;         /* max repeat count */
  var min_count = 4;         /* min repeat count */

  /* tree[max_code+1].Len = -1; */  /* guard already set */
  if (nextlen === 0) {
    max_count = 138;
    min_count = 3;
  }

  for (n = 0; n <= max_code; n++) {
    curlen = nextlen;
    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;

    if (++count < max_count && curlen === nextlen) {
      continue;

    } else if (count < min_count) {
      do { send_code(s, curlen, s.bl_tree); } while (--count !== 0);

    } else if (curlen !== 0) {
      if (curlen !== prevlen) {
        send_code(s, curlen, s.bl_tree);
        count--;
      }
      //Assert(count >= 3 && count <= 6, " 3_6?");
      send_code(s, REP_3_6, s.bl_tree);
      send_bits(s, count - 3, 2);

    } else if (count <= 10) {
      send_code(s, REPZ_3_10, s.bl_tree);
      send_bits(s, count - 3, 3);

    } else {
      send_code(s, REPZ_11_138, s.bl_tree);
      send_bits(s, count - 11, 7);
    }

    count = 0;
    prevlen = curlen;
    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;

    } else if (curlen === nextlen) {
      max_count = 6;
      min_count = 3;

    } else {
      max_count = 7;
      min_count = 4;
    }
  }
}


/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */
function build_bl_tree(s) {
  var max_blindex;  /* index of last bit length code of non zero freq */

  /* Determine the bit length frequencies for literal and distance trees */
  scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
  scan_tree(s, s.dyn_dtree, s.d_desc.max_code);

  /* Build the bit length tree: */
  build_tree(s, s.bl_desc);
  /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */

  /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */
  for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
    if (s.bl_tree[bl_order[max_blindex] * 2 + 1]/*.Len*/ !== 0) {
      break;
    }
  }
  /* Update opt_len to include the bit length tree and counts */
  s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
  //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
  //        s->opt_len, s->static_len));

  return max_blindex;
}


/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */
function send_all_trees(s, lcodes, dcodes, blcodes)
//    deflate_state *s;
//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
{
  var rank;                    /* index in bl_order */

  //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
  //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
  //        "too many codes");
  //Tracev((stderr, "\nbl counts: "));
  send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */
  send_bits(s, dcodes - 1,   5);
  send_bits(s, blcodes - 4,  4); /* not -3 as stated in appnote.txt */
  for (rank = 0; rank < blcodes; rank++) {
    //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1]/*.Len*/, 3);
  }
  //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));

  send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */
  //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));

  send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */
  //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
}


/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "black list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */
function detect_data_type(s) {
  /* black_mask is the bit mask of black-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */
  var black_mask = 0xf3ffc07f;
  var n;

  /* Check for non-textual ("black-listed") bytes. */
  for (n = 0; n <= 31; n++, black_mask >>>= 1) {
    if ((black_mask & 1) && (s.dyn_ltree[n * 2]/*.Freq*/ !== 0)) {
      return Z_BINARY;
    }
  }

  /* Check for textual ("white-listed") bytes. */
  if (s.dyn_ltree[9 * 2]/*.Freq*/ !== 0 || s.dyn_ltree[10 * 2]/*.Freq*/ !== 0 ||
      s.dyn_ltree[13 * 2]/*.Freq*/ !== 0) {
    return Z_TEXT;
  }
  for (n = 32; n < LITERALS; n++) {
    if (s.dyn_ltree[n * 2]/*.Freq*/ !== 0) {
      return Z_TEXT;
    }
  }

  /* There are no "black-listed" or "white-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */
  return Z_BINARY;
}


var static_init_done = false;

/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */
function _tr_init(s)
{

  if (!static_init_done) {
    tr_static_init();
    static_init_done = true;
  }

  s.l_desc  = new TreeDesc(s.dyn_ltree, static_l_desc);
  s.d_desc  = new TreeDesc(s.dyn_dtree, static_d_desc);
  s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);

  s.bi_buf = 0;
  s.bi_valid = 0;

  /* Initialize the first block of the first file: */
  init_block(s);
}


/* ===========================================================================
 * Send a stored block
 */
function _tr_stored_block(s, buf, stored_len, last)
//DeflateState *s;
//charf *buf;       /* input block */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
  send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);    /* send block type */
  copy_block(s, buf, stored_len, true); /* with header */
}


/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */
function _tr_align(s) {
  send_bits(s, STATIC_TREES << 1, 3);
  send_code(s, END_BLOCK, static_ltree);
  bi_flush(s);
}


/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and output the encoded block to the zip file.
 */
function _tr_flush_block(s, buf, stored_len, last)
//DeflateState *s;
//charf *buf;       /* input block, or NULL if too old */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
  var opt_lenb, static_lenb;  /* opt_len and static_len in bytes */
  var max_blindex = 0;        /* index of last bit length code of non zero freq */

  /* Build the Huffman trees unless a stored block is forced */
  if (s.level > 0) {

    /* Check if the file is binary or text */
    if (s.strm.data_type === Z_UNKNOWN) {
      s.strm.data_type = detect_data_type(s);
    }

    /* Construct the literal and distance trees */
    build_tree(s, s.l_desc);
    // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
    //        s->static_len));

    build_tree(s, s.d_desc);
    // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
    //        s->static_len));
    /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */

    /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */
    max_blindex = build_bl_tree(s);

    /* Determine the best encoding. Compute the block lengths in bytes. */
    opt_lenb = (s.opt_len + 3 + 7) >>> 3;
    static_lenb = (s.static_len + 3 + 7) >>> 3;

    // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
    //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
    //        s->last_lit));

    if (static_lenb <= opt_lenb) { opt_lenb = static_lenb; }

  } else {
    // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
  }

  if ((stored_len + 4 <= opt_lenb) && (buf !== -1)) {
    /* 4: two words for the lengths */

    /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */
    _tr_stored_block(s, buf, stored_len, last);

  } else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {

    send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
    compress_block(s, static_ltree, static_dtree);

  } else {
    send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
    send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
    compress_block(s, s.dyn_ltree, s.dyn_dtree);
  }
  // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
  /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */
  init_block(s);

  if (last) {
    bi_windup(s);
  }
  // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
  //       s->compressed_len-7*last));
}

/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */
function _tr_tally(s, dist, lc)
//    deflate_state *s;
//    unsigned dist;  /* distance of matched string */
//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
{
  //var out_length, in_length, dcode;

  s.pending_buf[s.d_buf + s.last_lit * 2]     = (dist >>> 8) & 0xff;
  s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;

  s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
  s.last_lit++;

  if (dist === 0) {
    /* lc is the unmatched char */
    s.dyn_ltree[lc * 2]/*.Freq*/++;
  } else {
    s.matches++;
    /* Here, lc is the match length - MIN_MATCH */
    dist--;             /* dist = match distance - 1 */
    //Assert((ush)dist < (ush)MAX_DIST(s) &&
    //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
    //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");

    s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2]/*.Freq*/++;
    s.dyn_dtree[d_code(dist) * 2]/*.Freq*/++;
  }

// (!) This block is disabled in zlib defaults,
// don't enable it for binary compatibility

//#ifdef TRUNCATE_BLOCK
//  /* Try to guess if it is profitable to stop the current block here */
//  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
//    /* Compute an upper bound for the compressed length */
//    out_length = s.last_lit*8;
//    in_length = s.strstart - s.block_start;
//
//    for (dcode = 0; dcode < D_CODES; dcode++) {
//      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
//    }
//    out_length >>>= 3;
//    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
//    //       s->last_lit, in_length, out_length,
//    //       100L - out_length*100L/in_length));
//    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
//      return true;
//    }
//  }
//#endif

  return (s.last_lit === s.lit_bufsize - 1);
  /* We avoid equality with lit_bufsize because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */
}

exports._tr_init  = _tr_init;
exports._tr_stored_block = _tr_stored_block;
exports._tr_flush_block  = _tr_flush_block;
exports._tr_tally = _tr_tally;
exports._tr_align = _tr_align;

},{"../utils/common":1170}],1180:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

function ZStream() {
  /* next input byte */
  this.input = null; // JS specific, because we have no pointers
  this.next_in = 0;
  /* number of bytes available at input */
  this.avail_in = 0;
  /* total number of input bytes read so far */
  this.total_in = 0;
  /* next output byte should be put there */
  this.output = null; // JS specific, because we have no pointers
  this.next_out = 0;
  /* remaining free space at output */
  this.avail_out = 0;
  /* total number of bytes output so far */
  this.total_out = 0;
  /* last error message, NULL if no error */
  this.msg = ''/*Z_NULL*/;
  /* not visible by applications */
  this.state = null;
  /* best guess about the data type: binary or text */
  this.data_type = 2/*Z_UNKNOWN*/;
  /* adler32 value of the uncompressed data */
  this.adler = 0;
}

module.exports = ZStream;

},{}],1181:[function(require,module,exports){
(function (process,global,Buffer){(function (){
/* Copyright 2017 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("pdfjs-dist/build/pdf", [], factory);
	else if(typeof exports === 'object')
		exports["pdfjs-dist/build/pdf"] = factory();
	else
		root["pdfjs-dist/build/pdf"] = root.pdfjsDistBuildPdf = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __w_pdfjs_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __w_pdfjs_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__w_pdfjs_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__w_pdfjs_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__w_pdfjs_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__w_pdfjs_require__.d = function(exports, name, getter) {
/******/ 		if(!__w_pdfjs_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__w_pdfjs_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__w_pdfjs_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__w_pdfjs_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__w_pdfjs_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __w_pdfjs_require__(__w_pdfjs_require__.s = 15);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unreachable = exports.warn = exports.utf8StringToString = exports.stringToUTF8String = exports.stringToPDFString = exports.stringToBytes = exports.string32 = exports.shadow = exports.setVerbosityLevel = exports.ReadableStream = exports.removeNullCharacters = exports.readUint32 = exports.readUint16 = exports.readInt8 = exports.log2 = exports.loadJpegStream = exports.isEvalSupported = exports.isLittleEndian = exports.createValidAbsoluteUrl = exports.isSameOrigin = exports.isNodeJS = exports.isSpace = exports.isString = exports.isNum = exports.isInt = exports.isEmptyObj = exports.isBool = exports.isArrayBuffer = exports.isArray = exports.info = exports.globalScope = exports.getVerbosityLevel = exports.getLookupTableFactory = exports.deprecated = exports.createObjectURL = exports.createPromiseCapability = exports.createBlob = exports.bytesToString = exports.assert = exports.arraysToBytes = exports.arrayByteLength = exports.FormatError = exports.XRefParseException = exports.Util = exports.UnknownErrorException = exports.UnexpectedResponseException = exports.TextRenderingMode = exports.StreamType = exports.StatTimer = exports.PasswordResponses = exports.PasswordException = exports.PageViewport = exports.NotImplementedException = exports.NativeImageDecoding = exports.MissingPDFException = exports.MissingDataException = exports.MessageHandler = exports.InvalidPDFException = exports.AbortException = exports.CMapCompressionType = exports.ImageKind = exports.FontType = exports.AnnotationType = exports.AnnotationFlag = exports.AnnotationFieldFlag = exports.AnnotationBorderStyleType = exports.UNSUPPORTED_FEATURES = exports.VERBOSITY_LEVELS = exports.OPS = exports.IDENTITY_MATRIX = exports.FONT_IDENTITY_MATRIX = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

__w_pdfjs_require__(16);

var _streams_polyfill = __w_pdfjs_require__(17);

var globalScope = typeof window !== 'undefined' && window.Math === Math ? window : typeof global !== 'undefined' && global.Math === Math ? global : typeof self !== 'undefined' && self.Math === Math ? self : undefined;
var FONT_IDENTITY_MATRIX = [0.001, 0, 0, 0.001, 0, 0];
var NativeImageDecoding = {
  NONE: 'none',
  DECODE: 'decode',
  DISPLAY: 'display'
};
var TextRenderingMode = {
  FILL: 0,
  STROKE: 1,
  FILL_STROKE: 2,
  INVISIBLE: 3,
  FILL_ADD_TO_PATH: 4,
  STROKE_ADD_TO_PATH: 5,
  FILL_STROKE_ADD_TO_PATH: 6,
  ADD_TO_PATH: 7,
  FILL_STROKE_MASK: 3,
  ADD_TO_PATH_FLAG: 4
};
var ImageKind = {
  GRAYSCALE_1BPP: 1,
  RGB_24BPP: 2,
  RGBA_32BPP: 3
};
var AnnotationType = {
  TEXT: 1,
  LINK: 2,
  FREETEXT: 3,
  LINE: 4,
  SQUARE: 5,
  CIRCLE: 6,
  POLYGON: 7,
  POLYLINE: 8,
  HIGHLIGHT: 9,
  UNDERLINE: 10,
  SQUIGGLY: 11,
  STRIKEOUT: 12,
  STAMP: 13,
  CARET: 14,
  INK: 15,
  POPUP: 16,
  FILEATTACHMENT: 17,
  SOUND: 18,
  MOVIE: 19,
  WIDGET: 20,
  SCREEN: 21,
  PRINTERMARK: 22,
  TRAPNET: 23,
  WATERMARK: 24,
  THREED: 25,
  REDACT: 26
};
var AnnotationFlag = {
  INVISIBLE: 0x01,
  HIDDEN: 0x02,
  PRINT: 0x04,
  NOZOOM: 0x08,
  NOROTATE: 0x10,
  NOVIEW: 0x20,
  READONLY: 0x40,
  LOCKED: 0x80,
  TOGGLENOVIEW: 0x100,
  LOCKEDCONTENTS: 0x200
};
var AnnotationFieldFlag = {
  READONLY: 0x0000001,
  REQUIRED: 0x0000002,
  NOEXPORT: 0x0000004,
  MULTILINE: 0x0001000,
  PASSWORD: 0x0002000,
  NOTOGGLETOOFF: 0x0004000,
  RADIO: 0x0008000,
  PUSHBUTTON: 0x0010000,
  COMBO: 0x0020000,
  EDIT: 0x0040000,
  SORT: 0x0080000,
  FILESELECT: 0x0100000,
  MULTISELECT: 0x0200000,
  DONOTSPELLCHECK: 0x0400000,
  DONOTSCROLL: 0x0800000,
  COMB: 0x1000000,
  RICHTEXT: 0x2000000,
  RADIOSINUNISON: 0x2000000,
  COMMITONSELCHANGE: 0x4000000
};
var AnnotationBorderStyleType = {
  SOLID: 1,
  DASHED: 2,
  BEVELED: 3,
  INSET: 4,
  UNDERLINE: 5
};
var StreamType = {
  UNKNOWN: 0,
  FLATE: 1,
  LZW: 2,
  DCT: 3,
  JPX: 4,
  JBIG: 5,
  A85: 6,
  AHX: 7,
  CCF: 8,
  RL: 9
};
var FontType = {
  UNKNOWN: 0,
  TYPE1: 1,
  TYPE1C: 2,
  CIDFONTTYPE0: 3,
  CIDFONTTYPE0C: 4,
  TRUETYPE: 5,
  CIDFONTTYPE2: 6,
  TYPE3: 7,
  OPENTYPE: 8,
  TYPE0: 9,
  MMTYPE1: 10
};
var VERBOSITY_LEVELS = {
  errors: 0,
  warnings: 1,
  infos: 5
};
var CMapCompressionType = {
  NONE: 0,
  BINARY: 1,
  STREAM: 2
};
var OPS = {
  dependency: 1,
  setLineWidth: 2,
  setLineCap: 3,
  setLineJoin: 4,
  setMiterLimit: 5,
  setDash: 6,
  setRenderingIntent: 7,
  setFlatness: 8,
  setGState: 9,
  save: 10,
  restore: 11,
  transform: 12,
  moveTo: 13,
  lineTo: 14,
  curveTo: 15,
  curveTo2: 16,
  curveTo3: 17,
  closePath: 18,
  rectangle: 19,
  stroke: 20,
  closeStroke: 21,
  fill: 22,
  eoFill: 23,
  fillStroke: 24,
  eoFillStroke: 25,
  closeFillStroke: 26,
  closeEOFillStroke: 27,
  endPath: 28,
  clip: 29,
  eoClip: 30,
  beginText: 31,
  endText: 32,
  setCharSpacing: 33,
  setWordSpacing: 34,
  setHScale: 35,
  setLeading: 36,
  setFont: 37,
  setTextRenderingMode: 38,
  setTextRise: 39,
  moveText: 40,
  setLeadingMoveText: 41,
  setTextMatrix: 42,
  nextLine: 43,
  showText: 44,
  showSpacedText: 45,
  nextLineShowText: 46,
  nextLineSetSpacingShowText: 47,
  setCharWidth: 48,
  setCharWidthAndBounds: 49,
  setStrokeColorSpace: 50,
  setFillColorSpace: 51,
  setStrokeColor: 52,
  setStrokeColorN: 53,
  setFillColor: 54,
  setFillColorN: 55,
  setStrokeGray: 56,
  setFillGray: 57,
  setStrokeRGBColor: 58,
  setFillRGBColor: 59,
  setStrokeCMYKColor: 60,
  setFillCMYKColor: 61,
  shadingFill: 62,
  beginInlineImage: 63,
  beginImageData: 64,
  endInlineImage: 65,
  paintXObject: 66,
  markPoint: 67,
  markPointProps: 68,
  beginMarkedContent: 69,
  beginMarkedContentProps: 70,
  endMarkedContent: 71,
  beginCompat: 72,
  endCompat: 73,
  paintFormXObjectBegin: 74,
  paintFormXObjectEnd: 75,
  beginGroup: 76,
  endGroup: 77,
  beginAnnotations: 78,
  endAnnotations: 79,
  beginAnnotation: 80,
  endAnnotation: 81,
  paintJpegXObject: 82,
  paintImageMaskXObject: 83,
  paintImageMaskXObjectGroup: 84,
  paintImageXObject: 85,
  paintInlineImageXObject: 86,
  paintInlineImageXObjectGroup: 87,
  paintImageXObjectRepeat: 88,
  paintImageMaskXObjectRepeat: 89,
  paintSolidColorImageMask: 90,
  constructPath: 91
};
var verbosity = VERBOSITY_LEVELS.warnings;
function setVerbosityLevel(level) {
  verbosity = level;
}
function getVerbosityLevel() {
  return verbosity;
}
function info(msg) {
  if (verbosity >= VERBOSITY_LEVELS.infos) {
    console.log('Info: ' + msg);
  }
}
function warn(msg) {
  if (verbosity >= VERBOSITY_LEVELS.warnings) {
    console.log('Warning: ' + msg);
  }
}
function deprecated(details) {
  console.log('Deprecated API usage: ' + details);
}
function unreachable(msg) {
  throw new Error(msg);
}
function assert(cond, msg) {
  if (!cond) {
    unreachable(msg);
  }
}
var UNSUPPORTED_FEATURES = {
  unknown: 'unknown',
  forms: 'forms',
  javaScript: 'javaScript',
  smask: 'smask',
  shadingPattern: 'shadingPattern',
  font: 'font'
};
function isSameOrigin(baseUrl, otherUrl) {
  try {
    var base = new URL(baseUrl);
    if (!base.origin || base.origin === 'null') {
      return false;
    }
  } catch (e) {
    return false;
  }
  var other = new URL(otherUrl, base);
  return base.origin === other.origin;
}
function isValidProtocol(url) {
  if (!url) {
    return false;
  }
  switch (url.protocol) {
    case 'http:':
    case 'https:':
    case 'ftp:':
    case 'mailto:':
    case 'tel:':
      return true;
    default:
      return false;
  }
}
function createValidAbsoluteUrl(url, baseUrl) {
  if (!url) {
    return null;
  }
  try {
    var absoluteUrl = baseUrl ? new URL(url, baseUrl) : new URL(url);
    if (isValidProtocol(absoluteUrl)) {
      return absoluteUrl;
    }
  } catch (ex) {}
  return null;
}
function shadow(obj, prop, value) {
  Object.defineProperty(obj, prop, {
    value: value,
    enumerable: true,
    configurable: true,
    writable: false
  });
  return value;
}
function getLookupTableFactory(initializer) {
  var lookup;
  return function () {
    if (initializer) {
      lookup = Object.create(null);
      initializer(lookup);
      initializer = null;
    }
    return lookup;
  };
}
var PasswordResponses = {
  NEED_PASSWORD: 1,
  INCORRECT_PASSWORD: 2
};
var PasswordException = function PasswordExceptionClosure() {
  function PasswordException(msg, code) {
    this.name = 'PasswordException';
    this.message = msg;
    this.code = code;
  }
  PasswordException.prototype = new Error();
  PasswordException.constructor = PasswordException;
  return PasswordException;
}();
var UnknownErrorException = function UnknownErrorExceptionClosure() {
  function UnknownErrorException(msg, details) {
    this.name = 'UnknownErrorException';
    this.message = msg;
    this.details = details;
  }
  UnknownErrorException.prototype = new Error();
  UnknownErrorException.constructor = UnknownErrorException;
  return UnknownErrorException;
}();
var InvalidPDFException = function InvalidPDFExceptionClosure() {
  function InvalidPDFException(msg) {
    this.name = 'InvalidPDFException';
    this.message = msg;
  }
  InvalidPDFException.prototype = new Error();
  InvalidPDFException.constructor = InvalidPDFException;
  return InvalidPDFException;
}();
var MissingPDFException = function MissingPDFExceptionClosure() {
  function MissingPDFException(msg) {
    this.name = 'MissingPDFException';
    this.message = msg;
  }
  MissingPDFException.prototype = new Error();
  MissingPDFException.constructor = MissingPDFException;
  return MissingPDFException;
}();
var UnexpectedResponseException = function UnexpectedResponseExceptionClosure() {
  function UnexpectedResponseException(msg, status) {
    this.name = 'UnexpectedResponseException';
    this.message = msg;
    this.status = status;
  }
  UnexpectedResponseException.prototype = new Error();
  UnexpectedResponseException.constructor = UnexpectedResponseException;
  return UnexpectedResponseException;
}();
var NotImplementedException = function NotImplementedExceptionClosure() {
  function NotImplementedException(msg) {
    this.message = msg;
  }
  NotImplementedException.prototype = new Error();
  NotImplementedException.prototype.name = 'NotImplementedException';
  NotImplementedException.constructor = NotImplementedException;
  return NotImplementedException;
}();
var MissingDataException = function MissingDataExceptionClosure() {
  function MissingDataException(begin, end) {
    this.begin = begin;
    this.end = end;
    this.message = 'Missing data [' + begin + ', ' + end + ')';
  }
  MissingDataException.prototype = new Error();
  MissingDataException.prototype.name = 'MissingDataException';
  MissingDataException.constructor = MissingDataException;
  return MissingDataException;
}();
var XRefParseException = function XRefParseExceptionClosure() {
  function XRefParseException(msg) {
    this.message = msg;
  }
  XRefParseException.prototype = new Error();
  XRefParseException.prototype.name = 'XRefParseException';
  XRefParseException.constructor = XRefParseException;
  return XRefParseException;
}();
var FormatError = function FormatErrorClosure() {
  function FormatError(msg) {
    this.message = msg;
  }
  FormatError.prototype = new Error();
  FormatError.prototype.name = 'FormatError';
  FormatError.constructor = FormatError;
  return FormatError;
}();
var AbortException = function AbortExceptionClosure() {
  function AbortException(msg) {
    this.name = 'AbortException';
    this.message = msg;
  }
  AbortException.prototype = new Error();
  AbortException.constructor = AbortException;
  return AbortException;
}();
var NullCharactersRegExp = /\x00/g;
function removeNullCharacters(str) {
  if (typeof str !== 'string') {
    warn('The argument for removeNullCharacters must be a string.');
    return str;
  }
  return str.replace(NullCharactersRegExp, '');
}
function bytesToString(bytes) {
  assert(bytes !== null && (typeof bytes === 'undefined' ? 'undefined' : _typeof(bytes)) === 'object' && bytes.length !== undefined, 'Invalid argument for bytesToString');
  var length = bytes.length;
  var MAX_ARGUMENT_COUNT = 8192;
  if (length < MAX_ARGUMENT_COUNT) {
    return String.fromCharCode.apply(null, bytes);
  }
  var strBuf = [];
  for (var i = 0; i < length; i += MAX_ARGUMENT_COUNT) {
    var chunkEnd = Math.min(i + MAX_ARGUMENT_COUNT, length);
    var chunk = bytes.subarray(i, chunkEnd);
    strBuf.push(String.fromCharCode.apply(null, chunk));
  }
  return strBuf.join('');
}
function stringToBytes(str) {
  assert(typeof str === 'string', 'Invalid argument for stringToBytes');
  var length = str.length;
  var bytes = new Uint8Array(length);
  for (var i = 0; i < length; ++i) {
    bytes[i] = str.charCodeAt(i) & 0xFF;
  }
  return bytes;
}
function arrayByteLength(arr) {
  if (arr.length !== undefined) {
    return arr.length;
  }
  assert(arr.byteLength !== undefined);
  return arr.byteLength;
}
function arraysToBytes(arr) {
  if (arr.length === 1 && arr[0] instanceof Uint8Array) {
    return arr[0];
  }
  var resultLength = 0;
  var i,
      ii = arr.length;
  var item, itemLength;
  for (i = 0; i < ii; i++) {
    item = arr[i];
    itemLength = arrayByteLength(item);
    resultLength += itemLength;
  }
  var pos = 0;
  var data = new Uint8Array(resultLength);
  for (i = 0; i < ii; i++) {
    item = arr[i];
    if (!(item instanceof Uint8Array)) {
      if (typeof item === 'string') {
        item = stringToBytes(item);
      } else {
        item = new Uint8Array(item);
      }
    }
    itemLength = item.byteLength;
    data.set(item, pos);
    pos += itemLength;
  }
  return data;
}
function string32(value) {
  return String.fromCharCode(value >> 24 & 0xff, value >> 16 & 0xff, value >> 8 & 0xff, value & 0xff);
}
function log2(x) {
  var n = 1,
      i = 0;
  while (x > n) {
    n <<= 1;
    i++;
  }
  return i;
}
function readInt8(data, start) {
  return data[start] << 24 >> 24;
}
function readUint16(data, offset) {
  return data[offset] << 8 | data[offset + 1];
}
function readUint32(data, offset) {
  return (data[offset] << 24 | data[offset + 1] << 16 | data[offset + 2] << 8 | data[offset + 3]) >>> 0;
}
function isLittleEndian() {
  var buffer8 = new Uint8Array(4);
  buffer8[0] = 1;
  var view32 = new Uint32Array(buffer8.buffer, 0, 1);
  return view32[0] === 1;
}
function isEvalSupported() {
  try {
    new Function('');
    return true;
  } catch (e) {
    return false;
  }
}
var IDENTITY_MATRIX = [1, 0, 0, 1, 0, 0];
var Util = function UtilClosure() {
  function Util() {}
  var rgbBuf = ['rgb(', 0, ',', 0, ',', 0, ')'];
  Util.makeCssRgb = function Util_makeCssRgb(r, g, b) {
    rgbBuf[1] = r;
    rgbBuf[3] = g;
    rgbBuf[5] = b;
    return rgbBuf.join('');
  };
  Util.transform = function Util_transform(m1, m2) {
    return [m1[0] * m2[0] + m1[2] * m2[1], m1[1] * m2[0] + m1[3] * m2[1], m1[0] * m2[2] + m1[2] * m2[3], m1[1] * m2[2] + m1[3] * m2[3], m1[0] * m2[4] + m1[2] * m2[5] + m1[4], m1[1] * m2[4] + m1[3] * m2[5] + m1[5]];
  };
  Util.applyTransform = function Util_applyTransform(p, m) {
    var xt = p[0] * m[0] + p[1] * m[2] + m[4];
    var yt = p[0] * m[1] + p[1] * m[3] + m[5];
    return [xt, yt];
  };
  Util.applyInverseTransform = function Util_applyInverseTransform(p, m) {
    var d = m[0] * m[3] - m[1] * m[2];
    var xt = (p[0] * m[3] - p[1] * m[2] + m[2] * m[5] - m[4] * m[3]) / d;
    var yt = (-p[0] * m[1] + p[1] * m[0] + m[4] * m[1] - m[5] * m[0]) / d;
    return [xt, yt];
  };
  Util.getAxialAlignedBoundingBox = function Util_getAxialAlignedBoundingBox(r, m) {
    var p1 = Util.applyTransform(r, m);
    var p2 = Util.applyTransform(r.slice(2, 4), m);
    var p3 = Util.applyTransform([r[0], r[3]], m);
    var p4 = Util.applyTransform([r[2], r[1]], m);
    return [Math.min(p1[0], p2[0], p3[0], p4[0]), Math.min(p1[1], p2[1], p3[1], p4[1]), Math.max(p1[0], p2[0], p3[0], p4[0]), Math.max(p1[1], p2[1], p3[1], p4[1])];
  };
  Util.inverseTransform = function Util_inverseTransform(m) {
    var d = m[0] * m[3] - m[1] * m[2];
    return [m[3] / d, -m[1] / d, -m[2] / d, m[0] / d, (m[2] * m[5] - m[4] * m[3]) / d, (m[4] * m[1] - m[5] * m[0]) / d];
  };
  Util.apply3dTransform = function Util_apply3dTransform(m, v) {
    return [m[0] * v[0] + m[1] * v[1] + m[2] * v[2], m[3] * v[0] + m[4] * v[1] + m[5] * v[2], m[6] * v[0] + m[7] * v[1] + m[8] * v[2]];
  };
  Util.singularValueDecompose2dScale = function Util_singularValueDecompose2dScale(m) {
    var transpose = [m[0], m[2], m[1], m[3]];
    var a = m[0] * transpose[0] + m[1] * transpose[2];
    var b = m[0] * transpose[1] + m[1] * transpose[3];
    var c = m[2] * transpose[0] + m[3] * transpose[2];
    var d = m[2] * transpose[1] + m[3] * transpose[3];
    var first = (a + d) / 2;
    var second = Math.sqrt((a + d) * (a + d) - 4 * (a * d - c * b)) / 2;
    var sx = first + second || 1;
    var sy = first - second || 1;
    return [Math.sqrt(sx), Math.sqrt(sy)];
  };
  Util.normalizeRect = function Util_normalizeRect(rect) {
    var r = rect.slice(0);
    if (rect[0] > rect[2]) {
      r[0] = rect[2];
      r[2] = rect[0];
    }
    if (rect[1] > rect[3]) {
      r[1] = rect[3];
      r[3] = rect[1];
    }
    return r;
  };
  Util.intersect = function Util_intersect(rect1, rect2) {
    function compare(a, b) {
      return a - b;
    }
    var orderedX = [rect1[0], rect1[2], rect2[0], rect2[2]].sort(compare),
        orderedY = [rect1[1], rect1[3], rect2[1], rect2[3]].sort(compare),
        result = [];
    rect1 = Util.normalizeRect(rect1);
    rect2 = Util.normalizeRect(rect2);
    if (orderedX[0] === rect1[0] && orderedX[1] === rect2[0] || orderedX[0] === rect2[0] && orderedX[1] === rect1[0]) {
      result[0] = orderedX[1];
      result[2] = orderedX[2];
    } else {
      return false;
    }
    if (orderedY[0] === rect1[1] && orderedY[1] === rect2[1] || orderedY[0] === rect2[1] && orderedY[1] === rect1[1]) {
      result[1] = orderedY[1];
      result[3] = orderedY[2];
    } else {
      return false;
    }
    return result;
  };
  Util.sign = function Util_sign(num) {
    return num < 0 ? -1 : 1;
  };
  var ROMAN_NUMBER_MAP = ['', 'C', 'CC', 'CCC', 'CD', 'D', 'DC', 'DCC', 'DCCC', 'CM', '', 'X', 'XX', 'XXX', 'XL', 'L', 'LX', 'LXX', 'LXXX', 'XC', '', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX'];
  Util.toRoman = function Util_toRoman(number, lowerCase) {
    assert(isInt(number) && number > 0, 'The number should be a positive integer.');
    var pos,
        romanBuf = [];
    while (number >= 1000) {
      number -= 1000;
      romanBuf.push('M');
    }
    pos = number / 100 | 0;
    number %= 100;
    romanBuf.push(ROMAN_NUMBER_MAP[pos]);
    pos = number / 10 | 0;
    number %= 10;
    romanBuf.push(ROMAN_NUMBER_MAP[10 + pos]);
    romanBuf.push(ROMAN_NUMBER_MAP[20 + number]);
    var romanStr = romanBuf.join('');
    return lowerCase ? romanStr.toLowerCase() : romanStr;
  };
  Util.appendToArray = function Util_appendToArray(arr1, arr2) {
    Array.prototype.push.apply(arr1, arr2);
  };
  Util.prependToArray = function Util_prependToArray(arr1, arr2) {
    Array.prototype.unshift.apply(arr1, arr2);
  };
  Util.extendObj = function extendObj(obj1, obj2) {
    for (var key in obj2) {
      obj1[key] = obj2[key];
    }
  };
  Util.getInheritableProperty = function Util_getInheritableProperty(dict, name, getArray) {
    while (dict && !dict.has(name)) {
      dict = dict.get('Parent');
    }
    if (!dict) {
      return null;
    }
    return getArray ? dict.getArray(name) : dict.get(name);
  };
  Util.inherit = function Util_inherit(sub, base, prototype) {
    sub.prototype = Object.create(base.prototype);
    sub.prototype.constructor = sub;
    for (var prop in prototype) {
      sub.prototype[prop] = prototype[prop];
    }
  };
  Util.loadScript = function Util_loadScript(src, callback) {
    var script = document.createElement('script');
    var loaded = false;
    script.setAttribute('src', src);
    if (callback) {
      script.onload = function () {
        if (!loaded) {
          callback();
        }
        loaded = true;
      };
    }
    document.getElementsByTagName('head')[0].appendChild(script);
  };
  return Util;
}();
var PageViewport = function PageViewportClosure() {
  function PageViewport(viewBox, scale, rotation, offsetX, offsetY, dontFlip) {
    this.viewBox = viewBox;
    this.scale = scale;
    this.rotation = rotation;
    this.offsetX = offsetX;
    this.offsetY = offsetY;
    var centerX = (viewBox[2] + viewBox[0]) / 2;
    var centerY = (viewBox[3] + viewBox[1]) / 2;
    var rotateA, rotateB, rotateC, rotateD;
    rotation = rotation % 360;
    rotation = rotation < 0 ? rotation + 360 : rotation;
    switch (rotation) {
      case 180:
        rotateA = -1;
        rotateB = 0;
        rotateC = 0;
        rotateD = 1;
        break;
      case 90:
        rotateA = 0;
        rotateB = 1;
        rotateC = 1;
        rotateD = 0;
        break;
      case 270:
        rotateA = 0;
        rotateB = -1;
        rotateC = -1;
        rotateD = 0;
        break;
      default:
        rotateA = 1;
        rotateB = 0;
        rotateC = 0;
        rotateD = -1;
        break;
    }
    if (dontFlip) {
      rotateC = -rotateC;
      rotateD = -rotateD;
    }
    var offsetCanvasX, offsetCanvasY;
    var width, height;
    if (rotateA === 0) {
      offsetCanvasX = Math.abs(centerY - viewBox[1]) * scale + offsetX;
      offsetCanvasY = Math.abs(centerX - viewBox[0]) * scale + offsetY;
      width = Math.abs(viewBox[3] - viewBox[1]) * scale;
      height = Math.abs(viewBox[2] - viewBox[0]) * scale;
    } else {
      offsetCanvasX = Math.abs(centerX - viewBox[0]) * scale + offsetX;
      offsetCanvasY = Math.abs(centerY - viewBox[1]) * scale + offsetY;
      width = Math.abs(viewBox[2] - viewBox[0]) * scale;
      height = Math.abs(viewBox[3] - viewBox[1]) * scale;
    }
    this.transform = [rotateA * scale, rotateB * scale, rotateC * scale, rotateD * scale, offsetCanvasX - rotateA * scale * centerX - rotateC * scale * centerY, offsetCanvasY - rotateB * scale * centerX - rotateD * scale * centerY];
    this.width = width;
    this.height = height;
    this.fontScale = scale;
  }
  PageViewport.prototype = {
    clone: function PageViewPort_clone(args) {
      args = args || {};
      var scale = 'scale' in args ? args.scale : this.scale;
      var rotation = 'rotation' in args ? args.rotation : this.rotation;
      return new PageViewport(this.viewBox.slice(), scale, rotation, this.offsetX, this.offsetY, args.dontFlip);
    },
    convertToViewportPoint: function PageViewport_convertToViewportPoint(x, y) {
      return Util.applyTransform([x, y], this.transform);
    },
    convertToViewportRectangle: function PageViewport_convertToViewportRectangle(rect) {
      var tl = Util.applyTransform([rect[0], rect[1]], this.transform);
      var br = Util.applyTransform([rect[2], rect[3]], this.transform);
      return [tl[0], tl[1], br[0], br[1]];
    },
    convertToPdfPoint: function PageViewport_convertToPdfPoint(x, y) {
      return Util.applyInverseTransform([x, y], this.transform);
    }
  };
  return PageViewport;
}();
var PDFStringTranslateTable = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0x2D8, 0x2C7, 0x2C6, 0x2D9, 0x2DD, 0x2DB, 0x2DA, 0x2DC, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0x2022, 0x2020, 0x2021, 0x2026, 0x2014, 0x2013, 0x192, 0x2044, 0x2039, 0x203A, 0x2212, 0x2030, 0x201E, 0x201C, 0x201D, 0x2018, 0x2019, 0x201A, 0x2122, 0xFB01, 0xFB02, 0x141, 0x152, 0x160, 0x178, 0x17D, 0x131, 0x142, 0x153, 0x161, 0x17E, 0, 0x20AC];
function stringToPDFString(str) {
  var i,
      n = str.length,
      strBuf = [];
  if (str[0] === '\xFE' && str[1] === '\xFF') {
    for (i = 2; i < n; i += 2) {
      strBuf.push(String.fromCharCode(str.charCodeAt(i) << 8 | str.charCodeAt(i + 1)));
    }
  } else {
    for (i = 0; i < n; ++i) {
      var code = PDFStringTranslateTable[str.charCodeAt(i)];
      strBuf.push(code ? String.fromCharCode(code) : str.charAt(i));
    }
  }
  return strBuf.join('');
}
function stringToUTF8String(str) {
  return decodeURIComponent(escape(str));
}
function utf8StringToString(str) {
  return unescape(encodeURIComponent(str));
}
function isEmptyObj(obj) {
  for (var key in obj) {
    return false;
  }
  return true;
}
function isBool(v) {
  return typeof v === 'boolean';
}
function isInt(v) {
  return typeof v === 'number' && (v | 0) === v;
}
function isNum(v) {
  return typeof v === 'number';
}
function isString(v) {
  return typeof v === 'string';
}
function isArray(v) {
  return v instanceof Array;
}
function isArrayBuffer(v) {
  return (typeof v === 'undefined' ? 'undefined' : _typeof(v)) === 'object' && v !== null && v.byteLength !== undefined;
}
function isSpace(ch) {
  return ch === 0x20 || ch === 0x09 || ch === 0x0D || ch === 0x0A;
}
function isNodeJS() {
  return (typeof process === 'undefined' ? 'undefined' : _typeof(process)) === 'object' && process + '' === '[object process]';
}
function createPromiseCapability() {
  var capability = {};
  capability.promise = new Promise(function (resolve, reject) {
    capability.resolve = resolve;
    capability.reject = reject;
  });
  return capability;
}
var StatTimer = function StatTimerClosure() {
  function rpad(str, pad, length) {
    while (str.length < length) {
      str += pad;
    }
    return str;
  }
  function StatTimer() {
    this.started = Object.create(null);
    this.times = [];
    this.enabled = true;
  }
  StatTimer.prototype = {
    time: function StatTimer_time(name) {
      if (!this.enabled) {
        return;
      }
      if (name in this.started) {
        warn('Timer is already running for ' + name);
      }
      this.started[name] = Date.now();
    },
    timeEnd: function StatTimer_timeEnd(name) {
      if (!this.enabled) {
        return;
      }
      if (!(name in this.started)) {
        warn('Timer has not been started for ' + name);
      }
      this.times.push({
        'name': name,
        'start': this.started[name],
        'end': Date.now()
      });
      delete this.started[name];
    },
    toString: function StatTimer_toString() {
      var i, ii;
      var times = this.times;
      var out = '';
      var longest = 0;
      for (i = 0, ii = times.length; i < ii; ++i) {
        var name = times[i]['name'];
        if (name.length > longest) {
          longest = name.length;
        }
      }
      for (i = 0, ii = times.length; i < ii; ++i) {
        var span = times[i];
        var duration = span.end - span.start;
        out += rpad(span['name'], ' ', longest) + ' ' + duration + 'ms\n';
      }
      return out;
    }
  };
  return StatTimer;
}();
var createBlob = function createBlob(data, contentType) {
  if (typeof Blob !== 'undefined') {
    return new Blob([data], { type: contentType });
  }
  throw new Error('The "Blob" constructor is not supported.');
};
var createObjectURL = function createObjectURLClosure() {
  var digits = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
  return function createObjectURL(data, contentType) {
    var forceDataSchema = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    if (!forceDataSchema && URL.createObjectURL) {
      var blob = createBlob(data, contentType);
      return URL.createObjectURL(blob);
    }
    var buffer = 'data:' + contentType + ';base64,';
    for (var i = 0, ii = data.length; i < ii; i += 3) {
      var b1 = data[i] & 0xFF;
      var b2 = data[i + 1] & 0xFF;
      var b3 = data[i + 2] & 0xFF;
      var d1 = b1 >> 2,
          d2 = (b1 & 3) << 4 | b2 >> 4;
      var d3 = i + 1 < ii ? (b2 & 0xF) << 2 | b3 >> 6 : 64;
      var d4 = i + 2 < ii ? b3 & 0x3F : 64;
      buffer += digits[d1] + digits[d2] + digits[d3] + digits[d4];
    }
    return buffer;
  };
}();
function resolveCall(fn, args) {
  var thisArg = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  if (!fn) {
    return Promise.resolve(undefined);
  }
  return new Promise(function (resolve, reject) {
    resolve(fn.apply(thisArg, args));
  });
}
function wrapReason(reason) {
  if ((typeof reason === 'undefined' ? 'undefined' : _typeof(reason)) !== 'object') {
    return reason;
  }
  switch (reason.name) {
    case 'AbortException':
      return new AbortException(reason.message);
    case 'MissingPDFException':
      return new MissingPDFException(reason.message);
    case 'UnexpectedResponseException':
      return new UnexpectedResponseException(reason.message, reason.status);
    default:
      return new UnknownErrorException(reason.message, reason.details);
  }
}
function resolveOrReject(capability, success, reason) {
  if (success) {
    capability.resolve();
  } else {
    capability.reject(reason);
  }
}
function finalize(promise) {
  return Promise.resolve(promise).catch(function () {});
}
function MessageHandler(sourceName, targetName, comObj) {
  var _this = this;

  this.sourceName = sourceName;
  this.targetName = targetName;
  this.comObj = comObj;
  this.callbackId = 1;
  this.streamId = 1;
  this.postMessageTransfers = true;
  this.streamSinks = Object.create(null);
  this.streamControllers = Object.create(null);
  var callbacksCapabilities = this.callbacksCapabilities = Object.create(null);
  var ah = this.actionHandler = Object.create(null);
  this._onComObjOnMessage = function (event) {
    var data = event.data;
    if (data.targetName !== _this.sourceName) {
      return;
    }
    if (data.stream) {
      _this._processStreamMessage(data);
    } else if (data.isReply) {
      var callbackId = data.callbackId;
      if (data.callbackId in callbacksCapabilities) {
        var callback = callbacksCapabilities[callbackId];
        delete callbacksCapabilities[callbackId];
        if ('error' in data) {
          callback.reject(wrapReason(data.error));
        } else {
          callback.resolve(data.data);
        }
      } else {
        throw new Error('Cannot resolve callback ' + callbackId);
      }
    } else if (data.action in ah) {
      var action = ah[data.action];
      if (data.callbackId) {
        var _sourceName = _this.sourceName;
        var _targetName = data.sourceName;
        Promise.resolve().then(function () {
          return action[0].call(action[1], data.data);
        }).then(function (result) {
          comObj.postMessage({
            sourceName: _sourceName,
            targetName: _targetName,
            isReply: true,
            callbackId: data.callbackId,
            data: result
          });
        }, function (reason) {
          if (reason instanceof Error) {
            reason = reason + '';
          }
          comObj.postMessage({
            sourceName: _sourceName,
            targetName: _targetName,
            isReply: true,
            callbackId: data.callbackId,
            error: reason
          });
        });
      } else if (data.streamId) {
        _this._createStreamSink(data);
      } else {
        action[0].call(action[1], data.data);
      }
    } else {
      throw new Error('Unknown action from worker: ' + data.action);
    }
  };
  comObj.addEventListener('message', this._onComObjOnMessage);
}
MessageHandler.prototype = {
  on: function on(actionName, handler, scope) {
    var ah = this.actionHandler;
    if (ah[actionName]) {
      throw new Error('There is already an actionName called "' + actionName + '"');
    }
    ah[actionName] = [handler, scope];
  },
  send: function send(actionName, data, transfers) {
    var message = {
      sourceName: this.sourceName,
      targetName: this.targetName,
      action: actionName,
      data: data
    };
    this.postMessage(message, transfers);
  },
  sendWithPromise: function sendWithPromise(actionName, data, transfers) {
    var callbackId = this.callbackId++;
    var message = {
      sourceName: this.sourceName,
      targetName: this.targetName,
      action: actionName,
      data: data,
      callbackId: callbackId
    };
    var capability = createPromiseCapability();
    this.callbacksCapabilities[callbackId] = capability;
    try {
      this.postMessage(message, transfers);
    } catch (e) {
      capability.reject(e);
    }
    return capability.promise;
  },
  sendWithStream: function sendWithStream(actionName, data, queueingStrategy, transfers) {
    var _this2 = this;

    var streamId = this.streamId++;
    var sourceName = this.sourceName;
    var targetName = this.targetName;
    return new _streams_polyfill.ReadableStream({
      start: function start(controller) {
        var startCapability = createPromiseCapability();
        _this2.streamControllers[streamId] = {
          controller: controller,
          startCall: startCapability,
          isClosed: false
        };
        _this2.postMessage({
          sourceName: sourceName,
          targetName: targetName,
          action: actionName,
          streamId: streamId,
          data: data,
          desiredSize: controller.desiredSize
        });
        return startCapability.promise;
      },
      pull: function pull(controller) {
        var pullCapability = createPromiseCapability();
        _this2.streamControllers[streamId].pullCall = pullCapability;
        _this2.postMessage({
          sourceName: sourceName,
          targetName: targetName,
          stream: 'pull',
          streamId: streamId,
          desiredSize: controller.desiredSize
        });
        return pullCapability.promise;
      },
      cancel: function cancel(reason) {
        var cancelCapability = createPromiseCapability();
        _this2.streamControllers[streamId].cancelCall = cancelCapability;
        _this2.streamControllers[streamId].isClosed = true;
        _this2.postMessage({
          sourceName: sourceName,
          targetName: targetName,
          stream: 'cancel',
          reason: reason,
          streamId: streamId
        });
        return cancelCapability.promise;
      }
    }, queueingStrategy);
  },
  _createStreamSink: function _createStreamSink(data) {
    var _this3 = this;

    var self = this;
    var action = this.actionHandler[data.action];
    var streamId = data.streamId;
    var desiredSize = data.desiredSize;
    var sourceName = this.sourceName;
    var targetName = data.sourceName;
    var capability = createPromiseCapability();
    var sendStreamRequest = function sendStreamRequest(_ref) {
      var stream = _ref.stream,
          chunk = _ref.chunk,
          transfers = _ref.transfers,
          success = _ref.success,
          reason = _ref.reason;

      _this3.postMessage({
        sourceName: sourceName,
        targetName: targetName,
        stream: stream,
        streamId: streamId,
        chunk: chunk,
        success: success,
        reason: reason
      }, transfers);
    };
    var streamSink = {
      enqueue: function enqueue(chunk) {
        var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        var transfers = arguments[2];

        if (this.isCancelled) {
          return;
        }
        var lastDesiredSize = this.desiredSize;
        this.desiredSize -= size;
        if (lastDesiredSize > 0 && this.desiredSize <= 0) {
          this.sinkCapability = createPromiseCapability();
          this.ready = this.sinkCapability.promise;
        }
        sendStreamRequest({
          stream: 'enqueue',
          chunk: chunk,
          transfers: transfers
        });
      },
      close: function close() {
        if (this.isCancelled) {
          return;
        }
        sendStreamRequest({ stream: 'close' });
        delete self.streamSinks[streamId];
      },
      error: function error(reason) {
        if (this.isCancelled) {
          return;
        }
        this.isCancelled = true;
        sendStreamRequest({
          stream: 'error',
          reason: reason
        });
      },

      sinkCapability: capability,
      onPull: null,
      onCancel: null,
      isCancelled: false,
      desiredSize: desiredSize,
      ready: null
    };
    streamSink.sinkCapability.resolve();
    streamSink.ready = streamSink.sinkCapability.promise;
    this.streamSinks[streamId] = streamSink;
    resolveCall(action[0], [data.data, streamSink], action[1]).then(function () {
      sendStreamRequest({
        stream: 'start_complete',
        success: true
      });
    }, function (reason) {
      sendStreamRequest({
        stream: 'start_complete',
        success: false,
        reason: reason
      });
    });
  },
  _processStreamMessage: function _processStreamMessage(data) {
    var _this4 = this;

    var sourceName = this.sourceName;
    var targetName = data.sourceName;
    var streamId = data.streamId;
    var sendStreamResponse = function sendStreamResponse(_ref2) {
      var stream = _ref2.stream,
          success = _ref2.success,
          reason = _ref2.reason;

      _this4.comObj.postMessage({
        sourceName: sourceName,
        targetName: targetName,
        stream: stream,
        success: success,
        streamId: streamId,
        reason: reason
      });
    };
    var deleteStreamController = function deleteStreamController() {
      Promise.all([_this4.streamControllers[data.streamId].startCall, _this4.streamControllers[data.streamId].pullCall, _this4.streamControllers[data.streamId].cancelCall].map(function (capability) {
        return capability && finalize(capability.promise);
      })).then(function () {
        delete _this4.streamControllers[data.streamId];
      });
    };
    switch (data.stream) {
      case 'start_complete':
        resolveOrReject(this.streamControllers[data.streamId].startCall, data.success, wrapReason(data.reason));
        break;
      case 'pull_complete':
        resolveOrReject(this.streamControllers[data.streamId].pullCall, data.success, wrapReason(data.reason));
        break;
      case 'pull':
        if (!this.streamSinks[data.streamId]) {
          sendStreamResponse({
            stream: 'pull_complete',
            success: true
          });
          break;
        }
        if (this.streamSinks[data.streamId].desiredSize <= 0 && data.desiredSize > 0) {
          this.streamSinks[data.streamId].sinkCapability.resolve();
        }
        this.streamSinks[data.streamId].desiredSize = data.desiredSize;
        resolveCall(this.streamSinks[data.streamId].onPull).then(function () {
          sendStreamResponse({
            stream: 'pull_complete',
            success: true
          });
        }, function (reason) {
          sendStreamResponse({
            stream: 'pull_complete',
            success: false,
            reason: reason
          });
        });
        break;
      case 'enqueue':
        assert(this.streamControllers[data.streamId], 'enqueue should have stream controller');
        if (!this.streamControllers[data.streamId].isClosed) {
          this.streamControllers[data.streamId].controller.enqueue(data.chunk);
        }
        break;
      case 'close':
        assert(this.streamControllers[data.streamId], 'close should have stream controller');
        if (this.streamControllers[data.streamId].isClosed) {
          break;
        }
        this.streamControllers[data.streamId].isClosed = true;
        this.streamControllers[data.streamId].controller.close();
        deleteStreamController();
        break;
      case 'error':
        assert(this.streamControllers[data.streamId], 'error should have stream controller');
        this.streamControllers[data.streamId].controller.error(wrapReason(data.reason));
        deleteStreamController();
        break;
      case 'cancel_complete':
        resolveOrReject(this.streamControllers[data.streamId].cancelCall, data.success, wrapReason(data.reason));
        deleteStreamController();
        break;
      case 'cancel':
        if (!this.streamSinks[data.streamId]) {
          break;
        }
        resolveCall(this.streamSinks[data.streamId].onCancel, [wrapReason(data.reason)]).then(function () {
          sendStreamResponse({
            stream: 'cancel_complete',
            success: true
          });
        }, function (reason) {
          sendStreamResponse({
            stream: 'cancel_complete',
            success: false,
            reason: reason
          });
        });
        this.streamSinks[data.streamId].sinkCapability.reject(wrapReason(data.reason));
        this.streamSinks[data.streamId].isCancelled = true;
        delete this.streamSinks[data.streamId];
        break;
      default:
        throw new Error('Unexpected stream case');
    }
  },
  postMessage: function postMessage(message, transfers) {
    if (transfers && this.postMessageTransfers) {
      this.comObj.postMessage(message, transfers);
    } else {
      this.comObj.postMessage(message);
    }
  },
  destroy: function destroy() {
    this.comObj.removeEventListener('message', this._onComObjOnMessage);
  }
};
function loadJpegStream(id, imageUrl, objs) {
  var img = new Image();
  img.onload = function loadJpegStream_onloadClosure() {
    objs.resolve(id, img);
  };
  img.onerror = function loadJpegStream_onerrorClosure() {
    objs.resolve(id, null);
    warn('Error during JPEG image loading');
  };
  img.src = imageUrl;
}
exports.FONT_IDENTITY_MATRIX = FONT_IDENTITY_MATRIX;
exports.IDENTITY_MATRIX = IDENTITY_MATRIX;
exports.OPS = OPS;
exports.VERBOSITY_LEVELS = VERBOSITY_LEVELS;
exports.UNSUPPORTED_FEATURES = UNSUPPORTED_FEATURES;
exports.AnnotationBorderStyleType = AnnotationBorderStyleType;
exports.AnnotationFieldFlag = AnnotationFieldFlag;
exports.AnnotationFlag = AnnotationFlag;
exports.AnnotationType = AnnotationType;
exports.FontType = FontType;
exports.ImageKind = ImageKind;
exports.CMapCompressionType = CMapCompressionType;
exports.AbortException = AbortException;
exports.InvalidPDFException = InvalidPDFException;
exports.MessageHandler = MessageHandler;
exports.MissingDataException = MissingDataException;
exports.MissingPDFException = MissingPDFException;
exports.NativeImageDecoding = NativeImageDecoding;
exports.NotImplementedException = NotImplementedException;
exports.PageViewport = PageViewport;
exports.PasswordException = PasswordException;
exports.PasswordResponses = PasswordResponses;
exports.StatTimer = StatTimer;
exports.StreamType = StreamType;
exports.TextRenderingMode = TextRenderingMode;
exports.UnexpectedResponseException = UnexpectedResponseException;
exports.UnknownErrorException = UnknownErrorException;
exports.Util = Util;
exports.XRefParseException = XRefParseException;
exports.FormatError = FormatError;
exports.arrayByteLength = arrayByteLength;
exports.arraysToBytes = arraysToBytes;
exports.assert = assert;
exports.bytesToString = bytesToString;
exports.createBlob = createBlob;
exports.createPromiseCapability = createPromiseCapability;
exports.createObjectURL = createObjectURL;
exports.deprecated = deprecated;
exports.getLookupTableFactory = getLookupTableFactory;
exports.getVerbosityLevel = getVerbosityLevel;
exports.globalScope = globalScope;
exports.info = info;
exports.isArray = isArray;
exports.isArrayBuffer = isArrayBuffer;
exports.isBool = isBool;
exports.isEmptyObj = isEmptyObj;
exports.isInt = isInt;
exports.isNum = isNum;
exports.isString = isString;
exports.isSpace = isSpace;
exports.isNodeJS = isNodeJS;
exports.isSameOrigin = isSameOrigin;
exports.createValidAbsoluteUrl = createValidAbsoluteUrl;
exports.isLittleEndian = isLittleEndian;
exports.isEvalSupported = isEvalSupported;
exports.loadJpegStream = loadJpegStream;
exports.log2 = log2;
exports.readInt8 = readInt8;
exports.readUint16 = readUint16;
exports.readUint32 = readUint32;
exports.removeNullCharacters = removeNullCharacters;
exports.ReadableStream = _streams_polyfill.ReadableStream;
exports.setVerbosityLevel = setVerbosityLevel;
exports.shadow = shadow;
exports.string32 = string32;
exports.stringToBytes = stringToBytes;
exports.stringToPDFString = stringToPDFString;
exports.stringToUTF8String = stringToUTF8String;
exports.utf8StringToString = utf8StringToString;
exports.warn = warn;
exports.unreachable = unreachable;

/***/ }),
/* 1 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DOMCMapReaderFactory = exports.DOMCanvasFactory = exports.DEFAULT_LINK_REL = exports.getDefaultSetting = exports.LinkTarget = exports.getFilenameFromUrl = exports.isValidUrl = exports.isExternalLinkTargetSet = exports.addLinkAttributes = exports.RenderingCancelledException = exports.CustomStyle = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _util = __w_pdfjs_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DEFAULT_LINK_REL = 'noopener noreferrer nofollow';

var DOMCanvasFactory = function () {
  function DOMCanvasFactory() {
    _classCallCheck(this, DOMCanvasFactory);
  }

  _createClass(DOMCanvasFactory, [{
    key: 'create',
    value: function create(width, height) {
      if (width <= 0 || height <= 0) {
        throw new Error('invalid canvas size');
      }
      var canvas = document.createElement('canvas');
      var context = canvas.getContext('2d');
      canvas.width = width;
      canvas.height = height;
      return {
        canvas: canvas,
        context: context
      };
    }
  }, {
    key: 'reset',
    value: function reset(canvasAndContext, width, height) {
      if (!canvasAndContext.canvas) {
        throw new Error('canvas is not specified');
      }
      if (width <= 0 || height <= 0) {
        throw new Error('invalid canvas size');
      }
      canvasAndContext.canvas.width = width;
      canvasAndContext.canvas.height = height;
    }
  }, {
    key: 'destroy',
    value: function destroy(canvasAndContext) {
      if (!canvasAndContext.canvas) {
        throw new Error('canvas is not specified');
      }
      canvasAndContext.canvas.width = 0;
      canvasAndContext.canvas.height = 0;
      canvasAndContext.canvas = null;
      canvasAndContext.context = null;
    }
  }]);

  return DOMCanvasFactory;
}();

var DOMCMapReaderFactory = function () {
  function DOMCMapReaderFactory(_ref) {
    var _ref$baseUrl = _ref.baseUrl,
        baseUrl = _ref$baseUrl === undefined ? null : _ref$baseUrl,
        _ref$isCompressed = _ref.isCompressed,
        isCompressed = _ref$isCompressed === undefined ? false : _ref$isCompressed;

    _classCallCheck(this, DOMCMapReaderFactory);

    this.baseUrl = baseUrl;
    this.isCompressed = isCompressed;
  }

  _createClass(DOMCMapReaderFactory, [{
    key: 'fetch',
    value: function fetch(_ref2) {
      var _this = this;

      var name = _ref2.name;

      if (!name) {
        return Promise.reject(new Error('CMap name must be specified.'));
      }
      return new Promise(function (resolve, reject) {
        var url = _this.baseUrl + name + (_this.isCompressed ? '.bcmap' : '');
        var request = new XMLHttpRequest();
        request.open('GET', url, true);
        if (_this.isCompressed) {
          request.responseType = 'arraybuffer';
        }
        request.onreadystatechange = function () {
          if (request.readyState !== XMLHttpRequest.DONE) {
            return;
          }
          if (request.status === 200 || request.status === 0) {
            var data = void 0;
            if (_this.isCompressed && request.response) {
              data = new Uint8Array(request.response);
            } else if (!_this.isCompressed && request.responseText) {
              data = (0, _util.stringToBytes)(request.responseText);
            }
            if (data) {
              resolve({
                cMapData: data,
                compressionType: _this.isCompressed ? _util.CMapCompressionType.BINARY : _util.CMapCompressionType.NONE
              });
              return;
            }
          }
          reject(new Error('Unable to load ' + (_this.isCompressed ? 'binary ' : '') + 'CMap at: ' + url));
        };
        request.send(null);
      });
    }
  }]);

  return DOMCMapReaderFactory;
}();

var CustomStyle = function CustomStyleClosure() {
  var prefixes = ['ms', 'Moz', 'Webkit', 'O'];
  var _cache = Object.create(null);
  function CustomStyle() {}
  CustomStyle.getProp = function get(propName, element) {
    if (arguments.length === 1 && typeof _cache[propName] === 'string') {
      return _cache[propName];
    }
    element = element || document.documentElement;
    var style = element.style,
        prefixed,
        uPropName;
    if (typeof style[propName] === 'string') {
      return _cache[propName] = propName;
    }
    uPropName = propName.charAt(0).toUpperCase() + propName.slice(1);
    for (var i = 0, l = prefixes.length; i < l; i++) {
      prefixed = prefixes[i] + uPropName;
      if (typeof style[prefixed] === 'string') {
        return _cache[propName] = prefixed;
      }
    }
    return _cache[propName] = 'undefined';
  };
  CustomStyle.setProp = function set(propName, element, str) {
    var prop = this.getProp(propName);
    if (prop !== 'undefined') {
      element.style[prop] = str;
    }
  };
  return CustomStyle;
}();
var RenderingCancelledException = function RenderingCancelledException() {
  function RenderingCancelledException(msg, type) {
    this.message = msg;
    this.type = type;
  }
  RenderingCancelledException.prototype = new Error();
  RenderingCancelledException.prototype.name = 'RenderingCancelledException';
  RenderingCancelledException.constructor = RenderingCancelledException;
  return RenderingCancelledException;
}();
var LinkTarget = {
  NONE: 0,
  SELF: 1,
  BLANK: 2,
  PARENT: 3,
  TOP: 4
};
var LinkTargetStringMap = ['', '_self', '_blank', '_parent', '_top'];
function addLinkAttributes(link, params) {
  var url = params && params.url;
  link.href = link.title = url ? (0, _util.removeNullCharacters)(url) : '';
  if (url) {
    var target = params.target;
    if (typeof target === 'undefined') {
      target = getDefaultSetting('externalLinkTarget');
    }
    link.target = LinkTargetStringMap[target];
    var rel = params.rel;
    if (typeof rel === 'undefined') {
      rel = getDefaultSetting('externalLinkRel');
    }
    link.rel = rel;
  }
}
function getFilenameFromUrl(url) {
  var anchor = url.indexOf('#');
  var query = url.indexOf('?');
  var end = Math.min(anchor > 0 ? anchor : url.length, query > 0 ? query : url.length);
  return url.substring(url.lastIndexOf('/', end) + 1, end);
}
function getDefaultSetting(id) {
  var globalSettings = _util.globalScope.PDFJS;
  switch (id) {
    case 'pdfBug':
      return globalSettings ? globalSettings.pdfBug : false;
    case 'disableAutoFetch':
      return globalSettings ? globalSettings.disableAutoFetch : false;
    case 'disableStream':
      return globalSettings ? globalSettings.disableStream : false;
    case 'disableRange':
      return globalSettings ? globalSettings.disableRange : false;
    case 'disableFontFace':
      return globalSettings ? globalSettings.disableFontFace : false;
    case 'disableCreateObjectURL':
      return globalSettings ? globalSettings.disableCreateObjectURL : false;
    case 'disableWebGL':
      return globalSettings ? globalSettings.disableWebGL : true;
    case 'cMapUrl':
      return globalSettings ? globalSettings.cMapUrl : null;
    case 'cMapPacked':
      return globalSettings ? globalSettings.cMapPacked : false;
    case 'postMessageTransfers':
      return globalSettings ? globalSettings.postMessageTransfers : true;
    case 'workerPort':
      return globalSettings ? globalSettings.workerPort : null;
    case 'workerSrc':
      return globalSettings ? globalSettings.workerSrc : null;
    case 'disableWorker':
      return globalSettings ? globalSettings.disableWorker : false;
    case 'maxImageSize':
      return globalSettings ? globalSettings.maxImageSize : -1;
    case 'imageResourcesPath':
      return globalSettings ? globalSettings.imageResourcesPath : '';
    case 'isEvalSupported':
      return globalSettings ? globalSettings.isEvalSupported : true;
    case 'externalLinkTarget':
      if (!globalSettings) {
        return LinkTarget.NONE;
      }
      switch (globalSettings.externalLinkTarget) {
        case LinkTarget.NONE:
        case LinkTarget.SELF:
        case LinkTarget.BLANK:
        case LinkTarget.PARENT:
        case LinkTarget.TOP:
          return globalSettings.externalLinkTarget;
      }
      (0, _util.warn)('PDFJS.externalLinkTarget is invalid: ' + globalSettings.externalLinkTarget);
      globalSettings.externalLinkTarget = LinkTarget.NONE;
      return LinkTarget.NONE;
    case 'externalLinkRel':
      return globalSettings ? globalSettings.externalLinkRel : DEFAULT_LINK_REL;
    case 'enableStats':
      return !!(globalSettings && globalSettings.enableStats);
    case 'pdfjsNext':
      return !!(globalSettings && globalSettings.pdfjsNext);
    default:
      throw new Error('Unknown default setting: ' + id);
  }
}
function isExternalLinkTargetSet() {
  var externalLinkTarget = getDefaultSetting('externalLinkTarget');
  switch (externalLinkTarget) {
    case LinkTarget.NONE:
      return false;
    case LinkTarget.SELF:
    case LinkTarget.BLANK:
    case LinkTarget.PARENT:
    case LinkTarget.TOP:
      return true;
  }
}
function isValidUrl(url, allowRelative) {
  (0, _util.deprecated)('isValidUrl(), please use createValidAbsoluteUrl() instead.');
  var baseUrl = allowRelative ? 'http://example.com' : null;
  return (0, _util.createValidAbsoluteUrl)(url, baseUrl) !== null;
}
exports.CustomStyle = CustomStyle;
exports.RenderingCancelledException = RenderingCancelledException;
exports.addLinkAttributes = addLinkAttributes;
exports.isExternalLinkTargetSet = isExternalLinkTargetSet;
exports.isValidUrl = isValidUrl;
exports.getFilenameFromUrl = getFilenameFromUrl;
exports.LinkTarget = LinkTarget;
exports.getDefaultSetting = getDefaultSetting;
exports.DEFAULT_LINK_REL = DEFAULT_LINK_REL;
exports.DOMCanvasFactory = DOMCanvasFactory;
exports.DOMCMapReaderFactory = DOMCMapReaderFactory;

/***/ }),
/* 2 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.build = exports.version = exports._UnsupportedManager = exports.setPDFNetworkStreamClass = exports.PDFPageProxy = exports.PDFDocumentProxy = exports.PDFWorker = exports.PDFDataRangeTransport = exports.LoopbackPort = exports.getDocument = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _util = __w_pdfjs_require__(0);

var _dom_utils = __w_pdfjs_require__(1);

var _font_loader = __w_pdfjs_require__(12);

var _canvas = __w_pdfjs_require__(11);

var _metadata = __w_pdfjs_require__(6);

var _transport_stream = __w_pdfjs_require__(14);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DEFAULT_RANGE_CHUNK_SIZE = 65536;
var isWorkerDisabled = false;
var workerSrc;
var isPostMessageTransfersDisabled = false;
var pdfjsFilePath = typeof document !== 'undefined' && document.currentScript ? document.currentScript.src : null;
var fakeWorkerFilesLoader = null;
var useRequireEnsure = false;
{
  if (typeof window === 'undefined') {
    isWorkerDisabled = true;
    if (typeof require.ensure === 'undefined') {
      require.ensure = require('node-ensure');
    }
    useRequireEnsure = true;
  } else if (typeof require !== 'undefined' && typeof require.ensure === 'function') {
    useRequireEnsure = true;
  }
  if (typeof requirejs !== 'undefined' && requirejs.toUrl) {
    workerSrc = requirejs.toUrl('pdfjs-dist/build/pdf.worker.js');
  }
  var dynamicLoaderSupported = typeof requirejs !== 'undefined' && requirejs.load;
  fakeWorkerFilesLoader = useRequireEnsure ? function (callback) {
    require.ensure([], function () {
      var worker;
      worker = require('./pdf.worker.js');
      callback(worker.WorkerMessageHandler);
    });
  } : dynamicLoaderSupported ? function (callback) {
    requirejs(['pdfjs-dist/build/pdf.worker'], function (worker) {
      callback(worker.WorkerMessageHandler);
    });
  } : null;
}
var PDFNetworkStream;
function setPDFNetworkStreamClass(cls) {
  PDFNetworkStream = cls;
}
function getDocument(src, pdfDataRangeTransport, passwordCallback, progressCallback) {
  var task = new PDFDocumentLoadingTask();
  if (arguments.length > 1) {
    (0, _util.deprecated)('getDocument is called with pdfDataRangeTransport, ' + 'passwordCallback or progressCallback argument');
  }
  if (pdfDataRangeTransport) {
    if (!(pdfDataRangeTransport instanceof PDFDataRangeTransport)) {
      pdfDataRangeTransport = Object.create(pdfDataRangeTransport);
      pdfDataRangeTransport.length = src.length;
      pdfDataRangeTransport.initialData = src.initialData;
      if (!pdfDataRangeTransport.abort) {
        pdfDataRangeTransport.abort = function () {};
      }
    }
    src = Object.create(src);
    src.range = pdfDataRangeTransport;
  }
  task.onPassword = passwordCallback || null;
  task.onProgress = progressCallback || null;
  var source;
  if (typeof src === 'string') {
    source = { url: src };
  } else if ((0, _util.isArrayBuffer)(src)) {
    source = { data: src };
  } else if (src instanceof PDFDataRangeTransport) {
    source = { range: src };
  } else {
    if ((typeof src === 'undefined' ? 'undefined' : _typeof(src)) !== 'object') {
      throw new Error('Invalid parameter in getDocument, ' + 'need either Uint8Array, string or a parameter object');
    }
    if (!src.url && !src.data && !src.range) {
      throw new Error('Invalid parameter object: need either .data, .range or .url');
    }
    source = src;
  }
  var params = {};
  var rangeTransport = null;
  var worker = null;
  var CMapReaderFactory = _dom_utils.DOMCMapReaderFactory;
  for (var key in source) {
    if (key === 'url' && typeof window !== 'undefined') {
      params[key] = new URL(source[key], window.location).href;
      continue;
    } else if (key === 'range') {
      rangeTransport = source[key];
      continue;
    } else if (key === 'worker') {
      worker = source[key];
      continue;
    } else if (key === 'data' && !(source[key] instanceof Uint8Array)) {
      var pdfBytes = source[key];
      if (typeof pdfBytes === 'string') {
        params[key] = (0, _util.stringToBytes)(pdfBytes);
      } else if ((typeof pdfBytes === 'undefined' ? 'undefined' : _typeof(pdfBytes)) === 'object' && pdfBytes !== null && !isNaN(pdfBytes.length)) {
        params[key] = new Uint8Array(pdfBytes);
      } else if ((0, _util.isArrayBuffer)(pdfBytes)) {
        params[key] = new Uint8Array(pdfBytes);
      } else {
        throw new Error('Invalid PDF binary data: either typed array, ' + 'string or array-like object is expected in the ' + 'data property.');
      }
      continue;
    } else if (key === 'CMapReaderFactory') {
      CMapReaderFactory = source[key];
      continue;
    }
    params[key] = source[key];
  }
  params.rangeChunkSize = params.rangeChunkSize || DEFAULT_RANGE_CHUNK_SIZE;
  params.ignoreErrors = params.stopAtErrors !== true;
  if (params.disableNativeImageDecoder !== undefined) {
    (0, _util.deprecated)('parameter disableNativeImageDecoder, ' + 'use nativeImageDecoderSupport instead');
  }
  params.nativeImageDecoderSupport = params.nativeImageDecoderSupport || (params.disableNativeImageDecoder === true ? _util.NativeImageDecoding.NONE : _util.NativeImageDecoding.DECODE);
  if (params.nativeImageDecoderSupport !== _util.NativeImageDecoding.DECODE && params.nativeImageDecoderSupport !== _util.NativeImageDecoding.NONE && params.nativeImageDecoderSupport !== _util.NativeImageDecoding.DISPLAY) {
    (0, _util.warn)('Invalid parameter nativeImageDecoderSupport: ' + 'need a state of enum {NativeImageDecoding}');
    params.nativeImageDecoderSupport = _util.NativeImageDecoding.DECODE;
  }
  if (!worker) {
    var workerPort = (0, _dom_utils.getDefaultSetting)('workerPort');
    worker = workerPort ? PDFWorker.fromPort(workerPort) : new PDFWorker();
    task._worker = worker;
  }
  var docId = task.docId;
  worker.promise.then(function () {
    if (task.destroyed) {
      throw new Error('Loading aborted');
    }
    return _fetchDocument(worker, params, rangeTransport, docId).then(function (workerId) {
      if (task.destroyed) {
        throw new Error('Loading aborted');
      }
      var networkStream = void 0;
      if (rangeTransport) {
        networkStream = new _transport_stream.PDFDataTransportStream(params, rangeTransport);
      } else if (!params.data) {
        networkStream = new PDFNetworkStream({
          source: params,
          disableRange: (0, _dom_utils.getDefaultSetting)('disableRange')
        });
      }
      var messageHandler = new _util.MessageHandler(docId, workerId, worker.port);
      messageHandler.postMessageTransfers = worker.postMessageTransfers;
      var transport = new WorkerTransport(messageHandler, task, networkStream, CMapReaderFactory);
      task._transport = transport;
      messageHandler.send('Ready', null);
    });
  }).catch(task._capability.reject);
  return task;
}
function _fetchDocument(worker, source, pdfDataRangeTransport, docId) {
  if (worker.destroyed) {
    return Promise.reject(new Error('Worker was destroyed'));
  }
  source.disableAutoFetch = (0, _dom_utils.getDefaultSetting)('disableAutoFetch');
  source.disableStream = (0, _dom_utils.getDefaultSetting)('disableStream');
  source.chunkedViewerLoading = !!pdfDataRangeTransport;
  if (pdfDataRangeTransport) {
    source.length = pdfDataRangeTransport.length;
    source.initialData = pdfDataRangeTransport.initialData;
  }
  return worker.messageHandler.sendWithPromise('GetDocRequest', {
    docId: docId,
    source: {
      data: source.data,
      url: source.url,
      password: source.password,
      disableAutoFetch: source.disableAutoFetch,
      rangeChunkSize: source.rangeChunkSize,
      length: source.length
    },
    maxImageSize: (0, _dom_utils.getDefaultSetting)('maxImageSize'),
    disableFontFace: (0, _dom_utils.getDefaultSetting)('disableFontFace'),
    disableCreateObjectURL: (0, _dom_utils.getDefaultSetting)('disableCreateObjectURL'),
    postMessageTransfers: (0, _dom_utils.getDefaultSetting)('postMessageTransfers') && !isPostMessageTransfersDisabled,
    docBaseUrl: source.docBaseUrl,
    nativeImageDecoderSupport: source.nativeImageDecoderSupport,
    ignoreErrors: source.ignoreErrors
  }).then(function (workerId) {
    if (worker.destroyed) {
      throw new Error('Worker was destroyed');
    }
    return workerId;
  });
}
var PDFDocumentLoadingTask = function PDFDocumentLoadingTaskClosure() {
  var nextDocumentId = 0;
  function PDFDocumentLoadingTask() {
    this._capability = (0, _util.createPromiseCapability)();
    this._transport = null;
    this._worker = null;
    this.docId = 'd' + nextDocumentId++;
    this.destroyed = false;
    this.onPassword = null;
    this.onProgress = null;
    this.onUnsupportedFeature = null;
  }
  PDFDocumentLoadingTask.prototype = {
    get promise() {
      return this._capability.promise;
    },
    destroy: function destroy() {
      var _this = this;

      this.destroyed = true;
      var transportDestroyed = !this._transport ? Promise.resolve() : this._transport.destroy();
      return transportDestroyed.then(function () {
        _this._transport = null;
        if (_this._worker) {
          _this._worker.destroy();
          _this._worker = null;
        }
      });
    },

    then: function PDFDocumentLoadingTask_then(onFulfilled, onRejected) {
      return this.promise.then.apply(this.promise, arguments);
    }
  };
  return PDFDocumentLoadingTask;
}();
var PDFDataRangeTransport = function pdfDataRangeTransportClosure() {
  function PDFDataRangeTransport(length, initialData) {
    this.length = length;
    this.initialData = initialData;
    this._rangeListeners = [];
    this._progressListeners = [];
    this._progressiveReadListeners = [];
    this._readyCapability = (0, _util.createPromiseCapability)();
  }
  PDFDataRangeTransport.prototype = {
    addRangeListener: function PDFDataRangeTransport_addRangeListener(listener) {
      this._rangeListeners.push(listener);
    },
    addProgressListener: function PDFDataRangeTransport_addProgressListener(listener) {
      this._progressListeners.push(listener);
    },
    addProgressiveReadListener: function PDFDataRangeTransport_addProgressiveReadListener(listener) {
      this._progressiveReadListeners.push(listener);
    },
    onDataRange: function PDFDataRangeTransport_onDataRange(begin, chunk) {
      var listeners = this._rangeListeners;
      for (var i = 0, n = listeners.length; i < n; ++i) {
        listeners[i](begin, chunk);
      }
    },
    onDataProgress: function PDFDataRangeTransport_onDataProgress(loaded) {
      var _this2 = this;

      this._readyCapability.promise.then(function () {
        var listeners = _this2._progressListeners;
        for (var i = 0, n = listeners.length; i < n; ++i) {
          listeners[i](loaded);
        }
      });
    },
    onDataProgressiveRead: function PDFDataRangeTransport_onDataProgress(chunk) {
      var _this3 = this;

      this._readyCapability.promise.then(function () {
        var listeners = _this3._progressiveReadListeners;
        for (var i = 0, n = listeners.length; i < n; ++i) {
          listeners[i](chunk);
        }
      });
    },
    transportReady: function PDFDataRangeTransport_transportReady() {
      this._readyCapability.resolve();
    },
    requestDataRange: function PDFDataRangeTransport_requestDataRange(begin, end) {
      throw new Error('Abstract method PDFDataRangeTransport.requestDataRange');
    },
    abort: function PDFDataRangeTransport_abort() {}
  };
  return PDFDataRangeTransport;
}();
var PDFDocumentProxy = function PDFDocumentProxyClosure() {
  function PDFDocumentProxy(pdfInfo, transport, loadingTask) {
    this.pdfInfo = pdfInfo;
    this.transport = transport;
    this.loadingTask = loadingTask;
  }
  PDFDocumentProxy.prototype = {
    get numPages() {
      return this.pdfInfo.numPages;
    },
    get fingerprint() {
      return this.pdfInfo.fingerprint;
    },
    getPage: function PDFDocumentProxy_getPage(pageNumber) {
      return this.transport.getPage(pageNumber);
    },
    getPageIndex: function PDFDocumentProxy_getPageIndex(ref) {
      return this.transport.getPageIndex(ref);
    },
    getDestinations: function PDFDocumentProxy_getDestinations() {
      return this.transport.getDestinations();
    },
    getDestination: function PDFDocumentProxy_getDestination(id) {
      return this.transport.getDestination(id);
    },
    getPageLabels: function PDFDocumentProxy_getPageLabels() {
      return this.transport.getPageLabels();
    },
    getPageMode: function getPageMode() {
      return this.transport.getPageMode();
    },

    getAttachments: function PDFDocumentProxy_getAttachments() {
      return this.transport.getAttachments();
    },
    getJavaScript: function PDFDocumentProxy_getJavaScript() {
      return this.transport.getJavaScript();
    },
    getOutline: function PDFDocumentProxy_getOutline() {
      return this.transport.getOutline();
    },
    getMetadata: function PDFDocumentProxy_getMetadata() {
      return this.transport.getMetadata();
    },
    getData: function PDFDocumentProxy_getData() {
      return this.transport.getData();
    },
    getDownloadInfo: function PDFDocumentProxy_getDownloadInfo() {
      return this.transport.downloadInfoCapability.promise;
    },
    getStats: function PDFDocumentProxy_getStats() {
      return this.transport.getStats();
    },
    cleanup: function PDFDocumentProxy_cleanup() {
      this.transport.startCleanup();
    },
    destroy: function PDFDocumentProxy_destroy() {
      return this.loadingTask.destroy();
    }
  };
  return PDFDocumentProxy;
}();
var PDFPageProxy = function PDFPageProxyClosure() {
  function PDFPageProxy(pageIndex, pageInfo, transport) {
    this.pageIndex = pageIndex;
    this.pageInfo = pageInfo;
    this.transport = transport;
    this.stats = new _util.StatTimer();
    this.stats.enabled = (0, _dom_utils.getDefaultSetting)('enableStats');
    this.commonObjs = transport.commonObjs;
    this.objs = new PDFObjects();
    this.cleanupAfterRender = false;
    this.pendingCleanup = false;
    this.intentStates = Object.create(null);
    this.destroyed = false;
  }
  PDFPageProxy.prototype = {
    get pageNumber() {
      return this.pageIndex + 1;
    },
    get rotate() {
      return this.pageInfo.rotate;
    },
    get ref() {
      return this.pageInfo.ref;
    },
    get userUnit() {
      return this.pageInfo.userUnit;
    },
    get view() {
      return this.pageInfo.view;
    },
    getViewport: function PDFPageProxy_getViewport(scale, rotate) {
      if (arguments.length < 2) {
        rotate = this.rotate;
      }
      return new _util.PageViewport(this.view, scale, rotate, 0, 0);
    },
    getAnnotations: function PDFPageProxy_getAnnotations(params) {
      var intent = params && params.intent || null;
      if (!this.annotationsPromise || this.annotationsIntent !== intent) {
        this.annotationsPromise = this.transport.getAnnotations(this.pageIndex, intent);
        this.annotationsIntent = intent;
      }
      return this.annotationsPromise;
    },
    render: function PDFPageProxy_render(params) {
      var _this4 = this;

      var stats = this.stats;
      stats.time('Overall');
      this.pendingCleanup = false;
      var renderingIntent = params.intent === 'print' ? 'print' : 'display';
      var canvasFactory = params.canvasFactory || new _dom_utils.DOMCanvasFactory();
      if (!this.intentStates[renderingIntent]) {
        this.intentStates[renderingIntent] = Object.create(null);
      }
      var intentState = this.intentStates[renderingIntent];
      if (!intentState.displayReadyCapability) {
        intentState.receivingOperatorList = true;
        intentState.displayReadyCapability = (0, _util.createPromiseCapability)();
        intentState.operatorList = {
          fnArray: [],
          argsArray: [],
          lastChunk: false
        };
        this.stats.time('Page Request');
        this.transport.messageHandler.send('RenderPageRequest', {
          pageIndex: this.pageNumber - 1,
          intent: renderingIntent,
          renderInteractiveForms: params.renderInteractiveForms === true
        });
      }
      var complete = function complete(error) {
        var i = intentState.renderTasks.indexOf(internalRenderTask);
        if (i >= 0) {
          intentState.renderTasks.splice(i, 1);
        }
        if (_this4.cleanupAfterRender) {
          _this4.pendingCleanup = true;
        }
        _this4._tryCleanup();
        if (error) {
          internalRenderTask.capability.reject(error);
        } else {
          internalRenderTask.capability.resolve();
        }
        stats.timeEnd('Rendering');
        stats.timeEnd('Overall');
      };
      var internalRenderTask = new InternalRenderTask(complete, params, this.objs, this.commonObjs, intentState.operatorList, this.pageNumber, canvasFactory);
      internalRenderTask.useRequestAnimationFrame = renderingIntent !== 'print';
      if (!intentState.renderTasks) {
        intentState.renderTasks = [];
      }
      intentState.renderTasks.push(internalRenderTask);
      var renderTask = internalRenderTask.task;
      if (params.continueCallback) {
        (0, _util.deprecated)('render is used with continueCallback parameter');
        renderTask.onContinue = params.continueCallback;
      }
      intentState.displayReadyCapability.promise.then(function (transparency) {
        if (_this4.pendingCleanup) {
          complete();
          return;
        }
        stats.time('Rendering');
        internalRenderTask.initializeGraphics(transparency);
        internalRenderTask.operatorListChanged();
      }).catch(complete);
      return renderTask;
    },
    getOperatorList: function PDFPageProxy_getOperatorList() {
      function operatorListChanged() {
        if (intentState.operatorList.lastChunk) {
          intentState.opListReadCapability.resolve(intentState.operatorList);
          var i = intentState.renderTasks.indexOf(opListTask);
          if (i >= 0) {
            intentState.renderTasks.splice(i, 1);
          }
        }
      }
      var renderingIntent = 'oplist';
      if (!this.intentStates[renderingIntent]) {
        this.intentStates[renderingIntent] = Object.create(null);
      }
      var intentState = this.intentStates[renderingIntent];
      var opListTask;
      if (!intentState.opListReadCapability) {
        opListTask = {};
        opListTask.operatorListChanged = operatorListChanged;
        intentState.receivingOperatorList = true;
        intentState.opListReadCapability = (0, _util.createPromiseCapability)();
        intentState.renderTasks = [];
        intentState.renderTasks.push(opListTask);
        intentState.operatorList = {
          fnArray: [],
          argsArray: [],
          lastChunk: false
        };
        this.transport.messageHandler.send('RenderPageRequest', {
          pageIndex: this.pageIndex,
          intent: renderingIntent
        });
      }
      return intentState.opListReadCapability.promise;
    },
    streamTextContent: function streamTextContent() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var TEXT_CONTENT_CHUNK_SIZE = 100;
      return this.transport.messageHandler.sendWithStream('GetTextContent', {
        pageIndex: this.pageNumber - 1,
        normalizeWhitespace: params.normalizeWhitespace === true,
        combineTextItems: params.disableCombineTextItems !== true
      }, {
        highWaterMark: TEXT_CONTENT_CHUNK_SIZE,
        size: function size(textContent) {
          return textContent.items.length;
        }
      });
    },

    getTextContent: function PDFPageProxy_getTextContent(params) {
      params = params || {};
      var readableStream = this.streamTextContent(params);
      return new Promise(function (resolve, reject) {
        function pump() {
          reader.read().then(function (_ref) {
            var value = _ref.value,
                done = _ref.done;

            if (done) {
              resolve(textContent);
              return;
            }
            _util.Util.extendObj(textContent.styles, value.styles);
            _util.Util.appendToArray(textContent.items, value.items);
            pump();
          }, reject);
        }
        var reader = readableStream.getReader();
        var textContent = {
          items: [],
          styles: Object.create(null)
        };
        pump();
      });
    },
    _destroy: function PDFPageProxy_destroy() {
      this.destroyed = true;
      this.transport.pageCache[this.pageIndex] = null;
      var waitOn = [];
      Object.keys(this.intentStates).forEach(function (intent) {
        if (intent === 'oplist') {
          return;
        }
        var intentState = this.intentStates[intent];
        intentState.renderTasks.forEach(function (renderTask) {
          var renderCompleted = renderTask.capability.promise.catch(function () {});
          waitOn.push(renderCompleted);
          renderTask.cancel();
        });
      }, this);
      this.objs.clear();
      this.annotationsPromise = null;
      this.pendingCleanup = false;
      return Promise.all(waitOn);
    },
    destroy: function destroy() {
      (0, _util.deprecated)('page destroy method, use cleanup() instead');
      this.cleanup();
    },

    cleanup: function PDFPageProxy_cleanup() {
      this.pendingCleanup = true;
      this._tryCleanup();
    },
    _tryCleanup: function PDFPageProxy_tryCleanup() {
      if (!this.pendingCleanup || Object.keys(this.intentStates).some(function (intent) {
        var intentState = this.intentStates[intent];
        return intentState.renderTasks.length !== 0 || intentState.receivingOperatorList;
      }, this)) {
        return;
      }
      Object.keys(this.intentStates).forEach(function (intent) {
        delete this.intentStates[intent];
      }, this);
      this.objs.clear();
      this.annotationsPromise = null;
      this.pendingCleanup = false;
    },
    _startRenderPage: function PDFPageProxy_startRenderPage(transparency, intent) {
      var intentState = this.intentStates[intent];
      if (intentState.displayReadyCapability) {
        intentState.displayReadyCapability.resolve(transparency);
      }
    },
    _renderPageChunk: function PDFPageProxy_renderPageChunk(operatorListChunk, intent) {
      var intentState = this.intentStates[intent];
      var i, ii;
      for (i = 0, ii = operatorListChunk.length; i < ii; i++) {
        intentState.operatorList.fnArray.push(operatorListChunk.fnArray[i]);
        intentState.operatorList.argsArray.push(operatorListChunk.argsArray[i]);
      }
      intentState.operatorList.lastChunk = operatorListChunk.lastChunk;
      for (i = 0; i < intentState.renderTasks.length; i++) {
        intentState.renderTasks[i].operatorListChanged();
      }
      if (operatorListChunk.lastChunk) {
        intentState.receivingOperatorList = false;
        this._tryCleanup();
      }
    }
  };
  return PDFPageProxy;
}();

var LoopbackPort = function () {
  function LoopbackPort(defer) {
    _classCallCheck(this, LoopbackPort);

    this._listeners = [];
    this._defer = defer;
    this._deferred = Promise.resolve(undefined);
  }

  _createClass(LoopbackPort, [{
    key: 'postMessage',
    value: function postMessage(obj, transfers) {
      var _this5 = this;

      function cloneValue(value) {
        if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object' || value === null) {
          return value;
        }
        if (cloned.has(value)) {
          return cloned.get(value);
        }
        var result;
        var buffer;
        if ((buffer = value.buffer) && (0, _util.isArrayBuffer)(buffer)) {
          var transferable = transfers && transfers.indexOf(buffer) >= 0;
          if (value === buffer) {
            result = value;
          } else if (transferable) {
            result = new value.constructor(buffer, value.byteOffset, value.byteLength);
          } else {
            result = new value.constructor(value);
          }
          cloned.set(value, result);
          return result;
        }
        result = (0, _util.isArray)(value) ? [] : {};
        cloned.set(value, result);
        for (var i in value) {
          var desc,
              p = value;
          while (!(desc = Object.getOwnPropertyDescriptor(p, i))) {
            p = Object.getPrototypeOf(p);
          }
          if (typeof desc.value === 'undefined' || typeof desc.value === 'function') {
            continue;
          }
          result[i] = cloneValue(desc.value);
        }
        return result;
      }
      if (!this._defer) {
        this._listeners.forEach(function (listener) {
          listener.call(this, { data: obj });
        }, this);
        return;
      }
      var cloned = new WeakMap();
      var e = { data: cloneValue(obj) };
      this._deferred.then(function () {
        _this5._listeners.forEach(function (listener) {
          listener.call(this, e);
        }, _this5);
      });
    }
  }, {
    key: 'addEventListener',
    value: function addEventListener(name, listener) {
      this._listeners.push(listener);
    }
  }, {
    key: 'removeEventListener',
    value: function removeEventListener(name, listener) {
      var i = this._listeners.indexOf(listener);
      this._listeners.splice(i, 1);
    }
  }, {
    key: 'terminate',
    value: function terminate() {
      this._listeners = [];
    }
  }]);

  return LoopbackPort;
}();

var PDFWorker = function PDFWorkerClosure() {
  var nextFakeWorkerId = 0;
  function getWorkerSrc() {
    if (typeof workerSrc !== 'undefined') {
      return workerSrc;
    }
    if ((0, _dom_utils.getDefaultSetting)('workerSrc')) {
      return (0, _dom_utils.getDefaultSetting)('workerSrc');
    }
    if (pdfjsFilePath) {
      return pdfjsFilePath.replace(/(\.(?:min\.)?js)(\?.*)?$/i, '.worker$1$2');
    }
    throw new Error('No PDFJS.workerSrc specified');
  }
  var fakeWorkerFilesLoadedCapability = void 0;
  function setupFakeWorkerGlobal() {
    var WorkerMessageHandler;
    if (fakeWorkerFilesLoadedCapability) {
      return fakeWorkerFilesLoadedCapability.promise;
    }
    fakeWorkerFilesLoadedCapability = (0, _util.createPromiseCapability)();
    var loader = fakeWorkerFilesLoader || function (callback) {
      _util.Util.loadScript(getWorkerSrc(), function () {
        callback(window.pdfjsDistBuildPdfWorker.WorkerMessageHandler);
      });
    };
    loader(fakeWorkerFilesLoadedCapability.resolve);
    return fakeWorkerFilesLoadedCapability.promise;
  }
  function createCDNWrapper(url) {
    var wrapper = 'importScripts(\'' + url + '\');';
    return URL.createObjectURL(new Blob([wrapper]));
  }
  var pdfWorkerPorts = new WeakMap();
  function PDFWorker(name, port) {
    if (port && pdfWorkerPorts.has(port)) {
      throw new Error('Cannot use more than one PDFWorker per port');
    }
    this.name = name;
    this.destroyed = false;
    this.postMessageTransfers = true;
    this._readyCapability = (0, _util.createPromiseCapability)();
    this._port = null;
    this._webWorker = null;
    this._messageHandler = null;
    if (port) {
      pdfWorkerPorts.set(port, this);
      this._initializeFromPort(port);
      return;
    }
    this._initialize();
  }
  PDFWorker.prototype = {
    get promise() {
      return this._readyCapability.promise;
    },
    get port() {
      return this._port;
    },
    get messageHandler() {
      return this._messageHandler;
    },
    _initializeFromPort: function PDFWorker_initializeFromPort(port) {
      this._port = port;
      this._messageHandler = new _util.MessageHandler('main', 'worker', port);
      this._messageHandler.on('ready', function () {});
      this._readyCapability.resolve();
    },
    _initialize: function PDFWorker_initialize() {
      var _this6 = this;

      if (!isWorkerDisabled && !(0, _dom_utils.getDefaultSetting)('disableWorker') && typeof Worker !== 'undefined') {
        var workerSrc = getWorkerSrc();
        try {
          if (!(0, _util.isSameOrigin)(window.location.href, workerSrc)) {
            workerSrc = createCDNWrapper(new URL(workerSrc, window.location).href);
          }
          var worker = new Worker(workerSrc);
          var messageHandler = new _util.MessageHandler('main', 'worker', worker);
          var terminateEarly = function terminateEarly() {
            worker.removeEventListener('error', onWorkerError);
            messageHandler.destroy();
            worker.terminate();
            if (_this6.destroyed) {
              _this6._readyCapability.reject(new Error('Worker was destroyed'));
            } else {
              _this6._setupFakeWorker();
            }
          };
          var onWorkerError = function onWorkerError() {
            if (!_this6._webWorker) {
              terminateEarly();
            }
          };
          worker.addEventListener('error', onWorkerError);
          messageHandler.on('test', function (data) {
            worker.removeEventListener('error', onWorkerError);
            if (_this6.destroyed) {
              terminateEarly();
              return;
            }
            var supportTypedArray = data && data.supportTypedArray;
            if (supportTypedArray) {
              _this6._messageHandler = messageHandler;
              _this6._port = worker;
              _this6._webWorker = worker;
              if (!data.supportTransfers) {
                _this6.postMessageTransfers = false;
                isPostMessageTransfersDisabled = true;
              }
              _this6._readyCapability.resolve();
              messageHandler.send('configure', { verbosity: (0, _util.getVerbosityLevel)() });
            } else {
              _this6._setupFakeWorker();
              messageHandler.destroy();
              worker.terminate();
            }
          });
          messageHandler.on('console_log', function (data) {
            console.log.apply(console, data);
          });
          messageHandler.on('console_error', function (data) {
            console.error.apply(console, data);
          });
          messageHandler.on('ready', function (data) {
            worker.removeEventListener('error', onWorkerError);
            if (_this6.destroyed) {
              terminateEarly();
              return;
            }
            try {
              sendTest();
            } catch (e) {
              _this6._setupFakeWorker();
            }
          });
          var sendTest = function sendTest() {
            var postMessageTransfers = (0, _dom_utils.getDefaultSetting)('postMessageTransfers') && !isPostMessageTransfersDisabled;
            var testObj = new Uint8Array([postMessageTransfers ? 255 : 0]);
            try {
              messageHandler.send('test', testObj, [testObj.buffer]);
            } catch (ex) {
              (0, _util.info)('Cannot use postMessage transfers');
              testObj[0] = 0;
              messageHandler.send('test', testObj);
            }
          };
          sendTest();
          return;
        } catch (e) {
          (0, _util.info)('The worker has been disabled.');
        }
      }
      this._setupFakeWorker();
    },
    _setupFakeWorker: function PDFWorker_setupFakeWorker() {
      var _this7 = this;

      if (!isWorkerDisabled && !(0, _dom_utils.getDefaultSetting)('disableWorker')) {
        (0, _util.warn)('Setting up fake worker.');
        isWorkerDisabled = true;
      }
      setupFakeWorkerGlobal().then(function (WorkerMessageHandler) {
        if (_this7.destroyed) {
          _this7._readyCapability.reject(new Error('Worker was destroyed'));
          return;
        }
        var isTypedArraysPresent = Uint8Array !== Float32Array;
        var port = new LoopbackPort(isTypedArraysPresent);
        _this7._port = port;
        var id = 'fake' + nextFakeWorkerId++;
        var workerHandler = new _util.MessageHandler(id + '_worker', id, port);
        WorkerMessageHandler.setup(workerHandler, port);
        var messageHandler = new _util.MessageHandler(id, id + '_worker', port);
        _this7._messageHandler = messageHandler;
        _this7._readyCapability.resolve();
      });
    },
    destroy: function PDFWorker_destroy() {
      this.destroyed = true;
      if (this._webWorker) {
        this._webWorker.terminate();
        this._webWorker = null;
      }
      pdfWorkerPorts.delete(this._port);
      this._port = null;
      if (this._messageHandler) {
        this._messageHandler.destroy();
        this._messageHandler = null;
      }
    }
  };
  PDFWorker.fromPort = function (port) {
    if (pdfWorkerPorts.has(port)) {
      return pdfWorkerPorts.get(port);
    }
    return new PDFWorker(null, port);
  };
  return PDFWorker;
}();
var WorkerTransport = function WorkerTransportClosure() {
  function WorkerTransport(messageHandler, loadingTask, networkStream, CMapReaderFactory) {
    this.messageHandler = messageHandler;
    this.loadingTask = loadingTask;
    this.commonObjs = new PDFObjects();
    this.fontLoader = new _font_loader.FontLoader(loadingTask.docId);
    this.CMapReaderFactory = new CMapReaderFactory({
      baseUrl: (0, _dom_utils.getDefaultSetting)('cMapUrl'),
      isCompressed: (0, _dom_utils.getDefaultSetting)('cMapPacked')
    });
    this.destroyed = false;
    this.destroyCapability = null;
    this._passwordCapability = null;
    this._networkStream = networkStream;
    this._fullReader = null;
    this._lastProgress = null;
    this.pageCache = [];
    this.pagePromises = [];
    this.downloadInfoCapability = (0, _util.createPromiseCapability)();
    this.setupMessageHandler();
  }
  WorkerTransport.prototype = {
    destroy: function WorkerTransport_destroy() {
      var _this8 = this;

      if (this.destroyCapability) {
        return this.destroyCapability.promise;
      }
      this.destroyed = true;
      this.destroyCapability = (0, _util.createPromiseCapability)();
      if (this._passwordCapability) {
        this._passwordCapability.reject(new Error('Worker was destroyed during onPassword callback'));
      }
      var waitOn = [];
      this.pageCache.forEach(function (page) {
        if (page) {
          waitOn.push(page._destroy());
        }
      });
      this.pageCache = [];
      this.pagePromises = [];
      var terminated = this.messageHandler.sendWithPromise('Terminate', null);
      waitOn.push(terminated);
      Promise.all(waitOn).then(function () {
        _this8.fontLoader.clear();
        if (_this8._networkStream) {
          _this8._networkStream.cancelAllRequests();
        }
        if (_this8.messageHandler) {
          _this8.messageHandler.destroy();
          _this8.messageHandler = null;
        }
        _this8.destroyCapability.resolve();
      }, this.destroyCapability.reject);
      return this.destroyCapability.promise;
    },
    setupMessageHandler: function WorkerTransport_setupMessageHandler() {
      var messageHandler = this.messageHandler;
      var loadingTask = this.loadingTask;
      messageHandler.on('GetReader', function (data, sink) {
        var _this9 = this;

        (0, _util.assert)(this._networkStream);
        this._fullReader = this._networkStream.getFullReader();
        this._fullReader.onProgress = function (evt) {
          _this9._lastProgress = {
            loaded: evt.loaded,
            total: evt.total
          };
        };
        sink.onPull = function () {
          _this9._fullReader.read().then(function (_ref2) {
            var value = _ref2.value,
                done = _ref2.done;

            if (done) {
              sink.close();
              return;
            }
            (0, _util.assert)((0, _util.isArrayBuffer)(value));
            sink.enqueue(new Uint8Array(value), 1, [value]);
          }).catch(function (reason) {
            sink.error(reason);
          });
        };
        sink.onCancel = function (reason) {
          _this9._fullReader.cancel(reason);
        };
      }, this);
      messageHandler.on('ReaderHeadersReady', function (data) {
        var _this10 = this;

        var headersCapability = (0, _util.createPromiseCapability)();
        var fullReader = this._fullReader;
        fullReader.headersReady.then(function () {
          if (!fullReader.isStreamingSupported || !fullReader.isRangeSupported) {
            if (_this10._lastProgress) {
              var _loadingTask = _this10.loadingTask;
              if (_loadingTask.onProgress) {
                _loadingTask.onProgress(_this10._lastProgress);
              }
            }
            fullReader.onProgress = function (evt) {
              var loadingTask = _this10.loadingTask;
              if (loadingTask.onProgress) {
                loadingTask.onProgress({
                  loaded: evt.loaded,
                  total: evt.total
                });
              }
            };
          }
          headersCapability.resolve({
            isStreamingSupported: fullReader.isStreamingSupported,
            isRangeSupported: fullReader.isRangeSupported,
            contentLength: fullReader.contentLength
          });
        }, headersCapability.reject);
        return headersCapability.promise;
      }, this);
      messageHandler.on('GetRangeReader', function (data, sink) {
        (0, _util.assert)(this._networkStream);
        var _rangeReader = this._networkStream.getRangeReader(data.begin, data.end);
        sink.onPull = function () {
          _rangeReader.read().then(function (_ref3) {
            var value = _ref3.value,
                done = _ref3.done;

            if (done) {
              sink.close();
              return;
            }
            (0, _util.assert)((0, _util.isArrayBuffer)(value));
            sink.enqueue(new Uint8Array(value), 1, [value]);
          }).catch(function (reason) {
            sink.error(reason);
          });
        };
        sink.onCancel = function (reason) {
          _rangeReader.cancel(reason);
        };
      }, this);
      messageHandler.on('GetDoc', function transportDoc(data) {
        var pdfInfo = data.pdfInfo;
        this.numPages = data.pdfInfo.numPages;
        var loadingTask = this.loadingTask;
        var pdfDocument = new PDFDocumentProxy(pdfInfo, this, loadingTask);
        this.pdfDocument = pdfDocument;
        loadingTask._capability.resolve(pdfDocument);
      }, this);
      messageHandler.on('PasswordRequest', function transportPasswordRequest(exception) {
        var _this11 = this;

        this._passwordCapability = (0, _util.createPromiseCapability)();
        if (loadingTask.onPassword) {
          var updatePassword = function updatePassword(password) {
            _this11._passwordCapability.resolve({ password: password });
          };
          loadingTask.onPassword(updatePassword, exception.code);
        } else {
          this._passwordCapability.reject(new _util.PasswordException(exception.message, exception.code));
        }
        return this._passwordCapability.promise;
      }, this);
      messageHandler.on('PasswordException', function transportPasswordException(exception) {
        loadingTask._capability.reject(new _util.PasswordException(exception.message, exception.code));
      }, this);
      messageHandler.on('InvalidPDF', function transportInvalidPDF(exception) {
        this.loadingTask._capability.reject(new _util.InvalidPDFException(exception.message));
      }, this);
      messageHandler.on('MissingPDF', function transportMissingPDF(exception) {
        this.loadingTask._capability.reject(new _util.MissingPDFException(exception.message));
      }, this);
      messageHandler.on('UnexpectedResponse', function transportUnexpectedResponse(exception) {
        this.loadingTask._capability.reject(new _util.UnexpectedResponseException(exception.message, exception.status));
      }, this);
      messageHandler.on('UnknownError', function transportUnknownError(exception) {
        this.loadingTask._capability.reject(new _util.UnknownErrorException(exception.message, exception.details));
      }, this);
      messageHandler.on('DataLoaded', function transportPage(data) {
        this.downloadInfoCapability.resolve(data);
      }, this);
      messageHandler.on('PDFManagerReady', function transportPage(data) {}, this);
      messageHandler.on('StartRenderPage', function transportRender(data) {
        if (this.destroyed) {
          return;
        }
        var page = this.pageCache[data.pageIndex];
        page.stats.timeEnd('Page Request');
        page._startRenderPage(data.transparency, data.intent);
      }, this);
      messageHandler.on('RenderPageChunk', function transportRender(data) {
        if (this.destroyed) {
          return;
        }
        var page = this.pageCache[data.pageIndex];
        page._renderPageChunk(data.operatorList, data.intent);
      }, this);
      messageHandler.on('commonobj', function transportObj(data) {
        var _this12 = this;

        if (this.destroyed) {
          return;
        }
        var id = data[0];
        var type = data[1];
        if (this.commonObjs.hasData(id)) {
          return;
        }
        switch (type) {
          case 'Font':
            var exportedData = data[2];
            if ('error' in exportedData) {
              var exportedError = exportedData.error;
              (0, _util.warn)('Error during font loading: ' + exportedError);
              this.commonObjs.resolve(id, exportedError);
              break;
            }
            var fontRegistry = null;
            if ((0, _dom_utils.getDefaultSetting)('pdfBug') && _util.globalScope.FontInspector && _util.globalScope['FontInspector'].enabled) {
              fontRegistry = {
                registerFont: function registerFont(font, url) {
                  _util.globalScope['FontInspector'].fontAdded(font, url);
                }
              };
            }
            var font = new _font_loader.FontFaceObject(exportedData, {
              isEvalSuported: (0, _dom_utils.getDefaultSetting)('isEvalSupported'),
              disableFontFace: (0, _dom_utils.getDefaultSetting)('disableFontFace'),
              fontRegistry: fontRegistry
            });
            var fontReady = function fontReady(fontObjs) {
              _this12.commonObjs.resolve(id, font);
            };
            this.fontLoader.bind([font], fontReady);
            break;
          case 'FontPath':
            this.commonObjs.resolve(id, data[2]);
            break;
          default:
            throw new Error('Got unknown common object type ' + type);
        }
      }, this);
      messageHandler.on('obj', function transportObj(data) {
        if (this.destroyed) {
          return;
        }
        var id = data[0];
        var pageIndex = data[1];
        var type = data[2];
        var pageProxy = this.pageCache[pageIndex];
        var imageData;
        if (pageProxy.objs.hasData(id)) {
          return;
        }
        switch (type) {
          case 'JpegStream':
            imageData = data[3];
            (0, _util.loadJpegStream)(id, imageData, pageProxy.objs);
            break;
          case 'Image':
            imageData = data[3];
            pageProxy.objs.resolve(id, imageData);
            var MAX_IMAGE_SIZE_TO_STORE = 8000000;
            if (imageData && 'data' in imageData && imageData.data.length > MAX_IMAGE_SIZE_TO_STORE) {
              pageProxy.cleanupAfterRender = true;
            }
            break;
          default:
            throw new Error('Got unknown object type ' + type);
        }
      }, this);
      messageHandler.on('DocProgress', function transportDocProgress(data) {
        if (this.destroyed) {
          return;
        }
        var loadingTask = this.loadingTask;
        if (loadingTask.onProgress) {
          loadingTask.onProgress({
            loaded: data.loaded,
            total: data.total
          });
        }
      }, this);
      messageHandler.on('PageError', function transportError(data) {
        if (this.destroyed) {
          return;
        }
        var page = this.pageCache[data.pageNum - 1];
        var intentState = page.intentStates[data.intent];
        if (intentState.displayReadyCapability) {
          intentState.displayReadyCapability.reject(data.error);
        } else {
          throw new Error(data.error);
        }
        if (intentState.operatorList) {
          intentState.operatorList.lastChunk = true;
          for (var i = 0; i < intentState.renderTasks.length; i++) {
            intentState.renderTasks[i].operatorListChanged();
          }
        }
      }, this);
      messageHandler.on('UnsupportedFeature', function transportUnsupportedFeature(data) {
        if (this.destroyed) {
          return;
        }
        var featureId = data.featureId;
        var loadingTask = this.loadingTask;
        if (loadingTask.onUnsupportedFeature) {
          loadingTask.onUnsupportedFeature(featureId);
        }
        _UnsupportedManager.notify(featureId);
      }, this);
      messageHandler.on('JpegDecode', function (data) {
        if (this.destroyed) {
          return Promise.reject(new Error('Worker was destroyed'));
        }
        if (typeof document === 'undefined') {
          return Promise.reject(new Error('"document" is not defined.'));
        }
        var imageUrl = data[0];
        var components = data[1];
        if (components !== 3 && components !== 1) {
          return Promise.reject(new Error('Only 3 components or 1 component can be returned'));
        }
        return new Promise(function (resolve, reject) {
          var img = new Image();
          img.onload = function () {
            var width = img.width;
            var height = img.height;
            var size = width * height;
            var rgbaLength = size * 4;
            var buf = new Uint8Array(size * components);
            var tmpCanvas = document.createElement('canvas');
            tmpCanvas.width = width;
            tmpCanvas.height = height;
            var tmpCtx = tmpCanvas.getContext('2d');
            tmpCtx.drawImage(img, 0, 0);
            var data = tmpCtx.getImageData(0, 0, width, height).data;
            var i, j;
            if (components === 3) {
              for (i = 0, j = 0; i < rgbaLength; i += 4, j += 3) {
                buf[j] = data[i];
                buf[j + 1] = data[i + 1];
                buf[j + 2] = data[i + 2];
              }
            } else if (components === 1) {
              for (i = 0, j = 0; i < rgbaLength; i += 4, j++) {
                buf[j] = data[i];
              }
            }
            resolve({
              data: buf,
              width: width,
              height: height
            });
          };
          img.onerror = function () {
            reject(new Error('JpegDecode failed to load image'));
          };
          img.src = imageUrl;
        });
      }, this);
      messageHandler.on('FetchBuiltInCMap', function (data) {
        if (this.destroyed) {
          return Promise.reject(new Error('Worker was destroyed'));
        }
        return this.CMapReaderFactory.fetch({ name: data.name });
      }, this);
    },
    getData: function WorkerTransport_getData() {
      return this.messageHandler.sendWithPromise('GetData', null);
    },
    getPage: function WorkerTransport_getPage(pageNumber, capability) {
      var _this13 = this;

      if (!(0, _util.isInt)(pageNumber) || pageNumber <= 0 || pageNumber > this.numPages) {
        return Promise.reject(new Error('Invalid page request'));
      }
      var pageIndex = pageNumber - 1;
      if (pageIndex in this.pagePromises) {
        return this.pagePromises[pageIndex];
      }
      var promise = this.messageHandler.sendWithPromise('GetPage', { pageIndex: pageIndex }).then(function (pageInfo) {
        if (_this13.destroyed) {
          throw new Error('Transport destroyed');
        }
        var page = new PDFPageProxy(pageIndex, pageInfo, _this13);
        _this13.pageCache[pageIndex] = page;
        return page;
      });
      this.pagePromises[pageIndex] = promise;
      return promise;
    },
    getPageIndex: function WorkerTransport_getPageIndexByRef(ref) {
      return this.messageHandler.sendWithPromise('GetPageIndex', { ref: ref }).catch(function (reason) {
        return Promise.reject(new Error(reason));
      });
    },
    getAnnotations: function WorkerTransport_getAnnotations(pageIndex, intent) {
      return this.messageHandler.sendWithPromise('GetAnnotations', {
        pageIndex: pageIndex,
        intent: intent
      });
    },
    getDestinations: function WorkerTransport_getDestinations() {
      return this.messageHandler.sendWithPromise('GetDestinations', null);
    },
    getDestination: function WorkerTransport_getDestination(id) {
      return this.messageHandler.sendWithPromise('GetDestination', { id: id });
    },
    getPageLabels: function WorkerTransport_getPageLabels() {
      return this.messageHandler.sendWithPromise('GetPageLabels', null);
    },
    getPageMode: function getPageMode() {
      return this.messageHandler.sendWithPromise('GetPageMode', null);
    },

    getAttachments: function WorkerTransport_getAttachments() {
      return this.messageHandler.sendWithPromise('GetAttachments', null);
    },
    getJavaScript: function WorkerTransport_getJavaScript() {
      return this.messageHandler.sendWithPromise('GetJavaScript', null);
    },
    getOutline: function WorkerTransport_getOutline() {
      return this.messageHandler.sendWithPromise('GetOutline', null);
    },
    getMetadata: function WorkerTransport_getMetadata() {
      return this.messageHandler.sendWithPromise('GetMetadata', null).then(function transportMetadata(results) {
        return {
          info: results[0],
          metadata: results[1] ? new _metadata.Metadata(results[1]) : null
        };
      });
    },
    getStats: function WorkerTransport_getStats() {
      return this.messageHandler.sendWithPromise('GetStats', null);
    },
    startCleanup: function WorkerTransport_startCleanup() {
      var _this14 = this;

      this.messageHandler.sendWithPromise('Cleanup', null).then(function () {
        for (var i = 0, ii = _this14.pageCache.length; i < ii; i++) {
          var page = _this14.pageCache[i];
          if (page) {
            page.cleanup();
          }
        }
        _this14.commonObjs.clear();
        _this14.fontLoader.clear();
      });
    }
  };
  return WorkerTransport;
}();
var PDFObjects = function PDFObjectsClosure() {
  function PDFObjects() {
    this.objs = Object.create(null);
  }
  PDFObjects.prototype = {
    ensureObj: function PDFObjects_ensureObj(objId) {
      if (this.objs[objId]) {
        return this.objs[objId];
      }
      var obj = {
        capability: (0, _util.createPromiseCapability)(),
        data: null,
        resolved: false
      };
      this.objs[objId] = obj;
      return obj;
    },
    get: function PDFObjects_get(objId, callback) {
      if (callback) {
        this.ensureObj(objId).capability.promise.then(callback);
        return null;
      }
      var obj = this.objs[objId];
      if (!obj || !obj.resolved) {
        throw new Error('Requesting object that isn\'t resolved yet ' + objId);
      }
      return obj.data;
    },
    resolve: function PDFObjects_resolve(objId, data) {
      var obj = this.ensureObj(objId);
      obj.resolved = true;
      obj.data = data;
      obj.capability.resolve(data);
    },
    isResolved: function PDFObjects_isResolved(objId) {
      var objs = this.objs;
      if (!objs[objId]) {
        return false;
      }
      return objs[objId].resolved;
    },
    hasData: function PDFObjects_hasData(objId) {
      return this.isResolved(objId);
    },
    getData: function PDFObjects_getData(objId) {
      var objs = this.objs;
      if (!objs[objId] || !objs[objId].resolved) {
        return null;
      }
      return objs[objId].data;
    },
    clear: function PDFObjects_clear() {
      this.objs = Object.create(null);
    }
  };
  return PDFObjects;
}();
var RenderTask = function RenderTaskClosure() {
  function RenderTask(internalRenderTask) {
    this._internalRenderTask = internalRenderTask;
    this.onContinue = null;
  }
  RenderTask.prototype = {
    get promise() {
      return this._internalRenderTask.capability.promise;
    },
    cancel: function RenderTask_cancel() {
      this._internalRenderTask.cancel();
    },
    then: function RenderTask_then(onFulfilled, onRejected) {
      return this.promise.then.apply(this.promise, arguments);
    }
  };
  return RenderTask;
}();
var InternalRenderTask = function InternalRenderTaskClosure() {
  var canvasInRendering = new WeakMap();
  function InternalRenderTask(callback, params, objs, commonObjs, operatorList, pageNumber, canvasFactory) {
    this.callback = callback;
    this.params = params;
    this.objs = objs;
    this.commonObjs = commonObjs;
    this.operatorListIdx = null;
    this.operatorList = operatorList;
    this.pageNumber = pageNumber;
    this.canvasFactory = canvasFactory;
    this.running = false;
    this.graphicsReadyCallback = null;
    this.graphicsReady = false;
    this.useRequestAnimationFrame = false;
    this.cancelled = false;
    this.capability = (0, _util.createPromiseCapability)();
    this.task = new RenderTask(this);
    this._continueBound = this._continue.bind(this);
    this._scheduleNextBound = this._scheduleNext.bind(this);
    this._nextBound = this._next.bind(this);
    this._canvas = params.canvasContext.canvas;
  }
  InternalRenderTask.prototype = {
    initializeGraphics: function InternalRenderTask_initializeGraphics(transparency) {
      if (this._canvas) {
        if (canvasInRendering.has(this._canvas)) {
          throw new Error('Cannot use the same canvas during multiple render() operations. ' + 'Use different canvas or ensure previous operations were ' + 'cancelled or completed.');
        }
        canvasInRendering.set(this._canvas, this);
      }
      if (this.cancelled) {
        return;
      }
      if ((0, _dom_utils.getDefaultSetting)('pdfBug') && _util.globalScope.StepperManager && _util.globalScope.StepperManager.enabled) {
        this.stepper = _util.globalScope.StepperManager.create(this.pageNumber - 1);
        this.stepper.init(this.operatorList);
        this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint();
      }
      var params = this.params;
      this.gfx = new _canvas.CanvasGraphics(params.canvasContext, this.commonObjs, this.objs, this.canvasFactory, params.imageLayer);
      this.gfx.beginDrawing({
        transform: params.transform,
        viewport: params.viewport,
        transparency: transparency,
        background: params.background
      });
      this.operatorListIdx = 0;
      this.graphicsReady = true;
      if (this.graphicsReadyCallback) {
        this.graphicsReadyCallback();
      }
    },
    cancel: function InternalRenderTask_cancel() {
      this.running = false;
      this.cancelled = true;
      if (this._canvas) {
        canvasInRendering.delete(this._canvas);
      }
      if ((0, _dom_utils.getDefaultSetting)('pdfjsNext')) {
        this.callback(new _dom_utils.RenderingCancelledException('Rendering cancelled, page ' + this.pageNumber, 'canvas'));
      } else {
        this.callback('cancelled');
      }
    },
    operatorListChanged: function InternalRenderTask_operatorListChanged() {
      if (!this.graphicsReady) {
        if (!this.graphicsReadyCallback) {
          this.graphicsReadyCallback = this._continueBound;
        }
        return;
      }
      if (this.stepper) {
        this.stepper.updateOperatorList(this.operatorList);
      }
      if (this.running) {
        return;
      }
      this._continue();
    },
    _continue: function InternalRenderTask__continue() {
      this.running = true;
      if (this.cancelled) {
        return;
      }
      if (this.task.onContinue) {
        this.task.onContinue(this._scheduleNextBound);
      } else {
        this._scheduleNext();
      }
    },
    _scheduleNext: function InternalRenderTask__scheduleNext() {
      if (this.useRequestAnimationFrame && typeof window !== 'undefined') {
        window.requestAnimationFrame(this._nextBound);
      } else {
        Promise.resolve(undefined).then(this._nextBound);
      }
    },
    _next: function InternalRenderTask__next() {
      if (this.cancelled) {
        return;
      }
      this.operatorListIdx = this.gfx.executeOperatorList(this.operatorList, this.operatorListIdx, this._continueBound, this.stepper);
      if (this.operatorListIdx === this.operatorList.argsArray.length) {
        this.running = false;
        if (this.operatorList.lastChunk) {
          this.gfx.endDrawing();
          if (this._canvas) {
            canvasInRendering.delete(this._canvas);
          }
          this.callback();
        }
      }
    }
  };
  return InternalRenderTask;
}();
var _UnsupportedManager = function UnsupportedManagerClosure() {
  var listeners = [];
  return {
    listen: function listen(cb) {
      (0, _util.deprecated)('Global UnsupportedManager.listen is used: ' + ' use PDFDocumentLoadingTask.onUnsupportedFeature instead');
      listeners.push(cb);
    },
    notify: function notify(featureId) {
      for (var i = 0, ii = listeners.length; i < ii; i++) {
        listeners[i](featureId);
      }
    }
  };
}();
var version, build;
{
  exports.version = version = '1.8.619';
  exports.build = build = '723bc25b';
}
exports.getDocument = getDocument;
exports.LoopbackPort = LoopbackPort;
exports.PDFDataRangeTransport = PDFDataRangeTransport;
exports.PDFWorker = PDFWorker;
exports.PDFDocumentProxy = PDFDocumentProxy;
exports.PDFPageProxy = PDFPageProxy;
exports.setPDFNetworkStreamClass = setPDFNetworkStreamClass;
exports._UnsupportedManager = _UnsupportedManager;
exports.version = version;
exports.build = build;

/***/ }),
/* 3 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnnotationLayer = undefined;

var _dom_utils = __w_pdfjs_require__(1);

var _util = __w_pdfjs_require__(0);

function AnnotationElementFactory() {}
AnnotationElementFactory.prototype = {
  create: function AnnotationElementFactory_create(parameters) {
    var subtype = parameters.data.annotationType;
    switch (subtype) {
      case _util.AnnotationType.LINK:
        return new LinkAnnotationElement(parameters);
      case _util.AnnotationType.TEXT:
        return new TextAnnotationElement(parameters);
      case _util.AnnotationType.WIDGET:
        var fieldType = parameters.data.fieldType;
        switch (fieldType) {
          case 'Tx':
            return new TextWidgetAnnotationElement(parameters);
          case 'Btn':
            if (parameters.data.radioButton) {
              return new RadioButtonWidgetAnnotationElement(parameters);
            } else if (parameters.data.checkBox) {
              return new CheckboxWidgetAnnotationElement(parameters);
            }
            (0, _util.warn)('Unimplemented button widget annotation: pushbutton');
            break;
          case 'Ch':
            return new ChoiceWidgetAnnotationElement(parameters);
        }
        return new WidgetAnnotationElement(parameters);
      case _util.AnnotationType.POPUP:
        return new PopupAnnotationElement(parameters);
      case _util.AnnotationType.LINE:
        return new LineAnnotationElement(parameters);
      case _util.AnnotationType.HIGHLIGHT:
        return new HighlightAnnotationElement(parameters);
      case _util.AnnotationType.UNDERLINE:
        return new UnderlineAnnotationElement(parameters);
      case _util.AnnotationType.SQUIGGLY:
        return new SquigglyAnnotationElement(parameters);
      case _util.AnnotationType.STRIKEOUT:
        return new StrikeOutAnnotationElement(parameters);
      case _util.AnnotationType.FILEATTACHMENT:
        return new FileAttachmentAnnotationElement(parameters);
      default:
        return new AnnotationElement(parameters);
    }
  }
};
var AnnotationElement = function AnnotationElementClosure() {
  function AnnotationElement(parameters, isRenderable, ignoreBorder) {
    this.isRenderable = isRenderable || false;
    this.data = parameters.data;
    this.layer = parameters.layer;
    this.page = parameters.page;
    this.viewport = parameters.viewport;
    this.linkService = parameters.linkService;
    this.downloadManager = parameters.downloadManager;
    this.imageResourcesPath = parameters.imageResourcesPath;
    this.renderInteractiveForms = parameters.renderInteractiveForms;
    if (isRenderable) {
      this.container = this._createContainer(ignoreBorder);
    }
  }
  AnnotationElement.prototype = {
    _createContainer: function AnnotationElement_createContainer(ignoreBorder) {
      var data = this.data,
          page = this.page,
          viewport = this.viewport;
      var container = document.createElement('section');
      var width = data.rect[2] - data.rect[0];
      var height = data.rect[3] - data.rect[1];
      container.setAttribute('data-annotation-id', data.id);
      var rect = _util.Util.normalizeRect([data.rect[0], page.view[3] - data.rect[1] + page.view[1], data.rect[2], page.view[3] - data.rect[3] + page.view[1]]);
      _dom_utils.CustomStyle.setProp('transform', container, 'matrix(' + viewport.transform.join(',') + ')');
      _dom_utils.CustomStyle.setProp('transformOrigin', container, -rect[0] + 'px ' + -rect[1] + 'px');
      if (!ignoreBorder && data.borderStyle.width > 0) {
        container.style.borderWidth = data.borderStyle.width + 'px';
        if (data.borderStyle.style !== _util.AnnotationBorderStyleType.UNDERLINE) {
          width = width - 2 * data.borderStyle.width;
          height = height - 2 * data.borderStyle.width;
        }
        var horizontalRadius = data.borderStyle.horizontalCornerRadius;
        var verticalRadius = data.borderStyle.verticalCornerRadius;
        if (horizontalRadius > 0 || verticalRadius > 0) {
          var radius = horizontalRadius + 'px / ' + verticalRadius + 'px';
          _dom_utils.CustomStyle.setProp('borderRadius', container, radius);
        }
        switch (data.borderStyle.style) {
          case _util.AnnotationBorderStyleType.SOLID:
            container.style.borderStyle = 'solid';
            break;
          case _util.AnnotationBorderStyleType.DASHED:
            container.style.borderStyle = 'dashed';
            break;
          case _util.AnnotationBorderStyleType.BEVELED:
            (0, _util.warn)('Unimplemented border style: beveled');
            break;
          case _util.AnnotationBorderStyleType.INSET:
            (0, _util.warn)('Unimplemented border style: inset');
            break;
          case _util.AnnotationBorderStyleType.UNDERLINE:
            container.style.borderBottomStyle = 'solid';
            break;
          default:
            break;
        }
        if (data.color) {
          container.style.borderColor = _util.Util.makeCssRgb(data.color[0] | 0, data.color[1] | 0, data.color[2] | 0);
        } else {
          container.style.borderWidth = 0;
        }
      }
      container.style.left = rect[0] + 'px';
      container.style.top = rect[1] + 'px';
      container.style.width = width + 'px';
      container.style.height = height + 'px';
      return container;
    },
    _createPopup: function AnnotationElement_createPopup(container, trigger, data) {
      if (!trigger) {
        trigger = document.createElement('div');
        trigger.style.height = container.style.height;
        trigger.style.width = container.style.width;
        container.appendChild(trigger);
      }
      var popupElement = new PopupElement({
        container: container,
        trigger: trigger,
        color: data.color,
        title: data.title,
        contents: data.contents,
        hideWrapper: true
      });
      var popup = popupElement.render();
      popup.style.left = container.style.width;
      container.appendChild(popup);
    },
    render: function AnnotationElement_render() {
      throw new Error('Abstract method AnnotationElement.render called');
    }
  };
  return AnnotationElement;
}();
var LinkAnnotationElement = function LinkAnnotationElementClosure() {
  function LinkAnnotationElement(parameters) {
    AnnotationElement.call(this, parameters, true);
  }
  _util.Util.inherit(LinkAnnotationElement, AnnotationElement, {
    render: function LinkAnnotationElement_render() {
      this.container.className = 'linkAnnotation';
      var link = document.createElement('a');
      (0, _dom_utils.addLinkAttributes)(link, {
        url: this.data.url,
        target: this.data.newWindow ? _dom_utils.LinkTarget.BLANK : undefined
      });
      if (!this.data.url) {
        if (this.data.action) {
          this._bindNamedAction(link, this.data.action);
        } else {
          this._bindLink(link, this.data.dest);
        }
      }
      this.container.appendChild(link);
      return this.container;
    },
    _bindLink: function _bindLink(link, destination) {
      var _this = this;

      link.href = this.linkService.getDestinationHash(destination);
      link.onclick = function () {
        if (destination) {
          _this.linkService.navigateTo(destination);
        }
        return false;
      };
      if (destination) {
        link.className = 'internalLink';
      }
    },
    _bindNamedAction: function _bindNamedAction(link, action) {
      var _this2 = this;

      link.href = this.linkService.getAnchorUrl('');
      link.onclick = function () {
        _this2.linkService.executeNamedAction(action);
        return false;
      };
      link.className = 'internalLink';
    }
  });
  return LinkAnnotationElement;
}();
var TextAnnotationElement = function TextAnnotationElementClosure() {
  function TextAnnotationElement(parameters) {
    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    AnnotationElement.call(this, parameters, isRenderable);
  }
  _util.Util.inherit(TextAnnotationElement, AnnotationElement, {
    render: function TextAnnotationElement_render() {
      this.container.className = 'textAnnotation';
      var image = document.createElement('img');
      image.style.height = this.container.style.height;
      image.style.width = this.container.style.width;
      image.src = this.imageResourcesPath + 'annotation-' + this.data.name.toLowerCase() + '.svg';
      image.alt = '[{{type}} Annotation]';
      image.dataset.l10nId = 'text_annotation_type';
      image.dataset.l10nArgs = JSON.stringify({ type: this.data.name });
      if (!this.data.hasPopup) {
        this._createPopup(this.container, image, this.data);
      }
      this.container.appendChild(image);
      return this.container;
    }
  });
  return TextAnnotationElement;
}();
var WidgetAnnotationElement = function WidgetAnnotationElementClosure() {
  function WidgetAnnotationElement(parameters, isRenderable) {
    AnnotationElement.call(this, parameters, isRenderable);
  }
  _util.Util.inherit(WidgetAnnotationElement, AnnotationElement, {
    render: function WidgetAnnotationElement_render() {
      return this.container;
    }
  });
  return WidgetAnnotationElement;
}();
var TextWidgetAnnotationElement = function TextWidgetAnnotationElementClosure() {
  var TEXT_ALIGNMENT = ['left', 'center', 'right'];
  function TextWidgetAnnotationElement(parameters) {
    var isRenderable = parameters.renderInteractiveForms || !parameters.data.hasAppearance && !!parameters.data.fieldValue;
    WidgetAnnotationElement.call(this, parameters, isRenderable);
  }
  _util.Util.inherit(TextWidgetAnnotationElement, WidgetAnnotationElement, {
    render: function TextWidgetAnnotationElement_render() {
      this.container.className = 'textWidgetAnnotation';
      var element = null;
      if (this.renderInteractiveForms) {
        if (this.data.multiLine) {
          element = document.createElement('textarea');
          element.textContent = this.data.fieldValue;
        } else {
          element = document.createElement('input');
          element.type = 'text';
          element.setAttribute('value', this.data.fieldValue);
        }
        element.disabled = this.data.readOnly;
        if (this.data.maxLen !== null) {
          element.maxLength = this.data.maxLen;
        }
        if (this.data.comb) {
          var fieldWidth = this.data.rect[2] - this.data.rect[0];
          var combWidth = fieldWidth / this.data.maxLen;
          element.classList.add('comb');
          element.style.letterSpacing = 'calc(' + combWidth + 'px - 1ch)';
        }
      } else {
        element = document.createElement('div');
        element.textContent = this.data.fieldValue;
        element.style.verticalAlign = 'middle';
        element.style.display = 'table-cell';
        var font = null;
        if (this.data.fontRefName) {
          font = this.page.commonObjs.getData(this.data.fontRefName);
        }
        this._setTextStyle(element, font);
      }
      if (this.data.textAlignment !== null) {
        element.style.textAlign = TEXT_ALIGNMENT[this.data.textAlignment];
      }
      this.container.appendChild(element);
      return this.container;
    },
    _setTextStyle: function TextWidgetAnnotationElement_setTextStyle(element, font) {
      var style = element.style;
      style.fontSize = this.data.fontSize + 'px';
      style.direction = this.data.fontDirection < 0 ? 'rtl' : 'ltr';
      if (!font) {
        return;
      }
      style.fontWeight = font.black ? font.bold ? '900' : 'bold' : font.bold ? 'bold' : 'normal';
      style.fontStyle = font.italic ? 'italic' : 'normal';
      var fontFamily = font.loadedName ? '"' + font.loadedName + '", ' : '';
      var fallbackName = font.fallbackName || 'Helvetica, sans-serif';
      style.fontFamily = fontFamily + fallbackName;
    }
  });
  return TextWidgetAnnotationElement;
}();
var CheckboxWidgetAnnotationElement = function CheckboxWidgetAnnotationElementClosure() {
  function CheckboxWidgetAnnotationElement(parameters) {
    WidgetAnnotationElement.call(this, parameters, parameters.renderInteractiveForms);
  }
  _util.Util.inherit(CheckboxWidgetAnnotationElement, WidgetAnnotationElement, {
    render: function CheckboxWidgetAnnotationElement_render() {
      this.container.className = 'buttonWidgetAnnotation checkBox';
      var element = document.createElement('input');
      element.disabled = this.data.readOnly;
      element.type = 'checkbox';
      if (this.data.fieldValue && this.data.fieldValue !== 'Off') {
        element.setAttribute('checked', true);
      }
      this.container.appendChild(element);
      return this.container;
    }
  });
  return CheckboxWidgetAnnotationElement;
}();
var RadioButtonWidgetAnnotationElement = function RadioButtonWidgetAnnotationElementClosure() {
  function RadioButtonWidgetAnnotationElement(parameters) {
    WidgetAnnotationElement.call(this, parameters, parameters.renderInteractiveForms);
  }
  _util.Util.inherit(RadioButtonWidgetAnnotationElement, WidgetAnnotationElement, {
    render: function RadioButtonWidgetAnnotationElement_render() {
      this.container.className = 'buttonWidgetAnnotation radioButton';
      var element = document.createElement('input');
      element.disabled = this.data.readOnly;
      element.type = 'radio';
      element.name = this.data.fieldName;
      if (this.data.fieldValue === this.data.buttonValue) {
        element.setAttribute('checked', true);
      }
      this.container.appendChild(element);
      return this.container;
    }
  });
  return RadioButtonWidgetAnnotationElement;
}();
var ChoiceWidgetAnnotationElement = function ChoiceWidgetAnnotationElementClosure() {
  function ChoiceWidgetAnnotationElement(parameters) {
    WidgetAnnotationElement.call(this, parameters, parameters.renderInteractiveForms);
  }
  _util.Util.inherit(ChoiceWidgetAnnotationElement, WidgetAnnotationElement, {
    render: function ChoiceWidgetAnnotationElement_render() {
      this.container.className = 'choiceWidgetAnnotation';
      var selectElement = document.createElement('select');
      selectElement.disabled = this.data.readOnly;
      if (!this.data.combo) {
        selectElement.size = this.data.options.length;
        if (this.data.multiSelect) {
          selectElement.multiple = true;
        }
      }
      for (var i = 0, ii = this.data.options.length; i < ii; i++) {
        var option = this.data.options[i];
        var optionElement = document.createElement('option');
        optionElement.textContent = option.displayValue;
        optionElement.value = option.exportValue;
        if (this.data.fieldValue.indexOf(option.displayValue) >= 0) {
          optionElement.setAttribute('selected', true);
        }
        selectElement.appendChild(optionElement);
      }
      this.container.appendChild(selectElement);
      return this.container;
    }
  });
  return ChoiceWidgetAnnotationElement;
}();
var PopupAnnotationElement = function PopupAnnotationElementClosure() {
  var IGNORE_TYPES = ['Line'];
  function PopupAnnotationElement(parameters) {
    var isRenderable = !!(parameters.data.title || parameters.data.contents);
    AnnotationElement.call(this, parameters, isRenderable);
  }
  _util.Util.inherit(PopupAnnotationElement, AnnotationElement, {
    render: function PopupAnnotationElement_render() {
      this.container.className = 'popupAnnotation';
      if (IGNORE_TYPES.indexOf(this.data.parentType) >= 0) {
        return this.container;
      }
      var selector = '[data-annotation-id="' + this.data.parentId + '"]';
      var parentElement = this.layer.querySelector(selector);
      if (!parentElement) {
        return this.container;
      }
      var popup = new PopupElement({
        container: this.container,
        trigger: parentElement,
        color: this.data.color,
        title: this.data.title,
        contents: this.data.contents
      });
      var parentLeft = parseFloat(parentElement.style.left);
      var parentWidth = parseFloat(parentElement.style.width);
      _dom_utils.CustomStyle.setProp('transformOrigin', this.container, -(parentLeft + parentWidth) + 'px -' + parentElement.style.top);
      this.container.style.left = parentLeft + parentWidth + 'px';
      this.container.appendChild(popup.render());
      return this.container;
    }
  });
  return PopupAnnotationElement;
}();
var PopupElement = function PopupElementClosure() {
  var BACKGROUND_ENLIGHT = 0.7;
  function PopupElement(parameters) {
    this.container = parameters.container;
    this.trigger = parameters.trigger;
    this.color = parameters.color;
    this.title = parameters.title;
    this.contents = parameters.contents;
    this.hideWrapper = parameters.hideWrapper || false;
    this.pinned = false;
  }
  PopupElement.prototype = {
    render: function PopupElement_render() {
      var wrapper = document.createElement('div');
      wrapper.className = 'popupWrapper';
      this.hideElement = this.hideWrapper ? wrapper : this.container;
      this.hideElement.setAttribute('hidden', true);
      var popup = document.createElement('div');
      popup.className = 'popup';
      var color = this.color;
      if (color) {
        var r = BACKGROUND_ENLIGHT * (255 - color[0]) + color[0];
        var g = BACKGROUND_ENLIGHT * (255 - color[1]) + color[1];
        var b = BACKGROUND_ENLIGHT * (255 - color[2]) + color[2];
        popup.style.backgroundColor = _util.Util.makeCssRgb(r | 0, g | 0, b | 0);
      }
      var contents = this._formatContents(this.contents);
      var title = document.createElement('h1');
      title.textContent = this.title;
      this.trigger.addEventListener('click', this._toggle.bind(this));
      this.trigger.addEventListener('mouseover', this._show.bind(this, false));
      this.trigger.addEventListener('mouseout', this._hide.bind(this, false));
      popup.addEventListener('click', this._hide.bind(this, true));
      popup.appendChild(title);
      popup.appendChild(contents);
      wrapper.appendChild(popup);
      return wrapper;
    },
    _formatContents: function PopupElement_formatContents(contents) {
      var p = document.createElement('p');
      var lines = contents.split(/(?:\r\n?|\n)/);
      for (var i = 0, ii = lines.length; i < ii; ++i) {
        var line = lines[i];
        p.appendChild(document.createTextNode(line));
        if (i < ii - 1) {
          p.appendChild(document.createElement('br'));
        }
      }
      return p;
    },
    _toggle: function PopupElement_toggle() {
      if (this.pinned) {
        this._hide(true);
      } else {
        this._show(true);
      }
    },
    _show: function PopupElement_show(pin) {
      if (pin) {
        this.pinned = true;
      }
      if (this.hideElement.hasAttribute('hidden')) {
        this.hideElement.removeAttribute('hidden');
        this.container.style.zIndex += 1;
      }
    },
    _hide: function PopupElement_hide(unpin) {
      if (unpin) {
        this.pinned = false;
      }
      if (!this.hideElement.hasAttribute('hidden') && !this.pinned) {
        this.hideElement.setAttribute('hidden', true);
        this.container.style.zIndex -= 1;
      }
    }
  };
  return PopupElement;
}();
var LineAnnotationElement = function LineAnnotationElementClosure() {
  var SVG_NS = 'http://www.w3.org/2000/svg';
  function LineAnnotationElement(parameters) {
    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    AnnotationElement.call(this, parameters, isRenderable, true);
  }
  _util.Util.inherit(LineAnnotationElement, AnnotationElement, {
    render: function LineAnnotationElement_render() {
      this.container.className = 'lineAnnotation';
      var data = this.data;
      var width = data.rect[2] - data.rect[0];
      var height = data.rect[3] - data.rect[1];
      var svg = document.createElementNS(SVG_NS, 'svg:svg');
      svg.setAttributeNS(null, 'version', '1.1');
      svg.setAttributeNS(null, 'width', width + 'px');
      svg.setAttributeNS(null, 'height', height + 'px');
      svg.setAttributeNS(null, 'preserveAspectRatio', 'none');
      svg.setAttributeNS(null, 'viewBox', '0 0 ' + width + ' ' + height);
      var line = document.createElementNS(SVG_NS, 'svg:line');
      line.setAttributeNS(null, 'x1', data.rect[2] - data.lineCoordinates[0]);
      line.setAttributeNS(null, 'y1', data.rect[3] - data.lineCoordinates[1]);
      line.setAttributeNS(null, 'x2', data.rect[2] - data.lineCoordinates[2]);
      line.setAttributeNS(null, 'y2', data.rect[3] - data.lineCoordinates[3]);
      line.setAttributeNS(null, 'stroke-width', data.borderStyle.width);
      line.setAttributeNS(null, 'stroke', 'transparent');
      svg.appendChild(line);
      this.container.append(svg);
      this._createPopup(this.container, line, this.data);
      return this.container;
    }
  });
  return LineAnnotationElement;
}();
var HighlightAnnotationElement = function HighlightAnnotationElementClosure() {
  function HighlightAnnotationElement(parameters) {
    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    AnnotationElement.call(this, parameters, isRenderable, true);
  }
  _util.Util.inherit(HighlightAnnotationElement, AnnotationElement, {
    render: function HighlightAnnotationElement_render() {
      this.container.className = 'highlightAnnotation';
      if (!this.data.hasPopup) {
        this._createPopup(this.container, null, this.data);
      }
      return this.container;
    }
  });
  return HighlightAnnotationElement;
}();
var UnderlineAnnotationElement = function UnderlineAnnotationElementClosure() {
  function UnderlineAnnotationElement(parameters) {
    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    AnnotationElement.call(this, parameters, isRenderable, true);
  }
  _util.Util.inherit(UnderlineAnnotationElement, AnnotationElement, {
    render: function UnderlineAnnotationElement_render() {
      this.container.className = 'underlineAnnotation';
      if (!this.data.hasPopup) {
        this._createPopup(this.container, null, this.data);
      }
      return this.container;
    }
  });
  return UnderlineAnnotationElement;
}();
var SquigglyAnnotationElement = function SquigglyAnnotationElementClosure() {
  function SquigglyAnnotationElement(parameters) {
    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    AnnotationElement.call(this, parameters, isRenderable, true);
  }
  _util.Util.inherit(SquigglyAnnotationElement, AnnotationElement, {
    render: function SquigglyAnnotationElement_render() {
      this.container.className = 'squigglyAnnotation';
      if (!this.data.hasPopup) {
        this._createPopup(this.container, null, this.data);
      }
      return this.container;
    }
  });
  return SquigglyAnnotationElement;
}();
var StrikeOutAnnotationElement = function StrikeOutAnnotationElementClosure() {
  function StrikeOutAnnotationElement(parameters) {
    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    AnnotationElement.call(this, parameters, isRenderable, true);
  }
  _util.Util.inherit(StrikeOutAnnotationElement, AnnotationElement, {
    render: function StrikeOutAnnotationElement_render() {
      this.container.className = 'strikeoutAnnotation';
      if (!this.data.hasPopup) {
        this._createPopup(this.container, null, this.data);
      }
      return this.container;
    }
  });
  return StrikeOutAnnotationElement;
}();
var FileAttachmentAnnotationElement = function FileAttachmentAnnotationElementClosure() {
  function FileAttachmentAnnotationElement(parameters) {
    AnnotationElement.call(this, parameters, true);
    var file = this.data.file;
    this.filename = (0, _dom_utils.getFilenameFromUrl)(file.filename);
    this.content = file.content;
    this.linkService.onFileAttachmentAnnotation({
      id: (0, _util.stringToPDFString)(file.filename),
      filename: file.filename,
      content: file.content
    });
  }
  _util.Util.inherit(FileAttachmentAnnotationElement, AnnotationElement, {
    render: function FileAttachmentAnnotationElement_render() {
      this.container.className = 'fileAttachmentAnnotation';
      var trigger = document.createElement('div');
      trigger.style.height = this.container.style.height;
      trigger.style.width = this.container.style.width;
      trigger.addEventListener('dblclick', this._download.bind(this));
      if (!this.data.hasPopup && (this.data.title || this.data.contents)) {
        this._createPopup(this.container, trigger, this.data);
      }
      this.container.appendChild(trigger);
      return this.container;
    },
    _download: function FileAttachmentAnnotationElement_download() {
      if (!this.downloadManager) {
        (0, _util.warn)('Download cannot be started due to unavailable download manager');
        return;
      }
      this.downloadManager.downloadData(this.content, this.filename, '');
    }
  });
  return FileAttachmentAnnotationElement;
}();
var AnnotationLayer = function AnnotationLayerClosure() {
  return {
    render: function AnnotationLayer_render(parameters) {
      var annotationElementFactory = new AnnotationElementFactory();
      for (var i = 0, ii = parameters.annotations.length; i < ii; i++) {
        var data = parameters.annotations[i];
        if (!data) {
          continue;
        }
        var element = annotationElementFactory.create({
          data: data,
          layer: parameters.div,
          page: parameters.page,
          viewport: parameters.viewport,
          linkService: parameters.linkService,
          downloadManager: parameters.downloadManager,
          imageResourcesPath: parameters.imageResourcesPath || (0, _dom_utils.getDefaultSetting)('imageResourcesPath'),
          renderInteractiveForms: parameters.renderInteractiveForms || false
        });
        if (element.isRenderable) {
          parameters.div.appendChild(element.render());
        }
      }
    },
    update: function AnnotationLayer_update(parameters) {
      for (var i = 0, ii = parameters.annotations.length; i < ii; i++) {
        var data = parameters.annotations[i];
        var element = parameters.div.querySelector('[data-annotation-id="' + data.id + '"]');
        if (element) {
          _dom_utils.CustomStyle.setProp('transform', element, 'matrix(' + parameters.viewport.transform.join(',') + ')');
        }
      }
      parameters.div.removeAttribute('hidden');
    }
  };
}();
exports.AnnotationLayer = AnnotationLayer;

/***/ }),
/* 4 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SVGGraphics = undefined;

var _util = __w_pdfjs_require__(0);

var SVGGraphics = function SVGGraphics() {
  throw new Error('Not implemented: SVGGraphics');
};
{
  var SVG_DEFAULTS = {
    fontStyle: 'normal',
    fontWeight: 'normal',
    fillColor: '#000000'
  };
  var convertImgDataToPng = function convertImgDataToPngClosure() {
    var PNG_HEADER = new Uint8Array([0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a]);
    var CHUNK_WRAPPER_SIZE = 12;
    var crcTable = new Int32Array(256);
    for (var i = 0; i < 256; i++) {
      var c = i;
      for (var h = 0; h < 8; h++) {
        if (c & 1) {
          c = 0xedB88320 ^ c >> 1 & 0x7fffffff;
        } else {
          c = c >> 1 & 0x7fffffff;
        }
      }
      crcTable[i] = c;
    }
    function crc32(data, start, end) {
      var crc = -1;
      for (var i = start; i < end; i++) {
        var a = (crc ^ data[i]) & 0xff;
        var b = crcTable[a];
        crc = crc >>> 8 ^ b;
      }
      return crc ^ -1;
    }
    function writePngChunk(type, body, data, offset) {
      var p = offset;
      var len = body.length;
      data[p] = len >> 24 & 0xff;
      data[p + 1] = len >> 16 & 0xff;
      data[p + 2] = len >> 8 & 0xff;
      data[p + 3] = len & 0xff;
      p += 4;
      data[p] = type.charCodeAt(0) & 0xff;
      data[p + 1] = type.charCodeAt(1) & 0xff;
      data[p + 2] = type.charCodeAt(2) & 0xff;
      data[p + 3] = type.charCodeAt(3) & 0xff;
      p += 4;
      data.set(body, p);
      p += body.length;
      var crc = crc32(data, offset + 4, p);
      data[p] = crc >> 24 & 0xff;
      data[p + 1] = crc >> 16 & 0xff;
      data[p + 2] = crc >> 8 & 0xff;
      data[p + 3] = crc & 0xff;
    }
    function adler32(data, start, end) {
      var a = 1;
      var b = 0;
      for (var i = start; i < end; ++i) {
        a = (a + (data[i] & 0xff)) % 65521;
        b = (b + a) % 65521;
      }
      return b << 16 | a;
    }
    function deflateSync(literals) {
      if (!(0, _util.isNodeJS)()) {
        return deflateSyncUncompressed(literals);
      }
      try {
        var input;
        if (parseInt(process.versions.node) >= 8) {
          input = literals;
        } else {
          input = new Buffer(literals);
        }
        var output = require('zlib').deflateSync(input, { level: 9 });
        return output instanceof Uint8Array ? output : new Uint8Array(output);
      } catch (e) {
        (0, _util.warn)('Not compressing PNG because zlib.deflateSync is unavailable: ' + e);
      }
      return deflateSyncUncompressed(literals);
    }
    function deflateSyncUncompressed(literals) {
      var len = literals.length;
      var maxBlockLength = 0xFFFF;
      var deflateBlocks = Math.ceil(len / maxBlockLength);
      var idat = new Uint8Array(2 + len + deflateBlocks * 5 + 4);
      var pi = 0;
      idat[pi++] = 0x78;
      idat[pi++] = 0x9c;
      var pos = 0;
      while (len > maxBlockLength) {
        idat[pi++] = 0x00;
        idat[pi++] = 0xff;
        idat[pi++] = 0xff;
        idat[pi++] = 0x00;
        idat[pi++] = 0x00;
        idat.set(literals.subarray(pos, pos + maxBlockLength), pi);
        pi += maxBlockLength;
        pos += maxBlockLength;
        len -= maxBlockLength;
      }
      idat[pi++] = 0x01;
      idat[pi++] = len & 0xff;
      idat[pi++] = len >> 8 & 0xff;
      idat[pi++] = ~len & 0xffff & 0xff;
      idat[pi++] = (~len & 0xffff) >> 8 & 0xff;
      idat.set(literals.subarray(pos), pi);
      pi += literals.length - pos;
      var adler = adler32(literals, 0, literals.length);
      idat[pi++] = adler >> 24 & 0xff;
      idat[pi++] = adler >> 16 & 0xff;
      idat[pi++] = adler >> 8 & 0xff;
      idat[pi++] = adler & 0xff;
      return idat;
    }
    function encode(imgData, kind, forceDataSchema) {
      var width = imgData.width;
      var height = imgData.height;
      var bitDepth, colorType, lineSize;
      var bytes = imgData.data;
      switch (kind) {
        case _util.ImageKind.GRAYSCALE_1BPP:
          colorType = 0;
          bitDepth = 1;
          lineSize = width + 7 >> 3;
          break;
        case _util.ImageKind.RGB_24BPP:
          colorType = 2;
          bitDepth = 8;
          lineSize = width * 3;
          break;
        case _util.ImageKind.RGBA_32BPP:
          colorType = 6;
          bitDepth = 8;
          lineSize = width * 4;
          break;
        default:
          throw new Error('invalid format');
      }
      var literals = new Uint8Array((1 + lineSize) * height);
      var offsetLiterals = 0,
          offsetBytes = 0;
      var y, i;
      for (y = 0; y < height; ++y) {
        literals[offsetLiterals++] = 0;
        literals.set(bytes.subarray(offsetBytes, offsetBytes + lineSize), offsetLiterals);
        offsetBytes += lineSize;
        offsetLiterals += lineSize;
      }
      if (kind === _util.ImageKind.GRAYSCALE_1BPP) {
        offsetLiterals = 0;
        for (y = 0; y < height; y++) {
          offsetLiterals++;
          for (i = 0; i < lineSize; i++) {
            literals[offsetLiterals++] ^= 0xFF;
          }
        }
      }
      var ihdr = new Uint8Array([width >> 24 & 0xff, width >> 16 & 0xff, width >> 8 & 0xff, width & 0xff, height >> 24 & 0xff, height >> 16 & 0xff, height >> 8 & 0xff, height & 0xff, bitDepth, colorType, 0x00, 0x00, 0x00]);
      var idat = deflateSync(literals);
      var pngLength = PNG_HEADER.length + CHUNK_WRAPPER_SIZE * 3 + ihdr.length + idat.length;
      var data = new Uint8Array(pngLength);
      var offset = 0;
      data.set(PNG_HEADER, offset);
      offset += PNG_HEADER.length;
      writePngChunk('IHDR', ihdr, data, offset);
      offset += CHUNK_WRAPPER_SIZE + ihdr.length;
      writePngChunk('IDATA', idat, data, offset);
      offset += CHUNK_WRAPPER_SIZE + idat.length;
      writePngChunk('IEND', new Uint8Array(0), data, offset);
      return (0, _util.createObjectURL)(data, 'image/png', forceDataSchema);
    }
    return function convertImgDataToPng(imgData, forceDataSchema) {
      var kind = imgData.kind === undefined ? _util.ImageKind.GRAYSCALE_1BPP : imgData.kind;
      return encode(imgData, kind, forceDataSchema);
    };
  }();
  var SVGExtraState = function SVGExtraStateClosure() {
    function SVGExtraState() {
      this.fontSizeScale = 1;
      this.fontWeight = SVG_DEFAULTS.fontWeight;
      this.fontSize = 0;
      this.textMatrix = _util.IDENTITY_MATRIX;
      this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
      this.leading = 0;
      this.x = 0;
      this.y = 0;
      this.lineX = 0;
      this.lineY = 0;
      this.charSpacing = 0;
      this.wordSpacing = 0;
      this.textHScale = 1;
      this.textRise = 0;
      this.fillColor = SVG_DEFAULTS.fillColor;
      this.strokeColor = '#000000';
      this.fillAlpha = 1;
      this.strokeAlpha = 1;
      this.lineWidth = 1;
      this.lineJoin = '';
      this.lineCap = '';
      this.miterLimit = 0;
      this.dashArray = [];
      this.dashPhase = 0;
      this.dependencies = [];
      this.activeClipUrl = null;
      this.clipGroup = null;
      this.maskId = '';
    }
    SVGExtraState.prototype = {
      clone: function SVGExtraState_clone() {
        return Object.create(this);
      },
      setCurrentPoint: function SVGExtraState_setCurrentPoint(x, y) {
        this.x = x;
        this.y = y;
      }
    };
    return SVGExtraState;
  }();
  exports.SVGGraphics = SVGGraphics = function SVGGraphicsClosure() {
    function opListToTree(opList) {
      var opTree = [];
      var tmp = [];
      var opListLen = opList.length;
      for (var x = 0; x < opListLen; x++) {
        if (opList[x].fn === 'save') {
          opTree.push({
            'fnId': 92,
            'fn': 'group',
            'items': []
          });
          tmp.push(opTree);
          opTree = opTree[opTree.length - 1].items;
          continue;
        }
        if (opList[x].fn === 'restore') {
          opTree = tmp.pop();
        } else {
          opTree.push(opList[x]);
        }
      }
      return opTree;
    }
    function pf(value) {
      if (value === (value | 0)) {
        return value.toString();
      }
      var s = value.toFixed(10);
      var i = s.length - 1;
      if (s[i] !== '0') {
        return s;
      }
      do {
        i--;
      } while (s[i] === '0');
      return s.substr(0, s[i] === '.' ? i : i + 1);
    }
    function pm(m) {
      if (m[4] === 0 && m[5] === 0) {
        if (m[1] === 0 && m[2] === 0) {
          if (m[0] === 1 && m[3] === 1) {
            return '';
          }
          return 'scale(' + pf(m[0]) + ' ' + pf(m[3]) + ')';
        }
        if (m[0] === m[3] && m[1] === -m[2]) {
          var a = Math.acos(m[0]) * 180 / Math.PI;
          return 'rotate(' + pf(a) + ')';
        }
      } else {
        if (m[0] === 1 && m[1] === 0 && m[2] === 0 && m[3] === 1) {
          return 'translate(' + pf(m[4]) + ' ' + pf(m[5]) + ')';
        }
      }
      return 'matrix(' + pf(m[0]) + ' ' + pf(m[1]) + ' ' + pf(m[2]) + ' ' + pf(m[3]) + ' ' + pf(m[4]) + ' ' + pf(m[5]) + ')';
    }
    function SVGGraphics(commonObjs, objs, forceDataSchema) {
      this.current = new SVGExtraState();
      this.transformMatrix = _util.IDENTITY_MATRIX;
      this.transformStack = [];
      this.extraStack = [];
      this.commonObjs = commonObjs;
      this.objs = objs;
      this.pendingClip = null;
      this.pendingEOFill = false;
      this.embedFonts = false;
      this.embeddedFonts = Object.create(null);
      this.cssStyle = null;
      this.forceDataSchema = !!forceDataSchema;
    }
    var NS = 'http://www.w3.org/2000/svg';
    var XML_NS = 'http://www.w3.org/XML/1998/namespace';
    var XLINK_NS = 'http://www.w3.org/1999/xlink';
    var LINE_CAP_STYLES = ['butt', 'round', 'square'];
    var LINE_JOIN_STYLES = ['miter', 'round', 'bevel'];
    var clipCount = 0;
    var maskCount = 0;
    SVGGraphics.prototype = {
      save: function SVGGraphics_save() {
        this.transformStack.push(this.transformMatrix);
        var old = this.current;
        this.extraStack.push(old);
        this.current = old.clone();
      },
      restore: function SVGGraphics_restore() {
        this.transformMatrix = this.transformStack.pop();
        this.current = this.extraStack.pop();
        this.pendingClip = null;
        this.tgrp = null;
      },
      group: function SVGGraphics_group(items) {
        this.save();
        this.executeOpTree(items);
        this.restore();
      },
      loadDependencies: function SVGGraphics_loadDependencies(operatorList) {
        var _this = this;

        var fnArray = operatorList.fnArray;
        var fnArrayLen = fnArray.length;
        var argsArray = operatorList.argsArray;
        for (var i = 0; i < fnArrayLen; i++) {
          if (_util.OPS.dependency === fnArray[i]) {
            var deps = argsArray[i];
            for (var n = 0, nn = deps.length; n < nn; n++) {
              var obj = deps[n];
              var common = obj.substring(0, 2) === 'g_';
              var promise;
              if (common) {
                promise = new Promise(function (resolve) {
                  _this.commonObjs.get(obj, resolve);
                });
              } else {
                promise = new Promise(function (resolve) {
                  _this.objs.get(obj, resolve);
                });
              }
              this.current.dependencies.push(promise);
            }
          }
        }
        return Promise.all(this.current.dependencies);
      },
      transform: function SVGGraphics_transform(a, b, c, d, e, f) {
        var transformMatrix = [a, b, c, d, e, f];
        this.transformMatrix = _util.Util.transform(this.transformMatrix, transformMatrix);
        this.tgrp = null;
      },
      getSVG: function SVGGraphics_getSVG(operatorList, viewport) {
        var _this2 = this;

        this.viewport = viewport;
        var svgElement = this._initialize(viewport);
        return this.loadDependencies(operatorList).then(function () {
          _this2.transformMatrix = _util.IDENTITY_MATRIX;
          var opTree = _this2.convertOpList(operatorList);
          _this2.executeOpTree(opTree);
          return svgElement;
        });
      },
      convertOpList: function SVGGraphics_convertOpList(operatorList) {
        var argsArray = operatorList.argsArray;
        var fnArray = operatorList.fnArray;
        var fnArrayLen = fnArray.length;
        var REVOPS = [];
        var opList = [];
        for (var op in _util.OPS) {
          REVOPS[_util.OPS[op]] = op;
        }
        for (var x = 0; x < fnArrayLen; x++) {
          var fnId = fnArray[x];
          opList.push({
            'fnId': fnId,
            'fn': REVOPS[fnId],
            'args': argsArray[x]
          });
        }
        return opListToTree(opList);
      },
      executeOpTree: function SVGGraphics_executeOpTree(opTree) {
        var opTreeLen = opTree.length;
        for (var x = 0; x < opTreeLen; x++) {
          var fn = opTree[x].fn;
          var fnId = opTree[x].fnId;
          var args = opTree[x].args;
          switch (fnId | 0) {
            case _util.OPS.beginText:
              this.beginText();
              break;
            case _util.OPS.setLeading:
              this.setLeading(args);
              break;
            case _util.OPS.setLeadingMoveText:
              this.setLeadingMoveText(args[0], args[1]);
              break;
            case _util.OPS.setFont:
              this.setFont(args);
              break;
            case _util.OPS.showText:
              this.showText(args[0]);
              break;
            case _util.OPS.showSpacedText:
              this.showText(args[0]);
              break;
            case _util.OPS.endText:
              this.endText();
              break;
            case _util.OPS.moveText:
              this.moveText(args[0], args[1]);
              break;
            case _util.OPS.setCharSpacing:
              this.setCharSpacing(args[0]);
              break;
            case _util.OPS.setWordSpacing:
              this.setWordSpacing(args[0]);
              break;
            case _util.OPS.setHScale:
              this.setHScale(args[0]);
              break;
            case _util.OPS.setTextMatrix:
              this.setTextMatrix(args[0], args[1], args[2], args[3], args[4], args[5]);
              break;
            case _util.OPS.setLineWidth:
              this.setLineWidth(args[0]);
              break;
            case _util.OPS.setLineJoin:
              this.setLineJoin(args[0]);
              break;
            case _util.OPS.setLineCap:
              this.setLineCap(args[0]);
              break;
            case _util.OPS.setMiterLimit:
              this.setMiterLimit(args[0]);
              break;
            case _util.OPS.setFillRGBColor:
              this.setFillRGBColor(args[0], args[1], args[2]);
              break;
            case _util.OPS.setStrokeRGBColor:
              this.setStrokeRGBColor(args[0], args[1], args[2]);
              break;
            case _util.OPS.setDash:
              this.setDash(args[0], args[1]);
              break;
            case _util.OPS.setGState:
              this.setGState(args[0]);
              break;
            case _util.OPS.fill:
              this.fill();
              break;
            case _util.OPS.eoFill:
              this.eoFill();
              break;
            case _util.OPS.stroke:
              this.stroke();
              break;
            case _util.OPS.fillStroke:
              this.fillStroke();
              break;
            case _util.OPS.eoFillStroke:
              this.eoFillStroke();
              break;
            case _util.OPS.clip:
              this.clip('nonzero');
              break;
            case _util.OPS.eoClip:
              this.clip('evenodd');
              break;
            case _util.OPS.paintSolidColorImageMask:
              this.paintSolidColorImageMask();
              break;
            case _util.OPS.paintJpegXObject:
              this.paintJpegXObject(args[0], args[1], args[2]);
              break;
            case _util.OPS.paintImageXObject:
              this.paintImageXObject(args[0]);
              break;
            case _util.OPS.paintInlineImageXObject:
              this.paintInlineImageXObject(args[0]);
              break;
            case _util.OPS.paintImageMaskXObject:
              this.paintImageMaskXObject(args[0]);
              break;
            case _util.OPS.paintFormXObjectBegin:
              this.paintFormXObjectBegin(args[0], args[1]);
              break;
            case _util.OPS.paintFormXObjectEnd:
              this.paintFormXObjectEnd();
              break;
            case _util.OPS.closePath:
              this.closePath();
              break;
            case _util.OPS.closeStroke:
              this.closeStroke();
              break;
            case _util.OPS.closeFillStroke:
              this.closeFillStroke();
              break;
            case _util.OPS.nextLine:
              this.nextLine();
              break;
            case _util.OPS.transform:
              this.transform(args[0], args[1], args[2], args[3], args[4], args[5]);
              break;
            case _util.OPS.constructPath:
              this.constructPath(args[0], args[1]);
              break;
            case _util.OPS.endPath:
              this.endPath();
              break;
            case 92:
              this.group(opTree[x].items);
              break;
            default:
              (0, _util.warn)('Unimplemented operator ' + fn);
              break;
          }
        }
      },
      setWordSpacing: function SVGGraphics_setWordSpacing(wordSpacing) {
        this.current.wordSpacing = wordSpacing;
      },
      setCharSpacing: function SVGGraphics_setCharSpacing(charSpacing) {
        this.current.charSpacing = charSpacing;
      },
      nextLine: function SVGGraphics_nextLine() {
        this.moveText(0, this.current.leading);
      },
      setTextMatrix: function SVGGraphics_setTextMatrix(a, b, c, d, e, f) {
        var current = this.current;
        this.current.textMatrix = this.current.lineMatrix = [a, b, c, d, e, f];
        this.current.x = this.current.lineX = 0;
        this.current.y = this.current.lineY = 0;
        current.xcoords = [];
        current.tspan = document.createElementNS(NS, 'svg:tspan');
        current.tspan.setAttributeNS(null, 'font-family', current.fontFamily);
        current.tspan.setAttributeNS(null, 'font-size', pf(current.fontSize) + 'px');
        current.tspan.setAttributeNS(null, 'y', pf(-current.y));
        current.txtElement = document.createElementNS(NS, 'svg:text');
        current.txtElement.appendChild(current.tspan);
      },
      beginText: function SVGGraphics_beginText() {
        this.current.x = this.current.lineX = 0;
        this.current.y = this.current.lineY = 0;
        this.current.textMatrix = _util.IDENTITY_MATRIX;
        this.current.lineMatrix = _util.IDENTITY_MATRIX;
        this.current.tspan = document.createElementNS(NS, 'svg:tspan');
        this.current.txtElement = document.createElementNS(NS, 'svg:text');
        this.current.txtgrp = document.createElementNS(NS, 'svg:g');
        this.current.xcoords = [];
      },
      moveText: function SVGGraphics_moveText(x, y) {
        var current = this.current;
        this.current.x = this.current.lineX += x;
        this.current.y = this.current.lineY += y;
        current.xcoords = [];
        current.tspan = document.createElementNS(NS, 'svg:tspan');
        current.tspan.setAttributeNS(null, 'font-family', current.fontFamily);
        current.tspan.setAttributeNS(null, 'font-size', pf(current.fontSize) + 'px');
        current.tspan.setAttributeNS(null, 'y', pf(-current.y));
      },
      showText: function SVGGraphics_showText(glyphs) {
        var current = this.current;
        var font = current.font;
        var fontSize = current.fontSize;
        if (fontSize === 0) {
          return;
        }
        var charSpacing = current.charSpacing;
        var wordSpacing = current.wordSpacing;
        var fontDirection = current.fontDirection;
        var textHScale = current.textHScale * fontDirection;
        var glyphsLength = glyphs.length;
        var vertical = font.vertical;
        var widthAdvanceScale = fontSize * current.fontMatrix[0];
        var x = 0,
            i;
        for (i = 0; i < glyphsLength; ++i) {
          var glyph = glyphs[i];
          if (glyph === null) {
            x += fontDirection * wordSpacing;
            continue;
          } else if ((0, _util.isNum)(glyph)) {
            x += -glyph * fontSize * 0.001;
            continue;
          }
          current.xcoords.push(current.x + x * textHScale);
          var width = glyph.width;
          var character = glyph.fontChar;
          var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
          var charWidth = width * widthAdvanceScale + spacing * fontDirection;
          x += charWidth;
          current.tspan.textContent += character;
        }
        if (vertical) {
          current.y -= x * textHScale;
        } else {
          current.x += x * textHScale;
        }
        current.tspan.setAttributeNS(null, 'x', current.xcoords.map(pf).join(' '));
        current.tspan.setAttributeNS(null, 'y', pf(-current.y));
        current.tspan.setAttributeNS(null, 'font-family', current.fontFamily);
        current.tspan.setAttributeNS(null, 'font-size', pf(current.fontSize) + 'px');
        if (current.fontStyle !== SVG_DEFAULTS.fontStyle) {
          current.tspan.setAttributeNS(null, 'font-style', current.fontStyle);
        }
        if (current.fontWeight !== SVG_DEFAULTS.fontWeight) {
          current.tspan.setAttributeNS(null, 'font-weight', current.fontWeight);
        }
        if (current.fillColor !== SVG_DEFAULTS.fillColor) {
          current.tspan.setAttributeNS(null, 'fill', current.fillColor);
        }
        current.txtElement.setAttributeNS(null, 'transform', pm(current.textMatrix) + ' scale(1, -1)');
        current.txtElement.setAttributeNS(XML_NS, 'xml:space', 'preserve');
        current.txtElement.appendChild(current.tspan);
        current.txtgrp.appendChild(current.txtElement);
        this._ensureTransformGroup().appendChild(current.txtElement);
      },
      setLeadingMoveText: function SVGGraphics_setLeadingMoveText(x, y) {
        this.setLeading(-y);
        this.moveText(x, y);
      },
      addFontStyle: function SVGGraphics_addFontStyle(fontObj) {
        if (!this.cssStyle) {
          this.cssStyle = document.createElementNS(NS, 'svg:style');
          this.cssStyle.setAttributeNS(null, 'type', 'text/css');
          this.defs.appendChild(this.cssStyle);
        }
        var url = (0, _util.createObjectURL)(fontObj.data, fontObj.mimetype, this.forceDataSchema);
        this.cssStyle.textContent += '@font-face { font-family: "' + fontObj.loadedName + '";' + ' src: url(' + url + '); }\n';
      },
      setFont: function SVGGraphics_setFont(details) {
        var current = this.current;
        var fontObj = this.commonObjs.get(details[0]);
        var size = details[1];
        this.current.font = fontObj;
        if (this.embedFonts && fontObj.data && !this.embeddedFonts[fontObj.loadedName]) {
          this.addFontStyle(fontObj);
          this.embeddedFonts[fontObj.loadedName] = fontObj;
        }
        current.fontMatrix = fontObj.fontMatrix ? fontObj.fontMatrix : _util.FONT_IDENTITY_MATRIX;
        var bold = fontObj.black ? fontObj.bold ? 'bolder' : 'bold' : fontObj.bold ? 'bold' : 'normal';
        var italic = fontObj.italic ? 'italic' : 'normal';
        if (size < 0) {
          size = -size;
          current.fontDirection = -1;
        } else {
          current.fontDirection = 1;
        }
        current.fontSize = size;
        current.fontFamily = fontObj.loadedName;
        current.fontWeight = bold;
        current.fontStyle = italic;
        current.tspan = document.createElementNS(NS, 'svg:tspan');
        current.tspan.setAttributeNS(null, 'y', pf(-current.y));
        current.xcoords = [];
      },
      endText: function SVGGraphics_endText() {},
      setLineWidth: function SVGGraphics_setLineWidth(width) {
        this.current.lineWidth = width;
      },
      setLineCap: function SVGGraphics_setLineCap(style) {
        this.current.lineCap = LINE_CAP_STYLES[style];
      },
      setLineJoin: function SVGGraphics_setLineJoin(style) {
        this.current.lineJoin = LINE_JOIN_STYLES[style];
      },
      setMiterLimit: function SVGGraphics_setMiterLimit(limit) {
        this.current.miterLimit = limit;
      },
      setStrokeAlpha: function SVGGraphics_setStrokeAlpha(strokeAlpha) {
        this.current.strokeAlpha = strokeAlpha;
      },
      setStrokeRGBColor: function SVGGraphics_setStrokeRGBColor(r, g, b) {
        var color = _util.Util.makeCssRgb(r, g, b);
        this.current.strokeColor = color;
      },
      setFillAlpha: function SVGGraphics_setFillAlpha(fillAlpha) {
        this.current.fillAlpha = fillAlpha;
      },
      setFillRGBColor: function SVGGraphics_setFillRGBColor(r, g, b) {
        var color = _util.Util.makeCssRgb(r, g, b);
        this.current.fillColor = color;
        this.current.tspan = document.createElementNS(NS, 'svg:tspan');
        this.current.xcoords = [];
      },
      setDash: function SVGGraphics_setDash(dashArray, dashPhase) {
        this.current.dashArray = dashArray;
        this.current.dashPhase = dashPhase;
      },
      constructPath: function SVGGraphics_constructPath(ops, args) {
        var current = this.current;
        var x = current.x,
            y = current.y;
        current.path = document.createElementNS(NS, 'svg:path');
        var d = [];
        var opLength = ops.length;
        for (var i = 0, j = 0; i < opLength; i++) {
          switch (ops[i] | 0) {
            case _util.OPS.rectangle:
              x = args[j++];
              y = args[j++];
              var width = args[j++];
              var height = args[j++];
              var xw = x + width;
              var yh = y + height;
              d.push('M', pf(x), pf(y), 'L', pf(xw), pf(y), 'L', pf(xw), pf(yh), 'L', pf(x), pf(yh), 'Z');
              break;
            case _util.OPS.moveTo:
              x = args[j++];
              y = args[j++];
              d.push('M', pf(x), pf(y));
              break;
            case _util.OPS.lineTo:
              x = args[j++];
              y = args[j++];
              d.push('L', pf(x), pf(y));
              break;
            case _util.OPS.curveTo:
              x = args[j + 4];
              y = args[j + 5];
              d.push('C', pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]), pf(x), pf(y));
              j += 6;
              break;
            case _util.OPS.curveTo2:
              x = args[j + 2];
              y = args[j + 3];
              d.push('C', pf(x), pf(y), pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]));
              j += 4;
              break;
            case _util.OPS.curveTo3:
              x = args[j + 2];
              y = args[j + 3];
              d.push('C', pf(args[j]), pf(args[j + 1]), pf(x), pf(y), pf(x), pf(y));
              j += 4;
              break;
            case _util.OPS.closePath:
              d.push('Z');
              break;
          }
        }
        current.path.setAttributeNS(null, 'd', d.join(' '));
        current.path.setAttributeNS(null, 'fill', 'none');
        this._ensureTransformGroup().appendChild(current.path);
        current.element = current.path;
        current.setCurrentPoint(x, y);
      },
      endPath: function SVGGraphics_endPath() {
        if (!this.pendingClip) {
          return;
        }
        var current = this.current;
        var clipId = 'clippath' + clipCount;
        clipCount++;
        var clipPath = document.createElementNS(NS, 'svg:clipPath');
        clipPath.setAttributeNS(null, 'id', clipId);
        clipPath.setAttributeNS(null, 'transform', pm(this.transformMatrix));
        var clipElement = current.element.cloneNode();
        if (this.pendingClip === 'evenodd') {
          clipElement.setAttributeNS(null, 'clip-rule', 'evenodd');
        } else {
          clipElement.setAttributeNS(null, 'clip-rule', 'nonzero');
        }
        this.pendingClip = null;
        clipPath.appendChild(clipElement);
        this.defs.appendChild(clipPath);
        if (current.activeClipUrl) {
          current.clipGroup = null;
          this.extraStack.forEach(function (prev) {
            prev.clipGroup = null;
          });
        }
        current.activeClipUrl = 'url(#' + clipId + ')';
        this.tgrp = null;
      },
      clip: function SVGGraphics_clip(type) {
        this.pendingClip = type;
      },
      closePath: function SVGGraphics_closePath() {
        var current = this.current;
        var d = current.path.getAttributeNS(null, 'd');
        d += 'Z';
        current.path.setAttributeNS(null, 'd', d);
      },
      setLeading: function SVGGraphics_setLeading(leading) {
        this.current.leading = -leading;
      },
      setTextRise: function SVGGraphics_setTextRise(textRise) {
        this.current.textRise = textRise;
      },
      setHScale: function SVGGraphics_setHScale(scale) {
        this.current.textHScale = scale / 100;
      },
      setGState: function SVGGraphics_setGState(states) {
        for (var i = 0, ii = states.length; i < ii; i++) {
          var state = states[i];
          var key = state[0];
          var value = state[1];
          switch (key) {
            case 'LW':
              this.setLineWidth(value);
              break;
            case 'LC':
              this.setLineCap(value);
              break;
            case 'LJ':
              this.setLineJoin(value);
              break;
            case 'ML':
              this.setMiterLimit(value);
              break;
            case 'D':
              this.setDash(value[0], value[1]);
              break;
            case 'Font':
              this.setFont(value);
              break;
            case 'CA':
              this.setStrokeAlpha(value);
              break;
            case 'ca':
              this.setFillAlpha(value);
              break;
            default:
              (0, _util.warn)('Unimplemented graphic state ' + key);
              break;
          }
        }
      },
      fill: function SVGGraphics_fill() {
        var current = this.current;
        current.element.setAttributeNS(null, 'fill', current.fillColor);
        current.element.setAttributeNS(null, 'fill-opacity', current.fillAlpha);
      },
      stroke: function SVGGraphics_stroke() {
        var current = this.current;
        current.element.setAttributeNS(null, 'stroke', current.strokeColor);
        current.element.setAttributeNS(null, 'stroke-opacity', current.strokeAlpha);
        current.element.setAttributeNS(null, 'stroke-miterlimit', pf(current.miterLimit));
        current.element.setAttributeNS(null, 'stroke-linecap', current.lineCap);
        current.element.setAttributeNS(null, 'stroke-linejoin', current.lineJoin);
        current.element.setAttributeNS(null, 'stroke-width', pf(current.lineWidth) + 'px');
        current.element.setAttributeNS(null, 'stroke-dasharray', current.dashArray.map(pf).join(' '));
        current.element.setAttributeNS(null, 'stroke-dashoffset', pf(current.dashPhase) + 'px');
        current.element.setAttributeNS(null, 'fill', 'none');
      },
      eoFill: function SVGGraphics_eoFill() {
        this.current.element.setAttributeNS(null, 'fill-rule', 'evenodd');
        this.fill();
      },
      fillStroke: function SVGGraphics_fillStroke() {
        this.stroke();
        this.fill();
      },
      eoFillStroke: function SVGGraphics_eoFillStroke() {
        this.current.element.setAttributeNS(null, 'fill-rule', 'evenodd');
        this.fillStroke();
      },
      closeStroke: function SVGGraphics_closeStroke() {
        this.closePath();
        this.stroke();
      },
      closeFillStroke: function SVGGraphics_closeFillStroke() {
        this.closePath();
        this.fillStroke();
      },
      paintSolidColorImageMask: function SVGGraphics_paintSolidColorImageMask() {
        var current = this.current;
        var rect = document.createElementNS(NS, 'svg:rect');
        rect.setAttributeNS(null, 'x', '0');
        rect.setAttributeNS(null, 'y', '0');
        rect.setAttributeNS(null, 'width', '1px');
        rect.setAttributeNS(null, 'height', '1px');
        rect.setAttributeNS(null, 'fill', current.fillColor);
        this._ensureTransformGroup().appendChild(rect);
      },
      paintJpegXObject: function SVGGraphics_paintJpegXObject(objId, w, h) {
        var imgObj = this.objs.get(objId);
        var imgEl = document.createElementNS(NS, 'svg:image');
        imgEl.setAttributeNS(XLINK_NS, 'xlink:href', imgObj.src);
        imgEl.setAttributeNS(null, 'width', pf(w));
        imgEl.setAttributeNS(null, 'height', pf(h));
        imgEl.setAttributeNS(null, 'x', '0');
        imgEl.setAttributeNS(null, 'y', pf(-h));
        imgEl.setAttributeNS(null, 'transform', 'scale(' + pf(1 / w) + ' ' + pf(-1 / h) + ')');
        this._ensureTransformGroup().appendChild(imgEl);
      },
      paintImageXObject: function SVGGraphics_paintImageXObject(objId) {
        var imgData = this.objs.get(objId);
        if (!imgData) {
          (0, _util.warn)('Dependent image isn\'t ready yet');
          return;
        }
        this.paintInlineImageXObject(imgData);
      },
      paintInlineImageXObject: function SVGGraphics_paintInlineImageXObject(imgData, mask) {
        var width = imgData.width;
        var height = imgData.height;
        var imgSrc = convertImgDataToPng(imgData, this.forceDataSchema);
        var cliprect = document.createElementNS(NS, 'svg:rect');
        cliprect.setAttributeNS(null, 'x', '0');
        cliprect.setAttributeNS(null, 'y', '0');
        cliprect.setAttributeNS(null, 'width', pf(width));
        cliprect.setAttributeNS(null, 'height', pf(height));
        this.current.element = cliprect;
        this.clip('nonzero');
        var imgEl = document.createElementNS(NS, 'svg:image');
        imgEl.setAttributeNS(XLINK_NS, 'xlink:href', imgSrc);
        imgEl.setAttributeNS(null, 'x', '0');
        imgEl.setAttributeNS(null, 'y', pf(-height));
        imgEl.setAttributeNS(null, 'width', pf(width) + 'px');
        imgEl.setAttributeNS(null, 'height', pf(height) + 'px');
        imgEl.setAttributeNS(null, 'transform', 'scale(' + pf(1 / width) + ' ' + pf(-1 / height) + ')');
        if (mask) {
          mask.appendChild(imgEl);
        } else {
          this._ensureTransformGroup().appendChild(imgEl);
        }
      },
      paintImageMaskXObject: function SVGGraphics_paintImageMaskXObject(imgData) {
        var current = this.current;
        var width = imgData.width;
        var height = imgData.height;
        var fillColor = current.fillColor;
        current.maskId = 'mask' + maskCount++;
        var mask = document.createElementNS(NS, 'svg:mask');
        mask.setAttributeNS(null, 'id', current.maskId);
        var rect = document.createElementNS(NS, 'svg:rect');
        rect.setAttributeNS(null, 'x', '0');
        rect.setAttributeNS(null, 'y', '0');
        rect.setAttributeNS(null, 'width', pf(width));
        rect.setAttributeNS(null, 'height', pf(height));
        rect.setAttributeNS(null, 'fill', fillColor);
        rect.setAttributeNS(null, 'mask', 'url(#' + current.maskId + ')');
        this.defs.appendChild(mask);
        this._ensureTransformGroup().appendChild(rect);
        this.paintInlineImageXObject(imgData, mask);
      },
      paintFormXObjectBegin: function SVGGraphics_paintFormXObjectBegin(matrix, bbox) {
        if ((0, _util.isArray)(matrix) && matrix.length === 6) {
          this.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
        }
        if ((0, _util.isArray)(bbox) && bbox.length === 4) {
          var width = bbox[2] - bbox[0];
          var height = bbox[3] - bbox[1];
          var cliprect = document.createElementNS(NS, 'svg:rect');
          cliprect.setAttributeNS(null, 'x', bbox[0]);
          cliprect.setAttributeNS(null, 'y', bbox[1]);
          cliprect.setAttributeNS(null, 'width', pf(width));
          cliprect.setAttributeNS(null, 'height', pf(height));
          this.current.element = cliprect;
          this.clip('nonzero');
          this.endPath();
        }
      },
      paintFormXObjectEnd: function SVGGraphics_paintFormXObjectEnd() {},
      _initialize: function SVGGraphics_initialize(viewport) {
        var svg = document.createElementNS(NS, 'svg:svg');
        svg.setAttributeNS(null, 'version', '1.1');
        svg.setAttributeNS(null, 'width', viewport.width + 'px');
        svg.setAttributeNS(null, 'height', viewport.height + 'px');
        svg.setAttributeNS(null, 'preserveAspectRatio', 'none');
        svg.setAttributeNS(null, 'viewBox', '0 0 ' + viewport.width + ' ' + viewport.height);
        var definitions = document.createElementNS(NS, 'svg:defs');
        svg.appendChild(definitions);
        this.defs = definitions;
        var rootGroup = document.createElementNS(NS, 'svg:g');
        rootGroup.setAttributeNS(null, 'transform', pm(viewport.transform));
        svg.appendChild(rootGroup);
        this.svg = rootGroup;
        return svg;
      },
      _ensureClipGroup: function SVGGraphics_ensureClipGroup() {
        if (!this.current.clipGroup) {
          var clipGroup = document.createElementNS(NS, 'svg:g');
          clipGroup.setAttributeNS(null, 'clip-path', this.current.activeClipUrl);
          this.svg.appendChild(clipGroup);
          this.current.clipGroup = clipGroup;
        }
        return this.current.clipGroup;
      },
      _ensureTransformGroup: function SVGGraphics_ensureTransformGroup() {
        if (!this.tgrp) {
          this.tgrp = document.createElementNS(NS, 'svg:g');
          this.tgrp.setAttributeNS(null, 'transform', pm(this.transformMatrix));
          if (this.current.activeClipUrl) {
            this._ensureClipGroup().appendChild(this.tgrp);
          } else {
            this.svg.appendChild(this.tgrp);
          }
        }
        return this.tgrp;
      }
    };
    return SVGGraphics;
  }();
}
exports.SVGGraphics = SVGGraphics;

/***/ }),
/* 5 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderTextLayer = undefined;

var _util = __w_pdfjs_require__(0);

var _dom_utils = __w_pdfjs_require__(1);

var renderTextLayer = function renderTextLayerClosure() {
  var MAX_TEXT_DIVS_TO_RENDER = 100000;
  var NonWhitespaceRegexp = /\S/;
  function isAllWhitespace(str) {
    return !NonWhitespaceRegexp.test(str);
  }
  var styleBuf = ['left: ', 0, 'px; top: ', 0, 'px; font-size: ', 0, 'px; font-family: ', '', ';'];
  function appendText(task, geom, styles) {
    var textDiv = document.createElement('div');
    var textDivProperties = {
      style: null,
      angle: 0,
      canvasWidth: 0,
      isWhitespace: false,
      originalTransform: null,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      scale: 1
    };
    task._textDivs.push(textDiv);
    if (isAllWhitespace(geom.str)) {
      textDivProperties.isWhitespace = true;
      task._textDivProperties.set(textDiv, textDivProperties);
      return;
    }
    var tx = _util.Util.transform(task._viewport.transform, geom.transform);
    var angle = Math.atan2(tx[1], tx[0]);
    var style = styles[geom.fontName];
    if (style.vertical) {
      angle += Math.PI / 2;
    }
    var fontHeight = Math.sqrt(tx[2] * tx[2] + tx[3] * tx[3]);
    var fontAscent = fontHeight;
    if (style.ascent) {
      fontAscent = style.ascent * fontAscent;
    } else if (style.descent) {
      fontAscent = (1 + style.descent) * fontAscent;
    }
    var left;
    var top;
    if (angle === 0) {
      left = tx[4];
      top = tx[5] - fontAscent;
    } else {
      left = tx[4] + fontAscent * Math.sin(angle);
      top = tx[5] - fontAscent * Math.cos(angle);
    }
    styleBuf[1] = left;
    styleBuf[3] = top;
    styleBuf[5] = fontHeight;
    styleBuf[7] = style.fontFamily;
    textDivProperties.style = styleBuf.join('');
    textDiv.setAttribute('style', textDivProperties.style);
    textDiv.textContent = geom.str;
    if ((0, _dom_utils.getDefaultSetting)('pdfBug')) {
      textDiv.dataset.fontName = geom.fontName;
    }
    if (angle !== 0) {
      textDivProperties.angle = angle * (180 / Math.PI);
    }
    if (geom.str.length > 1) {
      if (style.vertical) {
        textDivProperties.canvasWidth = geom.height * task._viewport.scale;
      } else {
        textDivProperties.canvasWidth = geom.width * task._viewport.scale;
      }
    }
    task._textDivProperties.set(textDiv, textDivProperties);
    if (task._textContentStream) {
      task._layoutText(textDiv);
    }
    if (task._enhanceTextSelection) {
      var angleCos = 1,
          angleSin = 0;
      if (angle !== 0) {
        angleCos = Math.cos(angle);
        angleSin = Math.sin(angle);
      }
      var divWidth = (style.vertical ? geom.height : geom.width) * task._viewport.scale;
      var divHeight = fontHeight;
      var m, b;
      if (angle !== 0) {
        m = [angleCos, angleSin, -angleSin, angleCos, left, top];
        b = _util.Util.getAxialAlignedBoundingBox([0, 0, divWidth, divHeight], m);
      } else {
        b = [left, top, left + divWidth, top + divHeight];
      }
      task._bounds.push({
        left: b[0],
        top: b[1],
        right: b[2],
        bottom: b[3],
        div: textDiv,
        size: [divWidth, divHeight],
        m: m
      });
    }
  }
  function render(task) {
    if (task._canceled) {
      return;
    }
    var textDivs = task._textDivs;
    var capability = task._capability;
    var textDivsLength = textDivs.length;
    if (textDivsLength > MAX_TEXT_DIVS_TO_RENDER) {
      task._renderingDone = true;
      capability.resolve();
      return;
    }
    if (!task._textContentStream) {
      for (var i = 0; i < textDivsLength; i++) {
        task._layoutText(textDivs[i]);
      }
    }
    task._renderingDone = true;
    capability.resolve();
  }
  function expand(task) {
    var bounds = task._bounds;
    var viewport = task._viewport;
    var expanded = expandBounds(viewport.width, viewport.height, bounds);
    for (var i = 0; i < expanded.length; i++) {
      var div = bounds[i].div;
      var divProperties = task._textDivProperties.get(div);
      if (divProperties.angle === 0) {
        divProperties.paddingLeft = bounds[i].left - expanded[i].left;
        divProperties.paddingTop = bounds[i].top - expanded[i].top;
        divProperties.paddingRight = expanded[i].right - bounds[i].right;
        divProperties.paddingBottom = expanded[i].bottom - bounds[i].bottom;
        task._textDivProperties.set(div, divProperties);
        continue;
      }
      var e = expanded[i],
          b = bounds[i];
      var m = b.m,
          c = m[0],
          s = m[1];
      var points = [[0, 0], [0, b.size[1]], [b.size[0], 0], b.size];
      var ts = new Float64Array(64);
      points.forEach(function (p, i) {
        var t = _util.Util.applyTransform(p, m);
        ts[i + 0] = c && (e.left - t[0]) / c;
        ts[i + 4] = s && (e.top - t[1]) / s;
        ts[i + 8] = c && (e.right - t[0]) / c;
        ts[i + 12] = s && (e.bottom - t[1]) / s;
        ts[i + 16] = s && (e.left - t[0]) / -s;
        ts[i + 20] = c && (e.top - t[1]) / c;
        ts[i + 24] = s && (e.right - t[0]) / -s;
        ts[i + 28] = c && (e.bottom - t[1]) / c;
        ts[i + 32] = c && (e.left - t[0]) / -c;
        ts[i + 36] = s && (e.top - t[1]) / -s;
        ts[i + 40] = c && (e.right - t[0]) / -c;
        ts[i + 44] = s && (e.bottom - t[1]) / -s;
        ts[i + 48] = s && (e.left - t[0]) / s;
        ts[i + 52] = c && (e.top - t[1]) / -c;
        ts[i + 56] = s && (e.right - t[0]) / s;
        ts[i + 60] = c && (e.bottom - t[1]) / -c;
      });
      var findPositiveMin = function findPositiveMin(ts, offset, count) {
        var result = 0;
        for (var i = 0; i < count; i++) {
          var t = ts[offset++];
          if (t > 0) {
            result = result ? Math.min(t, result) : t;
          }
        }
        return result;
      };
      var boxScale = 1 + Math.min(Math.abs(c), Math.abs(s));
      divProperties.paddingLeft = findPositiveMin(ts, 32, 16) / boxScale;
      divProperties.paddingTop = findPositiveMin(ts, 48, 16) / boxScale;
      divProperties.paddingRight = findPositiveMin(ts, 0, 16) / boxScale;
      divProperties.paddingBottom = findPositiveMin(ts, 16, 16) / boxScale;
      task._textDivProperties.set(div, divProperties);
    }
  }
  function expandBounds(width, height, boxes) {
    var bounds = boxes.map(function (box, i) {
      return {
        x1: box.left,
        y1: box.top,
        x2: box.right,
        y2: box.bottom,
        index: i,
        x1New: undefined,
        x2New: undefined
      };
    });
    expandBoundsLTR(width, bounds);
    var expanded = new Array(boxes.length);
    bounds.forEach(function (b) {
      var i = b.index;
      expanded[i] = {
        left: b.x1New,
        top: 0,
        right: b.x2New,
        bottom: 0
      };
    });
    boxes.map(function (box, i) {
      var e = expanded[i],
          b = bounds[i];
      b.x1 = box.top;
      b.y1 = width - e.right;
      b.x2 = box.bottom;
      b.y2 = width - e.left;
      b.index = i;
      b.x1New = undefined;
      b.x2New = undefined;
    });
    expandBoundsLTR(height, bounds);
    bounds.forEach(function (b) {
      var i = b.index;
      expanded[i].top = b.x1New;
      expanded[i].bottom = b.x2New;
    });
    return expanded;
  }
  function expandBoundsLTR(width, bounds) {
    bounds.sort(function (a, b) {
      return a.x1 - b.x1 || a.index - b.index;
    });
    var fakeBoundary = {
      x1: -Infinity,
      y1: -Infinity,
      x2: 0,
      y2: Infinity,
      index: -1,
      x1New: 0,
      x2New: 0
    };
    var horizon = [{
      start: -Infinity,
      end: Infinity,
      boundary: fakeBoundary
    }];
    bounds.forEach(function (boundary) {
      var i = 0;
      while (i < horizon.length && horizon[i].end <= boundary.y1) {
        i++;
      }
      var j = horizon.length - 1;
      while (j >= 0 && horizon[j].start >= boundary.y2) {
        j--;
      }
      var horizonPart, affectedBoundary;
      var q,
          k,
          maxXNew = -Infinity;
      for (q = i; q <= j; q++) {
        horizonPart = horizon[q];
        affectedBoundary = horizonPart.boundary;
        var xNew;
        if (affectedBoundary.x2 > boundary.x1) {
          xNew = affectedBoundary.index > boundary.index ? affectedBoundary.x1New : boundary.x1;
        } else if (affectedBoundary.x2New === undefined) {
          xNew = (affectedBoundary.x2 + boundary.x1) / 2;
        } else {
          xNew = affectedBoundary.x2New;
        }
        if (xNew > maxXNew) {
          maxXNew = xNew;
        }
      }
      boundary.x1New = maxXNew;
      for (q = i; q <= j; q++) {
        horizonPart = horizon[q];
        affectedBoundary = horizonPart.boundary;
        if (affectedBoundary.x2New === undefined) {
          if (affectedBoundary.x2 > boundary.x1) {
            if (affectedBoundary.index > boundary.index) {
              affectedBoundary.x2New = affectedBoundary.x2;
            }
          } else {
            affectedBoundary.x2New = maxXNew;
          }
        } else if (affectedBoundary.x2New > maxXNew) {
          affectedBoundary.x2New = Math.max(maxXNew, affectedBoundary.x2);
        }
      }
      var changedHorizon = [],
          lastBoundary = null;
      for (q = i; q <= j; q++) {
        horizonPart = horizon[q];
        affectedBoundary = horizonPart.boundary;
        var useBoundary = affectedBoundary.x2 > boundary.x2 ? affectedBoundary : boundary;
        if (lastBoundary === useBoundary) {
          changedHorizon[changedHorizon.length - 1].end = horizonPart.end;
        } else {
          changedHorizon.push({
            start: horizonPart.start,
            end: horizonPart.end,
            boundary: useBoundary
          });
          lastBoundary = useBoundary;
        }
      }
      if (horizon[i].start < boundary.y1) {
        changedHorizon[0].start = boundary.y1;
        changedHorizon.unshift({
          start: horizon[i].start,
          end: boundary.y1,
          boundary: horizon[i].boundary
        });
      }
      if (boundary.y2 < horizon[j].end) {
        changedHorizon[changedHorizon.length - 1].end = boundary.y2;
        changedHorizon.push({
          start: boundary.y2,
          end: horizon[j].end,
          boundary: horizon[j].boundary
        });
      }
      for (q = i; q <= j; q++) {
        horizonPart = horizon[q];
        affectedBoundary = horizonPart.boundary;
        if (affectedBoundary.x2New !== undefined) {
          continue;
        }
        var used = false;
        for (k = i - 1; !used && k >= 0 && horizon[k].start >= affectedBoundary.y1; k--) {
          used = horizon[k].boundary === affectedBoundary;
        }
        for (k = j + 1; !used && k < horizon.length && horizon[k].end <= affectedBoundary.y2; k++) {
          used = horizon[k].boundary === affectedBoundary;
        }
        for (k = 0; !used && k < changedHorizon.length; k++) {
          used = changedHorizon[k].boundary === affectedBoundary;
        }
        if (!used) {
          affectedBoundary.x2New = maxXNew;
        }
      }
      Array.prototype.splice.apply(horizon, [i, j - i + 1].concat(changedHorizon));
    });
    horizon.forEach(function (horizonPart) {
      var affectedBoundary = horizonPart.boundary;
      if (affectedBoundary.x2New === undefined) {
        affectedBoundary.x2New = Math.max(width, affectedBoundary.x2);
      }
    });
  }
  function TextLayerRenderTask(_ref) {
    var textContent = _ref.textContent,
        textContentStream = _ref.textContentStream,
        container = _ref.container,
        viewport = _ref.viewport,
        textDivs = _ref.textDivs,
        textContentItemsStr = _ref.textContentItemsStr,
        enhanceTextSelection = _ref.enhanceTextSelection;

    this._textContent = textContent;
    this._textContentStream = textContentStream;
    this._container = container;
    this._viewport = viewport;
    this._textDivs = textDivs || [];
    this._textContentItemsStr = textContentItemsStr || [];
    this._enhanceTextSelection = !!enhanceTextSelection;
    this._reader = null;
    this._layoutTextLastFontSize = null;
    this._layoutTextLastFontFamily = null;
    this._layoutTextCtx = null;
    this._textDivProperties = new WeakMap();
    this._renderingDone = false;
    this._canceled = false;
    this._capability = (0, _util.createPromiseCapability)();
    this._renderTimer = null;
    this._bounds = [];
  }
  TextLayerRenderTask.prototype = {
    get promise() {
      return this._capability.promise;
    },
    cancel: function TextLayer_cancel() {
      if (this._reader) {
        this._reader.cancel(new _util.AbortException('text layer task cancelled'));
        this._reader = null;
      }
      this._canceled = true;
      if (this._renderTimer !== null) {
        clearTimeout(this._renderTimer);
        this._renderTimer = null;
      }
      this._capability.reject('canceled');
    },
    _processItems: function _processItems(items, styleCache) {
      for (var i = 0, len = items.length; i < len; i++) {
        this._textContentItemsStr.push(items[i].str);
        appendText(this, items[i], styleCache);
      }
    },
    _layoutText: function _layoutText(textDiv) {
      var textLayerFrag = this._container;
      var textDivProperties = this._textDivProperties.get(textDiv);
      if (textDivProperties.isWhitespace) {
        return;
      }
      var fontSize = textDiv.style.fontSize;
      var fontFamily = textDiv.style.fontFamily;
      if (fontSize !== this._layoutTextLastFontSize || fontFamily !== this._layoutTextLastFontFamily) {
        this._layoutTextCtx.font = fontSize + ' ' + fontFamily;
        this._lastFontSize = fontSize;
        this._lastFontFamily = fontFamily;
      }
      var width = this._layoutTextCtx.measureText(textDiv.textContent).width;
      var transform = '';
      if (textDivProperties.canvasWidth !== 0 && width > 0) {
        textDivProperties.scale = textDivProperties.canvasWidth / width;
        transform = 'scaleX(' + textDivProperties.scale + ')';
      }
      if (textDivProperties.angle !== 0) {
        transform = 'rotate(' + textDivProperties.angle + 'deg) ' + transform;
      }
      if (transform !== '') {
        textDivProperties.originalTransform = transform;
        _dom_utils.CustomStyle.setProp('transform', textDiv, transform);
      }
      this._textDivProperties.set(textDiv, textDivProperties);
      textLayerFrag.appendChild(textDiv);
    },

    _render: function TextLayer_render(timeout) {
      var _this = this;

      var capability = (0, _util.createPromiseCapability)();
      var styleCache = Object.create(null);
      var canvas = document.createElement('canvas');
      canvas.mozOpaque = true;
      this._layoutTextCtx = canvas.getContext('2d', { alpha: false });
      if (this._textContent) {
        var textItems = this._textContent.items;
        var textStyles = this._textContent.styles;
        this._processItems(textItems, textStyles);
        capability.resolve();
      } else if (this._textContentStream) {
        var pump = function pump() {
          _this._reader.read().then(function (_ref2) {
            var value = _ref2.value,
                done = _ref2.done;

            if (done) {
              capability.resolve();
              return;
            }
            _util.Util.extendObj(styleCache, value.styles);
            _this._processItems(value.items, styleCache);
            pump();
          }, capability.reject);
        };
        this._reader = this._textContentStream.getReader();
        pump();
      } else {
        throw new Error('Neither "textContent" nor "textContentStream"' + ' parameters specified.');
      }
      capability.promise.then(function () {
        styleCache = null;
        if (!timeout) {
          render(_this);
        } else {
          _this._renderTimer = setTimeout(function () {
            render(_this);
            _this._renderTimer = null;
          }, timeout);
        }
      }, this._capability.reject);
    },
    expandTextDivs: function TextLayer_expandTextDivs(expandDivs) {
      if (!this._enhanceTextSelection || !this._renderingDone) {
        return;
      }
      if (this._bounds !== null) {
        expand(this);
        this._bounds = null;
      }
      for (var i = 0, ii = this._textDivs.length; i < ii; i++) {
        var div = this._textDivs[i];
        var divProperties = this._textDivProperties.get(div);
        if (divProperties.isWhitespace) {
          continue;
        }
        if (expandDivs) {
          var transform = '',
              padding = '';
          if (divProperties.scale !== 1) {
            transform = 'scaleX(' + divProperties.scale + ')';
          }
          if (divProperties.angle !== 0) {
            transform = 'rotate(' + divProperties.angle + 'deg) ' + transform;
          }
          if (divProperties.paddingLeft !== 0) {
            padding += ' padding-left: ' + divProperties.paddingLeft / divProperties.scale + 'px;';
            transform += ' translateX(' + -divProperties.paddingLeft / divProperties.scale + 'px)';
          }
          if (divProperties.paddingTop !== 0) {
            padding += ' padding-top: ' + divProperties.paddingTop + 'px;';
            transform += ' translateY(' + -divProperties.paddingTop + 'px)';
          }
          if (divProperties.paddingRight !== 0) {
            padding += ' padding-right: ' + divProperties.paddingRight / divProperties.scale + 'px;';
          }
          if (divProperties.paddingBottom !== 0) {
            padding += ' padding-bottom: ' + divProperties.paddingBottom + 'px;';
          }
          if (padding !== '') {
            div.setAttribute('style', divProperties.style + padding);
          }
          if (transform !== '') {
            _dom_utils.CustomStyle.setProp('transform', div, transform);
          }
        } else {
          div.style.padding = 0;
          _dom_utils.CustomStyle.setProp('transform', div, divProperties.originalTransform || '');
        }
      }
    }
  };
  function renderTextLayer(renderParameters) {
    var task = new TextLayerRenderTask({
      textContent: renderParameters.textContent,
      textContentStream: renderParameters.textContentStream,
      container: renderParameters.container,
      viewport: renderParameters.viewport,
      textDivs: renderParameters.textDivs,
      textContentItemsStr: renderParameters.textContentItemsStr,
      enhanceTextSelection: renderParameters.enhanceTextSelection
    });
    task._render(renderParameters.timeout);
    return task;
  }
  return renderTextLayer;
}();
exports.renderTextLayer = renderTextLayer;

/***/ }),
/* 6 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function fixMetadata(meta) {
  return meta.replace(/>\\376\\377([^<]+)/g, function (all, codes) {
    var bytes = codes.replace(/\\([0-3])([0-7])([0-7])/g, function (code, d1, d2, d3) {
      return String.fromCharCode(d1 * 64 + d2 * 8 + d3 * 1);
    });
    var chars = '';
    for (var i = 0; i < bytes.length; i += 2) {
      var code = bytes.charCodeAt(i) * 256 + bytes.charCodeAt(i + 1);
      chars += code >= 32 && code < 127 && code !== 60 && code !== 62 && code !== 38 ? String.fromCharCode(code) : '&#x' + (0x10000 + code).toString(16).substring(1) + ';';
    }
    return '>' + chars;
  });
}
function Metadata(meta) {
  if (typeof meta === 'string') {
    meta = fixMetadata(meta);
    var parser = new DOMParser();
    meta = parser.parseFromString(meta, 'application/xml');
  } else if (!(meta instanceof Document)) {
    throw new Error('Metadata: Invalid metadata object');
  }
  this.metaDocument = meta;
  this.metadata = Object.create(null);
  this.parse();
}
Metadata.prototype = {
  parse: function Metadata_parse() {
    var doc = this.metaDocument;
    var rdf = doc.documentElement;
    if (rdf.nodeName.toLowerCase() !== 'rdf:rdf') {
      rdf = rdf.firstChild;
      while (rdf && rdf.nodeName.toLowerCase() !== 'rdf:rdf') {
        rdf = rdf.nextSibling;
      }
    }
    var nodeName = rdf ? rdf.nodeName.toLowerCase() : null;
    if (!rdf || nodeName !== 'rdf:rdf' || !rdf.hasChildNodes()) {
      return;
    }
    var children = rdf.childNodes,
        desc,
        entry,
        name,
        i,
        ii,
        length,
        iLength;
    for (i = 0, length = children.length; i < length; i++) {
      desc = children[i];
      if (desc.nodeName.toLowerCase() !== 'rdf:description') {
        continue;
      }
      for (ii = 0, iLength = desc.childNodes.length; ii < iLength; ii++) {
        if (desc.childNodes[ii].nodeName.toLowerCase() !== '#text') {
          entry = desc.childNodes[ii];
          name = entry.nodeName.toLowerCase();
          this.metadata[name] = entry.textContent.trim();
        }
      }
    }
  },
  get: function Metadata_get(name) {
    return this.metadata[name] || null;
  },
  has: function Metadata_has(name) {
    return typeof this.metadata[name] !== 'undefined';
  }
};
exports.Metadata = Metadata;

/***/ }),
/* 7 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WebGLUtils = undefined;

var _dom_utils = __w_pdfjs_require__(1);

var _util = __w_pdfjs_require__(0);

var WebGLUtils = function WebGLUtilsClosure() {
  function loadShader(gl, code, shaderType) {
    var shader = gl.createShader(shaderType);
    gl.shaderSource(shader, code);
    gl.compileShader(shader);
    var compiled = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
    if (!compiled) {
      var errorMsg = gl.getShaderInfoLog(shader);
      throw new Error('Error during shader compilation: ' + errorMsg);
    }
    return shader;
  }
  function createVertexShader(gl, code) {
    return loadShader(gl, code, gl.VERTEX_SHADER);
  }
  function createFragmentShader(gl, code) {
    return loadShader(gl, code, gl.FRAGMENT_SHADER);
  }
  function createProgram(gl, shaders) {
    var program = gl.createProgram();
    for (var i = 0, ii = shaders.length; i < ii; ++i) {
      gl.attachShader(program, shaders[i]);
    }
    gl.linkProgram(program);
    var linked = gl.getProgramParameter(program, gl.LINK_STATUS);
    if (!linked) {
      var errorMsg = gl.getProgramInfoLog(program);
      throw new Error('Error during program linking: ' + errorMsg);
    }
    return program;
  }
  function createTexture(gl, image, textureId) {
    gl.activeTexture(textureId);
    var texture = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, texture);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, image);
    return texture;
  }
  var currentGL, currentCanvas;
  function generateGL() {
    if (currentGL) {
      return;
    }
    currentCanvas = document.createElement('canvas');
    currentGL = currentCanvas.getContext('webgl', { premultipliedalpha: false });
  }
  var smaskVertexShaderCode = '\
  attribute vec2 a_position;                                    \
  attribute vec2 a_texCoord;                                    \
                                                                \
  uniform vec2 u_resolution;                                    \
                                                                \
  varying vec2 v_texCoord;                                      \
                                                                \
  void main() {                                                 \
    vec2 clipSpace = (a_position / u_resolution) * 2.0 - 1.0;   \
    gl_Position = vec4(clipSpace * vec2(1, -1), 0, 1);          \
                                                                \
    v_texCoord = a_texCoord;                                    \
  }                                                             ';
  var smaskFragmentShaderCode = '\
  precision mediump float;                                      \
                                                                \
  uniform vec4 u_backdrop;                                      \
  uniform int u_subtype;                                        \
  uniform sampler2D u_image;                                    \
  uniform sampler2D u_mask;                                     \
                                                                \
  varying vec2 v_texCoord;                                      \
                                                                \
  void main() {                                                 \
    vec4 imageColor = texture2D(u_image, v_texCoord);           \
    vec4 maskColor = texture2D(u_mask, v_texCoord);             \
    if (u_backdrop.a > 0.0) {                                   \
      maskColor.rgb = maskColor.rgb * maskColor.a +             \
                      u_backdrop.rgb * (1.0 - maskColor.a);     \
    }                                                           \
    float lum;                                                  \
    if (u_subtype == 0) {                                       \
      lum = maskColor.a;                                        \
    } else {                                                    \
      lum = maskColor.r * 0.3 + maskColor.g * 0.59 +            \
            maskColor.b * 0.11;                                 \
    }                                                           \
    imageColor.a *= lum;                                        \
    imageColor.rgb *= imageColor.a;                             \
    gl_FragColor = imageColor;                                  \
  }                                                             ';
  var smaskCache = null;
  function initSmaskGL() {
    var canvas, gl;
    generateGL();
    canvas = currentCanvas;
    currentCanvas = null;
    gl = currentGL;
    currentGL = null;
    var vertexShader = createVertexShader(gl, smaskVertexShaderCode);
    var fragmentShader = createFragmentShader(gl, smaskFragmentShaderCode);
    var program = createProgram(gl, [vertexShader, fragmentShader]);
    gl.useProgram(program);
    var cache = {};
    cache.gl = gl;
    cache.canvas = canvas;
    cache.resolutionLocation = gl.getUniformLocation(program, 'u_resolution');
    cache.positionLocation = gl.getAttribLocation(program, 'a_position');
    cache.backdropLocation = gl.getUniformLocation(program, 'u_backdrop');
    cache.subtypeLocation = gl.getUniformLocation(program, 'u_subtype');
    var texCoordLocation = gl.getAttribLocation(program, 'a_texCoord');
    var texLayerLocation = gl.getUniformLocation(program, 'u_image');
    var texMaskLocation = gl.getUniformLocation(program, 'u_mask');
    var texCoordBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, texCoordBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([0.0, 0.0, 1.0, 0.0, 0.0, 1.0, 0.0, 1.0, 1.0, 0.0, 1.0, 1.0]), gl.STATIC_DRAW);
    gl.enableVertexAttribArray(texCoordLocation);
    gl.vertexAttribPointer(texCoordLocation, 2, gl.FLOAT, false, 0, 0);
    gl.uniform1i(texLayerLocation, 0);
    gl.uniform1i(texMaskLocation, 1);
    smaskCache = cache;
  }
  function composeSMask(layer, mask, properties) {
    var width = layer.width,
        height = layer.height;
    if (!smaskCache) {
      initSmaskGL();
    }
    var cache = smaskCache,
        canvas = cache.canvas,
        gl = cache.gl;
    canvas.width = width;
    canvas.height = height;
    gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
    gl.uniform2f(cache.resolutionLocation, width, height);
    if (properties.backdrop) {
      gl.uniform4f(cache.resolutionLocation, properties.backdrop[0], properties.backdrop[1], properties.backdrop[2], 1);
    } else {
      gl.uniform4f(cache.resolutionLocation, 0, 0, 0, 0);
    }
    gl.uniform1i(cache.subtypeLocation, properties.subtype === 'Luminosity' ? 1 : 0);
    var texture = createTexture(gl, layer, gl.TEXTURE0);
    var maskTexture = createTexture(gl, mask, gl.TEXTURE1);
    var buffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([0, 0, width, 0, 0, height, 0, height, width, 0, width, height]), gl.STATIC_DRAW);
    gl.enableVertexAttribArray(cache.positionLocation);
    gl.vertexAttribPointer(cache.positionLocation, 2, gl.FLOAT, false, 0, 0);
    gl.clearColor(0, 0, 0, 0);
    gl.enable(gl.BLEND);
    gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
    gl.clear(gl.COLOR_BUFFER_BIT);
    gl.drawArrays(gl.TRIANGLES, 0, 6);
    gl.flush();
    gl.deleteTexture(texture);
    gl.deleteTexture(maskTexture);
    gl.deleteBuffer(buffer);
    return canvas;
  }
  var figuresVertexShaderCode = '\
  attribute vec2 a_position;                                    \
  attribute vec3 a_color;                                       \
                                                                \
  uniform vec2 u_resolution;                                    \
  uniform vec2 u_scale;                                         \
  uniform vec2 u_offset;                                        \
                                                                \
  varying vec4 v_color;                                         \
                                                                \
  void main() {                                                 \
    vec2 position = (a_position + u_offset) * u_scale;          \
    vec2 clipSpace = (position / u_resolution) * 2.0 - 1.0;     \
    gl_Position = vec4(clipSpace * vec2(1, -1), 0, 1);          \
                                                                \
    v_color = vec4(a_color / 255.0, 1.0);                       \
  }                                                             ';
  var figuresFragmentShaderCode = '\
  precision mediump float;                                      \
                                                                \
  varying vec4 v_color;                                         \
                                                                \
  void main() {                                                 \
    gl_FragColor = v_color;                                     \
  }                                                             ';
  var figuresCache = null;
  function initFiguresGL() {
    var canvas, gl;
    generateGL();
    canvas = currentCanvas;
    currentCanvas = null;
    gl = currentGL;
    currentGL = null;
    var vertexShader = createVertexShader(gl, figuresVertexShaderCode);
    var fragmentShader = createFragmentShader(gl, figuresFragmentShaderCode);
    var program = createProgram(gl, [vertexShader, fragmentShader]);
    gl.useProgram(program);
    var cache = {};
    cache.gl = gl;
    cache.canvas = canvas;
    cache.resolutionLocation = gl.getUniformLocation(program, 'u_resolution');
    cache.scaleLocation = gl.getUniformLocation(program, 'u_scale');
    cache.offsetLocation = gl.getUniformLocation(program, 'u_offset');
    cache.positionLocation = gl.getAttribLocation(program, 'a_position');
    cache.colorLocation = gl.getAttribLocation(program, 'a_color');
    figuresCache = cache;
  }
  function drawFigures(width, height, backgroundColor, figures, context) {
    if (!figuresCache) {
      initFiguresGL();
    }
    var cache = figuresCache,
        canvas = cache.canvas,
        gl = cache.gl;
    canvas.width = width;
    canvas.height = height;
    gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
    gl.uniform2f(cache.resolutionLocation, width, height);
    var count = 0;
    var i, ii, rows;
    for (i = 0, ii = figures.length; i < ii; i++) {
      switch (figures[i].type) {
        case 'lattice':
          rows = figures[i].coords.length / figures[i].verticesPerRow | 0;
          count += (rows - 1) * (figures[i].verticesPerRow - 1) * 6;
          break;
        case 'triangles':
          count += figures[i].coords.length;
          break;
      }
    }
    var coords = new Float32Array(count * 2);
    var colors = new Uint8Array(count * 3);
    var coordsMap = context.coords,
        colorsMap = context.colors;
    var pIndex = 0,
        cIndex = 0;
    for (i = 0, ii = figures.length; i < ii; i++) {
      var figure = figures[i],
          ps = figure.coords,
          cs = figure.colors;
      switch (figure.type) {
        case 'lattice':
          var cols = figure.verticesPerRow;
          rows = ps.length / cols | 0;
          for (var row = 1; row < rows; row++) {
            var offset = row * cols + 1;
            for (var col = 1; col < cols; col++, offset++) {
              coords[pIndex] = coordsMap[ps[offset - cols - 1]];
              coords[pIndex + 1] = coordsMap[ps[offset - cols - 1] + 1];
              coords[pIndex + 2] = coordsMap[ps[offset - cols]];
              coords[pIndex + 3] = coordsMap[ps[offset - cols] + 1];
              coords[pIndex + 4] = coordsMap[ps[offset - 1]];
              coords[pIndex + 5] = coordsMap[ps[offset - 1] + 1];
              colors[cIndex] = colorsMap[cs[offset - cols - 1]];
              colors[cIndex + 1] = colorsMap[cs[offset - cols - 1] + 1];
              colors[cIndex + 2] = colorsMap[cs[offset - cols - 1] + 2];
              colors[cIndex + 3] = colorsMap[cs[offset - cols]];
              colors[cIndex + 4] = colorsMap[cs[offset - cols] + 1];
              colors[cIndex + 5] = colorsMap[cs[offset - cols] + 2];
              colors[cIndex + 6] = colorsMap[cs[offset - 1]];
              colors[cIndex + 7] = colorsMap[cs[offset - 1] + 1];
              colors[cIndex + 8] = colorsMap[cs[offset - 1] + 2];
              coords[pIndex + 6] = coords[pIndex + 2];
              coords[pIndex + 7] = coords[pIndex + 3];
              coords[pIndex + 8] = coords[pIndex + 4];
              coords[pIndex + 9] = coords[pIndex + 5];
              coords[pIndex + 10] = coordsMap[ps[offset]];
              coords[pIndex + 11] = coordsMap[ps[offset] + 1];
              colors[cIndex + 9] = colors[cIndex + 3];
              colors[cIndex + 10] = colors[cIndex + 4];
              colors[cIndex + 11] = colors[cIndex + 5];
              colors[cIndex + 12] = colors[cIndex + 6];
              colors[cIndex + 13] = colors[cIndex + 7];
              colors[cIndex + 14] = colors[cIndex + 8];
              colors[cIndex + 15] = colorsMap[cs[offset]];
              colors[cIndex + 16] = colorsMap[cs[offset] + 1];
              colors[cIndex + 17] = colorsMap[cs[offset] + 2];
              pIndex += 12;
              cIndex += 18;
            }
          }
          break;
        case 'triangles':
          for (var j = 0, jj = ps.length; j < jj; j++) {
            coords[pIndex] = coordsMap[ps[j]];
            coords[pIndex + 1] = coordsMap[ps[j] + 1];
            colors[cIndex] = colorsMap[cs[j]];
            colors[cIndex + 1] = colorsMap[cs[j] + 1];
            colors[cIndex + 2] = colorsMap[cs[j] + 2];
            pIndex += 2;
            cIndex += 3;
          }
          break;
      }
    }
    if (backgroundColor) {
      gl.clearColor(backgroundColor[0] / 255, backgroundColor[1] / 255, backgroundColor[2] / 255, 1.0);
    } else {
      gl.clearColor(0, 0, 0, 0);
    }
    gl.clear(gl.COLOR_BUFFER_BIT);
    var coordsBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, coordsBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, coords, gl.STATIC_DRAW);
    gl.enableVertexAttribArray(cache.positionLocation);
    gl.vertexAttribPointer(cache.positionLocation, 2, gl.FLOAT, false, 0, 0);
    var colorsBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, colorsBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, colors, gl.STATIC_DRAW);
    gl.enableVertexAttribArray(cache.colorLocation);
    gl.vertexAttribPointer(cache.colorLocation, 3, gl.UNSIGNED_BYTE, false, 0, 0);
    gl.uniform2f(cache.scaleLocation, context.scaleX, context.scaleY);
    gl.uniform2f(cache.offsetLocation, context.offsetX, context.offsetY);
    gl.drawArrays(gl.TRIANGLES, 0, count);
    gl.flush();
    gl.deleteBuffer(coordsBuffer);
    gl.deleteBuffer(colorsBuffer);
    return canvas;
  }
  function cleanup() {
    if (smaskCache && smaskCache.canvas) {
      smaskCache.canvas.width = 0;
      smaskCache.canvas.height = 0;
    }
    if (figuresCache && figuresCache.canvas) {
      figuresCache.canvas.width = 0;
      figuresCache.canvas.height = 0;
    }
    smaskCache = null;
    figuresCache = null;
  }
  return {
    get isEnabled() {
      if ((0, _dom_utils.getDefaultSetting)('disableWebGL')) {
        return false;
      }
      var enabled = false;
      try {
        generateGL();
        enabled = !!currentGL;
      } catch (e) {}
      return (0, _util.shadow)(this, 'isEnabled', enabled);
    },
    composeSMask: composeSMask,
    drawFigures: drawFigures,
    clear: cleanup
  };
}();
exports.WebGLUtils = WebGLUtils;

/***/ }),
/* 8 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PDFJS = exports.isWorker = exports.globalScope = undefined;

var _api = __w_pdfjs_require__(2);

var _dom_utils = __w_pdfjs_require__(1);

var _util = __w_pdfjs_require__(0);

var _annotation_layer = __w_pdfjs_require__(3);

var _metadata = __w_pdfjs_require__(6);

var _text_layer = __w_pdfjs_require__(5);

var _svg = __w_pdfjs_require__(4);

var isWorker = typeof window === 'undefined';
if (!_util.globalScope.PDFJS) {
  _util.globalScope.PDFJS = {};
}
var PDFJS = _util.globalScope.PDFJS;
{
  PDFJS.version = '1.8.619';
  PDFJS.build = '723bc25b';
}
PDFJS.pdfBug = false;
if (PDFJS.verbosity !== undefined) {
  (0, _util.setVerbosityLevel)(PDFJS.verbosity);
}
delete PDFJS.verbosity;
Object.defineProperty(PDFJS, 'verbosity', {
  get: function get() {
    return (0, _util.getVerbosityLevel)();
  },
  set: function set(level) {
    (0, _util.setVerbosityLevel)(level);
  },

  enumerable: true,
  configurable: true
});
PDFJS.VERBOSITY_LEVELS = _util.VERBOSITY_LEVELS;
PDFJS.OPS = _util.OPS;
PDFJS.UNSUPPORTED_FEATURES = _util.UNSUPPORTED_FEATURES;
PDFJS.isValidUrl = _dom_utils.isValidUrl;
PDFJS.shadow = _util.shadow;
PDFJS.createBlob = _util.createBlob;
PDFJS.createObjectURL = function PDFJS_createObjectURL(data, contentType) {
  return (0, _util.createObjectURL)(data, contentType, PDFJS.disableCreateObjectURL);
};
Object.defineProperty(PDFJS, 'isLittleEndian', {
  configurable: true,
  get: function PDFJS_isLittleEndian() {
    return (0, _util.shadow)(PDFJS, 'isLittleEndian', (0, _util.isLittleEndian)());
  }
});
PDFJS.removeNullCharacters = _util.removeNullCharacters;
PDFJS.PasswordResponses = _util.PasswordResponses;
PDFJS.PasswordException = _util.PasswordException;
PDFJS.UnknownErrorException = _util.UnknownErrorException;
PDFJS.InvalidPDFException = _util.InvalidPDFException;
PDFJS.MissingPDFException = _util.MissingPDFException;
PDFJS.UnexpectedResponseException = _util.UnexpectedResponseException;
PDFJS.Util = _util.Util;
PDFJS.PageViewport = _util.PageViewport;
PDFJS.createPromiseCapability = _util.createPromiseCapability;
PDFJS.maxImageSize = PDFJS.maxImageSize === undefined ? -1 : PDFJS.maxImageSize;
PDFJS.cMapUrl = PDFJS.cMapUrl === undefined ? null : PDFJS.cMapUrl;
PDFJS.cMapPacked = PDFJS.cMapPacked === undefined ? false : PDFJS.cMapPacked;
PDFJS.disableFontFace = PDFJS.disableFontFace === undefined ? false : PDFJS.disableFontFace;
PDFJS.imageResourcesPath = PDFJS.imageResourcesPath === undefined ? '' : PDFJS.imageResourcesPath;
PDFJS.disableWorker = PDFJS.disableWorker === undefined ? false : PDFJS.disableWorker;
PDFJS.workerSrc = PDFJS.workerSrc === undefined ? null : PDFJS.workerSrc;
PDFJS.workerPort = PDFJS.workerPort === undefined ? null : PDFJS.workerPort;
PDFJS.disableRange = PDFJS.disableRange === undefined ? false : PDFJS.disableRange;
PDFJS.disableStream = PDFJS.disableStream === undefined ? false : PDFJS.disableStream;
PDFJS.disableAutoFetch = PDFJS.disableAutoFetch === undefined ? false : PDFJS.disableAutoFetch;
PDFJS.pdfBug = PDFJS.pdfBug === undefined ? false : PDFJS.pdfBug;
PDFJS.postMessageTransfers = PDFJS.postMessageTransfers === undefined ? true : PDFJS.postMessageTransfers;
PDFJS.disableCreateObjectURL = PDFJS.disableCreateObjectURL === undefined ? false : PDFJS.disableCreateObjectURL;
PDFJS.disableWebGL = PDFJS.disableWebGL === undefined ? true : PDFJS.disableWebGL;
PDFJS.externalLinkTarget = PDFJS.externalLinkTarget === undefined ? _dom_utils.LinkTarget.NONE : PDFJS.externalLinkTarget;
PDFJS.externalLinkRel = PDFJS.externalLinkRel === undefined ? _dom_utils.DEFAULT_LINK_REL : PDFJS.externalLinkRel;
PDFJS.isEvalSupported = PDFJS.isEvalSupported === undefined ? true : PDFJS.isEvalSupported;
PDFJS.pdfjsNext = PDFJS.pdfjsNext === undefined ? false : PDFJS.pdfjsNext;
{
  var savedOpenExternalLinksInNewWindow = PDFJS.openExternalLinksInNewWindow;
  delete PDFJS.openExternalLinksInNewWindow;
  Object.defineProperty(PDFJS, 'openExternalLinksInNewWindow', {
    get: function get() {
      return PDFJS.externalLinkTarget === _dom_utils.LinkTarget.BLANK;
    },
    set: function set(value) {
      if (value) {
        (0, _util.deprecated)('PDFJS.openExternalLinksInNewWindow, please use ' + '"PDFJS.externalLinkTarget = PDFJS.LinkTarget.BLANK" instead.');
      }
      if (PDFJS.externalLinkTarget !== _dom_utils.LinkTarget.NONE) {
        (0, _util.warn)('PDFJS.externalLinkTarget is already initialized');
        return;
      }
      PDFJS.externalLinkTarget = value ? _dom_utils.LinkTarget.BLANK : _dom_utils.LinkTarget.NONE;
    },

    enumerable: true,
    configurable: true
  });
  if (savedOpenExternalLinksInNewWindow) {
    PDFJS.openExternalLinksInNewWindow = savedOpenExternalLinksInNewWindow;
  }
}
PDFJS.getDocument = _api.getDocument;
PDFJS.LoopbackPort = _api.LoopbackPort;
PDFJS.PDFDataRangeTransport = _api.PDFDataRangeTransport;
PDFJS.PDFWorker = _api.PDFWorker;
PDFJS.hasCanvasTypedArrays = true;
PDFJS.CustomStyle = _dom_utils.CustomStyle;
PDFJS.LinkTarget = _dom_utils.LinkTarget;
PDFJS.addLinkAttributes = _dom_utils.addLinkAttributes;
PDFJS.getFilenameFromUrl = _dom_utils.getFilenameFromUrl;
PDFJS.isExternalLinkTargetSet = _dom_utils.isExternalLinkTargetSet;
PDFJS.AnnotationLayer = _annotation_layer.AnnotationLayer;
PDFJS.renderTextLayer = _text_layer.renderTextLayer;
PDFJS.Metadata = _metadata.Metadata;
PDFJS.SVGGraphics = _svg.SVGGraphics;
PDFJS.UnsupportedManager = _api._UnsupportedManager;
exports.globalScope = _util.globalScope;
exports.isWorker = isWorker;
exports.PDFJS = PDFJS;

/***/ }),
/* 9 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NetworkManager = exports.PDFNetworkStream = undefined;

var _util = __w_pdfjs_require__(0);

var _api = __w_pdfjs_require__(2);

;
var OK_RESPONSE = 200;
var PARTIAL_CONTENT_RESPONSE = 206;
function NetworkManager(url, args) {
  this.url = url;
  args = args || {};
  this.isHttp = /^https?:/i.test(url);
  this.httpHeaders = this.isHttp && args.httpHeaders || {};
  this.withCredentials = args.withCredentials || false;
  this.getXhr = args.getXhr || function NetworkManager_getXhr() {
    return new XMLHttpRequest();
  };
  this.currXhrId = 0;
  this.pendingRequests = Object.create(null);
  this.loadedRequests = Object.create(null);
}
function getArrayBuffer(xhr) {
  var data = xhr.response;
  if (typeof data !== 'string') {
    return data;
  }
  var length = data.length;
  var array = new Uint8Array(length);
  for (var i = 0; i < length; i++) {
    array[i] = data.charCodeAt(i) & 0xFF;
  }
  return array.buffer;
}
var supportsMozChunked = function supportsMozChunkedClosure() {
  try {
    var x = new XMLHttpRequest();
    x.open('GET', _util.globalScope.location.href);
    x.responseType = 'moz-chunked-arraybuffer';
    return x.responseType === 'moz-chunked-arraybuffer';
  } catch (e) {
    return false;
  }
}();
NetworkManager.prototype = {
  requestRange: function NetworkManager_requestRange(begin, end, listeners) {
    var args = {
      begin: begin,
      end: end
    };
    for (var prop in listeners) {
      args[prop] = listeners[prop];
    }
    return this.request(args);
  },
  requestFull: function NetworkManager_requestFull(listeners) {
    return this.request(listeners);
  },
  request: function NetworkManager_request(args) {
    var xhr = this.getXhr();
    var xhrId = this.currXhrId++;
    var pendingRequest = this.pendingRequests[xhrId] = { xhr: xhr };
    xhr.open('GET', this.url);
    xhr.withCredentials = this.withCredentials;
    for (var property in this.httpHeaders) {
      var value = this.httpHeaders[property];
      if (typeof value === 'undefined') {
        continue;
      }
      xhr.setRequestHeader(property, value);
    }
    if (this.isHttp && 'begin' in args && 'end' in args) {
      var rangeStr = args.begin + '-' + (args.end - 1);
      xhr.setRequestHeader('Range', 'bytes=' + rangeStr);
      pendingRequest.expectedStatus = 206;
    } else {
      pendingRequest.expectedStatus = 200;
    }
    var useMozChunkedLoading = supportsMozChunked && !!args.onProgressiveData;
    if (useMozChunkedLoading) {
      xhr.responseType = 'moz-chunked-arraybuffer';
      pendingRequest.onProgressiveData = args.onProgressiveData;
      pendingRequest.mozChunked = true;
    } else {
      xhr.responseType = 'arraybuffer';
    }
    if (args.onError) {
      xhr.onerror = function (evt) {
        args.onError(xhr.status);
      };
    }
    xhr.onreadystatechange = this.onStateChange.bind(this, xhrId);
    xhr.onprogress = this.onProgress.bind(this, xhrId);
    pendingRequest.onHeadersReceived = args.onHeadersReceived;
    pendingRequest.onDone = args.onDone;
    pendingRequest.onError = args.onError;
    pendingRequest.onProgress = args.onProgress;
    xhr.send(null);
    return xhrId;
  },
  onProgress: function NetworkManager_onProgress(xhrId, evt) {
    var pendingRequest = this.pendingRequests[xhrId];
    if (!pendingRequest) {
      return;
    }
    if (pendingRequest.mozChunked) {
      var chunk = getArrayBuffer(pendingRequest.xhr);
      pendingRequest.onProgressiveData(chunk);
    }
    var onProgress = pendingRequest.onProgress;
    if (onProgress) {
      onProgress(evt);
    }
  },
  onStateChange: function NetworkManager_onStateChange(xhrId, evt) {
    var pendingRequest = this.pendingRequests[xhrId];
    if (!pendingRequest) {
      return;
    }
    var xhr = pendingRequest.xhr;
    if (xhr.readyState >= 2 && pendingRequest.onHeadersReceived) {
      pendingRequest.onHeadersReceived();
      delete pendingRequest.onHeadersReceived;
    }
    if (xhr.readyState !== 4) {
      return;
    }
    if (!(xhrId in this.pendingRequests)) {
      return;
    }
    delete this.pendingRequests[xhrId];
    if (xhr.status === 0 && this.isHttp) {
      if (pendingRequest.onError) {
        pendingRequest.onError(xhr.status);
      }
      return;
    }
    var xhrStatus = xhr.status || OK_RESPONSE;
    var ok_response_on_range_request = xhrStatus === OK_RESPONSE && pendingRequest.expectedStatus === PARTIAL_CONTENT_RESPONSE;
    if (!ok_response_on_range_request && xhrStatus !== pendingRequest.expectedStatus) {
      if (pendingRequest.onError) {
        pendingRequest.onError(xhr.status);
      }
      return;
    }
    this.loadedRequests[xhrId] = true;
    var chunk = getArrayBuffer(xhr);
    if (xhrStatus === PARTIAL_CONTENT_RESPONSE) {
      var rangeHeader = xhr.getResponseHeader('Content-Range');
      var matches = /bytes (\d+)-(\d+)\/(\d+)/.exec(rangeHeader);
      var begin = parseInt(matches[1], 10);
      pendingRequest.onDone({
        begin: begin,
        chunk: chunk
      });
    } else if (pendingRequest.onProgressiveData) {
      pendingRequest.onDone(null);
    } else if (chunk) {
      pendingRequest.onDone({
        begin: 0,
        chunk: chunk
      });
    } else if (pendingRequest.onError) {
      pendingRequest.onError(xhr.status);
    }
  },
  hasPendingRequests: function NetworkManager_hasPendingRequests() {
    for (var xhrId in this.pendingRequests) {
      return true;
    }
    return false;
  },
  getRequestXhr: function NetworkManager_getXhr(xhrId) {
    return this.pendingRequests[xhrId].xhr;
  },
  isStreamingRequest: function NetworkManager_isStreamingRequest(xhrId) {
    return !!this.pendingRequests[xhrId].onProgressiveData;
  },
  isPendingRequest: function NetworkManager_isPendingRequest(xhrId) {
    return xhrId in this.pendingRequests;
  },
  isLoadedRequest: function NetworkManager_isLoadedRequest(xhrId) {
    return xhrId in this.loadedRequests;
  },
  abortAllRequests: function NetworkManager_abortAllRequests() {
    for (var xhrId in this.pendingRequests) {
      this.abortRequest(xhrId | 0);
    }
  },
  abortRequest: function NetworkManager_abortRequest(xhrId) {
    var xhr = this.pendingRequests[xhrId].xhr;
    delete this.pendingRequests[xhrId];
    xhr.abort();
  }
};
function PDFNetworkStream(options) {
  this._options = options;
  var source = options.source;
  this._manager = new NetworkManager(source.url, {
    httpHeaders: source.httpHeaders,
    withCredentials: source.withCredentials
  });
  this._rangeChunkSize = source.rangeChunkSize;
  this._fullRequestReader = null;
  this._rangeRequestReaders = [];
}
PDFNetworkStream.prototype = {
  _onRangeRequestReaderClosed: function PDFNetworkStream_onRangeRequestReaderClosed(reader) {
    var i = this._rangeRequestReaders.indexOf(reader);
    if (i >= 0) {
      this._rangeRequestReaders.splice(i, 1);
    }
  },
  getFullReader: function PDFNetworkStream_getFullReader() {
    (0, _util.assert)(!this._fullRequestReader);
    this._fullRequestReader = new PDFNetworkStreamFullRequestReader(this._manager, this._options);
    return this._fullRequestReader;
  },
  getRangeReader: function PDFNetworkStream_getRangeReader(begin, end) {
    var reader = new PDFNetworkStreamRangeRequestReader(this._manager, begin, end);
    reader.onClosed = this._onRangeRequestReaderClosed.bind(this);
    this._rangeRequestReaders.push(reader);
    return reader;
  },
  cancelAllRequests: function PDFNetworkStream_cancelAllRequests(reason) {
    if (this._fullRequestReader) {
      this._fullRequestReader.cancel(reason);
    }
    var readers = this._rangeRequestReaders.slice(0);
    readers.forEach(function (reader) {
      reader.cancel(reason);
    });
  }
};
function PDFNetworkStreamFullRequestReader(manager, options) {
  this._manager = manager;
  var source = options.source;
  var args = {
    onHeadersReceived: this._onHeadersReceived.bind(this),
    onProgressiveData: source.disableStream ? null : this._onProgressiveData.bind(this),
    onDone: this._onDone.bind(this),
    onError: this._onError.bind(this),
    onProgress: this._onProgress.bind(this)
  };
  this._url = source.url;
  this._fullRequestId = manager.requestFull(args);
  this._headersReceivedCapability = (0, _util.createPromiseCapability)();
  this._disableRange = options.disableRange || false;
  this._contentLength = source.length;
  this._rangeChunkSize = source.rangeChunkSize;
  if (!this._rangeChunkSize && !this._disableRange) {
    this._disableRange = true;
  }
  this._isStreamingSupported = false;
  this._isRangeSupported = false;
  this._cachedChunks = [];
  this._requests = [];
  this._done = false;
  this._storedError = undefined;
  this.onProgress = null;
}
PDFNetworkStreamFullRequestReader.prototype = {
  _validateRangeRequestCapabilities: function PDFNetworkStreamFullRequestReader_validateRangeRequestCapabilities() {
    if (this._disableRange) {
      return false;
    }
    var networkManager = this._manager;
    if (!networkManager.isHttp) {
      return false;
    }
    var fullRequestXhrId = this._fullRequestId;
    var fullRequestXhr = networkManager.getRequestXhr(fullRequestXhrId);
    if (fullRequestXhr.getResponseHeader('Accept-Ranges') !== 'bytes') {
      return false;
    }
    var contentEncoding = fullRequestXhr.getResponseHeader('Content-Encoding') || 'identity';
    if (contentEncoding !== 'identity') {
      return false;
    }
    var length = fullRequestXhr.getResponseHeader('Content-Length');
    length = parseInt(length, 10);
    if (!(0, _util.isInt)(length)) {
      return false;
    }
    this._contentLength = length;
    if (length <= 2 * this._rangeChunkSize) {
      return false;
    }
    return true;
  },
  _onHeadersReceived: function PDFNetworkStreamFullRequestReader_onHeadersReceived() {
    if (this._validateRangeRequestCapabilities()) {
      this._isRangeSupported = true;
    }
    var networkManager = this._manager;
    var fullRequestXhrId = this._fullRequestId;
    if (networkManager.isStreamingRequest(fullRequestXhrId)) {
      this._isStreamingSupported = true;
    } else if (this._isRangeSupported) {
      networkManager.abortRequest(fullRequestXhrId);
    }
    this._headersReceivedCapability.resolve();
  },
  _onProgressiveData: function PDFNetworkStreamFullRequestReader_onProgressiveData(chunk) {
    if (this._requests.length > 0) {
      var requestCapability = this._requests.shift();
      requestCapability.resolve({
        value: chunk,
        done: false
      });
    } else {
      this._cachedChunks.push(chunk);
    }
  },
  _onDone: function PDFNetworkStreamFullRequestReader_onDone(args) {
    if (args) {
      this._onProgressiveData(args.chunk);
    }
    this._done = true;
    if (this._cachedChunks.length > 0) {
      return;
    }
    this._requests.forEach(function (requestCapability) {
      requestCapability.resolve({
        value: undefined,
        done: true
      });
    });
    this._requests = [];
  },
  _onError: function PDFNetworkStreamFullRequestReader_onError(status) {
    var url = this._url;
    var exception;
    if (status === 404 || status === 0 && /^file:/.test(url)) {
      exception = new _util.MissingPDFException('Missing PDF "' + url + '".');
    } else {
      exception = new _util.UnexpectedResponseException('Unexpected server response (' + status + ') while retrieving PDF "' + url + '".', status);
    }
    this._storedError = exception;
    this._headersReceivedCapability.reject(exception);
    this._requests.forEach(function (requestCapability) {
      requestCapability.reject(exception);
    });
    this._requests = [];
    this._cachedChunks = [];
  },
  _onProgress: function PDFNetworkStreamFullRequestReader_onProgress(data) {
    if (this.onProgress) {
      this.onProgress({
        loaded: data.loaded,
        total: data.lengthComputable ? data.total : this._contentLength
      });
    }
  },
  get isRangeSupported() {
    return this._isRangeSupported;
  },
  get isStreamingSupported() {
    return this._isStreamingSupported;
  },
  get contentLength() {
    return this._contentLength;
  },
  get headersReady() {
    return this._headersReceivedCapability.promise;
  },
  read: function PDFNetworkStreamFullRequestReader_read() {
    if (this._storedError) {
      return Promise.reject(this._storedError);
    }
    if (this._cachedChunks.length > 0) {
      var chunk = this._cachedChunks.shift();
      return Promise.resolve({
        value: chunk,
        done: false
      });
    }
    if (this._done) {
      return Promise.resolve({
        value: undefined,
        done: true
      });
    }
    var requestCapability = (0, _util.createPromiseCapability)();
    this._requests.push(requestCapability);
    return requestCapability.promise;
  },
  cancel: function PDFNetworkStreamFullRequestReader_cancel(reason) {
    this._done = true;
    this._headersReceivedCapability.reject(reason);
    this._requests.forEach(function (requestCapability) {
      requestCapability.resolve({
        value: undefined,
        done: true
      });
    });
    this._requests = [];
    if (this._manager.isPendingRequest(this._fullRequestId)) {
      this._manager.abortRequest(this._fullRequestId);
    }
    this._fullRequestReader = null;
  }
};
function PDFNetworkStreamRangeRequestReader(manager, begin, end) {
  this._manager = manager;
  var args = {
    onDone: this._onDone.bind(this),
    onProgress: this._onProgress.bind(this)
  };
  this._requestId = manager.requestRange(begin, end, args);
  this._requests = [];
  this._queuedChunk = null;
  this._done = false;
  this.onProgress = null;
  this.onClosed = null;
}
PDFNetworkStreamRangeRequestReader.prototype = {
  _close: function PDFNetworkStreamRangeRequestReader_close() {
    if (this.onClosed) {
      this.onClosed(this);
    }
  },
  _onDone: function PDFNetworkStreamRangeRequestReader_onDone(data) {
    var chunk = data.chunk;
    if (this._requests.length > 0) {
      var requestCapability = this._requests.shift();
      requestCapability.resolve({
        value: chunk,
        done: false
      });
    } else {
      this._queuedChunk = chunk;
    }
    this._done = true;
    this._requests.forEach(function (requestCapability) {
      requestCapability.resolve({
        value: undefined,
        done: true
      });
    });
    this._requests = [];
    this._close();
  },
  _onProgress: function PDFNetworkStreamRangeRequestReader_onProgress(evt) {
    if (!this.isStreamingSupported && this.onProgress) {
      this.onProgress({ loaded: evt.loaded });
    }
  },
  get isStreamingSupported() {
    return false;
  },
  read: function PDFNetworkStreamRangeRequestReader_read() {
    if (this._queuedChunk !== null) {
      var chunk = this._queuedChunk;
      this._queuedChunk = null;
      return Promise.resolve({
        value: chunk,
        done: false
      });
    }
    if (this._done) {
      return Promise.resolve({
        value: undefined,
        done: true
      });
    }
    var requestCapability = (0, _util.createPromiseCapability)();
    this._requests.push(requestCapability);
    return requestCapability.promise;
  },
  cancel: function PDFNetworkStreamRangeRequestReader_cancel(reason) {
    this._done = true;
    this._requests.forEach(function (requestCapability) {
      requestCapability.resolve({
        value: undefined,
        done: true
      });
    });
    this._requests = [];
    if (this._manager.isPendingRequest(this._requestId)) {
      this._manager.abortRequest(this._requestId);
    }
    this._close();
  }
};
(0, _api.setPDFNetworkStreamClass)(PDFNetworkStream);
exports.PDFNetworkStream = PDFNetworkStream;
exports.NetworkManager = NetworkManager;

/***/ }),
/* 10 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function (e, a) {
  for (var i in a) {
    e[i] = a[i];
  }
})(exports, function (modules) {
  var installedModules = {};
  function __w_pdfjs_require__(moduleId) {
    if (installedModules[moduleId]) return installedModules[moduleId].exports;
    var module = installedModules[moduleId] = {
      i: moduleId,
      l: false,
      exports: {}
    };
    modules[moduleId].call(module.exports, module, module.exports, __w_pdfjs_require__);
    module.l = true;
    return module.exports;
  }
  __w_pdfjs_require__.m = modules;
  __w_pdfjs_require__.c = installedModules;
  __w_pdfjs_require__.i = function (value) {
    return value;
  };
  __w_pdfjs_require__.d = function (exports, name, getter) {
    if (!__w_pdfjs_require__.o(exports, name)) {
      Object.defineProperty(exports, name, {
        configurable: false,
        enumerable: true,
        get: getter
      });
    }
  };
  __w_pdfjs_require__.n = function (module) {
    var getter = module && module.__esModule ? function getDefault() {
      return module['default'];
    } : function getModuleExports() {
      return module;
    };
    __w_pdfjs_require__.d(getter, 'a', getter);
    return getter;
  };
  __w_pdfjs_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  __w_pdfjs_require__.p = "";
  return __w_pdfjs_require__(__w_pdfjs_require__.s = 7);
}([function (module, exports, __w_pdfjs_require__) {
  "use strict";

  var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
    return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
  };
  var _require = __w_pdfjs_require__(1),
      assert = _require.assert;
  function IsPropertyKey(argument) {
    return typeof argument === 'string' || (typeof argument === 'undefined' ? 'undefined' : _typeof(argument)) === 'symbol';
  }
  exports.typeIsObject = function (x) {
    return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x !== null || typeof x === 'function';
  };
  exports.createDataProperty = function (o, p, v) {
    assert(exports.typeIsObject(o));
    Object.defineProperty(o, p, {
      value: v,
      writable: true,
      enumerable: true,
      configurable: true
    });
  };
  exports.createArrayFromList = function (elements) {
    return elements.slice();
  };
  exports.ArrayBufferCopy = function (dest, destOffset, src, srcOffset, n) {
    new Uint8Array(dest).set(new Uint8Array(src, srcOffset, n), destOffset);
  };
  exports.CreateIterResultObject = function (value, done) {
    assert(typeof done === 'boolean');
    var obj = {};
    Object.defineProperty(obj, 'value', {
      value: value,
      enumerable: true,
      writable: true,
      configurable: true
    });
    Object.defineProperty(obj, 'done', {
      value: done,
      enumerable: true,
      writable: true,
      configurable: true
    });
    return obj;
  };
  exports.IsFiniteNonNegativeNumber = function (v) {
    if (Number.isNaN(v)) {
      return false;
    }
    if (v === Infinity) {
      return false;
    }
    if (v < 0) {
      return false;
    }
    return true;
  };
  function Call(F, V, args) {
    if (typeof F !== 'function') {
      throw new TypeError('Argument is not a function');
    }
    return Function.prototype.apply.call(F, V, args);
  }
  exports.InvokeOrNoop = function (O, P, args) {
    assert(O !== undefined);
    assert(IsPropertyKey(P));
    assert(Array.isArray(args));
    var method = O[P];
    if (method === undefined) {
      return undefined;
    }
    return Call(method, O, args);
  };
  exports.PromiseInvokeOrNoop = function (O, P, args) {
    assert(O !== undefined);
    assert(IsPropertyKey(P));
    assert(Array.isArray(args));
    try {
      return Promise.resolve(exports.InvokeOrNoop(O, P, args));
    } catch (returnValueE) {
      return Promise.reject(returnValueE);
    }
  };
  exports.PromiseInvokeOrPerformFallback = function (O, P, args, F, argsF) {
    assert(O !== undefined);
    assert(IsPropertyKey(P));
    assert(Array.isArray(args));
    assert(Array.isArray(argsF));
    var method = void 0;
    try {
      method = O[P];
    } catch (methodE) {
      return Promise.reject(methodE);
    }
    if (method === undefined) {
      return F.apply(null, argsF);
    }
    try {
      return Promise.resolve(Call(method, O, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
  exports.TransferArrayBuffer = function (O) {
    return O.slice();
  };
  exports.ValidateAndNormalizeHighWaterMark = function (highWaterMark) {
    highWaterMark = Number(highWaterMark);
    if (Number.isNaN(highWaterMark) || highWaterMark < 0) {
      throw new RangeError('highWaterMark property of a queuing strategy must be non-negative and non-NaN');
    }
    return highWaterMark;
  };
  exports.ValidateAndNormalizeQueuingStrategy = function (size, highWaterMark) {
    if (size !== undefined && typeof size !== 'function') {
      throw new TypeError('size property of a queuing strategy must be a function');
    }
    highWaterMark = exports.ValidateAndNormalizeHighWaterMark(highWaterMark);
    return {
      size: size,
      highWaterMark: highWaterMark
    };
  };
}, function (module, exports, __w_pdfjs_require__) {
  "use strict";

  function rethrowAssertionErrorRejection(e) {
    if (e && e.constructor === AssertionError) {
      setTimeout(function () {
        throw e;
      }, 0);
    }
  }
  function AssertionError(message) {
    this.name = 'AssertionError';
    this.message = message || '';
    this.stack = new Error().stack;
  }
  AssertionError.prototype = Object.create(Error.prototype);
  AssertionError.prototype.constructor = AssertionError;
  function assert(value, message) {
    if (!value) {
      throw new AssertionError(message);
    }
  }
  module.exports = {
    rethrowAssertionErrorRejection: rethrowAssertionErrorRejection,
    AssertionError: AssertionError,
    assert: assert
  };
}, function (module, exports, __w_pdfjs_require__) {
  "use strict";

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var _require = __w_pdfjs_require__(0),
      InvokeOrNoop = _require.InvokeOrNoop,
      PromiseInvokeOrNoop = _require.PromiseInvokeOrNoop,
      ValidateAndNormalizeQueuingStrategy = _require.ValidateAndNormalizeQueuingStrategy,
      typeIsObject = _require.typeIsObject;
  var _require2 = __w_pdfjs_require__(1),
      assert = _require2.assert,
      rethrowAssertionErrorRejection = _require2.rethrowAssertionErrorRejection;
  var _require3 = __w_pdfjs_require__(3),
      DequeueValue = _require3.DequeueValue,
      EnqueueValueWithSize = _require3.EnqueueValueWithSize,
      PeekQueueValue = _require3.PeekQueueValue,
      ResetQueue = _require3.ResetQueue;
  var WritableStream = function () {
    function WritableStream() {
      var underlyingSink = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          size = _ref.size,
          _ref$highWaterMark = _ref.highWaterMark,
          highWaterMark = _ref$highWaterMark === undefined ? 1 : _ref$highWaterMark;
      _classCallCheck(this, WritableStream);
      this._state = 'writable';
      this._storedError = undefined;
      this._writer = undefined;
      this._writableStreamController = undefined;
      this._writeRequests = [];
      this._inFlightWriteRequest = undefined;
      this._closeRequest = undefined;
      this._inFlightCloseRequest = undefined;
      this._pendingAbortRequest = undefined;
      this._backpressure = false;
      var type = underlyingSink.type;
      if (type !== undefined) {
        throw new RangeError('Invalid type is specified');
      }
      this._writableStreamController = new WritableStreamDefaultController(this, underlyingSink, size, highWaterMark);
      this._writableStreamController.__startSteps();
    }
    _createClass(WritableStream, [{
      key: 'abort',
      value: function abort(reason) {
        if (IsWritableStream(this) === false) {
          return Promise.reject(streamBrandCheckException('abort'));
        }
        if (IsWritableStreamLocked(this) === true) {
          return Promise.reject(new TypeError('Cannot abort a stream that already has a writer'));
        }
        return WritableStreamAbort(this, reason);
      }
    }, {
      key: 'getWriter',
      value: function getWriter() {
        if (IsWritableStream(this) === false) {
          throw streamBrandCheckException('getWriter');
        }
        return AcquireWritableStreamDefaultWriter(this);
      }
    }, {
      key: 'locked',
      get: function get() {
        if (IsWritableStream(this) === false) {
          throw streamBrandCheckException('locked');
        }
        return IsWritableStreamLocked(this);
      }
    }]);
    return WritableStream;
  }();
  module.exports = {
    AcquireWritableStreamDefaultWriter: AcquireWritableStreamDefaultWriter,
    IsWritableStream: IsWritableStream,
    IsWritableStreamLocked: IsWritableStreamLocked,
    WritableStream: WritableStream,
    WritableStreamAbort: WritableStreamAbort,
    WritableStreamDefaultControllerError: WritableStreamDefaultControllerError,
    WritableStreamDefaultWriterCloseWithErrorPropagation: WritableStreamDefaultWriterCloseWithErrorPropagation,
    WritableStreamDefaultWriterRelease: WritableStreamDefaultWriterRelease,
    WritableStreamDefaultWriterWrite: WritableStreamDefaultWriterWrite,
    WritableStreamCloseQueuedOrInFlight: WritableStreamCloseQueuedOrInFlight
  };
  function AcquireWritableStreamDefaultWriter(stream) {
    return new WritableStreamDefaultWriter(stream);
  }
  function IsWritableStream(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_writableStreamController')) {
      return false;
    }
    return true;
  }
  function IsWritableStreamLocked(stream) {
    assert(IsWritableStream(stream) === true, 'IsWritableStreamLocked should only be used on known writable streams');
    if (stream._writer === undefined) {
      return false;
    }
    return true;
  }
  function WritableStreamAbort(stream, reason) {
    var state = stream._state;
    if (state === 'closed') {
      return Promise.resolve(undefined);
    }
    if (state === 'errored') {
      return Promise.reject(stream._storedError);
    }
    var error = new TypeError('Requested to abort');
    if (stream._pendingAbortRequest !== undefined) {
      return Promise.reject(error);
    }
    assert(state === 'writable' || state === 'erroring', 'state must be writable or erroring');
    var wasAlreadyErroring = false;
    if (state === 'erroring') {
      wasAlreadyErroring = true;
      reason = undefined;
    }
    var promise = new Promise(function (resolve, reject) {
      stream._pendingAbortRequest = {
        _resolve: resolve,
        _reject: reject,
        _reason: reason,
        _wasAlreadyErroring: wasAlreadyErroring
      };
    });
    if (wasAlreadyErroring === false) {
      WritableStreamStartErroring(stream, error);
    }
    return promise;
  }
  function WritableStreamAddWriteRequest(stream) {
    assert(IsWritableStreamLocked(stream) === true);
    assert(stream._state === 'writable');
    var promise = new Promise(function (resolve, reject) {
      var writeRequest = {
        _resolve: resolve,
        _reject: reject
      };
      stream._writeRequests.push(writeRequest);
    });
    return promise;
  }
  function WritableStreamDealWithRejection(stream, error) {
    var state = stream._state;
    if (state === 'writable') {
      WritableStreamStartErroring(stream, error);
      return;
    }
    assert(state === 'erroring');
    WritableStreamFinishErroring(stream);
  }
  function WritableStreamStartErroring(stream, reason) {
    assert(stream._storedError === undefined, 'stream._storedError === undefined');
    assert(stream._state === 'writable', 'state must be writable');
    var controller = stream._writableStreamController;
    assert(controller !== undefined, 'controller must not be undefined');
    stream._state = 'erroring';
    stream._storedError = reason;
    var writer = stream._writer;
    if (writer !== undefined) {
      WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, reason);
    }
    if (WritableStreamHasOperationMarkedInFlight(stream) === false && controller._started === true) {
      WritableStreamFinishErroring(stream);
    }
  }
  function WritableStreamFinishErroring(stream) {
    assert(stream._state === 'erroring', 'stream._state === erroring');
    assert(WritableStreamHasOperationMarkedInFlight(stream) === false, 'WritableStreamHasOperationMarkedInFlight(stream) === false');
    stream._state = 'errored';
    stream._writableStreamController.__errorSteps();
    var storedError = stream._storedError;
    for (var i = 0; i < stream._writeRequests.length; i++) {
      var writeRequest = stream._writeRequests[i];
      writeRequest._reject(storedError);
    }
    stream._writeRequests = [];
    if (stream._pendingAbortRequest === undefined) {
      WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
      return;
    }
    var abortRequest = stream._pendingAbortRequest;
    stream._pendingAbortRequest = undefined;
    if (abortRequest._wasAlreadyErroring === true) {
      abortRequest._reject(storedError);
      WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
      return;
    }
    var promise = stream._writableStreamController.__abortSteps(abortRequest._reason);
    promise.then(function () {
      abortRequest._resolve();
      WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
    }, function (reason) {
      abortRequest._reject(reason);
      WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
    });
  }
  function WritableStreamFinishInFlightWrite(stream) {
    assert(stream._inFlightWriteRequest !== undefined);
    stream._inFlightWriteRequest._resolve(undefined);
    stream._inFlightWriteRequest = undefined;
  }
  function WritableStreamFinishInFlightWriteWithError(stream, error) {
    assert(stream._inFlightWriteRequest !== undefined);
    stream._inFlightWriteRequest._reject(error);
    stream._inFlightWriteRequest = undefined;
    assert(stream._state === 'writable' || stream._state === 'erroring');
    WritableStreamDealWithRejection(stream, error);
  }
  function WritableStreamFinishInFlightClose(stream) {
    assert(stream._inFlightCloseRequest !== undefined);
    stream._inFlightCloseRequest._resolve(undefined);
    stream._inFlightCloseRequest = undefined;
    var state = stream._state;
    assert(state === 'writable' || state === 'erroring');
    if (state === 'erroring') {
      stream._storedError = undefined;
      if (stream._pendingAbortRequest !== undefined) {
        stream._pendingAbortRequest._resolve();
        stream._pendingAbortRequest = undefined;
      }
    }
    stream._state = 'closed';
    var writer = stream._writer;
    if (writer !== undefined) {
      defaultWriterClosedPromiseResolve(writer);
    }
    assert(stream._pendingAbortRequest === undefined, 'stream._pendingAbortRequest === undefined');
    assert(stream._storedError === undefined, 'stream._storedError === undefined');
  }
  function WritableStreamFinishInFlightCloseWithError(stream, error) {
    assert(stream._inFlightCloseRequest !== undefined);
    stream._inFlightCloseRequest._reject(error);
    stream._inFlightCloseRequest = undefined;
    assert(stream._state === 'writable' || stream._state === 'erroring');
    if (stream._pendingAbortRequest !== undefined) {
      stream._pendingAbortRequest._reject(error);
      stream._pendingAbortRequest = undefined;
    }
    WritableStreamDealWithRejection(stream, error);
  }
  function WritableStreamCloseQueuedOrInFlight(stream) {
    if (stream._closeRequest === undefined && stream._inFlightCloseRequest === undefined) {
      return false;
    }
    return true;
  }
  function WritableStreamHasOperationMarkedInFlight(stream) {
    if (stream._inFlightWriteRequest === undefined && stream._inFlightCloseRequest === undefined) {
      return false;
    }
    return true;
  }
  function WritableStreamMarkCloseRequestInFlight(stream) {
    assert(stream._inFlightCloseRequest === undefined);
    assert(stream._closeRequest !== undefined);
    stream._inFlightCloseRequest = stream._closeRequest;
    stream._closeRequest = undefined;
  }
  function WritableStreamMarkFirstWriteRequestInFlight(stream) {
    assert(stream._inFlightWriteRequest === undefined, 'there must be no pending write request');
    assert(stream._writeRequests.length !== 0, 'writeRequests must not be empty');
    stream._inFlightWriteRequest = stream._writeRequests.shift();
  }
  function WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream) {
    assert(stream._state === 'errored', '_stream_.[[state]] is `"errored"`');
    if (stream._closeRequest !== undefined) {
      assert(stream._inFlightCloseRequest === undefined);
      stream._closeRequest._reject(stream._storedError);
      stream._closeRequest = undefined;
    }
    var writer = stream._writer;
    if (writer !== undefined) {
      defaultWriterClosedPromiseReject(writer, stream._storedError);
      writer._closedPromise.catch(function () {});
    }
  }
  function WritableStreamUpdateBackpressure(stream, backpressure) {
    assert(stream._state === 'writable');
    assert(WritableStreamCloseQueuedOrInFlight(stream) === false);
    var writer = stream._writer;
    if (writer !== undefined && backpressure !== stream._backpressure) {
      if (backpressure === true) {
        defaultWriterReadyPromiseReset(writer);
      } else {
        assert(backpressure === false);
        defaultWriterReadyPromiseResolve(writer);
      }
    }
    stream._backpressure = backpressure;
  }
  var WritableStreamDefaultWriter = function () {
    function WritableStreamDefaultWriter(stream) {
      _classCallCheck(this, WritableStreamDefaultWriter);
      if (IsWritableStream(stream) === false) {
        throw new TypeError('WritableStreamDefaultWriter can only be constructed with a WritableStream instance');
      }
      if (IsWritableStreamLocked(stream) === true) {
        throw new TypeError('This stream has already been locked for exclusive writing by another writer');
      }
      this._ownerWritableStream = stream;
      stream._writer = this;
      var state = stream._state;
      if (state === 'writable') {
        if (WritableStreamCloseQueuedOrInFlight(stream) === false && stream._backpressure === true) {
          defaultWriterReadyPromiseInitialize(this);
        } else {
          defaultWriterReadyPromiseInitializeAsResolved(this);
        }
        defaultWriterClosedPromiseInitialize(this);
      } else if (state === 'erroring') {
        defaultWriterReadyPromiseInitializeAsRejected(this, stream._storedError);
        this._readyPromise.catch(function () {});
        defaultWriterClosedPromiseInitialize(this);
      } else if (state === 'closed') {
        defaultWriterReadyPromiseInitializeAsResolved(this);
        defaultWriterClosedPromiseInitializeAsResolved(this);
      } else {
        assert(state === 'errored', 'state must be errored');
        var storedError = stream._storedError;
        defaultWriterReadyPromiseInitializeAsRejected(this, storedError);
        this._readyPromise.catch(function () {});
        defaultWriterClosedPromiseInitializeAsRejected(this, storedError);
        this._closedPromise.catch(function () {});
      }
    }
    _createClass(WritableStreamDefaultWriter, [{
      key: 'abort',
      value: function abort(reason) {
        if (IsWritableStreamDefaultWriter(this) === false) {
          return Promise.reject(defaultWriterBrandCheckException('abort'));
        }
        if (this._ownerWritableStream === undefined) {
          return Promise.reject(defaultWriterLockException('abort'));
        }
        return WritableStreamDefaultWriterAbort(this, reason);
      }
    }, {
      key: 'close',
      value: function close() {
        if (IsWritableStreamDefaultWriter(this) === false) {
          return Promise.reject(defaultWriterBrandCheckException('close'));
        }
        var stream = this._ownerWritableStream;
        if (stream === undefined) {
          return Promise.reject(defaultWriterLockException('close'));
        }
        if (WritableStreamCloseQueuedOrInFlight(stream) === true) {
          return Promise.reject(new TypeError('cannot close an already-closing stream'));
        }
        return WritableStreamDefaultWriterClose(this);
      }
    }, {
      key: 'releaseLock',
      value: function releaseLock() {
        if (IsWritableStreamDefaultWriter(this) === false) {
          throw defaultWriterBrandCheckException('releaseLock');
        }
        var stream = this._ownerWritableStream;
        if (stream === undefined) {
          return;
        }
        assert(stream._writer !== undefined);
        WritableStreamDefaultWriterRelease(this);
      }
    }, {
      key: 'write',
      value: function write(chunk) {
        if (IsWritableStreamDefaultWriter(this) === false) {
          return Promise.reject(defaultWriterBrandCheckException('write'));
        }
        if (this._ownerWritableStream === undefined) {
          return Promise.reject(defaultWriterLockException('write to'));
        }
        return WritableStreamDefaultWriterWrite(this, chunk);
      }
    }, {
      key: 'closed',
      get: function get() {
        if (IsWritableStreamDefaultWriter(this) === false) {
          return Promise.reject(defaultWriterBrandCheckException('closed'));
        }
        return this._closedPromise;
      }
    }, {
      key: 'desiredSize',
      get: function get() {
        if (IsWritableStreamDefaultWriter(this) === false) {
          throw defaultWriterBrandCheckException('desiredSize');
        }
        if (this._ownerWritableStream === undefined) {
          throw defaultWriterLockException('desiredSize');
        }
        return WritableStreamDefaultWriterGetDesiredSize(this);
      }
    }, {
      key: 'ready',
      get: function get() {
        if (IsWritableStreamDefaultWriter(this) === false) {
          return Promise.reject(defaultWriterBrandCheckException('ready'));
        }
        return this._readyPromise;
      }
    }]);
    return WritableStreamDefaultWriter;
  }();
  function IsWritableStreamDefaultWriter(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_ownerWritableStream')) {
      return false;
    }
    return true;
  }
  function WritableStreamDefaultWriterAbort(writer, reason) {
    var stream = writer._ownerWritableStream;
    assert(stream !== undefined);
    return WritableStreamAbort(stream, reason);
  }
  function WritableStreamDefaultWriterClose(writer) {
    var stream = writer._ownerWritableStream;
    assert(stream !== undefined);
    var state = stream._state;
    if (state === 'closed' || state === 'errored') {
      return Promise.reject(new TypeError('The stream (in ' + state + ' state) is not in the writable state and cannot be closed'));
    }
    assert(state === 'writable' || state === 'erroring');
    assert(WritableStreamCloseQueuedOrInFlight(stream) === false);
    var promise = new Promise(function (resolve, reject) {
      var closeRequest = {
        _resolve: resolve,
        _reject: reject
      };
      stream._closeRequest = closeRequest;
    });
    if (stream._backpressure === true && state === 'writable') {
      defaultWriterReadyPromiseResolve(writer);
    }
    WritableStreamDefaultControllerClose(stream._writableStreamController);
    return promise;
  }
  function WritableStreamDefaultWriterCloseWithErrorPropagation(writer) {
    var stream = writer._ownerWritableStream;
    assert(stream !== undefined);
    var state = stream._state;
    if (WritableStreamCloseQueuedOrInFlight(stream) === true || state === 'closed') {
      return Promise.resolve();
    }
    if (state === 'errored') {
      return Promise.reject(stream._storedError);
    }
    assert(state === 'writable' || state === 'erroring');
    return WritableStreamDefaultWriterClose(writer);
  }
  function WritableStreamDefaultWriterEnsureClosedPromiseRejected(writer, error) {
    if (writer._closedPromiseState === 'pending') {
      defaultWriterClosedPromiseReject(writer, error);
    } else {
      defaultWriterClosedPromiseResetToRejected(writer, error);
    }
    writer._closedPromise.catch(function () {});
  }
  function WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, error) {
    if (writer._readyPromiseState === 'pending') {
      defaultWriterReadyPromiseReject(writer, error);
    } else {
      defaultWriterReadyPromiseResetToRejected(writer, error);
    }
    writer._readyPromise.catch(function () {});
  }
  function WritableStreamDefaultWriterGetDesiredSize(writer) {
    var stream = writer._ownerWritableStream;
    var state = stream._state;
    if (state === 'errored' || state === 'erroring') {
      return null;
    }
    if (state === 'closed') {
      return 0;
    }
    return WritableStreamDefaultControllerGetDesiredSize(stream._writableStreamController);
  }
  function WritableStreamDefaultWriterRelease(writer) {
    var stream = writer._ownerWritableStream;
    assert(stream !== undefined);
    assert(stream._writer === writer);
    var releasedError = new TypeError('Writer was released and can no longer be used to monitor the stream\'s closedness');
    WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, releasedError);
    WritableStreamDefaultWriterEnsureClosedPromiseRejected(writer, releasedError);
    stream._writer = undefined;
    writer._ownerWritableStream = undefined;
  }
  function WritableStreamDefaultWriterWrite(writer, chunk) {
    var stream = writer._ownerWritableStream;
    assert(stream !== undefined);
    var controller = stream._writableStreamController;
    var chunkSize = WritableStreamDefaultControllerGetChunkSize(controller, chunk);
    if (stream !== writer._ownerWritableStream) {
      return Promise.reject(defaultWriterLockException('write to'));
    }
    var state = stream._state;
    if (state === 'errored') {
      return Promise.reject(stream._storedError);
    }
    if (WritableStreamCloseQueuedOrInFlight(stream) === true || state === 'closed') {
      return Promise.reject(new TypeError('The stream is closing or closed and cannot be written to'));
    }
    if (state === 'erroring') {
      return Promise.reject(stream._storedError);
    }
    assert(state === 'writable');
    var promise = WritableStreamAddWriteRequest(stream);
    WritableStreamDefaultControllerWrite(controller, chunk, chunkSize);
    return promise;
  }
  var WritableStreamDefaultController = function () {
    function WritableStreamDefaultController(stream, underlyingSink, size, highWaterMark) {
      _classCallCheck(this, WritableStreamDefaultController);
      if (IsWritableStream(stream) === false) {
        throw new TypeError('WritableStreamDefaultController can only be constructed with a WritableStream instance');
      }
      if (stream._writableStreamController !== undefined) {
        throw new TypeError('WritableStreamDefaultController instances can only be created by the WritableStream constructor');
      }
      this._controlledWritableStream = stream;
      this._underlyingSink = underlyingSink;
      this._queue = undefined;
      this._queueTotalSize = undefined;
      ResetQueue(this);
      this._started = false;
      var normalizedStrategy = ValidateAndNormalizeQueuingStrategy(size, highWaterMark);
      this._strategySize = normalizedStrategy.size;
      this._strategyHWM = normalizedStrategy.highWaterMark;
      var backpressure = WritableStreamDefaultControllerGetBackpressure(this);
      WritableStreamUpdateBackpressure(stream, backpressure);
    }
    _createClass(WritableStreamDefaultController, [{
      key: 'error',
      value: function error(e) {
        if (IsWritableStreamDefaultController(this) === false) {
          throw new TypeError('WritableStreamDefaultController.prototype.error can only be used on a WritableStreamDefaultController');
        }
        var state = this._controlledWritableStream._state;
        if (state !== 'writable') {
          return;
        }
        WritableStreamDefaultControllerError(this, e);
      }
    }, {
      key: '__abortSteps',
      value: function __abortSteps(reason) {
        return PromiseInvokeOrNoop(this._underlyingSink, 'abort', [reason]);
      }
    }, {
      key: '__errorSteps',
      value: function __errorSteps() {
        ResetQueue(this);
      }
    }, {
      key: '__startSteps',
      value: function __startSteps() {
        var _this = this;
        var startResult = InvokeOrNoop(this._underlyingSink, 'start', [this]);
        var stream = this._controlledWritableStream;
        Promise.resolve(startResult).then(function () {
          assert(stream._state === 'writable' || stream._state === 'erroring');
          _this._started = true;
          WritableStreamDefaultControllerAdvanceQueueIfNeeded(_this);
        }, function (r) {
          assert(stream._state === 'writable' || stream._state === 'erroring');
          _this._started = true;
          WritableStreamDealWithRejection(stream, r);
        }).catch(rethrowAssertionErrorRejection);
      }
    }]);
    return WritableStreamDefaultController;
  }();
  function WritableStreamDefaultControllerClose(controller) {
    EnqueueValueWithSize(controller, 'close', 0);
    WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
  }
  function WritableStreamDefaultControllerGetChunkSize(controller, chunk) {
    var strategySize = controller._strategySize;
    if (strategySize === undefined) {
      return 1;
    }
    try {
      return strategySize(chunk);
    } catch (chunkSizeE) {
      WritableStreamDefaultControllerErrorIfNeeded(controller, chunkSizeE);
      return 1;
    }
  }
  function WritableStreamDefaultControllerGetDesiredSize(controller) {
    return controller._strategyHWM - controller._queueTotalSize;
  }
  function WritableStreamDefaultControllerWrite(controller, chunk, chunkSize) {
    var writeRecord = { chunk: chunk };
    try {
      EnqueueValueWithSize(controller, writeRecord, chunkSize);
    } catch (enqueueE) {
      WritableStreamDefaultControllerErrorIfNeeded(controller, enqueueE);
      return;
    }
    var stream = controller._controlledWritableStream;
    if (WritableStreamCloseQueuedOrInFlight(stream) === false && stream._state === 'writable') {
      var backpressure = WritableStreamDefaultControllerGetBackpressure(controller);
      WritableStreamUpdateBackpressure(stream, backpressure);
    }
    WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
  }
  function IsWritableStreamDefaultController(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_underlyingSink')) {
      return false;
    }
    return true;
  }
  function WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller) {
    var stream = controller._controlledWritableStream;
    if (controller._started === false) {
      return;
    }
    if (stream._inFlightWriteRequest !== undefined) {
      return;
    }
    var state = stream._state;
    if (state === 'closed' || state === 'errored') {
      return;
    }
    if (state === 'erroring') {
      WritableStreamFinishErroring(stream);
      return;
    }
    if (controller._queue.length === 0) {
      return;
    }
    var writeRecord = PeekQueueValue(controller);
    if (writeRecord === 'close') {
      WritableStreamDefaultControllerProcessClose(controller);
    } else {
      WritableStreamDefaultControllerProcessWrite(controller, writeRecord.chunk);
    }
  }
  function WritableStreamDefaultControllerErrorIfNeeded(controller, error) {
    if (controller._controlledWritableStream._state === 'writable') {
      WritableStreamDefaultControllerError(controller, error);
    }
  }
  function WritableStreamDefaultControllerProcessClose(controller) {
    var stream = controller._controlledWritableStream;
    WritableStreamMarkCloseRequestInFlight(stream);
    DequeueValue(controller);
    assert(controller._queue.length === 0, 'queue must be empty once the final write record is dequeued');
    var sinkClosePromise = PromiseInvokeOrNoop(controller._underlyingSink, 'close', []);
    sinkClosePromise.then(function () {
      WritableStreamFinishInFlightClose(stream);
    }, function (reason) {
      WritableStreamFinishInFlightCloseWithError(stream, reason);
    }).catch(rethrowAssertionErrorRejection);
  }
  function WritableStreamDefaultControllerProcessWrite(controller, chunk) {
    var stream = controller._controlledWritableStream;
    WritableStreamMarkFirstWriteRequestInFlight(stream);
    var sinkWritePromise = PromiseInvokeOrNoop(controller._underlyingSink, 'write', [chunk, controller]);
    sinkWritePromise.then(function () {
      WritableStreamFinishInFlightWrite(stream);
      var state = stream._state;
      assert(state === 'writable' || state === 'erroring');
      DequeueValue(controller);
      if (WritableStreamCloseQueuedOrInFlight(stream) === false && state === 'writable') {
        var backpressure = WritableStreamDefaultControllerGetBackpressure(controller);
        WritableStreamUpdateBackpressure(stream, backpressure);
      }
      WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
    }, function (reason) {
      WritableStreamFinishInFlightWriteWithError(stream, reason);
    }).catch(rethrowAssertionErrorRejection);
  }
  function WritableStreamDefaultControllerGetBackpressure(controller) {
    var desiredSize = WritableStreamDefaultControllerGetDesiredSize(controller);
    return desiredSize <= 0;
  }
  function WritableStreamDefaultControllerError(controller, error) {
    var stream = controller._controlledWritableStream;
    assert(stream._state === 'writable');
    WritableStreamStartErroring(stream, error);
  }
  function streamBrandCheckException(name) {
    return new TypeError('WritableStream.prototype.' + name + ' can only be used on a WritableStream');
  }
  function defaultWriterBrandCheckException(name) {
    return new TypeError('WritableStreamDefaultWriter.prototype.' + name + ' can only be used on a WritableStreamDefaultWriter');
  }
  function defaultWriterLockException(name) {
    return new TypeError('Cannot ' + name + ' a stream using a released writer');
  }
  function defaultWriterClosedPromiseInitialize(writer) {
    writer._closedPromise = new Promise(function (resolve, reject) {
      writer._closedPromise_resolve = resolve;
      writer._closedPromise_reject = reject;
      writer._closedPromiseState = 'pending';
    });
  }
  function defaultWriterClosedPromiseInitializeAsRejected(writer, reason) {
    writer._closedPromise = Promise.reject(reason);
    writer._closedPromise_resolve = undefined;
    writer._closedPromise_reject = undefined;
    writer._closedPromiseState = 'rejected';
  }
  function defaultWriterClosedPromiseInitializeAsResolved(writer) {
    writer._closedPromise = Promise.resolve(undefined);
    writer._closedPromise_resolve = undefined;
    writer._closedPromise_reject = undefined;
    writer._closedPromiseState = 'resolved';
  }
  function defaultWriterClosedPromiseReject(writer, reason) {
    assert(writer._closedPromise_resolve !== undefined, 'writer._closedPromise_resolve !== undefined');
    assert(writer._closedPromise_reject !== undefined, 'writer._closedPromise_reject !== undefined');
    assert(writer._closedPromiseState === 'pending', 'writer._closedPromiseState is pending');
    writer._closedPromise_reject(reason);
    writer._closedPromise_resolve = undefined;
    writer._closedPromise_reject = undefined;
    writer._closedPromiseState = 'rejected';
  }
  function defaultWriterClosedPromiseResetToRejected(writer, reason) {
    assert(writer._closedPromise_resolve === undefined, 'writer._closedPromise_resolve === undefined');
    assert(writer._closedPromise_reject === undefined, 'writer._closedPromise_reject === undefined');
    assert(writer._closedPromiseState !== 'pending', 'writer._closedPromiseState is not pending');
    writer._closedPromise = Promise.reject(reason);
    writer._closedPromiseState = 'rejected';
  }
  function defaultWriterClosedPromiseResolve(writer) {
    assert(writer._closedPromise_resolve !== undefined, 'writer._closedPromise_resolve !== undefined');
    assert(writer._closedPromise_reject !== undefined, 'writer._closedPromise_reject !== undefined');
    assert(writer._closedPromiseState === 'pending', 'writer._closedPromiseState is pending');
    writer._closedPromise_resolve(undefined);
    writer._closedPromise_resolve = undefined;
    writer._closedPromise_reject = undefined;
    writer._closedPromiseState = 'resolved';
  }
  function defaultWriterReadyPromiseInitialize(writer) {
    writer._readyPromise = new Promise(function (resolve, reject) {
      writer._readyPromise_resolve = resolve;
      writer._readyPromise_reject = reject;
    });
    writer._readyPromiseState = 'pending';
  }
  function defaultWriterReadyPromiseInitializeAsRejected(writer, reason) {
    writer._readyPromise = Promise.reject(reason);
    writer._readyPromise_resolve = undefined;
    writer._readyPromise_reject = undefined;
    writer._readyPromiseState = 'rejected';
  }
  function defaultWriterReadyPromiseInitializeAsResolved(writer) {
    writer._readyPromise = Promise.resolve(undefined);
    writer._readyPromise_resolve = undefined;
    writer._readyPromise_reject = undefined;
    writer._readyPromiseState = 'fulfilled';
  }
  function defaultWriterReadyPromiseReject(writer, reason) {
    assert(writer._readyPromise_resolve !== undefined, 'writer._readyPromise_resolve !== undefined');
    assert(writer._readyPromise_reject !== undefined, 'writer._readyPromise_reject !== undefined');
    writer._readyPromise_reject(reason);
    writer._readyPromise_resolve = undefined;
    writer._readyPromise_reject = undefined;
    writer._readyPromiseState = 'rejected';
  }
  function defaultWriterReadyPromiseReset(writer) {
    assert(writer._readyPromise_resolve === undefined, 'writer._readyPromise_resolve === undefined');
    assert(writer._readyPromise_reject === undefined, 'writer._readyPromise_reject === undefined');
    writer._readyPromise = new Promise(function (resolve, reject) {
      writer._readyPromise_resolve = resolve;
      writer._readyPromise_reject = reject;
    });
    writer._readyPromiseState = 'pending';
  }
  function defaultWriterReadyPromiseResetToRejected(writer, reason) {
    assert(writer._readyPromise_resolve === undefined, 'writer._readyPromise_resolve === undefined');
    assert(writer._readyPromise_reject === undefined, 'writer._readyPromise_reject === undefined');
    writer._readyPromise = Promise.reject(reason);
    writer._readyPromiseState = 'rejected';
  }
  function defaultWriterReadyPromiseResolve(writer) {
    assert(writer._readyPromise_resolve !== undefined, 'writer._readyPromise_resolve !== undefined');
    assert(writer._readyPromise_reject !== undefined, 'writer._readyPromise_reject !== undefined');
    writer._readyPromise_resolve(undefined);
    writer._readyPromise_resolve = undefined;
    writer._readyPromise_reject = undefined;
    writer._readyPromiseState = 'fulfilled';
  }
}, function (module, exports, __w_pdfjs_require__) {
  "use strict";

  var _require = __w_pdfjs_require__(0),
      IsFiniteNonNegativeNumber = _require.IsFiniteNonNegativeNumber;
  var _require2 = __w_pdfjs_require__(1),
      assert = _require2.assert;
  exports.DequeueValue = function (container) {
    assert('_queue' in container && '_queueTotalSize' in container, 'Spec-level failure: DequeueValue should only be used on containers with [[queue]] and [[queueTotalSize]].');
    assert(container._queue.length > 0, 'Spec-level failure: should never dequeue from an empty queue.');
    var pair = container._queue.shift();
    container._queueTotalSize -= pair.size;
    if (container._queueTotalSize < 0) {
      container._queueTotalSize = 0;
    }
    return pair.value;
  };
  exports.EnqueueValueWithSize = function (container, value, size) {
    assert('_queue' in container && '_queueTotalSize' in container, 'Spec-level failure: EnqueueValueWithSize should only be used on containers with [[queue]] and ' + '[[queueTotalSize]].');
    size = Number(size);
    if (!IsFiniteNonNegativeNumber(size)) {
      throw new RangeError('Size must be a finite, non-NaN, non-negative number.');
    }
    container._queue.push({
      value: value,
      size: size
    });
    container._queueTotalSize += size;
  };
  exports.PeekQueueValue = function (container) {
    assert('_queue' in container && '_queueTotalSize' in container, 'Spec-level failure: PeekQueueValue should only be used on containers with [[queue]] and [[queueTotalSize]].');
    assert(container._queue.length > 0, 'Spec-level failure: should never peek at an empty queue.');
    var pair = container._queue[0];
    return pair.value;
  };
  exports.ResetQueue = function (container) {
    assert('_queue' in container && '_queueTotalSize' in container, 'Spec-level failure: ResetQueue should only be used on containers with [[queue]] and [[queueTotalSize]].');
    container._queue = [];
    container._queueTotalSize = 0;
  };
}, function (module, exports, __w_pdfjs_require__) {
  "use strict";

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var _require = __w_pdfjs_require__(0),
      ArrayBufferCopy = _require.ArrayBufferCopy,
      CreateIterResultObject = _require.CreateIterResultObject,
      IsFiniteNonNegativeNumber = _require.IsFiniteNonNegativeNumber,
      InvokeOrNoop = _require.InvokeOrNoop,
      PromiseInvokeOrNoop = _require.PromiseInvokeOrNoop,
      TransferArrayBuffer = _require.TransferArrayBuffer,
      ValidateAndNormalizeQueuingStrategy = _require.ValidateAndNormalizeQueuingStrategy,
      ValidateAndNormalizeHighWaterMark = _require.ValidateAndNormalizeHighWaterMark;
  var _require2 = __w_pdfjs_require__(0),
      createArrayFromList = _require2.createArrayFromList,
      createDataProperty = _require2.createDataProperty,
      typeIsObject = _require2.typeIsObject;
  var _require3 = __w_pdfjs_require__(1),
      assert = _require3.assert,
      rethrowAssertionErrorRejection = _require3.rethrowAssertionErrorRejection;
  var _require4 = __w_pdfjs_require__(3),
      DequeueValue = _require4.DequeueValue,
      EnqueueValueWithSize = _require4.EnqueueValueWithSize,
      ResetQueue = _require4.ResetQueue;
  var _require5 = __w_pdfjs_require__(2),
      AcquireWritableStreamDefaultWriter = _require5.AcquireWritableStreamDefaultWriter,
      IsWritableStream = _require5.IsWritableStream,
      IsWritableStreamLocked = _require5.IsWritableStreamLocked,
      WritableStreamAbort = _require5.WritableStreamAbort,
      WritableStreamDefaultWriterCloseWithErrorPropagation = _require5.WritableStreamDefaultWriterCloseWithErrorPropagation,
      WritableStreamDefaultWriterRelease = _require5.WritableStreamDefaultWriterRelease,
      WritableStreamDefaultWriterWrite = _require5.WritableStreamDefaultWriterWrite,
      WritableStreamCloseQueuedOrInFlight = _require5.WritableStreamCloseQueuedOrInFlight;
  var ReadableStream = function () {
    function ReadableStream() {
      var underlyingSource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          size = _ref.size,
          highWaterMark = _ref.highWaterMark;
      _classCallCheck(this, ReadableStream);
      this._state = 'readable';
      this._reader = undefined;
      this._storedError = undefined;
      this._disturbed = false;
      this._readableStreamController = undefined;
      var type = underlyingSource.type;
      var typeString = String(type);
      if (typeString === 'bytes') {
        if (highWaterMark === undefined) {
          highWaterMark = 0;
        }
        this._readableStreamController = new ReadableByteStreamController(this, underlyingSource, highWaterMark);
      } else if (type === undefined) {
        if (highWaterMark === undefined) {
          highWaterMark = 1;
        }
        this._readableStreamController = new ReadableStreamDefaultController(this, underlyingSource, size, highWaterMark);
      } else {
        throw new RangeError('Invalid type is specified');
      }
    }
    _createClass(ReadableStream, [{
      key: 'cancel',
      value: function cancel(reason) {
        if (IsReadableStream(this) === false) {
          return Promise.reject(streamBrandCheckException('cancel'));
        }
        if (IsReadableStreamLocked(this) === true) {
          return Promise.reject(new TypeError('Cannot cancel a stream that already has a reader'));
        }
        return ReadableStreamCancel(this, reason);
      }
    }, {
      key: 'getReader',
      value: function getReader() {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            mode = _ref2.mode;
        if (IsReadableStream(this) === false) {
          throw streamBrandCheckException('getReader');
        }
        if (mode === undefined) {
          return AcquireReadableStreamDefaultReader(this);
        }
        mode = String(mode);
        if (mode === 'byob') {
          return AcquireReadableStreamBYOBReader(this);
        }
        throw new RangeError('Invalid mode is specified');
      }
    }, {
      key: 'pipeThrough',
      value: function pipeThrough(_ref3, options) {
        var writable = _ref3.writable,
            readable = _ref3.readable;
        var promise = this.pipeTo(writable, options);
        ifIsObjectAndHasAPromiseIsHandledInternalSlotSetPromiseIsHandledToTrue(promise);
        return readable;
      }
    }, {
      key: 'pipeTo',
      value: function pipeTo(dest) {
        var _this = this;
        var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            preventClose = _ref4.preventClose,
            preventAbort = _ref4.preventAbort,
            preventCancel = _ref4.preventCancel;
        if (IsReadableStream(this) === false) {
          return Promise.reject(streamBrandCheckException('pipeTo'));
        }
        if (IsWritableStream(dest) === false) {
          return Promise.reject(new TypeError('ReadableStream.prototype.pipeTo\'s first argument must be a WritableStream'));
        }
        preventClose = Boolean(preventClose);
        preventAbort = Boolean(preventAbort);
        preventCancel = Boolean(preventCancel);
        if (IsReadableStreamLocked(this) === true) {
          return Promise.reject(new TypeError('ReadableStream.prototype.pipeTo cannot be used on a locked ReadableStream'));
        }
        if (IsWritableStreamLocked(dest) === true) {
          return Promise.reject(new TypeError('ReadableStream.prototype.pipeTo cannot be used on a locked WritableStream'));
        }
        var reader = AcquireReadableStreamDefaultReader(this);
        var writer = AcquireWritableStreamDefaultWriter(dest);
        var shuttingDown = false;
        var currentWrite = Promise.resolve();
        return new Promise(function (resolve, reject) {
          function pipeLoop() {
            currentWrite = Promise.resolve();
            if (shuttingDown === true) {
              return Promise.resolve();
            }
            return writer._readyPromise.then(function () {
              return ReadableStreamDefaultReaderRead(reader).then(function (_ref5) {
                var value = _ref5.value,
                    done = _ref5.done;
                if (done === true) {
                  return;
                }
                currentWrite = WritableStreamDefaultWriterWrite(writer, value).catch(function () {});
              });
            }).then(pipeLoop);
          }
          isOrBecomesErrored(_this, reader._closedPromise, function (storedError) {
            if (preventAbort === false) {
              shutdownWithAction(function () {
                return WritableStreamAbort(dest, storedError);
              }, true, storedError);
            } else {
              shutdown(true, storedError);
            }
          });
          isOrBecomesErrored(dest, writer._closedPromise, function (storedError) {
            if (preventCancel === false) {
              shutdownWithAction(function () {
                return ReadableStreamCancel(_this, storedError);
              }, true, storedError);
            } else {
              shutdown(true, storedError);
            }
          });
          isOrBecomesClosed(_this, reader._closedPromise, function () {
            if (preventClose === false) {
              shutdownWithAction(function () {
                return WritableStreamDefaultWriterCloseWithErrorPropagation(writer);
              });
            } else {
              shutdown();
            }
          });
          if (WritableStreamCloseQueuedOrInFlight(dest) === true || dest._state === 'closed') {
            var destClosed = new TypeError('the destination writable stream closed before all data could be piped to it');
            if (preventCancel === false) {
              shutdownWithAction(function () {
                return ReadableStreamCancel(_this, destClosed);
              }, true, destClosed);
            } else {
              shutdown(true, destClosed);
            }
          }
          pipeLoop().catch(function (err) {
            currentWrite = Promise.resolve();
            rethrowAssertionErrorRejection(err);
          });
          function waitForWritesToFinish() {
            var oldCurrentWrite = currentWrite;
            return currentWrite.then(function () {
              return oldCurrentWrite !== currentWrite ? waitForWritesToFinish() : undefined;
            });
          }
          function isOrBecomesErrored(stream, promise, action) {
            if (stream._state === 'errored') {
              action(stream._storedError);
            } else {
              promise.catch(action).catch(rethrowAssertionErrorRejection);
            }
          }
          function isOrBecomesClosed(stream, promise, action) {
            if (stream._state === 'closed') {
              action();
            } else {
              promise.then(action).catch(rethrowAssertionErrorRejection);
            }
          }
          function shutdownWithAction(action, originalIsError, originalError) {
            if (shuttingDown === true) {
              return;
            }
            shuttingDown = true;
            if (dest._state === 'writable' && WritableStreamCloseQueuedOrInFlight(dest) === false) {
              waitForWritesToFinish().then(doTheRest);
            } else {
              doTheRest();
            }
            function doTheRest() {
              action().then(function () {
                return finalize(originalIsError, originalError);
              }, function (newError) {
                return finalize(true, newError);
              }).catch(rethrowAssertionErrorRejection);
            }
          }
          function shutdown(isError, error) {
            if (shuttingDown === true) {
              return;
            }
            shuttingDown = true;
            if (dest._state === 'writable' && WritableStreamCloseQueuedOrInFlight(dest) === false) {
              waitForWritesToFinish().then(function () {
                return finalize(isError, error);
              }).catch(rethrowAssertionErrorRejection);
            } else {
              finalize(isError, error);
            }
          }
          function finalize(isError, error) {
            WritableStreamDefaultWriterRelease(writer);
            ReadableStreamReaderGenericRelease(reader);
            if (isError) {
              reject(error);
            } else {
              resolve(undefined);
            }
          }
        });
      }
    }, {
      key: 'tee',
      value: function tee() {
        if (IsReadableStream(this) === false) {
          throw streamBrandCheckException('tee');
        }
        var branches = ReadableStreamTee(this, false);
        return createArrayFromList(branches);
      }
    }, {
      key: 'locked',
      get: function get() {
        if (IsReadableStream(this) === false) {
          throw streamBrandCheckException('locked');
        }
        return IsReadableStreamLocked(this);
      }
    }]);
    return ReadableStream;
  }();
  module.exports = {
    ReadableStream: ReadableStream,
    IsReadableStreamDisturbed: IsReadableStreamDisturbed,
    ReadableStreamDefaultControllerClose: ReadableStreamDefaultControllerClose,
    ReadableStreamDefaultControllerEnqueue: ReadableStreamDefaultControllerEnqueue,
    ReadableStreamDefaultControllerError: ReadableStreamDefaultControllerError,
    ReadableStreamDefaultControllerGetDesiredSize: ReadableStreamDefaultControllerGetDesiredSize
  };
  function AcquireReadableStreamBYOBReader(stream) {
    return new ReadableStreamBYOBReader(stream);
  }
  function AcquireReadableStreamDefaultReader(stream) {
    return new ReadableStreamDefaultReader(stream);
  }
  function IsReadableStream(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_readableStreamController')) {
      return false;
    }
    return true;
  }
  function IsReadableStreamDisturbed(stream) {
    assert(IsReadableStream(stream) === true, 'IsReadableStreamDisturbed should only be used on known readable streams');
    return stream._disturbed;
  }
  function IsReadableStreamLocked(stream) {
    assert(IsReadableStream(stream) === true, 'IsReadableStreamLocked should only be used on known readable streams');
    if (stream._reader === undefined) {
      return false;
    }
    return true;
  }
  function ReadableStreamTee(stream, cloneForBranch2) {
    assert(IsReadableStream(stream) === true);
    assert(typeof cloneForBranch2 === 'boolean');
    var reader = AcquireReadableStreamDefaultReader(stream);
    var teeState = {
      closedOrErrored: false,
      canceled1: false,
      canceled2: false,
      reason1: undefined,
      reason2: undefined
    };
    teeState.promise = new Promise(function (resolve) {
      teeState._resolve = resolve;
    });
    var pull = create_ReadableStreamTeePullFunction();
    pull._reader = reader;
    pull._teeState = teeState;
    pull._cloneForBranch2 = cloneForBranch2;
    var cancel1 = create_ReadableStreamTeeBranch1CancelFunction();
    cancel1._stream = stream;
    cancel1._teeState = teeState;
    var cancel2 = create_ReadableStreamTeeBranch2CancelFunction();
    cancel2._stream = stream;
    cancel2._teeState = teeState;
    var underlyingSource1 = Object.create(Object.prototype);
    createDataProperty(underlyingSource1, 'pull', pull);
    createDataProperty(underlyingSource1, 'cancel', cancel1);
    var branch1Stream = new ReadableStream(underlyingSource1);
    var underlyingSource2 = Object.create(Object.prototype);
    createDataProperty(underlyingSource2, 'pull', pull);
    createDataProperty(underlyingSource2, 'cancel', cancel2);
    var branch2Stream = new ReadableStream(underlyingSource2);
    pull._branch1 = branch1Stream._readableStreamController;
    pull._branch2 = branch2Stream._readableStreamController;
    reader._closedPromise.catch(function (r) {
      if (teeState.closedOrErrored === true) {
        return;
      }
      ReadableStreamDefaultControllerError(pull._branch1, r);
      ReadableStreamDefaultControllerError(pull._branch2, r);
      teeState.closedOrErrored = true;
    });
    return [branch1Stream, branch2Stream];
  }
  function create_ReadableStreamTeePullFunction() {
    function f() {
      var reader = f._reader,
          branch1 = f._branch1,
          branch2 = f._branch2,
          teeState = f._teeState;
      return ReadableStreamDefaultReaderRead(reader).then(function (result) {
        assert(typeIsObject(result));
        var value = result.value;
        var done = result.done;
        assert(typeof done === 'boolean');
        if (done === true && teeState.closedOrErrored === false) {
          if (teeState.canceled1 === false) {
            ReadableStreamDefaultControllerClose(branch1);
          }
          if (teeState.canceled2 === false) {
            ReadableStreamDefaultControllerClose(branch2);
          }
          teeState.closedOrErrored = true;
        }
        if (teeState.closedOrErrored === true) {
          return;
        }
        var value1 = value;
        var value2 = value;
        if (teeState.canceled1 === false) {
          ReadableStreamDefaultControllerEnqueue(branch1, value1);
        }
        if (teeState.canceled2 === false) {
          ReadableStreamDefaultControllerEnqueue(branch2, value2);
        }
      });
    }
    return f;
  }
  function create_ReadableStreamTeeBranch1CancelFunction() {
    function f(reason) {
      var stream = f._stream,
          teeState = f._teeState;
      teeState.canceled1 = true;
      teeState.reason1 = reason;
      if (teeState.canceled2 === true) {
        var compositeReason = createArrayFromList([teeState.reason1, teeState.reason2]);
        var cancelResult = ReadableStreamCancel(stream, compositeReason);
        teeState._resolve(cancelResult);
      }
      return teeState.promise;
    }
    return f;
  }
  function create_ReadableStreamTeeBranch2CancelFunction() {
    function f(reason) {
      var stream = f._stream,
          teeState = f._teeState;
      teeState.canceled2 = true;
      teeState.reason2 = reason;
      if (teeState.canceled1 === true) {
        var compositeReason = createArrayFromList([teeState.reason1, teeState.reason2]);
        var cancelResult = ReadableStreamCancel(stream, compositeReason);
        teeState._resolve(cancelResult);
      }
      return teeState.promise;
    }
    return f;
  }
  function ReadableStreamAddReadIntoRequest(stream) {
    assert(IsReadableStreamBYOBReader(stream._reader) === true);
    assert(stream._state === 'readable' || stream._state === 'closed');
    var promise = new Promise(function (resolve, reject) {
      var readIntoRequest = {
        _resolve: resolve,
        _reject: reject
      };
      stream._reader._readIntoRequests.push(readIntoRequest);
    });
    return promise;
  }
  function ReadableStreamAddReadRequest(stream) {
    assert(IsReadableStreamDefaultReader(stream._reader) === true);
    assert(stream._state === 'readable');
    var promise = new Promise(function (resolve, reject) {
      var readRequest = {
        _resolve: resolve,
        _reject: reject
      };
      stream._reader._readRequests.push(readRequest);
    });
    return promise;
  }
  function ReadableStreamCancel(stream, reason) {
    stream._disturbed = true;
    if (stream._state === 'closed') {
      return Promise.resolve(undefined);
    }
    if (stream._state === 'errored') {
      return Promise.reject(stream._storedError);
    }
    ReadableStreamClose(stream);
    var sourceCancelPromise = stream._readableStreamController.__cancelSteps(reason);
    return sourceCancelPromise.then(function () {
      return undefined;
    });
  }
  function ReadableStreamClose(stream) {
    assert(stream._state === 'readable');
    stream._state = 'closed';
    var reader = stream._reader;
    if (reader === undefined) {
      return undefined;
    }
    if (IsReadableStreamDefaultReader(reader) === true) {
      for (var i = 0; i < reader._readRequests.length; i++) {
        var _resolve = reader._readRequests[i]._resolve;
        _resolve(CreateIterResultObject(undefined, true));
      }
      reader._readRequests = [];
    }
    defaultReaderClosedPromiseResolve(reader);
    return undefined;
  }
  function ReadableStreamError(stream, e) {
    assert(IsReadableStream(stream) === true, 'stream must be ReadableStream');
    assert(stream._state === 'readable', 'state must be readable');
    stream._state = 'errored';
    stream._storedError = e;
    var reader = stream._reader;
    if (reader === undefined) {
      return undefined;
    }
    if (IsReadableStreamDefaultReader(reader) === true) {
      for (var i = 0; i < reader._readRequests.length; i++) {
        var readRequest = reader._readRequests[i];
        readRequest._reject(e);
      }
      reader._readRequests = [];
    } else {
      assert(IsReadableStreamBYOBReader(reader), 'reader must be ReadableStreamBYOBReader');
      for (var _i = 0; _i < reader._readIntoRequests.length; _i++) {
        var readIntoRequest = reader._readIntoRequests[_i];
        readIntoRequest._reject(e);
      }
      reader._readIntoRequests = [];
    }
    defaultReaderClosedPromiseReject(reader, e);
    reader._closedPromise.catch(function () {});
  }
  function ReadableStreamFulfillReadIntoRequest(stream, chunk, done) {
    var reader = stream._reader;
    assert(reader._readIntoRequests.length > 0);
    var readIntoRequest = reader._readIntoRequests.shift();
    readIntoRequest._resolve(CreateIterResultObject(chunk, done));
  }
  function ReadableStreamFulfillReadRequest(stream, chunk, done) {
    var reader = stream._reader;
    assert(reader._readRequests.length > 0);
    var readRequest = reader._readRequests.shift();
    readRequest._resolve(CreateIterResultObject(chunk, done));
  }
  function ReadableStreamGetNumReadIntoRequests(stream) {
    return stream._reader._readIntoRequests.length;
  }
  function ReadableStreamGetNumReadRequests(stream) {
    return stream._reader._readRequests.length;
  }
  function ReadableStreamHasBYOBReader(stream) {
    var reader = stream._reader;
    if (reader === undefined) {
      return false;
    }
    if (IsReadableStreamBYOBReader(reader) === false) {
      return false;
    }
    return true;
  }
  function ReadableStreamHasDefaultReader(stream) {
    var reader = stream._reader;
    if (reader === undefined) {
      return false;
    }
    if (IsReadableStreamDefaultReader(reader) === false) {
      return false;
    }
    return true;
  }
  var ReadableStreamDefaultReader = function () {
    function ReadableStreamDefaultReader(stream) {
      _classCallCheck(this, ReadableStreamDefaultReader);
      if (IsReadableStream(stream) === false) {
        throw new TypeError('ReadableStreamDefaultReader can only be constructed with a ReadableStream instance');
      }
      if (IsReadableStreamLocked(stream) === true) {
        throw new TypeError('This stream has already been locked for exclusive reading by another reader');
      }
      ReadableStreamReaderGenericInitialize(this, stream);
      this._readRequests = [];
    }
    _createClass(ReadableStreamDefaultReader, [{
      key: 'cancel',
      value: function cancel(reason) {
        if (IsReadableStreamDefaultReader(this) === false) {
          return Promise.reject(defaultReaderBrandCheckException('cancel'));
        }
        if (this._ownerReadableStream === undefined) {
          return Promise.reject(readerLockException('cancel'));
        }
        return ReadableStreamReaderGenericCancel(this, reason);
      }
    }, {
      key: 'read',
      value: function read() {
        if (IsReadableStreamDefaultReader(this) === false) {
          return Promise.reject(defaultReaderBrandCheckException('read'));
        }
        if (this._ownerReadableStream === undefined) {
          return Promise.reject(readerLockException('read from'));
        }
        return ReadableStreamDefaultReaderRead(this);
      }
    }, {
      key: 'releaseLock',
      value: function releaseLock() {
        if (IsReadableStreamDefaultReader(this) === false) {
          throw defaultReaderBrandCheckException('releaseLock');
        }
        if (this._ownerReadableStream === undefined) {
          return;
        }
        if (this._readRequests.length > 0) {
          throw new TypeError('Tried to release a reader lock when that reader has pending read() calls un-settled');
        }
        ReadableStreamReaderGenericRelease(this);
      }
    }, {
      key: 'closed',
      get: function get() {
        if (IsReadableStreamDefaultReader(this) === false) {
          return Promise.reject(defaultReaderBrandCheckException('closed'));
        }
        return this._closedPromise;
      }
    }]);
    return ReadableStreamDefaultReader;
  }();
  var ReadableStreamBYOBReader = function () {
    function ReadableStreamBYOBReader(stream) {
      _classCallCheck(this, ReadableStreamBYOBReader);
      if (!IsReadableStream(stream)) {
        throw new TypeError('ReadableStreamBYOBReader can only be constructed with a ReadableStream instance given a ' + 'byte source');
      }
      if (IsReadableByteStreamController(stream._readableStreamController) === false) {
        throw new TypeError('Cannot construct a ReadableStreamBYOBReader for a stream not constructed with a byte ' + 'source');
      }
      if (IsReadableStreamLocked(stream)) {
        throw new TypeError('This stream has already been locked for exclusive reading by another reader');
      }
      ReadableStreamReaderGenericInitialize(this, stream);
      this._readIntoRequests = [];
    }
    _createClass(ReadableStreamBYOBReader, [{
      key: 'cancel',
      value: function cancel(reason) {
        if (!IsReadableStreamBYOBReader(this)) {
          return Promise.reject(byobReaderBrandCheckException('cancel'));
        }
        if (this._ownerReadableStream === undefined) {
          return Promise.reject(readerLockException('cancel'));
        }
        return ReadableStreamReaderGenericCancel(this, reason);
      }
    }, {
      key: 'read',
      value: function read(view) {
        if (!IsReadableStreamBYOBReader(this)) {
          return Promise.reject(byobReaderBrandCheckException('read'));
        }
        if (this._ownerReadableStream === undefined) {
          return Promise.reject(readerLockException('read from'));
        }
        if (!ArrayBuffer.isView(view)) {
          return Promise.reject(new TypeError('view must be an array buffer view'));
        }
        if (view.byteLength === 0) {
          return Promise.reject(new TypeError('view must have non-zero byteLength'));
        }
        return ReadableStreamBYOBReaderRead(this, view);
      }
    }, {
      key: 'releaseLock',
      value: function releaseLock() {
        if (!IsReadableStreamBYOBReader(this)) {
          throw byobReaderBrandCheckException('releaseLock');
        }
        if (this._ownerReadableStream === undefined) {
          return;
        }
        if (this._readIntoRequests.length > 0) {
          throw new TypeError('Tried to release a reader lock when that reader has pending read() calls un-settled');
        }
        ReadableStreamReaderGenericRelease(this);
      }
    }, {
      key: 'closed',
      get: function get() {
        if (!IsReadableStreamBYOBReader(this)) {
          return Promise.reject(byobReaderBrandCheckException('closed'));
        }
        return this._closedPromise;
      }
    }]);
    return ReadableStreamBYOBReader;
  }();
  function IsReadableStreamBYOBReader(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_readIntoRequests')) {
      return false;
    }
    return true;
  }
  function IsReadableStreamDefaultReader(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_readRequests')) {
      return false;
    }
    return true;
  }
  function ReadableStreamReaderGenericInitialize(reader, stream) {
    reader._ownerReadableStream = stream;
    stream._reader = reader;
    if (stream._state === 'readable') {
      defaultReaderClosedPromiseInitialize(reader);
    } else if (stream._state === 'closed') {
      defaultReaderClosedPromiseInitializeAsResolved(reader);
    } else {
      assert(stream._state === 'errored', 'state must be errored');
      defaultReaderClosedPromiseInitializeAsRejected(reader, stream._storedError);
      reader._closedPromise.catch(function () {});
    }
  }
  function ReadableStreamReaderGenericCancel(reader, reason) {
    var stream = reader._ownerReadableStream;
    assert(stream !== undefined);
    return ReadableStreamCancel(stream, reason);
  }
  function ReadableStreamReaderGenericRelease(reader) {
    assert(reader._ownerReadableStream !== undefined);
    assert(reader._ownerReadableStream._reader === reader);
    if (reader._ownerReadableStream._state === 'readable') {
      defaultReaderClosedPromiseReject(reader, new TypeError('Reader was released and can no longer be used to monitor the stream\'s closedness'));
    } else {
      defaultReaderClosedPromiseResetToRejected(reader, new TypeError('Reader was released and can no longer be used to monitor the stream\'s closedness'));
    }
    reader._closedPromise.catch(function () {});
    reader._ownerReadableStream._reader = undefined;
    reader._ownerReadableStream = undefined;
  }
  function ReadableStreamBYOBReaderRead(reader, view) {
    var stream = reader._ownerReadableStream;
    assert(stream !== undefined);
    stream._disturbed = true;
    if (stream._state === 'errored') {
      return Promise.reject(stream._storedError);
    }
    return ReadableByteStreamControllerPullInto(stream._readableStreamController, view);
  }
  function ReadableStreamDefaultReaderRead(reader) {
    var stream = reader._ownerReadableStream;
    assert(stream !== undefined);
    stream._disturbed = true;
    if (stream._state === 'closed') {
      return Promise.resolve(CreateIterResultObject(undefined, true));
    }
    if (stream._state === 'errored') {
      return Promise.reject(stream._storedError);
    }
    assert(stream._state === 'readable');
    return stream._readableStreamController.__pullSteps();
  }
  var ReadableStreamDefaultController = function () {
    function ReadableStreamDefaultController(stream, underlyingSource, size, highWaterMark) {
      _classCallCheck(this, ReadableStreamDefaultController);
      if (IsReadableStream(stream) === false) {
        throw new TypeError('ReadableStreamDefaultController can only be constructed with a ReadableStream instance');
      }
      if (stream._readableStreamController !== undefined) {
        throw new TypeError('ReadableStreamDefaultController instances can only be created by the ReadableStream constructor');
      }
      this._controlledReadableStream = stream;
      this._underlyingSource = underlyingSource;
      this._queue = undefined;
      this._queueTotalSize = undefined;
      ResetQueue(this);
      this._started = false;
      this._closeRequested = false;
      this._pullAgain = false;
      this._pulling = false;
      var normalizedStrategy = ValidateAndNormalizeQueuingStrategy(size, highWaterMark);
      this._strategySize = normalizedStrategy.size;
      this._strategyHWM = normalizedStrategy.highWaterMark;
      var controller = this;
      var startResult = InvokeOrNoop(underlyingSource, 'start', [this]);
      Promise.resolve(startResult).then(function () {
        controller._started = true;
        assert(controller._pulling === false);
        assert(controller._pullAgain === false);
        ReadableStreamDefaultControllerCallPullIfNeeded(controller);
      }, function (r) {
        ReadableStreamDefaultControllerErrorIfNeeded(controller, r);
      }).catch(rethrowAssertionErrorRejection);
    }
    _createClass(ReadableStreamDefaultController, [{
      key: 'close',
      value: function close() {
        if (IsReadableStreamDefaultController(this) === false) {
          throw defaultControllerBrandCheckException('close');
        }
        if (this._closeRequested === true) {
          throw new TypeError('The stream has already been closed; do not close it again!');
        }
        var state = this._controlledReadableStream._state;
        if (state !== 'readable') {
          throw new TypeError('The stream (in ' + state + ' state) is not in the readable state and cannot be closed');
        }
        ReadableStreamDefaultControllerClose(this);
      }
    }, {
      key: 'enqueue',
      value: function enqueue(chunk) {
        if (IsReadableStreamDefaultController(this) === false) {
          throw defaultControllerBrandCheckException('enqueue');
        }
        if (this._closeRequested === true) {
          throw new TypeError('stream is closed or draining');
        }
        var state = this._controlledReadableStream._state;
        if (state !== 'readable') {
          throw new TypeError('The stream (in ' + state + ' state) is not in the readable state and cannot be enqueued to');
        }
        return ReadableStreamDefaultControllerEnqueue(this, chunk);
      }
    }, {
      key: 'error',
      value: function error(e) {
        if (IsReadableStreamDefaultController(this) === false) {
          throw defaultControllerBrandCheckException('error');
        }
        var stream = this._controlledReadableStream;
        if (stream._state !== 'readable') {
          throw new TypeError('The stream is ' + stream._state + ' and so cannot be errored');
        }
        ReadableStreamDefaultControllerError(this, e);
      }
    }, {
      key: '__cancelSteps',
      value: function __cancelSteps(reason) {
        ResetQueue(this);
        return PromiseInvokeOrNoop(this._underlyingSource, 'cancel', [reason]);
      }
    }, {
      key: '__pullSteps',
      value: function __pullSteps() {
        var stream = this._controlledReadableStream;
        if (this._queue.length > 0) {
          var chunk = DequeueValue(this);
          if (this._closeRequested === true && this._queue.length === 0) {
            ReadableStreamClose(stream);
          } else {
            ReadableStreamDefaultControllerCallPullIfNeeded(this);
          }
          return Promise.resolve(CreateIterResultObject(chunk, false));
        }
        var pendingPromise = ReadableStreamAddReadRequest(stream);
        ReadableStreamDefaultControllerCallPullIfNeeded(this);
        return pendingPromise;
      }
    }, {
      key: 'desiredSize',
      get: function get() {
        if (IsReadableStreamDefaultController(this) === false) {
          throw defaultControllerBrandCheckException('desiredSize');
        }
        return ReadableStreamDefaultControllerGetDesiredSize(this);
      }
    }]);
    return ReadableStreamDefaultController;
  }();
  function IsReadableStreamDefaultController(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_underlyingSource')) {
      return false;
    }
    return true;
  }
  function ReadableStreamDefaultControllerCallPullIfNeeded(controller) {
    var shouldPull = ReadableStreamDefaultControllerShouldCallPull(controller);
    if (shouldPull === false) {
      return undefined;
    }
    if (controller._pulling === true) {
      controller._pullAgain = true;
      return undefined;
    }
    assert(controller._pullAgain === false);
    controller._pulling = true;
    var pullPromise = PromiseInvokeOrNoop(controller._underlyingSource, 'pull', [controller]);
    pullPromise.then(function () {
      controller._pulling = false;
      if (controller._pullAgain === true) {
        controller._pullAgain = false;
        return ReadableStreamDefaultControllerCallPullIfNeeded(controller);
      }
      return undefined;
    }, function (e) {
      ReadableStreamDefaultControllerErrorIfNeeded(controller, e);
    }).catch(rethrowAssertionErrorRejection);
    return undefined;
  }
  function ReadableStreamDefaultControllerShouldCallPull(controller) {
    var stream = controller._controlledReadableStream;
    if (stream._state === 'closed' || stream._state === 'errored') {
      return false;
    }
    if (controller._closeRequested === true) {
      return false;
    }
    if (controller._started === false) {
      return false;
    }
    if (IsReadableStreamLocked(stream) === true && ReadableStreamGetNumReadRequests(stream) > 0) {
      return true;
    }
    var desiredSize = ReadableStreamDefaultControllerGetDesiredSize(controller);
    if (desiredSize > 0) {
      return true;
    }
    return false;
  }
  function ReadableStreamDefaultControllerClose(controller) {
    var stream = controller._controlledReadableStream;
    assert(controller._closeRequested === false);
    assert(stream._state === 'readable');
    controller._closeRequested = true;
    if (controller._queue.length === 0) {
      ReadableStreamClose(stream);
    }
  }
  function ReadableStreamDefaultControllerEnqueue(controller, chunk) {
    var stream = controller._controlledReadableStream;
    assert(controller._closeRequested === false);
    assert(stream._state === 'readable');
    if (IsReadableStreamLocked(stream) === true && ReadableStreamGetNumReadRequests(stream) > 0) {
      ReadableStreamFulfillReadRequest(stream, chunk, false);
    } else {
      var chunkSize = 1;
      if (controller._strategySize !== undefined) {
        var strategySize = controller._strategySize;
        try {
          chunkSize = strategySize(chunk);
        } catch (chunkSizeE) {
          ReadableStreamDefaultControllerErrorIfNeeded(controller, chunkSizeE);
          throw chunkSizeE;
        }
      }
      try {
        EnqueueValueWithSize(controller, chunk, chunkSize);
      } catch (enqueueE) {
        ReadableStreamDefaultControllerErrorIfNeeded(controller, enqueueE);
        throw enqueueE;
      }
    }
    ReadableStreamDefaultControllerCallPullIfNeeded(controller);
    return undefined;
  }
  function ReadableStreamDefaultControllerError(controller, e) {
    var stream = controller._controlledReadableStream;
    assert(stream._state === 'readable');
    ResetQueue(controller);
    ReadableStreamError(stream, e);
  }
  function ReadableStreamDefaultControllerErrorIfNeeded(controller, e) {
    if (controller._controlledReadableStream._state === 'readable') {
      ReadableStreamDefaultControllerError(controller, e);
    }
  }
  function ReadableStreamDefaultControllerGetDesiredSize(controller) {
    var stream = controller._controlledReadableStream;
    var state = stream._state;
    if (state === 'errored') {
      return null;
    }
    if (state === 'closed') {
      return 0;
    }
    return controller._strategyHWM - controller._queueTotalSize;
  }
  var ReadableStreamBYOBRequest = function () {
    function ReadableStreamBYOBRequest(controller, view) {
      _classCallCheck(this, ReadableStreamBYOBRequest);
      this._associatedReadableByteStreamController = controller;
      this._view = view;
    }
    _createClass(ReadableStreamBYOBRequest, [{
      key: 'respond',
      value: function respond(bytesWritten) {
        if (IsReadableStreamBYOBRequest(this) === false) {
          throw byobRequestBrandCheckException('respond');
        }
        if (this._associatedReadableByteStreamController === undefined) {
          throw new TypeError('This BYOB request has been invalidated');
        }
        ReadableByteStreamControllerRespond(this._associatedReadableByteStreamController, bytesWritten);
      }
    }, {
      key: 'respondWithNewView',
      value: function respondWithNewView(view) {
        if (IsReadableStreamBYOBRequest(this) === false) {
          throw byobRequestBrandCheckException('respond');
        }
        if (this._associatedReadableByteStreamController === undefined) {
          throw new TypeError('This BYOB request has been invalidated');
        }
        if (!ArrayBuffer.isView(view)) {
          throw new TypeError('You can only respond with array buffer views');
        }
        ReadableByteStreamControllerRespondWithNewView(this._associatedReadableByteStreamController, view);
      }
    }, {
      key: 'view',
      get: function get() {
        return this._view;
      }
    }]);
    return ReadableStreamBYOBRequest;
  }();
  var ReadableByteStreamController = function () {
    function ReadableByteStreamController(stream, underlyingByteSource, highWaterMark) {
      _classCallCheck(this, ReadableByteStreamController);
      if (IsReadableStream(stream) === false) {
        throw new TypeError('ReadableByteStreamController can only be constructed with a ReadableStream instance given ' + 'a byte source');
      }
      if (stream._readableStreamController !== undefined) {
        throw new TypeError('ReadableByteStreamController instances can only be created by the ReadableStream constructor given a byte ' + 'source');
      }
      this._controlledReadableStream = stream;
      this._underlyingByteSource = underlyingByteSource;
      this._pullAgain = false;
      this._pulling = false;
      ReadableByteStreamControllerClearPendingPullIntos(this);
      this._queue = this._queueTotalSize = undefined;
      ResetQueue(this);
      this._closeRequested = false;
      this._started = false;
      this._strategyHWM = ValidateAndNormalizeHighWaterMark(highWaterMark);
      var autoAllocateChunkSize = underlyingByteSource.autoAllocateChunkSize;
      if (autoAllocateChunkSize !== undefined) {
        if (Number.isInteger(autoAllocateChunkSize) === false || autoAllocateChunkSize <= 0) {
          throw new RangeError('autoAllocateChunkSize must be a positive integer');
        }
      }
      this._autoAllocateChunkSize = autoAllocateChunkSize;
      this._pendingPullIntos = [];
      var controller = this;
      var startResult = InvokeOrNoop(underlyingByteSource, 'start', [this]);
      Promise.resolve(startResult).then(function () {
        controller._started = true;
        assert(controller._pulling === false);
        assert(controller._pullAgain === false);
        ReadableByteStreamControllerCallPullIfNeeded(controller);
      }, function (r) {
        if (stream._state === 'readable') {
          ReadableByteStreamControllerError(controller, r);
        }
      }).catch(rethrowAssertionErrorRejection);
    }
    _createClass(ReadableByteStreamController, [{
      key: 'close',
      value: function close() {
        if (IsReadableByteStreamController(this) === false) {
          throw byteStreamControllerBrandCheckException('close');
        }
        if (this._closeRequested === true) {
          throw new TypeError('The stream has already been closed; do not close it again!');
        }
        var state = this._controlledReadableStream._state;
        if (state !== 'readable') {
          throw new TypeError('The stream (in ' + state + ' state) is not in the readable state and cannot be closed');
        }
        ReadableByteStreamControllerClose(this);
      }
    }, {
      key: 'enqueue',
      value: function enqueue(chunk) {
        if (IsReadableByteStreamController(this) === false) {
          throw byteStreamControllerBrandCheckException('enqueue');
        }
        if (this._closeRequested === true) {
          throw new TypeError('stream is closed or draining');
        }
        var state = this._controlledReadableStream._state;
        if (state !== 'readable') {
          throw new TypeError('The stream (in ' + state + ' state) is not in the readable state and cannot be enqueued to');
        }
        if (!ArrayBuffer.isView(chunk)) {
          throw new TypeError('You can only enqueue array buffer views when using a ReadableByteStreamController');
        }
        ReadableByteStreamControllerEnqueue(this, chunk);
      }
    }, {
      key: 'error',
      value: function error(e) {
        if (IsReadableByteStreamController(this) === false) {
          throw byteStreamControllerBrandCheckException('error');
        }
        var stream = this._controlledReadableStream;
        if (stream._state !== 'readable') {
          throw new TypeError('The stream is ' + stream._state + ' and so cannot be errored');
        }
        ReadableByteStreamControllerError(this, e);
      }
    }, {
      key: '__cancelSteps',
      value: function __cancelSteps(reason) {
        if (this._pendingPullIntos.length > 0) {
          var firstDescriptor = this._pendingPullIntos[0];
          firstDescriptor.bytesFilled = 0;
        }
        ResetQueue(this);
        return PromiseInvokeOrNoop(this._underlyingByteSource, 'cancel', [reason]);
      }
    }, {
      key: '__pullSteps',
      value: function __pullSteps() {
        var stream = this._controlledReadableStream;
        assert(ReadableStreamHasDefaultReader(stream) === true);
        if (this._queueTotalSize > 0) {
          assert(ReadableStreamGetNumReadRequests(stream) === 0);
          var entry = this._queue.shift();
          this._queueTotalSize -= entry.byteLength;
          ReadableByteStreamControllerHandleQueueDrain(this);
          var view = void 0;
          try {
            view = new Uint8Array(entry.buffer, entry.byteOffset, entry.byteLength);
          } catch (viewE) {
            return Promise.reject(viewE);
          }
          return Promise.resolve(CreateIterResultObject(view, false));
        }
        var autoAllocateChunkSize = this._autoAllocateChunkSize;
        if (autoAllocateChunkSize !== undefined) {
          var buffer = void 0;
          try {
            buffer = new ArrayBuffer(autoAllocateChunkSize);
          } catch (bufferE) {
            return Promise.reject(bufferE);
          }
          var pullIntoDescriptor = {
            buffer: buffer,
            byteOffset: 0,
            byteLength: autoAllocateChunkSize,
            bytesFilled: 0,
            elementSize: 1,
            ctor: Uint8Array,
            readerType: 'default'
          };
          this._pendingPullIntos.push(pullIntoDescriptor);
        }
        var promise = ReadableStreamAddReadRequest(stream);
        ReadableByteStreamControllerCallPullIfNeeded(this);
        return promise;
      }
    }, {
      key: 'byobRequest',
      get: function get() {
        if (IsReadableByteStreamController(this) === false) {
          throw byteStreamControllerBrandCheckException('byobRequest');
        }
        if (this._byobRequest === undefined && this._pendingPullIntos.length > 0) {
          var firstDescriptor = this._pendingPullIntos[0];
          var view = new Uint8Array(firstDescriptor.buffer, firstDescriptor.byteOffset + firstDescriptor.bytesFilled, firstDescriptor.byteLength - firstDescriptor.bytesFilled);
          this._byobRequest = new ReadableStreamBYOBRequest(this, view);
        }
        return this._byobRequest;
      }
    }, {
      key: 'desiredSize',
      get: function get() {
        if (IsReadableByteStreamController(this) === false) {
          throw byteStreamControllerBrandCheckException('desiredSize');
        }
        return ReadableByteStreamControllerGetDesiredSize(this);
      }
    }]);
    return ReadableByteStreamController;
  }();
  function IsReadableByteStreamController(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_underlyingByteSource')) {
      return false;
    }
    return true;
  }
  function IsReadableStreamBYOBRequest(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_associatedReadableByteStreamController')) {
      return false;
    }
    return true;
  }
  function ReadableByteStreamControllerCallPullIfNeeded(controller) {
    var shouldPull = ReadableByteStreamControllerShouldCallPull(controller);
    if (shouldPull === false) {
      return undefined;
    }
    if (controller._pulling === true) {
      controller._pullAgain = true;
      return undefined;
    }
    assert(controller._pullAgain === false);
    controller._pulling = true;
    var pullPromise = PromiseInvokeOrNoop(controller._underlyingByteSource, 'pull', [controller]);
    pullPromise.then(function () {
      controller._pulling = false;
      if (controller._pullAgain === true) {
        controller._pullAgain = false;
        ReadableByteStreamControllerCallPullIfNeeded(controller);
      }
    }, function (e) {
      if (controller._controlledReadableStream._state === 'readable') {
        ReadableByteStreamControllerError(controller, e);
      }
    }).catch(rethrowAssertionErrorRejection);
    return undefined;
  }
  function ReadableByteStreamControllerClearPendingPullIntos(controller) {
    ReadableByteStreamControllerInvalidateBYOBRequest(controller);
    controller._pendingPullIntos = [];
  }
  function ReadableByteStreamControllerCommitPullIntoDescriptor(stream, pullIntoDescriptor) {
    assert(stream._state !== 'errored', 'state must not be errored');
    var done = false;
    if (stream._state === 'closed') {
      assert(pullIntoDescriptor.bytesFilled === 0);
      done = true;
    }
    var filledView = ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor);
    if (pullIntoDescriptor.readerType === 'default') {
      ReadableStreamFulfillReadRequest(stream, filledView, done);
    } else {
      assert(pullIntoDescriptor.readerType === 'byob');
      ReadableStreamFulfillReadIntoRequest(stream, filledView, done);
    }
  }
  function ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor) {
    var bytesFilled = pullIntoDescriptor.bytesFilled;
    var elementSize = pullIntoDescriptor.elementSize;
    assert(bytesFilled <= pullIntoDescriptor.byteLength);
    assert(bytesFilled % elementSize === 0);
    return new pullIntoDescriptor.ctor(pullIntoDescriptor.buffer, pullIntoDescriptor.byteOffset, bytesFilled / elementSize);
  }
  function ReadableByteStreamControllerEnqueueChunkToQueue(controller, buffer, byteOffset, byteLength) {
    controller._queue.push({
      buffer: buffer,
      byteOffset: byteOffset,
      byteLength: byteLength
    });
    controller._queueTotalSize += byteLength;
  }
  function ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor) {
    var elementSize = pullIntoDescriptor.elementSize;
    var currentAlignedBytes = pullIntoDescriptor.bytesFilled - pullIntoDescriptor.bytesFilled % elementSize;
    var maxBytesToCopy = Math.min(controller._queueTotalSize, pullIntoDescriptor.byteLength - pullIntoDescriptor.bytesFilled);
    var maxBytesFilled = pullIntoDescriptor.bytesFilled + maxBytesToCopy;
    var maxAlignedBytes = maxBytesFilled - maxBytesFilled % elementSize;
    var totalBytesToCopyRemaining = maxBytesToCopy;
    var ready = false;
    if (maxAlignedBytes > currentAlignedBytes) {
      totalBytesToCopyRemaining = maxAlignedBytes - pullIntoDescriptor.bytesFilled;
      ready = true;
    }
    var queue = controller._queue;
    while (totalBytesToCopyRemaining > 0) {
      var headOfQueue = queue[0];
      var bytesToCopy = Math.min(totalBytesToCopyRemaining, headOfQueue.byteLength);
      var destStart = pullIntoDescriptor.byteOffset + pullIntoDescriptor.bytesFilled;
      ArrayBufferCopy(pullIntoDescriptor.buffer, destStart, headOfQueue.buffer, headOfQueue.byteOffset, bytesToCopy);
      if (headOfQueue.byteLength === bytesToCopy) {
        queue.shift();
      } else {
        headOfQueue.byteOffset += bytesToCopy;
        headOfQueue.byteLength -= bytesToCopy;
      }
      controller._queueTotalSize -= bytesToCopy;
      ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, bytesToCopy, pullIntoDescriptor);
      totalBytesToCopyRemaining -= bytesToCopy;
    }
    if (ready === false) {
      assert(controller._queueTotalSize === 0, 'queue must be empty');
      assert(pullIntoDescriptor.bytesFilled > 0);
      assert(pullIntoDescriptor.bytesFilled < pullIntoDescriptor.elementSize);
    }
    return ready;
  }
  function ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, size, pullIntoDescriptor) {
    assert(controller._pendingPullIntos.length === 0 || controller._pendingPullIntos[0] === pullIntoDescriptor);
    ReadableByteStreamControllerInvalidateBYOBRequest(controller);
    pullIntoDescriptor.bytesFilled += size;
  }
  function ReadableByteStreamControllerHandleQueueDrain(controller) {
    assert(controller._controlledReadableStream._state === 'readable');
    if (controller._queueTotalSize === 0 && controller._closeRequested === true) {
      ReadableStreamClose(controller._controlledReadableStream);
    } else {
      ReadableByteStreamControllerCallPullIfNeeded(controller);
    }
  }
  function ReadableByteStreamControllerInvalidateBYOBRequest(controller) {
    if (controller._byobRequest === undefined) {
      return;
    }
    controller._byobRequest._associatedReadableByteStreamController = undefined;
    controller._byobRequest._view = undefined;
    controller._byobRequest = undefined;
  }
  function ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller) {
    assert(controller._closeRequested === false);
    while (controller._pendingPullIntos.length > 0) {
      if (controller._queueTotalSize === 0) {
        return;
      }
      var pullIntoDescriptor = controller._pendingPullIntos[0];
      if (ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor) === true) {
        ReadableByteStreamControllerShiftPendingPullInto(controller);
        ReadableByteStreamControllerCommitPullIntoDescriptor(controller._controlledReadableStream, pullIntoDescriptor);
      }
    }
  }
  function ReadableByteStreamControllerPullInto(controller, view) {
    var stream = controller._controlledReadableStream;
    var elementSize = 1;
    if (view.constructor !== DataView) {
      elementSize = view.constructor.BYTES_PER_ELEMENT;
    }
    var ctor = view.constructor;
    var pullIntoDescriptor = {
      buffer: view.buffer,
      byteOffset: view.byteOffset,
      byteLength: view.byteLength,
      bytesFilled: 0,
      elementSize: elementSize,
      ctor: ctor,
      readerType: 'byob'
    };
    if (controller._pendingPullIntos.length > 0) {
      pullIntoDescriptor.buffer = TransferArrayBuffer(pullIntoDescriptor.buffer);
      controller._pendingPullIntos.push(pullIntoDescriptor);
      return ReadableStreamAddReadIntoRequest(stream);
    }
    if (stream._state === 'closed') {
      var emptyView = new view.constructor(pullIntoDescriptor.buffer, pullIntoDescriptor.byteOffset, 0);
      return Promise.resolve(CreateIterResultObject(emptyView, true));
    }
    if (controller._queueTotalSize > 0) {
      if (ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor) === true) {
        var filledView = ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor);
        ReadableByteStreamControllerHandleQueueDrain(controller);
        return Promise.resolve(CreateIterResultObject(filledView, false));
      }
      if (controller._closeRequested === true) {
        var e = new TypeError('Insufficient bytes to fill elements in the given buffer');
        ReadableByteStreamControllerError(controller, e);
        return Promise.reject(e);
      }
    }
    pullIntoDescriptor.buffer = TransferArrayBuffer(pullIntoDescriptor.buffer);
    controller._pendingPullIntos.push(pullIntoDescriptor);
    var promise = ReadableStreamAddReadIntoRequest(stream);
    ReadableByteStreamControllerCallPullIfNeeded(controller);
    return promise;
  }
  function ReadableByteStreamControllerRespondInClosedState(controller, firstDescriptor) {
    firstDescriptor.buffer = TransferArrayBuffer(firstDescriptor.buffer);
    assert(firstDescriptor.bytesFilled === 0, 'bytesFilled must be 0');
    var stream = controller._controlledReadableStream;
    if (ReadableStreamHasBYOBReader(stream) === true) {
      while (ReadableStreamGetNumReadIntoRequests(stream) > 0) {
        var pullIntoDescriptor = ReadableByteStreamControllerShiftPendingPullInto(controller);
        ReadableByteStreamControllerCommitPullIntoDescriptor(stream, pullIntoDescriptor);
      }
    }
  }
  function ReadableByteStreamControllerRespondInReadableState(controller, bytesWritten, pullIntoDescriptor) {
    if (pullIntoDescriptor.bytesFilled + bytesWritten > pullIntoDescriptor.byteLength) {
      throw new RangeError('bytesWritten out of range');
    }
    ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, bytesWritten, pullIntoDescriptor);
    if (pullIntoDescriptor.bytesFilled < pullIntoDescriptor.elementSize) {
      return;
    }
    ReadableByteStreamControllerShiftPendingPullInto(controller);
    var remainderSize = pullIntoDescriptor.bytesFilled % pullIntoDescriptor.elementSize;
    if (remainderSize > 0) {
      var end = pullIntoDescriptor.byteOffset + pullIntoDescriptor.bytesFilled;
      var remainder = pullIntoDescriptor.buffer.slice(end - remainderSize, end);
      ReadableByteStreamControllerEnqueueChunkToQueue(controller, remainder, 0, remainder.byteLength);
    }
    pullIntoDescriptor.buffer = TransferArrayBuffer(pullIntoDescriptor.buffer);
    pullIntoDescriptor.bytesFilled -= remainderSize;
    ReadableByteStreamControllerCommitPullIntoDescriptor(controller._controlledReadableStream, pullIntoDescriptor);
    ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller);
  }
  function ReadableByteStreamControllerRespondInternal(controller, bytesWritten) {
    var firstDescriptor = controller._pendingPullIntos[0];
    var stream = controller._controlledReadableStream;
    if (stream._state === 'closed') {
      if (bytesWritten !== 0) {
        throw new TypeError('bytesWritten must be 0 when calling respond() on a closed stream');
      }
      ReadableByteStreamControllerRespondInClosedState(controller, firstDescriptor);
    } else {
      assert(stream._state === 'readable');
      ReadableByteStreamControllerRespondInReadableState(controller, bytesWritten, firstDescriptor);
    }
  }
  function ReadableByteStreamControllerShiftPendingPullInto(controller) {
    var descriptor = controller._pendingPullIntos.shift();
    ReadableByteStreamControllerInvalidateBYOBRequest(controller);
    return descriptor;
  }
  function ReadableByteStreamControllerShouldCallPull(controller) {
    var stream = controller._controlledReadableStream;
    if (stream._state !== 'readable') {
      return false;
    }
    if (controller._closeRequested === true) {
      return false;
    }
    if (controller._started === false) {
      return false;
    }
    if (ReadableStreamHasDefaultReader(stream) === true && ReadableStreamGetNumReadRequests(stream) > 0) {
      return true;
    }
    if (ReadableStreamHasBYOBReader(stream) === true && ReadableStreamGetNumReadIntoRequests(stream) > 0) {
      return true;
    }
    if (ReadableByteStreamControllerGetDesiredSize(controller) > 0) {
      return true;
    }
    return false;
  }
  function ReadableByteStreamControllerClose(controller) {
    var stream = controller._controlledReadableStream;
    assert(controller._closeRequested === false);
    assert(stream._state === 'readable');
    if (controller._queueTotalSize > 0) {
      controller._closeRequested = true;
      return;
    }
    if (controller._pendingPullIntos.length > 0) {
      var firstPendingPullInto = controller._pendingPullIntos[0];
      if (firstPendingPullInto.bytesFilled > 0) {
        var e = new TypeError('Insufficient bytes to fill elements in the given buffer');
        ReadableByteStreamControllerError(controller, e);
        throw e;
      }
    }
    ReadableStreamClose(stream);
  }
  function ReadableByteStreamControllerEnqueue(controller, chunk) {
    var stream = controller._controlledReadableStream;
    assert(controller._closeRequested === false);
    assert(stream._state === 'readable');
    var buffer = chunk.buffer;
    var byteOffset = chunk.byteOffset;
    var byteLength = chunk.byteLength;
    var transferredBuffer = TransferArrayBuffer(buffer);
    if (ReadableStreamHasDefaultReader(stream) === true) {
      if (ReadableStreamGetNumReadRequests(stream) === 0) {
        ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength);
      } else {
        assert(controller._queue.length === 0);
        var transferredView = new Uint8Array(transferredBuffer, byteOffset, byteLength);
        ReadableStreamFulfillReadRequest(stream, transferredView, false);
      }
    } else if (ReadableStreamHasBYOBReader(stream) === true) {
      ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength);
      ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller);
    } else {
      assert(IsReadableStreamLocked(stream) === false, 'stream must not be locked');
      ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength);
    }
  }
  function ReadableByteStreamControllerError(controller, e) {
    var stream = controller._controlledReadableStream;
    assert(stream._state === 'readable');
    ReadableByteStreamControllerClearPendingPullIntos(controller);
    ResetQueue(controller);
    ReadableStreamError(stream, e);
  }
  function ReadableByteStreamControllerGetDesiredSize(controller) {
    var stream = controller._controlledReadableStream;
    var state = stream._state;
    if (state === 'errored') {
      return null;
    }
    if (state === 'closed') {
      return 0;
    }
    return controller._strategyHWM - controller._queueTotalSize;
  }
  function ReadableByteStreamControllerRespond(controller, bytesWritten) {
    bytesWritten = Number(bytesWritten);
    if (IsFiniteNonNegativeNumber(bytesWritten) === false) {
      throw new RangeError('bytesWritten must be a finite');
    }
    assert(controller._pendingPullIntos.length > 0);
    ReadableByteStreamControllerRespondInternal(controller, bytesWritten);
  }
  function ReadableByteStreamControllerRespondWithNewView(controller, view) {
    assert(controller._pendingPullIntos.length > 0);
    var firstDescriptor = controller._pendingPullIntos[0];
    if (firstDescriptor.byteOffset + firstDescriptor.bytesFilled !== view.byteOffset) {
      throw new RangeError('The region specified by view does not match byobRequest');
    }
    if (firstDescriptor.byteLength !== view.byteLength) {
      throw new RangeError('The buffer of view has different capacity than byobRequest');
    }
    firstDescriptor.buffer = view.buffer;
    ReadableByteStreamControllerRespondInternal(controller, view.byteLength);
  }
  function streamBrandCheckException(name) {
    return new TypeError('ReadableStream.prototype.' + name + ' can only be used on a ReadableStream');
  }
  function readerLockException(name) {
    return new TypeError('Cannot ' + name + ' a stream using a released reader');
  }
  function defaultReaderBrandCheckException(name) {
    return new TypeError('ReadableStreamDefaultReader.prototype.' + name + ' can only be used on a ReadableStreamDefaultReader');
  }
  function defaultReaderClosedPromiseInitialize(reader) {
    reader._closedPromise = new Promise(function (resolve, reject) {
      reader._closedPromise_resolve = resolve;
      reader._closedPromise_reject = reject;
    });
  }
  function defaultReaderClosedPromiseInitializeAsRejected(reader, reason) {
    reader._closedPromise = Promise.reject(reason);
    reader._closedPromise_resolve = undefined;
    reader._closedPromise_reject = undefined;
  }
  function defaultReaderClosedPromiseInitializeAsResolved(reader) {
    reader._closedPromise = Promise.resolve(undefined);
    reader._closedPromise_resolve = undefined;
    reader._closedPromise_reject = undefined;
  }
  function defaultReaderClosedPromiseReject(reader, reason) {
    assert(reader._closedPromise_resolve !== undefined);
    assert(reader._closedPromise_reject !== undefined);
    reader._closedPromise_reject(reason);
    reader._closedPromise_resolve = undefined;
    reader._closedPromise_reject = undefined;
  }
  function defaultReaderClosedPromiseResetToRejected(reader, reason) {
    assert(reader._closedPromise_resolve === undefined);
    assert(reader._closedPromise_reject === undefined);
    reader._closedPromise = Promise.reject(reason);
  }
  function defaultReaderClosedPromiseResolve(reader) {
    assert(reader._closedPromise_resolve !== undefined);
    assert(reader._closedPromise_reject !== undefined);
    reader._closedPromise_resolve(undefined);
    reader._closedPromise_resolve = undefined;
    reader._closedPromise_reject = undefined;
  }
  function byobReaderBrandCheckException(name) {
    return new TypeError('ReadableStreamBYOBReader.prototype.' + name + ' can only be used on a ReadableStreamBYOBReader');
  }
  function defaultControllerBrandCheckException(name) {
    return new TypeError('ReadableStreamDefaultController.prototype.' + name + ' can only be used on a ReadableStreamDefaultController');
  }
  function byobRequestBrandCheckException(name) {
    return new TypeError('ReadableStreamBYOBRequest.prototype.' + name + ' can only be used on a ReadableStreamBYOBRequest');
  }
  function byteStreamControllerBrandCheckException(name) {
    return new TypeError('ReadableByteStreamController.prototype.' + name + ' can only be used on a ReadableByteStreamController');
  }
  function ifIsObjectAndHasAPromiseIsHandledInternalSlotSetPromiseIsHandledToTrue(promise) {
    try {
      Promise.prototype.then.call(promise, undefined, function () {});
    } catch (e) {}
  }
}, function (module, exports, __w_pdfjs_require__) {
  "use strict";

  var transformStream = __w_pdfjs_require__(6);
  var readableStream = __w_pdfjs_require__(4);
  var writableStream = __w_pdfjs_require__(2);
  exports.TransformStream = transformStream.TransformStream;
  exports.ReadableStream = readableStream.ReadableStream;
  exports.IsReadableStreamDisturbed = readableStream.IsReadableStreamDisturbed;
  exports.ReadableStreamDefaultControllerClose = readableStream.ReadableStreamDefaultControllerClose;
  exports.ReadableStreamDefaultControllerEnqueue = readableStream.ReadableStreamDefaultControllerEnqueue;
  exports.ReadableStreamDefaultControllerError = readableStream.ReadableStreamDefaultControllerError;
  exports.ReadableStreamDefaultControllerGetDesiredSize = readableStream.ReadableStreamDefaultControllerGetDesiredSize;
  exports.AcquireWritableStreamDefaultWriter = writableStream.AcquireWritableStreamDefaultWriter;
  exports.IsWritableStream = writableStream.IsWritableStream;
  exports.IsWritableStreamLocked = writableStream.IsWritableStreamLocked;
  exports.WritableStream = writableStream.WritableStream;
  exports.WritableStreamAbort = writableStream.WritableStreamAbort;
  exports.WritableStreamDefaultControllerError = writableStream.WritableStreamDefaultControllerError;
  exports.WritableStreamDefaultWriterCloseWithErrorPropagation = writableStream.WritableStreamDefaultWriterCloseWithErrorPropagation;
  exports.WritableStreamDefaultWriterRelease = writableStream.WritableStreamDefaultWriterRelease;
  exports.WritableStreamDefaultWriterWrite = writableStream.WritableStreamDefaultWriterWrite;
}, function (module, exports, __w_pdfjs_require__) {
  "use strict";

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var _require = __w_pdfjs_require__(1),
      assert = _require.assert;
  var _require2 = __w_pdfjs_require__(0),
      InvokeOrNoop = _require2.InvokeOrNoop,
      PromiseInvokeOrPerformFallback = _require2.PromiseInvokeOrPerformFallback,
      PromiseInvokeOrNoop = _require2.PromiseInvokeOrNoop,
      typeIsObject = _require2.typeIsObject;
  var _require3 = __w_pdfjs_require__(4),
      ReadableStream = _require3.ReadableStream,
      ReadableStreamDefaultControllerClose = _require3.ReadableStreamDefaultControllerClose,
      ReadableStreamDefaultControllerEnqueue = _require3.ReadableStreamDefaultControllerEnqueue,
      ReadableStreamDefaultControllerError = _require3.ReadableStreamDefaultControllerError,
      ReadableStreamDefaultControllerGetDesiredSize = _require3.ReadableStreamDefaultControllerGetDesiredSize;
  var _require4 = __w_pdfjs_require__(2),
      WritableStream = _require4.WritableStream,
      WritableStreamDefaultControllerError = _require4.WritableStreamDefaultControllerError;
  function TransformStreamCloseReadable(transformStream) {
    if (transformStream._errored === true) {
      throw new TypeError('TransformStream is already errored');
    }
    if (transformStream._readableClosed === true) {
      throw new TypeError('Readable side is already closed');
    }
    TransformStreamCloseReadableInternal(transformStream);
  }
  function TransformStreamEnqueueToReadable(transformStream, chunk) {
    if (transformStream._errored === true) {
      throw new TypeError('TransformStream is already errored');
    }
    if (transformStream._readableClosed === true) {
      throw new TypeError('Readable side is already closed');
    }
    var controller = transformStream._readableController;
    try {
      ReadableStreamDefaultControllerEnqueue(controller, chunk);
    } catch (e) {
      transformStream._readableClosed = true;
      TransformStreamErrorIfNeeded(transformStream, e);
      throw transformStream._storedError;
    }
    var desiredSize = ReadableStreamDefaultControllerGetDesiredSize(controller);
    var maybeBackpressure = desiredSize <= 0;
    if (maybeBackpressure === true && transformStream._backpressure === false) {
      TransformStreamSetBackpressure(transformStream, true);
    }
  }
  function TransformStreamError(transformStream, e) {
    if (transformStream._errored === true) {
      throw new TypeError('TransformStream is already errored');
    }
    TransformStreamErrorInternal(transformStream, e);
  }
  function TransformStreamCloseReadableInternal(transformStream) {
    assert(transformStream._errored === false);
    assert(transformStream._readableClosed === false);
    try {
      ReadableStreamDefaultControllerClose(transformStream._readableController);
    } catch (e) {
      assert(false);
    }
    transformStream._readableClosed = true;
  }
  function TransformStreamErrorIfNeeded(transformStream, e) {
    if (transformStream._errored === false) {
      TransformStreamErrorInternal(transformStream, e);
    }
  }
  function TransformStreamErrorInternal(transformStream, e) {
    assert(transformStream._errored === false);
    transformStream._errored = true;
    transformStream._storedError = e;
    if (transformStream._writableDone === false) {
      WritableStreamDefaultControllerError(transformStream._writableController, e);
    }
    if (transformStream._readableClosed === false) {
      ReadableStreamDefaultControllerError(transformStream._readableController, e);
    }
  }
  function TransformStreamReadableReadyPromise(transformStream) {
    assert(transformStream._backpressureChangePromise !== undefined, '_backpressureChangePromise should have been initialized');
    if (transformStream._backpressure === false) {
      return Promise.resolve();
    }
    assert(transformStream._backpressure === true, '_backpressure should have been initialized');
    return transformStream._backpressureChangePromise;
  }
  function TransformStreamSetBackpressure(transformStream, backpressure) {
    assert(transformStream._backpressure !== backpressure, 'TransformStreamSetBackpressure() should be called only when backpressure is changed');
    if (transformStream._backpressureChangePromise !== undefined) {
      transformStream._backpressureChangePromise_resolve(backpressure);
    }
    transformStream._backpressureChangePromise = new Promise(function (resolve) {
      transformStream._backpressureChangePromise_resolve = resolve;
    });
    transformStream._backpressureChangePromise.then(function (resolution) {
      assert(resolution !== backpressure, '_backpressureChangePromise should be fulfilled only when backpressure is changed');
    });
    transformStream._backpressure = backpressure;
  }
  function TransformStreamDefaultTransform(chunk, transformStreamController) {
    var transformStream = transformStreamController._controlledTransformStream;
    TransformStreamEnqueueToReadable(transformStream, chunk);
    return Promise.resolve();
  }
  function TransformStreamTransform(transformStream, chunk) {
    assert(transformStream._errored === false);
    assert(transformStream._transforming === false);
    assert(transformStream._backpressure === false);
    transformStream._transforming = true;
    var transformer = transformStream._transformer;
    var controller = transformStream._transformStreamController;
    var transformPromise = PromiseInvokeOrPerformFallback(transformer, 'transform', [chunk, controller], TransformStreamDefaultTransform, [chunk, controller]);
    return transformPromise.then(function () {
      transformStream._transforming = false;
      return TransformStreamReadableReadyPromise(transformStream);
    }, function (e) {
      TransformStreamErrorIfNeeded(transformStream, e);
      return Promise.reject(e);
    });
  }
  function IsTransformStreamDefaultController(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_controlledTransformStream')) {
      return false;
    }
    return true;
  }
  function IsTransformStream(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_transformStreamController')) {
      return false;
    }
    return true;
  }
  var TransformStreamSink = function () {
    function TransformStreamSink(transformStream, startPromise) {
      _classCallCheck(this, TransformStreamSink);
      this._transformStream = transformStream;
      this._startPromise = startPromise;
    }
    _createClass(TransformStreamSink, [{
      key: 'start',
      value: function start(c) {
        var transformStream = this._transformStream;
        transformStream._writableController = c;
        return this._startPromise.then(function () {
          return TransformStreamReadableReadyPromise(transformStream);
        });
      }
    }, {
      key: 'write',
      value: function write(chunk) {
        var transformStream = this._transformStream;
        return TransformStreamTransform(transformStream, chunk);
      }
    }, {
      key: 'abort',
      value: function abort() {
        var transformStream = this._transformStream;
        transformStream._writableDone = true;
        TransformStreamErrorInternal(transformStream, new TypeError('Writable side aborted'));
      }
    }, {
      key: 'close',
      value: function close() {
        var transformStream = this._transformStream;
        assert(transformStream._transforming === false);
        transformStream._writableDone = true;
        var flushPromise = PromiseInvokeOrNoop(transformStream._transformer, 'flush', [transformStream._transformStreamController]);
        return flushPromise.then(function () {
          if (transformStream._errored === true) {
            return Promise.reject(transformStream._storedError);
          }
          if (transformStream._readableClosed === false) {
            TransformStreamCloseReadableInternal(transformStream);
          }
          return Promise.resolve();
        }).catch(function (r) {
          TransformStreamErrorIfNeeded(transformStream, r);
          return Promise.reject(transformStream._storedError);
        });
      }
    }]);
    return TransformStreamSink;
  }();
  var TransformStreamSource = function () {
    function TransformStreamSource(transformStream, startPromise) {
      _classCallCheck(this, TransformStreamSource);
      this._transformStream = transformStream;
      this._startPromise = startPromise;
    }
    _createClass(TransformStreamSource, [{
      key: 'start',
      value: function start(c) {
        var transformStream = this._transformStream;
        transformStream._readableController = c;
        return this._startPromise.then(function () {
          assert(transformStream._backpressureChangePromise !== undefined, '_backpressureChangePromise should have been initialized');
          if (transformStream._backpressure === true) {
            return Promise.resolve();
          }
          assert(transformStream._backpressure === false, '_backpressure should have been initialized');
          return transformStream._backpressureChangePromise;
        });
      }
    }, {
      key: 'pull',
      value: function pull() {
        var transformStream = this._transformStream;
        assert(transformStream._backpressure === true, 'pull() should be never called while _backpressure is false');
        assert(transformStream._backpressureChangePromise !== undefined, '_backpressureChangePromise should have been initialized');
        TransformStreamSetBackpressure(transformStream, false);
        return transformStream._backpressureChangePromise;
      }
    }, {
      key: 'cancel',
      value: function cancel() {
        var transformStream = this._transformStream;
        transformStream._readableClosed = true;
        TransformStreamErrorInternal(transformStream, new TypeError('Readable side canceled'));
      }
    }]);
    return TransformStreamSource;
  }();
  var TransformStreamDefaultController = function () {
    function TransformStreamDefaultController(transformStream) {
      _classCallCheck(this, TransformStreamDefaultController);
      if (IsTransformStream(transformStream) === false) {
        throw new TypeError('TransformStreamDefaultController can only be ' + 'constructed with a TransformStream instance');
      }
      if (transformStream._transformStreamController !== undefined) {
        throw new TypeError('TransformStreamDefaultController instances can ' + 'only be created by the TransformStream constructor');
      }
      this._controlledTransformStream = transformStream;
    }
    _createClass(TransformStreamDefaultController, [{
      key: 'enqueue',
      value: function enqueue(chunk) {
        if (IsTransformStreamDefaultController(this) === false) {
          throw defaultControllerBrandCheckException('enqueue');
        }
        TransformStreamEnqueueToReadable(this._controlledTransformStream, chunk);
      }
    }, {
      key: 'close',
      value: function close() {
        if (IsTransformStreamDefaultController(this) === false) {
          throw defaultControllerBrandCheckException('close');
        }
        TransformStreamCloseReadable(this._controlledTransformStream);
      }
    }, {
      key: 'error',
      value: function error(reason) {
        if (IsTransformStreamDefaultController(this) === false) {
          throw defaultControllerBrandCheckException('error');
        }
        TransformStreamError(this._controlledTransformStream, reason);
      }
    }, {
      key: 'desiredSize',
      get: function get() {
        if (IsTransformStreamDefaultController(this) === false) {
          throw defaultControllerBrandCheckException('desiredSize');
        }
        var transformStream = this._controlledTransformStream;
        var readableController = transformStream._readableController;
        return ReadableStreamDefaultControllerGetDesiredSize(readableController);
      }
    }]);
    return TransformStreamDefaultController;
  }();
  var TransformStream = function () {
    function TransformStream() {
      var transformer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      _classCallCheck(this, TransformStream);
      this._transformer = transformer;
      var readableStrategy = transformer.readableStrategy,
          writableStrategy = transformer.writableStrategy;
      this._transforming = false;
      this._errored = false;
      this._storedError = undefined;
      this._writableController = undefined;
      this._readableController = undefined;
      this._transformStreamController = undefined;
      this._writableDone = false;
      this._readableClosed = false;
      this._backpressure = undefined;
      this._backpressureChangePromise = undefined;
      this._backpressureChangePromise_resolve = undefined;
      this._transformStreamController = new TransformStreamDefaultController(this);
      var startPromise_resolve = void 0;
      var startPromise = new Promise(function (resolve) {
        startPromise_resolve = resolve;
      });
      var source = new TransformStreamSource(this, startPromise);
      this._readable = new ReadableStream(source, readableStrategy);
      var sink = new TransformStreamSink(this, startPromise);
      this._writable = new WritableStream(sink, writableStrategy);
      assert(this._writableController !== undefined);
      assert(this._readableController !== undefined);
      var desiredSize = ReadableStreamDefaultControllerGetDesiredSize(this._readableController);
      TransformStreamSetBackpressure(this, desiredSize <= 0);
      var transformStream = this;
      var startResult = InvokeOrNoop(transformer, 'start', [transformStream._transformStreamController]);
      startPromise_resolve(startResult);
      startPromise.catch(function (e) {
        if (transformStream._errored === false) {
          transformStream._errored = true;
          transformStream._storedError = e;
        }
      });
    }
    _createClass(TransformStream, [{
      key: 'readable',
      get: function get() {
        if (IsTransformStream(this) === false) {
          throw streamBrandCheckException('readable');
        }
        return this._readable;
      }
    }, {
      key: 'writable',
      get: function get() {
        if (IsTransformStream(this) === false) {
          throw streamBrandCheckException('writable');
        }
        return this._writable;
      }
    }]);
    return TransformStream;
  }();
  module.exports = { TransformStream: TransformStream };
  function defaultControllerBrandCheckException(name) {
    return new TypeError('TransformStreamDefaultController.prototype.' + name + ' can only be used on a TransformStreamDefaultController');
  }
  function streamBrandCheckException(name) {
    return new TypeError('TransformStream.prototype.' + name + ' can only be used on a TransformStream');
  }
}, function (module, exports, __w_pdfjs_require__) {
  module.exports = __w_pdfjs_require__(5);
}]));

/***/ }),
/* 11 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CanvasGraphics = undefined;

var _util = __w_pdfjs_require__(0);

var _pattern_helper = __w_pdfjs_require__(13);

var _webgl = __w_pdfjs_require__(7);

var MIN_FONT_SIZE = 16;
var MAX_FONT_SIZE = 100;
var MAX_GROUP_SIZE = 4096;
var MIN_WIDTH_FACTOR = 0.65;
var COMPILE_TYPE3_GLYPHS = true;
var MAX_SIZE_TO_COMPILE = 1000;
var FULL_CHUNK_HEIGHT = 16;
var IsLittleEndianCached = {
  get value() {
    return (0, _util.shadow)(IsLittleEndianCached, 'value', (0, _util.isLittleEndian)());
  }
};
function addContextCurrentTransform(ctx) {
  if (!ctx.mozCurrentTransform) {
    ctx._originalSave = ctx.save;
    ctx._originalRestore = ctx.restore;
    ctx._originalRotate = ctx.rotate;
    ctx._originalScale = ctx.scale;
    ctx._originalTranslate = ctx.translate;
    ctx._originalTransform = ctx.transform;
    ctx._originalSetTransform = ctx.setTransform;
    ctx._transformMatrix = ctx._transformMatrix || [1, 0, 0, 1, 0, 0];
    ctx._transformStack = [];
    Object.defineProperty(ctx, 'mozCurrentTransform', {
      get: function getCurrentTransform() {
        return this._transformMatrix;
      }
    });
    Object.defineProperty(ctx, 'mozCurrentTransformInverse', {
      get: function getCurrentTransformInverse() {
        var m = this._transformMatrix;
        var a = m[0],
            b = m[1],
            c = m[2],
            d = m[3],
            e = m[4],
            f = m[5];
        var ad_bc = a * d - b * c;
        var bc_ad = b * c - a * d;
        return [d / ad_bc, b / bc_ad, c / bc_ad, a / ad_bc, (d * e - c * f) / bc_ad, (b * e - a * f) / ad_bc];
      }
    });
    ctx.save = function ctxSave() {
      var old = this._transformMatrix;
      this._transformStack.push(old);
      this._transformMatrix = old.slice(0, 6);
      this._originalSave();
    };
    ctx.restore = function ctxRestore() {
      var prev = this._transformStack.pop();
      if (prev) {
        this._transformMatrix = prev;
        this._originalRestore();
      }
    };
    ctx.translate = function ctxTranslate(x, y) {
      var m = this._transformMatrix;
      m[4] = m[0] * x + m[2] * y + m[4];
      m[5] = m[1] * x + m[3] * y + m[5];
      this._originalTranslate(x, y);
    };
    ctx.scale = function ctxScale(x, y) {
      var m = this._transformMatrix;
      m[0] = m[0] * x;
      m[1] = m[1] * x;
      m[2] = m[2] * y;
      m[3] = m[3] * y;
      this._originalScale(x, y);
    };
    ctx.transform = function ctxTransform(a, b, c, d, e, f) {
      var m = this._transformMatrix;
      this._transformMatrix = [m[0] * a + m[2] * b, m[1] * a + m[3] * b, m[0] * c + m[2] * d, m[1] * c + m[3] * d, m[0] * e + m[2] * f + m[4], m[1] * e + m[3] * f + m[5]];
      ctx._originalTransform(a, b, c, d, e, f);
    };
    ctx.setTransform = function ctxSetTransform(a, b, c, d, e, f) {
      this._transformMatrix = [a, b, c, d, e, f];
      ctx._originalSetTransform(a, b, c, d, e, f);
    };
    ctx.rotate = function ctxRotate(angle) {
      var cosValue = Math.cos(angle);
      var sinValue = Math.sin(angle);
      var m = this._transformMatrix;
      this._transformMatrix = [m[0] * cosValue + m[2] * sinValue, m[1] * cosValue + m[3] * sinValue, m[0] * -sinValue + m[2] * cosValue, m[1] * -sinValue + m[3] * cosValue, m[4], m[5]];
      this._originalRotate(angle);
    };
  }
}
var CachedCanvases = function CachedCanvasesClosure() {
  function CachedCanvases(canvasFactory) {
    this.canvasFactory = canvasFactory;
    this.cache = Object.create(null);
  }
  CachedCanvases.prototype = {
    getCanvas: function CachedCanvases_getCanvas(id, width, height, trackTransform) {
      var canvasEntry;
      if (this.cache[id] !== undefined) {
        canvasEntry = this.cache[id];
        this.canvasFactory.reset(canvasEntry, width, height);
        canvasEntry.context.setTransform(1, 0, 0, 1, 0, 0);
      } else {
        canvasEntry = this.canvasFactory.create(width, height);
        this.cache[id] = canvasEntry;
      }
      if (trackTransform) {
        addContextCurrentTransform(canvasEntry.context);
      }
      return canvasEntry;
    },
    clear: function clear() {
      for (var id in this.cache) {
        var canvasEntry = this.cache[id];
        this.canvasFactory.destroy(canvasEntry);
        delete this.cache[id];
      }
    }
  };
  return CachedCanvases;
}();
function compileType3Glyph(imgData) {
  var POINT_TO_PROCESS_LIMIT = 1000;
  var width = imgData.width,
      height = imgData.height;
  var i,
      j,
      j0,
      width1 = width + 1;
  var points = new Uint8Array(width1 * (height + 1));
  var POINT_TYPES = new Uint8Array([0, 2, 4, 0, 1, 0, 5, 4, 8, 10, 0, 8, 0, 2, 1, 0]);
  var lineSize = width + 7 & ~7,
      data0 = imgData.data;
  var data = new Uint8Array(lineSize * height),
      pos = 0,
      ii;
  for (i = 0, ii = data0.length; i < ii; i++) {
    var mask = 128,
        elem = data0[i];
    while (mask > 0) {
      data[pos++] = elem & mask ? 0 : 255;
      mask >>= 1;
    }
  }
  var count = 0;
  pos = 0;
  if (data[pos] !== 0) {
    points[0] = 1;
    ++count;
  }
  for (j = 1; j < width; j++) {
    if (data[pos] !== data[pos + 1]) {
      points[j] = data[pos] ? 2 : 1;
      ++count;
    }
    pos++;
  }
  if (data[pos] !== 0) {
    points[j] = 2;
    ++count;
  }
  for (i = 1; i < height; i++) {
    pos = i * lineSize;
    j0 = i * width1;
    if (data[pos - lineSize] !== data[pos]) {
      points[j0] = data[pos] ? 1 : 8;
      ++count;
    }
    var sum = (data[pos] ? 4 : 0) + (data[pos - lineSize] ? 8 : 0);
    for (j = 1; j < width; j++) {
      sum = (sum >> 2) + (data[pos + 1] ? 4 : 0) + (data[pos - lineSize + 1] ? 8 : 0);
      if (POINT_TYPES[sum]) {
        points[j0 + j] = POINT_TYPES[sum];
        ++count;
      }
      pos++;
    }
    if (data[pos - lineSize] !== data[pos]) {
      points[j0 + j] = data[pos] ? 2 : 4;
      ++count;
    }
    if (count > POINT_TO_PROCESS_LIMIT) {
      return null;
    }
  }
  pos = lineSize * (height - 1);
  j0 = i * width1;
  if (data[pos] !== 0) {
    points[j0] = 8;
    ++count;
  }
  for (j = 1; j < width; j++) {
    if (data[pos] !== data[pos + 1]) {
      points[j0 + j] = data[pos] ? 4 : 8;
      ++count;
    }
    pos++;
  }
  if (data[pos] !== 0) {
    points[j0 + j] = 4;
    ++count;
  }
  if (count > POINT_TO_PROCESS_LIMIT) {
    return null;
  }
  var steps = new Int32Array([0, width1, -1, 0, -width1, 0, 0, 0, 1]);
  var outlines = [];
  for (i = 0; count && i <= height; i++) {
    var p = i * width1;
    var end = p + width;
    while (p < end && !points[p]) {
      p++;
    }
    if (p === end) {
      continue;
    }
    var coords = [p % width1, i];
    var type = points[p],
        p0 = p,
        pp;
    do {
      var step = steps[type];
      do {
        p += step;
      } while (!points[p]);
      pp = points[p];
      if (pp !== 5 && pp !== 10) {
        type = pp;
        points[p] = 0;
      } else {
        type = pp & 0x33 * type >> 4;
        points[p] &= type >> 2 | type << 2;
      }
      coords.push(p % width1);
      coords.push(p / width1 | 0);
      --count;
    } while (p0 !== p);
    outlines.push(coords);
    --i;
  }
  var drawOutline = function drawOutline(c) {
    c.save();
    c.scale(1 / width, -1 / height);
    c.translate(0, -height);
    c.beginPath();
    for (var i = 0, ii = outlines.length; i < ii; i++) {
      var o = outlines[i];
      c.moveTo(o[0], o[1]);
      for (var j = 2, jj = o.length; j < jj; j += 2) {
        c.lineTo(o[j], o[j + 1]);
      }
    }
    c.fill();
    c.beginPath();
    c.restore();
  };
  return drawOutline;
}
var CanvasExtraState = function CanvasExtraStateClosure() {
  function CanvasExtraState() {
    this.alphaIsShape = false;
    this.fontSize = 0;
    this.fontSizeScale = 1;
    this.textMatrix = _util.IDENTITY_MATRIX;
    this.textMatrixScale = 1;
    this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
    this.leading = 0;
    this.x = 0;
    this.y = 0;
    this.lineX = 0;
    this.lineY = 0;
    this.charSpacing = 0;
    this.wordSpacing = 0;
    this.textHScale = 1;
    this.textRenderingMode = _util.TextRenderingMode.FILL;
    this.textRise = 0;
    this.fillColor = '#000000';
    this.strokeColor = '#000000';
    this.patternFill = false;
    this.fillAlpha = 1;
    this.strokeAlpha = 1;
    this.lineWidth = 1;
    this.activeSMask = null;
    this.resumeSMaskCtx = null;
  }
  CanvasExtraState.prototype = {
    clone: function CanvasExtraState_clone() {
      return Object.create(this);
    },
    setCurrentPoint: function CanvasExtraState_setCurrentPoint(x, y) {
      this.x = x;
      this.y = y;
    }
  };
  return CanvasExtraState;
}();
var CanvasGraphics = function CanvasGraphicsClosure() {
  var EXECUTION_TIME = 15;
  var EXECUTION_STEPS = 10;
  function CanvasGraphics(canvasCtx, commonObjs, objs, canvasFactory, imageLayer) {
    this.ctx = canvasCtx;
    this.current = new CanvasExtraState();
    this.stateStack = [];
    this.pendingClip = null;
    this.pendingEOFill = false;
    this.res = null;
    this.xobjs = null;
    this.commonObjs = commonObjs;
    this.objs = objs;
    this.canvasFactory = canvasFactory;
    this.imageLayer = imageLayer;
    this.groupStack = [];
    this.processingType3 = null;
    this.baseTransform = null;
    this.baseTransformStack = [];
    this.groupLevel = 0;
    this.smaskStack = [];
    this.smaskCounter = 0;
    this.tempSMask = null;
    this.cachedCanvases = new CachedCanvases(this.canvasFactory);
    if (canvasCtx) {
      addContextCurrentTransform(canvasCtx);
    }
    this.cachedGetSinglePixelWidth = null;
  }
  function putBinaryImageData(ctx, imgData) {
    if (typeof ImageData !== 'undefined' && imgData instanceof ImageData) {
      ctx.putImageData(imgData, 0, 0);
      return;
    }
    var height = imgData.height,
        width = imgData.width;
    var partialChunkHeight = height % FULL_CHUNK_HEIGHT;
    var fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
    var totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
    var chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
    var srcPos = 0,
        destPos;
    var src = imgData.data;
    var dest = chunkImgData.data;
    var i, j, thisChunkHeight, elemsInThisChunk;
    if (imgData.kind === _util.ImageKind.GRAYSCALE_1BPP) {
      var srcLength = src.byteLength;
      var dest32 = new Uint32Array(dest.buffer, 0, dest.byteLength >> 2);
      var dest32DataLength = dest32.length;
      var fullSrcDiff = width + 7 >> 3;
      var white = 0xFFFFFFFF;
      var black = IsLittleEndianCached.value ? 0xFF000000 : 0x000000FF;
      for (i = 0; i < totalChunks; i++) {
        thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
        destPos = 0;
        for (j = 0; j < thisChunkHeight; j++) {
          var srcDiff = srcLength - srcPos;
          var k = 0;
          var kEnd = srcDiff > fullSrcDiff ? width : srcDiff * 8 - 7;
          var kEndUnrolled = kEnd & ~7;
          var mask = 0;
          var srcByte = 0;
          for (; k < kEndUnrolled; k += 8) {
            srcByte = src[srcPos++];
            dest32[destPos++] = srcByte & 128 ? white : black;
            dest32[destPos++] = srcByte & 64 ? white : black;
            dest32[destPos++] = srcByte & 32 ? white : black;
            dest32[destPos++] = srcByte & 16 ? white : black;
            dest32[destPos++] = srcByte & 8 ? white : black;
            dest32[destPos++] = srcByte & 4 ? white : black;
            dest32[destPos++] = srcByte & 2 ? white : black;
            dest32[destPos++] = srcByte & 1 ? white : black;
          }
          for (; k < kEnd; k++) {
            if (mask === 0) {
              srcByte = src[srcPos++];
              mask = 128;
            }
            dest32[destPos++] = srcByte & mask ? white : black;
            mask >>= 1;
          }
        }
        while (destPos < dest32DataLength) {
          dest32[destPos++] = 0;
        }
        ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
      }
    } else if (imgData.kind === _util.ImageKind.RGBA_32BPP) {
      j = 0;
      elemsInThisChunk = width * FULL_CHUNK_HEIGHT * 4;
      for (i = 0; i < fullChunks; i++) {
        dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
        srcPos += elemsInThisChunk;
        ctx.putImageData(chunkImgData, 0, j);
        j += FULL_CHUNK_HEIGHT;
      }
      if (i < totalChunks) {
        elemsInThisChunk = width * partialChunkHeight * 4;
        dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
        ctx.putImageData(chunkImgData, 0, j);
      }
    } else if (imgData.kind === _util.ImageKind.RGB_24BPP) {
      thisChunkHeight = FULL_CHUNK_HEIGHT;
      elemsInThisChunk = width * thisChunkHeight;
      for (i = 0; i < totalChunks; i++) {
        if (i >= fullChunks) {
          thisChunkHeight = partialChunkHeight;
          elemsInThisChunk = width * thisChunkHeight;
        }
        destPos = 0;
        for (j = elemsInThisChunk; j--;) {
          dest[destPos++] = src[srcPos++];
          dest[destPos++] = src[srcPos++];
          dest[destPos++] = src[srcPos++];
          dest[destPos++] = 255;
        }
        ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
      }
    } else {
      throw new Error('bad image kind: ' + imgData.kind);
    }
  }
  function putBinaryImageMask(ctx, imgData) {
    var height = imgData.height,
        width = imgData.width;
    var partialChunkHeight = height % FULL_CHUNK_HEIGHT;
    var fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
    var totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
    var chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
    var srcPos = 0;
    var src = imgData.data;
    var dest = chunkImgData.data;
    for (var i = 0; i < totalChunks; i++) {
      var thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
      var destPos = 3;
      for (var j = 0; j < thisChunkHeight; j++) {
        var mask = 0;
        for (var k = 0; k < width; k++) {
          if (!mask) {
            var elem = src[srcPos++];
            mask = 128;
          }
          dest[destPos] = elem & mask ? 0 : 255;
          destPos += 4;
          mask >>= 1;
        }
      }
      ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
    }
  }
  function copyCtxState(sourceCtx, destCtx) {
    var properties = ['strokeStyle', 'fillStyle', 'fillRule', 'globalAlpha', 'lineWidth', 'lineCap', 'lineJoin', 'miterLimit', 'globalCompositeOperation', 'font'];
    for (var i = 0, ii = properties.length; i < ii; i++) {
      var property = properties[i];
      if (sourceCtx[property] !== undefined) {
        destCtx[property] = sourceCtx[property];
      }
    }
    if (sourceCtx.setLineDash !== undefined) {
      destCtx.setLineDash(sourceCtx.getLineDash());
      destCtx.lineDashOffset = sourceCtx.lineDashOffset;
    }
  }
  function resetCtxToDefault(ctx) {
    ctx.strokeStyle = '#000000';
    ctx.fillStyle = '#000000';
    ctx.fillRule = 'nonzero';
    ctx.globalAlpha = 1;
    ctx.lineWidth = 1;
    ctx.lineCap = 'butt';
    ctx.lineJoin = 'miter';
    ctx.miterLimit = 10;
    ctx.globalCompositeOperation = 'source-over';
    ctx.font = '10px sans-serif';
    if (ctx.setLineDash !== undefined) {
      ctx.setLineDash([]);
      ctx.lineDashOffset = 0;
    }
  }
  function composeSMaskBackdrop(bytes, r0, g0, b0) {
    var length = bytes.length;
    for (var i = 3; i < length; i += 4) {
      var alpha = bytes[i];
      if (alpha === 0) {
        bytes[i - 3] = r0;
        bytes[i - 2] = g0;
        bytes[i - 1] = b0;
      } else if (alpha < 255) {
        var alpha_ = 255 - alpha;
        bytes[i - 3] = bytes[i - 3] * alpha + r0 * alpha_ >> 8;
        bytes[i - 2] = bytes[i - 2] * alpha + g0 * alpha_ >> 8;
        bytes[i - 1] = bytes[i - 1] * alpha + b0 * alpha_ >> 8;
      }
    }
  }
  function composeSMaskAlpha(maskData, layerData, transferMap) {
    var length = maskData.length;
    var scale = 1 / 255;
    for (var i = 3; i < length; i += 4) {
      var alpha = transferMap ? transferMap[maskData[i]] : maskData[i];
      layerData[i] = layerData[i] * alpha * scale | 0;
    }
  }
  function composeSMaskLuminosity(maskData, layerData, transferMap) {
    var length = maskData.length;
    for (var i = 3; i < length; i += 4) {
      var y = maskData[i - 3] * 77 + maskData[i - 2] * 152 + maskData[i - 1] * 28;
      layerData[i] = transferMap ? layerData[i] * transferMap[y >> 8] >> 8 : layerData[i] * y >> 16;
    }
  }
  function genericComposeSMask(maskCtx, layerCtx, width, height, subtype, backdrop, transferMap) {
    var hasBackdrop = !!backdrop;
    var r0 = hasBackdrop ? backdrop[0] : 0;
    var g0 = hasBackdrop ? backdrop[1] : 0;
    var b0 = hasBackdrop ? backdrop[2] : 0;
    var composeFn;
    if (subtype === 'Luminosity') {
      composeFn = composeSMaskLuminosity;
    } else {
      composeFn = composeSMaskAlpha;
    }
    var PIXELS_TO_PROCESS = 1048576;
    var chunkSize = Math.min(height, Math.ceil(PIXELS_TO_PROCESS / width));
    for (var row = 0; row < height; row += chunkSize) {
      var chunkHeight = Math.min(chunkSize, height - row);
      var maskData = maskCtx.getImageData(0, row, width, chunkHeight);
      var layerData = layerCtx.getImageData(0, row, width, chunkHeight);
      if (hasBackdrop) {
        composeSMaskBackdrop(maskData.data, r0, g0, b0);
      }
      composeFn(maskData.data, layerData.data, transferMap);
      maskCtx.putImageData(layerData, 0, row);
    }
  }
  function composeSMask(ctx, smask, layerCtx) {
    var mask = smask.canvas;
    var maskCtx = smask.context;
    ctx.setTransform(smask.scaleX, 0, 0, smask.scaleY, smask.offsetX, smask.offsetY);
    var backdrop = smask.backdrop || null;
    if (!smask.transferMap && _webgl.WebGLUtils.isEnabled) {
      var composed = _webgl.WebGLUtils.composeSMask(layerCtx.canvas, mask, {
        subtype: smask.subtype,
        backdrop: backdrop
      });
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.drawImage(composed, smask.offsetX, smask.offsetY);
      return;
    }
    genericComposeSMask(maskCtx, layerCtx, mask.width, mask.height, smask.subtype, backdrop, smask.transferMap);
    ctx.drawImage(mask, 0, 0);
  }
  var LINE_CAP_STYLES = ['butt', 'round', 'square'];
  var LINE_JOIN_STYLES = ['miter', 'round', 'bevel'];
  var NORMAL_CLIP = {};
  var EO_CLIP = {};
  CanvasGraphics.prototype = {
    beginDrawing: function beginDrawing(_ref) {
      var transform = _ref.transform,
          viewport = _ref.viewport,
          transparency = _ref.transparency,
          _ref$background = _ref.background,
          background = _ref$background === undefined ? null : _ref$background;

      var width = this.ctx.canvas.width;
      var height = this.ctx.canvas.height;
      this.ctx.save();
      this.ctx.fillStyle = background || 'rgb(255, 255, 255)';
      this.ctx.fillRect(0, 0, width, height);
      this.ctx.restore();
      if (transparency) {
        var transparentCanvas = this.cachedCanvases.getCanvas('transparent', width, height, true);
        this.compositeCtx = this.ctx;
        this.transparentCanvas = transparentCanvas.canvas;
        this.ctx = transparentCanvas.context;
        this.ctx.save();
        this.ctx.transform.apply(this.ctx, this.compositeCtx.mozCurrentTransform);
      }
      this.ctx.save();
      resetCtxToDefault(this.ctx);
      if (transform) {
        this.ctx.transform.apply(this.ctx, transform);
      }
      this.ctx.transform.apply(this.ctx, viewport.transform);
      this.baseTransform = this.ctx.mozCurrentTransform.slice();
      if (this.imageLayer) {
        this.imageLayer.beginLayout();
      }
    },

    executeOperatorList: function CanvasGraphics_executeOperatorList(operatorList, executionStartIdx, continueCallback, stepper) {
      var argsArray = operatorList.argsArray;
      var fnArray = operatorList.fnArray;
      var i = executionStartIdx || 0;
      var argsArrayLen = argsArray.length;
      if (argsArrayLen === i) {
        return i;
      }
      var chunkOperations = argsArrayLen - i > EXECUTION_STEPS && typeof continueCallback === 'function';
      var endTime = chunkOperations ? Date.now() + EXECUTION_TIME : 0;
      var steps = 0;
      var commonObjs = this.commonObjs;
      var objs = this.objs;
      var fnId;
      while (true) {
        if (stepper !== undefined && i === stepper.nextBreakPoint) {
          stepper.breakIt(i, continueCallback);
          return i;
        }
        fnId = fnArray[i];
        if (fnId !== _util.OPS.dependency) {
          this[fnId].apply(this, argsArray[i]);
        } else {
          var deps = argsArray[i];
          for (var n = 0, nn = deps.length; n < nn; n++) {
            var depObjId = deps[n];
            var common = depObjId[0] === 'g' && depObjId[1] === '_';
            var objsPool = common ? commonObjs : objs;
            if (!objsPool.isResolved(depObjId)) {
              objsPool.get(depObjId, continueCallback);
              return i;
            }
          }
        }
        i++;
        if (i === argsArrayLen) {
          return i;
        }
        if (chunkOperations && ++steps > EXECUTION_STEPS) {
          if (Date.now() > endTime) {
            continueCallback();
            return i;
          }
          steps = 0;
        }
      }
    },
    endDrawing: function CanvasGraphics_endDrawing() {
      if (this.current.activeSMask !== null) {
        this.endSMaskGroup();
      }
      this.ctx.restore();
      if (this.transparentCanvas) {
        this.ctx = this.compositeCtx;
        this.ctx.save();
        this.ctx.setTransform(1, 0, 0, 1, 0, 0);
        this.ctx.drawImage(this.transparentCanvas, 0, 0);
        this.ctx.restore();
        this.transparentCanvas = null;
      }
      this.cachedCanvases.clear();
      _webgl.WebGLUtils.clear();
      if (this.imageLayer) {
        this.imageLayer.endLayout();
      }
    },
    setLineWidth: function CanvasGraphics_setLineWidth(width) {
      this.current.lineWidth = width;
      this.ctx.lineWidth = width;
    },
    setLineCap: function CanvasGraphics_setLineCap(style) {
      this.ctx.lineCap = LINE_CAP_STYLES[style];
    },
    setLineJoin: function CanvasGraphics_setLineJoin(style) {
      this.ctx.lineJoin = LINE_JOIN_STYLES[style];
    },
    setMiterLimit: function CanvasGraphics_setMiterLimit(limit) {
      this.ctx.miterLimit = limit;
    },
    setDash: function CanvasGraphics_setDash(dashArray, dashPhase) {
      var ctx = this.ctx;
      if (ctx.setLineDash !== undefined) {
        ctx.setLineDash(dashArray);
        ctx.lineDashOffset = dashPhase;
      }
    },
    setRenderingIntent: function CanvasGraphics_setRenderingIntent(intent) {},
    setFlatness: function CanvasGraphics_setFlatness(flatness) {},
    setGState: function CanvasGraphics_setGState(states) {
      for (var i = 0, ii = states.length; i < ii; i++) {
        var state = states[i];
        var key = state[0];
        var value = state[1];
        switch (key) {
          case 'LW':
            this.setLineWidth(value);
            break;
          case 'LC':
            this.setLineCap(value);
            break;
          case 'LJ':
            this.setLineJoin(value);
            break;
          case 'ML':
            this.setMiterLimit(value);
            break;
          case 'D':
            this.setDash(value[0], value[1]);
            break;
          case 'RI':
            this.setRenderingIntent(value);
            break;
          case 'FL':
            this.setFlatness(value);
            break;
          case 'Font':
            this.setFont(value[0], value[1]);
            break;
          case 'CA':
            this.current.strokeAlpha = state[1];
            break;
          case 'ca':
            this.current.fillAlpha = state[1];
            this.ctx.globalAlpha = state[1];
            break;
          case 'BM':
            this.ctx.globalCompositeOperation = value;
            break;
          case 'SMask':
            if (this.current.activeSMask) {
              if (this.stateStack.length > 0 && this.stateStack[this.stateStack.length - 1].activeSMask === this.current.activeSMask) {
                this.suspendSMaskGroup();
              } else {
                this.endSMaskGroup();
              }
            }
            this.current.activeSMask = value ? this.tempSMask : null;
            if (this.current.activeSMask) {
              this.beginSMaskGroup();
            }
            this.tempSMask = null;
            break;
        }
      }
    },
    beginSMaskGroup: function CanvasGraphics_beginSMaskGroup() {
      var activeSMask = this.current.activeSMask;
      var drawnWidth = activeSMask.canvas.width;
      var drawnHeight = activeSMask.canvas.height;
      var cacheId = 'smaskGroupAt' + this.groupLevel;
      var scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight, true);
      var currentCtx = this.ctx;
      var currentTransform = currentCtx.mozCurrentTransform;
      this.ctx.save();
      var groupCtx = scratchCanvas.context;
      groupCtx.scale(1 / activeSMask.scaleX, 1 / activeSMask.scaleY);
      groupCtx.translate(-activeSMask.offsetX, -activeSMask.offsetY);
      groupCtx.transform.apply(groupCtx, currentTransform);
      activeSMask.startTransformInverse = groupCtx.mozCurrentTransformInverse;
      copyCtxState(currentCtx, groupCtx);
      this.ctx = groupCtx;
      this.setGState([['BM', 'source-over'], ['ca', 1], ['CA', 1]]);
      this.groupStack.push(currentCtx);
      this.groupLevel++;
    },
    suspendSMaskGroup: function CanvasGraphics_endSMaskGroup() {
      var groupCtx = this.ctx;
      this.groupLevel--;
      this.ctx = this.groupStack.pop();
      composeSMask(this.ctx, this.current.activeSMask, groupCtx);
      this.ctx.restore();
      this.ctx.save();
      copyCtxState(groupCtx, this.ctx);
      this.current.resumeSMaskCtx = groupCtx;
      var deltaTransform = _util.Util.transform(this.current.activeSMask.startTransformInverse, groupCtx.mozCurrentTransform);
      this.ctx.transform.apply(this.ctx, deltaTransform);
      groupCtx.save();
      groupCtx.setTransform(1, 0, 0, 1, 0, 0);
      groupCtx.clearRect(0, 0, groupCtx.canvas.width, groupCtx.canvas.height);
      groupCtx.restore();
    },
    resumeSMaskGroup: function CanvasGraphics_endSMaskGroup() {
      var groupCtx = this.current.resumeSMaskCtx;
      var currentCtx = this.ctx;
      this.ctx = groupCtx;
      this.groupStack.push(currentCtx);
      this.groupLevel++;
    },
    endSMaskGroup: function CanvasGraphics_endSMaskGroup() {
      var groupCtx = this.ctx;
      this.groupLevel--;
      this.ctx = this.groupStack.pop();
      composeSMask(this.ctx, this.current.activeSMask, groupCtx);
      this.ctx.restore();
      copyCtxState(groupCtx, this.ctx);
      var deltaTransform = _util.Util.transform(this.current.activeSMask.startTransformInverse, groupCtx.mozCurrentTransform);
      this.ctx.transform.apply(this.ctx, deltaTransform);
    },
    save: function CanvasGraphics_save() {
      this.ctx.save();
      var old = this.current;
      this.stateStack.push(old);
      this.current = old.clone();
      this.current.resumeSMaskCtx = null;
    },
    restore: function CanvasGraphics_restore() {
      if (this.current.resumeSMaskCtx) {
        this.resumeSMaskGroup();
      }
      if (this.current.activeSMask !== null && (this.stateStack.length === 0 || this.stateStack[this.stateStack.length - 1].activeSMask !== this.current.activeSMask)) {
        this.endSMaskGroup();
      }
      if (this.stateStack.length !== 0) {
        this.current = this.stateStack.pop();
        this.ctx.restore();
        this.pendingClip = null;
        this.cachedGetSinglePixelWidth = null;
      }
    },
    transform: function CanvasGraphics_transform(a, b, c, d, e, f) {
      this.ctx.transform(a, b, c, d, e, f);
      this.cachedGetSinglePixelWidth = null;
    },
    constructPath: function CanvasGraphics_constructPath(ops, args) {
      var ctx = this.ctx;
      var current = this.current;
      var x = current.x,
          y = current.y;
      for (var i = 0, j = 0, ii = ops.length; i < ii; i++) {
        switch (ops[i] | 0) {
          case _util.OPS.rectangle:
            x = args[j++];
            y = args[j++];
            var width = args[j++];
            var height = args[j++];
            if (width === 0) {
              width = this.getSinglePixelWidth();
            }
            if (height === 0) {
              height = this.getSinglePixelWidth();
            }
            var xw = x + width;
            var yh = y + height;
            this.ctx.moveTo(x, y);
            this.ctx.lineTo(xw, y);
            this.ctx.lineTo(xw, yh);
            this.ctx.lineTo(x, yh);
            this.ctx.lineTo(x, y);
            this.ctx.closePath();
            break;
          case _util.OPS.moveTo:
            x = args[j++];
            y = args[j++];
            ctx.moveTo(x, y);
            break;
          case _util.OPS.lineTo:
            x = args[j++];
            y = args[j++];
            ctx.lineTo(x, y);
            break;
          case _util.OPS.curveTo:
            x = args[j + 4];
            y = args[j + 5];
            ctx.bezierCurveTo(args[j], args[j + 1], args[j + 2], args[j + 3], x, y);
            j += 6;
            break;
          case _util.OPS.curveTo2:
            ctx.bezierCurveTo(x, y, args[j], args[j + 1], args[j + 2], args[j + 3]);
            x = args[j + 2];
            y = args[j + 3];
            j += 4;
            break;
          case _util.OPS.curveTo3:
            x = args[j + 2];
            y = args[j + 3];
            ctx.bezierCurveTo(args[j], args[j + 1], x, y, x, y);
            j += 4;
            break;
          case _util.OPS.closePath:
            ctx.closePath();
            break;
        }
      }
      current.setCurrentPoint(x, y);
    },
    closePath: function CanvasGraphics_closePath() {
      this.ctx.closePath();
    },
    stroke: function CanvasGraphics_stroke(consumePath) {
      consumePath = typeof consumePath !== 'undefined' ? consumePath : true;
      var ctx = this.ctx;
      var strokeColor = this.current.strokeColor;
      ctx.lineWidth = Math.max(this.getSinglePixelWidth() * MIN_WIDTH_FACTOR, this.current.lineWidth);
      ctx.globalAlpha = this.current.strokeAlpha;
      if (strokeColor && strokeColor.hasOwnProperty('type') && strokeColor.type === 'Pattern') {
        ctx.save();
        ctx.strokeStyle = strokeColor.getPattern(ctx, this);
        ctx.stroke();
        ctx.restore();
      } else {
        ctx.stroke();
      }
      if (consumePath) {
        this.consumePath();
      }
      ctx.globalAlpha = this.current.fillAlpha;
    },
    closeStroke: function CanvasGraphics_closeStroke() {
      this.closePath();
      this.stroke();
    },
    fill: function CanvasGraphics_fill(consumePath) {
      consumePath = typeof consumePath !== 'undefined' ? consumePath : true;
      var ctx = this.ctx;
      var fillColor = this.current.fillColor;
      var isPatternFill = this.current.patternFill;
      var needRestore = false;
      if (isPatternFill) {
        ctx.save();
        if (this.baseTransform) {
          ctx.setTransform.apply(ctx, this.baseTransform);
        }
        ctx.fillStyle = fillColor.getPattern(ctx, this);
        needRestore = true;
      }
      if (this.pendingEOFill) {
        ctx.fill('evenodd');
        this.pendingEOFill = false;
      } else {
        ctx.fill();
      }
      if (needRestore) {
        ctx.restore();
      }
      if (consumePath) {
        this.consumePath();
      }
    },
    eoFill: function CanvasGraphics_eoFill() {
      this.pendingEOFill = true;
      this.fill();
    },
    fillStroke: function CanvasGraphics_fillStroke() {
      this.fill(false);
      this.stroke(false);
      this.consumePath();
    },
    eoFillStroke: function CanvasGraphics_eoFillStroke() {
      this.pendingEOFill = true;
      this.fillStroke();
    },
    closeFillStroke: function CanvasGraphics_closeFillStroke() {
      this.closePath();
      this.fillStroke();
    },
    closeEOFillStroke: function CanvasGraphics_closeEOFillStroke() {
      this.pendingEOFill = true;
      this.closePath();
      this.fillStroke();
    },
    endPath: function CanvasGraphics_endPath() {
      this.consumePath();
    },
    clip: function CanvasGraphics_clip() {
      this.pendingClip = NORMAL_CLIP;
    },
    eoClip: function CanvasGraphics_eoClip() {
      this.pendingClip = EO_CLIP;
    },
    beginText: function CanvasGraphics_beginText() {
      this.current.textMatrix = _util.IDENTITY_MATRIX;
      this.current.textMatrixScale = 1;
      this.current.x = this.current.lineX = 0;
      this.current.y = this.current.lineY = 0;
    },
    endText: function CanvasGraphics_endText() {
      var paths = this.pendingTextPaths;
      var ctx = this.ctx;
      if (paths === undefined) {
        ctx.beginPath();
        return;
      }
      ctx.save();
      ctx.beginPath();
      for (var i = 0; i < paths.length; i++) {
        var path = paths[i];
        ctx.setTransform.apply(ctx, path.transform);
        ctx.translate(path.x, path.y);
        path.addToPath(ctx, path.fontSize);
      }
      ctx.restore();
      ctx.clip();
      ctx.beginPath();
      delete this.pendingTextPaths;
    },
    setCharSpacing: function CanvasGraphics_setCharSpacing(spacing) {
      this.current.charSpacing = spacing;
    },
    setWordSpacing: function CanvasGraphics_setWordSpacing(spacing) {
      this.current.wordSpacing = spacing;
    },
    setHScale: function CanvasGraphics_setHScale(scale) {
      this.current.textHScale = scale / 100;
    },
    setLeading: function CanvasGraphics_setLeading(leading) {
      this.current.leading = -leading;
    },
    setFont: function CanvasGraphics_setFont(fontRefName, size) {
      var fontObj = this.commonObjs.get(fontRefName);
      var current = this.current;
      if (!fontObj) {
        throw new Error('Can\'t find font for ' + fontRefName);
      }
      current.fontMatrix = fontObj.fontMatrix ? fontObj.fontMatrix : _util.FONT_IDENTITY_MATRIX;
      if (current.fontMatrix[0] === 0 || current.fontMatrix[3] === 0) {
        (0, _util.warn)('Invalid font matrix for font ' + fontRefName);
      }
      if (size < 0) {
        size = -size;
        current.fontDirection = -1;
      } else {
        current.fontDirection = 1;
      }
      this.current.font = fontObj;
      this.current.fontSize = size;
      if (fontObj.isType3Font) {
        return;
      }
      var name = fontObj.loadedName || 'sans-serif';
      var bold = fontObj.black ? '900' : fontObj.bold ? 'bold' : 'normal';
      var italic = fontObj.italic ? 'italic' : 'normal';
      var typeface = '"' + name + '", ' + fontObj.fallbackName;
      var browserFontSize = size < MIN_FONT_SIZE ? MIN_FONT_SIZE : size > MAX_FONT_SIZE ? MAX_FONT_SIZE : size;
      this.current.fontSizeScale = size / browserFontSize;
      var rule = italic + ' ' + bold + ' ' + browserFontSize + 'px ' + typeface;
      this.ctx.font = rule;
    },
    setTextRenderingMode: function CanvasGraphics_setTextRenderingMode(mode) {
      this.current.textRenderingMode = mode;
    },
    setTextRise: function CanvasGraphics_setTextRise(rise) {
      this.current.textRise = rise;
    },
    moveText: function CanvasGraphics_moveText(x, y) {
      this.current.x = this.current.lineX += x;
      this.current.y = this.current.lineY += y;
    },
    setLeadingMoveText: function CanvasGraphics_setLeadingMoveText(x, y) {
      this.setLeading(-y);
      this.moveText(x, y);
    },
    setTextMatrix: function CanvasGraphics_setTextMatrix(a, b, c, d, e, f) {
      this.current.textMatrix = [a, b, c, d, e, f];
      this.current.textMatrixScale = Math.sqrt(a * a + b * b);
      this.current.x = this.current.lineX = 0;
      this.current.y = this.current.lineY = 0;
    },
    nextLine: function CanvasGraphics_nextLine() {
      this.moveText(0, this.current.leading);
    },
    paintChar: function CanvasGraphics_paintChar(character, x, y) {
      var ctx = this.ctx;
      var current = this.current;
      var font = current.font;
      var textRenderingMode = current.textRenderingMode;
      var fontSize = current.fontSize / current.fontSizeScale;
      var fillStrokeMode = textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
      var isAddToPathSet = !!(textRenderingMode & _util.TextRenderingMode.ADD_TO_PATH_FLAG);
      var addToPath;
      if (font.disableFontFace || isAddToPathSet) {
        addToPath = font.getPathGenerator(this.commonObjs, character);
      }
      if (font.disableFontFace) {
        ctx.save();
        ctx.translate(x, y);
        ctx.beginPath();
        addToPath(ctx, fontSize);
        if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
          ctx.fill();
        }
        if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
          ctx.stroke();
        }
        ctx.restore();
      } else {
        if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
          ctx.fillText(character, x, y);
        }
        if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
          ctx.strokeText(character, x, y);
        }
      }
      if (isAddToPathSet) {
        var paths = this.pendingTextPaths || (this.pendingTextPaths = []);
        paths.push({
          transform: ctx.mozCurrentTransform,
          x: x,
          y: y,
          fontSize: fontSize,
          addToPath: addToPath
        });
      }
    },
    get isFontSubpixelAAEnabled() {
      var ctx = this.canvasFactory.create(10, 10).context;
      ctx.scale(1.5, 1);
      ctx.fillText('I', 0, 10);
      var data = ctx.getImageData(0, 0, 10, 10).data;
      var enabled = false;
      for (var i = 3; i < data.length; i += 4) {
        if (data[i] > 0 && data[i] < 255) {
          enabled = true;
          break;
        }
      }
      return (0, _util.shadow)(this, 'isFontSubpixelAAEnabled', enabled);
    },
    showText: function CanvasGraphics_showText(glyphs) {
      var current = this.current;
      var font = current.font;
      if (font.isType3Font) {
        return this.showType3Text(glyphs);
      }
      var fontSize = current.fontSize;
      if (fontSize === 0) {
        return;
      }
      var ctx = this.ctx;
      var fontSizeScale = current.fontSizeScale;
      var charSpacing = current.charSpacing;
      var wordSpacing = current.wordSpacing;
      var fontDirection = current.fontDirection;
      var textHScale = current.textHScale * fontDirection;
      var glyphsLength = glyphs.length;
      var vertical = font.vertical;
      var spacingDir = vertical ? 1 : -1;
      var defaultVMetrics = font.defaultVMetrics;
      var widthAdvanceScale = fontSize * current.fontMatrix[0];
      var simpleFillText = current.textRenderingMode === _util.TextRenderingMode.FILL && !font.disableFontFace;
      ctx.save();
      ctx.transform.apply(ctx, current.textMatrix);
      ctx.translate(current.x, current.y + current.textRise);
      if (current.patternFill) {
        ctx.fillStyle = current.fillColor.getPattern(ctx, this);
      }
      if (fontDirection > 0) {
        ctx.scale(textHScale, -1);
      } else {
        ctx.scale(textHScale, 1);
      }
      var lineWidth = current.lineWidth;
      var scale = current.textMatrixScale;
      if (scale === 0 || lineWidth === 0) {
        var fillStrokeMode = current.textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
        if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
          this.cachedGetSinglePixelWidth = null;
          lineWidth = this.getSinglePixelWidth() * MIN_WIDTH_FACTOR;
        }
      } else {
        lineWidth /= scale;
      }
      if (fontSizeScale !== 1.0) {
        ctx.scale(fontSizeScale, fontSizeScale);
        lineWidth /= fontSizeScale;
      }
      ctx.lineWidth = lineWidth;
      var x = 0,
          i;
      for (i = 0; i < glyphsLength; ++i) {
        var glyph = glyphs[i];
        if ((0, _util.isNum)(glyph)) {
          x += spacingDir * glyph * fontSize / 1000;
          continue;
        }
        var restoreNeeded = false;
        var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
        var character = glyph.fontChar;
        var accent = glyph.accent;
        var scaledX, scaledY, scaledAccentX, scaledAccentY;
        var width = glyph.width;
        if (vertical) {
          var vmetric, vx, vy;
          vmetric = glyph.vmetric || defaultVMetrics;
          vx = glyph.vmetric ? vmetric[1] : width * 0.5;
          vx = -vx * widthAdvanceScale;
          vy = vmetric[2] * widthAdvanceScale;
          width = vmetric ? -vmetric[0] : width;
          scaledX = vx / fontSizeScale;
          scaledY = (x + vy) / fontSizeScale;
        } else {
          scaledX = x / fontSizeScale;
          scaledY = 0;
        }
        if (font.remeasure && width > 0) {
          var measuredWidth = ctx.measureText(character).width * 1000 / fontSize * fontSizeScale;
          if (width < measuredWidth && this.isFontSubpixelAAEnabled) {
            var characterScaleX = width / measuredWidth;
            restoreNeeded = true;
            ctx.save();
            ctx.scale(characterScaleX, 1);
            scaledX /= characterScaleX;
          } else if (width !== measuredWidth) {
            scaledX += (width - measuredWidth) / 2000 * fontSize / fontSizeScale;
          }
        }
        if (glyph.isInFont || font.missingFile) {
          if (simpleFillText && !accent) {
            ctx.fillText(character, scaledX, scaledY);
          } else {
            this.paintChar(character, scaledX, scaledY);
            if (accent) {
              scaledAccentX = scaledX + accent.offset.x / fontSizeScale;
              scaledAccentY = scaledY - accent.offset.y / fontSizeScale;
              this.paintChar(accent.fontChar, scaledAccentX, scaledAccentY);
            }
          }
        }
        var charWidth = width * widthAdvanceScale + spacing * fontDirection;
        x += charWidth;
        if (restoreNeeded) {
          ctx.restore();
        }
      }
      if (vertical) {
        current.y -= x * textHScale;
      } else {
        current.x += x * textHScale;
      }
      ctx.restore();
    },
    showType3Text: function CanvasGraphics_showType3Text(glyphs) {
      var ctx = this.ctx;
      var current = this.current;
      var font = current.font;
      var fontSize = current.fontSize;
      var fontDirection = current.fontDirection;
      var spacingDir = font.vertical ? 1 : -1;
      var charSpacing = current.charSpacing;
      var wordSpacing = current.wordSpacing;
      var textHScale = current.textHScale * fontDirection;
      var fontMatrix = current.fontMatrix || _util.FONT_IDENTITY_MATRIX;
      var glyphsLength = glyphs.length;
      var isTextInvisible = current.textRenderingMode === _util.TextRenderingMode.INVISIBLE;
      var i, glyph, width, spacingLength;
      if (isTextInvisible || fontSize === 0) {
        return;
      }
      this.cachedGetSinglePixelWidth = null;
      ctx.save();
      ctx.transform.apply(ctx, current.textMatrix);
      ctx.translate(current.x, current.y);
      ctx.scale(textHScale, fontDirection);
      for (i = 0; i < glyphsLength; ++i) {
        glyph = glyphs[i];
        if ((0, _util.isNum)(glyph)) {
          spacingLength = spacingDir * glyph * fontSize / 1000;
          this.ctx.translate(spacingLength, 0);
          current.x += spacingLength * textHScale;
          continue;
        }
        var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
        var operatorList = font.charProcOperatorList[glyph.operatorListId];
        if (!operatorList) {
          (0, _util.warn)('Type3 character "' + glyph.operatorListId + '" is not available.');
          continue;
        }
        this.processingType3 = glyph;
        this.save();
        ctx.scale(fontSize, fontSize);
        ctx.transform.apply(ctx, fontMatrix);
        this.executeOperatorList(operatorList);
        this.restore();
        var transformed = _util.Util.applyTransform([glyph.width, 0], fontMatrix);
        width = transformed[0] * fontSize + spacing;
        ctx.translate(width, 0);
        current.x += width * textHScale;
      }
      ctx.restore();
      this.processingType3 = null;
    },
    setCharWidth: function CanvasGraphics_setCharWidth(xWidth, yWidth) {},
    setCharWidthAndBounds: function CanvasGraphics_setCharWidthAndBounds(xWidth, yWidth, llx, lly, urx, ury) {
      this.ctx.rect(llx, lly, urx - llx, ury - lly);
      this.clip();
      this.endPath();
    },
    getColorN_Pattern: function CanvasGraphics_getColorN_Pattern(IR) {
      var _this = this;

      var pattern;
      if (IR[0] === 'TilingPattern') {
        var color = IR[1];
        var baseTransform = this.baseTransform || this.ctx.mozCurrentTransform.slice();
        var canvasGraphicsFactory = {
          createCanvasGraphics: function createCanvasGraphics(ctx) {
            return new CanvasGraphics(ctx, _this.commonObjs, _this.objs, _this.canvasFactory);
          }
        };
        pattern = new _pattern_helper.TilingPattern(IR, color, this.ctx, canvasGraphicsFactory, baseTransform);
      } else {
        pattern = (0, _pattern_helper.getShadingPatternFromIR)(IR);
      }
      return pattern;
    },
    setStrokeColorN: function CanvasGraphics_setStrokeColorN() {
      this.current.strokeColor = this.getColorN_Pattern(arguments);
    },
    setFillColorN: function CanvasGraphics_setFillColorN() {
      this.current.fillColor = this.getColorN_Pattern(arguments);
      this.current.patternFill = true;
    },
    setStrokeRGBColor: function CanvasGraphics_setStrokeRGBColor(r, g, b) {
      var color = _util.Util.makeCssRgb(r, g, b);
      this.ctx.strokeStyle = color;
      this.current.strokeColor = color;
    },
    setFillRGBColor: function CanvasGraphics_setFillRGBColor(r, g, b) {
      var color = _util.Util.makeCssRgb(r, g, b);
      this.ctx.fillStyle = color;
      this.current.fillColor = color;
      this.current.patternFill = false;
    },
    shadingFill: function CanvasGraphics_shadingFill(patternIR) {
      var ctx = this.ctx;
      this.save();
      var pattern = (0, _pattern_helper.getShadingPatternFromIR)(patternIR);
      ctx.fillStyle = pattern.getPattern(ctx, this, true);
      var inv = ctx.mozCurrentTransformInverse;
      if (inv) {
        var canvas = ctx.canvas;
        var width = canvas.width;
        var height = canvas.height;
        var bl = _util.Util.applyTransform([0, 0], inv);
        var br = _util.Util.applyTransform([0, height], inv);
        var ul = _util.Util.applyTransform([width, 0], inv);
        var ur = _util.Util.applyTransform([width, height], inv);
        var x0 = Math.min(bl[0], br[0], ul[0], ur[0]);
        var y0 = Math.min(bl[1], br[1], ul[1], ur[1]);
        var x1 = Math.max(bl[0], br[0], ul[0], ur[0]);
        var y1 = Math.max(bl[1], br[1], ul[1], ur[1]);
        this.ctx.fillRect(x0, y0, x1 - x0, y1 - y0);
      } else {
        this.ctx.fillRect(-1e10, -1e10, 2e10, 2e10);
      }
      this.restore();
    },
    beginInlineImage: function CanvasGraphics_beginInlineImage() {
      throw new Error('Should not call beginInlineImage');
    },
    beginImageData: function CanvasGraphics_beginImageData() {
      throw new Error('Should not call beginImageData');
    },
    paintFormXObjectBegin: function CanvasGraphics_paintFormXObjectBegin(matrix, bbox) {
      this.save();
      this.baseTransformStack.push(this.baseTransform);
      if ((0, _util.isArray)(matrix) && matrix.length === 6) {
        this.transform.apply(this, matrix);
      }
      this.baseTransform = this.ctx.mozCurrentTransform;
      if ((0, _util.isArray)(bbox) && bbox.length === 4) {
        var width = bbox[2] - bbox[0];
        var height = bbox[3] - bbox[1];
        this.ctx.rect(bbox[0], bbox[1], width, height);
        this.clip();
        this.endPath();
      }
    },
    paintFormXObjectEnd: function CanvasGraphics_paintFormXObjectEnd() {
      this.restore();
      this.baseTransform = this.baseTransformStack.pop();
    },
    beginGroup: function CanvasGraphics_beginGroup(group) {
      this.save();
      var currentCtx = this.ctx;
      if (!group.isolated) {
        (0, _util.info)('TODO: Support non-isolated groups.');
      }
      if (group.knockout) {
        (0, _util.warn)('Knockout groups not supported.');
      }
      var currentTransform = currentCtx.mozCurrentTransform;
      if (group.matrix) {
        currentCtx.transform.apply(currentCtx, group.matrix);
      }
      if (!group.bbox) {
        throw new Error('Bounding box is required.');
      }
      var bounds = _util.Util.getAxialAlignedBoundingBox(group.bbox, currentCtx.mozCurrentTransform);
      var canvasBounds = [0, 0, currentCtx.canvas.width, currentCtx.canvas.height];
      bounds = _util.Util.intersect(bounds, canvasBounds) || [0, 0, 0, 0];
      var offsetX = Math.floor(bounds[0]);
      var offsetY = Math.floor(bounds[1]);
      var drawnWidth = Math.max(Math.ceil(bounds[2]) - offsetX, 1);
      var drawnHeight = Math.max(Math.ceil(bounds[3]) - offsetY, 1);
      var scaleX = 1,
          scaleY = 1;
      if (drawnWidth > MAX_GROUP_SIZE) {
        scaleX = drawnWidth / MAX_GROUP_SIZE;
        drawnWidth = MAX_GROUP_SIZE;
      }
      if (drawnHeight > MAX_GROUP_SIZE) {
        scaleY = drawnHeight / MAX_GROUP_SIZE;
        drawnHeight = MAX_GROUP_SIZE;
      }
      var cacheId = 'groupAt' + this.groupLevel;
      if (group.smask) {
        cacheId += '_smask_' + this.smaskCounter++ % 2;
      }
      var scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight, true);
      var groupCtx = scratchCanvas.context;
      groupCtx.scale(1 / scaleX, 1 / scaleY);
      groupCtx.translate(-offsetX, -offsetY);
      groupCtx.transform.apply(groupCtx, currentTransform);
      if (group.smask) {
        this.smaskStack.push({
          canvas: scratchCanvas.canvas,
          context: groupCtx,
          offsetX: offsetX,
          offsetY: offsetY,
          scaleX: scaleX,
          scaleY: scaleY,
          subtype: group.smask.subtype,
          backdrop: group.smask.backdrop,
          transferMap: group.smask.transferMap || null,
          startTransformInverse: null
        });
      } else {
        currentCtx.setTransform(1, 0, 0, 1, 0, 0);
        currentCtx.translate(offsetX, offsetY);
        currentCtx.scale(scaleX, scaleY);
      }
      copyCtxState(currentCtx, groupCtx);
      this.ctx = groupCtx;
      this.setGState([['BM', 'source-over'], ['ca', 1], ['CA', 1]]);
      this.groupStack.push(currentCtx);
      this.groupLevel++;
      this.current.activeSMask = null;
    },
    endGroup: function CanvasGraphics_endGroup(group) {
      this.groupLevel--;
      var groupCtx = this.ctx;
      this.ctx = this.groupStack.pop();
      if (this.ctx.imageSmoothingEnabled !== undefined) {
        this.ctx.imageSmoothingEnabled = false;
      } else {
        this.ctx.mozImageSmoothingEnabled = false;
      }
      if (group.smask) {
        this.tempSMask = this.smaskStack.pop();
      } else {
        this.ctx.drawImage(groupCtx.canvas, 0, 0);
      }
      this.restore();
    },
    beginAnnotations: function CanvasGraphics_beginAnnotations() {
      this.save();
      if (this.baseTransform) {
        this.ctx.setTransform.apply(this.ctx, this.baseTransform);
      }
    },
    endAnnotations: function CanvasGraphics_endAnnotations() {
      this.restore();
    },
    beginAnnotation: function CanvasGraphics_beginAnnotation(rect, transform, matrix) {
      this.save();
      resetCtxToDefault(this.ctx);
      this.current = new CanvasExtraState();
      if ((0, _util.isArray)(rect) && rect.length === 4) {
        var width = rect[2] - rect[0];
        var height = rect[3] - rect[1];
        this.ctx.rect(rect[0], rect[1], width, height);
        this.clip();
        this.endPath();
      }
      this.transform.apply(this, transform);
      this.transform.apply(this, matrix);
    },
    endAnnotation: function CanvasGraphics_endAnnotation() {
      this.restore();
    },
    paintJpegXObject: function CanvasGraphics_paintJpegXObject(objId, w, h) {
      var domImage = this.objs.get(objId);
      if (!domImage) {
        (0, _util.warn)('Dependent image isn\'t ready yet');
        return;
      }
      this.save();
      var ctx = this.ctx;
      ctx.scale(1 / w, -1 / h);
      ctx.drawImage(domImage, 0, 0, domImage.width, domImage.height, 0, -h, w, h);
      if (this.imageLayer) {
        var currentTransform = ctx.mozCurrentTransformInverse;
        var position = this.getCanvasPosition(0, 0);
        this.imageLayer.appendImage({
          objId: objId,
          left: position[0],
          top: position[1],
          width: w / currentTransform[0],
          height: h / currentTransform[3]
        });
      }
      this.restore();
    },
    paintImageMaskXObject: function CanvasGraphics_paintImageMaskXObject(img) {
      var ctx = this.ctx;
      var width = img.width,
          height = img.height;
      var fillColor = this.current.fillColor;
      var isPatternFill = this.current.patternFill;
      var glyph = this.processingType3;
      if (COMPILE_TYPE3_GLYPHS && glyph && glyph.compiled === undefined) {
        if (width <= MAX_SIZE_TO_COMPILE && height <= MAX_SIZE_TO_COMPILE) {
          glyph.compiled = compileType3Glyph({
            data: img.data,
            width: width,
            height: height
          });
        } else {
          glyph.compiled = null;
        }
      }
      if (glyph && glyph.compiled) {
        glyph.compiled(ctx);
        return;
      }
      var maskCanvas = this.cachedCanvases.getCanvas('maskCanvas', width, height);
      var maskCtx = maskCanvas.context;
      maskCtx.save();
      putBinaryImageMask(maskCtx, img);
      maskCtx.globalCompositeOperation = 'source-in';
      maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this) : fillColor;
      maskCtx.fillRect(0, 0, width, height);
      maskCtx.restore();
      this.paintInlineImageXObject(maskCanvas.canvas);
    },
    paintImageMaskXObjectRepeat: function CanvasGraphics_paintImageMaskXObjectRepeat(imgData, scaleX, scaleY, positions) {
      var width = imgData.width;
      var height = imgData.height;
      var fillColor = this.current.fillColor;
      var isPatternFill = this.current.patternFill;
      var maskCanvas = this.cachedCanvases.getCanvas('maskCanvas', width, height);
      var maskCtx = maskCanvas.context;
      maskCtx.save();
      putBinaryImageMask(maskCtx, imgData);
      maskCtx.globalCompositeOperation = 'source-in';
      maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this) : fillColor;
      maskCtx.fillRect(0, 0, width, height);
      maskCtx.restore();
      var ctx = this.ctx;
      for (var i = 0, ii = positions.length; i < ii; i += 2) {
        ctx.save();
        ctx.transform(scaleX, 0, 0, scaleY, positions[i], positions[i + 1]);
        ctx.scale(1, -1);
        ctx.drawImage(maskCanvas.canvas, 0, 0, width, height, 0, -1, 1, 1);
        ctx.restore();
      }
    },
    paintImageMaskXObjectGroup: function CanvasGraphics_paintImageMaskXObjectGroup(images) {
      var ctx = this.ctx;
      var fillColor = this.current.fillColor;
      var isPatternFill = this.current.patternFill;
      for (var i = 0, ii = images.length; i < ii; i++) {
        var image = images[i];
        var width = image.width,
            height = image.height;
        var maskCanvas = this.cachedCanvases.getCanvas('maskCanvas', width, height);
        var maskCtx = maskCanvas.context;
        maskCtx.save();
        putBinaryImageMask(maskCtx, image);
        maskCtx.globalCompositeOperation = 'source-in';
        maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this) : fillColor;
        maskCtx.fillRect(0, 0, width, height);
        maskCtx.restore();
        ctx.save();
        ctx.transform.apply(ctx, image.transform);
        ctx.scale(1, -1);
        ctx.drawImage(maskCanvas.canvas, 0, 0, width, height, 0, -1, 1, 1);
        ctx.restore();
      }
    },
    paintImageXObject: function CanvasGraphics_paintImageXObject(objId) {
      var imgData = this.objs.get(objId);
      if (!imgData) {
        (0, _util.warn)('Dependent image isn\'t ready yet');
        return;
      }
      this.paintInlineImageXObject(imgData);
    },
    paintImageXObjectRepeat: function CanvasGraphics_paintImageXObjectRepeat(objId, scaleX, scaleY, positions) {
      var imgData = this.objs.get(objId);
      if (!imgData) {
        (0, _util.warn)('Dependent image isn\'t ready yet');
        return;
      }
      var width = imgData.width;
      var height = imgData.height;
      var map = [];
      for (var i = 0, ii = positions.length; i < ii; i += 2) {
        map.push({
          transform: [scaleX, 0, 0, scaleY, positions[i], positions[i + 1]],
          x: 0,
          y: 0,
          w: width,
          h: height
        });
      }
      this.paintInlineImageXObjectGroup(imgData, map);
    },
    paintInlineImageXObject: function CanvasGraphics_paintInlineImageXObject(imgData) {
      var width = imgData.width;
      var height = imgData.height;
      var ctx = this.ctx;
      this.save();
      ctx.scale(1 / width, -1 / height);
      var currentTransform = ctx.mozCurrentTransformInverse;
      var a = currentTransform[0],
          b = currentTransform[1];
      var widthScale = Math.max(Math.sqrt(a * a + b * b), 1);
      var c = currentTransform[2],
          d = currentTransform[3];
      var heightScale = Math.max(Math.sqrt(c * c + d * d), 1);
      var imgToPaint, tmpCanvas;
      if (imgData instanceof HTMLElement || !imgData.data) {
        imgToPaint = imgData;
      } else {
        tmpCanvas = this.cachedCanvases.getCanvas('inlineImage', width, height);
        var tmpCtx = tmpCanvas.context;
        putBinaryImageData(tmpCtx, imgData);
        imgToPaint = tmpCanvas.canvas;
      }
      var paintWidth = width,
          paintHeight = height;
      var tmpCanvasId = 'prescale1';
      while (widthScale > 2 && paintWidth > 1 || heightScale > 2 && paintHeight > 1) {
        var newWidth = paintWidth,
            newHeight = paintHeight;
        if (widthScale > 2 && paintWidth > 1) {
          newWidth = Math.ceil(paintWidth / 2);
          widthScale /= paintWidth / newWidth;
        }
        if (heightScale > 2 && paintHeight > 1) {
          newHeight = Math.ceil(paintHeight / 2);
          heightScale /= paintHeight / newHeight;
        }
        tmpCanvas = this.cachedCanvases.getCanvas(tmpCanvasId, newWidth, newHeight);
        tmpCtx = tmpCanvas.context;
        tmpCtx.clearRect(0, 0, newWidth, newHeight);
        tmpCtx.drawImage(imgToPaint, 0, 0, paintWidth, paintHeight, 0, 0, newWidth, newHeight);
        imgToPaint = tmpCanvas.canvas;
        paintWidth = newWidth;
        paintHeight = newHeight;
        tmpCanvasId = tmpCanvasId === 'prescale1' ? 'prescale2' : 'prescale1';
      }
      ctx.drawImage(imgToPaint, 0, 0, paintWidth, paintHeight, 0, -height, width, height);
      if (this.imageLayer) {
        var position = this.getCanvasPosition(0, -height);
        this.imageLayer.appendImage({
          imgData: imgData,
          left: position[0],
          top: position[1],
          width: width / currentTransform[0],
          height: height / currentTransform[3]
        });
      }
      this.restore();
    },
    paintInlineImageXObjectGroup: function CanvasGraphics_paintInlineImageXObjectGroup(imgData, map) {
      var ctx = this.ctx;
      var w = imgData.width;
      var h = imgData.height;
      var tmpCanvas = this.cachedCanvases.getCanvas('inlineImage', w, h);
      var tmpCtx = tmpCanvas.context;
      putBinaryImageData(tmpCtx, imgData);
      for (var i = 0, ii = map.length; i < ii; i++) {
        var entry = map[i];
        ctx.save();
        ctx.transform.apply(ctx, entry.transform);
        ctx.scale(1, -1);
        ctx.drawImage(tmpCanvas.canvas, entry.x, entry.y, entry.w, entry.h, 0, -1, 1, 1);
        if (this.imageLayer) {
          var position = this.getCanvasPosition(entry.x, entry.y);
          this.imageLayer.appendImage({
            imgData: imgData,
            left: position[0],
            top: position[1],
            width: w,
            height: h
          });
        }
        ctx.restore();
      }
    },
    paintSolidColorImageMask: function CanvasGraphics_paintSolidColorImageMask() {
      this.ctx.fillRect(0, 0, 1, 1);
    },
    paintXObject: function CanvasGraphics_paintXObject() {
      (0, _util.warn)('Unsupported \'paintXObject\' command.');
    },
    markPoint: function CanvasGraphics_markPoint(tag) {},
    markPointProps: function CanvasGraphics_markPointProps(tag, properties) {},
    beginMarkedContent: function CanvasGraphics_beginMarkedContent(tag) {},
    beginMarkedContentProps: function CanvasGraphics_beginMarkedContentProps(tag, properties) {},
    endMarkedContent: function CanvasGraphics_endMarkedContent() {},
    beginCompat: function CanvasGraphics_beginCompat() {},
    endCompat: function CanvasGraphics_endCompat() {},
    consumePath: function CanvasGraphics_consumePath() {
      var ctx = this.ctx;
      if (this.pendingClip) {
        if (this.pendingClip === EO_CLIP) {
          ctx.clip('evenodd');
        } else {
          ctx.clip();
        }
        this.pendingClip = null;
      }
      ctx.beginPath();
    },
    getSinglePixelWidth: function CanvasGraphics_getSinglePixelWidth(scale) {
      if (this.cachedGetSinglePixelWidth === null) {
        this.ctx.save();
        var inverse = this.ctx.mozCurrentTransformInverse;
        this.ctx.restore();
        this.cachedGetSinglePixelWidth = Math.sqrt(Math.max(inverse[0] * inverse[0] + inverse[1] * inverse[1], inverse[2] * inverse[2] + inverse[3] * inverse[3]));
      }
      return this.cachedGetSinglePixelWidth;
    },
    getCanvasPosition: function CanvasGraphics_getCanvasPosition(x, y) {
      var transform = this.ctx.mozCurrentTransform;
      return [transform[0] * x + transform[2] * y + transform[4], transform[1] * x + transform[3] * y + transform[5]];
    }
  };
  for (var op in _util.OPS) {
    CanvasGraphics.prototype[_util.OPS[op]] = CanvasGraphics.prototype[op];
  }
  return CanvasGraphics;
}();
exports.CanvasGraphics = CanvasGraphics;

/***/ }),
/* 12 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FontLoader = exports.FontFaceObject = undefined;

var _util = __w_pdfjs_require__(0);

function FontLoader(docId) {
  this.docId = docId;
  this.styleElement = null;
  this.nativeFontFaces = [];
  this.loadTestFontId = 0;
  this.loadingContext = {
    requests: [],
    nextRequestId: 0
  };
}
FontLoader.prototype = {
  insertRule: function fontLoaderInsertRule(rule) {
    var styleElement = this.styleElement;
    if (!styleElement) {
      styleElement = this.styleElement = document.createElement('style');
      styleElement.id = 'PDFJS_FONT_STYLE_TAG_' + this.docId;
      document.documentElement.getElementsByTagName('head')[0].appendChild(styleElement);
    }
    var styleSheet = styleElement.sheet;
    styleSheet.insertRule(rule, styleSheet.cssRules.length);
  },
  clear: function fontLoaderClear() {
    if (this.styleElement) {
      this.styleElement.remove();
      this.styleElement = null;
    }
    this.nativeFontFaces.forEach(function (nativeFontFace) {
      document.fonts.delete(nativeFontFace);
    });
    this.nativeFontFaces.length = 0;
  }
};
{
  var getLoadTestFont = function getLoadTestFont() {
    return atob('T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQAFQ' + 'AABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAAALwA' + 'AAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgAAAAGbm' + 'FtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1AAsD6AAA' + 'AADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD6AAAAAAD6A' + 'ABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACMAooCvAAAAeAA' + 'MQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4DIP84AFoDIQAAAA' + 'AAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAAAAEAAQAAAAEAAAAA' + 'AAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUAAQAAAAEAAAAAAAYAAQ' + 'AAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgABAAMAAQQJAAMAAgABAAMA' + 'AQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABYAAAAAAAAAwAAAAMAAAAcAA' + 'EAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAAAC7////TAAEAAAAAAAABBgAA' + 'AQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAA' + 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' + 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' + 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' + 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAA' + 'AAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAAAAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgc' + 'A/gXBIwMAYuL+nz5tQXkD5j3CBLnEQACAQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWF' + 'hYWFhYWFhYAAABAQAADwACAQEEE/t3Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQA' + 'AAAAAAABAAAAAMmJbzEAAAAAzgTjFQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAg' + 'ABAAAAAAAAAAAD6AAAAAAAAA==');
  };
  Object.defineProperty(FontLoader.prototype, 'loadTestFont', {
    get: function get() {
      return (0, _util.shadow)(this, 'loadTestFont', getLoadTestFont());
    },

    configurable: true
  });
  FontLoader.prototype.addNativeFontFace = function fontLoader_addNativeFontFace(nativeFontFace) {
    this.nativeFontFaces.push(nativeFontFace);
    document.fonts.add(nativeFontFace);
  };
  FontLoader.prototype.bind = function fontLoaderBind(fonts, callback) {
    var rules = [];
    var fontsToLoad = [];
    var fontLoadPromises = [];
    var getNativeFontPromise = function getNativeFontPromise(nativeFontFace) {
      return nativeFontFace.loaded.catch(function (e) {
        (0, _util.warn)('Failed to load font "' + nativeFontFace.family + '": ' + e);
      });
    };
    var isFontLoadingAPISupported = FontLoader.isFontLoadingAPISupported && !FontLoader.isSyncFontLoadingSupported;
    for (var i = 0, ii = fonts.length; i < ii; i++) {
      var font = fonts[i];
      if (font.attached || font.loading === false) {
        continue;
      }
      font.attached = true;
      if (isFontLoadingAPISupported) {
        var nativeFontFace = font.createNativeFontFace();
        if (nativeFontFace) {
          this.addNativeFontFace(nativeFontFace);
          fontLoadPromises.push(getNativeFontPromise(nativeFontFace));
        }
      } else {
        var rule = font.createFontFaceRule();
        if (rule) {
          this.insertRule(rule);
          rules.push(rule);
          fontsToLoad.push(font);
        }
      }
    }
    var request = this.queueLoadingCallback(callback);
    if (isFontLoadingAPISupported) {
      Promise.all(fontLoadPromises).then(function () {
        request.complete();
      });
    } else if (rules.length > 0 && !FontLoader.isSyncFontLoadingSupported) {
      this.prepareFontLoadEvent(rules, fontsToLoad, request);
    } else {
      request.complete();
    }
  };
  FontLoader.prototype.queueLoadingCallback = function FontLoader_queueLoadingCallback(callback) {
    function LoadLoader_completeRequest() {
      (0, _util.assert)(!request.end, 'completeRequest() cannot be called twice');
      request.end = Date.now();
      while (context.requests.length > 0 && context.requests[0].end) {
        var otherRequest = context.requests.shift();
        setTimeout(otherRequest.callback, 0);
      }
    }
    var context = this.loadingContext;
    var requestId = 'pdfjs-font-loading-' + context.nextRequestId++;
    var request = {
      id: requestId,
      complete: LoadLoader_completeRequest,
      callback: callback,
      started: Date.now()
    };
    context.requests.push(request);
    return request;
  };
  FontLoader.prototype.prepareFontLoadEvent = function fontLoaderPrepareFontLoadEvent(rules, fonts, request) {
    function int32(data, offset) {
      return data.charCodeAt(offset) << 24 | data.charCodeAt(offset + 1) << 16 | data.charCodeAt(offset + 2) << 8 | data.charCodeAt(offset + 3) & 0xff;
    }
    function spliceString(s, offset, remove, insert) {
      var chunk1 = s.substr(0, offset);
      var chunk2 = s.substr(offset + remove);
      return chunk1 + insert + chunk2;
    }
    var i, ii;
    var canvas = document.createElement('canvas');
    canvas.width = 1;
    canvas.height = 1;
    var ctx = canvas.getContext('2d');
    var called = 0;
    function isFontReady(name, callback) {
      called++;
      if (called > 30) {
        (0, _util.warn)('Load test font never loaded.');
        callback();
        return;
      }
      ctx.font = '30px ' + name;
      ctx.fillText('.', 0, 20);
      var imageData = ctx.getImageData(0, 0, 1, 1);
      if (imageData.data[3] > 0) {
        callback();
        return;
      }
      setTimeout(isFontReady.bind(null, name, callback));
    }
    var loadTestFontId = 'lt' + Date.now() + this.loadTestFontId++;
    var data = this.loadTestFont;
    var COMMENT_OFFSET = 976;
    data = spliceString(data, COMMENT_OFFSET, loadTestFontId.length, loadTestFontId);
    var CFF_CHECKSUM_OFFSET = 16;
    var XXXX_VALUE = 0x58585858;
    var checksum = int32(data, CFF_CHECKSUM_OFFSET);
    for (i = 0, ii = loadTestFontId.length - 3; i < ii; i += 4) {
      checksum = checksum - XXXX_VALUE + int32(loadTestFontId, i) | 0;
    }
    if (i < loadTestFontId.length) {
      checksum = checksum - XXXX_VALUE + int32(loadTestFontId + 'XXX', i) | 0;
    }
    data = spliceString(data, CFF_CHECKSUM_OFFSET, 4, (0, _util.string32)(checksum));
    var url = 'url(data:font/opentype;base64,' + btoa(data) + ');';
    var rule = '@font-face { font-family:"' + loadTestFontId + '";src:' + url + '}';
    this.insertRule(rule);
    var names = [];
    for (i = 0, ii = fonts.length; i < ii; i++) {
      names.push(fonts[i].loadedName);
    }
    names.push(loadTestFontId);
    var div = document.createElement('div');
    div.setAttribute('style', 'visibility: hidden;' + 'width: 10px; height: 10px;' + 'position: absolute; top: 0px; left: 0px;');
    for (i = 0, ii = names.length; i < ii; ++i) {
      var span = document.createElement('span');
      span.textContent = 'Hi';
      span.style.fontFamily = names[i];
      div.appendChild(span);
    }
    document.body.appendChild(div);
    isFontReady(loadTestFontId, function () {
      document.body.removeChild(div);
      request.complete();
    });
  };
}
{
  FontLoader.isFontLoadingAPISupported = typeof document !== 'undefined' && !!document.fonts;
}
{
  var isSyncFontLoadingSupported = function isSyncFontLoadingSupported() {
    if (typeof navigator === 'undefined') {
      return true;
    }
    var supported = false;
    var m = /Mozilla\/5.0.*?rv:(\d+).*? Gecko/.exec(navigator.userAgent);
    if (m && m[1] >= 14) {
      supported = true;
    }
    return supported;
  };
  Object.defineProperty(FontLoader, 'isSyncFontLoadingSupported', {
    get: function get() {
      return (0, _util.shadow)(FontLoader, 'isSyncFontLoadingSupported', isSyncFontLoadingSupported());
    },

    enumerable: true,
    configurable: true
  });
}
var IsEvalSupportedCached = {
  get value() {
    return (0, _util.shadow)(this, 'value', (0, _util.isEvalSupported)());
  }
};
var FontFaceObject = function FontFaceObjectClosure() {
  function FontFaceObject(translatedData, options) {
    this.compiledGlyphs = Object.create(null);
    for (var i in translatedData) {
      this[i] = translatedData[i];
    }
    this.options = options;
  }
  FontFaceObject.prototype = {
    createNativeFontFace: function FontFaceObject_createNativeFontFace() {
      if (!this.data) {
        return null;
      }
      if (this.options.disableFontFace) {
        this.disableFontFace = true;
        return null;
      }
      var nativeFontFace = new FontFace(this.loadedName, this.data, {});
      if (this.options.fontRegistry) {
        this.options.fontRegistry.registerFont(this);
      }
      return nativeFontFace;
    },
    createFontFaceRule: function FontFaceObject_createFontFaceRule() {
      if (!this.data) {
        return null;
      }
      if (this.options.disableFontFace) {
        this.disableFontFace = true;
        return null;
      }
      var data = (0, _util.bytesToString)(new Uint8Array(this.data));
      var fontName = this.loadedName;
      var url = 'url(data:' + this.mimetype + ';base64,' + btoa(data) + ');';
      var rule = '@font-face { font-family:"' + fontName + '";src:' + url + '}';
      if (this.options.fontRegistry) {
        this.options.fontRegistry.registerFont(this, url);
      }
      return rule;
    },
    getPathGenerator: function FontFaceObject_getPathGenerator(objs, character) {
      if (!(character in this.compiledGlyphs)) {
        var cmds = objs.get(this.loadedName + '_path_' + character);
        var current, i, len;
        if (this.options.isEvalSupported && IsEvalSupportedCached.value) {
          var args,
              js = '';
          for (i = 0, len = cmds.length; i < len; i++) {
            current = cmds[i];
            if (current.args !== undefined) {
              args = current.args.join(',');
            } else {
              args = '';
            }
            js += 'c.' + current.cmd + '(' + args + ');\n';
          }
          this.compiledGlyphs[character] = new Function('c', 'size', js);
        } else {
          this.compiledGlyphs[character] = function (c, size) {
            for (i = 0, len = cmds.length; i < len; i++) {
              current = cmds[i];
              if (current.cmd === 'scale') {
                current.args = [size, -size];
              }
              c[current.cmd].apply(c, current.args);
            }
          };
        }
      }
      return this.compiledGlyphs[character];
    }
  };
  return FontFaceObject;
}();
exports.FontFaceObject = FontFaceObject;
exports.FontLoader = FontLoader;

/***/ }),
/* 13 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TilingPattern = exports.getShadingPatternFromIR = undefined;

var _util = __w_pdfjs_require__(0);

var _webgl = __w_pdfjs_require__(7);

var ShadingIRs = {};
ShadingIRs.RadialAxial = {
  fromIR: function RadialAxial_fromIR(raw) {
    var type = raw[1];
    var colorStops = raw[2];
    var p0 = raw[3];
    var p1 = raw[4];
    var r0 = raw[5];
    var r1 = raw[6];
    return {
      type: 'Pattern',
      getPattern: function RadialAxial_getPattern(ctx) {
        var grad;
        if (type === 'axial') {
          grad = ctx.createLinearGradient(p0[0], p0[1], p1[0], p1[1]);
        } else if (type === 'radial') {
          grad = ctx.createRadialGradient(p0[0], p0[1], r0, p1[0], p1[1], r1);
        }
        for (var i = 0, ii = colorStops.length; i < ii; ++i) {
          var c = colorStops[i];
          grad.addColorStop(c[0], c[1]);
        }
        return grad;
      }
    };
  }
};
var createMeshCanvas = function createMeshCanvasClosure() {
  function drawTriangle(data, context, p1, p2, p3, c1, c2, c3) {
    var coords = context.coords,
        colors = context.colors;
    var bytes = data.data,
        rowSize = data.width * 4;
    var tmp;
    if (coords[p1 + 1] > coords[p2 + 1]) {
      tmp = p1;
      p1 = p2;
      p2 = tmp;
      tmp = c1;
      c1 = c2;
      c2 = tmp;
    }
    if (coords[p2 + 1] > coords[p3 + 1]) {
      tmp = p2;
      p2 = p3;
      p3 = tmp;
      tmp = c2;
      c2 = c3;
      c3 = tmp;
    }
    if (coords[p1 + 1] > coords[p2 + 1]) {
      tmp = p1;
      p1 = p2;
      p2 = tmp;
      tmp = c1;
      c1 = c2;
      c2 = tmp;
    }
    var x1 = (coords[p1] + context.offsetX) * context.scaleX;
    var y1 = (coords[p1 + 1] + context.offsetY) * context.scaleY;
    var x2 = (coords[p2] + context.offsetX) * context.scaleX;
    var y2 = (coords[p2 + 1] + context.offsetY) * context.scaleY;
    var x3 = (coords[p3] + context.offsetX) * context.scaleX;
    var y3 = (coords[p3 + 1] + context.offsetY) * context.scaleY;
    if (y1 >= y3) {
      return;
    }
    var c1r = colors[c1],
        c1g = colors[c1 + 1],
        c1b = colors[c1 + 2];
    var c2r = colors[c2],
        c2g = colors[c2 + 1],
        c2b = colors[c2 + 2];
    var c3r = colors[c3],
        c3g = colors[c3 + 1],
        c3b = colors[c3 + 2];
    var minY = Math.round(y1),
        maxY = Math.round(y3);
    var xa, car, cag, cab;
    var xb, cbr, cbg, cbb;
    var k;
    for (var y = minY; y <= maxY; y++) {
      if (y < y2) {
        k = y < y1 ? 0 : y1 === y2 ? 1 : (y1 - y) / (y1 - y2);
        xa = x1 - (x1 - x2) * k;
        car = c1r - (c1r - c2r) * k;
        cag = c1g - (c1g - c2g) * k;
        cab = c1b - (c1b - c2b) * k;
      } else {
        k = y > y3 ? 1 : y2 === y3 ? 0 : (y2 - y) / (y2 - y3);
        xa = x2 - (x2 - x3) * k;
        car = c2r - (c2r - c3r) * k;
        cag = c2g - (c2g - c3g) * k;
        cab = c2b - (c2b - c3b) * k;
      }
      k = y < y1 ? 0 : y > y3 ? 1 : (y1 - y) / (y1 - y3);
      xb = x1 - (x1 - x3) * k;
      cbr = c1r - (c1r - c3r) * k;
      cbg = c1g - (c1g - c3g) * k;
      cbb = c1b - (c1b - c3b) * k;
      var x1_ = Math.round(Math.min(xa, xb));
      var x2_ = Math.round(Math.max(xa, xb));
      var j = rowSize * y + x1_ * 4;
      for (var x = x1_; x <= x2_; x++) {
        k = (xa - x) / (xa - xb);
        k = k < 0 ? 0 : k > 1 ? 1 : k;
        bytes[j++] = car - (car - cbr) * k | 0;
        bytes[j++] = cag - (cag - cbg) * k | 0;
        bytes[j++] = cab - (cab - cbb) * k | 0;
        bytes[j++] = 255;
      }
    }
  }
  function drawFigure(data, figure, context) {
    var ps = figure.coords;
    var cs = figure.colors;
    var i, ii;
    switch (figure.type) {
      case 'lattice':
        var verticesPerRow = figure.verticesPerRow;
        var rows = Math.floor(ps.length / verticesPerRow) - 1;
        var cols = verticesPerRow - 1;
        for (i = 0; i < rows; i++) {
          var q = i * verticesPerRow;
          for (var j = 0; j < cols; j++, q++) {
            drawTriangle(data, context, ps[q], ps[q + 1], ps[q + verticesPerRow], cs[q], cs[q + 1], cs[q + verticesPerRow]);
            drawTriangle(data, context, ps[q + verticesPerRow + 1], ps[q + 1], ps[q + verticesPerRow], cs[q + verticesPerRow + 1], cs[q + 1], cs[q + verticesPerRow]);
          }
        }
        break;
      case 'triangles':
        for (i = 0, ii = ps.length; i < ii; i += 3) {
          drawTriangle(data, context, ps[i], ps[i + 1], ps[i + 2], cs[i], cs[i + 1], cs[i + 2]);
        }
        break;
      default:
        throw new Error('illegal figure');
    }
  }
  function createMeshCanvas(bounds, combinesScale, coords, colors, figures, backgroundColor, cachedCanvases) {
    var EXPECTED_SCALE = 1.1;
    var MAX_PATTERN_SIZE = 3000;
    var BORDER_SIZE = 2;
    var offsetX = Math.floor(bounds[0]);
    var offsetY = Math.floor(bounds[1]);
    var boundsWidth = Math.ceil(bounds[2]) - offsetX;
    var boundsHeight = Math.ceil(bounds[3]) - offsetY;
    var width = Math.min(Math.ceil(Math.abs(boundsWidth * combinesScale[0] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
    var height = Math.min(Math.ceil(Math.abs(boundsHeight * combinesScale[1] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
    var scaleX = boundsWidth / width;
    var scaleY = boundsHeight / height;
    var context = {
      coords: coords,
      colors: colors,
      offsetX: -offsetX,
      offsetY: -offsetY,
      scaleX: 1 / scaleX,
      scaleY: 1 / scaleY
    };
    var paddedWidth = width + BORDER_SIZE * 2;
    var paddedHeight = height + BORDER_SIZE * 2;
    var canvas, tmpCanvas, i, ii;
    if (_webgl.WebGLUtils.isEnabled) {
      canvas = _webgl.WebGLUtils.drawFigures(width, height, backgroundColor, figures, context);
      tmpCanvas = cachedCanvases.getCanvas('mesh', paddedWidth, paddedHeight, false);
      tmpCanvas.context.drawImage(canvas, BORDER_SIZE, BORDER_SIZE);
      canvas = tmpCanvas.canvas;
    } else {
      tmpCanvas = cachedCanvases.getCanvas('mesh', paddedWidth, paddedHeight, false);
      var tmpCtx = tmpCanvas.context;
      var data = tmpCtx.createImageData(width, height);
      if (backgroundColor) {
        var bytes = data.data;
        for (i = 0, ii = bytes.length; i < ii; i += 4) {
          bytes[i] = backgroundColor[0];
          bytes[i + 1] = backgroundColor[1];
          bytes[i + 2] = backgroundColor[2];
          bytes[i + 3] = 255;
        }
      }
      for (i = 0; i < figures.length; i++) {
        drawFigure(data, figures[i], context);
      }
      tmpCtx.putImageData(data, BORDER_SIZE, BORDER_SIZE);
      canvas = tmpCanvas.canvas;
    }
    return {
      canvas: canvas,
      offsetX: offsetX - BORDER_SIZE * scaleX,
      offsetY: offsetY - BORDER_SIZE * scaleY,
      scaleX: scaleX,
      scaleY: scaleY
    };
  }
  return createMeshCanvas;
}();
ShadingIRs.Mesh = {
  fromIR: function Mesh_fromIR(raw) {
    var coords = raw[2];
    var colors = raw[3];
    var figures = raw[4];
    var bounds = raw[5];
    var matrix = raw[6];
    var background = raw[8];
    return {
      type: 'Pattern',
      getPattern: function Mesh_getPattern(ctx, owner, shadingFill) {
        var scale;
        if (shadingFill) {
          scale = _util.Util.singularValueDecompose2dScale(ctx.mozCurrentTransform);
        } else {
          scale = _util.Util.singularValueDecompose2dScale(owner.baseTransform);
          if (matrix) {
            var matrixScale = _util.Util.singularValueDecompose2dScale(matrix);
            scale = [scale[0] * matrixScale[0], scale[1] * matrixScale[1]];
          }
        }
        var temporaryPatternCanvas = createMeshCanvas(bounds, scale, coords, colors, figures, shadingFill ? null : background, owner.cachedCanvases);
        if (!shadingFill) {
          ctx.setTransform.apply(ctx, owner.baseTransform);
          if (matrix) {
            ctx.transform.apply(ctx, matrix);
          }
        }
        ctx.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
        ctx.scale(temporaryPatternCanvas.scaleX, temporaryPatternCanvas.scaleY);
        return ctx.createPattern(temporaryPatternCanvas.canvas, 'no-repeat');
      }
    };
  }
};
ShadingIRs.Dummy = {
  fromIR: function Dummy_fromIR() {
    return {
      type: 'Pattern',
      getPattern: function Dummy_fromIR_getPattern() {
        return 'hotpink';
      }
    };
  }
};
function getShadingPatternFromIR(raw) {
  var shadingIR = ShadingIRs[raw[0]];
  if (!shadingIR) {
    throw new Error('Unknown IR type: ' + raw[0]);
  }
  return shadingIR.fromIR(raw);
}
var TilingPattern = function TilingPatternClosure() {
  var PaintType = {
    COLORED: 1,
    UNCOLORED: 2
  };
  var MAX_PATTERN_SIZE = 3000;
  function TilingPattern(IR, color, ctx, canvasGraphicsFactory, baseTransform) {
    this.operatorList = IR[2];
    this.matrix = IR[3] || [1, 0, 0, 1, 0, 0];
    this.bbox = IR[4];
    this.xstep = IR[5];
    this.ystep = IR[6];
    this.paintType = IR[7];
    this.tilingType = IR[8];
    this.color = color;
    this.canvasGraphicsFactory = canvasGraphicsFactory;
    this.baseTransform = baseTransform;
    this.type = 'Pattern';
    this.ctx = ctx;
  }
  TilingPattern.prototype = {
    createPatternCanvas: function TilinPattern_createPatternCanvas(owner) {
      var operatorList = this.operatorList;
      var bbox = this.bbox;
      var xstep = this.xstep;
      var ystep = this.ystep;
      var paintType = this.paintType;
      var tilingType = this.tilingType;
      var color = this.color;
      var canvasGraphicsFactory = this.canvasGraphicsFactory;
      (0, _util.info)('TilingType: ' + tilingType);
      var x0 = bbox[0],
          y0 = bbox[1],
          x1 = bbox[2],
          y1 = bbox[3];
      var topLeft = [x0, y0];
      var botRight = [x0 + xstep, y0 + ystep];
      var width = botRight[0] - topLeft[0];
      var height = botRight[1] - topLeft[1];
      var matrixScale = _util.Util.singularValueDecompose2dScale(this.matrix);
      var curMatrixScale = _util.Util.singularValueDecompose2dScale(this.baseTransform);
      var combinedScale = [matrixScale[0] * curMatrixScale[0], matrixScale[1] * curMatrixScale[1]];
      width = Math.min(Math.ceil(Math.abs(width * combinedScale[0])), MAX_PATTERN_SIZE);
      height = Math.min(Math.ceil(Math.abs(height * combinedScale[1])), MAX_PATTERN_SIZE);
      var tmpCanvas = owner.cachedCanvases.getCanvas('pattern', width, height, true);
      var tmpCtx = tmpCanvas.context;
      var graphics = canvasGraphicsFactory.createCanvasGraphics(tmpCtx);
      graphics.groupLevel = owner.groupLevel;
      this.setFillAndStrokeStyleToContext(tmpCtx, paintType, color);
      this.setScale(width, height, xstep, ystep);
      this.transformToScale(graphics);
      var tmpTranslate = [1, 0, 0, 1, -topLeft[0], -topLeft[1]];
      graphics.transform.apply(graphics, tmpTranslate);
      this.clipBbox(graphics, bbox, x0, y0, x1, y1);
      graphics.executeOperatorList(operatorList);
      return tmpCanvas.canvas;
    },
    setScale: function TilingPattern_setScale(width, height, xstep, ystep) {
      this.scale = [width / xstep, height / ystep];
    },
    transformToScale: function TilingPattern_transformToScale(graphics) {
      var scale = this.scale;
      var tmpScale = [scale[0], 0, 0, scale[1], 0, 0];
      graphics.transform.apply(graphics, tmpScale);
    },
    scaleToContext: function TilingPattern_scaleToContext() {
      var scale = this.scale;
      this.ctx.scale(1 / scale[0], 1 / scale[1]);
    },
    clipBbox: function clipBbox(graphics, bbox, x0, y0, x1, y1) {
      if ((0, _util.isArray)(bbox) && bbox.length === 4) {
        var bboxWidth = x1 - x0;
        var bboxHeight = y1 - y0;
        graphics.ctx.rect(x0, y0, bboxWidth, bboxHeight);
        graphics.clip();
        graphics.endPath();
      }
    },
    setFillAndStrokeStyleToContext: function setFillAndStrokeStyleToContext(context, paintType, color) {
      switch (paintType) {
        case PaintType.COLORED:
          var ctx = this.ctx;
          context.fillStyle = ctx.fillStyle;
          context.strokeStyle = ctx.strokeStyle;
          break;
        case PaintType.UNCOLORED:
          var cssColor = _util.Util.makeCssRgb(color[0], color[1], color[2]);
          context.fillStyle = cssColor;
          context.strokeStyle = cssColor;
          break;
        default:
          throw new _util.FormatError('Unsupported paint type: ' + paintType);
      }
    },
    getPattern: function TilingPattern_getPattern(ctx, owner) {
      var temporaryPatternCanvas = this.createPatternCanvas(owner);
      ctx = this.ctx;
      ctx.setTransform.apply(ctx, this.baseTransform);
      ctx.transform.apply(ctx, this.matrix);
      this.scaleToContext();
      return ctx.createPattern(temporaryPatternCanvas, 'repeat');
    }
  };
  return TilingPattern;
}();
exports.getShadingPatternFromIR = getShadingPatternFromIR;
exports.TilingPattern = TilingPattern;

/***/ }),
/* 14 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PDFDataTransportStream = undefined;

var _util = __w_pdfjs_require__(0);

var PDFDataTransportStream = function PDFDataTransportStreamClosure() {
  function PDFDataTransportStream(params, pdfDataRangeTransport) {
    var _this = this;

    (0, _util.assert)(pdfDataRangeTransport);
    this._queuedChunks = [];
    var initialData = params.initialData;
    if (initialData && initialData.length > 0) {
      var buffer = new Uint8Array(initialData).buffer;
      this._queuedChunks.push(buffer);
    }
    this._pdfDataRangeTransport = pdfDataRangeTransport;
    this._isRangeSupported = !params.disableRange;
    this._isStreamingSupported = !params.disableStream;
    this._contentLength = params.length;
    this._fullRequestReader = null;
    this._rangeReaders = [];
    this._pdfDataRangeTransport.addRangeListener(function (begin, chunk) {
      _this._onReceiveData({
        begin: begin,
        chunk: chunk
      });
    });
    this._pdfDataRangeTransport.addProgressListener(function (loaded) {
      _this._onProgress({ loaded: loaded });
    });
    this._pdfDataRangeTransport.addProgressiveReadListener(function (chunk) {
      _this._onReceiveData({ chunk: chunk });
    });
    this._pdfDataRangeTransport.transportReady();
  }
  PDFDataTransportStream.prototype = {
    _onReceiveData: function PDFDataTransportStream_onReceiveData(args) {
      var buffer = new Uint8Array(args.chunk).buffer;
      if (args.begin === undefined) {
        if (this._fullRequestReader) {
          this._fullRequestReader._enqueue(buffer);
        } else {
          this._queuedChunks.push(buffer);
        }
      } else {
        var found = this._rangeReaders.some(function (rangeReader) {
          if (rangeReader._begin !== args.begin) {
            return false;
          }
          rangeReader._enqueue(buffer);
          return true;
        });
        (0, _util.assert)(found);
      }
    },
    _onProgress: function PDFDataTransportStream_onDataProgress(evt) {
      if (this._rangeReaders.length > 0) {
        var firstReader = this._rangeReaders[0];
        if (firstReader.onProgress) {
          firstReader.onProgress({ loaded: evt.loaded });
        }
      }
    },
    _removeRangeReader: function PDFDataTransportStream_removeRangeReader(reader) {
      var i = this._rangeReaders.indexOf(reader);
      if (i >= 0) {
        this._rangeReaders.splice(i, 1);
      }
    },
    getFullReader: function PDFDataTransportStream_getFullReader() {
      (0, _util.assert)(!this._fullRequestReader);
      var queuedChunks = this._queuedChunks;
      this._queuedChunks = null;
      return new PDFDataTransportStreamReader(this, queuedChunks);
    },
    getRangeReader: function PDFDataTransportStream_getRangeReader(begin, end) {
      var reader = new PDFDataTransportStreamRangeReader(this, begin, end);
      this._pdfDataRangeTransport.requestDataRange(begin, end);
      this._rangeReaders.push(reader);
      return reader;
    },
    cancelAllRequests: function PDFDataTransportStream_cancelAllRequests(reason) {
      if (this._fullRequestReader) {
        this._fullRequestReader.cancel(reason);
      }
      var readers = this._rangeReaders.slice(0);
      readers.forEach(function (rangeReader) {
        rangeReader.cancel(reason);
      });
      this._pdfDataRangeTransport.abort();
    }
  };
  function PDFDataTransportStreamReader(stream, queuedChunks) {
    this._stream = stream;
    this._done = false;
    this._queuedChunks = queuedChunks || [];
    this._requests = [];
    this._headersReady = Promise.resolve();
    stream._fullRequestReader = this;
    this.onProgress = null;
  }
  PDFDataTransportStreamReader.prototype = {
    _enqueue: function PDFDataTransportStreamReader_enqueue(chunk) {
      if (this._done) {
        return;
      }
      if (this._requests.length > 0) {
        var requestCapability = this._requests.shift();
        requestCapability.resolve({
          value: chunk,
          done: false
        });
        return;
      }
      this._queuedChunks.push(chunk);
    },
    get headersReady() {
      return this._headersReady;
    },
    get isRangeSupported() {
      return this._stream._isRangeSupported;
    },
    get isStreamingSupported() {
      return this._stream._isStreamingSupported;
    },
    get contentLength() {
      return this._stream._contentLength;
    },
    read: function PDFDataTransportStreamReader_read() {
      if (this._queuedChunks.length > 0) {
        var chunk = this._queuedChunks.shift();
        return Promise.resolve({
          value: chunk,
          done: false
        });
      }
      if (this._done) {
        return Promise.resolve({
          value: undefined,
          done: true
        });
      }
      var requestCapability = (0, _util.createPromiseCapability)();
      this._requests.push(requestCapability);
      return requestCapability.promise;
    },
    cancel: function PDFDataTransportStreamReader_cancel(reason) {
      this._done = true;
      this._requests.forEach(function (requestCapability) {
        requestCapability.resolve({
          value: undefined,
          done: true
        });
      });
      this._requests = [];
    }
  };
  function PDFDataTransportStreamRangeReader(stream, begin, end) {
    this._stream = stream;
    this._begin = begin;
    this._end = end;
    this._queuedChunk = null;
    this._requests = [];
    this._done = false;
    this.onProgress = null;
  }
  PDFDataTransportStreamRangeReader.prototype = {
    _enqueue: function PDFDataTransportStreamRangeReader_enqueue(chunk) {
      if (this._done) {
        return;
      }
      if (this._requests.length === 0) {
        this._queuedChunk = chunk;
      } else {
        var requestsCapability = this._requests.shift();
        requestsCapability.resolve({
          value: chunk,
          done: false
        });
        this._requests.forEach(function (requestCapability) {
          requestCapability.resolve({
            value: undefined,
            done: true
          });
        });
        this._requests = [];
      }
      this._done = true;
      this._stream._removeRangeReader(this);
    },
    get isStreamingSupported() {
      return false;
    },
    read: function PDFDataTransportStreamRangeReader_read() {
      if (this._queuedChunk) {
        var chunk = this._queuedChunk;
        this._queuedChunk = null;
        return Promise.resolve({
          value: chunk,
          done: false
        });
      }
      if (this._done) {
        return Promise.resolve({
          value: undefined,
          done: true
        });
      }
      var requestCapability = (0, _util.createPromiseCapability)();
      this._requests.push(requestCapability);
      return requestCapability.promise;
    },
    cancel: function PDFDataTransportStreamRangeReader_cancel(reason) {
      this._done = true;
      this._requests.forEach(function (requestCapability) {
        requestCapability.resolve({
          value: undefined,
          done: true
        });
      });
      this._requests = [];
      this._stream._removeRangeReader(this);
    }
  };
  return PDFDataTransportStream;
}();
exports.PDFDataTransportStream = PDFDataTransportStream;

/***/ }),
/* 15 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var pdfjsVersion = '1.8.619';
var pdfjsBuild = '723bc25b';
var pdfjsSharedUtil = __w_pdfjs_require__(0);
var pdfjsDisplayGlobal = __w_pdfjs_require__(8);
var pdfjsDisplayAPI = __w_pdfjs_require__(2);
var pdfjsDisplayTextLayer = __w_pdfjs_require__(5);
var pdfjsDisplayAnnotationLayer = __w_pdfjs_require__(3);
var pdfjsDisplayDOMUtils = __w_pdfjs_require__(1);
var pdfjsDisplaySVG = __w_pdfjs_require__(4);
{
  __w_pdfjs_require__(9);
}
exports.PDFJS = pdfjsDisplayGlobal.PDFJS;
exports.build = pdfjsDisplayAPI.build;
exports.version = pdfjsDisplayAPI.version;
exports.getDocument = pdfjsDisplayAPI.getDocument;
exports.LoopbackPort = pdfjsDisplayAPI.LoopbackPort;
exports.PDFDataRangeTransport = pdfjsDisplayAPI.PDFDataRangeTransport;
exports.PDFWorker = pdfjsDisplayAPI.PDFWorker;
exports.renderTextLayer = pdfjsDisplayTextLayer.renderTextLayer;
exports.AnnotationLayer = pdfjsDisplayAnnotationLayer.AnnotationLayer;
exports.CustomStyle = pdfjsDisplayDOMUtils.CustomStyle;
exports.createPromiseCapability = pdfjsSharedUtil.createPromiseCapability;
exports.PasswordResponses = pdfjsSharedUtil.PasswordResponses;
exports.InvalidPDFException = pdfjsSharedUtil.InvalidPDFException;
exports.MissingPDFException = pdfjsSharedUtil.MissingPDFException;
exports.SVGGraphics = pdfjsDisplaySVG.SVGGraphics;
exports.NativeImageDecoding = pdfjsSharedUtil.NativeImageDecoding;
exports.UnexpectedResponseException = pdfjsSharedUtil.UnexpectedResponseException;
exports.OPS = pdfjsSharedUtil.OPS;
exports.UNSUPPORTED_FEATURES = pdfjsSharedUtil.UNSUPPORTED_FEATURES;
exports.isValidUrl = pdfjsDisplayDOMUtils.isValidUrl;
exports.createValidAbsoluteUrl = pdfjsSharedUtil.createValidAbsoluteUrl;
exports.createObjectURL = pdfjsSharedUtil.createObjectURL;
exports.removeNullCharacters = pdfjsSharedUtil.removeNullCharacters;
exports.shadow = pdfjsSharedUtil.shadow;
exports.createBlob = pdfjsSharedUtil.createBlob;
exports.RenderingCancelledException = pdfjsDisplayDOMUtils.RenderingCancelledException;
exports.getFilenameFromUrl = pdfjsDisplayDOMUtils.getFilenameFromUrl;
exports.addLinkAttributes = pdfjsDisplayDOMUtils.addLinkAttributes;
exports.StatTimer = pdfjsSharedUtil.StatTimer;

/***/ }),
/* 16 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

if (typeof PDFJS === 'undefined' || !PDFJS.compatibilityChecked) {
  var globalScope = typeof window !== 'undefined' && window.Math === Math ? window : typeof global !== 'undefined' && global.Math === Math ? global : typeof self !== 'undefined' && self.Math === Math ? self :  false ? undefined : {};
  var userAgent = typeof navigator !== 'undefined' && navigator.userAgent || '';
  var isAndroid = /Android/.test(userAgent);
  var isAndroidPre3 = /Android\s[0-2][^\d]/.test(userAgent);
  var isAndroidPre5 = /Android\s[0-4][^\d]/.test(userAgent);
  var isChrome = userAgent.indexOf('Chrom') >= 0;
  var isChromeWithRangeBug = /Chrome\/(39|40)\./.test(userAgent);
  var isIOSChrome = userAgent.indexOf('CriOS') >= 0;
  var isIE = userAgent.indexOf('Trident') >= 0;
  var isIOS = /\b(iPad|iPhone|iPod)(?=;)/.test(userAgent);
  var isOpera = userAgent.indexOf('Opera') >= 0;
  var isSafari = /Safari\//.test(userAgent) && !/(Chrome\/|Android\s)/.test(userAgent);
  var hasDOM = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && (typeof document === 'undefined' ? 'undefined' : _typeof(document)) === 'object';
  if (typeof PDFJS === 'undefined') {
    globalScope.PDFJS = {};
  }
  PDFJS.compatibilityChecked = true;
  (function checkTypedArrayCompatibility() {
    if (typeof Uint8Array !== 'undefined') {
      if (typeof Uint8Array.prototype.subarray === 'undefined') {
        Uint8Array.prototype.subarray = function subarray(start, end) {
          return new Uint8Array(this.slice(start, end));
        };
        Float32Array.prototype.subarray = function subarray(start, end) {
          return new Float32Array(this.slice(start, end));
        };
      }
      if (typeof Float64Array === 'undefined') {
        globalScope.Float64Array = Float32Array;
      }
      return;
    }
    function subarray(start, end) {
      return new TypedArray(this.slice(start, end));
    }
    function setArrayOffset(array, offset) {
      if (arguments.length < 2) {
        offset = 0;
      }
      for (var i = 0, n = array.length; i < n; ++i, ++offset) {
        this[offset] = array[i] & 0xFF;
      }
    }
    function Uint32ArrayView(buffer, length) {
      this.buffer = buffer;
      this.byteLength = buffer.length;
      this.length = length;
      ensureUint32ArrayViewProps(this.length);
    }
    Uint32ArrayView.prototype = Object.create(null);
    var uint32ArrayViewSetters = 0;
    function createUint32ArrayProp(index) {
      return {
        get: function get() {
          var buffer = this.buffer,
              offset = index << 2;
          return (buffer[offset] | buffer[offset + 1] << 8 | buffer[offset + 2] << 16 | buffer[offset + 3] << 24) >>> 0;
        },
        set: function set(value) {
          var buffer = this.buffer,
              offset = index << 2;
          buffer[offset] = value & 255;
          buffer[offset + 1] = value >> 8 & 255;
          buffer[offset + 2] = value >> 16 & 255;
          buffer[offset + 3] = value >>> 24 & 255;
        }
      };
    }
    function ensureUint32ArrayViewProps(length) {
      while (uint32ArrayViewSetters < length) {
        Object.defineProperty(Uint32ArrayView.prototype, uint32ArrayViewSetters, createUint32ArrayProp(uint32ArrayViewSetters));
        uint32ArrayViewSetters++;
      }
    }
    function TypedArray(arg1) {
      var result, i, n;
      if (typeof arg1 === 'number') {
        result = [];
        for (i = 0; i < arg1; ++i) {
          result[i] = 0;
        }
      } else if ('slice' in arg1) {
        result = arg1.slice(0);
      } else {
        result = [];
        for (i = 0, n = arg1.length; i < n; ++i) {
          result[i] = arg1[i];
        }
      }
      result.subarray = subarray;
      result.buffer = result;
      result.byteLength = result.length;
      result.set = setArrayOffset;
      if ((typeof arg1 === 'undefined' ? 'undefined' : _typeof(arg1)) === 'object' && arg1.buffer) {
        result.buffer = arg1.buffer;
      }
      return result;
    }
    globalScope.Uint8Array = TypedArray;
    globalScope.Int8Array = TypedArray;
    globalScope.Int32Array = TypedArray;
    globalScope.Uint16Array = TypedArray;
    globalScope.Float32Array = TypedArray;
    globalScope.Float64Array = TypedArray;
    globalScope.Uint32Array = function () {
      if (arguments.length === 3) {
        if (arguments[1] !== 0) {
          throw new Error('offset !== 0 is not supported');
        }
        return new Uint32ArrayView(arguments[0], arguments[2]);
      }
      return TypedArray.apply(this, arguments);
    };
  })();
  (function canvasPixelArrayBuffer() {
    if (!hasDOM || !window.CanvasPixelArray) {
      return;
    }
    var cpaProto = window.CanvasPixelArray.prototype;
    if ('buffer' in cpaProto) {
      return;
    }
    Object.defineProperty(cpaProto, 'buffer', {
      get: function get() {
        return this;
      },

      enumerable: false,
      configurable: true
    });
    Object.defineProperty(cpaProto, 'byteLength', {
      get: function get() {
        return this.length;
      },

      enumerable: false,
      configurable: true
    });
  })();
  (function normalizeURLObject() {
    if (!globalScope.URL) {
      globalScope.URL = globalScope.webkitURL;
    }
  })();
  (function checkObjectDefinePropertyCompatibility() {
    if (typeof Object.defineProperty !== 'undefined') {
      var definePropertyPossible = true;
      try {
        if (hasDOM) {
          Object.defineProperty(new Image(), 'id', { value: 'test' });
        }
        var Test = function Test() {};
        Test.prototype = {
          get id() {}
        };
        Object.defineProperty(new Test(), 'id', {
          value: '',
          configurable: true,
          enumerable: true,
          writable: false
        });
      } catch (e) {
        definePropertyPossible = false;
      }
      if (definePropertyPossible) {
        return;
      }
    }
    Object.defineProperty = function objectDefineProperty(obj, name, def) {
      delete obj[name];
      if ('get' in def) {
        obj.__defineGetter__(name, def['get']);
      }
      if ('set' in def) {
        obj.__defineSetter__(name, def['set']);
      }
      if ('value' in def) {
        obj.__defineSetter__(name, function objectDefinePropertySetter(value) {
          this.__defineGetter__(name, function objectDefinePropertyGetter() {
            return value;
          });
          return value;
        });
        obj[name] = def.value;
      }
    };
  })();
  (function checkXMLHttpRequestResponseCompatibility() {
    if (typeof XMLHttpRequest === 'undefined') {
      return;
    }
    var xhrPrototype = XMLHttpRequest.prototype;
    var xhr = new XMLHttpRequest();
    if (!('overrideMimeType' in xhr)) {
      Object.defineProperty(xhrPrototype, 'overrideMimeType', {
        value: function xmlHttpRequestOverrideMimeType(mimeType) {}
      });
    }
    if ('responseType' in xhr) {
      return;
    }
    Object.defineProperty(xhrPrototype, 'responseType', {
      get: function xmlHttpRequestGetResponseType() {
        return this._responseType || 'text';
      },
      set: function xmlHttpRequestSetResponseType(value) {
        if (value === 'text' || value === 'arraybuffer') {
          this._responseType = value;
          if (value === 'arraybuffer' && typeof this.overrideMimeType === 'function') {
            this.overrideMimeType('text/plain; charset=x-user-defined');
          }
        }
      }
    });
    if (typeof VBArray !== 'undefined') {
      Object.defineProperty(xhrPrototype, 'response', {
        get: function xmlHttpRequestResponseGet() {
          if (this.responseType === 'arraybuffer') {
            return new Uint8Array(new VBArray(this.responseBody).toArray());
          }
          return this.responseText;
        }
      });
      return;
    }
    Object.defineProperty(xhrPrototype, 'response', {
      get: function xmlHttpRequestResponseGet() {
        if (this.responseType !== 'arraybuffer') {
          return this.responseText;
        }
        var text = this.responseText;
        var i,
            n = text.length;
        var result = new Uint8Array(n);
        for (i = 0; i < n; ++i) {
          result[i] = text.charCodeAt(i) & 0xFF;
        }
        return result.buffer;
      }
    });
  })();
  (function checkWindowBtoaCompatibility() {
    if ('btoa' in globalScope) {
      return;
    }
    var digits = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    globalScope.btoa = function (chars) {
      var buffer = '';
      var i, n;
      for (i = 0, n = chars.length; i < n; i += 3) {
        var b1 = chars.charCodeAt(i) & 0xFF;
        var b2 = chars.charCodeAt(i + 1) & 0xFF;
        var b3 = chars.charCodeAt(i + 2) & 0xFF;
        var d1 = b1 >> 2,
            d2 = (b1 & 3) << 4 | b2 >> 4;
        var d3 = i + 1 < n ? (b2 & 0xF) << 2 | b3 >> 6 : 64;
        var d4 = i + 2 < n ? b3 & 0x3F : 64;
        buffer += digits.charAt(d1) + digits.charAt(d2) + digits.charAt(d3) + digits.charAt(d4);
      }
      return buffer;
    };
  })();
  (function checkWindowAtobCompatibility() {
    if ('atob' in globalScope) {
      return;
    }
    var digits = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    globalScope.atob = function (input) {
      input = input.replace(/=+$/, '');
      if (input.length % 4 === 1) {
        throw new Error('bad atob input');
      }
      for (var bc = 0, bs, buffer, idx = 0, output = ''; buffer = input.charAt(idx++); ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer, bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0) {
        buffer = digits.indexOf(buffer);
      }
      return output;
    };
  })();
  (function checkFunctionPrototypeBindCompatibility() {
    if (typeof Function.prototype.bind !== 'undefined') {
      return;
    }
    Function.prototype.bind = function functionPrototypeBind(obj) {
      var fn = this,
          headArgs = Array.prototype.slice.call(arguments, 1);
      var bound = function functionPrototypeBindBound() {
        var args = headArgs.concat(Array.prototype.slice.call(arguments));
        return fn.apply(obj, args);
      };
      return bound;
    };
  })();
  (function checkDatasetProperty() {
    if (!hasDOM) {
      return;
    }
    var div = document.createElement('div');
    if ('dataset' in div) {
      return;
    }
    Object.defineProperty(HTMLElement.prototype, 'dataset', {
      get: function get() {
        if (this._dataset) {
          return this._dataset;
        }
        var dataset = {};
        for (var j = 0, jj = this.attributes.length; j < jj; j++) {
          var attribute = this.attributes[j];
          if (attribute.name.substring(0, 5) !== 'data-') {
            continue;
          }
          var key = attribute.name.substring(5).replace(/\-([a-z])/g, function (all, ch) {
            return ch.toUpperCase();
          });
          dataset[key] = attribute.value;
        }
        Object.defineProperty(this, '_dataset', {
          value: dataset,
          writable: false,
          enumerable: false
        });
        return dataset;
      },

      enumerable: true
    });
  })();
  (function checkClassListProperty() {
    function changeList(element, itemName, add, remove) {
      var s = element.className || '';
      var list = s.split(/\s+/g);
      if (list[0] === '') {
        list.shift();
      }
      var index = list.indexOf(itemName);
      if (index < 0 && add) {
        list.push(itemName);
      }
      if (index >= 0 && remove) {
        list.splice(index, 1);
      }
      element.className = list.join(' ');
      return index >= 0;
    }
    if (!hasDOM) {
      return;
    }
    var div = document.createElement('div');
    if ('classList' in div) {
      return;
    }
    var classListPrototype = {
      add: function add(name) {
        changeList(this.element, name, true, false);
      },
      contains: function contains(name) {
        return changeList(this.element, name, false, false);
      },
      remove: function remove(name) {
        changeList(this.element, name, false, true);
      },
      toggle: function toggle(name) {
        changeList(this.element, name, true, true);
      }
    };
    Object.defineProperty(HTMLElement.prototype, 'classList', {
      get: function get() {
        if (this._classList) {
          return this._classList;
        }
        var classList = Object.create(classListPrototype, {
          element: {
            value: this,
            writable: false,
            enumerable: true
          }
        });
        Object.defineProperty(this, '_classList', {
          value: classList,
          writable: false,
          enumerable: false
        });
        return classList;
      },

      enumerable: true
    });
  })();
  (function checkWorkerConsoleCompatibility() {
    if (typeof importScripts === 'undefined' || 'console' in globalScope) {
      return;
    }
    var consoleTimer = {};
    var workerConsole = {
      log: function log() {
        var args = Array.prototype.slice.call(arguments);
        globalScope.postMessage({
          targetName: 'main',
          action: 'console_log',
          data: args
        });
      },
      error: function error() {
        var args = Array.prototype.slice.call(arguments);
        globalScope.postMessage({
          targetName: 'main',
          action: 'console_error',
          data: args
        });
      },
      time: function time(name) {
        consoleTimer[name] = Date.now();
      },
      timeEnd: function timeEnd(name) {
        var time = consoleTimer[name];
        if (!time) {
          throw new Error('Unknown timer name ' + name);
        }
        this.log('Timer:', name, Date.now() - time);
      }
    };
    globalScope.console = workerConsole;
  })();
  (function checkConsoleCompatibility() {
    if (!hasDOM) {
      return;
    }
    if (!('console' in window)) {
      window.console = {
        log: function log() {},
        error: function error() {},
        warn: function warn() {}
      };
      return;
    }
    if (!('bind' in console.log)) {
      console.log = function (fn) {
        return function (msg) {
          return fn(msg);
        };
      }(console.log);
      console.error = function (fn) {
        return function (msg) {
          return fn(msg);
        };
      }(console.error);
      console.warn = function (fn) {
        return function (msg) {
          return fn(msg);
        };
      }(console.warn);
      return;
    }
  })();
  (function checkOnClickCompatibility() {
    function ignoreIfTargetDisabled(event) {
      if (isDisabled(event.target)) {
        event.stopPropagation();
      }
    }
    function isDisabled(node) {
      return node.disabled || node.parentNode && isDisabled(node.parentNode);
    }
    if (isOpera) {
      document.addEventListener('click', ignoreIfTargetDisabled, true);
    }
  })();
  (function checkOnBlobSupport() {
    if (isIE || isIOSChrome) {
      PDFJS.disableCreateObjectURL = true;
    }
  })();
  (function checkNavigatorLanguage() {
    if (typeof navigator === 'undefined') {
      return;
    }
    if ('language' in navigator) {
      return;
    }
    PDFJS.locale = navigator.userLanguage || 'en-US';
  })();
  (function checkRangeRequests() {
    if (isSafari || isAndroidPre3 || isChromeWithRangeBug || isIOS) {
      PDFJS.disableRange = true;
      PDFJS.disableStream = true;
    }
  })();
  (function checkHistoryManipulation() {
    if (!hasDOM) {
      return;
    }
    if (!history.pushState || isAndroidPre3) {
      PDFJS.disableHistory = true;
    }
  })();
  (function checkSetPresenceInImageData() {
    if (!hasDOM) {
      return;
    }
    if (window.CanvasPixelArray) {
      if (typeof window.CanvasPixelArray.prototype.set !== 'function') {
        window.CanvasPixelArray.prototype.set = function (arr) {
          for (var i = 0, ii = this.length; i < ii; i++) {
            this[i] = arr[i];
          }
        };
      }
    } else {
      var polyfill = false,
          versionMatch;
      if (isChrome) {
        versionMatch = userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
        polyfill = versionMatch && parseInt(versionMatch[2]) < 21;
      } else if (isAndroid) {
        polyfill = isAndroidPre5;
      } else if (isSafari) {
        versionMatch = userAgent.match(/Version\/([0-9]+)\.([0-9]+)\.([0-9]+) Safari\//);
        polyfill = versionMatch && parseInt(versionMatch[1]) < 6;
      }
      if (polyfill) {
        var contextPrototype = window.CanvasRenderingContext2D.prototype;
        var createImageData = contextPrototype.createImageData;
        contextPrototype.createImageData = function (w, h) {
          var imageData = createImageData.call(this, w, h);
          imageData.data.set = function (arr) {
            for (var i = 0, ii = this.length; i < ii; i++) {
              this[i] = arr[i];
            }
          };
          return imageData;
        };
        contextPrototype = null;
      }
    }
  })();
  (function checkRequestAnimationFrame() {
    function installFakeAnimationFrameFunctions() {
      window.requestAnimationFrame = function (callback) {
        return window.setTimeout(callback, 20);
      };
      window.cancelAnimationFrame = function (timeoutID) {
        window.clearTimeout(timeoutID);
      };
    }
    if (!hasDOM) {
      return;
    }
    if (isIOS) {
      installFakeAnimationFrameFunctions();
      return;
    }
    if ('requestAnimationFrame' in window) {
      return;
    }
    window.requestAnimationFrame = window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame;
    if (window.requestAnimationFrame) {
      return;
    }
    installFakeAnimationFrameFunctions();
  })();
  (function checkCanvasSizeLimitation() {
    if (isIOS || isAndroid) {
      PDFJS.maxCanvasPixels = 5242880;
    }
  })();
  (function checkFullscreenSupport() {
    if (!hasDOM) {
      return;
    }
    if (isIE && window.parent !== window) {
      PDFJS.disableFullscreen = true;
    }
  })();
  (function checkCurrentScript() {
    if (!hasDOM) {
      return;
    }
    if ('currentScript' in document) {
      return;
    }
    Object.defineProperty(document, 'currentScript', {
      get: function get() {
        var scripts = document.getElementsByTagName('script');
        return scripts[scripts.length - 1];
      },

      enumerable: true,
      configurable: true
    });
  })();
  (function checkInputTypeNumberAssign() {
    if (!hasDOM) {
      return;
    }
    var el = document.createElement('input');
    try {
      el.type = 'number';
    } catch (ex) {
      var inputProto = el.constructor.prototype;
      var typeProperty = Object.getOwnPropertyDescriptor(inputProto, 'type');
      Object.defineProperty(inputProto, 'type', {
        get: function get() {
          return typeProperty.get.call(this);
        },
        set: function set(value) {
          typeProperty.set.call(this, value === 'number' ? 'text' : value);
        },

        enumerable: true,
        configurable: true
      });
    }
  })();
  (function checkDocumentReadyState() {
    if (!hasDOM) {
      return;
    }
    if (!document.attachEvent) {
      return;
    }
    var documentProto = document.constructor.prototype;
    var readyStateProto = Object.getOwnPropertyDescriptor(documentProto, 'readyState');
    Object.defineProperty(documentProto, 'readyState', {
      get: function get() {
        var value = readyStateProto.get.call(this);
        return value === 'interactive' ? 'loading' : value;
      },
      set: function set(value) {
        readyStateProto.set.call(this, value);
      },

      enumerable: true,
      configurable: true
    });
  })();
  (function checkChildNodeRemove() {
    if (!hasDOM) {
      return;
    }
    if (typeof Element.prototype.remove !== 'undefined') {
      return;
    }
    Element.prototype.remove = function () {
      if (this.parentNode) {
        this.parentNode.removeChild(this);
      }
    };
  })();
  (function checkNumberIsNaN() {
    if (Number.isNaN) {
      return;
    }
    Number.isNaN = function (value) {
      return typeof value === 'number' && isNaN(value);
    };
  })();
  (function checkNumberIsInteger() {
    if (Number.isInteger) {
      return;
    }
    Number.isInteger = function (value) {
      return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
    };
  })();
  (function checkPromise() {
    if (globalScope.Promise) {
      if (typeof globalScope.Promise.all !== 'function') {
        globalScope.Promise.all = function (iterable) {
          var count = 0,
              results = [],
              resolve,
              reject;
          var promise = new globalScope.Promise(function (resolve_, reject_) {
            resolve = resolve_;
            reject = reject_;
          });
          iterable.forEach(function (p, i) {
            count++;
            p.then(function (result) {
              results[i] = result;
              count--;
              if (count === 0) {
                resolve(results);
              }
            }, reject);
          });
          if (count === 0) {
            resolve(results);
          }
          return promise;
        };
      }
      if (typeof globalScope.Promise.resolve !== 'function') {
        globalScope.Promise.resolve = function (value) {
          return new globalScope.Promise(function (resolve) {
            resolve(value);
          });
        };
      }
      if (typeof globalScope.Promise.reject !== 'function') {
        globalScope.Promise.reject = function (reason) {
          return new globalScope.Promise(function (resolve, reject) {
            reject(reason);
          });
        };
      }
      if (typeof globalScope.Promise.prototype.catch !== 'function') {
        globalScope.Promise.prototype.catch = function (onReject) {
          return globalScope.Promise.prototype.then(undefined, onReject);
        };
      }
      return;
    }
    var STATUS_PENDING = 0;
    var STATUS_RESOLVED = 1;
    var STATUS_REJECTED = 2;
    var REJECTION_TIMEOUT = 500;
    var HandlerManager = {
      handlers: [],
      running: false,
      unhandledRejections: [],
      pendingRejectionCheck: false,
      scheduleHandlers: function scheduleHandlers(promise) {
        if (promise._status === STATUS_PENDING) {
          return;
        }
        this.handlers = this.handlers.concat(promise._handlers);
        promise._handlers = [];
        if (this.running) {
          return;
        }
        this.running = true;
        setTimeout(this.runHandlers.bind(this), 0);
      },
      runHandlers: function runHandlers() {
        var RUN_TIMEOUT = 1;
        var timeoutAt = Date.now() + RUN_TIMEOUT;
        while (this.handlers.length > 0) {
          var handler = this.handlers.shift();
          var nextStatus = handler.thisPromise._status;
          var nextValue = handler.thisPromise._value;
          try {
            if (nextStatus === STATUS_RESOLVED) {
              if (typeof handler.onResolve === 'function') {
                nextValue = handler.onResolve(nextValue);
              }
            } else if (typeof handler.onReject === 'function') {
              nextValue = handler.onReject(nextValue);
              nextStatus = STATUS_RESOLVED;
              if (handler.thisPromise._unhandledRejection) {
                this.removeUnhandeledRejection(handler.thisPromise);
              }
            }
          } catch (ex) {
            nextStatus = STATUS_REJECTED;
            nextValue = ex;
          }
          handler.nextPromise._updateStatus(nextStatus, nextValue);
          if (Date.now() >= timeoutAt) {
            break;
          }
        }
        if (this.handlers.length > 0) {
          setTimeout(this.runHandlers.bind(this), 0);
          return;
        }
        this.running = false;
      },
      addUnhandledRejection: function addUnhandledRejection(promise) {
        this.unhandledRejections.push({
          promise: promise,
          time: Date.now()
        });
        this.scheduleRejectionCheck();
      },
      removeUnhandeledRejection: function removeUnhandeledRejection(promise) {
        promise._unhandledRejection = false;
        for (var i = 0; i < this.unhandledRejections.length; i++) {
          if (this.unhandledRejections[i].promise === promise) {
            this.unhandledRejections.splice(i);
            i--;
          }
        }
      },
      scheduleRejectionCheck: function scheduleRejectionCheck() {
        var _this = this;

        if (this.pendingRejectionCheck) {
          return;
        }
        this.pendingRejectionCheck = true;
        setTimeout(function () {
          _this.pendingRejectionCheck = false;
          var now = Date.now();
          for (var i = 0; i < _this.unhandledRejections.length; i++) {
            if (now - _this.unhandledRejections[i].time > REJECTION_TIMEOUT) {
              var unhandled = _this.unhandledRejections[i].promise._value;
              var msg = 'Unhandled rejection: ' + unhandled;
              if (unhandled.stack) {
                msg += '\n' + unhandled.stack;
              }
              try {
                throw new Error(msg);
              } catch (_) {
                console.warn(msg);
              }
              _this.unhandledRejections.splice(i);
              i--;
            }
          }
          if (_this.unhandledRejections.length) {
            _this.scheduleRejectionCheck();
          }
        }, REJECTION_TIMEOUT);
      }
    };
    var Promise = function Promise(resolver) {
      this._status = STATUS_PENDING;
      this._handlers = [];
      try {
        resolver.call(this, this._resolve.bind(this), this._reject.bind(this));
      } catch (e) {
        this._reject(e);
      }
    };
    Promise.all = function Promise_all(promises) {
      var resolveAll, rejectAll;
      var deferred = new Promise(function (resolve, reject) {
        resolveAll = resolve;
        rejectAll = reject;
      });
      var unresolved = promises.length;
      var results = [];
      if (unresolved === 0) {
        resolveAll(results);
        return deferred;
      }
      function reject(reason) {
        if (deferred._status === STATUS_REJECTED) {
          return;
        }
        results = [];
        rejectAll(reason);
      }
      for (var i = 0, ii = promises.length; i < ii; ++i) {
        var promise = promises[i];
        var resolve = function (i) {
          return function (value) {
            if (deferred._status === STATUS_REJECTED) {
              return;
            }
            results[i] = value;
            unresolved--;
            if (unresolved === 0) {
              resolveAll(results);
            }
          };
        }(i);
        if (Promise.isPromise(promise)) {
          promise.then(resolve, reject);
        } else {
          resolve(promise);
        }
      }
      return deferred;
    };
    Promise.isPromise = function Promise_isPromise(value) {
      return value && typeof value.then === 'function';
    };
    Promise.resolve = function Promise_resolve(value) {
      return new Promise(function (resolve) {
        resolve(value);
      });
    };
    Promise.reject = function Promise_reject(reason) {
      return new Promise(function (resolve, reject) {
        reject(reason);
      });
    };
    Promise.prototype = {
      _status: null,
      _value: null,
      _handlers: null,
      _unhandledRejection: null,
      _updateStatus: function Promise__updateStatus(status, value) {
        if (this._status === STATUS_RESOLVED || this._status === STATUS_REJECTED) {
          return;
        }
        if (status === STATUS_RESOLVED && Promise.isPromise(value)) {
          value.then(this._updateStatus.bind(this, STATUS_RESOLVED), this._updateStatus.bind(this, STATUS_REJECTED));
          return;
        }
        this._status = status;
        this._value = value;
        if (status === STATUS_REJECTED && this._handlers.length === 0) {
          this._unhandledRejection = true;
          HandlerManager.addUnhandledRejection(this);
        }
        HandlerManager.scheduleHandlers(this);
      },
      _resolve: function Promise_resolve(value) {
        this._updateStatus(STATUS_RESOLVED, value);
      },
      _reject: function Promise_reject(reason) {
        this._updateStatus(STATUS_REJECTED, reason);
      },
      then: function Promise_then(onResolve, onReject) {
        var nextPromise = new Promise(function (resolve, reject) {
          this.resolve = resolve;
          this.reject = reject;
        });
        this._handlers.push({
          thisPromise: this,
          onResolve: onResolve,
          onReject: onReject,
          nextPromise: nextPromise
        });
        HandlerManager.scheduleHandlers(this);
        return nextPromise;
      },
      catch: function Promise_catch(onReject) {
        return this.then(undefined, onReject);
      }
    };
    globalScope.Promise = Promise;
  })();
  (function checkWeakMap() {
    if (globalScope.WeakMap) {
      return;
    }
    var id = 0;
    function WeakMap() {
      this.id = '$weakmap' + id++;
    }
    WeakMap.prototype = {
      has: function has(obj) {
        if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' && typeof obj !== 'function' || obj === null) {
          return false;
        }
        return !!Object.getOwnPropertyDescriptor(obj, this.id);
      },
      get: function get(obj) {
        return this.has(obj) ? obj[this.id] : undefined;
      },
      set: function set(obj, value) {
        Object.defineProperty(obj, this.id, {
          value: value,
          enumerable: false,
          configurable: true
        });
      },
      delete: function _delete(obj) {
        delete obj[this.id];
      }
    };
    globalScope.WeakMap = WeakMap;
  })();
  (function checkURLConstructor() {
    var hasWorkingUrl = false;
    try {
      if (typeof URL === 'function' && _typeof(URL.prototype) === 'object' && 'origin' in URL.prototype) {
        var u = new URL('b', 'http://a');
        u.pathname = 'c%20d';
        hasWorkingUrl = u.href === 'http://a/c%20d';
      }
    } catch (e) {}
    if (hasWorkingUrl) {
      return;
    }
    var relative = Object.create(null);
    relative['ftp'] = 21;
    relative['file'] = 0;
    relative['gopher'] = 70;
    relative['http'] = 80;
    relative['https'] = 443;
    relative['ws'] = 80;
    relative['wss'] = 443;
    var relativePathDotMapping = Object.create(null);
    relativePathDotMapping['%2e'] = '.';
    relativePathDotMapping['.%2e'] = '..';
    relativePathDotMapping['%2e.'] = '..';
    relativePathDotMapping['%2e%2e'] = '..';
    function isRelativeScheme(scheme) {
      return relative[scheme] !== undefined;
    }
    function invalid() {
      clear.call(this);
      this._isInvalid = true;
    }
    function IDNAToASCII(h) {
      if (h === '') {
        invalid.call(this);
      }
      return h.toLowerCase();
    }
    function percentEscape(c) {
      var unicode = c.charCodeAt(0);
      if (unicode > 0x20 && unicode < 0x7F && [0x22, 0x23, 0x3C, 0x3E, 0x3F, 0x60].indexOf(unicode) === -1) {
        return c;
      }
      return encodeURIComponent(c);
    }
    function percentEscapeQuery(c) {
      var unicode = c.charCodeAt(0);
      if (unicode > 0x20 && unicode < 0x7F && [0x22, 0x23, 0x3C, 0x3E, 0x60].indexOf(unicode) === -1) {
        return c;
      }
      return encodeURIComponent(c);
    }
    var EOF,
        ALPHA = /[a-zA-Z]/,
        ALPHANUMERIC = /[a-zA-Z0-9\+\-\.]/;
    function parse(input, stateOverride, base) {
      function err(message) {
        errors.push(message);
      }
      var state = stateOverride || 'scheme start',
          cursor = 0,
          buffer = '',
          seenAt = false,
          seenBracket = false,
          errors = [];
      loop: while ((input[cursor - 1] !== EOF || cursor === 0) && !this._isInvalid) {
        var c = input[cursor];
        switch (state) {
          case 'scheme start':
            if (c && ALPHA.test(c)) {
              buffer += c.toLowerCase();
              state = 'scheme';
            } else if (!stateOverride) {
              buffer = '';
              state = 'no scheme';
              continue;
            } else {
              err('Invalid scheme.');
              break loop;
            }
            break;
          case 'scheme':
            if (c && ALPHANUMERIC.test(c)) {
              buffer += c.toLowerCase();
            } else if (c === ':') {
              this._scheme = buffer;
              buffer = '';
              if (stateOverride) {
                break loop;
              }
              if (isRelativeScheme(this._scheme)) {
                this._isRelative = true;
              }
              if (this._scheme === 'file') {
                state = 'relative';
              } else if (this._isRelative && base && base._scheme === this._scheme) {
                state = 'relative or authority';
              } else if (this._isRelative) {
                state = 'authority first slash';
              } else {
                state = 'scheme data';
              }
            } else if (!stateOverride) {
              buffer = '';
              cursor = 0;
              state = 'no scheme';
              continue;
            } else if (c === EOF) {
              break loop;
            } else {
              err('Code point not allowed in scheme: ' + c);
              break loop;
            }
            break;
          case 'scheme data':
            if (c === '?') {
              this._query = '?';
              state = 'query';
            } else if (c === '#') {
              this._fragment = '#';
              state = 'fragment';
            } else {
              if (c !== EOF && c !== '\t' && c !== '\n' && c !== '\r') {
                this._schemeData += percentEscape(c);
              }
            }
            break;
          case 'no scheme':
            if (!base || !isRelativeScheme(base._scheme)) {
              err('Missing scheme.');
              invalid.call(this);
            } else {
              state = 'relative';
              continue;
            }
            break;
          case 'relative or authority':
            if (c === '/' && input[cursor + 1] === '/') {
              state = 'authority ignore slashes';
            } else {
              err('Expected /, got: ' + c);
              state = 'relative';
              continue;
            }
            break;
          case 'relative':
            this._isRelative = true;
            if (this._scheme !== 'file') {
              this._scheme = base._scheme;
            }
            if (c === EOF) {
              this._host = base._host;
              this._port = base._port;
              this._path = base._path.slice();
              this._query = base._query;
              this._username = base._username;
              this._password = base._password;
              break loop;
            } else if (c === '/' || c === '\\') {
              if (c === '\\') {
                err('\\ is an invalid code point.');
              }
              state = 'relative slash';
            } else if (c === '?') {
              this._host = base._host;
              this._port = base._port;
              this._path = base._path.slice();
              this._query = '?';
              this._username = base._username;
              this._password = base._password;
              state = 'query';
            } else if (c === '#') {
              this._host = base._host;
              this._port = base._port;
              this._path = base._path.slice();
              this._query = base._query;
              this._fragment = '#';
              this._username = base._username;
              this._password = base._password;
              state = 'fragment';
            } else {
              var nextC = input[cursor + 1];
              var nextNextC = input[cursor + 2];
              if (this._scheme !== 'file' || !ALPHA.test(c) || nextC !== ':' && nextC !== '|' || nextNextC !== EOF && nextNextC !== '/' && nextNextC !== '\\' && nextNextC !== '?' && nextNextC !== '#') {
                this._host = base._host;
                this._port = base._port;
                this._username = base._username;
                this._password = base._password;
                this._path = base._path.slice();
                this._path.pop();
              }
              state = 'relative path';
              continue;
            }
            break;
          case 'relative slash':
            if (c === '/' || c === '\\') {
              if (c === '\\') {
                err('\\ is an invalid code point.');
              }
              if (this._scheme === 'file') {
                state = 'file host';
              } else {
                state = 'authority ignore slashes';
              }
            } else {
              if (this._scheme !== 'file') {
                this._host = base._host;
                this._port = base._port;
                this._username = base._username;
                this._password = base._password;
              }
              state = 'relative path';
              continue;
            }
            break;
          case 'authority first slash':
            if (c === '/') {
              state = 'authority second slash';
            } else {
              err('Expected \'/\', got: ' + c);
              state = 'authority ignore slashes';
              continue;
            }
            break;
          case 'authority second slash':
            state = 'authority ignore slashes';
            if (c !== '/') {
              err('Expected \'/\', got: ' + c);
              continue;
            }
            break;
          case 'authority ignore slashes':
            if (c !== '/' && c !== '\\') {
              state = 'authority';
              continue;
            } else {
              err('Expected authority, got: ' + c);
            }
            break;
          case 'authority':
            if (c === '@') {
              if (seenAt) {
                err('@ already seen.');
                buffer += '%40';
              }
              seenAt = true;
              for (var i = 0; i < buffer.length; i++) {
                var cp = buffer[i];
                if (cp === '\t' || cp === '\n' || cp === '\r') {
                  err('Invalid whitespace in authority.');
                  continue;
                }
                if (cp === ':' && this._password === null) {
                  this._password = '';
                  continue;
                }
                var tempC = percentEscape(cp);
                if (this._password !== null) {
                  this._password += tempC;
                } else {
                  this._username += tempC;
                }
              }
              buffer = '';
            } else if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#') {
              cursor -= buffer.length;
              buffer = '';
              state = 'host';
              continue;
            } else {
              buffer += c;
            }
            break;
          case 'file host':
            if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#') {
              if (buffer.length === 2 && ALPHA.test(buffer[0]) && (buffer[1] === ':' || buffer[1] === '|')) {
                state = 'relative path';
              } else if (buffer.length === 0) {
                state = 'relative path start';
              } else {
                this._host = IDNAToASCII.call(this, buffer);
                buffer = '';
                state = 'relative path start';
              }
              continue;
            } else if (c === '\t' || c === '\n' || c === '\r') {
              err('Invalid whitespace in file host.');
            } else {
              buffer += c;
            }
            break;
          case 'host':
          case 'hostname':
            if (c === ':' && !seenBracket) {
              this._host = IDNAToASCII.call(this, buffer);
              buffer = '';
              state = 'port';
              if (stateOverride === 'hostname') {
                break loop;
              }
            } else if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#') {
              this._host = IDNAToASCII.call(this, buffer);
              buffer = '';
              state = 'relative path start';
              if (stateOverride) {
                break loop;
              }
              continue;
            } else if (c !== '\t' && c !== '\n' && c !== '\r') {
              if (c === '[') {
                seenBracket = true;
              } else if (c === ']') {
                seenBracket = false;
              }
              buffer += c;
            } else {
              err('Invalid code point in host/hostname: ' + c);
            }
            break;
          case 'port':
            if (/[0-9]/.test(c)) {
              buffer += c;
            } else if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#' || stateOverride) {
              if (buffer !== '') {
                var temp = parseInt(buffer, 10);
                if (temp !== relative[this._scheme]) {
                  this._port = temp + '';
                }
                buffer = '';
              }
              if (stateOverride) {
                break loop;
              }
              state = 'relative path start';
              continue;
            } else if (c === '\t' || c === '\n' || c === '\r') {
              err('Invalid code point in port: ' + c);
            } else {
              invalid.call(this);
            }
            break;
          case 'relative path start':
            if (c === '\\') {
              err('\'\\\' not allowed in path.');
            }
            state = 'relative path';
            if (c !== '/' && c !== '\\') {
              continue;
            }
            break;
          case 'relative path':
            if (c === EOF || c === '/' || c === '\\' || !stateOverride && (c === '?' || c === '#')) {
              if (c === '\\') {
                err('\\ not allowed in relative path.');
              }
              var tmp;
              if (tmp = relativePathDotMapping[buffer.toLowerCase()]) {
                buffer = tmp;
              }
              if (buffer === '..') {
                this._path.pop();
                if (c !== '/' && c !== '\\') {
                  this._path.push('');
                }
              } else if (buffer === '.' && c !== '/' && c !== '\\') {
                this._path.push('');
              } else if (buffer !== '.') {
                if (this._scheme === 'file' && this._path.length === 0 && buffer.length === 2 && ALPHA.test(buffer[0]) && buffer[1] === '|') {
                  buffer = buffer[0] + ':';
                }
                this._path.push(buffer);
              }
              buffer = '';
              if (c === '?') {
                this._query = '?';
                state = 'query';
              } else if (c === '#') {
                this._fragment = '#';
                state = 'fragment';
              }
            } else if (c !== '\t' && c !== '\n' && c !== '\r') {
              buffer += percentEscape(c);
            }
            break;
          case 'query':
            if (!stateOverride && c === '#') {
              this._fragment = '#';
              state = 'fragment';
            } else if (c !== EOF && c !== '\t' && c !== '\n' && c !== '\r') {
              this._query += percentEscapeQuery(c);
            }
            break;
          case 'fragment':
            if (c !== EOF && c !== '\t' && c !== '\n' && c !== '\r') {
              this._fragment += c;
            }
            break;
        }
        cursor++;
      }
    }
    function clear() {
      this._scheme = '';
      this._schemeData = '';
      this._username = '';
      this._password = null;
      this._host = '';
      this._port = '';
      this._path = [];
      this._query = '';
      this._fragment = '';
      this._isInvalid = false;
      this._isRelative = false;
    }
    function JURL(url, base) {
      if (base !== undefined && !(base instanceof JURL)) {
        base = new JURL(String(base));
      }
      this._url = url;
      clear.call(this);
      var input = url.replace(/^[ \t\r\n\f]+|[ \t\r\n\f]+$/g, '');
      parse.call(this, input, null, base);
    }
    JURL.prototype = {
      toString: function toString() {
        return this.href;
      },

      get href() {
        if (this._isInvalid) {
          return this._url;
        }
        var authority = '';
        if (this._username !== '' || this._password !== null) {
          authority = this._username + (this._password !== null ? ':' + this._password : '') + '@';
        }
        return this.protocol + (this._isRelative ? '//' + authority + this.host : '') + this.pathname + this._query + this._fragment;
      },
      set href(value) {
        clear.call(this);
        parse.call(this, value);
      },
      get protocol() {
        return this._scheme + ':';
      },
      set protocol(value) {
        if (this._isInvalid) {
          return;
        }
        parse.call(this, value + ':', 'scheme start');
      },
      get host() {
        return this._isInvalid ? '' : this._port ? this._host + ':' + this._port : this._host;
      },
      set host(value) {
        if (this._isInvalid || !this._isRelative) {
          return;
        }
        parse.call(this, value, 'host');
      },
      get hostname() {
        return this._host;
      },
      set hostname(value) {
        if (this._isInvalid || !this._isRelative) {
          return;
        }
        parse.call(this, value, 'hostname');
      },
      get port() {
        return this._port;
      },
      set port(value) {
        if (this._isInvalid || !this._isRelative) {
          return;
        }
        parse.call(this, value, 'port');
      },
      get pathname() {
        return this._isInvalid ? '' : this._isRelative ? '/' + this._path.join('/') : this._schemeData;
      },
      set pathname(value) {
        if (this._isInvalid || !this._isRelative) {
          return;
        }
        this._path = [];
        parse.call(this, value, 'relative path start');
      },
      get search() {
        return this._isInvalid || !this._query || this._query === '?' ? '' : this._query;
      },
      set search(value) {
        if (this._isInvalid || !this._isRelative) {
          return;
        }
        this._query = '?';
        if (value[0] === '?') {
          value = value.slice(1);
        }
        parse.call(this, value, 'query');
      },
      get hash() {
        return this._isInvalid || !this._fragment || this._fragment === '#' ? '' : this._fragment;
      },
      set hash(value) {
        if (this._isInvalid) {
          return;
        }
        this._fragment = '#';
        if (value[0] === '#') {
          value = value.slice(1);
        }
        parse.call(this, value, 'fragment');
      },
      get origin() {
        var host;
        if (this._isInvalid || !this._scheme) {
          return '';
        }
        switch (this._scheme) {
          case 'data':
          case 'file':
          case 'javascript':
          case 'mailto':
            return 'null';
          case 'blob':
            try {
              return new JURL(this._schemeData).origin || 'null';
            } catch (_) {}
            return 'null';
        }
        host = this.host;
        if (!host) {
          return '';
        }
        return this._scheme + '://' + host;
      }
    };
    var OriginalURL = globalScope.URL;
    if (OriginalURL) {
      JURL.createObjectURL = function (blob) {
        return OriginalURL.createObjectURL.apply(OriginalURL, arguments);
      };
      JURL.revokeObjectURL = function (url) {
        OriginalURL.revokeObjectURL(url);
      };
    }
    globalScope.URL = JURL;
  })();
}

/***/ }),
/* 17 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var isReadableStreamSupported = false;
if (typeof ReadableStream !== 'undefined') {
  try {
    new ReadableStream({
      start: function start(controller) {
        controller.close();
      }
    });
    isReadableStreamSupported = true;
  } catch (e) {}
}
if (isReadableStreamSupported) {
  exports.ReadableStream = ReadableStream;
} else {
  exports.ReadableStream = __w_pdfjs_require__(10).ReadableStream;
}

/***/ })
/******/ ]);
});

}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer)
},{"./pdf.worker.js":1182,"_process":1185,"buffer":570,"node-ensure":566,"zlib":568}],1182:[function(require,module,exports){
(function (process,global){(function (){
/* Copyright 2017 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("pdfjs-dist/build/pdf.worker", [], factory);
	else if(typeof exports === 'object')
		exports["pdfjs-dist/build/pdf.worker"] = factory();
	else
		root["pdfjs-dist/build/pdf.worker"] = root.pdfjsDistBuildPdfWorker = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __w_pdfjs_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __w_pdfjs_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__w_pdfjs_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__w_pdfjs_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__w_pdfjs_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__w_pdfjs_require__.d = function(exports, name, getter) {
/******/ 		if(!__w_pdfjs_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__w_pdfjs_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__w_pdfjs_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__w_pdfjs_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__w_pdfjs_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __w_pdfjs_require__(__w_pdfjs_require__.s = 35);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unreachable = exports.warn = exports.utf8StringToString = exports.stringToUTF8String = exports.stringToPDFString = exports.stringToBytes = exports.string32 = exports.shadow = exports.setVerbosityLevel = exports.ReadableStream = exports.removeNullCharacters = exports.readUint32 = exports.readUint16 = exports.readInt8 = exports.log2 = exports.loadJpegStream = exports.isEvalSupported = exports.isLittleEndian = exports.createValidAbsoluteUrl = exports.isSameOrigin = exports.isNodeJS = exports.isSpace = exports.isString = exports.isNum = exports.isInt = exports.isEmptyObj = exports.isBool = exports.isArrayBuffer = exports.isArray = exports.info = exports.globalScope = exports.getVerbosityLevel = exports.getLookupTableFactory = exports.deprecated = exports.createObjectURL = exports.createPromiseCapability = exports.createBlob = exports.bytesToString = exports.assert = exports.arraysToBytes = exports.arrayByteLength = exports.FormatError = exports.XRefParseException = exports.Util = exports.UnknownErrorException = exports.UnexpectedResponseException = exports.TextRenderingMode = exports.StreamType = exports.StatTimer = exports.PasswordResponses = exports.PasswordException = exports.PageViewport = exports.NotImplementedException = exports.NativeImageDecoding = exports.MissingPDFException = exports.MissingDataException = exports.MessageHandler = exports.InvalidPDFException = exports.AbortException = exports.CMapCompressionType = exports.ImageKind = exports.FontType = exports.AnnotationType = exports.AnnotationFlag = exports.AnnotationFieldFlag = exports.AnnotationBorderStyleType = exports.UNSUPPORTED_FEATURES = exports.VERBOSITY_LEVELS = exports.OPS = exports.IDENTITY_MATRIX = exports.FONT_IDENTITY_MATRIX = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

__w_pdfjs_require__(36);

var _streams_polyfill = __w_pdfjs_require__(37);

var globalScope = typeof window !== 'undefined' && window.Math === Math ? window : typeof global !== 'undefined' && global.Math === Math ? global : typeof self !== 'undefined' && self.Math === Math ? self : undefined;
var FONT_IDENTITY_MATRIX = [0.001, 0, 0, 0.001, 0, 0];
var NativeImageDecoding = {
  NONE: 'none',
  DECODE: 'decode',
  DISPLAY: 'display'
};
var TextRenderingMode = {
  FILL: 0,
  STROKE: 1,
  FILL_STROKE: 2,
  INVISIBLE: 3,
  FILL_ADD_TO_PATH: 4,
  STROKE_ADD_TO_PATH: 5,
  FILL_STROKE_ADD_TO_PATH: 6,
  ADD_TO_PATH: 7,
  FILL_STROKE_MASK: 3,
  ADD_TO_PATH_FLAG: 4
};
var ImageKind = {
  GRAYSCALE_1BPP: 1,
  RGB_24BPP: 2,
  RGBA_32BPP: 3
};
var AnnotationType = {
  TEXT: 1,
  LINK: 2,
  FREETEXT: 3,
  LINE: 4,
  SQUARE: 5,
  CIRCLE: 6,
  POLYGON: 7,
  POLYLINE: 8,
  HIGHLIGHT: 9,
  UNDERLINE: 10,
  SQUIGGLY: 11,
  STRIKEOUT: 12,
  STAMP: 13,
  CARET: 14,
  INK: 15,
  POPUP: 16,
  FILEATTACHMENT: 17,
  SOUND: 18,
  MOVIE: 19,
  WIDGET: 20,
  SCREEN: 21,
  PRINTERMARK: 22,
  TRAPNET: 23,
  WATERMARK: 24,
  THREED: 25,
  REDACT: 26
};
var AnnotationFlag = {
  INVISIBLE: 0x01,
  HIDDEN: 0x02,
  PRINT: 0x04,
  NOZOOM: 0x08,
  NOROTATE: 0x10,
  NOVIEW: 0x20,
  READONLY: 0x40,
  LOCKED: 0x80,
  TOGGLENOVIEW: 0x100,
  LOCKEDCONTENTS: 0x200
};
var AnnotationFieldFlag = {
  READONLY: 0x0000001,
  REQUIRED: 0x0000002,
  NOEXPORT: 0x0000004,
  MULTILINE: 0x0001000,
  PASSWORD: 0x0002000,
  NOTOGGLETOOFF: 0x0004000,
  RADIO: 0x0008000,
  PUSHBUTTON: 0x0010000,
  COMBO: 0x0020000,
  EDIT: 0x0040000,
  SORT: 0x0080000,
  FILESELECT: 0x0100000,
  MULTISELECT: 0x0200000,
  DONOTSPELLCHECK: 0x0400000,
  DONOTSCROLL: 0x0800000,
  COMB: 0x1000000,
  RICHTEXT: 0x2000000,
  RADIOSINUNISON: 0x2000000,
  COMMITONSELCHANGE: 0x4000000
};
var AnnotationBorderStyleType = {
  SOLID: 1,
  DASHED: 2,
  BEVELED: 3,
  INSET: 4,
  UNDERLINE: 5
};
var StreamType = {
  UNKNOWN: 0,
  FLATE: 1,
  LZW: 2,
  DCT: 3,
  JPX: 4,
  JBIG: 5,
  A85: 6,
  AHX: 7,
  CCF: 8,
  RL: 9
};
var FontType = {
  UNKNOWN: 0,
  TYPE1: 1,
  TYPE1C: 2,
  CIDFONTTYPE0: 3,
  CIDFONTTYPE0C: 4,
  TRUETYPE: 5,
  CIDFONTTYPE2: 6,
  TYPE3: 7,
  OPENTYPE: 8,
  TYPE0: 9,
  MMTYPE1: 10
};
var VERBOSITY_LEVELS = {
  errors: 0,
  warnings: 1,
  infos: 5
};
var CMapCompressionType = {
  NONE: 0,
  BINARY: 1,
  STREAM: 2
};
var OPS = {
  dependency: 1,
  setLineWidth: 2,
  setLineCap: 3,
  setLineJoin: 4,
  setMiterLimit: 5,
  setDash: 6,
  setRenderingIntent: 7,
  setFlatness: 8,
  setGState: 9,
  save: 10,
  restore: 11,
  transform: 12,
  moveTo: 13,
  lineTo: 14,
  curveTo: 15,
  curveTo2: 16,
  curveTo3: 17,
  closePath: 18,
  rectangle: 19,
  stroke: 20,
  closeStroke: 21,
  fill: 22,
  eoFill: 23,
  fillStroke: 24,
  eoFillStroke: 25,
  closeFillStroke: 26,
  closeEOFillStroke: 27,
  endPath: 28,
  clip: 29,
  eoClip: 30,
  beginText: 31,
  endText: 32,
  setCharSpacing: 33,
  setWordSpacing: 34,
  setHScale: 35,
  setLeading: 36,
  setFont: 37,
  setTextRenderingMode: 38,
  setTextRise: 39,
  moveText: 40,
  setLeadingMoveText: 41,
  setTextMatrix: 42,
  nextLine: 43,
  showText: 44,
  showSpacedText: 45,
  nextLineShowText: 46,
  nextLineSetSpacingShowText: 47,
  setCharWidth: 48,
  setCharWidthAndBounds: 49,
  setStrokeColorSpace: 50,
  setFillColorSpace: 51,
  setStrokeColor: 52,
  setStrokeColorN: 53,
  setFillColor: 54,
  setFillColorN: 55,
  setStrokeGray: 56,
  setFillGray: 57,
  setStrokeRGBColor: 58,
  setFillRGBColor: 59,
  setStrokeCMYKColor: 60,
  setFillCMYKColor: 61,
  shadingFill: 62,
  beginInlineImage: 63,
  beginImageData: 64,
  endInlineImage: 65,
  paintXObject: 66,
  markPoint: 67,
  markPointProps: 68,
  beginMarkedContent: 69,
  beginMarkedContentProps: 70,
  endMarkedContent: 71,
  beginCompat: 72,
  endCompat: 73,
  paintFormXObjectBegin: 74,
  paintFormXObjectEnd: 75,
  beginGroup: 76,
  endGroup: 77,
  beginAnnotations: 78,
  endAnnotations: 79,
  beginAnnotation: 80,
  endAnnotation: 81,
  paintJpegXObject: 82,
  paintImageMaskXObject: 83,
  paintImageMaskXObjectGroup: 84,
  paintImageXObject: 85,
  paintInlineImageXObject: 86,
  paintInlineImageXObjectGroup: 87,
  paintImageXObjectRepeat: 88,
  paintImageMaskXObjectRepeat: 89,
  paintSolidColorImageMask: 90,
  constructPath: 91
};
var verbosity = VERBOSITY_LEVELS.warnings;
function setVerbosityLevel(level) {
  verbosity = level;
}
function getVerbosityLevel() {
  return verbosity;
}
function info(msg) {
  if (verbosity >= VERBOSITY_LEVELS.infos) {
    console.log('Info: ' + msg);
  }
}
function warn(msg) {
  if (verbosity >= VERBOSITY_LEVELS.warnings) {
    console.log('Warning: ' + msg);
  }
}
function deprecated(details) {
  console.log('Deprecated API usage: ' + details);
}
function unreachable(msg) {
  throw new Error(msg);
}
function assert(cond, msg) {
  if (!cond) {
    unreachable(msg);
  }
}
var UNSUPPORTED_FEATURES = {
  unknown: 'unknown',
  forms: 'forms',
  javaScript: 'javaScript',
  smask: 'smask',
  shadingPattern: 'shadingPattern',
  font: 'font'
};
function isSameOrigin(baseUrl, otherUrl) {
  try {
    var base = new URL(baseUrl);
    if (!base.origin || base.origin === 'null') {
      return false;
    }
  } catch (e) {
    return false;
  }
  var other = new URL(otherUrl, base);
  return base.origin === other.origin;
}
function isValidProtocol(url) {
  if (!url) {
    return false;
  }
  switch (url.protocol) {
    case 'http:':
    case 'https:':
    case 'ftp:':
    case 'mailto:':
    case 'tel:':
      return true;
    default:
      return false;
  }
}
function createValidAbsoluteUrl(url, baseUrl) {
  if (!url) {
    return null;
  }
  try {
    var absoluteUrl = baseUrl ? new URL(url, baseUrl) : new URL(url);
    if (isValidProtocol(absoluteUrl)) {
      return absoluteUrl;
    }
  } catch (ex) {}
  return null;
}
function shadow(obj, prop, value) {
  Object.defineProperty(obj, prop, {
    value: value,
    enumerable: true,
    configurable: true,
    writable: false
  });
  return value;
}
function getLookupTableFactory(initializer) {
  var lookup;
  return function () {
    if (initializer) {
      lookup = Object.create(null);
      initializer(lookup);
      initializer = null;
    }
    return lookup;
  };
}
var PasswordResponses = {
  NEED_PASSWORD: 1,
  INCORRECT_PASSWORD: 2
};
var PasswordException = function PasswordExceptionClosure() {
  function PasswordException(msg, code) {
    this.name = 'PasswordException';
    this.message = msg;
    this.code = code;
  }
  PasswordException.prototype = new Error();
  PasswordException.constructor = PasswordException;
  return PasswordException;
}();
var UnknownErrorException = function UnknownErrorExceptionClosure() {
  function UnknownErrorException(msg, details) {
    this.name = 'UnknownErrorException';
    this.message = msg;
    this.details = details;
  }
  UnknownErrorException.prototype = new Error();
  UnknownErrorException.constructor = UnknownErrorException;
  return UnknownErrorException;
}();
var InvalidPDFException = function InvalidPDFExceptionClosure() {
  function InvalidPDFException(msg) {
    this.name = 'InvalidPDFException';
    this.message = msg;
  }
  InvalidPDFException.prototype = new Error();
  InvalidPDFException.constructor = InvalidPDFException;
  return InvalidPDFException;
}();
var MissingPDFException = function MissingPDFExceptionClosure() {
  function MissingPDFException(msg) {
    this.name = 'MissingPDFException';
    this.message = msg;
  }
  MissingPDFException.prototype = new Error();
  MissingPDFException.constructor = MissingPDFException;
  return MissingPDFException;
}();
var UnexpectedResponseException = function UnexpectedResponseExceptionClosure() {
  function UnexpectedResponseException(msg, status) {
    this.name = 'UnexpectedResponseException';
    this.message = msg;
    this.status = status;
  }
  UnexpectedResponseException.prototype = new Error();
  UnexpectedResponseException.constructor = UnexpectedResponseException;
  return UnexpectedResponseException;
}();
var NotImplementedException = function NotImplementedExceptionClosure() {
  function NotImplementedException(msg) {
    this.message = msg;
  }
  NotImplementedException.prototype = new Error();
  NotImplementedException.prototype.name = 'NotImplementedException';
  NotImplementedException.constructor = NotImplementedException;
  return NotImplementedException;
}();
var MissingDataException = function MissingDataExceptionClosure() {
  function MissingDataException(begin, end) {
    this.begin = begin;
    this.end = end;
    this.message = 'Missing data [' + begin + ', ' + end + ')';
  }
  MissingDataException.prototype = new Error();
  MissingDataException.prototype.name = 'MissingDataException';
  MissingDataException.constructor = MissingDataException;
  return MissingDataException;
}();
var XRefParseException = function XRefParseExceptionClosure() {
  function XRefParseException(msg) {
    this.message = msg;
  }
  XRefParseException.prototype = new Error();
  XRefParseException.prototype.name = 'XRefParseException';
  XRefParseException.constructor = XRefParseException;
  return XRefParseException;
}();
var FormatError = function FormatErrorClosure() {
  function FormatError(msg) {
    this.message = msg;
  }
  FormatError.prototype = new Error();
  FormatError.prototype.name = 'FormatError';
  FormatError.constructor = FormatError;
  return FormatError;
}();
var AbortException = function AbortExceptionClosure() {
  function AbortException(msg) {
    this.name = 'AbortException';
    this.message = msg;
  }
  AbortException.prototype = new Error();
  AbortException.constructor = AbortException;
  return AbortException;
}();
var NullCharactersRegExp = /\x00/g;
function removeNullCharacters(str) {
  if (typeof str !== 'string') {
    warn('The argument for removeNullCharacters must be a string.');
    return str;
  }
  return str.replace(NullCharactersRegExp, '');
}
function bytesToString(bytes) {
  assert(bytes !== null && (typeof bytes === 'undefined' ? 'undefined' : _typeof(bytes)) === 'object' && bytes.length !== undefined, 'Invalid argument for bytesToString');
  var length = bytes.length;
  var MAX_ARGUMENT_COUNT = 8192;
  if (length < MAX_ARGUMENT_COUNT) {
    return String.fromCharCode.apply(null, bytes);
  }
  var strBuf = [];
  for (var i = 0; i < length; i += MAX_ARGUMENT_COUNT) {
    var chunkEnd = Math.min(i + MAX_ARGUMENT_COUNT, length);
    var chunk = bytes.subarray(i, chunkEnd);
    strBuf.push(String.fromCharCode.apply(null, chunk));
  }
  return strBuf.join('');
}
function stringToBytes(str) {
  assert(typeof str === 'string', 'Invalid argument for stringToBytes');
  var length = str.length;
  var bytes = new Uint8Array(length);
  for (var i = 0; i < length; ++i) {
    bytes[i] = str.charCodeAt(i) & 0xFF;
  }
  return bytes;
}
function arrayByteLength(arr) {
  if (arr.length !== undefined) {
    return arr.length;
  }
  assert(arr.byteLength !== undefined);
  return arr.byteLength;
}
function arraysToBytes(arr) {
  if (arr.length === 1 && arr[0] instanceof Uint8Array) {
    return arr[0];
  }
  var resultLength = 0;
  var i,
      ii = arr.length;
  var item, itemLength;
  for (i = 0; i < ii; i++) {
    item = arr[i];
    itemLength = arrayByteLength(item);
    resultLength += itemLength;
  }
  var pos = 0;
  var data = new Uint8Array(resultLength);
  for (i = 0; i < ii; i++) {
    item = arr[i];
    if (!(item instanceof Uint8Array)) {
      if (typeof item === 'string') {
        item = stringToBytes(item);
      } else {
        item = new Uint8Array(item);
      }
    }
    itemLength = item.byteLength;
    data.set(item, pos);
    pos += itemLength;
  }
  return data;
}
function string32(value) {
  return String.fromCharCode(value >> 24 & 0xff, value >> 16 & 0xff, value >> 8 & 0xff, value & 0xff);
}
function log2(x) {
  var n = 1,
      i = 0;
  while (x > n) {
    n <<= 1;
    i++;
  }
  return i;
}
function readInt8(data, start) {
  return data[start] << 24 >> 24;
}
function readUint16(data, offset) {
  return data[offset] << 8 | data[offset + 1];
}
function readUint32(data, offset) {
  return (data[offset] << 24 | data[offset + 1] << 16 | data[offset + 2] << 8 | data[offset + 3]) >>> 0;
}
function isLittleEndian() {
  var buffer8 = new Uint8Array(4);
  buffer8[0] = 1;
  var view32 = new Uint32Array(buffer8.buffer, 0, 1);
  return view32[0] === 1;
}
function isEvalSupported() {
  try {
    new Function('');
    return true;
  } catch (e) {
    return false;
  }
}
var IDENTITY_MATRIX = [1, 0, 0, 1, 0, 0];
var Util = function UtilClosure() {
  function Util() {}
  var rgbBuf = ['rgb(', 0, ',', 0, ',', 0, ')'];
  Util.makeCssRgb = function Util_makeCssRgb(r, g, b) {
    rgbBuf[1] = r;
    rgbBuf[3] = g;
    rgbBuf[5] = b;
    return rgbBuf.join('');
  };
  Util.transform = function Util_transform(m1, m2) {
    return [m1[0] * m2[0] + m1[2] * m2[1], m1[1] * m2[0] + m1[3] * m2[1], m1[0] * m2[2] + m1[2] * m2[3], m1[1] * m2[2] + m1[3] * m2[3], m1[0] * m2[4] + m1[2] * m2[5] + m1[4], m1[1] * m2[4] + m1[3] * m2[5] + m1[5]];
  };
  Util.applyTransform = function Util_applyTransform(p, m) {
    var xt = p[0] * m[0] + p[1] * m[2] + m[4];
    var yt = p[0] * m[1] + p[1] * m[3] + m[5];
    return [xt, yt];
  };
  Util.applyInverseTransform = function Util_applyInverseTransform(p, m) {
    var d = m[0] * m[3] - m[1] * m[2];
    var xt = (p[0] * m[3] - p[1] * m[2] + m[2] * m[5] - m[4] * m[3]) / d;
    var yt = (-p[0] * m[1] + p[1] * m[0] + m[4] * m[1] - m[5] * m[0]) / d;
    return [xt, yt];
  };
  Util.getAxialAlignedBoundingBox = function Util_getAxialAlignedBoundingBox(r, m) {
    var p1 = Util.applyTransform(r, m);
    var p2 = Util.applyTransform(r.slice(2, 4), m);
    var p3 = Util.applyTransform([r[0], r[3]], m);
    var p4 = Util.applyTransform([r[2], r[1]], m);
    return [Math.min(p1[0], p2[0], p3[0], p4[0]), Math.min(p1[1], p2[1], p3[1], p4[1]), Math.max(p1[0], p2[0], p3[0], p4[0]), Math.max(p1[1], p2[1], p3[1], p4[1])];
  };
  Util.inverseTransform = function Util_inverseTransform(m) {
    var d = m[0] * m[3] - m[1] * m[2];
    return [m[3] / d, -m[1] / d, -m[2] / d, m[0] / d, (m[2] * m[5] - m[4] * m[3]) / d, (m[4] * m[1] - m[5] * m[0]) / d];
  };
  Util.apply3dTransform = function Util_apply3dTransform(m, v) {
    return [m[0] * v[0] + m[1] * v[1] + m[2] * v[2], m[3] * v[0] + m[4] * v[1] + m[5] * v[2], m[6] * v[0] + m[7] * v[1] + m[8] * v[2]];
  };
  Util.singularValueDecompose2dScale = function Util_singularValueDecompose2dScale(m) {
    var transpose = [m[0], m[2], m[1], m[3]];
    var a = m[0] * transpose[0] + m[1] * transpose[2];
    var b = m[0] * transpose[1] + m[1] * transpose[3];
    var c = m[2] * transpose[0] + m[3] * transpose[2];
    var d = m[2] * transpose[1] + m[3] * transpose[3];
    var first = (a + d) / 2;
    var second = Math.sqrt((a + d) * (a + d) - 4 * (a * d - c * b)) / 2;
    var sx = first + second || 1;
    var sy = first - second || 1;
    return [Math.sqrt(sx), Math.sqrt(sy)];
  };
  Util.normalizeRect = function Util_normalizeRect(rect) {
    var r = rect.slice(0);
    if (rect[0] > rect[2]) {
      r[0] = rect[2];
      r[2] = rect[0];
    }
    if (rect[1] > rect[3]) {
      r[1] = rect[3];
      r[3] = rect[1];
    }
    return r;
  };
  Util.intersect = function Util_intersect(rect1, rect2) {
    function compare(a, b) {
      return a - b;
    }
    var orderedX = [rect1[0], rect1[2], rect2[0], rect2[2]].sort(compare),
        orderedY = [rect1[1], rect1[3], rect2[1], rect2[3]].sort(compare),
        result = [];
    rect1 = Util.normalizeRect(rect1);
    rect2 = Util.normalizeRect(rect2);
    if (orderedX[0] === rect1[0] && orderedX[1] === rect2[0] || orderedX[0] === rect2[0] && orderedX[1] === rect1[0]) {
      result[0] = orderedX[1];
      result[2] = orderedX[2];
    } else {
      return false;
    }
    if (orderedY[0] === rect1[1] && orderedY[1] === rect2[1] || orderedY[0] === rect2[1] && orderedY[1] === rect1[1]) {
      result[1] = orderedY[1];
      result[3] = orderedY[2];
    } else {
      return false;
    }
    return result;
  };
  Util.sign = function Util_sign(num) {
    return num < 0 ? -1 : 1;
  };
  var ROMAN_NUMBER_MAP = ['', 'C', 'CC', 'CCC', 'CD', 'D', 'DC', 'DCC', 'DCCC', 'CM', '', 'X', 'XX', 'XXX', 'XL', 'L', 'LX', 'LXX', 'LXXX', 'XC', '', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX'];
  Util.toRoman = function Util_toRoman(number, lowerCase) {
    assert(isInt(number) && number > 0, 'The number should be a positive integer.');
    var pos,
        romanBuf = [];
    while (number >= 1000) {
      number -= 1000;
      romanBuf.push('M');
    }
    pos = number / 100 | 0;
    number %= 100;
    romanBuf.push(ROMAN_NUMBER_MAP[pos]);
    pos = number / 10 | 0;
    number %= 10;
    romanBuf.push(ROMAN_NUMBER_MAP[10 + pos]);
    romanBuf.push(ROMAN_NUMBER_MAP[20 + number]);
    var romanStr = romanBuf.join('');
    return lowerCase ? romanStr.toLowerCase() : romanStr;
  };
  Util.appendToArray = function Util_appendToArray(arr1, arr2) {
    Array.prototype.push.apply(arr1, arr2);
  };
  Util.prependToArray = function Util_prependToArray(arr1, arr2) {
    Array.prototype.unshift.apply(arr1, arr2);
  };
  Util.extendObj = function extendObj(obj1, obj2) {
    for (var key in obj2) {
      obj1[key] = obj2[key];
    }
  };
  Util.getInheritableProperty = function Util_getInheritableProperty(dict, name, getArray) {
    while (dict && !dict.has(name)) {
      dict = dict.get('Parent');
    }
    if (!dict) {
      return null;
    }
    return getArray ? dict.getArray(name) : dict.get(name);
  };
  Util.inherit = function Util_inherit(sub, base, prototype) {
    sub.prototype = Object.create(base.prototype);
    sub.prototype.constructor = sub;
    for (var prop in prototype) {
      sub.prototype[prop] = prototype[prop];
    }
  };
  Util.loadScript = function Util_loadScript(src, callback) {
    var script = document.createElement('script');
    var loaded = false;
    script.setAttribute('src', src);
    if (callback) {
      script.onload = function () {
        if (!loaded) {
          callback();
        }
        loaded = true;
      };
    }
    document.getElementsByTagName('head')[0].appendChild(script);
  };
  return Util;
}();
var PageViewport = function PageViewportClosure() {
  function PageViewport(viewBox, scale, rotation, offsetX, offsetY, dontFlip) {
    this.viewBox = viewBox;
    this.scale = scale;
    this.rotation = rotation;
    this.offsetX = offsetX;
    this.offsetY = offsetY;
    var centerX = (viewBox[2] + viewBox[0]) / 2;
    var centerY = (viewBox[3] + viewBox[1]) / 2;
    var rotateA, rotateB, rotateC, rotateD;
    rotation = rotation % 360;
    rotation = rotation < 0 ? rotation + 360 : rotation;
    switch (rotation) {
      case 180:
        rotateA = -1;
        rotateB = 0;
        rotateC = 0;
        rotateD = 1;
        break;
      case 90:
        rotateA = 0;
        rotateB = 1;
        rotateC = 1;
        rotateD = 0;
        break;
      case 270:
        rotateA = 0;
        rotateB = -1;
        rotateC = -1;
        rotateD = 0;
        break;
      default:
        rotateA = 1;
        rotateB = 0;
        rotateC = 0;
        rotateD = -1;
        break;
    }
    if (dontFlip) {
      rotateC = -rotateC;
      rotateD = -rotateD;
    }
    var offsetCanvasX, offsetCanvasY;
    var width, height;
    if (rotateA === 0) {
      offsetCanvasX = Math.abs(centerY - viewBox[1]) * scale + offsetX;
      offsetCanvasY = Math.abs(centerX - viewBox[0]) * scale + offsetY;
      width = Math.abs(viewBox[3] - viewBox[1]) * scale;
      height = Math.abs(viewBox[2] - viewBox[0]) * scale;
    } else {
      offsetCanvasX = Math.abs(centerX - viewBox[0]) * scale + offsetX;
      offsetCanvasY = Math.abs(centerY - viewBox[1]) * scale + offsetY;
      width = Math.abs(viewBox[2] - viewBox[0]) * scale;
      height = Math.abs(viewBox[3] - viewBox[1]) * scale;
    }
    this.transform = [rotateA * scale, rotateB * scale, rotateC * scale, rotateD * scale, offsetCanvasX - rotateA * scale * centerX - rotateC * scale * centerY, offsetCanvasY - rotateB * scale * centerX - rotateD * scale * centerY];
    this.width = width;
    this.height = height;
    this.fontScale = scale;
  }
  PageViewport.prototype = {
    clone: function PageViewPort_clone(args) {
      args = args || {};
      var scale = 'scale' in args ? args.scale : this.scale;
      var rotation = 'rotation' in args ? args.rotation : this.rotation;
      return new PageViewport(this.viewBox.slice(), scale, rotation, this.offsetX, this.offsetY, args.dontFlip);
    },
    convertToViewportPoint: function PageViewport_convertToViewportPoint(x, y) {
      return Util.applyTransform([x, y], this.transform);
    },
    convertToViewportRectangle: function PageViewport_convertToViewportRectangle(rect) {
      var tl = Util.applyTransform([rect[0], rect[1]], this.transform);
      var br = Util.applyTransform([rect[2], rect[3]], this.transform);
      return [tl[0], tl[1], br[0], br[1]];
    },
    convertToPdfPoint: function PageViewport_convertToPdfPoint(x, y) {
      return Util.applyInverseTransform([x, y], this.transform);
    }
  };
  return PageViewport;
}();
var PDFStringTranslateTable = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0x2D8, 0x2C7, 0x2C6, 0x2D9, 0x2DD, 0x2DB, 0x2DA, 0x2DC, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0x2022, 0x2020, 0x2021, 0x2026, 0x2014, 0x2013, 0x192, 0x2044, 0x2039, 0x203A, 0x2212, 0x2030, 0x201E, 0x201C, 0x201D, 0x2018, 0x2019, 0x201A, 0x2122, 0xFB01, 0xFB02, 0x141, 0x152, 0x160, 0x178, 0x17D, 0x131, 0x142, 0x153, 0x161, 0x17E, 0, 0x20AC];
function stringToPDFString(str) {
  var i,
      n = str.length,
      strBuf = [];
  if (str[0] === '\xFE' && str[1] === '\xFF') {
    for (i = 2; i < n; i += 2) {
      strBuf.push(String.fromCharCode(str.charCodeAt(i) << 8 | str.charCodeAt(i + 1)));
    }
  } else {
    for (i = 0; i < n; ++i) {
      var code = PDFStringTranslateTable[str.charCodeAt(i)];
      strBuf.push(code ? String.fromCharCode(code) : str.charAt(i));
    }
  }
  return strBuf.join('');
}
function stringToUTF8String(str) {
  return decodeURIComponent(escape(str));
}
function utf8StringToString(str) {
  return unescape(encodeURIComponent(str));
}
function isEmptyObj(obj) {
  for (var key in obj) {
    return false;
  }
  return true;
}
function isBool(v) {
  return typeof v === 'boolean';
}
function isInt(v) {
  return typeof v === 'number' && (v | 0) === v;
}
function isNum(v) {
  return typeof v === 'number';
}
function isString(v) {
  return typeof v === 'string';
}
function isArray(v) {
  return v instanceof Array;
}
function isArrayBuffer(v) {
  return (typeof v === 'undefined' ? 'undefined' : _typeof(v)) === 'object' && v !== null && v.byteLength !== undefined;
}
function isSpace(ch) {
  return ch === 0x20 || ch === 0x09 || ch === 0x0D || ch === 0x0A;
}
function isNodeJS() {
  return (typeof process === 'undefined' ? 'undefined' : _typeof(process)) === 'object' && process + '' === '[object process]';
}
function createPromiseCapability() {
  var capability = {};
  capability.promise = new Promise(function (resolve, reject) {
    capability.resolve = resolve;
    capability.reject = reject;
  });
  return capability;
}
var StatTimer = function StatTimerClosure() {
  function rpad(str, pad, length) {
    while (str.length < length) {
      str += pad;
    }
    return str;
  }
  function StatTimer() {
    this.started = Object.create(null);
    this.times = [];
    this.enabled = true;
  }
  StatTimer.prototype = {
    time: function StatTimer_time(name) {
      if (!this.enabled) {
        return;
      }
      if (name in this.started) {
        warn('Timer is already running for ' + name);
      }
      this.started[name] = Date.now();
    },
    timeEnd: function StatTimer_timeEnd(name) {
      if (!this.enabled) {
        return;
      }
      if (!(name in this.started)) {
        warn('Timer has not been started for ' + name);
      }
      this.times.push({
        'name': name,
        'start': this.started[name],
        'end': Date.now()
      });
      delete this.started[name];
    },
    toString: function StatTimer_toString() {
      var i, ii;
      var times = this.times;
      var out = '';
      var longest = 0;
      for (i = 0, ii = times.length; i < ii; ++i) {
        var name = times[i]['name'];
        if (name.length > longest) {
          longest = name.length;
        }
      }
      for (i = 0, ii = times.length; i < ii; ++i) {
        var span = times[i];
        var duration = span.end - span.start;
        out += rpad(span['name'], ' ', longest) + ' ' + duration + 'ms\n';
      }
      return out;
    }
  };
  return StatTimer;
}();
var createBlob = function createBlob(data, contentType) {
  if (typeof Blob !== 'undefined') {
    return new Blob([data], { type: contentType });
  }
  throw new Error('The "Blob" constructor is not supported.');
};
var createObjectURL = function createObjectURLClosure() {
  var digits = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
  return function createObjectURL(data, contentType) {
    var forceDataSchema = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    if (!forceDataSchema && URL.createObjectURL) {
      var blob = createBlob(data, contentType);
      return URL.createObjectURL(blob);
    }
    var buffer = 'data:' + contentType + ';base64,';
    for (var i = 0, ii = data.length; i < ii; i += 3) {
      var b1 = data[i] & 0xFF;
      var b2 = data[i + 1] & 0xFF;
      var b3 = data[i + 2] & 0xFF;
      var d1 = b1 >> 2,
          d2 = (b1 & 3) << 4 | b2 >> 4;
      var d3 = i + 1 < ii ? (b2 & 0xF) << 2 | b3 >> 6 : 64;
      var d4 = i + 2 < ii ? b3 & 0x3F : 64;
      buffer += digits[d1] + digits[d2] + digits[d3] + digits[d4];
    }
    return buffer;
  };
}();
function resolveCall(fn, args) {
  var thisArg = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  if (!fn) {
    return Promise.resolve(undefined);
  }
  return new Promise(function (resolve, reject) {
    resolve(fn.apply(thisArg, args));
  });
}
function wrapReason(reason) {
  if ((typeof reason === 'undefined' ? 'undefined' : _typeof(reason)) !== 'object') {
    return reason;
  }
  switch (reason.name) {
    case 'AbortException':
      return new AbortException(reason.message);
    case 'MissingPDFException':
      return new MissingPDFException(reason.message);
    case 'UnexpectedResponseException':
      return new UnexpectedResponseException(reason.message, reason.status);
    default:
      return new UnknownErrorException(reason.message, reason.details);
  }
}
function resolveOrReject(capability, success, reason) {
  if (success) {
    capability.resolve();
  } else {
    capability.reject(reason);
  }
}
function finalize(promise) {
  return Promise.resolve(promise).catch(function () {});
}
function MessageHandler(sourceName, targetName, comObj) {
  var _this = this;

  this.sourceName = sourceName;
  this.targetName = targetName;
  this.comObj = comObj;
  this.callbackId = 1;
  this.streamId = 1;
  this.postMessageTransfers = true;
  this.streamSinks = Object.create(null);
  this.streamControllers = Object.create(null);
  var callbacksCapabilities = this.callbacksCapabilities = Object.create(null);
  var ah = this.actionHandler = Object.create(null);
  this._onComObjOnMessage = function (event) {
    var data = event.data;
    if (data.targetName !== _this.sourceName) {
      return;
    }
    if (data.stream) {
      _this._processStreamMessage(data);
    } else if (data.isReply) {
      var callbackId = data.callbackId;
      if (data.callbackId in callbacksCapabilities) {
        var callback = callbacksCapabilities[callbackId];
        delete callbacksCapabilities[callbackId];
        if ('error' in data) {
          callback.reject(wrapReason(data.error));
        } else {
          callback.resolve(data.data);
        }
      } else {
        throw new Error('Cannot resolve callback ' + callbackId);
      }
    } else if (data.action in ah) {
      var action = ah[data.action];
      if (data.callbackId) {
        var _sourceName = _this.sourceName;
        var _targetName = data.sourceName;
        Promise.resolve().then(function () {
          return action[0].call(action[1], data.data);
        }).then(function (result) {
          comObj.postMessage({
            sourceName: _sourceName,
            targetName: _targetName,
            isReply: true,
            callbackId: data.callbackId,
            data: result
          });
        }, function (reason) {
          if (reason instanceof Error) {
            reason = reason + '';
          }
          comObj.postMessage({
            sourceName: _sourceName,
            targetName: _targetName,
            isReply: true,
            callbackId: data.callbackId,
            error: reason
          });
        });
      } else if (data.streamId) {
        _this._createStreamSink(data);
      } else {
        action[0].call(action[1], data.data);
      }
    } else {
      throw new Error('Unknown action from worker: ' + data.action);
    }
  };
  comObj.addEventListener('message', this._onComObjOnMessage);
}
MessageHandler.prototype = {
  on: function on(actionName, handler, scope) {
    var ah = this.actionHandler;
    if (ah[actionName]) {
      throw new Error('There is already an actionName called "' + actionName + '"');
    }
    ah[actionName] = [handler, scope];
  },
  send: function send(actionName, data, transfers) {
    var message = {
      sourceName: this.sourceName,
      targetName: this.targetName,
      action: actionName,
      data: data
    };
    this.postMessage(message, transfers);
  },
  sendWithPromise: function sendWithPromise(actionName, data, transfers) {
    var callbackId = this.callbackId++;
    var message = {
      sourceName: this.sourceName,
      targetName: this.targetName,
      action: actionName,
      data: data,
      callbackId: callbackId
    };
    var capability = createPromiseCapability();
    this.callbacksCapabilities[callbackId] = capability;
    try {
      this.postMessage(message, transfers);
    } catch (e) {
      capability.reject(e);
    }
    return capability.promise;
  },
  sendWithStream: function sendWithStream(actionName, data, queueingStrategy, transfers) {
    var _this2 = this;

    var streamId = this.streamId++;
    var sourceName = this.sourceName;
    var targetName = this.targetName;
    return new _streams_polyfill.ReadableStream({
      start: function start(controller) {
        var startCapability = createPromiseCapability();
        _this2.streamControllers[streamId] = {
          controller: controller,
          startCall: startCapability,
          isClosed: false
        };
        _this2.postMessage({
          sourceName: sourceName,
          targetName: targetName,
          action: actionName,
          streamId: streamId,
          data: data,
          desiredSize: controller.desiredSize
        });
        return startCapability.promise;
      },
      pull: function pull(controller) {
        var pullCapability = createPromiseCapability();
        _this2.streamControllers[streamId].pullCall = pullCapability;
        _this2.postMessage({
          sourceName: sourceName,
          targetName: targetName,
          stream: 'pull',
          streamId: streamId,
          desiredSize: controller.desiredSize
        });
        return pullCapability.promise;
      },
      cancel: function cancel(reason) {
        var cancelCapability = createPromiseCapability();
        _this2.streamControllers[streamId].cancelCall = cancelCapability;
        _this2.streamControllers[streamId].isClosed = true;
        _this2.postMessage({
          sourceName: sourceName,
          targetName: targetName,
          stream: 'cancel',
          reason: reason,
          streamId: streamId
        });
        return cancelCapability.promise;
      }
    }, queueingStrategy);
  },
  _createStreamSink: function _createStreamSink(data) {
    var _this3 = this;

    var self = this;
    var action = this.actionHandler[data.action];
    var streamId = data.streamId;
    var desiredSize = data.desiredSize;
    var sourceName = this.sourceName;
    var targetName = data.sourceName;
    var capability = createPromiseCapability();
    var sendStreamRequest = function sendStreamRequest(_ref) {
      var stream = _ref.stream,
          chunk = _ref.chunk,
          transfers = _ref.transfers,
          success = _ref.success,
          reason = _ref.reason;

      _this3.postMessage({
        sourceName: sourceName,
        targetName: targetName,
        stream: stream,
        streamId: streamId,
        chunk: chunk,
        success: success,
        reason: reason
      }, transfers);
    };
    var streamSink = {
      enqueue: function enqueue(chunk) {
        var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        var transfers = arguments[2];

        if (this.isCancelled) {
          return;
        }
        var lastDesiredSize = this.desiredSize;
        this.desiredSize -= size;
        if (lastDesiredSize > 0 && this.desiredSize <= 0) {
          this.sinkCapability = createPromiseCapability();
          this.ready = this.sinkCapability.promise;
        }
        sendStreamRequest({
          stream: 'enqueue',
          chunk: chunk,
          transfers: transfers
        });
      },
      close: function close() {
        if (this.isCancelled) {
          return;
        }
        sendStreamRequest({ stream: 'close' });
        delete self.streamSinks[streamId];
      },
      error: function error(reason) {
        if (this.isCancelled) {
          return;
        }
        this.isCancelled = true;
        sendStreamRequest({
          stream: 'error',
          reason: reason
        });
      },

      sinkCapability: capability,
      onPull: null,
      onCancel: null,
      isCancelled: false,
      desiredSize: desiredSize,
      ready: null
    };
    streamSink.sinkCapability.resolve();
    streamSink.ready = streamSink.sinkCapability.promise;
    this.streamSinks[streamId] = streamSink;
    resolveCall(action[0], [data.data, streamSink], action[1]).then(function () {
      sendStreamRequest({
        stream: 'start_complete',
        success: true
      });
    }, function (reason) {
      sendStreamRequest({
        stream: 'start_complete',
        success: false,
        reason: reason
      });
    });
  },
  _processStreamMessage: function _processStreamMessage(data) {
    var _this4 = this;

    var sourceName = this.sourceName;
    var targetName = data.sourceName;
    var streamId = data.streamId;
    var sendStreamResponse = function sendStreamResponse(_ref2) {
      var stream = _ref2.stream,
          success = _ref2.success,
          reason = _ref2.reason;

      _this4.comObj.postMessage({
        sourceName: sourceName,
        targetName: targetName,
        stream: stream,
        success: success,
        streamId: streamId,
        reason: reason
      });
    };
    var deleteStreamController = function deleteStreamController() {
      Promise.all([_this4.streamControllers[data.streamId].startCall, _this4.streamControllers[data.streamId].pullCall, _this4.streamControllers[data.streamId].cancelCall].map(function (capability) {
        return capability && finalize(capability.promise);
      })).then(function () {
        delete _this4.streamControllers[data.streamId];
      });
    };
    switch (data.stream) {
      case 'start_complete':
        resolveOrReject(this.streamControllers[data.streamId].startCall, data.success, wrapReason(data.reason));
        break;
      case 'pull_complete':
        resolveOrReject(this.streamControllers[data.streamId].pullCall, data.success, wrapReason(data.reason));
        break;
      case 'pull':
        if (!this.streamSinks[data.streamId]) {
          sendStreamResponse({
            stream: 'pull_complete',
            success: true
          });
          break;
        }
        if (this.streamSinks[data.streamId].desiredSize <= 0 && data.desiredSize > 0) {
          this.streamSinks[data.streamId].sinkCapability.resolve();
        }
        this.streamSinks[data.streamId].desiredSize = data.desiredSize;
        resolveCall(this.streamSinks[data.streamId].onPull).then(function () {
          sendStreamResponse({
            stream: 'pull_complete',
            success: true
          });
        }, function (reason) {
          sendStreamResponse({
            stream: 'pull_complete',
            success: false,
            reason: reason
          });
        });
        break;
      case 'enqueue':
        assert(this.streamControllers[data.streamId], 'enqueue should have stream controller');
        if (!this.streamControllers[data.streamId].isClosed) {
          this.streamControllers[data.streamId].controller.enqueue(data.chunk);
        }
        break;
      case 'close':
        assert(this.streamControllers[data.streamId], 'close should have stream controller');
        if (this.streamControllers[data.streamId].isClosed) {
          break;
        }
        this.streamControllers[data.streamId].isClosed = true;
        this.streamControllers[data.streamId].controller.close();
        deleteStreamController();
        break;
      case 'error':
        assert(this.streamControllers[data.streamId], 'error should have stream controller');
        this.streamControllers[data.streamId].controller.error(wrapReason(data.reason));
        deleteStreamController();
        break;
      case 'cancel_complete':
        resolveOrReject(this.streamControllers[data.streamId].cancelCall, data.success, wrapReason(data.reason));
        deleteStreamController();
        break;
      case 'cancel':
        if (!this.streamSinks[data.streamId]) {
          break;
        }
        resolveCall(this.streamSinks[data.streamId].onCancel, [wrapReason(data.reason)]).then(function () {
          sendStreamResponse({
            stream: 'cancel_complete',
            success: true
          });
        }, function (reason) {
          sendStreamResponse({
            stream: 'cancel_complete',
            success: false,
            reason: reason
          });
        });
        this.streamSinks[data.streamId].sinkCapability.reject(wrapReason(data.reason));
        this.streamSinks[data.streamId].isCancelled = true;
        delete this.streamSinks[data.streamId];
        break;
      default:
        throw new Error('Unexpected stream case');
    }
  },
  postMessage: function postMessage(message, transfers) {
    if (transfers && this.postMessageTransfers) {
      this.comObj.postMessage(message, transfers);
    } else {
      this.comObj.postMessage(message);
    }
  },
  destroy: function destroy() {
    this.comObj.removeEventListener('message', this._onComObjOnMessage);
  }
};
function loadJpegStream(id, imageUrl, objs) {
  var img = new Image();
  img.onload = function loadJpegStream_onloadClosure() {
    objs.resolve(id, img);
  };
  img.onerror = function loadJpegStream_onerrorClosure() {
    objs.resolve(id, null);
    warn('Error during JPEG image loading');
  };
  img.src = imageUrl;
}
exports.FONT_IDENTITY_MATRIX = FONT_IDENTITY_MATRIX;
exports.IDENTITY_MATRIX = IDENTITY_MATRIX;
exports.OPS = OPS;
exports.VERBOSITY_LEVELS = VERBOSITY_LEVELS;
exports.UNSUPPORTED_FEATURES = UNSUPPORTED_FEATURES;
exports.AnnotationBorderStyleType = AnnotationBorderStyleType;
exports.AnnotationFieldFlag = AnnotationFieldFlag;
exports.AnnotationFlag = AnnotationFlag;
exports.AnnotationType = AnnotationType;
exports.FontType = FontType;
exports.ImageKind = ImageKind;
exports.CMapCompressionType = CMapCompressionType;
exports.AbortException = AbortException;
exports.InvalidPDFException = InvalidPDFException;
exports.MessageHandler = MessageHandler;
exports.MissingDataException = MissingDataException;
exports.MissingPDFException = MissingPDFException;
exports.NativeImageDecoding = NativeImageDecoding;
exports.NotImplementedException = NotImplementedException;
exports.PageViewport = PageViewport;
exports.PasswordException = PasswordException;
exports.PasswordResponses = PasswordResponses;
exports.StatTimer = StatTimer;
exports.StreamType = StreamType;
exports.TextRenderingMode = TextRenderingMode;
exports.UnexpectedResponseException = UnexpectedResponseException;
exports.UnknownErrorException = UnknownErrorException;
exports.Util = Util;
exports.XRefParseException = XRefParseException;
exports.FormatError = FormatError;
exports.arrayByteLength = arrayByteLength;
exports.arraysToBytes = arraysToBytes;
exports.assert = assert;
exports.bytesToString = bytesToString;
exports.createBlob = createBlob;
exports.createPromiseCapability = createPromiseCapability;
exports.createObjectURL = createObjectURL;
exports.deprecated = deprecated;
exports.getLookupTableFactory = getLookupTableFactory;
exports.getVerbosityLevel = getVerbosityLevel;
exports.globalScope = globalScope;
exports.info = info;
exports.isArray = isArray;
exports.isArrayBuffer = isArrayBuffer;
exports.isBool = isBool;
exports.isEmptyObj = isEmptyObj;
exports.isInt = isInt;
exports.isNum = isNum;
exports.isString = isString;
exports.isSpace = isSpace;
exports.isNodeJS = isNodeJS;
exports.isSameOrigin = isSameOrigin;
exports.createValidAbsoluteUrl = createValidAbsoluteUrl;
exports.isLittleEndian = isLittleEndian;
exports.isEvalSupported = isEvalSupported;
exports.loadJpegStream = loadJpegStream;
exports.log2 = log2;
exports.readInt8 = readInt8;
exports.readUint16 = readUint16;
exports.readUint32 = readUint32;
exports.removeNullCharacters = removeNullCharacters;
exports.ReadableStream = _streams_polyfill.ReadableStream;
exports.setVerbosityLevel = setVerbosityLevel;
exports.shadow = shadow;
exports.string32 = string32;
exports.stringToBytes = stringToBytes;
exports.stringToPDFString = stringToPDFString;
exports.stringToUTF8String = stringToUTF8String;
exports.utf8StringToString = utf8StringToString;
exports.warn = warn;
exports.unreachable = unreachable;

/***/ }),
/* 1 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isStream = exports.isRefsEqual = exports.isRef = exports.isName = exports.isDict = exports.isCmd = exports.isEOF = exports.RefSetCache = exports.RefSet = exports.Ref = exports.Name = exports.Dict = exports.Cmd = exports.EOF = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _util = __w_pdfjs_require__(0);

var EOF = {};
var Name = function NameClosure() {
  function Name(name) {
    this.name = name;
  }
  Name.prototype = {};
  var nameCache = Object.create(null);
  Name.get = function Name_get(name) {
    var nameValue = nameCache[name];
    return nameValue ? nameValue : nameCache[name] = new Name(name);
  };
  return Name;
}();
var Cmd = function CmdClosure() {
  function Cmd(cmd) {
    this.cmd = cmd;
  }
  Cmd.prototype = {};
  var cmdCache = Object.create(null);
  Cmd.get = function Cmd_get(cmd) {
    var cmdValue = cmdCache[cmd];
    return cmdValue ? cmdValue : cmdCache[cmd] = new Cmd(cmd);
  };
  return Cmd;
}();
var Dict = function DictClosure() {
  var nonSerializable = function nonSerializableClosure() {
    return nonSerializable;
  };
  function Dict(xref) {
    this._map = Object.create(null);
    this.xref = xref;
    this.objId = null;
    this.suppressEncryption = false;
    this.__nonSerializable__ = nonSerializable;
  }
  Dict.prototype = {
    assignXref: function Dict_assignXref(newXref) {
      this.xref = newXref;
    },
    get: function Dict_get(key1, key2, key3) {
      var value;
      var xref = this.xref,
          suppressEncryption = this.suppressEncryption;
      if (typeof (value = this._map[key1]) !== 'undefined' || key1 in this._map || typeof key2 === 'undefined') {
        return xref ? xref.fetchIfRef(value, suppressEncryption) : value;
      }
      if (typeof (value = this._map[key2]) !== 'undefined' || key2 in this._map || typeof key3 === 'undefined') {
        return xref ? xref.fetchIfRef(value, suppressEncryption) : value;
      }
      value = this._map[key3] || null;
      return xref ? xref.fetchIfRef(value, suppressEncryption) : value;
    },
    getAsync: function Dict_getAsync(key1, key2, key3) {
      var value;
      var xref = this.xref,
          suppressEncryption = this.suppressEncryption;
      if (typeof (value = this._map[key1]) !== 'undefined' || key1 in this._map || typeof key2 === 'undefined') {
        if (xref) {
          return xref.fetchIfRefAsync(value, suppressEncryption);
        }
        return Promise.resolve(value);
      }
      if (typeof (value = this._map[key2]) !== 'undefined' || key2 in this._map || typeof key3 === 'undefined') {
        if (xref) {
          return xref.fetchIfRefAsync(value, suppressEncryption);
        }
        return Promise.resolve(value);
      }
      value = this._map[key3] || null;
      if (xref) {
        return xref.fetchIfRefAsync(value, suppressEncryption);
      }
      return Promise.resolve(value);
    },
    getArray: function Dict_getArray(key1, key2, key3) {
      var value = this.get(key1, key2, key3);
      var xref = this.xref,
          suppressEncryption = this.suppressEncryption;
      if (!(0, _util.isArray)(value) || !xref) {
        return value;
      }
      value = value.slice();
      for (var i = 0, ii = value.length; i < ii; i++) {
        if (!isRef(value[i])) {
          continue;
        }
        value[i] = xref.fetch(value[i], suppressEncryption);
      }
      return value;
    },
    getRaw: function Dict_getRaw(key) {
      return this._map[key];
    },
    getKeys: function Dict_getKeys() {
      return Object.keys(this._map);
    },
    set: function Dict_set(key, value) {
      this._map[key] = value;
    },
    has: function Dict_has(key) {
      return key in this._map;
    },
    forEach: function Dict_forEach(callback) {
      for (var key in this._map) {
        callback(key, this.get(key));
      }
    }
  };
  Dict.empty = new Dict(null);
  Dict.merge = function (xref, dictArray) {
    var mergedDict = new Dict(xref);
    for (var i = 0, ii = dictArray.length; i < ii; i++) {
      var dict = dictArray[i];
      if (!isDict(dict)) {
        continue;
      }
      for (var keyName in dict._map) {
        if (mergedDict._map[keyName] !== undefined) {
          continue;
        }
        mergedDict._map[keyName] = dict._map[keyName];
      }
    }
    return mergedDict;
  };
  return Dict;
}();
var Ref = function RefClosure() {
  function Ref(num, gen) {
    this.num = num;
    this.gen = gen;
  }
  Ref.prototype = {
    toString: function Ref_toString() {
      var str = this.num + 'R';
      if (this.gen !== 0) {
        str += this.gen;
      }
      return str;
    }
  };
  return Ref;
}();
var RefSet = function RefSetClosure() {
  function RefSet() {
    this.dict = Object.create(null);
  }
  RefSet.prototype = {
    has: function RefSet_has(ref) {
      return ref.toString() in this.dict;
    },
    put: function RefSet_put(ref) {
      this.dict[ref.toString()] = true;
    },
    remove: function RefSet_remove(ref) {
      delete this.dict[ref.toString()];
    }
  };
  return RefSet;
}();
var RefSetCache = function RefSetCacheClosure() {
  function RefSetCache() {
    this.dict = Object.create(null);
  }
  RefSetCache.prototype = {
    get: function RefSetCache_get(ref) {
      return this.dict[ref.toString()];
    },
    has: function RefSetCache_has(ref) {
      return ref.toString() in this.dict;
    },
    put: function RefSetCache_put(ref, obj) {
      this.dict[ref.toString()] = obj;
    },
    putAlias: function RefSetCache_putAlias(ref, aliasRef) {
      this.dict[ref.toString()] = this.get(aliasRef);
    },
    forEach: function RefSetCache_forEach(fn, thisArg) {
      for (var i in this.dict) {
        fn.call(thisArg, this.dict[i]);
      }
    },
    clear: function RefSetCache_clear() {
      this.dict = Object.create(null);
    }
  };
  return RefSetCache;
}();
function isEOF(v) {
  return v === EOF;
}
function isName(v, name) {
  return v instanceof Name && (name === undefined || v.name === name);
}
function isCmd(v, cmd) {
  return v instanceof Cmd && (cmd === undefined || v.cmd === cmd);
}
function isDict(v, type) {
  return v instanceof Dict && (type === undefined || isName(v.get('Type'), type));
}
function isRef(v) {
  return v instanceof Ref;
}
function isRefsEqual(v1, v2) {
  return v1.num === v2.num && v1.gen === v2.gen;
}
function isStream(v) {
  return (typeof v === 'undefined' ? 'undefined' : _typeof(v)) === 'object' && v !== null && v.getBytes !== undefined;
}
exports.EOF = EOF;
exports.Cmd = Cmd;
exports.Dict = Dict;
exports.Name = Name;
exports.Ref = Ref;
exports.RefSet = RefSet;
exports.RefSetCache = RefSetCache;
exports.isEOF = isEOF;
exports.isCmd = isCmd;
exports.isDict = isDict;
exports.isName = isName;
exports.isRef = isRef;
exports.isRefsEqual = isRefsEqual;
exports.isStream = isStream;

/***/ }),
/* 2 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LZWStream = exports.StringStream = exports.StreamsSequenceStream = exports.Stream = exports.RunLengthStream = exports.PredictorStream = exports.NullStream = exports.JpxStream = exports.JpegStream = exports.Jbig2Stream = exports.FlateStream = exports.DecodeStream = exports.DecryptStream = exports.CCITTFaxStream = exports.AsciiHexStream = exports.Ascii85Stream = undefined;

var _util = __w_pdfjs_require__(0);

var _primitives = __w_pdfjs_require__(1);

var _jbig = __w_pdfjs_require__(27);

var _jpg = __w_pdfjs_require__(28);

var _jpx = __w_pdfjs_require__(13);

var Stream = function StreamClosure() {
  function Stream(arrayBuffer, start, length, dict) {
    this.bytes = arrayBuffer instanceof Uint8Array ? arrayBuffer : new Uint8Array(arrayBuffer);
    this.start = start || 0;
    this.pos = this.start;
    this.end = start + length || this.bytes.length;
    this.dict = dict;
  }
  Stream.prototype = {
    get length() {
      return this.end - this.start;
    },
    get isEmpty() {
      return this.length === 0;
    },
    getByte: function Stream_getByte() {
      if (this.pos >= this.end) {
        return -1;
      }
      return this.bytes[this.pos++];
    },
    getUint16: function Stream_getUint16() {
      var b0 = this.getByte();
      var b1 = this.getByte();
      if (b0 === -1 || b1 === -1) {
        return -1;
      }
      return (b0 << 8) + b1;
    },
    getInt32: function Stream_getInt32() {
      var b0 = this.getByte();
      var b1 = this.getByte();
      var b2 = this.getByte();
      var b3 = this.getByte();
      return (b0 << 24) + (b1 << 16) + (b2 << 8) + b3;
    },
    getBytes: function Stream_getBytes(length) {
      var bytes = this.bytes;
      var pos = this.pos;
      var strEnd = this.end;
      if (!length) {
        return bytes.subarray(pos, strEnd);
      }
      var end = pos + length;
      if (end > strEnd) {
        end = strEnd;
      }
      this.pos = end;
      return bytes.subarray(pos, end);
    },
    peekByte: function Stream_peekByte() {
      var peekedByte = this.getByte();
      this.pos--;
      return peekedByte;
    },
    peekBytes: function Stream_peekBytes(length) {
      var bytes = this.getBytes(length);
      this.pos -= bytes.length;
      return bytes;
    },
    skip: function Stream_skip(n) {
      if (!n) {
        n = 1;
      }
      this.pos += n;
    },
    reset: function Stream_reset() {
      this.pos = this.start;
    },
    moveStart: function Stream_moveStart() {
      this.start = this.pos;
    },
    makeSubStream: function Stream_makeSubStream(start, length, dict) {
      return new Stream(this.bytes.buffer, start, length, dict);
    }
  };
  return Stream;
}();
var StringStream = function StringStreamClosure() {
  function StringStream(str) {
    var length = str.length;
    var bytes = new Uint8Array(length);
    for (var n = 0; n < length; ++n) {
      bytes[n] = str.charCodeAt(n);
    }
    Stream.call(this, bytes);
  }
  StringStream.prototype = Stream.prototype;
  return StringStream;
}();
var DecodeStream = function DecodeStreamClosure() {
  var emptyBuffer = new Uint8Array(0);
  function DecodeStream(maybeMinBufferLength) {
    this.pos = 0;
    this.bufferLength = 0;
    this.eof = false;
    this.buffer = emptyBuffer;
    this.minBufferLength = 512;
    if (maybeMinBufferLength) {
      while (this.minBufferLength < maybeMinBufferLength) {
        this.minBufferLength *= 2;
      }
    }
  }
  DecodeStream.prototype = {
    get isEmpty() {
      while (!this.eof && this.bufferLength === 0) {
        this.readBlock();
      }
      return this.bufferLength === 0;
    },
    ensureBuffer: function DecodeStream_ensureBuffer(requested) {
      var buffer = this.buffer;
      if (requested <= buffer.byteLength) {
        return buffer;
      }
      var size = this.minBufferLength;
      while (size < requested) {
        size *= 2;
      }
      var buffer2 = new Uint8Array(size);
      buffer2.set(buffer);
      return this.buffer = buffer2;
    },
    getByte: function DecodeStream_getByte() {
      var pos = this.pos;
      while (this.bufferLength <= pos) {
        if (this.eof) {
          return -1;
        }
        this.readBlock();
      }
      return this.buffer[this.pos++];
    },
    getUint16: function DecodeStream_getUint16() {
      var b0 = this.getByte();
      var b1 = this.getByte();
      if (b0 === -1 || b1 === -1) {
        return -1;
      }
      return (b0 << 8) + b1;
    },
    getInt32: function DecodeStream_getInt32() {
      var b0 = this.getByte();
      var b1 = this.getByte();
      var b2 = this.getByte();
      var b3 = this.getByte();
      return (b0 << 24) + (b1 << 16) + (b2 << 8) + b3;
    },
    getBytes: function DecodeStream_getBytes(length) {
      var end,
          pos = this.pos;
      if (length) {
        this.ensureBuffer(pos + length);
        end = pos + length;
        while (!this.eof && this.bufferLength < end) {
          this.readBlock();
        }
        var bufEnd = this.bufferLength;
        if (end > bufEnd) {
          end = bufEnd;
        }
      } else {
        while (!this.eof) {
          this.readBlock();
        }
        end = this.bufferLength;
      }
      this.pos = end;
      return this.buffer.subarray(pos, end);
    },
    peekByte: function DecodeStream_peekByte() {
      var peekedByte = this.getByte();
      this.pos--;
      return peekedByte;
    },
    peekBytes: function DecodeStream_peekBytes(length) {
      var bytes = this.getBytes(length);
      this.pos -= bytes.length;
      return bytes;
    },
    makeSubStream: function DecodeStream_makeSubStream(start, length, dict) {
      var end = start + length;
      while (this.bufferLength <= end && !this.eof) {
        this.readBlock();
      }
      return new Stream(this.buffer, start, length, dict);
    },
    skip: function DecodeStream_skip(n) {
      if (!n) {
        n = 1;
      }
      this.pos += n;
    },
    reset: function DecodeStream_reset() {
      this.pos = 0;
    },
    getBaseStreams: function DecodeStream_getBaseStreams() {
      if (this.str && this.str.getBaseStreams) {
        return this.str.getBaseStreams();
      }
      return [];
    }
  };
  return DecodeStream;
}();
var StreamsSequenceStream = function StreamsSequenceStreamClosure() {
  function StreamsSequenceStream(streams) {
    this.streams = streams;
    DecodeStream.call(this, null);
  }
  StreamsSequenceStream.prototype = Object.create(DecodeStream.prototype);
  StreamsSequenceStream.prototype.readBlock = function streamSequenceStreamReadBlock() {
    var streams = this.streams;
    if (streams.length === 0) {
      this.eof = true;
      return;
    }
    var stream = streams.shift();
    var chunk = stream.getBytes();
    var bufferLength = this.bufferLength;
    var newLength = bufferLength + chunk.length;
    var buffer = this.ensureBuffer(newLength);
    buffer.set(chunk, bufferLength);
    this.bufferLength = newLength;
  };
  StreamsSequenceStream.prototype.getBaseStreams = function StreamsSequenceStream_getBaseStreams() {
    var baseStreams = [];
    for (var i = 0, ii = this.streams.length; i < ii; i++) {
      var stream = this.streams[i];
      if (stream.getBaseStreams) {
        _util.Util.appendToArray(baseStreams, stream.getBaseStreams());
      }
    }
    return baseStreams;
  };
  return StreamsSequenceStream;
}();
var FlateStream = function FlateStreamClosure() {
  var codeLenCodeMap = new Int32Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
  var lengthDecode = new Int32Array([0x00003, 0x00004, 0x00005, 0x00006, 0x00007, 0x00008, 0x00009, 0x0000a, 0x1000b, 0x1000d, 0x1000f, 0x10011, 0x20013, 0x20017, 0x2001b, 0x2001f, 0x30023, 0x3002b, 0x30033, 0x3003b, 0x40043, 0x40053, 0x40063, 0x40073, 0x50083, 0x500a3, 0x500c3, 0x500e3, 0x00102, 0x00102, 0x00102]);
  var distDecode = new Int32Array([0x00001, 0x00002, 0x00003, 0x00004, 0x10005, 0x10007, 0x20009, 0x2000d, 0x30011, 0x30019, 0x40021, 0x40031, 0x50041, 0x50061, 0x60081, 0x600c1, 0x70101, 0x70181, 0x80201, 0x80301, 0x90401, 0x90601, 0xa0801, 0xa0c01, 0xb1001, 0xb1801, 0xc2001, 0xc3001, 0xd4001, 0xd6001]);
  var fixedLitCodeTab = [new Int32Array([0x70100, 0x80050, 0x80010, 0x80118, 0x70110, 0x80070, 0x80030, 0x900c0, 0x70108, 0x80060, 0x80020, 0x900a0, 0x80000, 0x80080, 0x80040, 0x900e0, 0x70104, 0x80058, 0x80018, 0x90090, 0x70114, 0x80078, 0x80038, 0x900d0, 0x7010c, 0x80068, 0x80028, 0x900b0, 0x80008, 0x80088, 0x80048, 0x900f0, 0x70102, 0x80054, 0x80014, 0x8011c, 0x70112, 0x80074, 0x80034, 0x900c8, 0x7010a, 0x80064, 0x80024, 0x900a8, 0x80004, 0x80084, 0x80044, 0x900e8, 0x70106, 0x8005c, 0x8001c, 0x90098, 0x70116, 0x8007c, 0x8003c, 0x900d8, 0x7010e, 0x8006c, 0x8002c, 0x900b8, 0x8000c, 0x8008c, 0x8004c, 0x900f8, 0x70101, 0x80052, 0x80012, 0x8011a, 0x70111, 0x80072, 0x80032, 0x900c4, 0x70109, 0x80062, 0x80022, 0x900a4, 0x80002, 0x80082, 0x80042, 0x900e4, 0x70105, 0x8005a, 0x8001a, 0x90094, 0x70115, 0x8007a, 0x8003a, 0x900d4, 0x7010d, 0x8006a, 0x8002a, 0x900b4, 0x8000a, 0x8008a, 0x8004a, 0x900f4, 0x70103, 0x80056, 0x80016, 0x8011e, 0x70113, 0x80076, 0x80036, 0x900cc, 0x7010b, 0x80066, 0x80026, 0x900ac, 0x80006, 0x80086, 0x80046, 0x900ec, 0x70107, 0x8005e, 0x8001e, 0x9009c, 0x70117, 0x8007e, 0x8003e, 0x900dc, 0x7010f, 0x8006e, 0x8002e, 0x900bc, 0x8000e, 0x8008e, 0x8004e, 0x900fc, 0x70100, 0x80051, 0x80011, 0x80119, 0x70110, 0x80071, 0x80031, 0x900c2, 0x70108, 0x80061, 0x80021, 0x900a2, 0x80001, 0x80081, 0x80041, 0x900e2, 0x70104, 0x80059, 0x80019, 0x90092, 0x70114, 0x80079, 0x80039, 0x900d2, 0x7010c, 0x80069, 0x80029, 0x900b2, 0x80009, 0x80089, 0x80049, 0x900f2, 0x70102, 0x80055, 0x80015, 0x8011d, 0x70112, 0x80075, 0x80035, 0x900ca, 0x7010a, 0x80065, 0x80025, 0x900aa, 0x80005, 0x80085, 0x80045, 0x900ea, 0x70106, 0x8005d, 0x8001d, 0x9009a, 0x70116, 0x8007d, 0x8003d, 0x900da, 0x7010e, 0x8006d, 0x8002d, 0x900ba, 0x8000d, 0x8008d, 0x8004d, 0x900fa, 0x70101, 0x80053, 0x80013, 0x8011b, 0x70111, 0x80073, 0x80033, 0x900c6, 0x70109, 0x80063, 0x80023, 0x900a6, 0x80003, 0x80083, 0x80043, 0x900e6, 0x70105, 0x8005b, 0x8001b, 0x90096, 0x70115, 0x8007b, 0x8003b, 0x900d6, 0x7010d, 0x8006b, 0x8002b, 0x900b6, 0x8000b, 0x8008b, 0x8004b, 0x900f6, 0x70103, 0x80057, 0x80017, 0x8011f, 0x70113, 0x80077, 0x80037, 0x900ce, 0x7010b, 0x80067, 0x80027, 0x900ae, 0x80007, 0x80087, 0x80047, 0x900ee, 0x70107, 0x8005f, 0x8001f, 0x9009e, 0x70117, 0x8007f, 0x8003f, 0x900de, 0x7010f, 0x8006f, 0x8002f, 0x900be, 0x8000f, 0x8008f, 0x8004f, 0x900fe, 0x70100, 0x80050, 0x80010, 0x80118, 0x70110, 0x80070, 0x80030, 0x900c1, 0x70108, 0x80060, 0x80020, 0x900a1, 0x80000, 0x80080, 0x80040, 0x900e1, 0x70104, 0x80058, 0x80018, 0x90091, 0x70114, 0x80078, 0x80038, 0x900d1, 0x7010c, 0x80068, 0x80028, 0x900b1, 0x80008, 0x80088, 0x80048, 0x900f1, 0x70102, 0x80054, 0x80014, 0x8011c, 0x70112, 0x80074, 0x80034, 0x900c9, 0x7010a, 0x80064, 0x80024, 0x900a9, 0x80004, 0x80084, 0x80044, 0x900e9, 0x70106, 0x8005c, 0x8001c, 0x90099, 0x70116, 0x8007c, 0x8003c, 0x900d9, 0x7010e, 0x8006c, 0x8002c, 0x900b9, 0x8000c, 0x8008c, 0x8004c, 0x900f9, 0x70101, 0x80052, 0x80012, 0x8011a, 0x70111, 0x80072, 0x80032, 0x900c5, 0x70109, 0x80062, 0x80022, 0x900a5, 0x80002, 0x80082, 0x80042, 0x900e5, 0x70105, 0x8005a, 0x8001a, 0x90095, 0x70115, 0x8007a, 0x8003a, 0x900d5, 0x7010d, 0x8006a, 0x8002a, 0x900b5, 0x8000a, 0x8008a, 0x8004a, 0x900f5, 0x70103, 0x80056, 0x80016, 0x8011e, 0x70113, 0x80076, 0x80036, 0x900cd, 0x7010b, 0x80066, 0x80026, 0x900ad, 0x80006, 0x80086, 0x80046, 0x900ed, 0x70107, 0x8005e, 0x8001e, 0x9009d, 0x70117, 0x8007e, 0x8003e, 0x900dd, 0x7010f, 0x8006e, 0x8002e, 0x900bd, 0x8000e, 0x8008e, 0x8004e, 0x900fd, 0x70100, 0x80051, 0x80011, 0x80119, 0x70110, 0x80071, 0x80031, 0x900c3, 0x70108, 0x80061, 0x80021, 0x900a3, 0x80001, 0x80081, 0x80041, 0x900e3, 0x70104, 0x80059, 0x80019, 0x90093, 0x70114, 0x80079, 0x80039, 0x900d3, 0x7010c, 0x80069, 0x80029, 0x900b3, 0x80009, 0x80089, 0x80049, 0x900f3, 0x70102, 0x80055, 0x80015, 0x8011d, 0x70112, 0x80075, 0x80035, 0x900cb, 0x7010a, 0x80065, 0x80025, 0x900ab, 0x80005, 0x80085, 0x80045, 0x900eb, 0x70106, 0x8005d, 0x8001d, 0x9009b, 0x70116, 0x8007d, 0x8003d, 0x900db, 0x7010e, 0x8006d, 0x8002d, 0x900bb, 0x8000d, 0x8008d, 0x8004d, 0x900fb, 0x70101, 0x80053, 0x80013, 0x8011b, 0x70111, 0x80073, 0x80033, 0x900c7, 0x70109, 0x80063, 0x80023, 0x900a7, 0x80003, 0x80083, 0x80043, 0x900e7, 0x70105, 0x8005b, 0x8001b, 0x90097, 0x70115, 0x8007b, 0x8003b, 0x900d7, 0x7010d, 0x8006b, 0x8002b, 0x900b7, 0x8000b, 0x8008b, 0x8004b, 0x900f7, 0x70103, 0x80057, 0x80017, 0x8011f, 0x70113, 0x80077, 0x80037, 0x900cf, 0x7010b, 0x80067, 0x80027, 0x900af, 0x80007, 0x80087, 0x80047, 0x900ef, 0x70107, 0x8005f, 0x8001f, 0x9009f, 0x70117, 0x8007f, 0x8003f, 0x900df, 0x7010f, 0x8006f, 0x8002f, 0x900bf, 0x8000f, 0x8008f, 0x8004f, 0x900ff]), 9];
  var fixedDistCodeTab = [new Int32Array([0x50000, 0x50010, 0x50008, 0x50018, 0x50004, 0x50014, 0x5000c, 0x5001c, 0x50002, 0x50012, 0x5000a, 0x5001a, 0x50006, 0x50016, 0x5000e, 0x00000, 0x50001, 0x50011, 0x50009, 0x50019, 0x50005, 0x50015, 0x5000d, 0x5001d, 0x50003, 0x50013, 0x5000b, 0x5001b, 0x50007, 0x50017, 0x5000f, 0x00000]), 5];
  function FlateStream(str, maybeLength) {
    this.str = str;
    this.dict = str.dict;
    var cmf = str.getByte();
    var flg = str.getByte();
    if (cmf === -1 || flg === -1) {
      throw new _util.FormatError('Invalid header in flate stream: ' + cmf + ', ' + flg);
    }
    if ((cmf & 0x0f) !== 0x08) {
      throw new _util.FormatError('Unknown compression method in flate stream: ' + cmf + ', ' + flg);
    }
    if (((cmf << 8) + flg) % 31 !== 0) {
      throw new _util.FormatError('Bad FCHECK in flate stream: ' + cmf + ', ' + flg);
    }
    if (flg & 0x20) {
      throw new _util.FormatError('FDICT bit set in flate stream: ' + cmf + ', ' + flg);
    }
    this.codeSize = 0;
    this.codeBuf = 0;
    DecodeStream.call(this, maybeLength);
  }
  FlateStream.prototype = Object.create(DecodeStream.prototype);
  FlateStream.prototype.getBits = function FlateStream_getBits(bits) {
    var str = this.str;
    var codeSize = this.codeSize;
    var codeBuf = this.codeBuf;
    var b;
    while (codeSize < bits) {
      if ((b = str.getByte()) === -1) {
        throw new _util.FormatError('Bad encoding in flate stream');
      }
      codeBuf |= b << codeSize;
      codeSize += 8;
    }
    b = codeBuf & (1 << bits) - 1;
    this.codeBuf = codeBuf >> bits;
    this.codeSize = codeSize -= bits;
    return b;
  };
  FlateStream.prototype.getCode = function FlateStream_getCode(table) {
    var str = this.str;
    var codes = table[0];
    var maxLen = table[1];
    var codeSize = this.codeSize;
    var codeBuf = this.codeBuf;
    var b;
    while (codeSize < maxLen) {
      if ((b = str.getByte()) === -1) {
        break;
      }
      codeBuf |= b << codeSize;
      codeSize += 8;
    }
    var code = codes[codeBuf & (1 << maxLen) - 1];
    var codeLen = code >> 16;
    var codeVal = code & 0xffff;
    if (codeLen < 1 || codeSize < codeLen) {
      throw new _util.FormatError('Bad encoding in flate stream');
    }
    this.codeBuf = codeBuf >> codeLen;
    this.codeSize = codeSize - codeLen;
    return codeVal;
  };
  FlateStream.prototype.generateHuffmanTable = function flateStreamGenerateHuffmanTable(lengths) {
    var n = lengths.length;
    var maxLen = 0;
    var i;
    for (i = 0; i < n; ++i) {
      if (lengths[i] > maxLen) {
        maxLen = lengths[i];
      }
    }
    var size = 1 << maxLen;
    var codes = new Int32Array(size);
    for (var len = 1, code = 0, skip = 2; len <= maxLen; ++len, code <<= 1, skip <<= 1) {
      for (var val = 0; val < n; ++val) {
        if (lengths[val] === len) {
          var code2 = 0;
          var t = code;
          for (i = 0; i < len; ++i) {
            code2 = code2 << 1 | t & 1;
            t >>= 1;
          }
          for (i = code2; i < size; i += skip) {
            codes[i] = len << 16 | val;
          }
          ++code;
        }
      }
    }
    return [codes, maxLen];
  };
  FlateStream.prototype.readBlock = function FlateStream_readBlock() {
    var buffer, len;
    var str = this.str;
    var hdr = this.getBits(3);
    if (hdr & 1) {
      this.eof = true;
    }
    hdr >>= 1;
    if (hdr === 0) {
      var b;
      if ((b = str.getByte()) === -1) {
        throw new _util.FormatError('Bad block header in flate stream');
      }
      var blockLen = b;
      if ((b = str.getByte()) === -1) {
        throw new _util.FormatError('Bad block header in flate stream');
      }
      blockLen |= b << 8;
      if ((b = str.getByte()) === -1) {
        throw new _util.FormatError('Bad block header in flate stream');
      }
      var check = b;
      if ((b = str.getByte()) === -1) {
        throw new _util.FormatError('Bad block header in flate stream');
      }
      check |= b << 8;
      if (check !== (~blockLen & 0xffff) && (blockLen !== 0 || check !== 0)) {
        throw new _util.FormatError('Bad uncompressed block length in flate stream');
      }
      this.codeBuf = 0;
      this.codeSize = 0;
      var bufferLength = this.bufferLength;
      buffer = this.ensureBuffer(bufferLength + blockLen);
      var end = bufferLength + blockLen;
      this.bufferLength = end;
      if (blockLen === 0) {
        if (str.peekByte() === -1) {
          this.eof = true;
        }
      } else {
        for (var n = bufferLength; n < end; ++n) {
          if ((b = str.getByte()) === -1) {
            this.eof = true;
            break;
          }
          buffer[n] = b;
        }
      }
      return;
    }
    var litCodeTable;
    var distCodeTable;
    if (hdr === 1) {
      litCodeTable = fixedLitCodeTab;
      distCodeTable = fixedDistCodeTab;
    } else if (hdr === 2) {
      var numLitCodes = this.getBits(5) + 257;
      var numDistCodes = this.getBits(5) + 1;
      var numCodeLenCodes = this.getBits(4) + 4;
      var codeLenCodeLengths = new Uint8Array(codeLenCodeMap.length);
      var i;
      for (i = 0; i < numCodeLenCodes; ++i) {
        codeLenCodeLengths[codeLenCodeMap[i]] = this.getBits(3);
      }
      var codeLenCodeTab = this.generateHuffmanTable(codeLenCodeLengths);
      len = 0;
      i = 0;
      var codes = numLitCodes + numDistCodes;
      var codeLengths = new Uint8Array(codes);
      var bitsLength, bitsOffset, what;
      while (i < codes) {
        var code = this.getCode(codeLenCodeTab);
        if (code === 16) {
          bitsLength = 2;
          bitsOffset = 3;
          what = len;
        } else if (code === 17) {
          bitsLength = 3;
          bitsOffset = 3;
          what = len = 0;
        } else if (code === 18) {
          bitsLength = 7;
          bitsOffset = 11;
          what = len = 0;
        } else {
          codeLengths[i++] = len = code;
          continue;
        }
        var repeatLength = this.getBits(bitsLength) + bitsOffset;
        while (repeatLength-- > 0) {
          codeLengths[i++] = what;
        }
      }
      litCodeTable = this.generateHuffmanTable(codeLengths.subarray(0, numLitCodes));
      distCodeTable = this.generateHuffmanTable(codeLengths.subarray(numLitCodes, codes));
    } else {
      throw new _util.FormatError('Unknown block type in flate stream');
    }
    buffer = this.buffer;
    var limit = buffer ? buffer.length : 0;
    var pos = this.bufferLength;
    while (true) {
      var code1 = this.getCode(litCodeTable);
      if (code1 < 256) {
        if (pos + 1 >= limit) {
          buffer = this.ensureBuffer(pos + 1);
          limit = buffer.length;
        }
        buffer[pos++] = code1;
        continue;
      }
      if (code1 === 256) {
        this.bufferLength = pos;
        return;
      }
      code1 -= 257;
      code1 = lengthDecode[code1];
      var code2 = code1 >> 16;
      if (code2 > 0) {
        code2 = this.getBits(code2);
      }
      len = (code1 & 0xffff) + code2;
      code1 = this.getCode(distCodeTable);
      code1 = distDecode[code1];
      code2 = code1 >> 16;
      if (code2 > 0) {
        code2 = this.getBits(code2);
      }
      var dist = (code1 & 0xffff) + code2;
      if (pos + len >= limit) {
        buffer = this.ensureBuffer(pos + len);
        limit = buffer.length;
      }
      for (var k = 0; k < len; ++k, ++pos) {
        buffer[pos] = buffer[pos - dist];
      }
    }
  };
  return FlateStream;
}();
var PredictorStream = function PredictorStreamClosure() {
  function PredictorStream(str, maybeLength, params) {
    if (!(0, _primitives.isDict)(params)) {
      return str;
    }
    var predictor = this.predictor = params.get('Predictor') || 1;
    if (predictor <= 1) {
      return str;
    }
    if (predictor !== 2 && (predictor < 10 || predictor > 15)) {
      throw new _util.FormatError('Unsupported predictor: ' + predictor);
    }
    if (predictor === 2) {
      this.readBlock = this.readBlockTiff;
    } else {
      this.readBlock = this.readBlockPng;
    }
    this.str = str;
    this.dict = str.dict;
    var colors = this.colors = params.get('Colors') || 1;
    var bits = this.bits = params.get('BitsPerComponent') || 8;
    var columns = this.columns = params.get('Columns') || 1;
    this.pixBytes = colors * bits + 7 >> 3;
    this.rowBytes = columns * colors * bits + 7 >> 3;
    DecodeStream.call(this, maybeLength);
    return this;
  }
  PredictorStream.prototype = Object.create(DecodeStream.prototype);
  PredictorStream.prototype.readBlockTiff = function predictorStreamReadBlockTiff() {
    var rowBytes = this.rowBytes;
    var bufferLength = this.bufferLength;
    var buffer = this.ensureBuffer(bufferLength + rowBytes);
    var bits = this.bits;
    var colors = this.colors;
    var rawBytes = this.str.getBytes(rowBytes);
    this.eof = !rawBytes.length;
    if (this.eof) {
      return;
    }
    var inbuf = 0,
        outbuf = 0;
    var inbits = 0,
        outbits = 0;
    var pos = bufferLength;
    var i;
    if (bits === 1 && colors === 1) {
      for (i = 0; i < rowBytes; ++i) {
        var c = rawBytes[i] ^ inbuf;
        c ^= c >> 1;
        c ^= c >> 2;
        c ^= c >> 4;
        inbuf = (c & 1) << 7;
        buffer[pos++] = c;
      }
    } else if (bits === 8) {
      for (i = 0; i < colors; ++i) {
        buffer[pos++] = rawBytes[i];
      }
      for (; i < rowBytes; ++i) {
        buffer[pos] = buffer[pos - colors] + rawBytes[i];
        pos++;
      }
    } else {
      var compArray = new Uint8Array(colors + 1);
      var bitMask = (1 << bits) - 1;
      var j = 0,
          k = bufferLength;
      var columns = this.columns;
      for (i = 0; i < columns; ++i) {
        for (var kk = 0; kk < colors; ++kk) {
          if (inbits < bits) {
            inbuf = inbuf << 8 | rawBytes[j++] & 0xFF;
            inbits += 8;
          }
          compArray[kk] = compArray[kk] + (inbuf >> inbits - bits) & bitMask;
          inbits -= bits;
          outbuf = outbuf << bits | compArray[kk];
          outbits += bits;
          if (outbits >= 8) {
            buffer[k++] = outbuf >> outbits - 8 & 0xFF;
            outbits -= 8;
          }
        }
      }
      if (outbits > 0) {
        buffer[k++] = (outbuf << 8 - outbits) + (inbuf & (1 << 8 - outbits) - 1);
      }
    }
    this.bufferLength += rowBytes;
  };
  PredictorStream.prototype.readBlockPng = function predictorStreamReadBlockPng() {
    var rowBytes = this.rowBytes;
    var pixBytes = this.pixBytes;
    var predictor = this.str.getByte();
    var rawBytes = this.str.getBytes(rowBytes);
    this.eof = !rawBytes.length;
    if (this.eof) {
      return;
    }
    var bufferLength = this.bufferLength;
    var buffer = this.ensureBuffer(bufferLength + rowBytes);
    var prevRow = buffer.subarray(bufferLength - rowBytes, bufferLength);
    if (prevRow.length === 0) {
      prevRow = new Uint8Array(rowBytes);
    }
    var i,
        j = bufferLength,
        up,
        c;
    switch (predictor) {
      case 0:
        for (i = 0; i < rowBytes; ++i) {
          buffer[j++] = rawBytes[i];
        }
        break;
      case 1:
        for (i = 0; i < pixBytes; ++i) {
          buffer[j++] = rawBytes[i];
        }
        for (; i < rowBytes; ++i) {
          buffer[j] = buffer[j - pixBytes] + rawBytes[i] & 0xFF;
          j++;
        }
        break;
      case 2:
        for (i = 0; i < rowBytes; ++i) {
          buffer[j++] = prevRow[i] + rawBytes[i] & 0xFF;
        }
        break;
      case 3:
        for (i = 0; i < pixBytes; ++i) {
          buffer[j++] = (prevRow[i] >> 1) + rawBytes[i];
        }
        for (; i < rowBytes; ++i) {
          buffer[j] = (prevRow[i] + buffer[j - pixBytes] >> 1) + rawBytes[i] & 0xFF;
          j++;
        }
        break;
      case 4:
        for (i = 0; i < pixBytes; ++i) {
          up = prevRow[i];
          c = rawBytes[i];
          buffer[j++] = up + c;
        }
        for (; i < rowBytes; ++i) {
          up = prevRow[i];
          var upLeft = prevRow[i - pixBytes];
          var left = buffer[j - pixBytes];
          var p = left + up - upLeft;
          var pa = p - left;
          if (pa < 0) {
            pa = -pa;
          }
          var pb = p - up;
          if (pb < 0) {
            pb = -pb;
          }
          var pc = p - upLeft;
          if (pc < 0) {
            pc = -pc;
          }
          c = rawBytes[i];
          if (pa <= pb && pa <= pc) {
            buffer[j++] = left + c;
          } else if (pb <= pc) {
            buffer[j++] = up + c;
          } else {
            buffer[j++] = upLeft + c;
          }
        }
        break;
      default:
        throw new _util.FormatError('Unsupported predictor: ' + predictor);
    }
    this.bufferLength += rowBytes;
  };
  return PredictorStream;
}();
var JpegStream = function JpegStreamClosure() {
  function JpegStream(stream, maybeLength, dict, params) {
    var ch;
    while ((ch = stream.getByte()) !== -1) {
      if (ch === 0xFF) {
        stream.skip(-1);
        break;
      }
    }
    this.stream = stream;
    this.maybeLength = maybeLength;
    this.dict = dict;
    this.params = params;
    DecodeStream.call(this, maybeLength);
  }
  JpegStream.prototype = Object.create(DecodeStream.prototype);
  Object.defineProperty(JpegStream.prototype, 'bytes', {
    get: function JpegStream_bytes() {
      return (0, _util.shadow)(this, 'bytes', this.stream.getBytes(this.maybeLength));
    },
    configurable: true
  });
  JpegStream.prototype.ensureBuffer = function JpegStream_ensureBuffer(req) {
    if (this.bufferLength) {
      return;
    }
    var jpegImage = new _jpg.JpegImage();
    var decodeArr = this.dict.getArray('Decode', 'D');
    if (this.forceRGB && (0, _util.isArray)(decodeArr)) {
      var bitsPerComponent = this.dict.get('BitsPerComponent') || 8;
      var decodeArrLength = decodeArr.length;
      var transform = new Int32Array(decodeArrLength);
      var transformNeeded = false;
      var maxValue = (1 << bitsPerComponent) - 1;
      for (var i = 0; i < decodeArrLength; i += 2) {
        transform[i] = (decodeArr[i + 1] - decodeArr[i]) * 256 | 0;
        transform[i + 1] = decodeArr[i] * maxValue | 0;
        if (transform[i] !== 256 || transform[i + 1] !== 0) {
          transformNeeded = true;
        }
      }
      if (transformNeeded) {
        jpegImage.decodeTransform = transform;
      }
    }
    if ((0, _primitives.isDict)(this.params)) {
      var colorTransform = this.params.get('ColorTransform');
      if ((0, _util.isInt)(colorTransform)) {
        jpegImage.colorTransform = colorTransform;
      }
    }
    jpegImage.parse(this.bytes);
    var data = jpegImage.getData(this.drawWidth, this.drawHeight, this.forceRGB);
    this.buffer = data;
    this.bufferLength = data.length;
    this.eof = true;
  };
  JpegStream.prototype.getBytes = function JpegStream_getBytes(length) {
    this.ensureBuffer();
    return this.buffer;
  };
  JpegStream.prototype.getIR = function JpegStream_getIR(forceDataSchema) {
    return (0, _util.createObjectURL)(this.bytes, 'image/jpeg', forceDataSchema);
  };
  return JpegStream;
}();
var JpxStream = function JpxStreamClosure() {
  function JpxStream(stream, maybeLength, dict, params) {
    this.stream = stream;
    this.maybeLength = maybeLength;
    this.dict = dict;
    this.params = params;
    DecodeStream.call(this, maybeLength);
  }
  JpxStream.prototype = Object.create(DecodeStream.prototype);
  Object.defineProperty(JpxStream.prototype, 'bytes', {
    get: function JpxStream_bytes() {
      return (0, _util.shadow)(this, 'bytes', this.stream.getBytes(this.maybeLength));
    },
    configurable: true
  });
  JpxStream.prototype.ensureBuffer = function JpxStream_ensureBuffer(req) {
    if (this.bufferLength) {
      return;
    }
    var jpxImage = new _jpx.JpxImage();
    jpxImage.parse(this.bytes);
    var width = jpxImage.width;
    var height = jpxImage.height;
    var componentsCount = jpxImage.componentsCount;
    var tileCount = jpxImage.tiles.length;
    if (tileCount === 1) {
      this.buffer = jpxImage.tiles[0].items;
    } else {
      var data = new Uint8Array(width * height * componentsCount);
      for (var k = 0; k < tileCount; k++) {
        var tileComponents = jpxImage.tiles[k];
        var tileWidth = tileComponents.width;
        var tileHeight = tileComponents.height;
        var tileLeft = tileComponents.left;
        var tileTop = tileComponents.top;
        var src = tileComponents.items;
        var srcPosition = 0;
        var dataPosition = (width * tileTop + tileLeft) * componentsCount;
        var imgRowSize = width * componentsCount;
        var tileRowSize = tileWidth * componentsCount;
        for (var j = 0; j < tileHeight; j++) {
          var rowBytes = src.subarray(srcPosition, srcPosition + tileRowSize);
          data.set(rowBytes, dataPosition);
          srcPosition += tileRowSize;
          dataPosition += imgRowSize;
        }
      }
      this.buffer = data;
    }
    this.bufferLength = this.buffer.length;
    this.eof = true;
  };
  return JpxStream;
}();
var Jbig2Stream = function Jbig2StreamClosure() {
  function Jbig2Stream(stream, maybeLength, dict, params) {
    this.stream = stream;
    this.maybeLength = maybeLength;
    this.dict = dict;
    this.params = params;
    DecodeStream.call(this, maybeLength);
  }
  Jbig2Stream.prototype = Object.create(DecodeStream.prototype);
  Object.defineProperty(Jbig2Stream.prototype, 'bytes', {
    get: function Jbig2Stream_bytes() {
      return (0, _util.shadow)(this, 'bytes', this.stream.getBytes(this.maybeLength));
    },
    configurable: true
  });
  Jbig2Stream.prototype.ensureBuffer = function Jbig2Stream_ensureBuffer(req) {
    if (this.bufferLength) {
      return;
    }
    var jbig2Image = new _jbig.Jbig2Image();
    var chunks = [];
    if ((0, _primitives.isDict)(this.params)) {
      var globalsStream = this.params.get('JBIG2Globals');
      if ((0, _primitives.isStream)(globalsStream)) {
        var globals = globalsStream.getBytes();
        chunks.push({
          data: globals,
          start: 0,
          end: globals.length
        });
      }
    }
    chunks.push({
      data: this.bytes,
      start: 0,
      end: this.bytes.length
    });
    var data = jbig2Image.parseChunks(chunks);
    var dataLength = data.length;
    for (var i = 0; i < dataLength; i++) {
      data[i] ^= 0xFF;
    }
    this.buffer = data;
    this.bufferLength = dataLength;
    this.eof = true;
  };
  return Jbig2Stream;
}();
var DecryptStream = function DecryptStreamClosure() {
  function DecryptStream(str, maybeLength, decrypt) {
    this.str = str;
    this.dict = str.dict;
    this.decrypt = decrypt;
    this.nextChunk = null;
    this.initialized = false;
    DecodeStream.call(this, maybeLength);
  }
  var chunkSize = 512;
  DecryptStream.prototype = Object.create(DecodeStream.prototype);
  DecryptStream.prototype.readBlock = function DecryptStream_readBlock() {
    var chunk;
    if (this.initialized) {
      chunk = this.nextChunk;
    } else {
      chunk = this.str.getBytes(chunkSize);
      this.initialized = true;
    }
    if (!chunk || chunk.length === 0) {
      this.eof = true;
      return;
    }
    this.nextChunk = this.str.getBytes(chunkSize);
    var hasMoreData = this.nextChunk && this.nextChunk.length > 0;
    var decrypt = this.decrypt;
    chunk = decrypt(chunk, !hasMoreData);
    var bufferLength = this.bufferLength;
    var i,
        n = chunk.length;
    var buffer = this.ensureBuffer(bufferLength + n);
    for (i = 0; i < n; i++) {
      buffer[bufferLength++] = chunk[i];
    }
    this.bufferLength = bufferLength;
  };
  return DecryptStream;
}();
var Ascii85Stream = function Ascii85StreamClosure() {
  function Ascii85Stream(str, maybeLength) {
    this.str = str;
    this.dict = str.dict;
    this.input = new Uint8Array(5);
    if (maybeLength) {
      maybeLength = 0.8 * maybeLength;
    }
    DecodeStream.call(this, maybeLength);
  }
  Ascii85Stream.prototype = Object.create(DecodeStream.prototype);
  Ascii85Stream.prototype.readBlock = function Ascii85Stream_readBlock() {
    var TILDA_CHAR = 0x7E;
    var Z_LOWER_CHAR = 0x7A;
    var EOF = -1;
    var str = this.str;
    var c = str.getByte();
    while ((0, _util.isSpace)(c)) {
      c = str.getByte();
    }
    if (c === EOF || c === TILDA_CHAR) {
      this.eof = true;
      return;
    }
    var bufferLength = this.bufferLength,
        buffer;
    var i;
    if (c === Z_LOWER_CHAR) {
      buffer = this.ensureBuffer(bufferLength + 4);
      for (i = 0; i < 4; ++i) {
        buffer[bufferLength + i] = 0;
      }
      this.bufferLength += 4;
    } else {
      var input = this.input;
      input[0] = c;
      for (i = 1; i < 5; ++i) {
        c = str.getByte();
        while ((0, _util.isSpace)(c)) {
          c = str.getByte();
        }
        input[i] = c;
        if (c === EOF || c === TILDA_CHAR) {
          break;
        }
      }
      buffer = this.ensureBuffer(bufferLength + i - 1);
      this.bufferLength += i - 1;
      if (i < 5) {
        for (; i < 5; ++i) {
          input[i] = 0x21 + 84;
        }
        this.eof = true;
      }
      var t = 0;
      for (i = 0; i < 5; ++i) {
        t = t * 85 + (input[i] - 0x21);
      }
      for (i = 3; i >= 0; --i) {
        buffer[bufferLength + i] = t & 0xFF;
        t >>= 8;
      }
    }
  };
  return Ascii85Stream;
}();
var AsciiHexStream = function AsciiHexStreamClosure() {
  function AsciiHexStream(str, maybeLength) {
    this.str = str;
    this.dict = str.dict;
    this.firstDigit = -1;
    if (maybeLength) {
      maybeLength = 0.5 * maybeLength;
    }
    DecodeStream.call(this, maybeLength);
  }
  AsciiHexStream.prototype = Object.create(DecodeStream.prototype);
  AsciiHexStream.prototype.readBlock = function AsciiHexStream_readBlock() {
    var UPSTREAM_BLOCK_SIZE = 8000;
    var bytes = this.str.getBytes(UPSTREAM_BLOCK_SIZE);
    if (!bytes.length) {
      this.eof = true;
      return;
    }
    var maxDecodeLength = bytes.length + 1 >> 1;
    var buffer = this.ensureBuffer(this.bufferLength + maxDecodeLength);
    var bufferLength = this.bufferLength;
    var firstDigit = this.firstDigit;
    for (var i = 0, ii = bytes.length; i < ii; i++) {
      var ch = bytes[i],
          digit;
      if (ch >= 0x30 && ch <= 0x39) {
        digit = ch & 0x0F;
      } else if (ch >= 0x41 && ch <= 0x46 || ch >= 0x61 && ch <= 0x66) {
        digit = (ch & 0x0F) + 9;
      } else if (ch === 0x3E) {
        this.eof = true;
        break;
      } else {
        continue;
      }
      if (firstDigit < 0) {
        firstDigit = digit;
      } else {
        buffer[bufferLength++] = firstDigit << 4 | digit;
        firstDigit = -1;
      }
    }
    if (firstDigit >= 0 && this.eof) {
      buffer[bufferLength++] = firstDigit << 4;
      firstDigit = -1;
    }
    this.firstDigit = firstDigit;
    this.bufferLength = bufferLength;
  };
  return AsciiHexStream;
}();
var RunLengthStream = function RunLengthStreamClosure() {
  function RunLengthStream(str, maybeLength) {
    this.str = str;
    this.dict = str.dict;
    DecodeStream.call(this, maybeLength);
  }
  RunLengthStream.prototype = Object.create(DecodeStream.prototype);
  RunLengthStream.prototype.readBlock = function RunLengthStream_readBlock() {
    var repeatHeader = this.str.getBytes(2);
    if (!repeatHeader || repeatHeader.length < 2 || repeatHeader[0] === 128) {
      this.eof = true;
      return;
    }
    var buffer;
    var bufferLength = this.bufferLength;
    var n = repeatHeader[0];
    if (n < 128) {
      buffer = this.ensureBuffer(bufferLength + n + 1);
      buffer[bufferLength++] = repeatHeader[1];
      if (n > 0) {
        var source = this.str.getBytes(n);
        buffer.set(source, bufferLength);
        bufferLength += n;
      }
    } else {
      n = 257 - n;
      var b = repeatHeader[1];
      buffer = this.ensureBuffer(bufferLength + n + 1);
      for (var i = 0; i < n; i++) {
        buffer[bufferLength++] = b;
      }
    }
    this.bufferLength = bufferLength;
  };
  return RunLengthStream;
}();
var CCITTFaxStream = function CCITTFaxStreamClosure() {
  var ccittEOL = -2;
  var ccittEOF = -1;
  var twoDimPass = 0;
  var twoDimHoriz = 1;
  var twoDimVert0 = 2;
  var twoDimVertR1 = 3;
  var twoDimVertL1 = 4;
  var twoDimVertR2 = 5;
  var twoDimVertL2 = 6;
  var twoDimVertR3 = 7;
  var twoDimVertL3 = 8;
  var twoDimTable = [[-1, -1], [-1, -1], [7, twoDimVertL3], [7, twoDimVertR3], [6, twoDimVertL2], [6, twoDimVertL2], [6, twoDimVertR2], [6, twoDimVertR2], [4, twoDimPass], [4, twoDimPass], [4, twoDimPass], [4, twoDimPass], [4, twoDimPass], [4, twoDimPass], [4, twoDimPass], [4, twoDimPass], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimHoriz], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertL1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [3, twoDimVertR1], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0], [1, twoDimVert0]];
  var whiteTable1 = [[-1, -1], [12, ccittEOL], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [11, 1792], [11, 1792], [12, 1984], [12, 2048], [12, 2112], [12, 2176], [12, 2240], [12, 2304], [11, 1856], [11, 1856], [11, 1920], [11, 1920], [12, 2368], [12, 2432], [12, 2496], [12, 2560]];
  var whiteTable2 = [[-1, -1], [-1, -1], [-1, -1], [-1, -1], [8, 29], [8, 29], [8, 30], [8, 30], [8, 45], [8, 45], [8, 46], [8, 46], [7, 22], [7, 22], [7, 22], [7, 22], [7, 23], [7, 23], [7, 23], [7, 23], [8, 47], [8, 47], [8, 48], [8, 48], [6, 13], [6, 13], [6, 13], [6, 13], [6, 13], [6, 13], [6, 13], [6, 13], [7, 20], [7, 20], [7, 20], [7, 20], [8, 33], [8, 33], [8, 34], [8, 34], [8, 35], [8, 35], [8, 36], [8, 36], [8, 37], [8, 37], [8, 38], [8, 38], [7, 19], [7, 19], [7, 19], [7, 19], [8, 31], [8, 31], [8, 32], [8, 32], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 12], [6, 12], [6, 12], [6, 12], [6, 12], [6, 12], [6, 12], [6, 12], [8, 53], [8, 53], [8, 54], [8, 54], [7, 26], [7, 26], [7, 26], [7, 26], [8, 39], [8, 39], [8, 40], [8, 40], [8, 41], [8, 41], [8, 42], [8, 42], [8, 43], [8, 43], [8, 44], [8, 44], [7, 21], [7, 21], [7, 21], [7, 21], [7, 28], [7, 28], [7, 28], [7, 28], [8, 61], [8, 61], [8, 62], [8, 62], [8, 63], [8, 63], [8, 0], [8, 0], [8, 320], [8, 320], [8, 384], [8, 384], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [7, 27], [7, 27], [7, 27], [7, 27], [8, 59], [8, 59], [8, 60], [8, 60], [9, 1472], [9, 1536], [9, 1600], [9, 1728], [7, 18], [7, 18], [7, 18], [7, 18], [7, 24], [7, 24], [7, 24], [7, 24], [8, 49], [8, 49], [8, 50], [8, 50], [8, 51], [8, 51], [8, 52], [8, 52], [7, 25], [7, 25], [7, 25], [7, 25], [8, 55], [8, 55], [8, 56], [8, 56], [8, 57], [8, 57], [8, 58], [8, 58], [6, 192], [6, 192], [6, 192], [6, 192], [6, 192], [6, 192], [6, 192], [6, 192], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [8, 448], [8, 448], [8, 512], [8, 512], [9, 704], [9, 768], [8, 640], [8, 640], [8, 576], [8, 576], [9, 832], [9, 896], [9, 960], [9, 1024], [9, 1088], [9, 1152], [9, 1216], [9, 1280], [9, 1344], [9, 1408], [7, 256], [7, 256], [7, 256], [7, 256], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [6, 16], [6, 16], [6, 16], [6, 16], [6, 16], [6, 16], [6, 16], [6, 16], [6, 17], [6, 17], [6, 17], [6, 17], [6, 17], [6, 17], [6, 17], [6, 17], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [6, 14], [6, 14], [6, 14], [6, 14], [6, 14], [6, 14], [6, 14], [6, 14], [6, 15], [6, 15], [6, 15], [6, 15], [6, 15], [6, 15], [6, 15], [6, 15], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7]];
  var blackTable1 = [[-1, -1], [-1, -1], [12, ccittEOL], [12, ccittEOL], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [11, 1792], [11, 1792], [11, 1792], [11, 1792], [12, 1984], [12, 1984], [12, 2048], [12, 2048], [12, 2112], [12, 2112], [12, 2176], [12, 2176], [12, 2240], [12, 2240], [12, 2304], [12, 2304], [11, 1856], [11, 1856], [11, 1856], [11, 1856], [11, 1920], [11, 1920], [11, 1920], [11, 1920], [12, 2368], [12, 2368], [12, 2432], [12, 2432], [12, 2496], [12, 2496], [12, 2560], [12, 2560], [10, 18], [10, 18], [10, 18], [10, 18], [10, 18], [10, 18], [10, 18], [10, 18], [12, 52], [12, 52], [13, 640], [13, 704], [13, 768], [13, 832], [12, 55], [12, 55], [12, 56], [12, 56], [13, 1280], [13, 1344], [13, 1408], [13, 1472], [12, 59], [12, 59], [12, 60], [12, 60], [13, 1536], [13, 1600], [11, 24], [11, 24], [11, 24], [11, 24], [11, 25], [11, 25], [11, 25], [11, 25], [13, 1664], [13, 1728], [12, 320], [12, 320], [12, 384], [12, 384], [12, 448], [12, 448], [13, 512], [13, 576], [12, 53], [12, 53], [12, 54], [12, 54], [13, 896], [13, 960], [13, 1024], [13, 1088], [13, 1152], [13, 1216], [10, 64], [10, 64], [10, 64], [10, 64], [10, 64], [10, 64], [10, 64], [10, 64]];
  var blackTable2 = [[8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [11, 23], [11, 23], [12, 50], [12, 51], [12, 44], [12, 45], [12, 46], [12, 47], [12, 57], [12, 58], [12, 61], [12, 256], [10, 16], [10, 16], [10, 16], [10, 16], [10, 17], [10, 17], [10, 17], [10, 17], [12, 48], [12, 49], [12, 62], [12, 63], [12, 30], [12, 31], [12, 32], [12, 33], [12, 40], [12, 41], [11, 22], [11, 22], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [9, 15], [9, 15], [9, 15], [9, 15], [9, 15], [9, 15], [9, 15], [9, 15], [12, 128], [12, 192], [12, 26], [12, 27], [12, 28], [12, 29], [11, 19], [11, 19], [11, 20], [11, 20], [12, 34], [12, 35], [12, 36], [12, 37], [12, 38], [12, 39], [11, 21], [11, 21], [12, 42], [12, 43], [10, 0], [10, 0], [10, 0], [10, 0], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12]];
  var blackTable3 = [[-1, -1], [-1, -1], [-1, -1], [-1, -1], [6, 9], [6, 8], [5, 7], [5, 7], [4, 6], [4, 6], [4, 6], [4, 6], [4, 5], [4, 5], [4, 5], [4, 5], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2]];
  function CCITTFaxStream(str, maybeLength, params) {
    this.str = str;
    this.dict = str.dict;
    params = params || _primitives.Dict.empty;
    this.encoding = params.get('K') || 0;
    this.eoline = params.get('EndOfLine') || false;
    this.byteAlign = params.get('EncodedByteAlign') || false;
    this.columns = params.get('Columns') || 1728;
    this.rows = params.get('Rows') || 0;
    var eoblock = params.get('EndOfBlock');
    if (eoblock === null || eoblock === undefined) {
      eoblock = true;
    }
    this.eoblock = eoblock;
    this.black = params.get('BlackIs1') || false;
    this.codingLine = new Uint32Array(this.columns + 1);
    this.refLine = new Uint32Array(this.columns + 2);
    this.codingLine[0] = this.columns;
    this.codingPos = 0;
    this.row = 0;
    this.nextLine2D = this.encoding < 0;
    this.inputBits = 0;
    this.inputBuf = 0;
    this.outputBits = 0;
    var code1;
    while ((code1 = this.lookBits(12)) === 0) {
      this.eatBits(1);
    }
    if (code1 === 1) {
      this.eatBits(12);
    }
    if (this.encoding > 0) {
      this.nextLine2D = !this.lookBits(1);
      this.eatBits(1);
    }
    DecodeStream.call(this, maybeLength);
  }
  CCITTFaxStream.prototype = Object.create(DecodeStream.prototype);
  CCITTFaxStream.prototype.readBlock = function CCITTFaxStream_readBlock() {
    while (!this.eof) {
      var c = this.lookChar();
      this.ensureBuffer(this.bufferLength + 1);
      this.buffer[this.bufferLength++] = c;
    }
  };
  CCITTFaxStream.prototype.addPixels = function ccittFaxStreamAddPixels(a1, blackPixels) {
    var codingLine = this.codingLine;
    var codingPos = this.codingPos;
    if (a1 > codingLine[codingPos]) {
      if (a1 > this.columns) {
        (0, _util.info)('row is wrong length');
        this.err = true;
        a1 = this.columns;
      }
      if (codingPos & 1 ^ blackPixels) {
        ++codingPos;
      }
      codingLine[codingPos] = a1;
    }
    this.codingPos = codingPos;
  };
  CCITTFaxStream.prototype.addPixelsNeg = function ccittFaxStreamAddPixelsNeg(a1, blackPixels) {
    var codingLine = this.codingLine;
    var codingPos = this.codingPos;
    if (a1 > codingLine[codingPos]) {
      if (a1 > this.columns) {
        (0, _util.info)('row is wrong length');
        this.err = true;
        a1 = this.columns;
      }
      if (codingPos & 1 ^ blackPixels) {
        ++codingPos;
      }
      codingLine[codingPos] = a1;
    } else if (a1 < codingLine[codingPos]) {
      if (a1 < 0) {
        (0, _util.info)('invalid code');
        this.err = true;
        a1 = 0;
      }
      while (codingPos > 0 && a1 < codingLine[codingPos - 1]) {
        --codingPos;
      }
      codingLine[codingPos] = a1;
    }
    this.codingPos = codingPos;
  };
  CCITTFaxStream.prototype.lookChar = function CCITTFaxStream_lookChar() {
    var refLine = this.refLine;
    var codingLine = this.codingLine;
    var columns = this.columns;
    var refPos, blackPixels, bits, i;
    if (this.outputBits === 0) {
      if (this.eof) {
        return null;
      }
      this.err = false;
      var code1, code2, code3;
      if (this.nextLine2D) {
        for (i = 0; codingLine[i] < columns; ++i) {
          refLine[i] = codingLine[i];
        }
        refLine[i++] = columns;
        refLine[i] = columns;
        codingLine[0] = 0;
        this.codingPos = 0;
        refPos = 0;
        blackPixels = 0;
        while (codingLine[this.codingPos] < columns) {
          code1 = this.getTwoDimCode();
          switch (code1) {
            case twoDimPass:
              this.addPixels(refLine[refPos + 1], blackPixels);
              if (refLine[refPos + 1] < columns) {
                refPos += 2;
              }
              break;
            case twoDimHoriz:
              code1 = code2 = 0;
              if (blackPixels) {
                do {
                  code1 += code3 = this.getBlackCode();
                } while (code3 >= 64);
                do {
                  code2 += code3 = this.getWhiteCode();
                } while (code3 >= 64);
              } else {
                do {
                  code1 += code3 = this.getWhiteCode();
                } while (code3 >= 64);
                do {
                  code2 += code3 = this.getBlackCode();
                } while (code3 >= 64);
              }
              this.addPixels(codingLine[this.codingPos] + code1, blackPixels);
              if (codingLine[this.codingPos] < columns) {
                this.addPixels(codingLine[this.codingPos] + code2, blackPixels ^ 1);
              }
              while (refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns) {
                refPos += 2;
              }
              break;
            case twoDimVertR3:
              this.addPixels(refLine[refPos] + 3, blackPixels);
              blackPixels ^= 1;
              if (codingLine[this.codingPos] < columns) {
                ++refPos;
                while (refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns) {
                  refPos += 2;
                }
              }
              break;
            case twoDimVertR2:
              this.addPixels(refLine[refPos] + 2, blackPixels);
              blackPixels ^= 1;
              if (codingLine[this.codingPos] < columns) {
                ++refPos;
                while (refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns) {
                  refPos += 2;
                }
              }
              break;
            case twoDimVertR1:
              this.addPixels(refLine[refPos] + 1, blackPixels);
              blackPixels ^= 1;
              if (codingLine[this.codingPos] < columns) {
                ++refPos;
                while (refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns) {
                  refPos += 2;
                }
              }
              break;
            case twoDimVert0:
              this.addPixels(refLine[refPos], blackPixels);
              blackPixels ^= 1;
              if (codingLine[this.codingPos] < columns) {
                ++refPos;
                while (refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns) {
                  refPos += 2;
                }
              }
              break;
            case twoDimVertL3:
              this.addPixelsNeg(refLine[refPos] - 3, blackPixels);
              blackPixels ^= 1;
              if (codingLine[this.codingPos] < columns) {
                if (refPos > 0) {
                  --refPos;
                } else {
                  ++refPos;
                }
                while (refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns) {
                  refPos += 2;
                }
              }
              break;
            case twoDimVertL2:
              this.addPixelsNeg(refLine[refPos] - 2, blackPixels);
              blackPixels ^= 1;
              if (codingLine[this.codingPos] < columns) {
                if (refPos > 0) {
                  --refPos;
                } else {
                  ++refPos;
                }
                while (refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns) {
                  refPos += 2;
                }
              }
              break;
            case twoDimVertL1:
              this.addPixelsNeg(refLine[refPos] - 1, blackPixels);
              blackPixels ^= 1;
              if (codingLine[this.codingPos] < columns) {
                if (refPos > 0) {
                  --refPos;
                } else {
                  ++refPos;
                }
                while (refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns) {
                  refPos += 2;
                }
              }
              break;
            case ccittEOF:
              this.addPixels(columns, 0);
              this.eof = true;
              break;
            default:
              (0, _util.info)('bad 2d code');
              this.addPixels(columns, 0);
              this.err = true;
          }
        }
      } else {
        codingLine[0] = 0;
        this.codingPos = 0;
        blackPixels = 0;
        while (codingLine[this.codingPos] < columns) {
          code1 = 0;
          if (blackPixels) {
            do {
              code1 += code3 = this.getBlackCode();
            } while (code3 >= 64);
          } else {
            do {
              code1 += code3 = this.getWhiteCode();
            } while (code3 >= 64);
          }
          this.addPixels(codingLine[this.codingPos] + code1, blackPixels);
          blackPixels ^= 1;
        }
      }
      var gotEOL = false;
      if (this.byteAlign) {
        this.inputBits &= ~7;
      }
      if (!this.eoblock && this.row === this.rows - 1) {
        this.eof = true;
      } else {
        code1 = this.lookBits(12);
        if (this.eoline) {
          while (code1 !== ccittEOF && code1 !== 1) {
            this.eatBits(1);
            code1 = this.lookBits(12);
          }
        } else {
          while (code1 === 0) {
            this.eatBits(1);
            code1 = this.lookBits(12);
          }
        }
        if (code1 === 1) {
          this.eatBits(12);
          gotEOL = true;
        } else if (code1 === ccittEOF) {
          this.eof = true;
        }
      }
      if (!this.eof && this.encoding > 0) {
        this.nextLine2D = !this.lookBits(1);
        this.eatBits(1);
      }
      if (this.eoblock && gotEOL && this.byteAlign) {
        code1 = this.lookBits(12);
        if (code1 === 1) {
          this.eatBits(12);
          if (this.encoding > 0) {
            this.lookBits(1);
            this.eatBits(1);
          }
          if (this.encoding >= 0) {
            for (i = 0; i < 4; ++i) {
              code1 = this.lookBits(12);
              if (code1 !== 1) {
                (0, _util.info)('bad rtc code: ' + code1);
              }
              this.eatBits(12);
              if (this.encoding > 0) {
                this.lookBits(1);
                this.eatBits(1);
              }
            }
          }
          this.eof = true;
        }
      } else if (this.err && this.eoline) {
        while (true) {
          code1 = this.lookBits(13);
          if (code1 === ccittEOF) {
            this.eof = true;
            return null;
          }
          if (code1 >> 1 === 1) {
            break;
          }
          this.eatBits(1);
        }
        this.eatBits(12);
        if (this.encoding > 0) {
          this.eatBits(1);
          this.nextLine2D = !(code1 & 1);
        }
      }
      if (codingLine[0] > 0) {
        this.outputBits = codingLine[this.codingPos = 0];
      } else {
        this.outputBits = codingLine[this.codingPos = 1];
      }
      this.row++;
    }
    var c;
    if (this.outputBits >= 8) {
      c = this.codingPos & 1 ? 0 : 0xFF;
      this.outputBits -= 8;
      if (this.outputBits === 0 && codingLine[this.codingPos] < columns) {
        this.codingPos++;
        this.outputBits = codingLine[this.codingPos] - codingLine[this.codingPos - 1];
      }
    } else {
      bits = 8;
      c = 0;
      do {
        if (this.outputBits > bits) {
          c <<= bits;
          if (!(this.codingPos & 1)) {
            c |= 0xFF >> 8 - bits;
          }
          this.outputBits -= bits;
          bits = 0;
        } else {
          c <<= this.outputBits;
          if (!(this.codingPos & 1)) {
            c |= 0xFF >> 8 - this.outputBits;
          }
          bits -= this.outputBits;
          this.outputBits = 0;
          if (codingLine[this.codingPos] < columns) {
            this.codingPos++;
            this.outputBits = codingLine[this.codingPos] - codingLine[this.codingPos - 1];
          } else if (bits > 0) {
            c <<= bits;
            bits = 0;
          }
        }
      } while (bits);
    }
    if (this.black) {
      c ^= 0xFF;
    }
    return c;
  };
  CCITTFaxStream.prototype.findTableCode = function ccittFaxStreamFindTableCode(start, end, table, limit) {
    var limitValue = limit || 0;
    for (var i = start; i <= end; ++i) {
      var code = this.lookBits(i);
      if (code === ccittEOF) {
        return [true, 1, false];
      }
      if (i < end) {
        code <<= end - i;
      }
      if (!limitValue || code >= limitValue) {
        var p = table[code - limitValue];
        if (p[0] === i) {
          this.eatBits(i);
          return [true, p[1], true];
        }
      }
    }
    return [false, 0, false];
  };
  CCITTFaxStream.prototype.getTwoDimCode = function ccittFaxStreamGetTwoDimCode() {
    var code = 0;
    var p;
    if (this.eoblock) {
      code = this.lookBits(7);
      p = twoDimTable[code];
      if (p && p[0] > 0) {
        this.eatBits(p[0]);
        return p[1];
      }
    } else {
      var result = this.findTableCode(1, 7, twoDimTable);
      if (result[0] && result[2]) {
        return result[1];
      }
    }
    (0, _util.info)('Bad two dim code');
    return ccittEOF;
  };
  CCITTFaxStream.prototype.getWhiteCode = function ccittFaxStreamGetWhiteCode() {
    var code = 0;
    var p;
    if (this.eoblock) {
      code = this.lookBits(12);
      if (code === ccittEOF) {
        return 1;
      }
      if (code >> 5 === 0) {
        p = whiteTable1[code];
      } else {
        p = whiteTable2[code >> 3];
      }
      if (p[0] > 0) {
        this.eatBits(p[0]);
        return p[1];
      }
    } else {
      var result = this.findTableCode(1, 9, whiteTable2);
      if (result[0]) {
        return result[1];
      }
      result = this.findTableCode(11, 12, whiteTable1);
      if (result[0]) {
        return result[1];
      }
    }
    (0, _util.info)('bad white code');
    this.eatBits(1);
    return 1;
  };
  CCITTFaxStream.prototype.getBlackCode = function ccittFaxStreamGetBlackCode() {
    var code, p;
    if (this.eoblock) {
      code = this.lookBits(13);
      if (code === ccittEOF) {
        return 1;
      }
      if (code >> 7 === 0) {
        p = blackTable1[code];
      } else if (code >> 9 === 0 && code >> 7 !== 0) {
        p = blackTable2[(code >> 1) - 64];
      } else {
        p = blackTable3[code >> 7];
      }
      if (p[0] > 0) {
        this.eatBits(p[0]);
        return p[1];
      }
    } else {
      var result = this.findTableCode(2, 6, blackTable3);
      if (result[0]) {
        return result[1];
      }
      result = this.findTableCode(7, 12, blackTable2, 64);
      if (result[0]) {
        return result[1];
      }
      result = this.findTableCode(10, 13, blackTable1);
      if (result[0]) {
        return result[1];
      }
    }
    (0, _util.info)('bad black code');
    this.eatBits(1);
    return 1;
  };
  CCITTFaxStream.prototype.lookBits = function CCITTFaxStream_lookBits(n) {
    var c;
    while (this.inputBits < n) {
      if ((c = this.str.getByte()) === -1) {
        if (this.inputBits === 0) {
          return ccittEOF;
        }
        return this.inputBuf << n - this.inputBits & 0xFFFF >> 16 - n;
      }
      this.inputBuf = this.inputBuf << 8 | c;
      this.inputBits += 8;
    }
    return this.inputBuf >> this.inputBits - n & 0xFFFF >> 16 - n;
  };
  CCITTFaxStream.prototype.eatBits = function CCITTFaxStream_eatBits(n) {
    if ((this.inputBits -= n) < 0) {
      this.inputBits = 0;
    }
  };
  return CCITTFaxStream;
}();
var LZWStream = function LZWStreamClosure() {
  function LZWStream(str, maybeLength, earlyChange) {
    this.str = str;
    this.dict = str.dict;
    this.cachedData = 0;
    this.bitsCached = 0;
    var maxLzwDictionarySize = 4096;
    var lzwState = {
      earlyChange: earlyChange,
      codeLength: 9,
      nextCode: 258,
      dictionaryValues: new Uint8Array(maxLzwDictionarySize),
      dictionaryLengths: new Uint16Array(maxLzwDictionarySize),
      dictionaryPrevCodes: new Uint16Array(maxLzwDictionarySize),
      currentSequence: new Uint8Array(maxLzwDictionarySize),
      currentSequenceLength: 0
    };
    for (var i = 0; i < 256; ++i) {
      lzwState.dictionaryValues[i] = i;
      lzwState.dictionaryLengths[i] = 1;
    }
    this.lzwState = lzwState;
    DecodeStream.call(this, maybeLength);
  }
  LZWStream.prototype = Object.create(DecodeStream.prototype);
  LZWStream.prototype.readBits = function LZWStream_readBits(n) {
    var bitsCached = this.bitsCached;
    var cachedData = this.cachedData;
    while (bitsCached < n) {
      var c = this.str.getByte();
      if (c === -1) {
        this.eof = true;
        return null;
      }
      cachedData = cachedData << 8 | c;
      bitsCached += 8;
    }
    this.bitsCached = bitsCached -= n;
    this.cachedData = cachedData;
    this.lastCode = null;
    return cachedData >>> bitsCached & (1 << n) - 1;
  };
  LZWStream.prototype.readBlock = function LZWStream_readBlock() {
    var blockSize = 512;
    var estimatedDecodedSize = blockSize * 2,
        decodedSizeDelta = blockSize;
    var i, j, q;
    var lzwState = this.lzwState;
    if (!lzwState) {
      return;
    }
    var earlyChange = lzwState.earlyChange;
    var nextCode = lzwState.nextCode;
    var dictionaryValues = lzwState.dictionaryValues;
    var dictionaryLengths = lzwState.dictionaryLengths;
    var dictionaryPrevCodes = lzwState.dictionaryPrevCodes;
    var codeLength = lzwState.codeLength;
    var prevCode = lzwState.prevCode;
    var currentSequence = lzwState.currentSequence;
    var currentSequenceLength = lzwState.currentSequenceLength;
    var decodedLength = 0;
    var currentBufferLength = this.bufferLength;
    var buffer = this.ensureBuffer(this.bufferLength + estimatedDecodedSize);
    for (i = 0; i < blockSize; i++) {
      var code = this.readBits(codeLength);
      var hasPrev = currentSequenceLength > 0;
      if (code < 256) {
        currentSequence[0] = code;
        currentSequenceLength = 1;
      } else if (code >= 258) {
        if (code < nextCode) {
          currentSequenceLength = dictionaryLengths[code];
          for (j = currentSequenceLength - 1, q = code; j >= 0; j--) {
            currentSequence[j] = dictionaryValues[q];
            q = dictionaryPrevCodes[q];
          }
        } else {
          currentSequence[currentSequenceLength++] = currentSequence[0];
        }
      } else if (code === 256) {
        codeLength = 9;
        nextCode = 258;
        currentSequenceLength = 0;
        continue;
      } else {
        this.eof = true;
        delete this.lzwState;
        break;
      }
      if (hasPrev) {
        dictionaryPrevCodes[nextCode] = prevCode;
        dictionaryLengths[nextCode] = dictionaryLengths[prevCode] + 1;
        dictionaryValues[nextCode] = currentSequence[0];
        nextCode++;
        codeLength = nextCode + earlyChange & nextCode + earlyChange - 1 ? codeLength : Math.min(Math.log(nextCode + earlyChange) / 0.6931471805599453 + 1, 12) | 0;
      }
      prevCode = code;
      decodedLength += currentSequenceLength;
      if (estimatedDecodedSize < decodedLength) {
        do {
          estimatedDecodedSize += decodedSizeDelta;
        } while (estimatedDecodedSize < decodedLength);
        buffer = this.ensureBuffer(this.bufferLength + estimatedDecodedSize);
      }
      for (j = 0; j < currentSequenceLength; j++) {
        buffer[currentBufferLength++] = currentSequence[j];
      }
    }
    lzwState.nextCode = nextCode;
    lzwState.codeLength = codeLength;
    lzwState.prevCode = prevCode;
    lzwState.currentSequenceLength = currentSequenceLength;
    this.bufferLength = currentBufferLength;
  };
  return LZWStream;
}();
var NullStream = function NullStreamClosure() {
  function NullStream() {
    Stream.call(this, new Uint8Array(0));
  }
  NullStream.prototype = Stream.prototype;
  return NullStream;
}();
exports.Ascii85Stream = Ascii85Stream;
exports.AsciiHexStream = AsciiHexStream;
exports.CCITTFaxStream = CCITTFaxStream;
exports.DecryptStream = DecryptStream;
exports.DecodeStream = DecodeStream;
exports.FlateStream = FlateStream;
exports.Jbig2Stream = Jbig2Stream;
exports.JpegStream = JpegStream;
exports.JpxStream = JpxStream;
exports.NullStream = NullStream;
exports.PredictorStream = PredictorStream;
exports.RunLengthStream = RunLengthStream;
exports.Stream = Stream;
exports.StreamsSequenceStream = StreamsSequenceStream;
exports.StringStream = StringStream;
exports.LZWStream = LZWStream;

/***/ }),
/* 3 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColorSpace = undefined;

var _util = __w_pdfjs_require__(0);

var _primitives = __w_pdfjs_require__(1);

var _function = __w_pdfjs_require__(6);

var ColorSpace = function ColorSpaceClosure() {
  function resizeRgbImage(src, bpc, w1, h1, w2, h2, alpha01, dest) {
    var COMPONENTS = 3;
    alpha01 = alpha01 !== 1 ? 0 : alpha01;
    var xRatio = w1 / w2;
    var yRatio = h1 / h2;
    var i,
        j,
        py,
        newIndex = 0,
        oldIndex;
    var xScaled = new Uint16Array(w2);
    var w1Scanline = w1 * COMPONENTS;
    for (i = 0; i < w2; i++) {
      xScaled[i] = Math.floor(i * xRatio) * COMPONENTS;
    }
    for (i = 0; i < h2; i++) {
      py = Math.floor(i * yRatio) * w1Scanline;
      for (j = 0; j < w2; j++) {
        oldIndex = py + xScaled[j];
        dest[newIndex++] = src[oldIndex++];
        dest[newIndex++] = src[oldIndex++];
        dest[newIndex++] = src[oldIndex++];
        newIndex += alpha01;
      }
    }
  }
  function ColorSpace() {
    throw new Error('should not call ColorSpace constructor');
  }
  ColorSpace.prototype = {
    getRgb: function ColorSpace_getRgb(src, srcOffset) {
      var rgb = new Uint8Array(3);
      this.getRgbItem(src, srcOffset, rgb, 0);
      return rgb;
    },
    getRgbItem: function ColorSpace_getRgbItem(src, srcOffset, dest, destOffset) {
      throw new Error('Should not call ColorSpace.getRgbItem');
    },
    getRgbBuffer: function ColorSpace_getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
      throw new Error('Should not call ColorSpace.getRgbBuffer');
    },
    getOutputLength: function ColorSpace_getOutputLength(inputLength, alpha01) {
      throw new Error('Should not call ColorSpace.getOutputLength');
    },
    isPassthrough: function ColorSpace_isPassthrough(bits) {
      return false;
    },
    fillRgb: function ColorSpace_fillRgb(dest, originalWidth, originalHeight, width, height, actualHeight, bpc, comps, alpha01) {
      var count = originalWidth * originalHeight;
      var rgbBuf = null;
      var numComponentColors = 1 << bpc;
      var needsResizing = originalHeight !== height || originalWidth !== width;
      var i, ii;
      if (this.isPassthrough(bpc)) {
        rgbBuf = comps;
      } else if (this.numComps === 1 && count > numComponentColors && this.name !== 'DeviceGray' && this.name !== 'DeviceRGB') {
        var allColors = bpc <= 8 ? new Uint8Array(numComponentColors) : new Uint16Array(numComponentColors);
        var key;
        for (i = 0; i < numComponentColors; i++) {
          allColors[i] = i;
        }
        var colorMap = new Uint8Array(numComponentColors * 3);
        this.getRgbBuffer(allColors, 0, numComponentColors, colorMap, 0, bpc, 0);
        var destPos, rgbPos;
        if (!needsResizing) {
          destPos = 0;
          for (i = 0; i < count; ++i) {
            key = comps[i] * 3;
            dest[destPos++] = colorMap[key];
            dest[destPos++] = colorMap[key + 1];
            dest[destPos++] = colorMap[key + 2];
            destPos += alpha01;
          }
        } else {
          rgbBuf = new Uint8Array(count * 3);
          rgbPos = 0;
          for (i = 0; i < count; ++i) {
            key = comps[i] * 3;
            rgbBuf[rgbPos++] = colorMap[key];
            rgbBuf[rgbPos++] = colorMap[key + 1];
            rgbBuf[rgbPos++] = colorMap[key + 2];
          }
        }
      } else {
        if (!needsResizing) {
          this.getRgbBuffer(comps, 0, width * actualHeight, dest, 0, bpc, alpha01);
        } else {
          rgbBuf = new Uint8Array(count * 3);
          this.getRgbBuffer(comps, 0, count, rgbBuf, 0, bpc, 0);
        }
      }
      if (rgbBuf) {
        if (needsResizing) {
          resizeRgbImage(rgbBuf, bpc, originalWidth, originalHeight, width, height, alpha01, dest);
        } else {
          rgbPos = 0;
          destPos = 0;
          for (i = 0, ii = width * actualHeight; i < ii; i++) {
            dest[destPos++] = rgbBuf[rgbPos++];
            dest[destPos++] = rgbBuf[rgbPos++];
            dest[destPos++] = rgbBuf[rgbPos++];
            destPos += alpha01;
          }
        }
      }
    },
    usesZeroToOneRange: true
  };
  ColorSpace.parse = function ColorSpace_parse(cs, xref, res) {
    var IR = ColorSpace.parseToIR(cs, xref, res);
    if (IR instanceof AlternateCS) {
      return IR;
    }
    return ColorSpace.fromIR(IR);
  };
  ColorSpace.fromIR = function ColorSpace_fromIR(IR) {
    var name = (0, _util.isArray)(IR) ? IR[0] : IR;
    var whitePoint, blackPoint, gamma;
    switch (name) {
      case 'DeviceGrayCS':
        return this.singletons.gray;
      case 'DeviceRgbCS':
        return this.singletons.rgb;
      case 'DeviceCmykCS':
        return this.singletons.cmyk;
      case 'CalGrayCS':
        whitePoint = IR[1];
        blackPoint = IR[2];
        gamma = IR[3];
        return new CalGrayCS(whitePoint, blackPoint, gamma);
      case 'CalRGBCS':
        whitePoint = IR[1];
        blackPoint = IR[2];
        gamma = IR[3];
        var matrix = IR[4];
        return new CalRGBCS(whitePoint, blackPoint, gamma, matrix);
      case 'PatternCS':
        var basePatternCS = IR[1];
        if (basePatternCS) {
          basePatternCS = ColorSpace.fromIR(basePatternCS);
        }
        return new PatternCS(basePatternCS);
      case 'IndexedCS':
        var baseIndexedCS = IR[1];
        var hiVal = IR[2];
        var lookup = IR[3];
        return new IndexedCS(ColorSpace.fromIR(baseIndexedCS), hiVal, lookup);
      case 'AlternateCS':
        var numComps = IR[1];
        var alt = IR[2];
        var tintFnIR = IR[3];
        return new AlternateCS(numComps, ColorSpace.fromIR(alt), _function.PDFFunction.fromIR(tintFnIR));
      case 'LabCS':
        whitePoint = IR[1];
        blackPoint = IR[2];
        var range = IR[3];
        return new LabCS(whitePoint, blackPoint, range);
      default:
        throw new _util.FormatError('Unknown colorspace name: ' + name);
    }
  };
  ColorSpace.parseToIR = function ColorSpace_parseToIR(cs, xref, res) {
    if ((0, _primitives.isName)(cs)) {
      var colorSpaces = res.get('ColorSpace');
      if ((0, _primitives.isDict)(colorSpaces)) {
        var refcs = colorSpaces.get(cs.name);
        if (refcs) {
          cs = refcs;
        }
      }
    }
    cs = xref.fetchIfRef(cs);
    if ((0, _primitives.isName)(cs)) {
      switch (cs.name) {
        case 'DeviceGray':
        case 'G':
          return 'DeviceGrayCS';
        case 'DeviceRGB':
        case 'RGB':
          return 'DeviceRgbCS';
        case 'DeviceCMYK':
        case 'CMYK':
          return 'DeviceCmykCS';
        case 'Pattern':
          return ['PatternCS', null];
        default:
          throw new _util.FormatError('unrecognized colorspace ' + cs.name);
      }
    }
    if ((0, _util.isArray)(cs)) {
      var mode = xref.fetchIfRef(cs[0]).name;
      var numComps, params, alt, whitePoint, blackPoint, gamma;
      switch (mode) {
        case 'DeviceGray':
        case 'G':
          return 'DeviceGrayCS';
        case 'DeviceRGB':
        case 'RGB':
          return 'DeviceRgbCS';
        case 'DeviceCMYK':
        case 'CMYK':
          return 'DeviceCmykCS';
        case 'CalGray':
          params = xref.fetchIfRef(cs[1]);
          whitePoint = params.getArray('WhitePoint');
          blackPoint = params.getArray('BlackPoint');
          gamma = params.get('Gamma');
          return ['CalGrayCS', whitePoint, blackPoint, gamma];
        case 'CalRGB':
          params = xref.fetchIfRef(cs[1]);
          whitePoint = params.getArray('WhitePoint');
          blackPoint = params.getArray('BlackPoint');
          gamma = params.getArray('Gamma');
          var matrix = params.getArray('Matrix');
          return ['CalRGBCS', whitePoint, blackPoint, gamma, matrix];
        case 'ICCBased':
          var stream = xref.fetchIfRef(cs[1]);
          var dict = stream.dict;
          numComps = dict.get('N');
          alt = dict.get('Alternate');
          if (alt) {
            var altIR = ColorSpace.parseToIR(alt, xref, res);
            var altCS = ColorSpace.fromIR(altIR);
            if (altCS.numComps === numComps) {
              return altIR;
            }
            (0, _util.warn)('ICCBased color space: Ignoring incorrect /Alternate entry.');
          }
          if (numComps === 1) {
            return 'DeviceGrayCS';
          } else if (numComps === 3) {
            return 'DeviceRgbCS';
          } else if (numComps === 4) {
            return 'DeviceCmykCS';
          }
          break;
        case 'Pattern':
          var basePatternCS = cs[1] || null;
          if (basePatternCS) {
            basePatternCS = ColorSpace.parseToIR(basePatternCS, xref, res);
          }
          return ['PatternCS', basePatternCS];
        case 'Indexed':
        case 'I':
          var baseIndexedCS = ColorSpace.parseToIR(cs[1], xref, res);
          var hiVal = xref.fetchIfRef(cs[2]) + 1;
          var lookup = xref.fetchIfRef(cs[3]);
          if ((0, _primitives.isStream)(lookup)) {
            lookup = lookup.getBytes();
          }
          return ['IndexedCS', baseIndexedCS, hiVal, lookup];
        case 'Separation':
        case 'DeviceN':
          var name = xref.fetchIfRef(cs[1]);
          numComps = (0, _util.isArray)(name) ? name.length : 1;
          alt = ColorSpace.parseToIR(cs[2], xref, res);
          var tintFnIR = _function.PDFFunction.getIR(xref, xref.fetchIfRef(cs[3]));
          return ['AlternateCS', numComps, alt, tintFnIR];
        case 'Lab':
          params = xref.fetchIfRef(cs[1]);
          whitePoint = params.getArray('WhitePoint');
          blackPoint = params.getArray('BlackPoint');
          var range = params.getArray('Range');
          return ['LabCS', whitePoint, blackPoint, range];
        default:
          throw new _util.FormatError('unimplemented color space object "' + mode + '"');
      }
    }
    throw new _util.FormatError('unrecognized color space object: "' + cs + '"');
  };
  ColorSpace.isDefaultDecode = function ColorSpace_isDefaultDecode(decode, n) {
    if (!(0, _util.isArray)(decode)) {
      return true;
    }
    if (n * 2 !== decode.length) {
      (0, _util.warn)('The decode map is not the correct length');
      return true;
    }
    for (var i = 0, ii = decode.length; i < ii; i += 2) {
      if (decode[i] !== 0 || decode[i + 1] !== 1) {
        return false;
      }
    }
    return true;
  };
  ColorSpace.singletons = {
    get gray() {
      return (0, _util.shadow)(this, 'gray', new DeviceGrayCS());
    },
    get rgb() {
      return (0, _util.shadow)(this, 'rgb', new DeviceRgbCS());
    },
    get cmyk() {
      return (0, _util.shadow)(this, 'cmyk', new DeviceCmykCS());
    }
  };
  return ColorSpace;
}();
var AlternateCS = function AlternateCSClosure() {
  function AlternateCS(numComps, base, tintFn) {
    this.name = 'Alternate';
    this.numComps = numComps;
    this.defaultColor = new Float32Array(numComps);
    for (var i = 0; i < numComps; ++i) {
      this.defaultColor[i] = 1;
    }
    this.base = base;
    this.tintFn = tintFn;
    this.tmpBuf = new Float32Array(base.numComps);
  }
  AlternateCS.prototype = {
    getRgb: ColorSpace.prototype.getRgb,
    getRgbItem: function AlternateCS_getRgbItem(src, srcOffset, dest, destOffset) {
      var tmpBuf = this.tmpBuf;
      this.tintFn(src, srcOffset, tmpBuf, 0);
      this.base.getRgbItem(tmpBuf, 0, dest, destOffset);
    },
    getRgbBuffer: function AlternateCS_getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
      var tintFn = this.tintFn;
      var base = this.base;
      var scale = 1 / ((1 << bits) - 1);
      var baseNumComps = base.numComps;
      var usesZeroToOneRange = base.usesZeroToOneRange;
      var isPassthrough = (base.isPassthrough(8) || !usesZeroToOneRange) && alpha01 === 0;
      var pos = isPassthrough ? destOffset : 0;
      var baseBuf = isPassthrough ? dest : new Uint8Array(baseNumComps * count);
      var numComps = this.numComps;
      var scaled = new Float32Array(numComps);
      var tinted = new Float32Array(baseNumComps);
      var i, j;
      for (i = 0; i < count; i++) {
        for (j = 0; j < numComps; j++) {
          scaled[j] = src[srcOffset++] * scale;
        }
        tintFn(scaled, 0, tinted, 0);
        if (usesZeroToOneRange) {
          for (j = 0; j < baseNumComps; j++) {
            baseBuf[pos++] = tinted[j] * 255;
          }
        } else {
          base.getRgbItem(tinted, 0, baseBuf, pos);
          pos += baseNumComps;
        }
      }
      if (!isPassthrough) {
        base.getRgbBuffer(baseBuf, 0, count, dest, destOffset, 8, alpha01);
      }
    },
    getOutputLength: function AlternateCS_getOutputLength(inputLength, alpha01) {
      return this.base.getOutputLength(inputLength * this.base.numComps / this.numComps, alpha01);
    },
    isPassthrough: ColorSpace.prototype.isPassthrough,
    fillRgb: ColorSpace.prototype.fillRgb,
    isDefaultDecode: function AlternateCS_isDefaultDecode(decodeMap) {
      return ColorSpace.isDefaultDecode(decodeMap, this.numComps);
    },
    usesZeroToOneRange: true
  };
  return AlternateCS;
}();
var PatternCS = function PatternCSClosure() {
  function PatternCS(baseCS) {
    this.name = 'Pattern';
    this.base = baseCS;
  }
  PatternCS.prototype = {};
  return PatternCS;
}();
var IndexedCS = function IndexedCSClosure() {
  function IndexedCS(base, highVal, lookup) {
    this.name = 'Indexed';
    this.numComps = 1;
    this.defaultColor = new Uint8Array(this.numComps);
    this.base = base;
    this.highVal = highVal;
    var baseNumComps = base.numComps;
    var length = baseNumComps * highVal;
    if ((0, _primitives.isStream)(lookup)) {
      this.lookup = new Uint8Array(length);
      var bytes = lookup.getBytes(length);
      this.lookup.set(bytes);
    } else if ((0, _util.isString)(lookup)) {
      this.lookup = new Uint8Array(length);
      for (var i = 0; i < length; ++i) {
        this.lookup[i] = lookup.charCodeAt(i);
      }
    } else if (lookup instanceof Uint8Array || lookup instanceof Array) {
      this.lookup = lookup;
    } else {
      throw new _util.FormatError('Unrecognized lookup table: ' + lookup);
    }
  }
  IndexedCS.prototype = {
    getRgb: ColorSpace.prototype.getRgb,
    getRgbItem: function IndexedCS_getRgbItem(src, srcOffset, dest, destOffset) {
      var numComps = this.base.numComps;
      var start = src[srcOffset] * numComps;
      this.base.getRgbBuffer(this.lookup, start, 1, dest, destOffset, 8, 0);
    },
    getRgbBuffer: function IndexedCS_getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
      var base = this.base;
      var numComps = base.numComps;
      var outputDelta = base.getOutputLength(numComps, alpha01);
      var lookup = this.lookup;
      for (var i = 0; i < count; ++i) {
        var lookupPos = src[srcOffset++] * numComps;
        base.getRgbBuffer(lookup, lookupPos, 1, dest, destOffset, 8, alpha01);
        destOffset += outputDelta;
      }
    },
    getOutputLength: function IndexedCS_getOutputLength(inputLength, alpha01) {
      return this.base.getOutputLength(inputLength * this.base.numComps, alpha01);
    },
    isPassthrough: ColorSpace.prototype.isPassthrough,
    fillRgb: ColorSpace.prototype.fillRgb,
    isDefaultDecode: function IndexedCS_isDefaultDecode(decodeMap) {
      return true;
    },
    usesZeroToOneRange: true
  };
  return IndexedCS;
}();
var DeviceGrayCS = function DeviceGrayCSClosure() {
  function DeviceGrayCS() {
    this.name = 'DeviceGray';
    this.numComps = 1;
    this.defaultColor = new Float32Array(this.numComps);
  }
  DeviceGrayCS.prototype = {
    getRgb: ColorSpace.prototype.getRgb,
    getRgbItem: function DeviceGrayCS_getRgbItem(src, srcOffset, dest, destOffset) {
      var c = src[srcOffset] * 255 | 0;
      c = c < 0 ? 0 : c > 255 ? 255 : c;
      dest[destOffset] = dest[destOffset + 1] = dest[destOffset + 2] = c;
    },
    getRgbBuffer: function DeviceGrayCS_getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
      var scale = 255 / ((1 << bits) - 1);
      var j = srcOffset,
          q = destOffset;
      for (var i = 0; i < count; ++i) {
        var c = scale * src[j++] | 0;
        dest[q++] = c;
        dest[q++] = c;
        dest[q++] = c;
        q += alpha01;
      }
    },
    getOutputLength: function DeviceGrayCS_getOutputLength(inputLength, alpha01) {
      return inputLength * (3 + alpha01);
    },
    isPassthrough: ColorSpace.prototype.isPassthrough,
    fillRgb: ColorSpace.prototype.fillRgb,
    isDefaultDecode: function DeviceGrayCS_isDefaultDecode(decodeMap) {
      return ColorSpace.isDefaultDecode(decodeMap, this.numComps);
    },
    usesZeroToOneRange: true
  };
  return DeviceGrayCS;
}();
var DeviceRgbCS = function DeviceRgbCSClosure() {
  function DeviceRgbCS() {
    this.name = 'DeviceRGB';
    this.numComps = 3;
    this.defaultColor = new Float32Array(this.numComps);
  }
  DeviceRgbCS.prototype = {
    getRgb: ColorSpace.prototype.getRgb,
    getRgbItem: function DeviceRgbCS_getRgbItem(src, srcOffset, dest, destOffset) {
      var r = src[srcOffset] * 255 | 0;
      var g = src[srcOffset + 1] * 255 | 0;
      var b = src[srcOffset + 2] * 255 | 0;
      dest[destOffset] = r < 0 ? 0 : r > 255 ? 255 : r;
      dest[destOffset + 1] = g < 0 ? 0 : g > 255 ? 255 : g;
      dest[destOffset + 2] = b < 0 ? 0 : b > 255 ? 255 : b;
    },
    getRgbBuffer: function DeviceRgbCS_getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
      if (bits === 8 && alpha01 === 0) {
        dest.set(src.subarray(srcOffset, srcOffset + count * 3), destOffset);
        return;
      }
      var scale = 255 / ((1 << bits) - 1);
      var j = srcOffset,
          q = destOffset;
      for (var i = 0; i < count; ++i) {
        dest[q++] = scale * src[j++] | 0;
        dest[q++] = scale * src[j++] | 0;
        dest[q++] = scale * src[j++] | 0;
        q += alpha01;
      }
    },
    getOutputLength: function DeviceRgbCS_getOutputLength(inputLength, alpha01) {
      return inputLength * (3 + alpha01) / 3 | 0;
    },
    isPassthrough: function DeviceRgbCS_isPassthrough(bits) {
      return bits === 8;
    },
    fillRgb: ColorSpace.prototype.fillRgb,
    isDefaultDecode: function DeviceRgbCS_isDefaultDecode(decodeMap) {
      return ColorSpace.isDefaultDecode(decodeMap, this.numComps);
    },
    usesZeroToOneRange: true
  };
  return DeviceRgbCS;
}();
var DeviceCmykCS = function DeviceCmykCSClosure() {
  function convertToRgb(src, srcOffset, srcScale, dest, destOffset) {
    var c = src[srcOffset + 0] * srcScale;
    var m = src[srcOffset + 1] * srcScale;
    var y = src[srcOffset + 2] * srcScale;
    var k = src[srcOffset + 3] * srcScale;
    var r = c * (-4.387332384609988 * c + 54.48615194189176 * m + 18.82290502165302 * y + 212.25662451639585 * k + -285.2331026137004) + m * (1.7149763477362134 * m - 5.6096736904047315 * y + -17.873870861415444 * k - 5.497006427196366) + y * (-2.5217340131683033 * y - 21.248923337353073 * k + 17.5119270841813) + k * (-21.86122147463605 * k - 189.48180835922747) + 255 | 0;
    var g = c * (8.841041422036149 * c + 60.118027045597366 * m + 6.871425592049007 * y + 31.159100130055922 * k + -79.2970844816548) + m * (-15.310361306967817 * m + 17.575251261109482 * y + 131.35250912493976 * k - 190.9453302588951) + y * (4.444339102852739 * y + 9.8632861493405 * k - 24.86741582555878) + k * (-20.737325471181034 * k - 187.80453709719578) + 255 | 0;
    var b = c * (0.8842522430003296 * c + 8.078677503112928 * m + 30.89978309703729 * y - 0.23883238689178934 * k + -14.183576799673286) + m * (10.49593273432072 * m + 63.02378494754052 * y + 50.606957656360734 * k - 112.23884253719248) + y * (0.03296041114873217 * y + 115.60384449646641 * k + -193.58209356861505) + k * (-22.33816807309886 * k - 180.12613974708367) + 255 | 0;
    dest[destOffset] = r > 255 ? 255 : r < 0 ? 0 : r;
    dest[destOffset + 1] = g > 255 ? 255 : g < 0 ? 0 : g;
    dest[destOffset + 2] = b > 255 ? 255 : b < 0 ? 0 : b;
  }
  function DeviceCmykCS() {
    this.name = 'DeviceCMYK';
    this.numComps = 4;
    this.defaultColor = new Float32Array(this.numComps);
    this.defaultColor[3] = 1;
  }
  DeviceCmykCS.prototype = {
    getRgb: ColorSpace.prototype.getRgb,
    getRgbItem: function DeviceCmykCS_getRgbItem(src, srcOffset, dest, destOffset) {
      convertToRgb(src, srcOffset, 1, dest, destOffset);
    },
    getRgbBuffer: function DeviceCmykCS_getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
      var scale = 1 / ((1 << bits) - 1);
      for (var i = 0; i < count; i++) {
        convertToRgb(src, srcOffset, scale, dest, destOffset);
        srcOffset += 4;
        destOffset += 3 + alpha01;
      }
    },
    getOutputLength: function DeviceCmykCS_getOutputLength(inputLength, alpha01) {
      return inputLength / 4 * (3 + alpha01) | 0;
    },
    isPassthrough: ColorSpace.prototype.isPassthrough,
    fillRgb: ColorSpace.prototype.fillRgb,
    isDefaultDecode: function DeviceCmykCS_isDefaultDecode(decodeMap) {
      return ColorSpace.isDefaultDecode(decodeMap, this.numComps);
    },
    usesZeroToOneRange: true
  };
  return DeviceCmykCS;
}();
var CalGrayCS = function CalGrayCSClosure() {
  function CalGrayCS(whitePoint, blackPoint, gamma) {
    this.name = 'CalGray';
    this.numComps = 1;
    this.defaultColor = new Float32Array(this.numComps);
    if (!whitePoint) {
      throw new _util.FormatError('WhitePoint missing - required for color space CalGray');
    }
    blackPoint = blackPoint || [0, 0, 0];
    gamma = gamma || 1;
    this.XW = whitePoint[0];
    this.YW = whitePoint[1];
    this.ZW = whitePoint[2];
    this.XB = blackPoint[0];
    this.YB = blackPoint[1];
    this.ZB = blackPoint[2];
    this.G = gamma;
    if (this.XW < 0 || this.ZW < 0 || this.YW !== 1) {
      throw new _util.FormatError('Invalid WhitePoint components for ' + this.name + ', no fallback available');
    }
    if (this.XB < 0 || this.YB < 0 || this.ZB < 0) {
      (0, _util.info)('Invalid BlackPoint for ' + this.name + ', falling back to default');
      this.XB = this.YB = this.ZB = 0;
    }
    if (this.XB !== 0 || this.YB !== 0 || this.ZB !== 0) {
      (0, _util.warn)(this.name + ', BlackPoint: XB: ' + this.XB + ', YB: ' + this.YB + ', ZB: ' + this.ZB + ', only default values are supported.');
    }
    if (this.G < 1) {
      (0, _util.info)('Invalid Gamma: ' + this.G + ' for ' + this.name + ', falling back to default');
      this.G = 1;
    }
  }
  function convertToRgb(cs, src, srcOffset, dest, destOffset, scale) {
    var A = src[srcOffset] * scale;
    var AG = Math.pow(A, cs.G);
    var L = cs.YW * AG;
    var val = Math.max(295.8 * Math.pow(L, 0.333333333333333333) - 40.8, 0) | 0;
    dest[destOffset] = val;
    dest[destOffset + 1] = val;
    dest[destOffset + 2] = val;
  }
  CalGrayCS.prototype = {
    getRgb: ColorSpace.prototype.getRgb,
    getRgbItem: function CalGrayCS_getRgbItem(src, srcOffset, dest, destOffset) {
      convertToRgb(this, src, srcOffset, dest, destOffset, 1);
    },
    getRgbBuffer: function CalGrayCS_getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
      var scale = 1 / ((1 << bits) - 1);
      for (var i = 0; i < count; ++i) {
        convertToRgb(this, src, srcOffset, dest, destOffset, scale);
        srcOffset += 1;
        destOffset += 3 + alpha01;
      }
    },
    getOutputLength: function CalGrayCS_getOutputLength(inputLength, alpha01) {
      return inputLength * (3 + alpha01);
    },
    isPassthrough: ColorSpace.prototype.isPassthrough,
    fillRgb: ColorSpace.prototype.fillRgb,
    isDefaultDecode: function CalGrayCS_isDefaultDecode(decodeMap) {
      return ColorSpace.isDefaultDecode(decodeMap, this.numComps);
    },
    usesZeroToOneRange: true
  };
  return CalGrayCS;
}();
var CalRGBCS = function CalRGBCSClosure() {
  var BRADFORD_SCALE_MATRIX = new Float32Array([0.8951, 0.2664, -0.1614, -0.7502, 1.7135, 0.0367, 0.0389, -0.0685, 1.0296]);
  var BRADFORD_SCALE_INVERSE_MATRIX = new Float32Array([0.9869929, -0.1470543, 0.1599627, 0.4323053, 0.5183603, 0.0492912, -0.0085287, 0.0400428, 0.9684867]);
  var SRGB_D65_XYZ_TO_RGB_MATRIX = new Float32Array([3.2404542, -1.5371385, -0.4985314, -0.9692660, 1.8760108, 0.0415560, 0.0556434, -0.2040259, 1.0572252]);
  var FLAT_WHITEPOINT_MATRIX = new Float32Array([1, 1, 1]);
  var tempNormalizeMatrix = new Float32Array(3);
  var tempConvertMatrix1 = new Float32Array(3);
  var tempConvertMatrix2 = new Float32Array(3);
  var DECODE_L_CONSTANT = Math.pow((8 + 16) / 116, 3) / 8.0;
  function CalRGBCS(whitePoint, blackPoint, gamma, matrix) {
    this.name = 'CalRGB';
    this.numComps = 3;
    this.defaultColor = new Float32Array(this.numComps);
    if (!whitePoint) {
      throw new _util.FormatError('WhitePoint missing - required for color space CalRGB');
    }
    blackPoint = blackPoint || new Float32Array(3);
    gamma = gamma || new Float32Array([1, 1, 1]);
    matrix = matrix || new Float32Array([1, 0, 0, 0, 1, 0, 0, 0, 1]);
    var XW = whitePoint[0];
    var YW = whitePoint[1];
    var ZW = whitePoint[2];
    this.whitePoint = whitePoint;
    var XB = blackPoint[0];
    var YB = blackPoint[1];
    var ZB = blackPoint[2];
    this.blackPoint = blackPoint;
    this.GR = gamma[0];
    this.GG = gamma[1];
    this.GB = gamma[2];
    this.MXA = matrix[0];
    this.MYA = matrix[1];
    this.MZA = matrix[2];
    this.MXB = matrix[3];
    this.MYB = matrix[4];
    this.MZB = matrix[5];
    this.MXC = matrix[6];
    this.MYC = matrix[7];
    this.MZC = matrix[8];
    if (XW < 0 || ZW < 0 || YW !== 1) {
      throw new _util.FormatError('Invalid WhitePoint components for ' + this.name + ', no fallback available');
    }
    if (XB < 0 || YB < 0 || ZB < 0) {
      (0, _util.info)('Invalid BlackPoint for ' + this.name + ' [' + XB + ', ' + YB + ', ' + ZB + '], falling back to default');
      this.blackPoint = new Float32Array(3);
    }
    if (this.GR < 0 || this.GG < 0 || this.GB < 0) {
      (0, _util.info)('Invalid Gamma [' + this.GR + ', ' + this.GG + ', ' + this.GB + '] for ' + this.name + ', falling back to default');
      this.GR = this.GG = this.GB = 1;
    }
    if (this.MXA < 0 || this.MYA < 0 || this.MZA < 0 || this.MXB < 0 || this.MYB < 0 || this.MZB < 0 || this.MXC < 0 || this.MYC < 0 || this.MZC < 0) {
      (0, _util.info)('Invalid Matrix for ' + this.name + ' [' + this.MXA + ', ' + this.MYA + ', ' + this.MZA + this.MXB + ', ' + this.MYB + ', ' + this.MZB + this.MXC + ', ' + this.MYC + ', ' + this.MZC + '], falling back to default');
      this.MXA = this.MYB = this.MZC = 1;
      this.MXB = this.MYA = this.MZA = this.MXC = this.MYC = this.MZB = 0;
    }
  }
  function matrixProduct(a, b, result) {
    result[0] = a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
    result[1] = a[3] * b[0] + a[4] * b[1] + a[5] * b[2];
    result[2] = a[6] * b[0] + a[7] * b[1] + a[8] * b[2];
  }
  function convertToFlat(sourceWhitePoint, LMS, result) {
    result[0] = LMS[0] * 1 / sourceWhitePoint[0];
    result[1] = LMS[1] * 1 / sourceWhitePoint[1];
    result[2] = LMS[2] * 1 / sourceWhitePoint[2];
  }
  function convertToD65(sourceWhitePoint, LMS, result) {
    var D65X = 0.95047;
    var D65Y = 1;
    var D65Z = 1.08883;
    result[0] = LMS[0] * D65X / sourceWhitePoint[0];
    result[1] = LMS[1] * D65Y / sourceWhitePoint[1];
    result[2] = LMS[2] * D65Z / sourceWhitePoint[2];
  }
  function sRGBTransferFunction(color) {
    if (color <= 0.0031308) {
      return adjustToRange(0, 1, 12.92 * color);
    }
    return adjustToRange(0, 1, (1 + 0.055) * Math.pow(color, 1 / 2.4) - 0.055);
  }
  function adjustToRange(min, max, value) {
    return Math.max(min, Math.min(max, value));
  }
  function decodeL(L) {
    if (L < 0) {
      return -decodeL(-L);
    }
    if (L > 8.0) {
      return Math.pow((L + 16) / 116, 3);
    }
    return L * DECODE_L_CONSTANT;
  }
  function compensateBlackPoint(sourceBlackPoint, XYZ_Flat, result) {
    if (sourceBlackPoint[0] === 0 && sourceBlackPoint[1] === 0 && sourceBlackPoint[2] === 0) {
      result[0] = XYZ_Flat[0];
      result[1] = XYZ_Flat[1];
      result[2] = XYZ_Flat[2];
      return;
    }
    var zeroDecodeL = decodeL(0);
    var X_DST = zeroDecodeL;
    var X_SRC = decodeL(sourceBlackPoint[0]);
    var Y_DST = zeroDecodeL;
    var Y_SRC = decodeL(sourceBlackPoint[1]);
    var Z_DST = zeroDecodeL;
    var Z_SRC = decodeL(sourceBlackPoint[2]);
    var X_Scale = (1 - X_DST) / (1 - X_SRC);
    var X_Offset = 1 - X_Scale;
    var Y_Scale = (1 - Y_DST) / (1 - Y_SRC);
    var Y_Offset = 1 - Y_Scale;
    var Z_Scale = (1 - Z_DST) / (1 - Z_SRC);
    var Z_Offset = 1 - Z_Scale;
    result[0] = XYZ_Flat[0] * X_Scale + X_Offset;
    result[1] = XYZ_Flat[1] * Y_Scale + Y_Offset;
    result[2] = XYZ_Flat[2] * Z_Scale + Z_Offset;
  }
  function normalizeWhitePointToFlat(sourceWhitePoint, XYZ_In, result) {
    if (sourceWhitePoint[0] === 1 && sourceWhitePoint[2] === 1) {
      result[0] = XYZ_In[0];
      result[1] = XYZ_In[1];
      result[2] = XYZ_In[2];
      return;
    }
    var LMS = result;
    matrixProduct(BRADFORD_SCALE_MATRIX, XYZ_In, LMS);
    var LMS_Flat = tempNormalizeMatrix;
    convertToFlat(sourceWhitePoint, LMS, LMS_Flat);
    matrixProduct(BRADFORD_SCALE_INVERSE_MATRIX, LMS_Flat, result);
  }
  function normalizeWhitePointToD65(sourceWhitePoint, XYZ_In, result) {
    var LMS = result;
    matrixProduct(BRADFORD_SCALE_MATRIX, XYZ_In, LMS);
    var LMS_D65 = tempNormalizeMatrix;
    convertToD65(sourceWhitePoint, LMS, LMS_D65);
    matrixProduct(BRADFORD_SCALE_INVERSE_MATRIX, LMS_D65, result);
  }
  function convertToRgb(cs, src, srcOffset, dest, destOffset, scale) {
    var A = adjustToRange(0, 1, src[srcOffset] * scale);
    var B = adjustToRange(0, 1, src[srcOffset + 1] * scale);
    var C = adjustToRange(0, 1, src[srcOffset + 2] * scale);
    var AGR = Math.pow(A, cs.GR);
    var BGG = Math.pow(B, cs.GG);
    var CGB = Math.pow(C, cs.GB);
    var X = cs.MXA * AGR + cs.MXB * BGG + cs.MXC * CGB;
    var Y = cs.MYA * AGR + cs.MYB * BGG + cs.MYC * CGB;
    var Z = cs.MZA * AGR + cs.MZB * BGG + cs.MZC * CGB;
    var XYZ = tempConvertMatrix1;
    XYZ[0] = X;
    XYZ[1] = Y;
    XYZ[2] = Z;
    var XYZ_Flat = tempConvertMatrix2;
    normalizeWhitePointToFlat(cs.whitePoint, XYZ, XYZ_Flat);
    var XYZ_Black = tempConvertMatrix1;
    compensateBlackPoint(cs.blackPoint, XYZ_Flat, XYZ_Black);
    var XYZ_D65 = tempConvertMatrix2;
    normalizeWhitePointToD65(FLAT_WHITEPOINT_MATRIX, XYZ_Black, XYZ_D65);
    var SRGB = tempConvertMatrix1;
    matrixProduct(SRGB_D65_XYZ_TO_RGB_MATRIX, XYZ_D65, SRGB);
    var sR = sRGBTransferFunction(SRGB[0]);
    var sG = sRGBTransferFunction(SRGB[1]);
    var sB = sRGBTransferFunction(SRGB[2]);
    dest[destOffset] = Math.round(sR * 255);
    dest[destOffset + 1] = Math.round(sG * 255);
    dest[destOffset + 2] = Math.round(sB * 255);
  }
  CalRGBCS.prototype = {
    getRgb: ColorSpace.prototype.getRgb,
    getRgbItem: function CalRGBCS_getRgbItem(src, srcOffset, dest, destOffset) {
      convertToRgb(this, src, srcOffset, dest, destOffset, 1);
    },
    getRgbBuffer: function CalRGBCS_getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
      var scale = 1 / ((1 << bits) - 1);
      for (var i = 0; i < count; ++i) {
        convertToRgb(this, src, srcOffset, dest, destOffset, scale);
        srcOffset += 3;
        destOffset += 3 + alpha01;
      }
    },
    getOutputLength: function CalRGBCS_getOutputLength(inputLength, alpha01) {
      return inputLength * (3 + alpha01) / 3 | 0;
    },
    isPassthrough: ColorSpace.prototype.isPassthrough,
    fillRgb: ColorSpace.prototype.fillRgb,
    isDefaultDecode: function CalRGBCS_isDefaultDecode(decodeMap) {
      return ColorSpace.isDefaultDecode(decodeMap, this.numComps);
    },
    usesZeroToOneRange: true
  };
  return CalRGBCS;
}();
var LabCS = function LabCSClosure() {
  function LabCS(whitePoint, blackPoint, range) {
    this.name = 'Lab';
    this.numComps = 3;
    this.defaultColor = new Float32Array(this.numComps);
    if (!whitePoint) {
      throw new _util.FormatError('WhitePoint missing - required for color space Lab');
    }
    blackPoint = blackPoint || [0, 0, 0];
    range = range || [-100, 100, -100, 100];
    this.XW = whitePoint[0];
    this.YW = whitePoint[1];
    this.ZW = whitePoint[2];
    this.amin = range[0];
    this.amax = range[1];
    this.bmin = range[2];
    this.bmax = range[3];
    this.XB = blackPoint[0];
    this.YB = blackPoint[1];
    this.ZB = blackPoint[2];
    if (this.XW < 0 || this.ZW < 0 || this.YW !== 1) {
      throw new _util.FormatError('Invalid WhitePoint components, no fallback available');
    }
    if (this.XB < 0 || this.YB < 0 || this.ZB < 0) {
      (0, _util.info)('Invalid BlackPoint, falling back to default');
      this.XB = this.YB = this.ZB = 0;
    }
    if (this.amin > this.amax || this.bmin > this.bmax) {
      (0, _util.info)('Invalid Range, falling back to defaults');
      this.amin = -100;
      this.amax = 100;
      this.bmin = -100;
      this.bmax = 100;
    }
  }
  function fn_g(x) {
    var result;
    if (x >= 6 / 29) {
      result = x * x * x;
    } else {
      result = 108 / 841 * (x - 4 / 29);
    }
    return result;
  }
  function decode(value, high1, low2, high2) {
    return low2 + value * (high2 - low2) / high1;
  }
  function convertToRgb(cs, src, srcOffset, maxVal, dest, destOffset) {
    var Ls = src[srcOffset];
    var as = src[srcOffset + 1];
    var bs = src[srcOffset + 2];
    if (maxVal !== false) {
      Ls = decode(Ls, maxVal, 0, 100);
      as = decode(as, maxVal, cs.amin, cs.amax);
      bs = decode(bs, maxVal, cs.bmin, cs.bmax);
    }
    as = as > cs.amax ? cs.amax : as < cs.amin ? cs.amin : as;
    bs = bs > cs.bmax ? cs.bmax : bs < cs.bmin ? cs.bmin : bs;
    var M = (Ls + 16) / 116;
    var L = M + as / 500;
    var N = M - bs / 200;
    var X = cs.XW * fn_g(L);
    var Y = cs.YW * fn_g(M);
    var Z = cs.ZW * fn_g(N);
    var r, g, b;
    if (cs.ZW < 1) {
      r = X * 3.1339 + Y * -1.6170 + Z * -0.4906;
      g = X * -0.9785 + Y * 1.9160 + Z * 0.0333;
      b = X * 0.0720 + Y * -0.2290 + Z * 1.4057;
    } else {
      r = X * 3.2406 + Y * -1.5372 + Z * -0.4986;
      g = X * -0.9689 + Y * 1.8758 + Z * 0.0415;
      b = X * 0.0557 + Y * -0.2040 + Z * 1.0570;
    }
    dest[destOffset] = r <= 0 ? 0 : r >= 1 ? 255 : Math.sqrt(r) * 255 | 0;
    dest[destOffset + 1] = g <= 0 ? 0 : g >= 1 ? 255 : Math.sqrt(g) * 255 | 0;
    dest[destOffset + 2] = b <= 0 ? 0 : b >= 1 ? 255 : Math.sqrt(b) * 255 | 0;
  }
  LabCS.prototype = {
    getRgb: ColorSpace.prototype.getRgb,
    getRgbItem: function LabCS_getRgbItem(src, srcOffset, dest, destOffset) {
      convertToRgb(this, src, srcOffset, false, dest, destOffset);
    },
    getRgbBuffer: function LabCS_getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
      var maxVal = (1 << bits) - 1;
      for (var i = 0; i < count; i++) {
        convertToRgb(this, src, srcOffset, maxVal, dest, destOffset);
        srcOffset += 3;
        destOffset += 3 + alpha01;
      }
    },
    getOutputLength: function LabCS_getOutputLength(inputLength, alpha01) {
      return inputLength * (3 + alpha01) / 3 | 0;
    },
    isPassthrough: ColorSpace.prototype.isPassthrough,
    fillRgb: ColorSpace.prototype.fillRgb,
    isDefaultDecode: function LabCS_isDefaultDecode(decodeMap) {
      return true;
    },
    usesZeroToOneRange: false
  };
  return LabCS;
}();
exports.ColorSpace = ColorSpace;

/***/ }),
/* 4 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ExpertEncoding = ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'space', 'exclamsmall', 'Hungarumlautsmall', '', 'dollaroldstyle', 'dollarsuperior', 'ampersandsmall', 'Acutesmall', 'parenleftsuperior', 'parenrightsuperior', 'twodotenleader', 'onedotenleader', 'comma', 'hyphen', 'period', 'fraction', 'zerooldstyle', 'oneoldstyle', 'twooldstyle', 'threeoldstyle', 'fouroldstyle', 'fiveoldstyle', 'sixoldstyle', 'sevenoldstyle', 'eightoldstyle', 'nineoldstyle', 'colon', 'semicolon', 'commasuperior', 'threequartersemdash', 'periodsuperior', 'questionsmall', '', 'asuperior', 'bsuperior', 'centsuperior', 'dsuperior', 'esuperior', '', '', '', 'isuperior', '', '', 'lsuperior', 'msuperior', 'nsuperior', 'osuperior', '', '', 'rsuperior', 'ssuperior', 'tsuperior', '', 'ff', 'fi', 'fl', 'ffi', 'ffl', 'parenleftinferior', '', 'parenrightinferior', 'Circumflexsmall', 'hyphensuperior', 'Gravesmall', 'Asmall', 'Bsmall', 'Csmall', 'Dsmall', 'Esmall', 'Fsmall', 'Gsmall', 'Hsmall', 'Ismall', 'Jsmall', 'Ksmall', 'Lsmall', 'Msmall', 'Nsmall', 'Osmall', 'Psmall', 'Qsmall', 'Rsmall', 'Ssmall', 'Tsmall', 'Usmall', 'Vsmall', 'Wsmall', 'Xsmall', 'Ysmall', 'Zsmall', 'colonmonetary', 'onefitted', 'rupiah', 'Tildesmall', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'exclamdownsmall', 'centoldstyle', 'Lslashsmall', '', '', 'Scaronsmall', 'Zcaronsmall', 'Dieresissmall', 'Brevesmall', 'Caronsmall', '', 'Dotaccentsmall', '', '', 'Macronsmall', '', '', 'figuredash', 'hypheninferior', '', '', 'Ogoneksmall', 'Ringsmall', 'Cedillasmall', '', '', '', 'onequarter', 'onehalf', 'threequarters', 'questiondownsmall', 'oneeighth', 'threeeighths', 'fiveeighths', 'seveneighths', 'onethird', 'twothirds', '', '', 'zerosuperior', 'onesuperior', 'twosuperior', 'threesuperior', 'foursuperior', 'fivesuperior', 'sixsuperior', 'sevensuperior', 'eightsuperior', 'ninesuperior', 'zeroinferior', 'oneinferior', 'twoinferior', 'threeinferior', 'fourinferior', 'fiveinferior', 'sixinferior', 'seveninferior', 'eightinferior', 'nineinferior', 'centinferior', 'dollarinferior', 'periodinferior', 'commainferior', 'Agravesmall', 'Aacutesmall', 'Acircumflexsmall', 'Atildesmall', 'Adieresissmall', 'Aringsmall', 'AEsmall', 'Ccedillasmall', 'Egravesmall', 'Eacutesmall', 'Ecircumflexsmall', 'Edieresissmall', 'Igravesmall', 'Iacutesmall', 'Icircumflexsmall', 'Idieresissmall', 'Ethsmall', 'Ntildesmall', 'Ogravesmall', 'Oacutesmall', 'Ocircumflexsmall', 'Otildesmall', 'Odieresissmall', 'OEsmall', 'Oslashsmall', 'Ugravesmall', 'Uacutesmall', 'Ucircumflexsmall', 'Udieresissmall', 'Yacutesmall', 'Thornsmall', 'Ydieresissmall'];
var MacExpertEncoding = ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'space', 'exclamsmall', 'Hungarumlautsmall', 'centoldstyle', 'dollaroldstyle', 'dollarsuperior', 'ampersandsmall', 'Acutesmall', 'parenleftsuperior', 'parenrightsuperior', 'twodotenleader', 'onedotenleader', 'comma', 'hyphen', 'period', 'fraction', 'zerooldstyle', 'oneoldstyle', 'twooldstyle', 'threeoldstyle', 'fouroldstyle', 'fiveoldstyle', 'sixoldstyle', 'sevenoldstyle', 'eightoldstyle', 'nineoldstyle', 'colon', 'semicolon', '', 'threequartersemdash', '', 'questionsmall', '', '', '', '', 'Ethsmall', '', '', 'onequarter', 'onehalf', 'threequarters', 'oneeighth', 'threeeighths', 'fiveeighths', 'seveneighths', 'onethird', 'twothirds', '', '', '', '', '', '', 'ff', 'fi', 'fl', 'ffi', 'ffl', 'parenleftinferior', '', 'parenrightinferior', 'Circumflexsmall', 'hypheninferior', 'Gravesmall', 'Asmall', 'Bsmall', 'Csmall', 'Dsmall', 'Esmall', 'Fsmall', 'Gsmall', 'Hsmall', 'Ismall', 'Jsmall', 'Ksmall', 'Lsmall', 'Msmall', 'Nsmall', 'Osmall', 'Psmall', 'Qsmall', 'Rsmall', 'Ssmall', 'Tsmall', 'Usmall', 'Vsmall', 'Wsmall', 'Xsmall', 'Ysmall', 'Zsmall', 'colonmonetary', 'onefitted', 'rupiah', 'Tildesmall', '', '', 'asuperior', 'centsuperior', '', '', '', '', 'Aacutesmall', 'Agravesmall', 'Acircumflexsmall', 'Adieresissmall', 'Atildesmall', 'Aringsmall', 'Ccedillasmall', 'Eacutesmall', 'Egravesmall', 'Ecircumflexsmall', 'Edieresissmall', 'Iacutesmall', 'Igravesmall', 'Icircumflexsmall', 'Idieresissmall', 'Ntildesmall', 'Oacutesmall', 'Ogravesmall', 'Ocircumflexsmall', 'Odieresissmall', 'Otildesmall', 'Uacutesmall', 'Ugravesmall', 'Ucircumflexsmall', 'Udieresissmall', '', 'eightsuperior', 'fourinferior', 'threeinferior', 'sixinferior', 'eightinferior', 'seveninferior', 'Scaronsmall', '', 'centinferior', 'twoinferior', '', 'Dieresissmall', '', 'Caronsmall', 'osuperior', 'fiveinferior', '', 'commainferior', 'periodinferior', 'Yacutesmall', '', 'dollarinferior', '', 'Thornsmall', '', 'nineinferior', 'zeroinferior', 'Zcaronsmall', 'AEsmall', 'Oslashsmall', 'questiondownsmall', 'oneinferior', 'Lslashsmall', '', '', '', '', '', '', 'Cedillasmall', '', '', '', '', '', 'OEsmall', 'figuredash', 'hyphensuperior', '', '', '', '', 'exclamdownsmall', '', 'Ydieresissmall', '', 'onesuperior', 'twosuperior', 'threesuperior', 'foursuperior', 'fivesuperior', 'sixsuperior', 'sevensuperior', 'ninesuperior', 'zerosuperior', '', 'esuperior', 'rsuperior', 'tsuperior', '', '', 'isuperior', 'ssuperior', 'dsuperior', '', '', '', '', '', 'lsuperior', 'Ogoneksmall', 'Brevesmall', 'Macronsmall', 'bsuperior', 'nsuperior', 'msuperior', 'commasuperior', 'periodsuperior', 'Dotaccentsmall', 'Ringsmall'];
var MacRomanEncoding = ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'space', 'exclam', 'quotedbl', 'numbersign', 'dollar', 'percent', 'ampersand', 'quotesingle', 'parenleft', 'parenright', 'asterisk', 'plus', 'comma', 'hyphen', 'period', 'slash', 'zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'colon', 'semicolon', 'less', 'equal', 'greater', 'question', 'at', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'bracketleft', 'backslash', 'bracketright', 'asciicircum', 'underscore', 'grave', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'braceleft', 'bar', 'braceright', 'asciitilde', '', 'Adieresis', 'Aring', 'Ccedilla', 'Eacute', 'Ntilde', 'Odieresis', 'Udieresis', 'aacute', 'agrave', 'acircumflex', 'adieresis', 'atilde', 'aring', 'ccedilla', 'eacute', 'egrave', 'ecircumflex', 'edieresis', 'iacute', 'igrave', 'icircumflex', 'idieresis', 'ntilde', 'oacute', 'ograve', 'ocircumflex', 'odieresis', 'otilde', 'uacute', 'ugrave', 'ucircumflex', 'udieresis', 'dagger', 'degree', 'cent', 'sterling', 'section', 'bullet', 'paragraph', 'germandbls', 'registered', 'copyright', 'trademark', 'acute', 'dieresis', 'notequal', 'AE', 'Oslash', 'infinity', 'plusminus', 'lessequal', 'greaterequal', 'yen', 'mu', 'partialdiff', 'summation', 'product', 'pi', 'integral', 'ordfeminine', 'ordmasculine', 'Omega', 'ae', 'oslash', 'questiondown', 'exclamdown', 'logicalnot', 'radical', 'florin', 'approxequal', 'Delta', 'guillemotleft', 'guillemotright', 'ellipsis', 'space', 'Agrave', 'Atilde', 'Otilde', 'OE', 'oe', 'endash', 'emdash', 'quotedblleft', 'quotedblright', 'quoteleft', 'quoteright', 'divide', 'lozenge', 'ydieresis', 'Ydieresis', 'fraction', 'currency', 'guilsinglleft', 'guilsinglright', 'fi', 'fl', 'daggerdbl', 'periodcentered', 'quotesinglbase', 'quotedblbase', 'perthousand', 'Acircumflex', 'Ecircumflex', 'Aacute', 'Edieresis', 'Egrave', 'Iacute', 'Icircumflex', 'Idieresis', 'Igrave', 'Oacute', 'Ocircumflex', 'apple', 'Ograve', 'Uacute', 'Ucircumflex', 'Ugrave', 'dotlessi', 'circumflex', 'tilde', 'macron', 'breve', 'dotaccent', 'ring', 'cedilla', 'hungarumlaut', 'ogonek', 'caron'];
var StandardEncoding = ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'space', 'exclam', 'quotedbl', 'numbersign', 'dollar', 'percent', 'ampersand', 'quoteright', 'parenleft', 'parenright', 'asterisk', 'plus', 'comma', 'hyphen', 'period', 'slash', 'zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'colon', 'semicolon', 'less', 'equal', 'greater', 'question', 'at', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'bracketleft', 'backslash', 'bracketright', 'asciicircum', 'underscore', 'quoteleft', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'braceleft', 'bar', 'braceright', 'asciitilde', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'exclamdown', 'cent', 'sterling', 'fraction', 'yen', 'florin', 'section', 'currency', 'quotesingle', 'quotedblleft', 'guillemotleft', 'guilsinglleft', 'guilsinglright', 'fi', 'fl', '', 'endash', 'dagger', 'daggerdbl', 'periodcentered', '', 'paragraph', 'bullet', 'quotesinglbase', 'quotedblbase', 'quotedblright', 'guillemotright', 'ellipsis', 'perthousand', '', 'questiondown', '', 'grave', 'acute', 'circumflex', 'tilde', 'macron', 'breve', 'dotaccent', 'dieresis', '', 'ring', 'cedilla', '', 'hungarumlaut', 'ogonek', 'caron', 'emdash', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'AE', '', 'ordfeminine', '', '', '', '', 'Lslash', 'Oslash', 'OE', 'ordmasculine', '', '', '', '', '', 'ae', '', '', '', 'dotlessi', '', '', 'lslash', 'oslash', 'oe', 'germandbls'];
var WinAnsiEncoding = ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'space', 'exclam', 'quotedbl', 'numbersign', 'dollar', 'percent', 'ampersand', 'quotesingle', 'parenleft', 'parenright', 'asterisk', 'plus', 'comma', 'hyphen', 'period', 'slash', 'zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'colon', 'semicolon', 'less', 'equal', 'greater', 'question', 'at', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'bracketleft', 'backslash', 'bracketright', 'asciicircum', 'underscore', 'grave', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'braceleft', 'bar', 'braceright', 'asciitilde', 'bullet', 'Euro', 'bullet', 'quotesinglbase', 'florin', 'quotedblbase', 'ellipsis', 'dagger', 'daggerdbl', 'circumflex', 'perthousand', 'Scaron', 'guilsinglleft', 'OE', 'bullet', 'Zcaron', 'bullet', 'bullet', 'quoteleft', 'quoteright', 'quotedblleft', 'quotedblright', 'bullet', 'endash', 'emdash', 'tilde', 'trademark', 'scaron', 'guilsinglright', 'oe', 'bullet', 'zcaron', 'Ydieresis', 'space', 'exclamdown', 'cent', 'sterling', 'currency', 'yen', 'brokenbar', 'section', 'dieresis', 'copyright', 'ordfeminine', 'guillemotleft', 'logicalnot', 'hyphen', 'registered', 'macron', 'degree', 'plusminus', 'twosuperior', 'threesuperior', 'acute', 'mu', 'paragraph', 'periodcentered', 'cedilla', 'onesuperior', 'ordmasculine', 'guillemotright', 'onequarter', 'onehalf', 'threequarters', 'questiondown', 'Agrave', 'Aacute', 'Acircumflex', 'Atilde', 'Adieresis', 'Aring', 'AE', 'Ccedilla', 'Egrave', 'Eacute', 'Ecircumflex', 'Edieresis', 'Igrave', 'Iacute', 'Icircumflex', 'Idieresis', 'Eth', 'Ntilde', 'Ograve', 'Oacute', 'Ocircumflex', 'Otilde', 'Odieresis', 'multiply', 'Oslash', 'Ugrave', 'Uacute', 'Ucircumflex', 'Udieresis', 'Yacute', 'Thorn', 'germandbls', 'agrave', 'aacute', 'acircumflex', 'atilde', 'adieresis', 'aring', 'ae', 'ccedilla', 'egrave', 'eacute', 'ecircumflex', 'edieresis', 'igrave', 'iacute', 'icircumflex', 'idieresis', 'eth', 'ntilde', 'ograve', 'oacute', 'ocircumflex', 'otilde', 'odieresis', 'divide', 'oslash', 'ugrave', 'uacute', 'ucircumflex', 'udieresis', 'yacute', 'thorn', 'ydieresis'];
var SymbolSetEncoding = ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'space', 'exclam', 'universal', 'numbersign', 'existential', 'percent', 'ampersand', 'suchthat', 'parenleft', 'parenright', 'asteriskmath', 'plus', 'comma', 'minus', 'period', 'slash', 'zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'colon', 'semicolon', 'less', 'equal', 'greater', 'question', 'congruent', 'Alpha', 'Beta', 'Chi', 'Delta', 'Epsilon', 'Phi', 'Gamma', 'Eta', 'Iota', 'theta1', 'Kappa', 'Lambda', 'Mu', 'Nu', 'Omicron', 'Pi', 'Theta', 'Rho', 'Sigma', 'Tau', 'Upsilon', 'sigma1', 'Omega', 'Xi', 'Psi', 'Zeta', 'bracketleft', 'therefore', 'bracketright', 'perpendicular', 'underscore', 'radicalex', 'alpha', 'beta', 'chi', 'delta', 'epsilon', 'phi', 'gamma', 'eta', 'iota', 'phi1', 'kappa', 'lambda', 'mu', 'nu', 'omicron', 'pi', 'theta', 'rho', 'sigma', 'tau', 'upsilon', 'omega1', 'omega', 'xi', 'psi', 'zeta', 'braceleft', 'bar', 'braceright', 'similar', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'Euro', 'Upsilon1', 'minute', 'lessequal', 'fraction', 'infinity', 'florin', 'club', 'diamond', 'heart', 'spade', 'arrowboth', 'arrowleft', 'arrowup', 'arrowright', 'arrowdown', 'degree', 'plusminus', 'second', 'greaterequal', 'multiply', 'proportional', 'partialdiff', 'bullet', 'divide', 'notequal', 'equivalence', 'approxequal', 'ellipsis', 'arrowvertex', 'arrowhorizex', 'carriagereturn', 'aleph', 'Ifraktur', 'Rfraktur', 'weierstrass', 'circlemultiply', 'circleplus', 'emptyset', 'intersection', 'union', 'propersuperset', 'reflexsuperset', 'notsubset', 'propersubset', 'reflexsubset', 'element', 'notelement', 'angle', 'gradient', 'registerserif', 'copyrightserif', 'trademarkserif', 'product', 'radical', 'dotmath', 'logicalnot', 'logicaland', 'logicalor', 'arrowdblboth', 'arrowdblleft', 'arrowdblup', 'arrowdblright', 'arrowdbldown', 'lozenge', 'angleleft', 'registersans', 'copyrightsans', 'trademarksans', 'summation', 'parenlefttp', 'parenleftex', 'parenleftbt', 'bracketlefttp', 'bracketleftex', 'bracketleftbt', 'bracelefttp', 'braceleftmid', 'braceleftbt', 'braceex', '', 'angleright', 'integral', 'integraltp', 'integralex', 'integralbt', 'parenrighttp', 'parenrightex', 'parenrightbt', 'bracketrighttp', 'bracketrightex', 'bracketrightbt', 'bracerighttp', 'bracerightmid', 'bracerightbt'];
var ZapfDingbatsEncoding = ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'space', 'a1', 'a2', 'a202', 'a3', 'a4', 'a5', 'a119', 'a118', 'a117', 'a11', 'a12', 'a13', 'a14', 'a15', 'a16', 'a105', 'a17', 'a18', 'a19', 'a20', 'a21', 'a22', 'a23', 'a24', 'a25', 'a26', 'a27', 'a28', 'a6', 'a7', 'a8', 'a9', 'a10', 'a29', 'a30', 'a31', 'a32', 'a33', 'a34', 'a35', 'a36', 'a37', 'a38', 'a39', 'a40', 'a41', 'a42', 'a43', 'a44', 'a45', 'a46', 'a47', 'a48', 'a49', 'a50', 'a51', 'a52', 'a53', 'a54', 'a55', 'a56', 'a57', 'a58', 'a59', 'a60', 'a61', 'a62', 'a63', 'a64', 'a65', 'a66', 'a67', 'a68', 'a69', 'a70', 'a71', 'a72', 'a73', 'a74', 'a203', 'a75', 'a204', 'a76', 'a77', 'a78', 'a79', 'a81', 'a82', 'a83', 'a84', 'a97', 'a98', 'a99', 'a100', '', 'a89', 'a90', 'a93', 'a94', 'a91', 'a92', 'a205', 'a85', 'a206', 'a86', 'a87', 'a88', 'a95', 'a96', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'a101', 'a102', 'a103', 'a104', 'a106', 'a107', 'a108', 'a112', 'a111', 'a110', 'a109', 'a120', 'a121', 'a122', 'a123', 'a124', 'a125', 'a126', 'a127', 'a128', 'a129', 'a130', 'a131', 'a132', 'a133', 'a134', 'a135', 'a136', 'a137', 'a138', 'a139', 'a140', 'a141', 'a142', 'a143', 'a144', 'a145', 'a146', 'a147', 'a148', 'a149', 'a150', 'a151', 'a152', 'a153', 'a154', 'a155', 'a156', 'a157', 'a158', 'a159', 'a160', 'a161', 'a163', 'a164', 'a196', 'a165', 'a192', 'a166', 'a167', 'a168', 'a169', 'a170', 'a171', 'a172', 'a173', 'a162', 'a174', 'a175', 'a176', 'a177', 'a178', 'a179', 'a193', 'a180', 'a199', 'a181', 'a200', 'a182', '', 'a201', 'a183', 'a184', 'a197', 'a185', 'a194', 'a198', 'a186', 'a195', 'a187', 'a188', 'a189', 'a190', 'a191'];
function getEncoding(encodingName) {
  switch (encodingName) {
    case 'WinAnsiEncoding':
      return WinAnsiEncoding;
    case 'StandardEncoding':
      return StandardEncoding;
    case 'MacRomanEncoding':
      return MacRomanEncoding;
    case 'SymbolSetEncoding':
      return SymbolSetEncoding;
    case 'ZapfDingbatsEncoding':
      return ZapfDingbatsEncoding;
    case 'ExpertEncoding':
      return ExpertEncoding;
    case 'MacExpertEncoding':
      return MacExpertEncoding;
    default:
      return null;
  }
}
exports.WinAnsiEncoding = WinAnsiEncoding;
exports.StandardEncoding = StandardEncoding;
exports.MacRomanEncoding = MacRomanEncoding;
exports.SymbolSetEncoding = SymbolSetEncoding;
exports.ZapfDingbatsEncoding = ZapfDingbatsEncoding;
exports.ExpertEncoding = ExpertEncoding;
exports.getEncoding = getEncoding;

/***/ }),
/* 5 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Parser = exports.Linearization = exports.Lexer = undefined;

var _stream = __w_pdfjs_require__(2);

var _util = __w_pdfjs_require__(0);

var _primitives = __w_pdfjs_require__(1);

var MAX_LENGTH_TO_CACHE = 1000;
var Parser = function ParserClosure() {
  function Parser(lexer, allowStreams, xref, recoveryMode) {
    this.lexer = lexer;
    this.allowStreams = allowStreams;
    this.xref = xref;
    this.recoveryMode = recoveryMode || false;
    this.imageCache = Object.create(null);
    this.refill();
  }
  Parser.prototype = {
    refill: function Parser_refill() {
      this.buf1 = this.lexer.getObj();
      this.buf2 = this.lexer.getObj();
    },
    shift: function Parser_shift() {
      if ((0, _primitives.isCmd)(this.buf2, 'ID')) {
        this.buf1 = this.buf2;
        this.buf2 = null;
      } else {
        this.buf1 = this.buf2;
        this.buf2 = this.lexer.getObj();
      }
    },
    tryShift: function Parser_tryShift() {
      try {
        this.shift();
        return true;
      } catch (e) {
        if (e instanceof _util.MissingDataException) {
          throw e;
        }
        return false;
      }
    },
    getObj: function Parser_getObj(cipherTransform) {
      var buf1 = this.buf1;
      this.shift();
      if (buf1 instanceof _primitives.Cmd) {
        switch (buf1.cmd) {
          case 'BI':
            return this.makeInlineImage(cipherTransform);
          case '[':
            var array = [];
            while (!(0, _primitives.isCmd)(this.buf1, ']') && !(0, _primitives.isEOF)(this.buf1)) {
              array.push(this.getObj(cipherTransform));
            }
            if ((0, _primitives.isEOF)(this.buf1)) {
              if (!this.recoveryMode) {
                throw new _util.FormatError('End of file inside array');
              }
              return array;
            }
            this.shift();
            return array;
          case '<<':
            var dict = new _primitives.Dict(this.xref);
            while (!(0, _primitives.isCmd)(this.buf1, '>>') && !(0, _primitives.isEOF)(this.buf1)) {
              if (!(0, _primitives.isName)(this.buf1)) {
                (0, _util.info)('Malformed dictionary: key must be a name object');
                this.shift();
                continue;
              }
              var key = this.buf1.name;
              this.shift();
              if ((0, _primitives.isEOF)(this.buf1)) {
                break;
              }
              dict.set(key, this.getObj(cipherTransform));
            }
            if ((0, _primitives.isEOF)(this.buf1)) {
              if (!this.recoveryMode) {
                throw new _util.FormatError('End of file inside dictionary');
              }
              return dict;
            }
            if ((0, _primitives.isCmd)(this.buf2, 'stream')) {
              return this.allowStreams ? this.makeStream(dict, cipherTransform) : dict;
            }
            this.shift();
            return dict;
          default:
            return buf1;
        }
      }
      if ((0, _util.isInt)(buf1)) {
        var num = buf1;
        if ((0, _util.isInt)(this.buf1) && (0, _primitives.isCmd)(this.buf2, 'R')) {
          var ref = new _primitives.Ref(num, this.buf1);
          this.shift();
          this.shift();
          return ref;
        }
        return num;
      }
      if ((0, _util.isString)(buf1)) {
        var str = buf1;
        if (cipherTransform) {
          str = cipherTransform.decryptString(str);
        }
        return str;
      }
      return buf1;
    },
    findDefaultInlineStreamEnd: function Parser_findDefaultInlineStreamEnd(stream) {
      var E = 0x45,
          I = 0x49,
          SPACE = 0x20,
          LF = 0xA,
          CR = 0xD;
      var startPos = stream.pos,
          state = 0,
          ch,
          i,
          n,
          followingBytes;
      while ((ch = stream.getByte()) !== -1) {
        if (state === 0) {
          state = ch === E ? 1 : 0;
        } else if (state === 1) {
          state = ch === I ? 2 : 0;
        } else {
          (0, _util.assert)(state === 2);
          if (ch === SPACE || ch === LF || ch === CR) {
            n = 5;
            followingBytes = stream.peekBytes(n);
            for (i = 0; i < n; i++) {
              ch = followingBytes[i];
              if (ch !== LF && ch !== CR && (ch < SPACE || ch > 0x7F)) {
                state = 0;
                break;
              }
            }
            if (state === 2) {
              break;
            }
          } else {
            state = 0;
          }
        }
      }
      return stream.pos - 4 - startPos;
    },
    findDCTDecodeInlineStreamEnd: function Parser_findDCTDecodeInlineStreamEnd(stream) {
      var startPos = stream.pos,
          foundEOI = false,
          b,
          markerLength,
          length;
      while ((b = stream.getByte()) !== -1) {
        if (b !== 0xFF) {
          continue;
        }
        switch (stream.getByte()) {
          case 0x00:
            break;
          case 0xFF:
            stream.skip(-1);
            break;
          case 0xD9:
            foundEOI = true;
            break;
          case 0xC0:
          case 0xC1:
          case 0xC2:
          case 0xC3:
          case 0xC5:
          case 0xC6:
          case 0xC7:
          case 0xC9:
          case 0xCA:
          case 0xCB:
          case 0xCD:
          case 0xCE:
          case 0xCF:
          case 0xC4:
          case 0xCC:
          case 0xDA:
          case 0xDB:
          case 0xDC:
          case 0xDD:
          case 0xDE:
          case 0xDF:
          case 0xE0:
          case 0xE1:
          case 0xE2:
          case 0xE3:
          case 0xE4:
          case 0xE5:
          case 0xE6:
          case 0xE7:
          case 0xE8:
          case 0xE9:
          case 0xEA:
          case 0xEB:
          case 0xEC:
          case 0xED:
          case 0xEE:
          case 0xEF:
          case 0xFE:
            markerLength = stream.getUint16();
            if (markerLength > 2) {
              stream.skip(markerLength - 2);
            } else {
              stream.skip(-2);
            }
            break;
        }
        if (foundEOI) {
          break;
        }
      }
      length = stream.pos - startPos;
      if (b === -1) {
        (0, _util.warn)('Inline DCTDecode image stream: ' + 'EOI marker not found, searching for /EI/ instead.');
        stream.skip(-length);
        return this.findDefaultInlineStreamEnd(stream);
      }
      this.inlineStreamSkipEI(stream);
      return length;
    },
    findASCII85DecodeInlineStreamEnd: function Parser_findASCII85DecodeInlineStreamEnd(stream) {
      var TILDE = 0x7E,
          GT = 0x3E;
      var startPos = stream.pos,
          ch,
          length;
      while ((ch = stream.getByte()) !== -1) {
        if (ch === TILDE && stream.peekByte() === GT) {
          stream.skip();
          break;
        }
      }
      length = stream.pos - startPos;
      if (ch === -1) {
        (0, _util.warn)('Inline ASCII85Decode image stream: ' + 'EOD marker not found, searching for /EI/ instead.');
        stream.skip(-length);
        return this.findDefaultInlineStreamEnd(stream);
      }
      this.inlineStreamSkipEI(stream);
      return length;
    },
    findASCIIHexDecodeInlineStreamEnd: function Parser_findASCIIHexDecodeInlineStreamEnd(stream) {
      var GT = 0x3E;
      var startPos = stream.pos,
          ch,
          length;
      while ((ch = stream.getByte()) !== -1) {
        if (ch === GT) {
          break;
        }
      }
      length = stream.pos - startPos;
      if (ch === -1) {
        (0, _util.warn)('Inline ASCIIHexDecode image stream: ' + 'EOD marker not found, searching for /EI/ instead.');
        stream.skip(-length);
        return this.findDefaultInlineStreamEnd(stream);
      }
      this.inlineStreamSkipEI(stream);
      return length;
    },
    inlineStreamSkipEI: function Parser_inlineStreamSkipEI(stream) {
      var E = 0x45,
          I = 0x49;
      var state = 0,
          ch;
      while ((ch = stream.getByte()) !== -1) {
        if (state === 0) {
          state = ch === E ? 1 : 0;
        } else if (state === 1) {
          state = ch === I ? 2 : 0;
        } else if (state === 2) {
          break;
        }
      }
    },
    makeInlineImage: function Parser_makeInlineImage(cipherTransform) {
      var lexer = this.lexer;
      var stream = lexer.stream;
      var dict = new _primitives.Dict(this.xref);
      while (!(0, _primitives.isCmd)(this.buf1, 'ID') && !(0, _primitives.isEOF)(this.buf1)) {
        if (!(0, _primitives.isName)(this.buf1)) {
          throw new _util.FormatError('Dictionary key must be a name object');
        }
        var key = this.buf1.name;
        this.shift();
        if ((0, _primitives.isEOF)(this.buf1)) {
          break;
        }
        dict.set(key, this.getObj(cipherTransform));
      }
      var filter = dict.get('Filter', 'F'),
          filterName;
      if ((0, _primitives.isName)(filter)) {
        filterName = filter.name;
      } else if ((0, _util.isArray)(filter)) {
        var filterZero = this.xref.fetchIfRef(filter[0]);
        if ((0, _primitives.isName)(filterZero)) {
          filterName = filterZero.name;
        }
      }
      var startPos = stream.pos,
          length,
          i,
          ii;
      if (filterName === 'DCTDecode' || filterName === 'DCT') {
        length = this.findDCTDecodeInlineStreamEnd(stream);
      } else if (filterName === 'ASCII85Decode' || filterName === 'A85') {
        length = this.findASCII85DecodeInlineStreamEnd(stream);
      } else if (filterName === 'ASCIIHexDecode' || filterName === 'AHx') {
        length = this.findASCIIHexDecodeInlineStreamEnd(stream);
      } else {
        length = this.findDefaultInlineStreamEnd(stream);
      }
      var imageStream = stream.makeSubStream(startPos, length, dict);
      var adler32;
      if (length < MAX_LENGTH_TO_CACHE) {
        var imageBytes = imageStream.getBytes();
        imageStream.reset();
        var a = 1;
        var b = 0;
        for (i = 0, ii = imageBytes.length; i < ii; ++i) {
          a += imageBytes[i] & 0xff;
          b += a;
        }
        adler32 = b % 65521 << 16 | a % 65521;
        if (this.imageCache.adler32 === adler32) {
          this.buf2 = _primitives.Cmd.get('EI');
          this.shift();
          this.imageCache[adler32].reset();
          return this.imageCache[adler32];
        }
      }
      if (cipherTransform) {
        imageStream = cipherTransform.createStream(imageStream, length);
      }
      imageStream = this.filter(imageStream, dict, length);
      imageStream.dict = dict;
      if (adler32 !== undefined) {
        imageStream.cacheKey = 'inline_' + length + '_' + adler32;
        this.imageCache[adler32] = imageStream;
      }
      this.buf2 = _primitives.Cmd.get('EI');
      this.shift();
      return imageStream;
    },
    makeStream: function Parser_makeStream(dict, cipherTransform) {
      var lexer = this.lexer;
      var stream = lexer.stream;
      lexer.skipToNextLine();
      var pos = stream.pos - 1;
      var length = dict.get('Length');
      if (!(0, _util.isInt)(length)) {
        (0, _util.info)('Bad ' + length + ' attribute in stream');
        length = 0;
      }
      stream.pos = pos + length;
      lexer.nextChar();
      if (this.tryShift() && (0, _primitives.isCmd)(this.buf2, 'endstream')) {
        this.shift();
      } else {
        stream.pos = pos;
        var SCAN_BLOCK_SIZE = 2048;
        var ENDSTREAM_SIGNATURE_LENGTH = 9;
        var ENDSTREAM_SIGNATURE = [0x65, 0x6E, 0x64, 0x73, 0x74, 0x72, 0x65, 0x61, 0x6D];
        var skipped = 0,
            found = false,
            i,
            j;
        while (stream.pos < stream.end) {
          var scanBytes = stream.peekBytes(SCAN_BLOCK_SIZE);
          var scanLength = scanBytes.length - ENDSTREAM_SIGNATURE_LENGTH;
          if (scanLength <= 0) {
            break;
          }
          found = false;
          i = 0;
          while (i < scanLength) {
            j = 0;
            while (j < ENDSTREAM_SIGNATURE_LENGTH && scanBytes[i + j] === ENDSTREAM_SIGNATURE[j]) {
              j++;
            }
            if (j >= ENDSTREAM_SIGNATURE_LENGTH) {
              found = true;
              break;
            }
            i++;
          }
          if (found) {
            skipped += i;
            stream.pos += i;
            break;
          }
          skipped += scanLength;
          stream.pos += scanLength;
        }
        if (!found) {
          throw new _util.FormatError('Missing endstream');
        }
        length = skipped;
        lexer.nextChar();
        this.shift();
        this.shift();
      }
      this.shift();
      stream = stream.makeSubStream(pos, length, dict);
      if (cipherTransform) {
        stream = cipherTransform.createStream(stream, length);
      }
      stream = this.filter(stream, dict, length);
      stream.dict = dict;
      return stream;
    },
    filter: function Parser_filter(stream, dict, length) {
      var filter = dict.get('Filter', 'F');
      var params = dict.get('DecodeParms', 'DP');
      if ((0, _primitives.isName)(filter)) {
        if ((0, _util.isArray)(params)) {
          params = this.xref.fetchIfRef(params[0]);
        }
        return this.makeFilter(stream, filter.name, length, params);
      }
      var maybeLength = length;
      if ((0, _util.isArray)(filter)) {
        var filterArray = filter;
        var paramsArray = params;
        for (var i = 0, ii = filterArray.length; i < ii; ++i) {
          filter = this.xref.fetchIfRef(filterArray[i]);
          if (!(0, _primitives.isName)(filter)) {
            throw new _util.FormatError('Bad filter name: ' + filter);
          }
          params = null;
          if ((0, _util.isArray)(paramsArray) && i in paramsArray) {
            params = this.xref.fetchIfRef(paramsArray[i]);
          }
          stream = this.makeFilter(stream, filter.name, maybeLength, params);
          maybeLength = null;
        }
      }
      return stream;
    },
    makeFilter: function Parser_makeFilter(stream, name, maybeLength, params) {
      if (maybeLength === 0) {
        (0, _util.warn)('Empty "' + name + '" stream.');
        return new _stream.NullStream(stream);
      }
      try {
        var xrefStreamStats = this.xref.stats.streamTypes;
        if (name === 'FlateDecode' || name === 'Fl') {
          xrefStreamStats[_util.StreamType.FLATE] = true;
          if (params) {
            return new _stream.PredictorStream(new _stream.FlateStream(stream, maybeLength), maybeLength, params);
          }
          return new _stream.FlateStream(stream, maybeLength);
        }
        if (name === 'LZWDecode' || name === 'LZW') {
          xrefStreamStats[_util.StreamType.LZW] = true;
          var earlyChange = 1;
          if (params) {
            if (params.has('EarlyChange')) {
              earlyChange = params.get('EarlyChange');
            }
            return new _stream.PredictorStream(new _stream.LZWStream(stream, maybeLength, earlyChange), maybeLength, params);
          }
          return new _stream.LZWStream(stream, maybeLength, earlyChange);
        }
        if (name === 'DCTDecode' || name === 'DCT') {
          xrefStreamStats[_util.StreamType.DCT] = true;
          return new _stream.JpegStream(stream, maybeLength, stream.dict, params);
        }
        if (name === 'JPXDecode' || name === 'JPX') {
          xrefStreamStats[_util.StreamType.JPX] = true;
          return new _stream.JpxStream(stream, maybeLength, stream.dict, params);
        }
        if (name === 'ASCII85Decode' || name === 'A85') {
          xrefStreamStats[_util.StreamType.A85] = true;
          return new _stream.Ascii85Stream(stream, maybeLength);
        }
        if (name === 'ASCIIHexDecode' || name === 'AHx') {
          xrefStreamStats[_util.StreamType.AHX] = true;
          return new _stream.AsciiHexStream(stream, maybeLength);
        }
        if (name === 'CCITTFaxDecode' || name === 'CCF') {
          xrefStreamStats[_util.StreamType.CCF] = true;
          return new _stream.CCITTFaxStream(stream, maybeLength, params);
        }
        if (name === 'RunLengthDecode' || name === 'RL') {
          xrefStreamStats[_util.StreamType.RL] = true;
          return new _stream.RunLengthStream(stream, maybeLength);
        }
        if (name === 'JBIG2Decode') {
          xrefStreamStats[_util.StreamType.JBIG] = true;
          return new _stream.Jbig2Stream(stream, maybeLength, stream.dict, params);
        }
        (0, _util.warn)('filter "' + name + '" not supported yet');
        return stream;
      } catch (ex) {
        if (ex instanceof _util.MissingDataException) {
          throw ex;
        }
        (0, _util.warn)('Invalid stream: \"' + ex + '\"');
        return new _stream.NullStream(stream);
      }
    }
  };
  return Parser;
}();
var Lexer = function LexerClosure() {
  function Lexer(stream, knownCommands) {
    this.stream = stream;
    this.nextChar();
    this.strBuf = [];
    this.knownCommands = knownCommands;
  }
  var specialChars = [1, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 2, 0, 0, 2, 2, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  function toHexDigit(ch) {
    if (ch >= 0x30 && ch <= 0x39) {
      return ch & 0x0F;
    }
    if (ch >= 0x41 && ch <= 0x46 || ch >= 0x61 && ch <= 0x66) {
      return (ch & 0x0F) + 9;
    }
    return -1;
  }
  Lexer.prototype = {
    nextChar: function Lexer_nextChar() {
      return this.currentChar = this.stream.getByte();
    },
    peekChar: function Lexer_peekChar() {
      return this.stream.peekByte();
    },
    getNumber: function Lexer_getNumber() {
      var ch = this.currentChar;
      var eNotation = false;
      var divideBy = 0;
      var sign = 1;
      if (ch === 0x2D) {
        sign = -1;
        ch = this.nextChar();
        if (ch === 0x2D) {
          ch = this.nextChar();
        }
      } else if (ch === 0x2B) {
        ch = this.nextChar();
      }
      if (ch === 0x2E) {
        divideBy = 10;
        ch = this.nextChar();
      }
      if (ch === 0x0A || ch === 0x0D) {
        do {
          ch = this.nextChar();
        } while (ch === 0x0A || ch === 0x0D);
      }
      if (ch < 0x30 || ch > 0x39) {
        throw new _util.FormatError('Invalid number: ' + String.fromCharCode(ch) + ' (charCode ' + ch + ')');
      }
      var baseValue = ch - 0x30;
      var powerValue = 0;
      var powerValueSign = 1;
      while ((ch = this.nextChar()) >= 0) {
        if (0x30 <= ch && ch <= 0x39) {
          var currentDigit = ch - 0x30;
          if (eNotation) {
            powerValue = powerValue * 10 + currentDigit;
          } else {
            if (divideBy !== 0) {
              divideBy *= 10;
            }
            baseValue = baseValue * 10 + currentDigit;
          }
        } else if (ch === 0x2E) {
          if (divideBy === 0) {
            divideBy = 1;
          } else {
            break;
          }
        } else if (ch === 0x2D) {
          (0, _util.warn)('Badly formatted number');
        } else if (ch === 0x45 || ch === 0x65) {
          ch = this.peekChar();
          if (ch === 0x2B || ch === 0x2D) {
            powerValueSign = ch === 0x2D ? -1 : 1;
            this.nextChar();
          } else if (ch < 0x30 || ch > 0x39) {
            break;
          }
          eNotation = true;
        } else {
          break;
        }
      }
      if (divideBy !== 0) {
        baseValue /= divideBy;
      }
      if (eNotation) {
        baseValue *= Math.pow(10, powerValueSign * powerValue);
      }
      return sign * baseValue;
    },
    getString: function Lexer_getString() {
      var numParen = 1;
      var done = false;
      var strBuf = this.strBuf;
      strBuf.length = 0;
      var ch = this.nextChar();
      while (true) {
        var charBuffered = false;
        switch (ch | 0) {
          case -1:
            (0, _util.warn)('Unterminated string');
            done = true;
            break;
          case 0x28:
            ++numParen;
            strBuf.push('(');
            break;
          case 0x29:
            if (--numParen === 0) {
              this.nextChar();
              done = true;
            } else {
              strBuf.push(')');
            }
            break;
          case 0x5C:
            ch = this.nextChar();
            switch (ch) {
              case -1:
                (0, _util.warn)('Unterminated string');
                done = true;
                break;
              case 0x6E:
                strBuf.push('\n');
                break;
              case 0x72:
                strBuf.push('\r');
                break;
              case 0x74:
                strBuf.push('\t');
                break;
              case 0x62:
                strBuf.push('\b');
                break;
              case 0x66:
                strBuf.push('\f');
                break;
              case 0x5C:
              case 0x28:
              case 0x29:
                strBuf.push(String.fromCharCode(ch));
                break;
              case 0x30:
              case 0x31:
              case 0x32:
              case 0x33:
              case 0x34:
              case 0x35:
              case 0x36:
              case 0x37:
                var x = ch & 0x0F;
                ch = this.nextChar();
                charBuffered = true;
                if (ch >= 0x30 && ch <= 0x37) {
                  x = (x << 3) + (ch & 0x0F);
                  ch = this.nextChar();
                  if (ch >= 0x30 && ch <= 0x37) {
                    charBuffered = false;
                    x = (x << 3) + (ch & 0x0F);
                  }
                }
                strBuf.push(String.fromCharCode(x));
                break;
              case 0x0D:
                if (this.peekChar() === 0x0A) {
                  this.nextChar();
                }
                break;
              case 0x0A:
                break;
              default:
                strBuf.push(String.fromCharCode(ch));
                break;
            }
            break;
          default:
            strBuf.push(String.fromCharCode(ch));
            break;
        }
        if (done) {
          break;
        }
        if (!charBuffered) {
          ch = this.nextChar();
        }
      }
      return strBuf.join('');
    },
    getName: function Lexer_getName() {
      var ch, previousCh;
      var strBuf = this.strBuf;
      strBuf.length = 0;
      while ((ch = this.nextChar()) >= 0 && !specialChars[ch]) {
        if (ch === 0x23) {
          ch = this.nextChar();
          if (specialChars[ch]) {
            (0, _util.warn)('Lexer_getName: ' + 'NUMBER SIGN (#) should be followed by a hexadecimal number.');
            strBuf.push('#');
            break;
          }
          var x = toHexDigit(ch);
          if (x !== -1) {
            previousCh = ch;
            ch = this.nextChar();
            var x2 = toHexDigit(ch);
            if (x2 === -1) {
              (0, _util.warn)('Lexer_getName: Illegal digit (' + String.fromCharCode(ch) + ') in hexadecimal number.');
              strBuf.push('#', String.fromCharCode(previousCh));
              if (specialChars[ch]) {
                break;
              }
              strBuf.push(String.fromCharCode(ch));
              continue;
            }
            strBuf.push(String.fromCharCode(x << 4 | x2));
          } else {
            strBuf.push('#', String.fromCharCode(ch));
          }
        } else {
          strBuf.push(String.fromCharCode(ch));
        }
      }
      if (strBuf.length > 127) {
        (0, _util.warn)('name token is longer than allowed by the spec: ' + strBuf.length);
      }
      return _primitives.Name.get(strBuf.join(''));
    },
    getHexString: function Lexer_getHexString() {
      var strBuf = this.strBuf;
      strBuf.length = 0;
      var ch = this.currentChar;
      var isFirstHex = true;
      var firstDigit;
      var secondDigit;
      while (true) {
        if (ch < 0) {
          (0, _util.warn)('Unterminated hex string');
          break;
        } else if (ch === 0x3E) {
          this.nextChar();
          break;
        } else if (specialChars[ch] === 1) {
          ch = this.nextChar();
          continue;
        } else {
          if (isFirstHex) {
            firstDigit = toHexDigit(ch);
            if (firstDigit === -1) {
              (0, _util.warn)('Ignoring invalid character "' + ch + '" in hex string');
              ch = this.nextChar();
              continue;
            }
          } else {
            secondDigit = toHexDigit(ch);
            if (secondDigit === -1) {
              (0, _util.warn)('Ignoring invalid character "' + ch + '" in hex string');
              ch = this.nextChar();
              continue;
            }
            strBuf.push(String.fromCharCode(firstDigit << 4 | secondDigit));
          }
          isFirstHex = !isFirstHex;
          ch = this.nextChar();
        }
      }
      return strBuf.join('');
    },
    getObj: function Lexer_getObj() {
      var comment = false;
      var ch = this.currentChar;
      while (true) {
        if (ch < 0) {
          return _primitives.EOF;
        }
        if (comment) {
          if (ch === 0x0A || ch === 0x0D) {
            comment = false;
          }
        } else if (ch === 0x25) {
          comment = true;
        } else if (specialChars[ch] !== 1) {
          break;
        }
        ch = this.nextChar();
      }
      switch (ch | 0) {
        case 0x30:
        case 0x31:
        case 0x32:
        case 0x33:
        case 0x34:
        case 0x35:
        case 0x36:
        case 0x37:
        case 0x38:
        case 0x39:
        case 0x2B:
        case 0x2D:
        case 0x2E:
          return this.getNumber();
        case 0x28:
          return this.getString();
        case 0x2F:
          return this.getName();
        case 0x5B:
          this.nextChar();
          return _primitives.Cmd.get('[');
        case 0x5D:
          this.nextChar();
          return _primitives.Cmd.get(']');
        case 0x3C:
          ch = this.nextChar();
          if (ch === 0x3C) {
            this.nextChar();
            return _primitives.Cmd.get('<<');
          }
          return this.getHexString();
        case 0x3E:
          ch = this.nextChar();
          if (ch === 0x3E) {
            this.nextChar();
            return _primitives.Cmd.get('>>');
          }
          return _primitives.Cmd.get('>');
        case 0x7B:
          this.nextChar();
          return _primitives.Cmd.get('{');
        case 0x7D:
          this.nextChar();
          return _primitives.Cmd.get('}');
        case 0x29:
          this.nextChar();
          throw new _util.FormatError('Illegal character: ' + ch);
      }
      var str = String.fromCharCode(ch);
      var knownCommands = this.knownCommands;
      var knownCommandFound = knownCommands && knownCommands[str] !== undefined;
      while ((ch = this.nextChar()) >= 0 && !specialChars[ch]) {
        var possibleCommand = str + String.fromCharCode(ch);
        if (knownCommandFound && knownCommands[possibleCommand] === undefined) {
          break;
        }
        if (str.length === 128) {
          throw new _util.FormatError('Command token too long: ' + str.length);
        }
        str = possibleCommand;
        knownCommandFound = knownCommands && knownCommands[str] !== undefined;
      }
      if (str === 'true') {
        return true;
      }
      if (str === 'false') {
        return false;
      }
      if (str === 'null') {
        return null;
      }
      return _primitives.Cmd.get(str);
    },
    skipToNextLine: function Lexer_skipToNextLine() {
      var ch = this.currentChar;
      while (ch >= 0) {
        if (ch === 0x0D) {
          ch = this.nextChar();
          if (ch === 0x0A) {
            this.nextChar();
          }
          break;
        } else if (ch === 0x0A) {
          this.nextChar();
          break;
        }
        ch = this.nextChar();
      }
    }
  };
  return Lexer;
}();
var Linearization = {
  create: function LinearizationCreate(stream) {
    function getInt(name, allowZeroValue) {
      var obj = linDict.get(name);
      if ((0, _util.isInt)(obj) && (allowZeroValue ? obj >= 0 : obj > 0)) {
        return obj;
      }
      throw new Error('The "' + name + '" parameter in the linearization ' + 'dictionary is invalid.');
    }
    function getHints() {
      var hints = linDict.get('H'),
          hintsLength,
          item;
      if ((0, _util.isArray)(hints) && ((hintsLength = hints.length) === 2 || hintsLength === 4)) {
        for (var index = 0; index < hintsLength; index++) {
          if (!((0, _util.isInt)(item = hints[index]) && item > 0)) {
            throw new Error('Hint (' + index + ') in the linearization dictionary is invalid.');
          }
        }
        return hints;
      }
      throw new Error('Hint array in the linearization dictionary is invalid.');
    }
    var parser = new Parser(new Lexer(stream), false, null);
    var obj1 = parser.getObj();
    var obj2 = parser.getObj();
    var obj3 = parser.getObj();
    var linDict = parser.getObj();
    var obj, length;
    if (!((0, _util.isInt)(obj1) && (0, _util.isInt)(obj2) && (0, _primitives.isCmd)(obj3, 'obj') && (0, _primitives.isDict)(linDict) && (0, _util.isNum)(obj = linDict.get('Linearized')) && obj > 0)) {
      return null;
    } else if ((length = getInt('L')) !== stream.length) {
      throw new Error('The "L" parameter in the linearization dictionary ' + 'does not equal the stream length.');
    }
    return {
      length: length,
      hints: getHints(),
      objectNumberFirst: getInt('O'),
      endFirst: getInt('E'),
      numPages: getInt('N'),
      mainXRefEntriesOffset: getInt('T'),
      pageFirst: linDict.has('P') ? getInt('P', true) : 0
    };
  }
};
exports.Lexer = Lexer;
exports.Linearization = Linearization;
exports.Parser = Parser;

/***/ }),
/* 6 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PostScriptCompiler = exports.PostScriptEvaluator = exports.PDFFunction = exports.isPDFFunction = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _util = __w_pdfjs_require__(0);

var _primitives = __w_pdfjs_require__(1);

var _ps_parser = __w_pdfjs_require__(33);

var PDFFunction = function PDFFunctionClosure() {
  var CONSTRUCT_SAMPLED = 0;
  var CONSTRUCT_INTERPOLATED = 2;
  var CONSTRUCT_STICHED = 3;
  var CONSTRUCT_POSTSCRIPT = 4;
  return {
    getSampleArray: function PDFFunction_getSampleArray(size, outputSize, bps, str) {
      var i, ii;
      var length = 1;
      for (i = 0, ii = size.length; i < ii; i++) {
        length *= size[i];
      }
      length *= outputSize;
      var array = new Array(length);
      var codeSize = 0;
      var codeBuf = 0;
      var sampleMul = 1.0 / (Math.pow(2.0, bps) - 1);
      var strBytes = str.getBytes((length * bps + 7) / 8);
      var strIdx = 0;
      for (i = 0; i < length; i++) {
        while (codeSize < bps) {
          codeBuf <<= 8;
          codeBuf |= strBytes[strIdx++];
          codeSize += 8;
        }
        codeSize -= bps;
        array[i] = (codeBuf >> codeSize) * sampleMul;
        codeBuf &= (1 << codeSize) - 1;
      }
      return array;
    },
    getIR: function PDFFunction_getIR(xref, fn) {
      var dict = fn.dict;
      if (!dict) {
        dict = fn;
      }
      var types = [this.constructSampled, null, this.constructInterpolated, this.constructStiched, this.constructPostScript];
      var typeNum = dict.get('FunctionType');
      var typeFn = types[typeNum];
      if (!typeFn) {
        throw new _util.FormatError('Unknown type of function');
      }
      return typeFn.call(this, fn, dict, xref);
    },
    fromIR: function PDFFunction_fromIR(IR) {
      var type = IR[0];
      switch (type) {
        case CONSTRUCT_SAMPLED:
          return this.constructSampledFromIR(IR);
        case CONSTRUCT_INTERPOLATED:
          return this.constructInterpolatedFromIR(IR);
        case CONSTRUCT_STICHED:
          return this.constructStichedFromIR(IR);
        default:
          return this.constructPostScriptFromIR(IR);
      }
    },
    parse: function PDFFunction_parse(xref, fn) {
      var IR = this.getIR(xref, fn);
      return this.fromIR(IR);
    },
    parseArray: function PDFFunction_parseArray(xref, fnObj) {
      if (!(0, _util.isArray)(fnObj)) {
        return this.parse(xref, fnObj);
      }
      var fnArray = [];
      for (var j = 0, jj = fnObj.length; j < jj; j++) {
        var obj = xref.fetchIfRef(fnObj[j]);
        fnArray.push(PDFFunction.parse(xref, obj));
      }
      return function (src, srcOffset, dest, destOffset) {
        for (var i = 0, ii = fnArray.length; i < ii; i++) {
          fnArray[i](src, srcOffset, dest, destOffset + i);
        }
      };
    },
    constructSampled: function PDFFunction_constructSampled(str, dict) {
      function toMultiArray(arr) {
        var inputLength = arr.length;
        var out = [];
        var index = 0;
        for (var i = 0; i < inputLength; i += 2) {
          out[index] = [arr[i], arr[i + 1]];
          ++index;
        }
        return out;
      }
      var domain = dict.getArray('Domain');
      var range = dict.getArray('Range');
      if (!domain || !range) {
        throw new _util.FormatError('No domain or range');
      }
      var inputSize = domain.length / 2;
      var outputSize = range.length / 2;
      domain = toMultiArray(domain);
      range = toMultiArray(range);
      var size = dict.get('Size');
      var bps = dict.get('BitsPerSample');
      var order = dict.get('Order') || 1;
      if (order !== 1) {
        (0, _util.info)('No support for cubic spline interpolation: ' + order);
      }
      var encode = dict.getArray('Encode');
      if (!encode) {
        encode = [];
        for (var i = 0; i < inputSize; ++i) {
          encode.push(0);
          encode.push(size[i] - 1);
        }
      }
      encode = toMultiArray(encode);
      var decode = dict.getArray('Decode');
      if (!decode) {
        decode = range;
      } else {
        decode = toMultiArray(decode);
      }
      var samples = this.getSampleArray(size, outputSize, bps, str);
      return [CONSTRUCT_SAMPLED, inputSize, domain, encode, decode, samples, size, outputSize, Math.pow(2, bps) - 1, range];
    },
    constructSampledFromIR: function PDFFunction_constructSampledFromIR(IR) {
      function interpolate(x, xmin, xmax, ymin, ymax) {
        return ymin + (x - xmin) * ((ymax - ymin) / (xmax - xmin));
      }
      return function constructSampledFromIRResult(src, srcOffset, dest, destOffset) {
        var m = IR[1];
        var domain = IR[2];
        var encode = IR[3];
        var decode = IR[4];
        var samples = IR[5];
        var size = IR[6];
        var n = IR[7];
        var range = IR[9];
        var cubeVertices = 1 << m;
        var cubeN = new Float64Array(cubeVertices);
        var cubeVertex = new Uint32Array(cubeVertices);
        var i, j;
        for (j = 0; j < cubeVertices; j++) {
          cubeN[j] = 1;
        }
        var k = n,
            pos = 1;
        for (i = 0; i < m; ++i) {
          var domain_2i = domain[i][0];
          var domain_2i_1 = domain[i][1];
          var xi = Math.min(Math.max(src[srcOffset + i], domain_2i), domain_2i_1);
          var e = interpolate(xi, domain_2i, domain_2i_1, encode[i][0], encode[i][1]);
          var size_i = size[i];
          e = Math.min(Math.max(e, 0), size_i - 1);
          var e0 = e < size_i - 1 ? Math.floor(e) : e - 1;
          var n0 = e0 + 1 - e;
          var n1 = e - e0;
          var offset0 = e0 * k;
          var offset1 = offset0 + k;
          for (j = 0; j < cubeVertices; j++) {
            if (j & pos) {
              cubeN[j] *= n1;
              cubeVertex[j] += offset1;
            } else {
              cubeN[j] *= n0;
              cubeVertex[j] += offset0;
            }
          }
          k *= size_i;
          pos <<= 1;
        }
        for (j = 0; j < n; ++j) {
          var rj = 0;
          for (i = 0; i < cubeVertices; i++) {
            rj += samples[cubeVertex[i] + j] * cubeN[i];
          }
          rj = interpolate(rj, 0, 1, decode[j][0], decode[j][1]);
          dest[destOffset + j] = Math.min(Math.max(rj, range[j][0]), range[j][1]);
        }
      };
    },
    constructInterpolated: function PDFFunction_constructInterpolated(str, dict) {
      var c0 = dict.getArray('C0') || [0];
      var c1 = dict.getArray('C1') || [1];
      var n = dict.get('N');
      if (!(0, _util.isArray)(c0) || !(0, _util.isArray)(c1)) {
        throw new _util.FormatError('Illegal dictionary for interpolated function');
      }
      var length = c0.length;
      var diff = [];
      for (var i = 0; i < length; ++i) {
        diff.push(c1[i] - c0[i]);
      }
      return [CONSTRUCT_INTERPOLATED, c0, diff, n];
    },
    constructInterpolatedFromIR: function PDFFunction_constructInterpolatedFromIR(IR) {
      var c0 = IR[1];
      var diff = IR[2];
      var n = IR[3];
      var length = diff.length;
      return function constructInterpolatedFromIRResult(src, srcOffset, dest, destOffset) {
        var x = n === 1 ? src[srcOffset] : Math.pow(src[srcOffset], n);
        for (var j = 0; j < length; ++j) {
          dest[destOffset + j] = c0[j] + x * diff[j];
        }
      };
    },
    constructStiched: function PDFFunction_constructStiched(fn, dict, xref) {
      var domain = dict.getArray('Domain');
      if (!domain) {
        throw new _util.FormatError('No domain');
      }
      var inputSize = domain.length / 2;
      if (inputSize !== 1) {
        throw new _util.FormatError('Bad domain for stiched function');
      }
      var fnRefs = dict.get('Functions');
      var fns = [];
      for (var i = 0, ii = fnRefs.length; i < ii; ++i) {
        fns.push(PDFFunction.getIR(xref, xref.fetchIfRef(fnRefs[i])));
      }
      var bounds = dict.getArray('Bounds');
      var encode = dict.getArray('Encode');
      return [CONSTRUCT_STICHED, domain, bounds, encode, fns];
    },
    constructStichedFromIR: function PDFFunction_constructStichedFromIR(IR) {
      var domain = IR[1];
      var bounds = IR[2];
      var encode = IR[3];
      var fnsIR = IR[4];
      var fns = [];
      var tmpBuf = new Float32Array(1);
      for (var i = 0, ii = fnsIR.length; i < ii; i++) {
        fns.push(PDFFunction.fromIR(fnsIR[i]));
      }
      return function constructStichedFromIRResult(src, srcOffset, dest, destOffset) {
        var clip = function constructStichedFromIRClip(v, min, max) {
          if (v > max) {
            v = max;
          } else if (v < min) {
            v = min;
          }
          return v;
        };
        var v = clip(src[srcOffset], domain[0], domain[1]);
        for (var i = 0, ii = bounds.length; i < ii; ++i) {
          if (v < bounds[i]) {
            break;
          }
        }
        var dmin = domain[0];
        if (i > 0) {
          dmin = bounds[i - 1];
        }
        var dmax = domain[1];
        if (i < bounds.length) {
          dmax = bounds[i];
        }
        var rmin = encode[2 * i];
        var rmax = encode[2 * i + 1];
        tmpBuf[0] = dmin === dmax ? rmin : rmin + (v - dmin) * (rmax - rmin) / (dmax - dmin);
        fns[i](tmpBuf, 0, dest, destOffset);
      };
    },
    constructPostScript: function PDFFunction_constructPostScript(fn, dict, xref) {
      var domain = dict.getArray('Domain');
      var range = dict.getArray('Range');
      if (!domain) {
        throw new _util.FormatError('No domain.');
      }
      if (!range) {
        throw new _util.FormatError('No range.');
      }
      var lexer = new _ps_parser.PostScriptLexer(fn);
      var parser = new _ps_parser.PostScriptParser(lexer);
      var code = parser.parse();
      return [CONSTRUCT_POSTSCRIPT, domain, range, code];
    },
    constructPostScriptFromIR: function PDFFunction_constructPostScriptFromIR(IR) {
      var domain = IR[1];
      var range = IR[2];
      var code = IR[3];
      var compiled = new PostScriptCompiler().compile(code, domain, range);
      if (compiled) {
        return new Function('src', 'srcOffset', 'dest', 'destOffset', compiled);
      }
      (0, _util.info)('Unable to compile PS function');
      var numOutputs = range.length >> 1;
      var numInputs = domain.length >> 1;
      var evaluator = new PostScriptEvaluator(code);
      var cache = Object.create(null);
      var MAX_CACHE_SIZE = 2048 * 4;
      var cache_available = MAX_CACHE_SIZE;
      var tmpBuf = new Float32Array(numInputs);
      return function constructPostScriptFromIRResult(src, srcOffset, dest, destOffset) {
        var i, value;
        var key = '';
        var input = tmpBuf;
        for (i = 0; i < numInputs; i++) {
          value = src[srcOffset + i];
          input[i] = value;
          key += value + '_';
        }
        var cachedValue = cache[key];
        if (cachedValue !== undefined) {
          dest.set(cachedValue, destOffset);
          return;
        }
        var output = new Float32Array(numOutputs);
        var stack = evaluator.execute(input);
        var stackIndex = stack.length - numOutputs;
        for (i = 0; i < numOutputs; i++) {
          value = stack[stackIndex + i];
          var bound = range[i * 2];
          if (value < bound) {
            value = bound;
          } else {
            bound = range[i * 2 + 1];
            if (value > bound) {
              value = bound;
            }
          }
          output[i] = value;
        }
        if (cache_available > 0) {
          cache_available--;
          cache[key] = output;
        }
        dest.set(output, destOffset);
      };
    }
  };
}();
function isPDFFunction(v) {
  var fnDict;
  if ((typeof v === 'undefined' ? 'undefined' : _typeof(v)) !== 'object') {
    return false;
  } else if ((0, _primitives.isDict)(v)) {
    fnDict = v;
  } else if ((0, _primitives.isStream)(v)) {
    fnDict = v.dict;
  } else {
    return false;
  }
  return fnDict.has('FunctionType');
}
var PostScriptStack = function PostScriptStackClosure() {
  var MAX_STACK_SIZE = 100;
  function PostScriptStack(initialStack) {
    this.stack = !initialStack ? [] : Array.prototype.slice.call(initialStack, 0);
  }
  PostScriptStack.prototype = {
    push: function PostScriptStack_push(value) {
      if (this.stack.length >= MAX_STACK_SIZE) {
        throw new Error('PostScript function stack overflow.');
      }
      this.stack.push(value);
    },
    pop: function PostScriptStack_pop() {
      if (this.stack.length <= 0) {
        throw new Error('PostScript function stack underflow.');
      }
      return this.stack.pop();
    },
    copy: function PostScriptStack_copy(n) {
      if (this.stack.length + n >= MAX_STACK_SIZE) {
        throw new Error('PostScript function stack overflow.');
      }
      var stack = this.stack;
      for (var i = stack.length - n, j = n - 1; j >= 0; j--, i++) {
        stack.push(stack[i]);
      }
    },
    index: function PostScriptStack_index(n) {
      this.push(this.stack[this.stack.length - n - 1]);
    },
    roll: function PostScriptStack_roll(n, p) {
      var stack = this.stack;
      var l = stack.length - n;
      var r = stack.length - 1,
          c = l + (p - Math.floor(p / n) * n),
          i,
          j,
          t;
      for (i = l, j = r; i < j; i++, j--) {
        t = stack[i];
        stack[i] = stack[j];
        stack[j] = t;
      }
      for (i = l, j = c - 1; i < j; i++, j--) {
        t = stack[i];
        stack[i] = stack[j];
        stack[j] = t;
      }
      for (i = c, j = r; i < j; i++, j--) {
        t = stack[i];
        stack[i] = stack[j];
        stack[j] = t;
      }
    }
  };
  return PostScriptStack;
}();
var PostScriptEvaluator = function PostScriptEvaluatorClosure() {
  function PostScriptEvaluator(operators) {
    this.operators = operators;
  }
  PostScriptEvaluator.prototype = {
    execute: function PostScriptEvaluator_execute(initialStack) {
      var stack = new PostScriptStack(initialStack);
      var counter = 0;
      var operators = this.operators;
      var length = operators.length;
      var operator, a, b;
      while (counter < length) {
        operator = operators[counter++];
        if (typeof operator === 'number') {
          stack.push(operator);
          continue;
        }
        switch (operator) {
          case 'jz':
            b = stack.pop();
            a = stack.pop();
            if (!a) {
              counter = b;
            }
            break;
          case 'j':
            a = stack.pop();
            counter = a;
            break;
          case 'abs':
            a = stack.pop();
            stack.push(Math.abs(a));
            break;
          case 'add':
            b = stack.pop();
            a = stack.pop();
            stack.push(a + b);
            break;
          case 'and':
            b = stack.pop();
            a = stack.pop();
            if ((0, _util.isBool)(a) && (0, _util.isBool)(b)) {
              stack.push(a && b);
            } else {
              stack.push(a & b);
            }
            break;
          case 'atan':
            a = stack.pop();
            stack.push(Math.atan(a));
            break;
          case 'bitshift':
            b = stack.pop();
            a = stack.pop();
            if (a > 0) {
              stack.push(a << b);
            } else {
              stack.push(a >> b);
            }
            break;
          case 'ceiling':
            a = stack.pop();
            stack.push(Math.ceil(a));
            break;
          case 'copy':
            a = stack.pop();
            stack.copy(a);
            break;
          case 'cos':
            a = stack.pop();
            stack.push(Math.cos(a));
            break;
          case 'cvi':
            a = stack.pop() | 0;
            stack.push(a);
            break;
          case 'cvr':
            break;
          case 'div':
            b = stack.pop();
            a = stack.pop();
            stack.push(a / b);
            break;
          case 'dup':
            stack.copy(1);
            break;
          case 'eq':
            b = stack.pop();
            a = stack.pop();
            stack.push(a === b);
            break;
          case 'exch':
            stack.roll(2, 1);
            break;
          case 'exp':
            b = stack.pop();
            a = stack.pop();
            stack.push(Math.pow(a, b));
            break;
          case 'false':
            stack.push(false);
            break;
          case 'floor':
            a = stack.pop();
            stack.push(Math.floor(a));
            break;
          case 'ge':
            b = stack.pop();
            a = stack.pop();
            stack.push(a >= b);
            break;
          case 'gt':
            b = stack.pop();
            a = stack.pop();
            stack.push(a > b);
            break;
          case 'idiv':
            b = stack.pop();
            a = stack.pop();
            stack.push(a / b | 0);
            break;
          case 'index':
            a = stack.pop();
            stack.index(a);
            break;
          case 'le':
            b = stack.pop();
            a = stack.pop();
            stack.push(a <= b);
            break;
          case 'ln':
            a = stack.pop();
            stack.push(Math.log(a));
            break;
          case 'log':
            a = stack.pop();
            stack.push(Math.log(a) / Math.LN10);
            break;
          case 'lt':
            b = stack.pop();
            a = stack.pop();
            stack.push(a < b);
            break;
          case 'mod':
            b = stack.pop();
            a = stack.pop();
            stack.push(a % b);
            break;
          case 'mul':
            b = stack.pop();
            a = stack.pop();
            stack.push(a * b);
            break;
          case 'ne':
            b = stack.pop();
            a = stack.pop();
            stack.push(a !== b);
            break;
          case 'neg':
            a = stack.pop();
            stack.push(-a);
            break;
          case 'not':
            a = stack.pop();
            if ((0, _util.isBool)(a)) {
              stack.push(!a);
            } else {
              stack.push(~a);
            }
            break;
          case 'or':
            b = stack.pop();
            a = stack.pop();
            if ((0, _util.isBool)(a) && (0, _util.isBool)(b)) {
              stack.push(a || b);
            } else {
              stack.push(a | b);
            }
            break;
          case 'pop':
            stack.pop();
            break;
          case 'roll':
            b = stack.pop();
            a = stack.pop();
            stack.roll(a, b);
            break;
          case 'round':
            a = stack.pop();
            stack.push(Math.round(a));
            break;
          case 'sin':
            a = stack.pop();
            stack.push(Math.sin(a));
            break;
          case 'sqrt':
            a = stack.pop();
            stack.push(Math.sqrt(a));
            break;
          case 'sub':
            b = stack.pop();
            a = stack.pop();
            stack.push(a - b);
            break;
          case 'true':
            stack.push(true);
            break;
          case 'truncate':
            a = stack.pop();
            a = a < 0 ? Math.ceil(a) : Math.floor(a);
            stack.push(a);
            break;
          case 'xor':
            b = stack.pop();
            a = stack.pop();
            if ((0, _util.isBool)(a) && (0, _util.isBool)(b)) {
              stack.push(a !== b);
            } else {
              stack.push(a ^ b);
            }
            break;
          default:
            throw new _util.FormatError('Unknown operator ' + operator);
        }
      }
      return stack.stack;
    }
  };
  return PostScriptEvaluator;
}();
var PostScriptCompiler = function PostScriptCompilerClosure() {
  function AstNode(type) {
    this.type = type;
  }
  AstNode.prototype.visit = function (visitor) {
    throw new Error('abstract method');
  };
  function AstArgument(index, min, max) {
    AstNode.call(this, 'args');
    this.index = index;
    this.min = min;
    this.max = max;
  }
  AstArgument.prototype = Object.create(AstNode.prototype);
  AstArgument.prototype.visit = function (visitor) {
    visitor.visitArgument(this);
  };
  function AstLiteral(number) {
    AstNode.call(this, 'literal');
    this.number = number;
    this.min = number;
    this.max = number;
  }
  AstLiteral.prototype = Object.create(AstNode.prototype);
  AstLiteral.prototype.visit = function (visitor) {
    visitor.visitLiteral(this);
  };
  function AstBinaryOperation(op, arg1, arg2, min, max) {
    AstNode.call(this, 'binary');
    this.op = op;
    this.arg1 = arg1;
    this.arg2 = arg2;
    this.min = min;
    this.max = max;
  }
  AstBinaryOperation.prototype = Object.create(AstNode.prototype);
  AstBinaryOperation.prototype.visit = function (visitor) {
    visitor.visitBinaryOperation(this);
  };
  function AstMin(arg, max) {
    AstNode.call(this, 'max');
    this.arg = arg;
    this.min = arg.min;
    this.max = max;
  }
  AstMin.prototype = Object.create(AstNode.prototype);
  AstMin.prototype.visit = function (visitor) {
    visitor.visitMin(this);
  };
  function AstVariable(index, min, max) {
    AstNode.call(this, 'var');
    this.index = index;
    this.min = min;
    this.max = max;
  }
  AstVariable.prototype = Object.create(AstNode.prototype);
  AstVariable.prototype.visit = function (visitor) {
    visitor.visitVariable(this);
  };
  function AstVariableDefinition(variable, arg) {
    AstNode.call(this, 'definition');
    this.variable = variable;
    this.arg = arg;
  }
  AstVariableDefinition.prototype = Object.create(AstNode.prototype);
  AstVariableDefinition.prototype.visit = function (visitor) {
    visitor.visitVariableDefinition(this);
  };
  function ExpressionBuilderVisitor() {
    this.parts = [];
  }
  ExpressionBuilderVisitor.prototype = {
    visitArgument: function visitArgument(arg) {
      this.parts.push('Math.max(', arg.min, ', Math.min(', arg.max, ', src[srcOffset + ', arg.index, ']))');
    },
    visitVariable: function visitVariable(variable) {
      this.parts.push('v', variable.index);
    },
    visitLiteral: function visitLiteral(literal) {
      this.parts.push(literal.number);
    },
    visitBinaryOperation: function visitBinaryOperation(operation) {
      this.parts.push('(');
      operation.arg1.visit(this);
      this.parts.push(' ', operation.op, ' ');
      operation.arg2.visit(this);
      this.parts.push(')');
    },
    visitVariableDefinition: function visitVariableDefinition(definition) {
      this.parts.push('var ');
      definition.variable.visit(this);
      this.parts.push(' = ');
      definition.arg.visit(this);
      this.parts.push(';');
    },
    visitMin: function visitMin(max) {
      this.parts.push('Math.min(');
      max.arg.visit(this);
      this.parts.push(', ', max.max, ')');
    },
    toString: function toString() {
      return this.parts.join('');
    }
  };
  function buildAddOperation(num1, num2) {
    if (num2.type === 'literal' && num2.number === 0) {
      return num1;
    }
    if (num1.type === 'literal' && num1.number === 0) {
      return num2;
    }
    if (num2.type === 'literal' && num1.type === 'literal') {
      return new AstLiteral(num1.number + num2.number);
    }
    return new AstBinaryOperation('+', num1, num2, num1.min + num2.min, num1.max + num2.max);
  }
  function buildMulOperation(num1, num2) {
    if (num2.type === 'literal') {
      if (num2.number === 0) {
        return new AstLiteral(0);
      } else if (num2.number === 1) {
        return num1;
      } else if (num1.type === 'literal') {
        return new AstLiteral(num1.number * num2.number);
      }
    }
    if (num1.type === 'literal') {
      if (num1.number === 0) {
        return new AstLiteral(0);
      } else if (num1.number === 1) {
        return num2;
      }
    }
    var min = Math.min(num1.min * num2.min, num1.min * num2.max, num1.max * num2.min, num1.max * num2.max);
    var max = Math.max(num1.min * num2.min, num1.min * num2.max, num1.max * num2.min, num1.max * num2.max);
    return new AstBinaryOperation('*', num1, num2, min, max);
  }
  function buildSubOperation(num1, num2) {
    if (num2.type === 'literal') {
      if (num2.number === 0) {
        return num1;
      } else if (num1.type === 'literal') {
        return new AstLiteral(num1.number - num2.number);
      }
    }
    if (num2.type === 'binary' && num2.op === '-' && num1.type === 'literal' && num1.number === 1 && num2.arg1.type === 'literal' && num2.arg1.number === 1) {
      return num2.arg2;
    }
    return new AstBinaryOperation('-', num1, num2, num1.min - num2.max, num1.max - num2.min);
  }
  function buildMinOperation(num1, max) {
    if (num1.min >= max) {
      return new AstLiteral(max);
    } else if (num1.max <= max) {
      return num1;
    }
    return new AstMin(num1, max);
  }
  function PostScriptCompiler() {}
  PostScriptCompiler.prototype = {
    compile: function PostScriptCompiler_compile(code, domain, range) {
      var stack = [];
      var i, ii;
      var instructions = [];
      var inputSize = domain.length >> 1,
          outputSize = range.length >> 1;
      var lastRegister = 0;
      var n, j;
      var num1, num2, ast1, ast2, tmpVar, item;
      for (i = 0; i < inputSize; i++) {
        stack.push(new AstArgument(i, domain[i * 2], domain[i * 2 + 1]));
      }
      for (i = 0, ii = code.length; i < ii; i++) {
        item = code[i];
        if (typeof item === 'number') {
          stack.push(new AstLiteral(item));
          continue;
        }
        switch (item) {
          case 'add':
            if (stack.length < 2) {
              return null;
            }
            num2 = stack.pop();
            num1 = stack.pop();
            stack.push(buildAddOperation(num1, num2));
            break;
          case 'cvr':
            if (stack.length < 1) {
              return null;
            }
            break;
          case 'mul':
            if (stack.length < 2) {
              return null;
            }
            num2 = stack.pop();
            num1 = stack.pop();
            stack.push(buildMulOperation(num1, num2));
            break;
          case 'sub':
            if (stack.length < 2) {
              return null;
            }
            num2 = stack.pop();
            num1 = stack.pop();
            stack.push(buildSubOperation(num1, num2));
            break;
          case 'exch':
            if (stack.length < 2) {
              return null;
            }
            ast1 = stack.pop();
            ast2 = stack.pop();
            stack.push(ast1, ast2);
            break;
          case 'pop':
            if (stack.length < 1) {
              return null;
            }
            stack.pop();
            break;
          case 'index':
            if (stack.length < 1) {
              return null;
            }
            num1 = stack.pop();
            if (num1.type !== 'literal') {
              return null;
            }
            n = num1.number;
            if (n < 0 || (n | 0) !== n || stack.length < n) {
              return null;
            }
            ast1 = stack[stack.length - n - 1];
            if (ast1.type === 'literal' || ast1.type === 'var') {
              stack.push(ast1);
              break;
            }
            tmpVar = new AstVariable(lastRegister++, ast1.min, ast1.max);
            stack[stack.length - n - 1] = tmpVar;
            stack.push(tmpVar);
            instructions.push(new AstVariableDefinition(tmpVar, ast1));
            break;
          case 'dup':
            if (stack.length < 1) {
              return null;
            }
            if (typeof code[i + 1] === 'number' && code[i + 2] === 'gt' && code[i + 3] === i + 7 && code[i + 4] === 'jz' && code[i + 5] === 'pop' && code[i + 6] === code[i + 1]) {
              num1 = stack.pop();
              stack.push(buildMinOperation(num1, code[i + 1]));
              i += 6;
              break;
            }
            ast1 = stack[stack.length - 1];
            if (ast1.type === 'literal' || ast1.type === 'var') {
              stack.push(ast1);
              break;
            }
            tmpVar = new AstVariable(lastRegister++, ast1.min, ast1.max);
            stack[stack.length - 1] = tmpVar;
            stack.push(tmpVar);
            instructions.push(new AstVariableDefinition(tmpVar, ast1));
            break;
          case 'roll':
            if (stack.length < 2) {
              return null;
            }
            num2 = stack.pop();
            num1 = stack.pop();
            if (num2.type !== 'literal' || num1.type !== 'literal') {
              return null;
            }
            j = num2.number;
            n = num1.number;
            if (n <= 0 || (n | 0) !== n || (j | 0) !== j || stack.length < n) {
              return null;
            }
            j = (j % n + n) % n;
            if (j === 0) {
              break;
            }
            Array.prototype.push.apply(stack, stack.splice(stack.length - n, n - j));
            break;
          default:
            return null;
        }
      }
      if (stack.length !== outputSize) {
        return null;
      }
      var result = [];
      instructions.forEach(function (instruction) {
        var statementBuilder = new ExpressionBuilderVisitor();
        instruction.visit(statementBuilder);
        result.push(statementBuilder.toString());
      });
      stack.forEach(function (expr, i) {
        var statementBuilder = new ExpressionBuilderVisitor();
        expr.visit(statementBuilder);
        var min = range[i * 2],
            max = range[i * 2 + 1];
        var out = [statementBuilder.toString()];
        if (min > expr.min) {
          out.unshift('Math.max(', min, ', ');
          out.push(')');
        }
        if (max < expr.max) {
          out.unshift('Math.min(', max, ', ');
          out.push(')');
        }
        out.unshift('dest[destOffset + ', i, '] = ');
        out.push(';');
        result.push(out.join(''));
      });
      return result.join('\n');
    }
  };
  return PostScriptCompiler;
}();
exports.isPDFFunction = isPDFFunction;
exports.PDFFunction = PDFFunction;
exports.PostScriptEvaluator = PostScriptEvaluator;
exports.PostScriptCompiler = PostScriptCompiler;

/***/ }),
/* 7 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var getLookupTableFactory = __w_pdfjs_require__(0).getLookupTableFactory;
var getGlyphsUnicode = getLookupTableFactory(function (t) {
  t['A'] = 0x0041;
  t['AE'] = 0x00C6;
  t['AEacute'] = 0x01FC;
  t['AEmacron'] = 0x01E2;
  t['AEsmall'] = 0xF7E6;
  t['Aacute'] = 0x00C1;
  t['Aacutesmall'] = 0xF7E1;
  t['Abreve'] = 0x0102;
  t['Abreveacute'] = 0x1EAE;
  t['Abrevecyrillic'] = 0x04D0;
  t['Abrevedotbelow'] = 0x1EB6;
  t['Abrevegrave'] = 0x1EB0;
  t['Abrevehookabove'] = 0x1EB2;
  t['Abrevetilde'] = 0x1EB4;
  t['Acaron'] = 0x01CD;
  t['Acircle'] = 0x24B6;
  t['Acircumflex'] = 0x00C2;
  t['Acircumflexacute'] = 0x1EA4;
  t['Acircumflexdotbelow'] = 0x1EAC;
  t['Acircumflexgrave'] = 0x1EA6;
  t['Acircumflexhookabove'] = 0x1EA8;
  t['Acircumflexsmall'] = 0xF7E2;
  t['Acircumflextilde'] = 0x1EAA;
  t['Acute'] = 0xF6C9;
  t['Acutesmall'] = 0xF7B4;
  t['Acyrillic'] = 0x0410;
  t['Adblgrave'] = 0x0200;
  t['Adieresis'] = 0x00C4;
  t['Adieresiscyrillic'] = 0x04D2;
  t['Adieresismacron'] = 0x01DE;
  t['Adieresissmall'] = 0xF7E4;
  t['Adotbelow'] = 0x1EA0;
  t['Adotmacron'] = 0x01E0;
  t['Agrave'] = 0x00C0;
  t['Agravesmall'] = 0xF7E0;
  t['Ahookabove'] = 0x1EA2;
  t['Aiecyrillic'] = 0x04D4;
  t['Ainvertedbreve'] = 0x0202;
  t['Alpha'] = 0x0391;
  t['Alphatonos'] = 0x0386;
  t['Amacron'] = 0x0100;
  t['Amonospace'] = 0xFF21;
  t['Aogonek'] = 0x0104;
  t['Aring'] = 0x00C5;
  t['Aringacute'] = 0x01FA;
  t['Aringbelow'] = 0x1E00;
  t['Aringsmall'] = 0xF7E5;
  t['Asmall'] = 0xF761;
  t['Atilde'] = 0x00C3;
  t['Atildesmall'] = 0xF7E3;
  t['Aybarmenian'] = 0x0531;
  t['B'] = 0x0042;
  t['Bcircle'] = 0x24B7;
  t['Bdotaccent'] = 0x1E02;
  t['Bdotbelow'] = 0x1E04;
  t['Becyrillic'] = 0x0411;
  t['Benarmenian'] = 0x0532;
  t['Beta'] = 0x0392;
  t['Bhook'] = 0x0181;
  t['Blinebelow'] = 0x1E06;
  t['Bmonospace'] = 0xFF22;
  t['Brevesmall'] = 0xF6F4;
  t['Bsmall'] = 0xF762;
  t['Btopbar'] = 0x0182;
  t['C'] = 0x0043;
  t['Caarmenian'] = 0x053E;
  t['Cacute'] = 0x0106;
  t['Caron'] = 0xF6CA;
  t['Caronsmall'] = 0xF6F5;
  t['Ccaron'] = 0x010C;
  t['Ccedilla'] = 0x00C7;
  t['Ccedillaacute'] = 0x1E08;
  t['Ccedillasmall'] = 0xF7E7;
  t['Ccircle'] = 0x24B8;
  t['Ccircumflex'] = 0x0108;
  t['Cdot'] = 0x010A;
  t['Cdotaccent'] = 0x010A;
  t['Cedillasmall'] = 0xF7B8;
  t['Chaarmenian'] = 0x0549;
  t['Cheabkhasiancyrillic'] = 0x04BC;
  t['Checyrillic'] = 0x0427;
  t['Chedescenderabkhasiancyrillic'] = 0x04BE;
  t['Chedescendercyrillic'] = 0x04B6;
  t['Chedieresiscyrillic'] = 0x04F4;
  t['Cheharmenian'] = 0x0543;
  t['Chekhakassiancyrillic'] = 0x04CB;
  t['Cheverticalstrokecyrillic'] = 0x04B8;
  t['Chi'] = 0x03A7;
  t['Chook'] = 0x0187;
  t['Circumflexsmall'] = 0xF6F6;
  t['Cmonospace'] = 0xFF23;
  t['Coarmenian'] = 0x0551;
  t['Csmall'] = 0xF763;
  t['D'] = 0x0044;
  t['DZ'] = 0x01F1;
  t['DZcaron'] = 0x01C4;
  t['Daarmenian'] = 0x0534;
  t['Dafrican'] = 0x0189;
  t['Dcaron'] = 0x010E;
  t['Dcedilla'] = 0x1E10;
  t['Dcircle'] = 0x24B9;
  t['Dcircumflexbelow'] = 0x1E12;
  t['Dcroat'] = 0x0110;
  t['Ddotaccent'] = 0x1E0A;
  t['Ddotbelow'] = 0x1E0C;
  t['Decyrillic'] = 0x0414;
  t['Deicoptic'] = 0x03EE;
  t['Delta'] = 0x2206;
  t['Deltagreek'] = 0x0394;
  t['Dhook'] = 0x018A;
  t['Dieresis'] = 0xF6CB;
  t['DieresisAcute'] = 0xF6CC;
  t['DieresisGrave'] = 0xF6CD;
  t['Dieresissmall'] = 0xF7A8;
  t['Digammagreek'] = 0x03DC;
  t['Djecyrillic'] = 0x0402;
  t['Dlinebelow'] = 0x1E0E;
  t['Dmonospace'] = 0xFF24;
  t['Dotaccentsmall'] = 0xF6F7;
  t['Dslash'] = 0x0110;
  t['Dsmall'] = 0xF764;
  t['Dtopbar'] = 0x018B;
  t['Dz'] = 0x01F2;
  t['Dzcaron'] = 0x01C5;
  t['Dzeabkhasiancyrillic'] = 0x04E0;
  t['Dzecyrillic'] = 0x0405;
  t['Dzhecyrillic'] = 0x040F;
  t['E'] = 0x0045;
  t['Eacute'] = 0x00C9;
  t['Eacutesmall'] = 0xF7E9;
  t['Ebreve'] = 0x0114;
  t['Ecaron'] = 0x011A;
  t['Ecedillabreve'] = 0x1E1C;
  t['Echarmenian'] = 0x0535;
  t['Ecircle'] = 0x24BA;
  t['Ecircumflex'] = 0x00CA;
  t['Ecircumflexacute'] = 0x1EBE;
  t['Ecircumflexbelow'] = 0x1E18;
  t['Ecircumflexdotbelow'] = 0x1EC6;
  t['Ecircumflexgrave'] = 0x1EC0;
  t['Ecircumflexhookabove'] = 0x1EC2;
  t['Ecircumflexsmall'] = 0xF7EA;
  t['Ecircumflextilde'] = 0x1EC4;
  t['Ecyrillic'] = 0x0404;
  t['Edblgrave'] = 0x0204;
  t['Edieresis'] = 0x00CB;
  t['Edieresissmall'] = 0xF7EB;
  t['Edot'] = 0x0116;
  t['Edotaccent'] = 0x0116;
  t['Edotbelow'] = 0x1EB8;
  t['Efcyrillic'] = 0x0424;
  t['Egrave'] = 0x00C8;
  t['Egravesmall'] = 0xF7E8;
  t['Eharmenian'] = 0x0537;
  t['Ehookabove'] = 0x1EBA;
  t['Eightroman'] = 0x2167;
  t['Einvertedbreve'] = 0x0206;
  t['Eiotifiedcyrillic'] = 0x0464;
  t['Elcyrillic'] = 0x041B;
  t['Elevenroman'] = 0x216A;
  t['Emacron'] = 0x0112;
  t['Emacronacute'] = 0x1E16;
  t['Emacrongrave'] = 0x1E14;
  t['Emcyrillic'] = 0x041C;
  t['Emonospace'] = 0xFF25;
  t['Encyrillic'] = 0x041D;
  t['Endescendercyrillic'] = 0x04A2;
  t['Eng'] = 0x014A;
  t['Enghecyrillic'] = 0x04A4;
  t['Enhookcyrillic'] = 0x04C7;
  t['Eogonek'] = 0x0118;
  t['Eopen'] = 0x0190;
  t['Epsilon'] = 0x0395;
  t['Epsilontonos'] = 0x0388;
  t['Ercyrillic'] = 0x0420;
  t['Ereversed'] = 0x018E;
  t['Ereversedcyrillic'] = 0x042D;
  t['Escyrillic'] = 0x0421;
  t['Esdescendercyrillic'] = 0x04AA;
  t['Esh'] = 0x01A9;
  t['Esmall'] = 0xF765;
  t['Eta'] = 0x0397;
  t['Etarmenian'] = 0x0538;
  t['Etatonos'] = 0x0389;
  t['Eth'] = 0x00D0;
  t['Ethsmall'] = 0xF7F0;
  t['Etilde'] = 0x1EBC;
  t['Etildebelow'] = 0x1E1A;
  t['Euro'] = 0x20AC;
  t['Ezh'] = 0x01B7;
  t['Ezhcaron'] = 0x01EE;
  t['Ezhreversed'] = 0x01B8;
  t['F'] = 0x0046;
  t['Fcircle'] = 0x24BB;
  t['Fdotaccent'] = 0x1E1E;
  t['Feharmenian'] = 0x0556;
  t['Feicoptic'] = 0x03E4;
  t['Fhook'] = 0x0191;
  t['Fitacyrillic'] = 0x0472;
  t['Fiveroman'] = 0x2164;
  t['Fmonospace'] = 0xFF26;
  t['Fourroman'] = 0x2163;
  t['Fsmall'] = 0xF766;
  t['G'] = 0x0047;
  t['GBsquare'] = 0x3387;
  t['Gacute'] = 0x01F4;
  t['Gamma'] = 0x0393;
  t['Gammaafrican'] = 0x0194;
  t['Gangiacoptic'] = 0x03EA;
  t['Gbreve'] = 0x011E;
  t['Gcaron'] = 0x01E6;
  t['Gcedilla'] = 0x0122;
  t['Gcircle'] = 0x24BC;
  t['Gcircumflex'] = 0x011C;
  t['Gcommaaccent'] = 0x0122;
  t['Gdot'] = 0x0120;
  t['Gdotaccent'] = 0x0120;
  t['Gecyrillic'] = 0x0413;
  t['Ghadarmenian'] = 0x0542;
  t['Ghemiddlehookcyrillic'] = 0x0494;
  t['Ghestrokecyrillic'] = 0x0492;
  t['Gheupturncyrillic'] = 0x0490;
  t['Ghook'] = 0x0193;
  t['Gimarmenian'] = 0x0533;
  t['Gjecyrillic'] = 0x0403;
  t['Gmacron'] = 0x1E20;
  t['Gmonospace'] = 0xFF27;
  t['Grave'] = 0xF6CE;
  t['Gravesmall'] = 0xF760;
  t['Gsmall'] = 0xF767;
  t['Gsmallhook'] = 0x029B;
  t['Gstroke'] = 0x01E4;
  t['H'] = 0x0048;
  t['H18533'] = 0x25CF;
  t['H18543'] = 0x25AA;
  t['H18551'] = 0x25AB;
  t['H22073'] = 0x25A1;
  t['HPsquare'] = 0x33CB;
  t['Haabkhasiancyrillic'] = 0x04A8;
  t['Hadescendercyrillic'] = 0x04B2;
  t['Hardsigncyrillic'] = 0x042A;
  t['Hbar'] = 0x0126;
  t['Hbrevebelow'] = 0x1E2A;
  t['Hcedilla'] = 0x1E28;
  t['Hcircle'] = 0x24BD;
  t['Hcircumflex'] = 0x0124;
  t['Hdieresis'] = 0x1E26;
  t['Hdotaccent'] = 0x1E22;
  t['Hdotbelow'] = 0x1E24;
  t['Hmonospace'] = 0xFF28;
  t['Hoarmenian'] = 0x0540;
  t['Horicoptic'] = 0x03E8;
  t['Hsmall'] = 0xF768;
  t['Hungarumlaut'] = 0xF6CF;
  t['Hungarumlautsmall'] = 0xF6F8;
  t['Hzsquare'] = 0x3390;
  t['I'] = 0x0049;
  t['IAcyrillic'] = 0x042F;
  t['IJ'] = 0x0132;
  t['IUcyrillic'] = 0x042E;
  t['Iacute'] = 0x00CD;
  t['Iacutesmall'] = 0xF7ED;
  t['Ibreve'] = 0x012C;
  t['Icaron'] = 0x01CF;
  t['Icircle'] = 0x24BE;
  t['Icircumflex'] = 0x00CE;
  t['Icircumflexsmall'] = 0xF7EE;
  t['Icyrillic'] = 0x0406;
  t['Idblgrave'] = 0x0208;
  t['Idieresis'] = 0x00CF;
  t['Idieresisacute'] = 0x1E2E;
  t['Idieresiscyrillic'] = 0x04E4;
  t['Idieresissmall'] = 0xF7EF;
  t['Idot'] = 0x0130;
  t['Idotaccent'] = 0x0130;
  t['Idotbelow'] = 0x1ECA;
  t['Iebrevecyrillic'] = 0x04D6;
  t['Iecyrillic'] = 0x0415;
  t['Ifraktur'] = 0x2111;
  t['Igrave'] = 0x00CC;
  t['Igravesmall'] = 0xF7EC;
  t['Ihookabove'] = 0x1EC8;
  t['Iicyrillic'] = 0x0418;
  t['Iinvertedbreve'] = 0x020A;
  t['Iishortcyrillic'] = 0x0419;
  t['Imacron'] = 0x012A;
  t['Imacroncyrillic'] = 0x04E2;
  t['Imonospace'] = 0xFF29;
  t['Iniarmenian'] = 0x053B;
  t['Iocyrillic'] = 0x0401;
  t['Iogonek'] = 0x012E;
  t['Iota'] = 0x0399;
  t['Iotaafrican'] = 0x0196;
  t['Iotadieresis'] = 0x03AA;
  t['Iotatonos'] = 0x038A;
  t['Ismall'] = 0xF769;
  t['Istroke'] = 0x0197;
  t['Itilde'] = 0x0128;
  t['Itildebelow'] = 0x1E2C;
  t['Izhitsacyrillic'] = 0x0474;
  t['Izhitsadblgravecyrillic'] = 0x0476;
  t['J'] = 0x004A;
  t['Jaarmenian'] = 0x0541;
  t['Jcircle'] = 0x24BF;
  t['Jcircumflex'] = 0x0134;
  t['Jecyrillic'] = 0x0408;
  t['Jheharmenian'] = 0x054B;
  t['Jmonospace'] = 0xFF2A;
  t['Jsmall'] = 0xF76A;
  t['K'] = 0x004B;
  t['KBsquare'] = 0x3385;
  t['KKsquare'] = 0x33CD;
  t['Kabashkircyrillic'] = 0x04A0;
  t['Kacute'] = 0x1E30;
  t['Kacyrillic'] = 0x041A;
  t['Kadescendercyrillic'] = 0x049A;
  t['Kahookcyrillic'] = 0x04C3;
  t['Kappa'] = 0x039A;
  t['Kastrokecyrillic'] = 0x049E;
  t['Kaverticalstrokecyrillic'] = 0x049C;
  t['Kcaron'] = 0x01E8;
  t['Kcedilla'] = 0x0136;
  t['Kcircle'] = 0x24C0;
  t['Kcommaaccent'] = 0x0136;
  t['Kdotbelow'] = 0x1E32;
  t['Keharmenian'] = 0x0554;
  t['Kenarmenian'] = 0x053F;
  t['Khacyrillic'] = 0x0425;
  t['Kheicoptic'] = 0x03E6;
  t['Khook'] = 0x0198;
  t['Kjecyrillic'] = 0x040C;
  t['Klinebelow'] = 0x1E34;
  t['Kmonospace'] = 0xFF2B;
  t['Koppacyrillic'] = 0x0480;
  t['Koppagreek'] = 0x03DE;
  t['Ksicyrillic'] = 0x046E;
  t['Ksmall'] = 0xF76B;
  t['L'] = 0x004C;
  t['LJ'] = 0x01C7;
  t['LL'] = 0xF6BF;
  t['Lacute'] = 0x0139;
  t['Lambda'] = 0x039B;
  t['Lcaron'] = 0x013D;
  t['Lcedilla'] = 0x013B;
  t['Lcircle'] = 0x24C1;
  t['Lcircumflexbelow'] = 0x1E3C;
  t['Lcommaaccent'] = 0x013B;
  t['Ldot'] = 0x013F;
  t['Ldotaccent'] = 0x013F;
  t['Ldotbelow'] = 0x1E36;
  t['Ldotbelowmacron'] = 0x1E38;
  t['Liwnarmenian'] = 0x053C;
  t['Lj'] = 0x01C8;
  t['Ljecyrillic'] = 0x0409;
  t['Llinebelow'] = 0x1E3A;
  t['Lmonospace'] = 0xFF2C;
  t['Lslash'] = 0x0141;
  t['Lslashsmall'] = 0xF6F9;
  t['Lsmall'] = 0xF76C;
  t['M'] = 0x004D;
  t['MBsquare'] = 0x3386;
  t['Macron'] = 0xF6D0;
  t['Macronsmall'] = 0xF7AF;
  t['Macute'] = 0x1E3E;
  t['Mcircle'] = 0x24C2;
  t['Mdotaccent'] = 0x1E40;
  t['Mdotbelow'] = 0x1E42;
  t['Menarmenian'] = 0x0544;
  t['Mmonospace'] = 0xFF2D;
  t['Msmall'] = 0xF76D;
  t['Mturned'] = 0x019C;
  t['Mu'] = 0x039C;
  t['N'] = 0x004E;
  t['NJ'] = 0x01CA;
  t['Nacute'] = 0x0143;
  t['Ncaron'] = 0x0147;
  t['Ncedilla'] = 0x0145;
  t['Ncircle'] = 0x24C3;
  t['Ncircumflexbelow'] = 0x1E4A;
  t['Ncommaaccent'] = 0x0145;
  t['Ndotaccent'] = 0x1E44;
  t['Ndotbelow'] = 0x1E46;
  t['Nhookleft'] = 0x019D;
  t['Nineroman'] = 0x2168;
  t['Nj'] = 0x01CB;
  t['Njecyrillic'] = 0x040A;
  t['Nlinebelow'] = 0x1E48;
  t['Nmonospace'] = 0xFF2E;
  t['Nowarmenian'] = 0x0546;
  t['Nsmall'] = 0xF76E;
  t['Ntilde'] = 0x00D1;
  t['Ntildesmall'] = 0xF7F1;
  t['Nu'] = 0x039D;
  t['O'] = 0x004F;
  t['OE'] = 0x0152;
  t['OEsmall'] = 0xF6FA;
  t['Oacute'] = 0x00D3;
  t['Oacutesmall'] = 0xF7F3;
  t['Obarredcyrillic'] = 0x04E8;
  t['Obarreddieresiscyrillic'] = 0x04EA;
  t['Obreve'] = 0x014E;
  t['Ocaron'] = 0x01D1;
  t['Ocenteredtilde'] = 0x019F;
  t['Ocircle'] = 0x24C4;
  t['Ocircumflex'] = 0x00D4;
  t['Ocircumflexacute'] = 0x1ED0;
  t['Ocircumflexdotbelow'] = 0x1ED8;
  t['Ocircumflexgrave'] = 0x1ED2;
  t['Ocircumflexhookabove'] = 0x1ED4;
  t['Ocircumflexsmall'] = 0xF7F4;
  t['Ocircumflextilde'] = 0x1ED6;
  t['Ocyrillic'] = 0x041E;
  t['Odblacute'] = 0x0150;
  t['Odblgrave'] = 0x020C;
  t['Odieresis'] = 0x00D6;
  t['Odieresiscyrillic'] = 0x04E6;
  t['Odieresissmall'] = 0xF7F6;
  t['Odotbelow'] = 0x1ECC;
  t['Ogoneksmall'] = 0xF6FB;
  t['Ograve'] = 0x00D2;
  t['Ogravesmall'] = 0xF7F2;
  t['Oharmenian'] = 0x0555;
  t['Ohm'] = 0x2126;
  t['Ohookabove'] = 0x1ECE;
  t['Ohorn'] = 0x01A0;
  t['Ohornacute'] = 0x1EDA;
  t['Ohorndotbelow'] = 0x1EE2;
  t['Ohorngrave'] = 0x1EDC;
  t['Ohornhookabove'] = 0x1EDE;
  t['Ohorntilde'] = 0x1EE0;
  t['Ohungarumlaut'] = 0x0150;
  t['Oi'] = 0x01A2;
  t['Oinvertedbreve'] = 0x020E;
  t['Omacron'] = 0x014C;
  t['Omacronacute'] = 0x1E52;
  t['Omacrongrave'] = 0x1E50;
  t['Omega'] = 0x2126;
  t['Omegacyrillic'] = 0x0460;
  t['Omegagreek'] = 0x03A9;
  t['Omegaroundcyrillic'] = 0x047A;
  t['Omegatitlocyrillic'] = 0x047C;
  t['Omegatonos'] = 0x038F;
  t['Omicron'] = 0x039F;
  t['Omicrontonos'] = 0x038C;
  t['Omonospace'] = 0xFF2F;
  t['Oneroman'] = 0x2160;
  t['Oogonek'] = 0x01EA;
  t['Oogonekmacron'] = 0x01EC;
  t['Oopen'] = 0x0186;
  t['Oslash'] = 0x00D8;
  t['Oslashacute'] = 0x01FE;
  t['Oslashsmall'] = 0xF7F8;
  t['Osmall'] = 0xF76F;
  t['Ostrokeacute'] = 0x01FE;
  t['Otcyrillic'] = 0x047E;
  t['Otilde'] = 0x00D5;
  t['Otildeacute'] = 0x1E4C;
  t['Otildedieresis'] = 0x1E4E;
  t['Otildesmall'] = 0xF7F5;
  t['P'] = 0x0050;
  t['Pacute'] = 0x1E54;
  t['Pcircle'] = 0x24C5;
  t['Pdotaccent'] = 0x1E56;
  t['Pecyrillic'] = 0x041F;
  t['Peharmenian'] = 0x054A;
  t['Pemiddlehookcyrillic'] = 0x04A6;
  t['Phi'] = 0x03A6;
  t['Phook'] = 0x01A4;
  t['Pi'] = 0x03A0;
  t['Piwrarmenian'] = 0x0553;
  t['Pmonospace'] = 0xFF30;
  t['Psi'] = 0x03A8;
  t['Psicyrillic'] = 0x0470;
  t['Psmall'] = 0xF770;
  t['Q'] = 0x0051;
  t['Qcircle'] = 0x24C6;
  t['Qmonospace'] = 0xFF31;
  t['Qsmall'] = 0xF771;
  t['R'] = 0x0052;
  t['Raarmenian'] = 0x054C;
  t['Racute'] = 0x0154;
  t['Rcaron'] = 0x0158;
  t['Rcedilla'] = 0x0156;
  t['Rcircle'] = 0x24C7;
  t['Rcommaaccent'] = 0x0156;
  t['Rdblgrave'] = 0x0210;
  t['Rdotaccent'] = 0x1E58;
  t['Rdotbelow'] = 0x1E5A;
  t['Rdotbelowmacron'] = 0x1E5C;
  t['Reharmenian'] = 0x0550;
  t['Rfraktur'] = 0x211C;
  t['Rho'] = 0x03A1;
  t['Ringsmall'] = 0xF6FC;
  t['Rinvertedbreve'] = 0x0212;
  t['Rlinebelow'] = 0x1E5E;
  t['Rmonospace'] = 0xFF32;
  t['Rsmall'] = 0xF772;
  t['Rsmallinverted'] = 0x0281;
  t['Rsmallinvertedsuperior'] = 0x02B6;
  t['S'] = 0x0053;
  t['SF010000'] = 0x250C;
  t['SF020000'] = 0x2514;
  t['SF030000'] = 0x2510;
  t['SF040000'] = 0x2518;
  t['SF050000'] = 0x253C;
  t['SF060000'] = 0x252C;
  t['SF070000'] = 0x2534;
  t['SF080000'] = 0x251C;
  t['SF090000'] = 0x2524;
  t['SF100000'] = 0x2500;
  t['SF110000'] = 0x2502;
  t['SF190000'] = 0x2561;
  t['SF200000'] = 0x2562;
  t['SF210000'] = 0x2556;
  t['SF220000'] = 0x2555;
  t['SF230000'] = 0x2563;
  t['SF240000'] = 0x2551;
  t['SF250000'] = 0x2557;
  t['SF260000'] = 0x255D;
  t['SF270000'] = 0x255C;
  t['SF280000'] = 0x255B;
  t['SF360000'] = 0x255E;
  t['SF370000'] = 0x255F;
  t['SF380000'] = 0x255A;
  t['SF390000'] = 0x2554;
  t['SF400000'] = 0x2569;
  t['SF410000'] = 0x2566;
  t['SF420000'] = 0x2560;
  t['SF430000'] = 0x2550;
  t['SF440000'] = 0x256C;
  t['SF450000'] = 0x2567;
  t['SF460000'] = 0x2568;
  t['SF470000'] = 0x2564;
  t['SF480000'] = 0x2565;
  t['SF490000'] = 0x2559;
  t['SF500000'] = 0x2558;
  t['SF510000'] = 0x2552;
  t['SF520000'] = 0x2553;
  t['SF530000'] = 0x256B;
  t['SF540000'] = 0x256A;
  t['Sacute'] = 0x015A;
  t['Sacutedotaccent'] = 0x1E64;
  t['Sampigreek'] = 0x03E0;
  t['Scaron'] = 0x0160;
  t['Scarondotaccent'] = 0x1E66;
  t['Scaronsmall'] = 0xF6FD;
  t['Scedilla'] = 0x015E;
  t['Schwa'] = 0x018F;
  t['Schwacyrillic'] = 0x04D8;
  t['Schwadieresiscyrillic'] = 0x04DA;
  t['Scircle'] = 0x24C8;
  t['Scircumflex'] = 0x015C;
  t['Scommaaccent'] = 0x0218;
  t['Sdotaccent'] = 0x1E60;
  t['Sdotbelow'] = 0x1E62;
  t['Sdotbelowdotaccent'] = 0x1E68;
  t['Seharmenian'] = 0x054D;
  t['Sevenroman'] = 0x2166;
  t['Shaarmenian'] = 0x0547;
  t['Shacyrillic'] = 0x0428;
  t['Shchacyrillic'] = 0x0429;
  t['Sheicoptic'] = 0x03E2;
  t['Shhacyrillic'] = 0x04BA;
  t['Shimacoptic'] = 0x03EC;
  t['Sigma'] = 0x03A3;
  t['Sixroman'] = 0x2165;
  t['Smonospace'] = 0xFF33;
  t['Softsigncyrillic'] = 0x042C;
  t['Ssmall'] = 0xF773;
  t['Stigmagreek'] = 0x03DA;
  t['T'] = 0x0054;
  t['Tau'] = 0x03A4;
  t['Tbar'] = 0x0166;
  t['Tcaron'] = 0x0164;
  t['Tcedilla'] = 0x0162;
  t['Tcircle'] = 0x24C9;
  t['Tcircumflexbelow'] = 0x1E70;
  t['Tcommaaccent'] = 0x0162;
  t['Tdotaccent'] = 0x1E6A;
  t['Tdotbelow'] = 0x1E6C;
  t['Tecyrillic'] = 0x0422;
  t['Tedescendercyrillic'] = 0x04AC;
  t['Tenroman'] = 0x2169;
  t['Tetsecyrillic'] = 0x04B4;
  t['Theta'] = 0x0398;
  t['Thook'] = 0x01AC;
  t['Thorn'] = 0x00DE;
  t['Thornsmall'] = 0xF7FE;
  t['Threeroman'] = 0x2162;
  t['Tildesmall'] = 0xF6FE;
  t['Tiwnarmenian'] = 0x054F;
  t['Tlinebelow'] = 0x1E6E;
  t['Tmonospace'] = 0xFF34;
  t['Toarmenian'] = 0x0539;
  t['Tonefive'] = 0x01BC;
  t['Tonesix'] = 0x0184;
  t['Tonetwo'] = 0x01A7;
  t['Tretroflexhook'] = 0x01AE;
  t['Tsecyrillic'] = 0x0426;
  t['Tshecyrillic'] = 0x040B;
  t['Tsmall'] = 0xF774;
  t['Twelveroman'] = 0x216B;
  t['Tworoman'] = 0x2161;
  t['U'] = 0x0055;
  t['Uacute'] = 0x00DA;
  t['Uacutesmall'] = 0xF7FA;
  t['Ubreve'] = 0x016C;
  t['Ucaron'] = 0x01D3;
  t['Ucircle'] = 0x24CA;
  t['Ucircumflex'] = 0x00DB;
  t['Ucircumflexbelow'] = 0x1E76;
  t['Ucircumflexsmall'] = 0xF7FB;
  t['Ucyrillic'] = 0x0423;
  t['Udblacute'] = 0x0170;
  t['Udblgrave'] = 0x0214;
  t['Udieresis'] = 0x00DC;
  t['Udieresisacute'] = 0x01D7;
  t['Udieresisbelow'] = 0x1E72;
  t['Udieresiscaron'] = 0x01D9;
  t['Udieresiscyrillic'] = 0x04F0;
  t['Udieresisgrave'] = 0x01DB;
  t['Udieresismacron'] = 0x01D5;
  t['Udieresissmall'] = 0xF7FC;
  t['Udotbelow'] = 0x1EE4;
  t['Ugrave'] = 0x00D9;
  t['Ugravesmall'] = 0xF7F9;
  t['Uhookabove'] = 0x1EE6;
  t['Uhorn'] = 0x01AF;
  t['Uhornacute'] = 0x1EE8;
  t['Uhorndotbelow'] = 0x1EF0;
  t['Uhorngrave'] = 0x1EEA;
  t['Uhornhookabove'] = 0x1EEC;
  t['Uhorntilde'] = 0x1EEE;
  t['Uhungarumlaut'] = 0x0170;
  t['Uhungarumlautcyrillic'] = 0x04F2;
  t['Uinvertedbreve'] = 0x0216;
  t['Ukcyrillic'] = 0x0478;
  t['Umacron'] = 0x016A;
  t['Umacroncyrillic'] = 0x04EE;
  t['Umacrondieresis'] = 0x1E7A;
  t['Umonospace'] = 0xFF35;
  t['Uogonek'] = 0x0172;
  t['Upsilon'] = 0x03A5;
  t['Upsilon1'] = 0x03D2;
  t['Upsilonacutehooksymbolgreek'] = 0x03D3;
  t['Upsilonafrican'] = 0x01B1;
  t['Upsilondieresis'] = 0x03AB;
  t['Upsilondieresishooksymbolgreek'] = 0x03D4;
  t['Upsilonhooksymbol'] = 0x03D2;
  t['Upsilontonos'] = 0x038E;
  t['Uring'] = 0x016E;
  t['Ushortcyrillic'] = 0x040E;
  t['Usmall'] = 0xF775;
  t['Ustraightcyrillic'] = 0x04AE;
  t['Ustraightstrokecyrillic'] = 0x04B0;
  t['Utilde'] = 0x0168;
  t['Utildeacute'] = 0x1E78;
  t['Utildebelow'] = 0x1E74;
  t['V'] = 0x0056;
  t['Vcircle'] = 0x24CB;
  t['Vdotbelow'] = 0x1E7E;
  t['Vecyrillic'] = 0x0412;
  t['Vewarmenian'] = 0x054E;
  t['Vhook'] = 0x01B2;
  t['Vmonospace'] = 0xFF36;
  t['Voarmenian'] = 0x0548;
  t['Vsmall'] = 0xF776;
  t['Vtilde'] = 0x1E7C;
  t['W'] = 0x0057;
  t['Wacute'] = 0x1E82;
  t['Wcircle'] = 0x24CC;
  t['Wcircumflex'] = 0x0174;
  t['Wdieresis'] = 0x1E84;
  t['Wdotaccent'] = 0x1E86;
  t['Wdotbelow'] = 0x1E88;
  t['Wgrave'] = 0x1E80;
  t['Wmonospace'] = 0xFF37;
  t['Wsmall'] = 0xF777;
  t['X'] = 0x0058;
  t['Xcircle'] = 0x24CD;
  t['Xdieresis'] = 0x1E8C;
  t['Xdotaccent'] = 0x1E8A;
  t['Xeharmenian'] = 0x053D;
  t['Xi'] = 0x039E;
  t['Xmonospace'] = 0xFF38;
  t['Xsmall'] = 0xF778;
  t['Y'] = 0x0059;
  t['Yacute'] = 0x00DD;
  t['Yacutesmall'] = 0xF7FD;
  t['Yatcyrillic'] = 0x0462;
  t['Ycircle'] = 0x24CE;
  t['Ycircumflex'] = 0x0176;
  t['Ydieresis'] = 0x0178;
  t['Ydieresissmall'] = 0xF7FF;
  t['Ydotaccent'] = 0x1E8E;
  t['Ydotbelow'] = 0x1EF4;
  t['Yericyrillic'] = 0x042B;
  t['Yerudieresiscyrillic'] = 0x04F8;
  t['Ygrave'] = 0x1EF2;
  t['Yhook'] = 0x01B3;
  t['Yhookabove'] = 0x1EF6;
  t['Yiarmenian'] = 0x0545;
  t['Yicyrillic'] = 0x0407;
  t['Yiwnarmenian'] = 0x0552;
  t['Ymonospace'] = 0xFF39;
  t['Ysmall'] = 0xF779;
  t['Ytilde'] = 0x1EF8;
  t['Yusbigcyrillic'] = 0x046A;
  t['Yusbigiotifiedcyrillic'] = 0x046C;
  t['Yuslittlecyrillic'] = 0x0466;
  t['Yuslittleiotifiedcyrillic'] = 0x0468;
  t['Z'] = 0x005A;
  t['Zaarmenian'] = 0x0536;
  t['Zacute'] = 0x0179;
  t['Zcaron'] = 0x017D;
  t['Zcaronsmall'] = 0xF6FF;
  t['Zcircle'] = 0x24CF;
  t['Zcircumflex'] = 0x1E90;
  t['Zdot'] = 0x017B;
  t['Zdotaccent'] = 0x017B;
  t['Zdotbelow'] = 0x1E92;
  t['Zecyrillic'] = 0x0417;
  t['Zedescendercyrillic'] = 0x0498;
  t['Zedieresiscyrillic'] = 0x04DE;
  t['Zeta'] = 0x0396;
  t['Zhearmenian'] = 0x053A;
  t['Zhebrevecyrillic'] = 0x04C1;
  t['Zhecyrillic'] = 0x0416;
  t['Zhedescendercyrillic'] = 0x0496;
  t['Zhedieresiscyrillic'] = 0x04DC;
  t['Zlinebelow'] = 0x1E94;
  t['Zmonospace'] = 0xFF3A;
  t['Zsmall'] = 0xF77A;
  t['Zstroke'] = 0x01B5;
  t['a'] = 0x0061;
  t['aabengali'] = 0x0986;
  t['aacute'] = 0x00E1;
  t['aadeva'] = 0x0906;
  t['aagujarati'] = 0x0A86;
  t['aagurmukhi'] = 0x0A06;
  t['aamatragurmukhi'] = 0x0A3E;
  t['aarusquare'] = 0x3303;
  t['aavowelsignbengali'] = 0x09BE;
  t['aavowelsigndeva'] = 0x093E;
  t['aavowelsigngujarati'] = 0x0ABE;
  t['abbreviationmarkarmenian'] = 0x055F;
  t['abbreviationsigndeva'] = 0x0970;
  t['abengali'] = 0x0985;
  t['abopomofo'] = 0x311A;
  t['abreve'] = 0x0103;
  t['abreveacute'] = 0x1EAF;
  t['abrevecyrillic'] = 0x04D1;
  t['abrevedotbelow'] = 0x1EB7;
  t['abrevegrave'] = 0x1EB1;
  t['abrevehookabove'] = 0x1EB3;
  t['abrevetilde'] = 0x1EB5;
  t['acaron'] = 0x01CE;
  t['acircle'] = 0x24D0;
  t['acircumflex'] = 0x00E2;
  t['acircumflexacute'] = 0x1EA5;
  t['acircumflexdotbelow'] = 0x1EAD;
  t['acircumflexgrave'] = 0x1EA7;
  t['acircumflexhookabove'] = 0x1EA9;
  t['acircumflextilde'] = 0x1EAB;
  t['acute'] = 0x00B4;
  t['acutebelowcmb'] = 0x0317;
  t['acutecmb'] = 0x0301;
  t['acutecomb'] = 0x0301;
  t['acutedeva'] = 0x0954;
  t['acutelowmod'] = 0x02CF;
  t['acutetonecmb'] = 0x0341;
  t['acyrillic'] = 0x0430;
  t['adblgrave'] = 0x0201;
  t['addakgurmukhi'] = 0x0A71;
  t['adeva'] = 0x0905;
  t['adieresis'] = 0x00E4;
  t['adieresiscyrillic'] = 0x04D3;
  t['adieresismacron'] = 0x01DF;
  t['adotbelow'] = 0x1EA1;
  t['adotmacron'] = 0x01E1;
  t['ae'] = 0x00E6;
  t['aeacute'] = 0x01FD;
  t['aekorean'] = 0x3150;
  t['aemacron'] = 0x01E3;
  t['afii00208'] = 0x2015;
  t['afii08941'] = 0x20A4;
  t['afii10017'] = 0x0410;
  t['afii10018'] = 0x0411;
  t['afii10019'] = 0x0412;
  t['afii10020'] = 0x0413;
  t['afii10021'] = 0x0414;
  t['afii10022'] = 0x0415;
  t['afii10023'] = 0x0401;
  t['afii10024'] = 0x0416;
  t['afii10025'] = 0x0417;
  t['afii10026'] = 0x0418;
  t['afii10027'] = 0x0419;
  t['afii10028'] = 0x041A;
  t['afii10029'] = 0x041B;
  t['afii10030'] = 0x041C;
  t['afii10031'] = 0x041D;
  t['afii10032'] = 0x041E;
  t['afii10033'] = 0x041F;
  t['afii10034'] = 0x0420;
  t['afii10035'] = 0x0421;
  t['afii10036'] = 0x0422;
  t['afii10037'] = 0x0423;
  t['afii10038'] = 0x0424;
  t['afii10039'] = 0x0425;
  t['afii10040'] = 0x0426;
  t['afii10041'] = 0x0427;
  t['afii10042'] = 0x0428;
  t['afii10043'] = 0x0429;
  t['afii10044'] = 0x042A;
  t['afii10045'] = 0x042B;
  t['afii10046'] = 0x042C;
  t['afii10047'] = 0x042D;
  t['afii10048'] = 0x042E;
  t['afii10049'] = 0x042F;
  t['afii10050'] = 0x0490;
  t['afii10051'] = 0x0402;
  t['afii10052'] = 0x0403;
  t['afii10053'] = 0x0404;
  t['afii10054'] = 0x0405;
  t['afii10055'] = 0x0406;
  t['afii10056'] = 0x0407;
  t['afii10057'] = 0x0408;
  t['afii10058'] = 0x0409;
  t['afii10059'] = 0x040A;
  t['afii10060'] = 0x040B;
  t['afii10061'] = 0x040C;
  t['afii10062'] = 0x040E;
  t['afii10063'] = 0xF6C4;
  t['afii10064'] = 0xF6C5;
  t['afii10065'] = 0x0430;
  t['afii10066'] = 0x0431;
  t['afii10067'] = 0x0432;
  t['afii10068'] = 0x0433;
  t['afii10069'] = 0x0434;
  t['afii10070'] = 0x0435;
  t['afii10071'] = 0x0451;
  t['afii10072'] = 0x0436;
  t['afii10073'] = 0x0437;
  t['afii10074'] = 0x0438;
  t['afii10075'] = 0x0439;
  t['afii10076'] = 0x043A;
  t['afii10077'] = 0x043B;
  t['afii10078'] = 0x043C;
  t['afii10079'] = 0x043D;
  t['afii10080'] = 0x043E;
  t['afii10081'] = 0x043F;
  t['afii10082'] = 0x0440;
  t['afii10083'] = 0x0441;
  t['afii10084'] = 0x0442;
  t['afii10085'] = 0x0443;
  t['afii10086'] = 0x0444;
  t['afii10087'] = 0x0445;
  t['afii10088'] = 0x0446;
  t['afii10089'] = 0x0447;
  t['afii10090'] = 0x0448;
  t['afii10091'] = 0x0449;
  t['afii10092'] = 0x044A;
  t['afii10093'] = 0x044B;
  t['afii10094'] = 0x044C;
  t['afii10095'] = 0x044D;
  t['afii10096'] = 0x044E;
  t['afii10097'] = 0x044F;
  t['afii10098'] = 0x0491;
  t['afii10099'] = 0x0452;
  t['afii10100'] = 0x0453;
  t['afii10101'] = 0x0454;
  t['afii10102'] = 0x0455;
  t['afii10103'] = 0x0456;
  t['afii10104'] = 0x0457;
  t['afii10105'] = 0x0458;
  t['afii10106'] = 0x0459;
  t['afii10107'] = 0x045A;
  t['afii10108'] = 0x045B;
  t['afii10109'] = 0x045C;
  t['afii10110'] = 0x045E;
  t['afii10145'] = 0x040F;
  t['afii10146'] = 0x0462;
  t['afii10147'] = 0x0472;
  t['afii10148'] = 0x0474;
  t['afii10192'] = 0xF6C6;
  t['afii10193'] = 0x045F;
  t['afii10194'] = 0x0463;
  t['afii10195'] = 0x0473;
  t['afii10196'] = 0x0475;
  t['afii10831'] = 0xF6C7;
  t['afii10832'] = 0xF6C8;
  t['afii10846'] = 0x04D9;
  t['afii299'] = 0x200E;
  t['afii300'] = 0x200F;
  t['afii301'] = 0x200D;
  t['afii57381'] = 0x066A;
  t['afii57388'] = 0x060C;
  t['afii57392'] = 0x0660;
  t['afii57393'] = 0x0661;
  t['afii57394'] = 0x0662;
  t['afii57395'] = 0x0663;
  t['afii57396'] = 0x0664;
  t['afii57397'] = 0x0665;
  t['afii57398'] = 0x0666;
  t['afii57399'] = 0x0667;
  t['afii57400'] = 0x0668;
  t['afii57401'] = 0x0669;
  t['afii57403'] = 0x061B;
  t['afii57407'] = 0x061F;
  t['afii57409'] = 0x0621;
  t['afii57410'] = 0x0622;
  t['afii57411'] = 0x0623;
  t['afii57412'] = 0x0624;
  t['afii57413'] = 0x0625;
  t['afii57414'] = 0x0626;
  t['afii57415'] = 0x0627;
  t['afii57416'] = 0x0628;
  t['afii57417'] = 0x0629;
  t['afii57418'] = 0x062A;
  t['afii57419'] = 0x062B;
  t['afii57420'] = 0x062C;
  t['afii57421'] = 0x062D;
  t['afii57422'] = 0x062E;
  t['afii57423'] = 0x062F;
  t['afii57424'] = 0x0630;
  t['afii57425'] = 0x0631;
  t['afii57426'] = 0x0632;
  t['afii57427'] = 0x0633;
  t['afii57428'] = 0x0634;
  t['afii57429'] = 0x0635;
  t['afii57430'] = 0x0636;
  t['afii57431'] = 0x0637;
  t['afii57432'] = 0x0638;
  t['afii57433'] = 0x0639;
  t['afii57434'] = 0x063A;
  t['afii57440'] = 0x0640;
  t['afii57441'] = 0x0641;
  t['afii57442'] = 0x0642;
  t['afii57443'] = 0x0643;
  t['afii57444'] = 0x0644;
  t['afii57445'] = 0x0645;
  t['afii57446'] = 0x0646;
  t['afii57448'] = 0x0648;
  t['afii57449'] = 0x0649;
  t['afii57450'] = 0x064A;
  t['afii57451'] = 0x064B;
  t['afii57452'] = 0x064C;
  t['afii57453'] = 0x064D;
  t['afii57454'] = 0x064E;
  t['afii57455'] = 0x064F;
  t['afii57456'] = 0x0650;
  t['afii57457'] = 0x0651;
  t['afii57458'] = 0x0652;
  t['afii57470'] = 0x0647;
  t['afii57505'] = 0x06A4;
  t['afii57506'] = 0x067E;
  t['afii57507'] = 0x0686;
  t['afii57508'] = 0x0698;
  t['afii57509'] = 0x06AF;
  t['afii57511'] = 0x0679;
  t['afii57512'] = 0x0688;
  t['afii57513'] = 0x0691;
  t['afii57514'] = 0x06BA;
  t['afii57519'] = 0x06D2;
  t['afii57534'] = 0x06D5;
  t['afii57636'] = 0x20AA;
  t['afii57645'] = 0x05BE;
  t['afii57658'] = 0x05C3;
  t['afii57664'] = 0x05D0;
  t['afii57665'] = 0x05D1;
  t['afii57666'] = 0x05D2;
  t['afii57667'] = 0x05D3;
  t['afii57668'] = 0x05D4;
  t['afii57669'] = 0x05D5;
  t['afii57670'] = 0x05D6;
  t['afii57671'] = 0x05D7;
  t['afii57672'] = 0x05D8;
  t['afii57673'] = 0x05D9;
  t['afii57674'] = 0x05DA;
  t['afii57675'] = 0x05DB;
  t['afii57676'] = 0x05DC;
  t['afii57677'] = 0x05DD;
  t['afii57678'] = 0x05DE;
  t['afii57679'] = 0x05DF;
  t['afii57680'] = 0x05E0;
  t['afii57681'] = 0x05E1;
  t['afii57682'] = 0x05E2;
  t['afii57683'] = 0x05E3;
  t['afii57684'] = 0x05E4;
  t['afii57685'] = 0x05E5;
  t['afii57686'] = 0x05E6;
  t['afii57687'] = 0x05E7;
  t['afii57688'] = 0x05E8;
  t['afii57689'] = 0x05E9;
  t['afii57690'] = 0x05EA;
  t['afii57694'] = 0xFB2A;
  t['afii57695'] = 0xFB2B;
  t['afii57700'] = 0xFB4B;
  t['afii57705'] = 0xFB1F;
  t['afii57716'] = 0x05F0;
  t['afii57717'] = 0x05F1;
  t['afii57718'] = 0x05F2;
  t['afii57723'] = 0xFB35;
  t['afii57793'] = 0x05B4;
  t['afii57794'] = 0x05B5;
  t['afii57795'] = 0x05B6;
  t['afii57796'] = 0x05BB;
  t['afii57797'] = 0x05B8;
  t['afii57798'] = 0x05B7;
  t['afii57799'] = 0x05B0;
  t['afii57800'] = 0x05B2;
  t['afii57801'] = 0x05B1;
  t['afii57802'] = 0x05B3;
  t['afii57803'] = 0x05C2;
  t['afii57804'] = 0x05C1;
  t['afii57806'] = 0x05B9;
  t['afii57807'] = 0x05BC;
  t['afii57839'] = 0x05BD;
  t['afii57841'] = 0x05BF;
  t['afii57842'] = 0x05C0;
  t['afii57929'] = 0x02BC;
  t['afii61248'] = 0x2105;
  t['afii61289'] = 0x2113;
  t['afii61352'] = 0x2116;
  t['afii61573'] = 0x202C;
  t['afii61574'] = 0x202D;
  t['afii61575'] = 0x202E;
  t['afii61664'] = 0x200C;
  t['afii63167'] = 0x066D;
  t['afii64937'] = 0x02BD;
  t['agrave'] = 0x00E0;
  t['agujarati'] = 0x0A85;
  t['agurmukhi'] = 0x0A05;
  t['ahiragana'] = 0x3042;
  t['ahookabove'] = 0x1EA3;
  t['aibengali'] = 0x0990;
  t['aibopomofo'] = 0x311E;
  t['aideva'] = 0x0910;
  t['aiecyrillic'] = 0x04D5;
  t['aigujarati'] = 0x0A90;
  t['aigurmukhi'] = 0x0A10;
  t['aimatragurmukhi'] = 0x0A48;
  t['ainarabic'] = 0x0639;
  t['ainfinalarabic'] = 0xFECA;
  t['aininitialarabic'] = 0xFECB;
  t['ainmedialarabic'] = 0xFECC;
  t['ainvertedbreve'] = 0x0203;
  t['aivowelsignbengali'] = 0x09C8;
  t['aivowelsigndeva'] = 0x0948;
  t['aivowelsigngujarati'] = 0x0AC8;
  t['akatakana'] = 0x30A2;
  t['akatakanahalfwidth'] = 0xFF71;
  t['akorean'] = 0x314F;
  t['alef'] = 0x05D0;
  t['alefarabic'] = 0x0627;
  t['alefdageshhebrew'] = 0xFB30;
  t['aleffinalarabic'] = 0xFE8E;
  t['alefhamzaabovearabic'] = 0x0623;
  t['alefhamzaabovefinalarabic'] = 0xFE84;
  t['alefhamzabelowarabic'] = 0x0625;
  t['alefhamzabelowfinalarabic'] = 0xFE88;
  t['alefhebrew'] = 0x05D0;
  t['aleflamedhebrew'] = 0xFB4F;
  t['alefmaddaabovearabic'] = 0x0622;
  t['alefmaddaabovefinalarabic'] = 0xFE82;
  t['alefmaksuraarabic'] = 0x0649;
  t['alefmaksurafinalarabic'] = 0xFEF0;
  t['alefmaksurainitialarabic'] = 0xFEF3;
  t['alefmaksuramedialarabic'] = 0xFEF4;
  t['alefpatahhebrew'] = 0xFB2E;
  t['alefqamatshebrew'] = 0xFB2F;
  t['aleph'] = 0x2135;
  t['allequal'] = 0x224C;
  t['alpha'] = 0x03B1;
  t['alphatonos'] = 0x03AC;
  t['amacron'] = 0x0101;
  t['amonospace'] = 0xFF41;
  t['ampersand'] = 0x0026;
  t['ampersandmonospace'] = 0xFF06;
  t['ampersandsmall'] = 0xF726;
  t['amsquare'] = 0x33C2;
  t['anbopomofo'] = 0x3122;
  t['angbopomofo'] = 0x3124;
  t['angbracketleft'] = 0x3008;
  t['angbracketright'] = 0x3009;
  t['angkhankhuthai'] = 0x0E5A;
  t['angle'] = 0x2220;
  t['anglebracketleft'] = 0x3008;
  t['anglebracketleftvertical'] = 0xFE3F;
  t['anglebracketright'] = 0x3009;
  t['anglebracketrightvertical'] = 0xFE40;
  t['angleleft'] = 0x2329;
  t['angleright'] = 0x232A;
  t['angstrom'] = 0x212B;
  t['anoteleia'] = 0x0387;
  t['anudattadeva'] = 0x0952;
  t['anusvarabengali'] = 0x0982;
  t['anusvaradeva'] = 0x0902;
  t['anusvaragujarati'] = 0x0A82;
  t['aogonek'] = 0x0105;
  t['apaatosquare'] = 0x3300;
  t['aparen'] = 0x249C;
  t['apostrophearmenian'] = 0x055A;
  t['apostrophemod'] = 0x02BC;
  t['apple'] = 0xF8FF;
  t['approaches'] = 0x2250;
  t['approxequal'] = 0x2248;
  t['approxequalorimage'] = 0x2252;
  t['approximatelyequal'] = 0x2245;
  t['araeaekorean'] = 0x318E;
  t['araeakorean'] = 0x318D;
  t['arc'] = 0x2312;
  t['arighthalfring'] = 0x1E9A;
  t['aring'] = 0x00E5;
  t['aringacute'] = 0x01FB;
  t['aringbelow'] = 0x1E01;
  t['arrowboth'] = 0x2194;
  t['arrowdashdown'] = 0x21E3;
  t['arrowdashleft'] = 0x21E0;
  t['arrowdashright'] = 0x21E2;
  t['arrowdashup'] = 0x21E1;
  t['arrowdblboth'] = 0x21D4;
  t['arrowdbldown'] = 0x21D3;
  t['arrowdblleft'] = 0x21D0;
  t['arrowdblright'] = 0x21D2;
  t['arrowdblup'] = 0x21D1;
  t['arrowdown'] = 0x2193;
  t['arrowdownleft'] = 0x2199;
  t['arrowdownright'] = 0x2198;
  t['arrowdownwhite'] = 0x21E9;
  t['arrowheaddownmod'] = 0x02C5;
  t['arrowheadleftmod'] = 0x02C2;
  t['arrowheadrightmod'] = 0x02C3;
  t['arrowheadupmod'] = 0x02C4;
  t['arrowhorizex'] = 0xF8E7;
  t['arrowleft'] = 0x2190;
  t['arrowleftdbl'] = 0x21D0;
  t['arrowleftdblstroke'] = 0x21CD;
  t['arrowleftoverright'] = 0x21C6;
  t['arrowleftwhite'] = 0x21E6;
  t['arrowright'] = 0x2192;
  t['arrowrightdblstroke'] = 0x21CF;
  t['arrowrightheavy'] = 0x279E;
  t['arrowrightoverleft'] = 0x21C4;
  t['arrowrightwhite'] = 0x21E8;
  t['arrowtableft'] = 0x21E4;
  t['arrowtabright'] = 0x21E5;
  t['arrowup'] = 0x2191;
  t['arrowupdn'] = 0x2195;
  t['arrowupdnbse'] = 0x21A8;
  t['arrowupdownbase'] = 0x21A8;
  t['arrowupleft'] = 0x2196;
  t['arrowupleftofdown'] = 0x21C5;
  t['arrowupright'] = 0x2197;
  t['arrowupwhite'] = 0x21E7;
  t['arrowvertex'] = 0xF8E6;
  t['asciicircum'] = 0x005E;
  t['asciicircummonospace'] = 0xFF3E;
  t['asciitilde'] = 0x007E;
  t['asciitildemonospace'] = 0xFF5E;
  t['ascript'] = 0x0251;
  t['ascriptturned'] = 0x0252;
  t['asmallhiragana'] = 0x3041;
  t['asmallkatakana'] = 0x30A1;
  t['asmallkatakanahalfwidth'] = 0xFF67;
  t['asterisk'] = 0x002A;
  t['asteriskaltonearabic'] = 0x066D;
  t['asteriskarabic'] = 0x066D;
  t['asteriskmath'] = 0x2217;
  t['asteriskmonospace'] = 0xFF0A;
  t['asterisksmall'] = 0xFE61;
  t['asterism'] = 0x2042;
  t['asuperior'] = 0xF6E9;
  t['asymptoticallyequal'] = 0x2243;
  t['at'] = 0x0040;
  t['atilde'] = 0x00E3;
  t['atmonospace'] = 0xFF20;
  t['atsmall'] = 0xFE6B;
  t['aturned'] = 0x0250;
  t['aubengali'] = 0x0994;
  t['aubopomofo'] = 0x3120;
  t['audeva'] = 0x0914;
  t['augujarati'] = 0x0A94;
  t['augurmukhi'] = 0x0A14;
  t['aulengthmarkbengali'] = 0x09D7;
  t['aumatragurmukhi'] = 0x0A4C;
  t['auvowelsignbengali'] = 0x09CC;
  t['auvowelsigndeva'] = 0x094C;
  t['auvowelsigngujarati'] = 0x0ACC;
  t['avagrahadeva'] = 0x093D;
  t['aybarmenian'] = 0x0561;
  t['ayin'] = 0x05E2;
  t['ayinaltonehebrew'] = 0xFB20;
  t['ayinhebrew'] = 0x05E2;
  t['b'] = 0x0062;
  t['babengali'] = 0x09AC;
  t['backslash'] = 0x005C;
  t['backslashmonospace'] = 0xFF3C;
  t['badeva'] = 0x092C;
  t['bagujarati'] = 0x0AAC;
  t['bagurmukhi'] = 0x0A2C;
  t['bahiragana'] = 0x3070;
  t['bahtthai'] = 0x0E3F;
  t['bakatakana'] = 0x30D0;
  t['bar'] = 0x007C;
  t['barmonospace'] = 0xFF5C;
  t['bbopomofo'] = 0x3105;
  t['bcircle'] = 0x24D1;
  t['bdotaccent'] = 0x1E03;
  t['bdotbelow'] = 0x1E05;
  t['beamedsixteenthnotes'] = 0x266C;
  t['because'] = 0x2235;
  t['becyrillic'] = 0x0431;
  t['beharabic'] = 0x0628;
  t['behfinalarabic'] = 0xFE90;
  t['behinitialarabic'] = 0xFE91;
  t['behiragana'] = 0x3079;
  t['behmedialarabic'] = 0xFE92;
  t['behmeeminitialarabic'] = 0xFC9F;
  t['behmeemisolatedarabic'] = 0xFC08;
  t['behnoonfinalarabic'] = 0xFC6D;
  t['bekatakana'] = 0x30D9;
  t['benarmenian'] = 0x0562;
  t['bet'] = 0x05D1;
  t['beta'] = 0x03B2;
  t['betasymbolgreek'] = 0x03D0;
  t['betdagesh'] = 0xFB31;
  t['betdageshhebrew'] = 0xFB31;
  t['bethebrew'] = 0x05D1;
  t['betrafehebrew'] = 0xFB4C;
  t['bhabengali'] = 0x09AD;
  t['bhadeva'] = 0x092D;
  t['bhagujarati'] = 0x0AAD;
  t['bhagurmukhi'] = 0x0A2D;
  t['bhook'] = 0x0253;
  t['bihiragana'] = 0x3073;
  t['bikatakana'] = 0x30D3;
  t['bilabialclick'] = 0x0298;
  t['bindigurmukhi'] = 0x0A02;
  t['birusquare'] = 0x3331;
  t['blackcircle'] = 0x25CF;
  t['blackdiamond'] = 0x25C6;
  t['blackdownpointingtriangle'] = 0x25BC;
  t['blackleftpointingpointer'] = 0x25C4;
  t['blackleftpointingtriangle'] = 0x25C0;
  t['blacklenticularbracketleft'] = 0x3010;
  t['blacklenticularbracketleftvertical'] = 0xFE3B;
  t['blacklenticularbracketright'] = 0x3011;
  t['blacklenticularbracketrightvertical'] = 0xFE3C;
  t['blacklowerlefttriangle'] = 0x25E3;
  t['blacklowerrighttriangle'] = 0x25E2;
  t['blackrectangle'] = 0x25AC;
  t['blackrightpointingpointer'] = 0x25BA;
  t['blackrightpointingtriangle'] = 0x25B6;
  t['blacksmallsquare'] = 0x25AA;
  t['blacksmilingface'] = 0x263B;
  t['blacksquare'] = 0x25A0;
  t['blackstar'] = 0x2605;
  t['blackupperlefttriangle'] = 0x25E4;
  t['blackupperrighttriangle'] = 0x25E5;
  t['blackuppointingsmalltriangle'] = 0x25B4;
  t['blackuppointingtriangle'] = 0x25B2;
  t['blank'] = 0x2423;
  t['blinebelow'] = 0x1E07;
  t['block'] = 0x2588;
  t['bmonospace'] = 0xFF42;
  t['bobaimaithai'] = 0x0E1A;
  t['bohiragana'] = 0x307C;
  t['bokatakana'] = 0x30DC;
  t['bparen'] = 0x249D;
  t['bqsquare'] = 0x33C3;
  t['braceex'] = 0xF8F4;
  t['braceleft'] = 0x007B;
  t['braceleftbt'] = 0xF8F3;
  t['braceleftmid'] = 0xF8F2;
  t['braceleftmonospace'] = 0xFF5B;
  t['braceleftsmall'] = 0xFE5B;
  t['bracelefttp'] = 0xF8F1;
  t['braceleftvertical'] = 0xFE37;
  t['braceright'] = 0x007D;
  t['bracerightbt'] = 0xF8FE;
  t['bracerightmid'] = 0xF8FD;
  t['bracerightmonospace'] = 0xFF5D;
  t['bracerightsmall'] = 0xFE5C;
  t['bracerighttp'] = 0xF8FC;
  t['bracerightvertical'] = 0xFE38;
  t['bracketleft'] = 0x005B;
  t['bracketleftbt'] = 0xF8F0;
  t['bracketleftex'] = 0xF8EF;
  t['bracketleftmonospace'] = 0xFF3B;
  t['bracketlefttp'] = 0xF8EE;
  t['bracketright'] = 0x005D;
  t['bracketrightbt'] = 0xF8FB;
  t['bracketrightex'] = 0xF8FA;
  t['bracketrightmonospace'] = 0xFF3D;
  t['bracketrighttp'] = 0xF8F9;
  t['breve'] = 0x02D8;
  t['brevebelowcmb'] = 0x032E;
  t['brevecmb'] = 0x0306;
  t['breveinvertedbelowcmb'] = 0x032F;
  t['breveinvertedcmb'] = 0x0311;
  t['breveinverteddoublecmb'] = 0x0361;
  t['bridgebelowcmb'] = 0x032A;
  t['bridgeinvertedbelowcmb'] = 0x033A;
  t['brokenbar'] = 0x00A6;
  t['bstroke'] = 0x0180;
  t['bsuperior'] = 0xF6EA;
  t['btopbar'] = 0x0183;
  t['buhiragana'] = 0x3076;
  t['bukatakana'] = 0x30D6;
  t['bullet'] = 0x2022;
  t['bulletinverse'] = 0x25D8;
  t['bulletoperator'] = 0x2219;
  t['bullseye'] = 0x25CE;
  t['c'] = 0x0063;
  t['caarmenian'] = 0x056E;
  t['cabengali'] = 0x099A;
  t['cacute'] = 0x0107;
  t['cadeva'] = 0x091A;
  t['cagujarati'] = 0x0A9A;
  t['cagurmukhi'] = 0x0A1A;
  t['calsquare'] = 0x3388;
  t['candrabindubengali'] = 0x0981;
  t['candrabinducmb'] = 0x0310;
  t['candrabindudeva'] = 0x0901;
  t['candrabindugujarati'] = 0x0A81;
  t['capslock'] = 0x21EA;
  t['careof'] = 0x2105;
  t['caron'] = 0x02C7;
  t['caronbelowcmb'] = 0x032C;
  t['caroncmb'] = 0x030C;
  t['carriagereturn'] = 0x21B5;
  t['cbopomofo'] = 0x3118;
  t['ccaron'] = 0x010D;
  t['ccedilla'] = 0x00E7;
  t['ccedillaacute'] = 0x1E09;
  t['ccircle'] = 0x24D2;
  t['ccircumflex'] = 0x0109;
  t['ccurl'] = 0x0255;
  t['cdot'] = 0x010B;
  t['cdotaccent'] = 0x010B;
  t['cdsquare'] = 0x33C5;
  t['cedilla'] = 0x00B8;
  t['cedillacmb'] = 0x0327;
  t['cent'] = 0x00A2;
  t['centigrade'] = 0x2103;
  t['centinferior'] = 0xF6DF;
  t['centmonospace'] = 0xFFE0;
  t['centoldstyle'] = 0xF7A2;
  t['centsuperior'] = 0xF6E0;
  t['chaarmenian'] = 0x0579;
  t['chabengali'] = 0x099B;
  t['chadeva'] = 0x091B;
  t['chagujarati'] = 0x0A9B;
  t['chagurmukhi'] = 0x0A1B;
  t['chbopomofo'] = 0x3114;
  t['cheabkhasiancyrillic'] = 0x04BD;
  t['checkmark'] = 0x2713;
  t['checyrillic'] = 0x0447;
  t['chedescenderabkhasiancyrillic'] = 0x04BF;
  t['chedescendercyrillic'] = 0x04B7;
  t['chedieresiscyrillic'] = 0x04F5;
  t['cheharmenian'] = 0x0573;
  t['chekhakassiancyrillic'] = 0x04CC;
  t['cheverticalstrokecyrillic'] = 0x04B9;
  t['chi'] = 0x03C7;
  t['chieuchacirclekorean'] = 0x3277;
  t['chieuchaparenkorean'] = 0x3217;
  t['chieuchcirclekorean'] = 0x3269;
  t['chieuchkorean'] = 0x314A;
  t['chieuchparenkorean'] = 0x3209;
  t['chochangthai'] = 0x0E0A;
  t['chochanthai'] = 0x0E08;
  t['chochingthai'] = 0x0E09;
  t['chochoethai'] = 0x0E0C;
  t['chook'] = 0x0188;
  t['cieucacirclekorean'] = 0x3276;
  t['cieucaparenkorean'] = 0x3216;
  t['cieuccirclekorean'] = 0x3268;
  t['cieuckorean'] = 0x3148;
  t['cieucparenkorean'] = 0x3208;
  t['cieucuparenkorean'] = 0x321C;
  t['circle'] = 0x25CB;
  t['circlecopyrt'] = 0x00A9;
  t['circlemultiply'] = 0x2297;
  t['circleot'] = 0x2299;
  t['circleplus'] = 0x2295;
  t['circlepostalmark'] = 0x3036;
  t['circlewithlefthalfblack'] = 0x25D0;
  t['circlewithrighthalfblack'] = 0x25D1;
  t['circumflex'] = 0x02C6;
  t['circumflexbelowcmb'] = 0x032D;
  t['circumflexcmb'] = 0x0302;
  t['clear'] = 0x2327;
  t['clickalveolar'] = 0x01C2;
  t['clickdental'] = 0x01C0;
  t['clicklateral'] = 0x01C1;
  t['clickretroflex'] = 0x01C3;
  t['club'] = 0x2663;
  t['clubsuitblack'] = 0x2663;
  t['clubsuitwhite'] = 0x2667;
  t['cmcubedsquare'] = 0x33A4;
  t['cmonospace'] = 0xFF43;
  t['cmsquaredsquare'] = 0x33A0;
  t['coarmenian'] = 0x0581;
  t['colon'] = 0x003A;
  t['colonmonetary'] = 0x20A1;
  t['colonmonospace'] = 0xFF1A;
  t['colonsign'] = 0x20A1;
  t['colonsmall'] = 0xFE55;
  t['colontriangularhalfmod'] = 0x02D1;
  t['colontriangularmod'] = 0x02D0;
  t['comma'] = 0x002C;
  t['commaabovecmb'] = 0x0313;
  t['commaaboverightcmb'] = 0x0315;
  t['commaaccent'] = 0xF6C3;
  t['commaarabic'] = 0x060C;
  t['commaarmenian'] = 0x055D;
  t['commainferior'] = 0xF6E1;
  t['commamonospace'] = 0xFF0C;
  t['commareversedabovecmb'] = 0x0314;
  t['commareversedmod'] = 0x02BD;
  t['commasmall'] = 0xFE50;
  t['commasuperior'] = 0xF6E2;
  t['commaturnedabovecmb'] = 0x0312;
  t['commaturnedmod'] = 0x02BB;
  t['compass'] = 0x263C;
  t['congruent'] = 0x2245;
  t['contourintegral'] = 0x222E;
  t['control'] = 0x2303;
  t['controlACK'] = 0x0006;
  t['controlBEL'] = 0x0007;
  t['controlBS'] = 0x0008;
  t['controlCAN'] = 0x0018;
  t['controlCR'] = 0x000D;
  t['controlDC1'] = 0x0011;
  t['controlDC2'] = 0x0012;
  t['controlDC3'] = 0x0013;
  t['controlDC4'] = 0x0014;
  t['controlDEL'] = 0x007F;
  t['controlDLE'] = 0x0010;
  t['controlEM'] = 0x0019;
  t['controlENQ'] = 0x0005;
  t['controlEOT'] = 0x0004;
  t['controlESC'] = 0x001B;
  t['controlETB'] = 0x0017;
  t['controlETX'] = 0x0003;
  t['controlFF'] = 0x000C;
  t['controlFS'] = 0x001C;
  t['controlGS'] = 0x001D;
  t['controlHT'] = 0x0009;
  t['controlLF'] = 0x000A;
  t['controlNAK'] = 0x0015;
  t['controlNULL'] = 0x0000;
  t['controlRS'] = 0x001E;
  t['controlSI'] = 0x000F;
  t['controlSO'] = 0x000E;
  t['controlSOT'] = 0x0002;
  t['controlSTX'] = 0x0001;
  t['controlSUB'] = 0x001A;
  t['controlSYN'] = 0x0016;
  t['controlUS'] = 0x001F;
  t['controlVT'] = 0x000B;
  t['copyright'] = 0x00A9;
  t['copyrightsans'] = 0xF8E9;
  t['copyrightserif'] = 0xF6D9;
  t['cornerbracketleft'] = 0x300C;
  t['cornerbracketlefthalfwidth'] = 0xFF62;
  t['cornerbracketleftvertical'] = 0xFE41;
  t['cornerbracketright'] = 0x300D;
  t['cornerbracketrighthalfwidth'] = 0xFF63;
  t['cornerbracketrightvertical'] = 0xFE42;
  t['corporationsquare'] = 0x337F;
  t['cosquare'] = 0x33C7;
  t['coverkgsquare'] = 0x33C6;
  t['cparen'] = 0x249E;
  t['cruzeiro'] = 0x20A2;
  t['cstretched'] = 0x0297;
  t['curlyand'] = 0x22CF;
  t['curlyor'] = 0x22CE;
  t['currency'] = 0x00A4;
  t['cyrBreve'] = 0xF6D1;
  t['cyrFlex'] = 0xF6D2;
  t['cyrbreve'] = 0xF6D4;
  t['cyrflex'] = 0xF6D5;
  t['d'] = 0x0064;
  t['daarmenian'] = 0x0564;
  t['dabengali'] = 0x09A6;
  t['dadarabic'] = 0x0636;
  t['dadeva'] = 0x0926;
  t['dadfinalarabic'] = 0xFEBE;
  t['dadinitialarabic'] = 0xFEBF;
  t['dadmedialarabic'] = 0xFEC0;
  t['dagesh'] = 0x05BC;
  t['dageshhebrew'] = 0x05BC;
  t['dagger'] = 0x2020;
  t['daggerdbl'] = 0x2021;
  t['dagujarati'] = 0x0AA6;
  t['dagurmukhi'] = 0x0A26;
  t['dahiragana'] = 0x3060;
  t['dakatakana'] = 0x30C0;
  t['dalarabic'] = 0x062F;
  t['dalet'] = 0x05D3;
  t['daletdagesh'] = 0xFB33;
  t['daletdageshhebrew'] = 0xFB33;
  t['dalethebrew'] = 0x05D3;
  t['dalfinalarabic'] = 0xFEAA;
  t['dammaarabic'] = 0x064F;
  t['dammalowarabic'] = 0x064F;
  t['dammatanaltonearabic'] = 0x064C;
  t['dammatanarabic'] = 0x064C;
  t['danda'] = 0x0964;
  t['dargahebrew'] = 0x05A7;
  t['dargalefthebrew'] = 0x05A7;
  t['dasiapneumatacyrilliccmb'] = 0x0485;
  t['dblGrave'] = 0xF6D3;
  t['dblanglebracketleft'] = 0x300A;
  t['dblanglebracketleftvertical'] = 0xFE3D;
  t['dblanglebracketright'] = 0x300B;
  t['dblanglebracketrightvertical'] = 0xFE3E;
  t['dblarchinvertedbelowcmb'] = 0x032B;
  t['dblarrowleft'] = 0x21D4;
  t['dblarrowright'] = 0x21D2;
  t['dbldanda'] = 0x0965;
  t['dblgrave'] = 0xF6D6;
  t['dblgravecmb'] = 0x030F;
  t['dblintegral'] = 0x222C;
  t['dbllowline'] = 0x2017;
  t['dbllowlinecmb'] = 0x0333;
  t['dbloverlinecmb'] = 0x033F;
  t['dblprimemod'] = 0x02BA;
  t['dblverticalbar'] = 0x2016;
  t['dblverticallineabovecmb'] = 0x030E;
  t['dbopomofo'] = 0x3109;
  t['dbsquare'] = 0x33C8;
  t['dcaron'] = 0x010F;
  t['dcedilla'] = 0x1E11;
  t['dcircle'] = 0x24D3;
  t['dcircumflexbelow'] = 0x1E13;
  t['dcroat'] = 0x0111;
  t['ddabengali'] = 0x09A1;
  t['ddadeva'] = 0x0921;
  t['ddagujarati'] = 0x0AA1;
  t['ddagurmukhi'] = 0x0A21;
  t['ddalarabic'] = 0x0688;
  t['ddalfinalarabic'] = 0xFB89;
  t['dddhadeva'] = 0x095C;
  t['ddhabengali'] = 0x09A2;
  t['ddhadeva'] = 0x0922;
  t['ddhagujarati'] = 0x0AA2;
  t['ddhagurmukhi'] = 0x0A22;
  t['ddotaccent'] = 0x1E0B;
  t['ddotbelow'] = 0x1E0D;
  t['decimalseparatorarabic'] = 0x066B;
  t['decimalseparatorpersian'] = 0x066B;
  t['decyrillic'] = 0x0434;
  t['degree'] = 0x00B0;
  t['dehihebrew'] = 0x05AD;
  t['dehiragana'] = 0x3067;
  t['deicoptic'] = 0x03EF;
  t['dekatakana'] = 0x30C7;
  t['deleteleft'] = 0x232B;
  t['deleteright'] = 0x2326;
  t['delta'] = 0x03B4;
  t['deltaturned'] = 0x018D;
  t['denominatorminusonenumeratorbengali'] = 0x09F8;
  t['dezh'] = 0x02A4;
  t['dhabengali'] = 0x09A7;
  t['dhadeva'] = 0x0927;
  t['dhagujarati'] = 0x0AA7;
  t['dhagurmukhi'] = 0x0A27;
  t['dhook'] = 0x0257;
  t['dialytikatonos'] = 0x0385;
  t['dialytikatonoscmb'] = 0x0344;
  t['diamond'] = 0x2666;
  t['diamondsuitwhite'] = 0x2662;
  t['dieresis'] = 0x00A8;
  t['dieresisacute'] = 0xF6D7;
  t['dieresisbelowcmb'] = 0x0324;
  t['dieresiscmb'] = 0x0308;
  t['dieresisgrave'] = 0xF6D8;
  t['dieresistonos'] = 0x0385;
  t['dihiragana'] = 0x3062;
  t['dikatakana'] = 0x30C2;
  t['dittomark'] = 0x3003;
  t['divide'] = 0x00F7;
  t['divides'] = 0x2223;
  t['divisionslash'] = 0x2215;
  t['djecyrillic'] = 0x0452;
  t['dkshade'] = 0x2593;
  t['dlinebelow'] = 0x1E0F;
  t['dlsquare'] = 0x3397;
  t['dmacron'] = 0x0111;
  t['dmonospace'] = 0xFF44;
  t['dnblock'] = 0x2584;
  t['dochadathai'] = 0x0E0E;
  t['dodekthai'] = 0x0E14;
  t['dohiragana'] = 0x3069;
  t['dokatakana'] = 0x30C9;
  t['dollar'] = 0x0024;
  t['dollarinferior'] = 0xF6E3;
  t['dollarmonospace'] = 0xFF04;
  t['dollaroldstyle'] = 0xF724;
  t['dollarsmall'] = 0xFE69;
  t['dollarsuperior'] = 0xF6E4;
  t['dong'] = 0x20AB;
  t['dorusquare'] = 0x3326;
  t['dotaccent'] = 0x02D9;
  t['dotaccentcmb'] = 0x0307;
  t['dotbelowcmb'] = 0x0323;
  t['dotbelowcomb'] = 0x0323;
  t['dotkatakana'] = 0x30FB;
  t['dotlessi'] = 0x0131;
  t['dotlessj'] = 0xF6BE;
  t['dotlessjstrokehook'] = 0x0284;
  t['dotmath'] = 0x22C5;
  t['dottedcircle'] = 0x25CC;
  t['doubleyodpatah'] = 0xFB1F;
  t['doubleyodpatahhebrew'] = 0xFB1F;
  t['downtackbelowcmb'] = 0x031E;
  t['downtackmod'] = 0x02D5;
  t['dparen'] = 0x249F;
  t['dsuperior'] = 0xF6EB;
  t['dtail'] = 0x0256;
  t['dtopbar'] = 0x018C;
  t['duhiragana'] = 0x3065;
  t['dukatakana'] = 0x30C5;
  t['dz'] = 0x01F3;
  t['dzaltone'] = 0x02A3;
  t['dzcaron'] = 0x01C6;
  t['dzcurl'] = 0x02A5;
  t['dzeabkhasiancyrillic'] = 0x04E1;
  t['dzecyrillic'] = 0x0455;
  t['dzhecyrillic'] = 0x045F;
  t['e'] = 0x0065;
  t['eacute'] = 0x00E9;
  t['earth'] = 0x2641;
  t['ebengali'] = 0x098F;
  t['ebopomofo'] = 0x311C;
  t['ebreve'] = 0x0115;
  t['ecandradeva'] = 0x090D;
  t['ecandragujarati'] = 0x0A8D;
  t['ecandravowelsigndeva'] = 0x0945;
  t['ecandravowelsigngujarati'] = 0x0AC5;
  t['ecaron'] = 0x011B;
  t['ecedillabreve'] = 0x1E1D;
  t['echarmenian'] = 0x0565;
  t['echyiwnarmenian'] = 0x0587;
  t['ecircle'] = 0x24D4;
  t['ecircumflex'] = 0x00EA;
  t['ecircumflexacute'] = 0x1EBF;
  t['ecircumflexbelow'] = 0x1E19;
  t['ecircumflexdotbelow'] = 0x1EC7;
  t['ecircumflexgrave'] = 0x1EC1;
  t['ecircumflexhookabove'] = 0x1EC3;
  t['ecircumflextilde'] = 0x1EC5;
  t['ecyrillic'] = 0x0454;
  t['edblgrave'] = 0x0205;
  t['edeva'] = 0x090F;
  t['edieresis'] = 0x00EB;
  t['edot'] = 0x0117;
  t['edotaccent'] = 0x0117;
  t['edotbelow'] = 0x1EB9;
  t['eegurmukhi'] = 0x0A0F;
  t['eematragurmukhi'] = 0x0A47;
  t['efcyrillic'] = 0x0444;
  t['egrave'] = 0x00E8;
  t['egujarati'] = 0x0A8F;
  t['eharmenian'] = 0x0567;
  t['ehbopomofo'] = 0x311D;
  t['ehiragana'] = 0x3048;
  t['ehookabove'] = 0x1EBB;
  t['eibopomofo'] = 0x311F;
  t['eight'] = 0x0038;
  t['eightarabic'] = 0x0668;
  t['eightbengali'] = 0x09EE;
  t['eightcircle'] = 0x2467;
  t['eightcircleinversesansserif'] = 0x2791;
  t['eightdeva'] = 0x096E;
  t['eighteencircle'] = 0x2471;
  t['eighteenparen'] = 0x2485;
  t['eighteenperiod'] = 0x2499;
  t['eightgujarati'] = 0x0AEE;
  t['eightgurmukhi'] = 0x0A6E;
  t['eighthackarabic'] = 0x0668;
  t['eighthangzhou'] = 0x3028;
  t['eighthnotebeamed'] = 0x266B;
  t['eightideographicparen'] = 0x3227;
  t['eightinferior'] = 0x2088;
  t['eightmonospace'] = 0xFF18;
  t['eightoldstyle'] = 0xF738;
  t['eightparen'] = 0x247B;
  t['eightperiod'] = 0x248F;
  t['eightpersian'] = 0x06F8;
  t['eightroman'] = 0x2177;
  t['eightsuperior'] = 0x2078;
  t['eightthai'] = 0x0E58;
  t['einvertedbreve'] = 0x0207;
  t['eiotifiedcyrillic'] = 0x0465;
  t['ekatakana'] = 0x30A8;
  t['ekatakanahalfwidth'] = 0xFF74;
  t['ekonkargurmukhi'] = 0x0A74;
  t['ekorean'] = 0x3154;
  t['elcyrillic'] = 0x043B;
  t['element'] = 0x2208;
  t['elevencircle'] = 0x246A;
  t['elevenparen'] = 0x247E;
  t['elevenperiod'] = 0x2492;
  t['elevenroman'] = 0x217A;
  t['ellipsis'] = 0x2026;
  t['ellipsisvertical'] = 0x22EE;
  t['emacron'] = 0x0113;
  t['emacronacute'] = 0x1E17;
  t['emacrongrave'] = 0x1E15;
  t['emcyrillic'] = 0x043C;
  t['emdash'] = 0x2014;
  t['emdashvertical'] = 0xFE31;
  t['emonospace'] = 0xFF45;
  t['emphasismarkarmenian'] = 0x055B;
  t['emptyset'] = 0x2205;
  t['enbopomofo'] = 0x3123;
  t['encyrillic'] = 0x043D;
  t['endash'] = 0x2013;
  t['endashvertical'] = 0xFE32;
  t['endescendercyrillic'] = 0x04A3;
  t['eng'] = 0x014B;
  t['engbopomofo'] = 0x3125;
  t['enghecyrillic'] = 0x04A5;
  t['enhookcyrillic'] = 0x04C8;
  t['enspace'] = 0x2002;
  t['eogonek'] = 0x0119;
  t['eokorean'] = 0x3153;
  t['eopen'] = 0x025B;
  t['eopenclosed'] = 0x029A;
  t['eopenreversed'] = 0x025C;
  t['eopenreversedclosed'] = 0x025E;
  t['eopenreversedhook'] = 0x025D;
  t['eparen'] = 0x24A0;
  t['epsilon'] = 0x03B5;
  t['epsilontonos'] = 0x03AD;
  t['equal'] = 0x003D;
  t['equalmonospace'] = 0xFF1D;
  t['equalsmall'] = 0xFE66;
  t['equalsuperior'] = 0x207C;
  t['equivalence'] = 0x2261;
  t['erbopomofo'] = 0x3126;
  t['ercyrillic'] = 0x0440;
  t['ereversed'] = 0x0258;
  t['ereversedcyrillic'] = 0x044D;
  t['escyrillic'] = 0x0441;
  t['esdescendercyrillic'] = 0x04AB;
  t['esh'] = 0x0283;
  t['eshcurl'] = 0x0286;
  t['eshortdeva'] = 0x090E;
  t['eshortvowelsigndeva'] = 0x0946;
  t['eshreversedloop'] = 0x01AA;
  t['eshsquatreversed'] = 0x0285;
  t['esmallhiragana'] = 0x3047;
  t['esmallkatakana'] = 0x30A7;
  t['esmallkatakanahalfwidth'] = 0xFF6A;
  t['estimated'] = 0x212E;
  t['esuperior'] = 0xF6EC;
  t['eta'] = 0x03B7;
  t['etarmenian'] = 0x0568;
  t['etatonos'] = 0x03AE;
  t['eth'] = 0x00F0;
  t['etilde'] = 0x1EBD;
  t['etildebelow'] = 0x1E1B;
  t['etnahtafoukhhebrew'] = 0x0591;
  t['etnahtafoukhlefthebrew'] = 0x0591;
  t['etnahtahebrew'] = 0x0591;
  t['etnahtalefthebrew'] = 0x0591;
  t['eturned'] = 0x01DD;
  t['eukorean'] = 0x3161;
  t['euro'] = 0x20AC;
  t['evowelsignbengali'] = 0x09C7;
  t['evowelsigndeva'] = 0x0947;
  t['evowelsigngujarati'] = 0x0AC7;
  t['exclam'] = 0x0021;
  t['exclamarmenian'] = 0x055C;
  t['exclamdbl'] = 0x203C;
  t['exclamdown'] = 0x00A1;
  t['exclamdownsmall'] = 0xF7A1;
  t['exclammonospace'] = 0xFF01;
  t['exclamsmall'] = 0xF721;
  t['existential'] = 0x2203;
  t['ezh'] = 0x0292;
  t['ezhcaron'] = 0x01EF;
  t['ezhcurl'] = 0x0293;
  t['ezhreversed'] = 0x01B9;
  t['ezhtail'] = 0x01BA;
  t['f'] = 0x0066;
  t['fadeva'] = 0x095E;
  t['fagurmukhi'] = 0x0A5E;
  t['fahrenheit'] = 0x2109;
  t['fathaarabic'] = 0x064E;
  t['fathalowarabic'] = 0x064E;
  t['fathatanarabic'] = 0x064B;
  t['fbopomofo'] = 0x3108;
  t['fcircle'] = 0x24D5;
  t['fdotaccent'] = 0x1E1F;
  t['feharabic'] = 0x0641;
  t['feharmenian'] = 0x0586;
  t['fehfinalarabic'] = 0xFED2;
  t['fehinitialarabic'] = 0xFED3;
  t['fehmedialarabic'] = 0xFED4;
  t['feicoptic'] = 0x03E5;
  t['female'] = 0x2640;
  t['ff'] = 0xFB00;
  t['ffi'] = 0xFB03;
  t['ffl'] = 0xFB04;
  t['fi'] = 0xFB01;
  t['fifteencircle'] = 0x246E;
  t['fifteenparen'] = 0x2482;
  t['fifteenperiod'] = 0x2496;
  t['figuredash'] = 0x2012;
  t['filledbox'] = 0x25A0;
  t['filledrect'] = 0x25AC;
  t['finalkaf'] = 0x05DA;
  t['finalkafdagesh'] = 0xFB3A;
  t['finalkafdageshhebrew'] = 0xFB3A;
  t['finalkafhebrew'] = 0x05DA;
  t['finalmem'] = 0x05DD;
  t['finalmemhebrew'] = 0x05DD;
  t['finalnun'] = 0x05DF;
  t['finalnunhebrew'] = 0x05DF;
  t['finalpe'] = 0x05E3;
  t['finalpehebrew'] = 0x05E3;
  t['finaltsadi'] = 0x05E5;
  t['finaltsadihebrew'] = 0x05E5;
  t['firsttonechinese'] = 0x02C9;
  t['fisheye'] = 0x25C9;
  t['fitacyrillic'] = 0x0473;
  t['five'] = 0x0035;
  t['fivearabic'] = 0x0665;
  t['fivebengali'] = 0x09EB;
  t['fivecircle'] = 0x2464;
  t['fivecircleinversesansserif'] = 0x278E;
  t['fivedeva'] = 0x096B;
  t['fiveeighths'] = 0x215D;
  t['fivegujarati'] = 0x0AEB;
  t['fivegurmukhi'] = 0x0A6B;
  t['fivehackarabic'] = 0x0665;
  t['fivehangzhou'] = 0x3025;
  t['fiveideographicparen'] = 0x3224;
  t['fiveinferior'] = 0x2085;
  t['fivemonospace'] = 0xFF15;
  t['fiveoldstyle'] = 0xF735;
  t['fiveparen'] = 0x2478;
  t['fiveperiod'] = 0x248C;
  t['fivepersian'] = 0x06F5;
  t['fiveroman'] = 0x2174;
  t['fivesuperior'] = 0x2075;
  t['fivethai'] = 0x0E55;
  t['fl'] = 0xFB02;
  t['florin'] = 0x0192;
  t['fmonospace'] = 0xFF46;
  t['fmsquare'] = 0x3399;
  t['fofanthai'] = 0x0E1F;
  t['fofathai'] = 0x0E1D;
  t['fongmanthai'] = 0x0E4F;
  t['forall'] = 0x2200;
  t['four'] = 0x0034;
  t['fourarabic'] = 0x0664;
  t['fourbengali'] = 0x09EA;
  t['fourcircle'] = 0x2463;
  t['fourcircleinversesansserif'] = 0x278D;
  t['fourdeva'] = 0x096A;
  t['fourgujarati'] = 0x0AEA;
  t['fourgurmukhi'] = 0x0A6A;
  t['fourhackarabic'] = 0x0664;
  t['fourhangzhou'] = 0x3024;
  t['fourideographicparen'] = 0x3223;
  t['fourinferior'] = 0x2084;
  t['fourmonospace'] = 0xFF14;
  t['fournumeratorbengali'] = 0x09F7;
  t['fouroldstyle'] = 0xF734;
  t['fourparen'] = 0x2477;
  t['fourperiod'] = 0x248B;
  t['fourpersian'] = 0x06F4;
  t['fourroman'] = 0x2173;
  t['foursuperior'] = 0x2074;
  t['fourteencircle'] = 0x246D;
  t['fourteenparen'] = 0x2481;
  t['fourteenperiod'] = 0x2495;
  t['fourthai'] = 0x0E54;
  t['fourthtonechinese'] = 0x02CB;
  t['fparen'] = 0x24A1;
  t['fraction'] = 0x2044;
  t['franc'] = 0x20A3;
  t['g'] = 0x0067;
  t['gabengali'] = 0x0997;
  t['gacute'] = 0x01F5;
  t['gadeva'] = 0x0917;
  t['gafarabic'] = 0x06AF;
  t['gaffinalarabic'] = 0xFB93;
  t['gafinitialarabic'] = 0xFB94;
  t['gafmedialarabic'] = 0xFB95;
  t['gagujarati'] = 0x0A97;
  t['gagurmukhi'] = 0x0A17;
  t['gahiragana'] = 0x304C;
  t['gakatakana'] = 0x30AC;
  t['gamma'] = 0x03B3;
  t['gammalatinsmall'] = 0x0263;
  t['gammasuperior'] = 0x02E0;
  t['gangiacoptic'] = 0x03EB;
  t['gbopomofo'] = 0x310D;
  t['gbreve'] = 0x011F;
  t['gcaron'] = 0x01E7;
  t['gcedilla'] = 0x0123;
  t['gcircle'] = 0x24D6;
  t['gcircumflex'] = 0x011D;
  t['gcommaaccent'] = 0x0123;
  t['gdot'] = 0x0121;
  t['gdotaccent'] = 0x0121;
  t['gecyrillic'] = 0x0433;
  t['gehiragana'] = 0x3052;
  t['gekatakana'] = 0x30B2;
  t['geometricallyequal'] = 0x2251;
  t['gereshaccenthebrew'] = 0x059C;
  t['gereshhebrew'] = 0x05F3;
  t['gereshmuqdamhebrew'] = 0x059D;
  t['germandbls'] = 0x00DF;
  t['gershayimaccenthebrew'] = 0x059E;
  t['gershayimhebrew'] = 0x05F4;
  t['getamark'] = 0x3013;
  t['ghabengali'] = 0x0998;
  t['ghadarmenian'] = 0x0572;
  t['ghadeva'] = 0x0918;
  t['ghagujarati'] = 0x0A98;
  t['ghagurmukhi'] = 0x0A18;
  t['ghainarabic'] = 0x063A;
  t['ghainfinalarabic'] = 0xFECE;
  t['ghaininitialarabic'] = 0xFECF;
  t['ghainmedialarabic'] = 0xFED0;
  t['ghemiddlehookcyrillic'] = 0x0495;
  t['ghestrokecyrillic'] = 0x0493;
  t['gheupturncyrillic'] = 0x0491;
  t['ghhadeva'] = 0x095A;
  t['ghhagurmukhi'] = 0x0A5A;
  t['ghook'] = 0x0260;
  t['ghzsquare'] = 0x3393;
  t['gihiragana'] = 0x304E;
  t['gikatakana'] = 0x30AE;
  t['gimarmenian'] = 0x0563;
  t['gimel'] = 0x05D2;
  t['gimeldagesh'] = 0xFB32;
  t['gimeldageshhebrew'] = 0xFB32;
  t['gimelhebrew'] = 0x05D2;
  t['gjecyrillic'] = 0x0453;
  t['glottalinvertedstroke'] = 0x01BE;
  t['glottalstop'] = 0x0294;
  t['glottalstopinverted'] = 0x0296;
  t['glottalstopmod'] = 0x02C0;
  t['glottalstopreversed'] = 0x0295;
  t['glottalstopreversedmod'] = 0x02C1;
  t['glottalstopreversedsuperior'] = 0x02E4;
  t['glottalstopstroke'] = 0x02A1;
  t['glottalstopstrokereversed'] = 0x02A2;
  t['gmacron'] = 0x1E21;
  t['gmonospace'] = 0xFF47;
  t['gohiragana'] = 0x3054;
  t['gokatakana'] = 0x30B4;
  t['gparen'] = 0x24A2;
  t['gpasquare'] = 0x33AC;
  t['gradient'] = 0x2207;
  t['grave'] = 0x0060;
  t['gravebelowcmb'] = 0x0316;
  t['gravecmb'] = 0x0300;
  t['gravecomb'] = 0x0300;
  t['gravedeva'] = 0x0953;
  t['gravelowmod'] = 0x02CE;
  t['gravemonospace'] = 0xFF40;
  t['gravetonecmb'] = 0x0340;
  t['greater'] = 0x003E;
  t['greaterequal'] = 0x2265;
  t['greaterequalorless'] = 0x22DB;
  t['greatermonospace'] = 0xFF1E;
  t['greaterorequivalent'] = 0x2273;
  t['greaterorless'] = 0x2277;
  t['greateroverequal'] = 0x2267;
  t['greatersmall'] = 0xFE65;
  t['gscript'] = 0x0261;
  t['gstroke'] = 0x01E5;
  t['guhiragana'] = 0x3050;
  t['guillemotleft'] = 0x00AB;
  t['guillemotright'] = 0x00BB;
  t['guilsinglleft'] = 0x2039;
  t['guilsinglright'] = 0x203A;
  t['gukatakana'] = 0x30B0;
  t['guramusquare'] = 0x3318;
  t['gysquare'] = 0x33C9;
  t['h'] = 0x0068;
  t['haabkhasiancyrillic'] = 0x04A9;
  t['haaltonearabic'] = 0x06C1;
  t['habengali'] = 0x09B9;
  t['hadescendercyrillic'] = 0x04B3;
  t['hadeva'] = 0x0939;
  t['hagujarati'] = 0x0AB9;
  t['hagurmukhi'] = 0x0A39;
  t['haharabic'] = 0x062D;
  t['hahfinalarabic'] = 0xFEA2;
  t['hahinitialarabic'] = 0xFEA3;
  t['hahiragana'] = 0x306F;
  t['hahmedialarabic'] = 0xFEA4;
  t['haitusquare'] = 0x332A;
  t['hakatakana'] = 0x30CF;
  t['hakatakanahalfwidth'] = 0xFF8A;
  t['halantgurmukhi'] = 0x0A4D;
  t['hamzaarabic'] = 0x0621;
  t['hamzalowarabic'] = 0x0621;
  t['hangulfiller'] = 0x3164;
  t['hardsigncyrillic'] = 0x044A;
  t['harpoonleftbarbup'] = 0x21BC;
  t['harpoonrightbarbup'] = 0x21C0;
  t['hasquare'] = 0x33CA;
  t['hatafpatah'] = 0x05B2;
  t['hatafpatah16'] = 0x05B2;
  t['hatafpatah23'] = 0x05B2;
  t['hatafpatah2f'] = 0x05B2;
  t['hatafpatahhebrew'] = 0x05B2;
  t['hatafpatahnarrowhebrew'] = 0x05B2;
  t['hatafpatahquarterhebrew'] = 0x05B2;
  t['hatafpatahwidehebrew'] = 0x05B2;
  t['hatafqamats'] = 0x05B3;
  t['hatafqamats1b'] = 0x05B3;
  t['hatafqamats28'] = 0x05B3;
  t['hatafqamats34'] = 0x05B3;
  t['hatafqamatshebrew'] = 0x05B3;
  t['hatafqamatsnarrowhebrew'] = 0x05B3;
  t['hatafqamatsquarterhebrew'] = 0x05B3;
  t['hatafqamatswidehebrew'] = 0x05B3;
  t['hatafsegol'] = 0x05B1;
  t['hatafsegol17'] = 0x05B1;
  t['hatafsegol24'] = 0x05B1;
  t['hatafsegol30'] = 0x05B1;
  t['hatafsegolhebrew'] = 0x05B1;
  t['hatafsegolnarrowhebrew'] = 0x05B1;
  t['hatafsegolquarterhebrew'] = 0x05B1;
  t['hatafsegolwidehebrew'] = 0x05B1;
  t['hbar'] = 0x0127;
  t['hbopomofo'] = 0x310F;
  t['hbrevebelow'] = 0x1E2B;
  t['hcedilla'] = 0x1E29;
  t['hcircle'] = 0x24D7;
  t['hcircumflex'] = 0x0125;
  t['hdieresis'] = 0x1E27;
  t['hdotaccent'] = 0x1E23;
  t['hdotbelow'] = 0x1E25;
  t['he'] = 0x05D4;
  t['heart'] = 0x2665;
  t['heartsuitblack'] = 0x2665;
  t['heartsuitwhite'] = 0x2661;
  t['hedagesh'] = 0xFB34;
  t['hedageshhebrew'] = 0xFB34;
  t['hehaltonearabic'] = 0x06C1;
  t['heharabic'] = 0x0647;
  t['hehebrew'] = 0x05D4;
  t['hehfinalaltonearabic'] = 0xFBA7;
  t['hehfinalalttwoarabic'] = 0xFEEA;
  t['hehfinalarabic'] = 0xFEEA;
  t['hehhamzaabovefinalarabic'] = 0xFBA5;
  t['hehhamzaaboveisolatedarabic'] = 0xFBA4;
  t['hehinitialaltonearabic'] = 0xFBA8;
  t['hehinitialarabic'] = 0xFEEB;
  t['hehiragana'] = 0x3078;
  t['hehmedialaltonearabic'] = 0xFBA9;
  t['hehmedialarabic'] = 0xFEEC;
  t['heiseierasquare'] = 0x337B;
  t['hekatakana'] = 0x30D8;
  t['hekatakanahalfwidth'] = 0xFF8D;
  t['hekutaarusquare'] = 0x3336;
  t['henghook'] = 0x0267;
  t['herutusquare'] = 0x3339;
  t['het'] = 0x05D7;
  t['hethebrew'] = 0x05D7;
  t['hhook'] = 0x0266;
  t['hhooksuperior'] = 0x02B1;
  t['hieuhacirclekorean'] = 0x327B;
  t['hieuhaparenkorean'] = 0x321B;
  t['hieuhcirclekorean'] = 0x326D;
  t['hieuhkorean'] = 0x314E;
  t['hieuhparenkorean'] = 0x320D;
  t['hihiragana'] = 0x3072;
  t['hikatakana'] = 0x30D2;
  t['hikatakanahalfwidth'] = 0xFF8B;
  t['hiriq'] = 0x05B4;
  t['hiriq14'] = 0x05B4;
  t['hiriq21'] = 0x05B4;
  t['hiriq2d'] = 0x05B4;
  t['hiriqhebrew'] = 0x05B4;
  t['hiriqnarrowhebrew'] = 0x05B4;
  t['hiriqquarterhebrew'] = 0x05B4;
  t['hiriqwidehebrew'] = 0x05B4;
  t['hlinebelow'] = 0x1E96;
  t['hmonospace'] = 0xFF48;
  t['hoarmenian'] = 0x0570;
  t['hohipthai'] = 0x0E2B;
  t['hohiragana'] = 0x307B;
  t['hokatakana'] = 0x30DB;
  t['hokatakanahalfwidth'] = 0xFF8E;
  t['holam'] = 0x05B9;
  t['holam19'] = 0x05B9;
  t['holam26'] = 0x05B9;
  t['holam32'] = 0x05B9;
  t['holamhebrew'] = 0x05B9;
  t['holamnarrowhebrew'] = 0x05B9;
  t['holamquarterhebrew'] = 0x05B9;
  t['holamwidehebrew'] = 0x05B9;
  t['honokhukthai'] = 0x0E2E;
  t['hookabovecomb'] = 0x0309;
  t['hookcmb'] = 0x0309;
  t['hookpalatalizedbelowcmb'] = 0x0321;
  t['hookretroflexbelowcmb'] = 0x0322;
  t['hoonsquare'] = 0x3342;
  t['horicoptic'] = 0x03E9;
  t['horizontalbar'] = 0x2015;
  t['horncmb'] = 0x031B;
  t['hotsprings'] = 0x2668;
  t['house'] = 0x2302;
  t['hparen'] = 0x24A3;
  t['hsuperior'] = 0x02B0;
  t['hturned'] = 0x0265;
  t['huhiragana'] = 0x3075;
  t['huiitosquare'] = 0x3333;
  t['hukatakana'] = 0x30D5;
  t['hukatakanahalfwidth'] = 0xFF8C;
  t['hungarumlaut'] = 0x02DD;
  t['hungarumlautcmb'] = 0x030B;
  t['hv'] = 0x0195;
  t['hyphen'] = 0x002D;
  t['hypheninferior'] = 0xF6E5;
  t['hyphenmonospace'] = 0xFF0D;
  t['hyphensmall'] = 0xFE63;
  t['hyphensuperior'] = 0xF6E6;
  t['hyphentwo'] = 0x2010;
  t['i'] = 0x0069;
  t['iacute'] = 0x00ED;
  t['iacyrillic'] = 0x044F;
  t['ibengali'] = 0x0987;
  t['ibopomofo'] = 0x3127;
  t['ibreve'] = 0x012D;
  t['icaron'] = 0x01D0;
  t['icircle'] = 0x24D8;
  t['icircumflex'] = 0x00EE;
  t['icyrillic'] = 0x0456;
  t['idblgrave'] = 0x0209;
  t['ideographearthcircle'] = 0x328F;
  t['ideographfirecircle'] = 0x328B;
  t['ideographicallianceparen'] = 0x323F;
  t['ideographiccallparen'] = 0x323A;
  t['ideographiccentrecircle'] = 0x32A5;
  t['ideographicclose'] = 0x3006;
  t['ideographiccomma'] = 0x3001;
  t['ideographiccommaleft'] = 0xFF64;
  t['ideographiccongratulationparen'] = 0x3237;
  t['ideographiccorrectcircle'] = 0x32A3;
  t['ideographicearthparen'] = 0x322F;
  t['ideographicenterpriseparen'] = 0x323D;
  t['ideographicexcellentcircle'] = 0x329D;
  t['ideographicfestivalparen'] = 0x3240;
  t['ideographicfinancialcircle'] = 0x3296;
  t['ideographicfinancialparen'] = 0x3236;
  t['ideographicfireparen'] = 0x322B;
  t['ideographichaveparen'] = 0x3232;
  t['ideographichighcircle'] = 0x32A4;
  t['ideographiciterationmark'] = 0x3005;
  t['ideographiclaborcircle'] = 0x3298;
  t['ideographiclaborparen'] = 0x3238;
  t['ideographicleftcircle'] = 0x32A7;
  t['ideographiclowcircle'] = 0x32A6;
  t['ideographicmedicinecircle'] = 0x32A9;
  t['ideographicmetalparen'] = 0x322E;
  t['ideographicmoonparen'] = 0x322A;
  t['ideographicnameparen'] = 0x3234;
  t['ideographicperiod'] = 0x3002;
  t['ideographicprintcircle'] = 0x329E;
  t['ideographicreachparen'] = 0x3243;
  t['ideographicrepresentparen'] = 0x3239;
  t['ideographicresourceparen'] = 0x323E;
  t['ideographicrightcircle'] = 0x32A8;
  t['ideographicsecretcircle'] = 0x3299;
  t['ideographicselfparen'] = 0x3242;
  t['ideographicsocietyparen'] = 0x3233;
  t['ideographicspace'] = 0x3000;
  t['ideographicspecialparen'] = 0x3235;
  t['ideographicstockparen'] = 0x3231;
  t['ideographicstudyparen'] = 0x323B;
  t['ideographicsunparen'] = 0x3230;
  t['ideographicsuperviseparen'] = 0x323C;
  t['ideographicwaterparen'] = 0x322C;
  t['ideographicwoodparen'] = 0x322D;
  t['ideographiczero'] = 0x3007;
  t['ideographmetalcircle'] = 0x328E;
  t['ideographmooncircle'] = 0x328A;
  t['ideographnamecircle'] = 0x3294;
  t['ideographsuncircle'] = 0x3290;
  t['ideographwatercircle'] = 0x328C;
  t['ideographwoodcircle'] = 0x328D;
  t['ideva'] = 0x0907;
  t['idieresis'] = 0x00EF;
  t['idieresisacute'] = 0x1E2F;
  t['idieresiscyrillic'] = 0x04E5;
  t['idotbelow'] = 0x1ECB;
  t['iebrevecyrillic'] = 0x04D7;
  t['iecyrillic'] = 0x0435;
  t['ieungacirclekorean'] = 0x3275;
  t['ieungaparenkorean'] = 0x3215;
  t['ieungcirclekorean'] = 0x3267;
  t['ieungkorean'] = 0x3147;
  t['ieungparenkorean'] = 0x3207;
  t['igrave'] = 0x00EC;
  t['igujarati'] = 0x0A87;
  t['igurmukhi'] = 0x0A07;
  t['ihiragana'] = 0x3044;
  t['ihookabove'] = 0x1EC9;
  t['iibengali'] = 0x0988;
  t['iicyrillic'] = 0x0438;
  t['iideva'] = 0x0908;
  t['iigujarati'] = 0x0A88;
  t['iigurmukhi'] = 0x0A08;
  t['iimatragurmukhi'] = 0x0A40;
  t['iinvertedbreve'] = 0x020B;
  t['iishortcyrillic'] = 0x0439;
  t['iivowelsignbengali'] = 0x09C0;
  t['iivowelsigndeva'] = 0x0940;
  t['iivowelsigngujarati'] = 0x0AC0;
  t['ij'] = 0x0133;
  t['ikatakana'] = 0x30A4;
  t['ikatakanahalfwidth'] = 0xFF72;
  t['ikorean'] = 0x3163;
  t['ilde'] = 0x02DC;
  t['iluyhebrew'] = 0x05AC;
  t['imacron'] = 0x012B;
  t['imacroncyrillic'] = 0x04E3;
  t['imageorapproximatelyequal'] = 0x2253;
  t['imatragurmukhi'] = 0x0A3F;
  t['imonospace'] = 0xFF49;
  t['increment'] = 0x2206;
  t['infinity'] = 0x221E;
  t['iniarmenian'] = 0x056B;
  t['integral'] = 0x222B;
  t['integralbottom'] = 0x2321;
  t['integralbt'] = 0x2321;
  t['integralex'] = 0xF8F5;
  t['integraltop'] = 0x2320;
  t['integraltp'] = 0x2320;
  t['intersection'] = 0x2229;
  t['intisquare'] = 0x3305;
  t['invbullet'] = 0x25D8;
  t['invcircle'] = 0x25D9;
  t['invsmileface'] = 0x263B;
  t['iocyrillic'] = 0x0451;
  t['iogonek'] = 0x012F;
  t['iota'] = 0x03B9;
  t['iotadieresis'] = 0x03CA;
  t['iotadieresistonos'] = 0x0390;
  t['iotalatin'] = 0x0269;
  t['iotatonos'] = 0x03AF;
  t['iparen'] = 0x24A4;
  t['irigurmukhi'] = 0x0A72;
  t['ismallhiragana'] = 0x3043;
  t['ismallkatakana'] = 0x30A3;
  t['ismallkatakanahalfwidth'] = 0xFF68;
  t['issharbengali'] = 0x09FA;
  t['istroke'] = 0x0268;
  t['isuperior'] = 0xF6ED;
  t['iterationhiragana'] = 0x309D;
  t['iterationkatakana'] = 0x30FD;
  t['itilde'] = 0x0129;
  t['itildebelow'] = 0x1E2D;
  t['iubopomofo'] = 0x3129;
  t['iucyrillic'] = 0x044E;
  t['ivowelsignbengali'] = 0x09BF;
  t['ivowelsigndeva'] = 0x093F;
  t['ivowelsigngujarati'] = 0x0ABF;
  t['izhitsacyrillic'] = 0x0475;
  t['izhitsadblgravecyrillic'] = 0x0477;
  t['j'] = 0x006A;
  t['jaarmenian'] = 0x0571;
  t['jabengali'] = 0x099C;
  t['jadeva'] = 0x091C;
  t['jagujarati'] = 0x0A9C;
  t['jagurmukhi'] = 0x0A1C;
  t['jbopomofo'] = 0x3110;
  t['jcaron'] = 0x01F0;
  t['jcircle'] = 0x24D9;
  t['jcircumflex'] = 0x0135;
  t['jcrossedtail'] = 0x029D;
  t['jdotlessstroke'] = 0x025F;
  t['jecyrillic'] = 0x0458;
  t['jeemarabic'] = 0x062C;
  t['jeemfinalarabic'] = 0xFE9E;
  t['jeeminitialarabic'] = 0xFE9F;
  t['jeemmedialarabic'] = 0xFEA0;
  t['jeharabic'] = 0x0698;
  t['jehfinalarabic'] = 0xFB8B;
  t['jhabengali'] = 0x099D;
  t['jhadeva'] = 0x091D;
  t['jhagujarati'] = 0x0A9D;
  t['jhagurmukhi'] = 0x0A1D;
  t['jheharmenian'] = 0x057B;
  t['jis'] = 0x3004;
  t['jmonospace'] = 0xFF4A;
  t['jparen'] = 0x24A5;
  t['jsuperior'] = 0x02B2;
  t['k'] = 0x006B;
  t['kabashkircyrillic'] = 0x04A1;
  t['kabengali'] = 0x0995;
  t['kacute'] = 0x1E31;
  t['kacyrillic'] = 0x043A;
  t['kadescendercyrillic'] = 0x049B;
  t['kadeva'] = 0x0915;
  t['kaf'] = 0x05DB;
  t['kafarabic'] = 0x0643;
  t['kafdagesh'] = 0xFB3B;
  t['kafdageshhebrew'] = 0xFB3B;
  t['kaffinalarabic'] = 0xFEDA;
  t['kafhebrew'] = 0x05DB;
  t['kafinitialarabic'] = 0xFEDB;
  t['kafmedialarabic'] = 0xFEDC;
  t['kafrafehebrew'] = 0xFB4D;
  t['kagujarati'] = 0x0A95;
  t['kagurmukhi'] = 0x0A15;
  t['kahiragana'] = 0x304B;
  t['kahookcyrillic'] = 0x04C4;
  t['kakatakana'] = 0x30AB;
  t['kakatakanahalfwidth'] = 0xFF76;
  t['kappa'] = 0x03BA;
  t['kappasymbolgreek'] = 0x03F0;
  t['kapyeounmieumkorean'] = 0x3171;
  t['kapyeounphieuphkorean'] = 0x3184;
  t['kapyeounpieupkorean'] = 0x3178;
  t['kapyeounssangpieupkorean'] = 0x3179;
  t['karoriisquare'] = 0x330D;
  t['kashidaautoarabic'] = 0x0640;
  t['kashidaautonosidebearingarabic'] = 0x0640;
  t['kasmallkatakana'] = 0x30F5;
  t['kasquare'] = 0x3384;
  t['kasraarabic'] = 0x0650;
  t['kasratanarabic'] = 0x064D;
  t['kastrokecyrillic'] = 0x049F;
  t['katahiraprolongmarkhalfwidth'] = 0xFF70;
  t['kaverticalstrokecyrillic'] = 0x049D;
  t['kbopomofo'] = 0x310E;
  t['kcalsquare'] = 0x3389;
  t['kcaron'] = 0x01E9;
  t['kcedilla'] = 0x0137;
  t['kcircle'] = 0x24DA;
  t['kcommaaccent'] = 0x0137;
  t['kdotbelow'] = 0x1E33;
  t['keharmenian'] = 0x0584;
  t['kehiragana'] = 0x3051;
  t['kekatakana'] = 0x30B1;
  t['kekatakanahalfwidth'] = 0xFF79;
  t['kenarmenian'] = 0x056F;
  t['kesmallkatakana'] = 0x30F6;
  t['kgreenlandic'] = 0x0138;
  t['khabengali'] = 0x0996;
  t['khacyrillic'] = 0x0445;
  t['khadeva'] = 0x0916;
  t['khagujarati'] = 0x0A96;
  t['khagurmukhi'] = 0x0A16;
  t['khaharabic'] = 0x062E;
  t['khahfinalarabic'] = 0xFEA6;
  t['khahinitialarabic'] = 0xFEA7;
  t['khahmedialarabic'] = 0xFEA8;
  t['kheicoptic'] = 0x03E7;
  t['khhadeva'] = 0x0959;
  t['khhagurmukhi'] = 0x0A59;
  t['khieukhacirclekorean'] = 0x3278;
  t['khieukhaparenkorean'] = 0x3218;
  t['khieukhcirclekorean'] = 0x326A;
  t['khieukhkorean'] = 0x314B;
  t['khieukhparenkorean'] = 0x320A;
  t['khokhaithai'] = 0x0E02;
  t['khokhonthai'] = 0x0E05;
  t['khokhuatthai'] = 0x0E03;
  t['khokhwaithai'] = 0x0E04;
  t['khomutthai'] = 0x0E5B;
  t['khook'] = 0x0199;
  t['khorakhangthai'] = 0x0E06;
  t['khzsquare'] = 0x3391;
  t['kihiragana'] = 0x304D;
  t['kikatakana'] = 0x30AD;
  t['kikatakanahalfwidth'] = 0xFF77;
  t['kiroguramusquare'] = 0x3315;
  t['kiromeetorusquare'] = 0x3316;
  t['kirosquare'] = 0x3314;
  t['kiyeokacirclekorean'] = 0x326E;
  t['kiyeokaparenkorean'] = 0x320E;
  t['kiyeokcirclekorean'] = 0x3260;
  t['kiyeokkorean'] = 0x3131;
  t['kiyeokparenkorean'] = 0x3200;
  t['kiyeoksioskorean'] = 0x3133;
  t['kjecyrillic'] = 0x045C;
  t['klinebelow'] = 0x1E35;
  t['klsquare'] = 0x3398;
  t['kmcubedsquare'] = 0x33A6;
  t['kmonospace'] = 0xFF4B;
  t['kmsquaredsquare'] = 0x33A2;
  t['kohiragana'] = 0x3053;
  t['kohmsquare'] = 0x33C0;
  t['kokaithai'] = 0x0E01;
  t['kokatakana'] = 0x30B3;
  t['kokatakanahalfwidth'] = 0xFF7A;
  t['kooposquare'] = 0x331E;
  t['koppacyrillic'] = 0x0481;
  t['koreanstandardsymbol'] = 0x327F;
  t['koroniscmb'] = 0x0343;
  t['kparen'] = 0x24A6;
  t['kpasquare'] = 0x33AA;
  t['ksicyrillic'] = 0x046F;
  t['ktsquare'] = 0x33CF;
  t['kturned'] = 0x029E;
  t['kuhiragana'] = 0x304F;
  t['kukatakana'] = 0x30AF;
  t['kukatakanahalfwidth'] = 0xFF78;
  t['kvsquare'] = 0x33B8;
  t['kwsquare'] = 0x33BE;
  t['l'] = 0x006C;
  t['labengali'] = 0x09B2;
  t['lacute'] = 0x013A;
  t['ladeva'] = 0x0932;
  t['lagujarati'] = 0x0AB2;
  t['lagurmukhi'] = 0x0A32;
  t['lakkhangyaothai'] = 0x0E45;
  t['lamaleffinalarabic'] = 0xFEFC;
  t['lamalefhamzaabovefinalarabic'] = 0xFEF8;
  t['lamalefhamzaaboveisolatedarabic'] = 0xFEF7;
  t['lamalefhamzabelowfinalarabic'] = 0xFEFA;
  t['lamalefhamzabelowisolatedarabic'] = 0xFEF9;
  t['lamalefisolatedarabic'] = 0xFEFB;
  t['lamalefmaddaabovefinalarabic'] = 0xFEF6;
  t['lamalefmaddaaboveisolatedarabic'] = 0xFEF5;
  t['lamarabic'] = 0x0644;
  t['lambda'] = 0x03BB;
  t['lambdastroke'] = 0x019B;
  t['lamed'] = 0x05DC;
  t['lameddagesh'] = 0xFB3C;
  t['lameddageshhebrew'] = 0xFB3C;
  t['lamedhebrew'] = 0x05DC;
  t['lamfinalarabic'] = 0xFEDE;
  t['lamhahinitialarabic'] = 0xFCCA;
  t['laminitialarabic'] = 0xFEDF;
  t['lamjeeminitialarabic'] = 0xFCC9;
  t['lamkhahinitialarabic'] = 0xFCCB;
  t['lamlamhehisolatedarabic'] = 0xFDF2;
  t['lammedialarabic'] = 0xFEE0;
  t['lammeemhahinitialarabic'] = 0xFD88;
  t['lammeeminitialarabic'] = 0xFCCC;
  t['largecircle'] = 0x25EF;
  t['lbar'] = 0x019A;
  t['lbelt'] = 0x026C;
  t['lbopomofo'] = 0x310C;
  t['lcaron'] = 0x013E;
  t['lcedilla'] = 0x013C;
  t['lcircle'] = 0x24DB;
  t['lcircumflexbelow'] = 0x1E3D;
  t['lcommaaccent'] = 0x013C;
  t['ldot'] = 0x0140;
  t['ldotaccent'] = 0x0140;
  t['ldotbelow'] = 0x1E37;
  t['ldotbelowmacron'] = 0x1E39;
  t['leftangleabovecmb'] = 0x031A;
  t['lefttackbelowcmb'] = 0x0318;
  t['less'] = 0x003C;
  t['lessequal'] = 0x2264;
  t['lessequalorgreater'] = 0x22DA;
  t['lessmonospace'] = 0xFF1C;
  t['lessorequivalent'] = 0x2272;
  t['lessorgreater'] = 0x2276;
  t['lessoverequal'] = 0x2266;
  t['lesssmall'] = 0xFE64;
  t['lezh'] = 0x026E;
  t['lfblock'] = 0x258C;
  t['lhookretroflex'] = 0x026D;
  t['lira'] = 0x20A4;
  t['liwnarmenian'] = 0x056C;
  t['lj'] = 0x01C9;
  t['ljecyrillic'] = 0x0459;
  t['ll'] = 0xF6C0;
  t['lladeva'] = 0x0933;
  t['llagujarati'] = 0x0AB3;
  t['llinebelow'] = 0x1E3B;
  t['llladeva'] = 0x0934;
  t['llvocalicbengali'] = 0x09E1;
  t['llvocalicdeva'] = 0x0961;
  t['llvocalicvowelsignbengali'] = 0x09E3;
  t['llvocalicvowelsigndeva'] = 0x0963;
  t['lmiddletilde'] = 0x026B;
  t['lmonospace'] = 0xFF4C;
  t['lmsquare'] = 0x33D0;
  t['lochulathai'] = 0x0E2C;
  t['logicaland'] = 0x2227;
  t['logicalnot'] = 0x00AC;
  t['logicalnotreversed'] = 0x2310;
  t['logicalor'] = 0x2228;
  t['lolingthai'] = 0x0E25;
  t['longs'] = 0x017F;
  t['lowlinecenterline'] = 0xFE4E;
  t['lowlinecmb'] = 0x0332;
  t['lowlinedashed'] = 0xFE4D;
  t['lozenge'] = 0x25CA;
  t['lparen'] = 0x24A7;
  t['lslash'] = 0x0142;
  t['lsquare'] = 0x2113;
  t['lsuperior'] = 0xF6EE;
  t['ltshade'] = 0x2591;
  t['luthai'] = 0x0E26;
  t['lvocalicbengali'] = 0x098C;
  t['lvocalicdeva'] = 0x090C;
  t['lvocalicvowelsignbengali'] = 0x09E2;
  t['lvocalicvowelsigndeva'] = 0x0962;
  t['lxsquare'] = 0x33D3;
  t['m'] = 0x006D;
  t['mabengali'] = 0x09AE;
  t['macron'] = 0x00AF;
  t['macronbelowcmb'] = 0x0331;
  t['macroncmb'] = 0x0304;
  t['macronlowmod'] = 0x02CD;
  t['macronmonospace'] = 0xFFE3;
  t['macute'] = 0x1E3F;
  t['madeva'] = 0x092E;
  t['magujarati'] = 0x0AAE;
  t['magurmukhi'] = 0x0A2E;
  t['mahapakhhebrew'] = 0x05A4;
  t['mahapakhlefthebrew'] = 0x05A4;
  t['mahiragana'] = 0x307E;
  t['maichattawalowleftthai'] = 0xF895;
  t['maichattawalowrightthai'] = 0xF894;
  t['maichattawathai'] = 0x0E4B;
  t['maichattawaupperleftthai'] = 0xF893;
  t['maieklowleftthai'] = 0xF88C;
  t['maieklowrightthai'] = 0xF88B;
  t['maiekthai'] = 0x0E48;
  t['maiekupperleftthai'] = 0xF88A;
  t['maihanakatleftthai'] = 0xF884;
  t['maihanakatthai'] = 0x0E31;
  t['maitaikhuleftthai'] = 0xF889;
  t['maitaikhuthai'] = 0x0E47;
  t['maitholowleftthai'] = 0xF88F;
  t['maitholowrightthai'] = 0xF88E;
  t['maithothai'] = 0x0E49;
  t['maithoupperleftthai'] = 0xF88D;
  t['maitrilowleftthai'] = 0xF892;
  t['maitrilowrightthai'] = 0xF891;
  t['maitrithai'] = 0x0E4A;
  t['maitriupperleftthai'] = 0xF890;
  t['maiyamokthai'] = 0x0E46;
  t['makatakana'] = 0x30DE;
  t['makatakanahalfwidth'] = 0xFF8F;
  t['male'] = 0x2642;
  t['mansyonsquare'] = 0x3347;
  t['maqafhebrew'] = 0x05BE;
  t['mars'] = 0x2642;
  t['masoracirclehebrew'] = 0x05AF;
  t['masquare'] = 0x3383;
  t['mbopomofo'] = 0x3107;
  t['mbsquare'] = 0x33D4;
  t['mcircle'] = 0x24DC;
  t['mcubedsquare'] = 0x33A5;
  t['mdotaccent'] = 0x1E41;
  t['mdotbelow'] = 0x1E43;
  t['meemarabic'] = 0x0645;
  t['meemfinalarabic'] = 0xFEE2;
  t['meeminitialarabic'] = 0xFEE3;
  t['meemmedialarabic'] = 0xFEE4;
  t['meemmeeminitialarabic'] = 0xFCD1;
  t['meemmeemisolatedarabic'] = 0xFC48;
  t['meetorusquare'] = 0x334D;
  t['mehiragana'] = 0x3081;
  t['meizierasquare'] = 0x337E;
  t['mekatakana'] = 0x30E1;
  t['mekatakanahalfwidth'] = 0xFF92;
  t['mem'] = 0x05DE;
  t['memdagesh'] = 0xFB3E;
  t['memdageshhebrew'] = 0xFB3E;
  t['memhebrew'] = 0x05DE;
  t['menarmenian'] = 0x0574;
  t['merkhahebrew'] = 0x05A5;
  t['merkhakefulahebrew'] = 0x05A6;
  t['merkhakefulalefthebrew'] = 0x05A6;
  t['merkhalefthebrew'] = 0x05A5;
  t['mhook'] = 0x0271;
  t['mhzsquare'] = 0x3392;
  t['middledotkatakanahalfwidth'] = 0xFF65;
  t['middot'] = 0x00B7;
  t['mieumacirclekorean'] = 0x3272;
  t['mieumaparenkorean'] = 0x3212;
  t['mieumcirclekorean'] = 0x3264;
  t['mieumkorean'] = 0x3141;
  t['mieumpansioskorean'] = 0x3170;
  t['mieumparenkorean'] = 0x3204;
  t['mieumpieupkorean'] = 0x316E;
  t['mieumsioskorean'] = 0x316F;
  t['mihiragana'] = 0x307F;
  t['mikatakana'] = 0x30DF;
  t['mikatakanahalfwidth'] = 0xFF90;
  t['minus'] = 0x2212;
  t['minusbelowcmb'] = 0x0320;
  t['minuscircle'] = 0x2296;
  t['minusmod'] = 0x02D7;
  t['minusplus'] = 0x2213;
  t['minute'] = 0x2032;
  t['miribaarusquare'] = 0x334A;
  t['mirisquare'] = 0x3349;
  t['mlonglegturned'] = 0x0270;
  t['mlsquare'] = 0x3396;
  t['mmcubedsquare'] = 0x33A3;
  t['mmonospace'] = 0xFF4D;
  t['mmsquaredsquare'] = 0x339F;
  t['mohiragana'] = 0x3082;
  t['mohmsquare'] = 0x33C1;
  t['mokatakana'] = 0x30E2;
  t['mokatakanahalfwidth'] = 0xFF93;
  t['molsquare'] = 0x33D6;
  t['momathai'] = 0x0E21;
  t['moverssquare'] = 0x33A7;
  t['moverssquaredsquare'] = 0x33A8;
  t['mparen'] = 0x24A8;
  t['mpasquare'] = 0x33AB;
  t['mssquare'] = 0x33B3;
  t['msuperior'] = 0xF6EF;
  t['mturned'] = 0x026F;
  t['mu'] = 0x00B5;
  t['mu1'] = 0x00B5;
  t['muasquare'] = 0x3382;
  t['muchgreater'] = 0x226B;
  t['muchless'] = 0x226A;
  t['mufsquare'] = 0x338C;
  t['mugreek'] = 0x03BC;
  t['mugsquare'] = 0x338D;
  t['muhiragana'] = 0x3080;
  t['mukatakana'] = 0x30E0;
  t['mukatakanahalfwidth'] = 0xFF91;
  t['mulsquare'] = 0x3395;
  t['multiply'] = 0x00D7;
  t['mumsquare'] = 0x339B;
  t['munahhebrew'] = 0x05A3;
  t['munahlefthebrew'] = 0x05A3;
  t['musicalnote'] = 0x266A;
  t['musicalnotedbl'] = 0x266B;
  t['musicflatsign'] = 0x266D;
  t['musicsharpsign'] = 0x266F;
  t['mussquare'] = 0x33B2;
  t['muvsquare'] = 0x33B6;
  t['muwsquare'] = 0x33BC;
  t['mvmegasquare'] = 0x33B9;
  t['mvsquare'] = 0x33B7;
  t['mwmegasquare'] = 0x33BF;
  t['mwsquare'] = 0x33BD;
  t['n'] = 0x006E;
  t['nabengali'] = 0x09A8;
  t['nabla'] = 0x2207;
  t['nacute'] = 0x0144;
  t['nadeva'] = 0x0928;
  t['nagujarati'] = 0x0AA8;
  t['nagurmukhi'] = 0x0A28;
  t['nahiragana'] = 0x306A;
  t['nakatakana'] = 0x30CA;
  t['nakatakanahalfwidth'] = 0xFF85;
  t['napostrophe'] = 0x0149;
  t['nasquare'] = 0x3381;
  t['nbopomofo'] = 0x310B;
  t['nbspace'] = 0x00A0;
  t['ncaron'] = 0x0148;
  t['ncedilla'] = 0x0146;
  t['ncircle'] = 0x24DD;
  t['ncircumflexbelow'] = 0x1E4B;
  t['ncommaaccent'] = 0x0146;
  t['ndotaccent'] = 0x1E45;
  t['ndotbelow'] = 0x1E47;
  t['nehiragana'] = 0x306D;
  t['nekatakana'] = 0x30CD;
  t['nekatakanahalfwidth'] = 0xFF88;
  t['newsheqelsign'] = 0x20AA;
  t['nfsquare'] = 0x338B;
  t['ngabengali'] = 0x0999;
  t['ngadeva'] = 0x0919;
  t['ngagujarati'] = 0x0A99;
  t['ngagurmukhi'] = 0x0A19;
  t['ngonguthai'] = 0x0E07;
  t['nhiragana'] = 0x3093;
  t['nhookleft'] = 0x0272;
  t['nhookretroflex'] = 0x0273;
  t['nieunacirclekorean'] = 0x326F;
  t['nieunaparenkorean'] = 0x320F;
  t['nieuncieuckorean'] = 0x3135;
  t['nieuncirclekorean'] = 0x3261;
  t['nieunhieuhkorean'] = 0x3136;
  t['nieunkorean'] = 0x3134;
  t['nieunpansioskorean'] = 0x3168;
  t['nieunparenkorean'] = 0x3201;
  t['nieunsioskorean'] = 0x3167;
  t['nieuntikeutkorean'] = 0x3166;
  t['nihiragana'] = 0x306B;
  t['nikatakana'] = 0x30CB;
  t['nikatakanahalfwidth'] = 0xFF86;
  t['nikhahitleftthai'] = 0xF899;
  t['nikhahitthai'] = 0x0E4D;
  t['nine'] = 0x0039;
  t['ninearabic'] = 0x0669;
  t['ninebengali'] = 0x09EF;
  t['ninecircle'] = 0x2468;
  t['ninecircleinversesansserif'] = 0x2792;
  t['ninedeva'] = 0x096F;
  t['ninegujarati'] = 0x0AEF;
  t['ninegurmukhi'] = 0x0A6F;
  t['ninehackarabic'] = 0x0669;
  t['ninehangzhou'] = 0x3029;
  t['nineideographicparen'] = 0x3228;
  t['nineinferior'] = 0x2089;
  t['ninemonospace'] = 0xFF19;
  t['nineoldstyle'] = 0xF739;
  t['nineparen'] = 0x247C;
  t['nineperiod'] = 0x2490;
  t['ninepersian'] = 0x06F9;
  t['nineroman'] = 0x2178;
  t['ninesuperior'] = 0x2079;
  t['nineteencircle'] = 0x2472;
  t['nineteenparen'] = 0x2486;
  t['nineteenperiod'] = 0x249A;
  t['ninethai'] = 0x0E59;
  t['nj'] = 0x01CC;
  t['njecyrillic'] = 0x045A;
  t['nkatakana'] = 0x30F3;
  t['nkatakanahalfwidth'] = 0xFF9D;
  t['nlegrightlong'] = 0x019E;
  t['nlinebelow'] = 0x1E49;
  t['nmonospace'] = 0xFF4E;
  t['nmsquare'] = 0x339A;
  t['nnabengali'] = 0x09A3;
  t['nnadeva'] = 0x0923;
  t['nnagujarati'] = 0x0AA3;
  t['nnagurmukhi'] = 0x0A23;
  t['nnnadeva'] = 0x0929;
  t['nohiragana'] = 0x306E;
  t['nokatakana'] = 0x30CE;
  t['nokatakanahalfwidth'] = 0xFF89;
  t['nonbreakingspace'] = 0x00A0;
  t['nonenthai'] = 0x0E13;
  t['nonuthai'] = 0x0E19;
  t['noonarabic'] = 0x0646;
  t['noonfinalarabic'] = 0xFEE6;
  t['noonghunnaarabic'] = 0x06BA;
  t['noonghunnafinalarabic'] = 0xFB9F;
  t['nooninitialarabic'] = 0xFEE7;
  t['noonjeeminitialarabic'] = 0xFCD2;
  t['noonjeemisolatedarabic'] = 0xFC4B;
  t['noonmedialarabic'] = 0xFEE8;
  t['noonmeeminitialarabic'] = 0xFCD5;
  t['noonmeemisolatedarabic'] = 0xFC4E;
  t['noonnoonfinalarabic'] = 0xFC8D;
  t['notcontains'] = 0x220C;
  t['notelement'] = 0x2209;
  t['notelementof'] = 0x2209;
  t['notequal'] = 0x2260;
  t['notgreater'] = 0x226F;
  t['notgreaternorequal'] = 0x2271;
  t['notgreaternorless'] = 0x2279;
  t['notidentical'] = 0x2262;
  t['notless'] = 0x226E;
  t['notlessnorequal'] = 0x2270;
  t['notparallel'] = 0x2226;
  t['notprecedes'] = 0x2280;
  t['notsubset'] = 0x2284;
  t['notsucceeds'] = 0x2281;
  t['notsuperset'] = 0x2285;
  t['nowarmenian'] = 0x0576;
  t['nparen'] = 0x24A9;
  t['nssquare'] = 0x33B1;
  t['nsuperior'] = 0x207F;
  t['ntilde'] = 0x00F1;
  t['nu'] = 0x03BD;
  t['nuhiragana'] = 0x306C;
  t['nukatakana'] = 0x30CC;
  t['nukatakanahalfwidth'] = 0xFF87;
  t['nuktabengali'] = 0x09BC;
  t['nuktadeva'] = 0x093C;
  t['nuktagujarati'] = 0x0ABC;
  t['nuktagurmukhi'] = 0x0A3C;
  t['numbersign'] = 0x0023;
  t['numbersignmonospace'] = 0xFF03;
  t['numbersignsmall'] = 0xFE5F;
  t['numeralsigngreek'] = 0x0374;
  t['numeralsignlowergreek'] = 0x0375;
  t['numero'] = 0x2116;
  t['nun'] = 0x05E0;
  t['nundagesh'] = 0xFB40;
  t['nundageshhebrew'] = 0xFB40;
  t['nunhebrew'] = 0x05E0;
  t['nvsquare'] = 0x33B5;
  t['nwsquare'] = 0x33BB;
  t['nyabengali'] = 0x099E;
  t['nyadeva'] = 0x091E;
  t['nyagujarati'] = 0x0A9E;
  t['nyagurmukhi'] = 0x0A1E;
  t['o'] = 0x006F;
  t['oacute'] = 0x00F3;
  t['oangthai'] = 0x0E2D;
  t['obarred'] = 0x0275;
  t['obarredcyrillic'] = 0x04E9;
  t['obarreddieresiscyrillic'] = 0x04EB;
  t['obengali'] = 0x0993;
  t['obopomofo'] = 0x311B;
  t['obreve'] = 0x014F;
  t['ocandradeva'] = 0x0911;
  t['ocandragujarati'] = 0x0A91;
  t['ocandravowelsigndeva'] = 0x0949;
  t['ocandravowelsigngujarati'] = 0x0AC9;
  t['ocaron'] = 0x01D2;
  t['ocircle'] = 0x24DE;
  t['ocircumflex'] = 0x00F4;
  t['ocircumflexacute'] = 0x1ED1;
  t['ocircumflexdotbelow'] = 0x1ED9;
  t['ocircumflexgrave'] = 0x1ED3;
  t['ocircumflexhookabove'] = 0x1ED5;
  t['ocircumflextilde'] = 0x1ED7;
  t['ocyrillic'] = 0x043E;
  t['odblacute'] = 0x0151;
  t['odblgrave'] = 0x020D;
  t['odeva'] = 0x0913;
  t['odieresis'] = 0x00F6;
  t['odieresiscyrillic'] = 0x04E7;
  t['odotbelow'] = 0x1ECD;
  t['oe'] = 0x0153;
  t['oekorean'] = 0x315A;
  t['ogonek'] = 0x02DB;
  t['ogonekcmb'] = 0x0328;
  t['ograve'] = 0x00F2;
  t['ogujarati'] = 0x0A93;
  t['oharmenian'] = 0x0585;
  t['ohiragana'] = 0x304A;
  t['ohookabove'] = 0x1ECF;
  t['ohorn'] = 0x01A1;
  t['ohornacute'] = 0x1EDB;
  t['ohorndotbelow'] = 0x1EE3;
  t['ohorngrave'] = 0x1EDD;
  t['ohornhookabove'] = 0x1EDF;
  t['ohorntilde'] = 0x1EE1;
  t['ohungarumlaut'] = 0x0151;
  t['oi'] = 0x01A3;
  t['oinvertedbreve'] = 0x020F;
  t['okatakana'] = 0x30AA;
  t['okatakanahalfwidth'] = 0xFF75;
  t['okorean'] = 0x3157;
  t['olehebrew'] = 0x05AB;
  t['omacron'] = 0x014D;
  t['omacronacute'] = 0x1E53;
  t['omacrongrave'] = 0x1E51;
  t['omdeva'] = 0x0950;
  t['omega'] = 0x03C9;
  t['omega1'] = 0x03D6;
  t['omegacyrillic'] = 0x0461;
  t['omegalatinclosed'] = 0x0277;
  t['omegaroundcyrillic'] = 0x047B;
  t['omegatitlocyrillic'] = 0x047D;
  t['omegatonos'] = 0x03CE;
  t['omgujarati'] = 0x0AD0;
  t['omicron'] = 0x03BF;
  t['omicrontonos'] = 0x03CC;
  t['omonospace'] = 0xFF4F;
  t['one'] = 0x0031;
  t['onearabic'] = 0x0661;
  t['onebengali'] = 0x09E7;
  t['onecircle'] = 0x2460;
  t['onecircleinversesansserif'] = 0x278A;
  t['onedeva'] = 0x0967;
  t['onedotenleader'] = 0x2024;
  t['oneeighth'] = 0x215B;
  t['onefitted'] = 0xF6DC;
  t['onegujarati'] = 0x0AE7;
  t['onegurmukhi'] = 0x0A67;
  t['onehackarabic'] = 0x0661;
  t['onehalf'] = 0x00BD;
  t['onehangzhou'] = 0x3021;
  t['oneideographicparen'] = 0x3220;
  t['oneinferior'] = 0x2081;
  t['onemonospace'] = 0xFF11;
  t['onenumeratorbengali'] = 0x09F4;
  t['oneoldstyle'] = 0xF731;
  t['oneparen'] = 0x2474;
  t['oneperiod'] = 0x2488;
  t['onepersian'] = 0x06F1;
  t['onequarter'] = 0x00BC;
  t['oneroman'] = 0x2170;
  t['onesuperior'] = 0x00B9;
  t['onethai'] = 0x0E51;
  t['onethird'] = 0x2153;
  t['oogonek'] = 0x01EB;
  t['oogonekmacron'] = 0x01ED;
  t['oogurmukhi'] = 0x0A13;
  t['oomatragurmukhi'] = 0x0A4B;
  t['oopen'] = 0x0254;
  t['oparen'] = 0x24AA;
  t['openbullet'] = 0x25E6;
  t['option'] = 0x2325;
  t['ordfeminine'] = 0x00AA;
  t['ordmasculine'] = 0x00BA;
  t['orthogonal'] = 0x221F;
  t['oshortdeva'] = 0x0912;
  t['oshortvowelsigndeva'] = 0x094A;
  t['oslash'] = 0x00F8;
  t['oslashacute'] = 0x01FF;
  t['osmallhiragana'] = 0x3049;
  t['osmallkatakana'] = 0x30A9;
  t['osmallkatakanahalfwidth'] = 0xFF6B;
  t['ostrokeacute'] = 0x01FF;
  t['osuperior'] = 0xF6F0;
  t['otcyrillic'] = 0x047F;
  t['otilde'] = 0x00F5;
  t['otildeacute'] = 0x1E4D;
  t['otildedieresis'] = 0x1E4F;
  t['oubopomofo'] = 0x3121;
  t['overline'] = 0x203E;
  t['overlinecenterline'] = 0xFE4A;
  t['overlinecmb'] = 0x0305;
  t['overlinedashed'] = 0xFE49;
  t['overlinedblwavy'] = 0xFE4C;
  t['overlinewavy'] = 0xFE4B;
  t['overscore'] = 0x00AF;
  t['ovowelsignbengali'] = 0x09CB;
  t['ovowelsigndeva'] = 0x094B;
  t['ovowelsigngujarati'] = 0x0ACB;
  t['p'] = 0x0070;
  t['paampssquare'] = 0x3380;
  t['paasentosquare'] = 0x332B;
  t['pabengali'] = 0x09AA;
  t['pacute'] = 0x1E55;
  t['padeva'] = 0x092A;
  t['pagedown'] = 0x21DF;
  t['pageup'] = 0x21DE;
  t['pagujarati'] = 0x0AAA;
  t['pagurmukhi'] = 0x0A2A;
  t['pahiragana'] = 0x3071;
  t['paiyannoithai'] = 0x0E2F;
  t['pakatakana'] = 0x30D1;
  t['palatalizationcyrilliccmb'] = 0x0484;
  t['palochkacyrillic'] = 0x04C0;
  t['pansioskorean'] = 0x317F;
  t['paragraph'] = 0x00B6;
  t['parallel'] = 0x2225;
  t['parenleft'] = 0x0028;
  t['parenleftaltonearabic'] = 0xFD3E;
  t['parenleftbt'] = 0xF8ED;
  t['parenleftex'] = 0xF8EC;
  t['parenleftinferior'] = 0x208D;
  t['parenleftmonospace'] = 0xFF08;
  t['parenleftsmall'] = 0xFE59;
  t['parenleftsuperior'] = 0x207D;
  t['parenlefttp'] = 0xF8EB;
  t['parenleftvertical'] = 0xFE35;
  t['parenright'] = 0x0029;
  t['parenrightaltonearabic'] = 0xFD3F;
  t['parenrightbt'] = 0xF8F8;
  t['parenrightex'] = 0xF8F7;
  t['parenrightinferior'] = 0x208E;
  t['parenrightmonospace'] = 0xFF09;
  t['parenrightsmall'] = 0xFE5A;
  t['parenrightsuperior'] = 0x207E;
  t['parenrighttp'] = 0xF8F6;
  t['parenrightvertical'] = 0xFE36;
  t['partialdiff'] = 0x2202;
  t['paseqhebrew'] = 0x05C0;
  t['pashtahebrew'] = 0x0599;
  t['pasquare'] = 0x33A9;
  t['patah'] = 0x05B7;
  t['patah11'] = 0x05B7;
  t['patah1d'] = 0x05B7;
  t['patah2a'] = 0x05B7;
  t['patahhebrew'] = 0x05B7;
  t['patahnarrowhebrew'] = 0x05B7;
  t['patahquarterhebrew'] = 0x05B7;
  t['patahwidehebrew'] = 0x05B7;
  t['pazerhebrew'] = 0x05A1;
  t['pbopomofo'] = 0x3106;
  t['pcircle'] = 0x24DF;
  t['pdotaccent'] = 0x1E57;
  t['pe'] = 0x05E4;
  t['pecyrillic'] = 0x043F;
  t['pedagesh'] = 0xFB44;
  t['pedageshhebrew'] = 0xFB44;
  t['peezisquare'] = 0x333B;
  t['pefinaldageshhebrew'] = 0xFB43;
  t['peharabic'] = 0x067E;
  t['peharmenian'] = 0x057A;
  t['pehebrew'] = 0x05E4;
  t['pehfinalarabic'] = 0xFB57;
  t['pehinitialarabic'] = 0xFB58;
  t['pehiragana'] = 0x307A;
  t['pehmedialarabic'] = 0xFB59;
  t['pekatakana'] = 0x30DA;
  t['pemiddlehookcyrillic'] = 0x04A7;
  t['perafehebrew'] = 0xFB4E;
  t['percent'] = 0x0025;
  t['percentarabic'] = 0x066A;
  t['percentmonospace'] = 0xFF05;
  t['percentsmall'] = 0xFE6A;
  t['period'] = 0x002E;
  t['periodarmenian'] = 0x0589;
  t['periodcentered'] = 0x00B7;
  t['periodhalfwidth'] = 0xFF61;
  t['periodinferior'] = 0xF6E7;
  t['periodmonospace'] = 0xFF0E;
  t['periodsmall'] = 0xFE52;
  t['periodsuperior'] = 0xF6E8;
  t['perispomenigreekcmb'] = 0x0342;
  t['perpendicular'] = 0x22A5;
  t['perthousand'] = 0x2030;
  t['peseta'] = 0x20A7;
  t['pfsquare'] = 0x338A;
  t['phabengali'] = 0x09AB;
  t['phadeva'] = 0x092B;
  t['phagujarati'] = 0x0AAB;
  t['phagurmukhi'] = 0x0A2B;
  t['phi'] = 0x03C6;
  t['phi1'] = 0x03D5;
  t['phieuphacirclekorean'] = 0x327A;
  t['phieuphaparenkorean'] = 0x321A;
  t['phieuphcirclekorean'] = 0x326C;
  t['phieuphkorean'] = 0x314D;
  t['phieuphparenkorean'] = 0x320C;
  t['philatin'] = 0x0278;
  t['phinthuthai'] = 0x0E3A;
  t['phisymbolgreek'] = 0x03D5;
  t['phook'] = 0x01A5;
  t['phophanthai'] = 0x0E1E;
  t['phophungthai'] = 0x0E1C;
  t['phosamphaothai'] = 0x0E20;
  t['pi'] = 0x03C0;
  t['pieupacirclekorean'] = 0x3273;
  t['pieupaparenkorean'] = 0x3213;
  t['pieupcieuckorean'] = 0x3176;
  t['pieupcirclekorean'] = 0x3265;
  t['pieupkiyeokkorean'] = 0x3172;
  t['pieupkorean'] = 0x3142;
  t['pieupparenkorean'] = 0x3205;
  t['pieupsioskiyeokkorean'] = 0x3174;
  t['pieupsioskorean'] = 0x3144;
  t['pieupsiostikeutkorean'] = 0x3175;
  t['pieupthieuthkorean'] = 0x3177;
  t['pieuptikeutkorean'] = 0x3173;
  t['pihiragana'] = 0x3074;
  t['pikatakana'] = 0x30D4;
  t['pisymbolgreek'] = 0x03D6;
  t['piwrarmenian'] = 0x0583;
  t['plus'] = 0x002B;
  t['plusbelowcmb'] = 0x031F;
  t['pluscircle'] = 0x2295;
  t['plusminus'] = 0x00B1;
  t['plusmod'] = 0x02D6;
  t['plusmonospace'] = 0xFF0B;
  t['plussmall'] = 0xFE62;
  t['plussuperior'] = 0x207A;
  t['pmonospace'] = 0xFF50;
  t['pmsquare'] = 0x33D8;
  t['pohiragana'] = 0x307D;
  t['pointingindexdownwhite'] = 0x261F;
  t['pointingindexleftwhite'] = 0x261C;
  t['pointingindexrightwhite'] = 0x261E;
  t['pointingindexupwhite'] = 0x261D;
  t['pokatakana'] = 0x30DD;
  t['poplathai'] = 0x0E1B;
  t['postalmark'] = 0x3012;
  t['postalmarkface'] = 0x3020;
  t['pparen'] = 0x24AB;
  t['precedes'] = 0x227A;
  t['prescription'] = 0x211E;
  t['primemod'] = 0x02B9;
  t['primereversed'] = 0x2035;
  t['product'] = 0x220F;
  t['projective'] = 0x2305;
  t['prolongedkana'] = 0x30FC;
  t['propellor'] = 0x2318;
  t['propersubset'] = 0x2282;
  t['propersuperset'] = 0x2283;
  t['proportion'] = 0x2237;
  t['proportional'] = 0x221D;
  t['psi'] = 0x03C8;
  t['psicyrillic'] = 0x0471;
  t['psilipneumatacyrilliccmb'] = 0x0486;
  t['pssquare'] = 0x33B0;
  t['puhiragana'] = 0x3077;
  t['pukatakana'] = 0x30D7;
  t['pvsquare'] = 0x33B4;
  t['pwsquare'] = 0x33BA;
  t['q'] = 0x0071;
  t['qadeva'] = 0x0958;
  t['qadmahebrew'] = 0x05A8;
  t['qafarabic'] = 0x0642;
  t['qaffinalarabic'] = 0xFED6;
  t['qafinitialarabic'] = 0xFED7;
  t['qafmedialarabic'] = 0xFED8;
  t['qamats'] = 0x05B8;
  t['qamats10'] = 0x05B8;
  t['qamats1a'] = 0x05B8;
  t['qamats1c'] = 0x05B8;
  t['qamats27'] = 0x05B8;
  t['qamats29'] = 0x05B8;
  t['qamats33'] = 0x05B8;
  t['qamatsde'] = 0x05B8;
  t['qamatshebrew'] = 0x05B8;
  t['qamatsnarrowhebrew'] = 0x05B8;
  t['qamatsqatanhebrew'] = 0x05B8;
  t['qamatsqatannarrowhebrew'] = 0x05B8;
  t['qamatsqatanquarterhebrew'] = 0x05B8;
  t['qamatsqatanwidehebrew'] = 0x05B8;
  t['qamatsquarterhebrew'] = 0x05B8;
  t['qamatswidehebrew'] = 0x05B8;
  t['qarneyparahebrew'] = 0x059F;
  t['qbopomofo'] = 0x3111;
  t['qcircle'] = 0x24E0;
  t['qhook'] = 0x02A0;
  t['qmonospace'] = 0xFF51;
  t['qof'] = 0x05E7;
  t['qofdagesh'] = 0xFB47;
  t['qofdageshhebrew'] = 0xFB47;
  t['qofhebrew'] = 0x05E7;
  t['qparen'] = 0x24AC;
  t['quarternote'] = 0x2669;
  t['qubuts'] = 0x05BB;
  t['qubuts18'] = 0x05BB;
  t['qubuts25'] = 0x05BB;
  t['qubuts31'] = 0x05BB;
  t['qubutshebrew'] = 0x05BB;
  t['qubutsnarrowhebrew'] = 0x05BB;
  t['qubutsquarterhebrew'] = 0x05BB;
  t['qubutswidehebrew'] = 0x05BB;
  t['question'] = 0x003F;
  t['questionarabic'] = 0x061F;
  t['questionarmenian'] = 0x055E;
  t['questiondown'] = 0x00BF;
  t['questiondownsmall'] = 0xF7BF;
  t['questiongreek'] = 0x037E;
  t['questionmonospace'] = 0xFF1F;
  t['questionsmall'] = 0xF73F;
  t['quotedbl'] = 0x0022;
  t['quotedblbase'] = 0x201E;
  t['quotedblleft'] = 0x201C;
  t['quotedblmonospace'] = 0xFF02;
  t['quotedblprime'] = 0x301E;
  t['quotedblprimereversed'] = 0x301D;
  t['quotedblright'] = 0x201D;
  t['quoteleft'] = 0x2018;
  t['quoteleftreversed'] = 0x201B;
  t['quotereversed'] = 0x201B;
  t['quoteright'] = 0x2019;
  t['quoterightn'] = 0x0149;
  t['quotesinglbase'] = 0x201A;
  t['quotesingle'] = 0x0027;
  t['quotesinglemonospace'] = 0xFF07;
  t['r'] = 0x0072;
  t['raarmenian'] = 0x057C;
  t['rabengali'] = 0x09B0;
  t['racute'] = 0x0155;
  t['radeva'] = 0x0930;
  t['radical'] = 0x221A;
  t['radicalex'] = 0xF8E5;
  t['radoverssquare'] = 0x33AE;
  t['radoverssquaredsquare'] = 0x33AF;
  t['radsquare'] = 0x33AD;
  t['rafe'] = 0x05BF;
  t['rafehebrew'] = 0x05BF;
  t['ragujarati'] = 0x0AB0;
  t['ragurmukhi'] = 0x0A30;
  t['rahiragana'] = 0x3089;
  t['rakatakana'] = 0x30E9;
  t['rakatakanahalfwidth'] = 0xFF97;
  t['ralowerdiagonalbengali'] = 0x09F1;
  t['ramiddlediagonalbengali'] = 0x09F0;
  t['ramshorn'] = 0x0264;
  t['ratio'] = 0x2236;
  t['rbopomofo'] = 0x3116;
  t['rcaron'] = 0x0159;
  t['rcedilla'] = 0x0157;
  t['rcircle'] = 0x24E1;
  t['rcommaaccent'] = 0x0157;
  t['rdblgrave'] = 0x0211;
  t['rdotaccent'] = 0x1E59;
  t['rdotbelow'] = 0x1E5B;
  t['rdotbelowmacron'] = 0x1E5D;
  t['referencemark'] = 0x203B;
  t['reflexsubset'] = 0x2286;
  t['reflexsuperset'] = 0x2287;
  t['registered'] = 0x00AE;
  t['registersans'] = 0xF8E8;
  t['registerserif'] = 0xF6DA;
  t['reharabic'] = 0x0631;
  t['reharmenian'] = 0x0580;
  t['rehfinalarabic'] = 0xFEAE;
  t['rehiragana'] = 0x308C;
  t['rekatakana'] = 0x30EC;
  t['rekatakanahalfwidth'] = 0xFF9A;
  t['resh'] = 0x05E8;
  t['reshdageshhebrew'] = 0xFB48;
  t['reshhebrew'] = 0x05E8;
  t['reversedtilde'] = 0x223D;
  t['reviahebrew'] = 0x0597;
  t['reviamugrashhebrew'] = 0x0597;
  t['revlogicalnot'] = 0x2310;
  t['rfishhook'] = 0x027E;
  t['rfishhookreversed'] = 0x027F;
  t['rhabengali'] = 0x09DD;
  t['rhadeva'] = 0x095D;
  t['rho'] = 0x03C1;
  t['rhook'] = 0x027D;
  t['rhookturned'] = 0x027B;
  t['rhookturnedsuperior'] = 0x02B5;
  t['rhosymbolgreek'] = 0x03F1;
  t['rhotichookmod'] = 0x02DE;
  t['rieulacirclekorean'] = 0x3271;
  t['rieulaparenkorean'] = 0x3211;
  t['rieulcirclekorean'] = 0x3263;
  t['rieulhieuhkorean'] = 0x3140;
  t['rieulkiyeokkorean'] = 0x313A;
  t['rieulkiyeoksioskorean'] = 0x3169;
  t['rieulkorean'] = 0x3139;
  t['rieulmieumkorean'] = 0x313B;
  t['rieulpansioskorean'] = 0x316C;
  t['rieulparenkorean'] = 0x3203;
  t['rieulphieuphkorean'] = 0x313F;
  t['rieulpieupkorean'] = 0x313C;
  t['rieulpieupsioskorean'] = 0x316B;
  t['rieulsioskorean'] = 0x313D;
  t['rieulthieuthkorean'] = 0x313E;
  t['rieultikeutkorean'] = 0x316A;
  t['rieulyeorinhieuhkorean'] = 0x316D;
  t['rightangle'] = 0x221F;
  t['righttackbelowcmb'] = 0x0319;
  t['righttriangle'] = 0x22BF;
  t['rihiragana'] = 0x308A;
  t['rikatakana'] = 0x30EA;
  t['rikatakanahalfwidth'] = 0xFF98;
  t['ring'] = 0x02DA;
  t['ringbelowcmb'] = 0x0325;
  t['ringcmb'] = 0x030A;
  t['ringhalfleft'] = 0x02BF;
  t['ringhalfleftarmenian'] = 0x0559;
  t['ringhalfleftbelowcmb'] = 0x031C;
  t['ringhalfleftcentered'] = 0x02D3;
  t['ringhalfright'] = 0x02BE;
  t['ringhalfrightbelowcmb'] = 0x0339;
  t['ringhalfrightcentered'] = 0x02D2;
  t['rinvertedbreve'] = 0x0213;
  t['rittorusquare'] = 0x3351;
  t['rlinebelow'] = 0x1E5F;
  t['rlongleg'] = 0x027C;
  t['rlonglegturned'] = 0x027A;
  t['rmonospace'] = 0xFF52;
  t['rohiragana'] = 0x308D;
  t['rokatakana'] = 0x30ED;
  t['rokatakanahalfwidth'] = 0xFF9B;
  t['roruathai'] = 0x0E23;
  t['rparen'] = 0x24AD;
  t['rrabengali'] = 0x09DC;
  t['rradeva'] = 0x0931;
  t['rragurmukhi'] = 0x0A5C;
  t['rreharabic'] = 0x0691;
  t['rrehfinalarabic'] = 0xFB8D;
  t['rrvocalicbengali'] = 0x09E0;
  t['rrvocalicdeva'] = 0x0960;
  t['rrvocalicgujarati'] = 0x0AE0;
  t['rrvocalicvowelsignbengali'] = 0x09C4;
  t['rrvocalicvowelsigndeva'] = 0x0944;
  t['rrvocalicvowelsigngujarati'] = 0x0AC4;
  t['rsuperior'] = 0xF6F1;
  t['rtblock'] = 0x2590;
  t['rturned'] = 0x0279;
  t['rturnedsuperior'] = 0x02B4;
  t['ruhiragana'] = 0x308B;
  t['rukatakana'] = 0x30EB;
  t['rukatakanahalfwidth'] = 0xFF99;
  t['rupeemarkbengali'] = 0x09F2;
  t['rupeesignbengali'] = 0x09F3;
  t['rupiah'] = 0xF6DD;
  t['ruthai'] = 0x0E24;
  t['rvocalicbengali'] = 0x098B;
  t['rvocalicdeva'] = 0x090B;
  t['rvocalicgujarati'] = 0x0A8B;
  t['rvocalicvowelsignbengali'] = 0x09C3;
  t['rvocalicvowelsigndeva'] = 0x0943;
  t['rvocalicvowelsigngujarati'] = 0x0AC3;
  t['s'] = 0x0073;
  t['sabengali'] = 0x09B8;
  t['sacute'] = 0x015B;
  t['sacutedotaccent'] = 0x1E65;
  t['sadarabic'] = 0x0635;
  t['sadeva'] = 0x0938;
  t['sadfinalarabic'] = 0xFEBA;
  t['sadinitialarabic'] = 0xFEBB;
  t['sadmedialarabic'] = 0xFEBC;
  t['sagujarati'] = 0x0AB8;
  t['sagurmukhi'] = 0x0A38;
  t['sahiragana'] = 0x3055;
  t['sakatakana'] = 0x30B5;
  t['sakatakanahalfwidth'] = 0xFF7B;
  t['sallallahoualayhewasallamarabic'] = 0xFDFA;
  t['samekh'] = 0x05E1;
  t['samekhdagesh'] = 0xFB41;
  t['samekhdageshhebrew'] = 0xFB41;
  t['samekhhebrew'] = 0x05E1;
  t['saraaathai'] = 0x0E32;
  t['saraaethai'] = 0x0E41;
  t['saraaimaimalaithai'] = 0x0E44;
  t['saraaimaimuanthai'] = 0x0E43;
  t['saraamthai'] = 0x0E33;
  t['saraathai'] = 0x0E30;
  t['saraethai'] = 0x0E40;
  t['saraiileftthai'] = 0xF886;
  t['saraiithai'] = 0x0E35;
  t['saraileftthai'] = 0xF885;
  t['saraithai'] = 0x0E34;
  t['saraothai'] = 0x0E42;
  t['saraueeleftthai'] = 0xF888;
  t['saraueethai'] = 0x0E37;
  t['saraueleftthai'] = 0xF887;
  t['sarauethai'] = 0x0E36;
  t['sarauthai'] = 0x0E38;
  t['sarauuthai'] = 0x0E39;
  t['sbopomofo'] = 0x3119;
  t['scaron'] = 0x0161;
  t['scarondotaccent'] = 0x1E67;
  t['scedilla'] = 0x015F;
  t['schwa'] = 0x0259;
  t['schwacyrillic'] = 0x04D9;
  t['schwadieresiscyrillic'] = 0x04DB;
  t['schwahook'] = 0x025A;
  t['scircle'] = 0x24E2;
  t['scircumflex'] = 0x015D;
  t['scommaaccent'] = 0x0219;
  t['sdotaccent'] = 0x1E61;
  t['sdotbelow'] = 0x1E63;
  t['sdotbelowdotaccent'] = 0x1E69;
  t['seagullbelowcmb'] = 0x033C;
  t['second'] = 0x2033;
  t['secondtonechinese'] = 0x02CA;
  t['section'] = 0x00A7;
  t['seenarabic'] = 0x0633;
  t['seenfinalarabic'] = 0xFEB2;
  t['seeninitialarabic'] = 0xFEB3;
  t['seenmedialarabic'] = 0xFEB4;
  t['segol'] = 0x05B6;
  t['segol13'] = 0x05B6;
  t['segol1f'] = 0x05B6;
  t['segol2c'] = 0x05B6;
  t['segolhebrew'] = 0x05B6;
  t['segolnarrowhebrew'] = 0x05B6;
  t['segolquarterhebrew'] = 0x05B6;
  t['segoltahebrew'] = 0x0592;
  t['segolwidehebrew'] = 0x05B6;
  t['seharmenian'] = 0x057D;
  t['sehiragana'] = 0x305B;
  t['sekatakana'] = 0x30BB;
  t['sekatakanahalfwidth'] = 0xFF7E;
  t['semicolon'] = 0x003B;
  t['semicolonarabic'] = 0x061B;
  t['semicolonmonospace'] = 0xFF1B;
  t['semicolonsmall'] = 0xFE54;
  t['semivoicedmarkkana'] = 0x309C;
  t['semivoicedmarkkanahalfwidth'] = 0xFF9F;
  t['sentisquare'] = 0x3322;
  t['sentosquare'] = 0x3323;
  t['seven'] = 0x0037;
  t['sevenarabic'] = 0x0667;
  t['sevenbengali'] = 0x09ED;
  t['sevencircle'] = 0x2466;
  t['sevencircleinversesansserif'] = 0x2790;
  t['sevendeva'] = 0x096D;
  t['seveneighths'] = 0x215E;
  t['sevengujarati'] = 0x0AED;
  t['sevengurmukhi'] = 0x0A6D;
  t['sevenhackarabic'] = 0x0667;
  t['sevenhangzhou'] = 0x3027;
  t['sevenideographicparen'] = 0x3226;
  t['seveninferior'] = 0x2087;
  t['sevenmonospace'] = 0xFF17;
  t['sevenoldstyle'] = 0xF737;
  t['sevenparen'] = 0x247A;
  t['sevenperiod'] = 0x248E;
  t['sevenpersian'] = 0x06F7;
  t['sevenroman'] = 0x2176;
  t['sevensuperior'] = 0x2077;
  t['seventeencircle'] = 0x2470;
  t['seventeenparen'] = 0x2484;
  t['seventeenperiod'] = 0x2498;
  t['seventhai'] = 0x0E57;
  t['sfthyphen'] = 0x00AD;
  t['shaarmenian'] = 0x0577;
  t['shabengali'] = 0x09B6;
  t['shacyrillic'] = 0x0448;
  t['shaddaarabic'] = 0x0651;
  t['shaddadammaarabic'] = 0xFC61;
  t['shaddadammatanarabic'] = 0xFC5E;
  t['shaddafathaarabic'] = 0xFC60;
  t['shaddakasraarabic'] = 0xFC62;
  t['shaddakasratanarabic'] = 0xFC5F;
  t['shade'] = 0x2592;
  t['shadedark'] = 0x2593;
  t['shadelight'] = 0x2591;
  t['shademedium'] = 0x2592;
  t['shadeva'] = 0x0936;
  t['shagujarati'] = 0x0AB6;
  t['shagurmukhi'] = 0x0A36;
  t['shalshelethebrew'] = 0x0593;
  t['shbopomofo'] = 0x3115;
  t['shchacyrillic'] = 0x0449;
  t['sheenarabic'] = 0x0634;
  t['sheenfinalarabic'] = 0xFEB6;
  t['sheeninitialarabic'] = 0xFEB7;
  t['sheenmedialarabic'] = 0xFEB8;
  t['sheicoptic'] = 0x03E3;
  t['sheqel'] = 0x20AA;
  t['sheqelhebrew'] = 0x20AA;
  t['sheva'] = 0x05B0;
  t['sheva115'] = 0x05B0;
  t['sheva15'] = 0x05B0;
  t['sheva22'] = 0x05B0;
  t['sheva2e'] = 0x05B0;
  t['shevahebrew'] = 0x05B0;
  t['shevanarrowhebrew'] = 0x05B0;
  t['shevaquarterhebrew'] = 0x05B0;
  t['shevawidehebrew'] = 0x05B0;
  t['shhacyrillic'] = 0x04BB;
  t['shimacoptic'] = 0x03ED;
  t['shin'] = 0x05E9;
  t['shindagesh'] = 0xFB49;
  t['shindageshhebrew'] = 0xFB49;
  t['shindageshshindot'] = 0xFB2C;
  t['shindageshshindothebrew'] = 0xFB2C;
  t['shindageshsindot'] = 0xFB2D;
  t['shindageshsindothebrew'] = 0xFB2D;
  t['shindothebrew'] = 0x05C1;
  t['shinhebrew'] = 0x05E9;
  t['shinshindot'] = 0xFB2A;
  t['shinshindothebrew'] = 0xFB2A;
  t['shinsindot'] = 0xFB2B;
  t['shinsindothebrew'] = 0xFB2B;
  t['shook'] = 0x0282;
  t['sigma'] = 0x03C3;
  t['sigma1'] = 0x03C2;
  t['sigmafinal'] = 0x03C2;
  t['sigmalunatesymbolgreek'] = 0x03F2;
  t['sihiragana'] = 0x3057;
  t['sikatakana'] = 0x30B7;
  t['sikatakanahalfwidth'] = 0xFF7C;
  t['siluqhebrew'] = 0x05BD;
  t['siluqlefthebrew'] = 0x05BD;
  t['similar'] = 0x223C;
  t['sindothebrew'] = 0x05C2;
  t['siosacirclekorean'] = 0x3274;
  t['siosaparenkorean'] = 0x3214;
  t['sioscieuckorean'] = 0x317E;
  t['sioscirclekorean'] = 0x3266;
  t['sioskiyeokkorean'] = 0x317A;
  t['sioskorean'] = 0x3145;
  t['siosnieunkorean'] = 0x317B;
  t['siosparenkorean'] = 0x3206;
  t['siospieupkorean'] = 0x317D;
  t['siostikeutkorean'] = 0x317C;
  t['six'] = 0x0036;
  t['sixarabic'] = 0x0666;
  t['sixbengali'] = 0x09EC;
  t['sixcircle'] = 0x2465;
  t['sixcircleinversesansserif'] = 0x278F;
  t['sixdeva'] = 0x096C;
  t['sixgujarati'] = 0x0AEC;
  t['sixgurmukhi'] = 0x0A6C;
  t['sixhackarabic'] = 0x0666;
  t['sixhangzhou'] = 0x3026;
  t['sixideographicparen'] = 0x3225;
  t['sixinferior'] = 0x2086;
  t['sixmonospace'] = 0xFF16;
  t['sixoldstyle'] = 0xF736;
  t['sixparen'] = 0x2479;
  t['sixperiod'] = 0x248D;
  t['sixpersian'] = 0x06F6;
  t['sixroman'] = 0x2175;
  t['sixsuperior'] = 0x2076;
  t['sixteencircle'] = 0x246F;
  t['sixteencurrencydenominatorbengali'] = 0x09F9;
  t['sixteenparen'] = 0x2483;
  t['sixteenperiod'] = 0x2497;
  t['sixthai'] = 0x0E56;
  t['slash'] = 0x002F;
  t['slashmonospace'] = 0xFF0F;
  t['slong'] = 0x017F;
  t['slongdotaccent'] = 0x1E9B;
  t['smileface'] = 0x263A;
  t['smonospace'] = 0xFF53;
  t['sofpasuqhebrew'] = 0x05C3;
  t['softhyphen'] = 0x00AD;
  t['softsigncyrillic'] = 0x044C;
  t['sohiragana'] = 0x305D;
  t['sokatakana'] = 0x30BD;
  t['sokatakanahalfwidth'] = 0xFF7F;
  t['soliduslongoverlaycmb'] = 0x0338;
  t['solidusshortoverlaycmb'] = 0x0337;
  t['sorusithai'] = 0x0E29;
  t['sosalathai'] = 0x0E28;
  t['sosothai'] = 0x0E0B;
  t['sosuathai'] = 0x0E2A;
  t['space'] = 0x0020;
  t['spacehackarabic'] = 0x0020;
  t['spade'] = 0x2660;
  t['spadesuitblack'] = 0x2660;
  t['spadesuitwhite'] = 0x2664;
  t['sparen'] = 0x24AE;
  t['squarebelowcmb'] = 0x033B;
  t['squarecc'] = 0x33C4;
  t['squarecm'] = 0x339D;
  t['squarediagonalcrosshatchfill'] = 0x25A9;
  t['squarehorizontalfill'] = 0x25A4;
  t['squarekg'] = 0x338F;
  t['squarekm'] = 0x339E;
  t['squarekmcapital'] = 0x33CE;
  t['squareln'] = 0x33D1;
  t['squarelog'] = 0x33D2;
  t['squaremg'] = 0x338E;
  t['squaremil'] = 0x33D5;
  t['squaremm'] = 0x339C;
  t['squaremsquared'] = 0x33A1;
  t['squareorthogonalcrosshatchfill'] = 0x25A6;
  t['squareupperlefttolowerrightfill'] = 0x25A7;
  t['squareupperrighttolowerleftfill'] = 0x25A8;
  t['squareverticalfill'] = 0x25A5;
  t['squarewhitewithsmallblack'] = 0x25A3;
  t['srsquare'] = 0x33DB;
  t['ssabengali'] = 0x09B7;
  t['ssadeva'] = 0x0937;
  t['ssagujarati'] = 0x0AB7;
  t['ssangcieuckorean'] = 0x3149;
  t['ssanghieuhkorean'] = 0x3185;
  t['ssangieungkorean'] = 0x3180;
  t['ssangkiyeokkorean'] = 0x3132;
  t['ssangnieunkorean'] = 0x3165;
  t['ssangpieupkorean'] = 0x3143;
  t['ssangsioskorean'] = 0x3146;
  t['ssangtikeutkorean'] = 0x3138;
  t['ssuperior'] = 0xF6F2;
  t['sterling'] = 0x00A3;
  t['sterlingmonospace'] = 0xFFE1;
  t['strokelongoverlaycmb'] = 0x0336;
  t['strokeshortoverlaycmb'] = 0x0335;
  t['subset'] = 0x2282;
  t['subsetnotequal'] = 0x228A;
  t['subsetorequal'] = 0x2286;
  t['succeeds'] = 0x227B;
  t['suchthat'] = 0x220B;
  t['suhiragana'] = 0x3059;
  t['sukatakana'] = 0x30B9;
  t['sukatakanahalfwidth'] = 0xFF7D;
  t['sukunarabic'] = 0x0652;
  t['summation'] = 0x2211;
  t['sun'] = 0x263C;
  t['superset'] = 0x2283;
  t['supersetnotequal'] = 0x228B;
  t['supersetorequal'] = 0x2287;
  t['svsquare'] = 0x33DC;
  t['syouwaerasquare'] = 0x337C;
  t['t'] = 0x0074;
  t['tabengali'] = 0x09A4;
  t['tackdown'] = 0x22A4;
  t['tackleft'] = 0x22A3;
  t['tadeva'] = 0x0924;
  t['tagujarati'] = 0x0AA4;
  t['tagurmukhi'] = 0x0A24;
  t['taharabic'] = 0x0637;
  t['tahfinalarabic'] = 0xFEC2;
  t['tahinitialarabic'] = 0xFEC3;
  t['tahiragana'] = 0x305F;
  t['tahmedialarabic'] = 0xFEC4;
  t['taisyouerasquare'] = 0x337D;
  t['takatakana'] = 0x30BF;
  t['takatakanahalfwidth'] = 0xFF80;
  t['tatweelarabic'] = 0x0640;
  t['tau'] = 0x03C4;
  t['tav'] = 0x05EA;
  t['tavdages'] = 0xFB4A;
  t['tavdagesh'] = 0xFB4A;
  t['tavdageshhebrew'] = 0xFB4A;
  t['tavhebrew'] = 0x05EA;
  t['tbar'] = 0x0167;
  t['tbopomofo'] = 0x310A;
  t['tcaron'] = 0x0165;
  t['tccurl'] = 0x02A8;
  t['tcedilla'] = 0x0163;
  t['tcheharabic'] = 0x0686;
  t['tchehfinalarabic'] = 0xFB7B;
  t['tchehinitialarabic'] = 0xFB7C;
  t['tchehmedialarabic'] = 0xFB7D;
  t['tcircle'] = 0x24E3;
  t['tcircumflexbelow'] = 0x1E71;
  t['tcommaaccent'] = 0x0163;
  t['tdieresis'] = 0x1E97;
  t['tdotaccent'] = 0x1E6B;
  t['tdotbelow'] = 0x1E6D;
  t['tecyrillic'] = 0x0442;
  t['tedescendercyrillic'] = 0x04AD;
  t['teharabic'] = 0x062A;
  t['tehfinalarabic'] = 0xFE96;
  t['tehhahinitialarabic'] = 0xFCA2;
  t['tehhahisolatedarabic'] = 0xFC0C;
  t['tehinitialarabic'] = 0xFE97;
  t['tehiragana'] = 0x3066;
  t['tehjeeminitialarabic'] = 0xFCA1;
  t['tehjeemisolatedarabic'] = 0xFC0B;
  t['tehmarbutaarabic'] = 0x0629;
  t['tehmarbutafinalarabic'] = 0xFE94;
  t['tehmedialarabic'] = 0xFE98;
  t['tehmeeminitialarabic'] = 0xFCA4;
  t['tehmeemisolatedarabic'] = 0xFC0E;
  t['tehnoonfinalarabic'] = 0xFC73;
  t['tekatakana'] = 0x30C6;
  t['tekatakanahalfwidth'] = 0xFF83;
  t['telephone'] = 0x2121;
  t['telephoneblack'] = 0x260E;
  t['telishagedolahebrew'] = 0x05A0;
  t['telishaqetanahebrew'] = 0x05A9;
  t['tencircle'] = 0x2469;
  t['tenideographicparen'] = 0x3229;
  t['tenparen'] = 0x247D;
  t['tenperiod'] = 0x2491;
  t['tenroman'] = 0x2179;
  t['tesh'] = 0x02A7;
  t['tet'] = 0x05D8;
  t['tetdagesh'] = 0xFB38;
  t['tetdageshhebrew'] = 0xFB38;
  t['tethebrew'] = 0x05D8;
  t['tetsecyrillic'] = 0x04B5;
  t['tevirhebrew'] = 0x059B;
  t['tevirlefthebrew'] = 0x059B;
  t['thabengali'] = 0x09A5;
  t['thadeva'] = 0x0925;
  t['thagujarati'] = 0x0AA5;
  t['thagurmukhi'] = 0x0A25;
  t['thalarabic'] = 0x0630;
  t['thalfinalarabic'] = 0xFEAC;
  t['thanthakhatlowleftthai'] = 0xF898;
  t['thanthakhatlowrightthai'] = 0xF897;
  t['thanthakhatthai'] = 0x0E4C;
  t['thanthakhatupperleftthai'] = 0xF896;
  t['theharabic'] = 0x062B;
  t['thehfinalarabic'] = 0xFE9A;
  t['thehinitialarabic'] = 0xFE9B;
  t['thehmedialarabic'] = 0xFE9C;
  t['thereexists'] = 0x2203;
  t['therefore'] = 0x2234;
  t['theta'] = 0x03B8;
  t['theta1'] = 0x03D1;
  t['thetasymbolgreek'] = 0x03D1;
  t['thieuthacirclekorean'] = 0x3279;
  t['thieuthaparenkorean'] = 0x3219;
  t['thieuthcirclekorean'] = 0x326B;
  t['thieuthkorean'] = 0x314C;
  t['thieuthparenkorean'] = 0x320B;
  t['thirteencircle'] = 0x246C;
  t['thirteenparen'] = 0x2480;
  t['thirteenperiod'] = 0x2494;
  t['thonangmonthothai'] = 0x0E11;
  t['thook'] = 0x01AD;
  t['thophuthaothai'] = 0x0E12;
  t['thorn'] = 0x00FE;
  t['thothahanthai'] = 0x0E17;
  t['thothanthai'] = 0x0E10;
  t['thothongthai'] = 0x0E18;
  t['thothungthai'] = 0x0E16;
  t['thousandcyrillic'] = 0x0482;
  t['thousandsseparatorarabic'] = 0x066C;
  t['thousandsseparatorpersian'] = 0x066C;
  t['three'] = 0x0033;
  t['threearabic'] = 0x0663;
  t['threebengali'] = 0x09E9;
  t['threecircle'] = 0x2462;
  t['threecircleinversesansserif'] = 0x278C;
  t['threedeva'] = 0x0969;
  t['threeeighths'] = 0x215C;
  t['threegujarati'] = 0x0AE9;
  t['threegurmukhi'] = 0x0A69;
  t['threehackarabic'] = 0x0663;
  t['threehangzhou'] = 0x3023;
  t['threeideographicparen'] = 0x3222;
  t['threeinferior'] = 0x2083;
  t['threemonospace'] = 0xFF13;
  t['threenumeratorbengali'] = 0x09F6;
  t['threeoldstyle'] = 0xF733;
  t['threeparen'] = 0x2476;
  t['threeperiod'] = 0x248A;
  t['threepersian'] = 0x06F3;
  t['threequarters'] = 0x00BE;
  t['threequartersemdash'] = 0xF6DE;
  t['threeroman'] = 0x2172;
  t['threesuperior'] = 0x00B3;
  t['threethai'] = 0x0E53;
  t['thzsquare'] = 0x3394;
  t['tihiragana'] = 0x3061;
  t['tikatakana'] = 0x30C1;
  t['tikatakanahalfwidth'] = 0xFF81;
  t['tikeutacirclekorean'] = 0x3270;
  t['tikeutaparenkorean'] = 0x3210;
  t['tikeutcirclekorean'] = 0x3262;
  t['tikeutkorean'] = 0x3137;
  t['tikeutparenkorean'] = 0x3202;
  t['tilde'] = 0x02DC;
  t['tildebelowcmb'] = 0x0330;
  t['tildecmb'] = 0x0303;
  t['tildecomb'] = 0x0303;
  t['tildedoublecmb'] = 0x0360;
  t['tildeoperator'] = 0x223C;
  t['tildeoverlaycmb'] = 0x0334;
  t['tildeverticalcmb'] = 0x033E;
  t['timescircle'] = 0x2297;
  t['tipehahebrew'] = 0x0596;
  t['tipehalefthebrew'] = 0x0596;
  t['tippigurmukhi'] = 0x0A70;
  t['titlocyrilliccmb'] = 0x0483;
  t['tiwnarmenian'] = 0x057F;
  t['tlinebelow'] = 0x1E6F;
  t['tmonospace'] = 0xFF54;
  t['toarmenian'] = 0x0569;
  t['tohiragana'] = 0x3068;
  t['tokatakana'] = 0x30C8;
  t['tokatakanahalfwidth'] = 0xFF84;
  t['tonebarextrahighmod'] = 0x02E5;
  t['tonebarextralowmod'] = 0x02E9;
  t['tonebarhighmod'] = 0x02E6;
  t['tonebarlowmod'] = 0x02E8;
  t['tonebarmidmod'] = 0x02E7;
  t['tonefive'] = 0x01BD;
  t['tonesix'] = 0x0185;
  t['tonetwo'] = 0x01A8;
  t['tonos'] = 0x0384;
  t['tonsquare'] = 0x3327;
  t['topatakthai'] = 0x0E0F;
  t['tortoiseshellbracketleft'] = 0x3014;
  t['tortoiseshellbracketleftsmall'] = 0xFE5D;
  t['tortoiseshellbracketleftvertical'] = 0xFE39;
  t['tortoiseshellbracketright'] = 0x3015;
  t['tortoiseshellbracketrightsmall'] = 0xFE5E;
  t['tortoiseshellbracketrightvertical'] = 0xFE3A;
  t['totaothai'] = 0x0E15;
  t['tpalatalhook'] = 0x01AB;
  t['tparen'] = 0x24AF;
  t['trademark'] = 0x2122;
  t['trademarksans'] = 0xF8EA;
  t['trademarkserif'] = 0xF6DB;
  t['tretroflexhook'] = 0x0288;
  t['triagdn'] = 0x25BC;
  t['triaglf'] = 0x25C4;
  t['triagrt'] = 0x25BA;
  t['triagup'] = 0x25B2;
  t['ts'] = 0x02A6;
  t['tsadi'] = 0x05E6;
  t['tsadidagesh'] = 0xFB46;
  t['tsadidageshhebrew'] = 0xFB46;
  t['tsadihebrew'] = 0x05E6;
  t['tsecyrillic'] = 0x0446;
  t['tsere'] = 0x05B5;
  t['tsere12'] = 0x05B5;
  t['tsere1e'] = 0x05B5;
  t['tsere2b'] = 0x05B5;
  t['tserehebrew'] = 0x05B5;
  t['tserenarrowhebrew'] = 0x05B5;
  t['tserequarterhebrew'] = 0x05B5;
  t['tserewidehebrew'] = 0x05B5;
  t['tshecyrillic'] = 0x045B;
  t['tsuperior'] = 0xF6F3;
  t['ttabengali'] = 0x099F;
  t['ttadeva'] = 0x091F;
  t['ttagujarati'] = 0x0A9F;
  t['ttagurmukhi'] = 0x0A1F;
  t['tteharabic'] = 0x0679;
  t['ttehfinalarabic'] = 0xFB67;
  t['ttehinitialarabic'] = 0xFB68;
  t['ttehmedialarabic'] = 0xFB69;
  t['tthabengali'] = 0x09A0;
  t['tthadeva'] = 0x0920;
  t['tthagujarati'] = 0x0AA0;
  t['tthagurmukhi'] = 0x0A20;
  t['tturned'] = 0x0287;
  t['tuhiragana'] = 0x3064;
  t['tukatakana'] = 0x30C4;
  t['tukatakanahalfwidth'] = 0xFF82;
  t['tusmallhiragana'] = 0x3063;
  t['tusmallkatakana'] = 0x30C3;
  t['tusmallkatakanahalfwidth'] = 0xFF6F;
  t['twelvecircle'] = 0x246B;
  t['twelveparen'] = 0x247F;
  t['twelveperiod'] = 0x2493;
  t['twelveroman'] = 0x217B;
  t['twentycircle'] = 0x2473;
  t['twentyhangzhou'] = 0x5344;
  t['twentyparen'] = 0x2487;
  t['twentyperiod'] = 0x249B;
  t['two'] = 0x0032;
  t['twoarabic'] = 0x0662;
  t['twobengali'] = 0x09E8;
  t['twocircle'] = 0x2461;
  t['twocircleinversesansserif'] = 0x278B;
  t['twodeva'] = 0x0968;
  t['twodotenleader'] = 0x2025;
  t['twodotleader'] = 0x2025;
  t['twodotleadervertical'] = 0xFE30;
  t['twogujarati'] = 0x0AE8;
  t['twogurmukhi'] = 0x0A68;
  t['twohackarabic'] = 0x0662;
  t['twohangzhou'] = 0x3022;
  t['twoideographicparen'] = 0x3221;
  t['twoinferior'] = 0x2082;
  t['twomonospace'] = 0xFF12;
  t['twonumeratorbengali'] = 0x09F5;
  t['twooldstyle'] = 0xF732;
  t['twoparen'] = 0x2475;
  t['twoperiod'] = 0x2489;
  t['twopersian'] = 0x06F2;
  t['tworoman'] = 0x2171;
  t['twostroke'] = 0x01BB;
  t['twosuperior'] = 0x00B2;
  t['twothai'] = 0x0E52;
  t['twothirds'] = 0x2154;
  t['u'] = 0x0075;
  t['uacute'] = 0x00FA;
  t['ubar'] = 0x0289;
  t['ubengali'] = 0x0989;
  t['ubopomofo'] = 0x3128;
  t['ubreve'] = 0x016D;
  t['ucaron'] = 0x01D4;
  t['ucircle'] = 0x24E4;
  t['ucircumflex'] = 0x00FB;
  t['ucircumflexbelow'] = 0x1E77;
  t['ucyrillic'] = 0x0443;
  t['udattadeva'] = 0x0951;
  t['udblacute'] = 0x0171;
  t['udblgrave'] = 0x0215;
  t['udeva'] = 0x0909;
  t['udieresis'] = 0x00FC;
  t['udieresisacute'] = 0x01D8;
  t['udieresisbelow'] = 0x1E73;
  t['udieresiscaron'] = 0x01DA;
  t['udieresiscyrillic'] = 0x04F1;
  t['udieresisgrave'] = 0x01DC;
  t['udieresismacron'] = 0x01D6;
  t['udotbelow'] = 0x1EE5;
  t['ugrave'] = 0x00F9;
  t['ugujarati'] = 0x0A89;
  t['ugurmukhi'] = 0x0A09;
  t['uhiragana'] = 0x3046;
  t['uhookabove'] = 0x1EE7;
  t['uhorn'] = 0x01B0;
  t['uhornacute'] = 0x1EE9;
  t['uhorndotbelow'] = 0x1EF1;
  t['uhorngrave'] = 0x1EEB;
  t['uhornhookabove'] = 0x1EED;
  t['uhorntilde'] = 0x1EEF;
  t['uhungarumlaut'] = 0x0171;
  t['uhungarumlautcyrillic'] = 0x04F3;
  t['uinvertedbreve'] = 0x0217;
  t['ukatakana'] = 0x30A6;
  t['ukatakanahalfwidth'] = 0xFF73;
  t['ukcyrillic'] = 0x0479;
  t['ukorean'] = 0x315C;
  t['umacron'] = 0x016B;
  t['umacroncyrillic'] = 0x04EF;
  t['umacrondieresis'] = 0x1E7B;
  t['umatragurmukhi'] = 0x0A41;
  t['umonospace'] = 0xFF55;
  t['underscore'] = 0x005F;
  t['underscoredbl'] = 0x2017;
  t['underscoremonospace'] = 0xFF3F;
  t['underscorevertical'] = 0xFE33;
  t['underscorewavy'] = 0xFE4F;
  t['union'] = 0x222A;
  t['universal'] = 0x2200;
  t['uogonek'] = 0x0173;
  t['uparen'] = 0x24B0;
  t['upblock'] = 0x2580;
  t['upperdothebrew'] = 0x05C4;
  t['upsilon'] = 0x03C5;
  t['upsilondieresis'] = 0x03CB;
  t['upsilondieresistonos'] = 0x03B0;
  t['upsilonlatin'] = 0x028A;
  t['upsilontonos'] = 0x03CD;
  t['uptackbelowcmb'] = 0x031D;
  t['uptackmod'] = 0x02D4;
  t['uragurmukhi'] = 0x0A73;
  t['uring'] = 0x016F;
  t['ushortcyrillic'] = 0x045E;
  t['usmallhiragana'] = 0x3045;
  t['usmallkatakana'] = 0x30A5;
  t['usmallkatakanahalfwidth'] = 0xFF69;
  t['ustraightcyrillic'] = 0x04AF;
  t['ustraightstrokecyrillic'] = 0x04B1;
  t['utilde'] = 0x0169;
  t['utildeacute'] = 0x1E79;
  t['utildebelow'] = 0x1E75;
  t['uubengali'] = 0x098A;
  t['uudeva'] = 0x090A;
  t['uugujarati'] = 0x0A8A;
  t['uugurmukhi'] = 0x0A0A;
  t['uumatragurmukhi'] = 0x0A42;
  t['uuvowelsignbengali'] = 0x09C2;
  t['uuvowelsigndeva'] = 0x0942;
  t['uuvowelsigngujarati'] = 0x0AC2;
  t['uvowelsignbengali'] = 0x09C1;
  t['uvowelsigndeva'] = 0x0941;
  t['uvowelsigngujarati'] = 0x0AC1;
  t['v'] = 0x0076;
  t['vadeva'] = 0x0935;
  t['vagujarati'] = 0x0AB5;
  t['vagurmukhi'] = 0x0A35;
  t['vakatakana'] = 0x30F7;
  t['vav'] = 0x05D5;
  t['vavdagesh'] = 0xFB35;
  t['vavdagesh65'] = 0xFB35;
  t['vavdageshhebrew'] = 0xFB35;
  t['vavhebrew'] = 0x05D5;
  t['vavholam'] = 0xFB4B;
  t['vavholamhebrew'] = 0xFB4B;
  t['vavvavhebrew'] = 0x05F0;
  t['vavyodhebrew'] = 0x05F1;
  t['vcircle'] = 0x24E5;
  t['vdotbelow'] = 0x1E7F;
  t['vecyrillic'] = 0x0432;
  t['veharabic'] = 0x06A4;
  t['vehfinalarabic'] = 0xFB6B;
  t['vehinitialarabic'] = 0xFB6C;
  t['vehmedialarabic'] = 0xFB6D;
  t['vekatakana'] = 0x30F9;
  t['venus'] = 0x2640;
  t['verticalbar'] = 0x007C;
  t['verticallineabovecmb'] = 0x030D;
  t['verticallinebelowcmb'] = 0x0329;
  t['verticallinelowmod'] = 0x02CC;
  t['verticallinemod'] = 0x02C8;
  t['vewarmenian'] = 0x057E;
  t['vhook'] = 0x028B;
  t['vikatakana'] = 0x30F8;
  t['viramabengali'] = 0x09CD;
  t['viramadeva'] = 0x094D;
  t['viramagujarati'] = 0x0ACD;
  t['visargabengali'] = 0x0983;
  t['visargadeva'] = 0x0903;
  t['visargagujarati'] = 0x0A83;
  t['vmonospace'] = 0xFF56;
  t['voarmenian'] = 0x0578;
  t['voicediterationhiragana'] = 0x309E;
  t['voicediterationkatakana'] = 0x30FE;
  t['voicedmarkkana'] = 0x309B;
  t['voicedmarkkanahalfwidth'] = 0xFF9E;
  t['vokatakana'] = 0x30FA;
  t['vparen'] = 0x24B1;
  t['vtilde'] = 0x1E7D;
  t['vturned'] = 0x028C;
  t['vuhiragana'] = 0x3094;
  t['vukatakana'] = 0x30F4;
  t['w'] = 0x0077;
  t['wacute'] = 0x1E83;
  t['waekorean'] = 0x3159;
  t['wahiragana'] = 0x308F;
  t['wakatakana'] = 0x30EF;
  t['wakatakanahalfwidth'] = 0xFF9C;
  t['wakorean'] = 0x3158;
  t['wasmallhiragana'] = 0x308E;
  t['wasmallkatakana'] = 0x30EE;
  t['wattosquare'] = 0x3357;
  t['wavedash'] = 0x301C;
  t['wavyunderscorevertical'] = 0xFE34;
  t['wawarabic'] = 0x0648;
  t['wawfinalarabic'] = 0xFEEE;
  t['wawhamzaabovearabic'] = 0x0624;
  t['wawhamzaabovefinalarabic'] = 0xFE86;
  t['wbsquare'] = 0x33DD;
  t['wcircle'] = 0x24E6;
  t['wcircumflex'] = 0x0175;
  t['wdieresis'] = 0x1E85;
  t['wdotaccent'] = 0x1E87;
  t['wdotbelow'] = 0x1E89;
  t['wehiragana'] = 0x3091;
  t['weierstrass'] = 0x2118;
  t['wekatakana'] = 0x30F1;
  t['wekorean'] = 0x315E;
  t['weokorean'] = 0x315D;
  t['wgrave'] = 0x1E81;
  t['whitebullet'] = 0x25E6;
  t['whitecircle'] = 0x25CB;
  t['whitecircleinverse'] = 0x25D9;
  t['whitecornerbracketleft'] = 0x300E;
  t['whitecornerbracketleftvertical'] = 0xFE43;
  t['whitecornerbracketright'] = 0x300F;
  t['whitecornerbracketrightvertical'] = 0xFE44;
  t['whitediamond'] = 0x25C7;
  t['whitediamondcontainingblacksmalldiamond'] = 0x25C8;
  t['whitedownpointingsmalltriangle'] = 0x25BF;
  t['whitedownpointingtriangle'] = 0x25BD;
  t['whiteleftpointingsmalltriangle'] = 0x25C3;
  t['whiteleftpointingtriangle'] = 0x25C1;
  t['whitelenticularbracketleft'] = 0x3016;
  t['whitelenticularbracketright'] = 0x3017;
  t['whiterightpointingsmalltriangle'] = 0x25B9;
  t['whiterightpointingtriangle'] = 0x25B7;
  t['whitesmallsquare'] = 0x25AB;
  t['whitesmilingface'] = 0x263A;
  t['whitesquare'] = 0x25A1;
  t['whitestar'] = 0x2606;
  t['whitetelephone'] = 0x260F;
  t['whitetortoiseshellbracketleft'] = 0x3018;
  t['whitetortoiseshellbracketright'] = 0x3019;
  t['whiteuppointingsmalltriangle'] = 0x25B5;
  t['whiteuppointingtriangle'] = 0x25B3;
  t['wihiragana'] = 0x3090;
  t['wikatakana'] = 0x30F0;
  t['wikorean'] = 0x315F;
  t['wmonospace'] = 0xFF57;
  t['wohiragana'] = 0x3092;
  t['wokatakana'] = 0x30F2;
  t['wokatakanahalfwidth'] = 0xFF66;
  t['won'] = 0x20A9;
  t['wonmonospace'] = 0xFFE6;
  t['wowaenthai'] = 0x0E27;
  t['wparen'] = 0x24B2;
  t['wring'] = 0x1E98;
  t['wsuperior'] = 0x02B7;
  t['wturned'] = 0x028D;
  t['wynn'] = 0x01BF;
  t['x'] = 0x0078;
  t['xabovecmb'] = 0x033D;
  t['xbopomofo'] = 0x3112;
  t['xcircle'] = 0x24E7;
  t['xdieresis'] = 0x1E8D;
  t['xdotaccent'] = 0x1E8B;
  t['xeharmenian'] = 0x056D;
  t['xi'] = 0x03BE;
  t['xmonospace'] = 0xFF58;
  t['xparen'] = 0x24B3;
  t['xsuperior'] = 0x02E3;
  t['y'] = 0x0079;
  t['yaadosquare'] = 0x334E;
  t['yabengali'] = 0x09AF;
  t['yacute'] = 0x00FD;
  t['yadeva'] = 0x092F;
  t['yaekorean'] = 0x3152;
  t['yagujarati'] = 0x0AAF;
  t['yagurmukhi'] = 0x0A2F;
  t['yahiragana'] = 0x3084;
  t['yakatakana'] = 0x30E4;
  t['yakatakanahalfwidth'] = 0xFF94;
  t['yakorean'] = 0x3151;
  t['yamakkanthai'] = 0x0E4E;
  t['yasmallhiragana'] = 0x3083;
  t['yasmallkatakana'] = 0x30E3;
  t['yasmallkatakanahalfwidth'] = 0xFF6C;
  t['yatcyrillic'] = 0x0463;
  t['ycircle'] = 0x24E8;
  t['ycircumflex'] = 0x0177;
  t['ydieresis'] = 0x00FF;
  t['ydotaccent'] = 0x1E8F;
  t['ydotbelow'] = 0x1EF5;
  t['yeharabic'] = 0x064A;
  t['yehbarreearabic'] = 0x06D2;
  t['yehbarreefinalarabic'] = 0xFBAF;
  t['yehfinalarabic'] = 0xFEF2;
  t['yehhamzaabovearabic'] = 0x0626;
  t['yehhamzaabovefinalarabic'] = 0xFE8A;
  t['yehhamzaaboveinitialarabic'] = 0xFE8B;
  t['yehhamzaabovemedialarabic'] = 0xFE8C;
  t['yehinitialarabic'] = 0xFEF3;
  t['yehmedialarabic'] = 0xFEF4;
  t['yehmeeminitialarabic'] = 0xFCDD;
  t['yehmeemisolatedarabic'] = 0xFC58;
  t['yehnoonfinalarabic'] = 0xFC94;
  t['yehthreedotsbelowarabic'] = 0x06D1;
  t['yekorean'] = 0x3156;
  t['yen'] = 0x00A5;
  t['yenmonospace'] = 0xFFE5;
  t['yeokorean'] = 0x3155;
  t['yeorinhieuhkorean'] = 0x3186;
  t['yerahbenyomohebrew'] = 0x05AA;
  t['yerahbenyomolefthebrew'] = 0x05AA;
  t['yericyrillic'] = 0x044B;
  t['yerudieresiscyrillic'] = 0x04F9;
  t['yesieungkorean'] = 0x3181;
  t['yesieungpansioskorean'] = 0x3183;
  t['yesieungsioskorean'] = 0x3182;
  t['yetivhebrew'] = 0x059A;
  t['ygrave'] = 0x1EF3;
  t['yhook'] = 0x01B4;
  t['yhookabove'] = 0x1EF7;
  t['yiarmenian'] = 0x0575;
  t['yicyrillic'] = 0x0457;
  t['yikorean'] = 0x3162;
  t['yinyang'] = 0x262F;
  t['yiwnarmenian'] = 0x0582;
  t['ymonospace'] = 0xFF59;
  t['yod'] = 0x05D9;
  t['yoddagesh'] = 0xFB39;
  t['yoddageshhebrew'] = 0xFB39;
  t['yodhebrew'] = 0x05D9;
  t['yodyodhebrew'] = 0x05F2;
  t['yodyodpatahhebrew'] = 0xFB1F;
  t['yohiragana'] = 0x3088;
  t['yoikorean'] = 0x3189;
  t['yokatakana'] = 0x30E8;
  t['yokatakanahalfwidth'] = 0xFF96;
  t['yokorean'] = 0x315B;
  t['yosmallhiragana'] = 0x3087;
  t['yosmallkatakana'] = 0x30E7;
  t['yosmallkatakanahalfwidth'] = 0xFF6E;
  t['yotgreek'] = 0x03F3;
  t['yoyaekorean'] = 0x3188;
  t['yoyakorean'] = 0x3187;
  t['yoyakthai'] = 0x0E22;
  t['yoyingthai'] = 0x0E0D;
  t['yparen'] = 0x24B4;
  t['ypogegrammeni'] = 0x037A;
  t['ypogegrammenigreekcmb'] = 0x0345;
  t['yr'] = 0x01A6;
  t['yring'] = 0x1E99;
  t['ysuperior'] = 0x02B8;
  t['ytilde'] = 0x1EF9;
  t['yturned'] = 0x028E;
  t['yuhiragana'] = 0x3086;
  t['yuikorean'] = 0x318C;
  t['yukatakana'] = 0x30E6;
  t['yukatakanahalfwidth'] = 0xFF95;
  t['yukorean'] = 0x3160;
  t['yusbigcyrillic'] = 0x046B;
  t['yusbigiotifiedcyrillic'] = 0x046D;
  t['yuslittlecyrillic'] = 0x0467;
  t['yuslittleiotifiedcyrillic'] = 0x0469;
  t['yusmallhiragana'] = 0x3085;
  t['yusmallkatakana'] = 0x30E5;
  t['yusmallkatakanahalfwidth'] = 0xFF6D;
  t['yuyekorean'] = 0x318B;
  t['yuyeokorean'] = 0x318A;
  t['yyabengali'] = 0x09DF;
  t['yyadeva'] = 0x095F;
  t['z'] = 0x007A;
  t['zaarmenian'] = 0x0566;
  t['zacute'] = 0x017A;
  t['zadeva'] = 0x095B;
  t['zagurmukhi'] = 0x0A5B;
  t['zaharabic'] = 0x0638;
  t['zahfinalarabic'] = 0xFEC6;
  t['zahinitialarabic'] = 0xFEC7;
  t['zahiragana'] = 0x3056;
  t['zahmedialarabic'] = 0xFEC8;
  t['zainarabic'] = 0x0632;
  t['zainfinalarabic'] = 0xFEB0;
  t['zakatakana'] = 0x30B6;
  t['zaqefgadolhebrew'] = 0x0595;
  t['zaqefqatanhebrew'] = 0x0594;
  t['zarqahebrew'] = 0x0598;
  t['zayin'] = 0x05D6;
  t['zayindagesh'] = 0xFB36;
  t['zayindageshhebrew'] = 0xFB36;
  t['zayinhebrew'] = 0x05D6;
  t['zbopomofo'] = 0x3117;
  t['zcaron'] = 0x017E;
  t['zcircle'] = 0x24E9;
  t['zcircumflex'] = 0x1E91;
  t['zcurl'] = 0x0291;
  t['zdot'] = 0x017C;
  t['zdotaccent'] = 0x017C;
  t['zdotbelow'] = 0x1E93;
  t['zecyrillic'] = 0x0437;
  t['zedescendercyrillic'] = 0x0499;
  t['zedieresiscyrillic'] = 0x04DF;
  t['zehiragana'] = 0x305C;
  t['zekatakana'] = 0x30BC;
  t['zero'] = 0x0030;
  t['zeroarabic'] = 0x0660;
  t['zerobengali'] = 0x09E6;
  t['zerodeva'] = 0x0966;
  t['zerogujarati'] = 0x0AE6;
  t['zerogurmukhi'] = 0x0A66;
  t['zerohackarabic'] = 0x0660;
  t['zeroinferior'] = 0x2080;
  t['zeromonospace'] = 0xFF10;
  t['zerooldstyle'] = 0xF730;
  t['zeropersian'] = 0x06F0;
  t['zerosuperior'] = 0x2070;
  t['zerothai'] = 0x0E50;
  t['zerowidthjoiner'] = 0xFEFF;
  t['zerowidthnonjoiner'] = 0x200C;
  t['zerowidthspace'] = 0x200B;
  t['zeta'] = 0x03B6;
  t['zhbopomofo'] = 0x3113;
  t['zhearmenian'] = 0x056A;
  t['zhebrevecyrillic'] = 0x04C2;
  t['zhecyrillic'] = 0x0436;
  t['zhedescendercyrillic'] = 0x0497;
  t['zhedieresiscyrillic'] = 0x04DD;
  t['zihiragana'] = 0x3058;
  t['zikatakana'] = 0x30B8;
  t['zinorhebrew'] = 0x05AE;
  t['zlinebelow'] = 0x1E95;
  t['zmonospace'] = 0xFF5A;
  t['zohiragana'] = 0x305E;
  t['zokatakana'] = 0x30BE;
  t['zparen'] = 0x24B5;
  t['zretroflexhook'] = 0x0290;
  t['zstroke'] = 0x01B6;
  t['zuhiragana'] = 0x305A;
  t['zukatakana'] = 0x30BA;
  t['.notdef'] = 0x0000;
  t['angbracketleftbig'] = 0x2329;
  t['angbracketleftBig'] = 0x2329;
  t['angbracketleftbigg'] = 0x2329;
  t['angbracketleftBigg'] = 0x2329;
  t['angbracketrightBig'] = 0x232A;
  t['angbracketrightbig'] = 0x232A;
  t['angbracketrightBigg'] = 0x232A;
  t['angbracketrightbigg'] = 0x232A;
  t['arrowhookleft'] = 0x21AA;
  t['arrowhookright'] = 0x21A9;
  t['arrowlefttophalf'] = 0x21BC;
  t['arrowleftbothalf'] = 0x21BD;
  t['arrownortheast'] = 0x2197;
  t['arrownorthwest'] = 0x2196;
  t['arrowrighttophalf'] = 0x21C0;
  t['arrowrightbothalf'] = 0x21C1;
  t['arrowsoutheast'] = 0x2198;
  t['arrowsouthwest'] = 0x2199;
  t['backslashbig'] = 0x2216;
  t['backslashBig'] = 0x2216;
  t['backslashBigg'] = 0x2216;
  t['backslashbigg'] = 0x2216;
  t['bardbl'] = 0x2016;
  t['bracehtipdownleft'] = 0xFE37;
  t['bracehtipdownright'] = 0xFE37;
  t['bracehtipupleft'] = 0xFE38;
  t['bracehtipupright'] = 0xFE38;
  t['braceleftBig'] = 0x007B;
  t['braceleftbig'] = 0x007B;
  t['braceleftbigg'] = 0x007B;
  t['braceleftBigg'] = 0x007B;
  t['bracerightBig'] = 0x007D;
  t['bracerightbig'] = 0x007D;
  t['bracerightbigg'] = 0x007D;
  t['bracerightBigg'] = 0x007D;
  t['bracketleftbig'] = 0x005B;
  t['bracketleftBig'] = 0x005B;
  t['bracketleftbigg'] = 0x005B;
  t['bracketleftBigg'] = 0x005B;
  t['bracketrightBig'] = 0x005D;
  t['bracketrightbig'] = 0x005D;
  t['bracketrightbigg'] = 0x005D;
  t['bracketrightBigg'] = 0x005D;
  t['ceilingleftbig'] = 0x2308;
  t['ceilingleftBig'] = 0x2308;
  t['ceilingleftBigg'] = 0x2308;
  t['ceilingleftbigg'] = 0x2308;
  t['ceilingrightbig'] = 0x2309;
  t['ceilingrightBig'] = 0x2309;
  t['ceilingrightbigg'] = 0x2309;
  t['ceilingrightBigg'] = 0x2309;
  t['circledotdisplay'] = 0x2299;
  t['circledottext'] = 0x2299;
  t['circlemultiplydisplay'] = 0x2297;
  t['circlemultiplytext'] = 0x2297;
  t['circleplusdisplay'] = 0x2295;
  t['circleplustext'] = 0x2295;
  t['contintegraldisplay'] = 0x222E;
  t['contintegraltext'] = 0x222E;
  t['coproductdisplay'] = 0x2210;
  t['coproducttext'] = 0x2210;
  t['floorleftBig'] = 0x230A;
  t['floorleftbig'] = 0x230A;
  t['floorleftbigg'] = 0x230A;
  t['floorleftBigg'] = 0x230A;
  t['floorrightbig'] = 0x230B;
  t['floorrightBig'] = 0x230B;
  t['floorrightBigg'] = 0x230B;
  t['floorrightbigg'] = 0x230B;
  t['hatwide'] = 0x0302;
  t['hatwider'] = 0x0302;
  t['hatwidest'] = 0x0302;
  t['intercal'] = 0x1D40;
  t['integraldisplay'] = 0x222B;
  t['integraltext'] = 0x222B;
  t['intersectiondisplay'] = 0x22C2;
  t['intersectiontext'] = 0x22C2;
  t['logicalanddisplay'] = 0x2227;
  t['logicalandtext'] = 0x2227;
  t['logicalordisplay'] = 0x2228;
  t['logicalortext'] = 0x2228;
  t['parenleftBig'] = 0x0028;
  t['parenleftbig'] = 0x0028;
  t['parenleftBigg'] = 0x0028;
  t['parenleftbigg'] = 0x0028;
  t['parenrightBig'] = 0x0029;
  t['parenrightbig'] = 0x0029;
  t['parenrightBigg'] = 0x0029;
  t['parenrightbigg'] = 0x0029;
  t['prime'] = 0x2032;
  t['productdisplay'] = 0x220F;
  t['producttext'] = 0x220F;
  t['radicalbig'] = 0x221A;
  t['radicalBig'] = 0x221A;
  t['radicalBigg'] = 0x221A;
  t['radicalbigg'] = 0x221A;
  t['radicalbt'] = 0x221A;
  t['radicaltp'] = 0x221A;
  t['radicalvertex'] = 0x221A;
  t['slashbig'] = 0x002F;
  t['slashBig'] = 0x002F;
  t['slashBigg'] = 0x002F;
  t['slashbigg'] = 0x002F;
  t['summationdisplay'] = 0x2211;
  t['summationtext'] = 0x2211;
  t['tildewide'] = 0x02DC;
  t['tildewider'] = 0x02DC;
  t['tildewidest'] = 0x02DC;
  t['uniondisplay'] = 0x22C3;
  t['unionmultidisplay'] = 0x228E;
  t['unionmultitext'] = 0x228E;
  t['unionsqdisplay'] = 0x2294;
  t['unionsqtext'] = 0x2294;
  t['uniontext'] = 0x22C3;
  t['vextenddouble'] = 0x2225;
  t['vextendsingle'] = 0x2223;
});
var getDingbatsGlyphsUnicode = getLookupTableFactory(function (t) {
  t['space'] = 0x0020;
  t['a1'] = 0x2701;
  t['a2'] = 0x2702;
  t['a202'] = 0x2703;
  t['a3'] = 0x2704;
  t['a4'] = 0x260E;
  t['a5'] = 0x2706;
  t['a119'] = 0x2707;
  t['a118'] = 0x2708;
  t['a117'] = 0x2709;
  t['a11'] = 0x261B;
  t['a12'] = 0x261E;
  t['a13'] = 0x270C;
  t['a14'] = 0x270D;
  t['a15'] = 0x270E;
  t['a16'] = 0x270F;
  t['a105'] = 0x2710;
  t['a17'] = 0x2711;
  t['a18'] = 0x2712;
  t['a19'] = 0x2713;
  t['a20'] = 0x2714;
  t['a21'] = 0x2715;
  t['a22'] = 0x2716;
  t['a23'] = 0x2717;
  t['a24'] = 0x2718;
  t['a25'] = 0x2719;
  t['a26'] = 0x271A;
  t['a27'] = 0x271B;
  t['a28'] = 0x271C;
  t['a6'] = 0x271D;
  t['a7'] = 0x271E;
  t['a8'] = 0x271F;
  t['a9'] = 0x2720;
  t['a10'] = 0x2721;
  t['a29'] = 0x2722;
  t['a30'] = 0x2723;
  t['a31'] = 0x2724;
  t['a32'] = 0x2725;
  t['a33'] = 0x2726;
  t['a34'] = 0x2727;
  t['a35'] = 0x2605;
  t['a36'] = 0x2729;
  t['a37'] = 0x272A;
  t['a38'] = 0x272B;
  t['a39'] = 0x272C;
  t['a40'] = 0x272D;
  t['a41'] = 0x272E;
  t['a42'] = 0x272F;
  t['a43'] = 0x2730;
  t['a44'] = 0x2731;
  t['a45'] = 0x2732;
  t['a46'] = 0x2733;
  t['a47'] = 0x2734;
  t['a48'] = 0x2735;
  t['a49'] = 0x2736;
  t['a50'] = 0x2737;
  t['a51'] = 0x2738;
  t['a52'] = 0x2739;
  t['a53'] = 0x273A;
  t['a54'] = 0x273B;
  t['a55'] = 0x273C;
  t['a56'] = 0x273D;
  t['a57'] = 0x273E;
  t['a58'] = 0x273F;
  t['a59'] = 0x2740;
  t['a60'] = 0x2741;
  t['a61'] = 0x2742;
  t['a62'] = 0x2743;
  t['a63'] = 0x2744;
  t['a64'] = 0x2745;
  t['a65'] = 0x2746;
  t['a66'] = 0x2747;
  t['a67'] = 0x2748;
  t['a68'] = 0x2749;
  t['a69'] = 0x274A;
  t['a70'] = 0x274B;
  t['a71'] = 0x25CF;
  t['a72'] = 0x274D;
  t['a73'] = 0x25A0;
  t['a74'] = 0x274F;
  t['a203'] = 0x2750;
  t['a75'] = 0x2751;
  t['a204'] = 0x2752;
  t['a76'] = 0x25B2;
  t['a77'] = 0x25BC;
  t['a78'] = 0x25C6;
  t['a79'] = 0x2756;
  t['a81'] = 0x25D7;
  t['a82'] = 0x2758;
  t['a83'] = 0x2759;
  t['a84'] = 0x275A;
  t['a97'] = 0x275B;
  t['a98'] = 0x275C;
  t['a99'] = 0x275D;
  t['a100'] = 0x275E;
  t['a101'] = 0x2761;
  t['a102'] = 0x2762;
  t['a103'] = 0x2763;
  t['a104'] = 0x2764;
  t['a106'] = 0x2765;
  t['a107'] = 0x2766;
  t['a108'] = 0x2767;
  t['a112'] = 0x2663;
  t['a111'] = 0x2666;
  t['a110'] = 0x2665;
  t['a109'] = 0x2660;
  t['a120'] = 0x2460;
  t['a121'] = 0x2461;
  t['a122'] = 0x2462;
  t['a123'] = 0x2463;
  t['a124'] = 0x2464;
  t['a125'] = 0x2465;
  t['a126'] = 0x2466;
  t['a127'] = 0x2467;
  t['a128'] = 0x2468;
  t['a129'] = 0x2469;
  t['a130'] = 0x2776;
  t['a131'] = 0x2777;
  t['a132'] = 0x2778;
  t['a133'] = 0x2779;
  t['a134'] = 0x277A;
  t['a135'] = 0x277B;
  t['a136'] = 0x277C;
  t['a137'] = 0x277D;
  t['a138'] = 0x277E;
  t['a139'] = 0x277F;
  t['a140'] = 0x2780;
  t['a141'] = 0x2781;
  t['a142'] = 0x2782;
  t['a143'] = 0x2783;
  t['a144'] = 0x2784;
  t['a145'] = 0x2785;
  t['a146'] = 0x2786;
  t['a147'] = 0x2787;
  t['a148'] = 0x2788;
  t['a149'] = 0x2789;
  t['a150'] = 0x278A;
  t['a151'] = 0x278B;
  t['a152'] = 0x278C;
  t['a153'] = 0x278D;
  t['a154'] = 0x278E;
  t['a155'] = 0x278F;
  t['a156'] = 0x2790;
  t['a157'] = 0x2791;
  t['a158'] = 0x2792;
  t['a159'] = 0x2793;
  t['a160'] = 0x2794;
  t['a161'] = 0x2192;
  t['a163'] = 0x2194;
  t['a164'] = 0x2195;
  t['a196'] = 0x2798;
  t['a165'] = 0x2799;
  t['a192'] = 0x279A;
  t['a166'] = 0x279B;
  t['a167'] = 0x279C;
  t['a168'] = 0x279D;
  t['a169'] = 0x279E;
  t['a170'] = 0x279F;
  t['a171'] = 0x27A0;
  t['a172'] = 0x27A1;
  t['a173'] = 0x27A2;
  t['a162'] = 0x27A3;
  t['a174'] = 0x27A4;
  t['a175'] = 0x27A5;
  t['a176'] = 0x27A6;
  t['a177'] = 0x27A7;
  t['a178'] = 0x27A8;
  t['a179'] = 0x27A9;
  t['a193'] = 0x27AA;
  t['a180'] = 0x27AB;
  t['a199'] = 0x27AC;
  t['a181'] = 0x27AD;
  t['a200'] = 0x27AE;
  t['a182'] = 0x27AF;
  t['a201'] = 0x27B1;
  t['a183'] = 0x27B2;
  t['a184'] = 0x27B3;
  t['a197'] = 0x27B4;
  t['a185'] = 0x27B5;
  t['a194'] = 0x27B6;
  t['a198'] = 0x27B7;
  t['a186'] = 0x27B8;
  t['a195'] = 0x27B9;
  t['a187'] = 0x27BA;
  t['a188'] = 0x27BB;
  t['a189'] = 0x27BC;
  t['a190'] = 0x27BD;
  t['a191'] = 0x27BE;
  t['a89'] = 0x2768;
  t['a90'] = 0x2769;
  t['a93'] = 0x276A;
  t['a94'] = 0x276B;
  t['a91'] = 0x276C;
  t['a92'] = 0x276D;
  t['a205'] = 0x276E;
  t['a85'] = 0x276F;
  t['a206'] = 0x2770;
  t['a86'] = 0x2771;
  t['a87'] = 0x2772;
  t['a88'] = 0x2773;
  t['a95'] = 0x2774;
  t['a96'] = 0x2775;
  t['.notdef'] = 0x0000;
});
exports.getGlyphsUnicode = getGlyphsUnicode;
exports.getDingbatsGlyphsUnicode = getDingbatsGlyphsUnicode;

/***/ }),
/* 8 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ArithmeticDecoder = function ArithmeticDecoderClosure() {
  var QeTable = [{
    qe: 0x5601,
    nmps: 1,
    nlps: 1,
    switchFlag: 1
  }, {
    qe: 0x3401,
    nmps: 2,
    nlps: 6,
    switchFlag: 0
  }, {
    qe: 0x1801,
    nmps: 3,
    nlps: 9,
    switchFlag: 0
  }, {
    qe: 0x0AC1,
    nmps: 4,
    nlps: 12,
    switchFlag: 0
  }, {
    qe: 0x0521,
    nmps: 5,
    nlps: 29,
    switchFlag: 0
  }, {
    qe: 0x0221,
    nmps: 38,
    nlps: 33,
    switchFlag: 0
  }, {
    qe: 0x5601,
    nmps: 7,
    nlps: 6,
    switchFlag: 1
  }, {
    qe: 0x5401,
    nmps: 8,
    nlps: 14,
    switchFlag: 0
  }, {
    qe: 0x4801,
    nmps: 9,
    nlps: 14,
    switchFlag: 0
  }, {
    qe: 0x3801,
    nmps: 10,
    nlps: 14,
    switchFlag: 0
  }, {
    qe: 0x3001,
    nmps: 11,
    nlps: 17,
    switchFlag: 0
  }, {
    qe: 0x2401,
    nmps: 12,
    nlps: 18,
    switchFlag: 0
  }, {
    qe: 0x1C01,
    nmps: 13,
    nlps: 20,
    switchFlag: 0
  }, {
    qe: 0x1601,
    nmps: 29,
    nlps: 21,
    switchFlag: 0
  }, {
    qe: 0x5601,
    nmps: 15,
    nlps: 14,
    switchFlag: 1
  }, {
    qe: 0x5401,
    nmps: 16,
    nlps: 14,
    switchFlag: 0
  }, {
    qe: 0x5101,
    nmps: 17,
    nlps: 15,
    switchFlag: 0
  }, {
    qe: 0x4801,
    nmps: 18,
    nlps: 16,
    switchFlag: 0
  }, {
    qe: 0x3801,
    nmps: 19,
    nlps: 17,
    switchFlag: 0
  }, {
    qe: 0x3401,
    nmps: 20,
    nlps: 18,
    switchFlag: 0
  }, {
    qe: 0x3001,
    nmps: 21,
    nlps: 19,
    switchFlag: 0
  }, {
    qe: 0x2801,
    nmps: 22,
    nlps: 19,
    switchFlag: 0
  }, {
    qe: 0x2401,
    nmps: 23,
    nlps: 20,
    switchFlag: 0
  }, {
    qe: 0x2201,
    nmps: 24,
    nlps: 21,
    switchFlag: 0
  }, {
    qe: 0x1C01,
    nmps: 25,
    nlps: 22,
    switchFlag: 0
  }, {
    qe: 0x1801,
    nmps: 26,
    nlps: 23,
    switchFlag: 0
  }, {
    qe: 0x1601,
    nmps: 27,
    nlps: 24,
    switchFlag: 0
  }, {
    qe: 0x1401,
    nmps: 28,
    nlps: 25,
    switchFlag: 0
  }, {
    qe: 0x1201,
    nmps: 29,
    nlps: 26,
    switchFlag: 0
  }, {
    qe: 0x1101,
    nmps: 30,
    nlps: 27,
    switchFlag: 0
  }, {
    qe: 0x0AC1,
    nmps: 31,
    nlps: 28,
    switchFlag: 0
  }, {
    qe: 0x09C1,
    nmps: 32,
    nlps: 29,
    switchFlag: 0
  }, {
    qe: 0x08A1,
    nmps: 33,
    nlps: 30,
    switchFlag: 0
  }, {
    qe: 0x0521,
    nmps: 34,
    nlps: 31,
    switchFlag: 0
  }, {
    qe: 0x0441,
    nmps: 35,
    nlps: 32,
    switchFlag: 0
  }, {
    qe: 0x02A1,
    nmps: 36,
    nlps: 33,
    switchFlag: 0
  }, {
    qe: 0x0221,
    nmps: 37,
    nlps: 34,
    switchFlag: 0
  }, {
    qe: 0x0141,
    nmps: 38,
    nlps: 35,
    switchFlag: 0
  }, {
    qe: 0x0111,
    nmps: 39,
    nlps: 36,
    switchFlag: 0
  }, {
    qe: 0x0085,
    nmps: 40,
    nlps: 37,
    switchFlag: 0
  }, {
    qe: 0x0049,
    nmps: 41,
    nlps: 38,
    switchFlag: 0
  }, {
    qe: 0x0025,
    nmps: 42,
    nlps: 39,
    switchFlag: 0
  }, {
    qe: 0x0015,
    nmps: 43,
    nlps: 40,
    switchFlag: 0
  }, {
    qe: 0x0009,
    nmps: 44,
    nlps: 41,
    switchFlag: 0
  }, {
    qe: 0x0005,
    nmps: 45,
    nlps: 42,
    switchFlag: 0
  }, {
    qe: 0x0001,
    nmps: 45,
    nlps: 43,
    switchFlag: 0
  }, {
    qe: 0x5601,
    nmps: 46,
    nlps: 46,
    switchFlag: 0
  }];
  function ArithmeticDecoder(data, start, end) {
    this.data = data;
    this.bp = start;
    this.dataEnd = end;
    this.chigh = data[start];
    this.clow = 0;
    this.byteIn();
    this.chigh = this.chigh << 7 & 0xFFFF | this.clow >> 9 & 0x7F;
    this.clow = this.clow << 7 & 0xFFFF;
    this.ct -= 7;
    this.a = 0x8000;
  }
  ArithmeticDecoder.prototype = {
    byteIn: function ArithmeticDecoder_byteIn() {
      var data = this.data;
      var bp = this.bp;
      if (data[bp] === 0xFF) {
        var b1 = data[bp + 1];
        if (b1 > 0x8F) {
          this.clow += 0xFF00;
          this.ct = 8;
        } else {
          bp++;
          this.clow += data[bp] << 9;
          this.ct = 7;
          this.bp = bp;
        }
      } else {
        bp++;
        this.clow += bp < this.dataEnd ? data[bp] << 8 : 0xFF00;
        this.ct = 8;
        this.bp = bp;
      }
      if (this.clow > 0xFFFF) {
        this.chigh += this.clow >> 16;
        this.clow &= 0xFFFF;
      }
    },
    readBit: function ArithmeticDecoder_readBit(contexts, pos) {
      var cx_index = contexts[pos] >> 1,
          cx_mps = contexts[pos] & 1;
      var qeTableIcx = QeTable[cx_index];
      var qeIcx = qeTableIcx.qe;
      var d;
      var a = this.a - qeIcx;
      if (this.chigh < qeIcx) {
        if (a < qeIcx) {
          a = qeIcx;
          d = cx_mps;
          cx_index = qeTableIcx.nmps;
        } else {
          a = qeIcx;
          d = 1 ^ cx_mps;
          if (qeTableIcx.switchFlag === 1) {
            cx_mps = d;
          }
          cx_index = qeTableIcx.nlps;
        }
      } else {
        this.chigh -= qeIcx;
        if ((a & 0x8000) !== 0) {
          this.a = a;
          return cx_mps;
        }
        if (a < qeIcx) {
          d = 1 ^ cx_mps;
          if (qeTableIcx.switchFlag === 1) {
            cx_mps = d;
          }
          cx_index = qeTableIcx.nlps;
        } else {
          d = cx_mps;
          cx_index = qeTableIcx.nmps;
        }
      }
      do {
        if (this.ct === 0) {
          this.byteIn();
        }
        a <<= 1;
        this.chigh = this.chigh << 1 & 0xFFFF | this.clow >> 15 & 1;
        this.clow = this.clow << 1 & 0xFFFF;
        this.ct--;
      } while ((a & 0x8000) === 0);
      this.a = a;
      contexts[pos] = cx_index << 1 | cx_mps;
      return d;
    }
  };
  return ArithmeticDecoder;
}();
exports.ArithmeticDecoder = ArithmeticDecoder;

/***/ }),
/* 9 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CFFCompiler = exports.CFFPrivateDict = exports.CFFTopDict = exports.CFFCharset = exports.CFFIndex = exports.CFFStrings = exports.CFFHeader = exports.CFF = exports.CFFParser = exports.CFFStandardStrings = undefined;

var _util = __w_pdfjs_require__(0);

var _charsets = __w_pdfjs_require__(21);

var _encodings = __w_pdfjs_require__(4);

var MAX_SUBR_NESTING = 10;
var CFFStandardStrings = ['.notdef', 'space', 'exclam', 'quotedbl', 'numbersign', 'dollar', 'percent', 'ampersand', 'quoteright', 'parenleft', 'parenright', 'asterisk', 'plus', 'comma', 'hyphen', 'period', 'slash', 'zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'colon', 'semicolon', 'less', 'equal', 'greater', 'question', 'at', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'bracketleft', 'backslash', 'bracketright', 'asciicircum', 'underscore', 'quoteleft', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'braceleft', 'bar', 'braceright', 'asciitilde', 'exclamdown', 'cent', 'sterling', 'fraction', 'yen', 'florin', 'section', 'currency', 'quotesingle', 'quotedblleft', 'guillemotleft', 'guilsinglleft', 'guilsinglright', 'fi', 'fl', 'endash', 'dagger', 'daggerdbl', 'periodcentered', 'paragraph', 'bullet', 'quotesinglbase', 'quotedblbase', 'quotedblright', 'guillemotright', 'ellipsis', 'perthousand', 'questiondown', 'grave', 'acute', 'circumflex', 'tilde', 'macron', 'breve', 'dotaccent', 'dieresis', 'ring', 'cedilla', 'hungarumlaut', 'ogonek', 'caron', 'emdash', 'AE', 'ordfeminine', 'Lslash', 'Oslash', 'OE', 'ordmasculine', 'ae', 'dotlessi', 'lslash', 'oslash', 'oe', 'germandbls', 'onesuperior', 'logicalnot', 'mu', 'trademark', 'Eth', 'onehalf', 'plusminus', 'Thorn', 'onequarter', 'divide', 'brokenbar', 'degree', 'thorn', 'threequarters', 'twosuperior', 'registered', 'minus', 'eth', 'multiply', 'threesuperior', 'copyright', 'Aacute', 'Acircumflex', 'Adieresis', 'Agrave', 'Aring', 'Atilde', 'Ccedilla', 'Eacute', 'Ecircumflex', 'Edieresis', 'Egrave', 'Iacute', 'Icircumflex', 'Idieresis', 'Igrave', 'Ntilde', 'Oacute', 'Ocircumflex', 'Odieresis', 'Ograve', 'Otilde', 'Scaron', 'Uacute', 'Ucircumflex', 'Udieresis', 'Ugrave', 'Yacute', 'Ydieresis', 'Zcaron', 'aacute', 'acircumflex', 'adieresis', 'agrave', 'aring', 'atilde', 'ccedilla', 'eacute', 'ecircumflex', 'edieresis', 'egrave', 'iacute', 'icircumflex', 'idieresis', 'igrave', 'ntilde', 'oacute', 'ocircumflex', 'odieresis', 'ograve', 'otilde', 'scaron', 'uacute', 'ucircumflex', 'udieresis', 'ugrave', 'yacute', 'ydieresis', 'zcaron', 'exclamsmall', 'Hungarumlautsmall', 'dollaroldstyle', 'dollarsuperior', 'ampersandsmall', 'Acutesmall', 'parenleftsuperior', 'parenrightsuperior', 'twodotenleader', 'onedotenleader', 'zerooldstyle', 'oneoldstyle', 'twooldstyle', 'threeoldstyle', 'fouroldstyle', 'fiveoldstyle', 'sixoldstyle', 'sevenoldstyle', 'eightoldstyle', 'nineoldstyle', 'commasuperior', 'threequartersemdash', 'periodsuperior', 'questionsmall', 'asuperior', 'bsuperior', 'centsuperior', 'dsuperior', 'esuperior', 'isuperior', 'lsuperior', 'msuperior', 'nsuperior', 'osuperior', 'rsuperior', 'ssuperior', 'tsuperior', 'ff', 'ffi', 'ffl', 'parenleftinferior', 'parenrightinferior', 'Circumflexsmall', 'hyphensuperior', 'Gravesmall', 'Asmall', 'Bsmall', 'Csmall', 'Dsmall', 'Esmall', 'Fsmall', 'Gsmall', 'Hsmall', 'Ismall', 'Jsmall', 'Ksmall', 'Lsmall', 'Msmall', 'Nsmall', 'Osmall', 'Psmall', 'Qsmall', 'Rsmall', 'Ssmall', 'Tsmall', 'Usmall', 'Vsmall', 'Wsmall', 'Xsmall', 'Ysmall', 'Zsmall', 'colonmonetary', 'onefitted', 'rupiah', 'Tildesmall', 'exclamdownsmall', 'centoldstyle', 'Lslashsmall', 'Scaronsmall', 'Zcaronsmall', 'Dieresissmall', 'Brevesmall', 'Caronsmall', 'Dotaccentsmall', 'Macronsmall', 'figuredash', 'hypheninferior', 'Ogoneksmall', 'Ringsmall', 'Cedillasmall', 'questiondownsmall', 'oneeighth', 'threeeighths', 'fiveeighths', 'seveneighths', 'onethird', 'twothirds', 'zerosuperior', 'foursuperior', 'fivesuperior', 'sixsuperior', 'sevensuperior', 'eightsuperior', 'ninesuperior', 'zeroinferior', 'oneinferior', 'twoinferior', 'threeinferior', 'fourinferior', 'fiveinferior', 'sixinferior', 'seveninferior', 'eightinferior', 'nineinferior', 'centinferior', 'dollarinferior', 'periodinferior', 'commainferior', 'Agravesmall', 'Aacutesmall', 'Acircumflexsmall', 'Atildesmall', 'Adieresissmall', 'Aringsmall', 'AEsmall', 'Ccedillasmall', 'Egravesmall', 'Eacutesmall', 'Ecircumflexsmall', 'Edieresissmall', 'Igravesmall', 'Iacutesmall', 'Icircumflexsmall', 'Idieresissmall', 'Ethsmall', 'Ntildesmall', 'Ogravesmall', 'Oacutesmall', 'Ocircumflexsmall', 'Otildesmall', 'Odieresissmall', 'OEsmall', 'Oslashsmall', 'Ugravesmall', 'Uacutesmall', 'Ucircumflexsmall', 'Udieresissmall', 'Yacutesmall', 'Thornsmall', 'Ydieresissmall', '001.000', '001.001', '001.002', '001.003', 'Black', 'Bold', 'Book', 'Light', 'Medium', 'Regular', 'Roman', 'Semibold'];
var CFFParser = function CFFParserClosure() {
  var CharstringValidationData = [null, {
    id: 'hstem',
    min: 2,
    stackClearing: true,
    stem: true
  }, null, {
    id: 'vstem',
    min: 2,
    stackClearing: true,
    stem: true
  }, {
    id: 'vmoveto',
    min: 1,
    stackClearing: true
  }, {
    id: 'rlineto',
    min: 2,
    resetStack: true
  }, {
    id: 'hlineto',
    min: 1,
    resetStack: true
  }, {
    id: 'vlineto',
    min: 1,
    resetStack: true
  }, {
    id: 'rrcurveto',
    min: 6,
    resetStack: true
  }, null, {
    id: 'callsubr',
    min: 1,
    undefStack: true
  }, {
    id: 'return',
    min: 0,
    undefStack: true
  }, null, null, {
    id: 'endchar',
    min: 0,
    stackClearing: true
  }, null, null, null, {
    id: 'hstemhm',
    min: 2,
    stackClearing: true,
    stem: true
  }, {
    id: 'hintmask',
    min: 0,
    stackClearing: true
  }, {
    id: 'cntrmask',
    min: 0,
    stackClearing: true
  }, {
    id: 'rmoveto',
    min: 2,
    stackClearing: true
  }, {
    id: 'hmoveto',
    min: 1,
    stackClearing: true
  }, {
    id: 'vstemhm',
    min: 2,
    stackClearing: true,
    stem: true
  }, {
    id: 'rcurveline',
    min: 8,
    resetStack: true
  }, {
    id: 'rlinecurve',
    min: 8,
    resetStack: true
  }, {
    id: 'vvcurveto',
    min: 4,
    resetStack: true
  }, {
    id: 'hhcurveto',
    min: 4,
    resetStack: true
  }, null, {
    id: 'callgsubr',
    min: 1,
    undefStack: true
  }, {
    id: 'vhcurveto',
    min: 4,
    resetStack: true
  }, {
    id: 'hvcurveto',
    min: 4,
    resetStack: true
  }];
  var CharstringValidationData12 = [null, null, null, {
    id: 'and',
    min: 2,
    stackDelta: -1
  }, {
    id: 'or',
    min: 2,
    stackDelta: -1
  }, {
    id: 'not',
    min: 1,
    stackDelta: 0
  }, null, null, null, {
    id: 'abs',
    min: 1,
    stackDelta: 0
  }, {
    id: 'add',
    min: 2,
    stackDelta: -1,
    stackFn: function stack_div(stack, index) {
      stack[index - 2] = stack[index - 2] + stack[index - 1];
    }
  }, {
    id: 'sub',
    min: 2,
    stackDelta: -1,
    stackFn: function stack_div(stack, index) {
      stack[index - 2] = stack[index - 2] - stack[index - 1];
    }
  }, {
    id: 'div',
    min: 2,
    stackDelta: -1,
    stackFn: function stack_div(stack, index) {
      stack[index - 2] = stack[index - 2] / stack[index - 1];
    }
  }, null, {
    id: 'neg',
    min: 1,
    stackDelta: 0,
    stackFn: function stack_div(stack, index) {
      stack[index - 1] = -stack[index - 1];
    }
  }, {
    id: 'eq',
    min: 2,
    stackDelta: -1
  }, null, null, {
    id: 'drop',
    min: 1,
    stackDelta: -1
  }, null, {
    id: 'put',
    min: 2,
    stackDelta: -2
  }, {
    id: 'get',
    min: 1,
    stackDelta: 0
  }, {
    id: 'ifelse',
    min: 4,
    stackDelta: -3
  }, {
    id: 'random',
    min: 0,
    stackDelta: 1
  }, {
    id: 'mul',
    min: 2,
    stackDelta: -1,
    stackFn: function stack_div(stack, index) {
      stack[index - 2] = stack[index - 2] * stack[index - 1];
    }
  }, null, {
    id: 'sqrt',
    min: 1,
    stackDelta: 0
  }, {
    id: 'dup',
    min: 1,
    stackDelta: 1
  }, {
    id: 'exch',
    min: 2,
    stackDelta: 0
  }, {
    id: 'index',
    min: 2,
    stackDelta: 0
  }, {
    id: 'roll',
    min: 3,
    stackDelta: -2
  }, null, null, null, {
    id: 'hflex',
    min: 7,
    resetStack: true
  }, {
    id: 'flex',
    min: 13,
    resetStack: true
  }, {
    id: 'hflex1',
    min: 9,
    resetStack: true
  }, {
    id: 'flex1',
    min: 11,
    resetStack: true
  }];
  function CFFParser(file, properties, seacAnalysisEnabled) {
    this.bytes = file.getBytes();
    this.properties = properties;
    this.seacAnalysisEnabled = !!seacAnalysisEnabled;
  }
  CFFParser.prototype = {
    parse: function CFFParser_parse() {
      var properties = this.properties;
      var cff = new CFF();
      this.cff = cff;
      var header = this.parseHeader();
      var nameIndex = this.parseIndex(header.endPos);
      var topDictIndex = this.parseIndex(nameIndex.endPos);
      var stringIndex = this.parseIndex(topDictIndex.endPos);
      var globalSubrIndex = this.parseIndex(stringIndex.endPos);
      var topDictParsed = this.parseDict(topDictIndex.obj.get(0));
      var topDict = this.createDict(CFFTopDict, topDictParsed, cff.strings);
      cff.header = header.obj;
      cff.names = this.parseNameIndex(nameIndex.obj);
      cff.strings = this.parseStringIndex(stringIndex.obj);
      cff.topDict = topDict;
      cff.globalSubrIndex = globalSubrIndex.obj;
      this.parsePrivateDict(cff.topDict);
      cff.isCIDFont = topDict.hasName('ROS');
      var charStringOffset = topDict.getByName('CharStrings');
      var charStringIndex = this.parseIndex(charStringOffset).obj;
      var fontMatrix = topDict.getByName('FontMatrix');
      if (fontMatrix) {
        properties.fontMatrix = fontMatrix;
      }
      var fontBBox = topDict.getByName('FontBBox');
      if (fontBBox) {
        properties.ascent = Math.max(fontBBox[3], fontBBox[1]);
        properties.descent = Math.min(fontBBox[1], fontBBox[3]);
        properties.ascentScaled = true;
      }
      var charset, encoding;
      if (cff.isCIDFont) {
        var fdArrayIndex = this.parseIndex(topDict.getByName('FDArray')).obj;
        for (var i = 0, ii = fdArrayIndex.count; i < ii; ++i) {
          var dictRaw = fdArrayIndex.get(i);
          var fontDict = this.createDict(CFFTopDict, this.parseDict(dictRaw), cff.strings);
          this.parsePrivateDict(fontDict);
          cff.fdArray.push(fontDict);
        }
        encoding = null;
        charset = this.parseCharsets(topDict.getByName('charset'), charStringIndex.count, cff.strings, true);
        cff.fdSelect = this.parseFDSelect(topDict.getByName('FDSelect'), charStringIndex.count);
      } else {
        charset = this.parseCharsets(topDict.getByName('charset'), charStringIndex.count, cff.strings, false);
        encoding = this.parseEncoding(topDict.getByName('Encoding'), properties, cff.strings, charset.charset);
      }
      cff.charset = charset;
      cff.encoding = encoding;
      var charStringsAndSeacs = this.parseCharStrings({
        charStrings: charStringIndex,
        localSubrIndex: topDict.privateDict.subrsIndex,
        globalSubrIndex: globalSubrIndex.obj,
        fdSelect: cff.fdSelect,
        fdArray: cff.fdArray,
        privateDict: topDict.privateDict
      });
      cff.charStrings = charStringsAndSeacs.charStrings;
      cff.seacs = charStringsAndSeacs.seacs;
      cff.widths = charStringsAndSeacs.widths;
      return cff;
    },
    parseHeader: function CFFParser_parseHeader() {
      var bytes = this.bytes;
      var bytesLength = bytes.length;
      var offset = 0;
      while (offset < bytesLength && bytes[offset] !== 1) {
        ++offset;
      }
      if (offset >= bytesLength) {
        throw new _util.FormatError('Invalid CFF header');
      }
      if (offset !== 0) {
        (0, _util.info)('cff data is shifted');
        bytes = bytes.subarray(offset);
        this.bytes = bytes;
      }
      var major = bytes[0];
      var minor = bytes[1];
      var hdrSize = bytes[2];
      var offSize = bytes[3];
      var header = new CFFHeader(major, minor, hdrSize, offSize);
      return {
        obj: header,
        endPos: hdrSize
      };
    },
    parseDict: function CFFParser_parseDict(dict) {
      var pos = 0;
      function parseOperand() {
        var value = dict[pos++];
        if (value === 30) {
          return parseFloatOperand();
        } else if (value === 28) {
          value = dict[pos++];
          value = (value << 24 | dict[pos++] << 16) >> 16;
          return value;
        } else if (value === 29) {
          value = dict[pos++];
          value = value << 8 | dict[pos++];
          value = value << 8 | dict[pos++];
          value = value << 8 | dict[pos++];
          return value;
        } else if (value >= 32 && value <= 246) {
          return value - 139;
        } else if (value >= 247 && value <= 250) {
          return (value - 247) * 256 + dict[pos++] + 108;
        } else if (value >= 251 && value <= 254) {
          return -((value - 251) * 256) - dict[pos++] - 108;
        }
        (0, _util.warn)('CFFParser_parseDict: "' + value + '" is a reserved command.');
        return NaN;
      }
      function parseFloatOperand() {
        var str = '';
        var eof = 15;
        var lookup = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', 'E', 'E-', null, '-'];
        var length = dict.length;
        while (pos < length) {
          var b = dict[pos++];
          var b1 = b >> 4;
          var b2 = b & 15;
          if (b1 === eof) {
            break;
          }
          str += lookup[b1];
          if (b2 === eof) {
            break;
          }
          str += lookup[b2];
        }
        return parseFloat(str);
      }
      var operands = [];
      var entries = [];
      pos = 0;
      var end = dict.length;
      while (pos < end) {
        var b = dict[pos];
        if (b <= 21) {
          if (b === 12) {
            b = b << 8 | dict[++pos];
          }
          entries.push([b, operands]);
          operands = [];
          ++pos;
        } else {
          operands.push(parseOperand());
        }
      }
      return entries;
    },
    parseIndex: function CFFParser_parseIndex(pos) {
      var cffIndex = new CFFIndex();
      var bytes = this.bytes;
      var count = bytes[pos++] << 8 | bytes[pos++];
      var offsets = [];
      var end = pos;
      var i, ii;
      if (count !== 0) {
        var offsetSize = bytes[pos++];
        var startPos = pos + (count + 1) * offsetSize - 1;
        for (i = 0, ii = count + 1; i < ii; ++i) {
          var offset = 0;
          for (var j = 0; j < offsetSize; ++j) {
            offset <<= 8;
            offset += bytes[pos++];
          }
          offsets.push(startPos + offset);
        }
        end = offsets[count];
      }
      for (i = 0, ii = offsets.length - 1; i < ii; ++i) {
        var offsetStart = offsets[i];
        var offsetEnd = offsets[i + 1];
        cffIndex.add(bytes.subarray(offsetStart, offsetEnd));
      }
      return {
        obj: cffIndex,
        endPos: end
      };
    },
    parseNameIndex: function CFFParser_parseNameIndex(index) {
      var names = [];
      for (var i = 0, ii = index.count; i < ii; ++i) {
        var name = index.get(i);
        var length = Math.min(name.length, 127);
        var data = [];
        for (var j = 0; j < length; ++j) {
          var c = name[j];
          if (j === 0 && c === 0) {
            data[j] = c;
            continue;
          }
          if (c < 33 || c > 126 || c === 91 || c === 93 || c === 40 || c === 41 || c === 123 || c === 125 || c === 60 || c === 62 || c === 47 || c === 37 || c === 35) {
            data[j] = 95;
            continue;
          }
          data[j] = c;
        }
        names.push((0, _util.bytesToString)(data));
      }
      return names;
    },
    parseStringIndex: function CFFParser_parseStringIndex(index) {
      var strings = new CFFStrings();
      for (var i = 0, ii = index.count; i < ii; ++i) {
        var data = index.get(i);
        strings.add((0, _util.bytesToString)(data));
      }
      return strings;
    },
    createDict: function CFFParser_createDict(Type, dict, strings) {
      var cffDict = new Type(strings);
      for (var i = 0, ii = dict.length; i < ii; ++i) {
        var pair = dict[i];
        var key = pair[0];
        var value = pair[1];
        cffDict.setByKey(key, value);
      }
      return cffDict;
    },
    parseCharString: function CFFParser_parseCharString(state, data, localSubrIndex, globalSubrIndex) {
      if (!data || state.callDepth > MAX_SUBR_NESTING) {
        return false;
      }
      var stackSize = state.stackSize;
      var stack = state.stack;
      var length = data.length;
      for (var j = 0; j < length;) {
        var value = data[j++];
        var validationCommand = null;
        if (value === 12) {
          var q = data[j++];
          if (q === 0) {
            data[j - 2] = 139;
            data[j - 1] = 22;
            stackSize = 0;
          } else {
            validationCommand = CharstringValidationData12[q];
          }
        } else if (value === 28) {
          stack[stackSize] = (data[j] << 24 | data[j + 1] << 16) >> 16;
          j += 2;
          stackSize++;
        } else if (value === 14) {
          if (stackSize >= 4) {
            stackSize -= 4;
            if (this.seacAnalysisEnabled) {
              state.seac = stack.slice(stackSize, stackSize + 4);
              return false;
            }
          }
          validationCommand = CharstringValidationData[value];
        } else if (value >= 32 && value <= 246) {
          stack[stackSize] = value - 139;
          stackSize++;
        } else if (value >= 247 && value <= 254) {
          stack[stackSize] = value < 251 ? (value - 247 << 8) + data[j] + 108 : -(value - 251 << 8) - data[j] - 108;
          j++;
          stackSize++;
        } else if (value === 255) {
          stack[stackSize] = (data[j] << 24 | data[j + 1] << 16 | data[j + 2] << 8 | data[j + 3]) / 65536;
          j += 4;
          stackSize++;
        } else if (value === 19 || value === 20) {
          state.hints += stackSize >> 1;
          j += state.hints + 7 >> 3;
          stackSize %= 2;
          validationCommand = CharstringValidationData[value];
        } else if (value === 10 || value === 29) {
          var subrsIndex;
          if (value === 10) {
            subrsIndex = localSubrIndex;
          } else {
            subrsIndex = globalSubrIndex;
          }
          if (!subrsIndex) {
            validationCommand = CharstringValidationData[value];
            (0, _util.warn)('Missing subrsIndex for ' + validationCommand.id);
            return false;
          }
          var bias = 32768;
          if (subrsIndex.count < 1240) {
            bias = 107;
          } else if (subrsIndex.count < 33900) {
            bias = 1131;
          }
          var subrNumber = stack[--stackSize] + bias;
          if (subrNumber < 0 || subrNumber >= subrsIndex.count || isNaN(subrNumber)) {
            validationCommand = CharstringValidationData[value];
            (0, _util.warn)('Out of bounds subrIndex for ' + validationCommand.id);
            return false;
          }
          state.stackSize = stackSize;
          state.callDepth++;
          var valid = this.parseCharString(state, subrsIndex.get(subrNumber), localSubrIndex, globalSubrIndex);
          if (!valid) {
            return false;
          }
          state.callDepth--;
          stackSize = state.stackSize;
          continue;
        } else if (value === 11) {
          state.stackSize = stackSize;
          return true;
        } else {
          validationCommand = CharstringValidationData[value];
        }
        if (validationCommand) {
          if (validationCommand.stem) {
            state.hints += stackSize >> 1;
          }
          if ('min' in validationCommand) {
            if (!state.undefStack && stackSize < validationCommand.min) {
              (0, _util.warn)('Not enough parameters for ' + validationCommand.id + '; actual: ' + stackSize + ', expected: ' + validationCommand.min);
              return false;
            }
          }
          if (state.firstStackClearing && validationCommand.stackClearing) {
            state.firstStackClearing = false;
            stackSize -= validationCommand.min;
            if (stackSize >= 2 && validationCommand.stem) {
              stackSize %= 2;
            } else if (stackSize > 1) {
              (0, _util.warn)('Found too many parameters for stack-clearing command');
            }
            if (stackSize > 0 && stack[stackSize - 1] >= 0) {
              state.width = stack[stackSize - 1];
            }
          }
          if ('stackDelta' in validationCommand) {
            if ('stackFn' in validationCommand) {
              validationCommand.stackFn(stack, stackSize);
            }
            stackSize += validationCommand.stackDelta;
          } else if (validationCommand.stackClearing) {
            stackSize = 0;
          } else if (validationCommand.resetStack) {
            stackSize = 0;
            state.undefStack = false;
          } else if (validationCommand.undefStack) {
            stackSize = 0;
            state.undefStack = true;
            state.firstStackClearing = false;
          }
        }
      }
      state.stackSize = stackSize;
      return true;
    },
    parseCharStrings: function parseCharStrings(_ref) {
      var charStrings = _ref.charStrings,
          localSubrIndex = _ref.localSubrIndex,
          globalSubrIndex = _ref.globalSubrIndex,
          fdSelect = _ref.fdSelect,
          fdArray = _ref.fdArray,
          privateDict = _ref.privateDict;

      var seacs = [];
      var widths = [];
      var count = charStrings.count;
      for (var i = 0; i < count; i++) {
        var charstring = charStrings.get(i);
        var state = {
          callDepth: 0,
          stackSize: 0,
          stack: [],
          undefStack: true,
          hints: 0,
          firstStackClearing: true,
          seac: null,
          width: null
        };
        var valid = true;
        var localSubrToUse = null;
        var privateDictToUse = privateDict;
        if (fdSelect && fdArray.length) {
          var fdIndex = fdSelect.getFDIndex(i);
          if (fdIndex === -1) {
            (0, _util.warn)('Glyph index is not in fd select.');
            valid = false;
          }
          if (fdIndex >= fdArray.length) {
            (0, _util.warn)('Invalid fd index for glyph index.');
            valid = false;
          }
          if (valid) {
            privateDictToUse = fdArray[fdIndex].privateDict;
            localSubrToUse = privateDictToUse.subrsIndex;
          }
        } else if (localSubrIndex) {
          localSubrToUse = localSubrIndex;
        }
        if (valid) {
          valid = this.parseCharString(state, charstring, localSubrToUse, globalSubrIndex);
        }
        if (state.width !== null) {
          var nominalWidth = privateDictToUse.getByName('nominalWidthX');
          widths[i] = nominalWidth + state.width;
        } else {
          var defaultWidth = privateDictToUse.getByName('defaultWidthX');
          widths[i] = defaultWidth;
        }
        if (state.seac !== null) {
          seacs[i] = state.seac;
        }
        if (!valid) {
          charStrings.set(i, new Uint8Array([14]));
        }
      }
      return {
        charStrings: charStrings,
        seacs: seacs,
        widths: widths
      };
    },

    emptyPrivateDictionary: function CFFParser_emptyPrivateDictionary(parentDict) {
      var privateDict = this.createDict(CFFPrivateDict, [], parentDict.strings);
      parentDict.setByKey(18, [0, 0]);
      parentDict.privateDict = privateDict;
    },
    parsePrivateDict: function CFFParser_parsePrivateDict(parentDict) {
      if (!parentDict.hasName('Private')) {
        this.emptyPrivateDictionary(parentDict);
        return;
      }
      var privateOffset = parentDict.getByName('Private');
      if (!(0, _util.isArray)(privateOffset) || privateOffset.length !== 2) {
        parentDict.removeByName('Private');
        return;
      }
      var size = privateOffset[0];
      var offset = privateOffset[1];
      if (size === 0 || offset >= this.bytes.length) {
        this.emptyPrivateDictionary(parentDict);
        return;
      }
      var privateDictEnd = offset + size;
      var dictData = this.bytes.subarray(offset, privateDictEnd);
      var dict = this.parseDict(dictData);
      var privateDict = this.createDict(CFFPrivateDict, dict, parentDict.strings);
      parentDict.privateDict = privateDict;
      if (!privateDict.getByName('Subrs')) {
        return;
      }
      var subrsOffset = privateDict.getByName('Subrs');
      var relativeOffset = offset + subrsOffset;
      if (subrsOffset === 0 || relativeOffset >= this.bytes.length) {
        this.emptyPrivateDictionary(parentDict);
        return;
      }
      var subrsIndex = this.parseIndex(relativeOffset);
      privateDict.subrsIndex = subrsIndex.obj;
    },
    parseCharsets: function CFFParser_parseCharsets(pos, length, strings, cid) {
      if (pos === 0) {
        return new CFFCharset(true, CFFCharsetPredefinedTypes.ISO_ADOBE, _charsets.ISOAdobeCharset);
      } else if (pos === 1) {
        return new CFFCharset(true, CFFCharsetPredefinedTypes.EXPERT, _charsets.ExpertCharset);
      } else if (pos === 2) {
        return new CFFCharset(true, CFFCharsetPredefinedTypes.EXPERT_SUBSET, _charsets.ExpertSubsetCharset);
      }
      var bytes = this.bytes;
      var start = pos;
      var format = bytes[pos++];
      var charset = ['.notdef'];
      var id, count, i;
      length -= 1;
      switch (format) {
        case 0:
          for (i = 0; i < length; i++) {
            id = bytes[pos++] << 8 | bytes[pos++];
            charset.push(cid ? id : strings.get(id));
          }
          break;
        case 1:
          while (charset.length <= length) {
            id = bytes[pos++] << 8 | bytes[pos++];
            count = bytes[pos++];
            for (i = 0; i <= count; i++) {
              charset.push(cid ? id++ : strings.get(id++));
            }
          }
          break;
        case 2:
          while (charset.length <= length) {
            id = bytes[pos++] << 8 | bytes[pos++];
            count = bytes[pos++] << 8 | bytes[pos++];
            for (i = 0; i <= count; i++) {
              charset.push(cid ? id++ : strings.get(id++));
            }
          }
          break;
        default:
          throw new _util.FormatError('Unknown charset format');
      }
      var end = pos;
      var raw = bytes.subarray(start, end);
      return new CFFCharset(false, format, charset, raw);
    },
    parseEncoding: function CFFParser_parseEncoding(pos, properties, strings, charset) {
      var encoding = Object.create(null);
      var bytes = this.bytes;
      var predefined = false;
      var format, i, ii;
      var raw = null;
      function readSupplement() {
        var supplementsCount = bytes[pos++];
        for (i = 0; i < supplementsCount; i++) {
          var code = bytes[pos++];
          var sid = (bytes[pos++] << 8) + (bytes[pos++] & 0xff);
          encoding[code] = charset.indexOf(strings.get(sid));
        }
      }
      if (pos === 0 || pos === 1) {
        predefined = true;
        format = pos;
        var baseEncoding = pos ? _encodings.ExpertEncoding : _encodings.StandardEncoding;
        for (i = 0, ii = charset.length; i < ii; i++) {
          var index = baseEncoding.indexOf(charset[i]);
          if (index !== -1) {
            encoding[index] = i;
          }
        }
      } else {
        var dataStart = pos;
        format = bytes[pos++];
        switch (format & 0x7f) {
          case 0:
            var glyphsCount = bytes[pos++];
            for (i = 1; i <= glyphsCount; i++) {
              encoding[bytes[pos++]] = i;
            }
            break;
          case 1:
            var rangesCount = bytes[pos++];
            var gid = 1;
            for (i = 0; i < rangesCount; i++) {
              var start = bytes[pos++];
              var left = bytes[pos++];
              for (var j = start; j <= start + left; j++) {
                encoding[j] = gid++;
              }
            }
            break;
          default:
            throw new _util.FormatError('Unknown encoding format: ' + format + ' in CFF');
        }
        var dataEnd = pos;
        if (format & 0x80) {
          bytes[dataStart] &= 0x7f;
          readSupplement();
        }
        raw = bytes.subarray(dataStart, dataEnd);
      }
      format = format & 0x7f;
      return new CFFEncoding(predefined, format, encoding, raw);
    },
    parseFDSelect: function CFFParser_parseFDSelect(pos, length) {
      var start = pos;
      var bytes = this.bytes;
      var format = bytes[pos++];
      var fdSelect = [],
          rawBytes;
      var i,
          invalidFirstGID = false;
      switch (format) {
        case 0:
          for (i = 0; i < length; ++i) {
            var id = bytes[pos++];
            fdSelect.push(id);
          }
          rawBytes = bytes.subarray(start, pos);
          break;
        case 3:
          var rangesCount = bytes[pos++] << 8 | bytes[pos++];
          for (i = 0; i < rangesCount; ++i) {
            var first = bytes[pos++] << 8 | bytes[pos++];
            if (i === 0 && first !== 0) {
              (0, _util.warn)('parseFDSelect: The first range must have a first GID of 0' + ' -- trying to recover.');
              invalidFirstGID = true;
              first = 0;
            }
            var fdIndex = bytes[pos++];
            var next = bytes[pos] << 8 | bytes[pos + 1];
            for (var j = first; j < next; ++j) {
              fdSelect.push(fdIndex);
            }
          }
          pos += 2;
          rawBytes = bytes.subarray(start, pos);
          if (invalidFirstGID) {
            rawBytes[3] = rawBytes[4] = 0;
          }
          break;
        default:
          throw new _util.FormatError('parseFDSelect: Unknown format "' + format + '".');
      }
      if (fdSelect.length !== length) {
        throw new _util.FormatError('parseFDSelect: Invalid font data.');
      }
      return new CFFFDSelect(fdSelect, rawBytes);
    }
  };
  return CFFParser;
}();
var CFF = function CFFClosure() {
  function CFF() {
    this.header = null;
    this.names = [];
    this.topDict = null;
    this.strings = new CFFStrings();
    this.globalSubrIndex = null;
    this.encoding = null;
    this.charset = null;
    this.charStrings = null;
    this.fdArray = [];
    this.fdSelect = null;
    this.isCIDFont = false;
  }
  return CFF;
}();
var CFFHeader = function CFFHeaderClosure() {
  function CFFHeader(major, minor, hdrSize, offSize) {
    this.major = major;
    this.minor = minor;
    this.hdrSize = hdrSize;
    this.offSize = offSize;
  }
  return CFFHeader;
}();
var CFFStrings = function CFFStringsClosure() {
  function CFFStrings() {
    this.strings = [];
  }
  CFFStrings.prototype = {
    get: function CFFStrings_get(index) {
      if (index >= 0 && index <= 390) {
        return CFFStandardStrings[index];
      }
      if (index - 391 <= this.strings.length) {
        return this.strings[index - 391];
      }
      return CFFStandardStrings[0];
    },
    add: function CFFStrings_add(value) {
      this.strings.push(value);
    },
    get count() {
      return this.strings.length;
    }
  };
  return CFFStrings;
}();
var CFFIndex = function CFFIndexClosure() {
  function CFFIndex() {
    this.objects = [];
    this.length = 0;
  }
  CFFIndex.prototype = {
    add: function CFFIndex_add(data) {
      this.length += data.length;
      this.objects.push(data);
    },
    set: function CFFIndex_set(index, data) {
      this.length += data.length - this.objects[index].length;
      this.objects[index] = data;
    },
    get: function CFFIndex_get(index) {
      return this.objects[index];
    },
    get count() {
      return this.objects.length;
    }
  };
  return CFFIndex;
}();
var CFFDict = function CFFDictClosure() {
  function CFFDict(tables, strings) {
    this.keyToNameMap = tables.keyToNameMap;
    this.nameToKeyMap = tables.nameToKeyMap;
    this.defaults = tables.defaults;
    this.types = tables.types;
    this.opcodes = tables.opcodes;
    this.order = tables.order;
    this.strings = strings;
    this.values = Object.create(null);
  }
  CFFDict.prototype = {
    setByKey: function CFFDict_setByKey(key, value) {
      if (!(key in this.keyToNameMap)) {
        return false;
      }
      var valueLength = value.length;
      if (valueLength === 0) {
        return true;
      }
      for (var i = 0; i < valueLength; i++) {
        if (isNaN(value[i])) {
          (0, _util.warn)('Invalid CFFDict value: "' + value + '" for key "' + key + '".');
          return true;
        }
      }
      var type = this.types[key];
      if (type === 'num' || type === 'sid' || type === 'offset') {
        value = value[0];
      }
      this.values[key] = value;
      return true;
    },
    setByName: function CFFDict_setByName(name, value) {
      if (!(name in this.nameToKeyMap)) {
        throw new _util.FormatError('Invalid dictionary name "' + name + '"');
      }
      this.values[this.nameToKeyMap[name]] = value;
    },
    hasName: function CFFDict_hasName(name) {
      return this.nameToKeyMap[name] in this.values;
    },
    getByName: function CFFDict_getByName(name) {
      if (!(name in this.nameToKeyMap)) {
        throw new _util.FormatError('Invalid dictionary name ' + name + '"');
      }
      var key = this.nameToKeyMap[name];
      if (!(key in this.values)) {
        return this.defaults[key];
      }
      return this.values[key];
    },
    removeByName: function CFFDict_removeByName(name) {
      delete this.values[this.nameToKeyMap[name]];
    }
  };
  CFFDict.createTables = function CFFDict_createTables(layout) {
    var tables = {
      keyToNameMap: {},
      nameToKeyMap: {},
      defaults: {},
      types: {},
      opcodes: {},
      order: []
    };
    for (var i = 0, ii = layout.length; i < ii; ++i) {
      var entry = layout[i];
      var key = (0, _util.isArray)(entry[0]) ? (entry[0][0] << 8) + entry[0][1] : entry[0];
      tables.keyToNameMap[key] = entry[1];
      tables.nameToKeyMap[entry[1]] = key;
      tables.types[key] = entry[2];
      tables.defaults[key] = entry[3];
      tables.opcodes[key] = (0, _util.isArray)(entry[0]) ? entry[0] : [entry[0]];
      tables.order.push(key);
    }
    return tables;
  };
  return CFFDict;
}();
var CFFTopDict = function CFFTopDictClosure() {
  var layout = [[[12, 30], 'ROS', ['sid', 'sid', 'num'], null], [[12, 20], 'SyntheticBase', 'num', null], [0, 'version', 'sid', null], [1, 'Notice', 'sid', null], [[12, 0], 'Copyright', 'sid', null], [2, 'FullName', 'sid', null], [3, 'FamilyName', 'sid', null], [4, 'Weight', 'sid', null], [[12, 1], 'isFixedPitch', 'num', 0], [[12, 2], 'ItalicAngle', 'num', 0], [[12, 3], 'UnderlinePosition', 'num', -100], [[12, 4], 'UnderlineThickness', 'num', 50], [[12, 5], 'PaintType', 'num', 0], [[12, 6], 'CharstringType', 'num', 2], [[12, 7], 'FontMatrix', ['num', 'num', 'num', 'num', 'num', 'num'], [0.001, 0, 0, 0.001, 0, 0]], [13, 'UniqueID', 'num', null], [5, 'FontBBox', ['num', 'num', 'num', 'num'], [0, 0, 0, 0]], [[12, 8], 'StrokeWidth', 'num', 0], [14, 'XUID', 'array', null], [15, 'charset', 'offset', 0], [16, 'Encoding', 'offset', 0], [17, 'CharStrings', 'offset', 0], [18, 'Private', ['offset', 'offset'], null], [[12, 21], 'PostScript', 'sid', null], [[12, 22], 'BaseFontName', 'sid', null], [[12, 23], 'BaseFontBlend', 'delta', null], [[12, 31], 'CIDFontVersion', 'num', 0], [[12, 32], 'CIDFontRevision', 'num', 0], [[12, 33], 'CIDFontType', 'num', 0], [[12, 34], 'CIDCount', 'num', 8720], [[12, 35], 'UIDBase', 'num', null], [[12, 37], 'FDSelect', 'offset', null], [[12, 36], 'FDArray', 'offset', null], [[12, 38], 'FontName', 'sid', null]];
  var tables = null;
  function CFFTopDict(strings) {
    if (tables === null) {
      tables = CFFDict.createTables(layout);
    }
    CFFDict.call(this, tables, strings);
    this.privateDict = null;
  }
  CFFTopDict.prototype = Object.create(CFFDict.prototype);
  return CFFTopDict;
}();
var CFFPrivateDict = function CFFPrivateDictClosure() {
  var layout = [[6, 'BlueValues', 'delta', null], [7, 'OtherBlues', 'delta', null], [8, 'FamilyBlues', 'delta', null], [9, 'FamilyOtherBlues', 'delta', null], [[12, 9], 'BlueScale', 'num', 0.039625], [[12, 10], 'BlueShift', 'num', 7], [[12, 11], 'BlueFuzz', 'num', 1], [10, 'StdHW', 'num', null], [11, 'StdVW', 'num', null], [[12, 12], 'StemSnapH', 'delta', null], [[12, 13], 'StemSnapV', 'delta', null], [[12, 14], 'ForceBold', 'num', 0], [[12, 17], 'LanguageGroup', 'num', 0], [[12, 18], 'ExpansionFactor', 'num', 0.06], [[12, 19], 'initialRandomSeed', 'num', 0], [20, 'defaultWidthX', 'num', 0], [21, 'nominalWidthX', 'num', 0], [19, 'Subrs', 'offset', null]];
  var tables = null;
  function CFFPrivateDict(strings) {
    if (tables === null) {
      tables = CFFDict.createTables(layout);
    }
    CFFDict.call(this, tables, strings);
    this.subrsIndex = null;
  }
  CFFPrivateDict.prototype = Object.create(CFFDict.prototype);
  return CFFPrivateDict;
}();
var CFFCharsetPredefinedTypes = {
  ISO_ADOBE: 0,
  EXPERT: 1,
  EXPERT_SUBSET: 2
};
var CFFCharset = function CFFCharsetClosure() {
  function CFFCharset(predefined, format, charset, raw) {
    this.predefined = predefined;
    this.format = format;
    this.charset = charset;
    this.raw = raw;
  }
  return CFFCharset;
}();
var CFFEncoding = function CFFEncodingClosure() {
  function CFFEncoding(predefined, format, encoding, raw) {
    this.predefined = predefined;
    this.format = format;
    this.encoding = encoding;
    this.raw = raw;
  }
  return CFFEncoding;
}();
var CFFFDSelect = function CFFFDSelectClosure() {
  function CFFFDSelect(fdSelect, raw) {
    this.fdSelect = fdSelect;
    this.raw = raw;
  }
  CFFFDSelect.prototype = {
    getFDIndex: function CFFFDSelect_get(glyphIndex) {
      if (glyphIndex < 0 || glyphIndex >= this.fdSelect.length) {
        return -1;
      }
      return this.fdSelect[glyphIndex];
    }
  };
  return CFFFDSelect;
}();
var CFFOffsetTracker = function CFFOffsetTrackerClosure() {
  function CFFOffsetTracker() {
    this.offsets = Object.create(null);
  }
  CFFOffsetTracker.prototype = {
    isTracking: function CFFOffsetTracker_isTracking(key) {
      return key in this.offsets;
    },
    track: function CFFOffsetTracker_track(key, location) {
      if (key in this.offsets) {
        throw new _util.FormatError('Already tracking location of ' + key);
      }
      this.offsets[key] = location;
    },
    offset: function CFFOffsetTracker_offset(value) {
      for (var key in this.offsets) {
        this.offsets[key] += value;
      }
    },
    setEntryLocation: function CFFOffsetTracker_setEntryLocation(key, values, output) {
      if (!(key in this.offsets)) {
        throw new _util.FormatError('Not tracking location of ' + key);
      }
      var data = output.data;
      var dataOffset = this.offsets[key];
      var size = 5;
      for (var i = 0, ii = values.length; i < ii; ++i) {
        var offset0 = i * size + dataOffset;
        var offset1 = offset0 + 1;
        var offset2 = offset0 + 2;
        var offset3 = offset0 + 3;
        var offset4 = offset0 + 4;
        if (data[offset0] !== 0x1d || data[offset1] !== 0 || data[offset2] !== 0 || data[offset3] !== 0 || data[offset4] !== 0) {
          throw new _util.FormatError('writing to an offset that is not empty');
        }
        var value = values[i];
        data[offset0] = 0x1d;
        data[offset1] = value >> 24 & 0xFF;
        data[offset2] = value >> 16 & 0xFF;
        data[offset3] = value >> 8 & 0xFF;
        data[offset4] = value & 0xFF;
      }
    }
  };
  return CFFOffsetTracker;
}();
var CFFCompiler = function CFFCompilerClosure() {
  function CFFCompiler(cff) {
    this.cff = cff;
  }
  CFFCompiler.prototype = {
    compile: function CFFCompiler_compile() {
      var cff = this.cff;
      var output = {
        data: [],
        length: 0,
        add: function CFFCompiler_add(data) {
          this.data = this.data.concat(data);
          this.length = this.data.length;
        }
      };
      var header = this.compileHeader(cff.header);
      output.add(header);
      var nameIndex = this.compileNameIndex(cff.names);
      output.add(nameIndex);
      if (cff.isCIDFont) {
        if (cff.topDict.hasName('FontMatrix')) {
          var base = cff.topDict.getByName('FontMatrix');
          cff.topDict.removeByName('FontMatrix');
          for (var i = 0, ii = cff.fdArray.length; i < ii; i++) {
            var subDict = cff.fdArray[i];
            var matrix = base.slice(0);
            if (subDict.hasName('FontMatrix')) {
              matrix = _util.Util.transform(matrix, subDict.getByName('FontMatrix'));
            }
            subDict.setByName('FontMatrix', matrix);
          }
        }
      }
      var compiled = this.compileTopDicts([cff.topDict], output.length, cff.isCIDFont);
      output.add(compiled.output);
      var topDictTracker = compiled.trackers[0];
      var stringIndex = this.compileStringIndex(cff.strings.strings);
      output.add(stringIndex);
      var globalSubrIndex = this.compileIndex(cff.globalSubrIndex);
      output.add(globalSubrIndex);
      if (cff.encoding && cff.topDict.hasName('Encoding')) {
        if (cff.encoding.predefined) {
          topDictTracker.setEntryLocation('Encoding', [cff.encoding.format], output);
        } else {
          var encoding = this.compileEncoding(cff.encoding);
          topDictTracker.setEntryLocation('Encoding', [output.length], output);
          output.add(encoding);
        }
      }
      if (cff.charset && cff.topDict.hasName('charset')) {
        if (cff.charset.predefined) {
          topDictTracker.setEntryLocation('charset', [cff.charset.format], output);
        } else {
          var charset = this.compileCharset(cff.charset);
          topDictTracker.setEntryLocation('charset', [output.length], output);
          output.add(charset);
        }
      }
      var charStrings = this.compileCharStrings(cff.charStrings);
      topDictTracker.setEntryLocation('CharStrings', [output.length], output);
      output.add(charStrings);
      if (cff.isCIDFont) {
        topDictTracker.setEntryLocation('FDSelect', [output.length], output);
        var fdSelect = this.compileFDSelect(cff.fdSelect.raw);
        output.add(fdSelect);
        compiled = this.compileTopDicts(cff.fdArray, output.length, true);
        topDictTracker.setEntryLocation('FDArray', [output.length], output);
        output.add(compiled.output);
        var fontDictTrackers = compiled.trackers;
        this.compilePrivateDicts(cff.fdArray, fontDictTrackers, output);
      }
      this.compilePrivateDicts([cff.topDict], [topDictTracker], output);
      output.add([0]);
      return output.data;
    },
    encodeNumber: function CFFCompiler_encodeNumber(value) {
      if (parseFloat(value) === parseInt(value, 10) && !isNaN(value)) {
        return this.encodeInteger(value);
      }
      return this.encodeFloat(value);
    },
    encodeFloat: function CFFCompiler_encodeFloat(num) {
      var value = num.toString();
      var m = /\.(\d*?)(?:9{5,20}|0{5,20})\d{0,2}(?:e(.+)|$)/.exec(value);
      if (m) {
        var epsilon = parseFloat('1e' + ((m[2] ? +m[2] : 0) + m[1].length));
        value = (Math.round(num * epsilon) / epsilon).toString();
      }
      var nibbles = '';
      var i, ii;
      for (i = 0, ii = value.length; i < ii; ++i) {
        var a = value[i];
        if (a === 'e') {
          nibbles += value[++i] === '-' ? 'c' : 'b';
        } else if (a === '.') {
          nibbles += 'a';
        } else if (a === '-') {
          nibbles += 'e';
        } else {
          nibbles += a;
        }
      }
      nibbles += nibbles.length & 1 ? 'f' : 'ff';
      var out = [30];
      for (i = 0, ii = nibbles.length; i < ii; i += 2) {
        out.push(parseInt(nibbles.substr(i, 2), 16));
      }
      return out;
    },
    encodeInteger: function CFFCompiler_encodeInteger(value) {
      var code;
      if (value >= -107 && value <= 107) {
        code = [value + 139];
      } else if (value >= 108 && value <= 1131) {
        value = value - 108;
        code = [(value >> 8) + 247, value & 0xFF];
      } else if (value >= -1131 && value <= -108) {
        value = -value - 108;
        code = [(value >> 8) + 251, value & 0xFF];
      } else if (value >= -32768 && value <= 32767) {
        code = [0x1c, value >> 8 & 0xFF, value & 0xFF];
      } else {
        code = [0x1d, value >> 24 & 0xFF, value >> 16 & 0xFF, value >> 8 & 0xFF, value & 0xFF];
      }
      return code;
    },
    compileHeader: function CFFCompiler_compileHeader(header) {
      return [header.major, header.minor, header.hdrSize, header.offSize];
    },
    compileNameIndex: function CFFCompiler_compileNameIndex(names) {
      var nameIndex = new CFFIndex();
      for (var i = 0, ii = names.length; i < ii; ++i) {
        nameIndex.add((0, _util.stringToBytes)(names[i]));
      }
      return this.compileIndex(nameIndex);
    },
    compileTopDicts: function CFFCompiler_compileTopDicts(dicts, length, removeCidKeys) {
      var fontDictTrackers = [];
      var fdArrayIndex = new CFFIndex();
      for (var i = 0, ii = dicts.length; i < ii; ++i) {
        var fontDict = dicts[i];
        if (removeCidKeys) {
          fontDict.removeByName('CIDFontVersion');
          fontDict.removeByName('CIDFontRevision');
          fontDict.removeByName('CIDFontType');
          fontDict.removeByName('CIDCount');
          fontDict.removeByName('UIDBase');
        }
        var fontDictTracker = new CFFOffsetTracker();
        var fontDictData = this.compileDict(fontDict, fontDictTracker);
        fontDictTrackers.push(fontDictTracker);
        fdArrayIndex.add(fontDictData);
        fontDictTracker.offset(length);
      }
      fdArrayIndex = this.compileIndex(fdArrayIndex, fontDictTrackers);
      return {
        trackers: fontDictTrackers,
        output: fdArrayIndex
      };
    },
    compilePrivateDicts: function CFFCompiler_compilePrivateDicts(dicts, trackers, output) {
      for (var i = 0, ii = dicts.length; i < ii; ++i) {
        var fontDict = dicts[i];
        var privateDict = fontDict.privateDict;
        if (!privateDict || !fontDict.hasName('Private')) {
          throw new _util.FormatError('There must be a private dictionary.');
        }
        var privateDictTracker = new CFFOffsetTracker();
        var privateDictData = this.compileDict(privateDict, privateDictTracker);
        var outputLength = output.length;
        privateDictTracker.offset(outputLength);
        if (!privateDictData.length) {
          outputLength = 0;
        }
        trackers[i].setEntryLocation('Private', [privateDictData.length, outputLength], output);
        output.add(privateDictData);
        if (privateDict.subrsIndex && privateDict.hasName('Subrs')) {
          var subrs = this.compileIndex(privateDict.subrsIndex);
          privateDictTracker.setEntryLocation('Subrs', [privateDictData.length], output);
          output.add(subrs);
        }
      }
    },
    compileDict: function CFFCompiler_compileDict(dict, offsetTracker) {
      var out = [];
      var order = dict.order;
      for (var i = 0; i < order.length; ++i) {
        var key = order[i];
        if (!(key in dict.values)) {
          continue;
        }
        var values = dict.values[key];
        var types = dict.types[key];
        if (!(0, _util.isArray)(types)) {
          types = [types];
        }
        if (!(0, _util.isArray)(values)) {
          values = [values];
        }
        if (values.length === 0) {
          continue;
        }
        for (var j = 0, jj = types.length; j < jj; ++j) {
          var type = types[j];
          var value = values[j];
          switch (type) {
            case 'num':
            case 'sid':
              out = out.concat(this.encodeNumber(value));
              break;
            case 'offset':
              var name = dict.keyToNameMap[key];
              if (!offsetTracker.isTracking(name)) {
                offsetTracker.track(name, out.length);
              }
              out = out.concat([0x1d, 0, 0, 0, 0]);
              break;
            case 'array':
            case 'delta':
              out = out.concat(this.encodeNumber(value));
              for (var k = 1, kk = values.length; k < kk; ++k) {
                out = out.concat(this.encodeNumber(values[k]));
              }
              break;
            default:
              throw new _util.FormatError('Unknown data type of ' + type);
          }
        }
        out = out.concat(dict.opcodes[key]);
      }
      return out;
    },
    compileStringIndex: function CFFCompiler_compileStringIndex(strings) {
      var stringIndex = new CFFIndex();
      for (var i = 0, ii = strings.length; i < ii; ++i) {
        stringIndex.add((0, _util.stringToBytes)(strings[i]));
      }
      return this.compileIndex(stringIndex);
    },
    compileGlobalSubrIndex: function CFFCompiler_compileGlobalSubrIndex() {
      var globalSubrIndex = this.cff.globalSubrIndex;
      this.out.writeByteArray(this.compileIndex(globalSubrIndex));
    },
    compileCharStrings: function CFFCompiler_compileCharStrings(charStrings) {
      return this.compileIndex(charStrings);
    },
    compileCharset: function CFFCompiler_compileCharset(charset) {
      return this.compileTypedArray(charset.raw);
    },
    compileEncoding: function CFFCompiler_compileEncoding(encoding) {
      return this.compileTypedArray(encoding.raw);
    },
    compileFDSelect: function CFFCompiler_compileFDSelect(fdSelect) {
      return this.compileTypedArray(fdSelect);
    },
    compileTypedArray: function CFFCompiler_compileTypedArray(data) {
      var out = [];
      for (var i = 0, ii = data.length; i < ii; ++i) {
        out[i] = data[i];
      }
      return out;
    },
    compileIndex: function CFFCompiler_compileIndex(index, trackers) {
      trackers = trackers || [];
      var objects = index.objects;
      var count = objects.length;
      if (count === 0) {
        return [0, 0, 0];
      }
      var data = [count >> 8 & 0xFF, count & 0xff];
      var lastOffset = 1,
          i;
      for (i = 0; i < count; ++i) {
        lastOffset += objects[i].length;
      }
      var offsetSize;
      if (lastOffset < 0x100) {
        offsetSize = 1;
      } else if (lastOffset < 0x10000) {
        offsetSize = 2;
      } else if (lastOffset < 0x1000000) {
        offsetSize = 3;
      } else {
        offsetSize = 4;
      }
      data.push(offsetSize);
      var relativeOffset = 1;
      for (i = 0; i < count + 1; i++) {
        if (offsetSize === 1) {
          data.push(relativeOffset & 0xFF);
        } else if (offsetSize === 2) {
          data.push(relativeOffset >> 8 & 0xFF, relativeOffset & 0xFF);
        } else if (offsetSize === 3) {
          data.push(relativeOffset >> 16 & 0xFF, relativeOffset >> 8 & 0xFF, relativeOffset & 0xFF);
        } else {
          data.push(relativeOffset >>> 24 & 0xFF, relativeOffset >> 16 & 0xFF, relativeOffset >> 8 & 0xFF, relativeOffset & 0xFF);
        }
        if (objects[i]) {
          relativeOffset += objects[i].length;
        }
      }
      for (i = 0; i < count; i++) {
        if (trackers[i]) {
          trackers[i].offset(data.length);
        }
        for (var j = 0, jj = objects[i].length; j < jj; j++) {
          data.push(objects[i][j]);
        }
      }
      return data;
    }
  };
  return CFFCompiler;
}();
exports.CFFStandardStrings = CFFStandardStrings;
exports.CFFParser = CFFParser;
exports.CFF = CFF;
exports.CFFHeader = CFFHeader;
exports.CFFStrings = CFFStrings;
exports.CFFIndex = CFFIndex;
exports.CFFCharset = CFFCharset;
exports.CFFTopDict = CFFTopDict;
exports.CFFPrivateDict = CFFPrivateDict;
exports.CFFCompiler = CFFCompiler;

/***/ }),
/* 10 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChunkedStreamManager = exports.ChunkedStream = undefined;

var _util = __w_pdfjs_require__(0);

var ChunkedStream = function ChunkedStreamClosure() {
  function ChunkedStream(length, chunkSize, manager) {
    this.bytes = new Uint8Array(length);
    this.start = 0;
    this.pos = 0;
    this.end = length;
    this.chunkSize = chunkSize;
    this.loadedChunks = [];
    this.numChunksLoaded = 0;
    this.numChunks = Math.ceil(length / chunkSize);
    this.manager = manager;
    this.progressiveDataLength = 0;
    this.lastSuccessfulEnsureByteChunk = -1;
  }
  ChunkedStream.prototype = {
    getMissingChunks: function ChunkedStream_getMissingChunks() {
      var chunks = [];
      for (var chunk = 0, n = this.numChunks; chunk < n; ++chunk) {
        if (!this.loadedChunks[chunk]) {
          chunks.push(chunk);
        }
      }
      return chunks;
    },
    getBaseStreams: function ChunkedStream_getBaseStreams() {
      return [this];
    },
    allChunksLoaded: function ChunkedStream_allChunksLoaded() {
      return this.numChunksLoaded === this.numChunks;
    },
    onReceiveData: function ChunkedStream_onReceiveData(begin, chunk) {
      var end = begin + chunk.byteLength;
      if (begin % this.chunkSize !== 0) {
        throw new Error('Bad begin offset: ' + begin);
      }
      var length = this.bytes.length;
      if (end % this.chunkSize !== 0 && end !== length) {
        throw new Error('Bad end offset: ' + end);
      }
      this.bytes.set(new Uint8Array(chunk), begin);
      var chunkSize = this.chunkSize;
      var beginChunk = Math.floor(begin / chunkSize);
      var endChunk = Math.floor((end - 1) / chunkSize) + 1;
      var curChunk;
      for (curChunk = beginChunk; curChunk < endChunk; ++curChunk) {
        if (!this.loadedChunks[curChunk]) {
          this.loadedChunks[curChunk] = true;
          ++this.numChunksLoaded;
        }
      }
    },
    onReceiveProgressiveData: function ChunkedStream_onReceiveProgressiveData(data) {
      var position = this.progressiveDataLength;
      var beginChunk = Math.floor(position / this.chunkSize);
      this.bytes.set(new Uint8Array(data), position);
      position += data.byteLength;
      this.progressiveDataLength = position;
      var endChunk = position >= this.end ? this.numChunks : Math.floor(position / this.chunkSize);
      var curChunk;
      for (curChunk = beginChunk; curChunk < endChunk; ++curChunk) {
        if (!this.loadedChunks[curChunk]) {
          this.loadedChunks[curChunk] = true;
          ++this.numChunksLoaded;
        }
      }
    },
    ensureByte: function ChunkedStream_ensureByte(pos) {
      var chunk = Math.floor(pos / this.chunkSize);
      if (chunk === this.lastSuccessfulEnsureByteChunk) {
        return;
      }
      if (!this.loadedChunks[chunk]) {
        throw new _util.MissingDataException(pos, pos + 1);
      }
      this.lastSuccessfulEnsureByteChunk = chunk;
    },
    ensureRange: function ChunkedStream_ensureRange(begin, end) {
      if (begin >= end) {
        return;
      }
      if (end <= this.progressiveDataLength) {
        return;
      }
      var chunkSize = this.chunkSize;
      var beginChunk = Math.floor(begin / chunkSize);
      var endChunk = Math.floor((end - 1) / chunkSize) + 1;
      for (var chunk = beginChunk; chunk < endChunk; ++chunk) {
        if (!this.loadedChunks[chunk]) {
          throw new _util.MissingDataException(begin, end);
        }
      }
    },
    nextEmptyChunk: function ChunkedStream_nextEmptyChunk(beginChunk) {
      var chunk,
          numChunks = this.numChunks;
      for (var i = 0; i < numChunks; ++i) {
        chunk = (beginChunk + i) % numChunks;
        if (!this.loadedChunks[chunk]) {
          return chunk;
        }
      }
      return null;
    },
    hasChunk: function ChunkedStream_hasChunk(chunk) {
      return !!this.loadedChunks[chunk];
    },
    get length() {
      return this.end - this.start;
    },
    get isEmpty() {
      return this.length === 0;
    },
    getByte: function ChunkedStream_getByte() {
      var pos = this.pos;
      if (pos >= this.end) {
        return -1;
      }
      this.ensureByte(pos);
      return this.bytes[this.pos++];
    },
    getUint16: function ChunkedStream_getUint16() {
      var b0 = this.getByte();
      var b1 = this.getByte();
      if (b0 === -1 || b1 === -1) {
        return -1;
      }
      return (b0 << 8) + b1;
    },
    getInt32: function ChunkedStream_getInt32() {
      var b0 = this.getByte();
      var b1 = this.getByte();
      var b2 = this.getByte();
      var b3 = this.getByte();
      return (b0 << 24) + (b1 << 16) + (b2 << 8) + b3;
    },
    getBytes: function ChunkedStream_getBytes(length) {
      var bytes = this.bytes;
      var pos = this.pos;
      var strEnd = this.end;
      if (!length) {
        this.ensureRange(pos, strEnd);
        return bytes.subarray(pos, strEnd);
      }
      var end = pos + length;
      if (end > strEnd) {
        end = strEnd;
      }
      this.ensureRange(pos, end);
      this.pos = end;
      return bytes.subarray(pos, end);
    },
    peekByte: function ChunkedStream_peekByte() {
      var peekedByte = this.getByte();
      this.pos--;
      return peekedByte;
    },
    peekBytes: function ChunkedStream_peekBytes(length) {
      var bytes = this.getBytes(length);
      this.pos -= bytes.length;
      return bytes;
    },
    getByteRange: function ChunkedStream_getBytes(begin, end) {
      this.ensureRange(begin, end);
      return this.bytes.subarray(begin, end);
    },
    skip: function ChunkedStream_skip(n) {
      if (!n) {
        n = 1;
      }
      this.pos += n;
    },
    reset: function ChunkedStream_reset() {
      this.pos = this.start;
    },
    moveStart: function ChunkedStream_moveStart() {
      this.start = this.pos;
    },
    makeSubStream: function ChunkedStream_makeSubStream(start, length, dict) {
      this.ensureRange(start, start + length);
      function ChunkedStreamSubstream() {}
      ChunkedStreamSubstream.prototype = Object.create(this);
      ChunkedStreamSubstream.prototype.getMissingChunks = function () {
        var chunkSize = this.chunkSize;
        var beginChunk = Math.floor(this.start / chunkSize);
        var endChunk = Math.floor((this.end - 1) / chunkSize) + 1;
        var missingChunks = [];
        for (var chunk = beginChunk; chunk < endChunk; ++chunk) {
          if (!this.loadedChunks[chunk]) {
            missingChunks.push(chunk);
          }
        }
        return missingChunks;
      };
      var subStream = new ChunkedStreamSubstream();
      subStream.pos = subStream.start = start;
      subStream.end = start + length || this.end;
      subStream.dict = dict;
      return subStream;
    }
  };
  return ChunkedStream;
}();
var ChunkedStreamManager = function ChunkedStreamManagerClosure() {
  function ChunkedStreamManager(pdfNetworkStream, args) {
    var chunkSize = args.rangeChunkSize;
    var length = args.length;
    this.stream = new ChunkedStream(length, chunkSize, this);
    this.length = length;
    this.chunkSize = chunkSize;
    this.pdfNetworkStream = pdfNetworkStream;
    this.url = args.url;
    this.disableAutoFetch = args.disableAutoFetch;
    this.msgHandler = args.msgHandler;
    this.currRequestId = 0;
    this.chunksNeededByRequest = Object.create(null);
    this.requestsByChunk = Object.create(null);
    this.promisesByRequest = Object.create(null);
    this.progressiveDataLength = 0;
    this.aborted = false;
    this._loadedStreamCapability = (0, _util.createPromiseCapability)();
  }
  ChunkedStreamManager.prototype = {
    onLoadedStream: function ChunkedStreamManager_getLoadedStream() {
      return this._loadedStreamCapability.promise;
    },
    sendRequest: function ChunkedStreamManager_sendRequest(begin, end) {
      var _this = this;

      var rangeReader = this.pdfNetworkStream.getRangeReader(begin, end);
      if (!rangeReader.isStreamingSupported) {
        rangeReader.onProgress = this.onProgress.bind(this);
      }
      var chunks = [],
          loaded = 0;
      var manager = this;
      var promise = new Promise(function (resolve, reject) {
        var readChunk = function readChunk(chunk) {
          try {
            if (!chunk.done) {
              var data = chunk.value;
              chunks.push(data);
              loaded += (0, _util.arrayByteLength)(data);
              if (rangeReader.isStreamingSupported) {
                manager.onProgress({ loaded: loaded });
              }
              rangeReader.read().then(readChunk, reject);
              return;
            }
            var chunkData = (0, _util.arraysToBytes)(chunks);
            chunks = null;
            resolve(chunkData);
          } catch (e) {
            reject(e);
          }
        };
        rangeReader.read().then(readChunk, reject);
      });
      promise.then(function (data) {
        if (_this.aborted) {
          return;
        }
        _this.onReceiveData({
          chunk: data,
          begin: begin
        });
      });
    },
    requestAllChunks: function ChunkedStreamManager_requestAllChunks() {
      var missingChunks = this.stream.getMissingChunks();
      this._requestChunks(missingChunks);
      return this._loadedStreamCapability.promise;
    },
    _requestChunks: function ChunkedStreamManager_requestChunks(chunks) {
      var requestId = this.currRequestId++;
      var i, ii;
      var chunksNeeded = Object.create(null);
      this.chunksNeededByRequest[requestId] = chunksNeeded;
      for (i = 0, ii = chunks.length; i < ii; i++) {
        if (!this.stream.hasChunk(chunks[i])) {
          chunksNeeded[chunks[i]] = true;
        }
      }
      if ((0, _util.isEmptyObj)(chunksNeeded)) {
        return Promise.resolve();
      }
      var capability = (0, _util.createPromiseCapability)();
      this.promisesByRequest[requestId] = capability;
      var chunksToRequest = [];
      for (var chunk in chunksNeeded) {
        chunk = chunk | 0;
        if (!(chunk in this.requestsByChunk)) {
          this.requestsByChunk[chunk] = [];
          chunksToRequest.push(chunk);
        }
        this.requestsByChunk[chunk].push(requestId);
      }
      if (!chunksToRequest.length) {
        return capability.promise;
      }
      var groupedChunksToRequest = this.groupChunks(chunksToRequest);
      for (i = 0; i < groupedChunksToRequest.length; ++i) {
        var groupedChunk = groupedChunksToRequest[i];
        var begin = groupedChunk.beginChunk * this.chunkSize;
        var end = Math.min(groupedChunk.endChunk * this.chunkSize, this.length);
        this.sendRequest(begin, end);
      }
      return capability.promise;
    },
    getStream: function ChunkedStreamManager_getStream() {
      return this.stream;
    },
    requestRange: function ChunkedStreamManager_requestRange(begin, end) {
      end = Math.min(end, this.length);
      var beginChunk = this.getBeginChunk(begin);
      var endChunk = this.getEndChunk(end);
      var chunks = [];
      for (var chunk = beginChunk; chunk < endChunk; ++chunk) {
        chunks.push(chunk);
      }
      return this._requestChunks(chunks);
    },
    requestRanges: function ChunkedStreamManager_requestRanges(ranges) {
      ranges = ranges || [];
      var chunksToRequest = [];
      for (var i = 0; i < ranges.length; i++) {
        var beginChunk = this.getBeginChunk(ranges[i].begin);
        var endChunk = this.getEndChunk(ranges[i].end);
        for (var chunk = beginChunk; chunk < endChunk; ++chunk) {
          if (chunksToRequest.indexOf(chunk) < 0) {
            chunksToRequest.push(chunk);
          }
        }
      }
      chunksToRequest.sort(function (a, b) {
        return a - b;
      });
      return this._requestChunks(chunksToRequest);
    },
    groupChunks: function ChunkedStreamManager_groupChunks(chunks) {
      var groupedChunks = [];
      var beginChunk = -1;
      var prevChunk = -1;
      for (var i = 0; i < chunks.length; ++i) {
        var chunk = chunks[i];
        if (beginChunk < 0) {
          beginChunk = chunk;
        }
        if (prevChunk >= 0 && prevChunk + 1 !== chunk) {
          groupedChunks.push({
            beginChunk: beginChunk,
            endChunk: prevChunk + 1
          });
          beginChunk = chunk;
        }
        if (i + 1 === chunks.length) {
          groupedChunks.push({
            beginChunk: beginChunk,
            endChunk: chunk + 1
          });
        }
        prevChunk = chunk;
      }
      return groupedChunks;
    },
    onProgress: function ChunkedStreamManager_onProgress(args) {
      var bytesLoaded = this.stream.numChunksLoaded * this.chunkSize + args.loaded;
      this.msgHandler.send('DocProgress', {
        loaded: bytesLoaded,
        total: this.length
      });
    },
    onReceiveData: function ChunkedStreamManager_onReceiveData(args) {
      var chunk = args.chunk;
      var isProgressive = args.begin === undefined;
      var begin = isProgressive ? this.progressiveDataLength : args.begin;
      var end = begin + chunk.byteLength;
      var beginChunk = Math.floor(begin / this.chunkSize);
      var endChunk = end < this.length ? Math.floor(end / this.chunkSize) : Math.ceil(end / this.chunkSize);
      if (isProgressive) {
        this.stream.onReceiveProgressiveData(chunk);
        this.progressiveDataLength = end;
      } else {
        this.stream.onReceiveData(begin, chunk);
      }
      if (this.stream.allChunksLoaded()) {
        this._loadedStreamCapability.resolve(this.stream);
      }
      var loadedRequests = [];
      var i, requestId;
      for (chunk = beginChunk; chunk < endChunk; ++chunk) {
        var requestIds = this.requestsByChunk[chunk] || [];
        delete this.requestsByChunk[chunk];
        for (i = 0; i < requestIds.length; ++i) {
          requestId = requestIds[i];
          var chunksNeeded = this.chunksNeededByRequest[requestId];
          if (chunk in chunksNeeded) {
            delete chunksNeeded[chunk];
          }
          if (!(0, _util.isEmptyObj)(chunksNeeded)) {
            continue;
          }
          loadedRequests.push(requestId);
        }
      }
      if (!this.disableAutoFetch && (0, _util.isEmptyObj)(this.requestsByChunk)) {
        var nextEmptyChunk;
        if (this.stream.numChunksLoaded === 1) {
          var lastChunk = this.stream.numChunks - 1;
          if (!this.stream.hasChunk(lastChunk)) {
            nextEmptyChunk = lastChunk;
          }
        } else {
          nextEmptyChunk = this.stream.nextEmptyChunk(endChunk);
        }
        if ((0, _util.isInt)(nextEmptyChunk)) {
          this._requestChunks([nextEmptyChunk]);
        }
      }
      for (i = 0; i < loadedRequests.length; ++i) {
        requestId = loadedRequests[i];
        var capability = this.promisesByRequest[requestId];
        delete this.promisesByRequest[requestId];
        capability.resolve();
      }
      this.msgHandler.send('DocProgress', {
        loaded: this.stream.numChunksLoaded * this.chunkSize,
        total: this.length
      });
    },
    onError: function ChunkedStreamManager_onError(err) {
      this._loadedStreamCapability.reject(err);
    },
    getBeginChunk: function ChunkedStreamManager_getBeginChunk(begin) {
      var chunk = Math.floor(begin / this.chunkSize);
      return chunk;
    },
    getEndChunk: function ChunkedStreamManager_getEndChunk(end) {
      var chunk = Math.floor((end - 1) / this.chunkSize) + 1;
      return chunk;
    },
    abort: function ChunkedStreamManager_abort() {
      this.aborted = true;
      if (this.pdfNetworkStream) {
        this.pdfNetworkStream.cancelAllRequests('abort');
      }
      for (var requestId in this.promisesByRequest) {
        var capability = this.promisesByRequest[requestId];
        capability.reject(new Error('Request was aborted'));
      }
    }
  };
  return ChunkedStreamManager;
}();
exports.ChunkedStream = ChunkedStream;
exports.ChunkedStreamManager = ChunkedStreamManager;

/***/ }),
/* 11 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateSHA512 = exports.calculateSHA384 = exports.calculateSHA256 = exports.calculateMD5 = exports.PDF20 = exports.PDF17 = exports.CipherTransformFactory = exports.ARCFourCipher = exports.AES256Cipher = exports.AES128Cipher = undefined;

var _util = __w_pdfjs_require__(0);

var _primitives = __w_pdfjs_require__(1);

var _stream = __w_pdfjs_require__(2);

var ARCFourCipher = function ARCFourCipherClosure() {
  function ARCFourCipher(key) {
    this.a = 0;
    this.b = 0;
    var s = new Uint8Array(256);
    var i,
        j = 0,
        tmp,
        keyLength = key.length;
    for (i = 0; i < 256; ++i) {
      s[i] = i;
    }
    for (i = 0; i < 256; ++i) {
      tmp = s[i];
      j = j + tmp + key[i % keyLength] & 0xFF;
      s[i] = s[j];
      s[j] = tmp;
    }
    this.s = s;
  }
  ARCFourCipher.prototype = {
    encryptBlock: function ARCFourCipher_encryptBlock(data) {
      var i,
          n = data.length,
          tmp,
          tmp2;
      var a = this.a,
          b = this.b,
          s = this.s;
      var output = new Uint8Array(n);
      for (i = 0; i < n; ++i) {
        a = a + 1 & 0xFF;
        tmp = s[a];
        b = b + tmp & 0xFF;
        tmp2 = s[b];
        s[a] = tmp2;
        s[b] = tmp;
        output[i] = data[i] ^ s[tmp + tmp2 & 0xFF];
      }
      this.a = a;
      this.b = b;
      return output;
    }
  };
  ARCFourCipher.prototype.decryptBlock = ARCFourCipher.prototype.encryptBlock;
  return ARCFourCipher;
}();
var calculateMD5 = function calculateMD5Closure() {
  var r = new Uint8Array([7, 12, 17, 22, 7, 12, 17, 22, 7, 12, 17, 22, 7, 12, 17, 22, 5, 9, 14, 20, 5, 9, 14, 20, 5, 9, 14, 20, 5, 9, 14, 20, 4, 11, 16, 23, 4, 11, 16, 23, 4, 11, 16, 23, 4, 11, 16, 23, 6, 10, 15, 21, 6, 10, 15, 21, 6, 10, 15, 21, 6, 10, 15, 21]);
  var k = new Int32Array([-680876936, -389564586, 606105819, -1044525330, -176418897, 1200080426, -1473231341, -45705983, 1770035416, -1958414417, -42063, -1990404162, 1804603682, -40341101, -1502002290, 1236535329, -165796510, -1069501632, 643717713, -373897302, -701558691, 38016083, -660478335, -405537848, 568446438, -1019803690, -187363961, 1163531501, -1444681467, -51403784, 1735328473, -1926607734, -378558, -2022574463, 1839030562, -35309556, -1530992060, 1272893353, -155497632, -1094730640, 681279174, -358537222, -722521979, 76029189, -640364487, -421815835, 530742520, -995338651, -198630844, 1126891415, -1416354905, -57434055, 1700485571, -1894986606, -1051523, -2054922799, 1873313359, -30611744, -1560198380, 1309151649, -145523070, -1120210379, 718787259, -343485551]);
  function hash(data, offset, length) {
    var h0 = 1732584193,
        h1 = -271733879,
        h2 = -1732584194,
        h3 = 271733878;
    var paddedLength = length + 72 & ~63;
    var padded = new Uint8Array(paddedLength);
    var i, j, n;
    for (i = 0; i < length; ++i) {
      padded[i] = data[offset++];
    }
    padded[i++] = 0x80;
    n = paddedLength - 8;
    while (i < n) {
      padded[i++] = 0;
    }
    padded[i++] = length << 3 & 0xFF;
    padded[i++] = length >> 5 & 0xFF;
    padded[i++] = length >> 13 & 0xFF;
    padded[i++] = length >> 21 & 0xFF;
    padded[i++] = length >>> 29 & 0xFF;
    padded[i++] = 0;
    padded[i++] = 0;
    padded[i++] = 0;
    var w = new Int32Array(16);
    for (i = 0; i < paddedLength;) {
      for (j = 0; j < 16; ++j, i += 4) {
        w[j] = padded[i] | padded[i + 1] << 8 | padded[i + 2] << 16 | padded[i + 3] << 24;
      }
      var a = h0,
          b = h1,
          c = h2,
          d = h3,
          f,
          g;
      for (j = 0; j < 64; ++j) {
        if (j < 16) {
          f = b & c | ~b & d;
          g = j;
        } else if (j < 32) {
          f = d & b | ~d & c;
          g = 5 * j + 1 & 15;
        } else if (j < 48) {
          f = b ^ c ^ d;
          g = 3 * j + 5 & 15;
        } else {
          f = c ^ (b | ~d);
          g = 7 * j & 15;
        }
        var tmp = d,
            rotateArg = a + f + k[j] + w[g] | 0,
            rotate = r[j];
        d = c;
        c = b;
        b = b + (rotateArg << rotate | rotateArg >>> 32 - rotate) | 0;
        a = tmp;
      }
      h0 = h0 + a | 0;
      h1 = h1 + b | 0;
      h2 = h2 + c | 0;
      h3 = h3 + d | 0;
    }
    return new Uint8Array([h0 & 0xFF, h0 >> 8 & 0xFF, h0 >> 16 & 0xFF, h0 >>> 24 & 0xFF, h1 & 0xFF, h1 >> 8 & 0xFF, h1 >> 16 & 0xFF, h1 >>> 24 & 0xFF, h2 & 0xFF, h2 >> 8 & 0xFF, h2 >> 16 & 0xFF, h2 >>> 24 & 0xFF, h3 & 0xFF, h3 >> 8 & 0xFF, h3 >> 16 & 0xFF, h3 >>> 24 & 0xFF]);
  }
  return hash;
}();
var Word64 = function Word64Closure() {
  function Word64(highInteger, lowInteger) {
    this.high = highInteger | 0;
    this.low = lowInteger | 0;
  }
  Word64.prototype = {
    and: function Word64_and(word) {
      this.high &= word.high;
      this.low &= word.low;
    },
    xor: function Word64_xor(word) {
      this.high ^= word.high;
      this.low ^= word.low;
    },
    or: function Word64_or(word) {
      this.high |= word.high;
      this.low |= word.low;
    },
    shiftRight: function Word64_shiftRight(places) {
      if (places >= 32) {
        this.low = this.high >>> places - 32 | 0;
        this.high = 0;
      } else {
        this.low = this.low >>> places | this.high << 32 - places;
        this.high = this.high >>> places | 0;
      }
    },
    shiftLeft: function Word64_shiftLeft(places) {
      if (places >= 32) {
        this.high = this.low << places - 32;
        this.low = 0;
      } else {
        this.high = this.high << places | this.low >>> 32 - places;
        this.low = this.low << places;
      }
    },
    rotateRight: function Word64_rotateRight(places) {
      var low, high;
      if (places & 32) {
        high = this.low;
        low = this.high;
      } else {
        low = this.low;
        high = this.high;
      }
      places &= 31;
      this.low = low >>> places | high << 32 - places;
      this.high = high >>> places | low << 32 - places;
    },
    not: function Word64_not() {
      this.high = ~this.high;
      this.low = ~this.low;
    },
    add: function Word64_add(word) {
      var lowAdd = (this.low >>> 0) + (word.low >>> 0);
      var highAdd = (this.high >>> 0) + (word.high >>> 0);
      if (lowAdd > 0xFFFFFFFF) {
        highAdd += 1;
      }
      this.low = lowAdd | 0;
      this.high = highAdd | 0;
    },
    copyTo: function Word64_copyTo(bytes, offset) {
      bytes[offset] = this.high >>> 24 & 0xFF;
      bytes[offset + 1] = this.high >> 16 & 0xFF;
      bytes[offset + 2] = this.high >> 8 & 0xFF;
      bytes[offset + 3] = this.high & 0xFF;
      bytes[offset + 4] = this.low >>> 24 & 0xFF;
      bytes[offset + 5] = this.low >> 16 & 0xFF;
      bytes[offset + 6] = this.low >> 8 & 0xFF;
      bytes[offset + 7] = this.low & 0xFF;
    },
    assign: function Word64_assign(word) {
      this.high = word.high;
      this.low = word.low;
    }
  };
  return Word64;
}();
var calculateSHA256 = function calculateSHA256Closure() {
  function rotr(x, n) {
    return x >>> n | x << 32 - n;
  }
  function ch(x, y, z) {
    return x & y ^ ~x & z;
  }
  function maj(x, y, z) {
    return x & y ^ x & z ^ y & z;
  }
  function sigma(x) {
    return rotr(x, 2) ^ rotr(x, 13) ^ rotr(x, 22);
  }
  function sigmaPrime(x) {
    return rotr(x, 6) ^ rotr(x, 11) ^ rotr(x, 25);
  }
  function littleSigma(x) {
    return rotr(x, 7) ^ rotr(x, 18) ^ x >>> 3;
  }
  function littleSigmaPrime(x) {
    return rotr(x, 17) ^ rotr(x, 19) ^ x >>> 10;
  }
  var k = [0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5, 0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3, 0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174, 0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc, 0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da, 0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967, 0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13, 0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85, 0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3, 0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070, 0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3, 0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208, 0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2];
  function hash(data, offset, length) {
    var h0 = 0x6a09e667,
        h1 = 0xbb67ae85,
        h2 = 0x3c6ef372,
        h3 = 0xa54ff53a,
        h4 = 0x510e527f,
        h5 = 0x9b05688c,
        h6 = 0x1f83d9ab,
        h7 = 0x5be0cd19;
    var paddedLength = Math.ceil((length + 9) / 64) * 64;
    var padded = new Uint8Array(paddedLength);
    var i, j, n;
    for (i = 0; i < length; ++i) {
      padded[i] = data[offset++];
    }
    padded[i++] = 0x80;
    n = paddedLength - 8;
    while (i < n) {
      padded[i++] = 0;
    }
    padded[i++] = 0;
    padded[i++] = 0;
    padded[i++] = 0;
    padded[i++] = length >>> 29 & 0xFF;
    padded[i++] = length >> 21 & 0xFF;
    padded[i++] = length >> 13 & 0xFF;
    padded[i++] = length >> 5 & 0xFF;
    padded[i++] = length << 3 & 0xFF;
    var w = new Uint32Array(64);
    for (i = 0; i < paddedLength;) {
      for (j = 0; j < 16; ++j) {
        w[j] = padded[i] << 24 | padded[i + 1] << 16 | padded[i + 2] << 8 | padded[i + 3];
        i += 4;
      }
      for (j = 16; j < 64; ++j) {
        w[j] = littleSigmaPrime(w[j - 2]) + w[j - 7] + littleSigma(w[j - 15]) + w[j - 16] | 0;
      }
      var a = h0,
          b = h1,
          c = h2,
          d = h3,
          e = h4,
          f = h5,
          g = h6,
          h = h7,
          t1,
          t2;
      for (j = 0; j < 64; ++j) {
        t1 = h + sigmaPrime(e) + ch(e, f, g) + k[j] + w[j];
        t2 = sigma(a) + maj(a, b, c);
        h = g;
        g = f;
        f = e;
        e = d + t1 | 0;
        d = c;
        c = b;
        b = a;
        a = t1 + t2 | 0;
      }
      h0 = h0 + a | 0;
      h1 = h1 + b | 0;
      h2 = h2 + c | 0;
      h3 = h3 + d | 0;
      h4 = h4 + e | 0;
      h5 = h5 + f | 0;
      h6 = h6 + g | 0;
      h7 = h7 + h | 0;
    }
    return new Uint8Array([h0 >> 24 & 0xFF, h0 >> 16 & 0xFF, h0 >> 8 & 0xFF, h0 & 0xFF, h1 >> 24 & 0xFF, h1 >> 16 & 0xFF, h1 >> 8 & 0xFF, h1 & 0xFF, h2 >> 24 & 0xFF, h2 >> 16 & 0xFF, h2 >> 8 & 0xFF, h2 & 0xFF, h3 >> 24 & 0xFF, h3 >> 16 & 0xFF, h3 >> 8 & 0xFF, h3 & 0xFF, h4 >> 24 & 0xFF, h4 >> 16 & 0xFF, h4 >> 8 & 0xFF, h4 & 0xFF, h5 >> 24 & 0xFF, h5 >> 16 & 0xFF, h5 >> 8 & 0xFF, h5 & 0xFF, h6 >> 24 & 0xFF, h6 >> 16 & 0xFF, h6 >> 8 & 0xFF, h6 & 0xFF, h7 >> 24 & 0xFF, h7 >> 16 & 0xFF, h7 >> 8 & 0xFF, h7 & 0xFF]);
  }
  return hash;
}();
var calculateSHA512 = function calculateSHA512Closure() {
  function ch(result, x, y, z, tmp) {
    result.assign(x);
    result.and(y);
    tmp.assign(x);
    tmp.not();
    tmp.and(z);
    result.xor(tmp);
  }
  function maj(result, x, y, z, tmp) {
    result.assign(x);
    result.and(y);
    tmp.assign(x);
    tmp.and(z);
    result.xor(tmp);
    tmp.assign(y);
    tmp.and(z);
    result.xor(tmp);
  }
  function sigma(result, x, tmp) {
    result.assign(x);
    result.rotateRight(28);
    tmp.assign(x);
    tmp.rotateRight(34);
    result.xor(tmp);
    tmp.assign(x);
    tmp.rotateRight(39);
    result.xor(tmp);
  }
  function sigmaPrime(result, x, tmp) {
    result.assign(x);
    result.rotateRight(14);
    tmp.assign(x);
    tmp.rotateRight(18);
    result.xor(tmp);
    tmp.assign(x);
    tmp.rotateRight(41);
    result.xor(tmp);
  }
  function littleSigma(result, x, tmp) {
    result.assign(x);
    result.rotateRight(1);
    tmp.assign(x);
    tmp.rotateRight(8);
    result.xor(tmp);
    tmp.assign(x);
    tmp.shiftRight(7);
    result.xor(tmp);
  }
  function littleSigmaPrime(result, x, tmp) {
    result.assign(x);
    result.rotateRight(19);
    tmp.assign(x);
    tmp.rotateRight(61);
    result.xor(tmp);
    tmp.assign(x);
    tmp.shiftRight(6);
    result.xor(tmp);
  }
  var k = [new Word64(0x428a2f98, 0xd728ae22), new Word64(0x71374491, 0x23ef65cd), new Word64(0xb5c0fbcf, 0xec4d3b2f), new Word64(0xe9b5dba5, 0x8189dbbc), new Word64(0x3956c25b, 0xf348b538), new Word64(0x59f111f1, 0xb605d019), new Word64(0x923f82a4, 0xaf194f9b), new Word64(0xab1c5ed5, 0xda6d8118), new Word64(0xd807aa98, 0xa3030242), new Word64(0x12835b01, 0x45706fbe), new Word64(0x243185be, 0x4ee4b28c), new Word64(0x550c7dc3, 0xd5ffb4e2), new Word64(0x72be5d74, 0xf27b896f), new Word64(0x80deb1fe, 0x3b1696b1), new Word64(0x9bdc06a7, 0x25c71235), new Word64(0xc19bf174, 0xcf692694), new Word64(0xe49b69c1, 0x9ef14ad2), new Word64(0xefbe4786, 0x384f25e3), new Word64(0x0fc19dc6, 0x8b8cd5b5), new Word64(0x240ca1cc, 0x77ac9c65), new Word64(0x2de92c6f, 0x592b0275), new Word64(0x4a7484aa, 0x6ea6e483), new Word64(0x5cb0a9dc, 0xbd41fbd4), new Word64(0x76f988da, 0x831153b5), new Word64(0x983e5152, 0xee66dfab), new Word64(0xa831c66d, 0x2db43210), new Word64(0xb00327c8, 0x98fb213f), new Word64(0xbf597fc7, 0xbeef0ee4), new Word64(0xc6e00bf3, 0x3da88fc2), new Word64(0xd5a79147, 0x930aa725), new Word64(0x06ca6351, 0xe003826f), new Word64(0x14292967, 0x0a0e6e70), new Word64(0x27b70a85, 0x46d22ffc), new Word64(0x2e1b2138, 0x5c26c926), new Word64(0x4d2c6dfc, 0x5ac42aed), new Word64(0x53380d13, 0x9d95b3df), new Word64(0x650a7354, 0x8baf63de), new Word64(0x766a0abb, 0x3c77b2a8), new Word64(0x81c2c92e, 0x47edaee6), new Word64(0x92722c85, 0x1482353b), new Word64(0xa2bfe8a1, 0x4cf10364), new Word64(0xa81a664b, 0xbc423001), new Word64(0xc24b8b70, 0xd0f89791), new Word64(0xc76c51a3, 0x0654be30), new Word64(0xd192e819, 0xd6ef5218), new Word64(0xd6990624, 0x5565a910), new Word64(0xf40e3585, 0x5771202a), new Word64(0x106aa070, 0x32bbd1b8), new Word64(0x19a4c116, 0xb8d2d0c8), new Word64(0x1e376c08, 0x5141ab53), new Word64(0x2748774c, 0xdf8eeb99), new Word64(0x34b0bcb5, 0xe19b48a8), new Word64(0x391c0cb3, 0xc5c95a63), new Word64(0x4ed8aa4a, 0xe3418acb), new Word64(0x5b9cca4f, 0x7763e373), new Word64(0x682e6ff3, 0xd6b2b8a3), new Word64(0x748f82ee, 0x5defb2fc), new Word64(0x78a5636f, 0x43172f60), new Word64(0x84c87814, 0xa1f0ab72), new Word64(0x8cc70208, 0x1a6439ec), new Word64(0x90befffa, 0x23631e28), new Word64(0xa4506ceb, 0xde82bde9), new Word64(0xbef9a3f7, 0xb2c67915), new Word64(0xc67178f2, 0xe372532b), new Word64(0xca273ece, 0xea26619c), new Word64(0xd186b8c7, 0x21c0c207), new Word64(0xeada7dd6, 0xcde0eb1e), new Word64(0xf57d4f7f, 0xee6ed178), new Word64(0x06f067aa, 0x72176fba), new Word64(0x0a637dc5, 0xa2c898a6), new Word64(0x113f9804, 0xbef90dae), new Word64(0x1b710b35, 0x131c471b), new Word64(0x28db77f5, 0x23047d84), new Word64(0x32caab7b, 0x40c72493), new Word64(0x3c9ebe0a, 0x15c9bebc), new Word64(0x431d67c4, 0x9c100d4c), new Word64(0x4cc5d4be, 0xcb3e42b6), new Word64(0x597f299c, 0xfc657e2a), new Word64(0x5fcb6fab, 0x3ad6faec), new Word64(0x6c44198c, 0x4a475817)];
  function hash(data, offset, length, mode384) {
    mode384 = !!mode384;
    var h0, h1, h2, h3, h4, h5, h6, h7;
    if (!mode384) {
      h0 = new Word64(0x6a09e667, 0xf3bcc908);
      h1 = new Word64(0xbb67ae85, 0x84caa73b);
      h2 = new Word64(0x3c6ef372, 0xfe94f82b);
      h3 = new Word64(0xa54ff53a, 0x5f1d36f1);
      h4 = new Word64(0x510e527f, 0xade682d1);
      h5 = new Word64(0x9b05688c, 0x2b3e6c1f);
      h6 = new Word64(0x1f83d9ab, 0xfb41bd6b);
      h7 = new Word64(0x5be0cd19, 0x137e2179);
    } else {
      h0 = new Word64(0xcbbb9d5d, 0xc1059ed8);
      h1 = new Word64(0x629a292a, 0x367cd507);
      h2 = new Word64(0x9159015a, 0x3070dd17);
      h3 = new Word64(0x152fecd8, 0xf70e5939);
      h4 = new Word64(0x67332667, 0xffc00b31);
      h5 = new Word64(0x8eb44a87, 0x68581511);
      h6 = new Word64(0xdb0c2e0d, 0x64f98fa7);
      h7 = new Word64(0x47b5481d, 0xbefa4fa4);
    }
    var paddedLength = Math.ceil((length + 17) / 128) * 128;
    var padded = new Uint8Array(paddedLength);
    var i, j, n;
    for (i = 0; i < length; ++i) {
      padded[i] = data[offset++];
    }
    padded[i++] = 0x80;
    n = paddedLength - 16;
    while (i < n) {
      padded[i++] = 0;
    }
    padded[i++] = 0;
    padded[i++] = 0;
    padded[i++] = 0;
    padded[i++] = 0;
    padded[i++] = 0;
    padded[i++] = 0;
    padded[i++] = 0;
    padded[i++] = 0;
    padded[i++] = 0;
    padded[i++] = 0;
    padded[i++] = 0;
    padded[i++] = length >>> 29 & 0xFF;
    padded[i++] = length >> 21 & 0xFF;
    padded[i++] = length >> 13 & 0xFF;
    padded[i++] = length >> 5 & 0xFF;
    padded[i++] = length << 3 & 0xFF;
    var w = new Array(80);
    for (i = 0; i < 80; i++) {
      w[i] = new Word64(0, 0);
    }
    var a = new Word64(0, 0),
        b = new Word64(0, 0),
        c = new Word64(0, 0);
    var d = new Word64(0, 0),
        e = new Word64(0, 0),
        f = new Word64(0, 0);
    var g = new Word64(0, 0),
        h = new Word64(0, 0);
    var t1 = new Word64(0, 0),
        t2 = new Word64(0, 0);
    var tmp1 = new Word64(0, 0),
        tmp2 = new Word64(0, 0),
        tmp3;
    for (i = 0; i < paddedLength;) {
      for (j = 0; j < 16; ++j) {
        w[j].high = padded[i] << 24 | padded[i + 1] << 16 | padded[i + 2] << 8 | padded[i + 3];
        w[j].low = padded[i + 4] << 24 | padded[i + 5] << 16 | padded[i + 6] << 8 | padded[i + 7];
        i += 8;
      }
      for (j = 16; j < 80; ++j) {
        tmp3 = w[j];
        littleSigmaPrime(tmp3, w[j - 2], tmp2);
        tmp3.add(w[j - 7]);
        littleSigma(tmp1, w[j - 15], tmp2);
        tmp3.add(tmp1);
        tmp3.add(w[j - 16]);
      }
      a.assign(h0);
      b.assign(h1);
      c.assign(h2);
      d.assign(h3);
      e.assign(h4);
      f.assign(h5);
      g.assign(h6);
      h.assign(h7);
      for (j = 0; j < 80; ++j) {
        t1.assign(h);
        sigmaPrime(tmp1, e, tmp2);
        t1.add(tmp1);
        ch(tmp1, e, f, g, tmp2);
        t1.add(tmp1);
        t1.add(k[j]);
        t1.add(w[j]);
        sigma(t2, a, tmp2);
        maj(tmp1, a, b, c, tmp2);
        t2.add(tmp1);
        tmp3 = h;
        h = g;
        g = f;
        f = e;
        d.add(t1);
        e = d;
        d = c;
        c = b;
        b = a;
        tmp3.assign(t1);
        tmp3.add(t2);
        a = tmp3;
      }
      h0.add(a);
      h1.add(b);
      h2.add(c);
      h3.add(d);
      h4.add(e);
      h5.add(f);
      h6.add(g);
      h7.add(h);
    }
    var result;
    if (!mode384) {
      result = new Uint8Array(64);
      h0.copyTo(result, 0);
      h1.copyTo(result, 8);
      h2.copyTo(result, 16);
      h3.copyTo(result, 24);
      h4.copyTo(result, 32);
      h5.copyTo(result, 40);
      h6.copyTo(result, 48);
      h7.copyTo(result, 56);
    } else {
      result = new Uint8Array(48);
      h0.copyTo(result, 0);
      h1.copyTo(result, 8);
      h2.copyTo(result, 16);
      h3.copyTo(result, 24);
      h4.copyTo(result, 32);
      h5.copyTo(result, 40);
    }
    return result;
  }
  return hash;
}();
var calculateSHA384 = function calculateSHA384Closure() {
  function hash(data, offset, length) {
    return calculateSHA512(data, offset, length, true);
  }
  return hash;
}();
var NullCipher = function NullCipherClosure() {
  function NullCipher() {}
  NullCipher.prototype = {
    decryptBlock: function NullCipher_decryptBlock(data) {
      return data;
    }
  };
  return NullCipher;
}();
var AES128Cipher = function AES128CipherClosure() {
  var rcon = new Uint8Array([0x8d, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36, 0x6c, 0xd8, 0xab, 0x4d, 0x9a, 0x2f, 0x5e, 0xbc, 0x63, 0xc6, 0x97, 0x35, 0x6a, 0xd4, 0xb3, 0x7d, 0xfa, 0xef, 0xc5, 0x91, 0x39, 0x72, 0xe4, 0xd3, 0xbd, 0x61, 0xc2, 0x9f, 0x25, 0x4a, 0x94, 0x33, 0x66, 0xcc, 0x83, 0x1d, 0x3a, 0x74, 0xe8, 0xcb, 0x8d, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36, 0x6c, 0xd8, 0xab, 0x4d, 0x9a, 0x2f, 0x5e, 0xbc, 0x63, 0xc6, 0x97, 0x35, 0x6a, 0xd4, 0xb3, 0x7d, 0xfa, 0xef, 0xc5, 0x91, 0x39, 0x72, 0xe4, 0xd3, 0xbd, 0x61, 0xc2, 0x9f, 0x25, 0x4a, 0x94, 0x33, 0x66, 0xcc, 0x83, 0x1d, 0x3a, 0x74, 0xe8, 0xcb, 0x8d, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36, 0x6c, 0xd8, 0xab, 0x4d, 0x9a, 0x2f, 0x5e, 0xbc, 0x63, 0xc6, 0x97, 0x35, 0x6a, 0xd4, 0xb3, 0x7d, 0xfa, 0xef, 0xc5, 0x91, 0x39, 0x72, 0xe4, 0xd3, 0xbd, 0x61, 0xc2, 0x9f, 0x25, 0x4a, 0x94, 0x33, 0x66, 0xcc, 0x83, 0x1d, 0x3a, 0x74, 0xe8, 0xcb, 0x8d, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36, 0x6c, 0xd8, 0xab, 0x4d, 0x9a, 0x2f, 0x5e, 0xbc, 0x63, 0xc6, 0x97, 0x35, 0x6a, 0xd4, 0xb3, 0x7d, 0xfa, 0xef, 0xc5, 0x91, 0x39, 0x72, 0xe4, 0xd3, 0xbd, 0x61, 0xc2, 0x9f, 0x25, 0x4a, 0x94, 0x33, 0x66, 0xcc, 0x83, 0x1d, 0x3a, 0x74, 0xe8, 0xcb, 0x8d, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36, 0x6c, 0xd8, 0xab, 0x4d, 0x9a, 0x2f, 0x5e, 0xbc, 0x63, 0xc6, 0x97, 0x35, 0x6a, 0xd4, 0xb3, 0x7d, 0xfa, 0xef, 0xc5, 0x91, 0x39, 0x72, 0xe4, 0xd3, 0xbd, 0x61, 0xc2, 0x9f, 0x25, 0x4a, 0x94, 0x33, 0x66, 0xcc, 0x83, 0x1d, 0x3a, 0x74, 0xe8, 0xcb, 0x8d]);
  var s = new Uint8Array([0x63, 0x7c, 0x77, 0x7b, 0xf2, 0x6b, 0x6f, 0xc5, 0x30, 0x01, 0x67, 0x2b, 0xfe, 0xd7, 0xab, 0x76, 0xca, 0x82, 0xc9, 0x7d, 0xfa, 0x59, 0x47, 0xf0, 0xad, 0xd4, 0xa2, 0xaf, 0x9c, 0xa4, 0x72, 0xc0, 0xb7, 0xfd, 0x93, 0x26, 0x36, 0x3f, 0xf7, 0xcc, 0x34, 0xa5, 0xe5, 0xf1, 0x71, 0xd8, 0x31, 0x15, 0x04, 0xc7, 0x23, 0xc3, 0x18, 0x96, 0x05, 0x9a, 0x07, 0x12, 0x80, 0xe2, 0xeb, 0x27, 0xb2, 0x75, 0x09, 0x83, 0x2c, 0x1a, 0x1b, 0x6e, 0x5a, 0xa0, 0x52, 0x3b, 0xd6, 0xb3, 0x29, 0xe3, 0x2f, 0x84, 0x53, 0xd1, 0x00, 0xed, 0x20, 0xfc, 0xb1, 0x5b, 0x6a, 0xcb, 0xbe, 0x39, 0x4a, 0x4c, 0x58, 0xcf, 0xd0, 0xef, 0xaa, 0xfb, 0x43, 0x4d, 0x33, 0x85, 0x45, 0xf9, 0x02, 0x7f, 0x50, 0x3c, 0x9f, 0xa8, 0x51, 0xa3, 0x40, 0x8f, 0x92, 0x9d, 0x38, 0xf5, 0xbc, 0xb6, 0xda, 0x21, 0x10, 0xff, 0xf3, 0xd2, 0xcd, 0x0c, 0x13, 0xec, 0x5f, 0x97, 0x44, 0x17, 0xc4, 0xa7, 0x7e, 0x3d, 0x64, 0x5d, 0x19, 0x73, 0x60, 0x81, 0x4f, 0xdc, 0x22, 0x2a, 0x90, 0x88, 0x46, 0xee, 0xb8, 0x14, 0xde, 0x5e, 0x0b, 0xdb, 0xe0, 0x32, 0x3a, 0x0a, 0x49, 0x06, 0x24, 0x5c, 0xc2, 0xd3, 0xac, 0x62, 0x91, 0x95, 0xe4, 0x79, 0xe7, 0xc8, 0x37, 0x6d, 0x8d, 0xd5, 0x4e, 0xa9, 0x6c, 0x56, 0xf4, 0xea, 0x65, 0x7a, 0xae, 0x08, 0xba, 0x78, 0x25, 0x2e, 0x1c, 0xa6, 0xb4, 0xc6, 0xe8, 0xdd, 0x74, 0x1f, 0x4b, 0xbd, 0x8b, 0x8a, 0x70, 0x3e, 0xb5, 0x66, 0x48, 0x03, 0xf6, 0x0e, 0x61, 0x35, 0x57, 0xb9, 0x86, 0xc1, 0x1d, 0x9e, 0xe1, 0xf8, 0x98, 0x11, 0x69, 0xd9, 0x8e, 0x94, 0x9b, 0x1e, 0x87, 0xe9, 0xce, 0x55, 0x28, 0xdf, 0x8c, 0xa1, 0x89, 0x0d, 0xbf, 0xe6, 0x42, 0x68, 0x41, 0x99, 0x2d, 0x0f, 0xb0, 0x54, 0xbb, 0x16]);
  var inv_s = new Uint8Array([0x52, 0x09, 0x6a, 0xd5, 0x30, 0x36, 0xa5, 0x38, 0xbf, 0x40, 0xa3, 0x9e, 0x81, 0xf3, 0xd7, 0xfb, 0x7c, 0xe3, 0x39, 0x82, 0x9b, 0x2f, 0xff, 0x87, 0x34, 0x8e, 0x43, 0x44, 0xc4, 0xde, 0xe9, 0xcb, 0x54, 0x7b, 0x94, 0x32, 0xa6, 0xc2, 0x23, 0x3d, 0xee, 0x4c, 0x95, 0x0b, 0x42, 0xfa, 0xc3, 0x4e, 0x08, 0x2e, 0xa1, 0x66, 0x28, 0xd9, 0x24, 0xb2, 0x76, 0x5b, 0xa2, 0x49, 0x6d, 0x8b, 0xd1, 0x25, 0x72, 0xf8, 0xf6, 0x64, 0x86, 0x68, 0x98, 0x16, 0xd4, 0xa4, 0x5c, 0xcc, 0x5d, 0x65, 0xb6, 0x92, 0x6c, 0x70, 0x48, 0x50, 0xfd, 0xed, 0xb9, 0xda, 0x5e, 0x15, 0x46, 0x57, 0xa7, 0x8d, 0x9d, 0x84, 0x90, 0xd8, 0xab, 0x00, 0x8c, 0xbc, 0xd3, 0x0a, 0xf7, 0xe4, 0x58, 0x05, 0xb8, 0xb3, 0x45, 0x06, 0xd0, 0x2c, 0x1e, 0x8f, 0xca, 0x3f, 0x0f, 0x02, 0xc1, 0xaf, 0xbd, 0x03, 0x01, 0x13, 0x8a, 0x6b, 0x3a, 0x91, 0x11, 0x41, 0x4f, 0x67, 0xdc, 0xea, 0x97, 0xf2, 0xcf, 0xce, 0xf0, 0xb4, 0xe6, 0x73, 0x96, 0xac, 0x74, 0x22, 0xe7, 0xad, 0x35, 0x85, 0xe2, 0xf9, 0x37, 0xe8, 0x1c, 0x75, 0xdf, 0x6e, 0x47, 0xf1, 0x1a, 0x71, 0x1d, 0x29, 0xc5, 0x89, 0x6f, 0xb7, 0x62, 0x0e, 0xaa, 0x18, 0xbe, 0x1b, 0xfc, 0x56, 0x3e, 0x4b, 0xc6, 0xd2, 0x79, 0x20, 0x9a, 0xdb, 0xc0, 0xfe, 0x78, 0xcd, 0x5a, 0xf4, 0x1f, 0xdd, 0xa8, 0x33, 0x88, 0x07, 0xc7, 0x31, 0xb1, 0x12, 0x10, 0x59, 0x27, 0x80, 0xec, 0x5f, 0x60, 0x51, 0x7f, 0xa9, 0x19, 0xb5, 0x4a, 0x0d, 0x2d, 0xe5, 0x7a, 0x9f, 0x93, 0xc9, 0x9c, 0xef, 0xa0, 0xe0, 0x3b, 0x4d, 0xae, 0x2a, 0xf5, 0xb0, 0xc8, 0xeb, 0xbb, 0x3c, 0x83, 0x53, 0x99, 0x61, 0x17, 0x2b, 0x04, 0x7e, 0xba, 0x77, 0xd6, 0x26, 0xe1, 0x69, 0x14, 0x63, 0x55, 0x21, 0x0c, 0x7d]);
  var mixCol = new Uint8Array(256);
  for (var i = 0; i < 256; i++) {
    if (i < 128) {
      mixCol[i] = i << 1;
    } else {
      mixCol[i] = i << 1 ^ 0x1b;
    }
  }
  var mix = new Uint32Array([0x00000000, 0x0e090d0b, 0x1c121a16, 0x121b171d, 0x3824342c, 0x362d3927, 0x24362e3a, 0x2a3f2331, 0x70486858, 0x7e416553, 0x6c5a724e, 0x62537f45, 0x486c5c74, 0x4665517f, 0x547e4662, 0x5a774b69, 0xe090d0b0, 0xee99ddbb, 0xfc82caa6, 0xf28bc7ad, 0xd8b4e49c, 0xd6bde997, 0xc4a6fe8a, 0xcaaff381, 0x90d8b8e8, 0x9ed1b5e3, 0x8ccaa2fe, 0x82c3aff5, 0xa8fc8cc4, 0xa6f581cf, 0xb4ee96d2, 0xbae79bd9, 0xdb3bbb7b, 0xd532b670, 0xc729a16d, 0xc920ac66, 0xe31f8f57, 0xed16825c, 0xff0d9541, 0xf104984a, 0xab73d323, 0xa57ade28, 0xb761c935, 0xb968c43e, 0x9357e70f, 0x9d5eea04, 0x8f45fd19, 0x814cf012, 0x3bab6bcb, 0x35a266c0, 0x27b971dd, 0x29b07cd6, 0x038f5fe7, 0x0d8652ec, 0x1f9d45f1, 0x119448fa, 0x4be30393, 0x45ea0e98, 0x57f11985, 0x59f8148e, 0x73c737bf, 0x7dce3ab4, 0x6fd52da9, 0x61dc20a2, 0xad766df6, 0xa37f60fd, 0xb16477e0, 0xbf6d7aeb, 0x955259da, 0x9b5b54d1, 0x894043cc, 0x87494ec7, 0xdd3e05ae, 0xd33708a5, 0xc12c1fb8, 0xcf2512b3, 0xe51a3182, 0xeb133c89, 0xf9082b94, 0xf701269f, 0x4de6bd46, 0x43efb04d, 0x51f4a750, 0x5ffdaa5b, 0x75c2896a, 0x7bcb8461, 0x69d0937c, 0x67d99e77, 0x3daed51e, 0x33a7d815, 0x21bccf08, 0x2fb5c203, 0x058ae132, 0x0b83ec39, 0x1998fb24, 0x1791f62f, 0x764dd68d, 0x7844db86, 0x6a5fcc9b, 0x6456c190, 0x4e69e2a1, 0x4060efaa, 0x527bf8b7, 0x5c72f5bc, 0x0605bed5, 0x080cb3de, 0x1a17a4c3, 0x141ea9c8, 0x3e218af9, 0x302887f2, 0x223390ef, 0x2c3a9de4, 0x96dd063d, 0x98d40b36, 0x8acf1c2b, 0x84c61120, 0xaef93211, 0xa0f03f1a, 0xb2eb2807, 0xbce2250c, 0xe6956e65, 0xe89c636e, 0xfa877473, 0xf48e7978, 0xdeb15a49, 0xd0b85742, 0xc2a3405f, 0xccaa4d54, 0x41ecdaf7, 0x4fe5d7fc, 0x5dfec0e1, 0x53f7cdea, 0x79c8eedb, 0x77c1e3d0, 0x65daf4cd, 0x6bd3f9c6, 0x31a4b2af, 0x3fadbfa4, 0x2db6a8b9, 0x23bfa5b2, 0x09808683, 0x07898b88, 0x15929c95, 0x1b9b919e, 0xa17c0a47, 0xaf75074c, 0xbd6e1051, 0xb3671d5a, 0x99583e6b, 0x97513360, 0x854a247d, 0x8b432976, 0xd134621f, 0xdf3d6f14, 0xcd267809, 0xc32f7502, 0xe9105633, 0xe7195b38, 0xf5024c25, 0xfb0b412e, 0x9ad7618c, 0x94de6c87, 0x86c57b9a, 0x88cc7691, 0xa2f355a0, 0xacfa58ab, 0xbee14fb6, 0xb0e842bd, 0xea9f09d4, 0xe49604df, 0xf68d13c2, 0xf8841ec9, 0xd2bb3df8, 0xdcb230f3, 0xcea927ee, 0xc0a02ae5, 0x7a47b13c, 0x744ebc37, 0x6655ab2a, 0x685ca621, 0x42638510, 0x4c6a881b, 0x5e719f06, 0x5078920d, 0x0a0fd964, 0x0406d46f, 0x161dc372, 0x1814ce79, 0x322bed48, 0x3c22e043, 0x2e39f75e, 0x2030fa55, 0xec9ab701, 0xe293ba0a, 0xf088ad17, 0xfe81a01c, 0xd4be832d, 0xdab78e26, 0xc8ac993b, 0xc6a59430, 0x9cd2df59, 0x92dbd252, 0x80c0c54f, 0x8ec9c844, 0xa4f6eb75, 0xaaffe67e, 0xb8e4f163, 0xb6edfc68, 0x0c0a67b1, 0x02036aba, 0x10187da7, 0x1e1170ac, 0x342e539d, 0x3a275e96, 0x283c498b, 0x26354480, 0x7c420fe9, 0x724b02e2, 0x605015ff, 0x6e5918f4, 0x44663bc5, 0x4a6f36ce, 0x587421d3, 0x567d2cd8, 0x37a10c7a, 0x39a80171, 0x2bb3166c, 0x25ba1b67, 0x0f853856, 0x018c355d, 0x13972240, 0x1d9e2f4b, 0x47e96422, 0x49e06929, 0x5bfb7e34, 0x55f2733f, 0x7fcd500e, 0x71c45d05, 0x63df4a18, 0x6dd64713, 0xd731dcca, 0xd938d1c1, 0xcb23c6dc, 0xc52acbd7, 0xef15e8e6, 0xe11ce5ed, 0xf307f2f0, 0xfd0efffb, 0xa779b492, 0xa970b999, 0xbb6bae84, 0xb562a38f, 0x9f5d80be, 0x91548db5, 0x834f9aa8, 0x8d4697a3]);
  function expandKey128(cipherKey) {
    var b = 176,
        result = new Uint8Array(b);
    result.set(cipherKey);
    for (var j = 16, i = 1; j < b; ++i) {
      var t1 = result[j - 3],
          t2 = result[j - 2],
          t3 = result[j - 1],
          t4 = result[j - 4];
      t1 = s[t1];
      t2 = s[t2];
      t3 = s[t3];
      t4 = s[t4];
      t1 = t1 ^ rcon[i];
      for (var n = 0; n < 4; ++n) {
        result[j] = t1 ^= result[j - 16];
        j++;
        result[j] = t2 ^= result[j - 16];
        j++;
        result[j] = t3 ^= result[j - 16];
        j++;
        result[j] = t4 ^= result[j - 16];
        j++;
      }
    }
    return result;
  }
  function decrypt128(input, key) {
    var state = new Uint8Array(16);
    state.set(input);
    var i, j, k;
    var t, u, v;
    for (j = 0, k = 160; j < 16; ++j, ++k) {
      state[j] ^= key[k];
    }
    for (i = 9; i >= 1; --i) {
      t = state[13];
      state[13] = state[9];
      state[9] = state[5];
      state[5] = state[1];
      state[1] = t;
      t = state[14];
      u = state[10];
      state[14] = state[6];
      state[10] = state[2];
      state[6] = t;
      state[2] = u;
      t = state[15];
      u = state[11];
      v = state[7];
      state[15] = state[3];
      state[11] = t;
      state[7] = u;
      state[3] = v;
      for (j = 0; j < 16; ++j) {
        state[j] = inv_s[state[j]];
      }
      for (j = 0, k = i * 16; j < 16; ++j, ++k) {
        state[j] ^= key[k];
      }
      for (j = 0; j < 16; j += 4) {
        var s0 = mix[state[j]],
            s1 = mix[state[j + 1]],
            s2 = mix[state[j + 2]],
            s3 = mix[state[j + 3]];
        t = s0 ^ s1 >>> 8 ^ s1 << 24 ^ s2 >>> 16 ^ s2 << 16 ^ s3 >>> 24 ^ s3 << 8;
        state[j] = t >>> 24 & 0xFF;
        state[j + 1] = t >> 16 & 0xFF;
        state[j + 2] = t >> 8 & 0xFF;
        state[j + 3] = t & 0xFF;
      }
    }
    t = state[13];
    state[13] = state[9];
    state[9] = state[5];
    state[5] = state[1];
    state[1] = t;
    t = state[14];
    u = state[10];
    state[14] = state[6];
    state[10] = state[2];
    state[6] = t;
    state[2] = u;
    t = state[15];
    u = state[11];
    v = state[7];
    state[15] = state[3];
    state[11] = t;
    state[7] = u;
    state[3] = v;
    for (j = 0; j < 16; ++j) {
      state[j] = inv_s[state[j]];
      state[j] ^= key[j];
    }
    return state;
  }
  function encrypt128(input, key) {
    var t, u, v, k;
    var state = new Uint8Array(16);
    state.set(input);
    for (j = 0; j < 16; ++j) {
      state[j] ^= key[j];
    }
    for (i = 1; i < 10; i++) {
      for (j = 0; j < 16; ++j) {
        state[j] = s[state[j]];
      }
      v = state[1];
      state[1] = state[5];
      state[5] = state[9];
      state[9] = state[13];
      state[13] = v;
      v = state[2];
      u = state[6];
      state[2] = state[10];
      state[6] = state[14];
      state[10] = v;
      state[14] = u;
      v = state[3];
      u = state[7];
      t = state[11];
      state[3] = state[15];
      state[7] = v;
      state[11] = u;
      state[15] = t;
      for (var j = 0; j < 16; j += 4) {
        var s0 = state[j + 0],
            s1 = state[j + 1];
        var s2 = state[j + 2],
            s3 = state[j + 3];
        t = s0 ^ s1 ^ s2 ^ s3;
        state[j + 0] ^= t ^ mixCol[s0 ^ s1];
        state[j + 1] ^= t ^ mixCol[s1 ^ s2];
        state[j + 2] ^= t ^ mixCol[s2 ^ s3];
        state[j + 3] ^= t ^ mixCol[s3 ^ s0];
      }
      for (j = 0, k = i * 16; j < 16; ++j, ++k) {
        state[j] ^= key[k];
      }
    }
    for (j = 0; j < 16; ++j) {
      state[j] = s[state[j]];
    }
    v = state[1];
    state[1] = state[5];
    state[5] = state[9];
    state[9] = state[13];
    state[13] = v;
    v = state[2];
    u = state[6];
    state[2] = state[10];
    state[6] = state[14];
    state[10] = v;
    state[14] = u;
    v = state[3];
    u = state[7];
    t = state[11];
    state[3] = state[15];
    state[7] = v;
    state[11] = u;
    state[15] = t;
    for (j = 0, k = 160; j < 16; ++j, ++k) {
      state[j] ^= key[k];
    }
    return state;
  }
  function AES128Cipher(key) {
    this.key = expandKey128(key);
    this.buffer = new Uint8Array(16);
    this.bufferPosition = 0;
  }
  function decryptBlock2(data, finalize) {
    var i,
        j,
        ii,
        sourceLength = data.length,
        buffer = this.buffer,
        bufferLength = this.bufferPosition,
        result = [],
        iv = this.iv;
    for (i = 0; i < sourceLength; ++i) {
      buffer[bufferLength] = data[i];
      ++bufferLength;
      if (bufferLength < 16) {
        continue;
      }
      var plain = decrypt128(buffer, this.key);
      for (j = 0; j < 16; ++j) {
        plain[j] ^= iv[j];
      }
      iv = buffer;
      result.push(plain);
      buffer = new Uint8Array(16);
      bufferLength = 0;
    }
    this.buffer = buffer;
    this.bufferLength = bufferLength;
    this.iv = iv;
    if (result.length === 0) {
      return new Uint8Array([]);
    }
    var outputLength = 16 * result.length;
    if (finalize) {
      var lastBlock = result[result.length - 1];
      var psLen = lastBlock[15];
      if (psLen <= 16) {
        for (i = 15, ii = 16 - psLen; i >= ii; --i) {
          if (lastBlock[i] !== psLen) {
            psLen = 0;
            break;
          }
        }
        outputLength -= psLen;
        result[result.length - 1] = lastBlock.subarray(0, 16 - psLen);
      }
    }
    var output = new Uint8Array(outputLength);
    for (i = 0, j = 0, ii = result.length; i < ii; ++i, j += 16) {
      output.set(result[i], j);
    }
    return output;
  }
  AES128Cipher.prototype = {
    decryptBlock: function AES128Cipher_decryptBlock(data, finalize) {
      var i,
          sourceLength = data.length;
      var buffer = this.buffer,
          bufferLength = this.bufferPosition;
      for (i = 0; bufferLength < 16 && i < sourceLength; ++i, ++bufferLength) {
        buffer[bufferLength] = data[i];
      }
      if (bufferLength < 16) {
        this.bufferLength = bufferLength;
        return new Uint8Array([]);
      }
      this.iv = buffer;
      this.buffer = new Uint8Array(16);
      this.bufferLength = 0;
      this.decryptBlock = decryptBlock2;
      return this.decryptBlock(data.subarray(16), finalize);
    },
    encrypt: function AES128Cipher_encrypt(data, iv) {
      var i,
          j,
          ii,
          sourceLength = data.length,
          buffer = this.buffer,
          bufferLength = this.bufferPosition,
          result = [];
      if (!iv) {
        iv = new Uint8Array(16);
      }
      for (i = 0; i < sourceLength; ++i) {
        buffer[bufferLength] = data[i];
        ++bufferLength;
        if (bufferLength < 16) {
          continue;
        }
        for (j = 0; j < 16; ++j) {
          buffer[j] ^= iv[j];
        }
        var cipher = encrypt128(buffer, this.key);
        iv = cipher;
        result.push(cipher);
        buffer = new Uint8Array(16);
        bufferLength = 0;
      }
      this.buffer = buffer;
      this.bufferLength = bufferLength;
      this.iv = iv;
      if (result.length === 0) {
        return new Uint8Array([]);
      }
      var outputLength = 16 * result.length;
      var output = new Uint8Array(outputLength);
      for (i = 0, j = 0, ii = result.length; i < ii; ++i, j += 16) {
        output.set(result[i], j);
      }
      return output;
    }
  };
  return AES128Cipher;
}();
var AES256Cipher = function AES256CipherClosure() {
  var s = new Uint8Array([0x63, 0x7c, 0x77, 0x7b, 0xf2, 0x6b, 0x6f, 0xc5, 0x30, 0x01, 0x67, 0x2b, 0xfe, 0xd7, 0xab, 0x76, 0xca, 0x82, 0xc9, 0x7d, 0xfa, 0x59, 0x47, 0xf0, 0xad, 0xd4, 0xa2, 0xaf, 0x9c, 0xa4, 0x72, 0xc0, 0xb7, 0xfd, 0x93, 0x26, 0x36, 0x3f, 0xf7, 0xcc, 0x34, 0xa5, 0xe5, 0xf1, 0x71, 0xd8, 0x31, 0x15, 0x04, 0xc7, 0x23, 0xc3, 0x18, 0x96, 0x05, 0x9a, 0x07, 0x12, 0x80, 0xe2, 0xeb, 0x27, 0xb2, 0x75, 0x09, 0x83, 0x2c, 0x1a, 0x1b, 0x6e, 0x5a, 0xa0, 0x52, 0x3b, 0xd6, 0xb3, 0x29, 0xe3, 0x2f, 0x84, 0x53, 0xd1, 0x00, 0xed, 0x20, 0xfc, 0xb1, 0x5b, 0x6a, 0xcb, 0xbe, 0x39, 0x4a, 0x4c, 0x58, 0xcf, 0xd0, 0xef, 0xaa, 0xfb, 0x43, 0x4d, 0x33, 0x85, 0x45, 0xf9, 0x02, 0x7f, 0x50, 0x3c, 0x9f, 0xa8, 0x51, 0xa3, 0x40, 0x8f, 0x92, 0x9d, 0x38, 0xf5, 0xbc, 0xb6, 0xda, 0x21, 0x10, 0xff, 0xf3, 0xd2, 0xcd, 0x0c, 0x13, 0xec, 0x5f, 0x97, 0x44, 0x17, 0xc4, 0xa7, 0x7e, 0x3d, 0x64, 0x5d, 0x19, 0x73, 0x60, 0x81, 0x4f, 0xdc, 0x22, 0x2a, 0x90, 0x88, 0x46, 0xee, 0xb8, 0x14, 0xde, 0x5e, 0x0b, 0xdb, 0xe0, 0x32, 0x3a, 0x0a, 0x49, 0x06, 0x24, 0x5c, 0xc2, 0xd3, 0xac, 0x62, 0x91, 0x95, 0xe4, 0x79, 0xe7, 0xc8, 0x37, 0x6d, 0x8d, 0xd5, 0x4e, 0xa9, 0x6c, 0x56, 0xf4, 0xea, 0x65, 0x7a, 0xae, 0x08, 0xba, 0x78, 0x25, 0x2e, 0x1c, 0xa6, 0xb4, 0xc6, 0xe8, 0xdd, 0x74, 0x1f, 0x4b, 0xbd, 0x8b, 0x8a, 0x70, 0x3e, 0xb5, 0x66, 0x48, 0x03, 0xf6, 0x0e, 0x61, 0x35, 0x57, 0xb9, 0x86, 0xc1, 0x1d, 0x9e, 0xe1, 0xf8, 0x98, 0x11, 0x69, 0xd9, 0x8e, 0x94, 0x9b, 0x1e, 0x87, 0xe9, 0xce, 0x55, 0x28, 0xdf, 0x8c, 0xa1, 0x89, 0x0d, 0xbf, 0xe6, 0x42, 0x68, 0x41, 0x99, 0x2d, 0x0f, 0xb0, 0x54, 0xbb, 0x16]);
  var inv_s = new Uint8Array([0x52, 0x09, 0x6a, 0xd5, 0x30, 0x36, 0xa5, 0x38, 0xbf, 0x40, 0xa3, 0x9e, 0x81, 0xf3, 0xd7, 0xfb, 0x7c, 0xe3, 0x39, 0x82, 0x9b, 0x2f, 0xff, 0x87, 0x34, 0x8e, 0x43, 0x44, 0xc4, 0xde, 0xe9, 0xcb, 0x54, 0x7b, 0x94, 0x32, 0xa6, 0xc2, 0x23, 0x3d, 0xee, 0x4c, 0x95, 0x0b, 0x42, 0xfa, 0xc3, 0x4e, 0x08, 0x2e, 0xa1, 0x66, 0x28, 0xd9, 0x24, 0xb2, 0x76, 0x5b, 0xa2, 0x49, 0x6d, 0x8b, 0xd1, 0x25, 0x72, 0xf8, 0xf6, 0x64, 0x86, 0x68, 0x98, 0x16, 0xd4, 0xa4, 0x5c, 0xcc, 0x5d, 0x65, 0xb6, 0x92, 0x6c, 0x70, 0x48, 0x50, 0xfd, 0xed, 0xb9, 0xda, 0x5e, 0x15, 0x46, 0x57, 0xa7, 0x8d, 0x9d, 0x84, 0x90, 0xd8, 0xab, 0x00, 0x8c, 0xbc, 0xd3, 0x0a, 0xf7, 0xe4, 0x58, 0x05, 0xb8, 0xb3, 0x45, 0x06, 0xd0, 0x2c, 0x1e, 0x8f, 0xca, 0x3f, 0x0f, 0x02, 0xc1, 0xaf, 0xbd, 0x03, 0x01, 0x13, 0x8a, 0x6b, 0x3a, 0x91, 0x11, 0x41, 0x4f, 0x67, 0xdc, 0xea, 0x97, 0xf2, 0xcf, 0xce, 0xf0, 0xb4, 0xe6, 0x73, 0x96, 0xac, 0x74, 0x22, 0xe7, 0xad, 0x35, 0x85, 0xe2, 0xf9, 0x37, 0xe8, 0x1c, 0x75, 0xdf, 0x6e, 0x47, 0xf1, 0x1a, 0x71, 0x1d, 0x29, 0xc5, 0x89, 0x6f, 0xb7, 0x62, 0x0e, 0xaa, 0x18, 0xbe, 0x1b, 0xfc, 0x56, 0x3e, 0x4b, 0xc6, 0xd2, 0x79, 0x20, 0x9a, 0xdb, 0xc0, 0xfe, 0x78, 0xcd, 0x5a, 0xf4, 0x1f, 0xdd, 0xa8, 0x33, 0x88, 0x07, 0xc7, 0x31, 0xb1, 0x12, 0x10, 0x59, 0x27, 0x80, 0xec, 0x5f, 0x60, 0x51, 0x7f, 0xa9, 0x19, 0xb5, 0x4a, 0x0d, 0x2d, 0xe5, 0x7a, 0x9f, 0x93, 0xc9, 0x9c, 0xef, 0xa0, 0xe0, 0x3b, 0x4d, 0xae, 0x2a, 0xf5, 0xb0, 0xc8, 0xeb, 0xbb, 0x3c, 0x83, 0x53, 0x99, 0x61, 0x17, 0x2b, 0x04, 0x7e, 0xba, 0x77, 0xd6, 0x26, 0xe1, 0x69, 0x14, 0x63, 0x55, 0x21, 0x0c, 0x7d]);
  var mixCol = new Uint8Array(256);
  for (var i = 0; i < 256; i++) {
    if (i < 128) {
      mixCol[i] = i << 1;
    } else {
      mixCol[i] = i << 1 ^ 0x1b;
    }
  }
  var mix = new Uint32Array([0x00000000, 0x0e090d0b, 0x1c121a16, 0x121b171d, 0x3824342c, 0x362d3927, 0x24362e3a, 0x2a3f2331, 0x70486858, 0x7e416553, 0x6c5a724e, 0x62537f45, 0x486c5c74, 0x4665517f, 0x547e4662, 0x5a774b69, 0xe090d0b0, 0xee99ddbb, 0xfc82caa6, 0xf28bc7ad, 0xd8b4e49c, 0xd6bde997, 0xc4a6fe8a, 0xcaaff381, 0x90d8b8e8, 0x9ed1b5e3, 0x8ccaa2fe, 0x82c3aff5, 0xa8fc8cc4, 0xa6f581cf, 0xb4ee96d2, 0xbae79bd9, 0xdb3bbb7b, 0xd532b670, 0xc729a16d, 0xc920ac66, 0xe31f8f57, 0xed16825c, 0xff0d9541, 0xf104984a, 0xab73d323, 0xa57ade28, 0xb761c935, 0xb968c43e, 0x9357e70f, 0x9d5eea04, 0x8f45fd19, 0x814cf012, 0x3bab6bcb, 0x35a266c0, 0x27b971dd, 0x29b07cd6, 0x038f5fe7, 0x0d8652ec, 0x1f9d45f1, 0x119448fa, 0x4be30393, 0x45ea0e98, 0x57f11985, 0x59f8148e, 0x73c737bf, 0x7dce3ab4, 0x6fd52da9, 0x61dc20a2, 0xad766df6, 0xa37f60fd, 0xb16477e0, 0xbf6d7aeb, 0x955259da, 0x9b5b54d1, 0x894043cc, 0x87494ec7, 0xdd3e05ae, 0xd33708a5, 0xc12c1fb8, 0xcf2512b3, 0xe51a3182, 0xeb133c89, 0xf9082b94, 0xf701269f, 0x4de6bd46, 0x43efb04d, 0x51f4a750, 0x5ffdaa5b, 0x75c2896a, 0x7bcb8461, 0x69d0937c, 0x67d99e77, 0x3daed51e, 0x33a7d815, 0x21bccf08, 0x2fb5c203, 0x058ae132, 0x0b83ec39, 0x1998fb24, 0x1791f62f, 0x764dd68d, 0x7844db86, 0x6a5fcc9b, 0x6456c190, 0x4e69e2a1, 0x4060efaa, 0x527bf8b7, 0x5c72f5bc, 0x0605bed5, 0x080cb3de, 0x1a17a4c3, 0x141ea9c8, 0x3e218af9, 0x302887f2, 0x223390ef, 0x2c3a9de4, 0x96dd063d, 0x98d40b36, 0x8acf1c2b, 0x84c61120, 0xaef93211, 0xa0f03f1a, 0xb2eb2807, 0xbce2250c, 0xe6956e65, 0xe89c636e, 0xfa877473, 0xf48e7978, 0xdeb15a49, 0xd0b85742, 0xc2a3405f, 0xccaa4d54, 0x41ecdaf7, 0x4fe5d7fc, 0x5dfec0e1, 0x53f7cdea, 0x79c8eedb, 0x77c1e3d0, 0x65daf4cd, 0x6bd3f9c6, 0x31a4b2af, 0x3fadbfa4, 0x2db6a8b9, 0x23bfa5b2, 0x09808683, 0x07898b88, 0x15929c95, 0x1b9b919e, 0xa17c0a47, 0xaf75074c, 0xbd6e1051, 0xb3671d5a, 0x99583e6b, 0x97513360, 0x854a247d, 0x8b432976, 0xd134621f, 0xdf3d6f14, 0xcd267809, 0xc32f7502, 0xe9105633, 0xe7195b38, 0xf5024c25, 0xfb0b412e, 0x9ad7618c, 0x94de6c87, 0x86c57b9a, 0x88cc7691, 0xa2f355a0, 0xacfa58ab, 0xbee14fb6, 0xb0e842bd, 0xea9f09d4, 0xe49604df, 0xf68d13c2, 0xf8841ec9, 0xd2bb3df8, 0xdcb230f3, 0xcea927ee, 0xc0a02ae5, 0x7a47b13c, 0x744ebc37, 0x6655ab2a, 0x685ca621, 0x42638510, 0x4c6a881b, 0x5e719f06, 0x5078920d, 0x0a0fd964, 0x0406d46f, 0x161dc372, 0x1814ce79, 0x322bed48, 0x3c22e043, 0x2e39f75e, 0x2030fa55, 0xec9ab701, 0xe293ba0a, 0xf088ad17, 0xfe81a01c, 0xd4be832d, 0xdab78e26, 0xc8ac993b, 0xc6a59430, 0x9cd2df59, 0x92dbd252, 0x80c0c54f, 0x8ec9c844, 0xa4f6eb75, 0xaaffe67e, 0xb8e4f163, 0xb6edfc68, 0x0c0a67b1, 0x02036aba, 0x10187da7, 0x1e1170ac, 0x342e539d, 0x3a275e96, 0x283c498b, 0x26354480, 0x7c420fe9, 0x724b02e2, 0x605015ff, 0x6e5918f4, 0x44663bc5, 0x4a6f36ce, 0x587421d3, 0x567d2cd8, 0x37a10c7a, 0x39a80171, 0x2bb3166c, 0x25ba1b67, 0x0f853856, 0x018c355d, 0x13972240, 0x1d9e2f4b, 0x47e96422, 0x49e06929, 0x5bfb7e34, 0x55f2733f, 0x7fcd500e, 0x71c45d05, 0x63df4a18, 0x6dd64713, 0xd731dcca, 0xd938d1c1, 0xcb23c6dc, 0xc52acbd7, 0xef15e8e6, 0xe11ce5ed, 0xf307f2f0, 0xfd0efffb, 0xa779b492, 0xa970b999, 0xbb6bae84, 0xb562a38f, 0x9f5d80be, 0x91548db5, 0x834f9aa8, 0x8d4697a3]);
  function expandKey256(cipherKey) {
    var b = 240,
        result = new Uint8Array(b);
    var r = 1;
    result.set(cipherKey);
    for (var j = 32, i = 1; j < b; ++i) {
      if (j % 32 === 16) {
        t1 = s[t1];
        t2 = s[t2];
        t3 = s[t3];
        t4 = s[t4];
      } else if (j % 32 === 0) {
        var t1 = result[j - 3],
            t2 = result[j - 2],
            t3 = result[j - 1],
            t4 = result[j - 4];
        t1 = s[t1];
        t2 = s[t2];
        t3 = s[t3];
        t4 = s[t4];
        t1 = t1 ^ r;
        if ((r <<= 1) >= 256) {
          r = (r ^ 0x1b) & 0xFF;
        }
      }
      for (var n = 0; n < 4; ++n) {
        result[j] = t1 ^= result[j - 32];
        j++;
        result[j] = t2 ^= result[j - 32];
        j++;
        result[j] = t3 ^= result[j - 32];
        j++;
        result[j] = t4 ^= result[j - 32];
        j++;
      }
    }
    return result;
  }
  function decrypt256(input, key) {
    var state = new Uint8Array(16);
    state.set(input);
    var i, j, k;
    var t, u, v;
    for (j = 0, k = 224; j < 16; ++j, ++k) {
      state[j] ^= key[k];
    }
    for (i = 13; i >= 1; --i) {
      t = state[13];
      state[13] = state[9];
      state[9] = state[5];
      state[5] = state[1];
      state[1] = t;
      t = state[14];
      u = state[10];
      state[14] = state[6];
      state[10] = state[2];
      state[6] = t;
      state[2] = u;
      t = state[15];
      u = state[11];
      v = state[7];
      state[15] = state[3];
      state[11] = t;
      state[7] = u;
      state[3] = v;
      for (j = 0; j < 16; ++j) {
        state[j] = inv_s[state[j]];
      }
      for (j = 0, k = i * 16; j < 16; ++j, ++k) {
        state[j] ^= key[k];
      }
      for (j = 0; j < 16; j += 4) {
        var s0 = mix[state[j]],
            s1 = mix[state[j + 1]],
            s2 = mix[state[j + 2]],
            s3 = mix[state[j + 3]];
        t = s0 ^ s1 >>> 8 ^ s1 << 24 ^ s2 >>> 16 ^ s2 << 16 ^ s3 >>> 24 ^ s3 << 8;
        state[j] = t >>> 24 & 0xFF;
        state[j + 1] = t >> 16 & 0xFF;
        state[j + 2] = t >> 8 & 0xFF;
        state[j + 3] = t & 0xFF;
      }
    }
    t = state[13];
    state[13] = state[9];
    state[9] = state[5];
    state[5] = state[1];
    state[1] = t;
    t = state[14];
    u = state[10];
    state[14] = state[6];
    state[10] = state[2];
    state[6] = t;
    state[2] = u;
    t = state[15];
    u = state[11];
    v = state[7];
    state[15] = state[3];
    state[11] = t;
    state[7] = u;
    state[3] = v;
    for (j = 0; j < 16; ++j) {
      state[j] = inv_s[state[j]];
      state[j] ^= key[j];
    }
    return state;
  }
  function encrypt256(input, key) {
    var t, u, v, k;
    var state = new Uint8Array(16);
    state.set(input);
    for (j = 0; j < 16; ++j) {
      state[j] ^= key[j];
    }
    for (i = 1; i < 14; i++) {
      for (j = 0; j < 16; ++j) {
        state[j] = s[state[j]];
      }
      v = state[1];
      state[1] = state[5];
      state[5] = state[9];
      state[9] = state[13];
      state[13] = v;
      v = state[2];
      u = state[6];
      state[2] = state[10];
      state[6] = state[14];
      state[10] = v;
      state[14] = u;
      v = state[3];
      u = state[7];
      t = state[11];
      state[3] = state[15];
      state[7] = v;
      state[11] = u;
      state[15] = t;
      for (var j = 0; j < 16; j += 4) {
        var s0 = state[j + 0],
            s1 = state[j + 1];
        var s2 = state[j + 2],
            s3 = state[j + 3];
        t = s0 ^ s1 ^ s2 ^ s3;
        state[j + 0] ^= t ^ mixCol[s0 ^ s1];
        state[j + 1] ^= t ^ mixCol[s1 ^ s2];
        state[j + 2] ^= t ^ mixCol[s2 ^ s3];
        state[j + 3] ^= t ^ mixCol[s3 ^ s0];
      }
      for (j = 0, k = i * 16; j < 16; ++j, ++k) {
        state[j] ^= key[k];
      }
    }
    for (j = 0; j < 16; ++j) {
      state[j] = s[state[j]];
    }
    v = state[1];
    state[1] = state[5];
    state[5] = state[9];
    state[9] = state[13];
    state[13] = v;
    v = state[2];
    u = state[6];
    state[2] = state[10];
    state[6] = state[14];
    state[10] = v;
    state[14] = u;
    v = state[3];
    u = state[7];
    t = state[11];
    state[3] = state[15];
    state[7] = v;
    state[11] = u;
    state[15] = t;
    for (j = 0, k = 224; j < 16; ++j, ++k) {
      state[j] ^= key[k];
    }
    return state;
  }
  function AES256Cipher(key) {
    this.key = expandKey256(key);
    this.buffer = new Uint8Array(16);
    this.bufferPosition = 0;
  }
  function decryptBlock2(data, finalize) {
    var i,
        j,
        ii,
        sourceLength = data.length,
        buffer = this.buffer,
        bufferLength = this.bufferPosition,
        result = [],
        iv = this.iv;
    for (i = 0; i < sourceLength; ++i) {
      buffer[bufferLength] = data[i];
      ++bufferLength;
      if (bufferLength < 16) {
        continue;
      }
      var plain = decrypt256(buffer, this.key);
      for (j = 0; j < 16; ++j) {
        plain[j] ^= iv[j];
      }
      iv = buffer;
      result.push(plain);
      buffer = new Uint8Array(16);
      bufferLength = 0;
    }
    this.buffer = buffer;
    this.bufferLength = bufferLength;
    this.iv = iv;
    if (result.length === 0) {
      return new Uint8Array([]);
    }
    var outputLength = 16 * result.length;
    if (finalize) {
      var lastBlock = result[result.length - 1];
      var psLen = lastBlock[15];
      if (psLen <= 16) {
        for (i = 15, ii = 16 - psLen; i >= ii; --i) {
          if (lastBlock[i] !== psLen) {
            psLen = 0;
            break;
          }
        }
        outputLength -= psLen;
        result[result.length - 1] = lastBlock.subarray(0, 16 - psLen);
      }
    }
    var output = new Uint8Array(outputLength);
    for (i = 0, j = 0, ii = result.length; i < ii; ++i, j += 16) {
      output.set(result[i], j);
    }
    return output;
  }
  AES256Cipher.prototype = {
    decryptBlock: function AES256Cipher_decryptBlock(data, finalize, iv) {
      var i,
          sourceLength = data.length;
      var buffer = this.buffer,
          bufferLength = this.bufferPosition;
      if (iv) {
        this.iv = iv;
      } else {
        for (i = 0; bufferLength < 16 && i < sourceLength; ++i, ++bufferLength) {
          buffer[bufferLength] = data[i];
        }
        if (bufferLength < 16) {
          this.bufferLength = bufferLength;
          return new Uint8Array([]);
        }
        this.iv = buffer;
        data = data.subarray(16);
      }
      this.buffer = new Uint8Array(16);
      this.bufferLength = 0;
      this.decryptBlock = decryptBlock2;
      return this.decryptBlock(data, finalize);
    },
    encrypt: function AES256Cipher_encrypt(data, iv) {
      var i,
          j,
          ii,
          sourceLength = data.length,
          buffer = this.buffer,
          bufferLength = this.bufferPosition,
          result = [];
      if (!iv) {
        iv = new Uint8Array(16);
      }
      for (i = 0; i < sourceLength; ++i) {
        buffer[bufferLength] = data[i];
        ++bufferLength;
        if (bufferLength < 16) {
          continue;
        }
        for (j = 0; j < 16; ++j) {
          buffer[j] ^= iv[j];
        }
        var cipher = encrypt256(buffer, this.key);
        this.iv = cipher;
        result.push(cipher);
        buffer = new Uint8Array(16);
        bufferLength = 0;
      }
      this.buffer = buffer;
      this.bufferLength = bufferLength;
      this.iv = iv;
      if (result.length === 0) {
        return new Uint8Array([]);
      }
      var outputLength = 16 * result.length;
      var output = new Uint8Array(outputLength);
      for (i = 0, j = 0, ii = result.length; i < ii; ++i, j += 16) {
        output.set(result[i], j);
      }
      return output;
    }
  };
  return AES256Cipher;
}();
var PDF17 = function PDF17Closure() {
  function compareByteArrays(array1, array2) {
    if (array1.length !== array2.length) {
      return false;
    }
    for (var i = 0; i < array1.length; i++) {
      if (array1[i] !== array2[i]) {
        return false;
      }
    }
    return true;
  }
  function PDF17() {}
  PDF17.prototype = {
    checkOwnerPassword: function PDF17_checkOwnerPassword(password, ownerValidationSalt, userBytes, ownerPassword) {
      var hashData = new Uint8Array(password.length + 56);
      hashData.set(password, 0);
      hashData.set(ownerValidationSalt, password.length);
      hashData.set(userBytes, password.length + ownerValidationSalt.length);
      var result = calculateSHA256(hashData, 0, hashData.length);
      return compareByteArrays(result, ownerPassword);
    },
    checkUserPassword: function PDF17_checkUserPassword(password, userValidationSalt, userPassword) {
      var hashData = new Uint8Array(password.length + 8);
      hashData.set(password, 0);
      hashData.set(userValidationSalt, password.length);
      var result = calculateSHA256(hashData, 0, hashData.length);
      return compareByteArrays(result, userPassword);
    },
    getOwnerKey: function PDF17_getOwnerKey(password, ownerKeySalt, userBytes, ownerEncryption) {
      var hashData = new Uint8Array(password.length + 56);
      hashData.set(password, 0);
      hashData.set(ownerKeySalt, password.length);
      hashData.set(userBytes, password.length + ownerKeySalt.length);
      var key = calculateSHA256(hashData, 0, hashData.length);
      var cipher = new AES256Cipher(key);
      return cipher.decryptBlock(ownerEncryption, false, new Uint8Array(16));
    },
    getUserKey: function PDF17_getUserKey(password, userKeySalt, userEncryption) {
      var hashData = new Uint8Array(password.length + 8);
      hashData.set(password, 0);
      hashData.set(userKeySalt, password.length);
      var key = calculateSHA256(hashData, 0, hashData.length);
      var cipher = new AES256Cipher(key);
      return cipher.decryptBlock(userEncryption, false, new Uint8Array(16));
    }
  };
  return PDF17;
}();
var PDF20 = function PDF20Closure() {
  function concatArrays(array1, array2) {
    var t = new Uint8Array(array1.length + array2.length);
    t.set(array1, 0);
    t.set(array2, array1.length);
    return t;
  }
  function calculatePDF20Hash(password, input, userBytes) {
    var k = calculateSHA256(input, 0, input.length).subarray(0, 32);
    var e = [0];
    var i = 0;
    while (i < 64 || e[e.length - 1] > i - 32) {
      var arrayLength = password.length + k.length + userBytes.length;
      var k1 = new Uint8Array(arrayLength * 64);
      var array = concatArrays(password, k);
      array = concatArrays(array, userBytes);
      for (var j = 0, pos = 0; j < 64; j++, pos += arrayLength) {
        k1.set(array, pos);
      }
      var cipher = new AES128Cipher(k.subarray(0, 16));
      e = cipher.encrypt(k1, k.subarray(16, 32));
      var remainder = 0;
      for (var z = 0; z < 16; z++) {
        remainder *= 256 % 3;
        remainder %= 3;
        remainder += (e[z] >>> 0) % 3;
        remainder %= 3;
      }
      if (remainder === 0) {
        k = calculateSHA256(e, 0, e.length);
      } else if (remainder === 1) {
        k = calculateSHA384(e, 0, e.length);
      } else if (remainder === 2) {
        k = calculateSHA512(e, 0, e.length);
      }
      i++;
    }
    return k.subarray(0, 32);
  }
  function PDF20() {}
  function compareByteArrays(array1, array2) {
    if (array1.length !== array2.length) {
      return false;
    }
    for (var i = 0; i < array1.length; i++) {
      if (array1[i] !== array2[i]) {
        return false;
      }
    }
    return true;
  }
  PDF20.prototype = {
    hash: function PDF20_hash(password, concatBytes, userBytes) {
      return calculatePDF20Hash(password, concatBytes, userBytes);
    },
    checkOwnerPassword: function PDF20_checkOwnerPassword(password, ownerValidationSalt, userBytes, ownerPassword) {
      var hashData = new Uint8Array(password.length + 56);
      hashData.set(password, 0);
      hashData.set(ownerValidationSalt, password.length);
      hashData.set(userBytes, password.length + ownerValidationSalt.length);
      var result = calculatePDF20Hash(password, hashData, userBytes);
      return compareByteArrays(result, ownerPassword);
    },
    checkUserPassword: function PDF20_checkUserPassword(password, userValidationSalt, userPassword) {
      var hashData = new Uint8Array(password.length + 8);
      hashData.set(password, 0);
      hashData.set(userValidationSalt, password.length);
      var result = calculatePDF20Hash(password, hashData, []);
      return compareByteArrays(result, userPassword);
    },
    getOwnerKey: function PDF20_getOwnerKey(password, ownerKeySalt, userBytes, ownerEncryption) {
      var hashData = new Uint8Array(password.length + 56);
      hashData.set(password, 0);
      hashData.set(ownerKeySalt, password.length);
      hashData.set(userBytes, password.length + ownerKeySalt.length);
      var key = calculatePDF20Hash(password, hashData, userBytes);
      var cipher = new AES256Cipher(key);
      return cipher.decryptBlock(ownerEncryption, false, new Uint8Array(16));
    },
    getUserKey: function PDF20_getUserKey(password, userKeySalt, userEncryption) {
      var hashData = new Uint8Array(password.length + 8);
      hashData.set(password, 0);
      hashData.set(userKeySalt, password.length);
      var key = calculatePDF20Hash(password, hashData, []);
      var cipher = new AES256Cipher(key);
      return cipher.decryptBlock(userEncryption, false, new Uint8Array(16));
    }
  };
  return PDF20;
}();
var CipherTransform = function CipherTransformClosure() {
  function CipherTransform(stringCipherConstructor, streamCipherConstructor) {
    this.StringCipherConstructor = stringCipherConstructor;
    this.StreamCipherConstructor = streamCipherConstructor;
  }
  CipherTransform.prototype = {
    createStream: function CipherTransform_createStream(stream, length) {
      var cipher = new this.StreamCipherConstructor();
      return new _stream.DecryptStream(stream, length, function cipherTransformDecryptStream(data, finalize) {
        return cipher.decryptBlock(data, finalize);
      });
    },
    decryptString: function CipherTransform_decryptString(s) {
      var cipher = new this.StringCipherConstructor();
      var data = (0, _util.stringToBytes)(s);
      data = cipher.decryptBlock(data, true);
      return (0, _util.bytesToString)(data);
    }
  };
  return CipherTransform;
}();
var CipherTransformFactory = function CipherTransformFactoryClosure() {
  var defaultPasswordBytes = new Uint8Array([0x28, 0xBF, 0x4E, 0x5E, 0x4E, 0x75, 0x8A, 0x41, 0x64, 0x00, 0x4E, 0x56, 0xFF, 0xFA, 0x01, 0x08, 0x2E, 0x2E, 0x00, 0xB6, 0xD0, 0x68, 0x3E, 0x80, 0x2F, 0x0C, 0xA9, 0xFE, 0x64, 0x53, 0x69, 0x7A]);
  function createEncryptionKey20(revision, password, ownerPassword, ownerValidationSalt, ownerKeySalt, uBytes, userPassword, userValidationSalt, userKeySalt, ownerEncryption, userEncryption, perms) {
    if (password) {
      var passwordLength = Math.min(127, password.length);
      password = password.subarray(0, passwordLength);
    } else {
      password = [];
    }
    var pdfAlgorithm;
    if (revision === 6) {
      pdfAlgorithm = new PDF20();
    } else {
      pdfAlgorithm = new PDF17();
    }
    if (pdfAlgorithm.checkUserPassword(password, userValidationSalt, userPassword)) {
      return pdfAlgorithm.getUserKey(password, userKeySalt, userEncryption);
    } else if (password.length && pdfAlgorithm.checkOwnerPassword(password, ownerValidationSalt, uBytes, ownerPassword)) {
      return pdfAlgorithm.getOwnerKey(password, ownerKeySalt, uBytes, ownerEncryption);
    }
    return null;
  }
  function prepareKeyData(fileId, password, ownerPassword, userPassword, flags, revision, keyLength, encryptMetadata) {
    var hashDataSize = 40 + ownerPassword.length + fileId.length;
    var hashData = new Uint8Array(hashDataSize),
        i = 0,
        j,
        n;
    if (password) {
      n = Math.min(32, password.length);
      for (; i < n; ++i) {
        hashData[i] = password[i];
      }
    }
    j = 0;
    while (i < 32) {
      hashData[i++] = defaultPasswordBytes[j++];
    }
    for (j = 0, n = ownerPassword.length; j < n; ++j) {
      hashData[i++] = ownerPassword[j];
    }
    hashData[i++] = flags & 0xFF;
    hashData[i++] = flags >> 8 & 0xFF;
    hashData[i++] = flags >> 16 & 0xFF;
    hashData[i++] = flags >>> 24 & 0xFF;
    for (j = 0, n = fileId.length; j < n; ++j) {
      hashData[i++] = fileId[j];
    }
    if (revision >= 4 && !encryptMetadata) {
      hashData[i++] = 0xFF;
      hashData[i++] = 0xFF;
      hashData[i++] = 0xFF;
      hashData[i++] = 0xFF;
    }
    var hash = calculateMD5(hashData, 0, i);
    var keyLengthInBytes = keyLength >> 3;
    if (revision >= 3) {
      for (j = 0; j < 50; ++j) {
        hash = calculateMD5(hash, 0, keyLengthInBytes);
      }
    }
    var encryptionKey = hash.subarray(0, keyLengthInBytes);
    var cipher, checkData;
    if (revision >= 3) {
      for (i = 0; i < 32; ++i) {
        hashData[i] = defaultPasswordBytes[i];
      }
      for (j = 0, n = fileId.length; j < n; ++j) {
        hashData[i++] = fileId[j];
      }
      cipher = new ARCFourCipher(encryptionKey);
      checkData = cipher.encryptBlock(calculateMD5(hashData, 0, i));
      n = encryptionKey.length;
      var derivedKey = new Uint8Array(n),
          k;
      for (j = 1; j <= 19; ++j) {
        for (k = 0; k < n; ++k) {
          derivedKey[k] = encryptionKey[k] ^ j;
        }
        cipher = new ARCFourCipher(derivedKey);
        checkData = cipher.encryptBlock(checkData);
      }
      for (j = 0, n = checkData.length; j < n; ++j) {
        if (userPassword[j] !== checkData[j]) {
          return null;
        }
      }
    } else {
      cipher = new ARCFourCipher(encryptionKey);
      checkData = cipher.encryptBlock(defaultPasswordBytes);
      for (j = 0, n = checkData.length; j < n; ++j) {
        if (userPassword[j] !== checkData[j]) {
          return null;
        }
      }
    }
    return encryptionKey;
  }
  function decodeUserPassword(password, ownerPassword, revision, keyLength) {
    var hashData = new Uint8Array(32),
        i = 0,
        j,
        n;
    n = Math.min(32, password.length);
    for (; i < n; ++i) {
      hashData[i] = password[i];
    }
    j = 0;
    while (i < 32) {
      hashData[i++] = defaultPasswordBytes[j++];
    }
    var hash = calculateMD5(hashData, 0, i);
    var keyLengthInBytes = keyLength >> 3;
    if (revision >= 3) {
      for (j = 0; j < 50; ++j) {
        hash = calculateMD5(hash, 0, hash.length);
      }
    }
    var cipher, userPassword;
    if (revision >= 3) {
      userPassword = ownerPassword;
      var derivedKey = new Uint8Array(keyLengthInBytes),
          k;
      for (j = 19; j >= 0; j--) {
        for (k = 0; k < keyLengthInBytes; ++k) {
          derivedKey[k] = hash[k] ^ j;
        }
        cipher = new ARCFourCipher(derivedKey);
        userPassword = cipher.encryptBlock(userPassword);
      }
    } else {
      cipher = new ARCFourCipher(hash.subarray(0, keyLengthInBytes));
      userPassword = cipher.encryptBlock(ownerPassword);
    }
    return userPassword;
  }
  var identityName = _primitives.Name.get('Identity');
  function CipherTransformFactory(dict, fileId, password) {
    var filter = dict.get('Filter');
    if (!(0, _primitives.isName)(filter, 'Standard')) {
      throw new _util.FormatError('unknown encryption method');
    }
    this.dict = dict;
    var algorithm = dict.get('V');
    if (!(0, _util.isInt)(algorithm) || algorithm !== 1 && algorithm !== 2 && algorithm !== 4 && algorithm !== 5) {
      throw new _util.FormatError('unsupported encryption algorithm');
    }
    this.algorithm = algorithm;
    var keyLength = dict.get('Length');
    if (!keyLength) {
      if (algorithm <= 3) {
        keyLength = 40;
      } else {
        var cfDict = dict.get('CF');
        var streamCryptoName = dict.get('StmF');
        if ((0, _primitives.isDict)(cfDict) && (0, _primitives.isName)(streamCryptoName)) {
          cfDict.suppressEncryption = true;
          var handlerDict = cfDict.get(streamCryptoName.name);
          keyLength = handlerDict && handlerDict.get('Length') || 128;
          if (keyLength < 40) {
            keyLength <<= 3;
          }
        }
      }
    }
    if (!(0, _util.isInt)(keyLength) || keyLength < 40 || keyLength % 8 !== 0) {
      throw new _util.FormatError('invalid key length');
    }
    var ownerPassword = (0, _util.stringToBytes)(dict.get('O')).subarray(0, 32);
    var userPassword = (0, _util.stringToBytes)(dict.get('U')).subarray(0, 32);
    var flags = dict.get('P');
    var revision = dict.get('R');
    var encryptMetadata = (algorithm === 4 || algorithm === 5) && dict.get('EncryptMetadata') !== false;
    this.encryptMetadata = encryptMetadata;
    var fileIdBytes = (0, _util.stringToBytes)(fileId);
    var passwordBytes;
    if (password) {
      if (revision === 6) {
        try {
          password = (0, _util.utf8StringToString)(password);
        } catch (ex) {
          (0, _util.warn)('CipherTransformFactory: ' + 'Unable to convert UTF8 encoded password.');
        }
      }
      passwordBytes = (0, _util.stringToBytes)(password);
    }
    var encryptionKey;
    if (algorithm !== 5) {
      encryptionKey = prepareKeyData(fileIdBytes, passwordBytes, ownerPassword, userPassword, flags, revision, keyLength, encryptMetadata);
    } else {
      var ownerValidationSalt = (0, _util.stringToBytes)(dict.get('O')).subarray(32, 40);
      var ownerKeySalt = (0, _util.stringToBytes)(dict.get('O')).subarray(40, 48);
      var uBytes = (0, _util.stringToBytes)(dict.get('U')).subarray(0, 48);
      var userValidationSalt = (0, _util.stringToBytes)(dict.get('U')).subarray(32, 40);
      var userKeySalt = (0, _util.stringToBytes)(dict.get('U')).subarray(40, 48);
      var ownerEncryption = (0, _util.stringToBytes)(dict.get('OE'));
      var userEncryption = (0, _util.stringToBytes)(dict.get('UE'));
      var perms = (0, _util.stringToBytes)(dict.get('Perms'));
      encryptionKey = createEncryptionKey20(revision, passwordBytes, ownerPassword, ownerValidationSalt, ownerKeySalt, uBytes, userPassword, userValidationSalt, userKeySalt, ownerEncryption, userEncryption, perms);
    }
    if (!encryptionKey && !password) {
      throw new _util.PasswordException('No password given', _util.PasswordResponses.NEED_PASSWORD);
    } else if (!encryptionKey && password) {
      var decodedPassword = decodeUserPassword(passwordBytes, ownerPassword, revision, keyLength);
      encryptionKey = prepareKeyData(fileIdBytes, decodedPassword, ownerPassword, userPassword, flags, revision, keyLength, encryptMetadata);
    }
    if (!encryptionKey) {
      throw new _util.PasswordException('Incorrect Password', _util.PasswordResponses.INCORRECT_PASSWORD);
    }
    this.encryptionKey = encryptionKey;
    if (algorithm >= 4) {
      var cf = dict.get('CF');
      if ((0, _primitives.isDict)(cf)) {
        cf.suppressEncryption = true;
      }
      this.cf = cf;
      this.stmf = dict.get('StmF') || identityName;
      this.strf = dict.get('StrF') || identityName;
      this.eff = dict.get('EFF') || this.stmf;
    }
  }
  function buildObjectKey(num, gen, encryptionKey, isAes) {
    var key = new Uint8Array(encryptionKey.length + 9),
        i,
        n;
    for (i = 0, n = encryptionKey.length; i < n; ++i) {
      key[i] = encryptionKey[i];
    }
    key[i++] = num & 0xFF;
    key[i++] = num >> 8 & 0xFF;
    key[i++] = num >> 16 & 0xFF;
    key[i++] = gen & 0xFF;
    key[i++] = gen >> 8 & 0xFF;
    if (isAes) {
      key[i++] = 0x73;
      key[i++] = 0x41;
      key[i++] = 0x6C;
      key[i++] = 0x54;
    }
    var hash = calculateMD5(key, 0, i);
    return hash.subarray(0, Math.min(encryptionKey.length + 5, 16));
  }
  function buildCipherConstructor(cf, name, num, gen, key) {
    if (!(0, _primitives.isName)(name)) {
      throw new _util.FormatError('Invalid crypt filter name.');
    }
    var cryptFilter = cf.get(name.name);
    var cfm;
    if (cryptFilter !== null && cryptFilter !== undefined) {
      cfm = cryptFilter.get('CFM');
    }
    if (!cfm || cfm.name === 'None') {
      return function cipherTransformFactoryBuildCipherConstructorNone() {
        return new NullCipher();
      };
    }
    if (cfm.name === 'V2') {
      return function cipherTransformFactoryBuildCipherConstructorV2() {
        return new ARCFourCipher(buildObjectKey(num, gen, key, false));
      };
    }
    if (cfm.name === 'AESV2') {
      return function cipherTransformFactoryBuildCipherConstructorAESV2() {
        return new AES128Cipher(buildObjectKey(num, gen, key, true));
      };
    }
    if (cfm.name === 'AESV3') {
      return function cipherTransformFactoryBuildCipherConstructorAESV3() {
        return new AES256Cipher(key);
      };
    }
    throw new _util.FormatError('Unknown crypto method');
  }
  CipherTransformFactory.prototype = {
    createCipherTransform: function CipherTransformFactory_createCipherTransform(num, gen) {
      if (this.algorithm === 4 || this.algorithm === 5) {
        return new CipherTransform(buildCipherConstructor(this.cf, this.stmf, num, gen, this.encryptionKey), buildCipherConstructor(this.cf, this.strf, num, gen, this.encryptionKey));
      }
      var key = buildObjectKey(num, gen, this.encryptionKey, false);
      var cipherConstructor = function buildCipherCipherConstructor() {
        return new ARCFourCipher(key);
      };
      return new CipherTransform(cipherConstructor, cipherConstructor);
    }
  };
  return CipherTransformFactory;
}();
exports.AES128Cipher = AES128Cipher;
exports.AES256Cipher = AES256Cipher;
exports.ARCFourCipher = ARCFourCipher;
exports.CipherTransformFactory = CipherTransformFactory;
exports.PDF17 = PDF17;
exports.PDF20 = PDF20;
exports.calculateMD5 = calculateMD5;
exports.calculateSHA256 = calculateSHA256;
exports.calculateSHA384 = calculateSHA384;
exports.calculateSHA512 = calculateSHA512;

/***/ }),
/* 12 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PartialEvaluator = exports.OperatorList = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _util = __w_pdfjs_require__(0);

var _cmap = __w_pdfjs_require__(22);

var _stream = __w_pdfjs_require__(2);

var _primitives = __w_pdfjs_require__(1);

var _fonts = __w_pdfjs_require__(25);

var _encodings = __w_pdfjs_require__(4);

var _unicode = __w_pdfjs_require__(16);

var _standard_fonts = __w_pdfjs_require__(15);

var _pattern = __w_pdfjs_require__(31);

var _function = __w_pdfjs_require__(6);

var _parser = __w_pdfjs_require__(5);

var _bidi = __w_pdfjs_require__(20);

var _colorspace = __w_pdfjs_require__(3);

var _glyphlist = __w_pdfjs_require__(7);

var _metrics = __w_pdfjs_require__(29);

var _murmurhash = __w_pdfjs_require__(30);

var _image = __w_pdfjs_require__(26);

var PartialEvaluator = function PartialEvaluatorClosure() {
  var DefaultPartialEvaluatorOptions = {
    forceDataSchema: false,
    maxImageSize: -1,
    disableFontFace: false,
    nativeImageDecoderSupport: _util.NativeImageDecoding.DECODE,
    ignoreErrors: false
  };
  function NativeImageDecoder(xref, resources, handler, forceDataSchema) {
    this.xref = xref;
    this.resources = resources;
    this.handler = handler;
    this.forceDataSchema = forceDataSchema;
  }
  NativeImageDecoder.prototype = {
    canDecode: function canDecode(image) {
      return image instanceof _stream.JpegStream && NativeImageDecoder.isDecodable(image, this.xref, this.resources);
    },
    decode: function decode(image) {
      var dict = image.dict;
      var colorSpace = dict.get('ColorSpace', 'CS');
      colorSpace = _colorspace.ColorSpace.parse(colorSpace, this.xref, this.resources);
      var numComps = colorSpace.numComps;
      var decodePromise = this.handler.sendWithPromise('JpegDecode', [image.getIR(this.forceDataSchema), numComps]);
      return decodePromise.then(function (message) {
        var data = message.data;
        return new _stream.Stream(data, 0, data.length, image.dict);
      });
    }
  };
  NativeImageDecoder.isSupported = function NativeImageDecoder_isSupported(image, xref, res) {
    var dict = image.dict;
    if (dict.has('DecodeParms') || dict.has('DP')) {
      return false;
    }
    var cs = _colorspace.ColorSpace.parse(dict.get('ColorSpace', 'CS'), xref, res);
    return (cs.name === 'DeviceGray' || cs.name === 'DeviceRGB') && cs.isDefaultDecode(dict.getArray('Decode', 'D'));
  };
  NativeImageDecoder.isDecodable = function NativeImageDecoder_isDecodable(image, xref, res) {
    var dict = image.dict;
    if (dict.has('DecodeParms') || dict.has('DP')) {
      return false;
    }
    var cs = _colorspace.ColorSpace.parse(dict.get('ColorSpace', 'CS'), xref, res);
    return (cs.numComps === 1 || cs.numComps === 3) && cs.isDefaultDecode(dict.getArray('Decode', 'D'));
  };
  function PartialEvaluator(_ref) {
    var _this = this;

    var pdfManager = _ref.pdfManager,
        xref = _ref.xref,
        handler = _ref.handler,
        pageIndex = _ref.pageIndex,
        idFactory = _ref.idFactory,
        fontCache = _ref.fontCache,
        builtInCMapCache = _ref.builtInCMapCache,
        _ref$options = _ref.options,
        options = _ref$options === undefined ? null : _ref$options;

    this.pdfManager = pdfManager;
    this.xref = xref;
    this.handler = handler;
    this.pageIndex = pageIndex;
    this.idFactory = idFactory;
    this.fontCache = fontCache;
    this.builtInCMapCache = builtInCMapCache;
    this.options = options || DefaultPartialEvaluatorOptions;
    this.fetchBuiltInCMap = function (name) {
      var cachedCMap = _this.builtInCMapCache[name];
      if (cachedCMap) {
        return Promise.resolve(cachedCMap);
      }
      return _this.handler.sendWithPromise('FetchBuiltInCMap', { name: name }).then(function (data) {
        if (data.compressionType !== _util.CMapCompressionType.NONE) {
          _this.builtInCMapCache[name] = data;
        }
        return data;
      });
    };
  }
  var TIME_SLOT_DURATION_MS = 20;
  var CHECK_TIME_EVERY = 100;
  function TimeSlotManager() {
    this.reset();
  }
  TimeSlotManager.prototype = {
    check: function TimeSlotManager_check() {
      if (++this.checked < CHECK_TIME_EVERY) {
        return false;
      }
      this.checked = 0;
      return this.endTime <= Date.now();
    },
    reset: function TimeSlotManager_reset() {
      this.endTime = Date.now() + TIME_SLOT_DURATION_MS;
      this.checked = 0;
    }
  };
  function normalizeBlendMode(value) {
    if (!(0, _primitives.isName)(value)) {
      return 'source-over';
    }
    switch (value.name) {
      case 'Normal':
      case 'Compatible':
        return 'source-over';
      case 'Multiply':
        return 'multiply';
      case 'Screen':
        return 'screen';
      case 'Overlay':
        return 'overlay';
      case 'Darken':
        return 'darken';
      case 'Lighten':
        return 'lighten';
      case 'ColorDodge':
        return 'color-dodge';
      case 'ColorBurn':
        return 'color-burn';
      case 'HardLight':
        return 'hard-light';
      case 'SoftLight':
        return 'soft-light';
      case 'Difference':
        return 'difference';
      case 'Exclusion':
        return 'exclusion';
      case 'Hue':
        return 'hue';
      case 'Saturation':
        return 'saturation';
      case 'Color':
        return 'color';
      case 'Luminosity':
        return 'luminosity';
    }
    (0, _util.warn)('Unsupported blend mode: ' + value.name);
    return 'source-over';
  }
  var deferred = Promise.resolve();
  var TILING_PATTERN = 1,
      SHADING_PATTERN = 2;
  PartialEvaluator.prototype = {
    clone: function clone() {
      var newOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DefaultPartialEvaluatorOptions;

      var newEvaluator = Object.create(this);
      newEvaluator.options = newOptions;
      return newEvaluator;
    },

    hasBlendModes: function PartialEvaluator_hasBlendModes(resources) {
      if (!(0, _primitives.isDict)(resources)) {
        return false;
      }
      var processed = Object.create(null);
      if (resources.objId) {
        processed[resources.objId] = true;
      }
      var nodes = [resources],
          xref = this.xref;
      while (nodes.length) {
        var key, i, ii;
        var node = nodes.shift();
        var graphicStates = node.get('ExtGState');
        if ((0, _primitives.isDict)(graphicStates)) {
          var graphicStatesKeys = graphicStates.getKeys();
          for (i = 0, ii = graphicStatesKeys.length; i < ii; i++) {
            key = graphicStatesKeys[i];
            var graphicState = graphicStates.get(key);
            var bm = graphicState.get('BM');
            if ((0, _primitives.isName)(bm) && bm.name !== 'Normal') {
              return true;
            }
          }
        }
        var xObjects = node.get('XObject');
        if (!(0, _primitives.isDict)(xObjects)) {
          continue;
        }
        var xObjectsKeys = xObjects.getKeys();
        for (i = 0, ii = xObjectsKeys.length; i < ii; i++) {
          key = xObjectsKeys[i];
          var xObject = xObjects.getRaw(key);
          if ((0, _primitives.isRef)(xObject)) {
            if (processed[xObject.toString()]) {
              continue;
            }
            xObject = xref.fetch(xObject);
          }
          if (!(0, _primitives.isStream)(xObject)) {
            continue;
          }
          if (xObject.dict.objId) {
            if (processed[xObject.dict.objId]) {
              continue;
            }
            processed[xObject.dict.objId] = true;
          }
          var xResources = xObject.dict.get('Resources');
          if ((0, _primitives.isDict)(xResources) && (!xResources.objId || !processed[xResources.objId])) {
            nodes.push(xResources);
            if (xResources.objId) {
              processed[xResources.objId] = true;
            }
          }
        }
      }
      return false;
    },
    buildFormXObject: function PartialEvaluator_buildFormXObject(resources, xobj, smask, operatorList, task, initialState) {
      var dict = xobj.dict;
      var matrix = dict.getArray('Matrix');
      var bbox = dict.getArray('BBox');
      var group = dict.get('Group');
      if (group) {
        var groupOptions = {
          matrix: matrix,
          bbox: bbox,
          smask: smask,
          isolated: false,
          knockout: false
        };
        var groupSubtype = group.get('S');
        var colorSpace;
        if ((0, _primitives.isName)(groupSubtype, 'Transparency')) {
          groupOptions.isolated = group.get('I') || false;
          groupOptions.knockout = group.get('K') || false;
          colorSpace = group.has('CS') ? _colorspace.ColorSpace.parse(group.get('CS'), this.xref, resources) : null;
        }
        if (smask && smask.backdrop) {
          colorSpace = colorSpace || _colorspace.ColorSpace.singletons.rgb;
          smask.backdrop = colorSpace.getRgb(smask.backdrop, 0);
        }
        operatorList.addOp(_util.OPS.beginGroup, [groupOptions]);
      }
      operatorList.addOp(_util.OPS.paintFormXObjectBegin, [matrix, bbox]);
      return this.getOperatorList({
        stream: xobj,
        task: task,
        resources: dict.get('Resources') || resources,
        operatorList: operatorList,
        initialState: initialState
      }).then(function () {
        operatorList.addOp(_util.OPS.paintFormXObjectEnd, []);
        if (group) {
          operatorList.addOp(_util.OPS.endGroup, [groupOptions]);
        }
      });
    },
    buildPaintImageXObject: function PartialEvaluator_buildPaintImageXObject(resources, image, inline, operatorList, cacheKey, imageCache) {
      var _this2 = this;

      var dict = image.dict;
      var w = dict.get('Width', 'W');
      var h = dict.get('Height', 'H');
      if (!(w && (0, _util.isNum)(w)) || !(h && (0, _util.isNum)(h))) {
        (0, _util.warn)('Image dimensions are missing, or not numbers.');
        return;
      }
      var maxImageSize = this.options.maxImageSize;
      if (maxImageSize !== -1 && w * h > maxImageSize) {
        (0, _util.warn)('Image exceeded maximum allowed size and was removed.');
        return;
      }
      var imageMask = dict.get('ImageMask', 'IM') || false;
      var imgData, args;
      if (imageMask) {
        var width = dict.get('Width', 'W');
        var height = dict.get('Height', 'H');
        var bitStrideLength = width + 7 >> 3;
        var imgArray = image.getBytes(bitStrideLength * height);
        var decode = dict.getArray('Decode', 'D');
        var inverseDecode = !!decode && decode[0] > 0;
        imgData = _image.PDFImage.createMask(imgArray, width, height, image instanceof _stream.DecodeStream, inverseDecode);
        imgData.cached = true;
        args = [imgData];
        operatorList.addOp(_util.OPS.paintImageMaskXObject, args);
        if (cacheKey) {
          imageCache[cacheKey] = {
            fn: _util.OPS.paintImageMaskXObject,
            args: args
          };
        }
        return;
      }
      var softMask = dict.get('SMask', 'SM') || false;
      var mask = dict.get('Mask') || false;
      var SMALL_IMAGE_DIMENSIONS = 200;
      if (inline && !softMask && !mask && !(image instanceof _stream.JpegStream) && w + h < SMALL_IMAGE_DIMENSIONS) {
        var imageObj = new _image.PDFImage(this.xref, resources, image, inline, null, null);
        imgData = imageObj.createImageData(true);
        operatorList.addOp(_util.OPS.paintInlineImageXObject, [imgData]);
        return;
      }
      var nativeImageDecoderSupport = this.options.nativeImageDecoderSupport;
      var objId = 'img_' + this.idFactory.createObjId();
      operatorList.addDependency(objId);
      args = [objId, w, h];
      if (nativeImageDecoderSupport !== _util.NativeImageDecoding.NONE && !softMask && !mask && image instanceof _stream.JpegStream && NativeImageDecoder.isSupported(image, this.xref, resources)) {
        operatorList.addOp(_util.OPS.paintJpegXObject, args);
        this.handler.send('obj', [objId, this.pageIndex, 'JpegStream', image.getIR(this.options.forceDataSchema)]);
        if (cacheKey) {
          imageCache[cacheKey] = {
            fn: _util.OPS.paintJpegXObject,
            args: args
          };
        }
        return;
      }
      var nativeImageDecoder = null;
      if (nativeImageDecoderSupport === _util.NativeImageDecoding.DECODE && (image instanceof _stream.JpegStream || mask instanceof _stream.JpegStream || softMask instanceof _stream.JpegStream)) {
        nativeImageDecoder = new NativeImageDecoder(this.xref, resources, this.handler, this.options.forceDataSchema);
      }
      _image.PDFImage.buildImage(this.handler, this.xref, resources, image, inline, nativeImageDecoder).then(function (imageObj) {
        var imgData = imageObj.createImageData(false);
        _this2.handler.send('obj', [objId, _this2.pageIndex, 'Image', imgData], [imgData.data.buffer]);
      }).catch(function (reason) {
        (0, _util.warn)('Unable to decode image: ' + reason);
        _this2.handler.send('obj', [objId, _this2.pageIndex, 'Image', null]);
      });
      operatorList.addOp(_util.OPS.paintImageXObject, args);
      if (cacheKey) {
        imageCache[cacheKey] = {
          fn: _util.OPS.paintImageXObject,
          args: args
        };
      }
    },
    handleSMask: function PartialEvaluator_handleSmask(smask, resources, operatorList, task, stateManager) {
      var smaskContent = smask.get('G');
      var smaskOptions = {
        subtype: smask.get('S').name,
        backdrop: smask.get('BC')
      };
      var transferObj = smask.get('TR');
      if ((0, _function.isPDFFunction)(transferObj)) {
        var transferFn = _function.PDFFunction.parse(this.xref, transferObj);
        var transferMap = new Uint8Array(256);
        var tmp = new Float32Array(1);
        for (var i = 0; i < 256; i++) {
          tmp[0] = i / 255;
          transferFn(tmp, 0, tmp, 0);
          transferMap[i] = tmp[0] * 255 | 0;
        }
        smaskOptions.transferMap = transferMap;
      }
      return this.buildFormXObject(resources, smaskContent, smaskOptions, operatorList, task, stateManager.state.clone());
    },
    handleTilingType: function handleTilingType(fn, args, resources, pattern, patternDict, operatorList, task) {
      var _this3 = this;

      var tilingOpList = new OperatorList();
      var resourcesArray = [patternDict.get('Resources'), resources];
      var patternResources = _primitives.Dict.merge(this.xref, resourcesArray);
      return this.getOperatorList({
        stream: pattern,
        task: task,
        resources: patternResources,
        operatorList: tilingOpList
      }).then(function () {
        return (0, _pattern.getTilingPatternIR)({
          fnArray: tilingOpList.fnArray,
          argsArray: tilingOpList.argsArray
        }, patternDict, args);
      }).then(function (tilingPatternIR) {
        operatorList.addDependencies(tilingOpList.dependencies);
        operatorList.addOp(fn, tilingPatternIR);
      }, function (reason) {
        if (_this3.options.ignoreErrors) {
          _this3.handler.send('UnsupportedFeature', { featureId: _util.UNSUPPORTED_FEATURES.unknown });
          (0, _util.warn)('handleTilingType - ignoring pattern: "' + reason + '".');
          return;
        }
        throw reason;
      });
    },

    handleSetFont: function PartialEvaluator_handleSetFont(resources, fontArgs, fontRef, operatorList, task, state) {
      var _this4 = this;

      var fontName;
      if (fontArgs) {
        fontArgs = fontArgs.slice();
        fontName = fontArgs[0].name;
      }
      return this.loadFont(fontName, fontRef, resources).then(function (translated) {
        if (!translated.font.isType3Font) {
          return translated;
        }
        return translated.loadType3Data(_this4, resources, operatorList, task).then(function () {
          return translated;
        }).catch(function (reason) {
          _this4.handler.send('UnsupportedFeature', { featureId: _util.UNSUPPORTED_FEATURES.font });
          return new TranslatedFont('g_font_error', new _fonts.ErrorFont('Type3 font load error: ' + reason), translated.font);
        });
      }).then(function (translated) {
        state.font = translated.font;
        translated.send(_this4.handler);
        return translated.loadedName;
      });
    },
    handleText: function PartialEvaluator_handleText(chars, state) {
      var _this5 = this;

      var font = state.font;
      var glyphs = font.charsToGlyphs(chars);
      var isAddToPathSet = !!(state.textRenderingMode & _util.TextRenderingMode.ADD_TO_PATH_FLAG);
      if (font.data && (isAddToPathSet || this.options.disableFontFace)) {
        var buildPath = function buildPath(fontChar) {
          if (!font.renderer.hasBuiltPath(fontChar)) {
            var path = font.renderer.getPathJs(fontChar);
            _this5.handler.send('commonobj', [font.loadedName + '_path_' + fontChar, 'FontPath', path]);
          }
        };
        for (var i = 0, ii = glyphs.length; i < ii; i++) {
          var glyph = glyphs[i];
          buildPath(glyph.fontChar);
          var accent = glyph.accent;
          if (accent && accent.fontChar) {
            buildPath(accent.fontChar);
          }
        }
      }
      return glyphs;
    },
    setGState: function PartialEvaluator_setGState(resources, gState, operatorList, task, stateManager) {
      var _this6 = this;

      var gStateObj = [];
      var gStateKeys = gState.getKeys();
      var promise = Promise.resolve();

      var _loop = function _loop() {
        var key = gStateKeys[i];
        var value = gState.get(key);
        switch (key) {
          case 'Type':
            break;
          case 'LW':
          case 'LC':
          case 'LJ':
          case 'ML':
          case 'D':
          case 'RI':
          case 'FL':
          case 'CA':
          case 'ca':
            gStateObj.push([key, value]);
            break;
          case 'Font':
            promise = promise.then(function () {
              return _this6.handleSetFont(resources, null, value[0], operatorList, task, stateManager.state).then(function (loadedName) {
                operatorList.addDependency(loadedName);
                gStateObj.push([key, [loadedName, value[1]]]);
              });
            });
            break;
          case 'BM':
            gStateObj.push([key, normalizeBlendMode(value)]);
            break;
          case 'SMask':
            if ((0, _primitives.isName)(value, 'None')) {
              gStateObj.push([key, false]);
              break;
            }
            if ((0, _primitives.isDict)(value)) {
              promise = promise.then(function () {
                return _this6.handleSMask(value, resources, operatorList, task, stateManager);
              });
              gStateObj.push([key, true]);
            } else {
              (0, _util.warn)('Unsupported SMask type');
            }
            break;
          case 'OP':
          case 'op':
          case 'OPM':
          case 'BG':
          case 'BG2':
          case 'UCR':
          case 'UCR2':
          case 'TR':
          case 'TR2':
          case 'HT':
          case 'SM':
          case 'SA':
          case 'AIS':
          case 'TK':
            (0, _util.info)('graphic state operator ' + key);
            break;
          default:
            (0, _util.info)('Unknown graphic state operator ' + key);
            break;
        }
      };

      for (var i = 0, ii = gStateKeys.length; i < ii; i++) {
        _loop();
      }
      return promise.then(function () {
        if (gStateObj.length > 0) {
          operatorList.addOp(_util.OPS.setGState, [gStateObj]);
        }
      });
    },
    loadFont: function PartialEvaluator_loadFont(fontName, font, resources) {
      var _this7 = this;

      function errorFont() {
        return Promise.resolve(new TranslatedFont('g_font_error', new _fonts.ErrorFont('Font ' + fontName + ' is not available'), font));
      }
      var fontRef,
          xref = this.xref;
      if (font) {
        if (!(0, _primitives.isRef)(font)) {
          throw new Error('The "font" object should be a reference.');
        }
        fontRef = font;
      } else {
        var fontRes = resources.get('Font');
        if (fontRes) {
          fontRef = fontRes.getRaw(fontName);
        } else {
          (0, _util.warn)('fontRes not available');
          return errorFont();
        }
      }
      if (!fontRef) {
        (0, _util.warn)('fontRef not available');
        return errorFont();
      }
      if (this.fontCache.has(fontRef)) {
        return this.fontCache.get(fontRef);
      }
      font = xref.fetchIfRef(fontRef);
      if (!(0, _primitives.isDict)(font)) {
        return errorFont();
      }
      if (font.translated) {
        return font.translated;
      }
      var fontCapability = (0, _util.createPromiseCapability)();
      var preEvaluatedFont = this.preEvaluateFont(font);
      var descriptor = preEvaluatedFont.descriptor;
      var fontRefIsRef = (0, _primitives.isRef)(fontRef),
          fontID;
      if (fontRefIsRef) {
        fontID = fontRef.toString();
      }
      if ((0, _primitives.isDict)(descriptor)) {
        if (!descriptor.fontAliases) {
          descriptor.fontAliases = Object.create(null);
        }
        var fontAliases = descriptor.fontAliases;
        var hash = preEvaluatedFont.hash;
        if (fontAliases[hash]) {
          var aliasFontRef = fontAliases[hash].aliasRef;
          if (fontRefIsRef && aliasFontRef && this.fontCache.has(aliasFontRef)) {
            this.fontCache.putAlias(fontRef, aliasFontRef);
            return this.fontCache.get(fontRef);
          }
        } else {
          fontAliases[hash] = { fontID: _fonts.Font.getFontID() };
        }
        if (fontRefIsRef) {
          fontAliases[hash].aliasRef = fontRef;
        }
        fontID = fontAliases[hash].fontID;
      }
      if (fontRefIsRef) {
        this.fontCache.put(fontRef, fontCapability.promise);
      } else {
        if (!fontID) {
          fontID = this.idFactory.createObjId();
        }
        this.fontCache.put('id_' + fontID, fontCapability.promise);
      }
      (0, _util.assert)(fontID, 'The "fontID" must be defined.');
      font.loadedName = 'g_' + this.pdfManager.docId + '_f' + fontID;
      font.translated = fontCapability.promise;
      var translatedPromise;
      try {
        translatedPromise = this.translateFont(preEvaluatedFont);
      } catch (e) {
        translatedPromise = Promise.reject(e);
      }
      translatedPromise.then(function (translatedFont) {
        if (translatedFont.fontType !== undefined) {
          var xrefFontStats = xref.stats.fontTypes;
          xrefFontStats[translatedFont.fontType] = true;
        }
        fontCapability.resolve(new TranslatedFont(font.loadedName, translatedFont, font));
      }).catch(function (reason) {
        _this7.handler.send('UnsupportedFeature', { featureId: _util.UNSUPPORTED_FEATURES.font });
        try {
          var descriptor = preEvaluatedFont.descriptor;
          var fontFile3 = descriptor && descriptor.get('FontFile3');
          var subtype = fontFile3 && fontFile3.get('Subtype');
          var fontType = (0, _fonts.getFontType)(preEvaluatedFont.type, subtype && subtype.name);
          var xrefFontStats = xref.stats.fontTypes;
          xrefFontStats[fontType] = true;
        } catch (ex) {}
        fontCapability.resolve(new TranslatedFont(font.loadedName, new _fonts.ErrorFont(reason instanceof Error ? reason.message : reason), font));
      });
      return fontCapability.promise;
    },
    buildPath: function PartialEvaluator_buildPath(operatorList, fn, args) {
      var lastIndex = operatorList.length - 1;
      if (!args) {
        args = [];
      }
      if (lastIndex < 0 || operatorList.fnArray[lastIndex] !== _util.OPS.constructPath) {
        operatorList.addOp(_util.OPS.constructPath, [[fn], args]);
      } else {
        var opArgs = operatorList.argsArray[lastIndex];
        opArgs[0].push(fn);
        Array.prototype.push.apply(opArgs[1], args);
      }
    },
    handleColorN: function PartialEvaluator_handleColorN(operatorList, fn, args, cs, patterns, resources, task) {
      var patternName = args[args.length - 1];
      var pattern;
      if ((0, _primitives.isName)(patternName) && (pattern = patterns.get(patternName.name))) {
        var dict = (0, _primitives.isStream)(pattern) ? pattern.dict : pattern;
        var typeNum = dict.get('PatternType');
        if (typeNum === TILING_PATTERN) {
          var color = cs.base ? cs.base.getRgb(args, 0) : null;
          return this.handleTilingType(fn, color, resources, pattern, dict, operatorList, task);
        } else if (typeNum === SHADING_PATTERN) {
          var shading = dict.get('Shading');
          var matrix = dict.getArray('Matrix');
          pattern = _pattern.Pattern.parseShading(shading, matrix, this.xref, resources, this.handler);
          operatorList.addOp(fn, pattern.getIR());
          return Promise.resolve();
        }
        return Promise.reject(new Error('Unknown PatternType: ' + typeNum));
      }
      operatorList.addOp(fn, args);
      return Promise.resolve();
    },
    getOperatorList: function getOperatorList(_ref2) {
      var _this8 = this;

      var stream = _ref2.stream,
          task = _ref2.task,
          resources = _ref2.resources,
          operatorList = _ref2.operatorList,
          _ref2$initialState = _ref2.initialState,
          initialState = _ref2$initialState === undefined ? null : _ref2$initialState;

      resources = resources || _primitives.Dict.empty;
      initialState = initialState || new EvalState();
      if (!operatorList) {
        throw new Error('getOperatorList: missing "operatorList" parameter');
      }
      var self = this;
      var xref = this.xref;
      var imageCache = Object.create(null);
      var xobjs = resources.get('XObject') || _primitives.Dict.empty;
      var patterns = resources.get('Pattern') || _primitives.Dict.empty;
      var stateManager = new StateManager(initialState);
      var preprocessor = new EvaluatorPreprocessor(stream, xref, stateManager);
      var timeSlotManager = new TimeSlotManager();
      function closePendingRestoreOPS(argument) {
        for (var i = 0, ii = preprocessor.savedStatesDepth; i < ii; i++) {
          operatorList.addOp(_util.OPS.restore, []);
        }
      }
      return new Promise(function promiseBody(resolve, reject) {
        var next = function next(promise) {
          promise.then(function () {
            try {
              promiseBody(resolve, reject);
            } catch (ex) {
              reject(ex);
            }
          }, reject);
        };
        task.ensureNotTerminated();
        timeSlotManager.reset();
        var stop,
            operation = {},
            i,
            ii,
            cs;
        while (!(stop = timeSlotManager.check())) {
          operation.args = null;
          if (!preprocessor.read(operation)) {
            break;
          }
          var args = operation.args;
          var fn = operation.fn;
          switch (fn | 0) {
            case _util.OPS.paintXObject:
              var name = args[0].name;
              if (!name) {
                (0, _util.warn)('XObject must be referred to by name.');
                continue;
              }
              if (imageCache[name] !== undefined) {
                operatorList.addOp(imageCache[name].fn, imageCache[name].args);
                args = null;
                continue;
              }
              var xobj = xobjs.get(name);
              if (xobj) {
                if (!(0, _primitives.isStream)(xobj)) {
                  throw new _util.FormatError('XObject should be a stream');
                }
                var type = xobj.dict.get('Subtype');
                if (!(0, _primitives.isName)(type)) {
                  throw new _util.FormatError('XObject should have a Name subtype');
                }
                if (type.name === 'Form') {
                  stateManager.save();
                  next(self.buildFormXObject(resources, xobj, null, operatorList, task, stateManager.state.clone()).then(function () {
                    stateManager.restore();
                  }));
                  return;
                } else if (type.name === 'Image') {
                  self.buildPaintImageXObject(resources, xobj, false, operatorList, name, imageCache);
                  args = null;
                  continue;
                } else if (type.name === 'PS') {
                  (0, _util.info)('Ignored XObject subtype PS');
                  continue;
                } else {
                  throw new _util.FormatError('Unhandled XObject subtype ' + type.name);
                }
              }
              break;
            case _util.OPS.setFont:
              var fontSize = args[1];
              next(self.handleSetFont(resources, args, null, operatorList, task, stateManager.state).then(function (loadedName) {
                operatorList.addDependency(loadedName);
                operatorList.addOp(_util.OPS.setFont, [loadedName, fontSize]);
              }));
              return;
            case _util.OPS.endInlineImage:
              var cacheKey = args[0].cacheKey;
              if (cacheKey) {
                var cacheEntry = imageCache[cacheKey];
                if (cacheEntry !== undefined) {
                  operatorList.addOp(cacheEntry.fn, cacheEntry.args);
                  args = null;
                  continue;
                }
              }
              self.buildPaintImageXObject(resources, args[0], true, operatorList, cacheKey, imageCache);
              args = null;
              continue;
            case _util.OPS.showText:
              args[0] = self.handleText(args[0], stateManager.state);
              break;
            case _util.OPS.showSpacedText:
              var arr = args[0];
              var combinedGlyphs = [];
              var arrLength = arr.length;
              var state = stateManager.state;
              for (i = 0; i < arrLength; ++i) {
                var arrItem = arr[i];
                if ((0, _util.isString)(arrItem)) {
                  Array.prototype.push.apply(combinedGlyphs, self.handleText(arrItem, state));
                } else if ((0, _util.isNum)(arrItem)) {
                  combinedGlyphs.push(arrItem);
                }
              }
              args[0] = combinedGlyphs;
              fn = _util.OPS.showText;
              break;
            case _util.OPS.nextLineShowText:
              operatorList.addOp(_util.OPS.nextLine);
              args[0] = self.handleText(args[0], stateManager.state);
              fn = _util.OPS.showText;
              break;
            case _util.OPS.nextLineSetSpacingShowText:
              operatorList.addOp(_util.OPS.nextLine);
              operatorList.addOp(_util.OPS.setWordSpacing, [args.shift()]);
              operatorList.addOp(_util.OPS.setCharSpacing, [args.shift()]);
              args[0] = self.handleText(args[0], stateManager.state);
              fn = _util.OPS.showText;
              break;
            case _util.OPS.setTextRenderingMode:
              stateManager.state.textRenderingMode = args[0];
              break;
            case _util.OPS.setFillColorSpace:
              stateManager.state.fillColorSpace = _colorspace.ColorSpace.parse(args[0], xref, resources);
              continue;
            case _util.OPS.setStrokeColorSpace:
              stateManager.state.strokeColorSpace = _colorspace.ColorSpace.parse(args[0], xref, resources);
              continue;
            case _util.OPS.setFillColor:
              cs = stateManager.state.fillColorSpace;
              args = cs.getRgb(args, 0);
              fn = _util.OPS.setFillRGBColor;
              break;
            case _util.OPS.setStrokeColor:
              cs = stateManager.state.strokeColorSpace;
              args = cs.getRgb(args, 0);
              fn = _util.OPS.setStrokeRGBColor;
              break;
            case _util.OPS.setFillGray:
              stateManager.state.fillColorSpace = _colorspace.ColorSpace.singletons.gray;
              args = _colorspace.ColorSpace.singletons.gray.getRgb(args, 0);
              fn = _util.OPS.setFillRGBColor;
              break;
            case _util.OPS.setStrokeGray:
              stateManager.state.strokeColorSpace = _colorspace.ColorSpace.singletons.gray;
              args = _colorspace.ColorSpace.singletons.gray.getRgb(args, 0);
              fn = _util.OPS.setStrokeRGBColor;
              break;
            case _util.OPS.setFillCMYKColor:
              stateManager.state.fillColorSpace = _colorspace.ColorSpace.singletons.cmyk;
              args = _colorspace.ColorSpace.singletons.cmyk.getRgb(args, 0);
              fn = _util.OPS.setFillRGBColor;
              break;
            case _util.OPS.setStrokeCMYKColor:
              stateManager.state.strokeColorSpace = _colorspace.ColorSpace.singletons.cmyk;
              args = _colorspace.ColorSpace.singletons.cmyk.getRgb(args, 0);
              fn = _util.OPS.setStrokeRGBColor;
              break;
            case _util.OPS.setFillRGBColor:
              stateManager.state.fillColorSpace = _colorspace.ColorSpace.singletons.rgb;
              args = _colorspace.ColorSpace.singletons.rgb.getRgb(args, 0);
              break;
            case _util.OPS.setStrokeRGBColor:
              stateManager.state.strokeColorSpace = _colorspace.ColorSpace.singletons.rgb;
              args = _colorspace.ColorSpace.singletons.rgb.getRgb(args, 0);
              break;
            case _util.OPS.setFillColorN:
              cs = stateManager.state.fillColorSpace;
              if (cs.name === 'Pattern') {
                next(self.handleColorN(operatorList, _util.OPS.setFillColorN, args, cs, patterns, resources, task));
                return;
              }
              args = cs.getRgb(args, 0);
              fn = _util.OPS.setFillRGBColor;
              break;
            case _util.OPS.setStrokeColorN:
              cs = stateManager.state.strokeColorSpace;
              if (cs.name === 'Pattern') {
                next(self.handleColorN(operatorList, _util.OPS.setStrokeColorN, args, cs, patterns, resources, task));
                return;
              }
              args = cs.getRgb(args, 0);
              fn = _util.OPS.setStrokeRGBColor;
              break;
            case _util.OPS.shadingFill:
              var shadingRes = resources.get('Shading');
              if (!shadingRes) {
                throw new _util.FormatError('No shading resource found');
              }
              var shading = shadingRes.get(args[0].name);
              if (!shading) {
                throw new _util.FormatError('No shading object found');
              }
              var shadingFill = _pattern.Pattern.parseShading(shading, null, xref, resources, self.handler);
              var patternIR = shadingFill.getIR();
              args = [patternIR];
              fn = _util.OPS.shadingFill;
              break;
            case _util.OPS.setGState:
              var dictName = args[0];
              var extGState = resources.get('ExtGState');
              if (!(0, _primitives.isDict)(extGState) || !extGState.has(dictName.name)) {
                break;
              }
              var gState = extGState.get(dictName.name);
              next(self.setGState(resources, gState, operatorList, task, stateManager));
              return;
            case _util.OPS.moveTo:
            case _util.OPS.lineTo:
            case _util.OPS.curveTo:
            case _util.OPS.curveTo2:
            case _util.OPS.curveTo3:
            case _util.OPS.closePath:
              self.buildPath(operatorList, fn, args);
              continue;
            case _util.OPS.rectangle:
              self.buildPath(operatorList, fn, args);
              continue;
            case _util.OPS.markPoint:
            case _util.OPS.markPointProps:
            case _util.OPS.beginMarkedContent:
            case _util.OPS.beginMarkedContentProps:
            case _util.OPS.endMarkedContent:
            case _util.OPS.beginCompat:
            case _util.OPS.endCompat:
              continue;
            default:
              if (args !== null) {
                for (i = 0, ii = args.length; i < ii; i++) {
                  if (args[i] instanceof _primitives.Dict) {
                    break;
                  }
                }
                if (i < ii) {
                  (0, _util.warn)('getOperatorList - ignoring operator: ' + fn);
                  continue;
                }
              }
          }
          operatorList.addOp(fn, args);
        }
        if (stop) {
          next(deferred);
          return;
        }
        closePendingRestoreOPS();
        resolve();
      }).catch(function (reason) {
        if (_this8.options.ignoreErrors) {
          _this8.handler.send('UnsupportedFeature', { featureId: _util.UNSUPPORTED_FEATURES.unknown });
          (0, _util.warn)('getOperatorList - ignoring errors during task: ' + task.name);
          closePendingRestoreOPS();
          return;
        }
        throw reason;
      });
    },
    getTextContent: function getTextContent(_ref3) {
      var _this9 = this;

      var stream = _ref3.stream,
          task = _ref3.task,
          resources = _ref3.resources,
          _ref3$stateManager = _ref3.stateManager,
          stateManager = _ref3$stateManager === undefined ? null : _ref3$stateManager,
          _ref3$normalizeWhites = _ref3.normalizeWhitespace,
          normalizeWhitespace = _ref3$normalizeWhites === undefined ? false : _ref3$normalizeWhites,
          _ref3$combineTextItem = _ref3.combineTextItems,
          combineTextItems = _ref3$combineTextItem === undefined ? false : _ref3$combineTextItem,
          sink = _ref3.sink,
          _ref3$seenStyles = _ref3.seenStyles,
          seenStyles = _ref3$seenStyles === undefined ? Object.create(null) : _ref3$seenStyles;

      resources = resources || _primitives.Dict.empty;
      stateManager = stateManager || new StateManager(new TextState());
      var WhitespaceRegexp = /\s/g;
      var textContent = {
        items: [],
        styles: Object.create(null)
      };
      var textContentItem = {
        initialized: false,
        str: [],
        width: 0,
        height: 0,
        vertical: false,
        lastAdvanceWidth: 0,
        lastAdvanceHeight: 0,
        textAdvanceScale: 0,
        spaceWidth: 0,
        fakeSpaceMin: Infinity,
        fakeMultiSpaceMin: Infinity,
        fakeMultiSpaceMax: -0,
        textRunBreakAllowed: false,
        transform: null,
        fontName: null
      };
      var SPACE_FACTOR = 0.3;
      var MULTI_SPACE_FACTOR = 1.5;
      var MULTI_SPACE_FACTOR_MAX = 4;
      var self = this;
      var xref = this.xref;
      var xobjs = null;
      var skipEmptyXObjs = Object.create(null);
      var preprocessor = new EvaluatorPreprocessor(stream, xref, stateManager);
      var textState;
      function ensureTextContentItem() {
        if (textContentItem.initialized) {
          return textContentItem;
        }
        var font = textState.font;
        if (!(font.loadedName in seenStyles)) {
          seenStyles[font.loadedName] = true;
          textContent.styles[font.loadedName] = {
            fontFamily: font.fallbackName,
            ascent: font.ascent,
            descent: font.descent,
            vertical: font.vertical
          };
        }
        textContentItem.fontName = font.loadedName;
        var tsm = [textState.fontSize * textState.textHScale, 0, 0, textState.fontSize, 0, textState.textRise];
        if (font.isType3Font && textState.fontMatrix !== _util.FONT_IDENTITY_MATRIX && textState.fontSize === 1) {
          var glyphHeight = font.bbox[3] - font.bbox[1];
          if (glyphHeight > 0) {
            glyphHeight = glyphHeight * textState.fontMatrix[3];
            tsm[3] *= glyphHeight;
          }
        }
        var trm = _util.Util.transform(textState.ctm, _util.Util.transform(textState.textMatrix, tsm));
        textContentItem.transform = trm;
        if (!font.vertical) {
          textContentItem.width = 0;
          textContentItem.height = Math.sqrt(trm[2] * trm[2] + trm[3] * trm[3]);
          textContentItem.vertical = false;
        } else {
          textContentItem.width = Math.sqrt(trm[0] * trm[0] + trm[1] * trm[1]);
          textContentItem.height = 0;
          textContentItem.vertical = true;
        }
        var a = textState.textLineMatrix[0];
        var b = textState.textLineMatrix[1];
        var scaleLineX = Math.sqrt(a * a + b * b);
        a = textState.ctm[0];
        b = textState.ctm[1];
        var scaleCtmX = Math.sqrt(a * a + b * b);
        textContentItem.textAdvanceScale = scaleCtmX * scaleLineX;
        textContentItem.lastAdvanceWidth = 0;
        textContentItem.lastAdvanceHeight = 0;
        var spaceWidth = font.spaceWidth / 1000 * textState.fontSize;
        if (spaceWidth) {
          textContentItem.spaceWidth = spaceWidth;
          textContentItem.fakeSpaceMin = spaceWidth * SPACE_FACTOR;
          textContentItem.fakeMultiSpaceMin = spaceWidth * MULTI_SPACE_FACTOR;
          textContentItem.fakeMultiSpaceMax = spaceWidth * MULTI_SPACE_FACTOR_MAX;
          textContentItem.textRunBreakAllowed = !font.isMonospace;
        } else {
          textContentItem.spaceWidth = 0;
          textContentItem.fakeSpaceMin = Infinity;
          textContentItem.fakeMultiSpaceMin = Infinity;
          textContentItem.fakeMultiSpaceMax = 0;
          textContentItem.textRunBreakAllowed = false;
        }
        textContentItem.initialized = true;
        return textContentItem;
      }
      function replaceWhitespace(str) {
        var i = 0,
            ii = str.length,
            code;
        while (i < ii && (code = str.charCodeAt(i)) >= 0x20 && code <= 0x7F) {
          i++;
        }
        return i < ii ? str.replace(WhitespaceRegexp, ' ') : str;
      }
      function runBidiTransform(textChunk) {
        var str = textChunk.str.join('');
        var bidiResult = (0, _bidi.bidi)(str, -1, textChunk.vertical);
        return {
          str: normalizeWhitespace ? replaceWhitespace(bidiResult.str) : bidiResult.str,
          dir: bidiResult.dir,
          width: textChunk.width,
          height: textChunk.height,
          transform: textChunk.transform,
          fontName: textChunk.fontName
        };
      }
      function handleSetFont(fontName, fontRef) {
        return self.loadFont(fontName, fontRef, resources).then(function (translated) {
          textState.font = translated.font;
          textState.fontMatrix = translated.font.fontMatrix || _util.FONT_IDENTITY_MATRIX;
        });
      }
      function buildTextContentItem(chars) {
        var font = textState.font;
        var textChunk = ensureTextContentItem();
        var width = 0;
        var height = 0;
        var glyphs = font.charsToGlyphs(chars);
        for (var i = 0; i < glyphs.length; i++) {
          var glyph = glyphs[i];
          var glyphWidth = null;
          if (font.vertical && glyph.vmetric) {
            glyphWidth = glyph.vmetric[0];
          } else {
            glyphWidth = glyph.width;
          }
          var glyphUnicode = glyph.unicode;
          var NormalizedUnicodes = (0, _unicode.getNormalizedUnicodes)();
          if (NormalizedUnicodes[glyphUnicode] !== undefined) {
            glyphUnicode = NormalizedUnicodes[glyphUnicode];
          }
          glyphUnicode = (0, _unicode.reverseIfRtl)(glyphUnicode);
          var charSpacing = textState.charSpacing;
          if (glyph.isSpace) {
            var wordSpacing = textState.wordSpacing;
            charSpacing += wordSpacing;
            if (wordSpacing > 0) {
              addFakeSpaces(wordSpacing, textChunk.str);
            }
          }
          var tx = 0;
          var ty = 0;
          if (!font.vertical) {
            var w0 = glyphWidth * textState.fontMatrix[0];
            tx = (w0 * textState.fontSize + charSpacing) * textState.textHScale;
            width += tx;
          } else {
            var w1 = glyphWidth * textState.fontMatrix[0];
            ty = w1 * textState.fontSize + charSpacing;
            height += ty;
          }
          textState.translateTextMatrix(tx, ty);
          textChunk.str.push(glyphUnicode);
        }
        if (!font.vertical) {
          textChunk.lastAdvanceWidth = width;
          textChunk.width += width;
        } else {
          textChunk.lastAdvanceHeight = height;
          textChunk.height += Math.abs(height);
        }
        return textChunk;
      }
      function addFakeSpaces(width, strBuf) {
        if (width < textContentItem.fakeSpaceMin) {
          return;
        }
        if (width < textContentItem.fakeMultiSpaceMin) {
          strBuf.push(' ');
          return;
        }
        var fakeSpaces = Math.round(width / textContentItem.spaceWidth);
        while (fakeSpaces-- > 0) {
          strBuf.push(' ');
        }
      }
      function flushTextContentItem() {
        if (!textContentItem.initialized) {
          return;
        }
        textContentItem.width *= textContentItem.textAdvanceScale;
        textContentItem.height *= textContentItem.textAdvanceScale;
        textContent.items.push(runBidiTransform(textContentItem));
        textContentItem.initialized = false;
        textContentItem.str.length = 0;
      }
      function enqueueChunk() {
        var length = textContent.items.length;
        if (length > 0) {
          sink.enqueue(textContent, length);
          textContent.items = [];
          textContent.styles = Object.create(null);
        }
      }
      var timeSlotManager = new TimeSlotManager();
      return new Promise(function promiseBody(resolve, reject) {
        var next = function next(promise) {
          enqueueChunk();
          Promise.all([promise, sink.ready]).then(function () {
            try {
              promiseBody(resolve, reject);
            } catch (ex) {
              reject(ex);
            }
          }, reject);
        };
        task.ensureNotTerminated();
        timeSlotManager.reset();
        var stop,
            operation = {},
            args = [];
        while (!(stop = timeSlotManager.check())) {
          args.length = 0;
          operation.args = args;
          if (!preprocessor.read(operation)) {
            break;
          }
          textState = stateManager.state;
          var fn = operation.fn;
          args = operation.args;
          var advance, diff;
          var fontNameArg, fontSizeArg;
          var isSameTextLine;
          var items;
          var offset;
          var j, jj;
          var breakTextRun;
          var name;
          var xobj;
          var type;
          var currentState;
          var xObjStateManager;
          var matrix;
          var dictName;
          var extGState;
          var gState;
          var gStateFont;

          var _ret2 = function () {
            switch (fn | 0) {
              case _util.OPS.setFont:
                fontNameArg = args[0].name;
                fontSizeArg = args[1];

                if (textState.font && fontNameArg === textState.fontName && fontSizeArg === textState.fontSize) {
                  break;
                }
                flushTextContentItem();
                textState.fontName = fontNameArg;
                textState.fontSize = fontSizeArg;
                next(handleSetFont(fontNameArg, null));
                return {
                  v: void 0
                };
              case _util.OPS.setTextRise:
                flushTextContentItem();
                textState.textRise = args[0];
                break;
              case _util.OPS.setHScale:
                flushTextContentItem();
                textState.textHScale = args[0] / 100;
                break;
              case _util.OPS.setLeading:
                flushTextContentItem();
                textState.leading = args[0];
                break;
              case _util.OPS.moveText:
                isSameTextLine = !textState.font ? false : (textState.font.vertical ? args[0] : args[1]) === 0;

                advance = args[0] - args[1];
                if (combineTextItems && isSameTextLine && textContentItem.initialized && advance > 0 && advance <= textContentItem.fakeMultiSpaceMax) {
                  textState.translateTextLineMatrix(args[0], args[1]);
                  textContentItem.width += args[0] - textContentItem.lastAdvanceWidth;
                  textContentItem.height += args[1] - textContentItem.lastAdvanceHeight;
                  diff = args[0] - textContentItem.lastAdvanceWidth - (args[1] - textContentItem.lastAdvanceHeight);
                  addFakeSpaces(diff, textContentItem.str);
                  break;
                }
                flushTextContentItem();
                textState.translateTextLineMatrix(args[0], args[1]);
                textState.textMatrix = textState.textLineMatrix.slice();
                break;
              case _util.OPS.setLeadingMoveText:
                flushTextContentItem();
                textState.leading = -args[1];
                textState.translateTextLineMatrix(args[0], args[1]);
                textState.textMatrix = textState.textLineMatrix.slice();
                break;
              case _util.OPS.nextLine:
                flushTextContentItem();
                textState.carriageReturn();
                break;
              case _util.OPS.setTextMatrix:
                advance = textState.calcTextLineMatrixAdvance(args[0], args[1], args[2], args[3], args[4], args[5]);
                if (combineTextItems && advance !== null && textContentItem.initialized && advance.value > 0 && advance.value <= textContentItem.fakeMultiSpaceMax) {
                  textState.translateTextLineMatrix(advance.width, advance.height);
                  textContentItem.width += advance.width - textContentItem.lastAdvanceWidth;
                  textContentItem.height += advance.height - textContentItem.lastAdvanceHeight;
                  diff = advance.width - textContentItem.lastAdvanceWidth - (advance.height - textContentItem.lastAdvanceHeight);
                  addFakeSpaces(diff, textContentItem.str);
                  break;
                }
                flushTextContentItem();
                textState.setTextMatrix(args[0], args[1], args[2], args[3], args[4], args[5]);
                textState.setTextLineMatrix(args[0], args[1], args[2], args[3], args[4], args[5]);
                break;
              case _util.OPS.setCharSpacing:
                textState.charSpacing = args[0];
                break;
              case _util.OPS.setWordSpacing:
                textState.wordSpacing = args[0];
                break;
              case _util.OPS.beginText:
                flushTextContentItem();
                textState.textMatrix = _util.IDENTITY_MATRIX.slice();
                textState.textLineMatrix = _util.IDENTITY_MATRIX.slice();
                break;
              case _util.OPS.showSpacedText:
                items = args[0];

                for (j = 0, jj = items.length; j < jj; j++) {
                  if (typeof items[j] === 'string') {
                    buildTextContentItem(items[j]);
                  } else if ((0, _util.isNum)(items[j])) {
                    ensureTextContentItem();
                    advance = items[j] * textState.fontSize / 1000;
                    breakTextRun = false;

                    if (textState.font.vertical) {
                      offset = advance;
                      textState.translateTextMatrix(0, offset);
                      breakTextRun = textContentItem.textRunBreakAllowed && advance > textContentItem.fakeMultiSpaceMax;
                      if (!breakTextRun) {
                        textContentItem.height += offset;
                      }
                    } else {
                      advance = -advance;
                      offset = advance * textState.textHScale;
                      textState.translateTextMatrix(offset, 0);
                      breakTextRun = textContentItem.textRunBreakAllowed && advance > textContentItem.fakeMultiSpaceMax;
                      if (!breakTextRun) {
                        textContentItem.width += offset;
                      }
                    }
                    if (breakTextRun) {
                      flushTextContentItem();
                    } else if (advance > 0) {
                      addFakeSpaces(advance, textContentItem.str);
                    }
                  }
                }
                break;
              case _util.OPS.showText:
                buildTextContentItem(args[0]);
                break;
              case _util.OPS.nextLineShowText:
                flushTextContentItem();
                textState.carriageReturn();
                buildTextContentItem(args[0]);
                break;
              case _util.OPS.nextLineSetSpacingShowText:
                flushTextContentItem();
                textState.wordSpacing = args[0];
                textState.charSpacing = args[1];
                textState.carriageReturn();
                buildTextContentItem(args[2]);
                break;
              case _util.OPS.paintXObject:
                flushTextContentItem();
                if (!xobjs) {
                  xobjs = resources.get('XObject') || _primitives.Dict.empty;
                }
                name = args[0].name;

                if (name in skipEmptyXObjs) {
                  break;
                }
                xobj = xobjs.get(name);

                if (!xobj) {
                  break;
                }
                if (!(0, _primitives.isStream)(xobj)) {
                  throw new _util.FormatError('XObject should be a stream');
                }
                type = xobj.dict.get('Subtype');

                if (!(0, _primitives.isName)(type)) {
                  throw new _util.FormatError('XObject should have a Name subtype');
                }
                if (type.name !== 'Form') {
                  skipEmptyXObjs[name] = true;
                  break;
                }
                currentState = stateManager.state.clone();
                xObjStateManager = new StateManager(currentState);
                matrix = xobj.dict.getArray('Matrix');

                if ((0, _util.isArray)(matrix) && matrix.length === 6) {
                  xObjStateManager.transform(matrix);
                }
                enqueueChunk();
                var sinkWrapper = {
                  enqueueInvoked: false,
                  enqueue: function enqueue(chunk, size) {
                    this.enqueueInvoked = true;
                    sink.enqueue(chunk, size);
                  },

                  get desiredSize() {
                    return sink.desiredSize;
                  },
                  get ready() {
                    return sink.ready;
                  }
                };
                next(self.getTextContent({
                  stream: xobj,
                  task: task,
                  resources: xobj.dict.get('Resources') || resources,
                  stateManager: xObjStateManager,
                  normalizeWhitespace: normalizeWhitespace,
                  combineTextItems: combineTextItems,
                  sink: sinkWrapper,
                  seenStyles: seenStyles
                }).then(function () {
                  if (!sinkWrapper.enqueueInvoked) {
                    skipEmptyXObjs[name] = true;
                  }
                }));
                return {
                  v: void 0
                };
              case _util.OPS.setGState:
                flushTextContentItem();
                dictName = args[0];
                extGState = resources.get('ExtGState');

                if (!(0, _primitives.isDict)(extGState) || !(0, _primitives.isName)(dictName)) {
                  break;
                }
                gState = extGState.get(dictName.name);

                if (!(0, _primitives.isDict)(gState)) {
                  break;
                }
                gStateFont = gState.get('Font');

                if (gStateFont) {
                  textState.fontName = null;
                  textState.fontSize = gStateFont[1];
                  next(handleSetFont(null, gStateFont[0]));
                  return {
                    v: void 0
                  };
                }
                break;
            }
          }();

          if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
          if (textContent.items.length >= sink.desiredSize) {
            stop = true;
            break;
          }
        }
        if (stop) {
          next(deferred);
          return;
        }
        flushTextContentItem();
        enqueueChunk();
        resolve();
      }).catch(function (reason) {
        if (reason instanceof _util.AbortException) {
          return;
        }
        if (_this9.options.ignoreErrors) {
          (0, _util.warn)('getTextContent - ignoring errors during task: ' + task.name);
          flushTextContentItem();
          enqueueChunk();
          return;
        }
        throw reason;
      });
    },

    extractDataStructures: function PartialEvaluator_extractDataStructures(dict, baseDict, properties) {
      var _this10 = this;

      var xref = this.xref;
      var toUnicode = dict.get('ToUnicode') || baseDict.get('ToUnicode');
      var toUnicodePromise = toUnicode ? this.readToUnicode(toUnicode) : Promise.resolve(undefined);
      if (properties.composite) {
        var cidSystemInfo = dict.get('CIDSystemInfo');
        if ((0, _primitives.isDict)(cidSystemInfo)) {
          properties.cidSystemInfo = {
            registry: cidSystemInfo.get('Registry'),
            ordering: cidSystemInfo.get('Ordering'),
            supplement: cidSystemInfo.get('Supplement')
          };
        }
        var cidToGidMap = dict.get('CIDToGIDMap');
        if ((0, _primitives.isStream)(cidToGidMap)) {
          properties.cidToGidMap = this.readCidToGidMap(cidToGidMap);
        }
      }
      var differences = [];
      var baseEncodingName = null;
      var encoding;
      if (dict.has('Encoding')) {
        encoding = dict.get('Encoding');
        if ((0, _primitives.isDict)(encoding)) {
          baseEncodingName = encoding.get('BaseEncoding');
          baseEncodingName = (0, _primitives.isName)(baseEncodingName) ? baseEncodingName.name : null;
          if (encoding.has('Differences')) {
            var diffEncoding = encoding.get('Differences');
            var index = 0;
            for (var j = 0, jj = diffEncoding.length; j < jj; j++) {
              var data = xref.fetchIfRef(diffEncoding[j]);
              if ((0, _util.isNum)(data)) {
                index = data;
              } else if ((0, _primitives.isName)(data)) {
                differences[index++] = data.name;
              } else {
                throw new _util.FormatError('Invalid entry in \'Differences\' array: ' + data);
              }
            }
          }
        } else if ((0, _primitives.isName)(encoding)) {
          baseEncodingName = encoding.name;
        } else {
          throw new _util.FormatError('Encoding is not a Name nor a Dict');
        }
        if (baseEncodingName !== 'MacRomanEncoding' && baseEncodingName !== 'MacExpertEncoding' && baseEncodingName !== 'WinAnsiEncoding') {
          baseEncodingName = null;
        }
      }
      if (baseEncodingName) {
        properties.defaultEncoding = (0, _encodings.getEncoding)(baseEncodingName).slice();
      } else {
        var isSymbolicFont = !!(properties.flags & _fonts.FontFlags.Symbolic);
        var isNonsymbolicFont = !!(properties.flags & _fonts.FontFlags.Nonsymbolic);
        encoding = _encodings.StandardEncoding;
        if (properties.type === 'TrueType' && !isNonsymbolicFont) {
          encoding = _encodings.WinAnsiEncoding;
        }
        if (isSymbolicFont) {
          encoding = _encodings.MacRomanEncoding;
          if (!properties.file) {
            if (/Symbol/i.test(properties.name)) {
              encoding = _encodings.SymbolSetEncoding;
            } else if (/Dingbats/i.test(properties.name)) {
              encoding = _encodings.ZapfDingbatsEncoding;
            }
          }
        }
        properties.defaultEncoding = encoding;
      }
      properties.differences = differences;
      properties.baseEncodingName = baseEncodingName;
      properties.hasEncoding = !!baseEncodingName || differences.length > 0;
      properties.dict = dict;
      return toUnicodePromise.then(function (toUnicode) {
        properties.toUnicode = toUnicode;
        return _this10.buildToUnicode(properties);
      }).then(function (toUnicode) {
        properties.toUnicode = toUnicode;
        return properties;
      });
    },
    buildToUnicode: function PartialEvaluator_buildToUnicode(properties) {
      properties.hasIncludedToUnicodeMap = !!properties.toUnicode && properties.toUnicode.length > 0;
      if (properties.hasIncludedToUnicodeMap) {
        return Promise.resolve(properties.toUnicode);
      }
      var toUnicode, charcode, glyphName;
      if (!properties.composite) {
        toUnicode = [];
        var encoding = properties.defaultEncoding.slice();
        var baseEncodingName = properties.baseEncodingName;
        var differences = properties.differences;
        for (charcode in differences) {
          glyphName = differences[charcode];
          if (glyphName === '.notdef') {
            continue;
          }
          encoding[charcode] = glyphName;
        }
        var glyphsUnicodeMap = (0, _glyphlist.getGlyphsUnicode)();
        for (charcode in encoding) {
          glyphName = encoding[charcode];
          if (glyphName === '') {
            continue;
          } else if (glyphsUnicodeMap[glyphName] === undefined) {
            var code = 0;
            switch (glyphName[0]) {
              case 'G':
                if (glyphName.length === 3) {
                  code = parseInt(glyphName.substr(1), 16);
                }
                break;
              case 'g':
                if (glyphName.length === 5) {
                  code = parseInt(glyphName.substr(1), 16);
                }
                break;
              case 'C':
              case 'c':
                if (glyphName.length >= 3) {
                  code = +glyphName.substr(1);
                }
                break;
              default:
                var unicode = (0, _unicode.getUnicodeForGlyph)(glyphName, glyphsUnicodeMap);
                if (unicode !== -1) {
                  code = unicode;
                }
            }
            if (code) {
              if (baseEncodingName && code === +charcode) {
                var baseEncoding = (0, _encodings.getEncoding)(baseEncodingName);
                if (baseEncoding && (glyphName = baseEncoding[charcode])) {
                  toUnicode[charcode] = String.fromCharCode(glyphsUnicodeMap[glyphName]);
                  continue;
                }
              }
              toUnicode[charcode] = String.fromCharCode(code);
            }
            continue;
          }
          toUnicode[charcode] = String.fromCharCode(glyphsUnicodeMap[glyphName]);
        }
        return Promise.resolve(new _fonts.ToUnicodeMap(toUnicode));
      }
      if (properties.composite && (properties.cMap.builtInCMap && !(properties.cMap instanceof _cmap.IdentityCMap) || properties.cidSystemInfo.registry === 'Adobe' && (properties.cidSystemInfo.ordering === 'GB1' || properties.cidSystemInfo.ordering === 'CNS1' || properties.cidSystemInfo.ordering === 'Japan1' || properties.cidSystemInfo.ordering === 'Korea1'))) {
        var registry = properties.cidSystemInfo.registry;
        var ordering = properties.cidSystemInfo.ordering;
        var ucs2CMapName = _primitives.Name.get(registry + '-' + ordering + '-UCS2');
        return _cmap.CMapFactory.create({
          encoding: ucs2CMapName,
          fetchBuiltInCMap: this.fetchBuiltInCMap,
          useCMap: null
        }).then(function (ucs2CMap) {
          var cMap = properties.cMap;
          toUnicode = [];
          cMap.forEach(function (charcode, cid) {
            if (cid > 0xffff) {
              throw new _util.FormatError('Max size of CID is 65,535');
            }
            var ucs2 = ucs2CMap.lookup(cid);
            if (ucs2) {
              toUnicode[charcode] = String.fromCharCode((ucs2.charCodeAt(0) << 8) + ucs2.charCodeAt(1));
            }
          });
          return new _fonts.ToUnicodeMap(toUnicode);
        });
      }
      return Promise.resolve(new _fonts.IdentityToUnicodeMap(properties.firstChar, properties.lastChar));
    },
    readToUnicode: function PartialEvaluator_readToUnicode(toUnicode) {
      var cmapObj = toUnicode;
      if ((0, _primitives.isName)(cmapObj)) {
        return _cmap.CMapFactory.create({
          encoding: cmapObj,
          fetchBuiltInCMap: this.fetchBuiltInCMap,
          useCMap: null
        }).then(function (cmap) {
          if (cmap instanceof _cmap.IdentityCMap) {
            return new _fonts.IdentityToUnicodeMap(0, 0xFFFF);
          }
          return new _fonts.ToUnicodeMap(cmap.getMap());
        });
      } else if ((0, _primitives.isStream)(cmapObj)) {
        return _cmap.CMapFactory.create({
          encoding: cmapObj,
          fetchBuiltInCMap: this.fetchBuiltInCMap,
          useCMap: null
        }).then(function (cmap) {
          if (cmap instanceof _cmap.IdentityCMap) {
            return new _fonts.IdentityToUnicodeMap(0, 0xFFFF);
          }
          var map = new Array(cmap.length);
          cmap.forEach(function (charCode, token) {
            var str = [];
            for (var k = 0; k < token.length; k += 2) {
              var w1 = token.charCodeAt(k) << 8 | token.charCodeAt(k + 1);
              if ((w1 & 0xF800) !== 0xD800) {
                str.push(w1);
                continue;
              }
              k += 2;
              var w2 = token.charCodeAt(k) << 8 | token.charCodeAt(k + 1);
              str.push(((w1 & 0x3ff) << 10) + (w2 & 0x3ff) + 0x10000);
            }
            map[charCode] = String.fromCharCode.apply(String, str);
          });
          return new _fonts.ToUnicodeMap(map);
        });
      }
      return Promise.resolve(null);
    },
    readCidToGidMap: function PartialEvaluator_readCidToGidMap(cidToGidStream) {
      var glyphsData = cidToGidStream.getBytes();
      var result = [];
      for (var j = 0, jj = glyphsData.length; j < jj; j++) {
        var glyphID = glyphsData[j++] << 8 | glyphsData[j];
        if (glyphID === 0) {
          continue;
        }
        var code = j >> 1;
        result[code] = glyphID;
      }
      return result;
    },
    extractWidths: function PartialEvaluator_extractWidths(dict, descriptor, properties) {
      var xref = this.xref;
      var glyphsWidths = [];
      var defaultWidth = 0;
      var glyphsVMetrics = [];
      var defaultVMetrics;
      var i, ii, j, jj, start, code, widths;
      if (properties.composite) {
        defaultWidth = dict.get('DW') || 1000;
        widths = dict.get('W');
        if (widths) {
          for (i = 0, ii = widths.length; i < ii; i++) {
            start = xref.fetchIfRef(widths[i++]);
            code = xref.fetchIfRef(widths[i]);
            if ((0, _util.isArray)(code)) {
              for (j = 0, jj = code.length; j < jj; j++) {
                glyphsWidths[start++] = xref.fetchIfRef(code[j]);
              }
            } else {
              var width = xref.fetchIfRef(widths[++i]);
              for (j = start; j <= code; j++) {
                glyphsWidths[j] = width;
              }
            }
          }
        }
        if (properties.vertical) {
          var vmetrics = dict.getArray('DW2') || [880, -1000];
          defaultVMetrics = [vmetrics[1], defaultWidth * 0.5, vmetrics[0]];
          vmetrics = dict.get('W2');
          if (vmetrics) {
            for (i = 0, ii = vmetrics.length; i < ii; i++) {
              start = xref.fetchIfRef(vmetrics[i++]);
              code = xref.fetchIfRef(vmetrics[i]);
              if ((0, _util.isArray)(code)) {
                for (j = 0, jj = code.length; j < jj; j++) {
                  glyphsVMetrics[start++] = [xref.fetchIfRef(code[j++]), xref.fetchIfRef(code[j++]), xref.fetchIfRef(code[j])];
                }
              } else {
                var vmetric = [xref.fetchIfRef(vmetrics[++i]), xref.fetchIfRef(vmetrics[++i]), xref.fetchIfRef(vmetrics[++i])];
                for (j = start; j <= code; j++) {
                  glyphsVMetrics[j] = vmetric;
                }
              }
            }
          }
        }
      } else {
        var firstChar = properties.firstChar;
        widths = dict.get('Widths');
        if (widths) {
          j = firstChar;
          for (i = 0, ii = widths.length; i < ii; i++) {
            glyphsWidths[j++] = xref.fetchIfRef(widths[i]);
          }
          defaultWidth = parseFloat(descriptor.get('MissingWidth')) || 0;
        } else {
          var baseFontName = dict.get('BaseFont');
          if ((0, _primitives.isName)(baseFontName)) {
            var metrics = this.getBaseFontMetrics(baseFontName.name);
            glyphsWidths = this.buildCharCodeToWidth(metrics.widths, properties);
            defaultWidth = metrics.defaultWidth;
          }
        }
      }
      var isMonospace = true;
      var firstWidth = defaultWidth;
      for (var glyph in glyphsWidths) {
        var glyphWidth = glyphsWidths[glyph];
        if (!glyphWidth) {
          continue;
        }
        if (!firstWidth) {
          firstWidth = glyphWidth;
          continue;
        }
        if (firstWidth !== glyphWidth) {
          isMonospace = false;
          break;
        }
      }
      if (isMonospace) {
        properties.flags |= _fonts.FontFlags.FixedPitch;
      }
      properties.defaultWidth = defaultWidth;
      properties.widths = glyphsWidths;
      properties.defaultVMetrics = defaultVMetrics;
      properties.vmetrics = glyphsVMetrics;
    },
    isSerifFont: function PartialEvaluator_isSerifFont(baseFontName) {
      var fontNameWoStyle = baseFontName.split('-')[0];
      return fontNameWoStyle in (0, _standard_fonts.getSerifFonts)() || fontNameWoStyle.search(/serif/gi) !== -1;
    },
    getBaseFontMetrics: function PartialEvaluator_getBaseFontMetrics(name) {
      var defaultWidth = 0;
      var widths = [];
      var monospace = false;
      var stdFontMap = (0, _standard_fonts.getStdFontMap)();
      var lookupName = stdFontMap[name] || name;
      var Metrics = (0, _metrics.getMetrics)();
      if (!(lookupName in Metrics)) {
        if (this.isSerifFont(name)) {
          lookupName = 'Times-Roman';
        } else {
          lookupName = 'Helvetica';
        }
      }
      var glyphWidths = Metrics[lookupName];
      if ((0, _util.isNum)(glyphWidths)) {
        defaultWidth = glyphWidths;
        monospace = true;
      } else {
        widths = glyphWidths();
      }
      return {
        defaultWidth: defaultWidth,
        monospace: monospace,
        widths: widths
      };
    },
    buildCharCodeToWidth: function PartialEvaluator_bulildCharCodeToWidth(widthsByGlyphName, properties) {
      var widths = Object.create(null);
      var differences = properties.differences;
      var encoding = properties.defaultEncoding;
      for (var charCode = 0; charCode < 256; charCode++) {
        if (charCode in differences && widthsByGlyphName[differences[charCode]]) {
          widths[charCode] = widthsByGlyphName[differences[charCode]];
          continue;
        }
        if (charCode in encoding && widthsByGlyphName[encoding[charCode]]) {
          widths[charCode] = widthsByGlyphName[encoding[charCode]];
          continue;
        }
      }
      return widths;
    },
    preEvaluateFont: function PartialEvaluator_preEvaluateFont(dict) {
      var baseDict = dict;
      var type = dict.get('Subtype');
      if (!(0, _primitives.isName)(type)) {
        throw new _util.FormatError('invalid font Subtype');
      }
      var composite = false;
      var uint8array;
      if (type.name === 'Type0') {
        var df = dict.get('DescendantFonts');
        if (!df) {
          throw new _util.FormatError('Descendant fonts are not specified');
        }
        dict = (0, _util.isArray)(df) ? this.xref.fetchIfRef(df[0]) : df;
        type = dict.get('Subtype');
        if (!(0, _primitives.isName)(type)) {
          throw new _util.FormatError('invalid font Subtype');
        }
        composite = true;
      }
      var descriptor = dict.get('FontDescriptor');
      if (descriptor) {
        var hash = new _murmurhash.MurmurHash3_64();
        var encoding = baseDict.getRaw('Encoding');
        if ((0, _primitives.isName)(encoding)) {
          hash.update(encoding.name);
        } else if ((0, _primitives.isRef)(encoding)) {
          hash.update(encoding.toString());
        } else if ((0, _primitives.isDict)(encoding)) {
          var keys = encoding.getKeys();
          for (var i = 0, ii = keys.length; i < ii; i++) {
            var entry = encoding.getRaw(keys[i]);
            if ((0, _primitives.isName)(entry)) {
              hash.update(entry.name);
            } else if ((0, _primitives.isRef)(entry)) {
              hash.update(entry.toString());
            } else if ((0, _util.isArray)(entry)) {
              var diffLength = entry.length,
                  diffBuf = new Array(diffLength);
              for (var j = 0; j < diffLength; j++) {
                var diffEntry = entry[j];
                if ((0, _primitives.isName)(diffEntry)) {
                  diffBuf[j] = diffEntry.name;
                } else if ((0, _util.isNum)(diffEntry) || (0, _primitives.isRef)(diffEntry)) {
                  diffBuf[j] = diffEntry.toString();
                }
              }
              hash.update(diffBuf.join());
            }
          }
        }
        var toUnicode = dict.get('ToUnicode') || baseDict.get('ToUnicode');
        if ((0, _primitives.isStream)(toUnicode)) {
          var stream = toUnicode.str || toUnicode;
          uint8array = stream.buffer ? new Uint8Array(stream.buffer.buffer, 0, stream.bufferLength) : new Uint8Array(stream.bytes.buffer, stream.start, stream.end - stream.start);
          hash.update(uint8array);
        } else if ((0, _primitives.isName)(toUnicode)) {
          hash.update(toUnicode.name);
        }
        var widths = dict.get('Widths') || baseDict.get('Widths');
        if (widths) {
          uint8array = new Uint8Array(new Uint32Array(widths).buffer);
          hash.update(uint8array);
        }
      }
      return {
        descriptor: descriptor,
        dict: dict,
        baseDict: baseDict,
        composite: composite,
        type: type.name,
        hash: hash ? hash.hexdigest() : ''
      };
    },
    translateFont: function PartialEvaluator_translateFont(preEvaluatedFont) {
      var _this11 = this;

      var baseDict = preEvaluatedFont.baseDict;
      var dict = preEvaluatedFont.dict;
      var composite = preEvaluatedFont.composite;
      var descriptor = preEvaluatedFont.descriptor;
      var type = preEvaluatedFont.type;
      var maxCharIndex = composite ? 0xFFFF : 0xFF;
      var properties;
      if (!descriptor) {
        if (type === 'Type3') {
          descriptor = new _primitives.Dict(null);
          descriptor.set('FontName', _primitives.Name.get(type));
          descriptor.set('FontBBox', dict.getArray('FontBBox'));
        } else {
          var baseFontName = dict.get('BaseFont');
          if (!(0, _primitives.isName)(baseFontName)) {
            throw new _util.FormatError('Base font is not specified');
          }
          baseFontName = baseFontName.name.replace(/[,_]/g, '-');
          var metrics = this.getBaseFontMetrics(baseFontName);
          var fontNameWoStyle = baseFontName.split('-')[0];
          var flags = (this.isSerifFont(fontNameWoStyle) ? _fonts.FontFlags.Serif : 0) | (metrics.monospace ? _fonts.FontFlags.FixedPitch : 0) | ((0, _standard_fonts.getSymbolsFonts)()[fontNameWoStyle] ? _fonts.FontFlags.Symbolic : _fonts.FontFlags.Nonsymbolic);
          properties = {
            type: type,
            name: baseFontName,
            widths: metrics.widths,
            defaultWidth: metrics.defaultWidth,
            flags: flags,
            firstChar: 0,
            lastChar: maxCharIndex
          };
          return this.extractDataStructures(dict, dict, properties).then(function (properties) {
            properties.widths = _this11.buildCharCodeToWidth(metrics.widths, properties);
            return new _fonts.Font(baseFontName, null, properties);
          });
        }
      }
      var firstChar = dict.get('FirstChar') || 0;
      var lastChar = dict.get('LastChar') || maxCharIndex;
      var fontName = descriptor.get('FontName');
      var baseFont = dict.get('BaseFont');
      if ((0, _util.isString)(fontName)) {
        fontName = _primitives.Name.get(fontName);
      }
      if ((0, _util.isString)(baseFont)) {
        baseFont = _primitives.Name.get(baseFont);
      }
      if (type !== 'Type3') {
        var fontNameStr = fontName && fontName.name;
        var baseFontStr = baseFont && baseFont.name;
        if (fontNameStr !== baseFontStr) {
          (0, _util.info)('The FontDescriptor\'s FontName is "' + fontNameStr + '" but should be the same as the Font\'s BaseFont "' + baseFontStr + '"');
          if (fontNameStr && baseFontStr && baseFontStr.indexOf(fontNameStr) === 0) {
            fontName = baseFont;
          }
        }
      }
      fontName = fontName || baseFont;
      if (!(0, _primitives.isName)(fontName)) {
        throw new _util.FormatError('invalid font name');
      }
      var fontFile = descriptor.get('FontFile', 'FontFile2', 'FontFile3');
      if (fontFile) {
        if (fontFile.dict) {
          var subtype = fontFile.dict.get('Subtype');
          if (subtype) {
            subtype = subtype.name;
          }
          var length1 = fontFile.dict.get('Length1');
          var length2 = fontFile.dict.get('Length2');
          var length3 = fontFile.dict.get('Length3');
        }
      }
      properties = {
        type: type,
        name: fontName.name,
        subtype: subtype,
        file: fontFile,
        length1: length1,
        length2: length2,
        length3: length3,
        loadedName: baseDict.loadedName,
        composite: composite,
        wideChars: composite,
        fixedPitch: false,
        fontMatrix: dict.getArray('FontMatrix') || _util.FONT_IDENTITY_MATRIX,
        firstChar: firstChar || 0,
        lastChar: lastChar || maxCharIndex,
        bbox: descriptor.getArray('FontBBox'),
        ascent: descriptor.get('Ascent'),
        descent: descriptor.get('Descent'),
        xHeight: descriptor.get('XHeight'),
        capHeight: descriptor.get('CapHeight'),
        flags: descriptor.get('Flags'),
        italicAngle: descriptor.get('ItalicAngle'),
        isType3Font: false
      };
      var cMapPromise;
      if (composite) {
        var cidEncoding = baseDict.get('Encoding');
        if ((0, _primitives.isName)(cidEncoding)) {
          properties.cidEncoding = cidEncoding.name;
        }
        cMapPromise = _cmap.CMapFactory.create({
          encoding: cidEncoding,
          fetchBuiltInCMap: this.fetchBuiltInCMap,
          useCMap: null
        }).then(function (cMap) {
          properties.cMap = cMap;
          properties.vertical = properties.cMap.vertical;
        });
      } else {
        cMapPromise = Promise.resolve(undefined);
      }
      return cMapPromise.then(function () {
        return _this11.extractDataStructures(dict, baseDict, properties);
      }).then(function (properties) {
        _this11.extractWidths(dict, descriptor, properties);
        if (type === 'Type3') {
          properties.isType3Font = true;
        }
        return new _fonts.Font(fontName.name, fontFile, properties);
      });
    }
  };
  return PartialEvaluator;
}();
var TranslatedFont = function TranslatedFontClosure() {
  function TranslatedFont(loadedName, font, dict) {
    this.loadedName = loadedName;
    this.font = font;
    this.dict = dict;
    this.type3Loaded = null;
    this.sent = false;
  }
  TranslatedFont.prototype = {
    send: function send(handler) {
      if (this.sent) {
        return;
      }
      var fontData = this.font.exportData();
      handler.send('commonobj', [this.loadedName, 'Font', fontData]);
      this.sent = true;
    },
    loadType3Data: function loadType3Data(evaluator, resources, parentOperatorList, task) {
      if (!this.font.isType3Font) {
        throw new Error('Must be a Type3 font.');
      }
      if (this.type3Loaded) {
        return this.type3Loaded;
      }
      var type3Options = Object.create(evaluator.options);
      type3Options.ignoreErrors = false;
      var type3Evaluator = evaluator.clone(type3Options);
      var translatedFont = this.font;
      var loadCharProcsPromise = Promise.resolve();
      var charProcs = this.dict.get('CharProcs');
      var fontResources = this.dict.get('Resources') || resources;
      var charProcKeys = charProcs.getKeys();
      var charProcOperatorList = Object.create(null);

      var _loop2 = function _loop2() {
        var key = charProcKeys[i];
        loadCharProcsPromise = loadCharProcsPromise.then(function () {
          var glyphStream = charProcs.get(key);
          var operatorList = new OperatorList();
          return type3Evaluator.getOperatorList({
            stream: glyphStream,
            task: task,
            resources: fontResources,
            operatorList: operatorList
          }).then(function () {
            charProcOperatorList[key] = operatorList.getIR();
            parentOperatorList.addDependencies(operatorList.dependencies);
          }).catch(function (reason) {
            (0, _util.warn)('Type3 font resource "' + key + '" is not available.');
            var operatorList = new OperatorList();
            charProcOperatorList[key] = operatorList.getIR();
          });
        });
      };

      for (var i = 0, n = charProcKeys.length; i < n; ++i) {
        _loop2();
      }
      this.type3Loaded = loadCharProcsPromise.then(function () {
        translatedFont.charProcOperatorList = charProcOperatorList;
      });
      return this.type3Loaded;
    }
  };
  return TranslatedFont;
}();
var OperatorList = function OperatorListClosure() {
  var CHUNK_SIZE = 1000;
  var CHUNK_SIZE_ABOUT = CHUNK_SIZE - 5;
  function getTransfers(queue) {
    var transfers = [];
    var fnArray = queue.fnArray,
        argsArray = queue.argsArray;
    for (var i = 0, ii = queue.length; i < ii; i++) {
      switch (fnArray[i]) {
        case _util.OPS.paintInlineImageXObject:
        case _util.OPS.paintInlineImageXObjectGroup:
        case _util.OPS.paintImageMaskXObject:
          var arg = argsArray[i][0];
          if (!arg.cached) {
            transfers.push(arg.data.buffer);
          }
          break;
      }
    }
    return transfers;
  }
  function OperatorList(intent, messageHandler, pageIndex) {
    this.messageHandler = messageHandler;
    this.fnArray = [];
    this.argsArray = [];
    this.dependencies = Object.create(null);
    this._totalLength = 0;
    this.pageIndex = pageIndex;
    this.intent = intent;
  }
  OperatorList.prototype = {
    get length() {
      return this.argsArray.length;
    },
    get totalLength() {
      return this._totalLength + this.length;
    },
    addOp: function addOp(fn, args) {
      this.fnArray.push(fn);
      this.argsArray.push(args);
      if (this.messageHandler) {
        if (this.fnArray.length >= CHUNK_SIZE) {
          this.flush();
        } else if (this.fnArray.length >= CHUNK_SIZE_ABOUT && (fn === _util.OPS.restore || fn === _util.OPS.endText)) {
          this.flush();
        }
      }
    },
    addDependency: function addDependency(dependency) {
      if (dependency in this.dependencies) {
        return;
      }
      this.dependencies[dependency] = true;
      this.addOp(_util.OPS.dependency, [dependency]);
    },
    addDependencies: function addDependencies(dependencies) {
      for (var key in dependencies) {
        this.addDependency(key);
      }
    },
    addOpList: function addOpList(opList) {
      _util.Util.extendObj(this.dependencies, opList.dependencies);
      for (var i = 0, ii = opList.length; i < ii; i++) {
        this.addOp(opList.fnArray[i], opList.argsArray[i]);
      }
    },
    getIR: function getIR() {
      return {
        fnArray: this.fnArray,
        argsArray: this.argsArray,
        length: this.length
      };
    },
    flush: function flush(lastChunk) {
      if (this.intent !== 'oplist') {
        new QueueOptimizer().optimize(this);
      }
      var transfers = getTransfers(this);
      var length = this.length;
      this._totalLength += length;
      this.messageHandler.send('RenderPageChunk', {
        operatorList: {
          fnArray: this.fnArray,
          argsArray: this.argsArray,
          lastChunk: lastChunk,
          length: length
        },
        pageIndex: this.pageIndex,
        intent: this.intent
      }, transfers);
      this.dependencies = Object.create(null);
      this.fnArray.length = 0;
      this.argsArray.length = 0;
    }
  };
  return OperatorList;
}();
var StateManager = function StateManagerClosure() {
  function StateManager(initialState) {
    this.state = initialState;
    this.stateStack = [];
  }
  StateManager.prototype = {
    save: function save() {
      var old = this.state;
      this.stateStack.push(this.state);
      this.state = old.clone();
    },
    restore: function restore() {
      var prev = this.stateStack.pop();
      if (prev) {
        this.state = prev;
      }
    },
    transform: function transform(args) {
      this.state.ctm = _util.Util.transform(this.state.ctm, args);
    }
  };
  return StateManager;
}();
var TextState = function TextStateClosure() {
  function TextState() {
    this.ctm = new Float32Array(_util.IDENTITY_MATRIX);
    this.fontName = null;
    this.fontSize = 0;
    this.font = null;
    this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
    this.textMatrix = _util.IDENTITY_MATRIX.slice();
    this.textLineMatrix = _util.IDENTITY_MATRIX.slice();
    this.charSpacing = 0;
    this.wordSpacing = 0;
    this.leading = 0;
    this.textHScale = 1;
    this.textRise = 0;
  }
  TextState.prototype = {
    setTextMatrix: function TextState_setTextMatrix(a, b, c, d, e, f) {
      var m = this.textMatrix;
      m[0] = a;
      m[1] = b;
      m[2] = c;
      m[3] = d;
      m[4] = e;
      m[5] = f;
    },
    setTextLineMatrix: function TextState_setTextMatrix(a, b, c, d, e, f) {
      var m = this.textLineMatrix;
      m[0] = a;
      m[1] = b;
      m[2] = c;
      m[3] = d;
      m[4] = e;
      m[5] = f;
    },
    translateTextMatrix: function TextState_translateTextMatrix(x, y) {
      var m = this.textMatrix;
      m[4] = m[0] * x + m[2] * y + m[4];
      m[5] = m[1] * x + m[3] * y + m[5];
    },
    translateTextLineMatrix: function TextState_translateTextMatrix(x, y) {
      var m = this.textLineMatrix;
      m[4] = m[0] * x + m[2] * y + m[4];
      m[5] = m[1] * x + m[3] * y + m[5];
    },
    calcTextLineMatrixAdvance: function TextState_calcTextLineMatrixAdvance(a, b, c, d, e, f) {
      var font = this.font;
      if (!font) {
        return null;
      }
      var m = this.textLineMatrix;
      if (!(a === m[0] && b === m[1] && c === m[2] && d === m[3])) {
        return null;
      }
      var txDiff = e - m[4],
          tyDiff = f - m[5];
      if (font.vertical && txDiff !== 0 || !font.vertical && tyDiff !== 0) {
        return null;
      }
      var tx,
          ty,
          denominator = a * d - b * c;
      if (font.vertical) {
        tx = -tyDiff * c / denominator;
        ty = tyDiff * a / denominator;
      } else {
        tx = txDiff * d / denominator;
        ty = -txDiff * b / denominator;
      }
      return {
        width: tx,
        height: ty,
        value: font.vertical ? ty : tx
      };
    },
    calcRenderMatrix: function TextState_calcRendeMatrix(ctm) {
      var tsm = [this.fontSize * this.textHScale, 0, 0, this.fontSize, 0, this.textRise];
      return _util.Util.transform(ctm, _util.Util.transform(this.textMatrix, tsm));
    },
    carriageReturn: function TextState_carriageReturn() {
      this.translateTextLineMatrix(0, -this.leading);
      this.textMatrix = this.textLineMatrix.slice();
    },
    clone: function TextState_clone() {
      var clone = Object.create(this);
      clone.textMatrix = this.textMatrix.slice();
      clone.textLineMatrix = this.textLineMatrix.slice();
      clone.fontMatrix = this.fontMatrix.slice();
      return clone;
    }
  };
  return TextState;
}();
var EvalState = function EvalStateClosure() {
  function EvalState() {
    this.ctm = new Float32Array(_util.IDENTITY_MATRIX);
    this.font = null;
    this.textRenderingMode = _util.TextRenderingMode.FILL;
    this.fillColorSpace = _colorspace.ColorSpace.singletons.gray;
    this.strokeColorSpace = _colorspace.ColorSpace.singletons.gray;
  }
  EvalState.prototype = {
    clone: function CanvasExtraState_clone() {
      return Object.create(this);
    }
  };
  return EvalState;
}();
var EvaluatorPreprocessor = function EvaluatorPreprocessorClosure() {
  var getOPMap = (0, _util.getLookupTableFactory)(function (t) {
    t['w'] = {
      id: _util.OPS.setLineWidth,
      numArgs: 1,
      variableArgs: false
    };
    t['J'] = {
      id: _util.OPS.setLineCap,
      numArgs: 1,
      variableArgs: false
    };
    t['j'] = {
      id: _util.OPS.setLineJoin,
      numArgs: 1,
      variableArgs: false
    };
    t['M'] = {
      id: _util.OPS.setMiterLimit,
      numArgs: 1,
      variableArgs: false
    };
    t['d'] = {
      id: _util.OPS.setDash,
      numArgs: 2,
      variableArgs: false
    };
    t['ri'] = {
      id: _util.OPS.setRenderingIntent,
      numArgs: 1,
      variableArgs: false
    };
    t['i'] = {
      id: _util.OPS.setFlatness,
      numArgs: 1,
      variableArgs: false
    };
    t['gs'] = {
      id: _util.OPS.setGState,
      numArgs: 1,
      variableArgs: false
    };
    t['q'] = {
      id: _util.OPS.save,
      numArgs: 0,
      variableArgs: false
    };
    t['Q'] = {
      id: _util.OPS.restore,
      numArgs: 0,
      variableArgs: false
    };
    t['cm'] = {
      id: _util.OPS.transform,
      numArgs: 6,
      variableArgs: false
    };
    t['m'] = {
      id: _util.OPS.moveTo,
      numArgs: 2,
      variableArgs: false
    };
    t['l'] = {
      id: _util.OPS.lineTo,
      numArgs: 2,
      variableArgs: false
    };
    t['c'] = {
      id: _util.OPS.curveTo,
      numArgs: 6,
      variableArgs: false
    };
    t['v'] = {
      id: _util.OPS.curveTo2,
      numArgs: 4,
      variableArgs: false
    };
    t['y'] = {
      id: _util.OPS.curveTo3,
      numArgs: 4,
      variableArgs: false
    };
    t['h'] = {
      id: _util.OPS.closePath,
      numArgs: 0,
      variableArgs: false
    };
    t['re'] = {
      id: _util.OPS.rectangle,
      numArgs: 4,
      variableArgs: false
    };
    t['S'] = {
      id: _util.OPS.stroke,
      numArgs: 0,
      variableArgs: false
    };
    t['s'] = {
      id: _util.OPS.closeStroke,
      numArgs: 0,
      variableArgs: false
    };
    t['f'] = {
      id: _util.OPS.fill,
      numArgs: 0,
      variableArgs: false
    };
    t['F'] = {
      id: _util.OPS.fill,
      numArgs: 0,
      variableArgs: false
    };
    t['f*'] = {
      id: _util.OPS.eoFill,
      numArgs: 0,
      variableArgs: false
    };
    t['B'] = {
      id: _util.OPS.fillStroke,
      numArgs: 0,
      variableArgs: false
    };
    t['B*'] = {
      id: _util.OPS.eoFillStroke,
      numArgs: 0,
      variableArgs: false
    };
    t['b'] = {
      id: _util.OPS.closeFillStroke,
      numArgs: 0,
      variableArgs: false
    };
    t['b*'] = {
      id: _util.OPS.closeEOFillStroke,
      numArgs: 0,
      variableArgs: false
    };
    t['n'] = {
      id: _util.OPS.endPath,
      numArgs: 0,
      variableArgs: false
    };
    t['W'] = {
      id: _util.OPS.clip,
      numArgs: 0,
      variableArgs: false
    };
    t['W*'] = {
      id: _util.OPS.eoClip,
      numArgs: 0,
      variableArgs: false
    };
    t['BT'] = {
      id: _util.OPS.beginText,
      numArgs: 0,
      variableArgs: false
    };
    t['ET'] = {
      id: _util.OPS.endText,
      numArgs: 0,
      variableArgs: false
    };
    t['Tc'] = {
      id: _util.OPS.setCharSpacing,
      numArgs: 1,
      variableArgs: false
    };
    t['Tw'] = {
      id: _util.OPS.setWordSpacing,
      numArgs: 1,
      variableArgs: false
    };
    t['Tz'] = {
      id: _util.OPS.setHScale,
      numArgs: 1,
      variableArgs: false
    };
    t['TL'] = {
      id: _util.OPS.setLeading,
      numArgs: 1,
      variableArgs: false
    };
    t['Tf'] = {
      id: _util.OPS.setFont,
      numArgs: 2,
      variableArgs: false
    };
    t['Tr'] = {
      id: _util.OPS.setTextRenderingMode,
      numArgs: 1,
      variableArgs: false
    };
    t['Ts'] = {
      id: _util.OPS.setTextRise,
      numArgs: 1,
      variableArgs: false
    };
    t['Td'] = {
      id: _util.OPS.moveText,
      numArgs: 2,
      variableArgs: false
    };
    t['TD'] = {
      id: _util.OPS.setLeadingMoveText,
      numArgs: 2,
      variableArgs: false
    };
    t['Tm'] = {
      id: _util.OPS.setTextMatrix,
      numArgs: 6,
      variableArgs: false
    };
    t['T*'] = {
      id: _util.OPS.nextLine,
      numArgs: 0,
      variableArgs: false
    };
    t['Tj'] = {
      id: _util.OPS.showText,
      numArgs: 1,
      variableArgs: false
    };
    t['TJ'] = {
      id: _util.OPS.showSpacedText,
      numArgs: 1,
      variableArgs: false
    };
    t['\''] = {
      id: _util.OPS.nextLineShowText,
      numArgs: 1,
      variableArgs: false
    };
    t['"'] = {
      id: _util.OPS.nextLineSetSpacingShowText,
      numArgs: 3,
      variableArgs: false
    };
    t['d0'] = {
      id: _util.OPS.setCharWidth,
      numArgs: 2,
      variableArgs: false
    };
    t['d1'] = {
      id: _util.OPS.setCharWidthAndBounds,
      numArgs: 6,
      variableArgs: false
    };
    t['CS'] = {
      id: _util.OPS.setStrokeColorSpace,
      numArgs: 1,
      variableArgs: false
    };
    t['cs'] = {
      id: _util.OPS.setFillColorSpace,
      numArgs: 1,
      variableArgs: false
    };
    t['SC'] = {
      id: _util.OPS.setStrokeColor,
      numArgs: 4,
      variableArgs: true
    };
    t['SCN'] = {
      id: _util.OPS.setStrokeColorN,
      numArgs: 33,
      variableArgs: true
    };
    t['sc'] = {
      id: _util.OPS.setFillColor,
      numArgs: 4,
      variableArgs: true
    };
    t['scn'] = {
      id: _util.OPS.setFillColorN,
      numArgs: 33,
      variableArgs: true
    };
    t['G'] = {
      id: _util.OPS.setStrokeGray,
      numArgs: 1,
      variableArgs: false
    };
    t['g'] = {
      id: _util.OPS.setFillGray,
      numArgs: 1,
      variableArgs: false
    };
    t['RG'] = {
      id: _util.OPS.setStrokeRGBColor,
      numArgs: 3,
      variableArgs: false
    };
    t['rg'] = {
      id: _util.OPS.setFillRGBColor,
      numArgs: 3,
      variableArgs: false
    };
    t['K'] = {
      id: _util.OPS.setStrokeCMYKColor,
      numArgs: 4,
      variableArgs: false
    };
    t['k'] = {
      id: _util.OPS.setFillCMYKColor,
      numArgs: 4,
      variableArgs: false
    };
    t['sh'] = {
      id: _util.OPS.shadingFill,
      numArgs: 1,
      variableArgs: false
    };
    t['BI'] = {
      id: _util.OPS.beginInlineImage,
      numArgs: 0,
      variableArgs: false
    };
    t['ID'] = {
      id: _util.OPS.beginImageData,
      numArgs: 0,
      variableArgs: false
    };
    t['EI'] = {
      id: _util.OPS.endInlineImage,
      numArgs: 1,
      variableArgs: false
    };
    t['Do'] = {
      id: _util.OPS.paintXObject,
      numArgs: 1,
      variableArgs: false
    };
    t['MP'] = {
      id: _util.OPS.markPoint,
      numArgs: 1,
      variableArgs: false
    };
    t['DP'] = {
      id: _util.OPS.markPointProps,
      numArgs: 2,
      variableArgs: false
    };
    t['BMC'] = {
      id: _util.OPS.beginMarkedContent,
      numArgs: 1,
      variableArgs: false
    };
    t['BDC'] = {
      id: _util.OPS.beginMarkedContentProps,
      numArgs: 2,
      variableArgs: false
    };
    t['EMC'] = {
      id: _util.OPS.endMarkedContent,
      numArgs: 0,
      variableArgs: false
    };
    t['BX'] = {
      id: _util.OPS.beginCompat,
      numArgs: 0,
      variableArgs: false
    };
    t['EX'] = {
      id: _util.OPS.endCompat,
      numArgs: 0,
      variableArgs: false
    };
    t['BM'] = null;
    t['BD'] = null;
    t['true'] = null;
    t['fa'] = null;
    t['fal'] = null;
    t['fals'] = null;
    t['false'] = null;
    t['nu'] = null;
    t['nul'] = null;
    t['null'] = null;
  });
  function EvaluatorPreprocessor(stream, xref, stateManager) {
    this.opMap = getOPMap();
    this.parser = new _parser.Parser(new _parser.Lexer(stream, this.opMap), false, xref);
    this.stateManager = stateManager;
    this.nonProcessedArgs = [];
  }
  EvaluatorPreprocessor.prototype = {
    get savedStatesDepth() {
      return this.stateManager.stateStack.length;
    },
    read: function EvaluatorPreprocessor_read(operation) {
      var args = operation.args;
      while (true) {
        var obj = this.parser.getObj();
        if ((0, _primitives.isCmd)(obj)) {
          var cmd = obj.cmd;
          var opSpec = this.opMap[cmd];
          if (!opSpec) {
            (0, _util.warn)('Unknown command "' + cmd + '"');
            continue;
          }
          var fn = opSpec.id;
          var numArgs = opSpec.numArgs;
          var argsLength = args !== null ? args.length : 0;
          if (!opSpec.variableArgs) {
            if (argsLength !== numArgs) {
              var nonProcessedArgs = this.nonProcessedArgs;
              while (argsLength > numArgs) {
                nonProcessedArgs.push(args.shift());
                argsLength--;
              }
              while (argsLength < numArgs && nonProcessedArgs.length !== 0) {
                if (args === null) {
                  args = [];
                }
                args.unshift(nonProcessedArgs.pop());
                argsLength++;
              }
            }
            if (argsLength < numArgs) {
              (0, _util.warn)('Skipping command ' + fn + ': expected ' + numArgs + ' args, but received ' + argsLength + ' args.');
              if (args !== null) {
                args.length = 0;
              }
              continue;
            }
          } else if (argsLength > numArgs) {
            (0, _util.info)('Command ' + fn + ': expected [0,' + numArgs + '] args, but received ' + argsLength + ' args.');
          }
          this.preprocessCommand(fn, args);
          operation.fn = fn;
          operation.args = args;
          return true;
        }
        if ((0, _primitives.isEOF)(obj)) {
          return false;
        }
        if (obj !== null) {
          if (args === null) {
            args = [];
          }
          args.push(obj);
          if (args.length > 33) {
            throw new _util.FormatError('Too many arguments');
          }
        }
      }
    },
    preprocessCommand: function EvaluatorPreprocessor_preprocessCommand(fn, args) {
      switch (fn | 0) {
        case _util.OPS.save:
          this.stateManager.save();
          break;
        case _util.OPS.restore:
          this.stateManager.restore();
          break;
        case _util.OPS.transform:
          this.stateManager.transform(args);
          break;
      }
    }
  };
  return EvaluatorPreprocessor;
}();
var QueueOptimizer = function QueueOptimizerClosure() {
  function addState(parentState, pattern, fn) {
    var state = parentState;
    for (var i = 0, ii = pattern.length - 1; i < ii; i++) {
      var item = pattern[i];
      state = state[item] || (state[item] = []);
    }
    state[pattern[pattern.length - 1]] = fn;
  }
  function handlePaintSolidColorImageMask(iFirstSave, count, fnArray, argsArray) {
    var iFirstPIMXO = iFirstSave + 2;
    for (var i = 0; i < count; i++) {
      var arg = argsArray[iFirstPIMXO + 4 * i];
      var imageMask = arg.length === 1 && arg[0];
      if (imageMask && imageMask.width === 1 && imageMask.height === 1 && (!imageMask.data.length || imageMask.data.length === 1 && imageMask.data[0] === 0)) {
        fnArray[iFirstPIMXO + 4 * i] = _util.OPS.paintSolidColorImageMask;
        continue;
      }
      break;
    }
    return count - i;
  }
  var InitialState = [];
  addState(InitialState, [_util.OPS.save, _util.OPS.transform, _util.OPS.paintInlineImageXObject, _util.OPS.restore], function foundInlineImageGroup(context) {
    var MIN_IMAGES_IN_INLINE_IMAGES_BLOCK = 10;
    var MAX_IMAGES_IN_INLINE_IMAGES_BLOCK = 200;
    var MAX_WIDTH = 1000;
    var IMAGE_PADDING = 1;
    var fnArray = context.fnArray,
        argsArray = context.argsArray;
    var curr = context.iCurr;
    var iFirstSave = curr - 3;
    var iFirstTransform = curr - 2;
    var iFirstPIIXO = curr - 1;
    var i = iFirstSave + 4;
    var ii = fnArray.length;
    while (i + 3 < ii) {
      if (fnArray[i] !== _util.OPS.save || fnArray[i + 1] !== _util.OPS.transform || fnArray[i + 2] !== _util.OPS.paintInlineImageXObject || fnArray[i + 3] !== _util.OPS.restore) {
        break;
      }
      i += 4;
    }
    var count = Math.min((i - iFirstSave) / 4, MAX_IMAGES_IN_INLINE_IMAGES_BLOCK);
    if (count < MIN_IMAGES_IN_INLINE_IMAGES_BLOCK) {
      return i;
    }
    var maxX = 0;
    var map = [],
        maxLineHeight = 0;
    var currentX = IMAGE_PADDING,
        currentY = IMAGE_PADDING;
    var q;
    for (q = 0; q < count; q++) {
      var transform = argsArray[iFirstTransform + (q << 2)];
      var img = argsArray[iFirstPIIXO + (q << 2)][0];
      if (currentX + img.width > MAX_WIDTH) {
        maxX = Math.max(maxX, currentX);
        currentY += maxLineHeight + 2 * IMAGE_PADDING;
        currentX = 0;
        maxLineHeight = 0;
      }
      map.push({
        transform: transform,
        x: currentX,
        y: currentY,
        w: img.width,
        h: img.height
      });
      currentX += img.width + 2 * IMAGE_PADDING;
      maxLineHeight = Math.max(maxLineHeight, img.height);
    }
    var imgWidth = Math.max(maxX, currentX) + IMAGE_PADDING;
    var imgHeight = currentY + maxLineHeight + IMAGE_PADDING;
    var imgData = new Uint8Array(imgWidth * imgHeight * 4);
    var imgRowSize = imgWidth << 2;
    for (q = 0; q < count; q++) {
      var data = argsArray[iFirstPIIXO + (q << 2)][0].data;
      var rowSize = map[q].w << 2;
      var dataOffset = 0;
      var offset = map[q].x + map[q].y * imgWidth << 2;
      imgData.set(data.subarray(0, rowSize), offset - imgRowSize);
      for (var k = 0, kk = map[q].h; k < kk; k++) {
        imgData.set(data.subarray(dataOffset, dataOffset + rowSize), offset);
        dataOffset += rowSize;
        offset += imgRowSize;
      }
      imgData.set(data.subarray(dataOffset - rowSize, dataOffset), offset);
      while (offset >= 0) {
        data[offset - 4] = data[offset];
        data[offset - 3] = data[offset + 1];
        data[offset - 2] = data[offset + 2];
        data[offset - 1] = data[offset + 3];
        data[offset + rowSize] = data[offset + rowSize - 4];
        data[offset + rowSize + 1] = data[offset + rowSize - 3];
        data[offset + rowSize + 2] = data[offset + rowSize - 2];
        data[offset + rowSize + 3] = data[offset + rowSize - 1];
        offset -= imgRowSize;
      }
    }
    fnArray.splice(iFirstSave, count * 4, _util.OPS.paintInlineImageXObjectGroup);
    argsArray.splice(iFirstSave, count * 4, [{
      width: imgWidth,
      height: imgHeight,
      kind: _util.ImageKind.RGBA_32BPP,
      data: imgData
    }, map]);
    return iFirstSave + 1;
  });
  addState(InitialState, [_util.OPS.save, _util.OPS.transform, _util.OPS.paintImageMaskXObject, _util.OPS.restore], function foundImageMaskGroup(context) {
    var MIN_IMAGES_IN_MASKS_BLOCK = 10;
    var MAX_IMAGES_IN_MASKS_BLOCK = 100;
    var MAX_SAME_IMAGES_IN_MASKS_BLOCK = 1000;
    var fnArray = context.fnArray,
        argsArray = context.argsArray;
    var curr = context.iCurr;
    var iFirstSave = curr - 3;
    var iFirstTransform = curr - 2;
    var iFirstPIMXO = curr - 1;
    var i = iFirstSave + 4;
    var ii = fnArray.length;
    while (i + 3 < ii) {
      if (fnArray[i] !== _util.OPS.save || fnArray[i + 1] !== _util.OPS.transform || fnArray[i + 2] !== _util.OPS.paintImageMaskXObject || fnArray[i + 3] !== _util.OPS.restore) {
        break;
      }
      i += 4;
    }
    var count = (i - iFirstSave) / 4;
    count = handlePaintSolidColorImageMask(iFirstSave, count, fnArray, argsArray);
    if (count < MIN_IMAGES_IN_MASKS_BLOCK) {
      return i;
    }
    var q;
    var isSameImage = false;
    var iTransform, transformArgs;
    var firstPIMXOArg0 = argsArray[iFirstPIMXO][0];
    if (argsArray[iFirstTransform][1] === 0 && argsArray[iFirstTransform][2] === 0) {
      isSameImage = true;
      var firstTransformArg0 = argsArray[iFirstTransform][0];
      var firstTransformArg3 = argsArray[iFirstTransform][3];
      iTransform = iFirstTransform + 4;
      var iPIMXO = iFirstPIMXO + 4;
      for (q = 1; q < count; q++, iTransform += 4, iPIMXO += 4) {
        transformArgs = argsArray[iTransform];
        if (argsArray[iPIMXO][0] !== firstPIMXOArg0 || transformArgs[0] !== firstTransformArg0 || transformArgs[1] !== 0 || transformArgs[2] !== 0 || transformArgs[3] !== firstTransformArg3) {
          if (q < MIN_IMAGES_IN_MASKS_BLOCK) {
            isSameImage = false;
          } else {
            count = q;
          }
          break;
        }
      }
    }
    if (isSameImage) {
      count = Math.min(count, MAX_SAME_IMAGES_IN_MASKS_BLOCK);
      var positions = new Float32Array(count * 2);
      iTransform = iFirstTransform;
      for (q = 0; q < count; q++, iTransform += 4) {
        transformArgs = argsArray[iTransform];
        positions[q << 1] = transformArgs[4];
        positions[(q << 1) + 1] = transformArgs[5];
      }
      fnArray.splice(iFirstSave, count * 4, _util.OPS.paintImageMaskXObjectRepeat);
      argsArray.splice(iFirstSave, count * 4, [firstPIMXOArg0, firstTransformArg0, firstTransformArg3, positions]);
    } else {
      count = Math.min(count, MAX_IMAGES_IN_MASKS_BLOCK);
      var images = [];
      for (q = 0; q < count; q++) {
        transformArgs = argsArray[iFirstTransform + (q << 2)];
        var maskParams = argsArray[iFirstPIMXO + (q << 2)][0];
        images.push({
          data: maskParams.data,
          width: maskParams.width,
          height: maskParams.height,
          transform: transformArgs
        });
      }
      fnArray.splice(iFirstSave, count * 4, _util.OPS.paintImageMaskXObjectGroup);
      argsArray.splice(iFirstSave, count * 4, [images]);
    }
    return iFirstSave + 1;
  });
  addState(InitialState, [_util.OPS.save, _util.OPS.transform, _util.OPS.paintImageXObject, _util.OPS.restore], function (context) {
    var MIN_IMAGES_IN_BLOCK = 3;
    var MAX_IMAGES_IN_BLOCK = 1000;
    var fnArray = context.fnArray,
        argsArray = context.argsArray;
    var curr = context.iCurr;
    var iFirstSave = curr - 3;
    var iFirstTransform = curr - 2;
    var iFirstPIXO = curr - 1;
    var iFirstRestore = curr;
    if (argsArray[iFirstTransform][1] !== 0 || argsArray[iFirstTransform][2] !== 0) {
      return iFirstRestore + 1;
    }
    var firstPIXOArg0 = argsArray[iFirstPIXO][0];
    var firstTransformArg0 = argsArray[iFirstTransform][0];
    var firstTransformArg3 = argsArray[iFirstTransform][3];
    var i = iFirstSave + 4;
    var ii = fnArray.length;
    while (i + 3 < ii) {
      if (fnArray[i] !== _util.OPS.save || fnArray[i + 1] !== _util.OPS.transform || fnArray[i + 2] !== _util.OPS.paintImageXObject || fnArray[i + 3] !== _util.OPS.restore) {
        break;
      }
      if (argsArray[i + 1][0] !== firstTransformArg0 || argsArray[i + 1][1] !== 0 || argsArray[i + 1][2] !== 0 || argsArray[i + 1][3] !== firstTransformArg3) {
        break;
      }
      if (argsArray[i + 2][0] !== firstPIXOArg0) {
        break;
      }
      i += 4;
    }
    var count = Math.min((i - iFirstSave) / 4, MAX_IMAGES_IN_BLOCK);
    if (count < MIN_IMAGES_IN_BLOCK) {
      return i;
    }
    var positions = new Float32Array(count * 2);
    var iTransform = iFirstTransform;
    for (var q = 0; q < count; q++, iTransform += 4) {
      var transformArgs = argsArray[iTransform];
      positions[q << 1] = transformArgs[4];
      positions[(q << 1) + 1] = transformArgs[5];
    }
    var args = [firstPIXOArg0, firstTransformArg0, firstTransformArg3, positions];
    fnArray.splice(iFirstSave, count * 4, _util.OPS.paintImageXObjectRepeat);
    argsArray.splice(iFirstSave, count * 4, args);
    return iFirstSave + 1;
  });
  addState(InitialState, [_util.OPS.beginText, _util.OPS.setFont, _util.OPS.setTextMatrix, _util.OPS.showText, _util.OPS.endText], function (context) {
    var MIN_CHARS_IN_BLOCK = 3;
    var MAX_CHARS_IN_BLOCK = 1000;
    var fnArray = context.fnArray,
        argsArray = context.argsArray;
    var curr = context.iCurr;
    var iFirstBeginText = curr - 4;
    var iFirstSetFont = curr - 3;
    var iFirstSetTextMatrix = curr - 2;
    var iFirstShowText = curr - 1;
    var iFirstEndText = curr;
    var firstSetFontArg0 = argsArray[iFirstSetFont][0];
    var firstSetFontArg1 = argsArray[iFirstSetFont][1];
    var i = iFirstBeginText + 5;
    var ii = fnArray.length;
    while (i + 4 < ii) {
      if (fnArray[i] !== _util.OPS.beginText || fnArray[i + 1] !== _util.OPS.setFont || fnArray[i + 2] !== _util.OPS.setTextMatrix || fnArray[i + 3] !== _util.OPS.showText || fnArray[i + 4] !== _util.OPS.endText) {
        break;
      }
      if (argsArray[i + 1][0] !== firstSetFontArg0 || argsArray[i + 1][1] !== firstSetFontArg1) {
        break;
      }
      i += 5;
    }
    var count = Math.min((i - iFirstBeginText) / 5, MAX_CHARS_IN_BLOCK);
    if (count < MIN_CHARS_IN_BLOCK) {
      return i;
    }
    var iFirst = iFirstBeginText;
    if (iFirstBeginText >= 4 && fnArray[iFirstBeginText - 4] === fnArray[iFirstSetFont] && fnArray[iFirstBeginText - 3] === fnArray[iFirstSetTextMatrix] && fnArray[iFirstBeginText - 2] === fnArray[iFirstShowText] && fnArray[iFirstBeginText - 1] === fnArray[iFirstEndText] && argsArray[iFirstBeginText - 4][0] === firstSetFontArg0 && argsArray[iFirstBeginText - 4][1] === firstSetFontArg1) {
      count++;
      iFirst -= 5;
    }
    var iEndText = iFirst + 4;
    for (var q = 1; q < count; q++) {
      fnArray.splice(iEndText, 3);
      argsArray.splice(iEndText, 3);
      iEndText += 2;
    }
    return iEndText + 1;
  });
  function QueueOptimizer() {}
  QueueOptimizer.prototype = {
    optimize: function QueueOptimizer_optimize(queue) {
      var fnArray = queue.fnArray,
          argsArray = queue.argsArray;
      var context = {
        iCurr: 0,
        fnArray: fnArray,
        argsArray: argsArray
      };
      var state;
      var i = 0,
          ii = fnArray.length;
      while (i < ii) {
        state = (state || InitialState)[fnArray[i]];
        if (typeof state === 'function') {
          context.iCurr = i;
          i = state(context);
          state = undefined;
          ii = context.fnArray.length;
        } else {
          i++;
        }
      }
    }
  };
  return QueueOptimizer;
}();
exports.OperatorList = OperatorList;
exports.PartialEvaluator = PartialEvaluator;

/***/ }),
/* 13 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JpxImage = undefined;

var _util = __w_pdfjs_require__(0);

var _arithmetic_decoder = __w_pdfjs_require__(8);

var JpxError = function JpxErrorClosure() {
  function JpxError(msg) {
    this.message = 'JPX error: ' + msg;
  }
  JpxError.prototype = new Error();
  JpxError.prototype.name = 'JpxError';
  JpxError.constructor = JpxError;
  return JpxError;
}();
var JpxImage = function JpxImageClosure() {
  var SubbandsGainLog2 = {
    'LL': 0,
    'LH': 1,
    'HL': 1,
    'HH': 2
  };
  function JpxImage() {
    this.failOnCorruptedImage = false;
  }
  JpxImage.prototype = {
    parse: function JpxImage_parse(data) {
      var head = (0, _util.readUint16)(data, 0);
      if (head === 0xFF4F) {
        this.parseCodestream(data, 0, data.length);
        return;
      }
      var position = 0,
          length = data.length;
      while (position < length) {
        var headerSize = 8;
        var lbox = (0, _util.readUint32)(data, position);
        var tbox = (0, _util.readUint32)(data, position + 4);
        position += headerSize;
        if (lbox === 1) {
          lbox = (0, _util.readUint32)(data, position) * 4294967296 + (0, _util.readUint32)(data, position + 4);
          position += 8;
          headerSize += 8;
        }
        if (lbox === 0) {
          lbox = length - position + headerSize;
        }
        if (lbox < headerSize) {
          throw new JpxError('Invalid box field size');
        }
        var dataLength = lbox - headerSize;
        var jumpDataLength = true;
        switch (tbox) {
          case 0x6A703268:
            jumpDataLength = false;
            break;
          case 0x636F6C72:
            var method = data[position];
            if (method === 1) {
              var colorspace = (0, _util.readUint32)(data, position + 3);
              switch (colorspace) {
                case 16:
                case 17:
                case 18:
                  break;
                default:
                  (0, _util.warn)('Unknown colorspace ' + colorspace);
                  break;
              }
            } else if (method === 2) {
              (0, _util.info)('ICC profile not supported');
            }
            break;
          case 0x6A703263:
            this.parseCodestream(data, position, position + dataLength);
            break;
          case 0x6A502020:
            if ((0, _util.readUint32)(data, position) !== 0x0d0a870a) {
              (0, _util.warn)('Invalid JP2 signature');
            }
            break;
          case 0x6A501A1A:
          case 0x66747970:
          case 0x72726571:
          case 0x72657320:
          case 0x69686472:
            break;
          default:
            var headerType = String.fromCharCode(tbox >> 24 & 0xFF, tbox >> 16 & 0xFF, tbox >> 8 & 0xFF, tbox & 0xFF);
            (0, _util.warn)('Unsupported header type ' + tbox + ' (' + headerType + ')');
            break;
        }
        if (jumpDataLength) {
          position += dataLength;
        }
      }
    },
    parseImageProperties: function JpxImage_parseImageProperties(stream) {
      var newByte = stream.getByte();
      while (newByte >= 0) {
        var oldByte = newByte;
        newByte = stream.getByte();
        var code = oldByte << 8 | newByte;
        if (code === 0xFF51) {
          stream.skip(4);
          var Xsiz = stream.getInt32() >>> 0;
          var Ysiz = stream.getInt32() >>> 0;
          var XOsiz = stream.getInt32() >>> 0;
          var YOsiz = stream.getInt32() >>> 0;
          stream.skip(16);
          var Csiz = stream.getUint16();
          this.width = Xsiz - XOsiz;
          this.height = Ysiz - YOsiz;
          this.componentsCount = Csiz;
          this.bitsPerComponent = 8;
          return;
        }
      }
      throw new JpxError('No size marker found in JPX stream');
    },
    parseCodestream: function JpxImage_parseCodestream(data, start, end) {
      var context = {};
      var doNotRecover = false;
      try {
        var position = start;
        while (position + 1 < end) {
          var code = (0, _util.readUint16)(data, position);
          position += 2;
          var length = 0,
              j,
              sqcd,
              spqcds,
              spqcdSize,
              scalarExpounded,
              tile;
          switch (code) {
            case 0xFF4F:
              context.mainHeader = true;
              break;
            case 0xFFD9:
              break;
            case 0xFF51:
              length = (0, _util.readUint16)(data, position);
              var siz = {};
              siz.Xsiz = (0, _util.readUint32)(data, position + 4);
              siz.Ysiz = (0, _util.readUint32)(data, position + 8);
              siz.XOsiz = (0, _util.readUint32)(data, position + 12);
              siz.YOsiz = (0, _util.readUint32)(data, position + 16);
              siz.XTsiz = (0, _util.readUint32)(data, position + 20);
              siz.YTsiz = (0, _util.readUint32)(data, position + 24);
              siz.XTOsiz = (0, _util.readUint32)(data, position + 28);
              siz.YTOsiz = (0, _util.readUint32)(data, position + 32);
              var componentsCount = (0, _util.readUint16)(data, position + 36);
              siz.Csiz = componentsCount;
              var components = [];
              j = position + 38;
              for (var i = 0; i < componentsCount; i++) {
                var component = {
                  precision: (data[j] & 0x7F) + 1,
                  isSigned: !!(data[j] & 0x80),
                  XRsiz: data[j + 1],
                  YRsiz: data[j + 1]
                };
                calculateComponentDimensions(component, siz);
                components.push(component);
              }
              context.SIZ = siz;
              context.components = components;
              calculateTileGrids(context, components);
              context.QCC = [];
              context.COC = [];
              break;
            case 0xFF5C:
              length = (0, _util.readUint16)(data, position);
              var qcd = {};
              j = position + 2;
              sqcd = data[j++];
              switch (sqcd & 0x1F) {
                case 0:
                  spqcdSize = 8;
                  scalarExpounded = true;
                  break;
                case 1:
                  spqcdSize = 16;
                  scalarExpounded = false;
                  break;
                case 2:
                  spqcdSize = 16;
                  scalarExpounded = true;
                  break;
                default:
                  throw new Error('Invalid SQcd value ' + sqcd);
              }
              qcd.noQuantization = spqcdSize === 8;
              qcd.scalarExpounded = scalarExpounded;
              qcd.guardBits = sqcd >> 5;
              spqcds = [];
              while (j < length + position) {
                var spqcd = {};
                if (spqcdSize === 8) {
                  spqcd.epsilon = data[j++] >> 3;
                  spqcd.mu = 0;
                } else {
                  spqcd.epsilon = data[j] >> 3;
                  spqcd.mu = (data[j] & 0x7) << 8 | data[j + 1];
                  j += 2;
                }
                spqcds.push(spqcd);
              }
              qcd.SPqcds = spqcds;
              if (context.mainHeader) {
                context.QCD = qcd;
              } else {
                context.currentTile.QCD = qcd;
                context.currentTile.QCC = [];
              }
              break;
            case 0xFF5D:
              length = (0, _util.readUint16)(data, position);
              var qcc = {};
              j = position + 2;
              var cqcc;
              if (context.SIZ.Csiz < 257) {
                cqcc = data[j++];
              } else {
                cqcc = (0, _util.readUint16)(data, j);
                j += 2;
              }
              sqcd = data[j++];
              switch (sqcd & 0x1F) {
                case 0:
                  spqcdSize = 8;
                  scalarExpounded = true;
                  break;
                case 1:
                  spqcdSize = 16;
                  scalarExpounded = false;
                  break;
                case 2:
                  spqcdSize = 16;
                  scalarExpounded = true;
                  break;
                default:
                  throw new Error('Invalid SQcd value ' + sqcd);
              }
              qcc.noQuantization = spqcdSize === 8;
              qcc.scalarExpounded = scalarExpounded;
              qcc.guardBits = sqcd >> 5;
              spqcds = [];
              while (j < length + position) {
                spqcd = {};
                if (spqcdSize === 8) {
                  spqcd.epsilon = data[j++] >> 3;
                  spqcd.mu = 0;
                } else {
                  spqcd.epsilon = data[j] >> 3;
                  spqcd.mu = (data[j] & 0x7) << 8 | data[j + 1];
                  j += 2;
                }
                spqcds.push(spqcd);
              }
              qcc.SPqcds = spqcds;
              if (context.mainHeader) {
                context.QCC[cqcc] = qcc;
              } else {
                context.currentTile.QCC[cqcc] = qcc;
              }
              break;
            case 0xFF52:
              length = (0, _util.readUint16)(data, position);
              var cod = {};
              j = position + 2;
              var scod = data[j++];
              cod.entropyCoderWithCustomPrecincts = !!(scod & 1);
              cod.sopMarkerUsed = !!(scod & 2);
              cod.ephMarkerUsed = !!(scod & 4);
              cod.progressionOrder = data[j++];
              cod.layersCount = (0, _util.readUint16)(data, j);
              j += 2;
              cod.multipleComponentTransform = data[j++];
              cod.decompositionLevelsCount = data[j++];
              cod.xcb = (data[j++] & 0xF) + 2;
              cod.ycb = (data[j++] & 0xF) + 2;
              var blockStyle = data[j++];
              cod.selectiveArithmeticCodingBypass = !!(blockStyle & 1);
              cod.resetContextProbabilities = !!(blockStyle & 2);
              cod.terminationOnEachCodingPass = !!(blockStyle & 4);
              cod.verticalyStripe = !!(blockStyle & 8);
              cod.predictableTermination = !!(blockStyle & 16);
              cod.segmentationSymbolUsed = !!(blockStyle & 32);
              cod.reversibleTransformation = data[j++];
              if (cod.entropyCoderWithCustomPrecincts) {
                var precinctsSizes = [];
                while (j < length + position) {
                  var precinctsSize = data[j++];
                  precinctsSizes.push({
                    PPx: precinctsSize & 0xF,
                    PPy: precinctsSize >> 4
                  });
                }
                cod.precinctsSizes = precinctsSizes;
              }
              var unsupported = [];
              if (cod.selectiveArithmeticCodingBypass) {
                unsupported.push('selectiveArithmeticCodingBypass');
              }
              if (cod.resetContextProbabilities) {
                unsupported.push('resetContextProbabilities');
              }
              if (cod.terminationOnEachCodingPass) {
                unsupported.push('terminationOnEachCodingPass');
              }
              if (cod.verticalyStripe) {
                unsupported.push('verticalyStripe');
              }
              if (cod.predictableTermination) {
                unsupported.push('predictableTermination');
              }
              if (unsupported.length > 0) {
                doNotRecover = true;
                throw new Error('Unsupported COD options (' + unsupported.join(', ') + ')');
              }
              if (context.mainHeader) {
                context.COD = cod;
              } else {
                context.currentTile.COD = cod;
                context.currentTile.COC = [];
              }
              break;
            case 0xFF90:
              length = (0, _util.readUint16)(data, position);
              tile = {};
              tile.index = (0, _util.readUint16)(data, position + 2);
              tile.length = (0, _util.readUint32)(data, position + 4);
              tile.dataEnd = tile.length + position - 2;
              tile.partIndex = data[position + 8];
              tile.partsCount = data[position + 9];
              context.mainHeader = false;
              if (tile.partIndex === 0) {
                tile.COD = context.COD;
                tile.COC = context.COC.slice(0);
                tile.QCD = context.QCD;
                tile.QCC = context.QCC.slice(0);
              }
              context.currentTile = tile;
              break;
            case 0xFF93:
              tile = context.currentTile;
              if (tile.partIndex === 0) {
                initializeTile(context, tile.index);
                buildPackets(context);
              }
              length = tile.dataEnd - position;
              parseTilePackets(context, data, position, length);
              break;
            case 0xFF55:
            case 0xFF57:
            case 0xFF58:
            case 0xFF64:
              length = (0, _util.readUint16)(data, position);
              break;
            case 0xFF53:
              throw new Error('Codestream code 0xFF53 (COC) is ' + 'not implemented');
            default:
              throw new Error('Unknown codestream code: ' + code.toString(16));
          }
          position += length;
        }
      } catch (e) {
        if (doNotRecover || this.failOnCorruptedImage) {
          throw new JpxError(e.message);
        } else {
          (0, _util.warn)('JPX: Trying to recover from: ' + e.message);
        }
      }
      this.tiles = transformComponents(context);
      this.width = context.SIZ.Xsiz - context.SIZ.XOsiz;
      this.height = context.SIZ.Ysiz - context.SIZ.YOsiz;
      this.componentsCount = context.SIZ.Csiz;
    }
  };
  function calculateComponentDimensions(component, siz) {
    component.x0 = Math.ceil(siz.XOsiz / component.XRsiz);
    component.x1 = Math.ceil(siz.Xsiz / component.XRsiz);
    component.y0 = Math.ceil(siz.YOsiz / component.YRsiz);
    component.y1 = Math.ceil(siz.Ysiz / component.YRsiz);
    component.width = component.x1 - component.x0;
    component.height = component.y1 - component.y0;
  }
  function calculateTileGrids(context, components) {
    var siz = context.SIZ;
    var tile,
        tiles = [];
    var numXtiles = Math.ceil((siz.Xsiz - siz.XTOsiz) / siz.XTsiz);
    var numYtiles = Math.ceil((siz.Ysiz - siz.YTOsiz) / siz.YTsiz);
    for (var q = 0; q < numYtiles; q++) {
      for (var p = 0; p < numXtiles; p++) {
        tile = {};
        tile.tx0 = Math.max(siz.XTOsiz + p * siz.XTsiz, siz.XOsiz);
        tile.ty0 = Math.max(siz.YTOsiz + q * siz.YTsiz, siz.YOsiz);
        tile.tx1 = Math.min(siz.XTOsiz + (p + 1) * siz.XTsiz, siz.Xsiz);
        tile.ty1 = Math.min(siz.YTOsiz + (q + 1) * siz.YTsiz, siz.Ysiz);
        tile.width = tile.tx1 - tile.tx0;
        tile.height = tile.ty1 - tile.ty0;
        tile.components = [];
        tiles.push(tile);
      }
    }
    context.tiles = tiles;
    var componentsCount = siz.Csiz;
    for (var i = 0, ii = componentsCount; i < ii; i++) {
      var component = components[i];
      for (var j = 0, jj = tiles.length; j < jj; j++) {
        var tileComponent = {};
        tile = tiles[j];
        tileComponent.tcx0 = Math.ceil(tile.tx0 / component.XRsiz);
        tileComponent.tcy0 = Math.ceil(tile.ty0 / component.YRsiz);
        tileComponent.tcx1 = Math.ceil(tile.tx1 / component.XRsiz);
        tileComponent.tcy1 = Math.ceil(tile.ty1 / component.YRsiz);
        tileComponent.width = tileComponent.tcx1 - tileComponent.tcx0;
        tileComponent.height = tileComponent.tcy1 - tileComponent.tcy0;
        tile.components[i] = tileComponent;
      }
    }
  }
  function getBlocksDimensions(context, component, r) {
    var codOrCoc = component.codingStyleParameters;
    var result = {};
    if (!codOrCoc.entropyCoderWithCustomPrecincts) {
      result.PPx = 15;
      result.PPy = 15;
    } else {
      result.PPx = codOrCoc.precinctsSizes[r].PPx;
      result.PPy = codOrCoc.precinctsSizes[r].PPy;
    }
    result.xcb_ = r > 0 ? Math.min(codOrCoc.xcb, result.PPx - 1) : Math.min(codOrCoc.xcb, result.PPx);
    result.ycb_ = r > 0 ? Math.min(codOrCoc.ycb, result.PPy - 1) : Math.min(codOrCoc.ycb, result.PPy);
    return result;
  }
  function buildPrecincts(context, resolution, dimensions) {
    var precinctWidth = 1 << dimensions.PPx;
    var precinctHeight = 1 << dimensions.PPy;
    var isZeroRes = resolution.resLevel === 0;
    var precinctWidthInSubband = 1 << dimensions.PPx + (isZeroRes ? 0 : -1);
    var precinctHeightInSubband = 1 << dimensions.PPy + (isZeroRes ? 0 : -1);
    var numprecinctswide = resolution.trx1 > resolution.trx0 ? Math.ceil(resolution.trx1 / precinctWidth) - Math.floor(resolution.trx0 / precinctWidth) : 0;
    var numprecinctshigh = resolution.try1 > resolution.try0 ? Math.ceil(resolution.try1 / precinctHeight) - Math.floor(resolution.try0 / precinctHeight) : 0;
    var numprecincts = numprecinctswide * numprecinctshigh;
    resolution.precinctParameters = {
      precinctWidth: precinctWidth,
      precinctHeight: precinctHeight,
      numprecinctswide: numprecinctswide,
      numprecinctshigh: numprecinctshigh,
      numprecincts: numprecincts,
      precinctWidthInSubband: precinctWidthInSubband,
      precinctHeightInSubband: precinctHeightInSubband
    };
  }
  function buildCodeblocks(context, subband, dimensions) {
    var xcb_ = dimensions.xcb_;
    var ycb_ = dimensions.ycb_;
    var codeblockWidth = 1 << xcb_;
    var codeblockHeight = 1 << ycb_;
    var cbx0 = subband.tbx0 >> xcb_;
    var cby0 = subband.tby0 >> ycb_;
    var cbx1 = subband.tbx1 + codeblockWidth - 1 >> xcb_;
    var cby1 = subband.tby1 + codeblockHeight - 1 >> ycb_;
    var precinctParameters = subband.resolution.precinctParameters;
    var codeblocks = [];
    var precincts = [];
    var i, j, codeblock, precinctNumber;
    for (j = cby0; j < cby1; j++) {
      for (i = cbx0; i < cbx1; i++) {
        codeblock = {
          cbx: i,
          cby: j,
          tbx0: codeblockWidth * i,
          tby0: codeblockHeight * j,
          tbx1: codeblockWidth * (i + 1),
          tby1: codeblockHeight * (j + 1)
        };
        codeblock.tbx0_ = Math.max(subband.tbx0, codeblock.tbx0);
        codeblock.tby0_ = Math.max(subband.tby0, codeblock.tby0);
        codeblock.tbx1_ = Math.min(subband.tbx1, codeblock.tbx1);
        codeblock.tby1_ = Math.min(subband.tby1, codeblock.tby1);
        var pi = Math.floor((codeblock.tbx0_ - subband.tbx0) / precinctParameters.precinctWidthInSubband);
        var pj = Math.floor((codeblock.tby0_ - subband.tby0) / precinctParameters.precinctHeightInSubband);
        precinctNumber = pi + pj * precinctParameters.numprecinctswide;
        codeblock.precinctNumber = precinctNumber;
        codeblock.subbandType = subband.type;
        codeblock.Lblock = 3;
        if (codeblock.tbx1_ <= codeblock.tbx0_ || codeblock.tby1_ <= codeblock.tby0_) {
          continue;
        }
        codeblocks.push(codeblock);
        var precinct = precincts[precinctNumber];
        if (precinct !== undefined) {
          if (i < precinct.cbxMin) {
            precinct.cbxMin = i;
          } else if (i > precinct.cbxMax) {
            precinct.cbxMax = i;
          }
          if (j < precinct.cbyMin) {
            precinct.cbxMin = j;
          } else if (j > precinct.cbyMax) {
            precinct.cbyMax = j;
          }
        } else {
          precincts[precinctNumber] = precinct = {
            cbxMin: i,
            cbyMin: j,
            cbxMax: i,
            cbyMax: j
          };
        }
        codeblock.precinct = precinct;
      }
    }
    subband.codeblockParameters = {
      codeblockWidth: xcb_,
      codeblockHeight: ycb_,
      numcodeblockwide: cbx1 - cbx0 + 1,
      numcodeblockhigh: cby1 - cby0 + 1
    };
    subband.codeblocks = codeblocks;
    subband.precincts = precincts;
  }
  function createPacket(resolution, precinctNumber, layerNumber) {
    var precinctCodeblocks = [];
    var subbands = resolution.subbands;
    for (var i = 0, ii = subbands.length; i < ii; i++) {
      var subband = subbands[i];
      var codeblocks = subband.codeblocks;
      for (var j = 0, jj = codeblocks.length; j < jj; j++) {
        var codeblock = codeblocks[j];
        if (codeblock.precinctNumber !== precinctNumber) {
          continue;
        }
        precinctCodeblocks.push(codeblock);
      }
    }
    return {
      layerNumber: layerNumber,
      codeblocks: precinctCodeblocks
    };
  }
  function LayerResolutionComponentPositionIterator(context) {
    var siz = context.SIZ;
    var tileIndex = context.currentTile.index;
    var tile = context.tiles[tileIndex];
    var layersCount = tile.codingStyleDefaultParameters.layersCount;
    var componentsCount = siz.Csiz;
    var maxDecompositionLevelsCount = 0;
    for (var q = 0; q < componentsCount; q++) {
      maxDecompositionLevelsCount = Math.max(maxDecompositionLevelsCount, tile.components[q].codingStyleParameters.decompositionLevelsCount);
    }
    var l = 0,
        r = 0,
        i = 0,
        k = 0;
    this.nextPacket = function JpxImage_nextPacket() {
      for (; l < layersCount; l++) {
        for (; r <= maxDecompositionLevelsCount; r++) {
          for (; i < componentsCount; i++) {
            var component = tile.components[i];
            if (r > component.codingStyleParameters.decompositionLevelsCount) {
              continue;
            }
            var resolution = component.resolutions[r];
            var numprecincts = resolution.precinctParameters.numprecincts;
            for (; k < numprecincts;) {
              var packet = createPacket(resolution, k, l);
              k++;
              return packet;
            }
            k = 0;
          }
          i = 0;
        }
        r = 0;
      }
      throw new JpxError('Out of packets');
    };
  }
  function ResolutionLayerComponentPositionIterator(context) {
    var siz = context.SIZ;
    var tileIndex = context.currentTile.index;
    var tile = context.tiles[tileIndex];
    var layersCount = tile.codingStyleDefaultParameters.layersCount;
    var componentsCount = siz.Csiz;
    var maxDecompositionLevelsCount = 0;
    for (var q = 0; q < componentsCount; q++) {
      maxDecompositionLevelsCount = Math.max(maxDecompositionLevelsCount, tile.components[q].codingStyleParameters.decompositionLevelsCount);
    }
    var r = 0,
        l = 0,
        i = 0,
        k = 0;
    this.nextPacket = function JpxImage_nextPacket() {
      for (; r <= maxDecompositionLevelsCount; r++) {
        for (; l < layersCount; l++) {
          for (; i < componentsCount; i++) {
            var component = tile.components[i];
            if (r > component.codingStyleParameters.decompositionLevelsCount) {
              continue;
            }
            var resolution = component.resolutions[r];
            var numprecincts = resolution.precinctParameters.numprecincts;
            for (; k < numprecincts;) {
              var packet = createPacket(resolution, k, l);
              k++;
              return packet;
            }
            k = 0;
          }
          i = 0;
        }
        l = 0;
      }
      throw new JpxError('Out of packets');
    };
  }
  function ResolutionPositionComponentLayerIterator(context) {
    var siz = context.SIZ;
    var tileIndex = context.currentTile.index;
    var tile = context.tiles[tileIndex];
    var layersCount = tile.codingStyleDefaultParameters.layersCount;
    var componentsCount = siz.Csiz;
    var l, r, c, p;
    var maxDecompositionLevelsCount = 0;
    for (c = 0; c < componentsCount; c++) {
      var component = tile.components[c];
      maxDecompositionLevelsCount = Math.max(maxDecompositionLevelsCount, component.codingStyleParameters.decompositionLevelsCount);
    }
    var maxNumPrecinctsInLevel = new Int32Array(maxDecompositionLevelsCount + 1);
    for (r = 0; r <= maxDecompositionLevelsCount; ++r) {
      var maxNumPrecincts = 0;
      for (c = 0; c < componentsCount; ++c) {
        var resolutions = tile.components[c].resolutions;
        if (r < resolutions.length) {
          maxNumPrecincts = Math.max(maxNumPrecincts, resolutions[r].precinctParameters.numprecincts);
        }
      }
      maxNumPrecinctsInLevel[r] = maxNumPrecincts;
    }
    l = 0;
    r = 0;
    c = 0;
    p = 0;
    this.nextPacket = function JpxImage_nextPacket() {
      for (; r <= maxDecompositionLevelsCount; r++) {
        for (; p < maxNumPrecinctsInLevel[r]; p++) {
          for (; c < componentsCount; c++) {
            var component = tile.components[c];
            if (r > component.codingStyleParameters.decompositionLevelsCount) {
              continue;
            }
            var resolution = component.resolutions[r];
            var numprecincts = resolution.precinctParameters.numprecincts;
            if (p >= numprecincts) {
              continue;
            }
            for (; l < layersCount;) {
              var packet = createPacket(resolution, p, l);
              l++;
              return packet;
            }
            l = 0;
          }
          c = 0;
        }
        p = 0;
      }
      throw new JpxError('Out of packets');
    };
  }
  function PositionComponentResolutionLayerIterator(context) {
    var siz = context.SIZ;
    var tileIndex = context.currentTile.index;
    var tile = context.tiles[tileIndex];
    var layersCount = tile.codingStyleDefaultParameters.layersCount;
    var componentsCount = siz.Csiz;
    var precinctsSizes = getPrecinctSizesInImageScale(tile);
    var precinctsIterationSizes = precinctsSizes;
    var l = 0,
        r = 0,
        c = 0,
        px = 0,
        py = 0;
    this.nextPacket = function JpxImage_nextPacket() {
      for (; py < precinctsIterationSizes.maxNumHigh; py++) {
        for (; px < precinctsIterationSizes.maxNumWide; px++) {
          for (; c < componentsCount; c++) {
            var component = tile.components[c];
            var decompositionLevelsCount = component.codingStyleParameters.decompositionLevelsCount;
            for (; r <= decompositionLevelsCount; r++) {
              var resolution = component.resolutions[r];
              var sizeInImageScale = precinctsSizes.components[c].resolutions[r];
              var k = getPrecinctIndexIfExist(px, py, sizeInImageScale, precinctsIterationSizes, resolution);
              if (k === null) {
                continue;
              }
              for (; l < layersCount;) {
                var packet = createPacket(resolution, k, l);
                l++;
                return packet;
              }
              l = 0;
            }
            r = 0;
          }
          c = 0;
        }
        px = 0;
      }
      throw new JpxError('Out of packets');
    };
  }
  function ComponentPositionResolutionLayerIterator(context) {
    var siz = context.SIZ;
    var tileIndex = context.currentTile.index;
    var tile = context.tiles[tileIndex];
    var layersCount = tile.codingStyleDefaultParameters.layersCount;
    var componentsCount = siz.Csiz;
    var precinctsSizes = getPrecinctSizesInImageScale(tile);
    var l = 0,
        r = 0,
        c = 0,
        px = 0,
        py = 0;
    this.nextPacket = function JpxImage_nextPacket() {
      for (; c < componentsCount; ++c) {
        var component = tile.components[c];
        var precinctsIterationSizes = precinctsSizes.components[c];
        var decompositionLevelsCount = component.codingStyleParameters.decompositionLevelsCount;
        for (; py < precinctsIterationSizes.maxNumHigh; py++) {
          for (; px < precinctsIterationSizes.maxNumWide; px++) {
            for (; r <= decompositionLevelsCount; r++) {
              var resolution = component.resolutions[r];
              var sizeInImageScale = precinctsIterationSizes.resolutions[r];
              var k = getPrecinctIndexIfExist(px, py, sizeInImageScale, precinctsIterationSizes, resolution);
              if (k === null) {
                continue;
              }
              for (; l < layersCount;) {
                var packet = createPacket(resolution, k, l);
                l++;
                return packet;
              }
              l = 0;
            }
            r = 0;
          }
          px = 0;
        }
        py = 0;
      }
      throw new JpxError('Out of packets');
    };
  }
  function getPrecinctIndexIfExist(pxIndex, pyIndex, sizeInImageScale, precinctIterationSizes, resolution) {
    var posX = pxIndex * precinctIterationSizes.minWidth;
    var posY = pyIndex * precinctIterationSizes.minHeight;
    if (posX % sizeInImageScale.width !== 0 || posY % sizeInImageScale.height !== 0) {
      return null;
    }
    var startPrecinctRowIndex = posY / sizeInImageScale.width * resolution.precinctParameters.numprecinctswide;
    return posX / sizeInImageScale.height + startPrecinctRowIndex;
  }
  function getPrecinctSizesInImageScale(tile) {
    var componentsCount = tile.components.length;
    var minWidth = Number.MAX_VALUE;
    var minHeight = Number.MAX_VALUE;
    var maxNumWide = 0;
    var maxNumHigh = 0;
    var sizePerComponent = new Array(componentsCount);
    for (var c = 0; c < componentsCount; c++) {
      var component = tile.components[c];
      var decompositionLevelsCount = component.codingStyleParameters.decompositionLevelsCount;
      var sizePerResolution = new Array(decompositionLevelsCount + 1);
      var minWidthCurrentComponent = Number.MAX_VALUE;
      var minHeightCurrentComponent = Number.MAX_VALUE;
      var maxNumWideCurrentComponent = 0;
      var maxNumHighCurrentComponent = 0;
      var scale = 1;
      for (var r = decompositionLevelsCount; r >= 0; --r) {
        var resolution = component.resolutions[r];
        var widthCurrentResolution = scale * resolution.precinctParameters.precinctWidth;
        var heightCurrentResolution = scale * resolution.precinctParameters.precinctHeight;
        minWidthCurrentComponent = Math.min(minWidthCurrentComponent, widthCurrentResolution);
        minHeightCurrentComponent = Math.min(minHeightCurrentComponent, heightCurrentResolution);
        maxNumWideCurrentComponent = Math.max(maxNumWideCurrentComponent, resolution.precinctParameters.numprecinctswide);
        maxNumHighCurrentComponent = Math.max(maxNumHighCurrentComponent, resolution.precinctParameters.numprecinctshigh);
        sizePerResolution[r] = {
          width: widthCurrentResolution,
          height: heightCurrentResolution
        };
        scale <<= 1;
      }
      minWidth = Math.min(minWidth, minWidthCurrentComponent);
      minHeight = Math.min(minHeight, minHeightCurrentComponent);
      maxNumWide = Math.max(maxNumWide, maxNumWideCurrentComponent);
      maxNumHigh = Math.max(maxNumHigh, maxNumHighCurrentComponent);
      sizePerComponent[c] = {
        resolutions: sizePerResolution,
        minWidth: minWidthCurrentComponent,
        minHeight: minHeightCurrentComponent,
        maxNumWide: maxNumWideCurrentComponent,
        maxNumHigh: maxNumHighCurrentComponent
      };
    }
    return {
      components: sizePerComponent,
      minWidth: minWidth,
      minHeight: minHeight,
      maxNumWide: maxNumWide,
      maxNumHigh: maxNumHigh
    };
  }
  function buildPackets(context) {
    var siz = context.SIZ;
    var tileIndex = context.currentTile.index;
    var tile = context.tiles[tileIndex];
    var componentsCount = siz.Csiz;
    for (var c = 0; c < componentsCount; c++) {
      var component = tile.components[c];
      var decompositionLevelsCount = component.codingStyleParameters.decompositionLevelsCount;
      var resolutions = [];
      var subbands = [];
      for (var r = 0; r <= decompositionLevelsCount; r++) {
        var blocksDimensions = getBlocksDimensions(context, component, r);
        var resolution = {};
        var scale = 1 << decompositionLevelsCount - r;
        resolution.trx0 = Math.ceil(component.tcx0 / scale);
        resolution.try0 = Math.ceil(component.tcy0 / scale);
        resolution.trx1 = Math.ceil(component.tcx1 / scale);
        resolution.try1 = Math.ceil(component.tcy1 / scale);
        resolution.resLevel = r;
        buildPrecincts(context, resolution, blocksDimensions);
        resolutions.push(resolution);
        var subband;
        if (r === 0) {
          subband = {};
          subband.type = 'LL';
          subband.tbx0 = Math.ceil(component.tcx0 / scale);
          subband.tby0 = Math.ceil(component.tcy0 / scale);
          subband.tbx1 = Math.ceil(component.tcx1 / scale);
          subband.tby1 = Math.ceil(component.tcy1 / scale);
          subband.resolution = resolution;
          buildCodeblocks(context, subband, blocksDimensions);
          subbands.push(subband);
          resolution.subbands = [subband];
        } else {
          var bscale = 1 << decompositionLevelsCount - r + 1;
          var resolutionSubbands = [];
          subband = {};
          subband.type = 'HL';
          subband.tbx0 = Math.ceil(component.tcx0 / bscale - 0.5);
          subband.tby0 = Math.ceil(component.tcy0 / bscale);
          subband.tbx1 = Math.ceil(component.tcx1 / bscale - 0.5);
          subband.tby1 = Math.ceil(component.tcy1 / bscale);
          subband.resolution = resolution;
          buildCodeblocks(context, subband, blocksDimensions);
          subbands.push(subband);
          resolutionSubbands.push(subband);
          subband = {};
          subband.type = 'LH';
          subband.tbx0 = Math.ceil(component.tcx0 / bscale);
          subband.tby0 = Math.ceil(component.tcy0 / bscale - 0.5);
          subband.tbx1 = Math.ceil(component.tcx1 / bscale);
          subband.tby1 = Math.ceil(component.tcy1 / bscale - 0.5);
          subband.resolution = resolution;
          buildCodeblocks(context, subband, blocksDimensions);
          subbands.push(subband);
          resolutionSubbands.push(subband);
          subband = {};
          subband.type = 'HH';
          subband.tbx0 = Math.ceil(component.tcx0 / bscale - 0.5);
          subband.tby0 = Math.ceil(component.tcy0 / bscale - 0.5);
          subband.tbx1 = Math.ceil(component.tcx1 / bscale - 0.5);
          subband.tby1 = Math.ceil(component.tcy1 / bscale - 0.5);
          subband.resolution = resolution;
          buildCodeblocks(context, subband, blocksDimensions);
          subbands.push(subband);
          resolutionSubbands.push(subband);
          resolution.subbands = resolutionSubbands;
        }
      }
      component.resolutions = resolutions;
      component.subbands = subbands;
    }
    var progressionOrder = tile.codingStyleDefaultParameters.progressionOrder;
    switch (progressionOrder) {
      case 0:
        tile.packetsIterator = new LayerResolutionComponentPositionIterator(context);
        break;
      case 1:
        tile.packetsIterator = new ResolutionLayerComponentPositionIterator(context);
        break;
      case 2:
        tile.packetsIterator = new ResolutionPositionComponentLayerIterator(context);
        break;
      case 3:
        tile.packetsIterator = new PositionComponentResolutionLayerIterator(context);
        break;
      case 4:
        tile.packetsIterator = new ComponentPositionResolutionLayerIterator(context);
        break;
      default:
        throw new JpxError('Unsupported progression order ' + progressionOrder);
    }
  }
  function parseTilePackets(context, data, offset, dataLength) {
    var position = 0;
    var buffer,
        bufferSize = 0,
        skipNextBit = false;
    function readBits(count) {
      while (bufferSize < count) {
        var b = data[offset + position];
        position++;
        if (skipNextBit) {
          buffer = buffer << 7 | b;
          bufferSize += 7;
          skipNextBit = false;
        } else {
          buffer = buffer << 8 | b;
          bufferSize += 8;
        }
        if (b === 0xFF) {
          skipNextBit = true;
        }
      }
      bufferSize -= count;
      return buffer >>> bufferSize & (1 << count) - 1;
    }
    function skipMarkerIfEqual(value) {
      if (data[offset + position - 1] === 0xFF && data[offset + position] === value) {
        skipBytes(1);
        return true;
      } else if (data[offset + position] === 0xFF && data[offset + position + 1] === value) {
        skipBytes(2);
        return true;
      }
      return false;
    }
    function skipBytes(count) {
      position += count;
    }
    function alignToByte() {
      bufferSize = 0;
      if (skipNextBit) {
        position++;
        skipNextBit = false;
      }
    }
    function readCodingpasses() {
      if (readBits(1) === 0) {
        return 1;
      }
      if (readBits(1) === 0) {
        return 2;
      }
      var value = readBits(2);
      if (value < 3) {
        return value + 3;
      }
      value = readBits(5);
      if (value < 31) {
        return value + 6;
      }
      value = readBits(7);
      return value + 37;
    }
    var tileIndex = context.currentTile.index;
    var tile = context.tiles[tileIndex];
    var sopMarkerUsed = context.COD.sopMarkerUsed;
    var ephMarkerUsed = context.COD.ephMarkerUsed;
    var packetsIterator = tile.packetsIterator;
    while (position < dataLength) {
      alignToByte();
      if (sopMarkerUsed && skipMarkerIfEqual(0x91)) {
        skipBytes(4);
      }
      var packet = packetsIterator.nextPacket();
      if (!readBits(1)) {
        continue;
      }
      var layerNumber = packet.layerNumber;
      var queue = [],
          codeblock;
      for (var i = 0, ii = packet.codeblocks.length; i < ii; i++) {
        codeblock = packet.codeblocks[i];
        var precinct = codeblock.precinct;
        var codeblockColumn = codeblock.cbx - precinct.cbxMin;
        var codeblockRow = codeblock.cby - precinct.cbyMin;
        var codeblockIncluded = false;
        var firstTimeInclusion = false;
        var valueReady;
        if (codeblock['included'] !== undefined) {
          codeblockIncluded = !!readBits(1);
        } else {
          precinct = codeblock.precinct;
          var inclusionTree, zeroBitPlanesTree;
          if (precinct['inclusionTree'] !== undefined) {
            inclusionTree = precinct.inclusionTree;
          } else {
            var width = precinct.cbxMax - precinct.cbxMin + 1;
            var height = precinct.cbyMax - precinct.cbyMin + 1;
            inclusionTree = new InclusionTree(width, height, layerNumber);
            zeroBitPlanesTree = new TagTree(width, height);
            precinct.inclusionTree = inclusionTree;
            precinct.zeroBitPlanesTree = zeroBitPlanesTree;
          }
          if (inclusionTree.reset(codeblockColumn, codeblockRow, layerNumber)) {
            while (true) {
              if (readBits(1)) {
                valueReady = !inclusionTree.nextLevel();
                if (valueReady) {
                  codeblock.included = true;
                  codeblockIncluded = firstTimeInclusion = true;
                  break;
                }
              } else {
                inclusionTree.incrementValue(layerNumber);
                break;
              }
            }
          }
        }
        if (!codeblockIncluded) {
          continue;
        }
        if (firstTimeInclusion) {
          zeroBitPlanesTree = precinct.zeroBitPlanesTree;
          zeroBitPlanesTree.reset(codeblockColumn, codeblockRow);
          while (true) {
            if (readBits(1)) {
              valueReady = !zeroBitPlanesTree.nextLevel();
              if (valueReady) {
                break;
              }
            } else {
              zeroBitPlanesTree.incrementValue();
            }
          }
          codeblock.zeroBitPlanes = zeroBitPlanesTree.value;
        }
        var codingpasses = readCodingpasses();
        while (readBits(1)) {
          codeblock.Lblock++;
        }
        var codingpassesLog2 = (0, _util.log2)(codingpasses);
        var bits = (codingpasses < 1 << codingpassesLog2 ? codingpassesLog2 - 1 : codingpassesLog2) + codeblock.Lblock;
        var codedDataLength = readBits(bits);
        queue.push({
          codeblock: codeblock,
          codingpasses: codingpasses,
          dataLength: codedDataLength
        });
      }
      alignToByte();
      if (ephMarkerUsed) {
        skipMarkerIfEqual(0x92);
      }
      while (queue.length > 0) {
        var packetItem = queue.shift();
        codeblock = packetItem.codeblock;
        if (codeblock['data'] === undefined) {
          codeblock.data = [];
        }
        codeblock.data.push({
          data: data,
          start: offset + position,
          end: offset + position + packetItem.dataLength,
          codingpasses: packetItem.codingpasses
        });
        position += packetItem.dataLength;
      }
    }
    return position;
  }
  function copyCoefficients(coefficients, levelWidth, levelHeight, subband, delta, mb, reversible, segmentationSymbolUsed) {
    var x0 = subband.tbx0;
    var y0 = subband.tby0;
    var width = subband.tbx1 - subband.tbx0;
    var codeblocks = subband.codeblocks;
    var right = subband.type.charAt(0) === 'H' ? 1 : 0;
    var bottom = subband.type.charAt(1) === 'H' ? levelWidth : 0;
    for (var i = 0, ii = codeblocks.length; i < ii; ++i) {
      var codeblock = codeblocks[i];
      var blockWidth = codeblock.tbx1_ - codeblock.tbx0_;
      var blockHeight = codeblock.tby1_ - codeblock.tby0_;
      if (blockWidth === 0 || blockHeight === 0) {
        continue;
      }
      if (codeblock['data'] === undefined) {
        continue;
      }
      var bitModel, currentCodingpassType;
      bitModel = new BitModel(blockWidth, blockHeight, codeblock.subbandType, codeblock.zeroBitPlanes, mb);
      currentCodingpassType = 2;
      var data = codeblock.data,
          totalLength = 0,
          codingpasses = 0;
      var j, jj, dataItem;
      for (j = 0, jj = data.length; j < jj; j++) {
        dataItem = data[j];
        totalLength += dataItem.end - dataItem.start;
        codingpasses += dataItem.codingpasses;
      }
      var encodedData = new Uint8Array(totalLength);
      var position = 0;
      for (j = 0, jj = data.length; j < jj; j++) {
        dataItem = data[j];
        var chunk = dataItem.data.subarray(dataItem.start, dataItem.end);
        encodedData.set(chunk, position);
        position += chunk.length;
      }
      var decoder = new _arithmetic_decoder.ArithmeticDecoder(encodedData, 0, totalLength);
      bitModel.setDecoder(decoder);
      for (j = 0; j < codingpasses; j++) {
        switch (currentCodingpassType) {
          case 0:
            bitModel.runSignificancePropagationPass();
            break;
          case 1:
            bitModel.runMagnitudeRefinementPass();
            break;
          case 2:
            bitModel.runCleanupPass();
            if (segmentationSymbolUsed) {
              bitModel.checkSegmentationSymbol();
            }
            break;
        }
        currentCodingpassType = (currentCodingpassType + 1) % 3;
      }
      var offset = codeblock.tbx0_ - x0 + (codeblock.tby0_ - y0) * width;
      var sign = bitModel.coefficentsSign;
      var magnitude = bitModel.coefficentsMagnitude;
      var bitsDecoded = bitModel.bitsDecoded;
      var magnitudeCorrection = reversible ? 0 : 0.5;
      var k, n, nb;
      position = 0;
      var interleave = subband.type !== 'LL';
      for (j = 0; j < blockHeight; j++) {
        var row = offset / width | 0;
        var levelOffset = 2 * row * (levelWidth - width) + right + bottom;
        for (k = 0; k < blockWidth; k++) {
          n = magnitude[position];
          if (n !== 0) {
            n = (n + magnitudeCorrection) * delta;
            if (sign[position] !== 0) {
              n = -n;
            }
            nb = bitsDecoded[position];
            var pos = interleave ? levelOffset + (offset << 1) : offset;
            if (reversible && nb >= mb) {
              coefficients[pos] = n;
            } else {
              coefficients[pos] = n * (1 << mb - nb);
            }
          }
          offset++;
          position++;
        }
        offset += width - blockWidth;
      }
    }
  }
  function transformTile(context, tile, c) {
    var component = tile.components[c];
    var codingStyleParameters = component.codingStyleParameters;
    var quantizationParameters = component.quantizationParameters;
    var decompositionLevelsCount = codingStyleParameters.decompositionLevelsCount;
    var spqcds = quantizationParameters.SPqcds;
    var scalarExpounded = quantizationParameters.scalarExpounded;
    var guardBits = quantizationParameters.guardBits;
    var segmentationSymbolUsed = codingStyleParameters.segmentationSymbolUsed;
    var precision = context.components[c].precision;
    var reversible = codingStyleParameters.reversibleTransformation;
    var transform = reversible ? new ReversibleTransform() : new IrreversibleTransform();
    var subbandCoefficients = [];
    var b = 0;
    for (var i = 0; i <= decompositionLevelsCount; i++) {
      var resolution = component.resolutions[i];
      var width = resolution.trx1 - resolution.trx0;
      var height = resolution.try1 - resolution.try0;
      var coefficients = new Float32Array(width * height);
      for (var j = 0, jj = resolution.subbands.length; j < jj; j++) {
        var mu, epsilon;
        if (!scalarExpounded) {
          mu = spqcds[0].mu;
          epsilon = spqcds[0].epsilon + (i > 0 ? 1 - i : 0);
        } else {
          mu = spqcds[b].mu;
          epsilon = spqcds[b].epsilon;
          b++;
        }
        var subband = resolution.subbands[j];
        var gainLog2 = SubbandsGainLog2[subband.type];
        var delta = reversible ? 1 : Math.pow(2, precision + gainLog2 - epsilon) * (1 + mu / 2048);
        var mb = guardBits + epsilon - 1;
        copyCoefficients(coefficients, width, height, subband, delta, mb, reversible, segmentationSymbolUsed);
      }
      subbandCoefficients.push({
        width: width,
        height: height,
        items: coefficients
      });
    }
    var result = transform.calculate(subbandCoefficients, component.tcx0, component.tcy0);
    return {
      left: component.tcx0,
      top: component.tcy0,
      width: result.width,
      height: result.height,
      items: result.items
    };
  }
  function transformComponents(context) {
    var siz = context.SIZ;
    var components = context.components;
    var componentsCount = siz.Csiz;
    var resultImages = [];
    for (var i = 0, ii = context.tiles.length; i < ii; i++) {
      var tile = context.tiles[i];
      var transformedTiles = [];
      var c;
      for (c = 0; c < componentsCount; c++) {
        transformedTiles[c] = transformTile(context, tile, c);
      }
      var tile0 = transformedTiles[0];
      var out = new Uint8Array(tile0.items.length * componentsCount);
      var result = {
        left: tile0.left,
        top: tile0.top,
        width: tile0.width,
        height: tile0.height,
        items: out
      };
      var shift, offset, max, min, maxK;
      var pos = 0,
          j,
          jj,
          y0,
          y1,
          y2,
          r,
          g,
          b,
          k,
          val;
      if (tile.codingStyleDefaultParameters.multipleComponentTransform) {
        var fourComponents = componentsCount === 4;
        var y0items = transformedTiles[0].items;
        var y1items = transformedTiles[1].items;
        var y2items = transformedTiles[2].items;
        var y3items = fourComponents ? transformedTiles[3].items : null;
        shift = components[0].precision - 8;
        offset = (128 << shift) + 0.5;
        max = 255 * (1 << shift);
        maxK = max * 0.5;
        min = -maxK;
        var component0 = tile.components[0];
        var alpha01 = componentsCount - 3;
        jj = y0items.length;
        if (!component0.codingStyleParameters.reversibleTransformation) {
          for (j = 0; j < jj; j++, pos += alpha01) {
            y0 = y0items[j] + offset;
            y1 = y1items[j];
            y2 = y2items[j];
            r = y0 + 1.402 * y2;
            g = y0 - 0.34413 * y1 - 0.71414 * y2;
            b = y0 + 1.772 * y1;
            out[pos++] = r <= 0 ? 0 : r >= max ? 255 : r >> shift;
            out[pos++] = g <= 0 ? 0 : g >= max ? 255 : g >> shift;
            out[pos++] = b <= 0 ? 0 : b >= max ? 255 : b >> shift;
          }
        } else {
          for (j = 0; j < jj; j++, pos += alpha01) {
            y0 = y0items[j] + offset;
            y1 = y1items[j];
            y2 = y2items[j];
            g = y0 - (y2 + y1 >> 2);
            r = g + y2;
            b = g + y1;
            out[pos++] = r <= 0 ? 0 : r >= max ? 255 : r >> shift;
            out[pos++] = g <= 0 ? 0 : g >= max ? 255 : g >> shift;
            out[pos++] = b <= 0 ? 0 : b >= max ? 255 : b >> shift;
          }
        }
        if (fourComponents) {
          for (j = 0, pos = 3; j < jj; j++, pos += 4) {
            k = y3items[j];
            out[pos] = k <= min ? 0 : k >= maxK ? 255 : k + offset >> shift;
          }
        }
      } else {
        for (c = 0; c < componentsCount; c++) {
          var items = transformedTiles[c].items;
          shift = components[c].precision - 8;
          offset = (128 << shift) + 0.5;
          max = 127.5 * (1 << shift);
          min = -max;
          for (pos = c, j = 0, jj = items.length; j < jj; j++) {
            val = items[j];
            out[pos] = val <= min ? 0 : val >= max ? 255 : val + offset >> shift;
            pos += componentsCount;
          }
        }
      }
      resultImages.push(result);
    }
    return resultImages;
  }
  function initializeTile(context, tileIndex) {
    var siz = context.SIZ;
    var componentsCount = siz.Csiz;
    var tile = context.tiles[tileIndex];
    for (var c = 0; c < componentsCount; c++) {
      var component = tile.components[c];
      var qcdOrQcc = context.currentTile.QCC[c] !== undefined ? context.currentTile.QCC[c] : context.currentTile.QCD;
      component.quantizationParameters = qcdOrQcc;
      var codOrCoc = context.currentTile.COC[c] !== undefined ? context.currentTile.COC[c] : context.currentTile.COD;
      component.codingStyleParameters = codOrCoc;
    }
    tile.codingStyleDefaultParameters = context.currentTile.COD;
  }
  var TagTree = function TagTreeClosure() {
    function TagTree(width, height) {
      var levelsLength = (0, _util.log2)(Math.max(width, height)) + 1;
      this.levels = [];
      for (var i = 0; i < levelsLength; i++) {
        var level = {
          width: width,
          height: height,
          items: []
        };
        this.levels.push(level);
        width = Math.ceil(width / 2);
        height = Math.ceil(height / 2);
      }
    }
    TagTree.prototype = {
      reset: function TagTree_reset(i, j) {
        var currentLevel = 0,
            value = 0,
            level;
        while (currentLevel < this.levels.length) {
          level = this.levels[currentLevel];
          var index = i + j * level.width;
          if (level.items[index] !== undefined) {
            value = level.items[index];
            break;
          }
          level.index = index;
          i >>= 1;
          j >>= 1;
          currentLevel++;
        }
        currentLevel--;
        level = this.levels[currentLevel];
        level.items[level.index] = value;
        this.currentLevel = currentLevel;
        delete this.value;
      },
      incrementValue: function TagTree_incrementValue() {
        var level = this.levels[this.currentLevel];
        level.items[level.index]++;
      },
      nextLevel: function TagTree_nextLevel() {
        var currentLevel = this.currentLevel;
        var level = this.levels[currentLevel];
        var value = level.items[level.index];
        currentLevel--;
        if (currentLevel < 0) {
          this.value = value;
          return false;
        }
        this.currentLevel = currentLevel;
        level = this.levels[currentLevel];
        level.items[level.index] = value;
        return true;
      }
    };
    return TagTree;
  }();
  var InclusionTree = function InclusionTreeClosure() {
    function InclusionTree(width, height, defaultValue) {
      var levelsLength = (0, _util.log2)(Math.max(width, height)) + 1;
      this.levels = [];
      for (var i = 0; i < levelsLength; i++) {
        var items = new Uint8Array(width * height);
        for (var j = 0, jj = items.length; j < jj; j++) {
          items[j] = defaultValue;
        }
        var level = {
          width: width,
          height: height,
          items: items
        };
        this.levels.push(level);
        width = Math.ceil(width / 2);
        height = Math.ceil(height / 2);
      }
    }
    InclusionTree.prototype = {
      reset: function InclusionTree_reset(i, j, stopValue) {
        var currentLevel = 0;
        while (currentLevel < this.levels.length) {
          var level = this.levels[currentLevel];
          var index = i + j * level.width;
          level.index = index;
          var value = level.items[index];
          if (value === 0xFF) {
            break;
          }
          if (value > stopValue) {
            this.currentLevel = currentLevel;
            this.propagateValues();
            return false;
          }
          i >>= 1;
          j >>= 1;
          currentLevel++;
        }
        this.currentLevel = currentLevel - 1;
        return true;
      },
      incrementValue: function InclusionTree_incrementValue(stopValue) {
        var level = this.levels[this.currentLevel];
        level.items[level.index] = stopValue + 1;
        this.propagateValues();
      },
      propagateValues: function InclusionTree_propagateValues() {
        var levelIndex = this.currentLevel;
        var level = this.levels[levelIndex];
        var currentValue = level.items[level.index];
        while (--levelIndex >= 0) {
          level = this.levels[levelIndex];
          level.items[level.index] = currentValue;
        }
      },
      nextLevel: function InclusionTree_nextLevel() {
        var currentLevel = this.currentLevel;
        var level = this.levels[currentLevel];
        var value = level.items[level.index];
        level.items[level.index] = 0xFF;
        currentLevel--;
        if (currentLevel < 0) {
          return false;
        }
        this.currentLevel = currentLevel;
        level = this.levels[currentLevel];
        level.items[level.index] = value;
        return true;
      }
    };
    return InclusionTree;
  }();
  var BitModel = function BitModelClosure() {
    var UNIFORM_CONTEXT = 17;
    var RUNLENGTH_CONTEXT = 18;
    var LLAndLHContextsLabel = new Uint8Array([0, 5, 8, 0, 3, 7, 8, 0, 4, 7, 8, 0, 0, 0, 0, 0, 1, 6, 8, 0, 3, 7, 8, 0, 4, 7, 8, 0, 0, 0, 0, 0, 2, 6, 8, 0, 3, 7, 8, 0, 4, 7, 8, 0, 0, 0, 0, 0, 2, 6, 8, 0, 3, 7, 8, 0, 4, 7, 8, 0, 0, 0, 0, 0, 2, 6, 8, 0, 3, 7, 8, 0, 4, 7, 8]);
    var HLContextLabel = new Uint8Array([0, 3, 4, 0, 5, 7, 7, 0, 8, 8, 8, 0, 0, 0, 0, 0, 1, 3, 4, 0, 6, 7, 7, 0, 8, 8, 8, 0, 0, 0, 0, 0, 2, 3, 4, 0, 6, 7, 7, 0, 8, 8, 8, 0, 0, 0, 0, 0, 2, 3, 4, 0, 6, 7, 7, 0, 8, 8, 8, 0, 0, 0, 0, 0, 2, 3, 4, 0, 6, 7, 7, 0, 8, 8, 8]);
    var HHContextLabel = new Uint8Array([0, 1, 2, 0, 1, 2, 2, 0, 2, 2, 2, 0, 0, 0, 0, 0, 3, 4, 5, 0, 4, 5, 5, 0, 5, 5, 5, 0, 0, 0, 0, 0, 6, 7, 7, 0, 7, 7, 7, 0, 7, 7, 7, 0, 0, 0, 0, 0, 8, 8, 8, 0, 8, 8, 8, 0, 8, 8, 8, 0, 0, 0, 0, 0, 8, 8, 8, 0, 8, 8, 8, 0, 8, 8, 8]);
    function BitModel(width, height, subband, zeroBitPlanes, mb) {
      this.width = width;
      this.height = height;
      this.contextLabelTable = subband === 'HH' ? HHContextLabel : subband === 'HL' ? HLContextLabel : LLAndLHContextsLabel;
      var coefficientCount = width * height;
      this.neighborsSignificance = new Uint8Array(coefficientCount);
      this.coefficentsSign = new Uint8Array(coefficientCount);
      this.coefficentsMagnitude = mb > 14 ? new Uint32Array(coefficientCount) : mb > 6 ? new Uint16Array(coefficientCount) : new Uint8Array(coefficientCount);
      this.processingFlags = new Uint8Array(coefficientCount);
      var bitsDecoded = new Uint8Array(coefficientCount);
      if (zeroBitPlanes !== 0) {
        for (var i = 0; i < coefficientCount; i++) {
          bitsDecoded[i] = zeroBitPlanes;
        }
      }
      this.bitsDecoded = bitsDecoded;
      this.reset();
    }
    BitModel.prototype = {
      setDecoder: function BitModel_setDecoder(decoder) {
        this.decoder = decoder;
      },
      reset: function BitModel_reset() {
        this.contexts = new Int8Array(19);
        this.contexts[0] = 4 << 1 | 0;
        this.contexts[UNIFORM_CONTEXT] = 46 << 1 | 0;
        this.contexts[RUNLENGTH_CONTEXT] = 3 << 1 | 0;
      },
      setNeighborsSignificance: function BitModel_setNeighborsSignificance(row, column, index) {
        var neighborsSignificance = this.neighborsSignificance;
        var width = this.width,
            height = this.height;
        var left = column > 0;
        var right = column + 1 < width;
        var i;
        if (row > 0) {
          i = index - width;
          if (left) {
            neighborsSignificance[i - 1] += 0x10;
          }
          if (right) {
            neighborsSignificance[i + 1] += 0x10;
          }
          neighborsSignificance[i] += 0x04;
        }
        if (row + 1 < height) {
          i = index + width;
          if (left) {
            neighborsSignificance[i - 1] += 0x10;
          }
          if (right) {
            neighborsSignificance[i + 1] += 0x10;
          }
          neighborsSignificance[i] += 0x04;
        }
        if (left) {
          neighborsSignificance[index - 1] += 0x01;
        }
        if (right) {
          neighborsSignificance[index + 1] += 0x01;
        }
        neighborsSignificance[index] |= 0x80;
      },
      runSignificancePropagationPass: function BitModel_runSignificancePropagationPass() {
        var decoder = this.decoder;
        var width = this.width,
            height = this.height;
        var coefficentsMagnitude = this.coefficentsMagnitude;
        var coefficentsSign = this.coefficentsSign;
        var neighborsSignificance = this.neighborsSignificance;
        var processingFlags = this.processingFlags;
        var contexts = this.contexts;
        var labels = this.contextLabelTable;
        var bitsDecoded = this.bitsDecoded;
        var processedInverseMask = ~1;
        var processedMask = 1;
        var firstMagnitudeBitMask = 2;
        for (var i0 = 0; i0 < height; i0 += 4) {
          for (var j = 0; j < width; j++) {
            var index = i0 * width + j;
            for (var i1 = 0; i1 < 4; i1++, index += width) {
              var i = i0 + i1;
              if (i >= height) {
                break;
              }
              processingFlags[index] &= processedInverseMask;
              if (coefficentsMagnitude[index] || !neighborsSignificance[index]) {
                continue;
              }
              var contextLabel = labels[neighborsSignificance[index]];
              var decision = decoder.readBit(contexts, contextLabel);
              if (decision) {
                var sign = this.decodeSignBit(i, j, index);
                coefficentsSign[index] = sign;
                coefficentsMagnitude[index] = 1;
                this.setNeighborsSignificance(i, j, index);
                processingFlags[index] |= firstMagnitudeBitMask;
              }
              bitsDecoded[index]++;
              processingFlags[index] |= processedMask;
            }
          }
        }
      },
      decodeSignBit: function BitModel_decodeSignBit(row, column, index) {
        var width = this.width,
            height = this.height;
        var coefficentsMagnitude = this.coefficentsMagnitude;
        var coefficentsSign = this.coefficentsSign;
        var contribution, sign0, sign1, significance1;
        var contextLabel, decoded;
        significance1 = column > 0 && coefficentsMagnitude[index - 1] !== 0;
        if (column + 1 < width && coefficentsMagnitude[index + 1] !== 0) {
          sign1 = coefficentsSign[index + 1];
          if (significance1) {
            sign0 = coefficentsSign[index - 1];
            contribution = 1 - sign1 - sign0;
          } else {
            contribution = 1 - sign1 - sign1;
          }
        } else if (significance1) {
          sign0 = coefficentsSign[index - 1];
          contribution = 1 - sign0 - sign0;
        } else {
          contribution = 0;
        }
        var horizontalContribution = 3 * contribution;
        significance1 = row > 0 && coefficentsMagnitude[index - width] !== 0;
        if (row + 1 < height && coefficentsMagnitude[index + width] !== 0) {
          sign1 = coefficentsSign[index + width];
          if (significance1) {
            sign0 = coefficentsSign[index - width];
            contribution = 1 - sign1 - sign0 + horizontalContribution;
          } else {
            contribution = 1 - sign1 - sign1 + horizontalContribution;
          }
        } else if (significance1) {
          sign0 = coefficentsSign[index - width];
          contribution = 1 - sign0 - sign0 + horizontalContribution;
        } else {
          contribution = horizontalContribution;
        }
        if (contribution >= 0) {
          contextLabel = 9 + contribution;
          decoded = this.decoder.readBit(this.contexts, contextLabel);
        } else {
          contextLabel = 9 - contribution;
          decoded = this.decoder.readBit(this.contexts, contextLabel) ^ 1;
        }
        return decoded;
      },
      runMagnitudeRefinementPass: function BitModel_runMagnitudeRefinementPass() {
        var decoder = this.decoder;
        var width = this.width,
            height = this.height;
        var coefficentsMagnitude = this.coefficentsMagnitude;
        var neighborsSignificance = this.neighborsSignificance;
        var contexts = this.contexts;
        var bitsDecoded = this.bitsDecoded;
        var processingFlags = this.processingFlags;
        var processedMask = 1;
        var firstMagnitudeBitMask = 2;
        var length = width * height;
        var width4 = width * 4;
        for (var index0 = 0, indexNext; index0 < length; index0 = indexNext) {
          indexNext = Math.min(length, index0 + width4);
          for (var j = 0; j < width; j++) {
            for (var index = index0 + j; index < indexNext; index += width) {
              if (!coefficentsMagnitude[index] || (processingFlags[index] & processedMask) !== 0) {
                continue;
              }
              var contextLabel = 16;
              if ((processingFlags[index] & firstMagnitudeBitMask) !== 0) {
                processingFlags[index] ^= firstMagnitudeBitMask;
                var significance = neighborsSignificance[index] & 127;
                contextLabel = significance === 0 ? 15 : 14;
              }
              var bit = decoder.readBit(contexts, contextLabel);
              coefficentsMagnitude[index] = coefficentsMagnitude[index] << 1 | bit;
              bitsDecoded[index]++;
              processingFlags[index] |= processedMask;
            }
          }
        }
      },
      runCleanupPass: function BitModel_runCleanupPass() {
        var decoder = this.decoder;
        var width = this.width,
            height = this.height;
        var neighborsSignificance = this.neighborsSignificance;
        var coefficentsMagnitude = this.coefficentsMagnitude;
        var coefficentsSign = this.coefficentsSign;
        var contexts = this.contexts;
        var labels = this.contextLabelTable;
        var bitsDecoded = this.bitsDecoded;
        var processingFlags = this.processingFlags;
        var processedMask = 1;
        var firstMagnitudeBitMask = 2;
        var oneRowDown = width;
        var twoRowsDown = width * 2;
        var threeRowsDown = width * 3;
        var iNext;
        for (var i0 = 0; i0 < height; i0 = iNext) {
          iNext = Math.min(i0 + 4, height);
          var indexBase = i0 * width;
          var checkAllEmpty = i0 + 3 < height;
          for (var j = 0; j < width; j++) {
            var index0 = indexBase + j;
            var allEmpty = checkAllEmpty && processingFlags[index0] === 0 && processingFlags[index0 + oneRowDown] === 0 && processingFlags[index0 + twoRowsDown] === 0 && processingFlags[index0 + threeRowsDown] === 0 && neighborsSignificance[index0] === 0 && neighborsSignificance[index0 + oneRowDown] === 0 && neighborsSignificance[index0 + twoRowsDown] === 0 && neighborsSignificance[index0 + threeRowsDown] === 0;
            var i1 = 0,
                index = index0;
            var i = i0,
                sign;
            if (allEmpty) {
              var hasSignificantCoefficent = decoder.readBit(contexts, RUNLENGTH_CONTEXT);
              if (!hasSignificantCoefficent) {
                bitsDecoded[index0]++;
                bitsDecoded[index0 + oneRowDown]++;
                bitsDecoded[index0 + twoRowsDown]++;
                bitsDecoded[index0 + threeRowsDown]++;
                continue;
              }
              i1 = decoder.readBit(contexts, UNIFORM_CONTEXT) << 1 | decoder.readBit(contexts, UNIFORM_CONTEXT);
              if (i1 !== 0) {
                i = i0 + i1;
                index += i1 * width;
              }
              sign = this.decodeSignBit(i, j, index);
              coefficentsSign[index] = sign;
              coefficentsMagnitude[index] = 1;
              this.setNeighborsSignificance(i, j, index);
              processingFlags[index] |= firstMagnitudeBitMask;
              index = index0;
              for (var i2 = i0; i2 <= i; i2++, index += width) {
                bitsDecoded[index]++;
              }
              i1++;
            }
            for (i = i0 + i1; i < iNext; i++, index += width) {
              if (coefficentsMagnitude[index] || (processingFlags[index] & processedMask) !== 0) {
                continue;
              }
              var contextLabel = labels[neighborsSignificance[index]];
              var decision = decoder.readBit(contexts, contextLabel);
              if (decision === 1) {
                sign = this.decodeSignBit(i, j, index);
                coefficentsSign[index] = sign;
                coefficentsMagnitude[index] = 1;
                this.setNeighborsSignificance(i, j, index);
                processingFlags[index] |= firstMagnitudeBitMask;
              }
              bitsDecoded[index]++;
            }
          }
        }
      },
      checkSegmentationSymbol: function BitModel_checkSegmentationSymbol() {
        var decoder = this.decoder;
        var contexts = this.contexts;
        var symbol = decoder.readBit(contexts, UNIFORM_CONTEXT) << 3 | decoder.readBit(contexts, UNIFORM_CONTEXT) << 2 | decoder.readBit(contexts, UNIFORM_CONTEXT) << 1 | decoder.readBit(contexts, UNIFORM_CONTEXT);
        if (symbol !== 0xA) {
          throw new JpxError('Invalid segmentation symbol');
        }
      }
    };
    return BitModel;
  }();
  var Transform = function TransformClosure() {
    function Transform() {}
    Transform.prototype.calculate = function transformCalculate(subbands, u0, v0) {
      var ll = subbands[0];
      for (var i = 1, ii = subbands.length; i < ii; i++) {
        ll = this.iterate(ll, subbands[i], u0, v0);
      }
      return ll;
    };
    Transform.prototype.extend = function extend(buffer, offset, size) {
      var i1 = offset - 1,
          j1 = offset + 1;
      var i2 = offset + size - 2,
          j2 = offset + size;
      buffer[i1--] = buffer[j1++];
      buffer[j2++] = buffer[i2--];
      buffer[i1--] = buffer[j1++];
      buffer[j2++] = buffer[i2--];
      buffer[i1--] = buffer[j1++];
      buffer[j2++] = buffer[i2--];
      buffer[i1] = buffer[j1];
      buffer[j2] = buffer[i2];
    };
    Transform.prototype.iterate = function Transform_iterate(ll, hl_lh_hh, u0, v0) {
      var llWidth = ll.width,
          llHeight = ll.height,
          llItems = ll.items;
      var width = hl_lh_hh.width;
      var height = hl_lh_hh.height;
      var items = hl_lh_hh.items;
      var i, j, k, l, u, v;
      for (k = 0, i = 0; i < llHeight; i++) {
        l = i * 2 * width;
        for (j = 0; j < llWidth; j++, k++, l += 2) {
          items[l] = llItems[k];
        }
      }
      llItems = ll.items = null;
      var bufferPadding = 4;
      var rowBuffer = new Float32Array(width + 2 * bufferPadding);
      if (width === 1) {
        if ((u0 & 1) !== 0) {
          for (v = 0, k = 0; v < height; v++, k += width) {
            items[k] *= 0.5;
          }
        }
      } else {
        for (v = 0, k = 0; v < height; v++, k += width) {
          rowBuffer.set(items.subarray(k, k + width), bufferPadding);
          this.extend(rowBuffer, bufferPadding, width);
          this.filter(rowBuffer, bufferPadding, width);
          items.set(rowBuffer.subarray(bufferPadding, bufferPadding + width), k);
        }
      }
      var numBuffers = 16;
      var colBuffers = [];
      for (i = 0; i < numBuffers; i++) {
        colBuffers.push(new Float32Array(height + 2 * bufferPadding));
      }
      var b,
          currentBuffer = 0;
      ll = bufferPadding + height;
      if (height === 1) {
        if ((v0 & 1) !== 0) {
          for (u = 0; u < width; u++) {
            items[u] *= 0.5;
          }
        }
      } else {
        for (u = 0; u < width; u++) {
          if (currentBuffer === 0) {
            numBuffers = Math.min(width - u, numBuffers);
            for (k = u, l = bufferPadding; l < ll; k += width, l++) {
              for (b = 0; b < numBuffers; b++) {
                colBuffers[b][l] = items[k + b];
              }
            }
            currentBuffer = numBuffers;
          }
          currentBuffer--;
          var buffer = colBuffers[currentBuffer];
          this.extend(buffer, bufferPadding, height);
          this.filter(buffer, bufferPadding, height);
          if (currentBuffer === 0) {
            k = u - numBuffers + 1;
            for (l = bufferPadding; l < ll; k += width, l++) {
              for (b = 0; b < numBuffers; b++) {
                items[k + b] = colBuffers[b][l];
              }
            }
          }
        }
      }
      return {
        width: width,
        height: height,
        items: items
      };
    };
    return Transform;
  }();
  var IrreversibleTransform = function IrreversibleTransformClosure() {
    function IrreversibleTransform() {
      Transform.call(this);
    }
    IrreversibleTransform.prototype = Object.create(Transform.prototype);
    IrreversibleTransform.prototype.filter = function irreversibleTransformFilter(x, offset, length) {
      var len = length >> 1;
      offset = offset | 0;
      var j, n, current, next;
      var alpha = -1.586134342059924;
      var beta = -0.052980118572961;
      var gamma = 0.882911075530934;
      var delta = 0.443506852043971;
      var K = 1.230174104914001;
      var K_ = 1 / K;
      j = offset - 3;
      for (n = len + 4; n--; j += 2) {
        x[j] *= K_;
      }
      j = offset - 2;
      current = delta * x[j - 1];
      for (n = len + 3; n--; j += 2) {
        next = delta * x[j + 1];
        x[j] = K * x[j] - current - next;
        if (n--) {
          j += 2;
          current = delta * x[j + 1];
          x[j] = K * x[j] - current - next;
        } else {
          break;
        }
      }
      j = offset - 1;
      current = gamma * x[j - 1];
      for (n = len + 2; n--; j += 2) {
        next = gamma * x[j + 1];
        x[j] -= current + next;
        if (n--) {
          j += 2;
          current = gamma * x[j + 1];
          x[j] -= current + next;
        } else {
          break;
        }
      }
      j = offset;
      current = beta * x[j - 1];
      for (n = len + 1; n--; j += 2) {
        next = beta * x[j + 1];
        x[j] -= current + next;
        if (n--) {
          j += 2;
          current = beta * x[j + 1];
          x[j] -= current + next;
        } else {
          break;
        }
      }
      if (len !== 0) {
        j = offset + 1;
        current = alpha * x[j - 1];
        for (n = len; n--; j += 2) {
          next = alpha * x[j + 1];
          x[j] -= current + next;
          if (n--) {
            j += 2;
            current = alpha * x[j + 1];
            x[j] -= current + next;
          } else {
            break;
          }
        }
      }
    };
    return IrreversibleTransform;
  }();
  var ReversibleTransform = function ReversibleTransformClosure() {
    function ReversibleTransform() {
      Transform.call(this);
    }
    ReversibleTransform.prototype = Object.create(Transform.prototype);
    ReversibleTransform.prototype.filter = function reversibleTransformFilter(x, offset, length) {
      var len = length >> 1;
      offset = offset | 0;
      var j, n;
      for (j = offset, n = len + 1; n--; j += 2) {
        x[j] -= x[j - 1] + x[j + 1] + 2 >> 2;
      }
      for (j = offset + 1, n = len; n--; j += 2) {
        x[j] += x[j - 1] + x[j + 1] >> 1;
      }
    };
    return ReversibleTransform;
  }();
  return JpxImage;
}();
exports.JpxImage = JpxImage;

/***/ }),
/* 14 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FileSpec = exports.XRef = exports.ObjectLoader = exports.Catalog = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _util = __w_pdfjs_require__(0);

var _primitives = __w_pdfjs_require__(1);

var _parser = __w_pdfjs_require__(5);

var _chunked_stream = __w_pdfjs_require__(10);

var _crypto = __w_pdfjs_require__(11);

var _colorspace = __w_pdfjs_require__(3);

var Catalog = function CatalogClosure() {
  function Catalog(pdfManager, xref, pageFactory) {
    this.pdfManager = pdfManager;
    this.xref = xref;
    this.catDict = xref.getCatalogObj();
    if (!(0, _primitives.isDict)(this.catDict)) {
      throw new _util.FormatError('catalog object is not a dictionary');
    }
    this.fontCache = new _primitives.RefSetCache();
    this.builtInCMapCache = Object.create(null);
    this.pageKidsCountCache = new _primitives.RefSetCache();
    this.pageFactory = pageFactory;
    this.pagePromises = [];
  }
  Catalog.prototype = {
    get metadata() {
      var streamRef = this.catDict.getRaw('Metadata');
      if (!(0, _primitives.isRef)(streamRef)) {
        return (0, _util.shadow)(this, 'metadata', null);
      }
      var encryptMetadata = !this.xref.encrypt ? false : this.xref.encrypt.encryptMetadata;
      var stream = this.xref.fetch(streamRef, !encryptMetadata);
      var metadata;
      if (stream && (0, _primitives.isDict)(stream.dict)) {
        var type = stream.dict.get('Type');
        var subtype = stream.dict.get('Subtype');
        if ((0, _primitives.isName)(type, 'Metadata') && (0, _primitives.isName)(subtype, 'XML')) {
          try {
            metadata = (0, _util.stringToUTF8String)((0, _util.bytesToString)(stream.getBytes()));
          } catch (e) {
            if (e instanceof _util.MissingDataException) {
              throw e;
            }
            (0, _util.info)('Skipping invalid metadata.');
          }
        }
      }
      return (0, _util.shadow)(this, 'metadata', metadata);
    },
    get toplevelPagesDict() {
      var pagesObj = this.catDict.get('Pages');
      if (!(0, _primitives.isDict)(pagesObj)) {
        throw new _util.FormatError('invalid top-level pages dictionary');
      }
      return (0, _util.shadow)(this, 'toplevelPagesDict', pagesObj);
    },
    get documentOutline() {
      var obj = null;
      try {
        obj = this.readDocumentOutline();
      } catch (ex) {
        if (ex instanceof _util.MissingDataException) {
          throw ex;
        }
        (0, _util.warn)('Unable to read document outline');
      }
      return (0, _util.shadow)(this, 'documentOutline', obj);
    },
    readDocumentOutline: function Catalog_readDocumentOutline() {
      var obj = this.catDict.get('Outlines');
      if (!(0, _primitives.isDict)(obj)) {
        return null;
      }
      obj = obj.getRaw('First');
      if (!(0, _primitives.isRef)(obj)) {
        return null;
      }
      var root = { items: [] };
      var queue = [{
        obj: obj,
        parent: root
      }];
      var processed = new _primitives.RefSet();
      processed.put(obj);
      var xref = this.xref,
          blackColor = new Uint8Array(3);
      while (queue.length > 0) {
        var i = queue.shift();
        var outlineDict = xref.fetchIfRef(i.obj);
        if (outlineDict === null) {
          continue;
        }
        if (!outlineDict.has('Title')) {
          throw new _util.FormatError('Invalid outline item');
        }
        var data = {
          url: null,
          dest: null
        };
        Catalog.parseDestDictionary({
          destDict: outlineDict,
          resultObj: data,
          docBaseUrl: this.pdfManager.docBaseUrl
        });
        var title = outlineDict.get('Title');
        var flags = outlineDict.get('F') || 0;
        var color = outlineDict.getArray('C'),
            rgbColor = blackColor;
        if ((0, _util.isArray)(color) && color.length === 3 && (color[0] !== 0 || color[1] !== 0 || color[2] !== 0)) {
          rgbColor = _colorspace.ColorSpace.singletons.rgb.getRgb(color, 0);
        }
        var outlineItem = {
          dest: data.dest,
          url: data.url,
          unsafeUrl: data.unsafeUrl,
          newWindow: data.newWindow,
          title: (0, _util.stringToPDFString)(title),
          color: rgbColor,
          count: outlineDict.get('Count'),
          bold: !!(flags & 2),
          italic: !!(flags & 1),
          items: []
        };
        i.parent.items.push(outlineItem);
        obj = outlineDict.getRaw('First');
        if ((0, _primitives.isRef)(obj) && !processed.has(obj)) {
          queue.push({
            obj: obj,
            parent: outlineItem
          });
          processed.put(obj);
        }
        obj = outlineDict.getRaw('Next');
        if ((0, _primitives.isRef)(obj) && !processed.has(obj)) {
          queue.push({
            obj: obj,
            parent: i.parent
          });
          processed.put(obj);
        }
      }
      return root.items.length > 0 ? root.items : null;
    },
    get numPages() {
      var obj = this.toplevelPagesDict.get('Count');
      if (!(0, _util.isInt)(obj)) {
        throw new _util.FormatError('page count in top level pages object is not an integer');
      }
      return (0, _util.shadow)(this, 'numPages', obj);
    },
    get destinations() {
      function fetchDestination(dest) {
        return (0, _primitives.isDict)(dest) ? dest.get('D') : dest;
      }
      var xref = this.xref;
      var dests = {},
          nameTreeRef,
          nameDictionaryRef;
      var obj = this.catDict.get('Names');
      if (obj && obj.has('Dests')) {
        nameTreeRef = obj.getRaw('Dests');
      } else if (this.catDict.has('Dests')) {
        nameDictionaryRef = this.catDict.get('Dests');
      }
      if (nameDictionaryRef) {
        obj = nameDictionaryRef;
        obj.forEach(function catalogForEach(key, value) {
          if (!value) {
            return;
          }
          dests[key] = fetchDestination(value);
        });
      }
      if (nameTreeRef) {
        var nameTree = new NameTree(nameTreeRef, xref);
        var names = nameTree.getAll();
        for (var name in names) {
          dests[name] = fetchDestination(names[name]);
        }
      }
      return (0, _util.shadow)(this, 'destinations', dests);
    },
    getDestination: function Catalog_getDestination(destinationId) {
      function fetchDestination(dest) {
        return (0, _primitives.isDict)(dest) ? dest.get('D') : dest;
      }
      var xref = this.xref;
      var dest = null,
          nameTreeRef,
          nameDictionaryRef;
      var obj = this.catDict.get('Names');
      if (obj && obj.has('Dests')) {
        nameTreeRef = obj.getRaw('Dests');
      } else if (this.catDict.has('Dests')) {
        nameDictionaryRef = this.catDict.get('Dests');
      }
      if (nameDictionaryRef) {
        var value = nameDictionaryRef.get(destinationId);
        if (value) {
          dest = fetchDestination(value);
        }
      }
      if (nameTreeRef) {
        var nameTree = new NameTree(nameTreeRef, xref);
        dest = fetchDestination(nameTree.get(destinationId));
      }
      return dest;
    },
    get pageLabels() {
      var obj = null;
      try {
        obj = this.readPageLabels();
      } catch (ex) {
        if (ex instanceof _util.MissingDataException) {
          throw ex;
        }
        (0, _util.warn)('Unable to read page labels.');
      }
      return (0, _util.shadow)(this, 'pageLabels', obj);
    },
    readPageLabels: function Catalog_readPageLabels() {
      var obj = this.catDict.getRaw('PageLabels');
      if (!obj) {
        return null;
      }
      var pageLabels = new Array(this.numPages);
      var style = null;
      var prefix = '';
      var numberTree = new NumberTree(obj, this.xref);
      var nums = numberTree.getAll();
      var currentLabel = '',
          currentIndex = 1;
      for (var i = 0, ii = this.numPages; i < ii; i++) {
        if (i in nums) {
          var labelDict = nums[i];
          if (!(0, _primitives.isDict)(labelDict)) {
            throw new _util.FormatError('The PageLabel is not a dictionary.');
          }
          var type = labelDict.get('Type');
          if (type && !(0, _primitives.isName)(type, 'PageLabel')) {
            throw new _util.FormatError('Invalid type in PageLabel dictionary.');
          }
          var s = labelDict.get('S');
          if (s && !(0, _primitives.isName)(s)) {
            throw new _util.FormatError('Invalid style in PageLabel dictionary.');
          }
          style = s ? s.name : null;
          var p = labelDict.get('P');
          if (p && !(0, _util.isString)(p)) {
            throw new _util.FormatError('Invalid prefix in PageLabel dictionary.');
          }
          prefix = p ? (0, _util.stringToPDFString)(p) : '';
          var st = labelDict.get('St');
          if (st && !((0, _util.isInt)(st) && st >= 1)) {
            throw new _util.FormatError('Invalid start in PageLabel dictionary.');
          }
          currentIndex = st || 1;
        }
        switch (style) {
          case 'D':
            currentLabel = currentIndex;
            break;
          case 'R':
          case 'r':
            currentLabel = _util.Util.toRoman(currentIndex, style === 'r');
            break;
          case 'A':
          case 'a':
            var LIMIT = 26;
            var A_UPPER_CASE = 0x41,
                A_LOWER_CASE = 0x61;
            var baseCharCode = style === 'a' ? A_LOWER_CASE : A_UPPER_CASE;
            var letterIndex = currentIndex - 1;
            var character = String.fromCharCode(baseCharCode + letterIndex % LIMIT);
            var charBuf = [];
            for (var j = 0, jj = letterIndex / LIMIT | 0; j <= jj; j++) {
              charBuf.push(character);
            }
            currentLabel = charBuf.join('');
            break;
          default:
            if (style) {
              throw new _util.FormatError('Invalid style "' + style + '" in PageLabel dictionary.');
            }
        }
        pageLabels[i] = prefix + currentLabel;
        currentLabel = '';
        currentIndex++;
      }
      return pageLabels;
    },
    get pageMode() {
      var obj = this.catDict.get('PageMode');
      var pageMode = 'UseNone';
      if ((0, _primitives.isName)(obj)) {
        switch (obj.name) {
          case 'UseNone':
          case 'UseOutlines':
          case 'UseThumbs':
          case 'FullScreen':
          case 'UseOC':
          case 'UseAttachments':
            pageMode = obj.name;
        }
      }
      return (0, _util.shadow)(this, 'pageMode', pageMode);
    },
    get attachments() {
      var xref = this.xref;
      var attachments = null,
          nameTreeRef;
      var obj = this.catDict.get('Names');
      if (obj) {
        nameTreeRef = obj.getRaw('EmbeddedFiles');
      }
      if (nameTreeRef) {
        var nameTree = new NameTree(nameTreeRef, xref);
        var names = nameTree.getAll();
        for (var name in names) {
          var fs = new FileSpec(names[name], xref);
          if (!attachments) {
            attachments = Object.create(null);
          }
          attachments[(0, _util.stringToPDFString)(name)] = fs.serializable;
        }
      }
      return (0, _util.shadow)(this, 'attachments', attachments);
    },
    get javaScript() {
      var xref = this.xref;
      var obj = this.catDict.get('Names');
      var javaScript = [];
      function appendIfJavaScriptDict(jsDict) {
        var type = jsDict.get('S');
        if (!(0, _primitives.isName)(type, 'JavaScript')) {
          return;
        }
        var js = jsDict.get('JS');
        if ((0, _primitives.isStream)(js)) {
          js = (0, _util.bytesToString)(js.getBytes());
        } else if (!(0, _util.isString)(js)) {
          return;
        }
        javaScript.push((0, _util.stringToPDFString)(js));
      }
      if (obj && obj.has('JavaScript')) {
        var nameTree = new NameTree(obj.getRaw('JavaScript'), xref);
        var names = nameTree.getAll();
        for (var name in names) {
          var jsDict = names[name];
          if ((0, _primitives.isDict)(jsDict)) {
            appendIfJavaScriptDict(jsDict);
          }
        }
      }
      var openactionDict = this.catDict.get('OpenAction');
      if ((0, _primitives.isDict)(openactionDict, 'Action')) {
        var actionType = openactionDict.get('S');
        if ((0, _primitives.isName)(actionType, 'Named')) {
          var action = openactionDict.get('N');
          if ((0, _primitives.isName)(action, 'Print')) {
            javaScript.push('print({});');
          }
        } else {
          appendIfJavaScriptDict(openactionDict);
        }
      }
      return (0, _util.shadow)(this, 'javaScript', javaScript);
    },
    cleanup: function Catalog_cleanup() {
      var _this = this;

      this.pageKidsCountCache.clear();
      var promises = [];
      this.fontCache.forEach(function (promise) {
        promises.push(promise);
      });
      return Promise.all(promises).then(function (translatedFonts) {
        for (var i = 0, ii = translatedFonts.length; i < ii; i++) {
          var font = translatedFonts[i].dict;
          delete font.translated;
        }
        _this.fontCache.clear();
        _this.builtInCMapCache = Object.create(null);
      });
    },
    getPage: function Catalog_getPage(pageIndex) {
      var _this2 = this;

      if (!(pageIndex in this.pagePromises)) {
        this.pagePromises[pageIndex] = this.getPageDict(pageIndex).then(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              dict = _ref2[0],
              ref = _ref2[1];

          return _this2.pageFactory.createPage(pageIndex, dict, ref, _this2.fontCache, _this2.builtInCMapCache);
        });
      }
      return this.pagePromises[pageIndex];
    },
    getPageDict: function Catalog_getPageDict(pageIndex) {
      var capability = (0, _util.createPromiseCapability)();
      var nodesToVisit = [this.catDict.getRaw('Pages')];
      var count,
          currentPageIndex = 0;
      var xref = this.xref,
          pageKidsCountCache = this.pageKidsCountCache;
      function next() {
        while (nodesToVisit.length) {
          var currentNode = nodesToVisit.pop();
          if ((0, _primitives.isRef)(currentNode)) {
            count = pageKidsCountCache.get(currentNode);
            if (count > 0 && currentPageIndex + count < pageIndex) {
              currentPageIndex += count;
              continue;
            }
            xref.fetchAsync(currentNode).then(function (obj) {
              if ((0, _primitives.isDict)(obj, 'Page') || (0, _primitives.isDict)(obj) && !obj.has('Kids')) {
                if (pageIndex === currentPageIndex) {
                  if (currentNode && !pageKidsCountCache.has(currentNode)) {
                    pageKidsCountCache.put(currentNode, 1);
                  }
                  capability.resolve([obj, currentNode]);
                } else {
                  currentPageIndex++;
                  next();
                }
                return;
              }
              nodesToVisit.push(obj);
              next();
            }, capability.reject);
            return;
          }
          if (!(0, _primitives.isDict)(currentNode)) {
            capability.reject(new _util.FormatError('page dictionary kid reference points to wrong type of object'));
            return;
          }
          count = currentNode.get('Count');
          var objId = currentNode.objId;
          if (objId && !pageKidsCountCache.has(objId)) {
            pageKidsCountCache.put(objId, count);
          }
          if (currentPageIndex + count <= pageIndex) {
            currentPageIndex += count;
            continue;
          }
          var kids = currentNode.get('Kids');
          if (!(0, _util.isArray)(kids)) {
            capability.reject(new _util.FormatError('page dictionary kids object is not an array'));
            return;
          }
          for (var last = kids.length - 1; last >= 0; last--) {
            nodesToVisit.push(kids[last]);
          }
        }
        capability.reject(new Error('Page index ' + pageIndex + ' not found.'));
      }
      next();
      return capability.promise;
    },
    getPageIndex: function Catalog_getPageIndex(pageRef) {
      var xref = this.xref;
      function pagesBeforeRef(kidRef) {
        var total = 0;
        var parentRef;
        return xref.fetchAsync(kidRef).then(function (node) {
          if ((0, _primitives.isRefsEqual)(kidRef, pageRef) && !(0, _primitives.isDict)(node, 'Page') && !((0, _primitives.isDict)(node) && !node.has('Type') && node.has('Contents'))) {
            throw new _util.FormatError('The reference does not point to a /Page Dict.');
          }
          if (!node) {
            return null;
          }
          if (!(0, _primitives.isDict)(node)) {
            throw new _util.FormatError('node must be a Dict.');
          }
          parentRef = node.getRaw('Parent');
          return node.getAsync('Parent');
        }).then(function (parent) {
          if (!parent) {
            return null;
          }
          if (!(0, _primitives.isDict)(parent)) {
            throw new _util.FormatError('parent must be a Dict.');
          }
          return parent.getAsync('Kids');
        }).then(function (kids) {
          if (!kids) {
            return null;
          }
          var kidPromises = [];
          var found = false;
          for (var i = 0; i < kids.length; i++) {
            var kid = kids[i];
            if (!(0, _primitives.isRef)(kid)) {
              throw new _util.FormatError('kid must be a Ref.');
            }
            if (kid.num === kidRef.num) {
              found = true;
              break;
            }
            kidPromises.push(xref.fetchAsync(kid).then(function (kid) {
              if (kid.has('Count')) {
                var count = kid.get('Count');
                total += count;
              } else {
                total++;
              }
            }));
          }
          if (!found) {
            throw new _util.FormatError('kid ref not found in parents kids');
          }
          return Promise.all(kidPromises).then(function () {
            return [total, parentRef];
          });
        });
      }
      var total = 0;
      function next(ref) {
        return pagesBeforeRef(ref).then(function (args) {
          if (!args) {
            return total;
          }
          var count = args[0];
          var parentRef = args[1];
          total += count;
          return next(parentRef);
        });
      }
      return next(pageRef);
    }
  };
  Catalog.parseDestDictionary = function Catalog_parseDestDictionary(params) {
    function addDefaultProtocolToUrl(url) {
      if (url.indexOf('www.') === 0) {
        return 'http://' + url;
      }
      return url;
    }
    function tryConvertUrlEncoding(url) {
      try {
        return (0, _util.stringToUTF8String)(url);
      } catch (e) {
        return url;
      }
    }
    var destDict = params.destDict;
    if (!(0, _primitives.isDict)(destDict)) {
      (0, _util.warn)('Catalog_parseDestDictionary: "destDict" must be a dictionary.');
      return;
    }
    var resultObj = params.resultObj;
    if ((typeof resultObj === 'undefined' ? 'undefined' : _typeof(resultObj)) !== 'object') {
      (0, _util.warn)('Catalog_parseDestDictionary: "resultObj" must be an object.');
      return;
    }
    var docBaseUrl = params.docBaseUrl || null;
    var action = destDict.get('A'),
        url,
        dest;
    if ((0, _primitives.isDict)(action)) {
      var linkType = action.get('S').name;
      switch (linkType) {
        case 'URI':
          url = action.get('URI');
          if ((0, _primitives.isName)(url)) {
            url = '/' + url.name;
          } else if ((0, _util.isString)(url)) {
            url = addDefaultProtocolToUrl(url);
          }
          break;
        case 'GoTo':
          dest = action.get('D');
          break;
        case 'Launch':
        case 'GoToR':
          var urlDict = action.get('F');
          if ((0, _primitives.isDict)(urlDict)) {
            url = urlDict.get('F') || null;
          } else if ((0, _util.isString)(urlDict)) {
            url = urlDict;
          }
          var remoteDest = action.get('D');
          if (remoteDest) {
            if ((0, _primitives.isName)(remoteDest)) {
              remoteDest = remoteDest.name;
            }
            if ((0, _util.isString)(url)) {
              var baseUrl = url.split('#')[0];
              if ((0, _util.isString)(remoteDest)) {
                url = baseUrl + '#' + remoteDest;
              } else if ((0, _util.isArray)(remoteDest)) {
                url = baseUrl + '#' + JSON.stringify(remoteDest);
              }
            }
          }
          var newWindow = action.get('NewWindow');
          if ((0, _util.isBool)(newWindow)) {
            resultObj.newWindow = newWindow;
          }
          break;
        case 'Named':
          var namedAction = action.get('N');
          if ((0, _primitives.isName)(namedAction)) {
            resultObj.action = namedAction.name;
          }
          break;
        case 'JavaScript':
          var jsAction = action.get('JS'),
              js;
          if ((0, _primitives.isStream)(jsAction)) {
            js = (0, _util.bytesToString)(jsAction.getBytes());
          } else if ((0, _util.isString)(jsAction)) {
            js = jsAction;
          }
          if (js) {
            var URL_OPEN_METHODS = ['app.launchURL', 'window.open'];
            var regex = new RegExp('^\\s*(' + URL_OPEN_METHODS.join('|').split('.').join('\\.') + ')\\((?:\'|\")([^\'\"]*)(?:\'|\")(?:,\\s*(\\w+)\\)|\\))', 'i');
            var jsUrl = regex.exec((0, _util.stringToPDFString)(js));
            if (jsUrl && jsUrl[2]) {
              url = jsUrl[2];
              if (jsUrl[3] === 'true' && jsUrl[1] === 'app.launchURL') {
                resultObj.newWindow = true;
              }
              break;
            }
          }
        default:
          (0, _util.warn)('Catalog_parseDestDictionary: Unrecognized link type "' + linkType + '".');
          break;
      }
    } else if (destDict.has('Dest')) {
      dest = destDict.get('Dest');
    }
    if ((0, _util.isString)(url)) {
      url = tryConvertUrlEncoding(url);
      var absoluteUrl = (0, _util.createValidAbsoluteUrl)(url, docBaseUrl);
      if (absoluteUrl) {
        resultObj.url = absoluteUrl.href;
      }
      resultObj.unsafeUrl = url;
    }
    if (dest) {
      if ((0, _primitives.isName)(dest)) {
        dest = dest.name;
      }
      if ((0, _util.isString)(dest) || (0, _util.isArray)(dest)) {
        resultObj.dest = dest;
      }
    }
  };
  return Catalog;
}();
var XRef = function XRefClosure() {
  function XRef(stream, pdfManager) {
    this.stream = stream;
    this.pdfManager = pdfManager;
    this.entries = [];
    this.xrefstms = Object.create(null);
    this.cache = [];
    this.stats = {
      streamTypes: [],
      fontTypes: []
    };
  }
  XRef.prototype = {
    setStartXRef: function XRef_setStartXRef(startXRef) {
      this.startXRefQueue = [startXRef];
    },
    parse: function XRef_parse(recoveryMode) {
      var trailerDict;
      if (!recoveryMode) {
        trailerDict = this.readXRef();
      } else {
        (0, _util.warn)('Indexing all PDF objects');
        trailerDict = this.indexObjects();
      }
      trailerDict.assignXref(this);
      this.trailer = trailerDict;
      var encrypt = trailerDict.get('Encrypt');
      if ((0, _primitives.isDict)(encrypt)) {
        var ids = trailerDict.get('ID');
        var fileId = ids && ids.length ? ids[0] : '';
        encrypt.suppressEncryption = true;
        this.encrypt = new _crypto.CipherTransformFactory(encrypt, fileId, this.pdfManager.password);
      }
      if (!(this.root = trailerDict.get('Root'))) {
        throw new _util.FormatError('Invalid root reference');
      }
    },
    processXRefTable: function XRef_processXRefTable(parser) {
      if (!('tableState' in this)) {
        this.tableState = {
          entryNum: 0,
          streamPos: parser.lexer.stream.pos,
          parserBuf1: parser.buf1,
          parserBuf2: parser.buf2
        };
      }
      var obj = this.readXRefTable(parser);
      if (!(0, _primitives.isCmd)(obj, 'trailer')) {
        throw new _util.FormatError('Invalid XRef table: could not find trailer dictionary');
      }
      var dict = parser.getObj();
      if (!(0, _primitives.isDict)(dict) && dict.dict) {
        dict = dict.dict;
      }
      if (!(0, _primitives.isDict)(dict)) {
        throw new _util.FormatError('Invalid XRef table: could not parse trailer dictionary');
      }
      delete this.tableState;
      return dict;
    },
    readXRefTable: function XRef_readXRefTable(parser) {
      var stream = parser.lexer.stream;
      var tableState = this.tableState;
      stream.pos = tableState.streamPos;
      parser.buf1 = tableState.parserBuf1;
      parser.buf2 = tableState.parserBuf2;
      var obj;
      while (true) {
        if (!('firstEntryNum' in tableState) || !('entryCount' in tableState)) {
          if ((0, _primitives.isCmd)(obj = parser.getObj(), 'trailer')) {
            break;
          }
          tableState.firstEntryNum = obj;
          tableState.entryCount = parser.getObj();
        }
        var first = tableState.firstEntryNum;
        var count = tableState.entryCount;
        if (!(0, _util.isInt)(first) || !(0, _util.isInt)(count)) {
          throw new _util.FormatError('Invalid XRef table: wrong types in subsection header');
        }
        for (var i = tableState.entryNum; i < count; i++) {
          tableState.streamPos = stream.pos;
          tableState.entryNum = i;
          tableState.parserBuf1 = parser.buf1;
          tableState.parserBuf2 = parser.buf2;
          var entry = {};
          entry.offset = parser.getObj();
          entry.gen = parser.getObj();
          var type = parser.getObj();
          if ((0, _primitives.isCmd)(type, 'f')) {
            entry.free = true;
          } else if ((0, _primitives.isCmd)(type, 'n')) {
            entry.uncompressed = true;
          }
          if (!(0, _util.isInt)(entry.offset) || !(0, _util.isInt)(entry.gen) || !(entry.free || entry.uncompressed)) {
            throw new _util.FormatError('Invalid entry in XRef subsection: ' + first + ', ' + count);
          }
          if (i === 0 && entry.free && first === 1) {
            first = 0;
          }
          if (!this.entries[i + first]) {
            this.entries[i + first] = entry;
          }
        }
        tableState.entryNum = 0;
        tableState.streamPos = stream.pos;
        tableState.parserBuf1 = parser.buf1;
        tableState.parserBuf2 = parser.buf2;
        delete tableState.firstEntryNum;
        delete tableState.entryCount;
      }
      if (this.entries[0] && !this.entries[0].free) {
        throw new _util.FormatError('Invalid XRef table: unexpected first object');
      }
      return obj;
    },
    processXRefStream: function XRef_processXRefStream(stream) {
      if (!('streamState' in this)) {
        var streamParameters = stream.dict;
        var byteWidths = streamParameters.get('W');
        var range = streamParameters.get('Index');
        if (!range) {
          range = [0, streamParameters.get('Size')];
        }
        this.streamState = {
          entryRanges: range,
          byteWidths: byteWidths,
          entryNum: 0,
          streamPos: stream.pos
        };
      }
      this.readXRefStream(stream);
      delete this.streamState;
      return stream.dict;
    },
    readXRefStream: function XRef_readXRefStream(stream) {
      var i, j;
      var streamState = this.streamState;
      stream.pos = streamState.streamPos;
      var byteWidths = streamState.byteWidths;
      var typeFieldWidth = byteWidths[0];
      var offsetFieldWidth = byteWidths[1];
      var generationFieldWidth = byteWidths[2];
      var entryRanges = streamState.entryRanges;
      while (entryRanges.length > 0) {
        var first = entryRanges[0];
        var n = entryRanges[1];
        if (!(0, _util.isInt)(first) || !(0, _util.isInt)(n)) {
          throw new _util.FormatError('Invalid XRef range fields: ' + first + ', ' + n);
        }
        if (!(0, _util.isInt)(typeFieldWidth) || !(0, _util.isInt)(offsetFieldWidth) || !(0, _util.isInt)(generationFieldWidth)) {
          throw new _util.FormatError('Invalid XRef entry fields length: ' + first + ', ' + n);
        }
        for (i = streamState.entryNum; i < n; ++i) {
          streamState.entryNum = i;
          streamState.streamPos = stream.pos;
          var type = 0,
              offset = 0,
              generation = 0;
          for (j = 0; j < typeFieldWidth; ++j) {
            type = type << 8 | stream.getByte();
          }
          if (typeFieldWidth === 0) {
            type = 1;
          }
          for (j = 0; j < offsetFieldWidth; ++j) {
            offset = offset << 8 | stream.getByte();
          }
          for (j = 0; j < generationFieldWidth; ++j) {
            generation = generation << 8 | stream.getByte();
          }
          var entry = {};
          entry.offset = offset;
          entry.gen = generation;
          switch (type) {
            case 0:
              entry.free = true;
              break;
            case 1:
              entry.uncompressed = true;
              break;
            case 2:
              break;
            default:
              throw new _util.FormatError('Invalid XRef entry type: ' + type);
          }
          if (!this.entries[first + i]) {
            this.entries[first + i] = entry;
          }
        }
        streamState.entryNum = 0;
        streamState.streamPos = stream.pos;
        entryRanges.splice(0, 2);
      }
    },
    indexObjects: function XRef_indexObjects() {
      var TAB = 0x9,
          LF = 0xA,
          CR = 0xD,
          SPACE = 0x20;
      var PERCENT = 0x25,
          LT = 0x3C;
      function readToken(data, offset) {
        var token = '',
            ch = data[offset];
        while (ch !== LF && ch !== CR && ch !== LT) {
          if (++offset >= data.length) {
            break;
          }
          token += String.fromCharCode(ch);
          ch = data[offset];
        }
        return token;
      }
      function skipUntil(data, offset, what) {
        var length = what.length,
            dataLength = data.length;
        var skipped = 0;
        while (offset < dataLength) {
          var i = 0;
          while (i < length && data[offset + i] === what[i]) {
            ++i;
          }
          if (i >= length) {
            break;
          }
          offset++;
          skipped++;
        }
        return skipped;
      }
      var objRegExp = /^(\d+)\s+(\d+)\s+obj\b/;
      var trailerBytes = new Uint8Array([116, 114, 97, 105, 108, 101, 114]);
      var startxrefBytes = new Uint8Array([115, 116, 97, 114, 116, 120, 114, 101, 102]);
      var endobjBytes = new Uint8Array([101, 110, 100, 111, 98, 106]);
      var xrefBytes = new Uint8Array([47, 88, 82, 101, 102]);
      this.entries.length = 0;
      var stream = this.stream;
      stream.pos = 0;
      var buffer = stream.getBytes();
      var position = stream.start,
          length = buffer.length;
      var trailers = [],
          xrefStms = [];
      while (position < length) {
        var ch = buffer[position];
        if (ch === TAB || ch === LF || ch === CR || ch === SPACE) {
          ++position;
          continue;
        }
        if (ch === PERCENT) {
          do {
            ++position;
            if (position >= length) {
              break;
            }
            ch = buffer[position];
          } while (ch !== LF && ch !== CR);
          continue;
        }
        var token = readToken(buffer, position);
        var m;
        if (token.indexOf('xref') === 0 && (token.length === 4 || /\s/.test(token[4]))) {
          position += skipUntil(buffer, position, trailerBytes);
          trailers.push(position);
          position += skipUntil(buffer, position, startxrefBytes);
        } else if (m = objRegExp.exec(token)) {
          if (typeof this.entries[m[1]] === 'undefined') {
            this.entries[m[1]] = {
              offset: position - stream.start,
              gen: m[2] | 0,
              uncompressed: true
            };
          }
          var contentLength = skipUntil(buffer, position, endobjBytes) + 7;
          var content = buffer.subarray(position, position + contentLength);
          var xrefTagOffset = skipUntil(content, 0, xrefBytes);
          if (xrefTagOffset < contentLength && content[xrefTagOffset + 5] < 64) {
            xrefStms.push(position - stream.start);
            this.xrefstms[position - stream.start] = 1;
          }
          position += contentLength;
        } else if (token.indexOf('trailer') === 0 && (token.length === 7 || /\s/.test(token[7]))) {
          trailers.push(position);
          position += skipUntil(buffer, position, startxrefBytes);
        } else {
          position += token.length + 1;
        }
      }
      var i, ii;
      for (i = 0, ii = xrefStms.length; i < ii; ++i) {
        this.startXRefQueue.push(xrefStms[i]);
        this.readXRef(true);
      }
      var dict;
      for (i = 0, ii = trailers.length; i < ii; ++i) {
        stream.pos = trailers[i];
        var parser = new _parser.Parser(new _parser.Lexer(stream), true, this, true);
        var obj = parser.getObj();
        if (!(0, _primitives.isCmd)(obj, 'trailer')) {
          continue;
        }
        dict = parser.getObj();
        if (!(0, _primitives.isDict)(dict)) {
          continue;
        }
        if (dict.has('ID')) {
          return dict;
        }
      }
      if (dict) {
        return dict;
      }
      throw new _util.InvalidPDFException('Invalid PDF structure');
    },
    readXRef: function XRef_readXRef(recoveryMode) {
      var stream = this.stream;
      try {
        while (this.startXRefQueue.length) {
          var startXRef = this.startXRefQueue[0];
          stream.pos = startXRef + stream.start;
          var parser = new _parser.Parser(new _parser.Lexer(stream), true, this);
          var obj = parser.getObj();
          var dict;
          if ((0, _primitives.isCmd)(obj, 'xref')) {
            dict = this.processXRefTable(parser);
            if (!this.topDict) {
              this.topDict = dict;
            }
            obj = dict.get('XRefStm');
            if ((0, _util.isInt)(obj)) {
              var pos = obj;
              if (!(pos in this.xrefstms)) {
                this.xrefstms[pos] = 1;
                this.startXRefQueue.push(pos);
              }
            }
          } else if ((0, _util.isInt)(obj)) {
            if (!(0, _util.isInt)(parser.getObj()) || !(0, _primitives.isCmd)(parser.getObj(), 'obj') || !(0, _primitives.isStream)(obj = parser.getObj())) {
              throw new _util.FormatError('Invalid XRef stream');
            }
            dict = this.processXRefStream(obj);
            if (!this.topDict) {
              this.topDict = dict;
            }
            if (!dict) {
              throw new _util.FormatError('Failed to read XRef stream');
            }
          } else {
            throw new _util.FormatError('Invalid XRef stream header');
          }
          obj = dict.get('Prev');
          if ((0, _util.isInt)(obj)) {
            this.startXRefQueue.push(obj);
          } else if ((0, _primitives.isRef)(obj)) {
            this.startXRefQueue.push(obj.num);
          }
          this.startXRefQueue.shift();
        }
        return this.topDict;
      } catch (e) {
        if (e instanceof _util.MissingDataException) {
          throw e;
        }
        (0, _util.info)('(while reading XRef): ' + e);
      }
      if (recoveryMode) {
        return;
      }
      throw new _util.XRefParseException();
    },
    getEntry: function XRef_getEntry(i) {
      var xrefEntry = this.entries[i];
      if (xrefEntry && !xrefEntry.free && xrefEntry.offset) {
        return xrefEntry;
      }
      return null;
    },
    fetchIfRef: function XRef_fetchIfRef(obj, suppressEncryption) {
      if (!(0, _primitives.isRef)(obj)) {
        return obj;
      }
      return this.fetch(obj, suppressEncryption);
    },
    fetch: function XRef_fetch(ref, suppressEncryption) {
      if (!(0, _primitives.isRef)(ref)) {
        throw new Error('ref object is not a reference');
      }
      var num = ref.num;
      if (num in this.cache) {
        var cacheEntry = this.cache[num];
        if (cacheEntry instanceof _primitives.Dict && !cacheEntry.objId) {
          cacheEntry.objId = ref.toString();
        }
        return cacheEntry;
      }
      var xrefEntry = this.getEntry(num);
      if (xrefEntry === null) {
        return this.cache[num] = null;
      }
      if (xrefEntry.uncompressed) {
        xrefEntry = this.fetchUncompressed(ref, xrefEntry, suppressEncryption);
      } else {
        xrefEntry = this.fetchCompressed(xrefEntry, suppressEncryption);
      }
      if ((0, _primitives.isDict)(xrefEntry)) {
        xrefEntry.objId = ref.toString();
      } else if ((0, _primitives.isStream)(xrefEntry)) {
        xrefEntry.dict.objId = ref.toString();
      }
      return xrefEntry;
    },
    fetchUncompressed: function XRef_fetchUncompressed(ref, xrefEntry, suppressEncryption) {
      var gen = ref.gen;
      var num = ref.num;
      if (xrefEntry.gen !== gen) {
        throw new _util.FormatError('inconsistent generation in XRef');
      }
      var stream = this.stream.makeSubStream(xrefEntry.offset + this.stream.start);
      var parser = new _parser.Parser(new _parser.Lexer(stream), true, this);
      var obj1 = parser.getObj();
      var obj2 = parser.getObj();
      var obj3 = parser.getObj();
      if (!(0, _util.isInt)(obj1) || parseInt(obj1, 10) !== num || !(0, _util.isInt)(obj2) || parseInt(obj2, 10) !== gen || !(0, _primitives.isCmd)(obj3)) {
        throw new _util.FormatError('bad XRef entry');
      }
      if (!(0, _primitives.isCmd)(obj3, 'obj')) {
        if (obj3.cmd.indexOf('obj') === 0) {
          num = parseInt(obj3.cmd.substring(3), 10);
          if (!isNaN(num)) {
            return num;
          }
        }
        throw new _util.FormatError('bad XRef entry');
      }
      if (this.encrypt && !suppressEncryption) {
        xrefEntry = parser.getObj(this.encrypt.createCipherTransform(num, gen));
      } else {
        xrefEntry = parser.getObj();
      }
      if (!(0, _primitives.isStream)(xrefEntry)) {
        this.cache[num] = xrefEntry;
      }
      return xrefEntry;
    },
    fetchCompressed: function XRef_fetchCompressed(xrefEntry, suppressEncryption) {
      var tableOffset = xrefEntry.offset;
      var stream = this.fetch(new _primitives.Ref(tableOffset, 0));
      if (!(0, _primitives.isStream)(stream)) {
        throw new _util.FormatError('bad ObjStm stream');
      }
      var first = stream.dict.get('First');
      var n = stream.dict.get('N');
      if (!(0, _util.isInt)(first) || !(0, _util.isInt)(n)) {
        throw new _util.FormatError('invalid first and n parameters for ObjStm stream');
      }
      var parser = new _parser.Parser(new _parser.Lexer(stream), false, this);
      parser.allowStreams = true;
      var i,
          entries = [],
          num,
          nums = [];
      for (i = 0; i < n; ++i) {
        num = parser.getObj();
        if (!(0, _util.isInt)(num)) {
          throw new _util.FormatError('invalid object number in the ObjStm stream: ' + num);
        }
        nums.push(num);
        var offset = parser.getObj();
        if (!(0, _util.isInt)(offset)) {
          throw new _util.FormatError('invalid object offset in the ObjStm stream: ' + offset);
        }
      }
      for (i = 0; i < n; ++i) {
        entries.push(parser.getObj());
        if ((0, _primitives.isCmd)(parser.buf1, 'endobj')) {
          parser.shift();
        }
        num = nums[i];
        var entry = this.entries[num];
        if (entry && entry.offset === tableOffset && entry.gen === i) {
          this.cache[num] = entries[i];
        }
      }
      xrefEntry = entries[xrefEntry.gen];
      if (xrefEntry === undefined) {
        throw new _util.FormatError('bad XRef entry for compressed object');
      }
      return xrefEntry;
    },
    fetchIfRefAsync: function XRef_fetchIfRefAsync(obj, suppressEncryption) {
      if (!(0, _primitives.isRef)(obj)) {
        return Promise.resolve(obj);
      }
      return this.fetchAsync(obj, suppressEncryption);
    },
    fetchAsync: function XRef_fetchAsync(ref, suppressEncryption) {
      var streamManager = this.stream.manager;
      var xref = this;
      return new Promise(function tryFetch(resolve, reject) {
        try {
          resolve(xref.fetch(ref, suppressEncryption));
        } catch (e) {
          if (e instanceof _util.MissingDataException) {
            streamManager.requestRange(e.begin, e.end).then(function () {
              tryFetch(resolve, reject);
            }, reject);
            return;
          }
          reject(e);
        }
      });
    },
    getCatalogObj: function XRef_getCatalogObj() {
      return this.root;
    }
  };
  return XRef;
}();
var NameOrNumberTree = function NameOrNumberTreeClosure() {
  function NameOrNumberTree(root, xref) {
    throw new Error('Cannot initialize NameOrNumberTree.');
  }
  NameOrNumberTree.prototype = {
    getAll: function NameOrNumberTree_getAll() {
      var dict = Object.create(null);
      if (!this.root) {
        return dict;
      }
      var xref = this.xref;
      var processed = new _primitives.RefSet();
      processed.put(this.root);
      var queue = [this.root];
      while (queue.length > 0) {
        var i, n;
        var obj = xref.fetchIfRef(queue.shift());
        if (!(0, _primitives.isDict)(obj)) {
          continue;
        }
        if (obj.has('Kids')) {
          var kids = obj.get('Kids');
          for (i = 0, n = kids.length; i < n; i++) {
            var kid = kids[i];
            if (processed.has(kid)) {
              throw new _util.FormatError('Duplicate entry in "' + this._type + '" tree.');
            }
            queue.push(kid);
            processed.put(kid);
          }
          continue;
        }
        var entries = obj.get(this._type);
        if ((0, _util.isArray)(entries)) {
          for (i = 0, n = entries.length; i < n; i += 2) {
            dict[xref.fetchIfRef(entries[i])] = xref.fetchIfRef(entries[i + 1]);
          }
        }
      }
      return dict;
    },
    get: function NameOrNumberTree_get(key) {
      if (!this.root) {
        return null;
      }
      var xref = this.xref;
      var kidsOrEntries = xref.fetchIfRef(this.root);
      var loopCount = 0;
      var MAX_LEVELS = 10;
      var l, r, m;
      while (kidsOrEntries.has('Kids')) {
        if (++loopCount > MAX_LEVELS) {
          (0, _util.warn)('Search depth limit reached for "' + this._type + '" tree.');
          return null;
        }
        var kids = kidsOrEntries.get('Kids');
        if (!(0, _util.isArray)(kids)) {
          return null;
        }
        l = 0;
        r = kids.length - 1;
        while (l <= r) {
          m = l + r >> 1;
          var kid = xref.fetchIfRef(kids[m]);
          var limits = kid.get('Limits');
          if (key < xref.fetchIfRef(limits[0])) {
            r = m - 1;
          } else if (key > xref.fetchIfRef(limits[1])) {
            l = m + 1;
          } else {
            kidsOrEntries = xref.fetchIfRef(kids[m]);
            break;
          }
        }
        if (l > r) {
          return null;
        }
      }
      var entries = kidsOrEntries.get(this._type);
      if ((0, _util.isArray)(entries)) {
        l = 0;
        r = entries.length - 2;
        while (l <= r) {
          m = l + r & ~1;
          var currentKey = xref.fetchIfRef(entries[m]);
          if (key < currentKey) {
            r = m - 2;
          } else if (key > currentKey) {
            l = m + 2;
          } else {
            return xref.fetchIfRef(entries[m + 1]);
          }
        }
      }
      return null;
    }
  };
  return NameOrNumberTree;
}();
var NameTree = function NameTreeClosure() {
  function NameTree(root, xref) {
    this.root = root;
    this.xref = xref;
    this._type = 'Names';
  }
  _util.Util.inherit(NameTree, NameOrNumberTree, {});
  return NameTree;
}();
var NumberTree = function NumberTreeClosure() {
  function NumberTree(root, xref) {
    this.root = root;
    this.xref = xref;
    this._type = 'Nums';
  }
  _util.Util.inherit(NumberTree, NameOrNumberTree, {});
  return NumberTree;
}();
var FileSpec = function FileSpecClosure() {
  function FileSpec(root, xref) {
    if (!root || !(0, _primitives.isDict)(root)) {
      return;
    }
    this.xref = xref;
    this.root = root;
    if (root.has('FS')) {
      this.fs = root.get('FS');
    }
    this.description = root.has('Desc') ? (0, _util.stringToPDFString)(root.get('Desc')) : '';
    if (root.has('RF')) {
      (0, _util.warn)('Related file specifications are not supported');
    }
    this.contentAvailable = true;
    if (!root.has('EF')) {
      this.contentAvailable = false;
      (0, _util.warn)('Non-embedded file specifications are not supported');
    }
  }
  function pickPlatformItem(dict) {
    if (dict.has('UF')) {
      return dict.get('UF');
    } else if (dict.has('F')) {
      return dict.get('F');
    } else if (dict.has('Unix')) {
      return dict.get('Unix');
    } else if (dict.has('Mac')) {
      return dict.get('Mac');
    } else if (dict.has('DOS')) {
      return dict.get('DOS');
    }
    return null;
  }
  FileSpec.prototype = {
    get filename() {
      if (!this._filename && this.root) {
        var filename = pickPlatformItem(this.root) || 'unnamed';
        this._filename = (0, _util.stringToPDFString)(filename).replace(/\\\\/g, '\\').replace(/\\\//g, '/').replace(/\\/g, '/');
      }
      return this._filename;
    },
    get content() {
      if (!this.contentAvailable) {
        return null;
      }
      if (!this.contentRef && this.root) {
        this.contentRef = pickPlatformItem(this.root.get('EF'));
      }
      var content = null;
      if (this.contentRef) {
        var xref = this.xref;
        var fileObj = xref.fetchIfRef(this.contentRef);
        if (fileObj && (0, _primitives.isStream)(fileObj)) {
          content = fileObj.getBytes();
        } else {
          (0, _util.warn)('Embedded file specification points to non-existing/invalid ' + 'content');
        }
      } else {
        (0, _util.warn)('Embedded file specification does not have a content');
      }
      return content;
    },
    get serializable() {
      return {
        filename: this.filename,
        content: this.content
      };
    }
  };
  return FileSpec;
}();
var ObjectLoader = function () {
  function mayHaveChildren(value) {
    return (0, _primitives.isRef)(value) || (0, _primitives.isDict)(value) || (0, _util.isArray)(value) || (0, _primitives.isStream)(value);
  }
  function addChildren(node, nodesToVisit) {
    if ((0, _primitives.isDict)(node) || (0, _primitives.isStream)(node)) {
      var dict = (0, _primitives.isDict)(node) ? node : node.dict;
      var dictKeys = dict.getKeys();
      for (var i = 0, ii = dictKeys.length; i < ii; i++) {
        var rawValue = dict.getRaw(dictKeys[i]);
        if (mayHaveChildren(rawValue)) {
          nodesToVisit.push(rawValue);
        }
      }
    } else if ((0, _util.isArray)(node)) {
      for (var _i = 0, _ii = node.length; _i < _ii; _i++) {
        var value = node[_i];
        if (mayHaveChildren(value)) {
          nodesToVisit.push(value);
        }
      }
    }
  }
  function ObjectLoader(dict, keys, xref) {
    this.dict = dict;
    this.keys = keys;
    this.xref = xref;
    this.refSet = null;
    this.capability = null;
  }
  ObjectLoader.prototype = {
    load: function load() {
      this.capability = (0, _util.createPromiseCapability)();
      if (!(this.xref.stream instanceof _chunked_stream.ChunkedStream) || this.xref.stream.getMissingChunks().length === 0) {
        this.capability.resolve();
        return this.capability.promise;
      }
      var keys = this.keys,
          dict = this.dict;

      this.refSet = new _primitives.RefSet();
      var nodesToVisit = [];
      for (var i = 0, ii = keys.length; i < ii; i++) {
        var rawValue = dict.getRaw(keys[i]);
        if (rawValue !== undefined) {
          nodesToVisit.push(rawValue);
        }
      }
      this._walk(nodesToVisit);
      return this.capability.promise;
    },
    _walk: function _walk(nodesToVisit) {
      var _this3 = this;

      var nodesToRevisit = [];
      var pendingRequests = [];
      while (nodesToVisit.length) {
        var currentNode = nodesToVisit.pop();
        if ((0, _primitives.isRef)(currentNode)) {
          if (this.refSet.has(currentNode)) {
            continue;
          }
          try {
            this.refSet.put(currentNode);
            currentNode = this.xref.fetch(currentNode);
          } catch (ex) {
            if (!(ex instanceof _util.MissingDataException)) {
              throw ex;
            }
            nodesToRevisit.push(currentNode);
            pendingRequests.push({
              begin: ex.begin,
              end: ex.end
            });
          }
        }
        if (currentNode && currentNode.getBaseStreams) {
          var baseStreams = currentNode.getBaseStreams();
          var foundMissingData = false;
          for (var i = 0, ii = baseStreams.length; i < ii; i++) {
            var stream = baseStreams[i];
            if (stream.getMissingChunks && stream.getMissingChunks().length) {
              foundMissingData = true;
              pendingRequests.push({
                begin: stream.start,
                end: stream.end
              });
            }
          }
          if (foundMissingData) {
            nodesToRevisit.push(currentNode);
          }
        }
        addChildren(currentNode, nodesToVisit);
      }
      if (pendingRequests.length) {
        this.xref.stream.manager.requestRanges(pendingRequests).then(function () {
          for (var _i2 = 0, _ii2 = nodesToRevisit.length; _i2 < _ii2; _i2++) {
            var node = nodesToRevisit[_i2];
            if ((0, _primitives.isRef)(node)) {
              _this3.refSet.remove(node);
            }
          }
          _this3._walk(nodesToRevisit);
        }, this.capability.reject);
        return;
      }
      this.refSet = null;
      this.capability.resolve();
    }
  };
  return ObjectLoader;
}();
exports.Catalog = Catalog;
exports.ObjectLoader = ObjectLoader;
exports.XRef = XRef;
exports.FileSpec = FileSpec;

/***/ }),
/* 15 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSupplementalGlyphMapForArialBlack = exports.getGlyphMapForStandardFonts = exports.getSymbolsFonts = exports.getSerifFonts = exports.getNonStdFontMap = exports.getStdFontMap = undefined;

var _util = __w_pdfjs_require__(0);

var getStdFontMap = (0, _util.getLookupTableFactory)(function (t) {
  t['ArialNarrow'] = 'Helvetica';
  t['ArialNarrow-Bold'] = 'Helvetica-Bold';
  t['ArialNarrow-BoldItalic'] = 'Helvetica-BoldOblique';
  t['ArialNarrow-Italic'] = 'Helvetica-Oblique';
  t['ArialBlack'] = 'Helvetica';
  t['ArialBlack-Bold'] = 'Helvetica-Bold';
  t['ArialBlack-BoldItalic'] = 'Helvetica-BoldOblique';
  t['ArialBlack-Italic'] = 'Helvetica-Oblique';
  t['Arial-Black'] = 'Helvetica';
  t['Arial-Black-Bold'] = 'Helvetica-Bold';
  t['Arial-Black-BoldItalic'] = 'Helvetica-BoldOblique';
  t['Arial-Black-Italic'] = 'Helvetica-Oblique';
  t['Arial'] = 'Helvetica';
  t['Arial-Bold'] = 'Helvetica-Bold';
  t['Arial-BoldItalic'] = 'Helvetica-BoldOblique';
  t['Arial-Italic'] = 'Helvetica-Oblique';
  t['Arial-BoldItalicMT'] = 'Helvetica-BoldOblique';
  t['Arial-BoldMT'] = 'Helvetica-Bold';
  t['Arial-ItalicMT'] = 'Helvetica-Oblique';
  t['ArialMT'] = 'Helvetica';
  t['Courier-Bold'] = 'Courier-Bold';
  t['Courier-BoldItalic'] = 'Courier-BoldOblique';
  t['Courier-Italic'] = 'Courier-Oblique';
  t['CourierNew'] = 'Courier';
  t['CourierNew-Bold'] = 'Courier-Bold';
  t['CourierNew-BoldItalic'] = 'Courier-BoldOblique';
  t['CourierNew-Italic'] = 'Courier-Oblique';
  t['CourierNewPS-BoldItalicMT'] = 'Courier-BoldOblique';
  t['CourierNewPS-BoldMT'] = 'Courier-Bold';
  t['CourierNewPS-ItalicMT'] = 'Courier-Oblique';
  t['CourierNewPSMT'] = 'Courier';
  t['Helvetica'] = 'Helvetica';
  t['Helvetica-Bold'] = 'Helvetica-Bold';
  t['Helvetica-BoldItalic'] = 'Helvetica-BoldOblique';
  t['Helvetica-BoldOblique'] = 'Helvetica-BoldOblique';
  t['Helvetica-Italic'] = 'Helvetica-Oblique';
  t['Helvetica-Oblique'] = 'Helvetica-Oblique';
  t['SegoeUISymbol'] = 'Helvetica';
  t['Symbol-Bold'] = 'Symbol';
  t['Symbol-BoldItalic'] = 'Symbol';
  t['Symbol-Italic'] = 'Symbol';
  t['TimesNewRoman'] = 'Times-Roman';
  t['TimesNewRoman-Bold'] = 'Times-Bold';
  t['TimesNewRoman-BoldItalic'] = 'Times-BoldItalic';
  t['TimesNewRoman-Italic'] = 'Times-Italic';
  t['TimesNewRomanPS'] = 'Times-Roman';
  t['TimesNewRomanPS-Bold'] = 'Times-Bold';
  t['TimesNewRomanPS-BoldItalic'] = 'Times-BoldItalic';
  t['TimesNewRomanPS-BoldItalicMT'] = 'Times-BoldItalic';
  t['TimesNewRomanPS-BoldMT'] = 'Times-Bold';
  t['TimesNewRomanPS-Italic'] = 'Times-Italic';
  t['TimesNewRomanPS-ItalicMT'] = 'Times-Italic';
  t['TimesNewRomanPSMT'] = 'Times-Roman';
  t['TimesNewRomanPSMT-Bold'] = 'Times-Bold';
  t['TimesNewRomanPSMT-BoldItalic'] = 'Times-BoldItalic';
  t['TimesNewRomanPSMT-Italic'] = 'Times-Italic';
});
var getNonStdFontMap = (0, _util.getLookupTableFactory)(function (t) {
  t['CenturyGothic'] = 'Helvetica';
  t['CenturyGothic-Bold'] = 'Helvetica-Bold';
  t['CenturyGothic-BoldItalic'] = 'Helvetica-BoldOblique';
  t['CenturyGothic-Italic'] = 'Helvetica-Oblique';
  t['ComicSansMS'] = 'Comic Sans MS';
  t['ComicSansMS-Bold'] = 'Comic Sans MS-Bold';
  t['ComicSansMS-BoldItalic'] = 'Comic Sans MS-BoldItalic';
  t['ComicSansMS-Italic'] = 'Comic Sans MS-Italic';
  t['LucidaConsole'] = 'Courier';
  t['LucidaConsole-Bold'] = 'Courier-Bold';
  t['LucidaConsole-BoldItalic'] = 'Courier-BoldOblique';
  t['LucidaConsole-Italic'] = 'Courier-Oblique';
  t['MS-Gothic'] = 'MS Gothic';
  t['MS-Gothic-Bold'] = 'MS Gothic-Bold';
  t['MS-Gothic-BoldItalic'] = 'MS Gothic-BoldItalic';
  t['MS-Gothic-Italic'] = 'MS Gothic-Italic';
  t['MS-Mincho'] = 'MS Mincho';
  t['MS-Mincho-Bold'] = 'MS Mincho-Bold';
  t['MS-Mincho-BoldItalic'] = 'MS Mincho-BoldItalic';
  t['MS-Mincho-Italic'] = 'MS Mincho-Italic';
  t['MS-PGothic'] = 'MS PGothic';
  t['MS-PGothic-Bold'] = 'MS PGothic-Bold';
  t['MS-PGothic-BoldItalic'] = 'MS PGothic-BoldItalic';
  t['MS-PGothic-Italic'] = 'MS PGothic-Italic';
  t['MS-PMincho'] = 'MS PMincho';
  t['MS-PMincho-Bold'] = 'MS PMincho-Bold';
  t['MS-PMincho-BoldItalic'] = 'MS PMincho-BoldItalic';
  t['MS-PMincho-Italic'] = 'MS PMincho-Italic';
  t['NuptialScript'] = 'Times-Italic';
  t['Wingdings'] = 'ZapfDingbats';
});
var getSerifFonts = (0, _util.getLookupTableFactory)(function (t) {
  t['Adobe Jenson'] = true;
  t['Adobe Text'] = true;
  t['Albertus'] = true;
  t['Aldus'] = true;
  t['Alexandria'] = true;
  t['Algerian'] = true;
  t['American Typewriter'] = true;
  t['Antiqua'] = true;
  t['Apex'] = true;
  t['Arno'] = true;
  t['Aster'] = true;
  t['Aurora'] = true;
  t['Baskerville'] = true;
  t['Bell'] = true;
  t['Bembo'] = true;
  t['Bembo Schoolbook'] = true;
  t['Benguiat'] = true;
  t['Berkeley Old Style'] = true;
  t['Bernhard Modern'] = true;
  t['Berthold City'] = true;
  t['Bodoni'] = true;
  t['Bauer Bodoni'] = true;
  t['Book Antiqua'] = true;
  t['Bookman'] = true;
  t['Bordeaux Roman'] = true;
  t['Californian FB'] = true;
  t['Calisto'] = true;
  t['Calvert'] = true;
  t['Capitals'] = true;
  t['Cambria'] = true;
  t['Cartier'] = true;
  t['Caslon'] = true;
  t['Catull'] = true;
  t['Centaur'] = true;
  t['Century Old Style'] = true;
  t['Century Schoolbook'] = true;
  t['Chaparral'] = true;
  t['Charis SIL'] = true;
  t['Cheltenham'] = true;
  t['Cholla Slab'] = true;
  t['Clarendon'] = true;
  t['Clearface'] = true;
  t['Cochin'] = true;
  t['Colonna'] = true;
  t['Computer Modern'] = true;
  t['Concrete Roman'] = true;
  t['Constantia'] = true;
  t['Cooper Black'] = true;
  t['Corona'] = true;
  t['Ecotype'] = true;
  t['Egyptienne'] = true;
  t['Elephant'] = true;
  t['Excelsior'] = true;
  t['Fairfield'] = true;
  t['FF Scala'] = true;
  t['Folkard'] = true;
  t['Footlight'] = true;
  t['FreeSerif'] = true;
  t['Friz Quadrata'] = true;
  t['Garamond'] = true;
  t['Gentium'] = true;
  t['Georgia'] = true;
  t['Gloucester'] = true;
  t['Goudy Old Style'] = true;
  t['Goudy Schoolbook'] = true;
  t['Goudy Pro Font'] = true;
  t['Granjon'] = true;
  t['Guardian Egyptian'] = true;
  t['Heather'] = true;
  t['Hercules'] = true;
  t['High Tower Text'] = true;
  t['Hiroshige'] = true;
  t['Hoefler Text'] = true;
  t['Humana Serif'] = true;
  t['Imprint'] = true;
  t['Ionic No. 5'] = true;
  t['Janson'] = true;
  t['Joanna'] = true;
  t['Korinna'] = true;
  t['Lexicon'] = true;
  t['Liberation Serif'] = true;
  t['Linux Libertine'] = true;
  t['Literaturnaya'] = true;
  t['Lucida'] = true;
  t['Lucida Bright'] = true;
  t['Melior'] = true;
  t['Memphis'] = true;
  t['Miller'] = true;
  t['Minion'] = true;
  t['Modern'] = true;
  t['Mona Lisa'] = true;
  t['Mrs Eaves'] = true;
  t['MS Serif'] = true;
  t['Museo Slab'] = true;
  t['New York'] = true;
  t['Nimbus Roman'] = true;
  t['NPS Rawlinson Roadway'] = true;
  t['NuptialScript'] = true;
  t['Palatino'] = true;
  t['Perpetua'] = true;
  t['Plantin'] = true;
  t['Plantin Schoolbook'] = true;
  t['Playbill'] = true;
  t['Poor Richard'] = true;
  t['Rawlinson Roadway'] = true;
  t['Renault'] = true;
  t['Requiem'] = true;
  t['Rockwell'] = true;
  t['Roman'] = true;
  t['Rotis Serif'] = true;
  t['Sabon'] = true;
  t['Scala'] = true;
  t['Seagull'] = true;
  t['Sistina'] = true;
  t['Souvenir'] = true;
  t['STIX'] = true;
  t['Stone Informal'] = true;
  t['Stone Serif'] = true;
  t['Sylfaen'] = true;
  t['Times'] = true;
  t['Trajan'] = true;
  t['Trinité'] = true;
  t['Trump Mediaeval'] = true;
  t['Utopia'] = true;
  t['Vale Type'] = true;
  t['Bitstream Vera'] = true;
  t['Vera Serif'] = true;
  t['Versailles'] = true;
  t['Wanted'] = true;
  t['Weiss'] = true;
  t['Wide Latin'] = true;
  t['Windsor'] = true;
  t['XITS'] = true;
});
var getSymbolsFonts = (0, _util.getLookupTableFactory)(function (t) {
  t['Dingbats'] = true;
  t['Symbol'] = true;
  t['ZapfDingbats'] = true;
});
var getGlyphMapForStandardFonts = (0, _util.getLookupTableFactory)(function (t) {
  t[2] = 10;
  t[3] = 32;
  t[4] = 33;
  t[5] = 34;
  t[6] = 35;
  t[7] = 36;
  t[8] = 37;
  t[9] = 38;
  t[10] = 39;
  t[11] = 40;
  t[12] = 41;
  t[13] = 42;
  t[14] = 43;
  t[15] = 44;
  t[16] = 45;
  t[17] = 46;
  t[18] = 47;
  t[19] = 48;
  t[20] = 49;
  t[21] = 50;
  t[22] = 51;
  t[23] = 52;
  t[24] = 53;
  t[25] = 54;
  t[26] = 55;
  t[27] = 56;
  t[28] = 57;
  t[29] = 58;
  t[30] = 894;
  t[31] = 60;
  t[32] = 61;
  t[33] = 62;
  t[34] = 63;
  t[35] = 64;
  t[36] = 65;
  t[37] = 66;
  t[38] = 67;
  t[39] = 68;
  t[40] = 69;
  t[41] = 70;
  t[42] = 71;
  t[43] = 72;
  t[44] = 73;
  t[45] = 74;
  t[46] = 75;
  t[47] = 76;
  t[48] = 77;
  t[49] = 78;
  t[50] = 79;
  t[51] = 80;
  t[52] = 81;
  t[53] = 82;
  t[54] = 83;
  t[55] = 84;
  t[56] = 85;
  t[57] = 86;
  t[58] = 87;
  t[59] = 88;
  t[60] = 89;
  t[61] = 90;
  t[62] = 91;
  t[63] = 92;
  t[64] = 93;
  t[65] = 94;
  t[66] = 95;
  t[67] = 96;
  t[68] = 97;
  t[69] = 98;
  t[70] = 99;
  t[71] = 100;
  t[72] = 101;
  t[73] = 102;
  t[74] = 103;
  t[75] = 104;
  t[76] = 105;
  t[77] = 106;
  t[78] = 107;
  t[79] = 108;
  t[80] = 109;
  t[81] = 110;
  t[82] = 111;
  t[83] = 112;
  t[84] = 113;
  t[85] = 114;
  t[86] = 115;
  t[87] = 116;
  t[88] = 117;
  t[89] = 118;
  t[90] = 119;
  t[91] = 120;
  t[92] = 121;
  t[93] = 122;
  t[94] = 123;
  t[95] = 124;
  t[96] = 125;
  t[97] = 126;
  t[98] = 196;
  t[99] = 197;
  t[100] = 199;
  t[101] = 201;
  t[102] = 209;
  t[103] = 214;
  t[104] = 220;
  t[105] = 225;
  t[106] = 224;
  t[107] = 226;
  t[108] = 228;
  t[109] = 227;
  t[110] = 229;
  t[111] = 231;
  t[112] = 233;
  t[113] = 232;
  t[114] = 234;
  t[115] = 235;
  t[116] = 237;
  t[117] = 236;
  t[118] = 238;
  t[119] = 239;
  t[120] = 241;
  t[121] = 243;
  t[122] = 242;
  t[123] = 244;
  t[124] = 246;
  t[125] = 245;
  t[126] = 250;
  t[127] = 249;
  t[128] = 251;
  t[129] = 252;
  t[130] = 8224;
  t[131] = 176;
  t[132] = 162;
  t[133] = 163;
  t[134] = 167;
  t[135] = 8226;
  t[136] = 182;
  t[137] = 223;
  t[138] = 174;
  t[139] = 169;
  t[140] = 8482;
  t[141] = 180;
  t[142] = 168;
  t[143] = 8800;
  t[144] = 198;
  t[145] = 216;
  t[146] = 8734;
  t[147] = 177;
  t[148] = 8804;
  t[149] = 8805;
  t[150] = 165;
  t[151] = 181;
  t[152] = 8706;
  t[153] = 8721;
  t[154] = 8719;
  t[156] = 8747;
  t[157] = 170;
  t[158] = 186;
  t[159] = 8486;
  t[160] = 230;
  t[161] = 248;
  t[162] = 191;
  t[163] = 161;
  t[164] = 172;
  t[165] = 8730;
  t[166] = 402;
  t[167] = 8776;
  t[168] = 8710;
  t[169] = 171;
  t[170] = 187;
  t[171] = 8230;
  t[210] = 218;
  t[223] = 711;
  t[224] = 321;
  t[225] = 322;
  t[227] = 353;
  t[229] = 382;
  t[234] = 253;
  t[252] = 263;
  t[253] = 268;
  t[254] = 269;
  t[258] = 258;
  t[260] = 260;
  t[261] = 261;
  t[265] = 280;
  t[266] = 281;
  t[268] = 283;
  t[269] = 313;
  t[275] = 323;
  t[276] = 324;
  t[278] = 328;
  t[284] = 345;
  t[285] = 346;
  t[286] = 347;
  t[292] = 367;
  t[295] = 377;
  t[296] = 378;
  t[298] = 380;
  t[305] = 963;
  t[306] = 964;
  t[307] = 966;
  t[308] = 8215;
  t[309] = 8252;
  t[310] = 8319;
  t[311] = 8359;
  t[312] = 8592;
  t[313] = 8593;
  t[337] = 9552;
  t[493] = 1039;
  t[494] = 1040;
  t[705] = 1524;
  t[706] = 8362;
  t[710] = 64288;
  t[711] = 64298;
  t[759] = 1617;
  t[761] = 1776;
  t[763] = 1778;
  t[775] = 1652;
  t[777] = 1764;
  t[778] = 1780;
  t[779] = 1781;
  t[780] = 1782;
  t[782] = 771;
  t[783] = 64726;
  t[786] = 8363;
  t[788] = 8532;
  t[790] = 768;
  t[791] = 769;
  t[792] = 768;
  t[795] = 803;
  t[797] = 64336;
  t[798] = 64337;
  t[799] = 64342;
  t[800] = 64343;
  t[801] = 64344;
  t[802] = 64345;
  t[803] = 64362;
  t[804] = 64363;
  t[805] = 64364;
  t[2424] = 7821;
  t[2425] = 7822;
  t[2426] = 7823;
  t[2427] = 7824;
  t[2428] = 7825;
  t[2429] = 7826;
  t[2430] = 7827;
  t[2433] = 7682;
  t[2678] = 8045;
  t[2679] = 8046;
  t[2830] = 1552;
  t[2838] = 686;
  t[2840] = 751;
  t[2842] = 753;
  t[2843] = 754;
  t[2844] = 755;
  t[2846] = 757;
  t[2856] = 767;
  t[2857] = 848;
  t[2858] = 849;
  t[2862] = 853;
  t[2863] = 854;
  t[2864] = 855;
  t[2865] = 861;
  t[2866] = 862;
  t[2906] = 7460;
  t[2908] = 7462;
  t[2909] = 7463;
  t[2910] = 7464;
  t[2912] = 7466;
  t[2913] = 7467;
  t[2914] = 7468;
  t[2916] = 7470;
  t[2917] = 7471;
  t[2918] = 7472;
  t[2920] = 7474;
  t[2921] = 7475;
  t[2922] = 7476;
  t[2924] = 7478;
  t[2925] = 7479;
  t[2926] = 7480;
  t[2928] = 7482;
  t[2929] = 7483;
  t[2930] = 7484;
  t[2932] = 7486;
  t[2933] = 7487;
  t[2934] = 7488;
  t[2936] = 7490;
  t[2937] = 7491;
  t[2938] = 7492;
  t[2940] = 7494;
  t[2941] = 7495;
  t[2942] = 7496;
  t[2944] = 7498;
  t[2946] = 7500;
  t[2948] = 7502;
  t[2950] = 7504;
  t[2951] = 7505;
  t[2952] = 7506;
  t[2954] = 7508;
  t[2955] = 7509;
  t[2956] = 7510;
  t[2958] = 7512;
  t[2959] = 7513;
  t[2960] = 7514;
  t[2962] = 7516;
  t[2963] = 7517;
  t[2964] = 7518;
  t[2966] = 7520;
  t[2967] = 7521;
  t[2968] = 7522;
  t[2970] = 7524;
  t[2971] = 7525;
  t[2972] = 7526;
  t[2974] = 7528;
  t[2975] = 7529;
  t[2976] = 7530;
  t[2978] = 1537;
  t[2979] = 1538;
  t[2980] = 1539;
  t[2982] = 1549;
  t[2983] = 1551;
  t[2984] = 1552;
  t[2986] = 1554;
  t[2987] = 1555;
  t[2988] = 1556;
  t[2990] = 1623;
  t[2991] = 1624;
  t[2995] = 1775;
  t[2999] = 1791;
  t[3002] = 64290;
  t[3003] = 64291;
  t[3004] = 64292;
  t[3006] = 64294;
  t[3007] = 64295;
  t[3008] = 64296;
  t[3011] = 1900;
  t[3014] = 8223;
  t[3015] = 8244;
  t[3017] = 7532;
  t[3018] = 7533;
  t[3019] = 7534;
  t[3075] = 7590;
  t[3076] = 7591;
  t[3079] = 7594;
  t[3080] = 7595;
  t[3083] = 7598;
  t[3084] = 7599;
  t[3087] = 7602;
  t[3088] = 7603;
  t[3091] = 7606;
  t[3092] = 7607;
  t[3095] = 7610;
  t[3096] = 7611;
  t[3099] = 7614;
  t[3100] = 7615;
  t[3103] = 7618;
  t[3104] = 7619;
  t[3107] = 8337;
  t[3108] = 8338;
  t[3116] = 1884;
  t[3119] = 1885;
  t[3120] = 1885;
  t[3123] = 1886;
  t[3124] = 1886;
  t[3127] = 1887;
  t[3128] = 1887;
  t[3131] = 1888;
  t[3132] = 1888;
  t[3135] = 1889;
  t[3136] = 1889;
  t[3139] = 1890;
  t[3140] = 1890;
  t[3143] = 1891;
  t[3144] = 1891;
  t[3147] = 1892;
  t[3148] = 1892;
  t[3153] = 580;
  t[3154] = 581;
  t[3157] = 584;
  t[3158] = 585;
  t[3161] = 588;
  t[3162] = 589;
  t[3165] = 891;
  t[3166] = 892;
  t[3169] = 1274;
  t[3170] = 1275;
  t[3173] = 1278;
  t[3174] = 1279;
  t[3181] = 7622;
  t[3182] = 7623;
  t[3282] = 11799;
  t[3316] = 578;
  t[3379] = 42785;
  t[3393] = 1159;
  t[3416] = 8377;
});
var getSupplementalGlyphMapForArialBlack = (0, _util.getLookupTableFactory)(function (t) {
  t[227] = 322;
  t[264] = 261;
  t[291] = 346;
});
exports.getStdFontMap = getStdFontMap;
exports.getNonStdFontMap = getNonStdFontMap;
exports.getSerifFonts = getSerifFonts;
exports.getSymbolsFonts = getSymbolsFonts;
exports.getGlyphMapForStandardFonts = getGlyphMapForStandardFonts;
exports.getSupplementalGlyphMapForArialBlack = getSupplementalGlyphMapForArialBlack;

/***/ }),
/* 16 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var getLookupTableFactory = __w_pdfjs_require__(0).getLookupTableFactory;
var getSpecialPUASymbols = getLookupTableFactory(function (t) {
  t[63721] = 0x00A9;
  t[63193] = 0x00A9;
  t[63720] = 0x00AE;
  t[63194] = 0x00AE;
  t[63722] = 0x2122;
  t[63195] = 0x2122;
  t[63729] = 0x23A7;
  t[63730] = 0x23A8;
  t[63731] = 0x23A9;
  t[63740] = 0x23AB;
  t[63741] = 0x23AC;
  t[63742] = 0x23AD;
  t[63726] = 0x23A1;
  t[63727] = 0x23A2;
  t[63728] = 0x23A3;
  t[63737] = 0x23A4;
  t[63738] = 0x23A5;
  t[63739] = 0x23A6;
  t[63723] = 0x239B;
  t[63724] = 0x239C;
  t[63725] = 0x239D;
  t[63734] = 0x239E;
  t[63735] = 0x239F;
  t[63736] = 0x23A0;
});
function mapSpecialUnicodeValues(code) {
  if (code >= 0xFFF0 && code <= 0xFFFF) {
    return 0;
  } else if (code >= 0xF600 && code <= 0xF8FF) {
    return getSpecialPUASymbols()[code] || code;
  }
  return code;
}
function getUnicodeForGlyph(name, glyphsUnicodeMap) {
  var unicode = glyphsUnicodeMap[name];
  if (unicode !== undefined) {
    return unicode;
  }
  if (!name) {
    return -1;
  }
  if (name[0] === 'u') {
    var nameLen = name.length,
        hexStr;
    if (nameLen === 7 && name[1] === 'n' && name[2] === 'i') {
      hexStr = name.substr(3);
    } else if (nameLen >= 5 && nameLen <= 7) {
      hexStr = name.substr(1);
    } else {
      return -1;
    }
    if (hexStr === hexStr.toUpperCase()) {
      unicode = parseInt(hexStr, 16);
      if (unicode >= 0) {
        return unicode;
      }
    }
  }
  return -1;
}
var UnicodeRanges = [{
  'begin': 0x0000,
  'end': 0x007F
}, {
  'begin': 0x0080,
  'end': 0x00FF
}, {
  'begin': 0x0100,
  'end': 0x017F
}, {
  'begin': 0x0180,
  'end': 0x024F
}, {
  'begin': 0x0250,
  'end': 0x02AF
}, {
  'begin': 0x02B0,
  'end': 0x02FF
}, {
  'begin': 0x0300,
  'end': 0x036F
}, {
  'begin': 0x0370,
  'end': 0x03FF
}, {
  'begin': 0x2C80,
  'end': 0x2CFF
}, {
  'begin': 0x0400,
  'end': 0x04FF
}, {
  'begin': 0x0530,
  'end': 0x058F
}, {
  'begin': 0x0590,
  'end': 0x05FF
}, {
  'begin': 0xA500,
  'end': 0xA63F
}, {
  'begin': 0x0600,
  'end': 0x06FF
}, {
  'begin': 0x07C0,
  'end': 0x07FF
}, {
  'begin': 0x0900,
  'end': 0x097F
}, {
  'begin': 0x0980,
  'end': 0x09FF
}, {
  'begin': 0x0A00,
  'end': 0x0A7F
}, {
  'begin': 0x0A80,
  'end': 0x0AFF
}, {
  'begin': 0x0B00,
  'end': 0x0B7F
}, {
  'begin': 0x0B80,
  'end': 0x0BFF
}, {
  'begin': 0x0C00,
  'end': 0x0C7F
}, {
  'begin': 0x0C80,
  'end': 0x0CFF
}, {
  'begin': 0x0D00,
  'end': 0x0D7F
}, {
  'begin': 0x0E00,
  'end': 0x0E7F
}, {
  'begin': 0x0E80,
  'end': 0x0EFF
}, {
  'begin': 0x10A0,
  'end': 0x10FF
}, {
  'begin': 0x1B00,
  'end': 0x1B7F
}, {
  'begin': 0x1100,
  'end': 0x11FF
}, {
  'begin': 0x1E00,
  'end': 0x1EFF
}, {
  'begin': 0x1F00,
  'end': 0x1FFF
}, {
  'begin': 0x2000,
  'end': 0x206F
}, {
  'begin': 0x2070,
  'end': 0x209F
}, {
  'begin': 0x20A0,
  'end': 0x20CF
}, {
  'begin': 0x20D0,
  'end': 0x20FF
}, {
  'begin': 0x2100,
  'end': 0x214F
}, {
  'begin': 0x2150,
  'end': 0x218F
}, {
  'begin': 0x2190,
  'end': 0x21FF
}, {
  'begin': 0x2200,
  'end': 0x22FF
}, {
  'begin': 0x2300,
  'end': 0x23FF
}, {
  'begin': 0x2400,
  'end': 0x243F
}, {
  'begin': 0x2440,
  'end': 0x245F
}, {
  'begin': 0x2460,
  'end': 0x24FF
}, {
  'begin': 0x2500,
  'end': 0x257F
}, {
  'begin': 0x2580,
  'end': 0x259F
}, {
  'begin': 0x25A0,
  'end': 0x25FF
}, {
  'begin': 0x2600,
  'end': 0x26FF
}, {
  'begin': 0x2700,
  'end': 0x27BF
}, {
  'begin': 0x3000,
  'end': 0x303F
}, {
  'begin': 0x3040,
  'end': 0x309F
}, {
  'begin': 0x30A0,
  'end': 0x30FF
}, {
  'begin': 0x3100,
  'end': 0x312F
}, {
  'begin': 0x3130,
  'end': 0x318F
}, {
  'begin': 0xA840,
  'end': 0xA87F
}, {
  'begin': 0x3200,
  'end': 0x32FF
}, {
  'begin': 0x3300,
  'end': 0x33FF
}, {
  'begin': 0xAC00,
  'end': 0xD7AF
}, {
  'begin': 0xD800,
  'end': 0xDFFF
}, {
  'begin': 0x10900,
  'end': 0x1091F
}, {
  'begin': 0x4E00,
  'end': 0x9FFF
}, {
  'begin': 0xE000,
  'end': 0xF8FF
}, {
  'begin': 0x31C0,
  'end': 0x31EF
}, {
  'begin': 0xFB00,
  'end': 0xFB4F
}, {
  'begin': 0xFB50,
  'end': 0xFDFF
}, {
  'begin': 0xFE20,
  'end': 0xFE2F
}, {
  'begin': 0xFE10,
  'end': 0xFE1F
}, {
  'begin': 0xFE50,
  'end': 0xFE6F
}, {
  'begin': 0xFE70,
  'end': 0xFEFF
}, {
  'begin': 0xFF00,
  'end': 0xFFEF
}, {
  'begin': 0xFFF0,
  'end': 0xFFFF
}, {
  'begin': 0x0F00,
  'end': 0x0FFF
}, {
  'begin': 0x0700,
  'end': 0x074F
}, {
  'begin': 0x0780,
  'end': 0x07BF
}, {
  'begin': 0x0D80,
  'end': 0x0DFF
}, {
  'begin': 0x1000,
  'end': 0x109F
}, {
  'begin': 0x1200,
  'end': 0x137F
}, {
  'begin': 0x13A0,
  'end': 0x13FF
}, {
  'begin': 0x1400,
  'end': 0x167F
}, {
  'begin': 0x1680,
  'end': 0x169F
}, {
  'begin': 0x16A0,
  'end': 0x16FF
}, {
  'begin': 0x1780,
  'end': 0x17FF
}, {
  'begin': 0x1800,
  'end': 0x18AF
}, {
  'begin': 0x2800,
  'end': 0x28FF
}, {
  'begin': 0xA000,
  'end': 0xA48F
}, {
  'begin': 0x1700,
  'end': 0x171F
}, {
  'begin': 0x10300,
  'end': 0x1032F
}, {
  'begin': 0x10330,
  'end': 0x1034F
}, {
  'begin': 0x10400,
  'end': 0x1044F
}, {
  'begin': 0x1D000,
  'end': 0x1D0FF
}, {
  'begin': 0x1D400,
  'end': 0x1D7FF
}, {
  'begin': 0xFF000,
  'end': 0xFFFFD
}, {
  'begin': 0xFE00,
  'end': 0xFE0F
}, {
  'begin': 0xE0000,
  'end': 0xE007F
}, {
  'begin': 0x1900,
  'end': 0x194F
}, {
  'begin': 0x1950,
  'end': 0x197F
}, {
  'begin': 0x1980,
  'end': 0x19DF
}, {
  'begin': 0x1A00,
  'end': 0x1A1F
}, {
  'begin': 0x2C00,
  'end': 0x2C5F
}, {
  'begin': 0x2D30,
  'end': 0x2D7F
}, {
  'begin': 0x4DC0,
  'end': 0x4DFF
}, {
  'begin': 0xA800,
  'end': 0xA82F
}, {
  'begin': 0x10000,
  'end': 0x1007F
}, {
  'begin': 0x10140,
  'end': 0x1018F
}, {
  'begin': 0x10380,
  'end': 0x1039F
}, {
  'begin': 0x103A0,
  'end': 0x103DF
}, {
  'begin': 0x10450,
  'end': 0x1047F
}, {
  'begin': 0x10480,
  'end': 0x104AF
}, {
  'begin': 0x10800,
  'end': 0x1083F
}, {
  'begin': 0x10A00,
  'end': 0x10A5F
}, {
  'begin': 0x1D300,
  'end': 0x1D35F
}, {
  'begin': 0x12000,
  'end': 0x123FF
}, {
  'begin': 0x1D360,
  'end': 0x1D37F
}, {
  'begin': 0x1B80,
  'end': 0x1BBF
}, {
  'begin': 0x1C00,
  'end': 0x1C4F
}, {
  'begin': 0x1C50,
  'end': 0x1C7F
}, {
  'begin': 0xA880,
  'end': 0xA8DF
}, {
  'begin': 0xA900,
  'end': 0xA92F
}, {
  'begin': 0xA930,
  'end': 0xA95F
}, {
  'begin': 0xAA00,
  'end': 0xAA5F
}, {
  'begin': 0x10190,
  'end': 0x101CF
}, {
  'begin': 0x101D0,
  'end': 0x101FF
}, {
  'begin': 0x102A0,
  'end': 0x102DF
}, {
  'begin': 0x1F030,
  'end': 0x1F09F
}];
function getUnicodeRangeFor(value) {
  for (var i = 0, ii = UnicodeRanges.length; i < ii; i++) {
    var range = UnicodeRanges[i];
    if (value >= range.begin && value < range.end) {
      return i;
    }
  }
  return -1;
}
function isRTLRangeFor(value) {
  var range = UnicodeRanges[13];
  if (value >= range.begin && value < range.end) {
    return true;
  }
  range = UnicodeRanges[11];
  if (value >= range.begin && value < range.end) {
    return true;
  }
  return false;
}
var getNormalizedUnicodes = getLookupTableFactory(function (t) {
  t['\xA8'] = ' \u0308';
  t['\xAF'] = ' \u0304';
  t['\xB4'] = ' \u0301';
  t['\xB5'] = '\u03BC';
  t['\xB8'] = ' \u0327';
  t['\u0132'] = 'IJ';
  t['\u0133'] = 'ij';
  t['\u013F'] = 'L\xB7';
  t['\u0140'] = 'l\xB7';
  t['\u0149'] = '\u02BCn';
  t['\u017F'] = 's';
  t['\u01C4'] = 'D\u017D';
  t['\u01C5'] = 'D\u017E';
  t['\u01C6'] = 'd\u017E';
  t['\u01C7'] = 'LJ';
  t['\u01C8'] = 'Lj';
  t['\u01C9'] = 'lj';
  t['\u01CA'] = 'NJ';
  t['\u01CB'] = 'Nj';
  t['\u01CC'] = 'nj';
  t['\u01F1'] = 'DZ';
  t['\u01F2'] = 'Dz';
  t['\u01F3'] = 'dz';
  t['\u02D8'] = ' \u0306';
  t['\u02D9'] = ' \u0307';
  t['\u02DA'] = ' \u030A';
  t['\u02DB'] = ' \u0328';
  t['\u02DC'] = ' \u0303';
  t['\u02DD'] = ' \u030B';
  t['\u037A'] = ' \u0345';
  t['\u0384'] = ' \u0301';
  t['\u03D0'] = '\u03B2';
  t['\u03D1'] = '\u03B8';
  t['\u03D2'] = '\u03A5';
  t['\u03D5'] = '\u03C6';
  t['\u03D6'] = '\u03C0';
  t['\u03F0'] = '\u03BA';
  t['\u03F1'] = '\u03C1';
  t['\u03F2'] = '\u03C2';
  t['\u03F4'] = '\u0398';
  t['\u03F5'] = '\u03B5';
  t['\u03F9'] = '\u03A3';
  t['\u0587'] = '\u0565\u0582';
  t['\u0675'] = '\u0627\u0674';
  t['\u0676'] = '\u0648\u0674';
  t['\u0677'] = '\u06C7\u0674';
  t['\u0678'] = '\u064A\u0674';
  t['\u0E33'] = '\u0E4D\u0E32';
  t['\u0EB3'] = '\u0ECD\u0EB2';
  t['\u0EDC'] = '\u0EAB\u0E99';
  t['\u0EDD'] = '\u0EAB\u0EA1';
  t['\u0F77'] = '\u0FB2\u0F81';
  t['\u0F79'] = '\u0FB3\u0F81';
  t['\u1E9A'] = 'a\u02BE';
  t['\u1FBD'] = ' \u0313';
  t['\u1FBF'] = ' \u0313';
  t['\u1FC0'] = ' \u0342';
  t['\u1FFE'] = ' \u0314';
  t['\u2002'] = ' ';
  t['\u2003'] = ' ';
  t['\u2004'] = ' ';
  t['\u2005'] = ' ';
  t['\u2006'] = ' ';
  t['\u2008'] = ' ';
  t['\u2009'] = ' ';
  t['\u200A'] = ' ';
  t['\u2017'] = ' \u0333';
  t['\u2024'] = '.';
  t['\u2025'] = '..';
  t['\u2026'] = '...';
  t['\u2033'] = '\u2032\u2032';
  t['\u2034'] = '\u2032\u2032\u2032';
  t['\u2036'] = '\u2035\u2035';
  t['\u2037'] = '\u2035\u2035\u2035';
  t['\u203C'] = '!!';
  t['\u203E'] = ' \u0305';
  t['\u2047'] = '??';
  t['\u2048'] = '?!';
  t['\u2049'] = '!?';
  t['\u2057'] = '\u2032\u2032\u2032\u2032';
  t['\u205F'] = ' ';
  t['\u20A8'] = 'Rs';
  t['\u2100'] = 'a/c';
  t['\u2101'] = 'a/s';
  t['\u2103'] = '\xB0C';
  t['\u2105'] = 'c/o';
  t['\u2106'] = 'c/u';
  t['\u2107'] = '\u0190';
  t['\u2109'] = '\xB0F';
  t['\u2116'] = 'No';
  t['\u2121'] = 'TEL';
  t['\u2135'] = '\u05D0';
  t['\u2136'] = '\u05D1';
  t['\u2137'] = '\u05D2';
  t['\u2138'] = '\u05D3';
  t['\u213B'] = 'FAX';
  t['\u2160'] = 'I';
  t['\u2161'] = 'II';
  t['\u2162'] = 'III';
  t['\u2163'] = 'IV';
  t['\u2164'] = 'V';
  t['\u2165'] = 'VI';
  t['\u2166'] = 'VII';
  t['\u2167'] = 'VIII';
  t['\u2168'] = 'IX';
  t['\u2169'] = 'X';
  t['\u216A'] = 'XI';
  t['\u216B'] = 'XII';
  t['\u216C'] = 'L';
  t['\u216D'] = 'C';
  t['\u216E'] = 'D';
  t['\u216F'] = 'M';
  t['\u2170'] = 'i';
  t['\u2171'] = 'ii';
  t['\u2172'] = 'iii';
  t['\u2173'] = 'iv';
  t['\u2174'] = 'v';
  t['\u2175'] = 'vi';
  t['\u2176'] = 'vii';
  t['\u2177'] = 'viii';
  t['\u2178'] = 'ix';
  t['\u2179'] = 'x';
  t['\u217A'] = 'xi';
  t['\u217B'] = 'xii';
  t['\u217C'] = 'l';
  t['\u217D'] = 'c';
  t['\u217E'] = 'd';
  t['\u217F'] = 'm';
  t['\u222C'] = '\u222B\u222B';
  t['\u222D'] = '\u222B\u222B\u222B';
  t['\u222F'] = '\u222E\u222E';
  t['\u2230'] = '\u222E\u222E\u222E';
  t['\u2474'] = '(1)';
  t['\u2475'] = '(2)';
  t['\u2476'] = '(3)';
  t['\u2477'] = '(4)';
  t['\u2478'] = '(5)';
  t['\u2479'] = '(6)';
  t['\u247A'] = '(7)';
  t['\u247B'] = '(8)';
  t['\u247C'] = '(9)';
  t['\u247D'] = '(10)';
  t['\u247E'] = '(11)';
  t['\u247F'] = '(12)';
  t['\u2480'] = '(13)';
  t['\u2481'] = '(14)';
  t['\u2482'] = '(15)';
  t['\u2483'] = '(16)';
  t['\u2484'] = '(17)';
  t['\u2485'] = '(18)';
  t['\u2486'] = '(19)';
  t['\u2487'] = '(20)';
  t['\u2488'] = '1.';
  t['\u2489'] = '2.';
  t['\u248A'] = '3.';
  t['\u248B'] = '4.';
  t['\u248C'] = '5.';
  t['\u248D'] = '6.';
  t['\u248E'] = '7.';
  t['\u248F'] = '8.';
  t['\u2490'] = '9.';
  t['\u2491'] = '10.';
  t['\u2492'] = '11.';
  t['\u2493'] = '12.';
  t['\u2494'] = '13.';
  t['\u2495'] = '14.';
  t['\u2496'] = '15.';
  t['\u2497'] = '16.';
  t['\u2498'] = '17.';
  t['\u2499'] = '18.';
  t['\u249A'] = '19.';
  t['\u249B'] = '20.';
  t['\u249C'] = '(a)';
  t['\u249D'] = '(b)';
  t['\u249E'] = '(c)';
  t['\u249F'] = '(d)';
  t['\u24A0'] = '(e)';
  t['\u24A1'] = '(f)';
  t['\u24A2'] = '(g)';
  t['\u24A3'] = '(h)';
  t['\u24A4'] = '(i)';
  t['\u24A5'] = '(j)';
  t['\u24A6'] = '(k)';
  t['\u24A7'] = '(l)';
  t['\u24A8'] = '(m)';
  t['\u24A9'] = '(n)';
  t['\u24AA'] = '(o)';
  t['\u24AB'] = '(p)';
  t['\u24AC'] = '(q)';
  t['\u24AD'] = '(r)';
  t['\u24AE'] = '(s)';
  t['\u24AF'] = '(t)';
  t['\u24B0'] = '(u)';
  t['\u24B1'] = '(v)';
  t['\u24B2'] = '(w)';
  t['\u24B3'] = '(x)';
  t['\u24B4'] = '(y)';
  t['\u24B5'] = '(z)';
  t['\u2A0C'] = '\u222B\u222B\u222B\u222B';
  t['\u2A74'] = '::=';
  t['\u2A75'] = '==';
  t['\u2A76'] = '===';
  t['\u2E9F'] = '\u6BCD';
  t['\u2EF3'] = '\u9F9F';
  t['\u2F00'] = '\u4E00';
  t['\u2F01'] = '\u4E28';
  t['\u2F02'] = '\u4E36';
  t['\u2F03'] = '\u4E3F';
  t['\u2F04'] = '\u4E59';
  t['\u2F05'] = '\u4E85';
  t['\u2F06'] = '\u4E8C';
  t['\u2F07'] = '\u4EA0';
  t['\u2F08'] = '\u4EBA';
  t['\u2F09'] = '\u513F';
  t['\u2F0A'] = '\u5165';
  t['\u2F0B'] = '\u516B';
  t['\u2F0C'] = '\u5182';
  t['\u2F0D'] = '\u5196';
  t['\u2F0E'] = '\u51AB';
  t['\u2F0F'] = '\u51E0';
  t['\u2F10'] = '\u51F5';
  t['\u2F11'] = '\u5200';
  t['\u2F12'] = '\u529B';
  t['\u2F13'] = '\u52F9';
  t['\u2F14'] = '\u5315';
  t['\u2F15'] = '\u531A';
  t['\u2F16'] = '\u5338';
  t['\u2F17'] = '\u5341';
  t['\u2F18'] = '\u535C';
  t['\u2F19'] = '\u5369';
  t['\u2F1A'] = '\u5382';
  t['\u2F1B'] = '\u53B6';
  t['\u2F1C'] = '\u53C8';
  t['\u2F1D'] = '\u53E3';
  t['\u2F1E'] = '\u56D7';
  t['\u2F1F'] = '\u571F';
  t['\u2F20'] = '\u58EB';
  t['\u2F21'] = '\u5902';
  t['\u2F22'] = '\u590A';
  t['\u2F23'] = '\u5915';
  t['\u2F24'] = '\u5927';
  t['\u2F25'] = '\u5973';
  t['\u2F26'] = '\u5B50';
  t['\u2F27'] = '\u5B80';
  t['\u2F28'] = '\u5BF8';
  t['\u2F29'] = '\u5C0F';
  t['\u2F2A'] = '\u5C22';
  t['\u2F2B'] = '\u5C38';
  t['\u2F2C'] = '\u5C6E';
  t['\u2F2D'] = '\u5C71';
  t['\u2F2E'] = '\u5DDB';
  t['\u2F2F'] = '\u5DE5';
  t['\u2F30'] = '\u5DF1';
  t['\u2F31'] = '\u5DFE';
  t['\u2F32'] = '\u5E72';
  t['\u2F33'] = '\u5E7A';
  t['\u2F34'] = '\u5E7F';
  t['\u2F35'] = '\u5EF4';
  t['\u2F36'] = '\u5EFE';
  t['\u2F37'] = '\u5F0B';
  t['\u2F38'] = '\u5F13';
  t['\u2F39'] = '\u5F50';
  t['\u2F3A'] = '\u5F61';
  t['\u2F3B'] = '\u5F73';
  t['\u2F3C'] = '\u5FC3';
  t['\u2F3D'] = '\u6208';
  t['\u2F3E'] = '\u6236';
  t['\u2F3F'] = '\u624B';
  t['\u2F40'] = '\u652F';
  t['\u2F41'] = '\u6534';
  t['\u2F42'] = '\u6587';
  t['\u2F43'] = '\u6597';
  t['\u2F44'] = '\u65A4';
  t['\u2F45'] = '\u65B9';
  t['\u2F46'] = '\u65E0';
  t['\u2F47'] = '\u65E5';
  t['\u2F48'] = '\u66F0';
  t['\u2F49'] = '\u6708';
  t['\u2F4A'] = '\u6728';
  t['\u2F4B'] = '\u6B20';
  t['\u2F4C'] = '\u6B62';
  t['\u2F4D'] = '\u6B79';
  t['\u2F4E'] = '\u6BB3';
  t['\u2F4F'] = '\u6BCB';
  t['\u2F50'] = '\u6BD4';
  t['\u2F51'] = '\u6BDB';
  t['\u2F52'] = '\u6C0F';
  t['\u2F53'] = '\u6C14';
  t['\u2F54'] = '\u6C34';
  t['\u2F55'] = '\u706B';
  t['\u2F56'] = '\u722A';
  t['\u2F57'] = '\u7236';
  t['\u2F58'] = '\u723B';
  t['\u2F59'] = '\u723F';
  t['\u2F5A'] = '\u7247';
  t['\u2F5B'] = '\u7259';
  t['\u2F5C'] = '\u725B';
  t['\u2F5D'] = '\u72AC';
  t['\u2F5E'] = '\u7384';
  t['\u2F5F'] = '\u7389';
  t['\u2F60'] = '\u74DC';
  t['\u2F61'] = '\u74E6';
  t['\u2F62'] = '\u7518';
  t['\u2F63'] = '\u751F';
  t['\u2F64'] = '\u7528';
  t['\u2F65'] = '\u7530';
  t['\u2F66'] = '\u758B';
  t['\u2F67'] = '\u7592';
  t['\u2F68'] = '\u7676';
  t['\u2F69'] = '\u767D';
  t['\u2F6A'] = '\u76AE';
  t['\u2F6B'] = '\u76BF';
  t['\u2F6C'] = '\u76EE';
  t['\u2F6D'] = '\u77DB';
  t['\u2F6E'] = '\u77E2';
  t['\u2F6F'] = '\u77F3';
  t['\u2F70'] = '\u793A';
  t['\u2F71'] = '\u79B8';
  t['\u2F72'] = '\u79BE';
  t['\u2F73'] = '\u7A74';
  t['\u2F74'] = '\u7ACB';
  t['\u2F75'] = '\u7AF9';
  t['\u2F76'] = '\u7C73';
  t['\u2F77'] = '\u7CF8';
  t['\u2F78'] = '\u7F36';
  t['\u2F79'] = '\u7F51';
  t['\u2F7A'] = '\u7F8A';
  t['\u2F7B'] = '\u7FBD';
  t['\u2F7C'] = '\u8001';
  t['\u2F7D'] = '\u800C';
  t['\u2F7E'] = '\u8012';
  t['\u2F7F'] = '\u8033';
  t['\u2F80'] = '\u807F';
  t['\u2F81'] = '\u8089';
  t['\u2F82'] = '\u81E3';
  t['\u2F83'] = '\u81EA';
  t['\u2F84'] = '\u81F3';
  t['\u2F85'] = '\u81FC';
  t['\u2F86'] = '\u820C';
  t['\u2F87'] = '\u821B';
  t['\u2F88'] = '\u821F';
  t['\u2F89'] = '\u826E';
  t['\u2F8A'] = '\u8272';
  t['\u2F8B'] = '\u8278';
  t['\u2F8C'] = '\u864D';
  t['\u2F8D'] = '\u866B';
  t['\u2F8E'] = '\u8840';
  t['\u2F8F'] = '\u884C';
  t['\u2F90'] = '\u8863';
  t['\u2F91'] = '\u897E';
  t['\u2F92'] = '\u898B';
  t['\u2F93'] = '\u89D2';
  t['\u2F94'] = '\u8A00';
  t['\u2F95'] = '\u8C37';
  t['\u2F96'] = '\u8C46';
  t['\u2F97'] = '\u8C55';
  t['\u2F98'] = '\u8C78';
  t['\u2F99'] = '\u8C9D';
  t['\u2F9A'] = '\u8D64';
  t['\u2F9B'] = '\u8D70';
  t['\u2F9C'] = '\u8DB3';
  t['\u2F9D'] = '\u8EAB';
  t['\u2F9E'] = '\u8ECA';
  t['\u2F9F'] = '\u8F9B';
  t['\u2FA0'] = '\u8FB0';
  t['\u2FA1'] = '\u8FB5';
  t['\u2FA2'] = '\u9091';
  t['\u2FA3'] = '\u9149';
  t['\u2FA4'] = '\u91C6';
  t['\u2FA5'] = '\u91CC';
  t['\u2FA6'] = '\u91D1';
  t['\u2FA7'] = '\u9577';
  t['\u2FA8'] = '\u9580';
  t['\u2FA9'] = '\u961C';
  t['\u2FAA'] = '\u96B6';
  t['\u2FAB'] = '\u96B9';
  t['\u2FAC'] = '\u96E8';
  t['\u2FAD'] = '\u9751';
  t['\u2FAE'] = '\u975E';
  t['\u2FAF'] = '\u9762';
  t['\u2FB0'] = '\u9769';
  t['\u2FB1'] = '\u97CB';
  t['\u2FB2'] = '\u97ED';
  t['\u2FB3'] = '\u97F3';
  t['\u2FB4'] = '\u9801';
  t['\u2FB5'] = '\u98A8';
  t['\u2FB6'] = '\u98DB';
  t['\u2FB7'] = '\u98DF';
  t['\u2FB8'] = '\u9996';
  t['\u2FB9'] = '\u9999';
  t['\u2FBA'] = '\u99AC';
  t['\u2FBB'] = '\u9AA8';
  t['\u2FBC'] = '\u9AD8';
  t['\u2FBD'] = '\u9ADF';
  t['\u2FBE'] = '\u9B25';
  t['\u2FBF'] = '\u9B2F';
  t['\u2FC0'] = '\u9B32';
  t['\u2FC1'] = '\u9B3C';
  t['\u2FC2'] = '\u9B5A';
  t['\u2FC3'] = '\u9CE5';
  t['\u2FC4'] = '\u9E75';
  t['\u2FC5'] = '\u9E7F';
  t['\u2FC6'] = '\u9EA5';
  t['\u2FC7'] = '\u9EBB';
  t['\u2FC8'] = '\u9EC3';
  t['\u2FC9'] = '\u9ECD';
  t['\u2FCA'] = '\u9ED1';
  t['\u2FCB'] = '\u9EF9';
  t['\u2FCC'] = '\u9EFD';
  t['\u2FCD'] = '\u9F0E';
  t['\u2FCE'] = '\u9F13';
  t['\u2FCF'] = '\u9F20';
  t['\u2FD0'] = '\u9F3B';
  t['\u2FD1'] = '\u9F4A';
  t['\u2FD2'] = '\u9F52';
  t['\u2FD3'] = '\u9F8D';
  t['\u2FD4'] = '\u9F9C';
  t['\u2FD5'] = '\u9FA0';
  t['\u3036'] = '\u3012';
  t['\u3038'] = '\u5341';
  t['\u3039'] = '\u5344';
  t['\u303A'] = '\u5345';
  t['\u309B'] = ' \u3099';
  t['\u309C'] = ' \u309A';
  t['\u3131'] = '\u1100';
  t['\u3132'] = '\u1101';
  t['\u3133'] = '\u11AA';
  t['\u3134'] = '\u1102';
  t['\u3135'] = '\u11AC';
  t['\u3136'] = '\u11AD';
  t['\u3137'] = '\u1103';
  t['\u3138'] = '\u1104';
  t['\u3139'] = '\u1105';
  t['\u313A'] = '\u11B0';
  t['\u313B'] = '\u11B1';
  t['\u313C'] = '\u11B2';
  t['\u313D'] = '\u11B3';
  t['\u313E'] = '\u11B4';
  t['\u313F'] = '\u11B5';
  t['\u3140'] = '\u111A';
  t['\u3141'] = '\u1106';
  t['\u3142'] = '\u1107';
  t['\u3143'] = '\u1108';
  t['\u3144'] = '\u1121';
  t['\u3145'] = '\u1109';
  t['\u3146'] = '\u110A';
  t['\u3147'] = '\u110B';
  t['\u3148'] = '\u110C';
  t['\u3149'] = '\u110D';
  t['\u314A'] = '\u110E';
  t['\u314B'] = '\u110F';
  t['\u314C'] = '\u1110';
  t['\u314D'] = '\u1111';
  t['\u314E'] = '\u1112';
  t['\u314F'] = '\u1161';
  t['\u3150'] = '\u1162';
  t['\u3151'] = '\u1163';
  t['\u3152'] = '\u1164';
  t['\u3153'] = '\u1165';
  t['\u3154'] = '\u1166';
  t['\u3155'] = '\u1167';
  t['\u3156'] = '\u1168';
  t['\u3157'] = '\u1169';
  t['\u3158'] = '\u116A';
  t['\u3159'] = '\u116B';
  t['\u315A'] = '\u116C';
  t['\u315B'] = '\u116D';
  t['\u315C'] = '\u116E';
  t['\u315D'] = '\u116F';
  t['\u315E'] = '\u1170';
  t['\u315F'] = '\u1171';
  t['\u3160'] = '\u1172';
  t['\u3161'] = '\u1173';
  t['\u3162'] = '\u1174';
  t['\u3163'] = '\u1175';
  t['\u3164'] = '\u1160';
  t['\u3165'] = '\u1114';
  t['\u3166'] = '\u1115';
  t['\u3167'] = '\u11C7';
  t['\u3168'] = '\u11C8';
  t['\u3169'] = '\u11CC';
  t['\u316A'] = '\u11CE';
  t['\u316B'] = '\u11D3';
  t['\u316C'] = '\u11D7';
  t['\u316D'] = '\u11D9';
  t['\u316E'] = '\u111C';
  t['\u316F'] = '\u11DD';
  t['\u3170'] = '\u11DF';
  t['\u3171'] = '\u111D';
  t['\u3172'] = '\u111E';
  t['\u3173'] = '\u1120';
  t['\u3174'] = '\u1122';
  t['\u3175'] = '\u1123';
  t['\u3176'] = '\u1127';
  t['\u3177'] = '\u1129';
  t['\u3178'] = '\u112B';
  t['\u3179'] = '\u112C';
  t['\u317A'] = '\u112D';
  t['\u317B'] = '\u112E';
  t['\u317C'] = '\u112F';
  t['\u317D'] = '\u1132';
  t['\u317E'] = '\u1136';
  t['\u317F'] = '\u1140';
  t['\u3180'] = '\u1147';
  t['\u3181'] = '\u114C';
  t['\u3182'] = '\u11F1';
  t['\u3183'] = '\u11F2';
  t['\u3184'] = '\u1157';
  t['\u3185'] = '\u1158';
  t['\u3186'] = '\u1159';
  t['\u3187'] = '\u1184';
  t['\u3188'] = '\u1185';
  t['\u3189'] = '\u1188';
  t['\u318A'] = '\u1191';
  t['\u318B'] = '\u1192';
  t['\u318C'] = '\u1194';
  t['\u318D'] = '\u119E';
  t['\u318E'] = '\u11A1';
  t['\u3200'] = '(\u1100)';
  t['\u3201'] = '(\u1102)';
  t['\u3202'] = '(\u1103)';
  t['\u3203'] = '(\u1105)';
  t['\u3204'] = '(\u1106)';
  t['\u3205'] = '(\u1107)';
  t['\u3206'] = '(\u1109)';
  t['\u3207'] = '(\u110B)';
  t['\u3208'] = '(\u110C)';
  t['\u3209'] = '(\u110E)';
  t['\u320A'] = '(\u110F)';
  t['\u320B'] = '(\u1110)';
  t['\u320C'] = '(\u1111)';
  t['\u320D'] = '(\u1112)';
  t['\u320E'] = '(\u1100\u1161)';
  t['\u320F'] = '(\u1102\u1161)';
  t['\u3210'] = '(\u1103\u1161)';
  t['\u3211'] = '(\u1105\u1161)';
  t['\u3212'] = '(\u1106\u1161)';
  t['\u3213'] = '(\u1107\u1161)';
  t['\u3214'] = '(\u1109\u1161)';
  t['\u3215'] = '(\u110B\u1161)';
  t['\u3216'] = '(\u110C\u1161)';
  t['\u3217'] = '(\u110E\u1161)';
  t['\u3218'] = '(\u110F\u1161)';
  t['\u3219'] = '(\u1110\u1161)';
  t['\u321A'] = '(\u1111\u1161)';
  t['\u321B'] = '(\u1112\u1161)';
  t['\u321C'] = '(\u110C\u116E)';
  t['\u321D'] = '(\u110B\u1169\u110C\u1165\u11AB)';
  t['\u321E'] = '(\u110B\u1169\u1112\u116E)';
  t['\u3220'] = '(\u4E00)';
  t['\u3221'] = '(\u4E8C)';
  t['\u3222'] = '(\u4E09)';
  t['\u3223'] = '(\u56DB)';
  t['\u3224'] = '(\u4E94)';
  t['\u3225'] = '(\u516D)';
  t['\u3226'] = '(\u4E03)';
  t['\u3227'] = '(\u516B)';
  t['\u3228'] = '(\u4E5D)';
  t['\u3229'] = '(\u5341)';
  t['\u322A'] = '(\u6708)';
  t['\u322B'] = '(\u706B)';
  t['\u322C'] = '(\u6C34)';
  t['\u322D'] = '(\u6728)';
  t['\u322E'] = '(\u91D1)';
  t['\u322F'] = '(\u571F)';
  t['\u3230'] = '(\u65E5)';
  t['\u3231'] = '(\u682A)';
  t['\u3232'] = '(\u6709)';
  t['\u3233'] = '(\u793E)';
  t['\u3234'] = '(\u540D)';
  t['\u3235'] = '(\u7279)';
  t['\u3236'] = '(\u8CA1)';
  t['\u3237'] = '(\u795D)';
  t['\u3238'] = '(\u52B4)';
  t['\u3239'] = '(\u4EE3)';
  t['\u323A'] = '(\u547C)';
  t['\u323B'] = '(\u5B66)';
  t['\u323C'] = '(\u76E3)';
  t['\u323D'] = '(\u4F01)';
  t['\u323E'] = '(\u8CC7)';
  t['\u323F'] = '(\u5354)';
  t['\u3240'] = '(\u796D)';
  t['\u3241'] = '(\u4F11)';
  t['\u3242'] = '(\u81EA)';
  t['\u3243'] = '(\u81F3)';
  t['\u32C0'] = '1\u6708';
  t['\u32C1'] = '2\u6708';
  t['\u32C2'] = '3\u6708';
  t['\u32C3'] = '4\u6708';
  t['\u32C4'] = '5\u6708';
  t['\u32C5'] = '6\u6708';
  t['\u32C6'] = '7\u6708';
  t['\u32C7'] = '8\u6708';
  t['\u32C8'] = '9\u6708';
  t['\u32C9'] = '10\u6708';
  t['\u32CA'] = '11\u6708';
  t['\u32CB'] = '12\u6708';
  t['\u3358'] = '0\u70B9';
  t['\u3359'] = '1\u70B9';
  t['\u335A'] = '2\u70B9';
  t['\u335B'] = '3\u70B9';
  t['\u335C'] = '4\u70B9';
  t['\u335D'] = '5\u70B9';
  t['\u335E'] = '6\u70B9';
  t['\u335F'] = '7\u70B9';
  t['\u3360'] = '8\u70B9';
  t['\u3361'] = '9\u70B9';
  t['\u3362'] = '10\u70B9';
  t['\u3363'] = '11\u70B9';
  t['\u3364'] = '12\u70B9';
  t['\u3365'] = '13\u70B9';
  t['\u3366'] = '14\u70B9';
  t['\u3367'] = '15\u70B9';
  t['\u3368'] = '16\u70B9';
  t['\u3369'] = '17\u70B9';
  t['\u336A'] = '18\u70B9';
  t['\u336B'] = '19\u70B9';
  t['\u336C'] = '20\u70B9';
  t['\u336D'] = '21\u70B9';
  t['\u336E'] = '22\u70B9';
  t['\u336F'] = '23\u70B9';
  t['\u3370'] = '24\u70B9';
  t['\u33E0'] = '1\u65E5';
  t['\u33E1'] = '2\u65E5';
  t['\u33E2'] = '3\u65E5';
  t['\u33E3'] = '4\u65E5';
  t['\u33E4'] = '5\u65E5';
  t['\u33E5'] = '6\u65E5';
  t['\u33E6'] = '7\u65E5';
  t['\u33E7'] = '8\u65E5';
  t['\u33E8'] = '9\u65E5';
  t['\u33E9'] = '10\u65E5';
  t['\u33EA'] = '11\u65E5';
  t['\u33EB'] = '12\u65E5';
  t['\u33EC'] = '13\u65E5';
  t['\u33ED'] = '14\u65E5';
  t['\u33EE'] = '15\u65E5';
  t['\u33EF'] = '16\u65E5';
  t['\u33F0'] = '17\u65E5';
  t['\u33F1'] = '18\u65E5';
  t['\u33F2'] = '19\u65E5';
  t['\u33F3'] = '20\u65E5';
  t['\u33F4'] = '21\u65E5';
  t['\u33F5'] = '22\u65E5';
  t['\u33F6'] = '23\u65E5';
  t['\u33F7'] = '24\u65E5';
  t['\u33F8'] = '25\u65E5';
  t['\u33F9'] = '26\u65E5';
  t['\u33FA'] = '27\u65E5';
  t['\u33FB'] = '28\u65E5';
  t['\u33FC'] = '29\u65E5';
  t['\u33FD'] = '30\u65E5';
  t['\u33FE'] = '31\u65E5';
  t['\uFB00'] = 'ff';
  t['\uFB01'] = 'fi';
  t['\uFB02'] = 'fl';
  t['\uFB03'] = 'ffi';
  t['\uFB04'] = 'ffl';
  t['\uFB05'] = '\u017Ft';
  t['\uFB06'] = 'st';
  t['\uFB13'] = '\u0574\u0576';
  t['\uFB14'] = '\u0574\u0565';
  t['\uFB15'] = '\u0574\u056B';
  t['\uFB16'] = '\u057E\u0576';
  t['\uFB17'] = '\u0574\u056D';
  t['\uFB4F'] = '\u05D0\u05DC';
  t['\uFB50'] = '\u0671';
  t['\uFB51'] = '\u0671';
  t['\uFB52'] = '\u067B';
  t['\uFB53'] = '\u067B';
  t['\uFB54'] = '\u067B';
  t['\uFB55'] = '\u067B';
  t['\uFB56'] = '\u067E';
  t['\uFB57'] = '\u067E';
  t['\uFB58'] = '\u067E';
  t['\uFB59'] = '\u067E';
  t['\uFB5A'] = '\u0680';
  t['\uFB5B'] = '\u0680';
  t['\uFB5C'] = '\u0680';
  t['\uFB5D'] = '\u0680';
  t['\uFB5E'] = '\u067A';
  t['\uFB5F'] = '\u067A';
  t['\uFB60'] = '\u067A';
  t['\uFB61'] = '\u067A';
  t['\uFB62'] = '\u067F';
  t['\uFB63'] = '\u067F';
  t['\uFB64'] = '\u067F';
  t['\uFB65'] = '\u067F';
  t['\uFB66'] = '\u0679';
  t['\uFB67'] = '\u0679';
  t['\uFB68'] = '\u0679';
  t['\uFB69'] = '\u0679';
  t['\uFB6A'] = '\u06A4';
  t['\uFB6B'] = '\u06A4';
  t['\uFB6C'] = '\u06A4';
  t['\uFB6D'] = '\u06A4';
  t['\uFB6E'] = '\u06A6';
  t['\uFB6F'] = '\u06A6';
  t['\uFB70'] = '\u06A6';
  t['\uFB71'] = '\u06A6';
  t['\uFB72'] = '\u0684';
  t['\uFB73'] = '\u0684';
  t['\uFB74'] = '\u0684';
  t['\uFB75'] = '\u0684';
  t['\uFB76'] = '\u0683';
  t['\uFB77'] = '\u0683';
  t['\uFB78'] = '\u0683';
  t['\uFB79'] = '\u0683';
  t['\uFB7A'] = '\u0686';
  t['\uFB7B'] = '\u0686';
  t['\uFB7C'] = '\u0686';
  t['\uFB7D'] = '\u0686';
  t['\uFB7E'] = '\u0687';
  t['\uFB7F'] = '\u0687';
  t['\uFB80'] = '\u0687';
  t['\uFB81'] = '\u0687';
  t['\uFB82'] = '\u068D';
  t['\uFB83'] = '\u068D';
  t['\uFB84'] = '\u068C';
  t['\uFB85'] = '\u068C';
  t['\uFB86'] = '\u068E';
  t['\uFB87'] = '\u068E';
  t['\uFB88'] = '\u0688';
  t['\uFB89'] = '\u0688';
  t['\uFB8A'] = '\u0698';
  t['\uFB8B'] = '\u0698';
  t['\uFB8C'] = '\u0691';
  t['\uFB8D'] = '\u0691';
  t['\uFB8E'] = '\u06A9';
  t['\uFB8F'] = '\u06A9';
  t['\uFB90'] = '\u06A9';
  t['\uFB91'] = '\u06A9';
  t['\uFB92'] = '\u06AF';
  t['\uFB93'] = '\u06AF';
  t['\uFB94'] = '\u06AF';
  t['\uFB95'] = '\u06AF';
  t['\uFB96'] = '\u06B3';
  t['\uFB97'] = '\u06B3';
  t['\uFB98'] = '\u06B3';
  t['\uFB99'] = '\u06B3';
  t['\uFB9A'] = '\u06B1';
  t['\uFB9B'] = '\u06B1';
  t['\uFB9C'] = '\u06B1';
  t['\uFB9D'] = '\u06B1';
  t['\uFB9E'] = '\u06BA';
  t['\uFB9F'] = '\u06BA';
  t['\uFBA0'] = '\u06BB';
  t['\uFBA1'] = '\u06BB';
  t['\uFBA2'] = '\u06BB';
  t['\uFBA3'] = '\u06BB';
  t['\uFBA4'] = '\u06C0';
  t['\uFBA5'] = '\u06C0';
  t['\uFBA6'] = '\u06C1';
  t['\uFBA7'] = '\u06C1';
  t['\uFBA8'] = '\u06C1';
  t['\uFBA9'] = '\u06C1';
  t['\uFBAA'] = '\u06BE';
  t['\uFBAB'] = '\u06BE';
  t['\uFBAC'] = '\u06BE';
  t['\uFBAD'] = '\u06BE';
  t['\uFBAE'] = '\u06D2';
  t['\uFBAF'] = '\u06D2';
  t['\uFBB0'] = '\u06D3';
  t['\uFBB1'] = '\u06D3';
  t['\uFBD3'] = '\u06AD';
  t['\uFBD4'] = '\u06AD';
  t['\uFBD5'] = '\u06AD';
  t['\uFBD6'] = '\u06AD';
  t['\uFBD7'] = '\u06C7';
  t['\uFBD8'] = '\u06C7';
  t['\uFBD9'] = '\u06C6';
  t['\uFBDA'] = '\u06C6';
  t['\uFBDB'] = '\u06C8';
  t['\uFBDC'] = '\u06C8';
  t['\uFBDD'] = '\u0677';
  t['\uFBDE'] = '\u06CB';
  t['\uFBDF'] = '\u06CB';
  t['\uFBE0'] = '\u06C5';
  t['\uFBE1'] = '\u06C5';
  t['\uFBE2'] = '\u06C9';
  t['\uFBE3'] = '\u06C9';
  t['\uFBE4'] = '\u06D0';
  t['\uFBE5'] = '\u06D0';
  t['\uFBE6'] = '\u06D0';
  t['\uFBE7'] = '\u06D0';
  t['\uFBE8'] = '\u0649';
  t['\uFBE9'] = '\u0649';
  t['\uFBEA'] = '\u0626\u0627';
  t['\uFBEB'] = '\u0626\u0627';
  t['\uFBEC'] = '\u0626\u06D5';
  t['\uFBED'] = '\u0626\u06D5';
  t['\uFBEE'] = '\u0626\u0648';
  t['\uFBEF'] = '\u0626\u0648';
  t['\uFBF0'] = '\u0626\u06C7';
  t['\uFBF1'] = '\u0626\u06C7';
  t['\uFBF2'] = '\u0626\u06C6';
  t['\uFBF3'] = '\u0626\u06C6';
  t['\uFBF4'] = '\u0626\u06C8';
  t['\uFBF5'] = '\u0626\u06C8';
  t['\uFBF6'] = '\u0626\u06D0';
  t['\uFBF7'] = '\u0626\u06D0';
  t['\uFBF8'] = '\u0626\u06D0';
  t['\uFBF9'] = '\u0626\u0649';
  t['\uFBFA'] = '\u0626\u0649';
  t['\uFBFB'] = '\u0626\u0649';
  t['\uFBFC'] = '\u06CC';
  t['\uFBFD'] = '\u06CC';
  t['\uFBFE'] = '\u06CC';
  t['\uFBFF'] = '\u06CC';
  t['\uFC00'] = '\u0626\u062C';
  t['\uFC01'] = '\u0626\u062D';
  t['\uFC02'] = '\u0626\u0645';
  t['\uFC03'] = '\u0626\u0649';
  t['\uFC04'] = '\u0626\u064A';
  t['\uFC05'] = '\u0628\u062C';
  t['\uFC06'] = '\u0628\u062D';
  t['\uFC07'] = '\u0628\u062E';
  t['\uFC08'] = '\u0628\u0645';
  t['\uFC09'] = '\u0628\u0649';
  t['\uFC0A'] = '\u0628\u064A';
  t['\uFC0B'] = '\u062A\u062C';
  t['\uFC0C'] = '\u062A\u062D';
  t['\uFC0D'] = '\u062A\u062E';
  t['\uFC0E'] = '\u062A\u0645';
  t['\uFC0F'] = '\u062A\u0649';
  t['\uFC10'] = '\u062A\u064A';
  t['\uFC11'] = '\u062B\u062C';
  t['\uFC12'] = '\u062B\u0645';
  t['\uFC13'] = '\u062B\u0649';
  t['\uFC14'] = '\u062B\u064A';
  t['\uFC15'] = '\u062C\u062D';
  t['\uFC16'] = '\u062C\u0645';
  t['\uFC17'] = '\u062D\u062C';
  t['\uFC18'] = '\u062D\u0645';
  t['\uFC19'] = '\u062E\u062C';
  t['\uFC1A'] = '\u062E\u062D';
  t['\uFC1B'] = '\u062E\u0645';
  t['\uFC1C'] = '\u0633\u062C';
  t['\uFC1D'] = '\u0633\u062D';
  t['\uFC1E'] = '\u0633\u062E';
  t['\uFC1F'] = '\u0633\u0645';
  t['\uFC20'] = '\u0635\u062D';
  t['\uFC21'] = '\u0635\u0645';
  t['\uFC22'] = '\u0636\u062C';
  t['\uFC23'] = '\u0636\u062D';
  t['\uFC24'] = '\u0636\u062E';
  t['\uFC25'] = '\u0636\u0645';
  t['\uFC26'] = '\u0637\u062D';
  t['\uFC27'] = '\u0637\u0645';
  t['\uFC28'] = '\u0638\u0645';
  t['\uFC29'] = '\u0639\u062C';
  t['\uFC2A'] = '\u0639\u0645';
  t['\uFC2B'] = '\u063A\u062C';
  t['\uFC2C'] = '\u063A\u0645';
  t['\uFC2D'] = '\u0641\u062C';
  t['\uFC2E'] = '\u0641\u062D';
  t['\uFC2F'] = '\u0641\u062E';
  t['\uFC30'] = '\u0641\u0645';
  t['\uFC31'] = '\u0641\u0649';
  t['\uFC32'] = '\u0641\u064A';
  t['\uFC33'] = '\u0642\u062D';
  t['\uFC34'] = '\u0642\u0645';
  t['\uFC35'] = '\u0642\u0649';
  t['\uFC36'] = '\u0642\u064A';
  t['\uFC37'] = '\u0643\u0627';
  t['\uFC38'] = '\u0643\u062C';
  t['\uFC39'] = '\u0643\u062D';
  t['\uFC3A'] = '\u0643\u062E';
  t['\uFC3B'] = '\u0643\u0644';
  t['\uFC3C'] = '\u0643\u0645';
  t['\uFC3D'] = '\u0643\u0649';
  t['\uFC3E'] = '\u0643\u064A';
  t['\uFC3F'] = '\u0644\u062C';
  t['\uFC40'] = '\u0644\u062D';
  t['\uFC41'] = '\u0644\u062E';
  t['\uFC42'] = '\u0644\u0645';
  t['\uFC43'] = '\u0644\u0649';
  t['\uFC44'] = '\u0644\u064A';
  t['\uFC45'] = '\u0645\u062C';
  t['\uFC46'] = '\u0645\u062D';
  t['\uFC47'] = '\u0645\u062E';
  t['\uFC48'] = '\u0645\u0645';
  t['\uFC49'] = '\u0645\u0649';
  t['\uFC4A'] = '\u0645\u064A';
  t['\uFC4B'] = '\u0646\u062C';
  t['\uFC4C'] = '\u0646\u062D';
  t['\uFC4D'] = '\u0646\u062E';
  t['\uFC4E'] = '\u0646\u0645';
  t['\uFC4F'] = '\u0646\u0649';
  t['\uFC50'] = '\u0646\u064A';
  t['\uFC51'] = '\u0647\u062C';
  t['\uFC52'] = '\u0647\u0645';
  t['\uFC53'] = '\u0647\u0649';
  t['\uFC54'] = '\u0647\u064A';
  t['\uFC55'] = '\u064A\u062C';
  t['\uFC56'] = '\u064A\u062D';
  t['\uFC57'] = '\u064A\u062E';
  t['\uFC58'] = '\u064A\u0645';
  t['\uFC59'] = '\u064A\u0649';
  t['\uFC5A'] = '\u064A\u064A';
  t['\uFC5B'] = '\u0630\u0670';
  t['\uFC5C'] = '\u0631\u0670';
  t['\uFC5D'] = '\u0649\u0670';
  t['\uFC5E'] = ' \u064C\u0651';
  t['\uFC5F'] = ' \u064D\u0651';
  t['\uFC60'] = ' \u064E\u0651';
  t['\uFC61'] = ' \u064F\u0651';
  t['\uFC62'] = ' \u0650\u0651';
  t['\uFC63'] = ' \u0651\u0670';
  t['\uFC64'] = '\u0626\u0631';
  t['\uFC65'] = '\u0626\u0632';
  t['\uFC66'] = '\u0626\u0645';
  t['\uFC67'] = '\u0626\u0646';
  t['\uFC68'] = '\u0626\u0649';
  t['\uFC69'] = '\u0626\u064A';
  t['\uFC6A'] = '\u0628\u0631';
  t['\uFC6B'] = '\u0628\u0632';
  t['\uFC6C'] = '\u0628\u0645';
  t['\uFC6D'] = '\u0628\u0646';
  t['\uFC6E'] = '\u0628\u0649';
  t['\uFC6F'] = '\u0628\u064A';
  t['\uFC70'] = '\u062A\u0631';
  t['\uFC71'] = '\u062A\u0632';
  t['\uFC72'] = '\u062A\u0645';
  t['\uFC73'] = '\u062A\u0646';
  t['\uFC74'] = '\u062A\u0649';
  t['\uFC75'] = '\u062A\u064A';
  t['\uFC76'] = '\u062B\u0631';
  t['\uFC77'] = '\u062B\u0632';
  t['\uFC78'] = '\u062B\u0645';
  t['\uFC79'] = '\u062B\u0646';
  t['\uFC7A'] = '\u062B\u0649';
  t['\uFC7B'] = '\u062B\u064A';
  t['\uFC7C'] = '\u0641\u0649';
  t['\uFC7D'] = '\u0641\u064A';
  t['\uFC7E'] = '\u0642\u0649';
  t['\uFC7F'] = '\u0642\u064A';
  t['\uFC80'] = '\u0643\u0627';
  t['\uFC81'] = '\u0643\u0644';
  t['\uFC82'] = '\u0643\u0645';
  t['\uFC83'] = '\u0643\u0649';
  t['\uFC84'] = '\u0643\u064A';
  t['\uFC85'] = '\u0644\u0645';
  t['\uFC86'] = '\u0644\u0649';
  t['\uFC87'] = '\u0644\u064A';
  t['\uFC88'] = '\u0645\u0627';
  t['\uFC89'] = '\u0645\u0645';
  t['\uFC8A'] = '\u0646\u0631';
  t['\uFC8B'] = '\u0646\u0632';
  t['\uFC8C'] = '\u0646\u0645';
  t['\uFC8D'] = '\u0646\u0646';
  t['\uFC8E'] = '\u0646\u0649';
  t['\uFC8F'] = '\u0646\u064A';
  t['\uFC90'] = '\u0649\u0670';
  t['\uFC91'] = '\u064A\u0631';
  t['\uFC92'] = '\u064A\u0632';
  t['\uFC93'] = '\u064A\u0645';
  t['\uFC94'] = '\u064A\u0646';
  t['\uFC95'] = '\u064A\u0649';
  t['\uFC96'] = '\u064A\u064A';
  t['\uFC97'] = '\u0626\u062C';
  t['\uFC98'] = '\u0626\u062D';
  t['\uFC99'] = '\u0626\u062E';
  t['\uFC9A'] = '\u0626\u0645';
  t['\uFC9B'] = '\u0626\u0647';
  t['\uFC9C'] = '\u0628\u062C';
  t['\uFC9D'] = '\u0628\u062D';
  t['\uFC9E'] = '\u0628\u062E';
  t['\uFC9F'] = '\u0628\u0645';
  t['\uFCA0'] = '\u0628\u0647';
  t['\uFCA1'] = '\u062A\u062C';
  t['\uFCA2'] = '\u062A\u062D';
  t['\uFCA3'] = '\u062A\u062E';
  t['\uFCA4'] = '\u062A\u0645';
  t['\uFCA5'] = '\u062A\u0647';
  t['\uFCA6'] = '\u062B\u0645';
  t['\uFCA7'] = '\u062C\u062D';
  t['\uFCA8'] = '\u062C\u0645';
  t['\uFCA9'] = '\u062D\u062C';
  t['\uFCAA'] = '\u062D\u0645';
  t['\uFCAB'] = '\u062E\u062C';
  t['\uFCAC'] = '\u062E\u0645';
  t['\uFCAD'] = '\u0633\u062C';
  t['\uFCAE'] = '\u0633\u062D';
  t['\uFCAF'] = '\u0633\u062E';
  t['\uFCB0'] = '\u0633\u0645';
  t['\uFCB1'] = '\u0635\u062D';
  t['\uFCB2'] = '\u0635\u062E';
  t['\uFCB3'] = '\u0635\u0645';
  t['\uFCB4'] = '\u0636\u062C';
  t['\uFCB5'] = '\u0636\u062D';
  t['\uFCB6'] = '\u0636\u062E';
  t['\uFCB7'] = '\u0636\u0645';
  t['\uFCB8'] = '\u0637\u062D';
  t['\uFCB9'] = '\u0638\u0645';
  t['\uFCBA'] = '\u0639\u062C';
  t['\uFCBB'] = '\u0639\u0645';
  t['\uFCBC'] = '\u063A\u062C';
  t['\uFCBD'] = '\u063A\u0645';
  t['\uFCBE'] = '\u0641\u062C';
  t['\uFCBF'] = '\u0641\u062D';
  t['\uFCC0'] = '\u0641\u062E';
  t['\uFCC1'] = '\u0641\u0645';
  t['\uFCC2'] = '\u0642\u062D';
  t['\uFCC3'] = '\u0642\u0645';
  t['\uFCC4'] = '\u0643\u062C';
  t['\uFCC5'] = '\u0643\u062D';
  t['\uFCC6'] = '\u0643\u062E';
  t['\uFCC7'] = '\u0643\u0644';
  t['\uFCC8'] = '\u0643\u0645';
  t['\uFCC9'] = '\u0644\u062C';
  t['\uFCCA'] = '\u0644\u062D';
  t['\uFCCB'] = '\u0644\u062E';
  t['\uFCCC'] = '\u0644\u0645';
  t['\uFCCD'] = '\u0644\u0647';
  t['\uFCCE'] = '\u0645\u062C';
  t['\uFCCF'] = '\u0645\u062D';
  t['\uFCD0'] = '\u0645\u062E';
  t['\uFCD1'] = '\u0645\u0645';
  t['\uFCD2'] = '\u0646\u062C';
  t['\uFCD3'] = '\u0646\u062D';
  t['\uFCD4'] = '\u0646\u062E';
  t['\uFCD5'] = '\u0646\u0645';
  t['\uFCD6'] = '\u0646\u0647';
  t['\uFCD7'] = '\u0647\u062C';
  t['\uFCD8'] = '\u0647\u0645';
  t['\uFCD9'] = '\u0647\u0670';
  t['\uFCDA'] = '\u064A\u062C';
  t['\uFCDB'] = '\u064A\u062D';
  t['\uFCDC'] = '\u064A\u062E';
  t['\uFCDD'] = '\u064A\u0645';
  t['\uFCDE'] = '\u064A\u0647';
  t['\uFCDF'] = '\u0626\u0645';
  t['\uFCE0'] = '\u0626\u0647';
  t['\uFCE1'] = '\u0628\u0645';
  t['\uFCE2'] = '\u0628\u0647';
  t['\uFCE3'] = '\u062A\u0645';
  t['\uFCE4'] = '\u062A\u0647';
  t['\uFCE5'] = '\u062B\u0645';
  t['\uFCE6'] = '\u062B\u0647';
  t['\uFCE7'] = '\u0633\u0645';
  t['\uFCE8'] = '\u0633\u0647';
  t['\uFCE9'] = '\u0634\u0645';
  t['\uFCEA'] = '\u0634\u0647';
  t['\uFCEB'] = '\u0643\u0644';
  t['\uFCEC'] = '\u0643\u0645';
  t['\uFCED'] = '\u0644\u0645';
  t['\uFCEE'] = '\u0646\u0645';
  t['\uFCEF'] = '\u0646\u0647';
  t['\uFCF0'] = '\u064A\u0645';
  t['\uFCF1'] = '\u064A\u0647';
  t['\uFCF2'] = '\u0640\u064E\u0651';
  t['\uFCF3'] = '\u0640\u064F\u0651';
  t['\uFCF4'] = '\u0640\u0650\u0651';
  t['\uFCF5'] = '\u0637\u0649';
  t['\uFCF6'] = '\u0637\u064A';
  t['\uFCF7'] = '\u0639\u0649';
  t['\uFCF8'] = '\u0639\u064A';
  t['\uFCF9'] = '\u063A\u0649';
  t['\uFCFA'] = '\u063A\u064A';
  t['\uFCFB'] = '\u0633\u0649';
  t['\uFCFC'] = '\u0633\u064A';
  t['\uFCFD'] = '\u0634\u0649';
  t['\uFCFE'] = '\u0634\u064A';
  t['\uFCFF'] = '\u062D\u0649';
  t['\uFD00'] = '\u062D\u064A';
  t['\uFD01'] = '\u062C\u0649';
  t['\uFD02'] = '\u062C\u064A';
  t['\uFD03'] = '\u062E\u0649';
  t['\uFD04'] = '\u062E\u064A';
  t['\uFD05'] = '\u0635\u0649';
  t['\uFD06'] = '\u0635\u064A';
  t['\uFD07'] = '\u0636\u0649';
  t['\uFD08'] = '\u0636\u064A';
  t['\uFD09'] = '\u0634\u062C';
  t['\uFD0A'] = '\u0634\u062D';
  t['\uFD0B'] = '\u0634\u062E';
  t['\uFD0C'] = '\u0634\u0645';
  t['\uFD0D'] = '\u0634\u0631';
  t['\uFD0E'] = '\u0633\u0631';
  t['\uFD0F'] = '\u0635\u0631';
  t['\uFD10'] = '\u0636\u0631';
  t['\uFD11'] = '\u0637\u0649';
  t['\uFD12'] = '\u0637\u064A';
  t['\uFD13'] = '\u0639\u0649';
  t['\uFD14'] = '\u0639\u064A';
  t['\uFD15'] = '\u063A\u0649';
  t['\uFD16'] = '\u063A\u064A';
  t['\uFD17'] = '\u0633\u0649';
  t['\uFD18'] = '\u0633\u064A';
  t['\uFD19'] = '\u0634\u0649';
  t['\uFD1A'] = '\u0634\u064A';
  t['\uFD1B'] = '\u062D\u0649';
  t['\uFD1C'] = '\u062D\u064A';
  t['\uFD1D'] = '\u062C\u0649';
  t['\uFD1E'] = '\u062C\u064A';
  t['\uFD1F'] = '\u062E\u0649';
  t['\uFD20'] = '\u062E\u064A';
  t['\uFD21'] = '\u0635\u0649';
  t['\uFD22'] = '\u0635\u064A';
  t['\uFD23'] = '\u0636\u0649';
  t['\uFD24'] = '\u0636\u064A';
  t['\uFD25'] = '\u0634\u062C';
  t['\uFD26'] = '\u0634\u062D';
  t['\uFD27'] = '\u0634\u062E';
  t['\uFD28'] = '\u0634\u0645';
  t['\uFD29'] = '\u0634\u0631';
  t['\uFD2A'] = '\u0633\u0631';
  t['\uFD2B'] = '\u0635\u0631';
  t['\uFD2C'] = '\u0636\u0631';
  t['\uFD2D'] = '\u0634\u062C';
  t['\uFD2E'] = '\u0634\u062D';
  t['\uFD2F'] = '\u0634\u062E';
  t['\uFD30'] = '\u0634\u0645';
  t['\uFD31'] = '\u0633\u0647';
  t['\uFD32'] = '\u0634\u0647';
  t['\uFD33'] = '\u0637\u0645';
  t['\uFD34'] = '\u0633\u062C';
  t['\uFD35'] = '\u0633\u062D';
  t['\uFD36'] = '\u0633\u062E';
  t['\uFD37'] = '\u0634\u062C';
  t['\uFD38'] = '\u0634\u062D';
  t['\uFD39'] = '\u0634\u062E';
  t['\uFD3A'] = '\u0637\u0645';
  t['\uFD3B'] = '\u0638\u0645';
  t['\uFD3C'] = '\u0627\u064B';
  t['\uFD3D'] = '\u0627\u064B';
  t['\uFD50'] = '\u062A\u062C\u0645';
  t['\uFD51'] = '\u062A\u062D\u062C';
  t['\uFD52'] = '\u062A\u062D\u062C';
  t['\uFD53'] = '\u062A\u062D\u0645';
  t['\uFD54'] = '\u062A\u062E\u0645';
  t['\uFD55'] = '\u062A\u0645\u062C';
  t['\uFD56'] = '\u062A\u0645\u062D';
  t['\uFD57'] = '\u062A\u0645\u062E';
  t['\uFD58'] = '\u062C\u0645\u062D';
  t['\uFD59'] = '\u062C\u0645\u062D';
  t['\uFD5A'] = '\u062D\u0645\u064A';
  t['\uFD5B'] = '\u062D\u0645\u0649';
  t['\uFD5C'] = '\u0633\u062D\u062C';
  t['\uFD5D'] = '\u0633\u062C\u062D';
  t['\uFD5E'] = '\u0633\u062C\u0649';
  t['\uFD5F'] = '\u0633\u0645\u062D';
  t['\uFD60'] = '\u0633\u0645\u062D';
  t['\uFD61'] = '\u0633\u0645\u062C';
  t['\uFD62'] = '\u0633\u0645\u0645';
  t['\uFD63'] = '\u0633\u0645\u0645';
  t['\uFD64'] = '\u0635\u062D\u062D';
  t['\uFD65'] = '\u0635\u062D\u062D';
  t['\uFD66'] = '\u0635\u0645\u0645';
  t['\uFD67'] = '\u0634\u062D\u0645';
  t['\uFD68'] = '\u0634\u062D\u0645';
  t['\uFD69'] = '\u0634\u062C\u064A';
  t['\uFD6A'] = '\u0634\u0645\u062E';
  t['\uFD6B'] = '\u0634\u0645\u062E';
  t['\uFD6C'] = '\u0634\u0645\u0645';
  t['\uFD6D'] = '\u0634\u0645\u0645';
  t['\uFD6E'] = '\u0636\u062D\u0649';
  t['\uFD6F'] = '\u0636\u062E\u0645';
  t['\uFD70'] = '\u0636\u062E\u0645';
  t['\uFD71'] = '\u0637\u0645\u062D';
  t['\uFD72'] = '\u0637\u0645\u062D';
  t['\uFD73'] = '\u0637\u0645\u0645';
  t['\uFD74'] = '\u0637\u0645\u064A';
  t['\uFD75'] = '\u0639\u062C\u0645';
  t['\uFD76'] = '\u0639\u0645\u0645';
  t['\uFD77'] = '\u0639\u0645\u0645';
  t['\uFD78'] = '\u0639\u0645\u0649';
  t['\uFD79'] = '\u063A\u0645\u0645';
  t['\uFD7A'] = '\u063A\u0645\u064A';
  t['\uFD7B'] = '\u063A\u0645\u0649';
  t['\uFD7C'] = '\u0641\u062E\u0645';
  t['\uFD7D'] = '\u0641\u062E\u0645';
  t['\uFD7E'] = '\u0642\u0645\u062D';
  t['\uFD7F'] = '\u0642\u0645\u0645';
  t['\uFD80'] = '\u0644\u062D\u0645';
  t['\uFD81'] = '\u0644\u062D\u064A';
  t['\uFD82'] = '\u0644\u062D\u0649';
  t['\uFD83'] = '\u0644\u062C\u062C';
  t['\uFD84'] = '\u0644\u062C\u062C';
  t['\uFD85'] = '\u0644\u062E\u0645';
  t['\uFD86'] = '\u0644\u062E\u0645';
  t['\uFD87'] = '\u0644\u0645\u062D';
  t['\uFD88'] = '\u0644\u0645\u062D';
  t['\uFD89'] = '\u0645\u062D\u062C';
  t['\uFD8A'] = '\u0645\u062D\u0645';
  t['\uFD8B'] = '\u0645\u062D\u064A';
  t['\uFD8C'] = '\u0645\u062C\u062D';
  t['\uFD8D'] = '\u0645\u062C\u0645';
  t['\uFD8E'] = '\u0645\u062E\u062C';
  t['\uFD8F'] = '\u0645\u062E\u0645';
  t['\uFD92'] = '\u0645\u062C\u062E';
  t['\uFD93'] = '\u0647\u0645\u062C';
  t['\uFD94'] = '\u0647\u0645\u0645';
  t['\uFD95'] = '\u0646\u062D\u0645';
  t['\uFD96'] = '\u0646\u062D\u0649';
  t['\uFD97'] = '\u0646\u062C\u0645';
  t['\uFD98'] = '\u0646\u062C\u0645';
  t['\uFD99'] = '\u0646\u062C\u0649';
  t['\uFD9A'] = '\u0646\u0645\u064A';
  t['\uFD9B'] = '\u0646\u0645\u0649';
  t['\uFD9C'] = '\u064A\u0645\u0645';
  t['\uFD9D'] = '\u064A\u0645\u0645';
  t['\uFD9E'] = '\u0628\u062E\u064A';
  t['\uFD9F'] = '\u062A\u062C\u064A';
  t['\uFDA0'] = '\u062A\u062C\u0649';
  t['\uFDA1'] = '\u062A\u062E\u064A';
  t['\uFDA2'] = '\u062A\u062E\u0649';
  t['\uFDA3'] = '\u062A\u0645\u064A';
  t['\uFDA4'] = '\u062A\u0645\u0649';
  t['\uFDA5'] = '\u062C\u0645\u064A';
  t['\uFDA6'] = '\u062C\u062D\u0649';
  t['\uFDA7'] = '\u062C\u0645\u0649';
  t['\uFDA8'] = '\u0633\u062E\u0649';
  t['\uFDA9'] = '\u0635\u062D\u064A';
  t['\uFDAA'] = '\u0634\u062D\u064A';
  t['\uFDAB'] = '\u0636\u062D\u064A';
  t['\uFDAC'] = '\u0644\u062C\u064A';
  t['\uFDAD'] = '\u0644\u0645\u064A';
  t['\uFDAE'] = '\u064A\u062D\u064A';
  t['\uFDAF'] = '\u064A\u062C\u064A';
  t['\uFDB0'] = '\u064A\u0645\u064A';
  t['\uFDB1'] = '\u0645\u0645\u064A';
  t['\uFDB2'] = '\u0642\u0645\u064A';
  t['\uFDB3'] = '\u0646\u062D\u064A';
  t['\uFDB4'] = '\u0642\u0645\u062D';
  t['\uFDB5'] = '\u0644\u062D\u0645';
  t['\uFDB6'] = '\u0639\u0645\u064A';
  t['\uFDB7'] = '\u0643\u0645\u064A';
  t['\uFDB8'] = '\u0646\u062C\u062D';
  t['\uFDB9'] = '\u0645\u062E\u064A';
  t['\uFDBA'] = '\u0644\u062C\u0645';
  t['\uFDBB'] = '\u0643\u0645\u0645';
  t['\uFDBC'] = '\u0644\u062C\u0645';
  t['\uFDBD'] = '\u0646\u062C\u062D';
  t['\uFDBE'] = '\u062C\u062D\u064A';
  t['\uFDBF'] = '\u062D\u062C\u064A';
  t['\uFDC0'] = '\u0645\u062C\u064A';
  t['\uFDC1'] = '\u0641\u0645\u064A';
  t['\uFDC2'] = '\u0628\u062D\u064A';
  t['\uFDC3'] = '\u0643\u0645\u0645';
  t['\uFDC4'] = '\u0639\u062C\u0645';
  t['\uFDC5'] = '\u0635\u0645\u0645';
  t['\uFDC6'] = '\u0633\u062E\u064A';
  t['\uFDC7'] = '\u0646\u062C\u064A';
  t['\uFE49'] = '\u203E';
  t['\uFE4A'] = '\u203E';
  t['\uFE4B'] = '\u203E';
  t['\uFE4C'] = '\u203E';
  t['\uFE4D'] = '_';
  t['\uFE4E'] = '_';
  t['\uFE4F'] = '_';
  t['\uFE80'] = '\u0621';
  t['\uFE81'] = '\u0622';
  t['\uFE82'] = '\u0622';
  t['\uFE83'] = '\u0623';
  t['\uFE84'] = '\u0623';
  t['\uFE85'] = '\u0624';
  t['\uFE86'] = '\u0624';
  t['\uFE87'] = '\u0625';
  t['\uFE88'] = '\u0625';
  t['\uFE89'] = '\u0626';
  t['\uFE8A'] = '\u0626';
  t['\uFE8B'] = '\u0626';
  t['\uFE8C'] = '\u0626';
  t['\uFE8D'] = '\u0627';
  t['\uFE8E'] = '\u0627';
  t['\uFE8F'] = '\u0628';
  t['\uFE90'] = '\u0628';
  t['\uFE91'] = '\u0628';
  t['\uFE92'] = '\u0628';
  t['\uFE93'] = '\u0629';
  t['\uFE94'] = '\u0629';
  t['\uFE95'] = '\u062A';
  t['\uFE96'] = '\u062A';
  t['\uFE97'] = '\u062A';
  t['\uFE98'] = '\u062A';
  t['\uFE99'] = '\u062B';
  t['\uFE9A'] = '\u062B';
  t['\uFE9B'] = '\u062B';
  t['\uFE9C'] = '\u062B';
  t['\uFE9D'] = '\u062C';
  t['\uFE9E'] = '\u062C';
  t['\uFE9F'] = '\u062C';
  t['\uFEA0'] = '\u062C';
  t['\uFEA1'] = '\u062D';
  t['\uFEA2'] = '\u062D';
  t['\uFEA3'] = '\u062D';
  t['\uFEA4'] = '\u062D';
  t['\uFEA5'] = '\u062E';
  t['\uFEA6'] = '\u062E';
  t['\uFEA7'] = '\u062E';
  t['\uFEA8'] = '\u062E';
  t['\uFEA9'] = '\u062F';
  t['\uFEAA'] = '\u062F';
  t['\uFEAB'] = '\u0630';
  t['\uFEAC'] = '\u0630';
  t['\uFEAD'] = '\u0631';
  t['\uFEAE'] = '\u0631';
  t['\uFEAF'] = '\u0632';
  t['\uFEB0'] = '\u0632';
  t['\uFEB1'] = '\u0633';
  t['\uFEB2'] = '\u0633';
  t['\uFEB3'] = '\u0633';
  t['\uFEB4'] = '\u0633';
  t['\uFEB5'] = '\u0634';
  t['\uFEB6'] = '\u0634';
  t['\uFEB7'] = '\u0634';
  t['\uFEB8'] = '\u0634';
  t['\uFEB9'] = '\u0635';
  t['\uFEBA'] = '\u0635';
  t['\uFEBB'] = '\u0635';
  t['\uFEBC'] = '\u0635';
  t['\uFEBD'] = '\u0636';
  t['\uFEBE'] = '\u0636';
  t['\uFEBF'] = '\u0636';
  t['\uFEC0'] = '\u0636';
  t['\uFEC1'] = '\u0637';
  t['\uFEC2'] = '\u0637';
  t['\uFEC3'] = '\u0637';
  t['\uFEC4'] = '\u0637';
  t['\uFEC5'] = '\u0638';
  t['\uFEC6'] = '\u0638';
  t['\uFEC7'] = '\u0638';
  t['\uFEC8'] = '\u0638';
  t['\uFEC9'] = '\u0639';
  t['\uFECA'] = '\u0639';
  t['\uFECB'] = '\u0639';
  t['\uFECC'] = '\u0639';
  t['\uFECD'] = '\u063A';
  t['\uFECE'] = '\u063A';
  t['\uFECF'] = '\u063A';
  t['\uFED0'] = '\u063A';
  t['\uFED1'] = '\u0641';
  t['\uFED2'] = '\u0641';
  t['\uFED3'] = '\u0641';
  t['\uFED4'] = '\u0641';
  t['\uFED5'] = '\u0642';
  t['\uFED6'] = '\u0642';
  t['\uFED7'] = '\u0642';
  t['\uFED8'] = '\u0642';
  t['\uFED9'] = '\u0643';
  t['\uFEDA'] = '\u0643';
  t['\uFEDB'] = '\u0643';
  t['\uFEDC'] = '\u0643';
  t['\uFEDD'] = '\u0644';
  t['\uFEDE'] = '\u0644';
  t['\uFEDF'] = '\u0644';
  t['\uFEE0'] = '\u0644';
  t['\uFEE1'] = '\u0645';
  t['\uFEE2'] = '\u0645';
  t['\uFEE3'] = '\u0645';
  t['\uFEE4'] = '\u0645';
  t['\uFEE5'] = '\u0646';
  t['\uFEE6'] = '\u0646';
  t['\uFEE7'] = '\u0646';
  t['\uFEE8'] = '\u0646';
  t['\uFEE9'] = '\u0647';
  t['\uFEEA'] = '\u0647';
  t['\uFEEB'] = '\u0647';
  t['\uFEEC'] = '\u0647';
  t['\uFEED'] = '\u0648';
  t['\uFEEE'] = '\u0648';
  t['\uFEEF'] = '\u0649';
  t['\uFEF0'] = '\u0649';
  t['\uFEF1'] = '\u064A';
  t['\uFEF2'] = '\u064A';
  t['\uFEF3'] = '\u064A';
  t['\uFEF4'] = '\u064A';
  t['\uFEF5'] = '\u0644\u0622';
  t['\uFEF6'] = '\u0644\u0622';
  t['\uFEF7'] = '\u0644\u0623';
  t['\uFEF8'] = '\u0644\u0623';
  t['\uFEF9'] = '\u0644\u0625';
  t['\uFEFA'] = '\u0644\u0625';
  t['\uFEFB'] = '\u0644\u0627';
  t['\uFEFC'] = '\u0644\u0627';
});
function reverseIfRtl(chars) {
  var charsLength = chars.length;
  if (charsLength <= 1 || !isRTLRangeFor(chars.charCodeAt(0))) {
    return chars;
  }
  var s = '';
  for (var ii = charsLength - 1; ii >= 0; ii--) {
    s += chars[ii];
  }
  return s;
}
exports.mapSpecialUnicodeValues = mapSpecialUnicodeValues;
exports.reverseIfRtl = reverseIfRtl;
exports.getUnicodeRangeFor = getUnicodeRangeFor;
exports.getNormalizedUnicodes = getNormalizedUnicodes;
exports.getUnicodeForGlyph = getUnicodeForGlyph;

/***/ }),
/* 17 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WorkerMessageHandler = exports.WorkerTask = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _util = __w_pdfjs_require__(0);

var _pdf_manager = __w_pdfjs_require__(32);

var _primitives = __w_pdfjs_require__(1);

var WorkerTask = function WorkerTaskClosure() {
  function WorkerTask(name) {
    this.name = name;
    this.terminated = false;
    this._capability = (0, _util.createPromiseCapability)();
  }
  WorkerTask.prototype = {
    get finished() {
      return this._capability.promise;
    },
    finish: function finish() {
      this._capability.resolve();
    },
    terminate: function terminate() {
      this.terminated = true;
    },
    ensureNotTerminated: function ensureNotTerminated() {
      if (this.terminated) {
        throw new Error('Worker task was terminated');
      }
    }
  };
  return WorkerTask;
}();
;
var PDFWorkerStream = function PDFWorkerStreamClosure() {
  function PDFWorkerStream(msgHandler) {
    this._msgHandler = msgHandler;
    this._contentLength = null;
    this._fullRequestReader = null;
    this._rangeRequestReaders = [];
  }
  PDFWorkerStream.prototype = {
    getFullReader: function getFullReader() {
      (0, _util.assert)(!this._fullRequestReader);
      this._fullRequestReader = new PDFWorkerStreamReader(this._msgHandler);
      return this._fullRequestReader;
    },
    getRangeReader: function getRangeReader(begin, end) {
      var reader = new PDFWorkerStreamRangeReader(begin, end, this._msgHandler);
      this._rangeRequestReaders.push(reader);
      return reader;
    },
    cancelAllRequests: function cancelAllRequests(reason) {
      if (this._fullRequestReader) {
        this._fullRequestReader.cancel(reason);
      }
      var readers = this._rangeRequestReaders.slice(0);
      readers.forEach(function (reader) {
        reader.cancel(reason);
      });
    }
  };
  function PDFWorkerStreamReader(msgHandler) {
    var _this = this;

    this._msgHandler = msgHandler;
    this._contentLength = null;
    this._isRangeSupported = false;
    this._isStreamingSupported = false;
    var readableStream = this._msgHandler.sendWithStream('GetReader');
    this._reader = readableStream.getReader();
    this._headersReady = this._msgHandler.sendWithPromise('ReaderHeadersReady').then(function (data) {
      _this._isStreamingSupported = data.isStreamingSupported;
      _this._isRangeSupported = data.isRangeSupported;
      _this._contentLength = data.contentLength;
    });
  }
  PDFWorkerStreamReader.prototype = {
    get headersReady() {
      return this._headersReady;
    },
    get contentLength() {
      return this._contentLength;
    },
    get isStreamingSupported() {
      return this._isStreamingSupported;
    },
    get isRangeSupported() {
      return this._isRangeSupported;
    },
    read: function read() {
      return this._reader.read().then(function (_ref) {
        var value = _ref.value,
            done = _ref.done;

        if (done) {
          return {
            value: undefined,
            done: true
          };
        }
        return {
          value: value.buffer,
          done: false
        };
      });
    },
    cancel: function cancel(reason) {
      this._reader.cancel(reason);
    }
  };
  function PDFWorkerStreamRangeReader(begin, end, msgHandler) {
    this._msgHandler = msgHandler;
    this.onProgress = null;
    var readableStream = this._msgHandler.sendWithStream('GetRangeReader', {
      begin: begin,
      end: end
    });
    this._reader = readableStream.getReader();
  }
  PDFWorkerStreamRangeReader.prototype = {
    get isStreamingSupported() {
      return false;
    },
    read: function read() {
      return this._reader.read().then(function (_ref2) {
        var value = _ref2.value,
            done = _ref2.done;

        if (done) {
          return {
            value: undefined,
            done: true
          };
        }
        return {
          value: value.buffer,
          done: false
        };
      });
    },
    cancel: function cancel(reason) {
      this._reader.cancel(reason);
    }
  };
  return PDFWorkerStream;
}();
var WorkerMessageHandler = {
  setup: function setup(handler, port) {
    var testMessageProcessed = false;
    handler.on('test', function wphSetupTest(data) {
      if (testMessageProcessed) {
        return;
      }
      testMessageProcessed = true;
      if (!(data instanceof Uint8Array)) {
        handler.send('test', 'main', false);
        return;
      }
      var supportTransfers = data[0] === 255;
      handler.postMessageTransfers = supportTransfers;
      var xhr = new XMLHttpRequest();
      var responseExists = 'response' in xhr;
      try {
        xhr.responseType;
      } catch (e) {
        responseExists = false;
      }
      if (!responseExists) {
        handler.send('test', false);
        return;
      }
      handler.send('test', {
        supportTypedArray: true,
        supportTransfers: supportTransfers
      });
    });
    handler.on('configure', function wphConfigure(data) {
      (0, _util.setVerbosityLevel)(data.verbosity);
    });
    handler.on('GetDocRequest', function wphSetupDoc(data) {
      return WorkerMessageHandler.createDocumentHandler(data, port);
    });
  },
  createDocumentHandler: function createDocumentHandler(docParams, port) {
    var pdfManager;
    var terminated = false;
    var cancelXHRs = null;
    var WorkerTasks = [];
    var docId = docParams.docId;
    var docBaseUrl = docParams.docBaseUrl;
    var workerHandlerName = docParams.docId + '_worker';
    var handler = new _util.MessageHandler(workerHandlerName, docId, port);
    handler.postMessageTransfers = docParams.postMessageTransfers;
    function ensureNotTerminated() {
      if (terminated) {
        throw new Error('Worker was terminated');
      }
    }
    function startWorkerTask(task) {
      WorkerTasks.push(task);
    }
    function finishWorkerTask(task) {
      task.finish();
      var i = WorkerTasks.indexOf(task);
      WorkerTasks.splice(i, 1);
    }
    function loadDocument(recoveryMode) {
      var loadDocumentCapability = (0, _util.createPromiseCapability)();
      var parseSuccess = function parseSuccess() {
        var numPagesPromise = pdfManager.ensureDoc('numPages');
        var fingerprintPromise = pdfManager.ensureDoc('fingerprint');
        var encryptedPromise = pdfManager.ensureXRef('encrypt');
        Promise.all([numPagesPromise, fingerprintPromise, encryptedPromise]).then(function onDocReady(results) {
          var doc = {
            numPages: results[0],
            fingerprint: results[1],
            encrypted: !!results[2]
          };
          loadDocumentCapability.resolve(doc);
        }, parseFailure);
      };
      var parseFailure = function parseFailure(e) {
        loadDocumentCapability.reject(e);
      };
      pdfManager.ensureDoc('checkHeader', []).then(function () {
        pdfManager.ensureDoc('parseStartXRef', []).then(function () {
          pdfManager.ensureDoc('parse', [recoveryMode]).then(parseSuccess, parseFailure);
        }, parseFailure);
      }, parseFailure);
      return loadDocumentCapability.promise;
    }
    function getPdfManager(data, evaluatorOptions) {
      var pdfManagerCapability = (0, _util.createPromiseCapability)();
      var pdfManager;
      var source = data.source;
      if (source.data) {
        try {
          pdfManager = new _pdf_manager.LocalPdfManager(docId, source.data, source.password, evaluatorOptions, docBaseUrl);
          pdfManagerCapability.resolve(pdfManager);
        } catch (ex) {
          pdfManagerCapability.reject(ex);
        }
        return pdfManagerCapability.promise;
      }
      var pdfStream,
          cachedChunks = [];
      try {
        pdfStream = new PDFWorkerStream(handler);
      } catch (ex) {
        pdfManagerCapability.reject(ex);
        return pdfManagerCapability.promise;
      }
      var fullRequest = pdfStream.getFullReader();
      fullRequest.headersReady.then(function () {
        if (!fullRequest.isRangeSupported) {
          return;
        }
        var disableAutoFetch = source.disableAutoFetch || fullRequest.isStreamingSupported;
        pdfManager = new _pdf_manager.NetworkPdfManager(docId, pdfStream, {
          msgHandler: handler,
          url: source.url,
          password: source.password,
          length: fullRequest.contentLength,
          disableAutoFetch: disableAutoFetch,
          rangeChunkSize: source.rangeChunkSize
        }, evaluatorOptions, docBaseUrl);
        for (var i = 0; i < cachedChunks.length; i++) {
          pdfManager.sendProgressiveData(cachedChunks[i]);
        }
        cachedChunks = [];
        pdfManagerCapability.resolve(pdfManager);
        cancelXHRs = null;
      }).catch(function (reason) {
        pdfManagerCapability.reject(reason);
        cancelXHRs = null;
      });
      var loaded = 0;
      var flushChunks = function flushChunks() {
        var pdfFile = (0, _util.arraysToBytes)(cachedChunks);
        if (source.length && pdfFile.length !== source.length) {
          (0, _util.warn)('reported HTTP length is different from actual');
        }
        try {
          pdfManager = new _pdf_manager.LocalPdfManager(docId, pdfFile, source.password, evaluatorOptions, docBaseUrl);
          pdfManagerCapability.resolve(pdfManager);
        } catch (ex) {
          pdfManagerCapability.reject(ex);
        }
        cachedChunks = [];
      };
      var readPromise = new Promise(function (resolve, reject) {
        var readChunk = function readChunk(chunk) {
          try {
            ensureNotTerminated();
            if (chunk.done) {
              if (!pdfManager) {
                flushChunks();
              }
              cancelXHRs = null;
              return;
            }
            var data = chunk.value;
            loaded += (0, _util.arrayByteLength)(data);
            if (!fullRequest.isStreamingSupported) {
              handler.send('DocProgress', {
                loaded: loaded,
                total: Math.max(loaded, fullRequest.contentLength || 0)
              });
            }
            if (pdfManager) {
              pdfManager.sendProgressiveData(data);
            } else {
              cachedChunks.push(data);
            }
            fullRequest.read().then(readChunk, reject);
          } catch (e) {
            reject(e);
          }
        };
        fullRequest.read().then(readChunk, reject);
      });
      readPromise.catch(function (e) {
        pdfManagerCapability.reject(e);
        cancelXHRs = null;
      });
      cancelXHRs = function cancelXHRs() {
        pdfStream.cancelAllRequests('abort');
      };
      return pdfManagerCapability.promise;
    }
    function setupDoc(data) {
      function onSuccess(doc) {
        ensureNotTerminated();
        handler.send('GetDoc', { pdfInfo: doc });
      }
      function onFailure(e) {
        ensureNotTerminated();
        if (e instanceof _util.PasswordException) {
          var task = new WorkerTask('PasswordException: response ' + e.code);
          startWorkerTask(task);
          handler.sendWithPromise('PasswordRequest', e).then(function (data) {
            finishWorkerTask(task);
            pdfManager.updatePassword(data.password);
            pdfManagerReady();
          }).catch(function (ex) {
            finishWorkerTask(task);
            handler.send('PasswordException', ex);
          }.bind(null, e));
        } else if (e instanceof _util.InvalidPDFException) {
          handler.send('InvalidPDF', e);
        } else if (e instanceof _util.MissingPDFException) {
          handler.send('MissingPDF', e);
        } else if (e instanceof _util.UnexpectedResponseException) {
          handler.send('UnexpectedResponse', e);
        } else {
          handler.send('UnknownError', new _util.UnknownErrorException(e.message, e.toString()));
        }
      }
      function pdfManagerReady() {
        ensureNotTerminated();
        loadDocument(false).then(onSuccess, function loadFailure(ex) {
          ensureNotTerminated();
          if (!(ex instanceof _util.XRefParseException)) {
            onFailure(ex);
            return;
          }
          pdfManager.requestLoadedStream();
          pdfManager.onLoadedStream().then(function () {
            ensureNotTerminated();
            loadDocument(true).then(onSuccess, onFailure);
          });
        }, onFailure);
      }
      ensureNotTerminated();
      var evaluatorOptions = {
        forceDataSchema: data.disableCreateObjectURL,
        maxImageSize: data.maxImageSize === undefined ? -1 : data.maxImageSize,
        disableFontFace: data.disableFontFace,
        nativeImageDecoderSupport: data.nativeImageDecoderSupport,
        ignoreErrors: data.ignoreErrors
      };
      getPdfManager(data, evaluatorOptions).then(function (newPdfManager) {
        if (terminated) {
          newPdfManager.terminate();
          throw new Error('Worker was terminated');
        }
        pdfManager = newPdfManager;
        handler.send('PDFManagerReady', null);
        pdfManager.onLoadedStream().then(function (stream) {
          handler.send('DataLoaded', { length: stream.bytes.byteLength });
        });
      }).then(pdfManagerReady, onFailure);
    }
    handler.on('GetPage', function wphSetupGetPage(data) {
      return pdfManager.getPage(data.pageIndex).then(function (page) {
        var rotatePromise = pdfManager.ensure(page, 'rotate');
        var refPromise = pdfManager.ensure(page, 'ref');
        var userUnitPromise = pdfManager.ensure(page, 'userUnit');
        var viewPromise = pdfManager.ensure(page, 'view');
        return Promise.all([rotatePromise, refPromise, userUnitPromise, viewPromise]).then(function (results) {
          return {
            rotate: results[0],
            ref: results[1],
            userUnit: results[2],
            view: results[3]
          };
        });
      });
    });
    handler.on('GetPageIndex', function wphSetupGetPageIndex(data) {
      var ref = new _primitives.Ref(data.ref.num, data.ref.gen);
      var catalog = pdfManager.pdfDocument.catalog;
      return catalog.getPageIndex(ref);
    });
    handler.on('GetDestinations', function wphSetupGetDestinations(data) {
      return pdfManager.ensureCatalog('destinations');
    });
    handler.on('GetDestination', function wphSetupGetDestination(data) {
      return pdfManager.ensureCatalog('getDestination', [data.id]);
    });
    handler.on('GetPageLabels', function wphSetupGetPageLabels(data) {
      return pdfManager.ensureCatalog('pageLabels');
    });
    handler.on('GetPageMode', function wphSetupGetPageMode(data) {
      return pdfManager.ensureCatalog('pageMode');
    });
    handler.on('GetAttachments', function wphSetupGetAttachments(data) {
      return pdfManager.ensureCatalog('attachments');
    });
    handler.on('GetJavaScript', function wphSetupGetJavaScript(data) {
      return pdfManager.ensureCatalog('javaScript');
    });
    handler.on('GetOutline', function wphSetupGetOutline(data) {
      return pdfManager.ensureCatalog('documentOutline');
    });
    handler.on('GetMetadata', function wphSetupGetMetadata(data) {
      return Promise.all([pdfManager.ensureDoc('documentInfo'), pdfManager.ensureCatalog('metadata')]);
    });
    handler.on('GetData', function wphSetupGetData(data) {
      pdfManager.requestLoadedStream();
      return pdfManager.onLoadedStream().then(function (stream) {
        return stream.bytes;
      });
    });
    handler.on('GetStats', function wphSetupGetStats(data) {
      return pdfManager.pdfDocument.xref.stats;
    });
    handler.on('GetAnnotations', function wphSetupGetAnnotations(data) {
      return pdfManager.getPage(data.pageIndex).then(function (page) {
        return pdfManager.ensure(page, 'getAnnotationsData', [data.intent]);
      });
    });
    handler.on('RenderPageRequest', function wphSetupRenderPage(data) {
      var pageIndex = data.pageIndex;
      pdfManager.getPage(pageIndex).then(function (page) {
        var task = new WorkerTask('RenderPageRequest: page ' + pageIndex);
        startWorkerTask(task);
        var pageNum = pageIndex + 1;
        var start = Date.now();
        page.getOperatorList({
          handler: handler,
          task: task,
          intent: data.intent,
          renderInteractiveForms: data.renderInteractiveForms
        }).then(function (operatorList) {
          finishWorkerTask(task);
          (0, _util.info)('page=' + pageNum + ' - getOperatorList: time=' + (Date.now() - start) + 'ms, len=' + operatorList.totalLength);
        }, function (e) {
          finishWorkerTask(task);
          if (task.terminated) {
            return;
          }
          handler.send('UnsupportedFeature', { featureId: _util.UNSUPPORTED_FEATURES.unknown });
          var minimumStackMessage = 'worker.js: while trying to getPage() and getOperatorList()';
          var wrappedException;
          if (typeof e === 'string') {
            wrappedException = {
              message: e,
              stack: minimumStackMessage
            };
          } else if ((typeof e === 'undefined' ? 'undefined' : _typeof(e)) === 'object') {
            wrappedException = {
              message: e.message || e.toString(),
              stack: e.stack || minimumStackMessage
            };
          } else {
            wrappedException = {
              message: 'Unknown exception type: ' + (typeof e === 'undefined' ? 'undefined' : _typeof(e)),
              stack: minimumStackMessage
            };
          }
          handler.send('PageError', {
            pageNum: pageNum,
            error: wrappedException,
            intent: data.intent
          });
        });
      });
    }, this);
    handler.on('GetTextContent', function wphExtractText(data, sink) {
      var pageIndex = data.pageIndex;
      sink.onPull = function (desiredSize) {};
      sink.onCancel = function (reason) {};
      pdfManager.getPage(pageIndex).then(function (page) {
        var task = new WorkerTask('GetTextContent: page ' + pageIndex);
        startWorkerTask(task);
        var pageNum = pageIndex + 1;
        var start = Date.now();
        page.extractTextContent({
          handler: handler,
          task: task,
          sink: sink,
          normalizeWhitespace: data.normalizeWhitespace,
          combineTextItems: data.combineTextItems
        }).then(function () {
          finishWorkerTask(task);
          (0, _util.info)('text indexing: page=' + pageNum + ' - time=' + (Date.now() - start) + 'ms');
          sink.close();
        }, function (reason) {
          finishWorkerTask(task);
          if (task.terminated) {
            return;
          }
          sink.error(reason);
          throw reason;
        });
      });
    });
    handler.on('Cleanup', function wphCleanup(data) {
      return pdfManager.cleanup();
    });
    handler.on('Terminate', function wphTerminate(data) {
      terminated = true;
      if (pdfManager) {
        pdfManager.terminate();
        pdfManager = null;
      }
      if (cancelXHRs) {
        cancelXHRs();
      }
      var waitOn = [];
      WorkerTasks.forEach(function (task) {
        waitOn.push(task.finished);
        task.terminate();
      });
      return Promise.all(waitOn).then(function () {
        handler.destroy();
        handler = null;
      });
    });
    handler.on('Ready', function wphReady(data) {
      setupDoc(docParams);
      docParams = null;
    });
    return workerHandlerName;
  },
  initializeFromPort: function initializeFromPort(port) {
    var handler = new _util.MessageHandler('worker', 'main', port);
    WorkerMessageHandler.setup(handler, port);
    handler.send('ready', null);
  }
};
function isMessagePort(maybePort) {
  return typeof maybePort.postMessage === 'function' && 'onmessage' in maybePort;
}
if (typeof window === 'undefined' && !(0, _util.isNodeJS)() && typeof self !== 'undefined' && isMessagePort(self)) {
  WorkerMessageHandler.initializeFromPort(self);
}
exports.WorkerTask = WorkerTask;
exports.WorkerMessageHandler = WorkerMessageHandler;

/***/ }),
/* 18 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function (e, a) {
  for (var i in a) {
    e[i] = a[i];
  }
})(exports, function (modules) {
  var installedModules = {};
  function __w_pdfjs_require__(moduleId) {
    if (installedModules[moduleId]) return installedModules[moduleId].exports;
    var module = installedModules[moduleId] = {
      i: moduleId,
      l: false,
      exports: {}
    };
    modules[moduleId].call(module.exports, module, module.exports, __w_pdfjs_require__);
    module.l = true;
    return module.exports;
  }
  __w_pdfjs_require__.m = modules;
  __w_pdfjs_require__.c = installedModules;
  __w_pdfjs_require__.i = function (value) {
    return value;
  };
  __w_pdfjs_require__.d = function (exports, name, getter) {
    if (!__w_pdfjs_require__.o(exports, name)) {
      Object.defineProperty(exports, name, {
        configurable: false,
        enumerable: true,
        get: getter
      });
    }
  };
  __w_pdfjs_require__.n = function (module) {
    var getter = module && module.__esModule ? function getDefault() {
      return module['default'];
    } : function getModuleExports() {
      return module;
    };
    __w_pdfjs_require__.d(getter, 'a', getter);
    return getter;
  };
  __w_pdfjs_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  __w_pdfjs_require__.p = "";
  return __w_pdfjs_require__(__w_pdfjs_require__.s = 7);
}([function (module, exports, __w_pdfjs_require__) {
  "use strict";

  var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
    return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
  };
  var _require = __w_pdfjs_require__(1),
      assert = _require.assert;
  function IsPropertyKey(argument) {
    return typeof argument === 'string' || (typeof argument === 'undefined' ? 'undefined' : _typeof(argument)) === 'symbol';
  }
  exports.typeIsObject = function (x) {
    return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x !== null || typeof x === 'function';
  };
  exports.createDataProperty = function (o, p, v) {
    assert(exports.typeIsObject(o));
    Object.defineProperty(o, p, {
      value: v,
      writable: true,
      enumerable: true,
      configurable: true
    });
  };
  exports.createArrayFromList = function (elements) {
    return elements.slice();
  };
  exports.ArrayBufferCopy = function (dest, destOffset, src, srcOffset, n) {
    new Uint8Array(dest).set(new Uint8Array(src, srcOffset, n), destOffset);
  };
  exports.CreateIterResultObject = function (value, done) {
    assert(typeof done === 'boolean');
    var obj = {};
    Object.defineProperty(obj, 'value', {
      value: value,
      enumerable: true,
      writable: true,
      configurable: true
    });
    Object.defineProperty(obj, 'done', {
      value: done,
      enumerable: true,
      writable: true,
      configurable: true
    });
    return obj;
  };
  exports.IsFiniteNonNegativeNumber = function (v) {
    if (Number.isNaN(v)) {
      return false;
    }
    if (v === Infinity) {
      return false;
    }
    if (v < 0) {
      return false;
    }
    return true;
  };
  function Call(F, V, args) {
    if (typeof F !== 'function') {
      throw new TypeError('Argument is not a function');
    }
    return Function.prototype.apply.call(F, V, args);
  }
  exports.InvokeOrNoop = function (O, P, args) {
    assert(O !== undefined);
    assert(IsPropertyKey(P));
    assert(Array.isArray(args));
    var method = O[P];
    if (method === undefined) {
      return undefined;
    }
    return Call(method, O, args);
  };
  exports.PromiseInvokeOrNoop = function (O, P, args) {
    assert(O !== undefined);
    assert(IsPropertyKey(P));
    assert(Array.isArray(args));
    try {
      return Promise.resolve(exports.InvokeOrNoop(O, P, args));
    } catch (returnValueE) {
      return Promise.reject(returnValueE);
    }
  };
  exports.PromiseInvokeOrPerformFallback = function (O, P, args, F, argsF) {
    assert(O !== undefined);
    assert(IsPropertyKey(P));
    assert(Array.isArray(args));
    assert(Array.isArray(argsF));
    var method = void 0;
    try {
      method = O[P];
    } catch (methodE) {
      return Promise.reject(methodE);
    }
    if (method === undefined) {
      return F.apply(null, argsF);
    }
    try {
      return Promise.resolve(Call(method, O, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
  exports.TransferArrayBuffer = function (O) {
    return O.slice();
  };
  exports.ValidateAndNormalizeHighWaterMark = function (highWaterMark) {
    highWaterMark = Number(highWaterMark);
    if (Number.isNaN(highWaterMark) || highWaterMark < 0) {
      throw new RangeError('highWaterMark property of a queuing strategy must be non-negative and non-NaN');
    }
    return highWaterMark;
  };
  exports.ValidateAndNormalizeQueuingStrategy = function (size, highWaterMark) {
    if (size !== undefined && typeof size !== 'function') {
      throw new TypeError('size property of a queuing strategy must be a function');
    }
    highWaterMark = exports.ValidateAndNormalizeHighWaterMark(highWaterMark);
    return {
      size: size,
      highWaterMark: highWaterMark
    };
  };
}, function (module, exports, __w_pdfjs_require__) {
  "use strict";

  function rethrowAssertionErrorRejection(e) {
    if (e && e.constructor === AssertionError) {
      setTimeout(function () {
        throw e;
      }, 0);
    }
  }
  function AssertionError(message) {
    this.name = 'AssertionError';
    this.message = message || '';
    this.stack = new Error().stack;
  }
  AssertionError.prototype = Object.create(Error.prototype);
  AssertionError.prototype.constructor = AssertionError;
  function assert(value, message) {
    if (!value) {
      throw new AssertionError(message);
    }
  }
  module.exports = {
    rethrowAssertionErrorRejection: rethrowAssertionErrorRejection,
    AssertionError: AssertionError,
    assert: assert
  };
}, function (module, exports, __w_pdfjs_require__) {
  "use strict";

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var _require = __w_pdfjs_require__(0),
      InvokeOrNoop = _require.InvokeOrNoop,
      PromiseInvokeOrNoop = _require.PromiseInvokeOrNoop,
      ValidateAndNormalizeQueuingStrategy = _require.ValidateAndNormalizeQueuingStrategy,
      typeIsObject = _require.typeIsObject;
  var _require2 = __w_pdfjs_require__(1),
      assert = _require2.assert,
      rethrowAssertionErrorRejection = _require2.rethrowAssertionErrorRejection;
  var _require3 = __w_pdfjs_require__(3),
      DequeueValue = _require3.DequeueValue,
      EnqueueValueWithSize = _require3.EnqueueValueWithSize,
      PeekQueueValue = _require3.PeekQueueValue,
      ResetQueue = _require3.ResetQueue;
  var WritableStream = function () {
    function WritableStream() {
      var underlyingSink = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          size = _ref.size,
          _ref$highWaterMark = _ref.highWaterMark,
          highWaterMark = _ref$highWaterMark === undefined ? 1 : _ref$highWaterMark;
      _classCallCheck(this, WritableStream);
      this._state = 'writable';
      this._storedError = undefined;
      this._writer = undefined;
      this._writableStreamController = undefined;
      this._writeRequests = [];
      this._inFlightWriteRequest = undefined;
      this._closeRequest = undefined;
      this._inFlightCloseRequest = undefined;
      this._pendingAbortRequest = undefined;
      this._backpressure = false;
      var type = underlyingSink.type;
      if (type !== undefined) {
        throw new RangeError('Invalid type is specified');
      }
      this._writableStreamController = new WritableStreamDefaultController(this, underlyingSink, size, highWaterMark);
      this._writableStreamController.__startSteps();
    }
    _createClass(WritableStream, [{
      key: 'abort',
      value: function abort(reason) {
        if (IsWritableStream(this) === false) {
          return Promise.reject(streamBrandCheckException('abort'));
        }
        if (IsWritableStreamLocked(this) === true) {
          return Promise.reject(new TypeError('Cannot abort a stream that already has a writer'));
        }
        return WritableStreamAbort(this, reason);
      }
    }, {
      key: 'getWriter',
      value: function getWriter() {
        if (IsWritableStream(this) === false) {
          throw streamBrandCheckException('getWriter');
        }
        return AcquireWritableStreamDefaultWriter(this);
      }
    }, {
      key: 'locked',
      get: function get() {
        if (IsWritableStream(this) === false) {
          throw streamBrandCheckException('locked');
        }
        return IsWritableStreamLocked(this);
      }
    }]);
    return WritableStream;
  }();
  module.exports = {
    AcquireWritableStreamDefaultWriter: AcquireWritableStreamDefaultWriter,
    IsWritableStream: IsWritableStream,
    IsWritableStreamLocked: IsWritableStreamLocked,
    WritableStream: WritableStream,
    WritableStreamAbort: WritableStreamAbort,
    WritableStreamDefaultControllerError: WritableStreamDefaultControllerError,
    WritableStreamDefaultWriterCloseWithErrorPropagation: WritableStreamDefaultWriterCloseWithErrorPropagation,
    WritableStreamDefaultWriterRelease: WritableStreamDefaultWriterRelease,
    WritableStreamDefaultWriterWrite: WritableStreamDefaultWriterWrite,
    WritableStreamCloseQueuedOrInFlight: WritableStreamCloseQueuedOrInFlight
  };
  function AcquireWritableStreamDefaultWriter(stream) {
    return new WritableStreamDefaultWriter(stream);
  }
  function IsWritableStream(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_writableStreamController')) {
      return false;
    }
    return true;
  }
  function IsWritableStreamLocked(stream) {
    assert(IsWritableStream(stream) === true, 'IsWritableStreamLocked should only be used on known writable streams');
    if (stream._writer === undefined) {
      return false;
    }
    return true;
  }
  function WritableStreamAbort(stream, reason) {
    var state = stream._state;
    if (state === 'closed') {
      return Promise.resolve(undefined);
    }
    if (state === 'errored') {
      return Promise.reject(stream._storedError);
    }
    var error = new TypeError('Requested to abort');
    if (stream._pendingAbortRequest !== undefined) {
      return Promise.reject(error);
    }
    assert(state === 'writable' || state === 'erroring', 'state must be writable or erroring');
    var wasAlreadyErroring = false;
    if (state === 'erroring') {
      wasAlreadyErroring = true;
      reason = undefined;
    }
    var promise = new Promise(function (resolve, reject) {
      stream._pendingAbortRequest = {
        _resolve: resolve,
        _reject: reject,
        _reason: reason,
        _wasAlreadyErroring: wasAlreadyErroring
      };
    });
    if (wasAlreadyErroring === false) {
      WritableStreamStartErroring(stream, error);
    }
    return promise;
  }
  function WritableStreamAddWriteRequest(stream) {
    assert(IsWritableStreamLocked(stream) === true);
    assert(stream._state === 'writable');
    var promise = new Promise(function (resolve, reject) {
      var writeRequest = {
        _resolve: resolve,
        _reject: reject
      };
      stream._writeRequests.push(writeRequest);
    });
    return promise;
  }
  function WritableStreamDealWithRejection(stream, error) {
    var state = stream._state;
    if (state === 'writable') {
      WritableStreamStartErroring(stream, error);
      return;
    }
    assert(state === 'erroring');
    WritableStreamFinishErroring(stream);
  }
  function WritableStreamStartErroring(stream, reason) {
    assert(stream._storedError === undefined, 'stream._storedError === undefined');
    assert(stream._state === 'writable', 'state must be writable');
    var controller = stream._writableStreamController;
    assert(controller !== undefined, 'controller must not be undefined');
    stream._state = 'erroring';
    stream._storedError = reason;
    var writer = stream._writer;
    if (writer !== undefined) {
      WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, reason);
    }
    if (WritableStreamHasOperationMarkedInFlight(stream) === false && controller._started === true) {
      WritableStreamFinishErroring(stream);
    }
  }
  function WritableStreamFinishErroring(stream) {
    assert(stream._state === 'erroring', 'stream._state === erroring');
    assert(WritableStreamHasOperationMarkedInFlight(stream) === false, 'WritableStreamHasOperationMarkedInFlight(stream) === false');
    stream._state = 'errored';
    stream._writableStreamController.__errorSteps();
    var storedError = stream._storedError;
    for (var i = 0; i < stream._writeRequests.length; i++) {
      var writeRequest = stream._writeRequests[i];
      writeRequest._reject(storedError);
    }
    stream._writeRequests = [];
    if (stream._pendingAbortRequest === undefined) {
      WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
      return;
    }
    var abortRequest = stream._pendingAbortRequest;
    stream._pendingAbortRequest = undefined;
    if (abortRequest._wasAlreadyErroring === true) {
      abortRequest._reject(storedError);
      WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
      return;
    }
    var promise = stream._writableStreamController.__abortSteps(abortRequest._reason);
    promise.then(function () {
      abortRequest._resolve();
      WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
    }, function (reason) {
      abortRequest._reject(reason);
      WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
    });
  }
  function WritableStreamFinishInFlightWrite(stream) {
    assert(stream._inFlightWriteRequest !== undefined);
    stream._inFlightWriteRequest._resolve(undefined);
    stream._inFlightWriteRequest = undefined;
  }
  function WritableStreamFinishInFlightWriteWithError(stream, error) {
    assert(stream._inFlightWriteRequest !== undefined);
    stream._inFlightWriteRequest._reject(error);
    stream._inFlightWriteRequest = undefined;
    assert(stream._state === 'writable' || stream._state === 'erroring');
    WritableStreamDealWithRejection(stream, error);
  }
  function WritableStreamFinishInFlightClose(stream) {
    assert(stream._inFlightCloseRequest !== undefined);
    stream._inFlightCloseRequest._resolve(undefined);
    stream._inFlightCloseRequest = undefined;
    var state = stream._state;
    assert(state === 'writable' || state === 'erroring');
    if (state === 'erroring') {
      stream._storedError = undefined;
      if (stream._pendingAbortRequest !== undefined) {
        stream._pendingAbortRequest._resolve();
        stream._pendingAbortRequest = undefined;
      }
    }
    stream._state = 'closed';
    var writer = stream._writer;
    if (writer !== undefined) {
      defaultWriterClosedPromiseResolve(writer);
    }
    assert(stream._pendingAbortRequest === undefined, 'stream._pendingAbortRequest === undefined');
    assert(stream._storedError === undefined, 'stream._storedError === undefined');
  }
  function WritableStreamFinishInFlightCloseWithError(stream, error) {
    assert(stream._inFlightCloseRequest !== undefined);
    stream._inFlightCloseRequest._reject(error);
    stream._inFlightCloseRequest = undefined;
    assert(stream._state === 'writable' || stream._state === 'erroring');
    if (stream._pendingAbortRequest !== undefined) {
      stream._pendingAbortRequest._reject(error);
      stream._pendingAbortRequest = undefined;
    }
    WritableStreamDealWithRejection(stream, error);
  }
  function WritableStreamCloseQueuedOrInFlight(stream) {
    if (stream._closeRequest === undefined && stream._inFlightCloseRequest === undefined) {
      return false;
    }
    return true;
  }
  function WritableStreamHasOperationMarkedInFlight(stream) {
    if (stream._inFlightWriteRequest === undefined && stream._inFlightCloseRequest === undefined) {
      return false;
    }
    return true;
  }
  function WritableStreamMarkCloseRequestInFlight(stream) {
    assert(stream._inFlightCloseRequest === undefined);
    assert(stream._closeRequest !== undefined);
    stream._inFlightCloseRequest = stream._closeRequest;
    stream._closeRequest = undefined;
  }
  function WritableStreamMarkFirstWriteRequestInFlight(stream) {
    assert(stream._inFlightWriteRequest === undefined, 'there must be no pending write request');
    assert(stream._writeRequests.length !== 0, 'writeRequests must not be empty');
    stream._inFlightWriteRequest = stream._writeRequests.shift();
  }
  function WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream) {
    assert(stream._state === 'errored', '_stream_.[[state]] is `"errored"`');
    if (stream._closeRequest !== undefined) {
      assert(stream._inFlightCloseRequest === undefined);
      stream._closeRequest._reject(stream._storedError);
      stream._closeRequest = undefined;
    }
    var writer = stream._writer;
    if (writer !== undefined) {
      defaultWriterClosedPromiseReject(writer, stream._storedError);
      writer._closedPromise.catch(function () {});
    }
  }
  function WritableStreamUpdateBackpressure(stream, backpressure) {
    assert(stream._state === 'writable');
    assert(WritableStreamCloseQueuedOrInFlight(stream) === false);
    var writer = stream._writer;
    if (writer !== undefined && backpressure !== stream._backpressure) {
      if (backpressure === true) {
        defaultWriterReadyPromiseReset(writer);
      } else {
        assert(backpressure === false);
        defaultWriterReadyPromiseResolve(writer);
      }
    }
    stream._backpressure = backpressure;
  }
  var WritableStreamDefaultWriter = function () {
    function WritableStreamDefaultWriter(stream) {
      _classCallCheck(this, WritableStreamDefaultWriter);
      if (IsWritableStream(stream) === false) {
        throw new TypeError('WritableStreamDefaultWriter can only be constructed with a WritableStream instance');
      }
      if (IsWritableStreamLocked(stream) === true) {
        throw new TypeError('This stream has already been locked for exclusive writing by another writer');
      }
      this._ownerWritableStream = stream;
      stream._writer = this;
      var state = stream._state;
      if (state === 'writable') {
        if (WritableStreamCloseQueuedOrInFlight(stream) === false && stream._backpressure === true) {
          defaultWriterReadyPromiseInitialize(this);
        } else {
          defaultWriterReadyPromiseInitializeAsResolved(this);
        }
        defaultWriterClosedPromiseInitialize(this);
      } else if (state === 'erroring') {
        defaultWriterReadyPromiseInitializeAsRejected(this, stream._storedError);
        this._readyPromise.catch(function () {});
        defaultWriterClosedPromiseInitialize(this);
      } else if (state === 'closed') {
        defaultWriterReadyPromiseInitializeAsResolved(this);
        defaultWriterClosedPromiseInitializeAsResolved(this);
      } else {
        assert(state === 'errored', 'state must be errored');
        var storedError = stream._storedError;
        defaultWriterReadyPromiseInitializeAsRejected(this, storedError);
        this._readyPromise.catch(function () {});
        defaultWriterClosedPromiseInitializeAsRejected(this, storedError);
        this._closedPromise.catch(function () {});
      }
    }
    _createClass(WritableStreamDefaultWriter, [{
      key: 'abort',
      value: function abort(reason) {
        if (IsWritableStreamDefaultWriter(this) === false) {
          return Promise.reject(defaultWriterBrandCheckException('abort'));
        }
        if (this._ownerWritableStream === undefined) {
          return Promise.reject(defaultWriterLockException('abort'));
        }
        return WritableStreamDefaultWriterAbort(this, reason);
      }
    }, {
      key: 'close',
      value: function close() {
        if (IsWritableStreamDefaultWriter(this) === false) {
          return Promise.reject(defaultWriterBrandCheckException('close'));
        }
        var stream = this._ownerWritableStream;
        if (stream === undefined) {
          return Promise.reject(defaultWriterLockException('close'));
        }
        if (WritableStreamCloseQueuedOrInFlight(stream) === true) {
          return Promise.reject(new TypeError('cannot close an already-closing stream'));
        }
        return WritableStreamDefaultWriterClose(this);
      }
    }, {
      key: 'releaseLock',
      value: function releaseLock() {
        if (IsWritableStreamDefaultWriter(this) === false) {
          throw defaultWriterBrandCheckException('releaseLock');
        }
        var stream = this._ownerWritableStream;
        if (stream === undefined) {
          return;
        }
        assert(stream._writer !== undefined);
        WritableStreamDefaultWriterRelease(this);
      }
    }, {
      key: 'write',
      value: function write(chunk) {
        if (IsWritableStreamDefaultWriter(this) === false) {
          return Promise.reject(defaultWriterBrandCheckException('write'));
        }
        if (this._ownerWritableStream === undefined) {
          return Promise.reject(defaultWriterLockException('write to'));
        }
        return WritableStreamDefaultWriterWrite(this, chunk);
      }
    }, {
      key: 'closed',
      get: function get() {
        if (IsWritableStreamDefaultWriter(this) === false) {
          return Promise.reject(defaultWriterBrandCheckException('closed'));
        }
        return this._closedPromise;
      }
    }, {
      key: 'desiredSize',
      get: function get() {
        if (IsWritableStreamDefaultWriter(this) === false) {
          throw defaultWriterBrandCheckException('desiredSize');
        }
        if (this._ownerWritableStream === undefined) {
          throw defaultWriterLockException('desiredSize');
        }
        return WritableStreamDefaultWriterGetDesiredSize(this);
      }
    }, {
      key: 'ready',
      get: function get() {
        if (IsWritableStreamDefaultWriter(this) === false) {
          return Promise.reject(defaultWriterBrandCheckException('ready'));
        }
        return this._readyPromise;
      }
    }]);
    return WritableStreamDefaultWriter;
  }();
  function IsWritableStreamDefaultWriter(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_ownerWritableStream')) {
      return false;
    }
    return true;
  }
  function WritableStreamDefaultWriterAbort(writer, reason) {
    var stream = writer._ownerWritableStream;
    assert(stream !== undefined);
    return WritableStreamAbort(stream, reason);
  }
  function WritableStreamDefaultWriterClose(writer) {
    var stream = writer._ownerWritableStream;
    assert(stream !== undefined);
    var state = stream._state;
    if (state === 'closed' || state === 'errored') {
      return Promise.reject(new TypeError('The stream (in ' + state + ' state) is not in the writable state and cannot be closed'));
    }
    assert(state === 'writable' || state === 'erroring');
    assert(WritableStreamCloseQueuedOrInFlight(stream) === false);
    var promise = new Promise(function (resolve, reject) {
      var closeRequest = {
        _resolve: resolve,
        _reject: reject
      };
      stream._closeRequest = closeRequest;
    });
    if (stream._backpressure === true && state === 'writable') {
      defaultWriterReadyPromiseResolve(writer);
    }
    WritableStreamDefaultControllerClose(stream._writableStreamController);
    return promise;
  }
  function WritableStreamDefaultWriterCloseWithErrorPropagation(writer) {
    var stream = writer._ownerWritableStream;
    assert(stream !== undefined);
    var state = stream._state;
    if (WritableStreamCloseQueuedOrInFlight(stream) === true || state === 'closed') {
      return Promise.resolve();
    }
    if (state === 'errored') {
      return Promise.reject(stream._storedError);
    }
    assert(state === 'writable' || state === 'erroring');
    return WritableStreamDefaultWriterClose(writer);
  }
  function WritableStreamDefaultWriterEnsureClosedPromiseRejected(writer, error) {
    if (writer._closedPromiseState === 'pending') {
      defaultWriterClosedPromiseReject(writer, error);
    } else {
      defaultWriterClosedPromiseResetToRejected(writer, error);
    }
    writer._closedPromise.catch(function () {});
  }
  function WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, error) {
    if (writer._readyPromiseState === 'pending') {
      defaultWriterReadyPromiseReject(writer, error);
    } else {
      defaultWriterReadyPromiseResetToRejected(writer, error);
    }
    writer._readyPromise.catch(function () {});
  }
  function WritableStreamDefaultWriterGetDesiredSize(writer) {
    var stream = writer._ownerWritableStream;
    var state = stream._state;
    if (state === 'errored' || state === 'erroring') {
      return null;
    }
    if (state === 'closed') {
      return 0;
    }
    return WritableStreamDefaultControllerGetDesiredSize(stream._writableStreamController);
  }
  function WritableStreamDefaultWriterRelease(writer) {
    var stream = writer._ownerWritableStream;
    assert(stream !== undefined);
    assert(stream._writer === writer);
    var releasedError = new TypeError('Writer was released and can no longer be used to monitor the stream\'s closedness');
    WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, releasedError);
    WritableStreamDefaultWriterEnsureClosedPromiseRejected(writer, releasedError);
    stream._writer = undefined;
    writer._ownerWritableStream = undefined;
  }
  function WritableStreamDefaultWriterWrite(writer, chunk) {
    var stream = writer._ownerWritableStream;
    assert(stream !== undefined);
    var controller = stream._writableStreamController;
    var chunkSize = WritableStreamDefaultControllerGetChunkSize(controller, chunk);
    if (stream !== writer._ownerWritableStream) {
      return Promise.reject(defaultWriterLockException('write to'));
    }
    var state = stream._state;
    if (state === 'errored') {
      return Promise.reject(stream._storedError);
    }
    if (WritableStreamCloseQueuedOrInFlight(stream) === true || state === 'closed') {
      return Promise.reject(new TypeError('The stream is closing or closed and cannot be written to'));
    }
    if (state === 'erroring') {
      return Promise.reject(stream._storedError);
    }
    assert(state === 'writable');
    var promise = WritableStreamAddWriteRequest(stream);
    WritableStreamDefaultControllerWrite(controller, chunk, chunkSize);
    return promise;
  }
  var WritableStreamDefaultController = function () {
    function WritableStreamDefaultController(stream, underlyingSink, size, highWaterMark) {
      _classCallCheck(this, WritableStreamDefaultController);
      if (IsWritableStream(stream) === false) {
        throw new TypeError('WritableStreamDefaultController can only be constructed with a WritableStream instance');
      }
      if (stream._writableStreamController !== undefined) {
        throw new TypeError('WritableStreamDefaultController instances can only be created by the WritableStream constructor');
      }
      this._controlledWritableStream = stream;
      this._underlyingSink = underlyingSink;
      this._queue = undefined;
      this._queueTotalSize = undefined;
      ResetQueue(this);
      this._started = false;
      var normalizedStrategy = ValidateAndNormalizeQueuingStrategy(size, highWaterMark);
      this._strategySize = normalizedStrategy.size;
      this._strategyHWM = normalizedStrategy.highWaterMark;
      var backpressure = WritableStreamDefaultControllerGetBackpressure(this);
      WritableStreamUpdateBackpressure(stream, backpressure);
    }
    _createClass(WritableStreamDefaultController, [{
      key: 'error',
      value: function error(e) {
        if (IsWritableStreamDefaultController(this) === false) {
          throw new TypeError('WritableStreamDefaultController.prototype.error can only be used on a WritableStreamDefaultController');
        }
        var state = this._controlledWritableStream._state;
        if (state !== 'writable') {
          return;
        }
        WritableStreamDefaultControllerError(this, e);
      }
    }, {
      key: '__abortSteps',
      value: function __abortSteps(reason) {
        return PromiseInvokeOrNoop(this._underlyingSink, 'abort', [reason]);
      }
    }, {
      key: '__errorSteps',
      value: function __errorSteps() {
        ResetQueue(this);
      }
    }, {
      key: '__startSteps',
      value: function __startSteps() {
        var _this = this;
        var startResult = InvokeOrNoop(this._underlyingSink, 'start', [this]);
        var stream = this._controlledWritableStream;
        Promise.resolve(startResult).then(function () {
          assert(stream._state === 'writable' || stream._state === 'erroring');
          _this._started = true;
          WritableStreamDefaultControllerAdvanceQueueIfNeeded(_this);
        }, function (r) {
          assert(stream._state === 'writable' || stream._state === 'erroring');
          _this._started = true;
          WritableStreamDealWithRejection(stream, r);
        }).catch(rethrowAssertionErrorRejection);
      }
    }]);
    return WritableStreamDefaultController;
  }();
  function WritableStreamDefaultControllerClose(controller) {
    EnqueueValueWithSize(controller, 'close', 0);
    WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
  }
  function WritableStreamDefaultControllerGetChunkSize(controller, chunk) {
    var strategySize = controller._strategySize;
    if (strategySize === undefined) {
      return 1;
    }
    try {
      return strategySize(chunk);
    } catch (chunkSizeE) {
      WritableStreamDefaultControllerErrorIfNeeded(controller, chunkSizeE);
      return 1;
    }
  }
  function WritableStreamDefaultControllerGetDesiredSize(controller) {
    return controller._strategyHWM - controller._queueTotalSize;
  }
  function WritableStreamDefaultControllerWrite(controller, chunk, chunkSize) {
    var writeRecord = { chunk: chunk };
    try {
      EnqueueValueWithSize(controller, writeRecord, chunkSize);
    } catch (enqueueE) {
      WritableStreamDefaultControllerErrorIfNeeded(controller, enqueueE);
      return;
    }
    var stream = controller._controlledWritableStream;
    if (WritableStreamCloseQueuedOrInFlight(stream) === false && stream._state === 'writable') {
      var backpressure = WritableStreamDefaultControllerGetBackpressure(controller);
      WritableStreamUpdateBackpressure(stream, backpressure);
    }
    WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
  }
  function IsWritableStreamDefaultController(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_underlyingSink')) {
      return false;
    }
    return true;
  }
  function WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller) {
    var stream = controller._controlledWritableStream;
    if (controller._started === false) {
      return;
    }
    if (stream._inFlightWriteRequest !== undefined) {
      return;
    }
    var state = stream._state;
    if (state === 'closed' || state === 'errored') {
      return;
    }
    if (state === 'erroring') {
      WritableStreamFinishErroring(stream);
      return;
    }
    if (controller._queue.length === 0) {
      return;
    }
    var writeRecord = PeekQueueValue(controller);
    if (writeRecord === 'close') {
      WritableStreamDefaultControllerProcessClose(controller);
    } else {
      WritableStreamDefaultControllerProcessWrite(controller, writeRecord.chunk);
    }
  }
  function WritableStreamDefaultControllerErrorIfNeeded(controller, error) {
    if (controller._controlledWritableStream._state === 'writable') {
      WritableStreamDefaultControllerError(controller, error);
    }
  }
  function WritableStreamDefaultControllerProcessClose(controller) {
    var stream = controller._controlledWritableStream;
    WritableStreamMarkCloseRequestInFlight(stream);
    DequeueValue(controller);
    assert(controller._queue.length === 0, 'queue must be empty once the final write record is dequeued');
    var sinkClosePromise = PromiseInvokeOrNoop(controller._underlyingSink, 'close', []);
    sinkClosePromise.then(function () {
      WritableStreamFinishInFlightClose(stream);
    }, function (reason) {
      WritableStreamFinishInFlightCloseWithError(stream, reason);
    }).catch(rethrowAssertionErrorRejection);
  }
  function WritableStreamDefaultControllerProcessWrite(controller, chunk) {
    var stream = controller._controlledWritableStream;
    WritableStreamMarkFirstWriteRequestInFlight(stream);
    var sinkWritePromise = PromiseInvokeOrNoop(controller._underlyingSink, 'write', [chunk, controller]);
    sinkWritePromise.then(function () {
      WritableStreamFinishInFlightWrite(stream);
      var state = stream._state;
      assert(state === 'writable' || state === 'erroring');
      DequeueValue(controller);
      if (WritableStreamCloseQueuedOrInFlight(stream) === false && state === 'writable') {
        var backpressure = WritableStreamDefaultControllerGetBackpressure(controller);
        WritableStreamUpdateBackpressure(stream, backpressure);
      }
      WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
    }, function (reason) {
      WritableStreamFinishInFlightWriteWithError(stream, reason);
    }).catch(rethrowAssertionErrorRejection);
  }
  function WritableStreamDefaultControllerGetBackpressure(controller) {
    var desiredSize = WritableStreamDefaultControllerGetDesiredSize(controller);
    return desiredSize <= 0;
  }
  function WritableStreamDefaultControllerError(controller, error) {
    var stream = controller._controlledWritableStream;
    assert(stream._state === 'writable');
    WritableStreamStartErroring(stream, error);
  }
  function streamBrandCheckException(name) {
    return new TypeError('WritableStream.prototype.' + name + ' can only be used on a WritableStream');
  }
  function defaultWriterBrandCheckException(name) {
    return new TypeError('WritableStreamDefaultWriter.prototype.' + name + ' can only be used on a WritableStreamDefaultWriter');
  }
  function defaultWriterLockException(name) {
    return new TypeError('Cannot ' + name + ' a stream using a released writer');
  }
  function defaultWriterClosedPromiseInitialize(writer) {
    writer._closedPromise = new Promise(function (resolve, reject) {
      writer._closedPromise_resolve = resolve;
      writer._closedPromise_reject = reject;
      writer._closedPromiseState = 'pending';
    });
  }
  function defaultWriterClosedPromiseInitializeAsRejected(writer, reason) {
    writer._closedPromise = Promise.reject(reason);
    writer._closedPromise_resolve = undefined;
    writer._closedPromise_reject = undefined;
    writer._closedPromiseState = 'rejected';
  }
  function defaultWriterClosedPromiseInitializeAsResolved(writer) {
    writer._closedPromise = Promise.resolve(undefined);
    writer._closedPromise_resolve = undefined;
    writer._closedPromise_reject = undefined;
    writer._closedPromiseState = 'resolved';
  }
  function defaultWriterClosedPromiseReject(writer, reason) {
    assert(writer._closedPromise_resolve !== undefined, 'writer._closedPromise_resolve !== undefined');
    assert(writer._closedPromise_reject !== undefined, 'writer._closedPromise_reject !== undefined');
    assert(writer._closedPromiseState === 'pending', 'writer._closedPromiseState is pending');
    writer._closedPromise_reject(reason);
    writer._closedPromise_resolve = undefined;
    writer._closedPromise_reject = undefined;
    writer._closedPromiseState = 'rejected';
  }
  function defaultWriterClosedPromiseResetToRejected(writer, reason) {
    assert(writer._closedPromise_resolve === undefined, 'writer._closedPromise_resolve === undefined');
    assert(writer._closedPromise_reject === undefined, 'writer._closedPromise_reject === undefined');
    assert(writer._closedPromiseState !== 'pending', 'writer._closedPromiseState is not pending');
    writer._closedPromise = Promise.reject(reason);
    writer._closedPromiseState = 'rejected';
  }
  function defaultWriterClosedPromiseResolve(writer) {
    assert(writer._closedPromise_resolve !== undefined, 'writer._closedPromise_resolve !== undefined');
    assert(writer._closedPromise_reject !== undefined, 'writer._closedPromise_reject !== undefined');
    assert(writer._closedPromiseState === 'pending', 'writer._closedPromiseState is pending');
    writer._closedPromise_resolve(undefined);
    writer._closedPromise_resolve = undefined;
    writer._closedPromise_reject = undefined;
    writer._closedPromiseState = 'resolved';
  }
  function defaultWriterReadyPromiseInitialize(writer) {
    writer._readyPromise = new Promise(function (resolve, reject) {
      writer._readyPromise_resolve = resolve;
      writer._readyPromise_reject = reject;
    });
    writer._readyPromiseState = 'pending';
  }
  function defaultWriterReadyPromiseInitializeAsRejected(writer, reason) {
    writer._readyPromise = Promise.reject(reason);
    writer._readyPromise_resolve = undefined;
    writer._readyPromise_reject = undefined;
    writer._readyPromiseState = 'rejected';
  }
  function defaultWriterReadyPromiseInitializeAsResolved(writer) {
    writer._readyPromise = Promise.resolve(undefined);
    writer._readyPromise_resolve = undefined;
    writer._readyPromise_reject = undefined;
    writer._readyPromiseState = 'fulfilled';
  }
  function defaultWriterReadyPromiseReject(writer, reason) {
    assert(writer._readyPromise_resolve !== undefined, 'writer._readyPromise_resolve !== undefined');
    assert(writer._readyPromise_reject !== undefined, 'writer._readyPromise_reject !== undefined');
    writer._readyPromise_reject(reason);
    writer._readyPromise_resolve = undefined;
    writer._readyPromise_reject = undefined;
    writer._readyPromiseState = 'rejected';
  }
  function defaultWriterReadyPromiseReset(writer) {
    assert(writer._readyPromise_resolve === undefined, 'writer._readyPromise_resolve === undefined');
    assert(writer._readyPromise_reject === undefined, 'writer._readyPromise_reject === undefined');
    writer._readyPromise = new Promise(function (resolve, reject) {
      writer._readyPromise_resolve = resolve;
      writer._readyPromise_reject = reject;
    });
    writer._readyPromiseState = 'pending';
  }
  function defaultWriterReadyPromiseResetToRejected(writer, reason) {
    assert(writer._readyPromise_resolve === undefined, 'writer._readyPromise_resolve === undefined');
    assert(writer._readyPromise_reject === undefined, 'writer._readyPromise_reject === undefined');
    writer._readyPromise = Promise.reject(reason);
    writer._readyPromiseState = 'rejected';
  }
  function defaultWriterReadyPromiseResolve(writer) {
    assert(writer._readyPromise_resolve !== undefined, 'writer._readyPromise_resolve !== undefined');
    assert(writer._readyPromise_reject !== undefined, 'writer._readyPromise_reject !== undefined');
    writer._readyPromise_resolve(undefined);
    writer._readyPromise_resolve = undefined;
    writer._readyPromise_reject = undefined;
    writer._readyPromiseState = 'fulfilled';
  }
}, function (module, exports, __w_pdfjs_require__) {
  "use strict";

  var _require = __w_pdfjs_require__(0),
      IsFiniteNonNegativeNumber = _require.IsFiniteNonNegativeNumber;
  var _require2 = __w_pdfjs_require__(1),
      assert = _require2.assert;
  exports.DequeueValue = function (container) {
    assert('_queue' in container && '_queueTotalSize' in container, 'Spec-level failure: DequeueValue should only be used on containers with [[queue]] and [[queueTotalSize]].');
    assert(container._queue.length > 0, 'Spec-level failure: should never dequeue from an empty queue.');
    var pair = container._queue.shift();
    container._queueTotalSize -= pair.size;
    if (container._queueTotalSize < 0) {
      container._queueTotalSize = 0;
    }
    return pair.value;
  };
  exports.EnqueueValueWithSize = function (container, value, size) {
    assert('_queue' in container && '_queueTotalSize' in container, 'Spec-level failure: EnqueueValueWithSize should only be used on containers with [[queue]] and ' + '[[queueTotalSize]].');
    size = Number(size);
    if (!IsFiniteNonNegativeNumber(size)) {
      throw new RangeError('Size must be a finite, non-NaN, non-negative number.');
    }
    container._queue.push({
      value: value,
      size: size
    });
    container._queueTotalSize += size;
  };
  exports.PeekQueueValue = function (container) {
    assert('_queue' in container && '_queueTotalSize' in container, 'Spec-level failure: PeekQueueValue should only be used on containers with [[queue]] and [[queueTotalSize]].');
    assert(container._queue.length > 0, 'Spec-level failure: should never peek at an empty queue.');
    var pair = container._queue[0];
    return pair.value;
  };
  exports.ResetQueue = function (container) {
    assert('_queue' in container && '_queueTotalSize' in container, 'Spec-level failure: ResetQueue should only be used on containers with [[queue]] and [[queueTotalSize]].');
    container._queue = [];
    container._queueTotalSize = 0;
  };
}, function (module, exports, __w_pdfjs_require__) {
  "use strict";

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var _require = __w_pdfjs_require__(0),
      ArrayBufferCopy = _require.ArrayBufferCopy,
      CreateIterResultObject = _require.CreateIterResultObject,
      IsFiniteNonNegativeNumber = _require.IsFiniteNonNegativeNumber,
      InvokeOrNoop = _require.InvokeOrNoop,
      PromiseInvokeOrNoop = _require.PromiseInvokeOrNoop,
      TransferArrayBuffer = _require.TransferArrayBuffer,
      ValidateAndNormalizeQueuingStrategy = _require.ValidateAndNormalizeQueuingStrategy,
      ValidateAndNormalizeHighWaterMark = _require.ValidateAndNormalizeHighWaterMark;
  var _require2 = __w_pdfjs_require__(0),
      createArrayFromList = _require2.createArrayFromList,
      createDataProperty = _require2.createDataProperty,
      typeIsObject = _require2.typeIsObject;
  var _require3 = __w_pdfjs_require__(1),
      assert = _require3.assert,
      rethrowAssertionErrorRejection = _require3.rethrowAssertionErrorRejection;
  var _require4 = __w_pdfjs_require__(3),
      DequeueValue = _require4.DequeueValue,
      EnqueueValueWithSize = _require4.EnqueueValueWithSize,
      ResetQueue = _require4.ResetQueue;
  var _require5 = __w_pdfjs_require__(2),
      AcquireWritableStreamDefaultWriter = _require5.AcquireWritableStreamDefaultWriter,
      IsWritableStream = _require5.IsWritableStream,
      IsWritableStreamLocked = _require5.IsWritableStreamLocked,
      WritableStreamAbort = _require5.WritableStreamAbort,
      WritableStreamDefaultWriterCloseWithErrorPropagation = _require5.WritableStreamDefaultWriterCloseWithErrorPropagation,
      WritableStreamDefaultWriterRelease = _require5.WritableStreamDefaultWriterRelease,
      WritableStreamDefaultWriterWrite = _require5.WritableStreamDefaultWriterWrite,
      WritableStreamCloseQueuedOrInFlight = _require5.WritableStreamCloseQueuedOrInFlight;
  var ReadableStream = function () {
    function ReadableStream() {
      var underlyingSource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          size = _ref.size,
          highWaterMark = _ref.highWaterMark;
      _classCallCheck(this, ReadableStream);
      this._state = 'readable';
      this._reader = undefined;
      this._storedError = undefined;
      this._disturbed = false;
      this._readableStreamController = undefined;
      var type = underlyingSource.type;
      var typeString = String(type);
      if (typeString === 'bytes') {
        if (highWaterMark === undefined) {
          highWaterMark = 0;
        }
        this._readableStreamController = new ReadableByteStreamController(this, underlyingSource, highWaterMark);
      } else if (type === undefined) {
        if (highWaterMark === undefined) {
          highWaterMark = 1;
        }
        this._readableStreamController = new ReadableStreamDefaultController(this, underlyingSource, size, highWaterMark);
      } else {
        throw new RangeError('Invalid type is specified');
      }
    }
    _createClass(ReadableStream, [{
      key: 'cancel',
      value: function cancel(reason) {
        if (IsReadableStream(this) === false) {
          return Promise.reject(streamBrandCheckException('cancel'));
        }
        if (IsReadableStreamLocked(this) === true) {
          return Promise.reject(new TypeError('Cannot cancel a stream that already has a reader'));
        }
        return ReadableStreamCancel(this, reason);
      }
    }, {
      key: 'getReader',
      value: function getReader() {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            mode = _ref2.mode;
        if (IsReadableStream(this) === false) {
          throw streamBrandCheckException('getReader');
        }
        if (mode === undefined) {
          return AcquireReadableStreamDefaultReader(this);
        }
        mode = String(mode);
        if (mode === 'byob') {
          return AcquireReadableStreamBYOBReader(this);
        }
        throw new RangeError('Invalid mode is specified');
      }
    }, {
      key: 'pipeThrough',
      value: function pipeThrough(_ref3, options) {
        var writable = _ref3.writable,
            readable = _ref3.readable;
        var promise = this.pipeTo(writable, options);
        ifIsObjectAndHasAPromiseIsHandledInternalSlotSetPromiseIsHandledToTrue(promise);
        return readable;
      }
    }, {
      key: 'pipeTo',
      value: function pipeTo(dest) {
        var _this = this;
        var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            preventClose = _ref4.preventClose,
            preventAbort = _ref4.preventAbort,
            preventCancel = _ref4.preventCancel;
        if (IsReadableStream(this) === false) {
          return Promise.reject(streamBrandCheckException('pipeTo'));
        }
        if (IsWritableStream(dest) === false) {
          return Promise.reject(new TypeError('ReadableStream.prototype.pipeTo\'s first argument must be a WritableStream'));
        }
        preventClose = Boolean(preventClose);
        preventAbort = Boolean(preventAbort);
        preventCancel = Boolean(preventCancel);
        if (IsReadableStreamLocked(this) === true) {
          return Promise.reject(new TypeError('ReadableStream.prototype.pipeTo cannot be used on a locked ReadableStream'));
        }
        if (IsWritableStreamLocked(dest) === true) {
          return Promise.reject(new TypeError('ReadableStream.prototype.pipeTo cannot be used on a locked WritableStream'));
        }
        var reader = AcquireReadableStreamDefaultReader(this);
        var writer = AcquireWritableStreamDefaultWriter(dest);
        var shuttingDown = false;
        var currentWrite = Promise.resolve();
        return new Promise(function (resolve, reject) {
          function pipeLoop() {
            currentWrite = Promise.resolve();
            if (shuttingDown === true) {
              return Promise.resolve();
            }
            return writer._readyPromise.then(function () {
              return ReadableStreamDefaultReaderRead(reader).then(function (_ref5) {
                var value = _ref5.value,
                    done = _ref5.done;
                if (done === true) {
                  return;
                }
                currentWrite = WritableStreamDefaultWriterWrite(writer, value).catch(function () {});
              });
            }).then(pipeLoop);
          }
          isOrBecomesErrored(_this, reader._closedPromise, function (storedError) {
            if (preventAbort === false) {
              shutdownWithAction(function () {
                return WritableStreamAbort(dest, storedError);
              }, true, storedError);
            } else {
              shutdown(true, storedError);
            }
          });
          isOrBecomesErrored(dest, writer._closedPromise, function (storedError) {
            if (preventCancel === false) {
              shutdownWithAction(function () {
                return ReadableStreamCancel(_this, storedError);
              }, true, storedError);
            } else {
              shutdown(true, storedError);
            }
          });
          isOrBecomesClosed(_this, reader._closedPromise, function () {
            if (preventClose === false) {
              shutdownWithAction(function () {
                return WritableStreamDefaultWriterCloseWithErrorPropagation(writer);
              });
            } else {
              shutdown();
            }
          });
          if (WritableStreamCloseQueuedOrInFlight(dest) === true || dest._state === 'closed') {
            var destClosed = new TypeError('the destination writable stream closed before all data could be piped to it');
            if (preventCancel === false) {
              shutdownWithAction(function () {
                return ReadableStreamCancel(_this, destClosed);
              }, true, destClosed);
            } else {
              shutdown(true, destClosed);
            }
          }
          pipeLoop().catch(function (err) {
            currentWrite = Promise.resolve();
            rethrowAssertionErrorRejection(err);
          });
          function waitForWritesToFinish() {
            var oldCurrentWrite = currentWrite;
            return currentWrite.then(function () {
              return oldCurrentWrite !== currentWrite ? waitForWritesToFinish() : undefined;
            });
          }
          function isOrBecomesErrored(stream, promise, action) {
            if (stream._state === 'errored') {
              action(stream._storedError);
            } else {
              promise.catch(action).catch(rethrowAssertionErrorRejection);
            }
          }
          function isOrBecomesClosed(stream, promise, action) {
            if (stream._state === 'closed') {
              action();
            } else {
              promise.then(action).catch(rethrowAssertionErrorRejection);
            }
          }
          function shutdownWithAction(action, originalIsError, originalError) {
            if (shuttingDown === true) {
              return;
            }
            shuttingDown = true;
            if (dest._state === 'writable' && WritableStreamCloseQueuedOrInFlight(dest) === false) {
              waitForWritesToFinish().then(doTheRest);
            } else {
              doTheRest();
            }
            function doTheRest() {
              action().then(function () {
                return finalize(originalIsError, originalError);
              }, function (newError) {
                return finalize(true, newError);
              }).catch(rethrowAssertionErrorRejection);
            }
          }
          function shutdown(isError, error) {
            if (shuttingDown === true) {
              return;
            }
            shuttingDown = true;
            if (dest._state === 'writable' && WritableStreamCloseQueuedOrInFlight(dest) === false) {
              waitForWritesToFinish().then(function () {
                return finalize(isError, error);
              }).catch(rethrowAssertionErrorRejection);
            } else {
              finalize(isError, error);
            }
          }
          function finalize(isError, error) {
            WritableStreamDefaultWriterRelease(writer);
            ReadableStreamReaderGenericRelease(reader);
            if (isError) {
              reject(error);
            } else {
              resolve(undefined);
            }
          }
        });
      }
    }, {
      key: 'tee',
      value: function tee() {
        if (IsReadableStream(this) === false) {
          throw streamBrandCheckException('tee');
        }
        var branches = ReadableStreamTee(this, false);
        return createArrayFromList(branches);
      }
    }, {
      key: 'locked',
      get: function get() {
        if (IsReadableStream(this) === false) {
          throw streamBrandCheckException('locked');
        }
        return IsReadableStreamLocked(this);
      }
    }]);
    return ReadableStream;
  }();
  module.exports = {
    ReadableStream: ReadableStream,
    IsReadableStreamDisturbed: IsReadableStreamDisturbed,
    ReadableStreamDefaultControllerClose: ReadableStreamDefaultControllerClose,
    ReadableStreamDefaultControllerEnqueue: ReadableStreamDefaultControllerEnqueue,
    ReadableStreamDefaultControllerError: ReadableStreamDefaultControllerError,
    ReadableStreamDefaultControllerGetDesiredSize: ReadableStreamDefaultControllerGetDesiredSize
  };
  function AcquireReadableStreamBYOBReader(stream) {
    return new ReadableStreamBYOBReader(stream);
  }
  function AcquireReadableStreamDefaultReader(stream) {
    return new ReadableStreamDefaultReader(stream);
  }
  function IsReadableStream(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_readableStreamController')) {
      return false;
    }
    return true;
  }
  function IsReadableStreamDisturbed(stream) {
    assert(IsReadableStream(stream) === true, 'IsReadableStreamDisturbed should only be used on known readable streams');
    return stream._disturbed;
  }
  function IsReadableStreamLocked(stream) {
    assert(IsReadableStream(stream) === true, 'IsReadableStreamLocked should only be used on known readable streams');
    if (stream._reader === undefined) {
      return false;
    }
    return true;
  }
  function ReadableStreamTee(stream, cloneForBranch2) {
    assert(IsReadableStream(stream) === true);
    assert(typeof cloneForBranch2 === 'boolean');
    var reader = AcquireReadableStreamDefaultReader(stream);
    var teeState = {
      closedOrErrored: false,
      canceled1: false,
      canceled2: false,
      reason1: undefined,
      reason2: undefined
    };
    teeState.promise = new Promise(function (resolve) {
      teeState._resolve = resolve;
    });
    var pull = create_ReadableStreamTeePullFunction();
    pull._reader = reader;
    pull._teeState = teeState;
    pull._cloneForBranch2 = cloneForBranch2;
    var cancel1 = create_ReadableStreamTeeBranch1CancelFunction();
    cancel1._stream = stream;
    cancel1._teeState = teeState;
    var cancel2 = create_ReadableStreamTeeBranch2CancelFunction();
    cancel2._stream = stream;
    cancel2._teeState = teeState;
    var underlyingSource1 = Object.create(Object.prototype);
    createDataProperty(underlyingSource1, 'pull', pull);
    createDataProperty(underlyingSource1, 'cancel', cancel1);
    var branch1Stream = new ReadableStream(underlyingSource1);
    var underlyingSource2 = Object.create(Object.prototype);
    createDataProperty(underlyingSource2, 'pull', pull);
    createDataProperty(underlyingSource2, 'cancel', cancel2);
    var branch2Stream = new ReadableStream(underlyingSource2);
    pull._branch1 = branch1Stream._readableStreamController;
    pull._branch2 = branch2Stream._readableStreamController;
    reader._closedPromise.catch(function (r) {
      if (teeState.closedOrErrored === true) {
        return;
      }
      ReadableStreamDefaultControllerError(pull._branch1, r);
      ReadableStreamDefaultControllerError(pull._branch2, r);
      teeState.closedOrErrored = true;
    });
    return [branch1Stream, branch2Stream];
  }
  function create_ReadableStreamTeePullFunction() {
    function f() {
      var reader = f._reader,
          branch1 = f._branch1,
          branch2 = f._branch2,
          teeState = f._teeState;
      return ReadableStreamDefaultReaderRead(reader).then(function (result) {
        assert(typeIsObject(result));
        var value = result.value;
        var done = result.done;
        assert(typeof done === 'boolean');
        if (done === true && teeState.closedOrErrored === false) {
          if (teeState.canceled1 === false) {
            ReadableStreamDefaultControllerClose(branch1);
          }
          if (teeState.canceled2 === false) {
            ReadableStreamDefaultControllerClose(branch2);
          }
          teeState.closedOrErrored = true;
        }
        if (teeState.closedOrErrored === true) {
          return;
        }
        var value1 = value;
        var value2 = value;
        if (teeState.canceled1 === false) {
          ReadableStreamDefaultControllerEnqueue(branch1, value1);
        }
        if (teeState.canceled2 === false) {
          ReadableStreamDefaultControllerEnqueue(branch2, value2);
        }
      });
    }
    return f;
  }
  function create_ReadableStreamTeeBranch1CancelFunction() {
    function f(reason) {
      var stream = f._stream,
          teeState = f._teeState;
      teeState.canceled1 = true;
      teeState.reason1 = reason;
      if (teeState.canceled2 === true) {
        var compositeReason = createArrayFromList([teeState.reason1, teeState.reason2]);
        var cancelResult = ReadableStreamCancel(stream, compositeReason);
        teeState._resolve(cancelResult);
      }
      return teeState.promise;
    }
    return f;
  }
  function create_ReadableStreamTeeBranch2CancelFunction() {
    function f(reason) {
      var stream = f._stream,
          teeState = f._teeState;
      teeState.canceled2 = true;
      teeState.reason2 = reason;
      if (teeState.canceled1 === true) {
        var compositeReason = createArrayFromList([teeState.reason1, teeState.reason2]);
        var cancelResult = ReadableStreamCancel(stream, compositeReason);
        teeState._resolve(cancelResult);
      }
      return teeState.promise;
    }
    return f;
  }
  function ReadableStreamAddReadIntoRequest(stream) {
    assert(IsReadableStreamBYOBReader(stream._reader) === true);
    assert(stream._state === 'readable' || stream._state === 'closed');
    var promise = new Promise(function (resolve, reject) {
      var readIntoRequest = {
        _resolve: resolve,
        _reject: reject
      };
      stream._reader._readIntoRequests.push(readIntoRequest);
    });
    return promise;
  }
  function ReadableStreamAddReadRequest(stream) {
    assert(IsReadableStreamDefaultReader(stream._reader) === true);
    assert(stream._state === 'readable');
    var promise = new Promise(function (resolve, reject) {
      var readRequest = {
        _resolve: resolve,
        _reject: reject
      };
      stream._reader._readRequests.push(readRequest);
    });
    return promise;
  }
  function ReadableStreamCancel(stream, reason) {
    stream._disturbed = true;
    if (stream._state === 'closed') {
      return Promise.resolve(undefined);
    }
    if (stream._state === 'errored') {
      return Promise.reject(stream._storedError);
    }
    ReadableStreamClose(stream);
    var sourceCancelPromise = stream._readableStreamController.__cancelSteps(reason);
    return sourceCancelPromise.then(function () {
      return undefined;
    });
  }
  function ReadableStreamClose(stream) {
    assert(stream._state === 'readable');
    stream._state = 'closed';
    var reader = stream._reader;
    if (reader === undefined) {
      return undefined;
    }
    if (IsReadableStreamDefaultReader(reader) === true) {
      for (var i = 0; i < reader._readRequests.length; i++) {
        var _resolve = reader._readRequests[i]._resolve;
        _resolve(CreateIterResultObject(undefined, true));
      }
      reader._readRequests = [];
    }
    defaultReaderClosedPromiseResolve(reader);
    return undefined;
  }
  function ReadableStreamError(stream, e) {
    assert(IsReadableStream(stream) === true, 'stream must be ReadableStream');
    assert(stream._state === 'readable', 'state must be readable');
    stream._state = 'errored';
    stream._storedError = e;
    var reader = stream._reader;
    if (reader === undefined) {
      return undefined;
    }
    if (IsReadableStreamDefaultReader(reader) === true) {
      for (var i = 0; i < reader._readRequests.length; i++) {
        var readRequest = reader._readRequests[i];
        readRequest._reject(e);
      }
      reader._readRequests = [];
    } else {
      assert(IsReadableStreamBYOBReader(reader), 'reader must be ReadableStreamBYOBReader');
      for (var _i = 0; _i < reader._readIntoRequests.length; _i++) {
        var readIntoRequest = reader._readIntoRequests[_i];
        readIntoRequest._reject(e);
      }
      reader._readIntoRequests = [];
    }
    defaultReaderClosedPromiseReject(reader, e);
    reader._closedPromise.catch(function () {});
  }
  function ReadableStreamFulfillReadIntoRequest(stream, chunk, done) {
    var reader = stream._reader;
    assert(reader._readIntoRequests.length > 0);
    var readIntoRequest = reader._readIntoRequests.shift();
    readIntoRequest._resolve(CreateIterResultObject(chunk, done));
  }
  function ReadableStreamFulfillReadRequest(stream, chunk, done) {
    var reader = stream._reader;
    assert(reader._readRequests.length > 0);
    var readRequest = reader._readRequests.shift();
    readRequest._resolve(CreateIterResultObject(chunk, done));
  }
  function ReadableStreamGetNumReadIntoRequests(stream) {
    return stream._reader._readIntoRequests.length;
  }
  function ReadableStreamGetNumReadRequests(stream) {
    return stream._reader._readRequests.length;
  }
  function ReadableStreamHasBYOBReader(stream) {
    var reader = stream._reader;
    if (reader === undefined) {
      return false;
    }
    if (IsReadableStreamBYOBReader(reader) === false) {
      return false;
    }
    return true;
  }
  function ReadableStreamHasDefaultReader(stream) {
    var reader = stream._reader;
    if (reader === undefined) {
      return false;
    }
    if (IsReadableStreamDefaultReader(reader) === false) {
      return false;
    }
    return true;
  }
  var ReadableStreamDefaultReader = function () {
    function ReadableStreamDefaultReader(stream) {
      _classCallCheck(this, ReadableStreamDefaultReader);
      if (IsReadableStream(stream) === false) {
        throw new TypeError('ReadableStreamDefaultReader can only be constructed with a ReadableStream instance');
      }
      if (IsReadableStreamLocked(stream) === true) {
        throw new TypeError('This stream has already been locked for exclusive reading by another reader');
      }
      ReadableStreamReaderGenericInitialize(this, stream);
      this._readRequests = [];
    }
    _createClass(ReadableStreamDefaultReader, [{
      key: 'cancel',
      value: function cancel(reason) {
        if (IsReadableStreamDefaultReader(this) === false) {
          return Promise.reject(defaultReaderBrandCheckException('cancel'));
        }
        if (this._ownerReadableStream === undefined) {
          return Promise.reject(readerLockException('cancel'));
        }
        return ReadableStreamReaderGenericCancel(this, reason);
      }
    }, {
      key: 'read',
      value: function read() {
        if (IsReadableStreamDefaultReader(this) === false) {
          return Promise.reject(defaultReaderBrandCheckException('read'));
        }
        if (this._ownerReadableStream === undefined) {
          return Promise.reject(readerLockException('read from'));
        }
        return ReadableStreamDefaultReaderRead(this);
      }
    }, {
      key: 'releaseLock',
      value: function releaseLock() {
        if (IsReadableStreamDefaultReader(this) === false) {
          throw defaultReaderBrandCheckException('releaseLock');
        }
        if (this._ownerReadableStream === undefined) {
          return;
        }
        if (this._readRequests.length > 0) {
          throw new TypeError('Tried to release a reader lock when that reader has pending read() calls un-settled');
        }
        ReadableStreamReaderGenericRelease(this);
      }
    }, {
      key: 'closed',
      get: function get() {
        if (IsReadableStreamDefaultReader(this) === false) {
          return Promise.reject(defaultReaderBrandCheckException('closed'));
        }
        return this._closedPromise;
      }
    }]);
    return ReadableStreamDefaultReader;
  }();
  var ReadableStreamBYOBReader = function () {
    function ReadableStreamBYOBReader(stream) {
      _classCallCheck(this, ReadableStreamBYOBReader);
      if (!IsReadableStream(stream)) {
        throw new TypeError('ReadableStreamBYOBReader can only be constructed with a ReadableStream instance given a ' + 'byte source');
      }
      if (IsReadableByteStreamController(stream._readableStreamController) === false) {
        throw new TypeError('Cannot construct a ReadableStreamBYOBReader for a stream not constructed with a byte ' + 'source');
      }
      if (IsReadableStreamLocked(stream)) {
        throw new TypeError('This stream has already been locked for exclusive reading by another reader');
      }
      ReadableStreamReaderGenericInitialize(this, stream);
      this._readIntoRequests = [];
    }
    _createClass(ReadableStreamBYOBReader, [{
      key: 'cancel',
      value: function cancel(reason) {
        if (!IsReadableStreamBYOBReader(this)) {
          return Promise.reject(byobReaderBrandCheckException('cancel'));
        }
        if (this._ownerReadableStream === undefined) {
          return Promise.reject(readerLockException('cancel'));
        }
        return ReadableStreamReaderGenericCancel(this, reason);
      }
    }, {
      key: 'read',
      value: function read(view) {
        if (!IsReadableStreamBYOBReader(this)) {
          return Promise.reject(byobReaderBrandCheckException('read'));
        }
        if (this._ownerReadableStream === undefined) {
          return Promise.reject(readerLockException('read from'));
        }
        if (!ArrayBuffer.isView(view)) {
          return Promise.reject(new TypeError('view must be an array buffer view'));
        }
        if (view.byteLength === 0) {
          return Promise.reject(new TypeError('view must have non-zero byteLength'));
        }
        return ReadableStreamBYOBReaderRead(this, view);
      }
    }, {
      key: 'releaseLock',
      value: function releaseLock() {
        if (!IsReadableStreamBYOBReader(this)) {
          throw byobReaderBrandCheckException('releaseLock');
        }
        if (this._ownerReadableStream === undefined) {
          return;
        }
        if (this._readIntoRequests.length > 0) {
          throw new TypeError('Tried to release a reader lock when that reader has pending read() calls un-settled');
        }
        ReadableStreamReaderGenericRelease(this);
      }
    }, {
      key: 'closed',
      get: function get() {
        if (!IsReadableStreamBYOBReader(this)) {
          return Promise.reject(byobReaderBrandCheckException('closed'));
        }
        return this._closedPromise;
      }
    }]);
    return ReadableStreamBYOBReader;
  }();
  function IsReadableStreamBYOBReader(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_readIntoRequests')) {
      return false;
    }
    return true;
  }
  function IsReadableStreamDefaultReader(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_readRequests')) {
      return false;
    }
    return true;
  }
  function ReadableStreamReaderGenericInitialize(reader, stream) {
    reader._ownerReadableStream = stream;
    stream._reader = reader;
    if (stream._state === 'readable') {
      defaultReaderClosedPromiseInitialize(reader);
    } else if (stream._state === 'closed') {
      defaultReaderClosedPromiseInitializeAsResolved(reader);
    } else {
      assert(stream._state === 'errored', 'state must be errored');
      defaultReaderClosedPromiseInitializeAsRejected(reader, stream._storedError);
      reader._closedPromise.catch(function () {});
    }
  }
  function ReadableStreamReaderGenericCancel(reader, reason) {
    var stream = reader._ownerReadableStream;
    assert(stream !== undefined);
    return ReadableStreamCancel(stream, reason);
  }
  function ReadableStreamReaderGenericRelease(reader) {
    assert(reader._ownerReadableStream !== undefined);
    assert(reader._ownerReadableStream._reader === reader);
    if (reader._ownerReadableStream._state === 'readable') {
      defaultReaderClosedPromiseReject(reader, new TypeError('Reader was released and can no longer be used to monitor the stream\'s closedness'));
    } else {
      defaultReaderClosedPromiseResetToRejected(reader, new TypeError('Reader was released and can no longer be used to monitor the stream\'s closedness'));
    }
    reader._closedPromise.catch(function () {});
    reader._ownerReadableStream._reader = undefined;
    reader._ownerReadableStream = undefined;
  }
  function ReadableStreamBYOBReaderRead(reader, view) {
    var stream = reader._ownerReadableStream;
    assert(stream !== undefined);
    stream._disturbed = true;
    if (stream._state === 'errored') {
      return Promise.reject(stream._storedError);
    }
    return ReadableByteStreamControllerPullInto(stream._readableStreamController, view);
  }
  function ReadableStreamDefaultReaderRead(reader) {
    var stream = reader._ownerReadableStream;
    assert(stream !== undefined);
    stream._disturbed = true;
    if (stream._state === 'closed') {
      return Promise.resolve(CreateIterResultObject(undefined, true));
    }
    if (stream._state === 'errored') {
      return Promise.reject(stream._storedError);
    }
    assert(stream._state === 'readable');
    return stream._readableStreamController.__pullSteps();
  }
  var ReadableStreamDefaultController = function () {
    function ReadableStreamDefaultController(stream, underlyingSource, size, highWaterMark) {
      _classCallCheck(this, ReadableStreamDefaultController);
      if (IsReadableStream(stream) === false) {
        throw new TypeError('ReadableStreamDefaultController can only be constructed with a ReadableStream instance');
      }
      if (stream._readableStreamController !== undefined) {
        throw new TypeError('ReadableStreamDefaultController instances can only be created by the ReadableStream constructor');
      }
      this._controlledReadableStream = stream;
      this._underlyingSource = underlyingSource;
      this._queue = undefined;
      this._queueTotalSize = undefined;
      ResetQueue(this);
      this._started = false;
      this._closeRequested = false;
      this._pullAgain = false;
      this._pulling = false;
      var normalizedStrategy = ValidateAndNormalizeQueuingStrategy(size, highWaterMark);
      this._strategySize = normalizedStrategy.size;
      this._strategyHWM = normalizedStrategy.highWaterMark;
      var controller = this;
      var startResult = InvokeOrNoop(underlyingSource, 'start', [this]);
      Promise.resolve(startResult).then(function () {
        controller._started = true;
        assert(controller._pulling === false);
        assert(controller._pullAgain === false);
        ReadableStreamDefaultControllerCallPullIfNeeded(controller);
      }, function (r) {
        ReadableStreamDefaultControllerErrorIfNeeded(controller, r);
      }).catch(rethrowAssertionErrorRejection);
    }
    _createClass(ReadableStreamDefaultController, [{
      key: 'close',
      value: function close() {
        if (IsReadableStreamDefaultController(this) === false) {
          throw defaultControllerBrandCheckException('close');
        }
        if (this._closeRequested === true) {
          throw new TypeError('The stream has already been closed; do not close it again!');
        }
        var state = this._controlledReadableStream._state;
        if (state !== 'readable') {
          throw new TypeError('The stream (in ' + state + ' state) is not in the readable state and cannot be closed');
        }
        ReadableStreamDefaultControllerClose(this);
      }
    }, {
      key: 'enqueue',
      value: function enqueue(chunk) {
        if (IsReadableStreamDefaultController(this) === false) {
          throw defaultControllerBrandCheckException('enqueue');
        }
        if (this._closeRequested === true) {
          throw new TypeError('stream is closed or draining');
        }
        var state = this._controlledReadableStream._state;
        if (state !== 'readable') {
          throw new TypeError('The stream (in ' + state + ' state) is not in the readable state and cannot be enqueued to');
        }
        return ReadableStreamDefaultControllerEnqueue(this, chunk);
      }
    }, {
      key: 'error',
      value: function error(e) {
        if (IsReadableStreamDefaultController(this) === false) {
          throw defaultControllerBrandCheckException('error');
        }
        var stream = this._controlledReadableStream;
        if (stream._state !== 'readable') {
          throw new TypeError('The stream is ' + stream._state + ' and so cannot be errored');
        }
        ReadableStreamDefaultControllerError(this, e);
      }
    }, {
      key: '__cancelSteps',
      value: function __cancelSteps(reason) {
        ResetQueue(this);
        return PromiseInvokeOrNoop(this._underlyingSource, 'cancel', [reason]);
      }
    }, {
      key: '__pullSteps',
      value: function __pullSteps() {
        var stream = this._controlledReadableStream;
        if (this._queue.length > 0) {
          var chunk = DequeueValue(this);
          if (this._closeRequested === true && this._queue.length === 0) {
            ReadableStreamClose(stream);
          } else {
            ReadableStreamDefaultControllerCallPullIfNeeded(this);
          }
          return Promise.resolve(CreateIterResultObject(chunk, false));
        }
        var pendingPromise = ReadableStreamAddReadRequest(stream);
        ReadableStreamDefaultControllerCallPullIfNeeded(this);
        return pendingPromise;
      }
    }, {
      key: 'desiredSize',
      get: function get() {
        if (IsReadableStreamDefaultController(this) === false) {
          throw defaultControllerBrandCheckException('desiredSize');
        }
        return ReadableStreamDefaultControllerGetDesiredSize(this);
      }
    }]);
    return ReadableStreamDefaultController;
  }();
  function IsReadableStreamDefaultController(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_underlyingSource')) {
      return false;
    }
    return true;
  }
  function ReadableStreamDefaultControllerCallPullIfNeeded(controller) {
    var shouldPull = ReadableStreamDefaultControllerShouldCallPull(controller);
    if (shouldPull === false) {
      return undefined;
    }
    if (controller._pulling === true) {
      controller._pullAgain = true;
      return undefined;
    }
    assert(controller._pullAgain === false);
    controller._pulling = true;
    var pullPromise = PromiseInvokeOrNoop(controller._underlyingSource, 'pull', [controller]);
    pullPromise.then(function () {
      controller._pulling = false;
      if (controller._pullAgain === true) {
        controller._pullAgain = false;
        return ReadableStreamDefaultControllerCallPullIfNeeded(controller);
      }
      return undefined;
    }, function (e) {
      ReadableStreamDefaultControllerErrorIfNeeded(controller, e);
    }).catch(rethrowAssertionErrorRejection);
    return undefined;
  }
  function ReadableStreamDefaultControllerShouldCallPull(controller) {
    var stream = controller._controlledReadableStream;
    if (stream._state === 'closed' || stream._state === 'errored') {
      return false;
    }
    if (controller._closeRequested === true) {
      return false;
    }
    if (controller._started === false) {
      return false;
    }
    if (IsReadableStreamLocked(stream) === true && ReadableStreamGetNumReadRequests(stream) > 0) {
      return true;
    }
    var desiredSize = ReadableStreamDefaultControllerGetDesiredSize(controller);
    if (desiredSize > 0) {
      return true;
    }
    return false;
  }
  function ReadableStreamDefaultControllerClose(controller) {
    var stream = controller._controlledReadableStream;
    assert(controller._closeRequested === false);
    assert(stream._state === 'readable');
    controller._closeRequested = true;
    if (controller._queue.length === 0) {
      ReadableStreamClose(stream);
    }
  }
  function ReadableStreamDefaultControllerEnqueue(controller, chunk) {
    var stream = controller._controlledReadableStream;
    assert(controller._closeRequested === false);
    assert(stream._state === 'readable');
    if (IsReadableStreamLocked(stream) === true && ReadableStreamGetNumReadRequests(stream) > 0) {
      ReadableStreamFulfillReadRequest(stream, chunk, false);
    } else {
      var chunkSize = 1;
      if (controller._strategySize !== undefined) {
        var strategySize = controller._strategySize;
        try {
          chunkSize = strategySize(chunk);
        } catch (chunkSizeE) {
          ReadableStreamDefaultControllerErrorIfNeeded(controller, chunkSizeE);
          throw chunkSizeE;
        }
      }
      try {
        EnqueueValueWithSize(controller, chunk, chunkSize);
      } catch (enqueueE) {
        ReadableStreamDefaultControllerErrorIfNeeded(controller, enqueueE);
        throw enqueueE;
      }
    }
    ReadableStreamDefaultControllerCallPullIfNeeded(controller);
    return undefined;
  }
  function ReadableStreamDefaultControllerError(controller, e) {
    var stream = controller._controlledReadableStream;
    assert(stream._state === 'readable');
    ResetQueue(controller);
    ReadableStreamError(stream, e);
  }
  function ReadableStreamDefaultControllerErrorIfNeeded(controller, e) {
    if (controller._controlledReadableStream._state === 'readable') {
      ReadableStreamDefaultControllerError(controller, e);
    }
  }
  function ReadableStreamDefaultControllerGetDesiredSize(controller) {
    var stream = controller._controlledReadableStream;
    var state = stream._state;
    if (state === 'errored') {
      return null;
    }
    if (state === 'closed') {
      return 0;
    }
    return controller._strategyHWM - controller._queueTotalSize;
  }
  var ReadableStreamBYOBRequest = function () {
    function ReadableStreamBYOBRequest(controller, view) {
      _classCallCheck(this, ReadableStreamBYOBRequest);
      this._associatedReadableByteStreamController = controller;
      this._view = view;
    }
    _createClass(ReadableStreamBYOBRequest, [{
      key: 'respond',
      value: function respond(bytesWritten) {
        if (IsReadableStreamBYOBRequest(this) === false) {
          throw byobRequestBrandCheckException('respond');
        }
        if (this._associatedReadableByteStreamController === undefined) {
          throw new TypeError('This BYOB request has been invalidated');
        }
        ReadableByteStreamControllerRespond(this._associatedReadableByteStreamController, bytesWritten);
      }
    }, {
      key: 'respondWithNewView',
      value: function respondWithNewView(view) {
        if (IsReadableStreamBYOBRequest(this) === false) {
          throw byobRequestBrandCheckException('respond');
        }
        if (this._associatedReadableByteStreamController === undefined) {
          throw new TypeError('This BYOB request has been invalidated');
        }
        if (!ArrayBuffer.isView(view)) {
          throw new TypeError('You can only respond with array buffer views');
        }
        ReadableByteStreamControllerRespondWithNewView(this._associatedReadableByteStreamController, view);
      }
    }, {
      key: 'view',
      get: function get() {
        return this._view;
      }
    }]);
    return ReadableStreamBYOBRequest;
  }();
  var ReadableByteStreamController = function () {
    function ReadableByteStreamController(stream, underlyingByteSource, highWaterMark) {
      _classCallCheck(this, ReadableByteStreamController);
      if (IsReadableStream(stream) === false) {
        throw new TypeError('ReadableByteStreamController can only be constructed with a ReadableStream instance given ' + 'a byte source');
      }
      if (stream._readableStreamController !== undefined) {
        throw new TypeError('ReadableByteStreamController instances can only be created by the ReadableStream constructor given a byte ' + 'source');
      }
      this._controlledReadableStream = stream;
      this._underlyingByteSource = underlyingByteSource;
      this._pullAgain = false;
      this._pulling = false;
      ReadableByteStreamControllerClearPendingPullIntos(this);
      this._queue = this._queueTotalSize = undefined;
      ResetQueue(this);
      this._closeRequested = false;
      this._started = false;
      this._strategyHWM = ValidateAndNormalizeHighWaterMark(highWaterMark);
      var autoAllocateChunkSize = underlyingByteSource.autoAllocateChunkSize;
      if (autoAllocateChunkSize !== undefined) {
        if (Number.isInteger(autoAllocateChunkSize) === false || autoAllocateChunkSize <= 0) {
          throw new RangeError('autoAllocateChunkSize must be a positive integer');
        }
      }
      this._autoAllocateChunkSize = autoAllocateChunkSize;
      this._pendingPullIntos = [];
      var controller = this;
      var startResult = InvokeOrNoop(underlyingByteSource, 'start', [this]);
      Promise.resolve(startResult).then(function () {
        controller._started = true;
        assert(controller._pulling === false);
        assert(controller._pullAgain === false);
        ReadableByteStreamControllerCallPullIfNeeded(controller);
      }, function (r) {
        if (stream._state === 'readable') {
          ReadableByteStreamControllerError(controller, r);
        }
      }).catch(rethrowAssertionErrorRejection);
    }
    _createClass(ReadableByteStreamController, [{
      key: 'close',
      value: function close() {
        if (IsReadableByteStreamController(this) === false) {
          throw byteStreamControllerBrandCheckException('close');
        }
        if (this._closeRequested === true) {
          throw new TypeError('The stream has already been closed; do not close it again!');
        }
        var state = this._controlledReadableStream._state;
        if (state !== 'readable') {
          throw new TypeError('The stream (in ' + state + ' state) is not in the readable state and cannot be closed');
        }
        ReadableByteStreamControllerClose(this);
      }
    }, {
      key: 'enqueue',
      value: function enqueue(chunk) {
        if (IsReadableByteStreamController(this) === false) {
          throw byteStreamControllerBrandCheckException('enqueue');
        }
        if (this._closeRequested === true) {
          throw new TypeError('stream is closed or draining');
        }
        var state = this._controlledReadableStream._state;
        if (state !== 'readable') {
          throw new TypeError('The stream (in ' + state + ' state) is not in the readable state and cannot be enqueued to');
        }
        if (!ArrayBuffer.isView(chunk)) {
          throw new TypeError('You can only enqueue array buffer views when using a ReadableByteStreamController');
        }
        ReadableByteStreamControllerEnqueue(this, chunk);
      }
    }, {
      key: 'error',
      value: function error(e) {
        if (IsReadableByteStreamController(this) === false) {
          throw byteStreamControllerBrandCheckException('error');
        }
        var stream = this._controlledReadableStream;
        if (stream._state !== 'readable') {
          throw new TypeError('The stream is ' + stream._state + ' and so cannot be errored');
        }
        ReadableByteStreamControllerError(this, e);
      }
    }, {
      key: '__cancelSteps',
      value: function __cancelSteps(reason) {
        if (this._pendingPullIntos.length > 0) {
          var firstDescriptor = this._pendingPullIntos[0];
          firstDescriptor.bytesFilled = 0;
        }
        ResetQueue(this);
        return PromiseInvokeOrNoop(this._underlyingByteSource, 'cancel', [reason]);
      }
    }, {
      key: '__pullSteps',
      value: function __pullSteps() {
        var stream = this._controlledReadableStream;
        assert(ReadableStreamHasDefaultReader(stream) === true);
        if (this._queueTotalSize > 0) {
          assert(ReadableStreamGetNumReadRequests(stream) === 0);
          var entry = this._queue.shift();
          this._queueTotalSize -= entry.byteLength;
          ReadableByteStreamControllerHandleQueueDrain(this);
          var view = void 0;
          try {
            view = new Uint8Array(entry.buffer, entry.byteOffset, entry.byteLength);
          } catch (viewE) {
            return Promise.reject(viewE);
          }
          return Promise.resolve(CreateIterResultObject(view, false));
        }
        var autoAllocateChunkSize = this._autoAllocateChunkSize;
        if (autoAllocateChunkSize !== undefined) {
          var buffer = void 0;
          try {
            buffer = new ArrayBuffer(autoAllocateChunkSize);
          } catch (bufferE) {
            return Promise.reject(bufferE);
          }
          var pullIntoDescriptor = {
            buffer: buffer,
            byteOffset: 0,
            byteLength: autoAllocateChunkSize,
            bytesFilled: 0,
            elementSize: 1,
            ctor: Uint8Array,
            readerType: 'default'
          };
          this._pendingPullIntos.push(pullIntoDescriptor);
        }
        var promise = ReadableStreamAddReadRequest(stream);
        ReadableByteStreamControllerCallPullIfNeeded(this);
        return promise;
      }
    }, {
      key: 'byobRequest',
      get: function get() {
        if (IsReadableByteStreamController(this) === false) {
          throw byteStreamControllerBrandCheckException('byobRequest');
        }
        if (this._byobRequest === undefined && this._pendingPullIntos.length > 0) {
          var firstDescriptor = this._pendingPullIntos[0];
          var view = new Uint8Array(firstDescriptor.buffer, firstDescriptor.byteOffset + firstDescriptor.bytesFilled, firstDescriptor.byteLength - firstDescriptor.bytesFilled);
          this._byobRequest = new ReadableStreamBYOBRequest(this, view);
        }
        return this._byobRequest;
      }
    }, {
      key: 'desiredSize',
      get: function get() {
        if (IsReadableByteStreamController(this) === false) {
          throw byteStreamControllerBrandCheckException('desiredSize');
        }
        return ReadableByteStreamControllerGetDesiredSize(this);
      }
    }]);
    return ReadableByteStreamController;
  }();
  function IsReadableByteStreamController(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_underlyingByteSource')) {
      return false;
    }
    return true;
  }
  function IsReadableStreamBYOBRequest(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_associatedReadableByteStreamController')) {
      return false;
    }
    return true;
  }
  function ReadableByteStreamControllerCallPullIfNeeded(controller) {
    var shouldPull = ReadableByteStreamControllerShouldCallPull(controller);
    if (shouldPull === false) {
      return undefined;
    }
    if (controller._pulling === true) {
      controller._pullAgain = true;
      return undefined;
    }
    assert(controller._pullAgain === false);
    controller._pulling = true;
    var pullPromise = PromiseInvokeOrNoop(controller._underlyingByteSource, 'pull', [controller]);
    pullPromise.then(function () {
      controller._pulling = false;
      if (controller._pullAgain === true) {
        controller._pullAgain = false;
        ReadableByteStreamControllerCallPullIfNeeded(controller);
      }
    }, function (e) {
      if (controller._controlledReadableStream._state === 'readable') {
        ReadableByteStreamControllerError(controller, e);
      }
    }).catch(rethrowAssertionErrorRejection);
    return undefined;
  }
  function ReadableByteStreamControllerClearPendingPullIntos(controller) {
    ReadableByteStreamControllerInvalidateBYOBRequest(controller);
    controller._pendingPullIntos = [];
  }
  function ReadableByteStreamControllerCommitPullIntoDescriptor(stream, pullIntoDescriptor) {
    assert(stream._state !== 'errored', 'state must not be errored');
    var done = false;
    if (stream._state === 'closed') {
      assert(pullIntoDescriptor.bytesFilled === 0);
      done = true;
    }
    var filledView = ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor);
    if (pullIntoDescriptor.readerType === 'default') {
      ReadableStreamFulfillReadRequest(stream, filledView, done);
    } else {
      assert(pullIntoDescriptor.readerType === 'byob');
      ReadableStreamFulfillReadIntoRequest(stream, filledView, done);
    }
  }
  function ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor) {
    var bytesFilled = pullIntoDescriptor.bytesFilled;
    var elementSize = pullIntoDescriptor.elementSize;
    assert(bytesFilled <= pullIntoDescriptor.byteLength);
    assert(bytesFilled % elementSize === 0);
    return new pullIntoDescriptor.ctor(pullIntoDescriptor.buffer, pullIntoDescriptor.byteOffset, bytesFilled / elementSize);
  }
  function ReadableByteStreamControllerEnqueueChunkToQueue(controller, buffer, byteOffset, byteLength) {
    controller._queue.push({
      buffer: buffer,
      byteOffset: byteOffset,
      byteLength: byteLength
    });
    controller._queueTotalSize += byteLength;
  }
  function ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor) {
    var elementSize = pullIntoDescriptor.elementSize;
    var currentAlignedBytes = pullIntoDescriptor.bytesFilled - pullIntoDescriptor.bytesFilled % elementSize;
    var maxBytesToCopy = Math.min(controller._queueTotalSize, pullIntoDescriptor.byteLength - pullIntoDescriptor.bytesFilled);
    var maxBytesFilled = pullIntoDescriptor.bytesFilled + maxBytesToCopy;
    var maxAlignedBytes = maxBytesFilled - maxBytesFilled % elementSize;
    var totalBytesToCopyRemaining = maxBytesToCopy;
    var ready = false;
    if (maxAlignedBytes > currentAlignedBytes) {
      totalBytesToCopyRemaining = maxAlignedBytes - pullIntoDescriptor.bytesFilled;
      ready = true;
    }
    var queue = controller._queue;
    while (totalBytesToCopyRemaining > 0) {
      var headOfQueue = queue[0];
      var bytesToCopy = Math.min(totalBytesToCopyRemaining, headOfQueue.byteLength);
      var destStart = pullIntoDescriptor.byteOffset + pullIntoDescriptor.bytesFilled;
      ArrayBufferCopy(pullIntoDescriptor.buffer, destStart, headOfQueue.buffer, headOfQueue.byteOffset, bytesToCopy);
      if (headOfQueue.byteLength === bytesToCopy) {
        queue.shift();
      } else {
        headOfQueue.byteOffset += bytesToCopy;
        headOfQueue.byteLength -= bytesToCopy;
      }
      controller._queueTotalSize -= bytesToCopy;
      ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, bytesToCopy, pullIntoDescriptor);
      totalBytesToCopyRemaining -= bytesToCopy;
    }
    if (ready === false) {
      assert(controller._queueTotalSize === 0, 'queue must be empty');
      assert(pullIntoDescriptor.bytesFilled > 0);
      assert(pullIntoDescriptor.bytesFilled < pullIntoDescriptor.elementSize);
    }
    return ready;
  }
  function ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, size, pullIntoDescriptor) {
    assert(controller._pendingPullIntos.length === 0 || controller._pendingPullIntos[0] === pullIntoDescriptor);
    ReadableByteStreamControllerInvalidateBYOBRequest(controller);
    pullIntoDescriptor.bytesFilled += size;
  }
  function ReadableByteStreamControllerHandleQueueDrain(controller) {
    assert(controller._controlledReadableStream._state === 'readable');
    if (controller._queueTotalSize === 0 && controller._closeRequested === true) {
      ReadableStreamClose(controller._controlledReadableStream);
    } else {
      ReadableByteStreamControllerCallPullIfNeeded(controller);
    }
  }
  function ReadableByteStreamControllerInvalidateBYOBRequest(controller) {
    if (controller._byobRequest === undefined) {
      return;
    }
    controller._byobRequest._associatedReadableByteStreamController = undefined;
    controller._byobRequest._view = undefined;
    controller._byobRequest = undefined;
  }
  function ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller) {
    assert(controller._closeRequested === false);
    while (controller._pendingPullIntos.length > 0) {
      if (controller._queueTotalSize === 0) {
        return;
      }
      var pullIntoDescriptor = controller._pendingPullIntos[0];
      if (ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor) === true) {
        ReadableByteStreamControllerShiftPendingPullInto(controller);
        ReadableByteStreamControllerCommitPullIntoDescriptor(controller._controlledReadableStream, pullIntoDescriptor);
      }
    }
  }
  function ReadableByteStreamControllerPullInto(controller, view) {
    var stream = controller._controlledReadableStream;
    var elementSize = 1;
    if (view.constructor !== DataView) {
      elementSize = view.constructor.BYTES_PER_ELEMENT;
    }
    var ctor = view.constructor;
    var pullIntoDescriptor = {
      buffer: view.buffer,
      byteOffset: view.byteOffset,
      byteLength: view.byteLength,
      bytesFilled: 0,
      elementSize: elementSize,
      ctor: ctor,
      readerType: 'byob'
    };
    if (controller._pendingPullIntos.length > 0) {
      pullIntoDescriptor.buffer = TransferArrayBuffer(pullIntoDescriptor.buffer);
      controller._pendingPullIntos.push(pullIntoDescriptor);
      return ReadableStreamAddReadIntoRequest(stream);
    }
    if (stream._state === 'closed') {
      var emptyView = new view.constructor(pullIntoDescriptor.buffer, pullIntoDescriptor.byteOffset, 0);
      return Promise.resolve(CreateIterResultObject(emptyView, true));
    }
    if (controller._queueTotalSize > 0) {
      if (ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor) === true) {
        var filledView = ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor);
        ReadableByteStreamControllerHandleQueueDrain(controller);
        return Promise.resolve(CreateIterResultObject(filledView, false));
      }
      if (controller._closeRequested === true) {
        var e = new TypeError('Insufficient bytes to fill elements in the given buffer');
        ReadableByteStreamControllerError(controller, e);
        return Promise.reject(e);
      }
    }
    pullIntoDescriptor.buffer = TransferArrayBuffer(pullIntoDescriptor.buffer);
    controller._pendingPullIntos.push(pullIntoDescriptor);
    var promise = ReadableStreamAddReadIntoRequest(stream);
    ReadableByteStreamControllerCallPullIfNeeded(controller);
    return promise;
  }
  function ReadableByteStreamControllerRespondInClosedState(controller, firstDescriptor) {
    firstDescriptor.buffer = TransferArrayBuffer(firstDescriptor.buffer);
    assert(firstDescriptor.bytesFilled === 0, 'bytesFilled must be 0');
    var stream = controller._controlledReadableStream;
    if (ReadableStreamHasBYOBReader(stream) === true) {
      while (ReadableStreamGetNumReadIntoRequests(stream) > 0) {
        var pullIntoDescriptor = ReadableByteStreamControllerShiftPendingPullInto(controller);
        ReadableByteStreamControllerCommitPullIntoDescriptor(stream, pullIntoDescriptor);
      }
    }
  }
  function ReadableByteStreamControllerRespondInReadableState(controller, bytesWritten, pullIntoDescriptor) {
    if (pullIntoDescriptor.bytesFilled + bytesWritten > pullIntoDescriptor.byteLength) {
      throw new RangeError('bytesWritten out of range');
    }
    ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, bytesWritten, pullIntoDescriptor);
    if (pullIntoDescriptor.bytesFilled < pullIntoDescriptor.elementSize) {
      return;
    }
    ReadableByteStreamControllerShiftPendingPullInto(controller);
    var remainderSize = pullIntoDescriptor.bytesFilled % pullIntoDescriptor.elementSize;
    if (remainderSize > 0) {
      var end = pullIntoDescriptor.byteOffset + pullIntoDescriptor.bytesFilled;
      var remainder = pullIntoDescriptor.buffer.slice(end - remainderSize, end);
      ReadableByteStreamControllerEnqueueChunkToQueue(controller, remainder, 0, remainder.byteLength);
    }
    pullIntoDescriptor.buffer = TransferArrayBuffer(pullIntoDescriptor.buffer);
    pullIntoDescriptor.bytesFilled -= remainderSize;
    ReadableByteStreamControllerCommitPullIntoDescriptor(controller._controlledReadableStream, pullIntoDescriptor);
    ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller);
  }
  function ReadableByteStreamControllerRespondInternal(controller, bytesWritten) {
    var firstDescriptor = controller._pendingPullIntos[0];
    var stream = controller._controlledReadableStream;
    if (stream._state === 'closed') {
      if (bytesWritten !== 0) {
        throw new TypeError('bytesWritten must be 0 when calling respond() on a closed stream');
      }
      ReadableByteStreamControllerRespondInClosedState(controller, firstDescriptor);
    } else {
      assert(stream._state === 'readable');
      ReadableByteStreamControllerRespondInReadableState(controller, bytesWritten, firstDescriptor);
    }
  }
  function ReadableByteStreamControllerShiftPendingPullInto(controller) {
    var descriptor = controller._pendingPullIntos.shift();
    ReadableByteStreamControllerInvalidateBYOBRequest(controller);
    return descriptor;
  }
  function ReadableByteStreamControllerShouldCallPull(controller) {
    var stream = controller._controlledReadableStream;
    if (stream._state !== 'readable') {
      return false;
    }
    if (controller._closeRequested === true) {
      return false;
    }
    if (controller._started === false) {
      return false;
    }
    if (ReadableStreamHasDefaultReader(stream) === true && ReadableStreamGetNumReadRequests(stream) > 0) {
      return true;
    }
    if (ReadableStreamHasBYOBReader(stream) === true && ReadableStreamGetNumReadIntoRequests(stream) > 0) {
      return true;
    }
    if (ReadableByteStreamControllerGetDesiredSize(controller) > 0) {
      return true;
    }
    return false;
  }
  function ReadableByteStreamControllerClose(controller) {
    var stream = controller._controlledReadableStream;
    assert(controller._closeRequested === false);
    assert(stream._state === 'readable');
    if (controller._queueTotalSize > 0) {
      controller._closeRequested = true;
      return;
    }
    if (controller._pendingPullIntos.length > 0) {
      var firstPendingPullInto = controller._pendingPullIntos[0];
      if (firstPendingPullInto.bytesFilled > 0) {
        var e = new TypeError('Insufficient bytes to fill elements in the given buffer');
        ReadableByteStreamControllerError(controller, e);
        throw e;
      }
    }
    ReadableStreamClose(stream);
  }
  function ReadableByteStreamControllerEnqueue(controller, chunk) {
    var stream = controller._controlledReadableStream;
    assert(controller._closeRequested === false);
    assert(stream._state === 'readable');
    var buffer = chunk.buffer;
    var byteOffset = chunk.byteOffset;
    var byteLength = chunk.byteLength;
    var transferredBuffer = TransferArrayBuffer(buffer);
    if (ReadableStreamHasDefaultReader(stream) === true) {
      if (ReadableStreamGetNumReadRequests(stream) === 0) {
        ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength);
      } else {
        assert(controller._queue.length === 0);
        var transferredView = new Uint8Array(transferredBuffer, byteOffset, byteLength);
        ReadableStreamFulfillReadRequest(stream, transferredView, false);
      }
    } else if (ReadableStreamHasBYOBReader(stream) === true) {
      ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength);
      ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller);
    } else {
      assert(IsReadableStreamLocked(stream) === false, 'stream must not be locked');
      ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength);
    }
  }
  function ReadableByteStreamControllerError(controller, e) {
    var stream = controller._controlledReadableStream;
    assert(stream._state === 'readable');
    ReadableByteStreamControllerClearPendingPullIntos(controller);
    ResetQueue(controller);
    ReadableStreamError(stream, e);
  }
  function ReadableByteStreamControllerGetDesiredSize(controller) {
    var stream = controller._controlledReadableStream;
    var state = stream._state;
    if (state === 'errored') {
      return null;
    }
    if (state === 'closed') {
      return 0;
    }
    return controller._strategyHWM - controller._queueTotalSize;
  }
  function ReadableByteStreamControllerRespond(controller, bytesWritten) {
    bytesWritten = Number(bytesWritten);
    if (IsFiniteNonNegativeNumber(bytesWritten) === false) {
      throw new RangeError('bytesWritten must be a finite');
    }
    assert(controller._pendingPullIntos.length > 0);
    ReadableByteStreamControllerRespondInternal(controller, bytesWritten);
  }
  function ReadableByteStreamControllerRespondWithNewView(controller, view) {
    assert(controller._pendingPullIntos.length > 0);
    var firstDescriptor = controller._pendingPullIntos[0];
    if (firstDescriptor.byteOffset + firstDescriptor.bytesFilled !== view.byteOffset) {
      throw new RangeError('The region specified by view does not match byobRequest');
    }
    if (firstDescriptor.byteLength !== view.byteLength) {
      throw new RangeError('The buffer of view has different capacity than byobRequest');
    }
    firstDescriptor.buffer = view.buffer;
    ReadableByteStreamControllerRespondInternal(controller, view.byteLength);
  }
  function streamBrandCheckException(name) {
    return new TypeError('ReadableStream.prototype.' + name + ' can only be used on a ReadableStream');
  }
  function readerLockException(name) {
    return new TypeError('Cannot ' + name + ' a stream using a released reader');
  }
  function defaultReaderBrandCheckException(name) {
    return new TypeError('ReadableStreamDefaultReader.prototype.' + name + ' can only be used on a ReadableStreamDefaultReader');
  }
  function defaultReaderClosedPromiseInitialize(reader) {
    reader._closedPromise = new Promise(function (resolve, reject) {
      reader._closedPromise_resolve = resolve;
      reader._closedPromise_reject = reject;
    });
  }
  function defaultReaderClosedPromiseInitializeAsRejected(reader, reason) {
    reader._closedPromise = Promise.reject(reason);
    reader._closedPromise_resolve = undefined;
    reader._closedPromise_reject = undefined;
  }
  function defaultReaderClosedPromiseInitializeAsResolved(reader) {
    reader._closedPromise = Promise.resolve(undefined);
    reader._closedPromise_resolve = undefined;
    reader._closedPromise_reject = undefined;
  }
  function defaultReaderClosedPromiseReject(reader, reason) {
    assert(reader._closedPromise_resolve !== undefined);
    assert(reader._closedPromise_reject !== undefined);
    reader._closedPromise_reject(reason);
    reader._closedPromise_resolve = undefined;
    reader._closedPromise_reject = undefined;
  }
  function defaultReaderClosedPromiseResetToRejected(reader, reason) {
    assert(reader._closedPromise_resolve === undefined);
    assert(reader._closedPromise_reject === undefined);
    reader._closedPromise = Promise.reject(reason);
  }
  function defaultReaderClosedPromiseResolve(reader) {
    assert(reader._closedPromise_resolve !== undefined);
    assert(reader._closedPromise_reject !== undefined);
    reader._closedPromise_resolve(undefined);
    reader._closedPromise_resolve = undefined;
    reader._closedPromise_reject = undefined;
  }
  function byobReaderBrandCheckException(name) {
    return new TypeError('ReadableStreamBYOBReader.prototype.' + name + ' can only be used on a ReadableStreamBYOBReader');
  }
  function defaultControllerBrandCheckException(name) {
    return new TypeError('ReadableStreamDefaultController.prototype.' + name + ' can only be used on a ReadableStreamDefaultController');
  }
  function byobRequestBrandCheckException(name) {
    return new TypeError('ReadableStreamBYOBRequest.prototype.' + name + ' can only be used on a ReadableStreamBYOBRequest');
  }
  function byteStreamControllerBrandCheckException(name) {
    return new TypeError('ReadableByteStreamController.prototype.' + name + ' can only be used on a ReadableByteStreamController');
  }
  function ifIsObjectAndHasAPromiseIsHandledInternalSlotSetPromiseIsHandledToTrue(promise) {
    try {
      Promise.prototype.then.call(promise, undefined, function () {});
    } catch (e) {}
  }
}, function (module, exports, __w_pdfjs_require__) {
  "use strict";

  var transformStream = __w_pdfjs_require__(6);
  var readableStream = __w_pdfjs_require__(4);
  var writableStream = __w_pdfjs_require__(2);
  exports.TransformStream = transformStream.TransformStream;
  exports.ReadableStream = readableStream.ReadableStream;
  exports.IsReadableStreamDisturbed = readableStream.IsReadableStreamDisturbed;
  exports.ReadableStreamDefaultControllerClose = readableStream.ReadableStreamDefaultControllerClose;
  exports.ReadableStreamDefaultControllerEnqueue = readableStream.ReadableStreamDefaultControllerEnqueue;
  exports.ReadableStreamDefaultControllerError = readableStream.ReadableStreamDefaultControllerError;
  exports.ReadableStreamDefaultControllerGetDesiredSize = readableStream.ReadableStreamDefaultControllerGetDesiredSize;
  exports.AcquireWritableStreamDefaultWriter = writableStream.AcquireWritableStreamDefaultWriter;
  exports.IsWritableStream = writableStream.IsWritableStream;
  exports.IsWritableStreamLocked = writableStream.IsWritableStreamLocked;
  exports.WritableStream = writableStream.WritableStream;
  exports.WritableStreamAbort = writableStream.WritableStreamAbort;
  exports.WritableStreamDefaultControllerError = writableStream.WritableStreamDefaultControllerError;
  exports.WritableStreamDefaultWriterCloseWithErrorPropagation = writableStream.WritableStreamDefaultWriterCloseWithErrorPropagation;
  exports.WritableStreamDefaultWriterRelease = writableStream.WritableStreamDefaultWriterRelease;
  exports.WritableStreamDefaultWriterWrite = writableStream.WritableStreamDefaultWriterWrite;
}, function (module, exports, __w_pdfjs_require__) {
  "use strict";

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var _require = __w_pdfjs_require__(1),
      assert = _require.assert;
  var _require2 = __w_pdfjs_require__(0),
      InvokeOrNoop = _require2.InvokeOrNoop,
      PromiseInvokeOrPerformFallback = _require2.PromiseInvokeOrPerformFallback,
      PromiseInvokeOrNoop = _require2.PromiseInvokeOrNoop,
      typeIsObject = _require2.typeIsObject;
  var _require3 = __w_pdfjs_require__(4),
      ReadableStream = _require3.ReadableStream,
      ReadableStreamDefaultControllerClose = _require3.ReadableStreamDefaultControllerClose,
      ReadableStreamDefaultControllerEnqueue = _require3.ReadableStreamDefaultControllerEnqueue,
      ReadableStreamDefaultControllerError = _require3.ReadableStreamDefaultControllerError,
      ReadableStreamDefaultControllerGetDesiredSize = _require3.ReadableStreamDefaultControllerGetDesiredSize;
  var _require4 = __w_pdfjs_require__(2),
      WritableStream = _require4.WritableStream,
      WritableStreamDefaultControllerError = _require4.WritableStreamDefaultControllerError;
  function TransformStreamCloseReadable(transformStream) {
    if (transformStream._errored === true) {
      throw new TypeError('TransformStream is already errored');
    }
    if (transformStream._readableClosed === true) {
      throw new TypeError('Readable side is already closed');
    }
    TransformStreamCloseReadableInternal(transformStream);
  }
  function TransformStreamEnqueueToReadable(transformStream, chunk) {
    if (transformStream._errored === true) {
      throw new TypeError('TransformStream is already errored');
    }
    if (transformStream._readableClosed === true) {
      throw new TypeError('Readable side is already closed');
    }
    var controller = transformStream._readableController;
    try {
      ReadableStreamDefaultControllerEnqueue(controller, chunk);
    } catch (e) {
      transformStream._readableClosed = true;
      TransformStreamErrorIfNeeded(transformStream, e);
      throw transformStream._storedError;
    }
    var desiredSize = ReadableStreamDefaultControllerGetDesiredSize(controller);
    var maybeBackpressure = desiredSize <= 0;
    if (maybeBackpressure === true && transformStream._backpressure === false) {
      TransformStreamSetBackpressure(transformStream, true);
    }
  }
  function TransformStreamError(transformStream, e) {
    if (transformStream._errored === true) {
      throw new TypeError('TransformStream is already errored');
    }
    TransformStreamErrorInternal(transformStream, e);
  }
  function TransformStreamCloseReadableInternal(transformStream) {
    assert(transformStream._errored === false);
    assert(transformStream._readableClosed === false);
    try {
      ReadableStreamDefaultControllerClose(transformStream._readableController);
    } catch (e) {
      assert(false);
    }
    transformStream._readableClosed = true;
  }
  function TransformStreamErrorIfNeeded(transformStream, e) {
    if (transformStream._errored === false) {
      TransformStreamErrorInternal(transformStream, e);
    }
  }
  function TransformStreamErrorInternal(transformStream, e) {
    assert(transformStream._errored === false);
    transformStream._errored = true;
    transformStream._storedError = e;
    if (transformStream._writableDone === false) {
      WritableStreamDefaultControllerError(transformStream._writableController, e);
    }
    if (transformStream._readableClosed === false) {
      ReadableStreamDefaultControllerError(transformStream._readableController, e);
    }
  }
  function TransformStreamReadableReadyPromise(transformStream) {
    assert(transformStream._backpressureChangePromise !== undefined, '_backpressureChangePromise should have been initialized');
    if (transformStream._backpressure === false) {
      return Promise.resolve();
    }
    assert(transformStream._backpressure === true, '_backpressure should have been initialized');
    return transformStream._backpressureChangePromise;
  }
  function TransformStreamSetBackpressure(transformStream, backpressure) {
    assert(transformStream._backpressure !== backpressure, 'TransformStreamSetBackpressure() should be called only when backpressure is changed');
    if (transformStream._backpressureChangePromise !== undefined) {
      transformStream._backpressureChangePromise_resolve(backpressure);
    }
    transformStream._backpressureChangePromise = new Promise(function (resolve) {
      transformStream._backpressureChangePromise_resolve = resolve;
    });
    transformStream._backpressureChangePromise.then(function (resolution) {
      assert(resolution !== backpressure, '_backpressureChangePromise should be fulfilled only when backpressure is changed');
    });
    transformStream._backpressure = backpressure;
  }
  function TransformStreamDefaultTransform(chunk, transformStreamController) {
    var transformStream = transformStreamController._controlledTransformStream;
    TransformStreamEnqueueToReadable(transformStream, chunk);
    return Promise.resolve();
  }
  function TransformStreamTransform(transformStream, chunk) {
    assert(transformStream._errored === false);
    assert(transformStream._transforming === false);
    assert(transformStream._backpressure === false);
    transformStream._transforming = true;
    var transformer = transformStream._transformer;
    var controller = transformStream._transformStreamController;
    var transformPromise = PromiseInvokeOrPerformFallback(transformer, 'transform', [chunk, controller], TransformStreamDefaultTransform, [chunk, controller]);
    return transformPromise.then(function () {
      transformStream._transforming = false;
      return TransformStreamReadableReadyPromise(transformStream);
    }, function (e) {
      TransformStreamErrorIfNeeded(transformStream, e);
      return Promise.reject(e);
    });
  }
  function IsTransformStreamDefaultController(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_controlledTransformStream')) {
      return false;
    }
    return true;
  }
  function IsTransformStream(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_transformStreamController')) {
      return false;
    }
    return true;
  }
  var TransformStreamSink = function () {
    function TransformStreamSink(transformStream, startPromise) {
      _classCallCheck(this, TransformStreamSink);
      this._transformStream = transformStream;
      this._startPromise = startPromise;
    }
    _createClass(TransformStreamSink, [{
      key: 'start',
      value: function start(c) {
        var transformStream = this._transformStream;
        transformStream._writableController = c;
        return this._startPromise.then(function () {
          return TransformStreamReadableReadyPromise(transformStream);
        });
      }
    }, {
      key: 'write',
      value: function write(chunk) {
        var transformStream = this._transformStream;
        return TransformStreamTransform(transformStream, chunk);
      }
    }, {
      key: 'abort',
      value: function abort() {
        var transformStream = this._transformStream;
        transformStream._writableDone = true;
        TransformStreamErrorInternal(transformStream, new TypeError('Writable side aborted'));
      }
    }, {
      key: 'close',
      value: function close() {
        var transformStream = this._transformStream;
        assert(transformStream._transforming === false);
        transformStream._writableDone = true;
        var flushPromise = PromiseInvokeOrNoop(transformStream._transformer, 'flush', [transformStream._transformStreamController]);
        return flushPromise.then(function () {
          if (transformStream._errored === true) {
            return Promise.reject(transformStream._storedError);
          }
          if (transformStream._readableClosed === false) {
            TransformStreamCloseReadableInternal(transformStream);
          }
          return Promise.resolve();
        }).catch(function (r) {
          TransformStreamErrorIfNeeded(transformStream, r);
          return Promise.reject(transformStream._storedError);
        });
      }
    }]);
    return TransformStreamSink;
  }();
  var TransformStreamSource = function () {
    function TransformStreamSource(transformStream, startPromise) {
      _classCallCheck(this, TransformStreamSource);
      this._transformStream = transformStream;
      this._startPromise = startPromise;
    }
    _createClass(TransformStreamSource, [{
      key: 'start',
      value: function start(c) {
        var transformStream = this._transformStream;
        transformStream._readableController = c;
        return this._startPromise.then(function () {
          assert(transformStream._backpressureChangePromise !== undefined, '_backpressureChangePromise should have been initialized');
          if (transformStream._backpressure === true) {
            return Promise.resolve();
          }
          assert(transformStream._backpressure === false, '_backpressure should have been initialized');
          return transformStream._backpressureChangePromise;
        });
      }
    }, {
      key: 'pull',
      value: function pull() {
        var transformStream = this._transformStream;
        assert(transformStream._backpressure === true, 'pull() should be never called while _backpressure is false');
        assert(transformStream._backpressureChangePromise !== undefined, '_backpressureChangePromise should have been initialized');
        TransformStreamSetBackpressure(transformStream, false);
        return transformStream._backpressureChangePromise;
      }
    }, {
      key: 'cancel',
      value: function cancel() {
        var transformStream = this._transformStream;
        transformStream._readableClosed = true;
        TransformStreamErrorInternal(transformStream, new TypeError('Readable side canceled'));
      }
    }]);
    return TransformStreamSource;
  }();
  var TransformStreamDefaultController = function () {
    function TransformStreamDefaultController(transformStream) {
      _classCallCheck(this, TransformStreamDefaultController);
      if (IsTransformStream(transformStream) === false) {
        throw new TypeError('TransformStreamDefaultController can only be ' + 'constructed with a TransformStream instance');
      }
      if (transformStream._transformStreamController !== undefined) {
        throw new TypeError('TransformStreamDefaultController instances can ' + 'only be created by the TransformStream constructor');
      }
      this._controlledTransformStream = transformStream;
    }
    _createClass(TransformStreamDefaultController, [{
      key: 'enqueue',
      value: function enqueue(chunk) {
        if (IsTransformStreamDefaultController(this) === false) {
          throw defaultControllerBrandCheckException('enqueue');
        }
        TransformStreamEnqueueToReadable(this._controlledTransformStream, chunk);
      }
    }, {
      key: 'close',
      value: function close() {
        if (IsTransformStreamDefaultController(this) === false) {
          throw defaultControllerBrandCheckException('close');
        }
        TransformStreamCloseReadable(this._controlledTransformStream);
      }
    }, {
      key: 'error',
      value: function error(reason) {
        if (IsTransformStreamDefaultController(this) === false) {
          throw defaultControllerBrandCheckException('error');
        }
        TransformStreamError(this._controlledTransformStream, reason);
      }
    }, {
      key: 'desiredSize',
      get: function get() {
        if (IsTransformStreamDefaultController(this) === false) {
          throw defaultControllerBrandCheckException('desiredSize');
        }
        var transformStream = this._controlledTransformStream;
        var readableController = transformStream._readableController;
        return ReadableStreamDefaultControllerGetDesiredSize(readableController);
      }
    }]);
    return TransformStreamDefaultController;
  }();
  var TransformStream = function () {
    function TransformStream() {
      var transformer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      _classCallCheck(this, TransformStream);
      this._transformer = transformer;
      var readableStrategy = transformer.readableStrategy,
          writableStrategy = transformer.writableStrategy;
      this._transforming = false;
      this._errored = false;
      this._storedError = undefined;
      this._writableController = undefined;
      this._readableController = undefined;
      this._transformStreamController = undefined;
      this._writableDone = false;
      this._readableClosed = false;
      this._backpressure = undefined;
      this._backpressureChangePromise = undefined;
      this._backpressureChangePromise_resolve = undefined;
      this._transformStreamController = new TransformStreamDefaultController(this);
      var startPromise_resolve = void 0;
      var startPromise = new Promise(function (resolve) {
        startPromise_resolve = resolve;
      });
      var source = new TransformStreamSource(this, startPromise);
      this._readable = new ReadableStream(source, readableStrategy);
      var sink = new TransformStreamSink(this, startPromise);
      this._writable = new WritableStream(sink, writableStrategy);
      assert(this._writableController !== undefined);
      assert(this._readableController !== undefined);
      var desiredSize = ReadableStreamDefaultControllerGetDesiredSize(this._readableController);
      TransformStreamSetBackpressure(this, desiredSize <= 0);
      var transformStream = this;
      var startResult = InvokeOrNoop(transformer, 'start', [transformStream._transformStreamController]);
      startPromise_resolve(startResult);
      startPromise.catch(function (e) {
        if (transformStream._errored === false) {
          transformStream._errored = true;
          transformStream._storedError = e;
        }
      });
    }
    _createClass(TransformStream, [{
      key: 'readable',
      get: function get() {
        if (IsTransformStream(this) === false) {
          throw streamBrandCheckException('readable');
        }
        return this._readable;
      }
    }, {
      key: 'writable',
      get: function get() {
        if (IsTransformStream(this) === false) {
          throw streamBrandCheckException('writable');
        }
        return this._writable;
      }
    }]);
    return TransformStream;
  }();
  module.exports = { TransformStream: TransformStream };
  function defaultControllerBrandCheckException(name) {
    return new TypeError('TransformStreamDefaultController.prototype.' + name + ' can only be used on a TransformStreamDefaultController');
  }
  function streamBrandCheckException(name) {
    return new TypeError('TransformStream.prototype.' + name + ' can only be used on a TransformStream');
  }
}, function (module, exports, __w_pdfjs_require__) {
  module.exports = __w_pdfjs_require__(5);
}]));

/***/ }),
/* 19 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnnotationFactory = exports.AnnotationBorderStyle = exports.Annotation = undefined;

var _util = __w_pdfjs_require__(0);

var _obj = __w_pdfjs_require__(14);

var _primitives = __w_pdfjs_require__(1);

var _colorspace = __w_pdfjs_require__(3);

var _evaluator = __w_pdfjs_require__(12);

var _stream = __w_pdfjs_require__(2);

function AnnotationFactory() {}
AnnotationFactory.prototype = {
  create: function AnnotationFactory_create(xref, ref, pdfManager, idFactory) {
    var dict = xref.fetchIfRef(ref);
    if (!(0, _primitives.isDict)(dict)) {
      return;
    }
    var id = (0, _primitives.isRef)(ref) ? ref.toString() : 'annot_' + idFactory.createObjId();
    var subtype = dict.get('Subtype');
    subtype = (0, _primitives.isName)(subtype) ? subtype.name : null;
    var parameters = {
      xref: xref,
      dict: dict,
      ref: (0, _primitives.isRef)(ref) ? ref : null,
      subtype: subtype,
      id: id,
      pdfManager: pdfManager
    };
    switch (subtype) {
      case 'Link':
        return new LinkAnnotation(parameters);
      case 'Text':
        return new TextAnnotation(parameters);
      case 'Widget':
        var fieldType = _util.Util.getInheritableProperty(dict, 'FT');
        fieldType = (0, _primitives.isName)(fieldType) ? fieldType.name : null;
        switch (fieldType) {
          case 'Tx':
            return new TextWidgetAnnotation(parameters);
          case 'Btn':
            return new ButtonWidgetAnnotation(parameters);
          case 'Ch':
            return new ChoiceWidgetAnnotation(parameters);
        }
        (0, _util.warn)('Unimplemented widget field type "' + fieldType + '", ' + 'falling back to base field type.');
        return new WidgetAnnotation(parameters);
      case 'Popup':
        return new PopupAnnotation(parameters);
      case 'Line':
        return new LineAnnotation(parameters);
      case 'Highlight':
        return new HighlightAnnotation(parameters);
      case 'Underline':
        return new UnderlineAnnotation(parameters);
      case 'Squiggly':
        return new SquigglyAnnotation(parameters);
      case 'StrikeOut':
        return new StrikeOutAnnotation(parameters);
      case 'FileAttachment':
        return new FileAttachmentAnnotation(parameters);
      default:
        if (!subtype) {
          (0, _util.warn)('Annotation is missing the required /Subtype.');
        } else {
          (0, _util.warn)('Unimplemented annotation type "' + subtype + '", ' + 'falling back to base annotation.');
        }
        return new Annotation(parameters);
    }
  }
};
var Annotation = function AnnotationClosure() {
  function getTransformMatrix(rect, bbox, matrix) {
    var bounds = _util.Util.getAxialAlignedBoundingBox(bbox, matrix);
    var minX = bounds[0];
    var minY = bounds[1];
    var maxX = bounds[2];
    var maxY = bounds[3];
    if (minX === maxX || minY === maxY) {
      return [1, 0, 0, 1, rect[0], rect[1]];
    }
    var xRatio = (rect[2] - rect[0]) / (maxX - minX);
    var yRatio = (rect[3] - rect[1]) / (maxY - minY);
    return [xRatio, 0, 0, yRatio, rect[0] - minX * xRatio, rect[1] - minY * yRatio];
  }
  function Annotation(params) {
    var dict = params.dict;
    this.setFlags(dict.get('F'));
    this.setRectangle(dict.getArray('Rect'));
    this.setColor(dict.getArray('C'));
    this.setBorderStyle(dict);
    this.setAppearance(dict);
    this.data = {};
    this.data.id = params.id;
    this.data.subtype = params.subtype;
    this.data.annotationFlags = this.flags;
    this.data.rect = this.rectangle;
    this.data.color = this.color;
    this.data.borderStyle = this.borderStyle;
    this.data.hasAppearance = !!this.appearance;
  }
  Annotation.prototype = {
    _hasFlag: function Annotation_hasFlag(flags, flag) {
      return !!(flags & flag);
    },
    _isViewable: function Annotation_isViewable(flags) {
      return !this._hasFlag(flags, _util.AnnotationFlag.INVISIBLE) && !this._hasFlag(flags, _util.AnnotationFlag.HIDDEN) && !this._hasFlag(flags, _util.AnnotationFlag.NOVIEW);
    },
    _isPrintable: function AnnotationFlag_isPrintable(flags) {
      return this._hasFlag(flags, _util.AnnotationFlag.PRINT) && !this._hasFlag(flags, _util.AnnotationFlag.INVISIBLE) && !this._hasFlag(flags, _util.AnnotationFlag.HIDDEN);
    },
    get viewable() {
      if (this.flags === 0) {
        return true;
      }
      return this._isViewable(this.flags);
    },
    get printable() {
      if (this.flags === 0) {
        return false;
      }
      return this._isPrintable(this.flags);
    },
    setFlags: function Annotation_setFlags(flags) {
      this.flags = (0, _util.isInt)(flags) && flags > 0 ? flags : 0;
    },
    hasFlag: function Annotation_hasFlag(flag) {
      return this._hasFlag(this.flags, flag);
    },
    setRectangle: function Annotation_setRectangle(rectangle) {
      if ((0, _util.isArray)(rectangle) && rectangle.length === 4) {
        this.rectangle = _util.Util.normalizeRect(rectangle);
      } else {
        this.rectangle = [0, 0, 0, 0];
      }
    },
    setColor: function Annotation_setColor(color) {
      var rgbColor = new Uint8Array(3);
      if (!(0, _util.isArray)(color)) {
        this.color = rgbColor;
        return;
      }
      switch (color.length) {
        case 0:
          this.color = null;
          break;
        case 1:
          _colorspace.ColorSpace.singletons.gray.getRgbItem(color, 0, rgbColor, 0);
          this.color = rgbColor;
          break;
        case 3:
          _colorspace.ColorSpace.singletons.rgb.getRgbItem(color, 0, rgbColor, 0);
          this.color = rgbColor;
          break;
        case 4:
          _colorspace.ColorSpace.singletons.cmyk.getRgbItem(color, 0, rgbColor, 0);
          this.color = rgbColor;
          break;
        default:
          this.color = rgbColor;
          break;
      }
    },
    setBorderStyle: function Annotation_setBorderStyle(borderStyle) {
      this.borderStyle = new AnnotationBorderStyle();
      if (!(0, _primitives.isDict)(borderStyle)) {
        return;
      }
      if (borderStyle.has('BS')) {
        var dict = borderStyle.get('BS');
        var dictType = dict.get('Type');
        if (!dictType || (0, _primitives.isName)(dictType, 'Border')) {
          this.borderStyle.setWidth(dict.get('W'));
          this.borderStyle.setStyle(dict.get('S'));
          this.borderStyle.setDashArray(dict.getArray('D'));
        }
      } else if (borderStyle.has('Border')) {
        var array = borderStyle.getArray('Border');
        if ((0, _util.isArray)(array) && array.length >= 3) {
          this.borderStyle.setHorizontalCornerRadius(array[0]);
          this.borderStyle.setVerticalCornerRadius(array[1]);
          this.borderStyle.setWidth(array[2]);
          if (array.length === 4) {
            this.borderStyle.setDashArray(array[3]);
          }
        }
      } else {
        this.borderStyle.setWidth(0);
      }
    },
    setAppearance: function Annotation_setAppearance(dict) {
      this.appearance = null;
      var appearanceStates = dict.get('AP');
      if (!(0, _primitives.isDict)(appearanceStates)) {
        return;
      }
      var normalAppearanceState = appearanceStates.get('N');
      if ((0, _primitives.isStream)(normalAppearanceState)) {
        this.appearance = normalAppearanceState;
        return;
      }
      if (!(0, _primitives.isDict)(normalAppearanceState)) {
        return;
      }
      var as = dict.get('AS');
      if (!(0, _primitives.isName)(as) || !normalAppearanceState.has(as.name)) {
        return;
      }
      this.appearance = normalAppearanceState.get(as.name);
    },
    _preparePopup: function Annotation_preparePopup(dict) {
      if (!dict.has('C')) {
        this.data.color = null;
      }
      this.data.hasPopup = dict.has('Popup');
      this.data.title = (0, _util.stringToPDFString)(dict.get('T') || '');
      this.data.contents = (0, _util.stringToPDFString)(dict.get('Contents') || '');
    },
    loadResources: function Annotation_loadResources(keys) {
      return this.appearance.dict.getAsync('Resources').then(function (resources) {
        if (!resources) {
          return;
        }
        var objectLoader = new _obj.ObjectLoader(resources, keys, resources.xref);
        return objectLoader.load().then(function () {
          return resources;
        });
      });
    },
    getOperatorList: function Annotation_getOperatorList(evaluator, task, renderForms) {
      var _this = this;

      if (!this.appearance) {
        return Promise.resolve(new _evaluator.OperatorList());
      }
      var data = this.data;
      var appearanceDict = this.appearance.dict;
      var resourcesPromise = this.loadResources(['ExtGState', 'ColorSpace', 'Pattern', 'Shading', 'XObject', 'Font']);
      var bbox = appearanceDict.getArray('BBox') || [0, 0, 1, 1];
      var matrix = appearanceDict.getArray('Matrix') || [1, 0, 0, 1, 0, 0];
      var transform = getTransformMatrix(data.rect, bbox, matrix);
      return resourcesPromise.then(function (resources) {
        var opList = new _evaluator.OperatorList();
        opList.addOp(_util.OPS.beginAnnotation, [data.rect, transform, matrix]);
        return evaluator.getOperatorList({
          stream: _this.appearance,
          task: task,
          resources: resources,
          operatorList: opList
        }).then(function () {
          opList.addOp(_util.OPS.endAnnotation, []);
          _this.appearance.reset();
          return opList;
        });
      });
    }
  };
  return Annotation;
}();
var AnnotationBorderStyle = function AnnotationBorderStyleClosure() {
  function AnnotationBorderStyle() {
    this.width = 1;
    this.style = _util.AnnotationBorderStyleType.SOLID;
    this.dashArray = [3];
    this.horizontalCornerRadius = 0;
    this.verticalCornerRadius = 0;
  }
  AnnotationBorderStyle.prototype = {
    setWidth: function AnnotationBorderStyle_setWidth(width) {
      if (width === (width | 0)) {
        this.width = width;
      }
    },
    setStyle: function AnnotationBorderStyle_setStyle(style) {
      if (!style) {
        return;
      }
      switch (style.name) {
        case 'S':
          this.style = _util.AnnotationBorderStyleType.SOLID;
          break;
        case 'D':
          this.style = _util.AnnotationBorderStyleType.DASHED;
          break;
        case 'B':
          this.style = _util.AnnotationBorderStyleType.BEVELED;
          break;
        case 'I':
          this.style = _util.AnnotationBorderStyleType.INSET;
          break;
        case 'U':
          this.style = _util.AnnotationBorderStyleType.UNDERLINE;
          break;
        default:
          break;
      }
    },
    setDashArray: function AnnotationBorderStyle_setDashArray(dashArray) {
      if ((0, _util.isArray)(dashArray) && dashArray.length > 0) {
        var isValid = true;
        var allZeros = true;
        for (var i = 0, len = dashArray.length; i < len; i++) {
          var element = dashArray[i];
          var validNumber = +element >= 0;
          if (!validNumber) {
            isValid = false;
            break;
          } else if (element > 0) {
            allZeros = false;
          }
        }
        if (isValid && !allZeros) {
          this.dashArray = dashArray;
        } else {
          this.width = 0;
        }
      } else if (dashArray) {
        this.width = 0;
      }
    },
    setHorizontalCornerRadius: function AnnotationBorderStyle_setHorizontalCornerRadius(radius) {
      if (radius === (radius | 0)) {
        this.horizontalCornerRadius = radius;
      }
    },
    setVerticalCornerRadius: function AnnotationBorderStyle_setVerticalCornerRadius(radius) {
      if (radius === (radius | 0)) {
        this.verticalCornerRadius = radius;
      }
    }
  };
  return AnnotationBorderStyle;
}();
var WidgetAnnotation = function WidgetAnnotationClosure() {
  function WidgetAnnotation(params) {
    Annotation.call(this, params);
    var dict = params.dict;
    var data = this.data;
    data.annotationType = _util.AnnotationType.WIDGET;
    data.fieldName = this._constructFieldName(dict);
    data.fieldValue = _util.Util.getInheritableProperty(dict, 'V', true);
    data.alternativeText = (0, _util.stringToPDFString)(dict.get('TU') || '');
    data.defaultAppearance = _util.Util.getInheritableProperty(dict, 'DA') || '';
    var fieldType = _util.Util.getInheritableProperty(dict, 'FT');
    data.fieldType = (0, _primitives.isName)(fieldType) ? fieldType.name : null;
    this.fieldResources = _util.Util.getInheritableProperty(dict, 'DR') || _primitives.Dict.empty;
    data.fieldFlags = _util.Util.getInheritableProperty(dict, 'Ff');
    if (!(0, _util.isInt)(data.fieldFlags) || data.fieldFlags < 0) {
      data.fieldFlags = 0;
    }
    data.readOnly = this.hasFieldFlag(_util.AnnotationFieldFlag.READONLY);
    if (data.fieldType === 'Sig') {
      this.setFlags(_util.AnnotationFlag.HIDDEN);
    }
  }
  _util.Util.inherit(WidgetAnnotation, Annotation, {
    _constructFieldName: function WidgetAnnotation_constructFieldName(dict) {
      if (!dict.has('T') && !dict.has('Parent')) {
        (0, _util.warn)('Unknown field name, falling back to empty field name.');
        return '';
      }
      if (!dict.has('Parent')) {
        return (0, _util.stringToPDFString)(dict.get('T'));
      }
      var fieldName = [];
      if (dict.has('T')) {
        fieldName.unshift((0, _util.stringToPDFString)(dict.get('T')));
      }
      var loopDict = dict;
      while (loopDict.has('Parent')) {
        loopDict = loopDict.get('Parent');
        if (!(0, _primitives.isDict)(loopDict)) {
          break;
        }
        if (loopDict.has('T')) {
          fieldName.unshift((0, _util.stringToPDFString)(loopDict.get('T')));
        }
      }
      return fieldName.join('.');
    },
    hasFieldFlag: function WidgetAnnotation_hasFieldFlag(flag) {
      return !!(this.data.fieldFlags & flag);
    }
  });
  return WidgetAnnotation;
}();
var TextWidgetAnnotation = function TextWidgetAnnotationClosure() {
  function TextWidgetAnnotation(params) {
    WidgetAnnotation.call(this, params);
    this.data.fieldValue = (0, _util.stringToPDFString)(this.data.fieldValue || '');
    var alignment = _util.Util.getInheritableProperty(params.dict, 'Q');
    if (!(0, _util.isInt)(alignment) || alignment < 0 || alignment > 2) {
      alignment = null;
    }
    this.data.textAlignment = alignment;
    var maximumLength = _util.Util.getInheritableProperty(params.dict, 'MaxLen');
    if (!(0, _util.isInt)(maximumLength) || maximumLength < 0) {
      maximumLength = null;
    }
    this.data.maxLen = maximumLength;
    this.data.multiLine = this.hasFieldFlag(_util.AnnotationFieldFlag.MULTILINE);
    this.data.comb = this.hasFieldFlag(_util.AnnotationFieldFlag.COMB) && !this.hasFieldFlag(_util.AnnotationFieldFlag.MULTILINE) && !this.hasFieldFlag(_util.AnnotationFieldFlag.PASSWORD) && !this.hasFieldFlag(_util.AnnotationFieldFlag.FILESELECT) && this.data.maxLen !== null;
  }
  _util.Util.inherit(TextWidgetAnnotation, WidgetAnnotation, {
    getOperatorList: function TextWidgetAnnotation_getOperatorList(evaluator, task, renderForms) {
      var operatorList = new _evaluator.OperatorList();
      if (renderForms) {
        return Promise.resolve(operatorList);
      }
      if (this.appearance) {
        return Annotation.prototype.getOperatorList.call(this, evaluator, task, renderForms);
      }
      if (!this.data.defaultAppearance) {
        return Promise.resolve(operatorList);
      }
      var stream = new _stream.Stream((0, _util.stringToBytes)(this.data.defaultAppearance));
      return evaluator.getOperatorList({
        stream: stream,
        task: task,
        resources: this.fieldResources,
        operatorList: operatorList
      }).then(function () {
        return operatorList;
      });
    }
  });
  return TextWidgetAnnotation;
}();
var ButtonWidgetAnnotation = function ButtonWidgetAnnotationClosure() {
  function ButtonWidgetAnnotation(params) {
    WidgetAnnotation.call(this, params);
    this.data.checkBox = !this.hasFieldFlag(_util.AnnotationFieldFlag.RADIO) && !this.hasFieldFlag(_util.AnnotationFieldFlag.PUSHBUTTON);
    if (this.data.checkBox) {
      if (!(0, _primitives.isName)(this.data.fieldValue)) {
        return;
      }
      this.data.fieldValue = this.data.fieldValue.name;
    }
    this.data.radioButton = this.hasFieldFlag(_util.AnnotationFieldFlag.RADIO) && !this.hasFieldFlag(_util.AnnotationFieldFlag.PUSHBUTTON);
    if (this.data.radioButton) {
      this.data.fieldValue = this.data.buttonValue = null;
      var fieldParent = params.dict.get('Parent');
      if ((0, _primitives.isDict)(fieldParent) && fieldParent.has('V')) {
        var fieldParentValue = fieldParent.get('V');
        if ((0, _primitives.isName)(fieldParentValue)) {
          this.data.fieldValue = fieldParentValue.name;
        }
      }
      var appearanceStates = params.dict.get('AP');
      if (!(0, _primitives.isDict)(appearanceStates)) {
        return;
      }
      var normalAppearanceState = appearanceStates.get('N');
      if (!(0, _primitives.isDict)(normalAppearanceState)) {
        return;
      }
      var keys = normalAppearanceState.getKeys();
      for (var i = 0, ii = keys.length; i < ii; i++) {
        if (keys[i] !== 'Off') {
          this.data.buttonValue = keys[i];
          break;
        }
      }
    }
  }
  _util.Util.inherit(ButtonWidgetAnnotation, WidgetAnnotation, {
    getOperatorList: function ButtonWidgetAnnotation_getOperatorList(evaluator, task, renderForms) {
      var operatorList = new _evaluator.OperatorList();
      if (renderForms) {
        return Promise.resolve(operatorList);
      }
      if (this.appearance) {
        return Annotation.prototype.getOperatorList.call(this, evaluator, task, renderForms);
      }
      return Promise.resolve(operatorList);
    }
  });
  return ButtonWidgetAnnotation;
}();
var ChoiceWidgetAnnotation = function ChoiceWidgetAnnotationClosure() {
  function ChoiceWidgetAnnotation(params) {
    WidgetAnnotation.call(this, params);
    this.data.options = [];
    var options = _util.Util.getInheritableProperty(params.dict, 'Opt');
    if ((0, _util.isArray)(options)) {
      var xref = params.xref;
      for (var i = 0, ii = options.length; i < ii; i++) {
        var option = xref.fetchIfRef(options[i]);
        var isOptionArray = (0, _util.isArray)(option);
        this.data.options[i] = {
          exportValue: isOptionArray ? xref.fetchIfRef(option[0]) : option,
          displayValue: isOptionArray ? xref.fetchIfRef(option[1]) : option
        };
      }
    }
    if (!(0, _util.isArray)(this.data.fieldValue)) {
      this.data.fieldValue = [this.data.fieldValue];
    }
    this.data.combo = this.hasFieldFlag(_util.AnnotationFieldFlag.COMBO);
    this.data.multiSelect = this.hasFieldFlag(_util.AnnotationFieldFlag.MULTISELECT);
  }
  _util.Util.inherit(ChoiceWidgetAnnotation, WidgetAnnotation, {
    getOperatorList: function ChoiceWidgetAnnotation_getOperatorList(evaluator, task, renderForms) {
      var operatorList = new _evaluator.OperatorList();
      if (renderForms) {
        return Promise.resolve(operatorList);
      }
      return Annotation.prototype.getOperatorList.call(this, evaluator, task, renderForms);
    }
  });
  return ChoiceWidgetAnnotation;
}();
var TextAnnotation = function TextAnnotationClosure() {
  var DEFAULT_ICON_SIZE = 22;
  function TextAnnotation(parameters) {
    Annotation.call(this, parameters);
    this.data.annotationType = _util.AnnotationType.TEXT;
    if (this.data.hasAppearance) {
      this.data.name = 'NoIcon';
    } else {
      this.data.rect[1] = this.data.rect[3] - DEFAULT_ICON_SIZE;
      this.data.rect[2] = this.data.rect[0] + DEFAULT_ICON_SIZE;
      this.data.name = parameters.dict.has('Name') ? parameters.dict.get('Name').name : 'Note';
    }
    this._preparePopup(parameters.dict);
  }
  _util.Util.inherit(TextAnnotation, Annotation, {});
  return TextAnnotation;
}();
var LinkAnnotation = function LinkAnnotationClosure() {
  function LinkAnnotation(params) {
    Annotation.call(this, params);
    var data = this.data;
    data.annotationType = _util.AnnotationType.LINK;
    _obj.Catalog.parseDestDictionary({
      destDict: params.dict,
      resultObj: data,
      docBaseUrl: params.pdfManager.docBaseUrl
    });
  }
  _util.Util.inherit(LinkAnnotation, Annotation, {});
  return LinkAnnotation;
}();
var PopupAnnotation = function PopupAnnotationClosure() {
  function PopupAnnotation(parameters) {
    Annotation.call(this, parameters);
    this.data.annotationType = _util.AnnotationType.POPUP;
    var dict = parameters.dict;
    var parentItem = dict.get('Parent');
    if (!parentItem) {
      (0, _util.warn)('Popup annotation has a missing or invalid parent annotation.');
      return;
    }
    var parentSubtype = parentItem.get('Subtype');
    this.data.parentType = (0, _primitives.isName)(parentSubtype) ? parentSubtype.name : null;
    this.data.parentId = dict.getRaw('Parent').toString();
    this.data.title = (0, _util.stringToPDFString)(parentItem.get('T') || '');
    this.data.contents = (0, _util.stringToPDFString)(parentItem.get('Contents') || '');
    if (!parentItem.has('C')) {
      this.data.color = null;
    } else {
      this.setColor(parentItem.getArray('C'));
      this.data.color = this.color;
    }
    if (!this.viewable) {
      var parentFlags = parentItem.get('F');
      if (this._isViewable(parentFlags)) {
        this.setFlags(parentFlags);
      }
    }
  }
  _util.Util.inherit(PopupAnnotation, Annotation, {});
  return PopupAnnotation;
}();
var LineAnnotation = function LineAnnotationClosure() {
  function LineAnnotation(parameters) {
    Annotation.call(this, parameters);
    this.data.annotationType = _util.AnnotationType.LINE;
    var dict = parameters.dict;
    this.data.lineCoordinates = _util.Util.normalizeRect(dict.getArray('L'));
    this._preparePopup(dict);
  }
  _util.Util.inherit(LineAnnotation, Annotation, {});
  return LineAnnotation;
}();
var HighlightAnnotation = function HighlightAnnotationClosure() {
  function HighlightAnnotation(parameters) {
    Annotation.call(this, parameters);
    this.data.annotationType = _util.AnnotationType.HIGHLIGHT;
    this._preparePopup(parameters.dict);
  }
  _util.Util.inherit(HighlightAnnotation, Annotation, {});
  return HighlightAnnotation;
}();
var UnderlineAnnotation = function UnderlineAnnotationClosure() {
  function UnderlineAnnotation(parameters) {
    Annotation.call(this, parameters);
    this.data.annotationType = _util.AnnotationType.UNDERLINE;
    this._preparePopup(parameters.dict);
  }
  _util.Util.inherit(UnderlineAnnotation, Annotation, {});
  return UnderlineAnnotation;
}();
var SquigglyAnnotation = function SquigglyAnnotationClosure() {
  function SquigglyAnnotation(parameters) {
    Annotation.call(this, parameters);
    this.data.annotationType = _util.AnnotationType.SQUIGGLY;
    this._preparePopup(parameters.dict);
  }
  _util.Util.inherit(SquigglyAnnotation, Annotation, {});
  return SquigglyAnnotation;
}();
var StrikeOutAnnotation = function StrikeOutAnnotationClosure() {
  function StrikeOutAnnotation(parameters) {
    Annotation.call(this, parameters);
    this.data.annotationType = _util.AnnotationType.STRIKEOUT;
    this._preparePopup(parameters.dict);
  }
  _util.Util.inherit(StrikeOutAnnotation, Annotation, {});
  return StrikeOutAnnotation;
}();
var FileAttachmentAnnotation = function FileAttachmentAnnotationClosure() {
  function FileAttachmentAnnotation(parameters) {
    Annotation.call(this, parameters);
    var file = new _obj.FileSpec(parameters.dict.get('FS'), parameters.xref);
    this.data.annotationType = _util.AnnotationType.FILEATTACHMENT;
    this.data.file = file.serializable;
    this._preparePopup(parameters.dict);
  }
  _util.Util.inherit(FileAttachmentAnnotation, Annotation, {});
  return FileAttachmentAnnotation;
}();
exports.Annotation = Annotation;
exports.AnnotationBorderStyle = AnnotationBorderStyle;
exports.AnnotationFactory = AnnotationFactory;

/***/ }),
/* 20 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bidi = undefined;

var _util = __w_pdfjs_require__(0);

var baseTypes = ['BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'S', 'B', 'S', 'WS', 'B', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'B', 'B', 'B', 'S', 'WS', 'ON', 'ON', 'ET', 'ET', 'ET', 'ON', 'ON', 'ON', 'ON', 'ON', 'ES', 'CS', 'ES', 'CS', 'CS', 'EN', 'EN', 'EN', 'EN', 'EN', 'EN', 'EN', 'EN', 'EN', 'EN', 'CS', 'ON', 'ON', 'ON', 'ON', 'ON', 'ON', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'ON', 'ON', 'ON', 'ON', 'ON', 'ON', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'ON', 'ON', 'ON', 'ON', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'B', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'BN', 'CS', 'ON', 'ET', 'ET', 'ET', 'ET', 'ON', 'ON', 'ON', 'ON', 'L', 'ON', 'ON', 'BN', 'ON', 'ON', 'ET', 'ET', 'EN', 'EN', 'ON', 'L', 'ON', 'ON', 'ON', 'EN', 'L', 'ON', 'ON', 'ON', 'ON', 'ON', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'ON', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'ON', 'L', 'L', 'L', 'L', 'L', 'L', 'L', 'L'];
var arabicTypes = ['AN', 'AN', 'AN', 'AN', 'AN', 'AN', 'ON', 'ON', 'AL', 'ET', 'ET', 'AL', 'CS', 'AL', 'ON', 'ON', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'AL', 'AL', '', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'AN', 'AN', 'AN', 'AN', 'AN', 'AN', 'AN', 'AN', 'AN', 'AN', 'ET', 'AN', 'AN', 'AL', 'AL', 'AL', 'NSM', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'AN', 'ON', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'NSM', 'AL', 'AL', 'NSM', 'NSM', 'ON', 'NSM', 'NSM', 'NSM', 'NSM', 'AL', 'AL', 'EN', 'EN', 'EN', 'EN', 'EN', 'EN', 'EN', 'EN', 'EN', 'EN', 'AL', 'AL', 'AL', 'AL', 'AL', 'AL'];
function isOdd(i) {
  return (i & 1) !== 0;
}
function isEven(i) {
  return (i & 1) === 0;
}
function findUnequal(arr, start, value) {
  for (var j = start, jj = arr.length; j < jj; ++j) {
    if (arr[j] !== value) {
      return j;
    }
  }
  return j;
}
function setValues(arr, start, end, value) {
  for (var j = start; j < end; ++j) {
    arr[j] = value;
  }
}
function reverseValues(arr, start, end) {
  for (var i = start, j = end - 1; i < j; ++i, --j) {
    var temp = arr[i];
    arr[i] = arr[j];
    arr[j] = temp;
  }
}
function createBidiText(str, isLTR, vertical) {
  return {
    str: str,
    dir: vertical ? 'ttb' : isLTR ? 'ltr' : 'rtl'
  };
}
var chars = [];
var types = [];
function bidi(str, startLevel, vertical) {
  var isLTR = true;
  var strLength = str.length;
  if (strLength === 0 || vertical) {
    return createBidiText(str, isLTR, vertical);
  }
  chars.length = strLength;
  types.length = strLength;
  var numBidi = 0;
  var i, ii;
  for (i = 0; i < strLength; ++i) {
    chars[i] = str.charAt(i);
    var charCode = str.charCodeAt(i);
    var charType = 'L';
    if (charCode <= 0x00ff) {
      charType = baseTypes[charCode];
    } else if (0x0590 <= charCode && charCode <= 0x05f4) {
      charType = 'R';
    } else if (0x0600 <= charCode && charCode <= 0x06ff) {
      charType = arabicTypes[charCode & 0xff];
      if (!charType) {
        (0, _util.warn)('Bidi: invalid Unicode character ' + charCode.toString(16));
      }
    } else if (0x0700 <= charCode && charCode <= 0x08AC) {
      charType = 'AL';
    }
    if (charType === 'R' || charType === 'AL' || charType === 'AN') {
      numBidi++;
    }
    types[i] = charType;
  }
  if (numBidi === 0) {
    isLTR = true;
    return createBidiText(str, isLTR);
  }
  if (startLevel === -1) {
    if (numBidi / strLength < 0.3) {
      isLTR = true;
      startLevel = 0;
    } else {
      isLTR = false;
      startLevel = 1;
    }
  }
  var levels = [];
  for (i = 0; i < strLength; ++i) {
    levels[i] = startLevel;
  }
  var e = isOdd(startLevel) ? 'R' : 'L';
  var sor = e;
  var eor = sor;
  var lastType = sor;
  for (i = 0; i < strLength; ++i) {
    if (types[i] === 'NSM') {
      types[i] = lastType;
    } else {
      lastType = types[i];
    }
  }
  lastType = sor;
  var t;
  for (i = 0; i < strLength; ++i) {
    t = types[i];
    if (t === 'EN') {
      types[i] = lastType === 'AL' ? 'AN' : 'EN';
    } else if (t === 'R' || t === 'L' || t === 'AL') {
      lastType = t;
    }
  }
  for (i = 0; i < strLength; ++i) {
    t = types[i];
    if (t === 'AL') {
      types[i] = 'R';
    }
  }
  for (i = 1; i < strLength - 1; ++i) {
    if (types[i] === 'ES' && types[i - 1] === 'EN' && types[i + 1] === 'EN') {
      types[i] = 'EN';
    }
    if (types[i] === 'CS' && (types[i - 1] === 'EN' || types[i - 1] === 'AN') && types[i + 1] === types[i - 1]) {
      types[i] = types[i - 1];
    }
  }
  for (i = 0; i < strLength; ++i) {
    if (types[i] === 'EN') {
      var j;
      for (j = i - 1; j >= 0; --j) {
        if (types[j] !== 'ET') {
          break;
        }
        types[j] = 'EN';
      }
      for (j = i + 1; j < strLength; ++j) {
        if (types[j] !== 'ET') {
          break;
        }
        types[j] = 'EN';
      }
    }
  }
  for (i = 0; i < strLength; ++i) {
    t = types[i];
    if (t === 'WS' || t === 'ES' || t === 'ET' || t === 'CS') {
      types[i] = 'ON';
    }
  }
  lastType = sor;
  for (i = 0; i < strLength; ++i) {
    t = types[i];
    if (t === 'EN') {
      types[i] = lastType === 'L' ? 'L' : 'EN';
    } else if (t === 'R' || t === 'L') {
      lastType = t;
    }
  }
  for (i = 0; i < strLength; ++i) {
    if (types[i] === 'ON') {
      var end = findUnequal(types, i + 1, 'ON');
      var before = sor;
      if (i > 0) {
        before = types[i - 1];
      }
      var after = eor;
      if (end + 1 < strLength) {
        after = types[end + 1];
      }
      if (before !== 'L') {
        before = 'R';
      }
      if (after !== 'L') {
        after = 'R';
      }
      if (before === after) {
        setValues(types, i, end, before);
      }
      i = end - 1;
    }
  }
  for (i = 0; i < strLength; ++i) {
    if (types[i] === 'ON') {
      types[i] = e;
    }
  }
  for (i = 0; i < strLength; ++i) {
    t = types[i];
    if (isEven(levels[i])) {
      if (t === 'R') {
        levels[i] += 1;
      } else if (t === 'AN' || t === 'EN') {
        levels[i] += 2;
      }
    } else {
      if (t === 'L' || t === 'AN' || t === 'EN') {
        levels[i] += 1;
      }
    }
  }
  var highestLevel = -1;
  var lowestOddLevel = 99;
  var level;
  for (i = 0, ii = levels.length; i < ii; ++i) {
    level = levels[i];
    if (highestLevel < level) {
      highestLevel = level;
    }
    if (lowestOddLevel > level && isOdd(level)) {
      lowestOddLevel = level;
    }
  }
  for (level = highestLevel; level >= lowestOddLevel; --level) {
    var start = -1;
    for (i = 0, ii = levels.length; i < ii; ++i) {
      if (levels[i] < level) {
        if (start >= 0) {
          reverseValues(chars, start, i);
          start = -1;
        }
      } else if (start < 0) {
        start = i;
      }
    }
    if (start >= 0) {
      reverseValues(chars, start, levels.length);
    }
  }
  for (i = 0, ii = chars.length; i < ii; ++i) {
    var ch = chars[i];
    if (ch === '<' || ch === '>') {
      chars[i] = '';
    }
  }
  return createBidiText(chars.join(''), isLTR);
}
exports.bidi = bidi;

/***/ }),
/* 21 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ISOAdobeCharset = ['.notdef', 'space', 'exclam', 'quotedbl', 'numbersign', 'dollar', 'percent', 'ampersand', 'quoteright', 'parenleft', 'parenright', 'asterisk', 'plus', 'comma', 'hyphen', 'period', 'slash', 'zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'colon', 'semicolon', 'less', 'equal', 'greater', 'question', 'at', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'bracketleft', 'backslash', 'bracketright', 'asciicircum', 'underscore', 'quoteleft', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'braceleft', 'bar', 'braceright', 'asciitilde', 'exclamdown', 'cent', 'sterling', 'fraction', 'yen', 'florin', 'section', 'currency', 'quotesingle', 'quotedblleft', 'guillemotleft', 'guilsinglleft', 'guilsinglright', 'fi', 'fl', 'endash', 'dagger', 'daggerdbl', 'periodcentered', 'paragraph', 'bullet', 'quotesinglbase', 'quotedblbase', 'quotedblright', 'guillemotright', 'ellipsis', 'perthousand', 'questiondown', 'grave', 'acute', 'circumflex', 'tilde', 'macron', 'breve', 'dotaccent', 'dieresis', 'ring', 'cedilla', 'hungarumlaut', 'ogonek', 'caron', 'emdash', 'AE', 'ordfeminine', 'Lslash', 'Oslash', 'OE', 'ordmasculine', 'ae', 'dotlessi', 'lslash', 'oslash', 'oe', 'germandbls', 'onesuperior', 'logicalnot', 'mu', 'trademark', 'Eth', 'onehalf', 'plusminus', 'Thorn', 'onequarter', 'divide', 'brokenbar', 'degree', 'thorn', 'threequarters', 'twosuperior', 'registered', 'minus', 'eth', 'multiply', 'threesuperior', 'copyright', 'Aacute', 'Acircumflex', 'Adieresis', 'Agrave', 'Aring', 'Atilde', 'Ccedilla', 'Eacute', 'Ecircumflex', 'Edieresis', 'Egrave', 'Iacute', 'Icircumflex', 'Idieresis', 'Igrave', 'Ntilde', 'Oacute', 'Ocircumflex', 'Odieresis', 'Ograve', 'Otilde', 'Scaron', 'Uacute', 'Ucircumflex', 'Udieresis', 'Ugrave', 'Yacute', 'Ydieresis', 'Zcaron', 'aacute', 'acircumflex', 'adieresis', 'agrave', 'aring', 'atilde', 'ccedilla', 'eacute', 'ecircumflex', 'edieresis', 'egrave', 'iacute', 'icircumflex', 'idieresis', 'igrave', 'ntilde', 'oacute', 'ocircumflex', 'odieresis', 'ograve', 'otilde', 'scaron', 'uacute', 'ucircumflex', 'udieresis', 'ugrave', 'yacute', 'ydieresis', 'zcaron'];
var ExpertCharset = ['.notdef', 'space', 'exclamsmall', 'Hungarumlautsmall', 'dollaroldstyle', 'dollarsuperior', 'ampersandsmall', 'Acutesmall', 'parenleftsuperior', 'parenrightsuperior', 'twodotenleader', 'onedotenleader', 'comma', 'hyphen', 'period', 'fraction', 'zerooldstyle', 'oneoldstyle', 'twooldstyle', 'threeoldstyle', 'fouroldstyle', 'fiveoldstyle', 'sixoldstyle', 'sevenoldstyle', 'eightoldstyle', 'nineoldstyle', 'colon', 'semicolon', 'commasuperior', 'threequartersemdash', 'periodsuperior', 'questionsmall', 'asuperior', 'bsuperior', 'centsuperior', 'dsuperior', 'esuperior', 'isuperior', 'lsuperior', 'msuperior', 'nsuperior', 'osuperior', 'rsuperior', 'ssuperior', 'tsuperior', 'ff', 'fi', 'fl', 'ffi', 'ffl', 'parenleftinferior', 'parenrightinferior', 'Circumflexsmall', 'hyphensuperior', 'Gravesmall', 'Asmall', 'Bsmall', 'Csmall', 'Dsmall', 'Esmall', 'Fsmall', 'Gsmall', 'Hsmall', 'Ismall', 'Jsmall', 'Ksmall', 'Lsmall', 'Msmall', 'Nsmall', 'Osmall', 'Psmall', 'Qsmall', 'Rsmall', 'Ssmall', 'Tsmall', 'Usmall', 'Vsmall', 'Wsmall', 'Xsmall', 'Ysmall', 'Zsmall', 'colonmonetary', 'onefitted', 'rupiah', 'Tildesmall', 'exclamdownsmall', 'centoldstyle', 'Lslashsmall', 'Scaronsmall', 'Zcaronsmall', 'Dieresissmall', 'Brevesmall', 'Caronsmall', 'Dotaccentsmall', 'Macronsmall', 'figuredash', 'hypheninferior', 'Ogoneksmall', 'Ringsmall', 'Cedillasmall', 'onequarter', 'onehalf', 'threequarters', 'questiondownsmall', 'oneeighth', 'threeeighths', 'fiveeighths', 'seveneighths', 'onethird', 'twothirds', 'zerosuperior', 'onesuperior', 'twosuperior', 'threesuperior', 'foursuperior', 'fivesuperior', 'sixsuperior', 'sevensuperior', 'eightsuperior', 'ninesuperior', 'zeroinferior', 'oneinferior', 'twoinferior', 'threeinferior', 'fourinferior', 'fiveinferior', 'sixinferior', 'seveninferior', 'eightinferior', 'nineinferior', 'centinferior', 'dollarinferior', 'periodinferior', 'commainferior', 'Agravesmall', 'Aacutesmall', 'Acircumflexsmall', 'Atildesmall', 'Adieresissmall', 'Aringsmall', 'AEsmall', 'Ccedillasmall', 'Egravesmall', 'Eacutesmall', 'Ecircumflexsmall', 'Edieresissmall', 'Igravesmall', 'Iacutesmall', 'Icircumflexsmall', 'Idieresissmall', 'Ethsmall', 'Ntildesmall', 'Ogravesmall', 'Oacutesmall', 'Ocircumflexsmall', 'Otildesmall', 'Odieresissmall', 'OEsmall', 'Oslashsmall', 'Ugravesmall', 'Uacutesmall', 'Ucircumflexsmall', 'Udieresissmall', 'Yacutesmall', 'Thornsmall', 'Ydieresissmall'];
var ExpertSubsetCharset = ['.notdef', 'space', 'dollaroldstyle', 'dollarsuperior', 'parenleftsuperior', 'parenrightsuperior', 'twodotenleader', 'onedotenleader', 'comma', 'hyphen', 'period', 'fraction', 'zerooldstyle', 'oneoldstyle', 'twooldstyle', 'threeoldstyle', 'fouroldstyle', 'fiveoldstyle', 'sixoldstyle', 'sevenoldstyle', 'eightoldstyle', 'nineoldstyle', 'colon', 'semicolon', 'commasuperior', 'threequartersemdash', 'periodsuperior', 'asuperior', 'bsuperior', 'centsuperior', 'dsuperior', 'esuperior', 'isuperior', 'lsuperior', 'msuperior', 'nsuperior', 'osuperior', 'rsuperior', 'ssuperior', 'tsuperior', 'ff', 'fi', 'fl', 'ffi', 'ffl', 'parenleftinferior', 'parenrightinferior', 'hyphensuperior', 'colonmonetary', 'onefitted', 'rupiah', 'centoldstyle', 'figuredash', 'hypheninferior', 'onequarter', 'onehalf', 'threequarters', 'oneeighth', 'threeeighths', 'fiveeighths', 'seveneighths', 'onethird', 'twothirds', 'zerosuperior', 'onesuperior', 'twosuperior', 'threesuperior', 'foursuperior', 'fivesuperior', 'sixsuperior', 'sevensuperior', 'eightsuperior', 'ninesuperior', 'zeroinferior', 'oneinferior', 'twoinferior', 'threeinferior', 'fourinferior', 'fiveinferior', 'sixinferior', 'seveninferior', 'eightinferior', 'nineinferior', 'centinferior', 'dollarinferior', 'periodinferior', 'commainferior'];
exports.ISOAdobeCharset = ISOAdobeCharset;
exports.ExpertCharset = ExpertCharset;
exports.ExpertSubsetCharset = ExpertSubsetCharset;

/***/ }),
/* 22 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CMapFactory = exports.IdentityCMap = exports.CMap = undefined;

var _util = __w_pdfjs_require__(0);

var _primitives = __w_pdfjs_require__(1);

var _parser = __w_pdfjs_require__(5);

var _stream = __w_pdfjs_require__(2);

var BUILT_IN_CMAPS = ['Adobe-GB1-UCS2', 'Adobe-CNS1-UCS2', 'Adobe-Japan1-UCS2', 'Adobe-Korea1-UCS2', '78-EUC-H', '78-EUC-V', '78-H', '78-RKSJ-H', '78-RKSJ-V', '78-V', '78ms-RKSJ-H', '78ms-RKSJ-V', '83pv-RKSJ-H', '90ms-RKSJ-H', '90ms-RKSJ-V', '90msp-RKSJ-H', '90msp-RKSJ-V', '90pv-RKSJ-H', '90pv-RKSJ-V', 'Add-H', 'Add-RKSJ-H', 'Add-RKSJ-V', 'Add-V', 'Adobe-CNS1-0', 'Adobe-CNS1-1', 'Adobe-CNS1-2', 'Adobe-CNS1-3', 'Adobe-CNS1-4', 'Adobe-CNS1-5', 'Adobe-CNS1-6', 'Adobe-GB1-0', 'Adobe-GB1-1', 'Adobe-GB1-2', 'Adobe-GB1-3', 'Adobe-GB1-4', 'Adobe-GB1-5', 'Adobe-Japan1-0', 'Adobe-Japan1-1', 'Adobe-Japan1-2', 'Adobe-Japan1-3', 'Adobe-Japan1-4', 'Adobe-Japan1-5', 'Adobe-Japan1-6', 'Adobe-Korea1-0', 'Adobe-Korea1-1', 'Adobe-Korea1-2', 'B5-H', 'B5-V', 'B5pc-H', 'B5pc-V', 'CNS-EUC-H', 'CNS-EUC-V', 'CNS1-H', 'CNS1-V', 'CNS2-H', 'CNS2-V', 'ETHK-B5-H', 'ETHK-B5-V', 'ETen-B5-H', 'ETen-B5-V', 'ETenms-B5-H', 'ETenms-B5-V', 'EUC-H', 'EUC-V', 'Ext-H', 'Ext-RKSJ-H', 'Ext-RKSJ-V', 'Ext-V', 'GB-EUC-H', 'GB-EUC-V', 'GB-H', 'GB-V', 'GBK-EUC-H', 'GBK-EUC-V', 'GBK2K-H', 'GBK2K-V', 'GBKp-EUC-H', 'GBKp-EUC-V', 'GBT-EUC-H', 'GBT-EUC-V', 'GBT-H', 'GBT-V', 'GBTpc-EUC-H', 'GBTpc-EUC-V', 'GBpc-EUC-H', 'GBpc-EUC-V', 'H', 'HKdla-B5-H', 'HKdla-B5-V', 'HKdlb-B5-H', 'HKdlb-B5-V', 'HKgccs-B5-H', 'HKgccs-B5-V', 'HKm314-B5-H', 'HKm314-B5-V', 'HKm471-B5-H', 'HKm471-B5-V', 'HKscs-B5-H', 'HKscs-B5-V', 'Hankaku', 'Hiragana', 'KSC-EUC-H', 'KSC-EUC-V', 'KSC-H', 'KSC-Johab-H', 'KSC-Johab-V', 'KSC-V', 'KSCms-UHC-H', 'KSCms-UHC-HW-H', 'KSCms-UHC-HW-V', 'KSCms-UHC-V', 'KSCpc-EUC-H', 'KSCpc-EUC-V', 'Katakana', 'NWP-H', 'NWP-V', 'RKSJ-H', 'RKSJ-V', 'Roman', 'UniCNS-UCS2-H', 'UniCNS-UCS2-V', 'UniCNS-UTF16-H', 'UniCNS-UTF16-V', 'UniCNS-UTF32-H', 'UniCNS-UTF32-V', 'UniCNS-UTF8-H', 'UniCNS-UTF8-V', 'UniGB-UCS2-H', 'UniGB-UCS2-V', 'UniGB-UTF16-H', 'UniGB-UTF16-V', 'UniGB-UTF32-H', 'UniGB-UTF32-V', 'UniGB-UTF8-H', 'UniGB-UTF8-V', 'UniJIS-UCS2-H', 'UniJIS-UCS2-HW-H', 'UniJIS-UCS2-HW-V', 'UniJIS-UCS2-V', 'UniJIS-UTF16-H', 'UniJIS-UTF16-V', 'UniJIS-UTF32-H', 'UniJIS-UTF32-V', 'UniJIS-UTF8-H', 'UniJIS-UTF8-V', 'UniJIS2004-UTF16-H', 'UniJIS2004-UTF16-V', 'UniJIS2004-UTF32-H', 'UniJIS2004-UTF32-V', 'UniJIS2004-UTF8-H', 'UniJIS2004-UTF8-V', 'UniJISPro-UCS2-HW-V', 'UniJISPro-UCS2-V', 'UniJISPro-UTF8-V', 'UniJISX0213-UTF32-H', 'UniJISX0213-UTF32-V', 'UniJISX02132004-UTF32-H', 'UniJISX02132004-UTF32-V', 'UniKS-UCS2-H', 'UniKS-UCS2-V', 'UniKS-UTF16-H', 'UniKS-UTF16-V', 'UniKS-UTF32-H', 'UniKS-UTF32-V', 'UniKS-UTF8-H', 'UniKS-UTF8-V', 'V', 'WP-Symbol'];
var CMap = function CMapClosure() {
  function CMap(builtInCMap) {
    this.codespaceRanges = [[], [], [], []];
    this.numCodespaceRanges = 0;
    this._map = [];
    this.name = '';
    this.vertical = false;
    this.useCMap = null;
    this.builtInCMap = builtInCMap;
  }
  CMap.prototype = {
    addCodespaceRange: function addCodespaceRange(n, low, high) {
      this.codespaceRanges[n - 1].push(low, high);
      this.numCodespaceRanges++;
    },
    mapCidRange: function mapCidRange(low, high, dstLow) {
      while (low <= high) {
        this._map[low++] = dstLow++;
      }
    },
    mapBfRange: function mapBfRange(low, high, dstLow) {
      var lastByte = dstLow.length - 1;
      while (low <= high) {
        this._map[low++] = dstLow;
        dstLow = dstLow.substr(0, lastByte) + String.fromCharCode(dstLow.charCodeAt(lastByte) + 1);
      }
    },
    mapBfRangeToArray: function mapBfRangeToArray(low, high, array) {
      var i = 0,
          ii = array.length;
      while (low <= high && i < ii) {
        this._map[low] = array[i++];
        ++low;
      }
    },
    mapOne: function mapOne(src, dst) {
      this._map[src] = dst;
    },
    lookup: function lookup(code) {
      return this._map[code];
    },
    contains: function contains(code) {
      return this._map[code] !== undefined;
    },
    forEach: function forEach(callback) {
      var map = this._map;
      var length = map.length;
      if (length <= 0x10000) {
        for (var i = 0; i < length; i++) {
          if (map[i] !== undefined) {
            callback(i, map[i]);
          }
        }
      } else {
        for (var _i in map) {
          callback(_i, map[_i]);
        }
      }
    },
    charCodeOf: function charCodeOf(value) {
      var map = this._map;
      if (map.length <= 0x10000) {
        return map.indexOf(value);
      }
      for (var charCode in map) {
        if (map[charCode] === value) {
          return charCode | 0;
        }
      }
      return -1;
    },
    getMap: function getMap() {
      return this._map;
    },
    readCharCode: function readCharCode(str, offset, out) {
      var c = 0;
      var codespaceRanges = this.codespaceRanges;
      var codespaceRangesLen = this.codespaceRanges.length;
      for (var n = 0; n < codespaceRangesLen; n++) {
        c = (c << 8 | str.charCodeAt(offset + n)) >>> 0;
        var codespaceRange = codespaceRanges[n];
        for (var k = 0, kk = codespaceRange.length; k < kk;) {
          var low = codespaceRange[k++];
          var high = codespaceRange[k++];
          if (c >= low && c <= high) {
            out.charcode = c;
            out.length = n + 1;
            return;
          }
        }
      }
      out.charcode = 0;
      out.length = 1;
    },

    get length() {
      return this._map.length;
    },
    get isIdentityCMap() {
      if (!(this.name === 'Identity-H' || this.name === 'Identity-V')) {
        return false;
      }
      if (this._map.length !== 0x10000) {
        return false;
      }
      for (var i = 0; i < 0x10000; i++) {
        if (this._map[i] !== i) {
          return false;
        }
      }
      return true;
    }
  };
  return CMap;
}();
var IdentityCMap = function IdentityCMapClosure() {
  function IdentityCMap(vertical, n) {
    CMap.call(this);
    this.vertical = vertical;
    this.addCodespaceRange(n, 0, 0xffff);
  }
  _util.Util.inherit(IdentityCMap, CMap, {});
  IdentityCMap.prototype = {
    addCodespaceRange: CMap.prototype.addCodespaceRange,
    mapCidRange: function mapCidRange(low, high, dstLow) {
      throw new Error('should not call mapCidRange');
    },
    mapBfRange: function mapBfRange(low, high, dstLow) {
      throw new Error('should not call mapBfRange');
    },
    mapBfRangeToArray: function mapBfRangeToArray(low, high, array) {
      throw new Error('should not call mapBfRangeToArray');
    },
    mapOne: function mapOne(src, dst) {
      throw new Error('should not call mapCidOne');
    },
    lookup: function lookup(code) {
      return (0, _util.isInt)(code) && code <= 0xffff ? code : undefined;
    },
    contains: function contains(code) {
      return (0, _util.isInt)(code) && code <= 0xffff;
    },
    forEach: function forEach(callback) {
      for (var i = 0; i <= 0xffff; i++) {
        callback(i, i);
      }
    },
    charCodeOf: function charCodeOf(value) {
      return (0, _util.isInt)(value) && value <= 0xffff ? value : -1;
    },
    getMap: function getMap() {
      var map = new Array(0x10000);
      for (var i = 0; i <= 0xffff; i++) {
        map[i] = i;
      }
      return map;
    },

    readCharCode: CMap.prototype.readCharCode,
    get length() {
      return 0x10000;
    },
    get isIdentityCMap() {
      throw new Error('should not access .isIdentityCMap');
    }
  };
  return IdentityCMap;
}();
var BinaryCMapReader = function BinaryCMapReaderClosure() {
  function hexToInt(a, size) {
    var n = 0;
    for (var i = 0; i <= size; i++) {
      n = n << 8 | a[i];
    }
    return n >>> 0;
  }
  function hexToStr(a, size) {
    if (size === 1) {
      return String.fromCharCode(a[0], a[1]);
    }
    if (size === 3) {
      return String.fromCharCode(a[0], a[1], a[2], a[3]);
    }
    return String.fromCharCode.apply(null, a.subarray(0, size + 1));
  }
  function addHex(a, b, size) {
    var c = 0;
    for (var i = size; i >= 0; i--) {
      c += a[i] + b[i];
      a[i] = c & 255;
      c >>= 8;
    }
  }
  function incHex(a, size) {
    var c = 1;
    for (var i = size; i >= 0 && c > 0; i--) {
      c += a[i];
      a[i] = c & 255;
      c >>= 8;
    }
  }
  var MAX_NUM_SIZE = 16;
  var MAX_ENCODED_NUM_SIZE = 19;
  function BinaryCMapStream(data) {
    this.buffer = data;
    this.pos = 0;
    this.end = data.length;
    this.tmpBuf = new Uint8Array(MAX_ENCODED_NUM_SIZE);
  }
  BinaryCMapStream.prototype = {
    readByte: function readByte() {
      if (this.pos >= this.end) {
        return -1;
      }
      return this.buffer[this.pos++];
    },
    readNumber: function readNumber() {
      var n = 0;
      var last;
      do {
        var b = this.readByte();
        if (b < 0) {
          throw new _util.FormatError('unexpected EOF in bcmap');
        }
        last = !(b & 0x80);
        n = n << 7 | b & 0x7F;
      } while (!last);
      return n;
    },
    readSigned: function readSigned() {
      var n = this.readNumber();
      return n & 1 ? ~(n >>> 1) : n >>> 1;
    },
    readHex: function readHex(num, size) {
      num.set(this.buffer.subarray(this.pos, this.pos + size + 1));
      this.pos += size + 1;
    },
    readHexNumber: function readHexNumber(num, size) {
      var last;
      var stack = this.tmpBuf,
          sp = 0;
      do {
        var b = this.readByte();
        if (b < 0) {
          throw new _util.FormatError('unexpected EOF in bcmap');
        }
        last = !(b & 0x80);
        stack[sp++] = b & 0x7F;
      } while (!last);
      var i = size,
          buffer = 0,
          bufferSize = 0;
      while (i >= 0) {
        while (bufferSize < 8 && stack.length > 0) {
          buffer = stack[--sp] << bufferSize | buffer;
          bufferSize += 7;
        }
        num[i] = buffer & 255;
        i--;
        buffer >>= 8;
        bufferSize -= 8;
      }
    },
    readHexSigned: function readHexSigned(num, size) {
      this.readHexNumber(num, size);
      var sign = num[size] & 1 ? 255 : 0;
      var c = 0;
      for (var i = 0; i <= size; i++) {
        c = (c & 1) << 8 | num[i];
        num[i] = c >> 1 ^ sign;
      }
    },
    readString: function readString() {
      var len = this.readNumber();
      var s = '';
      for (var i = 0; i < len; i++) {
        s += String.fromCharCode(this.readNumber());
      }
      return s;
    }
  };
  function processBinaryCMap(data, cMap, extend) {
    return new Promise(function (resolve, reject) {
      var stream = new BinaryCMapStream(data);
      var header = stream.readByte();
      cMap.vertical = !!(header & 1);
      var useCMap = null;
      var start = new Uint8Array(MAX_NUM_SIZE);
      var end = new Uint8Array(MAX_NUM_SIZE);
      var char = new Uint8Array(MAX_NUM_SIZE);
      var charCode = new Uint8Array(MAX_NUM_SIZE);
      var tmp = new Uint8Array(MAX_NUM_SIZE);
      var code;
      var b;
      while ((b = stream.readByte()) >= 0) {
        var type = b >> 5;
        if (type === 7) {
          switch (b & 0x1F) {
            case 0:
              stream.readString();
              break;
            case 1:
              useCMap = stream.readString();
              break;
          }
          continue;
        }
        var sequence = !!(b & 0x10);
        var dataSize = b & 15;
        if (dataSize + 1 > MAX_NUM_SIZE) {
          throw new Error('processBinaryCMap: Invalid dataSize.');
        }
        var ucs2DataSize = 1;
        var subitemsCount = stream.readNumber();
        var i;
        switch (type) {
          case 0:
            stream.readHex(start, dataSize);
            stream.readHexNumber(end, dataSize);
            addHex(end, start, dataSize);
            cMap.addCodespaceRange(dataSize + 1, hexToInt(start, dataSize), hexToInt(end, dataSize));
            for (i = 1; i < subitemsCount; i++) {
              incHex(end, dataSize);
              stream.readHexNumber(start, dataSize);
              addHex(start, end, dataSize);
              stream.readHexNumber(end, dataSize);
              addHex(end, start, dataSize);
              cMap.addCodespaceRange(dataSize + 1, hexToInt(start, dataSize), hexToInt(end, dataSize));
            }
            break;
          case 1:
            stream.readHex(start, dataSize);
            stream.readHexNumber(end, dataSize);
            addHex(end, start, dataSize);
            code = stream.readNumber();
            for (i = 1; i < subitemsCount; i++) {
              incHex(end, dataSize);
              stream.readHexNumber(start, dataSize);
              addHex(start, end, dataSize);
              stream.readHexNumber(end, dataSize);
              addHex(end, start, dataSize);
              code = stream.readNumber();
            }
            break;
          case 2:
            stream.readHex(char, dataSize);
            code = stream.readNumber();
            cMap.mapOne(hexToInt(char, dataSize), code);
            for (i = 1; i < subitemsCount; i++) {
              incHex(char, dataSize);
              if (!sequence) {
                stream.readHexNumber(tmp, dataSize);
                addHex(char, tmp, dataSize);
              }
              code = stream.readSigned() + (code + 1);
              cMap.mapOne(hexToInt(char, dataSize), code);
            }
            break;
          case 3:
            stream.readHex(start, dataSize);
            stream.readHexNumber(end, dataSize);
            addHex(end, start, dataSize);
            code = stream.readNumber();
            cMap.mapCidRange(hexToInt(start, dataSize), hexToInt(end, dataSize), code);
            for (i = 1; i < subitemsCount; i++) {
              incHex(end, dataSize);
              if (!sequence) {
                stream.readHexNumber(start, dataSize);
                addHex(start, end, dataSize);
              } else {
                start.set(end);
              }
              stream.readHexNumber(end, dataSize);
              addHex(end, start, dataSize);
              code = stream.readNumber();
              cMap.mapCidRange(hexToInt(start, dataSize), hexToInt(end, dataSize), code);
            }
            break;
          case 4:
            stream.readHex(char, ucs2DataSize);
            stream.readHex(charCode, dataSize);
            cMap.mapOne(hexToInt(char, ucs2DataSize), hexToStr(charCode, dataSize));
            for (i = 1; i < subitemsCount; i++) {
              incHex(char, ucs2DataSize);
              if (!sequence) {
                stream.readHexNumber(tmp, ucs2DataSize);
                addHex(char, tmp, ucs2DataSize);
              }
              incHex(charCode, dataSize);
              stream.readHexSigned(tmp, dataSize);
              addHex(charCode, tmp, dataSize);
              cMap.mapOne(hexToInt(char, ucs2DataSize), hexToStr(charCode, dataSize));
            }
            break;
          case 5:
            stream.readHex(start, ucs2DataSize);
            stream.readHexNumber(end, ucs2DataSize);
            addHex(end, start, ucs2DataSize);
            stream.readHex(charCode, dataSize);
            cMap.mapBfRange(hexToInt(start, ucs2DataSize), hexToInt(end, ucs2DataSize), hexToStr(charCode, dataSize));
            for (i = 1; i < subitemsCount; i++) {
              incHex(end, ucs2DataSize);
              if (!sequence) {
                stream.readHexNumber(start, ucs2DataSize);
                addHex(start, end, ucs2DataSize);
              } else {
                start.set(end);
              }
              stream.readHexNumber(end, ucs2DataSize);
              addHex(end, start, ucs2DataSize);
              stream.readHex(charCode, dataSize);
              cMap.mapBfRange(hexToInt(start, ucs2DataSize), hexToInt(end, ucs2DataSize), hexToStr(charCode, dataSize));
            }
            break;
          default:
            reject(new Error('processBinaryCMap: Unknown type: ' + type));
            return;
        }
      }
      if (useCMap) {
        resolve(extend(useCMap));
        return;
      }
      resolve(cMap);
    });
  }
  function BinaryCMapReader() {}
  BinaryCMapReader.prototype = { process: processBinaryCMap };
  return BinaryCMapReader;
}();
var CMapFactory = function CMapFactoryClosure() {
  function strToInt(str) {
    var a = 0;
    for (var i = 0; i < str.length; i++) {
      a = a << 8 | str.charCodeAt(i);
    }
    return a >>> 0;
  }
  function expectString(obj) {
    if (!(0, _util.isString)(obj)) {
      throw new _util.FormatError('Malformed CMap: expected string.');
    }
  }
  function expectInt(obj) {
    if (!(0, _util.isInt)(obj)) {
      throw new _util.FormatError('Malformed CMap: expected int.');
    }
  }
  function parseBfChar(cMap, lexer) {
    while (true) {
      var obj = lexer.getObj();
      if ((0, _primitives.isEOF)(obj)) {
        break;
      }
      if ((0, _primitives.isCmd)(obj, 'endbfchar')) {
        return;
      }
      expectString(obj);
      var src = strToInt(obj);
      obj = lexer.getObj();
      expectString(obj);
      var dst = obj;
      cMap.mapOne(src, dst);
    }
  }
  function parseBfRange(cMap, lexer) {
    while (true) {
      var obj = lexer.getObj();
      if ((0, _primitives.isEOF)(obj)) {
        break;
      }
      if ((0, _primitives.isCmd)(obj, 'endbfrange')) {
        return;
      }
      expectString(obj);
      var low = strToInt(obj);
      obj = lexer.getObj();
      expectString(obj);
      var high = strToInt(obj);
      obj = lexer.getObj();
      if ((0, _util.isInt)(obj) || (0, _util.isString)(obj)) {
        var dstLow = (0, _util.isInt)(obj) ? String.fromCharCode(obj) : obj;
        cMap.mapBfRange(low, high, dstLow);
      } else if ((0, _primitives.isCmd)(obj, '[')) {
        obj = lexer.getObj();
        var array = [];
        while (!(0, _primitives.isCmd)(obj, ']') && !(0, _primitives.isEOF)(obj)) {
          array.push(obj);
          obj = lexer.getObj();
        }
        cMap.mapBfRangeToArray(low, high, array);
      } else {
        break;
      }
    }
    throw new _util.FormatError('Invalid bf range.');
  }
  function parseCidChar(cMap, lexer) {
    while (true) {
      var obj = lexer.getObj();
      if ((0, _primitives.isEOF)(obj)) {
        break;
      }
      if ((0, _primitives.isCmd)(obj, 'endcidchar')) {
        return;
      }
      expectString(obj);
      var src = strToInt(obj);
      obj = lexer.getObj();
      expectInt(obj);
      var dst = obj;
      cMap.mapOne(src, dst);
    }
  }
  function parseCidRange(cMap, lexer) {
    while (true) {
      var obj = lexer.getObj();
      if ((0, _primitives.isEOF)(obj)) {
        break;
      }
      if ((0, _primitives.isCmd)(obj, 'endcidrange')) {
        return;
      }
      expectString(obj);
      var low = strToInt(obj);
      obj = lexer.getObj();
      expectString(obj);
      var high = strToInt(obj);
      obj = lexer.getObj();
      expectInt(obj);
      var dstLow = obj;
      cMap.mapCidRange(low, high, dstLow);
    }
  }
  function parseCodespaceRange(cMap, lexer) {
    while (true) {
      var obj = lexer.getObj();
      if ((0, _primitives.isEOF)(obj)) {
        break;
      }
      if ((0, _primitives.isCmd)(obj, 'endcodespacerange')) {
        return;
      }
      if (!(0, _util.isString)(obj)) {
        break;
      }
      var low = strToInt(obj);
      obj = lexer.getObj();
      if (!(0, _util.isString)(obj)) {
        break;
      }
      var high = strToInt(obj);
      cMap.addCodespaceRange(obj.length, low, high);
    }
    throw new _util.FormatError('Invalid codespace range.');
  }
  function parseWMode(cMap, lexer) {
    var obj = lexer.getObj();
    if ((0, _util.isInt)(obj)) {
      cMap.vertical = !!obj;
    }
  }
  function parseCMapName(cMap, lexer) {
    var obj = lexer.getObj();
    if ((0, _primitives.isName)(obj) && (0, _util.isString)(obj.name)) {
      cMap.name = obj.name;
    }
  }
  function parseCMap(cMap, lexer, fetchBuiltInCMap, useCMap) {
    var previous;
    var embededUseCMap;
    objLoop: while (true) {
      try {
        var obj = lexer.getObj();
        if ((0, _primitives.isEOF)(obj)) {
          break;
        } else if ((0, _primitives.isName)(obj)) {
          if (obj.name === 'WMode') {
            parseWMode(cMap, lexer);
          } else if (obj.name === 'CMapName') {
            parseCMapName(cMap, lexer);
          }
          previous = obj;
        } else if ((0, _primitives.isCmd)(obj)) {
          switch (obj.cmd) {
            case 'endcmap':
              break objLoop;
            case 'usecmap':
              if ((0, _primitives.isName)(previous)) {
                embededUseCMap = previous.name;
              }
              break;
            case 'begincodespacerange':
              parseCodespaceRange(cMap, lexer);
              break;
            case 'beginbfchar':
              parseBfChar(cMap, lexer);
              break;
            case 'begincidchar':
              parseCidChar(cMap, lexer);
              break;
            case 'beginbfrange':
              parseBfRange(cMap, lexer);
              break;
            case 'begincidrange':
              parseCidRange(cMap, lexer);
              break;
          }
        }
      } catch (ex) {
        if (ex instanceof _util.MissingDataException) {
          throw ex;
        }
        (0, _util.warn)('Invalid cMap data: ' + ex);
        continue;
      }
    }
    if (!useCMap && embededUseCMap) {
      useCMap = embededUseCMap;
    }
    if (useCMap) {
      return extendCMap(cMap, fetchBuiltInCMap, useCMap);
    }
    return Promise.resolve(cMap);
  }
  function extendCMap(cMap, fetchBuiltInCMap, useCMap) {
    return createBuiltInCMap(useCMap, fetchBuiltInCMap).then(function (newCMap) {
      cMap.useCMap = newCMap;
      if (cMap.numCodespaceRanges === 0) {
        var useCodespaceRanges = cMap.useCMap.codespaceRanges;
        for (var i = 0; i < useCodespaceRanges.length; i++) {
          cMap.codespaceRanges[i] = useCodespaceRanges[i].slice();
        }
        cMap.numCodespaceRanges = cMap.useCMap.numCodespaceRanges;
      }
      cMap.useCMap.forEach(function (key, value) {
        if (!cMap.contains(key)) {
          cMap.mapOne(key, cMap.useCMap.lookup(key));
        }
      });
      return cMap;
    });
  }
  function createBuiltInCMap(name, fetchBuiltInCMap) {
    if (name === 'Identity-H') {
      return Promise.resolve(new IdentityCMap(false, 2));
    } else if (name === 'Identity-V') {
      return Promise.resolve(new IdentityCMap(true, 2));
    }
    if (BUILT_IN_CMAPS.indexOf(name) === -1) {
      return Promise.reject(new Error('Unknown CMap name: ' + name));
    }
    if (!fetchBuiltInCMap) {
      return Promise.reject(new Error('Built-in CMap parameters are not provided.'));
    }
    return fetchBuiltInCMap(name).then(function (data) {
      var cMapData = data.cMapData,
          compressionType = data.compressionType;
      var cMap = new CMap(true);
      if (compressionType === _util.CMapCompressionType.BINARY) {
        return new BinaryCMapReader().process(cMapData, cMap, function (useCMap) {
          return extendCMap(cMap, fetchBuiltInCMap, useCMap);
        });
      }
      if (compressionType === _util.CMapCompressionType.NONE) {
        var lexer = new _parser.Lexer(new _stream.Stream(cMapData));
        return parseCMap(cMap, lexer, fetchBuiltInCMap, null);
      }
      return Promise.reject(new Error('TODO: Only BINARY/NONE CMap compression is currently supported.'));
    });
  }
  return {
    create: function create(params) {
      var encoding = params.encoding;
      var fetchBuiltInCMap = params.fetchBuiltInCMap;
      var useCMap = params.useCMap;
      if ((0, _primitives.isName)(encoding)) {
        return createBuiltInCMap(encoding.name, fetchBuiltInCMap);
      } else if ((0, _primitives.isStream)(encoding)) {
        var cMap = new CMap();
        var lexer = new _parser.Lexer(encoding);
        return parseCMap(cMap, lexer, fetchBuiltInCMap, useCMap).then(function (parsedCMap) {
          if (parsedCMap.isIdentityCMap) {
            return createBuiltInCMap(parsedCMap.name, fetchBuiltInCMap);
          }
          return parsedCMap;
        });
      }
      return Promise.reject(new Error('Encoding required.'));
    }
  };
}();
exports.CMap = CMap;
exports.IdentityCMap = IdentityCMap;
exports.CMapFactory = CMapFactory;

/***/ }),
/* 23 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PDFDocument = exports.Page = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _obj = __w_pdfjs_require__(14);

var _primitives = __w_pdfjs_require__(1);

var _util = __w_pdfjs_require__(0);

var _stream = __w_pdfjs_require__(2);

var _evaluator = __w_pdfjs_require__(12);

var _annotation = __w_pdfjs_require__(19);

var _crypto = __w_pdfjs_require__(11);

var _parser = __w_pdfjs_require__(5);

var Page = function PageClosure() {
  var DEFAULT_USER_UNIT = 1.0;
  var LETTER_SIZE_MEDIABOX = [0, 0, 612, 792];
  function isAnnotationRenderable(annotation, intent) {
    return intent === 'display' && annotation.viewable || intent === 'print' && annotation.printable;
  }
  function Page(pdfManager, xref, pageIndex, pageDict, ref, fontCache, builtInCMapCache) {
    this.pdfManager = pdfManager;
    this.pageIndex = pageIndex;
    this.pageDict = pageDict;
    this.xref = xref;
    this.ref = ref;
    this.fontCache = fontCache;
    this.builtInCMapCache = builtInCMapCache;
    this.evaluatorOptions = pdfManager.evaluatorOptions;
    this.resourcesPromise = null;
    var uniquePrefix = 'p' + this.pageIndex + '_';
    var idCounters = { obj: 0 };
    this.idFactory = {
      createObjId: function createObjId() {
        return uniquePrefix + ++idCounters.obj;
      }
    };
  }
  Page.prototype = {
    getPageProp: function Page_getPageProp(key) {
      return this.pageDict.get(key);
    },
    getInheritedPageProp: function Page_getInheritedPageProp(key, getArray) {
      var dict = this.pageDict,
          valueArray = null,
          loopCount = 0;
      var MAX_LOOP_COUNT = 100;
      getArray = getArray || false;
      while (dict) {
        var value = getArray ? dict.getArray(key) : dict.get(key);
        if (value !== undefined) {
          if (!valueArray) {
            valueArray = [];
          }
          valueArray.push(value);
        }
        if (++loopCount > MAX_LOOP_COUNT) {
          (0, _util.warn)('getInheritedPageProp: maximum loop count exceeded for ' + key);
          return valueArray ? valueArray[0] : undefined;
        }
        dict = dict.get('Parent');
      }
      if (!valueArray) {
        return undefined;
      }
      if (valueArray.length === 1 || !(0, _primitives.isDict)(valueArray[0])) {
        return valueArray[0];
      }
      return _primitives.Dict.merge(this.xref, valueArray);
    },
    get content() {
      return this.getPageProp('Contents');
    },
    get resources() {
      return (0, _util.shadow)(this, 'resources', this.getInheritedPageProp('Resources') || _primitives.Dict.empty);
    },
    get mediaBox() {
      var mediaBox = this.getInheritedPageProp('MediaBox', true);
      if (!(0, _util.isArray)(mediaBox) || mediaBox.length !== 4) {
        return (0, _util.shadow)(this, 'mediaBox', LETTER_SIZE_MEDIABOX);
      }
      return (0, _util.shadow)(this, 'mediaBox', mediaBox);
    },
    get cropBox() {
      var cropBox = this.getInheritedPageProp('CropBox', true);
      if (!(0, _util.isArray)(cropBox) || cropBox.length !== 4) {
        return (0, _util.shadow)(this, 'cropBox', this.mediaBox);
      }
      return (0, _util.shadow)(this, 'cropBox', cropBox);
    },
    get userUnit() {
      var obj = this.getPageProp('UserUnit');
      if (!(0, _util.isNum)(obj) || obj <= 0) {
        obj = DEFAULT_USER_UNIT;
      }
      return (0, _util.shadow)(this, 'userUnit', obj);
    },
    get view() {
      var mediaBox = this.mediaBox,
          cropBox = this.cropBox;
      if (mediaBox === cropBox) {
        return (0, _util.shadow)(this, 'view', mediaBox);
      }
      var intersection = _util.Util.intersect(cropBox, mediaBox);
      return (0, _util.shadow)(this, 'view', intersection || mediaBox);
    },
    get rotate() {
      var rotate = this.getInheritedPageProp('Rotate') || 0;
      if (rotate % 90 !== 0) {
        rotate = 0;
      } else if (rotate >= 360) {
        rotate = rotate % 360;
      } else if (rotate < 0) {
        rotate = (rotate % 360 + 360) % 360;
      }
      return (0, _util.shadow)(this, 'rotate', rotate);
    },
    getContentStream: function Page_getContentStream() {
      var content = this.content;
      var stream;
      if ((0, _util.isArray)(content)) {
        var xref = this.xref;
        var i,
            n = content.length;
        var streams = [];
        for (i = 0; i < n; ++i) {
          streams.push(xref.fetchIfRef(content[i]));
        }
        stream = new _stream.StreamsSequenceStream(streams);
      } else if ((0, _primitives.isStream)(content)) {
        stream = content;
      } else {
        stream = new _stream.NullStream();
      }
      return stream;
    },
    loadResources: function Page_loadResources(keys) {
      var _this = this;

      if (!this.resourcesPromise) {
        this.resourcesPromise = this.pdfManager.ensure(this, 'resources');
      }
      return this.resourcesPromise.then(function () {
        var objectLoader = new _obj.ObjectLoader(_this.resources, keys, _this.xref);
        return objectLoader.load();
      });
    },
    getOperatorList: function getOperatorList(_ref) {
      var _this2 = this;

      var handler = _ref.handler,
          task = _ref.task,
          intent = _ref.intent,
          renderInteractiveForms = _ref.renderInteractiveForms;

      var contentStreamPromise = this.pdfManager.ensure(this, 'getContentStream');
      var resourcesPromise = this.loadResources(['ExtGState', 'ColorSpace', 'Pattern', 'Shading', 'XObject', 'Font']);
      var partialEvaluator = new _evaluator.PartialEvaluator({
        pdfManager: this.pdfManager,
        xref: this.xref,
        handler: handler,
        pageIndex: this.pageIndex,
        idFactory: this.idFactory,
        fontCache: this.fontCache,
        builtInCMapCache: this.builtInCMapCache,
        options: this.evaluatorOptions
      });
      var dataPromises = Promise.all([contentStreamPromise, resourcesPromise]);
      var pageListPromise = dataPromises.then(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 1),
            contentStream = _ref3[0];

        var opList = new _evaluator.OperatorList(intent, handler, _this2.pageIndex);
        handler.send('StartRenderPage', {
          transparency: partialEvaluator.hasBlendModes(_this2.resources),
          pageIndex: _this2.pageIndex,
          intent: intent
        });
        return partialEvaluator.getOperatorList({
          stream: contentStream,
          task: task,
          resources: _this2.resources,
          operatorList: opList
        }).then(function () {
          return opList;
        });
      });
      var annotationsPromise = this.pdfManager.ensure(this, 'annotations');
      return Promise.all([pageListPromise, annotationsPromise]).then(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
            pageOpList = _ref5[0],
            annotations = _ref5[1];

        if (annotations.length === 0) {
          pageOpList.flush(true);
          return pageOpList;
        }
        var i,
            ii,
            opListPromises = [];
        for (i = 0, ii = annotations.length; i < ii; i++) {
          if (isAnnotationRenderable(annotations[i], intent)) {
            opListPromises.push(annotations[i].getOperatorList(partialEvaluator, task, renderInteractiveForms));
          }
        }
        return Promise.all(opListPromises).then(function (opLists) {
          pageOpList.addOp(_util.OPS.beginAnnotations, []);
          for (i = 0, ii = opLists.length; i < ii; i++) {
            pageOpList.addOpList(opLists[i]);
          }
          pageOpList.addOp(_util.OPS.endAnnotations, []);
          pageOpList.flush(true);
          return pageOpList;
        });
      });
    },
    extractTextContent: function extractTextContent(_ref6) {
      var _this3 = this;

      var handler = _ref6.handler,
          task = _ref6.task,
          normalizeWhitespace = _ref6.normalizeWhitespace,
          sink = _ref6.sink,
          combineTextItems = _ref6.combineTextItems;

      var contentStreamPromise = this.pdfManager.ensure(this, 'getContentStream');
      var resourcesPromise = this.loadResources(['ExtGState', 'XObject', 'Font']);
      var dataPromises = Promise.all([contentStreamPromise, resourcesPromise]);
      return dataPromises.then(function (_ref7) {
        var _ref8 = _slicedToArray(_ref7, 1),
            contentStream = _ref8[0];

        var partialEvaluator = new _evaluator.PartialEvaluator({
          pdfManager: _this3.pdfManager,
          xref: _this3.xref,
          handler: handler,
          pageIndex: _this3.pageIndex,
          idFactory: _this3.idFactory,
          fontCache: _this3.fontCache,
          builtInCMapCache: _this3.builtInCMapCache,
          options: _this3.evaluatorOptions
        });
        return partialEvaluator.getTextContent({
          stream: contentStream,
          task: task,
          resources: _this3.resources,
          normalizeWhitespace: normalizeWhitespace,
          combineTextItems: combineTextItems,
          sink: sink
        });
      });
    },

    getAnnotationsData: function Page_getAnnotationsData(intent) {
      var annotations = this.annotations;
      var annotationsData = [];
      for (var i = 0, n = annotations.length; i < n; ++i) {
        if (!intent || isAnnotationRenderable(annotations[i], intent)) {
          annotationsData.push(annotations[i].data);
        }
      }
      return annotationsData;
    },
    get annotations() {
      var annotations = [];
      var annotationRefs = this.getInheritedPageProp('Annots') || [];
      var annotationFactory = new _annotation.AnnotationFactory();
      for (var i = 0, n = annotationRefs.length; i < n; ++i) {
        var annotationRef = annotationRefs[i];
        var annotation = annotationFactory.create(this.xref, annotationRef, this.pdfManager, this.idFactory);
        if (annotation) {
          annotations.push(annotation);
        }
      }
      return (0, _util.shadow)(this, 'annotations', annotations);
    }
  };
  return Page;
}();
var PDFDocument = function PDFDocumentClosure() {
  var FINGERPRINT_FIRST_BYTES = 1024;
  var EMPTY_FINGERPRINT = '\x00\x00\x00\x00\x00\x00\x00' + '\x00\x00\x00\x00\x00\x00\x00\x00\x00';
  function PDFDocument(pdfManager, arg) {
    var stream;
    if ((0, _primitives.isStream)(arg)) {
      stream = arg;
    } else if ((0, _util.isArrayBuffer)(arg)) {
      stream = new _stream.Stream(arg);
    } else {
      throw new Error('PDFDocument: Unknown argument type');
    }
    if (stream.length <= 0) {
      throw new Error('PDFDocument: stream must have data');
    }
    this.pdfManager = pdfManager;
    this.stream = stream;
    this.xref = new _obj.XRef(stream, pdfManager);
  }
  function find(stream, needle, limit, backwards) {
    var pos = stream.pos;
    var end = stream.end;
    var strBuf = [];
    if (pos + limit > end) {
      limit = end - pos;
    }
    for (var n = 0; n < limit; ++n) {
      strBuf.push(String.fromCharCode(stream.getByte()));
    }
    var str = strBuf.join('');
    stream.pos = pos;
    var index = backwards ? str.lastIndexOf(needle) : str.indexOf(needle);
    if (index === -1) {
      return false;
    }
    stream.pos += index;
    return true;
  }
  var DocumentInfoValidators = {
    get entries() {
      return (0, _util.shadow)(this, 'entries', {
        Title: _util.isString,
        Author: _util.isString,
        Subject: _util.isString,
        Keywords: _util.isString,
        Creator: _util.isString,
        Producer: _util.isString,
        CreationDate: _util.isString,
        ModDate: _util.isString,
        Trapped: _primitives.isName
      });
    }
  };
  PDFDocument.prototype = {
    parse: function PDFDocument_parse(recoveryMode) {
      this.setup(recoveryMode);
      var version = this.catalog.catDict.get('Version');
      if ((0, _primitives.isName)(version)) {
        this.pdfFormatVersion = version.name;
      }
      try {
        this.acroForm = this.catalog.catDict.get('AcroForm');
        if (this.acroForm) {
          this.xfa = this.acroForm.get('XFA');
          var fields = this.acroForm.get('Fields');
          if ((!fields || !(0, _util.isArray)(fields) || fields.length === 0) && !this.xfa) {
            this.acroForm = null;
          }
        }
      } catch (ex) {
        if (ex instanceof _util.MissingDataException) {
          throw ex;
        }
        (0, _util.info)('Something wrong with AcroForm entry');
        this.acroForm = null;
      }
    },
    get linearization() {
      var linearization = null;
      if (this.stream.length) {
        try {
          linearization = _parser.Linearization.create(this.stream);
        } catch (err) {
          if (err instanceof _util.MissingDataException) {
            throw err;
          }
          (0, _util.info)(err);
        }
      }
      return (0, _util.shadow)(this, 'linearization', linearization);
    },
    get startXRef() {
      var stream = this.stream;
      var startXRef = 0;
      var linearization = this.linearization;
      if (linearization) {
        stream.reset();
        if (find(stream, 'endobj', 1024)) {
          startXRef = stream.pos + 6;
        }
      } else {
        var step = 1024;
        var found = false,
            pos = stream.end;
        while (!found && pos > 0) {
          pos -= step - 'startxref'.length;
          if (pos < 0) {
            pos = 0;
          }
          stream.pos = pos;
          found = find(stream, 'startxref', step, true);
        }
        if (found) {
          stream.skip(9);
          var ch;
          do {
            ch = stream.getByte();
          } while ((0, _util.isSpace)(ch));
          var str = '';
          while (ch >= 0x20 && ch <= 0x39) {
            str += String.fromCharCode(ch);
            ch = stream.getByte();
          }
          startXRef = parseInt(str, 10);
          if (isNaN(startXRef)) {
            startXRef = 0;
          }
        }
      }
      return (0, _util.shadow)(this, 'startXRef', startXRef);
    },
    get mainXRefEntriesOffset() {
      var mainXRefEntriesOffset = 0;
      var linearization = this.linearization;
      if (linearization) {
        mainXRefEntriesOffset = linearization.mainXRefEntriesOffset;
      }
      return (0, _util.shadow)(this, 'mainXRefEntriesOffset', mainXRefEntriesOffset);
    },
    checkHeader: function PDFDocument_checkHeader() {
      var stream = this.stream;
      stream.reset();
      if (find(stream, '%PDF-', 1024)) {
        stream.moveStart();
        var MAX_VERSION_LENGTH = 12;
        var version = '',
            ch;
        while ((ch = stream.getByte()) > 0x20) {
          if (version.length >= MAX_VERSION_LENGTH) {
            break;
          }
          version += String.fromCharCode(ch);
        }
        if (!this.pdfFormatVersion) {
          this.pdfFormatVersion = version.substring(5);
        }
        return;
      }
    },
    parseStartXRef: function PDFDocument_parseStartXRef() {
      var startXRef = this.startXRef;
      this.xref.setStartXRef(startXRef);
    },
    setup: function PDFDocument_setup(recoveryMode) {
      var _this4 = this;

      this.xref.parse(recoveryMode);
      var pageFactory = {
        createPage: function createPage(pageIndex, dict, ref, fontCache, builtInCMapCache) {
          return new Page(_this4.pdfManager, _this4.xref, pageIndex, dict, ref, fontCache, builtInCMapCache);
        }
      };
      this.catalog = new _obj.Catalog(this.pdfManager, this.xref, pageFactory);
    },
    get numPages() {
      var linearization = this.linearization;
      var num = linearization ? linearization.numPages : this.catalog.numPages;
      return (0, _util.shadow)(this, 'numPages', num);
    },
    get documentInfo() {
      var docInfo = {
        PDFFormatVersion: this.pdfFormatVersion,
        IsAcroFormPresent: !!this.acroForm,
        IsXFAPresent: !!this.xfa
      };
      var infoDict;
      try {
        infoDict = this.xref.trailer.get('Info');
      } catch (err) {
        if (err instanceof _util.MissingDataException) {
          throw err;
        }
        (0, _util.info)('The document information dictionary is invalid.');
      }
      if (infoDict) {
        var validEntries = DocumentInfoValidators.entries;
        for (var key in validEntries) {
          if (infoDict.has(key)) {
            var value = infoDict.get(key);
            if (validEntries[key](value)) {
              docInfo[key] = typeof value !== 'string' ? value : (0, _util.stringToPDFString)(value);
            } else {
              (0, _util.info)('Bad value in document info for "' + key + '"');
            }
          }
        }
      }
      return (0, _util.shadow)(this, 'documentInfo', docInfo);
    },
    get fingerprint() {
      var xref = this.xref,
          hash,
          fileID = '';
      var idArray = xref.trailer.get('ID');
      if (idArray && (0, _util.isArray)(idArray) && idArray[0] && (0, _util.isString)(idArray[0]) && idArray[0] !== EMPTY_FINGERPRINT) {
        hash = (0, _util.stringToBytes)(idArray[0]);
      } else {
        if (this.stream.ensureRange) {
          this.stream.ensureRange(0, Math.min(FINGERPRINT_FIRST_BYTES, this.stream.end));
        }
        hash = (0, _crypto.calculateMD5)(this.stream.bytes.subarray(0, FINGERPRINT_FIRST_BYTES), 0, FINGERPRINT_FIRST_BYTES);
      }
      for (var i = 0, n = hash.length; i < n; i++) {
        var hex = hash[i].toString(16);
        fileID += hex.length === 1 ? '0' + hex : hex;
      }
      return (0, _util.shadow)(this, 'fingerprint', fileID);
    },
    getPage: function PDFDocument_getPage(pageIndex) {
      return this.catalog.getPage(pageIndex);
    },
    cleanup: function PDFDocument_cleanup() {
      return this.catalog.cleanup();
    }
  };
  return PDFDocument;
}();
exports.Page = Page;
exports.PDFDocument = PDFDocument;

/***/ }),
/* 24 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FontRendererFactory = undefined;

var _util = __w_pdfjs_require__(0);

var _cff_parser = __w_pdfjs_require__(9);

var _glyphlist = __w_pdfjs_require__(7);

var _encodings = __w_pdfjs_require__(4);

var _stream = __w_pdfjs_require__(2);

var FontRendererFactory = function FontRendererFactoryClosure() {
  function getLong(data, offset) {
    return data[offset] << 24 | data[offset + 1] << 16 | data[offset + 2] << 8 | data[offset + 3];
  }
  function getUshort(data, offset) {
    return data[offset] << 8 | data[offset + 1];
  }
  function parseCmap(data, start, end) {
    var offset = getUshort(data, start + 2) === 1 ? getLong(data, start + 8) : getLong(data, start + 16);
    var format = getUshort(data, start + offset);
    var ranges, p, i;
    if (format === 4) {
      getUshort(data, start + offset + 2);
      var segCount = getUshort(data, start + offset + 6) >> 1;
      p = start + offset + 14;
      ranges = [];
      for (i = 0; i < segCount; i++, p += 2) {
        ranges[i] = { end: getUshort(data, p) };
      }
      p += 2;
      for (i = 0; i < segCount; i++, p += 2) {
        ranges[i].start = getUshort(data, p);
      }
      for (i = 0; i < segCount; i++, p += 2) {
        ranges[i].idDelta = getUshort(data, p);
      }
      for (i = 0; i < segCount; i++, p += 2) {
        var idOffset = getUshort(data, p);
        if (idOffset === 0) {
          continue;
        }
        ranges[i].ids = [];
        for (var j = 0, jj = ranges[i].end - ranges[i].start + 1; j < jj; j++) {
          ranges[i].ids[j] = getUshort(data, p + idOffset);
          idOffset += 2;
        }
      }
      return ranges;
    } else if (format === 12) {
      getLong(data, start + offset + 4);
      var groups = getLong(data, start + offset + 12);
      p = start + offset + 16;
      ranges = [];
      for (i = 0; i < groups; i++) {
        ranges.push({
          start: getLong(data, p),
          end: getLong(data, p + 4),
          idDelta: getLong(data, p + 8) - getLong(data, p)
        });
        p += 12;
      }
      return ranges;
    }
    throw new _util.FormatError('unsupported cmap: ' + format);
  }
  function parseCff(data, start, end, seacAnalysisEnabled) {
    var properties = {};
    var parser = new _cff_parser.CFFParser(new _stream.Stream(data, start, end - start), properties, seacAnalysisEnabled);
    var cff = parser.parse();
    return {
      glyphs: cff.charStrings.objects,
      subrs: cff.topDict.privateDict && cff.topDict.privateDict.subrsIndex && cff.topDict.privateDict.subrsIndex.objects,
      gsubrs: cff.globalSubrIndex && cff.globalSubrIndex.objects
    };
  }
  function parseGlyfTable(glyf, loca, isGlyphLocationsLong) {
    var itemSize, itemDecode;
    if (isGlyphLocationsLong) {
      itemSize = 4;
      itemDecode = function fontItemDecodeLong(data, offset) {
        return data[offset] << 24 | data[offset + 1] << 16 | data[offset + 2] << 8 | data[offset + 3];
      };
    } else {
      itemSize = 2;
      itemDecode = function fontItemDecode(data, offset) {
        return data[offset] << 9 | data[offset + 1] << 1;
      };
    }
    var glyphs = [];
    var startOffset = itemDecode(loca, 0);
    for (var j = itemSize; j < loca.length; j += itemSize) {
      var endOffset = itemDecode(loca, j);
      glyphs.push(glyf.subarray(startOffset, endOffset));
      startOffset = endOffset;
    }
    return glyphs;
  }
  function lookupCmap(ranges, unicode) {
    var code = unicode.charCodeAt(0),
        gid = 0;
    var l = 0,
        r = ranges.length - 1;
    while (l < r) {
      var c = l + r + 1 >> 1;
      if (code < ranges[c].start) {
        r = c - 1;
      } else {
        l = c;
      }
    }
    if (ranges[l].start <= code && code <= ranges[l].end) {
      gid = ranges[l].idDelta + (ranges[l].ids ? ranges[l].ids[code - ranges[l].start] : code) & 0xFFFF;
    }
    return {
      charCode: code,
      glyphId: gid
    };
  }
  function compileGlyf(code, cmds, font) {
    function moveTo(x, y) {
      cmds.push({
        cmd: 'moveTo',
        args: [x, y]
      });
    }
    function lineTo(x, y) {
      cmds.push({
        cmd: 'lineTo',
        args: [x, y]
      });
    }
    function quadraticCurveTo(xa, ya, x, y) {
      cmds.push({
        cmd: 'quadraticCurveTo',
        args: [xa, ya, x, y]
      });
    }
    var i = 0;
    var numberOfContours = (code[i] << 24 | code[i + 1] << 16) >> 16;
    var flags;
    var x = 0,
        y = 0;
    i += 10;
    if (numberOfContours < 0) {
      do {
        flags = code[i] << 8 | code[i + 1];
        var glyphIndex = code[i + 2] << 8 | code[i + 3];
        i += 4;
        var arg1, arg2;
        if (flags & 0x01) {
          arg1 = (code[i] << 24 | code[i + 1] << 16) >> 16;
          arg2 = (code[i + 2] << 24 | code[i + 3] << 16) >> 16;
          i += 4;
        } else {
          arg1 = code[i++];
          arg2 = code[i++];
        }
        if (flags & 0x02) {
          x = arg1;
          y = arg2;
        } else {
          x = 0;
          y = 0;
        }
        var scaleX = 1,
            scaleY = 1,
            scale01 = 0,
            scale10 = 0;
        if (flags & 0x08) {
          scaleX = scaleY = (code[i] << 24 | code[i + 1] << 16) / 1073741824;
          i += 2;
        } else if (flags & 0x40) {
          scaleX = (code[i] << 24 | code[i + 1] << 16) / 1073741824;
          scaleY = (code[i + 2] << 24 | code[i + 3] << 16) / 1073741824;
          i += 4;
        } else if (flags & 0x80) {
          scaleX = (code[i] << 24 | code[i + 1] << 16) / 1073741824;
          scale01 = (code[i + 2] << 24 | code[i + 3] << 16) / 1073741824;
          scale10 = (code[i + 4] << 24 | code[i + 5] << 16) / 1073741824;
          scaleY = (code[i + 6] << 24 | code[i + 7] << 16) / 1073741824;
          i += 8;
        }
        var subglyph = font.glyphs[glyphIndex];
        if (subglyph) {
          cmds.push({ cmd: 'save' });
          cmds.push({
            cmd: 'transform',
            args: [scaleX, scale01, scale10, scaleY, x, y]
          });
          compileGlyf(subglyph, cmds, font);
          cmds.push({ cmd: 'restore' });
        }
      } while (flags & 0x20);
    } else {
      var endPtsOfContours = [];
      var j, jj;
      for (j = 0; j < numberOfContours; j++) {
        endPtsOfContours.push(code[i] << 8 | code[i + 1]);
        i += 2;
      }
      var instructionLength = code[i] << 8 | code[i + 1];
      i += 2 + instructionLength;
      var numberOfPoints = endPtsOfContours[endPtsOfContours.length - 1] + 1;
      var points = [];
      while (points.length < numberOfPoints) {
        flags = code[i++];
        var repeat = 1;
        if (flags & 0x08) {
          repeat += code[i++];
        }
        while (repeat-- > 0) {
          points.push({ flags: flags });
        }
      }
      for (j = 0; j < numberOfPoints; j++) {
        switch (points[j].flags & 0x12) {
          case 0x00:
            x += (code[i] << 24 | code[i + 1] << 16) >> 16;
            i += 2;
            break;
          case 0x02:
            x -= code[i++];
            break;
          case 0x12:
            x += code[i++];
            break;
        }
        points[j].x = x;
      }
      for (j = 0; j < numberOfPoints; j++) {
        switch (points[j].flags & 0x24) {
          case 0x00:
            y += (code[i] << 24 | code[i + 1] << 16) >> 16;
            i += 2;
            break;
          case 0x04:
            y -= code[i++];
            break;
          case 0x24:
            y += code[i++];
            break;
        }
        points[j].y = y;
      }
      var startPoint = 0;
      for (i = 0; i < numberOfContours; i++) {
        var endPoint = endPtsOfContours[i];
        var contour = points.slice(startPoint, endPoint + 1);
        if (contour[0].flags & 1) {
          contour.push(contour[0]);
        } else if (contour[contour.length - 1].flags & 1) {
          contour.unshift(contour[contour.length - 1]);
        } else {
          var p = {
            flags: 1,
            x: (contour[0].x + contour[contour.length - 1].x) / 2,
            y: (contour[0].y + contour[contour.length - 1].y) / 2
          };
          contour.unshift(p);
          contour.push(p);
        }
        moveTo(contour[0].x, contour[0].y);
        for (j = 1, jj = contour.length; j < jj; j++) {
          if (contour[j].flags & 1) {
            lineTo(contour[j].x, contour[j].y);
          } else if (contour[j + 1].flags & 1) {
            quadraticCurveTo(contour[j].x, contour[j].y, contour[j + 1].x, contour[j + 1].y);
            j++;
          } else {
            quadraticCurveTo(contour[j].x, contour[j].y, (contour[j].x + contour[j + 1].x) / 2, (contour[j].y + contour[j + 1].y) / 2);
          }
        }
        startPoint = endPoint + 1;
      }
    }
  }
  function compileCharString(code, cmds, font) {
    var stack = [];
    var x = 0,
        y = 0;
    var stems = 0;
    function moveTo(x, y) {
      cmds.push({
        cmd: 'moveTo',
        args: [x, y]
      });
    }
    function lineTo(x, y) {
      cmds.push({
        cmd: 'lineTo',
        args: [x, y]
      });
    }
    function bezierCurveTo(x1, y1, x2, y2, x, y) {
      cmds.push({
        cmd: 'bezierCurveTo',
        args: [x1, y1, x2, y2, x, y]
      });
    }
    function parse(code) {
      var i = 0;
      while (i < code.length) {
        var stackClean = false;
        var v = code[i++];
        var xa, xb, ya, yb, y1, y2, y3, n, subrCode;
        switch (v) {
          case 1:
            stems += stack.length >> 1;
            stackClean = true;
            break;
          case 3:
            stems += stack.length >> 1;
            stackClean = true;
            break;
          case 4:
            y += stack.pop();
            moveTo(x, y);
            stackClean = true;
            break;
          case 5:
            while (stack.length > 0) {
              x += stack.shift();
              y += stack.shift();
              lineTo(x, y);
            }
            break;
          case 6:
            while (stack.length > 0) {
              x += stack.shift();
              lineTo(x, y);
              if (stack.length === 0) {
                break;
              }
              y += stack.shift();
              lineTo(x, y);
            }
            break;
          case 7:
            while (stack.length > 0) {
              y += stack.shift();
              lineTo(x, y);
              if (stack.length === 0) {
                break;
              }
              x += stack.shift();
              lineTo(x, y);
            }
            break;
          case 8:
            while (stack.length > 0) {
              xa = x + stack.shift();
              ya = y + stack.shift();
              xb = xa + stack.shift();
              yb = ya + stack.shift();
              x = xb + stack.shift();
              y = yb + stack.shift();
              bezierCurveTo(xa, ya, xb, yb, x, y);
            }
            break;
          case 10:
            n = stack.pop() + font.subrsBias;
            subrCode = font.subrs[n];
            if (subrCode) {
              parse(subrCode);
            }
            break;
          case 11:
            return;
          case 12:
            v = code[i++];
            switch (v) {
              case 34:
                xa = x + stack.shift();
                xb = xa + stack.shift();
                y1 = y + stack.shift();
                x = xb + stack.shift();
                bezierCurveTo(xa, y, xb, y1, x, y1);
                xa = x + stack.shift();
                xb = xa + stack.shift();
                x = xb + stack.shift();
                bezierCurveTo(xa, y1, xb, y, x, y);
                break;
              case 35:
                xa = x + stack.shift();
                ya = y + stack.shift();
                xb = xa + stack.shift();
                yb = ya + stack.shift();
                x = xb + stack.shift();
                y = yb + stack.shift();
                bezierCurveTo(xa, ya, xb, yb, x, y);
                xa = x + stack.shift();
                ya = y + stack.shift();
                xb = xa + stack.shift();
                yb = ya + stack.shift();
                x = xb + stack.shift();
                y = yb + stack.shift();
                bezierCurveTo(xa, ya, xb, yb, x, y);
                stack.pop();
                break;
              case 36:
                xa = x + stack.shift();
                y1 = y + stack.shift();
                xb = xa + stack.shift();
                y2 = y1 + stack.shift();
                x = xb + stack.shift();
                bezierCurveTo(xa, y1, xb, y2, x, y2);
                xa = x + stack.shift();
                xb = xa + stack.shift();
                y3 = y2 + stack.shift();
                x = xb + stack.shift();
                bezierCurveTo(xa, y2, xb, y3, x, y);
                break;
              case 37:
                var x0 = x,
                    y0 = y;
                xa = x + stack.shift();
                ya = y + stack.shift();
                xb = xa + stack.shift();
                yb = ya + stack.shift();
                x = xb + stack.shift();
                y = yb + stack.shift();
                bezierCurveTo(xa, ya, xb, yb, x, y);
                xa = x + stack.shift();
                ya = y + stack.shift();
                xb = xa + stack.shift();
                yb = ya + stack.shift();
                x = xb;
                y = yb;
                if (Math.abs(x - x0) > Math.abs(y - y0)) {
                  x += stack.shift();
                } else {
                  y += stack.shift();
                }
                bezierCurveTo(xa, ya, xb, yb, x, y);
                break;
              default:
                throw new _util.FormatError('unknown operator: 12 ' + v);
            }
            break;
          case 14:
            if (stack.length >= 4) {
              var achar = stack.pop();
              var bchar = stack.pop();
              y = stack.pop();
              x = stack.pop();
              cmds.push({ cmd: 'save' });
              cmds.push({
                cmd: 'translate',
                args: [x, y]
              });
              var cmap = lookupCmap(font.cmap, String.fromCharCode(font.glyphNameMap[_encodings.StandardEncoding[achar]]));
              compileCharString(font.glyphs[cmap.glyphId], cmds, font);
              cmds.push({ cmd: 'restore' });
              cmap = lookupCmap(font.cmap, String.fromCharCode(font.glyphNameMap[_encodings.StandardEncoding[bchar]]));
              compileCharString(font.glyphs[cmap.glyphId], cmds, font);
            }
            return;
          case 18:
            stems += stack.length >> 1;
            stackClean = true;
            break;
          case 19:
            stems += stack.length >> 1;
            i += stems + 7 >> 3;
            stackClean = true;
            break;
          case 20:
            stems += stack.length >> 1;
            i += stems + 7 >> 3;
            stackClean = true;
            break;
          case 21:
            y += stack.pop();
            x += stack.pop();
            moveTo(x, y);
            stackClean = true;
            break;
          case 22:
            x += stack.pop();
            moveTo(x, y);
            stackClean = true;
            break;
          case 23:
            stems += stack.length >> 1;
            stackClean = true;
            break;
          case 24:
            while (stack.length > 2) {
              xa = x + stack.shift();
              ya = y + stack.shift();
              xb = xa + stack.shift();
              yb = ya + stack.shift();
              x = xb + stack.shift();
              y = yb + stack.shift();
              bezierCurveTo(xa, ya, xb, yb, x, y);
            }
            x += stack.shift();
            y += stack.shift();
            lineTo(x, y);
            break;
          case 25:
            while (stack.length > 6) {
              x += stack.shift();
              y += stack.shift();
              lineTo(x, y);
            }
            xa = x + stack.shift();
            ya = y + stack.shift();
            xb = xa + stack.shift();
            yb = ya + stack.shift();
            x = xb + stack.shift();
            y = yb + stack.shift();
            bezierCurveTo(xa, ya, xb, yb, x, y);
            break;
          case 26:
            if (stack.length % 2) {
              x += stack.shift();
            }
            while (stack.length > 0) {
              xa = x;
              ya = y + stack.shift();
              xb = xa + stack.shift();
              yb = ya + stack.shift();
              x = xb;
              y = yb + stack.shift();
              bezierCurveTo(xa, ya, xb, yb, x, y);
            }
            break;
          case 27:
            if (stack.length % 2) {
              y += stack.shift();
            }
            while (stack.length > 0) {
              xa = x + stack.shift();
              ya = y;
              xb = xa + stack.shift();
              yb = ya + stack.shift();
              x = xb + stack.shift();
              y = yb;
              bezierCurveTo(xa, ya, xb, yb, x, y);
            }
            break;
          case 28:
            stack.push((code[i] << 24 | code[i + 1] << 16) >> 16);
            i += 2;
            break;
          case 29:
            n = stack.pop() + font.gsubrsBias;
            subrCode = font.gsubrs[n];
            if (subrCode) {
              parse(subrCode);
            }
            break;
          case 30:
            while (stack.length > 0) {
              xa = x;
              ya = y + stack.shift();
              xb = xa + stack.shift();
              yb = ya + stack.shift();
              x = xb + stack.shift();
              y = yb + (stack.length === 1 ? stack.shift() : 0);
              bezierCurveTo(xa, ya, xb, yb, x, y);
              if (stack.length === 0) {
                break;
              }
              xa = x + stack.shift();
              ya = y;
              xb = xa + stack.shift();
              yb = ya + stack.shift();
              y = yb + stack.shift();
              x = xb + (stack.length === 1 ? stack.shift() : 0);
              bezierCurveTo(xa, ya, xb, yb, x, y);
            }
            break;
          case 31:
            while (stack.length > 0) {
              xa = x + stack.shift();
              ya = y;
              xb = xa + stack.shift();
              yb = ya + stack.shift();
              y = yb + stack.shift();
              x = xb + (stack.length === 1 ? stack.shift() : 0);
              bezierCurveTo(xa, ya, xb, yb, x, y);
              if (stack.length === 0) {
                break;
              }
              xa = x;
              ya = y + stack.shift();
              xb = xa + stack.shift();
              yb = ya + stack.shift();
              x = xb + stack.shift();
              y = yb + (stack.length === 1 ? stack.shift() : 0);
              bezierCurveTo(xa, ya, xb, yb, x, y);
            }
            break;
          default:
            if (v < 32) {
              throw new _util.FormatError('unknown operator: ' + v);
            }
            if (v < 247) {
              stack.push(v - 139);
            } else if (v < 251) {
              stack.push((v - 247) * 256 + code[i++] + 108);
            } else if (v < 255) {
              stack.push(-(v - 251) * 256 - code[i++] - 108);
            } else {
              stack.push((code[i] << 24 | code[i + 1] << 16 | code[i + 2] << 8 | code[i + 3]) / 65536);
              i += 4;
            }
            break;
        }
        if (stackClean) {
          stack.length = 0;
        }
      }
    }
    parse(code);
  }
  var noop = '';
  function CompiledFont(fontMatrix) {
    this.compiledGlyphs = Object.create(null);
    this.compiledCharCodeToGlyphId = Object.create(null);
    this.fontMatrix = fontMatrix;
  }
  CompiledFont.prototype = {
    getPathJs: function getPathJs(unicode) {
      var cmap = lookupCmap(this.cmap, unicode);
      var fn = this.compiledGlyphs[cmap.glyphId];
      if (!fn) {
        fn = this.compileGlyph(this.glyphs[cmap.glyphId]);
        this.compiledGlyphs[cmap.glyphId] = fn;
      }
      if (this.compiledCharCodeToGlyphId[cmap.charCode] === undefined) {
        this.compiledCharCodeToGlyphId[cmap.charCode] = cmap.glyphId;
      }
      return fn;
    },
    compileGlyph: function compileGlyph(code) {
      if (!code || code.length === 0 || code[0] === 14) {
        return noop;
      }
      var cmds = [];
      cmds.push({ cmd: 'save' });
      cmds.push({
        cmd: 'transform',
        args: this.fontMatrix.slice()
      });
      cmds.push({
        cmd: 'scale',
        args: ['size', '-size']
      });
      this.compileGlyphImpl(code, cmds);
      cmds.push({ cmd: 'restore' });
      return cmds;
    },
    compileGlyphImpl: function compileGlyphImpl() {
      throw new Error('Children classes should implement this.');
    },
    hasBuiltPath: function hasBuiltPath(unicode) {
      var cmap = lookupCmap(this.cmap, unicode);
      return this.compiledGlyphs[cmap.glyphId] !== undefined && this.compiledCharCodeToGlyphId[cmap.charCode] !== undefined;
    }
  };
  function TrueTypeCompiled(glyphs, cmap, fontMatrix) {
    fontMatrix = fontMatrix || [0.000488, 0, 0, 0.000488, 0, 0];
    CompiledFont.call(this, fontMatrix);
    this.glyphs = glyphs;
    this.cmap = cmap;
  }
  _util.Util.inherit(TrueTypeCompiled, CompiledFont, {
    compileGlyphImpl: function compileGlyphImpl(code, cmds) {
      compileGlyf(code, cmds, this);
    }
  });
  function Type2Compiled(cffInfo, cmap, fontMatrix, glyphNameMap) {
    fontMatrix = fontMatrix || [0.001, 0, 0, 0.001, 0, 0];
    CompiledFont.call(this, fontMatrix);
    this.glyphs = cffInfo.glyphs;
    this.gsubrs = cffInfo.gsubrs || [];
    this.subrs = cffInfo.subrs || [];
    this.cmap = cmap;
    this.glyphNameMap = glyphNameMap || (0, _glyphlist.getGlyphsUnicode)();
    this.gsubrsBias = this.gsubrs.length < 1240 ? 107 : this.gsubrs.length < 33900 ? 1131 : 32768;
    this.subrsBias = this.subrs.length < 1240 ? 107 : this.subrs.length < 33900 ? 1131 : 32768;
  }
  _util.Util.inherit(Type2Compiled, CompiledFont, {
    compileGlyphImpl: function compileGlyphImpl(code, cmds) {
      compileCharString(code, cmds, this);
    }
  });
  return {
    create: function FontRendererFactory_create(font, seacAnalysisEnabled) {
      var data = new Uint8Array(font.data);
      var cmap, glyf, loca, cff, indexToLocFormat, unitsPerEm;
      var numTables = getUshort(data, 4);
      for (var i = 0, p = 12; i < numTables; i++, p += 16) {
        var tag = (0, _util.bytesToString)(data.subarray(p, p + 4));
        var offset = getLong(data, p + 8);
        var length = getLong(data, p + 12);
        switch (tag) {
          case 'cmap':
            cmap = parseCmap(data, offset, offset + length);
            break;
          case 'glyf':
            glyf = data.subarray(offset, offset + length);
            break;
          case 'loca':
            loca = data.subarray(offset, offset + length);
            break;
          case 'head':
            unitsPerEm = getUshort(data, offset + 18);
            indexToLocFormat = getUshort(data, offset + 50);
            break;
          case 'CFF ':
            cff = parseCff(data, offset, offset + length, seacAnalysisEnabled);
            break;
        }
      }
      if (glyf) {
        var fontMatrix = !unitsPerEm ? font.fontMatrix : [1 / unitsPerEm, 0, 0, 1 / unitsPerEm, 0, 0];
        return new TrueTypeCompiled(parseGlyfTable(glyf, loca, indexToLocFormat), cmap, fontMatrix);
      }
      return new Type2Compiled(cff, cmap, font.fontMatrix, font.glyphNameMap);
    }
  };
}();
exports.FontRendererFactory = FontRendererFactory;

/***/ }),
/* 25 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFontType = exports.ProblematicCharRanges = exports.IdentityToUnicodeMap = exports.ToUnicodeMap = exports.FontFlags = exports.Font = exports.ErrorFont = exports.PRIVATE_USE_OFFSET_END = exports.PRIVATE_USE_OFFSET_START = exports.SEAC_ANALYSIS_ENABLED = undefined;

var _util = __w_pdfjs_require__(0);

var _cff_parser = __w_pdfjs_require__(9);

var _glyphlist = __w_pdfjs_require__(7);

var _encodings = __w_pdfjs_require__(4);

var _standard_fonts = __w_pdfjs_require__(15);

var _unicode = __w_pdfjs_require__(16);

var _font_renderer = __w_pdfjs_require__(24);

var _stream = __w_pdfjs_require__(2);

var _type1_parser = __w_pdfjs_require__(34);

var PRIVATE_USE_OFFSET_START = 0xE000;
var PRIVATE_USE_OFFSET_END = 0xF8FF;
var SKIP_PRIVATE_USE_RANGE_F000_TO_F01F = false;
var PDF_GLYPH_SPACE_UNITS = 1000;
var SEAC_ANALYSIS_ENABLED = false;
var FontFlags = {
  FixedPitch: 1,
  Serif: 2,
  Symbolic: 4,
  Script: 8,
  Nonsymbolic: 32,
  Italic: 64,
  AllCap: 65536,
  SmallCap: 131072,
  ForceBold: 262144
};
var MacStandardGlyphOrdering = ['.notdef', '.null', 'nonmarkingreturn', 'space', 'exclam', 'quotedbl', 'numbersign', 'dollar', 'percent', 'ampersand', 'quotesingle', 'parenleft', 'parenright', 'asterisk', 'plus', 'comma', 'hyphen', 'period', 'slash', 'zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'colon', 'semicolon', 'less', 'equal', 'greater', 'question', 'at', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'bracketleft', 'backslash', 'bracketright', 'asciicircum', 'underscore', 'grave', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'braceleft', 'bar', 'braceright', 'asciitilde', 'Adieresis', 'Aring', 'Ccedilla', 'Eacute', 'Ntilde', 'Odieresis', 'Udieresis', 'aacute', 'agrave', 'acircumflex', 'adieresis', 'atilde', 'aring', 'ccedilla', 'eacute', 'egrave', 'ecircumflex', 'edieresis', 'iacute', 'igrave', 'icircumflex', 'idieresis', 'ntilde', 'oacute', 'ograve', 'ocircumflex', 'odieresis', 'otilde', 'uacute', 'ugrave', 'ucircumflex', 'udieresis', 'dagger', 'degree', 'cent', 'sterling', 'section', 'bullet', 'paragraph', 'germandbls', 'registered', 'copyright', 'trademark', 'acute', 'dieresis', 'notequal', 'AE', 'Oslash', 'infinity', 'plusminus', 'lessequal', 'greaterequal', 'yen', 'mu', 'partialdiff', 'summation', 'product', 'pi', 'integral', 'ordfeminine', 'ordmasculine', 'Omega', 'ae', 'oslash', 'questiondown', 'exclamdown', 'logicalnot', 'radical', 'florin', 'approxequal', 'Delta', 'guillemotleft', 'guillemotright', 'ellipsis', 'nonbreakingspace', 'Agrave', 'Atilde', 'Otilde', 'OE', 'oe', 'endash', 'emdash', 'quotedblleft', 'quotedblright', 'quoteleft', 'quoteright', 'divide', 'lozenge', 'ydieresis', 'Ydieresis', 'fraction', 'currency', 'guilsinglleft', 'guilsinglright', 'fi', 'fl', 'daggerdbl', 'periodcentered', 'quotesinglbase', 'quotedblbase', 'perthousand', 'Acircumflex', 'Ecircumflex', 'Aacute', 'Edieresis', 'Egrave', 'Iacute', 'Icircumflex', 'Idieresis', 'Igrave', 'Oacute', 'Ocircumflex', 'apple', 'Ograve', 'Uacute', 'Ucircumflex', 'Ugrave', 'dotlessi', 'circumflex', 'tilde', 'macron', 'breve', 'dotaccent', 'ring', 'cedilla', 'hungarumlaut', 'ogonek', 'caron', 'Lslash', 'lslash', 'Scaron', 'scaron', 'Zcaron', 'zcaron', 'brokenbar', 'Eth', 'eth', 'Yacute', 'yacute', 'Thorn', 'thorn', 'minus', 'multiply', 'onesuperior', 'twosuperior', 'threesuperior', 'onehalf', 'onequarter', 'threequarters', 'franc', 'Gbreve', 'gbreve', 'Idotaccent', 'Scedilla', 'scedilla', 'Cacute', 'cacute', 'Ccaron', 'ccaron', 'dcroat'];
function adjustWidths(properties) {
  if (!properties.fontMatrix) {
    return;
  }
  if (properties.fontMatrix[0] === _util.FONT_IDENTITY_MATRIX[0]) {
    return;
  }
  var scale = 0.001 / properties.fontMatrix[0];
  var glyphsWidths = properties.widths;
  for (var glyph in glyphsWidths) {
    glyphsWidths[glyph] *= scale;
  }
  properties.defaultWidth *= scale;
}
function adjustToUnicode(properties, builtInEncoding) {
  if (properties.hasIncludedToUnicodeMap) {
    return;
  }
  if (properties.hasEncoding) {
    return;
  }
  if (builtInEncoding === properties.defaultEncoding) {
    return;
  }
  if (properties.toUnicode instanceof IdentityToUnicodeMap) {
    return;
  }
  var toUnicode = [],
      glyphsUnicodeMap = (0, _glyphlist.getGlyphsUnicode)();
  for (var charCode in builtInEncoding) {
    var glyphName = builtInEncoding[charCode];
    var unicode = (0, _unicode.getUnicodeForGlyph)(glyphName, glyphsUnicodeMap);
    if (unicode !== -1) {
      toUnicode[charCode] = String.fromCharCode(unicode);
    }
  }
  properties.toUnicode.amend(toUnicode);
}
function getFontType(type, subtype) {
  switch (type) {
    case 'Type1':
      return subtype === 'Type1C' ? _util.FontType.TYPE1C : _util.FontType.TYPE1;
    case 'CIDFontType0':
      return subtype === 'CIDFontType0C' ? _util.FontType.CIDFONTTYPE0C : _util.FontType.CIDFONTTYPE0;
    case 'OpenType':
      return _util.FontType.OPENTYPE;
    case 'TrueType':
      return _util.FontType.TRUETYPE;
    case 'CIDFontType2':
      return _util.FontType.CIDFONTTYPE2;
    case 'MMType1':
      return _util.FontType.MMTYPE1;
    case 'Type0':
      return _util.FontType.TYPE0;
    default:
      return _util.FontType.UNKNOWN;
  }
}
function recoverGlyphName(name, glyphsUnicodeMap) {
  if (glyphsUnicodeMap[name] !== undefined) {
    return name;
  }
  var unicode = (0, _unicode.getUnicodeForGlyph)(name, glyphsUnicodeMap);
  if (unicode !== -1) {
    for (var key in glyphsUnicodeMap) {
      if (glyphsUnicodeMap[key] === unicode) {
        return key;
      }
    }
  }
  (0, _util.info)('Unable to recover a standard glyph name for: ' + name);
  return name;
}
var Glyph = function GlyphClosure() {
  function Glyph(fontChar, unicode, accent, width, vmetric, operatorListId, isSpace, isInFont) {
    this.fontChar = fontChar;
    this.unicode = unicode;
    this.accent = accent;
    this.width = width;
    this.vmetric = vmetric;
    this.operatorListId = operatorListId;
    this.isSpace = isSpace;
    this.isInFont = isInFont;
  }
  Glyph.prototype.matchesForCache = function (fontChar, unicode, accent, width, vmetric, operatorListId, isSpace, isInFont) {
    return this.fontChar === fontChar && this.unicode === unicode && this.accent === accent && this.width === width && this.vmetric === vmetric && this.operatorListId === operatorListId && this.isSpace === isSpace && this.isInFont === isInFont;
  };
  return Glyph;
}();
var ToUnicodeMap = function ToUnicodeMapClosure() {
  function ToUnicodeMap(cmap) {
    this._map = cmap;
  }
  ToUnicodeMap.prototype = {
    get length() {
      return this._map.length;
    },
    forEach: function forEach(callback) {
      for (var charCode in this._map) {
        callback(charCode, this._map[charCode].charCodeAt(0));
      }
    },
    has: function has(i) {
      return this._map[i] !== undefined;
    },
    get: function get(i) {
      return this._map[i];
    },
    charCodeOf: function charCodeOf(value) {
      var map = this._map;
      if (map.length <= 0x10000) {
        return map.indexOf(value);
      }
      for (var charCode in map) {
        if (map[charCode] === value) {
          return charCode | 0;
        }
      }
      return -1;
    },
    amend: function amend(map) {
      for (var charCode in map) {
        this._map[charCode] = map[charCode];
      }
    }
  };
  return ToUnicodeMap;
}();
var IdentityToUnicodeMap = function IdentityToUnicodeMapClosure() {
  function IdentityToUnicodeMap(firstChar, lastChar) {
    this.firstChar = firstChar;
    this.lastChar = lastChar;
  }
  IdentityToUnicodeMap.prototype = {
    get length() {
      return this.lastChar + 1 - this.firstChar;
    },
    forEach: function forEach(callback) {
      for (var i = this.firstChar, ii = this.lastChar; i <= ii; i++) {
        callback(i, i);
      }
    },
    has: function has(i) {
      return this.firstChar <= i && i <= this.lastChar;
    },
    get: function get(i) {
      if (this.firstChar <= i && i <= this.lastChar) {
        return String.fromCharCode(i);
      }
      return undefined;
    },
    charCodeOf: function charCodeOf(v) {
      return (0, _util.isInt)(v) && v >= this.firstChar && v <= this.lastChar ? v : -1;
    },
    amend: function amend(map) {
      throw new Error('Should not call amend()');
    }
  };
  return IdentityToUnicodeMap;
}();
var OpenTypeFileBuilder = function OpenTypeFileBuilderClosure() {
  function writeInt16(dest, offset, num) {
    dest[offset] = num >> 8 & 0xFF;
    dest[offset + 1] = num & 0xFF;
  }
  function writeInt32(dest, offset, num) {
    dest[offset] = num >> 24 & 0xFF;
    dest[offset + 1] = num >> 16 & 0xFF;
    dest[offset + 2] = num >> 8 & 0xFF;
    dest[offset + 3] = num & 0xFF;
  }
  function writeData(dest, offset, data) {
    var i, ii;
    if (data instanceof Uint8Array) {
      dest.set(data, offset);
    } else if (typeof data === 'string') {
      for (i = 0, ii = data.length; i < ii; i++) {
        dest[offset++] = data.charCodeAt(i) & 0xFF;
      }
    } else {
      for (i = 0, ii = data.length; i < ii; i++) {
        dest[offset++] = data[i] & 0xFF;
      }
    }
  }
  function OpenTypeFileBuilder(sfnt) {
    this.sfnt = sfnt;
    this.tables = Object.create(null);
  }
  OpenTypeFileBuilder.getSearchParams = function OpenTypeFileBuilder_getSearchParams(entriesCount, entrySize) {
    var maxPower2 = 1,
        log2 = 0;
    while ((maxPower2 ^ entriesCount) > maxPower2) {
      maxPower2 <<= 1;
      log2++;
    }
    var searchRange = maxPower2 * entrySize;
    return {
      range: searchRange,
      entry: log2,
      rangeShift: entrySize * entriesCount - searchRange
    };
  };
  var OTF_HEADER_SIZE = 12;
  var OTF_TABLE_ENTRY_SIZE = 16;
  OpenTypeFileBuilder.prototype = {
    toArray: function OpenTypeFileBuilder_toArray() {
      var sfnt = this.sfnt;
      var tables = this.tables;
      var tablesNames = Object.keys(tables);
      tablesNames.sort();
      var numTables = tablesNames.length;
      var i, j, jj, table, tableName;
      var offset = OTF_HEADER_SIZE + numTables * OTF_TABLE_ENTRY_SIZE;
      var tableOffsets = [offset];
      for (i = 0; i < numTables; i++) {
        table = tables[tablesNames[i]];
        var paddedLength = (table.length + 3 & ~3) >>> 0;
        offset += paddedLength;
        tableOffsets.push(offset);
      }
      var file = new Uint8Array(offset);
      for (i = 0; i < numTables; i++) {
        table = tables[tablesNames[i]];
        writeData(file, tableOffsets[i], table);
      }
      if (sfnt === 'true') {
        sfnt = (0, _util.string32)(0x00010000);
      }
      file[0] = sfnt.charCodeAt(0) & 0xFF;
      file[1] = sfnt.charCodeAt(1) & 0xFF;
      file[2] = sfnt.charCodeAt(2) & 0xFF;
      file[3] = sfnt.charCodeAt(3) & 0xFF;
      writeInt16(file, 4, numTables);
      var searchParams = OpenTypeFileBuilder.getSearchParams(numTables, 16);
      writeInt16(file, 6, searchParams.range);
      writeInt16(file, 8, searchParams.entry);
      writeInt16(file, 10, searchParams.rangeShift);
      offset = OTF_HEADER_SIZE;
      for (i = 0; i < numTables; i++) {
        tableName = tablesNames[i];
        file[offset] = tableName.charCodeAt(0) & 0xFF;
        file[offset + 1] = tableName.charCodeAt(1) & 0xFF;
        file[offset + 2] = tableName.charCodeAt(2) & 0xFF;
        file[offset + 3] = tableName.charCodeAt(3) & 0xFF;
        var checksum = 0;
        for (j = tableOffsets[i], jj = tableOffsets[i + 1]; j < jj; j += 4) {
          var quad = (0, _util.readUint32)(file, j);
          checksum = checksum + quad >>> 0;
        }
        writeInt32(file, offset + 4, checksum);
        writeInt32(file, offset + 8, tableOffsets[i]);
        writeInt32(file, offset + 12, tables[tableName].length);
        offset += OTF_TABLE_ENTRY_SIZE;
      }
      return file;
    },
    addTable: function OpenTypeFileBuilder_addTable(tag, data) {
      if (tag in this.tables) {
        throw new Error('Table ' + tag + ' already exists');
      }
      this.tables[tag] = data;
    }
  };
  return OpenTypeFileBuilder;
}();
var ProblematicCharRanges = new Int32Array([0x0000, 0x0020, 0x007F, 0x00A1, 0x00AD, 0x00AE, 0x0600, 0x0780, 0x08A0, 0x10A0, 0x1780, 0x1800, 0x1C00, 0x1C50, 0x2000, 0x2010, 0x2011, 0x2012, 0x2028, 0x2030, 0x205F, 0x2070, 0x25CC, 0x25CD, 0x3000, 0x3001, 0x3164, 0x3165, 0xAA60, 0xAA80, 0xFFF0, 0x10000]);
var Font = function FontClosure() {
  function Font(name, file, properties) {
    var charCode;
    this.name = name;
    this.loadedName = properties.loadedName;
    this.isType3Font = properties.isType3Font;
    this.sizes = [];
    this.missingFile = false;
    this.glyphCache = Object.create(null);
    this.isSerifFont = !!(properties.flags & FontFlags.Serif);
    this.isSymbolicFont = !!(properties.flags & FontFlags.Symbolic);
    this.isMonospace = !!(properties.flags & FontFlags.FixedPitch);
    var type = properties.type;
    var subtype = properties.subtype;
    this.type = type;
    this.subtype = subtype;
    this.fallbackName = this.isMonospace ? 'monospace' : this.isSerifFont ? 'serif' : 'sans-serif';
    this.differences = properties.differences;
    this.widths = properties.widths;
    this.defaultWidth = properties.defaultWidth;
    this.composite = properties.composite;
    this.wideChars = properties.wideChars;
    this.cMap = properties.cMap;
    this.ascent = properties.ascent / PDF_GLYPH_SPACE_UNITS;
    this.descent = properties.descent / PDF_GLYPH_SPACE_UNITS;
    this.fontMatrix = properties.fontMatrix;
    this.bbox = properties.bbox;
    this.defaultEncoding = properties.defaultEncoding;
    this.toUnicode = properties.toUnicode;
    this.toFontChar = [];
    if (properties.type === 'Type3') {
      for (charCode = 0; charCode < 256; charCode++) {
        this.toFontChar[charCode] = this.differences[charCode] || properties.defaultEncoding[charCode];
      }
      this.fontType = _util.FontType.TYPE3;
      return;
    }
    this.cidEncoding = properties.cidEncoding;
    this.vertical = properties.vertical;
    if (this.vertical) {
      this.vmetrics = properties.vmetrics;
      this.defaultVMetrics = properties.defaultVMetrics;
    }
    if (!file || file.isEmpty) {
      if (file) {
        (0, _util.warn)('Font file is empty in "' + name + '" (' + this.loadedName + ')');
      }
      this.fallbackToSystemFont();
      return;
    }
    if (subtype === 'Type1C') {
      if (type !== 'Type1' && type !== 'MMType1') {
        if (isTrueTypeFile(file)) {
          subtype = 'TrueType';
        } else {
          type = 'Type1';
        }
      } else if (isOpenTypeFile(file)) {
        subtype = 'OpenType';
      }
    }
    if (subtype === 'CIDFontType0C' && type !== 'CIDFontType0') {
      type = 'CIDFontType0';
    }
    if (type === 'CIDFontType0') {
      if (isType1File(file)) {
        subtype = 'CIDFontType0';
      } else if (isOpenTypeFile(file)) {
        subtype = 'OpenType';
      } else {
        subtype = 'CIDFontType0C';
      }
    }
    if (subtype === 'OpenType' && type !== 'OpenType') {
      type = 'OpenType';
    }
    try {
      var data;
      switch (type) {
        case 'MMType1':
          (0, _util.info)('MMType1 font (' + name + '), falling back to Type1.');
        case 'Type1':
        case 'CIDFontType0':
          this.mimetype = 'font/opentype';
          var cff = subtype === 'Type1C' || subtype === 'CIDFontType0C' ? new CFFFont(file, properties) : new Type1Font(name, file, properties);
          adjustWidths(properties);
          data = this.convert(name, cff, properties);
          break;
        case 'OpenType':
        case 'TrueType':
        case 'CIDFontType2':
          this.mimetype = 'font/opentype';
          data = this.checkAndRepair(name, file, properties);
          if (this.isOpenType) {
            adjustWidths(properties);
            type = 'OpenType';
          }
          break;
        default:
          throw new _util.FormatError('Font ' + type + ' is not supported');
      }
    } catch (e) {
      if (!(e instanceof _util.FormatError)) {
        throw e;
      }
      (0, _util.warn)(e);
      this.fallbackToSystemFont();
      return;
    }
    this.data = data;
    this.fontType = getFontType(type, subtype);
    this.fontMatrix = properties.fontMatrix;
    this.widths = properties.widths;
    this.defaultWidth = properties.defaultWidth;
    this.toUnicode = properties.toUnicode;
    this.encoding = properties.baseEncoding;
    this.seacMap = properties.seacMap;
    this.loading = true;
  }
  Font.getFontID = function () {
    var ID = 1;
    return function Font_getFontID() {
      return String(ID++);
    };
  }();
  function int16(b0, b1) {
    return (b0 << 8) + b1;
  }
  function signedInt16(b0, b1) {
    var value = (b0 << 8) + b1;
    return value & 1 << 15 ? value - 0x10000 : value;
  }
  function int32(b0, b1, b2, b3) {
    return (b0 << 24) + (b1 << 16) + (b2 << 8) + b3;
  }
  function string16(value) {
    return String.fromCharCode(value >> 8 & 0xff, value & 0xff);
  }
  function safeString16(value) {
    value = value > 0x7FFF ? 0x7FFF : value < -0x8000 ? -0x8000 : value;
    return String.fromCharCode(value >> 8 & 0xff, value & 0xff);
  }
  function isTrueTypeFile(file) {
    var header = file.peekBytes(4);
    return (0, _util.readUint32)(header, 0) === 0x00010000;
  }
  function isOpenTypeFile(file) {
    var header = file.peekBytes(4);
    return (0, _util.bytesToString)(header) === 'OTTO';
  }
  function isType1File(file) {
    var header = file.peekBytes(2);
    if (header[0] === 0x25 && header[1] === 0x21) {
      return true;
    }
    if (header[0] === 0x80 && header[1] === 0x01) {
      return true;
    }
    return false;
  }
  function buildToFontChar(encoding, glyphsUnicodeMap, differences) {
    var toFontChar = [],
        unicode;
    for (var i = 0, ii = encoding.length; i < ii; i++) {
      unicode = (0, _unicode.getUnicodeForGlyph)(encoding[i], glyphsUnicodeMap);
      if (unicode !== -1) {
        toFontChar[i] = unicode;
      }
    }
    for (var charCode in differences) {
      unicode = (0, _unicode.getUnicodeForGlyph)(differences[charCode], glyphsUnicodeMap);
      if (unicode !== -1) {
        toFontChar[+charCode] = unicode;
      }
    }
    return toFontChar;
  }
  function isProblematicUnicodeLocation(code) {
    var i = 0,
        j = ProblematicCharRanges.length - 1;
    while (i < j) {
      var c = i + j + 1 >> 1;
      if (code < ProblematicCharRanges[c]) {
        j = c - 1;
      } else {
        i = c;
      }
    }
    return !(i & 1);
  }
  function adjustMapping(charCodeToGlyphId, properties, missingGlyphs) {
    var toUnicode = properties.toUnicode;
    var isSymbolic = !!(properties.flags & FontFlags.Symbolic);
    var isIdentityUnicode = properties.toUnicode instanceof IdentityToUnicodeMap;
    var newMap = Object.create(null);
    var toFontChar = [];
    var usedFontCharCodes = [];
    var nextAvailableFontCharCode = PRIVATE_USE_OFFSET_START;
    for (var originalCharCode in charCodeToGlyphId) {
      originalCharCode |= 0;
      var glyphId = charCodeToGlyphId[originalCharCode];
      if (missingGlyphs[glyphId]) {
        continue;
      }
      var fontCharCode = originalCharCode;
      var hasUnicodeValue = false;
      if (!isIdentityUnicode && toUnicode.has(originalCharCode)) {
        hasUnicodeValue = true;
        var unicode = toUnicode.get(fontCharCode);
        if (unicode.length === 1) {
          fontCharCode = unicode.charCodeAt(0);
        }
      }
      if (usedFontCharCodes[fontCharCode] !== undefined || isProblematicUnicodeLocation(fontCharCode) || isSymbolic && !hasUnicodeValue) {
        do {
          if (nextAvailableFontCharCode > PRIVATE_USE_OFFSET_END) {
            (0, _util.warn)('Ran out of space in font private use area.');
            break;
          }
          fontCharCode = nextAvailableFontCharCode++;
          if (SKIP_PRIVATE_USE_RANGE_F000_TO_F01F && fontCharCode === 0xF000) {
            fontCharCode = 0xF020;
            nextAvailableFontCharCode = fontCharCode + 1;
          }
        } while (usedFontCharCodes[fontCharCode] !== undefined);
      }
      newMap[fontCharCode] = glyphId;
      toFontChar[originalCharCode] = fontCharCode;
      usedFontCharCodes[fontCharCode] = true;
    }
    return {
      toFontChar: toFontChar,
      charCodeToGlyphId: newMap,
      nextAvailableFontCharCode: nextAvailableFontCharCode
    };
  }
  function getRanges(glyphs, numGlyphs) {
    var codes = [];
    for (var charCode in glyphs) {
      if (glyphs[charCode] >= numGlyphs) {
        continue;
      }
      codes.push({
        fontCharCode: charCode | 0,
        glyphId: glyphs[charCode]
      });
    }
    if (codes.length === 0) {
      codes.push({
        fontCharCode: 0,
        glyphId: 0
      });
    }
    codes.sort(function fontGetRangesSort(a, b) {
      return a.fontCharCode - b.fontCharCode;
    });
    var ranges = [];
    var length = codes.length;
    for (var n = 0; n < length;) {
      var start = codes[n].fontCharCode;
      var codeIndices = [codes[n].glyphId];
      ++n;
      var end = start;
      while (n < length && end + 1 === codes[n].fontCharCode) {
        codeIndices.push(codes[n].glyphId);
        ++end;
        ++n;
        if (end === 0xFFFF) {
          break;
        }
      }
      ranges.push([start, end, codeIndices]);
    }
    return ranges;
  }
  function createCmapTable(glyphs, numGlyphs) {
    var ranges = getRanges(glyphs, numGlyphs);
    var numTables = ranges[ranges.length - 1][1] > 0xFFFF ? 2 : 1;
    var cmap = '\x00\x00' + string16(numTables) + '\x00\x03' + '\x00\x01' + (0, _util.string32)(4 + numTables * 8);
    var i, ii, j, jj;
    for (i = ranges.length - 1; i >= 0; --i) {
      if (ranges[i][0] <= 0xFFFF) {
        break;
      }
    }
    var bmpLength = i + 1;
    if (ranges[i][0] < 0xFFFF && ranges[i][1] === 0xFFFF) {
      ranges[i][1] = 0xFFFE;
    }
    var trailingRangesCount = ranges[i][1] < 0xFFFF ? 1 : 0;
    var segCount = bmpLength + trailingRangesCount;
    var searchParams = OpenTypeFileBuilder.getSearchParams(segCount, 2);
    var startCount = '';
    var endCount = '';
    var idDeltas = '';
    var idRangeOffsets = '';
    var glyphsIds = '';
    var bias = 0;
    var range, start, end, codes;
    for (i = 0, ii = bmpLength; i < ii; i++) {
      range = ranges[i];
      start = range[0];
      end = range[1];
      startCount += string16(start);
      endCount += string16(end);
      codes = range[2];
      var contiguous = true;
      for (j = 1, jj = codes.length; j < jj; ++j) {
        if (codes[j] !== codes[j - 1] + 1) {
          contiguous = false;
          break;
        }
      }
      if (!contiguous) {
        var offset = (segCount - i) * 2 + bias * 2;
        bias += end - start + 1;
        idDeltas += string16(0);
        idRangeOffsets += string16(offset);
        for (j = 0, jj = codes.length; j < jj; ++j) {
          glyphsIds += string16(codes[j]);
        }
      } else {
        var startCode = codes[0];
        idDeltas += string16(startCode - start & 0xFFFF);
        idRangeOffsets += string16(0);
      }
    }
    if (trailingRangesCount > 0) {
      endCount += '\xFF\xFF';
      startCount += '\xFF\xFF';
      idDeltas += '\x00\x01';
      idRangeOffsets += '\x00\x00';
    }
    var format314 = '\x00\x00' + string16(2 * segCount) + string16(searchParams.range) + string16(searchParams.entry) + string16(searchParams.rangeShift) + endCount + '\x00\x00' + startCount + idDeltas + idRangeOffsets + glyphsIds;
    var format31012 = '';
    var header31012 = '';
    if (numTables > 1) {
      cmap += '\x00\x03' + '\x00\x0A' + (0, _util.string32)(4 + numTables * 8 + 4 + format314.length);
      format31012 = '';
      for (i = 0, ii = ranges.length; i < ii; i++) {
        range = ranges[i];
        start = range[0];
        codes = range[2];
        var code = codes[0];
        for (j = 1, jj = codes.length; j < jj; ++j) {
          if (codes[j] !== codes[j - 1] + 1) {
            end = range[0] + j - 1;
            format31012 += (0, _util.string32)(start) + (0, _util.string32)(end) + (0, _util.string32)(code);
            start = end + 1;
            code = codes[j];
          }
        }
        format31012 += (0, _util.string32)(start) + (0, _util.string32)(range[1]) + (0, _util.string32)(code);
      }
      header31012 = '\x00\x0C' + '\x00\x00' + (0, _util.string32)(format31012.length + 16) + '\x00\x00\x00\x00' + (0, _util.string32)(format31012.length / 12);
    }
    return cmap + '\x00\x04' + string16(format314.length + 4) + format314 + header31012 + format31012;
  }
  function validateOS2Table(os2) {
    var stream = new _stream.Stream(os2.data);
    var version = stream.getUint16();
    stream.getBytes(60);
    var selection = stream.getUint16();
    if (version < 4 && selection & 0x0300) {
      return false;
    }
    var firstChar = stream.getUint16();
    var lastChar = stream.getUint16();
    if (firstChar > lastChar) {
      return false;
    }
    stream.getBytes(6);
    var usWinAscent = stream.getUint16();
    if (usWinAscent === 0) {
      return false;
    }
    os2.data[8] = os2.data[9] = 0;
    return true;
  }
  function createOS2Table(properties, charstrings, override) {
    override = override || {
      unitsPerEm: 0,
      yMax: 0,
      yMin: 0,
      ascent: 0,
      descent: 0
    };
    var ulUnicodeRange1 = 0;
    var ulUnicodeRange2 = 0;
    var ulUnicodeRange3 = 0;
    var ulUnicodeRange4 = 0;
    var firstCharIndex = null;
    var lastCharIndex = 0;
    if (charstrings) {
      for (var code in charstrings) {
        code |= 0;
        if (firstCharIndex > code || !firstCharIndex) {
          firstCharIndex = code;
        }
        if (lastCharIndex < code) {
          lastCharIndex = code;
        }
        var position = (0, _unicode.getUnicodeRangeFor)(code);
        if (position < 32) {
          ulUnicodeRange1 |= 1 << position;
        } else if (position < 64) {
          ulUnicodeRange2 |= 1 << position - 32;
        } else if (position < 96) {
          ulUnicodeRange3 |= 1 << position - 64;
        } else if (position < 123) {
          ulUnicodeRange4 |= 1 << position - 96;
        } else {
          throw new _util.FormatError('Unicode ranges Bits > 123 are reserved for internal usage');
        }
      }
    } else {
      firstCharIndex = 0;
      lastCharIndex = 255;
    }
    var bbox = properties.bbox || [0, 0, 0, 0];
    var unitsPerEm = override.unitsPerEm || 1 / (properties.fontMatrix || _util.FONT_IDENTITY_MATRIX)[0];
    var scale = properties.ascentScaled ? 1.0 : unitsPerEm / PDF_GLYPH_SPACE_UNITS;
    var typoAscent = override.ascent || Math.round(scale * (properties.ascent || bbox[3]));
    var typoDescent = override.descent || Math.round(scale * (properties.descent || bbox[1]));
    if (typoDescent > 0 && properties.descent > 0 && bbox[1] < 0) {
      typoDescent = -typoDescent;
    }
    var winAscent = override.yMax || typoAscent;
    var winDescent = -override.yMin || -typoDescent;
    return '\x00\x03' + '\x02\x24' + '\x01\xF4' + '\x00\x05' + '\x00\x00' + '\x02\x8A' + '\x02\xBB' + '\x00\x00' + '\x00\x8C' + '\x02\x8A' + '\x02\xBB' + '\x00\x00' + '\x01\xDF' + '\x00\x31' + '\x01\x02' + '\x00\x00' + '\x00\x00\x06' + String.fromCharCode(properties.fixedPitch ? 0x09 : 0x00) + '\x00\x00\x00\x00\x00\x00' + (0, _util.string32)(ulUnicodeRange1) + (0, _util.string32)(ulUnicodeRange2) + (0, _util.string32)(ulUnicodeRange3) + (0, _util.string32)(ulUnicodeRange4) + '\x2A\x32\x31\x2A' + string16(properties.italicAngle ? 1 : 0) + string16(firstCharIndex || properties.firstChar) + string16(lastCharIndex || properties.lastChar) + string16(typoAscent) + string16(typoDescent) + '\x00\x64' + string16(winAscent) + string16(winDescent) + '\x00\x00\x00\x00' + '\x00\x00\x00\x00' + string16(properties.xHeight) + string16(properties.capHeight) + string16(0) + string16(firstCharIndex || properties.firstChar) + '\x00\x03';
  }
  function createPostTable(properties) {
    var angle = Math.floor(properties.italicAngle * Math.pow(2, 16));
    return '\x00\x03\x00\x00' + (0, _util.string32)(angle) + '\x00\x00' + '\x00\x00' + (0, _util.string32)(properties.fixedPitch) + '\x00\x00\x00\x00' + '\x00\x00\x00\x00' + '\x00\x00\x00\x00' + '\x00\x00\x00\x00';
  }
  function createNameTable(name, proto) {
    if (!proto) {
      proto = [[], []];
    }
    var strings = [proto[0][0] || 'Original licence', proto[0][1] || name, proto[0][2] || 'Unknown', proto[0][3] || 'uniqueID', proto[0][4] || name, proto[0][5] || 'Version 0.11', proto[0][6] || '', proto[0][7] || 'Unknown', proto[0][8] || 'Unknown', proto[0][9] || 'Unknown'];
    var stringsUnicode = [];
    var i, ii, j, jj, str;
    for (i = 0, ii = strings.length; i < ii; i++) {
      str = proto[1][i] || strings[i];
      var strBufUnicode = [];
      for (j = 0, jj = str.length; j < jj; j++) {
        strBufUnicode.push(string16(str.charCodeAt(j)));
      }
      stringsUnicode.push(strBufUnicode.join(''));
    }
    var names = [strings, stringsUnicode];
    var platforms = ['\x00\x01', '\x00\x03'];
    var encodings = ['\x00\x00', '\x00\x01'];
    var languages = ['\x00\x00', '\x04\x09'];
    var namesRecordCount = strings.length * platforms.length;
    var nameTable = '\x00\x00' + string16(namesRecordCount) + string16(namesRecordCount * 12 + 6);
    var strOffset = 0;
    for (i = 0, ii = platforms.length; i < ii; i++) {
      var strs = names[i];
      for (j = 0, jj = strs.length; j < jj; j++) {
        str = strs[j];
        var nameRecord = platforms[i] + encodings[i] + languages[i] + string16(j) + string16(str.length) + string16(strOffset);
        nameTable += nameRecord;
        strOffset += str.length;
      }
    }
    nameTable += strings.join('') + stringsUnicode.join('');
    return nameTable;
  }
  Font.prototype = {
    name: null,
    font: null,
    mimetype: null,
    encoding: null,
    get renderer() {
      var renderer = _font_renderer.FontRendererFactory.create(this, SEAC_ANALYSIS_ENABLED);
      return (0, _util.shadow)(this, 'renderer', renderer);
    },
    exportData: function Font_exportData() {
      var data = {};
      for (var i in this) {
        if (this.hasOwnProperty(i)) {
          data[i] = this[i];
        }
      }
      return data;
    },
    fallbackToSystemFont: function Font_fallbackToSystemFont() {
      var _this = this;

      this.missingFile = true;
      var charCode, unicode;
      var name = this.name;
      var type = this.type;
      var subtype = this.subtype;
      var fontName = name.replace(/[,_]/g, '-');
      var stdFontMap = (0, _standard_fonts.getStdFontMap)(),
          nonStdFontMap = (0, _standard_fonts.getNonStdFontMap)();
      var isStandardFont = !!stdFontMap[fontName] || !!(nonStdFontMap[fontName] && stdFontMap[nonStdFontMap[fontName]]);
      fontName = stdFontMap[fontName] || nonStdFontMap[fontName] || fontName;
      this.bold = fontName.search(/bold/gi) !== -1;
      this.italic = fontName.search(/oblique/gi) !== -1 || fontName.search(/italic/gi) !== -1;
      this.black = name.search(/Black/g) !== -1;
      this.remeasure = Object.keys(this.widths).length > 0;
      if (isStandardFont && type === 'CIDFontType2' && this.cidEncoding.indexOf('Identity-') === 0) {
        var GlyphMapForStandardFonts = (0, _standard_fonts.getGlyphMapForStandardFonts)();
        var map = [];
        for (charCode in GlyphMapForStandardFonts) {
          map[+charCode] = GlyphMapForStandardFonts[charCode];
        }
        if (/Arial-?Black/i.test(name)) {
          var SupplementalGlyphMapForArialBlack = (0, _standard_fonts.getSupplementalGlyphMapForArialBlack)();
          for (charCode in SupplementalGlyphMapForArialBlack) {
            map[+charCode] = SupplementalGlyphMapForArialBlack[charCode];
          }
        }
        var isIdentityUnicode = this.toUnicode instanceof IdentityToUnicodeMap;
        if (!isIdentityUnicode) {
          this.toUnicode.forEach(function (charCode, unicodeCharCode) {
            map[+charCode] = unicodeCharCode;
          });
        }
        this.toFontChar = map;
        this.toUnicode = new ToUnicodeMap(map);
      } else if (/Symbol/i.test(fontName)) {
        this.toFontChar = buildToFontChar(_encodings.SymbolSetEncoding, (0, _glyphlist.getGlyphsUnicode)(), this.differences);
      } else if (/Dingbats/i.test(fontName)) {
        if (/Wingdings/i.test(name)) {
          (0, _util.warn)('Non-embedded Wingdings font, falling back to ZapfDingbats.');
        }
        this.toFontChar = buildToFontChar(_encodings.ZapfDingbatsEncoding, (0, _glyphlist.getDingbatsGlyphsUnicode)(), this.differences);
      } else if (isStandardFont) {
        this.toFontChar = buildToFontChar(this.defaultEncoding, (0, _glyphlist.getGlyphsUnicode)(), this.differences);
      } else {
        var glyphsUnicodeMap = (0, _glyphlist.getGlyphsUnicode)();
        this.toUnicode.forEach(function (charCode, unicodeCharCode) {
          if (!_this.composite) {
            var glyphName = _this.differences[charCode] || _this.defaultEncoding[charCode];
            unicode = (0, _unicode.getUnicodeForGlyph)(glyphName, glyphsUnicodeMap);
            if (unicode !== -1) {
              unicodeCharCode = unicode;
            }
          }
          _this.toFontChar[charCode] = unicodeCharCode;
        });
      }
      this.loadedName = fontName.split('-')[0];
      this.loading = false;
      this.fontType = getFontType(type, subtype);
    },
    checkAndRepair: function Font_checkAndRepair(name, font, properties) {
      function readTableEntry(file) {
        var tag = (0, _util.bytesToString)(file.getBytes(4));
        var checksum = file.getInt32() >>> 0;
        var offset = file.getInt32() >>> 0;
        var length = file.getInt32() >>> 0;
        var previousPosition = file.pos;
        file.pos = file.start ? file.start : 0;
        file.skip(offset);
        var data = file.getBytes(length);
        file.pos = previousPosition;
        if (tag === 'head') {
          data[8] = data[9] = data[10] = data[11] = 0;
          data[17] |= 0x20;
        }
        return {
          tag: tag,
          checksum: checksum,
          length: length,
          offset: offset,
          data: data
        };
      }
      function readOpenTypeHeader(ttf) {
        return {
          version: (0, _util.bytesToString)(ttf.getBytes(4)),
          numTables: ttf.getUint16(),
          searchRange: ttf.getUint16(),
          entrySelector: ttf.getUint16(),
          rangeShift: ttf.getUint16()
        };
      }
      function readCmapTable(cmap, font, isSymbolicFont, hasEncoding) {
        if (!cmap) {
          (0, _util.warn)('No cmap table available.');
          return {
            platformId: -1,
            encodingId: -1,
            mappings: [],
            hasShortCmap: false
          };
        }
        var segment;
        var start = (font.start ? font.start : 0) + cmap.offset;
        font.pos = start;
        font.getUint16();
        var numTables = font.getUint16();
        var potentialTable;
        var canBreak = false;
        for (var i = 0; i < numTables; i++) {
          var platformId = font.getUint16();
          var encodingId = font.getUint16();
          var offset = font.getInt32() >>> 0;
          var useTable = false;
          if (potentialTable && potentialTable.platformId === platformId && potentialTable.encodingId === encodingId) {
            continue;
          }
          if (platformId === 0 && encodingId === 0) {
            useTable = true;
          } else if (platformId === 1 && encodingId === 0) {
            useTable = true;
          } else if (platformId === 3 && encodingId === 1 && (hasEncoding || !potentialTable)) {
            useTable = true;
            if (!isSymbolicFont) {
              canBreak = true;
            }
          } else if (isSymbolicFont && platformId === 3 && encodingId === 0) {
            useTable = true;
            canBreak = true;
          }
          if (useTable) {
            potentialTable = {
              platformId: platformId,
              encodingId: encodingId,
              offset: offset
            };
          }
          if (canBreak) {
            break;
          }
        }
        if (potentialTable) {
          font.pos = start + potentialTable.offset;
        }
        if (!potentialTable || font.peekByte() === -1) {
          (0, _util.warn)('Could not find a preferred cmap table.');
          return {
            platformId: -1,
            encodingId: -1,
            mappings: [],
            hasShortCmap: false
          };
        }
        var format = font.getUint16();
        font.getUint16();
        font.getUint16();
        var hasShortCmap = false;
        var mappings = [];
        var j, glyphId;
        if (format === 0) {
          for (j = 0; j < 256; j++) {
            var index = font.getByte();
            if (!index) {
              continue;
            }
            mappings.push({
              charCode: j,
              glyphId: index
            });
          }
          hasShortCmap = true;
        } else if (format === 4) {
          var segCount = font.getUint16() >> 1;
          font.getBytes(6);
          var segIndex,
              segments = [];
          for (segIndex = 0; segIndex < segCount; segIndex++) {
            segments.push({ end: font.getUint16() });
          }
          font.getUint16();
          for (segIndex = 0; segIndex < segCount; segIndex++) {
            segments[segIndex].start = font.getUint16();
          }
          for (segIndex = 0; segIndex < segCount; segIndex++) {
            segments[segIndex].delta = font.getUint16();
          }
          var offsetsCount = 0;
          for (segIndex = 0; segIndex < segCount; segIndex++) {
            segment = segments[segIndex];
            var rangeOffset = font.getUint16();
            if (!rangeOffset) {
              segment.offsetIndex = -1;
              continue;
            }
            var offsetIndex = (rangeOffset >> 1) - (segCount - segIndex);
            segment.offsetIndex = offsetIndex;
            offsetsCount = Math.max(offsetsCount, offsetIndex + segment.end - segment.start + 1);
          }
          var offsets = [];
          for (j = 0; j < offsetsCount; j++) {
            offsets.push(font.getUint16());
          }
          for (segIndex = 0; segIndex < segCount; segIndex++) {
            segment = segments[segIndex];
            start = segment.start;
            var end = segment.end;
            var delta = segment.delta;
            offsetIndex = segment.offsetIndex;
            for (j = start; j <= end; j++) {
              if (j === 0xFFFF) {
                continue;
              }
              glyphId = offsetIndex < 0 ? j : offsets[offsetIndex + j - start];
              glyphId = glyphId + delta & 0xFFFF;
              mappings.push({
                charCode: j,
                glyphId: glyphId
              });
            }
          }
        } else if (format === 6) {
          var firstCode = font.getUint16();
          var entryCount = font.getUint16();
          for (j = 0; j < entryCount; j++) {
            glyphId = font.getUint16();
            var charCode = firstCode + j;
            mappings.push({
              charCode: charCode,
              glyphId: glyphId
            });
          }
        } else {
          (0, _util.warn)('cmap table has unsupported format: ' + format);
          return {
            platformId: -1,
            encodingId: -1,
            mappings: [],
            hasShortCmap: false
          };
        }
        mappings.sort(function (a, b) {
          return a.charCode - b.charCode;
        });
        for (i = 1; i < mappings.length; i++) {
          if (mappings[i - 1].charCode === mappings[i].charCode) {
            mappings.splice(i, 1);
            i--;
          }
        }
        return {
          platformId: potentialTable.platformId,
          encodingId: potentialTable.encodingId,
          mappings: mappings,
          hasShortCmap: hasShortCmap
        };
      }
      function sanitizeMetrics(font, header, metrics, numGlyphs) {
        if (!header) {
          if (metrics) {
            metrics.data = null;
          }
          return;
        }
        font.pos = (font.start ? font.start : 0) + header.offset;
        font.pos += header.length - 2;
        var numOfMetrics = font.getUint16();
        if (numOfMetrics > numGlyphs) {
          (0, _util.info)('The numOfMetrics (' + numOfMetrics + ') should not be ' + 'greater than the numGlyphs (' + numGlyphs + ')');
          numOfMetrics = numGlyphs;
          header.data[34] = (numOfMetrics & 0xff00) >> 8;
          header.data[35] = numOfMetrics & 0x00ff;
        }
        var numOfSidebearings = numGlyphs - numOfMetrics;
        var numMissing = numOfSidebearings - (metrics.length - numOfMetrics * 4 >> 1);
        if (numMissing > 0) {
          var entries = new Uint8Array(metrics.length + numMissing * 2);
          entries.set(metrics.data);
          metrics.data = entries;
        }
      }
      function sanitizeGlyph(source, sourceStart, sourceEnd, dest, destStart, hintsValid) {
        if (sourceEnd - sourceStart <= 12) {
          return 0;
        }
        var glyf = source.subarray(sourceStart, sourceEnd);
        var contoursCount = glyf[0] << 8 | glyf[1];
        if (contoursCount & 0x8000) {
          dest.set(glyf, destStart);
          return glyf.length;
        }
        var i,
            j = 10,
            flagsCount = 0;
        for (i = 0; i < contoursCount; i++) {
          var endPoint = glyf[j] << 8 | glyf[j + 1];
          flagsCount = endPoint + 1;
          j += 2;
        }
        var instructionsStart = j;
        var instructionsLength = glyf[j] << 8 | glyf[j + 1];
        j += 2 + instructionsLength;
        var instructionsEnd = j;
        var coordinatesLength = 0;
        for (i = 0; i < flagsCount; i++) {
          var flag = glyf[j++];
          if (flag & 0xC0) {
            glyf[j - 1] = flag & 0x3F;
          }
          var xyLength = (flag & 2 ? 1 : flag & 16 ? 0 : 2) + (flag & 4 ? 1 : flag & 32 ? 0 : 2);
          coordinatesLength += xyLength;
          if (flag & 8) {
            var repeat = glyf[j++];
            i += repeat;
            coordinatesLength += repeat * xyLength;
          }
        }
        if (coordinatesLength === 0) {
          return 0;
        }
        var glyphDataLength = j + coordinatesLength;
        if (glyphDataLength > glyf.length) {
          return 0;
        }
        if (!hintsValid && instructionsLength > 0) {
          dest.set(glyf.subarray(0, instructionsStart), destStart);
          dest.set([0, 0], destStart + instructionsStart);
          dest.set(glyf.subarray(instructionsEnd, glyphDataLength), destStart + instructionsStart + 2);
          glyphDataLength -= instructionsLength;
          if (glyf.length - glyphDataLength > 3) {
            glyphDataLength = glyphDataLength + 3 & ~3;
          }
          return glyphDataLength;
        }
        if (glyf.length - glyphDataLength > 3) {
          glyphDataLength = glyphDataLength + 3 & ~3;
          dest.set(glyf.subarray(0, glyphDataLength), destStart);
          return glyphDataLength;
        }
        dest.set(glyf, destStart);
        return glyf.length;
      }
      function sanitizeHead(head, numGlyphs, locaLength) {
        var data = head.data;
        var version = int32(data[0], data[1], data[2], data[3]);
        if (version >> 16 !== 1) {
          (0, _util.info)('Attempting to fix invalid version in head table: ' + version);
          data[0] = 0;
          data[1] = 1;
          data[2] = 0;
          data[3] = 0;
        }
        var indexToLocFormat = int16(data[50], data[51]);
        if (indexToLocFormat < 0 || indexToLocFormat > 1) {
          (0, _util.info)('Attempting to fix invalid indexToLocFormat in head table: ' + indexToLocFormat);
          var numGlyphsPlusOne = numGlyphs + 1;
          if (locaLength === numGlyphsPlusOne << 1) {
            data[50] = 0;
            data[51] = 0;
          } else if (locaLength === numGlyphsPlusOne << 2) {
            data[50] = 0;
            data[51] = 1;
          } else {
            throw new _util.FormatError('Could not fix indexToLocFormat: ' + indexToLocFormat);
          }
        }
      }
      function sanitizeGlyphLocations(loca, glyf, numGlyphs, isGlyphLocationsLong, hintsValid, dupFirstEntry) {
        var itemSize, itemDecode, itemEncode;
        if (isGlyphLocationsLong) {
          itemSize = 4;
          itemDecode = function fontItemDecodeLong(data, offset) {
            return data[offset] << 24 | data[offset + 1] << 16 | data[offset + 2] << 8 | data[offset + 3];
          };
          itemEncode = function fontItemEncodeLong(data, offset, value) {
            data[offset] = value >>> 24 & 0xFF;
            data[offset + 1] = value >> 16 & 0xFF;
            data[offset + 2] = value >> 8 & 0xFF;
            data[offset + 3] = value & 0xFF;
          };
        } else {
          itemSize = 2;
          itemDecode = function fontItemDecode(data, offset) {
            return data[offset] << 9 | data[offset + 1] << 1;
          };
          itemEncode = function fontItemEncode(data, offset, value) {
            data[offset] = value >> 9 & 0xFF;
            data[offset + 1] = value >> 1 & 0xFF;
          };
        }
        var locaData = loca.data;
        var locaDataSize = itemSize * (1 + numGlyphs);
        if (locaData.length !== locaDataSize) {
          locaData = new Uint8Array(locaDataSize);
          locaData.set(loca.data.subarray(0, locaDataSize));
          loca.data = locaData;
        }
        var oldGlyfData = glyf.data;
        var oldGlyfDataLength = oldGlyfData.length;
        var newGlyfData = new Uint8Array(oldGlyfDataLength);
        var startOffset = itemDecode(locaData, 0);
        var writeOffset = 0;
        var missingGlyphData = Object.create(null);
        itemEncode(locaData, 0, writeOffset);
        var i, j;
        var locaCount = dupFirstEntry ? numGlyphs - 1 : numGlyphs;
        for (i = 0, j = itemSize; i < locaCount; i++, j += itemSize) {
          var endOffset = itemDecode(locaData, j);
          if (endOffset > oldGlyfDataLength && (oldGlyfDataLength + 3 & ~3) === endOffset) {
            endOffset = oldGlyfDataLength;
          }
          if (endOffset > oldGlyfDataLength) {
            startOffset = endOffset;
          }
          var newLength = sanitizeGlyph(oldGlyfData, startOffset, endOffset, newGlyfData, writeOffset, hintsValid);
          if (newLength === 0) {
            missingGlyphData[i] = true;
          }
          writeOffset += newLength;
          itemEncode(locaData, j, writeOffset);
          startOffset = endOffset;
        }
        if (writeOffset === 0) {
          var simpleGlyph = new Uint8Array([0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 49, 0]);
          for (i = 0, j = itemSize; i < numGlyphs; i++, j += itemSize) {
            itemEncode(locaData, j, simpleGlyph.length);
          }
          glyf.data = simpleGlyph;
          return missingGlyphData;
        }
        if (dupFirstEntry) {
          var firstEntryLength = itemDecode(locaData, itemSize);
          if (newGlyfData.length > firstEntryLength + writeOffset) {
            glyf.data = newGlyfData.subarray(0, firstEntryLength + writeOffset);
          } else {
            glyf.data = new Uint8Array(firstEntryLength + writeOffset);
            glyf.data.set(newGlyfData.subarray(0, writeOffset));
          }
          glyf.data.set(newGlyfData.subarray(0, firstEntryLength), writeOffset);
          itemEncode(loca.data, locaData.length - itemSize, writeOffset + firstEntryLength);
        } else {
          glyf.data = newGlyfData.subarray(0, writeOffset);
        }
        return missingGlyphData;
      }
      function readPostScriptTable(post, properties, maxpNumGlyphs) {
        var start = (font.start ? font.start : 0) + post.offset;
        font.pos = start;
        var length = post.length,
            end = start + length;
        var version = font.getInt32();
        font.getBytes(28);
        var glyphNames;
        var valid = true;
        var i;
        switch (version) {
          case 0x00010000:
            glyphNames = MacStandardGlyphOrdering;
            break;
          case 0x00020000:
            var numGlyphs = font.getUint16();
            if (numGlyphs !== maxpNumGlyphs) {
              valid = false;
              break;
            }
            var glyphNameIndexes = [];
            for (i = 0; i < numGlyphs; ++i) {
              var index = font.getUint16();
              if (index >= 32768) {
                valid = false;
                break;
              }
              glyphNameIndexes.push(index);
            }
            if (!valid) {
              break;
            }
            var customNames = [];
            var strBuf = [];
            while (font.pos < end) {
              var stringLength = font.getByte();
              strBuf.length = stringLength;
              for (i = 0; i < stringLength; ++i) {
                strBuf[i] = String.fromCharCode(font.getByte());
              }
              customNames.push(strBuf.join(''));
            }
            glyphNames = [];
            for (i = 0; i < numGlyphs; ++i) {
              var j = glyphNameIndexes[i];
              if (j < 258) {
                glyphNames.push(MacStandardGlyphOrdering[j]);
                continue;
              }
              glyphNames.push(customNames[j - 258]);
            }
            break;
          case 0x00030000:
            break;
          default:
            (0, _util.warn)('Unknown/unsupported post table version ' + version);
            valid = false;
            if (properties.defaultEncoding) {
              glyphNames = properties.defaultEncoding;
            }
            break;
        }
        properties.glyphNames = glyphNames;
        return valid;
      }
      function readNameTable(nameTable) {
        var start = (font.start ? font.start : 0) + nameTable.offset;
        font.pos = start;
        var names = [[], []];
        var length = nameTable.length,
            end = start + length;
        var format = font.getUint16();
        var FORMAT_0_HEADER_LENGTH = 6;
        if (format !== 0 || length < FORMAT_0_HEADER_LENGTH) {
          return names;
        }
        var numRecords = font.getUint16();
        var stringsStart = font.getUint16();
        var records = [];
        var NAME_RECORD_LENGTH = 12;
        var i, ii;
        for (i = 0; i < numRecords && font.pos + NAME_RECORD_LENGTH <= end; i++) {
          var r = {
            platform: font.getUint16(),
            encoding: font.getUint16(),
            language: font.getUint16(),
            name: font.getUint16(),
            length: font.getUint16(),
            offset: font.getUint16()
          };
          if (r.platform === 1 && r.encoding === 0 && r.language === 0 || r.platform === 3 && r.encoding === 1 && r.language === 0x409) {
            records.push(r);
          }
        }
        for (i = 0, ii = records.length; i < ii; i++) {
          var record = records[i];
          if (record.length <= 0) {
            continue;
          }
          var pos = start + stringsStart + record.offset;
          if (pos + record.length > end) {
            continue;
          }
          font.pos = pos;
          var nameIndex = record.name;
          if (record.encoding) {
            var str = '';
            for (var j = 0, jj = record.length; j < jj; j += 2) {
              str += String.fromCharCode(font.getUint16());
            }
            names[1][nameIndex] = str;
          } else {
            names[0][nameIndex] = (0, _util.bytesToString)(font.getBytes(record.length));
          }
        }
        return names;
      }
      var TTOpsStackDeltas = [0, 0, 0, 0, 0, 0, 0, 0, -2, -2, -2, -2, 0, 0, -2, -5, -1, -1, -1, -1, -1, -1, -1, -1, 0, 0, -1, 0, -1, -1, -1, -1, 1, -1, -999, 0, 1, 0, -1, -2, 0, -1, -2, -1, -1, 0, -1, -1, 0, 0, -999, -999, -1, -1, -1, -1, -2, -999, -2, -2, -999, 0, -2, -2, 0, 0, -2, 0, -2, 0, 0, 0, -2, -1, -1, 1, 1, 0, 0, -1, -1, -1, -1, -1, -1, -1, 0, 0, -1, 0, -1, -1, 0, -999, -1, -1, -1, -1, -1, -1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, -2, -999, -999, -999, -999, -999, -1, -1, -2, -2, 0, 0, 0, 0, -1, -1, -999, -2, -2, 0, 0, -1, -2, -2, 0, 0, 0, -1, -1, -1, -2];
      function sanitizeTTProgram(table, ttContext) {
        var data = table.data;
        var i = 0,
            j,
            n,
            b,
            funcId,
            pc,
            lastEndf = 0,
            lastDeff = 0;
        var stack = [];
        var callstack = [];
        var functionsCalled = [];
        var tooComplexToFollowFunctions = ttContext.tooComplexToFollowFunctions;
        var inFDEF = false,
            ifLevel = 0,
            inELSE = 0;
        for (var ii = data.length; i < ii;) {
          var op = data[i++];
          if (op === 0x40) {
            n = data[i++];
            if (inFDEF || inELSE) {
              i += n;
            } else {
              for (j = 0; j < n; j++) {
                stack.push(data[i++]);
              }
            }
          } else if (op === 0x41) {
            n = data[i++];
            if (inFDEF || inELSE) {
              i += n * 2;
            } else {
              for (j = 0; j < n; j++) {
                b = data[i++];
                stack.push(b << 8 | data[i++]);
              }
            }
          } else if ((op & 0xF8) === 0xB0) {
            n = op - 0xB0 + 1;
            if (inFDEF || inELSE) {
              i += n;
            } else {
              for (j = 0; j < n; j++) {
                stack.push(data[i++]);
              }
            }
          } else if ((op & 0xF8) === 0xB8) {
            n = op - 0xB8 + 1;
            if (inFDEF || inELSE) {
              i += n * 2;
            } else {
              for (j = 0; j < n; j++) {
                b = data[i++];
                stack.push(b << 8 | data[i++]);
              }
            }
          } else if (op === 0x2B && !tooComplexToFollowFunctions) {
            if (!inFDEF && !inELSE) {
              funcId = stack[stack.length - 1];
              ttContext.functionsUsed[funcId] = true;
              if (funcId in ttContext.functionsStackDeltas) {
                stack.length += ttContext.functionsStackDeltas[funcId];
              } else if (funcId in ttContext.functionsDefined && functionsCalled.indexOf(funcId) < 0) {
                callstack.push({
                  data: data,
                  i: i,
                  stackTop: stack.length - 1
                });
                functionsCalled.push(funcId);
                pc = ttContext.functionsDefined[funcId];
                if (!pc) {
                  (0, _util.warn)('TT: CALL non-existent function');
                  ttContext.hintsValid = false;
                  return;
                }
                data = pc.data;
                i = pc.i;
              }
            }
          } else if (op === 0x2C && !tooComplexToFollowFunctions) {
            if (inFDEF || inELSE) {
              (0, _util.warn)('TT: nested FDEFs not allowed');
              tooComplexToFollowFunctions = true;
            }
            inFDEF = true;
            lastDeff = i;
            funcId = stack.pop();
            ttContext.functionsDefined[funcId] = {
              data: data,
              i: i
            };
          } else if (op === 0x2D) {
            if (inFDEF) {
              inFDEF = false;
              lastEndf = i;
            } else {
              pc = callstack.pop();
              if (!pc) {
                (0, _util.warn)('TT: ENDF bad stack');
                ttContext.hintsValid = false;
                return;
              }
              funcId = functionsCalled.pop();
              data = pc.data;
              i = pc.i;
              ttContext.functionsStackDeltas[funcId] = stack.length - pc.stackTop;
            }
          } else if (op === 0x89) {
            if (inFDEF || inELSE) {
              (0, _util.warn)('TT: nested IDEFs not allowed');
              tooComplexToFollowFunctions = true;
            }
            inFDEF = true;
            lastDeff = i;
          } else if (op === 0x58) {
            ++ifLevel;
          } else if (op === 0x1B) {
            inELSE = ifLevel;
          } else if (op === 0x59) {
            if (inELSE === ifLevel) {
              inELSE = 0;
            }
            --ifLevel;
          } else if (op === 0x1C) {
            if (!inFDEF && !inELSE) {
              var offset = stack[stack.length - 1];
              if (offset > 0) {
                i += offset - 1;
              }
            }
          }
          if (!inFDEF && !inELSE) {
            var stackDelta = op <= 0x8E ? TTOpsStackDeltas[op] : op >= 0xC0 && op <= 0xDF ? -1 : op >= 0xE0 ? -2 : 0;
            if (op >= 0x71 && op <= 0x75) {
              n = stack.pop();
              if (!isNaN(n)) {
                stackDelta = -n * 2;
              }
            }
            while (stackDelta < 0 && stack.length > 0) {
              stack.pop();
              stackDelta++;
            }
            while (stackDelta > 0) {
              stack.push(NaN);
              stackDelta--;
            }
          }
        }
        ttContext.tooComplexToFollowFunctions = tooComplexToFollowFunctions;
        var content = [data];
        if (i > data.length) {
          content.push(new Uint8Array(i - data.length));
        }
        if (lastDeff > lastEndf) {
          (0, _util.warn)('TT: complementing a missing function tail');
          content.push(new Uint8Array([0x22, 0x2D]));
        }
        foldTTTable(table, content);
      }
      function checkInvalidFunctions(ttContext, maxFunctionDefs) {
        if (ttContext.tooComplexToFollowFunctions) {
          return;
        }
        if (ttContext.functionsDefined.length > maxFunctionDefs) {
          (0, _util.warn)('TT: more functions defined than expected');
          ttContext.hintsValid = false;
          return;
        }
        for (var j = 0, jj = ttContext.functionsUsed.length; j < jj; j++) {
          if (j > maxFunctionDefs) {
            (0, _util.warn)('TT: invalid function id: ' + j);
            ttContext.hintsValid = false;
            return;
          }
          if (ttContext.functionsUsed[j] && !ttContext.functionsDefined[j]) {
            (0, _util.warn)('TT: undefined function: ' + j);
            ttContext.hintsValid = false;
            return;
          }
        }
      }
      function foldTTTable(table, content) {
        if (content.length > 1) {
          var newLength = 0;
          var j, jj;
          for (j = 0, jj = content.length; j < jj; j++) {
            newLength += content[j].length;
          }
          newLength = newLength + 3 & ~3;
          var result = new Uint8Array(newLength);
          var pos = 0;
          for (j = 0, jj = content.length; j < jj; j++) {
            result.set(content[j], pos);
            pos += content[j].length;
          }
          table.data = result;
          table.length = newLength;
        }
      }
      function sanitizeTTPrograms(fpgm, prep, cvt, maxFunctionDefs) {
        var ttContext = {
          functionsDefined: [],
          functionsUsed: [],
          functionsStackDeltas: [],
          tooComplexToFollowFunctions: false,
          hintsValid: true
        };
        if (fpgm) {
          sanitizeTTProgram(fpgm, ttContext);
        }
        if (prep) {
          sanitizeTTProgram(prep, ttContext);
        }
        if (fpgm) {
          checkInvalidFunctions(ttContext, maxFunctionDefs);
        }
        if (cvt && cvt.length & 1) {
          var cvtData = new Uint8Array(cvt.length + 1);
          cvtData.set(cvt.data);
          cvt.data = cvtData;
        }
        return ttContext.hintsValid;
      }
      font = new _stream.Stream(new Uint8Array(font.getBytes()));
      var VALID_TABLES = ['OS/2', 'cmap', 'head', 'hhea', 'hmtx', 'maxp', 'name', 'post', 'loca', 'glyf', 'fpgm', 'prep', 'cvt ', 'CFF '];
      var header = readOpenTypeHeader(font);
      var numTables = header.numTables;
      var cff, cffFile;
      var tables = Object.create(null);
      tables['OS/2'] = null;
      tables['cmap'] = null;
      tables['head'] = null;
      tables['hhea'] = null;
      tables['hmtx'] = null;
      tables['maxp'] = null;
      tables['name'] = null;
      tables['post'] = null;
      var table;
      for (var i = 0; i < numTables; i++) {
        table = readTableEntry(font);
        if (VALID_TABLES.indexOf(table.tag) < 0) {
          continue;
        }
        if (table.length === 0) {
          continue;
        }
        tables[table.tag] = table;
      }
      var isTrueType = !tables['CFF '];
      if (!isTrueType) {
        if (header.version === 'OTTO' && !(properties.composite && properties.cidToGidMap) || !tables['head'] || !tables['hhea'] || !tables['maxp'] || !tables['post']) {
          cffFile = new _stream.Stream(tables['CFF '].data);
          cff = new CFFFont(cffFile, properties);
          adjustWidths(properties);
          return this.convert(name, cff, properties);
        }
        delete tables['glyf'];
        delete tables['loca'];
        delete tables['fpgm'];
        delete tables['prep'];
        delete tables['cvt '];
        this.isOpenType = true;
      } else {
        if (!tables['loca']) {
          throw new _util.FormatError('Required "loca" table is not found');
        }
        if (!tables['glyf']) {
          (0, _util.warn)('Required "glyf" table is not found -- trying to recover.');
          tables['glyf'] = {
            tag: 'glyf',
            data: new Uint8Array(0)
          };
        }
        this.isOpenType = false;
      }
      if (!tables['maxp']) {
        throw new _util.FormatError('Required "maxp" table is not found');
      }
      font.pos = (font.start || 0) + tables['maxp'].offset;
      var version = font.getInt32();
      var numGlyphs = font.getUint16();
      var maxFunctionDefs = 0;
      if (version >= 0x00010000 && tables['maxp'].length >= 22) {
        font.pos += 8;
        var maxZones = font.getUint16();
        if (maxZones > 2) {
          tables['maxp'].data[14] = 0;
          tables['maxp'].data[15] = 2;
        }
        font.pos += 4;
        maxFunctionDefs = font.getUint16();
      }
      var dupFirstEntry = false;
      if (properties.type === 'CIDFontType2' && properties.toUnicode && properties.toUnicode.get(0) > '\0') {
        dupFirstEntry = true;
        numGlyphs++;
        tables['maxp'].data[4] = numGlyphs >> 8;
        tables['maxp'].data[5] = numGlyphs & 255;
      }
      var hintsValid = sanitizeTTPrograms(tables['fpgm'], tables['prep'], tables['cvt '], maxFunctionDefs);
      if (!hintsValid) {
        delete tables['fpgm'];
        delete tables['prep'];
        delete tables['cvt '];
      }
      sanitizeMetrics(font, tables['hhea'], tables['hmtx'], numGlyphs);
      if (!tables['head']) {
        throw new _util.FormatError('Required "head" table is not found');
      }
      sanitizeHead(tables['head'], numGlyphs, isTrueType ? tables['loca'].length : 0);
      var missingGlyphs = Object.create(null);
      if (isTrueType) {
        var isGlyphLocationsLong = int16(tables['head'].data[50], tables['head'].data[51]);
        missingGlyphs = sanitizeGlyphLocations(tables['loca'], tables['glyf'], numGlyphs, isGlyphLocationsLong, hintsValid, dupFirstEntry);
      }
      if (!tables['hhea']) {
        throw new _util.FormatError('Required "hhea" table is not found');
      }
      if (tables['hhea'].data[10] === 0 && tables['hhea'].data[11] === 0) {
        tables['hhea'].data[10] = 0xFF;
        tables['hhea'].data[11] = 0xFF;
      }
      var metricsOverride = {
        unitsPerEm: int16(tables['head'].data[18], tables['head'].data[19]),
        yMax: int16(tables['head'].data[42], tables['head'].data[43]),
        yMin: signedInt16(tables['head'].data[38], tables['head'].data[39]),
        ascent: int16(tables['hhea'].data[4], tables['hhea'].data[5]),
        descent: signedInt16(tables['hhea'].data[6], tables['hhea'].data[7])
      };
      this.ascent = metricsOverride.ascent / metricsOverride.unitsPerEm;
      this.descent = metricsOverride.descent / metricsOverride.unitsPerEm;
      if (tables['post']) {
        var valid = readPostScriptTable(tables['post'], properties, numGlyphs);
        if (!valid) {
          tables['post'] = null;
        }
      }
      var charCodeToGlyphId = [],
          charCode;
      function hasGlyph(glyphId) {
        return !missingGlyphs[glyphId];
      }
      if (properties.composite) {
        var cidToGidMap = properties.cidToGidMap || [];
        var isCidToGidMapEmpty = cidToGidMap.length === 0;
        properties.cMap.forEach(function (charCode, cid) {
          if (cid > 0xffff) {
            throw new _util.FormatError('Max size of CID is 65,535');
          }
          var glyphId = -1;
          if (isCidToGidMapEmpty) {
            glyphId = cid;
          } else if (cidToGidMap[cid] !== undefined) {
            glyphId = cidToGidMap[cid];
          }
          if (glyphId >= 0 && glyphId < numGlyphs && hasGlyph(glyphId)) {
            charCodeToGlyphId[charCode] = glyphId;
          }
        });
        if (dupFirstEntry && (isCidToGidMapEmpty || !charCodeToGlyphId[0])) {
          charCodeToGlyphId[0] = numGlyphs - 1;
        }
      } else {
        var cmapTable = readCmapTable(tables['cmap'], font, this.isSymbolicFont, properties.hasEncoding);
        var cmapPlatformId = cmapTable.platformId;
        var cmapEncodingId = cmapTable.encodingId;
        var cmapMappings = cmapTable.mappings;
        var cmapMappingsLength = cmapMappings.length;
        if (properties.hasEncoding && (cmapPlatformId === 3 && cmapEncodingId === 1 || cmapPlatformId === 1 && cmapEncodingId === 0) || cmapPlatformId === -1 && cmapEncodingId === -1 && !!(0, _encodings.getEncoding)(properties.baseEncodingName)) {
          var baseEncoding = [];
          if (properties.baseEncodingName === 'MacRomanEncoding' || properties.baseEncodingName === 'WinAnsiEncoding') {
            baseEncoding = (0, _encodings.getEncoding)(properties.baseEncodingName);
          }
          var glyphsUnicodeMap = (0, _glyphlist.getGlyphsUnicode)();
          for (charCode = 0; charCode < 256; charCode++) {
            var glyphName, standardGlyphName;
            if (this.differences && charCode in this.differences) {
              glyphName = this.differences[charCode];
            } else if (charCode in baseEncoding && baseEncoding[charCode] !== '') {
              glyphName = baseEncoding[charCode];
            } else {
              glyphName = _encodings.StandardEncoding[charCode];
            }
            if (!glyphName) {
              continue;
            }
            standardGlyphName = recoverGlyphName(glyphName, glyphsUnicodeMap);
            var unicodeOrCharCode;
            if (cmapPlatformId === 3 && cmapEncodingId === 1) {
              unicodeOrCharCode = glyphsUnicodeMap[standardGlyphName];
            } else if (cmapPlatformId === 1 && cmapEncodingId === 0) {
              unicodeOrCharCode = _encodings.MacRomanEncoding.indexOf(standardGlyphName);
            }
            var found = false;
            for (i = 0; i < cmapMappingsLength; ++i) {
              if (cmapMappings[i].charCode !== unicodeOrCharCode) {
                continue;
              }
              charCodeToGlyphId[charCode] = cmapMappings[i].glyphId;
              found = true;
              break;
            }
            if (!found && properties.glyphNames) {
              var glyphId = properties.glyphNames.indexOf(glyphName);
              if (glyphId === -1 && standardGlyphName !== glyphName) {
                glyphId = properties.glyphNames.indexOf(standardGlyphName);
              }
              if (glyphId > 0 && hasGlyph(glyphId)) {
                charCodeToGlyphId[charCode] = glyphId;
                found = true;
              }
            }
          }
        } else if (cmapPlatformId === 0 && cmapEncodingId === 0) {
          for (i = 0; i < cmapMappingsLength; ++i) {
            charCodeToGlyphId[cmapMappings[i].charCode] = cmapMappings[i].glyphId;
          }
        } else {
          for (i = 0; i < cmapMappingsLength; ++i) {
            charCode = cmapMappings[i].charCode;
            if (cmapPlatformId === 3 && charCode >= 0xF000 && charCode <= 0xF0FF) {
              charCode &= 0xFF;
            }
            charCodeToGlyphId[charCode] = cmapMappings[i].glyphId;
          }
        }
      }
      if (charCodeToGlyphId.length === 0) {
        charCodeToGlyphId[0] = 0;
      }
      var newMapping = adjustMapping(charCodeToGlyphId, properties, missingGlyphs);
      this.toFontChar = newMapping.toFontChar;
      tables['cmap'] = {
        tag: 'cmap',
        data: createCmapTable(newMapping.charCodeToGlyphId, numGlyphs)
      };
      if (!tables['OS/2'] || !validateOS2Table(tables['OS/2'])) {
        tables['OS/2'] = {
          tag: 'OS/2',
          data: createOS2Table(properties, newMapping.charCodeToGlyphId, metricsOverride)
        };
      }
      if (!tables['post']) {
        tables['post'] = {
          tag: 'post',
          data: createPostTable(properties)
        };
      }
      if (!isTrueType) {
        try {
          cffFile = new _stream.Stream(tables['CFF '].data);
          var parser = new _cff_parser.CFFParser(cffFile, properties, SEAC_ANALYSIS_ENABLED);
          cff = parser.parse();
          var compiler = new _cff_parser.CFFCompiler(cff);
          tables['CFF '].data = compiler.compile();
        } catch (e) {
          (0, _util.warn)('Failed to compile font ' + properties.loadedName);
        }
      }
      if (!tables['name']) {
        tables['name'] = {
          tag: 'name',
          data: createNameTable(this.name)
        };
      } else {
        var namePrototype = readNameTable(tables['name']);
        tables['name'].data = createNameTable(name, namePrototype);
      }
      var builder = new OpenTypeFileBuilder(header.version);
      for (var tableTag in tables) {
        builder.addTable(tableTag, tables[tableTag].data);
      }
      return builder.toArray();
    },
    convert: function Font_convert(fontName, font, properties) {
      properties.fixedPitch = false;
      if (properties.builtInEncoding) {
        adjustToUnicode(properties, properties.builtInEncoding);
      }
      var mapping = font.getGlyphMapping(properties);
      var newMapping = adjustMapping(mapping, properties, Object.create(null));
      this.toFontChar = newMapping.toFontChar;
      var numGlyphs = font.numGlyphs;
      function getCharCodes(charCodeToGlyphId, glyphId) {
        var charCodes = null;
        for (var charCode in charCodeToGlyphId) {
          if (glyphId === charCodeToGlyphId[charCode]) {
            if (!charCodes) {
              charCodes = [];
            }
            charCodes.push(charCode | 0);
          }
        }
        return charCodes;
      }
      function createCharCode(charCodeToGlyphId, glyphId) {
        for (var charCode in charCodeToGlyphId) {
          if (glyphId === charCodeToGlyphId[charCode]) {
            return charCode | 0;
          }
        }
        newMapping.charCodeToGlyphId[newMapping.nextAvailableFontCharCode] = glyphId;
        return newMapping.nextAvailableFontCharCode++;
      }
      var seacs = font.seacs;
      if (SEAC_ANALYSIS_ENABLED && seacs && seacs.length) {
        var matrix = properties.fontMatrix || _util.FONT_IDENTITY_MATRIX;
        var charset = font.getCharset();
        var seacMap = Object.create(null);
        for (var glyphId in seacs) {
          glyphId |= 0;
          var seac = seacs[glyphId];
          var baseGlyphName = _encodings.StandardEncoding[seac[2]];
          var accentGlyphName = _encodings.StandardEncoding[seac[3]];
          var baseGlyphId = charset.indexOf(baseGlyphName);
          var accentGlyphId = charset.indexOf(accentGlyphName);
          if (baseGlyphId < 0 || accentGlyphId < 0) {
            continue;
          }
          var accentOffset = {
            x: seac[0] * matrix[0] + seac[1] * matrix[2] + matrix[4],
            y: seac[0] * matrix[1] + seac[1] * matrix[3] + matrix[5]
          };
          var charCodes = getCharCodes(mapping, glyphId);
          if (!charCodes) {
            continue;
          }
          for (var i = 0, ii = charCodes.length; i < ii; i++) {
            var charCode = charCodes[i];
            var charCodeToGlyphId = newMapping.charCodeToGlyphId;
            var baseFontCharCode = createCharCode(charCodeToGlyphId, baseGlyphId);
            var accentFontCharCode = createCharCode(charCodeToGlyphId, accentGlyphId);
            seacMap[charCode] = {
              baseFontCharCode: baseFontCharCode,
              accentFontCharCode: accentFontCharCode,
              accentOffset: accentOffset
            };
          }
        }
        properties.seacMap = seacMap;
      }
      var unitsPerEm = 1 / (properties.fontMatrix || _util.FONT_IDENTITY_MATRIX)[0];
      var builder = new OpenTypeFileBuilder('\x4F\x54\x54\x4F');
      builder.addTable('CFF ', font.data);
      builder.addTable('OS/2', createOS2Table(properties, newMapping.charCodeToGlyphId));
      builder.addTable('cmap', createCmapTable(newMapping.charCodeToGlyphId, numGlyphs));
      builder.addTable('head', '\x00\x01\x00\x00' + '\x00\x00\x10\x00' + '\x00\x00\x00\x00' + '\x5F\x0F\x3C\xF5' + '\x00\x00' + safeString16(unitsPerEm) + '\x00\x00\x00\x00\x9e\x0b\x7e\x27' + '\x00\x00\x00\x00\x9e\x0b\x7e\x27' + '\x00\x00' + safeString16(properties.descent) + '\x0F\xFF' + safeString16(properties.ascent) + string16(properties.italicAngle ? 2 : 0) + '\x00\x11' + '\x00\x00' + '\x00\x00' + '\x00\x00');
      builder.addTable('hhea', '\x00\x01\x00\x00' + safeString16(properties.ascent) + safeString16(properties.descent) + '\x00\x00' + '\xFF\xFF' + '\x00\x00' + '\x00\x00' + '\x00\x00' + safeString16(properties.capHeight) + safeString16(Math.tan(properties.italicAngle) * properties.xHeight) + '\x00\x00' + '\x00\x00' + '\x00\x00' + '\x00\x00' + '\x00\x00' + '\x00\x00' + string16(numGlyphs));
      builder.addTable('hmtx', function fontFieldsHmtx() {
        var charstrings = font.charstrings;
        var cffWidths = font.cff ? font.cff.widths : null;
        var hmtx = '\x00\x00\x00\x00';
        for (var i = 1, ii = numGlyphs; i < ii; i++) {
          var width = 0;
          if (charstrings) {
            var charstring = charstrings[i - 1];
            width = 'width' in charstring ? charstring.width : 0;
          } else if (cffWidths) {
            width = Math.ceil(cffWidths[i] || 0);
          }
          hmtx += string16(width) + string16(0);
        }
        return hmtx;
      }());
      builder.addTable('maxp', '\x00\x00\x50\x00' + string16(numGlyphs));
      builder.addTable('name', createNameTable(fontName));
      builder.addTable('post', createPostTable(properties));
      return builder.toArray();
    },
    get spaceWidth() {
      if ('_shadowWidth' in this) {
        return this._shadowWidth;
      }
      var possibleSpaceReplacements = ['space', 'minus', 'one', 'i', 'I'];
      var width;
      for (var i = 0, ii = possibleSpaceReplacements.length; i < ii; i++) {
        var glyphName = possibleSpaceReplacements[i];
        if (glyphName in this.widths) {
          width = this.widths[glyphName];
          break;
        }
        var glyphsUnicodeMap = (0, _glyphlist.getGlyphsUnicode)();
        var glyphUnicode = glyphsUnicodeMap[glyphName];
        var charcode = 0;
        if (this.composite) {
          if (this.cMap.contains(glyphUnicode)) {
            charcode = this.cMap.lookup(glyphUnicode);
          }
        }
        if (!charcode && this.toUnicode) {
          charcode = this.toUnicode.charCodeOf(glyphUnicode);
        }
        if (charcode <= 0) {
          charcode = glyphUnicode;
        }
        width = this.widths[charcode];
        if (width) {
          break;
        }
      }
      width = width || this.defaultWidth;
      this._shadowWidth = width;
      return width;
    },
    charToGlyph: function Font_charToGlyph(charcode, isSpace) {
      var fontCharCode, width, operatorListId;
      var widthCode = charcode;
      if (this.cMap && this.cMap.contains(charcode)) {
        widthCode = this.cMap.lookup(charcode);
      }
      width = this.widths[widthCode];
      width = (0, _util.isNum)(width) ? width : this.defaultWidth;
      var vmetric = this.vmetrics && this.vmetrics[widthCode];
      var unicode = this.toUnicode.get(charcode) || charcode;
      if (typeof unicode === 'number') {
        unicode = String.fromCharCode(unicode);
      }
      var isInFont = charcode in this.toFontChar;
      fontCharCode = this.toFontChar[charcode] || charcode;
      if (this.missingFile) {
        fontCharCode = (0, _unicode.mapSpecialUnicodeValues)(fontCharCode);
      }
      if (this.isType3Font) {
        operatorListId = fontCharCode;
      }
      var accent = null;
      if (this.seacMap && this.seacMap[charcode]) {
        isInFont = true;
        var seac = this.seacMap[charcode];
        fontCharCode = seac.baseFontCharCode;
        accent = {
          fontChar: String.fromCharCode(seac.accentFontCharCode),
          offset: seac.accentOffset
        };
      }
      var fontChar = String.fromCharCode(fontCharCode);
      var glyph = this.glyphCache[charcode];
      if (!glyph || !glyph.matchesForCache(fontChar, unicode, accent, width, vmetric, operatorListId, isSpace, isInFont)) {
        glyph = new Glyph(fontChar, unicode, accent, width, vmetric, operatorListId, isSpace, isInFont);
        this.glyphCache[charcode] = glyph;
      }
      return glyph;
    },
    charsToGlyphs: function Font_charsToGlyphs(chars) {
      var charsCache = this.charsCache;
      var glyphs, glyph, charcode;
      if (charsCache) {
        glyphs = charsCache[chars];
        if (glyphs) {
          return glyphs;
        }
      }
      if (!charsCache) {
        charsCache = this.charsCache = Object.create(null);
      }
      glyphs = [];
      var charsCacheKey = chars;
      var i = 0,
          ii;
      if (this.cMap) {
        var c = Object.create(null);
        while (i < chars.length) {
          this.cMap.readCharCode(chars, i, c);
          charcode = c.charcode;
          var length = c.length;
          i += length;
          var isSpace = length === 1 && chars.charCodeAt(i - 1) === 0x20;
          glyph = this.charToGlyph(charcode, isSpace);
          glyphs.push(glyph);
        }
      } else {
        for (i = 0, ii = chars.length; i < ii; ++i) {
          charcode = chars.charCodeAt(i);
          glyph = this.charToGlyph(charcode, charcode === 0x20);
          glyphs.push(glyph);
        }
      }
      return charsCache[charsCacheKey] = glyphs;
    }
  };
  return Font;
}();
var ErrorFont = function ErrorFontClosure() {
  function ErrorFont(error) {
    this.error = error;
    this.loadedName = 'g_font_error';
    this.loading = false;
  }
  ErrorFont.prototype = {
    charsToGlyphs: function ErrorFont_charsToGlyphs() {
      return [];
    },
    exportData: function ErrorFont_exportData() {
      return { error: this.error };
    }
  };
  return ErrorFont;
}();
function type1FontGlyphMapping(properties, builtInEncoding, glyphNames) {
  var charCodeToGlyphId = Object.create(null);
  var glyphId, charCode, baseEncoding;
  var isSymbolicFont = !!(properties.flags & FontFlags.Symbolic);
  if (properties.baseEncodingName) {
    baseEncoding = (0, _encodings.getEncoding)(properties.baseEncodingName);
    for (charCode = 0; charCode < baseEncoding.length; charCode++) {
      glyphId = glyphNames.indexOf(baseEncoding[charCode]);
      if (glyphId >= 0) {
        charCodeToGlyphId[charCode] = glyphId;
      } else {
        charCodeToGlyphId[charCode] = 0;
      }
    }
  } else if (isSymbolicFont) {
    for (charCode in builtInEncoding) {
      charCodeToGlyphId[charCode] = builtInEncoding[charCode];
    }
  } else {
    baseEncoding = _encodings.StandardEncoding;
    for (charCode = 0; charCode < baseEncoding.length; charCode++) {
      glyphId = glyphNames.indexOf(baseEncoding[charCode]);
      if (glyphId >= 0) {
        charCodeToGlyphId[charCode] = glyphId;
      } else {
        charCodeToGlyphId[charCode] = 0;
      }
    }
  }
  var differences = properties.differences,
      glyphsUnicodeMap;
  if (differences) {
    for (charCode in differences) {
      var glyphName = differences[charCode];
      glyphId = glyphNames.indexOf(glyphName);
      if (glyphId === -1) {
        if (!glyphsUnicodeMap) {
          glyphsUnicodeMap = (0, _glyphlist.getGlyphsUnicode)();
        }
        var standardGlyphName = recoverGlyphName(glyphName, glyphsUnicodeMap);
        if (standardGlyphName !== glyphName) {
          glyphId = glyphNames.indexOf(standardGlyphName);
        }
      }
      if (glyphId >= 0) {
        charCodeToGlyphId[charCode] = glyphId;
      } else {
        charCodeToGlyphId[charCode] = 0;
      }
    }
  }
  return charCodeToGlyphId;
}
var Type1Font = function Type1FontClosure() {
  function findBlock(streamBytes, signature, startIndex) {
    var streamBytesLength = streamBytes.length;
    var signatureLength = signature.length;
    var scanLength = streamBytesLength - signatureLength;
    var i = startIndex,
        j,
        found = false;
    while (i < scanLength) {
      j = 0;
      while (j < signatureLength && streamBytes[i + j] === signature[j]) {
        j++;
      }
      if (j >= signatureLength) {
        i += j;
        while (i < streamBytesLength && (0, _util.isSpace)(streamBytes[i])) {
          i++;
        }
        found = true;
        break;
      }
      i++;
    }
    return {
      found: found,
      length: i
    };
  }
  function getHeaderBlock(stream, suggestedLength) {
    var EEXEC_SIGNATURE = [0x65, 0x65, 0x78, 0x65, 0x63];
    var streamStartPos = stream.pos;
    var headerBytes, headerBytesLength, block;
    try {
      headerBytes = stream.getBytes(suggestedLength);
      headerBytesLength = headerBytes.length;
    } catch (ex) {
      if (ex instanceof _util.MissingDataException) {
        throw ex;
      }
    }
    if (headerBytesLength === suggestedLength) {
      block = findBlock(headerBytes, EEXEC_SIGNATURE, suggestedLength - 2 * EEXEC_SIGNATURE.length);
      if (block.found && block.length === suggestedLength) {
        return {
          stream: new _stream.Stream(headerBytes),
          length: suggestedLength
        };
      }
    }
    (0, _util.warn)('Invalid "Length1" property in Type1 font -- trying to recover.');
    stream.pos = streamStartPos;
    var SCAN_BLOCK_LENGTH = 2048;
    var actualLength;
    while (true) {
      var scanBytes = stream.peekBytes(SCAN_BLOCK_LENGTH);
      block = findBlock(scanBytes, EEXEC_SIGNATURE, 0);
      if (block.length === 0) {
        break;
      }
      stream.pos += block.length;
      if (block.found) {
        actualLength = stream.pos - streamStartPos;
        break;
      }
    }
    stream.pos = streamStartPos;
    if (actualLength) {
      return {
        stream: new _stream.Stream(stream.getBytes(actualLength)),
        length: actualLength
      };
    }
    (0, _util.warn)('Unable to recover "Length1" property in Type1 font -- using as is.');
    return {
      stream: new _stream.Stream(stream.getBytes(suggestedLength)),
      length: suggestedLength
    };
  }
  function getEexecBlock(stream, suggestedLength) {
    var eexecBytes = stream.getBytes();
    return {
      stream: new _stream.Stream(eexecBytes),
      length: eexecBytes.length
    };
  }
  function Type1Font(name, file, properties) {
    var PFB_HEADER_SIZE = 6;
    var headerBlockLength = properties.length1;
    var eexecBlockLength = properties.length2;
    var pfbHeader = file.peekBytes(PFB_HEADER_SIZE);
    var pfbHeaderPresent = pfbHeader[0] === 0x80 && pfbHeader[1] === 0x01;
    if (pfbHeaderPresent) {
      file.skip(PFB_HEADER_SIZE);
      headerBlockLength = pfbHeader[5] << 24 | pfbHeader[4] << 16 | pfbHeader[3] << 8 | pfbHeader[2];
    }
    var headerBlock = getHeaderBlock(file, headerBlockLength);
    headerBlockLength = headerBlock.length;
    var headerBlockParser = new _type1_parser.Type1Parser(headerBlock.stream, false, SEAC_ANALYSIS_ENABLED);
    headerBlockParser.extractFontHeader(properties);
    if (pfbHeaderPresent) {
      pfbHeader = file.getBytes(PFB_HEADER_SIZE);
      eexecBlockLength = pfbHeader[5] << 24 | pfbHeader[4] << 16 | pfbHeader[3] << 8 | pfbHeader[2];
    }
    var eexecBlock = getEexecBlock(file, eexecBlockLength);
    eexecBlockLength = eexecBlock.length;
    var eexecBlockParser = new _type1_parser.Type1Parser(eexecBlock.stream, true, SEAC_ANALYSIS_ENABLED);
    var data = eexecBlockParser.extractFontProgram();
    for (var info in data.properties) {
      properties[info] = data.properties[info];
    }
    var charstrings = data.charstrings;
    var type2Charstrings = this.getType2Charstrings(charstrings);
    var subrs = this.getType2Subrs(data.subrs);
    this.charstrings = charstrings;
    this.data = this.wrap(name, type2Charstrings, this.charstrings, subrs, properties);
    this.seacs = this.getSeacs(data.charstrings);
  }
  Type1Font.prototype = {
    get numGlyphs() {
      return this.charstrings.length + 1;
    },
    getCharset: function Type1Font_getCharset() {
      var charset = ['.notdef'];
      var charstrings = this.charstrings;
      for (var glyphId = 0; glyphId < charstrings.length; glyphId++) {
        charset.push(charstrings[glyphId].glyphName);
      }
      return charset;
    },
    getGlyphMapping: function Type1Font_getGlyphMapping(properties) {
      var charstrings = this.charstrings;
      var glyphNames = ['.notdef'],
          glyphId;
      for (glyphId = 0; glyphId < charstrings.length; glyphId++) {
        glyphNames.push(charstrings[glyphId].glyphName);
      }
      var encoding = properties.builtInEncoding;
      if (encoding) {
        var builtInEncoding = Object.create(null);
        for (var charCode in encoding) {
          glyphId = glyphNames.indexOf(encoding[charCode]);
          if (glyphId >= 0) {
            builtInEncoding[charCode] = glyphId;
          }
        }
      }
      return type1FontGlyphMapping(properties, builtInEncoding, glyphNames);
    },
    getSeacs: function Type1Font_getSeacs(charstrings) {
      var i, ii;
      var seacMap = [];
      for (i = 0, ii = charstrings.length; i < ii; i++) {
        var charstring = charstrings[i];
        if (charstring.seac) {
          seacMap[i + 1] = charstring.seac;
        }
      }
      return seacMap;
    },
    getType2Charstrings: function Type1Font_getType2Charstrings(type1Charstrings) {
      var type2Charstrings = [];
      for (var i = 0, ii = type1Charstrings.length; i < ii; i++) {
        type2Charstrings.push(type1Charstrings[i].charstring);
      }
      return type2Charstrings;
    },
    getType2Subrs: function Type1Font_getType2Subrs(type1Subrs) {
      var bias = 0;
      var count = type1Subrs.length;
      if (count < 1133) {
        bias = 107;
      } else if (count < 33769) {
        bias = 1131;
      } else {
        bias = 32768;
      }
      var type2Subrs = [];
      var i;
      for (i = 0; i < bias; i++) {
        type2Subrs.push([0x0B]);
      }
      for (i = 0; i < count; i++) {
        type2Subrs.push(type1Subrs[i]);
      }
      return type2Subrs;
    },
    wrap: function Type1Font_wrap(name, glyphs, charstrings, subrs, properties) {
      var cff = new _cff_parser.CFF();
      cff.header = new _cff_parser.CFFHeader(1, 0, 4, 4);
      cff.names = [name];
      var topDict = new _cff_parser.CFFTopDict();
      topDict.setByName('version', 391);
      topDict.setByName('Notice', 392);
      topDict.setByName('FullName', 393);
      topDict.setByName('FamilyName', 394);
      topDict.setByName('Weight', 395);
      topDict.setByName('Encoding', null);
      topDict.setByName('FontMatrix', properties.fontMatrix);
      topDict.setByName('FontBBox', properties.bbox);
      topDict.setByName('charset', null);
      topDict.setByName('CharStrings', null);
      topDict.setByName('Private', null);
      cff.topDict = topDict;
      var strings = new _cff_parser.CFFStrings();
      strings.add('Version 0.11');
      strings.add('See original notice');
      strings.add(name);
      strings.add(name);
      strings.add('Medium');
      cff.strings = strings;
      cff.globalSubrIndex = new _cff_parser.CFFIndex();
      var count = glyphs.length;
      var charsetArray = [0];
      var i, ii;
      for (i = 0; i < count; i++) {
        var index = _cff_parser.CFFStandardStrings.indexOf(charstrings[i].glyphName);
        if (index === -1) {
          index = 0;
        }
        charsetArray.push(index >> 8 & 0xff, index & 0xff);
      }
      cff.charset = new _cff_parser.CFFCharset(false, 0, [], charsetArray);
      var charStringsIndex = new _cff_parser.CFFIndex();
      charStringsIndex.add([0x8B, 0x0E]);
      for (i = 0; i < count; i++) {
        var glyph = glyphs[i];
        if (glyph.length === 0) {
          charStringsIndex.add([0x8B, 0x0E]);
          continue;
        }
        charStringsIndex.add(glyph);
      }
      cff.charStrings = charStringsIndex;
      var privateDict = new _cff_parser.CFFPrivateDict();
      privateDict.setByName('Subrs', null);
      var fields = ['BlueValues', 'OtherBlues', 'FamilyBlues', 'FamilyOtherBlues', 'StemSnapH', 'StemSnapV', 'BlueShift', 'BlueFuzz', 'BlueScale', 'LanguageGroup', 'ExpansionFactor', 'ForceBold', 'StdHW', 'StdVW'];
      for (i = 0, ii = fields.length; i < ii; i++) {
        var field = fields[i];
        if (!(field in properties.privateData)) {
          continue;
        }
        var value = properties.privateData[field];
        if ((0, _util.isArray)(value)) {
          for (var j = value.length - 1; j > 0; j--) {
            value[j] -= value[j - 1];
          }
        }
        privateDict.setByName(field, value);
      }
      cff.topDict.privateDict = privateDict;
      var subrIndex = new _cff_parser.CFFIndex();
      for (i = 0, ii = subrs.length; i < ii; i++) {
        subrIndex.add(subrs[i]);
      }
      privateDict.subrsIndex = subrIndex;
      var compiler = new _cff_parser.CFFCompiler(cff);
      return compiler.compile();
    }
  };
  return Type1Font;
}();
var CFFFont = function CFFFontClosure() {
  function CFFFont(file, properties) {
    this.properties = properties;
    var parser = new _cff_parser.CFFParser(file, properties, SEAC_ANALYSIS_ENABLED);
    this.cff = parser.parse();
    var compiler = new _cff_parser.CFFCompiler(this.cff);
    this.seacs = this.cff.seacs;
    try {
      this.data = compiler.compile();
    } catch (e) {
      (0, _util.warn)('Failed to compile font ' + properties.loadedName);
      this.data = file;
    }
  }
  CFFFont.prototype = {
    get numGlyphs() {
      return this.cff.charStrings.count;
    },
    getCharset: function CFFFont_getCharset() {
      return this.cff.charset.charset;
    },
    getGlyphMapping: function CFFFont_getGlyphMapping() {
      var cff = this.cff;
      var properties = this.properties;
      var charsets = cff.charset.charset;
      var charCodeToGlyphId;
      var glyphId;
      if (properties.composite) {
        charCodeToGlyphId = Object.create(null);
        if (cff.isCIDFont) {
          for (glyphId = 0; glyphId < charsets.length; glyphId++) {
            var cid = charsets[glyphId];
            var charCode = properties.cMap.charCodeOf(cid);
            charCodeToGlyphId[charCode] = glyphId;
          }
        } else {
          for (glyphId = 0; glyphId < cff.charStrings.count; glyphId++) {
            charCodeToGlyphId[glyphId] = glyphId;
          }
        }
        return charCodeToGlyphId;
      }
      var encoding = cff.encoding ? cff.encoding.encoding : null;
      charCodeToGlyphId = type1FontGlyphMapping(properties, encoding, charsets);
      return charCodeToGlyphId;
    }
  };
  return CFFFont;
}();
(function checkSeacSupport() {
  if (typeof navigator !== 'undefined' && /Windows/.test(navigator.userAgent)) {
    exports.SEAC_ANALYSIS_ENABLED = SEAC_ANALYSIS_ENABLED = true;
  }
})();
(function checkChromeWindows() {
  if (typeof navigator !== 'undefined' && /Windows.*Chrome/.test(navigator.userAgent)) {
    SKIP_PRIVATE_USE_RANGE_F000_TO_F01F = true;
  }
})();
exports.SEAC_ANALYSIS_ENABLED = SEAC_ANALYSIS_ENABLED;
exports.PRIVATE_USE_OFFSET_START = PRIVATE_USE_OFFSET_START;
exports.PRIVATE_USE_OFFSET_END = PRIVATE_USE_OFFSET_END;
exports.ErrorFont = ErrorFont;
exports.Font = Font;
exports.FontFlags = FontFlags;
exports.ToUnicodeMap = ToUnicodeMap;
exports.IdentityToUnicodeMap = IdentityToUnicodeMap;
exports.ProblematicCharRanges = ProblematicCharRanges;
exports.getFontType = getFontType;

/***/ }),
/* 26 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PDFImage = undefined;

var _util = __w_pdfjs_require__(0);

var _stream = __w_pdfjs_require__(2);

var _primitives = __w_pdfjs_require__(1);

var _colorspace = __w_pdfjs_require__(3);

var _jpx = __w_pdfjs_require__(13);

var PDFImage = function PDFImageClosure() {
  function handleImageData(image, nativeDecoder) {
    if (nativeDecoder && nativeDecoder.canDecode(image)) {
      return nativeDecoder.decode(image);
    }
    return Promise.resolve(image);
  }
  function decodeAndClamp(value, addend, coefficient, max) {
    value = addend + value * coefficient;
    return value < 0 ? 0 : value > max ? max : value;
  }
  function resizeImageMask(src, bpc, w1, h1, w2, h2) {
    var length = w2 * h2;
    var dest = bpc <= 8 ? new Uint8Array(length) : bpc <= 16 ? new Uint16Array(length) : new Uint32Array(length);
    var xRatio = w1 / w2;
    var yRatio = h1 / h2;
    var i,
        j,
        py,
        newIndex = 0,
        oldIndex;
    var xScaled = new Uint16Array(w2);
    var w1Scanline = w1;
    for (i = 0; i < w2; i++) {
      xScaled[i] = Math.floor(i * xRatio);
    }
    for (i = 0; i < h2; i++) {
      py = Math.floor(i * yRatio) * w1Scanline;
      for (j = 0; j < w2; j++) {
        oldIndex = py + xScaled[j];
        dest[newIndex++] = src[oldIndex];
      }
    }
    return dest;
  }
  function PDFImage(xref, res, image, inline, smask, mask, isMask) {
    this.image = image;
    var dict = image.dict;
    if (dict.has('Filter')) {
      var filter = dict.get('Filter').name;
      if (filter === 'JPXDecode') {
        var jpxImage = new _jpx.JpxImage();
        jpxImage.parseImageProperties(image.stream);
        image.stream.reset();
        image.bitsPerComponent = jpxImage.bitsPerComponent;
        image.numComps = jpxImage.componentsCount;
      } else if (filter === 'JBIG2Decode') {
        image.bitsPerComponent = 1;
        image.numComps = 1;
      }
    }
    this.width = dict.get('Width', 'W');
    this.height = dict.get('Height', 'H');
    if (this.width < 1 || this.height < 1) {
      throw new _util.FormatError('Invalid image width: ' + this.width + ' or ' + ('height: ' + this.height));
    }
    this.interpolate = dict.get('Interpolate', 'I') || false;
    this.imageMask = dict.get('ImageMask', 'IM') || false;
    this.matte = dict.get('Matte') || false;
    var bitsPerComponent = image.bitsPerComponent;
    if (!bitsPerComponent) {
      bitsPerComponent = dict.get('BitsPerComponent', 'BPC');
      if (!bitsPerComponent) {
        if (this.imageMask) {
          bitsPerComponent = 1;
        } else {
          throw new _util.FormatError('Bits per component missing in image: ' + this.imageMask);
        }
      }
    }
    this.bpc = bitsPerComponent;
    if (!this.imageMask) {
      var colorSpace = dict.get('ColorSpace', 'CS');
      if (!colorSpace) {
        (0, _util.info)('JPX images (which do not require color spaces)');
        switch (image.numComps) {
          case 1:
            colorSpace = _primitives.Name.get('DeviceGray');
            break;
          case 3:
            colorSpace = _primitives.Name.get('DeviceRGB');
            break;
          case 4:
            colorSpace = _primitives.Name.get('DeviceCMYK');
            break;
          default:
            throw new Error('JPX images with ' + this.numComps + ' ' + 'color components not supported.');
        }
      }
      this.colorSpace = _colorspace.ColorSpace.parse(colorSpace, xref, res);
      this.numComps = this.colorSpace.numComps;
    }
    this.decode = dict.getArray('Decode', 'D');
    this.needsDecode = false;
    if (this.decode && (this.colorSpace && !this.colorSpace.isDefaultDecode(this.decode) || isMask && !_colorspace.ColorSpace.isDefaultDecode(this.decode, 1))) {
      this.needsDecode = true;
      var max = (1 << bitsPerComponent) - 1;
      this.decodeCoefficients = [];
      this.decodeAddends = [];
      for (var i = 0, j = 0; i < this.decode.length; i += 2, ++j) {
        var dmin = this.decode[i];
        var dmax = this.decode[i + 1];
        this.decodeCoefficients[j] = dmax - dmin;
        this.decodeAddends[j] = max * dmin;
      }
    }
    if (smask) {
      this.smask = new PDFImage(xref, res, smask, false);
    } else if (mask) {
      if ((0, _primitives.isStream)(mask)) {
        var maskDict = mask.dict,
            imageMask = maskDict.get('ImageMask', 'IM');
        if (!imageMask) {
          (0, _util.warn)('Ignoring /Mask in image without /ImageMask.');
        } else {
          this.mask = new PDFImage(xref, res, mask, false, null, null, true);
        }
      } else {
        this.mask = mask;
      }
    }
  }
  PDFImage.buildImage = function PDFImage_buildImage(handler, xref, res, image, inline, nativeDecoder) {
    var imagePromise = handleImageData(image, nativeDecoder);
    var smaskPromise;
    var maskPromise;
    var smask = image.dict.get('SMask');
    var mask = image.dict.get('Mask');
    if (smask) {
      smaskPromise = handleImageData(smask, nativeDecoder);
      maskPromise = Promise.resolve(null);
    } else {
      smaskPromise = Promise.resolve(null);
      if (mask) {
        if ((0, _primitives.isStream)(mask)) {
          maskPromise = handleImageData(mask, nativeDecoder);
        } else if ((0, _util.isArray)(mask)) {
          maskPromise = Promise.resolve(mask);
        } else {
          (0, _util.warn)('Unsupported mask format.');
          maskPromise = Promise.resolve(null);
        }
      } else {
        maskPromise = Promise.resolve(null);
      }
    }
    return Promise.all([imagePromise, smaskPromise, maskPromise]).then(function (results) {
      var imageData = results[0];
      var smaskData = results[1];
      var maskData = results[2];
      return new PDFImage(xref, res, imageData, inline, smaskData, maskData);
    });
  };
  PDFImage.createMask = function PDFImage_createMask(imgArray, width, height, imageIsFromDecodeStream, inverseDecode) {
    var computedLength = (width + 7 >> 3) * height;
    var actualLength = imgArray.byteLength;
    var haveFullData = computedLength === actualLength;
    var data, i;
    if (imageIsFromDecodeStream && (!inverseDecode || haveFullData)) {
      data = imgArray;
    } else if (!inverseDecode) {
      data = new Uint8Array(actualLength);
      data.set(imgArray);
    } else {
      data = new Uint8Array(computedLength);
      data.set(imgArray);
      for (i = actualLength; i < computedLength; i++) {
        data[i] = 0xff;
      }
    }
    if (inverseDecode) {
      for (i = 0; i < actualLength; i++) {
        data[i] = ~data[i];
      }
    }
    return {
      data: data,
      width: width,
      height: height
    };
  };
  PDFImage.prototype = {
    get drawWidth() {
      return Math.max(this.width, this.smask && this.smask.width || 0, this.mask && this.mask.width || 0);
    },
    get drawHeight() {
      return Math.max(this.height, this.smask && this.smask.height || 0, this.mask && this.mask.height || 0);
    },
    decodeBuffer: function PDFImage_decodeBuffer(buffer) {
      var bpc = this.bpc;
      var numComps = this.numComps;
      var decodeAddends = this.decodeAddends;
      var decodeCoefficients = this.decodeCoefficients;
      var max = (1 << bpc) - 1;
      var i, ii;
      if (bpc === 1) {
        for (i = 0, ii = buffer.length; i < ii; i++) {
          buffer[i] = +!buffer[i];
        }
        return;
      }
      var index = 0;
      for (i = 0, ii = this.width * this.height; i < ii; i++) {
        for (var j = 0; j < numComps; j++) {
          buffer[index] = decodeAndClamp(buffer[index], decodeAddends[j], decodeCoefficients[j], max);
          index++;
        }
      }
    },
    getComponents: function PDFImage_getComponents(buffer) {
      var bpc = this.bpc;
      if (bpc === 8) {
        return buffer;
      }
      var width = this.width;
      var height = this.height;
      var numComps = this.numComps;
      var length = width * height * numComps;
      var bufferPos = 0;
      var output = bpc <= 8 ? new Uint8Array(length) : bpc <= 16 ? new Uint16Array(length) : new Uint32Array(length);
      var rowComps = width * numComps;
      var max = (1 << bpc) - 1;
      var i = 0,
          ii,
          buf;
      if (bpc === 1) {
        var mask, loop1End, loop2End;
        for (var j = 0; j < height; j++) {
          loop1End = i + (rowComps & ~7);
          loop2End = i + rowComps;
          while (i < loop1End) {
            buf = buffer[bufferPos++];
            output[i] = buf >> 7 & 1;
            output[i + 1] = buf >> 6 & 1;
            output[i + 2] = buf >> 5 & 1;
            output[i + 3] = buf >> 4 & 1;
            output[i + 4] = buf >> 3 & 1;
            output[i + 5] = buf >> 2 & 1;
            output[i + 6] = buf >> 1 & 1;
            output[i + 7] = buf & 1;
            i += 8;
          }
          if (i < loop2End) {
            buf = buffer[bufferPos++];
            mask = 128;
            while (i < loop2End) {
              output[i++] = +!!(buf & mask);
              mask >>= 1;
            }
          }
        }
      } else {
        var bits = 0;
        buf = 0;
        for (i = 0, ii = length; i < ii; ++i) {
          if (i % rowComps === 0) {
            buf = 0;
            bits = 0;
          }
          while (bits < bpc) {
            buf = buf << 8 | buffer[bufferPos++];
            bits += 8;
          }
          var remainingBits = bits - bpc;
          var value = buf >> remainingBits;
          output[i] = value < 0 ? 0 : value > max ? max : value;
          buf = buf & (1 << remainingBits) - 1;
          bits = remainingBits;
        }
      }
      return output;
    },
    fillOpacity: function PDFImage_fillOpacity(rgbaBuf, width, height, actualHeight, image) {
      var smask = this.smask;
      var mask = this.mask;
      var alphaBuf, sw, sh, i, ii, j;
      if (smask) {
        sw = smask.width;
        sh = smask.height;
        alphaBuf = new Uint8Array(sw * sh);
        smask.fillGrayBuffer(alphaBuf);
        if (sw !== width || sh !== height) {
          alphaBuf = resizeImageMask(alphaBuf, smask.bpc, sw, sh, width, height);
        }
      } else if (mask) {
        if (mask instanceof PDFImage) {
          sw = mask.width;
          sh = mask.height;
          alphaBuf = new Uint8Array(sw * sh);
          mask.numComps = 1;
          mask.fillGrayBuffer(alphaBuf);
          for (i = 0, ii = sw * sh; i < ii; ++i) {
            alphaBuf[i] = 255 - alphaBuf[i];
          }
          if (sw !== width || sh !== height) {
            alphaBuf = resizeImageMask(alphaBuf, mask.bpc, sw, sh, width, height);
          }
        } else if ((0, _util.isArray)(mask)) {
          alphaBuf = new Uint8Array(width * height);
          var numComps = this.numComps;
          for (i = 0, ii = width * height; i < ii; ++i) {
            var opacity = 0;
            var imageOffset = i * numComps;
            for (j = 0; j < numComps; ++j) {
              var color = image[imageOffset + j];
              var maskOffset = j * 2;
              if (color < mask[maskOffset] || color > mask[maskOffset + 1]) {
                opacity = 255;
                break;
              }
            }
            alphaBuf[i] = opacity;
          }
        } else {
          throw new _util.FormatError('Unknown mask format.');
        }
      }
      if (alphaBuf) {
        for (i = 0, j = 3, ii = width * actualHeight; i < ii; ++i, j += 4) {
          rgbaBuf[j] = alphaBuf[i];
        }
      } else {
        for (i = 0, j = 3, ii = width * actualHeight; i < ii; ++i, j += 4) {
          rgbaBuf[j] = 255;
        }
      }
    },
    undoPreblend: function PDFImage_undoPreblend(buffer, width, height) {
      var matte = this.smask && this.smask.matte;
      if (!matte) {
        return;
      }
      var matteRgb = this.colorSpace.getRgb(matte, 0);
      var matteR = matteRgb[0];
      var matteG = matteRgb[1];
      var matteB = matteRgb[2];
      var length = width * height * 4;
      var r, g, b;
      for (var i = 0; i < length; i += 4) {
        var alpha = buffer[i + 3];
        if (alpha === 0) {
          buffer[i] = 255;
          buffer[i + 1] = 255;
          buffer[i + 2] = 255;
          continue;
        }
        var k = 255 / alpha;
        r = (buffer[i] - matteR) * k + matteR;
        g = (buffer[i + 1] - matteG) * k + matteG;
        b = (buffer[i + 2] - matteB) * k + matteB;
        buffer[i] = r <= 0 ? 0 : r >= 255 ? 255 : r | 0;
        buffer[i + 1] = g <= 0 ? 0 : g >= 255 ? 255 : g | 0;
        buffer[i + 2] = b <= 0 ? 0 : b >= 255 ? 255 : b | 0;
      }
    },
    createImageData: function PDFImage_createImageData(forceRGBA) {
      var drawWidth = this.drawWidth;
      var drawHeight = this.drawHeight;
      var imgData = {
        width: drawWidth,
        height: drawHeight
      };
      var numComps = this.numComps;
      var originalWidth = this.width;
      var originalHeight = this.height;
      var bpc = this.bpc;
      var rowBytes = originalWidth * numComps * bpc + 7 >> 3;
      var imgArray;
      if (!forceRGBA) {
        var kind;
        if (this.colorSpace.name === 'DeviceGray' && bpc === 1) {
          kind = _util.ImageKind.GRAYSCALE_1BPP;
        } else if (this.colorSpace.name === 'DeviceRGB' && bpc === 8 && !this.needsDecode) {
          kind = _util.ImageKind.RGB_24BPP;
        }
        if (kind && !this.smask && !this.mask && drawWidth === originalWidth && drawHeight === originalHeight) {
          imgData.kind = kind;
          imgArray = this.getImageBytes(originalHeight * rowBytes);
          if (this.image instanceof _stream.DecodeStream) {
            imgData.data = imgArray;
          } else {
            var newArray = new Uint8Array(imgArray.length);
            newArray.set(imgArray);
            imgData.data = newArray;
          }
          if (this.needsDecode) {
            (0, _util.assert)(kind === _util.ImageKind.GRAYSCALE_1BPP);
            var buffer = imgData.data;
            for (var i = 0, ii = buffer.length; i < ii; i++) {
              buffer[i] ^= 0xff;
            }
          }
          return imgData;
        }
        if (this.image instanceof _stream.JpegStream && !this.smask && !this.mask && (this.colorSpace.name === 'DeviceGray' || this.colorSpace.name === 'DeviceRGB' || this.colorSpace.name === 'DeviceCMYK')) {
          imgData.kind = _util.ImageKind.RGB_24BPP;
          imgData.data = this.getImageBytes(originalHeight * rowBytes, drawWidth, drawHeight, true);
          return imgData;
        }
      }
      imgArray = this.getImageBytes(originalHeight * rowBytes);
      var actualHeight = 0 | imgArray.length / rowBytes * drawHeight / originalHeight;
      var comps = this.getComponents(imgArray);
      var alpha01, maybeUndoPreblend;
      if (!forceRGBA && !this.smask && !this.mask) {
        imgData.kind = _util.ImageKind.RGB_24BPP;
        imgData.data = new Uint8Array(drawWidth * drawHeight * 3);
        alpha01 = 0;
        maybeUndoPreblend = false;
      } else {
        imgData.kind = _util.ImageKind.RGBA_32BPP;
        imgData.data = new Uint8Array(drawWidth * drawHeight * 4);
        alpha01 = 1;
        maybeUndoPreblend = true;
        this.fillOpacity(imgData.data, drawWidth, drawHeight, actualHeight, comps);
      }
      if (this.needsDecode) {
        this.decodeBuffer(comps);
      }
      this.colorSpace.fillRgb(imgData.data, originalWidth, originalHeight, drawWidth, drawHeight, actualHeight, bpc, comps, alpha01);
      if (maybeUndoPreblend) {
        this.undoPreblend(imgData.data, drawWidth, actualHeight);
      }
      return imgData;
    },
    fillGrayBuffer: function PDFImage_fillGrayBuffer(buffer) {
      var numComps = this.numComps;
      if (numComps !== 1) {
        throw new _util.FormatError('Reading gray scale from a color image: ' + numComps);
      }
      var width = this.width;
      var height = this.height;
      var bpc = this.bpc;
      var rowBytes = width * numComps * bpc + 7 >> 3;
      var imgArray = this.getImageBytes(height * rowBytes);
      var comps = this.getComponents(imgArray);
      var i, length;
      if (bpc === 1) {
        length = width * height;
        if (this.needsDecode) {
          for (i = 0; i < length; ++i) {
            buffer[i] = comps[i] - 1 & 255;
          }
        } else {
          for (i = 0; i < length; ++i) {
            buffer[i] = -comps[i] & 255;
          }
        }
        return;
      }
      if (this.needsDecode) {
        this.decodeBuffer(comps);
      }
      length = width * height;
      var scale = 255 / ((1 << bpc) - 1);
      for (i = 0; i < length; ++i) {
        buffer[i] = scale * comps[i] | 0;
      }
    },
    getImageBytes: function PDFImage_getImageBytes(length, drawWidth, drawHeight, forceRGB) {
      this.image.reset();
      this.image.drawWidth = drawWidth || this.width;
      this.image.drawHeight = drawHeight || this.height;
      this.image.forceRGB = !!forceRGB;
      return this.image.getBytes(length);
    }
  };
  return PDFImage;
}();
exports.PDFImage = PDFImage;

/***/ }),
/* 27 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Jbig2Image = undefined;

var _util = __w_pdfjs_require__(0);

var _arithmetic_decoder = __w_pdfjs_require__(8);

var Jbig2Error = function Jbig2ErrorClosure() {
  function Jbig2Error(msg) {
    this.message = 'JBIG2 error: ' + msg;
  }
  Jbig2Error.prototype = new Error();
  Jbig2Error.prototype.name = 'Jbig2Error';
  Jbig2Error.constructor = Jbig2Error;
  return Jbig2Error;
}();
var Jbig2Image = function Jbig2ImageClosure() {
  function ContextCache() {}
  ContextCache.prototype = {
    getContexts: function getContexts(id) {
      if (id in this) {
        return this[id];
      }
      return this[id] = new Int8Array(1 << 16);
    }
  };
  function DecodingContext(data, start, end) {
    this.data = data;
    this.start = start;
    this.end = end;
  }
  DecodingContext.prototype = {
    get decoder() {
      var decoder = new _arithmetic_decoder.ArithmeticDecoder(this.data, this.start, this.end);
      return (0, _util.shadow)(this, 'decoder', decoder);
    },
    get contextCache() {
      var cache = new ContextCache();
      return (0, _util.shadow)(this, 'contextCache', cache);
    }
  };
  function decodeInteger(contextCache, procedure, decoder) {
    var contexts = contextCache.getContexts(procedure);
    var prev = 1;
    function readBits(length) {
      var v = 0;
      for (var i = 0; i < length; i++) {
        var bit = decoder.readBit(contexts, prev);
        prev = prev < 256 ? prev << 1 | bit : (prev << 1 | bit) & 511 | 256;
        v = v << 1 | bit;
      }
      return v >>> 0;
    }
    var sign = readBits(1);
    var value = readBits(1) ? readBits(1) ? readBits(1) ? readBits(1) ? readBits(1) ? readBits(32) + 4436 : readBits(12) + 340 : readBits(8) + 84 : readBits(6) + 20 : readBits(4) + 4 : readBits(2);
    return sign === 0 ? value : value > 0 ? -value : null;
  }
  function decodeIAID(contextCache, decoder, codeLength) {
    var contexts = contextCache.getContexts('IAID');
    var prev = 1;
    for (var i = 0; i < codeLength; i++) {
      var bit = decoder.readBit(contexts, prev);
      prev = prev << 1 | bit;
    }
    if (codeLength < 31) {
      return prev & (1 << codeLength) - 1;
    }
    return prev & 0x7FFFFFFF;
  }
  var SegmentTypes = ['SymbolDictionary', null, null, null, 'IntermediateTextRegion', null, 'ImmediateTextRegion', 'ImmediateLosslessTextRegion', null, null, null, null, null, null, null, null, 'patternDictionary', null, null, null, 'IntermediateHalftoneRegion', null, 'ImmediateHalftoneRegion', 'ImmediateLosslessHalftoneRegion', null, null, null, null, null, null, null, null, null, null, null, null, 'IntermediateGenericRegion', null, 'ImmediateGenericRegion', 'ImmediateLosslessGenericRegion', 'IntermediateGenericRefinementRegion', null, 'ImmediateGenericRefinementRegion', 'ImmediateLosslessGenericRefinementRegion', null, null, null, null, 'PageInformation', 'EndOfPage', 'EndOfStripe', 'EndOfFile', 'Profiles', 'Tables', null, null, null, null, null, null, null, null, 'Extension'];
  var CodingTemplates = [[{
    x: -1,
    y: -2
  }, {
    x: 0,
    y: -2
  }, {
    x: 1,
    y: -2
  }, {
    x: -2,
    y: -1
  }, {
    x: -1,
    y: -1
  }, {
    x: 0,
    y: -1
  }, {
    x: 1,
    y: -1
  }, {
    x: 2,
    y: -1
  }, {
    x: -4,
    y: 0
  }, {
    x: -3,
    y: 0
  }, {
    x: -2,
    y: 0
  }, {
    x: -1,
    y: 0
  }], [{
    x: -1,
    y: -2
  }, {
    x: 0,
    y: -2
  }, {
    x: 1,
    y: -2
  }, {
    x: 2,
    y: -2
  }, {
    x: -2,
    y: -1
  }, {
    x: -1,
    y: -1
  }, {
    x: 0,
    y: -1
  }, {
    x: 1,
    y: -1
  }, {
    x: 2,
    y: -1
  }, {
    x: -3,
    y: 0
  }, {
    x: -2,
    y: 0
  }, {
    x: -1,
    y: 0
  }], [{
    x: -1,
    y: -2
  }, {
    x: 0,
    y: -2
  }, {
    x: 1,
    y: -2
  }, {
    x: -2,
    y: -1
  }, {
    x: -1,
    y: -1
  }, {
    x: 0,
    y: -1
  }, {
    x: 1,
    y: -1
  }, {
    x: -2,
    y: 0
  }, {
    x: -1,
    y: 0
  }], [{
    x: -3,
    y: -1
  }, {
    x: -2,
    y: -1
  }, {
    x: -1,
    y: -1
  }, {
    x: 0,
    y: -1
  }, {
    x: 1,
    y: -1
  }, {
    x: -4,
    y: 0
  }, {
    x: -3,
    y: 0
  }, {
    x: -2,
    y: 0
  }, {
    x: -1,
    y: 0
  }]];
  var RefinementTemplates = [{
    coding: [{
      x: 0,
      y: -1
    }, {
      x: 1,
      y: -1
    }, {
      x: -1,
      y: 0
    }],
    reference: [{
      x: 0,
      y: -1
    }, {
      x: 1,
      y: -1
    }, {
      x: -1,
      y: 0
    }, {
      x: 0,
      y: 0
    }, {
      x: 1,
      y: 0
    }, {
      x: -1,
      y: 1
    }, {
      x: 0,
      y: 1
    }, {
      x: 1,
      y: 1
    }]
  }, {
    coding: [{
      x: -1,
      y: -1
    }, {
      x: 0,
      y: -1
    }, {
      x: 1,
      y: -1
    }, {
      x: -1,
      y: 0
    }],
    reference: [{
      x: 0,
      y: -1
    }, {
      x: -1,
      y: 0
    }, {
      x: 0,
      y: 0
    }, {
      x: 1,
      y: 0
    }, {
      x: 0,
      y: 1
    }, {
      x: 1,
      y: 1
    }]
  }];
  var ReusedContexts = [0x9B25, 0x0795, 0x00E5, 0x0195];
  var RefinementReusedContexts = [0x0020, 0x0008];
  function decodeBitmapTemplate0(width, height, decodingContext) {
    var decoder = decodingContext.decoder;
    var contexts = decodingContext.contextCache.getContexts('GB');
    var contextLabel,
        i,
        j,
        pixel,
        row,
        row1,
        row2,
        bitmap = [];
    var OLD_PIXEL_MASK = 0x7BF7;
    for (i = 0; i < height; i++) {
      row = bitmap[i] = new Uint8Array(width);
      row1 = i < 1 ? row : bitmap[i - 1];
      row2 = i < 2 ? row : bitmap[i - 2];
      contextLabel = row2[0] << 13 | row2[1] << 12 | row2[2] << 11 | row1[0] << 7 | row1[1] << 6 | row1[2] << 5 | row1[3] << 4;
      for (j = 0; j < width; j++) {
        row[j] = pixel = decoder.readBit(contexts, contextLabel);
        contextLabel = (contextLabel & OLD_PIXEL_MASK) << 1 | (j + 3 < width ? row2[j + 3] << 11 : 0) | (j + 4 < width ? row1[j + 4] << 4 : 0) | pixel;
      }
    }
    return bitmap;
  }
  function decodeBitmap(mmr, width, height, templateIndex, prediction, skip, at, decodingContext) {
    if (mmr) {
      throw new Jbig2Error('MMR encoding is not supported');
    }
    if (templateIndex === 0 && !skip && !prediction && at.length === 4 && at[0].x === 3 && at[0].y === -1 && at[1].x === -3 && at[1].y === -1 && at[2].x === 2 && at[2].y === -2 && at[3].x === -2 && at[3].y === -2) {
      return decodeBitmapTemplate0(width, height, decodingContext);
    }
    var useskip = !!skip;
    var template = CodingTemplates[templateIndex].concat(at);
    template.sort(function (a, b) {
      return a.y - b.y || a.x - b.x;
    });
    var templateLength = template.length;
    var templateX = new Int8Array(templateLength);
    var templateY = new Int8Array(templateLength);
    var changingTemplateEntries = [];
    var reuseMask = 0,
        minX = 0,
        maxX = 0,
        minY = 0;
    var c, k;
    for (k = 0; k < templateLength; k++) {
      templateX[k] = template[k].x;
      templateY[k] = template[k].y;
      minX = Math.min(minX, template[k].x);
      maxX = Math.max(maxX, template[k].x);
      minY = Math.min(minY, template[k].y);
      if (k < templateLength - 1 && template[k].y === template[k + 1].y && template[k].x === template[k + 1].x - 1) {
        reuseMask |= 1 << templateLength - 1 - k;
      } else {
        changingTemplateEntries.push(k);
      }
    }
    var changingEntriesLength = changingTemplateEntries.length;
    var changingTemplateX = new Int8Array(changingEntriesLength);
    var changingTemplateY = new Int8Array(changingEntriesLength);
    var changingTemplateBit = new Uint16Array(changingEntriesLength);
    for (c = 0; c < changingEntriesLength; c++) {
      k = changingTemplateEntries[c];
      changingTemplateX[c] = template[k].x;
      changingTemplateY[c] = template[k].y;
      changingTemplateBit[c] = 1 << templateLength - 1 - k;
    }
    var sbb_left = -minX;
    var sbb_top = -minY;
    var sbb_right = width - maxX;
    var pseudoPixelContext = ReusedContexts[templateIndex];
    var row = new Uint8Array(width);
    var bitmap = [];
    var decoder = decodingContext.decoder;
    var contexts = decodingContext.contextCache.getContexts('GB');
    var ltp = 0,
        j,
        i0,
        j0,
        contextLabel = 0,
        bit,
        shift;
    for (var i = 0; i < height; i++) {
      if (prediction) {
        var sltp = decoder.readBit(contexts, pseudoPixelContext);
        ltp ^= sltp;
        if (ltp) {
          bitmap.push(row);
          continue;
        }
      }
      row = new Uint8Array(row);
      bitmap.push(row);
      for (j = 0; j < width; j++) {
        if (useskip && skip[i][j]) {
          row[j] = 0;
          continue;
        }
        if (j >= sbb_left && j < sbb_right && i >= sbb_top) {
          contextLabel = contextLabel << 1 & reuseMask;
          for (k = 0; k < changingEntriesLength; k++) {
            i0 = i + changingTemplateY[k];
            j0 = j + changingTemplateX[k];
            bit = bitmap[i0][j0];
            if (bit) {
              bit = changingTemplateBit[k];
              contextLabel |= bit;
            }
          }
        } else {
          contextLabel = 0;
          shift = templateLength - 1;
          for (k = 0; k < templateLength; k++, shift--) {
            j0 = j + templateX[k];
            if (j0 >= 0 && j0 < width) {
              i0 = i + templateY[k];
              if (i0 >= 0) {
                bit = bitmap[i0][j0];
                if (bit) {
                  contextLabel |= bit << shift;
                }
              }
            }
          }
        }
        var pixel = decoder.readBit(contexts, contextLabel);
        row[j] = pixel;
      }
    }
    return bitmap;
  }
  function decodeRefinement(width, height, templateIndex, referenceBitmap, offsetX, offsetY, prediction, at, decodingContext) {
    var codingTemplate = RefinementTemplates[templateIndex].coding;
    if (templateIndex === 0) {
      codingTemplate = codingTemplate.concat([at[0]]);
    }
    var codingTemplateLength = codingTemplate.length;
    var codingTemplateX = new Int32Array(codingTemplateLength);
    var codingTemplateY = new Int32Array(codingTemplateLength);
    var k;
    for (k = 0; k < codingTemplateLength; k++) {
      codingTemplateX[k] = codingTemplate[k].x;
      codingTemplateY[k] = codingTemplate[k].y;
    }
    var referenceTemplate = RefinementTemplates[templateIndex].reference;
    if (templateIndex === 0) {
      referenceTemplate = referenceTemplate.concat([at[1]]);
    }
    var referenceTemplateLength = referenceTemplate.length;
    var referenceTemplateX = new Int32Array(referenceTemplateLength);
    var referenceTemplateY = new Int32Array(referenceTemplateLength);
    for (k = 0; k < referenceTemplateLength; k++) {
      referenceTemplateX[k] = referenceTemplate[k].x;
      referenceTemplateY[k] = referenceTemplate[k].y;
    }
    var referenceWidth = referenceBitmap[0].length;
    var referenceHeight = referenceBitmap.length;
    var pseudoPixelContext = RefinementReusedContexts[templateIndex];
    var bitmap = [];
    var decoder = decodingContext.decoder;
    var contexts = decodingContext.contextCache.getContexts('GR');
    var ltp = 0;
    for (var i = 0; i < height; i++) {
      if (prediction) {
        var sltp = decoder.readBit(contexts, pseudoPixelContext);
        ltp ^= sltp;
        if (ltp) {
          throw new Jbig2Error('prediction is not supported');
        }
      }
      var row = new Uint8Array(width);
      bitmap.push(row);
      for (var j = 0; j < width; j++) {
        var i0, j0;
        var contextLabel = 0;
        for (k = 0; k < codingTemplateLength; k++) {
          i0 = i + codingTemplateY[k];
          j0 = j + codingTemplateX[k];
          if (i0 < 0 || j0 < 0 || j0 >= width) {
            contextLabel <<= 1;
          } else {
            contextLabel = contextLabel << 1 | bitmap[i0][j0];
          }
        }
        for (k = 0; k < referenceTemplateLength; k++) {
          i0 = i + referenceTemplateY[k] - offsetY;
          j0 = j + referenceTemplateX[k] - offsetX;
          if (i0 < 0 || i0 >= referenceHeight || j0 < 0 || j0 >= referenceWidth) {
            contextLabel <<= 1;
          } else {
            contextLabel = contextLabel << 1 | referenceBitmap[i0][j0];
          }
        }
        var pixel = decoder.readBit(contexts, contextLabel);
        row[j] = pixel;
      }
    }
    return bitmap;
  }
  function decodeSymbolDictionary(huffman, refinement, symbols, numberOfNewSymbols, numberOfExportedSymbols, huffmanTables, templateIndex, at, refinementTemplateIndex, refinementAt, decodingContext) {
    if (huffman) {
      throw new Jbig2Error('huffman is not supported');
    }
    var newSymbols = [];
    var currentHeight = 0;
    var symbolCodeLength = (0, _util.log2)(symbols.length + numberOfNewSymbols);
    var decoder = decodingContext.decoder;
    var contextCache = decodingContext.contextCache;
    while (newSymbols.length < numberOfNewSymbols) {
      var deltaHeight = decodeInteger(contextCache, 'IADH', decoder);
      currentHeight += deltaHeight;
      var currentWidth = 0;
      while (true) {
        var deltaWidth = decodeInteger(contextCache, 'IADW', decoder);
        if (deltaWidth === null) {
          break;
        }
        currentWidth += deltaWidth;
        var bitmap;
        if (refinement) {
          var numberOfInstances = decodeInteger(contextCache, 'IAAI', decoder);
          if (numberOfInstances > 1) {
            bitmap = decodeTextRegion(huffman, refinement, currentWidth, currentHeight, 0, numberOfInstances, 1, symbols.concat(newSymbols), symbolCodeLength, 0, 0, 1, 0, huffmanTables, refinementTemplateIndex, refinementAt, decodingContext);
          } else {
            var symbolId = decodeIAID(contextCache, decoder, symbolCodeLength);
            var rdx = decodeInteger(contextCache, 'IARDX', decoder);
            var rdy = decodeInteger(contextCache, 'IARDY', decoder);
            var symbol = symbolId < symbols.length ? symbols[symbolId] : newSymbols[symbolId - symbols.length];
            bitmap = decodeRefinement(currentWidth, currentHeight, refinementTemplateIndex, symbol, rdx, rdy, false, refinementAt, decodingContext);
          }
        } else {
          bitmap = decodeBitmap(false, currentWidth, currentHeight, templateIndex, false, null, at, decodingContext);
        }
        newSymbols.push(bitmap);
      }
    }
    var exportedSymbols = [];
    var flags = [],
        currentFlag = false;
    var totalSymbolsLength = symbols.length + numberOfNewSymbols;
    while (flags.length < totalSymbolsLength) {
      var runLength = decodeInteger(contextCache, 'IAEX', decoder);
      while (runLength--) {
        flags.push(currentFlag);
      }
      currentFlag = !currentFlag;
    }
    for (var i = 0, ii = symbols.length; i < ii; i++) {
      if (flags[i]) {
        exportedSymbols.push(symbols[i]);
      }
    }
    for (var j = 0; j < numberOfNewSymbols; i++, j++) {
      if (flags[i]) {
        exportedSymbols.push(newSymbols[j]);
      }
    }
    return exportedSymbols;
  }
  function decodeTextRegion(huffman, refinement, width, height, defaultPixelValue, numberOfSymbolInstances, stripSize, inputSymbols, symbolCodeLength, transposed, dsOffset, referenceCorner, combinationOperator, huffmanTables, refinementTemplateIndex, refinementAt, decodingContext) {
    if (huffman) {
      throw new Jbig2Error('huffman is not supported');
    }
    var bitmap = [];
    var i, row;
    for (i = 0; i < height; i++) {
      row = new Uint8Array(width);
      if (defaultPixelValue) {
        for (var j = 0; j < width; j++) {
          row[j] = defaultPixelValue;
        }
      }
      bitmap.push(row);
    }
    var decoder = decodingContext.decoder;
    var contextCache = decodingContext.contextCache;
    var stripT = -decodeInteger(contextCache, 'IADT', decoder);
    var firstS = 0;
    i = 0;
    while (i < numberOfSymbolInstances) {
      var deltaT = decodeInteger(contextCache, 'IADT', decoder);
      stripT += deltaT;
      var deltaFirstS = decodeInteger(contextCache, 'IAFS', decoder);
      firstS += deltaFirstS;
      var currentS = firstS;
      do {
        var currentT = stripSize === 1 ? 0 : decodeInteger(contextCache, 'IAIT', decoder);
        var t = stripSize * stripT + currentT;
        var symbolId = decodeIAID(contextCache, decoder, symbolCodeLength);
        var applyRefinement = refinement && decodeInteger(contextCache, 'IARI', decoder);
        var symbolBitmap = inputSymbols[symbolId];
        var symbolWidth = symbolBitmap[0].length;
        var symbolHeight = symbolBitmap.length;
        if (applyRefinement) {
          var rdw = decodeInteger(contextCache, 'IARDW', decoder);
          var rdh = decodeInteger(contextCache, 'IARDH', decoder);
          var rdx = decodeInteger(contextCache, 'IARDX', decoder);
          var rdy = decodeInteger(contextCache, 'IARDY', decoder);
          symbolWidth += rdw;
          symbolHeight += rdh;
          symbolBitmap = decodeRefinement(symbolWidth, symbolHeight, refinementTemplateIndex, symbolBitmap, (rdw >> 1) + rdx, (rdh >> 1) + rdy, false, refinementAt, decodingContext);
        }
        var offsetT = t - (referenceCorner & 1 ? 0 : symbolHeight);
        var offsetS = currentS - (referenceCorner & 2 ? symbolWidth : 0);
        var s2, t2, symbolRow;
        if (transposed) {
          for (s2 = 0; s2 < symbolHeight; s2++) {
            row = bitmap[offsetS + s2];
            if (!row) {
              continue;
            }
            symbolRow = symbolBitmap[s2];
            var maxWidth = Math.min(width - offsetT, symbolWidth);
            switch (combinationOperator) {
              case 0:
                for (t2 = 0; t2 < maxWidth; t2++) {
                  row[offsetT + t2] |= symbolRow[t2];
                }
                break;
              case 2:
                for (t2 = 0; t2 < maxWidth; t2++) {
                  row[offsetT + t2] ^= symbolRow[t2];
                }
                break;
              default:
                throw new Jbig2Error('operator ' + combinationOperator + ' is not supported');
            }
          }
          currentS += symbolHeight - 1;
        } else {
          for (t2 = 0; t2 < symbolHeight; t2++) {
            row = bitmap[offsetT + t2];
            if (!row) {
              continue;
            }
            symbolRow = symbolBitmap[t2];
            switch (combinationOperator) {
              case 0:
                for (s2 = 0; s2 < symbolWidth; s2++) {
                  row[offsetS + s2] |= symbolRow[s2];
                }
                break;
              case 2:
                for (s2 = 0; s2 < symbolWidth; s2++) {
                  row[offsetS + s2] ^= symbolRow[s2];
                }
                break;
              default:
                throw new Jbig2Error('operator ' + combinationOperator + ' is not supported');
            }
          }
          currentS += symbolWidth - 1;
        }
        i++;
        var deltaS = decodeInteger(contextCache, 'IADS', decoder);
        if (deltaS === null) {
          break;
        }
        currentS += deltaS + dsOffset;
      } while (true);
    }
    return bitmap;
  }
  function readSegmentHeader(data, start) {
    var segmentHeader = {};
    segmentHeader.number = (0, _util.readUint32)(data, start);
    var flags = data[start + 4];
    var segmentType = flags & 0x3F;
    if (!SegmentTypes[segmentType]) {
      throw new Jbig2Error('invalid segment type: ' + segmentType);
    }
    segmentHeader.type = segmentType;
    segmentHeader.typeName = SegmentTypes[segmentType];
    segmentHeader.deferredNonRetain = !!(flags & 0x80);
    var pageAssociationFieldSize = !!(flags & 0x40);
    var referredFlags = data[start + 5];
    var referredToCount = referredFlags >> 5 & 7;
    var retainBits = [referredFlags & 31];
    var position = start + 6;
    if (referredFlags === 7) {
      referredToCount = (0, _util.readUint32)(data, position - 1) & 0x1FFFFFFF;
      position += 3;
      var bytes = referredToCount + 7 >> 3;
      retainBits[0] = data[position++];
      while (--bytes > 0) {
        retainBits.push(data[position++]);
      }
    } else if (referredFlags === 5 || referredFlags === 6) {
      throw new Jbig2Error('invalid referred-to flags');
    }
    segmentHeader.retainBits = retainBits;
    var referredToSegmentNumberSize = segmentHeader.number <= 256 ? 1 : segmentHeader.number <= 65536 ? 2 : 4;
    var referredTo = [];
    var i, ii;
    for (i = 0; i < referredToCount; i++) {
      var number = referredToSegmentNumberSize === 1 ? data[position] : referredToSegmentNumberSize === 2 ? (0, _util.readUint16)(data, position) : (0, _util.readUint32)(data, position);
      referredTo.push(number);
      position += referredToSegmentNumberSize;
    }
    segmentHeader.referredTo = referredTo;
    if (!pageAssociationFieldSize) {
      segmentHeader.pageAssociation = data[position++];
    } else {
      segmentHeader.pageAssociation = (0, _util.readUint32)(data, position);
      position += 4;
    }
    segmentHeader.length = (0, _util.readUint32)(data, position);
    position += 4;
    if (segmentHeader.length === 0xFFFFFFFF) {
      if (segmentType === 38) {
        var genericRegionInfo = readRegionSegmentInformation(data, position);
        var genericRegionSegmentFlags = data[position + RegionSegmentInformationFieldLength];
        var genericRegionMmr = !!(genericRegionSegmentFlags & 1);
        var searchPatternLength = 6;
        var searchPattern = new Uint8Array(searchPatternLength);
        if (!genericRegionMmr) {
          searchPattern[0] = 0xFF;
          searchPattern[1] = 0xAC;
        }
        searchPattern[2] = genericRegionInfo.height >>> 24 & 0xFF;
        searchPattern[3] = genericRegionInfo.height >> 16 & 0xFF;
        searchPattern[4] = genericRegionInfo.height >> 8 & 0xFF;
        searchPattern[5] = genericRegionInfo.height & 0xFF;
        for (i = position, ii = data.length; i < ii; i++) {
          var j = 0;
          while (j < searchPatternLength && searchPattern[j] === data[i + j]) {
            j++;
          }
          if (j === searchPatternLength) {
            segmentHeader.length = i + searchPatternLength;
            break;
          }
        }
        if (segmentHeader.length === 0xFFFFFFFF) {
          throw new Jbig2Error('segment end was not found');
        }
      } else {
        throw new Jbig2Error('invalid unknown segment length');
      }
    }
    segmentHeader.headerEnd = position;
    return segmentHeader;
  }
  function readSegments(header, data, start, end) {
    var segments = [];
    var position = start;
    while (position < end) {
      var segmentHeader = readSegmentHeader(data, position);
      position = segmentHeader.headerEnd;
      var segment = {
        header: segmentHeader,
        data: data
      };
      if (!header.randomAccess) {
        segment.start = position;
        position += segmentHeader.length;
        segment.end = position;
      }
      segments.push(segment);
      if (segmentHeader.type === 51) {
        break;
      }
    }
    if (header.randomAccess) {
      for (var i = 0, ii = segments.length; i < ii; i++) {
        segments[i].start = position;
        position += segments[i].header.length;
        segments[i].end = position;
      }
    }
    return segments;
  }
  function readRegionSegmentInformation(data, start) {
    return {
      width: (0, _util.readUint32)(data, start),
      height: (0, _util.readUint32)(data, start + 4),
      x: (0, _util.readUint32)(data, start + 8),
      y: (0, _util.readUint32)(data, start + 12),
      combinationOperator: data[start + 16] & 7
    };
  }
  var RegionSegmentInformationFieldLength = 17;
  function processSegment(segment, visitor) {
    var header = segment.header;
    var data = segment.data,
        position = segment.start,
        end = segment.end;
    var args, at, i, atLength;
    switch (header.type) {
      case 0:
        var dictionary = {};
        var dictionaryFlags = (0, _util.readUint16)(data, position);
        dictionary.huffman = !!(dictionaryFlags & 1);
        dictionary.refinement = !!(dictionaryFlags & 2);
        dictionary.huffmanDHSelector = dictionaryFlags >> 2 & 3;
        dictionary.huffmanDWSelector = dictionaryFlags >> 4 & 3;
        dictionary.bitmapSizeSelector = dictionaryFlags >> 6 & 1;
        dictionary.aggregationInstancesSelector = dictionaryFlags >> 7 & 1;
        dictionary.bitmapCodingContextUsed = !!(dictionaryFlags & 256);
        dictionary.bitmapCodingContextRetained = !!(dictionaryFlags & 512);
        dictionary.template = dictionaryFlags >> 10 & 3;
        dictionary.refinementTemplate = dictionaryFlags >> 12 & 1;
        position += 2;
        if (!dictionary.huffman) {
          atLength = dictionary.template === 0 ? 4 : 1;
          at = [];
          for (i = 0; i < atLength; i++) {
            at.push({
              x: (0, _util.readInt8)(data, position),
              y: (0, _util.readInt8)(data, position + 1)
            });
            position += 2;
          }
          dictionary.at = at;
        }
        if (dictionary.refinement && !dictionary.refinementTemplate) {
          at = [];
          for (i = 0; i < 2; i++) {
            at.push({
              x: (0, _util.readInt8)(data, position),
              y: (0, _util.readInt8)(data, position + 1)
            });
            position += 2;
          }
          dictionary.refinementAt = at;
        }
        dictionary.numberOfExportedSymbols = (0, _util.readUint32)(data, position);
        position += 4;
        dictionary.numberOfNewSymbols = (0, _util.readUint32)(data, position);
        position += 4;
        args = [dictionary, header.number, header.referredTo, data, position, end];
        break;
      case 6:
      case 7:
        var textRegion = {};
        textRegion.info = readRegionSegmentInformation(data, position);
        position += RegionSegmentInformationFieldLength;
        var textRegionSegmentFlags = (0, _util.readUint16)(data, position);
        position += 2;
        textRegion.huffman = !!(textRegionSegmentFlags & 1);
        textRegion.refinement = !!(textRegionSegmentFlags & 2);
        textRegion.stripSize = 1 << (textRegionSegmentFlags >> 2 & 3);
        textRegion.referenceCorner = textRegionSegmentFlags >> 4 & 3;
        textRegion.transposed = !!(textRegionSegmentFlags & 64);
        textRegion.combinationOperator = textRegionSegmentFlags >> 7 & 3;
        textRegion.defaultPixelValue = textRegionSegmentFlags >> 9 & 1;
        textRegion.dsOffset = textRegionSegmentFlags << 17 >> 27;
        textRegion.refinementTemplate = textRegionSegmentFlags >> 15 & 1;
        if (textRegion.huffman) {
          var textRegionHuffmanFlags = (0, _util.readUint16)(data, position);
          position += 2;
          textRegion.huffmanFS = textRegionHuffmanFlags & 3;
          textRegion.huffmanDS = textRegionHuffmanFlags >> 2 & 3;
          textRegion.huffmanDT = textRegionHuffmanFlags >> 4 & 3;
          textRegion.huffmanRefinementDW = textRegionHuffmanFlags >> 6 & 3;
          textRegion.huffmanRefinementDH = textRegionHuffmanFlags >> 8 & 3;
          textRegion.huffmanRefinementDX = textRegionHuffmanFlags >> 10 & 3;
          textRegion.huffmanRefinementDY = textRegionHuffmanFlags >> 12 & 3;
          textRegion.huffmanRefinementSizeSelector = !!(textRegionHuffmanFlags & 14);
        }
        if (textRegion.refinement && !textRegion.refinementTemplate) {
          at = [];
          for (i = 0; i < 2; i++) {
            at.push({
              x: (0, _util.readInt8)(data, position),
              y: (0, _util.readInt8)(data, position + 1)
            });
            position += 2;
          }
          textRegion.refinementAt = at;
        }
        textRegion.numberOfSymbolInstances = (0, _util.readUint32)(data, position);
        position += 4;
        if (textRegion.huffman) {
          throw new Jbig2Error('huffman is not supported');
        }
        args = [textRegion, header.referredTo, data, position, end];
        break;
      case 38:
      case 39:
        var genericRegion = {};
        genericRegion.info = readRegionSegmentInformation(data, position);
        position += RegionSegmentInformationFieldLength;
        var genericRegionSegmentFlags = data[position++];
        genericRegion.mmr = !!(genericRegionSegmentFlags & 1);
        genericRegion.template = genericRegionSegmentFlags >> 1 & 3;
        genericRegion.prediction = !!(genericRegionSegmentFlags & 8);
        if (!genericRegion.mmr) {
          atLength = genericRegion.template === 0 ? 4 : 1;
          at = [];
          for (i = 0; i < atLength; i++) {
            at.push({
              x: (0, _util.readInt8)(data, position),
              y: (0, _util.readInt8)(data, position + 1)
            });
            position += 2;
          }
          genericRegion.at = at;
        }
        args = [genericRegion, data, position, end];
        break;
      case 48:
        var pageInfo = {
          width: (0, _util.readUint32)(data, position),
          height: (0, _util.readUint32)(data, position + 4),
          resolutionX: (0, _util.readUint32)(data, position + 8),
          resolutionY: (0, _util.readUint32)(data, position + 12)
        };
        if (pageInfo.height === 0xFFFFFFFF) {
          delete pageInfo.height;
        }
        var pageSegmentFlags = data[position + 16];
        (0, _util.readUint16)(data, position + 17);
        pageInfo.lossless = !!(pageSegmentFlags & 1);
        pageInfo.refinement = !!(pageSegmentFlags & 2);
        pageInfo.defaultPixelValue = pageSegmentFlags >> 2 & 1;
        pageInfo.combinationOperator = pageSegmentFlags >> 3 & 3;
        pageInfo.requiresBuffer = !!(pageSegmentFlags & 32);
        pageInfo.combinationOperatorOverride = !!(pageSegmentFlags & 64);
        args = [pageInfo];
        break;
      case 49:
        break;
      case 50:
        break;
      case 51:
        break;
      case 62:
        break;
      default:
        throw new Jbig2Error('segment type ' + header.typeName + '(' + header.type + ')' + ' is not implemented');
    }
    var callbackName = 'on' + header.typeName;
    if (callbackName in visitor) {
      visitor[callbackName].apply(visitor, args);
    }
  }
  function processSegments(segments, visitor) {
    for (var i = 0, ii = segments.length; i < ii; i++) {
      processSegment(segments[i], visitor);
    }
  }
  function parseJbig2(data, start, end) {
    var position = start;
    if (data[position] !== 0x97 || data[position + 1] !== 0x4A || data[position + 2] !== 0x42 || data[position + 3] !== 0x32 || data[position + 4] !== 0x0D || data[position + 5] !== 0x0A || data[position + 6] !== 0x1A || data[position + 7] !== 0x0A) {
      throw new Jbig2Error('invalid header');
    }
    var header = {};
    position += 8;
    var flags = data[position++];
    header.randomAccess = !(flags & 1);
    if (!(flags & 2)) {
      header.numberOfPages = (0, _util.readUint32)(data, position);
      position += 4;
    }
    readSegments(header, data, position, end);
    throw new Error('Not implemented');
  }
  function parseJbig2Chunks(chunks) {
    var visitor = new SimpleSegmentVisitor();
    for (var i = 0, ii = chunks.length; i < ii; i++) {
      var chunk = chunks[i];
      var segments = readSegments({}, chunk.data, chunk.start, chunk.end);
      processSegments(segments, visitor);
    }
    return visitor.buffer;
  }
  function SimpleSegmentVisitor() {}
  SimpleSegmentVisitor.prototype = {
    onPageInformation: function SimpleSegmentVisitor_onPageInformation(info) {
      this.currentPageInfo = info;
      var rowSize = info.width + 7 >> 3;
      var buffer = new Uint8Array(rowSize * info.height);
      if (info.defaultPixelValue) {
        for (var i = 0, ii = buffer.length; i < ii; i++) {
          buffer[i] = 0xFF;
        }
      }
      this.buffer = buffer;
    },
    drawBitmap: function SimpleSegmentVisitor_drawBitmap(regionInfo, bitmap) {
      var pageInfo = this.currentPageInfo;
      var width = regionInfo.width,
          height = regionInfo.height;
      var rowSize = pageInfo.width + 7 >> 3;
      var combinationOperator = pageInfo.combinationOperatorOverride ? regionInfo.combinationOperator : pageInfo.combinationOperator;
      var buffer = this.buffer;
      var mask0 = 128 >> (regionInfo.x & 7);
      var offset0 = regionInfo.y * rowSize + (regionInfo.x >> 3);
      var i, j, mask, offset;
      switch (combinationOperator) {
        case 0:
          for (i = 0; i < height; i++) {
            mask = mask0;
            offset = offset0;
            for (j = 0; j < width; j++) {
              if (bitmap[i][j]) {
                buffer[offset] |= mask;
              }
              mask >>= 1;
              if (!mask) {
                mask = 128;
                offset++;
              }
            }
            offset0 += rowSize;
          }
          break;
        case 2:
          for (i = 0; i < height; i++) {
            mask = mask0;
            offset = offset0;
            for (j = 0; j < width; j++) {
              if (bitmap[i][j]) {
                buffer[offset] ^= mask;
              }
              mask >>= 1;
              if (!mask) {
                mask = 128;
                offset++;
              }
            }
            offset0 += rowSize;
          }
          break;
        default:
          throw new Jbig2Error('operator ' + combinationOperator + ' is not supported');
      }
    },
    onImmediateGenericRegion: function SimpleSegmentVisitor_onImmediateGenericRegion(region, data, start, end) {
      var regionInfo = region.info;
      var decodingContext = new DecodingContext(data, start, end);
      var bitmap = decodeBitmap(region.mmr, regionInfo.width, regionInfo.height, region.template, region.prediction, null, region.at, decodingContext);
      this.drawBitmap(regionInfo, bitmap);
    },
    onImmediateLosslessGenericRegion: function SimpleSegmentVisitor_onImmediateLosslessGenericRegion() {
      this.onImmediateGenericRegion.apply(this, arguments);
    },
    onSymbolDictionary: function SimpleSegmentVisitor_onSymbolDictionary(dictionary, currentSegment, referredSegments, data, start, end) {
      var huffmanTables;
      if (dictionary.huffman) {
        throw new Jbig2Error('huffman is not supported');
      }
      var symbols = this.symbols;
      if (!symbols) {
        this.symbols = symbols = {};
      }
      var inputSymbols = [];
      for (var i = 0, ii = referredSegments.length; i < ii; i++) {
        inputSymbols = inputSymbols.concat(symbols[referredSegments[i]]);
      }
      var decodingContext = new DecodingContext(data, start, end);
      symbols[currentSegment] = decodeSymbolDictionary(dictionary.huffman, dictionary.refinement, inputSymbols, dictionary.numberOfNewSymbols, dictionary.numberOfExportedSymbols, huffmanTables, dictionary.template, dictionary.at, dictionary.refinementTemplate, dictionary.refinementAt, decodingContext);
    },
    onImmediateTextRegion: function SimpleSegmentVisitor_onImmediateTextRegion(region, referredSegments, data, start, end) {
      var regionInfo = region.info;
      var huffmanTables;
      var symbols = this.symbols;
      var inputSymbols = [];
      for (var i = 0, ii = referredSegments.length; i < ii; i++) {
        inputSymbols = inputSymbols.concat(symbols[referredSegments[i]]);
      }
      var symbolCodeLength = (0, _util.log2)(inputSymbols.length);
      var decodingContext = new DecodingContext(data, start, end);
      var bitmap = decodeTextRegion(region.huffman, region.refinement, regionInfo.width, regionInfo.height, region.defaultPixelValue, region.numberOfSymbolInstances, region.stripSize, inputSymbols, symbolCodeLength, region.transposed, region.dsOffset, region.referenceCorner, region.combinationOperator, huffmanTables, region.refinementTemplate, region.refinementAt, decodingContext);
      this.drawBitmap(regionInfo, bitmap);
    },
    onImmediateLosslessTextRegion: function SimpleSegmentVisitor_onImmediateLosslessTextRegion() {
      this.onImmediateTextRegion.apply(this, arguments);
    }
  };
  function Jbig2Image() {}
  Jbig2Image.prototype = {
    parseChunks: function Jbig2Image_parseChunks(chunks) {
      return parseJbig2Chunks(chunks);
    }
  };
  return Jbig2Image;
}();
exports.Jbig2Image = Jbig2Image;

/***/ }),
/* 28 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JpegImage = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _util = __w_pdfjs_require__(0);

var JpegError = function JpegErrorClosure() {
  function JpegError(msg) {
    this.message = 'JPEG error: ' + msg;
  }
  JpegError.prototype = new Error();
  JpegError.prototype.name = 'JpegError';
  JpegError.constructor = JpegError;
  return JpegError;
}();
var JpegImage = function JpegImageClosure() {
  var dctZigZag = new Uint8Array([0, 1, 8, 16, 9, 2, 3, 10, 17, 24, 32, 25, 18, 11, 4, 5, 12, 19, 26, 33, 40, 48, 41, 34, 27, 20, 13, 6, 7, 14, 21, 28, 35, 42, 49, 56, 57, 50, 43, 36, 29, 22, 15, 23, 30, 37, 44, 51, 58, 59, 52, 45, 38, 31, 39, 46, 53, 60, 61, 54, 47, 55, 62, 63]);
  var dctCos1 = 4017;
  var dctSin1 = 799;
  var dctCos3 = 3406;
  var dctSin3 = 2276;
  var dctCos6 = 1567;
  var dctSin6 = 3784;
  var dctSqrt2 = 5793;
  var dctSqrt1d2 = 2896;
  function JpegImage() {
    this.decodeTransform = null;
    this.colorTransform = -1;
  }
  function buildHuffmanTable(codeLengths, values) {
    var k = 0,
        code = [],
        i,
        j,
        length = 16;
    while (length > 0 && !codeLengths[length - 1]) {
      length--;
    }
    code.push({
      children: [],
      index: 0
    });
    var p = code[0],
        q;
    for (i = 0; i < length; i++) {
      for (j = 0; j < codeLengths[i]; j++) {
        p = code.pop();
        p.children[p.index] = values[k];
        while (p.index > 0) {
          p = code.pop();
        }
        p.index++;
        code.push(p);
        while (code.length <= i) {
          code.push(q = {
            children: [],
            index: 0
          });
          p.children[p.index] = q.children;
          p = q;
        }
        k++;
      }
      if (i + 1 < length) {
        code.push(q = {
          children: [],
          index: 0
        });
        p.children[p.index] = q.children;
        p = q;
      }
    }
    return code[0].children;
  }
  function getBlockBufferOffset(component, row, col) {
    return 64 * ((component.blocksPerLine + 1) * row + col);
  }
  function decodeScan(data, offset, frame, components, resetInterval, spectralStart, spectralEnd, successivePrev, successive) {
    var mcusPerLine = frame.mcusPerLine;
    var progressive = frame.progressive;
    var startOffset = offset,
        bitsData = 0,
        bitsCount = 0;
    function readBit() {
      if (bitsCount > 0) {
        bitsCount--;
        return bitsData >> bitsCount & 1;
      }
      bitsData = data[offset++];
      if (bitsData === 0xFF) {
        var nextByte = data[offset++];
        if (nextByte) {
          throw new JpegError('unexpected marker ' + (bitsData << 8 | nextByte).toString(16));
        }
      }
      bitsCount = 7;
      return bitsData >>> 7;
    }
    function decodeHuffman(tree) {
      var node = tree;
      while (true) {
        node = node[readBit()];
        if (typeof node === 'number') {
          return node;
        }
        if ((typeof node === 'undefined' ? 'undefined' : _typeof(node)) !== 'object') {
          throw new JpegError('invalid huffman sequence');
        }
      }
    }
    function receive(length) {
      var n = 0;
      while (length > 0) {
        n = n << 1 | readBit();
        length--;
      }
      return n;
    }
    function receiveAndExtend(length) {
      if (length === 1) {
        return readBit() === 1 ? 1 : -1;
      }
      var n = receive(length);
      if (n >= 1 << length - 1) {
        return n;
      }
      return n + (-1 << length) + 1;
    }
    function decodeBaseline(component, offset) {
      var t = decodeHuffman(component.huffmanTableDC);
      var diff = t === 0 ? 0 : receiveAndExtend(t);
      component.blockData[offset] = component.pred += diff;
      var k = 1;
      while (k < 64) {
        var rs = decodeHuffman(component.huffmanTableAC);
        var s = rs & 15,
            r = rs >> 4;
        if (s === 0) {
          if (r < 15) {
            break;
          }
          k += 16;
          continue;
        }
        k += r;
        var z = dctZigZag[k];
        component.blockData[offset + z] = receiveAndExtend(s);
        k++;
      }
    }
    function decodeDCFirst(component, offset) {
      var t = decodeHuffman(component.huffmanTableDC);
      var diff = t === 0 ? 0 : receiveAndExtend(t) << successive;
      component.blockData[offset] = component.pred += diff;
    }
    function decodeDCSuccessive(component, offset) {
      component.blockData[offset] |= readBit() << successive;
    }
    var eobrun = 0;
    function decodeACFirst(component, offset) {
      if (eobrun > 0) {
        eobrun--;
        return;
      }
      var k = spectralStart,
          e = spectralEnd;
      while (k <= e) {
        var rs = decodeHuffman(component.huffmanTableAC);
        var s = rs & 15,
            r = rs >> 4;
        if (s === 0) {
          if (r < 15) {
            eobrun = receive(r) + (1 << r) - 1;
            break;
          }
          k += 16;
          continue;
        }
        k += r;
        var z = dctZigZag[k];
        component.blockData[offset + z] = receiveAndExtend(s) * (1 << successive);
        k++;
      }
    }
    var successiveACState = 0,
        successiveACNextValue;
    function decodeACSuccessive(component, offset) {
      var k = spectralStart;
      var e = spectralEnd;
      var r = 0;
      var s;
      var rs;
      while (k <= e) {
        var z = dctZigZag[k];
        switch (successiveACState) {
          case 0:
            rs = decodeHuffman(component.huffmanTableAC);
            s = rs & 15;
            r = rs >> 4;
            if (s === 0) {
              if (r < 15) {
                eobrun = receive(r) + (1 << r);
                successiveACState = 4;
              } else {
                r = 16;
                successiveACState = 1;
              }
            } else {
              if (s !== 1) {
                throw new JpegError('invalid ACn encoding');
              }
              successiveACNextValue = receiveAndExtend(s);
              successiveACState = r ? 2 : 3;
            }
            continue;
          case 1:
          case 2:
            if (component.blockData[offset + z]) {
              component.blockData[offset + z] += readBit() << successive;
            } else {
              r--;
              if (r === 0) {
                successiveACState = successiveACState === 2 ? 3 : 0;
              }
            }
            break;
          case 3:
            if (component.blockData[offset + z]) {
              component.blockData[offset + z] += readBit() << successive;
            } else {
              component.blockData[offset + z] = successiveACNextValue << successive;
              successiveACState = 0;
            }
            break;
          case 4:
            if (component.blockData[offset + z]) {
              component.blockData[offset + z] += readBit() << successive;
            }
            break;
        }
        k++;
      }
      if (successiveACState === 4) {
        eobrun--;
        if (eobrun === 0) {
          successiveACState = 0;
        }
      }
    }
    function decodeMcu(component, decode, mcu, row, col) {
      var mcuRow = mcu / mcusPerLine | 0;
      var mcuCol = mcu % mcusPerLine;
      var blockRow = mcuRow * component.v + row;
      var blockCol = mcuCol * component.h + col;
      var offset = getBlockBufferOffset(component, blockRow, blockCol);
      decode(component, offset);
    }
    function decodeBlock(component, decode, mcu) {
      var blockRow = mcu / component.blocksPerLine | 0;
      var blockCol = mcu % component.blocksPerLine;
      var offset = getBlockBufferOffset(component, blockRow, blockCol);
      decode(component, offset);
    }
    var componentsLength = components.length;
    var component, i, j, k, n;
    var decodeFn;
    if (progressive) {
      if (spectralStart === 0) {
        decodeFn = successivePrev === 0 ? decodeDCFirst : decodeDCSuccessive;
      } else {
        decodeFn = successivePrev === 0 ? decodeACFirst : decodeACSuccessive;
      }
    } else {
      decodeFn = decodeBaseline;
    }
    var mcu = 0,
        fileMarker;
    var mcuExpected;
    if (componentsLength === 1) {
      mcuExpected = components[0].blocksPerLine * components[0].blocksPerColumn;
    } else {
      mcuExpected = mcusPerLine * frame.mcusPerColumn;
    }
    var h, v;
    while (mcu < mcuExpected) {
      var mcuToRead = resetInterval ? Math.min(mcuExpected - mcu, resetInterval) : mcuExpected;
      for (i = 0; i < componentsLength; i++) {
        components[i].pred = 0;
      }
      eobrun = 0;
      if (componentsLength === 1) {
        component = components[0];
        for (n = 0; n < mcuToRead; n++) {
          decodeBlock(component, decodeFn, mcu);
          mcu++;
        }
      } else {
        for (n = 0; n < mcuToRead; n++) {
          for (i = 0; i < componentsLength; i++) {
            component = components[i];
            h = component.h;
            v = component.v;
            for (j = 0; j < v; j++) {
              for (k = 0; k < h; k++) {
                decodeMcu(component, decodeFn, mcu, j, k);
              }
            }
          }
          mcu++;
        }
      }
      bitsCount = 0;
      fileMarker = findNextFileMarker(data, offset);
      if (fileMarker && fileMarker.invalid) {
        (0, _util.warn)('decodeScan - unexpected MCU data, next marker is: ' + fileMarker.invalid);
        offset = fileMarker.offset;
      }
      var marker = fileMarker && fileMarker.marker;
      if (!marker || marker <= 0xFF00) {
        throw new JpegError('marker was not found');
      }
      if (marker >= 0xFFD0 && marker <= 0xFFD7) {
        offset += 2;
      } else {
        break;
      }
    }
    fileMarker = findNextFileMarker(data, offset);
    if (fileMarker && fileMarker.invalid) {
      (0, _util.warn)('decodeScan - unexpected Scan data, next marker is: ' + fileMarker.invalid);
      offset = fileMarker.offset;
    }
    return offset - startOffset;
  }
  function quantizeAndInverse(component, blockBufferOffset, p) {
    var qt = component.quantizationTable,
        blockData = component.blockData;
    var v0, v1, v2, v3, v4, v5, v6, v7;
    var p0, p1, p2, p3, p4, p5, p6, p7;
    var t;
    if (!qt) {
      throw new JpegError('missing required Quantization Table.');
    }
    for (var row = 0; row < 64; row += 8) {
      p0 = blockData[blockBufferOffset + row];
      p1 = blockData[blockBufferOffset + row + 1];
      p2 = blockData[blockBufferOffset + row + 2];
      p3 = blockData[blockBufferOffset + row + 3];
      p4 = blockData[blockBufferOffset + row + 4];
      p5 = blockData[blockBufferOffset + row + 5];
      p6 = blockData[blockBufferOffset + row + 6];
      p7 = blockData[blockBufferOffset + row + 7];
      p0 *= qt[row];
      if ((p1 | p2 | p3 | p4 | p5 | p6 | p7) === 0) {
        t = dctSqrt2 * p0 + 512 >> 10;
        p[row] = t;
        p[row + 1] = t;
        p[row + 2] = t;
        p[row + 3] = t;
        p[row + 4] = t;
        p[row + 5] = t;
        p[row + 6] = t;
        p[row + 7] = t;
        continue;
      }
      p1 *= qt[row + 1];
      p2 *= qt[row + 2];
      p3 *= qt[row + 3];
      p4 *= qt[row + 4];
      p5 *= qt[row + 5];
      p6 *= qt[row + 6];
      p7 *= qt[row + 7];
      v0 = dctSqrt2 * p0 + 128 >> 8;
      v1 = dctSqrt2 * p4 + 128 >> 8;
      v2 = p2;
      v3 = p6;
      v4 = dctSqrt1d2 * (p1 - p7) + 128 >> 8;
      v7 = dctSqrt1d2 * (p1 + p7) + 128 >> 8;
      v5 = p3 << 4;
      v6 = p5 << 4;
      v0 = v0 + v1 + 1 >> 1;
      v1 = v0 - v1;
      t = v2 * dctSin6 + v3 * dctCos6 + 128 >> 8;
      v2 = v2 * dctCos6 - v3 * dctSin6 + 128 >> 8;
      v3 = t;
      v4 = v4 + v6 + 1 >> 1;
      v6 = v4 - v6;
      v7 = v7 + v5 + 1 >> 1;
      v5 = v7 - v5;
      v0 = v0 + v3 + 1 >> 1;
      v3 = v0 - v3;
      v1 = v1 + v2 + 1 >> 1;
      v2 = v1 - v2;
      t = v4 * dctSin3 + v7 * dctCos3 + 2048 >> 12;
      v4 = v4 * dctCos3 - v7 * dctSin3 + 2048 >> 12;
      v7 = t;
      t = v5 * dctSin1 + v6 * dctCos1 + 2048 >> 12;
      v5 = v5 * dctCos1 - v6 * dctSin1 + 2048 >> 12;
      v6 = t;
      p[row] = v0 + v7;
      p[row + 7] = v0 - v7;
      p[row + 1] = v1 + v6;
      p[row + 6] = v1 - v6;
      p[row + 2] = v2 + v5;
      p[row + 5] = v2 - v5;
      p[row + 3] = v3 + v4;
      p[row + 4] = v3 - v4;
    }
    for (var col = 0; col < 8; ++col) {
      p0 = p[col];
      p1 = p[col + 8];
      p2 = p[col + 16];
      p3 = p[col + 24];
      p4 = p[col + 32];
      p5 = p[col + 40];
      p6 = p[col + 48];
      p7 = p[col + 56];
      if ((p1 | p2 | p3 | p4 | p5 | p6 | p7) === 0) {
        t = dctSqrt2 * p0 + 8192 >> 14;
        t = t < -2040 ? 0 : t >= 2024 ? 255 : t + 2056 >> 4;
        blockData[blockBufferOffset + col] = t;
        blockData[blockBufferOffset + col + 8] = t;
        blockData[blockBufferOffset + col + 16] = t;
        blockData[blockBufferOffset + col + 24] = t;
        blockData[blockBufferOffset + col + 32] = t;
        blockData[blockBufferOffset + col + 40] = t;
        blockData[blockBufferOffset + col + 48] = t;
        blockData[blockBufferOffset + col + 56] = t;
        continue;
      }
      v0 = dctSqrt2 * p0 + 2048 >> 12;
      v1 = dctSqrt2 * p4 + 2048 >> 12;
      v2 = p2;
      v3 = p6;
      v4 = dctSqrt1d2 * (p1 - p7) + 2048 >> 12;
      v7 = dctSqrt1d2 * (p1 + p7) + 2048 >> 12;
      v5 = p3;
      v6 = p5;
      v0 = (v0 + v1 + 1 >> 1) + 4112;
      v1 = v0 - v1;
      t = v2 * dctSin6 + v3 * dctCos6 + 2048 >> 12;
      v2 = v2 * dctCos6 - v3 * dctSin6 + 2048 >> 12;
      v3 = t;
      v4 = v4 + v6 + 1 >> 1;
      v6 = v4 - v6;
      v7 = v7 + v5 + 1 >> 1;
      v5 = v7 - v5;
      v0 = v0 + v3 + 1 >> 1;
      v3 = v0 - v3;
      v1 = v1 + v2 + 1 >> 1;
      v2 = v1 - v2;
      t = v4 * dctSin3 + v7 * dctCos3 + 2048 >> 12;
      v4 = v4 * dctCos3 - v7 * dctSin3 + 2048 >> 12;
      v7 = t;
      t = v5 * dctSin1 + v6 * dctCos1 + 2048 >> 12;
      v5 = v5 * dctCos1 - v6 * dctSin1 + 2048 >> 12;
      v6 = t;
      p0 = v0 + v7;
      p7 = v0 - v7;
      p1 = v1 + v6;
      p6 = v1 - v6;
      p2 = v2 + v5;
      p5 = v2 - v5;
      p3 = v3 + v4;
      p4 = v3 - v4;
      p0 = p0 < 16 ? 0 : p0 >= 4080 ? 255 : p0 >> 4;
      p1 = p1 < 16 ? 0 : p1 >= 4080 ? 255 : p1 >> 4;
      p2 = p2 < 16 ? 0 : p2 >= 4080 ? 255 : p2 >> 4;
      p3 = p3 < 16 ? 0 : p3 >= 4080 ? 255 : p3 >> 4;
      p4 = p4 < 16 ? 0 : p4 >= 4080 ? 255 : p4 >> 4;
      p5 = p5 < 16 ? 0 : p5 >= 4080 ? 255 : p5 >> 4;
      p6 = p6 < 16 ? 0 : p6 >= 4080 ? 255 : p6 >> 4;
      p7 = p7 < 16 ? 0 : p7 >= 4080 ? 255 : p7 >> 4;
      blockData[blockBufferOffset + col] = p0;
      blockData[blockBufferOffset + col + 8] = p1;
      blockData[blockBufferOffset + col + 16] = p2;
      blockData[blockBufferOffset + col + 24] = p3;
      blockData[blockBufferOffset + col + 32] = p4;
      blockData[blockBufferOffset + col + 40] = p5;
      blockData[blockBufferOffset + col + 48] = p6;
      blockData[blockBufferOffset + col + 56] = p7;
    }
  }
  function buildComponentData(frame, component) {
    var blocksPerLine = component.blocksPerLine;
    var blocksPerColumn = component.blocksPerColumn;
    var computationBuffer = new Int16Array(64);
    for (var blockRow = 0; blockRow < blocksPerColumn; blockRow++) {
      for (var blockCol = 0; blockCol < blocksPerLine; blockCol++) {
        var offset = getBlockBufferOffset(component, blockRow, blockCol);
        quantizeAndInverse(component, offset, computationBuffer);
      }
    }
    return component.blockData;
  }
  function clamp0to255(a) {
    return a <= 0 ? 0 : a >= 255 ? 255 : a;
  }
  function findNextFileMarker(data, currentPos, startPos) {
    function peekUint16(pos) {
      return data[pos] << 8 | data[pos + 1];
    }
    var maxPos = data.length - 1;
    var newPos = startPos < currentPos ? startPos : currentPos;
    if (currentPos >= maxPos) {
      return null;
    }
    var currentMarker = peekUint16(currentPos);
    if (currentMarker >= 0xFFC0 && currentMarker <= 0xFFFE) {
      return {
        invalid: null,
        marker: currentMarker,
        offset: currentPos
      };
    }
    var newMarker = peekUint16(newPos);
    while (!(newMarker >= 0xFFC0 && newMarker <= 0xFFFE)) {
      if (++newPos >= maxPos) {
        return null;
      }
      newMarker = peekUint16(newPos);
    }
    return {
      invalid: currentMarker.toString(16),
      marker: newMarker,
      offset: newPos
    };
  }
  JpegImage.prototype = {
    parse: function parse(data) {
      function readUint16() {
        var value = data[offset] << 8 | data[offset + 1];
        offset += 2;
        return value;
      }
      function readDataBlock() {
        var length = readUint16();
        var endOffset = offset + length - 2;
        var fileMarker = findNextFileMarker(data, endOffset, offset);
        if (fileMarker && fileMarker.invalid) {
          (0, _util.warn)('readDataBlock - incorrect length, next marker is: ' + fileMarker.invalid);
          endOffset = fileMarker.offset;
        }
        var array = data.subarray(offset, endOffset);
        offset += array.length;
        return array;
      }
      function prepareComponents(frame) {
        var mcusPerLine = Math.ceil(frame.samplesPerLine / 8 / frame.maxH);
        var mcusPerColumn = Math.ceil(frame.scanLines / 8 / frame.maxV);
        for (var i = 0; i < frame.components.length; i++) {
          component = frame.components[i];
          var blocksPerLine = Math.ceil(Math.ceil(frame.samplesPerLine / 8) * component.h / frame.maxH);
          var blocksPerColumn = Math.ceil(Math.ceil(frame.scanLines / 8) * component.v / frame.maxV);
          var blocksPerLineForMcu = mcusPerLine * component.h;
          var blocksPerColumnForMcu = mcusPerColumn * component.v;
          var blocksBufferSize = 64 * blocksPerColumnForMcu * (blocksPerLineForMcu + 1);
          component.blockData = new Int16Array(blocksBufferSize);
          component.blocksPerLine = blocksPerLine;
          component.blocksPerColumn = blocksPerColumn;
        }
        frame.mcusPerLine = mcusPerLine;
        frame.mcusPerColumn = mcusPerColumn;
      }
      var offset = 0;
      var jfif = null;
      var adobe = null;
      var frame, resetInterval;
      var quantizationTables = [];
      var huffmanTablesAC = [],
          huffmanTablesDC = [];
      var fileMarker = readUint16();
      if (fileMarker !== 0xFFD8) {
        throw new JpegError('SOI not found');
      }
      fileMarker = readUint16();
      while (fileMarker !== 0xFFD9) {
        var i, j, l;
        switch (fileMarker) {
          case 0xFFE0:
          case 0xFFE1:
          case 0xFFE2:
          case 0xFFE3:
          case 0xFFE4:
          case 0xFFE5:
          case 0xFFE6:
          case 0xFFE7:
          case 0xFFE8:
          case 0xFFE9:
          case 0xFFEA:
          case 0xFFEB:
          case 0xFFEC:
          case 0xFFED:
          case 0xFFEE:
          case 0xFFEF:
          case 0xFFFE:
            var appData = readDataBlock();
            if (fileMarker === 0xFFE0) {
              if (appData[0] === 0x4A && appData[1] === 0x46 && appData[2] === 0x49 && appData[3] === 0x46 && appData[4] === 0) {
                jfif = {
                  version: {
                    major: appData[5],
                    minor: appData[6]
                  },
                  densityUnits: appData[7],
                  xDensity: appData[8] << 8 | appData[9],
                  yDensity: appData[10] << 8 | appData[11],
                  thumbWidth: appData[12],
                  thumbHeight: appData[13],
                  thumbData: appData.subarray(14, 14 + 3 * appData[12] * appData[13])
                };
              }
            }
            if (fileMarker === 0xFFEE) {
              if (appData[0] === 0x41 && appData[1] === 0x64 && appData[2] === 0x6F && appData[3] === 0x62 && appData[4] === 0x65) {
                adobe = {
                  version: appData[5] << 8 | appData[6],
                  flags0: appData[7] << 8 | appData[8],
                  flags1: appData[9] << 8 | appData[10],
                  transformCode: appData[11]
                };
              }
            }
            break;
          case 0xFFDB:
            var quantizationTablesLength = readUint16();
            var quantizationTablesEnd = quantizationTablesLength + offset - 2;
            var z;
            while (offset < quantizationTablesEnd) {
              var quantizationTableSpec = data[offset++];
              var tableData = new Uint16Array(64);
              if (quantizationTableSpec >> 4 === 0) {
                for (j = 0; j < 64; j++) {
                  z = dctZigZag[j];
                  tableData[z] = data[offset++];
                }
              } else if (quantizationTableSpec >> 4 === 1) {
                for (j = 0; j < 64; j++) {
                  z = dctZigZag[j];
                  tableData[z] = readUint16();
                }
              } else {
                throw new JpegError('DQT - invalid table spec');
              }
              quantizationTables[quantizationTableSpec & 15] = tableData;
            }
            break;
          case 0xFFC0:
          case 0xFFC1:
          case 0xFFC2:
            if (frame) {
              throw new JpegError('Only single frame JPEGs supported');
            }
            readUint16();
            frame = {};
            frame.extended = fileMarker === 0xFFC1;
            frame.progressive = fileMarker === 0xFFC2;
            frame.precision = data[offset++];
            frame.scanLines = readUint16();
            frame.samplesPerLine = readUint16();
            frame.components = [];
            frame.componentIds = {};
            var componentsCount = data[offset++],
                componentId;
            var maxH = 0,
                maxV = 0;
            for (i = 0; i < componentsCount; i++) {
              componentId = data[offset];
              var h = data[offset + 1] >> 4;
              var v = data[offset + 1] & 15;
              if (maxH < h) {
                maxH = h;
              }
              if (maxV < v) {
                maxV = v;
              }
              var qId = data[offset + 2];
              l = frame.components.push({
                h: h,
                v: v,
                quantizationId: qId,
                quantizationTable: null
              });
              frame.componentIds[componentId] = l - 1;
              offset += 3;
            }
            frame.maxH = maxH;
            frame.maxV = maxV;
            prepareComponents(frame);
            break;
          case 0xFFC4:
            var huffmanLength = readUint16();
            for (i = 2; i < huffmanLength;) {
              var huffmanTableSpec = data[offset++];
              var codeLengths = new Uint8Array(16);
              var codeLengthSum = 0;
              for (j = 0; j < 16; j++, offset++) {
                codeLengthSum += codeLengths[j] = data[offset];
              }
              var huffmanValues = new Uint8Array(codeLengthSum);
              for (j = 0; j < codeLengthSum; j++, offset++) {
                huffmanValues[j] = data[offset];
              }
              i += 17 + codeLengthSum;
              (huffmanTableSpec >> 4 === 0 ? huffmanTablesDC : huffmanTablesAC)[huffmanTableSpec & 15] = buildHuffmanTable(codeLengths, huffmanValues);
            }
            break;
          case 0xFFDD:
            readUint16();
            resetInterval = readUint16();
            break;
          case 0xFFDA:
            readUint16();
            var selectorsCount = data[offset++];
            var components = [],
                component;
            for (i = 0; i < selectorsCount; i++) {
              var componentIndex = frame.componentIds[data[offset++]];
              component = frame.components[componentIndex];
              var tableSpec = data[offset++];
              component.huffmanTableDC = huffmanTablesDC[tableSpec >> 4];
              component.huffmanTableAC = huffmanTablesAC[tableSpec & 15];
              components.push(component);
            }
            var spectralStart = data[offset++];
            var spectralEnd = data[offset++];
            var successiveApproximation = data[offset++];
            var processed = decodeScan(data, offset, frame, components, resetInterval, spectralStart, spectralEnd, successiveApproximation >> 4, successiveApproximation & 15);
            offset += processed;
            break;
          case 0xFFFF:
            if (data[offset] !== 0xFF) {
              offset--;
            }
            break;
          default:
            if (data[offset - 3] === 0xFF && data[offset - 2] >= 0xC0 && data[offset - 2] <= 0xFE) {
              offset -= 3;
              break;
            }
            throw new JpegError('unknown marker ' + fileMarker.toString(16));
        }
        fileMarker = readUint16();
      }
      this.width = frame.samplesPerLine;
      this.height = frame.scanLines;
      this.jfif = jfif;
      this.adobe = adobe;
      this.components = [];
      for (i = 0; i < frame.components.length; i++) {
        component = frame.components[i];
        var quantizationTable = quantizationTables[component.quantizationId];
        if (quantizationTable) {
          component.quantizationTable = quantizationTable;
        }
        this.components.push({
          output: buildComponentData(frame, component),
          scaleX: component.h / frame.maxH,
          scaleY: component.v / frame.maxV,
          blocksPerLine: component.blocksPerLine,
          blocksPerColumn: component.blocksPerColumn
        });
      }
      this.numComponents = this.components.length;
    },
    _getLinearizedBlockData: function getLinearizedBlockData(width, height) {
      var scaleX = this.width / width,
          scaleY = this.height / height;
      var component, componentScaleX, componentScaleY, blocksPerScanline;
      var x, y, i, j, k;
      var index;
      var offset = 0;
      var output;
      var numComponents = this.components.length;
      var dataLength = width * height * numComponents;
      var data = new Uint8Array(dataLength);
      var xScaleBlockOffset = new Uint32Array(width);
      var mask3LSB = 0xfffffff8;
      for (i = 0; i < numComponents; i++) {
        component = this.components[i];
        componentScaleX = component.scaleX * scaleX;
        componentScaleY = component.scaleY * scaleY;
        offset = i;
        output = component.output;
        blocksPerScanline = component.blocksPerLine + 1 << 3;
        for (x = 0; x < width; x++) {
          j = 0 | x * componentScaleX;
          xScaleBlockOffset[x] = (j & mask3LSB) << 3 | j & 7;
        }
        for (y = 0; y < height; y++) {
          j = 0 | y * componentScaleY;
          index = blocksPerScanline * (j & mask3LSB) | (j & 7) << 3;
          for (x = 0; x < width; x++) {
            data[offset] = output[index + xScaleBlockOffset[x]];
            offset += numComponents;
          }
        }
      }
      var transform = this.decodeTransform;
      if (transform) {
        for (i = 0; i < dataLength;) {
          for (j = 0, k = 0; j < numComponents; j++, i++, k += 2) {
            data[i] = (data[i] * transform[k] >> 8) + transform[k + 1];
          }
        }
      }
      return data;
    },
    _isColorConversionNeeded: function _isColorConversionNeeded() {
      if (this.adobe) {
        return !!this.adobe.transformCode;
      }
      if (this.numComponents === 3) {
        if (this.colorTransform === 0) {
          return false;
        }
        return true;
      }
      if (this.colorTransform === 1) {
        return true;
      }
      return false;
    },

    _convertYccToRgb: function convertYccToRgb(data) {
      var Y, Cb, Cr;
      for (var i = 0, length = data.length; i < length; i += 3) {
        Y = data[i];
        Cb = data[i + 1];
        Cr = data[i + 2];
        data[i] = clamp0to255(Y - 179.456 + 1.402 * Cr);
        data[i + 1] = clamp0to255(Y + 135.459 - 0.344 * Cb - 0.714 * Cr);
        data[i + 2] = clamp0to255(Y - 226.816 + 1.772 * Cb);
      }
      return data;
    },
    _convertYcckToRgb: function convertYcckToRgb(data) {
      var Y, Cb, Cr, k;
      var offset = 0;
      for (var i = 0, length = data.length; i < length; i += 4) {
        Y = data[i];
        Cb = data[i + 1];
        Cr = data[i + 2];
        k = data[i + 3];
        var r = -122.67195406894 + Cb * (-6.60635669420364e-5 * Cb + 0.000437130475926232 * Cr - 5.4080610064599e-5 * Y + 0.00048449797120281 * k - 0.154362151871126) + Cr * (-0.000957964378445773 * Cr + 0.000817076911346625 * Y - 0.00477271405408747 * k + 1.53380253221734) + Y * (0.000961250184130688 * Y - 0.00266257332283933 * k + 0.48357088451265) + k * (-0.000336197177618394 * k + 0.484791561490776);
        var g = 107.268039397724 + Cb * (2.19927104525741e-5 * Cb - 0.000640992018297945 * Cr + 0.000659397001245577 * Y + 0.000426105652938837 * k - 0.176491792462875) + Cr * (-0.000778269941513683 * Cr + 0.00130872261408275 * Y + 0.000770482631801132 * k - 0.151051492775562) + Y * (0.00126935368114843 * Y - 0.00265090189010898 * k + 0.25802910206845) + k * (-0.000318913117588328 * k - 0.213742400323665);
        var b = -20.810012546947 + Cb * (-0.000570115196973677 * Cb - 2.63409051004589e-5 * Cr + 0.0020741088115012 * Y - 0.00288260236853442 * k + 0.814272968359295) + Cr * (-1.53496057440975e-5 * Cr - 0.000132689043961446 * Y + 0.000560833691242812 * k - 0.195152027534049) + Y * (0.00174418132927582 * Y - 0.00255243321439347 * k + 0.116935020465145) + k * (-0.000343531996510555 * k + 0.24165260232407);
        data[offset++] = clamp0to255(r);
        data[offset++] = clamp0to255(g);
        data[offset++] = clamp0to255(b);
      }
      return data;
    },
    _convertYcckToCmyk: function convertYcckToCmyk(data) {
      var Y, Cb, Cr;
      for (var i = 0, length = data.length; i < length; i += 4) {
        Y = data[i];
        Cb = data[i + 1];
        Cr = data[i + 2];
        data[i] = clamp0to255(434.456 - Y - 1.402 * Cr);
        data[i + 1] = clamp0to255(119.541 - Y + 0.344 * Cb + 0.714 * Cr);
        data[i + 2] = clamp0to255(481.816 - Y - 1.772 * Cb);
      }
      return data;
    },
    _convertCmykToRgb: function convertCmykToRgb(data) {
      var c, m, y, k;
      var offset = 0;
      var min = -255 * 255 * 255;
      var scale = 1 / 255 / 255;
      for (var i = 0, length = data.length; i < length; i += 4) {
        c = data[i];
        m = data[i + 1];
        y = data[i + 2];
        k = data[i + 3];
        var r = c * (-4.387332384609988 * c + 54.48615194189176 * m + 18.82290502165302 * y + 212.25662451639585 * k - 72734.4411664936) + m * (1.7149763477362134 * m - 5.6096736904047315 * y - 17.873870861415444 * k - 1401.7366389350734) + y * (-2.5217340131683033 * y - 21.248923337353073 * k + 4465.541406466231) - k * (21.86122147463605 * k + 48317.86113160301);
        var g = c * (8.841041422036149 * c + 60.118027045597366 * m + 6.871425592049007 * y + 31.159100130055922 * k - 20220.756542821975) + m * (-15.310361306967817 * m + 17.575251261109482 * y + 131.35250912493976 * k - 48691.05921601825) + y * (4.444339102852739 * y + 9.8632861493405 * k - 6341.191035517494) - k * (20.737325471181034 * k + 47890.15695978492);
        var b = c * (0.8842522430003296 * c + 8.078677503112928 * m + 30.89978309703729 * y - 0.23883238689178934 * k - 3616.812083916688) + m * (10.49593273432072 * m + 63.02378494754052 * y + 50.606957656360734 * k - 28620.90484698408) + y * (0.03296041114873217 * y + 115.60384449646641 * k - 49363.43385999684) - k * (22.33816807309886 * k + 45932.16563550634);
        data[offset++] = r >= 0 ? 255 : r <= min ? 0 : 255 + r * scale | 0;
        data[offset++] = g >= 0 ? 255 : g <= min ? 0 : 255 + g * scale | 0;
        data[offset++] = b >= 0 ? 255 : b <= min ? 0 : 255 + b * scale | 0;
      }
      return data;
    },
    getData: function getData(width, height, forceRGBoutput) {
      if (this.numComponents > 4) {
        throw new JpegError('Unsupported color mode');
      }
      var data = this._getLinearizedBlockData(width, height);
      if (this.numComponents === 1 && forceRGBoutput) {
        var dataLength = data.length;
        var rgbData = new Uint8Array(dataLength * 3);
        var offset = 0;
        for (var i = 0; i < dataLength; i++) {
          var grayColor = data[i];
          rgbData[offset++] = grayColor;
          rgbData[offset++] = grayColor;
          rgbData[offset++] = grayColor;
        }
        return rgbData;
      } else if (this.numComponents === 3 && this._isColorConversionNeeded()) {
        return this._convertYccToRgb(data);
      } else if (this.numComponents === 4) {
        if (this._isColorConversionNeeded()) {
          if (forceRGBoutput) {
            return this._convertYcckToRgb(data);
          }
          return this._convertYcckToCmyk(data);
        } else if (forceRGBoutput) {
          return this._convertCmykToRgb(data);
        }
      }
      return data;
    }
  };
  return JpegImage;
}();
exports.JpegImage = JpegImage;

/***/ }),
/* 29 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMetrics = undefined;

var _util = __w_pdfjs_require__(0);

var getMetrics = (0, _util.getLookupTableFactory)(function (t) {
  t['Courier'] = 600;
  t['Courier-Bold'] = 600;
  t['Courier-BoldOblique'] = 600;
  t['Courier-Oblique'] = 600;
  t['Helvetica'] = (0, _util.getLookupTableFactory)(function (t) {
    t['space'] = 278;
    t['exclam'] = 278;
    t['quotedbl'] = 355;
    t['numbersign'] = 556;
    t['dollar'] = 556;
    t['percent'] = 889;
    t['ampersand'] = 667;
    t['quoteright'] = 222;
    t['parenleft'] = 333;
    t['parenright'] = 333;
    t['asterisk'] = 389;
    t['plus'] = 584;
    t['comma'] = 278;
    t['hyphen'] = 333;
    t['period'] = 278;
    t['slash'] = 278;
    t['zero'] = 556;
    t['one'] = 556;
    t['two'] = 556;
    t['three'] = 556;
    t['four'] = 556;
    t['five'] = 556;
    t['six'] = 556;
    t['seven'] = 556;
    t['eight'] = 556;
    t['nine'] = 556;
    t['colon'] = 278;
    t['semicolon'] = 278;
    t['less'] = 584;
    t['equal'] = 584;
    t['greater'] = 584;
    t['question'] = 556;
    t['at'] = 1015;
    t['A'] = 667;
    t['B'] = 667;
    t['C'] = 722;
    t['D'] = 722;
    t['E'] = 667;
    t['F'] = 611;
    t['G'] = 778;
    t['H'] = 722;
    t['I'] = 278;
    t['J'] = 500;
    t['K'] = 667;
    t['L'] = 556;
    t['M'] = 833;
    t['N'] = 722;
    t['O'] = 778;
    t['P'] = 667;
    t['Q'] = 778;
    t['R'] = 722;
    t['S'] = 667;
    t['T'] = 611;
    t['U'] = 722;
    t['V'] = 667;
    t['W'] = 944;
    t['X'] = 667;
    t['Y'] = 667;
    t['Z'] = 611;
    t['bracketleft'] = 278;
    t['backslash'] = 278;
    t['bracketright'] = 278;
    t['asciicircum'] = 469;
    t['underscore'] = 556;
    t['quoteleft'] = 222;
    t['a'] = 556;
    t['b'] = 556;
    t['c'] = 500;
    t['d'] = 556;
    t['e'] = 556;
    t['f'] = 278;
    t['g'] = 556;
    t['h'] = 556;
    t['i'] = 222;
    t['j'] = 222;
    t['k'] = 500;
    t['l'] = 222;
    t['m'] = 833;
    t['n'] = 556;
    t['o'] = 556;
    t['p'] = 556;
    t['q'] = 556;
    t['r'] = 333;
    t['s'] = 500;
    t['t'] = 278;
    t['u'] = 556;
    t['v'] = 500;
    t['w'] = 722;
    t['x'] = 500;
    t['y'] = 500;
    t['z'] = 500;
    t['braceleft'] = 334;
    t['bar'] = 260;
    t['braceright'] = 334;
    t['asciitilde'] = 584;
    t['exclamdown'] = 333;
    t['cent'] = 556;
    t['sterling'] = 556;
    t['fraction'] = 167;
    t['yen'] = 556;
    t['florin'] = 556;
    t['section'] = 556;
    t['currency'] = 556;
    t['quotesingle'] = 191;
    t['quotedblleft'] = 333;
    t['guillemotleft'] = 556;
    t['guilsinglleft'] = 333;
    t['guilsinglright'] = 333;
    t['fi'] = 500;
    t['fl'] = 500;
    t['endash'] = 556;
    t['dagger'] = 556;
    t['daggerdbl'] = 556;
    t['periodcentered'] = 278;
    t['paragraph'] = 537;
    t['bullet'] = 350;
    t['quotesinglbase'] = 222;
    t['quotedblbase'] = 333;
    t['quotedblright'] = 333;
    t['guillemotright'] = 556;
    t['ellipsis'] = 1000;
    t['perthousand'] = 1000;
    t['questiondown'] = 611;
    t['grave'] = 333;
    t['acute'] = 333;
    t['circumflex'] = 333;
    t['tilde'] = 333;
    t['macron'] = 333;
    t['breve'] = 333;
    t['dotaccent'] = 333;
    t['dieresis'] = 333;
    t['ring'] = 333;
    t['cedilla'] = 333;
    t['hungarumlaut'] = 333;
    t['ogonek'] = 333;
    t['caron'] = 333;
    t['emdash'] = 1000;
    t['AE'] = 1000;
    t['ordfeminine'] = 370;
    t['Lslash'] = 556;
    t['Oslash'] = 778;
    t['OE'] = 1000;
    t['ordmasculine'] = 365;
    t['ae'] = 889;
    t['dotlessi'] = 278;
    t['lslash'] = 222;
    t['oslash'] = 611;
    t['oe'] = 944;
    t['germandbls'] = 611;
    t['Idieresis'] = 278;
    t['eacute'] = 556;
    t['abreve'] = 556;
    t['uhungarumlaut'] = 556;
    t['ecaron'] = 556;
    t['Ydieresis'] = 667;
    t['divide'] = 584;
    t['Yacute'] = 667;
    t['Acircumflex'] = 667;
    t['aacute'] = 556;
    t['Ucircumflex'] = 722;
    t['yacute'] = 500;
    t['scommaaccent'] = 500;
    t['ecircumflex'] = 556;
    t['Uring'] = 722;
    t['Udieresis'] = 722;
    t['aogonek'] = 556;
    t['Uacute'] = 722;
    t['uogonek'] = 556;
    t['Edieresis'] = 667;
    t['Dcroat'] = 722;
    t['commaaccent'] = 250;
    t['copyright'] = 737;
    t['Emacron'] = 667;
    t['ccaron'] = 500;
    t['aring'] = 556;
    t['Ncommaaccent'] = 722;
    t['lacute'] = 222;
    t['agrave'] = 556;
    t['Tcommaaccent'] = 611;
    t['Cacute'] = 722;
    t['atilde'] = 556;
    t['Edotaccent'] = 667;
    t['scaron'] = 500;
    t['scedilla'] = 500;
    t['iacute'] = 278;
    t['lozenge'] = 471;
    t['Rcaron'] = 722;
    t['Gcommaaccent'] = 778;
    t['ucircumflex'] = 556;
    t['acircumflex'] = 556;
    t['Amacron'] = 667;
    t['rcaron'] = 333;
    t['ccedilla'] = 500;
    t['Zdotaccent'] = 611;
    t['Thorn'] = 667;
    t['Omacron'] = 778;
    t['Racute'] = 722;
    t['Sacute'] = 667;
    t['dcaron'] = 643;
    t['Umacron'] = 722;
    t['uring'] = 556;
    t['threesuperior'] = 333;
    t['Ograve'] = 778;
    t['Agrave'] = 667;
    t['Abreve'] = 667;
    t['multiply'] = 584;
    t['uacute'] = 556;
    t['Tcaron'] = 611;
    t['partialdiff'] = 476;
    t['ydieresis'] = 500;
    t['Nacute'] = 722;
    t['icircumflex'] = 278;
    t['Ecircumflex'] = 667;
    t['adieresis'] = 556;
    t['edieresis'] = 556;
    t['cacute'] = 500;
    t['nacute'] = 556;
    t['umacron'] = 556;
    t['Ncaron'] = 722;
    t['Iacute'] = 278;
    t['plusminus'] = 584;
    t['brokenbar'] = 260;
    t['registered'] = 737;
    t['Gbreve'] = 778;
    t['Idotaccent'] = 278;
    t['summation'] = 600;
    t['Egrave'] = 667;
    t['racute'] = 333;
    t['omacron'] = 556;
    t['Zacute'] = 611;
    t['Zcaron'] = 611;
    t['greaterequal'] = 549;
    t['Eth'] = 722;
    t['Ccedilla'] = 722;
    t['lcommaaccent'] = 222;
    t['tcaron'] = 317;
    t['eogonek'] = 556;
    t['Uogonek'] = 722;
    t['Aacute'] = 667;
    t['Adieresis'] = 667;
    t['egrave'] = 556;
    t['zacute'] = 500;
    t['iogonek'] = 222;
    t['Oacute'] = 778;
    t['oacute'] = 556;
    t['amacron'] = 556;
    t['sacute'] = 500;
    t['idieresis'] = 278;
    t['Ocircumflex'] = 778;
    t['Ugrave'] = 722;
    t['Delta'] = 612;
    t['thorn'] = 556;
    t['twosuperior'] = 333;
    t['Odieresis'] = 778;
    t['mu'] = 556;
    t['igrave'] = 278;
    t['ohungarumlaut'] = 556;
    t['Eogonek'] = 667;
    t['dcroat'] = 556;
    t['threequarters'] = 834;
    t['Scedilla'] = 667;
    t['lcaron'] = 299;
    t['Kcommaaccent'] = 667;
    t['Lacute'] = 556;
    t['trademark'] = 1000;
    t['edotaccent'] = 556;
    t['Igrave'] = 278;
    t['Imacron'] = 278;
    t['Lcaron'] = 556;
    t['onehalf'] = 834;
    t['lessequal'] = 549;
    t['ocircumflex'] = 556;
    t['ntilde'] = 556;
    t['Uhungarumlaut'] = 722;
    t['Eacute'] = 667;
    t['emacron'] = 556;
    t['gbreve'] = 556;
    t['onequarter'] = 834;
    t['Scaron'] = 667;
    t['Scommaaccent'] = 667;
    t['Ohungarumlaut'] = 778;
    t['degree'] = 400;
    t['ograve'] = 556;
    t['Ccaron'] = 722;
    t['ugrave'] = 556;
    t['radical'] = 453;
    t['Dcaron'] = 722;
    t['rcommaaccent'] = 333;
    t['Ntilde'] = 722;
    t['otilde'] = 556;
    t['Rcommaaccent'] = 722;
    t['Lcommaaccent'] = 556;
    t['Atilde'] = 667;
    t['Aogonek'] = 667;
    t['Aring'] = 667;
    t['Otilde'] = 778;
    t['zdotaccent'] = 500;
    t['Ecaron'] = 667;
    t['Iogonek'] = 278;
    t['kcommaaccent'] = 500;
    t['minus'] = 584;
    t['Icircumflex'] = 278;
    t['ncaron'] = 556;
    t['tcommaaccent'] = 278;
    t['logicalnot'] = 584;
    t['odieresis'] = 556;
    t['udieresis'] = 556;
    t['notequal'] = 549;
    t['gcommaaccent'] = 556;
    t['eth'] = 556;
    t['zcaron'] = 500;
    t['ncommaaccent'] = 556;
    t['onesuperior'] = 333;
    t['imacron'] = 278;
    t['Euro'] = 556;
  });
  t['Helvetica-Bold'] = (0, _util.getLookupTableFactory)(function (t) {
    t['space'] = 278;
    t['exclam'] = 333;
    t['quotedbl'] = 474;
    t['numbersign'] = 556;
    t['dollar'] = 556;
    t['percent'] = 889;
    t['ampersand'] = 722;
    t['quoteright'] = 278;
    t['parenleft'] = 333;
    t['parenright'] = 333;
    t['asterisk'] = 389;
    t['plus'] = 584;
    t['comma'] = 278;
    t['hyphen'] = 333;
    t['period'] = 278;
    t['slash'] = 278;
    t['zero'] = 556;
    t['one'] = 556;
    t['two'] = 556;
    t['three'] = 556;
    t['four'] = 556;
    t['five'] = 556;
    t['six'] = 556;
    t['seven'] = 556;
    t['eight'] = 556;
    t['nine'] = 556;
    t['colon'] = 333;
    t['semicolon'] = 333;
    t['less'] = 584;
    t['equal'] = 584;
    t['greater'] = 584;
    t['question'] = 611;
    t['at'] = 975;
    t['A'] = 722;
    t['B'] = 722;
    t['C'] = 722;
    t['D'] = 722;
    t['E'] = 667;
    t['F'] = 611;
    t['G'] = 778;
    t['H'] = 722;
    t['I'] = 278;
    t['J'] = 556;
    t['K'] = 722;
    t['L'] = 611;
    t['M'] = 833;
    t['N'] = 722;
    t['O'] = 778;
    t['P'] = 667;
    t['Q'] = 778;
    t['R'] = 722;
    t['S'] = 667;
    t['T'] = 611;
    t['U'] = 722;
    t['V'] = 667;
    t['W'] = 944;
    t['X'] = 667;
    t['Y'] = 667;
    t['Z'] = 611;
    t['bracketleft'] = 333;
    t['backslash'] = 278;
    t['bracketright'] = 333;
    t['asciicircum'] = 584;
    t['underscore'] = 556;
    t['quoteleft'] = 278;
    t['a'] = 556;
    t['b'] = 611;
    t['c'] = 556;
    t['d'] = 611;
    t['e'] = 556;
    t['f'] = 333;
    t['g'] = 611;
    t['h'] = 611;
    t['i'] = 278;
    t['j'] = 278;
    t['k'] = 556;
    t['l'] = 278;
    t['m'] = 889;
    t['n'] = 611;
    t['o'] = 611;
    t['p'] = 611;
    t['q'] = 611;
    t['r'] = 389;
    t['s'] = 556;
    t['t'] = 333;
    t['u'] = 611;
    t['v'] = 556;
    t['w'] = 778;
    t['x'] = 556;
    t['y'] = 556;
    t['z'] = 500;
    t['braceleft'] = 389;
    t['bar'] = 280;
    t['braceright'] = 389;
    t['asciitilde'] = 584;
    t['exclamdown'] = 333;
    t['cent'] = 556;
    t['sterling'] = 556;
    t['fraction'] = 167;
    t['yen'] = 556;
    t['florin'] = 556;
    t['section'] = 556;
    t['currency'] = 556;
    t['quotesingle'] = 238;
    t['quotedblleft'] = 500;
    t['guillemotleft'] = 556;
    t['guilsinglleft'] = 333;
    t['guilsinglright'] = 333;
    t['fi'] = 611;
    t['fl'] = 611;
    t['endash'] = 556;
    t['dagger'] = 556;
    t['daggerdbl'] = 556;
    t['periodcentered'] = 278;
    t['paragraph'] = 556;
    t['bullet'] = 350;
    t['quotesinglbase'] = 278;
    t['quotedblbase'] = 500;
    t['quotedblright'] = 500;
    t['guillemotright'] = 556;
    t['ellipsis'] = 1000;
    t['perthousand'] = 1000;
    t['questiondown'] = 611;
    t['grave'] = 333;
    t['acute'] = 333;
    t['circumflex'] = 333;
    t['tilde'] = 333;
    t['macron'] = 333;
    t['breve'] = 333;
    t['dotaccent'] = 333;
    t['dieresis'] = 333;
    t['ring'] = 333;
    t['cedilla'] = 333;
    t['hungarumlaut'] = 333;
    t['ogonek'] = 333;
    t['caron'] = 333;
    t['emdash'] = 1000;
    t['AE'] = 1000;
    t['ordfeminine'] = 370;
    t['Lslash'] = 611;
    t['Oslash'] = 778;
    t['OE'] = 1000;
    t['ordmasculine'] = 365;
    t['ae'] = 889;
    t['dotlessi'] = 278;
    t['lslash'] = 278;
    t['oslash'] = 611;
    t['oe'] = 944;
    t['germandbls'] = 611;
    t['Idieresis'] = 278;
    t['eacute'] = 556;
    t['abreve'] = 556;
    t['uhungarumlaut'] = 611;
    t['ecaron'] = 556;
    t['Ydieresis'] = 667;
    t['divide'] = 584;
    t['Yacute'] = 667;
    t['Acircumflex'] = 722;
    t['aacute'] = 556;
    t['Ucircumflex'] = 722;
    t['yacute'] = 556;
    t['scommaaccent'] = 556;
    t['ecircumflex'] = 556;
    t['Uring'] = 722;
    t['Udieresis'] = 722;
    t['aogonek'] = 556;
    t['Uacute'] = 722;
    t['uogonek'] = 611;
    t['Edieresis'] = 667;
    t['Dcroat'] = 722;
    t['commaaccent'] = 250;
    t['copyright'] = 737;
    t['Emacron'] = 667;
    t['ccaron'] = 556;
    t['aring'] = 556;
    t['Ncommaaccent'] = 722;
    t['lacute'] = 278;
    t['agrave'] = 556;
    t['Tcommaaccent'] = 611;
    t['Cacute'] = 722;
    t['atilde'] = 556;
    t['Edotaccent'] = 667;
    t['scaron'] = 556;
    t['scedilla'] = 556;
    t['iacute'] = 278;
    t['lozenge'] = 494;
    t['Rcaron'] = 722;
    t['Gcommaaccent'] = 778;
    t['ucircumflex'] = 611;
    t['acircumflex'] = 556;
    t['Amacron'] = 722;
    t['rcaron'] = 389;
    t['ccedilla'] = 556;
    t['Zdotaccent'] = 611;
    t['Thorn'] = 667;
    t['Omacron'] = 778;
    t['Racute'] = 722;
    t['Sacute'] = 667;
    t['dcaron'] = 743;
    t['Umacron'] = 722;
    t['uring'] = 611;
    t['threesuperior'] = 333;
    t['Ograve'] = 778;
    t['Agrave'] = 722;
    t['Abreve'] = 722;
    t['multiply'] = 584;
    t['uacute'] = 611;
    t['Tcaron'] = 611;
    t['partialdiff'] = 494;
    t['ydieresis'] = 556;
    t['Nacute'] = 722;
    t['icircumflex'] = 278;
    t['Ecircumflex'] = 667;
    t['adieresis'] = 556;
    t['edieresis'] = 556;
    t['cacute'] = 556;
    t['nacute'] = 611;
    t['umacron'] = 611;
    t['Ncaron'] = 722;
    t['Iacute'] = 278;
    t['plusminus'] = 584;
    t['brokenbar'] = 280;
    t['registered'] = 737;
    t['Gbreve'] = 778;
    t['Idotaccent'] = 278;
    t['summation'] = 600;
    t['Egrave'] = 667;
    t['racute'] = 389;
    t['omacron'] = 611;
    t['Zacute'] = 611;
    t['Zcaron'] = 611;
    t['greaterequal'] = 549;
    t['Eth'] = 722;
    t['Ccedilla'] = 722;
    t['lcommaaccent'] = 278;
    t['tcaron'] = 389;
    t['eogonek'] = 556;
    t['Uogonek'] = 722;
    t['Aacute'] = 722;
    t['Adieresis'] = 722;
    t['egrave'] = 556;
    t['zacute'] = 500;
    t['iogonek'] = 278;
    t['Oacute'] = 778;
    t['oacute'] = 611;
    t['amacron'] = 556;
    t['sacute'] = 556;
    t['idieresis'] = 278;
    t['Ocircumflex'] = 778;
    t['Ugrave'] = 722;
    t['Delta'] = 612;
    t['thorn'] = 611;
    t['twosuperior'] = 333;
    t['Odieresis'] = 778;
    t['mu'] = 611;
    t['igrave'] = 278;
    t['ohungarumlaut'] = 611;
    t['Eogonek'] = 667;
    t['dcroat'] = 611;
    t['threequarters'] = 834;
    t['Scedilla'] = 667;
    t['lcaron'] = 400;
    t['Kcommaaccent'] = 722;
    t['Lacute'] = 611;
    t['trademark'] = 1000;
    t['edotaccent'] = 556;
    t['Igrave'] = 278;
    t['Imacron'] = 278;
    t['Lcaron'] = 611;
    t['onehalf'] = 834;
    t['lessequal'] = 549;
    t['ocircumflex'] = 611;
    t['ntilde'] = 611;
    t['Uhungarumlaut'] = 722;
    t['Eacute'] = 667;
    t['emacron'] = 556;
    t['gbreve'] = 611;
    t['onequarter'] = 834;
    t['Scaron'] = 667;
    t['Scommaaccent'] = 667;
    t['Ohungarumlaut'] = 778;
    t['degree'] = 400;
    t['ograve'] = 611;
    t['Ccaron'] = 722;
    t['ugrave'] = 611;
    t['radical'] = 549;
    t['Dcaron'] = 722;
    t['rcommaaccent'] = 389;
    t['Ntilde'] = 722;
    t['otilde'] = 611;
    t['Rcommaaccent'] = 722;
    t['Lcommaaccent'] = 611;
    t['Atilde'] = 722;
    t['Aogonek'] = 722;
    t['Aring'] = 722;
    t['Otilde'] = 778;
    t['zdotaccent'] = 500;
    t['Ecaron'] = 667;
    t['Iogonek'] = 278;
    t['kcommaaccent'] = 556;
    t['minus'] = 584;
    t['Icircumflex'] = 278;
    t['ncaron'] = 611;
    t['tcommaaccent'] = 333;
    t['logicalnot'] = 584;
    t['odieresis'] = 611;
    t['udieresis'] = 611;
    t['notequal'] = 549;
    t['gcommaaccent'] = 611;
    t['eth'] = 611;
    t['zcaron'] = 500;
    t['ncommaaccent'] = 611;
    t['onesuperior'] = 333;
    t['imacron'] = 278;
    t['Euro'] = 556;
  });
  t['Helvetica-BoldOblique'] = (0, _util.getLookupTableFactory)(function (t) {
    t['space'] = 278;
    t['exclam'] = 333;
    t['quotedbl'] = 474;
    t['numbersign'] = 556;
    t['dollar'] = 556;
    t['percent'] = 889;
    t['ampersand'] = 722;
    t['quoteright'] = 278;
    t['parenleft'] = 333;
    t['parenright'] = 333;
    t['asterisk'] = 389;
    t['plus'] = 584;
    t['comma'] = 278;
    t['hyphen'] = 333;
    t['period'] = 278;
    t['slash'] = 278;
    t['zero'] = 556;
    t['one'] = 556;
    t['two'] = 556;
    t['three'] = 556;
    t['four'] = 556;
    t['five'] = 556;
    t['six'] = 556;
    t['seven'] = 556;
    t['eight'] = 556;
    t['nine'] = 556;
    t['colon'] = 333;
    t['semicolon'] = 333;
    t['less'] = 584;
    t['equal'] = 584;
    t['greater'] = 584;
    t['question'] = 611;
    t['at'] = 975;
    t['A'] = 722;
    t['B'] = 722;
    t['C'] = 722;
    t['D'] = 722;
    t['E'] = 667;
    t['F'] = 611;
    t['G'] = 778;
    t['H'] = 722;
    t['I'] = 278;
    t['J'] = 556;
    t['K'] = 722;
    t['L'] = 611;
    t['M'] = 833;
    t['N'] = 722;
    t['O'] = 778;
    t['P'] = 667;
    t['Q'] = 778;
    t['R'] = 722;
    t['S'] = 667;
    t['T'] = 611;
    t['U'] = 722;
    t['V'] = 667;
    t['W'] = 944;
    t['X'] = 667;
    t['Y'] = 667;
    t['Z'] = 611;
    t['bracketleft'] = 333;
    t['backslash'] = 278;
    t['bracketright'] = 333;
    t['asciicircum'] = 584;
    t['underscore'] = 556;
    t['quoteleft'] = 278;
    t['a'] = 556;
    t['b'] = 611;
    t['c'] = 556;
    t['d'] = 611;
    t['e'] = 556;
    t['f'] = 333;
    t['g'] = 611;
    t['h'] = 611;
    t['i'] = 278;
    t['j'] = 278;
    t['k'] = 556;
    t['l'] = 278;
    t['m'] = 889;
    t['n'] = 611;
    t['o'] = 611;
    t['p'] = 611;
    t['q'] = 611;
    t['r'] = 389;
    t['s'] = 556;
    t['t'] = 333;
    t['u'] = 611;
    t['v'] = 556;
    t['w'] = 778;
    t['x'] = 556;
    t['y'] = 556;
    t['z'] = 500;
    t['braceleft'] = 389;
    t['bar'] = 280;
    t['braceright'] = 389;
    t['asciitilde'] = 584;
    t['exclamdown'] = 333;
    t['cent'] = 556;
    t['sterling'] = 556;
    t['fraction'] = 167;
    t['yen'] = 556;
    t['florin'] = 556;
    t['section'] = 556;
    t['currency'] = 556;
    t['quotesingle'] = 238;
    t['quotedblleft'] = 500;
    t['guillemotleft'] = 556;
    t['guilsinglleft'] = 333;
    t['guilsinglright'] = 333;
    t['fi'] = 611;
    t['fl'] = 611;
    t['endash'] = 556;
    t['dagger'] = 556;
    t['daggerdbl'] = 556;
    t['periodcentered'] = 278;
    t['paragraph'] = 556;
    t['bullet'] = 350;
    t['quotesinglbase'] = 278;
    t['quotedblbase'] = 500;
    t['quotedblright'] = 500;
    t['guillemotright'] = 556;
    t['ellipsis'] = 1000;
    t['perthousand'] = 1000;
    t['questiondown'] = 611;
    t['grave'] = 333;
    t['acute'] = 333;
    t['circumflex'] = 333;
    t['tilde'] = 333;
    t['macron'] = 333;
    t['breve'] = 333;
    t['dotaccent'] = 333;
    t['dieresis'] = 333;
    t['ring'] = 333;
    t['cedilla'] = 333;
    t['hungarumlaut'] = 333;
    t['ogonek'] = 333;
    t['caron'] = 333;
    t['emdash'] = 1000;
    t['AE'] = 1000;
    t['ordfeminine'] = 370;
    t['Lslash'] = 611;
    t['Oslash'] = 778;
    t['OE'] = 1000;
    t['ordmasculine'] = 365;
    t['ae'] = 889;
    t['dotlessi'] = 278;
    t['lslash'] = 278;
    t['oslash'] = 611;
    t['oe'] = 944;
    t['germandbls'] = 611;
    t['Idieresis'] = 278;
    t['eacute'] = 556;
    t['abreve'] = 556;
    t['uhungarumlaut'] = 611;
    t['ecaron'] = 556;
    t['Ydieresis'] = 667;
    t['divide'] = 584;
    t['Yacute'] = 667;
    t['Acircumflex'] = 722;
    t['aacute'] = 556;
    t['Ucircumflex'] = 722;
    t['yacute'] = 556;
    t['scommaaccent'] = 556;
    t['ecircumflex'] = 556;
    t['Uring'] = 722;
    t['Udieresis'] = 722;
    t['aogonek'] = 556;
    t['Uacute'] = 722;
    t['uogonek'] = 611;
    t['Edieresis'] = 667;
    t['Dcroat'] = 722;
    t['commaaccent'] = 250;
    t['copyright'] = 737;
    t['Emacron'] = 667;
    t['ccaron'] = 556;
    t['aring'] = 556;
    t['Ncommaaccent'] = 722;
    t['lacute'] = 278;
    t['agrave'] = 556;
    t['Tcommaaccent'] = 611;
    t['Cacute'] = 722;
    t['atilde'] = 556;
    t['Edotaccent'] = 667;
    t['scaron'] = 556;
    t['scedilla'] = 556;
    t['iacute'] = 278;
    t['lozenge'] = 494;
    t['Rcaron'] = 722;
    t['Gcommaaccent'] = 778;
    t['ucircumflex'] = 611;
    t['acircumflex'] = 556;
    t['Amacron'] = 722;
    t['rcaron'] = 389;
    t['ccedilla'] = 556;
    t['Zdotaccent'] = 611;
    t['Thorn'] = 667;
    t['Omacron'] = 778;
    t['Racute'] = 722;
    t['Sacute'] = 667;
    t['dcaron'] = 743;
    t['Umacron'] = 722;
    t['uring'] = 611;
    t['threesuperior'] = 333;
    t['Ograve'] = 778;
    t['Agrave'] = 722;
    t['Abreve'] = 722;
    t['multiply'] = 584;
    t['uacute'] = 611;
    t['Tcaron'] = 611;
    t['partialdiff'] = 494;
    t['ydieresis'] = 556;
    t['Nacute'] = 722;
    t['icircumflex'] = 278;
    t['Ecircumflex'] = 667;
    t['adieresis'] = 556;
    t['edieresis'] = 556;
    t['cacute'] = 556;
    t['nacute'] = 611;
    t['umacron'] = 611;
    t['Ncaron'] = 722;
    t['Iacute'] = 278;
    t['plusminus'] = 584;
    t['brokenbar'] = 280;
    t['registered'] = 737;
    t['Gbreve'] = 778;
    t['Idotaccent'] = 278;
    t['summation'] = 600;
    t['Egrave'] = 667;
    t['racute'] = 389;
    t['omacron'] = 611;
    t['Zacute'] = 611;
    t['Zcaron'] = 611;
    t['greaterequal'] = 549;
    t['Eth'] = 722;
    t['Ccedilla'] = 722;
    t['lcommaaccent'] = 278;
    t['tcaron'] = 389;
    t['eogonek'] = 556;
    t['Uogonek'] = 722;
    t['Aacute'] = 722;
    t['Adieresis'] = 722;
    t['egrave'] = 556;
    t['zacute'] = 500;
    t['iogonek'] = 278;
    t['Oacute'] = 778;
    t['oacute'] = 611;
    t['amacron'] = 556;
    t['sacute'] = 556;
    t['idieresis'] = 278;
    t['Ocircumflex'] = 778;
    t['Ugrave'] = 722;
    t['Delta'] = 612;
    t['thorn'] = 611;
    t['twosuperior'] = 333;
    t['Odieresis'] = 778;
    t['mu'] = 611;
    t['igrave'] = 278;
    t['ohungarumlaut'] = 611;
    t['Eogonek'] = 667;
    t['dcroat'] = 611;
    t['threequarters'] = 834;
    t['Scedilla'] = 667;
    t['lcaron'] = 400;
    t['Kcommaaccent'] = 722;
    t['Lacute'] = 611;
    t['trademark'] = 1000;
    t['edotaccent'] = 556;
    t['Igrave'] = 278;
    t['Imacron'] = 278;
    t['Lcaron'] = 611;
    t['onehalf'] = 834;
    t['lessequal'] = 549;
    t['ocircumflex'] = 611;
    t['ntilde'] = 611;
    t['Uhungarumlaut'] = 722;
    t['Eacute'] = 667;
    t['emacron'] = 556;
    t['gbreve'] = 611;
    t['onequarter'] = 834;
    t['Scaron'] = 667;
    t['Scommaaccent'] = 667;
    t['Ohungarumlaut'] = 778;
    t['degree'] = 400;
    t['ograve'] = 611;
    t['Ccaron'] = 722;
    t['ugrave'] = 611;
    t['radical'] = 549;
    t['Dcaron'] = 722;
    t['rcommaaccent'] = 389;
    t['Ntilde'] = 722;
    t['otilde'] = 611;
    t['Rcommaaccent'] = 722;
    t['Lcommaaccent'] = 611;
    t['Atilde'] = 722;
    t['Aogonek'] = 722;
    t['Aring'] = 722;
    t['Otilde'] = 778;
    t['zdotaccent'] = 500;
    t['Ecaron'] = 667;
    t['Iogonek'] = 278;
    t['kcommaaccent'] = 556;
    t['minus'] = 584;
    t['Icircumflex'] = 278;
    t['ncaron'] = 611;
    t['tcommaaccent'] = 333;
    t['logicalnot'] = 584;
    t['odieresis'] = 611;
    t['udieresis'] = 611;
    t['notequal'] = 549;
    t['gcommaaccent'] = 611;
    t['eth'] = 611;
    t['zcaron'] = 500;
    t['ncommaaccent'] = 611;
    t['onesuperior'] = 333;
    t['imacron'] = 278;
    t['Euro'] = 556;
  });
  t['Helvetica-Oblique'] = (0, _util.getLookupTableFactory)(function (t) {
    t['space'] = 278;
    t['exclam'] = 278;
    t['quotedbl'] = 355;
    t['numbersign'] = 556;
    t['dollar'] = 556;
    t['percent'] = 889;
    t['ampersand'] = 667;
    t['quoteright'] = 222;
    t['parenleft'] = 333;
    t['parenright'] = 333;
    t['asterisk'] = 389;
    t['plus'] = 584;
    t['comma'] = 278;
    t['hyphen'] = 333;
    t['period'] = 278;
    t['slash'] = 278;
    t['zero'] = 556;
    t['one'] = 556;
    t['two'] = 556;
    t['three'] = 556;
    t['four'] = 556;
    t['five'] = 556;
    t['six'] = 556;
    t['seven'] = 556;
    t['eight'] = 556;
    t['nine'] = 556;
    t['colon'] = 278;
    t['semicolon'] = 278;
    t['less'] = 584;
    t['equal'] = 584;
    t['greater'] = 584;
    t['question'] = 556;
    t['at'] = 1015;
    t['A'] = 667;
    t['B'] = 667;
    t['C'] = 722;
    t['D'] = 722;
    t['E'] = 667;
    t['F'] = 611;
    t['G'] = 778;
    t['H'] = 722;
    t['I'] = 278;
    t['J'] = 500;
    t['K'] = 667;
    t['L'] = 556;
    t['M'] = 833;
    t['N'] = 722;
    t['O'] = 778;
    t['P'] = 667;
    t['Q'] = 778;
    t['R'] = 722;
    t['S'] = 667;
    t['T'] = 611;
    t['U'] = 722;
    t['V'] = 667;
    t['W'] = 944;
    t['X'] = 667;
    t['Y'] = 667;
    t['Z'] = 611;
    t['bracketleft'] = 278;
    t['backslash'] = 278;
    t['bracketright'] = 278;
    t['asciicircum'] = 469;
    t['underscore'] = 556;
    t['quoteleft'] = 222;
    t['a'] = 556;
    t['b'] = 556;
    t['c'] = 500;
    t['d'] = 556;
    t['e'] = 556;
    t['f'] = 278;
    t['g'] = 556;
    t['h'] = 556;
    t['i'] = 222;
    t['j'] = 222;
    t['k'] = 500;
    t['l'] = 222;
    t['m'] = 833;
    t['n'] = 556;
    t['o'] = 556;
    t['p'] = 556;
    t['q'] = 556;
    t['r'] = 333;
    t['s'] = 500;
    t['t'] = 278;
    t['u'] = 556;
    t['v'] = 500;
    t['w'] = 722;
    t['x'] = 500;
    t['y'] = 500;
    t['z'] = 500;
    t['braceleft'] = 334;
    t['bar'] = 260;
    t['braceright'] = 334;
    t['asciitilde'] = 584;
    t['exclamdown'] = 333;
    t['cent'] = 556;
    t['sterling'] = 556;
    t['fraction'] = 167;
    t['yen'] = 556;
    t['florin'] = 556;
    t['section'] = 556;
    t['currency'] = 556;
    t['quotesingle'] = 191;
    t['quotedblleft'] = 333;
    t['guillemotleft'] = 556;
    t['guilsinglleft'] = 333;
    t['guilsinglright'] = 333;
    t['fi'] = 500;
    t['fl'] = 500;
    t['endash'] = 556;
    t['dagger'] = 556;
    t['daggerdbl'] = 556;
    t['periodcentered'] = 278;
    t['paragraph'] = 537;
    t['bullet'] = 350;
    t['quotesinglbase'] = 222;
    t['quotedblbase'] = 333;
    t['quotedblright'] = 333;
    t['guillemotright'] = 556;
    t['ellipsis'] = 1000;
    t['perthousand'] = 1000;
    t['questiondown'] = 611;
    t['grave'] = 333;
    t['acute'] = 333;
    t['circumflex'] = 333;
    t['tilde'] = 333;
    t['macron'] = 333;
    t['breve'] = 333;
    t['dotaccent'] = 333;
    t['dieresis'] = 333;
    t['ring'] = 333;
    t['cedilla'] = 333;
    t['hungarumlaut'] = 333;
    t['ogonek'] = 333;
    t['caron'] = 333;
    t['emdash'] = 1000;
    t['AE'] = 1000;
    t['ordfeminine'] = 370;
    t['Lslash'] = 556;
    t['Oslash'] = 778;
    t['OE'] = 1000;
    t['ordmasculine'] = 365;
    t['ae'] = 889;
    t['dotlessi'] = 278;
    t['lslash'] = 222;
    t['oslash'] = 611;
    t['oe'] = 944;
    t['germandbls'] = 611;
    t['Idieresis'] = 278;
    t['eacute'] = 556;
    t['abreve'] = 556;
    t['uhungarumlaut'] = 556;
    t['ecaron'] = 556;
    t['Ydieresis'] = 667;
    t['divide'] = 584;
    t['Yacute'] = 667;
    t['Acircumflex'] = 667;
    t['aacute'] = 556;
    t['Ucircumflex'] = 722;
    t['yacute'] = 500;
    t['scommaaccent'] = 500;
    t['ecircumflex'] = 556;
    t['Uring'] = 722;
    t['Udieresis'] = 722;
    t['aogonek'] = 556;
    t['Uacute'] = 722;
    t['uogonek'] = 556;
    t['Edieresis'] = 667;
    t['Dcroat'] = 722;
    t['commaaccent'] = 250;
    t['copyright'] = 737;
    t['Emacron'] = 667;
    t['ccaron'] = 500;
    t['aring'] = 556;
    t['Ncommaaccent'] = 722;
    t['lacute'] = 222;
    t['agrave'] = 556;
    t['Tcommaaccent'] = 611;
    t['Cacute'] = 722;
    t['atilde'] = 556;
    t['Edotaccent'] = 667;
    t['scaron'] = 500;
    t['scedilla'] = 500;
    t['iacute'] = 278;
    t['lozenge'] = 471;
    t['Rcaron'] = 722;
    t['Gcommaaccent'] = 778;
    t['ucircumflex'] = 556;
    t['acircumflex'] = 556;
    t['Amacron'] = 667;
    t['rcaron'] = 333;
    t['ccedilla'] = 500;
    t['Zdotaccent'] = 611;
    t['Thorn'] = 667;
    t['Omacron'] = 778;
    t['Racute'] = 722;
    t['Sacute'] = 667;
    t['dcaron'] = 643;
    t['Umacron'] = 722;
    t['uring'] = 556;
    t['threesuperior'] = 333;
    t['Ograve'] = 778;
    t['Agrave'] = 667;
    t['Abreve'] = 667;
    t['multiply'] = 584;
    t['uacute'] = 556;
    t['Tcaron'] = 611;
    t['partialdiff'] = 476;
    t['ydieresis'] = 500;
    t['Nacute'] = 722;
    t['icircumflex'] = 278;
    t['Ecircumflex'] = 667;
    t['adieresis'] = 556;
    t['edieresis'] = 556;
    t['cacute'] = 500;
    t['nacute'] = 556;
    t['umacron'] = 556;
    t['Ncaron'] = 722;
    t['Iacute'] = 278;
    t['plusminus'] = 584;
    t['brokenbar'] = 260;
    t['registered'] = 737;
    t['Gbreve'] = 778;
    t['Idotaccent'] = 278;
    t['summation'] = 600;
    t['Egrave'] = 667;
    t['racute'] = 333;
    t['omacron'] = 556;
    t['Zacute'] = 611;
    t['Zcaron'] = 611;
    t['greaterequal'] = 549;
    t['Eth'] = 722;
    t['Ccedilla'] = 722;
    t['lcommaaccent'] = 222;
    t['tcaron'] = 317;
    t['eogonek'] = 556;
    t['Uogonek'] = 722;
    t['Aacute'] = 667;
    t['Adieresis'] = 667;
    t['egrave'] = 556;
    t['zacute'] = 500;
    t['iogonek'] = 222;
    t['Oacute'] = 778;
    t['oacute'] = 556;
    t['amacron'] = 556;
    t['sacute'] = 500;
    t['idieresis'] = 278;
    t['Ocircumflex'] = 778;
    t['Ugrave'] = 722;
    t['Delta'] = 612;
    t['thorn'] = 556;
    t['twosuperior'] = 333;
    t['Odieresis'] = 778;
    t['mu'] = 556;
    t['igrave'] = 278;
    t['ohungarumlaut'] = 556;
    t['Eogonek'] = 667;
    t['dcroat'] = 556;
    t['threequarters'] = 834;
    t['Scedilla'] = 667;
    t['lcaron'] = 299;
    t['Kcommaaccent'] = 667;
    t['Lacute'] = 556;
    t['trademark'] = 1000;
    t['edotaccent'] = 556;
    t['Igrave'] = 278;
    t['Imacron'] = 278;
    t['Lcaron'] = 556;
    t['onehalf'] = 834;
    t['lessequal'] = 549;
    t['ocircumflex'] = 556;
    t['ntilde'] = 556;
    t['Uhungarumlaut'] = 722;
    t['Eacute'] = 667;
    t['emacron'] = 556;
    t['gbreve'] = 556;
    t['onequarter'] = 834;
    t['Scaron'] = 667;
    t['Scommaaccent'] = 667;
    t['Ohungarumlaut'] = 778;
    t['degree'] = 400;
    t['ograve'] = 556;
    t['Ccaron'] = 722;
    t['ugrave'] = 556;
    t['radical'] = 453;
    t['Dcaron'] = 722;
    t['rcommaaccent'] = 333;
    t['Ntilde'] = 722;
    t['otilde'] = 556;
    t['Rcommaaccent'] = 722;
    t['Lcommaaccent'] = 556;
    t['Atilde'] = 667;
    t['Aogonek'] = 667;
    t['Aring'] = 667;
    t['Otilde'] = 778;
    t['zdotaccent'] = 500;
    t['Ecaron'] = 667;
    t['Iogonek'] = 278;
    t['kcommaaccent'] = 500;
    t['minus'] = 584;
    t['Icircumflex'] = 278;
    t['ncaron'] = 556;
    t['tcommaaccent'] = 278;
    t['logicalnot'] = 584;
    t['odieresis'] = 556;
    t['udieresis'] = 556;
    t['notequal'] = 549;
    t['gcommaaccent'] = 556;
    t['eth'] = 556;
    t['zcaron'] = 500;
    t['ncommaaccent'] = 556;
    t['onesuperior'] = 333;
    t['imacron'] = 278;
    t['Euro'] = 556;
  });
  t['Symbol'] = (0, _util.getLookupTableFactory)(function (t) {
    t['space'] = 250;
    t['exclam'] = 333;
    t['universal'] = 713;
    t['numbersign'] = 500;
    t['existential'] = 549;
    t['percent'] = 833;
    t['ampersand'] = 778;
    t['suchthat'] = 439;
    t['parenleft'] = 333;
    t['parenright'] = 333;
    t['asteriskmath'] = 500;
    t['plus'] = 549;
    t['comma'] = 250;
    t['minus'] = 549;
    t['period'] = 250;
    t['slash'] = 278;
    t['zero'] = 500;
    t['one'] = 500;
    t['two'] = 500;
    t['three'] = 500;
    t['four'] = 500;
    t['five'] = 500;
    t['six'] = 500;
    t['seven'] = 500;
    t['eight'] = 500;
    t['nine'] = 500;
    t['colon'] = 278;
    t['semicolon'] = 278;
    t['less'] = 549;
    t['equal'] = 549;
    t['greater'] = 549;
    t['question'] = 444;
    t['congruent'] = 549;
    t['Alpha'] = 722;
    t['Beta'] = 667;
    t['Chi'] = 722;
    t['Delta'] = 612;
    t['Epsilon'] = 611;
    t['Phi'] = 763;
    t['Gamma'] = 603;
    t['Eta'] = 722;
    t['Iota'] = 333;
    t['theta1'] = 631;
    t['Kappa'] = 722;
    t['Lambda'] = 686;
    t['Mu'] = 889;
    t['Nu'] = 722;
    t['Omicron'] = 722;
    t['Pi'] = 768;
    t['Theta'] = 741;
    t['Rho'] = 556;
    t['Sigma'] = 592;
    t['Tau'] = 611;
    t['Upsilon'] = 690;
    t['sigma1'] = 439;
    t['Omega'] = 768;
    t['Xi'] = 645;
    t['Psi'] = 795;
    t['Zeta'] = 611;
    t['bracketleft'] = 333;
    t['therefore'] = 863;
    t['bracketright'] = 333;
    t['perpendicular'] = 658;
    t['underscore'] = 500;
    t['radicalex'] = 500;
    t['alpha'] = 631;
    t['beta'] = 549;
    t['chi'] = 549;
    t['delta'] = 494;
    t['epsilon'] = 439;
    t['phi'] = 521;
    t['gamma'] = 411;
    t['eta'] = 603;
    t['iota'] = 329;
    t['phi1'] = 603;
    t['kappa'] = 549;
    t['lambda'] = 549;
    t['mu'] = 576;
    t['nu'] = 521;
    t['omicron'] = 549;
    t['pi'] = 549;
    t['theta'] = 521;
    t['rho'] = 549;
    t['sigma'] = 603;
    t['tau'] = 439;
    t['upsilon'] = 576;
    t['omega1'] = 713;
    t['omega'] = 686;
    t['xi'] = 493;
    t['psi'] = 686;
    t['zeta'] = 494;
    t['braceleft'] = 480;
    t['bar'] = 200;
    t['braceright'] = 480;
    t['similar'] = 549;
    t['Euro'] = 750;
    t['Upsilon1'] = 620;
    t['minute'] = 247;
    t['lessequal'] = 549;
    t['fraction'] = 167;
    t['infinity'] = 713;
    t['florin'] = 500;
    t['club'] = 753;
    t['diamond'] = 753;
    t['heart'] = 753;
    t['spade'] = 753;
    t['arrowboth'] = 1042;
    t['arrowleft'] = 987;
    t['arrowup'] = 603;
    t['arrowright'] = 987;
    t['arrowdown'] = 603;
    t['degree'] = 400;
    t['plusminus'] = 549;
    t['second'] = 411;
    t['greaterequal'] = 549;
    t['multiply'] = 549;
    t['proportional'] = 713;
    t['partialdiff'] = 494;
    t['bullet'] = 460;
    t['divide'] = 549;
    t['notequal'] = 549;
    t['equivalence'] = 549;
    t['approxequal'] = 549;
    t['ellipsis'] = 1000;
    t['arrowvertex'] = 603;
    t['arrowhorizex'] = 1000;
    t['carriagereturn'] = 658;
    t['aleph'] = 823;
    t['Ifraktur'] = 686;
    t['Rfraktur'] = 795;
    t['weierstrass'] = 987;
    t['circlemultiply'] = 768;
    t['circleplus'] = 768;
    t['emptyset'] = 823;
    t['intersection'] = 768;
    t['union'] = 768;
    t['propersuperset'] = 713;
    t['reflexsuperset'] = 713;
    t['notsubset'] = 713;
    t['propersubset'] = 713;
    t['reflexsubset'] = 713;
    t['element'] = 713;
    t['notelement'] = 713;
    t['angle'] = 768;
    t['gradient'] = 713;
    t['registerserif'] = 790;
    t['copyrightserif'] = 790;
    t['trademarkserif'] = 890;
    t['product'] = 823;
    t['radical'] = 549;
    t['dotmath'] = 250;
    t['logicalnot'] = 713;
    t['logicaland'] = 603;
    t['logicalor'] = 603;
    t['arrowdblboth'] = 1042;
    t['arrowdblleft'] = 987;
    t['arrowdblup'] = 603;
    t['arrowdblright'] = 987;
    t['arrowdbldown'] = 603;
    t['lozenge'] = 494;
    t['angleleft'] = 329;
    t['registersans'] = 790;
    t['copyrightsans'] = 790;
    t['trademarksans'] = 786;
    t['summation'] = 713;
    t['parenlefttp'] = 384;
    t['parenleftex'] = 384;
    t['parenleftbt'] = 384;
    t['bracketlefttp'] = 384;
    t['bracketleftex'] = 384;
    t['bracketleftbt'] = 384;
    t['bracelefttp'] = 494;
    t['braceleftmid'] = 494;
    t['braceleftbt'] = 494;
    t['braceex'] = 494;
    t['angleright'] = 329;
    t['integral'] = 274;
    t['integraltp'] = 686;
    t['integralex'] = 686;
    t['integralbt'] = 686;
    t['parenrighttp'] = 384;
    t['parenrightex'] = 384;
    t['parenrightbt'] = 384;
    t['bracketrighttp'] = 384;
    t['bracketrightex'] = 384;
    t['bracketrightbt'] = 384;
    t['bracerighttp'] = 494;
    t['bracerightmid'] = 494;
    t['bracerightbt'] = 494;
    t['apple'] = 790;
  });
  t['Times-Roman'] = (0, _util.getLookupTableFactory)(function (t) {
    t['space'] = 250;
    t['exclam'] = 333;
    t['quotedbl'] = 408;
    t['numbersign'] = 500;
    t['dollar'] = 500;
    t['percent'] = 833;
    t['ampersand'] = 778;
    t['quoteright'] = 333;
    t['parenleft'] = 333;
    t['parenright'] = 333;
    t['asterisk'] = 500;
    t['plus'] = 564;
    t['comma'] = 250;
    t['hyphen'] = 333;
    t['period'] = 250;
    t['slash'] = 278;
    t['zero'] = 500;
    t['one'] = 500;
    t['two'] = 500;
    t['three'] = 500;
    t['four'] = 500;
    t['five'] = 500;
    t['six'] = 500;
    t['seven'] = 500;
    t['eight'] = 500;
    t['nine'] = 500;
    t['colon'] = 278;
    t['semicolon'] = 278;
    t['less'] = 564;
    t['equal'] = 564;
    t['greater'] = 564;
    t['question'] = 444;
    t['at'] = 921;
    t['A'] = 722;
    t['B'] = 667;
    t['C'] = 667;
    t['D'] = 722;
    t['E'] = 611;
    t['F'] = 556;
    t['G'] = 722;
    t['H'] = 722;
    t['I'] = 333;
    t['J'] = 389;
    t['K'] = 722;
    t['L'] = 611;
    t['M'] = 889;
    t['N'] = 722;
    t['O'] = 722;
    t['P'] = 556;
    t['Q'] = 722;
    t['R'] = 667;
    t['S'] = 556;
    t['T'] = 611;
    t['U'] = 722;
    t['V'] = 722;
    t['W'] = 944;
    t['X'] = 722;
    t['Y'] = 722;
    t['Z'] = 611;
    t['bracketleft'] = 333;
    t['backslash'] = 278;
    t['bracketright'] = 333;
    t['asciicircum'] = 469;
    t['underscore'] = 500;
    t['quoteleft'] = 333;
    t['a'] = 444;
    t['b'] = 500;
    t['c'] = 444;
    t['d'] = 500;
    t['e'] = 444;
    t['f'] = 333;
    t['g'] = 500;
    t['h'] = 500;
    t['i'] = 278;
    t['j'] = 278;
    t['k'] = 500;
    t['l'] = 278;
    t['m'] = 778;
    t['n'] = 500;
    t['o'] = 500;
    t['p'] = 500;
    t['q'] = 500;
    t['r'] = 333;
    t['s'] = 389;
    t['t'] = 278;
    t['u'] = 500;
    t['v'] = 500;
    t['w'] = 722;
    t['x'] = 500;
    t['y'] = 500;
    t['z'] = 444;
    t['braceleft'] = 480;
    t['bar'] = 200;
    t['braceright'] = 480;
    t['asciitilde'] = 541;
    t['exclamdown'] = 333;
    t['cent'] = 500;
    t['sterling'] = 500;
    t['fraction'] = 167;
    t['yen'] = 500;
    t['florin'] = 500;
    t['section'] = 500;
    t['currency'] = 500;
    t['quotesingle'] = 180;
    t['quotedblleft'] = 444;
    t['guillemotleft'] = 500;
    t['guilsinglleft'] = 333;
    t['guilsinglright'] = 333;
    t['fi'] = 556;
    t['fl'] = 556;
    t['endash'] = 500;
    t['dagger'] = 500;
    t['daggerdbl'] = 500;
    t['periodcentered'] = 250;
    t['paragraph'] = 453;
    t['bullet'] = 350;
    t['quotesinglbase'] = 333;
    t['quotedblbase'] = 444;
    t['quotedblright'] = 444;
    t['guillemotright'] = 500;
    t['ellipsis'] = 1000;
    t['perthousand'] = 1000;
    t['questiondown'] = 444;
    t['grave'] = 333;
    t['acute'] = 333;
    t['circumflex'] = 333;
    t['tilde'] = 333;
    t['macron'] = 333;
    t['breve'] = 333;
    t['dotaccent'] = 333;
    t['dieresis'] = 333;
    t['ring'] = 333;
    t['cedilla'] = 333;
    t['hungarumlaut'] = 333;
    t['ogonek'] = 333;
    t['caron'] = 333;
    t['emdash'] = 1000;
    t['AE'] = 889;
    t['ordfeminine'] = 276;
    t['Lslash'] = 611;
    t['Oslash'] = 722;
    t['OE'] = 889;
    t['ordmasculine'] = 310;
    t['ae'] = 667;
    t['dotlessi'] = 278;
    t['lslash'] = 278;
    t['oslash'] = 500;
    t['oe'] = 722;
    t['germandbls'] = 500;
    t['Idieresis'] = 333;
    t['eacute'] = 444;
    t['abreve'] = 444;
    t['uhungarumlaut'] = 500;
    t['ecaron'] = 444;
    t['Ydieresis'] = 722;
    t['divide'] = 564;
    t['Yacute'] = 722;
    t['Acircumflex'] = 722;
    t['aacute'] = 444;
    t['Ucircumflex'] = 722;
    t['yacute'] = 500;
    t['scommaaccent'] = 389;
    t['ecircumflex'] = 444;
    t['Uring'] = 722;
    t['Udieresis'] = 722;
    t['aogonek'] = 444;
    t['Uacute'] = 722;
    t['uogonek'] = 500;
    t['Edieresis'] = 611;
    t['Dcroat'] = 722;
    t['commaaccent'] = 250;
    t['copyright'] = 760;
    t['Emacron'] = 611;
    t['ccaron'] = 444;
    t['aring'] = 444;
    t['Ncommaaccent'] = 722;
    t['lacute'] = 278;
    t['agrave'] = 444;
    t['Tcommaaccent'] = 611;
    t['Cacute'] = 667;
    t['atilde'] = 444;
    t['Edotaccent'] = 611;
    t['scaron'] = 389;
    t['scedilla'] = 389;
    t['iacute'] = 278;
    t['lozenge'] = 471;
    t['Rcaron'] = 667;
    t['Gcommaaccent'] = 722;
    t['ucircumflex'] = 500;
    t['acircumflex'] = 444;
    t['Amacron'] = 722;
    t['rcaron'] = 333;
    t['ccedilla'] = 444;
    t['Zdotaccent'] = 611;
    t['Thorn'] = 556;
    t['Omacron'] = 722;
    t['Racute'] = 667;
    t['Sacute'] = 556;
    t['dcaron'] = 588;
    t['Umacron'] = 722;
    t['uring'] = 500;
    t['threesuperior'] = 300;
    t['Ograve'] = 722;
    t['Agrave'] = 722;
    t['Abreve'] = 722;
    t['multiply'] = 564;
    t['uacute'] = 500;
    t['Tcaron'] = 611;
    t['partialdiff'] = 476;
    t['ydieresis'] = 500;
    t['Nacute'] = 722;
    t['icircumflex'] = 278;
    t['Ecircumflex'] = 611;
    t['adieresis'] = 444;
    t['edieresis'] = 444;
    t['cacute'] = 444;
    t['nacute'] = 500;
    t['umacron'] = 500;
    t['Ncaron'] = 722;
    t['Iacute'] = 333;
    t['plusminus'] = 564;
    t['brokenbar'] = 200;
    t['registered'] = 760;
    t['Gbreve'] = 722;
    t['Idotaccent'] = 333;
    t['summation'] = 600;
    t['Egrave'] = 611;
    t['racute'] = 333;
    t['omacron'] = 500;
    t['Zacute'] = 611;
    t['Zcaron'] = 611;
    t['greaterequal'] = 549;
    t['Eth'] = 722;
    t['Ccedilla'] = 667;
    t['lcommaaccent'] = 278;
    t['tcaron'] = 326;
    t['eogonek'] = 444;
    t['Uogonek'] = 722;
    t['Aacute'] = 722;
    t['Adieresis'] = 722;
    t['egrave'] = 444;
    t['zacute'] = 444;
    t['iogonek'] = 278;
    t['Oacute'] = 722;
    t['oacute'] = 500;
    t['amacron'] = 444;
    t['sacute'] = 389;
    t['idieresis'] = 278;
    t['Ocircumflex'] = 722;
    t['Ugrave'] = 722;
    t['Delta'] = 612;
    t['thorn'] = 500;
    t['twosuperior'] = 300;
    t['Odieresis'] = 722;
    t['mu'] = 500;
    t['igrave'] = 278;
    t['ohungarumlaut'] = 500;
    t['Eogonek'] = 611;
    t['dcroat'] = 500;
    t['threequarters'] = 750;
    t['Scedilla'] = 556;
    t['lcaron'] = 344;
    t['Kcommaaccent'] = 722;
    t['Lacute'] = 611;
    t['trademark'] = 980;
    t['edotaccent'] = 444;
    t['Igrave'] = 333;
    t['Imacron'] = 333;
    t['Lcaron'] = 611;
    t['onehalf'] = 750;
    t['lessequal'] = 549;
    t['ocircumflex'] = 500;
    t['ntilde'] = 500;
    t['Uhungarumlaut'] = 722;
    t['Eacute'] = 611;
    t['emacron'] = 444;
    t['gbreve'] = 500;
    t['onequarter'] = 750;
    t['Scaron'] = 556;
    t['Scommaaccent'] = 556;
    t['Ohungarumlaut'] = 722;
    t['degree'] = 400;
    t['ograve'] = 500;
    t['Ccaron'] = 667;
    t['ugrave'] = 500;
    t['radical'] = 453;
    t['Dcaron'] = 722;
    t['rcommaaccent'] = 333;
    t['Ntilde'] = 722;
    t['otilde'] = 500;
    t['Rcommaaccent'] = 667;
    t['Lcommaaccent'] = 611;
    t['Atilde'] = 722;
    t['Aogonek'] = 722;
    t['Aring'] = 722;
    t['Otilde'] = 722;
    t['zdotaccent'] = 444;
    t['Ecaron'] = 611;
    t['Iogonek'] = 333;
    t['kcommaaccent'] = 500;
    t['minus'] = 564;
    t['Icircumflex'] = 333;
    t['ncaron'] = 500;
    t['tcommaaccent'] = 278;
    t['logicalnot'] = 564;
    t['odieresis'] = 500;
    t['udieresis'] = 500;
    t['notequal'] = 549;
    t['gcommaaccent'] = 500;
    t['eth'] = 500;
    t['zcaron'] = 444;
    t['ncommaaccent'] = 500;
    t['onesuperior'] = 300;
    t['imacron'] = 278;
    t['Euro'] = 500;
  });
  t['Times-Bold'] = (0, _util.getLookupTableFactory)(function (t) {
    t['space'] = 250;
    t['exclam'] = 333;
    t['quotedbl'] = 555;
    t['numbersign'] = 500;
    t['dollar'] = 500;
    t['percent'] = 1000;
    t['ampersand'] = 833;
    t['quoteright'] = 333;
    t['parenleft'] = 333;
    t['parenright'] = 333;
    t['asterisk'] = 500;
    t['plus'] = 570;
    t['comma'] = 250;
    t['hyphen'] = 333;
    t['period'] = 250;
    t['slash'] = 278;
    t['zero'] = 500;
    t['one'] = 500;
    t['two'] = 500;
    t['three'] = 500;
    t['four'] = 500;
    t['five'] = 500;
    t['six'] = 500;
    t['seven'] = 500;
    t['eight'] = 500;
    t['nine'] = 500;
    t['colon'] = 333;
    t['semicolon'] = 333;
    t['less'] = 570;
    t['equal'] = 570;
    t['greater'] = 570;
    t['question'] = 500;
    t['at'] = 930;
    t['A'] = 722;
    t['B'] = 667;
    t['C'] = 722;
    t['D'] = 722;
    t['E'] = 667;
    t['F'] = 611;
    t['G'] = 778;
    t['H'] = 778;
    t['I'] = 389;
    t['J'] = 500;
    t['K'] = 778;
    t['L'] = 667;
    t['M'] = 944;
    t['N'] = 722;
    t['O'] = 778;
    t['P'] = 611;
    t['Q'] = 778;
    t['R'] = 722;
    t['S'] = 556;
    t['T'] = 667;
    t['U'] = 722;
    t['V'] = 722;
    t['W'] = 1000;
    t['X'] = 722;
    t['Y'] = 722;
    t['Z'] = 667;
    t['bracketleft'] = 333;
    t['backslash'] = 278;
    t['bracketright'] = 333;
    t['asciicircum'] = 581;
    t['underscore'] = 500;
    t['quoteleft'] = 333;
    t['a'] = 500;
    t['b'] = 556;
    t['c'] = 444;
    t['d'] = 556;
    t['e'] = 444;
    t['f'] = 333;
    t['g'] = 500;
    t['h'] = 556;
    t['i'] = 278;
    t['j'] = 333;
    t['k'] = 556;
    t['l'] = 278;
    t['m'] = 833;
    t['n'] = 556;
    t['o'] = 500;
    t['p'] = 556;
    t['q'] = 556;
    t['r'] = 444;
    t['s'] = 389;
    t['t'] = 333;
    t['u'] = 556;
    t['v'] = 500;
    t['w'] = 722;
    t['x'] = 500;
    t['y'] = 500;
    t['z'] = 444;
    t['braceleft'] = 394;
    t['bar'] = 220;
    t['braceright'] = 394;
    t['asciitilde'] = 520;
    t['exclamdown'] = 333;
    t['cent'] = 500;
    t['sterling'] = 500;
    t['fraction'] = 167;
    t['yen'] = 500;
    t['florin'] = 500;
    t['section'] = 500;
    t['currency'] = 500;
    t['quotesingle'] = 278;
    t['quotedblleft'] = 500;
    t['guillemotleft'] = 500;
    t['guilsinglleft'] = 333;
    t['guilsinglright'] = 333;
    t['fi'] = 556;
    t['fl'] = 556;
    t['endash'] = 500;
    t['dagger'] = 500;
    t['daggerdbl'] = 500;
    t['periodcentered'] = 250;
    t['paragraph'] = 540;
    t['bullet'] = 350;
    t['quotesinglbase'] = 333;
    t['quotedblbase'] = 500;
    t['quotedblright'] = 500;
    t['guillemotright'] = 500;
    t['ellipsis'] = 1000;
    t['perthousand'] = 1000;
    t['questiondown'] = 500;
    t['grave'] = 333;
    t['acute'] = 333;
    t['circumflex'] = 333;
    t['tilde'] = 333;
    t['macron'] = 333;
    t['breve'] = 333;
    t['dotaccent'] = 333;
    t['dieresis'] = 333;
    t['ring'] = 333;
    t['cedilla'] = 333;
    t['hungarumlaut'] = 333;
    t['ogonek'] = 333;
    t['caron'] = 333;
    t['emdash'] = 1000;
    t['AE'] = 1000;
    t['ordfeminine'] = 300;
    t['Lslash'] = 667;
    t['Oslash'] = 778;
    t['OE'] = 1000;
    t['ordmasculine'] = 330;
    t['ae'] = 722;
    t['dotlessi'] = 278;
    t['lslash'] = 278;
    t['oslash'] = 500;
    t['oe'] = 722;
    t['germandbls'] = 556;
    t['Idieresis'] = 389;
    t['eacute'] = 444;
    t['abreve'] = 500;
    t['uhungarumlaut'] = 556;
    t['ecaron'] = 444;
    t['Ydieresis'] = 722;
    t['divide'] = 570;
    t['Yacute'] = 722;
    t['Acircumflex'] = 722;
    t['aacute'] = 500;
    t['Ucircumflex'] = 722;
    t['yacute'] = 500;
    t['scommaaccent'] = 389;
    t['ecircumflex'] = 444;
    t['Uring'] = 722;
    t['Udieresis'] = 722;
    t['aogonek'] = 500;
    t['Uacute'] = 722;
    t['uogonek'] = 556;
    t['Edieresis'] = 667;
    t['Dcroat'] = 722;
    t['commaaccent'] = 250;
    t['copyright'] = 747;
    t['Emacron'] = 667;
    t['ccaron'] = 444;
    t['aring'] = 500;
    t['Ncommaaccent'] = 722;
    t['lacute'] = 278;
    t['agrave'] = 500;
    t['Tcommaaccent'] = 667;
    t['Cacute'] = 722;
    t['atilde'] = 500;
    t['Edotaccent'] = 667;
    t['scaron'] = 389;
    t['scedilla'] = 389;
    t['iacute'] = 278;
    t['lozenge'] = 494;
    t['Rcaron'] = 722;
    t['Gcommaaccent'] = 778;
    t['ucircumflex'] = 556;
    t['acircumflex'] = 500;
    t['Amacron'] = 722;
    t['rcaron'] = 444;
    t['ccedilla'] = 444;
    t['Zdotaccent'] = 667;
    t['Thorn'] = 611;
    t['Omacron'] = 778;
    t['Racute'] = 722;
    t['Sacute'] = 556;
    t['dcaron'] = 672;
    t['Umacron'] = 722;
    t['uring'] = 556;
    t['threesuperior'] = 300;
    t['Ograve'] = 778;
    t['Agrave'] = 722;
    t['Abreve'] = 722;
    t['multiply'] = 570;
    t['uacute'] = 556;
    t['Tcaron'] = 667;
    t['partialdiff'] = 494;
    t['ydieresis'] = 500;
    t['Nacute'] = 722;
    t['icircumflex'] = 278;
    t['Ecircumflex'] = 667;
    t['adieresis'] = 500;
    t['edieresis'] = 444;
    t['cacute'] = 444;
    t['nacute'] = 556;
    t['umacron'] = 556;
    t['Ncaron'] = 722;
    t['Iacute'] = 389;
    t['plusminus'] = 570;
    t['brokenbar'] = 220;
    t['registered'] = 747;
    t['Gbreve'] = 778;
    t['Idotaccent'] = 389;
    t['summation'] = 600;
    t['Egrave'] = 667;
    t['racute'] = 444;
    t['omacron'] = 500;
    t['Zacute'] = 667;
    t['Zcaron'] = 667;
    t['greaterequal'] = 549;
    t['Eth'] = 722;
    t['Ccedilla'] = 722;
    t['lcommaaccent'] = 278;
    t['tcaron'] = 416;
    t['eogonek'] = 444;
    t['Uogonek'] = 722;
    t['Aacute'] = 722;
    t['Adieresis'] = 722;
    t['egrave'] = 444;
    t['zacute'] = 444;
    t['iogonek'] = 278;
    t['Oacute'] = 778;
    t['oacute'] = 500;
    t['amacron'] = 500;
    t['sacute'] = 389;
    t['idieresis'] = 278;
    t['Ocircumflex'] = 778;
    t['Ugrave'] = 722;
    t['Delta'] = 612;
    t['thorn'] = 556;
    t['twosuperior'] = 300;
    t['Odieresis'] = 778;
    t['mu'] = 556;
    t['igrave'] = 278;
    t['ohungarumlaut'] = 500;
    t['Eogonek'] = 667;
    t['dcroat'] = 556;
    t['threequarters'] = 750;
    t['Scedilla'] = 556;
    t['lcaron'] = 394;
    t['Kcommaaccent'] = 778;
    t['Lacute'] = 667;
    t['trademark'] = 1000;
    t['edotaccent'] = 444;
    t['Igrave'] = 389;
    t['Imacron'] = 389;
    t['Lcaron'] = 667;
    t['onehalf'] = 750;
    t['lessequal'] = 549;
    t['ocircumflex'] = 500;
    t['ntilde'] = 556;
    t['Uhungarumlaut'] = 722;
    t['Eacute'] = 667;
    t['emacron'] = 444;
    t['gbreve'] = 500;
    t['onequarter'] = 750;
    t['Scaron'] = 556;
    t['Scommaaccent'] = 556;
    t['Ohungarumlaut'] = 778;
    t['degree'] = 400;
    t['ograve'] = 500;
    t['Ccaron'] = 722;
    t['ugrave'] = 556;
    t['radical'] = 549;
    t['Dcaron'] = 722;
    t['rcommaaccent'] = 444;
    t['Ntilde'] = 722;
    t['otilde'] = 500;
    t['Rcommaaccent'] = 722;
    t['Lcommaaccent'] = 667;
    t['Atilde'] = 722;
    t['Aogonek'] = 722;
    t['Aring'] = 722;
    t['Otilde'] = 778;
    t['zdotaccent'] = 444;
    t['Ecaron'] = 667;
    t['Iogonek'] = 389;
    t['kcommaaccent'] = 556;
    t['minus'] = 570;
    t['Icircumflex'] = 389;
    t['ncaron'] = 556;
    t['tcommaaccent'] = 333;
    t['logicalnot'] = 570;
    t['odieresis'] = 500;
    t['udieresis'] = 556;
    t['notequal'] = 549;
    t['gcommaaccent'] = 500;
    t['eth'] = 500;
    t['zcaron'] = 444;
    t['ncommaaccent'] = 556;
    t['onesuperior'] = 300;
    t['imacron'] = 278;
    t['Euro'] = 500;
  });
  t['Times-BoldItalic'] = (0, _util.getLookupTableFactory)(function (t) {
    t['space'] = 250;
    t['exclam'] = 389;
    t['quotedbl'] = 555;
    t['numbersign'] = 500;
    t['dollar'] = 500;
    t['percent'] = 833;
    t['ampersand'] = 778;
    t['quoteright'] = 333;
    t['parenleft'] = 333;
    t['parenright'] = 333;
    t['asterisk'] = 500;
    t['plus'] = 570;
    t['comma'] = 250;
    t['hyphen'] = 333;
    t['period'] = 250;
    t['slash'] = 278;
    t['zero'] = 500;
    t['one'] = 500;
    t['two'] = 500;
    t['three'] = 500;
    t['four'] = 500;
    t['five'] = 500;
    t['six'] = 500;
    t['seven'] = 500;
    t['eight'] = 500;
    t['nine'] = 500;
    t['colon'] = 333;
    t['semicolon'] = 333;
    t['less'] = 570;
    t['equal'] = 570;
    t['greater'] = 570;
    t['question'] = 500;
    t['at'] = 832;
    t['A'] = 667;
    t['B'] = 667;
    t['C'] = 667;
    t['D'] = 722;
    t['E'] = 667;
    t['F'] = 667;
    t['G'] = 722;
    t['H'] = 778;
    t['I'] = 389;
    t['J'] = 500;
    t['K'] = 667;
    t['L'] = 611;
    t['M'] = 889;
    t['N'] = 722;
    t['O'] = 722;
    t['P'] = 611;
    t['Q'] = 722;
    t['R'] = 667;
    t['S'] = 556;
    t['T'] = 611;
    t['U'] = 722;
    t['V'] = 667;
    t['W'] = 889;
    t['X'] = 667;
    t['Y'] = 611;
    t['Z'] = 611;
    t['bracketleft'] = 333;
    t['backslash'] = 278;
    t['bracketright'] = 333;
    t['asciicircum'] = 570;
    t['underscore'] = 500;
    t['quoteleft'] = 333;
    t['a'] = 500;
    t['b'] = 500;
    t['c'] = 444;
    t['d'] = 500;
    t['e'] = 444;
    t['f'] = 333;
    t['g'] = 500;
    t['h'] = 556;
    t['i'] = 278;
    t['j'] = 278;
    t['k'] = 500;
    t['l'] = 278;
    t['m'] = 778;
    t['n'] = 556;
    t['o'] = 500;
    t['p'] = 500;
    t['q'] = 500;
    t['r'] = 389;
    t['s'] = 389;
    t['t'] = 278;
    t['u'] = 556;
    t['v'] = 444;
    t['w'] = 667;
    t['x'] = 500;
    t['y'] = 444;
    t['z'] = 389;
    t['braceleft'] = 348;
    t['bar'] = 220;
    t['braceright'] = 348;
    t['asciitilde'] = 570;
    t['exclamdown'] = 389;
    t['cent'] = 500;
    t['sterling'] = 500;
    t['fraction'] = 167;
    t['yen'] = 500;
    t['florin'] = 500;
    t['section'] = 500;
    t['currency'] = 500;
    t['quotesingle'] = 278;
    t['quotedblleft'] = 500;
    t['guillemotleft'] = 500;
    t['guilsinglleft'] = 333;
    t['guilsinglright'] = 333;
    t['fi'] = 556;
    t['fl'] = 556;
    t['endash'] = 500;
    t['dagger'] = 500;
    t['daggerdbl'] = 500;
    t['periodcentered'] = 250;
    t['paragraph'] = 500;
    t['bullet'] = 350;
    t['quotesinglbase'] = 333;
    t['quotedblbase'] = 500;
    t['quotedblright'] = 500;
    t['guillemotright'] = 500;
    t['ellipsis'] = 1000;
    t['perthousand'] = 1000;
    t['questiondown'] = 500;
    t['grave'] = 333;
    t['acute'] = 333;
    t['circumflex'] = 333;
    t['tilde'] = 333;
    t['macron'] = 333;
    t['breve'] = 333;
    t['dotaccent'] = 333;
    t['dieresis'] = 333;
    t['ring'] = 333;
    t['cedilla'] = 333;
    t['hungarumlaut'] = 333;
    t['ogonek'] = 333;
    t['caron'] = 333;
    t['emdash'] = 1000;
    t['AE'] = 944;
    t['ordfeminine'] = 266;
    t['Lslash'] = 611;
    t['Oslash'] = 722;
    t['OE'] = 944;
    t['ordmasculine'] = 300;
    t['ae'] = 722;
    t['dotlessi'] = 278;
    t['lslash'] = 278;
    t['oslash'] = 500;
    t['oe'] = 722;
    t['germandbls'] = 500;
    t['Idieresis'] = 389;
    t['eacute'] = 444;
    t['abreve'] = 500;
    t['uhungarumlaut'] = 556;
    t['ecaron'] = 444;
    t['Ydieresis'] = 611;
    t['divide'] = 570;
    t['Yacute'] = 611;
    t['Acircumflex'] = 667;
    t['aacute'] = 500;
    t['Ucircumflex'] = 722;
    t['yacute'] = 444;
    t['scommaaccent'] = 389;
    t['ecircumflex'] = 444;
    t['Uring'] = 722;
    t['Udieresis'] = 722;
    t['aogonek'] = 500;
    t['Uacute'] = 722;
    t['uogonek'] = 556;
    t['Edieresis'] = 667;
    t['Dcroat'] = 722;
    t['commaaccent'] = 250;
    t['copyright'] = 747;
    t['Emacron'] = 667;
    t['ccaron'] = 444;
    t['aring'] = 500;
    t['Ncommaaccent'] = 722;
    t['lacute'] = 278;
    t['agrave'] = 500;
    t['Tcommaaccent'] = 611;
    t['Cacute'] = 667;
    t['atilde'] = 500;
    t['Edotaccent'] = 667;
    t['scaron'] = 389;
    t['scedilla'] = 389;
    t['iacute'] = 278;
    t['lozenge'] = 494;
    t['Rcaron'] = 667;
    t['Gcommaaccent'] = 722;
    t['ucircumflex'] = 556;
    t['acircumflex'] = 500;
    t['Amacron'] = 667;
    t['rcaron'] = 389;
    t['ccedilla'] = 444;
    t['Zdotaccent'] = 611;
    t['Thorn'] = 611;
    t['Omacron'] = 722;
    t['Racute'] = 667;
    t['Sacute'] = 556;
    t['dcaron'] = 608;
    t['Umacron'] = 722;
    t['uring'] = 556;
    t['threesuperior'] = 300;
    t['Ograve'] = 722;
    t['Agrave'] = 667;
    t['Abreve'] = 667;
    t['multiply'] = 570;
    t['uacute'] = 556;
    t['Tcaron'] = 611;
    t['partialdiff'] = 494;
    t['ydieresis'] = 444;
    t['Nacute'] = 722;
    t['icircumflex'] = 278;
    t['Ecircumflex'] = 667;
    t['adieresis'] = 500;
    t['edieresis'] = 444;
    t['cacute'] = 444;
    t['nacute'] = 556;
    t['umacron'] = 556;
    t['Ncaron'] = 722;
    t['Iacute'] = 389;
    t['plusminus'] = 570;
    t['brokenbar'] = 220;
    t['registered'] = 747;
    t['Gbreve'] = 722;
    t['Idotaccent'] = 389;
    t['summation'] = 600;
    t['Egrave'] = 667;
    t['racute'] = 389;
    t['omacron'] = 500;
    t['Zacute'] = 611;
    t['Zcaron'] = 611;
    t['greaterequal'] = 549;
    t['Eth'] = 722;
    t['Ccedilla'] = 667;
    t['lcommaaccent'] = 278;
    t['tcaron'] = 366;
    t['eogonek'] = 444;
    t['Uogonek'] = 722;
    t['Aacute'] = 667;
    t['Adieresis'] = 667;
    t['egrave'] = 444;
    t['zacute'] = 389;
    t['iogonek'] = 278;
    t['Oacute'] = 722;
    t['oacute'] = 500;
    t['amacron'] = 500;
    t['sacute'] = 389;
    t['idieresis'] = 278;
    t['Ocircumflex'] = 722;
    t['Ugrave'] = 722;
    t['Delta'] = 612;
    t['thorn'] = 500;
    t['twosuperior'] = 300;
    t['Odieresis'] = 722;
    t['mu'] = 576;
    t['igrave'] = 278;
    t['ohungarumlaut'] = 500;
    t['Eogonek'] = 667;
    t['dcroat'] = 500;
    t['threequarters'] = 750;
    t['Scedilla'] = 556;
    t['lcaron'] = 382;
    t['Kcommaaccent'] = 667;
    t['Lacute'] = 611;
    t['trademark'] = 1000;
    t['edotaccent'] = 444;
    t['Igrave'] = 389;
    t['Imacron'] = 389;
    t['Lcaron'] = 611;
    t['onehalf'] = 750;
    t['lessequal'] = 549;
    t['ocircumflex'] = 500;
    t['ntilde'] = 556;
    t['Uhungarumlaut'] = 722;
    t['Eacute'] = 667;
    t['emacron'] = 444;
    t['gbreve'] = 500;
    t['onequarter'] = 750;
    t['Scaron'] = 556;
    t['Scommaaccent'] = 556;
    t['Ohungarumlaut'] = 722;
    t['degree'] = 400;
    t['ograve'] = 500;
    t['Ccaron'] = 667;
    t['ugrave'] = 556;
    t['radical'] = 549;
    t['Dcaron'] = 722;
    t['rcommaaccent'] = 389;
    t['Ntilde'] = 722;
    t['otilde'] = 500;
    t['Rcommaaccent'] = 667;
    t['Lcommaaccent'] = 611;
    t['Atilde'] = 667;
    t['Aogonek'] = 667;
    t['Aring'] = 667;
    t['Otilde'] = 722;
    t['zdotaccent'] = 389;
    t['Ecaron'] = 667;
    t['Iogonek'] = 389;
    t['kcommaaccent'] = 500;
    t['minus'] = 606;
    t['Icircumflex'] = 389;
    t['ncaron'] = 556;
    t['tcommaaccent'] = 278;
    t['logicalnot'] = 606;
    t['odieresis'] = 500;
    t['udieresis'] = 556;
    t['notequal'] = 549;
    t['gcommaaccent'] = 500;
    t['eth'] = 500;
    t['zcaron'] = 389;
    t['ncommaaccent'] = 556;
    t['onesuperior'] = 300;
    t['imacron'] = 278;
    t['Euro'] = 500;
  });
  t['Times-Italic'] = (0, _util.getLookupTableFactory)(function (t) {
    t['space'] = 250;
    t['exclam'] = 333;
    t['quotedbl'] = 420;
    t['numbersign'] = 500;
    t['dollar'] = 500;
    t['percent'] = 833;
    t['ampersand'] = 778;
    t['quoteright'] = 333;
    t['parenleft'] = 333;
    t['parenright'] = 333;
    t['asterisk'] = 500;
    t['plus'] = 675;
    t['comma'] = 250;
    t['hyphen'] = 333;
    t['period'] = 250;
    t['slash'] = 278;
    t['zero'] = 500;
    t['one'] = 500;
    t['two'] = 500;
    t['three'] = 500;
    t['four'] = 500;
    t['five'] = 500;
    t['six'] = 500;
    t['seven'] = 500;
    t['eight'] = 500;
    t['nine'] = 500;
    t['colon'] = 333;
    t['semicolon'] = 333;
    t['less'] = 675;
    t['equal'] = 675;
    t['greater'] = 675;
    t['question'] = 500;
    t['at'] = 920;
    t['A'] = 611;
    t['B'] = 611;
    t['C'] = 667;
    t['D'] = 722;
    t['E'] = 611;
    t['F'] = 611;
    t['G'] = 722;
    t['H'] = 722;
    t['I'] = 333;
    t['J'] = 444;
    t['K'] = 667;
    t['L'] = 556;
    t['M'] = 833;
    t['N'] = 667;
    t['O'] = 722;
    t['P'] = 611;
    t['Q'] = 722;
    t['R'] = 611;
    t['S'] = 500;
    t['T'] = 556;
    t['U'] = 722;
    t['V'] = 611;
    t['W'] = 833;
    t['X'] = 611;
    t['Y'] = 556;
    t['Z'] = 556;
    t['bracketleft'] = 389;
    t['backslash'] = 278;
    t['bracketright'] = 389;
    t['asciicircum'] = 422;
    t['underscore'] = 500;
    t['quoteleft'] = 333;
    t['a'] = 500;
    t['b'] = 500;
    t['c'] = 444;
    t['d'] = 500;
    t['e'] = 444;
    t['f'] = 278;
    t['g'] = 500;
    t['h'] = 500;
    t['i'] = 278;
    t['j'] = 278;
    t['k'] = 444;
    t['l'] = 278;
    t['m'] = 722;
    t['n'] = 500;
    t['o'] = 500;
    t['p'] = 500;
    t['q'] = 500;
    t['r'] = 389;
    t['s'] = 389;
    t['t'] = 278;
    t['u'] = 500;
    t['v'] = 444;
    t['w'] = 667;
    t['x'] = 444;
    t['y'] = 444;
    t['z'] = 389;
    t['braceleft'] = 400;
    t['bar'] = 275;
    t['braceright'] = 400;
    t['asciitilde'] = 541;
    t['exclamdown'] = 389;
    t['cent'] = 500;
    t['sterling'] = 500;
    t['fraction'] = 167;
    t['yen'] = 500;
    t['florin'] = 500;
    t['section'] = 500;
    t['currency'] = 500;
    t['quotesingle'] = 214;
    t['quotedblleft'] = 556;
    t['guillemotleft'] = 500;
    t['guilsinglleft'] = 333;
    t['guilsinglright'] = 333;
    t['fi'] = 500;
    t['fl'] = 500;
    t['endash'] = 500;
    t['dagger'] = 500;
    t['daggerdbl'] = 500;
    t['periodcentered'] = 250;
    t['paragraph'] = 523;
    t['bullet'] = 350;
    t['quotesinglbase'] = 333;
    t['quotedblbase'] = 556;
    t['quotedblright'] = 556;
    t['guillemotright'] = 500;
    t['ellipsis'] = 889;
    t['perthousand'] = 1000;
    t['questiondown'] = 500;
    t['grave'] = 333;
    t['acute'] = 333;
    t['circumflex'] = 333;
    t['tilde'] = 333;
    t['macron'] = 333;
    t['breve'] = 333;
    t['dotaccent'] = 333;
    t['dieresis'] = 333;
    t['ring'] = 333;
    t['cedilla'] = 333;
    t['hungarumlaut'] = 333;
    t['ogonek'] = 333;
    t['caron'] = 333;
    t['emdash'] = 889;
    t['AE'] = 889;
    t['ordfeminine'] = 276;
    t['Lslash'] = 556;
    t['Oslash'] = 722;
    t['OE'] = 944;
    t['ordmasculine'] = 310;
    t['ae'] = 667;
    t['dotlessi'] = 278;
    t['lslash'] = 278;
    t['oslash'] = 500;
    t['oe'] = 667;
    t['germandbls'] = 500;
    t['Idieresis'] = 333;
    t['eacute'] = 444;
    t['abreve'] = 500;
    t['uhungarumlaut'] = 500;
    t['ecaron'] = 444;
    t['Ydieresis'] = 556;
    t['divide'] = 675;
    t['Yacute'] = 556;
    t['Acircumflex'] = 611;
    t['aacute'] = 500;
    t['Ucircumflex'] = 722;
    t['yacute'] = 444;
    t['scommaaccent'] = 389;
    t['ecircumflex'] = 444;
    t['Uring'] = 722;
    t['Udieresis'] = 722;
    t['aogonek'] = 500;
    t['Uacute'] = 722;
    t['uogonek'] = 500;
    t['Edieresis'] = 611;
    t['Dcroat'] = 722;
    t['commaaccent'] = 250;
    t['copyright'] = 760;
    t['Emacron'] = 611;
    t['ccaron'] = 444;
    t['aring'] = 500;
    t['Ncommaaccent'] = 667;
    t['lacute'] = 278;
    t['agrave'] = 500;
    t['Tcommaaccent'] = 556;
    t['Cacute'] = 667;
    t['atilde'] = 500;
    t['Edotaccent'] = 611;
    t['scaron'] = 389;
    t['scedilla'] = 389;
    t['iacute'] = 278;
    t['lozenge'] = 471;
    t['Rcaron'] = 611;
    t['Gcommaaccent'] = 722;
    t['ucircumflex'] = 500;
    t['acircumflex'] = 500;
    t['Amacron'] = 611;
    t['rcaron'] = 389;
    t['ccedilla'] = 444;
    t['Zdotaccent'] = 556;
    t['Thorn'] = 611;
    t['Omacron'] = 722;
    t['Racute'] = 611;
    t['Sacute'] = 500;
    t['dcaron'] = 544;
    t['Umacron'] = 722;
    t['uring'] = 500;
    t['threesuperior'] = 300;
    t['Ograve'] = 722;
    t['Agrave'] = 611;
    t['Abreve'] = 611;
    t['multiply'] = 675;
    t['uacute'] = 500;
    t['Tcaron'] = 556;
    t['partialdiff'] = 476;
    t['ydieresis'] = 444;
    t['Nacute'] = 667;
    t['icircumflex'] = 278;
    t['Ecircumflex'] = 611;
    t['adieresis'] = 500;
    t['edieresis'] = 444;
    t['cacute'] = 444;
    t['nacute'] = 500;
    t['umacron'] = 500;
    t['Ncaron'] = 667;
    t['Iacute'] = 333;
    t['plusminus'] = 675;
    t['brokenbar'] = 275;
    t['registered'] = 760;
    t['Gbreve'] = 722;
    t['Idotaccent'] = 333;
    t['summation'] = 600;
    t['Egrave'] = 611;
    t['racute'] = 389;
    t['omacron'] = 500;
    t['Zacute'] = 556;
    t['Zcaron'] = 556;
    t['greaterequal'] = 549;
    t['Eth'] = 722;
    t['Ccedilla'] = 667;
    t['lcommaaccent'] = 278;
    t['tcaron'] = 300;
    t['eogonek'] = 444;
    t['Uogonek'] = 722;
    t['Aacute'] = 611;
    t['Adieresis'] = 611;
    t['egrave'] = 444;
    t['zacute'] = 389;
    t['iogonek'] = 278;
    t['Oacute'] = 722;
    t['oacute'] = 500;
    t['amacron'] = 500;
    t['sacute'] = 389;
    t['idieresis'] = 278;
    t['Ocircumflex'] = 722;
    t['Ugrave'] = 722;
    t['Delta'] = 612;
    t['thorn'] = 500;
    t['twosuperior'] = 300;
    t['Odieresis'] = 722;
    t['mu'] = 500;
    t['igrave'] = 278;
    t['ohungarumlaut'] = 500;
    t['Eogonek'] = 611;
    t['dcroat'] = 500;
    t['threequarters'] = 750;
    t['Scedilla'] = 500;
    t['lcaron'] = 300;
    t['Kcommaaccent'] = 667;
    t['Lacute'] = 556;
    t['trademark'] = 980;
    t['edotaccent'] = 444;
    t['Igrave'] = 333;
    t['Imacron'] = 333;
    t['Lcaron'] = 611;
    t['onehalf'] = 750;
    t['lessequal'] = 549;
    t['ocircumflex'] = 500;
    t['ntilde'] = 500;
    t['Uhungarumlaut'] = 722;
    t['Eacute'] = 611;
    t['emacron'] = 444;
    t['gbreve'] = 500;
    t['onequarter'] = 750;
    t['Scaron'] = 500;
    t['Scommaaccent'] = 500;
    t['Ohungarumlaut'] = 722;
    t['degree'] = 400;
    t['ograve'] = 500;
    t['Ccaron'] = 667;
    t['ugrave'] = 500;
    t['radical'] = 453;
    t['Dcaron'] = 722;
    t['rcommaaccent'] = 389;
    t['Ntilde'] = 667;
    t['otilde'] = 500;
    t['Rcommaaccent'] = 611;
    t['Lcommaaccent'] = 556;
    t['Atilde'] = 611;
    t['Aogonek'] = 611;
    t['Aring'] = 611;
    t['Otilde'] = 722;
    t['zdotaccent'] = 389;
    t['Ecaron'] = 611;
    t['Iogonek'] = 333;
    t['kcommaaccent'] = 444;
    t['minus'] = 675;
    t['Icircumflex'] = 333;
    t['ncaron'] = 500;
    t['tcommaaccent'] = 278;
    t['logicalnot'] = 675;
    t['odieresis'] = 500;
    t['udieresis'] = 500;
    t['notequal'] = 549;
    t['gcommaaccent'] = 500;
    t['eth'] = 500;
    t['zcaron'] = 389;
    t['ncommaaccent'] = 500;
    t['onesuperior'] = 300;
    t['imacron'] = 278;
    t['Euro'] = 500;
  });
  t['ZapfDingbats'] = (0, _util.getLookupTableFactory)(function (t) {
    t['space'] = 278;
    t['a1'] = 974;
    t['a2'] = 961;
    t['a202'] = 974;
    t['a3'] = 980;
    t['a4'] = 719;
    t['a5'] = 789;
    t['a119'] = 790;
    t['a118'] = 791;
    t['a117'] = 690;
    t['a11'] = 960;
    t['a12'] = 939;
    t['a13'] = 549;
    t['a14'] = 855;
    t['a15'] = 911;
    t['a16'] = 933;
    t['a105'] = 911;
    t['a17'] = 945;
    t['a18'] = 974;
    t['a19'] = 755;
    t['a20'] = 846;
    t['a21'] = 762;
    t['a22'] = 761;
    t['a23'] = 571;
    t['a24'] = 677;
    t['a25'] = 763;
    t['a26'] = 760;
    t['a27'] = 759;
    t['a28'] = 754;
    t['a6'] = 494;
    t['a7'] = 552;
    t['a8'] = 537;
    t['a9'] = 577;
    t['a10'] = 692;
    t['a29'] = 786;
    t['a30'] = 788;
    t['a31'] = 788;
    t['a32'] = 790;
    t['a33'] = 793;
    t['a34'] = 794;
    t['a35'] = 816;
    t['a36'] = 823;
    t['a37'] = 789;
    t['a38'] = 841;
    t['a39'] = 823;
    t['a40'] = 833;
    t['a41'] = 816;
    t['a42'] = 831;
    t['a43'] = 923;
    t['a44'] = 744;
    t['a45'] = 723;
    t['a46'] = 749;
    t['a47'] = 790;
    t['a48'] = 792;
    t['a49'] = 695;
    t['a50'] = 776;
    t['a51'] = 768;
    t['a52'] = 792;
    t['a53'] = 759;
    t['a54'] = 707;
    t['a55'] = 708;
    t['a56'] = 682;
    t['a57'] = 701;
    t['a58'] = 826;
    t['a59'] = 815;
    t['a60'] = 789;
    t['a61'] = 789;
    t['a62'] = 707;
    t['a63'] = 687;
    t['a64'] = 696;
    t['a65'] = 689;
    t['a66'] = 786;
    t['a67'] = 787;
    t['a68'] = 713;
    t['a69'] = 791;
    t['a70'] = 785;
    t['a71'] = 791;
    t['a72'] = 873;
    t['a73'] = 761;
    t['a74'] = 762;
    t['a203'] = 762;
    t['a75'] = 759;
    t['a204'] = 759;
    t['a76'] = 892;
    t['a77'] = 892;
    t['a78'] = 788;
    t['a79'] = 784;
    t['a81'] = 438;
    t['a82'] = 138;
    t['a83'] = 277;
    t['a84'] = 415;
    t['a97'] = 392;
    t['a98'] = 392;
    t['a99'] = 668;
    t['a100'] = 668;
    t['a89'] = 390;
    t['a90'] = 390;
    t['a93'] = 317;
    t['a94'] = 317;
    t['a91'] = 276;
    t['a92'] = 276;
    t['a205'] = 509;
    t['a85'] = 509;
    t['a206'] = 410;
    t['a86'] = 410;
    t['a87'] = 234;
    t['a88'] = 234;
    t['a95'] = 334;
    t['a96'] = 334;
    t['a101'] = 732;
    t['a102'] = 544;
    t['a103'] = 544;
    t['a104'] = 910;
    t['a106'] = 667;
    t['a107'] = 760;
    t['a108'] = 760;
    t['a112'] = 776;
    t['a111'] = 595;
    t['a110'] = 694;
    t['a109'] = 626;
    t['a120'] = 788;
    t['a121'] = 788;
    t['a122'] = 788;
    t['a123'] = 788;
    t['a124'] = 788;
    t['a125'] = 788;
    t['a126'] = 788;
    t['a127'] = 788;
    t['a128'] = 788;
    t['a129'] = 788;
    t['a130'] = 788;
    t['a131'] = 788;
    t['a132'] = 788;
    t['a133'] = 788;
    t['a134'] = 788;
    t['a135'] = 788;
    t['a136'] = 788;
    t['a137'] = 788;
    t['a138'] = 788;
    t['a139'] = 788;
    t['a140'] = 788;
    t['a141'] = 788;
    t['a142'] = 788;
    t['a143'] = 788;
    t['a144'] = 788;
    t['a145'] = 788;
    t['a146'] = 788;
    t['a147'] = 788;
    t['a148'] = 788;
    t['a149'] = 788;
    t['a150'] = 788;
    t['a151'] = 788;
    t['a152'] = 788;
    t['a153'] = 788;
    t['a154'] = 788;
    t['a155'] = 788;
    t['a156'] = 788;
    t['a157'] = 788;
    t['a158'] = 788;
    t['a159'] = 788;
    t['a160'] = 894;
    t['a161'] = 838;
    t['a163'] = 1016;
    t['a164'] = 458;
    t['a196'] = 748;
    t['a165'] = 924;
    t['a192'] = 748;
    t['a166'] = 918;
    t['a167'] = 927;
    t['a168'] = 928;
    t['a169'] = 928;
    t['a170'] = 834;
    t['a171'] = 873;
    t['a172'] = 828;
    t['a173'] = 924;
    t['a162'] = 924;
    t['a174'] = 917;
    t['a175'] = 930;
    t['a176'] = 931;
    t['a177'] = 463;
    t['a178'] = 883;
    t['a179'] = 836;
    t['a193'] = 836;
    t['a180'] = 867;
    t['a199'] = 867;
    t['a181'] = 696;
    t['a200'] = 696;
    t['a182'] = 874;
    t['a201'] = 874;
    t['a183'] = 760;
    t['a184'] = 946;
    t['a197'] = 771;
    t['a185'] = 865;
    t['a194'] = 771;
    t['a198'] = 888;
    t['a186'] = 967;
    t['a195'] = 888;
    t['a187'] = 831;
    t['a188'] = 873;
    t['a189'] = 927;
    t['a190'] = 970;
    t['a191'] = 918;
  });
});
exports.getMetrics = getMetrics;

/***/ }),
/* 30 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var MurmurHash3_64 = function MurmurHash3_64Closure(seed) {
  var MASK_HIGH = 0xffff0000;
  var MASK_LOW = 0xffff;
  function MurmurHash3_64(seed) {
    var SEED = 0xc3d2e1f0;
    this.h1 = seed ? seed & 0xffffffff : SEED;
    this.h2 = seed ? seed & 0xffffffff : SEED;
  }
  MurmurHash3_64.prototype = {
    update: function MurmurHash3_64_update(input) {
      var i;
      if (typeof input === 'string') {
        var data = new Uint8Array(input.length * 2);
        var length = 0;
        for (i = 0; i < input.length; i++) {
          var code = input.charCodeAt(i);
          if (code <= 0xff) {
            data[length++] = code;
          } else {
            data[length++] = code >>> 8;
            data[length++] = code & 0xff;
          }
        }
      } else if ((typeof input === 'undefined' ? 'undefined' : _typeof(input)) === 'object' && 'byteLength' in input) {
        data = input;
        length = data.byteLength;
      } else {
        throw new Error('Wrong data format in MurmurHash3_64_update. ' + 'Input must be a string or array.');
      }
      var blockCounts = length >> 2;
      var tailLength = length - blockCounts * 4;
      var dataUint32 = new Uint32Array(data.buffer, 0, blockCounts);
      var k1 = 0;
      var k2 = 0;
      var h1 = this.h1;
      var h2 = this.h2;
      var C1 = 0xcc9e2d51;
      var C2 = 0x1b873593;
      var C1_LOW = C1 & MASK_LOW;
      var C2_LOW = C2 & MASK_LOW;
      for (i = 0; i < blockCounts; i++) {
        if (i & 1) {
          k1 = dataUint32[i];
          k1 = k1 * C1 & MASK_HIGH | k1 * C1_LOW & MASK_LOW;
          k1 = k1 << 15 | k1 >>> 17;
          k1 = k1 * C2 & MASK_HIGH | k1 * C2_LOW & MASK_LOW;
          h1 ^= k1;
          h1 = h1 << 13 | h1 >>> 19;
          h1 = h1 * 5 + 0xe6546b64;
        } else {
          k2 = dataUint32[i];
          k2 = k2 * C1 & MASK_HIGH | k2 * C1_LOW & MASK_LOW;
          k2 = k2 << 15 | k2 >>> 17;
          k2 = k2 * C2 & MASK_HIGH | k2 * C2_LOW & MASK_LOW;
          h2 ^= k2;
          h2 = h2 << 13 | h2 >>> 19;
          h2 = h2 * 5 + 0xe6546b64;
        }
      }
      k1 = 0;
      switch (tailLength) {
        case 3:
          k1 ^= data[blockCounts * 4 + 2] << 16;
        case 2:
          k1 ^= data[blockCounts * 4 + 1] << 8;
        case 1:
          k1 ^= data[blockCounts * 4];
          k1 = k1 * C1 & MASK_HIGH | k1 * C1_LOW & MASK_LOW;
          k1 = k1 << 15 | k1 >>> 17;
          k1 = k1 * C2 & MASK_HIGH | k1 * C2_LOW & MASK_LOW;
          if (blockCounts & 1) {
            h1 ^= k1;
          } else {
            h2 ^= k1;
          }
      }
      this.h1 = h1;
      this.h2 = h2;
      return this;
    },
    hexdigest: function MurmurHash3_64_hexdigest() {
      var h1 = this.h1;
      var h2 = this.h2;
      h1 ^= h2 >>> 1;
      h1 = h1 * 0xed558ccd & MASK_HIGH | h1 * 0x8ccd & MASK_LOW;
      h2 = h2 * 0xff51afd7 & MASK_HIGH | ((h2 << 16 | h1 >>> 16) * 0xafd7ed55 & MASK_HIGH) >>> 16;
      h1 ^= h2 >>> 1;
      h1 = h1 * 0x1a85ec53 & MASK_HIGH | h1 * 0xec53 & MASK_LOW;
      h2 = h2 * 0xc4ceb9fe & MASK_HIGH | ((h2 << 16 | h1 >>> 16) * 0xb9fe1a85 & MASK_HIGH) >>> 16;
      h1 ^= h2 >>> 1;
      for (var i = 0, arr = [h1, h2], str = ''; i < arr.length; i++) {
        var hex = (arr[i] >>> 0).toString(16);
        while (hex.length < 8) {
          hex = '0' + hex;
        }
        str += hex;
      }
      return str;
    }
  };
  return MurmurHash3_64;
}();
exports.MurmurHash3_64 = MurmurHash3_64;

/***/ }),
/* 31 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTilingPatternIR = exports.Pattern = undefined;

var _util = __w_pdfjs_require__(0);

var _colorspace = __w_pdfjs_require__(3);

var _primitives = __w_pdfjs_require__(1);

var _function = __w_pdfjs_require__(6);

var ShadingType = {
  FUNCTION_BASED: 1,
  AXIAL: 2,
  RADIAL: 3,
  FREE_FORM_MESH: 4,
  LATTICE_FORM_MESH: 5,
  COONS_PATCH_MESH: 6,
  TENSOR_PATCH_MESH: 7
};
var Pattern = function PatternClosure() {
  function Pattern() {
    throw new Error('should not call Pattern constructor');
  }
  Pattern.prototype = {
    getPattern: function Pattern_getPattern(ctx) {
      throw new Error('Should not call Pattern.getStyle: ' + ctx);
    }
  };
  Pattern.parseShading = function Pattern_parseShading(shading, matrix, xref, res, handler) {
    var dict = (0, _primitives.isStream)(shading) ? shading.dict : shading;
    var type = dict.get('ShadingType');
    try {
      switch (type) {
        case ShadingType.AXIAL:
        case ShadingType.RADIAL:
          return new Shadings.RadialAxial(dict, matrix, xref, res);
        case ShadingType.FREE_FORM_MESH:
        case ShadingType.LATTICE_FORM_MESH:
        case ShadingType.COONS_PATCH_MESH:
        case ShadingType.TENSOR_PATCH_MESH:
          return new Shadings.Mesh(shading, matrix, xref, res);
        default:
          throw new _util.FormatError('Unsupported ShadingType: ' + type);
      }
    } catch (ex) {
      if (ex instanceof _util.MissingDataException) {
        throw ex;
      }
      handler.send('UnsupportedFeature', { featureId: _util.UNSUPPORTED_FEATURES.shadingPattern });
      (0, _util.warn)(ex);
      return new Shadings.Dummy();
    }
  };
  return Pattern;
}();
var Shadings = {};
Shadings.SMALL_NUMBER = 1e-6;
Shadings.RadialAxial = function RadialAxialClosure() {
  function RadialAxial(dict, matrix, xref, res) {
    this.matrix = matrix;
    this.coordsArr = dict.getArray('Coords');
    this.shadingType = dict.get('ShadingType');
    this.type = 'Pattern';
    var cs = dict.get('ColorSpace', 'CS');
    cs = _colorspace.ColorSpace.parse(cs, xref, res);
    this.cs = cs;
    var t0 = 0.0,
        t1 = 1.0;
    if (dict.has('Domain')) {
      var domainArr = dict.getArray('Domain');
      t0 = domainArr[0];
      t1 = domainArr[1];
    }
    var extendStart = false,
        extendEnd = false;
    if (dict.has('Extend')) {
      var extendArr = dict.getArray('Extend');
      extendStart = extendArr[0];
      extendEnd = extendArr[1];
    }
    if (this.shadingType === ShadingType.RADIAL && (!extendStart || !extendEnd)) {
      var x1 = this.coordsArr[0];
      var y1 = this.coordsArr[1];
      var r1 = this.coordsArr[2];
      var x2 = this.coordsArr[3];
      var y2 = this.coordsArr[4];
      var r2 = this.coordsArr[5];
      var distance = Math.sqrt((x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2));
      if (r1 <= r2 + distance && r2 <= r1 + distance) {
        (0, _util.warn)('Unsupported radial gradient.');
      }
    }
    this.extendStart = extendStart;
    this.extendEnd = extendEnd;
    var fnObj = dict.get('Function');
    var fn = _function.PDFFunction.parseArray(xref, fnObj);
    var diff = t1 - t0;
    var step = diff / 10;
    var colorStops = this.colorStops = [];
    if (t0 >= t1 || step <= 0) {
      (0, _util.info)('Bad shading domain.');
      return;
    }
    var color = new Float32Array(cs.numComps),
        ratio = new Float32Array(1);
    var rgbColor;
    for (var i = t0; i <= t1; i += step) {
      ratio[0] = i;
      fn(ratio, 0, color, 0);
      rgbColor = cs.getRgb(color, 0);
      var cssColor = _util.Util.makeCssRgb(rgbColor[0], rgbColor[1], rgbColor[2]);
      colorStops.push([(i - t0) / diff, cssColor]);
    }
    var background = 'transparent';
    if (dict.has('Background')) {
      rgbColor = cs.getRgb(dict.get('Background'), 0);
      background = _util.Util.makeCssRgb(rgbColor[0], rgbColor[1], rgbColor[2]);
    }
    if (!extendStart) {
      colorStops.unshift([0, background]);
      colorStops[1][0] += Shadings.SMALL_NUMBER;
    }
    if (!extendEnd) {
      colorStops[colorStops.length - 1][0] -= Shadings.SMALL_NUMBER;
      colorStops.push([1, background]);
    }
    this.colorStops = colorStops;
  }
  RadialAxial.prototype = {
    getIR: function RadialAxial_getIR() {
      var coordsArr = this.coordsArr;
      var shadingType = this.shadingType;
      var type, p0, p1, r0, r1;
      if (shadingType === ShadingType.AXIAL) {
        p0 = [coordsArr[0], coordsArr[1]];
        p1 = [coordsArr[2], coordsArr[3]];
        r0 = null;
        r1 = null;
        type = 'axial';
      } else if (shadingType === ShadingType.RADIAL) {
        p0 = [coordsArr[0], coordsArr[1]];
        p1 = [coordsArr[3], coordsArr[4]];
        r0 = coordsArr[2];
        r1 = coordsArr[5];
        type = 'radial';
      } else {
        (0, _util.unreachable)('getPattern type unknown: ' + shadingType);
      }
      var matrix = this.matrix;
      if (matrix) {
        p0 = _util.Util.applyTransform(p0, matrix);
        p1 = _util.Util.applyTransform(p1, matrix);
        if (shadingType === ShadingType.RADIAL) {
          var scale = _util.Util.singularValueDecompose2dScale(matrix);
          r0 *= scale[0];
          r1 *= scale[1];
        }
      }
      return ['RadialAxial', type, this.colorStops, p0, p1, r0, r1];
    }
  };
  return RadialAxial;
}();
Shadings.Mesh = function MeshClosure() {
  function MeshStreamReader(stream, context) {
    this.stream = stream;
    this.context = context;
    this.buffer = 0;
    this.bufferLength = 0;
    var numComps = context.numComps;
    this.tmpCompsBuf = new Float32Array(numComps);
    var csNumComps = context.colorSpace.numComps;
    this.tmpCsCompsBuf = context.colorFn ? new Float32Array(csNumComps) : this.tmpCompsBuf;
  }
  MeshStreamReader.prototype = {
    get hasData() {
      if (this.stream.end) {
        return this.stream.pos < this.stream.end;
      }
      if (this.bufferLength > 0) {
        return true;
      }
      var nextByte = this.stream.getByte();
      if (nextByte < 0) {
        return false;
      }
      this.buffer = nextByte;
      this.bufferLength = 8;
      return true;
    },
    readBits: function MeshStreamReader_readBits(n) {
      var buffer = this.buffer;
      var bufferLength = this.bufferLength;
      if (n === 32) {
        if (bufferLength === 0) {
          return (this.stream.getByte() << 24 | this.stream.getByte() << 16 | this.stream.getByte() << 8 | this.stream.getByte()) >>> 0;
        }
        buffer = buffer << 24 | this.stream.getByte() << 16 | this.stream.getByte() << 8 | this.stream.getByte();
        var nextByte = this.stream.getByte();
        this.buffer = nextByte & (1 << bufferLength) - 1;
        return (buffer << 8 - bufferLength | (nextByte & 0xFF) >> bufferLength) >>> 0;
      }
      if (n === 8 && bufferLength === 0) {
        return this.stream.getByte();
      }
      while (bufferLength < n) {
        buffer = buffer << 8 | this.stream.getByte();
        bufferLength += 8;
      }
      bufferLength -= n;
      this.bufferLength = bufferLength;
      this.buffer = buffer & (1 << bufferLength) - 1;
      return buffer >> bufferLength;
    },
    align: function MeshStreamReader_align() {
      this.buffer = 0;
      this.bufferLength = 0;
    },
    readFlag: function MeshStreamReader_readFlag() {
      return this.readBits(this.context.bitsPerFlag);
    },
    readCoordinate: function MeshStreamReader_readCoordinate() {
      var bitsPerCoordinate = this.context.bitsPerCoordinate;
      var xi = this.readBits(bitsPerCoordinate);
      var yi = this.readBits(bitsPerCoordinate);
      var decode = this.context.decode;
      var scale = bitsPerCoordinate < 32 ? 1 / ((1 << bitsPerCoordinate) - 1) : 2.3283064365386963e-10;
      return [xi * scale * (decode[1] - decode[0]) + decode[0], yi * scale * (decode[3] - decode[2]) + decode[2]];
    },
    readComponents: function MeshStreamReader_readComponents() {
      var numComps = this.context.numComps;
      var bitsPerComponent = this.context.bitsPerComponent;
      var scale = bitsPerComponent < 32 ? 1 / ((1 << bitsPerComponent) - 1) : 2.3283064365386963e-10;
      var decode = this.context.decode;
      var components = this.tmpCompsBuf;
      for (var i = 0, j = 4; i < numComps; i++, j += 2) {
        var ci = this.readBits(bitsPerComponent);
        components[i] = ci * scale * (decode[j + 1] - decode[j]) + decode[j];
      }
      var color = this.tmpCsCompsBuf;
      if (this.context.colorFn) {
        this.context.colorFn(components, 0, color, 0);
      }
      return this.context.colorSpace.getRgb(color, 0);
    }
  };
  function decodeType4Shading(mesh, reader) {
    var coords = mesh.coords;
    var colors = mesh.colors;
    var operators = [];
    var ps = [];
    var verticesLeft = 0;
    while (reader.hasData) {
      var f = reader.readFlag();
      var coord = reader.readCoordinate();
      var color = reader.readComponents();
      if (verticesLeft === 0) {
        if (!(0 <= f && f <= 2)) {
          throw new _util.FormatError('Unknown type4 flag');
        }
        switch (f) {
          case 0:
            verticesLeft = 3;
            break;
          case 1:
            ps.push(ps[ps.length - 2], ps[ps.length - 1]);
            verticesLeft = 1;
            break;
          case 2:
            ps.push(ps[ps.length - 3], ps[ps.length - 1]);
            verticesLeft = 1;
            break;
        }
        operators.push(f);
      }
      ps.push(coords.length);
      coords.push(coord);
      colors.push(color);
      verticesLeft--;
      reader.align();
    }
    mesh.figures.push({
      type: 'triangles',
      coords: new Int32Array(ps),
      colors: new Int32Array(ps)
    });
  }
  function decodeType5Shading(mesh, reader, verticesPerRow) {
    var coords = mesh.coords;
    var colors = mesh.colors;
    var ps = [];
    while (reader.hasData) {
      var coord = reader.readCoordinate();
      var color = reader.readComponents();
      ps.push(coords.length);
      coords.push(coord);
      colors.push(color);
    }
    mesh.figures.push({
      type: 'lattice',
      coords: new Int32Array(ps),
      colors: new Int32Array(ps),
      verticesPerRow: verticesPerRow
    });
  }
  var MIN_SPLIT_PATCH_CHUNKS_AMOUNT = 3;
  var MAX_SPLIT_PATCH_CHUNKS_AMOUNT = 20;
  var TRIANGLE_DENSITY = 20;
  var getB = function getBClosure() {
    function buildB(count) {
      var lut = [];
      for (var i = 0; i <= count; i++) {
        var t = i / count,
            t_ = 1 - t;
        lut.push(new Float32Array([t_ * t_ * t_, 3 * t * t_ * t_, 3 * t * t * t_, t * t * t]));
      }
      return lut;
    }
    var cache = [];
    return function getB(count) {
      if (!cache[count]) {
        cache[count] = buildB(count);
      }
      return cache[count];
    };
  }();
  function buildFigureFromPatch(mesh, index) {
    var figure = mesh.figures[index];
    (0, _util.assert)(figure.type === 'patch', 'Unexpected patch mesh figure');
    var coords = mesh.coords,
        colors = mesh.colors;
    var pi = figure.coords;
    var ci = figure.colors;
    var figureMinX = Math.min(coords[pi[0]][0], coords[pi[3]][0], coords[pi[12]][0], coords[pi[15]][0]);
    var figureMinY = Math.min(coords[pi[0]][1], coords[pi[3]][1], coords[pi[12]][1], coords[pi[15]][1]);
    var figureMaxX = Math.max(coords[pi[0]][0], coords[pi[3]][0], coords[pi[12]][0], coords[pi[15]][0]);
    var figureMaxY = Math.max(coords[pi[0]][1], coords[pi[3]][1], coords[pi[12]][1], coords[pi[15]][1]);
    var splitXBy = Math.ceil((figureMaxX - figureMinX) * TRIANGLE_DENSITY / (mesh.bounds[2] - mesh.bounds[0]));
    splitXBy = Math.max(MIN_SPLIT_PATCH_CHUNKS_AMOUNT, Math.min(MAX_SPLIT_PATCH_CHUNKS_AMOUNT, splitXBy));
    var splitYBy = Math.ceil((figureMaxY - figureMinY) * TRIANGLE_DENSITY / (mesh.bounds[3] - mesh.bounds[1]));
    splitYBy = Math.max(MIN_SPLIT_PATCH_CHUNKS_AMOUNT, Math.min(MAX_SPLIT_PATCH_CHUNKS_AMOUNT, splitYBy));
    var verticesPerRow = splitXBy + 1;
    var figureCoords = new Int32Array((splitYBy + 1) * verticesPerRow);
    var figureColors = new Int32Array((splitYBy + 1) * verticesPerRow);
    var k = 0;
    var cl = new Uint8Array(3),
        cr = new Uint8Array(3);
    var c0 = colors[ci[0]],
        c1 = colors[ci[1]],
        c2 = colors[ci[2]],
        c3 = colors[ci[3]];
    var bRow = getB(splitYBy),
        bCol = getB(splitXBy);
    for (var row = 0; row <= splitYBy; row++) {
      cl[0] = (c0[0] * (splitYBy - row) + c2[0] * row) / splitYBy | 0;
      cl[1] = (c0[1] * (splitYBy - row) + c2[1] * row) / splitYBy | 0;
      cl[2] = (c0[2] * (splitYBy - row) + c2[2] * row) / splitYBy | 0;
      cr[0] = (c1[0] * (splitYBy - row) + c3[0] * row) / splitYBy | 0;
      cr[1] = (c1[1] * (splitYBy - row) + c3[1] * row) / splitYBy | 0;
      cr[2] = (c1[2] * (splitYBy - row) + c3[2] * row) / splitYBy | 0;
      for (var col = 0; col <= splitXBy; col++, k++) {
        if ((row === 0 || row === splitYBy) && (col === 0 || col === splitXBy)) {
          continue;
        }
        var x = 0,
            y = 0;
        var q = 0;
        for (var i = 0; i <= 3; i++) {
          for (var j = 0; j <= 3; j++, q++) {
            var m = bRow[row][i] * bCol[col][j];
            x += coords[pi[q]][0] * m;
            y += coords[pi[q]][1] * m;
          }
        }
        figureCoords[k] = coords.length;
        coords.push([x, y]);
        figureColors[k] = colors.length;
        var newColor = new Uint8Array(3);
        newColor[0] = (cl[0] * (splitXBy - col) + cr[0] * col) / splitXBy | 0;
        newColor[1] = (cl[1] * (splitXBy - col) + cr[1] * col) / splitXBy | 0;
        newColor[2] = (cl[2] * (splitXBy - col) + cr[2] * col) / splitXBy | 0;
        colors.push(newColor);
      }
    }
    figureCoords[0] = pi[0];
    figureColors[0] = ci[0];
    figureCoords[splitXBy] = pi[3];
    figureColors[splitXBy] = ci[1];
    figureCoords[verticesPerRow * splitYBy] = pi[12];
    figureColors[verticesPerRow * splitYBy] = ci[2];
    figureCoords[verticesPerRow * splitYBy + splitXBy] = pi[15];
    figureColors[verticesPerRow * splitYBy + splitXBy] = ci[3];
    mesh.figures[index] = {
      type: 'lattice',
      coords: figureCoords,
      colors: figureColors,
      verticesPerRow: verticesPerRow
    };
  }
  function decodeType6Shading(mesh, reader) {
    var coords = mesh.coords;
    var colors = mesh.colors;
    var ps = new Int32Array(16);
    var cs = new Int32Array(4);
    while (reader.hasData) {
      var f = reader.readFlag();
      if (!(0 <= f && f <= 3)) {
        throw new _util.FormatError('Unknown type6 flag');
      }
      var i, ii;
      var pi = coords.length;
      for (i = 0, ii = f !== 0 ? 8 : 12; i < ii; i++) {
        coords.push(reader.readCoordinate());
      }
      var ci = colors.length;
      for (i = 0, ii = f !== 0 ? 2 : 4; i < ii; i++) {
        colors.push(reader.readComponents());
      }
      var tmp1, tmp2, tmp3, tmp4;
      switch (f) {
        case 0:
          ps[12] = pi + 3;
          ps[13] = pi + 4;
          ps[14] = pi + 5;
          ps[15] = pi + 6;
          ps[8] = pi + 2;
          ps[11] = pi + 7;
          ps[4] = pi + 1;
          ps[7] = pi + 8;
          ps[0] = pi;
          ps[1] = pi + 11;
          ps[2] = pi + 10;
          ps[3] = pi + 9;
          cs[2] = ci + 1;
          cs[3] = ci + 2;
          cs[0] = ci;
          cs[1] = ci + 3;
          break;
        case 1:
          tmp1 = ps[12];
          tmp2 = ps[13];
          tmp3 = ps[14];
          tmp4 = ps[15];
          ps[12] = tmp4;
          ps[13] = pi + 0;
          ps[14] = pi + 1;
          ps[15] = pi + 2;
          ps[8] = tmp3;
          ps[11] = pi + 3;
          ps[4] = tmp2;
          ps[7] = pi + 4;
          ps[0] = tmp1;
          ps[1] = pi + 7;
          ps[2] = pi + 6;
          ps[3] = pi + 5;
          tmp1 = cs[2];
          tmp2 = cs[3];
          cs[2] = tmp2;
          cs[3] = ci;
          cs[0] = tmp1;
          cs[1] = ci + 1;
          break;
        case 2:
          tmp1 = ps[15];
          tmp2 = ps[11];
          ps[12] = ps[3];
          ps[13] = pi + 0;
          ps[14] = pi + 1;
          ps[15] = pi + 2;
          ps[8] = ps[7];
          ps[11] = pi + 3;
          ps[4] = tmp2;
          ps[7] = pi + 4;
          ps[0] = tmp1;
          ps[1] = pi + 7;
          ps[2] = pi + 6;
          ps[3] = pi + 5;
          tmp1 = cs[3];
          cs[2] = cs[1];
          cs[3] = ci;
          cs[0] = tmp1;
          cs[1] = ci + 1;
          break;
        case 3:
          ps[12] = ps[0];
          ps[13] = pi + 0;
          ps[14] = pi + 1;
          ps[15] = pi + 2;
          ps[8] = ps[1];
          ps[11] = pi + 3;
          ps[4] = ps[2];
          ps[7] = pi + 4;
          ps[0] = ps[3];
          ps[1] = pi + 7;
          ps[2] = pi + 6;
          ps[3] = pi + 5;
          cs[2] = cs[0];
          cs[3] = ci;
          cs[0] = cs[1];
          cs[1] = ci + 1;
          break;
      }
      ps[5] = coords.length;
      coords.push([(-4 * coords[ps[0]][0] - coords[ps[15]][0] + 6 * (coords[ps[4]][0] + coords[ps[1]][0]) - 2 * (coords[ps[12]][0] + coords[ps[3]][0]) + 3 * (coords[ps[13]][0] + coords[ps[7]][0])) / 9, (-4 * coords[ps[0]][1] - coords[ps[15]][1] + 6 * (coords[ps[4]][1] + coords[ps[1]][1]) - 2 * (coords[ps[12]][1] + coords[ps[3]][1]) + 3 * (coords[ps[13]][1] + coords[ps[7]][1])) / 9]);
      ps[6] = coords.length;
      coords.push([(-4 * coords[ps[3]][0] - coords[ps[12]][0] + 6 * (coords[ps[2]][0] + coords[ps[7]][0]) - 2 * (coords[ps[0]][0] + coords[ps[15]][0]) + 3 * (coords[ps[4]][0] + coords[ps[14]][0])) / 9, (-4 * coords[ps[3]][1] - coords[ps[12]][1] + 6 * (coords[ps[2]][1] + coords[ps[7]][1]) - 2 * (coords[ps[0]][1] + coords[ps[15]][1]) + 3 * (coords[ps[4]][1] + coords[ps[14]][1])) / 9]);
      ps[9] = coords.length;
      coords.push([(-4 * coords[ps[12]][0] - coords[ps[3]][0] + 6 * (coords[ps[8]][0] + coords[ps[13]][0]) - 2 * (coords[ps[0]][0] + coords[ps[15]][0]) + 3 * (coords[ps[11]][0] + coords[ps[1]][0])) / 9, (-4 * coords[ps[12]][1] - coords[ps[3]][1] + 6 * (coords[ps[8]][1] + coords[ps[13]][1]) - 2 * (coords[ps[0]][1] + coords[ps[15]][1]) + 3 * (coords[ps[11]][1] + coords[ps[1]][1])) / 9]);
      ps[10] = coords.length;
      coords.push([(-4 * coords[ps[15]][0] - coords[ps[0]][0] + 6 * (coords[ps[11]][0] + coords[ps[14]][0]) - 2 * (coords[ps[12]][0] + coords[ps[3]][0]) + 3 * (coords[ps[2]][0] + coords[ps[8]][0])) / 9, (-4 * coords[ps[15]][1] - coords[ps[0]][1] + 6 * (coords[ps[11]][1] + coords[ps[14]][1]) - 2 * (coords[ps[12]][1] + coords[ps[3]][1]) + 3 * (coords[ps[2]][1] + coords[ps[8]][1])) / 9]);
      mesh.figures.push({
        type: 'patch',
        coords: new Int32Array(ps),
        colors: new Int32Array(cs)
      });
    }
  }
  function decodeType7Shading(mesh, reader) {
    var coords = mesh.coords;
    var colors = mesh.colors;
    var ps = new Int32Array(16);
    var cs = new Int32Array(4);
    while (reader.hasData) {
      var f = reader.readFlag();
      if (!(0 <= f && f <= 3)) {
        throw new _util.FormatError('Unknown type7 flag');
      }
      var i, ii;
      var pi = coords.length;
      for (i = 0, ii = f !== 0 ? 12 : 16; i < ii; i++) {
        coords.push(reader.readCoordinate());
      }
      var ci = colors.length;
      for (i = 0, ii = f !== 0 ? 2 : 4; i < ii; i++) {
        colors.push(reader.readComponents());
      }
      var tmp1, tmp2, tmp3, tmp4;
      switch (f) {
        case 0:
          ps[12] = pi + 3;
          ps[13] = pi + 4;
          ps[14] = pi + 5;
          ps[15] = pi + 6;
          ps[8] = pi + 2;
          ps[9] = pi + 13;
          ps[10] = pi + 14;
          ps[11] = pi + 7;
          ps[4] = pi + 1;
          ps[5] = pi + 12;
          ps[6] = pi + 15;
          ps[7] = pi + 8;
          ps[0] = pi;
          ps[1] = pi + 11;
          ps[2] = pi + 10;
          ps[3] = pi + 9;
          cs[2] = ci + 1;
          cs[3] = ci + 2;
          cs[0] = ci;
          cs[1] = ci + 3;
          break;
        case 1:
          tmp1 = ps[12];
          tmp2 = ps[13];
          tmp3 = ps[14];
          tmp4 = ps[15];
          ps[12] = tmp4;
          ps[13] = pi + 0;
          ps[14] = pi + 1;
          ps[15] = pi + 2;
          ps[8] = tmp3;
          ps[9] = pi + 9;
          ps[10] = pi + 10;
          ps[11] = pi + 3;
          ps[4] = tmp2;
          ps[5] = pi + 8;
          ps[6] = pi + 11;
          ps[7] = pi + 4;
          ps[0] = tmp1;
          ps[1] = pi + 7;
          ps[2] = pi + 6;
          ps[3] = pi + 5;
          tmp1 = cs[2];
          tmp2 = cs[3];
          cs[2] = tmp2;
          cs[3] = ci;
          cs[0] = tmp1;
          cs[1] = ci + 1;
          break;
        case 2:
          tmp1 = ps[15];
          tmp2 = ps[11];
          ps[12] = ps[3];
          ps[13] = pi + 0;
          ps[14] = pi + 1;
          ps[15] = pi + 2;
          ps[8] = ps[7];
          ps[9] = pi + 9;
          ps[10] = pi + 10;
          ps[11] = pi + 3;
          ps[4] = tmp2;
          ps[5] = pi + 8;
          ps[6] = pi + 11;
          ps[7] = pi + 4;
          ps[0] = tmp1;
          ps[1] = pi + 7;
          ps[2] = pi + 6;
          ps[3] = pi + 5;
          tmp1 = cs[3];
          cs[2] = cs[1];
          cs[3] = ci;
          cs[0] = tmp1;
          cs[1] = ci + 1;
          break;
        case 3:
          ps[12] = ps[0];
          ps[13] = pi + 0;
          ps[14] = pi + 1;
          ps[15] = pi + 2;
          ps[8] = ps[1];
          ps[9] = pi + 9;
          ps[10] = pi + 10;
          ps[11] = pi + 3;
          ps[4] = ps[2];
          ps[5] = pi + 8;
          ps[6] = pi + 11;
          ps[7] = pi + 4;
          ps[0] = ps[3];
          ps[1] = pi + 7;
          ps[2] = pi + 6;
          ps[3] = pi + 5;
          cs[2] = cs[0];
          cs[3] = ci;
          cs[0] = cs[1];
          cs[1] = ci + 1;
          break;
      }
      mesh.figures.push({
        type: 'patch',
        coords: new Int32Array(ps),
        colors: new Int32Array(cs)
      });
    }
  }
  function updateBounds(mesh) {
    var minX = mesh.coords[0][0],
        minY = mesh.coords[0][1],
        maxX = minX,
        maxY = minY;
    for (var i = 1, ii = mesh.coords.length; i < ii; i++) {
      var x = mesh.coords[i][0],
          y = mesh.coords[i][1];
      minX = minX > x ? x : minX;
      minY = minY > y ? y : minY;
      maxX = maxX < x ? x : maxX;
      maxY = maxY < y ? y : maxY;
    }
    mesh.bounds = [minX, minY, maxX, maxY];
  }
  function packData(mesh) {
    var i, ii, j, jj;
    var coords = mesh.coords;
    var coordsPacked = new Float32Array(coords.length * 2);
    for (i = 0, j = 0, ii = coords.length; i < ii; i++) {
      var xy = coords[i];
      coordsPacked[j++] = xy[0];
      coordsPacked[j++] = xy[1];
    }
    mesh.coords = coordsPacked;
    var colors = mesh.colors;
    var colorsPacked = new Uint8Array(colors.length * 3);
    for (i = 0, j = 0, ii = colors.length; i < ii; i++) {
      var c = colors[i];
      colorsPacked[j++] = c[0];
      colorsPacked[j++] = c[1];
      colorsPacked[j++] = c[2];
    }
    mesh.colors = colorsPacked;
    var figures = mesh.figures;
    for (i = 0, ii = figures.length; i < ii; i++) {
      var figure = figures[i],
          ps = figure.coords,
          cs = figure.colors;
      for (j = 0, jj = ps.length; j < jj; j++) {
        ps[j] *= 2;
        cs[j] *= 3;
      }
    }
  }
  function Mesh(stream, matrix, xref, res) {
    if (!(0, _primitives.isStream)(stream)) {
      throw new _util.FormatError('Mesh data is not a stream');
    }
    var dict = stream.dict;
    this.matrix = matrix;
    this.shadingType = dict.get('ShadingType');
    this.type = 'Pattern';
    this.bbox = dict.getArray('BBox');
    var cs = dict.get('ColorSpace', 'CS');
    cs = _colorspace.ColorSpace.parse(cs, xref, res);
    this.cs = cs;
    this.background = dict.has('Background') ? cs.getRgb(dict.get('Background'), 0) : null;
    var fnObj = dict.get('Function');
    var fn = fnObj ? _function.PDFFunction.parseArray(xref, fnObj) : null;
    this.coords = [];
    this.colors = [];
    this.figures = [];
    var decodeContext = {
      bitsPerCoordinate: dict.get('BitsPerCoordinate'),
      bitsPerComponent: dict.get('BitsPerComponent'),
      bitsPerFlag: dict.get('BitsPerFlag'),
      decode: dict.getArray('Decode'),
      colorFn: fn,
      colorSpace: cs,
      numComps: fn ? 1 : cs.numComps
    };
    var reader = new MeshStreamReader(stream, decodeContext);
    var patchMesh = false;
    switch (this.shadingType) {
      case ShadingType.FREE_FORM_MESH:
        decodeType4Shading(this, reader);
        break;
      case ShadingType.LATTICE_FORM_MESH:
        var verticesPerRow = dict.get('VerticesPerRow') | 0;
        if (verticesPerRow < 2) {
          throw new _util.FormatError('Invalid VerticesPerRow');
        }
        decodeType5Shading(this, reader, verticesPerRow);
        break;
      case ShadingType.COONS_PATCH_MESH:
        decodeType6Shading(this, reader);
        patchMesh = true;
        break;
      case ShadingType.TENSOR_PATCH_MESH:
        decodeType7Shading(this, reader);
        patchMesh = true;
        break;
      default:
        (0, _util.unreachable)('Unsupported mesh type.');
        break;
    }
    if (patchMesh) {
      updateBounds(this);
      for (var i = 0, ii = this.figures.length; i < ii; i++) {
        buildFigureFromPatch(this, i);
      }
    }
    updateBounds(this);
    packData(this);
  }
  Mesh.prototype = {
    getIR: function Mesh_getIR() {
      return ['Mesh', this.shadingType, this.coords, this.colors, this.figures, this.bounds, this.matrix, this.bbox, this.background];
    }
  };
  return Mesh;
}();
Shadings.Dummy = function DummyClosure() {
  function Dummy() {
    this.type = 'Pattern';
  }
  Dummy.prototype = {
    getIR: function Dummy_getIR() {
      return ['Dummy'];
    }
  };
  return Dummy;
}();
function getTilingPatternIR(operatorList, dict, args) {
  var matrix = dict.getArray('Matrix');
  var bbox = _util.Util.normalizeRect(dict.getArray('BBox'));
  var xstep = dict.get('XStep');
  var ystep = dict.get('YStep');
  var paintType = dict.get('PaintType');
  var tilingType = dict.get('TilingType');
  if (bbox[2] - bbox[0] === 0 || bbox[3] - bbox[1] === 0) {
    throw new _util.FormatError('Invalid getTilingPatternIR /BBox array: [' + bbox + '].');
  }
  return ['TilingPattern', args, operatorList, matrix, bbox, xstep, ystep, paintType, tilingType];
}
exports.Pattern = Pattern;
exports.getTilingPatternIR = getTilingPatternIR;

/***/ }),
/* 32 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NetworkPdfManager = exports.LocalPdfManager = undefined;

var _util = __w_pdfjs_require__(0);

var _chunked_stream = __w_pdfjs_require__(10);

var _document = __w_pdfjs_require__(23);

var _stream = __w_pdfjs_require__(2);

var BasePdfManager = function BasePdfManagerClosure() {
  function BasePdfManager() {
    throw new Error('Cannot initialize BaseManagerManager');
  }
  BasePdfManager.prototype = {
    get docId() {
      return this._docId;
    },
    get password() {
      return this._password;
    },
    get docBaseUrl() {
      var docBaseUrl = null;
      if (this._docBaseUrl) {
        var absoluteUrl = (0, _util.createValidAbsoluteUrl)(this._docBaseUrl);
        if (absoluteUrl) {
          docBaseUrl = absoluteUrl.href;
        } else {
          (0, _util.warn)('Invalid absolute docBaseUrl: "' + this._docBaseUrl + '".');
        }
      }
      return (0, _util.shadow)(this, 'docBaseUrl', docBaseUrl);
    },
    onLoadedStream: function BasePdfManager_onLoadedStream() {
      throw new _util.NotImplementedException();
    },
    ensureDoc: function BasePdfManager_ensureDoc(prop, args) {
      return this.ensure(this.pdfDocument, prop, args);
    },
    ensureXRef: function BasePdfManager_ensureXRef(prop, args) {
      return this.ensure(this.pdfDocument.xref, prop, args);
    },
    ensureCatalog: function BasePdfManager_ensureCatalog(prop, args) {
      return this.ensure(this.pdfDocument.catalog, prop, args);
    },
    getPage: function BasePdfManager_getPage(pageIndex) {
      return this.pdfDocument.getPage(pageIndex);
    },
    cleanup: function BasePdfManager_cleanup() {
      return this.pdfDocument.cleanup();
    },
    ensure: function BasePdfManager_ensure(obj, prop, args) {
      return new _util.NotImplementedException();
    },
    requestRange: function BasePdfManager_requestRange(begin, end) {
      return new _util.NotImplementedException();
    },
    requestLoadedStream: function BasePdfManager_requestLoadedStream() {
      return new _util.NotImplementedException();
    },
    sendProgressiveData: function BasePdfManager_sendProgressiveData(chunk) {
      return new _util.NotImplementedException();
    },
    updatePassword: function BasePdfManager_updatePassword(password) {
      this._password = password;
    },
    terminate: function BasePdfManager_terminate() {
      return new _util.NotImplementedException();
    }
  };
  return BasePdfManager;
}();
var LocalPdfManager = function LocalPdfManagerClosure() {
  function LocalPdfManager(docId, data, password, evaluatorOptions, docBaseUrl) {
    this._docId = docId;
    this._password = password;
    this._docBaseUrl = docBaseUrl;
    this.evaluatorOptions = evaluatorOptions;
    var stream = new _stream.Stream(data);
    this.pdfDocument = new _document.PDFDocument(this, stream);
    this._loadedStreamCapability = (0, _util.createPromiseCapability)();
    this._loadedStreamCapability.resolve(stream);
  }
  _util.Util.inherit(LocalPdfManager, BasePdfManager, {
    ensure: function LocalPdfManager_ensure(obj, prop, args) {
      return new Promise(function (resolve, reject) {
        try {
          var value = obj[prop];
          var result;
          if (typeof value === 'function') {
            result = value.apply(obj, args);
          } else {
            result = value;
          }
          resolve(result);
        } catch (e) {
          reject(e);
        }
      });
    },
    requestRange: function LocalPdfManager_requestRange(begin, end) {
      return Promise.resolve();
    },
    requestLoadedStream: function LocalPdfManager_requestLoadedStream() {},
    onLoadedStream: function LocalPdfManager_onLoadedStream() {
      return this._loadedStreamCapability.promise;
    },
    terminate: function LocalPdfManager_terminate() {}
  });
  return LocalPdfManager;
}();
var NetworkPdfManager = function NetworkPdfManagerClosure() {
  function NetworkPdfManager(docId, pdfNetworkStream, args, evaluatorOptions, docBaseUrl) {
    this._docId = docId;
    this._password = args.password;
    this._docBaseUrl = docBaseUrl;
    this.msgHandler = args.msgHandler;
    this.evaluatorOptions = evaluatorOptions;
    var params = {
      msgHandler: args.msgHandler,
      url: args.url,
      length: args.length,
      disableAutoFetch: args.disableAutoFetch,
      rangeChunkSize: args.rangeChunkSize
    };
    this.streamManager = new _chunked_stream.ChunkedStreamManager(pdfNetworkStream, params);
    this.pdfDocument = new _document.PDFDocument(this, this.streamManager.getStream());
  }
  _util.Util.inherit(NetworkPdfManager, BasePdfManager, {
    ensure: function NetworkPdfManager_ensure(obj, prop, args) {
      var pdfManager = this;
      return new Promise(function (resolve, reject) {
        function ensureHelper() {
          try {
            var result;
            var value = obj[prop];
            if (typeof value === 'function') {
              result = value.apply(obj, args);
            } else {
              result = value;
            }
            resolve(result);
          } catch (e) {
            if (!(e instanceof _util.MissingDataException)) {
              reject(e);
              return;
            }
            pdfManager.streamManager.requestRange(e.begin, e.end).then(ensureHelper, reject);
          }
        }
        ensureHelper();
      });
    },
    requestRange: function NetworkPdfManager_requestRange(begin, end) {
      return this.streamManager.requestRange(begin, end);
    },
    requestLoadedStream: function NetworkPdfManager_requestLoadedStream() {
      this.streamManager.requestAllChunks();
    },
    sendProgressiveData: function NetworkPdfManager_sendProgressiveData(chunk) {
      this.streamManager.onReceiveData({ chunk: chunk });
    },
    onLoadedStream: function NetworkPdfManager_onLoadedStream() {
      return this.streamManager.onLoadedStream();
    },
    terminate: function NetworkPdfManager_terminate() {
      this.streamManager.abort();
    }
  });
  return NetworkPdfManager;
}();
exports.LocalPdfManager = LocalPdfManager;
exports.NetworkPdfManager = NetworkPdfManager;

/***/ }),
/* 33 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PostScriptParser = exports.PostScriptLexer = undefined;

var _util = __w_pdfjs_require__(0);

var _primitives = __w_pdfjs_require__(1);

var PostScriptParser = function PostScriptParserClosure() {
  function PostScriptParser(lexer) {
    this.lexer = lexer;
    this.operators = [];
    this.token = null;
    this.prev = null;
  }
  PostScriptParser.prototype = {
    nextToken: function PostScriptParser_nextToken() {
      this.prev = this.token;
      this.token = this.lexer.getToken();
    },
    accept: function PostScriptParser_accept(type) {
      if (this.token.type === type) {
        this.nextToken();
        return true;
      }
      return false;
    },
    expect: function PostScriptParser_expect(type) {
      if (this.accept(type)) {
        return true;
      }
      throw new _util.FormatError('Unexpected symbol: found ' + this.token.type + ' expected ' + type + '.');
    },
    parse: function PostScriptParser_parse() {
      this.nextToken();
      this.expect(PostScriptTokenTypes.LBRACE);
      this.parseBlock();
      this.expect(PostScriptTokenTypes.RBRACE);
      return this.operators;
    },
    parseBlock: function PostScriptParser_parseBlock() {
      while (true) {
        if (this.accept(PostScriptTokenTypes.NUMBER)) {
          this.operators.push(this.prev.value);
        } else if (this.accept(PostScriptTokenTypes.OPERATOR)) {
          this.operators.push(this.prev.value);
        } else if (this.accept(PostScriptTokenTypes.LBRACE)) {
          this.parseCondition();
        } else {
          return;
        }
      }
    },
    parseCondition: function PostScriptParser_parseCondition() {
      var conditionLocation = this.operators.length;
      this.operators.push(null, null);
      this.parseBlock();
      this.expect(PostScriptTokenTypes.RBRACE);
      if (this.accept(PostScriptTokenTypes.IF)) {
        this.operators[conditionLocation] = this.operators.length;
        this.operators[conditionLocation + 1] = 'jz';
      } else if (this.accept(PostScriptTokenTypes.LBRACE)) {
        var jumpLocation = this.operators.length;
        this.operators.push(null, null);
        var endOfTrue = this.operators.length;
        this.parseBlock();
        this.expect(PostScriptTokenTypes.RBRACE);
        this.expect(PostScriptTokenTypes.IFELSE);
        this.operators[jumpLocation] = this.operators.length;
        this.operators[jumpLocation + 1] = 'j';
        this.operators[conditionLocation] = endOfTrue;
        this.operators[conditionLocation + 1] = 'jz';
      } else {
        throw new _util.FormatError('PS Function: error parsing conditional.');
      }
    }
  };
  return PostScriptParser;
}();
var PostScriptTokenTypes = {
  LBRACE: 0,
  RBRACE: 1,
  NUMBER: 2,
  OPERATOR: 3,
  IF: 4,
  IFELSE: 5
};
var PostScriptToken = function PostScriptTokenClosure() {
  function PostScriptToken(type, value) {
    this.type = type;
    this.value = value;
  }
  var opCache = Object.create(null);
  PostScriptToken.getOperator = function PostScriptToken_getOperator(op) {
    var opValue = opCache[op];
    if (opValue) {
      return opValue;
    }
    return opCache[op] = new PostScriptToken(PostScriptTokenTypes.OPERATOR, op);
  };
  PostScriptToken.LBRACE = new PostScriptToken(PostScriptTokenTypes.LBRACE, '{');
  PostScriptToken.RBRACE = new PostScriptToken(PostScriptTokenTypes.RBRACE, '}');
  PostScriptToken.IF = new PostScriptToken(PostScriptTokenTypes.IF, 'IF');
  PostScriptToken.IFELSE = new PostScriptToken(PostScriptTokenTypes.IFELSE, 'IFELSE');
  return PostScriptToken;
}();
var PostScriptLexer = function PostScriptLexerClosure() {
  function PostScriptLexer(stream) {
    this.stream = stream;
    this.nextChar();
    this.strBuf = [];
  }
  PostScriptLexer.prototype = {
    nextChar: function PostScriptLexer_nextChar() {
      return this.currentChar = this.stream.getByte();
    },
    getToken: function PostScriptLexer_getToken() {
      var comment = false;
      var ch = this.currentChar;
      while (true) {
        if (ch < 0) {
          return _primitives.EOF;
        }
        if (comment) {
          if (ch === 0x0A || ch === 0x0D) {
            comment = false;
          }
        } else if (ch === 0x25) {
          comment = true;
        } else if (!(0, _util.isSpace)(ch)) {
          break;
        }
        ch = this.nextChar();
      }
      switch (ch | 0) {
        case 0x30:
        case 0x31:
        case 0x32:
        case 0x33:
        case 0x34:
        case 0x35:
        case 0x36:
        case 0x37:
        case 0x38:
        case 0x39:
        case 0x2B:
        case 0x2D:
        case 0x2E:
          return new PostScriptToken(PostScriptTokenTypes.NUMBER, this.getNumber());
        case 0x7B:
          this.nextChar();
          return PostScriptToken.LBRACE;
        case 0x7D:
          this.nextChar();
          return PostScriptToken.RBRACE;
      }
      var strBuf = this.strBuf;
      strBuf.length = 0;
      strBuf[0] = String.fromCharCode(ch);
      while ((ch = this.nextChar()) >= 0 && (ch >= 0x41 && ch <= 0x5A || ch >= 0x61 && ch <= 0x7A)) {
        strBuf.push(String.fromCharCode(ch));
      }
      var str = strBuf.join('');
      switch (str.toLowerCase()) {
        case 'if':
          return PostScriptToken.IF;
        case 'ifelse':
          return PostScriptToken.IFELSE;
        default:
          return PostScriptToken.getOperator(str);
      }
    },
    getNumber: function PostScriptLexer_getNumber() {
      var ch = this.currentChar;
      var strBuf = this.strBuf;
      strBuf.length = 0;
      strBuf[0] = String.fromCharCode(ch);
      while ((ch = this.nextChar()) >= 0) {
        if (ch >= 0x30 && ch <= 0x39 || ch === 0x2D || ch === 0x2E) {
          strBuf.push(String.fromCharCode(ch));
        } else {
          break;
        }
      }
      var value = parseFloat(strBuf.join(''));
      if (isNaN(value)) {
        throw new _util.FormatError('Invalid floating point number: ' + value);
      }
      return value;
    }
  };
  return PostScriptLexer;
}();
exports.PostScriptLexer = PostScriptLexer;
exports.PostScriptParser = PostScriptParser;

/***/ }),
/* 34 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Type1Parser = undefined;

var _util = __w_pdfjs_require__(0);

var _encodings = __w_pdfjs_require__(4);

var _stream = __w_pdfjs_require__(2);

var HINTING_ENABLED = false;
var Type1CharString = function Type1CharStringClosure() {
  var COMMAND_MAP = {
    'hstem': [1],
    'vstem': [3],
    'vmoveto': [4],
    'rlineto': [5],
    'hlineto': [6],
    'vlineto': [7],
    'rrcurveto': [8],
    'callsubr': [10],
    'flex': [12, 35],
    'drop': [12, 18],
    'endchar': [14],
    'rmoveto': [21],
    'hmoveto': [22],
    'vhcurveto': [30],
    'hvcurveto': [31]
  };
  function Type1CharString() {
    this.width = 0;
    this.lsb = 0;
    this.flexing = false;
    this.output = [];
    this.stack = [];
  }
  Type1CharString.prototype = {
    convert: function Type1CharString_convert(encoded, subrs, seacAnalysisEnabled) {
      var count = encoded.length;
      var error = false;
      var wx, sbx, subrNumber;
      for (var i = 0; i < count; i++) {
        var value = encoded[i];
        if (value < 32) {
          if (value === 12) {
            value = (value << 8) + encoded[++i];
          }
          switch (value) {
            case 1:
              if (!HINTING_ENABLED) {
                this.stack = [];
                break;
              }
              error = this.executeCommand(2, COMMAND_MAP.hstem);
              break;
            case 3:
              if (!HINTING_ENABLED) {
                this.stack = [];
                break;
              }
              error = this.executeCommand(2, COMMAND_MAP.vstem);
              break;
            case 4:
              if (this.flexing) {
                if (this.stack.length < 1) {
                  error = true;
                  break;
                }
                var dy = this.stack.pop();
                this.stack.push(0, dy);
                break;
              }
              error = this.executeCommand(1, COMMAND_MAP.vmoveto);
              break;
            case 5:
              error = this.executeCommand(2, COMMAND_MAP.rlineto);
              break;
            case 6:
              error = this.executeCommand(1, COMMAND_MAP.hlineto);
              break;
            case 7:
              error = this.executeCommand(1, COMMAND_MAP.vlineto);
              break;
            case 8:
              error = this.executeCommand(6, COMMAND_MAP.rrcurveto);
              break;
            case 9:
              this.stack = [];
              break;
            case 10:
              if (this.stack.length < 1) {
                error = true;
                break;
              }
              subrNumber = this.stack.pop();
              error = this.convert(subrs[subrNumber], subrs, seacAnalysisEnabled);
              break;
            case 11:
              return error;
            case 13:
              if (this.stack.length < 2) {
                error = true;
                break;
              }
              wx = this.stack.pop();
              sbx = this.stack.pop();
              this.lsb = sbx;
              this.width = wx;
              this.stack.push(wx, sbx);
              error = this.executeCommand(2, COMMAND_MAP.hmoveto);
              break;
            case 14:
              this.output.push(COMMAND_MAP.endchar[0]);
              break;
            case 21:
              if (this.flexing) {
                break;
              }
              error = this.executeCommand(2, COMMAND_MAP.rmoveto);
              break;
            case 22:
              if (this.flexing) {
                this.stack.push(0);
                break;
              }
              error = this.executeCommand(1, COMMAND_MAP.hmoveto);
              break;
            case 30:
              error = this.executeCommand(4, COMMAND_MAP.vhcurveto);
              break;
            case 31:
              error = this.executeCommand(4, COMMAND_MAP.hvcurveto);
              break;
            case (12 << 8) + 0:
              this.stack = [];
              break;
            case (12 << 8) + 1:
              if (!HINTING_ENABLED) {
                this.stack = [];
                break;
              }
              error = this.executeCommand(2, COMMAND_MAP.vstem);
              break;
            case (12 << 8) + 2:
              if (!HINTING_ENABLED) {
                this.stack = [];
                break;
              }
              error = this.executeCommand(2, COMMAND_MAP.hstem);
              break;
            case (12 << 8) + 6:
              if (seacAnalysisEnabled) {
                this.seac = this.stack.splice(-4, 4);
                error = this.executeCommand(0, COMMAND_MAP.endchar);
              } else {
                error = this.executeCommand(4, COMMAND_MAP.endchar);
              }
              break;
            case (12 << 8) + 7:
              if (this.stack.length < 4) {
                error = true;
                break;
              }
              this.stack.pop();
              wx = this.stack.pop();
              var sby = this.stack.pop();
              sbx = this.stack.pop();
              this.lsb = sbx;
              this.width = wx;
              this.stack.push(wx, sbx, sby);
              error = this.executeCommand(3, COMMAND_MAP.rmoveto);
              break;
            case (12 << 8) + 12:
              if (this.stack.length < 2) {
                error = true;
                break;
              }
              var num2 = this.stack.pop();
              var num1 = this.stack.pop();
              this.stack.push(num1 / num2);
              break;
            case (12 << 8) + 16:
              if (this.stack.length < 2) {
                error = true;
                break;
              }
              subrNumber = this.stack.pop();
              var numArgs = this.stack.pop();
              if (subrNumber === 0 && numArgs === 3) {
                var flexArgs = this.stack.splice(this.stack.length - 17, 17);
                this.stack.push(flexArgs[2] + flexArgs[0], flexArgs[3] + flexArgs[1], flexArgs[4], flexArgs[5], flexArgs[6], flexArgs[7], flexArgs[8], flexArgs[9], flexArgs[10], flexArgs[11], flexArgs[12], flexArgs[13], flexArgs[14]);
                error = this.executeCommand(13, COMMAND_MAP.flex, true);
                this.flexing = false;
                this.stack.push(flexArgs[15], flexArgs[16]);
              } else if (subrNumber === 1 && numArgs === 0) {
                this.flexing = true;
              }
              break;
            case (12 << 8) + 17:
              break;
            case (12 << 8) + 33:
              this.stack = [];
              break;
            default:
              (0, _util.warn)('Unknown type 1 charstring command of "' + value + '"');
              break;
          }
          if (error) {
            break;
          }
          continue;
        } else if (value <= 246) {
          value = value - 139;
        } else if (value <= 250) {
          value = (value - 247) * 256 + encoded[++i] + 108;
        } else if (value <= 254) {
          value = -((value - 251) * 256) - encoded[++i] - 108;
        } else {
          value = (encoded[++i] & 0xff) << 24 | (encoded[++i] & 0xff) << 16 | (encoded[++i] & 0xff) << 8 | (encoded[++i] & 0xff) << 0;
        }
        this.stack.push(value);
      }
      return error;
    },
    executeCommand: function executeCommand(howManyArgs, command, keepStack) {
      var stackLength = this.stack.length;
      if (howManyArgs > stackLength) {
        return true;
      }
      var start = stackLength - howManyArgs;
      for (var i = start; i < stackLength; i++) {
        var value = this.stack[i];
        if (value === (value | 0)) {
          this.output.push(28, value >> 8 & 0xff, value & 0xff);
        } else {
          value = 65536 * value | 0;
          this.output.push(255, value >> 24 & 0xFF, value >> 16 & 0xFF, value >> 8 & 0xFF, value & 0xFF);
        }
      }
      this.output.push.apply(this.output, command);
      if (keepStack) {
        this.stack.splice(start, howManyArgs);
      } else {
        this.stack.length = 0;
      }
      return false;
    }
  };
  return Type1CharString;
}();
var Type1Parser = function Type1ParserClosure() {
  var EEXEC_ENCRYPT_KEY = 55665;
  var CHAR_STRS_ENCRYPT_KEY = 4330;
  function isHexDigit(code) {
    return code >= 48 && code <= 57 || code >= 65 && code <= 70 || code >= 97 && code <= 102;
  }
  function decrypt(data, key, discardNumber) {
    if (discardNumber >= data.length) {
      return new Uint8Array(0);
    }
    var r = key | 0,
        c1 = 52845,
        c2 = 22719,
        i,
        j;
    for (i = 0; i < discardNumber; i++) {
      r = (data[i] + r) * c1 + c2 & (1 << 16) - 1;
    }
    var count = data.length - discardNumber;
    var decrypted = new Uint8Array(count);
    for (i = discardNumber, j = 0; j < count; i++, j++) {
      var value = data[i];
      decrypted[j] = value ^ r >> 8;
      r = (value + r) * c1 + c2 & (1 << 16) - 1;
    }
    return decrypted;
  }
  function decryptAscii(data, key, discardNumber) {
    var r = key | 0,
        c1 = 52845,
        c2 = 22719;
    var count = data.length,
        maybeLength = count >>> 1;
    var decrypted = new Uint8Array(maybeLength);
    var i, j;
    for (i = 0, j = 0; i < count; i++) {
      var digit1 = data[i];
      if (!isHexDigit(digit1)) {
        continue;
      }
      i++;
      var digit2;
      while (i < count && !isHexDigit(digit2 = data[i])) {
        i++;
      }
      if (i < count) {
        var value = parseInt(String.fromCharCode(digit1, digit2), 16);
        decrypted[j++] = value ^ r >> 8;
        r = (value + r) * c1 + c2 & (1 << 16) - 1;
      }
    }
    return Array.prototype.slice.call(decrypted, discardNumber, j);
  }
  function isSpecial(c) {
    return c === 0x2F || c === 0x5B || c === 0x5D || c === 0x7B || c === 0x7D || c === 0x28 || c === 0x29;
  }
  function Type1Parser(stream, encrypted, seacAnalysisEnabled) {
    if (encrypted) {
      var data = stream.getBytes();
      var isBinary = !(isHexDigit(data[0]) && isHexDigit(data[1]) && isHexDigit(data[2]) && isHexDigit(data[3]));
      stream = new _stream.Stream(isBinary ? decrypt(data, EEXEC_ENCRYPT_KEY, 4) : decryptAscii(data, EEXEC_ENCRYPT_KEY, 4));
    }
    this.seacAnalysisEnabled = !!seacAnalysisEnabled;
    this.stream = stream;
    this.nextChar();
  }
  Type1Parser.prototype = {
    readNumberArray: function Type1Parser_readNumberArray() {
      this.getToken();
      var array = [];
      while (true) {
        var token = this.getToken();
        if (token === null || token === ']' || token === '}') {
          break;
        }
        array.push(parseFloat(token || 0));
      }
      return array;
    },
    readNumber: function Type1Parser_readNumber() {
      var token = this.getToken();
      return parseFloat(token || 0);
    },
    readInt: function Type1Parser_readInt() {
      var token = this.getToken();
      return parseInt(token || 0, 10) | 0;
    },
    readBoolean: function Type1Parser_readBoolean() {
      var token = this.getToken();
      return token === 'true' ? 1 : 0;
    },
    nextChar: function Type1_nextChar() {
      return this.currentChar = this.stream.getByte();
    },
    getToken: function Type1Parser_getToken() {
      var comment = false;
      var ch = this.currentChar;
      while (true) {
        if (ch === -1) {
          return null;
        }
        if (comment) {
          if (ch === 0x0A || ch === 0x0D) {
            comment = false;
          }
        } else if (ch === 0x25) {
          comment = true;
        } else if (!(0, _util.isSpace)(ch)) {
          break;
        }
        ch = this.nextChar();
      }
      if (isSpecial(ch)) {
        this.nextChar();
        return String.fromCharCode(ch);
      }
      var token = '';
      do {
        token += String.fromCharCode(ch);
        ch = this.nextChar();
      } while (ch >= 0 && !(0, _util.isSpace)(ch) && !isSpecial(ch));
      return token;
    },
    extractFontProgram: function Type1Parser_extractFontProgram() {
      var stream = this.stream;
      var subrs = [],
          charstrings = [];
      var privateData = Object.create(null);
      privateData['lenIV'] = 4;
      var program = {
        subrs: [],
        charstrings: [],
        properties: { 'privateData': privateData }
      };
      var token, length, data, lenIV, encoded;
      while ((token = this.getToken()) !== null) {
        if (token !== '/') {
          continue;
        }
        token = this.getToken();
        switch (token) {
          case 'CharStrings':
            this.getToken();
            this.getToken();
            this.getToken();
            this.getToken();
            while (true) {
              token = this.getToken();
              if (token === null || token === 'end') {
                break;
              }
              if (token !== '/') {
                continue;
              }
              var glyph = this.getToken();
              length = this.readInt();
              this.getToken();
              data = stream.makeSubStream(stream.pos, length);
              lenIV = program.properties.privateData['lenIV'];
              encoded = decrypt(data.getBytes(), CHAR_STRS_ENCRYPT_KEY, lenIV);
              stream.skip(length);
              this.nextChar();
              token = this.getToken();
              if (token === 'noaccess') {
                this.getToken();
              }
              charstrings.push({
                glyph: glyph,
                encoded: encoded
              });
            }
            break;
          case 'Subrs':
            this.readInt();
            this.getToken();
            while ((token = this.getToken()) === 'dup') {
              var index = this.readInt();
              length = this.readInt();
              this.getToken();
              data = stream.makeSubStream(stream.pos, length);
              lenIV = program.properties.privateData['lenIV'];
              encoded = decrypt(data.getBytes(), CHAR_STRS_ENCRYPT_KEY, lenIV);
              stream.skip(length);
              this.nextChar();
              token = this.getToken();
              if (token === 'noaccess') {
                this.getToken();
              }
              subrs[index] = encoded;
            }
            break;
          case 'BlueValues':
          case 'OtherBlues':
          case 'FamilyBlues':
          case 'FamilyOtherBlues':
            var blueArray = this.readNumberArray();
            if (blueArray.length > 0 && blueArray.length % 2 === 0 && HINTING_ENABLED) {
              program.properties.privateData[token] = blueArray;
            }
            break;
          case 'StemSnapH':
          case 'StemSnapV':
            program.properties.privateData[token] = this.readNumberArray();
            break;
          case 'StdHW':
          case 'StdVW':
            program.properties.privateData[token] = this.readNumberArray()[0];
            break;
          case 'BlueShift':
          case 'lenIV':
          case 'BlueFuzz':
          case 'BlueScale':
          case 'LanguageGroup':
          case 'ExpansionFactor':
            program.properties.privateData[token] = this.readNumber();
            break;
          case 'ForceBold':
            program.properties.privateData[token] = this.readBoolean();
            break;
        }
      }
      for (var i = 0; i < charstrings.length; i++) {
        glyph = charstrings[i].glyph;
        encoded = charstrings[i].encoded;
        var charString = new Type1CharString();
        var error = charString.convert(encoded, subrs, this.seacAnalysisEnabled);
        var output = charString.output;
        if (error) {
          output = [14];
        }
        program.charstrings.push({
          glyphName: glyph,
          charstring: output,
          width: charString.width,
          lsb: charString.lsb,
          seac: charString.seac
        });
      }
      return program;
    },
    extractFontHeader: function Type1Parser_extractFontHeader(properties) {
      var token;
      while ((token = this.getToken()) !== null) {
        if (token !== '/') {
          continue;
        }
        token = this.getToken();
        switch (token) {
          case 'FontMatrix':
            var matrix = this.readNumberArray();
            properties.fontMatrix = matrix;
            break;
          case 'Encoding':
            var encodingArg = this.getToken();
            var encoding;
            if (!/^\d+$/.test(encodingArg)) {
              encoding = (0, _encodings.getEncoding)(encodingArg);
            } else {
              encoding = [];
              var size = parseInt(encodingArg, 10) | 0;
              this.getToken();
              for (var j = 0; j < size; j++) {
                token = this.getToken();
                while (token !== 'dup' && token !== 'def') {
                  token = this.getToken();
                  if (token === null) {
                    return;
                  }
                }
                if (token === 'def') {
                  break;
                }
                var index = this.readInt();
                this.getToken();
                var glyph = this.getToken();
                encoding[index] = glyph;
                this.getToken();
              }
            }
            properties.builtInEncoding = encoding;
            break;
          case 'FontBBox':
            var fontBBox = this.readNumberArray();
            properties.ascent = Math.max(fontBBox[3], fontBBox[1]);
            properties.descent = Math.min(fontBBox[1], fontBBox[3]);
            properties.ascentScaled = true;
            break;
        }
      }
    }
  };
  return Type1Parser;
}();
exports.Type1Parser = Type1Parser;

/***/ }),
/* 35 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var pdfjsVersion = '1.8.619';
var pdfjsBuild = '723bc25b';
var pdfjsCoreWorker = __w_pdfjs_require__(17);
exports.WorkerMessageHandler = pdfjsCoreWorker.WorkerMessageHandler;

/***/ }),
/* 36 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

if (typeof PDFJS === 'undefined' || !PDFJS.compatibilityChecked) {
  var globalScope = typeof window !== 'undefined' && window.Math === Math ? window : typeof global !== 'undefined' && global.Math === Math ? global : typeof self !== 'undefined' && self.Math === Math ? self :  false ? undefined : {};
  var userAgent = typeof navigator !== 'undefined' && navigator.userAgent || '';
  var isAndroid = /Android/.test(userAgent);
  var isAndroidPre3 = /Android\s[0-2][^\d]/.test(userAgent);
  var isAndroidPre5 = /Android\s[0-4][^\d]/.test(userAgent);
  var isChrome = userAgent.indexOf('Chrom') >= 0;
  var isChromeWithRangeBug = /Chrome\/(39|40)\./.test(userAgent);
  var isIOSChrome = userAgent.indexOf('CriOS') >= 0;
  var isIE = userAgent.indexOf('Trident') >= 0;
  var isIOS = /\b(iPad|iPhone|iPod)(?=;)/.test(userAgent);
  var isOpera = userAgent.indexOf('Opera') >= 0;
  var isSafari = /Safari\//.test(userAgent) && !/(Chrome\/|Android\s)/.test(userAgent);
  var hasDOM = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && (typeof document === 'undefined' ? 'undefined' : _typeof(document)) === 'object';
  if (typeof PDFJS === 'undefined') {
    globalScope.PDFJS = {};
  }
  PDFJS.compatibilityChecked = true;
  (function checkTypedArrayCompatibility() {
    if (typeof Uint8Array !== 'undefined') {
      if (typeof Uint8Array.prototype.subarray === 'undefined') {
        Uint8Array.prototype.subarray = function subarray(start, end) {
          return new Uint8Array(this.slice(start, end));
        };
        Float32Array.prototype.subarray = function subarray(start, end) {
          return new Float32Array(this.slice(start, end));
        };
      }
      if (typeof Float64Array === 'undefined') {
        globalScope.Float64Array = Float32Array;
      }
      return;
    }
    function subarray(start, end) {
      return new TypedArray(this.slice(start, end));
    }
    function setArrayOffset(array, offset) {
      if (arguments.length < 2) {
        offset = 0;
      }
      for (var i = 0, n = array.length; i < n; ++i, ++offset) {
        this[offset] = array[i] & 0xFF;
      }
    }
    function Uint32ArrayView(buffer, length) {
      this.buffer = buffer;
      this.byteLength = buffer.length;
      this.length = length;
      ensureUint32ArrayViewProps(this.length);
    }
    Uint32ArrayView.prototype = Object.create(null);
    var uint32ArrayViewSetters = 0;
    function createUint32ArrayProp(index) {
      return {
        get: function get() {
          var buffer = this.buffer,
              offset = index << 2;
          return (buffer[offset] | buffer[offset + 1] << 8 | buffer[offset + 2] << 16 | buffer[offset + 3] << 24) >>> 0;
        },
        set: function set(value) {
          var buffer = this.buffer,
              offset = index << 2;
          buffer[offset] = value & 255;
          buffer[offset + 1] = value >> 8 & 255;
          buffer[offset + 2] = value >> 16 & 255;
          buffer[offset + 3] = value >>> 24 & 255;
        }
      };
    }
    function ensureUint32ArrayViewProps(length) {
      while (uint32ArrayViewSetters < length) {
        Object.defineProperty(Uint32ArrayView.prototype, uint32ArrayViewSetters, createUint32ArrayProp(uint32ArrayViewSetters));
        uint32ArrayViewSetters++;
      }
    }
    function TypedArray(arg1) {
      var result, i, n;
      if (typeof arg1 === 'number') {
        result = [];
        for (i = 0; i < arg1; ++i) {
          result[i] = 0;
        }
      } else if ('slice' in arg1) {
        result = arg1.slice(0);
      } else {
        result = [];
        for (i = 0, n = arg1.length; i < n; ++i) {
          result[i] = arg1[i];
        }
      }
      result.subarray = subarray;
      result.buffer = result;
      result.byteLength = result.length;
      result.set = setArrayOffset;
      if ((typeof arg1 === 'undefined' ? 'undefined' : _typeof(arg1)) === 'object' && arg1.buffer) {
        result.buffer = arg1.buffer;
      }
      return result;
    }
    globalScope.Uint8Array = TypedArray;
    globalScope.Int8Array = TypedArray;
    globalScope.Int32Array = TypedArray;
    globalScope.Uint16Array = TypedArray;
    globalScope.Float32Array = TypedArray;
    globalScope.Float64Array = TypedArray;
    globalScope.Uint32Array = function () {
      if (arguments.length === 3) {
        if (arguments[1] !== 0) {
          throw new Error('offset !== 0 is not supported');
        }
        return new Uint32ArrayView(arguments[0], arguments[2]);
      }
      return TypedArray.apply(this, arguments);
    };
  })();
  (function canvasPixelArrayBuffer() {
    if (!hasDOM || !window.CanvasPixelArray) {
      return;
    }
    var cpaProto = window.CanvasPixelArray.prototype;
    if ('buffer' in cpaProto) {
      return;
    }
    Object.defineProperty(cpaProto, 'buffer', {
      get: function get() {
        return this;
      },

      enumerable: false,
      configurable: true
    });
    Object.defineProperty(cpaProto, 'byteLength', {
      get: function get() {
        return this.length;
      },

      enumerable: false,
      configurable: true
    });
  })();
  (function normalizeURLObject() {
    if (!globalScope.URL) {
      globalScope.URL = globalScope.webkitURL;
    }
  })();
  (function checkObjectDefinePropertyCompatibility() {
    if (typeof Object.defineProperty !== 'undefined') {
      var definePropertyPossible = true;
      try {
        if (hasDOM) {
          Object.defineProperty(new Image(), 'id', { value: 'test' });
        }
        var Test = function Test() {};
        Test.prototype = {
          get id() {}
        };
        Object.defineProperty(new Test(), 'id', {
          value: '',
          configurable: true,
          enumerable: true,
          writable: false
        });
      } catch (e) {
        definePropertyPossible = false;
      }
      if (definePropertyPossible) {
        return;
      }
    }
    Object.defineProperty = function objectDefineProperty(obj, name, def) {
      delete obj[name];
      if ('get' in def) {
        obj.__defineGetter__(name, def['get']);
      }
      if ('set' in def) {
        obj.__defineSetter__(name, def['set']);
      }
      if ('value' in def) {
        obj.__defineSetter__(name, function objectDefinePropertySetter(value) {
          this.__defineGetter__(name, function objectDefinePropertyGetter() {
            return value;
          });
          return value;
        });
        obj[name] = def.value;
      }
    };
  })();
  (function checkXMLHttpRequestResponseCompatibility() {
    if (typeof XMLHttpRequest === 'undefined') {
      return;
    }
    var xhrPrototype = XMLHttpRequest.prototype;
    var xhr = new XMLHttpRequest();
    if (!('overrideMimeType' in xhr)) {
      Object.defineProperty(xhrPrototype, 'overrideMimeType', {
        value: function xmlHttpRequestOverrideMimeType(mimeType) {}
      });
    }
    if ('responseType' in xhr) {
      return;
    }
    Object.defineProperty(xhrPrototype, 'responseType', {
      get: function xmlHttpRequestGetResponseType() {
        return this._responseType || 'text';
      },
      set: function xmlHttpRequestSetResponseType(value) {
        if (value === 'text' || value === 'arraybuffer') {
          this._responseType = value;
          if (value === 'arraybuffer' && typeof this.overrideMimeType === 'function') {
            this.overrideMimeType('text/plain; charset=x-user-defined');
          }
        }
      }
    });
    if (typeof VBArray !== 'undefined') {
      Object.defineProperty(xhrPrototype, 'response', {
        get: function xmlHttpRequestResponseGet() {
          if (this.responseType === 'arraybuffer') {
            return new Uint8Array(new VBArray(this.responseBody).toArray());
          }
          return this.responseText;
        }
      });
      return;
    }
    Object.defineProperty(xhrPrototype, 'response', {
      get: function xmlHttpRequestResponseGet() {
        if (this.responseType !== 'arraybuffer') {
          return this.responseText;
        }
        var text = this.responseText;
        var i,
            n = text.length;
        var result = new Uint8Array(n);
        for (i = 0; i < n; ++i) {
          result[i] = text.charCodeAt(i) & 0xFF;
        }
        return result.buffer;
      }
    });
  })();
  (function checkWindowBtoaCompatibility() {
    if ('btoa' in globalScope) {
      return;
    }
    var digits = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    globalScope.btoa = function (chars) {
      var buffer = '';
      var i, n;
      for (i = 0, n = chars.length; i < n; i += 3) {
        var b1 = chars.charCodeAt(i) & 0xFF;
        var b2 = chars.charCodeAt(i + 1) & 0xFF;
        var b3 = chars.charCodeAt(i + 2) & 0xFF;
        var d1 = b1 >> 2,
            d2 = (b1 & 3) << 4 | b2 >> 4;
        var d3 = i + 1 < n ? (b2 & 0xF) << 2 | b3 >> 6 : 64;
        var d4 = i + 2 < n ? b3 & 0x3F : 64;
        buffer += digits.charAt(d1) + digits.charAt(d2) + digits.charAt(d3) + digits.charAt(d4);
      }
      return buffer;
    };
  })();
  (function checkWindowAtobCompatibility() {
    if ('atob' in globalScope) {
      return;
    }
    var digits = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    globalScope.atob = function (input) {
      input = input.replace(/=+$/, '');
      if (input.length % 4 === 1) {
        throw new Error('bad atob input');
      }
      for (var bc = 0, bs, buffer, idx = 0, output = ''; buffer = input.charAt(idx++); ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer, bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0) {
        buffer = digits.indexOf(buffer);
      }
      return output;
    };
  })();
  (function checkFunctionPrototypeBindCompatibility() {
    if (typeof Function.prototype.bind !== 'undefined') {
      return;
    }
    Function.prototype.bind = function functionPrototypeBind(obj) {
      var fn = this,
          headArgs = Array.prototype.slice.call(arguments, 1);
      var bound = function functionPrototypeBindBound() {
        var args = headArgs.concat(Array.prototype.slice.call(arguments));
        return fn.apply(obj, args);
      };
      return bound;
    };
  })();
  (function checkDatasetProperty() {
    if (!hasDOM) {
      return;
    }
    var div = document.createElement('div');
    if ('dataset' in div) {
      return;
    }
    Object.defineProperty(HTMLElement.prototype, 'dataset', {
      get: function get() {
        if (this._dataset) {
          return this._dataset;
        }
        var dataset = {};
        for (var j = 0, jj = this.attributes.length; j < jj; j++) {
          var attribute = this.attributes[j];
          if (attribute.name.substring(0, 5) !== 'data-') {
            continue;
          }
          var key = attribute.name.substring(5).replace(/\-([a-z])/g, function (all, ch) {
            return ch.toUpperCase();
          });
          dataset[key] = attribute.value;
        }
        Object.defineProperty(this, '_dataset', {
          value: dataset,
          writable: false,
          enumerable: false
        });
        return dataset;
      },

      enumerable: true
    });
  })();
  (function checkClassListProperty() {
    function changeList(element, itemName, add, remove) {
      var s = element.className || '';
      var list = s.split(/\s+/g);
      if (list[0] === '') {
        list.shift();
      }
      var index = list.indexOf(itemName);
      if (index < 0 && add) {
        list.push(itemName);
      }
      if (index >= 0 && remove) {
        list.splice(index, 1);
      }
      element.className = list.join(' ');
      return index >= 0;
    }
    if (!hasDOM) {
      return;
    }
    var div = document.createElement('div');
    if ('classList' in div) {
      return;
    }
    var classListPrototype = {
      add: function add(name) {
        changeList(this.element, name, true, false);
      },
      contains: function contains(name) {
        return changeList(this.element, name, false, false);
      },
      remove: function remove(name) {
        changeList(this.element, name, false, true);
      },
      toggle: function toggle(name) {
        changeList(this.element, name, true, true);
      }
    };
    Object.defineProperty(HTMLElement.prototype, 'classList', {
      get: function get() {
        if (this._classList) {
          return this._classList;
        }
        var classList = Object.create(classListPrototype, {
          element: {
            value: this,
            writable: false,
            enumerable: true
          }
        });
        Object.defineProperty(this, '_classList', {
          value: classList,
          writable: false,
          enumerable: false
        });
        return classList;
      },

      enumerable: true
    });
  })();
  (function checkWorkerConsoleCompatibility() {
    if (typeof importScripts === 'undefined' || 'console' in globalScope) {
      return;
    }
    var consoleTimer = {};
    var workerConsole = {
      log: function log() {
        var args = Array.prototype.slice.call(arguments);
        globalScope.postMessage({
          targetName: 'main',
          action: 'console_log',
          data: args
        });
      },
      error: function error() {
        var args = Array.prototype.slice.call(arguments);
        globalScope.postMessage({
          targetName: 'main',
          action: 'console_error',
          data: args
        });
      },
      time: function time(name) {
        consoleTimer[name] = Date.now();
      },
      timeEnd: function timeEnd(name) {
        var time = consoleTimer[name];
        if (!time) {
          throw new Error('Unknown timer name ' + name);
        }
        this.log('Timer:', name, Date.now() - time);
      }
    };
    globalScope.console = workerConsole;
  })();
  (function checkConsoleCompatibility() {
    if (!hasDOM) {
      return;
    }
    if (!('console' in window)) {
      window.console = {
        log: function log() {},
        error: function error() {},
        warn: function warn() {}
      };
      return;
    }
    if (!('bind' in console.log)) {
      console.log = function (fn) {
        return function (msg) {
          return fn(msg);
        };
      }(console.log);
      console.error = function (fn) {
        return function (msg) {
          return fn(msg);
        };
      }(console.error);
      console.warn = function (fn) {
        return function (msg) {
          return fn(msg);
        };
      }(console.warn);
      return;
    }
  })();
  (function checkOnClickCompatibility() {
    function ignoreIfTargetDisabled(event) {
      if (isDisabled(event.target)) {
        event.stopPropagation();
      }
    }
    function isDisabled(node) {
      return node.disabled || node.parentNode && isDisabled(node.parentNode);
    }
    if (isOpera) {
      document.addEventListener('click', ignoreIfTargetDisabled, true);
    }
  })();
  (function checkOnBlobSupport() {
    if (isIE || isIOSChrome) {
      PDFJS.disableCreateObjectURL = true;
    }
  })();
  (function checkNavigatorLanguage() {
    if (typeof navigator === 'undefined') {
      return;
    }
    if ('language' in navigator) {
      return;
    }
    PDFJS.locale = navigator.userLanguage || 'en-US';
  })();
  (function checkRangeRequests() {
    if (isSafari || isAndroidPre3 || isChromeWithRangeBug || isIOS) {
      PDFJS.disableRange = true;
      PDFJS.disableStream = true;
    }
  })();
  (function checkHistoryManipulation() {
    if (!hasDOM) {
      return;
    }
    if (!history.pushState || isAndroidPre3) {
      PDFJS.disableHistory = true;
    }
  })();
  (function checkSetPresenceInImageData() {
    if (!hasDOM) {
      return;
    }
    if (window.CanvasPixelArray) {
      if (typeof window.CanvasPixelArray.prototype.set !== 'function') {
        window.CanvasPixelArray.prototype.set = function (arr) {
          for (var i = 0, ii = this.length; i < ii; i++) {
            this[i] = arr[i];
          }
        };
      }
    } else {
      var polyfill = false,
          versionMatch;
      if (isChrome) {
        versionMatch = userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
        polyfill = versionMatch && parseInt(versionMatch[2]) < 21;
      } else if (isAndroid) {
        polyfill = isAndroidPre5;
      } else if (isSafari) {
        versionMatch = userAgent.match(/Version\/([0-9]+)\.([0-9]+)\.([0-9]+) Safari\//);
        polyfill = versionMatch && parseInt(versionMatch[1]) < 6;
      }
      if (polyfill) {
        var contextPrototype = window.CanvasRenderingContext2D.prototype;
        var createImageData = contextPrototype.createImageData;
        contextPrototype.createImageData = function (w, h) {
          var imageData = createImageData.call(this, w, h);
          imageData.data.set = function (arr) {
            for (var i = 0, ii = this.length; i < ii; i++) {
              this[i] = arr[i];
            }
          };
          return imageData;
        };
        contextPrototype = null;
      }
    }
  })();
  (function checkRequestAnimationFrame() {
    function installFakeAnimationFrameFunctions() {
      window.requestAnimationFrame = function (callback) {
        return window.setTimeout(callback, 20);
      };
      window.cancelAnimationFrame = function (timeoutID) {
        window.clearTimeout(timeoutID);
      };
    }
    if (!hasDOM) {
      return;
    }
    if (isIOS) {
      installFakeAnimationFrameFunctions();
      return;
    }
    if ('requestAnimationFrame' in window) {
      return;
    }
    window.requestAnimationFrame = window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame;
    if (window.requestAnimationFrame) {
      return;
    }
    installFakeAnimationFrameFunctions();
  })();
  (function checkCanvasSizeLimitation() {
    if (isIOS || isAndroid) {
      PDFJS.maxCanvasPixels = 5242880;
    }
  })();
  (function checkFullscreenSupport() {
    if (!hasDOM) {
      return;
    }
    if (isIE && window.parent !== window) {
      PDFJS.disableFullscreen = true;
    }
  })();
  (function checkCurrentScript() {
    if (!hasDOM) {
      return;
    }
    if ('currentScript' in document) {
      return;
    }
    Object.defineProperty(document, 'currentScript', {
      get: function get() {
        var scripts = document.getElementsByTagName('script');
        return scripts[scripts.length - 1];
      },

      enumerable: true,
      configurable: true
    });
  })();
  (function checkInputTypeNumberAssign() {
    if (!hasDOM) {
      return;
    }
    var el = document.createElement('input');
    try {
      el.type = 'number';
    } catch (ex) {
      var inputProto = el.constructor.prototype;
      var typeProperty = Object.getOwnPropertyDescriptor(inputProto, 'type');
      Object.defineProperty(inputProto, 'type', {
        get: function get() {
          return typeProperty.get.call(this);
        },
        set: function set(value) {
          typeProperty.set.call(this, value === 'number' ? 'text' : value);
        },

        enumerable: true,
        configurable: true
      });
    }
  })();
  (function checkDocumentReadyState() {
    if (!hasDOM) {
      return;
    }
    if (!document.attachEvent) {
      return;
    }
    var documentProto = document.constructor.prototype;
    var readyStateProto = Object.getOwnPropertyDescriptor(documentProto, 'readyState');
    Object.defineProperty(documentProto, 'readyState', {
      get: function get() {
        var value = readyStateProto.get.call(this);
        return value === 'interactive' ? 'loading' : value;
      },
      set: function set(value) {
        readyStateProto.set.call(this, value);
      },

      enumerable: true,
      configurable: true
    });
  })();
  (function checkChildNodeRemove() {
    if (!hasDOM) {
      return;
    }
    if (typeof Element.prototype.remove !== 'undefined') {
      return;
    }
    Element.prototype.remove = function () {
      if (this.parentNode) {
        this.parentNode.removeChild(this);
      }
    };
  })();
  (function checkNumberIsNaN() {
    if (Number.isNaN) {
      return;
    }
    Number.isNaN = function (value) {
      return typeof value === 'number' && isNaN(value);
    };
  })();
  (function checkNumberIsInteger() {
    if (Number.isInteger) {
      return;
    }
    Number.isInteger = function (value) {
      return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
    };
  })();
  (function checkPromise() {
    if (globalScope.Promise) {
      if (typeof globalScope.Promise.all !== 'function') {
        globalScope.Promise.all = function (iterable) {
          var count = 0,
              results = [],
              resolve,
              reject;
          var promise = new globalScope.Promise(function (resolve_, reject_) {
            resolve = resolve_;
            reject = reject_;
          });
          iterable.forEach(function (p, i) {
            count++;
            p.then(function (result) {
              results[i] = result;
              count--;
              if (count === 0) {
                resolve(results);
              }
            }, reject);
          });
          if (count === 0) {
            resolve(results);
          }
          return promise;
        };
      }
      if (typeof globalScope.Promise.resolve !== 'function') {
        globalScope.Promise.resolve = function (value) {
          return new globalScope.Promise(function (resolve) {
            resolve(value);
          });
        };
      }
      if (typeof globalScope.Promise.reject !== 'function') {
        globalScope.Promise.reject = function (reason) {
          return new globalScope.Promise(function (resolve, reject) {
            reject(reason);
          });
        };
      }
      if (typeof globalScope.Promise.prototype.catch !== 'function') {
        globalScope.Promise.prototype.catch = function (onReject) {
          return globalScope.Promise.prototype.then(undefined, onReject);
        };
      }
      return;
    }
    var STATUS_PENDING = 0;
    var STATUS_RESOLVED = 1;
    var STATUS_REJECTED = 2;
    var REJECTION_TIMEOUT = 500;
    var HandlerManager = {
      handlers: [],
      running: false,
      unhandledRejections: [],
      pendingRejectionCheck: false,
      scheduleHandlers: function scheduleHandlers(promise) {
        if (promise._status === STATUS_PENDING) {
          return;
        }
        this.handlers = this.handlers.concat(promise._handlers);
        promise._handlers = [];
        if (this.running) {
          return;
        }
        this.running = true;
        setTimeout(this.runHandlers.bind(this), 0);
      },
      runHandlers: function runHandlers() {
        var RUN_TIMEOUT = 1;
        var timeoutAt = Date.now() + RUN_TIMEOUT;
        while (this.handlers.length > 0) {
          var handler = this.handlers.shift();
          var nextStatus = handler.thisPromise._status;
          var nextValue = handler.thisPromise._value;
          try {
            if (nextStatus === STATUS_RESOLVED) {
              if (typeof handler.onResolve === 'function') {
                nextValue = handler.onResolve(nextValue);
              }
            } else if (typeof handler.onReject === 'function') {
              nextValue = handler.onReject(nextValue);
              nextStatus = STATUS_RESOLVED;
              if (handler.thisPromise._unhandledRejection) {
                this.removeUnhandeledRejection(handler.thisPromise);
              }
            }
          } catch (ex) {
            nextStatus = STATUS_REJECTED;
            nextValue = ex;
          }
          handler.nextPromise._updateStatus(nextStatus, nextValue);
          if (Date.now() >= timeoutAt) {
            break;
          }
        }
        if (this.handlers.length > 0) {
          setTimeout(this.runHandlers.bind(this), 0);
          return;
        }
        this.running = false;
      },
      addUnhandledRejection: function addUnhandledRejection(promise) {
        this.unhandledRejections.push({
          promise: promise,
          time: Date.now()
        });
        this.scheduleRejectionCheck();
      },
      removeUnhandeledRejection: function removeUnhandeledRejection(promise) {
        promise._unhandledRejection = false;
        for (var i = 0; i < this.unhandledRejections.length; i++) {
          if (this.unhandledRejections[i].promise === promise) {
            this.unhandledRejections.splice(i);
            i--;
          }
        }
      },
      scheduleRejectionCheck: function scheduleRejectionCheck() {
        var _this = this;

        if (this.pendingRejectionCheck) {
          return;
        }
        this.pendingRejectionCheck = true;
        setTimeout(function () {
          _this.pendingRejectionCheck = false;
          var now = Date.now();
          for (var i = 0; i < _this.unhandledRejections.length; i++) {
            if (now - _this.unhandledRejections[i].time > REJECTION_TIMEOUT) {
              var unhandled = _this.unhandledRejections[i].promise._value;
              var msg = 'Unhandled rejection: ' + unhandled;
              if (unhandled.stack) {
                msg += '\n' + unhandled.stack;
              }
              try {
                throw new Error(msg);
              } catch (_) {
                console.warn(msg);
              }
              _this.unhandledRejections.splice(i);
              i--;
            }
          }
          if (_this.unhandledRejections.length) {
            _this.scheduleRejectionCheck();
          }
        }, REJECTION_TIMEOUT);
      }
    };
    var Promise = function Promise(resolver) {
      this._status = STATUS_PENDING;
      this._handlers = [];
      try {
        resolver.call(this, this._resolve.bind(this), this._reject.bind(this));
      } catch (e) {
        this._reject(e);
      }
    };
    Promise.all = function Promise_all(promises) {
      var resolveAll, rejectAll;
      var deferred = new Promise(function (resolve, reject) {
        resolveAll = resolve;
        rejectAll = reject;
      });
      var unresolved = promises.length;
      var results = [];
      if (unresolved === 0) {
        resolveAll(results);
        return deferred;
      }
      function reject(reason) {
        if (deferred._status === STATUS_REJECTED) {
          return;
        }
        results = [];
        rejectAll(reason);
      }
      for (var i = 0, ii = promises.length; i < ii; ++i) {
        var promise = promises[i];
        var resolve = function (i) {
          return function (value) {
            if (deferred._status === STATUS_REJECTED) {
              return;
            }
            results[i] = value;
            unresolved--;
            if (unresolved === 0) {
              resolveAll(results);
            }
          };
        }(i);
        if (Promise.isPromise(promise)) {
          promise.then(resolve, reject);
        } else {
          resolve(promise);
        }
      }
      return deferred;
    };
    Promise.isPromise = function Promise_isPromise(value) {
      return value && typeof value.then === 'function';
    };
    Promise.resolve = function Promise_resolve(value) {
      return new Promise(function (resolve) {
        resolve(value);
      });
    };
    Promise.reject = function Promise_reject(reason) {
      return new Promise(function (resolve, reject) {
        reject(reason);
      });
    };
    Promise.prototype = {
      _status: null,
      _value: null,
      _handlers: null,
      _unhandledRejection: null,
      _updateStatus: function Promise__updateStatus(status, value) {
        if (this._status === STATUS_RESOLVED || this._status === STATUS_REJECTED) {
          return;
        }
        if (status === STATUS_RESOLVED && Promise.isPromise(value)) {
          value.then(this._updateStatus.bind(this, STATUS_RESOLVED), this._updateStatus.bind(this, STATUS_REJECTED));
          return;
        }
        this._status = status;
        this._value = value;
        if (status === STATUS_REJECTED && this._handlers.length === 0) {
          this._unhandledRejection = true;
          HandlerManager.addUnhandledRejection(this);
        }
        HandlerManager.scheduleHandlers(this);
      },
      _resolve: function Promise_resolve(value) {
        this._updateStatus(STATUS_RESOLVED, value);
      },
      _reject: function Promise_reject(reason) {
        this._updateStatus(STATUS_REJECTED, reason);
      },
      then: function Promise_then(onResolve, onReject) {
        var nextPromise = new Promise(function (resolve, reject) {
          this.resolve = resolve;
          this.reject = reject;
        });
        this._handlers.push({
          thisPromise: this,
          onResolve: onResolve,
          onReject: onReject,
          nextPromise: nextPromise
        });
        HandlerManager.scheduleHandlers(this);
        return nextPromise;
      },
      catch: function Promise_catch(onReject) {
        return this.then(undefined, onReject);
      }
    };
    globalScope.Promise = Promise;
  })();
  (function checkWeakMap() {
    if (globalScope.WeakMap) {
      return;
    }
    var id = 0;
    function WeakMap() {
      this.id = '$weakmap' + id++;
    }
    WeakMap.prototype = {
      has: function has(obj) {
        if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' && typeof obj !== 'function' || obj === null) {
          return false;
        }
        return !!Object.getOwnPropertyDescriptor(obj, this.id);
      },
      get: function get(obj) {
        return this.has(obj) ? obj[this.id] : undefined;
      },
      set: function set(obj, value) {
        Object.defineProperty(obj, this.id, {
          value: value,
          enumerable: false,
          configurable: true
        });
      },
      delete: function _delete(obj) {
        delete obj[this.id];
      }
    };
    globalScope.WeakMap = WeakMap;
  })();
  (function checkURLConstructor() {
    var hasWorkingUrl = false;
    try {
      if (typeof URL === 'function' && _typeof(URL.prototype) === 'object' && 'origin' in URL.prototype) {
        var u = new URL('b', 'http://a');
        u.pathname = 'c%20d';
        hasWorkingUrl = u.href === 'http://a/c%20d';
      }
    } catch (e) {}
    if (hasWorkingUrl) {
      return;
    }
    var relative = Object.create(null);
    relative['ftp'] = 21;
    relative['file'] = 0;
    relative['gopher'] = 70;
    relative['http'] = 80;
    relative['https'] = 443;
    relative['ws'] = 80;
    relative['wss'] = 443;
    var relativePathDotMapping = Object.create(null);
    relativePathDotMapping['%2e'] = '.';
    relativePathDotMapping['.%2e'] = '..';
    relativePathDotMapping['%2e.'] = '..';
    relativePathDotMapping['%2e%2e'] = '..';
    function isRelativeScheme(scheme) {
      return relative[scheme] !== undefined;
    }
    function invalid() {
      clear.call(this);
      this._isInvalid = true;
    }
    function IDNAToASCII(h) {
      if (h === '') {
        invalid.call(this);
      }
      return h.toLowerCase();
    }
    function percentEscape(c) {
      var unicode = c.charCodeAt(0);
      if (unicode > 0x20 && unicode < 0x7F && [0x22, 0x23, 0x3C, 0x3E, 0x3F, 0x60].indexOf(unicode) === -1) {
        return c;
      }
      return encodeURIComponent(c);
    }
    function percentEscapeQuery(c) {
      var unicode = c.charCodeAt(0);
      if (unicode > 0x20 && unicode < 0x7F && [0x22, 0x23, 0x3C, 0x3E, 0x60].indexOf(unicode) === -1) {
        return c;
      }
      return encodeURIComponent(c);
    }
    var EOF,
        ALPHA = /[a-zA-Z]/,
        ALPHANUMERIC = /[a-zA-Z0-9\+\-\.]/;
    function parse(input, stateOverride, base) {
      function err(message) {
        errors.push(message);
      }
      var state = stateOverride || 'scheme start',
          cursor = 0,
          buffer = '',
          seenAt = false,
          seenBracket = false,
          errors = [];
      loop: while ((input[cursor - 1] !== EOF || cursor === 0) && !this._isInvalid) {
        var c = input[cursor];
        switch (state) {
          case 'scheme start':
            if (c && ALPHA.test(c)) {
              buffer += c.toLowerCase();
              state = 'scheme';
            } else if (!stateOverride) {
              buffer = '';
              state = 'no scheme';
              continue;
            } else {
              err('Invalid scheme.');
              break loop;
            }
            break;
          case 'scheme':
            if (c && ALPHANUMERIC.test(c)) {
              buffer += c.toLowerCase();
            } else if (c === ':') {
              this._scheme = buffer;
              buffer = '';
              if (stateOverride) {
                break loop;
              }
              if (isRelativeScheme(this._scheme)) {
                this._isRelative = true;
              }
              if (this._scheme === 'file') {
                state = 'relative';
              } else if (this._isRelative && base && base._scheme === this._scheme) {
                state = 'relative or authority';
              } else if (this._isRelative) {
                state = 'authority first slash';
              } else {
                state = 'scheme data';
              }
            } else if (!stateOverride) {
              buffer = '';
              cursor = 0;
              state = 'no scheme';
              continue;
            } else if (c === EOF) {
              break loop;
            } else {
              err('Code point not allowed in scheme: ' + c);
              break loop;
            }
            break;
          case 'scheme data':
            if (c === '?') {
              this._query = '?';
              state = 'query';
            } else if (c === '#') {
              this._fragment = '#';
              state = 'fragment';
            } else {
              if (c !== EOF && c !== '\t' && c !== '\n' && c !== '\r') {
                this._schemeData += percentEscape(c);
              }
            }
            break;
          case 'no scheme':
            if (!base || !isRelativeScheme(base._scheme)) {
              err('Missing scheme.');
              invalid.call(this);
            } else {
              state = 'relative';
              continue;
            }
            break;
          case 'relative or authority':
            if (c === '/' && input[cursor + 1] === '/') {
              state = 'authority ignore slashes';
            } else {
              err('Expected /, got: ' + c);
              state = 'relative';
              continue;
            }
            break;
          case 'relative':
            this._isRelative = true;
            if (this._scheme !== 'file') {
              this._scheme = base._scheme;
            }
            if (c === EOF) {
              this._host = base._host;
              this._port = base._port;
              this._path = base._path.slice();
              this._query = base._query;
              this._username = base._username;
              this._password = base._password;
              break loop;
            } else if (c === '/' || c === '\\') {
              if (c === '\\') {
                err('\\ is an invalid code point.');
              }
              state = 'relative slash';
            } else if (c === '?') {
              this._host = base._host;
              this._port = base._port;
              this._path = base._path.slice();
              this._query = '?';
              this._username = base._username;
              this._password = base._password;
              state = 'query';
            } else if (c === '#') {
              this._host = base._host;
              this._port = base._port;
              this._path = base._path.slice();
              this._query = base._query;
              this._fragment = '#';
              this._username = base._username;
              this._password = base._password;
              state = 'fragment';
            } else {
              var nextC = input[cursor + 1];
              var nextNextC = input[cursor + 2];
              if (this._scheme !== 'file' || !ALPHA.test(c) || nextC !== ':' && nextC !== '|' || nextNextC !== EOF && nextNextC !== '/' && nextNextC !== '\\' && nextNextC !== '?' && nextNextC !== '#') {
                this._host = base._host;
                this._port = base._port;
                this._username = base._username;
                this._password = base._password;
                this._path = base._path.slice();
                this._path.pop();
              }
              state = 'relative path';
              continue;
            }
            break;
          case 'relative slash':
            if (c === '/' || c === '\\') {
              if (c === '\\') {
                err('\\ is an invalid code point.');
              }
              if (this._scheme === 'file') {
                state = 'file host';
              } else {
                state = 'authority ignore slashes';
              }
            } else {
              if (this._scheme !== 'file') {
                this._host = base._host;
                this._port = base._port;
                this._username = base._username;
                this._password = base._password;
              }
              state = 'relative path';
              continue;
            }
            break;
          case 'authority first slash':
            if (c === '/') {
              state = 'authority second slash';
            } else {
              err('Expected \'/\', got: ' + c);
              state = 'authority ignore slashes';
              continue;
            }
            break;
          case 'authority second slash':
            state = 'authority ignore slashes';
            if (c !== '/') {
              err('Expected \'/\', got: ' + c);
              continue;
            }
            break;
          case 'authority ignore slashes':
            if (c !== '/' && c !== '\\') {
              state = 'authority';
              continue;
            } else {
              err('Expected authority, got: ' + c);
            }
            break;
          case 'authority':
            if (c === '@') {
              if (seenAt) {
                err('@ already seen.');
                buffer += '%40';
              }
              seenAt = true;
              for (var i = 0; i < buffer.length; i++) {
                var cp = buffer[i];
                if (cp === '\t' || cp === '\n' || cp === '\r') {
                  err('Invalid whitespace in authority.');
                  continue;
                }
                if (cp === ':' && this._password === null) {
                  this._password = '';
                  continue;
                }
                var tempC = percentEscape(cp);
                if (this._password !== null) {
                  this._password += tempC;
                } else {
                  this._username += tempC;
                }
              }
              buffer = '';
            } else if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#') {
              cursor -= buffer.length;
              buffer = '';
              state = 'host';
              continue;
            } else {
              buffer += c;
            }
            break;
          case 'file host':
            if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#') {
              if (buffer.length === 2 && ALPHA.test(buffer[0]) && (buffer[1] === ':' || buffer[1] === '|')) {
                state = 'relative path';
              } else if (buffer.length === 0) {
                state = 'relative path start';
              } else {
                this._host = IDNAToASCII.call(this, buffer);
                buffer = '';
                state = 'relative path start';
              }
              continue;
            } else if (c === '\t' || c === '\n' || c === '\r') {
              err('Invalid whitespace in file host.');
            } else {
              buffer += c;
            }
            break;
          case 'host':
          case 'hostname':
            if (c === ':' && !seenBracket) {
              this._host = IDNAToASCII.call(this, buffer);
              buffer = '';
              state = 'port';
              if (stateOverride === 'hostname') {
                break loop;
              }
            } else if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#') {
              this._host = IDNAToASCII.call(this, buffer);
              buffer = '';
              state = 'relative path start';
              if (stateOverride) {
                break loop;
              }
              continue;
            } else if (c !== '\t' && c !== '\n' && c !== '\r') {
              if (c === '[') {
                seenBracket = true;
              } else if (c === ']') {
                seenBracket = false;
              }
              buffer += c;
            } else {
              err('Invalid code point in host/hostname: ' + c);
            }
            break;
          case 'port':
            if (/[0-9]/.test(c)) {
              buffer += c;
            } else if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#' || stateOverride) {
              if (buffer !== '') {
                var temp = parseInt(buffer, 10);
                if (temp !== relative[this._scheme]) {
                  this._port = temp + '';
                }
                buffer = '';
              }
              if (stateOverride) {
                break loop;
              }
              state = 'relative path start';
              continue;
            } else if (c === '\t' || c === '\n' || c === '\r') {
              err('Invalid code point in port: ' + c);
            } else {
              invalid.call(this);
            }
            break;
          case 'relative path start':
            if (c === '\\') {
              err('\'\\\' not allowed in path.');
            }
            state = 'relative path';
            if (c !== '/' && c !== '\\') {
              continue;
            }
            break;
          case 'relative path':
            if (c === EOF || c === '/' || c === '\\' || !stateOverride && (c === '?' || c === '#')) {
              if (c === '\\') {
                err('\\ not allowed in relative path.');
              }
              var tmp;
              if (tmp = relativePathDotMapping[buffer.toLowerCase()]) {
                buffer = tmp;
              }
              if (buffer === '..') {
                this._path.pop();
                if (c !== '/' && c !== '\\') {
                  this._path.push('');
                }
              } else if (buffer === '.' && c !== '/' && c !== '\\') {
                this._path.push('');
              } else if (buffer !== '.') {
                if (this._scheme === 'file' && this._path.length === 0 && buffer.length === 2 && ALPHA.test(buffer[0]) && buffer[1] === '|') {
                  buffer = buffer[0] + ':';
                }
                this._path.push(buffer);
              }
              buffer = '';
              if (c === '?') {
                this._query = '?';
                state = 'query';
              } else if (c === '#') {
                this._fragment = '#';
                state = 'fragment';
              }
            } else if (c !== '\t' && c !== '\n' && c !== '\r') {
              buffer += percentEscape(c);
            }
            break;
          case 'query':
            if (!stateOverride && c === '#') {
              this._fragment = '#';
              state = 'fragment';
            } else if (c !== EOF && c !== '\t' && c !== '\n' && c !== '\r') {
              this._query += percentEscapeQuery(c);
            }
            break;
          case 'fragment':
            if (c !== EOF && c !== '\t' && c !== '\n' && c !== '\r') {
              this._fragment += c;
            }
            break;
        }
        cursor++;
      }
    }
    function clear() {
      this._scheme = '';
      this._schemeData = '';
      this._username = '';
      this._password = null;
      this._host = '';
      this._port = '';
      this._path = [];
      this._query = '';
      this._fragment = '';
      this._isInvalid = false;
      this._isRelative = false;
    }
    function JURL(url, base) {
      if (base !== undefined && !(base instanceof JURL)) {
        base = new JURL(String(base));
      }
      this._url = url;
      clear.call(this);
      var input = url.replace(/^[ \t\r\n\f]+|[ \t\r\n\f]+$/g, '');
      parse.call(this, input, null, base);
    }
    JURL.prototype = {
      toString: function toString() {
        return this.href;
      },

      get href() {
        if (this._isInvalid) {
          return this._url;
        }
        var authority = '';
        if (this._username !== '' || this._password !== null) {
          authority = this._username + (this._password !== null ? ':' + this._password : '') + '@';
        }
        return this.protocol + (this._isRelative ? '//' + authority + this.host : '') + this.pathname + this._query + this._fragment;
      },
      set href(value) {
        clear.call(this);
        parse.call(this, value);
      },
      get protocol() {
        return this._scheme + ':';
      },
      set protocol(value) {
        if (this._isInvalid) {
          return;
        }
        parse.call(this, value + ':', 'scheme start');
      },
      get host() {
        return this._isInvalid ? '' : this._port ? this._host + ':' + this._port : this._host;
      },
      set host(value) {
        if (this._isInvalid || !this._isRelative) {
          return;
        }
        parse.call(this, value, 'host');
      },
      get hostname() {
        return this._host;
      },
      set hostname(value) {
        if (this._isInvalid || !this._isRelative) {
          return;
        }
        parse.call(this, value, 'hostname');
      },
      get port() {
        return this._port;
      },
      set port(value) {
        if (this._isInvalid || !this._isRelative) {
          return;
        }
        parse.call(this, value, 'port');
      },
      get pathname() {
        return this._isInvalid ? '' : this._isRelative ? '/' + this._path.join('/') : this._schemeData;
      },
      set pathname(value) {
        if (this._isInvalid || !this._isRelative) {
          return;
        }
        this._path = [];
        parse.call(this, value, 'relative path start');
      },
      get search() {
        return this._isInvalid || !this._query || this._query === '?' ? '' : this._query;
      },
      set search(value) {
        if (this._isInvalid || !this._isRelative) {
          return;
        }
        this._query = '?';
        if (value[0] === '?') {
          value = value.slice(1);
        }
        parse.call(this, value, 'query');
      },
      get hash() {
        return this._isInvalid || !this._fragment || this._fragment === '#' ? '' : this._fragment;
      },
      set hash(value) {
        if (this._isInvalid) {
          return;
        }
        this._fragment = '#';
        if (value[0] === '#') {
          value = value.slice(1);
        }
        parse.call(this, value, 'fragment');
      },
      get origin() {
        var host;
        if (this._isInvalid || !this._scheme) {
          return '';
        }
        switch (this._scheme) {
          case 'data':
          case 'file':
          case 'javascript':
          case 'mailto':
            return 'null';
          case 'blob':
            try {
              return new JURL(this._schemeData).origin || 'null';
            } catch (_) {}
            return 'null';
        }
        host = this.host;
        if (!host) {
          return '';
        }
        return this._scheme + '://' + host;
      }
    };
    var OriginalURL = globalScope.URL;
    if (OriginalURL) {
      JURL.createObjectURL = function (blob) {
        return OriginalURL.createObjectURL.apply(OriginalURL, arguments);
      };
      JURL.revokeObjectURL = function (url) {
        OriginalURL.revokeObjectURL(url);
      };
    }
    globalScope.URL = JURL;
  })();
}

/***/ }),
/* 37 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var isReadableStreamSupported = false;
if (typeof ReadableStream !== 'undefined') {
  try {
    new ReadableStream({
      start: function start(controller) {
        controller.close();
      }
    });
    isReadableStreamSupported = true;
  } catch (e) {}
}
if (isReadableStreamSupported) {
  exports.ReadableStream = ReadableStream;
} else {
  exports.ReadableStream = __w_pdfjs_require__(18).ReadableStream;
}

/***/ })
/******/ ]);
});

}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"_process":1185}],1183:[function(require,module,exports){
(function (global){(function (){
/* Copyright 2017 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("pdfjs-dist/web/compatibility", [], factory);
	else if(typeof exports === 'object')
		exports["pdfjs-dist/web/compatibility"] = factory();
	else
		root["pdfjs-dist/web/compatibility"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

if (typeof PDFJS === 'undefined' || !PDFJS.compatibilityChecked) {
  var globalScope = typeof window !== 'undefined' && window.Math === Math ? window : typeof global !== 'undefined' && global.Math === Math ? global : typeof self !== 'undefined' && self.Math === Math ? self :  false ? undefined : {};
  var userAgent = typeof navigator !== 'undefined' && navigator.userAgent || '';
  var isAndroid = /Android/.test(userAgent);
  var isAndroidPre3 = /Android\s[0-2][^\d]/.test(userAgent);
  var isAndroidPre5 = /Android\s[0-4][^\d]/.test(userAgent);
  var isChrome = userAgent.indexOf('Chrom') >= 0;
  var isChromeWithRangeBug = /Chrome\/(39|40)\./.test(userAgent);
  var isIOSChrome = userAgent.indexOf('CriOS') >= 0;
  var isIE = userAgent.indexOf('Trident') >= 0;
  var isIOS = /\b(iPad|iPhone|iPod)(?=;)/.test(userAgent);
  var isOpera = userAgent.indexOf('Opera') >= 0;
  var isSafari = /Safari\//.test(userAgent) && !/(Chrome\/|Android\s)/.test(userAgent);
  var hasDOM = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && (typeof document === 'undefined' ? 'undefined' : _typeof(document)) === 'object';
  if (typeof PDFJS === 'undefined') {
    globalScope.PDFJS = {};
  }
  PDFJS.compatibilityChecked = true;
  (function checkTypedArrayCompatibility() {
    if (typeof Uint8Array !== 'undefined') {
      if (typeof Uint8Array.prototype.subarray === 'undefined') {
        Uint8Array.prototype.subarray = function subarray(start, end) {
          return new Uint8Array(this.slice(start, end));
        };
        Float32Array.prototype.subarray = function subarray(start, end) {
          return new Float32Array(this.slice(start, end));
        };
      }
      if (typeof Float64Array === 'undefined') {
        globalScope.Float64Array = Float32Array;
      }
      return;
    }
    function subarray(start, end) {
      return new TypedArray(this.slice(start, end));
    }
    function setArrayOffset(array, offset) {
      if (arguments.length < 2) {
        offset = 0;
      }
      for (var i = 0, n = array.length; i < n; ++i, ++offset) {
        this[offset] = array[i] & 0xFF;
      }
    }
    function Uint32ArrayView(buffer, length) {
      this.buffer = buffer;
      this.byteLength = buffer.length;
      this.length = length;
      ensureUint32ArrayViewProps(this.length);
    }
    Uint32ArrayView.prototype = Object.create(null);
    var uint32ArrayViewSetters = 0;
    function createUint32ArrayProp(index) {
      return {
        get: function get() {
          var buffer = this.buffer,
              offset = index << 2;
          return (buffer[offset] | buffer[offset + 1] << 8 | buffer[offset + 2] << 16 | buffer[offset + 3] << 24) >>> 0;
        },
        set: function set(value) {
          var buffer = this.buffer,
              offset = index << 2;
          buffer[offset] = value & 255;
          buffer[offset + 1] = value >> 8 & 255;
          buffer[offset + 2] = value >> 16 & 255;
          buffer[offset + 3] = value >>> 24 & 255;
        }
      };
    }
    function ensureUint32ArrayViewProps(length) {
      while (uint32ArrayViewSetters < length) {
        Object.defineProperty(Uint32ArrayView.prototype, uint32ArrayViewSetters, createUint32ArrayProp(uint32ArrayViewSetters));
        uint32ArrayViewSetters++;
      }
    }
    function TypedArray(arg1) {
      var result, i, n;
      if (typeof arg1 === 'number') {
        result = [];
        for (i = 0; i < arg1; ++i) {
          result[i] = 0;
        }
      } else if ('slice' in arg1) {
        result = arg1.slice(0);
      } else {
        result = [];
        for (i = 0, n = arg1.length; i < n; ++i) {
          result[i] = arg1[i];
        }
      }
      result.subarray = subarray;
      result.buffer = result;
      result.byteLength = result.length;
      result.set = setArrayOffset;
      if ((typeof arg1 === 'undefined' ? 'undefined' : _typeof(arg1)) === 'object' && arg1.buffer) {
        result.buffer = arg1.buffer;
      }
      return result;
    }
    globalScope.Uint8Array = TypedArray;
    globalScope.Int8Array = TypedArray;
    globalScope.Int32Array = TypedArray;
    globalScope.Uint16Array = TypedArray;
    globalScope.Float32Array = TypedArray;
    globalScope.Float64Array = TypedArray;
    globalScope.Uint32Array = function () {
      if (arguments.length === 3) {
        if (arguments[1] !== 0) {
          throw new Error('offset !== 0 is not supported');
        }
        return new Uint32ArrayView(arguments[0], arguments[2]);
      }
      return TypedArray.apply(this, arguments);
    };
  })();
  (function canvasPixelArrayBuffer() {
    if (!hasDOM || !window.CanvasPixelArray) {
      return;
    }
    var cpaProto = window.CanvasPixelArray.prototype;
    if ('buffer' in cpaProto) {
      return;
    }
    Object.defineProperty(cpaProto, 'buffer', {
      get: function get() {
        return this;
      },

      enumerable: false,
      configurable: true
    });
    Object.defineProperty(cpaProto, 'byteLength', {
      get: function get() {
        return this.length;
      },

      enumerable: false,
      configurable: true
    });
  })();
  (function normalizeURLObject() {
    if (!globalScope.URL) {
      globalScope.URL = globalScope.webkitURL;
    }
  })();
  (function checkObjectDefinePropertyCompatibility() {
    if (typeof Object.defineProperty !== 'undefined') {
      var definePropertyPossible = true;
      try {
        if (hasDOM) {
          Object.defineProperty(new Image(), 'id', { value: 'test' });
        }
        var Test = function Test() {};
        Test.prototype = {
          get id() {}
        };
        Object.defineProperty(new Test(), 'id', {
          value: '',
          configurable: true,
          enumerable: true,
          writable: false
        });
      } catch (e) {
        definePropertyPossible = false;
      }
      if (definePropertyPossible) {
        return;
      }
    }
    Object.defineProperty = function objectDefineProperty(obj, name, def) {
      delete obj[name];
      if ('get' in def) {
        obj.__defineGetter__(name, def['get']);
      }
      if ('set' in def) {
        obj.__defineSetter__(name, def['set']);
      }
      if ('value' in def) {
        obj.__defineSetter__(name, function objectDefinePropertySetter(value) {
          this.__defineGetter__(name, function objectDefinePropertyGetter() {
            return value;
          });
          return value;
        });
        obj[name] = def.value;
      }
    };
  })();
  (function checkXMLHttpRequestResponseCompatibility() {
    if (typeof XMLHttpRequest === 'undefined') {
      return;
    }
    var xhrPrototype = XMLHttpRequest.prototype;
    var xhr = new XMLHttpRequest();
    if (!('overrideMimeType' in xhr)) {
      Object.defineProperty(xhrPrototype, 'overrideMimeType', {
        value: function xmlHttpRequestOverrideMimeType(mimeType) {}
      });
    }
    if ('responseType' in xhr) {
      return;
    }
    Object.defineProperty(xhrPrototype, 'responseType', {
      get: function xmlHttpRequestGetResponseType() {
        return this._responseType || 'text';
      },
      set: function xmlHttpRequestSetResponseType(value) {
        if (value === 'text' || value === 'arraybuffer') {
          this._responseType = value;
          if (value === 'arraybuffer' && typeof this.overrideMimeType === 'function') {
            this.overrideMimeType('text/plain; charset=x-user-defined');
          }
        }
      }
    });
    if (typeof VBArray !== 'undefined') {
      Object.defineProperty(xhrPrototype, 'response', {
        get: function xmlHttpRequestResponseGet() {
          if (this.responseType === 'arraybuffer') {
            return new Uint8Array(new VBArray(this.responseBody).toArray());
          }
          return this.responseText;
        }
      });
      return;
    }
    Object.defineProperty(xhrPrototype, 'response', {
      get: function xmlHttpRequestResponseGet() {
        if (this.responseType !== 'arraybuffer') {
          return this.responseText;
        }
        var text = this.responseText;
        var i,
            n = text.length;
        var result = new Uint8Array(n);
        for (i = 0; i < n; ++i) {
          result[i] = text.charCodeAt(i) & 0xFF;
        }
        return result.buffer;
      }
    });
  })();
  (function checkWindowBtoaCompatibility() {
    if ('btoa' in globalScope) {
      return;
    }
    var digits = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    globalScope.btoa = function (chars) {
      var buffer = '';
      var i, n;
      for (i = 0, n = chars.length; i < n; i += 3) {
        var b1 = chars.charCodeAt(i) & 0xFF;
        var b2 = chars.charCodeAt(i + 1) & 0xFF;
        var b3 = chars.charCodeAt(i + 2) & 0xFF;
        var d1 = b1 >> 2,
            d2 = (b1 & 3) << 4 | b2 >> 4;
        var d3 = i + 1 < n ? (b2 & 0xF) << 2 | b3 >> 6 : 64;
        var d4 = i + 2 < n ? b3 & 0x3F : 64;
        buffer += digits.charAt(d1) + digits.charAt(d2) + digits.charAt(d3) + digits.charAt(d4);
      }
      return buffer;
    };
  })();
  (function checkWindowAtobCompatibility() {
    if ('atob' in globalScope) {
      return;
    }
    var digits = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    globalScope.atob = function (input) {
      input = input.replace(/=+$/, '');
      if (input.length % 4 === 1) {
        throw new Error('bad atob input');
      }
      for (var bc = 0, bs, buffer, idx = 0, output = ''; buffer = input.charAt(idx++); ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer, bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0) {
        buffer = digits.indexOf(buffer);
      }
      return output;
    };
  })();
  (function checkFunctionPrototypeBindCompatibility() {
    if (typeof Function.prototype.bind !== 'undefined') {
      return;
    }
    Function.prototype.bind = function functionPrototypeBind(obj) {
      var fn = this,
          headArgs = Array.prototype.slice.call(arguments, 1);
      var bound = function functionPrototypeBindBound() {
        var args = headArgs.concat(Array.prototype.slice.call(arguments));
        return fn.apply(obj, args);
      };
      return bound;
    };
  })();
  (function checkDatasetProperty() {
    if (!hasDOM) {
      return;
    }
    var div = document.createElement('div');
    if ('dataset' in div) {
      return;
    }
    Object.defineProperty(HTMLElement.prototype, 'dataset', {
      get: function get() {
        if (this._dataset) {
          return this._dataset;
        }
        var dataset = {};
        for (var j = 0, jj = this.attributes.length; j < jj; j++) {
          var attribute = this.attributes[j];
          if (attribute.name.substring(0, 5) !== 'data-') {
            continue;
          }
          var key = attribute.name.substring(5).replace(/\-([a-z])/g, function (all, ch) {
            return ch.toUpperCase();
          });
          dataset[key] = attribute.value;
        }
        Object.defineProperty(this, '_dataset', {
          value: dataset,
          writable: false,
          enumerable: false
        });
        return dataset;
      },

      enumerable: true
    });
  })();
  (function checkClassListProperty() {
    function changeList(element, itemName, add, remove) {
      var s = element.className || '';
      var list = s.split(/\s+/g);
      if (list[0] === '') {
        list.shift();
      }
      var index = list.indexOf(itemName);
      if (index < 0 && add) {
        list.push(itemName);
      }
      if (index >= 0 && remove) {
        list.splice(index, 1);
      }
      element.className = list.join(' ');
      return index >= 0;
    }
    if (!hasDOM) {
      return;
    }
    var div = document.createElement('div');
    if ('classList' in div) {
      return;
    }
    var classListPrototype = {
      add: function add(name) {
        changeList(this.element, name, true, false);
      },
      contains: function contains(name) {
        return changeList(this.element, name, false, false);
      },
      remove: function remove(name) {
        changeList(this.element, name, false, true);
      },
      toggle: function toggle(name) {
        changeList(this.element, name, true, true);
      }
    };
    Object.defineProperty(HTMLElement.prototype, 'classList', {
      get: function get() {
        if (this._classList) {
          return this._classList;
        }
        var classList = Object.create(classListPrototype, {
          element: {
            value: this,
            writable: false,
            enumerable: true
          }
        });
        Object.defineProperty(this, '_classList', {
          value: classList,
          writable: false,
          enumerable: false
        });
        return classList;
      },

      enumerable: true
    });
  })();
  (function checkWorkerConsoleCompatibility() {
    if (typeof importScripts === 'undefined' || 'console' in globalScope) {
      return;
    }
    var consoleTimer = {};
    var workerConsole = {
      log: function log() {
        var args = Array.prototype.slice.call(arguments);
        globalScope.postMessage({
          targetName: 'main',
          action: 'console_log',
          data: args
        });
      },
      error: function error() {
        var args = Array.prototype.slice.call(arguments);
        globalScope.postMessage({
          targetName: 'main',
          action: 'console_error',
          data: args
        });
      },
      time: function time(name) {
        consoleTimer[name] = Date.now();
      },
      timeEnd: function timeEnd(name) {
        var time = consoleTimer[name];
        if (!time) {
          throw new Error('Unknown timer name ' + name);
        }
        this.log('Timer:', name, Date.now() - time);
      }
    };
    globalScope.console = workerConsole;
  })();
  (function checkConsoleCompatibility() {
    if (!hasDOM) {
      return;
    }
    if (!('console' in window)) {
      window.console = {
        log: function log() {},
        error: function error() {},
        warn: function warn() {}
      };
      return;
    }
    if (!('bind' in console.log)) {
      console.log = function (fn) {
        return function (msg) {
          return fn(msg);
        };
      }(console.log);
      console.error = function (fn) {
        return function (msg) {
          return fn(msg);
        };
      }(console.error);
      console.warn = function (fn) {
        return function (msg) {
          return fn(msg);
        };
      }(console.warn);
      return;
    }
  })();
  (function checkOnClickCompatibility() {
    function ignoreIfTargetDisabled(event) {
      if (isDisabled(event.target)) {
        event.stopPropagation();
      }
    }
    function isDisabled(node) {
      return node.disabled || node.parentNode && isDisabled(node.parentNode);
    }
    if (isOpera) {
      document.addEventListener('click', ignoreIfTargetDisabled, true);
    }
  })();
  (function checkOnBlobSupport() {
    if (isIE || isIOSChrome) {
      PDFJS.disableCreateObjectURL = true;
    }
  })();
  (function checkNavigatorLanguage() {
    if (typeof navigator === 'undefined') {
      return;
    }
    if ('language' in navigator) {
      return;
    }
    PDFJS.locale = navigator.userLanguage || 'en-US';
  })();
  (function checkRangeRequests() {
    if (isSafari || isAndroidPre3 || isChromeWithRangeBug || isIOS) {
      PDFJS.disableRange = true;
      PDFJS.disableStream = true;
    }
  })();
  (function checkHistoryManipulation() {
    if (!hasDOM) {
      return;
    }
    if (!history.pushState || isAndroidPre3) {
      PDFJS.disableHistory = true;
    }
  })();
  (function checkSetPresenceInImageData() {
    if (!hasDOM) {
      return;
    }
    if (window.CanvasPixelArray) {
      if (typeof window.CanvasPixelArray.prototype.set !== 'function') {
        window.CanvasPixelArray.prototype.set = function (arr) {
          for (var i = 0, ii = this.length; i < ii; i++) {
            this[i] = arr[i];
          }
        };
      }
    } else {
      var polyfill = false,
          versionMatch;
      if (isChrome) {
        versionMatch = userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
        polyfill = versionMatch && parseInt(versionMatch[2]) < 21;
      } else if (isAndroid) {
        polyfill = isAndroidPre5;
      } else if (isSafari) {
        versionMatch = userAgent.match(/Version\/([0-9]+)\.([0-9]+)\.([0-9]+) Safari\//);
        polyfill = versionMatch && parseInt(versionMatch[1]) < 6;
      }
      if (polyfill) {
        var contextPrototype = window.CanvasRenderingContext2D.prototype;
        var createImageData = contextPrototype.createImageData;
        contextPrototype.createImageData = function (w, h) {
          var imageData = createImageData.call(this, w, h);
          imageData.data.set = function (arr) {
            for (var i = 0, ii = this.length; i < ii; i++) {
              this[i] = arr[i];
            }
          };
          return imageData;
        };
        contextPrototype = null;
      }
    }
  })();
  (function checkRequestAnimationFrame() {
    function installFakeAnimationFrameFunctions() {
      window.requestAnimationFrame = function (callback) {
        return window.setTimeout(callback, 20);
      };
      window.cancelAnimationFrame = function (timeoutID) {
        window.clearTimeout(timeoutID);
      };
    }
    if (!hasDOM) {
      return;
    }
    if (isIOS) {
      installFakeAnimationFrameFunctions();
      return;
    }
    if ('requestAnimationFrame' in window) {
      return;
    }
    window.requestAnimationFrame = window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame;
    if (window.requestAnimationFrame) {
      return;
    }
    installFakeAnimationFrameFunctions();
  })();
  (function checkCanvasSizeLimitation() {
    if (isIOS || isAndroid) {
      PDFJS.maxCanvasPixels = 5242880;
    }
  })();
  (function checkFullscreenSupport() {
    if (!hasDOM) {
      return;
    }
    if (isIE && window.parent !== window) {
      PDFJS.disableFullscreen = true;
    }
  })();
  (function checkCurrentScript() {
    if (!hasDOM) {
      return;
    }
    if ('currentScript' in document) {
      return;
    }
    Object.defineProperty(document, 'currentScript', {
      get: function get() {
        var scripts = document.getElementsByTagName('script');
        return scripts[scripts.length - 1];
      },

      enumerable: true,
      configurable: true
    });
  })();
  (function checkInputTypeNumberAssign() {
    if (!hasDOM) {
      return;
    }
    var el = document.createElement('input');
    try {
      el.type = 'number';
    } catch (ex) {
      var inputProto = el.constructor.prototype;
      var typeProperty = Object.getOwnPropertyDescriptor(inputProto, 'type');
      Object.defineProperty(inputProto, 'type', {
        get: function get() {
          return typeProperty.get.call(this);
        },
        set: function set(value) {
          typeProperty.set.call(this, value === 'number' ? 'text' : value);
        },

        enumerable: true,
        configurable: true
      });
    }
  })();
  (function checkDocumentReadyState() {
    if (!hasDOM) {
      return;
    }
    if (!document.attachEvent) {
      return;
    }
    var documentProto = document.constructor.prototype;
    var readyStateProto = Object.getOwnPropertyDescriptor(documentProto, 'readyState');
    Object.defineProperty(documentProto, 'readyState', {
      get: function get() {
        var value = readyStateProto.get.call(this);
        return value === 'interactive' ? 'loading' : value;
      },
      set: function set(value) {
        readyStateProto.set.call(this, value);
      },

      enumerable: true,
      configurable: true
    });
  })();
  (function checkChildNodeRemove() {
    if (!hasDOM) {
      return;
    }
    if (typeof Element.prototype.remove !== 'undefined') {
      return;
    }
    Element.prototype.remove = function () {
      if (this.parentNode) {
        this.parentNode.removeChild(this);
      }
    };
  })();
  (function checkNumberIsNaN() {
    if (Number.isNaN) {
      return;
    }
    Number.isNaN = function (value) {
      return typeof value === 'number' && isNaN(value);
    };
  })();
  (function checkNumberIsInteger() {
    if (Number.isInteger) {
      return;
    }
    Number.isInteger = function (value) {
      return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
    };
  })();
  (function checkPromise() {
    if (globalScope.Promise) {
      if (typeof globalScope.Promise.all !== 'function') {
        globalScope.Promise.all = function (iterable) {
          var count = 0,
              results = [],
              resolve,
              reject;
          var promise = new globalScope.Promise(function (resolve_, reject_) {
            resolve = resolve_;
            reject = reject_;
          });
          iterable.forEach(function (p, i) {
            count++;
            p.then(function (result) {
              results[i] = result;
              count--;
              if (count === 0) {
                resolve(results);
              }
            }, reject);
          });
          if (count === 0) {
            resolve(results);
          }
          return promise;
        };
      }
      if (typeof globalScope.Promise.resolve !== 'function') {
        globalScope.Promise.resolve = function (value) {
          return new globalScope.Promise(function (resolve) {
            resolve(value);
          });
        };
      }
      if (typeof globalScope.Promise.reject !== 'function') {
        globalScope.Promise.reject = function (reason) {
          return new globalScope.Promise(function (resolve, reject) {
            reject(reason);
          });
        };
      }
      if (typeof globalScope.Promise.prototype.catch !== 'function') {
        globalScope.Promise.prototype.catch = function (onReject) {
          return globalScope.Promise.prototype.then(undefined, onReject);
        };
      }
      return;
    }
    var STATUS_PENDING = 0;
    var STATUS_RESOLVED = 1;
    var STATUS_REJECTED = 2;
    var REJECTION_TIMEOUT = 500;
    var HandlerManager = {
      handlers: [],
      running: false,
      unhandledRejections: [],
      pendingRejectionCheck: false,
      scheduleHandlers: function scheduleHandlers(promise) {
        if (promise._status === STATUS_PENDING) {
          return;
        }
        this.handlers = this.handlers.concat(promise._handlers);
        promise._handlers = [];
        if (this.running) {
          return;
        }
        this.running = true;
        setTimeout(this.runHandlers.bind(this), 0);
      },
      runHandlers: function runHandlers() {
        var RUN_TIMEOUT = 1;
        var timeoutAt = Date.now() + RUN_TIMEOUT;
        while (this.handlers.length > 0) {
          var handler = this.handlers.shift();
          var nextStatus = handler.thisPromise._status;
          var nextValue = handler.thisPromise._value;
          try {
            if (nextStatus === STATUS_RESOLVED) {
              if (typeof handler.onResolve === 'function') {
                nextValue = handler.onResolve(nextValue);
              }
            } else if (typeof handler.onReject === 'function') {
              nextValue = handler.onReject(nextValue);
              nextStatus = STATUS_RESOLVED;
              if (handler.thisPromise._unhandledRejection) {
                this.removeUnhandeledRejection(handler.thisPromise);
              }
            }
          } catch (ex) {
            nextStatus = STATUS_REJECTED;
            nextValue = ex;
          }
          handler.nextPromise._updateStatus(nextStatus, nextValue);
          if (Date.now() >= timeoutAt) {
            break;
          }
        }
        if (this.handlers.length > 0) {
          setTimeout(this.runHandlers.bind(this), 0);
          return;
        }
        this.running = false;
      },
      addUnhandledRejection: function addUnhandledRejection(promise) {
        this.unhandledRejections.push({
          promise: promise,
          time: Date.now()
        });
        this.scheduleRejectionCheck();
      },
      removeUnhandeledRejection: function removeUnhandeledRejection(promise) {
        promise._unhandledRejection = false;
        for (var i = 0; i < this.unhandledRejections.length; i++) {
          if (this.unhandledRejections[i].promise === promise) {
            this.unhandledRejections.splice(i);
            i--;
          }
        }
      },
      scheduleRejectionCheck: function scheduleRejectionCheck() {
        var _this = this;

        if (this.pendingRejectionCheck) {
          return;
        }
        this.pendingRejectionCheck = true;
        setTimeout(function () {
          _this.pendingRejectionCheck = false;
          var now = Date.now();
          for (var i = 0; i < _this.unhandledRejections.length; i++) {
            if (now - _this.unhandledRejections[i].time > REJECTION_TIMEOUT) {
              var unhandled = _this.unhandledRejections[i].promise._value;
              var msg = 'Unhandled rejection: ' + unhandled;
              if (unhandled.stack) {
                msg += '\n' + unhandled.stack;
              }
              try {
                throw new Error(msg);
              } catch (_) {
                console.warn(msg);
              }
              _this.unhandledRejections.splice(i);
              i--;
            }
          }
          if (_this.unhandledRejections.length) {
            _this.scheduleRejectionCheck();
          }
        }, REJECTION_TIMEOUT);
      }
    };
    var Promise = function Promise(resolver) {
      this._status = STATUS_PENDING;
      this._handlers = [];
      try {
        resolver.call(this, this._resolve.bind(this), this._reject.bind(this));
      } catch (e) {
        this._reject(e);
      }
    };
    Promise.all = function Promise_all(promises) {
      var resolveAll, rejectAll;
      var deferred = new Promise(function (resolve, reject) {
        resolveAll = resolve;
        rejectAll = reject;
      });
      var unresolved = promises.length;
      var results = [];
      if (unresolved === 0) {
        resolveAll(results);
        return deferred;
      }
      function reject(reason) {
        if (deferred._status === STATUS_REJECTED) {
          return;
        }
        results = [];
        rejectAll(reason);
      }
      for (var i = 0, ii = promises.length; i < ii; ++i) {
        var promise = promises[i];
        var resolve = function (i) {
          return function (value) {
            if (deferred._status === STATUS_REJECTED) {
              return;
            }
            results[i] = value;
            unresolved--;
            if (unresolved === 0) {
              resolveAll(results);
            }
          };
        }(i);
        if (Promise.isPromise(promise)) {
          promise.then(resolve, reject);
        } else {
          resolve(promise);
        }
      }
      return deferred;
    };
    Promise.isPromise = function Promise_isPromise(value) {
      return value && typeof value.then === 'function';
    };
    Promise.resolve = function Promise_resolve(value) {
      return new Promise(function (resolve) {
        resolve(value);
      });
    };
    Promise.reject = function Promise_reject(reason) {
      return new Promise(function (resolve, reject) {
        reject(reason);
      });
    };
    Promise.prototype = {
      _status: null,
      _value: null,
      _handlers: null,
      _unhandledRejection: null,
      _updateStatus: function Promise__updateStatus(status, value) {
        if (this._status === STATUS_RESOLVED || this._status === STATUS_REJECTED) {
          return;
        }
        if (status === STATUS_RESOLVED && Promise.isPromise(value)) {
          value.then(this._updateStatus.bind(this, STATUS_RESOLVED), this._updateStatus.bind(this, STATUS_REJECTED));
          return;
        }
        this._status = status;
        this._value = value;
        if (status === STATUS_REJECTED && this._handlers.length === 0) {
          this._unhandledRejection = true;
          HandlerManager.addUnhandledRejection(this);
        }
        HandlerManager.scheduleHandlers(this);
      },
      _resolve: function Promise_resolve(value) {
        this._updateStatus(STATUS_RESOLVED, value);
      },
      _reject: function Promise_reject(reason) {
        this._updateStatus(STATUS_REJECTED, reason);
      },
      then: function Promise_then(onResolve, onReject) {
        var nextPromise = new Promise(function (resolve, reject) {
          this.resolve = resolve;
          this.reject = reject;
        });
        this._handlers.push({
          thisPromise: this,
          onResolve: onResolve,
          onReject: onReject,
          nextPromise: nextPromise
        });
        HandlerManager.scheduleHandlers(this);
        return nextPromise;
      },
      catch: function Promise_catch(onReject) {
        return this.then(undefined, onReject);
      }
    };
    globalScope.Promise = Promise;
  })();
  (function checkWeakMap() {
    if (globalScope.WeakMap) {
      return;
    }
    var id = 0;
    function WeakMap() {
      this.id = '$weakmap' + id++;
    }
    WeakMap.prototype = {
      has: function has(obj) {
        if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' && typeof obj !== 'function' || obj === null) {
          return false;
        }
        return !!Object.getOwnPropertyDescriptor(obj, this.id);
      },
      get: function get(obj) {
        return this.has(obj) ? obj[this.id] : undefined;
      },
      set: function set(obj, value) {
        Object.defineProperty(obj, this.id, {
          value: value,
          enumerable: false,
          configurable: true
        });
      },
      delete: function _delete(obj) {
        delete obj[this.id];
      }
    };
    globalScope.WeakMap = WeakMap;
  })();
  (function checkURLConstructor() {
    var hasWorkingUrl = false;
    try {
      if (typeof URL === 'function' && _typeof(URL.prototype) === 'object' && 'origin' in URL.prototype) {
        var u = new URL('b', 'http://a');
        u.pathname = 'c%20d';
        hasWorkingUrl = u.href === 'http://a/c%20d';
      }
    } catch (e) {}
    if (hasWorkingUrl) {
      return;
    }
    var relative = Object.create(null);
    relative['ftp'] = 21;
    relative['file'] = 0;
    relative['gopher'] = 70;
    relative['http'] = 80;
    relative['https'] = 443;
    relative['ws'] = 80;
    relative['wss'] = 443;
    var relativePathDotMapping = Object.create(null);
    relativePathDotMapping['%2e'] = '.';
    relativePathDotMapping['.%2e'] = '..';
    relativePathDotMapping['%2e.'] = '..';
    relativePathDotMapping['%2e%2e'] = '..';
    function isRelativeScheme(scheme) {
      return relative[scheme] !== undefined;
    }
    function invalid() {
      clear.call(this);
      this._isInvalid = true;
    }
    function IDNAToASCII(h) {
      if (h === '') {
        invalid.call(this);
      }
      return h.toLowerCase();
    }
    function percentEscape(c) {
      var unicode = c.charCodeAt(0);
      if (unicode > 0x20 && unicode < 0x7F && [0x22, 0x23, 0x3C, 0x3E, 0x3F, 0x60].indexOf(unicode) === -1) {
        return c;
      }
      return encodeURIComponent(c);
    }
    function percentEscapeQuery(c) {
      var unicode = c.charCodeAt(0);
      if (unicode > 0x20 && unicode < 0x7F && [0x22, 0x23, 0x3C, 0x3E, 0x60].indexOf(unicode) === -1) {
        return c;
      }
      return encodeURIComponent(c);
    }
    var EOF,
        ALPHA = /[a-zA-Z]/,
        ALPHANUMERIC = /[a-zA-Z0-9\+\-\.]/;
    function parse(input, stateOverride, base) {
      function err(message) {
        errors.push(message);
      }
      var state = stateOverride || 'scheme start',
          cursor = 0,
          buffer = '',
          seenAt = false,
          seenBracket = false,
          errors = [];
      loop: while ((input[cursor - 1] !== EOF || cursor === 0) && !this._isInvalid) {
        var c = input[cursor];
        switch (state) {
          case 'scheme start':
            if (c && ALPHA.test(c)) {
              buffer += c.toLowerCase();
              state = 'scheme';
            } else if (!stateOverride) {
              buffer = '';
              state = 'no scheme';
              continue;
            } else {
              err('Invalid scheme.');
              break loop;
            }
            break;
          case 'scheme':
            if (c && ALPHANUMERIC.test(c)) {
              buffer += c.toLowerCase();
            } else if (c === ':') {
              this._scheme = buffer;
              buffer = '';
              if (stateOverride) {
                break loop;
              }
              if (isRelativeScheme(this._scheme)) {
                this._isRelative = true;
              }
              if (this._scheme === 'file') {
                state = 'relative';
              } else if (this._isRelative && base && base._scheme === this._scheme) {
                state = 'relative or authority';
              } else if (this._isRelative) {
                state = 'authority first slash';
              } else {
                state = 'scheme data';
              }
            } else if (!stateOverride) {
              buffer = '';
              cursor = 0;
              state = 'no scheme';
              continue;
            } else if (c === EOF) {
              break loop;
            } else {
              err('Code point not allowed in scheme: ' + c);
              break loop;
            }
            break;
          case 'scheme data':
            if (c === '?') {
              this._query = '?';
              state = 'query';
            } else if (c === '#') {
              this._fragment = '#';
              state = 'fragment';
            } else {
              if (c !== EOF && c !== '\t' && c !== '\n' && c !== '\r') {
                this._schemeData += percentEscape(c);
              }
            }
            break;
          case 'no scheme':
            if (!base || !isRelativeScheme(base._scheme)) {
              err('Missing scheme.');
              invalid.call(this);
            } else {
              state = 'relative';
              continue;
            }
            break;
          case 'relative or authority':
            if (c === '/' && input[cursor + 1] === '/') {
              state = 'authority ignore slashes';
            } else {
              err('Expected /, got: ' + c);
              state = 'relative';
              continue;
            }
            break;
          case 'relative':
            this._isRelative = true;
            if (this._scheme !== 'file') {
              this._scheme = base._scheme;
            }
            if (c === EOF) {
              this._host = base._host;
              this._port = base._port;
              this._path = base._path.slice();
              this._query = base._query;
              this._username = base._username;
              this._password = base._password;
              break loop;
            } else if (c === '/' || c === '\\') {
              if (c === '\\') {
                err('\\ is an invalid code point.');
              }
              state = 'relative slash';
            } else if (c === '?') {
              this._host = base._host;
              this._port = base._port;
              this._path = base._path.slice();
              this._query = '?';
              this._username = base._username;
              this._password = base._password;
              state = 'query';
            } else if (c === '#') {
              this._host = base._host;
              this._port = base._port;
              this._path = base._path.slice();
              this._query = base._query;
              this._fragment = '#';
              this._username = base._username;
              this._password = base._password;
              state = 'fragment';
            } else {
              var nextC = input[cursor + 1];
              var nextNextC = input[cursor + 2];
              if (this._scheme !== 'file' || !ALPHA.test(c) || nextC !== ':' && nextC !== '|' || nextNextC !== EOF && nextNextC !== '/' && nextNextC !== '\\' && nextNextC !== '?' && nextNextC !== '#') {
                this._host = base._host;
                this._port = base._port;
                this._username = base._username;
                this._password = base._password;
                this._path = base._path.slice();
                this._path.pop();
              }
              state = 'relative path';
              continue;
            }
            break;
          case 'relative slash':
            if (c === '/' || c === '\\') {
              if (c === '\\') {
                err('\\ is an invalid code point.');
              }
              if (this._scheme === 'file') {
                state = 'file host';
              } else {
                state = 'authority ignore slashes';
              }
            } else {
              if (this._scheme !== 'file') {
                this._host = base._host;
                this._port = base._port;
                this._username = base._username;
                this._password = base._password;
              }
              state = 'relative path';
              continue;
            }
            break;
          case 'authority first slash':
            if (c === '/') {
              state = 'authority second slash';
            } else {
              err('Expected \'/\', got: ' + c);
              state = 'authority ignore slashes';
              continue;
            }
            break;
          case 'authority second slash':
            state = 'authority ignore slashes';
            if (c !== '/') {
              err('Expected \'/\', got: ' + c);
              continue;
            }
            break;
          case 'authority ignore slashes':
            if (c !== '/' && c !== '\\') {
              state = 'authority';
              continue;
            } else {
              err('Expected authority, got: ' + c);
            }
            break;
          case 'authority':
            if (c === '@') {
              if (seenAt) {
                err('@ already seen.');
                buffer += '%40';
              }
              seenAt = true;
              for (var i = 0; i < buffer.length; i++) {
                var cp = buffer[i];
                if (cp === '\t' || cp === '\n' || cp === '\r') {
                  err('Invalid whitespace in authority.');
                  continue;
                }
                if (cp === ':' && this._password === null) {
                  this._password = '';
                  continue;
                }
                var tempC = percentEscape(cp);
                if (this._password !== null) {
                  this._password += tempC;
                } else {
                  this._username += tempC;
                }
              }
              buffer = '';
            } else if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#') {
              cursor -= buffer.length;
              buffer = '';
              state = 'host';
              continue;
            } else {
              buffer += c;
            }
            break;
          case 'file host':
            if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#') {
              if (buffer.length === 2 && ALPHA.test(buffer[0]) && (buffer[1] === ':' || buffer[1] === '|')) {
                state = 'relative path';
              } else if (buffer.length === 0) {
                state = 'relative path start';
              } else {
                this._host = IDNAToASCII.call(this, buffer);
                buffer = '';
                state = 'relative path start';
              }
              continue;
            } else if (c === '\t' || c === '\n' || c === '\r') {
              err('Invalid whitespace in file host.');
            } else {
              buffer += c;
            }
            break;
          case 'host':
          case 'hostname':
            if (c === ':' && !seenBracket) {
              this._host = IDNAToASCII.call(this, buffer);
              buffer = '';
              state = 'port';
              if (stateOverride === 'hostname') {
                break loop;
              }
            } else if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#') {
              this._host = IDNAToASCII.call(this, buffer);
              buffer = '';
              state = 'relative path start';
              if (stateOverride) {
                break loop;
              }
              continue;
            } else if (c !== '\t' && c !== '\n' && c !== '\r') {
              if (c === '[') {
                seenBracket = true;
              } else if (c === ']') {
                seenBracket = false;
              }
              buffer += c;
            } else {
              err('Invalid code point in host/hostname: ' + c);
            }
            break;
          case 'port':
            if (/[0-9]/.test(c)) {
              buffer += c;
            } else if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#' || stateOverride) {
              if (buffer !== '') {
                var temp = parseInt(buffer, 10);
                if (temp !== relative[this._scheme]) {
                  this._port = temp + '';
                }
                buffer = '';
              }
              if (stateOverride) {
                break loop;
              }
              state = 'relative path start';
              continue;
            } else if (c === '\t' || c === '\n' || c === '\r') {
              err('Invalid code point in port: ' + c);
            } else {
              invalid.call(this);
            }
            break;
          case 'relative path start':
            if (c === '\\') {
              err('\'\\\' not allowed in path.');
            }
            state = 'relative path';
            if (c !== '/' && c !== '\\') {
              continue;
            }
            break;
          case 'relative path':
            if (c === EOF || c === '/' || c === '\\' || !stateOverride && (c === '?' || c === '#')) {
              if (c === '\\') {
                err('\\ not allowed in relative path.');
              }
              var tmp;
              if (tmp = relativePathDotMapping[buffer.toLowerCase()]) {
                buffer = tmp;
              }
              if (buffer === '..') {
                this._path.pop();
                if (c !== '/' && c !== '\\') {
                  this._path.push('');
                }
              } else if (buffer === '.' && c !== '/' && c !== '\\') {
                this._path.push('');
              } else if (buffer !== '.') {
                if (this._scheme === 'file' && this._path.length === 0 && buffer.length === 2 && ALPHA.test(buffer[0]) && buffer[1] === '|') {
                  buffer = buffer[0] + ':';
                }
                this._path.push(buffer);
              }
              buffer = '';
              if (c === '?') {
                this._query = '?';
                state = 'query';
              } else if (c === '#') {
                this._fragment = '#';
                state = 'fragment';
              }
            } else if (c !== '\t' && c !== '\n' && c !== '\r') {
              buffer += percentEscape(c);
            }
            break;
          case 'query':
            if (!stateOverride && c === '#') {
              this._fragment = '#';
              state = 'fragment';
            } else if (c !== EOF && c !== '\t' && c !== '\n' && c !== '\r') {
              this._query += percentEscapeQuery(c);
            }
            break;
          case 'fragment':
            if (c !== EOF && c !== '\t' && c !== '\n' && c !== '\r') {
              this._fragment += c;
            }
            break;
        }
        cursor++;
      }
    }
    function clear() {
      this._scheme = '';
      this._schemeData = '';
      this._username = '';
      this._password = null;
      this._host = '';
      this._port = '';
      this._path = [];
      this._query = '';
      this._fragment = '';
      this._isInvalid = false;
      this._isRelative = false;
    }
    function JURL(url, base) {
      if (base !== undefined && !(base instanceof JURL)) {
        base = new JURL(String(base));
      }
      this._url = url;
      clear.call(this);
      var input = url.replace(/^[ \t\r\n\f]+|[ \t\r\n\f]+$/g, '');
      parse.call(this, input, null, base);
    }
    JURL.prototype = {
      toString: function toString() {
        return this.href;
      },

      get href() {
        if (this._isInvalid) {
          return this._url;
        }
        var authority = '';
        if (this._username !== '' || this._password !== null) {
          authority = this._username + (this._password !== null ? ':' + this._password : '') + '@';
        }
        return this.protocol + (this._isRelative ? '//' + authority + this.host : '') + this.pathname + this._query + this._fragment;
      },
      set href(value) {
        clear.call(this);
        parse.call(this, value);
      },
      get protocol() {
        return this._scheme + ':';
      },
      set protocol(value) {
        if (this._isInvalid) {
          return;
        }
        parse.call(this, value + ':', 'scheme start');
      },
      get host() {
        return this._isInvalid ? '' : this._port ? this._host + ':' + this._port : this._host;
      },
      set host(value) {
        if (this._isInvalid || !this._isRelative) {
          return;
        }
        parse.call(this, value, 'host');
      },
      get hostname() {
        return this._host;
      },
      set hostname(value) {
        if (this._isInvalid || !this._isRelative) {
          return;
        }
        parse.call(this, value, 'hostname');
      },
      get port() {
        return this._port;
      },
      set port(value) {
        if (this._isInvalid || !this._isRelative) {
          return;
        }
        parse.call(this, value, 'port');
      },
      get pathname() {
        return this._isInvalid ? '' : this._isRelative ? '/' + this._path.join('/') : this._schemeData;
      },
      set pathname(value) {
        if (this._isInvalid || !this._isRelative) {
          return;
        }
        this._path = [];
        parse.call(this, value, 'relative path start');
      },
      get search() {
        return this._isInvalid || !this._query || this._query === '?' ? '' : this._query;
      },
      set search(value) {
        if (this._isInvalid || !this._isRelative) {
          return;
        }
        this._query = '?';
        if (value[0] === '?') {
          value = value.slice(1);
        }
        parse.call(this, value, 'query');
      },
      get hash() {
        return this._isInvalid || !this._fragment || this._fragment === '#' ? '' : this._fragment;
      },
      set hash(value) {
        if (this._isInvalid) {
          return;
        }
        this._fragment = '#';
        if (value[0] === '#') {
          value = value.slice(1);
        }
        parse.call(this, value, 'fragment');
      },
      get origin() {
        var host;
        if (this._isInvalid || !this._scheme) {
          return '';
        }
        switch (this._scheme) {
          case 'data':
          case 'file':
          case 'javascript':
          case 'mailto':
            return 'null';
          case 'blob':
            try {
              return new JURL(this._schemeData).origin || 'null';
            } catch (_) {}
            return 'null';
        }
        host = this.host;
        if (!host) {
          return '';
        }
        return this._scheme + '://' + host;
      }
    };
    var OriginalURL = globalScope.URL;
    if (OriginalURL) {
      JURL.createObjectURL = function (blob) {
        return OriginalURL.createObjectURL.apply(OriginalURL, arguments);
      };
      JURL.revokeObjectURL = function (url) {
        OriginalURL.revokeObjectURL(url);
      };
    }
    globalScope.URL = JURL;
  })();
}

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(0);

/***/ })
/******/ ]);
});

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],1184:[function(require,module,exports){
/* Copyright 2017 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("pdfjs-dist/web/pdf_viewer", [], factory);
	else if(typeof exports === 'object')
		exports["pdfjs-dist/web/pdf_viewer"] = factory();
	else
		root["pdfjs-dist/web/pdf_viewer"] = root.pdfjsDistWebPdfViewer = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __w_pdfjs_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __w_pdfjs_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__w_pdfjs_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__w_pdfjs_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__w_pdfjs_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__w_pdfjs_require__.d = function(exports, name, getter) {
/******/ 		if(!__w_pdfjs_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__w_pdfjs_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__w_pdfjs_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__w_pdfjs_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__w_pdfjs_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __w_pdfjs_require__(__w_pdfjs_require__.s = 14);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var pdfjsLib;
if (typeof window !== 'undefined' && window['pdfjs-dist/build/pdf']) {
  pdfjsLib = window['pdfjs-dist/build/pdf'];
} else {
  pdfjsLib = require('../build/pdf.js');
}
module.exports = pdfjsLib;

/***/ }),
/* 1 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.localized = exports.animationStarted = exports.normalizeWheelEventDelta = exports.binarySearchFirstItem = exports.watchScroll = exports.scrollIntoView = exports.getOutputScale = exports.approximateFraction = exports.roundToDivide = exports.getVisibleElements = exports.parseQueryString = exports.noContextMenuHandler = exports.getPDFFileNameFromURL = exports.ProgressBar = exports.EventBus = exports.NullL10n = exports.mozL10n = exports.RendererType = exports.cloneObj = exports.VERTICAL_PADDING = exports.SCROLLBAR_PADDING = exports.MAX_AUTO_SCALE = exports.UNKNOWN_SCALE = exports.MAX_SCALE = exports.MIN_SCALE = exports.DEFAULT_SCALE = exports.DEFAULT_SCALE_VALUE = exports.CSS_UNITS = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _pdfjsLib = __w_pdfjs_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CSS_UNITS = 96.0 / 72.0;
var DEFAULT_SCALE_VALUE = 'auto';
var DEFAULT_SCALE = 1.0;
var MIN_SCALE = 0.25;
var MAX_SCALE = 10.0;
var UNKNOWN_SCALE = 0;
var MAX_AUTO_SCALE = 1.25;
var SCROLLBAR_PADDING = 40;
var VERTICAL_PADDING = 5;
var RendererType = {
  CANVAS: 'canvas',
  SVG: 'svg'
};
function formatL10nValue(text, args) {
  if (!args) {
    return text;
  }
  return text.replace(/\{\{\s*(\w+)\s*\}\}/g, function (all, name) {
    return name in args ? args[name] : '{{' + name + '}}';
  });
}
var NullL10n = {
  get: function get(property, args, fallback) {
    return Promise.resolve(formatL10nValue(fallback, args));
  },
  translate: function translate(element) {
    return Promise.resolve();
  }
};
_pdfjsLib.PDFJS.disableFullscreen = _pdfjsLib.PDFJS.disableFullscreen === undefined ? false : _pdfjsLib.PDFJS.disableFullscreen;
_pdfjsLib.PDFJS.useOnlyCssZoom = _pdfjsLib.PDFJS.useOnlyCssZoom === undefined ? false : _pdfjsLib.PDFJS.useOnlyCssZoom;
_pdfjsLib.PDFJS.maxCanvasPixels = _pdfjsLib.PDFJS.maxCanvasPixels === undefined ? 16777216 : _pdfjsLib.PDFJS.maxCanvasPixels;
_pdfjsLib.PDFJS.disableHistory = _pdfjsLib.PDFJS.disableHistory === undefined ? false : _pdfjsLib.PDFJS.disableHistory;
_pdfjsLib.PDFJS.disableTextLayer = _pdfjsLib.PDFJS.disableTextLayer === undefined ? false : _pdfjsLib.PDFJS.disableTextLayer;
_pdfjsLib.PDFJS.ignoreCurrentPositionOnZoom = _pdfjsLib.PDFJS.ignoreCurrentPositionOnZoom === undefined ? false : _pdfjsLib.PDFJS.ignoreCurrentPositionOnZoom;
{
  _pdfjsLib.PDFJS.locale = _pdfjsLib.PDFJS.locale === undefined && typeof navigator !== 'undefined' ? navigator.language : _pdfjsLib.PDFJS.locale;
}
function getOutputScale(ctx) {
  var devicePixelRatio = window.devicePixelRatio || 1;
  var backingStoreRatio = ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1;
  var pixelRatio = devicePixelRatio / backingStoreRatio;
  return {
    sx: pixelRatio,
    sy: pixelRatio,
    scaled: pixelRatio !== 1
  };
}
function scrollIntoView(element, spot) {
  var skipOverflowHiddenElements = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var parent = element.offsetParent;
  if (!parent) {
    console.error('offsetParent is not set -- cannot scroll');
    return;
  }
  var offsetY = element.offsetTop + element.clientTop;
  var offsetX = element.offsetLeft + element.clientLeft;
  while (parent.clientHeight === parent.scrollHeight || skipOverflowHiddenElements && getComputedStyle(parent).overflow === 'hidden') {
    if (parent.dataset._scaleY) {
      offsetY /= parent.dataset._scaleY;
      offsetX /= parent.dataset._scaleX;
    }
    offsetY += parent.offsetTop;
    offsetX += parent.offsetLeft;
    parent = parent.offsetParent;
    if (!parent) {
      return;
    }
  }
  if (spot) {
    if (spot.top !== undefined) {
      offsetY += spot.top;
    }
    if (spot.left !== undefined) {
      offsetX += spot.left;
      parent.scrollLeft = offsetX;
    }
  }
  parent.scrollTop = offsetY;
}
function watchScroll(viewAreaElement, callback) {
  var debounceScroll = function debounceScroll(evt) {
    if (rAF) {
      return;
    }
    rAF = window.requestAnimationFrame(function viewAreaElementScrolled() {
      rAF = null;
      var currentY = viewAreaElement.scrollTop;
      var lastY = state.lastY;
      if (currentY !== lastY) {
        state.down = currentY > lastY;
      }
      state.lastY = currentY;
      callback(state);
    });
  };
  var state = {
    down: true,
    lastY: viewAreaElement.scrollTop,
    _eventHandler: debounceScroll
  };
  var rAF = null;
  viewAreaElement.addEventListener('scroll', debounceScroll, true);
  return state;
}
function parseQueryString(query) {
  var parts = query.split('&');
  var params = Object.create(null);
  for (var i = 0, ii = parts.length; i < ii; ++i) {
    var param = parts[i].split('=');
    var key = param[0].toLowerCase();
    var value = param.length > 1 ? param[1] : null;
    params[decodeURIComponent(key)] = decodeURIComponent(value);
  }
  return params;
}
function binarySearchFirstItem(items, condition) {
  var minIndex = 0;
  var maxIndex = items.length - 1;
  if (items.length === 0 || !condition(items[maxIndex])) {
    return items.length;
  }
  if (condition(items[minIndex])) {
    return minIndex;
  }
  while (minIndex < maxIndex) {
    var currentIndex = minIndex + maxIndex >> 1;
    var currentItem = items[currentIndex];
    if (condition(currentItem)) {
      maxIndex = currentIndex;
    } else {
      minIndex = currentIndex + 1;
    }
  }
  return minIndex;
}
function approximateFraction(x) {
  if (Math.floor(x) === x) {
    return [x, 1];
  }
  var xinv = 1 / x;
  var limit = 8;
  if (xinv > limit) {
    return [1, limit];
  } else if (Math.floor(xinv) === xinv) {
    return [1, xinv];
  }
  var x_ = x > 1 ? xinv : x;
  var a = 0,
      b = 1,
      c = 1,
      d = 1;
  while (true) {
    var p = a + c,
        q = b + d;
    if (q > limit) {
      break;
    }
    if (x_ <= p / q) {
      c = p;
      d = q;
    } else {
      a = p;
      b = q;
    }
  }
  var result = void 0;
  if (x_ - a / b < c / d - x_) {
    result = x_ === x ? [a, b] : [b, a];
  } else {
    result = x_ === x ? [c, d] : [d, c];
  }
  return result;
}
function roundToDivide(x, div) {
  var r = x % div;
  return r === 0 ? x : Math.round(x - r + div);
}
function getVisibleElements(scrollEl, views) {
  var sortByVisibility = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var top = scrollEl.scrollTop,
      bottom = top + scrollEl.clientHeight;
  var left = scrollEl.scrollLeft,
      right = left + scrollEl.clientWidth;
  function isElementBottomBelowViewTop(view) {
    var element = view.div;
    var elementBottom = element.offsetTop + element.clientTop + element.clientHeight;
    return elementBottom > top;
  }
  var visible = [],
      view = void 0,
      element = void 0;
  var currentHeight = void 0,
      viewHeight = void 0,
      hiddenHeight = void 0,
      percentHeight = void 0;
  var currentWidth = void 0,
      viewWidth = void 0;
  var firstVisibleElementInd = views.length === 0 ? 0 : binarySearchFirstItem(views, isElementBottomBelowViewTop);
  for (var i = firstVisibleElementInd, ii = views.length; i < ii; i++) {
    view = views[i];
    element = view.div;
    currentHeight = element.offsetTop + element.clientTop;
    viewHeight = element.clientHeight;
    if (currentHeight > bottom) {
      break;
    }
    currentWidth = element.offsetLeft + element.clientLeft;
    viewWidth = element.clientWidth;
    if (currentWidth + viewWidth < left || currentWidth > right) {
      continue;
    }
    hiddenHeight = Math.max(0, top - currentHeight) + Math.max(0, currentHeight + viewHeight - bottom);
    percentHeight = (viewHeight - hiddenHeight) * 100 / viewHeight | 0;
    visible.push({
      id: view.id,
      x: currentWidth,
      y: currentHeight,
      view: view,
      percent: percentHeight
    });
  }
  var first = visible[0];
  var last = visible[visible.length - 1];
  if (sortByVisibility) {
    visible.sort(function (a, b) {
      var pc = a.percent - b.percent;
      if (Math.abs(pc) > 0.001) {
        return -pc;
      }
      return a.id - b.id;
    });
  }
  return {
    first: first,
    last: last,
    views: visible
  };
}
function noContextMenuHandler(evt) {
  evt.preventDefault();
}
function isDataSchema(url) {
  var i = 0,
      ii = url.length;
  while (i < ii && url[i].trim() === '') {
    i++;
  }
  return url.substr(i, 5).toLowerCase() === 'data:';
}
function getPDFFileNameFromURL(url) {
  var defaultFilename = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'document.pdf';

  if (isDataSchema(url)) {
    console.warn('getPDFFileNameFromURL: ' + 'ignoring "data:" URL for performance reasons.');
    return defaultFilename;
  }
  var reURI = /^(?:(?:[^:]+:)?\/\/[^\/]+)?([^?#]*)(\?[^#]*)?(#.*)?$/;
  var reFilename = /[^\/?#=]+\.pdf\b(?!.*\.pdf\b)/i;
  var splitURI = reURI.exec(url);
  var suggestedFilename = reFilename.exec(splitURI[1]) || reFilename.exec(splitURI[2]) || reFilename.exec(splitURI[3]);
  if (suggestedFilename) {
    suggestedFilename = suggestedFilename[0];
    if (suggestedFilename.indexOf('%') !== -1) {
      try {
        suggestedFilename = reFilename.exec(decodeURIComponent(suggestedFilename))[0];
      } catch (ex) {}
    }
  }
  return suggestedFilename || defaultFilename;
}
function normalizeWheelEventDelta(evt) {
  var delta = Math.sqrt(evt.deltaX * evt.deltaX + evt.deltaY * evt.deltaY);
  var angle = Math.atan2(evt.deltaY, evt.deltaX);
  if (-0.25 * Math.PI < angle && angle < 0.75 * Math.PI) {
    delta = -delta;
  }
  var MOUSE_DOM_DELTA_PIXEL_MODE = 0;
  var MOUSE_DOM_DELTA_LINE_MODE = 1;
  var MOUSE_PIXELS_PER_LINE = 30;
  var MOUSE_LINES_PER_PAGE = 30;
  if (evt.deltaMode === MOUSE_DOM_DELTA_PIXEL_MODE) {
    delta /= MOUSE_PIXELS_PER_LINE * MOUSE_LINES_PER_PAGE;
  } else if (evt.deltaMode === MOUSE_DOM_DELTA_LINE_MODE) {
    delta /= MOUSE_LINES_PER_PAGE;
  }
  return delta;
}
function cloneObj(obj) {
  var result = Object.create(null);
  for (var i in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, i)) {
      result[i] = obj[i];
    }
  }
  return result;
}
var animationStarted = new Promise(function (resolve) {
  window.requestAnimationFrame(resolve);
});
var mozL10n = void 0;
var localized = Promise.resolve();

var EventBus = function () {
  function EventBus() {
    _classCallCheck(this, EventBus);

    this._listeners = Object.create(null);
  }

  _createClass(EventBus, [{
    key: 'on',
    value: function on(eventName, listener) {
      var eventListeners = this._listeners[eventName];
      if (!eventListeners) {
        eventListeners = [];
        this._listeners[eventName] = eventListeners;
      }
      eventListeners.push(listener);
    }
  }, {
    key: 'off',
    value: function off(eventName, listener) {
      var eventListeners = this._listeners[eventName];
      var i = void 0;
      if (!eventListeners || (i = eventListeners.indexOf(listener)) < 0) {
        return;
      }
      eventListeners.splice(i, 1);
    }
  }, {
    key: 'dispatch',
    value: function dispatch(eventName) {
      var eventListeners = this._listeners[eventName];
      if (!eventListeners || eventListeners.length === 0) {
        return;
      }
      var args = Array.prototype.slice.call(arguments, 1);
      eventListeners.slice(0).forEach(function (listener) {
        listener.apply(null, args);
      });
    }
  }]);

  return EventBus;
}();

function clamp(v, min, max) {
  return Math.min(Math.max(v, min), max);
}

var ProgressBar = function () {
  function ProgressBar(id) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        height = _ref.height,
        width = _ref.width,
        units = _ref.units;

    _classCallCheck(this, ProgressBar);

    this.visible = true;
    this.div = document.querySelector(id + ' .progress');
    this.bar = this.div.parentNode;
    this.height = height || 100;
    this.width = width || 100;
    this.units = units || '%';
    this.div.style.height = this.height + this.units;
    this.percent = 0;
  }

  _createClass(ProgressBar, [{
    key: '_updateBar',
    value: function _updateBar() {
      if (this._indeterminate) {
        this.div.classList.add('indeterminate');
        this.div.style.width = this.width + this.units;
        return;
      }
      this.div.classList.remove('indeterminate');
      var progressSize = this.width * this._percent / 100;
      this.div.style.width = progressSize + this.units;
    }
  }, {
    key: 'setWidth',
    value: function setWidth(viewer) {
      if (!viewer) {
        return;
      }
      var container = viewer.parentNode;
      var scrollbarWidth = container.offsetWidth - viewer.offsetWidth;
      if (scrollbarWidth > 0) {
        this.bar.setAttribute('style', 'width: calc(100% - ' + scrollbarWidth + 'px);');
      }
    }
  }, {
    key: 'hide',
    value: function hide() {
      if (!this.visible) {
        return;
      }
      this.visible = false;
      this.bar.classList.add('hidden');
      document.body.classList.remove('loadingInProgress');
    }
  }, {
    key: 'show',
    value: function show() {
      if (this.visible) {
        return;
      }
      this.visible = true;
      document.body.classList.add('loadingInProgress');
      this.bar.classList.remove('hidden');
    }
  }, {
    key: 'percent',
    get: function get() {
      return this._percent;
    },
    set: function set(val) {
      this._indeterminate = isNaN(val);
      this._percent = clamp(val, 0, 100);
      this._updateBar();
    }
  }]);

  return ProgressBar;
}();

exports.CSS_UNITS = CSS_UNITS;
exports.DEFAULT_SCALE_VALUE = DEFAULT_SCALE_VALUE;
exports.DEFAULT_SCALE = DEFAULT_SCALE;
exports.MIN_SCALE = MIN_SCALE;
exports.MAX_SCALE = MAX_SCALE;
exports.UNKNOWN_SCALE = UNKNOWN_SCALE;
exports.MAX_AUTO_SCALE = MAX_AUTO_SCALE;
exports.SCROLLBAR_PADDING = SCROLLBAR_PADDING;
exports.VERTICAL_PADDING = VERTICAL_PADDING;
exports.cloneObj = cloneObj;
exports.RendererType = RendererType;
exports.mozL10n = mozL10n;
exports.NullL10n = NullL10n;
exports.EventBus = EventBus;
exports.ProgressBar = ProgressBar;
exports.getPDFFileNameFromURL = getPDFFileNameFromURL;
exports.noContextMenuHandler = noContextMenuHandler;
exports.parseQueryString = parseQueryString;
exports.getVisibleElements = getVisibleElements;
exports.roundToDivide = roundToDivide;
exports.approximateFraction = approximateFraction;
exports.getOutputScale = getOutputScale;
exports.scrollIntoView = scrollIntoView;
exports.watchScroll = watchScroll;
exports.binarySearchFirstItem = binarySearchFirstItem;
exports.normalizeWheelEventDelta = normalizeWheelEventDelta;
exports.animationStarted = animationStarted;
exports.localized = localized;

/***/ }),
/* 2 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGlobalEventBus = exports.attachDOMEventsToEventBus = undefined;

var _ui_utils = __w_pdfjs_require__(1);

function attachDOMEventsToEventBus(eventBus) {
  eventBus.on('documentload', function () {
    var event = document.createEvent('CustomEvent');
    event.initCustomEvent('documentload', true, true, {});
    window.dispatchEvent(event);
  });
  eventBus.on('pagerendered', function (evt) {
    var event = document.createEvent('CustomEvent');
    event.initCustomEvent('pagerendered', true, true, {
      pageNumber: evt.pageNumber,
      cssTransform: evt.cssTransform
    });
    evt.source.div.dispatchEvent(event);
  });
  eventBus.on('textlayerrendered', function (evt) {
    var event = document.createEvent('CustomEvent');
    event.initCustomEvent('textlayerrendered', true, true, { pageNumber: evt.pageNumber });
    evt.source.textLayerDiv.dispatchEvent(event);
  });
  eventBus.on('pagechange', function (evt) {
    var event = document.createEvent('UIEvents');
    event.initUIEvent('pagechange', true, true, window, 0);
    event.pageNumber = evt.pageNumber;
    evt.source.container.dispatchEvent(event);
  });
  eventBus.on('pagesinit', function (evt) {
    var event = document.createEvent('CustomEvent');
    event.initCustomEvent('pagesinit', true, true, null);
    evt.source.container.dispatchEvent(event);
  });
  eventBus.on('pagesloaded', function (evt) {
    var event = document.createEvent('CustomEvent');
    event.initCustomEvent('pagesloaded', true, true, { pagesCount: evt.pagesCount });
    evt.source.container.dispatchEvent(event);
  });
  eventBus.on('scalechange', function (evt) {
    var event = document.createEvent('UIEvents');
    event.initUIEvent('scalechange', true, true, window, 0);
    event.scale = evt.scale;
    event.presetValue = evt.presetValue;
    evt.source.container.dispatchEvent(event);
  });
  eventBus.on('updateviewarea', function (evt) {
    var event = document.createEvent('UIEvents');
    event.initUIEvent('updateviewarea', true, true, window, 0);
    event.location = evt.location;
    evt.source.container.dispatchEvent(event);
  });
  eventBus.on('find', function (evt) {
    if (evt.source === window) {
      return;
    }
    var event = document.createEvent('CustomEvent');
    event.initCustomEvent('find' + evt.type, true, true, {
      query: evt.query,
      phraseSearch: evt.phraseSearch,
      caseSensitive: evt.caseSensitive,
      highlightAll: evt.highlightAll,
      findPrevious: evt.findPrevious
    });
    window.dispatchEvent(event);
  });
  eventBus.on('attachmentsloaded', function (evt) {
    var event = document.createEvent('CustomEvent');
    event.initCustomEvent('attachmentsloaded', true, true, { attachmentsCount: evt.attachmentsCount });
    evt.source.container.dispatchEvent(event);
  });
  eventBus.on('sidebarviewchanged', function (evt) {
    var event = document.createEvent('CustomEvent');
    event.initCustomEvent('sidebarviewchanged', true, true, { view: evt.view });
    evt.source.outerContainer.dispatchEvent(event);
  });
  eventBus.on('pagemode', function (evt) {
    var event = document.createEvent('CustomEvent');
    event.initCustomEvent('pagemode', true, true, { mode: evt.mode });
    evt.source.pdfViewer.container.dispatchEvent(event);
  });
  eventBus.on('namedaction', function (evt) {
    var event = document.createEvent('CustomEvent');
    event.initCustomEvent('namedaction', true, true, { action: evt.action });
    evt.source.pdfViewer.container.dispatchEvent(event);
  });
  eventBus.on('presentationmodechanged', function (evt) {
    var event = document.createEvent('CustomEvent');
    event.initCustomEvent('presentationmodechanged', true, true, {
      active: evt.active,
      switchInProgress: evt.switchInProgress
    });
    window.dispatchEvent(event);
  });
  eventBus.on('outlineloaded', function (evt) {
    var event = document.createEvent('CustomEvent');
    event.initCustomEvent('outlineloaded', true, true, { outlineCount: evt.outlineCount });
    evt.source.container.dispatchEvent(event);
  });
}
var globalEventBus = null;
function getGlobalEventBus() {
  if (globalEventBus) {
    return globalEventBus;
  }
  globalEventBus = new _ui_utils.EventBus();
  attachDOMEventsToEventBus(globalEventBus);
  return globalEventBus;
}
exports.attachDOMEventsToEventBus = attachDOMEventsToEventBus;
exports.getGlobalEventBus = getGlobalEventBus;

/***/ }),
/* 3 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimpleLinkService = exports.PDFLinkService = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dom_events = __w_pdfjs_require__(2);

var _ui_utils = __w_pdfjs_require__(1);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PDFLinkService = function () {
  function PDFLinkService() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        eventBus = _ref.eventBus;

    _classCallCheck(this, PDFLinkService);

    this.eventBus = eventBus || (0, _dom_events.getGlobalEventBus)();
    this.baseUrl = null;
    this.pdfDocument = null;
    this.pdfViewer = null;
    this.pdfHistory = null;
    this._pagesRefCache = null;
  }

  _createClass(PDFLinkService, [{
    key: 'setDocument',
    value: function setDocument(pdfDocument, baseUrl) {
      this.baseUrl = baseUrl;
      this.pdfDocument = pdfDocument;
      this._pagesRefCache = Object.create(null);
    }
  }, {
    key: 'setViewer',
    value: function setViewer(pdfViewer) {
      this.pdfViewer = pdfViewer;
    }
  }, {
    key: 'setHistory',
    value: function setHistory(pdfHistory) {
      this.pdfHistory = pdfHistory;
    }
  }, {
    key: 'navigateTo',
    value: function navigateTo(dest) {
      var _this = this;

      var goToDestination = function goToDestination(_ref2) {
        var namedDest = _ref2.namedDest,
            explicitDest = _ref2.explicitDest;

        var destRef = explicitDest[0],
            pageNumber = void 0;
        if (destRef instanceof Object) {
          pageNumber = _this._cachedPageNumber(destRef);
          if (pageNumber === null) {
            _this.pdfDocument.getPageIndex(destRef).then(function (pageIndex) {
              _this.cachePageRef(pageIndex + 1, destRef);
              goToDestination({
                namedDest: namedDest,
                explicitDest: explicitDest
              });
            }).catch(function () {
              console.error('PDFLinkService.navigateTo: "' + destRef + '" is not ' + ('a valid page reference, for dest="' + dest + '".'));
            });
            return;
          }
        } else if ((destRef | 0) === destRef) {
          pageNumber = destRef + 1;
        } else {
          console.error('PDFLinkService.navigateTo: "' + destRef + '" is not ' + ('a valid destination reference, for dest="' + dest + '".'));
          return;
        }
        if (!pageNumber || pageNumber < 1 || pageNumber > _this.pagesCount) {
          console.error('PDFLinkService.navigateTo: "' + pageNumber + '" is not ' + ('a valid page number, for dest="' + dest + '".'));
          return;
        }
        _this.pdfViewer.scrollPageIntoView({
          pageNumber: pageNumber,
          destArray: explicitDest
        });
        if (_this.pdfHistory) {
          _this.pdfHistory.push({
            dest: explicitDest,
            hash: namedDest,
            page: pageNumber
          });
        }
      };
      new Promise(function (resolve, reject) {
        if (typeof dest === 'string') {
          _this.pdfDocument.getDestination(dest).then(function (destArray) {
            resolve({
              namedDest: dest,
              explicitDest: destArray
            });
          });
          return;
        }
        resolve({
          namedDest: '',
          explicitDest: dest
        });
      }).then(function (data) {
        if (!(data.explicitDest instanceof Array)) {
          console.error('PDFLinkService.navigateTo: "' + data.explicitDest + '" is' + (' not a valid destination array, for dest="' + dest + '".'));
          return;
        }
        goToDestination(data);
      });
    }
  }, {
    key: 'getDestinationHash',
    value: function getDestinationHash(dest) {
      if (typeof dest === 'string') {
        return this.getAnchorUrl('#' + escape(dest));
      }
      if (dest instanceof Array) {
        var str = JSON.stringify(dest);
        return this.getAnchorUrl('#' + escape(str));
      }
      return this.getAnchorUrl('');
    }
  }, {
    key: 'getAnchorUrl',
    value: function getAnchorUrl(anchor) {
      return (this.baseUrl || '') + anchor;
    }
  }, {
    key: 'setHash',
    value: function setHash(hash) {
      var pageNumber = void 0,
          dest = void 0;
      if (hash.indexOf('=') >= 0) {
        var params = (0, _ui_utils.parseQueryString)(hash);
        if ('search' in params) {
          this.eventBus.dispatch('findfromurlhash', {
            source: this,
            query: params['search'].replace(/"/g, ''),
            phraseSearch: params['phrase'] === 'true'
          });
        }
        if ('nameddest' in params) {
          if (this.pdfHistory) {
            this.pdfHistory.updateNextHashParam(params.nameddest);
          }
          this.navigateTo(params.nameddest);
          return;
        }
        if ('page' in params) {
          pageNumber = params.page | 0 || 1;
        }
        if ('zoom' in params) {
          var zoomArgs = params.zoom.split(',');
          var zoomArg = zoomArgs[0];
          var zoomArgNumber = parseFloat(zoomArg);
          if (zoomArg.indexOf('Fit') === -1) {
            dest = [null, { name: 'XYZ' }, zoomArgs.length > 1 ? zoomArgs[1] | 0 : null, zoomArgs.length > 2 ? zoomArgs[2] | 0 : null, zoomArgNumber ? zoomArgNumber / 100 : zoomArg];
          } else {
            if (zoomArg === 'Fit' || zoomArg === 'FitB') {
              dest = [null, { name: zoomArg }];
            } else if (zoomArg === 'FitH' || zoomArg === 'FitBH' || zoomArg === 'FitV' || zoomArg === 'FitBV') {
              dest = [null, { name: zoomArg }, zoomArgs.length > 1 ? zoomArgs[1] | 0 : null];
            } else if (zoomArg === 'FitR') {
              if (zoomArgs.length !== 5) {
                console.error('PDFLinkService.setHash: Not enough parameters for "FitR".');
              } else {
                dest = [null, { name: zoomArg }, zoomArgs[1] | 0, zoomArgs[2] | 0, zoomArgs[3] | 0, zoomArgs[4] | 0];
              }
            } else {
              console.error('PDFLinkService.setHash: "' + zoomArg + '" is not ' + 'a valid zoom value.');
            }
          }
        }
        if (dest) {
          this.pdfViewer.scrollPageIntoView({
            pageNumber: pageNumber || this.page,
            destArray: dest,
            allowNegativeOffset: true
          });
        } else if (pageNumber) {
          this.page = pageNumber;
        }
        if ('pagemode' in params) {
          this.eventBus.dispatch('pagemode', {
            source: this,
            mode: params.pagemode
          });
        }
      } else {
        if (/^\d+$/.test(hash) && hash <= this.pagesCount) {
          console.warn('PDFLinkService_setHash: specifying a page number ' + 'directly after the hash symbol (#) is deprecated, ' + ('please use the "#page=' + hash + '" form instead.'));
          this.page = hash | 0;
        }
        dest = unescape(hash);
        try {
          dest = JSON.parse(dest);
          if (!(dest instanceof Array)) {
            dest = dest.toString();
          }
        } catch (ex) {}
        if (typeof dest === 'string' || isValidExplicitDestination(dest)) {
          if (this.pdfHistory) {
            this.pdfHistory.updateNextHashParam(dest);
          }
          this.navigateTo(dest);
          return;
        }
        console.error('PDFLinkService.setHash: "' + unescape(hash) + '" is not ' + 'a valid destination.');
      }
    }
  }, {
    key: 'executeNamedAction',
    value: function executeNamedAction(action) {
      switch (action) {
        case 'GoBack':
          if (this.pdfHistory) {
            this.pdfHistory.back();
          }
          break;
        case 'GoForward':
          if (this.pdfHistory) {
            this.pdfHistory.forward();
          }
          break;
        case 'NextPage':
          if (this.page < this.pagesCount) {
            this.page++;
          }
          break;
        case 'PrevPage':
          if (this.page > 1) {
            this.page--;
          }
          break;
        case 'LastPage':
          this.page = this.pagesCount;
          break;
        case 'FirstPage':
          this.page = 1;
          break;
        default:
          break;
      }
      this.eventBus.dispatch('namedaction', {
        source: this,
        action: action
      });
    }
  }, {
    key: 'onFileAttachmentAnnotation',
    value: function onFileAttachmentAnnotation(_ref3) {
      var id = _ref3.id,
          filename = _ref3.filename,
          content = _ref3.content;

      this.eventBus.dispatch('fileattachmentannotation', {
        source: this,
        id: id,
        filename: filename,
        content: content
      });
    }
  }, {
    key: 'cachePageRef',
    value: function cachePageRef(pageNum, pageRef) {
      var refStr = pageRef.num + ' ' + pageRef.gen + ' R';
      this._pagesRefCache[refStr] = pageNum;
    }
  }, {
    key: '_cachedPageNumber',
    value: function _cachedPageNumber(pageRef) {
      var refStr = pageRef.num + ' ' + pageRef.gen + ' R';
      return this._pagesRefCache && this._pagesRefCache[refStr] || null;
    }
  }, {
    key: 'pagesCount',
    get: function get() {
      return this.pdfDocument ? this.pdfDocument.numPages : 0;
    }
  }, {
    key: 'page',
    get: function get() {
      return this.pdfViewer.currentPageNumber;
    },
    set: function set(value) {
      this.pdfViewer.currentPageNumber = value;
    }
  }]);

  return PDFLinkService;
}();

function isValidExplicitDestination(dest) {
  if (!(dest instanceof Array)) {
    return false;
  }
  var destLength = dest.length,
      allowNull = true;
  if (destLength < 2) {
    return false;
  }
  var page = dest[0];
  if (!((typeof page === 'undefined' ? 'undefined' : _typeof(page)) === 'object' && typeof page.num === 'number' && (page.num | 0) === page.num && typeof page.gen === 'number' && (page.gen | 0) === page.gen) && !(typeof page === 'number' && (page | 0) === page && page >= 0)) {
    return false;
  }
  var zoom = dest[1];
  if (!((typeof zoom === 'undefined' ? 'undefined' : _typeof(zoom)) === 'object' && typeof zoom.name === 'string')) {
    return false;
  }
  switch (zoom.name) {
    case 'XYZ':
      if (destLength !== 5) {
        return false;
      }
      break;
    case 'Fit':
    case 'FitB':
      return destLength === 2;
    case 'FitH':
    case 'FitBH':
    case 'FitV':
    case 'FitBV':
      if (destLength !== 3) {
        return false;
      }
      break;
    case 'FitR':
      if (destLength !== 6) {
        return false;
      }
      allowNull = false;
      break;
    default:
      return false;
  }
  for (var i = 2; i < destLength; i++) {
    var param = dest[i];
    if (!(typeof param === 'number' || allowNull && param === null)) {
      return false;
    }
  }
  return true;
}

var SimpleLinkService = function () {
  function SimpleLinkService() {
    _classCallCheck(this, SimpleLinkService);
  }

  _createClass(SimpleLinkService, [{
    key: 'navigateTo',
    value: function navigateTo(dest) {}
  }, {
    key: 'getDestinationHash',
    value: function getDestinationHash(dest) {
      return '#';
    }
  }, {
    key: 'getAnchorUrl',
    value: function getAnchorUrl(hash) {
      return '#';
    }
  }, {
    key: 'setHash',
    value: function setHash(hash) {}
  }, {
    key: 'executeNamedAction',
    value: function executeNamedAction(action) {}
  }, {
    key: 'onFileAttachmentAnnotation',
    value: function onFileAttachmentAnnotation(_ref4) {
      var id = _ref4.id,
          filename = _ref4.filename,
          content = _ref4.content;
    }
  }, {
    key: 'cachePageRef',
    value: function cachePageRef(pageNum, pageRef) {}
  }, {
    key: 'page',
    get: function get() {
      return 0;
    },
    set: function set(value) {}
  }]);

  return SimpleLinkService;
}();

exports.PDFLinkService = PDFLinkService;
exports.SimpleLinkService = SimpleLinkService;

/***/ }),
/* 4 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultAnnotationLayerFactory = exports.AnnotationLayerBuilder = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _pdfjsLib = __w_pdfjs_require__(0);

var _ui_utils = __w_pdfjs_require__(1);

var _pdf_link_service = __w_pdfjs_require__(3);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AnnotationLayerBuilder = function () {
  function AnnotationLayerBuilder(_ref) {
    var pageDiv = _ref.pageDiv,
        pdfPage = _ref.pdfPage,
        linkService = _ref.linkService,
        downloadManager = _ref.downloadManager,
        _ref$renderInteractiv = _ref.renderInteractiveForms,
        renderInteractiveForms = _ref$renderInteractiv === undefined ? false : _ref$renderInteractiv,
        _ref$l10n = _ref.l10n,
        l10n = _ref$l10n === undefined ? _ui_utils.NullL10n : _ref$l10n;

    _classCallCheck(this, AnnotationLayerBuilder);

    this.pageDiv = pageDiv;
    this.pdfPage = pdfPage;
    this.linkService = linkService;
    this.downloadManager = downloadManager;
    this.renderInteractiveForms = renderInteractiveForms;
    this.l10n = l10n;
    this.div = null;
  }

  _createClass(AnnotationLayerBuilder, [{
    key: 'render',
    value: function render(viewport) {
      var _this = this;

      var intent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'display';

      this.pdfPage.getAnnotations({ intent: intent }).then(function (annotations) {
        var parameters = {
          viewport: viewport.clone({ dontFlip: true }),
          div: _this.div,
          annotations: annotations,
          page: _this.pdfPage,
          renderInteractiveForms: _this.renderInteractiveForms,
          linkService: _this.linkService,
          downloadManager: _this.downloadManager
        };
        if (_this.div) {
          _pdfjsLib.AnnotationLayer.update(parameters);
        } else {
          if (annotations.length === 0) {
            return;
          }
          _this.div = document.createElement('div');
          _this.div.className = 'annotationLayer';
          _this.pageDiv.appendChild(_this.div);
          parameters.div = _this.div;
          _pdfjsLib.AnnotationLayer.render(parameters);
          _this.l10n.translate(_this.div);
        }
      });
    }
  }, {
    key: 'hide',
    value: function hide() {
      if (!this.div) {
        return;
      }
      this.div.setAttribute('hidden', 'true');
    }
  }]);

  return AnnotationLayerBuilder;
}();

var DefaultAnnotationLayerFactory = function () {
  function DefaultAnnotationLayerFactory() {
    _classCallCheck(this, DefaultAnnotationLayerFactory);
  }

  _createClass(DefaultAnnotationLayerFactory, [{
    key: 'createAnnotationLayerBuilder',
    value: function createAnnotationLayerBuilder(pageDiv, pdfPage) {
      var renderInteractiveForms = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var l10n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _ui_utils.NullL10n;

      return new AnnotationLayerBuilder({
        pageDiv: pageDiv,
        pdfPage: pdfPage,
        renderInteractiveForms: renderInteractiveForms,
        linkService: new _pdf_link_service.SimpleLinkService(),
        l10n: l10n
      });
    }
  }]);

  return DefaultAnnotationLayerFactory;
}();

exports.AnnotationLayerBuilder = AnnotationLayerBuilder;
exports.DefaultAnnotationLayerFactory = DefaultAnnotationLayerFactory;

/***/ }),
/* 5 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PDFPageView = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ui_utils = __w_pdfjs_require__(1);

var _pdfjsLib = __w_pdfjs_require__(0);

var _dom_events = __w_pdfjs_require__(2);

var _pdf_rendering_queue = __w_pdfjs_require__(7);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PDFPageView = function () {
  function PDFPageView(options) {
    _classCallCheck(this, PDFPageView);

    var container = options.container;
    var defaultViewport = options.defaultViewport;
    this.id = options.id;
    this.renderingId = 'page' + this.id;
    this.pdfPage = null;
    this.pageLabel = null;
    this.rotation = 0;
    this.scale = options.scale || _ui_utils.DEFAULT_SCALE;
    this.viewport = defaultViewport;
    this.pdfPageRotate = defaultViewport.rotation;
    this.hasRestrictedScaling = false;
    this.enhanceTextSelection = options.enhanceTextSelection || false;
    this.renderInteractiveForms = options.renderInteractiveForms || false;
    this.eventBus = options.eventBus || (0, _dom_events.getGlobalEventBus)();
    this.renderingQueue = options.renderingQueue;
    this.textLayerFactory = options.textLayerFactory;
    this.annotationLayerFactory = options.annotationLayerFactory;
    this.renderer = options.renderer || _ui_utils.RendererType.CANVAS;
    this.l10n = options.l10n || _ui_utils.NullL10n;
    this.paintTask = null;
    this.paintedViewportMap = new WeakMap();
    this.renderingState = _pdf_rendering_queue.RenderingStates.INITIAL;
    this.resume = null;
    this.error = null;
    this.onBeforeDraw = null;
    this.onAfterDraw = null;
    this.annotationLayer = null;
    this.textLayer = null;
    this.zoomLayer = null;
    var div = document.createElement('div');
    div.className = 'page';
    div.style.width = Math.floor(this.viewport.width) + 'px';
    div.style.height = Math.floor(this.viewport.height) + 'px';
    div.setAttribute('data-page-number', this.id);
    this.div = div;
    container.appendChild(div);
  }

  _createClass(PDFPageView, [{
    key: 'setPdfPage',
    value: function setPdfPage(pdfPage) {
      this.pdfPage = pdfPage;
      this.pdfPageRotate = pdfPage.rotate;
      var totalRotation = (this.rotation + this.pdfPageRotate) % 360;
      this.viewport = pdfPage.getViewport(this.scale * _ui_utils.CSS_UNITS, totalRotation);
      this.stats = pdfPage.stats;
      this.reset();
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.reset();
      if (this.pdfPage) {
        this.pdfPage.cleanup();
        this.pdfPage = null;
      }
    }
  }, {
    key: '_resetZoomLayer',
    value: function _resetZoomLayer() {
      var removeFromDOM = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!this.zoomLayer) {
        return;
      }
      var zoomLayerCanvas = this.zoomLayer.firstChild;
      this.paintedViewportMap.delete(zoomLayerCanvas);
      zoomLayerCanvas.width = 0;
      zoomLayerCanvas.height = 0;
      if (removeFromDOM) {
        this.zoomLayer.remove();
      }
      this.zoomLayer = null;
    }
  }, {
    key: 'reset',
    value: function reset() {
      var keepZoomLayer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var keepAnnotations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      this.cancelRendering();
      var div = this.div;
      div.style.width = Math.floor(this.viewport.width) + 'px';
      div.style.height = Math.floor(this.viewport.height) + 'px';
      var childNodes = div.childNodes;
      var currentZoomLayerNode = keepZoomLayer && this.zoomLayer || null;
      var currentAnnotationNode = keepAnnotations && this.annotationLayer && this.annotationLayer.div || null;
      for (var i = childNodes.length - 1; i >= 0; i--) {
        var node = childNodes[i];
        if (currentZoomLayerNode === node || currentAnnotationNode === node) {
          continue;
        }
        div.removeChild(node);
      }
      div.removeAttribute('data-loaded');
      if (currentAnnotationNode) {
        this.annotationLayer.hide();
      } else {
        this.annotationLayer = null;
      }
      if (!currentZoomLayerNode) {
        if (this.canvas) {
          this.paintedViewportMap.delete(this.canvas);
          this.canvas.width = 0;
          this.canvas.height = 0;
          delete this.canvas;
        }
        this._resetZoomLayer();
      }
      if (this.svg) {
        this.paintedViewportMap.delete(this.svg);
        delete this.svg;
      }
      this.loadingIconDiv = document.createElement('div');
      this.loadingIconDiv.className = 'loadingIcon';
      div.appendChild(this.loadingIconDiv);
    }
  }, {
    key: 'update',
    value: function update(scale, rotation) {
      this.scale = scale || this.scale;
      if (typeof rotation !== 'undefined') {
        this.rotation = rotation;
      }
      var totalRotation = (this.rotation + this.pdfPageRotate) % 360;
      this.viewport = this.viewport.clone({
        scale: this.scale * _ui_utils.CSS_UNITS,
        rotation: totalRotation
      });
      if (this.svg) {
        this.cssTransform(this.svg, true);
        this.eventBus.dispatch('pagerendered', {
          source: this,
          pageNumber: this.id,
          cssTransform: true
        });
        return;
      }
      var isScalingRestricted = false;
      if (this.canvas && _pdfjsLib.PDFJS.maxCanvasPixels > 0) {
        var outputScale = this.outputScale;
        if ((Math.floor(this.viewport.width) * outputScale.sx | 0) * (Math.floor(this.viewport.height) * outputScale.sy | 0) > _pdfjsLib.PDFJS.maxCanvasPixels) {
          isScalingRestricted = true;
        }
      }
      if (this.canvas) {
        if (_pdfjsLib.PDFJS.useOnlyCssZoom || this.hasRestrictedScaling && isScalingRestricted) {
          this.cssTransform(this.canvas, true);
          this.eventBus.dispatch('pagerendered', {
            source: this,
            pageNumber: this.id,
            cssTransform: true
          });
          return;
        }
        if (!this.zoomLayer && !this.canvas.hasAttribute('hidden')) {
          this.zoomLayer = this.canvas.parentNode;
          this.zoomLayer.style.position = 'absolute';
        }
      }
      if (this.zoomLayer) {
        this.cssTransform(this.zoomLayer.firstChild);
      }
      this.reset(true, true);
    }
  }, {
    key: 'cancelRendering',
    value: function cancelRendering() {
      if (this.paintTask) {
        this.paintTask.cancel();
        this.paintTask = null;
      }
      this.renderingState = _pdf_rendering_queue.RenderingStates.INITIAL;
      this.resume = null;
      if (this.textLayer) {
        this.textLayer.cancel();
        this.textLayer = null;
      }
    }
  }, {
    key: 'cssTransform',
    value: function cssTransform(target) {
      var redrawAnnotations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var width = this.viewport.width;
      var height = this.viewport.height;
      var div = this.div;
      target.style.width = target.parentNode.style.width = div.style.width = Math.floor(width) + 'px';
      target.style.height = target.parentNode.style.height = div.style.height = Math.floor(height) + 'px';
      var relativeRotation = this.viewport.rotation - this.paintedViewportMap.get(target).rotation;
      var absRotation = Math.abs(relativeRotation);
      var scaleX = 1,
          scaleY = 1;
      if (absRotation === 90 || absRotation === 270) {
        scaleX = height / width;
        scaleY = width / height;
      }
      var cssTransform = 'rotate(' + relativeRotation + 'deg) ' + 'scale(' + scaleX + ',' + scaleY + ')';
      _pdfjsLib.CustomStyle.setProp('transform', target, cssTransform);
      if (this.textLayer) {
        var textLayerViewport = this.textLayer.viewport;
        var textRelativeRotation = this.viewport.rotation - textLayerViewport.rotation;
        var textAbsRotation = Math.abs(textRelativeRotation);
        var scale = width / textLayerViewport.width;
        if (textAbsRotation === 90 || textAbsRotation === 270) {
          scale = width / textLayerViewport.height;
        }
        var textLayerDiv = this.textLayer.textLayerDiv;
        var transX = void 0,
            transY = void 0;
        switch (textAbsRotation) {
          case 0:
            transX = transY = 0;
            break;
          case 90:
            transX = 0;
            transY = '-' + textLayerDiv.style.height;
            break;
          case 180:
            transX = '-' + textLayerDiv.style.width;
            transY = '-' + textLayerDiv.style.height;
            break;
          case 270:
            transX = '-' + textLayerDiv.style.width;
            transY = 0;
            break;
          default:
            console.error('Bad rotation value.');
            break;
        }
        _pdfjsLib.CustomStyle.setProp('transform', textLayerDiv, 'rotate(' + textAbsRotation + 'deg) ' + 'scale(' + scale + ', ' + scale + ') ' + 'translate(' + transX + ', ' + transY + ')');
        _pdfjsLib.CustomStyle.setProp('transformOrigin', textLayerDiv, '0% 0%');
      }
      if (redrawAnnotations && this.annotationLayer) {
        this.annotationLayer.render(this.viewport, 'display');
      }
    }
  }, {
    key: 'getPagePoint',
    value: function getPagePoint(x, y) {
      return this.viewport.convertToPdfPoint(x, y);
    }
  }, {
    key: 'draw',
    value: function draw() {
      var _this = this;

      if (this.renderingState !== _pdf_rendering_queue.RenderingStates.INITIAL) {
        console.error('Must be in new state before drawing');
        this.reset();
      }
      if (!this.pdfPage) {
        this.renderingState = _pdf_rendering_queue.RenderingStates.FINISHED;
        return Promise.reject(new Error('Page is not loaded'));
      }
      this.renderingState = _pdf_rendering_queue.RenderingStates.RUNNING;
      var pdfPage = this.pdfPage;
      var div = this.div;
      var canvasWrapper = document.createElement('div');
      canvasWrapper.style.width = div.style.width;
      canvasWrapper.style.height = div.style.height;
      canvasWrapper.classList.add('canvasWrapper');
      if (this.annotationLayer && this.annotationLayer.div) {
        div.insertBefore(canvasWrapper, this.annotationLayer.div);
      } else {
        div.appendChild(canvasWrapper);
      }
      var textLayer = null;
      if (this.textLayerFactory) {
        var textLayerDiv = document.createElement('div');
        textLayerDiv.className = 'textLayer';
        textLayerDiv.style.width = canvasWrapper.style.width;
        textLayerDiv.style.height = canvasWrapper.style.height;
        if (this.annotationLayer && this.annotationLayer.div) {
          div.insertBefore(textLayerDiv, this.annotationLayer.div);
        } else {
          div.appendChild(textLayerDiv);
        }
        textLayer = this.textLayerFactory.createTextLayerBuilder(textLayerDiv, this.id - 1, this.viewport, this.enhanceTextSelection);
      }
      this.textLayer = textLayer;
      var renderContinueCallback = null;
      if (this.renderingQueue) {
        renderContinueCallback = function renderContinueCallback(cont) {
          if (!_this.renderingQueue.isHighestPriority(_this)) {
            _this.renderingState = _pdf_rendering_queue.RenderingStates.PAUSED;
            _this.resume = function () {
              _this.renderingState = _pdf_rendering_queue.RenderingStates.RUNNING;
              cont();
            };
            return;
          }
          cont();
        };
      }
      var finishPaintTask = function finishPaintTask(error) {
        if (paintTask === _this.paintTask) {
          _this.paintTask = null;
        }
        if (error === 'cancelled' || error instanceof _pdfjsLib.RenderingCancelledException) {
          _this.error = null;
          return Promise.resolve(undefined);
        }
        _this.renderingState = _pdf_rendering_queue.RenderingStates.FINISHED;
        if (_this.loadingIconDiv) {
          div.removeChild(_this.loadingIconDiv);
          delete _this.loadingIconDiv;
        }
        _this._resetZoomLayer(true);
        _this.error = error;
        _this.stats = pdfPage.stats;
        if (_this.onAfterDraw) {
          _this.onAfterDraw();
        }
        _this.eventBus.dispatch('pagerendered', {
          source: _this,
          pageNumber: _this.id,
          cssTransform: false
        });
        if (error) {
          return Promise.reject(error);
        }
        return Promise.resolve(undefined);
      };
      var paintTask = this.renderer === _ui_utils.RendererType.SVG ? this.paintOnSvg(canvasWrapper) : this.paintOnCanvas(canvasWrapper);
      paintTask.onRenderContinue = renderContinueCallback;
      this.paintTask = paintTask;
      var resultPromise = paintTask.promise.then(function () {
        return finishPaintTask(null).then(function () {
          if (textLayer) {
            var readableStream = pdfPage.streamTextContent({ normalizeWhitespace: true });
            textLayer.setTextContentStream(readableStream);
            textLayer.render();
          }
        });
      }, function (reason) {
        return finishPaintTask(reason);
      });
      if (this.annotationLayerFactory) {
        if (!this.annotationLayer) {
          this.annotationLayer = this.annotationLayerFactory.createAnnotationLayerBuilder(div, pdfPage, this.renderInteractiveForms, this.l10n);
        }
        this.annotationLayer.render(this.viewport, 'display');
      }
      div.setAttribute('data-loaded', true);
      if (this.onBeforeDraw) {
        this.onBeforeDraw();
      }
      return resultPromise;
    }
  }, {
    key: 'paintOnCanvas',
    value: function paintOnCanvas(canvasWrapper) {
      var renderCapability = (0, _pdfjsLib.createPromiseCapability)();
      var result = {
        promise: renderCapability.promise,
        onRenderContinue: function onRenderContinue(cont) {
          cont();
        },
        cancel: function cancel() {
          renderTask.cancel();
        }
      };
      var viewport = this.viewport;
      var canvas = document.createElement('canvas');
      canvas.id = this.renderingId;
      canvas.setAttribute('hidden', 'hidden');
      var isCanvasHidden = true;
      var showCanvas = function showCanvas() {
        if (isCanvasHidden) {
          canvas.removeAttribute('hidden');
          isCanvasHidden = false;
        }
      };
      canvasWrapper.appendChild(canvas);
      this.canvas = canvas;
      canvas.mozOpaque = true;
      var ctx = canvas.getContext('2d', { alpha: false });
      var outputScale = (0, _ui_utils.getOutputScale)(ctx);
      this.outputScale = outputScale;
      if (_pdfjsLib.PDFJS.useOnlyCssZoom) {
        var actualSizeViewport = viewport.clone({ scale: _ui_utils.CSS_UNITS });
        outputScale.sx *= actualSizeViewport.width / viewport.width;
        outputScale.sy *= actualSizeViewport.height / viewport.height;
        outputScale.scaled = true;
      }
      if (_pdfjsLib.PDFJS.maxCanvasPixels > 0) {
        var pixelsInViewport = viewport.width * viewport.height;
        var maxScale = Math.sqrt(_pdfjsLib.PDFJS.maxCanvasPixels / pixelsInViewport);
        if (outputScale.sx > maxScale || outputScale.sy > maxScale) {
          outputScale.sx = maxScale;
          outputScale.sy = maxScale;
          outputScale.scaled = true;
          this.hasRestrictedScaling = true;
        } else {
          this.hasRestrictedScaling = false;
        }
      }
      var sfx = (0, _ui_utils.approximateFraction)(outputScale.sx);
      var sfy = (0, _ui_utils.approximateFraction)(outputScale.sy);
      canvas.width = (0, _ui_utils.roundToDivide)(viewport.width * outputScale.sx, sfx[0]);
      canvas.height = (0, _ui_utils.roundToDivide)(viewport.height * outputScale.sy, sfy[0]);
      canvas.style.width = (0, _ui_utils.roundToDivide)(viewport.width, sfx[1]) + 'px';
      canvas.style.height = (0, _ui_utils.roundToDivide)(viewport.height, sfy[1]) + 'px';
      this.paintedViewportMap.set(canvas, viewport);
      var transform = !outputScale.scaled ? null : [outputScale.sx, 0, 0, outputScale.sy, 0, 0];
      var renderContext = {
        canvasContext: ctx,
        transform: transform,
        viewport: this.viewport,
        renderInteractiveForms: this.renderInteractiveForms
      };
      var renderTask = this.pdfPage.render(renderContext);
      renderTask.onContinue = function (cont) {
        showCanvas();
        if (result.onRenderContinue) {
          result.onRenderContinue(cont);
        } else {
          cont();
        }
      };
      renderTask.promise.then(function () {
        showCanvas();
        renderCapability.resolve(undefined);
      }, function (error) {
        showCanvas();
        renderCapability.reject(error);
      });
      return result;
    }
  }, {
    key: 'paintOnSvg',
    value: function paintOnSvg(wrapper) {
      var _this2 = this;

      var cancelled = false;
      var ensureNotCancelled = function ensureNotCancelled() {
        if (cancelled) {
          if (_pdfjsLib.PDFJS.pdfjsNext) {
            throw new _pdfjsLib.RenderingCancelledException('Rendering cancelled, page ' + _this2.id, 'svg');
          } else {
            throw 'cancelled';
          }
        }
      };
      var pdfPage = this.pdfPage;
      var actualSizeViewport = this.viewport.clone({ scale: _ui_utils.CSS_UNITS });
      var promise = pdfPage.getOperatorList().then(function (opList) {
        ensureNotCancelled();
        var svgGfx = new _pdfjsLib.SVGGraphics(pdfPage.commonObjs, pdfPage.objs);
        return svgGfx.getSVG(opList, actualSizeViewport).then(function (svg) {
          ensureNotCancelled();
          _this2.svg = svg;
          _this2.paintedViewportMap.set(svg, actualSizeViewport);
          svg.style.width = wrapper.style.width;
          svg.style.height = wrapper.style.height;
          _this2.renderingState = _pdf_rendering_queue.RenderingStates.FINISHED;
          wrapper.appendChild(svg);
        });
      });
      return {
        promise: promise,
        onRenderContinue: function onRenderContinue(cont) {
          cont();
        },
        cancel: function cancel() {
          cancelled = true;
        }
      };
    }
  }, {
    key: 'setPageLabel',
    value: function setPageLabel(label) {
      this.pageLabel = typeof label === 'string' ? label : null;
      if (this.pageLabel !== null) {
        this.div.setAttribute('data-page-label', this.pageLabel);
      } else {
        this.div.removeAttribute('data-page-label');
      }
    }
  }, {
    key: 'width',
    get: function get() {
      return this.viewport.width;
    }
  }, {
    key: 'height',
    get: function get() {
      return this.viewport.height;
    }
  }]);

  return PDFPageView;
}();

exports.PDFPageView = PDFPageView;

/***/ }),
/* 6 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultTextLayerFactory = exports.TextLayerBuilder = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dom_events = __w_pdfjs_require__(2);

var _pdfjsLib = __w_pdfjs_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EXPAND_DIVS_TIMEOUT = 300;

var TextLayerBuilder = function () {
  function TextLayerBuilder(_ref) {
    var textLayerDiv = _ref.textLayerDiv,
        eventBus = _ref.eventBus,
        pageIndex = _ref.pageIndex,
        viewport = _ref.viewport,
        _ref$findController = _ref.findController,
        findController = _ref$findController === undefined ? null : _ref$findController,
        _ref$enhanceTextSelec = _ref.enhanceTextSelection,
        enhanceTextSelection = _ref$enhanceTextSelec === undefined ? false : _ref$enhanceTextSelec;

    _classCallCheck(this, TextLayerBuilder);

    this.textLayerDiv = textLayerDiv;
    this.eventBus = eventBus || (0, _dom_events.getGlobalEventBus)();
    this.textContent = null;
    this.textContentItemsStr = [];
    this.textContentStream = null;
    this.renderingDone = false;
    this.pageIdx = pageIndex;
    this.pageNumber = this.pageIdx + 1;
    this.matches = [];
    this.viewport = viewport;
    this.textDivs = [];
    this.findController = findController;
    this.textLayerRenderTask = null;
    this.enhanceTextSelection = enhanceTextSelection;
    this._bindMouse();
  }

  _createClass(TextLayerBuilder, [{
    key: '_finishRendering',
    value: function _finishRendering() {
      this.renderingDone = true;
      if (!this.enhanceTextSelection) {
        var endOfContent = document.createElement('div');
        endOfContent.className = 'endOfContent';
        this.textLayerDiv.appendChild(endOfContent);
      }
      this.eventBus.dispatch('textlayerrendered', {
        source: this,
        pageNumber: this.pageNumber,
        numTextDivs: this.textDivs.length
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this = this;

      var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (!(this.textContent || this.textContentStream) || this.renderingDone) {
        return;
      }
      this.cancel();
      this.textDivs = [];
      var textLayerFrag = document.createDocumentFragment();
      this.textLayerRenderTask = (0, _pdfjsLib.renderTextLayer)({
        textContent: this.textContent,
        textContentStream: this.textContentStream,
        container: textLayerFrag,
        viewport: this.viewport,
        textDivs: this.textDivs,
        textContentItemsStr: this.textContentItemsStr,
        timeout: timeout,
        enhanceTextSelection: this.enhanceTextSelection
      });
      this.textLayerRenderTask.promise.then(function () {
        _this.textLayerDiv.appendChild(textLayerFrag);
        _this._finishRendering();
        _this.updateMatches();
      }, function (reason) {});
    }
  }, {
    key: 'cancel',
    value: function cancel() {
      if (this.textLayerRenderTask) {
        this.textLayerRenderTask.cancel();
        this.textLayerRenderTask = null;
      }
    }
  }, {
    key: 'setTextContentStream',
    value: function setTextContentStream(readableStream) {
      this.cancel();
      this.textContentStream = readableStream;
    }
  }, {
    key: 'setTextContent',
    value: function setTextContent(textContent) {
      this.cancel();
      this.textContent = textContent;
    }
  }, {
    key: 'convertMatches',
    value: function convertMatches(matches, matchesLength) {
      var i = 0;
      var iIndex = 0;
      var textContentItemsStr = this.textContentItemsStr;
      var end = textContentItemsStr.length - 1;
      var queryLen = this.findController === null ? 0 : this.findController.state.query.length;
      var ret = [];
      if (!matches) {
        return ret;
      }
      for (var m = 0, len = matches.length; m < len; m++) {
        var matchIdx = matches[m];
        while (i !== end && matchIdx >= iIndex + textContentItemsStr[i].length) {
          iIndex += textContentItemsStr[i].length;
          i++;
        }
        if (i === textContentItemsStr.length) {
          console.error('Could not find a matching mapping');
        }
        var match = {
          begin: {
            divIdx: i,
            offset: matchIdx - iIndex
          }
        };
        if (matchesLength) {
          matchIdx += matchesLength[m];
        } else {
          matchIdx += queryLen;
        }
        while (i !== end && matchIdx > iIndex + textContentItemsStr[i].length) {
          iIndex += textContentItemsStr[i].length;
          i++;
        }
        match.end = {
          divIdx: i,
          offset: matchIdx - iIndex
        };
        ret.push(match);
      }
      return ret;
    }
  }, {
    key: 'renderMatches',
    value: function renderMatches(matches) {
      if (matches.length === 0) {
        return;
      }
      var textContentItemsStr = this.textContentItemsStr;
      var textDivs = this.textDivs;
      var prevEnd = null;
      var pageIdx = this.pageIdx;
      var isSelectedPage = this.findController === null ? false : pageIdx === this.findController.selected.pageIdx;
      var selectedMatchIdx = this.findController === null ? -1 : this.findController.selected.matchIdx;
      var highlightAll = this.findController === null ? false : this.findController.state.highlightAll;
      var infinity = {
        divIdx: -1,
        offset: undefined
      };
      function beginText(begin, className) {
        var divIdx = begin.divIdx;
        textDivs[divIdx].textContent = '';
        appendTextToDiv(divIdx, 0, begin.offset, className);
      }
      function appendTextToDiv(divIdx, fromOffset, toOffset, className) {
        var div = textDivs[divIdx];
        var content = textContentItemsStr[divIdx].substring(fromOffset, toOffset);
        var node = document.createTextNode(content);
        if (className) {
          var span = document.createElement('span');
          span.className = className;
          span.appendChild(node);
          div.appendChild(span);
          return;
        }
        div.appendChild(node);
      }
      var i0 = selectedMatchIdx,
          i1 = i0 + 1;
      if (highlightAll) {
        i0 = 0;
        i1 = matches.length;
      } else if (!isSelectedPage) {
        return;
      }
      for (var i = i0; i < i1; i++) {
        var match = matches[i];
        var begin = match.begin;
        var end = match.end;
        var isSelected = isSelectedPage && i === selectedMatchIdx;
        var highlightSuffix = isSelected ? ' selected' : '';
        if (this.findController) {
          this.findController.updateMatchPosition(pageIdx, i, textDivs, begin.divIdx);
        }
        if (!prevEnd || begin.divIdx !== prevEnd.divIdx) {
          if (prevEnd !== null) {
            appendTextToDiv(prevEnd.divIdx, prevEnd.offset, infinity.offset);
          }
          beginText(begin);
        } else {
          appendTextToDiv(prevEnd.divIdx, prevEnd.offset, begin.offset);
        }
        if (begin.divIdx === end.divIdx) {
          appendTextToDiv(begin.divIdx, begin.offset, end.offset, 'highlight' + highlightSuffix);
        } else {
          appendTextToDiv(begin.divIdx, begin.offset, infinity.offset, 'highlight begin' + highlightSuffix);
          for (var n0 = begin.divIdx + 1, n1 = end.divIdx; n0 < n1; n0++) {
            textDivs[n0].className = 'highlight middle' + highlightSuffix;
          }
          beginText(end, 'highlight end' + highlightSuffix);
        }
        prevEnd = end;
      }
      if (prevEnd) {
        appendTextToDiv(prevEnd.divIdx, prevEnd.offset, infinity.offset);
      }
    }
  }, {
    key: 'updateMatches',
    value: function updateMatches() {
      if (!this.renderingDone) {
        return;
      }
      var matches = this.matches;
      var textDivs = this.textDivs;
      var textContentItemsStr = this.textContentItemsStr;
      var clearedUntilDivIdx = -1;
      for (var i = 0, len = matches.length; i < len; i++) {
        var match = matches[i];
        var begin = Math.max(clearedUntilDivIdx, match.begin.divIdx);
        for (var n = begin, end = match.end.divIdx; n <= end; n++) {
          var div = textDivs[n];
          div.textContent = textContentItemsStr[n];
          div.className = '';
        }
        clearedUntilDivIdx = match.end.divIdx + 1;
      }
      if (this.findController === null || !this.findController.active) {
        return;
      }
      var pageMatches = void 0,
          pageMatchesLength = void 0;
      if (this.findController !== null) {
        pageMatches = this.findController.pageMatches[this.pageIdx] || null;
        pageMatchesLength = this.findController.pageMatchesLength ? this.findController.pageMatchesLength[this.pageIdx] || null : null;
      }
      this.matches = this.convertMatches(pageMatches, pageMatchesLength);
      this.renderMatches(this.matches);
    }
  }, {
    key: '_bindMouse',
    value: function _bindMouse() {
      var _this2 = this;

      var div = this.textLayerDiv;
      var expandDivsTimer = null;
      div.addEventListener('mousedown', function (evt) {
        if (_this2.enhanceTextSelection && _this2.textLayerRenderTask) {
          _this2.textLayerRenderTask.expandTextDivs(true);
          if (expandDivsTimer) {
            clearTimeout(expandDivsTimer);
            expandDivsTimer = null;
          }
          return;
        }
        var end = div.querySelector('.endOfContent');
        if (!end) {
          return;
        }
        var adjustTop = evt.target !== div;
        adjustTop = adjustTop && window.getComputedStyle(end).getPropertyValue('-moz-user-select') !== 'none';
        if (adjustTop) {
          var divBounds = div.getBoundingClientRect();
          var r = Math.max(0, (evt.pageY - divBounds.top) / divBounds.height);
          end.style.top = (r * 100).toFixed(2) + '%';
        }
        end.classList.add('active');
      });
      div.addEventListener('mouseup', function () {
        if (_this2.enhanceTextSelection && _this2.textLayerRenderTask) {
          expandDivsTimer = setTimeout(function () {
            if (_this2.textLayerRenderTask) {
              _this2.textLayerRenderTask.expandTextDivs(false);
            }
            expandDivsTimer = null;
          }, EXPAND_DIVS_TIMEOUT);
          return;
        }
        var end = div.querySelector('.endOfContent');
        if (!end) {
          return;
        }
        end.style.top = '';
        end.classList.remove('active');
      });
    }
  }]);

  return TextLayerBuilder;
}();

var DefaultTextLayerFactory = function () {
  function DefaultTextLayerFactory() {
    _classCallCheck(this, DefaultTextLayerFactory);
  }

  _createClass(DefaultTextLayerFactory, [{
    key: 'createTextLayerBuilder',
    value: function createTextLayerBuilder(textLayerDiv, pageIndex, viewport) {
      var enhanceTextSelection = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      return new TextLayerBuilder({
        textLayerDiv: textLayerDiv,
        pageIndex: pageIndex,
        viewport: viewport,
        enhanceTextSelection: enhanceTextSelection
      });
    }
  }]);

  return DefaultTextLayerFactory;
}();

exports.TextLayerBuilder = TextLayerBuilder;
exports.DefaultTextLayerFactory = DefaultTextLayerFactory;

/***/ }),
/* 7 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CLEANUP_TIMEOUT = 30000;
var RenderingStates = {
  INITIAL: 0,
  RUNNING: 1,
  PAUSED: 2,
  FINISHED: 3
};

var PDFRenderingQueue = function () {
  function PDFRenderingQueue() {
    _classCallCheck(this, PDFRenderingQueue);

    this.pdfViewer = null;
    this.pdfThumbnailViewer = null;
    this.onIdle = null;
    this.highestPriorityPage = null;
    this.idleTimeout = null;
    this.printing = false;
    this.isThumbnailViewEnabled = false;
  }

  _createClass(PDFRenderingQueue, [{
    key: "setViewer",
    value: function setViewer(pdfViewer) {
      this.pdfViewer = pdfViewer;
    }
  }, {
    key: "setThumbnailViewer",
    value: function setThumbnailViewer(pdfThumbnailViewer) {
      this.pdfThumbnailViewer = pdfThumbnailViewer;
    }
  }, {
    key: "isHighestPriority",
    value: function isHighestPriority(view) {
      return this.highestPriorityPage === view.renderingId;
    }
  }, {
    key: "renderHighestPriority",
    value: function renderHighestPriority(currentlyVisiblePages) {
      if (this.idleTimeout) {
        clearTimeout(this.idleTimeout);
        this.idleTimeout = null;
      }
      if (this.pdfViewer.forceRendering(currentlyVisiblePages)) {
        return;
      }
      if (this.pdfThumbnailViewer && this.isThumbnailViewEnabled) {
        if (this.pdfThumbnailViewer.forceRendering()) {
          return;
        }
      }
      if (this.printing) {
        return;
      }
      if (this.onIdle) {
        this.idleTimeout = setTimeout(this.onIdle.bind(this), CLEANUP_TIMEOUT);
      }
    }
  }, {
    key: "getHighestPriority",
    value: function getHighestPriority(visible, views, scrolledDown) {
      var visibleViews = visible.views;
      var numVisible = visibleViews.length;
      if (numVisible === 0) {
        return false;
      }
      for (var i = 0; i < numVisible; ++i) {
        var view = visibleViews[i].view;
        if (!this.isViewFinished(view)) {
          return view;
        }
      }
      if (scrolledDown) {
        var nextPageIndex = visible.last.id;
        if (views[nextPageIndex] && !this.isViewFinished(views[nextPageIndex])) {
          return views[nextPageIndex];
        }
      } else {
        var previousPageIndex = visible.first.id - 2;
        if (views[previousPageIndex] && !this.isViewFinished(views[previousPageIndex])) {
          return views[previousPageIndex];
        }
      }
      return null;
    }
  }, {
    key: "isViewFinished",
    value: function isViewFinished(view) {
      return view.renderingState === RenderingStates.FINISHED;
    }
  }, {
    key: "renderView",
    value: function renderView(view) {
      var _this = this;

      switch (view.renderingState) {
        case RenderingStates.FINISHED:
          return false;
        case RenderingStates.PAUSED:
          this.highestPriorityPage = view.renderingId;
          view.resume();
          break;
        case RenderingStates.RUNNING:
          this.highestPriorityPage = view.renderingId;
          break;
        case RenderingStates.INITIAL:
          this.highestPriorityPage = view.renderingId;
          var continueRendering = function continueRendering() {
            _this.renderHighestPriority();
          };
          view.draw().then(continueRendering, continueRendering);
          break;
      }
      return true;
    }
  }]);

  return PDFRenderingQueue;
}();

exports.RenderingStates = RenderingStates;
exports.PDFRenderingQueue = PDFRenderingQueue;

/***/ }),
/* 8 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DownloadManager = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _pdfjsLib = __w_pdfjs_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

;
function _download(blobUrl, filename) {
  var a = document.createElement('a');
  if (a.click) {
    a.href = blobUrl;
    a.target = '_parent';
    if ('download' in a) {
      a.download = filename;
    }
    (document.body || document.documentElement).appendChild(a);
    a.click();
    a.parentNode.removeChild(a);
  } else {
    if (window.top === window && blobUrl.split('#')[0] === window.location.href.split('#')[0]) {
      var padCharacter = blobUrl.indexOf('?') === -1 ? '?' : '&';
      blobUrl = blobUrl.replace(/#|$/, padCharacter + '$&');
    }
    window.open(blobUrl, '_parent');
  }
}

var DownloadManager = function () {
  function DownloadManager() {
    _classCallCheck(this, DownloadManager);
  }

  _createClass(DownloadManager, [{
    key: 'downloadUrl',
    value: function downloadUrl(url, filename) {
      if (!(0, _pdfjsLib.createValidAbsoluteUrl)(url, 'http://example.com')) {
        return;
      }
      _download(url + '#pdfjs.action=download', filename);
    }
  }, {
    key: 'downloadData',
    value: function downloadData(data, filename, contentType) {
      if (navigator.msSaveBlob) {
        return navigator.msSaveBlob(new Blob([data], { type: contentType }), filename);
      }
      var blobUrl = (0, _pdfjsLib.createObjectURL)(data, contentType, _pdfjsLib.PDFJS.disableCreateObjectURL);
      _download(blobUrl, filename);
    }
  }, {
    key: 'download',
    value: function download(blob, url, filename) {
      if (navigator.msSaveBlob) {
        if (!navigator.msSaveBlob(blob, filename)) {
          this.downloadUrl(url, filename);
        }
        return;
      }
      if (_pdfjsLib.PDFJS.disableCreateObjectURL) {
        this.downloadUrl(url, filename);
        return;
      }
      var blobUrl = URL.createObjectURL(blob);
      _download(blobUrl, filename);
    }
  }]);

  return DownloadManager;
}();

exports.DownloadManager = DownloadManager;

/***/ }),
/* 9 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GenericL10n = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__w_pdfjs_require__(13);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var webL10n = document.webL10n;

var GenericL10n = function () {
  function GenericL10n(lang) {
    _classCallCheck(this, GenericL10n);

    this._lang = lang;
    this._ready = new Promise(function (resolve, reject) {
      webL10n.setLanguage(lang, function () {
        resolve(webL10n);
      });
    });
  }

  _createClass(GenericL10n, [{
    key: 'getDirection',
    value: function getDirection() {
      return this._ready.then(function (l10n) {
        return l10n.getDirection();
      });
    }
  }, {
    key: 'get',
    value: function get(property, args, fallback) {
      return this._ready.then(function (l10n) {
        return l10n.get(property, args, fallback);
      });
    }
  }, {
    key: 'translate',
    value: function translate(element) {
      return this._ready.then(function (l10n) {
        return l10n.translate(element);
      });
    }
  }]);

  return GenericL10n;
}();

exports.GenericL10n = GenericL10n;

/***/ }),
/* 10 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PDFFindController = exports.FindState = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _pdfjsLib = __w_pdfjs_require__(0);

var _ui_utils = __w_pdfjs_require__(1);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FindState = {
  FOUND: 0,
  NOT_FOUND: 1,
  WRAPPED: 2,
  PENDING: 3
};
var FIND_SCROLL_OFFSET_TOP = -50;
var FIND_SCROLL_OFFSET_LEFT = -400;
var FIND_TIMEOUT = 250;
var CHARACTERS_TO_NORMALIZE = {
  '\u2018': '\'',
  '\u2019': '\'',
  '\u201A': '\'',
  '\u201B': '\'',
  '\u201C': '"',
  '\u201D': '"',
  '\u201E': '"',
  '\u201F': '"',
  '\xBC': '1/4',
  '\xBD': '1/2',
  '\xBE': '3/4'
};

var PDFFindController = function () {
  function PDFFindController(_ref) {
    var pdfViewer = _ref.pdfViewer;

    _classCallCheck(this, PDFFindController);

    this.pdfViewer = pdfViewer;
    this.onUpdateResultsCount = null;
    this.onUpdateState = null;
    this.reset();
    var replace = Object.keys(CHARACTERS_TO_NORMALIZE).join('');
    this.normalizationRegex = new RegExp('[' + replace + ']', 'g');
  }

  _createClass(PDFFindController, [{
    key: 'reset',
    value: function reset() {
      var _this = this;

      this.startedTextExtraction = false;
      this.extractTextPromises = [];
      this.pendingFindMatches = Object.create(null);
      this.active = false;
      this.pageContents = [];
      this.pageMatches = [];
      this.pageMatchesLength = null;
      this.matchCount = 0;
      this.selected = {
        pageIdx: -1,
        matchIdx: -1
      };
      this.offset = {
        pageIdx: null,
        matchIdx: null
      };
      this.pagesToSearch = null;
      this.resumePageIdx = null;
      this.state = null;
      this.dirtyMatch = false;
      this.findTimeout = null;
      this._firstPagePromise = new Promise(function (resolve) {
        _this.resolveFirstPage = resolve;
      });
    }
  }, {
    key: 'normalize',
    value: function normalize(text) {
      return text.replace(this.normalizationRegex, function (ch) {
        return CHARACTERS_TO_NORMALIZE[ch];
      });
    }
  }, {
    key: '_prepareMatches',
    value: function _prepareMatches(matchesWithLength, matches, matchesLength) {
      function isSubTerm(matchesWithLength, currentIndex) {
        var currentElem = matchesWithLength[currentIndex];
        var nextElem = matchesWithLength[currentIndex + 1];
        if (currentIndex < matchesWithLength.length - 1 && currentElem.match === nextElem.match) {
          currentElem.skipped = true;
          return true;
        }
        for (var i = currentIndex - 1; i >= 0; i--) {
          var prevElem = matchesWithLength[i];
          if (prevElem.skipped) {
            continue;
          }
          if (prevElem.match + prevElem.matchLength < currentElem.match) {
            break;
          }
          if (prevElem.match + prevElem.matchLength >= currentElem.match + currentElem.matchLength) {
            currentElem.skipped = true;
            return true;
          }
        }
        return false;
      }
      matchesWithLength.sort(function (a, b) {
        return a.match === b.match ? a.matchLength - b.matchLength : a.match - b.match;
      });
      for (var i = 0, len = matchesWithLength.length; i < len; i++) {
        if (isSubTerm(matchesWithLength, i)) {
          continue;
        }
        matches.push(matchesWithLength[i].match);
        matchesLength.push(matchesWithLength[i].matchLength);
      }
    }
  }, {
    key: 'calcFindPhraseMatch',
    value: function calcFindPhraseMatch(query, pageIndex, pageContent) {
      var matches = [];
      var queryLen = query.length;
      var matchIdx = -queryLen;
      while (true) {
        matchIdx = pageContent.indexOf(query, matchIdx + queryLen);
        if (matchIdx === -1) {
          break;
        }
        matches.push(matchIdx);
      }
      this.pageMatches[pageIndex] = matches;
    }
  }, {
    key: 'calcFindWordMatch',
    value: function calcFindWordMatch(query, pageIndex, pageContent) {
      var matchesWithLength = [];
      var queryArray = query.match(/\S+/g);
      for (var i = 0, len = queryArray.length; i < len; i++) {
        var subquery = queryArray[i];
        var subqueryLen = subquery.length;
        var matchIdx = -subqueryLen;
        while (true) {
          matchIdx = pageContent.indexOf(subquery, matchIdx + subqueryLen);
          if (matchIdx === -1) {
            break;
          }
          matchesWithLength.push({
            match: matchIdx,
            matchLength: subqueryLen,
            skipped: false
          });
        }
      }
      if (!this.pageMatchesLength) {
        this.pageMatchesLength = [];
      }
      this.pageMatchesLength[pageIndex] = [];
      this.pageMatches[pageIndex] = [];
      this._prepareMatches(matchesWithLength, this.pageMatches[pageIndex], this.pageMatchesLength[pageIndex]);
    }
  }, {
    key: 'calcFindMatch',
    value: function calcFindMatch(pageIndex) {
      var pageContent = this.normalize(this.pageContents[pageIndex]);
      var query = this.normalize(this.state.query);
      var caseSensitive = this.state.caseSensitive;
      var phraseSearch = this.state.phraseSearch;
      var queryLen = query.length;
      if (queryLen === 0) {
        return;
      }
      if (!caseSensitive) {
        pageContent = pageContent.toLowerCase();
        query = query.toLowerCase();
      }
      if (phraseSearch) {
        this.calcFindPhraseMatch(query, pageIndex, pageContent);
      } else {
        this.calcFindWordMatch(query, pageIndex, pageContent);
      }
      this.updatePage(pageIndex);
      if (this.resumePageIdx === pageIndex) {
        this.resumePageIdx = null;
        this.nextPageMatch();
      }
      if (this.pageMatches[pageIndex].length > 0) {
        this.matchCount += this.pageMatches[pageIndex].length;
        this.updateUIResultsCount();
      }
    }
  }, {
    key: 'extractText',
    value: function extractText() {
      var _this2 = this;

      if (this.startedTextExtraction) {
        return;
      }
      this.startedTextExtraction = true;
      this.pageContents.length = 0;
      var promise = Promise.resolve();

      var _loop = function _loop(i, ii) {
        var extractTextCapability = (0, _pdfjsLib.createPromiseCapability)();
        _this2.extractTextPromises[i] = extractTextCapability.promise;
        promise = promise.then(function () {
          return _this2.pdfViewer.getPageTextContent(i).then(function (textContent) {
            var textItems = textContent.items;
            var strBuf = [];
            for (var j = 0, jj = textItems.length; j < jj; j++) {
              strBuf.push(textItems[j].str);
            }
            _this2.pageContents[i] = strBuf.join('');
            extractTextCapability.resolve(i);
          }, function (reason) {
            console.error('Unable to get page ' + (i + 1) + ' text content', reason);
            _this2.pageContents[i] = '';
            extractTextCapability.resolve(i);
          });
        });
      };

      for (var i = 0, ii = this.pdfViewer.pagesCount; i < ii; i++) {
        _loop(i, ii);
      }
    }
  }, {
    key: 'executeCommand',
    value: function executeCommand(cmd, state) {
      var _this3 = this;

      if (this.state === null || cmd !== 'findagain') {
        this.dirtyMatch = true;
      }
      this.state = state;
      this.updateUIState(FindState.PENDING);
      this._firstPagePromise.then(function () {
        _this3.extractText();
        clearTimeout(_this3.findTimeout);
        if (cmd === 'find') {
          _this3.findTimeout = setTimeout(_this3.nextMatch.bind(_this3), FIND_TIMEOUT);
        } else {
          _this3.nextMatch();
        }
      });
    }
  }, {
    key: 'updatePage',
    value: function updatePage(index) {
      if (this.selected.pageIdx === index) {
        this.pdfViewer.currentPageNumber = index + 1;
      }
      var page = this.pdfViewer.getPageView(index);
      if (page.textLayer) {
        page.textLayer.updateMatches();
      }
    }
  }, {
    key: 'nextMatch',
    value: function nextMatch() {
      var _this4 = this;

      var previous = this.state.findPrevious;
      var currentPageIndex = this.pdfViewer.currentPageNumber - 1;
      var numPages = this.pdfViewer.pagesCount;
      this.active = true;
      if (this.dirtyMatch) {
        this.dirtyMatch = false;
        this.selected.pageIdx = this.selected.matchIdx = -1;
        this.offset.pageIdx = currentPageIndex;
        this.offset.matchIdx = null;
        this.hadMatch = false;
        this.resumePageIdx = null;
        this.pageMatches = [];
        this.matchCount = 0;
        this.pageMatchesLength = null;
        for (var i = 0; i < numPages; i++) {
          this.updatePage(i);
          if (!(i in this.pendingFindMatches)) {
            this.pendingFindMatches[i] = true;
            this.extractTextPromises[i].then(function (pageIdx) {
              delete _this4.pendingFindMatches[pageIdx];
              _this4.calcFindMatch(pageIdx);
            });
          }
        }
      }
      if (this.state.query === '') {
        this.updateUIState(FindState.FOUND);
        return;
      }
      if (this.resumePageIdx) {
        return;
      }
      var offset = this.offset;
      this.pagesToSearch = numPages;
      if (offset.matchIdx !== null) {
        var numPageMatches = this.pageMatches[offset.pageIdx].length;
        if (!previous && offset.matchIdx + 1 < numPageMatches || previous && offset.matchIdx > 0) {
          this.hadMatch = true;
          offset.matchIdx = previous ? offset.matchIdx - 1 : offset.matchIdx + 1;
          this.updateMatch(true);
          return;
        }
        this.advanceOffsetPage(previous);
      }
      this.nextPageMatch();
    }
  }, {
    key: 'matchesReady',
    value: function matchesReady(matches) {
      var offset = this.offset;
      var numMatches = matches.length;
      var previous = this.state.findPrevious;
      if (numMatches) {
        this.hadMatch = true;
        offset.matchIdx = previous ? numMatches - 1 : 0;
        this.updateMatch(true);
        return true;
      }
      this.advanceOffsetPage(previous);
      if (offset.wrapped) {
        offset.matchIdx = null;
        if (this.pagesToSearch < 0) {
          this.updateMatch(false);
          return true;
        }
      }
      return false;
    }
  }, {
    key: 'updateMatchPosition',
    value: function updateMatchPosition(pageIndex, matchIndex, elements, beginIdx) {
      if (this.selected.matchIdx === matchIndex && this.selected.pageIdx === pageIndex) {
        var spot = {
          top: FIND_SCROLL_OFFSET_TOP,
          left: FIND_SCROLL_OFFSET_LEFT
        };
        (0, _ui_utils.scrollIntoView)(elements[beginIdx], spot, true);
      }
    }
  }, {
    key: 'nextPageMatch',
    value: function nextPageMatch() {
      if (this.resumePageIdx !== null) {
        console.error('There can only be one pending page.');
      }
      var matches = null;
      do {
        var pageIdx = this.offset.pageIdx;
        matches = this.pageMatches[pageIdx];
        if (!matches) {
          this.resumePageIdx = pageIdx;
          break;
        }
      } while (!this.matchesReady(matches));
    }
  }, {
    key: 'advanceOffsetPage',
    value: function advanceOffsetPage(previous) {
      var offset = this.offset;
      var numPages = this.extractTextPromises.length;
      offset.pageIdx = previous ? offset.pageIdx - 1 : offset.pageIdx + 1;
      offset.matchIdx = null;
      this.pagesToSearch--;
      if (offset.pageIdx >= numPages || offset.pageIdx < 0) {
        offset.pageIdx = previous ? numPages - 1 : 0;
        offset.wrapped = true;
      }
    }
  }, {
    key: 'updateMatch',
    value: function updateMatch() {
      var found = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var state = FindState.NOT_FOUND;
      var wrapped = this.offset.wrapped;
      this.offset.wrapped = false;
      if (found) {
        var previousPage = this.selected.pageIdx;
        this.selected.pageIdx = this.offset.pageIdx;
        this.selected.matchIdx = this.offset.matchIdx;
        state = wrapped ? FindState.WRAPPED : FindState.FOUND;
        if (previousPage !== -1 && previousPage !== this.selected.pageIdx) {
          this.updatePage(previousPage);
        }
      }
      this.updateUIState(state, this.state.findPrevious);
      if (this.selected.pageIdx !== -1) {
        this.updatePage(this.selected.pageIdx);
      }
    }
  }, {
    key: 'updateUIResultsCount',
    value: function updateUIResultsCount() {
      if (this.onUpdateResultsCount) {
        this.onUpdateResultsCount(this.matchCount);
      }
    }
  }, {
    key: 'updateUIState',
    value: function updateUIState(state, previous) {
      if (this.onUpdateState) {
        this.onUpdateState(state, previous, this.matchCount);
      }
    }
  }]);

  return PDFFindController;
}();

exports.FindState = FindState;
exports.PDFFindController = PDFFindController;

/***/ }),
/* 11 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PDFHistory = undefined;

var _dom_events = __w_pdfjs_require__(2);

function PDFHistory(options) {
  this.linkService = options.linkService;
  this.eventBus = options.eventBus || (0, _dom_events.getGlobalEventBus)();
  this.initialized = false;
  this.initialDestination = null;
  this.initialBookmark = null;
}
PDFHistory.prototype = {
  initialize: function pdfHistoryInitialize(fingerprint) {
    this.initialized = true;
    this.reInitialized = false;
    this.allowHashChange = true;
    this.historyUnlocked = true;
    this.isViewerInPresentationMode = false;
    this.previousHash = window.location.hash.substring(1);
    this.currentBookmark = '';
    this.currentPage = 0;
    this.updatePreviousBookmark = false;
    this.previousBookmark = '';
    this.previousPage = 0;
    this.nextHashParam = '';
    this.fingerprint = fingerprint;
    this.currentUid = this.uid = 0;
    this.current = {};
    var state = window.history.state;
    if (this._isStateObjectDefined(state)) {
      if (state.target.dest) {
        this.initialDestination = state.target.dest;
      } else {
        this.initialBookmark = state.target.hash;
      }
      this.currentUid = state.uid;
      this.uid = state.uid + 1;
      this.current = state.target;
    } else {
      if (state && state.fingerprint && this.fingerprint !== state.fingerprint) {
        this.reInitialized = true;
      }
      this._pushOrReplaceState({ fingerprint: this.fingerprint }, true);
    }
    var self = this;
    window.addEventListener('popstate', function pdfHistoryPopstate(evt) {
      if (!self.historyUnlocked) {
        return;
      }
      if (evt.state) {
        self._goTo(evt.state);
        return;
      }
      if (self.uid === 0) {
        var previousParams = self.previousHash && self.currentBookmark && self.previousHash !== self.currentBookmark ? {
          hash: self.currentBookmark,
          page: self.currentPage
        } : { page: 1 };
        replacePreviousHistoryState(previousParams, function () {
          updateHistoryWithCurrentHash();
        });
      } else {
        updateHistoryWithCurrentHash();
      }
    });
    function updateHistoryWithCurrentHash() {
      self.previousHash = window.location.hash.slice(1);
      self._pushToHistory({ hash: self.previousHash }, false, true);
      self._updatePreviousBookmark();
    }
    function replacePreviousHistoryState(params, callback) {
      self.historyUnlocked = false;
      self.allowHashChange = false;
      window.addEventListener('popstate', rewriteHistoryAfterBack);
      history.back();
      function rewriteHistoryAfterBack() {
        window.removeEventListener('popstate', rewriteHistoryAfterBack);
        window.addEventListener('popstate', rewriteHistoryAfterForward);
        self._pushToHistory(params, false, true);
        history.forward();
      }
      function rewriteHistoryAfterForward() {
        window.removeEventListener('popstate', rewriteHistoryAfterForward);
        self.allowHashChange = true;
        self.historyUnlocked = true;
        callback();
      }
    }
    function pdfHistoryBeforeUnload() {
      var previousParams = self._getPreviousParams(null, true);
      if (previousParams) {
        var replacePrevious = !self.current.dest && self.current.hash !== self.previousHash;
        self._pushToHistory(previousParams, false, replacePrevious);
        self._updatePreviousBookmark();
      }
      window.removeEventListener('beforeunload', pdfHistoryBeforeUnload);
    }
    window.addEventListener('beforeunload', pdfHistoryBeforeUnload);
    window.addEventListener('pageshow', function pdfHistoryPageShow(evt) {
      window.addEventListener('beforeunload', pdfHistoryBeforeUnload);
    });
    self.eventBus.on('presentationmodechanged', function (e) {
      self.isViewerInPresentationMode = e.active;
    });
  },
  clearHistoryState: function pdfHistory_clearHistoryState() {
    this._pushOrReplaceState(null, true);
  },
  _isStateObjectDefined: function pdfHistory_isStateObjectDefined(state) {
    return state && state.uid >= 0 && state.fingerprint && this.fingerprint === state.fingerprint && state.target && state.target.hash ? true : false;
  },
  _pushOrReplaceState: function pdfHistory_pushOrReplaceState(stateObj, replace) {
    if (replace) {
      window.history.replaceState(stateObj, '', document.URL);
    } else {
      window.history.pushState(stateObj, '', document.URL);
    }
  },
  get isHashChangeUnlocked() {
    if (!this.initialized) {
      return true;
    }
    return this.allowHashChange;
  },
  _updatePreviousBookmark: function pdfHistory_updatePreviousBookmark() {
    if (this.updatePreviousBookmark && this.currentBookmark && this.currentPage) {
      this.previousBookmark = this.currentBookmark;
      this.previousPage = this.currentPage;
      this.updatePreviousBookmark = false;
    }
  },
  updateCurrentBookmark: function pdfHistoryUpdateCurrentBookmark(bookmark, pageNum) {
    if (this.initialized) {
      this.currentBookmark = bookmark.substring(1);
      this.currentPage = pageNum | 0;
      this._updatePreviousBookmark();
    }
  },
  updateNextHashParam: function pdfHistoryUpdateNextHashParam(param) {
    if (this.initialized) {
      this.nextHashParam = param;
    }
  },
  push: function pdfHistoryPush(params, isInitialBookmark) {
    if (!(this.initialized && this.historyUnlocked)) {
      return;
    }
    if (params.dest && !params.hash) {
      params.hash = this.current.hash && this.current.dest && this.current.dest === params.dest ? this.current.hash : this.linkService.getDestinationHash(params.dest).split('#')[1];
    }
    if (params.page) {
      params.page |= 0;
    }
    if (isInitialBookmark) {
      var target = window.history.state.target;
      if (!target) {
        this._pushToHistory(params, false);
        this.previousHash = window.location.hash.substring(1);
      }
      this.updatePreviousBookmark = this.nextHashParam ? false : true;
      if (target) {
        this._updatePreviousBookmark();
      }
      return;
    }
    if (this.nextHashParam) {
      if (this.nextHashParam === params.hash) {
        this.nextHashParam = null;
        this.updatePreviousBookmark = true;
        return;
      }
      this.nextHashParam = null;
    }
    if (params.hash) {
      if (this.current.hash) {
        if (this.current.hash !== params.hash) {
          this._pushToHistory(params, true);
        } else {
          if (!this.current.page && params.page) {
            this._pushToHistory(params, false, true);
          }
          this.updatePreviousBookmark = true;
        }
      } else {
        this._pushToHistory(params, true);
      }
    } else if (this.current.page && params.page && this.current.page !== params.page) {
      this._pushToHistory(params, true);
    }
  },
  _getPreviousParams: function pdfHistory_getPreviousParams(onlyCheckPage, beforeUnload) {
    if (!(this.currentBookmark && this.currentPage)) {
      return null;
    } else if (this.updatePreviousBookmark) {
      this.updatePreviousBookmark = false;
    }
    if (this.uid > 0 && !(this.previousBookmark && this.previousPage)) {
      return null;
    }
    if (!this.current.dest && !onlyCheckPage || beforeUnload) {
      if (this.previousBookmark === this.currentBookmark) {
        return null;
      }
    } else if (this.current.page || onlyCheckPage) {
      if (this.previousPage === this.currentPage) {
        return null;
      }
    } else {
      return null;
    }
    var params = {
      hash: this.currentBookmark,
      page: this.currentPage
    };
    if (this.isViewerInPresentationMode) {
      params.hash = null;
    }
    return params;
  },
  _stateObj: function pdfHistory_stateObj(params) {
    return {
      fingerprint: this.fingerprint,
      uid: this.uid,
      target: params
    };
  },
  _pushToHistory: function pdfHistory_pushToHistory(params, addPrevious, overwrite) {
    if (!this.initialized) {
      return;
    }
    if (!params.hash && params.page) {
      params.hash = 'page=' + params.page;
    }
    if (addPrevious && !overwrite) {
      var previousParams = this._getPreviousParams();
      if (previousParams) {
        var replacePrevious = !this.current.dest && this.current.hash !== this.previousHash;
        this._pushToHistory(previousParams, false, replacePrevious);
      }
    }
    this._pushOrReplaceState(this._stateObj(params), overwrite || this.uid === 0);
    this.currentUid = this.uid++;
    this.current = params;
    this.updatePreviousBookmark = true;
  },
  _goTo: function pdfHistory_goTo(state) {
    if (!(this.initialized && this.historyUnlocked && this._isStateObjectDefined(state))) {
      return;
    }
    if (!this.reInitialized && state.uid < this.currentUid) {
      var previousParams = this._getPreviousParams(true);
      if (previousParams) {
        this._pushToHistory(this.current, false);
        this._pushToHistory(previousParams, false);
        this.currentUid = state.uid;
        window.history.back();
        return;
      }
    }
    this.historyUnlocked = false;
    if (state.target.dest) {
      this.linkService.navigateTo(state.target.dest);
    } else {
      this.linkService.setHash(state.target.hash);
    }
    this.currentUid = state.uid;
    if (state.uid > this.uid) {
      this.uid = state.uid;
    }
    this.current = state.target;
    this.updatePreviousBookmark = true;
    var currentHash = window.location.hash.substring(1);
    if (this.previousHash !== currentHash) {
      this.allowHashChange = false;
    }
    this.previousHash = currentHash;
    this.historyUnlocked = true;
  },
  back: function pdfHistoryBack() {
    this.go(-1);
  },
  forward: function pdfHistoryForward() {
    this.go(1);
  },
  go: function pdfHistoryGo(direction) {
    if (this.initialized && this.historyUnlocked) {
      var state = window.history.state;
      if (direction === -1 && state && state.uid > 0) {
        window.history.back();
      } else if (direction === 1 && state && state.uid < this.uid - 1) {
        window.history.forward();
      }
    }
  }
};
exports.PDFHistory = PDFHistory;

/***/ }),
/* 12 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PDFViewer = exports.PresentationModeState = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _pdfjsLib = __w_pdfjs_require__(0);

var _ui_utils = __w_pdfjs_require__(1);

var _pdf_rendering_queue = __w_pdfjs_require__(7);

var _annotation_layer_builder = __w_pdfjs_require__(4);

var _dom_events = __w_pdfjs_require__(2);

var _pdf_page_view = __w_pdfjs_require__(5);

var _pdf_link_service = __w_pdfjs_require__(3);

var _text_layer_builder = __w_pdfjs_require__(6);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PresentationModeState = {
  UNKNOWN: 0,
  NORMAL: 1,
  CHANGING: 2,
  FULLSCREEN: 3
};
var DEFAULT_CACHE_SIZE = 10;
function PDFPageViewBuffer(size) {
  var data = [];
  this.push = function cachePush(view) {
    var i = data.indexOf(view);
    if (i >= 0) {
      data.splice(i, 1);
    }
    data.push(view);
    if (data.length > size) {
      data.shift().destroy();
    }
  };
  this.resize = function (newSize) {
    size = newSize;
    while (data.length > size) {
      data.shift().destroy();
    }
  };
}
function isSameScale(oldScale, newScale) {
  if (newScale === oldScale) {
    return true;
  }
  if (Math.abs(newScale - oldScale) < 1e-15) {
    return true;
  }
  return false;
}
function isPortraitOrientation(size) {
  return size.width <= size.height;
}

var PDFViewer = function () {
  function PDFViewer(options) {
    _classCallCheck(this, PDFViewer);

    this.container = options.container;
    this.viewer = options.viewer || options.container.firstElementChild;
    this.eventBus = options.eventBus || (0, _dom_events.getGlobalEventBus)();
    this.linkService = options.linkService || new _pdf_link_service.SimpleLinkService();
    this.downloadManager = options.downloadManager || null;
    this.removePageBorders = options.removePageBorders || false;
    this.enhanceTextSelection = options.enhanceTextSelection || false;
    this.renderInteractiveForms = options.renderInteractiveForms || false;
    this.enablePrintAutoRotate = options.enablePrintAutoRotate || false;
    this.renderer = options.renderer || _ui_utils.RendererType.CANVAS;
    this.l10n = options.l10n || _ui_utils.NullL10n;
    this.defaultRenderingQueue = !options.renderingQueue;
    if (this.defaultRenderingQueue) {
      this.renderingQueue = new _pdf_rendering_queue.PDFRenderingQueue();
      this.renderingQueue.setViewer(this);
    } else {
      this.renderingQueue = options.renderingQueue;
    }
    this.scroll = (0, _ui_utils.watchScroll)(this.container, this._scrollUpdate.bind(this));
    this.presentationModeState = PresentationModeState.UNKNOWN;
    this._resetView();
    if (this.removePageBorders) {
      this.viewer.classList.add('removePageBorders');
    }
  }

  _createClass(PDFViewer, [{
    key: 'getPageView',
    value: function getPageView(index) {
      return this._pages[index];
    }
  }, {
    key: '_setCurrentPageNumber',
    value: function _setCurrentPageNumber(val) {
      var resetCurrentPageView = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (this._currentPageNumber === val) {
        if (resetCurrentPageView) {
          this._resetCurrentPageView();
        }
        return;
      }
      if (!(0 < val && val <= this.pagesCount)) {
        console.error('PDFViewer._setCurrentPageNumber: "' + val + '" is out of bounds.');
        return;
      }
      var arg = {
        source: this,
        pageNumber: val,
        pageLabel: this._pageLabels && this._pageLabels[val - 1]
      };
      this._currentPageNumber = val;
      this.eventBus.dispatch('pagechanging', arg);
      this.eventBus.dispatch('pagechange', arg);
      if (resetCurrentPageView) {
        this._resetCurrentPageView();
      }
    }
  }, {
    key: 'setDocument',
    value: function setDocument(pdfDocument) {
      var _this = this;

      if (this.pdfDocument) {
        this._cancelRendering();
        this._resetView();
      }
      this.pdfDocument = pdfDocument;
      if (!pdfDocument) {
        return;
      }
      var pagesCount = pdfDocument.numPages;
      var pagesCapability = (0, _pdfjsLib.createPromiseCapability)();
      this.pagesPromise = pagesCapability.promise;
      pagesCapability.promise.then(function () {
        _this._pageViewsReady = true;
        _this.eventBus.dispatch('pagesloaded', {
          source: _this,
          pagesCount: pagesCount
        });
      });
      var isOnePageRenderedResolved = false;
      var onePageRenderedCapability = (0, _pdfjsLib.createPromiseCapability)();
      this.onePageRendered = onePageRenderedCapability.promise;
      var bindOnAfterAndBeforeDraw = function bindOnAfterAndBeforeDraw(pageView) {
        pageView.onBeforeDraw = function () {
          _this._buffer.push(pageView);
        };
        pageView.onAfterDraw = function () {
          if (!isOnePageRenderedResolved) {
            isOnePageRenderedResolved = true;
            onePageRenderedCapability.resolve();
          }
        };
      };
      var firstPagePromise = pdfDocument.getPage(1);
      this.firstPagePromise = firstPagePromise;
      firstPagePromise.then(function (pdfPage) {
        var scale = _this.currentScale;
        var viewport = pdfPage.getViewport(scale * _ui_utils.CSS_UNITS);
        for (var pageNum = 1; pageNum <= pagesCount; ++pageNum) {
          var textLayerFactory = null;
          if (!_pdfjsLib.PDFJS.disableTextLayer) {
            textLayerFactory = _this;
          }
          var pageView = new _pdf_page_view.PDFPageView({
            container: _this.viewer,
            eventBus: _this.eventBus,
            id: pageNum,
            scale: scale,
            defaultViewport: viewport.clone(),
            renderingQueue: _this.renderingQueue,
            textLayerFactory: textLayerFactory,
            annotationLayerFactory: _this,
            enhanceTextSelection: _this.enhanceTextSelection,
            renderInteractiveForms: _this.renderInteractiveForms,
            renderer: _this.renderer,
            l10n: _this.l10n
          });
          bindOnAfterAndBeforeDraw(pageView);
          _this._pages.push(pageView);
        }
        onePageRenderedCapability.promise.then(function () {
          if (_pdfjsLib.PDFJS.disableAutoFetch) {
            pagesCapability.resolve();
            return;
          }
          var getPagesLeft = pagesCount;

          var _loop = function _loop(_pageNum) {
            pdfDocument.getPage(_pageNum).then(function (pdfPage) {
              var pageView = _this._pages[_pageNum - 1];
              if (!pageView.pdfPage) {
                pageView.setPdfPage(pdfPage);
              }
              _this.linkService.cachePageRef(_pageNum, pdfPage.ref);
              if (--getPagesLeft === 0) {
                pagesCapability.resolve();
              }
            }, function (reason) {
              console.error('Unable to get page ' + _pageNum + ' to initialize viewer', reason);
              if (--getPagesLeft === 0) {
                pagesCapability.resolve();
              }
            });
          };

          for (var _pageNum = 1; _pageNum <= pagesCount; ++_pageNum) {
            _loop(_pageNum);
          }
        });
        _this.eventBus.dispatch('pagesinit', { source: _this });
        if (_this.defaultRenderingQueue) {
          _this.update();
        }
        if (_this.findController) {
          _this.findController.resolveFirstPage();
        }
      }).catch(function (reason) {
        console.error('Unable to initialize viewer', reason);
      });
    }
  }, {
    key: 'setPageLabels',
    value: function setPageLabels(labels) {
      if (!this.pdfDocument) {
        return;
      }
      if (!labels) {
        this._pageLabels = null;
      } else if (!(labels instanceof Array && this.pdfDocument.numPages === labels.length)) {
        this._pageLabels = null;
        console.error('PDFViewer.setPageLabels: Invalid page labels.');
      } else {
        this._pageLabels = labels;
      }
      for (var i = 0, ii = this._pages.length; i < ii; i++) {
        var pageView = this._pages[i];
        var label = this._pageLabels && this._pageLabels[i];
        pageView.setPageLabel(label);
      }
    }
  }, {
    key: '_resetView',
    value: function _resetView() {
      this._pages = [];
      this._currentPageNumber = 1;
      this._currentScale = _ui_utils.UNKNOWN_SCALE;
      this._currentScaleValue = null;
      this._pageLabels = null;
      this._buffer = new PDFPageViewBuffer(DEFAULT_CACHE_SIZE);
      this._location = null;
      this._pagesRotation = 0;
      this._pagesRequests = [];
      this._pageViewsReady = false;
      this.viewer.textContent = '';
    }
  }, {
    key: '_scrollUpdate',
    value: function _scrollUpdate() {
      if (this.pagesCount === 0) {
        return;
      }
      this.update();
    }
  }, {
    key: '_setScaleDispatchEvent',
    value: function _setScaleDispatchEvent(newScale, newValue) {
      var preset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      var arg = {
        source: this,
        scale: newScale,
        presetValue: preset ? newValue : undefined
      };
      this.eventBus.dispatch('scalechanging', arg);
      this.eventBus.dispatch('scalechange', arg);
    }
  }, {
    key: '_setScaleUpdatePages',
    value: function _setScaleUpdatePages(newScale, newValue) {
      var noScroll = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var preset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      this._currentScaleValue = newValue.toString();
      if (isSameScale(this._currentScale, newScale)) {
        if (preset) {
          this._setScaleDispatchEvent(newScale, newValue, true);
        }
        return;
      }
      for (var i = 0, ii = this._pages.length; i < ii; i++) {
        this._pages[i].update(newScale);
      }
      this._currentScale = newScale;
      if (!noScroll) {
        var page = this._currentPageNumber,
            dest = void 0;
        if (this._location && !_pdfjsLib.PDFJS.ignoreCurrentPositionOnZoom && !(this.isInPresentationMode || this.isChangingPresentationMode)) {
          page = this._location.pageNumber;
          dest = [null, { name: 'XYZ' }, this._location.left, this._location.top, null];
        }
        this.scrollPageIntoView({
          pageNumber: page,
          destArray: dest,
          allowNegativeOffset: true
        });
      }
      this._setScaleDispatchEvent(newScale, newValue, preset);
      if (this.defaultRenderingQueue) {
        this.update();
      }
    }
  }, {
    key: '_setScale',
    value: function _setScale(value) {
      var noScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var scale = parseFloat(value);
      if (scale > 0) {
        this._setScaleUpdatePages(scale, value, noScroll, false);
      } else {
        var currentPage = this._pages[this._currentPageNumber - 1];
        if (!currentPage) {
          return;
        }
        var hPadding = this.isInPresentationMode || this.removePageBorders ? 0 : _ui_utils.SCROLLBAR_PADDING;
        var vPadding = this.isInPresentationMode || this.removePageBorders ? 0 : _ui_utils.VERTICAL_PADDING;
        var pageWidthScale = (this.container.clientWidth - hPadding) / currentPage.width * currentPage.scale;
        var pageHeightScale = (this.container.clientHeight - vPadding) / currentPage.height * currentPage.scale;
        switch (value) {
          case 'page-actual':
            scale = 1;
            break;
          case 'page-width':
            scale = pageWidthScale;
            break;
          case 'page-height':
            scale = pageHeightScale;
            break;
          case 'page-fit':
            scale = Math.min(pageWidthScale, pageHeightScale);
            break;
          case 'auto':
            var isLandscape = currentPage.width > currentPage.height;
            var horizontalScale = isLandscape ? Math.min(pageHeightScale, pageWidthScale) : pageWidthScale;
            scale = Math.min(_ui_utils.MAX_AUTO_SCALE, horizontalScale);
            break;
          default:
            console.error('PDFViewer._setScale: "' + value + '" is an unknown zoom value.');
            return;
        }
        this._setScaleUpdatePages(scale, value, noScroll, true);
      }
    }
  }, {
    key: '_resetCurrentPageView',
    value: function _resetCurrentPageView() {
      if (this.isInPresentationMode) {
        this._setScale(this._currentScaleValue, true);
      }
      var pageView = this._pages[this._currentPageNumber - 1];
      (0, _ui_utils.scrollIntoView)(pageView.div);
    }
  }, {
    key: 'scrollPageIntoView',
    value: function scrollPageIntoView(params) {
      if (!this.pdfDocument) {
        return;
      }
      if (arguments.length > 1 || typeof params === 'number') {
        console.warn('Call of scrollPageIntoView() with obsolete signature.');
        var paramObj = {};
        if (typeof params === 'number') {
          paramObj.pageNumber = params;
        }
        if (arguments[1] instanceof Array) {
          paramObj.destArray = arguments[1];
        }
        params = paramObj;
      }
      var pageNumber = params.pageNumber || 0;
      var dest = params.destArray || null;
      var allowNegativeOffset = params.allowNegativeOffset || false;
      if (this.isInPresentationMode || !dest) {
        this._setCurrentPageNumber(pageNumber, true);
        return;
      }
      var pageView = this._pages[pageNumber - 1];
      if (!pageView) {
        console.error('PDFViewer.scrollPageIntoView: Invalid "pageNumber" parameter.');
        return;
      }
      var x = 0,
          y = 0;
      var width = 0,
          height = 0,
          widthScale = void 0,
          heightScale = void 0;
      var changeOrientation = pageView.rotation % 180 === 0 ? false : true;
      var pageWidth = (changeOrientation ? pageView.height : pageView.width) / pageView.scale / _ui_utils.CSS_UNITS;
      var pageHeight = (changeOrientation ? pageView.width : pageView.height) / pageView.scale / _ui_utils.CSS_UNITS;
      var scale = 0;
      switch (dest[1].name) {
        case 'XYZ':
          x = dest[2];
          y = dest[3];
          scale = dest[4];
          x = x !== null ? x : 0;
          y = y !== null ? y : pageHeight;
          break;
        case 'Fit':
        case 'FitB':
          scale = 'page-fit';
          break;
        case 'FitH':
        case 'FitBH':
          y = dest[2];
          scale = 'page-width';
          if (y === null && this._location) {
            x = this._location.left;
            y = this._location.top;
          }
          break;
        case 'FitV':
        case 'FitBV':
          x = dest[2];
          width = pageWidth;
          height = pageHeight;
          scale = 'page-height';
          break;
        case 'FitR':
          x = dest[2];
          y = dest[3];
          width = dest[4] - x;
          height = dest[5] - y;
          var hPadding = this.removePageBorders ? 0 : _ui_utils.SCROLLBAR_PADDING;
          var vPadding = this.removePageBorders ? 0 : _ui_utils.VERTICAL_PADDING;
          widthScale = (this.container.clientWidth - hPadding) / width / _ui_utils.CSS_UNITS;
          heightScale = (this.container.clientHeight - vPadding) / height / _ui_utils.CSS_UNITS;
          scale = Math.min(Math.abs(widthScale), Math.abs(heightScale));
          break;
        default:
          console.error('PDFViewer.scrollPageIntoView: "' + dest[1].name + '" ' + 'is not a valid destination type.');
          return;
      }
      if (scale && scale !== this._currentScale) {
        this.currentScaleValue = scale;
      } else if (this._currentScale === _ui_utils.UNKNOWN_SCALE) {
        this.currentScaleValue = _ui_utils.DEFAULT_SCALE_VALUE;
      }
      if (scale === 'page-fit' && !dest[4]) {
        (0, _ui_utils.scrollIntoView)(pageView.div);
        return;
      }
      var boundingRect = [pageView.viewport.convertToViewportPoint(x, y), pageView.viewport.convertToViewportPoint(x + width, y + height)];
      var left = Math.min(boundingRect[0][0], boundingRect[1][0]);
      var top = Math.min(boundingRect[0][1], boundingRect[1][1]);
      if (!allowNegativeOffset) {
        left = Math.max(left, 0);
        top = Math.max(top, 0);
      }
      (0, _ui_utils.scrollIntoView)(pageView.div, {
        left: left,
        top: top
      });
    }
  }, {
    key: '_updateLocation',
    value: function _updateLocation(firstPage) {
      var currentScale = this._currentScale;
      var currentScaleValue = this._currentScaleValue;
      var normalizedScaleValue = parseFloat(currentScaleValue) === currentScale ? Math.round(currentScale * 10000) / 100 : currentScaleValue;
      var pageNumber = firstPage.id;
      var pdfOpenParams = '#page=' + pageNumber;
      pdfOpenParams += '&zoom=' + normalizedScaleValue;
      var currentPageView = this._pages[pageNumber - 1];
      var container = this.container;
      var topLeft = currentPageView.getPagePoint(container.scrollLeft - firstPage.x, container.scrollTop - firstPage.y);
      var intLeft = Math.round(topLeft[0]);
      var intTop = Math.round(topLeft[1]);
      pdfOpenParams += ',' + intLeft + ',' + intTop;
      this._location = {
        pageNumber: pageNumber,
        scale: normalizedScaleValue,
        top: intTop,
        left: intLeft,
        pdfOpenParams: pdfOpenParams
      };
    }
  }, {
    key: 'update',
    value: function update() {
      var visible = this._getVisiblePages();
      var visiblePages = visible.views;
      if (visiblePages.length === 0) {
        return;
      }
      var suggestedCacheSize = Math.max(DEFAULT_CACHE_SIZE, 2 * visiblePages.length + 1);
      this._buffer.resize(suggestedCacheSize);
      this.renderingQueue.renderHighestPriority(visible);
      var currentId = this._currentPageNumber;
      var firstPage = visible.first;
      var stillFullyVisible = false;
      for (var i = 0, ii = visiblePages.length; i < ii; ++i) {
        var page = visiblePages[i];
        if (page.percent < 100) {
          break;
        }
        if (page.id === currentId) {
          stillFullyVisible = true;
          break;
        }
      }
      if (!stillFullyVisible) {
        currentId = visiblePages[0].id;
      }
      if (!this.isInPresentationMode) {
        this._setCurrentPageNumber(currentId);
      }
      this._updateLocation(firstPage);
      this.eventBus.dispatch('updateviewarea', {
        source: this,
        location: this._location
      });
    }
  }, {
    key: 'containsElement',
    value: function containsElement(element) {
      return this.container.contains(element);
    }
  }, {
    key: 'focus',
    value: function focus() {
      this.container.focus();
    }
  }, {
    key: '_getVisiblePages',
    value: function _getVisiblePages() {
      if (!this.isInPresentationMode) {
        return (0, _ui_utils.getVisibleElements)(this.container, this._pages, true);
      }
      var visible = [];
      var currentPage = this._pages[this._currentPageNumber - 1];
      visible.push({
        id: currentPage.id,
        view: currentPage
      });
      return {
        first: currentPage,
        last: currentPage,
        views: visible
      };
    }
  }, {
    key: 'cleanup',
    value: function cleanup() {
      for (var i = 0, ii = this._pages.length; i < ii; i++) {
        if (this._pages[i] && this._pages[i].renderingState !== _pdf_rendering_queue.RenderingStates.FINISHED) {
          this._pages[i].reset();
        }
      }
    }
  }, {
    key: '_cancelRendering',
    value: function _cancelRendering() {
      for (var i = 0, ii = this._pages.length; i < ii; i++) {
        if (this._pages[i]) {
          this._pages[i].cancelRendering();
        }
      }
    }
  }, {
    key: '_ensurePdfPageLoaded',
    value: function _ensurePdfPageLoaded(pageView) {
      var _this2 = this;

      if (pageView.pdfPage) {
        return Promise.resolve(pageView.pdfPage);
      }
      var pageNumber = pageView.id;
      if (this._pagesRequests[pageNumber]) {
        return this._pagesRequests[pageNumber];
      }
      var promise = this.pdfDocument.getPage(pageNumber).then(function (pdfPage) {
        if (!pageView.pdfPage) {
          pageView.setPdfPage(pdfPage);
        }
        _this2._pagesRequests[pageNumber] = null;
        return pdfPage;
      }).catch(function (reason) {
        console.error('Unable to get page for page view', reason);
        _this2._pagesRequests[pageNumber] = null;
      });
      this._pagesRequests[pageNumber] = promise;
      return promise;
    }
  }, {
    key: 'forceRendering',
    value: function forceRendering(currentlyVisiblePages) {
      var _this3 = this;

      var visiblePages = currentlyVisiblePages || this._getVisiblePages();
      var pageView = this.renderingQueue.getHighestPriority(visiblePages, this._pages, this.scroll.down);
      if (pageView) {
        this._ensurePdfPageLoaded(pageView).then(function () {
          _this3.renderingQueue.renderView(pageView);
        });
        return true;
      }
      return false;
    }
  }, {
    key: 'getPageTextContent',
    value: function getPageTextContent(pageIndex) {
      return this.pdfDocument.getPage(pageIndex + 1).then(function (page) {
        return page.getTextContent({ normalizeWhitespace: true });
      });
    }
  }, {
    key: 'createTextLayerBuilder',
    value: function createTextLayerBuilder(textLayerDiv, pageIndex, viewport) {
      var enhanceTextSelection = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      return new _text_layer_builder.TextLayerBuilder({
        textLayerDiv: textLayerDiv,
        eventBus: this.eventBus,
        pageIndex: pageIndex,
        viewport: viewport,
        findController: this.isInPresentationMode ? null : this.findController,
        enhanceTextSelection: this.isInPresentationMode ? false : enhanceTextSelection
      });
    }
  }, {
    key: 'createAnnotationLayerBuilder',
    value: function createAnnotationLayerBuilder(pageDiv, pdfPage) {
      var renderInteractiveForms = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var l10n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _ui_utils.NullL10n;

      return new _annotation_layer_builder.AnnotationLayerBuilder({
        pageDiv: pageDiv,
        pdfPage: pdfPage,
        renderInteractiveForms: renderInteractiveForms,
        linkService: this.linkService,
        downloadManager: this.downloadManager,
        l10n: l10n
      });
    }
  }, {
    key: 'setFindController',
    value: function setFindController(findController) {
      this.findController = findController;
    }
  }, {
    key: 'getPagesOverview',
    value: function getPagesOverview() {
      var pagesOverview = this._pages.map(function (pageView) {
        var viewport = pageView.pdfPage.getViewport(1);
        return {
          width: viewport.width,
          height: viewport.height,
          rotation: viewport.rotation
        };
      });
      if (!this.enablePrintAutoRotate) {
        return pagesOverview;
      }
      var isFirstPagePortrait = isPortraitOrientation(pagesOverview[0]);
      return pagesOverview.map(function (size) {
        if (isFirstPagePortrait === isPortraitOrientation(size)) {
          return size;
        }
        return {
          width: size.height,
          height: size.width,
          rotation: (size.rotation + 90) % 360
        };
      });
    }
  }, {
    key: 'pagesCount',
    get: function get() {
      return this._pages.length;
    }
  }, {
    key: 'pageViewsReady',
    get: function get() {
      return this._pageViewsReady;
    }
  }, {
    key: 'currentPageNumber',
    get: function get() {
      return this._currentPageNumber;
    },
    set: function set(val) {
      if ((val | 0) !== val) {
        throw new Error('Invalid page number.');
      }
      if (!this.pdfDocument) {
        return;
      }
      this._setCurrentPageNumber(val, true);
    }
  }, {
    key: 'currentPageLabel',
    get: function get() {
      return this._pageLabels && this._pageLabels[this._currentPageNumber - 1];
    },
    set: function set(val) {
      var pageNumber = val | 0;
      if (this._pageLabels) {
        var i = this._pageLabels.indexOf(val);
        if (i >= 0) {
          pageNumber = i + 1;
        }
      }
      this.currentPageNumber = pageNumber;
    }
  }, {
    key: 'currentScale',
    get: function get() {
      return this._currentScale !== _ui_utils.UNKNOWN_SCALE ? this._currentScale : _ui_utils.DEFAULT_SCALE;
    },
    set: function set(val) {
      if (isNaN(val)) {
        throw new Error('Invalid numeric scale');
      }
      if (!this.pdfDocument) {
        return;
      }
      this._setScale(val, false);
    }
  }, {
    key: 'currentScaleValue',
    get: function get() {
      return this._currentScaleValue;
    },
    set: function set(val) {
      if (!this.pdfDocument) {
        return;
      }
      this._setScale(val, false);
    }
  }, {
    key: 'pagesRotation',
    get: function get() {
      return this._pagesRotation;
    },
    set: function set(rotation) {
      if (!(typeof rotation === 'number' && rotation % 90 === 0)) {
        throw new Error('Invalid pages rotation angle.');
      }
      if (!this.pdfDocument) {
        return;
      }
      this._pagesRotation = rotation;
      for (var i = 0, ii = this._pages.length; i < ii; i++) {
        var pageView = this._pages[i];
        pageView.update(pageView.scale, rotation);
      }
      this._setScale(this._currentScaleValue, true);
      if (this.defaultRenderingQueue) {
        this.update();
      }
    }
  }, {
    key: 'isInPresentationMode',
    get: function get() {
      return this.presentationModeState === PresentationModeState.FULLSCREEN;
    }
  }, {
    key: 'isChangingPresentationMode',
    get: function get() {
      return this.presentationModeState === PresentationModeState.CHANGING;
    }
  }, {
    key: 'isHorizontalScrollbarEnabled',
    get: function get() {
      return this.isInPresentationMode ? false : this.container.scrollWidth > this.container.clientWidth;
    }
  }, {
    key: 'hasEqualPageSizes',
    get: function get() {
      var firstPageView = this._pages[0];
      for (var i = 1, ii = this._pages.length; i < ii; ++i) {
        var pageView = this._pages[i];
        if (pageView.width !== firstPageView.width || pageView.height !== firstPageView.height) {
          return false;
        }
      }
      return true;
    }
  }]);

  return PDFViewer;
}();

exports.PresentationModeState = PresentationModeState;
exports.PDFViewer = PDFViewer;

/***/ }),
/* 13 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


document.webL10n = function (window, document, undefined) {
  var gL10nData = {};
  var gTextData = '';
  var gTextProp = 'textContent';
  var gLanguage = '';
  var gMacros = {};
  var gReadyState = 'loading';
  var gAsyncResourceLoading = true;
  function getL10nResourceLinks() {
    return document.querySelectorAll('link[type="application/l10n"]');
  }
  function getL10nDictionary() {
    var script = document.querySelector('script[type="application/l10n"]');
    return script ? JSON.parse(script.innerHTML) : null;
  }
  function getTranslatableChildren(element) {
    return element ? element.querySelectorAll('*[data-l10n-id]') : [];
  }
  function getL10nAttributes(element) {
    if (!element) return {};
    var l10nId = element.getAttribute('data-l10n-id');
    var l10nArgs = element.getAttribute('data-l10n-args');
    var args = {};
    if (l10nArgs) {
      try {
        args = JSON.parse(l10nArgs);
      } catch (e) {
        console.warn('could not parse arguments for #' + l10nId);
      }
    }
    return {
      id: l10nId,
      args: args
    };
  }
  function fireL10nReadyEvent(lang) {
    var evtObject = document.createEvent('Event');
    evtObject.initEvent('localized', true, false);
    evtObject.language = lang;
    document.dispatchEvent(evtObject);
  }
  function xhrLoadText(url, onSuccess, onFailure) {
    onSuccess = onSuccess || function _onSuccess(data) {};
    onFailure = onFailure || function _onFailure() {};
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, gAsyncResourceLoading);
    if (xhr.overrideMimeType) {
      xhr.overrideMimeType('text/plain; charset=utf-8');
    }
    xhr.onreadystatechange = function () {
      if (xhr.readyState == 4) {
        if (xhr.status == 200 || xhr.status === 0) {
          onSuccess(xhr.responseText);
        } else {
          onFailure();
        }
      }
    };
    xhr.onerror = onFailure;
    xhr.ontimeout = onFailure;
    try {
      xhr.send(null);
    } catch (e) {
      onFailure();
    }
  }
  function parseResource(href, lang, successCallback, failureCallback) {
    var baseURL = href.replace(/[^\/]*$/, '') || './';
    function evalString(text) {
      if (text.lastIndexOf('\\') < 0) return text;
      return text.replace(/\\\\/g, '\\').replace(/\\n/g, '\n').replace(/\\r/g, '\r').replace(/\\t/g, '\t').replace(/\\b/g, '\b').replace(/\\f/g, '\f').replace(/\\{/g, '{').replace(/\\}/g, '}').replace(/\\"/g, '"').replace(/\\'/g, "'");
    }
    function parseProperties(text, parsedPropertiesCallback) {
      var dictionary = {};
      var reBlank = /^\s*|\s*$/;
      var reComment = /^\s*#|^\s*$/;
      var reSection = /^\s*\[(.*)\]\s*$/;
      var reImport = /^\s*@import\s+url\((.*)\)\s*$/i;
      var reSplit = /^([^=\s]*)\s*=\s*(.+)$/;
      function parseRawLines(rawText, extendedSyntax, parsedRawLinesCallback) {
        var entries = rawText.replace(reBlank, '').split(/[\r\n]+/);
        var currentLang = '*';
        var genericLang = lang.split('-', 1)[0];
        var skipLang = false;
        var match = '';
        function nextEntry() {
          while (true) {
            if (!entries.length) {
              parsedRawLinesCallback();
              return;
            }
            var line = entries.shift();
            if (reComment.test(line)) continue;
            if (extendedSyntax) {
              match = reSection.exec(line);
              if (match) {
                currentLang = match[1].toLowerCase();
                skipLang = currentLang !== '*' && currentLang !== lang && currentLang !== genericLang;
                continue;
              } else if (skipLang) {
                continue;
              }
              match = reImport.exec(line);
              if (match) {
                loadImport(baseURL + match[1], nextEntry);
                return;
              }
            }
            var tmp = line.match(reSplit);
            if (tmp && tmp.length == 3) {
              dictionary[tmp[1]] = evalString(tmp[2]);
            }
          }
        }
        nextEntry();
      }
      function loadImport(url, callback) {
        xhrLoadText(url, function (content) {
          parseRawLines(content, false, callback);
        }, function () {
          console.warn(url + ' not found.');
          callback();
        });
      }
      parseRawLines(text, true, function () {
        parsedPropertiesCallback(dictionary);
      });
    }
    xhrLoadText(href, function (response) {
      gTextData += response;
      parseProperties(response, function (data) {
        for (var key in data) {
          var id,
              prop,
              index = key.lastIndexOf('.');
          if (index > 0) {
            id = key.substring(0, index);
            prop = key.substr(index + 1);
          } else {
            id = key;
            prop = gTextProp;
          }
          if (!gL10nData[id]) {
            gL10nData[id] = {};
          }
          gL10nData[id][prop] = data[key];
        }
        if (successCallback) {
          successCallback();
        }
      });
    }, failureCallback);
  }
  function loadLocale(lang, callback) {
    if (lang) {
      lang = lang.toLowerCase();
    }
    callback = callback || function _callback() {};
    clear();
    gLanguage = lang;
    var langLinks = getL10nResourceLinks();
    var langCount = langLinks.length;
    if (langCount === 0) {
      var dict = getL10nDictionary();
      if (dict && dict.locales && dict.default_locale) {
        console.log('using the embedded JSON directory, early way out');
        gL10nData = dict.locales[lang];
        if (!gL10nData) {
          var defaultLocale = dict.default_locale.toLowerCase();
          for (var anyCaseLang in dict.locales) {
            anyCaseLang = anyCaseLang.toLowerCase();
            if (anyCaseLang === lang) {
              gL10nData = dict.locales[lang];
              break;
            } else if (anyCaseLang === defaultLocale) {
              gL10nData = dict.locales[defaultLocale];
            }
          }
        }
        callback();
      } else {
        console.log('no resource to load, early way out');
      }
      fireL10nReadyEvent(lang);
      gReadyState = 'complete';
      return;
    }
    var onResourceLoaded = null;
    var gResourceCount = 0;
    onResourceLoaded = function onResourceLoaded() {
      gResourceCount++;
      if (gResourceCount >= langCount) {
        callback();
        fireL10nReadyEvent(lang);
        gReadyState = 'complete';
      }
    };
    function L10nResourceLink(link) {
      var href = link.href;
      this.load = function (lang, callback) {
        parseResource(href, lang, callback, function () {
          console.warn(href + ' not found.');
          console.warn('"' + lang + '" resource not found');
          gLanguage = '';
          callback();
        });
      };
    }
    for (var i = 0; i < langCount; i++) {
      var resource = new L10nResourceLink(langLinks[i]);
      resource.load(lang, onResourceLoaded);
    }
  }
  function clear() {
    gL10nData = {};
    gTextData = '';
    gLanguage = '';
  }
  function getPluralRules(lang) {
    var locales2rules = {
      'af': 3,
      'ak': 4,
      'am': 4,
      'ar': 1,
      'asa': 3,
      'az': 0,
      'be': 11,
      'bem': 3,
      'bez': 3,
      'bg': 3,
      'bh': 4,
      'bm': 0,
      'bn': 3,
      'bo': 0,
      'br': 20,
      'brx': 3,
      'bs': 11,
      'ca': 3,
      'cgg': 3,
      'chr': 3,
      'cs': 12,
      'cy': 17,
      'da': 3,
      'de': 3,
      'dv': 3,
      'dz': 0,
      'ee': 3,
      'el': 3,
      'en': 3,
      'eo': 3,
      'es': 3,
      'et': 3,
      'eu': 3,
      'fa': 0,
      'ff': 5,
      'fi': 3,
      'fil': 4,
      'fo': 3,
      'fr': 5,
      'fur': 3,
      'fy': 3,
      'ga': 8,
      'gd': 24,
      'gl': 3,
      'gsw': 3,
      'gu': 3,
      'guw': 4,
      'gv': 23,
      'ha': 3,
      'haw': 3,
      'he': 2,
      'hi': 4,
      'hr': 11,
      'hu': 0,
      'id': 0,
      'ig': 0,
      'ii': 0,
      'is': 3,
      'it': 3,
      'iu': 7,
      'ja': 0,
      'jmc': 3,
      'jv': 0,
      'ka': 0,
      'kab': 5,
      'kaj': 3,
      'kcg': 3,
      'kde': 0,
      'kea': 0,
      'kk': 3,
      'kl': 3,
      'km': 0,
      'kn': 0,
      'ko': 0,
      'ksb': 3,
      'ksh': 21,
      'ku': 3,
      'kw': 7,
      'lag': 18,
      'lb': 3,
      'lg': 3,
      'ln': 4,
      'lo': 0,
      'lt': 10,
      'lv': 6,
      'mas': 3,
      'mg': 4,
      'mk': 16,
      'ml': 3,
      'mn': 3,
      'mo': 9,
      'mr': 3,
      'ms': 0,
      'mt': 15,
      'my': 0,
      'nah': 3,
      'naq': 7,
      'nb': 3,
      'nd': 3,
      'ne': 3,
      'nl': 3,
      'nn': 3,
      'no': 3,
      'nr': 3,
      'nso': 4,
      'ny': 3,
      'nyn': 3,
      'om': 3,
      'or': 3,
      'pa': 3,
      'pap': 3,
      'pl': 13,
      'ps': 3,
      'pt': 3,
      'rm': 3,
      'ro': 9,
      'rof': 3,
      'ru': 11,
      'rwk': 3,
      'sah': 0,
      'saq': 3,
      'se': 7,
      'seh': 3,
      'ses': 0,
      'sg': 0,
      'sh': 11,
      'shi': 19,
      'sk': 12,
      'sl': 14,
      'sma': 7,
      'smi': 7,
      'smj': 7,
      'smn': 7,
      'sms': 7,
      'sn': 3,
      'so': 3,
      'sq': 3,
      'sr': 11,
      'ss': 3,
      'ssy': 3,
      'st': 3,
      'sv': 3,
      'sw': 3,
      'syr': 3,
      'ta': 3,
      'te': 3,
      'teo': 3,
      'th': 0,
      'ti': 4,
      'tig': 3,
      'tk': 3,
      'tl': 4,
      'tn': 3,
      'to': 0,
      'tr': 0,
      'ts': 3,
      'tzm': 22,
      'uk': 11,
      'ur': 3,
      've': 3,
      'vi': 0,
      'vun': 3,
      'wa': 4,
      'wae': 3,
      'wo': 0,
      'xh': 3,
      'xog': 3,
      'yo': 0,
      'zh': 0,
      'zu': 3
    };
    function isIn(n, list) {
      return list.indexOf(n) !== -1;
    }
    function isBetween(n, start, end) {
      return start <= n && n <= end;
    }
    var pluralRules = {
      '0': function _(n) {
        return 'other';
      },
      '1': function _(n) {
        if (isBetween(n % 100, 3, 10)) return 'few';
        if (n === 0) return 'zero';
        if (isBetween(n % 100, 11, 99)) return 'many';
        if (n == 2) return 'two';
        if (n == 1) return 'one';
        return 'other';
      },
      '2': function _(n) {
        if (n !== 0 && n % 10 === 0) return 'many';
        if (n == 2) return 'two';
        if (n == 1) return 'one';
        return 'other';
      },
      '3': function _(n) {
        if (n == 1) return 'one';
        return 'other';
      },
      '4': function _(n) {
        if (isBetween(n, 0, 1)) return 'one';
        return 'other';
      },
      '5': function _(n) {
        if (isBetween(n, 0, 2) && n != 2) return 'one';
        return 'other';
      },
      '6': function _(n) {
        if (n === 0) return 'zero';
        if (n % 10 == 1 && n % 100 != 11) return 'one';
        return 'other';
      },
      '7': function _(n) {
        if (n == 2) return 'two';
        if (n == 1) return 'one';
        return 'other';
      },
      '8': function _(n) {
        if (isBetween(n, 3, 6)) return 'few';
        if (isBetween(n, 7, 10)) return 'many';
        if (n == 2) return 'two';
        if (n == 1) return 'one';
        return 'other';
      },
      '9': function _(n) {
        if (n === 0 || n != 1 && isBetween(n % 100, 1, 19)) return 'few';
        if (n == 1) return 'one';
        return 'other';
      },
      '10': function _(n) {
        if (isBetween(n % 10, 2, 9) && !isBetween(n % 100, 11, 19)) return 'few';
        if (n % 10 == 1 && !isBetween(n % 100, 11, 19)) return 'one';
        return 'other';
      },
      '11': function _(n) {
        if (isBetween(n % 10, 2, 4) && !isBetween(n % 100, 12, 14)) return 'few';
        if (n % 10 === 0 || isBetween(n % 10, 5, 9) || isBetween(n % 100, 11, 14)) return 'many';
        if (n % 10 == 1 && n % 100 != 11) return 'one';
        return 'other';
      },
      '12': function _(n) {
        if (isBetween(n, 2, 4)) return 'few';
        if (n == 1) return 'one';
        return 'other';
      },
      '13': function _(n) {
        if (isBetween(n % 10, 2, 4) && !isBetween(n % 100, 12, 14)) return 'few';
        if (n != 1 && isBetween(n % 10, 0, 1) || isBetween(n % 10, 5, 9) || isBetween(n % 100, 12, 14)) return 'many';
        if (n == 1) return 'one';
        return 'other';
      },
      '14': function _(n) {
        if (isBetween(n % 100, 3, 4)) return 'few';
        if (n % 100 == 2) return 'two';
        if (n % 100 == 1) return 'one';
        return 'other';
      },
      '15': function _(n) {
        if (n === 0 || isBetween(n % 100, 2, 10)) return 'few';
        if (isBetween(n % 100, 11, 19)) return 'many';
        if (n == 1) return 'one';
        return 'other';
      },
      '16': function _(n) {
        if (n % 10 == 1 && n != 11) return 'one';
        return 'other';
      },
      '17': function _(n) {
        if (n == 3) return 'few';
        if (n === 0) return 'zero';
        if (n == 6) return 'many';
        if (n == 2) return 'two';
        if (n == 1) return 'one';
        return 'other';
      },
      '18': function _(n) {
        if (n === 0) return 'zero';
        if (isBetween(n, 0, 2) && n !== 0 && n != 2) return 'one';
        return 'other';
      },
      '19': function _(n) {
        if (isBetween(n, 2, 10)) return 'few';
        if (isBetween(n, 0, 1)) return 'one';
        return 'other';
      },
      '20': function _(n) {
        if ((isBetween(n % 10, 3, 4) || n % 10 == 9) && !(isBetween(n % 100, 10, 19) || isBetween(n % 100, 70, 79) || isBetween(n % 100, 90, 99))) return 'few';
        if (n % 1000000 === 0 && n !== 0) return 'many';
        if (n % 10 == 2 && !isIn(n % 100, [12, 72, 92])) return 'two';
        if (n % 10 == 1 && !isIn(n % 100, [11, 71, 91])) return 'one';
        return 'other';
      },
      '21': function _(n) {
        if (n === 0) return 'zero';
        if (n == 1) return 'one';
        return 'other';
      },
      '22': function _(n) {
        if (isBetween(n, 0, 1) || isBetween(n, 11, 99)) return 'one';
        return 'other';
      },
      '23': function _(n) {
        if (isBetween(n % 10, 1, 2) || n % 20 === 0) return 'one';
        return 'other';
      },
      '24': function _(n) {
        if (isBetween(n, 3, 10) || isBetween(n, 13, 19)) return 'few';
        if (isIn(n, [2, 12])) return 'two';
        if (isIn(n, [1, 11])) return 'one';
        return 'other';
      }
    };
    var index = locales2rules[lang.replace(/-.*$/, '')];
    if (!(index in pluralRules)) {
      console.warn('plural form unknown for [' + lang + ']');
      return function () {
        return 'other';
      };
    }
    return pluralRules[index];
  }
  gMacros.plural = function (str, param, key, prop) {
    var n = parseFloat(param);
    if (isNaN(n)) return str;
    if (prop != gTextProp) return str;
    if (!gMacros._pluralRules) {
      gMacros._pluralRules = getPluralRules(gLanguage);
    }
    var index = '[' + gMacros._pluralRules(n) + ']';
    if (n === 0 && key + '[zero]' in gL10nData) {
      str = gL10nData[key + '[zero]'][prop];
    } else if (n == 1 && key + '[one]' in gL10nData) {
      str = gL10nData[key + '[one]'][prop];
    } else if (n == 2 && key + '[two]' in gL10nData) {
      str = gL10nData[key + '[two]'][prop];
    } else if (key + index in gL10nData) {
      str = gL10nData[key + index][prop];
    } else if (key + '[other]' in gL10nData) {
      str = gL10nData[key + '[other]'][prop];
    }
    return str;
  };
  function getL10nData(key, args, fallback) {
    var data = gL10nData[key];
    if (!data) {
      console.warn('#' + key + ' is undefined.');
      if (!fallback) {
        return null;
      }
      data = fallback;
    }
    var rv = {};
    for (var prop in data) {
      var str = data[prop];
      str = substIndexes(str, args, key, prop);
      str = substArguments(str, args, key);
      rv[prop] = str;
    }
    return rv;
  }
  function substIndexes(str, args, key, prop) {
    var reIndex = /\{\[\s*([a-zA-Z]+)\(([a-zA-Z]+)\)\s*\]\}/;
    var reMatch = reIndex.exec(str);
    if (!reMatch || !reMatch.length) return str;
    var macroName = reMatch[1];
    var paramName = reMatch[2];
    var param;
    if (args && paramName in args) {
      param = args[paramName];
    } else if (paramName in gL10nData) {
      param = gL10nData[paramName];
    }
    if (macroName in gMacros) {
      var macro = gMacros[macroName];
      str = macro(str, param, key, prop);
    }
    return str;
  }
  function substArguments(str, args, key) {
    var reArgs = /\{\{\s*(.+?)\s*\}\}/g;
    return str.replace(reArgs, function (matched_text, arg) {
      if (args && arg in args) {
        return args[arg];
      }
      if (arg in gL10nData) {
        return gL10nData[arg];
      }
      console.log('argument {{' + arg + '}} for #' + key + ' is undefined.');
      return matched_text;
    });
  }
  function translateElement(element) {
    var l10n = getL10nAttributes(element);
    if (!l10n.id) return;
    var data = getL10nData(l10n.id, l10n.args);
    if (!data) {
      console.warn('#' + l10n.id + ' is undefined.');
      return;
    }
    if (data[gTextProp]) {
      if (getChildElementCount(element) === 0) {
        element[gTextProp] = data[gTextProp];
      } else {
        var children = element.childNodes;
        var found = false;
        for (var i = 0, l = children.length; i < l; i++) {
          if (children[i].nodeType === 3 && /\S/.test(children[i].nodeValue)) {
            if (found) {
              children[i].nodeValue = '';
            } else {
              children[i].nodeValue = data[gTextProp];
              found = true;
            }
          }
        }
        if (!found) {
          var textNode = document.createTextNode(data[gTextProp]);
          element.insertBefore(textNode, element.firstChild);
        }
      }
      delete data[gTextProp];
    }
    for (var k in data) {
      element[k] = data[k];
    }
  }
  function getChildElementCount(element) {
    if (element.children) {
      return element.children.length;
    }
    if (typeof element.childElementCount !== 'undefined') {
      return element.childElementCount;
    }
    var count = 0;
    for (var i = 0; i < element.childNodes.length; i++) {
      count += element.nodeType === 1 ? 1 : 0;
    }
    return count;
  }
  function translateFragment(element) {
    element = element || document.documentElement;
    var children = getTranslatableChildren(element);
    var elementCount = children.length;
    for (var i = 0; i < elementCount; i++) {
      translateElement(children[i]);
    }
    translateElement(element);
  }
  return {
    get: function get(key, args, fallbackString) {
      var index = key.lastIndexOf('.');
      var prop = gTextProp;
      if (index > 0) {
        prop = key.substr(index + 1);
        key = key.substring(0, index);
      }
      var fallback;
      if (fallbackString) {
        fallback = {};
        fallback[prop] = fallbackString;
      }
      var data = getL10nData(key, args, fallback);
      if (data && prop in data) {
        return data[prop];
      }
      return '{{' + key + '}}';
    },
    getData: function getData() {
      return gL10nData;
    },
    getText: function getText() {
      return gTextData;
    },
    getLanguage: function getLanguage() {
      return gLanguage;
    },
    setLanguage: function setLanguage(lang, callback) {
      loadLocale(lang, function () {
        if (callback) callback();
      });
    },
    getDirection: function getDirection() {
      var rtlList = ['ar', 'he', 'fa', 'ps', 'ur'];
      var shortCode = gLanguage.split('-', 1)[0];
      return rtlList.indexOf(shortCode) >= 0 ? 'rtl' : 'ltr';
    },
    translate: translateFragment,
    getReadyState: function getReadyState() {
      return gReadyState;
    },
    ready: function ready(callback) {
      if (!callback) {
        return;
      } else if (gReadyState == 'complete' || gReadyState == 'interactive') {
        window.setTimeout(function () {
          callback();
        });
      } else if (document.addEventListener) {
        document.addEventListener('localized', function once() {
          document.removeEventListener('localized', once);
          callback();
        });
      }
    }
  };
}(window, document);

/***/ }),
/* 14 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var pdfjsLib = __w_pdfjs_require__(0);
var pdfjsWebPDFViewer = __w_pdfjs_require__(12);
var pdfjsWebPDFPageView = __w_pdfjs_require__(5);
var pdfjsWebPDFLinkService = __w_pdfjs_require__(3);
var pdfjsWebTextLayerBuilder = __w_pdfjs_require__(6);
var pdfjsWebAnnotationLayerBuilder = __w_pdfjs_require__(4);
var pdfjsWebPDFHistory = __w_pdfjs_require__(11);
var pdfjsWebPDFFindController = __w_pdfjs_require__(10);
var pdfjsWebUIUtils = __w_pdfjs_require__(1);
var pdfjsWebDownloadManager = __w_pdfjs_require__(8);
var pdfjsWebGenericL10n = __w_pdfjs_require__(9);
var PDFJS = pdfjsLib.PDFJS;
PDFJS.PDFViewer = pdfjsWebPDFViewer.PDFViewer;
PDFJS.PDFPageView = pdfjsWebPDFPageView.PDFPageView;
PDFJS.PDFLinkService = pdfjsWebPDFLinkService.PDFLinkService;
PDFJS.TextLayerBuilder = pdfjsWebTextLayerBuilder.TextLayerBuilder;
PDFJS.DefaultTextLayerFactory = pdfjsWebTextLayerBuilder.DefaultTextLayerFactory;
PDFJS.AnnotationLayerBuilder = pdfjsWebAnnotationLayerBuilder.AnnotationLayerBuilder;
PDFJS.DefaultAnnotationLayerFactory = pdfjsWebAnnotationLayerBuilder.DefaultAnnotationLayerFactory;
PDFJS.PDFHistory = pdfjsWebPDFHistory.PDFHistory;
PDFJS.PDFFindController = pdfjsWebPDFFindController.PDFFindController;
PDFJS.EventBus = pdfjsWebUIUtils.EventBus;
PDFJS.DownloadManager = pdfjsWebDownloadManager.DownloadManager;
PDFJS.ProgressBar = pdfjsWebUIUtils.ProgressBar;
PDFJS.GenericL10n = pdfjsWebGenericL10n.GenericL10n;
PDFJS.NullL10n = pdfjsWebUIUtils.NullL10n;
exports.PDFJS = PDFJS;

/***/ })
/******/ ]);
});

},{"../build/pdf.js":1181}],1185:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],1186:[function(require,module,exports){
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
/* eslint-disable node/no-deprecated-api */
var buffer = require('buffer')
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.prototype = Object.create(Buffer.prototype)

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}

},{"buffer":570}],1187:[function(require,module,exports){
'use strict';

var GetIntrinsic = require('get-intrinsic');
var define = require('define-data-property');
var hasDescriptors = require('has-property-descriptors')();
var gOPD = require('gopd');

var $TypeError = require('es-errors/type');
var $floor = GetIntrinsic('%Math.floor%');

/** @type {import('.')} */
module.exports = function setFunctionLength(fn, length) {
	if (typeof fn !== 'function') {
		throw new $TypeError('`fn` is not a function');
	}
	if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $floor(length) !== length) {
		throw new $TypeError('`length` must be a positive 32-bit integer');
	}

	var loose = arguments.length > 2 && !!arguments[2];

	var functionLengthIsConfigurable = true;
	var functionLengthIsWritable = true;
	if ('length' in fn && gOPD) {
		var desc = gOPD(fn, 'length');
		if (desc && !desc.configurable) {
			functionLengthIsConfigurable = false;
		}
		if (desc && !desc.writable) {
			functionLengthIsWritable = false;
		}
	}

	if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
		if (hasDescriptors) {
			define(/** @type {Parameters<define>[0]} */ (fn), 'length', length, true, true);
		} else {
			define(/** @type {Parameters<define>[0]} */ (fn), 'length', length);
		}
	}
	return fn;
};

},{"define-data-property":1093,"es-errors/type":1100,"get-intrinsic":1118,"gopd":1119,"has-property-descriptors":1152}],1188:[function(require,module,exports){
/*
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/

 Version: 1.8.1
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues

 */
/* global window, document, define, jQuery, setInterval, clearInterval */
;(function(factory) {
    'use strict';
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    } else if (typeof exports !== 'undefined') {
        module.exports = factory(require('jquery'));
    } else {
        factory(jQuery);
    }

}(function($) {
    'use strict';
    var Slick = window.Slick || {};

    Slick = (function() {

        var instanceUid = 0;

        function Slick(element, settings) {

            var _ = this, dataSettings;

            _.defaults = {
                accessibility: true,
                adaptiveHeight: false,
                appendArrows: $(element),
                appendDots: $(element),
                arrows: true,
                asNavFor: null,
                prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
                nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
                autoplay: false,
                autoplaySpeed: 3000,
                centerMode: false,
                centerPadding: '50px',
                cssEase: 'ease',
                customPaging: function(slider, i) {
                    return $('<button type="button" />').text(i + 1);
                },
                dots: false,
                dotsClass: 'slick-dots',
                draggable: true,
                easing: 'linear',
                edgeFriction: 0.35,
                fade: false,
                focusOnSelect: false,
                focusOnChange: false,
                infinite: true,
                initialSlide: 0,
                lazyLoad: 'ondemand',
                mobileFirst: false,
                pauseOnHover: true,
                pauseOnFocus: true,
                pauseOnDotsHover: false,
                respondTo: 'window',
                responsive: null,
                rows: 1,
                rtl: false,
                slide: '',
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: true,
                swipeToSlide: false,
                touchMove: true,
                touchThreshold: 5,
                useCSS: true,
                useTransform: true,
                variableWidth: false,
                vertical: false,
                verticalSwiping: false,
                waitForAnimate: true,
                zIndex: 1000
            };

            _.initials = {
                animating: false,
                dragging: false,
                autoPlayTimer: null,
                currentDirection: 0,
                currentLeft: null,
                currentSlide: 0,
                direction: 1,
                $dots: null,
                listWidth: null,
                listHeight: null,
                loadIndex: 0,
                $nextArrow: null,
                $prevArrow: null,
                scrolling: false,
                slideCount: null,
                slideWidth: null,
                $slideTrack: null,
                $slides: null,
                sliding: false,
                slideOffset: 0,
                swipeLeft: null,
                swiping: false,
                $list: null,
                touchObject: {},
                transformsEnabled: false,
                unslicked: false
            };

            $.extend(_, _.initials);

            _.activeBreakpoint = null;
            _.animType = null;
            _.animProp = null;
            _.breakpoints = [];
            _.breakpointSettings = [];
            _.cssTransitions = false;
            _.focussed = false;
            _.interrupted = false;
            _.hidden = 'hidden';
            _.paused = true;
            _.positionProp = null;
            _.respondTo = null;
            _.rowCount = 1;
            _.shouldClick = true;
            _.$slider = $(element);
            _.$slidesCache = null;
            _.transformType = null;
            _.transitionType = null;
            _.visibilityChange = 'visibilitychange';
            _.windowWidth = 0;
            _.windowTimer = null;

            dataSettings = $(element).data('slick') || {};

            _.options = $.extend({}, _.defaults, settings, dataSettings);

            _.currentSlide = _.options.initialSlide;

            _.originalSettings = _.options;

            if (typeof document.mozHidden !== 'undefined') {
                _.hidden = 'mozHidden';
                _.visibilityChange = 'mozvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                _.hidden = 'webkitHidden';
                _.visibilityChange = 'webkitvisibilitychange';
            }

            _.autoPlay = $.proxy(_.autoPlay, _);
            _.autoPlayClear = $.proxy(_.autoPlayClear, _);
            _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
            _.changeSlide = $.proxy(_.changeSlide, _);
            _.clickHandler = $.proxy(_.clickHandler, _);
            _.selectHandler = $.proxy(_.selectHandler, _);
            _.setPosition = $.proxy(_.setPosition, _);
            _.swipeHandler = $.proxy(_.swipeHandler, _);
            _.dragHandler = $.proxy(_.dragHandler, _);
            _.keyHandler = $.proxy(_.keyHandler, _);

            _.instanceUid = instanceUid++;

            // A simple way to check for HTML strings
            // Strict HTML recognition (must start with <)
            // Extracted from jQuery v1.11 source
            _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;


            _.registerBreakpoints();
            _.init(true);

        }

        return Slick;

    }());

    Slick.prototype.activateADA = function() {
        var _ = this;

        _.$slideTrack.find('.slick-active').attr({
            'aria-hidden': 'false'
        }).find('a, input, button, select').attr({
            'tabindex': '0'
        });

    };

    Slick.prototype.addSlide = Slick.prototype.slickAdd = function(markup, index, addBefore) {

        var _ = this;

        if (typeof(index) === 'boolean') {
            addBefore = index;
            index = null;
        } else if (index < 0 || (index >= _.slideCount)) {
            return false;
        }

        _.unload();

        if (typeof(index) === 'number') {
            if (index === 0 && _.$slides.length === 0) {
                $(markup).appendTo(_.$slideTrack);
            } else if (addBefore) {
                $(markup).insertBefore(_.$slides.eq(index));
            } else {
                $(markup).insertAfter(_.$slides.eq(index));
            }
        } else {
            if (addBefore === true) {
                $(markup).prependTo(_.$slideTrack);
            } else {
                $(markup).appendTo(_.$slideTrack);
            }
        }

        _.$slides = _.$slideTrack.children(this.options.slide);

        _.$slideTrack.children(this.options.slide).detach();

        _.$slideTrack.append(_.$slides);

        _.$slides.each(function(index, element) {
            $(element).attr('data-slick-index', index);
        });

        _.$slidesCache = _.$slides;

        _.reinit();

    };

    Slick.prototype.animateHeight = function() {
        var _ = this;
        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.animate({
                height: targetHeight
            }, _.options.speed);
        }
    };

    Slick.prototype.animateSlide = function(targetLeft, callback) {

        var animProps = {},
            _ = this;

        _.animateHeight();

        if (_.options.rtl === true && _.options.vertical === false) {
            targetLeft = -targetLeft;
        }
        if (_.transformsEnabled === false) {
            if (_.options.vertical === false) {
                _.$slideTrack.animate({
                    left: targetLeft
                }, _.options.speed, _.options.easing, callback);
            } else {
                _.$slideTrack.animate({
                    top: targetLeft
                }, _.options.speed, _.options.easing, callback);
            }

        } else {

            if (_.cssTransitions === false) {
                if (_.options.rtl === true) {
                    _.currentLeft = -(_.currentLeft);
                }
                $({
                    animStart: _.currentLeft
                }).animate({
                    animStart: targetLeft
                }, {
                    duration: _.options.speed,
                    easing: _.options.easing,
                    step: function(now) {
                        now = Math.ceil(now);
                        if (_.options.vertical === false) {
                            animProps[_.animType] = 'translate(' +
                                now + 'px, 0px)';
                            _.$slideTrack.css(animProps);
                        } else {
                            animProps[_.animType] = 'translate(0px,' +
                                now + 'px)';
                            _.$slideTrack.css(animProps);
                        }
                    },
                    complete: function() {
                        if (callback) {
                            callback.call();
                        }
                    }
                });

            } else {

                _.applyTransition();
                targetLeft = Math.ceil(targetLeft);

                if (_.options.vertical === false) {
                    animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';
                } else {
                    animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';
                }
                _.$slideTrack.css(animProps);

                if (callback) {
                    setTimeout(function() {

                        _.disableTransition();

                        callback.call();
                    }, _.options.speed);
                }

            }

        }

    };

    Slick.prototype.getNavTarget = function() {

        var _ = this,
            asNavFor = _.options.asNavFor;

        if ( asNavFor && asNavFor !== null ) {
            asNavFor = $(asNavFor).not(_.$slider);
        }

        return asNavFor;

    };

    Slick.prototype.asNavFor = function(index) {

        var _ = this,
            asNavFor = _.getNavTarget();

        if ( asNavFor !== null && typeof asNavFor === 'object' ) {
            asNavFor.each(function() {
                var target = $(this).slick('getSlick');
                if(!target.unslicked) {
                    target.slideHandler(index, true);
                }
            });
        }

    };

    Slick.prototype.applyTransition = function(slide) {

        var _ = this,
            transition = {};

        if (_.options.fade === false) {
            transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;
        } else {
            transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;
        }

        if (_.options.fade === false) {
            _.$slideTrack.css(transition);
        } else {
            _.$slides.eq(slide).css(transition);
        }

    };

    Slick.prototype.autoPlay = function() {

        var _ = this;

        _.autoPlayClear();

        if ( _.slideCount > _.options.slidesToShow ) {
            _.autoPlayTimer = setInterval( _.autoPlayIterator, _.options.autoplaySpeed );
        }

    };

    Slick.prototype.autoPlayClear = function() {

        var _ = this;

        if (_.autoPlayTimer) {
            clearInterval(_.autoPlayTimer);
        }

    };

    Slick.prototype.autoPlayIterator = function() {

        var _ = this,
            slideTo = _.currentSlide + _.options.slidesToScroll;

        if ( !_.paused && !_.interrupted && !_.focussed ) {

            if ( _.options.infinite === false ) {

                if ( _.direction === 1 && ( _.currentSlide + 1 ) === ( _.slideCount - 1 )) {
                    _.direction = 0;
                }

                else if ( _.direction === 0 ) {

                    slideTo = _.currentSlide - _.options.slidesToScroll;

                    if ( _.currentSlide - 1 === 0 ) {
                        _.direction = 1;
                    }

                }

            }

            _.slideHandler( slideTo );

        }

    };

    Slick.prototype.buildArrows = function() {

        var _ = this;

        if (_.options.arrows === true ) {

            _.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');
            _.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');

            if( _.slideCount > _.options.slidesToShow ) {

                _.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
                _.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');

                if (_.htmlExpr.test(_.options.prevArrow)) {
                    _.$prevArrow.prependTo(_.options.appendArrows);
                }

                if (_.htmlExpr.test(_.options.nextArrow)) {
                    _.$nextArrow.appendTo(_.options.appendArrows);
                }

                if (_.options.infinite !== true) {
                    _.$prevArrow
                        .addClass('slick-disabled')
                        .attr('aria-disabled', 'true');
                }

            } else {

                _.$prevArrow.add( _.$nextArrow )

                    .addClass('slick-hidden')
                    .attr({
                        'aria-disabled': 'true',
                        'tabindex': '-1'
                    });

            }

        }

    };

    Slick.prototype.buildDots = function() {

        var _ = this,
            i, dot;

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$slider.addClass('slick-dotted');

            dot = $('<ul />').addClass(_.options.dotsClass);

            for (i = 0; i <= _.getDotCount(); i += 1) {
                dot.append($('<li />').append(_.options.customPaging.call(this, _, i)));
            }

            _.$dots = dot.appendTo(_.options.appendDots);

            _.$dots.find('li').first().addClass('slick-active');

        }

    };

    Slick.prototype.buildOut = function() {

        var _ = this;

        _.$slides =
            _.$slider
                .children( _.options.slide + ':not(.slick-cloned)')
                .addClass('slick-slide');

        _.slideCount = _.$slides.length;

        _.$slides.each(function(index, element) {
            $(element)
                .attr('data-slick-index', index)
                .data('originalStyling', $(element).attr('style') || '');
        });

        _.$slider.addClass('slick-slider');

        _.$slideTrack = (_.slideCount === 0) ?
            $('<div class="slick-track"/>').appendTo(_.$slider) :
            _.$slides.wrapAll('<div class="slick-track"/>').parent();

        _.$list = _.$slideTrack.wrap(
            '<div class="slick-list"/>').parent();
        _.$slideTrack.css('opacity', 0);

        if (_.options.centerMode === true || _.options.swipeToSlide === true) {
            _.options.slidesToScroll = 1;
        }

        $('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');

        _.setupInfinite();

        _.buildArrows();

        _.buildDots();

        _.updateDots();


        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

        if (_.options.draggable === true) {
            _.$list.addClass('draggable');
        }

    };

    Slick.prototype.buildRows = function() {

        var _ = this, a, b, c, newSlides, numOfSlides, originalSlides,slidesPerSection;

        newSlides = document.createDocumentFragment();
        originalSlides = _.$slider.children();

        if(_.options.rows > 0) {

            slidesPerSection = _.options.slidesPerRow * _.options.rows;
            numOfSlides = Math.ceil(
                originalSlides.length / slidesPerSection
            );

            for(a = 0; a < numOfSlides; a++){
                var slide = document.createElement('div');
                for(b = 0; b < _.options.rows; b++) {
                    var row = document.createElement('div');
                    for(c = 0; c < _.options.slidesPerRow; c++) {
                        var target = (a * slidesPerSection + ((b * _.options.slidesPerRow) + c));
                        if (originalSlides.get(target)) {
                            row.appendChild(originalSlides.get(target));
                        }
                    }
                    slide.appendChild(row);
                }
                newSlides.appendChild(slide);
            }

            _.$slider.empty().append(newSlides);
            _.$slider.children().children().children()
                .css({
                    'width':(100 / _.options.slidesPerRow) + '%',
                    'display': 'inline-block'
                });

        }

    };

    Slick.prototype.checkResponsive = function(initial, forceUpdate) {

        var _ = this,
            breakpoint, targetBreakpoint, respondToWidth, triggerBreakpoint = false;
        var sliderWidth = _.$slider.width();
        var windowWidth = window.innerWidth || $(window).width();

        if (_.respondTo === 'window') {
            respondToWidth = windowWidth;
        } else if (_.respondTo === 'slider') {
            respondToWidth = sliderWidth;
        } else if (_.respondTo === 'min') {
            respondToWidth = Math.min(windowWidth, sliderWidth);
        }

        if ( _.options.responsive &&
            _.options.responsive.length &&
            _.options.responsive !== null) {

            targetBreakpoint = null;

            for (breakpoint in _.breakpoints) {
                if (_.breakpoints.hasOwnProperty(breakpoint)) {
                    if (_.originalSettings.mobileFirst === false) {
                        if (respondToWidth < _.breakpoints[breakpoint]) {
                            targetBreakpoint = _.breakpoints[breakpoint];
                        }
                    } else {
                        if (respondToWidth > _.breakpoints[breakpoint]) {
                            targetBreakpoint = _.breakpoints[breakpoint];
                        }
                    }
                }
            }

            if (targetBreakpoint !== null) {
                if (_.activeBreakpoint !== null) {
                    if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
                        _.activeBreakpoint =
                            targetBreakpoint;
                        if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                            _.unslick(targetBreakpoint);
                        } else {
                            _.options = $.extend({}, _.originalSettings,
                                _.breakpointSettings[
                                    targetBreakpoint]);
                            if (initial === true) {
                                _.currentSlide = _.options.initialSlide;
                            }
                            _.refresh(initial);
                        }
                        triggerBreakpoint = targetBreakpoint;
                    }
                } else {
                    _.activeBreakpoint = targetBreakpoint;
                    if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                        _.unslick(targetBreakpoint);
                    } else {
                        _.options = $.extend({}, _.originalSettings,
                            _.breakpointSettings[
                                targetBreakpoint]);
                        if (initial === true) {
                            _.currentSlide = _.options.initialSlide;
                        }
                        _.refresh(initial);
                    }
                    triggerBreakpoint = targetBreakpoint;
                }
            } else {
                if (_.activeBreakpoint !== null) {
                    _.activeBreakpoint = null;
                    _.options = _.originalSettings;
                    if (initial === true) {
                        _.currentSlide = _.options.initialSlide;
                    }
                    _.refresh(initial);
                    triggerBreakpoint = targetBreakpoint;
                }
            }

            // only trigger breakpoints during an actual break. not on initialize.
            if( !initial && triggerBreakpoint !== false ) {
                _.$slider.trigger('breakpoint', [_, triggerBreakpoint]);
            }
        }

    };

    Slick.prototype.changeSlide = function(event, dontAnimate) {

        var _ = this,
            $target = $(event.currentTarget),
            indexOffset, slideOffset, unevenOffset;

        // If target is a link, prevent default action.
        if($target.is('a')) {
            event.preventDefault();
        }

        // If target is not the <li> element (ie: a child), find the <li>.
        if(!$target.is('li')) {
            $target = $target.closest('li');
        }

        unevenOffset = (_.slideCount % _.options.slidesToScroll !== 0);
        indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;

        switch (event.data.message) {

            case 'previous':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
                if (_.slideCount > _.options.slidesToShow) {
                    _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
                }
                break;

            case 'next':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
                if (_.slideCount > _.options.slidesToShow) {
                    _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
                }
                break;

            case 'index':
                var index = event.data.index === 0 ? 0 :
                    event.data.index || $target.index() * _.options.slidesToScroll;

                _.slideHandler(_.checkNavigable(index), false, dontAnimate);
                $target.children().trigger('focus');
                break;

            default:
                return;
        }

    };

    Slick.prototype.checkNavigable = function(index) {

        var _ = this,
            navigables, prevNavigable;

        navigables = _.getNavigableIndexes();
        prevNavigable = 0;
        if (index > navigables[navigables.length - 1]) {
            index = navigables[navigables.length - 1];
        } else {
            for (var n in navigables) {
                if (index < navigables[n]) {
                    index = prevNavigable;
                    break;
                }
                prevNavigable = navigables[n];
            }
        }

        return index;
    };

    Slick.prototype.cleanUpEvents = function() {

        var _ = this;

        if (_.options.dots && _.$dots !== null) {

            $('li', _.$dots)
                .off('click.slick', _.changeSlide)
                .off('mouseenter.slick', $.proxy(_.interrupt, _, true))
                .off('mouseleave.slick', $.proxy(_.interrupt, _, false));

            if (_.options.accessibility === true) {
                _.$dots.off('keydown.slick', _.keyHandler);
            }
        }

        _.$slider.off('focus.slick blur.slick');

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
            _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);

            if (_.options.accessibility === true) {
                _.$prevArrow && _.$prevArrow.off('keydown.slick', _.keyHandler);
                _.$nextArrow && _.$nextArrow.off('keydown.slick', _.keyHandler);
            }
        }

        _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);
        _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);
        _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);
        _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);

        _.$list.off('click.slick', _.clickHandler);

        $(document).off(_.visibilityChange, _.visibility);

        _.cleanUpSlideEvents();

        if (_.options.accessibility === true) {
            _.$list.off('keydown.slick', _.keyHandler);
        }

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().off('click.slick', _.selectHandler);
        }

        $(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);

        $(window).off('resize.slick.slick-' + _.instanceUid, _.resize);

        $('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);

        $(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);

    };

    Slick.prototype.cleanUpSlideEvents = function() {

        var _ = this;

        _.$list.off('mouseenter.slick', $.proxy(_.interrupt, _, true));
        _.$list.off('mouseleave.slick', $.proxy(_.interrupt, _, false));

    };

    Slick.prototype.cleanUpRows = function() {

        var _ = this, originalSlides;

        if(_.options.rows > 0) {
            originalSlides = _.$slides.children().children();
            originalSlides.removeAttr('style');
            _.$slider.empty().append(originalSlides);
        }

    };

    Slick.prototype.clickHandler = function(event) {

        var _ = this;

        if (_.shouldClick === false) {
            event.stopImmediatePropagation();
            event.stopPropagation();
            event.preventDefault();
        }

    };

    Slick.prototype.destroy = function(refresh) {

        var _ = this;

        _.autoPlayClear();

        _.touchObject = {};

        _.cleanUpEvents();

        $('.slick-cloned', _.$slider).detach();

        if (_.$dots) {
            _.$dots.remove();
        }

        if ( _.$prevArrow && _.$prevArrow.length ) {

            _.$prevArrow
                .removeClass('slick-disabled slick-arrow slick-hidden')
                .removeAttr('aria-hidden aria-disabled tabindex')
                .css('display','');

            if ( _.htmlExpr.test( _.options.prevArrow )) {
                _.$prevArrow.remove();
            }
        }

        if ( _.$nextArrow && _.$nextArrow.length ) {

            _.$nextArrow
                .removeClass('slick-disabled slick-arrow slick-hidden')
                .removeAttr('aria-hidden aria-disabled tabindex')
                .css('display','');

            if ( _.htmlExpr.test( _.options.nextArrow )) {
                _.$nextArrow.remove();
            }
        }


        if (_.$slides) {

            _.$slides
                .removeClass('slick-slide slick-active slick-center slick-visible slick-current')
                .removeAttr('aria-hidden')
                .removeAttr('data-slick-index')
                .each(function(){
                    $(this).attr('style', $(this).data('originalStyling'));
                });

            _.$slideTrack.children(this.options.slide).detach();

            _.$slideTrack.detach();

            _.$list.detach();

            _.$slider.append(_.$slides);
        }

        _.cleanUpRows();

        _.$slider.removeClass('slick-slider');
        _.$slider.removeClass('slick-initialized');
        _.$slider.removeClass('slick-dotted');

        _.unslicked = true;

        if(!refresh) {
            _.$slider.trigger('destroy', [_]);
        }

    };

    Slick.prototype.disableTransition = function(slide) {

        var _ = this,
            transition = {};

        transition[_.transitionType] = '';

        if (_.options.fade === false) {
            _.$slideTrack.css(transition);
        } else {
            _.$slides.eq(slide).css(transition);
        }

    };

    Slick.prototype.fadeSlide = function(slideIndex, callback) {

        var _ = this;

        if (_.cssTransitions === false) {

            _.$slides.eq(slideIndex).css({
                zIndex: _.options.zIndex
            });

            _.$slides.eq(slideIndex).animate({
                opacity: 1
            }, _.options.speed, _.options.easing, callback);

        } else {

            _.applyTransition(slideIndex);

            _.$slides.eq(slideIndex).css({
                opacity: 1,
                zIndex: _.options.zIndex
            });

            if (callback) {
                setTimeout(function() {

                    _.disableTransition(slideIndex);

                    callback.call();
                }, _.options.speed);
            }

        }

    };

    Slick.prototype.fadeSlideOut = function(slideIndex) {

        var _ = this;

        if (_.cssTransitions === false) {

            _.$slides.eq(slideIndex).animate({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            }, _.options.speed, _.options.easing);

        } else {

            _.applyTransition(slideIndex);

            _.$slides.eq(slideIndex).css({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            });

        }

    };

    Slick.prototype.filterSlides = Slick.prototype.slickFilter = function(filter) {

        var _ = this;

        if (filter !== null) {

            _.$slidesCache = _.$slides;

            _.unload();

            _.$slideTrack.children(this.options.slide).detach();

            _.$slidesCache.filter(filter).appendTo(_.$slideTrack);

            _.reinit();

        }

    };

    Slick.prototype.focusHandler = function() {

        var _ = this;

        _.$slider
            .off('focus.slick blur.slick')
            .on('focus.slick blur.slick', '*', function(event) {

            event.stopImmediatePropagation();
            var $sf = $(this);

            setTimeout(function() {

                if( _.options.pauseOnFocus ) {
                    _.focussed = $sf.is(':focus');
                    _.autoPlay();
                }

            }, 0);

        });
    };

    Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function() {

        var _ = this;
        return _.currentSlide;

    };

    Slick.prototype.getDotCount = function() {

        var _ = this;

        var breakPoint = 0;
        var counter = 0;
        var pagerQty = 0;

        if (_.options.infinite === true) {
            if (_.slideCount <= _.options.slidesToShow) {
                 ++pagerQty;
            } else {
                while (breakPoint < _.slideCount) {
                    ++pagerQty;
                    breakPoint = counter + _.options.slidesToScroll;
                    counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
                }
            }
        } else if (_.options.centerMode === true) {
            pagerQty = _.slideCount;
        } else if(!_.options.asNavFor) {
            pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
        }else {
            while (breakPoint < _.slideCount) {
                ++pagerQty;
                breakPoint = counter + _.options.slidesToScroll;
                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
            }
        }

        return pagerQty - 1;

    };

    Slick.prototype.getLeft = function(slideIndex) {

        var _ = this,
            targetLeft,
            verticalHeight,
            verticalOffset = 0,
            targetSlide,
            coef;

        _.slideOffset = 0;
        verticalHeight = _.$slides.first().outerHeight(true);

        if (_.options.infinite === true) {
            if (_.slideCount > _.options.slidesToShow) {
                _.slideOffset = (_.slideWidth * _.options.slidesToShow) * -1;
                coef = -1

                if (_.options.vertical === true && _.options.centerMode === true) {
                    if (_.options.slidesToShow === 2) {
                        coef = -1.5;
                    } else if (_.options.slidesToShow === 1) {
                        coef = -2
                    }
                }
                verticalOffset = (verticalHeight * _.options.slidesToShow) * coef;
            }
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
                    if (slideIndex > _.slideCount) {
                        _.slideOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth) * -1;
                        verticalOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight) * -1;
                    } else {
                        _.slideOffset = ((_.slideCount % _.options.slidesToScroll) * _.slideWidth) * -1;
                        verticalOffset = ((_.slideCount % _.options.slidesToScroll) * verticalHeight) * -1;
                    }
                }
            }
        } else {
            if (slideIndex + _.options.slidesToShow > _.slideCount) {
                _.slideOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * _.slideWidth;
                verticalOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * verticalHeight;
            }
        }

        if (_.slideCount <= _.options.slidesToShow) {
            _.slideOffset = 0;
            verticalOffset = 0;
        }

        if (_.options.centerMode === true && _.slideCount <= _.options.slidesToShow) {
            _.slideOffset = ((_.slideWidth * Math.floor(_.options.slidesToShow)) / 2) - ((_.slideWidth * _.slideCount) / 2);
        } else if (_.options.centerMode === true && _.options.infinite === true) {
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
        } else if (_.options.centerMode === true) {
            _.slideOffset = 0;
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
        }

        if (_.options.vertical === false) {
            targetLeft = ((slideIndex * _.slideWidth) * -1) + _.slideOffset;
        } else {
            targetLeft = ((slideIndex * verticalHeight) * -1) + verticalOffset;
        }

        if (_.options.variableWidth === true) {

            if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
            } else {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
            }

            if (_.options.rtl === true) {
                if (targetSlide[0]) {
                    targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                } else {
                    targetLeft =  0;
                }
            } else {
                targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
            }

            if (_.options.centerMode === true) {
                if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
                } else {
                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
                }

                if (_.options.rtl === true) {
                    if (targetSlide[0]) {
                        targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                    } else {
                        targetLeft =  0;
                    }
                } else {
                    targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
                }

                targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
            }
        }

        return targetLeft;

    };

    Slick.prototype.getOption = Slick.prototype.slickGetOption = function(option) {

        var _ = this;

        return _.options[option];

    };

    Slick.prototype.getNavigableIndexes = function() {

        var _ = this,
            breakPoint = 0,
            counter = 0,
            indexes = [],
            max;

        if (_.options.infinite === false) {
            max = _.slideCount;
        } else {
            breakPoint = _.options.slidesToScroll * -1;
            counter = _.options.slidesToScroll * -1;
            max = _.slideCount * 2;
        }

        while (breakPoint < max) {
            indexes.push(breakPoint);
            breakPoint = counter + _.options.slidesToScroll;
            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
        }

        return indexes;

    };

    Slick.prototype.getSlick = function() {

        return this;

    };

    Slick.prototype.getSlideCount = function() {

        var _ = this,
            slidesTraversed, swipedSlide, centerOffset;

        centerOffset = _.options.centerMode === true ? _.slideWidth * Math.floor(_.options.slidesToShow / 2) : 0;

        if (_.options.swipeToSlide === true) {
            _.$slideTrack.find('.slick-slide').each(function(index, slide) {
                if (slide.offsetLeft - centerOffset + ($(slide).outerWidth() / 2) > (_.swipeLeft * -1)) {
                    swipedSlide = slide;
                    return false;
                }
            });

            slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;

            return slidesTraversed;

        } else {
            return _.options.slidesToScroll;
        }

    };

    Slick.prototype.goTo = Slick.prototype.slickGoTo = function(slide, dontAnimate) {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'index',
                index: parseInt(slide)
            }
        }, dontAnimate);

    };

    Slick.prototype.init = function(creation) {

        var _ = this;

        if (!$(_.$slider).hasClass('slick-initialized')) {

            $(_.$slider).addClass('slick-initialized');

            _.buildRows();
            _.buildOut();
            _.setProps();
            _.startLoad();
            _.loadSlider();
            _.initializeEvents();
            _.updateArrows();
            _.updateDots();
            _.checkResponsive(true);
            _.focusHandler();

        }

        if (creation) {
            _.$slider.trigger('init', [_]);
        }

        if (_.options.accessibility === true) {
            _.initADA();
        }

        if ( _.options.autoplay ) {

            _.paused = false;
            _.autoPlay();

        }

    };

    Slick.prototype.initADA = function() {
        var _ = this,
                numDotGroups = Math.ceil(_.slideCount / _.options.slidesToShow),
                tabControlIndexes = _.getNavigableIndexes().filter(function(val) {
                    return (val >= 0) && (val < _.slideCount);
                });

        _.$slides.add(_.$slideTrack.find('.slick-cloned')).attr({
            'aria-hidden': 'true',
            'tabindex': '-1'
        }).find('a, input, button, select').attr({
            'tabindex': '-1'
        });

        if (_.$dots !== null) {
            _.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function(i) {
                var slideControlIndex = tabControlIndexes.indexOf(i);

                $(this).attr({
                    'role': 'tabpanel',
                    'id': 'slick-slide' + _.instanceUid + i,
                    'tabindex': -1
                });

                if (slideControlIndex !== -1) {
                   var ariaButtonControl = 'slick-slide-control' + _.instanceUid + slideControlIndex
                   if ($('#' + ariaButtonControl).length) {
                     $(this).attr({
                         'aria-describedby': ariaButtonControl
                     });
                   }
                }
            });

            _.$dots.attr('role', 'tablist').find('li').each(function(i) {
                var mappedSlideIndex = tabControlIndexes[i];

                $(this).attr({
                    'role': 'presentation'
                });

                $(this).find('button').first().attr({
                    'role': 'tab',
                    'id': 'slick-slide-control' + _.instanceUid + i,
                    'aria-controls': 'slick-slide' + _.instanceUid + mappedSlideIndex,
                    'aria-label': (i + 1) + ' of ' + numDotGroups,
                    'aria-selected': null,
                    'tabindex': '-1'
                });

            }).eq(_.currentSlide).find('button').attr({
                'aria-selected': 'true',
                'tabindex': '0'
            }).end();
        }

        for (var i=_.currentSlide, max=i+_.options.slidesToShow; i < max; i++) {
          if (_.options.focusOnChange) {
            _.$slides.eq(i).attr({'tabindex': '0'});
          } else {
            _.$slides.eq(i).removeAttr('tabindex');
          }
        }

        _.activateADA();

    };

    Slick.prototype.initArrowEvents = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow
               .off('click.slick')
               .on('click.slick', {
                    message: 'previous'
               }, _.changeSlide);
            _.$nextArrow
               .off('click.slick')
               .on('click.slick', {
                    message: 'next'
               }, _.changeSlide);

            if (_.options.accessibility === true) {
                _.$prevArrow.on('keydown.slick', _.keyHandler);
                _.$nextArrow.on('keydown.slick', _.keyHandler);
            }
        }

    };

    Slick.prototype.initDotEvents = function() {

        var _ = this;

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
            $('li', _.$dots).on('click.slick', {
                message: 'index'
            }, _.changeSlide);

            if (_.options.accessibility === true) {
                _.$dots.on('keydown.slick', _.keyHandler);
            }
        }

        if (_.options.dots === true && _.options.pauseOnDotsHover === true && _.slideCount > _.options.slidesToShow) {

            $('li', _.$dots)
                .on('mouseenter.slick', $.proxy(_.interrupt, _, true))
                .on('mouseleave.slick', $.proxy(_.interrupt, _, false));

        }

    };

    Slick.prototype.initSlideEvents = function() {

        var _ = this;

        if ( _.options.pauseOnHover ) {

            _.$list.on('mouseenter.slick', $.proxy(_.interrupt, _, true));
            _.$list.on('mouseleave.slick', $.proxy(_.interrupt, _, false));

        }

    };

    Slick.prototype.initializeEvents = function() {

        var _ = this;

        _.initArrowEvents();

        _.initDotEvents();
        _.initSlideEvents();

        _.$list.on('touchstart.slick mousedown.slick', {
            action: 'start'
        }, _.swipeHandler);
        _.$list.on('touchmove.slick mousemove.slick', {
            action: 'move'
        }, _.swipeHandler);
        _.$list.on('touchend.slick mouseup.slick', {
            action: 'end'
        }, _.swipeHandler);
        _.$list.on('touchcancel.slick mouseleave.slick', {
            action: 'end'
        }, _.swipeHandler);

        _.$list.on('click.slick', _.clickHandler);

        $(document).on(_.visibilityChange, $.proxy(_.visibility, _));

        if (_.options.accessibility === true) {
            _.$list.on('keydown.slick', _.keyHandler);
        }

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        }

        $(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));

        $(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));

        $('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);

        $(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
        $(_.setPosition);

    };

    Slick.prototype.initUI = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

            _.$prevArrow.show();
            _.$nextArrow.show();

        }

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$dots.show();

        }

    };

    Slick.prototype.keyHandler = function(event) {

        var _ = this;
         //Dont slide if the cursor is inside the form fields and arrow keys are pressed
        if(!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
            if (event.keyCode === 37 && _.options.accessibility === true) {
                _.changeSlide({
                    data: {
                        message: _.options.rtl === true ? 'next' :  'previous'
                    }
                });
            } else if (event.keyCode === 39 && _.options.accessibility === true) {
                _.changeSlide({
                    data: {
                        message: _.options.rtl === true ? 'previous' : 'next'
                    }
                });
            }
        }

    };

    Slick.prototype.lazyLoad = function() {

        var _ = this,
            loadRange, cloneRange, rangeStart, rangeEnd;

        function loadImages(imagesScope) {

            $('img[data-lazy]', imagesScope).each(function() {

                var image = $(this),
                    imageSource = $(this).attr('data-lazy'),
                    imageSrcSet = $(this).attr('data-srcset'),
                    imageSizes  = $(this).attr('data-sizes') || _.$slider.attr('data-sizes'),
                    imageToLoad = document.createElement('img');

                imageToLoad.onload = function() {

                    image
                        .animate({ opacity: 0 }, 100, function() {

                            if (imageSrcSet) {
                                image
                                    .attr('srcset', imageSrcSet );

                                if (imageSizes) {
                                    image
                                        .attr('sizes', imageSizes );
                                }
                            }

                            image
                                .attr('src', imageSource)
                                .animate({ opacity: 1 }, 200, function() {
                                    image
                                        .removeAttr('data-lazy data-srcset data-sizes')
                                        .removeClass('slick-loading');
                                });
                            _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
                        });

                };

                imageToLoad.onerror = function() {

                    image
                        .removeAttr( 'data-lazy' )
                        .removeClass( 'slick-loading' )
                        .addClass( 'slick-lazyload-error' );

                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);

                };

                imageToLoad.src = imageSource;

            });

        }

        if (_.options.centerMode === true) {
            if (_.options.infinite === true) {
                rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
                rangeEnd = rangeStart + _.options.slidesToShow + 2;
            } else {
                rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
                rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
            }
        } else {
            rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
            rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
            if (_.options.fade === true) {
                if (rangeStart > 0) rangeStart--;
                if (rangeEnd <= _.slideCount) rangeEnd++;
            }
        }

        loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);

        if (_.options.lazyLoad === 'anticipated') {
            var prevSlide = rangeStart - 1,
                nextSlide = rangeEnd,
                $slides = _.$slider.find('.slick-slide');

            for (var i = 0; i < _.options.slidesToScroll; i++) {
                if (prevSlide < 0) prevSlide = _.slideCount - 1;
                loadRange = loadRange.add($slides.eq(prevSlide));
                loadRange = loadRange.add($slides.eq(nextSlide));
                prevSlide--;
                nextSlide++;
            }
        }

        loadImages(loadRange);

        if (_.slideCount <= _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-slide');
            loadImages(cloneRange);
        } else
        if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
            loadImages(cloneRange);
        } else if (_.currentSlide === 0) {
            cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
            loadImages(cloneRange);
        }

    };

    Slick.prototype.loadSlider = function() {

        var _ = this;

        _.setPosition();

        _.$slideTrack.css({
            opacity: 1
        });

        _.$slider.removeClass('slick-loading');

        _.initUI();

        if (_.options.lazyLoad === 'progressive') {
            _.progressiveLazyLoad();
        }

    };

    Slick.prototype.next = Slick.prototype.slickNext = function() {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'next'
            }
        });

    };

    Slick.prototype.orientationChange = function() {

        var _ = this;

        _.checkResponsive();
        _.setPosition();

    };

    Slick.prototype.pause = Slick.prototype.slickPause = function() {

        var _ = this;

        _.autoPlayClear();
        _.paused = true;

    };

    Slick.prototype.play = Slick.prototype.slickPlay = function() {

        var _ = this;

        _.autoPlay();
        _.options.autoplay = true;
        _.paused = false;
        _.focussed = false;
        _.interrupted = false;

    };

    Slick.prototype.postSlide = function(index) {

        var _ = this;

        if( !_.unslicked ) {

            _.$slider.trigger('afterChange', [_, index]);

            _.animating = false;

            if (_.slideCount > _.options.slidesToShow) {
                _.setPosition();
            }

            _.swipeLeft = null;

            if ( _.options.autoplay ) {
                _.autoPlay();
            }

            if (_.options.accessibility === true) {
                _.initADA();

                if (_.options.focusOnChange) {
                    var $currentSlide = $(_.$slides.get(_.currentSlide));
                    $currentSlide.attr('tabindex', 0).focus();
                }
            }

        }

    };

    Slick.prototype.prev = Slick.prototype.slickPrev = function() {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'previous'
            }
        });

    };

    Slick.prototype.preventDefault = function(event) {

        event.preventDefault();

    };

    Slick.prototype.progressiveLazyLoad = function( tryCount ) {

        tryCount = tryCount || 1;

        var _ = this,
            $imgsToLoad = $( 'img[data-lazy]', _.$slider ),
            image,
            imageSource,
            imageSrcSet,
            imageSizes,
            imageToLoad;

        if ( $imgsToLoad.length ) {

            image = $imgsToLoad.first();
            imageSource = image.attr('data-lazy');
            imageSrcSet = image.attr('data-srcset');
            imageSizes  = image.attr('data-sizes') || _.$slider.attr('data-sizes');
            imageToLoad = document.createElement('img');

            imageToLoad.onload = function() {

                if (imageSrcSet) {
                    image
                        .attr('srcset', imageSrcSet );

                    if (imageSizes) {
                        image
                            .attr('sizes', imageSizes );
                    }
                }

                image
                    .attr( 'src', imageSource )
                    .removeAttr('data-lazy data-srcset data-sizes')
                    .removeClass('slick-loading');

                if ( _.options.adaptiveHeight === true ) {
                    _.setPosition();
                }

                _.$slider.trigger('lazyLoaded', [ _, image, imageSource ]);
                _.progressiveLazyLoad();

            };

            imageToLoad.onerror = function() {

                if ( tryCount < 3 ) {

                    /**
                     * try to load the image 3 times,
                     * leave a slight delay so we don't get
                     * servers blocking the request.
                     */
                    setTimeout( function() {
                        _.progressiveLazyLoad( tryCount + 1 );
                    }, 500 );

                } else {

                    image
                        .removeAttr( 'data-lazy' )
                        .removeClass( 'slick-loading' )
                        .addClass( 'slick-lazyload-error' );

                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);

                    _.progressiveLazyLoad();

                }

            };

            imageToLoad.src = imageSource;

        } else {

            _.$slider.trigger('allImagesLoaded', [ _ ]);

        }

    };

    Slick.prototype.refresh = function( initializing ) {

        var _ = this, currentSlide, lastVisibleIndex;

        lastVisibleIndex = _.slideCount - _.options.slidesToShow;

        // in non-infinite sliders, we don't want to go past the
        // last visible index.
        if( !_.options.infinite && ( _.currentSlide > lastVisibleIndex )) {
            _.currentSlide = lastVisibleIndex;
        }

        // if less slides than to show, go to start.
        if ( _.slideCount <= _.options.slidesToShow ) {
            _.currentSlide = 0;

        }

        currentSlide = _.currentSlide;

        _.destroy(true);

        $.extend(_, _.initials, { currentSlide: currentSlide });

        _.init();

        if( !initializing ) {

            _.changeSlide({
                data: {
                    message: 'index',
                    index: currentSlide
                }
            }, false);

        }

    };

    Slick.prototype.registerBreakpoints = function() {

        var _ = this, breakpoint, currentBreakpoint, l,
            responsiveSettings = _.options.responsive || null;

        if ( $.type(responsiveSettings) === 'array' && responsiveSettings.length ) {

            _.respondTo = _.options.respondTo || 'window';

            for ( breakpoint in responsiveSettings ) {

                l = _.breakpoints.length-1;

                if (responsiveSettings.hasOwnProperty(breakpoint)) {
                    currentBreakpoint = responsiveSettings[breakpoint].breakpoint;

                    // loop through the breakpoints and cut out any existing
                    // ones with the same breakpoint number, we don't want dupes.
                    while( l >= 0 ) {
                        if( _.breakpoints[l] && _.breakpoints[l] === currentBreakpoint ) {
                            _.breakpoints.splice(l,1);
                        }
                        l--;
                    }

                    _.breakpoints.push(currentBreakpoint);
                    _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;

                }

            }

            _.breakpoints.sort(function(a, b) {
                return ( _.options.mobileFirst ) ? a-b : b-a;
            });

        }

    };

    Slick.prototype.reinit = function() {

        var _ = this;

        _.$slides =
            _.$slideTrack
                .children(_.options.slide)
                .addClass('slick-slide');

        _.slideCount = _.$slides.length;

        if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) {
            _.currentSlide = _.currentSlide - _.options.slidesToScroll;
        }

        if (_.slideCount <= _.options.slidesToShow) {
            _.currentSlide = 0;
        }

        _.registerBreakpoints();

        _.setProps();
        _.setupInfinite();
        _.buildArrows();
        _.updateArrows();
        _.initArrowEvents();
        _.buildDots();
        _.updateDots();
        _.initDotEvents();
        _.cleanUpSlideEvents();
        _.initSlideEvents();

        _.checkResponsive(false, true);

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        }

        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

        _.setPosition();
        _.focusHandler();

        _.paused = !_.options.autoplay;
        _.autoPlay();

        _.$slider.trigger('reInit', [_]);

    };

    Slick.prototype.resize = function() {

        var _ = this;

        if ($(window).width() !== _.windowWidth) {
            clearTimeout(_.windowDelay);
            _.windowDelay = window.setTimeout(function() {
                _.windowWidth = $(window).width();
                _.checkResponsive();
                if( !_.unslicked ) { _.setPosition(); }
            }, 50);
        }
    };

    Slick.prototype.removeSlide = Slick.prototype.slickRemove = function(index, removeBefore, removeAll) {

        var _ = this;

        if (typeof(index) === 'boolean') {
            removeBefore = index;
            index = removeBefore === true ? 0 : _.slideCount - 1;
        } else {
            index = removeBefore === true ? --index : index;
        }

        if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) {
            return false;
        }

        _.unload();

        if (removeAll === true) {
            _.$slideTrack.children().remove();
        } else {
            _.$slideTrack.children(this.options.slide).eq(index).remove();
        }

        _.$slides = _.$slideTrack.children(this.options.slide);

        _.$slideTrack.children(this.options.slide).detach();

        _.$slideTrack.append(_.$slides);

        _.$slidesCache = _.$slides;

        _.reinit();

    };

    Slick.prototype.setCSS = function(position) {

        var _ = this,
            positionProps = {},
            x, y;

        if (_.options.rtl === true) {
            position = -position;
        }
        x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
        y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';

        positionProps[_.positionProp] = position;

        if (_.transformsEnabled === false) {
            _.$slideTrack.css(positionProps);
        } else {
            positionProps = {};
            if (_.cssTransitions === false) {
                positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';
                _.$slideTrack.css(positionProps);
            } else {
                positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';
                _.$slideTrack.css(positionProps);
            }
        }

    };

    Slick.prototype.setDimensions = function() {

        var _ = this;

        if (_.options.vertical === false) {
            if (_.options.centerMode === true) {
                _.$list.css({
                    padding: ('0px ' + _.options.centerPadding)
                });
            }
        } else {
            _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
            if (_.options.centerMode === true) {
                _.$list.css({
                    padding: (_.options.centerPadding + ' 0px')
                });
            }
        }

        _.listWidth = _.$list.width();
        _.listHeight = _.$list.height();


        if (_.options.vertical === false && _.options.variableWidth === false) {
            _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
            _.$slideTrack.width(Math.ceil((_.slideWidth * _.$slideTrack.children('.slick-slide').length)));

        } else if (_.options.variableWidth === true) {
            _.$slideTrack.width(5000 * _.slideCount);
        } else {
            _.slideWidth = Math.ceil(_.listWidth);
            _.$slideTrack.height(Math.ceil((_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length)));
        }

        var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
        if (_.options.variableWidth === false) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);

    };

    Slick.prototype.setFade = function() {

        var _ = this,
            targetLeft;

        _.$slides.each(function(index, element) {
            targetLeft = (_.slideWidth * index) * -1;
            if (_.options.rtl === true) {
                $(element).css({
                    position: 'relative',
                    right: targetLeft,
                    top: 0,
                    zIndex: _.options.zIndex - 2,
                    opacity: 0
                });
            } else {
                $(element).css({
                    position: 'relative',
                    left: targetLeft,
                    top: 0,
                    zIndex: _.options.zIndex - 2,
                    opacity: 0
                });
            }
        });

        _.$slides.eq(_.currentSlide).css({
            zIndex: _.options.zIndex - 1,
            opacity: 1
        });

    };

    Slick.prototype.setHeight = function() {

        var _ = this;

        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.css('height', targetHeight);
        }

    };

    Slick.prototype.setOption =
    Slick.prototype.slickSetOption = function() {

        /**
         * accepts arguments in format of:
         *
         *  - for changing a single option's value:
         *     .slick("setOption", option, value, refresh )
         *
         *  - for changing a set of responsive options:
         *     .slick("setOption", 'responsive', [{}, ...], refresh )
         *
         *  - for updating multiple values at once (not responsive)
         *     .slick("setOption", { 'option': value, ... }, refresh )
         */

        var _ = this, l, item, option, value, refresh = false, type;

        if( $.type( arguments[0] ) === 'object' ) {

            option =  arguments[0];
            refresh = arguments[1];
            type = 'multiple';

        } else if ( $.type( arguments[0] ) === 'string' ) {

            option =  arguments[0];
            value = arguments[1];
            refresh = arguments[2];

            if ( arguments[0] === 'responsive' && $.type( arguments[1] ) === 'array' ) {

                type = 'responsive';

            } else if ( typeof arguments[1] !== 'undefined' ) {

                type = 'single';

            }

        }

        if ( type === 'single' ) {

            _.options[option] = value;


        } else if ( type === 'multiple' ) {

            $.each( option , function( opt, val ) {

                _.options[opt] = val;

            });


        } else if ( type === 'responsive' ) {

            for ( item in value ) {

                if( $.type( _.options.responsive ) !== 'array' ) {

                    _.options.responsive = [ value[item] ];

                } else {

                    l = _.options.responsive.length-1;

                    // loop through the responsive object and splice out duplicates.
                    while( l >= 0 ) {

                        if( _.options.responsive[l].breakpoint === value[item].breakpoint ) {

                            _.options.responsive.splice(l,1);

                        }

                        l--;

                    }

                    _.options.responsive.push( value[item] );

                }

            }

        }

        if ( refresh ) {

            _.unload();
            _.reinit();

        }

    };

    Slick.prototype.setPosition = function() {

        var _ = this;

        _.setDimensions();

        _.setHeight();

        if (_.options.fade === false) {
            _.setCSS(_.getLeft(_.currentSlide));
        } else {
            _.setFade();
        }

        _.$slider.trigger('setPosition', [_]);

    };

    Slick.prototype.setProps = function() {

        var _ = this,
            bodyStyle = document.body.style;

        _.positionProp = _.options.vertical === true ? 'top' : 'left';

        if (_.positionProp === 'top') {
            _.$slider.addClass('slick-vertical');
        } else {
            _.$slider.removeClass('slick-vertical');
        }

        if (bodyStyle.WebkitTransition !== undefined ||
            bodyStyle.MozTransition !== undefined ||
            bodyStyle.msTransition !== undefined) {
            if (_.options.useCSS === true) {
                _.cssTransitions = true;
            }
        }

        if ( _.options.fade ) {
            if ( typeof _.options.zIndex === 'number' ) {
                if( _.options.zIndex < 3 ) {
                    _.options.zIndex = 3;
                }
            } else {
                _.options.zIndex = _.defaults.zIndex;
            }
        }

        if (bodyStyle.OTransform !== undefined) {
            _.animType = 'OTransform';
            _.transformType = '-o-transform';
            _.transitionType = 'OTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.MozTransform !== undefined) {
            _.animType = 'MozTransform';
            _.transformType = '-moz-transform';
            _.transitionType = 'MozTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.webkitTransform !== undefined) {
            _.animType = 'webkitTransform';
            _.transformType = '-webkit-transform';
            _.transitionType = 'webkitTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.msTransform !== undefined) {
            _.animType = 'msTransform';
            _.transformType = '-ms-transform';
            _.transitionType = 'msTransition';
            if (bodyStyle.msTransform === undefined) _.animType = false;
        }
        if (bodyStyle.transform !== undefined && _.animType !== false) {
            _.animType = 'transform';
            _.transformType = 'transform';
            _.transitionType = 'transition';
        }
        _.transformsEnabled = _.options.useTransform && (_.animType !== null && _.animType !== false);
    };


    Slick.prototype.setSlideClasses = function(index) {

        var _ = this,
            centerOffset, allSlides, indexOffset, remainder;

        allSlides = _.$slider
            .find('.slick-slide')
            .removeClass('slick-active slick-center slick-current')
            .attr('aria-hidden', 'true');

        _.$slides
            .eq(index)
            .addClass('slick-current');

        if (_.options.centerMode === true) {

            var evenCoef = _.options.slidesToShow % 2 === 0 ? 1 : 0;

            centerOffset = Math.floor(_.options.slidesToShow / 2);

            if (_.options.infinite === true) {

                if (index >= centerOffset && index <= (_.slideCount - 1) - centerOffset) {
                    _.$slides
                        .slice(index - centerOffset + evenCoef, index + centerOffset + 1)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                } else {

                    indexOffset = _.options.slidesToShow + index;
                    allSlides
                        .slice(indexOffset - centerOffset + 1 + evenCoef, indexOffset + centerOffset + 2)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                }

                if (index === 0) {

                    allSlides
                        .eq(allSlides.length - 1 - _.options.slidesToShow)
                        .addClass('slick-center');

                } else if (index === _.slideCount - 1) {

                    allSlides
                        .eq(_.options.slidesToShow)
                        .addClass('slick-center');

                }

            }

            _.$slides
                .eq(index)
                .addClass('slick-center');

        } else {

            if (index >= 0 && index <= (_.slideCount - _.options.slidesToShow)) {

                _.$slides
                    .slice(index, index + _.options.slidesToShow)
                    .addClass('slick-active')
                    .attr('aria-hidden', 'false');

            } else if (allSlides.length <= _.options.slidesToShow) {

                allSlides
                    .addClass('slick-active')
                    .attr('aria-hidden', 'false');

            } else {

                remainder = _.slideCount % _.options.slidesToShow;
                indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;

                if (_.options.slidesToShow == _.options.slidesToScroll && (_.slideCount - index) < _.options.slidesToShow) {

                    allSlides
                        .slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                } else {

                    allSlides
                        .slice(indexOffset, indexOffset + _.options.slidesToShow)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                }

            }

        }

        if (_.options.lazyLoad === 'ondemand' || _.options.lazyLoad === 'anticipated') {
            _.lazyLoad();
        }
    };

    Slick.prototype.setupInfinite = function() {

        var _ = this,
            i, slideIndex, infiniteCount;

        if (_.options.fade === true) {
            _.options.centerMode = false;
        }

        if (_.options.infinite === true && _.options.fade === false) {

            slideIndex = null;

            if (_.slideCount > _.options.slidesToShow) {

                if (_.options.centerMode === true) {
                    infiniteCount = _.options.slidesToShow + 1;
                } else {
                    infiniteCount = _.options.slidesToShow;
                }

                for (i = _.slideCount; i > (_.slideCount -
                        infiniteCount); i -= 1) {
                    slideIndex = i - 1;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '')
                        .attr('data-slick-index', slideIndex - _.slideCount)
                        .prependTo(_.$slideTrack).addClass('slick-cloned');
                }
                for (i = 0; i < infiniteCount  + _.slideCount; i += 1) {
                    slideIndex = i;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '')
                        .attr('data-slick-index', slideIndex + _.slideCount)
                        .appendTo(_.$slideTrack).addClass('slick-cloned');
                }
                _.$slideTrack.find('.slick-cloned').find('[id]').each(function() {
                    $(this).attr('id', '');
                });

            }

        }

    };

    Slick.prototype.interrupt = function( toggle ) {

        var _ = this;

        if( !toggle ) {
            _.autoPlay();
        }
        _.interrupted = toggle;

    };

    Slick.prototype.selectHandler = function(event) {

        var _ = this;

        var targetElement =
            $(event.target).is('.slick-slide') ?
                $(event.target) :
                $(event.target).parents('.slick-slide');

        var index = parseInt(targetElement.attr('data-slick-index'));

        if (!index) index = 0;

        if (_.slideCount <= _.options.slidesToShow) {

            _.slideHandler(index, false, true);
            return;

        }

        _.slideHandler(index);

    };

    Slick.prototype.slideHandler = function(index, sync, dontAnimate) {

        var targetSlide, animSlide, oldSlide, slideLeft, targetLeft = null,
            _ = this, navTarget;

        sync = sync || false;

        if (_.animating === true && _.options.waitForAnimate === true) {
            return;
        }

        if (_.options.fade === true && _.currentSlide === index) {
            return;
        }

        if (sync === false) {
            _.asNavFor(index);
        }

        targetSlide = index;
        targetLeft = _.getLeft(targetSlide);
        slideLeft = _.getLeft(_.currentSlide);

        _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;

        if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
                    _.animateSlide(slideLeft, function() {
                        _.postSlide(targetSlide);
                    });
                } else {
                    _.postSlide(targetSlide);
                }
            }
            return;
        } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > (_.slideCount - _.options.slidesToScroll))) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
                    _.animateSlide(slideLeft, function() {
                        _.postSlide(targetSlide);
                    });
                } else {
                    _.postSlide(targetSlide);
                }
            }
            return;
        }

        if ( _.options.autoplay ) {
            clearInterval(_.autoPlayTimer);
        }

        if (targetSlide < 0) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = _.slideCount - (_.slideCount % _.options.slidesToScroll);
            } else {
                animSlide = _.slideCount + targetSlide;
            }
        } else if (targetSlide >= _.slideCount) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = 0;
            } else {
                animSlide = targetSlide - _.slideCount;
            }
        } else {
            animSlide = targetSlide;
        }

        _.animating = true;

        _.$slider.trigger('beforeChange', [_, _.currentSlide, animSlide]);

        oldSlide = _.currentSlide;
        _.currentSlide = animSlide;

        _.setSlideClasses(_.currentSlide);

        if ( _.options.asNavFor ) {

            navTarget = _.getNavTarget();
            navTarget = navTarget.slick('getSlick');

            if ( navTarget.slideCount <= navTarget.options.slidesToShow ) {
                navTarget.setSlideClasses(_.currentSlide);
            }

        }

        _.updateDots();
        _.updateArrows();

        if (_.options.fade === true) {
            if (dontAnimate !== true) {

                _.fadeSlideOut(oldSlide);

                _.fadeSlide(animSlide, function() {
                    _.postSlide(animSlide);
                });

            } else {
                _.postSlide(animSlide);
            }
            _.animateHeight();
            return;
        }

        if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
            _.animateSlide(targetLeft, function() {
                _.postSlide(animSlide);
            });
        } else {
            _.postSlide(animSlide);
        }

    };

    Slick.prototype.startLoad = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

            _.$prevArrow.hide();
            _.$nextArrow.hide();

        }

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$dots.hide();

        }

        _.$slider.addClass('slick-loading');

    };

    Slick.prototype.swipeDirection = function() {

        var xDist, yDist, r, swipeAngle, _ = this;

        xDist = _.touchObject.startX - _.touchObject.curX;
        yDist = _.touchObject.startY - _.touchObject.curY;
        r = Math.atan2(yDist, xDist);

        swipeAngle = Math.round(r * 180 / Math.PI);
        if (swipeAngle < 0) {
            swipeAngle = 360 - Math.abs(swipeAngle);
        }

        if ((swipeAngle <= 45) && (swipeAngle >= 0)) {
            return (_.options.rtl === false ? 'left' : 'right');
        }
        if ((swipeAngle <= 360) && (swipeAngle >= 315)) {
            return (_.options.rtl === false ? 'left' : 'right');
        }
        if ((swipeAngle >= 135) && (swipeAngle <= 225)) {
            return (_.options.rtl === false ? 'right' : 'left');
        }
        if (_.options.verticalSwiping === true) {
            if ((swipeAngle >= 35) && (swipeAngle <= 135)) {
                return 'down';
            } else {
                return 'up';
            }
        }

        return 'vertical';

    };

    Slick.prototype.swipeEnd = function(event) {

        var _ = this,
            slideCount,
            direction;

        _.dragging = false;
        _.swiping = false;

        if (_.scrolling) {
            _.scrolling = false;
            return false;
        }

        _.interrupted = false;
        _.shouldClick = ( _.touchObject.swipeLength > 10 ) ? false : true;

        if ( _.touchObject.curX === undefined ) {
            return false;
        }

        if ( _.touchObject.edgeHit === true ) {
            _.$slider.trigger('edge', [_, _.swipeDirection() ]);
        }

        if ( _.touchObject.swipeLength >= _.touchObject.minSwipe ) {

            direction = _.swipeDirection();

            switch ( direction ) {

                case 'left':
                case 'down':

                    slideCount =
                        _.options.swipeToSlide ?
                            _.checkNavigable( _.currentSlide + _.getSlideCount() ) :
                            _.currentSlide + _.getSlideCount();

                    _.currentDirection = 0;

                    break;

                case 'right':
                case 'up':

                    slideCount =
                        _.options.swipeToSlide ?
                            _.checkNavigable( _.currentSlide - _.getSlideCount() ) :
                            _.currentSlide - _.getSlideCount();

                    _.currentDirection = 1;

                    break;

                default:


            }

            if( direction != 'vertical' ) {

                _.slideHandler( slideCount );
                _.touchObject = {};
                _.$slider.trigger('swipe', [_, direction ]);

            }

        } else {

            if ( _.touchObject.startX !== _.touchObject.curX ) {

                _.slideHandler( _.currentSlide );
                _.touchObject = {};

            }

        }

    };

    Slick.prototype.swipeHandler = function(event) {

        var _ = this;

        if ((_.options.swipe === false) || ('ontouchend' in document && _.options.swipe === false)) {
            return;
        } else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) {
            return;
        }

        _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ?
            event.originalEvent.touches.length : 1;

        _.touchObject.minSwipe = _.listWidth / _.options
            .touchThreshold;

        if (_.options.verticalSwiping === true) {
            _.touchObject.minSwipe = _.listHeight / _.options
                .touchThreshold;
        }

        switch (event.data.action) {

            case 'start':
                _.swipeStart(event);
                break;

            case 'move':
                _.swipeMove(event);
                break;

            case 'end':
                _.swipeEnd(event);
                break;

        }

    };

    Slick.prototype.swipeMove = function(event) {

        var _ = this,
            edgeWasHit = false,
            curLeft, swipeDirection, swipeLength, positionOffset, touches, verticalSwipeLength;

        touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;

        if (!_.dragging || _.scrolling || touches && touches.length !== 1) {
            return false;
        }

        curLeft = _.getLeft(_.currentSlide);

        _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
        _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;

        _.touchObject.swipeLength = Math.round(Math.sqrt(
            Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));

        verticalSwipeLength = Math.round(Math.sqrt(
            Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));

        if (!_.options.verticalSwiping && !_.swiping && verticalSwipeLength > 4) {
            _.scrolling = true;
            return false;
        }

        if (_.options.verticalSwiping === true) {
            _.touchObject.swipeLength = verticalSwipeLength;
        }

        swipeDirection = _.swipeDirection();

        if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
            _.swiping = true;
            event.preventDefault();
        }

        positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
        if (_.options.verticalSwiping === true) {
            positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
        }


        swipeLength = _.touchObject.swipeLength;

        _.touchObject.edgeHit = false;

        if (_.options.infinite === false) {
            if ((_.currentSlide === 0 && swipeDirection === 'right') || (_.currentSlide >= _.getDotCount() && swipeDirection === 'left')) {
                swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
                _.touchObject.edgeHit = true;
            }
        }

        if (_.options.vertical === false) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
        } else {
            _.swipeLeft = curLeft + (swipeLength * (_.$list.height() / _.listWidth)) * positionOffset;
        }
        if (_.options.verticalSwiping === true) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
        }

        if (_.options.fade === true || _.options.touchMove === false) {
            return false;
        }

        if (_.animating === true) {
            _.swipeLeft = null;
            return false;
        }

        _.setCSS(_.swipeLeft);

    };

    Slick.prototype.swipeStart = function(event) {

        var _ = this,
            touches;

        _.interrupted = true;

        if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
            _.touchObject = {};
            return false;
        }

        if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) {
            touches = event.originalEvent.touches[0];
        }

        _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
        _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;

        _.dragging = true;

    };

    Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function() {

        var _ = this;

        if (_.$slidesCache !== null) {

            _.unload();

            _.$slideTrack.children(this.options.slide).detach();

            _.$slidesCache.appendTo(_.$slideTrack);

            _.reinit();

        }

    };

    Slick.prototype.unload = function() {

        var _ = this;

        $('.slick-cloned', _.$slider).remove();

        if (_.$dots) {
            _.$dots.remove();
        }

        if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) {
            _.$prevArrow.remove();
        }

        if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) {
            _.$nextArrow.remove();
        }

        _.$slides
            .removeClass('slick-slide slick-active slick-visible slick-current')
            .attr('aria-hidden', 'true')
            .css('width', '');

    };

    Slick.prototype.unslick = function(fromBreakpoint) {

        var _ = this;
        _.$slider.trigger('unslick', [_, fromBreakpoint]);
        _.destroy();

    };

    Slick.prototype.updateArrows = function() {

        var _ = this,
            centerOffset;

        centerOffset = Math.floor(_.options.slidesToShow / 2);

        if ( _.options.arrows === true &&
            _.slideCount > _.options.slidesToShow &&
            !_.options.infinite ) {

            _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            if (_.currentSlide === 0) {

                _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {

                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {

                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            }

        }

    };

    Slick.prototype.updateDots = function() {

        var _ = this;

        if (_.$dots !== null) {

            _.$dots
                .find('li')
                    .removeClass('slick-active')
                    .end();

            _.$dots
                .find('li')
                .eq(Math.floor(_.currentSlide / _.options.slidesToScroll))
                .addClass('slick-active');

        }

    };

    Slick.prototype.visibility = function() {

        var _ = this;

        if ( _.options.autoplay ) {

            if ( document[_.hidden] ) {

                _.interrupted = true;

            } else {

                _.interrupted = false;

            }

        }

    };

    $.fn.slick = function() {
        var _ = this,
            opt = arguments[0],
            args = Array.prototype.slice.call(arguments, 1),
            l = _.length,
            i,
            ret;
        for (i = 0; i < l; i++) {
            if (typeof opt == 'object' || typeof opt == 'undefined')
                _[i].slick = new Slick(_[i], opt);
            else
                ret = _[i].slick[opt].apply(_[i].slick, args);
            if (typeof ret != 'undefined') return ret;
        }
        return _;
    };

}));

},{"jquery":"jquery"}],1189:[function(require,module,exports){
/* -*- Mode: js; js-indent-level: 2; -*- */
/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

var util = require('./util');
var has = Object.prototype.hasOwnProperty;
var hasNativeMap = typeof Map !== "undefined";

/**
 * A data structure which is a combination of an array and a set. Adding a new
 * member is O(1), testing for membership is O(1), and finding the index of an
 * element is O(1). Removing elements from the set is not supported. Only
 * strings are supported for membership.
 */
function ArraySet() {
  this._array = [];
  this._set = hasNativeMap ? new Map() : Object.create(null);
}

/**
 * Static method for creating ArraySet instances from an existing array.
 */
ArraySet.fromArray = function ArraySet_fromArray(aArray, aAllowDuplicates) {
  var set = new ArraySet();
  for (var i = 0, len = aArray.length; i < len; i++) {
    set.add(aArray[i], aAllowDuplicates);
  }
  return set;
};

/**
 * Return how many unique items are in this ArraySet. If duplicates have been
 * added, than those do not count towards the size.
 *
 * @returns Number
 */
ArraySet.prototype.size = function ArraySet_size() {
  return hasNativeMap ? this._set.size : Object.getOwnPropertyNames(this._set).length;
};

/**
 * Add the given string to this set.
 *
 * @param String aStr
 */
ArraySet.prototype.add = function ArraySet_add(aStr, aAllowDuplicates) {
  var sStr = hasNativeMap ? aStr : util.toSetString(aStr);
  var isDuplicate = hasNativeMap ? this.has(aStr) : has.call(this._set, sStr);
  var idx = this._array.length;
  if (!isDuplicate || aAllowDuplicates) {
    this._array.push(aStr);
  }
  if (!isDuplicate) {
    if (hasNativeMap) {
      this._set.set(aStr, idx);
    } else {
      this._set[sStr] = idx;
    }
  }
};

/**
 * Is the given string a member of this set?
 *
 * @param String aStr
 */
ArraySet.prototype.has = function ArraySet_has(aStr) {
  if (hasNativeMap) {
    return this._set.has(aStr);
  } else {
    var sStr = util.toSetString(aStr);
    return has.call(this._set, sStr);
  }
};

/**
 * What is the index of the given string in the array?
 *
 * @param String aStr
 */
ArraySet.prototype.indexOf = function ArraySet_indexOf(aStr) {
  if (hasNativeMap) {
    var idx = this._set.get(aStr);
    if (idx >= 0) {
        return idx;
    }
  } else {
    var sStr = util.toSetString(aStr);
    if (has.call(this._set, sStr)) {
      return this._set[sStr];
    }
  }

  throw new Error('"' + aStr + '" is not in the set.');
};

/**
 * What is the element at the given index?
 *
 * @param Number aIdx
 */
ArraySet.prototype.at = function ArraySet_at(aIdx) {
  if (aIdx >= 0 && aIdx < this._array.length) {
    return this._array[aIdx];
  }
  throw new Error('No element indexed by ' + aIdx);
};

/**
 * Returns the array representation of this set (which has the proper indices
 * indicated by indexOf). Note that this is a copy of the internal array used
 * for storing the members so that no one can mess with internal state.
 */
ArraySet.prototype.toArray = function ArraySet_toArray() {
  return this._array.slice();
};

exports.ArraySet = ArraySet;

},{"./util":1198}],1190:[function(require,module,exports){
/* -*- Mode: js; js-indent-level: 2; -*- */
/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 *
 * Based on the Base 64 VLQ implementation in Closure Compiler:
 * https://code.google.com/p/closure-compiler/source/browse/trunk/src/com/google/debugging/sourcemap/Base64VLQ.java
 *
 * Copyright 2011 The Closure Compiler Authors. All rights reserved.
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 *  * Redistributions of source code must retain the above copyright
 *    notice, this list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above
 *    copyright notice, this list of conditions and the following
 *    disclaimer in the documentation and/or other materials provided
 *    with the distribution.
 *  * Neither the name of Google Inc. nor the names of its
 *    contributors may be used to endorse or promote products derived
 *    from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 * LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
 * THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */

var base64 = require('./base64');

// A single base 64 digit can contain 6 bits of data. For the base 64 variable
// length quantities we use in the source map spec, the first bit is the sign,
// the next four bits are the actual value, and the 6th bit is the
// continuation bit. The continuation bit tells us whether there are more
// digits in this value following this digit.
//
//   Continuation
//   |    Sign
//   |    |
//   V    V
//   101011

var VLQ_BASE_SHIFT = 5;

// binary: 100000
var VLQ_BASE = 1 << VLQ_BASE_SHIFT;

// binary: 011111
var VLQ_BASE_MASK = VLQ_BASE - 1;

// binary: 100000
var VLQ_CONTINUATION_BIT = VLQ_BASE;

/**
 * Converts from a two-complement value to a value where the sign bit is
 * placed in the least significant bit.  For example, as decimals:
 *   1 becomes 2 (10 binary), -1 becomes 3 (11 binary)
 *   2 becomes 4 (100 binary), -2 becomes 5 (101 binary)
 */
function toVLQSigned(aValue) {
  return aValue < 0
    ? ((-aValue) << 1) + 1
    : (aValue << 1) + 0;
}

/**
 * Converts to a two-complement value from a value where the sign bit is
 * placed in the least significant bit.  For example, as decimals:
 *   2 (10 binary) becomes 1, 3 (11 binary) becomes -1
 *   4 (100 binary) becomes 2, 5 (101 binary) becomes -2
 */
function fromVLQSigned(aValue) {
  var isNegative = (aValue & 1) === 1;
  var shifted = aValue >> 1;
  return isNegative
    ? -shifted
    : shifted;
}

/**
 * Returns the base 64 VLQ encoded value.
 */
exports.encode = function base64VLQ_encode(aValue) {
  var encoded = "";
  var digit;

  var vlq = toVLQSigned(aValue);

  do {
    digit = vlq & VLQ_BASE_MASK;
    vlq >>>= VLQ_BASE_SHIFT;
    if (vlq > 0) {
      // There are still more digits in this value, so we must make sure the
      // continuation bit is marked.
      digit |= VLQ_CONTINUATION_BIT;
    }
    encoded += base64.encode(digit);
  } while (vlq > 0);

  return encoded;
};

/**
 * Decodes the next base 64 VLQ value from the given string and returns the
 * value and the rest of the string via the out parameter.
 */
exports.decode = function base64VLQ_decode(aStr, aIndex, aOutParam) {
  var strLen = aStr.length;
  var result = 0;
  var shift = 0;
  var continuation, digit;

  do {
    if (aIndex >= strLen) {
      throw new Error("Expected more digits in base 64 VLQ value.");
    }

    digit = base64.decode(aStr.charCodeAt(aIndex++));
    if (digit === -1) {
      throw new Error("Invalid base64 digit: " + aStr.charAt(aIndex - 1));
    }

    continuation = !!(digit & VLQ_CONTINUATION_BIT);
    digit &= VLQ_BASE_MASK;
    result = result + (digit << shift);
    shift += VLQ_BASE_SHIFT;
  } while (continuation);

  aOutParam.value = fromVLQSigned(result);
  aOutParam.rest = aIndex;
};

},{"./base64":1191}],1191:[function(require,module,exports){
/* -*- Mode: js; js-indent-level: 2; -*- */
/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

var intToCharMap = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'.split('');

/**
 * Encode an integer in the range of 0 to 63 to a single base 64 digit.
 */
exports.encode = function (number) {
  if (0 <= number && number < intToCharMap.length) {
    return intToCharMap[number];
  }
  throw new TypeError("Must be between 0 and 63: " + number);
};

/**
 * Decode a single base 64 character code digit to an integer. Returns -1 on
 * failure.
 */
exports.decode = function (charCode) {
  var bigA = 65;     // 'A'
  var bigZ = 90;     // 'Z'

  var littleA = 97;  // 'a'
  var littleZ = 122; // 'z'

  var zero = 48;     // '0'
  var nine = 57;     // '9'

  var plus = 43;     // '+'
  var slash = 47;    // '/'

  var littleOffset = 26;
  var numberOffset = 52;

  // 0 - 25: ABCDEFGHIJKLMNOPQRSTUVWXYZ
  if (bigA <= charCode && charCode <= bigZ) {
    return (charCode - bigA);
  }

  // 26 - 51: abcdefghijklmnopqrstuvwxyz
  if (littleA <= charCode && charCode <= littleZ) {
    return (charCode - littleA + littleOffset);
  }

  // 52 - 61: 0123456789
  if (zero <= charCode && charCode <= nine) {
    return (charCode - zero + numberOffset);
  }

  // 62: +
  if (charCode == plus) {
    return 62;
  }

  // 63: /
  if (charCode == slash) {
    return 63;
  }

  // Invalid base64 digit.
  return -1;
};

},{}],1192:[function(require,module,exports){
/* -*- Mode: js; js-indent-level: 2; -*- */
/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

exports.GREATEST_LOWER_BOUND = 1;
exports.LEAST_UPPER_BOUND = 2;

/**
 * Recursive implementation of binary search.
 *
 * @param aLow Indices here and lower do not contain the needle.
 * @param aHigh Indices here and higher do not contain the needle.
 * @param aNeedle The element being searched for.
 * @param aHaystack The non-empty array being searched.
 * @param aCompare Function which takes two elements and returns -1, 0, or 1.
 * @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
 *     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 */
function recursiveSearch(aLow, aHigh, aNeedle, aHaystack, aCompare, aBias) {
  // This function terminates when one of the following is true:
  //
  //   1. We find the exact element we are looking for.
  //
  //   2. We did not find the exact element, but we can return the index of
  //      the next-closest element.
  //
  //   3. We did not find the exact element, and there is no next-closest
  //      element than the one we are searching for, so we return -1.
  var mid = Math.floor((aHigh - aLow) / 2) + aLow;
  var cmp = aCompare(aNeedle, aHaystack[mid], true);
  if (cmp === 0) {
    // Found the element we are looking for.
    return mid;
  }
  else if (cmp > 0) {
    // Our needle is greater than aHaystack[mid].
    if (aHigh - mid > 1) {
      // The element is in the upper half.
      return recursiveSearch(mid, aHigh, aNeedle, aHaystack, aCompare, aBias);
    }

    // The exact needle element was not found in this haystack. Determine if
    // we are in termination case (3) or (2) and return the appropriate thing.
    if (aBias == exports.LEAST_UPPER_BOUND) {
      return aHigh < aHaystack.length ? aHigh : -1;
    } else {
      return mid;
    }
  }
  else {
    // Our needle is less than aHaystack[mid].
    if (mid - aLow > 1) {
      // The element is in the lower half.
      return recursiveSearch(aLow, mid, aNeedle, aHaystack, aCompare, aBias);
    }

    // we are in termination case (3) or (2) and return the appropriate thing.
    if (aBias == exports.LEAST_UPPER_BOUND) {
      return mid;
    } else {
      return aLow < 0 ? -1 : aLow;
    }
  }
}

/**
 * This is an implementation of binary search which will always try and return
 * the index of the closest element if there is no exact hit. This is because
 * mappings between original and generated line/col pairs are single points,
 * and there is an implicit region between each of them, so a miss just means
 * that you aren't on the very start of a region.
 *
 * @param aNeedle The element you are looking for.
 * @param aHaystack The array that is being searched.
 * @param aCompare A function which takes the needle and an element in the
 *     array and returns -1, 0, or 1 depending on whether the needle is less
 *     than, equal to, or greater than the element, respectively.
 * @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
 *     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 *     Defaults to 'binarySearch.GREATEST_LOWER_BOUND'.
 */
exports.search = function search(aNeedle, aHaystack, aCompare, aBias) {
  if (aHaystack.length === 0) {
    return -1;
  }

  var index = recursiveSearch(-1, aHaystack.length, aNeedle, aHaystack,
                              aCompare, aBias || exports.GREATEST_LOWER_BOUND);
  if (index < 0) {
    return -1;
  }

  // We have found either the exact element, or the next-closest element than
  // the one we are searching for. However, there may be more than one such
  // element. Make sure we always return the smallest of these.
  while (index - 1 >= 0) {
    if (aCompare(aHaystack[index], aHaystack[index - 1], true) !== 0) {
      break;
    }
    --index;
  }

  return index;
};

},{}],1193:[function(require,module,exports){
/* -*- Mode: js; js-indent-level: 2; -*- */
/*
 * Copyright 2014 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

var util = require('./util');

/**
 * Determine whether mappingB is after mappingA with respect to generated
 * position.
 */
function generatedPositionAfter(mappingA, mappingB) {
  // Optimized for most common case
  var lineA = mappingA.generatedLine;
  var lineB = mappingB.generatedLine;
  var columnA = mappingA.generatedColumn;
  var columnB = mappingB.generatedColumn;
  return lineB > lineA || lineB == lineA && columnB >= columnA ||
         util.compareByGeneratedPositionsInflated(mappingA, mappingB) <= 0;
}

/**
 * A data structure to provide a sorted view of accumulated mappings in a
 * performance conscious manner. It trades a neglibable overhead in general
 * case for a large speedup in case of mappings being added in order.
 */
function MappingList() {
  this._array = [];
  this._sorted = true;
  // Serves as infimum
  this._last = {generatedLine: -1, generatedColumn: 0};
}

/**
 * Iterate through internal items. This method takes the same arguments that
 * `Array.prototype.forEach` takes.
 *
 * NOTE: The order of the mappings is NOT guaranteed.
 */
MappingList.prototype.unsortedForEach =
  function MappingList_forEach(aCallback, aThisArg) {
    this._array.forEach(aCallback, aThisArg);
  };

/**
 * Add the given source mapping.
 *
 * @param Object aMapping
 */
MappingList.prototype.add = function MappingList_add(aMapping) {
  if (generatedPositionAfter(this._last, aMapping)) {
    this._last = aMapping;
    this._array.push(aMapping);
  } else {
    this._sorted = false;
    this._array.push(aMapping);
  }
};

/**
 * Returns the flat, sorted array of mappings. The mappings are sorted by
 * generated position.
 *
 * WARNING: This method returns internal data without copying, for
 * performance. The return value must NOT be mutated, and should be treated as
 * an immutable borrow. If you want to take ownership, you must make your own
 * copy.
 */
MappingList.prototype.toArray = function MappingList_toArray() {
  if (!this._sorted) {
    this._array.sort(util.compareByGeneratedPositionsInflated);
    this._sorted = true;
  }
  return this._array;
};

exports.MappingList = MappingList;

},{"./util":1198}],1194:[function(require,module,exports){
/* -*- Mode: js; js-indent-level: 2; -*- */
/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

// It turns out that some (most?) JavaScript engines don't self-host
// `Array.prototype.sort`. This makes sense because C++ will likely remain
// faster than JS when doing raw CPU-intensive sorting. However, when using a
// custom comparator function, calling back and forth between the VM's C++ and
// JIT'd JS is rather slow *and* loses JIT type information, resulting in
// worse generated code for the comparator function than would be optimal. In
// fact, when sorting with a comparator, these costs outweigh the benefits of
// sorting in C++. By using our own JS-implemented Quick Sort (below), we get
// a ~3500ms mean speed-up in `bench/bench.html`.

/**
 * Swap the elements indexed by `x` and `y` in the array `ary`.
 *
 * @param {Array} ary
 *        The array.
 * @param {Number} x
 *        The index of the first item.
 * @param {Number} y
 *        The index of the second item.
 */
function swap(ary, x, y) {
  var temp = ary[x];
  ary[x] = ary[y];
  ary[y] = temp;
}

/**
 * Returns a random integer within the range `low .. high` inclusive.
 *
 * @param {Number} low
 *        The lower bound on the range.
 * @param {Number} high
 *        The upper bound on the range.
 */
function randomIntInRange(low, high) {
  return Math.round(low + (Math.random() * (high - low)));
}

/**
 * The Quick Sort algorithm.
 *
 * @param {Array} ary
 *        An array to sort.
 * @param {function} comparator
 *        Function to use to compare two items.
 * @param {Number} p
 *        Start index of the array
 * @param {Number} r
 *        End index of the array
 */
function doQuickSort(ary, comparator, p, r) {
  // If our lower bound is less than our upper bound, we (1) partition the
  // array into two pieces and (2) recurse on each half. If it is not, this is
  // the empty array and our base case.

  if (p < r) {
    // (1) Partitioning.
    //
    // The partitioning chooses a pivot between `p` and `r` and moves all
    // elements that are less than or equal to the pivot to the before it, and
    // all the elements that are greater than it after it. The effect is that
    // once partition is done, the pivot is in the exact place it will be when
    // the array is put in sorted order, and it will not need to be moved
    // again. This runs in O(n) time.

    // Always choose a random pivot so that an input array which is reverse
    // sorted does not cause O(n^2) running time.
    var pivotIndex = randomIntInRange(p, r);
    var i = p - 1;

    swap(ary, pivotIndex, r);
    var pivot = ary[r];

    // Immediately after `j` is incremented in this loop, the following hold
    // true:
    //
    //   * Every element in `ary[p .. i]` is less than or equal to the pivot.
    //
    //   * Every element in `ary[i+1 .. j-1]` is greater than the pivot.
    for (var j = p; j < r; j++) {
      if (comparator(ary[j], pivot) <= 0) {
        i += 1;
        swap(ary, i, j);
      }
    }

    swap(ary, i + 1, j);
    var q = i + 1;

    // (2) Recurse on each half.

    doQuickSort(ary, comparator, p, q - 1);
    doQuickSort(ary, comparator, q + 1, r);
  }
}

/**
 * Sort the given array in-place with the given comparator function.
 *
 * @param {Array} ary
 *        An array to sort.
 * @param {function} comparator
 *        Function to use to compare two items.
 */
exports.quickSort = function (ary, comparator) {
  doQuickSort(ary, comparator, 0, ary.length - 1);
};

},{}],1195:[function(require,module,exports){
/* -*- Mode: js; js-indent-level: 2; -*- */
/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

var util = require('./util');
var binarySearch = require('./binary-search');
var ArraySet = require('./array-set').ArraySet;
var base64VLQ = require('./base64-vlq');
var quickSort = require('./quick-sort').quickSort;

function SourceMapConsumer(aSourceMap, aSourceMapURL) {
  var sourceMap = aSourceMap;
  if (typeof aSourceMap === 'string') {
    sourceMap = util.parseSourceMapInput(aSourceMap);
  }

  return sourceMap.sections != null
    ? new IndexedSourceMapConsumer(sourceMap, aSourceMapURL)
    : new BasicSourceMapConsumer(sourceMap, aSourceMapURL);
}

SourceMapConsumer.fromSourceMap = function(aSourceMap, aSourceMapURL) {
  return BasicSourceMapConsumer.fromSourceMap(aSourceMap, aSourceMapURL);
}

/**
 * The version of the source mapping spec that we are consuming.
 */
SourceMapConsumer.prototype._version = 3;

// `__generatedMappings` and `__originalMappings` are arrays that hold the
// parsed mapping coordinates from the source map's "mappings" attribute. They
// are lazily instantiated, accessed via the `_generatedMappings` and
// `_originalMappings` getters respectively, and we only parse the mappings
// and create these arrays once queried for a source location. We jump through
// these hoops because there can be many thousands of mappings, and parsing
// them is expensive, so we only want to do it if we must.
//
// Each object in the arrays is of the form:
//
//     {
//       generatedLine: The line number in the generated code,
//       generatedColumn: The column number in the generated code,
//       source: The path to the original source file that generated this
//               chunk of code,
//       originalLine: The line number in the original source that
//                     corresponds to this chunk of generated code,
//       originalColumn: The column number in the original source that
//                       corresponds to this chunk of generated code,
//       name: The name of the original symbol which generated this chunk of
//             code.
//     }
//
// All properties except for `generatedLine` and `generatedColumn` can be
// `null`.
//
// `_generatedMappings` is ordered by the generated positions.
//
// `_originalMappings` is ordered by the original positions.

SourceMapConsumer.prototype.__generatedMappings = null;
Object.defineProperty(SourceMapConsumer.prototype, '_generatedMappings', {
  configurable: true,
  enumerable: true,
  get: function () {
    if (!this.__generatedMappings) {
      this._parseMappings(this._mappings, this.sourceRoot);
    }

    return this.__generatedMappings;
  }
});

SourceMapConsumer.prototype.__originalMappings = null;
Object.defineProperty(SourceMapConsumer.prototype, '_originalMappings', {
  configurable: true,
  enumerable: true,
  get: function () {
    if (!this.__originalMappings) {
      this._parseMappings(this._mappings, this.sourceRoot);
    }

    return this.__originalMappings;
  }
});

SourceMapConsumer.prototype._charIsMappingSeparator =
  function SourceMapConsumer_charIsMappingSeparator(aStr, index) {
    var c = aStr.charAt(index);
    return c === ";" || c === ",";
  };

/**
 * Parse the mappings in a string in to a data structure which we can easily
 * query (the ordered arrays in the `this.__generatedMappings` and
 * `this.__originalMappings` properties).
 */
SourceMapConsumer.prototype._parseMappings =
  function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
    throw new Error("Subclasses must implement _parseMappings");
  };

SourceMapConsumer.GENERATED_ORDER = 1;
SourceMapConsumer.ORIGINAL_ORDER = 2;

SourceMapConsumer.GREATEST_LOWER_BOUND = 1;
SourceMapConsumer.LEAST_UPPER_BOUND = 2;

/**
 * Iterate over each mapping between an original source/line/column and a
 * generated line/column in this source map.
 *
 * @param Function aCallback
 *        The function that is called with each mapping.
 * @param Object aContext
 *        Optional. If specified, this object will be the value of `this` every
 *        time that `aCallback` is called.
 * @param aOrder
 *        Either `SourceMapConsumer.GENERATED_ORDER` or
 *        `SourceMapConsumer.ORIGINAL_ORDER`. Specifies whether you want to
 *        iterate over the mappings sorted by the generated file's line/column
 *        order or the original's source/line/column order, respectively. Defaults to
 *        `SourceMapConsumer.GENERATED_ORDER`.
 */
SourceMapConsumer.prototype.eachMapping =
  function SourceMapConsumer_eachMapping(aCallback, aContext, aOrder) {
    var context = aContext || null;
    var order = aOrder || SourceMapConsumer.GENERATED_ORDER;

    var mappings;
    switch (order) {
    case SourceMapConsumer.GENERATED_ORDER:
      mappings = this._generatedMappings;
      break;
    case SourceMapConsumer.ORIGINAL_ORDER:
      mappings = this._originalMappings;
      break;
    default:
      throw new Error("Unknown order of iteration.");
    }

    var sourceRoot = this.sourceRoot;
    mappings.map(function (mapping) {
      var source = mapping.source === null ? null : this._sources.at(mapping.source);
      source = util.computeSourceURL(sourceRoot, source, this._sourceMapURL);
      return {
        source: source,
        generatedLine: mapping.generatedLine,
        generatedColumn: mapping.generatedColumn,
        originalLine: mapping.originalLine,
        originalColumn: mapping.originalColumn,
        name: mapping.name === null ? null : this._names.at(mapping.name)
      };
    }, this).forEach(aCallback, context);
  };

/**
 * Returns all generated line and column information for the original source,
 * line, and column provided. If no column is provided, returns all mappings
 * corresponding to a either the line we are searching for or the next
 * closest line that has any mappings. Otherwise, returns all mappings
 * corresponding to the given line and either the column we are searching for
 * or the next closest column that has any offsets.
 *
 * The only argument is an object with the following properties:
 *
 *   - source: The filename of the original source.
 *   - line: The line number in the original source.  The line number is 1-based.
 *   - column: Optional. the column number in the original source.
 *    The column number is 0-based.
 *
 * and an array of objects is returned, each with the following properties:
 *
 *   - line: The line number in the generated source, or null.  The
 *    line number is 1-based.
 *   - column: The column number in the generated source, or null.
 *    The column number is 0-based.
 */
SourceMapConsumer.prototype.allGeneratedPositionsFor =
  function SourceMapConsumer_allGeneratedPositionsFor(aArgs) {
    var line = util.getArg(aArgs, 'line');

    // When there is no exact match, BasicSourceMapConsumer.prototype._findMapping
    // returns the index of the closest mapping less than the needle. By
    // setting needle.originalColumn to 0, we thus find the last mapping for
    // the given line, provided such a mapping exists.
    var needle = {
      source: util.getArg(aArgs, 'source'),
      originalLine: line,
      originalColumn: util.getArg(aArgs, 'column', 0)
    };

    needle.source = this._findSourceIndex(needle.source);
    if (needle.source < 0) {
      return [];
    }

    var mappings = [];

    var index = this._findMapping(needle,
                                  this._originalMappings,
                                  "originalLine",
                                  "originalColumn",
                                  util.compareByOriginalPositions,
                                  binarySearch.LEAST_UPPER_BOUND);
    if (index >= 0) {
      var mapping = this._originalMappings[index];

      if (aArgs.column === undefined) {
        var originalLine = mapping.originalLine;

        // Iterate until either we run out of mappings, or we run into
        // a mapping for a different line than the one we found. Since
        // mappings are sorted, this is guaranteed to find all mappings for
        // the line we found.
        while (mapping && mapping.originalLine === originalLine) {
          mappings.push({
            line: util.getArg(mapping, 'generatedLine', null),
            column: util.getArg(mapping, 'generatedColumn', null),
            lastColumn: util.getArg(mapping, 'lastGeneratedColumn', null)
          });

          mapping = this._originalMappings[++index];
        }
      } else {
        var originalColumn = mapping.originalColumn;

        // Iterate until either we run out of mappings, or we run into
        // a mapping for a different line than the one we were searching for.
        // Since mappings are sorted, this is guaranteed to find all mappings for
        // the line we are searching for.
        while (mapping &&
               mapping.originalLine === line &&
               mapping.originalColumn == originalColumn) {
          mappings.push({
            line: util.getArg(mapping, 'generatedLine', null),
            column: util.getArg(mapping, 'generatedColumn', null),
            lastColumn: util.getArg(mapping, 'lastGeneratedColumn', null)
          });

          mapping = this._originalMappings[++index];
        }
      }
    }

    return mappings;
  };

exports.SourceMapConsumer = SourceMapConsumer;

/**
 * A BasicSourceMapConsumer instance represents a parsed source map which we can
 * query for information about the original file positions by giving it a file
 * position in the generated source.
 *
 * The first parameter is the raw source map (either as a JSON string, or
 * already parsed to an object). According to the spec, source maps have the
 * following attributes:
 *
 *   - version: Which version of the source map spec this map is following.
 *   - sources: An array of URLs to the original source files.
 *   - names: An array of identifiers which can be referrenced by individual mappings.
 *   - sourceRoot: Optional. The URL root from which all sources are relative.
 *   - sourcesContent: Optional. An array of contents of the original source files.
 *   - mappings: A string of base64 VLQs which contain the actual mappings.
 *   - file: Optional. The generated file this source map is associated with.
 *
 * Here is an example source map, taken from the source map spec[0]:
 *
 *     {
 *       version : 3,
 *       file: "out.js",
 *       sourceRoot : "",
 *       sources: ["foo.js", "bar.js"],
 *       names: ["src", "maps", "are", "fun"],
 *       mappings: "AA,AB;;ABCDE;"
 *     }
 *
 * The second parameter, if given, is a string whose value is the URL
 * at which the source map was found.  This URL is used to compute the
 * sources array.
 *
 * [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit?pli=1#
 */
function BasicSourceMapConsumer(aSourceMap, aSourceMapURL) {
  var sourceMap = aSourceMap;
  if (typeof aSourceMap === 'string') {
    sourceMap = util.parseSourceMapInput(aSourceMap);
  }

  var version = util.getArg(sourceMap, 'version');
  var sources = util.getArg(sourceMap, 'sources');
  // Sass 3.3 leaves out the 'names' array, so we deviate from the spec (which
  // requires the array) to play nice here.
  var names = util.getArg(sourceMap, 'names', []);
  var sourceRoot = util.getArg(sourceMap, 'sourceRoot', null);
  var sourcesContent = util.getArg(sourceMap, 'sourcesContent', null);
  var mappings = util.getArg(sourceMap, 'mappings');
  var file = util.getArg(sourceMap, 'file', null);

  // Once again, Sass deviates from the spec and supplies the version as a
  // string rather than a number, so we use loose equality checking here.
  if (version != this._version) {
    throw new Error('Unsupported version: ' + version);
  }

  if (sourceRoot) {
    sourceRoot = util.normalize(sourceRoot);
  }

  sources = sources
    .map(String)
    // Some source maps produce relative source paths like "./foo.js" instead of
    // "foo.js".  Normalize these first so that future comparisons will succeed.
    // See bugzil.la/1090768.
    .map(util.normalize)
    // Always ensure that absolute sources are internally stored relative to
    // the source root, if the source root is absolute. Not doing this would
    // be particularly problematic when the source root is a prefix of the
    // source (valid, but why??). See github issue #199 and bugzil.la/1188982.
    .map(function (source) {
      return sourceRoot && util.isAbsolute(sourceRoot) && util.isAbsolute(source)
        ? util.relative(sourceRoot, source)
        : source;
    });

  // Pass `true` below to allow duplicate names and sources. While source maps
  // are intended to be compressed and deduplicated, the TypeScript compiler
  // sometimes generates source maps with duplicates in them. See Github issue
  // #72 and bugzil.la/889492.
  this._names = ArraySet.fromArray(names.map(String), true);
  this._sources = ArraySet.fromArray(sources, true);

  this._absoluteSources = this._sources.toArray().map(function (s) {
    return util.computeSourceURL(sourceRoot, s, aSourceMapURL);
  });

  this.sourceRoot = sourceRoot;
  this.sourcesContent = sourcesContent;
  this._mappings = mappings;
  this._sourceMapURL = aSourceMapURL;
  this.file = file;
}

BasicSourceMapConsumer.prototype = Object.create(SourceMapConsumer.prototype);
BasicSourceMapConsumer.prototype.consumer = SourceMapConsumer;

/**
 * Utility function to find the index of a source.  Returns -1 if not
 * found.
 */
BasicSourceMapConsumer.prototype._findSourceIndex = function(aSource) {
  var relativeSource = aSource;
  if (this.sourceRoot != null) {
    relativeSource = util.relative(this.sourceRoot, relativeSource);
  }

  if (this._sources.has(relativeSource)) {
    return this._sources.indexOf(relativeSource);
  }

  // Maybe aSource is an absolute URL as returned by |sources|.  In
  // this case we can't simply undo the transform.
  var i;
  for (i = 0; i < this._absoluteSources.length; ++i) {
    if (this._absoluteSources[i] == aSource) {
      return i;
    }
  }

  return -1;
};

/**
 * Create a BasicSourceMapConsumer from a SourceMapGenerator.
 *
 * @param SourceMapGenerator aSourceMap
 *        The source map that will be consumed.
 * @param String aSourceMapURL
 *        The URL at which the source map can be found (optional)
 * @returns BasicSourceMapConsumer
 */
BasicSourceMapConsumer.fromSourceMap =
  function SourceMapConsumer_fromSourceMap(aSourceMap, aSourceMapURL) {
    var smc = Object.create(BasicSourceMapConsumer.prototype);

    var names = smc._names = ArraySet.fromArray(aSourceMap._names.toArray(), true);
    var sources = smc._sources = ArraySet.fromArray(aSourceMap._sources.toArray(), true);
    smc.sourceRoot = aSourceMap._sourceRoot;
    smc.sourcesContent = aSourceMap._generateSourcesContent(smc._sources.toArray(),
                                                            smc.sourceRoot);
    smc.file = aSourceMap._file;
    smc._sourceMapURL = aSourceMapURL;
    smc._absoluteSources = smc._sources.toArray().map(function (s) {
      return util.computeSourceURL(smc.sourceRoot, s, aSourceMapURL);
    });

    // Because we are modifying the entries (by converting string sources and
    // names to indices into the sources and names ArraySets), we have to make
    // a copy of the entry or else bad things happen. Shared mutable state
    // strikes again! See github issue #191.

    var generatedMappings = aSourceMap._mappings.toArray().slice();
    var destGeneratedMappings = smc.__generatedMappings = [];
    var destOriginalMappings = smc.__originalMappings = [];

    for (var i = 0, length = generatedMappings.length; i < length; i++) {
      var srcMapping = generatedMappings[i];
      var destMapping = new Mapping;
      destMapping.generatedLine = srcMapping.generatedLine;
      destMapping.generatedColumn = srcMapping.generatedColumn;

      if (srcMapping.source) {
        destMapping.source = sources.indexOf(srcMapping.source);
        destMapping.originalLine = srcMapping.originalLine;
        destMapping.originalColumn = srcMapping.originalColumn;

        if (srcMapping.name) {
          destMapping.name = names.indexOf(srcMapping.name);
        }

        destOriginalMappings.push(destMapping);
      }

      destGeneratedMappings.push(destMapping);
    }

    quickSort(smc.__originalMappings, util.compareByOriginalPositions);

    return smc;
  };

/**
 * The version of the source mapping spec that we are consuming.
 */
BasicSourceMapConsumer.prototype._version = 3;

/**
 * The list of original sources.
 */
Object.defineProperty(BasicSourceMapConsumer.prototype, 'sources', {
  get: function () {
    return this._absoluteSources.slice();
  }
});

/**
 * Provide the JIT with a nice shape / hidden class.
 */
function Mapping() {
  this.generatedLine = 0;
  this.generatedColumn = 0;
  this.source = null;
  this.originalLine = null;
  this.originalColumn = null;
  this.name = null;
}

/**
 * Parse the mappings in a string in to a data structure which we can easily
 * query (the ordered arrays in the `this.__generatedMappings` and
 * `this.__originalMappings` properties).
 */
BasicSourceMapConsumer.prototype._parseMappings =
  function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
    var generatedLine = 1;
    var previousGeneratedColumn = 0;
    var previousOriginalLine = 0;
    var previousOriginalColumn = 0;
    var previousSource = 0;
    var previousName = 0;
    var length = aStr.length;
    var index = 0;
    var cachedSegments = {};
    var temp = {};
    var originalMappings = [];
    var generatedMappings = [];
    var mapping, str, segment, end, value;

    while (index < length) {
      if (aStr.charAt(index) === ';') {
        generatedLine++;
        index++;
        previousGeneratedColumn = 0;
      }
      else if (aStr.charAt(index) === ',') {
        index++;
      }
      else {
        mapping = new Mapping();
        mapping.generatedLine = generatedLine;

        // Because each offset is encoded relative to the previous one,
        // many segments often have the same encoding. We can exploit this
        // fact by caching the parsed variable length fields of each segment,
        // allowing us to avoid a second parse if we encounter the same
        // segment again.
        for (end = index; end < length; end++) {
          if (this._charIsMappingSeparator(aStr, end)) {
            break;
          }
        }
        str = aStr.slice(index, end);

        segment = cachedSegments[str];
        if (segment) {
          index += str.length;
        } else {
          segment = [];
          while (index < end) {
            base64VLQ.decode(aStr, index, temp);
            value = temp.value;
            index = temp.rest;
            segment.push(value);
          }

          if (segment.length === 2) {
            throw new Error('Found a source, but no line and column');
          }

          if (segment.length === 3) {
            throw new Error('Found a source and line, but no column');
          }

          cachedSegments[str] = segment;
        }

        // Generated column.
        mapping.generatedColumn = previousGeneratedColumn + segment[0];
        previousGeneratedColumn = mapping.generatedColumn;

        if (segment.length > 1) {
          // Original source.
          mapping.source = previousSource + segment[1];
          previousSource += segment[1];

          // Original line.
          mapping.originalLine = previousOriginalLine + segment[2];
          previousOriginalLine = mapping.originalLine;
          // Lines are stored 0-based
          mapping.originalLine += 1;

          // Original column.
          mapping.originalColumn = previousOriginalColumn + segment[3];
          previousOriginalColumn = mapping.originalColumn;

          if (segment.length > 4) {
            // Original name.
            mapping.name = previousName + segment[4];
            previousName += segment[4];
          }
        }

        generatedMappings.push(mapping);
        if (typeof mapping.originalLine === 'number') {
          originalMappings.push(mapping);
        }
      }
    }

    quickSort(generatedMappings, util.compareByGeneratedPositionsDeflated);
    this.__generatedMappings = generatedMappings;

    quickSort(originalMappings, util.compareByOriginalPositions);
    this.__originalMappings = originalMappings;
  };

/**
 * Find the mapping that best matches the hypothetical "needle" mapping that
 * we are searching for in the given "haystack" of mappings.
 */
BasicSourceMapConsumer.prototype._findMapping =
  function SourceMapConsumer_findMapping(aNeedle, aMappings, aLineName,
                                         aColumnName, aComparator, aBias) {
    // To return the position we are searching for, we must first find the
    // mapping for the given position and then return the opposite position it
    // points to. Because the mappings are sorted, we can use binary search to
    // find the best mapping.

    if (aNeedle[aLineName] <= 0) {
      throw new TypeError('Line must be greater than or equal to 1, got '
                          + aNeedle[aLineName]);
    }
    if (aNeedle[aColumnName] < 0) {
      throw new TypeError('Column must be greater than or equal to 0, got '
                          + aNeedle[aColumnName]);
    }

    return binarySearch.search(aNeedle, aMappings, aComparator, aBias);
  };

/**
 * Compute the last column for each generated mapping. The last column is
 * inclusive.
 */
BasicSourceMapConsumer.prototype.computeColumnSpans =
  function SourceMapConsumer_computeColumnSpans() {
    for (var index = 0; index < this._generatedMappings.length; ++index) {
      var mapping = this._generatedMappings[index];

      // Mappings do not contain a field for the last generated columnt. We
      // can come up with an optimistic estimate, however, by assuming that
      // mappings are contiguous (i.e. given two consecutive mappings, the
      // first mapping ends where the second one starts).
      if (index + 1 < this._generatedMappings.length) {
        var nextMapping = this._generatedMappings[index + 1];

        if (mapping.generatedLine === nextMapping.generatedLine) {
          mapping.lastGeneratedColumn = nextMapping.generatedColumn - 1;
          continue;
        }
      }

      // The last mapping for each line spans the entire line.
      mapping.lastGeneratedColumn = Infinity;
    }
  };

/**
 * Returns the original source, line, and column information for the generated
 * source's line and column positions provided. The only argument is an object
 * with the following properties:
 *
 *   - line: The line number in the generated source.  The line number
 *     is 1-based.
 *   - column: The column number in the generated source.  The column
 *     number is 0-based.
 *   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
 *     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 *     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
 *
 * and an object is returned with the following properties:
 *
 *   - source: The original source file, or null.
 *   - line: The line number in the original source, or null.  The
 *     line number is 1-based.
 *   - column: The column number in the original source, or null.  The
 *     column number is 0-based.
 *   - name: The original identifier, or null.
 */
BasicSourceMapConsumer.prototype.originalPositionFor =
  function SourceMapConsumer_originalPositionFor(aArgs) {
    var needle = {
      generatedLine: util.getArg(aArgs, 'line'),
      generatedColumn: util.getArg(aArgs, 'column')
    };

    var index = this._findMapping(
      needle,
      this._generatedMappings,
      "generatedLine",
      "generatedColumn",
      util.compareByGeneratedPositionsDeflated,
      util.getArg(aArgs, 'bias', SourceMapConsumer.GREATEST_LOWER_BOUND)
    );

    if (index >= 0) {
      var mapping = this._generatedMappings[index];

      if (mapping.generatedLine === needle.generatedLine) {
        var source = util.getArg(mapping, 'source', null);
        if (source !== null) {
          source = this._sources.at(source);
          source = util.computeSourceURL(this.sourceRoot, source, this._sourceMapURL);
        }
        var name = util.getArg(mapping, 'name', null);
        if (name !== null) {
          name = this._names.at(name);
        }
        return {
          source: source,
          line: util.getArg(mapping, 'originalLine', null),
          column: util.getArg(mapping, 'originalColumn', null),
          name: name
        };
      }
    }

    return {
      source: null,
      line: null,
      column: null,
      name: null
    };
  };

/**
 * Return true if we have the source content for every source in the source
 * map, false otherwise.
 */
BasicSourceMapConsumer.prototype.hasContentsOfAllSources =
  function BasicSourceMapConsumer_hasContentsOfAllSources() {
    if (!this.sourcesContent) {
      return false;
    }
    return this.sourcesContent.length >= this._sources.size() &&
      !this.sourcesContent.some(function (sc) { return sc == null; });
  };

/**
 * Returns the original source content. The only argument is the url of the
 * original source file. Returns null if no original source content is
 * available.
 */
BasicSourceMapConsumer.prototype.sourceContentFor =
  function SourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
    if (!this.sourcesContent) {
      return null;
    }

    var index = this._findSourceIndex(aSource);
    if (index >= 0) {
      return this.sourcesContent[index];
    }

    var relativeSource = aSource;
    if (this.sourceRoot != null) {
      relativeSource = util.relative(this.sourceRoot, relativeSource);
    }

    var url;
    if (this.sourceRoot != null
        && (url = util.urlParse(this.sourceRoot))) {
      // XXX: file:// URIs and absolute paths lead to unexpected behavior for
      // many users. We can help them out when they expect file:// URIs to
      // behave like it would if they were running a local HTTP server. See
      // https://bugzilla.mozilla.org/show_bug.cgi?id=885597.
      var fileUriAbsPath = relativeSource.replace(/^file:\/\//, "");
      if (url.scheme == "file"
          && this._sources.has(fileUriAbsPath)) {
        return this.sourcesContent[this._sources.indexOf(fileUriAbsPath)]
      }

      if ((!url.path || url.path == "/")
          && this._sources.has("/" + relativeSource)) {
        return this.sourcesContent[this._sources.indexOf("/" + relativeSource)];
      }
    }

    // This function is used recursively from
    // IndexedSourceMapConsumer.prototype.sourceContentFor. In that case, we
    // don't want to throw if we can't find the source - we just want to
    // return null, so we provide a flag to exit gracefully.
    if (nullOnMissing) {
      return null;
    }
    else {
      throw new Error('"' + relativeSource + '" is not in the SourceMap.');
    }
  };

/**
 * Returns the generated line and column information for the original source,
 * line, and column positions provided. The only argument is an object with
 * the following properties:
 *
 *   - source: The filename of the original source.
 *   - line: The line number in the original source.  The line number
 *     is 1-based.
 *   - column: The column number in the original source.  The column
 *     number is 0-based.
 *   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
 *     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 *     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
 *
 * and an object is returned with the following properties:
 *
 *   - line: The line number in the generated source, or null.  The
 *     line number is 1-based.
 *   - column: The column number in the generated source, or null.
 *     The column number is 0-based.
 */
BasicSourceMapConsumer.prototype.generatedPositionFor =
  function SourceMapConsumer_generatedPositionFor(aArgs) {
    var source = util.getArg(aArgs, 'source');
    source = this._findSourceIndex(source);
    if (source < 0) {
      return {
        line: null,
        column: null,
        lastColumn: null
      };
    }

    var needle = {
      source: source,
      originalLine: util.getArg(aArgs, 'line'),
      originalColumn: util.getArg(aArgs, 'column')
    };

    var index = this._findMapping(
      needle,
      this._originalMappings,
      "originalLine",
      "originalColumn",
      util.compareByOriginalPositions,
      util.getArg(aArgs, 'bias', SourceMapConsumer.GREATEST_LOWER_BOUND)
    );

    if (index >= 0) {
      var mapping = this._originalMappings[index];

      if (mapping.source === needle.source) {
        return {
          line: util.getArg(mapping, 'generatedLine', null),
          column: util.getArg(mapping, 'generatedColumn', null),
          lastColumn: util.getArg(mapping, 'lastGeneratedColumn', null)
        };
      }
    }

    return {
      line: null,
      column: null,
      lastColumn: null
    };
  };

exports.BasicSourceMapConsumer = BasicSourceMapConsumer;

/**
 * An IndexedSourceMapConsumer instance represents a parsed source map which
 * we can query for information. It differs from BasicSourceMapConsumer in
 * that it takes "indexed" source maps (i.e. ones with a "sections" field) as
 * input.
 *
 * The first parameter is a raw source map (either as a JSON string, or already
 * parsed to an object). According to the spec for indexed source maps, they
 * have the following attributes:
 *
 *   - version: Which version of the source map spec this map is following.
 *   - file: Optional. The generated file this source map is associated with.
 *   - sections: A list of section definitions.
 *
 * Each value under the "sections" field has two fields:
 *   - offset: The offset into the original specified at which this section
 *       begins to apply, defined as an object with a "line" and "column"
 *       field.
 *   - map: A source map definition. This source map could also be indexed,
 *       but doesn't have to be.
 *
 * Instead of the "map" field, it's also possible to have a "url" field
 * specifying a URL to retrieve a source map from, but that's currently
 * unsupported.
 *
 * Here's an example source map, taken from the source map spec[0], but
 * modified to omit a section which uses the "url" field.
 *
 *  {
 *    version : 3,
 *    file: "app.js",
 *    sections: [{
 *      offset: {line:100, column:10},
 *      map: {
 *        version : 3,
 *        file: "section.js",
 *        sources: ["foo.js", "bar.js"],
 *        names: ["src", "maps", "are", "fun"],
 *        mappings: "AAAA,E;;ABCDE;"
 *      }
 *    }],
 *  }
 *
 * The second parameter, if given, is a string whose value is the URL
 * at which the source map was found.  This URL is used to compute the
 * sources array.
 *
 * [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit#heading=h.535es3xeprgt
 */
function IndexedSourceMapConsumer(aSourceMap, aSourceMapURL) {
  var sourceMap = aSourceMap;
  if (typeof aSourceMap === 'string') {
    sourceMap = util.parseSourceMapInput(aSourceMap);
  }

  var version = util.getArg(sourceMap, 'version');
  var sections = util.getArg(sourceMap, 'sections');

  if (version != this._version) {
    throw new Error('Unsupported version: ' + version);
  }

  this._sources = new ArraySet();
  this._names = new ArraySet();

  var lastOffset = {
    line: -1,
    column: 0
  };
  this._sections = sections.map(function (s) {
    if (s.url) {
      // The url field will require support for asynchronicity.
      // See https://github.com/mozilla/source-map/issues/16
      throw new Error('Support for url field in sections not implemented.');
    }
    var offset = util.getArg(s, 'offset');
    var offsetLine = util.getArg(offset, 'line');
    var offsetColumn = util.getArg(offset, 'column');

    if (offsetLine < lastOffset.line ||
        (offsetLine === lastOffset.line && offsetColumn < lastOffset.column)) {
      throw new Error('Section offsets must be ordered and non-overlapping.');
    }
    lastOffset = offset;

    return {
      generatedOffset: {
        // The offset fields are 0-based, but we use 1-based indices when
        // encoding/decoding from VLQ.
        generatedLine: offsetLine + 1,
        generatedColumn: offsetColumn + 1
      },
      consumer: new SourceMapConsumer(util.getArg(s, 'map'), aSourceMapURL)
    }
  });
}

IndexedSourceMapConsumer.prototype = Object.create(SourceMapConsumer.prototype);
IndexedSourceMapConsumer.prototype.constructor = SourceMapConsumer;

/**
 * The version of the source mapping spec that we are consuming.
 */
IndexedSourceMapConsumer.prototype._version = 3;

/**
 * The list of original sources.
 */
Object.defineProperty(IndexedSourceMapConsumer.prototype, 'sources', {
  get: function () {
    var sources = [];
    for (var i = 0; i < this._sections.length; i++) {
      for (var j = 0; j < this._sections[i].consumer.sources.length; j++) {
        sources.push(this._sections[i].consumer.sources[j]);
      }
    }
    return sources;
  }
});

/**
 * Returns the original source, line, and column information for the generated
 * source's line and column positions provided. The only argument is an object
 * with the following properties:
 *
 *   - line: The line number in the generated source.  The line number
 *     is 1-based.
 *   - column: The column number in the generated source.  The column
 *     number is 0-based.
 *
 * and an object is returned with the following properties:
 *
 *   - source: The original source file, or null.
 *   - line: The line number in the original source, or null.  The
 *     line number is 1-based.
 *   - column: The column number in the original source, or null.  The
 *     column number is 0-based.
 *   - name: The original identifier, or null.
 */
IndexedSourceMapConsumer.prototype.originalPositionFor =
  function IndexedSourceMapConsumer_originalPositionFor(aArgs) {
    var needle = {
      generatedLine: util.getArg(aArgs, 'line'),
      generatedColumn: util.getArg(aArgs, 'column')
    };

    // Find the section containing the generated position we're trying to map
    // to an original position.
    var sectionIndex = binarySearch.search(needle, this._sections,
      function(needle, section) {
        var cmp = needle.generatedLine - section.generatedOffset.generatedLine;
        if (cmp) {
          return cmp;
        }

        return (needle.generatedColumn -
                section.generatedOffset.generatedColumn);
      });
    var section = this._sections[sectionIndex];

    if (!section) {
      return {
        source: null,
        line: null,
        column: null,
        name: null
      };
    }

    return section.consumer.originalPositionFor({
      line: needle.generatedLine -
        (section.generatedOffset.generatedLine - 1),
      column: needle.generatedColumn -
        (section.generatedOffset.generatedLine === needle.generatedLine
         ? section.generatedOffset.generatedColumn - 1
         : 0),
      bias: aArgs.bias
    });
  };

/**
 * Return true if we have the source content for every source in the source
 * map, false otherwise.
 */
IndexedSourceMapConsumer.prototype.hasContentsOfAllSources =
  function IndexedSourceMapConsumer_hasContentsOfAllSources() {
    return this._sections.every(function (s) {
      return s.consumer.hasContentsOfAllSources();
    });
  };

/**
 * Returns the original source content. The only argument is the url of the
 * original source file. Returns null if no original source content is
 * available.
 */
IndexedSourceMapConsumer.prototype.sourceContentFor =
  function IndexedSourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
    for (var i = 0; i < this._sections.length; i++) {
      var section = this._sections[i];

      var content = section.consumer.sourceContentFor(aSource, true);
      if (content) {
        return content;
      }
    }
    if (nullOnMissing) {
      return null;
    }
    else {
      throw new Error('"' + aSource + '" is not in the SourceMap.');
    }
  };

/**
 * Returns the generated line and column information for the original source,
 * line, and column positions provided. The only argument is an object with
 * the following properties:
 *
 *   - source: The filename of the original source.
 *   - line: The line number in the original source.  The line number
 *     is 1-based.
 *   - column: The column number in the original source.  The column
 *     number is 0-based.
 *
 * and an object is returned with the following properties:
 *
 *   - line: The line number in the generated source, or null.  The
 *     line number is 1-based. 
 *   - column: The column number in the generated source, or null.
 *     The column number is 0-based.
 */
IndexedSourceMapConsumer.prototype.generatedPositionFor =
  function IndexedSourceMapConsumer_generatedPositionFor(aArgs) {
    for (var i = 0; i < this._sections.length; i++) {
      var section = this._sections[i];

      // Only consider this section if the requested source is in the list of
      // sources of the consumer.
      if (section.consumer._findSourceIndex(util.getArg(aArgs, 'source')) === -1) {
        continue;
      }
      var generatedPosition = section.consumer.generatedPositionFor(aArgs);
      if (generatedPosition) {
        var ret = {
          line: generatedPosition.line +
            (section.generatedOffset.generatedLine - 1),
          column: generatedPosition.column +
            (section.generatedOffset.generatedLine === generatedPosition.line
             ? section.generatedOffset.generatedColumn - 1
             : 0)
        };
        return ret;
      }
    }

    return {
      line: null,
      column: null
    };
  };

/**
 * Parse the mappings in a string in to a data structure which we can easily
 * query (the ordered arrays in the `this.__generatedMappings` and
 * `this.__originalMappings` properties).
 */
IndexedSourceMapConsumer.prototype._parseMappings =
  function IndexedSourceMapConsumer_parseMappings(aStr, aSourceRoot) {
    this.__generatedMappings = [];
    this.__originalMappings = [];
    for (var i = 0; i < this._sections.length; i++) {
      var section = this._sections[i];
      var sectionMappings = section.consumer._generatedMappings;
      for (var j = 0; j < sectionMappings.length; j++) {
        var mapping = sectionMappings[j];

        var source = section.consumer._sources.at(mapping.source);
        source = util.computeSourceURL(section.consumer.sourceRoot, source, this._sourceMapURL);
        this._sources.add(source);
        source = this._sources.indexOf(source);

        var name = null;
        if (mapping.name) {
          name = section.consumer._names.at(mapping.name);
          this._names.add(name);
          name = this._names.indexOf(name);
        }

        // The mappings coming from the consumer for the section have
        // generated positions relative to the start of the section, so we
        // need to offset them to be relative to the start of the concatenated
        // generated file.
        var adjustedMapping = {
          source: source,
          generatedLine: mapping.generatedLine +
            (section.generatedOffset.generatedLine - 1),
          generatedColumn: mapping.generatedColumn +
            (section.generatedOffset.generatedLine === mapping.generatedLine
            ? section.generatedOffset.generatedColumn - 1
            : 0),
          originalLine: mapping.originalLine,
          originalColumn: mapping.originalColumn,
          name: name
        };

        this.__generatedMappings.push(adjustedMapping);
        if (typeof adjustedMapping.originalLine === 'number') {
          this.__originalMappings.push(adjustedMapping);
        }
      }
    }

    quickSort(this.__generatedMappings, util.compareByGeneratedPositionsDeflated);
    quickSort(this.__originalMappings, util.compareByOriginalPositions);
  };

exports.IndexedSourceMapConsumer = IndexedSourceMapConsumer;

},{"./array-set":1189,"./base64-vlq":1190,"./binary-search":1192,"./quick-sort":1194,"./util":1198}],1196:[function(require,module,exports){
/* -*- Mode: js; js-indent-level: 2; -*- */
/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

var base64VLQ = require('./base64-vlq');
var util = require('./util');
var ArraySet = require('./array-set').ArraySet;
var MappingList = require('./mapping-list').MappingList;

/**
 * An instance of the SourceMapGenerator represents a source map which is
 * being built incrementally. You may pass an object with the following
 * properties:
 *
 *   - file: The filename of the generated source.
 *   - sourceRoot: A root for all relative URLs in this source map.
 */
function SourceMapGenerator(aArgs) {
  if (!aArgs) {
    aArgs = {};
  }
  this._file = util.getArg(aArgs, 'file', null);
  this._sourceRoot = util.getArg(aArgs, 'sourceRoot', null);
  this._skipValidation = util.getArg(aArgs, 'skipValidation', false);
  this._sources = new ArraySet();
  this._names = new ArraySet();
  this._mappings = new MappingList();
  this._sourcesContents = null;
}

SourceMapGenerator.prototype._version = 3;

/**
 * Creates a new SourceMapGenerator based on a SourceMapConsumer
 *
 * @param aSourceMapConsumer The SourceMap.
 */
SourceMapGenerator.fromSourceMap =
  function SourceMapGenerator_fromSourceMap(aSourceMapConsumer) {
    var sourceRoot = aSourceMapConsumer.sourceRoot;
    var generator = new SourceMapGenerator({
      file: aSourceMapConsumer.file,
      sourceRoot: sourceRoot
    });
    aSourceMapConsumer.eachMapping(function (mapping) {
      var newMapping = {
        generated: {
          line: mapping.generatedLine,
          column: mapping.generatedColumn
        }
      };

      if (mapping.source != null) {
        newMapping.source = mapping.source;
        if (sourceRoot != null) {
          newMapping.source = util.relative(sourceRoot, newMapping.source);
        }

        newMapping.original = {
          line: mapping.originalLine,
          column: mapping.originalColumn
        };

        if (mapping.name != null) {
          newMapping.name = mapping.name;
        }
      }

      generator.addMapping(newMapping);
    });
    aSourceMapConsumer.sources.forEach(function (sourceFile) {
      var sourceRelative = sourceFile;
      if (sourceRoot !== null) {
        sourceRelative = util.relative(sourceRoot, sourceFile);
      }

      if (!generator._sources.has(sourceRelative)) {
        generator._sources.add(sourceRelative);
      }

      var content = aSourceMapConsumer.sourceContentFor(sourceFile);
      if (content != null) {
        generator.setSourceContent(sourceFile, content);
      }
    });
    return generator;
  };

/**
 * Add a single mapping from original source line and column to the generated
 * source's line and column for this source map being created. The mapping
 * object should have the following properties:
 *
 *   - generated: An object with the generated line and column positions.
 *   - original: An object with the original line and column positions.
 *   - source: The original source file (relative to the sourceRoot).
 *   - name: An optional original token name for this mapping.
 */
SourceMapGenerator.prototype.addMapping =
  function SourceMapGenerator_addMapping(aArgs) {
    var generated = util.getArg(aArgs, 'generated');
    var original = util.getArg(aArgs, 'original', null);
    var source = util.getArg(aArgs, 'source', null);
    var name = util.getArg(aArgs, 'name', null);

    if (!this._skipValidation) {
      this._validateMapping(generated, original, source, name);
    }

    if (source != null) {
      source = String(source);
      if (!this._sources.has(source)) {
        this._sources.add(source);
      }
    }

    if (name != null) {
      name = String(name);
      if (!this._names.has(name)) {
        this._names.add(name);
      }
    }

    this._mappings.add({
      generatedLine: generated.line,
      generatedColumn: generated.column,
      originalLine: original != null && original.line,
      originalColumn: original != null && original.column,
      source: source,
      name: name
    });
  };

/**
 * Set the source content for a source file.
 */
SourceMapGenerator.prototype.setSourceContent =
  function SourceMapGenerator_setSourceContent(aSourceFile, aSourceContent) {
    var source = aSourceFile;
    if (this._sourceRoot != null) {
      source = util.relative(this._sourceRoot, source);
    }

    if (aSourceContent != null) {
      // Add the source content to the _sourcesContents map.
      // Create a new _sourcesContents map if the property is null.
      if (!this._sourcesContents) {
        this._sourcesContents = Object.create(null);
      }
      this._sourcesContents[util.toSetString(source)] = aSourceContent;
    } else if (this._sourcesContents) {
      // Remove the source file from the _sourcesContents map.
      // If the _sourcesContents map is empty, set the property to null.
      delete this._sourcesContents[util.toSetString(source)];
      if (Object.keys(this._sourcesContents).length === 0) {
        this._sourcesContents = null;
      }
    }
  };

/**
 * Applies the mappings of a sub-source-map for a specific source file to the
 * source map being generated. Each mapping to the supplied source file is
 * rewritten using the supplied source map. Note: The resolution for the
 * resulting mappings is the minimium of this map and the supplied map.
 *
 * @param aSourceMapConsumer The source map to be applied.
 * @param aSourceFile Optional. The filename of the source file.
 *        If omitted, SourceMapConsumer's file property will be used.
 * @param aSourceMapPath Optional. The dirname of the path to the source map
 *        to be applied. If relative, it is relative to the SourceMapConsumer.
 *        This parameter is needed when the two source maps aren't in the same
 *        directory, and the source map to be applied contains relative source
 *        paths. If so, those relative source paths need to be rewritten
 *        relative to the SourceMapGenerator.
 */
SourceMapGenerator.prototype.applySourceMap =
  function SourceMapGenerator_applySourceMap(aSourceMapConsumer, aSourceFile, aSourceMapPath) {
    var sourceFile = aSourceFile;
    // If aSourceFile is omitted, we will use the file property of the SourceMap
    if (aSourceFile == null) {
      if (aSourceMapConsumer.file == null) {
        throw new Error(
          'SourceMapGenerator.prototype.applySourceMap requires either an explicit source file, ' +
          'or the source map\'s "file" property. Both were omitted.'
        );
      }
      sourceFile = aSourceMapConsumer.file;
    }
    var sourceRoot = this._sourceRoot;
    // Make "sourceFile" relative if an absolute Url is passed.
    if (sourceRoot != null) {
      sourceFile = util.relative(sourceRoot, sourceFile);
    }
    // Applying the SourceMap can add and remove items from the sources and
    // the names array.
    var newSources = new ArraySet();
    var newNames = new ArraySet();

    // Find mappings for the "sourceFile"
    this._mappings.unsortedForEach(function (mapping) {
      if (mapping.source === sourceFile && mapping.originalLine != null) {
        // Check if it can be mapped by the source map, then update the mapping.
        var original = aSourceMapConsumer.originalPositionFor({
          line: mapping.originalLine,
          column: mapping.originalColumn
        });
        if (original.source != null) {
          // Copy mapping
          mapping.source = original.source;
          if (aSourceMapPath != null) {
            mapping.source = util.join(aSourceMapPath, mapping.source)
          }
          if (sourceRoot != null) {
            mapping.source = util.relative(sourceRoot, mapping.source);
          }
          mapping.originalLine = original.line;
          mapping.originalColumn = original.column;
          if (original.name != null) {
            mapping.name = original.name;
          }
        }
      }

      var source = mapping.source;
      if (source != null && !newSources.has(source)) {
        newSources.add(source);
      }

      var name = mapping.name;
      if (name != null && !newNames.has(name)) {
        newNames.add(name);
      }

    }, this);
    this._sources = newSources;
    this._names = newNames;

    // Copy sourcesContents of applied map.
    aSourceMapConsumer.sources.forEach(function (sourceFile) {
      var content = aSourceMapConsumer.sourceContentFor(sourceFile);
      if (content != null) {
        if (aSourceMapPath != null) {
          sourceFile = util.join(aSourceMapPath, sourceFile);
        }
        if (sourceRoot != null) {
          sourceFile = util.relative(sourceRoot, sourceFile);
        }
        this.setSourceContent(sourceFile, content);
      }
    }, this);
  };

/**
 * A mapping can have one of the three levels of data:
 *
 *   1. Just the generated position.
 *   2. The Generated position, original position, and original source.
 *   3. Generated and original position, original source, as well as a name
 *      token.
 *
 * To maintain consistency, we validate that any new mapping being added falls
 * in to one of these categories.
 */
SourceMapGenerator.prototype._validateMapping =
  function SourceMapGenerator_validateMapping(aGenerated, aOriginal, aSource,
                                              aName) {
    // When aOriginal is truthy but has empty values for .line and .column,
    // it is most likely a programmer error. In this case we throw a very
    // specific error message to try to guide them the right way.
    // For example: https://github.com/Polymer/polymer-bundler/pull/519
    if (aOriginal && typeof aOriginal.line !== 'number' && typeof aOriginal.column !== 'number') {
        throw new Error(
            'original.line and original.column are not numbers -- you probably meant to omit ' +
            'the original mapping entirely and only map the generated position. If so, pass ' +
            'null for the original mapping instead of an object with empty or null values.'
        );
    }

    if (aGenerated && 'line' in aGenerated && 'column' in aGenerated
        && aGenerated.line > 0 && aGenerated.column >= 0
        && !aOriginal && !aSource && !aName) {
      // Case 1.
      return;
    }
    else if (aGenerated && 'line' in aGenerated && 'column' in aGenerated
             && aOriginal && 'line' in aOriginal && 'column' in aOriginal
             && aGenerated.line > 0 && aGenerated.column >= 0
             && aOriginal.line > 0 && aOriginal.column >= 0
             && aSource) {
      // Cases 2 and 3.
      return;
    }
    else {
      throw new Error('Invalid mapping: ' + JSON.stringify({
        generated: aGenerated,
        source: aSource,
        original: aOriginal,
        name: aName
      }));
    }
  };

/**
 * Serialize the accumulated mappings in to the stream of base 64 VLQs
 * specified by the source map format.
 */
SourceMapGenerator.prototype._serializeMappings =
  function SourceMapGenerator_serializeMappings() {
    var previousGeneratedColumn = 0;
    var previousGeneratedLine = 1;
    var previousOriginalColumn = 0;
    var previousOriginalLine = 0;
    var previousName = 0;
    var previousSource = 0;
    var result = '';
    var next;
    var mapping;
    var nameIdx;
    var sourceIdx;

    var mappings = this._mappings.toArray();
    for (var i = 0, len = mappings.length; i < len; i++) {
      mapping = mappings[i];
      next = ''

      if (mapping.generatedLine !== previousGeneratedLine) {
        previousGeneratedColumn = 0;
        while (mapping.generatedLine !== previousGeneratedLine) {
          next += ';';
          previousGeneratedLine++;
        }
      }
      else {
        if (i > 0) {
          if (!util.compareByGeneratedPositionsInflated(mapping, mappings[i - 1])) {
            continue;
          }
          next += ',';
        }
      }

      next += base64VLQ.encode(mapping.generatedColumn
                                 - previousGeneratedColumn);
      previousGeneratedColumn = mapping.generatedColumn;

      if (mapping.source != null) {
        sourceIdx = this._sources.indexOf(mapping.source);
        next += base64VLQ.encode(sourceIdx - previousSource);
        previousSource = sourceIdx;

        // lines are stored 0-based in SourceMap spec version 3
        next += base64VLQ.encode(mapping.originalLine - 1
                                   - previousOriginalLine);
        previousOriginalLine = mapping.originalLine - 1;

        next += base64VLQ.encode(mapping.originalColumn
                                   - previousOriginalColumn);
        previousOriginalColumn = mapping.originalColumn;

        if (mapping.name != null) {
          nameIdx = this._names.indexOf(mapping.name);
          next += base64VLQ.encode(nameIdx - previousName);
          previousName = nameIdx;
        }
      }

      result += next;
    }

    return result;
  };

SourceMapGenerator.prototype._generateSourcesContent =
  function SourceMapGenerator_generateSourcesContent(aSources, aSourceRoot) {
    return aSources.map(function (source) {
      if (!this._sourcesContents) {
        return null;
      }
      if (aSourceRoot != null) {
        source = util.relative(aSourceRoot, source);
      }
      var key = util.toSetString(source);
      return Object.prototype.hasOwnProperty.call(this._sourcesContents, key)
        ? this._sourcesContents[key]
        : null;
    }, this);
  };

/**
 * Externalize the source map.
 */
SourceMapGenerator.prototype.toJSON =
  function SourceMapGenerator_toJSON() {
    var map = {
      version: this._version,
      sources: this._sources.toArray(),
      names: this._names.toArray(),
      mappings: this._serializeMappings()
    };
    if (this._file != null) {
      map.file = this._file;
    }
    if (this._sourceRoot != null) {
      map.sourceRoot = this._sourceRoot;
    }
    if (this._sourcesContents) {
      map.sourcesContent = this._generateSourcesContent(map.sources, map.sourceRoot);
    }

    return map;
  };

/**
 * Render the source map being generated to a string.
 */
SourceMapGenerator.prototype.toString =
  function SourceMapGenerator_toString() {
    return JSON.stringify(this.toJSON());
  };

exports.SourceMapGenerator = SourceMapGenerator;

},{"./array-set":1189,"./base64-vlq":1190,"./mapping-list":1193,"./util":1198}],1197:[function(require,module,exports){
/* -*- Mode: js; js-indent-level: 2; -*- */
/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

var SourceMapGenerator = require('./source-map-generator').SourceMapGenerator;
var util = require('./util');

// Matches a Windows-style `\r\n` newline or a `\n` newline used by all other
// operating systems these days (capturing the result).
var REGEX_NEWLINE = /(\r?\n)/;

// Newline character code for charCodeAt() comparisons
var NEWLINE_CODE = 10;

// Private symbol for identifying `SourceNode`s when multiple versions of
// the source-map library are loaded. This MUST NOT CHANGE across
// versions!
var isSourceNode = "$$$isSourceNode$$$";

/**
 * SourceNodes provide a way to abstract over interpolating/concatenating
 * snippets of generated JavaScript source code while maintaining the line and
 * column information associated with the original source code.
 *
 * @param aLine The original line number.
 * @param aColumn The original column number.
 * @param aSource The original source's filename.
 * @param aChunks Optional. An array of strings which are snippets of
 *        generated JS, or other SourceNodes.
 * @param aName The original identifier.
 */
function SourceNode(aLine, aColumn, aSource, aChunks, aName) {
  this.children = [];
  this.sourceContents = {};
  this.line = aLine == null ? null : aLine;
  this.column = aColumn == null ? null : aColumn;
  this.source = aSource == null ? null : aSource;
  this.name = aName == null ? null : aName;
  this[isSourceNode] = true;
  if (aChunks != null) this.add(aChunks);
}

/**
 * Creates a SourceNode from generated code and a SourceMapConsumer.
 *
 * @param aGeneratedCode The generated code
 * @param aSourceMapConsumer The SourceMap for the generated code
 * @param aRelativePath Optional. The path that relative sources in the
 *        SourceMapConsumer should be relative to.
 */
SourceNode.fromStringWithSourceMap =
  function SourceNode_fromStringWithSourceMap(aGeneratedCode, aSourceMapConsumer, aRelativePath) {
    // The SourceNode we want to fill with the generated code
    // and the SourceMap
    var node = new SourceNode();

    // All even indices of this array are one line of the generated code,
    // while all odd indices are the newlines between two adjacent lines
    // (since `REGEX_NEWLINE` captures its match).
    // Processed fragments are accessed by calling `shiftNextLine`.
    var remainingLines = aGeneratedCode.split(REGEX_NEWLINE);
    var remainingLinesIndex = 0;
    var shiftNextLine = function() {
      var lineContents = getNextLine();
      // The last line of a file might not have a newline.
      var newLine = getNextLine() || "";
      return lineContents + newLine;

      function getNextLine() {
        return remainingLinesIndex < remainingLines.length ?
            remainingLines[remainingLinesIndex++] : undefined;
      }
    };

    // We need to remember the position of "remainingLines"
    var lastGeneratedLine = 1, lastGeneratedColumn = 0;

    // The generate SourceNodes we need a code range.
    // To extract it current and last mapping is used.
    // Here we store the last mapping.
    var lastMapping = null;

    aSourceMapConsumer.eachMapping(function (mapping) {
      if (lastMapping !== null) {
        // We add the code from "lastMapping" to "mapping":
        // First check if there is a new line in between.
        if (lastGeneratedLine < mapping.generatedLine) {
          // Associate first line with "lastMapping"
          addMappingWithCode(lastMapping, shiftNextLine());
          lastGeneratedLine++;
          lastGeneratedColumn = 0;
          // The remaining code is added without mapping
        } else {
          // There is no new line in between.
          // Associate the code between "lastGeneratedColumn" and
          // "mapping.generatedColumn" with "lastMapping"
          var nextLine = remainingLines[remainingLinesIndex] || '';
          var code = nextLine.substr(0, mapping.generatedColumn -
                                        lastGeneratedColumn);
          remainingLines[remainingLinesIndex] = nextLine.substr(mapping.generatedColumn -
                                              lastGeneratedColumn);
          lastGeneratedColumn = mapping.generatedColumn;
          addMappingWithCode(lastMapping, code);
          // No more remaining code, continue
          lastMapping = mapping;
          return;
        }
      }
      // We add the generated code until the first mapping
      // to the SourceNode without any mapping.
      // Each line is added as separate string.
      while (lastGeneratedLine < mapping.generatedLine) {
        node.add(shiftNextLine());
        lastGeneratedLine++;
      }
      if (lastGeneratedColumn < mapping.generatedColumn) {
        var nextLine = remainingLines[remainingLinesIndex] || '';
        node.add(nextLine.substr(0, mapping.generatedColumn));
        remainingLines[remainingLinesIndex] = nextLine.substr(mapping.generatedColumn);
        lastGeneratedColumn = mapping.generatedColumn;
      }
      lastMapping = mapping;
    }, this);
    // We have processed all mappings.
    if (remainingLinesIndex < remainingLines.length) {
      if (lastMapping) {
        // Associate the remaining code in the current line with "lastMapping"
        addMappingWithCode(lastMapping, shiftNextLine());
      }
      // and add the remaining lines without any mapping
      node.add(remainingLines.splice(remainingLinesIndex).join(""));
    }

    // Copy sourcesContent into SourceNode
    aSourceMapConsumer.sources.forEach(function (sourceFile) {
      var content = aSourceMapConsumer.sourceContentFor(sourceFile);
      if (content != null) {
        if (aRelativePath != null) {
          sourceFile = util.join(aRelativePath, sourceFile);
        }
        node.setSourceContent(sourceFile, content);
      }
    });

    return node;

    function addMappingWithCode(mapping, code) {
      if (mapping === null || mapping.source === undefined) {
        node.add(code);
      } else {
        var source = aRelativePath
          ? util.join(aRelativePath, mapping.source)
          : mapping.source;
        node.add(new SourceNode(mapping.originalLine,
                                mapping.originalColumn,
                                source,
                                code,
                                mapping.name));
      }
    }
  };

/**
 * Add a chunk of generated JS to this source node.
 *
 * @param aChunk A string snippet of generated JS code, another instance of
 *        SourceNode, or an array where each member is one of those things.
 */
SourceNode.prototype.add = function SourceNode_add(aChunk) {
  if (Array.isArray(aChunk)) {
    aChunk.forEach(function (chunk) {
      this.add(chunk);
    }, this);
  }
  else if (aChunk[isSourceNode] || typeof aChunk === "string") {
    if (aChunk) {
      this.children.push(aChunk);
    }
  }
  else {
    throw new TypeError(
      "Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + aChunk
    );
  }
  return this;
};

/**
 * Add a chunk of generated JS to the beginning of this source node.
 *
 * @param aChunk A string snippet of generated JS code, another instance of
 *        SourceNode, or an array where each member is one of those things.
 */
SourceNode.prototype.prepend = function SourceNode_prepend(aChunk) {
  if (Array.isArray(aChunk)) {
    for (var i = aChunk.length-1; i >= 0; i--) {
      this.prepend(aChunk[i]);
    }
  }
  else if (aChunk[isSourceNode] || typeof aChunk === "string") {
    this.children.unshift(aChunk);
  }
  else {
    throw new TypeError(
      "Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + aChunk
    );
  }
  return this;
};

/**
 * Walk over the tree of JS snippets in this node and its children. The
 * walking function is called once for each snippet of JS and is passed that
 * snippet and the its original associated source's line/column location.
 *
 * @param aFn The traversal function.
 */
SourceNode.prototype.walk = function SourceNode_walk(aFn) {
  var chunk;
  for (var i = 0, len = this.children.length; i < len; i++) {
    chunk = this.children[i];
    if (chunk[isSourceNode]) {
      chunk.walk(aFn);
    }
    else {
      if (chunk !== '') {
        aFn(chunk, { source: this.source,
                     line: this.line,
                     column: this.column,
                     name: this.name });
      }
    }
  }
};

/**
 * Like `String.prototype.join` except for SourceNodes. Inserts `aStr` between
 * each of `this.children`.
 *
 * @param aSep The separator.
 */
SourceNode.prototype.join = function SourceNode_join(aSep) {
  var newChildren;
  var i;
  var len = this.children.length;
  if (len > 0) {
    newChildren = [];
    for (i = 0; i < len-1; i++) {
      newChildren.push(this.children[i]);
      newChildren.push(aSep);
    }
    newChildren.push(this.children[i]);
    this.children = newChildren;
  }
  return this;
};

/**
 * Call String.prototype.replace on the very right-most source snippet. Useful
 * for trimming whitespace from the end of a source node, etc.
 *
 * @param aPattern The pattern to replace.
 * @param aReplacement The thing to replace the pattern with.
 */
SourceNode.prototype.replaceRight = function SourceNode_replaceRight(aPattern, aReplacement) {
  var lastChild = this.children[this.children.length - 1];
  if (lastChild[isSourceNode]) {
    lastChild.replaceRight(aPattern, aReplacement);
  }
  else if (typeof lastChild === 'string') {
    this.children[this.children.length - 1] = lastChild.replace(aPattern, aReplacement);
  }
  else {
    this.children.push(''.replace(aPattern, aReplacement));
  }
  return this;
};

/**
 * Set the source content for a source file. This will be added to the SourceMapGenerator
 * in the sourcesContent field.
 *
 * @param aSourceFile The filename of the source file
 * @param aSourceContent The content of the source file
 */
SourceNode.prototype.setSourceContent =
  function SourceNode_setSourceContent(aSourceFile, aSourceContent) {
    this.sourceContents[util.toSetString(aSourceFile)] = aSourceContent;
  };

/**
 * Walk over the tree of SourceNodes. The walking function is called for each
 * source file content and is passed the filename and source content.
 *
 * @param aFn The traversal function.
 */
SourceNode.prototype.walkSourceContents =
  function SourceNode_walkSourceContents(aFn) {
    for (var i = 0, len = this.children.length; i < len; i++) {
      if (this.children[i][isSourceNode]) {
        this.children[i].walkSourceContents(aFn);
      }
    }

    var sources = Object.keys(this.sourceContents);
    for (var i = 0, len = sources.length; i < len; i++) {
      aFn(util.fromSetString(sources[i]), this.sourceContents[sources[i]]);
    }
  };

/**
 * Return the string representation of this source node. Walks over the tree
 * and concatenates all the various snippets together to one string.
 */
SourceNode.prototype.toString = function SourceNode_toString() {
  var str = "";
  this.walk(function (chunk) {
    str += chunk;
  });
  return str;
};

/**
 * Returns the string representation of this source node along with a source
 * map.
 */
SourceNode.prototype.toStringWithSourceMap = function SourceNode_toStringWithSourceMap(aArgs) {
  var generated = {
    code: "",
    line: 1,
    column: 0
  };
  var map = new SourceMapGenerator(aArgs);
  var sourceMappingActive = false;
  var lastOriginalSource = null;
  var lastOriginalLine = null;
  var lastOriginalColumn = null;
  var lastOriginalName = null;
  this.walk(function (chunk, original) {
    generated.code += chunk;
    if (original.source !== null
        && original.line !== null
        && original.column !== null) {
      if(lastOriginalSource !== original.source
         || lastOriginalLine !== original.line
         || lastOriginalColumn !== original.column
         || lastOriginalName !== original.name) {
        map.addMapping({
          source: original.source,
          original: {
            line: original.line,
            column: original.column
          },
          generated: {
            line: generated.line,
            column: generated.column
          },
          name: original.name
        });
      }
      lastOriginalSource = original.source;
      lastOriginalLine = original.line;
      lastOriginalColumn = original.column;
      lastOriginalName = original.name;
      sourceMappingActive = true;
    } else if (sourceMappingActive) {
      map.addMapping({
        generated: {
          line: generated.line,
          column: generated.column
        }
      });
      lastOriginalSource = null;
      sourceMappingActive = false;
    }
    for (var idx = 0, length = chunk.length; idx < length; idx++) {
      if (chunk.charCodeAt(idx) === NEWLINE_CODE) {
        generated.line++;
        generated.column = 0;
        // Mappings end at eol
        if (idx + 1 === length) {
          lastOriginalSource = null;
          sourceMappingActive = false;
        } else if (sourceMappingActive) {
          map.addMapping({
            source: original.source,
            original: {
              line: original.line,
              column: original.column
            },
            generated: {
              line: generated.line,
              column: generated.column
            },
            name: original.name
          });
        }
      } else {
        generated.column++;
      }
    }
  });
  this.walkSourceContents(function (sourceFile, sourceContent) {
    map.setSourceContent(sourceFile, sourceContent);
  });

  return { code: generated.code, map: map };
};

exports.SourceNode = SourceNode;

},{"./source-map-generator":1196,"./util":1198}],1198:[function(require,module,exports){
/* -*- Mode: js; js-indent-level: 2; -*- */
/*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

/**
 * This is a helper function for getting values from parameter/options
 * objects.
 *
 * @param args The object we are extracting values from
 * @param name The name of the property we are getting.
 * @param defaultValue An optional value to return if the property is missing
 * from the object. If this is not specified and the property is missing, an
 * error will be thrown.
 */
function getArg(aArgs, aName, aDefaultValue) {
  if (aName in aArgs) {
    return aArgs[aName];
  } else if (arguments.length === 3) {
    return aDefaultValue;
  } else {
    throw new Error('"' + aName + '" is a required argument.');
  }
}
exports.getArg = getArg;

var urlRegexp = /^(?:([\w+\-.]+):)?\/\/(?:(\w+:\w+)@)?([\w.-]*)(?::(\d+))?(.*)$/;
var dataUrlRegexp = /^data:.+\,.+$/;

function urlParse(aUrl) {
  var match = aUrl.match(urlRegexp);
  if (!match) {
    return null;
  }
  return {
    scheme: match[1],
    auth: match[2],
    host: match[3],
    port: match[4],
    path: match[5]
  };
}
exports.urlParse = urlParse;

function urlGenerate(aParsedUrl) {
  var url = '';
  if (aParsedUrl.scheme) {
    url += aParsedUrl.scheme + ':';
  }
  url += '//';
  if (aParsedUrl.auth) {
    url += aParsedUrl.auth + '@';
  }
  if (aParsedUrl.host) {
    url += aParsedUrl.host;
  }
  if (aParsedUrl.port) {
    url += ":" + aParsedUrl.port
  }
  if (aParsedUrl.path) {
    url += aParsedUrl.path;
  }
  return url;
}
exports.urlGenerate = urlGenerate;

/**
 * Normalizes a path, or the path portion of a URL:
 *
 * - Replaces consecutive slashes with one slash.
 * - Removes unnecessary '.' parts.
 * - Removes unnecessary '<dir>/..' parts.
 *
 * Based on code in the Node.js 'path' core module.
 *
 * @param aPath The path or url to normalize.
 */
function normalize(aPath) {
  var path = aPath;
  var url = urlParse(aPath);
  if (url) {
    if (!url.path) {
      return aPath;
    }
    path = url.path;
  }
  var isAbsolute = exports.isAbsolute(path);

  var parts = path.split(/\/+/);
  for (var part, up = 0, i = parts.length - 1; i >= 0; i--) {
    part = parts[i];
    if (part === '.') {
      parts.splice(i, 1);
    } else if (part === '..') {
      up++;
    } else if (up > 0) {
      if (part === '') {
        // The first part is blank if the path is absolute. Trying to go
        // above the root is a no-op. Therefore we can remove all '..' parts
        // directly after the root.
        parts.splice(i + 1, up);
        up = 0;
      } else {
        parts.splice(i, 2);
        up--;
      }
    }
  }
  path = parts.join('/');

  if (path === '') {
    path = isAbsolute ? '/' : '.';
  }

  if (url) {
    url.path = path;
    return urlGenerate(url);
  }
  return path;
}
exports.normalize = normalize;

/**
 * Joins two paths/URLs.
 *
 * @param aRoot The root path or URL.
 * @param aPath The path or URL to be joined with the root.
 *
 * - If aPath is a URL or a data URI, aPath is returned, unless aPath is a
 *   scheme-relative URL: Then the scheme of aRoot, if any, is prepended
 *   first.
 * - Otherwise aPath is a path. If aRoot is a URL, then its path portion
 *   is updated with the result and aRoot is returned. Otherwise the result
 *   is returned.
 *   - If aPath is absolute, the result is aPath.
 *   - Otherwise the two paths are joined with a slash.
 * - Joining for example 'http://' and 'www.example.com' is also supported.
 */
function join(aRoot, aPath) {
  if (aRoot === "") {
    aRoot = ".";
  }
  if (aPath === "") {
    aPath = ".";
  }
  var aPathUrl = urlParse(aPath);
  var aRootUrl = urlParse(aRoot);
  if (aRootUrl) {
    aRoot = aRootUrl.path || '/';
  }

  // `join(foo, '//www.example.org')`
  if (aPathUrl && !aPathUrl.scheme) {
    if (aRootUrl) {
      aPathUrl.scheme = aRootUrl.scheme;
    }
    return urlGenerate(aPathUrl);
  }

  if (aPathUrl || aPath.match(dataUrlRegexp)) {
    return aPath;
  }

  // `join('http://', 'www.example.com')`
  if (aRootUrl && !aRootUrl.host && !aRootUrl.path) {
    aRootUrl.host = aPath;
    return urlGenerate(aRootUrl);
  }

  var joined = aPath.charAt(0) === '/'
    ? aPath
    : normalize(aRoot.replace(/\/+$/, '') + '/' + aPath);

  if (aRootUrl) {
    aRootUrl.path = joined;
    return urlGenerate(aRootUrl);
  }
  return joined;
}
exports.join = join;

exports.isAbsolute = function (aPath) {
  return aPath.charAt(0) === '/' || urlRegexp.test(aPath);
};

/**
 * Make a path relative to a URL or another path.
 *
 * @param aRoot The root path or URL.
 * @param aPath The path or URL to be made relative to aRoot.
 */
function relative(aRoot, aPath) {
  if (aRoot === "") {
    aRoot = ".";
  }

  aRoot = aRoot.replace(/\/$/, '');

  // It is possible for the path to be above the root. In this case, simply
  // checking whether the root is a prefix of the path won't work. Instead, we
  // need to remove components from the root one by one, until either we find
  // a prefix that fits, or we run out of components to remove.
  var level = 0;
  while (aPath.indexOf(aRoot + '/') !== 0) {
    var index = aRoot.lastIndexOf("/");
    if (index < 0) {
      return aPath;
    }

    // If the only part of the root that is left is the scheme (i.e. http://,
    // file:///, etc.), one or more slashes (/), or simply nothing at all, we
    // have exhausted all components, so the path is not relative to the root.
    aRoot = aRoot.slice(0, index);
    if (aRoot.match(/^([^\/]+:\/)?\/*$/)) {
      return aPath;
    }

    ++level;
  }

  // Make sure we add a "../" for each component we removed from the root.
  return Array(level + 1).join("../") + aPath.substr(aRoot.length + 1);
}
exports.relative = relative;

var supportsNullProto = (function () {
  var obj = Object.create(null);
  return !('__proto__' in obj);
}());

function identity (s) {
  return s;
}

/**
 * Because behavior goes wacky when you set `__proto__` on objects, we
 * have to prefix all the strings in our set with an arbitrary character.
 *
 * See https://github.com/mozilla/source-map/pull/31 and
 * https://github.com/mozilla/source-map/issues/30
 *
 * @param String aStr
 */
function toSetString(aStr) {
  if (isProtoString(aStr)) {
    return '$' + aStr;
  }

  return aStr;
}
exports.toSetString = supportsNullProto ? identity : toSetString;

function fromSetString(aStr) {
  if (isProtoString(aStr)) {
    return aStr.slice(1);
  }

  return aStr;
}
exports.fromSetString = supportsNullProto ? identity : fromSetString;

function isProtoString(s) {
  if (!s) {
    return false;
  }

  var length = s.length;

  if (length < 9 /* "__proto__".length */) {
    return false;
  }

  if (s.charCodeAt(length - 1) !== 95  /* '_' */ ||
      s.charCodeAt(length - 2) !== 95  /* '_' */ ||
      s.charCodeAt(length - 3) !== 111 /* 'o' */ ||
      s.charCodeAt(length - 4) !== 116 /* 't' */ ||
      s.charCodeAt(length - 5) !== 111 /* 'o' */ ||
      s.charCodeAt(length - 6) !== 114 /* 'r' */ ||
      s.charCodeAt(length - 7) !== 112 /* 'p' */ ||
      s.charCodeAt(length - 8) !== 95  /* '_' */ ||
      s.charCodeAt(length - 9) !== 95  /* '_' */) {
    return false;
  }

  for (var i = length - 10; i >= 0; i--) {
    if (s.charCodeAt(i) !== 36 /* '$' */) {
      return false;
    }
  }

  return true;
}

/**
 * Comparator between two mappings where the original positions are compared.
 *
 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
 * mappings with the same original source/line/column, but different generated
 * line and column the same. Useful when searching for a mapping with a
 * stubbed out mapping.
 */
function compareByOriginalPositions(mappingA, mappingB, onlyCompareOriginal) {
  var cmp = strcmp(mappingA.source, mappingB.source);
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.originalLine - mappingB.originalLine;
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.originalColumn - mappingB.originalColumn;
  if (cmp !== 0 || onlyCompareOriginal) {
    return cmp;
  }

  cmp = mappingA.generatedColumn - mappingB.generatedColumn;
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.generatedLine - mappingB.generatedLine;
  if (cmp !== 0) {
    return cmp;
  }

  return strcmp(mappingA.name, mappingB.name);
}
exports.compareByOriginalPositions = compareByOriginalPositions;

/**
 * Comparator between two mappings with deflated source and name indices where
 * the generated positions are compared.
 *
 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
 * mappings with the same generated line and column, but different
 * source/name/original line and column the same. Useful when searching for a
 * mapping with a stubbed out mapping.
 */
function compareByGeneratedPositionsDeflated(mappingA, mappingB, onlyCompareGenerated) {
  var cmp = mappingA.generatedLine - mappingB.generatedLine;
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.generatedColumn - mappingB.generatedColumn;
  if (cmp !== 0 || onlyCompareGenerated) {
    return cmp;
  }

  cmp = strcmp(mappingA.source, mappingB.source);
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.originalLine - mappingB.originalLine;
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.originalColumn - mappingB.originalColumn;
  if (cmp !== 0) {
    return cmp;
  }

  return strcmp(mappingA.name, mappingB.name);
}
exports.compareByGeneratedPositionsDeflated = compareByGeneratedPositionsDeflated;

function strcmp(aStr1, aStr2) {
  if (aStr1 === aStr2) {
    return 0;
  }

  if (aStr1 === null) {
    return 1; // aStr2 !== null
  }

  if (aStr2 === null) {
    return -1; // aStr1 !== null
  }

  if (aStr1 > aStr2) {
    return 1;
  }

  return -1;
}

/**
 * Comparator between two mappings with inflated source and name strings where
 * the generated positions are compared.
 */
function compareByGeneratedPositionsInflated(mappingA, mappingB) {
  var cmp = mappingA.generatedLine - mappingB.generatedLine;
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.generatedColumn - mappingB.generatedColumn;
  if (cmp !== 0) {
    return cmp;
  }

  cmp = strcmp(mappingA.source, mappingB.source);
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.originalLine - mappingB.originalLine;
  if (cmp !== 0) {
    return cmp;
  }

  cmp = mappingA.originalColumn - mappingB.originalColumn;
  if (cmp !== 0) {
    return cmp;
  }

  return strcmp(mappingA.name, mappingB.name);
}
exports.compareByGeneratedPositionsInflated = compareByGeneratedPositionsInflated;

/**
 * Strip any JSON XSSI avoidance prefix from the string (as documented
 * in the source maps specification), and then parse the string as
 * JSON.
 */
function parseSourceMapInput(str) {
  return JSON.parse(str.replace(/^\)]}'[^\n]*\n/, ''));
}
exports.parseSourceMapInput = parseSourceMapInput;

/**
 * Compute the URL of a source given the the source root, the source's
 * URL, and the source map's URL.
 */
function computeSourceURL(sourceRoot, sourceURL, sourceMapURL) {
  sourceURL = sourceURL || '';

  if (sourceRoot) {
    // This follows what Chrome does.
    if (sourceRoot[sourceRoot.length - 1] !== '/' && sourceURL[0] !== '/') {
      sourceRoot += '/';
    }
    // The spec says:
    //   Line 4: An optional source root, useful for relocating source
    //   files on a server or removing repeated values in the
    //   “sources” entry.  This value is prepended to the individual
    //   entries in the “source” field.
    sourceURL = sourceRoot + sourceURL;
  }

  // Historically, SourceMapConsumer did not take the sourceMapURL as
  // a parameter.  This mode is still somewhat supported, which is why
  // this code block is conditional.  However, it's preferable to pass
  // the source map URL to SourceMapConsumer, so that this function
  // can implement the source URL resolution algorithm as outlined in
  // the spec.  This block is basically the equivalent of:
  //    new URL(sourceURL, sourceMapURL).toString()
  // ... except it avoids using URL, which wasn't available in the
  // older releases of node still supported by this library.
  //
  // The spec says:
  //   If the sources are not absolute URLs after prepending of the
  //   “sourceRoot”, the sources are resolved relative to the
  //   SourceMap (like resolving script src in a html document).
  if (sourceMapURL) {
    var parsed = urlParse(sourceMapURL);
    if (!parsed) {
      throw new Error("sourceMapURL could not be parsed");
    }
    if (parsed.path) {
      // Strip the last path component, but keep the "/".
      var index = parsed.path.lastIndexOf('/');
      if (index >= 0) {
        parsed.path = parsed.path.substring(0, index + 1);
      }
    }
    sourceURL = join(urlGenerate(parsed), sourceURL);
  }

  return normalize(sourceURL);
}
exports.computeSourceURL = computeSourceURL;

},{}],1199:[function(require,module,exports){
/*
 * Copyright 2009-2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE.txt or:
 * http://opensource.org/licenses/BSD-3-Clause
 */
exports.SourceMapGenerator = require('./lib/source-map-generator').SourceMapGenerator;
exports.SourceMapConsumer = require('./lib/source-map-consumer').SourceMapConsumer;
exports.SourceNode = require('./lib/source-node').SourceNode;

},{"./lib/source-map-consumer":1195,"./lib/source-map-generator":1196,"./lib/source-node":1197}],1200:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Stream;

var EE = require('events').EventEmitter;
var inherits = require('inherits');

inherits(Stream, EE);
Stream.Readable = require('readable-stream/lib/_stream_readable.js');
Stream.Writable = require('readable-stream/lib/_stream_writable.js');
Stream.Duplex = require('readable-stream/lib/_stream_duplex.js');
Stream.Transform = require('readable-stream/lib/_stream_transform.js');
Stream.PassThrough = require('readable-stream/lib/_stream_passthrough.js');
Stream.finished = require('readable-stream/lib/internal/streams/end-of-stream.js')
Stream.pipeline = require('readable-stream/lib/internal/streams/pipeline.js')

// Backwards-compat with node 0.4.x
Stream.Stream = Stream;



// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.

function Stream() {
  EE.call(this);
}

Stream.prototype.pipe = function(dest, options) {
  var source = this;

  function ondata(chunk) {
    if (dest.writable) {
      if (false === dest.write(chunk) && source.pause) {
        source.pause();
      }
    }
  }

  source.on('data', ondata);

  function ondrain() {
    if (source.readable && source.resume) {
      source.resume();
    }
  }

  dest.on('drain', ondrain);

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend);
    source.on('close', onclose);
  }

  var didOnEnd = false;
  function onend() {
    if (didOnEnd) return;
    didOnEnd = true;

    dest.end();
  }


  function onclose() {
    if (didOnEnd) return;
    didOnEnd = true;

    if (typeof dest.destroy === 'function') dest.destroy();
  }

  // don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup();
    if (EE.listenerCount(this, 'error') === 0) {
      throw er; // Unhandled stream error in pipe.
    }
  }

  source.on('error', onerror);
  dest.on('error', onerror);

  // remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata);
    dest.removeListener('drain', ondrain);

    source.removeListener('end', onend);
    source.removeListener('close', onclose);

    source.removeListener('error', onerror);
    dest.removeListener('error', onerror);

    source.removeListener('end', cleanup);
    source.removeListener('close', cleanup);

    dest.removeListener('close', cleanup);
  }

  source.on('end', cleanup);
  source.on('close', cleanup);

  dest.on('close', cleanup);

  dest.emit('pipe', source);

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest;
};

},{"events":1102,"inherits":1159,"readable-stream/lib/_stream_duplex.js":1202,"readable-stream/lib/_stream_passthrough.js":1203,"readable-stream/lib/_stream_readable.js":1204,"readable-stream/lib/_stream_transform.js":1205,"readable-stream/lib/_stream_writable.js":1206,"readable-stream/lib/internal/streams/end-of-stream.js":1210,"readable-stream/lib/internal/streams/pipeline.js":1212}],1201:[function(require,module,exports){
'use strict';

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var codes = {};

function createErrorType(code, message, Base) {
  if (!Base) {
    Base = Error;
  }

  function getMessage(arg1, arg2, arg3) {
    if (typeof message === 'string') {
      return message;
    } else {
      return message(arg1, arg2, arg3);
    }
  }

  var NodeError =
  /*#__PURE__*/
  function (_Base) {
    _inheritsLoose(NodeError, _Base);

    function NodeError(arg1, arg2, arg3) {
      return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
    }

    return NodeError;
  }(Base);

  NodeError.prototype.name = Base.name;
  NodeError.prototype.code = code;
  codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js


function oneOf(expected, thing) {
  if (Array.isArray(expected)) {
    var len = expected.length;
    expected = expected.map(function (i) {
      return String(i);
    });

    if (len > 2) {
      return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
    } else if (len === 2) {
      return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
    } else {
      return "of ".concat(thing, " ").concat(expected[0]);
    }
  } else {
    return "of ".concat(thing, " ").concat(String(expected));
  }
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith


function startsWith(str, search, pos) {
  return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith


function endsWith(str, search, this_len) {
  if (this_len === undefined || this_len > str.length) {
    this_len = str.length;
  }

  return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes


function includes(str, search, start) {
  if (typeof start !== 'number') {
    start = 0;
  }

  if (start + search.length > str.length) {
    return false;
  } else {
    return str.indexOf(search, start) !== -1;
  }
}

createErrorType('ERR_INVALID_OPT_VALUE', function (name, value) {
  return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
createErrorType('ERR_INVALID_ARG_TYPE', function (name, expected, actual) {
  // determiner: 'must be' or 'must not be'
  var determiner;

  if (typeof expected === 'string' && startsWith(expected, 'not ')) {
    determiner = 'must not be';
    expected = expected.replace(/^not /, '');
  } else {
    determiner = 'must be';
  }

  var msg;

  if (endsWith(name, ' argument')) {
    // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
  } else {
    var type = includes(name, '.') ? 'property' : 'argument';
    msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
  }

  msg += ". Received type ".concat(typeof actual);
  return msg;
}, TypeError);
createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function (name) {
  return 'The ' + name + ' method is not implemented';
});
createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
createErrorType('ERR_STREAM_DESTROYED', function (name) {
  return 'Cannot call ' + name + ' after a stream was destroyed';
});
createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
createErrorType('ERR_UNKNOWN_ENCODING', function (arg) {
  return 'Unknown encoding: ' + arg;
}, TypeError);
createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
module.exports.codes = codes;

},{}],1202:[function(require,module,exports){
(function (process){(function (){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

'use strict';

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
};
/*</replacement>*/

module.exports = Duplex;
var Readable = require('./_stream_readable');
var Writable = require('./_stream_writable');
require('inherits')(Duplex, Readable);
{
  // Allow the keys array to be GC'ed.
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}
function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);
  Readable.call(this, options);
  Writable.call(this, options);
  this.allowHalfOpen = true;
  if (options) {
    if (options.readable === false) this.readable = false;
    if (options.writable === false) this.writable = false;
    if (options.allowHalfOpen === false) {
      this.allowHalfOpen = false;
      this.once('end', onend);
    }
  }
}
Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.highWaterMark;
  }
});
Object.defineProperty(Duplex.prototype, 'writableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState && this._writableState.getBuffer();
  }
});
Object.defineProperty(Duplex.prototype, 'writableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.length;
  }
});

// the no-half-open enforcer
function onend() {
  // If the writable side ended, then we're ok.
  if (this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  process.nextTick(onEndNT, this);
}
function onEndNT(self) {
  self.end();
}
Object.defineProperty(Duplex.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});
}).call(this)}).call(this,require('_process'))
},{"./_stream_readable":1204,"./_stream_writable":1206,"_process":1185,"inherits":1159}],1203:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.

'use strict';

module.exports = PassThrough;
var Transform = require('./_stream_transform');
require('inherits')(PassThrough, Transform);
function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);
  Transform.call(this, options);
}
PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};
},{"./_stream_transform":1205,"inherits":1159}],1204:[function(require,module,exports){
(function (process,global){(function (){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

module.exports = Readable;

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = require('events').EventEmitter;
var EElistenerCount = function EElistenerCount(emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = require('./internal/streams/stream');
/*</replacement>*/

var Buffer = require('buffer').Buffer;
var OurUint8Array = (typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*<replacement>*/
var debugUtil = require('util');
var debug;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function debug() {};
}
/*</replacement>*/

var BufferList = require('./internal/streams/buffer_list');
var destroyImpl = require('./internal/streams/destroy');
var _require = require('./internal/streams/state'),
  getHighWaterMark = _require.getHighWaterMark;
var _require$codes = require('../errors').codes,
  ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
  ERR_STREAM_PUSH_AFTER_EOF = _require$codes.ERR_STREAM_PUSH_AFTER_EOF,
  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
  ERR_STREAM_UNSHIFT_AFTER_END_EVENT = _require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;

// Lazy loaded to improve the startup performance.
var StringDecoder;
var createReadableStreamAsyncIterator;
var from;
require('inherits')(Readable, Stream);
var errorOrDestroy = destroyImpl.errorOrDestroy;
var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];
function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}
function ReadableState(options, stream, isDuplex) {
  Duplex = Duplex || require('./_stream_duplex');
  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;
  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  this.highWaterMark = getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;
  this.paused = true;

  // Should close be emitted on destroy. Defaults to true.
  this.emitClose = options.emitClose !== false;

  // Should .destroy() be called after 'end' (and potentially 'finish')
  this.autoDestroy = !!options.autoDestroy;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;
  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = require('string_decoder/').StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}
function Readable(options) {
  Duplex = Duplex || require('./_stream_duplex');
  if (!(this instanceof Readable)) return new Readable(options);

  // Checking for a Stream.Duplex instance is faster here instead of inside
  // the ReadableState constructor, at least with V8 6.5
  var isDuplex = this instanceof Duplex;
  this._readableState = new ReadableState(options, this, isDuplex);

  // legacy
  this.readable = true;
  if (options) {
    if (typeof options.read === 'function') this._read = options.read;
    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }
  Stream.call(this);
}
Object.defineProperty(Readable.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});
Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;
  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }
  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};
function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  debug('readableAddChunk', chunk);
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      errorOrDestroy(stream, er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }
      if (addToFront) {
        if (state.endEmitted) errorOrDestroy(stream, new ERR_STREAM_UNSHIFT_AFTER_END_EVENT());else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        errorOrDestroy(stream, new ERR_STREAM_PUSH_AFTER_EOF());
      } else if (state.destroyed) {
        return false;
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
      maybeReadMore(stream, state);
    }
  }

  // We can push more data if we are below the highWaterMark.
  // Also, if we have no data yet, we can stand some more bytes.
  // This is to work around cases where hwm=0, such as the repl.
  return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    state.awaitDrain = 0;
    stream.emit('data', chunk);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}
function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer', 'Uint8Array'], chunk);
  }
  return er;
}
Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = require('string_decoder/').StringDecoder;
  var decoder = new StringDecoder(enc);
  this._readableState.decoder = decoder;
  // If setEncoding(null), decoder.encoding equals utf8
  this._readableState.encoding = this._readableState.decoder.encoding;

  // Iterate over current buffer to convert already stored Buffers:
  var p = this._readableState.buffer.head;
  var content = '';
  while (p !== null) {
    content += decoder.write(p.data);
    p = p.next;
  }
  this._readableState.buffer.clear();
  if (content !== '') this._readableState.buffer.push(content);
  this._readableState.length = content.length;
  return this;
};

// Don't raise the hwm > 1GB
var MAX_HWM = 0x40000000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;
  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }
  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }
  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;
  if (ret === null) {
    state.needReadable = state.length <= state.highWaterMark;
    n = 0;
  } else {
    state.length -= n;
    state.awaitDrain = 0;
  }
  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }
  if (ret !== null) this.emit('data', ret);
  return ret;
};
function onEofChunk(stream, state) {
  debug('onEofChunk');
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;
  if (state.sync) {
    // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    emitReadable(stream);
  } else {
    // emit 'readable' now to make sure it gets picked up.
    state.needReadable = false;
    if (!state.emittedReadable) {
      state.emittedReadable = true;
      emitReadable_(stream);
    }
  }
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  debug('emitReadable', state.needReadable, state.emittedReadable);
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    process.nextTick(emitReadable_, stream);
  }
}
function emitReadable_(stream) {
  var state = stream._readableState;
  debug('emitReadable_', state.destroyed, state.length, state.ended);
  if (!state.destroyed && (state.length || state.ended)) {
    stream.emit('readable');
    state.emittedReadable = false;
  }

  // The stream needs another readable event if
  // 1. It is not flowing, as the flow mechanism will take
  //    care of it.
  // 2. It is not ended.
  // 3. It is below the highWaterMark, so we can schedule
  //    another readable later.
  state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    process.nextTick(maybeReadMore_, stream, state);
  }
}
function maybeReadMore_(stream, state) {
  // Attempt to read more data if we should.
  //
  // The conditions for reading more data are (one of):
  // - Not enough data buffered (state.length < state.highWaterMark). The loop
  //   is responsible for filling the buffer with enough data if such data
  //   is available. If highWaterMark is 0 and we are not in the flowing mode
  //   we should _not_ attempt to buffer any extra data. We'll get more data
  //   when the stream consumer calls read() instead.
  // - No data in the buffer, and the stream is in flowing mode. In this mode
  //   the loop below is responsible for ensuring read() is called. Failing to
  //   call read here would abort the flow and there's no other mechanism for
  //   continuing the flow if the stream consumer has just subscribed to the
  //   'data' event.
  //
  // In addition to the above conditions to keep reading data, the following
  // conditions prevent the data from being read:
  // - The stream has ended (state.ended).
  // - There is already a pending 'read' operation (state.reading). This is a
  //   case where the the stream has called the implementation defined _read()
  //   method, but they are processing the call asynchronously and have _not_
  //   called push() with new data. In this case we skip performing more
  //   read()s. The execution ends in this method again after the _read() ends
  //   up calling push() with more data.
  while (!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)) {
    var len = state.length;
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  errorOrDestroy(this, new ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;
  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) process.nextTick(endFn);else src.once('end', endFn);
  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }
  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);
  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);
    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    var ret = dest.write(chunk);
    debug('dest.write', ret);
    if (ret === false) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', state.awaitDrain);
        state.awaitDrain++;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) errorOrDestroy(dest, er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);
  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }
  return dest;
};
function pipeOnDrain(src) {
  return function pipeOnDrainFunctionResult() {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}
Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = {
    hasUnpiped: false
  };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;
    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    for (var i = 0; i < len; i++) dests[i].emit('unpipe', this, {
      hasUnpiped: false
    });
    return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;
  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];
  dest.emit('unpipe', this, unpipeInfo);
  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);
  var state = this._readableState;
  if (ev === 'data') {
    // update readableListening so that resume() may be a no-op
    // a few lines down. This is needed to support once('readable').
    state.readableListening = this.listenerCount('readable') > 0;

    // Try start flowing on next tick if stream isn't explicitly paused
    if (state.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.flowing = false;
      state.emittedReadable = false;
      debug('on readable', state.length, state.reading);
      if (state.length) {
        emitReadable(this);
      } else if (!state.reading) {
        process.nextTick(nReadingNextTick, this);
      }
    }
  }
  return res;
};
Readable.prototype.addListener = Readable.prototype.on;
Readable.prototype.removeListener = function (ev, fn) {
  var res = Stream.prototype.removeListener.call(this, ev, fn);
  if (ev === 'readable') {
    // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
  }
  return res;
};
Readable.prototype.removeAllListeners = function (ev) {
  var res = Stream.prototype.removeAllListeners.apply(this, arguments);
  if (ev === 'readable' || ev === undefined) {
    // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
  }
  return res;
};
function updateReadableListening(self) {
  var state = self._readableState;
  state.readableListening = self.listenerCount('readable') > 0;
  if (state.resumeScheduled && !state.paused) {
    // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;

    // crude way to check if we should resume
  } else if (self.listenerCount('data') > 0) {
    self.resume();
  }
}
function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    // we flow only if there is no one listening
    // for readable, but we still have to call
    // resume()
    state.flowing = !state.readableListening;
    resume(this, state);
  }
  state.paused = false;
  return this;
};
function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    process.nextTick(resume_, stream, state);
  }
}
function resume_(stream, state) {
  debug('resume', state.reading);
  if (!state.reading) {
    stream.read(0);
  }
  state.resumeScheduled = false;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}
Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (this._readableState.flowing !== false) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  this._readableState.paused = true;
  return this;
};
function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null);
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;
  var state = this._readableState;
  var paused = false;
  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }
    _this.push(null);
  });
  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };
  return this;
};
if (typeof Symbol === 'function') {
  Readable.prototype[Symbol.asyncIterator] = function () {
    if (createReadableStreamAsyncIterator === undefined) {
      createReadableStreamAsyncIterator = require('./internal/streams/async_iterator');
    }
    return createReadableStreamAsyncIterator(this);
  };
}
Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.highWaterMark;
  }
});
Object.defineProperty(Readable.prototype, 'readableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState && this._readableState.buffer;
  }
});
Object.defineProperty(Readable.prototype, 'readableFlowing', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.flowing;
  },
  set: function set(state) {
    if (this._readableState) {
      this._readableState.flowing = state;
    }
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;
Object.defineProperty(Readable.prototype, 'readableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.length;
  }
});

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;
  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.first();else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = state.buffer.consume(n, state.decoder);
  }
  return ret;
}
function endReadable(stream) {
  var state = stream._readableState;
  debug('endReadable', state.endEmitted);
  if (!state.endEmitted) {
    state.ended = true;
    process.nextTick(endReadableNT, state, stream);
  }
}
function endReadableNT(state, stream) {
  debug('endReadableNT', state.endEmitted, state.length);

  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
    if (state.autoDestroy) {
      // In case of duplex streams we need a way to detect
      // if the writable side is ready for autoDestroy as well
      var wState = stream._writableState;
      if (!wState || wState.autoDestroy && wState.finished) {
        stream.destroy();
      }
    }
  }
}
if (typeof Symbol === 'function') {
  Readable.from = function (iterable, opts) {
    if (from === undefined) {
      from = require('./internal/streams/from');
    }
    return from(Readable, iterable, opts);
  };
}
function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"../errors":1201,"./_stream_duplex":1202,"./internal/streams/async_iterator":1207,"./internal/streams/buffer_list":1208,"./internal/streams/destroy":1209,"./internal/streams/from":1211,"./internal/streams/state":1213,"./internal/streams/stream":1214,"_process":1185,"buffer":570,"events":1102,"inherits":1159,"string_decoder/":1215,"util":566}],1205:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

'use strict';

module.exports = Transform;
var _require$codes = require('../errors').codes,
  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
  ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
  ERR_TRANSFORM_ALREADY_TRANSFORMING = _require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING,
  ERR_TRANSFORM_WITH_LENGTH_0 = _require$codes.ERR_TRANSFORM_WITH_LENGTH_0;
var Duplex = require('./_stream_duplex');
require('inherits')(Transform, Duplex);
function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;
  var cb = ts.writecb;
  if (cb === null) {
    return this.emit('error', new ERR_MULTIPLE_CALLBACK());
  }
  ts.writechunk = null;
  ts.writecb = null;
  if (data != null)
    // single equals check for both `null` and `undefined`
    this.push(data);
  cb(er);
  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}
function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);
  Duplex.call(this, options);
  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;
  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;
    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}
function prefinish() {
  var _this = this;
  if (typeof this._flush === 'function' && !this._readableState.destroyed) {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}
Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  cb(new ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;
  if (ts.writechunk !== null && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};
Transform.prototype._destroy = function (err, cb) {
  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
  });
};
function done(stream, er, data) {
  if (er) return stream.emit('error', er);
  if (data != null)
    // single equals check for both `null` and `undefined`
    stream.push(data);

  // TODO(BridgeAR): Write a test for these two error cases
  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new ERR_TRANSFORM_WITH_LENGTH_0();
  if (stream._transformState.transforming) throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
  return stream.push(null);
}
},{"../errors":1201,"./_stream_duplex":1202,"inherits":1159}],1206:[function(require,module,exports){
(function (process,global){(function (){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

'use strict';

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;
  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var internalUtil = {
  deprecate: require('util-deprecate')
};
/*</replacement>*/

/*<replacement>*/
var Stream = require('./internal/streams/stream');
/*</replacement>*/

var Buffer = require('buffer').Buffer;
var OurUint8Array = (typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
var destroyImpl = require('./internal/streams/destroy');
var _require = require('./internal/streams/state'),
  getHighWaterMark = _require.getHighWaterMark;
var _require$codes = require('../errors').codes,
  ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
  ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
  ERR_STREAM_CANNOT_PIPE = _require$codes.ERR_STREAM_CANNOT_PIPE,
  ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED,
  ERR_STREAM_NULL_VALUES = _require$codes.ERR_STREAM_NULL_VALUES,
  ERR_STREAM_WRITE_AFTER_END = _require$codes.ERR_STREAM_WRITE_AFTER_END,
  ERR_UNKNOWN_ENCODING = _require$codes.ERR_UNKNOWN_ENCODING;
var errorOrDestroy = destroyImpl.errorOrDestroy;
require('inherits')(Writable, Stream);
function nop() {}
function WritableState(options, stream, isDuplex) {
  Duplex = Duplex || require('./_stream_duplex');
  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream,
  // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;
  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  this.highWaterMark = getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;
  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // Should close be emitted on destroy. Defaults to true.
  this.emitClose = options.emitClose !== false;

  // Should .destroy() be called after 'finish' (and potentially 'end')
  this.autoDestroy = !!options.autoDestroy;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}
WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};
(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function writableStateBufferGetter() {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function value(object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;
      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function realHasInstance(object) {
    return object instanceof this;
  };
}
function Writable(options) {
  Duplex = Duplex || require('./_stream_duplex');

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.

  // Checking for a Stream.Duplex instance is faster here instead of inside
  // the WritableState constructor, at least with V8 6.5
  var isDuplex = this instanceof Duplex;
  if (!isDuplex && !realHasInstance.call(Writable, this)) return new Writable(options);
  this._writableState = new WritableState(options, this, isDuplex);

  // legacy.
  this.writable = true;
  if (options) {
    if (typeof options.write === 'function') this._write = options.write;
    if (typeof options.writev === 'function') this._writev = options.writev;
    if (typeof options.destroy === 'function') this._destroy = options.destroy;
    if (typeof options.final === 'function') this._final = options.final;
  }
  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  errorOrDestroy(this, new ERR_STREAM_CANNOT_PIPE());
};
function writeAfterEnd(stream, cb) {
  var er = new ERR_STREAM_WRITE_AFTER_END();
  // TODO: defer error events consistently everywhere, not just the cb
  errorOrDestroy(stream, er);
  process.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var er;
  if (chunk === null) {
    er = new ERR_STREAM_NULL_VALUES();
  } else if (typeof chunk !== 'string' && !state.objectMode) {
    er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer'], chunk);
  }
  if (er) {
    errorOrDestroy(stream, er);
    process.nextTick(cb, er);
    return false;
  }
  return true;
}
Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);
  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }
  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }
  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
  if (typeof cb !== 'function') cb = nop;
  if (state.ending) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }
  return ret;
};
Writable.prototype.cork = function () {
  this._writableState.corked++;
};
Writable.prototype.uncork = function () {
  var state = this._writableState;
  if (state.corked) {
    state.corked--;
    if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};
Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new ERR_UNKNOWN_ENCODING(encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};
Object.defineProperty(Writable.prototype, 'writableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState && this._writableState.getBuffer();
  }
});
function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}
Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;
  state.length += len;
  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;
  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }
  return ret;
}
function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (state.destroyed) state.onwrite(new ERR_STREAM_DESTROYED('write'));else if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}
function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;
  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    process.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    process.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    errorOrDestroy(stream, er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    errorOrDestroy(stream, er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}
function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}
function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;
  if (typeof cb !== 'function') throw new ERR_MULTIPLE_CALLBACK();
  onwriteStateUpdate(state);
  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state) || stream.destroyed;
    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }
    if (sync) {
      process.nextTick(afterWrite, stream, state, finished, cb);
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}
function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;
  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;
    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;
    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;
      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }
    if (entry === null) state.lastBufferedRequest = null;
  }
  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}
Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
Writable.prototype._writev = null;
Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;
  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }
  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending) endWritable(this, state, cb);
  return this;
};
Object.defineProperty(Writable.prototype, 'writableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.length;
  }
});
function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      errorOrDestroy(stream, err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function' && !state.destroyed) {
      state.pendingcb++;
      state.finalCalled = true;
      process.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}
function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
      if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well
        var rState = stream._readableState;
        if (!rState || rState.autoDestroy && rState.endEmitted) {
          stream.destroy();
        }
      }
    }
  }
  return need;
}
function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) process.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}
function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }

  // reuse the free corkReq.
  state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty(Writable.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});
Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  cb(err);
};
}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"../errors":1201,"./_stream_duplex":1202,"./internal/streams/destroy":1209,"./internal/streams/state":1213,"./internal/streams/stream":1214,"_process":1185,"buffer":570,"inherits":1159,"util-deprecate":1218}],1207:[function(require,module,exports){
(function (process){(function (){
'use strict';

var _Object$setPrototypeO;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var finished = require('./end-of-stream');
var kLastResolve = Symbol('lastResolve');
var kLastReject = Symbol('lastReject');
var kError = Symbol('error');
var kEnded = Symbol('ended');
var kLastPromise = Symbol('lastPromise');
var kHandlePromise = Symbol('handlePromise');
var kStream = Symbol('stream');
function createIterResult(value, done) {
  return {
    value: value,
    done: done
  };
}
function readAndResolve(iter) {
  var resolve = iter[kLastResolve];
  if (resolve !== null) {
    var data = iter[kStream].read();
    // we defer if data is null
    // we can be expecting either 'end' or
    // 'error'
    if (data !== null) {
      iter[kLastPromise] = null;
      iter[kLastResolve] = null;
      iter[kLastReject] = null;
      resolve(createIterResult(data, false));
    }
  }
}
function onReadable(iter) {
  // we wait for the next tick, because it might
  // emit an error with process.nextTick
  process.nextTick(readAndResolve, iter);
}
function wrapForNext(lastPromise, iter) {
  return function (resolve, reject) {
    lastPromise.then(function () {
      if (iter[kEnded]) {
        resolve(createIterResult(undefined, true));
        return;
      }
      iter[kHandlePromise](resolve, reject);
    }, reject);
  };
}
var AsyncIteratorPrototype = Object.getPrototypeOf(function () {});
var ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf((_Object$setPrototypeO = {
  get stream() {
    return this[kStream];
  },
  next: function next() {
    var _this = this;
    // if we have detected an error in the meanwhile
    // reject straight away
    var error = this[kError];
    if (error !== null) {
      return Promise.reject(error);
    }
    if (this[kEnded]) {
      return Promise.resolve(createIterResult(undefined, true));
    }
    if (this[kStream].destroyed) {
      // We need to defer via nextTick because if .destroy(err) is
      // called, the error will be emitted via nextTick, and
      // we cannot guarantee that there is no error lingering around
      // waiting to be emitted.
      return new Promise(function (resolve, reject) {
        process.nextTick(function () {
          if (_this[kError]) {
            reject(_this[kError]);
          } else {
            resolve(createIterResult(undefined, true));
          }
        });
      });
    }

    // if we have multiple next() calls
    // we will wait for the previous Promise to finish
    // this logic is optimized to support for await loops,
    // where next() is only called once at a time
    var lastPromise = this[kLastPromise];
    var promise;
    if (lastPromise) {
      promise = new Promise(wrapForNext(lastPromise, this));
    } else {
      // fast path needed to support multiple this.push()
      // without triggering the next() queue
      var data = this[kStream].read();
      if (data !== null) {
        return Promise.resolve(createIterResult(data, false));
      }
      promise = new Promise(this[kHandlePromise]);
    }
    this[kLastPromise] = promise;
    return promise;
  }
}, _defineProperty(_Object$setPrototypeO, Symbol.asyncIterator, function () {
  return this;
}), _defineProperty(_Object$setPrototypeO, "return", function _return() {
  var _this2 = this;
  // destroy(err, cb) is a private API
  // we can guarantee we have that here, because we control the
  // Readable class this is attached to
  return new Promise(function (resolve, reject) {
    _this2[kStream].destroy(null, function (err) {
      if (err) {
        reject(err);
        return;
      }
      resolve(createIterResult(undefined, true));
    });
  });
}), _Object$setPrototypeO), AsyncIteratorPrototype);
var createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
  var _Object$create;
  var iterator = Object.create(ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, _defineProperty(_Object$create, kStream, {
    value: stream,
    writable: true
  }), _defineProperty(_Object$create, kLastResolve, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kLastReject, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kError, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kEnded, {
    value: stream._readableState.endEmitted,
    writable: true
  }), _defineProperty(_Object$create, kHandlePromise, {
    value: function value(resolve, reject) {
      var data = iterator[kStream].read();
      if (data) {
        iterator[kLastPromise] = null;
        iterator[kLastResolve] = null;
        iterator[kLastReject] = null;
        resolve(createIterResult(data, false));
      } else {
        iterator[kLastResolve] = resolve;
        iterator[kLastReject] = reject;
      }
    },
    writable: true
  }), _Object$create));
  iterator[kLastPromise] = null;
  finished(stream, function (err) {
    if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
      var reject = iterator[kLastReject];
      // reject if we are waiting for data in the Promise
      // returned by next() and store the error
      if (reject !== null) {
        iterator[kLastPromise] = null;
        iterator[kLastResolve] = null;
        iterator[kLastReject] = null;
        reject(err);
      }
      iterator[kError] = err;
      return;
    }
    var resolve = iterator[kLastResolve];
    if (resolve !== null) {
      iterator[kLastPromise] = null;
      iterator[kLastResolve] = null;
      iterator[kLastReject] = null;
      resolve(createIterResult(undefined, true));
    }
    iterator[kEnded] = true;
  });
  stream.on('readable', onReadable.bind(null, iterator));
  return iterator;
};
module.exports = createReadableStreamAsyncIterator;
}).call(this)}).call(this,require('_process'))
},{"./end-of-stream":1210,"_process":1185}],1208:[function(require,module,exports){
'use strict';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var _require = require('buffer'),
  Buffer = _require.Buffer;
var _require2 = require('util'),
  inspect = _require2.inspect;
var custom = inspect && inspect.custom || 'inspect';
function copyBuffer(src, target, offset) {
  Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/function () {
  function BufferList() {
    _classCallCheck(this, BufferList);
    this.head = null;
    this.tail = null;
    this.length = 0;
  }
  _createClass(BufferList, [{
    key: "push",
    value: function push(v) {
      var entry = {
        data: v,
        next: null
      };
      if (this.length > 0) this.tail.next = entry;else this.head = entry;
      this.tail = entry;
      ++this.length;
    }
  }, {
    key: "unshift",
    value: function unshift(v) {
      var entry = {
        data: v,
        next: this.head
      };
      if (this.length === 0) this.tail = entry;
      this.head = entry;
      ++this.length;
    }
  }, {
    key: "shift",
    value: function shift() {
      if (this.length === 0) return;
      var ret = this.head.data;
      if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
      --this.length;
      return ret;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.head = this.tail = null;
      this.length = 0;
    }
  }, {
    key: "join",
    value: function join(s) {
      if (this.length === 0) return '';
      var p = this.head;
      var ret = '' + p.data;
      while (p = p.next) ret += s + p.data;
      return ret;
    }
  }, {
    key: "concat",
    value: function concat(n) {
      if (this.length === 0) return Buffer.alloc(0);
      var ret = Buffer.allocUnsafe(n >>> 0);
      var p = this.head;
      var i = 0;
      while (p) {
        copyBuffer(p.data, ret, i);
        i += p.data.length;
        p = p.next;
      }
      return ret;
    }

    // Consumes a specified amount of bytes or characters from the buffered data.
  }, {
    key: "consume",
    value: function consume(n, hasStrings) {
      var ret;
      if (n < this.head.data.length) {
        // `slice` is the same for buffers and strings.
        ret = this.head.data.slice(0, n);
        this.head.data = this.head.data.slice(n);
      } else if (n === this.head.data.length) {
        // First chunk is a perfect match.
        ret = this.shift();
      } else {
        // Result spans more than one buffer.
        ret = hasStrings ? this._getString(n) : this._getBuffer(n);
      }
      return ret;
    }
  }, {
    key: "first",
    value: function first() {
      return this.head.data;
    }

    // Consumes a specified amount of characters from the buffered data.
  }, {
    key: "_getString",
    value: function _getString(n) {
      var p = this.head;
      var c = 1;
      var ret = p.data;
      n -= ret.length;
      while (p = p.next) {
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
          if (nb === str.length) {
            ++c;
            if (p.next) this.head = p.next;else this.head = this.tail = null;
          } else {
            this.head = p;
            p.data = str.slice(nb);
          }
          break;
        }
        ++c;
      }
      this.length -= c;
      return ret;
    }

    // Consumes a specified amount of bytes from the buffered data.
  }, {
    key: "_getBuffer",
    value: function _getBuffer(n) {
      var ret = Buffer.allocUnsafe(n);
      var p = this.head;
      var c = 1;
      p.data.copy(ret);
      n -= p.data.length;
      while (p = p.next) {
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
          if (nb === buf.length) {
            ++c;
            if (p.next) this.head = p.next;else this.head = this.tail = null;
          } else {
            this.head = p;
            p.data = buf.slice(nb);
          }
          break;
        }
        ++c;
      }
      this.length -= c;
      return ret;
    }

    // Make sure the linked list only shows the minimal necessary information.
  }, {
    key: custom,
    value: function value(_, options) {
      return inspect(this, _objectSpread(_objectSpread({}, options), {}, {
        // Only inspect one level.
        depth: 0,
        // It should not recurse.
        customInspect: false
      }));
    }
  }]);
  return BufferList;
}();
},{"buffer":570,"util":566}],1209:[function(require,module,exports){
(function (process){(function (){
'use strict';

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;
  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;
  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err) {
      if (!this._writableState) {
        process.nextTick(emitErrorNT, this, err);
      } else if (!this._writableState.errorEmitted) {
        this._writableState.errorEmitted = true;
        process.nextTick(emitErrorNT, this, err);
      }
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }
  this._destroy(err || null, function (err) {
    if (!cb && err) {
      if (!_this._writableState) {
        process.nextTick(emitErrorAndCloseNT, _this, err);
      } else if (!_this._writableState.errorEmitted) {
        _this._writableState.errorEmitted = true;
        process.nextTick(emitErrorAndCloseNT, _this, err);
      } else {
        process.nextTick(emitCloseNT, _this);
      }
    } else if (cb) {
      process.nextTick(emitCloseNT, _this);
      cb(err);
    } else {
      process.nextTick(emitCloseNT, _this);
    }
  });
  return this;
}
function emitErrorAndCloseNT(self, err) {
  emitErrorNT(self, err);
  emitCloseNT(self);
}
function emitCloseNT(self) {
  if (self._writableState && !self._writableState.emitClose) return;
  if (self._readableState && !self._readableState.emitClose) return;
  self.emit('close');
}
function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }
  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finalCalled = false;
    this._writableState.prefinished = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}
function emitErrorNT(self, err) {
  self.emit('error', err);
}
function errorOrDestroy(stream, err) {
  // We have tests that rely on errors being emitted
  // in the same tick, so changing this is semver major.
  // For now when you opt-in to autoDestroy we allow
  // the error to be emitted nextTick. In a future
  // semver major update we should change the default to this.

  var rState = stream._readableState;
  var wState = stream._writableState;
  if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);else stream.emit('error', err);
}
module.exports = {
  destroy: destroy,
  undestroy: undestroy,
  errorOrDestroy: errorOrDestroy
};
}).call(this)}).call(this,require('_process'))
},{"_process":1185}],1210:[function(require,module,exports){
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).

'use strict';

var ERR_STREAM_PREMATURE_CLOSE = require('../../../errors').codes.ERR_STREAM_PREMATURE_CLOSE;
function once(callback) {
  var called = false;
  return function () {
    if (called) return;
    called = true;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    callback.apply(this, args);
  };
}
function noop() {}
function isRequest(stream) {
  return stream.setHeader && typeof stream.abort === 'function';
}
function eos(stream, opts, callback) {
  if (typeof opts === 'function') return eos(stream, null, opts);
  if (!opts) opts = {};
  callback = once(callback || noop);
  var readable = opts.readable || opts.readable !== false && stream.readable;
  var writable = opts.writable || opts.writable !== false && stream.writable;
  var onlegacyfinish = function onlegacyfinish() {
    if (!stream.writable) onfinish();
  };
  var writableEnded = stream._writableState && stream._writableState.finished;
  var onfinish = function onfinish() {
    writable = false;
    writableEnded = true;
    if (!readable) callback.call(stream);
  };
  var readableEnded = stream._readableState && stream._readableState.endEmitted;
  var onend = function onend() {
    readable = false;
    readableEnded = true;
    if (!writable) callback.call(stream);
  };
  var onerror = function onerror(err) {
    callback.call(stream, err);
  };
  var onclose = function onclose() {
    var err;
    if (readable && !readableEnded) {
      if (!stream._readableState || !stream._readableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
      return callback.call(stream, err);
    }
    if (writable && !writableEnded) {
      if (!stream._writableState || !stream._writableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
      return callback.call(stream, err);
    }
  };
  var onrequest = function onrequest() {
    stream.req.on('finish', onfinish);
  };
  if (isRequest(stream)) {
    stream.on('complete', onfinish);
    stream.on('abort', onclose);
    if (stream.req) onrequest();else stream.on('request', onrequest);
  } else if (writable && !stream._writableState) {
    // legacy streams
    stream.on('end', onlegacyfinish);
    stream.on('close', onlegacyfinish);
  }
  stream.on('end', onend);
  stream.on('finish', onfinish);
  if (opts.error !== false) stream.on('error', onerror);
  stream.on('close', onclose);
  return function () {
    stream.removeListener('complete', onfinish);
    stream.removeListener('abort', onclose);
    stream.removeListener('request', onrequest);
    if (stream.req) stream.req.removeListener('finish', onfinish);
    stream.removeListener('end', onlegacyfinish);
    stream.removeListener('close', onlegacyfinish);
    stream.removeListener('finish', onfinish);
    stream.removeListener('end', onend);
    stream.removeListener('error', onerror);
    stream.removeListener('close', onclose);
  };
}
module.exports = eos;
},{"../../../errors":1201}],1211:[function(require,module,exports){
module.exports = function () {
  throw new Error('Readable.from is not available in the browser')
};

},{}],1212:[function(require,module,exports){
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).

'use strict';

var eos;
function once(callback) {
  var called = false;
  return function () {
    if (called) return;
    called = true;
    callback.apply(void 0, arguments);
  };
}
var _require$codes = require('../../../errors').codes,
  ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS,
  ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED;
function noop(err) {
  // Rethrow the error if it exists to avoid swallowing it
  if (err) throw err;
}
function isRequest(stream) {
  return stream.setHeader && typeof stream.abort === 'function';
}
function destroyer(stream, reading, writing, callback) {
  callback = once(callback);
  var closed = false;
  stream.on('close', function () {
    closed = true;
  });
  if (eos === undefined) eos = require('./end-of-stream');
  eos(stream, {
    readable: reading,
    writable: writing
  }, function (err) {
    if (err) return callback(err);
    closed = true;
    callback();
  });
  var destroyed = false;
  return function (err) {
    if (closed) return;
    if (destroyed) return;
    destroyed = true;

    // request.destroy just do .end - .abort is what we want
    if (isRequest(stream)) return stream.abort();
    if (typeof stream.destroy === 'function') return stream.destroy();
    callback(err || new ERR_STREAM_DESTROYED('pipe'));
  };
}
function call(fn) {
  fn();
}
function pipe(from, to) {
  return from.pipe(to);
}
function popCallback(streams) {
  if (!streams.length) return noop;
  if (typeof streams[streams.length - 1] !== 'function') return noop;
  return streams.pop();
}
function pipeline() {
  for (var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++) {
    streams[_key] = arguments[_key];
  }
  var callback = popCallback(streams);
  if (Array.isArray(streams[0])) streams = streams[0];
  if (streams.length < 2) {
    throw new ERR_MISSING_ARGS('streams');
  }
  var error;
  var destroys = streams.map(function (stream, i) {
    var reading = i < streams.length - 1;
    var writing = i > 0;
    return destroyer(stream, reading, writing, function (err) {
      if (!error) error = err;
      if (err) destroys.forEach(call);
      if (reading) return;
      destroys.forEach(call);
      callback(error);
    });
  });
  return streams.reduce(pipe);
}
module.exports = pipeline;
},{"../../../errors":1201,"./end-of-stream":1210}],1213:[function(require,module,exports){
'use strict';

var ERR_INVALID_OPT_VALUE = require('../../../errors').codes.ERR_INVALID_OPT_VALUE;
function highWaterMarkFrom(options, isDuplex, duplexKey) {
  return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function getHighWaterMark(state, options, duplexKey, isDuplex) {
  var hwm = highWaterMarkFrom(options, isDuplex, duplexKey);
  if (hwm != null) {
    if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
      var name = isDuplex ? duplexKey : 'highWaterMark';
      throw new ERR_INVALID_OPT_VALUE(name, hwm);
    }
    return Math.floor(hwm);
  }

  // Default value
  return state.objectMode ? 16 : 16 * 1024;
}
module.exports = {
  getHighWaterMark: getHighWaterMark
};
},{"../../../errors":1201}],1214:[function(require,module,exports){
module.exports = require('events').EventEmitter;

},{"events":1102}],1215:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

/*<replacement>*/

var Buffer = require('safe-buffer').Buffer;
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}
},{"safe-buffer":1186}],1216:[function(require,module,exports){
(function (setImmediate,clearImmediate){(function (){
var nextTick = require('process/browser.js').nextTick;
var apply = Function.prototype.apply;
var slice = Array.prototype.slice;
var immediateIds = {};
var nextImmediateId = 0;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) { timeout.close(); };

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// That's not how node.js implements it but the exposed api is the same.
exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function(fn) {
  var id = nextImmediateId++;
  var args = arguments.length < 2 ? false : slice.call(arguments, 1);

  immediateIds[id] = true;

  nextTick(function onNextTick() {
    if (immediateIds[id]) {
      // fn.call() is faster so we optimize for the common use-case
      // @see http://jsperf.com/call-apply-segu
      if (args) {
        fn.apply(null, args);
      } else {
        fn.call(null);
      }
      // Prevent ids from leaking
      exports.clearImmediate(id);
    }
  });

  return id;
};

exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function(id) {
  delete immediateIds[id];
};
}).call(this)}).call(this,require("timers").setImmediate,require("timers").clearImmediate)
},{"process/browser.js":1185,"timers":1216}],1217:[function(require,module,exports){
(function (global){(function (){
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define('underscore', factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, (function () {
    var current = global._;
    var exports = global._ = factory();
    exports.noConflict = function () { global._ = current; return exports; };
  }()));
}(this, (function () {
  //     Underscore.js 1.13.6
  //     https://underscorejs.org
  //     (c) 2009-2022 Jeremy Ashkenas, Julian Gonggrijp, and DocumentCloud and Investigative Reporters & Editors
  //     Underscore may be freely distributed under the MIT license.

  // Current version.
  var VERSION = '1.13.6';

  // Establish the root object, `window` (`self`) in the browser, `global`
  // on the server, or `this` in some virtual machines. We use `self`
  // instead of `window` for `WebWorker` support.
  var root = (typeof self == 'object' && self.self === self && self) ||
            (typeof global == 'object' && global.global === global && global) ||
            Function('return this')() ||
            {};

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype;
  var SymbolProto = typeof Symbol !== 'undefined' ? Symbol.prototype : null;

  // Create quick reference variables for speed access to core prototypes.
  var push = ArrayProto.push,
      slice = ArrayProto.slice,
      toString = ObjProto.toString,
      hasOwnProperty = ObjProto.hasOwnProperty;

  // Modern feature detection.
  var supportsArrayBuffer = typeof ArrayBuffer !== 'undefined',
      supportsDataView = typeof DataView !== 'undefined';

  // All **ECMAScript 5+** native function implementations that we hope to use
  // are declared here.
  var nativeIsArray = Array.isArray,
      nativeKeys = Object.keys,
      nativeCreate = Object.create,
      nativeIsView = supportsArrayBuffer && ArrayBuffer.isView;

  // Create references to these builtin functions because we override them.
  var _isNaN = isNaN,
      _isFinite = isFinite;

  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
    'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

  // The largest integer that can be represented exactly.
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;

  // Some functions take a variable number of arguments, or a few expected
  // arguments at the beginning and then a variable number of values to operate
  // on. This helper accumulates all remaining arguments past the function’s
  // argument length (or an explicit `startIndex`), into an array that becomes
  // the last argument. Similar to ES6’s "rest parameter".
  function restArguments(func, startIndex) {
    startIndex = startIndex == null ? func.length - 1 : +startIndex;
    return function() {
      var length = Math.max(arguments.length - startIndex, 0),
          rest = Array(length),
          index = 0;
      for (; index < length; index++) {
        rest[index] = arguments[index + startIndex];
      }
      switch (startIndex) {
        case 0: return func.call(this, rest);
        case 1: return func.call(this, arguments[0], rest);
        case 2: return func.call(this, arguments[0], arguments[1], rest);
      }
      var args = Array(startIndex + 1);
      for (index = 0; index < startIndex; index++) {
        args[index] = arguments[index];
      }
      args[startIndex] = rest;
      return func.apply(this, args);
    };
  }

  // Is a given variable an object?
  function isObject(obj) {
    var type = typeof obj;
    return type === 'function' || (type === 'object' && !!obj);
  }

  // Is a given value equal to null?
  function isNull(obj) {
    return obj === null;
  }

  // Is a given variable undefined?
  function isUndefined(obj) {
    return obj === void 0;
  }

  // Is a given value a boolean?
  function isBoolean(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  }

  // Is a given value a DOM element?
  function isElement(obj) {
    return !!(obj && obj.nodeType === 1);
  }

  // Internal function for creating a `toString`-based type tester.
  function tagTester(name) {
    var tag = '[object ' + name + ']';
    return function(obj) {
      return toString.call(obj) === tag;
    };
  }

  var isString = tagTester('String');

  var isNumber = tagTester('Number');

  var isDate = tagTester('Date');

  var isRegExp = tagTester('RegExp');

  var isError = tagTester('Error');

  var isSymbol = tagTester('Symbol');

  var isArrayBuffer = tagTester('ArrayBuffer');

  var isFunction = tagTester('Function');

  // Optimize `isFunction` if appropriate. Work around some `typeof` bugs in old
  // v8, IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
  var nodelist = root.document && root.document.childNodes;
  if (typeof /./ != 'function' && typeof Int8Array != 'object' && typeof nodelist != 'function') {
    isFunction = function(obj) {
      return typeof obj == 'function' || false;
    };
  }

  var isFunction$1 = isFunction;

  var hasObjectTag = tagTester('Object');

  // In IE 10 - Edge 13, `DataView` has string tag `'[object Object]'`.
  // In IE 11, the most common among them, this problem also applies to
  // `Map`, `WeakMap` and `Set`.
  var hasStringTagBug = (
        supportsDataView && hasObjectTag(new DataView(new ArrayBuffer(8)))
      ),
      isIE11 = (typeof Map !== 'undefined' && hasObjectTag(new Map));

  var isDataView = tagTester('DataView');

  // In IE 10 - Edge 13, we need a different heuristic
  // to determine whether an object is a `DataView`.
  function ie10IsDataView(obj) {
    return obj != null && isFunction$1(obj.getInt8) && isArrayBuffer(obj.buffer);
  }

  var isDataView$1 = (hasStringTagBug ? ie10IsDataView : isDataView);

  // Is a given value an array?
  // Delegates to ECMA5's native `Array.isArray`.
  var isArray = nativeIsArray || tagTester('Array');

  // Internal function to check whether `key` is an own property name of `obj`.
  function has$1(obj, key) {
    return obj != null && hasOwnProperty.call(obj, key);
  }

  var isArguments = tagTester('Arguments');

  // Define a fallback version of the method in browsers (ahem, IE < 9), where
  // there isn't any inspectable "Arguments" type.
  (function() {
    if (!isArguments(arguments)) {
      isArguments = function(obj) {
        return has$1(obj, 'callee');
      };
    }
  }());

  var isArguments$1 = isArguments;

  // Is a given object a finite number?
  function isFinite$1(obj) {
    return !isSymbol(obj) && _isFinite(obj) && !isNaN(parseFloat(obj));
  }

  // Is the given value `NaN`?
  function isNaN$1(obj) {
    return isNumber(obj) && _isNaN(obj);
  }

  // Predicate-generating function. Often useful outside of Underscore.
  function constant(value) {
    return function() {
      return value;
    };
  }

  // Common internal logic for `isArrayLike` and `isBufferLike`.
  function createSizePropertyCheck(getSizeProperty) {
    return function(collection) {
      var sizeProperty = getSizeProperty(collection);
      return typeof sizeProperty == 'number' && sizeProperty >= 0 && sizeProperty <= MAX_ARRAY_INDEX;
    }
  }

  // Internal helper to generate a function to obtain property `key` from `obj`.
  function shallowProperty(key) {
    return function(obj) {
      return obj == null ? void 0 : obj[key];
    };
  }

  // Internal helper to obtain the `byteLength` property of an object.
  var getByteLength = shallowProperty('byteLength');

  // Internal helper to determine whether we should spend extensive checks against
  // `ArrayBuffer` et al.
  var isBufferLike = createSizePropertyCheck(getByteLength);

  // Is a given value a typed array?
  var typedArrayPattern = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/;
  function isTypedArray(obj) {
    // `ArrayBuffer.isView` is the most future-proof, so use it when available.
    // Otherwise, fall back on the above regular expression.
    return nativeIsView ? (nativeIsView(obj) && !isDataView$1(obj)) :
                  isBufferLike(obj) && typedArrayPattern.test(toString.call(obj));
  }

  var isTypedArray$1 = supportsArrayBuffer ? isTypedArray : constant(false);

  // Internal helper to obtain the `length` property of an object.
  var getLength = shallowProperty('length');

  // Internal helper to create a simple lookup structure.
  // `collectNonEnumProps` used to depend on `_.contains`, but this led to
  // circular imports. `emulatedSet` is a one-off solution that only works for
  // arrays of strings.
  function emulatedSet(keys) {
    var hash = {};
    for (var l = keys.length, i = 0; i < l; ++i) hash[keys[i]] = true;
    return {
      contains: function(key) { return hash[key] === true; },
      push: function(key) {
        hash[key] = true;
        return keys.push(key);
      }
    };
  }

  // Internal helper. Checks `keys` for the presence of keys in IE < 9 that won't
  // be iterated by `for key in ...` and thus missed. Extends `keys` in place if
  // needed.
  function collectNonEnumProps(obj, keys) {
    keys = emulatedSet(keys);
    var nonEnumIdx = nonEnumerableProps.length;
    var constructor = obj.constructor;
    var proto = (isFunction$1(constructor) && constructor.prototype) || ObjProto;

    // Constructor is a special case.
    var prop = 'constructor';
    if (has$1(obj, prop) && !keys.contains(prop)) keys.push(prop);

    while (nonEnumIdx--) {
      prop = nonEnumerableProps[nonEnumIdx];
      if (prop in obj && obj[prop] !== proto[prop] && !keys.contains(prop)) {
        keys.push(prop);
      }
    }
  }

  // Retrieve the names of an object's own properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`.
  function keys(obj) {
    if (!isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (has$1(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  }

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  function isEmpty(obj) {
    if (obj == null) return true;
    // Skip the more expensive `toString`-based type checks if `obj` has no
    // `.length`.
    var length = getLength(obj);
    if (typeof length == 'number' && (
      isArray(obj) || isString(obj) || isArguments$1(obj)
    )) return length === 0;
    return getLength(keys(obj)) === 0;
  }

  // Returns whether an object has a given set of `key:value` pairs.
  function isMatch(object, attrs) {
    var _keys = keys(attrs), length = _keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = _keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
  }

  // If Underscore is called as a function, it returns a wrapped object that can
  // be used OO-style. This wrapper holds altered versions of all functions added
  // through `_.mixin`. Wrapped objects may be chained.
  function _$1(obj) {
    if (obj instanceof _$1) return obj;
    if (!(this instanceof _$1)) return new _$1(obj);
    this._wrapped = obj;
  }

  _$1.VERSION = VERSION;

  // Extracts the result from a wrapped and chained object.
  _$1.prototype.value = function() {
    return this._wrapped;
  };

  // Provide unwrapping proxies for some methods used in engine operations
  // such as arithmetic and JSON stringification.
  _$1.prototype.valueOf = _$1.prototype.toJSON = _$1.prototype.value;

  _$1.prototype.toString = function() {
    return String(this._wrapped);
  };

  // Internal function to wrap or shallow-copy an ArrayBuffer,
  // typed array or DataView to a new view, reusing the buffer.
  function toBufferView(bufferSource) {
    return new Uint8Array(
      bufferSource.buffer || bufferSource,
      bufferSource.byteOffset || 0,
      getByteLength(bufferSource)
    );
  }

  // We use this string twice, so give it a name for minification.
  var tagDataView = '[object DataView]';

  // Internal recursive comparison function for `_.isEqual`.
  function eq(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](https://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== 'function' && type !== 'object' && typeof b != 'object') return false;
    return deepEq(a, b, aStack, bStack);
  }

  // Internal recursive comparison function for `_.isEqual`.
  function deepEq(a, b, aStack, bStack) {
    // Unwrap any wrapped objects.
    if (a instanceof _$1) a = a._wrapped;
    if (b instanceof _$1) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    // Work around a bug in IE 10 - Edge 13.
    if (hasStringTagBug && className == '[object Object]' && isDataView$1(a)) {
      if (!isDataView$1(b)) return false;
      className = tagDataView;
    }
    switch (className) {
      // These types are compared by value.
      case '[object RegExp]':
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN.
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
      case '[object Symbol]':
        return SymbolProto.valueOf.call(a) === SymbolProto.valueOf.call(b);
      case '[object ArrayBuffer]':
      case tagDataView:
        // Coerce to typed array so we can fall through.
        return deepEq(toBufferView(a), toBufferView(b), aStack, bStack);
    }

    var areArrays = className === '[object Array]';
    if (!areArrays && isTypedArray$1(a)) {
        var byteLength = getByteLength(a);
        if (byteLength !== getByteLength(b)) return false;
        if (a.buffer === b.buffer && a.byteOffset === b.byteOffset) return true;
        areArrays = true;
    }
    if (!areArrays) {
      if (typeof a != 'object' || typeof b != 'object') return false;

      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
      // from different frames are.
      var aCtor = a.constructor, bCtor = b.constructor;
      if (aCtor !== bCtor && !(isFunction$1(aCtor) && aCtor instanceof aCtor &&
                               isFunction$1(bCtor) && bCtor instanceof bCtor)
                          && ('constructor' in a && 'constructor' in b)) {
        return false;
      }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
      // Compare array lengths to determine if a deep comparison is necessary.
      length = a.length;
      if (length !== b.length) return false;
      // Deep compare the contents, ignoring non-numeric properties.
      while (length--) {
        if (!eq(a[length], b[length], aStack, bStack)) return false;
      }
    } else {
      // Deep compare objects.
      var _keys = keys(a), key;
      length = _keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      if (keys(b).length !== length) return false;
      while (length--) {
        // Deep compare each member
        key = _keys[length];
        if (!(has$1(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
  }

  // Perform a deep comparison to check if two objects are equal.
  function isEqual(a, b) {
    return eq(a, b);
  }

  // Retrieve all the enumerable property names of an object.
  function allKeys(obj) {
    if (!isObject(obj)) return [];
    var keys = [];
    for (var key in obj) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  }

  // Since the regular `Object.prototype.toString` type tests don't work for
  // some types in IE 11, we use a fingerprinting heuristic instead, based
  // on the methods. It's not great, but it's the best we got.
  // The fingerprint method lists are defined below.
  function ie11fingerprint(methods) {
    var length = getLength(methods);
    return function(obj) {
      if (obj == null) return false;
      // `Map`, `WeakMap` and `Set` have no enumerable keys.
      var keys = allKeys(obj);
      if (getLength(keys)) return false;
      for (var i = 0; i < length; i++) {
        if (!isFunction$1(obj[methods[i]])) return false;
      }
      // If we are testing against `WeakMap`, we need to ensure that
      // `obj` doesn't have a `forEach` method in order to distinguish
      // it from a regular `Map`.
      return methods !== weakMapMethods || !isFunction$1(obj[forEachName]);
    };
  }

  // In the interest of compact minification, we write
  // each string in the fingerprints only once.
  var forEachName = 'forEach',
      hasName = 'has',
      commonInit = ['clear', 'delete'],
      mapTail = ['get', hasName, 'set'];

  // `Map`, `WeakMap` and `Set` each have slightly different
  // combinations of the above sublists.
  var mapMethods = commonInit.concat(forEachName, mapTail),
      weakMapMethods = commonInit.concat(mapTail),
      setMethods = ['add'].concat(commonInit, forEachName, hasName);

  var isMap = isIE11 ? ie11fingerprint(mapMethods) : tagTester('Map');

  var isWeakMap = isIE11 ? ie11fingerprint(weakMapMethods) : tagTester('WeakMap');

  var isSet = isIE11 ? ie11fingerprint(setMethods) : tagTester('Set');

  var isWeakSet = tagTester('WeakSet');

  // Retrieve the values of an object's properties.
  function values(obj) {
    var _keys = keys(obj);
    var length = _keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[_keys[i]];
    }
    return values;
  }

  // Convert an object into a list of `[key, value]` pairs.
  // The opposite of `_.object` with one argument.
  function pairs(obj) {
    var _keys = keys(obj);
    var length = _keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [_keys[i], obj[_keys[i]]];
    }
    return pairs;
  }

  // Invert the keys and values of an object. The values must be serializable.
  function invert(obj) {
    var result = {};
    var _keys = keys(obj);
    for (var i = 0, length = _keys.length; i < length; i++) {
      result[obj[_keys[i]]] = _keys[i];
    }
    return result;
  }

  // Return a sorted list of the function names available on the object.
  function functions(obj) {
    var names = [];
    for (var key in obj) {
      if (isFunction$1(obj[key])) names.push(key);
    }
    return names.sort();
  }

  // An internal function for creating assigner functions.
  function createAssigner(keysFunc, defaults) {
    return function(obj) {
      var length = arguments.length;
      if (defaults) obj = Object(obj);
      if (length < 2 || obj == null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index],
            keys = keysFunc(source),
            l = keys.length;
        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!defaults || obj[key] === void 0) obj[key] = source[key];
        }
      }
      return obj;
    };
  }

  // Extend a given object with all the properties in passed-in object(s).
  var extend = createAssigner(allKeys);

  // Assigns a given object with all the own properties in the passed-in
  // object(s).
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  var extendOwn = createAssigner(keys);

  // Fill in a given object with default properties.
  var defaults = createAssigner(allKeys, true);

  // Create a naked function reference for surrogate-prototype-swapping.
  function ctor() {
    return function(){};
  }

  // An internal function for creating a new object that inherits from another.
  function baseCreate(prototype) {
    if (!isObject(prototype)) return {};
    if (nativeCreate) return nativeCreate(prototype);
    var Ctor = ctor();
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
  }

  // Creates an object that inherits from the given prototype object.
  // If additional properties are provided then they will be added to the
  // created object.
  function create(prototype, props) {
    var result = baseCreate(prototype);
    if (props) extendOwn(result, props);
    return result;
  }

  // Create a (shallow-cloned) duplicate of an object.
  function clone(obj) {
    if (!isObject(obj)) return obj;
    return isArray(obj) ? obj.slice() : extend({}, obj);
  }

  // Invokes `interceptor` with the `obj` and then returns `obj`.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  function tap(obj, interceptor) {
    interceptor(obj);
    return obj;
  }

  // Normalize a (deep) property `path` to array.
  // Like `_.iteratee`, this function can be customized.
  function toPath$1(path) {
    return isArray(path) ? path : [path];
  }
  _$1.toPath = toPath$1;

  // Internal wrapper for `_.toPath` to enable minification.
  // Similar to `cb` for `_.iteratee`.
  function toPath(path) {
    return _$1.toPath(path);
  }

  // Internal function to obtain a nested property in `obj` along `path`.
  function deepGet(obj, path) {
    var length = path.length;
    for (var i = 0; i < length; i++) {
      if (obj == null) return void 0;
      obj = obj[path[i]];
    }
    return length ? obj : void 0;
  }

  // Get the value of the (deep) property on `path` from `object`.
  // If any property in `path` does not exist or if the value is
  // `undefined`, return `defaultValue` instead.
  // The `path` is normalized through `_.toPath`.
  function get(object, path, defaultValue) {
    var value = deepGet(object, toPath(path));
    return isUndefined(value) ? defaultValue : value;
  }

  // Shortcut function for checking if an object has a given property directly on
  // itself (in other words, not on a prototype). Unlike the internal `has`
  // function, this public version can also traverse nested properties.
  function has(obj, path) {
    path = toPath(path);
    var length = path.length;
    for (var i = 0; i < length; i++) {
      var key = path[i];
      if (!has$1(obj, key)) return false;
      obj = obj[key];
    }
    return !!length;
  }

  // Keep the identity function around for default iteratees.
  function identity(value) {
    return value;
  }

  // Returns a predicate for checking whether an object has a given set of
  // `key:value` pairs.
  function matcher(attrs) {
    attrs = extendOwn({}, attrs);
    return function(obj) {
      return isMatch(obj, attrs);
    };
  }

  // Creates a function that, when passed an object, will traverse that object’s
  // properties down the given `path`, specified as an array of keys or indices.
  function property(path) {
    path = toPath(path);
    return function(obj) {
      return deepGet(obj, path);
    };
  }

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  function optimizeCb(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };
      // The 2-argument case is omitted because we’re not using it.
      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  }

  // An internal function to generate callbacks that can be applied to each
  // element in a collection, returning the desired result — either `_.identity`,
  // an arbitrary callback, a property matcher, or a property accessor.
  function baseIteratee(value, context, argCount) {
    if (value == null) return identity;
    if (isFunction$1(value)) return optimizeCb(value, context, argCount);
    if (isObject(value) && !isArray(value)) return matcher(value);
    return property(value);
  }

  // External wrapper for our callback generator. Users may customize
  // `_.iteratee` if they want additional predicate/iteratee shorthand styles.
  // This abstraction hides the internal-only `argCount` argument.
  function iteratee(value, context) {
    return baseIteratee(value, context, Infinity);
  }
  _$1.iteratee = iteratee;

  // The function we call internally to generate a callback. It invokes
  // `_.iteratee` if overridden, otherwise `baseIteratee`.
  function cb(value, context, argCount) {
    if (_$1.iteratee !== iteratee) return _$1.iteratee(value, context);
    return baseIteratee(value, context, argCount);
  }

  // Returns the results of applying the `iteratee` to each element of `obj`.
  // In contrast to `_.map` it returns an object.
  function mapObject(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var _keys = keys(obj),
        length = _keys.length,
        results = {};
    for (var index = 0; index < length; index++) {
      var currentKey = _keys[index];
      results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  }

  // Predicate-generating function. Often useful outside of Underscore.
  function noop(){}

  // Generates a function for a given object that returns a given property.
  function propertyOf(obj) {
    if (obj == null) return noop;
    return function(path) {
      return get(obj, path);
    };
  }

  // Run a function **n** times.
  function times(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = optimizeCb(iteratee, context, 1);
    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
    return accum;
  }

  // Return a random integer between `min` and `max` (inclusive).
  function random(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  }

  // A (possibly faster) way to get the current timestamp as an integer.
  var now = Date.now || function() {
    return new Date().getTime();
  };

  // Internal helper to generate functions for escaping and unescaping strings
  // to/from HTML interpolation.
  function createEscaper(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped.
    var source = '(?:' + keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  }

  // Internal list of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };

  // Function for escaping strings to HTML interpolation.
  var _escape = createEscaper(escapeMap);

  // Internal list of HTML entities for unescaping.
  var unescapeMap = invert(escapeMap);

  // Function for unescaping strings from HTML interpolation.
  var _unescape = createEscaper(unescapeMap);

  // By default, Underscore uses ERB-style template delimiters. Change the
  // following template settings to use alternative delimiters.
  var templateSettings = _$1.templateSettings = {
    evaluate: /<%([\s\S]+?)%>/g,
    interpolate: /<%=([\s\S]+?)%>/g,
    escape: /<%-([\s\S]+?)%>/g
  };

  // When customizing `_.templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'": "'",
    '\\': '\\',
    '\r': 'r',
    '\n': 'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;

  function escapeChar(match) {
    return '\\' + escapes[match];
  }

  // In order to prevent third-party code injection through
  // `_.templateSettings.variable`, we test it against the following regular
  // expression. It is intentionally a bit more liberal than just matching valid
  // identifiers, but still prevents possible loopholes through defaults or
  // destructuring assignment.
  var bareIdentifier = /^\s*(\w|\$)+\s*$/;

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  function template(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = defaults({}, settings, _$1.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escapeRegExp, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offset.
      return match;
    });
    source += "';\n";

    var argument = settings.variable;
    if (argument) {
      // Insure against third-party code injection. (CVE-2021-23358)
      if (!bareIdentifier.test(argument)) throw new Error(
        'variable is not a bare identifier: ' + argument
      );
    } else {
      // If a variable is not specified, place data values in local scope.
      source = 'with(obj||{}){\n' + source + '}\n';
      argument = 'obj';
    }

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + 'return __p;\n';

    var render;
    try {
      render = new Function(argument, '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function(data) {
      return render.call(this, data, _$1);
    };

    // Provide the compiled source as a convenience for precompilation.
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  }

  // Traverses the children of `obj` along `path`. If a child is a function, it
  // is invoked with its parent as context. Returns the value of the final
  // child, or `fallback` if any child is undefined.
  function result(obj, path, fallback) {
    path = toPath(path);
    var length = path.length;
    if (!length) {
      return isFunction$1(fallback) ? fallback.call(obj) : fallback;
    }
    for (var i = 0; i < length; i++) {
      var prop = obj == null ? void 0 : obj[path[i]];
      if (prop === void 0) {
        prop = fallback;
        i = length; // Ensure we don't continue iterating.
      }
      obj = isFunction$1(prop) ? prop.call(obj) : prop;
    }
    return obj;
  }

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  function uniqueId(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  }

  // Start chaining a wrapped Underscore object.
  function chain(obj) {
    var instance = _$1(obj);
    instance._chain = true;
    return instance;
  }

  // Internal function to execute `sourceFunc` bound to `context` with optional
  // `args`. Determines whether to execute a function as a constructor or as a
  // normal function.
  function executeBound(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (isObject(result)) return result;
    return self;
  }

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. `_` acts
  // as a placeholder by default, allowing any combination of arguments to be
  // pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
  var partial = restArguments(function(func, boundArgs) {
    var placeholder = partial.placeholder;
    var bound = function() {
      var position = 0, length = boundArgs.length;
      var args = Array(length);
      for (var i = 0; i < length; i++) {
        args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return executeBound(func, bound, this, this, args);
    };
    return bound;
  });

  partial.placeholder = _$1;

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally).
  var bind = restArguments(function(func, context, args) {
    if (!isFunction$1(func)) throw new TypeError('Bind must be called on a function');
    var bound = restArguments(function(callArgs) {
      return executeBound(func, bound, context, this, args.concat(callArgs));
    });
    return bound;
  });

  // Internal helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object.
  // Related: https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
  var isArrayLike = createSizePropertyCheck(getLength);

  // Internal implementation of a recursive `flatten` function.
  function flatten$1(input, depth, strict, output) {
    output = output || [];
    if (!depth && depth !== 0) {
      depth = Infinity;
    } else if (depth <= 0) {
      return output.concat(input);
    }
    var idx = output.length;
    for (var i = 0, length = getLength(input); i < length; i++) {
      var value = input[i];
      if (isArrayLike(value) && (isArray(value) || isArguments$1(value))) {
        // Flatten current level of array or arguments object.
        if (depth > 1) {
          flatten$1(value, depth - 1, strict, output);
          idx = output.length;
        } else {
          var j = 0, len = value.length;
          while (j < len) output[idx++] = value[j++];
        }
      } else if (!strict) {
        output[idx++] = value;
      }
    }
    return output;
  }

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  var bindAll = restArguments(function(obj, keys) {
    keys = flatten$1(keys, false, false);
    var index = keys.length;
    if (index < 1) throw new Error('bindAll must be passed function names');
    while (index--) {
      var key = keys[index];
      obj[key] = bind(obj[key], obj);
    }
    return obj;
  });

  // Memoize an expensive function by storing its results.
  function memoize(func, hasher) {
    var memoize = function(key) {
      var cache = memoize.cache;
      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
      if (!has$1(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  }

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  var delay = restArguments(function(func, wait, args) {
    return setTimeout(function() {
      return func.apply(null, args);
    }, wait);
  });

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  var defer = partial(delay, _$1, 1);

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  function throttle(func, wait, options) {
    var timeout, context, args, result;
    var previous = 0;
    if (!options) options = {};

    var later = function() {
      previous = options.leading === false ? 0 : now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };

    var throttled = function() {
      var _now = now();
      if (!previous && options.leading === false) previous = _now;
      var remaining = wait - (_now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = _now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };

    throttled.cancel = function() {
      clearTimeout(timeout);
      previous = 0;
      timeout = context = args = null;
    };

    return throttled;
  }

  // When a sequence of calls of the returned function ends, the argument
  // function is triggered. The end of a sequence is defined by the `wait`
  // parameter. If `immediate` is passed, the argument function will be
  // triggered at the beginning of the sequence instead of at the end.
  function debounce(func, wait, immediate) {
    var timeout, previous, args, result, context;

    var later = function() {
      var passed = now() - previous;
      if (wait > passed) {
        timeout = setTimeout(later, wait - passed);
      } else {
        timeout = null;
        if (!immediate) result = func.apply(context, args);
        // This check is needed because `func` can recursively invoke `debounced`.
        if (!timeout) args = context = null;
      }
    };

    var debounced = restArguments(function(_args) {
      context = this;
      args = _args;
      previous = now();
      if (!timeout) {
        timeout = setTimeout(later, wait);
        if (immediate) result = func.apply(context, args);
      }
      return result;
    });

    debounced.cancel = function() {
      clearTimeout(timeout);
      timeout = args = context = null;
    };

    return debounced;
  }

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  function wrap(func, wrapper) {
    return partial(wrapper, func);
  }

  // Returns a negated version of the passed-in predicate.
  function negate(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    };
  }

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  function compose() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  }

  // Returns a function that will only be executed on and after the Nth call.
  function after(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  }

  // Returns a function that will only be executed up to (but not including) the
  // Nth call.
  function before(times, func) {
    var memo;
    return function() {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }
      if (times <= 1) func = null;
      return memo;
    };
  }

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  var once = partial(before, 2);

  // Returns the first key on an object that passes a truth test.
  function findKey(obj, predicate, context) {
    predicate = cb(predicate, context);
    var _keys = keys(obj), key;
    for (var i = 0, length = _keys.length; i < length; i++) {
      key = _keys[i];
      if (predicate(obj[key], key, obj)) return key;
    }
  }

  // Internal function to generate `_.findIndex` and `_.findLastIndex`.
  function createPredicateIndexFinder(dir) {
    return function(array, predicate, context) {
      predicate = cb(predicate, context);
      var length = getLength(array);
      var index = dir > 0 ? 0 : length - 1;
      for (; index >= 0 && index < length; index += dir) {
        if (predicate(array[index], index, array)) return index;
      }
      return -1;
    };
  }

  // Returns the first index on an array-like that passes a truth test.
  var findIndex = createPredicateIndexFinder(1);

  // Returns the last index on an array-like that passes a truth test.
  var findLastIndex = createPredicateIndexFinder(-1);

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  function sortedIndex(array, obj, iteratee, context) {
    iteratee = cb(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = getLength(array);
    while (low < high) {
      var mid = Math.floor((low + high) / 2);
      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
    }
    return low;
  }

  // Internal function to generate the `_.indexOf` and `_.lastIndexOf` functions.
  function createIndexFinder(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
      var i = 0, length = getLength(array);
      if (typeof idx == 'number') {
        if (dir > 0) {
          i = idx >= 0 ? idx : Math.max(idx + length, i);
        } else {
          length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        }
      } else if (sortedIndex && idx && length) {
        idx = sortedIndex(array, item);
        return array[idx] === item ? idx : -1;
      }
      if (item !== item) {
        idx = predicateFind(slice.call(array, i, length), isNaN$1);
        return idx >= 0 ? idx + i : -1;
      }
      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
        if (array[idx] === item) return idx;
      }
      return -1;
    };
  }

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  var indexOf = createIndexFinder(1, findIndex, sortedIndex);

  // Return the position of the last occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  var lastIndexOf = createIndexFinder(-1, findLastIndex);

  // Return the first value which passes a truth test.
  function find(obj, predicate, context) {
    var keyFinder = isArrayLike(obj) ? findIndex : findKey;
    var key = keyFinder(obj, predicate, context);
    if (key !== void 0 && key !== -1) return obj[key];
  }

  // Convenience version of a common use case of `_.find`: getting the first
  // object containing specific `key:value` pairs.
  function findWhere(obj, attrs) {
    return find(obj, matcher(attrs));
  }

  // The cornerstone for collection functions, an `each`
  // implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  function each(obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    var i, length;
    if (isArrayLike(obj)) {
      for (i = 0, length = obj.length; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var _keys = keys(obj);
      for (i = 0, length = _keys.length; i < length; i++) {
        iteratee(obj[_keys[i]], _keys[i], obj);
      }
    }
    return obj;
  }

  // Return the results of applying the iteratee to each element.
  function map(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var _keys = !isArrayLike(obj) && keys(obj),
        length = (_keys || obj).length,
        results = Array(length);
    for (var index = 0; index < length; index++) {
      var currentKey = _keys ? _keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  }

  // Internal helper to create a reducing function, iterating left or right.
  function createReduce(dir) {
    // Wrap code that reassigns argument variables in a separate function than
    // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
    var reducer = function(obj, iteratee, memo, initial) {
      var _keys = !isArrayLike(obj) && keys(obj),
          length = (_keys || obj).length,
          index = dir > 0 ? 0 : length - 1;
      if (!initial) {
        memo = obj[_keys ? _keys[index] : index];
        index += dir;
      }
      for (; index >= 0 && index < length; index += dir) {
        var currentKey = _keys ? _keys[index] : index;
        memo = iteratee(memo, obj[currentKey], currentKey, obj);
      }
      return memo;
    };

    return function(obj, iteratee, memo, context) {
      var initial = arguments.length >= 3;
      return reducer(obj, optimizeCb(iteratee, context, 4), memo, initial);
    };
  }

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  var reduce = createReduce(1);

  // The right-associative version of reduce, also known as `foldr`.
  var reduceRight = createReduce(-1);

  // Return all the elements that pass a truth test.
  function filter(obj, predicate, context) {
    var results = [];
    predicate = cb(predicate, context);
    each(obj, function(value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  }

  // Return all the elements for which a truth test fails.
  function reject(obj, predicate, context) {
    return filter(obj, negate(cb(predicate)), context);
  }

  // Determine whether all of the elements pass a truth test.
  function every(obj, predicate, context) {
    predicate = cb(predicate, context);
    var _keys = !isArrayLike(obj) && keys(obj),
        length = (_keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = _keys ? _keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  }

  // Determine if at least one element in the object passes a truth test.
  function some(obj, predicate, context) {
    predicate = cb(predicate, context);
    var _keys = !isArrayLike(obj) && keys(obj),
        length = (_keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = _keys ? _keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  }

  // Determine if the array or object contains a given item (using `===`).
  function contains(obj, item, fromIndex, guard) {
    if (!isArrayLike(obj)) obj = values(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return indexOf(obj, item, fromIndex) >= 0;
  }

  // Invoke a method (with arguments) on every item in a collection.
  var invoke = restArguments(function(obj, path, args) {
    var contextPath, func;
    if (isFunction$1(path)) {
      func = path;
    } else {
      path = toPath(path);
      contextPath = path.slice(0, -1);
      path = path[path.length - 1];
    }
    return map(obj, function(context) {
      var method = func;
      if (!method) {
        if (contextPath && contextPath.length) {
          context = deepGet(context, contextPath);
        }
        if (context == null) return void 0;
        method = context[path];
      }
      return method == null ? method : method.apply(context, args);
    });
  });

  // Convenience version of a common use case of `_.map`: fetching a property.
  function pluck(obj, key) {
    return map(obj, property(key));
  }

  // Convenience version of a common use case of `_.filter`: selecting only
  // objects containing specific `key:value` pairs.
  function where(obj, attrs) {
    return filter(obj, matcher(attrs));
  }

  // Return the maximum element (or element-based computation).
  function max(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity,
        value, computed;
    if (iteratee == null || (typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null)) {
      obj = isArrayLike(obj) ? obj : values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value != null && value > result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      each(obj, function(v, index, list) {
        computed = iteratee(v, index, list);
        if (computed > lastComputed || (computed === -Infinity && result === -Infinity)) {
          result = v;
          lastComputed = computed;
        }
      });
    }
    return result;
  }

  // Return the minimum element (or element-based computation).
  function min(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity,
        value, computed;
    if (iteratee == null || (typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null)) {
      obj = isArrayLike(obj) ? obj : values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value != null && value < result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      each(obj, function(v, index, list) {
        computed = iteratee(v, index, list);
        if (computed < lastComputed || (computed === Infinity && result === Infinity)) {
          result = v;
          lastComputed = computed;
        }
      });
    }
    return result;
  }

  // Safely create a real, live array from anything iterable.
  var reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
  function toArray(obj) {
    if (!obj) return [];
    if (isArray(obj)) return slice.call(obj);
    if (isString(obj)) {
      // Keep surrogate pair characters together.
      return obj.match(reStrSymbol);
    }
    if (isArrayLike(obj)) return map(obj, identity);
    return values(obj);
  }

  // Sample **n** random values from a collection using the modern version of the
  // [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `_.map`.
  function sample(obj, n, guard) {
    if (n == null || guard) {
      if (!isArrayLike(obj)) obj = values(obj);
      return obj[random(obj.length - 1)];
    }
    var sample = toArray(obj);
    var length = getLength(sample);
    n = Math.max(Math.min(n, length), 0);
    var last = length - 1;
    for (var index = 0; index < n; index++) {
      var rand = random(index, last);
      var temp = sample[index];
      sample[index] = sample[rand];
      sample[rand] = temp;
    }
    return sample.slice(0, n);
  }

  // Shuffle a collection.
  function shuffle(obj) {
    return sample(obj, Infinity);
  }

  // Sort the object's values by a criterion produced by an iteratee.
  function sortBy(obj, iteratee, context) {
    var index = 0;
    iteratee = cb(iteratee, context);
    return pluck(map(obj, function(value, key, list) {
      return {
        value: value,
        index: index++,
        criteria: iteratee(value, key, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  }

  // An internal function used for aggregate "group by" operations.
  function group(behavior, partition) {
    return function(obj, iteratee, context) {
      var result = partition ? [[], []] : {};
      iteratee = cb(iteratee, context);
      each(obj, function(value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  }

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  var groupBy = group(function(result, value, key) {
    if (has$1(result, key)) result[key].push(value); else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `_.groupBy`, but for
  // when you know that your index values will be unique.
  var indexBy = group(function(result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  var countBy = group(function(result, value, key) {
    if (has$1(result, key)) result[key]++; else result[key] = 1;
  });

  // Split a collection into two arrays: one whose elements all pass the given
  // truth test, and one whose elements all do not pass the truth test.
  var partition = group(function(result, value, pass) {
    result[pass ? 0 : 1].push(value);
  }, true);

  // Return the number of elements in a collection.
  function size(obj) {
    if (obj == null) return 0;
    return isArrayLike(obj) ? obj.length : keys(obj).length;
  }

  // Internal `_.pick` helper function to determine whether `key` is an enumerable
  // property name of `obj`.
  function keyInObj(value, key, obj) {
    return key in obj;
  }

  // Return a copy of the object only containing the allowed properties.
  var pick = restArguments(function(obj, keys) {
    var result = {}, iteratee = keys[0];
    if (obj == null) return result;
    if (isFunction$1(iteratee)) {
      if (keys.length > 1) iteratee = optimizeCb(iteratee, keys[1]);
      keys = allKeys(obj);
    } else {
      iteratee = keyInObj;
      keys = flatten$1(keys, false, false);
      obj = Object(obj);
    }
    for (var i = 0, length = keys.length; i < length; i++) {
      var key = keys[i];
      var value = obj[key];
      if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
  });

  // Return a copy of the object without the disallowed properties.
  var omit = restArguments(function(obj, keys) {
    var iteratee = keys[0], context;
    if (isFunction$1(iteratee)) {
      iteratee = negate(iteratee);
      if (keys.length > 1) context = keys[1];
    } else {
      keys = map(flatten$1(keys, false, false), String);
      iteratee = function(value, key) {
        return !contains(keys, key);
      };
    }
    return pick(obj, iteratee, context);
  });

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N.
  function initial(array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  }

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. The **guard** check allows it to work with `_.map`.
  function first(array, n, guard) {
    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
    if (n == null || guard) return array[0];
    return initial(array, array.length - n);
  }

  // Returns everything but the first entry of the `array`. Especially useful on
  // the `arguments` object. Passing an **n** will return the rest N values in the
  // `array`.
  function rest(array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  }

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array.
  function last(array, n, guard) {
    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
    if (n == null || guard) return array[array.length - 1];
    return rest(array, Math.max(0, array.length - n));
  }

  // Trim out all falsy values from an array.
  function compact(array) {
    return filter(array, Boolean);
  }

  // Flatten out an array, either recursively (by default), or up to `depth`.
  // Passing `true` or `false` as `depth` means `1` or `Infinity`, respectively.
  function flatten(array, depth) {
    return flatten$1(array, depth, false);
  }

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  var difference = restArguments(function(array, rest) {
    rest = flatten$1(rest, true, true);
    return filter(array, function(value){
      return !contains(rest, value);
    });
  });

  // Return a version of the array that does not contain the specified value(s).
  var without = restArguments(function(array, otherArrays) {
    return difference(array, otherArrays);
  });

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // The faster algorithm will not work with an iteratee if the iteratee
  // is not a one-to-one function, so providing an iteratee will disable
  // the faster algorithm.
  function uniq(array, isSorted, iteratee, context) {
    if (!isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = cb(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = getLength(array); i < length; i++) {
      var value = array[i],
          computed = iteratee ? iteratee(value, i, array) : value;
      if (isSorted && !iteratee) {
        if (!i || seen !== computed) result.push(value);
        seen = computed;
      } else if (iteratee) {
        if (!contains(seen, computed)) {
          seen.push(computed);
          result.push(value);
        }
      } else if (!contains(result, value)) {
        result.push(value);
      }
    }
    return result;
  }

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  var union = restArguments(function(arrays) {
    return uniq(flatten$1(arrays, true, true));
  });

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  function intersection(array) {
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = getLength(array); i < length; i++) {
      var item = array[i];
      if (contains(result, item)) continue;
      var j;
      for (j = 1; j < argsLength; j++) {
        if (!contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  }

  // Complement of zip. Unzip accepts an array of arrays and groups
  // each array's elements on shared indices.
  function unzip(array) {
    var length = (array && max(array, getLength).length) || 0;
    var result = Array(length);

    for (var index = 0; index < length; index++) {
      result[index] = pluck(array, index);
    }
    return result;
  }

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  var zip = restArguments(unzip);

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values. Passing by pairs is the reverse of `_.pairs`.
  function object(list, values) {
    var result = {};
    for (var i = 0, length = getLength(list); i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  }

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](https://docs.python.org/library/functions.html#range).
  function range(start, stop, step) {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    if (!step) {
      step = stop < start ? -1 : 1;
    }

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  }

  // Chunk a single array into multiple arrays, each containing `count` or fewer
  // items.
  function chunk(array, count) {
    if (count == null || count < 1) return [];
    var result = [];
    var i = 0, length = array.length;
    while (i < length) {
      result.push(slice.call(array, i, i += count));
    }
    return result;
  }

  // Helper function to continue chaining intermediate results.
  function chainResult(instance, obj) {
    return instance._chain ? _$1(obj).chain() : obj;
  }

  // Add your own custom functions to the Underscore object.
  function mixin(obj) {
    each(functions(obj), function(name) {
      var func = _$1[name] = obj[name];
      _$1.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return chainResult(this, func.apply(_$1, args));
      };
    });
    return _$1;
  }

  // Add all mutator `Array` functions to the wrapper.
  each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _$1.prototype[name] = function() {
      var obj = this._wrapped;
      if (obj != null) {
        method.apply(obj, arguments);
        if ((name === 'shift' || name === 'splice') && obj.length === 0) {
          delete obj[0];
        }
      }
      return chainResult(this, obj);
    };
  });

  // Add all accessor `Array` functions to the wrapper.
  each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _$1.prototype[name] = function() {
      var obj = this._wrapped;
      if (obj != null) obj = method.apply(obj, arguments);
      return chainResult(this, obj);
    };
  });

  // Named Exports

  var allExports = {
    __proto__: null,
    VERSION: VERSION,
    restArguments: restArguments,
    isObject: isObject,
    isNull: isNull,
    isUndefined: isUndefined,
    isBoolean: isBoolean,
    isElement: isElement,
    isString: isString,
    isNumber: isNumber,
    isDate: isDate,
    isRegExp: isRegExp,
    isError: isError,
    isSymbol: isSymbol,
    isArrayBuffer: isArrayBuffer,
    isDataView: isDataView$1,
    isArray: isArray,
    isFunction: isFunction$1,
    isArguments: isArguments$1,
    isFinite: isFinite$1,
    isNaN: isNaN$1,
    isTypedArray: isTypedArray$1,
    isEmpty: isEmpty,
    isMatch: isMatch,
    isEqual: isEqual,
    isMap: isMap,
    isWeakMap: isWeakMap,
    isSet: isSet,
    isWeakSet: isWeakSet,
    keys: keys,
    allKeys: allKeys,
    values: values,
    pairs: pairs,
    invert: invert,
    functions: functions,
    methods: functions,
    extend: extend,
    extendOwn: extendOwn,
    assign: extendOwn,
    defaults: defaults,
    create: create,
    clone: clone,
    tap: tap,
    get: get,
    has: has,
    mapObject: mapObject,
    identity: identity,
    constant: constant,
    noop: noop,
    toPath: toPath$1,
    property: property,
    propertyOf: propertyOf,
    matcher: matcher,
    matches: matcher,
    times: times,
    random: random,
    now: now,
    escape: _escape,
    unescape: _unescape,
    templateSettings: templateSettings,
    template: template,
    result: result,
    uniqueId: uniqueId,
    chain: chain,
    iteratee: iteratee,
    partial: partial,
    bind: bind,
    bindAll: bindAll,
    memoize: memoize,
    delay: delay,
    defer: defer,
    throttle: throttle,
    debounce: debounce,
    wrap: wrap,
    negate: negate,
    compose: compose,
    after: after,
    before: before,
    once: once,
    findKey: findKey,
    findIndex: findIndex,
    findLastIndex: findLastIndex,
    sortedIndex: sortedIndex,
    indexOf: indexOf,
    lastIndexOf: lastIndexOf,
    find: find,
    detect: find,
    findWhere: findWhere,
    each: each,
    forEach: each,
    map: map,
    collect: map,
    reduce: reduce,
    foldl: reduce,
    inject: reduce,
    reduceRight: reduceRight,
    foldr: reduceRight,
    filter: filter,
    select: filter,
    reject: reject,
    every: every,
    all: every,
    some: some,
    any: some,
    contains: contains,
    includes: contains,
    include: contains,
    invoke: invoke,
    pluck: pluck,
    where: where,
    max: max,
    min: min,
    shuffle: shuffle,
    sample: sample,
    sortBy: sortBy,
    groupBy: groupBy,
    indexBy: indexBy,
    countBy: countBy,
    partition: partition,
    toArray: toArray,
    size: size,
    pick: pick,
    omit: omit,
    first: first,
    head: first,
    take: first,
    initial: initial,
    last: last,
    rest: rest,
    tail: rest,
    drop: rest,
    compact: compact,
    flatten: flatten,
    without: without,
    uniq: uniq,
    unique: uniq,
    union: union,
    intersection: intersection,
    difference: difference,
    unzip: unzip,
    transpose: unzip,
    zip: zip,
    object: object,
    range: range,
    chunk: chunk,
    mixin: mixin,
    'default': _$1
  };

  // Default Export

  // Add all of the Underscore functions to the wrapper object.
  var _ = mixin(allExports);
  // Legacy Node.js API.
  _._ = _;

  return _;

})));


}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],1218:[function(require,module,exports){
(function (global){(function (){

/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],1219:[function(require,module,exports){
arguments[4][562][0].apply(exports,arguments)
},{"dup":562}],1220:[function(require,module,exports){
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9

'use strict';

var isArgumentsObject = require('is-arguments');
var isGeneratorFunction = require('is-generator-function');
var whichTypedArray = require('which-typed-array');
var isTypedArray = require('is-typed-array');

function uncurryThis(f) {
  return f.call.bind(f);
}

var BigIntSupported = typeof BigInt !== 'undefined';
var SymbolSupported = typeof Symbol !== 'undefined';

var ObjectToString = uncurryThis(Object.prototype.toString);

var numberValue = uncurryThis(Number.prototype.valueOf);
var stringValue = uncurryThis(String.prototype.valueOf);
var booleanValue = uncurryThis(Boolean.prototype.valueOf);

if (BigIntSupported) {
  var bigIntValue = uncurryThis(BigInt.prototype.valueOf);
}

if (SymbolSupported) {
  var symbolValue = uncurryThis(Symbol.prototype.valueOf);
}

function checkBoxedPrimitive(value, prototypeValueOf) {
  if (typeof value !== 'object') {
    return false;
  }
  try {
    prototypeValueOf(value);
    return true;
  } catch(e) {
    return false;
  }
}

exports.isArgumentsObject = isArgumentsObject;
exports.isGeneratorFunction = isGeneratorFunction;
exports.isTypedArray = isTypedArray;

// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function isPromise(input) {
	return (
		(
			typeof Promise !== 'undefined' &&
			input instanceof Promise
		) ||
		(
			input !== null &&
			typeof input === 'object' &&
			typeof input.then === 'function' &&
			typeof input.catch === 'function'
		)
	);
}
exports.isPromise = isPromise;

function isArrayBufferView(value) {
  if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
    return ArrayBuffer.isView(value);
  }

  return (
    isTypedArray(value) ||
    isDataView(value)
  );
}
exports.isArrayBufferView = isArrayBufferView;


function isUint8Array(value) {
  return whichTypedArray(value) === 'Uint8Array';
}
exports.isUint8Array = isUint8Array;

function isUint8ClampedArray(value) {
  return whichTypedArray(value) === 'Uint8ClampedArray';
}
exports.isUint8ClampedArray = isUint8ClampedArray;

function isUint16Array(value) {
  return whichTypedArray(value) === 'Uint16Array';
}
exports.isUint16Array = isUint16Array;

function isUint32Array(value) {
  return whichTypedArray(value) === 'Uint32Array';
}
exports.isUint32Array = isUint32Array;

function isInt8Array(value) {
  return whichTypedArray(value) === 'Int8Array';
}
exports.isInt8Array = isInt8Array;

function isInt16Array(value) {
  return whichTypedArray(value) === 'Int16Array';
}
exports.isInt16Array = isInt16Array;

function isInt32Array(value) {
  return whichTypedArray(value) === 'Int32Array';
}
exports.isInt32Array = isInt32Array;

function isFloat32Array(value) {
  return whichTypedArray(value) === 'Float32Array';
}
exports.isFloat32Array = isFloat32Array;

function isFloat64Array(value) {
  return whichTypedArray(value) === 'Float64Array';
}
exports.isFloat64Array = isFloat64Array;

function isBigInt64Array(value) {
  return whichTypedArray(value) === 'BigInt64Array';
}
exports.isBigInt64Array = isBigInt64Array;

function isBigUint64Array(value) {
  return whichTypedArray(value) === 'BigUint64Array';
}
exports.isBigUint64Array = isBigUint64Array;

function isMapToString(value) {
  return ObjectToString(value) === '[object Map]';
}
isMapToString.working = (
  typeof Map !== 'undefined' &&
  isMapToString(new Map())
);

function isMap(value) {
  if (typeof Map === 'undefined') {
    return false;
  }

  return isMapToString.working
    ? isMapToString(value)
    : value instanceof Map;
}
exports.isMap = isMap;

function isSetToString(value) {
  return ObjectToString(value) === '[object Set]';
}
isSetToString.working = (
  typeof Set !== 'undefined' &&
  isSetToString(new Set())
);
function isSet(value) {
  if (typeof Set === 'undefined') {
    return false;
  }

  return isSetToString.working
    ? isSetToString(value)
    : value instanceof Set;
}
exports.isSet = isSet;

function isWeakMapToString(value) {
  return ObjectToString(value) === '[object WeakMap]';
}
isWeakMapToString.working = (
  typeof WeakMap !== 'undefined' &&
  isWeakMapToString(new WeakMap())
);
function isWeakMap(value) {
  if (typeof WeakMap === 'undefined') {
    return false;
  }

  return isWeakMapToString.working
    ? isWeakMapToString(value)
    : value instanceof WeakMap;
}
exports.isWeakMap = isWeakMap;

function isWeakSetToString(value) {
  return ObjectToString(value) === '[object WeakSet]';
}
isWeakSetToString.working = (
  typeof WeakSet !== 'undefined' &&
  isWeakSetToString(new WeakSet())
);
function isWeakSet(value) {
  return isWeakSetToString(value);
}
exports.isWeakSet = isWeakSet;

function isArrayBufferToString(value) {
  return ObjectToString(value) === '[object ArrayBuffer]';
}
isArrayBufferToString.working = (
  typeof ArrayBuffer !== 'undefined' &&
  isArrayBufferToString(new ArrayBuffer())
);
function isArrayBuffer(value) {
  if (typeof ArrayBuffer === 'undefined') {
    return false;
  }

  return isArrayBufferToString.working
    ? isArrayBufferToString(value)
    : value instanceof ArrayBuffer;
}
exports.isArrayBuffer = isArrayBuffer;

function isDataViewToString(value) {
  return ObjectToString(value) === '[object DataView]';
}
isDataViewToString.working = (
  typeof ArrayBuffer !== 'undefined' &&
  typeof DataView !== 'undefined' &&
  isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1))
);
function isDataView(value) {
  if (typeof DataView === 'undefined') {
    return false;
  }

  return isDataViewToString.working
    ? isDataViewToString(value)
    : value instanceof DataView;
}
exports.isDataView = isDataView;

// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function isSharedArrayBufferToString(value) {
  return ObjectToString(value) === '[object SharedArrayBuffer]';
}
function isSharedArrayBuffer(value) {
  if (typeof SharedArrayBufferCopy === 'undefined') {
    return false;
  }

  if (typeof isSharedArrayBufferToString.working === 'undefined') {
    isSharedArrayBufferToString.working = isSharedArrayBufferToString(new SharedArrayBufferCopy());
  }

  return isSharedArrayBufferToString.working
    ? isSharedArrayBufferToString(value)
    : value instanceof SharedArrayBufferCopy;
}
exports.isSharedArrayBuffer = isSharedArrayBuffer;

function isAsyncFunction(value) {
  return ObjectToString(value) === '[object AsyncFunction]';
}
exports.isAsyncFunction = isAsyncFunction;

function isMapIterator(value) {
  return ObjectToString(value) === '[object Map Iterator]';
}
exports.isMapIterator = isMapIterator;

function isSetIterator(value) {
  return ObjectToString(value) === '[object Set Iterator]';
}
exports.isSetIterator = isSetIterator;

function isGeneratorObject(value) {
  return ObjectToString(value) === '[object Generator]';
}
exports.isGeneratorObject = isGeneratorObject;

function isWebAssemblyCompiledModule(value) {
  return ObjectToString(value) === '[object WebAssembly.Module]';
}
exports.isWebAssemblyCompiledModule = isWebAssemblyCompiledModule;

function isNumberObject(value) {
  return checkBoxedPrimitive(value, numberValue);
}
exports.isNumberObject = isNumberObject;

function isStringObject(value) {
  return checkBoxedPrimitive(value, stringValue);
}
exports.isStringObject = isStringObject;

function isBooleanObject(value) {
  return checkBoxedPrimitive(value, booleanValue);
}
exports.isBooleanObject = isBooleanObject;

function isBigIntObject(value) {
  return BigIntSupported && checkBoxedPrimitive(value, bigIntValue);
}
exports.isBigIntObject = isBigIntObject;

function isSymbolObject(value) {
  return SymbolSupported && checkBoxedPrimitive(value, symbolValue);
}
exports.isSymbolObject = isSymbolObject;

function isBoxedPrimitive(value) {
  return (
    isNumberObject(value) ||
    isStringObject(value) ||
    isBooleanObject(value) ||
    isBigIntObject(value) ||
    isSymbolObject(value)
  );
}
exports.isBoxedPrimitive = isBoxedPrimitive;

function isAnyArrayBuffer(value) {
  return typeof Uint8Array !== 'undefined' && (
    isArrayBuffer(value) ||
    isSharedArrayBuffer(value)
  );
}
exports.isAnyArrayBuffer = isAnyArrayBuffer;

['isProxy', 'isExternal', 'isModuleNamespaceObject'].forEach(function(method) {
  Object.defineProperty(exports, method, {
    enumerable: false,
    value: function() {
      throw new Error(method + ' is not supported in userland');
    }
  });
});

},{"is-arguments":1160,"is-generator-function":1162,"is-typed-array":1163,"which-typed-array":1237}],1221:[function(require,module,exports){
(function (process){(function (){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors ||
  function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for (var i = 0; i < keys.length; i++) {
      descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    }
    return descriptors;
  };

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  if (typeof process !== 'undefined' && process.noDeprecation === true) {
    return fn;
  }

  // Allow for deprecating things in the process of starting up.
  if (typeof process === 'undefined') {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnvRegex = /^$/;

if (process.env.NODE_DEBUG) {
  var debugEnv = process.env.NODE_DEBUG;
  debugEnv = debugEnv.replace(/[|\\{}()[\]^$+?.]/g, '\\$&')
    .replace(/\*/g, '.*')
    .replace(/,/g, '$|^')
    .toUpperCase();
  debugEnvRegex = new RegExp('^' + debugEnv + '$', 'i');
}
exports.debuglog = function(set) {
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (debugEnvRegex.test(set)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').slice(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.slice(1, -1);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
exports.types = require('./support/types');

function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;
exports.types.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;
exports.types.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;
exports.types.isNativeError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = require('./support/isBuffer');

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = require('inherits');

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;

exports.promisify = function promisify(original) {
  if (typeof original !== 'function')
    throw new TypeError('The "original" argument must be of type Function');

  if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
    var fn = original[kCustomPromisifiedSymbol];
    if (typeof fn !== 'function') {
      throw new TypeError('The "util.promisify.custom" argument must be of type Function');
    }
    Object.defineProperty(fn, kCustomPromisifiedSymbol, {
      value: fn, enumerable: false, writable: false, configurable: true
    });
    return fn;
  }

  function fn() {
    var promiseResolve, promiseReject;
    var promise = new Promise(function (resolve, reject) {
      promiseResolve = resolve;
      promiseReject = reject;
    });

    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }
    args.push(function (err, value) {
      if (err) {
        promiseReject(err);
      } else {
        promiseResolve(value);
      }
    });

    try {
      original.apply(this, args);
    } catch (err) {
      promiseReject(err);
    }

    return promise;
  }

  Object.setPrototypeOf(fn, Object.getPrototypeOf(original));

  if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
    value: fn, enumerable: false, writable: false, configurable: true
  });
  return Object.defineProperties(
    fn,
    getOwnPropertyDescriptors(original)
  );
}

exports.promisify.custom = kCustomPromisifiedSymbol

function callbackifyOnRejected(reason, cb) {
  // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
  // Because `null` is a special error value in callbacks which means "no error
  // occurred", we error-wrap so the callback consumer can distinguish between
  // "the promise rejected with null" or "the promise fulfilled with undefined".
  if (!reason) {
    var newReason = new Error('Promise was rejected with a falsy value');
    newReason.reason = reason;
    reason = newReason;
  }
  return cb(reason);
}

function callbackify(original) {
  if (typeof original !== 'function') {
    throw new TypeError('The "original" argument must be of type Function');
  }

  // We DO NOT return the promise as it gives the user a false sense that
  // the promise is actually somehow related to the callback's execution
  // and that the callback throwing will reject the promise.
  function callbackified() {
    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }

    var maybeCb = args.pop();
    if (typeof maybeCb !== 'function') {
      throw new TypeError('The last argument must be of type Function');
    }
    var self = this;
    var cb = function() {
      return maybeCb.apply(self, arguments);
    };
    // In true node style we process the callback on `nextTick` with all the
    // implications (stack, `uncaughtException`, `async_hooks`)
    original.apply(this, args)
      .then(function(ret) { process.nextTick(cb.bind(null, null, ret)) },
            function(rej) { process.nextTick(callbackifyOnRejected.bind(null, rej, cb)) });
  }

  Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
  Object.defineProperties(callbackified,
                          getOwnPropertyDescriptors(original));
  return callbackified;
}
exports.callbackify = callbackify;

}).call(this)}).call(this,require('_process'))
},{"./support/isBuffer":1219,"./support/types":1220,"_process":1185,"inherits":1159}],1222:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "v1", {
  enumerable: true,
  get: function () {
    return _v.default;
  }
});
Object.defineProperty(exports, "v3", {
  enumerable: true,
  get: function () {
    return _v2.default;
  }
});
Object.defineProperty(exports, "v4", {
  enumerable: true,
  get: function () {
    return _v3.default;
  }
});
Object.defineProperty(exports, "v5", {
  enumerable: true,
  get: function () {
    return _v4.default;
  }
});
Object.defineProperty(exports, "NIL", {
  enumerable: true,
  get: function () {
    return _nil.default;
  }
});
Object.defineProperty(exports, "version", {
  enumerable: true,
  get: function () {
    return _version.default;
  }
});
Object.defineProperty(exports, "validate", {
  enumerable: true,
  get: function () {
    return _validate.default;
  }
});
Object.defineProperty(exports, "stringify", {
  enumerable: true,
  get: function () {
    return _stringify.default;
  }
});
Object.defineProperty(exports, "parse", {
  enumerable: true,
  get: function () {
    return _parse.default;
  }
});

var _v = _interopRequireDefault(require("./v1.js"));

var _v2 = _interopRequireDefault(require("./v3.js"));

var _v3 = _interopRequireDefault(require("./v4.js"));

var _v4 = _interopRequireDefault(require("./v5.js"));

var _nil = _interopRequireDefault(require("./nil.js"));

var _version = _interopRequireDefault(require("./version.js"));

var _validate = _interopRequireDefault(require("./validate.js"));

var _stringify = _interopRequireDefault(require("./stringify.js"));

var _parse = _interopRequireDefault(require("./parse.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
},{"./nil.js":1224,"./parse.js":1225,"./stringify.js":1229,"./v1.js":1230,"./v3.js":1231,"./v4.js":1233,"./v5.js":1234,"./validate.js":1235,"./version.js":1236}],1223:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/*
 * Browser-compatible JavaScript MD5
 *
 * Modification of JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */
function md5(bytes) {
  if (typeof bytes === 'string') {
    const msg = unescape(encodeURIComponent(bytes)); // UTF8 escape

    bytes = new Uint8Array(msg.length);

    for (let i = 0; i < msg.length; ++i) {
      bytes[i] = msg.charCodeAt(i);
    }
  }

  return md5ToHexEncodedArray(wordsToMd5(bytesToWords(bytes), bytes.length * 8));
}
/*
 * Convert an array of little-endian words to an array of bytes
 */


function md5ToHexEncodedArray(input) {
  const output = [];
  const length32 = input.length * 32;
  const hexTab = '0123456789abcdef';

  for (let i = 0; i < length32; i += 8) {
    const x = input[i >> 5] >>> i % 32 & 0xff;
    const hex = parseInt(hexTab.charAt(x >>> 4 & 0x0f) + hexTab.charAt(x & 0x0f), 16);
    output.push(hex);
  }

  return output;
}
/**
 * Calculate output length with padding and bit length
 */


function getOutputLength(inputLength8) {
  return (inputLength8 + 64 >>> 9 << 4) + 14 + 1;
}
/*
 * Calculate the MD5 of an array of little-endian words, and a bit length.
 */


function wordsToMd5(x, len) {
  /* append padding */
  x[len >> 5] |= 0x80 << len % 32;
  x[getOutputLength(len) - 1] = len;
  let a = 1732584193;
  let b = -271733879;
  let c = -1732584194;
  let d = 271733878;

  for (let i = 0; i < x.length; i += 16) {
    const olda = a;
    const oldb = b;
    const oldc = c;
    const oldd = d;
    a = md5ff(a, b, c, d, x[i], 7, -680876936);
    d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
    c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
    b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
    a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
    d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
    c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
    b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
    a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
    d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
    c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
    b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
    a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
    d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
    c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
    b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
    a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
    d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
    c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
    b = md5gg(b, c, d, a, x[i], 20, -373897302);
    a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
    d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
    c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
    b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
    a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
    d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
    c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
    b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
    a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
    d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
    c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
    b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
    a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
    d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
    c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
    b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
    a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
    d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
    c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
    b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
    a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
    d = md5hh(d, a, b, c, x[i], 11, -358537222);
    c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
    b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
    a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
    d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
    c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
    b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
    a = md5ii(a, b, c, d, x[i], 6, -198630844);
    d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
    c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
    b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
    a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
    d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
    c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
    b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
    a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
    d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
    c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
    b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
    a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
    d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
    c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
    b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
    a = safeAdd(a, olda);
    b = safeAdd(b, oldb);
    c = safeAdd(c, oldc);
    d = safeAdd(d, oldd);
  }

  return [a, b, c, d];
}
/*
 * Convert an array bytes to an array of little-endian words
 * Characters >255 have their high-byte silently ignored.
 */


function bytesToWords(input) {
  if (input.length === 0) {
    return [];
  }

  const length8 = input.length * 8;
  const output = new Uint32Array(getOutputLength(length8));

  for (let i = 0; i < length8; i += 8) {
    output[i >> 5] |= (input[i / 8] & 0xff) << i % 32;
  }

  return output;
}
/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */


function safeAdd(x, y) {
  const lsw = (x & 0xffff) + (y & 0xffff);
  const msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return msw << 16 | lsw & 0xffff;
}
/*
 * Bitwise rotate a 32-bit number to the left.
 */


function bitRotateLeft(num, cnt) {
  return num << cnt | num >>> 32 - cnt;
}
/*
 * These functions implement the four basic operations the algorithm uses.
 */


function md5cmn(q, a, b, x, s, t) {
  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
}

function md5ff(a, b, c, d, x, s, t) {
  return md5cmn(b & c | ~b & d, a, b, x, s, t);
}

function md5gg(a, b, c, d, x, s, t) {
  return md5cmn(b & d | c & ~d, a, b, x, s, t);
}

function md5hh(a, b, c, d, x, s, t) {
  return md5cmn(b ^ c ^ d, a, b, x, s, t);
}

function md5ii(a, b, c, d, x, s, t) {
  return md5cmn(c ^ (b | ~d), a, b, x, s, t);
}

var _default = md5;
exports.default = _default;
},{}],1224:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = '00000000-0000-0000-0000-000000000000';
exports.default = _default;
},{}],1225:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _validate = _interopRequireDefault(require("./validate.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function parse(uuid) {
  if (!(0, _validate.default)(uuid)) {
    throw TypeError('Invalid UUID');
  }

  let v;
  const arr = new Uint8Array(16); // Parse ########-....-....-....-............

  arr[0] = (v = parseInt(uuid.slice(0, 8), 16)) >>> 24;
  arr[1] = v >>> 16 & 0xff;
  arr[2] = v >>> 8 & 0xff;
  arr[3] = v & 0xff; // Parse ........-####-....-....-............

  arr[4] = (v = parseInt(uuid.slice(9, 13), 16)) >>> 8;
  arr[5] = v & 0xff; // Parse ........-....-####-....-............

  arr[6] = (v = parseInt(uuid.slice(14, 18), 16)) >>> 8;
  arr[7] = v & 0xff; // Parse ........-....-....-####-............

  arr[8] = (v = parseInt(uuid.slice(19, 23), 16)) >>> 8;
  arr[9] = v & 0xff; // Parse ........-....-....-....-############
  // (Use "/" to avoid 32-bit truncation when bit-shifting high-order bytes)

  arr[10] = (v = parseInt(uuid.slice(24, 36), 16)) / 0x10000000000 & 0xff;
  arr[11] = v / 0x100000000 & 0xff;
  arr[12] = v >>> 24 & 0xff;
  arr[13] = v >>> 16 & 0xff;
  arr[14] = v >>> 8 & 0xff;
  arr[15] = v & 0xff;
  return arr;
}

var _default = parse;
exports.default = _default;
},{"./validate.js":1235}],1226:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
exports.default = _default;
},{}],1227:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = rng;
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let getRandomValues;
const rnds8 = new Uint8Array(16);

function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
    // find the complete implementation of crypto (msCrypto) on IE11.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}
},{}],1228:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

// Adapted from Chris Veness' SHA1 code at
// http://www.movable-type.co.uk/scripts/sha1.html
function f(s, x, y, z) {
  switch (s) {
    case 0:
      return x & y ^ ~x & z;

    case 1:
      return x ^ y ^ z;

    case 2:
      return x & y ^ x & z ^ y & z;

    case 3:
      return x ^ y ^ z;
  }
}

function ROTL(x, n) {
  return x << n | x >>> 32 - n;
}

function sha1(bytes) {
  const K = [0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xca62c1d6];
  const H = [0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0];

  if (typeof bytes === 'string') {
    const msg = unescape(encodeURIComponent(bytes)); // UTF8 escape

    bytes = [];

    for (let i = 0; i < msg.length; ++i) {
      bytes.push(msg.charCodeAt(i));
    }
  } else if (!Array.isArray(bytes)) {
    // Convert Array-like to Array
    bytes = Array.prototype.slice.call(bytes);
  }

  bytes.push(0x80);
  const l = bytes.length / 4 + 2;
  const N = Math.ceil(l / 16);
  const M = new Array(N);

  for (let i = 0; i < N; ++i) {
    const arr = new Uint32Array(16);

    for (let j = 0; j < 16; ++j) {
      arr[j] = bytes[i * 64 + j * 4] << 24 | bytes[i * 64 + j * 4 + 1] << 16 | bytes[i * 64 + j * 4 + 2] << 8 | bytes[i * 64 + j * 4 + 3];
    }

    M[i] = arr;
  }

  M[N - 1][14] = (bytes.length - 1) * 8 / Math.pow(2, 32);
  M[N - 1][14] = Math.floor(M[N - 1][14]);
  M[N - 1][15] = (bytes.length - 1) * 8 & 0xffffffff;

  for (let i = 0; i < N; ++i) {
    const W = new Uint32Array(80);

    for (let t = 0; t < 16; ++t) {
      W[t] = M[i][t];
    }

    for (let t = 16; t < 80; ++t) {
      W[t] = ROTL(W[t - 3] ^ W[t - 8] ^ W[t - 14] ^ W[t - 16], 1);
    }

    let a = H[0];
    let b = H[1];
    let c = H[2];
    let d = H[3];
    let e = H[4];

    for (let t = 0; t < 80; ++t) {
      const s = Math.floor(t / 20);
      const T = ROTL(a, 5) + f(s, b, c, d) + e + K[s] + W[t] >>> 0;
      e = d;
      d = c;
      c = ROTL(b, 30) >>> 0;
      b = a;
      a = T;
    }

    H[0] = H[0] + a >>> 0;
    H[1] = H[1] + b >>> 0;
    H[2] = H[2] + c >>> 0;
    H[3] = H[3] + d >>> 0;
    H[4] = H[4] + e >>> 0;
  }

  return [H[0] >> 24 & 0xff, H[0] >> 16 & 0xff, H[0] >> 8 & 0xff, H[0] & 0xff, H[1] >> 24 & 0xff, H[1] >> 16 & 0xff, H[1] >> 8 & 0xff, H[1] & 0xff, H[2] >> 24 & 0xff, H[2] >> 16 & 0xff, H[2] >> 8 & 0xff, H[2] & 0xff, H[3] >> 24 & 0xff, H[3] >> 16 & 0xff, H[3] >> 8 & 0xff, H[3] & 0xff, H[4] >> 24 & 0xff, H[4] >> 16 & 0xff, H[4] >> 8 & 0xff, H[4] & 0xff];
}

var _default = sha1;
exports.default = _default;
},{}],1229:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _validate = _interopRequireDefault(require("./validate.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
const byteToHex = [];

for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).substr(1));
}

function stringify(arr, offset = 0) {
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  const uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!(0, _validate.default)(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

var _default = stringify;
exports.default = _default;
},{"./validate.js":1235}],1230:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _rng = _interopRequireDefault(require("./rng.js"));

var _stringify = _interopRequireDefault(require("./stringify.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
let _nodeId;

let _clockseq; // Previous uuid creation time


let _lastMSecs = 0;
let _lastNSecs = 0; // See https://github.com/uuidjs/uuid for API details

function v1(options, buf, offset) {
  let i = buf && offset || 0;
  const b = buf || new Array(16);
  options = options || {};
  let node = options.node || _nodeId;
  let clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq; // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189

  if (node == null || clockseq == null) {
    const seedBytes = options.random || (options.rng || _rng.default)();

    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [seedBytes[0] | 0x01, seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]];
    }

    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  } // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.


  let msecs = options.msecs !== undefined ? options.msecs : Date.now(); // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock

  let nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1; // Time since last uuid creation (in msecs)

  const dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000; // Per 4.2.1.2, Bump clockseq on clock regression

  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  } // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval


  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  } // Per 4.2.1.2 Throw error if too many uuids are requested


  if (nsecs >= 10000) {
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq; // Per 4.1.4 - Convert from unix epoch to Gregorian epoch

  msecs += 12219292800000; // `time_low`

  const tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff; // `time_mid`

  const tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff; // `time_high_and_version`

  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version

  b[i++] = tmh >>> 16 & 0xff; // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)

  b[i++] = clockseq >>> 8 | 0x80; // `clock_seq_low`

  b[i++] = clockseq & 0xff; // `node`

  for (let n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf || (0, _stringify.default)(b);
}

var _default = v1;
exports.default = _default;
},{"./rng.js":1227,"./stringify.js":1229}],1231:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _v = _interopRequireDefault(require("./v35.js"));

var _md = _interopRequireDefault(require("./md5.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const v3 = (0, _v.default)('v3', 0x30, _md.default);
var _default = v3;
exports.default = _default;
},{"./md5.js":1223,"./v35.js":1232}],1232:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.URL = exports.DNS = void 0;

var _stringify = _interopRequireDefault(require("./stringify.js"));

var _parse = _interopRequireDefault(require("./parse.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function stringToBytes(str) {
  str = unescape(encodeURIComponent(str)); // UTF8 escape

  const bytes = [];

  for (let i = 0; i < str.length; ++i) {
    bytes.push(str.charCodeAt(i));
  }

  return bytes;
}

const DNS = '6ba7b810-9dad-11d1-80b4-00c04fd430c8';
exports.DNS = DNS;
const URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8';
exports.URL = URL;

function _default(name, version, hashfunc) {
  function generateUUID(value, namespace, buf, offset) {
    if (typeof value === 'string') {
      value = stringToBytes(value);
    }

    if (typeof namespace === 'string') {
      namespace = (0, _parse.default)(namespace);
    }

    if (namespace.length !== 16) {
      throw TypeError('Namespace must be array-like (16 iterable integer values, 0-255)');
    } // Compute hash of namespace and value, Per 4.3
    // Future: Use spread syntax when supported on all platforms, e.g. `bytes =
    // hashfunc([...namespace, ... value])`


    let bytes = new Uint8Array(16 + value.length);
    bytes.set(namespace);
    bytes.set(value, namespace.length);
    bytes = hashfunc(bytes);
    bytes[6] = bytes[6] & 0x0f | version;
    bytes[8] = bytes[8] & 0x3f | 0x80;

    if (buf) {
      offset = offset || 0;

      for (let i = 0; i < 16; ++i) {
        buf[offset + i] = bytes[i];
      }

      return buf;
    }

    return (0, _stringify.default)(bytes);
  } // Function#name is not settable on some platforms (#270)


  try {
    generateUUID.name = name; // eslint-disable-next-line no-empty
  } catch (err) {} // For CommonJS default export support


  generateUUID.DNS = DNS;
  generateUUID.URL = URL;
  return generateUUID;
}
},{"./parse.js":1225,"./stringify.js":1229}],1233:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _rng = _interopRequireDefault(require("./rng.js"));

var _stringify = _interopRequireDefault(require("./stringify.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function v4(options, buf, offset) {
  options = options || {};

  const rnds = options.random || (options.rng || _rng.default)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`


  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (let i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return (0, _stringify.default)(rnds);
}

var _default = v4;
exports.default = _default;
},{"./rng.js":1227,"./stringify.js":1229}],1234:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _v = _interopRequireDefault(require("./v35.js"));

var _sha = _interopRequireDefault(require("./sha1.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const v5 = (0, _v.default)('v5', 0x50, _sha.default);
var _default = v5;
exports.default = _default;
},{"./sha1.js":1228,"./v35.js":1232}],1235:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regex = _interopRequireDefault(require("./regex.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function validate(uuid) {
  return typeof uuid === 'string' && _regex.default.test(uuid);
}

var _default = validate;
exports.default = _default;
},{"./regex.js":1226}],1236:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _validate = _interopRequireDefault(require("./validate.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function version(uuid) {
  if (!(0, _validate.default)(uuid)) {
    throw TypeError('Invalid UUID');
  }

  return parseInt(uuid.substr(14, 1), 16);
}

var _default = version;
exports.default = _default;
},{"./validate.js":1235}],1237:[function(require,module,exports){
(function (global){(function (){
'use strict';

var forEach = require('for-each');
var availableTypedArrays = require('available-typed-arrays');
var callBound = require('call-bind/callBound');
var gOPD = require('gopd');

var $toString = callBound('Object.prototype.toString');
var hasToStringTag = require('has-tostringtag/shams')();

var g = typeof globalThis === 'undefined' ? global : globalThis;
var typedArrays = availableTypedArrays();

var $slice = callBound('String.prototype.slice');
var toStrTags = {};
var getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
if (hasToStringTag && gOPD && getPrototypeOf) {
	forEach(typedArrays, function (typedArray) {
		if (typeof g[typedArray] === 'function') {
			var arr = new g[typedArray]();
			if (Symbol.toStringTag in arr) {
				var proto = getPrototypeOf(arr);
				var descriptor = gOPD(proto, Symbol.toStringTag);
				if (!descriptor) {
					var superProto = getPrototypeOf(proto);
					descriptor = gOPD(superProto, Symbol.toStringTag);
				}
				toStrTags[typedArray] = descriptor.get;
			}
		}
	});
}

var tryTypedArrays = function tryAllTypedArrays(value) {
	var foundName = false;
	forEach(toStrTags, function (getter, typedArray) {
		if (!foundName) {
			try {
				var name = getter.call(value);
				if (name === typedArray) {
					foundName = name;
				}
			} catch (e) {}
		}
	});
	return foundName;
};

var isTypedArray = require('is-typed-array');

module.exports = function whichTypedArray(value) {
	if (!isTypedArray(value)) { return false; }
	if (!hasToStringTag || !(Symbol.toStringTag in value)) { return $slice($toString(value), 8, -1); }
	return tryTypedArrays(value);
};

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"available-typed-arrays":564,"call-bind/callBound":571,"for-each":1103,"gopd":1119,"has-tostringtag/shams":1156,"is-typed-array":1163}],1238:[function(require,module,exports){
(function (global,setImmediate,clearImmediate){(function (){
(function UMDish(name, context, definition, plugins) {
  context[name] = definition.call(context);
  for (var i = 0; i < plugins.length; i++) {
    plugins[i](context[name])
  }
  if (typeof module !== "undefined" && module.exports) {
    module.exports = context[name];
  } else if (typeof define === "function" && define.amd) {
    define(function reference() { return context[name]; });
  }
})("Primus", this || {}, function wrapper() {
  var define, module, exports
    , Primus = (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
'use strict';

/**
 * Create a function that will cleanup the instance.
 *
 * @param {Array|String} keys Properties on the instance that needs to be cleared.
 * @param {Object} options Additional configuration.
 * @returns {Function} Destroy function
 * @api public
 */
module.exports = function demolish(keys, options) {
  var split = /[, ]+/;

  options = options ||  {};
  keys = keys || [];

  if ('string' === typeof keys) keys = keys.split(split);

  /**
   * Run addition cleanup hooks.
   *
   * @param {String} key Name of the clean up hook to run.
   * @param {Mixed} selfie Reference to the instance we're cleaning up.
   * @api private
   */
  function run(key, selfie) {
    if (!options[key]) return;
    if ('string' === typeof options[key]) options[key] = options[key].split(split);
    if ('function' === typeof options[key]) return options[key].call(selfie);

    for (var i = 0, type, what; i < options[key].length; i++) {
      what = options[key][i];
      type = typeof what;

      if ('function' === type) {
        what.call(selfie);
      } else if ('string' === type && 'function' === typeof selfie[what]) {
        selfie[what]();
      }
    }
  }

  /**
   * Destroy the instance completely and clean up all the existing references.
   *
   * @returns {Boolean}
   * @api public
   */
  return function destroy() {
    var selfie = this
      , i = 0
      , prop;

    if (selfie[keys[0]] === null) return false;
    run('before', selfie);

    for (; i < keys.length; i++) {
      prop = keys[i];

      if (selfie[prop]) {
        if ('function' === typeof selfie[prop].destroy) selfie[prop].destroy();
        selfie[prop] = null;
      }
    }

    if (selfie.emit) selfie.emit('destroy');
    run('after', selfie);

    return true;
  };
};

},{}],2:[function(_dereq_,module,exports){
'use strict';

/**
 * Returns a function that when invoked executes all the listeners of the
 * given event with the given arguments.
 *
 * @returns {Function} The function that emits all the things.
 * @api public
 */
module.exports = function emits() {
  var self = this
    , parser;

  for (var i = 0, l = arguments.length, args = new Array(l); i < l; i++) {
    args[i] = arguments[i];
  }

  //
  // If the last argument is a function, assume that it's a parser.
  //
  if ('function' !== typeof args[args.length - 1]) return function emitter() {
    for (var i = 0, l = arguments.length, arg = new Array(l); i < l; i++) {
      arg[i] = arguments[i];
    }

    return self.emit.apply(self, args.concat(arg));
  };

  parser = args.pop();

  /**
   * The actual function that emits the given event. It returns a boolean
   * indicating if the event was emitted.
   *
   * @returns {Boolean}
   * @api public
   */
  return function emitter() {
    for (var i = 0, l = arguments.length, arg = new Array(l + 1); i < l; i++) {
      arg[i + 1] = arguments[i];
    }

    /**
     * Async completion method for the parser.
     *
     * @param {Error} err Optional error when parsing failed.
     * @param {Mixed} returned Emit instructions.
     * @api private
     */
    arg[0] = function next(err, returned) {
      if (err) return self.emit('error', err);

      arg = returned === undefined
        ? arg.slice(1) : returned === null
          ? [] : returned;

      self.emit.apply(self, args.concat(arg));
    };

    parser.apply(self, arg);
    return true;
  };
};

},{}],3:[function(_dereq_,module,exports){
'use strict';

var has = Object.prototype.hasOwnProperty
  , prefix = '~';

/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @api private
 */
function Events() {}

//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
  Events.prototype = Object.create(null);

  //
  // This hack is needed because the `__proto__` property is still inherited in
  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
  //
  if (!new Events().__proto__) prefix = false;
}

/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {Mixed} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @api private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @api public
 */
function EventEmitter() {
  this._events = new Events();
  this._eventsCount = 0;
}

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @api public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var names = []
    , events
    , name;

  if (this._eventsCount === 0) return names;

  for (name in (events = this._events)) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Boolean} exists Only check if there are listeners.
 * @returns {Array|Boolean}
 * @api public
 */
EventEmitter.prototype.listeners = function listeners(event, exists) {
  var evt = prefix ? prefix + event : event
    , available = this._events[evt];

  if (exists) return !!available;
  if (!available) return [];
  if (available.fn) return [available.fn];

  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
    ee[i] = available[i].fn;
  }

  return ee;
};

/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @api public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return false;

  var listeners = this._events[evt]
    , len = arguments.length
    , args
    , i;

  if (listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1: return listeners.fn.call(listeners.context), true;
      case 2: return listeners.fn.call(listeners.context, a1), true;
      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len -1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length
      , j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1: listeners[i].fn.call(listeners[i].context); break;
        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
        default:
          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Add a listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  var listener = new EE(fn, context || this)
    , evt = prefix ? prefix + event : event;

  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
  else if (!this._events[evt].fn) this._events[evt].push(listener);
  else this._events[evt] = [this._events[evt], listener];

  return this;
};

/**
 * Add a one-time listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  var listener = new EE(fn, context || this, true)
    , evt = prefix ? prefix + event : event;

  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
  else if (!this._events[evt].fn) this._events[evt].push(listener);
  else this._events[evt] = [this._events[evt], listener];

  return this;
};

/**
 * Remove the listeners of a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {Mixed} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return this;
  if (!fn) {
    if (--this._eventsCount === 0) this._events = new Events();
    else delete this._events[evt];
    return this;
  }

  var listeners = this._events[evt];

  if (listeners.fn) {
    if (
         listeners.fn === fn
      && (!once || listeners.once)
      && (!context || listeners.context === context)
    ) {
      if (--this._eventsCount === 0) this._events = new Events();
      else delete this._events[evt];
    }
  } else {
    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
      if (
           listeners[i].fn !== fn
        || (once && !listeners[i].once)
        || (context && listeners[i].context !== context)
      ) {
        events.push(listeners[i]);
      }
    }

    //
    // Reset the array, or remove it completely if we have no more listeners.
    //
    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
    else if (--this._eventsCount === 0) this._events = new Events();
    else delete this._events[evt];
  }

  return this;
};

/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {String|Symbol} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  var evt;

  if (event) {
    evt = prefix ? prefix + event : event;
    if (this._events[evt]) {
      if (--this._eventsCount === 0) this._events = new Events();
      else delete this._events[evt];
    }
  } else {
    this._events = new Events();
    this._eventsCount = 0;
  }

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// This function doesn't apply anymore.
//
EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
  return this;
};

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;

//
// Expose the module.
//
if ('undefined' !== typeof module) {
  module.exports = EventEmitter;
}

},{}],4:[function(_dereq_,module,exports){
if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}

},{}],5:[function(_dereq_,module,exports){
'use strict';

var regex = new RegExp('^((?:\\d+)?\\.?\\d+) *('+ [
  'milliseconds?',
  'msecs?',
  'ms',
  'seconds?',
  'secs?',
  's',
  'minutes?',
  'mins?',
  'm',
  'hours?',
  'hrs?',
  'h',
  'days?',
  'd',
  'weeks?',
  'wks?',
  'w',
  'years?',
  'yrs?',
  'y'
].join('|') +')?$', 'i');

var second = 1000
  , minute = second * 60
  , hour = minute * 60
  , day = hour * 24
  , week = day * 7
  , year = day * 365;

/**
 * Parse a time string and return the number value of it.
 *
 * @param {String} ms Time string.
 * @returns {Number}
 * @api private
 */
module.exports = function millisecond(ms) {
  var type = typeof ms
    , amount
    , match;

  if ('number' === type) return ms;
  else if ('string' !== type || '0' === ms || !ms) return 0;
  else if (+ms) return +ms;

  //
  // We are vulnerable to the regular expression denial of service (ReDoS).
  // In order to mitigate this we don't parse the input string if it is too long.
  // See https://nodesecurity.io/advisories/46.
  //
  if (ms.length > 10000 || !(match = regex.exec(ms))) return 0;

  amount = parseFloat(match[1]);

  switch (match[2].toLowerCase()) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return amount * year;

    case 'weeks':
    case 'week':
    case 'wks':
    case 'wk':
    case 'w':
      return amount * week;

    case 'days':
    case 'day':
    case 'd':
      return amount * day;

    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return amount * hour;

    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return amount * minute;

    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return amount * second;

    default:
      return amount;
  }
};

},{}],6:[function(_dereq_,module,exports){
'use strict';

/**
 * Wrap callbacks to prevent double execution.
 *
 * @param {Function} fn Function that should only be called once.
 * @returns {Function} A wrapped callback which prevents execution.
 * @api public
 */
module.exports = function one(fn) {
  var called = 0
    , value;

  /**
   * The function that prevents double execution.
   *
   * @api private
   */
  function onetime() {
    if (called) return value;

    called = 1;
    value = fn.apply(this, arguments);
    fn = null;

    return value;
  }

  //
  // To make debugging more easy we want to use the name of the supplied
  // function. So when you look at the functions that are assigned to event
  // listeners you don't see a load of `onetime` functions but actually the
  // names of the functions that this module will call.
  //
  onetime.displayName = fn.displayName || fn.name || onetime.displayName || onetime.name;
  return onetime;
};

},{}],7:[function(_dereq_,module,exports){
'use strict';

var has = Object.prototype.hasOwnProperty;

/**
 * Decode a URI encoded string.
 *
 * @param {String} input The URI encoded string.
 * @returns {String} The decoded string.
 * @api private
 */
function decode(input) {
  return decodeURIComponent(input.replace(/\+/g, ' '));
}

/**
 * Simple query string parser.
 *
 * @param {String} query The query string that needs to be parsed.
 * @returns {Object}
 * @api public
 */
function querystring(query) {
  var parser = /([^=?&]+)=?([^&]*)/g
    , result = {}
    , part;

  //
  // Little nifty parsing hack, leverage the fact that RegExp.exec increments
  // the lastIndex property so we can continue executing this loop until we've
  // parsed all results.
  //
  for (;
    part = parser.exec(query);
    result[decode(part[1])] = decode(part[2])
  );

  return result;
}

/**
 * Transform a query string to an object.
 *
 * @param {Object} obj Object that should be transformed.
 * @param {String} prefix Optional prefix.
 * @returns {String}
 * @api public
 */
function querystringify(obj, prefix) {
  prefix = prefix || '';

  var pairs = [];

  //
  // Optionally prefix with a '?' if needed
  //
  if ('string' !== typeof prefix) prefix = '?';

  for (var key in obj) {
    if (has.call(obj, key)) {
      pairs.push(encodeURIComponent(key) +'='+ encodeURIComponent(obj[key]));
    }
  }

  return pairs.length ? prefix + pairs.join('&') : '';
}

//
// Expose the module.
//
exports.stringify = querystringify;
exports.parse = querystring;

},{}],8:[function(_dereq_,module,exports){
'use strict';

var EventEmitter = _dereq_('eventemitter3')
  , millisecond = _dereq_('millisecond')
  , destroy = _dereq_('demolish')
  , Tick = _dereq_('tick-tock')
  , one = _dereq_('one-time');

/**
 * Returns sane defaults about a given value.
 *
 * @param {String} name Name of property we want.
 * @param {Recovery} selfie Recovery instance that got created.
 * @param {Object} opts User supplied options we want to check.
 * @returns {Number} Some default value.
 * @api private
 */
function defaults(name, selfie, opts) {
  return millisecond(
    name in opts ? opts[name] : (name in selfie ? selfie[name] : Recovery[name])
  );
}

/**
 * Attempt to recover your connection with reconnection attempt.
 *
 * @constructor
 * @param {Object} options Configuration
 * @api public
 */
function Recovery(options) {
  var recovery = this;

  if (!(recovery instanceof Recovery)) return new Recovery(options);

  options = options || {};

  recovery.attempt = null;        // Stores the current reconnect attempt.
  recovery._fn = null;            // Stores the callback.

  recovery['reconnect timeout'] = defaults('reconnect timeout', recovery, options);
  recovery.retries = defaults('retries', recovery, options);
  recovery.factor = defaults('factor', recovery, options);
  recovery.max = defaults('max', recovery, options);
  recovery.min = defaults('min', recovery, options);
  recovery.timers = new Tick(recovery);
}

Recovery.prototype = new EventEmitter();
Recovery.prototype.constructor = Recovery;

Recovery['reconnect timeout'] = '30 seconds';  // Maximum time to wait for an answer.
Recovery.max = Infinity;                       // Maximum delay.
Recovery.min = '500 ms';                       // Minimum delay.
Recovery.retries = 10;                         // Maximum amount of retries.
Recovery.factor = 2;                           // Exponential back off factor.

/**
 * Start a new reconnect procedure.
 *
 * @returns {Recovery}
 * @api public
 */
Recovery.prototype.reconnect = function reconnect() {
  var recovery = this;

  return recovery.backoff(function backedoff(err, opts) {
    opts.duration = (+new Date()) - opts.start;

    if (err) return recovery.emit('reconnect failed', err, opts);

    recovery.emit('reconnected', opts);
  }, recovery.attempt);
};

/**
 * Exponential back off algorithm for retry operations. It uses a randomized
 * retry so we don't DDOS our server when it goes down under pressure.
 *
 * @param {Function} fn Callback to be called after the timeout.
 * @param {Object} opts Options for configuring the timeout.
 * @returns {Recovery}
 * @api private
 */
Recovery.prototype.backoff = function backoff(fn, opts) {
  var recovery = this;

  opts = opts || recovery.attempt || {};

  //
  // Bailout when we already have a back off process running. We shouldn't call
  // the callback then.
  //
  if (opts.backoff) return recovery;

  opts['reconnect timeout'] = defaults('reconnect timeout', recovery, opts);
  opts.retries = defaults('retries', recovery, opts);
  opts.factor = defaults('factor', recovery, opts);
  opts.max = defaults('max', recovery, opts);
  opts.min = defaults('min', recovery, opts);

  opts.start = +opts.start || +new Date();
  opts.duration = +opts.duration || 0;
  opts.attempt = +opts.attempt || 0;

  //
  // Bailout if we are about to make too much attempts.
  //
  if (opts.attempt === opts.retries) {
    fn.call(recovery, new Error('Unable to recover'), opts);
    return recovery;
  }

  //
  // Prevent duplicate back off attempts using the same options object and
  // increment our attempt as we're about to have another go at this thing.
  //
  opts.backoff = true;
  opts.attempt++;

  recovery.attempt = opts;

  //
  // Calculate the timeout, but make it randomly so we don't retry connections
  // at the same interval and defeat the purpose. This exponential back off is
  // based on the work of:
  //
  // http://dthain.blogspot.nl/2009/02/exponential-backoff-in-distributed.html
  //
  opts.scheduled = opts.attempt !== 1
    ? Math.min(Math.round(
        (Math.random() + 1) * opts.min * Math.pow(opts.factor, opts.attempt - 1)
      ), opts.max)
    : opts.min;

  recovery.timers.setTimeout('reconnect', function delay() {
    opts.duration = (+new Date()) - opts.start;
    opts.backoff = false;
    recovery.timers.clear('reconnect, timeout');

    //
    // Create a `one` function which can only be called once. So we can use the
    // same function for different types of invocations to create a much better
    // and usable API.
    //
    var connect = recovery._fn = one(function connect(err) {
      recovery.reset();

      if (err) return recovery.backoff(fn, opts);

      fn.call(recovery, undefined, opts);
    });

    recovery.emit('reconnect', opts, connect);
    recovery.timers.setTimeout('timeout', function timeout() {
      var err = new Error('Failed to reconnect in a timely manner');
      opts.duration = (+new Date()) - opts.start;

      recovery.emit('reconnect timeout', err, opts);
      connect(err);
    }, opts['reconnect timeout']);
  }, opts.scheduled);

  //
  // Emit a `reconnecting` event with current reconnect options. This allows
  // them to update the UI and provide their users with feedback.
  //
  recovery.emit('reconnect scheduled', opts);

  return recovery;
};

/**
 * Check if the reconnection process is currently reconnecting.
 *
 * @returns {Boolean}
 * @api public
 */
Recovery.prototype.reconnecting = function reconnecting() {
  return !!this.attempt;
};

/**
 * Tell our reconnection procedure that we're passed.
 *
 * @param {Error} err Reconnection failed.
 * @returns {Recovery}
 * @api public
 */
Recovery.prototype.reconnected = function reconnected(err) {
  if (this._fn) this._fn(err);
  return this;
};

/**
 * Reset the reconnection attempt so it can be re-used again.
 *
 * @returns {Recovery}
 * @api public
 */
Recovery.prototype.reset = function reset() {
  this._fn = this.attempt = null;
  this.timers.clear('reconnect, timeout');

  return this;
};

/**
 * Clean up the instance.
 *
 * @type {Function}
 * @returns {Boolean}
 * @api public
 */
Recovery.prototype.destroy = destroy('timers attempt _fn');

//
// Expose the module.
//
module.exports = Recovery;

},{"demolish":1,"eventemitter3":9,"millisecond":5,"one-time":6,"tick-tock":11}],9:[function(_dereq_,module,exports){
'use strict';

//
// We store our EE objects in a plain object whose properties are event names.
// If `Object.create(null)` is not supported we prefix the event names with a
// `~` to make sure that the built-in object properties are not overridden or
// used as an attack vector.
// We also assume that `Object.create(null)` is available when the event name
// is an ES6 Symbol.
//
var prefix = typeof Object.create !== 'function' ? '~' : false;

/**
 * Representation of a single EventEmitter function.
 *
 * @param {Function} fn Event handler to be called.
 * @param {Mixed} context Context for function execution.
 * @param {Boolean} once Only emit once
 * @api private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Minimal EventEmitter interface that is molded against the Node.js
 * EventEmitter interface.
 *
 * @constructor
 * @api public
 */
function EventEmitter() { /* Nothing to set */ }

/**
 * Holds the assigned EventEmitters by name.
 *
 * @type {Object}
 * @private
 */
EventEmitter.prototype._events = undefined;

/**
 * Return a list of assigned event listeners.
 *
 * @param {String} event The events that should be listed.
 * @param {Boolean} exists We only need to know if there are listeners.
 * @returns {Array|Boolean}
 * @api public
 */
EventEmitter.prototype.listeners = function listeners(event, exists) {
  var evt = prefix ? prefix + event : event
    , available = this._events && this._events[evt];

  if (exists) return !!available;
  if (!available) return [];
  if (available.fn) return [available.fn];

  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
    ee[i] = available[i].fn;
  }

  return ee;
};

/**
 * Emit an event to all registered event listeners.
 *
 * @param {String} event The name of the event.
 * @returns {Boolean} Indication if we've emitted an event.
 * @api public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events || !this._events[evt]) return false;

  var listeners = this._events[evt]
    , len = arguments.length
    , args
    , i;

  if ('function' === typeof listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1: return listeners.fn.call(listeners.context), true;
      case 2: return listeners.fn.call(listeners.context, a1), true;
      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len -1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length
      , j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1: listeners[i].fn.call(listeners[i].context); break;
        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
        default:
          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Register a new EventListener for the given event.
 *
 * @param {String} event Name of the event.
 * @param {Functon} fn Callback function.
 * @param {Mixed} context The context of the function.
 * @api public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  var listener = new EE(fn, context || this)
    , evt = prefix ? prefix + event : event;

  if (!this._events) this._events = prefix ? {} : Object.create(null);
  if (!this._events[evt]) this._events[evt] = listener;
  else {
    if (!this._events[evt].fn) this._events[evt].push(listener);
    else this._events[evt] = [
      this._events[evt], listener
    ];
  }

  return this;
};

/**
 * Add an EventListener that's only called once.
 *
 * @param {String} event Name of the event.
 * @param {Function} fn Callback function.
 * @param {Mixed} context The context of the function.
 * @api public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  var listener = new EE(fn, context || this, true)
    , evt = prefix ? prefix + event : event;

  if (!this._events) this._events = prefix ? {} : Object.create(null);
  if (!this._events[evt]) this._events[evt] = listener;
  else {
    if (!this._events[evt].fn) this._events[evt].push(listener);
    else this._events[evt] = [
      this._events[evt], listener
    ];
  }

  return this;
};

/**
 * Remove event listeners.
 *
 * @param {String} event The event we want to remove.
 * @param {Function} fn The listener that we need to find.
 * @param {Mixed} context Only remove listeners matching this context.
 * @param {Boolean} once Only remove once listeners.
 * @api public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events || !this._events[evt]) return this;

  var listeners = this._events[evt]
    , events = [];

  if (fn) {
    if (listeners.fn) {
      if (
           listeners.fn !== fn
        || (once && !listeners.once)
        || (context && listeners.context !== context)
      ) {
        events.push(listeners);
      }
    } else {
      for (var i = 0, length = listeners.length; i < length; i++) {
        if (
             listeners[i].fn !== fn
          || (once && !listeners[i].once)
          || (context && listeners[i].context !== context)
        ) {
          events.push(listeners[i]);
        }
      }
    }
  }

  //
  // Reset the array, or remove it completely if we have no more listeners.
  //
  if (events.length) {
    this._events[evt] = events.length === 1 ? events[0] : events;
  } else {
    delete this._events[evt];
  }

  return this;
};

/**
 * Remove all listeners or only the listeners for the specified event.
 *
 * @param {String} event The event want to remove all listeners for.
 * @api public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  if (!this._events) return this;

  if (event) delete this._events[prefix ? prefix + event : event];
  else this._events = prefix ? {} : Object.create(null);

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// This function doesn't apply anymore.
//
EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
  return this;
};

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Expose the module.
//
if ('undefined' !== typeof module) {
  module.exports = EventEmitter;
}

},{}],10:[function(_dereq_,module,exports){
'use strict';

/**
 * Check if we're required to add a port number.
 *
 * @see https://url.spec.whatwg.org/#default-port
 * @param {Number|String} port Port number we need to check
 * @param {String} protocol Protocol we need to check against.
 * @returns {Boolean} Is it a default port for the given protocol
 * @api private
 */
module.exports = function required(port, protocol) {
  protocol = protocol.split(':')[0];
  port = +port;

  if (!port) return false;

  switch (protocol) {
    case 'http':
    case 'ws':
    return port !== 80;

    case 'https':
    case 'wss':
    return port !== 443;

    case 'ftp':
    return port !== 21;

    case 'gopher':
    return port !== 70;

    case 'file':
    return false;
  }

  return port !== 0;
};

},{}],11:[function(_dereq_,module,exports){
'use strict';

var has = Object.prototype.hasOwnProperty
  , ms = _dereq_('millisecond');

/**
 * Timer instance.
 *
 * @constructor
 * @param {Object} timer New timer instance.
 * @param {Function} clear Clears the timer instance.
 * @param {Function} duration Duration of the timer.
 * @param {Function} fn The functions that need to be executed.
 * @api private
 */
function Timer(timer, clear, duration, fn) {
  this.start = +(new Date());
  this.duration = duration;
  this.clear = clear;
  this.timer = timer;
  this.fns = [fn];
}

/**
 * Calculate the time left for a given timer.
 *
 * @returns {Number} Time in milliseconds.
 * @api public
 */
Timer.prototype.remaining = function remaining() {
  return this.duration - this.taken();
};

/**
 * Calculate the amount of time it has taken since we've set the timer.
 *
 * @returns {Number}
 * @api public
 */
Timer.prototype.taken = function taken() {
  return +(new Date()) - this.start;
};

/**
 * Custom wrappers for the various of clear{whatever} functions. We cannot
 * invoke them directly as this will cause thrown errors in Google Chrome with
 * an Illegal Invocation Error
 *
 * @see #2
 * @type {Function}
 * @api private
 */
function unsetTimeout(id) { clearTimeout(id); }
function unsetInterval(id) { clearInterval(id); }
function unsetImmediate(id) { clearImmediate(id); }

/**
 * Simple timer management.
 *
 * @constructor
 * @param {Mixed} context Context of the callbacks that we execute.
 * @api public
 */
function Tick(context) {
  if (!(this instanceof Tick)) return new Tick(context);

  this.timers = {};
  this.context = context || this;
}

/**
 * Return a function which will just iterate over all assigned callbacks and
 * optionally clear the timers from memory if needed.
 *
 * @param {String} name Name of the timer we need to execute.
 * @param {Boolean} clear Also clear from memory.
 * @returns {Function}
 * @api private
 */
Tick.prototype.tock = function ticktock(name, clear) {
  var tock = this;

  return function tickedtock() {
    if (!(name in tock.timers)) return;

    var timer = tock.timers[name]
      , fns = timer.fns.slice()
      , l = fns.length
      , i = 0;

    if (clear) tock.clear(name);
    else tock.start = +new Date();

    for (; i < l; i++) {
      fns[i].call(tock.context);
    }
  };
};

/**
 * Add a new timeout.
 *
 * @param {String} name Name of the timer.
 * @param {Function} fn Completion callback.
 * @param {Mixed} time Duration of the timer.
 * @returns {Tick}
 * @api public
 */
Tick.prototype.setTimeout = function timeout(name, fn, time) {
  var tick = this
    , tock;

  if (tick.timers[name]) {
    tick.timers[name].fns.push(fn);
    return tick;
  }

  tock = ms(time);
  tick.timers[name] = new Timer(
    setTimeout(tick.tock(name, true), ms(time)),
    unsetTimeout,
    tock,
    fn
  );

  return tick;
};

/**
 * Add a new interval.
 *
 * @param {String} name Name of the timer.
 * @param {Function} fn Completion callback.
 * @param {Mixed} time Interval of the timer.
 * @returns {Tick}
 * @api public
 */
Tick.prototype.setInterval = function interval(name, fn, time) {
  var tick = this
    , tock;

  if (tick.timers[name]) {
    tick.timers[name].fns.push(fn);
    return tick;
  }

  tock = ms(time);
  tick.timers[name] = new Timer(
    setInterval(tick.tock(name), ms(time)),
    unsetInterval,
    tock,
    fn
  );

  return tick;
};

/**
 * Add a new setImmediate.
 *
 * @param {String} name Name of the timer.
 * @param {Function} fn Completion callback.
 * @returns {Tick}
 * @api public
 */
Tick.prototype.setImmediate = function immediate(name, fn) {
  var tick = this;

  if ('function' !== typeof setImmediate) return tick.setTimeout(name, fn, 0);

  if (tick.timers[name]) {
    tick.timers[name].fns.push(fn);
    return tick;
  }

  tick.timers[name] = new Timer(
    setImmediate(tick.tock(name, true)),
    unsetImmediate,
    0,
    fn
  );

  return tick;
};

/**
 * Check if we have a timer set.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api public
 */
Tick.prototype.active = function active(name) {
  return name in this.timers;
};

/**
 * Properly clean up all timeout references. If no arguments are supplied we
 * will attempt to clear every single timer that is present.
 *
 * @param {Arguments} ..args.. The names of the timeouts we need to clear
 * @returns {Tick}
 * @api public
 */
Tick.prototype.clear = function clear() {
  var args = arguments.length ? arguments : []
    , tick = this
    , timer, i, l;

  if (args.length === 1 && 'string' === typeof args[0]) {
    args = args[0].split(/[, ]+/);
  }

  if (!args.length) {
    for (timer in tick.timers) {
      if (has.call(tick.timers, timer)) args.push(timer);
    }
  }

  for (i = 0, l = args.length; i < l; i++) {
    timer = tick.timers[args[i]];

    if (!timer) continue;
    timer.clear(timer.timer);

    timer.fns = timer.timer = timer.clear = null;
    delete tick.timers[args[i]];
  }

  return tick;
};

/**
 * Adjust a timeout or interval to a new duration.
 *
 * @returns {Tick}
 * @api public
 */
Tick.prototype.adjust = function adjust(name, time) {
  var interval
    , tick = this
    , tock = ms(time)
    , timer = tick.timers[name];

  if (!timer) return tick;

  interval = timer.clear === unsetInterval;
  timer.clear(timer.timer);
  timer.start = +(new Date());
  timer.duration = tock;
  timer.timer = (interval ? setInterval : setTimeout)(tick.tock(name, !interval), tock);

  return tick;
};

/**
 * We will no longer use this module, prepare your self for global cleanups.
 *
 * @returns {Boolean}
 * @api public
 */
Tick.prototype.end = Tick.prototype.destroy = function end() {
  if (!this.context) return false;

  this.clear();
  this.context = this.timers = null;

  return true;
};

//
// Expose the timer factory.
//
Tick.Timer = Timer;
module.exports = Tick;

},{"millisecond":5}],12:[function(_dereq_,module,exports){
(function (global){
'use strict';

var required = _dereq_('requires-port')
  , qs = _dereq_('querystringify')
  , protocolre = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\S\s]*)/i
  , slashes = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//;

/**
 * These are the parse rules for the URL parser, it informs the parser
 * about:
 *
 * 0. The char it Needs to parse, if it's a string it should be done using
 *    indexOf, RegExp using exec and NaN means set as current value.
 * 1. The property we should set when parsing this value.
 * 2. Indication if it's backwards or forward parsing, when set as number it's
 *    the value of extra chars that should be split off.
 * 3. Inherit from location if non existing in the parser.
 * 4. `toLowerCase` the resulting value.
 */
var rules = [
  ['#', 'hash'],                        // Extract from the back.
  ['?', 'query'],                       // Extract from the back.
  ['/', 'pathname'],                    // Extract from the back.
  ['@', 'auth', 1],                     // Extract from the front.
  [NaN, 'host', undefined, 1, 1],       // Set left over value.
  [/:(\d+)$/, 'port', undefined, 1],    // RegExp the back.
  [NaN, 'hostname', undefined, 1, 1]    // Set left over.
];

/**
 * These properties should not be copied or inherited from. This is only needed
 * for all non blob URL's as a blob URL does not include a hash, only the
 * origin.
 *
 * @type {Object}
 * @private
 */
var ignore = { hash: 1, query: 1 };

/**
 * The location object differs when your code is loaded through a normal page,
 * Worker or through a worker using a blob. And with the blobble begins the
 * trouble as the location object will contain the URL of the blob, not the
 * location of the page where our code is loaded in. The actual origin is
 * encoded in the `pathname` so we can thankfully generate a good "default"
 * location from it so we can generate proper relative URL's again.
 *
 * @param {Object|String} loc Optional default location object.
 * @returns {Object} lolcation object.
 * @api public
 */
function lolcation(loc) {
  loc = loc || global.location || {};

  var finaldestination = {}
    , type = typeof loc
    , key;

  if ('blob:' === loc.protocol) {
    finaldestination = new URL(unescape(loc.pathname), {});
  } else if ('string' === type) {
    finaldestination = new URL(loc, {});
    for (key in ignore) delete finaldestination[key];
  } else if ('object' === type) {
    for (key in loc) {
      if (key in ignore) continue;
      finaldestination[key] = loc[key];
    }

    if (finaldestination.slashes === undefined) {
      finaldestination.slashes = slashes.test(loc.href);
    }
  }

  return finaldestination;
}

/**
 * @typedef ProtocolExtract
 * @type Object
 * @property {String} protocol Protocol matched in the URL, in lowercase.
 * @property {Boolean} slashes `true` if protocol is followed by "//", else `false`.
 * @property {String} rest Rest of the URL that is not part of the protocol.
 */

/**
 * Extract protocol information from a URL with/without double slash ("//").
 *
 * @param {String} address URL we want to extract from.
 * @return {ProtocolExtract} Extracted information.
 * @api private
 */
function extractProtocol(address) {
  var match = protocolre.exec(address);

  return {
    protocol: match[1] ? match[1].toLowerCase() : '',
    slashes: !!match[2],
    rest: match[3]
  };
}

/**
 * Resolve a relative URL pathname against a base URL pathname.
 *
 * @param {String} relative Pathname of the relative URL.
 * @param {String} base Pathname of the base URL.
 * @return {String} Resolved pathname.
 * @api private
 */
function resolve(relative, base) {
  var path = (base || '/').split('/').slice(0, -1).concat(relative.split('/'))
    , i = path.length
    , last = path[i - 1]
    , unshift = false
    , up = 0;

  while (i--) {
    if (path[i] === '.') {
      path.splice(i, 1);
    } else if (path[i] === '..') {
      path.splice(i, 1);
      up++;
    } else if (up) {
      if (i === 0) unshift = true;
      path.splice(i, 1);
      up--;
    }
  }

  if (unshift) path.unshift('');
  if (last === '.' || last === '..') path.push('');

  return path.join('/');
}

/**
 * The actual URL instance. Instead of returning an object we've opted-in to
 * create an actual constructor as it's much more memory efficient and
 * faster and it pleases my OCD.
 *
 * @constructor
 * @param {String} address URL we want to parse.
 * @param {Object|String} location Location defaults for relative paths.
 * @param {Boolean|Function} parser Parser for the query string.
 * @api public
 */
function URL(address, location, parser) {
  if (!(this instanceof URL)) {
    return new URL(address, location, parser);
  }

  var relative, extracted, parse, instruction, index, key
    , instructions = rules.slice()
    , type = typeof location
    , url = this
    , i = 0;

  //
  // The following if statements allows this module two have compatibility with
  // 2 different API:
  //
  // 1. Node.js's `url.parse` api which accepts a URL, boolean as arguments
  //    where the boolean indicates that the query string should also be parsed.
  //
  // 2. The `URL` interface of the browser which accepts a URL, object as
  //    arguments. The supplied object will be used as default values / fall-back
  //    for relative paths.
  //
  if ('object' !== type && 'string' !== type) {
    parser = location;
    location = null;
  }

  if (parser && 'function' !== typeof parser) parser = qs.parse;

  location = lolcation(location);

  //
  // Extract protocol information before running the instructions.
  //
  extracted = extractProtocol(address || '');
  relative = !extracted.protocol && !extracted.slashes;
  url.slashes = extracted.slashes || relative && location.slashes;
  url.protocol = extracted.protocol || location.protocol || '';
  address = extracted.rest;

  //
  // When the authority component is absent the URL starts with a path
  // component.
  //
  if (!extracted.slashes) instructions[2] = [/(.*)/, 'pathname'];

  for (; i < instructions.length; i++) {
    instruction = instructions[i];
    parse = instruction[0];
    key = instruction[1];

    if (parse !== parse) {
      url[key] = address;
    } else if ('string' === typeof parse) {
      if (~(index = address.indexOf(parse))) {
        if ('number' === typeof instruction[2]) {
          url[key] = address.slice(0, index);
          address = address.slice(index + instruction[2]);
        } else {
          url[key] = address.slice(index);
          address = address.slice(0, index);
        }
      }
    } else if ((index = parse.exec(address))) {
      url[key] = index[1];
      address = address.slice(0, index.index);
    }

    url[key] = url[key] || (
      relative && instruction[3] ? location[key] || '' : ''
    );

    //
    // Hostname, host and protocol should be lowercased so they can be used to
    // create a proper `origin`.
    //
    if (instruction[4]) url[key] = url[key].toLowerCase();
  }

  //
  // Also parse the supplied query string in to an object. If we're supplied
  // with a custom parser as function use that instead of the default build-in
  // parser.
  //
  if (parser) url.query = parser(url.query);

  //
  // If the URL is relative, resolve the pathname against the base URL.
  //
  if (
      relative
    && location.slashes
    && url.pathname.charAt(0) !== '/'
    && (url.pathname !== '' || location.pathname !== '')
  ) {
    url.pathname = resolve(url.pathname, location.pathname);
  }

  //
  // We should not add port numbers if they are already the default port number
  // for a given protocol. As the host also contains the port number we're going
  // override it with the hostname which contains no port number.
  //
  if (!required(url.port, url.protocol)) {
    url.host = url.hostname;
    url.port = '';
  }

  //
  // Parse down the `auth` for the username and password.
  //
  url.username = url.password = '';
  if (url.auth) {
    instruction = url.auth.split(':');
    url.username = instruction[0] || '';
    url.password = instruction[1] || '';
  }

  url.origin = url.protocol && url.host && url.protocol !== 'file:'
    ? url.protocol +'//'+ url.host
    : 'null';

  //
  // The href is just the compiled result.
  //
  url.href = url.toString();
}

/**
 * This is convenience method for changing properties in the URL instance to
 * insure that they all propagate correctly.
 *
 * @param {String} part          Property we need to adjust.
 * @param {Mixed} value          The newly assigned value.
 * @param {Boolean|Function} fn  When setting the query, it will be the function
 *                               used to parse the query.
 *                               When setting the protocol, double slash will be
 *                               removed from the final url if it is true.
 * @returns {URL}
 * @api public
 */
function set(part, value, fn) {
  var url = this;

  switch (part) {
    case 'query':
      if ('string' === typeof value && value.length) {
        value = (fn || qs.parse)(value);
      }

      url[part] = value;
      break;

    case 'port':
      url[part] = value;

      if (!required(value, url.protocol)) {
        url.host = url.hostname;
        url[part] = '';
      } else if (value) {
        url.host = url.hostname +':'+ value;
      }

      break;

    case 'hostname':
      url[part] = value;

      if (url.port) value += ':'+ url.port;
      url.host = value;
      break;

    case 'host':
      url[part] = value;

      if (/:\d+$/.test(value)) {
        value = value.split(':');
        url.port = value.pop();
        url.hostname = value.join(':');
      } else {
        url.hostname = value;
        url.port = '';
      }

      break;

    case 'protocol':
      url.protocol = value.toLowerCase();
      url.slashes = !fn;
      break;

    case 'pathname':
      url.pathname = value.length && value.charAt(0) !== '/' ? '/' + value : value;

      break;

    default:
      url[part] = value;
  }

  for (var i = 0; i < rules.length; i++) {
    var ins = rules[i];

    if (ins[4]) url[ins[1]] = url[ins[1]].toLowerCase();
  }

  url.origin = url.protocol && url.host && url.protocol !== 'file:'
    ? url.protocol +'//'+ url.host
    : 'null';

  url.href = url.toString();

  return url;
}

/**
 * Transform the properties back in to a valid and full URL string.
 *
 * @param {Function} stringify Optional query stringify function.
 * @returns {String}
 * @api public
 */
function toString(stringify) {
  if (!stringify || 'function' !== typeof stringify) stringify = qs.stringify;

  var query
    , url = this
    , protocol = url.protocol;

  if (protocol && protocol.charAt(protocol.length - 1) !== ':') protocol += ':';

  var result = protocol + (url.slashes ? '//' : '');

  if (url.username) {
    result += url.username;
    if (url.password) result += ':'+ url.password;
    result += '@';
  }

  result += url.host + url.pathname;

  query = 'object' === typeof url.query ? stringify(url.query) : url.query;
  if (query) result += '?' !== query.charAt(0) ? '?'+ query : query;

  if (url.hash) result += url.hash;

  return result;
}

URL.prototype = { set: set, toString: toString };

//
// Expose the URL parser and some additional properties that might be useful for
// others or testing.
//
URL.extractProtocol = extractProtocol;
URL.location = lolcation;
URL.qs = qs;

module.exports = URL;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"querystringify":7,"requires-port":10}],13:[function(_dereq_,module,exports){
'use strict';

var alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_'.split('')
  , length = 64
  , map = {}
  , seed = 0
  , i = 0
  , prev;

/**
 * Return a string representing the specified number.
 *
 * @param {Number} num The number to convert.
 * @returns {String} The string representation of the number.
 * @api public
 */
function encode(num) {
  var encoded = '';

  do {
    encoded = alphabet[num % length] + encoded;
    num = Math.floor(num / length);
  } while (num > 0);

  return encoded;
}

/**
 * Return the integer value specified by the given string.
 *
 * @param {String} str The string to convert.
 * @returns {Number} The integer value represented by the string.
 * @api public
 */
function decode(str) {
  var decoded = 0;

  for (i = 0; i < str.length; i++) {
    decoded = decoded * length + map[str.charAt(i)];
  }

  return decoded;
}

/**
 * Yeast: A tiny growing id generator.
 *
 * @returns {String} A unique id.
 * @api public
 */
function yeast() {
  var now = encode(+new Date());

  if (now !== prev) return seed = 0, prev = now;
  return now +'.'+ encode(seed++);
}

//
// Map each character to its index.
//
for (; i < length; i++) map[alphabet[i]] = i;

//
// Expose the `yeast`, `encode` and `decode` functions.
//
yeast.encode = encode;
yeast.decode = decode;
module.exports = yeast;

},{}],14:[function(_dereq_,module,exports){
/*globals require, define */
'use strict';

var EventEmitter = _dereq_('eventemitter3')
  , TickTock = _dereq_('tick-tock')
  , Recovery = _dereq_('recovery')
  , qs = _dereq_('querystringify')
  , inherits = _dereq_('inherits')
  , destroy = _dereq_('demolish')
  , yeast = _dereq_('yeast')
  , u2028 = /\u2028/g
  , u2029 = /\u2029/g;

/**
 * Context assertion, ensure that some of our public Primus methods are called
 * with the correct context to ensure that
 *
 * @param {Primus} self The context of the function.
 * @param {String} method The method name.
 * @api private
 */
function context(self, method) {
  if (self instanceof Primus) return;

  var failure = new Error('Primus#'+ method + '\'s context should called with a Primus instance');

  if ('function' !== typeof self.listeners || !self.listeners('error').length) {
    throw failure;
  }

  self.emit('error', failure);
}

//
// Sets the default connection URL, it uses the default origin of the browser
// when supported but degrades for older browsers. In Node.js, we cannot guess
// where the user wants to connect to, so we just default to localhost.
//
var defaultUrl;

try {
  if (location.origin) {
    defaultUrl = location.origin;
  } else {
    defaultUrl = location.protocol +'//'+ location.host;
  }
} catch (e) {
  defaultUrl = 'http://127.0.0.1';
}

/**
 * Primus is a real-time library agnostic framework for establishing real-time
 * connections with servers.
 *
 * Options:
 * - reconnect, configuration for the reconnect process.
 * - manual, don't automatically call `.open` to start the connection.
 * - websockets, force the use of WebSockets, even when you should avoid them.
 * - timeout, connect timeout, server didn't respond in a timely manner.
 * - pingTimeout, The maximum amount of time to wait for the server to send a ping.
 * - network, Use network events as leading method for network connection drops.
 * - strategy, Reconnection strategies.
 * - transport, Transport options.
 * - url, uri, The URL to use connect with the server.
 *
 * @constructor
 * @param {String} url The URL of your server.
 * @param {Object} options The configuration.
 * @api public
 */
function Primus(url, options) {
  if (!(this instanceof Primus)) return new Primus(url, options);

  Primus.Stream.call(this);

  if ('function' !== typeof this.client) {
    return this.critical(new Error(
      'The client library has not been compiled correctly, see '+
      'https://github.com/primus/primus#client-library for more details'
    ));
  }

  if ('object' === typeof url) {
    options = url;
    url = options.url || options.uri || defaultUrl;
  } else {
    options = options || {};
  }

  if ('ping' in options || 'pong' in options) {
    return this.critical(new Error(
      'The `ping` and `pong` options have been removed'
    ));
  }

  var primus = this;

  // The maximum number of messages that can be placed in queue.
  options.queueSize = 'queueSize' in options ? options.queueSize : Infinity;

  // Connection timeout duration.
  options.timeout = 'timeout' in options ? options.timeout : 10e3;

  // Stores the back off configuration.
  options.reconnect = 'reconnect' in options ? options.reconnect : {};

  // Heartbeat ping interval.
  options.pingTimeout = 'pingTimeout' in options ? options.pingTimeout : 45000;

  // Reconnect strategies.
  options.strategy = 'strategy' in options ? options.strategy : [];

  // Custom transport options.
  options.transport = 'transport' in options ? options.transport : {};

  primus.buffer = [];                           // Stores premature send data.
  primus.writable = true;                       // Silly stream compatibility.
  primus.readable = true;                       // Silly stream compatibility.
  primus.url = primus.parse(url || defaultUrl); // Parse the URL to a readable format.
  primus.readyState = Primus.CLOSED;            // The readyState of the connection.
  primus.options = options;                     // Reference to the supplied options.
  primus.timers = new TickTock(this);           // Contains all our timers.
  primus.socket = null;                         // Reference to the internal connection.
  primus.disconnect = false;                    // Did we receive a disconnect packet?
  primus.transport = options.transport;         // Transport options.
  primus.transformers = {                       // Message transformers.
    outgoing: [],
    incoming: []
  };

  //
  // Create our reconnection instance.
  //
  primus.recovery = new Recovery(options.reconnect);

  //
  // Parse the reconnection strategy. It can have the following strategies:
  //
  // - timeout: Reconnect when we have a network timeout.
  // - disconnect: Reconnect when we have an unexpected disconnect.
  // - online: Reconnect when we're back online.
  //
  if ('string' === typeof options.strategy) {
    options.strategy = options.strategy.split(/\s?,\s?/g);
  }

  if (false === options.strategy) {
    //
    // Strategies are disabled, but we still need an empty array to join it in
    // to nothing.
    //
    options.strategy = [];
  } else if (!options.strategy.length) {
    options.strategy.push('disconnect', 'online');

    //
    // Timeout based reconnection should only be enabled conditionally. When
    // authorization is enabled it could trigger.
    //
    if (!this.authorization) options.strategy.push('timeout');
  }

  options.strategy = options.strategy.join(',').toLowerCase();

  //
  // Force the use of WebSockets, even when we've detected some potential
  // broken WebSocket implementation.
  //
  if ('websockets' in options) {
    primus.AVOID_WEBSOCKETS = !options.websockets;
  }

  //
  // Force or disable the use of NETWORK events as leading client side
  // disconnection detection.
  //
  if ('network' in options) {
    primus.NETWORK_EVENTS = options.network;
  }

  //
  // Check if the user wants to manually initialise a connection. If they don't,
  // we want to do it after a really small timeout so we give the users enough
  // time to listen for `error` events etc.
  //
  if (!options.manual) primus.timers.setTimeout('open', function open() {
    primus.timers.clear('open');
    primus.open();
  }, 0);

  primus.initialise(options);
}

/**
 * Simple require wrapper to make browserify, node and require.js play nice.
 *
 * @param {String} name The module to require.
 * @returns {Object|Undefined} The module that we required.
 * @api private
 */
Primus.requires = Primus.require = function requires(name) {
  if ('function' !== typeof _dereq_) return undefined;

  return !('function' === typeof define && define.amd)
    ? _dereq_(name)
    : undefined;
};

//
// It's possible that we're running in Node.js or in a Node.js compatible
// environment. In this cases we try to inherit from the Stream base class.
//
try {
  Primus.Stream = Primus.requires('stream');
} catch (e) { }

if (!Primus.Stream) Primus.Stream = EventEmitter;

inherits(Primus, Primus.Stream);

/**
 * Primus readyStates, used internally to set the correct ready state.
 *
 * @type {Number}
 * @private
 */
Primus.OPENING = 1;   // We're opening the connection.
Primus.CLOSED  = 2;   // No active connection.
Primus.OPEN    = 3;   // The connection is open.

/**
 * Are we working with a potentially broken WebSockets implementation? This
 * boolean can be used by transformers to remove `WebSockets` from their
 * supported transports.
 *
 * @type {Boolean}
 * @private
 */
Primus.prototype.AVOID_WEBSOCKETS = false;

/**
 * Some browsers support registering emitting `online` and `offline` events when
 * the connection has been dropped on the client. We're going to detect it in
 * a simple `try {} catch (e) {}` statement so we don't have to do complicated
 * feature detection.
 *
 * @type {Boolean}
 * @private
 */
Primus.prototype.NETWORK_EVENTS = false;
Primus.prototype.online = true;

try {
  if (
       Primus.prototype.NETWORK_EVENTS = 'onLine' in navigator
    && (window.addEventListener || document.body.attachEvent)
  ) {
    if (!navigator.onLine) {
      Primus.prototype.online = false;
    }
  }
} catch (e) { }

/**
 * The Ark contains all our plugins definitions. It's namespaced by
 * name => plugin.
 *
 * @type {Object}
 * @private
 */
Primus.prototype.ark = {};

/**
 * Simple emit wrapper that returns a function that emits an event once it's
 * called. This makes it easier for transports to emit specific events.
 *
 * @returns {Function} A function that will emit the event when called.
 * @api public
 */
Primus.prototype.emits = _dereq_('emits');

/**
 * Return the given plugin.
 *
 * @param {String} name The name of the plugin.
 * @returns {Object|undefined} The plugin or undefined.
 * @api public
 */
Primus.prototype.plugin = function plugin(name) {
  context(this, 'plugin');

  if (name) return this.ark[name];

  var plugins = {};

  for (name in this.ark) {
    plugins[name] = this.ark[name];
  }

  return plugins;
};

/**
 * Checks if the given event is an emitted event by Primus.
 *
 * @param {String} evt The event name.
 * @returns {Boolean} Indication of the event is reserved for internal use.
 * @api public
 */
Primus.prototype.reserved = function reserved(evt) {
  return (/^(incoming|outgoing)::/).test(evt)
  || evt in this.reserved.events;
};

/**
 * The actual events that are used by the client.
 *
 * @type {Object}
 * @public
 */
Primus.prototype.reserved.events = {
  'reconnect scheduled': 1,
  'reconnect timeout': 1,
  'readyStateChange': 1,
  'reconnect failed': 1,
  'reconnected': 1,
  'reconnect': 1,
  'offline': 1,
  'timeout': 1,
  'destroy': 1,
  'online': 1,
  'error': 1,
  'close': 1,
  'open': 1,
  'data': 1,
  'end': 1
};

/**
 * Initialise the Primus and setup all parsers and internal listeners.
 *
 * @param {Object} options The original options object.
 * @returns {Primus}
 * @api private
 */
Primus.prototype.initialise = function initialise(options) {
  var primus = this;

  primus.recovery
  .on('reconnected', primus.emits('reconnected'))
  .on('reconnect failed', primus.emits('reconnect failed', function failed(next) {
    primus.emit('end');
    next();
  }))
  .on('reconnect timeout', primus.emits('reconnect timeout'))
  .on('reconnect scheduled', primus.emits('reconnect scheduled'))
  .on('reconnect', primus.emits('reconnect', function reconnect(next) {
    primus.emit('outgoing::reconnect');
    next();
  }));

  primus.on('outgoing::open', function opening() {
    var readyState = primus.readyState;

    primus.readyState = Primus.OPENING;
    if (readyState !== primus.readyState) {
      primus.emit('readyStateChange', 'opening');
    }
  });

  primus.on('incoming::open', function opened() {
    var readyState = primus.readyState;

    if (primus.recovery.reconnecting()) {
      primus.recovery.reconnected();
    }

    //
    // The connection has been opened so we should set our state to
    // (writ|read)able so our stream compatibility works as intended.
    //
    primus.writable = true;
    primus.readable = true;

    //
    // Make sure we are flagged as `online` as we've successfully opened the
    // connection.
    //
    if (!primus.online) {
      primus.online = true;
      primus.emit('online');
    }

    primus.readyState = Primus.OPEN;
    if (readyState !== primus.readyState) {
      primus.emit('readyStateChange', 'open');
    }

    primus.heartbeat();

    if (primus.buffer.length) {
      var data = primus.buffer.slice()
        , length = data.length
        , i = 0;

      primus.buffer.length = 0;

      for (; i < length; i++) {
        primus._write(data[i]);
      }
    }

    primus.emit('open');
  });

  primus.on('incoming::ping', function ping(time) {
    primus.online = true;
    primus.heartbeat();
    primus.emit('outgoing::pong', time);
    primus._write('primus::pong::'+ time);
  });

  primus.on('incoming::error', function error(e) {
    var connect = primus.timers.active('connect')
      , err = e;

    //
    // When the error is not an Error instance we try to normalize it.
    //
    if ('string' === typeof e) {
      err = new Error(e);
    } else if (!(e instanceof Error) && 'object' === typeof e) {
      //
      // BrowserChannel and SockJS returns an object which contains some
      // details of the error. In order to have a proper error we "copy" the
      // details in an Error instance.
      //
      err = new Error(e.message || e.reason);
      for (var key in e) {
        if (Object.prototype.hasOwnProperty.call(e, key))
          err[key] = e[key];
      }
    }
    //
    // We're still doing a reconnect attempt, it could be that we failed to
    // connect because the server was down. Failing connect attempts should
    // always emit an `error` event instead of a `open` event.
    //
    //
    if (primus.recovery.reconnecting()) return primus.recovery.reconnected(err);
    if (primus.listeners('error').length) primus.emit('error', err);

    //
    // We received an error while connecting, this most likely the result of an
    // unauthorized access to the server.
    //
    if (connect) {
      if (~primus.options.strategy.indexOf('timeout')) {
        primus.recovery.reconnect();
      } else {
        primus.end();
      }
    }
  });

  primus.on('incoming::data', function message(raw) {
    primus.decoder(raw, function decoding(err, data) {
      //
      // Do a "safe" emit('error') when we fail to parse a message. We don't
      // want to throw here as listening to errors should be optional.
      //
      if (err) return primus.listeners('error').length && primus.emit('error', err);

      //
      // Handle all "primus::" prefixed protocol messages.
      //
      if (primus.protocol(data)) return;
      primus.transforms(primus, primus, 'incoming', data, raw);
    });
  });

  primus.on('incoming::end', function end() {
    var readyState = primus.readyState;

    //
    // This `end` started with the receiving of a primus::server::close packet
    // which indicated that the user/developer on the server closed the
    // connection and it was not a result of a network disruption. So we should
    // kill the connection without doing a reconnect.
    //
    if (primus.disconnect) {
      primus.disconnect = false;

      return primus.end();
    }

    //
    // Always set the readyState to closed, and if we're still connecting, close
    // the connection so we're sure that everything after this if statement block
    // is only executed because our readyState is set to `open`.
    //
    primus.readyState = Primus.CLOSED;
    if (readyState !== primus.readyState) {
      primus.emit('readyStateChange', 'end');
    }

    if (primus.timers.active('connect')) primus.end();
    if (readyState !== Primus.OPEN) {
      return primus.recovery.reconnecting()
        ? primus.recovery.reconnect()
        : false;
    }

    this.writable = false;
    this.readable = false;

    //
    // Clear all timers in case we're not going to reconnect.
    //
    this.timers.clear();

    //
    // Fire the `close` event as an indication of connection disruption.
    // This is also fired by `primus#end` so it is emitted in all cases.
    //
    primus.emit('close');

    //
    // The disconnect was unintentional, probably because the server has
    // shutdown, so if the reconnection is enabled start a reconnect procedure.
    //
    if (~primus.options.strategy.indexOf('disconnect')) {
      return primus.recovery.reconnect();
    }

    primus.emit('outgoing::end');
    primus.emit('end');
  });

  //
  // Setup the real-time client.
  //
  primus.client();

  //
  // Process the potential plugins.
  //
  for (var plugin in primus.ark) {
    primus.ark[plugin].call(primus, primus, options);
  }

  //
  // NOTE: The following code is only required if we're supporting network
  // events as it requires access to browser globals.
  //
  if (!primus.NETWORK_EVENTS) return primus;

  /**
   * Handler for offline notifications.
   *
   * @api private
   */
  primus.offlineHandler = function offline() {
    if (!primus.online) return; // Already or still offline, bailout.

    primus.online = false;
    primus.emit('offline');
    primus.end();

    //
    // It is certainly possible that we're in a reconnection loop and that the
    // user goes offline. In this case we want to kill the existing attempt so
    // when the user goes online, it will attempt to reconnect freshly again.
    //
    primus.recovery.reset();
  };

  /**
   * Handler for online notifications.
   *
   * @api private
   */
  primus.onlineHandler = function online() {
    if (primus.online) return; // Already or still online, bailout.

    primus.online = true;
    primus.emit('online');

    if (~primus.options.strategy.indexOf('online')) {
      primus.recovery.reconnect();
    }
  };

  if (window.addEventListener) {
    window.addEventListener('offline', primus.offlineHandler, false);
    window.addEventListener('online', primus.onlineHandler, false);
  } else if (document.body.attachEvent){
    document.body.attachEvent('onoffline', primus.offlineHandler);
    document.body.attachEvent('ononline', primus.onlineHandler);
  }

  return primus;
};

/**
 * Really dead simple protocol parser. We simply assume that every message that
 * is prefixed with `primus::` could be used as some sort of protocol definition
 * for Primus.
 *
 * @param {String} msg The data.
 * @returns {Boolean} Is a protocol message.
 * @api private
 */
Primus.prototype.protocol = function protocol(msg) {
  if (
       'string' !== typeof msg
    || msg.indexOf('primus::') !== 0
  ) return false;

  var last = msg.indexOf(':', 8)
    , value = msg.slice(last + 2);

  switch (msg.slice(8,  last)) {
    case 'ping':
      this.emit('incoming::ping', +value);
      break;

    case 'server':
      //
      // The server is closing the connection, forcefully disconnect so we don't
      // reconnect again.
      //
      if ('close' === value) {
        this.disconnect = true;
      }
      break;

    case 'id':
      this.emit('incoming::id', value);
      break;

    //
    // Unknown protocol, somebody is probably sending `primus::` prefixed
    // messages.
    //
    default:
      return false;
  }

  return true;
};

/**
 * Execute the set of message transformers from Primus on the incoming or
 * outgoing message.
 * This function and it's content should be in sync with Spark#transforms in
 * spark.js.
 *
 * @param {Primus} primus Reference to the Primus instance with message transformers.
 * @param {Spark|Primus} connection Connection that receives or sends data.
 * @param {String} type The type of message, 'incoming' or 'outgoing'.
 * @param {Mixed} data The data to send or that has been received.
 * @param {String} raw The raw encoded data.
 * @returns {Primus}
 * @api public
 */
Primus.prototype.transforms = function transforms(primus, connection, type, data, raw) {
  var packet = { data: data }
    , fns = primus.transformers[type];

  //
  // Iterate in series over the message transformers so we can allow optional
  // asynchronous execution of message transformers which could for example
  // retrieve additional data from the server, do extra decoding or even
  // message validation.
  //
  (function transform(index, done) {
    var transformer = fns[index++];

    if (!transformer) return done();

    if (1 === transformer.length) {
      if (false === transformer.call(connection, packet)) {
        //
        // When false is returned by an incoming transformer it means that's
        // being handled by the transformer and we should not emit the `data`
        // event.
        //
        return;
      }

      return transform(index, done);
    }

    transformer.call(connection, packet, function finished(err, arg) {
      if (err) return connection.emit('error', err);
      if (false === arg) return;

      transform(index, done);
    });
  }(0, function done() {
    //
    // We always emit 2 arguments for the data event, the first argument is the
    // parsed data and the second argument is the raw string that we received.
    // This allows you, for example, to do some validation on the parsed data
    // and then save the raw string in your database without the stringify
    // overhead.
    //
    if ('incoming' === type) return connection.emit('data', packet.data, raw);

    connection._write(packet.data);
  }));

  return this;
};

/**
 * Retrieve the current id from the server.
 *
 * @param {Function} fn Callback function.
 * @returns {Primus}
 * @api public
 */
Primus.prototype.id = function id(fn) {
  if (this.socket && this.socket.id) return fn(this.socket.id);

  this._write('primus::id::');
  return this.once('incoming::id', fn);
};

/**
 * Establish a connection with the server. When this function is called we
 * assume that we don't have any open connections. If you do call it when you
 * have a connection open, it could cause duplicate connections.
 *
 * @returns {Primus}
 * @api public
 */
Primus.prototype.open = function open() {
  context(this, 'open');

  //
  // Only start a `connection timeout` procedure if we're not reconnecting as
  // that shouldn't count as an initial connection. This should be started
  // before the connection is opened to capture failing connections and kill the
  // timeout.
  //
  if (!this.recovery.reconnecting() && this.options.timeout) this.timeout();

  this.emit('outgoing::open');
  return this;
};

/**
 * Send a new message.
 *
 * @param {Mixed} data The data that needs to be written.
 * @returns {Boolean} Always returns true as we don't support back pressure.
 * @api public
 */
Primus.prototype.write = function write(data) {
  context(this, 'write');
  this.transforms(this, this, 'outgoing', data);

  return true;
};

/**
 * The actual message writer.
 *
 * @param {Mixed} data The message that needs to be written.
 * @returns {Boolean} Successful write to the underlaying transport.
 * @api private
 */
Primus.prototype._write = function write(data) {
  var primus = this;

  //
  // The connection is closed, normally this would already be done in the
  // `spark.write` method, but as `_write` is used internally, we should also
  // add the same check here to prevent potential crashes by writing to a dead
  // socket.
  //
  if (Primus.OPEN !== primus.readyState) {
    //
    // If the buffer is at capacity, remove the first item.
    //
    if (this.buffer.length === this.options.queueSize) {
      this.buffer.splice(0, 1);
    }

    this.buffer.push(data);
    return false;
  }

  primus.encoder(data, function encoded(err, packet) {
    //
    // Do a "safe" emit('error') when we fail to parse a message. We don't
    // want to throw here as listening to errors should be optional.
    //
    if (err) return primus.listeners('error').length && primus.emit('error', err);

    //
    // Hack 1: \u2028 and \u2029 are allowed inside a JSON string, but JavaScript
    // defines them as newline separators. Unescaped control characters are not
    // allowed inside JSON strings, so this causes an error at parse time. We
    // work around this issue by escaping these characters. This can cause
    // errors with JSONP requests or if the string is just evaluated.
    //
    if ('string' === typeof packet) {
      if (~packet.indexOf('\u2028')) packet = packet.replace(u2028, '\\u2028');
      if (~packet.indexOf('\u2029')) packet = packet.replace(u2029, '\\u2029');
    }

    primus.emit('outgoing::data', packet);
  });

  return true;
};

/**
 * Set a timer that, upon expiration, closes the client.
 *
 * @returns {Primus}
 * @api private
 */
Primus.prototype.heartbeat = function heartbeat() {
  if (!this.options.pingTimeout) return this;

  this.timers.clear('heartbeat');
  this.timers.setTimeout('heartbeat', function expired() {
    //
    // The network events already captured the offline event.
    //
    if (!this.online) return;

    this.online = false;
    this.emit('offline');
    this.emit('incoming::end');
  }, this.options.pingTimeout);

  return this;
};

/**
 * Start a connection timeout.
 *
 * @returns {Primus}
 * @api private
 */
Primus.prototype.timeout = function timeout() {
  var primus = this;

  /**
   * Remove all references to the timeout listener as we've received an event
   * that can be used to determine state.
   *
   * @api private
   */
  function remove() {
    primus.removeListener('error', remove)
          .removeListener('open', remove)
          .removeListener('end', remove)
          .timers.clear('connect');
  }

  primus.timers.setTimeout('connect', function expired() {
    remove(); // Clean up old references.

    if (primus.readyState === Primus.OPEN || primus.recovery.reconnecting()) {
      return;
    }

    primus.emit('timeout');

    //
    // We failed to connect to the server.
    //
    if (~primus.options.strategy.indexOf('timeout')) {
      primus.recovery.reconnect();
    } else {
      primus.end();
    }
  }, primus.options.timeout);

  return primus.on('error', remove)
    .on('open', remove)
    .on('end', remove);
};

/**
 * Close the connection completely.
 *
 * @param {Mixed} data last packet of data.
 * @returns {Primus}
 * @api public
 */
Primus.prototype.end = function end(data) {
  context(this, 'end');

  if (
      this.readyState === Primus.CLOSED
    && !this.timers.active('connect')
    && !this.timers.active('open')
  ) {
    //
    // If we are reconnecting stop the reconnection procedure.
    //
    if (this.recovery.reconnecting()) {
      this.recovery.reset();
      this.emit('end');
    }

    return this;
  }

  if (data !== undefined) this.write(data);

  this.writable = false;
  this.readable = false;

  var readyState = this.readyState;
  this.readyState = Primus.CLOSED;

  if (readyState !== this.readyState) {
    this.emit('readyStateChange', 'end');
  }

  this.timers.clear();
  this.emit('outgoing::end');
  this.emit('close');
  this.emit('end');

  return this;
};

/**
 * Completely demolish the Primus instance and forcefully nuke all references.
 *
 * @returns {Boolean}
 * @api public
 */
Primus.prototype.destroy = destroy('url timers options recovery socket transport transformers', {
  before: 'end',
  after: ['removeAllListeners', function detach() {
    if (!this.NETWORK_EVENTS) return;

    if (window.addEventListener) {
      window.removeEventListener('offline', this.offlineHandler);
      window.removeEventListener('online', this.onlineHandler);
    } else if (document.body.attachEvent){
      document.body.detachEvent('onoffline', this.offlineHandler);
      document.body.detachEvent('ononline', this.onlineHandler);
    }
  }]
});

/**
 * Create a shallow clone of a given object.
 *
 * @param {Object} obj The object that needs to be cloned.
 * @returns {Object} Copy.
 * @api private
 */
Primus.prototype.clone = function clone(obj) {
  return this.merge({}, obj);
};

/**
 * Merge different objects in to one target object.
 *
 * @param {Object} target The object where everything should be merged in.
 * @returns {Object} Original target with all merged objects.
 * @api private
 */
Primus.prototype.merge = function merge(target) {
  for (var i = 1, key, obj; i < arguments.length; i++) {
    obj = arguments[i];

    for (key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key))
        target[key] = obj[key];
    }
  }

  return target;
};

/**
 * Parse the connection string.
 *
 * @type {Function}
 * @param {String} url Connection URL.
 * @returns {Object} Parsed connection.
 * @api private
 */
Primus.prototype.parse = _dereq_('url-parse');

/**
 * Parse a query string.
 *
 * @param {String} query The query string that needs to be parsed.
 * @returns {Object} Parsed query string.
 * @api private
 */
Primus.prototype.querystring = qs.parse;
/**
 * Transform a query string object back into string equiv.
 *
 * @param {Object} obj The query string object.
 * @returns {String}
 * @api private
 */
Primus.prototype.querystringify = qs.stringify;

/**
 * Generates a connection URI.
 *
 * @param {String} protocol The protocol that should used to crate the URI.
 * @returns {String|options} The URL.
 * @api private
 */
Primus.prototype.uri = function uri(options) {
  var url = this.url
    , server = []
    , qsa = false;

  //
  // Query strings are only allowed when we've received clearance for it.
  //
  if (options.query) qsa = true;

  options = options || {};
  options.protocol = 'protocol' in options
    ? options.protocol
    : 'http:';
  options.query = url.query && qsa
    ? url.query.slice(1)
    : false;
  options.secure = 'secure' in options
    ? options.secure
    : url.protocol === 'https:' || url.protocol === 'wss:';
  options.auth = 'auth' in options
    ? options.auth
    : url.auth;
  options.pathname = 'pathname' in options
    ? options.pathname
    : this.pathname;
  options.port = 'port' in options
    ? +options.port
    : +url.port || (options.secure ? 443 : 80);

  //
  // We need to make sure that we create a unique connection URL every time to
  // prevent back forward cache from becoming an issue. We're doing this by
  // forcing an cache busting query string in to the URL.
  //
  var querystring = this.querystring(options.query || '');
  querystring._primuscb = yeast();
  options.query = this.querystringify(querystring);

  //
  // Allow transformation of the options before we construct a full URL from it.
  //
  this.emit('outgoing::url', options);

  //
  // Automatically suffix the protocol so we can supply `ws:` and `http:` and
  // it gets transformed correctly.
  //
  server.push(options.secure ? options.protocol.replace(':', 's:') : options.protocol, '');

  server.push(options.auth ? options.auth +'@'+ url.host : url.host);

  //
  // Pathnames are optional as some Transformers would just use the pathname
  // directly.
  //
  if (options.pathname) server.push(options.pathname.slice(1));

  //
  // Optionally add a search query.
  //
  if (qsa) server[server.length - 1] += '?'+ options.query;
  else delete options.query;

  if (options.object) return options;
  return server.join('/');
};

/**
 * Register a new message transformer. This allows you to easily manipulate incoming
 * and outgoing data which is particularity handy for plugins that want to send
 * meta data together with the messages.
 *
 * @param {String} type Incoming or outgoing
 * @param {Function} fn A new message transformer.
 * @returns {Primus}
 * @api public
 */
Primus.prototype.transform = function transform(type, fn) {
  context(this, 'transform');

  if (!(type in this.transformers)) {
    return this.critical(new Error('Invalid transformer type'));
  }

  this.transformers[type].push(fn);
  return this;
};

/**
 * A critical error has occurred, if we have an `error` listener, emit it there.
 * If not, throw it, so we get a stack trace + proper error message.
 *
 * @param {Error} err The critical error.
 * @returns {Primus}
 * @api private
 */
Primus.prototype.critical = function critical(err) {
  if (this.emit('error', err)) return this;

  throw err;
};

/**
 * Syntax sugar, adopt a Socket.IO like API.
 *
 * @param {String} url The URL we want to connect to.
 * @param {Object} options Connection options.
 * @returns {Primus}
 * @api public
 */
Primus.connect = function connect(url, options) {
  return new Primus(url, options);
};

//
// Expose the EventEmitter so it can be re-used by wrapping libraries we're also
// exposing the Stream interface.
//
Primus.EventEmitter = EventEmitter;

//
// These libraries are automatically inserted at the server-side using the
// Primus#library method.
//
Primus.prototype.client = function client() {
  var primus = this
    , socket;

  //
  // Select an available WebSocket factory.
  //
  var Factory = (function factory() {
    if ('undefined' !== typeof WebSocket) return WebSocket;
    if ('undefined' !== typeof MozWebSocket) return MozWebSocket;

    try { return Primus.requires('ws'); }
    catch (e) {}

    return undefined;
  })();

  if (!Factory) return primus.critical(new Error(
    'Missing required `ws` module. Please run `npm install --save ws`'
  ));

  //
  // Connect to the given URL.
  //
  primus.on('outgoing::open', function opening() {
    primus.emit('outgoing::end');

    //
    // FireFox will throw an error when we try to establish a connection from
    // a secure page to an unsecured WebSocket connection. This is inconsistent
    // behaviour between different browsers. This should ideally be solved in
    // Primus when we connect.
    //
    try {
      var options = {
        protocol: primus.url.protocol === 'ws+unix:' ? 'ws+unix:' : 'ws:',
        query: true
      };

      //
      // Only allow primus.transport object in Node.js, it will throw in
      // browsers with a TypeError if we supply to much arguments.
      //
      if (Factory.length === 3) {
        if ('ws+unix:' === options.protocol) {
          options.pathname = primus.url.pathname +':'+ primus.pathname;
        }
        primus.socket = socket = new Factory(
          primus.uri(options),  // URL
          [],                   // Sub protocols
          primus.transport      // options.
        );
      } else {
        primus.socket = socket = new Factory(primus.uri(options));
        socket.binaryType = 'arraybuffer';
      }
    } catch (e) { return primus.emit('error', e); }

    //
    // Setup the Event handlers.
    //
    socket.onopen = primus.emits('incoming::open');
    socket.onerror = primus.emits('incoming::error');
    socket.onclose = primus.emits('incoming::end');
    socket.onmessage = primus.emits('incoming::data', function parse(next, evt) {
      next(undefined, evt.data);
    });
  });

  //
  // We need to write a new message to the socket.
  //
  primus.on('outgoing::data', function write(message) {
    if (!socket || socket.readyState !== Factory.OPEN) return;

    try { socket.send(message); }
    catch (e) { primus.emit('incoming::error', e); }
  });

  //
  // Attempt to reconnect the socket.
  //
  primus.on('outgoing::reconnect', function reconnect() {
    primus.emit('outgoing::open');
  });

  //
  // We need to close the socket.
  //
  primus.on('outgoing::end', function close() {
    if (!socket) return;

    socket.onerror = socket.onopen = socket.onclose = socket.onmessage = function () {};
    socket.close();
    socket = null;
  });
};
Primus.prototype.authorization = true;
Primus.prototype.pathname = "/api/v1/websockets";
Primus.prototype.encoder = function encoder(data, fn) {
  var err;

  try { data = JSON.stringify(data); }
  catch (e) { err = e; }

  fn(err, data);
};
Primus.prototype.decoder = function decoder(data, fn) {
  var err;

  if ('string' !== typeof data) return fn(err, data);

  try { data = JSON.parse(data); }
  catch (e) { err = e; }

  fn(err, data);
};
Primus.prototype.version = "7.1.0";

if (
     'undefined' !== typeof document
  && 'undefined' !== typeof navigator
) {
  //
  // Hack 2: If you press ESC in FireFox it will close all active connections.
  // Normally this makes sense, when your page is still loading. But versions
  // before FireFox 22 will close all connections including WebSocket connections
  // after page load. One way to prevent this is to do a `preventDefault()` and
  // cancel the operation before it bubbles up to the browsers default handler.
  // It needs to be added as `keydown` event, if it's added keyup it will not be
  // able to prevent the connection from being closed.
  //
  if (document.addEventListener) {
    document.addEventListener('keydown', function keydown(e) {
      if (e.keyCode !== 27 || !e.preventDefault) return;

      e.preventDefault();
    }, false);
  }

  //
  // Hack 3: This is a Mac/Apple bug only, when you're behind a reverse proxy or
  // have you network settings set to `automatic proxy discovery` the safari
  // browser will crash when the WebSocket constructor is initialised. There is
  // no way to detect the usage of these proxies available in JavaScript so we
  // need to do some nasty browser sniffing. This only affects Safari versions
  // lower then 5.1.4
  //
  var ua = (navigator.userAgent || '').toLowerCase()
    , parsed = ua.match(/.+(?:rv|it|ra|ie)[/: ](\d+)\.(\d+)(?:\.(\d+))?/) || []
    , version = +[parsed[1], parsed[2]].join('.');

  if (
       !~ua.indexOf('chrome')
    && ~ua.indexOf('safari')
    && version < 534.54
  ) {
    Primus.prototype.AVOID_WEBSOCKETS = true;
  }
}

//
// Expose the library.
//
module.exports = Primus;

},{"demolish":1,"emits":2,"eventemitter3":3,"inherits":4,"querystringify":7,"recovery":8,"tick-tock":11,"url-parse":12,"yeast":13}]},{},[14])(14);
  return Primus;
},
[

]);
}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("timers").setImmediate,require("timers").clearImmediate)
},{"timers":1216}],1239:[function(require,module,exports){
/*!
 * RangeFix v0.2.1
 * https://github.com/edg2s/rangefix
 *
 * Copyright 2014-16 Ed Sanders.
 * Released under the MIT license
 */


var broken,
    rangeFix = {};

/**
 * Check if bugs are present in the native functions
 *
 * For getClientRects, constructs two lines of text and
 * creates a range between them. Broken browsers will
 * return three rectangles instead of two.
 *
 * For getBoundingClientRect, create a collapsed range
 * and check if the resulting rect has non-zero offsets.
 *
 * getBoundingClientRect is also considered broken if
 * getClientRects is broken.
 *
 * For the IE zoom bug, just check the version number as
 * we can't detect the bug if the zoom level is currently 100%.
 *
 * @private
 * @return {Object} Object containing boolean properties 'getClientRects',
 *                  'getBoundingClientRect' and 'ieZoom' indicating bugs are present
 *                  in these functions/browsers.
 */
function isBroken() {
    var boundingRect, p1, p2, t1, t2, range, jscriptVersion;

    if (broken === undefined) {
        p1 = document.createElement('p');
        p2 = document.createElement('p');
        t1 = document.createTextNode('aa');
        t2 = document.createTextNode('aa');
        range = document.createRange();

        broken = {};

        p1.appendChild(t1);
        p2.appendChild(t2);

        document.body.appendChild(p1);
        document.body.appendChild(p2);

        range.setStart(t1, 1);
        range.setEnd(t2, 1);
        broken.getClientRects = broken.getBoundingClientRect = range.getClientRects().length > 2;

        if (!broken.getBoundingClientRect) {
            // Safari doesn't return a valid bounding rect for collapsed ranges
            range.setEnd(t1, 1);
            boundingRect = range.getBoundingClientRect();
            broken.getBoundingClientRect = boundingRect.top === 0 && boundingRect.left === 0;
        }

        document.body.removeChild(p1);
        document.body.removeChild(p2);

        // Detect IE<=10
        // eslint-disable-next-line no-new-func
        jscriptVersion = window.ActiveXObject && new Function('/*@cc_on return @_jscript_version; @*/')();
        broken.ieZoom = jscriptVersion && jscriptVersion <= 10;
    }
    return broken;
}

/**
 * Compensate for the current zoom level in IE<=10
 *
 * getClientRects returns values in real pixels in these browsers,
 * so using them in your CSS will result in them getting scaled again.
 *
 * @private
 * @param {ClientRectList|ClientRect[]|ClientRect|Object|null} rectOrRects Rect or list of rects to fix
 * @return {ClientRectList|ClientRect[]|ClientRect|Object|null} Fixed rect or list of rects
 */
function zoomFix(rectOrRects) {
    var zoom;
    if (!rectOrRects) {
        return rectOrRects;
    }
    // Optimisation when zoom level is 1: return original object
    if (screen.deviceXDPI === screen.logicalXDPI) {
        return rectOrRects;
    }
    // Rect list: map this function to each rect
    if ('length' in rectOrRects) {
        return Array.prototype.map.call(rectOrRects, zoomFix);
    }
    // Single rect: Adjust by zoom factor
    zoom = screen.deviceXDPI / screen.logicalXDPI;
    return {
        top: rectOrRects.top / zoom,
        bottom: rectOrRects.bottom / zoom,
        left: rectOrRects.left / zoom,
        right: rectOrRects.right / zoom,
        width: rectOrRects.width / zoom,
        height: rectOrRects.height / zoom
    };
}

/**
 * Get client rectangles from a range
 *
 * @param {Range} range Range
 * @return {ClientRectList|ClientRect[]} ClientRectList or list of ClientRect objects describing range
 */
rangeFix.getClientRects = function(range) {
    var rects, endContainer, endOffset, partialRange,
        broken = isBroken();

    if (broken.ieZoom) {
        return zoomFix(range.getClientRects());
    } else if (!broken.getClientRects) {
        return range.getClientRects();
    }

    // Chrome gets the end container rects wrong when spanning
    // nodes so we need to traverse up the tree from the endContainer until
    // we reach the common ancestor, then we can add on from start to where
    // we got up to
    // https://code.google.com/p/chromium/issues/detail?id=324437
    rects = [];
    endContainer = range.endContainer;
    endOffset = range.endOffset;
    partialRange = document.createRange();

    while (endContainer !== range.commonAncestorContainer) {
        partialRange.setStart(endContainer, 0);
        partialRange.setEnd(endContainer, endOffset);

        Array.prototype.push.apply(rects, partialRange.getClientRects());

        endOffset = Array.prototype.indexOf.call(endContainer.parentNode.childNodes, endContainer);
        endContainer = endContainer.parentNode;
    }

    // Once we've reached the common ancestor, add on the range from the
    // original start position to where we ended up.
    partialRange = range.cloneRange();
    partialRange.setEnd(endContainer, endOffset);
    Array.prototype.push.apply(rects, partialRange.getClientRects());
    return rects;
};

/**
 * Get bounding rectangle from a range
 *
 * @param {Range} range Range
 * @return {ClientRect|Object|null} ClientRect or ClientRect-like object describing
 *                                  bounding rectangle, or null if not computable
 */
rangeFix.getBoundingClientRect = function(range) {
    var i, l, boundingRect, rect, nativeBoundingRect, broken,
        rects = this.getClientRects(range);

    // If there are no rects return null, otherwise we'll fall through to
    // getBoundingClientRect, which in Chrome and Firefox becomes [0,0,0,0].
    if (rects.length === 0) {
        return null;
    }

    nativeBoundingRect = range.getBoundingClientRect();
    broken = isBroken();

    if (broken.ieZoom) {
        return zoomFix(nativeBoundingRect);
    } else if (!broken.getBoundingClientRect) {
        return nativeBoundingRect;
    }

    // When nativeRange is a collapsed cursor at the end of a line or
    // the start of a line, the bounding rect is [0,0,0,0] in Chrome.
    // getClientRects returns two rects, one correct, and one at the
    // end of the next line / start of the previous line. We can't tell
    // here which one to use so just pick the first. This matches
    // Firefox's behaviour, which tells you the cursor is at the end
    // of the previous line when it is at the start of the line.
    // See https://code.google.com/p/chromium/issues/detail?id=426017
    if (nativeBoundingRect.width === 0 && nativeBoundingRect.height === 0) {
        return rects[0];
    }

    for (i = 0, l = rects.length; i < l; i++) {
        rect = rects[i];
        if (!boundingRect) {
            boundingRect = {
                left: rect.left,
                top: rect.top,
                right: rect.right,
                bottom: rect.bottom
            };
        } else {
            boundingRect.left = Math.min(boundingRect.left, rect.left);
            boundingRect.top = Math.min(boundingRect.top, rect.top);
            boundingRect.right = Math.max(boundingRect.right, rect.right);
            boundingRect.bottom = Math.max(boundingRect.bottom, rect.bottom);
        }
    }
    if (boundingRect) {
        boundingRect.width = boundingRect.right - boundingRect.left;
        boundingRect.height = boundingRect.bottom - boundingRect.top;
    }
    return boundingRect;
};

module.exports = rangeFix;

},{}],"angular":[function(require,module,exports){
require('./angular');
module.exports = angular;

},{"./angular":555}],"handlebars":[function(require,module,exports){
// USAGE:
// var handlebars = require('handlebars');
/* eslint-disable no-var */

// var local = handlebars.create();

var handlebars = require('../dist/cjs/handlebars')['default'];

var printer = require('../dist/cjs/handlebars/compiler/printer');
handlebars.PrintVisitor = printer.PrintVisitor;
handlebars.print = printer.print;

module.exports = handlebars;

// Publish a Node.js require() handler for .handlebars and .hbs files
function extension(module, filename) {
  var fs = require('fs');
  var templateString = fs.readFileSync(filename, 'utf8');
  module.exports = handlebars.compile(templateString);
}
/* istanbul ignore else */
if (typeof require !== 'undefined' && require.extensions) {
  require.extensions['.handlebars'] = extension;
  require.extensions['.hbs'] = extension;
}

},{"../dist/cjs/handlebars":1120,"../dist/cjs/handlebars/compiler/printer":1130,"fs":569}],"jquery":[function(require,module,exports){
/*!
 * jQuery JavaScript Library v3.6.4
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-03-08T15:28Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket trac-14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var flat = arr.flat ? function( array ) {
	return arr.flat.call( array );
} : function( array ) {
	return arr.concat.apply( [], array );
};


var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

		// Support: Chrome <=57, Firefox <=52
		// In some browsers, typeof returns "function" for HTML <object> elements
		// (i.e., `typeof document.createElement( "object" ) === "function"`).
		// We don't want to classify *any* DOM node as a function.
		// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
		// Plus for old WebKit, typeof returns "function" for HTML collections
		// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
		return typeof obj === "function" && typeof obj.nodeType !== "number" &&
			typeof obj.item !== "function";
	};


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};


var document = window.document;



	var preservedScriptAttributes = {
		type: true,
		src: true,
		nonce: true,
		noModule: true
	};

	function DOMEval( code, node, doc ) {
		doc = doc || document;

		var i, val,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {

				// Support: Firefox 64+, Edge 18+
				// Some browsers don't support the "nonce" property on scripts.
				// On the other hand, just using `getAttribute` is not enough as
				// the `nonce` attribute is reset to an empty string whenever it
				// becomes browsing-context connected.
				// See https://github.com/whatwg/html/issues/2369
				// See https://html.spec.whatwg.org/#nonce-attributes
				// The `node.getAttribute` check was added for the sake of
				// `jQuery.globalEval` so that it can fake a nonce-containing node
				// via an object.
				val = node[ i ] || node.getAttribute && node.getAttribute( i );
				if ( val ) {
					script.setAttribute( i, val );
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.6.4",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	even: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return ( i + 1 ) % 2;
		} ) );
	},

	odd: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return i % 2;
		} ) );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				copy = options[ name ];

				// Prevent Object.prototype pollution
				// Prevent never-ending loop
				if ( name === "__proto__" || target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {
					src = target[ name ];

					// Ensure proper type for the source value
					if ( copyIsArray && !Array.isArray( src ) ) {
						clone = [];
					} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
						clone = {};
					} else {
						clone = src;
					}
					copyIsArray = false;

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a provided context; falls back to the global one
	// if not specified.
	globalEval: function( code, options, doc ) {
		DOMEval( code, { nonce: options && options.nonce }, doc );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
						[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return flat( ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( _i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.10
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://js.foundation/
 *
 * Date: 2023-02-14
 */
( function( window ) {
var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	nonnativeSelectorCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ( {} ).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	pushNative = arr.push,
	push = arr.push,
	slice = arr.slice,

	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[ i ] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|" +
		"ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
	identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +

		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +

		// "Attribute values must be CSS identifiers [capture 5]
		// or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
		whitespace + "*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +

		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +

		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" +
		whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rleadingCombinator = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace +
		"*" ),
	rdescend = new RegExp( whitespace + "|>" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
			whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
			whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),

		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace +
			"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
			"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rhtml = /HTML$/i,
	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g" ),
	funescape = function( escape, nonHex ) {
		var high = "0x" + escape.slice( 1 ) - 0x10000;

		return nonHex ?

			// Strip the backslash prefix from a non-hex escape sequence
			nonHex :

			// Replace a hexadecimal escape sequence with the encoded Unicode code point
			// Support: IE <=11+
			// For values outside the Basic Multilingual Plane (BMP), manually construct a
			// surrogate pair
			high < 0 ?
				String.fromCharCode( high + 0x10000 ) :
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" +
				ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	inDisabledFieldset = addCombinator(
		function( elem ) {
			return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		( arr = slice.call( preferredDoc.childNodes ) ),
		preferredDoc.childNodes
	);

	// Support: Android<4.0
	// Detect silently failing push.apply
	// eslint-disable-next-line no-unused-expressions
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			pushNative.apply( target, slice.call( els ) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;

			// Can't trust NodeList.length
			while ( ( target[ j++ ] = els[ i++ ] ) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {
		setDocument( context );
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {

				// ID selector
				if ( ( m = match[ 1 ] ) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( ( elem = context.getElementById( m ) ) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && ( elem = newContext.getElementById( m ) ) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[ 2 ] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( ( m = match[ 3 ] ) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!nonnativeSelectorCache[ selector + " " ] &&
				( !rbuggyQSA || !rbuggyQSA.test( selector ) ) &&

				// Support: IE 8 only
				// Exclude object elements
				( nodeType !== 1 || context.nodeName.toLowerCase() !== "object" ) ) {

				newSelector = selector;
				newContext = context;

				// qSA considers elements outside a scoping root when evaluating child or
				// descendant combinators, which is not what we want.
				// In such cases, we work around the behavior by prefixing every selector in the
				// list with an ID selector referencing the scope context.
				// The technique has to be used as well when a leading combinator is used
				// as such selectors are not recognized by querySelectorAll.
				// Thanks to Andrew Dupont for this technique.
				if ( nodeType === 1 &&
					( rdescend.test( selector ) || rleadingCombinator.test( selector ) ) ) {

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;

					// We can use :scope instead of the ID hack if the browser
					// supports it & if we're not changing the context.
					if ( newContext !== context || !support.scope ) {

						// Capture the context ID, setting it first if necessary
						if ( ( nid = context.getAttribute( "id" ) ) ) {
							nid = nid.replace( rcssescape, fcssescape );
						} else {
							context.setAttribute( "id", ( nid = expando ) );
						}
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
							toSelector( groups[ i ] );
					}
					newSelector = groups.join( "," );
				}

				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch ( qsaError ) {
					nonnativeSelectorCache( selector, true );
				} finally {
					if ( nid === expando ) {
						context.removeAttribute( "id" );
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {

		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {

			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return ( cache[ key + " " ] = value );
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement( "fieldset" );

	try {
		return !!fn( el );
	} catch ( e ) {
		return false;
	} finally {

		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}

		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split( "|" ),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[ i ] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( ( cur = cur.nextSibling ) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return ( name === "input" || name === "button" ) && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
					inDisabledFieldset( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction( function( argument ) {
		argument = +argument;
		return markFunction( function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
					seed[ j ] = !( matches[ j ] = seed[ j ] );
				}
			}
		} );
	} );
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	var namespace = elem && elem.namespaceURI,
		docElem = elem && ( elem.ownerDocument || elem ).documentElement;

	// Support: IE <=8
	// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
	// https://bugs.jquery.com/ticket/4833
	return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9 - 11+, Edge 12 - 18+
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( preferredDoc != document &&
		( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	// Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
	// Safari 4 - 5 only, Opera <=11.6 - 12.x only
	// IE/Edge & older browsers don't support the :scope pseudo-class.
	// Support: Safari 6.0 only
	// Safari 6.0 supports :scope but it's an alias of :root there.
	support.scope = assert( function( el ) {
		docElem.appendChild( el ).appendChild( document.createElement( "div" ) );
		return typeof el.querySelectorAll !== "undefined" &&
			!el.querySelectorAll( ":scope fieldset div" ).length;
	} );

	// Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
	// Make sure the the `:has()` argument is parsed unforgivingly.
	// We include `*` in the test to detect buggy implementations that are
	// _selectively_ forgiving (specifically when the list includes at least
	// one valid selector).
	// Note that we treat complete lack of support for `:has()` as if it were
	// spec-compliant support, which is fine because use of `:has()` in such
	// environments will fail in the qSA path and fall back to jQuery traversal
	// anyway.
	support.cssHas = assert( function() {
		try {
			document.querySelector( ":has(*,:jqfake)" );
			return false;
		} catch ( e ) {
			return true;
		}
	} );

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert( function( el ) {
		el.className = "i";
		return !el.getAttribute( "className" );
	} );

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert( function( el ) {
		el.appendChild( document.createComment( "" ) );
		return !el.getElementsByTagName( "*" ).length;
	} );

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert( function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	} );

	// ID filter and find
	if ( support.getById ) {
		Expr.filter[ "ID" ] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute( "id" ) === attrId;
			};
		};
		Expr.find[ "ID" ] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter[ "ID" ] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode( "id" );
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find[ "ID" ] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode( "id" );
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( ( elem = elems[ i++ ] ) ) {
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find[ "TAG" ] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,

				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( ( elem = results[ i++ ] ) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find[ "CLASS" ] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( ( support.qsa = rnative.test( document.querySelectorAll ) ) ) {

		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert( function( el ) {

			var input;

			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll( "[msallowcapture^='']" ).length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll( "[selected]" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push( "~=" );
			}

			// Support: IE 11+, Edge 15 - 18+
			// IE 11/Edge don't find elements on a `[name='']` query in some cases.
			// Adding a temporary attribute to the document before the selection works
			// around the issue.
			// Interestingly, IE 10 & older don't seem to have the issue.
			input = document.createElement( "input" );
			input.setAttribute( "name", "" );
			el.appendChild( input );
			if ( !el.querySelectorAll( "[name='']" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
					whitespace + "*(?:''|\"\")" );
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll( ":checked" ).length ) {
				rbuggyQSA.push( ":checked" );
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push( ".#.+[+~]" );
			}

			// Support: Firefox <=3.6 - 5 only
			// Old Firefox doesn't throw on a badly-escaped identifier.
			el.querySelectorAll( "\\\f" );
			rbuggyQSA.push( "[\\r\\n\\f]" );
		} );

		assert( function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement( "input" );
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll( "[name=d]" ).length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll( ":enabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: Opera 10 - 11 only
			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll( "*,:x" );
			rbuggyQSA.push( ",.*:" );
		} );
	}

	if ( ( support.matchesSelector = rnative.test( ( matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector ) ) ) ) {

		assert( function( el ) {

			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		} );
	}

	if ( !support.cssHas ) {

		// Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
		// Our regular `try-catch` mechanism fails to detect natively-unsupported
		// pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
		// in browsers that parse the `:has()` argument as a forgiving selector list.
		// https://drafts.csswg.org/selectors/#relational now requires the argument
		// to be parsed unforgivingly, but browsers have not yet fully adjusted.
		rbuggyQSA.push( ":has" );
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join( "|" ) );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {

			// Support: IE <9 only
			// IE doesn't have `contains` on `document` so we need to check for
			// `documentElement` presence.
			// We need to fall back to `a` when `documentElement` is missing
			// as `ownerDocument` of elements within `<template/>` may have
			// a null one - a default behavior of all modern browsers.
			var adown = a.nodeType === 9 && a.documentElement || a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			) );
		} :
		function( a, b ) {
			if ( b ) {
				while ( ( b = b.parentNode ) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {

			// Choose the first element that is related to our preferred document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( a == document || a.ownerDocument == preferredDoc &&
				contains( preferredDoc, a ) ) {
				return -1;
			}

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( b == document || b.ownerDocument == preferredDoc &&
				contains( preferredDoc, b ) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {

		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			/* eslint-disable eqeqeq */
			return a == document ? -1 :
				b == document ? 1 :
				/* eslint-enable eqeqeq */
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( ( cur = cur.parentNode ) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( ( cur = cur.parentNode ) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[ i ] === bp[ i ] ) {
			i++;
		}

		return i ?

			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[ i ], bp[ i ] ) :

			// Otherwise nodes in our document sort first
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			/* eslint-disable eqeqeq */
			ap[ i ] == preferredDoc ? -1 :
			bp[ i ] == preferredDoc ? 1 :
			/* eslint-enable eqeqeq */
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	setDocument( elem );

	if ( support.matchesSelector && documentIsHTML &&
		!nonnativeSelectorCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||

				// As well, disconnected nodes are said to be in a document
				// fragment in IE 9
				elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch ( e ) {
			nonnativeSelectorCache( expr, true );
		}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( context.ownerDocument || context ) != document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( elem.ownerDocument || elem ) != document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],

		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			( val = elem.getAttributeNode( name ) ) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return ( sel + "" ).replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( ( elem = results[ i++ ] ) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {

		// If no nodeType, this is expected to be an array
		while ( ( node = elem[ i++ ] ) ) {

			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {

		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {

			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}

	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[ 1 ] = match[ 1 ].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[ 3 ] = ( match[ 3 ] || match[ 4 ] ||
				match[ 5 ] || "" ).replace( runescape, funescape );

			if ( match[ 2 ] === "~=" ) {
				match[ 3 ] = " " + match[ 3 ] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {

			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[ 1 ] = match[ 1 ].toLowerCase();

			if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {

				// nth-* requires argument
				if ( !match[ 3 ] ) {
					Sizzle.error( match[ 0 ] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[ 4 ] = +( match[ 4 ] ?
					match[ 5 ] + ( match[ 6 ] || 1 ) :
					2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" ) );
				match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );

				// other types prohibit arguments
			} else if ( match[ 3 ] ) {
				Sizzle.error( match[ 0 ] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[ 6 ] && match[ 2 ];

			if ( matchExpr[ "CHILD" ].test( match[ 0 ] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[ 3 ] ) {
				match[ 2 ] = match[ 4 ] || match[ 5 ] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&

				// Get excess from tokenize (recursively)
				( excess = tokenize( unquoted, true ) ) &&

				// advance to the next closing parenthesis
				( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {

				// excess is a negative index
				match[ 0 ] = match[ 0 ].slice( 0, excess );
				match[ 2 ] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() {
					return true;
				} :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				( pattern = new RegExp( "(^|" + whitespace +
					")" + className + "(" + whitespace + "|$)" ) ) && classCache(
						className, function( elem ) {
							return pattern.test(
								typeof elem.className === "string" && elem.className ||
								typeof elem.getAttribute !== "undefined" &&
									elem.getAttribute( "class" ) ||
								""
							);
				} );
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				/* eslint-disable max-len */

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
				/* eslint-enable max-len */

			};
		},

		"CHILD": function( type, what, _argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, _context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( ( node = node[ dir ] ) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}

								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || ( node[ expando ] = {} );

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								( outerCache[ node.uniqueID ] = {} );

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( ( node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								( diff = nodeIndex = 0 ) || start.pop() ) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {

							// Use previously-cached element index if available
							if ( useCache ) {

								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || ( node[ expando ] = {} );

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									( outerCache[ node.uniqueID ] = {} );

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {

								// Use the same loop as above to seek `elem` from the start
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
									( diff = nodeIndex = 0 ) || start.pop() ) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] ||
												( node[ expando ] = {} );

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												( outerCache[ node.uniqueID ] = {} );

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {

			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction( function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[ i ] );
							seed[ idx ] = !( matches[ idx ] = matched[ i ] );
						}
					} ) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {

		// Potentially complex pseudos
		"not": markFunction( function( selector ) {

			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction( function( seed, matches, _context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( ( elem = unmatched[ i ] ) ) {
							seed[ i ] = !( matches[ i ] = elem );
						}
					}
				} ) :
				function( elem, _context, xml ) {
					input[ 0 ] = elem;
					matcher( input, null, xml, results );

					// Don't keep the element (issue #299)
					input[ 0 ] = null;
					return !results.pop();
				};
		} ),

		"has": markFunction( function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		} ),

		"contains": markFunction( function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
			};
		} ),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {

			// lang value must be a valid identifier
			if ( !ridentifier.test( lang || "" ) ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( ( elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
				return false;
			};
		} ),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement &&
				( !document.hasFocus || document.hasFocus() ) &&
				!!( elem.type || elem.href || ~elem.tabIndex );
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {

			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return ( nodeName === "input" && !!elem.checked ) ||
				( nodeName === "option" && !!elem.selected );
		},

		"selected": function( elem ) {

			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				// eslint-disable-next-line no-unused-expressions
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {

			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos[ "empty" ]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE <10 only
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( ( attr = elem.getAttribute( "type" ) ) == null ||
					attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo( function() {
			return [ 0 ];
		} ),

		"last": createPositionalPseudo( function( _matchIndexes, length ) {
			return [ length - 1 ];
		} ),

		"eq": createPositionalPseudo( function( _matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		} ),

		"even": createPositionalPseudo( function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"odd": createPositionalPseudo( function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"lt": createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ?
				argument + length :
				argument > length ?
					length :
					argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"gt": createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} )
	}
};

Expr.pseudos[ "nth" ] = Expr.pseudos[ "eq" ];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
			if ( match ) {

				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[ 0 ].length ) || soFar;
			}
			groups.push( ( tokens = [] ) );
		}

		matched = false;

		// Combinators
		if ( ( match = rleadingCombinator.exec( soFar ) ) ) {
			matched = match.shift();
			tokens.push( {
				value: matched,

				// Cast descendant combinators to space
				type: match[ 0 ].replace( rtrim, " " )
			} );
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
				( match = preFilters[ type ]( match ) ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
					type: type,
					matches: match
				} );
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :

			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[ i ].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?

		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( ( elem = elem[ dir ] ) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || ( elem[ expando ] = {} );

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] ||
							( outerCache[ elem.uniqueID ] = {} );

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( ( oldCache = uniqueCache[ key ] ) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return ( newCache[ 2 ] = oldCache[ 2 ] );
						} else {

							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[ i ]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[ 0 ];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[ i ], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( ( elem = unmatched[ i ] ) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction( function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts(
				selector || "*",
				context.nodeType ? [ context ] : context,
				[]
			),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?

				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( ( elem = temp[ i ] ) ) {
					matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {

					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) ) {

							// Restore matcherIn since elem is not yet a final match
							temp.push( ( matcherIn[ i ] = elem ) );
						}
					}
					postFinder( null, ( matcherOut = [] ), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( ( elem = matcherOut[ i ] ) &&
						( temp = postFinder ? indexOf( seed, elem ) : preMap[ i ] ) > -1 ) {

						seed[ temp ] = !( results[ temp ] = elem );
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	} );
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[ 0 ].type ],
		implicitRelative = leadingRelative || Expr.relative[ " " ],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				( checkContext = context ).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );

			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
			matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
		} else {
			matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {

				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[ j ].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(

					// If the preceding token was a descendant combinator, insert an implicit any-element `*`
					tokens
						.slice( 0, i - 1 )
						.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,

				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find[ "TAG" ]( "*", outermost ),

				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
				len = elems.length;

			if ( outermost ) {

				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				outermostContext = context == document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;

					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( !context && elem.ownerDocument != document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( ( matcher = elementMatchers[ j++ ] ) ) {
						if ( matcher( elem, context || document, xml ) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {

					// They will have gone through all possible matchers
					if ( ( elem = !matcher && elem ) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( ( matcher = setMatchers[ j++ ] ) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {

					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
								setMatched[ i ] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {

		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[ i ] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache(
			selector,
			matcherFromGroupMatchers( elementMatchers, setMatchers )
		);

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( ( selector = compiled.selector || selector ) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[ 0 ] = match[ 0 ].slice( 0 );
		if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
			context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {

			context = ( Expr.find[ "ID" ]( token.matches[ 0 ]
				.replace( runescape, funescape ), context ) || [] )[ 0 ];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr[ "needsContext" ].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[ i ];

			// Abort if we hit a combinator
			if ( Expr.relative[ ( type = token.type ) ] ) {
				break;
			}
			if ( ( find = Expr.find[ type ] ) ) {

				// Search, expanding context for leading sibling combinators
				if ( ( seed = find(
					token.matches[ 0 ].replace( runescape, funescape ),
					rsibling.test( tokens[ 0 ].type ) && testContext( context.parentNode ) ||
						context
				) ) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert( function( el ) {

	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
} );

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert( function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute( "href" ) === "#";
} ) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	} );
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert( function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
} ) ) {
	addHandle( "value", function( elem, _name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	} );
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert( function( el ) {
	return el.getAttribute( "disabled" ) == null;
} ) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
				( val = elem.getAttributeNode( name ) ) && val.specified ?
					val.value :
					null;
		}
	} );
}

return Sizzle;

} )( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

	return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

}
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
	// Strict HTML recognition (trac-11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, _i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, _i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, _i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		if ( elem.contentDocument != null &&

			// Support: IE 11+
			// <object> elements with no `data` attribute has an object
			// `contentDocument` with a `null` prototype.
			getProto( elem.contentDocument ) ) {

			return elem.contentDocument;
		}

		// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
		// Treat the template element as a regular one in browsers that
		// don't support it.
		if ( nodeName( elem, "template" ) ) {
			elem = elem.content || elem;
		}

		return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( _i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the primary Deferred
			primary = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						primary.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( primary.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return primary.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
		}

		return primary.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See trac-6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, _key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( _all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (trac-9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see trac-8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (trac-14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var documentElement = document.documentElement;



	var isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem );
		},
		composed = { composed: true };

	// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	// Check attachment across shadow DOM boundaries when possible (gh-3504)
	// Support: iOS 10.0-10.2 only
	// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	// leading to errors. We need to check for `getRootNode`.
	if ( documentElement.getRootNode ) {
		isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem ) ||
				elem.getRootNode( composed ) === elem.ownerDocument;
		};
	}
var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			isAttached( elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};



function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = elem.nodeType &&
			( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (trac-11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (trac-14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;

	// Support: IE <=9 only
	// IE <=9 replaces <option> tags with their contents when inserted outside of
	// the select element.
	div.innerHTML = "<option></option>";
	support.option = !!div.lastChild;
} )();


// We have to close these tags to support XHTML (trac-13200)
var wrapMap = {

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

// Support: IE <=9 only
if ( !support.option ) {
	wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
}


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, attached, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (trac-12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		attached = isAttached( elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( attached ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 - 11+
// focus() and blur() are asynchronous, except when they are no-op.
// So expect focus to be synchronous when the element is already active,
// and blur to be synchronous when the element is not already active.
// (focus and blur are always synchronous in other supported browsers,
// this just defines when we can count on it).
function expectSync( elem, type ) {
	return ( elem === safeActiveElement() ) === ( type === "focus" );
}

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Only attach events to objects that accept data
		if ( !acceptData( elem ) ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = Object.create( null );
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),

			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( nativeEvent ),

			handlers = (
				dataPriv.get( this, "events" ) || Object.create( null )
			)[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// If the event is namespaced, then each handler is only invoked if it is
				// specially universal or its namespaces are a superset of the event's.
				if ( !event.rnamespace || handleObj.namespace === false ||
					event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (trac-13208)
				// Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (trac-13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
						return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
						return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		click: {

			// Utilize native event to ensure correct state for checkable inputs
			setup: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Claim the first handler
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					// dataPriv.set( el, "click", ... )
					leverageNative( el, "click", returnTrue );
				}

				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Force setup before triggering a click
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					leverageNative( el, "click" );
				}

				// Return non-false to allow normal event-path propagation
				return true;
			},

			// For cross-browser consistency, suppress native .click() on links
			// Also prevent it if we're currently inside a leveraged native-event stack
			_default: function( event ) {
				var target = event.target;
				return rcheckableType.test( target.type ) &&
					target.click && nodeName( target, "input" ) &&
					dataPriv.get( target, "click" ) ||
					nodeName( target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
function leverageNative( el, type, expectSync ) {

	// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
	if ( !expectSync ) {
		if ( dataPriv.get( el, type ) === undefined ) {
			jQuery.event.add( el, type, returnTrue );
		}
		return;
	}

	// Register the controller as a special universal handler for all event namespaces
	dataPriv.set( el, type, false );
	jQuery.event.add( el, type, {
		namespace: false,
		handler: function( event ) {
			var notAsync, result,
				saved = dataPriv.get( this, type );

			if ( ( event.isTrigger & 1 ) && this[ type ] ) {

				// Interrupt processing of the outer synthetic .trigger()ed event
				// Saved data should be false in such cases, but might be a leftover capture object
				// from an async native handler (gh-4350)
				if ( !saved.length ) {

					// Store arguments for use when handling the inner native event
					// There will always be at least one argument (an event object), so this array
					// will not be confused with a leftover capture object.
					saved = slice.call( arguments );
					dataPriv.set( this, type, saved );

					// Trigger the native event and capture its result
					// Support: IE <=9 - 11+
					// focus() and blur() are asynchronous
					notAsync = expectSync( this, type );
					this[ type ]();
					result = dataPriv.get( this, type );
					if ( saved !== result || notAsync ) {
						dataPriv.set( this, type, false );
					} else {
						result = {};
					}
					if ( saved !== result ) {

						// Cancel the outer synthetic event
						event.stopImmediatePropagation();
						event.preventDefault();

						// Support: Chrome 86+
						// In Chrome, if an element having a focusout handler is blurred by
						// clicking outside of it, it invokes the handler synchronously. If
						// that handler calls `.remove()` on the element, the data is cleared,
						// leaving `result` undefined. We need to guard against this.
						return result && result.value;
					}

				// If this is an inner synthetic event for an event with a bubbling surrogate
				// (focus or blur), assume that the surrogate already propagated from triggering the
				// native event and prevent that from happening again here.
				// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
				// bubbling surrogate propagates *after* the non-bubbling base), but that seems
				// less bad than duplication.
				} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
					event.stopPropagation();
				}

			// If this is a native event triggered above, everything is now in order
			// Fire an inner synthetic event with the original arguments
			} else if ( saved.length ) {

				// ...and capture the result
				dataPriv.set( this, type, {
					value: jQuery.event.trigger(

						// Support: IE <=9 - 11+
						// Extend with the prototype to reset the above stopImmediatePropagation()
						jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
						saved.slice( 1 ),
						this
					)
				} );

				// Abort handling of the native event
				event.stopImmediatePropagation();
			}
		}
	} );
}

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (trac-504, trac-13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	code: true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,
	which: true
}, jQuery.event.addProp );

jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
	jQuery.event.special[ type ] = {

		// Utilize native event if possible so blur/focus sequence is correct
		setup: function() {

			// Claim the first handler
			// dataPriv.set( this, "focus", ... )
			// dataPriv.set( this, "blur", ... )
			leverageNative( this, type, expectSync );

			// Return false to allow normal processing in the caller
			return false;
		},
		trigger: function() {

			// Force setup before trigger
			leverageNative( this, type );

			// Return non-false to allow normal event-path propagation
			return true;
		},

		// Suppress native focus or blur if we're currently inside
		// a leveraged native-event stack
		_default: function( event ) {
			return dataPriv.get( event.target, type );
		},

		delegateType: delegateType
	};
} );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,

	rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.get( src );
		events = pdataOld.events;

		if ( events ) {
			dataPriv.remove( dest, "handle events" );

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = flat( args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (trac-8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl && !node.noModule ) {
								jQuery._evalUrl( node.src, {
									nonce: node.nonce || node.getAttribute( "nonce" )
								}, doc );
							}
						} else {

							// Unwrap a CDATA section containing script contents. This shouldn't be
							// needed as in XML documents they're already not visible when
							// inspecting element contents and in HTML documents they have no
							// meaning but we're preserving that logic for backwards compatibility.
							// This will be removed completely in 4.0. See gh-4904.
							DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && isAttached( node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html;
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = isAttached( elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var rcustomProp = /^--/;


var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var swap = function( elem, options, callback ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.call( elem );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );

var whitespace = "[\\x20\\t\\r\\n\\f]";


var rtrimCSS = new RegExp(
	"^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$",
	"g"
);




( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		// Support: Chrome <=64
		// Don't get tricked when zoom affects offsetWidth (gh-4029)
		div.style.position = "absolute";
		scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableTrDimensionsVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (trac-8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		},

		// Support: IE 9 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Behavior in IE 9 is more subtle than in newer versions & it passes
		// some versions of this test; make sure not to make it pass there!
		//
		// Support: Firefox 70+
		// Only Firefox includes border widths
		// in computed dimensions. (gh-4529)
		reliableTrDimensions: function() {
			var table, tr, trChild, trStyle;
			if ( reliableTrDimensionsVal == null ) {
				table = document.createElement( "table" );
				tr = document.createElement( "tr" );
				trChild = document.createElement( "div" );

				table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
				tr.style.cssText = "border:1px solid";

				// Support: Chrome 86+
				// Height set through cssText does not get applied.
				// Computed height then comes back as 0.
				tr.style.height = "1px";
				trChild.style.height = "9px";

				// Support: Android 8 Chrome 86+
				// In our bodyBackground.html iframe,
				// display for all div elements is set to "inline",
				// which causes a problem only in Android 8 Chrome 86.
				// Ensuring the div is display: block
				// gets around this issue.
				trChild.style.display = "block";

				documentElement
					.appendChild( table )
					.appendChild( tr )
					.appendChild( trChild );

				trStyle = window.getComputedStyle( tr );
				reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
					parseInt( trStyle.borderTopWidth, 10 ) +
					parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;

				documentElement.removeChild( table );
			}
			return reliableTrDimensionsVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,
		isCustomProp = rcustomProp.test( name ),

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, trac-12537)
	//   .css('--customProperty) (gh-3144)
	if ( computed ) {

		// Support: IE <=9 - 11+
		// IE only supports `"float"` in `getPropertyValue`; in computed styles
		// it's only available as `"cssFloat"`. We no longer modify properties
		// sent to `.css()` apart from camelCasing, so we need to check both.
		// Normally, this would create difference in behavior: if
		// `getPropertyValue` returns an empty string, the value returned
		// by `.css()` would be `undefined`. This is usually the case for
		// disconnected elements. However, in IE even disconnected elements
		// with no styles return `"none"` for `getPropertyValue( "float" )`
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( isCustomProp && ret ) {

			// Support: Firefox 105+, Chrome <=105+
			// Spec requires trimming whitespace for custom properties (gh-4926).
			// Firefox only trims leading whitespace. Chrome just collapses
			// both leading & trailing whitespace to a single space.
			//
			// Fall back to `undefined` if empty string returned.
			// This collapses a missing definition with property defined
			// and set to an empty string but there's no standard API
			// allowing us to differentiate them without a performance penalty
			// and returning `undefined` aligns with older jQuery.
			//
			// rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
			// as whitespace while CSS does not, but this is not a problem
			// because CSS preprocessing replaces them with U+000A LINE FEED
			// (which *is* CSS whitespace)
			// https://www.w3.org/TR/css-syntax-3/#input-preprocessing
			ret = ret.replace( rtrimCSS, "$1" ) || undefined;
		}

		if ( ret === "" && !isAttached( elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style,
	vendorProps = {};

// Return a vendor-prefixed property or undefined
function vendorPropName( name ) {

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
function finalPropName( name ) {
	var final = jQuery.cssProps[ name ] || vendorProps[ name ];

	if ( final ) {
		return final;
	}
	if ( name in emptyStyle ) {
		return name;
	}
	return vendorProps[ name ] = vendorPropName( name ) || name;
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	};

function setPositiveNumber( _elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		if ( box === "margin" ) {
			delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5

		// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
		// Use an explicit zero to avoid NaN (gh-3964)
		) ) || 0;
	}

	return delta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),

		// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
		// Fake content-box until we know it's needed to know the true value.
		boxSizingNeeded = !support.boxSizingReliable() || extra,
		isBorderBox = boxSizingNeeded &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox,

		val = curCSS( elem, dimension, styles ),
		offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}


	// Support: IE 9 - 11 only
	// Use offsetWidth/offsetHeight for when box sizing is unreliable.
	// In those cases, the computed value can be trusted to be border-box.
	if ( ( !support.boxSizingReliable() && isBorderBox ||

		// Support: IE 10 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Interestingly, in some cases IE 9 doesn't suffer from this issue.
		!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||

		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		val === "auto" ||

		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&

		// Make sure the element is visible & connected
		elem.getClientRects().length ) {

		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

		// Where available, offsetWidth/offsetHeight approximate border box dimensions.
		// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
		// retrieved value as a content box dimension.
		valueIsBorderBox = offsetProp in elem;
		if ( valueIsBorderBox ) {
			val = elem[ offsetProp ];
		}
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"gridArea": true,
		"gridColumn": true,
		"gridColumnEnd": true,
		"gridColumnStart": true,
		"gridRow": true,
		"gridRowEnd": true,
		"gridRowStart": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (trac-7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug trac-9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (trac-7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
			// "px" to a few hardcoded values.
			if ( type === "number" && !isCustomProp ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( _i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
					swap( elem, cssShow, function() {
						return getWidthOrHeight( elem, dimension, extra );
					} ) :
					getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),

				// Only read styles.position if the test has a chance to fail
				// to avoid forcing a reflow.
				scrollboxSizeBuggy = !support.scrollboxSize() &&
					styles.position === "absolute",

				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
				boxSizingNeeded = scrollboxSizeBuggy || extra,
				isBorderBox = boxSizingNeeded &&
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra ?
					boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					) :
					0;

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && scrollboxSizeBuggy ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
			) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 && (
				jQuery.cssHooks[ tween.prop ] ||
					tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

				/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
					animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};

		doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// Use proper attribute retrieval (trac-12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classNames, cur, curValue, className, i, finalValue;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classNames = classesToArray( value );

		if ( classNames.length ) {
			return this.each( function() {
				curValue = getClass( this );
				cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];
						if ( cur.indexOf( " " + className + " " ) < 0 ) {
							cur += className + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						this.setAttribute( "class", finalValue );
					}
				}
			} );
		}

		return this;
	},

	removeClass: function( value ) {
		var classNames, cur, curValue, className, i, finalValue;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classNames = classesToArray( value );

		if ( classNames.length ) {
			return this.each( function() {
				curValue = getClass( this );

				// This expression is here for better compressibility (see addClass)
				cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];

						// Remove *all* instances
						while ( cur.indexOf( " " + className + " " ) > -1 ) {
							cur = cur.replace( " " + className + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						this.setAttribute( "class", finalValue );
					}
				}
			} );
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var classNames, className, i, self,
			type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		classNames = classesToArray( value );

		return this.each( function() {
			if ( isValidValue ) {

				// Toggle individual class names
				self = jQuery( this );

				for ( i = 0; i < classNames.length; i++ ) {
					className = classNames[ i ];

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
				return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (trac-14686, trac-14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (trac-2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


support.focusin = "onfocusin" in window;


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (trac-9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (trac-6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {

				// Handle: regular nodes (via `this.ownerDocument`), window
				// (via `this.document`) & document (via `this`).
				var doc = this.ownerDocument || this.document || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this.document || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = { guid: Date.now() };

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml, parserErrorElem;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {}

	parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
	if ( !xml || parserErrorElem ) {
		jQuery.error( "Invalid XML: " + (
			parserErrorElem ?
				jQuery.map( parserErrorElem.childNodes, function( el ) {
					return el.textContent;
				} ).join( "\n" ) :
				data
		) );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	if ( a == null ) {
		return "";
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} ).filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} ).map( function( _i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// trac-7653, trac-8125, trac-8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );

originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes trac-9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
				jQuery( callbackContext ) :
				jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
									( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
										.concat( match[ 2 ] );
							}
						}
						match = responseHeaders[ key.toLowerCase() + " " ];
					}
					return match == null ? null : match.join( ", " );
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (trac-10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket trac-12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// trac-9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
					uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Use a noop converter for missing script but not if jsonp
			if ( !isSuccess &&
				jQuery.inArray( "script", s.dataTypes ) > -1 &&
				jQuery.inArray( "json", s.dataTypes ) < 0 ) {
				s.converters[ "text script" ] = function() {};
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( _i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );

jQuery.ajaxPrefilter( function( s ) {
	var i;
	for ( i in s.headers ) {
		if ( i.toLowerCase() === "content-type" ) {
			s.contentType = s.headers[ i ] || "";
		}
	}
} );


jQuery._evalUrl = function( url, options, doc ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (trac-11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,

		// Only evaluate the response if it is successful (gh-4126)
		// dataFilter is not invoked for failure responses, so using it instead
		// of the default converter is kludgy but it works.
		converters: {
			"text script": function() {}
		},
		dataFilter: function( response ) {
			jQuery.globalEval( response, options, doc );
		}
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// trac-1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see trac-8605, trac-14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// trac-14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain or forced-by-attrs requests
	if ( s.crossDomain || s.scriptAttrs ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" )
					.attr( s.scriptAttrs || {} )
					.prop( { charset: s.scriptCharset, src: s.url } )
					.on( "load error", callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					} );

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( _i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( {
		padding: "inner" + name,
		content: type,
		"": "outer" + name
	}, function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( _i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	},

	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );

jQuery.each(
	( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( _i, name ) {

		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	}
);




// Support: Android <=4.0 only
// Make sure we trim BOM and NBSP
// Require that the "whitespace run" starts from a non-whitespace
// to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};

jQuery.trim = function( text ) {
	return text == null ?
		"" :
		( text + "" ).replace( rtrim, "$1" );
};



// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( typeof define === "function" && define.amd ) {
	define( "jquery", [], function() {
		return jQuery;
	} );
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (trac-13566)
if ( typeof noGlobal === "undefined" ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );

},{}],"lodash":[function(require,module,exports){
(function (global){(function (){
/**
 * @license
 * lodash 3.10.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern -d -o ./index.js`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '3.10.1';

  /** Used to compose bitmasks for wrapper metadata. */
  var BIND_FLAG = 1,
      BIND_KEY_FLAG = 2,
      CURRY_BOUND_FLAG = 4,
      CURRY_FLAG = 8,
      CURRY_RIGHT_FLAG = 16,
      PARTIAL_FLAG = 32,
      PARTIAL_RIGHT_FLAG = 64,
      ARY_FLAG = 128,
      REARG_FLAG = 256;

  /** Used as default options for `_.trunc`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect when a function becomes hot. */
  var HOT_COUNT = 150,
      HOT_SPAN = 16;

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2;

  /** Used as the `TypeError` message for "Functions" methods. */
  var FUNC_ERROR_TEXT = 'Expected a function';

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      objectTag = '[object Object]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      weakMapTag = '[object WeakMap]';

  var arrayBufferTag = '[object ArrayBuffer]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39|#96);/g,
      reUnescapedHtml = /[&<>"'`]/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;

  /**
   * Used to match `RegExp` [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns)
   * and those outlined by [`EscapeRegExpPattern`](http://ecma-international.org/ecma-262/6.0/#sec-escaperegexppattern).
   */
  var reRegExpChars = /^[:!,]|[\\^$.*+?()[\]{}|\/]|(^[0-9a-fA-Fnrtuvx])|([\n\r\u2028\u2029])/g,
      reHasRegExpChars = RegExp(reRegExpChars.source);

  /** Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks). */
  var reComboMark = /[\u0300-\u036f\ufe20-\ufe23]/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /** Used to match [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components). */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect hexadecimal string values. */
  var reHasHexPrefix = /^0[xX]/;

  /** Used to detect host constructors (Safari > 5). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^\d+$/;

  /** Used to match latin-1 supplementary letters (excluding mathematical operators). */
  var reLatin1 = /[\xc0-\xd6\xd8-\xde\xdf-\xf6\xf8-\xff]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to match words to create compound words. */
  var reWords = (function() {
    var upper = '[A-Z\\xc0-\\xd6\\xd8-\\xde]',
        lower = '[a-z\\xdf-\\xf6\\xf8-\\xff]+';

    return RegExp(upper + '+(?=' + upper + lower + ')|' + upper + '?' + lower + '|' + upper + '+|[0-9]+', 'g');
  }());

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'ArrayBuffer', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Math', 'Number',
    'Object', 'RegExp', 'Set', 'String', '_', 'clearTimeout', 'isFinite',
    'parseFloat', 'parseInt', 'setTimeout', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dateTag] = typedArrayTags[errorTag] =
  typedArrayTags[funcTag] = typedArrayTags[mapTag] =
  typedArrayTags[numberTag] = typedArrayTags[objectTag] =
  typedArrayTags[regexpTag] = typedArrayTags[setTag] =
  typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[boolTag] =
  cloneableTags[dateTag] = cloneableTags[float32Tag] =
  cloneableTags[float64Tag] = cloneableTags[int8Tag] =
  cloneableTags[int16Tag] = cloneableTags[int32Tag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[stringTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[mapTag] = cloneableTags[setTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map latin-1 supplementary letters to basic latin letters. */
  var deburredLetters = {
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcC': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xeC': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '`': '&#96;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'",
    '&#96;': '`'
  };

  /** Used to determine if values are of the language type `Object`. */
  var objectTypes = {
    'function': true,
    'object': true
  };

  /** Used to escape characters for inclusion in compiled regexes. */
  var regexpEscapes = {
    '0': 'x30', '1': 'x31', '2': 'x32', '3': 'x33', '4': 'x34',
    '5': 'x35', '6': 'x36', '7': 'x37', '8': 'x38', '9': 'x39',
    'A': 'x41', 'B': 'x42', 'C': 'x43', 'D': 'x44', 'E': 'x45', 'F': 'x46',
    'a': 'x61', 'b': 'x62', 'c': 'x63', 'd': 'x64', 'e': 'x65', 'f': 'x66',
    'n': 'x6e', 'r': 'x72', 't': 'x74', 'u': 'x75', 'v': 'x76', 'x': 'x78'
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Detect free variable `exports`. */
  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = freeExports && freeModule && typeof global == 'object' && global && global.Object && global;

  /** Detect free variable `self`. */
  var freeSelf = objectTypes[typeof self] && self && self.Object && self;

  /** Detect free variable `window`. */
  var freeWindow = objectTypes[typeof window] && window && window.Object && window;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports && freeExports;

  /**
   * Used as a reference to the global object.
   *
   * The `this` value is used if it's the global object to avoid Greasemonkey's
   * restricted `window` object, otherwise the `window` object is used.
   */
  var root = freeGlobal || ((freeWindow !== (this && this.window)) && freeWindow) || freeSelf || this;

  /*--------------------------------------------------------------------------*/

  /**
   * The base implementation of `compareAscending` which compares values and
   * sorts them in ascending order without guaranteeing a stable sort.
   *
   * @private
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {number} Returns the sort order indicator for `value`.
   */
  function baseCompareAscending(value, other) {
    if (value !== other) {
      var valIsNull = value === null,
          valIsUndef = value === undefined,
          valIsReflexive = value === value;

      var othIsNull = other === null,
          othIsUndef = other === undefined,
          othIsReflexive = other === other;

      if ((value > other && !othIsNull) || !valIsReflexive ||
          (valIsNull && !othIsUndef && othIsReflexive) ||
          (valIsUndef && othIsReflexive)) {
        return 1;
      }
      if ((value < other && !valIsNull) || !othIsReflexive ||
          (othIsNull && !valIsUndef && valIsReflexive) ||
          (othIsUndef && valIsReflexive)) {
        return -1;
      }
    }
    return 0;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for callback shorthands and `this` binding.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {Function} predicate The function invoked per iteration.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromRight) {
    var length = array.length,
        index = fromRight ? length : -1;

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without support for binary searches.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    if (value !== value) {
      return indexOfNaN(array, fromIndex);
    }
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isFunction` without support for environments
   * with incorrect `typeof` results.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
   */
  function baseIsFunction(value) {
    // Avoid a Chakra JIT bug in compatibility modes of IE 11.
    // See https://github.com/jashkenas/underscore/issues/1621 for more details.
    return typeof value == 'function' || false;
  }

  /**
   * Converts `value` to a string if it's not one. An empty string is returned
   * for `null` or `undefined` values.
   *
   * @private
   * @param {*} value The value to process.
   * @returns {string} Returns the string.
   */
  function baseToString(value) {
    return value == null ? '' : (value + '');
  }

  /**
   * Used by `_.trim` and `_.trimLeft` to get the index of the first character
   * of `string` that is not found in `chars`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @param {string} chars The characters to find.
   * @returns {number} Returns the index of the first character not found in `chars`.
   */
  function charsLeftIndex(string, chars) {
    var index = -1,
        length = string.length;

    while (++index < length && chars.indexOf(string.charAt(index)) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimRight` to get the index of the last character
   * of `string` that is not found in `chars`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @param {string} chars The characters to find.
   * @returns {number} Returns the index of the last character not found in `chars`.
   */
  function charsRightIndex(string, chars) {
    var index = string.length;

    while (index-- && chars.indexOf(string.charAt(index)) > -1) {}
    return index;
  }

  /**
   * Used by `_.sortBy` to compare transformed elements of a collection and stable
   * sort them in ascending order.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @returns {number} Returns the sort order indicator for `object`.
   */
  function compareAscending(object, other) {
    return baseCompareAscending(object.criteria, other.criteria) || (object.index - other.index);
  }

  /**
   * Used by `_.sortByOrder` to compare multiple properties of a value to another
   * and stable sort them.
   *
   * If `orders` is unspecified, all valuess are sorted in ascending order. Otherwise,
   * a value is sorted in ascending order if its corresponding order is "asc", and
   * descending if "desc".
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {boolean[]} orders The order to sort by for each property.
   * @returns {number} Returns the sort order indicator for `object`.
   */
  function compareMultiple(object, other, orders) {
    var index = -1,
        objCriteria = object.criteria,
        othCriteria = other.criteria,
        length = objCriteria.length,
        ordersLength = orders.length;

    while (++index < length) {
      var result = baseCompareAscending(objCriteria[index], othCriteria[index]);
      if (result) {
        if (index >= ordersLength) {
          return result;
        }
        var order = orders[index];
        return result * ((order === 'asc' || order === true) ? 1 : -1);
      }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://code.google.com/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
  }

  /**
   * Used by `_.deburr` to convert latin-1 supplementary letters to basic latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  function deburrLetter(letter) {
    return deburredLetters[letter];
  }

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeHtmlChar(chr) {
    return htmlEscapes[chr];
  }

  /**
   * Used by `_.escapeRegExp` to escape characters for inclusion in compiled regexes.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @param {string} leadingChar The capture group for a leading character.
   * @param {string} whitespaceChar The capture group for a whitespace character.
   * @returns {string} Returns the escaped character.
   */
  function escapeRegExpChar(chr, leadingChar, whitespaceChar) {
    if (leadingChar) {
      chr = regexpEscapes[chr];
    } else if (whitespaceChar) {
      chr = stringEscapes[chr];
    }
    return '\\' + chr;
  }

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the index at which the first occurrence of `NaN` is found in `array`.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched `NaN`, else `-1`.
   */
  function indexOfNaN(array, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 0 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      var other = array[index];
      if (other !== other) {
        return index;
      }
    }
    return -1;
  }

  /**
   * Checks if `value` is object-like.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   */
  function isObjectLike(value) {
    return !!value && typeof value == 'object';
  }

  /**
   * Used by `trimmedLeftIndex` and `trimmedRightIndex` to determine if a
   * character code is whitespace.
   *
   * @private
   * @param {number} charCode The character code to inspect.
   * @returns {boolean} Returns `true` if `charCode` is whitespace, else `false`.
   */
  function isSpace(charCode) {
    return ((charCode <= 160 && (charCode >= 9 && charCode <= 13) || charCode == 32 || charCode == 160) || charCode == 5760 || charCode == 6158 ||
      (charCode >= 8192 && (charCode <= 8202 || charCode == 8232 || charCode == 8233 || charCode == 8239 || charCode == 8287 || charCode == 12288 || charCode == 65279)));
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = -1,
        result = [];

    while (++index < length) {
      if (array[index] === placeholder) {
        array[index] = PLACEHOLDER;
        result[++resIndex] = index;
      }
    }
    return result;
  }

  /**
   * An implementation of `_.uniq` optimized for sorted arrays without support
   * for callback shorthands and `this` binding.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} [iteratee] The function invoked per iteration.
   * @returns {Array} Returns the new duplicate-value-free array.
   */
  function sortedUniq(array, iteratee) {
    var seen,
        index = -1,
        length = array.length,
        resIndex = -1,
        result = [];

    while (++index < length) {
      var value = array[index],
          computed = iteratee ? iteratee(value, index, array) : value;

      if (!index || seen !== computed) {
        seen = computed;
        result[++resIndex] = value;
      }
    }
    return result;
  }

  /**
   * Used by `_.trim` and `_.trimLeft` to get the index of the first non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the first non-whitespace character.
   */
  function trimmedLeftIndex(string) {
    var index = -1,
        length = string.length;

    while (++index < length && isSpace(string.charCodeAt(index))) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimRight` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedRightIndex(string) {
    var index = string.length;

    while (index-- && isSpace(string.charCodeAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  function unescapeHtmlChar(chr) {
    return htmlUnescapes[chr];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the given `context` object.
   *
   * @static
   * @memberOf _
   * @category Utility
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // using `context` to mock `Date#getTime` use in `_.now`
   * var mock = _.runInContext({
   *   'Date': function() {
   *     return { 'getTime': getTimeMock };
   *   }
   * });
   *
   * // or creating a suped-up `defer` in Node.js
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  function runInContext(context) {
    // Avoid issues with some ES3 environments that attempt to use values, named
    // after built-in constructors like `Object`, for the creation of literals.
    // ES5 clears this up by stating that literals must use built-in constructors.
    // See https://es5.github.io/#x11.1.5 for more details.
    context = context ? _.defaults(root.Object(), context, _.pick(root, contextProps)) : root;

    /** Native constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Number = context.Number,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for native method references. */
    var arrayProto = Array.prototype,
        objectProto = Object.prototype,
        stringProto = String.prototype;

    /** Used to resolve the decompiled source of functions. */
    var fnToString = Function.prototype.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /**
     * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
     * of values.
     */
    var objToString = objectProto.toString;

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Native method references. */
    var ArrayBuffer = context.ArrayBuffer,
        clearTimeout = context.clearTimeout,
        parseFloat = context.parseFloat,
        pow = Math.pow,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        Set = getNative(context, 'Set'),
        setTimeout = context.setTimeout,
        splice = arrayProto.splice,
        Uint8Array = context.Uint8Array,
        WeakMap = getNative(context, 'WeakMap');

    /* Native method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeCreate = getNative(Object, 'create'),
        nativeFloor = Math.floor,
        nativeIsArray = getNative(Array, 'isArray'),
        nativeIsFinite = context.isFinite,
        nativeKeys = getNative(Object, 'keys'),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = getNative(Date, 'now'),
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random;

    /** Used as references for `-Infinity` and `Infinity`. */
    var NEGATIVE_INFINITY = Number.NEGATIVE_INFINITY,
        POSITIVE_INFINITY = Number.POSITIVE_INFINITY;

    /** Used as references for the maximum length and index of an array. */
    var MAX_ARRAY_LENGTH = 4294967295,
        MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
        HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

    /**
     * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
     * of an array-like value.
     */
    var MAX_SAFE_INTEGER = 9007199254740991;

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit chaining.
     * Methods that operate on and return arrays, collections, and functions can
     * be chained together. Methods that retrieve a single value or may return a
     * primitive value will automatically end the chain returning the unwrapped
     * value. Explicit chaining may be enabled using `_.chain`. The execution of
     * chained methods is lazy, that is, execution is deferred until `_#value`
     * is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion. Shortcut
     * fusion is an optimization strategy which merge iteratee calls; this can help
     * to avoid the creation of intermediate data structures and greatly reduce the
     * number of iteratee executions.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `reverse`, `shift`, `slice`, `sort`,
     * `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `compact`, `drop`, `dropRight`, `dropRightWhile`, `dropWhile`, `filter`,
     * `first`, `initial`, `last`, `map`, `pluck`, `reject`, `rest`, `reverse`,
     * `slice`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, `toArray`,
     * and `where`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `at`, `before`, `bind`, `bindAll`, `bindKey`,
     * `callback`, `chain`, `chunk`, `commit`, `compact`, `concat`, `constant`,
     * `countBy`, `create`, `curry`, `debounce`, `defaults`, `defaultsDeep`,
     * `defer`, `delay`, `difference`, `drop`, `dropRight`, `dropRightWhile`,
     * `dropWhile`, `fill`, `filter`, `flatten`, `flattenDeep`, `flow`, `flowRight`,
     * `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`, `forOwnRight`,
     * `functions`, `groupBy`, `indexBy`, `initial`, `intersection`, `invert`,
     * `invoke`, `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`,
     * `matchesProperty`, `memoize`, `merge`, `method`, `methodOf`, `mixin`,
     * `modArgs`, `negate`, `omit`, `once`, `pairs`, `partial`, `partialRight`,
     * `partition`, `pick`, `plant`, `pluck`, `property`, `propertyOf`, `pull`,
     * `pullAt`, `push`, `range`, `rearg`, `reject`, `remove`, `rest`, `restParam`,
     * `reverse`, `set`, `shuffle`, `slice`, `sort`, `sortBy`, `sortByAll`,
     * `sortByOrder`, `splice`, `spread`, `take`, `takeRight`, `takeRightWhile`,
     * `takeWhile`, `tap`, `throttle`, `thru`, `times`, `toArray`, `toPlainObject`,
     * `transform`, `union`, `uniq`, `unshift`, `unzip`, `unzipWith`, `values`,
     * `valuesIn`, `where`, `without`, `wrap`, `xor`, `zip`, `zipObject`, `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clone`, `cloneDeep`,
     * `deburr`, `endsWith`, `escape`, `escapeRegExp`, `every`, `find`, `findIndex`,
     * `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `findWhere`, `first`,
     * `floor`, `get`, `gt`, `gte`, `has`, `identity`, `includes`, `indexOf`,
     * `inRange`, `isArguments`, `isArray`, `isBoolean`, `isDate`, `isElement`,
     * `isEmpty`, `isEqual`, `isError`, `isFinite` `isFunction`, `isMatch`,
     * `isNative`, `isNaN`, `isNull`, `isNumber`, `isObject`, `isPlainObject`,
     * `isRegExp`, `isString`, `isUndefined`, `isTypedArray`, `join`, `kebabCase`,
     * `last`, `lastIndexOf`, `lt`, `lte`, `max`, `min`, `noConflict`, `noop`,
     * `now`, `pad`, `padLeft`, `padRight`, `parseInt`, `pop`, `random`, `reduce`,
     * `reduceRight`, `repeat`, `result`, `round`, `runInContext`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedLastIndex`, `startCase`,
     * `startsWith`, `sum`, `template`, `trim`, `trimLeft`, `trimRight`, `trunc`,
     * `unescape`, `uniqueId`, `value`, and `words`
     *
     * The wrapper method `sample` will return a wrapped value when `n` is provided,
     * otherwise an unwrapped value is returned.
     *
     * @name _
     * @constructor
     * @category Chain
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // returns an unwrapped value
     * wrapped.reduce(function(total, n) {
     *   return total + n;
     * });
     * // => 6
     *
     * // returns a wrapped value
     * var squares = wrapped.map(function(n) {
     *   return n * n;
     * });
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__chain__') && hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The function whose prototype all chaining wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable chaining for all wrapper methods.
     * @param {Array} [actions=[]] Actions to peform to resolve the unwrapped value.
     */
    function LodashWrapper(value, chainAll, actions) {
      this.__wrapped__ = value;
      this.__actions__ = actions || [];
      this.__chain__ = !!chainAll;
    }

    /**
     * An object environment feature flags.
     *
     * @static
     * @memberOf _
     * @type Object
     */
    var support = lodash.support = {};

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB). Change the following template settings to use
     * alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type Object
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type string
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type Object
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type Function
         */
        '_': lodash
      }
    };

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = POSITIVE_INFINITY;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = arrayCopy(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = arrayCopy(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = arrayCopy(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || arrLength < LARGE_ARRAY_SIZE || (arrLength == length && takeCount == length)) {
        return baseWrapperValue((isRight && isArr) ? array.reverse() : array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates a cache object to store key/value pairs.
     *
     * @private
     * @static
     * @name Cache
     * @memberOf _.memoize
     */
    function MapCache() {
      this.__data__ = {};
    }

    /**
     * Removes `key` and its value from the cache.
     *
     * @private
     * @name delete
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed successfully, else `false`.
     */
    function mapDelete(key) {
      return this.has(key) && delete this.__data__[key];
    }

    /**
     * Gets the cached value for `key`.
     *
     * @private
     * @name get
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the cached value.
     */
    function mapGet(key) {
      return key == '__proto__' ? undefined : this.__data__[key];
    }

    /**
     * Checks if a cached value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapHas(key) {
      return key != '__proto__' && hasOwnProperty.call(this.__data__, key);
    }

    /**
     * Sets `value` to `key` of the cache.
     *
     * @private
     * @name set
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the value to cache.
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache object.
     */
    function mapSet(key, value) {
      if (key != '__proto__') {
        this.__data__[key] = value;
      }
      return this;
    }

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates a cache object to store unique values.
     *
     * @private
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var length = values ? values.length : 0;

      this.data = { 'hash': nativeCreate(null), 'set': new Set };
      while (length--) {
        this.push(values[length]);
      }
    }

    /**
     * Checks if `value` is in `cache` mimicking the return signature of
     * `_.indexOf` by returning `0` if the value is found, else `-1`.
     *
     * @private
     * @param {Object} cache The cache to search.
     * @param {*} value The value to search for.
     * @returns {number} Returns `0` if `value` is found, else `-1`.
     */
    function cacheIndexOf(cache, value) {
      var data = cache.data,
          result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];

      return result ? 0 : -1;
    }

    /**
     * Adds `value` to the cache.
     *
     * @private
     * @name push
     * @memberOf SetCache
     * @param {*} value The value to cache.
     */
    function cachePush(value) {
      var data = this.data;
      if (typeof value == 'string' || isObject(value)) {
        data.set.add(value);
      } else {
        data.hash[value] = true;
      }
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates a new array joining `array` with `other`.
     *
     * @private
     * @param {Array} array The array to join.
     * @param {Array} other The other array to join.
     * @returns {Array} Returns the new concatenated array.
     */
    function arrayConcat(array, other) {
      var index = -1,
          length = array.length,
          othIndex = -1,
          othLength = other.length,
          result = Array(length + othLength);

      while (++index < length) {
        result[index] = array[index];
      }
      while (++othIndex < othLength) {
        result[index++] = other[othIndex];
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function arrayCopy(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * A specialized version of `_.forEach` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns `array`.
     */
    function arrayEach(array, iteratee) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        if (iteratee(array[index], index, array) === false) {
          break;
        }
      }
      return array;
    }

    /**
     * A specialized version of `_.forEachRight` for arrays without support for
     * callback shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns `array`.
     */
    function arrayEachRight(array, iteratee) {
      var length = array.length;

      while (length--) {
        if (iteratee(array[length], length, array) === false) {
          break;
        }
      }
      return array;
    }

    /**
     * A specialized version of `_.every` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     */
    function arrayEvery(array, predicate) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        if (!predicate(array[index], index, array)) {
          return false;
        }
      }
      return true;
    }

    /**
     * A specialized version of `baseExtremum` for arrays which invokes `iteratee`
     * with one argument: (value).
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} comparator The function used to compare values.
     * @param {*} exValue The initial extremum value.
     * @returns {*} Returns the extremum value.
     */
    function arrayExtremum(array, iteratee, comparator, exValue) {
      var index = -1,
          length = array.length,
          computed = exValue,
          result = computed;

      while (++index < length) {
        var value = array[index],
            current = +iteratee(value);

        if (comparator(current, computed)) {
          computed = current;
          result = value;
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.filter` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function arrayFilter(array, predicate) {
      var index = -1,
          length = array.length,
          resIndex = -1,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result[++resIndex] = value;
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.map` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function arrayMap(array, iteratee) {
      var index = -1,
          length = array.length,
          result = Array(length);

      while (++index < length) {
        result[index] = iteratee(array[index], index, array);
      }
      return result;
    }

    /**
     * Appends the elements of `values` to `array`.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to append.
     * @returns {Array} Returns `array`.
     */
    function arrayPush(array, values) {
      var index = -1,
          length = values.length,
          offset = array.length;

      while (++index < length) {
        array[offset + index] = values[index];
      }
      return array;
    }

    /**
     * A specialized version of `_.reduce` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {boolean} [initFromArray] Specify using the first element of `array`
     *  as the initial value.
     * @returns {*} Returns the accumulated value.
     */
    function arrayReduce(array, iteratee, accumulator, initFromArray) {
      var index = -1,
          length = array.length;

      if (initFromArray && length) {
        accumulator = array[++index];
      }
      while (++index < length) {
        accumulator = iteratee(accumulator, array[index], index, array);
      }
      return accumulator;
    }

    /**
     * A specialized version of `_.reduceRight` for arrays without support for
     * callback shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {boolean} [initFromArray] Specify using the last element of `array`
     *  as the initial value.
     * @returns {*} Returns the accumulated value.
     */
    function arrayReduceRight(array, iteratee, accumulator, initFromArray) {
      var length = array.length;
      if (initFromArray && length) {
        accumulator = array[--length];
      }
      while (length--) {
        accumulator = iteratee(accumulator, array[length], length, array);
      }
      return accumulator;
    }

    /**
     * A specialized version of `_.some` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function arraySome(array, predicate) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        if (predicate(array[index], index, array)) {
          return true;
        }
      }
      return false;
    }

    /**
     * A specialized version of `_.sum` for arrays without support for callback
     * shorthands and `this` binding..
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {number} Returns the sum.
     */
    function arraySum(array, iteratee) {
      var length = array.length,
          result = 0;

      while (length--) {
        result += +iteratee(array[length]) || 0;
      }
      return result;
    }

    /**
     * Used by `_.defaults` to customize its `_.assign` use.
     *
     * @private
     * @param {*} objectValue The destination object property value.
     * @param {*} sourceValue The source object property value.
     * @returns {*} Returns the value to assign to the destination object.
     */
    function assignDefaults(objectValue, sourceValue) {
      return objectValue === undefined ? sourceValue : objectValue;
    }

    /**
     * Used by `_.template` to customize its `_.assign` use.
     *
     * **Note:** This function is like `assignDefaults` except that it ignores
     * inherited property values when checking if a property is `undefined`.
     *
     * @private
     * @param {*} objectValue The destination object property value.
     * @param {*} sourceValue The source object property value.
     * @param {string} key The key associated with the object and source values.
     * @param {Object} object The destination object.
     * @returns {*} Returns the value to assign to the destination object.
     */
    function assignOwnDefaults(objectValue, sourceValue, key, object) {
      return (objectValue === undefined || !hasOwnProperty.call(object, key))
        ? sourceValue
        : objectValue;
    }

    /**
     * A specialized version of `_.assign` for customizing assigned values without
     * support for argument juggling, multiple sources, and `this` binding `customizer`
     * functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     */
    function assignWith(object, source, customizer) {
      var index = -1,
          props = keys(source),
          length = props.length;

      while (++index < length) {
        var key = props[index],
            value = object[key],
            result = customizer(value, source[key], key, object, source);

        if ((result === result ? (result !== value) : (value === value)) ||
            (value === undefined && !(key in object))) {
          object[key] = result;
        }
      }
      return object;
    }

    /**
     * The base implementation of `_.assign` without support for argument juggling,
     * multiple sources, and `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return source == null
        ? object
        : baseCopy(source, keys(source), object);
    }

    /**
     * The base implementation of `_.at` without support for string collections
     * and individual key arguments.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {number[]|string[]} props The property names or indexes of elements to pick.
     * @returns {Array} Returns the new array of picked elements.
     */
    function baseAt(collection, props) {
      var index = -1,
          isNil = collection == null,
          isArr = !isNil && isArrayLike(collection),
          length = isArr ? collection.length : 0,
          propsLength = props.length,
          result = Array(propsLength);

      while(++index < propsLength) {
        var key = props[index];
        if (isArr) {
          result[index] = isIndex(key, length) ? collection[key] : undefined;
        } else {
          result[index] = isNil ? undefined : collection[key];
        }
      }
      return result;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property names to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @returns {Object} Returns `object`.
     */
    function baseCopy(source, props, object) {
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];
        object[key] = source[key];
      }
      return object;
    }

    /**
     * The base implementation of `_.callback` which supports specifying the
     * number of arguments to provide to `func`.
     *
     * @private
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {number} [argCount] The number of arguments to provide to `func`.
     * @returns {Function} Returns the callback.
     */
    function baseCallback(func, thisArg, argCount) {
      var type = typeof func;
      if (type == 'function') {
        return thisArg === undefined
          ? func
          : bindCallback(func, thisArg, argCount);
      }
      if (func == null) {
        return identity;
      }
      if (type == 'object') {
        return baseMatches(func);
      }
      return thisArg === undefined
        ? property(func)
        : baseMatchesProperty(func, thisArg);
    }

    /**
     * The base implementation of `_.clone` without support for argument juggling
     * and `this` binding `customizer` functions.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @param {Function} [customizer] The function to customize cloning values.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The object `value` belongs to.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates clones with source counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, isDeep, customizer, key, object, stackA, stackB) {
      var result;
      if (customizer) {
        result = object ? customizer(value, key, object) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return arrayCopy(value, result);
        }
      } else {
        var tag = objToString.call(value),
            isFunc = tag == funcTag;

        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = initCloneObject(isFunc ? {} : value);
          if (!isDeep) {
            return baseAssign(result, value);
          }
        } else {
          return cloneableTags[tag]
            ? initCloneByTag(value, tag, isDeep)
            : (object ? value : {});
        }
      }
      // Check for circular references and return its corresponding clone.
      stackA || (stackA = []);
      stackB || (stackB = []);

      var length = stackA.length;
      while (length--) {
        if (stackA[length] == value) {
          return stackB[length];
        }
      }
      // Add the source value to the stack of traversed objects and associate it with its clone.
      stackA.push(value);
      stackB.push(result);

      // Recursively populate clone (susceptible to call stack limits).
      (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
        result[key] = baseClone(subValue, isDeep, customizer, key, value, stackA, stackB);
      });
      return result;
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} prototype The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(prototype) {
        if (isObject(prototype)) {
          object.prototype = prototype;
          var result = new object;
          object.prototype = undefined;
        }
        return result || {};
      };
    }());

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts an index
     * of where to slice the arguments to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Object} args The arguments provide to `func`.
     * @returns {number} Returns the timer id.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of `_.difference` which accepts a single array
     * of values to exclude.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values) {
      var length = array ? array.length : 0,
          result = [];

      if (!length) {
        return result;
      }
      var index = -1,
          indexOf = getIndexOf(),
          isCommon = indexOf == baseIndexOf,
          cache = (isCommon && values.length >= LARGE_ARRAY_SIZE) ? createCache(values) : null,
          valuesLength = values.length;

      if (cache) {
        indexOf = cacheIndexOf;
        isCommon = false;
        values = cache;
      }
      outer:
      while (++index < length) {
        var value = array[index];

        if (isCommon && value === value) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === value) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (indexOf(values, value, 0) < 0) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object|string} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object|string} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * Gets the extremum value of `collection` invoking `iteratee` for each value
     * in `collection` to generate the criterion by which the value is ranked.
     * The `iteratee` is invoked with three arguments: (value, index|key, collection).
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} comparator The function used to compare values.
     * @param {*} exValue The initial extremum value.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(collection, iteratee, comparator, exValue) {
      var computed = exValue,
          result = computed;

      baseEach(collection, function(value, index, collection) {
        var current = +iteratee(value, index, collection);
        if (comparator(current, computed) || (current === exValue && current === result)) {
          computed = current;
          result = value;
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = start == null ? 0 : (+start || 0);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : (+end || 0);
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : (end >>> 0);
      start >>>= 0;

      while (start < length) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
     * without support for callback shorthands and `this` binding, which iterates
     * over `collection` using the provided `eachFunc`.
     *
     * @private
     * @param {Array|Object|string} collection The collection to search.
     * @param {Function} predicate The function invoked per iteration.
     * @param {Function} eachFunc The function to iterate over `collection`.
     * @param {boolean} [retKey] Specify returning the key of the found element
     *  instead of the element itself.
     * @returns {*} Returns the found element or its key, else `undefined`.
     */
    function baseFind(collection, predicate, eachFunc, retKey) {
      var result;
      eachFunc(collection, function(value, key, collection) {
        if (predicate(value, key, collection)) {
          result = retKey ? key : value;
          return false;
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with added support for restricting
     * flattening and specifying the start index.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {boolean} [isDeep] Specify a deep flatten.
     * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, isDeep, isStrict, result) {
      result || (result = []);

      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index];
        if (isObjectLike(value) && isArrayLike(value) &&
            (isStrict || isArray(value) || isArguments(value))) {
          if (isDeep) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, isDeep, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForIn` and `baseForOwn` which iterates
     * over `object` properties returned by `keysFunc` invoking `iteratee` for
     * each property. Iteratee functions may exit iteration early by explicitly
     * returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forIn` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForIn(object, iteratee) {
      return baseFor(object, iteratee, keysIn);
    }

    /**
     * The base implementation of `_.forOwn` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from those provided.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the new array of filtered property names.
     */
    function baseFunctions(object, props) {
      var index = -1,
          length = props.length,
          resIndex = -1,
          result = [];

      while (++index < length) {
        var key = props[index];
        if (isFunction(object[key])) {
          result[++resIndex] = key;
        }
      }
      return result;
    }

    /**
     * The base implementation of `get` without support for string paths
     * and default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path of the property to get.
     * @param {string} [pathKey] The key representation of path.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path, pathKey) {
      if (object == null) {
        return;
      }
      if (pathKey !== undefined && pathKey in toObject(object)) {
        path = [pathKey];
      }
      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[path[index++]];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `_.isEqual` without support for `this` binding
     * `customizer` functions.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparing values.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA] Tracks traversed `value` objects.
     * @param {Array} [stackB] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparing objects.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA=[]] Tracks traversed `value` objects.
     * @param {Array} [stackB=[]] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = arrayTag,
          othTag = arrayTag;

      if (!objIsArr) {
        objTag = objToString.call(object);
        if (objTag == argsTag) {
          objTag = objectTag;
        } else if (objTag != objectTag) {
          objIsArr = isTypedArray(object);
        }
      }
      if (!othIsArr) {
        othTag = objToString.call(other);
        if (othTag == argsTag) {
          othTag = objectTag;
        } else if (othTag != objectTag) {
          othIsArr = isTypedArray(other);
        }
      }
      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && !(objIsArr || objIsObj)) {
        return equalByTag(object, other, objTag);
      }
      if (!isLoose) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
        }
      }
      if (!isSameTag) {
        return false;
      }
      // Assume cyclic values are equal.
      // For more information on detecting circular references see https://es5.github.io/#JO.
      stackA || (stackA = []);
      stackB || (stackB = []);

      var length = stackA.length;
      while (length--) {
        if (stackA[length] == object) {
          return stackB[length] == other;
        }
      }
      // Add `object` and `other` to the stack of traversed objects.
      stackA.push(object);
      stackB.push(other);

      var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);

      stackA.pop();
      stackB.pop();

      return result;
    }

    /**
     * The base implementation of `_.isMatch` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} matchData The propery names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparing objects.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = toObject(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var result = customizer ? customizer(objValue, srcValue, key) : undefined;
          if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.map` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which does not clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        var key = matchData[0][0],
            value = matchData[0][1];

        return function(object) {
          if (object == null) {
            return false;
          }
          return object[key] === value && (value !== undefined || (key in toObject(object)));
        };
      }
      return function(object) {
        return baseIsMatch(object, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to compare.
     * @returns {Function} Returns the new function.
     */
    function baseMatchesProperty(path, srcValue) {
      var isArr = isArray(path),
          isCommon = isKey(path) && isStrictComparable(srcValue),
          pathKey = (path + '');

      path = toPath(path);
      return function(object) {
        if (object == null) {
          return false;
        }
        var key = pathKey;
        object = toObject(object);
        if ((isArr || !isCommon) && !(key in object)) {
          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
          if (object == null) {
            return false;
          }
          key = last(path);
          object = toObject(object);
        }
        return object[key] === srcValue
          ? (srcValue !== undefined || (key in object))
          : baseIsEqual(srcValue, object[key], undefined, true);
      };
    }

    /**
     * The base implementation of `_.merge` without support for argument juggling,
     * multiple sources, and `this` binding `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates values with source counterparts.
     * @returns {Object} Returns `object`.
     */
    function baseMerge(object, source, customizer, stackA, stackB) {
      if (!isObject(object)) {
        return object;
      }
      var isSrcArr = isArrayLike(source) && (isArray(source) || isTypedArray(source)),
          props = isSrcArr ? undefined : keys(source);

      arrayEach(props || source, function(srcValue, key) {
        if (props) {
          key = srcValue;
          srcValue = source[key];
        }
        if (isObjectLike(srcValue)) {
          stackA || (stackA = []);
          stackB || (stackB = []);
          baseMergeDeep(object, source, key, baseMerge, customizer, stackA, stackB);
        }
        else {
          var value = object[key],
              result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
              isCommon = result === undefined;

          if (isCommon) {
            result = srcValue;
          }
          if ((result !== undefined || (isSrcArr && !(key in object))) &&
              (isCommon || (result === result ? (result !== value) : (value === value)))) {
            object[key] = result;
          }
        }
      });
      return object;
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates values with source counterparts.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseMergeDeep(object, source, key, mergeFunc, customizer, stackA, stackB) {
      var length = stackA.length,
          srcValue = source[key];

      while (length--) {
        if (stackA[length] == srcValue) {
          object[key] = stackB[length];
          return;
        }
      }
      var value = object[key],
          result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
          isCommon = result === undefined;

      if (isCommon) {
        result = srcValue;
        if (isArrayLike(srcValue) && (isArray(srcValue) || isTypedArray(srcValue))) {
          result = isArray(value)
            ? value
            : (isArrayLike(value) ? arrayCopy(value) : []);
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          result = isArguments(value)
            ? toPlainObject(value)
            : (isPlainObject(value) ? value : {});
        }
        else {
          isCommon = false;
        }
      }
      // Add the source value to the stack of traversed objects and associate
      // it with its merged value.
      stackA.push(srcValue);
      stackB.push(result);

      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        object[key] = mergeFunc(result, srcValue, customizer, stackA, stackB);
      } else if (result === result ? (result !== value) : (value === value)) {
        object[key] = result;
      }
    }

    /**
     * The base implementation of `_.property` without support for deep paths.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @returns {Function} Returns the new function.
     */
    function baseProperty(key) {
      return function(object) {
        return object == null ? undefined : object[key];
      };
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new function.
     */
    function basePropertyDeep(path) {
      var pathKey = (path + '');
      path = toPath(path);
      return function(object) {
        return baseGet(object, path, pathKey);
      };
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * index arguments and capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0;
      while (length--) {
        var index = indexes[length];
        if (index != previous && isIndex(index)) {
          var previous = index;
          splice.call(array, index, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for argument juggling
     * and returning floating-point numbers.
     *
     * @private
     * @param {number} min The minimum possible value.
     * @param {number} max The maximum possible value.
     * @returns {number} Returns the random number.
     */
    function baseRandom(min, max) {
      return min + nativeFloor(nativeRandom() * (max - min + 1));
    }

    /**
     * The base implementation of `_.reduce` and `_.reduceRight` without support
     * for callback shorthands and `this` binding, which iterates over `collection`
     * using the provided `eachFunc`.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} accumulator The initial value.
     * @param {boolean} initFromCollection Specify using the first or last element
     *  of `collection` as the initial value.
     * @param {Function} eachFunc The function to iterate over `collection`.
     * @returns {*} Returns the accumulated value.
     */
    function baseReduce(collection, iteratee, accumulator, initFromCollection, eachFunc) {
      eachFunc(collection, function(value, index, collection) {
        accumulator = initFromCollection
          ? (initFromCollection = false, value)
          : iteratee(accumulator, value, index, collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `setData` without support for hot loop detection.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      start = start == null ? 0 : (+start || 0);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : (+end || 0);
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortBy` which uses `comparer` to define
     * the sort order of `array` and replaces criteria objects with their
     * corresponding values.
     *
     * @private
     * @param {Array} array The array to sort.
     * @param {Function} comparer The function to define sort order.
     * @returns {Array} Returns `array`.
     */
    function baseSortBy(array, comparer) {
      var length = array.length;

      array.sort(comparer);
      while (length--) {
        array[length] = array[length].value;
      }
      return array;
    }

    /**
     * The base implementation of `_.sortByOrder` without param guards.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {boolean[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseSortByOrder(collection, iteratees, orders) {
      var callback = getCallback(),
          index = -1;

      iteratees = arrayMap(iteratees, function(iteratee) { return callback(iteratee); });

      var result = baseMap(collection, function(value) {
        var criteria = arrayMap(iteratees, function(iteratee) { return iteratee(value); });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.sum` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {number} Returns the sum.
     */
    function baseSum(collection, iteratee) {
      var result = 0;
      baseEach(collection, function(value, index, collection) {
        result += +iteratee(value, index, collection) || 0;
      });
      return result;
    }

    /**
     * The base implementation of `_.uniq` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The function invoked per iteration.
     * @returns {Array} Returns the new duplicate-value-free array.
     */
    function baseUniq(array, iteratee) {
      var index = -1,
          indexOf = getIndexOf(),
          length = array.length,
          isCommon = indexOf == baseIndexOf,
          isLarge = isCommon && length >= LARGE_ARRAY_SIZE,
          seen = isLarge ? createCache() : null,
          result = [];

      if (seen) {
        indexOf = cacheIndexOf;
        isCommon = false;
      } else {
        isLarge = false;
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value, index, array) : value;

        if (isCommon && value === value) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (indexOf(seen, computed, 0) < 0) {
          if (iteratee || isLarge) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.values` and `_.valuesIn` which creates an
     * array of `object` property values corresponding to the property names
     * of `props`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} props The property names to get values for.
     * @returns {Object} Returns the array of property values.
     */
    function baseValues(object, props) {
      var index = -1,
          length = props.length,
          result = Array(length);

      while (++index < length) {
        result[index] = object[props[index]];
      }
      return result;
    }

    /**
     * The base implementation of `_.dropRightWhile`, `_.dropWhile`, `_.takeRightWhile`,
     * and `_.takeWhile` without support for callback shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {}
      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to peform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      var index = -1,
          length = actions.length;

      while (++index < length) {
        var action = actions[index];
        result = action.func.apply(action.thisArg, arrayPush([result], action.args));
      }
      return result;
    }

    /**
     * Performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function binaryIndex(array, value, retHighest) {
      var low = 0,
          high = array ? array.length : low;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if ((retHighest ? (computed <= value) : (computed < value)) && computed !== null) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return binaryIndexBy(array, value, identity, retHighest);
    }

    /**
     * This function is like `binaryIndex` except that it invokes `iteratee` for
     * `value` and each element of `array` to compute their sort ranking. The
     * iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function binaryIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array ? array.length : 0,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsUndef = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            isDef = computed !== undefined,
            isReflexive = computed === computed;

        if (valIsNaN) {
          var setLow = isReflexive || retHighest;
        } else if (valIsNull) {
          setLow = isReflexive && isDef && (retHighest || computed != null);
        } else if (valIsUndef) {
          setLow = isReflexive && (retHighest || isDef);
        } else if (computed == null) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * A specialized version of `baseCallback` which only supports `this` binding
     * and specifying the number of arguments to provide to `func`.
     *
     * @private
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {number} [argCount] The number of arguments to provide to `func`.
     * @returns {Function} Returns the callback.
     */
    function bindCallback(func, thisArg, argCount) {
      if (typeof func != 'function') {
        return identity;
      }
      if (thisArg === undefined) {
        return func;
      }
      switch (argCount) {
        case 1: return function(value) {
          return func.call(thisArg, value);
        };
        case 3: return function(value, index, collection) {
          return func.call(thisArg, value, index, collection);
        };
        case 4: return function(accumulator, value, index, collection) {
          return func.call(thisArg, accumulator, value, index, collection);
        };
        case 5: return function(value, other, key, object, source) {
          return func.call(thisArg, value, other, key, object, source);
        };
      }
      return function() {
        return func.apply(thisArg, arguments);
      };
    }

    /**
     * Creates a clone of the given array buffer.
     *
     * @private
     * @param {ArrayBuffer} buffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function bufferClone(buffer) {
      var result = new ArrayBuffer(buffer.byteLength),
          view = new Uint8Array(result);

      view.set(new Uint8Array(buffer));
      return result;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array|Object} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders) {
      var holdersLength = holders.length,
          argsIndex = -1,
          argsLength = nativeMax(args.length - holdersLength, 0),
          leftIndex = -1,
          leftLength = partials.length,
          result = Array(leftLength + argsLength);

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        result[holders[argsIndex]] = args[argsIndex];
      }
      while (argsLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array|Object} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders) {
      var holdersIndex = -1,
          holdersLength = holders.length,
          argsIndex = -1,
          argsLength = nativeMax(args.length - holdersLength, 0),
          rightIndex = -1,
          rightLength = partials.length,
          result = Array(argsLength + rightLength);

      while (++argsIndex < argsLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        result[offset + holders[holdersIndex]] = args[argsIndex++];
      }
      return result;
    }

    /**
     * Creates a `_.countBy`, `_.groupBy`, `_.indexBy`, or `_.partition` function.
     *
     * @private
     * @param {Function} setter The function to set keys and values of the accumulator object.
     * @param {Function} [initializer] The function to initialize the accumulator object.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee, thisArg) {
        var result = initializer ? initializer() : {};
        iteratee = getCallback(iteratee, thisArg, 3);

        if (isArray(collection)) {
          var index = -1,
              length = collection.length;

          while (++index < length) {
            var value = collection[index];
            setter(result, value, iteratee(value, index, collection), collection);
          }
        } else {
          baseEach(collection, function(value, key, collection) {
            setter(result, value, iteratee(value, key, collection), collection);
          });
        }
        return result;
      };
    }

    /**
     * Creates a `_.assign`, `_.defaults`, or `_.merge` function.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return restParam(function(object, sources) {
        var index = -1,
            length = object == null ? 0 : sources.length,
            customizer = length > 2 ? sources[length - 2] : undefined,
            guard = length > 2 ? sources[2] : undefined,
            thisArg = length > 1 ? sources[length - 1] : undefined;

        if (typeof customizer == 'function') {
          customizer = bindCallback(customizer, thisArg, 5);
          length -= 2;
        } else {
          customizer = typeof thisArg == 'function' ? thisArg : undefined;
          length -= (customizer ? 1 : 0);
        }
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        var length = collection ? getLength(collection) : 0;
        if (!isLength(length)) {
          return eachFunc(collection, iteratee);
        }
        var index = fromRight ? length : -1,
            iterable = toObject(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for `_.forIn` or `_.forInRight`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var iterable = toObject(object),
            props = keysFunc(object),
            length = props.length,
            index = fromRight ? length : -1;

        while ((fromRight ? index-- : ++index < length)) {
          var key = props[index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` and invokes it with the `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to bind.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new bound function.
     */
    function createBindWrapper(func, thisArg) {
      var Ctor = createCtorWrapper(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(thisArg, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a `Set` cache object to optimize linear searches of large arrays.
     *
     * @private
     * @param {Array} [values] The values to cache.
     * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
     */
    function createCache(values) {
      return (nativeCreate && Set) ? new SetCache(values) : null;
    }

    /**
     * Creates a function that produces compound words out of the words in a
     * given string.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        var index = -1,
            array = words(deburr(string)),
            length = array.length,
            result = '';

        while (++index < length) {
          result = callback(result, array[index], index);
        }
        return result;
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtorWrapper(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors.
        // See http://ecma-international.org/ecma-262/6.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a `_.curry` or `_.curryRight` function.
     *
     * @private
     * @param {boolean} flag The curry bit flag.
     * @returns {Function} Returns the new curry function.
     */
    function createCurry(flag) {
      function curryFunc(func, arity, guard) {
        if (guard && isIterateeCall(func, arity, guard)) {
          arity = undefined;
        }
        var result = createWrapper(func, flag, undefined, undefined, undefined, undefined, undefined, arity);
        result.placeholder = curryFunc.placeholder;
        return result;
      }
      return curryFunc;
    }

    /**
     * Creates a `_.defaults` or `_.defaultsDeep` function.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Function} Returns the new defaults function.
     */
    function createDefaults(assigner, customizer) {
      return restParam(function(args) {
        var object = args[0];
        if (object == null) {
          return object;
        }
        args.push(customizer);
        return assigner.apply(undefined, args);
      });
    }

    /**
     * Creates a `_.max` or `_.min` function.
     *
     * @private
     * @param {Function} comparator The function used to compare values.
     * @param {*} exValue The initial extremum value.
     * @returns {Function} Returns the new extremum function.
     */
    function createExtremum(comparator, exValue) {
      return function(collection, iteratee, thisArg) {
        if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
          iteratee = undefined;
        }
        iteratee = getCallback(iteratee, thisArg, 3);
        if (iteratee.length == 1) {
          collection = isArray(collection) ? collection : toIterable(collection);
          var result = arrayExtremum(collection, iteratee, comparator, exValue);
          if (!(collection.length && result === exValue)) {
            return result;
          }
        }
        return baseExtremum(collection, iteratee, comparator, exValue);
      };
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new find function.
     */
    function createFind(eachFunc, fromRight) {
      return function(collection, predicate, thisArg) {
        predicate = getCallback(predicate, thisArg, 3);
        if (isArray(collection)) {
          var index = baseFindIndex(collection, predicate, fromRight);
          return index > -1 ? collection[index] : undefined;
        }
        return baseFind(collection, predicate, eachFunc);
      };
    }

    /**
     * Creates a `_.findIndex` or `_.findLastIndex` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new find function.
     */
    function createFindIndex(fromRight) {
      return function(array, predicate, thisArg) {
        if (!(array && array.length)) {
          return -1;
        }
        predicate = getCallback(predicate, thisArg, 3);
        return baseFindIndex(array, predicate, fromRight);
      };
    }

    /**
     * Creates a `_.findKey` or `_.findLastKey` function.
     *
     * @private
     * @param {Function} objectFunc The function to iterate over an object.
     * @returns {Function} Returns the new find function.
     */
    function createFindKey(objectFunc) {
      return function(object, predicate, thisArg) {
        predicate = getCallback(predicate, thisArg, 3);
        return baseFind(object, predicate, objectFunc, true);
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return function() {
        var wrapper,
            length = arguments.length,
            index = fromRight ? length : -1,
            leftIndex = 0,
            funcs = Array(length);

        while ((fromRight ? index-- : ++index < length)) {
          var func = funcs[leftIndex++] = arguments[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (!wrapper && LodashWrapper.prototype.thru && getFuncName(func) == 'wrapper') {
            wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? -1 : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) && data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) && !data[4].length && data[9] == 1) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func)) ? wrapper[funcName]() : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value) && value.length >= LARGE_ARRAY_SIZE) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      };
    }

    /**
     * Creates a function for `_.forEach` or `_.forEachRight`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over an array.
     * @param {Function} eachFunc The function to iterate over a collection.
     * @returns {Function} Returns the new each function.
     */
    function createForEach(arrayFunc, eachFunc) {
      return function(collection, iteratee, thisArg) {
        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
          ? arrayFunc(collection, iteratee)
          : eachFunc(collection, bindCallback(iteratee, thisArg, 3));
      };
    }

    /**
     * Creates a function for `_.forIn` or `_.forInRight`.
     *
     * @private
     * @param {Function} objectFunc The function to iterate over an object.
     * @returns {Function} Returns the new each function.
     */
    function createForIn(objectFunc) {
      return function(object, iteratee, thisArg) {
        if (typeof iteratee != 'function' || thisArg !== undefined) {
          iteratee = bindCallback(iteratee, thisArg, 3);
        }
        return objectFunc(object, iteratee, keysIn);
      };
    }

    /**
     * Creates a function for `_.forOwn` or `_.forOwnRight`.
     *
     * @private
     * @param {Function} objectFunc The function to iterate over an object.
     * @returns {Function} Returns the new each function.
     */
    function createForOwn(objectFunc) {
      return function(object, iteratee, thisArg) {
        if (typeof iteratee != 'function' || thisArg !== undefined) {
          iteratee = bindCallback(iteratee, thisArg, 3);
        }
        return objectFunc(object, iteratee);
      };
    }

    /**
     * Creates a function for `_.mapKeys` or `_.mapValues`.
     *
     * @private
     * @param {boolean} [isMapKeys] Specify mapping keys instead of values.
     * @returns {Function} Returns the new map function.
     */
    function createObjectMapper(isMapKeys) {
      return function(object, iteratee, thisArg) {
        var result = {};
        iteratee = getCallback(iteratee, thisArg, 3);

        baseForOwn(object, function(value, key, object) {
          var mapped = iteratee(value, key, object);
          key = isMapKeys ? mapped : key;
          value = isMapKeys ? value : mapped;
          result[key] = value;
        });
        return result;
      };
    }

    /**
     * Creates a function for `_.padLeft` or `_.padRight`.
     *
     * @private
     * @param {boolean} [fromRight] Specify padding from the right.
     * @returns {Function} Returns the new pad function.
     */
    function createPadDir(fromRight) {
      return function(string, length, chars) {
        string = baseToString(string);
        return (fromRight ? string : '') + createPadding(string, length, chars) + (fromRight ? '' : string);
      };
    }

    /**
     * Creates a `_.partial` or `_.partialRight` function.
     *
     * @private
     * @param {boolean} flag The partial bit flag.
     * @returns {Function} Returns the new partial function.
     */
    function createPartial(flag) {
      var partialFunc = restParam(function(func, partials) {
        var holders = replaceHolders(partials, partialFunc.placeholder);
        return createWrapper(func, flag, undefined, partials, holders);
      });
      return partialFunc;
    }

    /**
     * Creates a function for `_.reduce` or `_.reduceRight`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over an array.
     * @param {Function} eachFunc The function to iterate over a collection.
     * @returns {Function} Returns the new each function.
     */
    function createReduce(arrayFunc, eachFunc) {
      return function(collection, iteratee, accumulator, thisArg) {
        var initFromArray = arguments.length < 3;
        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
          ? arrayFunc(collection, iteratee, accumulator, initFromArray)
          : baseReduce(collection, getCallback(iteratee, thisArg, 4), accumulator, initFromArray, eachFunc);
      };
    }

    /**
     * Creates a function that wraps `func` and invokes it with optional `this`
     * binding of, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to reference.
     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & ARY_FLAG,
          isBind = bitmask & BIND_FLAG,
          isBindKey = bitmask & BIND_KEY_FLAG,
          isCurry = bitmask & CURRY_FLAG,
          isCurryBound = bitmask & CURRY_BOUND_FLAG,
          isCurryRight = bitmask & CURRY_RIGHT_FLAG,
          Ctor = isBindKey ? undefined : createCtorWrapper(func);

      function wrapper() {
        // Avoid `arguments` object use disqualifying optimizations by
        // converting it to an array before providing it to other functions.
        var length = arguments.length,
            index = length,
            args = Array(length);

        while (index--) {
          args[index] = arguments[index];
        }
        if (partials) {
          args = composeArgs(args, partials, holders);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight);
        }
        if (isCurry || isCurryRight) {
          var placeholder = wrapper.placeholder,
              argsHolders = replaceHolders(args, placeholder);

          length -= argsHolders.length;
          if (length < arity) {
            var newArgPos = argPos ? arrayCopy(argPos) : undefined,
                newArity = nativeMax(arity - length, 0),
                newsHolders = isCurry ? argsHolders : undefined,
                newHoldersRight = isCurry ? undefined : argsHolders,
                newPartials = isCurry ? args : undefined,
                newPartialsRight = isCurry ? undefined : args;

            bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
            bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);

            if (!isCurryBound) {
              bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
            }
            var newData = [func, bitmask, thisArg, newPartials, newsHolders, newPartialsRight, newHoldersRight, newArgPos, ary, newArity],
                result = createHybridWrapper.apply(undefined, newData);

            if (isLaziable(func)) {
              setData(result, newData);
            }
            result.placeholder = placeholder;
            return result;
          }
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        if (argPos) {
          args = reorder(args, argPos);
        }
        if (isAry && ary < args.length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtorWrapper(func);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates the padding required for `string` based on the given `length`.
     * The `chars` string is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {string} string The string to create padding for.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the pad for `string`.
     */
    function createPadding(string, length, chars) {
      var strLength = string.length;
      length = +length;

      if (strLength >= length || !nativeIsFinite(length)) {
        return '';
      }
      var padLength = length - strLength;
      chars = chars == null ? ' ' : (chars + '');
      return repeat(chars, nativeCeil(padLength / chars.length)).slice(0, padLength);
    }

    /**
     * Creates a function that wraps `func` and invokes it with the optional `this`
     * binding of `thisArg` and the `partials` prepended to those provided to
     * the wrapper.
     *
     * @private
     * @param {Function} func The function to partially apply arguments to.
     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to the new function.
     * @returns {Function} Returns the new bound function.
     */
    function createPartialWrapper(func, bitmask, thisArg, partials) {
      var isBind = bitmask & BIND_FLAG,
          Ctor = createCtorWrapper(func);

      function wrapper() {
        // Avoid `arguments` object use disqualifying optimizations by
        // converting it to an array before providing it `func`.
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength);

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.ceil`, `_.floor`, or `_.round` function.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        precision = precision === undefined ? 0 : (+precision || 0);
        if (precision) {
          precision = pow(10, precision);
          return func(number * precision) / precision;
        }
        return func(number);
      };
    }

    /**
     * Creates a `_.sortedIndex` or `_.sortedLastIndex` function.
     *
     * @private
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {Function} Returns the new index function.
     */
    function createSortedIndex(retHighest) {
      return function(array, value, iteratee, thisArg) {
        var callback = getCallback(iteratee);
        return (iteratee == null && callback === baseCallback)
          ? binaryIndex(array, value, retHighest)
          : binaryIndexBy(array, value, callback(iteratee, thisArg, 1), retHighest);
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to reference.
     * @param {number} bitmask The bitmask of flags.
     *  The bitmask may be composed of the following flags:
     *     1 - `_.bind`
     *     2 - `_.bindKey`
     *     4 - `_.curry` or `_.curryRight` of a bound function
     *     8 - `_.curry`
     *    16 - `_.curryRight`
     *    32 - `_.partial`
     *    64 - `_.partialRight`
     *   128 - `_.rearg`
     *   256 - `_.ary`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      length -= (holders ? holders.length : 0);
      if (bitmask & PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func),
          newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];

      if (data) {
        mergeData(newData, data);
        bitmask = newData[1];
        arity = newData[9];
      }
      newData[9] = arity == null
        ? (isBindKey ? 0 : func.length)
        : (nativeMax(arity - length, 0) || 0);

      if (bitmask == BIND_FLAG) {
        var result = createBindWrapper(newData[0], newData[2]);
      } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !newData[4].length) {
        result = createPartialWrapper.apply(undefined, newData);
      } else {
        result = createHybridWrapper.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setter(result, newData);
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparing arrays.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA] Tracks traversed `value` objects.
     * @param {Array} [stackB] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
      var index = -1,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
        return false;
      }
      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index],
            result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;

        if (result !== undefined) {
          if (result) {
            continue;
          }
          return false;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (isLoose) {
          if (!arraySome(other, function(othValue) {
                return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
              })) {
            return false;
          }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
          return false;
        }
      }
      return true;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag) {
      switch (tag) {
        case boolTag:
        case dateTag:
          // Coerce dates and booleans to numbers, dates to milliseconds and booleans
          // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
          return +object == +other;

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case numberTag:
          // Treat `NaN` vs. `NaN` as equal.
          return (object != +object)
            ? other != +other
            : object == +other;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings primitives and string
          // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
          return object == (other + '');
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparing values.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA] Tracks traversed `value` objects.
     * @param {Array} [stackB] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
      var objProps = keys(object),
          objLength = objProps.length,
          othProps = keys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isLoose) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      var skipCtor = isLoose;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key],
            result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;

        // Recursively compare objects (susceptible to call stack limits).
        if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
          return false;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (!skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Gets the appropriate "callback" function. If the `_.callback` method is
     * customized this function returns the custom method, otherwise it returns
     * the `baseCallback` function. If arguments are provided the chosen function
     * is invoked with them and its result is returned.
     *
     * @private
     * @returns {Function} Returns the chosen function or its result.
     */
    function getCallback(func, thisArg, argCount) {
      var result = lodash.callback || callback;
      result = result === callback ? baseCallback : result;
      return argCount ? result(func, thisArg, argCount) : result;
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = func.name,
          array = realNames[result],
          length = array ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the appropriate "indexOf" function. If the `_.indexOf` method is
     * customized this function returns the custom method, otherwise it returns
     * the `baseIndexOf` function. If arguments are provided the chosen function
     * is invoked with them and its result is returned.
     *
     * @private
     * @returns {Function|number} Returns the chosen function or its result.
     */
    function getIndexOf(collection, target, fromIndex) {
      var result = lodash.indexOf || indexOf;
      result = result === indexOf ? baseIndexOf : result;
      return collection ? result(collection, target, fromIndex) : result;
    }

    /**
     * Gets the "length" property value of `object`.
     *
     * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
     * that affects Safari on at least iOS 8.1-8.3 ARM64.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {*} Returns the "length" value.
     */
    var getLength = baseProperty('length');

    /**
     * Gets the propery names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = pairs(object),
          length = result.length;

      while (length--) {
        result[length][2] = isStrictComparable(result[length][1]);
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = object == null ? undefined : object[key];
      return isNative(value) ? value : undefined;
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add array properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      var Ctor = object.constructor;
      if (!(typeof Ctor == 'function' && Ctor instanceof Ctor)) {
        Ctor = Object;
      }
      return new Ctor;
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return bufferClone(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          var buffer = object.buffer;
          return new Ctor(isDeep ? bufferClone(buffer) : buffer, object.byteOffset, object.length);

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          var result = new Ctor(object.source, reFlags.exec(object));
          result.lastIndex = object.lastIndex;
      }
      return result;
    }

    /**
     * Invokes the method at `path` on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function invokePath(object, path, args) {
      if (object != null && !isKey(path, object)) {
        path = toPath(path);
        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
        path = last(path);
      }
      var func = object == null ? object : object[path];
      return func == null ? undefined : func.apply(object, args);
    }

    /**
     * Checks if `value` is array-like.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     */
    function isArrayLike(value) {
      return value != null && isLength(getLength(value));
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
      length = length == null ? MAX_SAFE_INTEGER : length;
      return value > -1 && value % 1 == 0 && value < length;
    }

    /**
     * Checks if the provided arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
          ? (isArrayLike(object) && isIndex(index, object.length))
          : (type == 'string' && index in object)) {
        var other = object[index];
        return value === value ? (value === other) : (other !== other);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      var type = typeof value;
      if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
        return true;
      }
      if (isArray(value)) {
        return false;
      }
      var result = !reIsDeepProp.test(value);
      return result || (object != null && value in toObject(object));
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart, else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func);
      if (!(funcName in LazyWrapper.prototype)) {
        return false;
      }
      var other = lodash[funcName];
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     */
    function isLength(value) {
      return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers required to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and `_.rearg`
     * augment function arguments, making the order in which they are executed important,
     * preventing the merging of metadata. However, we make an exception for a safe
     * common case where curried functions have `_.ary` and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < ARY_FLAG;

      var isCombo =
        (srcBitmask == ARY_FLAG && bitmask == CURRY_FLAG) ||
        (srcBitmask == ARY_FLAG && bitmask == REARG_FLAG && data[7].length <= source[8]) ||
        (srcBitmask == (ARY_FLAG | REARG_FLAG) && bitmask == CURRY_FLAG);

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= (bitmask & BIND_FLAG) ? 0 : CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : arrayCopy(value);
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : arrayCopy(source[4]);
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : arrayCopy(value);
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : arrayCopy(source[6]);
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = arrayCopy(value);
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use.
     *
     * @private
     * @param {*} objectValue The destination object property value.
     * @param {*} sourceValue The source object property value.
     * @returns {*} Returns the value to assign to the destination object.
     */
    function mergeDefaults(objectValue, sourceValue) {
      return objectValue === undefined ? sourceValue : merge(objectValue, sourceValue, mergeDefaults);
    }

    /**
     * A specialized version of `_.pick` which picks `object` properties specified
     * by `props`.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} props The property names to pick.
     * @returns {Object} Returns the new object.
     */
    function pickByArray(object, props) {
      object = toObject(object);

      var index = -1,
          length = props.length,
          result = {};

      while (++index < length) {
        var key = props[index];
        if (key in object) {
          result[key] = object[key];
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.pick` which picks `object` properties `predicate`
     * returns truthy for.
     *
     * @private
     * @param {Object} object The source object.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Object} Returns the new object.
     */
    function pickByCallback(object, predicate) {
      var result = {};
      baseForIn(object, function(value, key, object) {
        if (predicate(value, key, object)) {
          result[key] = value;
        }
      });
      return result;
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = arrayCopy(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity function
     * to avoid garbage collection pauses in V8. See [V8 issue 2070](https://code.google.com/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = (function() {
      var count = 0,
          lastCalled = 0;

      return function(key, value) {
        var stamp = now(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return key;
          }
        } else {
          count = 0;
        }
        return baseSetData(key, value);
      };
    }());

    /**
     * A fallback implementation of `Object.keys` which creates an array of the
     * own enumerable property names of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function shimKeys(object) {
      var props = keysIn(object),
          propsLength = props.length,
          length = propsLength && object.length;

      var allowIndexes = !!length && isLength(length) &&
        (isArray(object) || isArguments(object));

      var index = -1,
          result = [];

      while (++index < propsLength) {
        var key = props[index];
        if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to an array-like object if it's not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Array|Object} Returns the array-like object.
     */
    function toIterable(value) {
      if (value == null) {
        return [];
      }
      if (!isArrayLike(value)) {
        return values(value);
      }
      return isObject(value) ? value : Object(value);
    }

    /**
     * Converts `value` to an object if it's not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Object} Returns the object.
     */
    function toObject(value) {
      return isObject(value) ? value : Object(value);
    }

    /**
     * Converts `value` to property path array if it's not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Array} Returns the property path array.
     */
    function toPath(value) {
      if (isArray(value)) {
        return value;
      }
      var result = [];
      baseToString(value).replace(rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      return wrapper instanceof LazyWrapper
        ? wrapper.clone()
        : new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__, arrayCopy(wrapper.__actions__));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `collection` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the new array containing chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if (guard ? isIterateeCall(array, size, guard) : size == null) {
        size = 1;
      } else {
        size = nativeMax(nativeFloor(size) || 1, 1);
      }
      var index = 0,
          length = array ? array.length : 0,
          resIndex = -1,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[++resIndex] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array ? array.length : 0,
          resIndex = -1,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[++resIndex] = value;
        }
      }
      return result;
    }

    /**
     * Creates an array of unique `array` values not included in the other
     * provided arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The arrays of values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.difference([1, 2, 3], [4, 2]);
     * // => [1, 3]
     */
    var difference = restParam(function(array, values) {
      return (isObjectLike(array) && isArrayLike(array))
        ? baseDifference(array, baseFlatten(values, false, true))
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      return baseSlice(array, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      n = length - (+n || 0);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * bound to `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that match the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRightWhile([1, 2, 3], function(n) {
     *   return n > 1;
     * });
     * // => [1]
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.dropRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
     * // => ['barney', 'fred']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.dropRightWhile(users, 'active', false), 'user');
     * // => ['barney']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.dropRightWhile(users, 'active'), 'user');
     * // => ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * bound to `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropWhile([1, 2, 3], function(n) {
     *   return n < 3;
     * });
     * // => [3]
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.dropWhile(users, { 'user': 'barney', 'active': false }), 'user');
     * // => ['fred', 'pebbles']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.dropWhile(users, 'active', false), 'user');
     * // => ['pebbles']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.dropWhile(users, 'active'), 'user');
     * // => ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8], '*', 1, 2);
     * // => [4, '*', 8]
     */
    function fill(array, value, start, end) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(chr) {
     *   return chr.user == 'barney';
     * });
     * // => 0
     *
     * // using the `_.matches` callback shorthand
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findIndex(users, 'active', false);
     * // => 0
     *
     * // using the `_.property` callback shorthand
     * _.findIndex(users, 'active');
     * // => 2
     */
    var findIndex = createFindIndex();

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(chr) {
     *   return chr.user == 'pebbles';
     * });
     * // => 2
     *
     * // using the `_.matches` callback shorthand
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findLastIndex(users, 'active', false);
     * // => 2
     *
     * // using the `_.property` callback shorthand
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    var findLastIndex = createFindIndex(true);

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @alias head
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.first([1, 2, 3]);
     * // => 1
     *
     * _.first([]);
     * // => undefined
     */
    function first(array) {
      return array ? array[0] : undefined;
    }

    /**
     * Flattens a nested array. If `isDeep` is `true` the array is recursively
     * flattened, otherwise it is only flattened a single level.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {boolean} [isDeep] Specify a deep flatten.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, 3, [4]]]);
     * // => [1, 2, 3, [4]]
     *
     * // using `isDeep`
     * _.flatten([1, [2, 3, [4]]], true);
     * // => [1, 2, 3, 4]
     */
    function flatten(array, isDeep, guard) {
      var length = array ? array.length : 0;
      if (guard && isIterateeCall(array, isDeep, guard)) {
        isDeep = false;
      }
      return length ? baseFlatten(array, isDeep) : [];
    }

    /**
     * Recursively flattens a nested array.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to recursively flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, 3, [4]]]);
     * // => [1, 2, 3, 4]
     */
    function flattenDeep(array) {
      var length = array ? array.length : 0;
      return length ? baseFlatten(array, true) : [];
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
     * from the end of `array`. If `array` is sorted providing `true` for `fromIndex`
     * performs a faster binary search.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {*} value The value to search for.
     * @param {boolean|number} [fromIndex=0] The index to search from or `true`
     *  to perform a binary search on a sorted array.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // using `fromIndex`
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     *
     * // performing a binary search
     * _.indexOf([1, 1, 2, 2], 2, true);
     * // => 2
     */
    function indexOf(array, value, fromIndex) {
      var length = array ? array.length : 0;
      if (!length) {
        return -1;
      }
      if (typeof fromIndex == 'number') {
        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : fromIndex;
      } else if (fromIndex) {
        var index = binaryIndex(array, value);
        if (index < length &&
            (value === value ? (value === array[index]) : (array[index] !== array[index]))) {
          return index;
        }
        return -1;
      }
      return baseIndexOf(array, value, fromIndex || 0);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      return dropRight(array, 1);
    }

    /**
     * Creates an array of unique values that are included in all of the provided
     * arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of shared values.
     * @example
     * _.intersection([1, 2], [4, 2], [2, 1]);
     * // => [2]
     */
    var intersection = restParam(function(arrays) {
      var othLength = arrays.length,
          othIndex = othLength,
          caches = Array(length),
          indexOf = getIndexOf(),
          isCommon = indexOf == baseIndexOf,
          result = [];

      while (othIndex--) {
        var value = arrays[othIndex] = isArrayLike(value = arrays[othIndex]) ? value : [];
        caches[othIndex] = (isCommon && value.length >= 120) ? createCache(othIndex && value) : null;
      }
      var array = arrays[0],
          index = -1,
          length = array ? array.length : 0,
          seen = caches[0];

      outer:
      while (++index < length) {
        value = array[index];
        if ((seen ? cacheIndexOf(seen, value) : indexOf(result, value, 0)) < 0) {
          var othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if ((cache ? cacheIndexOf(cache, value) : indexOf(arrays[othIndex], value, 0)) < 0) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(value);
          }
          result.push(value);
        }
      }
      return result;
    });

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array ? array.length : 0;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {*} value The value to search for.
     * @param {boolean|number} [fromIndex=array.length-1] The index to search from
     *  or `true` to perform a binary search on a sorted array.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // using `fromIndex`
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     *
     * // performing a binary search
     * _.lastIndexOf([1, 1, 2, 2], 2, true);
     * // => 3
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array ? array.length : 0;
      if (!length) {
        return -1;
      }
      var index = length;
      if (typeof fromIndex == 'number') {
        index = (fromIndex < 0 ? nativeMax(length + fromIndex, 0) : nativeMin(fromIndex || 0, length - 1)) + 1;
      } else if (fromIndex) {
        index = binaryIndex(array, value, true) - 1;
        var other = array[index];
        if (value === value ? (value === other) : (other !== other)) {
          return index;
        }
        return -1;
      }
      if (value !== value) {
        return indexOfNaN(array, index, true);
      }
      while (index--) {
        if (array[index] === value) {
          return index;
        }
      }
      return -1;
    }

    /**
     * Removes all provided values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3, 1, 2, 3];
     *
     * _.pull(array, 2, 3);
     * console.log(array);
     * // => [1, 1]
     */
    function pull() {
      var args = arguments,
          array = args[0];

      if (!(array && array.length)) {
        return array;
      }
      var index = 0,
          indexOf = getIndexOf(),
          length = args.length;

      while (++index < length) {
        var fromIndex = 0,
            value = args[index];

        while ((fromIndex = indexOf(array, value, fromIndex)) > -1) {
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * Removes elements from `array` corresponding to the given indexes and returns
     * an array of the removed elements. Indexes may be specified as an array of
     * indexes or as individual arguments.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove,
     *  specified as individual indexes or arrays of indexes.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [5, 10, 15, 20];
     * var evens = _.pullAt(array, 1, 3);
     *
     * console.log(array);
     * // => [5, 15]
     *
     * console.log(evens);
     * // => [10, 20]
     */
    var pullAt = restParam(function(array, indexes) {
      indexes = baseFlatten(indexes);

      var result = baseAt(array, indexes);
      basePullAt(array, indexes.sort(baseCompareAscending));
      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is bound to
     * `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate, thisArg) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getCallback(predicate, thisArg, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @alias tail
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.rest([1, 2, 3]);
     * // => [2, 3]
     */
    function rest(array) {
      return drop(array, 1);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of `Array#slice` to support node
     * lists in IE < 9 and to ensure dense arrays are returned.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value` should
     * be inserted into `array` in order to maintain its sort order. If an iteratee
     * function is provided it is invoked for `value` and each element of `array`
     * to compute their sort ranking. The iteratee is bound to `thisArg` and
     * invoked with one argument; (value).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     *
     * _.sortedIndex([4, 4, 5, 5], 5);
     * // => 2
     *
     * var dict = { 'data': { 'thirty': 30, 'forty': 40, 'fifty': 50 } };
     *
     * // using an iteratee function
     * _.sortedIndex(['thirty', 'fifty'], 'forty', function(word) {
     *   return this.data[word];
     * }, dict);
     * // => 1
     *
     * // using the `_.property` callback shorthand
     * _.sortedIndex([{ 'x': 30 }, { 'x': 50 }], { 'x': 40 }, 'x');
     * // => 1
     */
    var sortedIndex = createSortedIndex();

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 4, 5, 5], 5);
     * // => 4
     */
    var sortedLastIndex = createSortedIndex(true);

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      n = length - (+n || 0);
      return baseSlice(array, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is bound to `thisArg`
     * and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRightWhile([1, 2, 3], function(n) {
     *   return n > 1;
     * });
     * // => [2, 3]
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.takeRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
     * // => ['pebbles']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.takeRightWhile(users, 'active', false), 'user');
     * // => ['fred', 'pebbles']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.takeRightWhile(users, 'active'), 'user');
     * // => []
     */
    function takeRightWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is bound to
     * `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeWhile([1, 2, 3], function(n) {
     *   return n < 3;
     * });
     * // => [1, 2]
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false},
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.takeWhile(users, { 'user': 'barney', 'active': false }), 'user');
     * // => ['barney']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.takeWhile(users, 'active', false), 'user');
     * // => ['barney', 'fred']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.takeWhile(users, 'active'), 'user');
     * // => []
     */
    function takeWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all of the provided arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([1, 2], [4, 2], [2, 1]);
     * // => [1, 2, 4]
     */
    var union = restParam(function(arrays) {
      return baseUniq(baseFlatten(arrays, false, true));
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurence of each element
     * is kept. Providing `true` for `isSorted` performs a faster search algorithm
     * for sorted arrays. If an iteratee function is provided it is invoked for
     * each element in the array to generate the criterion by which uniqueness
     * is computed. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index, array).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias unique
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {boolean} [isSorted] Specify the array is sorted.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new duplicate-value-free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     *
     * // using `isSorted`
     * _.uniq([1, 1, 2], true);
     * // => [1, 2]
     *
     * // using an iteratee function
     * _.uniq([1, 2.5, 1.5, 2], function(n) {
     *   return this.floor(n);
     * }, Math);
     * // => [1, 2.5]
     *
     * // using the `_.property` callback shorthand
     * _.uniq([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniq(array, isSorted, iteratee, thisArg) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (isSorted != null && typeof isSorted != 'boolean') {
        thisArg = iteratee;
        iteratee = isIterateeCall(array, isSorted, thisArg) ? undefined : isSorted;
        isSorted = false;
      }
      var callback = getCallback();
      if (!(iteratee == null && callback === baseCallback)) {
        iteratee = callback(iteratee, thisArg, 3);
      }
      return (isSorted && getIndexOf() == baseIndexOf)
        ? sortedUniq(array, iteratee)
        : baseUniq(array, iteratee);
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['fred', 'barney'], [30, 40], [true, false]);
     * // => [['fred', 30, true], ['barney', 40, false]]
     *
     * _.unzip(zipped);
     * // => [['fred', 'barney'], [30, 40], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var index = -1,
          length = 0;

      array = arrayFilter(array, function(group) {
        if (isArrayLike(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      var result = Array(length);
      while (++index < length) {
        result[index] = arrayMap(array, baseProperty(index));
      }
      return result;
    }

    /**
     * This method is like `_.unzip` except that it accepts an iteratee to specify
     * how regrouped values should be combined. The `iteratee` is bound to `thisArg`
     * and invoked with four arguments: (accumulator, value, index, group).
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee] The function to combine regrouped values.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee, thisArg) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      iteratee = bindCallback(iteratee, thisArg, 4);
      return arrayMap(result, function(group) {
        return arrayReduce(group, iteratee, undefined, true);
      });
    }

    /**
     * Creates an array excluding all provided values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to filter.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.without([1, 2, 1, 3], 1, 2);
     * // => [3]
     */
    var without = restParam(function(array, values) {
      return isArrayLike(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the provided arrays.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of values.
     * @example
     *
     * _.xor([1, 2], [4, 2]);
     * // => [1, 4]
     */
    function xor() {
      var index = -1,
          length = arguments.length;

      while (++index < length) {
        var array = arguments[index];
        if (isArrayLike(array)) {
          var result = result
            ? arrayPush(baseDifference(result, array), baseDifference(array, result))
            : array;
        }
      }
      return result ? baseUniq(result) : [];
    }

    /**
     * Creates an array of grouped elements, the first of which contains the first
     * elements of the given arrays, the second of which contains the second elements
     * of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['fred', 'barney'], [30, 40], [true, false]);
     * // => [['fred', 30, true], ['barney', 40, false]]
     */
    var zip = restParam(unzip);

    /**
     * The inverse of `_.pairs`; this method returns an object composed from arrays
     * of property names and values. Provide either a single two dimensional array,
     * e.g. `[[key1, value1], [key2, value2]]` or two arrays, one of property names
     * and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @alias object
     * @category Array
     * @param {Array} props The property names.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject([['fred', 30], ['barney', 40]]);
     * // => { 'fred': 30, 'barney': 40 }
     *
     * _.zipObject(['fred', 'barney'], [30, 40]);
     * // => { 'fred': 30, 'barney': 40 }
     */
    function zipObject(props, values) {
      var index = -1,
          length = props ? props.length : 0,
          result = {};

      if (length && !values && !isArray(props[0])) {
        values = [];
      }
      while (++index < length) {
        var key = props[index];
        if (values) {
          result[key] = values[index];
        } else if (key) {
          result[key[0]] = key[1];
        }
      }
      return result;
    }

    /**
     * This method is like `_.zip` except that it accepts an iteratee to specify
     * how grouped values should be combined. The `iteratee` is bound to `thisArg`
     * and invoked with four arguments: (accumulator, value, index, group).
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee] The function to combine grouped values.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], _.add);
     * // => [111, 222]
     */
    var zipWith = restParam(function(arrays) {
      var length = arrays.length,
          iteratee = length > 2 ? arrays[length - 2] : undefined,
          thisArg = length > 1 ? arrays[length - 1] : undefined;

      if (length > 2 && typeof iteratee == 'function') {
        length -= 2;
      } else {
        iteratee = (length > 1 && typeof thisArg == 'function') ? (--length, thisArg) : undefined;
        thisArg = undefined;
      }
      arrays.length = length;
      return unzipWith(arrays, iteratee, thisArg);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object that wraps `value` with explicit method
     * chaining enabled.
     *
     * @static
     * @memberOf _
     * @category Chain
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _.chain(users)
     *   .sortBy('age')
     *   .map(function(chr) {
     *     return chr.user + ' is ' + chr.age;
     *   })
     *   .first()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor is
     * bound to `thisArg` and invoked with one argument; (value). The purpose of
     * this method is to "tap into" a method chain in order to perform operations
     * on intermediate results within the chain.
     *
     * @static
     * @memberOf _
     * @category Chain
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @param {*} [thisArg] The `this` binding of `interceptor`.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor, thisArg) {
      interceptor.call(thisArg, value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     *
     * @static
     * @memberOf _
     * @category Chain
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @param {*} [thisArg] The `this` binding of `interceptor`.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor, thisArg) {
      return interceptor.call(thisArg, value);
    }

    /**
     * Enables explicit method chaining on the wrapper object.
     *
     * @name chain
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // without explicit chaining
     * _(users).first();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // with explicit chaining
     * _(users).chain()
     *   .first()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chained sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Creates a new array joining a wrapped array with any additional arrays
     * and/or values.
     *
     * @name concat
     * @memberOf _
     * @category Chain
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var wrapped = _(array).concat(2, [3], [[4]]);
     *
     * console.log(wrapped.value());
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    var wrapperConcat = restParam(function(values) {
      values = baseFlatten(values);
      return this.thru(function(array) {
        return arrayConcat(isArray(array) ? array : [toObject(array)], values);
      });
    });

    /**
     * Creates a clone of the chained sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).map(function(value) {
     *   return Math.pow(value, 2);
     * });
     *
     * var other = [3, 4];
     * var otherWrapped = wrapped.plant(other);
     *
     * otherWrapped.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * Reverses the wrapped array so the first element becomes the last, the
     * second element becomes the second to last, and so on.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new reversed `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;

      var interceptor = function(value) {
        return (wrapped && wrapped.__dir__ < 0) ? value : value.reverse();
      };
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(interceptor);
    }

    /**
     * Produces the result of coercing the unwrapped value to a string.
     *
     * @name toString
     * @memberOf _
     * @category Chain
     * @returns {string} Returns the coerced string value.
     * @example
     *
     * _([1, 2, 3]).toString();
     * // => '1,2,3'
     */
    function wrapperToString() {
      return (this.value() + '');
    }

    /**
     * Executes the chained sequence to extract the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @alias run, toJSON, valueOf
     * @category Chain
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements corresponding to the given keys, or indexes,
     * of `collection`. Keys may be specified as individual arguments or as arrays
     * of keys.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {...(number|number[]|string|string[])} [props] The property names
     *  or indexes of elements to pick, specified individually or in arrays.
     * @returns {Array} Returns the new array of picked elements.
     * @example
     *
     * _.at(['a', 'b', 'c'], [0, 2]);
     * // => ['a', 'c']
     *
     * _.at(['barney', 'fred', 'pebbles'], 0, 2);
     * // => ['barney', 'pebbles']
     */
    var at = restParam(function(collection, props) {
      return baseAt(collection, baseFlatten(props));
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through `iteratee`. The corresponding value
     * of each key is the number of times the key was returned by `iteratee`.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([4.3, 6.1, 6.4], function(n) {
     *   return Math.floor(n);
     * });
     * // => { '4': 1, '6': 2 }
     *
     * _.countBy([4.3, 6.1, 6.4], function(n) {
     *   return this.floor(n);
     * }, Math);
     * // => { '4': 1, '6': 2 }
     *
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      hasOwnProperty.call(result, key) ? ++result[key] : (result[key] = 1);
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * The predicate is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias all
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'active': false },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.every(users, 'active', false);
     * // => true
     *
     * // using the `_.property` callback shorthand
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, thisArg) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
        predicate = undefined;
      }
      if (typeof predicate != 'function' || thisArg !== undefined) {
        predicate = getCallback(predicate, thisArg, 3);
      }
      return func(collection, predicate);
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
     * invoked with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias select
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the new filtered array.
     * @example
     *
     * _.filter([4, 5, 6], function(n) {
     *   return n % 2 == 0;
     * });
     * // => [4, 6]
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.filter(users, { 'age': 36, 'active': true }), 'user');
     * // => ['barney']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.filter(users, 'active', false), 'user');
     * // => ['fred']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.filter(users, 'active'), 'user');
     * // => ['barney']
     */
    function filter(collection, predicate, thisArg) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      predicate = getCallback(predicate, thisArg, 3);
      return func(collection, predicate);
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
     * invoked with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias detect
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.result(_.find(users, function(chr) {
     *   return chr.age < 40;
     * }), 'user');
     * // => 'barney'
     *
     * // using the `_.matches` callback shorthand
     * _.result(_.find(users, { 'age': 1, 'active': true }), 'user');
     * // => 'pebbles'
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.result(_.find(users, 'active', false), 'user');
     * // => 'fred'
     *
     * // using the `_.property` callback shorthand
     * _.result(_.find(users, 'active'), 'user');
     * // => 'barney'
     */
    var find = createFind(baseEach);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(baseEachRight, true);

    /**
     * Performs a deep comparison between each element in `collection` and the
     * source object, returning the first element that has equivalent property
     * values.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. For comparing a single
     * own or inherited property value see `_.matchesProperty`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Object} source The object of property values to match.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.result(_.findWhere(users, { 'age': 36, 'active': true }), 'user');
     * // => 'barney'
     *
     * _.result(_.findWhere(users, { 'age': 40, 'active': false }), 'user');
     * // => 'fred'
     */
    function findWhere(collection, source) {
      return find(collection, baseMatches(source));
    }

    /**
     * Iterates over elements of `collection` invoking `iteratee` for each element.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection). Iteratee functions may exit iteration early
     * by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length" property
     * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
     * may be used for object iteration.
     *
     * @static
     * @memberOf _
     * @alias each
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array|Object|string} Returns `collection`.
     * @example
     *
     * _([1, 2]).forEach(function(n) {
     *   console.log(n);
     * }).value();
     * // => logs each value from left to right and returns the array
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(n, key) {
     *   console.log(n, key);
     * });
     * // => logs each value-key pair and returns the object (iteration order is not guaranteed)
     */
    var forEach = createForEach(arrayEach, baseEach);

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @alias eachRight
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array|Object|string} Returns `collection`.
     * @example
     *
     * _([1, 2]).forEachRight(function(n) {
     *   console.log(n);
     * }).value();
     * // => logs each value from right to left and returns the array
     */
    var forEachRight = createForEach(arrayEachRight, baseEachRight);

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through `iteratee`. The corresponding value
     * of each key is an array of the elements responsible for generating the key.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([4.2, 6.1, 6.4], function(n) {
     *   return Math.floor(n);
     * });
     * // => { '4': [4.2], '6': [6.1, 6.4] }
     *
     * _.groupBy([4.2, 6.1, 6.4], function(n) {
     *   return this.floor(n);
     * }, Math);
     * // => { '4': [4.2], '6': [6.1, 6.4] }
     *
     * // using the `_.property` callback shorthand
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        result[key] = [value];
      }
    });

    /**
     * Checks if `value` is in `collection` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
     * from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @alias contains, include
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {*} target The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
     * @returns {boolean} Returns `true` if a matching element is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'user': 'fred', 'age': 40 }, 'fred');
     * // => true
     *
     * _.includes('pebbles', 'eb');
     * // => true
     */
    function includes(collection, target, fromIndex, guard) {
      var length = collection ? getLength(collection) : 0;
      if (!isLength(length)) {
        collection = values(collection);
        length = collection.length;
      }
      if (typeof fromIndex != 'number' || (guard && isIterateeCall(target, fromIndex, guard))) {
        fromIndex = 0;
      } else {
        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : (fromIndex || 0);
      }
      return (typeof collection == 'string' || !isArray(collection) && isString(collection))
        ? (fromIndex <= length && collection.indexOf(target, fromIndex) > -1)
        : (!!length && getIndexOf(collection, target, fromIndex) > -1);
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through `iteratee`. The corresponding value
     * of each key is the last element responsible for generating the key. The
     * iteratee function is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var keyData = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.indexBy(keyData, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     *
     * _.indexBy(keyData, function(object) {
     *   return String.fromCharCode(object.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.indexBy(keyData, function(object) {
     *   return this.fromCharCode(object.code);
     * }, String);
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     */
    var indexBy = createAggregator(function(result, value, key) {
      result[key] = value;
    });

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `methodName` is a function it is
     * invoked for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invoke([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invoke([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invoke = restParam(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          isProp = isKey(path),
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        var func = isFunc ? path : ((isProp && value != null) ? value[path] : undefined);
        result[++index] = func ? func.apply(value, args) : invokePath(value, path, args);
      });
      return result;
    });

    /**
     * Creates an array of values by running each element in `collection` through
     * `iteratee`. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `callback`, `chunk`, `clone`, `create`, `curry`, `curryRight`,
     * `drop`, `dropRight`, `every`, `fill`, `flatten`, `invert`, `max`, `min`,
     * `parseInt`, `slice`, `sortBy`, `take`, `takeRight`, `template`, `trim`,
     * `trimLeft`, `trimRight`, `trunc`, `random`, `range`, `sample`, `some`,
     * `sum`, `uniq`, and `words`
     *
     * @static
     * @memberOf _
     * @alias collect
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function timesThree(n) {
     *   return n * 3;
     * }
     *
     * _.map([1, 2], timesThree);
     * // => [3, 6]
     *
     * _.map({ 'a': 1, 'b': 2 }, timesThree);
     * // => [3, 6] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // using the `_.property` callback shorthand
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee, thisArg) {
      var func = isArray(collection) ? arrayMap : baseMap;
      iteratee = getCallback(iteratee, thisArg, 3);
      return func(collection, iteratee);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, while the second of which
     * contains elements `predicate` returns falsey for. The predicate is bound
     * to `thisArg` and invoked with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * _.partition([1, 2, 3], function(n) {
     *   return n % 2;
     * });
     * // => [[1, 3], [2]]
     *
     * _.partition([1.2, 2.3, 3.4], function(n) {
     *   return this.floor(n) % 2;
     * }, Math);
     * // => [[1.2, 3.4], [2.3]]
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * var mapper = function(array) {
     *   return _.pluck(array, 'user');
     * };
     *
     * // using the `_.matches` callback shorthand
     * _.map(_.partition(users, { 'age': 1, 'active': false }), mapper);
     * // => [['pebbles'], ['barney', 'fred']]
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.map(_.partition(users, 'active', false), mapper);
     * // => [['barney', 'pebbles'], ['fred']]
     *
     * // using the `_.property` callback shorthand
     * _.map(_.partition(users, 'active'), mapper);
     * // => [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Gets the property value of `path` from all elements in `collection`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Array|string} path The path of the property to pluck.
     * @returns {Array} Returns the property values.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * _.pluck(users, 'user');
     * // => ['barney', 'fred']
     *
     * var userIndex = _.indexBy(users, 'user');
     * _.pluck(userIndex, 'age');
     * // => [36, 40] (iteration order is not guaranteed)
     */
    function pluck(collection, path) {
      return map(collection, property(path));
    }

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` through `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not provided the first element of `collection` is used as the initial
     * value. The `iteratee` is bound to `thisArg` and invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `sortByAll`,
     * and `sortByOrder`
     *
     * @static
     * @memberOf _
     * @alias foldl, inject
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.reduce([1, 2], function(total, n) {
     *   return total + n;
     * });
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2 }, function(result, n, key) {
     *   result[key] = n * 3;
     *   return result;
     * }, {});
     * // => { 'a': 3, 'b': 6 } (iteration order is not guaranteed)
     */
    var reduce = createReduce(arrayReduce, baseEach);

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @alias foldr
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    var reduceRight = createReduce(arrayReduceRight, baseEachRight);

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the new filtered array.
     * @example
     *
     * _.reject([1, 2, 3, 4], function(n) {
     *   return n % 2 == 0;
     * });
     * // => [1, 3]
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.reject(users, { 'age': 40, 'active': true }), 'user');
     * // => ['barney']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.reject(users, 'active', false), 'user');
     * // => ['fred']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.reject(users, 'active'), 'user');
     * // => ['barney']
     */
    function reject(collection, predicate, thisArg) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      predicate = getCallback(predicate, thisArg, 3);
      return func(collection, function(value, index, collection) {
        return !predicate(value, index, collection);
      });
    }

    /**
     * Gets a random element or `n` random elements from a collection.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to sample.
     * @param {number} [n] The number of elements to sample.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {*} Returns the random sample(s).
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     *
     * _.sample([1, 2, 3, 4], 2);
     * // => [3, 1]
     */
    function sample(collection, n, guard) {
      if (guard ? isIterateeCall(collection, n, guard) : n == null) {
        collection = toIterable(collection);
        var length = collection.length;
        return length > 0 ? collection[baseRandom(0, length - 1)] : undefined;
      }
      var index = -1,
          result = toArray(collection),
          length = result.length,
          lastIndex = length - 1;

      n = nativeMin(n < 0 ? 0 : (+n || 0), length);
      while (++index < n) {
        var rand = baseRandom(index, lastIndex),
            value = result[rand];

        result[rand] = result[index];
        result[index] = value;
      }
      result.length = n;
      return result;
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      return sample(collection, POSITIVE_INFINITY);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable properties for objects.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the size of `collection`.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      var length = collection ? getLength(collection) : 0;
      return isLength(length) ? length : keys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * The function returns as soon as it finds a passing value and does not iterate
     * over the entire collection. The predicate is bound to `thisArg` and invoked
     * with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias any
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.some(users, 'active', false);
     * // => true
     *
     * // using the `_.property` callback shorthand
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, thisArg) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
        predicate = undefined;
      }
      if (typeof predicate != 'function' || thisArg !== undefined) {
        predicate = getCallback(predicate, thisArg, 3);
      }
      return func(collection, predicate);
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection through `iteratee`. This method performs
     * a stable sort, that is, it preserves the original sort order of equal elements.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * _.sortBy([1, 2, 3], function(n) {
     *   return Math.sin(n);
     * });
     * // => [3, 1, 2]
     *
     * _.sortBy([1, 2, 3], function(n) {
     *   return this.sin(n);
     * }, Math);
     * // => [3, 1, 2]
     *
     * var users = [
     *   { 'user': 'fred' },
     *   { 'user': 'pebbles' },
     *   { 'user': 'barney' }
     * ];
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.sortBy(users, 'user'), 'user');
     * // => ['barney', 'fred', 'pebbles']
     */
    function sortBy(collection, iteratee, thisArg) {
      if (collection == null) {
        return [];
      }
      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
        iteratee = undefined;
      }
      var index = -1;
      iteratee = getCallback(iteratee, thisArg, 3);

      var result = baseMap(collection, function(value, key, collection) {
        return { 'criteria': iteratee(value, key, collection), 'index': ++index, 'value': value };
      });
      return baseSortBy(result, compareAscending);
    }

    /**
     * This method is like `_.sortBy` except that it can sort by multiple iteratees
     * or property names.
     *
     * If a property name is provided for an iteratee the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If an object is provided for an iteratee the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {...(Function|Function[]|Object|Object[]|string|string[])} iteratees
     *  The iteratees to sort by, specified as individual values or arrays of values.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 42 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.map(_.sortByAll(users, ['user', 'age']), _.values);
     * // => [['barney', 34], ['barney', 36], ['fred', 42], ['fred', 48]]
     *
     * _.map(_.sortByAll(users, 'user', function(chr) {
     *   return Math.floor(chr.age / 10);
     * }), _.values);
     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
     */
    var sortByAll = restParam(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var guard = iteratees[2];
      if (guard && isIterateeCall(iteratees[0], iteratees[1], guard)) {
        iteratees.length = 1;
      }
      return baseSortByOrder(collection, baseFlatten(iteratees), []);
    });

    /**
     * This method is like `_.sortByAll` except that it allows specifying the
     * sort orders of the iteratees to sort by. If `orders` is unspecified, all
     * values are sorted in ascending order. Otherwise, a value is sorted in
     * ascending order if its corresponding order is "asc", and descending if "desc".
     *
     * If a property name is provided for an iteratee the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If an object is provided for an iteratee the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {boolean[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 42 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // sort by `user` in ascending order and by `age` in descending order
     * _.map(_.sortByOrder(users, ['user', 'age'], ['asc', 'desc']), _.values);
     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
     */
    function sortByOrder(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (guard && isIterateeCall(iteratees, orders, guard)) {
        orders = undefined;
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseSortByOrder(collection, iteratees, orders);
    }

    /**
     * Performs a deep comparison between each element in `collection` and the
     * source object, returning an array of all elements that have equivalent
     * property values.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. For comparing a single
     * own or inherited property value see `_.matchesProperty`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Object} source The object of property values to match.
     * @returns {Array} Returns the new filtered array.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false, 'pets': ['hoppy'] },
     *   { 'user': 'fred',   'age': 40, 'active': true, 'pets': ['baby puss', 'dino'] }
     * ];
     *
     * _.pluck(_.where(users, { 'age': 36, 'active': false }), 'user');
     * // => ['barney']
     *
     * _.pluck(_.where(users, { 'pets': ['dino'] }), 'user');
     * // => ['fred']
     */
    function where(collection, source) {
      return filter(collection, baseMatches(source));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Gets the number of milliseconds that have elapsed since the Unix epoch
     * (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @category Date
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => logs the number of milliseconds it took for the deferred function to be invoked
     */
    var now = nativeNow || function() {
      return new Date().getTime();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it is called `n` or more times.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => logs 'done saving!' after the two async saves have completed
     */
    function after(n, func) {
      if (typeof func != 'function') {
        if (typeof n == 'function') {
          var temp = n;
          n = func;
          func = temp;
        } else {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
      }
      n = nativeIsFinite(n = +n) ? n : 0;
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that accepts up to `n` arguments ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the new function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      if (guard && isIterateeCall(func, n, guard)) {
        n = undefined;
      }
      n = (func && n == null) ? func.length : nativeMax(+n || 0, 0);
      return createWrapper(func, ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it is called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery('#add').on('click', _.before(5, addContactToList));
     * // => allows adding up to 4 contacts to the list
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        if (typeof n == 'function') {
          var temp = n;
          n = func;
          func = temp;
        } else {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
      }
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and prepends any additional `_.bind` arguments to those provided to the
     * bound function.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind` this method does not set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var greet = function(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * };
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // using placeholders
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = restParam(function(func, thisArg, partials) {
      var bitmask = BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, bind.placeholder);
        bitmask |= PARTIAL_FLAG;
      }
      return createWrapper(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method. Method names may be specified as individual arguments or as arrays
     * of method names. If no method names are provided all enumerable function
     * properties, own and inherited, of `object` are bound.
     *
     * **Note:** This method does not set the "length" property of bound functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} [methodNames] The object method names to bind,
     *  specified as individual method names or arrays of method names.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'onClick': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view);
     * jQuery('#docs').on('click', view.onClick);
     * // => logs 'clicked docs' when the element is clicked
     */
    var bindAll = restParam(function(object, methodNames) {
      methodNames = methodNames.length ? baseFlatten(methodNames) : functions(object);

      var index = -1,
          length = methodNames.length;

      while (++index < length) {
        var key = methodNames[index];
        object[key] = createWrapper(object[key], BIND_FLAG, object);
      }
      return object;
    });

    /**
     * Creates a function that invokes the method at `object[key]` and prepends
     * any additional `_.bindKey` arguments to those provided to the bound function.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist.
     * See [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Object} object The object the method belongs to.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // using placeholders
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = restParam(function(object, key, partials) {
      var bitmask = BIND_FLAG | BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, bindKey.placeholder);
        bitmask |= PARTIAL_FLAG;
      }
      return createWrapper(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts one or more arguments of `func` that when
     * called either invokes `func` returning its result, if all `func` arguments
     * have been provided, or returns a function that accepts one or more of the
     * remaining `func` arguments, and so on. The arity of `func` may be specified
     * if `func.length` is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method does not set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // using placeholders
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    var curry = createCurry(CURRY_FLAG);

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method does not set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // using placeholders
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    var curryRight = createCurry(CURRY_RIGHT_FLAG);

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed invocations. Provide an options object to indicate that `func`
     * should be invoked on the leading and/or trailing edge of the `wait` timeout.
     * Subsequent calls to the debounced function return the result of the last
     * `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
     * on the trailing edge of the timeout only if the the debounced function is
     * invoked more than once during the `wait` timeout.
     *
     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.leading=false] Specify invoking on the leading
     *  edge of the timeout.
     * @param {number} [options.maxWait] The maximum time `func` is allowed to be
     *  delayed before it is invoked.
     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
     *  edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // avoid costly calculations while the window size is in flux
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // invoke `sendMail` when the click event is fired, debouncing subsequent calls
     * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // ensure `batchLog` is invoked once after 1 second of debounced calls
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', _.debounce(batchLog, 250, {
     *   'maxWait': 1000
     * }));
     *
     * // cancel a debounced call
     * var todoChanges = _.debounce(batchLog, 1000);
     * Object.observe(models.todo, todoChanges);
     *
     * Object.observe(models, function(changes) {
     *   if (_.find(changes, { 'user': 'todo', 'type': 'delete'})) {
     *     todoChanges.cancel();
     *   }
     * }, ['delete']);
     *
     * // ...at some point `models.todo` is changed
     * models.todo.completed = true;
     *
     * // ...before 1 second has passed `models.todo` is deleted
     * // which cancels the debounced `todoChanges` call
     * delete models.todo;
     */
    function debounce(func, wait, options) {
      var args,
          maxTimeoutId,
          result,
          stamp,
          thisArg,
          timeoutId,
          trailingCall,
          lastCalled = 0,
          maxWait = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = wait < 0 ? 0 : (+wait || 0);
      if (options === true) {
        var leading = true;
        trailing = false;
      } else if (isObject(options)) {
        leading = !!options.leading;
        maxWait = 'maxWait' in options && nativeMax(+options.maxWait || 0, wait);
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function cancel() {
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
        if (maxTimeoutId) {
          clearTimeout(maxTimeoutId);
        }
        lastCalled = 0;
        maxTimeoutId = timeoutId = trailingCall = undefined;
      }

      function complete(isCalled, id) {
        if (id) {
          clearTimeout(id);
        }
        maxTimeoutId = timeoutId = trailingCall = undefined;
        if (isCalled) {
          lastCalled = now();
          result = func.apply(thisArg, args);
          if (!timeoutId && !maxTimeoutId) {
            args = thisArg = undefined;
          }
        }
      }

      function delayed() {
        var remaining = wait - (now() - stamp);
        if (remaining <= 0 || remaining > wait) {
          complete(trailingCall, maxTimeoutId);
        } else {
          timeoutId = setTimeout(delayed, remaining);
        }
      }

      function maxDelayed() {
        complete(trailing, timeoutId);
      }

      function debounced() {
        args = arguments;
        stamp = now();
        thisArg = this;
        trailingCall = trailing && (timeoutId || !leading);

        if (maxWait === false) {
          var leadingCall = leading && !timeoutId;
        } else {
          if (!maxTimeoutId && !leading) {
            lastCalled = stamp;
          }
          var remaining = maxWait - (stamp - lastCalled),
              isCalled = remaining <= 0 || remaining > maxWait;

          if (isCalled) {
            if (maxTimeoutId) {
              maxTimeoutId = clearTimeout(maxTimeoutId);
            }
            lastCalled = stamp;
            result = func.apply(thisArg, args);
          }
          else if (!maxTimeoutId) {
            maxTimeoutId = setTimeout(maxDelayed, remaining);
          }
        }
        if (isCalled && timeoutId) {
          timeoutId = clearTimeout(timeoutId);
        }
        else if (!timeoutId && wait !== maxWait) {
          timeoutId = setTimeout(delayed, wait);
        }
        if (leadingCall) {
          isCalled = true;
          result = func.apply(thisArg, args);
        }
        if (isCalled && !timeoutId && !maxTimeoutId) {
          args = thisArg = undefined;
        }
        return result;
      }
      debounced.cancel = cancel;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it is invoked.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke the function with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // logs 'deferred' after one or more milliseconds
     */
    var defer = restParam(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it is invoked.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke the function with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => logs 'later' after one second
     */
    var delay = restParam(function(func, wait, args) {
      return baseDelay(func, wait, args);
    });

    /**
     * Creates a function that returns the result of invoking the provided
     * functions with the `this` binding of the created function, where each
     * successive invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {...Function} [funcs] Functions to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow(_.add, square);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the provided functions from right to left.
     *
     * @static
     * @memberOf _
     * @alias backflow, compose
     * @category Function
     * @param {...Function} [funcs] Functions to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight(square, _.add);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is coerced to a string and used as the
     * cache key. The `func` is invoked with the `this` binding of the memoized
     * function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the [`Map`](http://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoizing function.
     * @example
     *
     * var upperCase = _.memoize(function(string) {
     *   return string.toUpperCase();
     * });
     *
     * upperCase('fred');
     * // => 'FRED'
     *
     * // modifying the result cache
     * upperCase.cache.set('fred', 'BARNEY');
     * upperCase('fred');
     * // => 'BARNEY'
     *
     * // replacing `_.memoize.Cache`
     * var object = { 'user': 'fred' };
     * var other = { 'user': 'barney' };
     * var identity = _.memoize(_.identity);
     *
     * identity(object);
     * // => { 'user': 'fred' }
     * identity(other);
     * // => { 'user': 'fred' }
     *
     * _.memoize.Cache = WeakMap;
     * var identity = _.memoize(_.identity);
     *
     * identity(object);
     * // => { 'user': 'fred' }
     * identity(other);
     * // => { 'user': 'barney' }
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
      };
      memoized.cache = new memoize.Cache;
      return memoized;
    }

    /**
     * Creates a function that runs each argument through a corresponding
     * transform function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms] The functions to transform
     * arguments, specified as individual functions or arrays of functions.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var modded = _.modArgs(function(x, y) {
     *   return [x, y];
     * }, square, doubled);
     *
     * modded(1, 2);
     * // => [1, 4]
     *
     * modded(5, 10);
     * // => [25, 20]
     */
    var modArgs = restParam(function(func, transforms) {
      transforms = baseFlatten(transforms);
      if (typeof func != 'function' || !arrayEvery(transforms, baseIsFunction)) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = transforms.length;
      return restParam(function(args) {
        var index = nativeMin(args.length, length);
        while (index--) {
          args[index] = transforms[index](args[index]);
        }
        return func.apply(this, args);
      });
    });

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        return !predicate.apply(this, arguments);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first call. The `func` is invoked
     * with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // `initialize` invokes `createApplication` once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with `partial` arguments prepended
     * to those provided to the new function. This method is like `_.bind` except
     * it does **not** alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method does not set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * var greet = function(greeting, name) {
     *   return greeting + ' ' + name;
     * };
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // using placeholders
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = createPartial(PARTIAL_FLAG);

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to those provided to the new function.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method does not set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * var greet = function(greeting, name) {
     *   return greeting + ' ' + name;
     * };
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // using placeholders
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = createPartial(PARTIAL_RIGHT_FLAG);

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified indexes where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes,
     *  specified as individual indexes or arrays of indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, 2, 0, 1);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     *
     * var map = _.rearg(_.map, [1, 0]);
     * map(function(n) {
     *   return n * 3;
     * }, [1, 2, 3]);
     * // => [3, 6, 9]
     */
    var rearg = restParam(function(func, indexes) {
      return createWrapper(func, REARG_FLAG, undefined, undefined, undefined, baseFlatten(indexes));
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as an array.
     *
     * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters).
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.restParam(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function restParam(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            rest = Array(length);

        while (++index < length) {
          rest[index] = args[start + index];
        }
        switch (start) {
          case 0: return func.call(this, rest);
          case 1: return func.call(this, args[0], rest);
          case 2: return func.call(this, args[0], args[1], rest);
        }
        var otherArgs = Array(start + 1);
        index = -1;
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = rest;
        return func.apply(this, otherArgs);
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the created
     * function and an array of arguments much like [`Function#apply`](https://es5.github.io/#x15.3.4.3).
     *
     * **Note:** This method is based on the [spread operator](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Spread_operator).
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * // with a Promise
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function(array) {
        return func.apply(this, array);
      };
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed invocations. Provide an options object to indicate
     * that `func` should be invoked on the leading and/or trailing edge of the
     * `wait` timeout. Subsequent calls to the throttled function return the
     * result of the last `func` call.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
     * on the trailing edge of the timeout only if the the throttled function is
     * invoked more than once during the `wait` timeout.
     *
     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.leading=true] Specify invoking on the leading
     *  edge of the timeout.
     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
     *  edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // avoid excessively updating the position while scrolling
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // invoke `renewToken` when the click event is fired, but not more than once every 5 minutes
     * jQuery('.interactive').on('click', _.throttle(renewToken, 300000, {
     *   'trailing': false
     * }));
     *
     * // cancel a trailing throttled call
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (options === false) {
        leading = false;
      } else if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, { 'leading': leading, 'maxWait': +wait, 'trailing': trailing });
    }

    /**
     * Creates a function that provides `value` to the wrapper function as its
     * first argument. Any additional arguments provided to the function are
     * appended to those provided to the wrapper function. The wrapper is invoked
     * with the `this` binding of the created function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} wrapper The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      wrapper = wrapper == null ? identity : wrapper;
      return createWrapper(wrapper, PARTIAL_FLAG, undefined, [value], []);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates a clone of `value`. If `isDeep` is `true` nested objects are cloned,
     * otherwise they are assigned by reference. If `customizer` is provided it is
     * invoked to produce the cloned values. If `customizer` returns `undefined`
     * cloning is handled by the method instead. The `customizer` is bound to
     * `thisArg` and invoked with two argument; (value [, index|key, object]).
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
     * The enumerable properties of `arguments` objects and objects created by
     * constructors other than `Object` are cloned to plain `Object` objects. An
     * empty object is returned for uncloneable values such as functions, DOM nodes,
     * Maps, Sets, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @param {Function} [customizer] The function to customize cloning values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {*} Returns the cloned value.
     * @example
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * var shallow = _.clone(users);
     * shallow[0] === users[0];
     * // => true
     *
     * var deep = _.clone(users, true);
     * deep[0] === users[0];
     * // => false
     *
     * // using a customizer callback
     * var el = _.clone(document.body, function(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * });
     *
     * el === document.body
     * // => false
     * el.nodeName
     * // => BODY
     * el.childNodes.length;
     * // => 0
     */
    function clone(value, isDeep, customizer, thisArg) {
      if (isDeep && typeof isDeep != 'boolean' && isIterateeCall(value, isDeep, customizer)) {
        isDeep = false;
      }
      else if (typeof isDeep == 'function') {
        thisArg = customizer;
        customizer = isDeep;
        isDeep = false;
      }
      return typeof customizer == 'function'
        ? baseClone(value, isDeep, bindCallback(customizer, thisArg, 1))
        : baseClone(value, isDeep);
    }

    /**
     * Creates a deep clone of `value`. If `customizer` is provided it is invoked
     * to produce the cloned values. If `customizer` returns `undefined` cloning
     * is handled by the method instead. The `customizer` is bound to `thisArg`
     * and invoked with two argument; (value [, index|key, object]).
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
     * The enumerable properties of `arguments` objects and objects created by
     * constructors other than `Object` are cloned to plain `Object` objects. An
     * empty object is returned for uncloneable values such as functions, DOM nodes,
     * Maps, Sets, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to deep clone.
     * @param {Function} [customizer] The function to customize cloning values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {*} Returns the deep cloned value.
     * @example
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * var deep = _.cloneDeep(users);
     * deep[0] === users[0];
     * // => false
     *
     * // using a customizer callback
     * var el = _.cloneDeep(document.body, function(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * });
     *
     * el === document.body
     * // => false
     * el.nodeName
     * // => BODY
     * el.childNodes.length;
     * // => 20
     */
    function cloneDeep(value, customizer, thisArg) {
      return typeof customizer == 'function'
        ? baseClone(value, true, bindCallback(customizer, thisArg, 1))
        : baseClone(value, true);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`, else `false`.
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    function gt(value, other) {
      return value > other;
    }

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to `other`, else `false`.
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    function gte(value, other) {
      return value >= other;
    }

    /**
     * Checks if `value` is classified as an `arguments` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    function isArguments(value) {
      return isObjectLike(value) && isArrayLike(value) &&
        hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
    }

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(function() { return arguments; }());
     * // => false
     */
    var isArray = nativeIsArray || function(value) {
      return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
    };

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false || (isObjectLike(value) && objToString.call(value) == boolTag);
    }

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    function isDate(value) {
      return isObjectLike(value) && objToString.call(value) == dateTag;
    }

    /**
     * Checks if `value` is a DOM element.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return !!value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
    }

    /**
     * Checks if `value` is empty. A value is considered empty unless it is an
     * `arguments` object, array, string, or jQuery-like collection with a length
     * greater than `0` or an object with own enumerable properties.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {Array|Object|string} value The value to inspect.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) && (isArray(value) || isString(value) || isArguments(value) ||
          (isObjectLike(value) && isFunction(value.splice)))) {
        return !value.length;
      }
      return !keys(value).length;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent. If `customizer` is provided it is invoked to compare values.
     * If `customizer` returns `undefined` comparisons are handled by the method
     * instead. The `customizer` is bound to `thisArg` and invoked with three
     * arguments: (value, other [, index|key]).
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. Functions and DOM nodes
     * are **not** supported. Provide a customizer function to extend support
     * for comparing other values.
     *
     * @static
     * @memberOf _
     * @alias eq
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize value comparisons.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'user': 'fred' };
     * var other = { 'user': 'fred' };
     *
     * object == other;
     * // => false
     *
     * _.isEqual(object, other);
     * // => true
     *
     * // using a customizer callback
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqual(array, other, function(value, other) {
     *   if (_.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/)) {
     *     return true;
     *   }
     * });
     * // => true
     */
    function isEqual(value, other, customizer, thisArg) {
      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return  result === undefined ? baseIsEqual(value, other, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      return isObjectLike(value) && typeof value.message == 'string' && objToString.call(value) == errorTag;
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on [`Number.isFinite`](http://ecma-international.org/ecma-262/6.0/#sec-number.isfinite).
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(10);
     * // => true
     *
     * _.isFinite('10');
     * // => false
     *
     * _.isFinite(true);
     * // => false
     *
     * _.isFinite(Object(10));
     * // => false
     *
     * _.isFinite(Infinity);
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in older versions of Chrome and Safari which return 'function' for regexes
      // and Safari 8 equivalents which return 'object' for typed array constructors.
      return isObject(value) && objToString.call(value) == funcTag;
    }

    /**
     * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
     * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(1);
     * // => false
     */
    function isObject(value) {
      // Avoid a V8 JIT bug in Chrome 19-20.
      // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
      var type = typeof value;
      return !!value && (type == 'object' || type == 'function');
    }

    /**
     * Performs a deep comparison between `object` and `source` to determine if
     * `object` contains equivalent property values. If `customizer` is provided
     * it is invoked to compare values. If `customizer` returns `undefined`
     * comparisons are handled by the method instead. The `customizer` is bound
     * to `thisArg` and invoked with three arguments: (value, other, index|key).
     *
     * **Note:** This method supports comparing properties of arrays, booleans,
     * `Date` objects, numbers, `Object` objects, regexes, and strings. Functions
     * and DOM nodes are **not** supported. Provide a customizer function to extend
     * support for comparing other values.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize value comparisons.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'user': 'fred', 'age': 40 };
     *
     * _.isMatch(object, { 'age': 40 });
     * // => true
     *
     * _.isMatch(object, { 'age': 36 });
     * // => false
     *
     * // using a customizer callback
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatch(object, source, function(value, other) {
     *   return _.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/) || undefined;
     * });
     * // => true
     */
    function isMatch(object, source, customizer, thisArg) {
      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
      return baseIsMatch(object, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is not the same as [`isNaN`](https://es5.github.io/#x15.1.2.4)
     * which returns `true` for `undefined` and other non-numeric values.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some host objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a native function.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (value == null) {
        return false;
      }
      if (isFunction(value)) {
        return reIsNative.test(fnToString.call(value));
      }
      return isObjectLike(value) && reIsHostCtor.test(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
     * as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isNumber(8.4);
     * // => true
     *
     * _.isNumber(NaN);
     * // => true
     *
     * _.isNumber('8.4');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' || (isObjectLike(value) && objToString.call(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * **Note:** This method assumes objects created by the `Object` constructor
     * have no inherited enumerable properties.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      var Ctor;

      // Exit early for non `Object` objects.
      if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) ||
          (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
        return false;
      }
      // IE < 9 iterates inherited properties before own properties. If the first
      // iterated property is an object's own property then there are no inherited
      // enumerable properties.
      var result;
      // In most environments an object's own properties are iterated before
      // its inherited properties. If the last iterated property is an object's
      // own property then there are no inherited enumerable properties.
      baseForIn(value, function(subValue, key) {
        result = key;
      });
      return result === undefined || hasOwnProperty.call(value, result);
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    function isRegExp(value) {
      return isObject(value) && objToString.call(value) == regexpTag;
    }

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    function isTypedArray(value) {
      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
    }

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`, else `false`.
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    function lt(value, other) {
      return value < other;
    }

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to `other`, else `false`.
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    function lte(value, other) {
      return value <= other;
    }

    /**
     * Converts `value` to an array.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * (function() {
     *   return _.toArray(arguments).slice(1);
     * }(1, 2, 3));
     * // => [2, 3]
     */
    function toArray(value) {
      var length = value ? getLength(value) : 0;
      if (!isLength(length)) {
        return values(value);
      }
      if (!length) {
        return [];
      }
      return arrayCopy(value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable
     * properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return baseCopy(value, keysIn(value));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Recursively merges own enumerable properties of the source object(s), that
     * don't resolve to `undefined` into the destination object. Subsequent sources
     * overwrite property assignments of previous sources. If `customizer` is
     * provided it is invoked to produce the merged values of the destination and
     * source properties. If `customizer` returns `undefined` merging is handled
     * by the method instead. The `customizer` is bound to `thisArg` and invoked
     * with five arguments: (objectValue, sourceValue, key, object, source).
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var users = {
     *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
     * };
     *
     * var ages = {
     *   'data': [{ 'age': 36 }, { 'age': 40 }]
     * };
     *
     * _.merge(users, ages);
     * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
     *
     * // using a customizer callback
     * var object = {
     *   'fruits': ['apple'],
     *   'vegetables': ['beet']
     * };
     *
     * var other = {
     *   'fruits': ['banana'],
     *   'vegetables': ['carrot']
     * };
     *
     * _.merge(object, other, function(a, b) {
     *   if (_.isArray(a)) {
     *     return a.concat(b);
     *   }
     * });
     * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
     */
    var merge = createAssigner(baseMerge);

    /**
     * Assigns own enumerable properties of source object(s) to the destination
     * object. Subsequent sources overwrite property assignments of previous sources.
     * If `customizer` is provided it is invoked to produce the assigned values.
     * The `customizer` is bound to `thisArg` and invoked with five arguments:
     * (objectValue, sourceValue, key, object, source).
     *
     * **Note:** This method mutates `object` and is based on
     * [`Object.assign`](http://ecma-international.org/ecma-262/6.0/#sec-object.assign).
     *
     * @static
     * @memberOf _
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
     * // => { 'user': 'fred', 'age': 40 }
     *
     * // using a customizer callback
     * var defaults = _.partialRight(_.assign, function(value, other) {
     *   return _.isUndefined(value) ? other : value;
     * });
     *
     * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
     * // => { 'user': 'barney', 'age': 36 }
     */
    var assign = createAssigner(function(object, source, customizer) {
      return customizer
        ? assignWith(object, source, customizer)
        : baseAssign(object, source);
    });

    /**
     * Creates an object that inherits from the given `prototype` object. If a
     * `properties` object is provided its own enumerable properties are assigned
     * to the created object.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties, guard) {
      var result = baseCreate(prototype);
      if (guard && isIterateeCall(prototype, properties, guard)) {
        properties = undefined;
      }
      return properties ? baseAssign(result, properties) : result;
    }

    /**
     * Assigns own enumerable properties of source object(s) to the destination
     * object for all destination properties that resolve to `undefined`. Once a
     * property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
     * // => { 'user': 'barney', 'age': 36 }
     */
    var defaults = createDefaults(assign, assignDefaults);

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.defaultsDeep({ 'user': { 'name': 'barney' } }, { 'user': { 'name': 'fred', 'age': 36 } });
     * // => { 'user': { 'name': 'barney', 'age': 36 } }
     *
     */
    var defaultsDeep = createDefaults(merge, mergeDefaults);

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(chr) {
     *   return chr.age < 40;
     * });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // using the `_.matches` callback shorthand
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findKey(users, 'active', false);
     * // => 'fred'
     *
     * // using the `_.property` callback shorthand
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    var findKey = createFindKey(baseForOwn);

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(chr) {
     *   return chr.age < 40;
     * });
     * // => returns `pebbles` assuming `_.findKey` returns `barney`
     *
     * // using the `_.matches` callback shorthand
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findLastKey(users, 'active', false);
     * // => 'fred'
     *
     * // using the `_.property` callback shorthand
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    var findLastKey = createFindKey(baseForOwnRight);

    /**
     * Iterates over own and inherited enumerable properties of an object invoking
     * `iteratee` for each property. The `iteratee` is bound to `thisArg` and invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'a', 'b', and 'c' (iteration order is not guaranteed)
     */
    var forIn = createForIn(baseFor);

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'c', 'b', and 'a' assuming `_.forIn ` logs 'a', 'b', and 'c'
     */
    var forInRight = createForIn(baseForRight);

    /**
     * Iterates over own enumerable properties of an object invoking `iteratee`
     * for each property. The `iteratee` is bound to `thisArg` and invoked with
     * three arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'a' and 'b' (iteration order is not guaranteed)
     */
    var forOwn = createForOwn(baseForOwn);

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'b' and 'a' assuming `_.forOwn` logs 'a' and 'b'
     */
    var forOwnRight = createForOwn(baseForOwnRight);

    /**
     * Creates an array of function property names from all enumerable properties,
     * own and inherited, of `object`.
     *
     * @static
     * @memberOf _
     * @alias methods
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the new array of property names.
     * @example
     *
     * _.functions(_);
     * // => ['after', 'ary', 'assign', ...]
     */
    function functions(object) {
      return baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the property value at `path` of `object`. If the resolved value is
     * `undefined` the `defaultValue` is used in its place.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, toPath(path), path + '');
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` is a direct property, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': { 'c': 3 } } };
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b.c');
     * // => true
     *
     * _.has(object, ['a', 'b', 'c']);
     * // => true
     */
    function has(object, path) {
      if (object == null) {
        return false;
      }
      var result = hasOwnProperty.call(object, path);
      if (!result && !isKey(path)) {
        path = toPath(path);
        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
        if (object == null) {
          return false;
        }
        path = last(path);
        result = hasOwnProperty.call(object, path);
      }
      return result || (isLength(object.length) && isIndex(path, object.length) &&
        (isArray(object) || isArguments(object)));
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite property
     * assignments of previous values unless `multiValue` is `true`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to invert.
     * @param {boolean} [multiValue] Allow multiple values per key.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     *
     * // with `multiValue`
     * _.invert(object, true);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function invert(object, multiValue, guard) {
      if (guard && isIterateeCall(object, multiValue, guard)) {
        multiValue = undefined;
      }
      var index = -1,
          props = keys(object),
          length = props.length,
          result = {};

      while (++index < length) {
        var key = props[index],
            value = object[key];

        if (multiValue) {
          if (hasOwnProperty.call(result, value)) {
            result[value].push(key);
          } else {
            result[value] = [key];
          }
        }
        else {
          result[value] = key;
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    var keys = !nativeKeys ? shimKeys : function(object) {
      var Ctor = object == null ? undefined : object.constructor;
      if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
          (typeof object != 'function' && isArrayLike(object))) {
        return shimKeys(object);
      }
      return isObject(object) ? nativeKeys(object) : [];
    };

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      if (object == null) {
        return [];
      }
      if (!isObject(object)) {
        object = Object(object);
      }
      var length = object.length;
      length = (length && isLength(length) &&
        (isArray(object) || isArguments(object)) && length) || 0;

      var Ctor = object.constructor,
          index = -1,
          isProto = typeof Ctor == 'function' && Ctor.prototype === object,
          result = Array(length),
          skipIndexes = length > 0;

      while (++index < length) {
        result[index] = (index + '');
      }
      for (var key in object) {
        if (!(skipIndexes && isIndex(key, length)) &&
            !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * property of `object` through `iteratee`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the new mapped object.
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    var mapKeys = createObjectMapper(true);

    /**
     * Creates an object with the same keys as `object` and values generated by
     * running each own enumerable property of `object` through `iteratee`. The
     * iteratee function is bound to `thisArg` and invoked with three arguments:
     * (value, key, object).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the new mapped object.
     * @example
     *
     * _.mapValues({ 'a': 1, 'b': 2 }, function(n) {
     *   return n * 3;
     * });
     * // => { 'a': 3, 'b': 6 }
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * // using the `_.property` callback shorthand
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    var mapValues = createObjectMapper();

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable properties of `object` that are not omitted.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {Function|...(string|string[])} [predicate] The function invoked per
     *  iteration or property names to omit, specified as individual property
     *  names or arrays of property names.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'user': 'fred', 'age': 40 };
     *
     * _.omit(object, 'age');
     * // => { 'user': 'fred' }
     *
     * _.omit(object, _.isNumber);
     * // => { 'user': 'fred' }
     */
    var omit = restParam(function(object, props) {
      if (object == null) {
        return {};
      }
      if (typeof props[0] != 'function') {
        var props = arrayMap(baseFlatten(props), String);
        return pickByArray(object, baseDifference(keysIn(object), props));
      }
      var predicate = bindCallback(props[0], props[1], 3);
      return pickByCallback(object, function(value, key, object) {
        return !predicate(value, key, object);
      });
    });

    /**
     * Creates a two dimensional array of the key-value pairs for `object`,
     * e.g. `[[key1, value1], [key2, value2]]`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the new array of key-value pairs.
     * @example
     *
     * _.pairs({ 'barney': 36, 'fred': 40 });
     * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
     */
    function pairs(object) {
      object = toObject(object);

      var index = -1,
          props = keys(object),
          length = props.length,
          result = Array(length);

      while (++index < length) {
        var key = props[index];
        result[index] = [key, object[key]];
      }
      return result;
    }

    /**
     * Creates an object composed of the picked `object` properties. Property
     * names may be specified as individual arguments or as arrays of property
     * names. If `predicate` is provided it is invoked for each property of `object`
     * picking the properties `predicate` returns truthy for. The predicate is
     * bound to `thisArg` and invoked with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {Function|...(string|string[])} [predicate] The function invoked per
     *  iteration or property names to pick, specified as individual property
     *  names or arrays of property names.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'user': 'fred', 'age': 40 };
     *
     * _.pick(object, 'user');
     * // => { 'user': 'fred' }
     *
     * _.pick(object, _.isString);
     * // => { 'user': 'fred' }
     */
    var pick = restParam(function(object, props) {
      if (object == null) {
        return {};
      }
      return typeof props[0] == 'function'
        ? pickByCallback(object, bindCallback(props[0], props[1], 3))
        : pickByArray(object, baseFlatten(props));
    });

    /**
     * This method is like `_.get` except that if the resolved value is a function
     * it is invoked with the `this` binding of its parent object and its result
     * is returned.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a.b.c', 'default');
     * // => 'default'
     *
     * _.result(object, 'a.b.c', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      var result = object == null ? undefined : object[path];
      if (result === undefined) {
        if (object != null && !isKey(path, object)) {
          path = toPath(path);
          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
          result = object == null ? undefined : object[last(path)];
        }
        result = result === undefined ? defaultValue : result;
      }
      return isFunction(result) ? result.call(object) : result;
    }

    /**
     * Sets the property value of `path` on `object`. If a portion of `path`
     * does not exist it is created.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to augment.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, 'x[0].y.z', 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      if (object == null) {
        return object;
      }
      var pathKey = (path + '');
      path = (object[pathKey] != null || isKey(path, object)) ? [pathKey] : toPath(path);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = path[index];
        if (isObject(nested)) {
          if (index == lastIndex) {
            nested[key] = value;
          } else if (nested[key] == null) {
            nested[key] = isIndex(path[index + 1]) ? [] : {};
          }
        }
        nested = nested[key];
      }
      return object;
    }

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own enumerable
     * properties through `iteratee`, with each invocation potentially mutating
     * the `accumulator` object. The `iteratee` is bound to `thisArg` and invoked
     * with four arguments: (accumulator, value, key, object). Iteratee functions
     * may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Array|Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * });
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2 }, function(result, n, key) {
     *   result[key] = n * 3;
     * });
     * // => { 'a': 3, 'b': 6 }
     */
    function transform(object, iteratee, accumulator, thisArg) {
      var isArr = isArray(object) || isTypedArray(object);
      iteratee = getCallback(iteratee, thisArg, 4);

      if (accumulator == null) {
        if (isArr || isObject(object)) {
          var Ctor = object.constructor;
          if (isArr) {
            accumulator = isArray(object) ? new Ctor : [];
          } else {
            accumulator = baseCreate(isFunction(Ctor) ? Ctor.prototype : undefined);
          }
        } else {
          accumulator = {};
        }
      }
      (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Creates an array of the own enumerable property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable property values
     * of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Checks if `n` is between `start` and up to but not including, `end`. If
     * `end` is not specified it is set to `start` with `start` then set to `0`.
     *
     * @static
     * @memberOf _
     * @category Number
     * @param {number} n The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `n` is in the range, else `false`.
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     */
    function inRange(value, start, end) {
      start = +start || 0;
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = +end || 0;
      }
      return value >= nativeMin(start, end) && value < nativeMax(start, end);
    }

    /**
     * Produces a random number between `min` and `max` (inclusive). If only one
     * argument is provided a number between `0` and the given number is returned.
     * If `floating` is `true`, or either `min` or `max` are floats, a floating-point
     * number is returned instead of an integer.
     *
     * @static
     * @memberOf _
     * @category Number
     * @param {number} [min=0] The minimum possible value.
     * @param {number} [max=1] The maximum possible value.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(min, max, floating) {
      if (floating && isIterateeCall(min, max, floating)) {
        max = floating = undefined;
      }
      var noMin = min == null,
          noMax = max == null;

      if (floating == null) {
        if (noMax && typeof min == 'boolean') {
          floating = min;
          min = 1;
        }
        else if (typeof max == 'boolean') {
          floating = max;
          noMax = true;
        }
      }
      if (noMin && noMax) {
        max = 1;
        noMax = false;
      }
      min = +min || 0;
      if (noMax) {
        max = min;
        min = 0;
      } else {
        max = +max || 0;
      }
      if (floating || min % 1 || max % 1) {
        var rand = nativeRandom();
        return nativeMin(min + (rand * (max - min + parseFloat('1e-' + ((rand + '').length - 1)))), max);
      }
      return baseRandom(min, max);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar');
     * // => 'fooBar'
     *
     * _.camelCase('__foo_bar__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? (word.charAt(0).toUpperCase() + word.slice(1)) : word);
    });

    /**
     * Capitalizes the first character of `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('fred');
     * // => 'Fred'
     */
    function capitalize(string) {
      string = baseToString(string);
      return string && (string.charAt(0).toUpperCase() + string.slice(1));
    }

    /**
     * Deburrs `string` by converting [latin-1 supplementary letters](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * to basic latin letters and removing [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = baseToString(string);
      return string && string.replace(reLatin1, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to search.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search from.
     * @returns {boolean} Returns `true` if `string` ends with `target`, else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = baseToString(string);
      target = (target + '');

      var length = string.length;
      position = position === undefined
        ? length
        : nativeMin(position < 0 ? 0 : (+position || 0), length);

      position -= target.length;
      return position >= 0 && string.indexOf(target, position) == position;
    }

    /**
     * Converts the characters "&", "<", ">", '"', "'", and "\`", in `string` to
     * their corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional characters
     * use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value.
     * See [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * Backticks are escaped because in Internet Explorer < 9, they can break out
     * of attribute values or HTML comments. See [#59](https://html5sec.org/#59),
     * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
     * [#133](https://html5sec.org/#133) of the [HTML5 Security Cheatsheet](https://html5sec.org/)
     * for more details.
     *
     * When working with HTML you should always [quote attribute values](http://wonko.com/post/html-escaping)
     * to reduce XSS vectors.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      // Reset `lastIndex` because in IE < 9 `String#replace` does not.
      string = baseToString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "\", "/", "^", "$", ".", "|", "?",
     * "*", "+", "(", ")", "[", "]", "{" and "}" in `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https:\/\/lodash\.com\/\)'
     */
    function escapeRegExp(string) {
      string = baseToString(string);
      return (string && reHasRegExpChars.test(string))
        ? string.replace(reRegExpChars, escapeRegExpChar)
        : (string || '(?:)');
    }

    /**
     * Converts `string` to [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__foo_bar__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = baseToString(string);
      length = +length;

      var strLength = string.length;
      if (strLength >= length || !nativeIsFinite(length)) {
        return string;
      }
      var mid = (length - strLength) / 2,
          leftLength = nativeFloor(mid),
          rightLength = nativeCeil(mid);

      chars = createPadding('', rightLength, chars);
      return chars.slice(0, leftLength) + string + chars;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padLeft('abc', 6);
     * // => '   abc'
     *
     * _.padLeft('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padLeft('abc', 3);
     * // => 'abc'
     */
    var padLeft = createPadDir();

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padRight('abc', 6);
     * // => 'abc   '
     *
     * _.padRight('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padRight('abc', 3);
     * // => 'abc'
     */
    var padRight = createPadDir(true);

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a hexadecimal,
     * in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the [ES5 implementation](https://es5.github.io/#E)
     * of `parseInt`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      // Firefox < 21 and Opera < 15 follow ES3 for `parseInt`.
      // Chrome fails to trim leading <BOM> whitespace characters.
      // See https://code.google.com/p/v8/issues/detail?id=3109 for more details.
      if (guard ? isIterateeCall(string, radix, guard) : radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      string = trim(string);
      return nativeParseInt(string, radix || (reHasHexPrefix.test(string) ? 16 : 10));
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=0] The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n) {
      var result = '';
      string = baseToString(string);
      n = +n;
      if (n < 1 || !string || !nativeIsFinite(n)) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        string += string;
      } while (n);

      return result;
    }

    /**
     * Converts `string` to [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--foo-bar');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Converts `string` to [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__foo_bar__');
     * // => 'Foo Bar'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + (word.charAt(0).toUpperCase() + word.slice(1));
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to search.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`, else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = baseToString(string);
      position = position == null
        ? 0
        : nativeMin(position < 0 ? 0 : (+position || 0), string.length);

      return string.lastIndexOf(target, position) == position;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is provided it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options] The options object.
     * @param {RegExp} [options.escape] The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate] The "evaluate" delimiter.
     * @param {Object} [options.imports] An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate] The "interpolate" delimiter.
     * @param {string} [options.sourceURL] The sourceURL of the template's compiled source.
     * @param {string} [options.variable] The data object variable name.
     * @param- {Object} [otherOptions] Enables the legacy `options` param signature.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // using the "interpolate" delimiter to create a compiled template
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // using the HTML "escape" delimiter to escape data property values
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // using the "evaluate" delimiter to execute JavaScript and generate HTML
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // using the internal `print` function in "evaluate" delimiters
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // using the ES delimiter as an alternative to the default "interpolate" delimiter
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // using custom template delimiters
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // using backslashes to treat delimiters as plain text
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // using the `imports` option to import `jQuery` as `jq`
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // using the `sourceURL` option to specify a custom sourceURL for the template
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector
     *
     * // using the `variable` option to ensure a with-statement isn't used in the compiled template
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // using the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and a stack trace
     * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, otherOptions) {
      // Based on John Resig's `tmpl` implementation (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (otherOptions && isIterateeCall(string, options, otherOptions)) {
        options = otherOptions = undefined;
      }
      string = baseToString(string);
      options = assignWith(baseAssign({}, otherOptions || options), settings, assignOwnDefaults);

      var imports = assignWith(baseAssign({}, options.imports), settings.imports, assignOwnDefaults),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products requires returning the `match`
        // string in order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      var value = string;
      string = baseToString(string);
      if (!string) {
        return string;
      }
      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
        return string.slice(trimmedLeftIndex(string), trimmedRightIndex(string) + 1);
      }
      chars = (chars + '');
      return string.slice(charsLeftIndex(string, chars), charsRightIndex(string, chars) + 1);
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimLeft('  abc  ');
     * // => 'abc  '
     *
     * _.trimLeft('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimLeft(string, chars, guard) {
      var value = string;
      string = baseToString(string);
      if (!string) {
        return string;
      }
      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
        return string.slice(trimmedLeftIndex(string));
      }
      return string.slice(charsLeftIndex(string, (chars + '')));
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimRight('  abc  ');
     * // => '  abc'
     *
     * _.trimRight('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimRight(string, chars, guard) {
      var value = string;
      string = baseToString(string);
      if (!string) {
        return string;
      }
      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
        return string.slice(0, trimmedRightIndex(string) + 1);
      }
      return string.slice(0, charsRightIndex(string, (chars + '')) + 1);
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object|number} [options] The options object or maximum string length.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.trunc('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', 24);
     * // => 'hi-diddly-ho there, n...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function trunc(string, options, guard) {
      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (options != null) {
        if (isObject(options)) {
          var separator = 'separator' in options ? options.separator : separator;
          length = 'length' in options ? (+options.length || 0) : length;
          omission = 'omission' in options ? baseToString(options.omission) : omission;
        } else {
          length = +options || 0;
        }
      }
      string = baseToString(string);
      if (length >= string.length) {
        return string;
      }
      var end = length - omission.length;
      if (end < 1) {
        return omission;
      }
      var result = string.slice(0, end);
      if (separator == null) {
        return result + omission;
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              newEnd,
              substring = string.slice(0, end);

          if (!separator.global) {
            separator = RegExp(separator.source, (reFlags.exec(separator) || '') + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            newEnd = match.index;
          }
          result = result.slice(0, newEnd == null ? end : newEnd);
        }
      } else if (string.indexOf(separator, end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, `&#39;`, and `&#96;` in `string` to their
     * corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional HTML
     * entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = baseToString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      if (guard && isIterateeCall(string, pattern, guard)) {
        pattern = undefined;
      }
      string = baseToString(string);
      return string.match(pattern || reWords) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it is invoked.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Function} func The function to attempt.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // avoid throwing errors for invalid selectors
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = restParam(function(func, args) {
      try {
        return func.apply(undefined, args);
      } catch(e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and arguments of the created function. If `func` is a property name the
     * created callback returns the property value for a given element. If `func`
     * is an object the created callback returns `true` for elements that contain
     * the equivalent object properties, otherwise it returns `false`.
     *
     * @static
     * @memberOf _
     * @alias iteratee
     * @category Utility
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // wrap to create custom callback shorthands
     * _.callback = _.wrap(_.callback, function(callback, func, thisArg) {
     *   var match = /^(.+?)__([gl]t)(.+)$/.exec(func);
     *   if (!match) {
     *     return callback(func, thisArg);
     *   }
     *   return function(object) {
     *     return match[2] == 'gt'
     *       ? object[match[1]] > match[3]
     *       : object[match[1]] < match[3];
     *   };
     * });
     *
     * _.filter(users, 'age__gt36');
     * // => [{ 'user': 'fred', 'age': 40 }]
     */
    function callback(func, thisArg, guard) {
      if (guard && isIterateeCall(func, thisArg, guard)) {
        thisArg = undefined;
      }
      return isObjectLike(func)
        ? matches(func)
        : baseCallback(func, thisArg);
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var object = { 'user': 'fred' };
     * var getter = _.constant(object);
     *
     * getter() === object;
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * This method returns the first argument provided to it.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'user': 'fred' };
     *
     * _.identity(object) === object;
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that performs a deep comparison between a given object
     * and `source`, returning `true` if the given object has equivalent property
     * values, else `false`.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. For comparing a single
     * own or inherited property value see `_.matchesProperty`.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, _.matches({ 'age': 40, 'active': false }));
     * // => [{ 'user': 'fred', 'age': 40, 'active': false }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, true));
    }

    /**
     * Creates a function that compares the property value of `path` on a given
     * object to `value`.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * _.find(users, _.matchesProperty('user', 'fred'));
     * // => { 'user': 'fred' }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, true));
    }

    /**
     * Creates a function that invokes the method at `path` on a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': { 'c': _.constant(2) } } },
     *   { 'a': { 'b': { 'c': _.constant(1) } } }
     * ];
     *
     * _.map(objects, _.method('a.b.c'));
     * // => [2, 1]
     *
     * _.invoke(_.sortBy(objects, _.method(['a', 'b', 'c'])), 'a.b.c');
     * // => [1, 2]
     */
    var method = restParam(function(path, args) {
      return function(object) {
        return invokePath(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path on `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = restParam(function(object, args) {
      return function(path) {
        return invokePath(object, path, args);
      };
    });

    /**
     * Adds all own enumerable function properties of a source object to the
     * destination object. If `object` is a function then methods are added to
     * its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.chain=true] Specify whether the functions added
     *  are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      if (options == null) {
        var isObj = isObject(source),
            props = isObj ? keys(source) : undefined,
            methodNames = (props && props.length) ? baseFunctions(source, props) : undefined;

        if (!(methodNames ? methodNames.length : isObj)) {
          methodNames = false;
          options = source;
          source = object;
          object = this;
        }
      }
      if (!methodNames) {
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = true,
          index = -1,
          isFunc = isFunction(object),
          length = methodNames.length;

      if (options === false) {
        chain = false;
      } else if (isObject(options) && 'chain' in options) {
        chain = options.chain;
      }
      while (++index < length) {
        var methodName = methodNames[index],
            func = source[methodName];

        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = (function(func) {
            return function() {
              var chainAll = this.__chain__;
              if (chain || chainAll) {
                var result = object(this.__wrapped__),
                    actions = result.__actions__ = arrayCopy(this.__actions__);

                actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
                result.__chain__ = chainAll;
                return result;
              }
              return func.apply(object, arrayPush([this.value()], arguments));
            };
          }(func));
        }
      }
      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      root._ = oldDash;
      return this;
    }

    /**
     * A no-operation function that returns `undefined` regardless of the
     * arguments it receives.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @example
     *
     * var object = { 'user': 'fred' };
     *
     * _.noop(object) === undefined;
     * // => true
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that returns the property value at `path` on a
     * given object.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': { 'c': 2 } } },
     *   { 'a': { 'b': { 'c': 1 } } }
     * ];
     *
     * _.map(objects, _.property('a.b.c'));
     * // => [2, 1]
     *
     * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the property value at a given path on `object`.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return baseGet(object, toPath(path), path + '');
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. If `end` is not specified it is
     * set to `start` with `start` then set to `0`. If `end` is less than `start`
     * a zero-length range is created unless a negative `step` is specified.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the new array of numbers.
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    function range(start, end, step) {
      if (step && isIterateeCall(start, end, step)) {
        end = step = undefined;
      }
      start = +start || 0;
      step = step == null ? 1 : (+step || 0);

      if (end == null) {
        end = start;
        start = 0;
      } else {
        end = +end || 0;
      }
      // Use `Array(length)` so engines like Chakra and V8 avoid slower modes.
      // See https://youtu.be/XAqIpGU8ZZk#t=17m25s for more details.
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (++index < length) {
        result[index] = start;
        start += step;
      }
      return result;
    }

    /**
     * Invokes the iteratee function `n` times, returning an array of the results
     * of each invocation. The `iteratee` is bound to `thisArg` and invoked with
     * one argument; (index).
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * var diceRolls = _.times(3, _.partial(_.random, 1, 6, false));
     * // => [3, 6, 4]
     *
     * _.times(3, function(n) {
     *   mage.castSpell(n);
     * });
     * // => invokes `mage.castSpell(n)` three times with `n` of `0`, `1`, and `2`
     *
     * _.times(3, function(n) {
     *   this.cast(n);
     * }, mage);
     * // => also invokes `mage.castSpell(n)` three times
     */
    function times(n, iteratee, thisArg) {
      n = nativeFloor(n);

      // Exit early to avoid a JSC JIT bug in Safari 8
      // where `Array(0)` is treated as `Array(1)`.
      if (n < 1 || !nativeIsFinite(n)) {
        return [];
      }
      var index = -1,
          result = Array(nativeMin(n, MAX_ARRAY_LENGTH));

      iteratee = bindCallback(iteratee, thisArg, 1);
      while (++index < n) {
        if (index < MAX_ARRAY_LENGTH) {
          result[index] = iteratee(index);
        } else {
          iteratee(index);
        }
      }
      return result;
    }

    /**
     * Generates a unique ID. If `prefix` is provided the ID is appended to it.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {string} [prefix] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return baseToString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} augend The first number to add.
     * @param {number} addend The second number to add.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    function add(augend, addend) {
      return (+augend || 0) + (+addend || 0);
    }

    /**
     * Calculates `n` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} n The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Calculates `n` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} n The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Gets the maximum value of `collection`. If `collection` is empty or falsey
     * `-Infinity` is returned. If an iteratee function is provided it is invoked
     * for each value in `collection` to generate the criterion by which the value
     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => -Infinity
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * _.max(users, function(chr) {
     *   return chr.age;
     * });
     * // => { 'user': 'fred', 'age': 40 }
     *
     * // using the `_.property` callback shorthand
     * _.max(users, 'age');
     * // => { 'user': 'fred', 'age': 40 }
     */
    var max = createExtremum(gt, NEGATIVE_INFINITY);

    /**
     * Gets the minimum value of `collection`. If `collection` is empty or falsey
     * `Infinity` is returned. If an iteratee function is provided it is invoked
     * for each value in `collection` to generate the criterion by which the value
     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => Infinity
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * _.min(users, function(chr) {
     *   return chr.age;
     * });
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // using the `_.property` callback shorthand
     * _.min(users, 'age');
     * // => { 'user': 'barney', 'age': 36 }
     */
    var min = createExtremum(lt, POSITIVE_INFINITY);

    /**
     * Calculates `n` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} n The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Gets the sum of the values in `collection`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 6]);
     * // => 10
     *
     * _.sum({ 'a': 4, 'b': 6 });
     * // => 10
     *
     * var objects = [
     *   { 'n': 4 },
     *   { 'n': 6 }
     * ];
     *
     * _.sum(objects, function(object) {
     *   return object.n;
     * });
     * // => 10
     *
     * // using the `_.property` callback shorthand
     * _.sum(objects, 'n');
     * // => 10
     */
    function sum(collection, iteratee, thisArg) {
      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
        iteratee = undefined;
      }
      iteratee = getCallback(iteratee, thisArg, 3);
      return iteratee.length == 1
        ? arraySum(isArray(collection) ? collection : toIterable(collection), iteratee)
        : baseSum(collection, iteratee);
    }

    /*------------------------------------------------------------------------*/

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    // Add functions to the `Map` cache.
    MapCache.prototype['delete'] = mapDelete;
    MapCache.prototype.get = mapGet;
    MapCache.prototype.has = mapHas;
    MapCache.prototype.set = mapSet;

    // Add functions to the `Set` cache.
    SetCache.prototype.push = cachePush;

    // Assign cache to `_.memoize`.
    memoize.Cache = MapCache;

    // Add functions that return wrapped values when chaining.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.callback = callback;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.functions = functions;
    lodash.groupBy = groupBy;
    lodash.indexBy = indexBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.invert = invert;
    lodash.invoke = invoke;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.modArgs = modArgs;
    lodash.negate = negate;
    lodash.omit = omit;
    lodash.once = once;
    lodash.pairs = pairs;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pluck = pluck;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.restParam = restParam;
    lodash.set = set;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortByAll = sortByAll;
    lodash.sortByOrder = sortByOrder;
    lodash.spread = spread;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.times = times;
    lodash.toArray = toArray;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.union = union;
    lodash.uniq = uniq;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.where = where;
    lodash.without = without;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.backflow = flowRight;
    lodash.collect = map;
    lodash.compose = flowRight;
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.extend = assign;
    lodash.iteratee = callback;
    lodash.methods = functions;
    lodash.object = zipObject;
    lodash.select = filter;
    lodash.tail = rest;
    lodash.unique = uniq;

    // Add functions to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add functions that return unwrapped values when chaining.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.deburr = deburr;
    lodash.endsWith = endsWith;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.findWhere = findWhere;
    lodash.first = first;
    lodash.floor = floor;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isBoolean = isBoolean;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isMatch = isMatch;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isString = isString;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.min = min;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padLeft = padLeft;
    lodash.padRight = padRight;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.sum = sum;
    lodash.template = template;
    lodash.trim = trim;
    lodash.trimLeft = trimLeft;
    lodash.trimRight = trimRight;
    lodash.trunc = trunc;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.words = words;

    // Add aliases.
    lodash.all = every;
    lodash.any = some;
    lodash.contains = includes;
    lodash.eq = isEqual;
    lodash.detect = find;
    lodash.foldl = reduce;
    lodash.foldr = reduceRight;
    lodash.head = first;
    lodash.include = includes;
    lodash.inject = reduce;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!lodash.prototype[methodName]) {
          source[methodName] = func;
        }
      });
      return source;
    }()), false);

    /*------------------------------------------------------------------------*/

    // Add functions capable of returning wrapped and unwrapped values when chaining.
    lodash.sample = sample;

    lodash.prototype.sample = function(n) {
      if (!this.__chain__ && n == null) {
        return sample(this.value());
      }
      return this.thru(function(value) {
        return sample(value, n);
      });
    };

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type string
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        var filtered = this.__filtered__;
        if (filtered && !index) {
          return new LazyWrapper(this);
        }
        n = n == null ? 1 : nativeMax(nativeFloor(n) || 0, 0);

        var result = this.clone();
        if (filtered) {
          result.__takeCount__ = nativeMin(result.__takeCount__, n);
        } else {
          result.__views__.push({ 'size': n, 'type': methodName + (result.__dir__ < 0 ? 'Right' : '') });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type != LAZY_MAP_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee, thisArg) {
        var result = this.clone();
        result.__iteratees__.push({ 'iteratee': getCallback(iteratee, thisArg, 1), 'type': type });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.first` and `_.last`.
    arrayEach(['first', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.rest`.
    arrayEach(['initial', 'rest'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    // Add `LazyWrapper` methods for `_.pluck` and `_.where`.
    arrayEach(['pluck', 'where'], function(methodName, index) {
      var operationName = index ? 'filter' : 'map',
          createCallback = index ? baseMatches : property;

      LazyWrapper.prototype[methodName] = function(value) {
        return this[operationName](createCallback(value));
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.reject = function(predicate, thisArg) {
      predicate = getCallback(predicate, thisArg, 1);
      return this.filter(function(value) {
        return !predicate(value);
      });
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = start == null ? 0 : (+start || 0);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = (+end || 0);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate, thisArg) {
      return this.reverse().takeWhile(predicate, thisArg).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(POSITIVE_INFINITY);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|map|reject)|While$/.test(methodName),
          retUnwrapped = /^(?:first|last)$/.test(methodName),
          lodashFunc = lodash[retUnwrapped ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName];

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var args = retUnwrapped ? [1] : arguments,
            chainAll = this.__chain__,
            value = this.__wrapped__,
            isHybrid = !!this.__actions__.length,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var interceptor = function(value) {
          return (retUnwrapped && chainAll)
            ? lodashFunc(value, 1)[0]
            : lodashFunc.apply(undefined, arrayPush([value], args));
        };

        var action = { 'func': thru, 'args': [interceptor], 'thisArg': undefined },
            onlyLazy = isLazy && !isHybrid;

        if (retUnwrapped && !chainAll) {
          if (onlyLazy) {
            value = value.clone();
            value.__actions__.push(action);
            return func.call(value);
          }
          return lodashFunc.call(undefined, this.value())[0];
        }
        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push(action);
          return new LodashWrapper(result, chainAll);
        }
        return this.thru(interceptor);
      };
    });

    // Add `Array` and `String` methods to `lodash.prototype`.
    arrayEach(['join', 'pop', 'push', 'replace', 'shift', 'sort', 'splice', 'split', 'unshift'], function(methodName) {
      var func = (/^(?:replace|split)$/.test(methodName) ? stringProto : arrayProto)[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:join|pop|replace|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          return func.apply(this.value(), args);
        }
        return this[chainName](function(value) {
          return func.apply(value, args);
        });
      };
    });

    // Map minified function names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name,
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybridWrapper(undefined, BIND_KEY_FLAG).name] = [{ 'name': 'wrapper', 'func': undefined }];

    // Add functions to the lazy wrapper.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chaining functions to the `lodash` wrapper.
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.concat = wrapperConcat;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toString = wrapperToString;
    lodash.prototype.run = lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add function aliases to the `lodash` wrapper.
    lodash.prototype.collect = lodash.prototype.map;
    lodash.prototype.head = lodash.prototype.first;
    lodash.prototype.select = lodash.prototype.filter;
    lodash.prototype.tail = lodash.prototype.rest;

    return lodash;
  }

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers like r.js check for condition patterns like the following:
  if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
    // Expose lodash to the global object when an AMD loader is present to avoid
    // errors in cases where lodash is loaded by a script tag and not intended
    // as an AMD module. See http://requirejs.org/docs/errors.html#mismatch for
    // more details.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    define(function() {
      return _;
    });
  }
  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
  else if (freeExports && freeModule) {
    // Export for Node.js or RingoJS.
    if (moduleExports) {
      (freeModule.exports = _)._ = _;
    }
    // Export for Rhino with CommonJS support.
    else {
      freeExports._ = _;
    }
  }
  else {
    // Export for a browser or Rhino.
    root._ = _;
  }
}.call(this));

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],"moment-timezone":[function(require,module,exports){
var moment = module.exports = require("./moment-timezone");
moment.tz.load(require('./data/packed/latest.json'));

},{"./data/packed/latest.json":1164,"./moment-timezone":1165}],"moment":[function(require,module,exports){
//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i,
            arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i,
            prop,
            val,
            momentPropertiesLen = momentProperties.length;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentPropertiesLen > 0) {
            for (i = 0; i < momentPropertiesLen; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key,
                    argLen = arguments.length;
                for (i = 0; i < argLen; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens =
            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i,
                prioritizedLen = prioritized.length;
            for (i = 0; i < prioritizedLen; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord =
            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(
                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                    function (matched, p1, p2, p3, p4) {
                        return p1 || p2 || p3 || p4;
                    }
                )
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback,
            tokenLen;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        tokenLen = token.length;
        for (i = 0; i < tokenLen; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths =
            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                '_'
            ),
        defaultLocaleMonthsShort =
            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(
        ['w', 'ww', 'W', 'WW'],
        function (input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
        }
    );

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays =
            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        return name.match('^[^/\\\\]*$') != null;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports &&
            isLocaleNameSane(name)
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                aliasedRequire('./locale/' + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 =
            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat,
            isoDatesLen = isoDates.length,
            isoTimesLen = isoTimes.length;

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDatesLen; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimesLen; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^()]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era,
            tokenLen;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for (i = 0; i < tokenLen; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false,
            configfLen = config._f.length;

        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < configfLen; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i,
            orderLen = ordering.length;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < orderLen; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex =
            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property,
            propertyLen = properties.length;

        for (i = 0; i < propertyLen; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(
        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
        function (input, array, config, token) {
            var era = config._locale.erasParse(input, token, config._strict);
            if (era) {
                getParsingFlags(config).era = era;
            } else {
                getParsingFlags(config).invalidEra = input;
            }
        }
    );

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(
        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
        function (input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
        }
    );

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.29.4';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));

},{}],"quill":[function(require,module,exports){
(function (Buffer){(function (){
/*!
 * Quill Editor v1.3.7
 * https://quilljs.com/
 * Copyright (c) 2014, Jason Chen
 * Copyright (c) 2013, salesforce.com
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Quill"] = factory();
	else
		root["Quill"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 109);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var container_1 = __webpack_require__(17);
var format_1 = __webpack_require__(18);
var leaf_1 = __webpack_require__(19);
var scroll_1 = __webpack_require__(45);
var inline_1 = __webpack_require__(46);
var block_1 = __webpack_require__(47);
var embed_1 = __webpack_require__(48);
var text_1 = __webpack_require__(49);
var attributor_1 = __webpack_require__(12);
var class_1 = __webpack_require__(32);
var style_1 = __webpack_require__(33);
var store_1 = __webpack_require__(31);
var Registry = __webpack_require__(1);
var Parchment = {
    Scope: Registry.Scope,
    create: Registry.create,
    find: Registry.find,
    query: Registry.query,
    register: Registry.register,
    Container: container_1.default,
    Format: format_1.default,
    Leaf: leaf_1.default,
    Embed: embed_1.default,
    Scroll: scroll_1.default,
    Block: block_1.default,
    Inline: inline_1.default,
    Text: text_1.default,
    Attributor: {
        Attribute: attributor_1.default,
        Class: class_1.default,
        Style: style_1.default,
        Store: store_1.default,
    },
};
exports.default = Parchment;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ParchmentError = /** @class */ (function (_super) {
    __extends(ParchmentError, _super);
    function ParchmentError(message) {
        var _this = this;
        message = '[Parchment] ' + message;
        _this = _super.call(this, message) || this;
        _this.message = message;
        _this.name = _this.constructor.name;
        return _this;
    }
    return ParchmentError;
}(Error));
exports.ParchmentError = ParchmentError;
var attributes = {};
var classes = {};
var tags = {};
var types = {};
exports.DATA_KEY = '__blot';
var Scope;
(function (Scope) {
    Scope[Scope["TYPE"] = 3] = "TYPE";
    Scope[Scope["LEVEL"] = 12] = "LEVEL";
    Scope[Scope["ATTRIBUTE"] = 13] = "ATTRIBUTE";
    Scope[Scope["BLOT"] = 14] = "BLOT";
    Scope[Scope["INLINE"] = 7] = "INLINE";
    Scope[Scope["BLOCK"] = 11] = "BLOCK";
    Scope[Scope["BLOCK_BLOT"] = 10] = "BLOCK_BLOT";
    Scope[Scope["INLINE_BLOT"] = 6] = "INLINE_BLOT";
    Scope[Scope["BLOCK_ATTRIBUTE"] = 9] = "BLOCK_ATTRIBUTE";
    Scope[Scope["INLINE_ATTRIBUTE"] = 5] = "INLINE_ATTRIBUTE";
    Scope[Scope["ANY"] = 15] = "ANY";
})(Scope = exports.Scope || (exports.Scope = {}));
function create(input, value) {
    var match = query(input);
    if (match == null) {
        throw new ParchmentError("Unable to create " + input + " blot");
    }
    var BlotClass = match;
    var node = 
    // @ts-ignore
    input instanceof Node || input['nodeType'] === Node.TEXT_NODE ? input : BlotClass.create(value);
    return new BlotClass(node, value);
}
exports.create = create;
function find(node, bubble) {
    if (bubble === void 0) { bubble = false; }
    if (node == null)
        return null;
    // @ts-ignore
    if (node[exports.DATA_KEY] != null)
        return node[exports.DATA_KEY].blot;
    if (bubble)
        return find(node.parentNode, bubble);
    return null;
}
exports.find = find;
function query(query, scope) {
    if (scope === void 0) { scope = Scope.ANY; }
    var match;
    if (typeof query === 'string') {
        match = types[query] || attributes[query];
        // @ts-ignore
    }
    else if (query instanceof Text || query['nodeType'] === Node.TEXT_NODE) {
        match = types['text'];
    }
    else if (typeof query === 'number') {
        if (query & Scope.LEVEL & Scope.BLOCK) {
            match = types['block'];
        }
        else if (query & Scope.LEVEL & Scope.INLINE) {
            match = types['inline'];
        }
    }
    else if (query instanceof HTMLElement) {
        var names = (query.getAttribute('class') || '').split(/\s+/);
        for (var i in names) {
            match = classes[names[i]];
            if (match)
                break;
        }
        match = match || tags[query.tagName];
    }
    if (match == null)
        return null;
    // @ts-ignore
    if (scope & Scope.LEVEL & match.scope && scope & Scope.TYPE & match.scope)
        return match;
    return null;
}
exports.query = query;
function register() {
    var Definitions = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        Definitions[_i] = arguments[_i];
    }
    if (Definitions.length > 1) {
        return Definitions.map(function (d) {
            return register(d);
        });
    }
    var Definition = Definitions[0];
    if (typeof Definition.blotName !== 'string' && typeof Definition.attrName !== 'string') {
        throw new ParchmentError('Invalid definition');
    }
    else if (Definition.blotName === 'abstract') {
        throw new ParchmentError('Cannot register abstract class');
    }
    types[Definition.blotName || Definition.attrName] = Definition;
    if (typeof Definition.keyName === 'string') {
        attributes[Definition.keyName] = Definition;
    }
    else {
        if (Definition.className != null) {
            classes[Definition.className] = Definition;
        }
        if (Definition.tagName != null) {
            if (Array.isArray(Definition.tagName)) {
                Definition.tagName = Definition.tagName.map(function (tagName) {
                    return tagName.toUpperCase();
                });
            }
            else {
                Definition.tagName = Definition.tagName.toUpperCase();
            }
            var tagNames = Array.isArray(Definition.tagName) ? Definition.tagName : [Definition.tagName];
            tagNames.forEach(function (tag) {
                if (tags[tag] == null || Definition.className == null) {
                    tags[tag] = Definition;
                }
            });
        }
    }
    return Definition;
}
exports.register = register;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var diff = __webpack_require__(51);
var equal = __webpack_require__(11);
var extend = __webpack_require__(3);
var op = __webpack_require__(20);


var NULL_CHARACTER = String.fromCharCode(0);  // Placeholder char for embed in diff()


var Delta = function (ops) {
  // Assume we are given a well formed ops
  if (Array.isArray(ops)) {
    this.ops = ops;
  } else if (ops != null && Array.isArray(ops.ops)) {
    this.ops = ops.ops;
  } else {
    this.ops = [];
  }
};


Delta.prototype.insert = function (text, attributes) {
  var newOp = {};
  if (text.length === 0) return this;
  newOp.insert = text;
  if (attributes != null && typeof attributes === 'object' && Object.keys(attributes).length > 0) {
    newOp.attributes = attributes;
  }
  return this.push(newOp);
};

Delta.prototype['delete'] = function (length) {
  if (length <= 0) return this;
  return this.push({ 'delete': length });
};

Delta.prototype.retain = function (length, attributes) {
  if (length <= 0) return this;
  var newOp = { retain: length };
  if (attributes != null && typeof attributes === 'object' && Object.keys(attributes).length > 0) {
    newOp.attributes = attributes;
  }
  return this.push(newOp);
};

Delta.prototype.push = function (newOp) {
  var index = this.ops.length;
  var lastOp = this.ops[index - 1];
  newOp = extend(true, {}, newOp);
  if (typeof lastOp === 'object') {
    if (typeof newOp['delete'] === 'number' && typeof lastOp['delete'] === 'number') {
      this.ops[index - 1] = { 'delete': lastOp['delete'] + newOp['delete'] };
      return this;
    }
    // Since it does not matter if we insert before or after deleting at the same index,
    // always prefer to insert first
    if (typeof lastOp['delete'] === 'number' && newOp.insert != null) {
      index -= 1;
      lastOp = this.ops[index - 1];
      if (typeof lastOp !== 'object') {
        this.ops.unshift(newOp);
        return this;
      }
    }
    if (equal(newOp.attributes, lastOp.attributes)) {
      if (typeof newOp.insert === 'string' && typeof lastOp.insert === 'string') {
        this.ops[index - 1] = { insert: lastOp.insert + newOp.insert };
        if (typeof newOp.attributes === 'object') this.ops[index - 1].attributes = newOp.attributes
        return this;
      } else if (typeof newOp.retain === 'number' && typeof lastOp.retain === 'number') {
        this.ops[index - 1] = { retain: lastOp.retain + newOp.retain };
        if (typeof newOp.attributes === 'object') this.ops[index - 1].attributes = newOp.attributes
        return this;
      }
    }
  }
  if (index === this.ops.length) {
    this.ops.push(newOp);
  } else {
    this.ops.splice(index, 0, newOp);
  }
  return this;
};

Delta.prototype.chop = function () {
  var lastOp = this.ops[this.ops.length - 1];
  if (lastOp && lastOp.retain && !lastOp.attributes) {
    this.ops.pop();
  }
  return this;
};

Delta.prototype.filter = function (predicate) {
  return this.ops.filter(predicate);
};

Delta.prototype.forEach = function (predicate) {
  this.ops.forEach(predicate);
};

Delta.prototype.map = function (predicate) {
  return this.ops.map(predicate);
};

Delta.prototype.partition = function (predicate) {
  var passed = [], failed = [];
  this.forEach(function(op) {
    var target = predicate(op) ? passed : failed;
    target.push(op);
  });
  return [passed, failed];
};

Delta.prototype.reduce = function (predicate, initial) {
  return this.ops.reduce(predicate, initial);
};

Delta.prototype.changeLength = function () {
  return this.reduce(function (length, elem) {
    if (elem.insert) {
      return length + op.length(elem);
    } else if (elem.delete) {
      return length - elem.delete;
    }
    return length;
  }, 0);
};

Delta.prototype.length = function () {
  return this.reduce(function (length, elem) {
    return length + op.length(elem);
  }, 0);
};

Delta.prototype.slice = function (start, end) {
  start = start || 0;
  if (typeof end !== 'number') end = Infinity;
  var ops = [];
  var iter = op.iterator(this.ops);
  var index = 0;
  while (index < end && iter.hasNext()) {
    var nextOp;
    if (index < start) {
      nextOp = iter.next(start - index);
    } else {
      nextOp = iter.next(end - index);
      ops.push(nextOp);
    }
    index += op.length(nextOp);
  }
  return new Delta(ops);
};


Delta.prototype.compose = function (other) {
  var thisIter = op.iterator(this.ops);
  var otherIter = op.iterator(other.ops);
  var ops = [];
  var firstOther = otherIter.peek();
  if (firstOther != null && typeof firstOther.retain === 'number' && firstOther.attributes == null) {
    var firstLeft = firstOther.retain;
    while (thisIter.peekType() === 'insert' && thisIter.peekLength() <= firstLeft) {
      firstLeft -= thisIter.peekLength();
      ops.push(thisIter.next());
    }
    if (firstOther.retain - firstLeft > 0) {
      otherIter.next(firstOther.retain - firstLeft);
    }
  }
  var delta = new Delta(ops);
  while (thisIter.hasNext() || otherIter.hasNext()) {
    if (otherIter.peekType() === 'insert') {
      delta.push(otherIter.next());
    } else if (thisIter.peekType() === 'delete') {
      delta.push(thisIter.next());
    } else {
      var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
      var thisOp = thisIter.next(length);
      var otherOp = otherIter.next(length);
      if (typeof otherOp.retain === 'number') {
        var newOp = {};
        if (typeof thisOp.retain === 'number') {
          newOp.retain = length;
        } else {
          newOp.insert = thisOp.insert;
        }
        // Preserve null when composing with a retain, otherwise remove it for inserts
        var attributes = op.attributes.compose(thisOp.attributes, otherOp.attributes, typeof thisOp.retain === 'number');
        if (attributes) newOp.attributes = attributes;
        delta.push(newOp);

        // Optimization if rest of other is just retain
        if (!otherIter.hasNext() && equal(delta.ops[delta.ops.length - 1], newOp)) {
          var rest = new Delta(thisIter.rest());
          return delta.concat(rest).chop();
        }

      // Other op should be delete, we could be an insert or retain
      // Insert + delete cancels out
      } else if (typeof otherOp['delete'] === 'number' && typeof thisOp.retain === 'number') {
        delta.push(otherOp);
      }
    }
  }
  return delta.chop();
};

Delta.prototype.concat = function (other) {
  var delta = new Delta(this.ops.slice());
  if (other.ops.length > 0) {
    delta.push(other.ops[0]);
    delta.ops = delta.ops.concat(other.ops.slice(1));
  }
  return delta;
};

Delta.prototype.diff = function (other, index) {
  if (this.ops === other.ops) {
    return new Delta();
  }
  var strings = [this, other].map(function (delta) {
    return delta.map(function (op) {
      if (op.insert != null) {
        return typeof op.insert === 'string' ? op.insert : NULL_CHARACTER;
      }
      var prep = (delta === other) ? 'on' : 'with';
      throw new Error('diff() called ' + prep + ' non-document');
    }).join('');
  });
  var delta = new Delta();
  var diffResult = diff(strings[0], strings[1], index);
  var thisIter = op.iterator(this.ops);
  var otherIter = op.iterator(other.ops);
  diffResult.forEach(function (component) {
    var length = component[1].length;
    while (length > 0) {
      var opLength = 0;
      switch (component[0]) {
        case diff.INSERT:
          opLength = Math.min(otherIter.peekLength(), length);
          delta.push(otherIter.next(opLength));
          break;
        case diff.DELETE:
          opLength = Math.min(length, thisIter.peekLength());
          thisIter.next(opLength);
          delta['delete'](opLength);
          break;
        case diff.EQUAL:
          opLength = Math.min(thisIter.peekLength(), otherIter.peekLength(), length);
          var thisOp = thisIter.next(opLength);
          var otherOp = otherIter.next(opLength);
          if (equal(thisOp.insert, otherOp.insert)) {
            delta.retain(opLength, op.attributes.diff(thisOp.attributes, otherOp.attributes));
          } else {
            delta.push(otherOp)['delete'](opLength);
          }
          break;
      }
      length -= opLength;
    }
  });
  return delta.chop();
};

Delta.prototype.eachLine = function (predicate, newline) {
  newline = newline || '\n';
  var iter = op.iterator(this.ops);
  var line = new Delta();
  var i = 0;
  while (iter.hasNext()) {
    if (iter.peekType() !== 'insert') return;
    var thisOp = iter.peek();
    var start = op.length(thisOp) - iter.peekLength();
    var index = typeof thisOp.insert === 'string' ?
      thisOp.insert.indexOf(newline, start) - start : -1;
    if (index < 0) {
      line.push(iter.next());
    } else if (index > 0) {
      line.push(iter.next(index));
    } else {
      if (predicate(line, iter.next(1).attributes || {}, i) === false) {
        return;
      }
      i += 1;
      line = new Delta();
    }
  }
  if (line.length() > 0) {
    predicate(line, {}, i);
  }
};

Delta.prototype.transform = function (other, priority) {
  priority = !!priority;
  if (typeof other === 'number') {
    return this.transformPosition(other, priority);
  }
  var thisIter = op.iterator(this.ops);
  var otherIter = op.iterator(other.ops);
  var delta = new Delta();
  while (thisIter.hasNext() || otherIter.hasNext()) {
    if (thisIter.peekType() === 'insert' && (priority || otherIter.peekType() !== 'insert')) {
      delta.retain(op.length(thisIter.next()));
    } else if (otherIter.peekType() === 'insert') {
      delta.push(otherIter.next());
    } else {
      var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
      var thisOp = thisIter.next(length);
      var otherOp = otherIter.next(length);
      if (thisOp['delete']) {
        // Our delete either makes their delete redundant or removes their retain
        continue;
      } else if (otherOp['delete']) {
        delta.push(otherOp);
      } else {
        // We retain either their retain or insert
        delta.retain(length, op.attributes.transform(thisOp.attributes, otherOp.attributes, priority));
      }
    }
  }
  return delta.chop();
};

Delta.prototype.transformPosition = function (index, priority) {
  priority = !!priority;
  var thisIter = op.iterator(this.ops);
  var offset = 0;
  while (thisIter.hasNext() && offset <= index) {
    var length = thisIter.peekLength();
    var nextType = thisIter.peekType();
    thisIter.next();
    if (nextType === 'delete') {
      index -= Math.min(length, index - offset);
      continue;
    } else if (nextType === 'insert' && (offset < index || !priority)) {
      index += length;
    }
    offset += length;
  }
  return index;
};


module.exports = Delta;


/***/ }),
/* 3 */
/***/ (function(module, exports) {

'use strict';

var hasOwn = Object.prototype.hasOwnProperty;
var toStr = Object.prototype.toString;
var defineProperty = Object.defineProperty;
var gOPD = Object.getOwnPropertyDescriptor;

var isArray = function isArray(arr) {
	if (typeof Array.isArray === 'function') {
		return Array.isArray(arr);
	}

	return toStr.call(arr) === '[object Array]';
};

var isPlainObject = function isPlainObject(obj) {
	if (!obj || toStr.call(obj) !== '[object Object]') {
		return false;
	}

	var hasOwnConstructor = hasOwn.call(obj, 'constructor');
	var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
	// Not own constructor property must be Object
	if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
		return false;
	}

	// Own properties are enumerated firstly, so to speed up,
	// if last one is own, then all properties are own.
	var key;
	for (key in obj) { /**/ }

	return typeof key === 'undefined' || hasOwn.call(obj, key);
};

// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var setProperty = function setProperty(target, options) {
	if (defineProperty && options.name === '__proto__') {
		defineProperty(target, options.name, {
			enumerable: true,
			configurable: true,
			value: options.newValue,
			writable: true
		});
	} else {
		target[options.name] = options.newValue;
	}
};

// Return undefined instead of __proto__ if '__proto__' is not an own property
var getProperty = function getProperty(obj, name) {
	if (name === '__proto__') {
		if (!hasOwn.call(obj, name)) {
			return void 0;
		} else if (gOPD) {
			// In early versions of node, obj['__proto__'] is buggy when obj has
			// __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
			return gOPD(obj, name).value;
		}
	}

	return obj[name];
};

module.exports = function extend() {
	var options, name, src, copy, copyIsArray, clone;
	var target = arguments[0];
	var i = 1;
	var length = arguments.length;
	var deep = false;

	// Handle a deep copy situation
	if (typeof target === 'boolean') {
		deep = target;
		target = arguments[1] || {};
		// skip the boolean and the target
		i = 2;
	}
	if (target == null || (typeof target !== 'object' && typeof target !== 'function')) {
		target = {};
	}

	for (; i < length; ++i) {
		options = arguments[i];
		// Only deal with non-null/undefined values
		if (options != null) {
			// Extend the base object
			for (name in options) {
				src = getProperty(target, name);
				copy = getProperty(options, name);

				// Prevent never-ending loop
				if (target !== copy) {
					// Recurse if we're merging plain objects or arrays
					if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
						if (copyIsArray) {
							copyIsArray = false;
							clone = src && isArray(src) ? src : [];
						} else {
							clone = src && isPlainObject(src) ? src : {};
						}

						// Never move original objects, clone them
						setProperty(target, { name: name, newValue: extend(deep, clone, copy) });

					// Don't bring in undefined values
					} else if (typeof copy !== 'undefined') {
						setProperty(target, { name: name, newValue: copy });
					}
				}
			}
		}
	}

	// Return the modified object
	return target;
};


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BlockEmbed = exports.bubbleFormats = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _extend = __webpack_require__(3);

var _extend2 = _interopRequireDefault(_extend);

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _break = __webpack_require__(16);

var _break2 = _interopRequireDefault(_break);

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

var _text = __webpack_require__(7);

var _text2 = _interopRequireDefault(_text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NEWLINE_LENGTH = 1;

var BlockEmbed = function (_Parchment$Embed) {
  _inherits(BlockEmbed, _Parchment$Embed);

  function BlockEmbed() {
    _classCallCheck(this, BlockEmbed);

    return _possibleConstructorReturn(this, (BlockEmbed.__proto__ || Object.getPrototypeOf(BlockEmbed)).apply(this, arguments));
  }

  _createClass(BlockEmbed, [{
    key: 'attach',
    value: function attach() {
      _get(BlockEmbed.prototype.__proto__ || Object.getPrototypeOf(BlockEmbed.prototype), 'attach', this).call(this);
      this.attributes = new _parchment2.default.Attributor.Store(this.domNode);
    }
  }, {
    key: 'delta',
    value: function delta() {
      return new _quillDelta2.default().insert(this.value(), (0, _extend2.default)(this.formats(), this.attributes.values()));
    }
  }, {
    key: 'format',
    value: function format(name, value) {
      var attribute = _parchment2.default.query(name, _parchment2.default.Scope.BLOCK_ATTRIBUTE);
      if (attribute != null) {
        this.attributes.attribute(attribute, value);
      }
    }
  }, {
    key: 'formatAt',
    value: function formatAt(index, length, name, value) {
      this.format(name, value);
    }
  }, {
    key: 'insertAt',
    value: function insertAt(index, value, def) {
      if (typeof value === 'string' && value.endsWith('\n')) {
        var block = _parchment2.default.create(Block.blotName);
        this.parent.insertBefore(block, index === 0 ? this : this.next);
        block.insertAt(0, value.slice(0, -1));
      } else {
        _get(BlockEmbed.prototype.__proto__ || Object.getPrototypeOf(BlockEmbed.prototype), 'insertAt', this).call(this, index, value, def);
      }
    }
  }]);

  return BlockEmbed;
}(_parchment2.default.Embed);

BlockEmbed.scope = _parchment2.default.Scope.BLOCK_BLOT;
// It is important for cursor behavior BlockEmbeds use tags that are block level elements


var Block = function (_Parchment$Block) {
  _inherits(Block, _Parchment$Block);

  function Block(domNode) {
    _classCallCheck(this, Block);

    var _this2 = _possibleConstructorReturn(this, (Block.__proto__ || Object.getPrototypeOf(Block)).call(this, domNode));

    _this2.cache = {};
    return _this2;
  }

  _createClass(Block, [{
    key: 'delta',
    value: function delta() {
      if (this.cache.delta == null) {
        this.cache.delta = this.descendants(_parchment2.default.Leaf).reduce(function (delta, leaf) {
          if (leaf.length() === 0) {
            return delta;
          } else {
            return delta.insert(leaf.value(), bubbleFormats(leaf));
          }
        }, new _quillDelta2.default()).insert('\n', bubbleFormats(this));
      }
      return this.cache.delta;
    }
  }, {
    key: 'deleteAt',
    value: function deleteAt(index, length) {
      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'deleteAt', this).call(this, index, length);
      this.cache = {};
    }
  }, {
    key: 'formatAt',
    value: function formatAt(index, length, name, value) {
      if (length <= 0) return;
      if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK)) {
        if (index + length === this.length()) {
          this.format(name, value);
        }
      } else {
        _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'formatAt', this).call(this, index, Math.min(length, this.length() - index - 1), name, value);
      }
      this.cache = {};
    }
  }, {
    key: 'insertAt',
    value: function insertAt(index, value, def) {
      if (def != null) return _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertAt', this).call(this, index, value, def);
      if (value.length === 0) return;
      var lines = value.split('\n');
      var text = lines.shift();
      if (text.length > 0) {
        if (index < this.length() - 1 || this.children.tail == null) {
          _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertAt', this).call(this, Math.min(index, this.length() - 1), text);
        } else {
          this.children.tail.insertAt(this.children.tail.length(), text);
        }
        this.cache = {};
      }
      var block = this;
      lines.reduce(function (index, line) {
        block = block.split(index, true);
        block.insertAt(0, line);
        return line.length;
      }, index + text.length);
    }
  }, {
    key: 'insertBefore',
    value: function insertBefore(blot, ref) {
      var head = this.children.head;
      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertBefore', this).call(this, blot, ref);
      if (head instanceof _break2.default) {
        head.remove();
      }
      this.cache = {};
    }
  }, {
    key: 'length',
    value: function length() {
      if (this.cache.length == null) {
        this.cache.length = _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'length', this).call(this) + NEWLINE_LENGTH;
      }
      return this.cache.length;
    }
  }, {
    key: 'moveChildren',
    value: function moveChildren(target, ref) {
      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'moveChildren', this).call(this, target, ref);
      this.cache = {};
    }
  }, {
    key: 'optimize',
    value: function optimize(context) {
      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'optimize', this).call(this, context);
      this.cache = {};
    }
  }, {
    key: 'path',
    value: function path(index) {
      return _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'path', this).call(this, index, true);
    }
  }, {
    key: 'removeChild',
    value: function removeChild(child) {
      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'removeChild', this).call(this, child);
      this.cache = {};
    }
  }, {
    key: 'split',
    value: function split(index) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (force && (index === 0 || index >= this.length() - NEWLINE_LENGTH)) {
        var clone = this.clone();
        if (index === 0) {
          this.parent.insertBefore(clone, this);
          return this;
        } else {
          this.parent.insertBefore(clone, this.next);
          return clone;
        }
      } else {
        var next = _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'split', this).call(this, index, force);
        this.cache = {};
        return next;
      }
    }
  }]);

  return Block;
}(_parchment2.default.Block);

Block.blotName = 'block';
Block.tagName = 'P';
Block.defaultChild = 'break';
Block.allowedChildren = [_inline2.default, _parchment2.default.Embed, _text2.default];

function bubbleFormats(blot) {
  var formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (blot == null) return formats;
  if (typeof blot.formats === 'function') {
    formats = (0, _extend2.default)(formats, blot.formats());
  }
  if (blot.parent == null || blot.parent.blotName == 'scroll' || blot.parent.statics.scope !== blot.statics.scope) {
    return formats;
  }
  return bubbleFormats(blot.parent, formats);
}

exports.bubbleFormats = bubbleFormats;
exports.BlockEmbed = BlockEmbed;
exports.default = Block;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.overload = exports.expandConfig = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(50);

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _editor = __webpack_require__(14);

var _editor2 = _interopRequireDefault(_editor);

var _emitter3 = __webpack_require__(8);

var _emitter4 = _interopRequireDefault(_emitter3);

var _module = __webpack_require__(9);

var _module2 = _interopRequireDefault(_module);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _selection = __webpack_require__(15);

var _selection2 = _interopRequireDefault(_selection);

var _extend = __webpack_require__(3);

var _extend2 = _interopRequireDefault(_extend);

var _logger = __webpack_require__(10);

var _logger2 = _interopRequireDefault(_logger);

var _theme = __webpack_require__(34);

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var debug = (0, _logger2.default)('quill');

var Quill = function () {
  _createClass(Quill, null, [{
    key: 'debug',
    value: function debug(limit) {
      if (limit === true) {
        limit = 'log';
      }
      _logger2.default.level(limit);
    }
  }, {
    key: 'find',
    value: function find(node) {
      return node.__quill || _parchment2.default.find(node);
    }
  }, {
    key: 'import',
    value: function _import(name) {
      if (this.imports[name] == null) {
        debug.error('Cannot import ' + name + '. Are you sure it was registered?');
      }
      return this.imports[name];
    }
  }, {
    key: 'register',
    value: function register(path, target) {
      var _this = this;

      var overwrite = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (typeof path !== 'string') {
        var name = path.attrName || path.blotName;
        if (typeof name === 'string') {
          // register(Blot | Attributor, overwrite)
          this.register('formats/' + name, path, target);
        } else {
          Object.keys(path).forEach(function (key) {
            _this.register(key, path[key], target);
          });
        }
      } else {
        if (this.imports[path] != null && !overwrite) {
          debug.warn('Overwriting ' + path + ' with', target);
        }
        this.imports[path] = target;
        if ((path.startsWith('blots/') || path.startsWith('formats/')) && target.blotName !== 'abstract') {
          _parchment2.default.register(target);
        } else if (path.startsWith('modules') && typeof target.register === 'function') {
          target.register();
        }
      }
    }
  }]);

  function Quill(container) {
    var _this2 = this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Quill);

    this.options = expandConfig(container, options);
    this.container = this.options.container;
    if (this.container == null) {
      return debug.error('Invalid Quill container', container);
    }
    if (this.options.debug) {
      Quill.debug(this.options.debug);
    }
    var html = this.container.innerHTML.trim();
    this.container.classList.add('ql-container');
    this.container.innerHTML = '';
    this.container.__quill = this;
    this.root = this.addContainer('ql-editor');
    this.root.classList.add('ql-blank');
    this.root.setAttribute('data-gramm', false);
    this.scrollingContainer = this.options.scrollingContainer || this.root;
    this.emitter = new _emitter4.default();
    this.scroll = _parchment2.default.create(this.root, {
      emitter: this.emitter,
      whitelist: this.options.formats
    });
    this.editor = new _editor2.default(this.scroll);
    this.selection = new _selection2.default(this.scroll, this.emitter);
    this.theme = new this.options.theme(this, this.options);
    this.keyboard = this.theme.addModule('keyboard');
    this.clipboard = this.theme.addModule('clipboard');
    this.history = this.theme.addModule('history');
    this.theme.init();
    this.emitter.on(_emitter4.default.events.EDITOR_CHANGE, function (type) {
      if (type === _emitter4.default.events.TEXT_CHANGE) {
        _this2.root.classList.toggle('ql-blank', _this2.editor.isBlank());
      }
    });
    this.emitter.on(_emitter4.default.events.SCROLL_UPDATE, function (source, mutations) {
      var range = _this2.selection.lastRange;
      var index = range && range.length === 0 ? range.index : undefined;
      modify.call(_this2, function () {
        return _this2.editor.update(null, mutations, index);
      }, source);
    });
    var contents = this.clipboard.convert('<div class=\'ql-editor\' style="white-space: normal;">' + html + '<p><br></p></div>');
    this.setContents(contents);
    this.history.clear();
    if (this.options.placeholder) {
      this.root.setAttribute('data-placeholder', this.options.placeholder);
    }
    if (this.options.readOnly) {
      this.disable();
    }
  }

  _createClass(Quill, [{
    key: 'addContainer',
    value: function addContainer(container) {
      var refNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (typeof container === 'string') {
        var className = container;
        container = document.createElement('div');
        container.classList.add(className);
      }
      this.container.insertBefore(container, refNode);
      return container;
    }
  }, {
    key: 'blur',
    value: function blur() {
      this.selection.setRange(null);
    }
  }, {
    key: 'deleteText',
    value: function deleteText(index, length, source) {
      var _this3 = this;

      var _overload = overload(index, length, source);

      var _overload2 = _slicedToArray(_overload, 4);

      index = _overload2[0];
      length = _overload2[1];
      source = _overload2[3];

      return modify.call(this, function () {
        return _this3.editor.deleteText(index, length);
      }, source, index, -1 * length);
    }
  }, {
    key: 'disable',
    value: function disable() {
      this.enable(false);
    }
  }, {
    key: 'enable',
    value: function enable() {
      var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.scroll.enable(enabled);
      this.container.classList.toggle('ql-disabled', !enabled);
    }
  }, {
    key: 'focus',
    value: function focus() {
      var scrollTop = this.scrollingContainer.scrollTop;
      this.selection.focus();
      this.scrollingContainer.scrollTop = scrollTop;
      this.scrollIntoView();
    }
  }, {
    key: 'format',
    value: function format(name, value) {
      var _this4 = this;

      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _emitter4.default.sources.API;

      return modify.call(this, function () {
        var range = _this4.getSelection(true);
        var change = new _quillDelta2.default();
        if (range == null) {
          return change;
        } else if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK)) {
          change = _this4.editor.formatLine(range.index, range.length, _defineProperty({}, name, value));
        } else if (range.length === 0) {
          _this4.selection.format(name, value);
          return change;
        } else {
          change = _this4.editor.formatText(range.index, range.length, _defineProperty({}, name, value));
        }
        _this4.setSelection(range, _emitter4.default.sources.SILENT);
        return change;
      }, source);
    }
  }, {
    key: 'formatLine',
    value: function formatLine(index, length, name, value, source) {
      var _this5 = this;

      var formats = void 0;

      var _overload3 = overload(index, length, name, value, source);

      var _overload4 = _slicedToArray(_overload3, 4);

      index = _overload4[0];
      length = _overload4[1];
      formats = _overload4[2];
      source = _overload4[3];

      return modify.call(this, function () {
        return _this5.editor.formatLine(index, length, formats);
      }, source, index, 0);
    }
  }, {
    key: 'formatText',
    value: function formatText(index, length, name, value, source) {
      var _this6 = this;

      var formats = void 0;

      var _overload5 = overload(index, length, name, value, source);

      var _overload6 = _slicedToArray(_overload5, 4);

      index = _overload6[0];
      length = _overload6[1];
      formats = _overload6[2];
      source = _overload6[3];

      return modify.call(this, function () {
        return _this6.editor.formatText(index, length, formats);
      }, source, index, 0);
    }
  }, {
    key: 'getBounds',
    value: function getBounds(index) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var bounds = void 0;
      if (typeof index === 'number') {
        bounds = this.selection.getBounds(index, length);
      } else {
        bounds = this.selection.getBounds(index.index, index.length);
      }
      var containerBounds = this.container.getBoundingClientRect();
      return {
        bottom: bounds.bottom - containerBounds.top,
        height: bounds.height,
        left: bounds.left - containerBounds.left,
        right: bounds.right - containerBounds.left,
        top: bounds.top - containerBounds.top,
        width: bounds.width
      };
    }
  }, {
    key: 'getContents',
    value: function getContents() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;

      var _overload7 = overload(index, length);

      var _overload8 = _slicedToArray(_overload7, 2);

      index = _overload8[0];
      length = _overload8[1];

      return this.editor.getContents(index, length);
    }
  }, {
    key: 'getFormat',
    value: function getFormat() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getSelection(true);
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (typeof index === 'number') {
        return this.editor.getFormat(index, length);
      } else {
        return this.editor.getFormat(index.index, index.length);
      }
    }
  }, {
    key: 'getIndex',
    value: function getIndex(blot) {
      return blot.offset(this.scroll);
    }
  }, {
    key: 'getLength',
    value: function getLength() {
      return this.scroll.length();
    }
  }, {
    key: 'getLeaf',
    value: function getLeaf(index) {
      return this.scroll.leaf(index);
    }
  }, {
    key: 'getLine',
    value: function getLine(index) {
      return this.scroll.line(index);
    }
  }, {
    key: 'getLines',
    value: function getLines() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;

      if (typeof index !== 'number') {
        return this.scroll.lines(index.index, index.length);
      } else {
        return this.scroll.lines(index, length);
      }
    }
  }, {
    key: 'getModule',
    value: function getModule(name) {
      return this.theme.modules[name];
    }
  }, {
    key: 'getSelection',
    value: function getSelection() {
      var focus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (focus) this.focus();
      this.update(); // Make sure we access getRange with editor in consistent state
      return this.selection.getRange()[0];
    }
  }, {
    key: 'getText',
    value: function getText() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;

      var _overload9 = overload(index, length);

      var _overload10 = _slicedToArray(_overload9, 2);

      index = _overload10[0];
      length = _overload10[1];

      return this.editor.getText(index, length);
    }
  }, {
    key: 'hasFocus',
    value: function hasFocus() {
      return this.selection.hasFocus();
    }
  }, {
    key: 'insertEmbed',
    value: function insertEmbed(index, embed, value) {
      var _this7 = this;

      var source = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Quill.sources.API;

      return modify.call(this, function () {
        return _this7.editor.insertEmbed(index, embed, value);
      }, source, index);
    }
  }, {
    key: 'insertText',
    value: function insertText(index, text, name, value, source) {
      var _this8 = this;

      var formats = void 0;

      var _overload11 = overload(index, 0, name, value, source);

      var _overload12 = _slicedToArray(_overload11, 4);

      index = _overload12[0];
      formats = _overload12[2];
      source = _overload12[3];

      return modify.call(this, function () {
        return _this8.editor.insertText(index, text, formats);
      }, source, index, text.length);
    }
  }, {
    key: 'isEnabled',
    value: function isEnabled() {
      return !this.container.classList.contains('ql-disabled');
    }
  }, {
    key: 'off',
    value: function off() {
      return this.emitter.off.apply(this.emitter, arguments);
    }
  }, {
    key: 'on',
    value: function on() {
      return this.emitter.on.apply(this.emitter, arguments);
    }
  }, {
    key: 'once',
    value: function once() {
      return this.emitter.once.apply(this.emitter, arguments);
    }
  }, {
    key: 'pasteHTML',
    value: function pasteHTML(index, html, source) {
      this.clipboard.dangerouslyPasteHTML(index, html, source);
    }
  }, {
    key: 'removeFormat',
    value: function removeFormat(index, length, source) {
      var _this9 = this;

      var _overload13 = overload(index, length, source);

      var _overload14 = _slicedToArray(_overload13, 4);

      index = _overload14[0];
      length = _overload14[1];
      source = _overload14[3];

      return modify.call(this, function () {
        return _this9.editor.removeFormat(index, length);
      }, source, index);
    }
  }, {
    key: 'scrollIntoView',
    value: function scrollIntoView() {
      this.selection.scrollIntoView(this.scrollingContainer);
    }
  }, {
    key: 'setContents',
    value: function setContents(delta) {
      var _this10 = this;

      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;

      return modify.call(this, function () {
        delta = new _quillDelta2.default(delta);
        var length = _this10.getLength();
        var deleted = _this10.editor.deleteText(0, length);
        var applied = _this10.editor.applyDelta(delta);
        var lastOp = applied.ops[applied.ops.length - 1];
        if (lastOp != null && typeof lastOp.insert === 'string' && lastOp.insert[lastOp.insert.length - 1] === '\n') {
          _this10.editor.deleteText(_this10.getLength() - 1, 1);
          applied.delete(1);
        }
        var ret = deleted.compose(applied);
        return ret;
      }, source);
    }
  }, {
    key: 'setSelection',
    value: function setSelection(index, length, source) {
      if (index == null) {
        this.selection.setRange(null, length || Quill.sources.API);
      } else {
        var _overload15 = overload(index, length, source);

        var _overload16 = _slicedToArray(_overload15, 4);

        index = _overload16[0];
        length = _overload16[1];
        source = _overload16[3];

        this.selection.setRange(new _selection.Range(index, length), source);
        if (source !== _emitter4.default.sources.SILENT) {
          this.selection.scrollIntoView(this.scrollingContainer);
        }
      }
    }
  }, {
    key: 'setText',
    value: function setText(text) {
      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;

      var delta = new _quillDelta2.default().insert(text);
      return this.setContents(delta, source);
    }
  }, {
    key: 'update',
    value: function update() {
      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emitter4.default.sources.USER;

      var change = this.scroll.update(source); // Will update selection before selection.update() does if text changes
      this.selection.update(source);
      return change;
    }
  }, {
    key: 'updateContents',
    value: function updateContents(delta) {
      var _this11 = this;

      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;

      return modify.call(this, function () {
        delta = new _quillDelta2.default(delta);
        return _this11.editor.applyDelta(delta, source);
      }, source, true);
    }
  }]);

  return Quill;
}();

Quill.DEFAULTS = {
  bounds: null,
  formats: null,
  modules: {},
  placeholder: '',
  readOnly: false,
  scrollingContainer: null,
  strict: true,
  theme: 'default'
};
Quill.events = _emitter4.default.events;
Quill.sources = _emitter4.default.sources;
// eslint-disable-next-line no-undef
Quill.version =  false ? 'dev' : "1.3.7";

Quill.imports = {
  'delta': _quillDelta2.default,
  'parchment': _parchment2.default,
  'core/module': _module2.default,
  'core/theme': _theme2.default
};

function expandConfig(container, userConfig) {
  userConfig = (0, _extend2.default)(true, {
    container: container,
    modules: {
      clipboard: true,
      keyboard: true,
      history: true
    }
  }, userConfig);
  if (!userConfig.theme || userConfig.theme === Quill.DEFAULTS.theme) {
    userConfig.theme = _theme2.default;
  } else {
    userConfig.theme = Quill.import('themes/' + userConfig.theme);
    if (userConfig.theme == null) {
      throw new Error('Invalid theme ' + userConfig.theme + '. Did you register it?');
    }
  }
  var themeConfig = (0, _extend2.default)(true, {}, userConfig.theme.DEFAULTS);
  [themeConfig, userConfig].forEach(function (config) {
    config.modules = config.modules || {};
    Object.keys(config.modules).forEach(function (module) {
      if (config.modules[module] === true) {
        config.modules[module] = {};
      }
    });
  });
  var moduleNames = Object.keys(themeConfig.modules).concat(Object.keys(userConfig.modules));
  var moduleConfig = moduleNames.reduce(function (config, name) {
    var moduleClass = Quill.import('modules/' + name);
    if (moduleClass == null) {
      debug.error('Cannot load ' + name + ' module. Are you sure you registered it?');
    } else {
      config[name] = moduleClass.DEFAULTS || {};
    }
    return config;
  }, {});
  // Special case toolbar shorthand
  if (userConfig.modules != null && userConfig.modules.toolbar && userConfig.modules.toolbar.constructor !== Object) {
    userConfig.modules.toolbar = {
      container: userConfig.modules.toolbar
    };
  }
  userConfig = (0, _extend2.default)(true, {}, Quill.DEFAULTS, { modules: moduleConfig }, themeConfig, userConfig);
  ['bounds', 'container', 'scrollingContainer'].forEach(function (key) {
    if (typeof userConfig[key] === 'string') {
      userConfig[key] = document.querySelector(userConfig[key]);
    }
  });
  userConfig.modules = Object.keys(userConfig.modules).reduce(function (config, name) {
    if (userConfig.modules[name]) {
      config[name] = userConfig.modules[name];
    }
    return config;
  }, {});
  return userConfig;
}

// Handle selection preservation and TEXT_CHANGE emission
// common to modification APIs
function modify(modifier, source, index, shift) {
  if (this.options.strict && !this.isEnabled() && source === _emitter4.default.sources.USER) {
    return new _quillDelta2.default();
  }
  var range = index == null ? null : this.getSelection();
  var oldDelta = this.editor.delta;
  var change = modifier();
  if (range != null) {
    if (index === true) index = range.index;
    if (shift == null) {
      range = shiftRange(range, change, source);
    } else if (shift !== 0) {
      range = shiftRange(range, index, shift, source);
    }
    this.setSelection(range, _emitter4.default.sources.SILENT);
  }
  if (change.length() > 0) {
    var _emitter;

    var args = [_emitter4.default.events.TEXT_CHANGE, change, oldDelta, source];
    (_emitter = this.emitter).emit.apply(_emitter, [_emitter4.default.events.EDITOR_CHANGE].concat(args));
    if (source !== _emitter4.default.sources.SILENT) {
      var _emitter2;

      (_emitter2 = this.emitter).emit.apply(_emitter2, args);
    }
  }
  return change;
}

function overload(index, length, name, value, source) {
  var formats = {};
  if (typeof index.index === 'number' && typeof index.length === 'number') {
    // Allow for throwaway end (used by insertText/insertEmbed)
    if (typeof length !== 'number') {
      source = value, value = name, name = length, length = index.length, index = index.index;
    } else {
      length = index.length, index = index.index;
    }
  } else if (typeof length !== 'number') {
    source = value, value = name, name = length, length = 0;
  }
  // Handle format being object, two format name/value strings or excluded
  if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
    formats = name;
    source = value;
  } else if (typeof name === 'string') {
    if (value != null) {
      formats[name] = value;
    } else {
      source = name;
    }
  }
  // Handle optional source
  source = source || _emitter4.default.sources.API;
  return [index, length, formats, source];
}

function shiftRange(range, index, length, source) {
  if (range == null) return null;
  var start = void 0,
      end = void 0;
  if (index instanceof _quillDelta2.default) {
    var _map = [range.index, range.index + range.length].map(function (pos) {
      return index.transformPosition(pos, source !== _emitter4.default.sources.USER);
    });

    var _map2 = _slicedToArray(_map, 2);

    start = _map2[0];
    end = _map2[1];
  } else {
    var _map3 = [range.index, range.index + range.length].map(function (pos) {
      if (pos < index || pos === index && source === _emitter4.default.sources.USER) return pos;
      if (length >= 0) {
        return pos + length;
      } else {
        return Math.max(index, pos + length);
      }
    });

    var _map4 = _slicedToArray(_map3, 2);

    start = _map4[0];
    end = _map4[1];
  }
  return new _selection.Range(start, end - start);
}

exports.expandConfig = expandConfig;
exports.overload = overload;
exports.default = Quill;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _text = __webpack_require__(7);

var _text2 = _interopRequireDefault(_text);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Inline = function (_Parchment$Inline) {
  _inherits(Inline, _Parchment$Inline);

  function Inline() {
    _classCallCheck(this, Inline);

    return _possibleConstructorReturn(this, (Inline.__proto__ || Object.getPrototypeOf(Inline)).apply(this, arguments));
  }

  _createClass(Inline, [{
    key: 'formatAt',
    value: function formatAt(index, length, name, value) {
      if (Inline.compare(this.statics.blotName, name) < 0 && _parchment2.default.query(name, _parchment2.default.Scope.BLOT)) {
        var blot = this.isolate(index, length);
        if (value) {
          blot.wrap(name, value);
        }
      } else {
        _get(Inline.prototype.__proto__ || Object.getPrototypeOf(Inline.prototype), 'formatAt', this).call(this, index, length, name, value);
      }
    }
  }, {
    key: 'optimize',
    value: function optimize(context) {
      _get(Inline.prototype.__proto__ || Object.getPrototypeOf(Inline.prototype), 'optimize', this).call(this, context);
      if (this.parent instanceof Inline && Inline.compare(this.statics.blotName, this.parent.statics.blotName) > 0) {
        var parent = this.parent.isolate(this.offset(), this.length());
        this.moveChildren(parent);
        parent.wrap(this);
      }
    }
  }], [{
    key: 'compare',
    value: function compare(self, other) {
      var selfIndex = Inline.order.indexOf(self);
      var otherIndex = Inline.order.indexOf(other);
      if (selfIndex >= 0 || otherIndex >= 0) {
        return selfIndex - otherIndex;
      } else if (self === other) {
        return 0;
      } else if (self < other) {
        return -1;
      } else {
        return 1;
      }
    }
  }]);

  return Inline;
}(_parchment2.default.Inline);

Inline.allowedChildren = [Inline, _parchment2.default.Embed, _text2.default];
// Lower index means deeper in the DOM tree, since not found (-1) is for embeds
Inline.order = ['cursor', 'inline', // Must be lower
'underline', 'strike', 'italic', 'bold', 'script', 'link', 'code' // Must be higher
];

exports.default = Inline;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextBlot = function (_Parchment$Text) {
  _inherits(TextBlot, _Parchment$Text);

  function TextBlot() {
    _classCallCheck(this, TextBlot);

    return _possibleConstructorReturn(this, (TextBlot.__proto__ || Object.getPrototypeOf(TextBlot)).apply(this, arguments));
  }

  return TextBlot;
}(_parchment2.default.Text);

exports.default = TextBlot;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _eventemitter = __webpack_require__(54);

var _eventemitter2 = _interopRequireDefault(_eventemitter);

var _logger = __webpack_require__(10);

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var debug = (0, _logger2.default)('quill:events');

var EVENTS = ['selectionchange', 'mousedown', 'mouseup', 'click'];

EVENTS.forEach(function (eventName) {
  document.addEventListener(eventName, function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    [].slice.call(document.querySelectorAll('.ql-container')).forEach(function (node) {
      // TODO use WeakMap
      if (node.__quill && node.__quill.emitter) {
        var _node$__quill$emitter;

        (_node$__quill$emitter = node.__quill.emitter).handleDOM.apply(_node$__quill$emitter, args);
      }
    });
  });
});

var Emitter = function (_EventEmitter) {
  _inherits(Emitter, _EventEmitter);

  function Emitter() {
    _classCallCheck(this, Emitter);

    var _this = _possibleConstructorReturn(this, (Emitter.__proto__ || Object.getPrototypeOf(Emitter)).call(this));

    _this.listeners = {};
    _this.on('error', debug.error);
    return _this;
  }

  _createClass(Emitter, [{
    key: 'emit',
    value: function emit() {
      debug.log.apply(debug, arguments);
      _get(Emitter.prototype.__proto__ || Object.getPrototypeOf(Emitter.prototype), 'emit', this).apply(this, arguments);
    }
  }, {
    key: 'handleDOM',
    value: function handleDOM(event) {
      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      (this.listeners[event.type] || []).forEach(function (_ref) {
        var node = _ref.node,
            handler = _ref.handler;

        if (event.target === node || node.contains(event.target)) {
          handler.apply(undefined, [event].concat(args));
        }
      });
    }
  }, {
    key: 'listenDOM',
    value: function listenDOM(eventName, node, handler) {
      if (!this.listeners[eventName]) {
        this.listeners[eventName] = [];
      }
      this.listeners[eventName].push({ node: node, handler: handler });
    }
  }]);

  return Emitter;
}(_eventemitter2.default);

Emitter.events = {
  EDITOR_CHANGE: 'editor-change',
  SCROLL_BEFORE_UPDATE: 'scroll-before-update',
  SCROLL_OPTIMIZE: 'scroll-optimize',
  SCROLL_UPDATE: 'scroll-update',
  SELECTION_CHANGE: 'selection-change',
  TEXT_CHANGE: 'text-change'
};
Emitter.sources = {
  API: 'api',
  SILENT: 'silent',
  USER: 'user'
};

exports.default = Emitter;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Module = function Module(quill) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  _classCallCheck(this, Module);

  this.quill = quill;
  this.options = options;
};

Module.DEFAULTS = {};

exports.default = Module;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var levels = ['error', 'warn', 'log', 'info'];
var level = 'warn';

function debug(method) {
  if (levels.indexOf(method) <= levels.indexOf(level)) {
    var _console;

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    (_console = console)[method].apply(_console, args); // eslint-disable-line no-console
  }
}

function namespace(ns) {
  return levels.reduce(function (logger, method) {
    logger[method] = debug.bind(console, method, ns);
    return logger;
  }, {});
}

debug.level = namespace.level = function (newLevel) {
  level = newLevel;
};

exports.default = namespace;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var pSlice = Array.prototype.slice;
var objectKeys = __webpack_require__(52);
var isArguments = __webpack_require__(53);

var deepEqual = module.exports = function (actual, expected, opts) {
  if (!opts) opts = {};
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;

  } else if (actual instanceof Date && expected instanceof Date) {
    return actual.getTime() === expected.getTime();

  // 7.3. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
    return opts.strict ? actual === expected : actual == expected;

  // 7.4. For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else {
    return objEquiv(actual, expected, opts);
  }
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer (x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') return false;
  return true;
}

function objEquiv(a, b, opts) {
  var i, key;
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
    return false;
  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) return false;
  //~~~I've managed to break Object.keys through screwy arguments passing.
  //   Converting to array solves the problem.
  if (isArguments(a)) {
    if (!isArguments(b)) {
      return false;
    }
    a = pSlice.call(a);
    b = pSlice.call(b);
    return deepEqual(a, b, opts);
  }
  if (isBuffer(a)) {
    if (!isBuffer(b)) {
      return false;
    }
    if (a.length !== b.length) return false;
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }
  try {
    var ka = objectKeys(a),
        kb = objectKeys(b);
  } catch (e) {//happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length != kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) return false;
  }
  return typeof a === typeof b;
}


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Registry = __webpack_require__(1);
var Attributor = /** @class */ (function () {
    function Attributor(attrName, keyName, options) {
        if (options === void 0) { options = {}; }
        this.attrName = attrName;
        this.keyName = keyName;
        var attributeBit = Registry.Scope.TYPE & Registry.Scope.ATTRIBUTE;
        if (options.scope != null) {
            // Ignore type bits, force attribute bit
            this.scope = (options.scope & Registry.Scope.LEVEL) | attributeBit;
        }
        else {
            this.scope = Registry.Scope.ATTRIBUTE;
        }
        if (options.whitelist != null)
            this.whitelist = options.whitelist;
    }
    Attributor.keys = function (node) {
        return [].map.call(node.attributes, function (item) {
            return item.name;
        });
    };
    Attributor.prototype.add = function (node, value) {
        if (!this.canAdd(node, value))
            return false;
        node.setAttribute(this.keyName, value);
        return true;
    };
    Attributor.prototype.canAdd = function (node, value) {
        var match = Registry.query(node, Registry.Scope.BLOT & (this.scope | Registry.Scope.TYPE));
        if (match == null)
            return false;
        if (this.whitelist == null)
            return true;
        if (typeof value === 'string') {
            return this.whitelist.indexOf(value.replace(/["']/g, '')) > -1;
        }
        else {
            return this.whitelist.indexOf(value) > -1;
        }
    };
    Attributor.prototype.remove = function (node) {
        node.removeAttribute(this.keyName);
    };
    Attributor.prototype.value = function (node) {
        var value = node.getAttribute(this.keyName);
        if (this.canAdd(node, value) && value) {
            return value;
        }
        return '';
    };
    return Attributor;
}());
exports.default = Attributor;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Code = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

var _text = __webpack_require__(7);

var _text2 = _interopRequireDefault(_text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Code = function (_Inline) {
  _inherits(Code, _Inline);

  function Code() {
    _classCallCheck(this, Code);

    return _possibleConstructorReturn(this, (Code.__proto__ || Object.getPrototypeOf(Code)).apply(this, arguments));
  }

  return Code;
}(_inline2.default);

Code.blotName = 'code';
Code.tagName = 'CODE';

var CodeBlock = function (_Block) {
  _inherits(CodeBlock, _Block);

  function CodeBlock() {
    _classCallCheck(this, CodeBlock);

    return _possibleConstructorReturn(this, (CodeBlock.__proto__ || Object.getPrototypeOf(CodeBlock)).apply(this, arguments));
  }

  _createClass(CodeBlock, [{
    key: 'delta',
    value: function delta() {
      var _this3 = this;

      var text = this.domNode.textContent;
      if (text.endsWith('\n')) {
        // Should always be true
        text = text.slice(0, -1);
      }
      return text.split('\n').reduce(function (delta, frag) {
        return delta.insert(frag).insert('\n', _this3.formats());
      }, new _quillDelta2.default());
    }
  }, {
    key: 'format',
    value: function format(name, value) {
      if (name === this.statics.blotName && value) return;

      var _descendant = this.descendant(_text2.default, this.length() - 1),
          _descendant2 = _slicedToArray(_descendant, 1),
          text = _descendant2[0];

      if (text != null) {
        text.deleteAt(text.length() - 1, 1);
      }
      _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'format', this).call(this, name, value);
    }
  }, {
    key: 'formatAt',
    value: function formatAt(index, length, name, value) {
      if (length === 0) return;
      if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK) == null || name === this.statics.blotName && value === this.statics.formats(this.domNode)) {
        return;
      }
      var nextNewline = this.newlineIndex(index);
      if (nextNewline < 0 || nextNewline >= index + length) return;
      var prevNewline = this.newlineIndex(index, true) + 1;
      var isolateLength = nextNewline - prevNewline + 1;
      var blot = this.isolate(prevNewline, isolateLength);
      var next = blot.next;
      blot.format(name, value);
      if (next instanceof CodeBlock) {
        next.formatAt(0, index - prevNewline + length - isolateLength, name, value);
      }
    }
  }, {
    key: 'insertAt',
    value: function insertAt(index, value, def) {
      if (def != null) return;

      var _descendant3 = this.descendant(_text2.default, index),
          _descendant4 = _slicedToArray(_descendant3, 2),
          text = _descendant4[0],
          offset = _descendant4[1];

      text.insertAt(offset, value);
    }
  }, {
    key: 'length',
    value: function length() {
      var length = this.domNode.textContent.length;
      if (!this.domNode.textContent.endsWith('\n')) {
        return length + 1;
      }
      return length;
    }
  }, {
    key: 'newlineIndex',
    value: function newlineIndex(searchIndex) {
      var reverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!reverse) {
        var offset = this.domNode.textContent.slice(searchIndex).indexOf('\n');
        return offset > -1 ? searchIndex + offset : -1;
      } else {
        return this.domNode.textContent.slice(0, searchIndex).lastIndexOf('\n');
      }
    }
  }, {
    key: 'optimize',
    value: function optimize(context) {
      if (!this.domNode.textContent.endsWith('\n')) {
        this.appendChild(_parchment2.default.create('text', '\n'));
      }
      _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'optimize', this).call(this, context);
      var next = this.next;
      if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && this.statics.formats(this.domNode) === next.statics.formats(next.domNode)) {
        next.optimize(context);
        next.moveChildren(this);
        next.remove();
      }
    }
  }, {
    key: 'replace',
    value: function replace(target) {
      _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'replace', this).call(this, target);
      [].slice.call(this.domNode.querySelectorAll('*')).forEach(function (node) {
        var blot = _parchment2.default.find(node);
        if (blot == null) {
          node.parentNode.removeChild(node);
        } else if (blot instanceof _parchment2.default.Embed) {
          blot.remove();
        } else {
          blot.unwrap();
        }
      });
    }
  }], [{
    key: 'create',
    value: function create(value) {
      var domNode = _get(CodeBlock.__proto__ || Object.getPrototypeOf(CodeBlock), 'create', this).call(this, value);
      domNode.setAttribute('spellcheck', false);
      return domNode;
    }
  }, {
    key: 'formats',
    value: function formats() {
      return true;
    }
  }]);

  return CodeBlock;
}(_block2.default);

CodeBlock.blotName = 'code-block';
CodeBlock.tagName = 'PRE';
CodeBlock.TAB = '  ';

exports.Code = Code;
exports.default = CodeBlock;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _op = __webpack_require__(20);

var _op2 = _interopRequireDefault(_op);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _code = __webpack_require__(13);

var _code2 = _interopRequireDefault(_code);

var _cursor = __webpack_require__(24);

var _cursor2 = _interopRequireDefault(_cursor);

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

var _break = __webpack_require__(16);

var _break2 = _interopRequireDefault(_break);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _deepEqual = __webpack_require__(11);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _extend = __webpack_require__(3);

var _extend2 = _interopRequireDefault(_extend);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ASCII = /^[ -~]*$/;

var Editor = function () {
  function Editor(scroll) {
    _classCallCheck(this, Editor);

    this.scroll = scroll;
    this.delta = this.getDelta();
  }

  _createClass(Editor, [{
    key: 'applyDelta',
    value: function applyDelta(delta) {
      var _this = this;

      var consumeNextNewline = false;
      this.scroll.update();
      var scrollLength = this.scroll.length();
      this.scroll.batchStart();
      delta = normalizeDelta(delta);
      delta.reduce(function (index, op) {
        var length = op.retain || op.delete || op.insert.length || 1;
        var attributes = op.attributes || {};
        if (op.insert != null) {
          if (typeof op.insert === 'string') {
            var text = op.insert;
            if (text.endsWith('\n') && consumeNextNewline) {
              consumeNextNewline = false;
              text = text.slice(0, -1);
            }
            if (index >= scrollLength && !text.endsWith('\n')) {
              consumeNextNewline = true;
            }
            _this.scroll.insertAt(index, text);

            var _scroll$line = _this.scroll.line(index),
                _scroll$line2 = _slicedToArray(_scroll$line, 2),
                line = _scroll$line2[0],
                offset = _scroll$line2[1];

            var formats = (0, _extend2.default)({}, (0, _block.bubbleFormats)(line));
            if (line instanceof _block2.default) {
              var _line$descendant = line.descendant(_parchment2.default.Leaf, offset),
                  _line$descendant2 = _slicedToArray(_line$descendant, 1),
                  leaf = _line$descendant2[0];

              formats = (0, _extend2.default)(formats, (0, _block.bubbleFormats)(leaf));
            }
            attributes = _op2.default.attributes.diff(formats, attributes) || {};
          } else if (_typeof(op.insert) === 'object') {
            var key = Object.keys(op.insert)[0]; // There should only be one key
            if (key == null) return index;
            _this.scroll.insertAt(index, key, op.insert[key]);
          }
          scrollLength += length;
        }
        Object.keys(attributes).forEach(function (name) {
          _this.scroll.formatAt(index, length, name, attributes[name]);
        });
        return index + length;
      }, 0);
      delta.reduce(function (index, op) {
        if (typeof op.delete === 'number') {
          _this.scroll.deleteAt(index, op.delete);
          return index;
        }
        return index + (op.retain || op.insert.length || 1);
      }, 0);
      this.scroll.batchEnd();
      return this.update(delta);
    }
  }, {
    key: 'deleteText',
    value: function deleteText(index, length) {
      this.scroll.deleteAt(index, length);
      return this.update(new _quillDelta2.default().retain(index).delete(length));
    }
  }, {
    key: 'formatLine',
    value: function formatLine(index, length) {
      var _this2 = this;

      var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      this.scroll.update();
      Object.keys(formats).forEach(function (format) {
        if (_this2.scroll.whitelist != null && !_this2.scroll.whitelist[format]) return;
        var lines = _this2.scroll.lines(index, Math.max(length, 1));
        var lengthRemaining = length;
        lines.forEach(function (line) {
          var lineLength = line.length();
          if (!(line instanceof _code2.default)) {
            line.format(format, formats[format]);
          } else {
            var codeIndex = index - line.offset(_this2.scroll);
            var codeLength = line.newlineIndex(codeIndex + lengthRemaining) - codeIndex + 1;
            line.formatAt(codeIndex, codeLength, format, formats[format]);
          }
          lengthRemaining -= lineLength;
        });
      });
      this.scroll.optimize();
      return this.update(new _quillDelta2.default().retain(index).retain(length, (0, _clone2.default)(formats)));
    }
  }, {
    key: 'formatText',
    value: function formatText(index, length) {
      var _this3 = this;

      var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      Object.keys(formats).forEach(function (format) {
        _this3.scroll.formatAt(index, length, format, formats[format]);
      });
      return this.update(new _quillDelta2.default().retain(index).retain(length, (0, _clone2.default)(formats)));
    }
  }, {
    key: 'getContents',
    value: function getContents(index, length) {
      return this.delta.slice(index, index + length);
    }
  }, {
    key: 'getDelta',
    value: function getDelta() {
      return this.scroll.lines().reduce(function (delta, line) {
        return delta.concat(line.delta());
      }, new _quillDelta2.default());
    }
  }, {
    key: 'getFormat',
    value: function getFormat(index) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var lines = [],
          leaves = [];
      if (length === 0) {
        this.scroll.path(index).forEach(function (path) {
          var _path = _slicedToArray(path, 1),
              blot = _path[0];

          if (blot instanceof _block2.default) {
            lines.push(blot);
          } else if (blot instanceof _parchment2.default.Leaf) {
            leaves.push(blot);
          }
        });
      } else {
        lines = this.scroll.lines(index, length);
        leaves = this.scroll.descendants(_parchment2.default.Leaf, index, length);
      }
      var formatsArr = [lines, leaves].map(function (blots) {
        if (blots.length === 0) return {};
        var formats = (0, _block.bubbleFormats)(blots.shift());
        while (Object.keys(formats).length > 0) {
          var blot = blots.shift();
          if (blot == null) return formats;
          formats = combineFormats((0, _block.bubbleFormats)(blot), formats);
        }
        return formats;
      });
      return _extend2.default.apply(_extend2.default, formatsArr);
    }
  }, {
    key: 'getText',
    value: function getText(index, length) {
      return this.getContents(index, length).filter(function (op) {
        return typeof op.insert === 'string';
      }).map(function (op) {
        return op.insert;
      }).join('');
    }
  }, {
    key: 'insertEmbed',
    value: function insertEmbed(index, embed, value) {
      this.scroll.insertAt(index, embed, value);
      return this.update(new _quillDelta2.default().retain(index).insert(_defineProperty({}, embed, value)));
    }
  }, {
    key: 'insertText',
    value: function insertText(index, text) {
      var _this4 = this;

      var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      text = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
      this.scroll.insertAt(index, text);
      Object.keys(formats).forEach(function (format) {
        _this4.scroll.formatAt(index, text.length, format, formats[format]);
      });
      return this.update(new _quillDelta2.default().retain(index).insert(text, (0, _clone2.default)(formats)));
    }
  }, {
    key: 'isBlank',
    value: function isBlank() {
      if (this.scroll.children.length == 0) return true;
      if (this.scroll.children.length > 1) return false;
      var block = this.scroll.children.head;
      if (block.statics.blotName !== _block2.default.blotName) return false;
      if (block.children.length > 1) return false;
      return block.children.head instanceof _break2.default;
    }
  }, {
    key: 'removeFormat',
    value: function removeFormat(index, length) {
      var text = this.getText(index, length);

      var _scroll$line3 = this.scroll.line(index + length),
          _scroll$line4 = _slicedToArray(_scroll$line3, 2),
          line = _scroll$line4[0],
          offset = _scroll$line4[1];

      var suffixLength = 0,
          suffix = new _quillDelta2.default();
      if (line != null) {
        if (!(line instanceof _code2.default)) {
          suffixLength = line.length() - offset;
        } else {
          suffixLength = line.newlineIndex(offset) - offset + 1;
        }
        suffix = line.delta().slice(offset, offset + suffixLength - 1).insert('\n');
      }
      var contents = this.getContents(index, length + suffixLength);
      var diff = contents.diff(new _quillDelta2.default().insert(text).concat(suffix));
      var delta = new _quillDelta2.default().retain(index).concat(diff);
      return this.applyDelta(delta);
    }
  }, {
    key: 'update',
    value: function update(change) {
      var mutations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var cursorIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

      var oldDelta = this.delta;
      if (mutations.length === 1 && mutations[0].type === 'characterData' && mutations[0].target.data.match(ASCII) && _parchment2.default.find(mutations[0].target)) {
        // Optimization for character changes
        var textBlot = _parchment2.default.find(mutations[0].target);
        var formats = (0, _block.bubbleFormats)(textBlot);
        var index = textBlot.offset(this.scroll);
        var oldValue = mutations[0].oldValue.replace(_cursor2.default.CONTENTS, '');
        var oldText = new _quillDelta2.default().insert(oldValue);
        var newText = new _quillDelta2.default().insert(textBlot.value());
        var diffDelta = new _quillDelta2.default().retain(index).concat(oldText.diff(newText, cursorIndex));
        change = diffDelta.reduce(function (delta, op) {
          if (op.insert) {
            return delta.insert(op.insert, formats);
          } else {
            return delta.push(op);
          }
        }, new _quillDelta2.default());
        this.delta = oldDelta.compose(change);
      } else {
        this.delta = this.getDelta();
        if (!change || !(0, _deepEqual2.default)(oldDelta.compose(change), this.delta)) {
          change = oldDelta.diff(this.delta, cursorIndex);
        }
      }
      return change;
    }
  }]);

  return Editor;
}();

function combineFormats(formats, combined) {
  return Object.keys(combined).reduce(function (merged, name) {
    if (formats[name] == null) return merged;
    if (combined[name] === formats[name]) {
      merged[name] = combined[name];
    } else if (Array.isArray(combined[name])) {
      if (combined[name].indexOf(formats[name]) < 0) {
        merged[name] = combined[name].concat([formats[name]]);
      }
    } else {
      merged[name] = [combined[name], formats[name]];
    }
    return merged;
  }, {});
}

function normalizeDelta(delta) {
  return delta.reduce(function (delta, op) {
    if (op.insert === 1) {
      var attributes = (0, _clone2.default)(op.attributes);
      delete attributes['image'];
      return delta.insert({ image: op.attributes.image }, attributes);
    }
    if (op.attributes != null && (op.attributes.list === true || op.attributes.bullet === true)) {
      op = (0, _clone2.default)(op);
      if (op.attributes.list) {
        op.attributes.list = 'ordered';
      } else {
        op.attributes.list = 'bullet';
        delete op.attributes.bullet;
      }
    }
    if (typeof op.insert === 'string') {
      var text = op.insert.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
      return delta.insert(text, op.attributes);
    }
    return delta.push(op);
  }, new _quillDelta2.default());
}

exports.default = Editor;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Range = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _deepEqual = __webpack_require__(11);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _emitter3 = __webpack_require__(8);

var _emitter4 = _interopRequireDefault(_emitter3);

var _logger = __webpack_require__(10);

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var debug = (0, _logger2.default)('quill:selection');

var Range = function Range(index) {
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  _classCallCheck(this, Range);

  this.index = index;
  this.length = length;
};

var Selection = function () {
  function Selection(scroll, emitter) {
    var _this = this;

    _classCallCheck(this, Selection);

    this.emitter = emitter;
    this.scroll = scroll;
    this.composing = false;
    this.mouseDown = false;
    this.root = this.scroll.domNode;
    this.cursor = _parchment2.default.create('cursor', this);
    // savedRange is last non-null range
    this.lastRange = this.savedRange = new Range(0, 0);
    this.handleComposition();
    this.handleDragging();
    this.emitter.listenDOM('selectionchange', document, function () {
      if (!_this.mouseDown) {
        setTimeout(_this.update.bind(_this, _emitter4.default.sources.USER), 1);
      }
    });
    this.emitter.on(_emitter4.default.events.EDITOR_CHANGE, function (type, delta) {
      if (type === _emitter4.default.events.TEXT_CHANGE && delta.length() > 0) {
        _this.update(_emitter4.default.sources.SILENT);
      }
    });
    this.emitter.on(_emitter4.default.events.SCROLL_BEFORE_UPDATE, function () {
      if (!_this.hasFocus()) return;
      var native = _this.getNativeRange();
      if (native == null) return;
      if (native.start.node === _this.cursor.textNode) return; // cursor.restore() will handle
      // TODO unclear if this has negative side effects
      _this.emitter.once(_emitter4.default.events.SCROLL_UPDATE, function () {
        try {
          _this.setNativeRange(native.start.node, native.start.offset, native.end.node, native.end.offset);
        } catch (ignored) {}
      });
    });
    this.emitter.on(_emitter4.default.events.SCROLL_OPTIMIZE, function (mutations, context) {
      if (context.range) {
        var _context$range = context.range,
            startNode = _context$range.startNode,
            startOffset = _context$range.startOffset,
            endNode = _context$range.endNode,
            endOffset = _context$range.endOffset;

        _this.setNativeRange(startNode, startOffset, endNode, endOffset);
      }
    });
    this.update(_emitter4.default.sources.SILENT);
  }

  _createClass(Selection, [{
    key: 'handleComposition',
    value: function handleComposition() {
      var _this2 = this;

      this.root.addEventListener('compositionstart', function () {
        _this2.composing = true;
      });
      this.root.addEventListener('compositionend', function () {
        _this2.composing = false;
        if (_this2.cursor.parent) {
          var range = _this2.cursor.restore();
          if (!range) return;
          setTimeout(function () {
            _this2.setNativeRange(range.startNode, range.startOffset, range.endNode, range.endOffset);
          }, 1);
        }
      });
    }
  }, {
    key: 'handleDragging',
    value: function handleDragging() {
      var _this3 = this;

      this.emitter.listenDOM('mousedown', document.body, function () {
        _this3.mouseDown = true;
      });
      this.emitter.listenDOM('mouseup', document.body, function () {
        _this3.mouseDown = false;
        _this3.update(_emitter4.default.sources.USER);
      });
    }
  }, {
    key: 'focus',
    value: function focus() {
      if (this.hasFocus()) return;
      this.root.focus();
      this.setRange(this.savedRange);
    }
  }, {
    key: 'format',
    value: function format(_format, value) {
      if (this.scroll.whitelist != null && !this.scroll.whitelist[_format]) return;
      this.scroll.update();
      var nativeRange = this.getNativeRange();
      if (nativeRange == null || !nativeRange.native.collapsed || _parchment2.default.query(_format, _parchment2.default.Scope.BLOCK)) return;
      if (nativeRange.start.node !== this.cursor.textNode) {
        var blot = _parchment2.default.find(nativeRange.start.node, false);
        if (blot == null) return;
        // TODO Give blot ability to not split
        if (blot instanceof _parchment2.default.Leaf) {
          var after = blot.split(nativeRange.start.offset);
          blot.parent.insertBefore(this.cursor, after);
        } else {
          blot.insertBefore(this.cursor, nativeRange.start.node); // Should never happen
        }
        this.cursor.attach();
      }
      this.cursor.format(_format, value);
      this.scroll.optimize();
      this.setNativeRange(this.cursor.textNode, this.cursor.textNode.data.length);
      this.update();
    }
  }, {
    key: 'getBounds',
    value: function getBounds(index) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var scrollLength = this.scroll.length();
      index = Math.min(index, scrollLength - 1);
      length = Math.min(index + length, scrollLength - 1) - index;
      var node = void 0,
          _scroll$leaf = this.scroll.leaf(index),
          _scroll$leaf2 = _slicedToArray(_scroll$leaf, 2),
          leaf = _scroll$leaf2[0],
          offset = _scroll$leaf2[1];
      if (leaf == null) return null;

      var _leaf$position = leaf.position(offset, true);

      var _leaf$position2 = _slicedToArray(_leaf$position, 2);

      node = _leaf$position2[0];
      offset = _leaf$position2[1];

      var range = document.createRange();
      if (length > 0) {
        range.setStart(node, offset);

        var _scroll$leaf3 = this.scroll.leaf(index + length);

        var _scroll$leaf4 = _slicedToArray(_scroll$leaf3, 2);

        leaf = _scroll$leaf4[0];
        offset = _scroll$leaf4[1];

        if (leaf == null) return null;

        var _leaf$position3 = leaf.position(offset, true);

        var _leaf$position4 = _slicedToArray(_leaf$position3, 2);

        node = _leaf$position4[0];
        offset = _leaf$position4[1];

        range.setEnd(node, offset);
        return range.getBoundingClientRect();
      } else {
        var side = 'left';
        var rect = void 0;
        if (node instanceof Text) {
          if (offset < node.data.length) {
            range.setStart(node, offset);
            range.setEnd(node, offset + 1);
          } else {
            range.setStart(node, offset - 1);
            range.setEnd(node, offset);
            side = 'right';
          }
          rect = range.getBoundingClientRect();
        } else {
          rect = leaf.domNode.getBoundingClientRect();
          if (offset > 0) side = 'right';
        }
        return {
          bottom: rect.top + rect.height,
          height: rect.height,
          left: rect[side],
          right: rect[side],
          top: rect.top,
          width: 0
        };
      }
    }
  }, {
    key: 'getNativeRange',
    value: function getNativeRange() {
      var selection = document.getSelection();
      if (selection == null || selection.rangeCount <= 0) return null;
      var nativeRange = selection.getRangeAt(0);
      if (nativeRange == null) return null;
      var range = this.normalizeNative(nativeRange);
      debug.info('getNativeRange', range);
      return range;
    }
  }, {
    key: 'getRange',
    value: function getRange() {
      var normalized = this.getNativeRange();
      if (normalized == null) return [null, null];
      var range = this.normalizedToRange(normalized);
      return [range, normalized];
    }
  }, {
    key: 'hasFocus',
    value: function hasFocus() {
      return document.activeElement === this.root;
    }
  }, {
    key: 'normalizedToRange',
    value: function normalizedToRange(range) {
      var _this4 = this;

      var positions = [[range.start.node, range.start.offset]];
      if (!range.native.collapsed) {
        positions.push([range.end.node, range.end.offset]);
      }
      var indexes = positions.map(function (position) {
        var _position = _slicedToArray(position, 2),
            node = _position[0],
            offset = _position[1];

        var blot = _parchment2.default.find(node, true);
        var index = blot.offset(_this4.scroll);
        if (offset === 0) {
          return index;
        } else if (blot instanceof _parchment2.default.Container) {
          return index + blot.length();
        } else {
          return index + blot.index(node, offset);
        }
      });
      var end = Math.min(Math.max.apply(Math, _toConsumableArray(indexes)), this.scroll.length() - 1);
      var start = Math.min.apply(Math, [end].concat(_toConsumableArray(indexes)));
      return new Range(start, end - start);
    }
  }, {
    key: 'normalizeNative',
    value: function normalizeNative(nativeRange) {
      if (!contains(this.root, nativeRange.startContainer) || !nativeRange.collapsed && !contains(this.root, nativeRange.endContainer)) {
        return null;
      }
      var range = {
        start: { node: nativeRange.startContainer, offset: nativeRange.startOffset },
        end: { node: nativeRange.endContainer, offset: nativeRange.endOffset },
        native: nativeRange
      };
      [range.start, range.end].forEach(function (position) {
        var node = position.node,
            offset = position.offset;
        while (!(node instanceof Text) && node.childNodes.length > 0) {
          if (node.childNodes.length > offset) {
            node = node.childNodes[offset];
            offset = 0;
          } else if (node.childNodes.length === offset) {
            node = node.lastChild;
            offset = node instanceof Text ? node.data.length : node.childNodes.length + 1;
          } else {
            break;
          }
        }
        position.node = node, position.offset = offset;
      });
      return range;
    }
  }, {
    key: 'rangeToNative',
    value: function rangeToNative(range) {
      var _this5 = this;

      var indexes = range.collapsed ? [range.index] : [range.index, range.index + range.length];
      var args = [];
      var scrollLength = this.scroll.length();
      indexes.forEach(function (index, i) {
        index = Math.min(scrollLength - 1, index);
        var node = void 0,
            _scroll$leaf5 = _this5.scroll.leaf(index),
            _scroll$leaf6 = _slicedToArray(_scroll$leaf5, 2),
            leaf = _scroll$leaf6[0],
            offset = _scroll$leaf6[1];
        var _leaf$position5 = leaf.position(offset, i !== 0);

        var _leaf$position6 = _slicedToArray(_leaf$position5, 2);

        node = _leaf$position6[0];
        offset = _leaf$position6[1];

        args.push(node, offset);
      });
      if (args.length < 2) {
        args = args.concat(args);
      }
      return args;
    }
  }, {
    key: 'scrollIntoView',
    value: function scrollIntoView(scrollingContainer) {
      var range = this.lastRange;
      if (range == null) return;
      var bounds = this.getBounds(range.index, range.length);
      if (bounds == null) return;
      var limit = this.scroll.length() - 1;

      var _scroll$line = this.scroll.line(Math.min(range.index, limit)),
          _scroll$line2 = _slicedToArray(_scroll$line, 1),
          first = _scroll$line2[0];

      var last = first;
      if (range.length > 0) {
        var _scroll$line3 = this.scroll.line(Math.min(range.index + range.length, limit));

        var _scroll$line4 = _slicedToArray(_scroll$line3, 1);

        last = _scroll$line4[0];
      }
      if (first == null || last == null) return;
      var scrollBounds = scrollingContainer.getBoundingClientRect();
      if (bounds.top < scrollBounds.top) {
        scrollingContainer.scrollTop -= scrollBounds.top - bounds.top;
      } else if (bounds.bottom > scrollBounds.bottom) {
        scrollingContainer.scrollTop += bounds.bottom - scrollBounds.bottom;
      }
    }
  }, {
    key: 'setNativeRange',
    value: function setNativeRange(startNode, startOffset) {
      var endNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : startNode;
      var endOffset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : startOffset;
      var force = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

      debug.info('setNativeRange', startNode, startOffset, endNode, endOffset);
      if (startNode != null && (this.root.parentNode == null || startNode.parentNode == null || endNode.parentNode == null)) {
        return;
      }
      var selection = document.getSelection();
      if (selection == null) return;
      if (startNode != null) {
        if (!this.hasFocus()) this.root.focus();
        var native = (this.getNativeRange() || {}).native;
        if (native == null || force || startNode !== native.startContainer || startOffset !== native.startOffset || endNode !== native.endContainer || endOffset !== native.endOffset) {

          if (startNode.tagName == "BR") {
            startOffset = [].indexOf.call(startNode.parentNode.childNodes, startNode);
            startNode = startNode.parentNode;
          }
          if (endNode.tagName == "BR") {
            endOffset = [].indexOf.call(endNode.parentNode.childNodes, endNode);
            endNode = endNode.parentNode;
          }
          var range = document.createRange();
          range.setStart(startNode, startOffset);
          range.setEnd(endNode, endOffset);
          selection.removeAllRanges();
          selection.addRange(range);
        }
      } else {
        selection.removeAllRanges();
        this.root.blur();
        document.body.focus(); // root.blur() not enough on IE11+Travis+SauceLabs (but not local VMs)
      }
    }
  }, {
    key: 'setRange',
    value: function setRange(range) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _emitter4.default.sources.API;

      if (typeof force === 'string') {
        source = force;
        force = false;
      }
      debug.info('setRange', range);
      if (range != null) {
        var args = this.rangeToNative(range);
        this.setNativeRange.apply(this, _toConsumableArray(args).concat([force]));
      } else {
        this.setNativeRange(null);
      }
      this.update(source);
    }
  }, {
    key: 'update',
    value: function update() {
      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emitter4.default.sources.USER;

      var oldRange = this.lastRange;

      var _getRange = this.getRange(),
          _getRange2 = _slicedToArray(_getRange, 2),
          lastRange = _getRange2[0],
          nativeRange = _getRange2[1];

      this.lastRange = lastRange;
      if (this.lastRange != null) {
        this.savedRange = this.lastRange;
      }
      if (!(0, _deepEqual2.default)(oldRange, this.lastRange)) {
        var _emitter;

        if (!this.composing && nativeRange != null && nativeRange.native.collapsed && nativeRange.start.node !== this.cursor.textNode) {
          this.cursor.restore();
        }
        var args = [_emitter4.default.events.SELECTION_CHANGE, (0, _clone2.default)(this.lastRange), (0, _clone2.default)(oldRange), source];
        (_emitter = this.emitter).emit.apply(_emitter, [_emitter4.default.events.EDITOR_CHANGE].concat(args));
        if (source !== _emitter4.default.sources.SILENT) {
          var _emitter2;

          (_emitter2 = this.emitter).emit.apply(_emitter2, args);
        }
      }
    }
  }]);

  return Selection;
}();

function contains(parent, descendant) {
  try {
    // Firefox inserts inaccessible nodes around video elements
    descendant.parentNode;
  } catch (e) {
    return false;
  }
  // IE11 has bug with Text nodes
  // https://connect.microsoft.com/IE/feedback/details/780874/node-contains-is-incorrect
  if (descendant instanceof Text) {
    descendant = descendant.parentNode;
  }
  return parent.contains(descendant);
}

exports.Range = Range;
exports.default = Selection;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Break = function (_Parchment$Embed) {
  _inherits(Break, _Parchment$Embed);

  function Break() {
    _classCallCheck(this, Break);

    return _possibleConstructorReturn(this, (Break.__proto__ || Object.getPrototypeOf(Break)).apply(this, arguments));
  }

  _createClass(Break, [{
    key: 'insertInto',
    value: function insertInto(parent, ref) {
      if (parent.children.length === 0) {
        _get(Break.prototype.__proto__ || Object.getPrototypeOf(Break.prototype), 'insertInto', this).call(this, parent, ref);
      } else {
        this.remove();
      }
    }
  }, {
    key: 'length',
    value: function length() {
      return 0;
    }
  }, {
    key: 'value',
    value: function value() {
      return '';
    }
  }], [{
    key: 'value',
    value: function value() {
      return undefined;
    }
  }]);

  return Break;
}(_parchment2.default.Embed);

Break.blotName = 'break';
Break.tagName = 'BR';

exports.default = Break;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var linked_list_1 = __webpack_require__(44);
var shadow_1 = __webpack_require__(30);
var Registry = __webpack_require__(1);
var ContainerBlot = /** @class */ (function (_super) {
    __extends(ContainerBlot, _super);
    function ContainerBlot(domNode) {
        var _this = _super.call(this, domNode) || this;
        _this.build();
        return _this;
    }
    ContainerBlot.prototype.appendChild = function (other) {
        this.insertBefore(other);
    };
    ContainerBlot.prototype.attach = function () {
        _super.prototype.attach.call(this);
        this.children.forEach(function (child) {
            child.attach();
        });
    };
    ContainerBlot.prototype.build = function () {
        var _this = this;
        this.children = new linked_list_1.default();
        // Need to be reversed for if DOM nodes already in order
        [].slice
            .call(this.domNode.childNodes)
            .reverse()
            .forEach(function (node) {
            try {
                var child = makeBlot(node);
                _this.insertBefore(child, _this.children.head || undefined);
            }
            catch (err) {
                if (err instanceof Registry.ParchmentError)
                    return;
                else
                    throw err;
            }
        });
    };
    ContainerBlot.prototype.deleteAt = function (index, length) {
        if (index === 0 && length === this.length()) {
            return this.remove();
        }
        this.children.forEachAt(index, length, function (child, offset, length) {
            child.deleteAt(offset, length);
        });
    };
    ContainerBlot.prototype.descendant = function (criteria, index) {
        var _a = this.children.find(index), child = _a[0], offset = _a[1];
        if ((criteria.blotName == null && criteria(child)) ||
            (criteria.blotName != null && child instanceof criteria)) {
            return [child, offset];
        }
        else if (child instanceof ContainerBlot) {
            return child.descendant(criteria, offset);
        }
        else {
            return [null, -1];
        }
    };
    ContainerBlot.prototype.descendants = function (criteria, index, length) {
        if (index === void 0) { index = 0; }
        if (length === void 0) { length = Number.MAX_VALUE; }
        var descendants = [];
        var lengthLeft = length;
        this.children.forEachAt(index, length, function (child, index, length) {
            if ((criteria.blotName == null && criteria(child)) ||
                (criteria.blotName != null && child instanceof criteria)) {
                descendants.push(child);
            }
            if (child instanceof ContainerBlot) {
                descendants = descendants.concat(child.descendants(criteria, index, lengthLeft));
            }
            lengthLeft -= length;
        });
        return descendants;
    };
    ContainerBlot.prototype.detach = function () {
        this.children.forEach(function (child) {
            child.detach();
        });
        _super.prototype.detach.call(this);
    };
    ContainerBlot.prototype.formatAt = function (index, length, name, value) {
        this.children.forEachAt(index, length, function (child, offset, length) {
            child.formatAt(offset, length, name, value);
        });
    };
    ContainerBlot.prototype.insertAt = function (index, value, def) {
        var _a = this.children.find(index), child = _a[0], offset = _a[1];
        if (child) {
            child.insertAt(offset, value, def);
        }
        else {
            var blot = def == null ? Registry.create('text', value) : Registry.create(value, def);
            this.appendChild(blot);
        }
    };
    ContainerBlot.prototype.insertBefore = function (childBlot, refBlot) {
        if (this.statics.allowedChildren != null &&
            !this.statics.allowedChildren.some(function (child) {
                return childBlot instanceof child;
            })) {
            throw new Registry.ParchmentError("Cannot insert " + childBlot.statics.blotName + " into " + this.statics.blotName);
        }
        childBlot.insertInto(this, refBlot);
    };
    ContainerBlot.prototype.length = function () {
        return this.children.reduce(function (memo, child) {
            return memo + child.length();
        }, 0);
    };
    ContainerBlot.prototype.moveChildren = function (targetParent, refNode) {
        this.children.forEach(function (child) {
            targetParent.insertBefore(child, refNode);
        });
    };
    ContainerBlot.prototype.optimize = function (context) {
        _super.prototype.optimize.call(this, context);
        if (this.children.length === 0) {
            if (this.statics.defaultChild != null) {
                var child = Registry.create(this.statics.defaultChild);
                this.appendChild(child);
                child.optimize(context);
            }
            else {
                this.remove();
            }
        }
    };
    ContainerBlot.prototype.path = function (index, inclusive) {
        if (inclusive === void 0) { inclusive = false; }
        var _a = this.children.find(index, inclusive), child = _a[0], offset = _a[1];
        var position = [[this, index]];
        if (child instanceof ContainerBlot) {
            return position.concat(child.path(offset, inclusive));
        }
        else if (child != null) {
            position.push([child, offset]);
        }
        return position;
    };
    ContainerBlot.prototype.removeChild = function (child) {
        this.children.remove(child);
    };
    ContainerBlot.prototype.replace = function (target) {
        if (target instanceof ContainerBlot) {
            target.moveChildren(this);
        }
        _super.prototype.replace.call(this, target);
    };
    ContainerBlot.prototype.split = function (index, force) {
        if (force === void 0) { force = false; }
        if (!force) {
            if (index === 0)
                return this;
            if (index === this.length())
                return this.next;
        }
        var after = this.clone();
        this.parent.insertBefore(after, this.next);
        this.children.forEachAt(index, this.length(), function (child, offset, length) {
            child = child.split(offset, force);
            after.appendChild(child);
        });
        return after;
    };
    ContainerBlot.prototype.unwrap = function () {
        this.moveChildren(this.parent, this.next);
        this.remove();
    };
    ContainerBlot.prototype.update = function (mutations, context) {
        var _this = this;
        var addedNodes = [];
        var removedNodes = [];
        mutations.forEach(function (mutation) {
            if (mutation.target === _this.domNode && mutation.type === 'childList') {
                addedNodes.push.apply(addedNodes, mutation.addedNodes);
                removedNodes.push.apply(removedNodes, mutation.removedNodes);
            }
        });
        removedNodes.forEach(function (node) {
            // Check node has actually been removed
            // One exception is Chrome does not immediately remove IFRAMEs
            // from DOM but MutationRecord is correct in its reported removal
            if (node.parentNode != null &&
                // @ts-ignore
                node.tagName !== 'IFRAME' &&
                document.body.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) {
                return;
            }
            var blot = Registry.find(node);
            if (blot == null)
                return;
            if (blot.domNode.parentNode == null || blot.domNode.parentNode === _this.domNode) {
                blot.detach();
            }
        });
        addedNodes
            .filter(function (node) {
            return node.parentNode == _this.domNode;
        })
            .sort(function (a, b) {
            if (a === b)
                return 0;
            if (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING) {
                return 1;
            }
            return -1;
        })
            .forEach(function (node) {
            var refBlot = null;
            if (node.nextSibling != null) {
                refBlot = Registry.find(node.nextSibling);
            }
            var blot = makeBlot(node);
            if (blot.next != refBlot || blot.next == null) {
                if (blot.parent != null) {
                    blot.parent.removeChild(_this);
                }
                _this.insertBefore(blot, refBlot || undefined);
            }
        });
    };
    return ContainerBlot;
}(shadow_1.default));
function makeBlot(node) {
    var blot = Registry.find(node);
    if (blot == null) {
        try {
            blot = Registry.create(node);
        }
        catch (e) {
            blot = Registry.create(Registry.Scope.INLINE);
            [].slice.call(node.childNodes).forEach(function (child) {
                // @ts-ignore
                blot.domNode.appendChild(child);
            });
            if (node.parentNode) {
                node.parentNode.replaceChild(blot.domNode, node);
            }
            blot.attach();
        }
    }
    return blot;
}
exports.default = ContainerBlot;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var attributor_1 = __webpack_require__(12);
var store_1 = __webpack_require__(31);
var container_1 = __webpack_require__(17);
var Registry = __webpack_require__(1);
var FormatBlot = /** @class */ (function (_super) {
    __extends(FormatBlot, _super);
    function FormatBlot(domNode) {
        var _this = _super.call(this, domNode) || this;
        _this.attributes = new store_1.default(_this.domNode);
        return _this;
    }
    FormatBlot.formats = function (domNode) {
        if (typeof this.tagName === 'string') {
            return true;
        }
        else if (Array.isArray(this.tagName)) {
            return domNode.tagName.toLowerCase();
        }
        return undefined;
    };
    FormatBlot.prototype.format = function (name, value) {
        var format = Registry.query(name);
        if (format instanceof attributor_1.default) {
            this.attributes.attribute(format, value);
        }
        else if (value) {
            if (format != null && (name !== this.statics.blotName || this.formats()[name] !== value)) {
                this.replaceWith(name, value);
            }
        }
    };
    FormatBlot.prototype.formats = function () {
        var formats = this.attributes.values();
        var format = this.statics.formats(this.domNode);
        if (format != null) {
            formats[this.statics.blotName] = format;
        }
        return formats;
    };
    FormatBlot.prototype.replaceWith = function (name, value) {
        var replacement = _super.prototype.replaceWith.call(this, name, value);
        this.attributes.copy(replacement);
        return replacement;
    };
    FormatBlot.prototype.update = function (mutations, context) {
        var _this = this;
        _super.prototype.update.call(this, mutations, context);
        if (mutations.some(function (mutation) {
            return mutation.target === _this.domNode && mutation.type === 'attributes';
        })) {
            this.attributes.build();
        }
    };
    FormatBlot.prototype.wrap = function (name, value) {
        var wrapper = _super.prototype.wrap.call(this, name, value);
        if (wrapper instanceof FormatBlot && wrapper.statics.scope === this.statics.scope) {
            this.attributes.move(wrapper);
        }
        return wrapper;
    };
    return FormatBlot;
}(container_1.default));
exports.default = FormatBlot;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var shadow_1 = __webpack_require__(30);
var Registry = __webpack_require__(1);
var LeafBlot = /** @class */ (function (_super) {
    __extends(LeafBlot, _super);
    function LeafBlot() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LeafBlot.value = function (domNode) {
        return true;
    };
    LeafBlot.prototype.index = function (node, offset) {
        if (this.domNode === node ||
            this.domNode.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) {
            return Math.min(offset, 1);
        }
        return -1;
    };
    LeafBlot.prototype.position = function (index, inclusive) {
        var offset = [].indexOf.call(this.parent.domNode.childNodes, this.domNode);
        if (index > 0)
            offset += 1;
        return [this.parent.domNode, offset];
    };
    LeafBlot.prototype.value = function () {
        var _a;
        return _a = {}, _a[this.statics.blotName] = this.statics.value(this.domNode) || true, _a;
    };
    LeafBlot.scope = Registry.Scope.INLINE_BLOT;
    return LeafBlot;
}(shadow_1.default));
exports.default = LeafBlot;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var equal = __webpack_require__(11);
var extend = __webpack_require__(3);


var lib = {
  attributes: {
    compose: function (a, b, keepNull) {
      if (typeof a !== 'object') a = {};
      if (typeof b !== 'object') b = {};
      var attributes = extend(true, {}, b);
      if (!keepNull) {
        attributes = Object.keys(attributes).reduce(function (copy, key) {
          if (attributes[key] != null) {
            copy[key] = attributes[key];
          }
          return copy;
        }, {});
      }
      for (var key in a) {
        if (a[key] !== undefined && b[key] === undefined) {
          attributes[key] = a[key];
        }
      }
      return Object.keys(attributes).length > 0 ? attributes : undefined;
    },

    diff: function(a, b) {
      if (typeof a !== 'object') a = {};
      if (typeof b !== 'object') b = {};
      var attributes = Object.keys(a).concat(Object.keys(b)).reduce(function (attributes, key) {
        if (!equal(a[key], b[key])) {
          attributes[key] = b[key] === undefined ? null : b[key];
        }
        return attributes;
      }, {});
      return Object.keys(attributes).length > 0 ? attributes : undefined;
    },

    transform: function (a, b, priority) {
      if (typeof a !== 'object') return b;
      if (typeof b !== 'object') return undefined;
      if (!priority) return b;  // b simply overwrites us without priority
      var attributes = Object.keys(b).reduce(function (attributes, key) {
        if (a[key] === undefined) attributes[key] = b[key];  // null is a valid value
        return attributes;
      }, {});
      return Object.keys(attributes).length > 0 ? attributes : undefined;
    }
  },

  iterator: function (ops) {
    return new Iterator(ops);
  },

  length: function (op) {
    if (typeof op['delete'] === 'number') {
      return op['delete'];
    } else if (typeof op.retain === 'number') {
      return op.retain;
    } else {
      return typeof op.insert === 'string' ? op.insert.length : 1;
    }
  }
};


function Iterator(ops) {
  this.ops = ops;
  this.index = 0;
  this.offset = 0;
};

Iterator.prototype.hasNext = function () {
  return this.peekLength() < Infinity;
};

Iterator.prototype.next = function (length) {
  if (!length) length = Infinity;
  var nextOp = this.ops[this.index];
  if (nextOp) {
    var offset = this.offset;
    var opLength = lib.length(nextOp)
    if (length >= opLength - offset) {
      length = opLength - offset;
      this.index += 1;
      this.offset = 0;
    } else {
      this.offset += length;
    }
    if (typeof nextOp['delete'] === 'number') {
      return { 'delete': length };
    } else {
      var retOp = {};
      if (nextOp.attributes) {
        retOp.attributes = nextOp.attributes;
      }
      if (typeof nextOp.retain === 'number') {
        retOp.retain = length;
      } else if (typeof nextOp.insert === 'string') {
        retOp.insert = nextOp.insert.substr(offset, length);
      } else {
        // offset should === 0, length should === 1
        retOp.insert = nextOp.insert;
      }
      return retOp;
    }
  } else {
    return { retain: Infinity };
  }
};

Iterator.prototype.peek = function () {
  return this.ops[this.index];
};

Iterator.prototype.peekLength = function () {
  if (this.ops[this.index]) {
    // Should never return 0 if our index is being managed correctly
    return lib.length(this.ops[this.index]) - this.offset;
  } else {
    return Infinity;
  }
};

Iterator.prototype.peekType = function () {
  if (this.ops[this.index]) {
    if (typeof this.ops[this.index]['delete'] === 'number') {
      return 'delete';
    } else if (typeof this.ops[this.index].retain === 'number') {
      return 'retain';
    } else {
      return 'insert';
    }
  }
  return 'retain';
};

Iterator.prototype.rest = function () {
  if (!this.hasNext()) {
    return [];
  } else if (this.offset === 0) {
    return this.ops.slice(this.index);
  } else {
    var offset = this.offset;
    var index = this.index;
    var next = this.next();
    var rest = this.ops.slice(this.index);
    this.offset = offset;
    this.index = index;
    return [next].concat(rest);
  }
};


module.exports = lib;


/***/ }),
/* 21 */
/***/ (function(module, exports) {

var clone = (function() {
'use strict';

function _instanceof(obj, type) {
  return type != null && obj instanceof type;
}

var nativeMap;
try {
  nativeMap = Map;
} catch(_) {
  // maybe a reference error because no `Map`. Give it a dummy value that no
  // value will ever be an instanceof.
  nativeMap = function() {};
}

var nativeSet;
try {
  nativeSet = Set;
} catch(_) {
  nativeSet = function() {};
}

var nativePromise;
try {
  nativePromise = Promise;
} catch(_) {
  nativePromise = function() {};
}

/**
 * Clones (copies) an Object using deep copying.
 *
 * This function supports circular references by default, but if you are certain
 * there are no circular references in your object, you can save some CPU time
 * by calling clone(obj, false).
 *
 * Caution: if `circular` is false and `parent` contains circular references,
 * your program may enter an infinite loop and crash.
 *
 * @param `parent` - the object to be cloned
 * @param `circular` - set to true if the object to be cloned may contain
 *    circular references. (optional - true by default)
 * @param `depth` - set to a number if the object is only to be cloned to
 *    a particular depth. (optional - defaults to Infinity)
 * @param `prototype` - sets the prototype to be used when cloning an object.
 *    (optional - defaults to parent prototype).
 * @param `includeNonEnumerable` - set to true if the non-enumerable properties
 *    should be cloned as well. Non-enumerable properties on the prototype
 *    chain will be ignored. (optional - false by default)
*/
function clone(parent, circular, depth, prototype, includeNonEnumerable) {
  if (typeof circular === 'object') {
    depth = circular.depth;
    prototype = circular.prototype;
    includeNonEnumerable = circular.includeNonEnumerable;
    circular = circular.circular;
  }
  // maintain two arrays for circular references, where corresponding parents
  // and children have the same index
  var allParents = [];
  var allChildren = [];

  var useBuffer = typeof Buffer != 'undefined';

  if (typeof circular == 'undefined')
    circular = true;

  if (typeof depth == 'undefined')
    depth = Infinity;

  // recurse this function so we don't reset allParents and allChildren
  function _clone(parent, depth) {
    // cloning null always returns null
    if (parent === null)
      return null;

    if (depth === 0)
      return parent;

    var child;
    var proto;
    if (typeof parent != 'object') {
      return parent;
    }

    if (_instanceof(parent, nativeMap)) {
      child = new nativeMap();
    } else if (_instanceof(parent, nativeSet)) {
      child = new nativeSet();
    } else if (_instanceof(parent, nativePromise)) {
      child = new nativePromise(function (resolve, reject) {
        parent.then(function(value) {
          resolve(_clone(value, depth - 1));
        }, function(err) {
          reject(_clone(err, depth - 1));
        });
      });
    } else if (clone.__isArray(parent)) {
      child = [];
    } else if (clone.__isRegExp(parent)) {
      child = new RegExp(parent.source, __getRegExpFlags(parent));
      if (parent.lastIndex) child.lastIndex = parent.lastIndex;
    } else if (clone.__isDate(parent)) {
      child = new Date(parent.getTime());
    } else if (useBuffer && Buffer.isBuffer(parent)) {
      if (Buffer.allocUnsafe) {
        // Node.js >= 4.5.0
        child = Buffer.allocUnsafe(parent.length);
      } else {
        // Older Node.js versions
        child = new Buffer(parent.length);
      }
      parent.copy(child);
      return child;
    } else if (_instanceof(parent, Error)) {
      child = Object.create(parent);
    } else {
      if (typeof prototype == 'undefined') {
        proto = Object.getPrototypeOf(parent);
        child = Object.create(proto);
      }
      else {
        child = Object.create(prototype);
        proto = prototype;
      }
    }

    if (circular) {
      var index = allParents.indexOf(parent);

      if (index != -1) {
        return allChildren[index];
      }
      allParents.push(parent);
      allChildren.push(child);
    }

    if (_instanceof(parent, nativeMap)) {
      parent.forEach(function(value, key) {
        var keyChild = _clone(key, depth - 1);
        var valueChild = _clone(value, depth - 1);
        child.set(keyChild, valueChild);
      });
    }
    if (_instanceof(parent, nativeSet)) {
      parent.forEach(function(value) {
        var entryChild = _clone(value, depth - 1);
        child.add(entryChild);
      });
    }

    for (var i in parent) {
      var attrs;
      if (proto) {
        attrs = Object.getOwnPropertyDescriptor(proto, i);
      }

      if (attrs && attrs.set == null) {
        continue;
      }
      child[i] = _clone(parent[i], depth - 1);
    }

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(parent);
      for (var i = 0; i < symbols.length; i++) {
        // Don't need to worry about cloning a symbol because it is a primitive,
        // like a number or string.
        var symbol = symbols[i];
        var descriptor = Object.getOwnPropertyDescriptor(parent, symbol);
        if (descriptor && !descriptor.enumerable && !includeNonEnumerable) {
          continue;
        }
        child[symbol] = _clone(parent[symbol], depth - 1);
        if (!descriptor.enumerable) {
          Object.defineProperty(child, symbol, {
            enumerable: false
          });
        }
      }
    }

    if (includeNonEnumerable) {
      var allPropertyNames = Object.getOwnPropertyNames(parent);
      for (var i = 0; i < allPropertyNames.length; i++) {
        var propertyName = allPropertyNames[i];
        var descriptor = Object.getOwnPropertyDescriptor(parent, propertyName);
        if (descriptor && descriptor.enumerable) {
          continue;
        }
        child[propertyName] = _clone(parent[propertyName], depth - 1);
        Object.defineProperty(child, propertyName, {
          enumerable: false
        });
      }
    }

    return child;
  }

  return _clone(parent, depth);
}

/**
 * Simple flat clone using prototype, accepts only objects, usefull for property
 * override on FLAT configuration object (no nested props).
 *
 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
 * works.
 */
clone.clonePrototype = function clonePrototype(parent) {
  if (parent === null)
    return null;

  var c = function () {};
  c.prototype = parent;
  return new c();
};

// private utility functions

function __objToStr(o) {
  return Object.prototype.toString.call(o);
}
clone.__objToStr = __objToStr;

function __isDate(o) {
  return typeof o === 'object' && __objToStr(o) === '[object Date]';
}
clone.__isDate = __isDate;

function __isArray(o) {
  return typeof o === 'object' && __objToStr(o) === '[object Array]';
}
clone.__isArray = __isArray;

function __isRegExp(o) {
  return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
}
clone.__isRegExp = __isRegExp;

function __getRegExpFlags(re) {
  var flags = '';
  if (re.global) flags += 'g';
  if (re.ignoreCase) flags += 'i';
  if (re.multiline) flags += 'm';
  return flags;
}
clone.__getRegExpFlags = __getRegExpFlags;

return clone;
})();

if (typeof module === 'object' && module.exports) {
  module.exports = clone;
}


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _emitter = __webpack_require__(8);

var _emitter2 = _interopRequireDefault(_emitter);

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

var _break = __webpack_require__(16);

var _break2 = _interopRequireDefault(_break);

var _code = __webpack_require__(13);

var _code2 = _interopRequireDefault(_code);

var _container = __webpack_require__(25);

var _container2 = _interopRequireDefault(_container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function isLine(blot) {
  return blot instanceof _block2.default || blot instanceof _block.BlockEmbed;
}

var Scroll = function (_Parchment$Scroll) {
  _inherits(Scroll, _Parchment$Scroll);

  function Scroll(domNode, config) {
    _classCallCheck(this, Scroll);

    var _this = _possibleConstructorReturn(this, (Scroll.__proto__ || Object.getPrototypeOf(Scroll)).call(this, domNode));

    _this.emitter = config.emitter;
    if (Array.isArray(config.whitelist)) {
      _this.whitelist = config.whitelist.reduce(function (whitelist, format) {
        whitelist[format] = true;
        return whitelist;
      }, {});
    }
    // Some reason fixes composition issues with character languages in Windows/Chrome, Safari
    _this.domNode.addEventListener('DOMNodeInserted', function () {});
    _this.optimize();
    _this.enable();
    return _this;
  }

  _createClass(Scroll, [{
    key: 'batchStart',
    value: function batchStart() {
      this.batch = true;
    }
  }, {
    key: 'batchEnd',
    value: function batchEnd() {
      this.batch = false;
      this.optimize();
    }
  }, {
    key: 'deleteAt',
    value: function deleteAt(index, length) {
      var _line = this.line(index),
          _line2 = _slicedToArray(_line, 2),
          first = _line2[0],
          offset = _line2[1];

      var _line3 = this.line(index + length),
          _line4 = _slicedToArray(_line3, 1),
          last = _line4[0];

      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'deleteAt', this).call(this, index, length);
      if (last != null && first !== last && offset > 0) {
        if (first instanceof _block.BlockEmbed || last instanceof _block.BlockEmbed) {
          this.optimize();
          return;
        }
        if (first instanceof _code2.default) {
          var newlineIndex = first.newlineIndex(first.length(), true);
          if (newlineIndex > -1) {
            first = first.split(newlineIndex + 1);
            if (first === last) {
              this.optimize();
              return;
            }
          }
        } else if (last instanceof _code2.default) {
          var _newlineIndex = last.newlineIndex(0);
          if (_newlineIndex > -1) {
            last.split(_newlineIndex + 1);
          }
        }
        var ref = last.children.head instanceof _break2.default ? null : last.children.head;
        first.moveChildren(last, ref);
        first.remove();
      }
      this.optimize();
    }
  }, {
    key: 'enable',
    value: function enable() {
      var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.domNode.setAttribute('contenteditable', enabled);
    }
  }, {
    key: 'formatAt',
    value: function formatAt(index, length, format, value) {
      if (this.whitelist != null && !this.whitelist[format]) return;
      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'formatAt', this).call(this, index, length, format, value);
      this.optimize();
    }
  }, {
    key: 'insertAt',
    value: function insertAt(index, value, def) {
      if (def != null && this.whitelist != null && !this.whitelist[value]) return;
      if (index >= this.length()) {
        if (def == null || _parchment2.default.query(value, _parchment2.default.Scope.BLOCK) == null) {
          var blot = _parchment2.default.create(this.statics.defaultChild);
          this.appendChild(blot);
          if (def == null && value.endsWith('\n')) {
            value = value.slice(0, -1);
          }
          blot.insertAt(0, value, def);
        } else {
          var embed = _parchment2.default.create(value, def);
          this.appendChild(embed);
        }
      } else {
        _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'insertAt', this).call(this, index, value, def);
      }
      this.optimize();
    }
  }, {
    key: 'insertBefore',
    value: function insertBefore(blot, ref) {
      if (blot.statics.scope === _parchment2.default.Scope.INLINE_BLOT) {
        var wrapper = _parchment2.default.create(this.statics.defaultChild);
        wrapper.appendChild(blot);
        blot = wrapper;
      }
      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'insertBefore', this).call(this, blot, ref);
    }
  }, {
    key: 'leaf',
    value: function leaf(index) {
      return this.path(index).pop() || [null, -1];
    }
  }, {
    key: 'line',
    value: function line(index) {
      if (index === this.length()) {
        return this.line(index - 1);
      }
      return this.descendant(isLine, index);
    }
  }, {
    key: 'lines',
    value: function lines() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;

      var getLines = function getLines(blot, index, length) {
        var lines = [],
            lengthLeft = length;
        blot.children.forEachAt(index, length, function (child, index, length) {
          if (isLine(child)) {
            lines.push(child);
          } else if (child instanceof _parchment2.default.Container) {
            lines = lines.concat(getLines(child, index, lengthLeft));
          }
          lengthLeft -= length;
        });
        return lines;
      };
      return getLines(this, index, length);
    }
  }, {
    key: 'optimize',
    value: function optimize() {
      var mutations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (this.batch === true) return;
      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'optimize', this).call(this, mutations, context);
      if (mutations.length > 0) {
        this.emitter.emit(_emitter2.default.events.SCROLL_OPTIMIZE, mutations, context);
      }
    }
  }, {
    key: 'path',
    value: function path(index) {
      return _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'path', this).call(this, index).slice(1); // Exclude self
    }
  }, {
    key: 'update',
    value: function update(mutations) {
      if (this.batch === true) return;
      var source = _emitter2.default.sources.USER;
      if (typeof mutations === 'string') {
        source = mutations;
      }
      if (!Array.isArray(mutations)) {
        mutations = this.observer.takeRecords();
      }
      if (mutations.length > 0) {
        this.emitter.emit(_emitter2.default.events.SCROLL_BEFORE_UPDATE, source, mutations);
      }
      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'update', this).call(this, mutations.concat([])); // pass copy
      if (mutations.length > 0) {
        this.emitter.emit(_emitter2.default.events.SCROLL_UPDATE, source, mutations);
      }
    }
  }]);

  return Scroll;
}(_parchment2.default.Scroll);

Scroll.blotName = 'scroll';
Scroll.className = 'ql-editor';
Scroll.tagName = 'DIV';
Scroll.defaultChild = 'block';
Scroll.allowedChildren = [_block2.default, _block.BlockEmbed, _container2.default];

exports.default = Scroll;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SHORTKEY = exports.default = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _deepEqual = __webpack_require__(11);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _extend = __webpack_require__(3);

var _extend2 = _interopRequireDefault(_extend);

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _op = __webpack_require__(20);

var _op2 = _interopRequireDefault(_op);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _quill = __webpack_require__(5);

var _quill2 = _interopRequireDefault(_quill);

var _logger = __webpack_require__(10);

var _logger2 = _interopRequireDefault(_logger);

var _module = __webpack_require__(9);

var _module2 = _interopRequireDefault(_module);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var debug = (0, _logger2.default)('quill:keyboard');

var SHORTKEY = /Mac/i.test(navigator.platform) ? 'metaKey' : 'ctrlKey';

var Keyboard = function (_Module) {
  _inherits(Keyboard, _Module);

  _createClass(Keyboard, null, [{
    key: 'match',
    value: function match(evt, binding) {
      binding = normalize(binding);
      if (['altKey', 'ctrlKey', 'metaKey', 'shiftKey'].some(function (key) {
        return !!binding[key] !== evt[key] && binding[key] !== null;
      })) {
        return false;
      }
      return binding.key === (evt.which || evt.keyCode);
    }
  }]);

  function Keyboard(quill, options) {
    _classCallCheck(this, Keyboard);

    var _this = _possibleConstructorReturn(this, (Keyboard.__proto__ || Object.getPrototypeOf(Keyboard)).call(this, quill, options));

    _this.bindings = {};
    Object.keys(_this.options.bindings).forEach(function (name) {
      if (name === 'list autofill' && quill.scroll.whitelist != null && !quill.scroll.whitelist['list']) {
        return;
      }
      if (_this.options.bindings[name]) {
        _this.addBinding(_this.options.bindings[name]);
      }
    });
    _this.addBinding({ key: Keyboard.keys.ENTER, shiftKey: null }, handleEnter);
    _this.addBinding({ key: Keyboard.keys.ENTER, metaKey: null, ctrlKey: null, altKey: null }, function () {});
    if (/Firefox/i.test(navigator.userAgent)) {
      // Need to handle delete and backspace for Firefox in the general case #1171
      _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: true }, handleBackspace);
      _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: true }, handleDelete);
    } else {
      _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: true, prefix: /^.?$/ }, handleBackspace);
      _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: true, suffix: /^.?$/ }, handleDelete);
    }
    _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: false }, handleDeleteRange);
    _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: false }, handleDeleteRange);
    _this.addBinding({ key: Keyboard.keys.BACKSPACE, altKey: null, ctrlKey: null, metaKey: null, shiftKey: null }, { collapsed: true, offset: 0 }, handleBackspace);
    _this.listen();
    return _this;
  }

  _createClass(Keyboard, [{
    key: 'addBinding',
    value: function addBinding(key) {
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var handler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var binding = normalize(key);
      if (binding == null || binding.key == null) {
        return debug.warn('Attempted to add invalid keyboard binding', binding);
      }
      if (typeof context === 'function') {
        context = { handler: context };
      }
      if (typeof handler === 'function') {
        handler = { handler: handler };
      }
      binding = (0, _extend2.default)(binding, context, handler);
      this.bindings[binding.key] = this.bindings[binding.key] || [];
      this.bindings[binding.key].push(binding);
    }
  }, {
    key: 'listen',
    value: function listen() {
      var _this2 = this;

      this.quill.root.addEventListener('keydown', function (evt) {
        if (evt.defaultPrevented) return;
        var which = evt.which || evt.keyCode;
        var bindings = (_this2.bindings[which] || []).filter(function (binding) {
          return Keyboard.match(evt, binding);
        });
        if (bindings.length === 0) return;
        var range = _this2.quill.getSelection();
        if (range == null || !_this2.quill.hasFocus()) return;

        var _quill$getLine = _this2.quill.getLine(range.index),
            _quill$getLine2 = _slicedToArray(_quill$getLine, 2),
            line = _quill$getLine2[0],
            offset = _quill$getLine2[1];

        var _quill$getLeaf = _this2.quill.getLeaf(range.index),
            _quill$getLeaf2 = _slicedToArray(_quill$getLeaf, 2),
            leafStart = _quill$getLeaf2[0],
            offsetStart = _quill$getLeaf2[1];

        var _ref = range.length === 0 ? [leafStart, offsetStart] : _this2.quill.getLeaf(range.index + range.length),
            _ref2 = _slicedToArray(_ref, 2),
            leafEnd = _ref2[0],
            offsetEnd = _ref2[1];

        var prefixText = leafStart instanceof _parchment2.default.Text ? leafStart.value().slice(0, offsetStart) : '';
        var suffixText = leafEnd instanceof _parchment2.default.Text ? leafEnd.value().slice(offsetEnd) : '';
        var curContext = {
          collapsed: range.length === 0,
          empty: range.length === 0 && line.length() <= 1,
          format: _this2.quill.getFormat(range),
          offset: offset,
          prefix: prefixText,
          suffix: suffixText
        };
        var prevented = bindings.some(function (binding) {
          if (binding.collapsed != null && binding.collapsed !== curContext.collapsed) return false;
          if (binding.empty != null && binding.empty !== curContext.empty) return false;
          if (binding.offset != null && binding.offset !== curContext.offset) return false;
          if (Array.isArray(binding.format)) {
            // any format is present
            if (binding.format.every(function (name) {
              return curContext.format[name] == null;
            })) {
              return false;
            }
          } else if (_typeof(binding.format) === 'object') {
            // all formats must match
            if (!Object.keys(binding.format).every(function (name) {
              if (binding.format[name] === true) return curContext.format[name] != null;
              if (binding.format[name] === false) return curContext.format[name] == null;
              return (0, _deepEqual2.default)(binding.format[name], curContext.format[name]);
            })) {
              return false;
            }
          }
          if (binding.prefix != null && !binding.prefix.test(curContext.prefix)) return false;
          if (binding.suffix != null && !binding.suffix.test(curContext.suffix)) return false;
          return binding.handler.call(_this2, range, curContext) !== true;
        });
        if (prevented) {
          evt.preventDefault();
        }
      });
    }
  }]);

  return Keyboard;
}(_module2.default);

Keyboard.keys = {
  BACKSPACE: 8,
  TAB: 9,
  ENTER: 13,
  ESCAPE: 27,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  DELETE: 46
};

Keyboard.DEFAULTS = {
  bindings: {
    'bold': makeFormatHandler('bold'),
    'italic': makeFormatHandler('italic'),
    'underline': makeFormatHandler('underline'),
    'indent': {
      // highlight tab or tab at beginning of list, indent or blockquote
      key: Keyboard.keys.TAB,
      format: ['blockquote', 'indent', 'list'],
      handler: function handler(range, context) {
        if (context.collapsed && context.offset !== 0) return true;
        this.quill.format('indent', '+1', _quill2.default.sources.USER);
      }
    },
    'outdent': {
      key: Keyboard.keys.TAB,
      shiftKey: true,
      format: ['blockquote', 'indent', 'list'],
      // highlight tab or tab at beginning of list, indent or blockquote
      handler: function handler(range, context) {
        if (context.collapsed && context.offset !== 0) return true;
        this.quill.format('indent', '-1', _quill2.default.sources.USER);
      }
    },
    'outdent backspace': {
      key: Keyboard.keys.BACKSPACE,
      collapsed: true,
      shiftKey: null,
      metaKey: null,
      ctrlKey: null,
      altKey: null,
      format: ['indent', 'list'],
      offset: 0,
      handler: function handler(range, context) {
        if (context.format.indent != null) {
          this.quill.format('indent', '-1', _quill2.default.sources.USER);
        } else if (context.format.list != null) {
          this.quill.format('list', false, _quill2.default.sources.USER);
        }
      }
    },
    'indent code-block': makeCodeBlockHandler(true),
    'outdent code-block': makeCodeBlockHandler(false),
    'remove tab': {
      key: Keyboard.keys.TAB,
      shiftKey: true,
      collapsed: true,
      prefix: /\t$/,
      handler: function handler(range) {
        this.quill.deleteText(range.index - 1, 1, _quill2.default.sources.USER);
      }
    },
    'tab': {
      key: Keyboard.keys.TAB,
      handler: function handler(range) {
        this.quill.history.cutoff();
        var delta = new _quillDelta2.default().retain(range.index).delete(range.length).insert('\t');
        this.quill.updateContents(delta, _quill2.default.sources.USER);
        this.quill.history.cutoff();
        this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
      }
    },
    'list empty enter': {
      key: Keyboard.keys.ENTER,
      collapsed: true,
      format: ['list'],
      empty: true,
      handler: function handler(range, context) {
        this.quill.format('list', false, _quill2.default.sources.USER);
        if (context.format.indent) {
          this.quill.format('indent', false, _quill2.default.sources.USER);
        }
      }
    },
    'checklist enter': {
      key: Keyboard.keys.ENTER,
      collapsed: true,
      format: { list: 'checked' },
      handler: function handler(range) {
        var _quill$getLine3 = this.quill.getLine(range.index),
            _quill$getLine4 = _slicedToArray(_quill$getLine3, 2),
            line = _quill$getLine4[0],
            offset = _quill$getLine4[1];

        var formats = (0, _extend2.default)({}, line.formats(), { list: 'checked' });
        var delta = new _quillDelta2.default().retain(range.index).insert('\n', formats).retain(line.length() - offset - 1).retain(1, { list: 'unchecked' });
        this.quill.updateContents(delta, _quill2.default.sources.USER);
        this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
        this.quill.scrollIntoView();
      }
    },
    'header enter': {
      key: Keyboard.keys.ENTER,
      collapsed: true,
      format: ['header'],
      suffix: /^$/,
      handler: function handler(range, context) {
        var _quill$getLine5 = this.quill.getLine(range.index),
            _quill$getLine6 = _slicedToArray(_quill$getLine5, 2),
            line = _quill$getLine6[0],
            offset = _quill$getLine6[1];

        var delta = new _quillDelta2.default().retain(range.index).insert('\n', context.format).retain(line.length() - offset - 1).retain(1, { header: null });
        this.quill.updateContents(delta, _quill2.default.sources.USER);
        this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
        this.quill.scrollIntoView();
      }
    },
    'list autofill': {
      key: ' ',
      collapsed: true,
      format: { list: false },
      prefix: /^\s*?(\d+\.|-|\*|\[ ?\]|\[x\])$/,
      handler: function handler(range, context) {
        var length = context.prefix.length;

        var _quill$getLine7 = this.quill.getLine(range.index),
            _quill$getLine8 = _slicedToArray(_quill$getLine7, 2),
            line = _quill$getLine8[0],
            offset = _quill$getLine8[1];

        if (offset > length) return true;
        var value = void 0;
        switch (context.prefix.trim()) {
          case '[]':case '[ ]':
            value = 'unchecked';
            break;
          case '[x]':
            value = 'checked';
            break;
          case '-':case '*':
            value = 'bullet';
            break;
          default:
            value = 'ordered';
        }
        this.quill.insertText(range.index, ' ', _quill2.default.sources.USER);
        this.quill.history.cutoff();
        var delta = new _quillDelta2.default().retain(range.index - offset).delete(length + 1).retain(line.length() - 2 - offset).retain(1, { list: value });
        this.quill.updateContents(delta, _quill2.default.sources.USER);
        this.quill.history.cutoff();
        this.quill.setSelection(range.index - length, _quill2.default.sources.SILENT);
      }
    },
    'code exit': {
      key: Keyboard.keys.ENTER,
      collapsed: true,
      format: ['code-block'],
      prefix: /\n\n$/,
      suffix: /^\s+$/,
      handler: function handler(range) {
        var _quill$getLine9 = this.quill.getLine(range.index),
            _quill$getLine10 = _slicedToArray(_quill$getLine9, 2),
            line = _quill$getLine10[0],
            offset = _quill$getLine10[1];

        var delta = new _quillDelta2.default().retain(range.index + line.length() - offset - 2).retain(1, { 'code-block': null }).delete(1);
        this.quill.updateContents(delta, _quill2.default.sources.USER);
      }
    },
    'embed left': makeEmbedArrowHandler(Keyboard.keys.LEFT, false),
    'embed left shift': makeEmbedArrowHandler(Keyboard.keys.LEFT, true),
    'embed right': makeEmbedArrowHandler(Keyboard.keys.RIGHT, false),
    'embed right shift': makeEmbedArrowHandler(Keyboard.keys.RIGHT, true)
  }
};

function makeEmbedArrowHandler(key, shiftKey) {
  var _ref3;

  var where = key === Keyboard.keys.LEFT ? 'prefix' : 'suffix';
  return _ref3 = {
    key: key,
    shiftKey: shiftKey,
    altKey: null
  }, _defineProperty(_ref3, where, /^$/), _defineProperty(_ref3, 'handler', function handler(range) {
    var index = range.index;
    if (key === Keyboard.keys.RIGHT) {
      index += range.length + 1;
    }

    var _quill$getLeaf3 = this.quill.getLeaf(index),
        _quill$getLeaf4 = _slicedToArray(_quill$getLeaf3, 1),
        leaf = _quill$getLeaf4[0];

    if (!(leaf instanceof _parchment2.default.Embed)) return true;
    if (key === Keyboard.keys.LEFT) {
      if (shiftKey) {
        this.quill.setSelection(range.index - 1, range.length + 1, _quill2.default.sources.USER);
      } else {
        this.quill.setSelection(range.index - 1, _quill2.default.sources.USER);
      }
    } else {
      if (shiftKey) {
        this.quill.setSelection(range.index, range.length + 1, _quill2.default.sources.USER);
      } else {
        this.quill.setSelection(range.index + range.length + 1, _quill2.default.sources.USER);
      }
    }
    return false;
  }), _ref3;
}

function handleBackspace(range, context) {
  if (range.index === 0 || this.quill.getLength() <= 1) return;

  var _quill$getLine11 = this.quill.getLine(range.index),
      _quill$getLine12 = _slicedToArray(_quill$getLine11, 1),
      line = _quill$getLine12[0];

  var formats = {};
  if (context.offset === 0) {
    var _quill$getLine13 = this.quill.getLine(range.index - 1),
        _quill$getLine14 = _slicedToArray(_quill$getLine13, 1),
        prev = _quill$getLine14[0];

    if (prev != null && prev.length() > 1) {
      var curFormats = line.formats();
      var prevFormats = this.quill.getFormat(range.index - 1, 1);
      formats = _op2.default.attributes.diff(curFormats, prevFormats) || {};
    }
  }
  // Check for astral symbols
  var length = /[\uD800-\uDBFF][\uDC00-\uDFFF]$/.test(context.prefix) ? 2 : 1;
  this.quill.deleteText(range.index - length, length, _quill2.default.sources.USER);
  if (Object.keys(formats).length > 0) {
    this.quill.formatLine(range.index - length, length, formats, _quill2.default.sources.USER);
  }
  this.quill.focus();
}

function handleDelete(range, context) {
  // Check for astral symbols
  var length = /^[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(context.suffix) ? 2 : 1;
  if (range.index >= this.quill.getLength() - length) return;
  var formats = {},
      nextLength = 0;

  var _quill$getLine15 = this.quill.getLine(range.index),
      _quill$getLine16 = _slicedToArray(_quill$getLine15, 1),
      line = _quill$getLine16[0];

  if (context.offset >= line.length() - 1) {
    var _quill$getLine17 = this.quill.getLine(range.index + 1),
        _quill$getLine18 = _slicedToArray(_quill$getLine17, 1),
        next = _quill$getLine18[0];

    if (next) {
      var curFormats = line.formats();
      var nextFormats = this.quill.getFormat(range.index, 1);
      formats = _op2.default.attributes.diff(curFormats, nextFormats) || {};
      nextLength = next.length();
    }
  }
  this.quill.deleteText(range.index, length, _quill2.default.sources.USER);
  if (Object.keys(formats).length > 0) {
    this.quill.formatLine(range.index + nextLength - 1, length, formats, _quill2.default.sources.USER);
  }
}

function handleDeleteRange(range) {
  var lines = this.quill.getLines(range);
  var formats = {};
  if (lines.length > 1) {
    var firstFormats = lines[0].formats();
    var lastFormats = lines[lines.length - 1].formats();
    formats = _op2.default.attributes.diff(lastFormats, firstFormats) || {};
  }
  this.quill.deleteText(range, _quill2.default.sources.USER);
  if (Object.keys(formats).length > 0) {
    this.quill.formatLine(range.index, 1, formats, _quill2.default.sources.USER);
  }
  this.quill.setSelection(range.index, _quill2.default.sources.SILENT);
  this.quill.focus();
}

function handleEnter(range, context) {
  var _this3 = this;

  if (range.length > 0) {
    this.quill.scroll.deleteAt(range.index, range.length); // So we do not trigger text-change
  }
  var lineFormats = Object.keys(context.format).reduce(function (lineFormats, format) {
    if (_parchment2.default.query(format, _parchment2.default.Scope.BLOCK) && !Array.isArray(context.format[format])) {
      lineFormats[format] = context.format[format];
    }
    return lineFormats;
  }, {});
  this.quill.insertText(range.index, '\n', lineFormats, _quill2.default.sources.USER);
  // Earlier scroll.deleteAt might have messed up our selection,
  // so insertText's built in selection preservation is not reliable
  this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
  this.quill.focus();
  Object.keys(context.format).forEach(function (name) {
    if (lineFormats[name] != null) return;
    if (Array.isArray(context.format[name])) return;
    if (name === 'link') return;
    _this3.quill.format(name, context.format[name], _quill2.default.sources.USER);
  });
}

function makeCodeBlockHandler(indent) {
  return {
    key: Keyboard.keys.TAB,
    shiftKey: !indent,
    format: { 'code-block': true },
    handler: function handler(range) {
      var CodeBlock = _parchment2.default.query('code-block');
      var index = range.index,
          length = range.length;

      var _quill$scroll$descend = this.quill.scroll.descendant(CodeBlock, index),
          _quill$scroll$descend2 = _slicedToArray(_quill$scroll$descend, 2),
          block = _quill$scroll$descend2[0],
          offset = _quill$scroll$descend2[1];

      if (block == null) return;
      var scrollIndex = this.quill.getIndex(block);
      var start = block.newlineIndex(offset, true) + 1;
      var end = block.newlineIndex(scrollIndex + offset + length);
      var lines = block.domNode.textContent.slice(start, end).split('\n');
      offset = 0;
      lines.forEach(function (line, i) {
        if (indent) {
          block.insertAt(start + offset, CodeBlock.TAB);
          offset += CodeBlock.TAB.length;
          if (i === 0) {
            index += CodeBlock.TAB.length;
          } else {
            length += CodeBlock.TAB.length;
          }
        } else if (line.startsWith(CodeBlock.TAB)) {
          block.deleteAt(start + offset, CodeBlock.TAB.length);
          offset -= CodeBlock.TAB.length;
          if (i === 0) {
            index -= CodeBlock.TAB.length;
          } else {
            length -= CodeBlock.TAB.length;
          }
        }
        offset += line.length + 1;
      });
      this.quill.update(_quill2.default.sources.USER);
      this.quill.setSelection(index, length, _quill2.default.sources.SILENT);
    }
  };
}

function makeFormatHandler(format) {
  return {
    key: format[0].toUpperCase(),
    shortKey: true,
    handler: function handler(range, context) {
      this.quill.format(format, !context.format[format], _quill2.default.sources.USER);
    }
  };
}

function normalize(binding) {
  if (typeof binding === 'string' || typeof binding === 'number') {
    return normalize({ key: binding });
  }
  if ((typeof binding === 'undefined' ? 'undefined' : _typeof(binding)) === 'object') {
    binding = (0, _clone2.default)(binding, false);
  }
  if (typeof binding.key === 'string') {
    if (Keyboard.keys[binding.key.toUpperCase()] != null) {
      binding.key = Keyboard.keys[binding.key.toUpperCase()];
    } else if (binding.key.length === 1) {
      binding.key = binding.key.toUpperCase().charCodeAt(0);
    } else {
      return null;
    }
  }
  if (binding.shortKey) {
    binding[SHORTKEY] = binding.shortKey;
    delete binding.shortKey;
  }
  return binding;
}

exports.default = Keyboard;
exports.SHORTKEY = SHORTKEY;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _text = __webpack_require__(7);

var _text2 = _interopRequireDefault(_text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Cursor = function (_Parchment$Embed) {
  _inherits(Cursor, _Parchment$Embed);

  _createClass(Cursor, null, [{
    key: 'value',
    value: function value() {
      return undefined;
    }
  }]);

  function Cursor(domNode, selection) {
    _classCallCheck(this, Cursor);

    var _this = _possibleConstructorReturn(this, (Cursor.__proto__ || Object.getPrototypeOf(Cursor)).call(this, domNode));

    _this.selection = selection;
    _this.textNode = document.createTextNode(Cursor.CONTENTS);
    _this.domNode.appendChild(_this.textNode);
    _this._length = 0;
    return _this;
  }

  _createClass(Cursor, [{
    key: 'detach',
    value: function detach() {
      // super.detach() will also clear domNode.__blot
      if (this.parent != null) this.parent.removeChild(this);
    }
  }, {
    key: 'format',
    value: function format(name, value) {
      if (this._length !== 0) {
        return _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'format', this).call(this, name, value);
      }
      var target = this,
          index = 0;
      while (target != null && target.statics.scope !== _parchment2.default.Scope.BLOCK_BLOT) {
        index += target.offset(target.parent);
        target = target.parent;
      }
      if (target != null) {
        this._length = Cursor.CONTENTS.length;
        target.optimize();
        target.formatAt(index, Cursor.CONTENTS.length, name, value);
        this._length = 0;
      }
    }
  }, {
    key: 'index',
    value: function index(node, offset) {
      if (node === this.textNode) return 0;
      return _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'index', this).call(this, node, offset);
    }
  }, {
    key: 'length',
    value: function length() {
      return this._length;
    }
  }, {
    key: 'position',
    value: function position() {
      return [this.textNode, this.textNode.data.length];
    }
  }, {
    key: 'remove',
    value: function remove() {
      _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'remove', this).call(this);
      this.parent = null;
    }
  }, {
    key: 'restore',
    value: function restore() {
      if (this.selection.composing || this.parent == null) return;
      var textNode = this.textNode;
      var range = this.selection.getNativeRange();
      var restoreText = void 0,
          start = void 0,
          end = void 0;
      if (range != null && range.start.node === textNode && range.end.node === textNode) {
        var _ref = [textNode, range.start.offset, range.end.offset];
        restoreText = _ref[0];
        start = _ref[1];
        end = _ref[2];
      }
      // Link format will insert text outside of anchor tag
      while (this.domNode.lastChild != null && this.domNode.lastChild !== this.textNode) {
        this.domNode.parentNode.insertBefore(this.domNode.lastChild, this.domNode);
      }
      if (this.textNode.data !== Cursor.CONTENTS) {
        var text = this.textNode.data.split(Cursor.CONTENTS).join('');
        if (this.next instanceof _text2.default) {
          restoreText = this.next.domNode;
          this.next.insertAt(0, text);
          this.textNode.data = Cursor.CONTENTS;
        } else {
          this.textNode.data = text;
          this.parent.insertBefore(_parchment2.default.create(this.textNode), this);
          this.textNode = document.createTextNode(Cursor.CONTENTS);
          this.domNode.appendChild(this.textNode);
        }
      }
      this.remove();
      if (start != null) {
        var _map = [start, end].map(function (offset) {
          return Math.max(0, Math.min(restoreText.data.length, offset - 1));
        });

        var _map2 = _slicedToArray(_map, 2);

        start = _map2[0];
        end = _map2[1];

        return {
          startNode: restoreText,
          startOffset: start,
          endNode: restoreText,
          endOffset: end
        };
      }
    }
  }, {
    key: 'update',
    value: function update(mutations, context) {
      var _this2 = this;

      if (mutations.some(function (mutation) {
        return mutation.type === 'characterData' && mutation.target === _this2.textNode;
      })) {
        var range = this.restore();
        if (range) context.range = range;
      }
    }
  }, {
    key: 'value',
    value: function value() {
      return '';
    }
  }]);

  return Cursor;
}(_parchment2.default.Embed);

Cursor.blotName = 'cursor';
Cursor.className = 'ql-cursor';
Cursor.tagName = 'span';
Cursor.CONTENTS = '\uFEFF'; // Zero width no break space


exports.default = Cursor;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Container = function (_Parchment$Container) {
  _inherits(Container, _Parchment$Container);

  function Container() {
    _classCallCheck(this, Container);

    return _possibleConstructorReturn(this, (Container.__proto__ || Object.getPrototypeOf(Container)).apply(this, arguments));
  }

  return Container;
}(_parchment2.default.Container);

Container.allowedChildren = [_block2.default, _block.BlockEmbed, Container];

exports.default = Container;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColorStyle = exports.ColorClass = exports.ColorAttributor = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ColorAttributor = function (_Parchment$Attributor) {
  _inherits(ColorAttributor, _Parchment$Attributor);

  function ColorAttributor() {
    _classCallCheck(this, ColorAttributor);

    return _possibleConstructorReturn(this, (ColorAttributor.__proto__ || Object.getPrototypeOf(ColorAttributor)).apply(this, arguments));
  }

  _createClass(ColorAttributor, [{
    key: 'value',
    value: function value(domNode) {
      var value = _get(ColorAttributor.prototype.__proto__ || Object.getPrototypeOf(ColorAttributor.prototype), 'value', this).call(this, domNode);
      if (!value.startsWith('rgb(')) return value;
      value = value.replace(/^[^\d]+/, '').replace(/[^\d]+$/, '');
      return '#' + value.split(',').map(function (component) {
        return ('00' + parseInt(component).toString(16)).slice(-2);
      }).join('');
    }
  }]);

  return ColorAttributor;
}(_parchment2.default.Attributor.Style);

var ColorClass = new _parchment2.default.Attributor.Class('color', 'ql-color', {
  scope: _parchment2.default.Scope.INLINE
});
var ColorStyle = new ColorAttributor('color', 'color', {
  scope: _parchment2.default.Scope.INLINE
});

exports.ColorAttributor = ColorAttributor;
exports.ColorClass = ColorClass;
exports.ColorStyle = ColorStyle;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sanitize = exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Link = function (_Inline) {
  _inherits(Link, _Inline);

  function Link() {
    _classCallCheck(this, Link);

    return _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).apply(this, arguments));
  }

  _createClass(Link, [{
    key: 'format',
    value: function format(name, value) {
      if (name !== this.statics.blotName || !value) return _get(Link.prototype.__proto__ || Object.getPrototypeOf(Link.prototype), 'format', this).call(this, name, value);
      value = this.constructor.sanitize(value);
      this.domNode.setAttribute('href', value);
    }
  }], [{
    key: 'create',
    value: function create(value) {
      var node = _get(Link.__proto__ || Object.getPrototypeOf(Link), 'create', this).call(this, value);
      value = this.sanitize(value);
      node.setAttribute('href', value);
      node.setAttribute('rel', 'noopener noreferrer');
      node.setAttribute('target', '_blank');
      return node;
    }
  }, {
    key: 'formats',
    value: function formats(domNode) {
      return domNode.getAttribute('href');
    }
  }, {
    key: 'sanitize',
    value: function sanitize(url) {
      return _sanitize(url, this.PROTOCOL_WHITELIST) ? url : this.SANITIZED_URL;
    }
  }]);

  return Link;
}(_inline2.default);

Link.blotName = 'link';
Link.tagName = 'A';
Link.SANITIZED_URL = 'about:blank';
Link.PROTOCOL_WHITELIST = ['http', 'https', 'mailto', 'tel'];

function _sanitize(url, protocols) {
  var anchor = document.createElement('a');
  anchor.href = url;
  var protocol = anchor.href.slice(0, anchor.href.indexOf(':'));
  return protocols.indexOf(protocol) > -1;
}

exports.default = Link;
exports.sanitize = _sanitize;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _keyboard = __webpack_require__(23);

var _keyboard2 = _interopRequireDefault(_keyboard);

var _dropdown = __webpack_require__(107);

var _dropdown2 = _interopRequireDefault(_dropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var optionsCounter = 0;

function toggleAriaAttribute(element, attribute) {
  element.setAttribute(attribute, !(element.getAttribute(attribute) === 'true'));
}

var Picker = function () {
  function Picker(select) {
    var _this = this;

    _classCallCheck(this, Picker);

    this.select = select;
    this.container = document.createElement('span');
    this.buildPicker();
    this.select.style.display = 'none';
    this.select.parentNode.insertBefore(this.container, this.select);

    this.label.addEventListener('mousedown', function () {
      _this.togglePicker();
    });
    this.label.addEventListener('keydown', function (event) {
      switch (event.keyCode) {
        // Allows the "Enter" key to open the picker
        case _keyboard2.default.keys.ENTER:
          _this.togglePicker();
          break;

        // Allows the "Escape" key to close the picker
        case _keyboard2.default.keys.ESCAPE:
          _this.escape();
          event.preventDefault();
          break;
        default:
      }
    });
    this.select.addEventListener('change', this.update.bind(this));
  }

  _createClass(Picker, [{
    key: 'togglePicker',
    value: function togglePicker() {
      this.container.classList.toggle('ql-expanded');
      // Toggle aria-expanded and aria-hidden to make the picker accessible
      toggleAriaAttribute(this.label, 'aria-expanded');
      toggleAriaAttribute(this.options, 'aria-hidden');
    }
  }, {
    key: 'buildItem',
    value: function buildItem(option) {
      var _this2 = this;

      var item = document.createElement('span');
      item.tabIndex = '0';
      item.setAttribute('role', 'button');

      item.classList.add('ql-picker-item');
      if (option.hasAttribute('value')) {
        item.setAttribute('data-value', option.getAttribute('value'));
      }
      if (option.textContent) {
        item.setAttribute('data-label', option.textContent);
      }
      item.addEventListener('click', function () {
        _this2.selectItem(item, true);
      });
      item.addEventListener('keydown', function (event) {
        switch (event.keyCode) {
          // Allows the "Enter" key to select an item
          case _keyboard2.default.keys.ENTER:
            _this2.selectItem(item, true);
            event.preventDefault();
            break;

          // Allows the "Escape" key to close the picker
          case _keyboard2.default.keys.ESCAPE:
            _this2.escape();
            event.preventDefault();
            break;
          default:
        }
      });

      return item;
    }
  }, {
    key: 'buildLabel',
    value: function buildLabel() {
      var label = document.createElement('span');
      label.classList.add('ql-picker-label');
      label.innerHTML = _dropdown2.default;
      label.tabIndex = '0';
      label.setAttribute('role', 'button');
      label.setAttribute('aria-expanded', 'false');
      this.container.appendChild(label);
      return label;
    }
  }, {
    key: 'buildOptions',
    value: function buildOptions() {
      var _this3 = this;

      var options = document.createElement('span');
      options.classList.add('ql-picker-options');

      // Don't want screen readers to read this until options are visible
      options.setAttribute('aria-hidden', 'true');
      options.tabIndex = '-1';

      // Need a unique id for aria-controls
      options.id = 'ql-picker-options-' + optionsCounter;
      optionsCounter += 1;
      this.label.setAttribute('aria-controls', options.id);

      this.options = options;

      [].slice.call(this.select.options).forEach(function (option) {
        var item = _this3.buildItem(option);
        options.appendChild(item);
        if (option.selected === true) {
          _this3.selectItem(item);
        }
      });
      this.container.appendChild(options);
    }
  }, {
    key: 'buildPicker',
    value: function buildPicker() {
      var _this4 = this;

      [].slice.call(this.select.attributes).forEach(function (item) {
        _this4.container.setAttribute(item.name, item.value);
      });
      this.container.classList.add('ql-picker');
      this.label = this.buildLabel();
      this.buildOptions();
    }
  }, {
    key: 'escape',
    value: function escape() {
      var _this5 = this;

      // Close menu and return focus to trigger label
      this.close();
      // Need setTimeout for accessibility to ensure that the browser executes
      // focus on the next process thread and after any DOM content changes
      setTimeout(function () {
        return _this5.label.focus();
      }, 1);
    }
  }, {
    key: 'close',
    value: function close() {
      this.container.classList.remove('ql-expanded');
      this.label.setAttribute('aria-expanded', 'false');
      this.options.setAttribute('aria-hidden', 'true');
    }
  }, {
    key: 'selectItem',
    value: function selectItem(item) {
      var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var selected = this.container.querySelector('.ql-selected');
      if (item === selected) return;
      if (selected != null) {
        selected.classList.remove('ql-selected');
      }
      if (item == null) return;
      item.classList.add('ql-selected');
      this.select.selectedIndex = [].indexOf.call(item.parentNode.children, item);
      if (item.hasAttribute('data-value')) {
        this.label.setAttribute('data-value', item.getAttribute('data-value'));
      } else {
        this.label.removeAttribute('data-value');
      }
      if (item.hasAttribute('data-label')) {
        this.label.setAttribute('data-label', item.getAttribute('data-label'));
      } else {
        this.label.removeAttribute('data-label');
      }
      if (trigger) {
        if (typeof Event === 'function') {
          this.select.dispatchEvent(new Event('change'));
        } else if ((typeof Event === 'undefined' ? 'undefined' : _typeof(Event)) === 'object') {
          // IE11
          var event = document.createEvent('Event');
          event.initEvent('change', true, true);
          this.select.dispatchEvent(event);
        }
        this.close();
      }
    }
  }, {
    key: 'update',
    value: function update() {
      var option = void 0;
      if (this.select.selectedIndex > -1) {
        var item = this.container.querySelector('.ql-picker-options').children[this.select.selectedIndex];
        option = this.select.options[this.select.selectedIndex];
        this.selectItem(item);
      } else {
        this.selectItem(null);
      }
      var isActive = option != null && option !== this.select.querySelector('option[selected]');
      this.label.classList.toggle('ql-active', isActive);
    }
  }]);

  return Picker;
}();

exports.default = Picker;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _quill = __webpack_require__(5);

var _quill2 = _interopRequireDefault(_quill);

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

var _break = __webpack_require__(16);

var _break2 = _interopRequireDefault(_break);

var _container = __webpack_require__(25);

var _container2 = _interopRequireDefault(_container);

var _cursor = __webpack_require__(24);

var _cursor2 = _interopRequireDefault(_cursor);

var _embed = __webpack_require__(35);

var _embed2 = _interopRequireDefault(_embed);

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

var _scroll = __webpack_require__(22);

var _scroll2 = _interopRequireDefault(_scroll);

var _text = __webpack_require__(7);

var _text2 = _interopRequireDefault(_text);

var _clipboard = __webpack_require__(55);

var _clipboard2 = _interopRequireDefault(_clipboard);

var _history = __webpack_require__(42);

var _history2 = _interopRequireDefault(_history);

var _keyboard = __webpack_require__(23);

var _keyboard2 = _interopRequireDefault(_keyboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_quill2.default.register({
  'blots/block': _block2.default,
  'blots/block/embed': _block.BlockEmbed,
  'blots/break': _break2.default,
  'blots/container': _container2.default,
  'blots/cursor': _cursor2.default,
  'blots/embed': _embed2.default,
  'blots/inline': _inline2.default,
  'blots/scroll': _scroll2.default,
  'blots/text': _text2.default,

  'modules/clipboard': _clipboard2.default,
  'modules/history': _history2.default,
  'modules/keyboard': _keyboard2.default
});

_parchment2.default.register(_block2.default, _break2.default, _cursor2.default, _inline2.default, _scroll2.default, _text2.default);

exports.default = _quill2.default;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Registry = __webpack_require__(1);
var ShadowBlot = /** @class */ (function () {
    function ShadowBlot(domNode) {
        this.domNode = domNode;
        // @ts-ignore
        this.domNode[Registry.DATA_KEY] = { blot: this };
    }
    Object.defineProperty(ShadowBlot.prototype, "statics", {
        // Hack for accessing inherited static methods
        get: function () {
            return this.constructor;
        },
        enumerable: true,
        configurable: true
    });
    ShadowBlot.create = function (value) {
        if (this.tagName == null) {
            throw new Registry.ParchmentError('Blot definition missing tagName');
        }
        var node;
        if (Array.isArray(this.tagName)) {
            if (typeof value === 'string') {
                value = value.toUpperCase();
                if (parseInt(value).toString() === value) {
                    value = parseInt(value);
                }
            }
            if (typeof value === 'number') {
                node = document.createElement(this.tagName[value - 1]);
            }
            else if (this.tagName.indexOf(value) > -1) {
                node = document.createElement(value);
            }
            else {
                node = document.createElement(this.tagName[0]);
            }
        }
        else {
            node = document.createElement(this.tagName);
        }
        if (this.className) {
            node.classList.add(this.className);
        }
        return node;
    };
    ShadowBlot.prototype.attach = function () {
        if (this.parent != null) {
            this.scroll = this.parent.scroll;
        }
    };
    ShadowBlot.prototype.clone = function () {
        var domNode = this.domNode.cloneNode(false);
        return Registry.create(domNode);
    };
    ShadowBlot.prototype.detach = function () {
        if (this.parent != null)
            this.parent.removeChild(this);
        // @ts-ignore
        delete this.domNode[Registry.DATA_KEY];
    };
    ShadowBlot.prototype.deleteAt = function (index, length) {
        var blot = this.isolate(index, length);
        blot.remove();
    };
    ShadowBlot.prototype.formatAt = function (index, length, name, value) {
        var blot = this.isolate(index, length);
        if (Registry.query(name, Registry.Scope.BLOT) != null && value) {
            blot.wrap(name, value);
        }
        else if (Registry.query(name, Registry.Scope.ATTRIBUTE) != null) {
            var parent = Registry.create(this.statics.scope);
            blot.wrap(parent);
            parent.format(name, value);
        }
    };
    ShadowBlot.prototype.insertAt = function (index, value, def) {
        var blot = def == null ? Registry.create('text', value) : Registry.create(value, def);
        var ref = this.split(index);
        this.parent.insertBefore(blot, ref);
    };
    ShadowBlot.prototype.insertInto = function (parentBlot, refBlot) {
        if (refBlot === void 0) { refBlot = null; }
        if (this.parent != null) {
            this.parent.children.remove(this);
        }
        var refDomNode = null;
        parentBlot.children.insertBefore(this, refBlot);
        if (refBlot != null) {
            refDomNode = refBlot.domNode;
        }
        if (this.domNode.parentNode != parentBlot.domNode ||
            this.domNode.nextSibling != refDomNode) {
            parentBlot.domNode.insertBefore(this.domNode, refDomNode);
        }
        this.parent = parentBlot;
        this.attach();
    };
    ShadowBlot.prototype.isolate = function (index, length) {
        var target = this.split(index);
        target.split(length);
        return target;
    };
    ShadowBlot.prototype.length = function () {
        return 1;
    };
    ShadowBlot.prototype.offset = function (root) {
        if (root === void 0) { root = this.parent; }
        if (this.parent == null || this == root)
            return 0;
        return this.parent.children.offset(this) + this.parent.offset(root);
    };
    ShadowBlot.prototype.optimize = function (context) {
        // TODO clean up once we use WeakMap
        // @ts-ignore
        if (this.domNode[Registry.DATA_KEY] != null) {
            // @ts-ignore
            delete this.domNode[Registry.DATA_KEY].mutations;
        }
    };
    ShadowBlot.prototype.remove = function () {
        if (this.domNode.parentNode != null) {
            this.domNode.parentNode.removeChild(this.domNode);
        }
        this.detach();
    };
    ShadowBlot.prototype.replace = function (target) {
        if (target.parent == null)
            return;
        target.parent.insertBefore(this, target.next);
        target.remove();
    };
    ShadowBlot.prototype.replaceWith = function (name, value) {
        var replacement = typeof name === 'string' ? Registry.create(name, value) : name;
        replacement.replace(this);
        return replacement;
    };
    ShadowBlot.prototype.split = function (index, force) {
        return index === 0 ? this : this.next;
    };
    ShadowBlot.prototype.update = function (mutations, context) {
        // Nothing to do by default
    };
    ShadowBlot.prototype.wrap = function (name, value) {
        var wrapper = typeof name === 'string' ? Registry.create(name, value) : name;
        if (this.parent != null) {
            this.parent.insertBefore(wrapper, this.next);
        }
        wrapper.appendChild(this);
        return wrapper;
    };
    ShadowBlot.blotName = 'abstract';
    return ShadowBlot;
}());
exports.default = ShadowBlot;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var attributor_1 = __webpack_require__(12);
var class_1 = __webpack_require__(32);
var style_1 = __webpack_require__(33);
var Registry = __webpack_require__(1);
var AttributorStore = /** @class */ (function () {
    function AttributorStore(domNode) {
        this.attributes = {};
        this.domNode = domNode;
        this.build();
    }
    AttributorStore.prototype.attribute = function (attribute, value) {
        // verb
        if (value) {
            if (attribute.add(this.domNode, value)) {
                if (attribute.value(this.domNode) != null) {
                    this.attributes[attribute.attrName] = attribute;
                }
                else {
                    delete this.attributes[attribute.attrName];
                }
            }
        }
        else {
            attribute.remove(this.domNode);
            delete this.attributes[attribute.attrName];
        }
    };
    AttributorStore.prototype.build = function () {
        var _this = this;
        this.attributes = {};
        var attributes = attributor_1.default.keys(this.domNode);
        var classes = class_1.default.keys(this.domNode);
        var styles = style_1.default.keys(this.domNode);
        attributes
            .concat(classes)
            .concat(styles)
            .forEach(function (name) {
            var attr = Registry.query(name, Registry.Scope.ATTRIBUTE);
            if (attr instanceof attributor_1.default) {
                _this.attributes[attr.attrName] = attr;
            }
        });
    };
    AttributorStore.prototype.copy = function (target) {
        var _this = this;
        Object.keys(this.attributes).forEach(function (key) {
            var value = _this.attributes[key].value(_this.domNode);
            target.format(key, value);
        });
    };
    AttributorStore.prototype.move = function (target) {
        var _this = this;
        this.copy(target);
        Object.keys(this.attributes).forEach(function (key) {
            _this.attributes[key].remove(_this.domNode);
        });
        this.attributes = {};
    };
    AttributorStore.prototype.values = function () {
        var _this = this;
        return Object.keys(this.attributes).reduce(function (attributes, name) {
            attributes[name] = _this.attributes[name].value(_this.domNode);
            return attributes;
        }, {});
    };
    return AttributorStore;
}());
exports.default = AttributorStore;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var attributor_1 = __webpack_require__(12);
function match(node, prefix) {
    var className = node.getAttribute('class') || '';
    return className.split(/\s+/).filter(function (name) {
        return name.indexOf(prefix + "-") === 0;
    });
}
var ClassAttributor = /** @class */ (function (_super) {
    __extends(ClassAttributor, _super);
    function ClassAttributor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ClassAttributor.keys = function (node) {
        return (node.getAttribute('class') || '').split(/\s+/).map(function (name) {
            return name
                .split('-')
                .slice(0, -1)
                .join('-');
        });
    };
    ClassAttributor.prototype.add = function (node, value) {
        if (!this.canAdd(node, value))
            return false;
        this.remove(node);
        node.classList.add(this.keyName + "-" + value);
        return true;
    };
    ClassAttributor.prototype.remove = function (node) {
        var matches = match(node, this.keyName);
        matches.forEach(function (name) {
            node.classList.remove(name);
        });
        if (node.classList.length === 0) {
            node.removeAttribute('class');
        }
    };
    ClassAttributor.prototype.value = function (node) {
        var result = match(node, this.keyName)[0] || '';
        var value = result.slice(this.keyName.length + 1); // +1 for hyphen
        return this.canAdd(node, value) ? value : '';
    };
    return ClassAttributor;
}(attributor_1.default));
exports.default = ClassAttributor;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var attributor_1 = __webpack_require__(12);
function camelize(name) {
    var parts = name.split('-');
    var rest = parts
        .slice(1)
        .map(function (part) {
        return part[0].toUpperCase() + part.slice(1);
    })
        .join('');
    return parts[0] + rest;
}
var StyleAttributor = /** @class */ (function (_super) {
    __extends(StyleAttributor, _super);
    function StyleAttributor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StyleAttributor.keys = function (node) {
        return (node.getAttribute('style') || '').split(';').map(function (value) {
            var arr = value.split(':');
            return arr[0].trim();
        });
    };
    StyleAttributor.prototype.add = function (node, value) {
        if (!this.canAdd(node, value))
            return false;
        // @ts-ignore
        node.style[camelize(this.keyName)] = value;
        return true;
    };
    StyleAttributor.prototype.remove = function (node) {
        // @ts-ignore
        node.style[camelize(this.keyName)] = '';
        if (!node.getAttribute('style')) {
            node.removeAttribute('style');
        }
    };
    StyleAttributor.prototype.value = function (node) {
        // @ts-ignore
        var value = node.style[camelize(this.keyName)];
        return this.canAdd(node, value) ? value : '';
    };
    return StyleAttributor;
}(attributor_1.default));
exports.default = StyleAttributor;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Theme = function () {
  function Theme(quill, options) {
    _classCallCheck(this, Theme);

    this.quill = quill;
    this.options = options;
    this.modules = {};
  }

  _createClass(Theme, [{
    key: 'init',
    value: function init() {
      var _this = this;

      Object.keys(this.options.modules).forEach(function (name) {
        if (_this.modules[name] == null) {
          _this.addModule(name);
        }
      });
    }
  }, {
    key: 'addModule',
    value: function addModule(name) {
      var moduleClass = this.quill.constructor.import('modules/' + name);
      this.modules[name] = new moduleClass(this.quill, this.options.modules[name] || {});
      return this.modules[name];
    }
  }]);

  return Theme;
}();

Theme.DEFAULTS = {
  modules: {}
};
Theme.themes = {
  'default': Theme
};

exports.default = Theme;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _text = __webpack_require__(7);

var _text2 = _interopRequireDefault(_text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GUARD_TEXT = '\uFEFF';

var Embed = function (_Parchment$Embed) {
  _inherits(Embed, _Parchment$Embed);

  function Embed(node) {
    _classCallCheck(this, Embed);

    var _this = _possibleConstructorReturn(this, (Embed.__proto__ || Object.getPrototypeOf(Embed)).call(this, node));

    _this.contentNode = document.createElement('span');
    _this.contentNode.setAttribute('contenteditable', false);
    [].slice.call(_this.domNode.childNodes).forEach(function (childNode) {
      _this.contentNode.appendChild(childNode);
    });
    _this.leftGuard = document.createTextNode(GUARD_TEXT);
    _this.rightGuard = document.createTextNode(GUARD_TEXT);
    _this.domNode.appendChild(_this.leftGuard);
    _this.domNode.appendChild(_this.contentNode);
    _this.domNode.appendChild(_this.rightGuard);
    return _this;
  }

  _createClass(Embed, [{
    key: 'index',
    value: function index(node, offset) {
      if (node === this.leftGuard) return 0;
      if (node === this.rightGuard) return 1;
      return _get(Embed.prototype.__proto__ || Object.getPrototypeOf(Embed.prototype), 'index', this).call(this, node, offset);
    }
  }, {
    key: 'restore',
    value: function restore(node) {
      var range = void 0,
          textNode = void 0;
      var text = node.data.split(GUARD_TEXT).join('');
      if (node === this.leftGuard) {
        if (this.prev instanceof _text2.default) {
          var prevLength = this.prev.length();
          this.prev.insertAt(prevLength, text);
          range = {
            startNode: this.prev.domNode,
            startOffset: prevLength + text.length
          };
        } else {
          textNode = document.createTextNode(text);
          this.parent.insertBefore(_parchment2.default.create(textNode), this);
          range = {
            startNode: textNode,
            startOffset: text.length
          };
        }
      } else if (node === this.rightGuard) {
        if (this.next instanceof _text2.default) {
          this.next.insertAt(0, text);
          range = {
            startNode: this.next.domNode,
            startOffset: text.length
          };
        } else {
          textNode = document.createTextNode(text);
          this.parent.insertBefore(_parchment2.default.create(textNode), this.next);
          range = {
            startNode: textNode,
            startOffset: text.length
          };
        }
      }
      node.data = GUARD_TEXT;
      return range;
    }
  }, {
    key: 'update',
    value: function update(mutations, context) {
      var _this2 = this;

      mutations.forEach(function (mutation) {
        if (mutation.type === 'characterData' && (mutation.target === _this2.leftGuard || mutation.target === _this2.rightGuard)) {
          var range = _this2.restore(mutation.target);
          if (range) context.range = range;
        }
      });
    }
  }]);

  return Embed;
}(_parchment2.default.Embed);

exports.default = Embed;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlignStyle = exports.AlignClass = exports.AlignAttribute = undefined;

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var config = {
  scope: _parchment2.default.Scope.BLOCK,
  whitelist: ['right', 'center', 'justify']
};

var AlignAttribute = new _parchment2.default.Attributor.Attribute('align', 'align', config);
var AlignClass = new _parchment2.default.Attributor.Class('align', 'ql-align', config);
var AlignStyle = new _parchment2.default.Attributor.Style('align', 'text-align', config);

exports.AlignAttribute = AlignAttribute;
exports.AlignClass = AlignClass;
exports.AlignStyle = AlignStyle;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BackgroundStyle = exports.BackgroundClass = undefined;

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _color = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BackgroundClass = new _parchment2.default.Attributor.Class('background', 'ql-bg', {
  scope: _parchment2.default.Scope.INLINE
});
var BackgroundStyle = new _color.ColorAttributor('background', 'background-color', {
  scope: _parchment2.default.Scope.INLINE
});

exports.BackgroundClass = BackgroundClass;
exports.BackgroundStyle = BackgroundStyle;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DirectionStyle = exports.DirectionClass = exports.DirectionAttribute = undefined;

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var config = {
  scope: _parchment2.default.Scope.BLOCK,
  whitelist: ['rtl']
};

var DirectionAttribute = new _parchment2.default.Attributor.Attribute('direction', 'dir', config);
var DirectionClass = new _parchment2.default.Attributor.Class('direction', 'ql-direction', config);
var DirectionStyle = new _parchment2.default.Attributor.Style('direction', 'direction', config);

exports.DirectionAttribute = DirectionAttribute;
exports.DirectionClass = DirectionClass;
exports.DirectionStyle = DirectionStyle;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FontClass = exports.FontStyle = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var config = {
  scope: _parchment2.default.Scope.INLINE,
  whitelist: ['serif', 'monospace']
};

var FontClass = new _parchment2.default.Attributor.Class('font', 'ql-font', config);

var FontStyleAttributor = function (_Parchment$Attributor) {
  _inherits(FontStyleAttributor, _Parchment$Attributor);

  function FontStyleAttributor() {
    _classCallCheck(this, FontStyleAttributor);

    return _possibleConstructorReturn(this, (FontStyleAttributor.__proto__ || Object.getPrototypeOf(FontStyleAttributor)).apply(this, arguments));
  }

  _createClass(FontStyleAttributor, [{
    key: 'value',
    value: function value(node) {
      return _get(FontStyleAttributor.prototype.__proto__ || Object.getPrototypeOf(FontStyleAttributor.prototype), 'value', this).call(this, node).replace(/["']/g, '');
    }
  }]);

  return FontStyleAttributor;
}(_parchment2.default.Attributor.Style);

var FontStyle = new FontStyleAttributor('font', 'font-family', config);

exports.FontStyle = FontStyle;
exports.FontClass = FontClass;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SizeStyle = exports.SizeClass = undefined;

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SizeClass = new _parchment2.default.Attributor.Class('size', 'ql-size', {
  scope: _parchment2.default.Scope.INLINE,
  whitelist: ['small', 'large', 'huge']
});
var SizeStyle = new _parchment2.default.Attributor.Style('size', 'font-size', {
  scope: _parchment2.default.Scope.INLINE,
  whitelist: ['10px', '18px', '32px']
});

exports.SizeClass = SizeClass;
exports.SizeStyle = SizeStyle;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  'align': {
    '': __webpack_require__(76),
    'center': __webpack_require__(77),
    'right': __webpack_require__(78),
    'justify': __webpack_require__(79)
  },
  'background': __webpack_require__(80),
  'blockquote': __webpack_require__(81),
  'bold': __webpack_require__(82),
  'clean': __webpack_require__(83),
  'code': __webpack_require__(58),
  'code-block': __webpack_require__(58),
  'color': __webpack_require__(84),
  'direction': {
    '': __webpack_require__(85),
    'rtl': __webpack_require__(86)
  },
  'float': {
    'center': __webpack_require__(87),
    'full': __webpack_require__(88),
    'left': __webpack_require__(89),
    'right': __webpack_require__(90)
  },
  'formula': __webpack_require__(91),
  'header': {
    '1': __webpack_require__(92),
    '2': __webpack_require__(93)
  },
  'italic': __webpack_require__(94),
  'image': __webpack_require__(95),
  'indent': {
    '+1': __webpack_require__(96),
    '-1': __webpack_require__(97)
  },
  'link': __webpack_require__(98),
  'list': {
    'ordered': __webpack_require__(99),
    'bullet': __webpack_require__(100),
    'check': __webpack_require__(101)
  },
  'script': {
    'sub': __webpack_require__(102),
    'super': __webpack_require__(103)
  },
  'strike': __webpack_require__(104),
  'underline': __webpack_require__(105),
  'video': __webpack_require__(106)
};

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLastChangeIndex = exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _quill = __webpack_require__(5);

var _quill2 = _interopRequireDefault(_quill);

var _module = __webpack_require__(9);

var _module2 = _interopRequireDefault(_module);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var History = function (_Module) {
  _inherits(History, _Module);

  function History(quill, options) {
    _classCallCheck(this, History);

    var _this = _possibleConstructorReturn(this, (History.__proto__ || Object.getPrototypeOf(History)).call(this, quill, options));

    _this.lastRecorded = 0;
    _this.ignoreChange = false;
    _this.clear();
    _this.quill.on(_quill2.default.events.EDITOR_CHANGE, function (eventName, delta, oldDelta, source) {
      if (eventName !== _quill2.default.events.TEXT_CHANGE || _this.ignoreChange) return;
      if (!_this.options.userOnly || source === _quill2.default.sources.USER) {
        _this.record(delta, oldDelta);
      } else {
        _this.transform(delta);
      }
    });
    _this.quill.keyboard.addBinding({ key: 'Z', shortKey: true }, _this.undo.bind(_this));
    _this.quill.keyboard.addBinding({ key: 'Z', shortKey: true, shiftKey: true }, _this.redo.bind(_this));
    if (/Win/i.test(navigator.platform)) {
      _this.quill.keyboard.addBinding({ key: 'Y', shortKey: true }, _this.redo.bind(_this));
    }
    return _this;
  }

  _createClass(History, [{
    key: 'change',
    value: function change(source, dest) {
      if (this.stack[source].length === 0) return;
      var delta = this.stack[source].pop();
      this.stack[dest].push(delta);
      this.lastRecorded = 0;
      this.ignoreChange = true;
      this.quill.updateContents(delta[source], _quill2.default.sources.USER);
      this.ignoreChange = false;
      var index = getLastChangeIndex(delta[source]);
      this.quill.setSelection(index);
    }
  }, {
    key: 'clear',
    value: function clear() {
      this.stack = { undo: [], redo: [] };
    }
  }, {
    key: 'cutoff',
    value: function cutoff() {
      this.lastRecorded = 0;
    }
  }, {
    key: 'record',
    value: function record(changeDelta, oldDelta) {
      if (changeDelta.ops.length === 0) return;
      this.stack.redo = [];
      var undoDelta = this.quill.getContents().diff(oldDelta);
      var timestamp = Date.now();
      if (this.lastRecorded + this.options.delay > timestamp && this.stack.undo.length > 0) {
        var delta = this.stack.undo.pop();
        undoDelta = undoDelta.compose(delta.undo);
        changeDelta = delta.redo.compose(changeDelta);
      } else {
        this.lastRecorded = timestamp;
      }
      this.stack.undo.push({
        redo: changeDelta,
        undo: undoDelta
      });
      if (this.stack.undo.length > this.options.maxStack) {
        this.stack.undo.shift();
      }
    }
  }, {
    key: 'redo',
    value: function redo() {
      this.change('redo', 'undo');
    }
  }, {
    key: 'transform',
    value: function transform(delta) {
      this.stack.undo.forEach(function (change) {
        change.undo = delta.transform(change.undo, true);
        change.redo = delta.transform(change.redo, true);
      });
      this.stack.redo.forEach(function (change) {
        change.undo = delta.transform(change.undo, true);
        change.redo = delta.transform(change.redo, true);
      });
    }
  }, {
    key: 'undo',
    value: function undo() {
      this.change('undo', 'redo');
    }
  }]);

  return History;
}(_module2.default);

History.DEFAULTS = {
  delay: 1000,
  maxStack: 100,
  userOnly: false
};

function endsWithNewlineChange(delta) {
  var lastOp = delta.ops[delta.ops.length - 1];
  if (lastOp == null) return false;
  if (lastOp.insert != null) {
    return typeof lastOp.insert === 'string' && lastOp.insert.endsWith('\n');
  }
  if (lastOp.attributes != null) {
    return Object.keys(lastOp.attributes).some(function (attr) {
      return _parchment2.default.query(attr, _parchment2.default.Scope.BLOCK) != null;
    });
  }
  return false;
}

function getLastChangeIndex(delta) {
  var deleteLength = delta.reduce(function (length, op) {
    length += op.delete || 0;
    return length;
  }, 0);
  var changeIndex = delta.length() - deleteLength;
  if (endsWithNewlineChange(delta)) {
    changeIndex -= 1;
  }
  return changeIndex;
}

exports.default = History;
exports.getLastChangeIndex = getLastChangeIndex;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BaseTooltip = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _extend = __webpack_require__(3);

var _extend2 = _interopRequireDefault(_extend);

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _emitter = __webpack_require__(8);

var _emitter2 = _interopRequireDefault(_emitter);

var _keyboard = __webpack_require__(23);

var _keyboard2 = _interopRequireDefault(_keyboard);

var _theme = __webpack_require__(34);

var _theme2 = _interopRequireDefault(_theme);

var _colorPicker = __webpack_require__(59);

var _colorPicker2 = _interopRequireDefault(_colorPicker);

var _iconPicker = __webpack_require__(60);

var _iconPicker2 = _interopRequireDefault(_iconPicker);

var _picker = __webpack_require__(28);

var _picker2 = _interopRequireDefault(_picker);

var _tooltip = __webpack_require__(61);

var _tooltip2 = _interopRequireDefault(_tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ALIGNS = [false, 'center', 'right', 'justify'];

var COLORS = ["#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff", "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff", "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff", "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2", "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466"];

var FONTS = [false, 'serif', 'monospace'];

var HEADERS = ['1', '2', '3', false];

var SIZES = ['small', false, 'large', 'huge'];

var BaseTheme = function (_Theme) {
  _inherits(BaseTheme, _Theme);

  function BaseTheme(quill, options) {
    _classCallCheck(this, BaseTheme);

    var _this = _possibleConstructorReturn(this, (BaseTheme.__proto__ || Object.getPrototypeOf(BaseTheme)).call(this, quill, options));

    var listener = function listener(e) {
      if (!document.body.contains(quill.root)) {
        return document.body.removeEventListener('click', listener);
      }
      if (_this.tooltip != null && !_this.tooltip.root.contains(e.target) && document.activeElement !== _this.tooltip.textbox && !_this.quill.hasFocus()) {
        _this.tooltip.hide();
      }
      if (_this.pickers != null) {
        _this.pickers.forEach(function (picker) {
          if (!picker.container.contains(e.target)) {
            picker.close();
          }
        });
      }
    };
    quill.emitter.listenDOM('click', document.body, listener);
    return _this;
  }

  _createClass(BaseTheme, [{
    key: 'addModule',
    value: function addModule(name) {
      var module = _get(BaseTheme.prototype.__proto__ || Object.getPrototypeOf(BaseTheme.prototype), 'addModule', this).call(this, name);
      if (name === 'toolbar') {
        this.extendToolbar(module);
      }
      return module;
    }
  }, {
    key: 'buildButtons',
    value: function buildButtons(buttons, icons) {
      buttons.forEach(function (button) {
        var className = button.getAttribute('class') || '';
        className.split(/\s+/).forEach(function (name) {
          if (!name.startsWith('ql-')) return;
          name = name.slice('ql-'.length);
          if (icons[name] == null) return;
          if (name === 'direction') {
            button.innerHTML = icons[name][''] + icons[name]['rtl'];
          } else if (typeof icons[name] === 'string') {
            button.innerHTML = icons[name];
          } else {
            var value = button.value || '';
            if (value != null && icons[name][value]) {
              button.innerHTML = icons[name][value];
            }
          }
        });
      });
    }
  }, {
    key: 'buildPickers',
    value: function buildPickers(selects, icons) {
      var _this2 = this;

      this.pickers = selects.map(function (select) {
        if (select.classList.contains('ql-align')) {
          if (select.querySelector('option') == null) {
            fillSelect(select, ALIGNS);
          }
          return new _iconPicker2.default(select, icons.align);
        } else if (select.classList.contains('ql-background') || select.classList.contains('ql-color')) {
          var format = select.classList.contains('ql-background') ? 'background' : 'color';
          if (select.querySelector('option') == null) {
            fillSelect(select, COLORS, format === 'background' ? '#ffffff' : '#000000');
          }
          return new _colorPicker2.default(select, icons[format]);
        } else {
          if (select.querySelector('option') == null) {
            if (select.classList.contains('ql-font')) {
              fillSelect(select, FONTS);
            } else if (select.classList.contains('ql-header')) {
              fillSelect(select, HEADERS);
            } else if (select.classList.contains('ql-size')) {
              fillSelect(select, SIZES);
            }
          }
          return new _picker2.default(select);
        }
      });
      var update = function update() {
        _this2.pickers.forEach(function (picker) {
          picker.update();
        });
      };
      this.quill.on(_emitter2.default.events.EDITOR_CHANGE, update);
    }
  }]);

  return BaseTheme;
}(_theme2.default);

BaseTheme.DEFAULTS = (0, _extend2.default)(true, {}, _theme2.default.DEFAULTS, {
  modules: {
    toolbar: {
      handlers: {
        formula: function formula() {
          this.quill.theme.tooltip.edit('formula');
        },
        image: function image() {
          var _this3 = this;

          var fileInput = this.container.querySelector('input.ql-image[type=file]');
          if (fileInput == null) {
            fileInput = document.createElement('input');
            fileInput.setAttribute('type', 'file');
            fileInput.setAttribute('accept', 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon');
            fileInput.classList.add('ql-image');
            fileInput.addEventListener('change', function () {
              if (fileInput.files != null && fileInput.files[0] != null) {
                var reader = new FileReader();
                reader.onload = function (e) {
                  var range = _this3.quill.getSelection(true);
                  _this3.quill.updateContents(new _quillDelta2.default().retain(range.index).delete(range.length).insert({ image: e.target.result }), _emitter2.default.sources.USER);
                  _this3.quill.setSelection(range.index + 1, _emitter2.default.sources.SILENT);
                  fileInput.value = "";
                };
                reader.readAsDataURL(fileInput.files[0]);
              }
            });
            this.container.appendChild(fileInput);
          }
          fileInput.click();
        },
        video: function video() {
          this.quill.theme.tooltip.edit('video');
        }
      }
    }
  }
});

var BaseTooltip = function (_Tooltip) {
  _inherits(BaseTooltip, _Tooltip);

  function BaseTooltip(quill, boundsContainer) {
    _classCallCheck(this, BaseTooltip);

    var _this4 = _possibleConstructorReturn(this, (BaseTooltip.__proto__ || Object.getPrototypeOf(BaseTooltip)).call(this, quill, boundsContainer));

    _this4.textbox = _this4.root.querySelector('input[type="text"]');
    _this4.listen();
    return _this4;
  }

  _createClass(BaseTooltip, [{
    key: 'listen',
    value: function listen() {
      var _this5 = this;

      this.textbox.addEventListener('keydown', function (event) {
        if (_keyboard2.default.match(event, 'enter')) {
          _this5.save();
          event.preventDefault();
        } else if (_keyboard2.default.match(event, 'escape')) {
          _this5.cancel();
          event.preventDefault();
        }
      });
    }
  }, {
    key: 'cancel',
    value: function cancel() {
      this.hide();
    }
  }, {
    key: 'edit',
    value: function edit() {
      var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'link';
      var preview = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this.root.classList.remove('ql-hidden');
      this.root.classList.add('ql-editing');
      if (preview != null) {
        this.textbox.value = preview;
      } else if (mode !== this.root.getAttribute('data-mode')) {
        this.textbox.value = '';
      }
      this.position(this.quill.getBounds(this.quill.selection.savedRange));
      this.textbox.select();
      this.textbox.setAttribute('placeholder', this.textbox.getAttribute('data-' + mode) || '');
      this.root.setAttribute('data-mode', mode);
    }
  }, {
    key: 'restoreFocus',
    value: function restoreFocus() {
      var scrollTop = this.quill.scrollingContainer.scrollTop;
      this.quill.focus();
      this.quill.scrollingContainer.scrollTop = scrollTop;
    }
  }, {
    key: 'save',
    value: function save() {
      var value = this.textbox.value;
      switch (this.root.getAttribute('data-mode')) {
        case 'link':
          {
            var scrollTop = this.quill.root.scrollTop;
            if (this.linkRange) {
              this.quill.formatText(this.linkRange, 'link', value, _emitter2.default.sources.USER);
              delete this.linkRange;
            } else {
              this.restoreFocus();
              this.quill.format('link', value, _emitter2.default.sources.USER);
            }
            this.quill.root.scrollTop = scrollTop;
            break;
          }
        case 'video':
          {
            value = extractVideoUrl(value);
          } // eslint-disable-next-line no-fallthrough
        case 'formula':
          {
            if (!value) break;
            var range = this.quill.getSelection(true);
            if (range != null) {
              var index = range.index + range.length;
              this.quill.insertEmbed(index, this.root.getAttribute('data-mode'), value, _emitter2.default.sources.USER);
              if (this.root.getAttribute('data-mode') === 'formula') {
                this.quill.insertText(index + 1, ' ', _emitter2.default.sources.USER);
              }
              this.quill.setSelection(index + 2, _emitter2.default.sources.USER);
            }
            break;
          }
        default:
      }
      this.textbox.value = '';
      this.hide();
    }
  }]);

  return BaseTooltip;
}(_tooltip2.default);

function extractVideoUrl(url) {
  var match = url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/) || url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/);
  if (match) {
    return (match[1] || 'https') + '://www.youtube.com/embed/' + match[2] + '?showinfo=0';
  }
  if (match = url.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/)) {
    // eslint-disable-line no-cond-assign
    return (match[1] || 'https') + '://player.vimeo.com/video/' + match[2] + '/';
  }
  return url;
}

function fillSelect(select, values) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  values.forEach(function (value) {
    var option = document.createElement('option');
    if (value === defaultValue) {
      option.setAttribute('selected', 'selected');
    } else {
      option.setAttribute('value', value);
    }
    select.appendChild(option);
  });
}

exports.BaseTooltip = BaseTooltip;
exports.default = BaseTheme;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var LinkedList = /** @class */ (function () {
    function LinkedList() {
        this.head = this.tail = null;
        this.length = 0;
    }
    LinkedList.prototype.append = function () {
        var nodes = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            nodes[_i] = arguments[_i];
        }
        this.insertBefore(nodes[0], null);
        if (nodes.length > 1) {
            this.append.apply(this, nodes.slice(1));
        }
    };
    LinkedList.prototype.contains = function (node) {
        var cur, next = this.iterator();
        while ((cur = next())) {
            if (cur === node)
                return true;
        }
        return false;
    };
    LinkedList.prototype.insertBefore = function (node, refNode) {
        if (!node)
            return;
        node.next = refNode;
        if (refNode != null) {
            node.prev = refNode.prev;
            if (refNode.prev != null) {
                refNode.prev.next = node;
            }
            refNode.prev = node;
            if (refNode === this.head) {
                this.head = node;
            }
        }
        else if (this.tail != null) {
            this.tail.next = node;
            node.prev = this.tail;
            this.tail = node;
        }
        else {
            node.prev = null;
            this.head = this.tail = node;
        }
        this.length += 1;
    };
    LinkedList.prototype.offset = function (target) {
        var index = 0, cur = this.head;
        while (cur != null) {
            if (cur === target)
                return index;
            index += cur.length();
            cur = cur.next;
        }
        return -1;
    };
    LinkedList.prototype.remove = function (node) {
        if (!this.contains(node))
            return;
        if (node.prev != null)
            node.prev.next = node.next;
        if (node.next != null)
            node.next.prev = node.prev;
        if (node === this.head)
            this.head = node.next;
        if (node === this.tail)
            this.tail = node.prev;
        this.length -= 1;
    };
    LinkedList.prototype.iterator = function (curNode) {
        if (curNode === void 0) { curNode = this.head; }
        // TODO use yield when we can
        return function () {
            var ret = curNode;
            if (curNode != null)
                curNode = curNode.next;
            return ret;
        };
    };
    LinkedList.prototype.find = function (index, inclusive) {
        if (inclusive === void 0) { inclusive = false; }
        var cur, next = this.iterator();
        while ((cur = next())) {
            var length = cur.length();
            if (index < length ||
                (inclusive && index === length && (cur.next == null || cur.next.length() !== 0))) {
                return [cur, index];
            }
            index -= length;
        }
        return [null, 0];
    };
    LinkedList.prototype.forEach = function (callback) {
        var cur, next = this.iterator();
        while ((cur = next())) {
            callback(cur);
        }
    };
    LinkedList.prototype.forEachAt = function (index, length, callback) {
        if (length <= 0)
            return;
        var _a = this.find(index), startNode = _a[0], offset = _a[1];
        var cur, curIndex = index - offset, next = this.iterator(startNode);
        while ((cur = next()) && curIndex < index + length) {
            var curLength = cur.length();
            if (index > curIndex) {
                callback(cur, index - curIndex, Math.min(length, curIndex + curLength - index));
            }
            else {
                callback(cur, 0, Math.min(curLength, index + length - curIndex));
            }
            curIndex += curLength;
        }
    };
    LinkedList.prototype.map = function (callback) {
        return this.reduce(function (memo, cur) {
            memo.push(callback(cur));
            return memo;
        }, []);
    };
    LinkedList.prototype.reduce = function (callback, memo) {
        var cur, next = this.iterator();
        while ((cur = next())) {
            memo = callback(memo, cur);
        }
        return memo;
    };
    return LinkedList;
}());
exports.default = LinkedList;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var container_1 = __webpack_require__(17);
var Registry = __webpack_require__(1);
var OBSERVER_CONFIG = {
    attributes: true,
    characterData: true,
    characterDataOldValue: true,
    childList: true,
    subtree: true,
};
var MAX_OPTIMIZE_ITERATIONS = 100;
var ScrollBlot = /** @class */ (function (_super) {
    __extends(ScrollBlot, _super);
    function ScrollBlot(node) {
        var _this = _super.call(this, node) || this;
        _this.scroll = _this;
        _this.observer = new MutationObserver(function (mutations) {
            _this.update(mutations);
        });
        _this.observer.observe(_this.domNode, OBSERVER_CONFIG);
        _this.attach();
        return _this;
    }
    ScrollBlot.prototype.detach = function () {
        _super.prototype.detach.call(this);
        this.observer.disconnect();
    };
    ScrollBlot.prototype.deleteAt = function (index, length) {
        this.update();
        if (index === 0 && length === this.length()) {
            this.children.forEach(function (child) {
                child.remove();
            });
        }
        else {
            _super.prototype.deleteAt.call(this, index, length);
        }
    };
    ScrollBlot.prototype.formatAt = function (index, length, name, value) {
        this.update();
        _super.prototype.formatAt.call(this, index, length, name, value);
    };
    ScrollBlot.prototype.insertAt = function (index, value, def) {
        this.update();
        _super.prototype.insertAt.call(this, index, value, def);
    };
    ScrollBlot.prototype.optimize = function (mutations, context) {
        var _this = this;
        if (mutations === void 0) { mutations = []; }
        if (context === void 0) { context = {}; }
        _super.prototype.optimize.call(this, context);
        // We must modify mutations directly, cannot make copy and then modify
        var records = [].slice.call(this.observer.takeRecords());
        // Array.push currently seems to be implemented by a non-tail recursive function
        // so we cannot just mutations.push.apply(mutations, this.observer.takeRecords());
        while (records.length > 0)
            mutations.push(records.pop());
        // TODO use WeakMap
        var mark = function (blot, markParent) {
            if (markParent === void 0) { markParent = true; }
            if (blot == null || blot === _this)
                return;
            if (blot.domNode.parentNode == null)
                return;
            // @ts-ignore
            if (blot.domNode[Registry.DATA_KEY].mutations == null) {
                // @ts-ignore
                blot.domNode[Registry.DATA_KEY].mutations = [];
            }
            if (markParent)
                mark(blot.parent);
        };
        var optimize = function (blot) {
            // Post-order traversal
            if (
            // @ts-ignore
            blot.domNode[Registry.DATA_KEY] == null ||
                // @ts-ignore
                blot.domNode[Registry.DATA_KEY].mutations == null) {
                return;
            }
            if (blot instanceof container_1.default) {
                blot.children.forEach(optimize);
            }
            blot.optimize(context);
        };
        var remaining = mutations;
        for (var i = 0; remaining.length > 0; i += 1) {
            if (i >= MAX_OPTIMIZE_ITERATIONS) {
                throw new Error('[Parchment] Maximum optimize iterations reached');
            }
            remaining.forEach(function (mutation) {
                var blot = Registry.find(mutation.target, true);
                if (blot == null)
                    return;
                if (blot.domNode === mutation.target) {
                    if (mutation.type === 'childList') {
                        mark(Registry.find(mutation.previousSibling, false));
                        [].forEach.call(mutation.addedNodes, function (node) {
                            var child = Registry.find(node, false);
                            mark(child, false);
                            if (child instanceof container_1.default) {
                                child.children.forEach(function (grandChild) {
                                    mark(grandChild, false);
                                });
                            }
                        });
                    }
                    else if (mutation.type === 'attributes') {
                        mark(blot.prev);
                    }
                }
                mark(blot);
            });
            this.children.forEach(optimize);
            remaining = [].slice.call(this.observer.takeRecords());
            records = remaining.slice();
            while (records.length > 0)
                mutations.push(records.pop());
        }
    };
    ScrollBlot.prototype.update = function (mutations, context) {
        var _this = this;
        if (context === void 0) { context = {}; }
        mutations = mutations || this.observer.takeRecords();
        // TODO use WeakMap
        mutations
            .map(function (mutation) {
            var blot = Registry.find(mutation.target, true);
            if (blot == null)
                return null;
            // @ts-ignore
            if (blot.domNode[Registry.DATA_KEY].mutations == null) {
                // @ts-ignore
                blot.domNode[Registry.DATA_KEY].mutations = [mutation];
                return blot;
            }
            else {
                // @ts-ignore
                blot.domNode[Registry.DATA_KEY].mutations.push(mutation);
                return null;
            }
        })
            .forEach(function (blot) {
            if (blot == null ||
                blot === _this ||
                //@ts-ignore
                blot.domNode[Registry.DATA_KEY] == null)
                return;
            // @ts-ignore
            blot.update(blot.domNode[Registry.DATA_KEY].mutations || [], context);
        });
        // @ts-ignore
        if (this.domNode[Registry.DATA_KEY].mutations != null) {
            // @ts-ignore
            _super.prototype.update.call(this, this.domNode[Registry.DATA_KEY].mutations, context);
        }
        this.optimize(mutations, context);
    };
    ScrollBlot.blotName = 'scroll';
    ScrollBlot.defaultChild = 'block';
    ScrollBlot.scope = Registry.Scope.BLOCK_BLOT;
    ScrollBlot.tagName = 'DIV';
    return ScrollBlot;
}(container_1.default));
exports.default = ScrollBlot;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var format_1 = __webpack_require__(18);
var Registry = __webpack_require__(1);
// Shallow object comparison
function isEqual(obj1, obj2) {
    if (Object.keys(obj1).length !== Object.keys(obj2).length)
        return false;
    // @ts-ignore
    for (var prop in obj1) {
        // @ts-ignore
        if (obj1[prop] !== obj2[prop])
            return false;
    }
    return true;
}
var InlineBlot = /** @class */ (function (_super) {
    __extends(InlineBlot, _super);
    function InlineBlot() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InlineBlot.formats = function (domNode) {
        if (domNode.tagName === InlineBlot.tagName)
            return undefined;
        return _super.formats.call(this, domNode);
    };
    InlineBlot.prototype.format = function (name, value) {
        var _this = this;
        if (name === this.statics.blotName && !value) {
            this.children.forEach(function (child) {
                if (!(child instanceof format_1.default)) {
                    child = child.wrap(InlineBlot.blotName, true);
                }
                _this.attributes.copy(child);
            });
            this.unwrap();
        }
        else {
            _super.prototype.format.call(this, name, value);
        }
    };
    InlineBlot.prototype.formatAt = function (index, length, name, value) {
        if (this.formats()[name] != null || Registry.query(name, Registry.Scope.ATTRIBUTE)) {
            var blot = this.isolate(index, length);
            blot.format(name, value);
        }
        else {
            _super.prototype.formatAt.call(this, index, length, name, value);
        }
    };
    InlineBlot.prototype.optimize = function (context) {
        _super.prototype.optimize.call(this, context);
        var formats = this.formats();
        if (Object.keys(formats).length === 0) {
            return this.unwrap(); // unformatted span
        }
        var next = this.next;
        if (next instanceof InlineBlot && next.prev === this && isEqual(formats, next.formats())) {
            next.moveChildren(this);
            next.remove();
        }
    };
    InlineBlot.blotName = 'inline';
    InlineBlot.scope = Registry.Scope.INLINE_BLOT;
    InlineBlot.tagName = 'SPAN';
    return InlineBlot;
}(format_1.default));
exports.default = InlineBlot;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var format_1 = __webpack_require__(18);
var Registry = __webpack_require__(1);
var BlockBlot = /** @class */ (function (_super) {
    __extends(BlockBlot, _super);
    function BlockBlot() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BlockBlot.formats = function (domNode) {
        var tagName = Registry.query(BlockBlot.blotName).tagName;
        if (domNode.tagName === tagName)
            return undefined;
        return _super.formats.call(this, domNode);
    };
    BlockBlot.prototype.format = function (name, value) {
        if (Registry.query(name, Registry.Scope.BLOCK) == null) {
            return;
        }
        else if (name === this.statics.blotName && !value) {
            this.replaceWith(BlockBlot.blotName);
        }
        else {
            _super.prototype.format.call(this, name, value);
        }
    };
    BlockBlot.prototype.formatAt = function (index, length, name, value) {
        if (Registry.query(name, Registry.Scope.BLOCK) != null) {
            this.format(name, value);
        }
        else {
            _super.prototype.formatAt.call(this, index, length, name, value);
        }
    };
    BlockBlot.prototype.insertAt = function (index, value, def) {
        if (def == null || Registry.query(value, Registry.Scope.INLINE) != null) {
            // Insert text or inline
            _super.prototype.insertAt.call(this, index, value, def);
        }
        else {
            var after = this.split(index);
            var blot = Registry.create(value, def);
            after.parent.insertBefore(blot, after);
        }
    };
    BlockBlot.prototype.update = function (mutations, context) {
        if (navigator.userAgent.match(/Trident/)) {
            this.build();
        }
        else {
            _super.prototype.update.call(this, mutations, context);
        }
    };
    BlockBlot.blotName = 'block';
    BlockBlot.scope = Registry.Scope.BLOCK_BLOT;
    BlockBlot.tagName = 'P';
    return BlockBlot;
}(format_1.default));
exports.default = BlockBlot;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var leaf_1 = __webpack_require__(19);
var EmbedBlot = /** @class */ (function (_super) {
    __extends(EmbedBlot, _super);
    function EmbedBlot() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EmbedBlot.formats = function (domNode) {
        return undefined;
    };
    EmbedBlot.prototype.format = function (name, value) {
        // super.formatAt wraps, which is what we want in general,
        // but this allows subclasses to overwrite for formats
        // that just apply to particular embeds
        _super.prototype.formatAt.call(this, 0, this.length(), name, value);
    };
    EmbedBlot.prototype.formatAt = function (index, length, name, value) {
        if (index === 0 && length === this.length()) {
            this.format(name, value);
        }
        else {
            _super.prototype.formatAt.call(this, index, length, name, value);
        }
    };
    EmbedBlot.prototype.formats = function () {
        return this.statics.formats(this.domNode);
    };
    return EmbedBlot;
}(leaf_1.default));
exports.default = EmbedBlot;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var leaf_1 = __webpack_require__(19);
var Registry = __webpack_require__(1);
var TextBlot = /** @class */ (function (_super) {
    __extends(TextBlot, _super);
    function TextBlot(node) {
        var _this = _super.call(this, node) || this;
        _this.text = _this.statics.value(_this.domNode);
        return _this;
    }
    TextBlot.create = function (value) {
        return document.createTextNode(value);
    };
    TextBlot.value = function (domNode) {
        var text = domNode.data;
        // @ts-ignore
        if (text['normalize'])
            text = text['normalize']();
        return text;
    };
    TextBlot.prototype.deleteAt = function (index, length) {
        this.domNode.data = this.text = this.text.slice(0, index) + this.text.slice(index + length);
    };
    TextBlot.prototype.index = function (node, offset) {
        if (this.domNode === node) {
            return offset;
        }
        return -1;
    };
    TextBlot.prototype.insertAt = function (index, value, def) {
        if (def == null) {
            this.text = this.text.slice(0, index) + value + this.text.slice(index);
            this.domNode.data = this.text;
        }
        else {
            _super.prototype.insertAt.call(this, index, value, def);
        }
    };
    TextBlot.prototype.length = function () {
        return this.text.length;
    };
    TextBlot.prototype.optimize = function (context) {
        _super.prototype.optimize.call(this, context);
        this.text = this.statics.value(this.domNode);
        if (this.text.length === 0) {
            this.remove();
        }
        else if (this.next instanceof TextBlot && this.next.prev === this) {
            this.insertAt(this.length(), this.next.value());
            this.next.remove();
        }
    };
    TextBlot.prototype.position = function (index, inclusive) {
        if (inclusive === void 0) { inclusive = false; }
        return [this.domNode, index];
    };
    TextBlot.prototype.split = function (index, force) {
        if (force === void 0) { force = false; }
        if (!force) {
            if (index === 0)
                return this;
            if (index === this.length())
                return this.next;
        }
        var after = Registry.create(this.domNode.splitText(index));
        this.parent.insertBefore(after, this.next);
        this.text = this.statics.value(this.domNode);
        return after;
    };
    TextBlot.prototype.update = function (mutations, context) {
        var _this = this;
        if (mutations.some(function (mutation) {
            return mutation.type === 'characterData' && mutation.target === _this.domNode;
        })) {
            this.text = this.statics.value(this.domNode);
        }
    };
    TextBlot.prototype.value = function () {
        return this.text;
    };
    TextBlot.blotName = 'text';
    TextBlot.scope = Registry.Scope.INLINE_BLOT;
    return TextBlot;
}(leaf_1.default));
exports.default = TextBlot;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var elem = document.createElement('div');
elem.classList.toggle('test-class', false);
if (elem.classList.contains('test-class')) {
  var _toggle = DOMTokenList.prototype.toggle;
  DOMTokenList.prototype.toggle = function (token, force) {
    if (arguments.length > 1 && !this.contains(token) === !force) {
      return force;
    } else {
      return _toggle.call(this, token);
    }
  };
}

if (!String.prototype.startsWith) {
  String.prototype.startsWith = function (searchString, position) {
    position = position || 0;
    return this.substr(position, searchString.length) === searchString;
  };
}

if (!String.prototype.endsWith) {
  String.prototype.endsWith = function (searchString, position) {
    var subjectString = this.toString();
    if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
      position = subjectString.length;
    }
    position -= searchString.length;
    var lastIndex = subjectString.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
  };
}

if (!Array.prototype.find) {
  Object.defineProperty(Array.prototype, "find", {
    value: function value(predicate) {
      if (this === null) {
        throw new TypeError('Array.prototype.find called on null or undefined');
      }
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }
      var list = Object(this);
      var length = list.length >>> 0;
      var thisArg = arguments[1];
      var value;

      for (var i = 0; i < length; i++) {
        value = list[i];
        if (predicate.call(thisArg, value, i, list)) {
          return value;
        }
      }
      return undefined;
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  // Disable resizing in Firefox
  document.execCommand("enableObjectResizing", false, false);
  // Disable automatic linkifying in IE11
  document.execCommand("autoUrlDetect", false, false);
});

/***/ }),
/* 51 */
/***/ (function(module, exports) {

/**
 * This library modifies the diff-patch-match library by Neil Fraser
 * by removing the patch and match functionality and certain advanced
 * options in the diff function. The original license is as follows:
 *
 * ===
 *
 * Diff Match and Patch
 *
 * Copyright 2006 Google Inc.
 * http://code.google.com/p/google-diff-match-patch/
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


/**
 * The data structure representing a diff is an array of tuples:
 * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]
 * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
 */
var DIFF_DELETE = -1;
var DIFF_INSERT = 1;
var DIFF_EQUAL = 0;


/**
 * Find the differences between two texts.  Simplifies the problem by stripping
 * any common prefix or suffix off the texts before diffing.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {Int} cursor_pos Expected edit position in text1 (optional)
 * @return {Array} Array of diff tuples.
 */
function diff_main(text1, text2, cursor_pos) {
  // Check for equality (speedup).
  if (text1 == text2) {
    if (text1) {
      return [[DIFF_EQUAL, text1]];
    }
    return [];
  }

  // Check cursor_pos within bounds
  if (cursor_pos < 0 || text1.length < cursor_pos) {
    cursor_pos = null;
  }

  // Trim off common prefix (speedup).
  var commonlength = diff_commonPrefix(text1, text2);
  var commonprefix = text1.substring(0, commonlength);
  text1 = text1.substring(commonlength);
  text2 = text2.substring(commonlength);

  // Trim off common suffix (speedup).
  commonlength = diff_commonSuffix(text1, text2);
  var commonsuffix = text1.substring(text1.length - commonlength);
  text1 = text1.substring(0, text1.length - commonlength);
  text2 = text2.substring(0, text2.length - commonlength);

  // Compute the diff on the middle block.
  var diffs = diff_compute_(text1, text2);

  // Restore the prefix and suffix.
  if (commonprefix) {
    diffs.unshift([DIFF_EQUAL, commonprefix]);
  }
  if (commonsuffix) {
    diffs.push([DIFF_EQUAL, commonsuffix]);
  }
  diff_cleanupMerge(diffs);
  if (cursor_pos != null) {
    diffs = fix_cursor(diffs, cursor_pos);
  }
  diffs = fix_emoji(diffs);
  return diffs;
};


/**
 * Find the differences between two texts.  Assumes that the texts do not
 * have any common prefix or suffix.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @return {Array} Array of diff tuples.
 */
function diff_compute_(text1, text2) {
  var diffs;

  if (!text1) {
    // Just add some text (speedup).
    return [[DIFF_INSERT, text2]];
  }

  if (!text2) {
    // Just delete some text (speedup).
    return [[DIFF_DELETE, text1]];
  }

  var longtext = text1.length > text2.length ? text1 : text2;
  var shorttext = text1.length > text2.length ? text2 : text1;
  var i = longtext.indexOf(shorttext);
  if (i != -1) {
    // Shorter text is inside the longer text (speedup).
    diffs = [[DIFF_INSERT, longtext.substring(0, i)],
             [DIFF_EQUAL, shorttext],
             [DIFF_INSERT, longtext.substring(i + shorttext.length)]];
    // Swap insertions for deletions if diff is reversed.
    if (text1.length > text2.length) {
      diffs[0][0] = diffs[2][0] = DIFF_DELETE;
    }
    return diffs;
  }

  if (shorttext.length == 1) {
    // Single character string.
    // After the previous speedup, the character can't be an equality.
    return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
  }

  // Check to see if the problem can be split in two.
  var hm = diff_halfMatch_(text1, text2);
  if (hm) {
    // A half-match was found, sort out the return data.
    var text1_a = hm[0];
    var text1_b = hm[1];
    var text2_a = hm[2];
    var text2_b = hm[3];
    var mid_common = hm[4];
    // Send both pairs off for separate processing.
    var diffs_a = diff_main(text1_a, text2_a);
    var diffs_b = diff_main(text1_b, text2_b);
    // Merge the results.
    return diffs_a.concat([[DIFF_EQUAL, mid_common]], diffs_b);
  }

  return diff_bisect_(text1, text2);
};


/**
 * Find the 'middle snake' of a diff, split the problem in two
 * and return the recursively constructed diff.
 * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @return {Array} Array of diff tuples.
 * @private
 */
function diff_bisect_(text1, text2) {
  // Cache the text lengths to prevent multiple calls.
  var text1_length = text1.length;
  var text2_length = text2.length;
  var max_d = Math.ceil((text1_length + text2_length) / 2);
  var v_offset = max_d;
  var v_length = 2 * max_d;
  var v1 = new Array(v_length);
  var v2 = new Array(v_length);
  // Setting all elements to -1 is faster in Chrome & Firefox than mixing
  // integers and undefined.
  for (var x = 0; x < v_length; x++) {
    v1[x] = -1;
    v2[x] = -1;
  }
  v1[v_offset + 1] = 0;
  v2[v_offset + 1] = 0;
  var delta = text1_length - text2_length;
  // If the total number of characters is odd, then the front path will collide
  // with the reverse path.
  var front = (delta % 2 != 0);
  // Offsets for start and end of k loop.
  // Prevents mapping of space beyond the grid.
  var k1start = 0;
  var k1end = 0;
  var k2start = 0;
  var k2end = 0;
  for (var d = 0; d < max_d; d++) {
    // Walk the front path one step.
    for (var k1 = -d + k1start; k1 <= d - k1end; k1 += 2) {
      var k1_offset = v_offset + k1;
      var x1;
      if (k1 == -d || (k1 != d && v1[k1_offset - 1] < v1[k1_offset + 1])) {
        x1 = v1[k1_offset + 1];
      } else {
        x1 = v1[k1_offset - 1] + 1;
      }
      var y1 = x1 - k1;
      while (x1 < text1_length && y1 < text2_length &&
             text1.charAt(x1) == text2.charAt(y1)) {
        x1++;
        y1++;
      }
      v1[k1_offset] = x1;
      if (x1 > text1_length) {
        // Ran off the right of the graph.
        k1end += 2;
      } else if (y1 > text2_length) {
        // Ran off the bottom of the graph.
        k1start += 2;
      } else if (front) {
        var k2_offset = v_offset + delta - k1;
        if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] != -1) {
          // Mirror x2 onto top-left coordinate system.
          var x2 = text1_length - v2[k2_offset];
          if (x1 >= x2) {
            // Overlap detected.
            return diff_bisectSplit_(text1, text2, x1, y1);
          }
        }
      }
    }

    // Walk the reverse path one step.
    for (var k2 = -d + k2start; k2 <= d - k2end; k2 += 2) {
      var k2_offset = v_offset + k2;
      var x2;
      if (k2 == -d || (k2 != d && v2[k2_offset - 1] < v2[k2_offset + 1])) {
        x2 = v2[k2_offset + 1];
      } else {
        x2 = v2[k2_offset - 1] + 1;
      }
      var y2 = x2 - k2;
      while (x2 < text1_length && y2 < text2_length &&
             text1.charAt(text1_length - x2 - 1) ==
             text2.charAt(text2_length - y2 - 1)) {
        x2++;
        y2++;
      }
      v2[k2_offset] = x2;
      if (x2 > text1_length) {
        // Ran off the left of the graph.
        k2end += 2;
      } else if (y2 > text2_length) {
        // Ran off the top of the graph.
        k2start += 2;
      } else if (!front) {
        var k1_offset = v_offset + delta - k2;
        if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] != -1) {
          var x1 = v1[k1_offset];
          var y1 = v_offset + x1 - k1_offset;
          // Mirror x2 onto top-left coordinate system.
          x2 = text1_length - x2;
          if (x1 >= x2) {
            // Overlap detected.
            return diff_bisectSplit_(text1, text2, x1, y1);
          }
        }
      }
    }
  }
  // Diff took too long and hit the deadline or
  // number of diffs equals number of characters, no commonality at all.
  return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
};


/**
 * Given the location of the 'middle snake', split the diff in two parts
 * and recurse.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} x Index of split point in text1.
 * @param {number} y Index of split point in text2.
 * @return {Array} Array of diff tuples.
 */
function diff_bisectSplit_(text1, text2, x, y) {
  var text1a = text1.substring(0, x);
  var text2a = text2.substring(0, y);
  var text1b = text1.substring(x);
  var text2b = text2.substring(y);

  // Compute both diffs serially.
  var diffs = diff_main(text1a, text2a);
  var diffsb = diff_main(text1b, text2b);

  return diffs.concat(diffsb);
};


/**
 * Determine the common prefix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the start of each
 *     string.
 */
function diff_commonPrefix(text1, text2) {
  // Quick check for common null cases.
  if (!text1 || !text2 || text1.charAt(0) != text2.charAt(0)) {
    return 0;
  }
  // Binary search.
  // Performance analysis: http://neil.fraser.name/news/2007/10/09/
  var pointermin = 0;
  var pointermax = Math.min(text1.length, text2.length);
  var pointermid = pointermax;
  var pointerstart = 0;
  while (pointermin < pointermid) {
    if (text1.substring(pointerstart, pointermid) ==
        text2.substring(pointerstart, pointermid)) {
      pointermin = pointermid;
      pointerstart = pointermin;
    } else {
      pointermax = pointermid;
    }
    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
  }
  return pointermid;
};


/**
 * Determine the common suffix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of each string.
 */
function diff_commonSuffix(text1, text2) {
  // Quick check for common null cases.
  if (!text1 || !text2 ||
      text1.charAt(text1.length - 1) != text2.charAt(text2.length - 1)) {
    return 0;
  }
  // Binary search.
  // Performance analysis: http://neil.fraser.name/news/2007/10/09/
  var pointermin = 0;
  var pointermax = Math.min(text1.length, text2.length);
  var pointermid = pointermax;
  var pointerend = 0;
  while (pointermin < pointermid) {
    if (text1.substring(text1.length - pointermid, text1.length - pointerend) ==
        text2.substring(text2.length - pointermid, text2.length - pointerend)) {
      pointermin = pointermid;
      pointerend = pointermin;
    } else {
      pointermax = pointermid;
    }
    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
  }
  return pointermid;
};


/**
 * Do the two texts share a substring which is at least half the length of the
 * longer text?
 * This speedup can produce non-minimal diffs.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {Array.<string>} Five element Array, containing the prefix of
 *     text1, the suffix of text1, the prefix of text2, the suffix of
 *     text2 and the common middle.  Or null if there was no match.
 */
function diff_halfMatch_(text1, text2) {
  var longtext = text1.length > text2.length ? text1 : text2;
  var shorttext = text1.length > text2.length ? text2 : text1;
  if (longtext.length < 4 || shorttext.length * 2 < longtext.length) {
    return null;  // Pointless.
  }

  /**
   * Does a substring of shorttext exist within longtext such that the substring
   * is at least half the length of longtext?
   * Closure, but does not reference any external variables.
   * @param {string} longtext Longer string.
   * @param {string} shorttext Shorter string.
   * @param {number} i Start index of quarter length substring within longtext.
   * @return {Array.<string>} Five element Array, containing the prefix of
   *     longtext, the suffix of longtext, the prefix of shorttext, the suffix
   *     of shorttext and the common middle.  Or null if there was no match.
   * @private
   */
  function diff_halfMatchI_(longtext, shorttext, i) {
    // Start with a 1/4 length substring at position i as a seed.
    var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));
    var j = -1;
    var best_common = '';
    var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
    while ((j = shorttext.indexOf(seed, j + 1)) != -1) {
      var prefixLength = diff_commonPrefix(longtext.substring(i),
                                           shorttext.substring(j));
      var suffixLength = diff_commonSuffix(longtext.substring(0, i),
                                           shorttext.substring(0, j));
      if (best_common.length < suffixLength + prefixLength) {
        best_common = shorttext.substring(j - suffixLength, j) +
            shorttext.substring(j, j + prefixLength);
        best_longtext_a = longtext.substring(0, i - suffixLength);
        best_longtext_b = longtext.substring(i + prefixLength);
        best_shorttext_a = shorttext.substring(0, j - suffixLength);
        best_shorttext_b = shorttext.substring(j + prefixLength);
      }
    }
    if (best_common.length * 2 >= longtext.length) {
      return [best_longtext_a, best_longtext_b,
              best_shorttext_a, best_shorttext_b, best_common];
    } else {
      return null;
    }
  }

  // First check if the second quarter is the seed for a half-match.
  var hm1 = diff_halfMatchI_(longtext, shorttext,
                             Math.ceil(longtext.length / 4));
  // Check again based on the third quarter.
  var hm2 = diff_halfMatchI_(longtext, shorttext,
                             Math.ceil(longtext.length / 2));
  var hm;
  if (!hm1 && !hm2) {
    return null;
  } else if (!hm2) {
    hm = hm1;
  } else if (!hm1) {
    hm = hm2;
  } else {
    // Both matched.  Select the longest.
    hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
  }

  // A half-match was found, sort out the return data.
  var text1_a, text1_b, text2_a, text2_b;
  if (text1.length > text2.length) {
    text1_a = hm[0];
    text1_b = hm[1];
    text2_a = hm[2];
    text2_b = hm[3];
  } else {
    text2_a = hm[0];
    text2_b = hm[1];
    text1_a = hm[2];
    text1_b = hm[3];
  }
  var mid_common = hm[4];
  return [text1_a, text1_b, text2_a, text2_b, mid_common];
};


/**
 * Reorder and merge like edit sections.  Merge equalities.
 * Any edit section can move as long as it doesn't cross an equality.
 * @param {Array} diffs Array of diff tuples.
 */
function diff_cleanupMerge(diffs) {
  diffs.push([DIFF_EQUAL, '']);  // Add a dummy entry at the end.
  var pointer = 0;
  var count_delete = 0;
  var count_insert = 0;
  var text_delete = '';
  var text_insert = '';
  var commonlength;
  while (pointer < diffs.length) {
    switch (diffs[pointer][0]) {
      case DIFF_INSERT:
        count_insert++;
        text_insert += diffs[pointer][1];
        pointer++;
        break;
      case DIFF_DELETE:
        count_delete++;
        text_delete += diffs[pointer][1];
        pointer++;
        break;
      case DIFF_EQUAL:
        // Upon reaching an equality, check for prior redundancies.
        if (count_delete + count_insert > 1) {
          if (count_delete !== 0 && count_insert !== 0) {
            // Factor out any common prefixies.
            commonlength = diff_commonPrefix(text_insert, text_delete);
            if (commonlength !== 0) {
              if ((pointer - count_delete - count_insert) > 0 &&
                  diffs[pointer - count_delete - count_insert - 1][0] ==
                  DIFF_EQUAL) {
                diffs[pointer - count_delete - count_insert - 1][1] +=
                    text_insert.substring(0, commonlength);
              } else {
                diffs.splice(0, 0, [DIFF_EQUAL,
                                    text_insert.substring(0, commonlength)]);
                pointer++;
              }
              text_insert = text_insert.substring(commonlength);
              text_delete = text_delete.substring(commonlength);
            }
            // Factor out any common suffixies.
            commonlength = diff_commonSuffix(text_insert, text_delete);
            if (commonlength !== 0) {
              diffs[pointer][1] = text_insert.substring(text_insert.length -
                  commonlength) + diffs[pointer][1];
              text_insert = text_insert.substring(0, text_insert.length -
                  commonlength);
              text_delete = text_delete.substring(0, text_delete.length -
                  commonlength);
            }
          }
          // Delete the offending records and add the merged ones.
          if (count_delete === 0) {
            diffs.splice(pointer - count_insert,
                count_delete + count_insert, [DIFF_INSERT, text_insert]);
          } else if (count_insert === 0) {
            diffs.splice(pointer - count_delete,
                count_delete + count_insert, [DIFF_DELETE, text_delete]);
          } else {
            diffs.splice(pointer - count_delete - count_insert,
                count_delete + count_insert, [DIFF_DELETE, text_delete],
                [DIFF_INSERT, text_insert]);
          }
          pointer = pointer - count_delete - count_insert +
                    (count_delete ? 1 : 0) + (count_insert ? 1 : 0) + 1;
        } else if (pointer !== 0 && diffs[pointer - 1][0] == DIFF_EQUAL) {
          // Merge this equality with the previous one.
          diffs[pointer - 1][1] += diffs[pointer][1];
          diffs.splice(pointer, 1);
        } else {
          pointer++;
        }
        count_insert = 0;
        count_delete = 0;
        text_delete = '';
        text_insert = '';
        break;
    }
  }
  if (diffs[diffs.length - 1][1] === '') {
    diffs.pop();  // Remove the dummy entry at the end.
  }

  // Second pass: look for single edits surrounded on both sides by equalities
  // which can be shifted sideways to eliminate an equality.
  // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
  var changes = false;
  pointer = 1;
  // Intentionally ignore the first and last element (don't need checking).
  while (pointer < diffs.length - 1) {
    if (diffs[pointer - 1][0] == DIFF_EQUAL &&
        diffs[pointer + 1][0] == DIFF_EQUAL) {
      // This is a single edit surrounded by equalities.
      if (diffs[pointer][1].substring(diffs[pointer][1].length -
          diffs[pointer - 1][1].length) == diffs[pointer - 1][1]) {
        // Shift the edit over the previous equality.
        diffs[pointer][1] = diffs[pointer - 1][1] +
            diffs[pointer][1].substring(0, diffs[pointer][1].length -
                                        diffs[pointer - 1][1].length);
        diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
        diffs.splice(pointer - 1, 1);
        changes = true;
      } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) ==
          diffs[pointer + 1][1]) {
        // Shift the edit over the next equality.
        diffs[pointer - 1][1] += diffs[pointer + 1][1];
        diffs[pointer][1] =
            diffs[pointer][1].substring(diffs[pointer + 1][1].length) +
            diffs[pointer + 1][1];
        diffs.splice(pointer + 1, 1);
        changes = true;
      }
    }
    pointer++;
  }
  // If shifts were made, the diff needs reordering and another shift sweep.
  if (changes) {
    diff_cleanupMerge(diffs);
  }
};


var diff = diff_main;
diff.INSERT = DIFF_INSERT;
diff.DELETE = DIFF_DELETE;
diff.EQUAL = DIFF_EQUAL;

module.exports = diff;

/*
 * Modify a diff such that the cursor position points to the start of a change:
 * E.g.
 *   cursor_normalize_diff([[DIFF_EQUAL, 'abc']], 1)
 *     => [1, [[DIFF_EQUAL, 'a'], [DIFF_EQUAL, 'bc']]]
 *   cursor_normalize_diff([[DIFF_INSERT, 'new'], [DIFF_DELETE, 'xyz']], 2)
 *     => [2, [[DIFF_INSERT, 'new'], [DIFF_DELETE, 'xy'], [DIFF_DELETE, 'z']]]
 *
 * @param {Array} diffs Array of diff tuples
 * @param {Int} cursor_pos Suggested edit position. Must not be out of bounds!
 * @return {Array} A tuple [cursor location in the modified diff, modified diff]
 */
function cursor_normalize_diff (diffs, cursor_pos) {
  if (cursor_pos === 0) {
    return [DIFF_EQUAL, diffs];
  }
  for (var current_pos = 0, i = 0; i < diffs.length; i++) {
    var d = diffs[i];
    if (d[0] === DIFF_DELETE || d[0] === DIFF_EQUAL) {
      var next_pos = current_pos + d[1].length;
      if (cursor_pos === next_pos) {
        return [i + 1, diffs];
      } else if (cursor_pos < next_pos) {
        // copy to prevent side effects
        diffs = diffs.slice();
        // split d into two diff changes
        var split_pos = cursor_pos - current_pos;
        var d_left = [d[0], d[1].slice(0, split_pos)];
        var d_right = [d[0], d[1].slice(split_pos)];
        diffs.splice(i, 1, d_left, d_right);
        return [i + 1, diffs];
      } else {
        current_pos = next_pos;
      }
    }
  }
  throw new Error('cursor_pos is out of bounds!')
}

/*
 * Modify a diff such that the edit position is "shifted" to the proposed edit location (cursor_position).
 *
 * Case 1)
 *   Check if a naive shift is possible:
 *     [0, X], [ 1, Y] -> [ 1, Y], [0, X]    (if X + Y === Y + X)
 *     [0, X], [-1, Y] -> [-1, Y], [0, X]    (if X + Y === Y + X) - holds same result
 * Case 2)
 *   Check if the following shifts are possible:
 *     [0, 'pre'], [ 1, 'prefix'] -> [ 1, 'pre'], [0, 'pre'], [ 1, 'fix']
 *     [0, 'pre'], [-1, 'prefix'] -> [-1, 'pre'], [0, 'pre'], [-1, 'fix']
 *         ^            ^
 *         d          d_next
 *
 * @param {Array} diffs Array of diff tuples
 * @param {Int} cursor_pos Suggested edit position. Must not be out of bounds!
 * @return {Array} Array of diff tuples
 */
function fix_cursor (diffs, cursor_pos) {
  var norm = cursor_normalize_diff(diffs, cursor_pos);
  var ndiffs = norm[1];
  var cursor_pointer = norm[0];
  var d = ndiffs[cursor_pointer];
  var d_next = ndiffs[cursor_pointer + 1];

  if (d == null) {
    // Text was deleted from end of original string,
    // cursor is now out of bounds in new string
    return diffs;
  } else if (d[0] !== DIFF_EQUAL) {
    // A modification happened at the cursor location.
    // This is the expected outcome, so we can return the original diff.
    return diffs;
  } else {
    if (d_next != null && d[1] + d_next[1] === d_next[1] + d[1]) {
      // Case 1)
      // It is possible to perform a naive shift
      ndiffs.splice(cursor_pointer, 2, d_next, d)
      return merge_tuples(ndiffs, cursor_pointer, 2)
    } else if (d_next != null && d_next[1].indexOf(d[1]) === 0) {
      // Case 2)
      // d[1] is a prefix of d_next[1]
      // We can assume that d_next[0] !== 0, since d[0] === 0
      // Shift edit locations..
      ndiffs.splice(cursor_pointer, 2, [d_next[0], d[1]], [0, d[1]]);
      var suffix = d_next[1].slice(d[1].length);
      if (suffix.length > 0) {
        ndiffs.splice(cursor_pointer + 2, 0, [d_next[0], suffix]);
      }
      return merge_tuples(ndiffs, cursor_pointer, 3)
    } else {
      // Not possible to perform any modification
      return diffs;
    }
  }
}

/*
 * Check diff did not split surrogate pairs.
 * Ex. [0, '\uD83D'], [-1, '\uDC36'], [1, '\uDC2F'] -> [-1, '\uD83D\uDC36'], [1, '\uD83D\uDC2F']
 *     '\uD83D\uDC36' === '🐶', '\uD83D\uDC2F' === '🐯'
 *
 * @param {Array} diffs Array of diff tuples
 * @return {Array} Array of diff tuples
 */
function fix_emoji (diffs) {
  var compact = false;
  var starts_with_pair_end = function(str) {
    return str.charCodeAt(0) >= 0xDC00 && str.charCodeAt(0) <= 0xDFFF;
  }
  var ends_with_pair_start = function(str) {
    return str.charCodeAt(str.length-1) >= 0xD800 && str.charCodeAt(str.length-1) <= 0xDBFF;
  }
  for (var i = 2; i < diffs.length; i += 1) {
    if (diffs[i-2][0] === DIFF_EQUAL && ends_with_pair_start(diffs[i-2][1]) &&
        diffs[i-1][0] === DIFF_DELETE && starts_with_pair_end(diffs[i-1][1]) &&
        diffs[i][0] === DIFF_INSERT && starts_with_pair_end(diffs[i][1])) {
      compact = true;

      diffs[i-1][1] = diffs[i-2][1].slice(-1) + diffs[i-1][1];
      diffs[i][1] = diffs[i-2][1].slice(-1) + diffs[i][1];

      diffs[i-2][1] = diffs[i-2][1].slice(0, -1);
    }
  }
  if (!compact) {
    return diffs;
  }
  var fixed_diffs = [];
  for (var i = 0; i < diffs.length; i += 1) {
    if (diffs[i][1].length > 0) {
      fixed_diffs.push(diffs[i]);
    }
  }
  return fixed_diffs;
}

/*
 * Try to merge tuples with their neigbors in a given range.
 * E.g. [0, 'a'], [0, 'b'] -> [0, 'ab']
 *
 * @param {Array} diffs Array of diff tuples.
 * @param {Int} start Position of the first element to merge (diffs[start] is also merged with diffs[start - 1]).
 * @param {Int} length Number of consecutive elements to check.
 * @return {Array} Array of merged diff tuples.
 */
function merge_tuples (diffs, start, length) {
  // Check from (start-1) to (start+length).
  for (var i = start + length - 1; i >= 0 && i >= start - 1; i--) {
    if (i + 1 < diffs.length) {
      var left_d = diffs[i];
      var right_d = diffs[i+1];
      if (left_d[0] === right_d[1]) {
        diffs.splice(i, 2, [left_d[0], left_d[1] + right_d[1]]);
      }
    }
  }
  return diffs;
}


/***/ }),
/* 52 */
/***/ (function(module, exports) {

exports = module.exports = typeof Object.keys === 'function'
  ? Object.keys : shim;

exports.shim = shim;
function shim (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
}


/***/ }),
/* 53 */
/***/ (function(module, exports) {

var supportsArgumentsClass = (function(){
  return Object.prototype.toString.call(arguments)
})() == '[object Arguments]';

exports = module.exports = supportsArgumentsClass ? supported : unsupported;

exports.supported = supported;
function supported(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
};

exports.unsupported = unsupported;
function unsupported(object){
  return object &&
    typeof object == 'object' &&
    typeof object.length == 'number' &&
    Object.prototype.hasOwnProperty.call(object, 'callee') &&
    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
    false;
};


/***/ }),
/* 54 */
/***/ (function(module, exports) {

'use strict';

var has = Object.prototype.hasOwnProperty
  , prefix = '~';

/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @api private
 */
function Events() {}

//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
  Events.prototype = Object.create(null);

  //
  // This hack is needed because the `__proto__` property is still inherited in
  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
  //
  if (!new Events().__proto__) prefix = false;
}

/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {Mixed} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @api private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @api public
 */
function EventEmitter() {
  this._events = new Events();
  this._eventsCount = 0;
}

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @api public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var names = []
    , events
    , name;

  if (this._eventsCount === 0) return names;

  for (name in (events = this._events)) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Boolean} exists Only check if there are listeners.
 * @returns {Array|Boolean}
 * @api public
 */
EventEmitter.prototype.listeners = function listeners(event, exists) {
  var evt = prefix ? prefix + event : event
    , available = this._events[evt];

  if (exists) return !!available;
  if (!available) return [];
  if (available.fn) return [available.fn];

  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
    ee[i] = available[i].fn;
  }

  return ee;
};

/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @api public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return false;

  var listeners = this._events[evt]
    , len = arguments.length
    , args
    , i;

  if (listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1: return listeners.fn.call(listeners.context), true;
      case 2: return listeners.fn.call(listeners.context, a1), true;
      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len -1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length
      , j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1: listeners[i].fn.call(listeners[i].context); break;
        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
        default:
          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Add a listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  var listener = new EE(fn, context || this)
    , evt = prefix ? prefix + event : event;

  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
  else if (!this._events[evt].fn) this._events[evt].push(listener);
  else this._events[evt] = [this._events[evt], listener];

  return this;
};

/**
 * Add a one-time listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  var listener = new EE(fn, context || this, true)
    , evt = prefix ? prefix + event : event;

  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
  else if (!this._events[evt].fn) this._events[evt].push(listener);
  else this._events[evt] = [this._events[evt], listener];

  return this;
};

/**
 * Remove the listeners of a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {Mixed} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return this;
  if (!fn) {
    if (--this._eventsCount === 0) this._events = new Events();
    else delete this._events[evt];
    return this;
  }

  var listeners = this._events[evt];

  if (listeners.fn) {
    if (
         listeners.fn === fn
      && (!once || listeners.once)
      && (!context || listeners.context === context)
    ) {
      if (--this._eventsCount === 0) this._events = new Events();
      else delete this._events[evt];
    }
  } else {
    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
      if (
           listeners[i].fn !== fn
        || (once && !listeners[i].once)
        || (context && listeners[i].context !== context)
      ) {
        events.push(listeners[i]);
      }
    }

    //
    // Reset the array, or remove it completely if we have no more listeners.
    //
    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
    else if (--this._eventsCount === 0) this._events = new Events();
    else delete this._events[evt];
  }

  return this;
};

/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {String|Symbol} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  var evt;

  if (event) {
    evt = prefix ? prefix + event : event;
    if (this._events[evt]) {
      if (--this._eventsCount === 0) this._events = new Events();
      else delete this._events[evt];
    }
  } else {
    this._events = new Events();
    this._eventsCount = 0;
  }

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// This function doesn't apply anymore.
//
EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
  return this;
};

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;

//
// Expose the module.
//
if ('undefined' !== typeof module) {
  module.exports = EventEmitter;
}


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.matchText = exports.matchSpacing = exports.matchNewline = exports.matchBlot = exports.matchAttributor = exports.default = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extend2 = __webpack_require__(3);

var _extend3 = _interopRequireDefault(_extend2);

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _quill = __webpack_require__(5);

var _quill2 = _interopRequireDefault(_quill);

var _logger = __webpack_require__(10);

var _logger2 = _interopRequireDefault(_logger);

var _module = __webpack_require__(9);

var _module2 = _interopRequireDefault(_module);

var _align = __webpack_require__(36);

var _background = __webpack_require__(37);

var _code = __webpack_require__(13);

var _code2 = _interopRequireDefault(_code);

var _color = __webpack_require__(26);

var _direction = __webpack_require__(38);

var _font = __webpack_require__(39);

var _size = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var debug = (0, _logger2.default)('quill:clipboard');

var DOM_KEY = '__ql-matcher';

var CLIPBOARD_CONFIG = [[Node.TEXT_NODE, matchText], [Node.TEXT_NODE, matchNewline], ['br', matchBreak], [Node.ELEMENT_NODE, matchNewline], [Node.ELEMENT_NODE, matchBlot], [Node.ELEMENT_NODE, matchSpacing], [Node.ELEMENT_NODE, matchAttributor], [Node.ELEMENT_NODE, matchStyles], ['li', matchIndent], ['b', matchAlias.bind(matchAlias, 'bold')], ['i', matchAlias.bind(matchAlias, 'italic')], ['style', matchIgnore]];

var ATTRIBUTE_ATTRIBUTORS = [_align.AlignAttribute, _direction.DirectionAttribute].reduce(function (memo, attr) {
  memo[attr.keyName] = attr;
  return memo;
}, {});

var STYLE_ATTRIBUTORS = [_align.AlignStyle, _background.BackgroundStyle, _color.ColorStyle, _direction.DirectionStyle, _font.FontStyle, _size.SizeStyle].reduce(function (memo, attr) {
  memo[attr.keyName] = attr;
  return memo;
}, {});

var Clipboard = function (_Module) {
  _inherits(Clipboard, _Module);

  function Clipboard(quill, options) {
    _classCallCheck(this, Clipboard);

    var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this, quill, options));

    _this.quill.root.addEventListener('paste', _this.onPaste.bind(_this));
    _this.container = _this.quill.addContainer('ql-clipboard');
    _this.container.setAttribute('contenteditable', true);
    _this.container.setAttribute('tabindex', -1);
    _this.matchers = [];
    CLIPBOARD_CONFIG.concat(_this.options.matchers).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          selector = _ref2[0],
          matcher = _ref2[1];

      if (!options.matchVisual && matcher === matchSpacing) return;
      _this.addMatcher(selector, matcher);
    });
    return _this;
  }

  _createClass(Clipboard, [{
    key: 'addMatcher',
    value: function addMatcher(selector, matcher) {
      this.matchers.push([selector, matcher]);
    }
  }, {
    key: 'convert',
    value: function convert(html) {
      if (typeof html === 'string') {
        this.container.innerHTML = html.replace(/\>\r?\n +\</g, '><'); // Remove spaces between tags
        return this.convert();
      }
      var formats = this.quill.getFormat(this.quill.selection.savedRange.index);
      if (formats[_code2.default.blotName]) {
        var text = this.container.innerText;
        this.container.innerHTML = '';
        return new _quillDelta2.default().insert(text, _defineProperty({}, _code2.default.blotName, formats[_code2.default.blotName]));
      }

      var _prepareMatching = this.prepareMatching(),
          _prepareMatching2 = _slicedToArray(_prepareMatching, 2),
          elementMatchers = _prepareMatching2[0],
          textMatchers = _prepareMatching2[1];

      var delta = traverse(this.container, elementMatchers, textMatchers);
      // Remove trailing newline
      if (deltaEndsWith(delta, '\n') && delta.ops[delta.ops.length - 1].attributes == null) {
        delta = delta.compose(new _quillDelta2.default().retain(delta.length() - 1).delete(1));
      }
      debug.log('convert', this.container.innerHTML, delta);
      this.container.innerHTML = '';
      return delta;
    }
  }, {
    key: 'dangerouslyPasteHTML',
    value: function dangerouslyPasteHTML(index, html) {
      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _quill2.default.sources.API;

      if (typeof index === 'string') {
        this.quill.setContents(this.convert(index), html);
        this.quill.setSelection(0, _quill2.default.sources.SILENT);
      } else {
        var paste = this.convert(html);
        this.quill.updateContents(new _quillDelta2.default().retain(index).concat(paste), source);
        this.quill.setSelection(index + paste.length(), _quill2.default.sources.SILENT);
      }
    }
  }, {
    key: 'onPaste',
    value: function onPaste(e) {
      var _this2 = this;

      if (e.defaultPrevented || !this.quill.isEnabled()) return;
      var range = this.quill.getSelection();
      var delta = new _quillDelta2.default().retain(range.index);
      var scrollTop = this.quill.scrollingContainer.scrollTop;
      this.container.focus();
      this.quill.selection.update(_quill2.default.sources.SILENT);
      setTimeout(function () {
        delta = delta.concat(_this2.convert()).delete(range.length);
        _this2.quill.updateContents(delta, _quill2.default.sources.USER);
        // range.length contributes to delta.length()
        _this2.quill.setSelection(delta.length() - range.length, _quill2.default.sources.SILENT);
        _this2.quill.scrollingContainer.scrollTop = scrollTop;
        _this2.quill.focus();
      }, 1);
    }
  }, {
    key: 'prepareMatching',
    value: function prepareMatching() {
      var _this3 = this;

      var elementMatchers = [],
          textMatchers = [];
      this.matchers.forEach(function (pair) {
        var _pair = _slicedToArray(pair, 2),
            selector = _pair[0],
            matcher = _pair[1];

        switch (selector) {
          case Node.TEXT_NODE:
            textMatchers.push(matcher);
            break;
          case Node.ELEMENT_NODE:
            elementMatchers.push(matcher);
            break;
          default:
            [].forEach.call(_this3.container.querySelectorAll(selector), function (node) {
              // TODO use weakmap
              node[DOM_KEY] = node[DOM_KEY] || [];
              node[DOM_KEY].push(matcher);
            });
            break;
        }
      });
      return [elementMatchers, textMatchers];
    }
  }]);

  return Clipboard;
}(_module2.default);

Clipboard.DEFAULTS = {
  matchers: [],
  matchVisual: true
};

function applyFormat(delta, format, value) {
  if ((typeof format === 'undefined' ? 'undefined' : _typeof(format)) === 'object') {
    return Object.keys(format).reduce(function (delta, key) {
      return applyFormat(delta, key, format[key]);
    }, delta);
  } else {
    return delta.reduce(function (delta, op) {
      if (op.attributes && op.attributes[format]) {
        return delta.push(op);
      } else {
        return delta.insert(op.insert, (0, _extend3.default)({}, _defineProperty({}, format, value), op.attributes));
      }
    }, new _quillDelta2.default());
  }
}

function computeStyle(node) {
  if (node.nodeType !== Node.ELEMENT_NODE) return {};
  var DOM_KEY = '__ql-computed-style';
  return node[DOM_KEY] || (node[DOM_KEY] = window.getComputedStyle(node));
}

function deltaEndsWith(delta, text) {
  var endText = "";
  for (var i = delta.ops.length - 1; i >= 0 && endText.length < text.length; --i) {
    var op = delta.ops[i];
    if (typeof op.insert !== 'string') break;
    endText = op.insert + endText;
  }
  return endText.slice(-1 * text.length) === text;
}

function isLine(node) {
  if (node.childNodes.length === 0) return false; // Exclude embed blocks
  var style = computeStyle(node);
  return ['block', 'list-item'].indexOf(style.display) > -1;
}

function traverse(node, elementMatchers, textMatchers) {
  // Post-order
  if (node.nodeType === node.TEXT_NODE) {
    return textMatchers.reduce(function (delta, matcher) {
      return matcher(node, delta);
    }, new _quillDelta2.default());
  } else if (node.nodeType === node.ELEMENT_NODE) {
    return [].reduce.call(node.childNodes || [], function (delta, childNode) {
      var childrenDelta = traverse(childNode, elementMatchers, textMatchers);
      if (childNode.nodeType === node.ELEMENT_NODE) {
        childrenDelta = elementMatchers.reduce(function (childrenDelta, matcher) {
          return matcher(childNode, childrenDelta);
        }, childrenDelta);
        childrenDelta = (childNode[DOM_KEY] || []).reduce(function (childrenDelta, matcher) {
          return matcher(childNode, childrenDelta);
        }, childrenDelta);
      }
      return delta.concat(childrenDelta);
    }, new _quillDelta2.default());
  } else {
    return new _quillDelta2.default();
  }
}

function matchAlias(format, node, delta) {
  return applyFormat(delta, format, true);
}

function matchAttributor(node, delta) {
  var attributes = _parchment2.default.Attributor.Attribute.keys(node);
  var classes = _parchment2.default.Attributor.Class.keys(node);
  var styles = _parchment2.default.Attributor.Style.keys(node);
  var formats = {};
  attributes.concat(classes).concat(styles).forEach(function (name) {
    var attr = _parchment2.default.query(name, _parchment2.default.Scope.ATTRIBUTE);
    if (attr != null) {
      formats[attr.attrName] = attr.value(node);
      if (formats[attr.attrName]) return;
    }
    attr = ATTRIBUTE_ATTRIBUTORS[name];
    if (attr != null && (attr.attrName === name || attr.keyName === name)) {
      formats[attr.attrName] = attr.value(node) || undefined;
    }
    attr = STYLE_ATTRIBUTORS[name];
    if (attr != null && (attr.attrName === name || attr.keyName === name)) {
      attr = STYLE_ATTRIBUTORS[name];
      formats[attr.attrName] = attr.value(node) || undefined;
    }
  });
  if (Object.keys(formats).length > 0) {
    delta = applyFormat(delta, formats);
  }
  return delta;
}

function matchBlot(node, delta) {
  var match = _parchment2.default.query(node);
  if (match == null) return delta;
  if (match.prototype instanceof _parchment2.default.Embed) {
    var embed = {};
    var value = match.value(node);
    if (value != null) {
      embed[match.blotName] = value;
      delta = new _quillDelta2.default().insert(embed, match.formats(node));
    }
  } else if (typeof match.formats === 'function') {
    delta = applyFormat(delta, match.blotName, match.formats(node));
  }
  return delta;
}

function matchBreak(node, delta) {
  if (!deltaEndsWith(delta, '\n')) {
    delta.insert('\n');
  }
  return delta;
}

function matchIgnore() {
  return new _quillDelta2.default();
}

function matchIndent(node, delta) {
  var match = _parchment2.default.query(node);
  if (match == null || match.blotName !== 'list-item' || !deltaEndsWith(delta, '\n')) {
    return delta;
  }
  var indent = -1,
      parent = node.parentNode;
  while (!parent.classList.contains('ql-clipboard')) {
    if ((_parchment2.default.query(parent) || {}).blotName === 'list') {
      indent += 1;
    }
    parent = parent.parentNode;
  }
  if (indent <= 0) return delta;
  return delta.compose(new _quillDelta2.default().retain(delta.length() - 1).retain(1, { indent: indent }));
}

function matchNewline(node, delta) {
  if (!deltaEndsWith(delta, '\n')) {
    if (isLine(node) || delta.length() > 0 && node.nextSibling && isLine(node.nextSibling)) {
      delta.insert('\n');
    }
  }
  return delta;
}

function matchSpacing(node, delta) {
  if (isLine(node) && node.nextElementSibling != null && !deltaEndsWith(delta, '\n\n')) {
    var nodeHeight = node.offsetHeight + parseFloat(computeStyle(node).marginTop) + parseFloat(computeStyle(node).marginBottom);
    if (node.nextElementSibling.offsetTop > node.offsetTop + nodeHeight * 1.5) {
      delta.insert('\n');
    }
  }
  return delta;
}

function matchStyles(node, delta) {
  var formats = {};
  var style = node.style || {};
  if (style.fontStyle && computeStyle(node).fontStyle === 'italic') {
    formats.italic = true;
  }
  if (style.fontWeight && (computeStyle(node).fontWeight.startsWith('bold') || parseInt(computeStyle(node).fontWeight) >= 700)) {
    formats.bold = true;
  }
  if (Object.keys(formats).length > 0) {
    delta = applyFormat(delta, formats);
  }
  if (parseFloat(style.textIndent || 0) > 0) {
    // Could be 0.5in
    delta = new _quillDelta2.default().insert('\t').concat(delta);
  }
  return delta;
}

function matchText(node, delta) {
  var text = node.data;
  // Word represents empty line with <o:p>&nbsp;</o:p>
  if (node.parentNode.tagName === 'O:P') {
    return delta.insert(text.trim());
  }
  if (text.trim().length === 0 && node.parentNode.classList.contains('ql-clipboard')) {
    return delta;
  }
  if (!computeStyle(node.parentNode).whiteSpace.startsWith('pre')) {
    // eslint-disable-next-line func-style
    var replacer = function replacer(collapse, match) {
      match = match.replace(/[^\u00a0]/g, ''); // \u00a0 is nbsp;
      return match.length < 1 && collapse ? ' ' : match;
    };
    text = text.replace(/\r\n/g, ' ').replace(/\n/g, ' ');
    text = text.replace(/\s\s+/g, replacer.bind(replacer, true)); // collapse whitespace
    if (node.previousSibling == null && isLine(node.parentNode) || node.previousSibling != null && isLine(node.previousSibling)) {
      text = text.replace(/^\s+/, replacer.bind(replacer, false));
    }
    if (node.nextSibling == null && isLine(node.parentNode) || node.nextSibling != null && isLine(node.nextSibling)) {
      text = text.replace(/\s+$/, replacer.bind(replacer, false));
    }
  }
  return delta.insert(text);
}

exports.default = Clipboard;
exports.matchAttributor = matchAttributor;
exports.matchBlot = matchBlot;
exports.matchNewline = matchNewline;
exports.matchSpacing = matchSpacing;
exports.matchText = matchText;

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Bold = function (_Inline) {
  _inherits(Bold, _Inline);

  function Bold() {
    _classCallCheck(this, Bold);

    return _possibleConstructorReturn(this, (Bold.__proto__ || Object.getPrototypeOf(Bold)).apply(this, arguments));
  }

  _createClass(Bold, [{
    key: 'optimize',
    value: function optimize(context) {
      _get(Bold.prototype.__proto__ || Object.getPrototypeOf(Bold.prototype), 'optimize', this).call(this, context);
      if (this.domNode.tagName !== this.statics.tagName[0]) {
        this.replaceWith(this.statics.blotName);
      }
    }
  }], [{
    key: 'create',
    value: function create() {
      return _get(Bold.__proto__ || Object.getPrototypeOf(Bold), 'create', this).call(this);
    }
  }, {
    key: 'formats',
    value: function formats() {
      return true;
    }
  }]);

  return Bold;
}(_inline2.default);

Bold.blotName = 'bold';
Bold.tagName = ['STRONG', 'B'];

exports.default = Bold;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addControls = exports.default = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _quillDelta = __webpack_require__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _quill = __webpack_require__(5);

var _quill2 = _interopRequireDefault(_quill);

var _logger = __webpack_require__(10);

var _logger2 = _interopRequireDefault(_logger);

var _module = __webpack_require__(9);

var _module2 = _interopRequireDefault(_module);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var debug = (0, _logger2.default)('quill:toolbar');

var Toolbar = function (_Module) {
  _inherits(Toolbar, _Module);

  function Toolbar(quill, options) {
    _classCallCheck(this, Toolbar);

    var _this = _possibleConstructorReturn(this, (Toolbar.__proto__ || Object.getPrototypeOf(Toolbar)).call(this, quill, options));

    if (Array.isArray(_this.options.container)) {
      var container = document.createElement('div');
      addControls(container, _this.options.container);
      quill.container.parentNode.insertBefore(container, quill.container);
      _this.container = container;
    } else if (typeof _this.options.container === 'string') {
      _this.container = document.querySelector(_this.options.container);
    } else {
      _this.container = _this.options.container;
    }
    if (!(_this.container instanceof HTMLElement)) {
      var _ret;

      return _ret = debug.error('Container required for toolbar', _this.options), _possibleConstructorReturn(_this, _ret);
    }
    _this.container.classList.add('ql-toolbar');
    _this.controls = [];
    _this.handlers = {};
    Object.keys(_this.options.handlers).forEach(function (format) {
      _this.addHandler(format, _this.options.handlers[format]);
    });
    [].forEach.call(_this.container.querySelectorAll('button, select'), function (input) {
      _this.attach(input);
    });
    _this.quill.on(_quill2.default.events.EDITOR_CHANGE, function (type, range) {
      if (type === _quill2.default.events.SELECTION_CHANGE) {
        _this.update(range);
      }
    });
    _this.quill.on(_quill2.default.events.SCROLL_OPTIMIZE, function () {
      var _this$quill$selection = _this.quill.selection.getRange(),
          _this$quill$selection2 = _slicedToArray(_this$quill$selection, 1),
          range = _this$quill$selection2[0]; // quill.getSelection triggers update


      _this.update(range);
    });
    return _this;
  }

  _createClass(Toolbar, [{
    key: 'addHandler',
    value: function addHandler(format, handler) {
      this.handlers[format] = handler;
    }
  }, {
    key: 'attach',
    value: function attach(input) {
      var _this2 = this;

      var format = [].find.call(input.classList, function (className) {
        return className.indexOf('ql-') === 0;
      });
      if (!format) return;
      format = format.slice('ql-'.length);
      if (input.tagName === 'BUTTON') {
        input.setAttribute('type', 'button');
      }
      if (this.handlers[format] == null) {
        if (this.quill.scroll.whitelist != null && this.quill.scroll.whitelist[format] == null) {
          debug.warn('ignoring attaching to disabled format', format, input);
          return;
        }
        if (_parchment2.default.query(format) == null) {
          debug.warn('ignoring attaching to nonexistent format', format, input);
          return;
        }
      }
      var eventName = input.tagName === 'SELECT' ? 'change' : 'click';
      input.addEventListener(eventName, function (e) {
        var value = void 0;
        if (input.tagName === 'SELECT') {
          if (input.selectedIndex < 0) return;
          var selected = input.options[input.selectedIndex];
          if (selected.hasAttribute('selected')) {
            value = false;
          } else {
            value = selected.value || false;
          }
        } else {
          if (input.classList.contains('ql-active')) {
            value = false;
          } else {
            value = input.value || !input.hasAttribute('value');
          }
          e.preventDefault();
        }
        _this2.quill.focus();

        var _quill$selection$getR = _this2.quill.selection.getRange(),
            _quill$selection$getR2 = _slicedToArray(_quill$selection$getR, 1),
            range = _quill$selection$getR2[0];

        if (_this2.handlers[format] != null) {
          _this2.handlers[format].call(_this2, value);
        } else if (_parchment2.default.query(format).prototype instanceof _parchment2.default.Embed) {
          value = prompt('Enter ' + format);
          if (!value) return;
          _this2.quill.updateContents(new _quillDelta2.default().retain(range.index).delete(range.length).insert(_defineProperty({}, format, value)), _quill2.default.sources.USER);
        } else {
          _this2.quill.format(format, value, _quill2.default.sources.USER);
        }
        _this2.update(range);
      });
      // TODO use weakmap
      this.controls.push([format, input]);
    }
  }, {
    key: 'update',
    value: function update(range) {
      var formats = range == null ? {} : this.quill.getFormat(range);
      this.controls.forEach(function (pair) {
        var _pair = _slicedToArray(pair, 2),
            format = _pair[0],
            input = _pair[1];

        if (input.tagName === 'SELECT') {
          var option = void 0;
          if (range == null) {
            option = null;
          } else if (formats[format] == null) {
            option = input.querySelector('option[selected]');
          } else if (!Array.isArray(formats[format])) {
            var value = formats[format];
            if (typeof value === 'string') {
              value = value.replace(/\"/g, '\\"');
            }
            option = input.querySelector('option[value="' + value + '"]');
          }
          if (option == null) {
            input.value = ''; // TODO make configurable?
            input.selectedIndex = -1;
          } else {
            option.selected = true;
          }
        } else {
          if (range == null) {
            input.classList.remove('ql-active');
          } else if (input.hasAttribute('value')) {
            // both being null should match (default values)
            // '1' should match with 1 (headers)
            var isActive = formats[format] === input.getAttribute('value') || formats[format] != null && formats[format].toString() === input.getAttribute('value') || formats[format] == null && !input.getAttribute('value');
            input.classList.toggle('ql-active', isActive);
          } else {
            input.classList.toggle('ql-active', formats[format] != null);
          }
        }
      });
    }
  }]);

  return Toolbar;
}(_module2.default);

Toolbar.DEFAULTS = {};

function addButton(container, format, value) {
  var input = document.createElement('button');
  input.setAttribute('type', 'button');
  input.classList.add('ql-' + format);
  if (value != null) {
    input.value = value;
  }
  container.appendChild(input);
}

function addControls(container, groups) {
  if (!Array.isArray(groups[0])) {
    groups = [groups];
  }
  groups.forEach(function (controls) {
    var group = document.createElement('span');
    group.classList.add('ql-formats');
    controls.forEach(function (control) {
      if (typeof control === 'string') {
        addButton(group, control);
      } else {
        var format = Object.keys(control)[0];
        var value = control[format];
        if (Array.isArray(value)) {
          addSelect(group, format, value);
        } else {
          addButton(group, format, value);
        }
      }
    });
    container.appendChild(group);
  });
}

function addSelect(container, format, values) {
  var input = document.createElement('select');
  input.classList.add('ql-' + format);
  values.forEach(function (value) {
    var option = document.createElement('option');
    if (value !== false) {
      option.setAttribute('value', value);
    } else {
      option.setAttribute('selected', 'selected');
    }
    input.appendChild(option);
  });
  container.appendChild(input);
}

Toolbar.DEFAULTS = {
  container: null,
  handlers: {
    clean: function clean() {
      var _this3 = this;

      var range = this.quill.getSelection();
      if (range == null) return;
      if (range.length == 0) {
        var formats = this.quill.getFormat();
        Object.keys(formats).forEach(function (name) {
          // Clean functionality in existing apps only clean inline formats
          if (_parchment2.default.query(name, _parchment2.default.Scope.INLINE) != null) {
            _this3.quill.format(name, false);
          }
        });
      } else {
        this.quill.removeFormat(range, _quill2.default.sources.USER);
      }
    },
    direction: function direction(value) {
      var align = this.quill.getFormat()['align'];
      if (value === 'rtl' && align == null) {
        this.quill.format('align', 'right', _quill2.default.sources.USER);
      } else if (!value && align === 'right') {
        this.quill.format('align', false, _quill2.default.sources.USER);
      }
      this.quill.format('direction', value, _quill2.default.sources.USER);
    },
    indent: function indent(value) {
      var range = this.quill.getSelection();
      var formats = this.quill.getFormat(range);
      var indent = parseInt(formats.indent || 0);
      if (value === '+1' || value === '-1') {
        var modifier = value === '+1' ? 1 : -1;
        if (formats.direction === 'rtl') modifier *= -1;
        this.quill.format('indent', indent + modifier, _quill2.default.sources.USER);
      }
    },
    link: function link(value) {
      if (value === true) {
        value = prompt('Enter link URL:');
      }
      this.quill.format('link', value, _quill2.default.sources.USER);
    },
    list: function list(value) {
      var range = this.quill.getSelection();
      var formats = this.quill.getFormat(range);
      if (value === 'check') {
        if (formats['list'] === 'checked' || formats['list'] === 'unchecked') {
          this.quill.format('list', false, _quill2.default.sources.USER);
        } else {
          this.quill.format('list', 'unchecked', _quill2.default.sources.USER);
        }
      } else {
        this.quill.format('list', value, _quill2.default.sources.USER);
      }
    }
  }
};

exports.default = Toolbar;
exports.addControls = addControls;

/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <polyline class=\"ql-even ql-stroke\" points=\"5 7 3 9 5 11\"></polyline> <polyline class=\"ql-even ql-stroke\" points=\"13 7 15 9 13 11\"></polyline> <line class=ql-stroke x1=10 x2=8 y1=5 y2=13></line> </svg>";

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _picker = __webpack_require__(28);

var _picker2 = _interopRequireDefault(_picker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ColorPicker = function (_Picker) {
  _inherits(ColorPicker, _Picker);

  function ColorPicker(select, label) {
    _classCallCheck(this, ColorPicker);

    var _this = _possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this, select));

    _this.label.innerHTML = label;
    _this.container.classList.add('ql-color-picker');
    [].slice.call(_this.container.querySelectorAll('.ql-picker-item'), 0, 7).forEach(function (item) {
      item.classList.add('ql-primary');
    });
    return _this;
  }

  _createClass(ColorPicker, [{
    key: 'buildItem',
    value: function buildItem(option) {
      var item = _get(ColorPicker.prototype.__proto__ || Object.getPrototypeOf(ColorPicker.prototype), 'buildItem', this).call(this, option);
      item.style.backgroundColor = option.getAttribute('value') || '';
      return item;
    }
  }, {
    key: 'selectItem',
    value: function selectItem(item, trigger) {
      _get(ColorPicker.prototype.__proto__ || Object.getPrototypeOf(ColorPicker.prototype), 'selectItem', this).call(this, item, trigger);
      var colorLabel = this.label.querySelector('.ql-color-label');
      var value = item ? item.getAttribute('data-value') || '' : '';
      if (colorLabel) {
        if (colorLabel.tagName === 'line') {
          colorLabel.style.stroke = value;
        } else {
          colorLabel.style.fill = value;
        }
      }
    }
  }]);

  return ColorPicker;
}(_picker2.default);

exports.default = ColorPicker;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _picker = __webpack_require__(28);

var _picker2 = _interopRequireDefault(_picker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IconPicker = function (_Picker) {
  _inherits(IconPicker, _Picker);

  function IconPicker(select, icons) {
    _classCallCheck(this, IconPicker);

    var _this = _possibleConstructorReturn(this, (IconPicker.__proto__ || Object.getPrototypeOf(IconPicker)).call(this, select));

    _this.container.classList.add('ql-icon-picker');
    [].forEach.call(_this.container.querySelectorAll('.ql-picker-item'), function (item) {
      item.innerHTML = icons[item.getAttribute('data-value') || ''];
    });
    _this.defaultItem = _this.container.querySelector('.ql-selected');
    _this.selectItem(_this.defaultItem);
    return _this;
  }

  _createClass(IconPicker, [{
    key: 'selectItem',
    value: function selectItem(item, trigger) {
      _get(IconPicker.prototype.__proto__ || Object.getPrototypeOf(IconPicker.prototype), 'selectItem', this).call(this, item, trigger);
      item = item || this.defaultItem;
      this.label.innerHTML = item.innerHTML;
    }
  }]);

  return IconPicker;
}(_picker2.default);

exports.default = IconPicker;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Tooltip = function () {
  function Tooltip(quill, boundsContainer) {
    var _this = this;

    _classCallCheck(this, Tooltip);

    this.quill = quill;
    this.boundsContainer = boundsContainer || document.body;
    this.root = quill.addContainer('ql-tooltip');
    this.root.innerHTML = this.constructor.TEMPLATE;
    if (this.quill.root === this.quill.scrollingContainer) {
      this.quill.root.addEventListener('scroll', function () {
        _this.root.style.marginTop = -1 * _this.quill.root.scrollTop + 'px';
      });
    }
    this.hide();
  }

  _createClass(Tooltip, [{
    key: 'hide',
    value: function hide() {
      this.root.classList.add('ql-hidden');
    }
  }, {
    key: 'position',
    value: function position(reference) {
      var left = reference.left + reference.width / 2 - this.root.offsetWidth / 2;
      // root.scrollTop should be 0 if scrollContainer !== root
      var top = reference.bottom + this.quill.root.scrollTop;
      this.root.style.left = left + 'px';
      this.root.style.top = top + 'px';
      this.root.classList.remove('ql-flip');
      var containerBounds = this.boundsContainer.getBoundingClientRect();
      var rootBounds = this.root.getBoundingClientRect();
      var shift = 0;
      if (rootBounds.right > containerBounds.right) {
        shift = containerBounds.right - rootBounds.right;
        this.root.style.left = left + shift + 'px';
      }
      if (rootBounds.left < containerBounds.left) {
        shift = containerBounds.left - rootBounds.left;
        this.root.style.left = left + shift + 'px';
      }
      if (rootBounds.bottom > containerBounds.bottom) {
        var height = rootBounds.bottom - rootBounds.top;
        var verticalShift = reference.bottom - reference.top + height;
        this.root.style.top = top - verticalShift + 'px';
        this.root.classList.add('ql-flip');
      }
      return shift;
    }
  }, {
    key: 'show',
    value: function show() {
      this.root.classList.remove('ql-editing');
      this.root.classList.remove('ql-hidden');
    }
  }]);

  return Tooltip;
}();

exports.default = Tooltip;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extend = __webpack_require__(3);

var _extend2 = _interopRequireDefault(_extend);

var _emitter = __webpack_require__(8);

var _emitter2 = _interopRequireDefault(_emitter);

var _base = __webpack_require__(43);

var _base2 = _interopRequireDefault(_base);

var _link = __webpack_require__(27);

var _link2 = _interopRequireDefault(_link);

var _selection = __webpack_require__(15);

var _icons = __webpack_require__(41);

var _icons2 = _interopRequireDefault(_icons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TOOLBAR_CONFIG = [[{ header: ['1', '2', '3', false] }], ['bold', 'italic', 'underline', 'link'], [{ list: 'ordered' }, { list: 'bullet' }], ['clean']];

var SnowTheme = function (_BaseTheme) {
  _inherits(SnowTheme, _BaseTheme);

  function SnowTheme(quill, options) {
    _classCallCheck(this, SnowTheme);

    if (options.modules.toolbar != null && options.modules.toolbar.container == null) {
      options.modules.toolbar.container = TOOLBAR_CONFIG;
    }

    var _this = _possibleConstructorReturn(this, (SnowTheme.__proto__ || Object.getPrototypeOf(SnowTheme)).call(this, quill, options));

    _this.quill.container.classList.add('ql-snow');
    return _this;
  }

  _createClass(SnowTheme, [{
    key: 'extendToolbar',
    value: function extendToolbar(toolbar) {
      toolbar.container.classList.add('ql-snow');
      this.buildButtons([].slice.call(toolbar.container.querySelectorAll('button')), _icons2.default);
      this.buildPickers([].slice.call(toolbar.container.querySelectorAll('select')), _icons2.default);
      this.tooltip = new SnowTooltip(this.quill, this.options.bounds);
      if (toolbar.container.querySelector('.ql-link')) {
        this.quill.keyboard.addBinding({ key: 'K', shortKey: true }, function (range, context) {
          toolbar.handlers['link'].call(toolbar, !context.format.link);
        });
      }
    }
  }]);

  return SnowTheme;
}(_base2.default);

SnowTheme.DEFAULTS = (0, _extend2.default)(true, {}, _base2.default.DEFAULTS, {
  modules: {
    toolbar: {
      handlers: {
        link: function link(value) {
          if (value) {
            var range = this.quill.getSelection();
            if (range == null || range.length == 0) return;
            var preview = this.quill.getText(range);
            if (/^\S+@\S+\.\S+$/.test(preview) && preview.indexOf('mailto:') !== 0) {
              preview = 'mailto:' + preview;
            }
            var tooltip = this.quill.theme.tooltip;
            tooltip.edit('link', preview);
          } else {
            this.quill.format('link', false);
          }
        }
      }
    }
  }
});

var SnowTooltip = function (_BaseTooltip) {
  _inherits(SnowTooltip, _BaseTooltip);

  function SnowTooltip(quill, bounds) {
    _classCallCheck(this, SnowTooltip);

    var _this2 = _possibleConstructorReturn(this, (SnowTooltip.__proto__ || Object.getPrototypeOf(SnowTooltip)).call(this, quill, bounds));

    _this2.preview = _this2.root.querySelector('a.ql-preview');
    return _this2;
  }

  _createClass(SnowTooltip, [{
    key: 'listen',
    value: function listen() {
      var _this3 = this;

      _get(SnowTooltip.prototype.__proto__ || Object.getPrototypeOf(SnowTooltip.prototype), 'listen', this).call(this);
      this.root.querySelector('a.ql-action').addEventListener('click', function (event) {
        if (_this3.root.classList.contains('ql-editing')) {
          _this3.save();
        } else {
          _this3.edit('link', _this3.preview.textContent);
        }
        event.preventDefault();
      });
      this.root.querySelector('a.ql-remove').addEventListener('click', function (event) {
        if (_this3.linkRange != null) {
          var range = _this3.linkRange;
          _this3.restoreFocus();
          _this3.quill.formatText(range, 'link', false, _emitter2.default.sources.USER);
          delete _this3.linkRange;
        }
        event.preventDefault();
        _this3.hide();
      });
      this.quill.on(_emitter2.default.events.SELECTION_CHANGE, function (range, oldRange, source) {
        if (range == null) return;
        if (range.length === 0 && source === _emitter2.default.sources.USER) {
          var _quill$scroll$descend = _this3.quill.scroll.descendant(_link2.default, range.index),
              _quill$scroll$descend2 = _slicedToArray(_quill$scroll$descend, 2),
              link = _quill$scroll$descend2[0],
              offset = _quill$scroll$descend2[1];

          if (link != null) {
            _this3.linkRange = new _selection.Range(range.index - offset, link.length());
            var preview = _link2.default.formats(link.domNode);
            _this3.preview.textContent = preview;
            _this3.preview.setAttribute('href', preview);
            _this3.show();
            _this3.position(_this3.quill.getBounds(_this3.linkRange));
            return;
          }
        } else {
          delete _this3.linkRange;
        }
        _this3.hide();
      });
    }
  }, {
    key: 'show',
    value: function show() {
      _get(SnowTooltip.prototype.__proto__ || Object.getPrototypeOf(SnowTooltip.prototype), 'show', this).call(this);
      this.root.removeAttribute('data-mode');
    }
  }]);

  return SnowTooltip;
}(_base.BaseTooltip);

SnowTooltip.TEMPLATE = ['<a class="ql-preview" rel="noopener noreferrer" target="_blank" href="about:blank"></a>', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-action"></a>', '<a class="ql-remove"></a>'].join('');

exports.default = SnowTheme;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _core = __webpack_require__(29);

var _core2 = _interopRequireDefault(_core);

var _align = __webpack_require__(36);

var _direction = __webpack_require__(38);

var _indent = __webpack_require__(64);

var _blockquote = __webpack_require__(65);

var _blockquote2 = _interopRequireDefault(_blockquote);

var _header = __webpack_require__(66);

var _header2 = _interopRequireDefault(_header);

var _list = __webpack_require__(67);

var _list2 = _interopRequireDefault(_list);

var _background = __webpack_require__(37);

var _color = __webpack_require__(26);

var _font = __webpack_require__(39);

var _size = __webpack_require__(40);

var _bold = __webpack_require__(56);

var _bold2 = _interopRequireDefault(_bold);

var _italic = __webpack_require__(68);

var _italic2 = _interopRequireDefault(_italic);

var _link = __webpack_require__(27);

var _link2 = _interopRequireDefault(_link);

var _script = __webpack_require__(69);

var _script2 = _interopRequireDefault(_script);

var _strike = __webpack_require__(70);

var _strike2 = _interopRequireDefault(_strike);

var _underline = __webpack_require__(71);

var _underline2 = _interopRequireDefault(_underline);

var _image = __webpack_require__(72);

var _image2 = _interopRequireDefault(_image);

var _video = __webpack_require__(73);

var _video2 = _interopRequireDefault(_video);

var _code = __webpack_require__(13);

var _code2 = _interopRequireDefault(_code);

var _formula = __webpack_require__(74);

var _formula2 = _interopRequireDefault(_formula);

var _syntax = __webpack_require__(75);

var _syntax2 = _interopRequireDefault(_syntax);

var _toolbar = __webpack_require__(57);

var _toolbar2 = _interopRequireDefault(_toolbar);

var _icons = __webpack_require__(41);

var _icons2 = _interopRequireDefault(_icons);

var _picker = __webpack_require__(28);

var _picker2 = _interopRequireDefault(_picker);

var _colorPicker = __webpack_require__(59);

var _colorPicker2 = _interopRequireDefault(_colorPicker);

var _iconPicker = __webpack_require__(60);

var _iconPicker2 = _interopRequireDefault(_iconPicker);

var _tooltip = __webpack_require__(61);

var _tooltip2 = _interopRequireDefault(_tooltip);

var _bubble = __webpack_require__(108);

var _bubble2 = _interopRequireDefault(_bubble);

var _snow = __webpack_require__(62);

var _snow2 = _interopRequireDefault(_snow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_core2.default.register({
  'attributors/attribute/direction': _direction.DirectionAttribute,

  'attributors/class/align': _align.AlignClass,
  'attributors/class/background': _background.BackgroundClass,
  'attributors/class/color': _color.ColorClass,
  'attributors/class/direction': _direction.DirectionClass,
  'attributors/class/font': _font.FontClass,
  'attributors/class/size': _size.SizeClass,

  'attributors/style/align': _align.AlignStyle,
  'attributors/style/background': _background.BackgroundStyle,
  'attributors/style/color': _color.ColorStyle,
  'attributors/style/direction': _direction.DirectionStyle,
  'attributors/style/font': _font.FontStyle,
  'attributors/style/size': _size.SizeStyle
}, true);

_core2.default.register({
  'formats/align': _align.AlignClass,
  'formats/direction': _direction.DirectionClass,
  'formats/indent': _indent.IndentClass,

  'formats/background': _background.BackgroundStyle,
  'formats/color': _color.ColorStyle,
  'formats/font': _font.FontClass,
  'formats/size': _size.SizeClass,

  'formats/blockquote': _blockquote2.default,
  'formats/code-block': _code2.default,
  'formats/header': _header2.default,
  'formats/list': _list2.default,

  'formats/bold': _bold2.default,
  'formats/code': _code.Code,
  'formats/italic': _italic2.default,
  'formats/link': _link2.default,
  'formats/script': _script2.default,
  'formats/strike': _strike2.default,
  'formats/underline': _underline2.default,

  'formats/image': _image2.default,
  'formats/video': _video2.default,

  'formats/list/item': _list.ListItem,

  'modules/formula': _formula2.default,
  'modules/syntax': _syntax2.default,
  'modules/toolbar': _toolbar2.default,

  'themes/bubble': _bubble2.default,
  'themes/snow': _snow2.default,

  'ui/icons': _icons2.default,
  'ui/picker': _picker2.default,
  'ui/icon-picker': _iconPicker2.default,
  'ui/color-picker': _colorPicker2.default,
  'ui/tooltip': _tooltip2.default
}, true);

exports.default = _core2.default;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IndentClass = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IdentAttributor = function (_Parchment$Attributor) {
  _inherits(IdentAttributor, _Parchment$Attributor);

  function IdentAttributor() {
    _classCallCheck(this, IdentAttributor);

    return _possibleConstructorReturn(this, (IdentAttributor.__proto__ || Object.getPrototypeOf(IdentAttributor)).apply(this, arguments));
  }

  _createClass(IdentAttributor, [{
    key: 'add',
    value: function add(node, value) {
      if (value === '+1' || value === '-1') {
        var indent = this.value(node) || 0;
        value = value === '+1' ? indent + 1 : indent - 1;
      }
      if (value === 0) {
        this.remove(node);
        return true;
      } else {
        return _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'add', this).call(this, node, value);
      }
    }
  }, {
    key: 'canAdd',
    value: function canAdd(node, value) {
      return _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'canAdd', this).call(this, node, value) || _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'canAdd', this).call(this, node, parseInt(value));
    }
  }, {
    key: 'value',
    value: function value(node) {
      return parseInt(_get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'value', this).call(this, node)) || undefined; // Don't return NaN
    }
  }]);

  return IdentAttributor;
}(_parchment2.default.Attributor.Class);

var IndentClass = new IdentAttributor('indent', 'ql-indent', {
  scope: _parchment2.default.Scope.BLOCK,
  whitelist: [1, 2, 3, 4, 5, 6, 7, 8]
});

exports.IndentClass = IndentClass;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Blockquote = function (_Block) {
  _inherits(Blockquote, _Block);

  function Blockquote() {
    _classCallCheck(this, Blockquote);

    return _possibleConstructorReturn(this, (Blockquote.__proto__ || Object.getPrototypeOf(Blockquote)).apply(this, arguments));
  }

  return Blockquote;
}(_block2.default);

Blockquote.blotName = 'blockquote';
Blockquote.tagName = 'blockquote';

exports.default = Blockquote;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Header = function (_Block) {
  _inherits(Header, _Block);

  function Header() {
    _classCallCheck(this, Header);

    return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
  }

  _createClass(Header, null, [{
    key: 'formats',
    value: function formats(domNode) {
      return this.tagName.indexOf(domNode.tagName) + 1;
    }
  }]);

  return Header;
}(_block2.default);

Header.blotName = 'header';
Header.tagName = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'];

exports.default = Header;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ListItem = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _block = __webpack_require__(4);

var _block2 = _interopRequireDefault(_block);

var _container = __webpack_require__(25);

var _container2 = _interopRequireDefault(_container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListItem = function (_Block) {
  _inherits(ListItem, _Block);

  function ListItem() {
    _classCallCheck(this, ListItem);

    return _possibleConstructorReturn(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).apply(this, arguments));
  }

  _createClass(ListItem, [{
    key: 'format',
    value: function format(name, value) {
      if (name === List.blotName && !value) {
        this.replaceWith(_parchment2.default.create(this.statics.scope));
      } else {
        _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'format', this).call(this, name, value);
      }
    }
  }, {
    key: 'remove',
    value: function remove() {
      if (this.prev == null && this.next == null) {
        this.parent.remove();
      } else {
        _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'remove', this).call(this);
      }
    }
  }, {
    key: 'replaceWith',
    value: function replaceWith(name, value) {
      this.parent.isolate(this.offset(this.parent), this.length());
      if (name === this.parent.statics.blotName) {
        this.parent.replaceWith(name, value);
        return this;
      } else {
        this.parent.unwrap();
        return _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'replaceWith', this).call(this, name, value);
      }
    }
  }], [{
    key: 'formats',
    value: function formats(domNode) {
      return domNode.tagName === this.tagName ? undefined : _get(ListItem.__proto__ || Object.getPrototypeOf(ListItem), 'formats', this).call(this, domNode);
    }
  }]);

  return ListItem;
}(_block2.default);

ListItem.blotName = 'list-item';
ListItem.tagName = 'LI';

var List = function (_Container) {
  _inherits(List, _Container);

  _createClass(List, null, [{
    key: 'create',
    value: function create(value) {
      var tagName = value === 'ordered' ? 'OL' : 'UL';
      var node = _get(List.__proto__ || Object.getPrototypeOf(List), 'create', this).call(this, tagName);
      if (value === 'checked' || value === 'unchecked') {
        node.setAttribute('data-checked', value === 'checked');
      }
      return node;
    }
  }, {
    key: 'formats',
    value: function formats(domNode) {
      if (domNode.tagName === 'OL') return 'ordered';
      if (domNode.tagName === 'UL') {
        if (domNode.hasAttribute('data-checked')) {
          return domNode.getAttribute('data-checked') === 'true' ? 'checked' : 'unchecked';
        } else {
          return 'bullet';
        }
      }
      return undefined;
    }
  }]);

  function List(domNode) {
    _classCallCheck(this, List);

    var _this2 = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, domNode));

    var listEventHandler = function listEventHandler(e) {
      if (e.target.parentNode !== domNode) return;
      var format = _this2.statics.formats(domNode);
      var blot = _parchment2.default.find(e.target);
      if (format === 'checked') {
        blot.format('list', 'unchecked');
      } else if (format === 'unchecked') {
        blot.format('list', 'checked');
      }
    };

    domNode.addEventListener('touchstart', listEventHandler);
    domNode.addEventListener('mousedown', listEventHandler);
    return _this2;
  }

  _createClass(List, [{
    key: 'format',
    value: function format(name, value) {
      if (this.children.length > 0) {
        this.children.tail.format(name, value);
      }
    }
  }, {
    key: 'formats',
    value: function formats() {
      // We don't inherit from FormatBlot
      return _defineProperty({}, this.statics.blotName, this.statics.formats(this.domNode));
    }
  }, {
    key: 'insertBefore',
    value: function insertBefore(blot, ref) {
      if (blot instanceof ListItem) {
        _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'insertBefore', this).call(this, blot, ref);
      } else {
        var index = ref == null ? this.length() : ref.offset(this);
        var after = this.split(index);
        after.parent.insertBefore(blot, after);
      }
    }
  }, {
    key: 'optimize',
    value: function optimize(context) {
      _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'optimize', this).call(this, context);
      var next = this.next;
      if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && next.domNode.tagName === this.domNode.tagName && next.domNode.getAttribute('data-checked') === this.domNode.getAttribute('data-checked')) {
        next.moveChildren(this);
        next.remove();
      }
    }
  }, {
    key: 'replace',
    value: function replace(target) {
      if (target.statics.blotName !== this.statics.blotName) {
        var item = _parchment2.default.create(this.statics.defaultChild);
        target.moveChildren(item);
        this.appendChild(item);
      }
      _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'replace', this).call(this, target);
    }
  }]);

  return List;
}(_container2.default);

List.blotName = 'list';
List.scope = _parchment2.default.Scope.BLOCK_BLOT;
List.tagName = ['OL', 'UL'];
List.defaultChild = 'list-item';
List.allowedChildren = [ListItem];

exports.ListItem = ListItem;
exports.default = List;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bold = __webpack_require__(56);

var _bold2 = _interopRequireDefault(_bold);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Italic = function (_Bold) {
  _inherits(Italic, _Bold);

  function Italic() {
    _classCallCheck(this, Italic);

    return _possibleConstructorReturn(this, (Italic.__proto__ || Object.getPrototypeOf(Italic)).apply(this, arguments));
  }

  return Italic;
}(_bold2.default);

Italic.blotName = 'italic';
Italic.tagName = ['EM', 'I'];

exports.default = Italic;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Script = function (_Inline) {
  _inherits(Script, _Inline);

  function Script() {
    _classCallCheck(this, Script);

    return _possibleConstructorReturn(this, (Script.__proto__ || Object.getPrototypeOf(Script)).apply(this, arguments));
  }

  _createClass(Script, null, [{
    key: 'create',
    value: function create(value) {
      if (value === 'super') {
        return document.createElement('sup');
      } else if (value === 'sub') {
        return document.createElement('sub');
      } else {
        return _get(Script.__proto__ || Object.getPrototypeOf(Script), 'create', this).call(this, value);
      }
    }
  }, {
    key: 'formats',
    value: function formats(domNode) {
      if (domNode.tagName === 'SUB') return 'sub';
      if (domNode.tagName === 'SUP') return 'super';
      return undefined;
    }
  }]);

  return Script;
}(_inline2.default);

Script.blotName = 'script';
Script.tagName = ['SUB', 'SUP'];

exports.default = Script;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Strike = function (_Inline) {
  _inherits(Strike, _Inline);

  function Strike() {
    _classCallCheck(this, Strike);

    return _possibleConstructorReturn(this, (Strike.__proto__ || Object.getPrototypeOf(Strike)).apply(this, arguments));
  }

  return Strike;
}(_inline2.default);

Strike.blotName = 'strike';
Strike.tagName = 'S';

exports.default = Strike;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inline = __webpack_require__(6);

var _inline2 = _interopRequireDefault(_inline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Underline = function (_Inline) {
  _inherits(Underline, _Inline);

  function Underline() {
    _classCallCheck(this, Underline);

    return _possibleConstructorReturn(this, (Underline.__proto__ || Object.getPrototypeOf(Underline)).apply(this, arguments));
  }

  return Underline;
}(_inline2.default);

Underline.blotName = 'underline';
Underline.tagName = 'U';

exports.default = Underline;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _link = __webpack_require__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ATTRIBUTES = ['alt', 'height', 'width'];

var Image = function (_Parchment$Embed) {
  _inherits(Image, _Parchment$Embed);

  function Image() {
    _classCallCheck(this, Image);

    return _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).apply(this, arguments));
  }

  _createClass(Image, [{
    key: 'format',
    value: function format(name, value) {
      if (ATTRIBUTES.indexOf(name) > -1) {
        if (value) {
          this.domNode.setAttribute(name, value);
        } else {
          this.domNode.removeAttribute(name);
        }
      } else {
        _get(Image.prototype.__proto__ || Object.getPrototypeOf(Image.prototype), 'format', this).call(this, name, value);
      }
    }
  }], [{
    key: 'create',
    value: function create(value) {
      var node = _get(Image.__proto__ || Object.getPrototypeOf(Image), 'create', this).call(this, value);
      if (typeof value === 'string') {
        node.setAttribute('src', this.sanitize(value));
      }
      return node;
    }
  }, {
    key: 'formats',
    value: function formats(domNode) {
      return ATTRIBUTES.reduce(function (formats, attribute) {
        if (domNode.hasAttribute(attribute)) {
          formats[attribute] = domNode.getAttribute(attribute);
        }
        return formats;
      }, {});
    }
  }, {
    key: 'match',
    value: function match(url) {
      return (/\.(jpe?g|gif|png)$/.test(url) || /^data:image\/.+;base64/.test(url)
      );
    }
  }, {
    key: 'sanitize',
    value: function sanitize(url) {
      return (0, _link.sanitize)(url, ['http', 'https', 'data']) ? url : '//:0';
    }
  }, {
    key: 'value',
    value: function value(domNode) {
      return domNode.getAttribute('src');
    }
  }]);

  return Image;
}(_parchment2.default.Embed);

Image.blotName = 'image';
Image.tagName = 'IMG';

exports.default = Image;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _block = __webpack_require__(4);

var _link = __webpack_require__(27);

var _link2 = _interopRequireDefault(_link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ATTRIBUTES = ['height', 'width'];

var Video = function (_BlockEmbed) {
  _inherits(Video, _BlockEmbed);

  function Video() {
    _classCallCheck(this, Video);

    return _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).apply(this, arguments));
  }

  _createClass(Video, [{
    key: 'format',
    value: function format(name, value) {
      if (ATTRIBUTES.indexOf(name) > -1) {
        if (value) {
          this.domNode.setAttribute(name, value);
        } else {
          this.domNode.removeAttribute(name);
        }
      } else {
        _get(Video.prototype.__proto__ || Object.getPrototypeOf(Video.prototype), 'format', this).call(this, name, value);
      }
    }
  }], [{
    key: 'create',
    value: function create(value) {
      var node = _get(Video.__proto__ || Object.getPrototypeOf(Video), 'create', this).call(this, value);
      node.setAttribute('frameborder', '0');
      node.setAttribute('allowfullscreen', true);
      node.setAttribute('src', this.sanitize(value));
      return node;
    }
  }, {
    key: 'formats',
    value: function formats(domNode) {
      return ATTRIBUTES.reduce(function (formats, attribute) {
        if (domNode.hasAttribute(attribute)) {
          formats[attribute] = domNode.getAttribute(attribute);
        }
        return formats;
      }, {});
    }
  }, {
    key: 'sanitize',
    value: function sanitize(url) {
      return _link2.default.sanitize(url);
    }
  }, {
    key: 'value',
    value: function value(domNode) {
      return domNode.getAttribute('src');
    }
  }]);

  return Video;
}(_block.BlockEmbed);

Video.blotName = 'video';
Video.className = 'ql-video';
Video.tagName = 'IFRAME';

exports.default = Video;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FormulaBlot = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _embed = __webpack_require__(35);

var _embed2 = _interopRequireDefault(_embed);

var _quill = __webpack_require__(5);

var _quill2 = _interopRequireDefault(_quill);

var _module = __webpack_require__(9);

var _module2 = _interopRequireDefault(_module);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FormulaBlot = function (_Embed) {
  _inherits(FormulaBlot, _Embed);

  function FormulaBlot() {
    _classCallCheck(this, FormulaBlot);

    return _possibleConstructorReturn(this, (FormulaBlot.__proto__ || Object.getPrototypeOf(FormulaBlot)).apply(this, arguments));
  }

  _createClass(FormulaBlot, null, [{
    key: 'create',
    value: function create(value) {
      var node = _get(FormulaBlot.__proto__ || Object.getPrototypeOf(FormulaBlot), 'create', this).call(this, value);
      if (typeof value === 'string') {
        window.katex.render(value, node, {
          throwOnError: false,
          errorColor: '#f00'
        });
        node.setAttribute('data-value', value);
      }
      return node;
    }
  }, {
    key: 'value',
    value: function value(domNode) {
      return domNode.getAttribute('data-value');
    }
  }]);

  return FormulaBlot;
}(_embed2.default);

FormulaBlot.blotName = 'formula';
FormulaBlot.className = 'ql-formula';
FormulaBlot.tagName = 'SPAN';

var Formula = function (_Module) {
  _inherits(Formula, _Module);

  _createClass(Formula, null, [{
    key: 'register',
    value: function register() {
      _quill2.default.register(FormulaBlot, true);
    }
  }]);

  function Formula() {
    _classCallCheck(this, Formula);

    var _this2 = _possibleConstructorReturn(this, (Formula.__proto__ || Object.getPrototypeOf(Formula)).call(this));

    if (window.katex == null) {
      throw new Error('Formula module requires KaTeX.');
    }
    return _this2;
  }

  return Formula;
}(_module2.default);

exports.FormulaBlot = FormulaBlot;
exports.default = Formula;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CodeToken = exports.CodeBlock = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __webpack_require__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _quill = __webpack_require__(5);

var _quill2 = _interopRequireDefault(_quill);

var _module = __webpack_require__(9);

var _module2 = _interopRequireDefault(_module);

var _code = __webpack_require__(13);

var _code2 = _interopRequireDefault(_code);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SyntaxCodeBlock = function (_CodeBlock) {
  _inherits(SyntaxCodeBlock, _CodeBlock);

  function SyntaxCodeBlock() {
    _classCallCheck(this, SyntaxCodeBlock);

    return _possibleConstructorReturn(this, (SyntaxCodeBlock.__proto__ || Object.getPrototypeOf(SyntaxCodeBlock)).apply(this, arguments));
  }

  _createClass(SyntaxCodeBlock, [{
    key: 'replaceWith',
    value: function replaceWith(block) {
      this.domNode.textContent = this.domNode.textContent;
      this.attach();
      _get(SyntaxCodeBlock.prototype.__proto__ || Object.getPrototypeOf(SyntaxCodeBlock.prototype), 'replaceWith', this).call(this, block);
    }
  }, {
    key: 'highlight',
    value: function highlight(_highlight) {
      var text = this.domNode.textContent;
      if (this.cachedText !== text) {
        if (text.trim().length > 0 || this.cachedText == null) {
          this.domNode.innerHTML = _highlight(text);
          this.domNode.normalize();
          this.attach();
        }
        this.cachedText = text;
      }
    }
  }]);

  return SyntaxCodeBlock;
}(_code2.default);

SyntaxCodeBlock.className = 'ql-syntax';

var CodeToken = new _parchment2.default.Attributor.Class('token', 'hljs', {
  scope: _parchment2.default.Scope.INLINE
});

var Syntax = function (_Module) {
  _inherits(Syntax, _Module);

  _createClass(Syntax, null, [{
    key: 'register',
    value: function register() {
      _quill2.default.register(CodeToken, true);
      _quill2.default.register(SyntaxCodeBlock, true);
    }
  }]);

  function Syntax(quill, options) {
    _classCallCheck(this, Syntax);

    var _this2 = _possibleConstructorReturn(this, (Syntax.__proto__ || Object.getPrototypeOf(Syntax)).call(this, quill, options));

    if (typeof _this2.options.highlight !== 'function') {
      throw new Error('Syntax module requires highlight.js. Please include the library on the page before Quill.');
    }
    var timer = null;
    _this2.quill.on(_quill2.default.events.SCROLL_OPTIMIZE, function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        _this2.highlight();
        timer = null;
      }, _this2.options.interval);
    });
    _this2.highlight();
    return _this2;
  }

  _createClass(Syntax, [{
    key: 'highlight',
    value: function highlight() {
      var _this3 = this;

      if (this.quill.selection.composing) return;
      this.quill.update(_quill2.default.sources.USER);
      var range = this.quill.getSelection();
      this.quill.scroll.descendants(SyntaxCodeBlock).forEach(function (code) {
        code.highlight(_this3.options.highlight);
      });
      this.quill.update(_quill2.default.sources.SILENT);
      if (range != null) {
        this.quill.setSelection(range, _quill2.default.sources.SILENT);
      }
    }
  }]);

  return Syntax;
}(_module2.default);

Syntax.DEFAULTS = {
  highlight: function () {
    if (window.hljs == null) return null;
    return function (text) {
      var result = window.hljs.highlightAuto(text);
      return result.value;
    };
  }(),
  interval: 1000
};

exports.CodeBlock = SyntaxCodeBlock;
exports.CodeToken = CodeToken;
exports.default = Syntax;

/***/ }),
/* 76 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=13 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=9 y1=4 y2=4></line> </svg>";

/***/ }),
/* 77 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=14 x2=4 y1=14 y2=14></line> <line class=ql-stroke x1=12 x2=6 y1=4 y2=4></line> </svg>";

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=5 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=9 y1=4 y2=4></line> </svg>";

/***/ }),
/* 79 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=3 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=3 y1=4 y2=4></line> </svg>";

/***/ }),
/* 80 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <g class=\"ql-fill ql-color-label\"> <polygon points=\"6 6.868 6 6 5 6 5 7 5.942 7 6 6.868\"></polygon> <rect height=1 width=1 x=4 y=4></rect> <polygon points=\"6.817 5 6 5 6 6 6.38 6 6.817 5\"></polygon> <rect height=1 width=1 x=2 y=6></rect> <rect height=1 width=1 x=3 y=5></rect> <rect height=1 width=1 x=4 y=7></rect> <polygon points=\"4 11.439 4 11 3 11 3 12 3.755 12 4 11.439\"></polygon> <rect height=1 width=1 x=2 y=12></rect> <rect height=1 width=1 x=2 y=9></rect> <rect height=1 width=1 x=2 y=15></rect> <polygon points=\"4.63 10 4 10 4 11 4.192 11 4.63 10\"></polygon> <rect height=1 width=1 x=3 y=8></rect> <path d=M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z></path> <path d=M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z></path> <path d=M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z></path> <rect height=1 width=1 x=12 y=2></rect> <rect height=1 width=1 x=11 y=3></rect> <path d=M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z></path> <rect height=1 width=1 x=2 y=3></rect> <rect height=1 width=1 x=6 y=2></rect> <rect height=1 width=1 x=3 y=2></rect> <rect height=1 width=1 x=5 y=3></rect> <rect height=1 width=1 x=9 y=2></rect> <rect height=1 width=1 x=15 y=14></rect> <polygon points=\"13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174\"></polygon> <rect height=1 width=1 x=13 y=7></rect> <rect height=1 width=1 x=15 y=5></rect> <rect height=1 width=1 x=14 y=6></rect> <rect height=1 width=1 x=15 y=8></rect> <rect height=1 width=1 x=14 y=9></rect> <path d=M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z></path> <rect height=1 width=1 x=14 y=3></rect> <polygon points=\"12 6.868 12 6 11.62 6 12 6.868\"></polygon> <rect height=1 width=1 x=15 y=2></rect> <rect height=1 width=1 x=12 y=5></rect> <rect height=1 width=1 x=13 y=4></rect> <polygon points=\"12.933 9 13 9 13 8 12.495 8 12.933 9\"></polygon> <rect height=1 width=1 x=9 y=14></rect> <rect height=1 width=1 x=8 y=15></rect> <path d=M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z></path> <rect height=1 width=1 x=5 y=15></rect> <path d=M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z></path> <rect height=1 width=1 x=11 y=15></rect> <path d=M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z></path> <rect height=1 width=1 x=14 y=15></rect> <rect height=1 width=1 x=15 y=11></rect> </g> <polyline class=ql-stroke points=\"5.5 13 9 5 12.5 13\"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=11 y2=11></line> </svg>";

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=\"ql-fill ql-stroke\" height=3 width=3 x=4 y=5></rect> <rect class=\"ql-fill ql-stroke\" height=3 width=3 x=11 y=5></rect> <path class=\"ql-even ql-fill ql-stroke\" d=M7,8c0,4.031-3,5-3,5></path> <path class=\"ql-even ql-fill ql-stroke\" d=M14,8c0,4.031-3,5-3,5></path> </svg>";

/***/ }),
/* 82 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-stroke d=M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z></path> <path class=ql-stroke d=M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z></path> </svg>";

/***/ }),
/* 83 */
/***/ (function(module, exports) {

module.exports = "<svg class=\"\" viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=5 x2=13 y1=3 y2=3></line> <line class=ql-stroke x1=6 x2=9.35 y1=12 y2=3></line> <line class=ql-stroke x1=11 x2=15 y1=11 y2=15></line> <line class=ql-stroke x1=15 x2=11 y1=11 y2=15></line> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=7 x=2 y=14></rect> </svg>";

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=\"ql-color-label ql-stroke ql-transparent\" x1=3 x2=15 y1=15 y2=15></line> <polyline class=ql-stroke points=\"5.5 11 9 3 12.5 11\"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=9 y2=9></line> </svg>";

/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=\"ql-stroke ql-fill\" points=\"3 11 5 9 3 7 3 11\"></polygon> <line class=\"ql-stroke ql-fill\" x1=15 x2=11 y1=4 y2=4></line> <path class=ql-fill d=M11,3a3,3,0,0,0,0,6h1V3H11Z></path> <rect class=ql-fill height=11 width=1 x=11 y=4></rect> <rect class=ql-fill height=11 width=1 x=13 y=4></rect> </svg>";

/***/ }),
/* 86 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=\"ql-stroke ql-fill\" points=\"15 12 13 10 15 8 15 12\"></polygon> <line class=\"ql-stroke ql-fill\" x1=9 x2=5 y1=4 y2=4></line> <path class=ql-fill d=M5,3A3,3,0,0,0,5,9H6V3H5Z></path> <rect class=ql-fill height=11 width=1 x=5 y=4></rect> <rect class=ql-fill height=11 width=1 x=7 y=4></rect> </svg>";

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M14,16H4a1,1,0,0,1,0-2H14A1,1,0,0,1,14,16Z /> <path class=ql-fill d=M14,4H4A1,1,0,0,1,4,2H14A1,1,0,0,1,14,4Z /> <rect class=ql-fill x=3 y=6 width=12 height=6 rx=1 ry=1 /> </svg>";

/***/ }),
/* 88 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M13,16H5a1,1,0,0,1,0-2h8A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H5A1,1,0,0,1,5,2h8A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=2 y=6 width=14 height=6 rx=1 ry=1 /> </svg>";

/***/ }),
/* 89 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15,8H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,8Z /> <path class=ql-fill d=M15,12H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,12Z /> <path class=ql-fill d=M15,16H5a1,1,0,0,1,0-2H15A1,1,0,0,1,15,16Z /> <path class=ql-fill d=M15,4H5A1,1,0,0,1,5,2H15A1,1,0,0,1,15,4Z /> <rect class=ql-fill x=2 y=6 width=8 height=6 rx=1 ry=1 /> </svg>";

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M5,8H3A1,1,0,0,1,3,6H5A1,1,0,0,1,5,8Z /> <path class=ql-fill d=M5,12H3a1,1,0,0,1,0-2H5A1,1,0,0,1,5,12Z /> <path class=ql-fill d=M13,16H3a1,1,0,0,1,0-2H13A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H3A1,1,0,0,1,3,2H13A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=8 y=6 width=8 height=6 rx=1 ry=1 transform=\"translate(24 18) rotate(-180)\"/> </svg>";

/***/ }),
/* 91 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M11.759,2.482a2.561,2.561,0,0,0-3.53.607A7.656,7.656,0,0,0,6.8,6.2C6.109,9.188,5.275,14.677,4.15,14.927a1.545,1.545,0,0,0-1.3-.933A0.922,0.922,0,0,0,2,15.036S1.954,16,4.119,16s3.091-2.691,3.7-5.553c0.177-.826.36-1.726,0.554-2.6L8.775,6.2c0.381-1.421.807-2.521,1.306-2.676a1.014,1.014,0,0,0,1.02.56A0.966,0.966,0,0,0,11.759,2.482Z></path> <rect class=ql-fill height=1.6 rx=0.8 ry=0.8 width=5 x=5.15 y=6.2></rect> <path class=ql-fill d=M13.663,12.027a1.662,1.662,0,0,1,.266-0.276q0.193,0.069.456,0.138a2.1,2.1,0,0,0,.535.069,1.075,1.075,0,0,0,.767-0.3,1.044,1.044,0,0,0,.314-0.8,0.84,0.84,0,0,0-.238-0.619,0.8,0.8,0,0,0-.594-0.239,1.154,1.154,0,0,0-.781.3,4.607,4.607,0,0,0-.781,1q-0.091.15-.218,0.346l-0.246.38c-0.068-.288-0.137-0.582-0.212-0.885-0.459-1.847-2.494-.984-2.941-0.8-0.482.2-.353,0.647-0.094,0.529a0.869,0.869,0,0,1,1.281.585c0.217,0.751.377,1.436,0.527,2.038a5.688,5.688,0,0,1-.362.467,2.69,2.69,0,0,1-.264.271q-0.221-.08-0.471-0.147a2.029,2.029,0,0,0-.522-0.066,1.079,1.079,0,0,0-.768.3A1.058,1.058,0,0,0,9,15.131a0.82,0.82,0,0,0,.832.852,1.134,1.134,0,0,0,.787-0.3,5.11,5.11,0,0,0,.776-0.993q0.141-.219.215-0.34c0.046-.076.122-0.194,0.223-0.346a2.786,2.786,0,0,0,.918,1.726,2.582,2.582,0,0,0,2.376-.185c0.317-.181.212-0.565,0-0.494A0.807,0.807,0,0,1,14.176,15a5.159,5.159,0,0,1-.913-2.446l0,0Q13.487,12.24,13.663,12.027Z></path> </svg>";

/***/ }),
/* 92 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 18 18\"> <path class=ql-fill d=M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm6.06787,9.209H14.98975V7.59863a.54085.54085,0,0,0-.605-.60547h-.62744a1.01119,1.01119,0,0,0-.748.29688L11.645,8.56641a.5435.5435,0,0,0-.022.8584l.28613.30762a.53861.53861,0,0,0,.84717.0332l.09912-.08789a1.2137,1.2137,0,0,0,.2417-.35254h.02246s-.01123.30859-.01123.60547V13.209H12.041a.54085.54085,0,0,0-.605.60547v.43945a.54085.54085,0,0,0,.605.60547h4.02686a.54085.54085,0,0,0,.605-.60547v-.43945A.54085.54085,0,0,0,16.06787,13.209Z /> </svg>";

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 18 18\"> <path class=ql-fill d=M16.73975,13.81445v.43945a.54085.54085,0,0,1-.605.60547H11.855a.58392.58392,0,0,1-.64893-.60547V14.0127c0-2.90527,3.39941-3.42187,3.39941-4.55469a.77675.77675,0,0,0-.84717-.78125,1.17684,1.17684,0,0,0-.83594.38477c-.2749.26367-.561.374-.85791.13184l-.4292-.34082c-.30811-.24219-.38525-.51758-.1543-.81445a2.97155,2.97155,0,0,1,2.45361-1.17676,2.45393,2.45393,0,0,1,2.68408,2.40918c0,2.45312-3.1792,2.92676-3.27832,3.93848h2.79443A.54085.54085,0,0,1,16.73975,13.81445ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z /> </svg>";

/***/ }),
/* 94 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=13 y1=4 y2=4></line> <line class=ql-stroke x1=5 x2=11 y1=14 y2=14></line> <line class=ql-stroke x1=8 x2=10 y1=14 y2=4></line> </svg>";

/***/ }),
/* 95 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=ql-stroke height=10 width=12 x=3 y=4></rect> <circle class=ql-fill cx=6 cy=7 r=1></circle> <polyline class=\"ql-even ql-fill\" points=\"5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12\"></polyline> </svg>";

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=\"ql-fill ql-stroke\" points=\"3 7 3 11 5 9 3 7\"></polyline> </svg>";

/***/ }),
/* 97 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points=\"5 7 5 11 3 9 5 7\"></polyline> </svg>";

/***/ }),
/* 98 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=11 y1=7 y2=11></line> <path class=\"ql-even ql-stroke\" d=M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z></path> <path class=\"ql-even ql-stroke\" d=M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z></path> </svg>";

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=7 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=7 x2=15 y1=14 y2=14></line> <line class=\"ql-stroke ql-thin\" x1=2.5 x2=4.5 y1=5.5 y2=5.5></line> <path class=ql-fill d=M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z></path> <path class=\"ql-stroke ql-thin\" d=M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156></path> <path class=\"ql-stroke ql-thin\" d=M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109></path> </svg>";

/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=6 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=6 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=6 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=3 y1=4 y2=4></line> <line class=ql-stroke x1=3 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=3 y1=14 y2=14></line> </svg>";

/***/ }),
/* 101 */
/***/ (function(module, exports) {

module.exports = "<svg class=\"\" viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=9 x2=15 y1=4 y2=4></line> <polyline class=ql-stroke points=\"3 4 4 5 6 3\"></polyline> <line class=ql-stroke x1=9 x2=15 y1=14 y2=14></line> <polyline class=ql-stroke points=\"3 14 4 15 6 13\"></polyline> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points=\"3 9 4 10 6 8\"></polyline> </svg>";

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15.5,15H13.861a3.858,3.858,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.921,1.921,0,0,0,12.021,11.7a0.50013,0.50013,0,1,0,.957.291h0a0.914,0.914,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.076-1.16971,1.86982-1.93971,2.43082A1.45639,1.45639,0,0,0,12,15.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,15Z /> <path class=ql-fill d=M9.65,5.241a1,1,0,0,0-1.409.108L6,7.964,3.759,5.349A1,1,0,0,0,2.192,6.59178Q2.21541,6.6213,2.241,6.649L4.684,9.5,2.241,12.35A1,1,0,0,0,3.71,13.70722q0.02557-.02768.049-0.05722L6,11.036,8.241,13.65a1,1,0,1,0,1.567-1.24277Q9.78459,12.3777,9.759,12.35L7.316,9.5,9.759,6.651A1,1,0,0,0,9.65,5.241Z /> </svg>";

/***/ }),
/* 103 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15.5,7H13.861a4.015,4.015,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.922,1.922,0,0,0,12.021,3.7a0.5,0.5,0,1,0,.957.291,0.917,0.917,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.077-1.164,1.925-1.934,2.486A1.423,1.423,0,0,0,12,7.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,7Z /> <path class=ql-fill d=M9.651,5.241a1,1,0,0,0-1.41.108L6,7.964,3.759,5.349a1,1,0,1,0-1.519,1.3L4.683,9.5,2.241,12.35a1,1,0,1,0,1.519,1.3L6,11.036,8.241,13.65a1,1,0,0,0,1.519-1.3L7.317,9.5,9.759,6.651A1,1,0,0,0,9.651,5.241Z /> </svg>";

/***/ }),
/* 104 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=\"ql-stroke ql-thin\" x1=15.5 x2=2.5 y1=8.5 y2=9.5></line> <path class=ql-fill d=M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z></path> <path class=ql-fill d=M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z></path> </svg>";

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-stroke d=M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3></path> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=12 x=3 y=15></rect> </svg>";

/***/ }),
/* 106 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=ql-stroke height=12 width=12 x=3 y=3></rect> <rect class=ql-fill height=12 width=1 x=5 y=3></rect> <rect class=ql-fill height=12 width=1 x=12 y=3></rect> <rect class=ql-fill height=2 width=8 x=5 y=8></rect> <rect class=ql-fill height=1 width=3 x=3 y=5></rect> <rect class=ql-fill height=1 width=3 x=3 y=7></rect> <rect class=ql-fill height=1 width=3 x=3 y=10></rect> <rect class=ql-fill height=1 width=3 x=3 y=12></rect> <rect class=ql-fill height=1 width=3 x=12 y=5></rect> <rect class=ql-fill height=1 width=3 x=12 y=7></rect> <rect class=ql-fill height=1 width=3 x=12 y=10></rect> <rect class=ql-fill height=1 width=3 x=12 y=12></rect> </svg>";

/***/ }),
/* 107 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=ql-stroke points=\"7 11 9 13 11 11 7 11\"></polygon> <polygon class=ql-stroke points=\"7 7 9 5 11 7 7 7\"></polygon> </svg>";

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BubbleTooltip = undefined;

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extend = __webpack_require__(3);

var _extend2 = _interopRequireDefault(_extend);

var _emitter = __webpack_require__(8);

var _emitter2 = _interopRequireDefault(_emitter);

var _base = __webpack_require__(43);

var _base2 = _interopRequireDefault(_base);

var _selection = __webpack_require__(15);

var _icons = __webpack_require__(41);

var _icons2 = _interopRequireDefault(_icons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TOOLBAR_CONFIG = [['bold', 'italic', 'link'], [{ header: 1 }, { header: 2 }, 'blockquote']];

var BubbleTheme = function (_BaseTheme) {
  _inherits(BubbleTheme, _BaseTheme);

  function BubbleTheme(quill, options) {
    _classCallCheck(this, BubbleTheme);

    if (options.modules.toolbar != null && options.modules.toolbar.container == null) {
      options.modules.toolbar.container = TOOLBAR_CONFIG;
    }

    var _this = _possibleConstructorReturn(this, (BubbleTheme.__proto__ || Object.getPrototypeOf(BubbleTheme)).call(this, quill, options));

    _this.quill.container.classList.add('ql-bubble');
    return _this;
  }

  _createClass(BubbleTheme, [{
    key: 'extendToolbar',
    value: function extendToolbar(toolbar) {
      this.tooltip = new BubbleTooltip(this.quill, this.options.bounds);
      this.tooltip.root.appendChild(toolbar.container);
      this.buildButtons([].slice.call(toolbar.container.querySelectorAll('button')), _icons2.default);
      this.buildPickers([].slice.call(toolbar.container.querySelectorAll('select')), _icons2.default);
    }
  }]);

  return BubbleTheme;
}(_base2.default);

BubbleTheme.DEFAULTS = (0, _extend2.default)(true, {}, _base2.default.DEFAULTS, {
  modules: {
    toolbar: {
      handlers: {
        link: function link(value) {
          if (!value) {
            this.quill.format('link', false);
          } else {
            this.quill.theme.tooltip.edit();
          }
        }
      }
    }
  }
});

var BubbleTooltip = function (_BaseTooltip) {
  _inherits(BubbleTooltip, _BaseTooltip);

  function BubbleTooltip(quill, bounds) {
    _classCallCheck(this, BubbleTooltip);

    var _this2 = _possibleConstructorReturn(this, (BubbleTooltip.__proto__ || Object.getPrototypeOf(BubbleTooltip)).call(this, quill, bounds));

    _this2.quill.on(_emitter2.default.events.EDITOR_CHANGE, function (type, range, oldRange, source) {
      if (type !== _emitter2.default.events.SELECTION_CHANGE) return;
      if (range != null && range.length > 0 && source === _emitter2.default.sources.USER) {
        _this2.show();
        // Lock our width so we will expand beyond our offsetParent boundaries
        _this2.root.style.left = '0px';
        _this2.root.style.width = '';
        _this2.root.style.width = _this2.root.offsetWidth + 'px';
        var lines = _this2.quill.getLines(range.index, range.length);
        if (lines.length === 1) {
          _this2.position(_this2.quill.getBounds(range));
        } else {
          var lastLine = lines[lines.length - 1];
          var index = _this2.quill.getIndex(lastLine);
          var length = Math.min(lastLine.length() - 1, range.index + range.length - index);
          var _bounds = _this2.quill.getBounds(new _selection.Range(index, length));
          _this2.position(_bounds);
        }
      } else if (document.activeElement !== _this2.textbox && _this2.quill.hasFocus()) {
        _this2.hide();
      }
    });
    return _this2;
  }

  _createClass(BubbleTooltip, [{
    key: 'listen',
    value: function listen() {
      var _this3 = this;

      _get(BubbleTooltip.prototype.__proto__ || Object.getPrototypeOf(BubbleTooltip.prototype), 'listen', this).call(this);
      this.root.querySelector('.ql-close').addEventListener('click', function () {
        _this3.root.classList.remove('ql-editing');
      });
      this.quill.on(_emitter2.default.events.SCROLL_OPTIMIZE, function () {
        // Let selection be restored by toolbar handlers before repositioning
        setTimeout(function () {
          if (_this3.root.classList.contains('ql-hidden')) return;
          var range = _this3.quill.getSelection();
          if (range != null) {
            _this3.position(_this3.quill.getBounds(range));
          }
        }, 1);
      });
    }
  }, {
    key: 'cancel',
    value: function cancel() {
      this.show();
    }
  }, {
    key: 'position',
    value: function position(reference) {
      var shift = _get(BubbleTooltip.prototype.__proto__ || Object.getPrototypeOf(BubbleTooltip.prototype), 'position', this).call(this, reference);
      var arrow = this.root.querySelector('.ql-tooltip-arrow');
      arrow.style.marginLeft = '';
      if (shift === 0) return shift;
      arrow.style.marginLeft = -1 * shift - arrow.offsetWidth / 2 + 'px';
    }
  }]);

  return BubbleTooltip;
}(_base.BaseTooltip);

BubbleTooltip.TEMPLATE = ['<span class="ql-tooltip-arrow"></span>', '<div class="ql-tooltip-editor">', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-close"></a>', '</div>'].join('');

exports.BubbleTooltip = BubbleTooltip;
exports.default = BubbleTheme;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(63);


/***/ })
/******/ ])["default"];
});
}).call(this)}).call(this,require("buffer").Buffer)
},{"buffer":570}]},{},[238]);
